[
  {
    "#": "11 Abbottsford Rd (054-02-00)",
    "$": 2861200,
    "address": "11 Abbottsford Rd",
    "parcel_id": "054-02-00",
    "owner1": "MARTIN TR, SUSAN F",
    "owner2": "",
    "current_taxes": 25663.75,
    "new_taxes_no_override": 26772.42,
    "override_total_1": 27532.07,
    "override_increase_1": 759.65
  },
  {
    "#": "12 Abbottsford Rd (053-16-00)",
    "$": 3273100,
    "address": "12 Abbottsford Rd",
    "parcel_id": "053-16-00",
    "owner1": "WEN, PATRICIA P",
    "owner2": "",
    "current_taxes": 29881.61,
    "new_taxes_no_override": 31172.5,
    "override_total_1": 32056.99,
    "override_increase_1": 884.5
  },
  {
    "#": "19 Abbottsford Rd (054-03-00)",
    "$": 2308900,
    "address": "19 Abbottsford Rd",
    "parcel_id": "054-03-00",
    "owner1": "SCHAFF, GLEN",
    "owner2": "STOCK, SARA",
    "current_taxes": 23643.14,
    "new_taxes_no_override": 24664.52,
    "override_total_1": 25364.36,
    "override_increase_1": 699.84
  },
  {
    "#": "20 Abbottsford Rd (053-15-00)",
    "$": 2768500,
    "address": "20 Abbottsford Rd",
    "parcel_id": "053-15-00",
    "owner1": "KORT TRS, ELEZA N",
    "owner2": "MILLER, TAMARA A K",
    "current_taxes": 28349.44,
    "new_taxes_no_override": 29574.14,
    "override_total_1": 30413.28,
    "override_increase_1": 839.14
  },
  {
    "#": "25 Abbottsford Rd (054-04-00)",
    "$": 3318900,
    "address": "25 Abbottsford Rd",
    "parcel_id": "054-04-00",
    "owner1": "TOFFEL TRS, MICHAEL WAYNE",
    "owner2": "DEEMER, ERIN ELIZABETH",
    "current_taxes": 30350.6,
    "new_taxes_no_override": 31661.75,
    "override_total_1": 32560.12,
    "override_increase_1": 898.38
  },
  {
    "#": "26 Abbottsford Rd (053-14-00)",
    "$": 2901900,
    "address": "26 Abbottsford Rd",
    "parcel_id": "053-14-00",
    "owner1": "BRIL, LIDIA",
    "owner2": "",
    "current_taxes": 26080.52,
    "new_taxes_no_override": 27207.2,
    "override_total_1": 27979.18,
    "override_increase_1": 771.98
  },
  {
    "#": "29 Abbottsford Rd (054-05-00)",
    "$": 2785500,
    "address": "29 Abbottsford Rd",
    "parcel_id": "054-05-00",
    "owner1": "CHENG TRS, HENRY",
    "owner2": "MCSWEENEY, MAIREADE E",
    "current_taxes": 24888.59,
    "new_taxes_no_override": 25963.78,
    "override_total_1": 26700.48,
    "override_increase_1": 736.7
  },
  {
    "#": "32 Abbottsford Rd (053-13-00)",
    "$": 3544900,
    "address": "32 Abbottsford Rd",
    "parcel_id": "053-13-00",
    "owner1": "HENRICH, JOSEPH",
    "owner2": "",
    "current_taxes": 32664.84,
    "new_taxes_no_override": 34075.96,
    "override_total_1": 35042.84,
    "override_increase_1": 966.88
  },
  {
    "#": "33 Abbottsford Rd (054-06-00)",
    "$": 2264000,
    "address": "33 Abbottsford Rd",
    "parcel_id": "054-06-00",
    "owner1": "PERRIN, JAMES M & ELLEN",
    "owner2": "",
    "current_taxes": 19548.43,
    "new_taxes_no_override": 20392.92,
    "override_total_1": 20971.56,
    "override_increase_1": 578.63
  },
  {
    "#": "40 Abbottsford Rd (053-12-00)",
    "$": 2704900,
    "address": "40 Abbottsford Rd",
    "parcel_id": "053-12-00",
    "owner1": "HELLER TR, NANCY S",
    "owner2": "",
    "current_taxes": 24063.24,
    "new_taxes_no_override": 25102.77,
    "override_total_1": 25815.04,
    "override_increase_1": 712.27
  },
  {
    "#": "43 Abbottsford Rd (054-07-00)",
    "$": 4139800,
    "address": "43 Abbottsford Rd",
    "parcel_id": "054-07-00",
    "owner1": "DOWD, JOHN P & ELIZABETH G S",
    "owner2": "",
    "current_taxes": 38756.62,
    "new_taxes_no_override": 40430.91,
    "override_total_1": 41578.1,
    "override_increase_1": 1147.2
  },
  {
    "#": "46 Abbottsford Rd (053-11-00)",
    "$": 2924400,
    "address": "46 Abbottsford Rd",
    "parcel_id": "053-11-00",
    "owner1": "WHITLEY, ROBERT C & CHARLA L",
    "owner2": "",
    "current_taxes": 26310.92,
    "new_taxes_no_override": 27447.55,
    "override_total_1": 28226.35,
    "override_increase_1": 778.8
  },
  {
    "#": "51 Abbottsford Rd (054-08-00)",
    "$": 3292600,
    "address": "51 Abbottsford Rd",
    "parcel_id": "054-08-00",
    "owner1": "REINSTEIN, JOHN & NANCY",
    "owner2": "",
    "current_taxes": 30081.29,
    "new_taxes_no_override": 31380.8,
    "override_total_1": 32271.21,
    "override_increase_1": 890.41
  },
  {
    "#": "70 Abbottsford Rd, Unit 1 (062-10-01)",
    "$": 1114100,
    "address": "70 Abbottsford Rd, Unit 1",
    "parcel_id": "062-10-01",
    "owner1": "MOUNTJOY TR, ALAN HELLMAN",
    "owner2": "MONTANO, MONTY ARMANDO",
    "current_taxes": 7773.45,
    "new_taxes_no_override": 8109.26,
    "override_total_1": 8339.36,
    "override_increase_1": 230.09
  },
  {
    "#": "70 Abbottsford Rd, Unit 2 (062-10-02)",
    "$": 1080300,
    "address": "70 Abbottsford Rd, Unit 2",
    "parcel_id": "062-10-02",
    "owner1": "WILLIAMS, NORMAN",
    "owner2": "CHIMURENGA, YAOSCA",
    "current_taxes": 11062.27,
    "new_taxes_no_override": 11540.16,
    "override_total_1": 11867.6,
    "override_increase_1": 327.44
  },
  {
    "#": "75 Abbottsford Rd (057-14-00)",
    "$": 2201600,
    "address": "75 Abbottsford Rd",
    "parcel_id": "057-14-00",
    "owner1": "CHANG, ET AL, CONNIE P F",
    "owner2": "WONG, LEZ P F",
    "current_taxes": 18909.45,
    "new_taxes_no_override": 19726.34,
    "override_total_1": 20286.06,
    "override_increase_1": 559.72
  },
  {
    "#": "85 Abbottsford Rd, Unit 1 (059-01-01)",
    "$": 1081300,
    "address": "85 Abbottsford Rd, Unit 1",
    "parcel_id": "059-01-01",
    "owner1": "SCHUBERT, SHAI",
    "owner2": "NEEMAN-SCHUBERT, YAEL A",
    "current_taxes": 11072.51,
    "new_taxes_no_override": 11550.84,
    "override_total_1": 11878.59,
    "override_increase_1": 327.75
  },
  {
    "#": "87 Abbottsford Rd, Unit 2 (059-02-02)",
    "$": 1410600,
    "address": "87 Abbottsford Rd, Unit 2",
    "parcel_id": "059-02-02",
    "owner1": "RAIKAR, SANTOSH",
    "owner2": "WARKE, SMITA PREMCHAND",
    "current_taxes": 10809.61,
    "new_taxes_no_override": 11276.59,
    "override_total_1": 11596.55,
    "override_increase_1": 319.96
  },
  {
    "#": "89 Abbottsford Rd, Unit 1 (059-02-01)",
    "$": 1190900,
    "address": "89 Abbottsford Rd, Unit 1",
    "parcel_id": "059-02-01",
    "owner1": "TAYLOR TR, JACOB",
    "owner2": "",
    "current_taxes": 12194.82,
    "new_taxes_no_override": 12721.64,
    "override_total_1": 13082.6,
    "override_increase_1": 360.97
  },
  {
    "#": "91 Abbottsford Rd (059-03-01)",
    "$": 2476900,
    "address": "91 Abbottsford Rd",
    "parcel_id": "059-03-01",
    "owner1": "HUANG, YENLING",
    "owner2": "LU, CHUN-NAN",
    "current_taxes": 21728.52,
    "new_taxes_no_override": 22667.19,
    "override_total_1": 23310.36,
    "override_increase_1": 643.16
  },
  {
    "#": "101 Abbottsford Rd, Unit 1 (059-04-01)",
    "$": 1243300,
    "address": "101 Abbottsford Rd, Unit 1",
    "parcel_id": "059-04-01",
    "owner1": "WENGLIN, LAURENCE G",
    "owner2": "",
    "current_taxes": 9096.46,
    "new_taxes_no_override": 9489.43,
    "override_total_1": 9758.68,
    "override_increase_1": 269.26
  },
  {
    "#": "101 Abbottsford Rd, Unit 2 (059-04-02)",
    "$": 1720100,
    "address": "101 Abbottsford Rd, Unit 2",
    "parcel_id": "059-04-02",
    "owner1": "LEE, GEOFFREY & JENNIFER",
    "owner2": "",
    "current_taxes": 13978.89,
    "new_taxes_no_override": 14582.78,
    "override_total_1": 14996.55,
    "override_increase_1": 413.78
  },
  {
    "#": "12 Ackers Ave, Unit 12 (269A-16-01)",
    "$": 2202400,
    "address": "12 Ackers Ave, Unit 12",
    "parcel_id": "269A-16-01",
    "owner1": "ZHANG, XIYU",
    "owner2": "",
    "current_taxes": 22552.58,
    "new_taxes_no_override": 23526.85,
    "override_total_1": 24194.41,
    "override_increase_1": 667.56
  },
  {
    "#": "12 Ackers Ave, Unit 16 (269A-16-02)",
    "$": 2272000,
    "address": "12 Ackers Ave, Unit 16",
    "parcel_id": "269A-16-02",
    "owner1": "VADUGANATHAN, NITHYA",
    "owner2": "",
    "current_taxes": 19630.35,
    "new_taxes_no_override": 20478.38,
    "override_total_1": 21059.44,
    "override_increase_1": 581.06
  },
  {
    "#": "22 Ackers Ave (269A-15-00)",
    "$": 2257200,
    "address": "22 Ackers Ave",
    "parcel_id": "269A-15-00",
    "owner1": "JARVIS, ANNE M & BRIAN",
    "owner2": "",
    "current_taxes": 19478.79,
    "new_taxes_no_override": 20320.27,
    "override_total_1": 20896.85,
    "override_increase_1": 576.57
  },
  {
    "#": "27 Ackers Ave (267-39-00)",
    "$": 15898800,
    "address": "27 Ackers Ave",
    "parcel_id": "267-39-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O DANIEL WARREN PLAYGROUND",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "30 Ackers Ave (269-11-00)",
    "$": 2564800,
    "address": "30 Ackers Ave",
    "parcel_id": "269-11-00",
    "owner1": "MACDOUGALL, STEPHAN & MAI",
    "owner2": "",
    "current_taxes": 26263.55,
    "new_taxes_no_override": 27398.14,
    "override_total_1": 28175.54,
    "override_increase_1": 777.4
  },
  {
    "#": "33 Ackers Ave, Unit 1 (267-26-06)",
    "$": 793200,
    "address": "33 Ackers Ave, Unit 1",
    "parcel_id": "267-26-06",
    "owner1": "STERNSTEIN, JERRI",
    "owner2": "LAFFERTY, CONNOR",
    "current_taxes": 4487.43,
    "new_taxes_no_override": 4681.29,
    "override_total_1": 4814.11,
    "override_increase_1": 132.83
  },
  {
    "#": "33 Ackers Ave, Unit 2 (267-26-07)",
    "$": 1325000,
    "address": "33 Ackers Ave, Unit 2",
    "parcel_id": "267-26-07",
    "owner1": "MYERS, DAVID W & ANNE E",
    "owner2": "",
    "current_taxes": 9933.07,
    "new_taxes_no_override": 10362.18,
    "override_total_1": 10656.2,
    "override_increase_1": 294.02
  },
  {
    "#": "36 Ackers Ave (269-10-00)",
    "$": 1836600,
    "address": "36 Ackers Ave",
    "parcel_id": "269-10-00",
    "owner1": "ROUMALLY, ELIAS",
    "owner2": "",
    "current_taxes": 15171.85,
    "new_taxes_no_override": 15827.27,
    "override_total_1": 16276.36,
    "override_increase_1": 449.09
  },
  {
    "#": "39 Ackers Ave (267-26-05)",
    "$": 2414800,
    "address": "39 Ackers Ave",
    "parcel_id": "267-26-05",
    "owner1": "LAMACCHIA, BRIAN M",
    "owner2": "DRISCOLL, KATHERINE C",
    "current_taxes": 21092.62,
    "new_taxes_no_override": 22003.82,
    "override_total_1": 22628.16,
    "override_increase_1": 624.34
  },
  {
    "#": "41 Ackers Ave, Unit 1 (267-27-01)",
    "$": 652800,
    "address": "41 Ackers Ave, Unit 1",
    "parcel_id": "267-27-01",
    "owner1": "STREIT JR TRS, JOHN PAUL",
    "owner2": "MCCANDLESS-KNIGHT , SUSAN M",
    "current_taxes": 6684.67,
    "new_taxes_no_override": 6973.45,
    "override_total_1": 7171.31,
    "override_increase_1": 197.87
  },
  {
    "#": "41 Ackers Ave, Unit 2 (267-27-02)",
    "$": 1075900,
    "address": "41 Ackers Ave, Unit 2",
    "parcel_id": "267-27-02",
    "owner1": "CAMHI, ILANA M SCHLAM",
    "owner2": "",
    "current_taxes": 7382.28,
    "new_taxes_no_override": 7701.19,
    "override_total_1": 7919.71,
    "override_increase_1": 218.52
  },
  {
    "#": "42 Ackers Ave (269-09-00)",
    "$": 1567300,
    "address": "42 Ackers Ave",
    "parcel_id": "269-09-00",
    "owner1": "STERNSTEIN TRS, ROBERT",
    "owner2": "EVANS , MARGARET",
    "current_taxes": 12414.22,
    "new_taxes_no_override": 12950.51,
    "override_total_1": 13317.98,
    "override_increase_1": 367.46
  },
  {
    "#": "43 Ackers Ave (267-28-00)",
    "$": 2708000,
    "address": "43 Ackers Ave",
    "parcel_id": "267-28-00",
    "owner1": "ASHER STUDENT FOUNDATION",
    "owner2": "",
    "current_taxes": 27729.92,
    "new_taxes_no_override": 28927.85,
    "override_total_1": 29748.66,
    "override_increase_1": 820.81
  },
  {
    "#": "46 Ackers Ave, Unit 1 (269-07-04)",
    "$": 1628200,
    "address": "46 Ackers Ave, Unit 1",
    "parcel_id": "269-07-04",
    "owner1": "BUTENSKY, ALEX PAUL",
    "owner2": "CORWIN, EMILY ROSE",
    "current_taxes": 13037.83,
    "new_taxes_no_override": 13601.06,
    "override_total_1": 13986.98,
    "override_increase_1": 385.92
  },
  {
    "#": "46 Ackers Ave, Unit 2 (269-07-05)",
    "$": 1533600,
    "address": "46 Ackers Ave, Unit 2",
    "parcel_id": "269-07-05",
    "owner1": "PATEL, HARESHKUMAR K",
    "owner2": "",
    "current_taxes": 12069.13,
    "new_taxes_no_override": 12590.52,
    "override_total_1": 12947.76,
    "override_increase_1": 357.25
  },
  {
    "#": "48 Ackers Ave, Unit 2 (269-07-03)",
    "$": 940800,
    "address": "48 Ackers Ave, Unit 2",
    "parcel_id": "269-07-03",
    "owner1": "BARBER, JENNIFER C",
    "owner2": "BROWN, PETER D",
    "current_taxes": 5998.86,
    "new_taxes_no_override": 6258.01,
    "override_total_1": 6435.58,
    "override_increase_1": 177.57
  },
  {
    "#": "49 Ackers Ave (268-04-00)",
    "$": 1825600,
    "address": "49 Ackers Ave",
    "parcel_id": "268-04-00",
    "owner1": "FISHKIN TRS, MARTIN E",
    "owner2": "ROSEMAN , LYNDA E",
    "current_taxes": 15059.21,
    "new_taxes_no_override": 15709.77,
    "override_total_1": 16155.52,
    "override_increase_1": 445.75
  },
  {
    "#": "50 Ackers Ave, Unit 1 (269-07-02)",
    "$": 720200,
    "address": "50 Ackers Ave, Unit 1",
    "parcel_id": "269-07-02",
    "owner1": "BARBER, JENNIFER C",
    "owner2": "BROWN, PETER",
    "current_taxes": 7374.85,
    "new_taxes_no_override": 7693.44,
    "override_total_1": 7911.74,
    "override_increase_1": 218.3
  },
  {
    "#": "51 Ackers Ave, Unit 51 4 Pksp (268-05-01)",
    "$": 973800,
    "address": "51 Ackers Ave, Unit 51 4 Pksp",
    "parcel_id": "268-05-01",
    "owner1": "ZUBAREV, SIMON",
    "owner2": "",
    "current_taxes": 6336.78,
    "new_taxes_no_override": 6610.53,
    "override_total_1": 6798.1,
    "override_increase_1": 187.57
  },
  {
    "#": "52 Ackers Ave (269-06-02)",
    "$": 1808100,
    "address": "52 Ackers Ave",
    "parcel_id": "269-06-02",
    "owner1": "KAPLAN, ELIOT M & LINDA M",
    "owner2": "",
    "current_taxes": 14880.01,
    "new_taxes_no_override": 15522.83,
    "override_total_1": 15963.27,
    "override_increase_1": 440.45
  },
  {
    "#": "53 Ackers Ave, Unit 53 4 Pksp (268-05-02)",
    "$": 1004000,
    "address": "53 Ackers Ave, Unit 53 4 Pksp",
    "parcel_id": "268-05-02",
    "owner1": "GOLDMAN, YARON",
    "owner2": "",
    "current_taxes": 10280.96,
    "new_taxes_no_override": 10725.1,
    "override_total_1": 11029.41,
    "override_increase_1": 304.32
  },
  {
    "#": "54 Ackers Ave (269-02-03)",
    "$": 1734100,
    "address": "54 Ackers Ave",
    "parcel_id": "269-02-03",
    "owner1": "CORCORAN, CRAIG L & GAIL J",
    "owner2": "",
    "current_taxes": 14122.25,
    "new_taxes_no_override": 14732.33,
    "override_total_1": 15150.35,
    "override_increase_1": 418.02
  },
  {
    "#": "57 Ackers Ave, Unit 1 (268-06-01)",
    "$": 644000,
    "address": "57 Ackers Ave, Unit 1",
    "parcel_id": "268-06-01",
    "owner1": "SMITH, DAVID HUGH",
    "owner2": "",
    "current_taxes": 2959.63,
    "new_taxes_no_override": 3087.49,
    "override_total_1": 3175.09,
    "override_increase_1": 87.61
  },
  {
    "#": "57 Ackers Ave, Unit 2 (268-06-02)",
    "$": 732700,
    "address": "57 Ackers Ave, Unit 2",
    "parcel_id": "268-06-02",
    "owner1": "BIRAN, ANAT & SHAI",
    "owner2": "",
    "current_taxes": 7502.85,
    "new_taxes_no_override": 7826.97,
    "override_total_1": 8049.06,
    "override_increase_1": 222.08
  },
  {
    "#": "57 Ackers Ave, Unit 3 (268-06-03)",
    "$": 743100,
    "address": "57 Ackers Ave, Unit 3",
    "parcel_id": "268-06-03",
    "owner1": "CAPLAN, JENNIFER",
    "owner2": "",
    "current_taxes": 3974.41,
    "new_taxes_no_override": 4146.1,
    "override_total_1": 4263.75,
    "override_increase_1": 117.64
  },
  {
    "#": "59 Ackers Ave, Unit 1 (268-07-03)",
    "$": 719700,
    "address": "59 Ackers Ave, Unit 1",
    "parcel_id": "268-07-03",
    "owner1": "PRUSTY TR, DEEPANWITA",
    "owner2": "",
    "current_taxes": 7369.73,
    "new_taxes_no_override": 7688.1,
    "override_total_1": 7906.25,
    "override_increase_1": 218.14
  },
  {
    "#": "59 Ackers Ave, Unit 2 (268-07-01)",
    "$": 755700,
    "address": "59 Ackers Ave, Unit 2",
    "parcel_id": "268-07-01",
    "owner1": "OCONNELL TR, KATHLEEN M",
    "owner2": "",
    "current_taxes": 4103.43,
    "new_taxes_no_override": 4280.7,
    "override_total_1": 4402.16,
    "override_increase_1": 121.46
  },
  {
    "#": "59 Ackers Ave, Unit 3 (268-07-02)",
    "$": 964400,
    "address": "59 Ackers Ave, Unit 3",
    "parcel_id": "268-07-02",
    "owner1": "SLATER, MARK & REBECCA",
    "owner2": "",
    "current_taxes": 6240.52,
    "new_taxes_no_override": 6510.11,
    "override_total_1": 6694.83,
    "override_increase_1": 184.72
  },
  {
    "#": "8 Ackers Ter (267-26-01)",
    "$": 1361800,
    "address": "8 Ackers Ter",
    "parcel_id": "267-26-01",
    "owner1": "AMSLER, JOAN KIBRICK",
    "owner2": "",
    "current_taxes": 10309.9,
    "new_taxes_no_override": 10755.29,
    "override_total_1": 11060.46,
    "override_increase_1": 305.17
  },
  {
    "#": "12 Ackers Ter (267-26-02)",
    "$": 1494000,
    "address": "12 Ackers Ter",
    "parcel_id": "267-26-02",
    "owner1": "RUTHERFURD, CHARLOTTE",
    "owner2": "",
    "current_taxes": 11663.63,
    "new_taxes_no_override": 12167.5,
    "override_total_1": 12512.74,
    "override_increase_1": 345.24
  },
  {
    "#": "16 Ackers Ter (267-26-03)",
    "$": 1103400,
    "address": "16 Ackers Ter",
    "parcel_id": "267-26-03",
    "owner1": "ORLANDO, LAURA F",
    "owner2": "",
    "current_taxes": 7663.88,
    "new_taxes_no_override": 7994.96,
    "override_total_1": 8221.81,
    "override_increase_1": 226.85
  },
  {
    "#": "20 Ackers Ter (267-26-04)",
    "$": 1332300,
    "address": "20 Ackers Ter",
    "parcel_id": "267-26-04",
    "owner1": "GORMLEY, PHILIP J & MARGARET F",
    "owner2": "",
    "current_taxes": 10007.82,
    "new_taxes_no_override": 10440.16,
    "override_total_1": 10736.39,
    "override_increase_1": 296.23
  },
  {
    "#": "2 Acron Rd (315-01-00)",
    "$": 1534900,
    "address": "2 Acron Rd",
    "parcel_id": "315-01-00",
    "owner1": "WASHBURN TRS, BRADFORD V & KIRA J",
    "owner2": "",
    "current_taxes": 15717.38,
    "new_taxes_no_override": 16396.37,
    "override_total_1": 16861.61,
    "override_increase_1": 465.23
  },
  {
    "#": "7 Acron Rd (314-15-00)",
    "$": 2215300,
    "address": "7 Acron Rd",
    "parcel_id": "314-15-00",
    "owner1": "7 ACRON ROAD LLC",
    "owner2": "C/O AARON M ADLER",
    "current_taxes": 22684.67,
    "new_taxes_no_override": 23664.65,
    "override_total_1": 24336.11,
    "override_increase_1": 671.47
  },
  {
    "#": "9 Acron Rd (314-16-00)",
    "$": 1551000,
    "address": "9 Acron Rd",
    "parcel_id": "314-16-00",
    "owner1": "BUCKLEY, PHILIP W JR",
    "owner2": "",
    "current_taxes": 12247.31,
    "new_taxes_no_override": 12776.39,
    "override_total_1": 13138.91,
    "override_increase_1": 362.52
  },
  {
    "#": "12 Acron Rd (315-11-00)",
    "$": 1699100,
    "address": "12 Acron Rd",
    "parcel_id": "315-11-00",
    "owner1": "CURRAN TRS, THOMAS A & MARGARET R",
    "owner2": "",
    "current_taxes": 17398.78,
    "new_taxes_no_override": 18150.41,
    "override_total_1": 18665.41,
    "override_increase_1": 515.0
  },
  {
    "#": "15 Acron Rd (314-17-00)",
    "$": 1638800,
    "address": "15 Acron Rd",
    "parcel_id": "314-17-00",
    "owner1": "BOYLE TR, ELAINE M",
    "owner2": "",
    "current_taxes": 13146.38,
    "new_taxes_no_override": 13714.3,
    "override_total_1": 14103.44,
    "override_increase_1": 389.13
  },
  {
    "#": "16 Acron Rd, Unit 1 (315-10-01)",
    "$": 1121800,
    "address": "16 Acron Rd, Unit 1",
    "parcel_id": "315-10-01",
    "owner1": "HINTZ  TRS, TIMOTHY D",
    "owner2": "ROSSER, SUSAN  C",
    "current_taxes": 7852.3,
    "new_taxes_no_override": 8191.52,
    "override_total_1": 8423.95,
    "override_increase_1": 232.43
  },
  {
    "#": "16 Acron Rd, Unit 2 (315-10-02)",
    "$": 1255900,
    "address": "16 Acron Rd, Unit 2",
    "parcel_id": "315-10-02",
    "owner1": "GROSSMAN, BRIAN & MARCI L",
    "owner2": "",
    "current_taxes": 9225.48,
    "new_taxes_no_override": 9624.02,
    "override_total_1": 9897.09,
    "override_increase_1": 273.07
  },
  {
    "#": "18 Acron Rd (315-09-00)",
    "$": 2474800,
    "address": "18 Acron Rd",
    "parcel_id": "315-09-00",
    "owner1": "STRAUSS TRS, GARY M & MEDA E",
    "owner2": "LINKE, ROBERT E & REBECCA A",
    "current_taxes": 21707.02,
    "new_taxes_no_override": 22644.76,
    "override_total_1": 23287.29,
    "override_increase_1": 642.53
  },
  {
    "#": "3 Adams St, Unit 3 (028-02-01)",
    "$": 1794600,
    "address": "3 Adams St, Unit 3",
    "parcel_id": "028-02-01",
    "owner1": "OLSEN TRS, DOUGLAS M",
    "owner2": "VELASCO, MARTA",
    "current_taxes": 14741.77,
    "new_taxes_no_override": 15378.61,
    "override_total_1": 15814.97,
    "override_increase_1": 436.36
  },
  {
    "#": "5 Adams St, Unit 5 (028-02-02)",
    "$": 1686200,
    "address": "5 Adams St, Unit 5",
    "parcel_id": "028-02-02",
    "owner1": "ELLIN, JANE ALICE",
    "owner2": "PAZ, RORY MAG-ISA DELA",
    "current_taxes": 13631.75,
    "new_taxes_no_override": 14220.64,
    "override_total_1": 14624.14,
    "override_increase_1": 403.5
  },
  {
    "#": "9 Adams St (028-03-00)",
    "$": 1583700,
    "address": "9 Adams St",
    "parcel_id": "028-03-00",
    "owner1": "SOLARI, RENEE N & CAMILLE L",
    "owner2": "",
    "current_taxes": 16217.09,
    "new_taxes_no_override": 16917.67,
    "override_total_1": 17397.69,
    "override_increase_1": 480.03
  },
  {
    "#": "12 Adams St (029-13-00)",
    "$": 1992500,
    "address": "12 Adams St",
    "parcel_id": "029-13-00",
    "owner1": "SHERMAN 3RD, JOHN F",
    "owner2": "SHERMAN, BARBARA F",
    "current_taxes": 16768.27,
    "new_taxes_no_override": 17492.66,
    "override_total_1": 17989.0,
    "override_increase_1": 496.34
  },
  {
    "#": "15 Adams St (028-04-00)",
    "$": 2416100,
    "address": "15 Adams St",
    "parcel_id": "028-04-00",
    "owner1": "MANDAPATI, SARASWATHI",
    "owner2": "GINGIPALLI, LAKSHMAIAH",
    "current_taxes": 21105.93,
    "new_taxes_no_override": 22017.71,
    "override_total_1": 22642.44,
    "override_increase_1": 624.74
  },
  {
    "#": "16 Adams St (029-12-00)",
    "$": 2195600,
    "address": "16 Adams St",
    "parcel_id": "029-12-00",
    "owner1": "SHIH, TRS, DAVID P & JANET CHI-NGA P",
    "owner2": "",
    "current_taxes": 22482.94,
    "new_taxes_no_override": 23454.2,
    "override_total_1": 24119.7,
    "override_increase_1": 665.5
  },
  {
    "#": "19 Adams St (028-05-00)",
    "$": 1817100,
    "address": "19 Adams St",
    "parcel_id": "028-05-00",
    "owner1": "PEREZ-RAMIREZ, JOSE B",
    "owner2": "CASTELLS, MARIA",
    "current_taxes": 14972.17,
    "new_taxes_no_override": 15618.97,
    "override_total_1": 16062.14,
    "override_increase_1": 443.18
  },
  {
    "#": "20 Adams St (029-11-00)",
    "$": 2888100,
    "address": "20 Adams St",
    "parcel_id": "029-11-00",
    "owner1": "WALLACE, DEREK WILLIAM",
    "owner2": "",
    "current_taxes": 25939.21,
    "new_taxes_no_override": 27059.78,
    "override_total_1": 27827.58,
    "override_increase_1": 767.8
  },
  {
    "#": "24 Adams St (029-10-00)",
    "$": 1890400,
    "address": "24 Adams St",
    "parcel_id": "029-10-00",
    "owner1": "KLAUSNER TRS, MARIAN L",
    "owner2": "BRILL, NELSON K",
    "current_taxes": 15722.76,
    "new_taxes_no_override": 16401.98,
    "override_total_1": 16867.38,
    "override_increase_1": 465.39
  },
  {
    "#": "25 Adams St (028-06-00)",
    "$": 2082500,
    "address": "25 Adams St",
    "parcel_id": "028-06-00",
    "owner1": "HONG, XUEFEI",
    "owner2": "ZOU, KENNETH QIN",
    "current_taxes": 21324.8,
    "new_taxes_no_override": 22246.03,
    "override_total_1": 22877.25,
    "override_increase_1": 631.21
  },
  {
    "#": "28 Adams St (029-09-00)",
    "$": 2104900,
    "address": "28 Adams St",
    "parcel_id": "029-09-00",
    "owner1": "HEMENWAY, DAVID",
    "owner2": "",
    "current_taxes": 17919.24,
    "new_taxes_no_override": 18693.35,
    "override_total_1": 19223.76,
    "override_increase_1": 530.41
  },
  {
    "#": "29 Adams St (028-07-00)",
    "$": 2221100,
    "address": "29 Adams St",
    "parcel_id": "028-07-00",
    "owner1": "BUSHARI, ELAD & MARA",
    "owner2": "",
    "current_taxes": 19109.13,
    "new_taxes_no_override": 19934.64,
    "override_total_1": 20500.27,
    "override_increase_1": 565.63
  },
  {
    "#": "35 Adams St (028-08-00)",
    "$": 1969600,
    "address": "35 Adams St",
    "parcel_id": "028-08-00",
    "owner1": "CHUNG, JAMES",
    "owner2": "",
    "current_taxes": 16533.77,
    "new_taxes_no_override": 17248.03,
    "override_total_1": 17737.43,
    "override_increase_1": 489.4
  },
  {
    "#": "39 Adams St (028-09-00)",
    "$": 2104300,
    "address": "39 Adams St",
    "parcel_id": "028-09-00",
    "owner1": "POVERMAN, KATE",
    "owner2": "BUENO, RAPHAL",
    "current_taxes": 17913.1,
    "new_taxes_no_override": 18686.95,
    "override_total_1": 19217.17,
    "override_increase_1": 530.23
  },
  {
    "#": "1 Addington Rd, Unit 1 (220-01-02)",
    "$": 1136500,
    "address": "1 Addington Rd, Unit 1",
    "parcel_id": "220-01-02",
    "owner1": "ITZKOWITZ TR, AVRUM E",
    "owner2": "",
    "current_taxes": 8002.83,
    "new_taxes_no_override": 8348.55,
    "override_total_1": 8585.44,
    "override_increase_1": 236.88
  },
  {
    "#": "3 Addington Rd, Unit 2 (220-01-01)",
    "$": 1529400,
    "address": "3 Addington Rd, Unit 2",
    "parcel_id": "220-01-01",
    "owner1": "PHILLIPS, JONATHAN T",
    "owner2": "",
    "current_taxes": 12026.12,
    "new_taxes_no_override": 12545.65,
    "override_total_1": 12901.62,
    "override_increase_1": 355.97
  },
  {
    "#": "4 Addington Rd (219-37-00)",
    "$": 2594800,
    "address": "4 Addington Rd",
    "parcel_id": "219-37-00",
    "owner1": "PLESS, IRWIN & GLORIA JOAN",
    "owner2": "",
    "current_taxes": 22935.82,
    "new_taxes_no_override": 23926.65,
    "override_total_1": 24605.55,
    "override_increase_1": 678.9
  },
  {
    "#": "7 Addington Rd (220-02-00)",
    "$": 2344000,
    "address": "7 Addington Rd",
    "parcel_id": "220-02-00",
    "owner1": "MARSH, CHRISTOPHER S",
    "owner2": "",
    "current_taxes": 20367.63,
    "new_taxes_no_override": 21247.51,
    "override_total_1": 21850.39,
    "override_increase_1": 602.88
  },
  {
    "#": "16 Addington Rd, Unit 12 & P16 (219-36-01)",
    "$": 594400,
    "address": "16 Addington Rd, Unit 12 & P16",
    "parcel_id": "219-36-01",
    "owner1": "ABBASI, NAZANIN & NIMA",
    "owner2": "",
    "current_taxes": 6086.66,
    "new_taxes_no_override": 6349.6,
    "override_total_1": 6529.77,
    "override_increase_1": 180.17
  },
  {
    "#": "16 Addington Rd, Unit 21  P15-18 (219-36-02)",
    "$": 1175300,
    "address": "16 Addington Rd, Unit 21  P15-18",
    "parcel_id": "219-36-02",
    "owner1": "NAYOR, MATTHEW & JENNIFER",
    "owner2": "",
    "current_taxes": 8400.14,
    "new_taxes_no_override": 8763.03,
    "override_total_1": 9011.67,
    "override_increase_1": 248.64
  },
  {
    "#": "16 Addington Rd, Unit 22 &P24 28 (219-36-03)",
    "$": 931200,
    "address": "16 Addington Rd, Unit 22 &P24 28",
    "parcel_id": "219-36-03",
    "owner1": "NGUYEN, HUY",
    "owner2": "SHOHET, MERAV",
    "current_taxes": 5900.55,
    "new_taxes_no_override": 6155.45,
    "override_total_1": 6330.11,
    "override_increase_1": 174.66
  },
  {
    "#": "16 Addington Rd, Unit 23 (219-36-04)",
    "$": 812100,
    "address": "16 Addington Rd, Unit 23",
    "parcel_id": "219-36-04",
    "owner1": "CHING, KARL",
    "owner2": "",
    "current_taxes": 4680.97,
    "new_taxes_no_override": 4883.19,
    "override_total_1": 5021.74,
    "override_increase_1": 138.56
  },
  {
    "#": "16 Addington Rd, Unit 24 & P8 (219-36-05)",
    "$": 675900,
    "address": "16 Addington Rd, Unit 24 & P8",
    "parcel_id": "219-36-05",
    "owner1": "DIETRICK, ELLEN",
    "owner2": "",
    "current_taxes": 3286.28,
    "new_taxes_no_override": 3428.25,
    "override_total_1": 3525.52,
    "override_increase_1": 97.27
  },
  {
    "#": "16 Addington Rd, Unit 25 & P4 (219-36-06)",
    "$": 479500,
    "address": "16 Addington Rd, Unit 25 & P4",
    "parcel_id": "219-36-06",
    "owner1": "NEXT GEN 16 ADDINGTON ROAD INC",
    "owner2": "",
    "current_taxes": 4910.08,
    "new_taxes_no_override": 5122.2,
    "override_total_1": 5267.53,
    "override_increase_1": 145.34
  },
  {
    "#": "16 Addington Rd, Unit 26 & P3 (219-36-07)",
    "$": 712100,
    "address": "16 Addington Rd, Unit 26 & P3",
    "parcel_id": "219-36-07",
    "owner1": "YE, HUI",
    "owner2": "HA, CHENG",
    "current_taxes": 3656.97,
    "new_taxes_no_override": 3814.95,
    "override_total_1": 3923.2,
    "override_increase_1": 108.25
  },
  {
    "#": "16 Addington Rd, Unit 31 & P17 (219-36-08)",
    "$": 813400,
    "address": "16 Addington Rd, Unit 31 & P17",
    "parcel_id": "219-36-08",
    "owner1": "AUDEH TRS, FRED L & HILDAH",
    "owner2": "",
    "current_taxes": 8329.22,
    "new_taxes_no_override": 8689.04,
    "override_total_1": 8935.59,
    "override_increase_1": 246.54
  },
  {
    "#": "16 Addington Rd, Unit 32 & P14 (219-36-09)",
    "$": 728100,
    "address": "16 Addington Rd, Unit 32 & P14",
    "parcel_id": "219-36-09",
    "owner1": "THK DEVELOPMENT LLC",
    "owner2": "",
    "current_taxes": 7455.74,
    "new_taxes_no_override": 7777.83,
    "override_total_1": 7998.52,
    "override_increase_1": 220.69
  },
  {
    "#": "16 Addington Rd, Unit 33 & P12 (219-36-10)",
    "$": 509500,
    "address": "16 Addington Rd, Unit 33 & P12",
    "parcel_id": "219-36-10",
    "owner1": "XUE, WEINI",
    "owner2": "",
    "current_taxes": 5217.28,
    "new_taxes_no_override": 5442.67,
    "override_total_1": 5597.1,
    "override_increase_1": 154.43
  },
  {
    "#": "16 Addington Rd, Unit 34 P7 & 27 (219-36-11)",
    "$": 796900,
    "address": "16 Addington Rd, Unit 34 P7 & 27",
    "parcel_id": "219-36-11",
    "owner1": "BALANOV, YANINA & KIRIL",
    "owner2": "",
    "current_taxes": 4525.32,
    "new_taxes_no_override": 4720.81,
    "override_total_1": 4854.76,
    "override_increase_1": 133.95
  },
  {
    "#": "16 Addington Rd, Unit 35 & P21 (219-36-12)",
    "$": 579200,
    "address": "16 Addington Rd, Unit 35 & P21",
    "parcel_id": "219-36-12",
    "owner1": "NEXT GEN 16 ADDINGTON ROAD INC",
    "owner2": "",
    "current_taxes": 5931.01,
    "new_taxes_no_override": 6187.23,
    "override_total_1": 6362.79,
    "override_increase_1": 175.56
  },
  {
    "#": "16 Addington Rd, Unit 36 & P20 (219-36-13)",
    "$": 792400,
    "address": "16 Addington Rd, Unit 36 & P20",
    "parcel_id": "219-36-13",
    "owner1": "ZHANG, NUOHAN",
    "owner2": "AZZAM, ANDREW",
    "current_taxes": 4479.24,
    "new_taxes_no_override": 4672.74,
    "override_total_1": 4805.33,
    "override_increase_1": 132.59
  },
  {
    "#": "16 Addington Rd, Unit 41 & P9-10 (219-36-14)",
    "$": 861200,
    "address": "16 Addington Rd, Unit 41 & P9-10",
    "parcel_id": "219-36-14",
    "owner1": "AZRIN, LINDA B",
    "owner2": "",
    "current_taxes": 5183.75,
    "new_taxes_no_override": 5407.69,
    "override_total_1": 5561.13,
    "override_increase_1": 153.44
  },
  {
    "#": "16 Addington Rd, Unit 42 & P11 (219-36-15)",
    "$": 761100,
    "address": "16 Addington Rd, Unit 42 & P11",
    "parcel_id": "219-36-15",
    "owner1": "RICHARDS, JAMES",
    "owner2": "AHWACH, HALA",
    "current_taxes": 4158.73,
    "new_taxes_no_override": 4338.39,
    "override_total_1": 4461.49,
    "override_increase_1": 123.1
  },
  {
    "#": "16 Addington Rd, Unit 43 & P6 (219-36-16)",
    "$": 549500,
    "address": "16 Addington Rd, Unit 43 & P6",
    "parcel_id": "219-36-16",
    "owner1": "CHANG, NINGYEH",
    "owner2": "",
    "current_taxes": 5626.88,
    "new_taxes_no_override": 5869.96,
    "override_total_1": 6036.52,
    "override_increase_1": 166.56
  },
  {
    "#": "16 Addington Rd, Unit 45 & P22 (219-36-18)",
    "$": 579200,
    "address": "16 Addington Rd, Unit 45 & P22",
    "parcel_id": "219-36-18",
    "owner1": "NEXT GEN 16 ADDINGTON ROAD INC",
    "owner2": "",
    "current_taxes": 5931.01,
    "new_taxes_no_override": 6187.23,
    "override_total_1": 6362.79,
    "override_increase_1": 175.56
  },
  {
    "#": "16 Addington Rd, Unit 46 & P5 (219-36-19)",
    "$": 792400,
    "address": "16 Addington Rd, Unit 46 & P5",
    "parcel_id": "219-36-19",
    "owner1": "YAN, HE",
    "owner2": "HUANG, KUN",
    "current_taxes": 4479.24,
    "new_taxes_no_override": 4672.74,
    "override_total_1": 4805.33,
    "override_increase_1": 132.59
  },
  {
    "#": "16 Addington Rd, Unit 48 & P25 (219-36-17)",
    "$": 747400,
    "address": "16 Addington Rd, Unit 48 & P25",
    "parcel_id": "219-36-17",
    "owner1": "TAI, MEI YUK",
    "owner2": "WONG, SHU KING",
    "current_taxes": 4018.44,
    "new_taxes_no_override": 4192.04,
    "override_total_1": 4310.98,
    "override_increase_1": 118.95
  },
  {
    "#": "16 Addington Rd, Unit 51 & P1 (219-36-20)",
    "$": 1602900,
    "address": "16 Addington Rd, Unit 51 & P1",
    "parcel_id": "219-36-20",
    "owner1": "BARDFIELD TRS, CLAIRE M & DAVID",
    "owner2": "",
    "current_taxes": 16413.7,
    "new_taxes_no_override": 17122.77,
    "override_total_1": 17608.62,
    "override_increase_1": 485.85
  },
  {
    "#": "16 Addington Rd, Unit 52&P13 P26 (219-36-21)",
    "$": 926900,
    "address": "16 Addington Rd, Unit 52&P13 P26",
    "parcel_id": "219-36-21",
    "owner1": "ABBASI, NIMA",
    "owner2": "",
    "current_taxes": 5856.52,
    "new_taxes_no_override": 6109.52,
    "override_total_1": 6282.87,
    "override_increase_1": 173.35
  },
  {
    "#": "16 Addington Rd, Unit 53 & P19 (219-36-22)",
    "$": 995700,
    "address": "16 Addington Rd, Unit 53 & P19",
    "parcel_id": "219-36-22",
    "owner1": "LOFCHIE, JILL BETH & JASON ROBERT",
    "owner2": "",
    "current_taxes": 6561.03,
    "new_taxes_no_override": 6844.47,
    "override_total_1": 7038.67,
    "override_increase_1": 194.21
  },
  {
    "#": "16 Addington Rd, Unit 54 & P2 (219-36-23)",
    "$": 1044600,
    "address": "16 Addington Rd, Unit 54 & P2",
    "parcel_id": "219-36-23",
    "owner1": "TSVETKOV, IGOR",
    "owner2": "MOLCHANOVA, EKATERINA",
    "current_taxes": 7061.77,
    "new_taxes_no_override": 7366.84,
    "override_total_1": 7575.87,
    "override_increase_1": 209.03
  },
  {
    "#": "19 Addington Rd (220-04-00)",
    "$": 2344400,
    "address": "19 Addington Rd",
    "parcel_id": "220-04-00",
    "owner1": "LOCKWOOD, JOHN",
    "owner2": "OLSEN, KIRSTEN",
    "current_taxes": 20371.72,
    "new_taxes_no_override": 21251.78,
    "override_total_1": 21854.78,
    "override_increase_1": 603.0
  },
  {
    "#": "21 Addington Rd (220-05-00)",
    "$": 2722300,
    "address": "21 Addington Rd",
    "parcel_id": "220-05-00",
    "owner1": "THOMPSON, SAMUEL B",
    "owner2": "MACGARVIE-THOMPSON, MEGAN",
    "current_taxes": 24241.42,
    "new_taxes_no_override": 25288.65,
    "override_total_1": 26006.2,
    "override_increase_1": 717.55
  },
  {
    "#": "22 Addington Rd, Unit 1 (219-34-01)",
    "$": 852900,
    "address": "22 Addington Rd, Unit 1",
    "parcel_id": "219-34-01",
    "owner1": "ARANDIA, JASON A",
    "owner2": "",
    "current_taxes": 5098.76,
    "new_taxes_no_override": 5319.03,
    "override_total_1": 5469.95,
    "override_increase_1": 150.92
  },
  {
    "#": "22 Addington Rd, Unit 2 (219-34-02)",
    "$": 914800,
    "address": "22 Addington Rd, Unit 2",
    "parcel_id": "219-34-02",
    "owner1": "OKUSSICK, ANTHONY J JR",
    "owner2": "",
    "current_taxes": 5732.62,
    "new_taxes_no_override": 5980.27,
    "override_total_1": 6149.95,
    "override_increase_1": 169.69
  },
  {
    "#": "22 Addington Rd, Unit 3 (219-34-03)",
    "$": 965500,
    "address": "22 Addington Rd, Unit 3",
    "parcel_id": "219-34-03",
    "owner1": "JOHNSON, ELIZABETH",
    "owner2": "RUMPLER, WILLIAM VERNON",
    "current_taxes": 9886.72,
    "new_taxes_no_override": 10313.83,
    "override_total_1": 10606.47,
    "override_increase_1": 292.65
  },
  {
    "#": "22 Addington Rd, Unit B (219-34-04)",
    "$": 568000,
    "address": "22 Addington Rd, Unit B",
    "parcel_id": "219-34-04",
    "owner1": "SHIRLAND, JONATHAN C & MAGGIE F",
    "owner2": "",
    "current_taxes": 2181.39,
    "new_taxes_no_override": 2275.63,
    "override_total_1": 2340.2,
    "override_increase_1": 64.57
  },
  {
    "#": "24 Addington Rd, Unit 1 (219-33-03)",
    "$": 937000,
    "address": "24 Addington Rd, Unit 1",
    "parcel_id": "219-33-03",
    "owner1": "BARLETTA TR, ANNE MARIE",
    "owner2": "",
    "current_taxes": 5959.95,
    "new_taxes_no_override": 6217.42,
    "override_total_1": 6393.83,
    "override_increase_1": 176.41
  },
  {
    "#": "24 Addington Rd, Unit 2 & P2 (219-33-01)",
    "$": 1023400,
    "address": "24 Addington Rd, Unit 2 & P2",
    "parcel_id": "219-33-01",
    "owner1": "LUSKIN, MARLISE RACHAEL",
    "owner2": "",
    "current_taxes": 6844.68,
    "new_taxes_no_override": 7140.37,
    "override_total_1": 7342.97,
    "override_increase_1": 202.6
  },
  {
    "#": "24 Addington Rd, Unit 3 (219-33-02)",
    "$": 994100,
    "address": "24 Addington Rd, Unit 3",
    "parcel_id": "219-33-02",
    "owner1": "XIE, XUAN",
    "owner2": "JI, GUOSHI",
    "current_taxes": 10179.58,
    "new_taxes_no_override": 10619.34,
    "override_total_1": 10920.65,
    "override_increase_1": 301.32
  },
  {
    "#": "28 Addington Rd, Unit 1 (219-32-01)",
    "$": 884100,
    "address": "28 Addington Rd, Unit 1",
    "parcel_id": "219-32-01",
    "owner1": "ABE, MIYAKO",
    "owner2": "",
    "current_taxes": 5418.25,
    "new_taxes_no_override": 5652.32,
    "override_total_1": 5812.7,
    "override_increase_1": 160.38
  },
  {
    "#": "28 Addington Rd, Unit 2 (219-32-02)",
    "$": 938300,
    "address": "28 Addington Rd, Unit 2",
    "parcel_id": "219-32-02",
    "owner1": "POPKOV, YEVGENIY & ELENA",
    "owner2": "",
    "current_taxes": 5973.26,
    "new_taxes_no_override": 6231.3,
    "override_total_1": 6408.11,
    "override_increase_1": 176.81
  },
  {
    "#": "28 Addington Rd, Unit 3 (219-32-03)",
    "$": 996600,
    "address": "28 Addington Rd, Unit 3",
    "parcel_id": "219-32-03",
    "owner1": "BERGMEYER, HEIDI",
    "owner2": "",
    "current_taxes": 6570.25,
    "new_taxes_no_override": 6854.08,
    "override_total_1": 7048.56,
    "override_increase_1": 194.48
  },
  {
    "#": "28 Addington Rd, Unit Gar (219-32-04)",
    "$": 90800,
    "address": "28 Addington Rd, Unit Gar",
    "parcel_id": "219-32-04",
    "owner1": "COHEN, IRA",
    "owner2": "",
    "current_taxes": 929.79,
    "new_taxes_no_override": 969.96,
    "override_total_1": 997.48,
    "override_increase_1": 27.52
  },
  {
    "#": "29 Addington Rd, Unit A (220-06-11)",
    "$": 1339100,
    "address": "29 Addington Rd, Unit A",
    "parcel_id": "220-06-11",
    "owner1": "GHERBI, CHAKIB & SOUAD",
    "owner2": "",
    "current_taxes": 13712.38,
    "new_taxes_no_override": 14304.75,
    "override_total_1": 14710.64,
    "override_increase_1": 405.89
  },
  {
    "#": "29 Addington Rd, Unit B (220-06-12)",
    "$": 1465900,
    "address": "29 Addington Rd, Unit B",
    "parcel_id": "220-06-12",
    "owner1": "GHERBI, CHAKIB & SOUAD",
    "owner2": "",
    "current_taxes": 11375.88,
    "new_taxes_no_override": 11867.32,
    "override_total_1": 12204.04,
    "override_increase_1": 336.73
  },
  {
    "#": "30 Addington Rd (219-31-00)",
    "$": 2467000,
    "address": "30 Addington Rd",
    "parcel_id": "219-31-00",
    "owner1": "SANIEOFF, SYROOS & SIEON",
    "owner2": "",
    "current_taxes": 25262.08,
    "new_taxes_no_override": 26353.4,
    "override_total_1": 27101.16,
    "override_increase_1": 747.76
  },
  {
    "#": "35 Addington Rd (220-17-00)",
    "$": 2522700,
    "address": "35 Addington Rd",
    "parcel_id": "220-17-00",
    "owner1": "WONG, BASIL L & MUN S",
    "owner2": "",
    "current_taxes": 22197.51,
    "new_taxes_no_override": 23156.44,
    "override_total_1": 23813.49,
    "override_increase_1": 657.05
  },
  {
    "#": "36 Addington Rd (219-30-00)",
    "$": 2461000,
    "address": "36 Addington Rd",
    "parcel_id": "219-30-00",
    "owner1": "SANIEOFF TRS, SYROOS &  SIEON",
    "owner2": "",
    "current_taxes": 25200.64,
    "new_taxes_no_override": 26289.31,
    "override_total_1": 27035.25,
    "override_increase_1": 745.94
  },
  {
    "#": "37 Addington Rd (220-18-00)",
    "$": 3083900,
    "address": "37 Addington Rd",
    "parcel_id": "220-18-00",
    "owner1": "CAPLAN, MICHAEL & ERICA",
    "owner2": "",
    "current_taxes": 27944.2,
    "new_taxes_no_override": 29151.39,
    "override_total_1": 29978.54,
    "override_increase_1": 827.15
  },
  {
    "#": "39 Addington Rd (220-19-00)",
    "$": 2852800,
    "address": "39 Addington Rd",
    "parcel_id": "220-19-00",
    "owner1": "WINTHROP 168 LLC",
    "owner2": "C/O D CHIU",
    "current_taxes": 29212.67,
    "new_taxes_no_override": 30474.66,
    "override_total_1": 31339.35,
    "override_increase_1": 864.7
  },
  {
    "#": "41 Addington Rd, Unit 1 (220-20-01)",
    "$": 1341300,
    "address": "41 Addington Rd, Unit 1",
    "parcel_id": "220-20-01",
    "owner1": "KRAUSS, ALEXANDER",
    "owner2": "RODRIGUEZ, JESSICA",
    "current_taxes": 10099.98,
    "new_taxes_no_override": 10536.3,
    "override_total_1": 10835.26,
    "override_increase_1": 298.96
  },
  {
    "#": "41 Addington Rd, Unit 2 (220-20-02)",
    "$": 948700,
    "address": "41 Addington Rd, Unit 2",
    "parcel_id": "220-20-02",
    "owner1": "OLDS, ELIZABETH W",
    "owner2": "",
    "current_taxes": 6079.75,
    "new_taxes_no_override": 6342.4,
    "override_total_1": 6522.36,
    "override_increase_1": 179.96
  },
  {
    "#": "41 Addington Rd, Unit 3 (220-20-03)",
    "$": 999700,
    "address": "41 Addington Rd, Unit 3",
    "parcel_id": "220-20-03",
    "owner1": "RYU, EHRI",
    "owner2": "",
    "current_taxes": 6601.99,
    "new_taxes_no_override": 6887.2,
    "override_total_1": 7082.61,
    "override_increase_1": 195.42
  },
  {
    "#": "42 Addington Rd, Unit 1 P-B&D&E (219-29-01)",
    "$": 1400100,
    "address": "42 Addington Rd, Unit 1 P-B&D&E",
    "parcel_id": "219-29-01",
    "owner1": "MOROZ TRS, PAUL & SOPHIA",
    "owner2": "",
    "current_taxes": 10702.09,
    "new_taxes_no_override": 11164.42,
    "override_total_1": 11481.2,
    "override_increase_1": 316.78
  },
  {
    "#": "42 Addington Rd, Unit 2 (219-29-02)",
    "$": 1233700,
    "address": "42 Addington Rd, Unit 2",
    "parcel_id": "219-29-02",
    "owner1": "RINNIG TRS, PETER S",
    "owner2": "SILVERSTEIN, RUTH A",
    "current_taxes": 8998.15,
    "new_taxes_no_override": 9386.87,
    "override_total_1": 9653.22,
    "override_increase_1": 266.35
  },
  {
    "#": "43 Addington Rd, Unit 1 & Gar A & Pk Sps D (220-21-01)",
    "$": 2112900,
    "address": "43 Addington Rd, Unit 1 & Gar A & Pk Sps D",
    "parcel_id": "220-21-01",
    "owner1": "BADZAK, MIRAN & SANDRA",
    "owner2": "",
    "current_taxes": 18001.16,
    "new_taxes_no_override": 18778.81,
    "override_total_1": 19311.64,
    "override_increase_1": 532.83
  },
  {
    "#": "43 Addington Rd, Unit 2 & Pk Sps- C (220-21-02)",
    "$": 1398000,
    "address": "43 Addington Rd, Unit 2 & Pk Sps- C",
    "parcel_id": "220-21-02",
    "owner1": "BECKFORD, THOMAS JAN",
    "owner2": "LIN-BECKFORD, STEPHANIE",
    "current_taxes": 10680.59,
    "new_taxes_no_override": 11141.99,
    "override_total_1": 11458.14,
    "override_increase_1": 316.15
  },
  {
    "#": "43 Addington Rd, Unit 3 & Gar B (220-21-03)",
    "$": 1498100,
    "address": "43 Addington Rd, Unit 3 & Gar B",
    "parcel_id": "220-21-03",
    "owner1": "FRAHM, NICOLE",
    "owner2": "GWOST, STEVEN DOUGLAS",
    "current_taxes": 11705.61,
    "new_taxes_no_override": 12211.29,
    "override_total_1": 12557.78,
    "override_increase_1": 346.49
  },
  {
    "#": "45 Addington Rd, Unit 1 & P3-4 (220-22-01)",
    "$": 1041900,
    "address": "45 Addington Rd, Unit 1 & P3-4",
    "parcel_id": "220-22-01",
    "owner1": "SUGARMAN, ELLEN",
    "owner2": "",
    "current_taxes": 7034.12,
    "new_taxes_no_override": 7337.99,
    "override_total_1": 7546.2,
    "override_increase_1": 208.21
  },
  {
    "#": "45 Addington Rd, Unit 2 & P1 (220-22-02)",
    "$": 869500,
    "address": "45 Addington Rd, Unit 2 & P1",
    "parcel_id": "220-22-02",
    "owner1": "STEPHENSON 2 DFK 1 LLC",
    "owner2": "",
    "current_taxes": 8903.68,
    "new_taxes_no_override": 9288.32,
    "override_total_1": 9551.87,
    "override_increase_1": 263.55
  },
  {
    "#": "45 Addington Rd, Unit 3 & P-2 (220-22-03)",
    "$": 900400,
    "address": "45 Addington Rd, Unit 3 & P-2",
    "parcel_id": "220-22-03",
    "owner1": "MEHTA, TEJAS",
    "owner2": "LAKSHMINARAYANAN, MEENAKSHI",
    "current_taxes": 5585.16,
    "new_taxes_no_override": 5826.44,
    "override_total_1": 5991.76,
    "override_increase_1": 165.32
  },
  {
    "#": "47 Addington Rd (220-23-00)",
    "$": 3112300,
    "address": "47 Addington Rd",
    "parcel_id": "220-23-00",
    "owner1": "ORICHULA ET AL, NICOLA",
    "owner2": "MELE, ALESSANDRA",
    "current_taxes": 31869.95,
    "new_taxes_no_override": 33246.73,
    "override_total_1": 34190.08,
    "override_increase_1": 943.35
  },
  {
    "#": "48 Addington Rd (219-28-00)",
    "$": 2061100,
    "address": "48 Addington Rd",
    "parcel_id": "219-28-00",
    "owner1": "MOY TRS, ALICE M C & ARTHUR C P",
    "owner2": "",
    "current_taxes": 21105.66,
    "new_taxes_no_override": 22017.42,
    "override_total_1": 22642.15,
    "override_increase_1": 624.73
  },
  {
    "#": "49 Addington Rd (220-24-00)",
    "$": 2749000,
    "address": "49 Addington Rd",
    "parcel_id": "220-24-00",
    "owner1": "REIBSTEIN TR, AARON W",
    "owner2": "",
    "current_taxes": 24514.83,
    "new_taxes_no_override": 25573.87,
    "override_total_1": 26299.51,
    "override_increase_1": 725.64
  },
  {
    "#": "51 Addington Rd, Unit 1 (220-25-01)",
    "$": 1872000,
    "address": "51 Addington Rd, Unit 1",
    "parcel_id": "220-25-01",
    "owner1": "BENSHABAT, HAGAI & JESSICA KRAFT",
    "owner2": "",
    "current_taxes": 15534.35,
    "new_taxes_no_override": 16205.43,
    "override_total_1": 16665.25,
    "override_increase_1": 459.82
  },
  {
    "#": "51 Addington Rd, Unit 2 (220-25-02)",
    "$": 2530300,
    "address": "51 Addington Rd, Unit 2",
    "parcel_id": "220-25-02",
    "owner1": "MARTIN, PETER S",
    "owner2": "SCUDDER MARTIN, DEIRDRE W",
    "current_taxes": 25910.27,
    "new_taxes_no_override": 27029.59,
    "override_total_1": 27796.54,
    "override_increase_1": 766.94
  },
  {
    "#": "53 Addington Rd (220-26-00)",
    "$": 3084500,
    "address": "53 Addington Rd",
    "parcel_id": "220-26-00",
    "owner1": "EDELMAN, DANA BETH",
    "owner2": "KRAUSS, BARUCH S",
    "current_taxes": 27950.35,
    "new_taxes_no_override": 29157.81,
    "override_total_1": 29985.14,
    "override_increase_1": 827.33
  },
  {
    "#": "55 Addington Rd, Unit 1 & P1 (220-27-01)",
    "$": 1301700,
    "address": "55 Addington Rd, Unit 1 & P1",
    "parcel_id": "220-27-01",
    "owner1": "LIANG, STEPHEN",
    "owner2": "",
    "current_taxes": 13329.41,
    "new_taxes_no_override": 13905.24,
    "override_total_1": 14299.79,
    "override_increase_1": 394.55
  },
  {
    "#": "55 Addington Rd, Unit 2 & P2 (220-27-02)",
    "$": 1358300,
    "address": "55 Addington Rd, Unit 2 & P2",
    "parcel_id": "220-27-02",
    "owner1": "CHANGCHANG, LIU",
    "owner2": "BIXIAO, ZHAO",
    "current_taxes": 10274.06,
    "new_taxes_no_override": 10717.9,
    "override_total_1": 11022.01,
    "override_increase_1": 304.11
  },
  {
    "#": "55 Addington Rd, Unit 3 & P3 (220-27-03)",
    "$": 1427700,
    "address": "55 Addington Rd, Unit 3 & P3",
    "parcel_id": "220-27-03",
    "owner1": "LAU, DAVID",
    "owner2": "ANDROSKI, TORREY S",
    "current_taxes": 10984.71,
    "new_taxes_no_override": 11459.25,
    "override_total_1": 11784.4,
    "override_increase_1": 325.15
  },
  {
    "#": "55 Addington Rd, Unit 4 & P4 (220-27-04)",
    "$": 1585100,
    "address": "55 Addington Rd, Unit 4 & P4",
    "parcel_id": "220-27-04",
    "owner1": "ZHANG TR, LEI",
    "owner2": "",
    "current_taxes": 16231.42,
    "new_taxes_no_override": 16932.62,
    "override_total_1": 17413.07,
    "override_increase_1": 480.45
  },
  {
    "#": "56 Addington Rd (219-27-00)",
    "$": 2132000,
    "address": "56 Addington Rd",
    "parcel_id": "219-27-00",
    "owner1": "SHI, WENDONG",
    "owner2": "SUN, JINGWEI",
    "current_taxes": 18196.75,
    "new_taxes_no_override": 18982.85,
    "override_total_1": 19521.47,
    "override_increase_1": 538.62
  },
  {
    "#": "57 Addington Rd, Unit 1 (220-28-03)",
    "$": 1435100,
    "address": "57 Addington Rd, Unit 1",
    "parcel_id": "220-28-03",
    "owner1": "SHARON, BOAZ",
    "owner2": "REED, KATHRYN ELIZABETH",
    "current_taxes": 11060.49,
    "new_taxes_no_override": 11538.3,
    "override_total_1": 11865.69,
    "override_increase_1": 327.39
  },
  {
    "#": "57 Addington Rd, Unit 2 (220-28-01)",
    "$": 1071100,
    "address": "57 Addington Rd, Unit 2",
    "parcel_id": "220-28-01",
    "owner1": "ARAN TRS, ILHAN & OYO",
    "owner2": "",
    "current_taxes": 7333.13,
    "new_taxes_no_override": 7649.92,
    "override_total_1": 7866.98,
    "override_increase_1": 217.06
  },
  {
    "#": "57 Addington Rd, Unit 3 (220-28-02)",
    "$": 1110400,
    "address": "57 Addington Rd, Unit 3",
    "parcel_id": "220-28-02",
    "owner1": "BROWN, ALAN",
    "owner2": "",
    "current_taxes": 7735.56,
    "new_taxes_no_override": 8069.74,
    "override_total_1": 8298.71,
    "override_increase_1": 228.97
  },
  {
    "#": "59 Addington Rd, Unit 1  & Pk B (220-29-01)",
    "$": 1154600,
    "address": "59 Addington Rd, Unit 1  & Pk B",
    "parcel_id": "220-29-01",
    "owner1": "ALVES, CESAR AUGUSTO PINHEIRO",
    "owner2": "",
    "current_taxes": 11823.1,
    "new_taxes_no_override": 12333.86,
    "override_total_1": 12683.82,
    "override_increase_1": 349.96
  },
  {
    "#": "59 Addington Rd, Unit 2 & Pk A (220-29-02)",
    "$": 1475100,
    "address": "59 Addington Rd, Unit 2 & Pk A",
    "parcel_id": "220-29-02",
    "owner1": "JOKUBAITIS, LEONARD A",
    "owner2": "GRANATA, CYNTHIA L",
    "current_taxes": 11470.09,
    "new_taxes_no_override": 11965.6,
    "override_total_1": 12305.11,
    "override_increase_1": 339.51
  },
  {
    "#": "59 Addington Rd, Unit 3 & Pk E (220-29-03)",
    "$": 1557600,
    "address": "59 Addington Rd, Unit 3 & Pk E",
    "parcel_id": "220-29-03",
    "owner1": "ORSMOND TRS, GARETH I & CHARLOTTE M",
    "owner2": "",
    "current_taxes": 12314.89,
    "new_taxes_no_override": 12846.89,
    "override_total_1": 13211.41,
    "override_increase_1": 364.52
  },
  {
    "#": "59 Addington Rd, Unit 4 & Pk C & D (220-29-04)",
    "$": 1764100,
    "address": "59 Addington Rd, Unit 4 & Pk C & D",
    "parcel_id": "220-29-04",
    "owner1": "CHAO, LUKE",
    "owner2": "KILLILEA, ANGELA C",
    "current_taxes": 14429.45,
    "new_taxes_no_override": 15052.8,
    "override_total_1": 15479.91,
    "override_increase_1": 427.11
  },
  {
    "#": "63 Addington Rd (220-30-00)",
    "$": 2688700,
    "address": "63 Addington Rd",
    "parcel_id": "220-30-00",
    "owner1": "DEBONIS, DANIEL V",
    "owner2": "MCMULLIN, SHANNON M",
    "current_taxes": 23897.35,
    "new_taxes_no_override": 24929.72,
    "override_total_1": 25637.08,
    "override_increase_1": 707.36
  },
  {
    "#": "66 Addington Rd (219-26-00)",
    "$": 2994600,
    "address": "66 Addington Rd",
    "parcel_id": "219-26-00",
    "owner1": "EPPSTEIN, DAVID S",
    "owner2": "FOSTER, DEBORAH",
    "current_taxes": 27029.77,
    "new_taxes_no_override": 28197.46,
    "override_total_1": 28997.54,
    "override_increase_1": 800.08
  },
  {
    "#": "71 Addington Rd (220-31-00)",
    "$": 3038900,
    "address": "71 Addington Rd",
    "parcel_id": "220-31-00",
    "owner1": "DAMM-LUHR TRS, DAVID L & INGEBORG P",
    "owner2": "",
    "current_taxes": 27483.4,
    "new_taxes_no_override": 28670.68,
    "override_total_1": 29484.19,
    "override_increase_1": 813.51
  },
  {
    "#": "72 Addington Rd (219-25-00)",
    "$": 2860700,
    "address": "72 Addington Rd",
    "parcel_id": "219-25-00",
    "owner1": "IDE, ROBERT D",
    "owner2": "",
    "current_taxes": 25658.63,
    "new_taxes_no_override": 26767.08,
    "override_total_1": 27526.58,
    "override_increase_1": 759.5
  },
  {
    "#": "77 Addington Rd, Unit 1 (220-32-01)",
    "$": 3123000,
    "address": "77 Addington Rd, Unit 1",
    "parcel_id": "220-32-01",
    "owner1": "REMIEN TR, JANET LIND",
    "owner2": "",
    "current_taxes": 28344.59,
    "new_taxes_no_override": 29569.08,
    "override_total_1": 30408.08,
    "override_increase_1": 839.0
  },
  {
    "#": "77 Addington Rd, Unit 2 (220-32-02)",
    "$": 3203600,
    "address": "77 Addington Rd, Unit 2",
    "parcel_id": "220-32-02",
    "owner1": "COGGIN TR, MICHAEL A",
    "owner2": "",
    "current_taxes": 29169.93,
    "new_taxes_no_override": 30430.07,
    "override_total_1": 31293.5,
    "override_increase_1": 863.43
  },
  {
    "#": "78 Addington Rd (219-24-00)",
    "$": 2433500,
    "address": "78 Addington Rd",
    "parcel_id": "219-24-00",
    "owner1": "PASEK, RICHARD EDWARD",
    "owner2": "MCARDEL, SHANNON LEAH",
    "current_taxes": 21284.11,
    "new_taxes_no_override": 22203.58,
    "override_total_1": 22833.59,
    "override_increase_1": 630.01
  },
  {
    "#": "86 Addington Rd (219-23-00)",
    "$": 3059300,
    "address": "86 Addington Rd",
    "parcel_id": "219-23-00",
    "owner1": "SPINOWITZ, MOSHE",
    "owner2": "DAY, TOVAH",
    "current_taxes": 27692.3,
    "new_taxes_no_override": 28888.61,
    "override_total_1": 29708.3,
    "override_increase_1": 819.69
  },
  {
    "#": "90 Addington Rd, Unit 1 (219-22-03)",
    "$": 1155100,
    "address": "90 Addington Rd, Unit 1",
    "parcel_id": "219-22-03",
    "owner1": "ADDING90 LLC",
    "owner2": "",
    "current_taxes": 11828.22,
    "new_taxes_no_override": 12339.2,
    "override_total_1": 12689.31,
    "override_increase_1": 350.12
  },
  {
    "#": "90 Addington Rd, Unit 2 (219-22-01)",
    "$": 1605400,
    "address": "90 Addington Rd, Unit 2",
    "parcel_id": "219-22-01",
    "owner1": "ADDING90 LLC",
    "owner2": "",
    "current_taxes": 16439.3,
    "new_taxes_no_override": 17149.48,
    "override_total_1": 17636.08,
    "override_increase_1": 486.6
  },
  {
    "#": "90 Addington Rd, Unit 3 (219-22-02)",
    "$": 214900,
    "address": "90 Addington Rd, Unit 3",
    "parcel_id": "219-22-02",
    "owner1": "ADDING90 LLC",
    "owner2": "",
    "current_taxes": 2200.58,
    "new_taxes_no_override": 2295.65,
    "override_total_1": 2360.78,
    "override_increase_1": 65.14
  },
  {
    "#": "94 Addington Rd (219-21-00)",
    "$": 2465000,
    "address": "94 Addington Rd",
    "parcel_id": "219-21-00",
    "owner1": "REGOLINO, CONNIE ANNE & AUSTIN",
    "owner2": "",
    "current_taxes": 21606.67,
    "new_taxes_no_override": 22540.08,
    "override_total_1": 23179.64,
    "override_increase_1": 639.56
  },
  {
    "#": "98 Addington Rd (219-20-00)",
    "$": 2889200,
    "address": "98 Addington Rd",
    "parcel_id": "219-20-00",
    "owner1": "REGOLINO, CONNIE A & AUSTIN P",
    "owner2": "",
    "current_taxes": 29585.41,
    "new_taxes_no_override": 30863.5,
    "override_total_1": 31739.23,
    "override_increase_1": 875.73
  },
  {
    "#": "99 Addington Rd (220-33-00)",
    "$": 5690000,
    "address": "99 Addington Rd",
    "parcel_id": "220-33-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O LOTTA BRADBURN SCHICK PARK",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "102 Addington Rd, Unit 1 (219-19-01)",
    "$": 1268800,
    "address": "102 Addington Rd, Unit 1",
    "parcel_id": "219-19-01",
    "owner1": "SAMAROV TRS, ALEXANDER M & NORA E",
    "owner2": "",
    "current_taxes": 9357.58,
    "new_taxes_no_override": 9761.83,
    "override_total_1": 10038.81,
    "override_increase_1": 276.98
  },
  {
    "#": "102 Addington Rd, Unit 2 (219-19-02)",
    "$": 1521400,
    "address": "102 Addington Rd, Unit 2",
    "parcel_id": "219-19-02",
    "owner1": "ZHANG, HUAXIN",
    "owner2": "MA, WENJIANG",
    "current_taxes": 11944.2,
    "new_taxes_no_override": 12460.19,
    "override_total_1": 12813.74,
    "override_increase_1": 353.55
  },
  {
    "#": "106 Addington Rd, Unit 1 (219-18-01)",
    "$": 1268800,
    "address": "106 Addington Rd, Unit 1",
    "parcel_id": "219-18-01",
    "owner1": "SILEVITCH, PAUL D & LIANE",
    "owner2": "",
    "current_taxes": 9357.58,
    "new_taxes_no_override": 9761.83,
    "override_total_1": 10038.81,
    "override_increase_1": 276.98
  },
  {
    "#": "106 Addington Rd, Unit 2 (219-18-02)",
    "$": 2207900,
    "address": "106 Addington Rd, Unit 2",
    "parcel_id": "219-18-02",
    "owner1": "KADOSH, ODED & RUVANNE",
    "owner2": "",
    "current_taxes": 22608.9,
    "new_taxes_no_override": 23585.6,
    "override_total_1": 24254.83,
    "override_increase_1": 669.22
  },
  {
    "#": "110 Addington Rd, Unit A (219-17-01)",
    "$": 2945900,
    "address": "110 Addington Rd, Unit A",
    "parcel_id": "219-17-01",
    "owner1": "SHAKHNOVICH, BORIS E",
    "owner2": "SUI, SHANNAN J HO",
    "current_taxes": 30166.02,
    "new_taxes_no_override": 31469.19,
    "override_total_1": 32362.11,
    "override_increase_1": 892.91
  },
  {
    "#": "110 Addington Rd, Unit B (219-17-02)",
    "$": 2935400,
    "address": "110 Addington Rd, Unit B",
    "parcel_id": "219-17-02",
    "owner1": "WILLEN, PAUL",
    "owner2": "DOLBEAR, EMILY",
    "current_taxes": 26423.56,
    "new_taxes_no_override": 27565.06,
    "override_total_1": 28347.2,
    "override_increase_1": 782.14
  },
  {
    "#": "114 Addington Rd, Unit 1 (219-16-01)",
    "$": 1789600,
    "address": "114 Addington Rd, Unit 1",
    "parcel_id": "219-16-01",
    "owner1": "HACOHEN, EREZ & MIRI",
    "owner2": "",
    "current_taxes": 14690.57,
    "new_taxes_no_override": 15325.2,
    "override_total_1": 15760.04,
    "override_increase_1": 434.84
  },
  {
    "#": "114 Addington Rd, Unit 2 & P10 P11 (219-16-02)",
    "$": 1220000,
    "address": "114 Addington Rd, Unit 2 & P10 P11",
    "parcel_id": "219-16-02",
    "owner1": "PAIT, FELIPE MIGUEL",
    "owner2": "STERN, SUSANNA VICTORIA",
    "current_taxes": 8857.87,
    "new_taxes_no_override": 9240.53,
    "override_total_1": 9502.72,
    "override_increase_1": 262.19
  },
  {
    "#": "114 Addington Rd, Unit Gar B (219-16-06)",
    "$": 88500,
    "address": "114 Addington Rd, Unit Gar B",
    "parcel_id": "219-16-06",
    "owner1": "PAIT, FELIPE MIGUEL",
    "owner2": "STERN, SUSANNA VICTORIA",
    "current_taxes": 906.24,
    "new_taxes_no_override": 945.39,
    "override_total_1": 972.21,
    "override_increase_1": 26.82
  },
  {
    "#": "114 Addington Rd, Unit P12 (219-16-05)",
    "$": 52500,
    "address": "114 Addington Rd, Unit P12",
    "parcel_id": "219-16-05",
    "owner1": "PAIT ET AL, FELIPE M",
    "owner2": "ZACK, LINDA",
    "current_taxes": 537.6,
    "new_taxes_no_override": 560.82,
    "override_total_1": 576.74,
    "override_increase_1": 15.91
  },
  {
    "#": "114 Addington Rd, Unit P4-P5 (219-16-04)",
    "$": 105000,
    "address": "114 Addington Rd, Unit P4-P5",
    "parcel_id": "219-16-04",
    "owner1": "SULLIVAN, BRIGID",
    "owner2": "",
    "current_taxes": 1075.2,
    "new_taxes_no_override": 1121.65,
    "override_total_1": 1153.47,
    "override_increase_1": 31.83
  },
  {
    "#": "114 Addington Rd, Unit P6-P7 (219-16-03)",
    "$": 105000,
    "address": "114 Addington Rd, Unit P6-P7",
    "parcel_id": "219-16-03",
    "owner1": "TMI-RR WINTHROP ROAD BROOKLINE LLC",
    "owner2": "C/O TAYMIL PARTNERS LLC",
    "current_taxes": 1075.2,
    "new_taxes_no_override": 1121.65,
    "override_total_1": 1153.47,
    "override_increase_1": 31.83
  },
  {
    "#": "118 Addington Rd, Unit 1 (219-15-01)",
    "$": 1676100,
    "address": "118 Addington Rd, Unit 1",
    "parcel_id": "219-15-01",
    "owner1": "ASSAD, JOHN A",
    "owner2": "BATTELLI, LORELLA",
    "current_taxes": 13528.33,
    "new_taxes_no_override": 14112.75,
    "override_total_1": 14513.19,
    "override_increase_1": 400.44
  },
  {
    "#": "118 Addington Rd, Unit 2 (219-15-02)",
    "$": 2009600,
    "address": "118 Addington Rd, Unit 2",
    "parcel_id": "219-15-02",
    "owner1": "GROSS, STEFAN B & ANDRIA E",
    "owner2": "",
    "current_taxes": 16943.37,
    "new_taxes_no_override": 17675.32,
    "override_total_1": 18176.85,
    "override_increase_1": 501.52
  },
  {
    "#": "122 Addington Rd, Unit 1 (219-14-02)",
    "$": 1086400,
    "address": "122 Addington Rd, Unit 1",
    "parcel_id": "219-14-02",
    "owner1": "RAJU, CHITRANGADA SAREGA",
    "owner2": "HEGDE, KARTHIK",
    "current_taxes": 11124.74,
    "new_taxes_no_override": 11605.33,
    "override_total_1": 11934.62,
    "override_increase_1": 329.29
  },
  {
    "#": "122 Addington Rd, Unit 2 (219-14-01)",
    "$": 1487400,
    "address": "122 Addington Rd, Unit 2",
    "parcel_id": "219-14-01",
    "owner1": "RAJU, PRIYAMVADA",
    "owner2": "ANAND, VIKAS",
    "current_taxes": 11596.04,
    "new_taxes_no_override": 12096.99,
    "override_total_1": 12440.23,
    "override_increase_1": 343.24
  },
  {
    "#": "125 Addington Rd (220-38-00)",
    "$": 3274000,
    "address": "125 Addington Rd",
    "parcel_id": "220-38-00",
    "owner1": "LYLE, ELIZABETH",
    "owner2": "SMITH, EDWARD",
    "current_taxes": 29890.83,
    "new_taxes_no_override": 31182.11,
    "override_total_1": 32066.88,
    "override_increase_1": 884.77
  },
  {
    "#": "128 Addington Rd (219-13-00)",
    "$": 2783000,
    "address": "128 Addington Rd",
    "parcel_id": "219-13-00",
    "owner1": "BAISSAC, MATHIEU",
    "owner2": "LIBBY, JUSTIN C",
    "current_taxes": 28497.92,
    "new_taxes_no_override": 29729.03,
    "override_total_1": 30572.57,
    "override_increase_1": 843.54
  },
  {
    "#": "129 Addington Rd (220-39-00)",
    "$": 2506300,
    "address": "129 Addington Rd",
    "parcel_id": "220-39-00",
    "owner1": "PECHENICK TRS, FRANCES CLAIRE & ANNETTE RUTH",
    "owner2": "",
    "current_taxes": 22029.58,
    "new_taxes_no_override": 22981.26,
    "override_total_1": 23633.33,
    "override_increase_1": 652.08
  },
  {
    "#": "135 Addington Rd (220-40-00)",
    "$": 3080700,
    "address": "135 Addington Rd",
    "parcel_id": "220-40-00",
    "owner1": "DALY, MORGAN A & RITA  & NINA MAX",
    "owner2": "MURRAY, SHANE THOMAS",
    "current_taxes": 27911.43,
    "new_taxes_no_override": 29117.2,
    "override_total_1": 29943.38,
    "override_increase_1": 826.18
  },
  {
    "#": " Addington Rd (219-35-01)",
    "$": 263800,
    "address": " Addington Rd",
    "parcel_id": "219-35-01",
    "owner1": "BARDFIELD, TR, CLAIRE",
    "owner2": "",
    "current_taxes": 2701.31,
    "new_taxes_no_override": 2818.01,
    "override_total_1": 2897.97,
    "override_increase_1": 79.96
  },
  {
    "#": " Addington Rd (220-16-01)",
    "$": 3900,
    "address": " Addington Rd",
    "parcel_id": "220-16-01",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O VACANT PARCEL REAR 41 ADDINGTON",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "8 Alberta Rd (374-18-00)",
    "$": 1948900,
    "address": "8 Alberta Rd",
    "parcel_id": "374-18-00",
    "owner1": "HUSSAIN, AYSHA & TANVIR",
    "owner2": "",
    "current_taxes": 16321.8,
    "new_taxes_no_override": 17026.9,
    "override_total_1": 17510.03,
    "override_increase_1": 483.13
  },
  {
    "#": "15 Alberta Rd (399-48-00)",
    "$": 2402600,
    "address": "15 Alberta Rd",
    "parcel_id": "399-48-00",
    "owner1": "RICHLIN, JENNY",
    "owner2": "",
    "current_taxes": 20967.69,
    "new_taxes_no_override": 21873.49,
    "override_total_1": 22494.14,
    "override_increase_1": 620.64
  },
  {
    "#": "16 Alberta Rd (395-29-00)",
    "$": 2334700,
    "address": "16 Alberta Rd",
    "parcel_id": "395-29-00",
    "owner1": "BERGANTINO TRS, JOSEPH A",
    "owner2": "ALTMAN , CANDY B",
    "current_taxes": 20272.39,
    "new_taxes_no_override": 21148.16,
    "override_total_1": 21748.22,
    "override_increase_1": 600.06
  },
  {
    "#": "24 Alberta Rd (395-28-00)",
    "$": 2052000,
    "address": "24 Alberta Rd",
    "parcel_id": "395-28-00",
    "owner1": "XUAN, ZIMING",
    "owner2": "CHEN, YUEQING",
    "current_taxes": 17377.55,
    "new_taxes_no_override": 18128.26,
    "override_total_1": 18642.64,
    "override_increase_1": 514.38
  },
  {
    "#": "25 Alberta Rd (399-49-00)",
    "$": 1712200,
    "address": "25 Alberta Rd",
    "parcel_id": "399-49-00",
    "owner1": "DONOFF, MADELYN B",
    "owner2": "",
    "current_taxes": 13897.99,
    "new_taxes_no_override": 14498.38,
    "override_total_1": 14909.76,
    "override_increase_1": 411.38
  },
  {
    "#": "31 Alberta Rd (399-50-00)",
    "$": 1992100,
    "address": "31 Alberta Rd",
    "parcel_id": "399-50-00",
    "owner1": "LYNCH, GEORGE W & MELISSA H",
    "owner2": "",
    "current_taxes": 16764.17,
    "new_taxes_no_override": 17488.38,
    "override_total_1": 17984.6,
    "override_increase_1": 496.22
  },
  {
    "#": "32 Alberta Rd (395-27-01)",
    "$": 2435300,
    "address": "32 Alberta Rd",
    "parcel_id": "395-27-01",
    "owner1": "GUREVICH, ALEXANDER A &  MARIA B",
    "owner2": "",
    "current_taxes": 21302.54,
    "new_taxes_no_override": 22222.81,
    "override_total_1": 22853.36,
    "override_increase_1": 630.56
  },
  {
    "#": "37 Alberta Rd (399-51-00)",
    "$": 2324200,
    "address": "37 Alberta Rd",
    "parcel_id": "399-51-00",
    "owner1": "ASHER TR, DANIEL",
    "owner2": "",
    "current_taxes": 20164.87,
    "new_taxes_no_override": 21035.99,
    "override_total_1": 21632.87,
    "override_increase_1": 596.88
  },
  {
    "#": "38 Alberta Rd (395-27-00)",
    "$": 2578700,
    "address": "38 Alberta Rd",
    "parcel_id": "395-27-00",
    "owner1": "SERVER TR, JUDITH C",
    "owner2": "",
    "current_taxes": 22770.95,
    "new_taxes_no_override": 23754.66,
    "override_total_1": 24428.68,
    "override_increase_1": 674.02
  },
  {
    "#": "45 Alberta Rd (399-52-00)",
    "$": 1707600,
    "address": "45 Alberta Rd",
    "parcel_id": "399-52-00",
    "owner1": "ZHANG TRS, DI",
    "owner2": "CHEN, DINGFENG",
    "current_taxes": 13850.89,
    "new_taxes_no_override": 14449.25,
    "override_total_1": 14859.23,
    "override_increase_1": 409.99
  },
  {
    "#": "46 Alberta Rd (395-26-00)",
    "$": 2410200,
    "address": "46 Alberta Rd",
    "parcel_id": "395-26-00",
    "owner1": "ALTMAN TRS, SUSAN M & STEVEN E",
    "owner2": "",
    "current_taxes": 21045.51,
    "new_taxes_no_override": 21954.68,
    "override_total_1": 22577.62,
    "override_increase_1": 622.95
  },
  {
    "#": "50 Alberta Rd (395-13-01)",
    "$": 20400,
    "address": "50 Alberta Rd",
    "parcel_id": "395-13-01",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O VACANT PARCEL/REAR 52 ALBERTA",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "51 Alberta Rd (399-53-00)",
    "$": 1665800,
    "address": "51 Alberta Rd",
    "parcel_id": "399-53-00",
    "owner1": "CRANBERG, LEE D",
    "owner2": "FLASHMAN, SHARON L",
    "current_taxes": 13422.86,
    "new_taxes_no_override": 14002.73,
    "override_total_1": 14400.04,
    "override_increase_1": 397.32
  },
  {
    "#": "52 Alberta Rd (395-25-00)",
    "$": 2158400,
    "address": "52 Alberta Rd",
    "parcel_id": "395-25-00",
    "owner1": "LIPSHUTZ, DAVID M & MARGERY R",
    "owner2": "",
    "current_taxes": 18467.08,
    "new_taxes_no_override": 19264.86,
    "override_total_1": 19811.48,
    "override_increase_1": 546.63
  },
  {
    "#": "57 Alberta Rd (399-54-00)",
    "$": 1493800,
    "address": "57 Alberta Rd",
    "parcel_id": "399-54-00",
    "owner1": "SARKAR, APRATIM",
    "owner2": "DAS, SUDESHNA",
    "current_taxes": 11661.58,
    "new_taxes_no_override": 12165.36,
    "override_total_1": 12510.54,
    "override_increase_1": 345.18
  },
  {
    "#": "60 Alberta Rd (395-24-00)",
    "$": 1700900,
    "address": "60 Alberta Rd",
    "parcel_id": "395-24-00",
    "owner1": "SCHREINER-OLDHAM, JULIE",
    "owner2": "OLDHAM, WILLIAM",
    "current_taxes": 17417.22,
    "new_taxes_no_override": 18169.64,
    "override_total_1": 18685.19,
    "override_increase_1": 515.55
  },
  {
    "#": "65 Alberta Rd (399-55-00)",
    "$": 1943100,
    "address": "65 Alberta Rd",
    "parcel_id": "399-55-00",
    "owner1": "BABBAR, RAJAT",
    "owner2": "MAHAJAN, ALKA",
    "current_taxes": 16262.41,
    "new_taxes_no_override": 16964.95,
    "override_total_1": 17446.31,
    "override_increase_1": 481.37
  },
  {
    "#": "68 Alberta Rd (395-23-00)",
    "$": 2342600,
    "address": "68 Alberta Rd",
    "parcel_id": "395-23-00",
    "owner1": "SINHA, INDRANIL",
    "owner2": "TRAN, HUONG HOAI",
    "current_taxes": 23988.22,
    "new_taxes_no_override": 25024.51,
    "override_total_1": 25734.56,
    "override_increase_1": 710.05
  },
  {
    "#": "71 Alberta Rd (399-56-00)",
    "$": 803100,
    "address": "71 Alberta Rd",
    "parcel_id": "399-56-00",
    "owner1": "KICKHAM LIFE ESTATE, GEORGE A",
    "owner2": "",
    "current_taxes": 8223.74,
    "new_taxes_no_override": 8579.01,
    "override_total_1": 8822.43,
    "override_increase_1": 243.42
  },
  {
    "#": "74 Alberta Rd (395-22-00)",
    "$": 1209400,
    "address": "74 Alberta Rd",
    "parcel_id": "395-22-00",
    "owner1": "SUTTON, MARK",
    "owner2": "BITENSKY, SUSAN",
    "current_taxes": 12384.26,
    "new_taxes_no_override": 12919.26,
    "override_total_1": 13285.83,
    "override_increase_1": 366.57
  },
  {
    "#": "79 Alberta Rd (399-57-00)",
    "$": 770100,
    "address": "79 Alberta Rd",
    "parcel_id": "399-57-00",
    "owner1": "KICKHAM LIFE ESTATE, GEORGE A",
    "owner2": "",
    "current_taxes": 7885.82,
    "new_taxes_no_override": 8226.49,
    "override_total_1": 8459.91,
    "override_increase_1": 233.42
  },
  {
    "#": "84 Alberta Rd (395-21-00)",
    "$": 1507300,
    "address": "84 Alberta Rd",
    "parcel_id": "395-21-00",
    "owner1": "ZHU, LIBEN",
    "owner2": "REN, XINPING",
    "current_taxes": 11799.82,
    "new_taxes_no_override": 12309.57,
    "override_total_1": 12658.85,
    "override_increase_1": 349.27
  },
  {
    "#": "85 Alberta Rd (399-58-00)",
    "$": 1906600,
    "address": "85 Alberta Rd",
    "parcel_id": "399-58-00",
    "owner1": "MADSEN TRS, OLE SECHER & GRACE YONG",
    "owner2": "",
    "current_taxes": 15888.65,
    "new_taxes_no_override": 16575.04,
    "override_total_1": 17045.34,
    "override_increase_1": 470.3
  },
  {
    "#": "93 Alberta Rd (399-59-00)",
    "$": 1793100,
    "address": "93 Alberta Rd",
    "parcel_id": "399-59-00",
    "owner1": "MOHANTY TRS, DEBRAJ & LISA B",
    "owner2": "",
    "current_taxes": 18361.34,
    "new_taxes_no_override": 19154.55,
    "override_total_1": 19698.05,
    "override_increase_1": 543.5
  },
  {
    "#": "99 Alberta Rd (399-60-00)",
    "$": 1759500,
    "address": "99 Alberta Rd",
    "parcel_id": "399-60-00",
    "owner1": "AMES, CARLOTTA A",
    "owner2": "",
    "current_taxes": 14382.35,
    "new_taxes_no_override": 15003.67,
    "override_total_1": 15429.39,
    "override_increase_1": 425.72
  },
  {
    "#": "107 Alberta Rd (399-61-00)",
    "$": 2094000,
    "address": "107 Alberta Rd",
    "parcel_id": "399-61-00",
    "owner1": "HART, JAMES D & LINDA R",
    "owner2": "",
    "current_taxes": 17807.63,
    "new_taxes_no_override": 18576.92,
    "override_total_1": 19104.03,
    "override_increase_1": 527.11
  },
  {
    "#": " Alberta Rd (395-11-01)",
    "$": 20600,
    "address": " Alberta Rd",
    "parcel_id": "395-11-01",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O VACANT PARCEL/REAR 32 ALBERTA",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "266 Allandale Rd (358-01-00)",
    "$": 1221500,
    "address": "266 Allandale Rd",
    "parcel_id": "358-01-00",
    "owner1": "YANKOWITZ, ETHAN S",
    "owner2": "GWIAZDA, AMY S",
    "current_taxes": 8873.23,
    "new_taxes_no_override": 9256.55,
    "override_total_1": 9519.2,
    "override_increase_1": 262.65
  },
  {
    "#": "278 Allandale Rd (359-01-00)",
    "$": 1451200,
    "address": "278 Allandale Rd",
    "parcel_id": "359-01-00",
    "owner1": "BLOOSTEIN TR, MARC J",
    "owner2": "",
    "current_taxes": 14860.29,
    "new_taxes_no_override": 15502.25,
    "override_total_1": 15942.12,
    "override_increase_1": 439.86
  },
  {
    "#": "294 Allandale Rd (359-13-14)",
    "$": 2022000,
    "address": "294 Allandale Rd",
    "parcel_id": "359-13-14",
    "owner1": "TIMOTHY, J GETHYN",
    "owner2": "LINGGOOD, RITA M",
    "current_taxes": 17070.35,
    "new_taxes_no_override": 17807.79,
    "override_total_1": 18313.07,
    "override_increase_1": 505.28
  },
  {
    "#": "302 Allandale Rd (359-12-00)",
    "$": 2307600,
    "address": "302 Allandale Rd",
    "parcel_id": "359-12-00",
    "owner1": "TRUESDALE TR, TODD M",
    "owner2": "AKIN, SUSAN ELIZABETH",
    "current_taxes": 19994.89,
    "new_taxes_no_override": 20858.67,
    "override_total_1": 21450.52,
    "override_increase_1": 591.85
  },
  {
    "#": "306 Allandale Rd (359-11-00)",
    "$": 2055900,
    "address": "306 Allandale Rd",
    "parcel_id": "359-11-00",
    "owner1": "HONG, MIN PYO & MARGARET",
    "owner2": "",
    "current_taxes": 17417.48,
    "new_taxes_no_override": 18169.92,
    "override_total_1": 18685.47,
    "override_increase_1": 515.56
  },
  {
    "#": "318 Allandale Rd (363-30-31)",
    "$": 1251500,
    "address": "318 Allandale Rd",
    "parcel_id": "363-30-31",
    "owner1": "VAZIRI, SONYA M",
    "owner2": "",
    "current_taxes": 12815.36,
    "new_taxes_no_override": 13368.98,
    "override_total_1": 13748.32,
    "override_increase_1": 379.33
  },
  {
    "#": "28 Allerton St (292-08-00)",
    "$": 3486600,
    "address": "28 Allerton St",
    "parcel_id": "292-08-00",
    "owner1": "SCHARER TRS, L SCOTT",
    "owner2": "TALCOTT, MARGARET M",
    "current_taxes": 32067.85,
    "new_taxes_no_override": 33453.18,
    "override_total_1": 34402.39,
    "override_increase_1": 949.21
  },
  {
    "#": "31 Allerton St (295-02-00)",
    "$": 2658500,
    "address": "31 Allerton St",
    "parcel_id": "295-02-00",
    "owner1": "BRICKUS, RUTA E",
    "owner2": "MOORE TR, M QUINN",
    "current_taxes": 23588.11,
    "new_taxes_no_override": 24607.12,
    "override_total_1": 25305.32,
    "override_increase_1": 698.21
  },
  {
    "#": "32 Allerton St (292-07-00)",
    "$": 2460800,
    "address": "32 Allerton St",
    "parcel_id": "292-07-00",
    "owner1": "RING, CHARLES B & CORINNE L",
    "owner2": "",
    "current_taxes": 21563.66,
    "new_taxes_no_override": 22495.21,
    "override_total_1": 23133.49,
    "override_increase_1": 638.28
  },
  {
    "#": "35 Allerton St (295-03-00)",
    "$": 4037700,
    "address": "35 Allerton St",
    "parcel_id": "295-03-00",
    "owner1": "GOLDMAN, JOSHUA",
    "owner2": "PETERSON, COURTNEY",
    "current_taxes": 41346.05,
    "new_taxes_no_override": 43132.2,
    "override_total_1": 44356.04,
    "override_increase_1": 1223.84
  },
  {
    "#": "36 Allerton St (292-06-00)",
    "$": 3749600,
    "address": "36 Allerton St",
    "parcel_id": "292-06-00",
    "owner1": "PERREAULT, DAVID JOHN",
    "owner2": "NAKAJIMA, HIDEKO HEIDI",
    "current_taxes": 38395.9,
    "new_taxes_no_override": 40054.6,
    "override_total_1": 41191.12,
    "override_increase_1": 1136.52
  },
  {
    "#": "41 Allerton St (295-04-00)",
    "$": 3557900,
    "address": "41 Allerton St",
    "parcel_id": "295-04-00",
    "owner1": "MACENKA, MARK J",
    "owner2": "MITTELHOLZER, LISEL",
    "current_taxes": 32797.96,
    "new_taxes_no_override": 34214.83,
    "override_total_1": 35185.65,
    "override_increase_1": 970.82
  },
  {
    "#": "43 Allerton St (295-05-00)",
    "$": 2618900,
    "address": "43 Allerton St",
    "parcel_id": "295-05-00",
    "owner1": "BATCHELDER, EDWARD M",
    "owner2": "SENATOR, SUSAN",
    "current_taxes": 23182.6,
    "new_taxes_no_override": 24184.09,
    "override_total_1": 24870.29,
    "override_increase_1": 686.2
  },
  {
    "#": "44 Allerton St (292-05-00)",
    "$": 2047800,
    "address": "44 Allerton St",
    "parcel_id": "292-05-00",
    "owner1": "COOK, JOHN R JR & BROOKE C",
    "owner2": "",
    "current_taxes": 17334.54,
    "new_taxes_no_override": 18083.39,
    "override_total_1": 18596.49,
    "override_increase_1": 513.1
  },
  {
    "#": "48 Allerton St (292-04-00)",
    "$": 2934900,
    "address": "48 Allerton St",
    "parcel_id": "292-04-00",
    "owner1": "POPLOWSKI, MEGAN",
    "owner2": "PEDLIKIN, JOEL",
    "current_taxes": 26418.44,
    "new_taxes_no_override": 27559.72,
    "override_total_1": 28341.7,
    "override_increase_1": 781.99
  },
  {
    "#": "52 Allerton St (292-03-00)",
    "$": 2619700,
    "address": "52 Allerton St",
    "parcel_id": "292-03-00",
    "owner1": "TAYLOR, CAROL M",
    "owner2": "",
    "current_taxes": 23190.79,
    "new_taxes_no_override": 24192.63,
    "override_total_1": 24879.08,
    "override_increase_1": 686.45
  },
  {
    "#": "58 Allerton St (292-02-00)",
    "$": 2791800,
    "address": "58 Allerton St",
    "parcel_id": "292-02-00",
    "owner1": "GODDARD TRS, HENRY BROTHERTON III & JANET HOBER",
    "owner2": "",
    "current_taxes": 24953.1,
    "new_taxes_no_override": 26031.07,
    "override_total_1": 26769.69,
    "override_increase_1": 738.61
  },
  {
    "#": "4 Alton Ct, Unit 1 & P2 & 31 (155-47-01)",
    "$": 1619800,
    "address": "4 Alton Ct, Unit 1 & P2 & 31",
    "parcel_id": "155-47-01",
    "owner1": "RABB, DANIEL A",
    "owner2": "BENJAMIN, JESSICA E",
    "current_taxes": 16586.75,
    "new_taxes_no_override": 17303.3,
    "override_total_1": 17794.27,
    "override_increase_1": 490.97
  },
  {
    "#": "4 Alton Ct, Unit 2 & P1 & 30 (155-47-02)",
    "$": 1470300,
    "address": "4 Alton Ct, Unit 2 & P1 & 30",
    "parcel_id": "155-47-02",
    "owner1": "GALLOP, JENNIFER",
    "owner2": "STARR, DAVID B",
    "current_taxes": 11420.94,
    "new_taxes_no_override": 11914.32,
    "override_total_1": 12252.38,
    "override_increase_1": 338.06
  },
  {
    "#": "4 Alton Ct, Unit 3 & P15 (155-47-03)",
    "$": 1444600,
    "address": "4 Alton Ct, Unit 3 & P15",
    "parcel_id": "155-47-03",
    "owner1": "DEVRIES, TRS, BARBARA K",
    "owner2": "",
    "current_taxes": 11157.77,
    "new_taxes_no_override": 11639.79,
    "override_total_1": 11970.06,
    "override_increase_1": 330.27
  },
  {
    "#": "4 Alton Ct, Unit A (155-47-04)",
    "$": 333300,
    "address": "4 Alton Ct, Unit A",
    "parcel_id": "155-47-04",
    "owner1": "YUE, SIMON",
    "owner2": "",
    "current_taxes": 3412.99,
    "new_taxes_no_override": 3560.43,
    "override_total_1": 3661.46,
    "override_increase_1": 101.02
  },
  {
    "#": "5 Alton Ct, Unit 5-1 & P24 (155-40-07)",
    "$": 516400,
    "address": "5 Alton Ct, Unit 5-1 & P24",
    "parcel_id": "155-40-07",
    "owner1": "FRISARDI, ANDREW D",
    "owner2": "LULL, DAPHNE J",
    "current_taxes": 5287.94,
    "new_taxes_no_override": 5516.38,
    "override_total_1": 5672.9,
    "override_increase_1": 156.52
  },
  {
    "#": "5 Alton Ct, Unit 5-2 (155-40-08)",
    "$": 527000,
    "address": "5 Alton Ct, Unit 5-2",
    "parcel_id": "155-40-08",
    "owner1": "PANETTIERE, JAMES YOUNG",
    "owner2": "DURAN PANETTIERE, KRISTINA JEAN",
    "current_taxes": 5396.48,
    "new_taxes_no_override": 5629.61,
    "override_total_1": 5789.34,
    "override_increase_1": 159.74
  },
  {
    "#": "5 Alton Ct, Unit 5-3 (155-40-09)",
    "$": 529300,
    "address": "5 Alton Ct, Unit 5-3",
    "parcel_id": "155-40-09",
    "owner1": "ARNAOUT, AMAL K",
    "owner2": "",
    "current_taxes": 5420.03,
    "new_taxes_no_override": 5654.18,
    "override_total_1": 5814.61,
    "override_increase_1": 160.43
  },
  {
    "#": "5 Alton Ct, Unit 5-4 & Pk Sp (155-40-10)",
    "$": 528600,
    "address": "5 Alton Ct, Unit 5-4 & Pk Sp",
    "parcel_id": "155-40-10",
    "owner1": "KINEL, KAREN S",
    "owner2": "",
    "current_taxes": 1777.93,
    "new_taxes_no_override": 1854.74,
    "override_total_1": 1907.36,
    "override_increase_1": 52.63
  },
  {
    "#": "5 Alton Ct, Unit 5-5 (155-40-11)",
    "$": 515600,
    "address": "5 Alton Ct, Unit 5-5",
    "parcel_id": "155-40-11",
    "owner1": "MOSHA, STEPHEN N",
    "owner2": "",
    "current_taxes": 5279.74,
    "new_taxes_no_override": 5507.82,
    "override_total_1": 5664.11,
    "override_increase_1": 156.28
  },
  {
    "#": "5 Alton Ct, Unit 5-6 (155-40-12)",
    "$": 588400,
    "address": "5 Alton Ct, Unit 5-6",
    "parcel_id": "155-40-12",
    "owner1": "WANG, TONG & YINGJIE",
    "owner2": "",
    "current_taxes": 6025.22,
    "new_taxes_no_override": 6285.51,
    "override_total_1": 6463.86,
    "override_increase_1": 178.35
  },
  {
    "#": "6 Alton Ct, Unit 1 & P3 P34 (155-46-01)",
    "$": 1829100,
    "address": "6 Alton Ct, Unit 1 & P3 P34",
    "parcel_id": "155-46-01",
    "owner1": "CAO, ZHIPENG",
    "owner2": "LIU, DAI",
    "current_taxes": 15095.05,
    "new_taxes_no_override": 15747.16,
    "override_total_1": 16193.97,
    "override_increase_1": 446.81
  },
  {
    "#": "6 Alton Ct, Unit 2 & P17 (155-46-02)",
    "$": 1397200,
    "address": "6 Alton Ct, Unit 2 & P17",
    "parcel_id": "155-46-02",
    "owner1": "ANDERSON TRS, JOSEPH L & SADAKO H",
    "owner2": "",
    "current_taxes": 14307.33,
    "new_taxes_no_override": 14925.41,
    "override_total_1": 15348.9,
    "override_increase_1": 423.5
  },
  {
    "#": "6 Alton Ct, Unit 3 & P32 P33 (155-46-03)",
    "$": 1540100,
    "address": "6 Alton Ct, Unit 3 & P32 P33",
    "parcel_id": "155-46-03",
    "owner1": "SOLOMON, DEBORAH & DAVID H",
    "owner2": "",
    "current_taxes": 15770.62,
    "new_taxes_no_override": 16451.91,
    "override_total_1": 16918.72,
    "override_increase_1": 466.81
  },
  {
    "#": "9 Alton Ct, Unit 9-1 & P5 (155-40-13)",
    "$": 585700,
    "address": "9 Alton Ct, Unit 9-1 & P5",
    "parcel_id": "155-40-13",
    "owner1": "ROBERTSON, SHARON & SARAH",
    "owner2": "",
    "current_taxes": 2362.63,
    "new_taxes_no_override": 2464.7,
    "override_total_1": 2534.63,
    "override_increase_1": 69.93
  },
  {
    "#": "9 Alton Ct, Unit 9-2 & P23 (155-40-14)",
    "$": 524400,
    "address": "9 Alton Ct, Unit 9-2 & P23",
    "parcel_id": "155-40-14",
    "owner1": "SONG, CHENLU",
    "owner2": "MCCARTHY, JOSHUA",
    "current_taxes": 5369.86,
    "new_taxes_no_override": 5601.84,
    "override_total_1": 5760.79,
    "override_increase_1": 158.95
  },
  {
    "#": "9 Alton Ct, Unit 9-3 (155-40-15)",
    "$": 618400,
    "address": "9 Alton Ct, Unit 9-3",
    "parcel_id": "155-40-15",
    "owner1": "GANNETT, DAVID M",
    "owner2": "",
    "current_taxes": 6332.42,
    "new_taxes_no_override": 6605.98,
    "override_total_1": 6793.42,
    "override_increase_1": 187.44
  },
  {
    "#": "9 Alton Ct, Unit 9-4 & P22 (155-40-16)",
    "$": 586600,
    "address": "9 Alton Ct, Unit 9-4 & P22",
    "parcel_id": "155-40-16",
    "owner1": "FAY, BRIGHAM PAIGE",
    "owner2": "",
    "current_taxes": 2371.85,
    "new_taxes_no_override": 2474.31,
    "override_total_1": 2544.52,
    "override_increase_1": 70.21
  },
  {
    "#": "9 Alton Ct, Unit 9-5 & P8 (155-40-17)",
    "$": 514000,
    "address": "9 Alton Ct, Unit 9-5 & P8",
    "parcel_id": "155-40-17",
    "owner1": "CAMBARERI, MARIETTA",
    "owner2": "",
    "current_taxes": 1628.43,
    "new_taxes_no_override": 1698.78,
    "override_total_1": 1746.98,
    "override_increase_1": 48.2
  },
  {
    "#": "9 Alton Ct, Unit 9-6 (155-40-18)",
    "$": 514000,
    "address": "9 Alton Ct, Unit 9-6",
    "parcel_id": "155-40-18",
    "owner1": "GOLDBERG, DONALD A",
    "owner2": "FRIEDLANDER, KATHRYN",
    "current_taxes": 5263.36,
    "new_taxes_no_override": 5490.74,
    "override_total_1": 5646.53,
    "override_increase_1": 155.8
  },
  {
    "#": "10 Alton Ct (155-45-00)",
    "$": 2882600,
    "address": "10 Alton Ct",
    "parcel_id": "155-45-00",
    "owner1": "SHON, RITA S",
    "owner2": "",
    "current_taxes": 25882.89,
    "new_taxes_no_override": 27001.03,
    "override_total_1": 27767.16,
    "override_increase_1": 766.13
  },
  {
    "#": "14 Alton Ct, Unit 1 P22-39 (155-44-01)",
    "$": 1236500,
    "address": "14 Alton Ct, Unit 1 P22-39",
    "parcel_id": "155-44-01",
    "owner1": "ANDREWS, GAVIN & JOANNE",
    "owner2": "RACHELEFSKY, LANCE",
    "current_taxes": 9026.83,
    "new_taxes_no_override": 9416.79,
    "override_total_1": 9683.98,
    "override_increase_1": 267.19
  },
  {
    "#": "14 Alton Ct, Unit 2 & P9 (155-44-02)",
    "$": 1272900,
    "address": "14 Alton Ct, Unit 2 & P9",
    "parcel_id": "155-44-02",
    "owner1": "IRIZARRY TRS, RAFAEL ANGEL",
    "owner2": "NONES, ALEXANDRA CAROLINA",
    "current_taxes": 9399.56,
    "new_taxes_no_override": 9805.62,
    "override_total_1": 10083.85,
    "override_increase_1": 278.23
  },
  {
    "#": "14 Alton Ct, Unit 3 P21&38 (155-44-03)",
    "$": 1286900,
    "address": "14 Alton Ct, Unit 3 P21&38",
    "parcel_id": "155-44-03",
    "owner1": "SONG, YANG",
    "owner2": "",
    "current_taxes": 9542.92,
    "new_taxes_no_override": 9955.17,
    "override_total_1": 10237.64,
    "override_increase_1": 282.47
  },
  {
    "#": "15 Alton Ct, Unit 15-1 (155-40-19)",
    "$": 527000,
    "address": "15 Alton Ct, Unit 15-1",
    "parcel_id": "155-40-19",
    "owner1": "GANESAN, SANTOSH & NIRMALA",
    "owner2": "",
    "current_taxes": 5396.48,
    "new_taxes_no_override": 5629.61,
    "override_total_1": 5789.34,
    "override_increase_1": 159.74
  },
  {
    "#": "15 Alton Ct, Unit 15-2 (155-40-20)",
    "$": 509400,
    "address": "15 Alton Ct, Unit 15-2",
    "parcel_id": "155-40-20",
    "owner1": "BORTNICK, ANNA E",
    "owner2": "GEE, EMMANUEL PIERRE JORDAN",
    "current_taxes": 5216.26,
    "new_taxes_no_override": 5441.6,
    "override_total_1": 5596.0,
    "override_increase_1": 154.4
  },
  {
    "#": "15 Alton Ct, Unit 15-3 & P9 (155-40-21)",
    "$": 523600,
    "address": "15 Alton Ct, Unit 15-3 & P9",
    "parcel_id": "155-40-21",
    "owner1": "ALTON BEACONSFIELD LLC",
    "owner2": "C/O ALEXANDRA CRIVON - COLDWELL BANKER",
    "current_taxes": 5361.66,
    "new_taxes_no_override": 5593.28,
    "override_total_1": 5751.99,
    "override_increase_1": 158.71
  },
  {
    "#": "15 Alton Ct, Unit 15-4 (155-40-22)",
    "$": 513300,
    "address": "15 Alton Ct, Unit 15-4",
    "parcel_id": "155-40-22",
    "owner1": "PARINEJAD, TR, REZA",
    "owner2": "",
    "current_taxes": 5256.19,
    "new_taxes_no_override": 5483.26,
    "override_total_1": 5638.84,
    "override_increase_1": 155.58
  },
  {
    "#": "15 Alton Ct, Unit 15-5 (155-40-23)",
    "$": 512500,
    "address": "15 Alton Ct, Unit 15-5",
    "parcel_id": "155-40-23",
    "owner1": "TRYKOWSKI, MICHAEL E",
    "owner2": "",
    "current_taxes": 1613.07,
    "new_taxes_no_override": 1682.75,
    "override_total_1": 1730.5,
    "override_increase_1": 47.75
  },
  {
    "#": "15 Alton Ct, Unit 15-6 & P3 (155-40-24)",
    "$": 586600,
    "address": "15 Alton Ct, Unit 15-6 & P3",
    "parcel_id": "155-40-24",
    "owner1": "REVOLUTIONARY HOLDINGS LLC",
    "owner2": "",
    "current_taxes": 6006.78,
    "new_taxes_no_override": 6266.27,
    "override_total_1": 6444.07,
    "override_increase_1": 177.8
  },
  {
    "#": "18 Alton Ct, Unit 1 & P40-41 (155-43-01)",
    "$": 1557000,
    "address": "18 Alton Ct, Unit 1 & P40-41",
    "parcel_id": "155-43-01",
    "owner1": "GOLDSMITH, SCOTT",
    "owner2": "",
    "current_taxes": 15943.68,
    "new_taxes_no_override": 16632.45,
    "override_total_1": 17104.38,
    "override_increase_1": 471.93
  },
  {
    "#": "18 Alton Ct, Unit 2 & P12-23 (155-43-02)",
    "$": 1504300,
    "address": "18 Alton Ct, Unit 2 & P12-23",
    "parcel_id": "155-43-02",
    "owner1": "WELLMAN, SCOTT D & JACQUELINE",
    "owner2": "",
    "current_taxes": 11769.1,
    "new_taxes_no_override": 12277.53,
    "override_total_1": 12625.89,
    "override_increase_1": 348.37
  },
  {
    "#": "18 Alton Ct, Unit 3 & P7 (155-43-03)",
    "$": 1476600,
    "address": "18 Alton Ct, Unit 3 & P7",
    "parcel_id": "155-43-03",
    "owner1": "PITTMAN, STEPHEN D",
    "owner2": "MURCOTT, CHRISTINE M",
    "current_taxes": 15120.38,
    "new_taxes_no_override": 15773.58,
    "override_total_1": 16221.14,
    "override_increase_1": 447.56
  },
  {
    "#": "19 Alton Ct, Unit 19-1 & P20 (155-40-25)",
    "$": 523200,
    "address": "19 Alton Ct, Unit 19-1 & P20",
    "parcel_id": "155-40-25",
    "owner1": "ROTNER, ANNIE S",
    "owner2": "",
    "current_taxes": 5357.57,
    "new_taxes_no_override": 5589.02,
    "override_total_1": 5747.6,
    "override_increase_1": 158.58
  },
  {
    "#": "19 Alton Ct, Unit 19-2 (155-40-26)",
    "$": 616600,
    "address": "19 Alton Ct, Unit 19-2",
    "parcel_id": "155-40-26",
    "owner1": "GIANELLY, A TODD",
    "owner2": "",
    "current_taxes": 6313.98,
    "new_taxes_no_override": 6586.74,
    "override_total_1": 6773.64,
    "override_increase_1": 186.89
  },
  {
    "#": "19 Alton Ct, Unit 19-3 (155-40-27)",
    "$": 513300,
    "address": "19 Alton Ct, Unit 19-3",
    "parcel_id": "155-40-27",
    "owner1": "GANNETT TR, RICHARD W",
    "owner2": "",
    "current_taxes": 5256.19,
    "new_taxes_no_override": 5483.26,
    "override_total_1": 5638.84,
    "override_increase_1": 155.58
  },
  {
    "#": "19 Alton Ct, Unit 19-4 & P12 (155-40-28)",
    "$": 602000,
    "address": "19 Alton Ct, Unit 19-4 & P12",
    "parcel_id": "155-40-28",
    "owner1": "ZHANG ETAL, LEON",
    "owner2": "YANG, MIN",
    "current_taxes": 6164.48,
    "new_taxes_no_override": 6430.79,
    "override_total_1": 6613.25,
    "override_increase_1": 182.47
  },
  {
    "#": "19 Alton Ct, Unit 19-5 (155-40-29)",
    "$": 510200,
    "address": "19 Alton Ct, Unit 19-5",
    "parcel_id": "155-40-29",
    "owner1": "HICKEY, TIMOTHY J",
    "owner2": "ISHIBASHI, YASUKO",
    "current_taxes": 5224.45,
    "new_taxes_no_override": 5450.15,
    "override_total_1": 5604.79,
    "override_increase_1": 154.64
  },
  {
    "#": "19 Alton Ct, Unit 19-6 & P15 (155-40-30)",
    "$": 523500,
    "address": "19 Alton Ct, Unit 19-6 & P15",
    "parcel_id": "155-40-30",
    "owner1": "CHIANG, DEREK YUNG HO & DOROTHY WU",
    "owner2": "",
    "current_taxes": 5360.64,
    "new_taxes_no_override": 5592.22,
    "override_total_1": 5750.89,
    "override_increase_1": 158.67
  },
  {
    "#": "21 Alton Ct (155-41-00)",
    "$": 3085800,
    "address": "21 Alton Ct",
    "parcel_id": "155-41-00",
    "owner1": "WOLPOW LIFE ESTATE, EDWARD R",
    "owner2": "",
    "current_taxes": 27963.66,
    "new_taxes_no_override": 29171.69,
    "override_total_1": 29999.41,
    "override_increase_1": 827.72
  },
  {
    "#": "22 Alton Ct, Unit 1 & P11-42-43 (155-42-02)",
    "$": 1125900,
    "address": "22 Alton Ct, Unit 1 & P11-42-43",
    "parcel_id": "155-42-02",
    "owner1": "PEDROSA TRS, MARCOS DA CUNHA & HELOISA MARIA LEITE BARBOSA",
    "owner2": "",
    "current_taxes": 7894.28,
    "new_taxes_no_override": 8235.31,
    "override_total_1": 8468.98,
    "override_increase_1": 233.67
  },
  {
    "#": "22 Alton Ct, Unit 2 & P25 (155-42-03)",
    "$": 1377500,
    "address": "22 Alton Ct, Unit 2 & P25",
    "parcel_id": "155-42-03",
    "owner1": "RAMUSSEN, DAVID M",
    "owner2": "CHADBOURNE, DEBORA",
    "current_taxes": 10470.67,
    "new_taxes_no_override": 10923.0,
    "override_total_1": 11232.93,
    "override_increase_1": 309.93
  },
  {
    "#": "22 Alton Ct, Unit 3 & P10 (155-42-04)",
    "$": 1169300,
    "address": "22 Alton Ct, Unit 3 & P10",
    "parcel_id": "155-42-04",
    "owner1": "FINE, DANA",
    "owner2": "FLOERKE, HEIDEMARIE",
    "current_taxes": 8338.7,
    "new_taxes_no_override": 8698.93,
    "override_total_1": 8945.76,
    "override_increase_1": 246.83
  },
  {
    "#": "25 Alton Ct, Unit 1 & P29 P46 (155-41-02)",
    "$": 1913700,
    "address": "25 Alton Ct, Unit 1 & P29 P46",
    "parcel_id": "155-41-02",
    "owner1": "LAM, ALLEN C & MIRANDA B",
    "owner2": "",
    "current_taxes": 15961.35,
    "new_taxes_no_override": 16650.88,
    "override_total_1": 17123.34,
    "override_increase_1": 472.46
  },
  {
    "#": "25 Alton Ct, Unit 2 & P4 (155-41-03)",
    "$": 1704700,
    "address": "25 Alton Ct, Unit 2 & P4",
    "parcel_id": "155-41-03",
    "owner1": "ZUROFF, CAMERON",
    "owner2": "SALMON, VALERIE",
    "current_taxes": 17456.13,
    "new_taxes_no_override": 18210.23,
    "override_total_1": 18726.94,
    "override_increase_1": 516.7
  },
  {
    "#": "25 Alton Ct, Unit 3 & P19 P24 (155-41-04)",
    "$": 1889900,
    "address": "25 Alton Ct, Unit 3 & P19 P24",
    "parcel_id": "155-41-04",
    "owner1": "LUBERT, CARLY & LEAH",
    "owner2": "",
    "current_taxes": 15717.64,
    "new_taxes_no_override": 16396.64,
    "override_total_1": 16861.88,
    "override_increase_1": 465.24
  },
  {
    "#": "26 Alton Ct, Unit 1 (155-42-05)",
    "$": 1453600,
    "address": "26 Alton Ct, Unit 1",
    "parcel_id": "155-42-05",
    "owner1": "LI TRS, GILES L",
    "owner2": "PALMER, GERMAINE LI",
    "current_taxes": 14884.86,
    "new_taxes_no_override": 15527.89,
    "override_total_1": 15968.48,
    "override_increase_1": 440.59
  },
  {
    "#": "26 Alton Ct, Unit 2 & P45 P8 (155-42-06)",
    "$": 1245600,
    "address": "26 Alton Ct, Unit 2 & P45 P8",
    "parcel_id": "155-42-06",
    "owner1": "DAY, CHARLES SHIEN & MICHELLE",
    "owner2": "",
    "current_taxes": 12754.94,
    "new_taxes_no_override": 13305.95,
    "override_total_1": 13683.5,
    "override_increase_1": 377.55
  },
  {
    "#": "26 Alton Ct, Unit 3 (155-42-07)",
    "$": 1225700,
    "address": "26 Alton Ct, Unit 3",
    "parcel_id": "155-42-07",
    "owner1": "LI, GILES L",
    "owner2": "TEK, SOPHEAK",
    "current_taxes": 12551.17,
    "new_taxes_no_override": 13093.38,
    "override_total_1": 13464.9,
    "override_increase_1": 371.51
  },
  {
    "#": "3 Alton Pl (155-32-00)",
    "$": 3204800,
    "address": "3 Alton Pl",
    "parcel_id": "155-32-00",
    "owner1": "SCHICKLER TR, ERIC",
    "owner2": "",
    "current_taxes": 37471.49,
    "new_taxes_no_override": 39090.26,
    "override_total_1": 40199.41,
    "override_increase_1": 1109.16
  },
  {
    "#": "8 Alton Pl (156-11-01)",
    "$": 3031900,
    "address": "8 Alton Pl",
    "parcel_id": "156-11-01",
    "owner1": "MACROPOULOS, ET AL, DEMETRIOS",
    "owner2": "C/O ALTON REALTY TRUST",
    "current_taxes": 52027.4,
    "new_taxes_no_override": 54274.98,
    "override_total_1": 55814.99,
    "override_increase_1": 1540.01
  },
  {
    "#": "9 Alton Pl, Unit 1 (155-33-03)",
    "$": 1417200,
    "address": "9 Alton Pl, Unit 1",
    "parcel_id": "155-33-03",
    "owner1": "VITALE, AMIR MOSHE & NITZAN HAKLAI",
    "owner2": "",
    "current_taxes": 10877.19,
    "new_taxes_no_override": 11347.08,
    "override_total_1": 11669.05,
    "override_increase_1": 321.96
  },
  {
    "#": "9 Alton Pl, Unit 2 (155-33-01)",
    "$": 1453000,
    "address": "9 Alton Pl, Unit 2",
    "parcel_id": "155-33-01",
    "owner1": "CATTO, PETER J & SHARON L",
    "owner2": "",
    "current_taxes": 11243.79,
    "new_taxes_no_override": 11729.52,
    "override_total_1": 12062.34,
    "override_increase_1": 332.82
  },
  {
    "#": "9 Alton Pl, Unit 3 (155-33-02)",
    "$": 1428900,
    "address": "9 Alton Pl, Unit 3",
    "parcel_id": "155-33-02",
    "owner1": "STERN, JONATHAN & ZIVA Y",
    "owner2": "",
    "current_taxes": 14631.94,
    "new_taxes_no_override": 15264.04,
    "override_total_1": 15697.15,
    "override_increase_1": 433.11
  },
  {
    "#": "11 Alton Pl (155-34-00)",
    "$": 6333100,
    "address": "11 Alton Pl",
    "parcel_id": "155-34-00",
    "owner1": "BLOTNER, MARK",
    "owner2": "",
    "current_taxes": 64850.94,
    "new_taxes_no_override": 67652.5,
    "override_total_1": 69572.09,
    "override_increase_1": 1919.59
  },
  {
    "#": "12 Alton Pl (156-11-00)",
    "$": 14641700,
    "address": "12 Alton Pl",
    "parcel_id": "156-11-00",
    "owner1": "SYNH LLC",
    "owner2": "",
    "current_taxes": 149931.01,
    "new_taxes_no_override": 156408.03,
    "override_total_1": 160845.99,
    "override_increase_1": 4437.96
  },
  {
    "#": "15 Alton Pl, Unit 1 (155-35-01)",
    "$": 1654300,
    "address": "15 Alton Pl, Unit 1",
    "parcel_id": "155-35-01",
    "owner1": "FOPIANO, JILL A",
    "owner2": "",
    "current_taxes": 13305.1,
    "new_taxes_no_override": 13879.88,
    "override_total_1": 14273.71,
    "override_increase_1": 393.83
  },
  {
    "#": "15 Alton Pl, Unit 2 (155-35-02)",
    "$": 1753200,
    "address": "15 Alton Pl, Unit 2",
    "parcel_id": "155-35-02",
    "owner1": "LEVEY, ANDREW",
    "owner2": "FALKE, ROBERTA",
    "current_taxes": 14317.83,
    "new_taxes_no_override": 14936.36,
    "override_total_1": 15360.17,
    "override_increase_1": 423.81
  },
  {
    "#": "15 Alton Pl, Unit 3 (155-35-03)",
    "$": 1711700,
    "address": "15 Alton Pl, Unit 3",
    "parcel_id": "155-35-03",
    "owner1": "NEWELL, MAX E & AMY I",
    "owner2": "",
    "current_taxes": 13892.87,
    "new_taxes_no_override": 14493.04,
    "override_total_1": 14904.27,
    "override_increase_1": 411.23
  },
  {
    "#": "15 Alton Pl, Unit Garden & P (155-35-04)",
    "$": 963200,
    "address": "15 Alton Pl, Unit Garden & P",
    "parcel_id": "155-35-04",
    "owner1": "ALBURY, MITCHELL",
    "owner2": "",
    "current_taxes": 6228.23,
    "new_taxes_no_override": 6497.29,
    "override_total_1": 6681.65,
    "override_increase_1": 184.36
  },
  {
    "#": "17 Alton Pl (155-36-00)",
    "$": 3385800,
    "address": "17 Alton Pl",
    "parcel_id": "155-36-00",
    "owner1": "GOLDRICH FAMILY PROPERTY LLC",
    "owner2": "",
    "current_taxes": 34670.59,
    "new_taxes_no_override": 36168.36,
    "override_total_1": 37194.61,
    "override_increase_1": 1026.25
  },
  {
    "#": "19 Alton Pl, Unit 1 (155-37-03)",
    "$": 1297900,
    "address": "19 Alton Pl, Unit 1",
    "parcel_id": "155-37-03",
    "owner1": "ALVAREZ, PABLO & KATHLEEN",
    "owner2": "",
    "current_taxes": 13290.5,
    "new_taxes_no_override": 13864.65,
    "override_total_1": 14258.05,
    "override_increase_1": 393.4
  },
  {
    "#": "19 Alton Pl, Unit 2 (155-37-01)",
    "$": 1384600,
    "address": "19 Alton Pl, Unit 2",
    "parcel_id": "155-37-01",
    "owner1": "WALLACE TR, MEGAN W",
    "owner2": "",
    "current_taxes": 14178.3,
    "new_taxes_no_override": 14790.8,
    "override_total_1": 15210.48,
    "override_increase_1": 419.68
  },
  {
    "#": "19 Alton Pl, Unit 3 (155-37-02)",
    "$": 1571600,
    "address": "19 Alton Pl, Unit 3",
    "parcel_id": "155-37-02",
    "owner1": "MADSEN, SALLY",
    "owner2": "ROTHSCHILD, ADAM",
    "current_taxes": 12458.25,
    "new_taxes_no_override": 12996.45,
    "override_total_1": 13365.21,
    "override_increase_1": 368.76
  },
  {
    "#": "24 Alton Pl, Unit A (156-10-18)",
    "$": 957400,
    "address": "24 Alton Pl, Unit A",
    "parcel_id": "156-10-18",
    "owner1": "SHUHAIBER, JEFFREY",
    "owner2": "GARIBYAN, LILIT",
    "current_taxes": 9803.78,
    "new_taxes_no_override": 10227.3,
    "override_total_1": 10517.5,
    "override_increase_1": 290.19
  },
  {
    "#": "24 Alton Pl, Unit B (156-10-01)",
    "$": 989300,
    "address": "24 Alton Pl, Unit B",
    "parcel_id": "156-10-01",
    "owner1": "DATTA TR, NAND S",
    "owner2": "",
    "current_taxes": 10130.43,
    "new_taxes_no_override": 10568.06,
    "override_total_1": 10867.93,
    "override_increase_1": 299.86
  },
  {
    "#": "24 Alton Pl, Unit C (156-10-02)",
    "$": 1028000,
    "address": "24 Alton Pl, Unit C",
    "parcel_id": "156-10-02",
    "owner1": "RICOTTA, DANIEL N & ANDREA L",
    "owner2": "",
    "current_taxes": 6891.79,
    "new_taxes_no_override": 7189.52,
    "override_total_1": 7393.51,
    "override_increase_1": 204.0
  },
  {
    "#": "24 Alton Pl, Unit D (156-10-03)",
    "$": 1042100,
    "address": "24 Alton Pl, Unit D",
    "parcel_id": "156-10-03",
    "owner1": "KBOZ LLC",
    "owner2": "",
    "current_taxes": 10671.1,
    "new_taxes_no_override": 11132.09,
    "override_total_1": 11447.96,
    "override_increase_1": 315.86
  },
  {
    "#": "24 Alton Pl, Unit E & P-E (156-10-04)",
    "$": 1109200,
    "address": "24 Alton Pl, Unit E & P-E",
    "parcel_id": "156-10-04",
    "owner1": "CHEN, TZU-MAINN",
    "owner2": "WANG, GRACE",
    "current_taxes": 7723.27,
    "new_taxes_no_override": 8056.92,
    "override_total_1": 8285.52,
    "override_increase_1": 228.61
  },
  {
    "#": "24 Alton Pl, Unit F (156-10-05)",
    "$": 1194200,
    "address": "24 Alton Pl, Unit F",
    "parcel_id": "156-10-05",
    "owner1": "KHEYFETS, VLADIMIR & IRINA",
    "owner2": "",
    "current_taxes": 8593.67,
    "new_taxes_no_override": 8964.92,
    "override_total_1": 9219.29,
    "override_increase_1": 254.37
  },
  {
    "#": "25 Alton Pl (155-38-00)",
    "$": 4503700,
    "address": "25 Alton Pl",
    "parcel_id": "155-38-00",
    "owner1": "VERNDALE PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 46117.89,
    "new_taxes_no_override": 48110.18,
    "override_total_1": 49475.27,
    "override_increase_1": 1365.09
  },
  {
    "#": "26 Alton Pl, Unit A  & P-A (156-10-06)",
    "$": 1046400,
    "address": "26 Alton Pl, Unit A  & P-A",
    "parcel_id": "156-10-06",
    "owner1": "GOYAL, SHARAD",
    "owner2": "AGRAWAL, PARUL",
    "current_taxes": 10715.14,
    "new_taxes_no_override": 11178.03,
    "override_total_1": 11495.2,
    "override_increase_1": 317.17
  },
  {
    "#": "26 Alton Pl, Unit B & G-B (156-10-07)",
    "$": 1013700,
    "address": "26 Alton Pl, Unit B & G-B",
    "parcel_id": "156-10-07",
    "owner1": "TSAI, CHIA JUNG",
    "owner2": "SHARMA, KANISHKA S",
    "current_taxes": 6745.35,
    "new_taxes_no_override": 7036.75,
    "override_total_1": 7236.41,
    "override_increase_1": 199.66
  },
  {
    "#": "26 Alton Pl, Unit C (156-10-08)",
    "$": 1019500,
    "address": "26 Alton Pl, Unit C",
    "parcel_id": "156-10-08",
    "owner1": "CHANG, SAMUEL C",
    "owner2": "",
    "current_taxes": 6804.75,
    "new_taxes_no_override": 7098.72,
    "override_total_1": 7300.14,
    "override_increase_1": 201.42
  },
  {
    "#": "26 Alton Pl, Unit D & P-D2 (156-10-09)",
    "$": 1136400,
    "address": "26 Alton Pl, Unit D & P-D2",
    "parcel_id": "156-10-09",
    "owner1": "KOTHARI, ANN & RISHI",
    "owner2": "",
    "current_taxes": 11636.74,
    "new_taxes_no_override": 12139.45,
    "override_total_1": 12483.89,
    "override_increase_1": 344.45
  },
  {
    "#": "26 Alton Pl, Unit E & Pe-8 (156-10-10)",
    "$": 1152500,
    "address": "26 Alton Pl, Unit E & Pe-8",
    "parcel_id": "156-10-10",
    "owner1": "LAM, CHI-KONG & ALICE",
    "owner2": "",
    "current_taxes": 8166.67,
    "new_taxes_no_override": 8519.47,
    "override_total_1": 8761.2,
    "override_increase_1": 241.73
  },
  {
    "#": "26 Alton Pl, Unit F& P-F & P (156-10-11)",
    "$": 1182600,
    "address": "26 Alton Pl, Unit F& P-F & P",
    "parcel_id": "156-10-11",
    "owner1": "BROWN, LUCIA Y & STEPHEN C",
    "owner2": "",
    "current_taxes": 8474.89,
    "new_taxes_no_override": 8841.01,
    "override_total_1": 9091.86,
    "override_increase_1": 250.86
  },
  {
    "#": "27 Alton Pl (155-39-00)",
    "$": 2709000,
    "address": "27 Alton Pl",
    "parcel_id": "155-39-00",
    "owner1": "27 ALTON PLACE LLC",
    "owner2": "",
    "current_taxes": 46486.44,
    "new_taxes_no_override": 48494.65,
    "override_total_1": 49870.65,
    "override_increase_1": 1376.0
  },
  {
    "#": "28 Alton Pl, Unit A P6 G-A (156-10-12)",
    "$": 970500,
    "address": "28 Alton Pl, Unit A P6 G-A",
    "parcel_id": "156-10-12",
    "owner1": "CHO, DAVID",
    "owner2": "HA, CHRISTINA",
    "current_taxes": 9937.92,
    "new_taxes_no_override": 10367.24,
    "override_total_1": 10661.4,
    "override_increase_1": 294.16
  },
  {
    "#": "28 Alton Pl, Unit B (156-10-13)",
    "$": 989300,
    "address": "28 Alton Pl, Unit B",
    "parcel_id": "156-10-13",
    "owner1": "ZIMMERMAN, MICHAEL C",
    "owner2": "SIMONSEN, S",
    "current_taxes": 6495.5,
    "new_taxes_no_override": 6776.11,
    "override_total_1": 6968.37,
    "override_increase_1": 192.27
  },
  {
    "#": "28 Alton Pl, Unit C & G-C (156-10-14)",
    "$": 1008400,
    "address": "28 Alton Pl, Unit C & G-C",
    "parcel_id": "156-10-14",
    "owner1": "EGOROVA, NATASHA",
    "owner2": "",
    "current_taxes": 6691.08,
    "new_taxes_no_override": 6980.13,
    "override_total_1": 7178.19,
    "override_increase_1": 198.06
  },
  {
    "#": "28 Alton Pl, Unit D & P3 & D (156-10-15)",
    "$": 1110300,
    "address": "28 Alton Pl, Unit D & P3 & D",
    "parcel_id": "156-10-15",
    "owner1": "CHAN, ALBERT",
    "owner2": "",
    "current_taxes": 11369.47,
    "new_taxes_no_override": 11860.63,
    "override_total_1": 12197.17,
    "override_increase_1": 336.54
  },
  {
    "#": "28 Alton Pl, Unit E & P4-G4 (156-10-16)",
    "$": 1152300,
    "address": "28 Alton Pl, Unit E & P4-G4",
    "parcel_id": "156-10-16",
    "owner1": "KABISCH, JOSHUA MATTHEW",
    "owner2": "KATZ, ANDREW PHILIP",
    "current_taxes": 8164.62,
    "new_taxes_no_override": 8517.33,
    "override_total_1": 8759.0,
    "override_increase_1": 241.67
  },
  {
    "#": "28 Alton Pl, Unit F (156-10-17)",
    "$": 1223500,
    "address": "28 Alton Pl, Unit F",
    "parcel_id": "156-10-17",
    "owner1": "COHEN, DEREK",
    "owner2": "HARING, ANNA",
    "current_taxes": 8893.71,
    "new_taxes_no_override": 9277.92,
    "override_total_1": 9541.17,
    "override_increase_1": 263.25
  },
  {
    "#": "31 Alton Pl, Unit 31-1 & P15 (155-40-01)",
    "$": 531400,
    "address": "31 Alton Pl, Unit 31-1 & P15",
    "parcel_id": "155-40-01",
    "owner1": "BEARDSWORTH, ETHAN",
    "owner2": "",
    "current_taxes": 1806.6,
    "new_taxes_no_override": 1884.65,
    "override_total_1": 1938.12,
    "override_increase_1": 53.48
  },
  {
    "#": "31 Alton Pl, Unit 31-2 & P27 (155-40-02)",
    "$": 584000,
    "address": "31 Alton Pl, Unit 31-2 & P27",
    "parcel_id": "155-40-02",
    "owner1": "OREN-GRINBERG, ACHIKAM",
    "owner2": "OREN, RONNY",
    "current_taxes": 5980.16,
    "new_taxes_no_override": 6238.5,
    "override_total_1": 6415.52,
    "override_increase_1": 177.01
  },
  {
    "#": "31 Alton Pl, Unit 31-3 (155-40-03)",
    "$": 515600,
    "address": "31 Alton Pl, Unit 31-3",
    "parcel_id": "155-40-03",
    "owner1": "DEYESO, ANTHONY J",
    "owner2": "",
    "current_taxes": 1644.81,
    "new_taxes_no_override": 1715.87,
    "override_total_1": 1764.55,
    "override_increase_1": 48.69
  },
  {
    "#": "31 Alton Pl, Unit 31-4 & P28 (155-40-04)",
    "$": 511000,
    "address": "31 Alton Pl, Unit 31-4 & P28",
    "parcel_id": "155-40-04",
    "owner1": "COES, DEBORAH J",
    "owner2": "",
    "current_taxes": 1597.71,
    "new_taxes_no_override": 1666.73,
    "override_total_1": 1714.02,
    "override_increase_1": 47.29
  },
  {
    "#": "31 Alton Pl, Unit 31-5 (155-40-05)",
    "$": 616600,
    "address": "31 Alton Pl, Unit 31-5",
    "parcel_id": "155-40-05",
    "owner1": "KAPLAN, GAIL",
    "owner2": "",
    "current_taxes": 6313.98,
    "new_taxes_no_override": 6586.74,
    "override_total_1": 6773.64,
    "override_increase_1": 186.89
  },
  {
    "#": "31 Alton Pl, Unit 31-6 (155-40-06)",
    "$": 511700,
    "address": "31 Alton Pl, Unit 31-6",
    "parcel_id": "155-40-06",
    "owner1": "ARNAOUT, AMAL",
    "owner2": "",
    "current_taxes": 5239.81,
    "new_taxes_no_override": 5466.17,
    "override_total_1": 5621.27,
    "override_increase_1": 155.1
  },
  {
    "#": "36 Alton Pl (156-09-00)",
    "$": 3211600,
    "address": "36 Alton Pl",
    "parcel_id": "156-09-00",
    "owner1": "GALPERIN TR, LEO",
    "owner2": "",
    "current_taxes": 32886.78,
    "new_taxes_no_override": 34307.49,
    "override_total_1": 35280.94,
    "override_increase_1": 973.45
  },
  {
    "#": "42 Alton Pl (157-03-00)",
    "$": 2341600,
    "address": "42 Alton Pl",
    "parcel_id": "157-03-00",
    "owner1": "GOODALE TR, RONDA A",
    "owner2": "GRODBERG TR, ROBERT S",
    "current_taxes": 20343.05,
    "new_taxes_no_override": 21221.87,
    "override_total_1": 21824.02,
    "override_increase_1": 602.15
  },
  {
    "#": "47 Alton Pl, Unit 1 (155-01-07)",
    "$": 1267000,
    "address": "47 Alton Pl, Unit 1",
    "parcel_id": "155-01-07",
    "owner1": "CUNNING TRS, NANCY J",
    "owner2": "JURBERG, Z PAUL",
    "current_taxes": 12974.08,
    "new_taxes_no_override": 13534.56,
    "override_total_1": 13918.59,
    "override_increase_1": 384.03
  },
  {
    "#": "47 Alton Pl, Unit 2 (155-01-08)",
    "$": 1361700,
    "address": "47 Alton Pl, Unit 2",
    "parcel_id": "155-01-08",
    "owner1": "SAMUELS, TR, ZITA M",
    "owner2": "",
    "current_taxes": 10308.87,
    "new_taxes_no_override": 10754.21,
    "override_total_1": 11059.36,
    "override_increase_1": 305.14
  },
  {
    "#": "47 Alton Pl, Unit 3 (155-01-09)",
    "$": 1504000,
    "address": "47 Alton Pl, Unit 3",
    "parcel_id": "155-01-09",
    "owner1": "ROSE TRS, STUART MARK & JAN Z",
    "owner2": "",
    "current_taxes": 11766.03,
    "new_taxes_no_override": 12274.32,
    "override_total_1": 12622.6,
    "override_increase_1": 348.27
  },
  {
    "#": "49 Alton Pl, Unit 1 (155-01-10)",
    "$": 1287400,
    "address": "49 Alton Pl, Unit 1",
    "parcel_id": "155-01-10",
    "owner1": "COHEN LIFE ESTATE, ESTHER",
    "owner2": "",
    "current_taxes": 13182.98,
    "new_taxes_no_override": 13752.48,
    "override_total_1": 14142.7,
    "override_increase_1": 390.22
  },
  {
    "#": "49 Alton Pl, Unit 2 (155-01-11)",
    "$": 1473000,
    "address": "49 Alton Pl, Unit 2",
    "parcel_id": "155-01-11",
    "owner1": "WOLFE, IAN & TATE",
    "owner2": "",
    "current_taxes": 11448.59,
    "new_taxes_no_override": 11943.17,
    "override_total_1": 12282.05,
    "override_increase_1": 338.88
  },
  {
    "#": "49 Alton Pl, Unit 3 (155-01-12)",
    "$": 1444700,
    "address": "49 Alton Pl, Unit 3",
    "parcel_id": "155-01-12",
    "owner1": "WALTER, JOHANNES",
    "owner2": "SEVER, SANJA",
    "current_taxes": 11158.79,
    "new_taxes_no_override": 11640.85,
    "override_total_1": 11971.15,
    "override_increase_1": 330.3
  },
  {
    "#": "50 Alton Pl (157-01-02)",
    "$": 34357800,
    "address": "50 Alton Pl",
    "parcel_id": "157-01-02",
    "owner1": "ST PAUL GARDENS LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 351823.87,
    "new_taxes_no_override": 367022.66,
    "override_total_1": 377436.65,
    "override_increase_1": 10413.99
  },
  {
    "#": "53 Alton Pl, Unit 1 (155-01-13)",
    "$": 585000,
    "address": "53 Alton Pl, Unit 1",
    "parcel_id": "155-01-13",
    "owner1": "KAHN, SUSAN M",
    "owner2": "",
    "current_taxes": 2355.47,
    "new_taxes_no_override": 2457.23,
    "override_total_1": 2526.95,
    "override_increase_1": 69.72
  },
  {
    "#": "53 Alton Pl, Unit 2 (155-01-14)",
    "$": 807300,
    "address": "53 Alton Pl, Unit 2",
    "parcel_id": "155-01-14",
    "owner1": "HANNIBAL, KARI E",
    "owner2": "",
    "current_taxes": 4631.82,
    "new_taxes_no_override": 4831.91,
    "override_total_1": 4969.02,
    "override_increase_1": 137.1
  },
  {
    "#": "53 Alton Pl, Unit 3 (155-01-15)",
    "$": 804200,
    "address": "53 Alton Pl, Unit 3",
    "parcel_id": "155-01-15",
    "owner1": "NASACASA LLC",
    "owner2": "",
    "current_taxes": 4600.07,
    "new_taxes_no_override": 4798.79,
    "override_total_1": 4934.96,
    "override_increase_1": 136.16
  },
  {
    "#": "53 Alton Pl, Unit 4 (155-01-16)",
    "$": 692000,
    "address": "53 Alton Pl, Unit 4",
    "parcel_id": "155-01-16",
    "owner1": "CHAN, KEE",
    "owner2": "",
    "current_taxes": 7086.08,
    "new_taxes_no_override": 7392.2,
    "override_total_1": 7601.95,
    "override_increase_1": 209.75
  },
  {
    "#": "53 Alton Pl, Unit 5 (155-01-17)",
    "$": 802600,
    "address": "53 Alton Pl, Unit 5",
    "parcel_id": "155-01-17",
    "owner1": "DUFFY, EVAN E & ANDREW",
    "owner2": "",
    "current_taxes": 4583.69,
    "new_taxes_no_override": 4781.71,
    "override_total_1": 4917.38,
    "override_increase_1": 135.68
  },
  {
    "#": "53 Alton Pl, Unit 6 (155-01-18)",
    "$": 798900,
    "address": "53 Alton Pl, Unit 6",
    "parcel_id": "155-01-18",
    "owner1": "VARASTEH TRS, FARSHID",
    "owner2": "ANSARI, NAGMEH",
    "current_taxes": 4545.8,
    "new_taxes_no_override": 4742.18,
    "override_total_1": 4876.73,
    "override_increase_1": 134.56
  },
  {
    "#": "57 Alton Pl, Unit 1 (155-01-19)",
    "$": 1025500,
    "address": "57 Alton Pl, Unit 1",
    "parcel_id": "155-01-19",
    "owner1": "GHAFOUR, ZIAD",
    "owner2": "LISI, LISA",
    "current_taxes": 10501.12,
    "new_taxes_no_override": 10954.77,
    "override_total_1": 11265.6,
    "override_increase_1": 310.83
  },
  {
    "#": "57 Alton Pl, Unit 2 (155-01-20)",
    "$": 1120400,
    "address": "57 Alton Pl, Unit 2",
    "parcel_id": "155-01-20",
    "owner1": "GHAFARI, RAMIN",
    "owner2": "",
    "current_taxes": 11472.9,
    "new_taxes_no_override": 11968.53,
    "override_total_1": 12308.13,
    "override_increase_1": 339.6
  },
  {
    "#": "57 Alton Pl, Unit 3 (155-01-21)",
    "$": 1105500,
    "address": "57 Alton Pl, Unit 3",
    "parcel_id": "155-01-21",
    "owner1": "LISI, LISA MARIA",
    "owner2": "GHAFOUR, ZIAD A",
    "current_taxes": 11320.32,
    "new_taxes_no_override": 11809.36,
    "override_total_1": 12144.44,
    "override_increase_1": 335.08
  },
  {
    "#": "59 Alton Pl, Unit 1 (155-01-22)",
    "$": 496700,
    "address": "59 Alton Pl, Unit 1",
    "parcel_id": "155-01-22",
    "owner1": "GARDNER, JOSHUA W",
    "owner2": "OLSSON, LINE MOLIN",
    "current_taxes": 5086.21,
    "new_taxes_no_override": 5305.93,
    "override_total_1": 5456.49,
    "override_increase_1": 150.55
  },
  {
    "#": "59 Alton Pl, Unit 2 (155-01-23)",
    "$": 678500,
    "address": "59 Alton Pl, Unit 2",
    "parcel_id": "155-01-23",
    "owner1": "GARDNER, JOSHUA W",
    "owner2": "OLSSON, LINE MOLIN",
    "current_taxes": 3312.91,
    "new_taxes_no_override": 3456.03,
    "override_total_1": 3554.09,
    "override_increase_1": 98.06
  },
  {
    "#": "59 Alton Pl, Unit 3 & P7 (155-01-24)",
    "$": 714000,
    "address": "59 Alton Pl, Unit 3 & P7",
    "parcel_id": "155-01-24",
    "owner1": "DOWLATSHAHI, ARRIYAN S",
    "owner2": "",
    "current_taxes": 7311.36,
    "new_taxes_no_override": 7627.21,
    "override_total_1": 7843.63,
    "override_increase_1": 216.42
  },
  {
    "#": "59 Alton Pl, Unit 4 & P6 (155-01-25)",
    "$": 816100,
    "address": "59 Alton Pl, Unit 4 & P6",
    "parcel_id": "155-01-25",
    "owner1": "MCQUILLAN, JEFFREY",
    "owner2": "",
    "current_taxes": 8356.86,
    "new_taxes_no_override": 8717.88,
    "override_total_1": 8965.24,
    "override_increase_1": 247.36
  },
  {
    "#": "59 Alton Pl, Unit 5 (155-01-26)",
    "$": 717900,
    "address": "59 Alton Pl, Unit 5",
    "parcel_id": "155-01-26",
    "owner1": "BLUESTONE, DEBORAH",
    "owner2": "",
    "current_taxes": 3716.36,
    "new_taxes_no_override": 3876.91,
    "override_total_1": 3986.91,
    "override_increase_1": 110.0
  },
  {
    "#": "59 Alton Pl, Unit 6 (155-01-27)",
    "$": 691900,
    "address": "59 Alton Pl, Unit 6",
    "parcel_id": "155-01-27",
    "owner1": "GELLER, RANDALL S",
    "owner2": "",
    "current_taxes": 3450.12,
    "new_taxes_no_override": 3599.17,
    "override_total_1": 3701.29,
    "override_increase_1": 102.12
  },
  {
    "#": "1 Alwyngton Rd (284-12-00)",
    "$": 3821300,
    "address": "1 Alwyngton Rd",
    "parcel_id": "284-12-00",
    "owner1": "KETKAR, AKHIL SHIRISH",
    "owner2": "MEHROTRA, PRIYANKA",
    "current_taxes": 35495.18,
    "new_taxes_no_override": 37028.57,
    "override_total_1": 38079.23,
    "override_increase_1": 1050.66
  },
  {
    "#": "3 Alwyngton Rd (284-11-00)",
    "$": 3649500,
    "address": "3 Alwyngton Rd",
    "parcel_id": "284-11-00",
    "owner1": "BLACKWELL, ANDREW",
    "owner2": "ODONOGHUE, MICHELLE",
    "current_taxes": 33735.95,
    "new_taxes_no_override": 35193.34,
    "override_total_1": 36191.93,
    "override_increase_1": 998.58
  },
  {
    "#": "4 Alwyngton Rd (284-09-00)",
    "$": 3357800,
    "address": "4 Alwyngton Rd",
    "parcel_id": "284-09-00",
    "owner1": "DONOVAN TR, MELINDA N",
    "owner2": "",
    "current_taxes": 30748.94,
    "new_taxes_no_override": 32077.29,
    "override_total_1": 32987.46,
    "override_increase_1": 910.17
  },
  {
    "#": "6 Alwyngton Rd (284-10-00)",
    "$": 8983800,
    "address": "6 Alwyngton Rd",
    "parcel_id": "284-10-00",
    "owner1": "LEWIN TR, LEONARD L",
    "owner2": "C/O ATHENA CAPITAL ADVISORS",
    "current_taxes": 91994.11,
    "new_taxes_no_override": 95968.26,
    "override_total_1": 98691.28,
    "override_increase_1": 2723.03
  },
  {
    "#": "14 Amory St (011-25-00)",
    "$": 2877700,
    "address": "14 Amory St",
    "parcel_id": "011-25-00",
    "owner1": "PLATT, MICHAEL & JUDY",
    "owner2": "",
    "current_taxes": 25832.71,
    "new_taxes_no_override": 26948.68,
    "override_total_1": 27713.33,
    "override_increase_1": 764.65
  },
  {
    "#": "15 Amory St (010-05-00)",
    "$": 45975200,
    "address": "15 Amory St",
    "parcel_id": "010-05-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O AMORY PLAYGROUND",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "20 Amory St (011-24-00)",
    "$": 5041400,
    "address": "20 Amory St",
    "parcel_id": "011-24-00",
    "owner1": "LESSIG, LESTER LAWRENCE III",
    "owner2": "NEUEFEIND, BETTINA",
    "current_taxes": 47989.0,
    "new_taxes_no_override": 50062.12,
    "override_total_1": 51482.6,
    "override_increase_1": 1420.47
  },
  {
    "#": "30 Amory St (011-23-00)",
    "$": 3339700,
    "address": "30 Amory St",
    "parcel_id": "011-23-00",
    "owner1": "BELL, JONATHAN & JACOBA JANE JACOBSON",
    "owner2": "",
    "current_taxes": 30563.59,
    "new_taxes_no_override": 31883.94,
    "override_total_1": 32788.62,
    "override_increase_1": 904.68
  },
  {
    "#": "36 Amory St (011-22-00)",
    "$": 4100100,
    "address": "36 Amory St",
    "parcel_id": "011-22-00",
    "owner1": "PATTERSON, KATHRYN SHAW & STEPHEN S",
    "owner2": "",
    "current_taxes": 38350.09,
    "new_taxes_no_override": 40006.81,
    "override_total_1": 41141.98,
    "override_increase_1": 1135.16
  },
  {
    "#": "44 Amory St (011-21-00)",
    "$": 4717100,
    "address": "44 Amory St",
    "parcel_id": "011-21-00",
    "owner1": "GUROCK, ELI & SHERI",
    "owner2": "",
    "current_taxes": 44668.17,
    "new_taxes_no_override": 46597.83,
    "override_total_1": 47920.01,
    "override_increase_1": 1322.18
  },
  {
    "#": "50 Amory St (011-20-00)",
    "$": 3673500,
    "address": "50 Amory St",
    "parcel_id": "011-20-00",
    "owner1": "ZARREN, MICHAEL H",
    "owner2": "",
    "current_taxes": 33981.71,
    "new_taxes_no_override": 35449.72,
    "override_total_1": 36455.58,
    "override_increase_1": 1005.86
  },
  {
    "#": "60 Amory St (011-19-00)",
    "$": 3738600,
    "address": "60 Amory St",
    "parcel_id": "011-19-00",
    "owner1": "MARTEL, DAVID A  & CYDNEY F",
    "owner2": "",
    "current_taxes": 34648.33,
    "new_taxes_no_override": 36145.14,
    "override_total_1": 37170.73,
    "override_increase_1": 1025.59
  },
  {
    "#": "64 Amory St (011-18-00)",
    "$": 3772200,
    "address": "64 Amory St",
    "parcel_id": "011-18-00",
    "owner1": "BERGIN, RICHARD JEFFREY",
    "owner2": "INGRAHAM, KATHERINE ANNE",
    "current_taxes": 34992.39,
    "new_taxes_no_override": 36504.06,
    "override_total_1": 37539.84,
    "override_increase_1": 1035.77
  },
  {
    "#": "68 Amory St (011-17-00)",
    "$": 4141300,
    "address": "68 Amory St",
    "parcel_id": "011-17-00",
    "owner1": "JURAYJ, DANIEL H",
    "owner2": "SILBAUGH, KATHARINE",
    "current_taxes": 38771.98,
    "new_taxes_no_override": 40446.93,
    "override_total_1": 41594.58,
    "override_increase_1": 1147.65
  },
  {
    "#": "74 Amory St (011-16-00)",
    "$": 3083500,
    "address": "74 Amory St",
    "parcel_id": "011-16-00",
    "owner1": "PATTON, WILLIAM L & LESLIE A",
    "owner2": "",
    "current_taxes": 27940.11,
    "new_taxes_no_override": 29147.12,
    "override_total_1": 29974.15,
    "override_increase_1": 827.03
  },
  {
    "#": "120 Amory St, Unit 1 & P-F19 (022-09-05)",
    "$": 785900,
    "address": "120 Amory St, Unit 1 & P-F19",
    "parcel_id": "022-09-05",
    "owner1": "ZHAO, YILUN",
    "owner2": "LEE, TZUUFEN",
    "current_taxes": 4412.68,
    "new_taxes_no_override": 4603.31,
    "override_total_1": 4733.92,
    "override_increase_1": 130.62
  },
  {
    "#": "120 Amory St, Unit 1A & P15 (022-09-06)",
    "$": 846600,
    "address": "120 Amory St, Unit 1A & P15",
    "parcel_id": "022-09-06",
    "owner1": "ADLER TRS, SELIG & BARBARA I",
    "owner2": "",
    "current_taxes": 5034.25,
    "new_taxes_no_override": 5251.73,
    "override_total_1": 5400.74,
    "override_increase_1": 149.01
  },
  {
    "#": "120 Amory St, Unit 2 (022-09-07)",
    "$": 1083600,
    "address": "120 Amory St, Unit 2",
    "parcel_id": "022-09-07",
    "owner1": "MAGARACI, THOMAS",
    "owner2": "FROST, JOEL",
    "current_taxes": 7461.13,
    "new_taxes_no_override": 7783.45,
    "override_total_1": 8004.3,
    "override_increase_1": 220.85
  },
  {
    "#": "120 Amory St, Unit 3 & P3 (022-09-08)",
    "$": 1399400,
    "address": "120 Amory St, Unit 3 & P3",
    "parcel_id": "022-09-08",
    "owner1": "SHEOLA TRS, RICHARD A",
    "owner2": "BINNEY, JUNE S",
    "current_taxes": 10694.92,
    "new_taxes_no_override": 11156.94,
    "override_total_1": 11473.51,
    "override_increase_1": 316.57
  },
  {
    "#": "120 Amory St, Unit 4 (022-09-09)",
    "$": 1338200,
    "address": "120 Amory St, Unit 4",
    "parcel_id": "022-09-09",
    "owner1": "CAMINETSKY, SYDNEY",
    "owner2": "SHAUL, RUSSELL",
    "current_taxes": 10068.23,
    "new_taxes_no_override": 10503.18,
    "override_total_1": 10801.2,
    "override_increase_1": 298.02
  },
  {
    "#": "120 Amory St, Unit 5 (022-09-10)",
    "$": 742800,
    "address": "120 Amory St, Unit 5",
    "parcel_id": "022-09-10",
    "owner1": "CYKASH LLC",
    "owner2": "",
    "current_taxes": 7606.27,
    "new_taxes_no_override": 7934.86,
    "override_total_1": 8160.01,
    "override_increase_1": 225.15
  },
  {
    "#": "120 Amory St, Unit 5A & P7 (022-09-11)",
    "$": 884200,
    "address": "120 Amory St, Unit 5A & P7",
    "parcel_id": "022-09-11",
    "owner1": "CALKINS, CHRISTOPHER R",
    "owner2": "",
    "current_taxes": 9054.21,
    "new_taxes_no_override": 9445.35,
    "override_total_1": 9713.36,
    "override_increase_1": 268.0
  },
  {
    "#": "120 Amory St, Unit 6 & P8 (022-09-12)",
    "$": 1243500,
    "address": "120 Amory St, Unit 6 & P8",
    "parcel_id": "022-09-12",
    "owner1": "MEI, MARGERY",
    "owner2": "",
    "current_taxes": 12733.44,
    "new_taxes_no_override": 13283.52,
    "override_total_1": 13660.43,
    "override_increase_1": 376.91
  },
  {
    "#": "120 Amory St, Unit B-1 & P2 (022-09-01)",
    "$": 441400,
    "address": "120 Amory St, Unit B-1 & P2",
    "parcel_id": "022-09-01",
    "owner1": "SAMDPERIL TRS, DEBRA",
    "owner2": "FAMIGLIETTI, PHYLLIS G",
    "current_taxes": 885.0,
    "new_taxes_no_override": 923.23,
    "override_total_1": 949.43,
    "override_increase_1": 26.2
  },
  {
    "#": "120 Amory St, Unit B-2 (022-09-02)",
    "$": 430100,
    "address": "120 Amory St, Unit B-2",
    "parcel_id": "022-09-02",
    "owner1": "STARR, CURTIS B",
    "owner2": "",
    "current_taxes": 4404.22,
    "new_taxes_no_override": 4594.48,
    "override_total_1": 4724.85,
    "override_increase_1": 130.36
  },
  {
    "#": "126 Amory St, Unit 10 (022-09-16)",
    "$": 1134700,
    "address": "126 Amory St, Unit 10",
    "parcel_id": "022-09-16",
    "owner1": "EHRLICH, J SHOSHANNA",
    "owner2": "STOSKOPF, ALAN L",
    "current_taxes": 7984.39,
    "new_taxes_no_override": 8329.32,
    "override_total_1": 8565.65,
    "override_increase_1": 236.34
  },
  {
    "#": "126 Amory St, Unit 11 (022-09-17)",
    "$": 1218100,
    "address": "126 Amory St, Unit 11",
    "parcel_id": "022-09-17",
    "owner1": "ELLOZY TR, MOHAMED",
    "owner2": "",
    "current_taxes": 12473.34,
    "new_taxes_no_override": 13012.19,
    "override_total_1": 13381.4,
    "override_increase_1": 369.21
  },
  {
    "#": "126 Amory St, Unit 12 & P9 (022-09-18)",
    "$": 1216400,
    "address": "126 Amory St, Unit 12 & P9",
    "parcel_id": "022-09-18",
    "owner1": "BLECHER, ROBERT",
    "owner2": "MILLER, ZINAIDA",
    "current_taxes": 8821.0,
    "new_taxes_no_override": 9202.07,
    "override_total_1": 9463.17,
    "override_increase_1": 261.1
  },
  {
    "#": "126 Amory St, Unit 7 (022-09-13)",
    "$": 1083600,
    "address": "126 Amory St, Unit 7",
    "parcel_id": "022-09-13",
    "owner1": "MORSE, MARK E",
    "owner2": "",
    "current_taxes": 11096.06,
    "new_taxes_no_override": 11575.41,
    "override_total_1": 11903.85,
    "override_increase_1": 328.44
  },
  {
    "#": "126 Amory St, Unit 8 & P16 (022-09-14)",
    "$": 1106000,
    "address": "126 Amory St, Unit 8 & P16",
    "parcel_id": "022-09-14",
    "owner1": "KARLINSKY, NAHUM",
    "owner2": "ANKORI, GANNIT",
    "current_taxes": 7690.51,
    "new_taxes_no_override": 8022.74,
    "override_total_1": 8250.38,
    "override_increase_1": 227.64
  },
  {
    "#": "126 Amory St, Unit 9 & P11-12 (022-09-15)",
    "$": 1238300,
    "address": "126 Amory St, Unit 9 & P11-12",
    "parcel_id": "022-09-15",
    "owner1": "FRANCO, ELLEN S R",
    "owner2": "",
    "current_taxes": 9045.26,
    "new_taxes_no_override": 9436.02,
    "override_total_1": 9703.75,
    "override_increase_1": 267.74
  },
  {
    "#": "126 Amory St, Unit B-3 & P1 (022-09-03)",
    "$": 565100,
    "address": "126 Amory St, Unit B-3 & P1",
    "parcel_id": "022-09-03",
    "owner1": "VELASQUEZ TR, MARGARITA",
    "owner2": "",
    "current_taxes": 5786.62,
    "new_taxes_no_override": 6036.6,
    "override_total_1": 6207.89,
    "override_increase_1": 171.28
  },
  {
    "#": "126 Amory St, Unit B-4 & P18 (022-09-04)",
    "$": 577800,
    "address": "126 Amory St, Unit B-4 & P18",
    "parcel_id": "022-09-04",
    "owner1": "TAVANA, DARIAN",
    "owner2": "",
    "current_taxes": 2281.74,
    "new_taxes_no_override": 2380.31,
    "override_total_1": 2447.85,
    "override_increase_1": 67.54
  },
  {
    "#": "132 Amory St, Unit 1 & P23 P24 (022-07-07)",
    "$": 1198900,
    "address": "132 Amory St, Unit 1 & P23 P24",
    "parcel_id": "022-07-07",
    "owner1": "VASUNILASHORN, SARINNAPHA",
    "owner2": "MAY, BORI",
    "current_taxes": 8641.8,
    "new_taxes_no_override": 9015.13,
    "override_total_1": 9270.92,
    "override_increase_1": 255.8
  },
  {
    "#": "132 Amory St, Unit 2 & P25 (022-07-01)",
    "$": 1313900,
    "address": "132 Amory St, Unit 2 & P25",
    "parcel_id": "022-07-01",
    "owner1": "STANG, DEBORAH",
    "owner2": "CRAIGUE, ROBERT J JR",
    "current_taxes": 13454.34,
    "new_taxes_no_override": 14035.57,
    "override_total_1": 14433.82,
    "override_increase_1": 398.25
  },
  {
    "#": "132 Amory St, Unit 3 & P20 P21 (022-07-02)",
    "$": 1425100,
    "address": "132 Amory St, Unit 3 & P20 P21",
    "parcel_id": "022-07-02",
    "owner1": "CHASE, JENNIFER A",
    "owner2": "BEN-ARI, NIR",
    "current_taxes": 10958.09,
    "new_taxes_no_override": 11431.48,
    "override_total_1": 11755.84,
    "override_increase_1": 324.36
  },
  {
    "#": "132 Amory St, Unit 4 & P27 P28 (022-07-03)",
    "$": 1525500,
    "address": "132 Amory St, Unit 4 & P27 P28",
    "parcel_id": "022-07-03",
    "owner1": "WILCOX, ET AL, DAVID L",
    "owner2": "",
    "current_taxes": 15621.12,
    "new_taxes_no_override": 16295.95,
    "override_total_1": 16758.34,
    "override_increase_1": 462.39
  },
  {
    "#": "132 Amory St, Unit 5 & P-26 (022-07-04)",
    "$": 1402500,
    "address": "132 Amory St, Unit 5 & P-26",
    "parcel_id": "022-07-04",
    "owner1": "VANDOR, STEVEN",
    "owner2": "MUROFF, JORDANA",
    "current_taxes": 10726.67,
    "new_taxes_no_override": 11190.06,
    "override_total_1": 11507.57,
    "override_increase_1": 317.51
  },
  {
    "#": "132 Amory St, Unit 6 & P29 (022-07-05)",
    "$": 1555600,
    "address": "132 Amory St, Unit 6 & P29",
    "parcel_id": "022-07-05",
    "owner1": "OTT, PATRICK A",
    "owner2": "",
    "current_taxes": 12294.41,
    "new_taxes_no_override": 12825.53,
    "override_total_1": 13189.44,
    "override_increase_1": 363.91
  },
  {
    "#": "132 Amory St, Unit B & P22 (022-07-06)",
    "$": 766500,
    "address": "132 Amory St, Unit B & P22",
    "parcel_id": "022-07-06",
    "owner1": "MATTSON, LESLEY",
    "owner2": "",
    "current_taxes": 4214.03,
    "new_taxes_no_override": 4396.08,
    "override_total_1": 4520.81,
    "override_increase_1": 124.74
  },
  {
    "#": "144 Amory St (021-01-00)",
    "$": 21131700,
    "address": "144 Amory St",
    "parcel_id": "021-01-00",
    "owner1": "BROOKLINE HOUSING AUTHORITY",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "155 Amory St (016-01-03)",
    "$": 3207700,
    "address": "155 Amory St",
    "parcel_id": "016-01-03",
    "owner1": "HUANG, YASHENG",
    "owner2": "",
    "current_taxes": 32846.85,
    "new_taxes_no_override": 34265.83,
    "override_total_1": 35238.1,
    "override_increase_1": 972.27
  },
  {
    "#": "163 Amory St (017-05-00)",
    "$": 9481600,
    "address": "163 Amory St",
    "parcel_id": "017-05-00",
    "owner1": "TRUSTEES OF BOSTON UNIVERSITY",
    "owner2": "C/O GENERAL ACCOUNTING 4TH FL",
    "current_taxes": 29518.84,
    "new_taxes_no_override": 30794.05,
    "override_total_1": 31667.81,
    "override_increase_1": 873.76
  },
  {
    "#": "5 Arlington Rd (416-24-00)",
    "$": 2153800,
    "address": "5 Arlington Rd",
    "parcel_id": "416-24-00",
    "owner1": "SCANLON TRS, WILLIAM F & NANCY C",
    "owner2": "",
    "current_taxes": 22054.91,
    "new_taxes_no_override": 23007.68,
    "override_total_1": 23660.51,
    "override_increase_1": 652.83
  },
  {
    "#": "8 Arlington Rd (412-01-00)",
    "$": 1642000,
    "address": "8 Arlington Rd",
    "parcel_id": "412-01-00",
    "owner1": "ANER, ELDA ESIM & MUSA",
    "owner2": "",
    "current_taxes": 16814.08,
    "new_taxes_no_override": 17540.45,
    "override_total_1": 18038.15,
    "override_increase_1": 497.7
  },
  {
    "#": "11 Arlington Rd (416-23-00)",
    "$": 2407500,
    "address": "11 Arlington Rd",
    "parcel_id": "416-23-00",
    "owner1": "WALSH, CHRISTOPHER",
    "owner2": "CHEN, MING HUI",
    "current_taxes": 21017.87,
    "new_taxes_no_override": 21925.84,
    "override_total_1": 22547.97,
    "override_increase_1": 622.13
  },
  {
    "#": "16 Arlington Rd (412-02-00)",
    "$": 2194000,
    "address": "16 Arlington Rd",
    "parcel_id": "412-02-00",
    "owner1": "BANKIER, ALEXANDER",
    "owner2": "FERRARIS, FRANCESCA",
    "current_taxes": 18831.63,
    "new_taxes_no_override": 19645.16,
    "override_total_1": 20202.57,
    "override_increase_1": 557.42
  },
  {
    "#": "17 Arlington Rd (416-22-00)",
    "$": 2150200,
    "address": "17 Arlington Rd",
    "parcel_id": "416-22-00",
    "owner1": "FALLON, DANA  C",
    "owner2": "KUDISCH, LAUREN E",
    "current_taxes": 18383.11,
    "new_taxes_no_override": 19177.26,
    "override_total_1": 19721.4,
    "override_increase_1": 544.14
  },
  {
    "#": "23 Arlington Rd (416-21-00)",
    "$": 1759600,
    "address": "23 Arlington Rd",
    "parcel_id": "416-21-00",
    "owner1": "RIFFE, SUSAN L & CHRISTOPHER R",
    "owner2": "",
    "current_taxes": 14383.37,
    "new_taxes_no_override": 15004.73,
    "override_total_1": 15430.48,
    "override_increase_1": 425.75
  },
  {
    "#": "24 Arlington Rd (412-03-00)",
    "$": 2572400,
    "address": "24 Arlington Rd",
    "parcel_id": "412-03-00",
    "owner1": "AVILLACH, CLAIRE & PAUL",
    "owner2": "",
    "current_taxes": 22706.44,
    "new_taxes_no_override": 23687.36,
    "override_total_1": 24359.47,
    "override_increase_1": 672.11
  },
  {
    "#": "31 Arlington Rd (416-20-00)",
    "$": 1571700,
    "address": "31 Arlington Rd",
    "parcel_id": "416-20-00",
    "owner1": "KATZ, TRS, KERMIT H & HELEN R",
    "owner2": "",
    "current_taxes": 12459.27,
    "new_taxes_no_override": 12997.51,
    "override_total_1": 13366.3,
    "override_increase_1": 368.79
  },
  {
    "#": "32 Arlington Rd (412-04-00)",
    "$": 1193900,
    "address": "32 Arlington Rd",
    "parcel_id": "412-04-00",
    "owner1": "HUNTER, TRS, RUTH ANN M & KRISTEN L",
    "owner2": "",
    "current_taxes": 8590.6,
    "new_taxes_no_override": 8961.71,
    "override_total_1": 9216.0,
    "override_increase_1": 254.28
  },
  {
    "#": "36 Arlington Rd (412-05-00)",
    "$": 1780800,
    "address": "36 Arlington Rd",
    "parcel_id": "412-05-00",
    "owner1": "MCGUGAN TRS, VINCENT J & JOYCE WYMAN",
    "owner2": "",
    "current_taxes": 14600.46,
    "new_taxes_no_override": 15231.2,
    "override_total_1": 15663.37,
    "override_increase_1": 432.17
  },
  {
    "#": "39 Arlington Rd (416-19-00)",
    "$": 1967200,
    "address": "39 Arlington Rd",
    "parcel_id": "416-19-00",
    "owner1": "MOORHEAD, SAMUEL & ALEXANDRA",
    "owner2": "",
    "current_taxes": 16509.19,
    "new_taxes_no_override": 17222.39,
    "override_total_1": 17711.06,
    "override_increase_1": 488.67
  },
  {
    "#": "42 Arlington Rd (412-06-00)",
    "$": 2131000,
    "address": "42 Arlington Rd",
    "parcel_id": "412-06-00",
    "owner1": "YOUSEF TR, MONA K",
    "owner2": "",
    "current_taxes": 21821.44,
    "new_taxes_no_override": 22764.13,
    "override_total_1": 23410.04,
    "override_increase_1": 645.91
  },
  {
    "#": "47 Arlington Rd (416-18-00)",
    "$": 2164000,
    "address": "47 Arlington Rd",
    "parcel_id": "416-18-00",
    "owner1": "DHILLON, GURSIMRAN",
    "owner2": "",
    "current_taxes": 18524.43,
    "new_taxes_no_override": 19324.69,
    "override_total_1": 19873.01,
    "override_increase_1": 548.32
  },
  {
    "#": "50 Arlington Rd (412-07-01)",
    "$": 2946700,
    "address": "50 Arlington Rd",
    "parcel_id": "412-07-01",
    "owner1": "GURDIN, STEVEN E & LISA",
    "owner2": "",
    "current_taxes": 26539.27,
    "new_taxes_no_override": 27685.77,
    "override_total_1": 28471.33,
    "override_increase_1": 785.56
  },
  {
    "#": "61 Arlington Rd (415-08-00)",
    "$": 2237500,
    "address": "61 Arlington Rd",
    "parcel_id": "415-08-00",
    "owner1": "OBRIEN TRS, PATRICK J JR  & DYANNE F",
    "owner2": "",
    "current_taxes": 19277.07,
    "new_taxes_no_override": 20109.84,
    "override_total_1": 20680.44,
    "override_increase_1": 570.6
  },
  {
    "#": "64 Arlington Rd (413-08-00)",
    "$": 2079300,
    "address": "64 Arlington Rd",
    "parcel_id": "413-08-00",
    "owner1": "ALLEN, LINDA J",
    "owner2": "",
    "current_taxes": 17657.1,
    "new_taxes_no_override": 18419.89,
    "override_total_1": 18942.54,
    "override_increase_1": 522.65
  },
  {
    "#": "72 Arlington Rd (413-09-00)",
    "$": 1760200,
    "address": "72 Arlington Rd",
    "parcel_id": "413-09-00",
    "owner1": "MIR, JULITA",
    "owner2": "MUNARRIZ, RICARDO",
    "current_taxes": 14389.51,
    "new_taxes_no_override": 15011.14,
    "override_total_1": 15437.07,
    "override_increase_1": 425.93
  },
  {
    "#": "73 Arlington Rd (415-10-00)",
    "$": 2356800,
    "address": "73 Arlington Rd",
    "parcel_id": "415-10-00",
    "owner1": "BOURDINE TRS, ANDREI G & ANNE E",
    "owner2": "",
    "current_taxes": 20498.7,
    "new_taxes_no_override": 21384.24,
    "override_total_1": 21991.01,
    "override_increase_1": 606.76
  },
  {
    "#": "78 Arlington Rd (413-10-00)",
    "$": 2009400,
    "address": "78 Arlington Rd",
    "parcel_id": "413-10-00",
    "owner1": "CHOUDHRY, NITEESH & SALONI BOWRY",
    "owner2": "",
    "current_taxes": 16941.32,
    "new_taxes_no_override": 17673.19,
    "override_total_1": 18174.65,
    "override_increase_1": 501.46
  },
  {
    "#": "81 Arlington Rd (415-11-00)",
    "$": 1554200,
    "address": "81 Arlington Rd",
    "parcel_id": "415-11-00",
    "owner1": "SHEA TRS, MARK V & JODI L",
    "owner2": "",
    "current_taxes": 12280.07,
    "new_taxes_no_override": 12810.57,
    "override_total_1": 13174.06,
    "override_increase_1": 363.49
  },
  {
    "#": "86 Arlington Rd (413-11-00)",
    "$": 1814600,
    "address": "86 Arlington Rd",
    "parcel_id": "413-11-00",
    "owner1": "BROWN, THEODORE H & JENNIFER R",
    "owner2": "",
    "current_taxes": 18581.5,
    "new_taxes_no_override": 19384.22,
    "override_total_1": 19934.23,
    "override_increase_1": 550.01
  },
  {
    "#": "89 Arlington Rd (415-12-00)",
    "$": 3149900,
    "address": "89 Arlington Rd",
    "parcel_id": "415-12-00",
    "owner1": "FONG TRS, STEPHANIE",
    "owner2": "VAN DYCK, THOMAS",
    "current_taxes": 28620.04,
    "new_taxes_no_override": 29856.43,
    "override_total_1": 30703.58,
    "override_increase_1": 847.15
  },
  {
    "#": "92 Arlington Rd (413-12-00)",
    "$": 2314700,
    "address": "92 Arlington Rd",
    "parcel_id": "413-12-00",
    "owner1": "GORDON, PETER H & JACQUELINE V",
    "owner2": "",
    "current_taxes": 20067.59,
    "new_taxes_no_override": 20934.51,
    "override_total_1": 21528.51,
    "override_increase_1": 594.0
  },
  {
    "#": "96 Arlington Rd (413-12-01)",
    "$": 2499600,
    "address": "96 Arlington Rd",
    "parcel_id": "413-12-01",
    "owner1": "DAVID, EDUARDA VASCONCELLOS & RAFAEL MACEDO",
    "owner2": "",
    "current_taxes": 25595.9,
    "new_taxes_no_override": 26701.64,
    "override_total_1": 27459.28,
    "override_increase_1": 757.64
  },
  {
    "#": "97 Arlington Rd (415-13-00)",
    "$": 1926400,
    "address": "97 Arlington Rd",
    "parcel_id": "415-13-00",
    "owner1": "DELGADO, MELVIN & DENISE H",
    "owner2": "",
    "current_taxes": 16091.4,
    "new_taxes_no_override": 16786.55,
    "override_total_1": 17262.85,
    "override_increase_1": 476.31
  },
  {
    "#": "100 Arlington Rd (413-13-00)",
    "$": 2075700,
    "address": "100 Arlington Rd",
    "parcel_id": "413-13-00",
    "owner1": "WONG, GRACE H W",
    "owner2": "",
    "current_taxes": 17620.23,
    "new_taxes_no_override": 18381.42,
    "override_total_1": 18902.98,
    "override_increase_1": 521.56
  },
  {
    "#": "110 Arlington Rd (413-14-00)",
    "$": 2006400,
    "address": "110 Arlington Rd",
    "parcel_id": "413-14-00",
    "owner1": "KOCHAR, AJAR & BHARATI DEVI",
    "owner2": "",
    "current_taxes": 16910.6,
    "new_taxes_no_override": 17641.14,
    "override_total_1": 18141.69,
    "override_increase_1": 500.55
  },
  {
    "#": "115 Arlington Rd (416-05-06)",
    "$": 2714400,
    "address": "115 Arlington Rd",
    "parcel_id": "416-05-06",
    "owner1": "RAHBAR TR, REZA",
    "owner2": "",
    "current_taxes": 24160.52,
    "new_taxes_no_override": 25204.25,
    "override_total_1": 25919.41,
    "override_increase_1": 715.15
  },
  {
    "#": "118 Arlington Rd (413-15-00)",
    "$": 1750600,
    "address": "118 Arlington Rd",
    "parcel_id": "413-15-00",
    "owner1": "DANA, ALAN G & MARGARET G",
    "owner2": "",
    "current_taxes": 14291.21,
    "new_taxes_no_override": 14908.59,
    "override_total_1": 15331.61,
    "override_increase_1": 423.02
  },
  {
    "#": "124 Arlington Rd (413-16-00)",
    "$": 1889600,
    "address": "124 Arlington Rd",
    "parcel_id": "413-16-00",
    "owner1": "SILK, KENNETH JON",
    "owner2": "WOLCHANSKY SILK, SANDI ILENE",
    "current_taxes": 15714.57,
    "new_taxes_no_override": 16393.44,
    "override_total_1": 16858.59,
    "override_increase_1": 465.15
  },
  {
    "#": "125 Arlington Rd (416-04-00)",
    "$": 2403800,
    "address": "125 Arlington Rd",
    "parcel_id": "416-04-00",
    "owner1": "SADEGHI-NEJAD TR, ABDOLLAH",
    "owner2": "",
    "current_taxes": 20979.98,
    "new_taxes_no_override": 21886.32,
    "override_total_1": 22507.32,
    "override_increase_1": 621.01
  },
  {
    "#": "132 Arlington Rd (413-17-00)",
    "$": 2325000,
    "address": "132 Arlington Rd",
    "parcel_id": "413-17-00",
    "owner1": "CHI ETAL, CHEN MING",
    "owner2": "DENG, TERESA",
    "current_taxes": 20173.07,
    "new_taxes_no_override": 21044.55,
    "override_total_1": 21641.67,
    "override_increase_1": 597.12
  },
  {
    "#": "135 Arlington Rd (416-03-00)",
    "$": 2381600,
    "address": "135 Arlington Rd",
    "parcel_id": "416-03-00",
    "owner1": "GARDNER, KATHLEEN T",
    "owner2": "WHITEHEAD, RICHARD E",
    "current_taxes": 20752.65,
    "new_taxes_no_override": 21649.16,
    "override_total_1": 22263.44,
    "override_increase_1": 614.28
  },
  {
    "#": "141 Arlington Rd (416-01-02)",
    "$": 3764800,
    "address": "141 Arlington Rd",
    "parcel_id": "416-01-02",
    "owner1": "GOLD, NEAL S & LAURIE C",
    "owner2": "",
    "current_taxes": 34916.62,
    "new_taxes_no_override": 36425.02,
    "override_total_1": 37458.55,
    "override_increase_1": 1033.53
  },
  {
    "#": "260 Arlington Rd (418-21-00)",
    "$": 29731500,
    "address": "260 Arlington Rd",
    "parcel_id": "418-21-00",
    "owner1": "COMMONWEALTH OF MASSACHUSETTS",
    "owner2": "C/O DEPT OF CONSERVATION & RECREATION",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "290 Arlington Rd (423-01-00)",
    "$": 1204000,
    "address": "290 Arlington Rd",
    "parcel_id": "423-01-00",
    "owner1": "WOODWARD, SUE",
    "owner2": "",
    "current_taxes": 8694.03,
    "new_taxes_no_override": 9069.61,
    "override_total_1": 9326.96,
    "override_increase_1": 257.34
  },
  {
    "#": "302 Arlington Rd (423-02-00)",
    "$": 2130100,
    "address": "302 Arlington Rd",
    "parcel_id": "423-02-00",
    "owner1": "FRANKEL TRS, IRWIN H & MARCY B & DAVID",
    "owner2": "",
    "current_taxes": 18177.29,
    "new_taxes_no_override": 18962.55,
    "override_total_1": 19500.6,
    "override_increase_1": 538.05
  },
  {
    "#": "6 Asheville Rd (382-14-00)",
    "$": 1150900,
    "address": "6 Asheville Rd",
    "parcel_id": "382-14-00",
    "owner1": "CASSIM, BRIAN & MARLENE",
    "owner2": "",
    "current_taxes": 8150.28,
    "new_taxes_no_override": 8502.37,
    "override_total_1": 8743.62,
    "override_increase_1": 241.25
  },
  {
    "#": "7 Asheville Rd (385-18-00)",
    "$": 1434000,
    "address": "7 Asheville Rd",
    "parcel_id": "385-18-00",
    "owner1": "MARSHALL, JESSE",
    "owner2": "RENGARAJAN, MICHELLE",
    "current_taxes": 11049.23,
    "new_taxes_no_override": 11526.56,
    "override_total_1": 11853.61,
    "override_increase_1": 327.06
  },
  {
    "#": "10 Asheville Rd (382-13-00)",
    "$": 1042600,
    "address": "10 Asheville Rd",
    "parcel_id": "382-13-00",
    "owner1": "DUVALL TRS, ROBERT E & AMMALIA",
    "owner2": "",
    "current_taxes": 7041.29,
    "new_taxes_no_override": 7345.47,
    "override_total_1": 7553.9,
    "override_increase_1": 208.42
  },
  {
    "#": "14 Asheville Rd (382-12-00)",
    "$": 1381400,
    "address": "14 Asheville Rd",
    "parcel_id": "382-12-00",
    "owner1": "REES, LORIN & JENNIFER A",
    "owner2": "",
    "current_taxes": 10510.6,
    "new_taxes_no_override": 10964.66,
    "override_total_1": 11275.77,
    "override_increase_1": 311.11
  },
  {
    "#": "25 Asheville Rd (386-20-00)",
    "$": 2085000,
    "address": "25 Asheville Rd",
    "parcel_id": "386-20-00",
    "owner1": "PATEL, SAVAN",
    "owner2": "PALADINO, JOANNA",
    "current_taxes": 17715.47,
    "new_taxes_no_override": 18480.78,
    "override_total_1": 19005.16,
    "override_increase_1": 524.38
  },
  {
    "#": "26 Asheville Rd (383-13-00)",
    "$": 1321700,
    "address": "26 Asheville Rd",
    "parcel_id": "383-13-00",
    "owner1": "RECHES, EHUD N & DEBORAH M",
    "owner2": "",
    "current_taxes": 9899.27,
    "new_taxes_no_override": 10326.92,
    "override_total_1": 10619.94,
    "override_increase_1": 293.02
  },
  {
    "#": "33 Asheville Rd (386-01-00)",
    "$": 1163100,
    "address": "33 Asheville Rd",
    "parcel_id": "386-01-00",
    "owner1": "SCOTT, SAMUEL JR",
    "owner2": "COLLERAN, ROBERT J",
    "current_taxes": 8275.21,
    "new_taxes_no_override": 8632.7,
    "override_total_1": 8877.65,
    "override_increase_1": 244.95
  },
  {
    "#": "45 Asheville Rd (387-01-00)",
    "$": 1323600,
    "address": "45 Asheville Rd",
    "parcel_id": "387-01-00",
    "owner1": "ARNOLD, TRACY L",
    "owner2": "VARRELL, WILLIAM M",
    "current_taxes": 9918.73,
    "new_taxes_no_override": 10347.22,
    "override_total_1": 10640.81,
    "override_increase_1": 293.59
  },
  {
    "#": "46 Asheville Rd (384-12-00)",
    "$": 1745500,
    "address": "46 Asheville Rd",
    "parcel_id": "384-12-00",
    "owner1": "LO, SOPHY & RICHARD",
    "owner2": "",
    "current_taxes": 14238.99,
    "new_taxes_no_override": 14854.11,
    "override_total_1": 15275.59,
    "override_increase_1": 421.47
  },
  {
    "#": "15 Aspinwall Ave, Unit 1 (154-06-01)",
    "$": 630100,
    "address": "15 Aspinwall Ave, Unit 1",
    "parcel_id": "154-06-01",
    "owner1": "KOTSUR, YURIY & YELENA",
    "owner2": "",
    "current_taxes": 6452.22,
    "new_taxes_no_override": 6730.96,
    "override_total_1": 6921.94,
    "override_increase_1": 190.99
  },
  {
    "#": "15 Aspinwall Ave, Unit 2 (154-06-02)",
    "$": 676100,
    "address": "15 Aspinwall Ave, Unit 2",
    "parcel_id": "154-06-02",
    "owner1": "HUANG, SAM",
    "owner2": "OU, YING HUA",
    "current_taxes": 3288.33,
    "new_taxes_no_override": 3430.39,
    "override_total_1": 3527.72,
    "override_increase_1": 97.33
  },
  {
    "#": "15 Aspinwall Ave, Unit 3 (154-06-03)",
    "$": 689700,
    "address": "15 Aspinwall Ave, Unit 3",
    "parcel_id": "154-06-03",
    "owner1": "XING, XIAOFANG",
    "owner2": "SHAO, HANG",
    "current_taxes": 7062.53,
    "new_taxes_no_override": 7367.63,
    "override_total_1": 7576.68,
    "override_increase_1": 209.05
  },
  {
    "#": "15 Aspinwall Ave, Unit 4 & Prk 5 (154-06-04)",
    "$": 726300,
    "address": "15 Aspinwall Ave, Unit 4 & Prk 5",
    "parcel_id": "154-06-04",
    "owner1": "SZETO, PIK KI",
    "owner2": "WONG, KIN SONG",
    "current_taxes": 7437.31,
    "new_taxes_no_override": 7758.6,
    "override_total_1": 7978.75,
    "override_increase_1": 220.14
  },
  {
    "#": "17 Aspinwall Ave, Unit 1 (154-06-05)",
    "$": 649500,
    "address": "17 Aspinwall Ave, Unit 1",
    "parcel_id": "154-06-05",
    "owner1": "AUDY, OMAR E",
    "owner2": "",
    "current_taxes": 3015.95,
    "new_taxes_no_override": 3146.24,
    "override_total_1": 3235.51,
    "override_increase_1": 89.27
  },
  {
    "#": "17 Aspinwall Ave, Unit 2 & P6 (154-06-06)",
    "$": 771800,
    "address": "17 Aspinwall Ave, Unit 2 & P6",
    "parcel_id": "154-06-06",
    "owner1": "LI, WOON YI",
    "owner2": "",
    "current_taxes": 7903.23,
    "new_taxes_no_override": 8244.65,
    "override_total_1": 8478.59,
    "override_increase_1": 233.94
  },
  {
    "#": "17 Aspinwall Ave, Unit 3 & P1 (154-06-07)",
    "$": 757100,
    "address": "17 Aspinwall Ave, Unit 3 & P1",
    "parcel_id": "154-06-07",
    "owner1": "ABRAMSKIY, VLADISLAV & NATALIYA",
    "owner2": "",
    "current_taxes": 7752.7,
    "new_taxes_no_override": 8087.62,
    "override_total_1": 8317.1,
    "override_increase_1": 229.48
  },
  {
    "#": "17 Aspinwall Ave, Unit 4 & P3 (154-06-08)",
    "$": 726300,
    "address": "17 Aspinwall Ave, Unit 4 & P3",
    "parcel_id": "154-06-08",
    "owner1": "CALAY, SUHA E & MEHMET R",
    "owner2": "",
    "current_taxes": 7437.31,
    "new_taxes_no_override": 7758.6,
    "override_total_1": 7978.75,
    "override_increase_1": 220.14
  },
  {
    "#": "18 Aspinwall Ave (155-13-00)",
    "$": 1944800,
    "address": "18 Aspinwall Ave",
    "parcel_id": "155-13-00",
    "owner1": "SANIEOFF TRS, ESHAGH",
    "owner2": "NAVIAN, SHAHNAZ",
    "current_taxes": 19914.75,
    "new_taxes_no_override": 20775.07,
    "override_total_1": 21364.54,
    "override_increase_1": 589.48
  },
  {
    "#": "23 Aspinwall Ave (154-11-00)",
    "$": 4595900,
    "address": "23 Aspinwall Ave",
    "parcel_id": "154-11-00",
    "owner1": "UPSILON LLC",
    "owner2": "",
    "current_taxes": 47062.02,
    "new_taxes_no_override": 49095.1,
    "override_total_1": 50488.14,
    "override_increase_1": 1393.04
  },
  {
    "#": "33 Aspinwall Ave, Unit 1 (154-08-01)",
    "$": 952300,
    "address": "33 Aspinwall Ave, Unit 1",
    "parcel_id": "154-08-01",
    "owner1": "LENNERZ, BELINDA & JOCHEN",
    "owner2": "",
    "current_taxes": 6116.62,
    "new_taxes_no_override": 6380.86,
    "override_total_1": 6561.91,
    "override_increase_1": 181.05
  },
  {
    "#": "33 Aspinwall Ave, Unit 2 (154-08-02)",
    "$": 607500,
    "address": "33 Aspinwall Ave, Unit 2",
    "parcel_id": "154-08-02",
    "owner1": "KAPUST, JONATHAN & ANNA",
    "owner2": "",
    "current_taxes": 2585.87,
    "new_taxes_no_override": 2697.58,
    "override_total_1": 2774.12,
    "override_increase_1": 76.54
  },
  {
    "#": "33 Aspinwall Ave, Unit 3 (154-08-03)",
    "$": 577200,
    "address": "33 Aspinwall Ave, Unit 3",
    "parcel_id": "154-08-03",
    "owner1": "MYERS, MARGARET EISEN & ALAN",
    "owner2": "",
    "current_taxes": 5910.53,
    "new_taxes_no_override": 6165.86,
    "override_total_1": 6340.82,
    "override_increase_1": 174.95
  },
  {
    "#": "33 Aspinwall Ave, Unit 4 (154-08-04)",
    "$": 760900,
    "address": "33 Aspinwall Ave, Unit 4",
    "parcel_id": "154-08-04",
    "owner1": "HEALY, MICHAEL & HELEN",
    "owner2": "",
    "current_taxes": 4156.68,
    "new_taxes_no_override": 4336.25,
    "override_total_1": 4459.29,
    "override_increase_1": 123.04
  },
  {
    "#": "33 Aspinwall Ave, Unit 5 (154-08-05)",
    "$": 661500,
    "address": "33 Aspinwall Ave, Unit 5",
    "parcel_id": "154-08-05",
    "owner1": "RYBARSKI, MICHAEL",
    "owner2": "BONG-RYBARSKI, LOUISA",
    "current_taxes": 3138.83,
    "new_taxes_no_override": 3274.43,
    "override_total_1": 3367.34,
    "override_increase_1": 92.91
  },
  {
    "#": "39 Aspinwall Ave (154-09-00)",
    "$": 1658200,
    "address": "39 Aspinwall Ave",
    "parcel_id": "154-09-00",
    "owner1": "REPUBLIC REALTY LP",
    "owner2": "C/O REPUBLIC PLUMBING SUPPLY",
    "current_taxes": 28454.71,
    "new_taxes_no_override": 29683.95,
    "override_total_1": 30526.21,
    "override_increase_1": 842.26
  },
  {
    "#": "40 Aspinwall Ave (155-10-11)",
    "$": 2759000,
    "address": "40 Aspinwall Ave",
    "parcel_id": "155-10-11",
    "owner1": "BGOODMAN LLC",
    "owner2": "",
    "current_taxes": 47344.44,
    "new_taxes_no_override": 49389.72,
    "override_total_1": 50791.12,
    "override_increase_1": 1401.4
  },
  {
    "#": "46 Aspinwall Ave (155-09-01)",
    "$": 2104400,
    "address": "46 Aspinwall Ave",
    "parcel_id": "155-09-01",
    "owner1": "JOCELYN, BADELE",
    "owner2": "CHEN, LI",
    "current_taxes": 17914.12,
    "new_taxes_no_override": 18688.01,
    "override_total_1": 19218.27,
    "override_increase_1": 530.26
  },
  {
    "#": "57 Aspinwall Ave (153-09-00)",
    "$": 1733500,
    "address": "57 Aspinwall Ave",
    "parcel_id": "153-09-00",
    "owner1": "KURLANDER TR, KAREN",
    "owner2": "",
    "current_taxes": 17751.04,
    "new_taxes_no_override": 18517.88,
    "override_total_1": 19043.32,
    "override_increase_1": 525.43
  },
  {
    "#": "58 Aspinwall Ave (155-09-00)",
    "$": 1780500,
    "address": "58 Aspinwall Ave",
    "parcel_id": "155-09-00",
    "owner1": "58 ASPINWALL LLC",
    "owner2": "",
    "current_taxes": 18232.32,
    "new_taxes_no_override": 19019.96,
    "override_total_1": 19559.63,
    "override_increase_1": 539.68
  },
  {
    "#": "60 Aspinwall Ave, Unit 1 (155-08-03)",
    "$": 1036400,
    "address": "60 Aspinwall Ave, Unit 1",
    "parcel_id": "155-08-03",
    "owner1": "MCMAHON, SEAN",
    "owner2": "KEENAN, NORA",
    "current_taxes": 6977.8,
    "new_taxes_no_override": 7279.24,
    "override_total_1": 7485.78,
    "override_increase_1": 206.54
  },
  {
    "#": "60 Aspinwall Ave, Unit 2 (155-08-01)",
    "$": 1078300,
    "address": "60 Aspinwall Ave, Unit 2",
    "parcel_id": "155-08-01",
    "owner1": "SHIUE, REU-JYE",
    "owner2": "CHANG, CHIH-WEI",
    "current_taxes": 7406.86,
    "new_taxes_no_override": 7726.84,
    "override_total_1": 7946.08,
    "override_increase_1": 219.24
  },
  {
    "#": "60 Aspinwall Ave, Unit 3 (155-08-02)",
    "$": 1096400,
    "address": "60 Aspinwall Ave, Unit 3",
    "parcel_id": "155-08-02",
    "owner1": "WIRTZ, VERONIKA JOSEFA",
    "owner2": "GUTUERREZ WING, ENRIQUE SIMON",
    "current_taxes": 7592.2,
    "new_taxes_no_override": 7920.18,
    "override_total_1": 8144.91,
    "override_increase_1": 224.73
  },
  {
    "#": "64 Aspinwall Ave, Unit 1 (155-07-02)",
    "$": 947700,
    "address": "64 Aspinwall Ave, Unit 1",
    "parcel_id": "155-07-02",
    "owner1": "TANG, YUNNENG",
    "owner2": "WANG, LI",
    "current_taxes": 9704.45,
    "new_taxes_no_override": 10123.68,
    "override_total_1": 10410.93,
    "override_increase_1": 287.25
  },
  {
    "#": "64 Aspinwall Ave, Unit 2 (155-07-03)",
    "$": 974500,
    "address": "64 Aspinwall Ave, Unit 2",
    "parcel_id": "155-07-03",
    "owner1": "SHWALB, GENE M & RACHEL L",
    "owner2": "",
    "current_taxes": 6343.95,
    "new_taxes_no_override": 6618.01,
    "override_total_1": 6805.79,
    "override_increase_1": 187.78
  },
  {
    "#": "64 Aspinwall Ave, Unit 3 (155-07-04)",
    "$": 950600,
    "address": "64 Aspinwall Ave, Unit 3",
    "parcel_id": "155-07-04",
    "owner1": "VIRTA, OLIVER W",
    "owner2": "MCALEER, BETH",
    "current_taxes": 6099.21,
    "new_taxes_no_override": 6362.7,
    "override_total_1": 6543.23,
    "override_increase_1": 180.54
  },
  {
    "#": "64 Aspinwall Ave, Unit 4 (155-07-05)",
    "$": 931200,
    "address": "64 Aspinwall Ave, Unit 4",
    "parcel_id": "155-07-05",
    "owner1": "PIRA, SUE O KIM & TONY N",
    "owner2": "",
    "current_taxes": 5900.55,
    "new_taxes_no_override": 6155.45,
    "override_total_1": 6330.11,
    "override_increase_1": 174.66
  },
  {
    "#": "64 Aspinwall Ave, Unit 5 (155-07-06)",
    "$": 1017200,
    "address": "64 Aspinwall Ave, Unit 5",
    "parcel_id": "155-07-06",
    "owner1": "WEBER, STEPHAN",
    "owner2": "PALACIOS, REBECA SALGUERO",
    "current_taxes": 6781.19,
    "new_taxes_no_override": 7074.14,
    "override_total_1": 7274.86,
    "override_increase_1": 200.72
  },
  {
    "#": "64 Aspinwall Ave, Unit 6 (155-07-07)",
    "$": 1006200,
    "address": "64 Aspinwall Ave, Unit 6",
    "parcel_id": "155-07-07",
    "owner1": "THOMAS, JANE DELIMA",
    "owner2": "",
    "current_taxes": 6668.55,
    "new_taxes_no_override": 6956.63,
    "override_total_1": 7154.02,
    "override_increase_1": 197.39
  },
  {
    "#": "65 Aspinwall Ave (153-10-00)",
    "$": 2183100,
    "address": "65 Aspinwall Ave",
    "parcel_id": "153-10-00",
    "owner1": "MENDOZA, DENNIS & MICHELE",
    "owner2": "",
    "current_taxes": 18720.01,
    "new_taxes_no_override": 19528.71,
    "override_total_1": 20082.83,
    "override_increase_1": 554.11
  },
  {
    "#": "71 Aspinwall Ave (153-11-00)",
    "$": 2356700,
    "address": "71 Aspinwall Ave",
    "parcel_id": "153-11-00",
    "owner1": "ISGANAITIS, ELVIRA",
    "owner2": "ALSACE MANAGEMENT LTD",
    "current_taxes": 20497.67,
    "new_taxes_no_override": 21383.17,
    "override_total_1": 21989.9,
    "override_increase_1": 606.73
  },
  {
    "#": "79 Aspinwall Ave (153-12-00)",
    "$": 2366600,
    "address": "79 Aspinwall Ave",
    "parcel_id": "153-12-00",
    "owner1": "WYLAN TRS, LOUISE M",
    "owner2": "SCARBOROUGH, JANE L",
    "current_taxes": 24233.98,
    "new_taxes_no_override": 25280.89,
    "override_total_1": 25998.21,
    "override_increase_1": 717.33
  },
  {
    "#": "89 Aspinwall Ave (153-13-00)",
    "$": 2422000,
    "address": "89 Aspinwall Ave",
    "parcel_id": "153-13-00",
    "owner1": "BARMACH, JESSICA COHEN & JEFFREY",
    "owner2": "",
    "current_taxes": 21166.35,
    "new_taxes_no_override": 22080.74,
    "override_total_1": 22707.26,
    "override_increase_1": 626.52
  },
  {
    "#": "97 Aspinwall Ave (153-14-00)",
    "$": 2386100,
    "address": "97 Aspinwall Ave",
    "parcel_id": "153-14-00",
    "owner1": "BHAMBI, TRS, HARISH K & MEENA",
    "owner2": "",
    "current_taxes": 20798.73,
    "new_taxes_no_override": 21697.24,
    "override_total_1": 22312.88,
    "override_increase_1": 615.64
  },
  {
    "#": "104 Aspinwall Ave (132-02-00)",
    "$": 8960700,
    "address": "104 Aspinwall Ave",
    "parcel_id": "132-02-00",
    "owner1": "ST PAULS EPISCOPAL CHURCH",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "123 Aspinwall Ave (153-17-00)",
    "$": 2535200,
    "address": "123 Aspinwall Ave",
    "parcel_id": "153-17-00",
    "owner1": "BLUMSTEIN TRS, STEVEN R & MONA R",
    "owner2": "",
    "current_taxes": 22325.51,
    "new_taxes_no_override": 23289.97,
    "override_total_1": 23950.81,
    "override_increase_1": 660.84
  },
  {
    "#": "130 Aspinwall Ave (132-01-00)",
    "$": 3877200,
    "address": "130 Aspinwall Ave",
    "parcel_id": "132-01-00",
    "owner1": "ST PAULS EPISCOPAL CHURCH",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "135 Aspinwall Ave (153-18-00)",
    "$": 2509000,
    "address": "135 Aspinwall Ave",
    "parcel_id": "153-18-00",
    "owner1": "YOUNG TRS, G OLIVER IV",
    "owner2": "COHEN, SALLY M",
    "current_taxes": 22057.23,
    "new_taxes_no_override": 23010.1,
    "override_total_1": 23663.0,
    "override_increase_1": 652.89
  },
  {
    "#": "145 Aspinwall Ave (152-10-00)",
    "$": 2188000,
    "address": "145 Aspinwall Ave",
    "parcel_id": "152-10-00",
    "owner1": "CLARKE, JANET B",
    "owner2": "SELL, RAINER",
    "current_taxes": 18770.19,
    "new_taxes_no_override": 19581.06,
    "override_total_1": 20136.66,
    "override_increase_1": 555.6
  },
  {
    "#": "150 Aspinwall Ave (131-05-00)",
    "$": 1571800,
    "address": "150 Aspinwall Ave",
    "parcel_id": "131-05-00",
    "owner1": "CAZORT, TR, VIRGINIA",
    "owner2": "",
    "current_taxes": 12460.3,
    "new_taxes_no_override": 12998.58,
    "override_total_1": 13367.41,
    "override_increase_1": 368.82
  },
  {
    "#": "152 Aspinwall Ave (131-04-00)",
    "$": 2636000,
    "address": "152 Aspinwall Ave",
    "parcel_id": "131-04-00",
    "owner1": "ISHIBASHI, YASUKO",
    "owner2": "HICKEY, TIMOTHY J",
    "current_taxes": 23357.71,
    "new_taxes_no_override": 24366.76,
    "override_total_1": 25058.15,
    "override_increase_1": 691.39
  },
  {
    "#": "155 Aspinwall Ave (152-11-00)",
    "$": 2533400,
    "address": "155 Aspinwall Ave",
    "parcel_id": "152-11-00",
    "owner1": "WHITAKER, JOHN S",
    "owner2": "BUECHNER, BARBARA L",
    "current_taxes": 22307.08,
    "new_taxes_no_override": 23270.75,
    "override_total_1": 23931.04,
    "override_increase_1": 660.29
  },
  {
    "#": "157 Aspinwall Ave (152-12-00)",
    "$": 2829500,
    "address": "157 Aspinwall Ave",
    "parcel_id": "152-12-00",
    "owner1": "GANNON, STEPHEN ANDREW & KELLY MARIE",
    "owner2": "",
    "current_taxes": 28974.08,
    "new_taxes_no_override": 30225.76,
    "override_total_1": 31083.39,
    "override_increase_1": 857.63
  },
  {
    "#": "159 Aspinwall Ave, Unit 1 (152-13-01)",
    "$": 3489400,
    "address": "159 Aspinwall Ave, Unit 1",
    "parcel_id": "152-13-01",
    "owner1": "SMITH, JILL",
    "owner2": "",
    "current_taxes": 35731.46,
    "new_taxes_no_override": 37275.06,
    "override_total_1": 38332.71,
    "override_increase_1": 1057.65
  },
  {
    "#": "159 Aspinwall Ave, Unit 2 (152-13-02)",
    "$": 3359000,
    "address": "159 Aspinwall Ave, Unit 2",
    "parcel_id": "152-13-02",
    "owner1": "YOUNG, DONALD ROBERT & CAROLINE C",
    "owner2": "",
    "current_taxes": 34396.16,
    "new_taxes_no_override": 35882.07,
    "override_total_1": 36900.2,
    "override_increase_1": 1018.13
  },
  {
    "#": "160 Aspinwall Ave, Unit 1 (131-03-01)",
    "$": 1439000,
    "address": "160 Aspinwall Ave, Unit 1",
    "parcel_id": "131-03-01",
    "owner1": "MORSE, CECILY & ALAN",
    "owner2": "",
    "current_taxes": 11100.43,
    "new_taxes_no_override": 11579.97,
    "override_total_1": 11908.54,
    "override_increase_1": 328.57
  },
  {
    "#": "160 Aspinwall Ave, Unit 2 (131-03-02)",
    "$": 1457500,
    "address": "160 Aspinwall Ave, Unit 2",
    "parcel_id": "131-03-02",
    "owner1": "STEINFIELD, REBECCA MORSE & FRANK",
    "owner2": "",
    "current_taxes": 11289.87,
    "new_taxes_no_override": 11777.59,
    "override_total_1": 12111.77,
    "override_increase_1": 334.18
  },
  {
    "#": "162 Aspinwall Ave (131-02-00)",
    "$": 2622800,
    "address": "162 Aspinwall Ave",
    "parcel_id": "131-02-00",
    "owner1": "RUBERG, FREDERICK L",
    "owner2": "POLLOCK, NIRA",
    "current_taxes": 23222.54,
    "new_taxes_no_override": 24225.75,
    "override_total_1": 24913.14,
    "override_increase_1": 687.39
  },
  {
    "#": "165 Aspinwall Ave (152-14-00)",
    "$": 2048900,
    "address": "165 Aspinwall Ave",
    "parcel_id": "152-14-00",
    "owner1": "BOYD, ANNA M",
    "owner2": "",
    "current_taxes": 20980.74,
    "new_taxes_no_override": 21887.11,
    "override_total_1": 22508.14,
    "override_increase_1": 621.03
  },
  {
    "#": "168 Aspinwall Ave (131-01-00)",
    "$": 1991300,
    "address": "168 Aspinwall Ave",
    "parcel_id": "131-01-00",
    "owner1": "HOEY TRS, RONALD Y & VIVIEN M",
    "owner2": "",
    "current_taxes": 16755.98,
    "new_taxes_no_override": 17479.84,
    "override_total_1": 17975.82,
    "override_increase_1": 495.98
  },
  {
    "#": "172 Aspinwall Ave, Unit 1 (130-02-01)",
    "$": 1620800,
    "address": "172 Aspinwall Ave, Unit 1",
    "parcel_id": "130-02-01",
    "owner1": "LACEY, BRIAN E & JOAN C",
    "owner2": "",
    "current_taxes": 12962.06,
    "new_taxes_no_override": 13522.02,
    "override_total_1": 13905.7,
    "override_increase_1": 383.68
  },
  {
    "#": "172 Aspinwall Ave, Unit 2 (130-02-02)",
    "$": 865400,
    "address": "172 Aspinwall Ave, Unit 2",
    "parcel_id": "130-02-02",
    "owner1": "NORTH, JASON & KRYSTEN",
    "owner2": "",
    "current_taxes": 5226.76,
    "new_taxes_no_override": 5452.56,
    "override_total_1": 5607.27,
    "override_increase_1": 154.71
  },
  {
    "#": "177 Aspinwall Ave (144-14-00)",
    "$": 2117700,
    "address": "177 Aspinwall Ave",
    "parcel_id": "144-14-00",
    "owner1": "BROWDER, ELIZABETH T",
    "owner2": "",
    "current_taxes": 18050.31,
    "new_taxes_no_override": 18830.08,
    "override_total_1": 19364.37,
    "override_increase_1": 534.29
  },
  {
    "#": "179 Aspinwall Ave (144-15-00)",
    "$": 2186600,
    "address": "179 Aspinwall Ave",
    "parcel_id": "144-15-00",
    "owner1": "BOEHS, SARAH T & JOHN H JR",
    "owner2": "",
    "current_taxes": 18755.85,
    "new_taxes_no_override": 19566.1,
    "override_total_1": 20121.28,
    "override_increase_1": 555.17
  },
  {
    "#": "183 Aspinwall Ave (144-16-00)",
    "$": 2587700,
    "address": "183 Aspinwall Ave",
    "parcel_id": "144-16-00",
    "owner1": "STERN, BENJAMIN M & KAREN QUEEN",
    "owner2": "",
    "current_taxes": 22863.11,
    "new_taxes_no_override": 23850.8,
    "override_total_1": 24527.54,
    "override_increase_1": 676.75
  },
  {
    "#": "184 Aspinwall Ave (130-01-00)",
    "$": 2414900,
    "address": "184 Aspinwall Ave",
    "parcel_id": "130-01-00",
    "owner1": "RODDY, TR, CAROLE A",
    "owner2": "",
    "current_taxes": 21093.64,
    "new_taxes_no_override": 22004.89,
    "override_total_1": 22629.26,
    "override_increase_1": 624.37
  },
  {
    "#": "189 Aspinwall Ave (144-17-00)",
    "$": 2864200,
    "address": "189 Aspinwall Ave",
    "parcel_id": "144-17-00",
    "owner1": "GILSON, STUART C & SUSAN E",
    "owner2": "",
    "current_taxes": 25694.47,
    "new_taxes_no_override": 26804.47,
    "override_total_1": 27565.03,
    "override_increase_1": 760.56
  },
  {
    "#": "193 Aspinwall Ave (144-18-00)",
    "$": 1823100,
    "address": "193 Aspinwall Ave",
    "parcel_id": "144-18-00",
    "owner1": "HARRISON TR, KATHLEEN",
    "owner2": "",
    "current_taxes": 15033.61,
    "new_taxes_no_override": 15683.06,
    "override_total_1": 16128.06,
    "override_increase_1": 444.99
  },
  {
    "#": "194 Aspinwall Ave (128-18-00)",
    "$": 3031200,
    "address": "194 Aspinwall Ave",
    "parcel_id": "128-18-00",
    "owner1": "MAHONEY TRS, JENNIFER A & SCOTT J",
    "owner2": "",
    "current_taxes": 27404.55,
    "new_taxes_no_override": 28588.43,
    "override_total_1": 29399.6,
    "override_increase_1": 811.17
  },
  {
    "#": "198 Aspinwall Ave (128-17-00)",
    "$": 1877800,
    "address": "198 Aspinwall Ave",
    "parcel_id": "128-17-00",
    "owner1": "BARAM, YAAKOV",
    "owner2": "ASHER, IRVING",
    "current_taxes": 15593.74,
    "new_taxes_no_override": 16267.39,
    "override_total_1": 16728.96,
    "override_increase_1": 461.57
  },
  {
    "#": "199 Aspinwall Ave (144-19-00)",
    "$": 1921600,
    "address": "199 Aspinwall Ave",
    "parcel_id": "144-19-00",
    "owner1": "BAIN TRS, JOHN T & KAREN  N & ROBERT  N",
    "owner2": "",
    "current_taxes": 16042.25,
    "new_taxes_no_override": 16735.28,
    "override_total_1": 17210.13,
    "override_increase_1": 474.85
  },
  {
    "#": "203 Aspinwall Ave (144-20-00)",
    "$": 2186300,
    "address": "203 Aspinwall Ave",
    "parcel_id": "144-20-00",
    "owner1": "WILCOXSON, JAREN D & ERICA",
    "owner2": "",
    "current_taxes": 18752.78,
    "new_taxes_no_override": 19562.9,
    "override_total_1": 20117.98,
    "override_increase_1": 555.08
  },
  {
    "#": "204 Aspinwall Ave (128-16-00)",
    "$": 3473700,
    "address": "204 Aspinwall Ave",
    "parcel_id": "128-16-00",
    "owner1": "LIN, NINA",
    "owner2": "BEROUKHIM, RAMEEN",
    "current_taxes": 31935.75,
    "new_taxes_no_override": 33315.37,
    "override_total_1": 34260.67,
    "override_increase_1": 945.3
  },
  {
    "#": "206 Aspinwall Ave, Unit 1 (128-15-07)",
    "$": 1269100,
    "address": "206 Aspinwall Ave, Unit 1",
    "parcel_id": "128-15-07",
    "owner1": "SURESH, SHRUTHI",
    "owner2": "",
    "current_taxes": 12995.58,
    "new_taxes_no_override": 13556.99,
    "override_total_1": 13941.66,
    "override_increase_1": 384.67
  },
  {
    "#": "206 Aspinwall Ave, Unit 2 (128-15-08)",
    "$": 1291000,
    "address": "206 Aspinwall Ave, Unit 2",
    "parcel_id": "128-15-08",
    "owner1": "BOLOTNICK, TRACEY",
    "owner2": "SEAVER, ROBERT",
    "current_taxes": 9584.91,
    "new_taxes_no_override": 9998.98,
    "override_total_1": 10282.69,
    "override_increase_1": 283.71
  },
  {
    "#": "207 Aspinwall Ave (144-21-00)",
    "$": 3110400,
    "address": "207 Aspinwall Ave",
    "parcel_id": "144-21-00",
    "owner1": "LUDWIG, DAVID S & DAWN P",
    "owner2": "",
    "current_taxes": 28215.56,
    "new_taxes_no_override": 29434.47,
    "override_total_1": 30269.65,
    "override_increase_1": 835.18
  },
  {
    "#": "208 Aspinwall Ave, Unit A & P1 & 2 (128-15-02)",
    "$": 1472000,
    "address": "208 Aspinwall Ave, Unit A & P1 & 2",
    "parcel_id": "128-15-02",
    "owner1": "CHIONGBIAN, WESLEY PAUL & LAURICE ALAAN",
    "owner2": "",
    "current_taxes": 11438.35,
    "new_taxes_no_override": 11932.49,
    "override_total_1": 12271.06,
    "override_increase_1": 338.58
  },
  {
    "#": "208 Aspinwall Ave, Unit B & P3-4-5 (128-15-03)",
    "$": 1439100,
    "address": "208 Aspinwall Ave, Unit B & P3-4-5",
    "parcel_id": "128-15-03",
    "owner1": "BLANEY TRS, SHAWN A",
    "owner2": "CIBIRIAIN, MERCEDES PETIT",
    "current_taxes": 11101.45,
    "new_taxes_no_override": 11581.03,
    "override_total_1": 11909.64,
    "override_increase_1": 328.6
  },
  {
    "#": "209 Aspinwall Ave (144-21-01)",
    "$": 1796800,
    "address": "209 Aspinwall Ave",
    "parcel_id": "144-21-01",
    "owner1": "DU, LINA",
    "owner2": "XIE, GEORGE G",
    "current_taxes": 18399.23,
    "new_taxes_no_override": 19194.08,
    "override_total_1": 19738.69,
    "override_increase_1": 544.62
  },
  {
    "#": "212 Aspinwall Ave (128-14-00)",
    "$": 3349800,
    "address": "212 Aspinwall Ave",
    "parcel_id": "128-14-00",
    "owner1": "PENINSULA HOME BUILDERS INC",
    "owner2": "",
    "current_taxes": 34301.95,
    "new_taxes_no_override": 35783.79,
    "override_total_1": 36799.13,
    "override_increase_1": 1015.34
  },
  {
    "#": "213 Aspinwall Ave (144-22-00)",
    "$": 2677300,
    "address": "213 Aspinwall Ave",
    "parcel_id": "144-22-00",
    "owner1": "CROTEAU, RYAN",
    "owner2": "BUDDE, PRIYA PRAKASH",
    "current_taxes": 27415.55,
    "new_taxes_no_override": 28599.9,
    "override_total_1": 29411.4,
    "override_increase_1": 811.5
  },
  {
    "#": "219 Aspinwall Ave (144-23-00)",
    "$": 2901500,
    "address": "219 Aspinwall Ave",
    "parcel_id": "144-23-00",
    "owner1": "CHAO, JENNIFER J",
    "owner2": "LERNER, MICHAEL",
    "current_taxes": 26076.43,
    "new_taxes_no_override": 27202.93,
    "override_total_1": 27974.79,
    "override_increase_1": 771.86
  },
  {
    "#": "220 Aspinwall Ave (128-13-00)",
    "$": 3296500,
    "address": "220 Aspinwall Ave",
    "parcel_id": "128-13-00",
    "owner1": "OLOFSON TR, HAYES S",
    "owner2": "",
    "current_taxes": 30121.23,
    "new_taxes_no_override": 31422.47,
    "override_total_1": 32314.06,
    "override_increase_1": 891.59
  },
  {
    "#": "223 Aspinwall Ave (144-24-00)",
    "$": 2604100,
    "address": "223 Aspinwall Ave",
    "parcel_id": "144-24-00",
    "owner1": "SCHNEIDER, DANIEL",
    "owner2": "KRIER, LAURA",
    "current_taxes": 23031.05,
    "new_taxes_no_override": 24025.99,
    "override_total_1": 24707.71,
    "override_increase_1": 681.72
  },
  {
    "#": "224 Aspinwall Ave (128-12-00)",
    "$": 3206200,
    "address": "224 Aspinwall Ave",
    "parcel_id": "128-12-00",
    "owner1": "CODY TRS, STEPHEN SMITH",
    "owner2": "BECK, AMANDA HUDSON",
    "current_taxes": 32831.49,
    "new_taxes_no_override": 34249.81,
    "override_total_1": 35221.62,
    "override_increase_1": 971.81
  },
  {
    "#": "227 Aspinwall Ave (144-25-00)",
    "$": 2868200,
    "address": "227 Aspinwall Ave",
    "parcel_id": "144-25-00",
    "owner1": "OLSSON, MEGHAN & JONATHAN",
    "owner2": "",
    "current_taxes": 25735.43,
    "new_taxes_no_override": 26847.2,
    "override_total_1": 27608.97,
    "override_increase_1": 761.77
  },
  {
    "#": "232 Aspinwall Ave, Unit 1 (127-20-01)",
    "$": 1204000,
    "address": "232 Aspinwall Ave, Unit 1",
    "parcel_id": "127-20-01",
    "owner1": "HARTMANN, TILL SEBASTIAN & ANNA HELENE",
    "owner2": "",
    "current_taxes": 12328.96,
    "new_taxes_no_override": 12861.57,
    "override_total_1": 13226.51,
    "override_increase_1": 364.94
  },
  {
    "#": "232 Aspinwall Ave, Unit 2 (127-20-02)",
    "$": 1479200,
    "address": "232 Aspinwall Ave, Unit 2",
    "parcel_id": "127-20-02",
    "owner1": "PARK, EDMUND & KIM",
    "owner2": "",
    "current_taxes": 11512.07,
    "new_taxes_no_override": 12009.39,
    "override_total_1": 12350.15,
    "override_increase_1": 340.76
  },
  {
    "#": "233 Aspinwall Ave (143-06-00)",
    "$": 2500500,
    "address": "233 Aspinwall Ave",
    "parcel_id": "143-06-00",
    "owner1": "BAIN, TRS, JOHN T & A FLORIS",
    "owner2": "",
    "current_taxes": 28182.2,
    "new_taxes_no_override": 29399.67,
    "override_total_1": 30233.86,
    "override_increase_1": 834.19
  },
  {
    "#": "240 Aspinwall Ave (133-07-00)",
    "$": 1588500,
    "address": "240 Aspinwall Ave",
    "parcel_id": "133-07-00",
    "owner1": "WILSON, JOSEPHINE",
    "owner2": "LASCALEIA, MICHAEL",
    "current_taxes": 12631.31,
    "new_taxes_no_override": 13176.98,
    "override_total_1": 13550.87,
    "override_increase_1": 373.89
  },
  {
    "#": "252 Aspinwall Ave (134-17-00)",
    "$": 2068800,
    "address": "252 Aspinwall Ave",
    "parcel_id": "134-17-00",
    "owner1": "252 ASPINWALL LLC",
    "owner2": "",
    "current_taxes": 21184.51,
    "new_taxes_no_override": 22099.68,
    "override_total_1": 22726.74,
    "override_increase_1": 627.06
  },
  {
    "#": "256 Aspinwall Ave (134-16-00)",
    "$": 2389600,
    "address": "256 Aspinwall Ave",
    "parcel_id": "134-16-00",
    "owner1": "256 ASPINWALL LLC",
    "owner2": "",
    "current_taxes": 24469.5,
    "new_taxes_no_override": 25526.58,
    "override_total_1": 26250.88,
    "override_increase_1": 724.3
  },
  {
    "#": "260 Aspinwall Ave (134-15-00)",
    "$": 2295200,
    "address": "260 Aspinwall Ave",
    "parcel_id": "134-15-00",
    "owner1": "PUSHAK, LUDMILA & SVETLANA",
    "owner2": "",
    "current_taxes": 23502.85,
    "new_taxes_no_override": 24518.17,
    "override_total_1": 25213.86,
    "override_increase_1": 695.68
  },
  {
    "#": "5 Aston Rd (419B-15-00)",
    "$": 3103400,
    "address": "5 Aston Rd",
    "parcel_id": "419B-15-00",
    "owner1": "BOUDREAU, EDWARD G & STEFFANI J",
    "owner2": "",
    "current_taxes": 28143.88,
    "new_taxes_no_override": 29359.7,
    "override_total_1": 30192.75,
    "override_increase_1": 833.06
  },
  {
    "#": "8 Aston Rd (419A-06-00)",
    "$": 3992800,
    "address": "8 Aston Rd",
    "parcel_id": "419A-06-00",
    "owner1": "XIAO, QIANG JACK",
    "owner2": "LI, YU",
    "current_taxes": 40886.27,
    "new_taxes_no_override": 42652.56,
    "override_total_1": 43862.79,
    "override_increase_1": 1210.23
  },
  {
    "#": "13 Aston Rd (419B-14-01)",
    "$": 148700,
    "address": "13 Aston Rd",
    "parcel_id": "419B-14-01",
    "owner1": "BERGER TR, BARRY M",
    "owner2": "",
    "current_taxes": 1522.69,
    "new_taxes_no_override": 1588.47,
    "override_total_1": 1633.54,
    "override_increase_1": 45.07
  },
  {
    "#": "15 Aston Rd (419B-14-00)",
    "$": 3949600,
    "address": "15 Aston Rd",
    "parcel_id": "419B-14-00",
    "owner1": "KAY, JONATHAN B & LINDA SLOANE",
    "owner2": "",
    "current_taxes": 36808.97,
    "new_taxes_no_override": 38399.12,
    "override_total_1": 39488.66,
    "override_increase_1": 1089.55
  },
  {
    "#": "25 Aston Rd (419B-13-00)",
    "$": 4530500,
    "address": "25 Aston Rd",
    "parcel_id": "419B-13-00",
    "owner1": "HU, YEJUAN",
    "owner2": "",
    "current_taxes": 46392.32,
    "new_taxes_no_override": 48396.47,
    "override_total_1": 49769.68,
    "override_increase_1": 1373.21
  },
  {
    "#": "30 Aston Rd (419A-07-00)",
    "$": 4582800,
    "address": "30 Aston Rd",
    "parcel_id": "419A-07-00",
    "owner1": "CHESTNUT HILL HOUSE LLC",
    "owner2": "",
    "current_taxes": 46927.87,
    "new_taxes_no_override": 48955.15,
    "override_total_1": 50344.22,
    "override_increase_1": 1389.06
  },
  {
    "#": "37 Aston Rd (419B-12-00)",
    "$": 5578500,
    "address": "37 Aston Rd",
    "parcel_id": "419B-12-00",
    "owner1": "DRUCKER, AMY A",
    "owner2": "",
    "current_taxes": 53488.91,
    "new_taxes_no_override": 55799.63,
    "override_total_1": 57382.9,
    "override_increase_1": 1583.27
  },
  {
    "#": "40 Aston Rd (419A-08-00)",
    "$": 2973400,
    "address": "40 Aston Rd",
    "parcel_id": "419A-08-00",
    "owner1": "FINK, ROSALIE P",
    "owner2": "",
    "current_taxes": 26812.68,
    "new_taxes_no_override": 27970.99,
    "override_total_1": 28764.64,
    "override_increase_1": 793.66
  },
  {
    "#": "7 Atherton Rd (084-13-00)",
    "$": 2009300,
    "address": "7 Atherton Rd",
    "parcel_id": "084-13-00",
    "owner1": "CHOW TR, JOHN J",
    "owner2": "",
    "current_taxes": 20575.23,
    "new_taxes_no_override": 21464.08,
    "override_total_1": 22073.11,
    "override_increase_1": 609.03
  },
  {
    "#": "11 Atherton Rd, Unit 1 & P2 (084-14-01)",
    "$": 1480800,
    "address": "11 Atherton Rd, Unit 1 & P2",
    "parcel_id": "084-14-01",
    "owner1": "RICCIO, ANTONIO",
    "owner2": "DE RIENZO, ASSUNTA",
    "current_taxes": 11528.46,
    "new_taxes_no_override": 12026.49,
    "override_total_1": 12367.73,
    "override_increase_1": 341.24
  },
  {
    "#": "11 Atherton Rd, Unit 2&G1 & 2 (084-14-02)",
    "$": 1350500,
    "address": "11 Atherton Rd, Unit 2&G1 & 2",
    "parcel_id": "084-14-02",
    "owner1": "PALCHICK, BORIS",
    "owner2": "OZERNOV-PALCHIK, OLA",
    "current_taxes": 10194.19,
    "new_taxes_no_override": 10634.58,
    "override_total_1": 10936.33,
    "override_increase_1": 301.75
  },
  {
    "#": "11 Atherton Rd, Unit P1 (084-14-03)",
    "$": 49000,
    "address": "11 Atherton Rd, Unit P1",
    "parcel_id": "084-14-03",
    "owner1": "RICCIO, ANTONIO",
    "owner2": "DERIENZO, ASSUNTA",
    "current_taxes": 501.76,
    "new_taxes_no_override": 523.44,
    "override_total_1": 538.29,
    "override_increase_1": 14.85
  },
  {
    "#": "11 Atherton Rd, Unit P3 (084-14-04)",
    "$": 49000,
    "address": "11 Atherton Rd, Unit P3",
    "parcel_id": "084-14-04",
    "owner1": "RICCIO, ANTONIO",
    "owner2": "DE RIENZO, ASSUNTA",
    "current_taxes": 501.76,
    "new_taxes_no_override": 523.44,
    "override_total_1": 538.29,
    "override_increase_1": 14.85
  },
  {
    "#": "11 Atherton Rd, Unit P4 (084-14-05)",
    "$": 49000,
    "address": "11 Atherton Rd, Unit P4",
    "parcel_id": "084-14-05",
    "owner1": "ABEZGAUZ, VLADIMIR",
    "owner2": "TSYVINA, YELENA",
    "current_taxes": 501.76,
    "new_taxes_no_override": 523.44,
    "override_total_1": 538.29,
    "override_increase_1": 14.85
  },
  {
    "#": "15 Atherton Rd (084-15-00)",
    "$": 1951100,
    "address": "15 Atherton Rd",
    "parcel_id": "084-15-00",
    "owner1": "LOUIE TRS, KWOK J",
    "owner2": "",
    "current_taxes": 16344.33,
    "new_taxes_no_override": 17050.41,
    "override_total_1": 17534.2,
    "override_increase_1": 483.79
  },
  {
    "#": "17 Atherton Rd (084-16-00)",
    "$": 2174900,
    "address": "17 Atherton Rd",
    "parcel_id": "084-16-00",
    "owner1": "REIDT, PAUL",
    "owner2": "MANASEVIT, KIM",
    "current_taxes": 18636.04,
    "new_taxes_no_override": 19441.12,
    "override_total_1": 19992.74,
    "override_increase_1": 551.63
  },
  {
    "#": "18 Atherton Rd (085-48-00)",
    "$": 2412400,
    "address": "18 Atherton Rd",
    "parcel_id": "085-48-00",
    "owner1": "PUA, MENG H",
    "owner2": "CHEUNG, HONG CHEN",
    "current_taxes": 24702.98,
    "new_taxes_no_override": 25770.15,
    "override_total_1": 26501.36,
    "override_increase_1": 731.21
  },
  {
    "#": "21 Atherton Rd (084-17-00)",
    "$": 3050100,
    "address": "21 Atherton Rd",
    "parcel_id": "084-17-00",
    "owner1": "CHU-MOYER TRS, MARGARET Y",
    "owner2": "MOYER, MIKEL P",
    "current_taxes": 27598.09,
    "new_taxes_no_override": 28790.33,
    "override_total_1": 29607.23,
    "override_increase_1": 816.9
  },
  {
    "#": "22 Atherton Rd, Unit 1 (085-47-01)",
    "$": 1842800,
    "address": "22 Atherton Rd, Unit 1",
    "parcel_id": "085-47-01",
    "owner1": "FRAVEL, MARIS TAYLOR & ANNA M",
    "owner2": "",
    "current_taxes": 15235.34,
    "new_taxes_no_override": 15893.51,
    "override_total_1": 16344.47,
    "override_increase_1": 450.97
  },
  {
    "#": "22 Atherton Rd, Unit 2 (085-47-02)",
    "$": 2294000,
    "address": "22 Atherton Rd, Unit 2",
    "parcel_id": "085-47-02",
    "owner1": "NARANG, VIPIN",
    "owner2": "AIYAR, SANA",
    "current_taxes": 23490.56,
    "new_taxes_no_override": 24505.35,
    "override_total_1": 25200.67,
    "override_increase_1": 695.32
  },
  {
    "#": "28 Atherton Rd (085-46-00)",
    "$": 2405600,
    "address": "28 Atherton Rd",
    "parcel_id": "085-46-00",
    "owner1": "28 ATHERTON ROAD LLC",
    "owner2": "",
    "current_taxes": 24633.34,
    "new_taxes_no_override": 25697.5,
    "override_total_1": 26426.65,
    "override_increase_1": 729.15
  },
  {
    "#": "32 Atherton Rd (085-45-00)",
    "$": 2909900,
    "address": "32 Atherton Rd",
    "parcel_id": "085-45-00",
    "owner1": "MITRANO TRS, JAMES L & LAURA P",
    "owner2": "",
    "current_taxes": 29797.38,
    "new_taxes_no_override": 31084.63,
    "override_total_1": 31966.63,
    "override_increase_1": 882.0
  },
  {
    "#": "36 Atherton Rd, Unit 1 (085-44-01)",
    "$": 1266900,
    "address": "36 Atherton Rd, Unit 1",
    "parcel_id": "085-44-01",
    "owner1": "GOLAN, YOAV & ANAT",
    "owner2": "",
    "current_taxes": 9338.12,
    "new_taxes_no_override": 9741.53,
    "override_total_1": 10017.94,
    "override_increase_1": 276.41
  },
  {
    "#": "36 Atherton Rd, Unit 2 (085-44-02)",
    "$": 1347700,
    "address": "36 Atherton Rd, Unit 2",
    "parcel_id": "085-44-02",
    "owner1": "MILLER TRS, PETER B & KAREN B",
    "owner2": "",
    "current_taxes": 10165.51,
    "new_taxes_no_override": 10604.66,
    "override_total_1": 10905.56,
    "override_increase_1": 300.9
  },
  {
    "#": "40 Atherton Rd (085-43-00)",
    "$": 2579600,
    "address": "40 Atherton Rd",
    "parcel_id": "085-43-00",
    "owner1": "CODDON, JONATHAN",
    "owner2": "",
    "current_taxes": 26415.1,
    "new_taxes_no_override": 27556.23,
    "override_total_1": 28338.12,
    "override_increase_1": 781.89
  },
  {
    "#": "44 Atherton Rd, Unit 1 & Gar A (085-42-01)",
    "$": 1718800,
    "address": "44 Atherton Rd, Unit 1 & Gar A",
    "parcel_id": "085-42-01",
    "owner1": "HARTMANN, NADINE L & PHILIP J",
    "owner2": "",
    "current_taxes": 13965.58,
    "new_taxes_no_override": 14568.89,
    "override_total_1": 14982.27,
    "override_increase_1": 413.38
  },
  {
    "#": "44 Atherton Rd, Unit 2 & Gar B (085-42-02)",
    "$": 1929600,
    "address": "44 Atherton Rd, Unit 2 & Gar B",
    "parcel_id": "085-42-02",
    "owner1": "MORI, SIMONE",
    "owner2": "BRAMBATTI, MICHELA",
    "current_taxes": 16124.17,
    "new_taxes_no_override": 16820.73,
    "override_total_1": 17298.01,
    "override_increase_1": 477.28
  },
  {
    "#": "45 Atherton Rd (084-28-01)",
    "$": 2828800,
    "address": "45 Atherton Rd",
    "parcel_id": "084-28-01",
    "owner1": "ADRIANZEN, ERNESTO U & FABIOLA",
    "owner2": "",
    "current_taxes": 28966.91,
    "new_taxes_no_override": 30218.28,
    "override_total_1": 31075.7,
    "override_increase_1": 857.42
  },
  {
    "#": "48 Atherton Rd (085-41-00)",
    "$": 1913100,
    "address": "48 Atherton Rd",
    "parcel_id": "085-41-00",
    "owner1": "48 ATHERTON LLC",
    "owner2": "",
    "current_taxes": 19590.14,
    "new_taxes_no_override": 20436.43,
    "override_total_1": 21016.3,
    "override_increase_1": 579.87
  },
  {
    "#": "50 Atherton Rd (085-40-00)",
    "$": 1376100,
    "address": "50 Atherton Rd",
    "parcel_id": "085-40-00",
    "owner1": "SAITTA, PAUL G",
    "owner2": "SAITTA-RINGGER, DEBORAH J",
    "current_taxes": 14091.26,
    "new_taxes_no_override": 14700.0,
    "override_total_1": 15117.1,
    "override_increase_1": 417.1
  },
  {
    "#": "53 Atherton Rd (084-26-01)",
    "$": 494300,
    "address": "53 Atherton Rd",
    "parcel_id": "084-26-01",
    "owner1": "SANDER, MARCEL & DANIEL",
    "owner2": "",
    "current_taxes": 5061.63,
    "new_taxes_no_override": 5280.29,
    "override_total_1": 5430.12,
    "override_increase_1": 149.82
  },
  {
    "#": "54 Atherton Rd (085-39-00)",
    "$": 1948400,
    "address": "54 Atherton Rd",
    "parcel_id": "085-39-00",
    "owner1": "SOTO TR, KENNETH L",
    "owner2": "",
    "current_taxes": 19951.62,
    "new_taxes_no_override": 20813.53,
    "override_total_1": 21404.1,
    "override_increase_1": 590.57
  },
  {
    "#": "58 Atherton Rd (085-38-00)",
    "$": 2051400,
    "address": "58 Atherton Rd",
    "parcel_id": "085-38-00",
    "owner1": "POURATI, EBRAHIM & FLORA G",
    "owner2": "",
    "current_taxes": 21006.34,
    "new_taxes_no_override": 21913.81,
    "override_total_1": 22535.6,
    "override_increase_1": 621.79
  },
  {
    "#": "61 Atherton Rd (084-18-00)",
    "$": 2229100,
    "address": "61 Atherton Rd",
    "parcel_id": "084-18-00",
    "owner1": "MILLER TR, DEBORAH M",
    "owner2": "",
    "current_taxes": 19191.05,
    "new_taxes_no_override": 20020.1,
    "override_total_1": 20588.16,
    "override_increase_1": 568.06
  },
  {
    "#": "62 Atherton Rd, Unit 1 (085-37-01)",
    "$": 1081800,
    "address": "62 Atherton Rd, Unit 1",
    "parcel_id": "085-37-01",
    "owner1": "PECI, ERION",
    "owner2": "JHA, RAJANI",
    "current_taxes": 11077.63,
    "new_taxes_no_override": 11556.18,
    "override_total_1": 11884.08,
    "override_increase_1": 327.9
  },
  {
    "#": "62 Atherton Rd (085-37-02)",
    "$": 1871200,
    "address": "62 Atherton Rd",
    "parcel_id": "085-37-02",
    "owner1": "AERTS, HUGO J W",
    "owner2": "PREVOO, DESIRE M",
    "current_taxes": 15526.15,
    "new_taxes_no_override": 16196.88,
    "override_total_1": 16656.45,
    "override_increase_1": 459.57
  },
  {
    "#": "65 Atherton Rd (084-19-00)",
    "$": 2358800,
    "address": "65 Atherton Rd",
    "parcel_id": "084-19-00",
    "owner1": "GORDON TRS, BETH B & ROBERT H",
    "owner2": "",
    "current_taxes": 20519.18,
    "new_taxes_no_override": 21405.61,
    "override_total_1": 22012.98,
    "override_increase_1": 607.37
  },
  {
    "#": "66 Atherton Rd, Unit 1 (085-36-01)",
    "$": 1059000,
    "address": "66 Atherton Rd, Unit 1",
    "parcel_id": "085-36-01",
    "owner1": "MARIANO, AARON & BECKY G",
    "owner2": "",
    "current_taxes": 10844.16,
    "new_taxes_no_override": 11312.63,
    "override_total_1": 11633.61,
    "override_increase_1": 320.99
  },
  {
    "#": "66 Atherton Rd, Unit 2 (085-36-02)",
    "$": 1280900,
    "address": "66 Atherton Rd, Unit 2",
    "parcel_id": "085-36-02",
    "owner1": "EDELSTEIN ET AL, MICHAEL M",
    "owner2": "LEVY, KAREN B",
    "current_taxes": 9481.48,
    "new_taxes_no_override": 9891.08,
    "override_total_1": 10171.73,
    "override_increase_1": 280.65
  },
  {
    "#": "70 Atherton Rd (085-35-00)",
    "$": 1859600,
    "address": "70 Atherton Rd",
    "parcel_id": "085-35-00",
    "owner1": "SIEGEL, HOWARD P & SHALVA T",
    "owner2": "",
    "current_taxes": 15407.37,
    "new_taxes_no_override": 16072.97,
    "override_total_1": 16529.03,
    "override_increase_1": 456.06
  },
  {
    "#": "76 Atherton Rd (085-34-00)",
    "$": 1971000,
    "address": "76 Atherton Rd",
    "parcel_id": "085-34-00",
    "owner1": "MANDELL, JESSE D",
    "owner2": "DAVIS, SHIRA C",
    "current_taxes": 16548.11,
    "new_taxes_no_override": 17262.99,
    "override_total_1": 17752.81,
    "override_increase_1": 489.82
  },
  {
    "#": "82 Atherton Rd, Unit 1 (085-33-01)",
    "$": 1257200,
    "address": "82 Atherton Rd, Unit 1",
    "parcel_id": "085-33-01",
    "owner1": "DAVIDSON, ADAM L & ARIELLE",
    "owner2": "",
    "current_taxes": 9238.79,
    "new_taxes_no_override": 9637.91,
    "override_total_1": 9911.37,
    "override_increase_1": 273.47
  },
  {
    "#": "82 Atherton Rd, Unit 2 (085-33-02)",
    "$": 1264900,
    "address": "82 Atherton Rd, Unit 2",
    "parcel_id": "085-33-02",
    "owner1": "GRINSTEIN, AMIR & YANA SHECHTERMAN",
    "owner2": "",
    "current_taxes": 9317.64,
    "new_taxes_no_override": 9720.16,
    "override_total_1": 9995.96,
    "override_increase_1": 275.8
  },
  {
    "#": "84 Atherton Rd (085-32-00)",
    "$": 2809400,
    "address": "84 Atherton Rd",
    "parcel_id": "085-32-00",
    "owner1": "84 ATHERTON ROAD LLC",
    "owner2": "",
    "current_taxes": 28768.26,
    "new_taxes_no_override": 30011.05,
    "override_total_1": 30862.59,
    "override_increase_1": 851.54
  },
  {
    "#": "90 Atherton Rd, Unit 1 (085-31-01)",
    "$": 1085500,
    "address": "90 Atherton Rd, Unit 1",
    "parcel_id": "085-31-01",
    "owner1": "PARAS, MARTHA SPENCE MERROW & PETER ANGELO DEJESUS",
    "owner2": "",
    "current_taxes": 7480.59,
    "new_taxes_no_override": 7803.75,
    "override_total_1": 8025.18,
    "override_increase_1": 221.43
  },
  {
    "#": "90 Atherton Rd, Unit 2 (085-31-02)",
    "$": 1343100,
    "address": "90 Atherton Rd, Unit 2",
    "parcel_id": "085-31-02",
    "owner1": "GIRAUD, ISABEL",
    "owner2": "",
    "current_taxes": 10118.41,
    "new_taxes_no_override": 10555.53,
    "override_total_1": 10855.03,
    "override_increase_1": 299.5
  },
  {
    "#": "1 Auburn Ct, Unit 1-1 (170-14-01)",
    "$": 933500,
    "address": "1 Auburn Ct, Unit 1-1",
    "parcel_id": "170-14-01",
    "owner1": "SAJI, NORIKO & MICHAEL",
    "owner2": "",
    "current_taxes": 5924.11,
    "new_taxes_no_override": 6180.03,
    "override_total_1": 6355.39,
    "override_increase_1": 175.35
  },
  {
    "#": "1 Auburn Ct, Unit 2 (170-14-02)",
    "$": 864400,
    "address": "1 Auburn Ct, Unit 2",
    "parcel_id": "170-14-02",
    "owner1": "SHAH, SHRUTI DHIREN",
    "owner2": "DERIPPE, THIBAUD ADRIEN",
    "current_taxes": 5216.52,
    "new_taxes_no_override": 5441.87,
    "override_total_1": 5596.28,
    "override_increase_1": 154.41
  },
  {
    "#": "1 Auburn Ct, Unit 3 (170-14-03)",
    "$": 907300,
    "address": "1 Auburn Ct, Unit 3",
    "parcel_id": "170-14-03",
    "owner1": "CHIARLE, ROBERTO",
    "owner2": "",
    "current_taxes": 5655.82,
    "new_taxes_no_override": 5900.15,
    "override_total_1": 6067.56,
    "override_increase_1": 167.41
  },
  {
    "#": "2 Auburn Ct, Unit 1 (170-14-04)",
    "$": 784900,
    "address": "2 Auburn Ct, Unit 1",
    "parcel_id": "170-14-04",
    "owner1": "LAUTENBACH, A JOANN",
    "owner2": "",
    "current_taxes": 4402.44,
    "new_taxes_no_override": 4592.63,
    "override_total_1": 4722.94,
    "override_increase_1": 130.31
  },
  {
    "#": "2 Auburn Ct, Unit 2 (170-14-05)",
    "$": 790900,
    "address": "2 Auburn Ct, Unit 2",
    "parcel_id": "170-14-05",
    "owner1": "WANG, SHARON XIURONG",
    "owner2": "",
    "current_taxes": 4463.88,
    "new_taxes_no_override": 4656.72,
    "override_total_1": 4788.85,
    "override_increase_1": 132.13
  },
  {
    "#": "2 Auburn Ct, Unit 3 (170-14-06)",
    "$": 843800,
    "address": "2 Auburn Ct, Unit 3",
    "parcel_id": "170-14-06",
    "owner1": "YAO, CAROLYN C",
    "owner2": "",
    "current_taxes": 5005.58,
    "new_taxes_no_override": 5221.82,
    "override_total_1": 5369.99,
    "override_increase_1": 148.17
  },
  {
    "#": "3 Auburn Ct, Unit 1 (170-14-07)",
    "$": 725300,
    "address": "3 Auburn Ct, Unit 1",
    "parcel_id": "170-14-07",
    "owner1": "BLUM TRS, LORI",
    "owner2": "GILBERT, BONNY",
    "current_taxes": 7427.07,
    "new_taxes_no_override": 7747.92,
    "override_total_1": 7967.76,
    "override_increase_1": 219.84
  },
  {
    "#": "3 Auburn Ct, Unit 2 (170-14-08)",
    "$": 822900,
    "address": "3 Auburn Ct, Unit 2",
    "parcel_id": "170-14-08",
    "owner1": "SPASIC, ALEKSANDAR",
    "owner2": "ROJAS, ANA",
    "current_taxes": 4791.56,
    "new_taxes_no_override": 4998.56,
    "override_total_1": 5140.39,
    "override_increase_1": 141.83
  },
  {
    "#": "3 Auburn Ct, Unit 3 (170-14-09)",
    "$": 819700,
    "address": "3 Auburn Ct, Unit 3",
    "parcel_id": "170-14-09",
    "owner1": "STRAUSS, PATRICK EDWARD",
    "owner2": "",
    "current_taxes": 8393.73,
    "new_taxes_no_override": 8756.34,
    "override_total_1": 9004.79,
    "override_increase_1": 248.45
  },
  {
    "#": "4 Auburn Ct, Unit 1 (170-14-10)",
    "$": 869000,
    "address": "4 Auburn Ct, Unit 1",
    "parcel_id": "170-14-10",
    "owner1": "GALABURDA, DANIEL & MEGAN MCAVEY",
    "owner2": "",
    "current_taxes": 5263.63,
    "new_taxes_no_override": 5491.02,
    "override_total_1": 5646.82,
    "override_increase_1": 155.8
  },
  {
    "#": "4 Auburn Ct, Unit 2 (170-14-11)",
    "$": 837700,
    "address": "4 Auburn Ct, Unit 2",
    "parcel_id": "170-14-11",
    "owner1": "WIZEL, SHEINE",
    "owner2": "",
    "current_taxes": 8578.05,
    "new_taxes_no_override": 8948.62,
    "override_total_1": 9202.53,
    "override_increase_1": 253.91
  },
  {
    "#": "4 Auburn Ct, Unit 3 (170-14-12)",
    "$": 796100,
    "address": "4 Auburn Ct, Unit 3",
    "parcel_id": "170-14-12",
    "owner1": "GILL TR, KRISTIE CALLAHAN",
    "owner2": "",
    "current_taxes": 8152.06,
    "new_taxes_no_override": 8504.23,
    "override_total_1": 8745.53,
    "override_increase_1": 241.3
  },
  {
    "#": "5 Auburn Ct, Unit 1 (170-14-13)",
    "$": 773900,
    "address": "5 Auburn Ct, Unit 1",
    "parcel_id": "170-14-13",
    "owner1": "BURES TRS, GARY & MARY JO",
    "owner2": "",
    "current_taxes": 7924.74,
    "new_taxes_no_override": 8267.09,
    "override_total_1": 8501.66,
    "override_increase_1": 234.57
  },
  {
    "#": "5 Auburn Ct, Unit 2 (170-14-14)",
    "$": 820100,
    "address": "5 Auburn Ct, Unit 2",
    "parcel_id": "170-14-14",
    "owner1": "SIMON, MICHELLE",
    "owner2": "",
    "current_taxes": 4762.89,
    "new_taxes_no_override": 4968.65,
    "override_total_1": 5109.63,
    "override_increase_1": 140.98
  },
  {
    "#": "5 Auburn Ct, Unit 3 (170-14-15)",
    "$": 790900,
    "address": "5 Auburn Ct, Unit 3",
    "parcel_id": "170-14-15",
    "owner1": "SPECTOR, SANDRA L",
    "owner2": "",
    "current_taxes": 4463.88,
    "new_taxes_no_override": 4656.72,
    "override_total_1": 4788.85,
    "override_increase_1": 132.13
  },
  {
    "#": "6 Auburn Ct, Unit 1 (170-14-16)",
    "$": 764500,
    "address": "6 Auburn Ct, Unit 1",
    "parcel_id": "170-14-16",
    "owner1": "MARTENSON TR, GLORIA V",
    "owner2": "",
    "current_taxes": 4193.55,
    "new_taxes_no_override": 4374.71,
    "override_total_1": 4498.84,
    "override_increase_1": 124.13
  },
  {
    "#": "6 Auburn Ct, Unit 2 (170-14-17)",
    "$": 793800,
    "address": "6 Auburn Ct, Unit 2",
    "parcel_id": "170-14-17",
    "owner1": "JACOBSON LIFE ESTATE, RINA",
    "owner2": "",
    "current_taxes": 4493.58,
    "new_taxes_no_override": 4687.7,
    "override_total_1": 4820.71,
    "override_increase_1": 133.01
  },
  {
    "#": "6 Auburn Ct, Unit 3 (170-14-18)",
    "$": 825800,
    "address": "6 Auburn Ct, Unit 3",
    "parcel_id": "170-14-18",
    "owner1": "LAJOIE, ELIZABETH A",
    "owner2": "",
    "current_taxes": 4821.26,
    "new_taxes_no_override": 5029.54,
    "override_total_1": 5172.25,
    "override_increase_1": 142.71
  },
  {
    "#": "7 Auburn Ct, Unit 1 (170-14-19)",
    "$": 796300,
    "address": "7 Auburn Ct, Unit 1",
    "parcel_id": "170-14-19",
    "owner1": "ARI, NISA",
    "owner2": "KUBO, MICHAEL",
    "current_taxes": 8154.11,
    "new_taxes_no_override": 8506.37,
    "override_total_1": 8747.73,
    "override_increase_1": 241.36
  },
  {
    "#": "7 Auburn Ct, Unit 2 (170-14-20)",
    "$": 809300,
    "address": "7 Auburn Ct, Unit 2",
    "parcel_id": "170-14-20",
    "owner1": "LIPSKY, HOWARD",
    "owner2": "CLARK, CYNTHIA",
    "current_taxes": 4652.3,
    "new_taxes_no_override": 4853.28,
    "override_total_1": 4990.99,
    "override_increase_1": 137.71
  },
  {
    "#": "7 Auburn Ct, Unit 3 (170-14-21)",
    "$": 810300,
    "address": "7 Auburn Ct, Unit 3",
    "parcel_id": "170-14-21",
    "owner1": "ALEF LLC",
    "owner2": "",
    "current_taxes": 8297.47,
    "new_taxes_no_override": 8655.92,
    "override_total_1": 8901.53,
    "override_increase_1": 245.61
  },
  {
    "#": "8 Auburn Ct, Unit 1 (170-14-22)",
    "$": 784400,
    "address": "8 Auburn Ct, Unit 1",
    "parcel_id": "170-14-22",
    "owner1": "FULLER TR, ETHLYN DAVIS",
    "owner2": "",
    "current_taxes": 4397.32,
    "new_taxes_no_override": 4587.28,
    "override_total_1": 4717.44,
    "override_increase_1": 130.16
  },
  {
    "#": "8 Auburn Ct, Unit 2 (170-14-23)",
    "$": 835500,
    "address": "8 Auburn Ct, Unit 2",
    "parcel_id": "170-14-23",
    "owner1": "LUKITSH TRS, JOANNE M",
    "owner2": "",
    "current_taxes": 4920.59,
    "new_taxes_no_override": 5133.16,
    "override_total_1": 5278.81,
    "override_increase_1": 145.65
  },
  {
    "#": "8 Auburn Ct, Unit 3 (170-14-24)",
    "$": 823400,
    "address": "8 Auburn Ct, Unit 3",
    "parcel_id": "170-14-24",
    "owner1": "GUILLEMEN, ROBERT D & JEANNETTE L",
    "owner2": "",
    "current_taxes": 4796.68,
    "new_taxes_no_override": 5003.9,
    "override_total_1": 5145.88,
    "override_increase_1": 141.98
  },
  {
    "#": "9 Auburn Ct, Unit 1 (170-14-25)",
    "$": 849600,
    "address": "9 Auburn Ct, Unit 1",
    "parcel_id": "170-14-25",
    "owner1": "CARNIE, ROGER P",
    "owner2": "ALBANESE, REGINA P",
    "current_taxes": 5064.97,
    "new_taxes_no_override": 5283.78,
    "override_total_1": 5433.7,
    "override_increase_1": 149.92
  },
  {
    "#": "9 Auburn Ct, Unit 2 (170-14-26)",
    "$": 806400,
    "address": "9 Auburn Ct, Unit 2",
    "parcel_id": "170-14-26",
    "owner1": "NEIDLE, CAROL J",
    "owner2": "",
    "current_taxes": 4622.6,
    "new_taxes_no_override": 4822.3,
    "override_total_1": 4959.13,
    "override_increase_1": 136.83
  },
  {
    "#": "9 Auburn Ct, Unit 3 (170-14-27)",
    "$": 794400,
    "address": "9 Auburn Ct, Unit 3",
    "parcel_id": "170-14-27",
    "owner1": "HILL, MALCOLM T JR",
    "owner2": "",
    "current_taxes": 4499.72,
    "new_taxes_no_override": 4694.11,
    "override_total_1": 4827.3,
    "override_increase_1": 133.19
  },
  {
    "#": "10 Auburn Ct, Unit 1 (170-14-28)",
    "$": 817200,
    "address": "10 Auburn Ct, Unit 1",
    "parcel_id": "170-14-28",
    "owner1": "NADER, ALEXANDRE K",
    "owner2": "",
    "current_taxes": 8368.13,
    "new_taxes_no_override": 8729.63,
    "override_total_1": 8977.33,
    "override_increase_1": 247.7
  },
  {
    "#": "10 Auburn Ct, Unit 2 (170-14-29)",
    "$": 844800,
    "address": "10 Auburn Ct, Unit 2",
    "parcel_id": "170-14-29",
    "owner1": "VIGDORCHIK, MARK & LARISA",
    "owner2": "",
    "current_taxes": 5015.82,
    "new_taxes_no_override": 5232.5,
    "override_total_1": 5380.97,
    "override_increase_1": 148.47
  },
  {
    "#": "10 Auburn Ct, Unit 3 (170-14-30)",
    "$": 808200,
    "address": "10 Auburn Ct, Unit 3",
    "parcel_id": "170-14-30",
    "owner1": "LEE, HUAN L",
    "owner2": "SEMINERIO, MARIA",
    "current_taxes": 4641.03,
    "new_taxes_no_override": 4841.52,
    "override_total_1": 4978.9,
    "override_increase_1": 137.37
  },
  {
    "#": "9 Auburn Pl (170-05-00)",
    "$": 2469900,
    "address": "9 Auburn Pl",
    "parcel_id": "170-05-00",
    "owner1": "STOKES, JESSICA WALLING & COLIN S",
    "owner2": "",
    "current_taxes": 21656.84,
    "new_taxes_no_override": 22592.42,
    "override_total_1": 23233.46,
    "override_increase_1": 641.04
  },
  {
    "#": "10 Auburn Pl (170-08-00)",
    "$": 2327900,
    "address": "10 Auburn Pl",
    "parcel_id": "170-08-00",
    "owner1": "SPERLING, REISA A",
    "owner2": "JOHNSON, KEITH A",
    "current_taxes": 20202.76,
    "new_taxes_no_override": 21075.52,
    "override_total_1": 21673.52,
    "override_increase_1": 598.0
  },
  {
    "#": "14 Auburn Pl (170-07-00)",
    "$": 2525000,
    "address": "14 Auburn Pl",
    "parcel_id": "170-07-00",
    "owner1": "MILSTEIN, ROBERT LEE",
    "owner2": "",
    "current_taxes": 22221.07,
    "new_taxes_no_override": 23181.02,
    "override_total_1": 23838.76,
    "override_increase_1": 657.74
  },
  {
    "#": "15 Auburn Pl (170-06-00)",
    "$": 2066200,
    "address": "15 Auburn Pl",
    "parcel_id": "170-06-00",
    "owner1": "DUCHESNE, JUNE D & LAURENT G",
    "owner2": "",
    "current_taxes": 17522.95,
    "new_taxes_no_override": 18279.94,
    "override_total_1": 18798.62,
    "override_increase_1": 518.68
  },
  {
    "#": "4 Auburn St (170-15-00)",
    "$": 2386200,
    "address": "4 Auburn St",
    "parcel_id": "170-15-00",
    "owner1": "HERNANDEZ, PHILLIP",
    "owner2": "SLAYTON, JAMES M",
    "current_taxes": 20799.75,
    "new_taxes_no_override": 21698.3,
    "override_total_1": 22313.97,
    "override_increase_1": 615.67
  },
  {
    "#": "15 Auburn St (169-25-00)",
    "$": 2370800,
    "address": "15 Auburn St",
    "parcel_id": "169-25-00",
    "owner1": "SLAYTON, JAMES M",
    "owner2": "HERNANDEZ, PHILLIP",
    "current_taxes": 24276.99,
    "new_taxes_no_override": 25325.76,
    "override_total_1": 26044.35,
    "override_increase_1": 718.6
  },
  {
    "#": "17 Auburn St (169-26-00)",
    "$": 2057100,
    "address": "17 Auburn St",
    "parcel_id": "169-26-00",
    "owner1": "MARTIN, ADAM CHARLES & ANDREA LYTLE",
    "owner2": "",
    "current_taxes": 21064.7,
    "new_taxes_no_override": 21974.7,
    "override_total_1": 22598.21,
    "override_increase_1": 623.52
  },
  {
    "#": "21 Auburn St (169-27-00)",
    "$": 1897700,
    "address": "21 Auburn St",
    "parcel_id": "169-27-00",
    "owner1": "HEBERT, JOHN P & BARBARA C",
    "owner2": "",
    "current_taxes": 15797.51,
    "new_taxes_no_override": 16479.96,
    "override_total_1": 16947.57,
    "override_increase_1": 467.61
  },
  {
    "#": "23 Auburn St (169-28-00)",
    "$": 2167900,
    "address": "23 Auburn St",
    "parcel_id": "169-28-00",
    "owner1": "GAUGER, TRS, ANNEMARIE & THOMAS L",
    "owner2": "",
    "current_taxes": 18564.36,
    "new_taxes_no_override": 19366.34,
    "override_total_1": 19915.85,
    "override_increase_1": 549.51
  },
  {
    "#": "24 Auburn St (170-13-00)",
    "$": 3838900,
    "address": "24 Auburn St",
    "parcel_id": "170-13-00",
    "owner1": "24 AUBURN DEVELOPMENT LLC",
    "owner2": "",
    "current_taxes": 39310.34,
    "new_taxes_no_override": 41008.55,
    "override_total_1": 42172.13,
    "override_increase_1": 1163.59
  },
  {
    "#": "27 Auburn St (169-29-00)",
    "$": 2044700,
    "address": "27 Auburn St",
    "parcel_id": "169-29-00",
    "owner1": "BARKAI, SIMCHA",
    "owner2": "MSALL, LUCILLE",
    "current_taxes": 17302.79,
    "new_taxes_no_override": 18050.27,
    "override_total_1": 18562.43,
    "override_increase_1": 512.16
  },
  {
    "#": "31 Auburn St (169-30-00)",
    "$": 1937000,
    "address": "31 Auburn St",
    "parcel_id": "169-30-00",
    "owner1": "WONG TR, JANEY",
    "owner2": "",
    "current_taxes": 16199.95,
    "new_taxes_no_override": 16899.79,
    "override_total_1": 17379.31,
    "override_increase_1": 479.52
  },
  {
    "#": "32 Auburn St (170-10-00)",
    "$": 2102500,
    "address": "32 Auburn St",
    "parcel_id": "170-10-00",
    "owner1": "32 34 AUBURN STREET LLC",
    "owner2": "",
    "current_taxes": 21529.6,
    "new_taxes_no_override": 22459.68,
    "override_total_1": 23096.95,
    "override_increase_1": 637.28
  },
  {
    "#": "37 Auburn St (169-17-00)",
    "$": 15712800,
    "address": "37 Auburn St",
    "parcel_id": "169-17-00",
    "owner1": "AUBURN & HARRIS LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 160899.07,
    "new_taxes_no_override": 167849.91,
    "override_total_1": 172612.52,
    "override_increase_1": 4762.61
  },
  {
    "#": "40 Auburn St (170-09-00)",
    "$": 2500600,
    "address": "40 Auburn St",
    "parcel_id": "170-09-00",
    "owner1": "BABAI TRS, RUTH E & SOHRAB",
    "owner2": "",
    "current_taxes": 21971.21,
    "new_taxes_no_override": 22920.37,
    "override_total_1": 23570.71,
    "override_increase_1": 650.35
  },
  {
    "#": "45 Auburn St (169-31-00)",
    "$": 1889600,
    "address": "45 Auburn St",
    "parcel_id": "169-31-00",
    "owner1": "SCHIMELMAN, ELLEN",
    "owner2": "",
    "current_taxes": 15714.57,
    "new_taxes_no_override": 16393.44,
    "override_total_1": 16858.59,
    "override_increase_1": 465.15
  },
  {
    "#": "48 Auburn St (170-04-00)",
    "$": 2009000,
    "address": "48 Auburn St",
    "parcel_id": "170-04-00",
    "owner1": "REDLENER, PAMELA J",
    "owner2": "",
    "current_taxes": 16937.23,
    "new_taxes_no_override": 17668.92,
    "override_total_1": 18170.26,
    "override_increase_1": 501.34
  },
  {
    "#": "54 Auburn St (170-03-00)",
    "$": 8563100,
    "address": "54 Auburn St",
    "parcel_id": "170-03-00",
    "owner1": "54 AUBURN STREET LLC",
    "owner2": "C/O TREMONT ASSET MGMT LLC",
    "current_taxes": 87686.14,
    "new_taxes_no_override": 91474.18,
    "override_total_1": 94069.69,
    "override_increase_1": 2595.51
  },
  {
    "#": "57 Auburn St (169-33-00)",
    "$": 2143900,
    "address": "57 Auburn St",
    "parcel_id": "169-33-00",
    "owner1": "ABULNOUR, RAJA",
    "owner2": "NIJMEH, JULIE",
    "current_taxes": 18318.6,
    "new_taxes_no_override": 19109.96,
    "override_total_1": 19652.19,
    "override_increase_1": 542.23
  },
  {
    "#": "59 Auburn St, Unit 1 (169-34-01)",
    "$": 2320300,
    "address": "59 Auburn St, Unit 1",
    "parcel_id": "169-34-01",
    "owner1": "STEIN, CALLAN & DANIELLE R",
    "owner2": "",
    "current_taxes": 23759.87,
    "new_taxes_no_override": 24786.3,
    "override_total_1": 25489.59,
    "override_increase_1": 703.29
  },
  {
    "#": "59 Auburn St, Unit 2 (169-34-02)",
    "$": 1634800,
    "address": "59 Auburn St, Unit 2",
    "parcel_id": "169-34-02",
    "owner1": "MATVEEV, ALEXANDER",
    "owner2": "ZLOCHISTI, MARINA",
    "current_taxes": 13105.42,
    "new_taxes_no_override": 13671.57,
    "override_total_1": 14059.49,
    "override_increase_1": 387.92
  },
  {
    "#": "59 Auburn St, Unit 3 (169-34-03)",
    "$": 1478200,
    "address": "59 Auburn St, Unit 3",
    "parcel_id": "169-34-03",
    "owner1": "TAGLIARENI TR, JOAN ELLEN",
    "owner2": "",
    "current_taxes": 11501.83,
    "new_taxes_no_override": 11998.71,
    "override_total_1": 12339.16,
    "override_increase_1": 340.45
  },
  {
    "#": "71 Avon St (354-02-00)",
    "$": 2392200,
    "address": "71 Avon St",
    "parcel_id": "354-02-00",
    "owner1": "71 AVON STREET INVESTMENT LLC",
    "owner2": "",
    "current_taxes": 24496.13,
    "new_taxes_no_override": 25554.36,
    "override_total_1": 26279.45,
    "override_increase_1": 725.09
  },
  {
    "#": " Avon St (354-03-00)",
    "$": 22900,
    "address": " Avon St",
    "parcel_id": "354-03-00",
    "owner1": "LYX ROCKWOOD DEVELOPMENT LLC",
    "owner2": "",
    "current_taxes": 234.5,
    "new_taxes_no_override": 244.63,
    "override_total_1": 251.57,
    "override_increase_1": 6.94
  },
  {
    "#": "9 Babcock St, Unit 1 (047A-05-01)",
    "$": 1023500,
    "address": "9 Babcock St, Unit 1",
    "parcel_id": "047A-05-01",
    "owner1": "BYRON, ET AL, VIRGINIA A",
    "owner2": "",
    "current_taxes": 17563.26,
    "new_taxes_no_override": 18321.99,
    "override_total_1": 18841.87,
    "override_increase_1": 519.87
  },
  {
    "#": "9 Babcock St, Unit 2 (047A-05-02)",
    "$": 1098900,
    "address": "9 Babcock St, Unit 2",
    "parcel_id": "047A-05-02",
    "owner1": "KALM LLC",
    "owner2": "",
    "current_taxes": 18857.12,
    "new_taxes_no_override": 19671.75,
    "override_total_1": 20229.92,
    "override_increase_1": 558.17
  },
  {
    "#": "9 Babcock St, Unit 3 (047A-05-03)",
    "$": 1120000,
    "address": "9 Babcock St, Unit 3",
    "parcel_id": "047A-05-03",
    "owner1": "KORN, YUVAL",
    "owner2": "",
    "current_taxes": 7833.87,
    "new_taxes_no_override": 8172.29,
    "override_total_1": 8404.18,
    "override_increase_1": 231.88
  },
  {
    "#": "9 Babcock St, Unit B (047A-05-04)",
    "$": 998400,
    "address": "9 Babcock St, Unit B",
    "parcel_id": "047A-05-04",
    "owner1": "RUBINO TRS, RICHARD L & WINNIE J",
    "owner2": "ROOK, JARRAD & LANI",
    "current_taxes": 17132.54,
    "new_taxes_no_override": 17872.67,
    "override_total_1": 18379.79,
    "override_increase_1": 507.12
  },
  {
    "#": "11 Babcock St (047A-06-00)",
    "$": 2685200,
    "address": "11 Babcock St",
    "parcel_id": "047A-06-00",
    "owner1": "LEUNG TR, PHILIP",
    "owner2": "",
    "current_taxes": 27496.45,
    "new_taxes_no_override": 28684.3,
    "override_total_1": 29498.19,
    "override_increase_1": 813.89
  },
  {
    "#": "15 Babcock St (047A-07-09)",
    "$": 4254800,
    "address": "15 Babcock St",
    "parcel_id": "047A-07-09",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O BABCOCK ST PARKING LOT",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "26 Babcock St (048-10-00)",
    "$": 2315000,
    "address": "26 Babcock St",
    "parcel_id": "048-10-00",
    "owner1": "GANJEI, CAROLINE",
    "owner2": "",
    "current_taxes": 23705.6,
    "new_taxes_no_override": 24729.68,
    "override_total_1": 25431.37,
    "override_increase_1": 701.69
  },
  {
    "#": "28 Babcock St (048-08-00)",
    "$": 3829400,
    "address": "28 Babcock St",
    "parcel_id": "048-08-00",
    "owner1": "GANJEI, ALBERT & CAROLINE",
    "owner2": "",
    "current_taxes": 39213.06,
    "new_taxes_no_override": 40907.06,
    "override_total_1": 42067.77,
    "override_increase_1": 1160.71
  },
  {
    "#": "30 Babcock St (048-07-00)",
    "$": 2633600,
    "address": "30 Babcock St",
    "parcel_id": "048-07-00",
    "owner1": "ZAZULA, GREGORY",
    "owner2": "",
    "current_taxes": 26968.06,
    "new_taxes_no_override": 28133.08,
    "override_total_1": 28931.33,
    "override_increase_1": 798.25
  },
  {
    "#": "34 Babcock St (048-06-00)",
    "$": 7484200,
    "address": "34 Babcock St",
    "parcel_id": "048-06-00",
    "owner1": "MANAGEMENT REALTY INC",
    "owner2": "",
    "current_taxes": 76638.21,
    "new_taxes_no_override": 79948.98,
    "override_total_1": 82217.47,
    "override_increase_1": 2268.49
  },
  {
    "#": "38 Babcock St (048-05-01)",
    "$": 2525700,
    "address": "38 Babcock St",
    "parcel_id": "048-05-01",
    "owner1": "FAISAL, ANWAR",
    "owner2": "",
    "current_taxes": 25863.17,
    "new_taxes_no_override": 26980.46,
    "override_total_1": 27746.01,
    "override_increase_1": 765.55
  },
  {
    "#": "40 Babcock St (048-05-00)",
    "$": 3677500,
    "address": "40 Babcock St",
    "parcel_id": "048-05-00",
    "owner1": "VERNDALE PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 37657.6,
    "new_taxes_no_override": 39284.41,
    "override_total_1": 40399.07,
    "override_increase_1": 1114.66
  },
  {
    "#": "46 Babcock St (048-04-01)",
    "$": 2955400,
    "address": "46 Babcock St",
    "parcel_id": "048-04-01",
    "owner1": "ARGIROS  TRS, ALEXANDER A & JANA M",
    "owner2": "",
    "current_taxes": 30263.3,
    "new_taxes_no_override": 31570.67,
    "override_total_1": 32466.47,
    "override_increase_1": 895.79
  },
  {
    "#": "48 Babcock St (048-04-00)",
    "$": 5128500,
    "address": "48 Babcock St",
    "parcel_id": "048-04-00",
    "owner1": "NORA II LLC",
    "owner2": "",
    "current_taxes": 52515.84,
    "new_taxes_no_override": 54784.52,
    "override_total_1": 56338.99,
    "override_increase_1": 1554.47
  },
  {
    "#": "49 Babcock St (047-02-00)",
    "$": 4852700,
    "address": "49 Babcock St",
    "parcel_id": "047-02-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O FIRE STATION #5",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "52 Babcock St, Unit 1 & Pk G4 (048-03-12)",
    "$": 861300,
    "address": "52 Babcock St, Unit 1 & Pk G4",
    "parcel_id": "048-03-12",
    "owner1": "FINEBERG, GARY D & IRIS C",
    "owner2": "",
    "current_taxes": 8819.71,
    "new_taxes_no_override": 9200.72,
    "override_total_1": 9461.78,
    "override_increase_1": 261.06
  },
  {
    "#": "52 Babcock St, Unit 2 (048-03-01)",
    "$": 680200,
    "address": "52 Babcock St, Unit 2",
    "parcel_id": "048-03-01",
    "owner1": "WONG, AMY",
    "owner2": "",
    "current_taxes": 3330.31,
    "new_taxes_no_override": 3474.18,
    "override_total_1": 3572.76,
    "override_increase_1": 98.58
  },
  {
    "#": "52 Babcock St, Unit 3 & Pk G3 (048-03-02)",
    "$": 842200,
    "address": "52 Babcock St, Unit 3 & Pk G3",
    "parcel_id": "048-03-02",
    "owner1": "BERNSTEIN, AMY",
    "owner2": "",
    "current_taxes": 4989.19,
    "new_taxes_no_override": 5204.72,
    "override_total_1": 5352.4,
    "override_increase_1": 147.68
  },
  {
    "#": "52 Babcock St, Unit 4 & Pk G6 (048-03-03)",
    "$": 921700,
    "address": "52 Babcock St, Unit 4 & Pk G6",
    "parcel_id": "048-03-03",
    "owner1": "HARRIS TRS, BRUCE ANDREW & ELLIOTT",
    "owner2": "",
    "current_taxes": 5803.27,
    "new_taxes_no_override": 6053.97,
    "override_total_1": 6225.75,
    "override_increase_1": 171.78
  },
  {
    "#": "52 Babcock St, Unit 5 (048-03-04)",
    "$": 735600,
    "address": "52 Babcock St, Unit 5",
    "parcel_id": "048-03-04",
    "owner1": "SU, LIHE",
    "owner2": "LIN, POKUNG & BRIAN",
    "current_taxes": 3897.61,
    "new_taxes_no_override": 4065.99,
    "override_total_1": 4181.36,
    "override_increase_1": 115.37
  },
  {
    "#": "52 Babcock St, Unit 6 & Pk G2 (048-03-05)",
    "$": 937400,
    "address": "52 Babcock St, Unit 6 & Pk G2",
    "parcel_id": "048-03-05",
    "owner1": "LEIFER, ALEX C & BROOKE A",
    "owner2": "",
    "current_taxes": 5964.04,
    "new_taxes_no_override": 6221.69,
    "override_total_1": 6398.22,
    "override_increase_1": 176.54
  },
  {
    "#": "54 Babcock St, Unit 10 (048-03-09)",
    "$": 572500,
    "address": "54 Babcock St, Unit 10",
    "parcel_id": "048-03-09",
    "owner1": "DISINI, CAOLAN A",
    "owner2": "",
    "current_taxes": 5862.4,
    "new_taxes_no_override": 6115.66,
    "override_total_1": 6289.18,
    "override_increase_1": 173.53
  },
  {
    "#": "54 Babcock St, Unit 11 & Pk G5 (048-03-10)",
    "$": 758700,
    "address": "54 Babcock St, Unit 11 & Pk G5",
    "parcel_id": "048-03-10",
    "owner1": "PARIKH TR, CAROL ANN",
    "owner2": "",
    "current_taxes": 4134.15,
    "new_taxes_no_override": 4312.75,
    "override_total_1": 4435.12,
    "override_increase_1": 122.37
  },
  {
    "#": "54 Babcock St, Unit 12 & Pk G1 (048-03-11)",
    "$": 752400,
    "address": "54 Babcock St, Unit 12 & Pk G1",
    "parcel_id": "048-03-11",
    "owner1": "YEE, JANET K",
    "owner2": "",
    "current_taxes": 4069.64,
    "new_taxes_no_override": 4245.45,
    "override_total_1": 4365.91,
    "override_increase_1": 120.46
  },
  {
    "#": "54 Babcock St, Unit 7 (048-03-06)",
    "$": 621400,
    "address": "54 Babcock St, Unit 7",
    "parcel_id": "048-03-06",
    "owner1": "HANSEN, STEEN",
    "owner2": "",
    "current_taxes": 2728.2,
    "new_taxes_no_override": 2846.06,
    "override_total_1": 2926.81,
    "override_increase_1": 80.75
  },
  {
    "#": "54 Babcock St, Unit 8 (048-03-07)",
    "$": 572500,
    "address": "54 Babcock St, Unit 8",
    "parcel_id": "048-03-07",
    "owner1": "HOLLAND, DELIA",
    "owner2": "",
    "current_taxes": 2227.47,
    "new_taxes_no_override": 2323.7,
    "override_total_1": 2389.63,
    "override_increase_1": 65.93
  },
  {
    "#": "54 Babcock St, Unit 9 (048-03-08)",
    "$": 593400,
    "address": "54 Babcock St, Unit 9",
    "parcel_id": "048-03-08",
    "owner1": "PATRICK LIFE ESTATE, JANE I",
    "owner2": "",
    "current_taxes": 2441.48,
    "new_taxes_no_override": 2546.95,
    "override_total_1": 2619.22,
    "override_increase_1": 72.27
  },
  {
    "#": "57 Babcock St, Unit A-1 & P30 (047-04-30)",
    "$": 1031700,
    "address": "57 Babcock St, Unit A-1 & P30",
    "parcel_id": "047-04-30",
    "owner1": "YELLIN, HARRIET",
    "owner2": "",
    "current_taxes": 6929.67,
    "new_taxes_no_override": 7229.03,
    "override_total_1": 7434.15,
    "override_increase_1": 205.12
  },
  {
    "#": "57 Babcock St, Unit A-2 & P3 (047-04-01)",
    "$": 1143400,
    "address": "57 Babcock St, Unit A-2 & P3",
    "parcel_id": "047-04-01",
    "owner1": "BALASHOVA, ALLA",
    "owner2": "LEBOVITZ, GREGG",
    "current_taxes": 8073.48,
    "new_taxes_no_override": 8422.25,
    "override_total_1": 8661.23,
    "override_increase_1": 238.98
  },
  {
    "#": "57 Babcock St, Unit A-3 & P27 (047-04-02)",
    "$": 1114900,
    "address": "57 Babcock St, Unit A-3 & P27",
    "parcel_id": "047-04-02",
    "owner1": "TURCI, SUSAN",
    "owner2": "",
    "current_taxes": 7781.64,
    "new_taxes_no_override": 8117.81,
    "override_total_1": 8348.14,
    "override_increase_1": 230.34
  },
  {
    "#": "57 Babcock St, Unit B-1 & P32 (047-04-03)",
    "$": 1196400,
    "address": "57 Babcock St, Unit B-1 & P32",
    "parcel_id": "047-04-03",
    "owner1": "RUBINOFF, SALLY ANN",
    "owner2": "",
    "current_taxes": 8616.2,
    "new_taxes_no_override": 8988.42,
    "override_total_1": 9243.46,
    "override_increase_1": 255.04
  },
  {
    "#": "57 Babcock St, Unit B-2 & P28 (047-04-04)",
    "$": 1176900,
    "address": "57 Babcock St, Unit B-2 & P28",
    "parcel_id": "047-04-04",
    "owner1": "LUCA, JOSEPH R",
    "owner2": "",
    "current_taxes": 12051.46,
    "new_taxes_no_override": 12572.08,
    "override_total_1": 12928.81,
    "override_increase_1": 356.72
  },
  {
    "#": "57 Babcock St, Unit B-3 & P24 (047-04-05)",
    "$": 1179000,
    "address": "57 Babcock St, Unit B-3 & P24",
    "parcel_id": "047-04-05",
    "owner1": "MEAD, BRIAN",
    "owner2": "SGANGA, DANIELLE",
    "current_taxes": 12072.96,
    "new_taxes_no_override": 12594.51,
    "override_total_1": 12951.87,
    "override_increase_1": 357.36
  },
  {
    "#": "59 Babcock St, Unit A-1 & P29 (047-04-06)",
    "$": 917500,
    "address": "59 Babcock St, Unit A-1 & P29",
    "parcel_id": "047-04-06",
    "owner1": "SHERTZER, GERALD",
    "owner2": "",
    "current_taxes": 5760.27,
    "new_taxes_no_override": 6009.11,
    "override_total_1": 6179.62,
    "override_increase_1": 170.5
  },
  {
    "#": "59 Babcock St, Unit A-2 & P6 (047-04-07)",
    "$": 937000,
    "address": "59 Babcock St, Unit A-2 & P6",
    "parcel_id": "047-04-07",
    "owner1": "ROBINS, SUSAN Z",
    "owner2": "",
    "current_taxes": 9594.88,
    "new_taxes_no_override": 10009.38,
    "override_total_1": 10293.39,
    "override_increase_1": 284.01
  },
  {
    "#": "59 Babcock St, Unit A-3 & P8 (047-04-08)",
    "$": 940900,
    "address": "59 Babcock St, Unit A-3 & P8",
    "parcel_id": "047-04-08",
    "owner1": "GELFAND, SAMANTHA",
    "owner2": "",
    "current_taxes": 5999.88,
    "new_taxes_no_override": 6259.07,
    "override_total_1": 6436.67,
    "override_increase_1": 177.6
  },
  {
    "#": "59 Babcock St, Unit B-1 & P13 (047-04-09)",
    "$": 902300,
    "address": "59 Babcock St, Unit B-1 & P13",
    "parcel_id": "047-04-09",
    "owner1": "RICHMAN TRS, MARTIN L",
    "owner2": "LAMPKE , DANIEL I",
    "current_taxes": 5604.62,
    "new_taxes_no_override": 5846.74,
    "override_total_1": 6012.64,
    "override_increase_1": 165.9
  },
  {
    "#": "59 Babcock St, Unit B-2 & P11 (047-04-10)",
    "$": 967900,
    "address": "59 Babcock St, Unit B-2 & P11",
    "parcel_id": "047-04-10",
    "owner1": "WEINBERG CROCCO, BRUNO & FABIO",
    "owner2": "",
    "current_taxes": 9911.3,
    "new_taxes_no_override": 10339.47,
    "override_total_1": 10632.84,
    "override_increase_1": 293.37
  },
  {
    "#": "59 Babcock St, Unit B-3 & P9 (047-04-11)",
    "$": 944700,
    "address": "59 Babcock St, Unit B-3 & P9",
    "parcel_id": "047-04-11",
    "owner1": "SCOTT, BENJAMIN BARNETT",
    "owner2": "SCIRE, SARAH",
    "current_taxes": 6038.79,
    "new_taxes_no_override": 6299.67,
    "override_total_1": 6478.41,
    "override_increase_1": 178.75
  },
  {
    "#": "60 Babcock St, Unit 11 (048-01-11)",
    "$": 718800,
    "address": "60 Babcock St, Unit 11",
    "parcel_id": "048-01-11",
    "owner1": "MAKEDON, FILLIA",
    "owner2": "",
    "current_taxes": 7360.51,
    "new_taxes_no_override": 7678.48,
    "override_total_1": 7896.36,
    "override_increase_1": 217.87
  },
  {
    "#": "60 Babcock St, Unit 12 (048-01-12)",
    "$": 576500,
    "address": "60 Babcock St, Unit 12",
    "parcel_id": "048-01-12",
    "owner1": "PRIMILSKY, VLADIMIR & VERA",
    "owner2": "",
    "current_taxes": 2268.43,
    "new_taxes_no_override": 2366.43,
    "override_total_1": 2433.57,
    "override_increase_1": 67.15
  },
  {
    "#": "60 Babcock St, Unit 16 (048-01-16)",
    "$": 514600,
    "address": "60 Babcock St, Unit 16",
    "parcel_id": "048-01-16",
    "owner1": "BLOOM TRS, LAWRENCE D",
    "owner2": "JONES-BLOOM, REBECCA",
    "current_taxes": 5269.5,
    "new_taxes_no_override": 5497.14,
    "override_total_1": 5653.12,
    "override_increase_1": 155.98
  },
  {
    "#": "60 Babcock St, Unit 17 (048-01-17)",
    "$": 753200,
    "address": "60 Babcock St, Unit 17",
    "parcel_id": "048-01-17",
    "owner1": "EHRLICH TR, WALTER",
    "owner2": "",
    "current_taxes": 7712.77,
    "new_taxes_no_override": 8045.96,
    "override_total_1": 8274.26,
    "override_increase_1": 228.3
  },
  {
    "#": "60 Babcock St, Unit 18 (048-01-18)",
    "$": 574300,
    "address": "60 Babcock St, Unit 18",
    "parcel_id": "048-01-18",
    "owner1": "MYUNG, KYUNG HYUN",
    "owner2": "",
    "current_taxes": 2245.9,
    "new_taxes_no_override": 2342.92,
    "override_total_1": 2409.4,
    "override_increase_1": 66.48
  },
  {
    "#": "60 Babcock St, Unit 21 (048-01-21)",
    "$": 602000,
    "address": "60 Babcock St, Unit 21",
    "parcel_id": "048-01-21",
    "owner1": "HUANG, GRACE",
    "owner2": "",
    "current_taxes": 6164.48,
    "new_taxes_no_override": 6430.79,
    "override_total_1": 6613.25,
    "override_increase_1": 182.47
  },
  {
    "#": "60 Babcock St, Unit 22 (048-01-22)",
    "$": 583700,
    "address": "60 Babcock St, Unit 22",
    "parcel_id": "048-01-22",
    "owner1": "STONELEDGE LLC",
    "owner2": "C/O WALTER EHRLICH TR",
    "current_taxes": 5977.09,
    "new_taxes_no_override": 6235.3,
    "override_total_1": 6412.22,
    "override_increase_1": 176.92
  },
  {
    "#": "60 Babcock St, Unit 23 (048-01-23)",
    "$": 592000,
    "address": "60 Babcock St, Unit 23",
    "parcel_id": "048-01-23",
    "owner1": "EHRLICH TR, WALTER J",
    "owner2": "C/O WJE REALTY TRUST",
    "current_taxes": 6062.08,
    "new_taxes_no_override": 6323.96,
    "override_total_1": 6503.4,
    "override_increase_1": 179.44
  },
  {
    "#": "60 Babcock St, Unit 24 (048-01-24)",
    "$": 543800,
    "address": "60 Babcock St, Unit 24",
    "parcel_id": "048-01-24",
    "owner1": "STAHL, JON & JACQUELINE",
    "owner2": "",
    "current_taxes": 5568.51,
    "new_taxes_no_override": 5809.07,
    "override_total_1": 5973.9,
    "override_increase_1": 164.83
  },
  {
    "#": "60 Babcock St, Unit 25 (048-01-25)",
    "$": 416600,
    "address": "60 Babcock St, Unit 25",
    "parcel_id": "048-01-25",
    "owner1": "MAKEDON, FILLIA",
    "owner2": "",
    "current_taxes": 4265.98,
    "new_taxes_no_override": 4450.27,
    "override_total_1": 4576.54,
    "override_increase_1": 126.27
  },
  {
    "#": "60 Babcock St, Unit 26 (048-01-26)",
    "$": 521800,
    "address": "60 Babcock St, Unit 26",
    "parcel_id": "048-01-26",
    "owner1": "UNVER, MEHMET",
    "owner2": "",
    "current_taxes": 5343.23,
    "new_taxes_no_override": 5574.06,
    "override_total_1": 5732.22,
    "override_increase_1": 158.16
  },
  {
    "#": "60 Babcock St, Unit 27 (048-01-27)",
    "$": 614500,
    "address": "60 Babcock St, Unit 27",
    "parcel_id": "048-01-27",
    "owner1": "XU, YUHUI",
    "owner2": "HU, XUZHEN",
    "current_taxes": 6292.48,
    "new_taxes_no_override": 6564.32,
    "override_total_1": 6750.57,
    "override_increase_1": 186.26
  },
  {
    "#": "60 Babcock St, Unit 28 (048-01-28)",
    "$": 605300,
    "address": "60 Babcock St, Unit 28",
    "parcel_id": "048-01-28",
    "owner1": "BLEIMES, LINDSEY",
    "owner2": "",
    "current_taxes": 6198.27,
    "new_taxes_no_override": 6466.04,
    "override_total_1": 6649.5,
    "override_increase_1": 183.47
  },
  {
    "#": "60 Babcock St, Unit 31 (048-01-31)",
    "$": 576500,
    "address": "60 Babcock St, Unit 31",
    "parcel_id": "048-01-31",
    "owner1": "DONNELLY, SUSAN F",
    "owner2": "",
    "current_taxes": 5903.36,
    "new_taxes_no_override": 6158.39,
    "override_total_1": 6333.12,
    "override_increase_1": 174.74
  },
  {
    "#": "60 Babcock St, Unit 32 (048-01-32)",
    "$": 591800,
    "address": "60 Babcock St, Unit 32",
    "parcel_id": "048-01-32",
    "owner1": "ZHUO, YI",
    "owner2": "",
    "current_taxes": 6060.03,
    "new_taxes_no_override": 6321.82,
    "override_total_1": 6501.2,
    "override_increase_1": 179.38
  },
  {
    "#": "60 Babcock St, Unit 33 (048-01-33)",
    "$": 607300,
    "address": "60 Babcock St, Unit 33",
    "parcel_id": "048-01-33",
    "owner1": "GOLDMAN TR, LEE",
    "owner2": "",
    "current_taxes": 6218.75,
    "new_taxes_no_override": 6487.4,
    "override_total_1": 6671.47,
    "override_increase_1": 184.07
  },
  {
    "#": "60 Babcock St, Unit 34 (048-01-34)",
    "$": 518300,
    "address": "60 Babcock St, Unit 34",
    "parcel_id": "048-01-34",
    "owner1": "CHANG, LI WEN",
    "owner2": "",
    "current_taxes": 5307.39,
    "new_taxes_no_override": 5536.67,
    "override_total_1": 5693.77,
    "override_increase_1": 157.1
  },
  {
    "#": "60 Babcock St, Unit 35 (048-01-35)",
    "$": 461800,
    "address": "60 Babcock St, Unit 35",
    "parcel_id": "048-01-35",
    "owner1": "ZHOU, ZHENWEI",
    "owner2": "",
    "current_taxes": 4728.83,
    "new_taxes_no_override": 4933.12,
    "override_total_1": 5073.09,
    "override_increase_1": 139.97
  },
  {
    "#": "60 Babcock St, Unit 36 (048-01-36)",
    "$": 555000,
    "address": "60 Babcock St, Unit 36",
    "parcel_id": "048-01-36",
    "owner1": "VERNOVSKY, LEV & INNA",
    "owner2": "",
    "current_taxes": 5683.2,
    "new_taxes_no_override": 5928.71,
    "override_total_1": 6096.94,
    "override_increase_1": 168.22
  },
  {
    "#": "60 Babcock St, Unit 37 (048-01-37)",
    "$": 648900,
    "address": "60 Babcock St, Unit 37",
    "parcel_id": "048-01-37",
    "owner1": "VOLDINER, KARINA",
    "owner2": "",
    "current_taxes": 6644.74,
    "new_taxes_no_override": 6931.79,
    "override_total_1": 7128.48,
    "override_increase_1": 196.68
  },
  {
    "#": "60 Babcock St, Unit 38 (048-01-38)",
    "$": 610700,
    "address": "60 Babcock St, Unit 38",
    "parcel_id": "048-01-38",
    "owner1": "GERSTEL TR, HELENE",
    "owner2": "",
    "current_taxes": 2618.63,
    "new_taxes_no_override": 2731.75,
    "override_total_1": 2809.27,
    "override_increase_1": 77.51
  },
  {
    "#": "60 Babcock St, Unit 41 (048-01-41)",
    "$": 576500,
    "address": "60 Babcock St, Unit 41",
    "parcel_id": "048-01-41",
    "owner1": "ZRODLOWSKI, GRACE",
    "owner2": "C/O KABAT GRACE Z",
    "current_taxes": 5903.36,
    "new_taxes_no_override": 6158.39,
    "override_total_1": 6333.12,
    "override_increase_1": 174.74
  },
  {
    "#": "60 Babcock St, Unit 42 (048-01-42)",
    "$": 576500,
    "address": "60 Babcock St, Unit 42",
    "parcel_id": "048-01-42",
    "owner1": "VERNOVSKY, LEV & INNA",
    "owner2": "",
    "current_taxes": 5903.36,
    "new_taxes_no_override": 6158.39,
    "override_total_1": 6333.12,
    "override_increase_1": 174.74
  },
  {
    "#": "60 Babcock St, Unit 43 (048-01-43)",
    "$": 617500,
    "address": "60 Babcock St, Unit 43",
    "parcel_id": "048-01-43",
    "owner1": "GAO, MATTHEW",
    "owner2": "",
    "current_taxes": 2688.27,
    "new_taxes_no_override": 2804.4,
    "override_total_1": 2883.98,
    "override_increase_1": 79.57
  },
  {
    "#": "60 Babcock St, Unit 44 (048-01-44)",
    "$": 528500,
    "address": "60 Babcock St, Unit 44",
    "parcel_id": "048-01-44",
    "owner1": "FOGG TR, ALFRED LEON",
    "owner2": "",
    "current_taxes": 1776.91,
    "new_taxes_no_override": 1853.67,
    "override_total_1": 1906.27,
    "override_increase_1": 52.6
  },
  {
    "#": "60 Babcock St, Unit 45 (048-01-45)",
    "$": 442400,
    "address": "60 Babcock St, Unit 45",
    "parcel_id": "048-01-45",
    "owner1": "ELLIN, TR, BARBARA J",
    "owner2": "",
    "current_taxes": 4530.18,
    "new_taxes_no_override": 4725.88,
    "override_total_1": 4859.98,
    "override_increase_1": 134.09
  },
  {
    "#": "60 Babcock St, Unit 46 (048-01-46)",
    "$": 514600,
    "address": "60 Babcock St, Unit 46",
    "parcel_id": "048-01-46",
    "owner1": "VOLDINER TRS, LUCIEN & KARINA",
    "owner2": "",
    "current_taxes": 5269.5,
    "new_taxes_no_override": 5497.14,
    "override_total_1": 5653.12,
    "override_increase_1": 155.98
  },
  {
    "#": "60 Babcock St, Unit 47 (048-01-47)",
    "$": 614500,
    "address": "60 Babcock St, Unit 47",
    "parcel_id": "048-01-47",
    "owner1": "HAY, BERNWARD",
    "owner2": "",
    "current_taxes": 6292.48,
    "new_taxes_no_override": 6564.32,
    "override_total_1": 6750.57,
    "override_increase_1": 186.26
  },
  {
    "#": "60 Babcock St, Unit 48 (048-01-48)",
    "$": 585200,
    "address": "60 Babcock St, Unit 48",
    "parcel_id": "048-01-48",
    "owner1": "FELDKHUN, LEV G",
    "owner2": "",
    "current_taxes": 5992.45,
    "new_taxes_no_override": 6251.32,
    "override_total_1": 6428.7,
    "override_increase_1": 177.38
  },
  {
    "#": "60 Babcock St, Unit 51 (048-01-51)",
    "$": 576500,
    "address": "60 Babcock St, Unit 51",
    "parcel_id": "048-01-51",
    "owner1": "STEIN, RALPH S & HERBERT M",
    "owner2": "",
    "current_taxes": 5903.36,
    "new_taxes_no_override": 6158.39,
    "override_total_1": 6333.12,
    "override_increase_1": 174.74
  },
  {
    "#": "60 Babcock St, Unit 52 (048-01-52)",
    "$": 576500,
    "address": "60 Babcock St, Unit 52",
    "parcel_id": "048-01-52",
    "owner1": "KLOUPTE, SIMA",
    "owner2": "",
    "current_taxes": 2268.43,
    "new_taxes_no_override": 2366.43,
    "override_total_1": 2433.57,
    "override_increase_1": 67.15
  },
  {
    "#": "60 Babcock St, Unit 53 (048-01-53)",
    "$": 617500,
    "address": "60 Babcock St, Unit 53",
    "parcel_id": "048-01-53",
    "owner1": "PAYTON, MARIE",
    "owner2": "",
    "current_taxes": 6323.2,
    "new_taxes_no_override": 6596.36,
    "override_total_1": 6783.53,
    "override_increase_1": 187.17
  },
  {
    "#": "60 Babcock St, Unit 54 (048-01-54)",
    "$": 543800,
    "address": "60 Babcock St, Unit 54",
    "parcel_id": "048-01-54",
    "owner1": "PENG, SHIYI",
    "owner2": "",
    "current_taxes": 1933.58,
    "new_taxes_no_override": 2017.11,
    "override_total_1": 2074.34,
    "override_increase_1": 57.23
  },
  {
    "#": "60 Babcock St, Unit 55 (048-01-55)",
    "$": 461800,
    "address": "60 Babcock St, Unit 55",
    "parcel_id": "048-01-55",
    "owner1": "GLEASON, PAUL J",
    "owner2": "",
    "current_taxes": 1093.9,
    "new_taxes_no_override": 1141.16,
    "override_total_1": 1173.54,
    "override_increase_1": 32.38
  },
  {
    "#": "60 Babcock St, Unit 56 (048-01-56)",
    "$": 540100,
    "address": "60 Babcock St, Unit 56",
    "parcel_id": "048-01-56",
    "owner1": "PEO, JEFFREY HANS",
    "owner2": "HSU, JOYCE TYNG",
    "current_taxes": 1895.69,
    "new_taxes_no_override": 1977.58,
    "override_total_1": 2033.7,
    "override_increase_1": 56.11
  },
  {
    "#": "60 Babcock St, Unit 57 (048-01-57)",
    "$": 648900,
    "address": "60 Babcock St, Unit 57",
    "parcel_id": "048-01-57",
    "owner1": "STONELEDGE LLC",
    "owner2": "C/O WALTER EHRLICH TR",
    "current_taxes": 6644.74,
    "new_taxes_no_override": 6931.79,
    "override_total_1": 7128.48,
    "override_increase_1": 196.68
  },
  {
    "#": "60 Babcock St, Unit 58 (048-01-58)",
    "$": 585200,
    "address": "60 Babcock St, Unit 58",
    "parcel_id": "048-01-58",
    "owner1": "STEINMETZ, MILTON A",
    "owner2": "DONOVAN, LESLIE E",
    "current_taxes": 5992.45,
    "new_taxes_no_override": 6251.32,
    "override_total_1": 6428.7,
    "override_increase_1": 177.38
  },
  {
    "#": "60 Babcock St, Unit 61 (048-01-61)",
    "$": 591800,
    "address": "60 Babcock St, Unit 61",
    "parcel_id": "048-01-61",
    "owner1": "SOLE PLASA, MARIA M",
    "owner2": "",
    "current_taxes": 2425.1,
    "new_taxes_no_override": 2529.86,
    "override_total_1": 2601.65,
    "override_increase_1": 71.78
  },
  {
    "#": "60 Babcock St, Unit 62 (048-01-62)",
    "$": 576500,
    "address": "60 Babcock St, Unit 62",
    "parcel_id": "048-01-62",
    "owner1": "FELDMAN, ZIV",
    "owner2": "",
    "current_taxes": 5903.36,
    "new_taxes_no_override": 6158.39,
    "override_total_1": 6333.12,
    "override_increase_1": 174.74
  },
  {
    "#": "60 Babcock St, Unit 63 (048-01-63)",
    "$": 592000,
    "address": "60 Babcock St, Unit 63",
    "parcel_id": "048-01-63",
    "owner1": "SOLE PLASA, MARIA M",
    "owner2": "",
    "current_taxes": 6062.08,
    "new_taxes_no_override": 6323.96,
    "override_total_1": 6503.4,
    "override_increase_1": 179.44
  },
  {
    "#": "60 Babcock St, Unit 64 (048-01-64)",
    "$": 518300,
    "address": "60 Babcock St, Unit 64",
    "parcel_id": "048-01-64",
    "owner1": "MALONE, BRIAN JAMES & PATRICIA & BRIAN",
    "owner2": "",
    "current_taxes": 5307.39,
    "new_taxes_no_override": 5536.67,
    "override_total_1": 5693.77,
    "override_increase_1": 157.1
  },
  {
    "#": "60 Babcock St, Unit 65 (048-01-65)",
    "$": 473400,
    "address": "60 Babcock St, Unit 65",
    "parcel_id": "048-01-65",
    "owner1": "ZHANG, KAI",
    "owner2": "",
    "current_taxes": 1212.68,
    "new_taxes_no_override": 1265.07,
    "override_total_1": 1300.96,
    "override_increase_1": 35.9
  },
  {
    "#": "60 Babcock St, Unit 66 (048-01-66)",
    "$": 521800,
    "address": "60 Babcock St, Unit 66",
    "parcel_id": "048-01-66",
    "owner1": "JIANG, CHENGLIANG",
    "owner2": "XIAO, YANPING",
    "current_taxes": 5343.23,
    "new_taxes_no_override": 5574.06,
    "override_total_1": 5732.22,
    "override_increase_1": 158.16
  },
  {
    "#": "60 Babcock St, Unit 67 (048-01-67)",
    "$": 630600,
    "address": "60 Babcock St, Unit 67",
    "parcel_id": "048-01-67",
    "owner1": "FAN LIFE ESTATE, SAU YING",
    "owner2": "",
    "current_taxes": 2822.41,
    "new_taxes_no_override": 2944.34,
    "override_total_1": 3027.88,
    "override_increase_1": 83.54
  },
  {
    "#": "60 Babcock St, Unit 68 (048-01-68)",
    "$": 585200,
    "address": "60 Babcock St, Unit 68",
    "parcel_id": "048-01-68",
    "owner1": "SMITH, RONALD BRUCE",
    "owner2": "",
    "current_taxes": 2357.51,
    "new_taxes_no_override": 2459.35,
    "override_total_1": 2529.14,
    "override_increase_1": 69.78
  },
  {
    "#": "60 Babcock St, Unit 71 (048-01-71)",
    "$": 576500,
    "address": "60 Babcock St, Unit 71",
    "parcel_id": "048-01-71",
    "owner1": "FISHER TR, DANA A",
    "owner2": "",
    "current_taxes": 2268.43,
    "new_taxes_no_override": 2366.43,
    "override_total_1": 2433.57,
    "override_increase_1": 67.15
  },
  {
    "#": "60 Babcock St, Unit 72 (048-01-72)",
    "$": 671500,
    "address": "60 Babcock St, Unit 72",
    "parcel_id": "048-01-72",
    "owner1": "EHRLICH TR, WALTER J",
    "owner2": "C/O WJE REALTY TRUST",
    "current_taxes": 6876.16,
    "new_taxes_no_override": 7173.21,
    "override_total_1": 7376.74,
    "override_increase_1": 203.53
  },
  {
    "#": "60 Babcock St, Unit 73 (048-01-73)",
    "$": 689200,
    "address": "60 Babcock St, Unit 73",
    "parcel_id": "048-01-73",
    "owner1": "LIEBERMAN, LINDA F",
    "owner2": "",
    "current_taxes": 7057.41,
    "new_taxes_no_override": 7362.29,
    "override_total_1": 7571.19,
    "override_increase_1": 208.9
  },
  {
    "#": "60 Babcock St, Unit 74 (048-01-74)",
    "$": 530200,
    "address": "60 Babcock St, Unit 74",
    "parcel_id": "048-01-74",
    "owner1": "MAKEDON, FILLIA",
    "owner2": "",
    "current_taxes": 5429.25,
    "new_taxes_no_override": 5663.79,
    "override_total_1": 5824.5,
    "override_increase_1": 160.71
  },
  {
    "#": "60 Babcock St, Unit 75 (048-01-75)",
    "$": 461800,
    "address": "60 Babcock St, Unit 75",
    "parcel_id": "048-01-75",
    "owner1": "KUPELNICK, SAM M",
    "owner2": "CHAN, ELIZABETH H",
    "current_taxes": 4728.83,
    "new_taxes_no_override": 4933.12,
    "override_total_1": 5073.09,
    "override_increase_1": 139.97
  },
  {
    "#": "60 Babcock St, Unit 76 (048-01-76)",
    "$": 526500,
    "address": "60 Babcock St, Unit 76",
    "parcel_id": "048-01-76",
    "owner1": "KOZLOVSKIY TR, ALEXANDER",
    "owner2": "",
    "current_taxes": 1756.43,
    "new_taxes_no_override": 1832.31,
    "override_total_1": 1884.3,
    "override_increase_1": 51.99
  },
  {
    "#": "60 Babcock St, Unit 77 (048-01-77)",
    "$": 602600,
    "address": "60 Babcock St, Unit 77",
    "parcel_id": "048-01-77",
    "owner1": "CULLINANE, ANN",
    "owner2": "",
    "current_taxes": 2535.69,
    "new_taxes_no_override": 2645.23,
    "override_total_1": 2720.29,
    "override_increase_1": 75.06
  },
  {
    "#": "60 Babcock St, Unit 78 (048-01-78)",
    "$": 585200,
    "address": "60 Babcock St, Unit 78",
    "parcel_id": "048-01-78",
    "owner1": "ZERWITZ, DONNA L",
    "owner2": "",
    "current_taxes": 2357.51,
    "new_taxes_no_override": 2459.35,
    "override_total_1": 2529.14,
    "override_increase_1": 69.78
  },
  {
    "#": "60 Babcock St, Unit 81 (048-01-81)",
    "$": 657900,
    "address": "60 Babcock St, Unit 81",
    "parcel_id": "048-01-81",
    "owner1": "KASPAROVA TRS, OLGA VIKTOROVNA",
    "owner2": "LEYKIN, MICHAEL IGOR",
    "current_taxes": 6736.9,
    "new_taxes_no_override": 7027.93,
    "override_total_1": 7227.35,
    "override_increase_1": 199.41
  },
  {
    "#": "60 Babcock St, Unit 82 (048-01-82)",
    "$": 664400,
    "address": "60 Babcock St, Unit 82",
    "parcel_id": "048-01-82",
    "owner1": "CHEN, WANG",
    "owner2": "",
    "current_taxes": 3168.52,
    "new_taxes_no_override": 3305.4,
    "override_total_1": 3399.19,
    "override_increase_1": 93.79
  },
  {
    "#": "60 Babcock St, Unit 83 (048-01-83)",
    "$": 603900,
    "address": "60 Babcock St, Unit 83",
    "parcel_id": "048-01-83",
    "owner1": "RAVITZ, RANDALL E",
    "owner2": "",
    "current_taxes": 6183.94,
    "new_taxes_no_override": 6451.09,
    "override_total_1": 6634.13,
    "override_increase_1": 183.04
  },
  {
    "#": "60 Babcock St, Unit 84 (048-01-84)",
    "$": 572000,
    "address": "60 Babcock St, Unit 84",
    "parcel_id": "048-01-84",
    "owner1": "WIELOPOLSKI, PIOTR",
    "owner2": "C/O PREMIER PROPERTY SOLUTIONS",
    "current_taxes": 5857.28,
    "new_taxes_no_override": 6110.31,
    "override_total_1": 6283.69,
    "override_increase_1": 173.38
  },
  {
    "#": "60 Babcock St, Unit 85 (048-01-85)",
    "$": 490900,
    "address": "60 Babcock St, Unit 85",
    "parcel_id": "048-01-85",
    "owner1": "IMMEL, MICHAEL L",
    "owner2": "GALVAN, GREGORY B",
    "current_taxes": 5026.82,
    "new_taxes_no_override": 5243.98,
    "override_total_1": 5392.77,
    "override_increase_1": 148.79
  },
  {
    "#": "60 Babcock St, Unit 86 (048-01-86)",
    "$": 592700,
    "address": "60 Babcock St, Unit 86",
    "parcel_id": "048-01-86",
    "owner1": "FURUGORI, JOSEPH",
    "owner2": "YOSHIOKA, MARI",
    "current_taxes": 6069.25,
    "new_taxes_no_override": 6331.44,
    "override_total_1": 6511.09,
    "override_increase_1": 179.65
  },
  {
    "#": "60 Babcock St, Unit 87 (048-01-87)",
    "$": 675100,
    "address": "60 Babcock St, Unit 87",
    "parcel_id": "048-01-87",
    "owner1": "DONNELLY, SUSAN F",
    "owner2": "",
    "current_taxes": 3278.09,
    "new_taxes_no_override": 3419.7,
    "override_total_1": 3516.73,
    "override_increase_1": 97.03
  },
  {
    "#": "60 Babcock St, Unit 88 (048-01-88)",
    "$": 668200,
    "address": "60 Babcock St, Unit 88",
    "parcel_id": "048-01-88",
    "owner1": "FELDMAN TR, MARSHALL",
    "owner2": "",
    "current_taxes": 3207.43,
    "new_taxes_no_override": 3345.99,
    "override_total_1": 3440.93,
    "override_increase_1": 94.94
  },
  {
    "#": "60 Babcock St, Unit 91 (048-01-91)",
    "$": 638500,
    "address": "60 Babcock St, Unit 91",
    "parcel_id": "048-01-91",
    "owner1": "SABRA, AMIN F  & ELLEN",
    "owner2": "",
    "current_taxes": 6538.24,
    "new_taxes_no_override": 6820.69,
    "override_total_1": 7014.22,
    "override_increase_1": 193.53
  },
  {
    "#": "60 Babcock St, Unit 92 (048-01-92)",
    "$": 638500,
    "address": "60 Babcock St, Unit 92",
    "parcel_id": "048-01-92",
    "owner1": "MCFARLANE, BRYAN",
    "owner2": "",
    "current_taxes": 6538.24,
    "new_taxes_no_override": 6820.69,
    "override_total_1": 7014.22,
    "override_increase_1": 193.53
  },
  {
    "#": "60 Babcock St, Unit 93 (048-01-93)",
    "$": 1087600,
    "address": "60 Babcock St, Unit 93",
    "parcel_id": "048-01-93",
    "owner1": "BERNSTEIN LIFE ESTATE, JANE HOLMES",
    "owner2": "",
    "current_taxes": 7502.09,
    "new_taxes_no_override": 7826.18,
    "override_total_1": 8048.24,
    "override_increase_1": 222.06
  },
  {
    "#": "60 Babcock St, Unit 94 (048-01-94)",
    "$": 572000,
    "address": "60 Babcock St, Unit 94",
    "parcel_id": "048-01-94",
    "owner1": "FEINBERG, MICHAEL E",
    "owner2": "",
    "current_taxes": 5857.28,
    "new_taxes_no_override": 6110.31,
    "override_total_1": 6283.69,
    "override_increase_1": 173.38
  },
  {
    "#": "60 Babcock St, Unit 96 (048-01-96)",
    "$": 600800,
    "address": "60 Babcock St, Unit 96",
    "parcel_id": "048-01-96",
    "owner1": "STONELEDGE LLC",
    "owner2": "C/O WALTER EHRLICH TR",
    "current_taxes": 6152.19,
    "new_taxes_no_override": 6417.96,
    "override_total_1": 6600.07,
    "override_increase_1": 182.1
  },
  {
    "#": "60 Babcock St, Unit 97 (048-01-97)",
    "$": 669000,
    "address": "60 Babcock St, Unit 97",
    "parcel_id": "048-01-97",
    "owner1": "WINE, DAVID",
    "owner2": "RAZ, TAL",
    "current_taxes": 6850.56,
    "new_taxes_no_override": 7146.5,
    "override_total_1": 7349.28,
    "override_increase_1": 202.78
  },
  {
    "#": "60 Babcock St, Unit 98 (048-01-98)",
    "$": 661900,
    "address": "60 Babcock St, Unit 98",
    "parcel_id": "048-01-98",
    "owner1": "CHEN, YING",
    "owner2": "SHAO, MIN",
    "current_taxes": 6777.86,
    "new_taxes_no_override": 7070.66,
    "override_total_1": 7271.29,
    "override_increase_1": 200.62
  },
  {
    "#": "61 Babcock St, Unit A-1 & P5 (047-04-12)",
    "$": 1172500,
    "address": "61 Babcock St, Unit A-1 & P5",
    "parcel_id": "047-04-12",
    "owner1": "DREIZINE TR, ELENA",
    "owner2": "",
    "current_taxes": 12006.4,
    "new_taxes_no_override": 12525.08,
    "override_total_1": 12880.47,
    "override_increase_1": 355.39
  },
  {
    "#": "61 Babcock St, Unit A-2 & P7 (047-04-13)",
    "$": 1176300,
    "address": "61 Babcock St, Unit A-2 & P7",
    "parcel_id": "047-04-13",
    "owner1": "JEANNERET TRS, MARC & SHARON K",
    "owner2": "",
    "current_taxes": 8410.38,
    "new_taxes_no_override": 8773.71,
    "override_total_1": 9022.66,
    "override_increase_1": 248.95
  },
  {
    "#": "61 Babcock St, Unit A-3 & P10 (047-04-14)",
    "$": 1190100,
    "address": "61 Babcock St, Unit A-3 & P10",
    "parcel_id": "047-04-14",
    "owner1": "MAYHEW, DAVID R",
    "owner2": "HURLEY, ANN C",
    "current_taxes": 8551.69,
    "new_taxes_no_override": 8921.12,
    "override_total_1": 9174.25,
    "override_increase_1": 253.13
  },
  {
    "#": "61 Babcock St, Unit B-1 & P19 (047-04-15)",
    "$": 1114800,
    "address": "61 Babcock St, Unit B-1 & P19",
    "parcel_id": "047-04-15",
    "owner1": "SCHWARTZ TRS, RAYMUND A & LYNN T",
    "owner2": "",
    "current_taxes": 7780.62,
    "new_taxes_no_override": 8116.74,
    "override_total_1": 8347.05,
    "override_increase_1": 230.31
  },
  {
    "#": "61 Babcock St, Unit B-2 & P12 (047-04-16)",
    "$": 1220200,
    "address": "61 Babcock St, Unit B-2 & P12",
    "parcel_id": "047-04-16",
    "owner1": "JAZAYERI, MEHRDAD",
    "owner2": "PASHA, LILI",
    "current_taxes": 12494.85,
    "new_taxes_no_override": 13034.63,
    "override_total_1": 13404.48,
    "override_increase_1": 369.85
  },
  {
    "#": "61 Babcock St, Unit B-3 & P4 (047-04-17)",
    "$": 1220100,
    "address": "61 Babcock St, Unit B-3 & P4",
    "parcel_id": "047-04-17",
    "owner1": "MARAGNI, MARK D",
    "owner2": "LESHO, LYNNE A",
    "current_taxes": 8858.89,
    "new_taxes_no_override": 9241.59,
    "override_total_1": 9503.82,
    "override_increase_1": 262.22
  },
  {
    "#": "63 Babcock St, Unit A-1 & G11 (047-04-18)",
    "$": 957900,
    "address": "63 Babcock St, Unit A-1 & G11",
    "parcel_id": "047-04-18",
    "owner1": "RAPHAEL, JAYNE",
    "owner2": "SIMMONS, JEFFREY",
    "current_taxes": 6173.96,
    "new_taxes_no_override": 6440.68,
    "override_total_1": 6623.42,
    "override_increase_1": 182.75
  },
  {
    "#": "63 Babcock St, Unit A-2 & P17 (047-04-19)",
    "$": 867400,
    "address": "63 Babcock St, Unit A-2 & P17",
    "parcel_id": "047-04-19",
    "owner1": "HWEE TR, JEAN",
    "owner2": "",
    "current_taxes": 8882.18,
    "new_taxes_no_override": 9265.89,
    "override_total_1": 9528.8,
    "override_increase_1": 262.91
  },
  {
    "#": "63 Babcock St, Unit A-3 & G2 (047-04-20)",
    "$": 935400,
    "address": "63 Babcock St, Unit A-3 & G2",
    "parcel_id": "047-04-20",
    "owner1": "SONG, CHENLU",
    "owner2": "",
    "current_taxes": 9578.5,
    "new_taxes_no_override": 9992.29,
    "override_total_1": 10275.81,
    "override_increase_1": 283.52
  },
  {
    "#": "63 Babcock St, Unit B-1 & P25 (047-04-21)",
    "$": 869000,
    "address": "63 Babcock St, Unit B-1 & P25",
    "parcel_id": "047-04-21",
    "owner1": "WU, DAI-RONG",
    "owner2": "",
    "current_taxes": 8898.56,
    "new_taxes_no_override": 9282.98,
    "override_total_1": 9546.38,
    "override_increase_1": 263.4
  },
  {
    "#": "63 Babcock St, Unit B-2 & P16 (047-04-22)",
    "$": 917600,
    "address": "63 Babcock St, Unit B-2 & P16",
    "parcel_id": "047-04-22",
    "owner1": "NIEMINEN, ERIC",
    "owner2": "KING, CAROLYN",
    "current_taxes": 9396.22,
    "new_taxes_no_override": 9802.14,
    "override_total_1": 10080.26,
    "override_increase_1": 278.13
  },
  {
    "#": "63 Babcock St, Unit B-3 & P15 (047-04-23)",
    "$": 911400,
    "address": "63 Babcock St, Unit B-3 & P15",
    "parcel_id": "047-04-23",
    "owner1": "CHHENG, SUNNUARITH",
    "owner2": "",
    "current_taxes": 5697.8,
    "new_taxes_no_override": 5943.94,
    "override_total_1": 6112.6,
    "override_increase_1": 168.65
  },
  {
    "#": "65 Babcock St, Unit A-1 & P20 (047-04-24)",
    "$": 1177000,
    "address": "65 Babcock St, Unit A-1 & P20",
    "parcel_id": "047-04-24",
    "owner1": "MANWARING TR, JANE M",
    "owner2": "",
    "current_taxes": 8417.55,
    "new_taxes_no_override": 8781.19,
    "override_total_1": 9030.35,
    "override_increase_1": 249.16
  },
  {
    "#": "65 Babcock St, Unit A-2 & P18 (047-04-25)",
    "$": 1265300,
    "address": "65 Babcock St, Unit A-2 & P18",
    "parcel_id": "047-04-25",
    "owner1": "MOCHE, RICHARD H",
    "owner2": "BROWN, HEIDI F",
    "current_taxes": 9321.74,
    "new_taxes_no_override": 9724.44,
    "override_total_1": 10000.36,
    "override_increase_1": 275.92
  },
  {
    "#": "65 Babcock St, Unit A-3 & P22 (047-04-26)",
    "$": 1208200,
    "address": "65 Babcock St, Unit A-3 & P22",
    "parcel_id": "047-04-26",
    "owner1": "PITTS TRS, W EDWARD III & SARAH A B",
    "owner2": "",
    "current_taxes": 8737.03,
    "new_taxes_no_override": 9114.47,
    "override_total_1": 9373.09,
    "override_increase_1": 258.62
  },
  {
    "#": "65 Babcock St, Unit B-1 & P21 (047-04-27)",
    "$": 1089900,
    "address": "65 Babcock St, Unit B-1 & P21",
    "parcel_id": "047-04-27",
    "owner1": "PERLMAN, LINDA & RICHARD TR",
    "owner2": "",
    "current_taxes": 7525.64,
    "new_taxes_no_override": 7850.75,
    "override_total_1": 8073.51,
    "override_increase_1": 222.76
  },
  {
    "#": "65 Babcock St, Unit B-2 & P23 (047-04-28)",
    "$": 1218000,
    "address": "65 Babcock St, Unit B-2 & P23",
    "parcel_id": "047-04-28",
    "owner1": "KANG, BYUNG HAK",
    "owner2": "LEE, STELLA SUYONG",
    "current_taxes": 8837.39,
    "new_taxes_no_override": 9219.17,
    "override_total_1": 9480.75,
    "override_increase_1": 261.59
  },
  {
    "#": "65 Babcock St, Unit B-3 & P14 (047-04-29)",
    "$": 1114900,
    "address": "65 Babcock St, Unit B-3 & P14",
    "parcel_id": "047-04-29",
    "owner1": "SHTERN, VICTOR & LUDMILLA",
    "owner2": "",
    "current_taxes": 11416.58,
    "new_taxes_no_override": 11909.78,
    "override_total_1": 12247.71,
    "override_increase_1": 337.93
  },
  {
    "#": "69 Babcock St (047-09-00)",
    "$": 3968900,
    "address": "69 Babcock St",
    "parcel_id": "047-09-00",
    "owner1": "69 BABCOCK ST LLC",
    "owner2": "",
    "current_taxes": 40641.54,
    "new_taxes_no_override": 42397.25,
    "override_total_1": 43600.24,
    "override_increase_1": 1202.99
  },
  {
    "#": "71 Babcock St, Unit 1 (047-10-36)",
    "$": 771800,
    "address": "71 Babcock St, Unit 1",
    "parcel_id": "047-10-36",
    "owner1": "MAR TR, DEBORAH",
    "owner2": "",
    "current_taxes": 4268.3,
    "new_taxes_no_override": 4452.69,
    "override_total_1": 4579.03,
    "override_increase_1": 126.34
  },
  {
    "#": "71 Babcock St, Unit 2 & P26 (047-10-01)",
    "$": 524300,
    "address": "71 Babcock St, Unit 2 & P26",
    "parcel_id": "047-10-01",
    "owner1": "WEI TRS, ZONGJIE",
    "owner2": "CHEN, LI",
    "current_taxes": 5368.83,
    "new_taxes_no_override": 5600.76,
    "override_total_1": 5759.68,
    "override_increase_1": 158.92
  },
  {
    "#": "71 Babcock St, Unit 3 & P6 (047-10-02)",
    "$": 832200,
    "address": "71 Babcock St, Unit 3 & P6",
    "parcel_id": "047-10-02",
    "owner1": "PENG, CHENG",
    "owner2": "LIU, PENG",
    "current_taxes": 4886.79,
    "new_taxes_no_override": 5097.9,
    "override_total_1": 5242.55,
    "override_increase_1": 144.65
  },
  {
    "#": "71 Babcock St, Unit 4 (047-10-03)",
    "$": 487400,
    "address": "71 Babcock St, Unit 4",
    "parcel_id": "047-10-03",
    "owner1": "WOPAT, JAMES R",
    "owner2": "",
    "current_taxes": 4990.98,
    "new_taxes_no_override": 5206.59,
    "override_total_1": 5354.32,
    "override_increase_1": 147.73
  },
  {
    "#": "71 Babcock St, Unit 5 & P23 (047-10-04)",
    "$": 823000,
    "address": "71 Babcock St, Unit 5 & P23",
    "parcel_id": "047-10-04",
    "owner1": "XIE, YIFU",
    "owner2": "",
    "current_taxes": 8427.52,
    "new_taxes_no_override": 8791.59,
    "override_total_1": 9041.04,
    "override_increase_1": 249.45
  },
  {
    "#": "71 Babcock St, Unit 6 & P5 (047-10-05)",
    "$": 539900,
    "address": "71 Babcock St, Unit 6 & P5",
    "parcel_id": "047-10-05",
    "owner1": "COME, KATHLEEN",
    "owner2": "",
    "current_taxes": 5528.58,
    "new_taxes_no_override": 5767.41,
    "override_total_1": 5931.06,
    "override_increase_1": 163.65
  },
  {
    "#": "74 Babcock St (049-15-00)",
    "$": 4788800,
    "address": "74 Babcock St",
    "parcel_id": "049-15-00",
    "owner1": "GIBCO II REALTY LLC",
    "owner2": "",
    "current_taxes": 49037.31,
    "new_taxes_no_override": 51155.72,
    "override_total_1": 52607.23,
    "override_increase_1": 1451.5
  },
  {
    "#": "77 Babcock St (034-01-00)",
    "$": 78400,
    "address": "77 Babcock St",
    "parcel_id": "034-01-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O DWIGHT SQUARE",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "80 Babcock St (049-14-00)",
    "$": 3034300,
    "address": "80 Babcock St",
    "parcel_id": "049-14-00",
    "owner1": "DANTZIG, CYNTHIA",
    "owner2": "",
    "current_taxes": 27436.3,
    "new_taxes_no_override": 28621.55,
    "override_total_1": 29433.66,
    "override_increase_1": 812.11
  },
  {
    "#": "86 Babcock St, Unit 1 & 2 Pk Sps (049-13-01)",
    "$": 2030600,
    "address": "86 Babcock St, Unit 1 & 2 Pk Sps",
    "parcel_id": "049-13-01",
    "owner1": "FALK, PHILLIP  HALE & ELISA NABEL",
    "owner2": "",
    "current_taxes": 17158.41,
    "new_taxes_no_override": 17899.65,
    "override_total_1": 18407.54,
    "override_increase_1": 507.89
  },
  {
    "#": "86 Babcock St, Unit 2 & 2 Pk Sps (049-13-02)",
    "$": 2326100,
    "address": "86 Babcock St, Unit 2 & 2 Pk Sps",
    "parcel_id": "049-13-02",
    "owner1": "STERNMAN, JULIA",
    "owner2": "GIOCONDI, ANDREW",
    "current_taxes": 23819.26,
    "new_taxes_no_override": 24848.25,
    "override_total_1": 25553.3,
    "override_increase_1": 705.05
  },
  {
    "#": "90 Babcock St, Unit 1 & 3 Pk Sps (049-12-01)",
    "$": 2147100,
    "address": "90 Babcock St, Unit 1 & 3 Pk Sps",
    "parcel_id": "049-12-01",
    "owner1": "TAM, ERIC",
    "owner2": "TRAN , NANCY T",
    "current_taxes": 21986.3,
    "new_taxes_no_override": 22936.11,
    "override_total_1": 23586.9,
    "override_increase_1": 650.79
  },
  {
    "#": "90 Babcock St, Unit 2 & 3 Pk Sps (049-12-02)",
    "$": 2584500,
    "address": "90 Babcock St, Unit 2 & 3 Pk Sps",
    "parcel_id": "049-12-02",
    "owner1": "WEBER, GRIFFIN M",
    "owner2": "",
    "current_taxes": 22830.35,
    "new_taxes_no_override": 23816.62,
    "override_total_1": 24492.4,
    "override_increase_1": 675.78
  },
  {
    "#": "91 Babcock St (033-03-00)",
    "$": 2674900,
    "address": "91 Babcock St",
    "parcel_id": "033-03-00",
    "owner1": "APALIS LLC",
    "owner2": "",
    "current_taxes": 45901.28,
    "new_taxes_no_override": 47884.22,
    "override_total_1": 49242.89,
    "override_increase_1": 1358.68
  },
  {
    "#": "94 Babcock St (049-11-00)",
    "$": 2831500,
    "address": "94 Babcock St",
    "parcel_id": "049-11-00",
    "owner1": "SCHWARTZ, RICHARD B",
    "owner2": "VARTIKAR, JASMINE",
    "current_taxes": 25359.63,
    "new_taxes_no_override": 26455.17,
    "override_total_1": 27205.81,
    "override_increase_1": 750.65
  },
  {
    "#": "95 Babcock St (033-04-00)",
    "$": 3068500,
    "address": "95 Babcock St",
    "parcel_id": "033-04-00",
    "owner1": "TADVALKAR, CHETAN & LAURA",
    "owner2": "",
    "current_taxes": 27786.51,
    "new_taxes_no_override": 28986.89,
    "override_total_1": 29809.37,
    "override_increase_1": 822.48
  },
  {
    "#": "99 Babcock St (033-05-03)",
    "$": 2411700,
    "address": "99 Babcock St",
    "parcel_id": "033-05-03",
    "owner1": "ANGRIST, JOSHUA & MIRIAM",
    "owner2": "",
    "current_taxes": 21060.87,
    "new_taxes_no_override": 21970.7,
    "override_total_1": 22594.1,
    "override_increase_1": 623.4
  },
  {
    "#": "104 Babcock St, Unit 1 & P4 G5 (049-09-04)",
    "$": 2241800,
    "address": "104 Babcock St, Unit 1 & P4 G5",
    "parcel_id": "049-09-04",
    "owner1": "GREGORY, MATTHEW C & HEEJIN",
    "owner2": "",
    "current_taxes": 19321.1,
    "new_taxes_no_override": 20155.77,
    "override_total_1": 20727.68,
    "override_increase_1": 571.9
  },
  {
    "#": "104 Babcock St, Unit 2 & P7 P8 (049-09-01)",
    "$": 1529500,
    "address": "104 Babcock St, Unit 2 & P7 P8",
    "parcel_id": "049-09-01",
    "owner1": "SAMUELSON TR, HARRIET",
    "owner2": "",
    "current_taxes": 12027.15,
    "new_taxes_no_override": 12546.72,
    "override_total_1": 12902.73,
    "override_increase_1": 356.0
  },
  {
    "#": "104 Babcock St, Unit 3 (049-09-02)",
    "$": 1736000,
    "address": "104 Babcock St, Unit 3",
    "parcel_id": "049-09-02",
    "owner1": "LEUNG, EMILY",
    "owner2": "SANSOM, RYAN",
    "current_taxes": 14141.71,
    "new_taxes_no_override": 14752.63,
    "override_total_1": 15171.23,
    "override_increase_1": 418.59
  },
  {
    "#": "104 Babcock St, Unit 4 & P3 P6 (049-09-03)",
    "$": 1903600,
    "address": "104 Babcock St, Unit 4 & P3 P6",
    "parcel_id": "049-09-03",
    "owner1": "WEITZMAN TRS, DONALD C",
    "owner2": "GOLDBERG, HARRIET",
    "current_taxes": 19492.86,
    "new_taxes_no_override": 20334.95,
    "override_total_1": 20911.94,
    "override_increase_1": 576.99
  },
  {
    "#": "105 Babcock St (033-06-00)",
    "$": 3087100,
    "address": "105 Babcock St",
    "parcel_id": "033-06-00",
    "owner1": "GLICKENHAUS, LEE H",
    "owner2": "MOSKOWITZ, VICTORIA",
    "current_taxes": 27976.97,
    "new_taxes_no_override": 29185.58,
    "override_total_1": 30013.69,
    "override_increase_1": 828.12
  },
  {
    "#": "109 Babcock St, Unit 1 (033-07-01)",
    "$": 1944200,
    "address": "109 Babcock St, Unit 1",
    "parcel_id": "033-07-01",
    "owner1": "KAUFMAN, MARY & SETH",
    "owner2": "",
    "current_taxes": 16273.67,
    "new_taxes_no_override": 16976.69,
    "override_total_1": 17458.39,
    "override_increase_1": 481.7
  },
  {
    "#": "109 Babcock St, Unit 2 (033-07-02)",
    "$": 2188000,
    "address": "109 Babcock St, Unit 2",
    "parcel_id": "033-07-02",
    "owner1": "FOSTER, JESSICA A",
    "owner2": "BERKOWITZ, BENJAMIN H",
    "current_taxes": 18770.19,
    "new_taxes_no_override": 19581.06,
    "override_total_1": 20136.66,
    "override_increase_1": 555.6
  },
  {
    "#": "110 Babcock St (049-08-00)",
    "$": 14626300,
    "address": "110 Babcock St",
    "parcel_id": "049-08-00",
    "owner1": "IDRG LLC",
    "owner2": "C/O HAMILTON CO",
    "current_taxes": 149773.31,
    "new_taxes_no_override": 156243.52,
    "override_total_1": 160676.81,
    "override_increase_1": 4433.29
  },
  {
    "#": "113 Babcock St (033-08-00)",
    "$": 1359800,
    "address": "113 Babcock St",
    "parcel_id": "033-08-00",
    "owner1": "118 BABCOCK STREET LLC",
    "owner2": "C/O TREMONT ASSET MGMT LLC",
    "current_taxes": 13924.35,
    "new_taxes_no_override": 14525.88,
    "override_total_1": 14938.04,
    "override_increase_1": 412.16
  },
  {
    "#": "120 Babcock St (049-07-00)",
    "$": 28978900,
    "address": "120 Babcock St",
    "parcel_id": "049-07-00",
    "owner1": "118 BABCOCK STREET LLC",
    "owner2": "C/O TREMONT ASSET MGMT LLC",
    "current_taxes": 296743.94,
    "new_taxes_no_override": 309563.28,
    "override_total_1": 318346.9,
    "override_increase_1": 8783.62
  },
  {
    "#": "121 Babcock St, Unit 121 P5&6 (033-09-01)",
    "$": 2112600,
    "address": "121 Babcock St, Unit 121 P5&6",
    "parcel_id": "033-09-01",
    "owner1": "ISLA, DAMIAN",
    "owner2": "FARAGO, JULIA",
    "current_taxes": 21633.02,
    "new_taxes_no_override": 22567.57,
    "override_total_1": 23207.9,
    "override_increase_1": 640.34
  },
  {
    "#": "123 Babcock St, Unit 123 P1&2 (033-09-02)",
    "$": 1968000,
    "address": "123 Babcock St, Unit 123 P1&2",
    "parcel_id": "033-09-02",
    "owner1": "LEVI-MINZI, SIMONETTA",
    "owner2": "",
    "current_taxes": 20152.32,
    "new_taxes_no_override": 21022.9,
    "override_total_1": 21619.41,
    "override_increase_1": 596.51
  },
  {
    "#": "125 Babcock St, Unit 125 P3&4 (033-09-03)",
    "$": 2821000,
    "address": "125 Babcock St, Unit 125 P3&4",
    "parcel_id": "033-09-03",
    "owner1": "BREIMAN, GIL",
    "owner2": "DREWIACKI, HILLA",
    "current_taxes": 25252.11,
    "new_taxes_no_override": 26343.0,
    "override_total_1": 27090.46,
    "override_increase_1": 747.46
  },
  {
    "#": "129 Babcock St (032-01-00)",
    "$": 200700,
    "address": "129 Babcock St",
    "parcel_id": "032-01-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O FREEMAN SQUARE",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "136 Babcock St (049-06-01)",
    "$": 19176600,
    "address": "136 Babcock St",
    "parcel_id": "049-06-01",
    "owner1": "BABCOCK PLACE LLC",
    "owner2": "C/O TREMONT ASSET MGMT LLC",
    "current_taxes": 196368.38,
    "new_taxes_no_override": 204851.49,
    "override_total_1": 210664.0,
    "override_increase_1": 5812.5
  },
  {
    "#": "140 Babcock St (049-05-00)",
    "$": 1925700,
    "address": "140 Babcock St",
    "parcel_id": "049-05-00",
    "owner1": "YEE, EDWARD JAMES & KIMIKO S",
    "owner2": "",
    "current_taxes": 16084.23,
    "new_taxes_no_override": 16779.07,
    "override_total_1": 17255.16,
    "override_increase_1": 476.09
  },
  {
    "#": "143 Babcock St, Unit 1 & P3 (027-13-06)",
    "$": 810400,
    "address": "143 Babcock St, Unit 1 & P3",
    "parcel_id": "027-13-06",
    "owner1": "HU, CHEN",
    "owner2": "LI, CHENGYU",
    "current_taxes": 8298.5,
    "new_taxes_no_override": 8657.0,
    "override_total_1": 8902.63,
    "override_increase_1": 245.64
  },
  {
    "#": "143 Babcock St, Unit 2 & P6 (027-13-01)",
    "$": 819500,
    "address": "143 Babcock St, Unit 2 & P6",
    "parcel_id": "027-13-01",
    "owner1": "TAN TR, FIONA",
    "owner2": "",
    "current_taxes": 8391.68,
    "new_taxes_no_override": 8754.2,
    "override_total_1": 9002.59,
    "override_increase_1": 248.39
  },
  {
    "#": "143 Babcock St, Unit 3 & P7 (027-13-02)",
    "$": 843200,
    "address": "143 Babcock St, Unit 3 & P7",
    "parcel_id": "027-13-02",
    "owner1": "LIU, YUNFANG",
    "owner2": "",
    "current_taxes": 4999.43,
    "new_taxes_no_override": 5215.41,
    "override_total_1": 5363.39,
    "override_increase_1": 147.98
  },
  {
    "#": "143 Babcock St, Unit 4 & P4 (027-13-03)",
    "$": 837900,
    "address": "143 Babcock St, Unit 4 & P4",
    "parcel_id": "027-13-03",
    "owner1": "YU, TIAN",
    "owner2": "",
    "current_taxes": 8580.1,
    "new_taxes_no_override": 8950.76,
    "override_total_1": 9204.73,
    "override_increase_1": 253.97
  },
  {
    "#": "143 Babcock St, Unit 5 &P1 P2 (027-13-04)",
    "$": 872800,
    "address": "143 Babcock St, Unit 5 &P1 P2",
    "parcel_id": "027-13-04",
    "owner1": "MA, YOUXUAN & JINFENG",
    "owner2": "",
    "current_taxes": 8937.47,
    "new_taxes_no_override": 9323.57,
    "override_total_1": 9588.12,
    "override_increase_1": 264.55
  },
  {
    "#": "143 Babcock St, Unit 6 & P5 (027-13-05)",
    "$": 849500,
    "address": "143 Babcock St, Unit 6 & P5",
    "parcel_id": "027-13-05",
    "owner1": "CHIAO, JEN-HSIN & CHANG-TAI",
    "owner2": "",
    "current_taxes": 8698.88,
    "new_taxes_no_override": 9074.67,
    "override_total_1": 9332.16,
    "override_increase_1": 257.49
  },
  {
    "#": "145 Babcock St, Unit 1 & Pk Sp E (027-14-01)",
    "$": 813900,
    "address": "145 Babcock St, Unit 1 & Pk Sp E",
    "parcel_id": "027-14-01",
    "owner1": "PILTCH, SARAH",
    "owner2": "",
    "current_taxes": 8334.34,
    "new_taxes_no_override": 8694.38,
    "override_total_1": 8941.08,
    "override_increase_1": 246.7
  },
  {
    "#": "145 Babcock St, Unit 2 (027-14-02)",
    "$": 786500,
    "address": "145 Babcock St, Unit 2",
    "parcel_id": "027-14-02",
    "owner1": "CHIANG, DAVID",
    "owner2": "MALIAKKAL, JOSEPH",
    "current_taxes": 8053.76,
    "new_taxes_no_override": 8401.68,
    "override_total_1": 8640.07,
    "override_increase_1": 238.39
  },
  {
    "#": "145 Babcock St, Unit 3 (027-14-03)",
    "$": 932200,
    "address": "145 Babcock St, Unit 3",
    "parcel_id": "027-14-03",
    "owner1": "PETROVA, PETIA G",
    "owner2": "IVANOV, GUEORGUI D",
    "current_taxes": 9545.73,
    "new_taxes_no_override": 9958.11,
    "override_total_1": 10240.66,
    "override_increase_1": 282.55
  },
  {
    "#": "145 Babcock St, Unit 4 (027-14-04)",
    "$": 897300,
    "address": "145 Babcock St, Unit 4",
    "parcel_id": "027-14-04",
    "owner1": "JERMAIN, COLIN",
    "owner2": "NASR, PAMELA",
    "current_taxes": 5553.42,
    "new_taxes_no_override": 5793.33,
    "override_total_1": 5957.71,
    "override_increase_1": 164.38
  },
  {
    "#": "145 Babcock St, Unit 5 (027-14-05)",
    "$": 924900,
    "address": "145 Babcock St, Unit 5",
    "parcel_id": "027-14-05",
    "owner1": "BADER, PAUL S",
    "owner2": "BROWN, ELIZABETH M",
    "current_taxes": 9470.98,
    "new_taxes_no_override": 9880.13,
    "override_total_1": 10160.47,
    "override_increase_1": 280.34
  },
  {
    "#": "145 Babcock St, Unit 6 (027-14-06)",
    "$": 897300,
    "address": "145 Babcock St, Unit 6",
    "parcel_id": "027-14-06",
    "owner1": "KORZENDORFER, KATE S",
    "owner2": "",
    "current_taxes": 5553.42,
    "new_taxes_no_override": 5793.33,
    "override_total_1": 5957.71,
    "override_increase_1": 164.38
  },
  {
    "#": "145 Babcock St, Unit Pk Sp (027-14-08)",
    "$": 49000,
    "address": "145 Babcock St, Unit Pk Sp",
    "parcel_id": "027-14-08",
    "owner1": "KORZENDORFER, KATE S",
    "owner2": "",
    "current_taxes": 501.76,
    "new_taxes_no_override": 523.44,
    "override_total_1": 538.29,
    "override_increase_1": 14.85
  },
  {
    "#": "147 Babcock St, Unit 7 & P42 (027-14-07)",
    "$": 614400,
    "address": "147 Babcock St, Unit 7 & P42",
    "parcel_id": "027-14-07",
    "owner1": "JIA, GEORGE D & WENDY Y",
    "owner2": "",
    "current_taxes": 6291.46,
    "new_taxes_no_override": 6563.25,
    "override_total_1": 6749.48,
    "override_increase_1": 186.23
  },
  {
    "#": "148 Babcock St (049-04-00)",
    "$": 2341100,
    "address": "148 Babcock St",
    "parcel_id": "049-04-00",
    "owner1": "YUAN, ZUO",
    "owner2": "LI, HONGWU",
    "current_taxes": 20337.93,
    "new_taxes_no_override": 21216.53,
    "override_total_1": 21818.53,
    "override_increase_1": 602.0
  },
  {
    "#": "149 Babcock St, Unit 149 (027-17-07)",
    "$": 3498200,
    "address": "149 Babcock St, Unit 149",
    "parcel_id": "027-17-07",
    "owner1": "TICHO, BARUCH S",
    "owner2": "AUGUST, ALLISON M",
    "current_taxes": 35821.57,
    "new_taxes_no_override": 37369.06,
    "override_total_1": 38429.38,
    "override_increase_1": 1060.32
  },
  {
    "#": "149 Babcock St, Unit 151 (027-17-08)",
    "$": 3046000,
    "address": "149 Babcock St, Unit 151",
    "parcel_id": "027-17-08",
    "owner1": "STANZLER, LAUREN",
    "owner2": "KLIGER, YITZCHAK",
    "current_taxes": 27556.11,
    "new_taxes_no_override": 28746.53,
    "override_total_1": 29562.19,
    "override_increase_1": 815.66
  },
  {
    "#": "153 Babcock St (027-17-02)",
    "$": 4198700,
    "address": "153 Babcock St",
    "parcel_id": "027-17-02",
    "owner1": "TROMER, SHLOMIT AZGAD & ERAN",
    "owner2": "",
    "current_taxes": 39359.75,
    "new_taxes_no_override": 41060.09,
    "override_total_1": 42225.14,
    "override_increase_1": 1165.05
  },
  {
    "#": "156 Babcock St (049-03-00)",
    "$": 2692200,
    "address": "156 Babcock St",
    "parcel_id": "049-03-00",
    "owner1": "MONIZ TRS, ERNEST J & NAOMI HOKI",
    "owner2": "",
    "current_taxes": 23933.19,
    "new_taxes_no_override": 24967.1,
    "override_total_1": 25675.53,
    "override_increase_1": 708.42
  },
  {
    "#": "157 Babcock St, Unit 1 & G1 P5 (027-17-04)",
    "$": 2368100,
    "address": "157 Babcock St, Unit 1 & G1 P5",
    "parcel_id": "027-17-04",
    "owner1": "MCPHERSON, LUCIANN T",
    "owner2": "",
    "current_taxes": 24249.34,
    "new_taxes_no_override": 25296.91,
    "override_total_1": 26014.69,
    "override_increase_1": 717.78
  },
  {
    "#": "157 Babcock St, Unit 2 & G2 P6& P8 (027-17-05)",
    "$": 2414400,
    "address": "157 Babcock St, Unit 2 & G2 P6& P8",
    "parcel_id": "027-17-05",
    "owner1": "HINMAN, MEGAN",
    "owner2": "OCONNOR, THOMAS",
    "current_taxes": 21088.52,
    "new_taxes_no_override": 21999.54,
    "override_total_1": 22623.76,
    "override_increase_1": 624.22
  },
  {
    "#": "157 Babcock St, Unit 3 & G3 P7 (027-17-06)",
    "$": 1515200,
    "address": "157 Babcock St, Unit 3 & G3 P7",
    "parcel_id": "027-17-06",
    "owner1": "OCONNOR TR, THOMAS M",
    "owner2": "",
    "current_taxes": 15515.65,
    "new_taxes_no_override": 16185.93,
    "override_total_1": 16645.19,
    "override_increase_1": 459.26
  },
  {
    "#": "162 Babcock St (053-01-00)",
    "$": 2430100,
    "address": "162 Babcock St",
    "parcel_id": "053-01-00",
    "owner1": "162 BABCOCK STREET LLC",
    "owner2": "C/O TREMONT ASSET MANAGEMENT LLC",
    "current_taxes": 24884.22,
    "new_taxes_no_override": 25959.22,
    "override_total_1": 26695.79,
    "override_increase_1": 736.57
  },
  {
    "#": "163 Babcock St (027-18-00)",
    "$": 2497700,
    "address": "163 Babcock St",
    "parcel_id": "027-18-00",
    "owner1": "COLBERT, KRISTINA",
    "owner2": "C/O LOURIE KRISTINA",
    "current_taxes": 21941.51,
    "new_taxes_no_override": 22889.38,
    "override_total_1": 23538.85,
    "override_increase_1": 649.47
  },
  {
    "#": "167 Babcock St, Unit 1 (027-19-01)",
    "$": 1265800,
    "address": "167 Babcock St, Unit 1",
    "parcel_id": "027-19-01",
    "owner1": "SHEENA TR, DAVID",
    "owner2": "C/O NEWMAN & NEWMAN PC",
    "current_taxes": 12961.79,
    "new_taxes_no_override": 13521.74,
    "override_total_1": 13905.41,
    "override_increase_1": 383.67
  },
  {
    "#": "167 Babcock St, Unit 2 (027-19-02)",
    "$": 1411900,
    "address": "167 Babcock St, Unit 2",
    "parcel_id": "027-19-02",
    "owner1": "GUZZETTI TRS, ALFRED F & DEBORAH FORTSON",
    "owner2": "",
    "current_taxes": 10822.92,
    "new_taxes_no_override": 11290.47,
    "override_total_1": 11610.83,
    "override_increase_1": 320.36
  },
  {
    "#": "170 Babcock St (053-17-00)",
    "$": 3057700,
    "address": "170 Babcock St",
    "parcel_id": "053-17-00",
    "owner1": "MEI, MARVIN & EILEEN",
    "owner2": "",
    "current_taxes": 31310.85,
    "new_taxes_no_override": 32663.48,
    "override_total_1": 33590.28,
    "override_increase_1": 926.8
  },
  {
    "#": "173 Babcock St (027-20-00)",
    "$": 3526900,
    "address": "173 Babcock St",
    "parcel_id": "027-20-00",
    "owner1": "KAZMI TRS, ANWAR H & NIKHAT A",
    "owner2": "",
    "current_taxes": 32480.52,
    "new_taxes_no_override": 33883.68,
    "override_total_1": 34845.1,
    "override_increase_1": 961.42
  },
  {
    "#": "177 Babcock St, Unit 1 (027-21-03)",
    "$": 1084800,
    "address": "177 Babcock St, Unit 1",
    "parcel_id": "027-21-03",
    "owner1": "TREVVETT, DAVID E  & MELISSA D",
    "owner2": "",
    "current_taxes": 7473.42,
    "new_taxes_no_override": 7796.27,
    "override_total_1": 8017.48,
    "override_increase_1": 221.21
  },
  {
    "#": "177 Babcock St, Unit 2 (027-21-01)",
    "$": 1122100,
    "address": "177 Babcock St, Unit 2",
    "parcel_id": "027-21-01",
    "owner1": "VINOGRAD, JOSEPH M",
    "owner2": "",
    "current_taxes": 7855.37,
    "new_taxes_no_override": 8194.72,
    "override_total_1": 8427.24,
    "override_increase_1": 232.52
  },
  {
    "#": "177 Babcock St, Unit 3 (027-21-02)",
    "$": 1153200,
    "address": "177 Babcock St, Unit 3",
    "parcel_id": "027-21-02",
    "owner1": "MCINTOSH, JANET",
    "owner2": "JEHN, THOMAS R",
    "current_taxes": 8173.83,
    "new_taxes_no_override": 8526.94,
    "override_total_1": 8768.88,
    "override_increase_1": 241.95
  },
  {
    "#": "179 Babcock St (027-22-00)",
    "$": 3486700,
    "address": "179 Babcock St",
    "parcel_id": "027-22-00",
    "owner1": "LADY B LLC",
    "owner2": "",
    "current_taxes": 35703.81,
    "new_taxes_no_override": 37246.21,
    "override_total_1": 38303.05,
    "override_increase_1": 1056.83
  },
  {
    "#": "182 Babcock St (054-01-00)",
    "$": 2284500,
    "address": "182 Babcock St",
    "parcel_id": "054-01-00",
    "owner1": "BABCOCK 182 LLC",
    "owner2": "",
    "current_taxes": 23393.28,
    "new_taxes_no_override": 24403.87,
    "override_total_1": 25096.31,
    "override_increase_1": 692.44
  },
  {
    "#": "183 Babcock St, Unit 1 (027-23-03)",
    "$": 1119400,
    "address": "183 Babcock St, Unit 1",
    "parcel_id": "027-23-03",
    "owner1": "NARAIN, NAMRATA",
    "owner2": "SINGAYAPALLY, SANKALP",
    "current_taxes": 7827.72,
    "new_taxes_no_override": 8165.88,
    "override_total_1": 8397.58,
    "override_increase_1": 231.7
  },
  {
    "#": "183 Babcock St, Unit 2 (027-23-01)",
    "$": 1150500,
    "address": "183 Babcock St, Unit 2",
    "parcel_id": "027-23-01",
    "owner1": "SEMPERT, MICHAEL",
    "owner2": "",
    "current_taxes": 8146.19,
    "new_taxes_no_override": 8498.11,
    "override_total_1": 8739.23,
    "override_increase_1": 241.13
  },
  {
    "#": "183 Babcock St, Unit 3 (027-23-02)",
    "$": 1159800,
    "address": "183 Babcock St, Unit 3",
    "parcel_id": "027-23-02",
    "owner1": "WANG, CHENGFANG",
    "owner2": "",
    "current_taxes": 8241.42,
    "new_taxes_no_override": 8597.45,
    "override_total_1": 8841.4,
    "override_increase_1": 243.95
  },
  {
    "#": "184 Babcock St (054-20-00)",
    "$": 1307100,
    "address": "184 Babcock St",
    "parcel_id": "054-20-00",
    "owner1": "BERNSTEIN, MARILYN",
    "owner2": "",
    "current_taxes": 13384.7,
    "new_taxes_no_override": 13962.92,
    "override_total_1": 14359.11,
    "override_increase_1": 396.19
  },
  {
    "#": "187 Babcock St, Unit 1 (027-24-03)",
    "$": 1380900,
    "address": "187 Babcock St, Unit 1",
    "parcel_id": "027-24-03",
    "owner1": "JOHNSON, PAUL",
    "owner2": "",
    "current_taxes": 10505.48,
    "new_taxes_no_override": 10959.32,
    "override_total_1": 11270.28,
    "override_increase_1": 310.96
  },
  {
    "#": "187 Babcock St, Unit 2 (027-24-01)",
    "$": 1226600,
    "address": "187 Babcock St, Unit 2",
    "parcel_id": "027-24-01",
    "owner1": "MONIZ, KATYA",
    "owner2": "",
    "current_taxes": 8925.45,
    "new_taxes_no_override": 9311.03,
    "override_total_1": 9575.22,
    "override_increase_1": 264.19
  },
  {
    "#": "187 Babcock St, Unit 3 (027-24-02)",
    "$": 1203400,
    "address": "187 Babcock St, Unit 3",
    "parcel_id": "027-24-02",
    "owner1": "FREESTONE, MITCHELL C",
    "owner2": "",
    "current_taxes": 12322.82,
    "new_taxes_no_override": 12855.17,
    "override_total_1": 13219.92,
    "override_increase_1": 364.76
  },
  {
    "#": "189 Babcock St, Unit 1 (027-25-01)",
    "$": 1620300,
    "address": "189 Babcock St, Unit 1",
    "parcel_id": "027-25-01",
    "owner1": "ZACHOS, ELIZABETH",
    "owner2": "",
    "current_taxes": 16591.87,
    "new_taxes_no_override": 17308.64,
    "override_total_1": 17799.76,
    "override_increase_1": 491.12
  },
  {
    "#": "189 Babcock St, Unit 2 (027-25-02)",
    "$": 1658900,
    "address": "189 Babcock St, Unit 2",
    "parcel_id": "027-25-02",
    "owner1": "KREMER TRS, CHRISTOPHER A & JEANNINE M",
    "owner2": "",
    "current_taxes": 13352.2,
    "new_taxes_no_override": 13929.02,
    "override_total_1": 14324.24,
    "override_increase_1": 395.23
  },
  {
    "#": "189 Babcock St, Unit 3 (027-25-03)",
    "$": 1728000,
    "address": "189 Babcock St, Unit 3",
    "parcel_id": "027-25-03",
    "owner1": "NARDONE, CHRISTOPHER",
    "owner2": "GU, XIN",
    "current_taxes": 14059.79,
    "new_taxes_no_override": 14667.17,
    "override_total_1": 15083.34,
    "override_increase_1": 416.17
  },
  {
    "#": "190 Babcock St (054-19-00)",
    "$": 1937300,
    "address": "190 Babcock St",
    "parcel_id": "054-19-00",
    "owner1": "BERNSTEIN, MARILYN",
    "owner2": "",
    "current_taxes": 16203.02,
    "new_taxes_no_override": 16902.99,
    "override_total_1": 17382.6,
    "override_increase_1": 479.61
  },
  {
    "#": "191 Babcock St (027-26-00)",
    "$": 2899100,
    "address": "191 Babcock St",
    "parcel_id": "027-26-00",
    "owner1": "LEE, TRS, EDNA & CYNTHIA E",
    "owner2": "",
    "current_taxes": 26051.85,
    "new_taxes_no_override": 27177.29,
    "override_total_1": 27948.42,
    "override_increase_1": 771.13
  },
  {
    "#": "195 Babcock St, Unit 1  Pk Sps A & B (027-27-01)",
    "$": 1274200,
    "address": "195 Babcock St, Unit 1  Pk Sps A & B",
    "parcel_id": "027-27-01",
    "owner1": "MICZEK TRS, JAMES C & LYNN P",
    "owner2": "",
    "current_taxes": 9412.87,
    "new_taxes_no_override": 9819.51,
    "override_total_1": 10098.13,
    "override_increase_1": 278.62
  },
  {
    "#": "195 Babcock St, Unit 2 & Pk Sp C (027-27-02)",
    "$": 1112100,
    "address": "195 Babcock St, Unit 2 & Pk Sp C",
    "parcel_id": "027-27-02",
    "owner1": "MICZEK, MICHAEL J & JENNIFER L",
    "owner2": "",
    "current_taxes": 11387.9,
    "new_taxes_no_override": 11879.86,
    "override_total_1": 12216.94,
    "override_increase_1": 337.08
  },
  {
    "#": "197 Babcock St, Unit 3 & P D-E & Gar (027-27-03)",
    "$": 1712300,
    "address": "197 Babcock St, Unit 3 & P D-E & Gar",
    "parcel_id": "027-27-03",
    "owner1": "CHEN TR, LIYING MICHELLE",
    "owner2": "",
    "current_taxes": 17533.95,
    "new_taxes_no_override": 18291.42,
    "override_total_1": 18810.42,
    "override_increase_1": 519.0
  },
  {
    "#": "198 Babcock St (055-01-00)",
    "$": 2879500,
    "address": "198 Babcock St",
    "parcel_id": "055-01-00",
    "owner1": "ROFFMAN, JONATHAN",
    "owner2": "LIEBERMAN, SARAH",
    "current_taxes": 25851.15,
    "new_taxes_no_override": 26967.92,
    "override_total_1": 27733.11,
    "override_increase_1": 765.19
  },
  {
    "#": "199 Babcock St, Unit 1 (027-28-01)",
    "$": 1684800,
    "address": "199 Babcock St, Unit 1",
    "parcel_id": "027-28-01",
    "owner1": "STEIN, NORMAN",
    "owner2": "LUBBER, MINDY",
    "current_taxes": 13617.42,
    "new_taxes_no_override": 14205.69,
    "override_total_1": 14608.77,
    "override_increase_1": 403.08
  },
  {
    "#": "199 Babcock St, Unit 2 (027-28-02)",
    "$": 1838800,
    "address": "199 Babcock St, Unit 2",
    "parcel_id": "027-28-02",
    "owner1": "ROSEN, TR, LINDA C",
    "owner2": "",
    "current_taxes": 15194.38,
    "new_taxes_no_override": 15850.78,
    "override_total_1": 16300.53,
    "override_increase_1": 449.75
  },
  {
    "#": "204 Babcock St (055-29-00)",
    "$": 2386000,
    "address": "204 Babcock St",
    "parcel_id": "055-29-00",
    "owner1": "YU, CHAN FAY",
    "owner2": "WOO-YU, MEI C",
    "current_taxes": 20797.71,
    "new_taxes_no_override": 21696.17,
    "override_total_1": 22311.78,
    "override_increase_1": 615.61
  },
  {
    "#": "205 Babcock St (027-29-00)",
    "$": 3051700,
    "address": "205 Babcock St",
    "parcel_id": "027-29-00",
    "owner1": "SHALISH, CHRISTO",
    "owner2": "BARAKAT, LANA",
    "current_taxes": 27614.47,
    "new_taxes_no_override": 28807.42,
    "override_total_1": 29624.8,
    "override_increase_1": 817.39
  },
  {
    "#": "209 Babcock St (027-30-00)",
    "$": 2447300,
    "address": "209 Babcock St",
    "parcel_id": "027-30-00",
    "owner1": "HRI HOSPITAL INC",
    "owner2": "C/O PROP VALUATION SERVICES",
    "current_taxes": 41995.67,
    "new_taxes_no_override": 43809.88,
    "override_total_1": 45052.95,
    "override_increase_1": 1243.07
  },
  {
    "#": "210 Babcock St (055-28-01)",
    "$": 2604000,
    "address": "210 Babcock St",
    "parcel_id": "055-28-01",
    "owner1": "210 BABCOCK STREET LLC",
    "owner2": "",
    "current_taxes": 26664.96,
    "new_taxes_no_override": 27816.89,
    "override_total_1": 28606.17,
    "override_increase_1": 789.28
  },
  {
    "#": "215 Babcock St (027-31-00)",
    "$": 1949500,
    "address": "215 Babcock St",
    "parcel_id": "027-31-00",
    "owner1": "HRI HOSPITAL INC",
    "owner2": "C/O PROP VALUATION SERVICES",
    "current_taxes": 33453.42,
    "new_taxes_no_override": 34898.61,
    "override_total_1": 35888.83,
    "override_increase_1": 990.22
  },
  {
    "#": "222 Babcock St (056-01-16)",
    "$": 25281600,
    "address": "222 Babcock St",
    "parcel_id": "056-01-16",
    "owner1": "BABCOCK STREET ASSOCIATES LLC",
    "owner2": "",
    "current_taxes": 258883.58,
    "new_taxes_no_override": 270067.35,
    "override_total_1": 277730.3,
    "override_increase_1": 7662.95
  },
  {
    "#": "227 Babcock St (027-32-34)",
    "$": 11327300,
    "address": "227 Babcock St",
    "parcel_id": "027-32-34",
    "owner1": "HRI HOSPITAL INC",
    "owner2": "C/O PROP VALUATION SERVICES",
    "current_taxes": 194376.47,
    "new_taxes_no_override": 202773.53,
    "override_total_1": 208527.08,
    "override_increase_1": 5753.54
  },
  {
    "#": "240 Babcock St (056-15-00)",
    "$": 3498900,
    "address": "240 Babcock St",
    "parcel_id": "056-15-00",
    "owner1": "HOANG TRS, KENNETH & HELEN",
    "owner2": "",
    "current_taxes": 35828.74,
    "new_taxes_no_override": 37376.54,
    "override_total_1": 38437.07,
    "override_increase_1": 1060.53
  },
  {
    "#": " Babcock St (048-09-00)",
    "$": 235500,
    "address": " Babcock St",
    "parcel_id": "048-09-00",
    "owner1": "ZAZULA, GREGORY",
    "owner2": "",
    "current_taxes": 2411.52,
    "new_taxes_no_override": 2515.7,
    "override_total_1": 2587.08,
    "override_increase_1": 71.38
  },
  {
    "#": "5 Baker Cir (365-24-00)",
    "$": 1686300,
    "address": "5 Baker Cir",
    "parcel_id": "365-24-00",
    "owner1": "5 BAKER CIRCLE LLC",
    "owner2": "C/O MATRIX FINANCIAL",
    "current_taxes": 17267.71,
    "new_taxes_no_override": 18013.68,
    "override_total_1": 18524.8,
    "override_increase_1": 511.12
  },
  {
    "#": "11 Baker Cir (365-23-00)",
    "$": 1721100,
    "address": "11 Baker Cir",
    "parcel_id": "365-23-00",
    "owner1": "COUREY, TR, NORMAN L",
    "owner2": "",
    "current_taxes": 13989.13,
    "new_taxes_no_override": 14593.46,
    "override_total_1": 15007.54,
    "override_increase_1": 414.08
  },
  {
    "#": "17 Baker Cir (365-22-00)",
    "$": 1931700,
    "address": "17 Baker Cir",
    "parcel_id": "365-22-00",
    "owner1": "HAUSER, THOMAS H",
    "owner2": "BASHAR, BELA R",
    "current_taxes": 16145.67,
    "new_taxes_no_override": 16843.16,
    "override_total_1": 17321.07,
    "override_increase_1": 477.91
  },
  {
    "#": "25 Baker Cir (365-21-00)",
    "$": 1349600,
    "address": "25 Baker Cir",
    "parcel_id": "365-21-00",
    "owner1": "WINESTEIN, LEONID G",
    "owner2": "MINKINA, NATALY",
    "current_taxes": 10184.97,
    "new_taxes_no_override": 10624.96,
    "override_total_1": 10926.44,
    "override_increase_1": 301.48
  },
  {
    "#": "30 Baker Cir (365-09-00)",
    "$": 1983700,
    "address": "30 Baker Cir",
    "parcel_id": "365-09-00",
    "owner1": "SATO, LUKE & YUKO",
    "owner2": "",
    "current_taxes": 16678.15,
    "new_taxes_no_override": 17398.65,
    "override_total_1": 17892.32,
    "override_increase_1": 493.67
  },
  {
    "#": "31 Baker Cir (365-20-00)",
    "$": 1863200,
    "address": "31 Baker Cir",
    "parcel_id": "365-20-00",
    "owner1": "BRINCKERHOFF, ET AL, LAURENCE H",
    "owner2": "",
    "current_taxes": 19079.17,
    "new_taxes_no_override": 19903.39,
    "override_total_1": 20468.13,
    "override_increase_1": 564.74
  },
  {
    "#": "37 Baker Cir (365-19-00)",
    "$": 1322500,
    "address": "37 Baker Cir",
    "parcel_id": "365-19-00",
    "owner1": "MACFADDEN, PATRICK T",
    "owner2": "",
    "current_taxes": 13542.4,
    "new_taxes_no_override": 14127.43,
    "override_total_1": 14528.29,
    "override_increase_1": 400.86
  },
  {
    "#": "38 Baker Cir (365-10-00)",
    "$": 2030300,
    "address": "38 Baker Cir",
    "parcel_id": "365-10-00",
    "owner1": "MAGAZINER, JONATHAN & JENNIFER DOORLY",
    "owner2": "",
    "current_taxes": 17155.34,
    "new_taxes_no_override": 17896.45,
    "override_total_1": 18404.25,
    "override_increase_1": 507.8
  },
  {
    "#": "44 Baker Cir (365-11-00)",
    "$": 1780100,
    "address": "44 Baker Cir",
    "parcel_id": "365-11-00",
    "owner1": "CHURWIN, SHARI & MICHAEL",
    "owner2": "",
    "current_taxes": 14593.29,
    "new_taxes_no_override": 15223.72,
    "override_total_1": 15655.68,
    "override_increase_1": 431.96
  },
  {
    "#": "45 Baker Cir (365-17-18)",
    "$": 1435100,
    "address": "45 Baker Cir",
    "parcel_id": "365-17-18",
    "owner1": "JAFFE TRS, ABRAHAM & ARLENE I",
    "owner2": "",
    "current_taxes": 11060.49,
    "new_taxes_no_override": 11538.3,
    "override_total_1": 11865.69,
    "override_increase_1": 327.39
  },
  {
    "#": "51 Baker Cir (365-16-02)",
    "$": 2132000,
    "address": "51 Baker Cir",
    "parcel_id": "365-16-02",
    "owner1": "AMARNEH, MOHAMMAD",
    "owner2": "AL RASHAIDEH, TASNIM",
    "current_taxes": 18196.75,
    "new_taxes_no_override": 18982.85,
    "override_total_1": 19521.47,
    "override_increase_1": 538.62
  },
  {
    "#": "55 Baker Cir (365-16-01)",
    "$": 2472300,
    "address": "55 Baker Cir",
    "parcel_id": "365-16-01",
    "owner1": "BETTENHAUSER, GEORG & NIRLAP",
    "owner2": "",
    "current_taxes": 21681.42,
    "new_taxes_no_override": 22618.06,
    "override_total_1": 23259.83,
    "override_increase_1": 641.77
  },
  {
    "#": "56 Baker Cir (365-12-00)",
    "$": 1931000,
    "address": "56 Baker Cir",
    "parcel_id": "365-12-00",
    "owner1": "PANTHER TR, LORI A",
    "owner2": "",
    "current_taxes": 16138.51,
    "new_taxes_no_override": 16835.69,
    "override_total_1": 17313.39,
    "override_increase_1": 477.7
  },
  {
    "#": "61 Baker Cir (365-15-00)",
    "$": 1583200,
    "address": "61 Baker Cir",
    "parcel_id": "365-15-00",
    "owner1": "MURPHY TRS, PATTY W & RICHARD M",
    "owner2": "",
    "current_taxes": 12577.03,
    "new_taxes_no_override": 13120.36,
    "override_total_1": 13492.64,
    "override_increase_1": 372.28
  },
  {
    "#": "62 Baker Cir (365-13-00)",
    "$": 1786700,
    "address": "62 Baker Cir",
    "parcel_id": "365-13-00",
    "owner1": "MURPHY, JOSLIN H",
    "owner2": "",
    "current_taxes": 14660.87,
    "new_taxes_no_override": 15294.22,
    "override_total_1": 15728.18,
    "override_increase_1": 433.96
  },
  {
    "#": "66 Baker Cir (365-14-00)",
    "$": 1296300,
    "address": "66 Baker Cir",
    "parcel_id": "365-14-00",
    "owner1": "MURPHY, JOSLIN",
    "owner2": "",
    "current_taxes": 13274.11,
    "new_taxes_no_override": 13847.55,
    "override_total_1": 14240.47,
    "override_increase_1": 392.91
  },
  {
    "#": "5 Bartlett Cres (093-16-00)",
    "$": 2636100,
    "address": "5 Bartlett Cres",
    "parcel_id": "093-16-00",
    "owner1": "GILBERT, YUVAL S & BONNY M",
    "owner2": "",
    "current_taxes": 23358.73,
    "new_taxes_no_override": 24367.83,
    "override_total_1": 25059.25,
    "override_increase_1": 691.42
  },
  {
    "#": "9 Bartlett Cres, Unit 1 & P3 (093-17-01)",
    "$": 1880400,
    "address": "9 Bartlett Cres, Unit 1 & P3",
    "parcel_id": "093-17-01",
    "owner1": "CHIU, PETER",
    "owner2": "BROWN, JENNIFER RYAN",
    "current_taxes": 15620.36,
    "new_taxes_no_override": 16295.16,
    "override_total_1": 16757.52,
    "override_increase_1": 462.36
  },
  {
    "#": "9 Bartlett Cres, Unit 2 & P1-2 (093-17-02)",
    "$": 1727400,
    "address": "9 Bartlett Cres, Unit 2 & P1-2",
    "parcel_id": "093-17-02",
    "owner1": "BENOIT TRS, ERIC & ALINA",
    "owner2": "",
    "current_taxes": 14053.64,
    "new_taxes_no_override": 14660.76,
    "override_total_1": 15076.74,
    "override_increase_1": 415.99
  },
  {
    "#": "13 Bartlett Cres, Unit 1 (093-18-01)",
    "$": 1227100,
    "address": "13 Bartlett Cres, Unit 1",
    "parcel_id": "093-18-01",
    "owner1": "RITZENTHALER, NATHANIEL & KARLA",
    "owner2": "",
    "current_taxes": 12565.5,
    "new_taxes_no_override": 13108.33,
    "override_total_1": 13480.27,
    "override_increase_1": 371.94
  },
  {
    "#": "13 Bartlett Cres, Unit 2 (093-18-02)",
    "$": 1363200,
    "address": "13 Bartlett Cres, Unit 2",
    "parcel_id": "093-18-02",
    "owner1": "RITZENTHALER, NATHANIEL JOHN & KARLA",
    "owner2": "",
    "current_taxes": 10324.23,
    "new_taxes_no_override": 10770.24,
    "override_total_1": 11075.83,
    "override_increase_1": 305.6
  },
  {
    "#": "17 Bartlett Cres, Unit 1 (093-19-01)",
    "$": 1158900,
    "address": "17 Bartlett Cres, Unit 1",
    "parcel_id": "093-19-01",
    "owner1": "BLAUM, JOAQUIN",
    "owner2": "FISZBEIN, ANA",
    "current_taxes": 8232.2,
    "new_taxes_no_override": 8587.83,
    "override_total_1": 8831.5,
    "override_increase_1": 243.67
  },
  {
    "#": "17 Bartlett Cres, Unit 2 (093-19-02)",
    "$": 1261000,
    "address": "17 Bartlett Cres, Unit 2",
    "parcel_id": "093-19-02",
    "owner1": "CAMERON, LISA C & JAMES F",
    "owner2": "",
    "current_taxes": 9277.71,
    "new_taxes_no_override": 9678.51,
    "override_total_1": 9953.13,
    "override_increase_1": 274.62
  },
  {
    "#": "21 Bartlett Cres (093-20-00)",
    "$": 2747100,
    "address": "21 Bartlett Cres",
    "parcel_id": "093-20-00",
    "owner1": "FISCHER, ANDREW M",
    "owner2": "JASON, LINDA G",
    "current_taxes": 24495.37,
    "new_taxes_no_override": 25553.57,
    "override_total_1": 26278.63,
    "override_increase_1": 725.06
  },
  {
    "#": "24 Bartlett Cres, Unit 1 (094-12-01)",
    "$": 1685200,
    "address": "24 Bartlett Cres, Unit 1",
    "parcel_id": "094-12-01",
    "owner1": "ZOU, YUAN",
    "owner2": "",
    "current_taxes": 17256.45,
    "new_taxes_no_override": 18001.93,
    "override_total_1": 18512.72,
    "override_increase_1": 510.79
  },
  {
    "#": "24 Bartlett Cres, Unit 2 (094-12-02)",
    "$": 1764800,
    "address": "24 Bartlett Cres, Unit 2",
    "parcel_id": "094-12-02",
    "owner1": "BERNSTEIN TRS, ETHAN ZEV",
    "owner2": "DUNNE, JULIE PRASAD",
    "current_taxes": 18071.55,
    "new_taxes_no_override": 18852.24,
    "override_total_1": 19387.16,
    "override_increase_1": 534.92
  },
  {
    "#": "25 Bartlett Cres, Unit 1 (093-21-01)",
    "$": 1260500,
    "address": "25 Bartlett Cres, Unit 1",
    "parcel_id": "093-21-01",
    "owner1": "BARSKY, AMY",
    "owner2": "",
    "current_taxes": 9272.59,
    "new_taxes_no_override": 9673.17,
    "override_total_1": 9947.63,
    "override_increase_1": 274.47
  },
  {
    "#": "25 Bartlett Cres, Unit 2 (093-21-02)",
    "$": 1475600,
    "address": "25 Bartlett Cres, Unit 2",
    "parcel_id": "093-21-02",
    "owner1": "KATES, THOMAS J & KATHY ANN",
    "owner2": "",
    "current_taxes": 11475.21,
    "new_taxes_no_override": 11970.94,
    "override_total_1": 12310.61,
    "override_increase_1": 339.67
  },
  {
    "#": "29 Bartlett Cres (093-22-00)",
    "$": 2507200,
    "address": "29 Bartlett Cres",
    "parcel_id": "093-22-00",
    "owner1": "SPECTOR, DANIEL LEWIS",
    "owner2": "UNGER, SARAH MARIA",
    "current_taxes": 25673.73,
    "new_taxes_no_override": 26782.84,
    "override_total_1": 27542.78,
    "override_increase_1": 759.94
  },
  {
    "#": "33 Bartlett Cres (093-23-00)",
    "$": 2347700,
    "address": "33 Bartlett Cres",
    "parcel_id": "093-23-00",
    "owner1": "CHIN, IP H",
    "owner2": "",
    "current_taxes": 20405.51,
    "new_taxes_no_override": 21287.03,
    "override_total_1": 21891.03,
    "override_increase_1": 604.0
  },
  {
    "#": "37 Bartlett Cres (093-24-00)",
    "$": 2675000,
    "address": "37 Bartlett Cres",
    "parcel_id": "093-24-00",
    "owner1": "ZENNER, TRS, ALFRED & MICHELINE",
    "owner2": "",
    "current_taxes": 27392.0,
    "new_taxes_no_override": 28575.33,
    "override_total_1": 29386.14,
    "override_increase_1": 810.8
  },
  {
    "#": "43 Bartlett Cres (093-25-00)",
    "$": 424200,
    "address": "43 Bartlett Cres",
    "parcel_id": "093-25-00",
    "owner1": "5 WASHINGTON SQUARE FEE OWNER LLC",
    "owner2": "C/O WASHINGTON SQUARE VENTURES",
    "current_taxes": 7279.27,
    "new_taxes_no_override": 7593.73,
    "override_total_1": 7809.2,
    "override_increase_1": 215.47
  },
  {
    "#": "45 Bartlett Cres (093-24-01)",
    "$": 4242500,
    "address": "45 Bartlett Cres",
    "parcel_id": "093-24-01",
    "owner1": "WESTVIEW BARTLETT LLC",
    "owner2": "",
    "current_taxes": 43443.2,
    "new_taxes_no_override": 45319.95,
    "override_total_1": 46605.86,
    "override_increase_1": 1285.92
  },
  {
    "#": "51 Bartlett Cres (093-25-01)",
    "$": 662800,
    "address": "51 Bartlett Cres",
    "parcel_id": "093-25-01",
    "owner1": "5 WASHINGTON SQUARE FEE OWNER LLC",
    "owner2": "C/O WASHINGTON SQUARE VENTURES",
    "current_taxes": 11373.65,
    "new_taxes_no_override": 11864.99,
    "override_total_1": 12201.65,
    "override_increase_1": 336.66
  },
  {
    "#": "16 Bartlett St (093-15-00)",
    "$": 2545300,
    "address": "16 Bartlett St",
    "parcel_id": "093-15-00",
    "owner1": "WANG, YAN",
    "owner2": "LI, SHUJIA",
    "current_taxes": 22428.94,
    "new_taxes_no_override": 23397.87,
    "override_total_1": 24061.77,
    "override_increase_1": 663.9
  },
  {
    "#": "51 Baxter Rd (256A-07-00)",
    "$": 3628500,
    "address": "51 Baxter Rd",
    "parcel_id": "256A-07-00",
    "owner1": "FEINBERG TR, STEPHEN B",
    "owner2": "",
    "current_taxes": 33520.91,
    "new_taxes_no_override": 34969.01,
    "override_total_1": 35961.23,
    "override_increase_1": 992.22
  },
  {
    "#": "59 Baxter Rd (256A-07-01)",
    "$": 3956800,
    "address": "59 Baxter Rd",
    "parcel_id": "256A-07-01",
    "owner1": "TALLARICO, JOHN A & AIMEE S",
    "owner2": "",
    "current_taxes": 40517.63,
    "new_taxes_no_override": 42267.99,
    "override_total_1": 43467.31,
    "override_increase_1": 1199.32
  },
  {
    "#": "69 Baxter Rd (256A-07-02)",
    "$": 4029600,
    "address": "69 Baxter Rd",
    "parcel_id": "256A-07-02",
    "owner1": "SNIDER, SUSAN G",
    "owner2": "",
    "current_taxes": 37628.17,
    "new_taxes_no_override": 39253.71,
    "override_total_1": 40367.5,
    "override_increase_1": 1113.79
  },
  {
    "#": "79 Baxter Rd (256A-07-03)",
    "$": 3800100,
    "address": "79 Baxter Rd",
    "parcel_id": "256A-07-03",
    "owner1": "MELKI TRS, SAMIR A & RANIA C",
    "owner2": "",
    "current_taxes": 35278.09,
    "new_taxes_no_override": 36802.1,
    "override_total_1": 37846.33,
    "override_increase_1": 1044.23
  },
  {
    "#": "85 Baxter Rd (256A-08-00)",
    "$": 3789900,
    "address": "85 Baxter Rd",
    "parcel_id": "256A-08-00",
    "owner1": "EINHORN, ALAN H",
    "owner2": "SALAMON, SUZANNE E",
    "current_taxes": 35173.64,
    "new_taxes_no_override": 36693.14,
    "override_total_1": 37734.28,
    "override_increase_1": 1041.14
  },
  {
    "#": "90 Baxter Rd (256-06-00)",
    "$": 4523000,
    "address": "90 Baxter Rd",
    "parcel_id": "256-06-00",
    "owner1": "COHEN TR, JON E",
    "owner2": "",
    "current_taxes": 46315.52,
    "new_taxes_no_override": 48316.35,
    "override_total_1": 49687.29,
    "override_increase_1": 1370.94
  },
  {
    "#": "91 Baxter Rd (256A-08-01)",
    "$": 3090800,
    "address": "91 Baxter Rd",
    "parcel_id": "256A-08-01",
    "owner1": "SHORT, RICHARD A",
    "owner2": "SCHNELL, RONNI A",
    "current_taxes": 28014.86,
    "new_taxes_no_override": 29225.1,
    "override_total_1": 30054.34,
    "override_increase_1": 829.24
  },
  {
    "#": "999 Beacon St, Unit A (112-25-26)",
    "$": 4415900,
    "address": "999 Beacon St, Unit A",
    "parcel_id": "112-25-26",
    "owner1": "SHAUGHNESSY JR, FRED",
    "owner2": "GEARY, SUSAN",
    "current_taxes": 75776.84,
    "new_taxes_no_override": 79050.4,
    "override_total_1": 81293.39,
    "override_increase_1": 2242.99
  },
  {
    "#": "1002 Beacon St (001-01-00)",
    "$": 4807700,
    "address": "1002 Beacon St",
    "parcel_id": "001-01-00",
    "owner1": "XIAO INVESTMENT COMPANY V LLC",
    "owner2": "",
    "current_taxes": 73517.46,
    "new_taxes_no_override": 76693.41,
    "override_total_1": 78869.53,
    "override_increase_1": 2176.12
  },
  {
    "#": "1004 Beacon St (001-02-08)",
    "$": 11438400,
    "address": "1004 Beacon St",
    "parcel_id": "001-02-08",
    "owner1": "LINEAGE RE BROOKLINE LLC",
    "owner2": "",
    "current_taxes": 196282.94,
    "new_taxes_no_override": 204762.36,
    "override_total_1": 210572.34,
    "override_increase_1": 5809.98
  },
  {
    "#": "1011 Beacon St, Unit 1 (112-24-05)",
    "$": 213600,
    "address": "1011 Beacon St, Unit 1",
    "parcel_id": "112-24-05",
    "owner1": "YADEGAR, JEANNETTE",
    "owner2": "",
    "current_taxes": 3665.38,
    "new_taxes_no_override": 3823.72,
    "override_total_1": 3932.22,
    "override_increase_1": 108.5
  },
  {
    "#": "1011 Beacon St, Unit 2 (112-24-01)",
    "$": 681200,
    "address": "1011 Beacon St, Unit 2",
    "parcel_id": "112-24-01",
    "owner1": "SULLIVAN, ET AL TRS, JOHN P",
    "owner2": "",
    "current_taxes": 11689.39,
    "new_taxes_no_override": 12194.37,
    "override_total_1": 12540.38,
    "override_increase_1": 346.01
  },
  {
    "#": "1011 Beacon St, Unit 3 & P3 (112-24-02)",
    "$": 925600,
    "address": "1011 Beacon St, Unit 3 & P3",
    "parcel_id": "112-24-02",
    "owner1": "CHIN, STANLEY D & SUSAN F",
    "owner2": "",
    "current_taxes": 5843.21,
    "new_taxes_no_override": 6095.64,
    "override_total_1": 6268.6,
    "override_increase_1": 172.96
  },
  {
    "#": "1011 Beacon St, Unit 4 (112-24-03)",
    "$": 943600,
    "address": "1011 Beacon St, Unit 4",
    "parcel_id": "112-24-03",
    "owner1": "HANNICK, JOHN D & ELIZABETH E",
    "owner2": "",
    "current_taxes": 6027.53,
    "new_taxes_no_override": 6287.92,
    "override_total_1": 6466.33,
    "override_increase_1": 178.41
  },
  {
    "#": "1011 Beacon St, Unit 5 & P1 (112-24-04)",
    "$": 942400,
    "address": "1011 Beacon St, Unit 5 & P1",
    "parcel_id": "112-24-04",
    "owner1": "CHOU, KENNY",
    "owner2": "",
    "current_taxes": 6015.24,
    "new_taxes_no_override": 6275.1,
    "override_total_1": 6453.15,
    "override_increase_1": 178.05
  },
  {
    "#": "1013 Beacon St (112-23-00)",
    "$": 2797700,
    "address": "1013 Beacon St",
    "parcel_id": "112-23-00",
    "owner1": "1013 BEACON LLC",
    "owner2": "",
    "current_taxes": 28648.45,
    "new_taxes_no_override": 29886.06,
    "override_total_1": 30734.06,
    "override_increase_1": 847.99
  },
  {
    "#": "1015 Beacon St (112-22-00)",
    "$": 3141000,
    "address": "1015 Beacon St",
    "parcel_id": "112-22-00",
    "owner1": "LYONS, ANNE S",
    "owner2": "",
    "current_taxes": 32163.84,
    "new_taxes_no_override": 33553.32,
    "override_total_1": 34505.37,
    "override_increase_1": 952.05
  },
  {
    "#": "1017 Beacon St (112-21-00)",
    "$": 1092700,
    "address": "1017 Beacon St",
    "parcel_id": "112-21-00",
    "owner1": "BROOKLINE IMPROVEMENT COALITION",
    "owner2": "C/O PINE ST INN, ATTN FINANCE DEPT",
    "current_taxes": 11189.25,
    "new_taxes_no_override": 11672.63,
    "override_total_1": 12003.83,
    "override_increase_1": 331.2
  },
  {
    "#": "1018 Beacon St (001-09-00)",
    "$": 3053300,
    "address": "1018 Beacon St",
    "parcel_id": "001-09-00",
    "owner1": "GLANZ, ET AL TRS, RICHARD E",
    "owner2": "C/O GLANZ PROPERTIES INC",
    "current_taxes": 52394.63,
    "new_taxes_no_override": 54658.08,
    "override_total_1": 56208.96,
    "override_increase_1": 1550.88
  },
  {
    "#": "1019 Beacon St (112-20-00)",
    "$": 1610000,
    "address": "1019 Beacon St",
    "parcel_id": "112-20-00",
    "owner1": "KALOTKIN TR, ABBY R & ARTHUR A",
    "owner2": "",
    "current_taxes": 16486.4,
    "new_taxes_no_override": 17198.61,
    "override_total_1": 17686.61,
    "override_increase_1": 488.0
  },
  {
    "#": "1020 Beacon St, Unit A (001-10-00)",
    "$": 1577800,
    "address": "1020 Beacon St, Unit A",
    "parcel_id": "001-10-00",
    "owner1": "GALVIN, TR, SEAN D",
    "owner2": "C/O 1020-1024 BEACON ST REALTY",
    "current_taxes": 27075.05,
    "new_taxes_no_override": 28244.69,
    "override_total_1": 29046.11,
    "override_increase_1": 801.42
  },
  {
    "#": "1021 Beacon St (112-19-00)",
    "$": 3116300,
    "address": "1021 Beacon St",
    "parcel_id": "112-19-00",
    "owner1": "1021 BEACON LLC",
    "owner2": "",
    "current_taxes": 31910.91,
    "new_taxes_no_override": 33289.46,
    "override_total_1": 34234.02,
    "override_increase_1": 944.56
  },
  {
    "#": "1022 Beacon St (001-11-00)",
    "$": 2213700,
    "address": "1022 Beacon St",
    "parcel_id": "001-11-00",
    "owner1": "GALVIN, TR, SEAN D",
    "owner2": "C/O 1020-1024 BEACON ST REALTY",
    "current_taxes": 37987.09,
    "new_taxes_no_override": 39628.13,
    "override_total_1": 40752.55,
    "override_increase_1": 1124.42
  },
  {
    "#": "1023 Beacon St (112-18-00)",
    "$": 3175100,
    "address": "1023 Beacon St",
    "parcel_id": "112-18-00",
    "owner1": "1023 BEACON LLC",
    "owner2": "",
    "current_taxes": 32513.02,
    "new_taxes_no_override": 33917.58,
    "override_total_1": 34879.97,
    "override_increase_1": 962.39
  },
  {
    "#": "1024 Beacon St (001-12-00)",
    "$": 8949000,
    "address": "1024 Beacon St",
    "parcel_id": "001-12-00",
    "owner1": "SHIEF TRS, BERRIL",
    "owner2": "GOODMAN, CAROL S",
    "current_taxes": 153564.84,
    "new_taxes_no_override": 160198.84,
    "override_total_1": 164744.36,
    "override_increase_1": 4545.52
  },
  {
    "#": "1025 Beacon St (112-17-00)",
    "$": 2961400,
    "address": "1025 Beacon St",
    "parcel_id": "112-17-00",
    "owner1": "LYONS INVESTMENT LLC",
    "owner2": "",
    "current_taxes": 30324.74,
    "new_taxes_no_override": 31634.77,
    "override_total_1": 32532.38,
    "override_increase_1": 897.61
  },
  {
    "#": "1027 Beacon St (112-16-00)",
    "$": 1303200,
    "address": "1027 Beacon St",
    "parcel_id": "112-16-00",
    "owner1": "CEEH BEACON INC",
    "owner2": "",
    "current_taxes": 13344.77,
    "new_taxes_no_override": 13921.26,
    "override_total_1": 14316.27,
    "override_increase_1": 395.01
  },
  {
    "#": "1029 Beacon St (112-15-00)",
    "$": 1423800,
    "address": "1029 Beacon St",
    "parcel_id": "112-15-00",
    "owner1": "CHAPIN TRS, DAVID C & CYNTHIA E",
    "owner2": "",
    "current_taxes": 14579.71,
    "new_taxes_no_override": 15209.55,
    "override_total_1": 15641.11,
    "override_increase_1": 431.56
  },
  {
    "#": "1031 Beacon St (112-14-00)",
    "$": 3001000,
    "address": "1031 Beacon St",
    "parcel_id": "112-14-00",
    "owner1": "CHIU TRS, BERNICE T",
    "owner2": "LEE, RUTH M",
    "current_taxes": 27095.31,
    "new_taxes_no_override": 28265.83,
    "override_total_1": 29067.85,
    "override_increase_1": 802.02
  },
  {
    "#": "1033 Beacon St (112-13-00)",
    "$": 3991400,
    "address": "1033 Beacon St",
    "parcel_id": "112-13-00",
    "owner1": "SAVORY ASSOCIATES II LLC",
    "owner2": "",
    "current_taxes": 40871.94,
    "new_taxes_no_override": 42637.61,
    "override_total_1": 43847.42,
    "override_increase_1": 1209.81
  },
  {
    "#": "1035 Beacon St, Unit 1 (112-12-02)",
    "$": 1516100,
    "address": "1035 Beacon St, Unit 1",
    "parcel_id": "112-12-02",
    "owner1": "KNEZEVIC, DAVID J",
    "owner2": "AISENBREY, JESSICA W",
    "current_taxes": 11889.93,
    "new_taxes_no_override": 12403.57,
    "override_total_1": 12755.52,
    "override_increase_1": 351.94
  },
  {
    "#": "1035 Beacon St, Unit 2 (112-12-03)",
    "$": 1527000,
    "address": "1035 Beacon St, Unit 2",
    "parcel_id": "112-12-03",
    "owner1": "TSOUROS, CHRISTOPHER",
    "owner2": "ROSSI, CAMILLE",
    "current_taxes": 12001.55,
    "new_taxes_no_override": 12520.02,
    "override_total_1": 12875.26,
    "override_increase_1": 355.25
  },
  {
    "#": "1035 Beacon St, Unit 3 (112-12-04)",
    "$": 1527000,
    "address": "1035 Beacon St, Unit 3",
    "parcel_id": "112-12-04",
    "owner1": "GLASSNER, MARSHALL S",
    "owner2": "",
    "current_taxes": 12001.55,
    "new_taxes_no_override": 12520.02,
    "override_total_1": 12875.26,
    "override_increase_1": 355.25
  },
  {
    "#": "1035 Beacon St, Unit A (112-12-01)",
    "$": 1282600,
    "address": "1035 Beacon St, Unit A",
    "parcel_id": "112-12-01",
    "owner1": "GUEN, ROBERT",
    "owner2": "",
    "current_taxes": 22009.42,
    "new_taxes_no_override": 22960.23,
    "override_total_1": 23611.71,
    "override_increase_1": 651.48
  },
  {
    "#": "1037 Beacon St, Unit 1 (112-11-04)",
    "$": 1301600,
    "address": "1037 Beacon St, Unit 1",
    "parcel_id": "112-11-04",
    "owner1": "WEISSMAN, RONALD G",
    "owner2": "",
    "current_taxes": 22335.46,
    "new_taxes_no_override": 23300.35,
    "override_total_1": 23961.48,
    "override_increase_1": 661.13
  },
  {
    "#": "1037 Beacon St, Unit 2 (112-11-01)",
    "$": 1626200,
    "address": "1037 Beacon St, Unit 2",
    "parcel_id": "112-11-01",
    "owner1": "BLAKE STREET MANAGEMENT LLC",
    "owner2": "",
    "current_taxes": 27905.59,
    "new_taxes_no_override": 29111.11,
    "override_total_1": 29937.12,
    "override_increase_1": 826.01
  },
  {
    "#": "1037 Beacon St, Unit 3 (112-11-02)",
    "$": 1613100,
    "address": "1037 Beacon St, Unit 3",
    "parcel_id": "112-11-02",
    "owner1": "ACEMOGLU, KAMER DARON",
    "owner2": "OZDAGLAR-ACEMOGLU, ASUMAN",
    "current_taxes": 16518.14,
    "new_taxes_no_override": 17231.72,
    "override_total_1": 17720.66,
    "override_increase_1": 488.94
  },
  {
    "#": "1037 Beacon St, Unit 4 (112-11-03)",
    "$": 1533400,
    "address": "1037 Beacon St, Unit 4",
    "parcel_id": "112-11-03",
    "owner1": "SNYDER, RICHARD",
    "owner2": "",
    "current_taxes": 12067.08,
    "new_taxes_no_override": 12588.38,
    "override_total_1": 12945.56,
    "override_increase_1": 357.19
  },
  {
    "#": "1038 Beacon St, Unit 100 & P1 (001-13-05)",
    "$": 846400,
    "address": "1038 Beacon St, Unit 100 & P1",
    "parcel_id": "001-13-05",
    "owner1": "TRUMAN, ROBERT HENRY",
    "owner2": "JOE, STEPHANIE",
    "current_taxes": 8667.14,
    "new_taxes_no_override": 9041.56,
    "override_total_1": 9298.11,
    "override_increase_1": 256.55
  },
  {
    "#": "1038 Beacon St, Unit 101 & P3 (001-13-06)",
    "$": 865100,
    "address": "1038 Beacon St, Unit 101 & P3",
    "parcel_id": "001-13-06",
    "owner1": "PANG, LEE & ALL LLC",
    "owner2": "C/O PANG, FU YUNG",
    "current_taxes": 8858.62,
    "new_taxes_no_override": 9241.31,
    "override_total_1": 9503.53,
    "override_increase_1": 262.22
  },
  {
    "#": "1038 Beacon St, Unit 102 (001-13-07)",
    "$": 337900,
    "address": "1038 Beacon St, Unit 102",
    "parcel_id": "001-13-07",
    "owner1": "LIU, TERESA",
    "owner2": "YOUNG, ERIC",
    "current_taxes": 3460.1,
    "new_taxes_no_override": 3609.58,
    "override_total_1": 3712.0,
    "override_increase_1": 102.42
  },
  {
    "#": "1038 Beacon St, Unit 103 & P14 (001-13-08)",
    "$": 1179200,
    "address": "1038 Beacon St, Unit 103 & P14",
    "parcel_id": "001-13-08",
    "owner1": "LEAO DESLANDES TR, CAIO & MARIA L G",
    "owner2": "",
    "current_taxes": 20235.07,
    "new_taxes_no_override": 21109.23,
    "override_total_1": 21708.18,
    "override_increase_1": 598.96
  },
  {
    "#": "1038 Beacon St, Unit 104 & P8 (001-13-09)",
    "$": 818600,
    "address": "1038 Beacon St, Unit 104 & P8",
    "parcel_id": "001-13-09",
    "owner1": "TSO TRS, DAVID & VICTORIA",
    "owner2": "",
    "current_taxes": 8382.46,
    "new_taxes_no_override": 8744.58,
    "override_total_1": 8992.7,
    "override_increase_1": 248.12
  },
  {
    "#": "1038 Beacon St, Unit 200 & P4 (001-13-10)",
    "$": 917300,
    "address": "1038 Beacon St, Unit 200 & P4",
    "parcel_id": "001-13-10",
    "owner1": "CHOW TRS, JASON A",
    "owner2": "SULLIVAN, MICHAEL G",
    "current_taxes": 5758.22,
    "new_taxes_no_override": 6006.98,
    "override_total_1": 6177.42,
    "override_increase_1": 170.44
  },
  {
    "#": "1038 Beacon St, Unit 201 & P17 (001-13-11)",
    "$": 858200,
    "address": "1038 Beacon St, Unit 201 & P17",
    "parcel_id": "001-13-11",
    "owner1": "KRASNER TR, LORI E",
    "owner2": "",
    "current_taxes": 8787.97,
    "new_taxes_no_override": 9167.61,
    "override_total_1": 9427.73,
    "override_increase_1": 260.12
  },
  {
    "#": "1038 Beacon St, Unit 202 (001-13-12)",
    "$": 373100,
    "address": "1038 Beacon St, Unit 202",
    "parcel_id": "001-13-12",
    "owner1": "BOHR, ROBERT & TRUDY & COURTNEY",
    "owner2": "",
    "current_taxes": 382.05,
    "new_taxes_no_override": 398.55,
    "override_total_1": 409.86,
    "override_increase_1": 11.31
  },
  {
    "#": "1038 Beacon St, Unit 203 & P7 (001-13-13)",
    "$": 1161900,
    "address": "1038 Beacon St, Unit 203 & P7",
    "parcel_id": "001-13-13",
    "owner1": "SIMA, ANQI",
    "owner2": "FU, BIN",
    "current_taxes": 11897.86,
    "new_taxes_no_override": 12411.85,
    "override_total_1": 12764.02,
    "override_increase_1": 352.18
  },
  {
    "#": "1038 Beacon St, Unit 204& P5 (001-13-14)",
    "$": 878000,
    "address": "1038 Beacon St, Unit 204& P5",
    "parcel_id": "001-13-14",
    "owner1": "VASANTHA, SREEMALI",
    "owner2": "ANJANEYULU, SUJATHA",
    "current_taxes": 8990.72,
    "new_taxes_no_override": 9379.12,
    "override_total_1": 9645.24,
    "override_increase_1": 266.13
  },
  {
    "#": "1038 Beacon St, Unit 300 & P11 (001-13-15)",
    "$": 903100,
    "address": "1038 Beacon St, Unit 300 & P11",
    "parcel_id": "001-13-15",
    "owner1": "BEHNEGAR, NASSER",
    "owner2": "PARKER, ALICE",
    "current_taxes": 5612.81,
    "new_taxes_no_override": 5855.28,
    "override_total_1": 6021.42,
    "override_increase_1": 166.14
  },
  {
    "#": "1038 Beacon St, Unit 301 & P6 (001-13-16)",
    "$": 778600,
    "address": "1038 Beacon St, Unit 301 & P6",
    "parcel_id": "001-13-16",
    "owner1": "ELLIOTT TRS, LAWRENCE C & LORI S",
    "owner2": "",
    "current_taxes": 4337.93,
    "new_taxes_no_override": 4525.33,
    "override_total_1": 4653.73,
    "override_increase_1": 128.4
  },
  {
    "#": "1038 Beacon St, Unit 302 (001-13-17)",
    "$": 418300,
    "address": "1038 Beacon St, Unit 302",
    "parcel_id": "001-13-17",
    "owner1": "WANG, YAN",
    "owner2": "",
    "current_taxes": 4283.39,
    "new_taxes_no_override": 4468.43,
    "override_total_1": 4595.22,
    "override_increase_1": 126.79
  },
  {
    "#": "1038 Beacon St, Unit 303 & P19 (001-13-18)",
    "$": 1029500,
    "address": "1038 Beacon St, Unit 303 & P19",
    "parcel_id": "001-13-18",
    "owner1": "TRI-CORNER REALTY LLC",
    "owner2": "",
    "current_taxes": 10542.08,
    "new_taxes_no_override": 10997.5,
    "override_total_1": 11309.54,
    "override_increase_1": 312.05
  },
  {
    "#": "1038 Beacon St, Unit 304 & P12 (001-13-19)",
    "$": 883200,
    "address": "1038 Beacon St, Unit 304 & P12",
    "parcel_id": "001-13-19",
    "owner1": "HUNG, STEPHEN",
    "owner2": "",
    "current_taxes": 5409.03,
    "new_taxes_no_override": 5642.7,
    "override_total_1": 5802.81,
    "override_increase_1": 160.11
  },
  {
    "#": "1038 Beacon St, Unit 400 & P16 (001-13-20)",
    "$": 924000,
    "address": "1038 Beacon St, Unit 400 & P16",
    "parcel_id": "001-13-20",
    "owner1": "EVANS, RUSSELL B",
    "owner2": "",
    "current_taxes": 9461.76,
    "new_taxes_no_override": 9870.51,
    "override_total_1": 10150.58,
    "override_increase_1": 280.07
  },
  {
    "#": "1038 Beacon St, Unit 401 & P10 (001-13-21)",
    "$": 807500,
    "address": "1038 Beacon St, Unit 401 & P10",
    "parcel_id": "001-13-21",
    "owner1": "KIRDA, ENGIN",
    "owner2": "",
    "current_taxes": 8268.8,
    "new_taxes_no_override": 8626.01,
    "override_total_1": 8870.77,
    "override_increase_1": 244.76
  },
  {
    "#": "1038 Beacon St, Unit 402 & P18 (001-13-22)",
    "$": 412000,
    "address": "1038 Beacon St, Unit 402 & P18",
    "parcel_id": "001-13-22",
    "owner1": "1038 BEACON NAUSET GROUP LLC",
    "owner2": "",
    "current_taxes": 4218.88,
    "new_taxes_no_override": 4401.14,
    "override_total_1": 4526.01,
    "override_increase_1": 124.88
  },
  {
    "#": "1038 Beacon St, Unit 403 & P13 (001-13-23)",
    "$": 1090900,
    "address": "1038 Beacon St, Unit 403 & P13",
    "parcel_id": "001-13-23",
    "owner1": "TESFAIGZI, YOHANNES",
    "owner2": "TEWOLDE, ADDA",
    "current_taxes": 11170.82,
    "new_taxes_no_override": 11653.4,
    "override_total_1": 11984.06,
    "override_increase_1": 330.66
  },
  {
    "#": "1038 Beacon St, Unit 404 & P15 (001-13-24)",
    "$": 946700,
    "address": "1038 Beacon St, Unit 404 & P15",
    "parcel_id": "001-13-24",
    "owner1": "FASTOV, RITA",
    "owner2": "",
    "current_taxes": 9694.21,
    "new_taxes_no_override": 10113.0,
    "override_total_1": 10399.95,
    "override_increase_1": 286.95
  },
  {
    "#": "1038 Beacon St, Unit A (001-13-02)",
    "$": 541600,
    "address": "1038 Beacon St, Unit A",
    "parcel_id": "001-13-02",
    "owner1": "KEITH, THOMAS OCONNELL",
    "owner2": "",
    "current_taxes": 1911.05,
    "new_taxes_no_override": 1993.61,
    "override_total_1": 2050.17,
    "override_increase_1": 56.57
  },
  {
    "#": "1038 Beacon St, Unit B (001-13-03)",
    "$": 289500,
    "address": "1038 Beacon St, Unit B",
    "parcel_id": "001-13-03",
    "owner1": "MOBE 12 LLC",
    "owner2": "",
    "current_taxes": 2964.48,
    "new_taxes_no_override": 3092.55,
    "override_total_1": 3180.29,
    "override_increase_1": 87.75
  },
  {
    "#": "1038 Beacon St, Unit C (001-13-04)",
    "$": 491000,
    "address": "1038 Beacon St, Unit C",
    "parcel_id": "001-13-04",
    "owner1": "EVANS, STUART ALEXANDER & STUART ANTHONY & LESLIE L",
    "owner2": "",
    "current_taxes": 1392.91,
    "new_taxes_no_override": 1453.08,
    "override_total_1": 1494.31,
    "override_increase_1": 41.23
  },
  {
    "#": "1038 Beacon St, Unit Cr-1 & P9 (001-13-25)",
    "$": 1213500,
    "address": "1038 Beacon St, Unit Cr-1 & P9",
    "parcel_id": "001-13-25",
    "owner1": "JAPARA LLC",
    "owner2": "",
    "current_taxes": 20823.66,
    "new_taxes_no_override": 21723.24,
    "override_total_1": 22339.62,
    "override_increase_1": 616.38
  },
  {
    "#": "1038 Beacon St, Unit Cr-2 & P2 (001-13-01)",
    "$": 1151600,
    "address": "1038 Beacon St, Unit Cr-2 & P2",
    "parcel_id": "001-13-01",
    "owner1": "SGC REALTY LLC",
    "owner2": "",
    "current_taxes": 19761.46,
    "new_taxes_no_override": 20615.16,
    "override_total_1": 21200.09,
    "override_increase_1": 584.94
  },
  {
    "#": "1042 Beacon St, Unit 1A (001-14-02)",
    "$": 1028100,
    "address": "1042 Beacon St, Unit 1A",
    "parcel_id": "001-14-02",
    "owner1": "SALLET, LAUREN",
    "owner2": "",
    "current_taxes": 17642.2,
    "new_taxes_no_override": 18404.34,
    "override_total_1": 18926.55,
    "override_increase_1": 522.21
  },
  {
    "#": "1043 Beacon St (112-09-10)",
    "$": 1625300,
    "address": "1043 Beacon St",
    "parcel_id": "112-09-10",
    "owner1": "PINE STREET INN INC",
    "owner2": "",
    "current_taxes": 16643.07,
    "new_taxes_no_override": 17362.05,
    "override_total_1": 17854.69,
    "override_increase_1": 492.63
  },
  {
    "#": "1044 Beacon St, Unit 1 (001-14-01)",
    "$": 696800,
    "address": "1044 Beacon St, Unit 1",
    "parcel_id": "001-14-01",
    "owner1": "SALLET, LAUREN",
    "owner2": "",
    "current_taxes": 11957.09,
    "new_taxes_no_override": 12473.64,
    "override_total_1": 12827.57,
    "override_increase_1": 353.93
  },
  {
    "#": "1046 Beacon St, Unit 2 (001-14-03)",
    "$": 740200,
    "address": "1046 Beacon St, Unit 2",
    "parcel_id": "001-14-03",
    "owner1": "CHRISTAKIS TR, CHRIS",
    "owner2": "",
    "current_taxes": 12701.83,
    "new_taxes_no_override": 13250.55,
    "override_total_1": 13626.52,
    "override_increase_1": 375.97
  },
  {
    "#": "1047 Beacon St (112-08-00)",
    "$": 2976700,
    "address": "1047 Beacon St",
    "parcel_id": "112-08-00",
    "owner1": "B & B LODGING HOUSES LLC",
    "owner2": "",
    "current_taxes": 30481.41,
    "new_taxes_no_override": 31798.21,
    "override_total_1": 32700.46,
    "override_increase_1": 902.25
  },
  {
    "#": "1050 Beacon St, Unit 3 (001-14-04)",
    "$": 2067500,
    "address": "1050 Beacon St, Unit 3",
    "parcel_id": "001-14-04",
    "owner1": "KOLGIAN, BARRY & LOIS",
    "owner2": "",
    "current_taxes": 35478.3,
    "new_taxes_no_override": 37010.96,
    "override_total_1": 38061.12,
    "override_increase_1": 1050.16
  },
  {
    "#": "1051 Beacon St, Unit 1 (112-06-15)",
    "$": 721300,
    "address": "1051 Beacon St, Unit 1",
    "parcel_id": "112-06-15",
    "owner1": "ALLADI, SANTHOSH K",
    "owner2": "THATIPAMULA, SARITHA",
    "current_taxes": 12377.51,
    "new_taxes_no_override": 12912.22,
    "override_total_1": 13278.59,
    "override_increase_1": 366.37
  },
  {
    "#": "1051 Beacon St, Unit 10 (112-06-09)",
    "$": 279500,
    "address": "1051 Beacon St, Unit 10",
    "parcel_id": "112-06-09",
    "owner1": "ITER LLC",
    "owner2": "",
    "current_taxes": 4796.22,
    "new_taxes_no_override": 5003.42,
    "override_total_1": 5145.38,
    "override_increase_1": 141.97
  },
  {
    "#": "1051 Beacon St, Unit 11 (112-06-10)",
    "$": 106100,
    "address": "1051 Beacon St, Unit 11",
    "parcel_id": "112-06-10",
    "owner1": "RODRIGUEZ  ANTON, EVELYN",
    "owner2": "",
    "current_taxes": 1820.68,
    "new_taxes_no_override": 1899.33,
    "override_total_1": 1953.23,
    "override_increase_1": 53.89
  },
  {
    "#": "1051 Beacon St, Unit 12 (112-06-11)",
    "$": 325528,
    "address": "1051 Beacon St, Unit 12",
    "parcel_id": "112-06-11",
    "owner1": "JVX LLC",
    "owner2": "",
    "current_taxes": 5586.06,
    "new_taxes_no_override": 5827.38,
    "override_total_1": 5992.73,
    "override_increase_1": 165.35
  },
  {
    "#": "1051 Beacon St, Unit 13 & P-3 (112-06-12)",
    "$": 338049,
    "address": "1051 Beacon St, Unit 13 & P-3",
    "parcel_id": "112-06-12",
    "owner1": "JVX LLC",
    "owner2": "",
    "current_taxes": 5800.92,
    "new_taxes_no_override": 6051.52,
    "override_total_1": 6223.23,
    "override_increase_1": 171.71
  },
  {
    "#": "1051 Beacon St, Unit 14 (112-06-13)",
    "$": 462100,
    "address": "1051 Beacon St, Unit 14",
    "parcel_id": "112-06-13",
    "owner1": "ZANDPARSA LLC",
    "owner2": "",
    "current_taxes": 7929.64,
    "new_taxes_no_override": 8272.2,
    "override_total_1": 8506.92,
    "override_increase_1": 234.72
  },
  {
    "#": "1051 Beacon St, Unit 15 (112-06-14)",
    "$": 106423,
    "address": "1051 Beacon St, Unit 15",
    "parcel_id": "112-06-14",
    "owner1": "JVX LLC",
    "owner2": "",
    "current_taxes": 1826.22,
    "new_taxes_no_override": 1905.11,
    "override_total_1": 1959.17,
    "override_increase_1": 54.06
  },
  {
    "#": "1051 Beacon St, Unit 2 (112-06-01)",
    "$": 788000,
    "address": "1051 Beacon St, Unit 2",
    "parcel_id": "112-06-01",
    "owner1": "INT REALTY LLC",
    "owner2": "",
    "current_taxes": 13522.08,
    "new_taxes_no_override": 14106.23,
    "override_total_1": 14506.49,
    "override_increase_1": 400.25
  },
  {
    "#": "1051 Beacon St, Unit 3 (112-06-02)",
    "$": 761400,
    "address": "1051 Beacon St, Unit 3",
    "parcel_id": "112-06-02",
    "owner1": "ALLADI, SANTHOSH K",
    "owner2": "THATIPAMULA, SARITHA",
    "current_taxes": 13065.62,
    "new_taxes_no_override": 13630.05,
    "override_total_1": 14016.8,
    "override_increase_1": 386.74
  },
  {
    "#": "1051 Beacon St, Unit 4 & P1 (112-06-03)",
    "$": 822800,
    "address": "1051 Beacon St, Unit 4 & P1",
    "parcel_id": "112-06-03",
    "owner1": "1051 BEACON LLC",
    "owner2": "",
    "current_taxes": 14119.25,
    "new_taxes_no_override": 14729.2,
    "override_total_1": 15147.13,
    "override_increase_1": 417.93
  },
  {
    "#": "1051 Beacon St, Unit 5 (112-06-04)",
    "$": 306500,
    "address": "1051 Beacon St, Unit 5",
    "parcel_id": "112-06-04",
    "owner1": "ALBAN, LUDWIG & MARSHA",
    "owner2": "",
    "current_taxes": 5259.54,
    "new_taxes_no_override": 5486.75,
    "override_total_1": 5642.43,
    "override_increase_1": 155.68
  },
  {
    "#": "1051 Beacon St, Unit 6  & P5 (112-06-05)",
    "$": 820200,
    "address": "1051 Beacon St, Unit 6  & P5",
    "parcel_id": "112-06-05",
    "owner1": "HINSHAW HOLDINGS LLC",
    "owner2": "",
    "current_taxes": 14074.63,
    "new_taxes_no_override": 14682.65,
    "override_total_1": 15099.26,
    "override_increase_1": 416.61
  },
  {
    "#": "1051 Beacon St, Unit 7 & P2 (112-06-06)",
    "$": 547600,
    "address": "1051 Beacon St, Unit 7 & P2",
    "parcel_id": "112-06-06",
    "owner1": "ALBAN, LUDWIG & MARSHA",
    "owner2": "",
    "current_taxes": 9396.82,
    "new_taxes_no_override": 9802.76,
    "override_total_1": 10080.91,
    "override_increase_1": 278.15
  },
  {
    "#": "1051 Beacon St, Unit 8 & P4 (112-06-07)",
    "$": 761400,
    "address": "1051 Beacon St, Unit 8 & P4",
    "parcel_id": "112-06-07",
    "owner1": "PONCE TR, SILVIA A",
    "owner2": "",
    "current_taxes": 13065.62,
    "new_taxes_no_override": 13630.05,
    "override_total_1": 14016.8,
    "override_increase_1": 386.74
  },
  {
    "#": "1051 Beacon St, Unit 9 & P6 (112-06-08)",
    "$": 822800,
    "address": "1051 Beacon St, Unit 9 & P6",
    "parcel_id": "112-06-08",
    "owner1": "ARG LLC",
    "owner2": "",
    "current_taxes": 14119.25,
    "new_taxes_no_override": 14729.2,
    "override_total_1": 15147.13,
    "override_increase_1": 417.93
  },
  {
    "#": "1052 Beacon St, Unit 4 (001-14-05)",
    "$": 1155900,
    "address": "1052 Beacon St, Unit 4",
    "parcel_id": "001-14-05",
    "owner1": "SGC REALTY LLC",
    "owner2": "",
    "current_taxes": 19835.24,
    "new_taxes_no_override": 20692.12,
    "override_total_1": 21279.25,
    "override_increase_1": 587.12
  },
  {
    "#": "1053 Beacon St (116-24-00)",
    "$": 2797100,
    "address": "1053 Beacon St",
    "parcel_id": "116-24-00",
    "owner1": "BOSTON UNIVERSITY TRS",
    "owner2": "C/O GENERAL ACCOUNTING 4TH FLR",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "1054 Beacon St, Unit 5 (001-14-06)",
    "$": 1066200,
    "address": "1054 Beacon St, Unit 5",
    "parcel_id": "001-14-06",
    "owner1": "SGC REALTY LLC",
    "owner2": "",
    "current_taxes": 18295.99,
    "new_taxes_no_override": 19086.38,
    "override_total_1": 19627.94,
    "override_increase_1": 541.56
  },
  {
    "#": "1055 Beacon St (116-23-00)",
    "$": 3697600,
    "address": "1055 Beacon St",
    "parcel_id": "116-23-00",
    "owner1": "MONTROSE 1055 BEACON ST LLC",
    "owner2": "",
    "current_taxes": 37863.42,
    "new_taxes_no_override": 39499.12,
    "override_total_1": 40619.88,
    "override_increase_1": 1120.76
  },
  {
    "#": "1056 Beacon St, Unit 1 & P1 (009B-07-04)",
    "$": 776700,
    "address": "1056 Beacon St, Unit 1 & P1",
    "parcel_id": "009B-07-04",
    "owner1": "LIDDELL, MATTHEW T",
    "owner2": "",
    "current_taxes": 4318.47,
    "new_taxes_no_override": 4505.03,
    "override_total_1": 4632.85,
    "override_increase_1": 127.83
  },
  {
    "#": "1056 Beacon St, Unit 10 (009B-07-13)",
    "$": 631700,
    "address": "1056 Beacon St, Unit 10",
    "parcel_id": "009B-07-13",
    "owner1": "PRASAD, BALRAM & PRATIVA",
    "owner2": "",
    "current_taxes": 6468.61,
    "new_taxes_no_override": 6748.05,
    "override_total_1": 6939.52,
    "override_increase_1": 191.47
  },
  {
    "#": "1056 Beacon St, Unit 11 (009B-07-14)",
    "$": 461700,
    "address": "1056 Beacon St, Unit 11",
    "parcel_id": "009B-07-14",
    "owner1": "CHEN TR, JEAN  YI",
    "owner2": "",
    "current_taxes": 4727.81,
    "new_taxes_no_override": 4932.05,
    "override_total_1": 5071.99,
    "override_increase_1": 139.94
  },
  {
    "#": "1056 Beacon St, Unit 12 (009B-07-15)",
    "$": 515400,
    "address": "1056 Beacon St, Unit 12",
    "parcel_id": "009B-07-15",
    "owner1": "LUTFI, NASSIB",
    "owner2": "",
    "current_taxes": 5277.7,
    "new_taxes_no_override": 5505.7,
    "override_total_1": 5661.92,
    "override_increase_1": 156.22
  },
  {
    "#": "1056 Beacon St, Unit 12A & Prk (009B-07-16)",
    "$": 794400,
    "address": "1056 Beacon St, Unit 12A & Prk",
    "parcel_id": "009B-07-16",
    "owner1": "HUANG, EMERALD & CYRUS",
    "owner2": "",
    "current_taxes": 4499.72,
    "new_taxes_no_override": 4694.11,
    "override_total_1": 4827.3,
    "override_increase_1": 133.19
  },
  {
    "#": "1056 Beacon St, Unit 14 & P22 (009B-07-17)",
    "$": 702200,
    "address": "1056 Beacon St, Unit 14 & P22",
    "parcel_id": "009B-07-17",
    "owner1": "BASKIN, GENNADY & EMMA",
    "owner2": "",
    "current_taxes": 7190.53,
    "new_taxes_no_override": 7501.16,
    "override_total_1": 7714.0,
    "override_increase_1": 212.84
  },
  {
    "#": "1056 Beacon St, Unit 15 (009B-07-18)",
    "$": 489700,
    "address": "1056 Beacon St, Unit 15",
    "parcel_id": "009B-07-18",
    "owner1": "EFTEKHARZADEH, BAHAREH",
    "owner2": "",
    "current_taxes": 5014.53,
    "new_taxes_no_override": 5231.16,
    "override_total_1": 5379.59,
    "override_increase_1": 148.43
  },
  {
    "#": "1056 Beacon St, Unit 16 (009B-07-19)",
    "$": 472200,
    "address": "1056 Beacon St, Unit 16",
    "parcel_id": "009B-07-19",
    "owner1": "ARSENAULT, KYLE THOMAS & PETER & KARIN",
    "owner2": "",
    "current_taxes": 1200.39,
    "new_taxes_no_override": 1252.25,
    "override_total_1": 1287.78,
    "override_increase_1": 35.53
  },
  {
    "#": "1056 Beacon St, Unit 2 (009B-07-05)",
    "$": 585400,
    "address": "1056 Beacon St, Unit 2",
    "parcel_id": "009B-07-05",
    "owner1": "KOS, CLAUDINE H",
    "owner2": "",
    "current_taxes": 2359.56,
    "new_taxes_no_override": 2461.49,
    "override_total_1": 2531.34,
    "override_increase_1": 69.84
  },
  {
    "#": "1056 Beacon St, Unit 3 (009B-07-06)",
    "$": 461700,
    "address": "1056 Beacon St, Unit 3",
    "parcel_id": "009B-07-06",
    "owner1": "JACOBS, ROBERT M",
    "owner2": "",
    "current_taxes": 1092.87,
    "new_taxes_no_override": 1140.08,
    "override_total_1": 1172.43,
    "override_increase_1": 32.35
  },
  {
    "#": "1056 Beacon St, Unit 4 (009B-07-07)",
    "$": 468700,
    "address": "1056 Beacon St, Unit 4",
    "parcel_id": "009B-07-07",
    "owner1": "FATTMAN, KELLY L",
    "owner2": "MURRAY, BRENDAN",
    "current_taxes": 4799.49,
    "new_taxes_no_override": 5006.83,
    "override_total_1": 5148.89,
    "override_increase_1": 142.06
  },
  {
    "#": "1056 Beacon St, Unit 5 & P3 (009B-07-08)",
    "$": 790300,
    "address": "1056 Beacon St, Unit 5 & P3",
    "parcel_id": "009B-07-08",
    "owner1": "FANG, DAVID",
    "owner2": "ZHANG, JIAN",
    "current_taxes": 4457.74,
    "new_taxes_no_override": 4650.31,
    "override_total_1": 4782.26,
    "override_increase_1": 131.95
  },
  {
    "#": "1056 Beacon St, Unit 6 & P-H (009B-07-09)",
    "$": 747100,
    "address": "1056 Beacon St, Unit 6 & P-H",
    "parcel_id": "009B-07-09",
    "owner1": "BEACON STREET BROOKLINE 1056-6 LLC",
    "owner2": "",
    "current_taxes": 7650.3,
    "new_taxes_no_override": 7980.79,
    "override_total_1": 8207.24,
    "override_increase_1": 226.45
  },
  {
    "#": "1056 Beacon St, Unit 7 (009B-07-10)",
    "$": 488800,
    "address": "1056 Beacon St, Unit 7",
    "parcel_id": "009B-07-10",
    "owner1": "MCCABE, RYAN",
    "owner2": "",
    "current_taxes": 1370.38,
    "new_taxes_no_override": 1429.58,
    "override_total_1": 1470.14,
    "override_increase_1": 40.56
  },
  {
    "#": "1056 Beacon St, Unit 8 (009B-07-11)",
    "$": 548100,
    "address": "1056 Beacon St, Unit 8",
    "parcel_id": "009B-07-11",
    "owner1": "DICKINSON, KAREN & KATE & JOHN",
    "owner2": "",
    "current_taxes": 1977.61,
    "new_taxes_no_override": 2063.04,
    "override_total_1": 2121.58,
    "override_increase_1": 58.54
  },
  {
    "#": "1056 Beacon St, Unit 9 & P12 (009B-07-12)",
    "$": 788400,
    "address": "1056 Beacon St, Unit 9 & P12",
    "parcel_id": "009B-07-12",
    "owner1": "LEE TRS, KUO-HSIANG SEAN",
    "owner2": "HSU, WEN-CHIEN MARGARET",
    "current_taxes": 8073.22,
    "new_taxes_no_override": 8421.98,
    "override_total_1": 8660.95,
    "override_increase_1": 238.97
  },
  {
    "#": "1056 Beacon St, Unit A (009B-07-01)",
    "$": 534800,
    "address": "1056 Beacon St, Unit A",
    "parcel_id": "009B-07-01",
    "owner1": "FUJITA TR, ALLAN S",
    "owner2": "",
    "current_taxes": 1841.42,
    "new_taxes_no_override": 1920.97,
    "override_total_1": 1975.48,
    "override_increase_1": 54.51
  },
  {
    "#": "1056 Beacon St, Unit B (009B-07-02)",
    "$": 400400,
    "address": "1056 Beacon St, Unit B",
    "parcel_id": "009B-07-02",
    "owner1": "CACACE III, JOHN A",
    "owner2": "CACACE, KATIE M",
    "current_taxes": 4100.1,
    "new_taxes_no_override": 4277.22,
    "override_total_1": 4398.59,
    "override_increase_1": 121.36
  },
  {
    "#": "1056 Beacon St, Unit C (009B-07-03)",
    "$": 484100,
    "address": "1056 Beacon St, Unit C",
    "parcel_id": "009B-07-03",
    "owner1": "FABRIZIO, CHARLEEN F & GEORGE N",
    "owner2": "",
    "current_taxes": 4957.18,
    "new_taxes_no_override": 5171.33,
    "override_total_1": 5318.06,
    "override_increase_1": 146.73
  },
  {
    "#": "1056 Beacon St, Unit Pk-Y-Z-Aa (009B-07-59)",
    "$": 153600,
    "address": "1056 Beacon St, Unit Pk-Y-Z-Aa",
    "parcel_id": "009B-07-59",
    "owner1": "BEACON GATE CONDOS",
    "owner2": "C/O CERTIFIED PROPERTY MGMT",
    "current_taxes": 1572.86,
    "new_taxes_no_override": 1640.81,
    "override_total_1": 1687.36,
    "override_increase_1": 46.56
  },
  {
    "#": "1056 Beacon St, Unit Prk-N (009B-07-60)",
    "$": 50400,
    "address": "1056 Beacon St, Unit Prk-N",
    "parcel_id": "009B-07-60",
    "owner1": "SUN, DYANNA",
    "owner2": "YUNG, RICKY",
    "current_taxes": 516.1,
    "new_taxes_no_override": 538.4,
    "override_total_1": 553.67,
    "override_increase_1": 15.28
  },
  {
    "#": "1057 Beacon St (116-22-00)",
    "$": 1873700,
    "address": "1057 Beacon St",
    "parcel_id": "116-22-00",
    "owner1": "BROOKLINE HOUSING AUTHORITY",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "1059 Beacon St (116-21-00)",
    "$": 3841100,
    "address": "1059 Beacon St",
    "parcel_id": "116-21-00",
    "owner1": "TURK, JOSEPH E",
    "owner2": "",
    "current_taxes": 35697.93,
    "new_taxes_no_override": 37240.08,
    "override_total_1": 38296.74,
    "override_increase_1": 1056.66
  },
  {
    "#": "1060 Beacon St, Unit 1 & P9 (009B-07-23)",
    "$": 795200,
    "address": "1060 Beacon St, Unit 1 & P9",
    "parcel_id": "009B-07-23",
    "owner1": "WU, WESTLEY WENBO",
    "owner2": "PAYNE, JASON",
    "current_taxes": 4507.91,
    "new_taxes_no_override": 4702.65,
    "override_total_1": 4836.09,
    "override_increase_1": 133.43
  },
  {
    "#": "1060 Beacon St, Unit 10 & Prk (009B-07-32)",
    "$": 865200,
    "address": "1060 Beacon St, Unit 10 & Prk",
    "parcel_id": "009B-07-32",
    "owner1": "PELL, GABRIEL",
    "owner2": "",
    "current_taxes": 5224.71,
    "new_taxes_no_override": 5450.42,
    "override_total_1": 5605.07,
    "override_increase_1": 154.65
  },
  {
    "#": "1060 Beacon St, Unit 11 & P18 (009B-07-33)",
    "$": 604200,
    "address": "1060 Beacon St, Unit 11 & P18",
    "parcel_id": "009B-07-33",
    "owner1": "GUTTENBERG, ELIZABETH",
    "owner2": "",
    "current_taxes": 2552.07,
    "new_taxes_no_override": 2662.32,
    "override_total_1": 2737.86,
    "override_increase_1": 75.54
  },
  {
    "#": "1060 Beacon St, Unit 12 & Prk (009B-07-34)",
    "$": 561800,
    "address": "1060 Beacon St, Unit 12 & Prk",
    "parcel_id": "009B-07-34",
    "owner1": "MORTE, TR, STEPHEN G",
    "owner2": "",
    "current_taxes": 5752.83,
    "new_taxes_no_override": 6001.35,
    "override_total_1": 6171.64,
    "override_increase_1": 170.28
  },
  {
    "#": "1060 Beacon St, Unit 12A & P17 (009B-07-35)",
    "$": 758100,
    "address": "1060 Beacon St, Unit 12A & P17",
    "parcel_id": "009B-07-35",
    "owner1": "HALL, KELLY",
    "owner2": "SOLOMON, MATTHEW",
    "current_taxes": 7762.94,
    "new_taxes_no_override": 8098.3,
    "override_total_1": 8328.08,
    "override_increase_1": 229.78
  },
  {
    "#": "1060 Beacon St, Unit 14 (009B-07-36)",
    "$": 663700,
    "address": "1060 Beacon St, Unit 14",
    "parcel_id": "009B-07-36",
    "owner1": "CANCHOLA, ANGELA MARIE",
    "owner2": "PHILBIN, JOHN",
    "current_taxes": 6796.29,
    "new_taxes_no_override": 7089.89,
    "override_total_1": 7291.06,
    "override_increase_1": 201.17
  },
  {
    "#": "1060 Beacon St, Unit 15 (009B-07-37)",
    "$": 491000,
    "address": "1060 Beacon St, Unit 15",
    "parcel_id": "009B-07-37",
    "owner1": "LUCIC, KATIA",
    "owner2": "",
    "current_taxes": 5027.84,
    "new_taxes_no_override": 5245.04,
    "override_total_1": 5393.87,
    "override_increase_1": 148.82
  },
  {
    "#": "1060 Beacon St, Unit 16 (009B-07-38)",
    "$": 479200,
    "address": "1060 Beacon St, Unit 16",
    "parcel_id": "009B-07-38",
    "owner1": "DIAMOND, DANIEL J",
    "owner2": "",
    "current_taxes": 4907.01,
    "new_taxes_no_override": 5118.99,
    "override_total_1": 5264.24,
    "override_increase_1": 145.25
  },
  {
    "#": "1060 Beacon St, Unit 2 & P19 (009B-07-24)",
    "$": 639600,
    "address": "1060 Beacon St, Unit 2 & P19",
    "parcel_id": "009B-07-24",
    "owner1": "AHLEMEYER, LISA",
    "owner2": "",
    "current_taxes": 6549.5,
    "new_taxes_no_override": 6832.44,
    "override_total_1": 7026.3,
    "override_increase_1": 193.87
  },
  {
    "#": "1060 Beacon St, Unit 3 (009B-07-25)",
    "$": 497700,
    "address": "1060 Beacon St, Unit 3",
    "parcel_id": "009B-07-25",
    "owner1": "KRIZ TR, YU LIN",
    "owner2": "",
    "current_taxes": 5096.45,
    "new_taxes_no_override": 5316.62,
    "override_total_1": 5467.47,
    "override_increase_1": 150.85
  },
  {
    "#": "1060 Beacon St, Unit 4 (009B-07-26)",
    "$": 461700,
    "address": "1060 Beacon St, Unit 4",
    "parcel_id": "009B-07-26",
    "owner1": "GRIFFIN TRS, PAUL V JR & KEVIN P",
    "owner2": "LUBKER, SCOTT O",
    "current_taxes": 4727.81,
    "new_taxes_no_override": 4932.05,
    "override_total_1": 5071.99,
    "override_increase_1": 139.94
  },
  {
    "#": "1060 Beacon St, Unit 5 & Prk (009B-07-27)",
    "$": 777800,
    "address": "1060 Beacon St, Unit 5 & Prk",
    "parcel_id": "009B-07-27",
    "owner1": "ZHANG, SUI",
    "owner2": "YI, JI",
    "current_taxes": 7964.67,
    "new_taxes_no_override": 8308.74,
    "override_total_1": 8544.5,
    "override_increase_1": 235.75
  },
  {
    "#": "1060 Beacon St, Unit 6 & Prk (009B-07-28)",
    "$": 813800,
    "address": "1060 Beacon St, Unit 6 & Prk",
    "parcel_id": "009B-07-28",
    "owner1": "WANG, FENG & HELENA XUE",
    "owner2": "ZHANG, WENXIA",
    "current_taxes": 4698.38,
    "new_taxes_no_override": 4901.35,
    "override_total_1": 5040.42,
    "override_increase_1": 139.07
  },
  {
    "#": "1060 Beacon St, Unit 7 (009B-07-29)",
    "$": 479300,
    "address": "1060 Beacon St, Unit 7",
    "parcel_id": "009B-07-29",
    "owner1": "WINOGRAD, DANIEL H",
    "owner2": "FELDSCHER, KAREN",
    "current_taxes": 4908.03,
    "new_taxes_no_override": 5120.06,
    "override_total_1": 5265.33,
    "override_increase_1": 145.28
  },
  {
    "#": "1060 Beacon St, Unit 8 (009B-07-30)",
    "$": 482700,
    "address": "1060 Beacon St, Unit 8",
    "parcel_id": "009B-07-30",
    "owner1": "ZHANG, FEIXUE",
    "owner2": "BLESS S MATTHEW, C/O THRIVE REALY PARTNERS",
    "current_taxes": 4942.85,
    "new_taxes_no_override": 5156.38,
    "override_total_1": 5302.69,
    "override_increase_1": 146.31
  },
  {
    "#": "1060 Beacon St, Unit 9 & Prk (009B-07-31)",
    "$": 780300,
    "address": "1060 Beacon St, Unit 9 & Prk",
    "parcel_id": "009B-07-31",
    "owner1": "PARFITT, MATTHEW A",
    "owner2": "WELCH, JEFFREY S",
    "current_taxes": 4355.34,
    "new_taxes_no_override": 4543.49,
    "override_total_1": 4672.41,
    "override_increase_1": 128.92
  },
  {
    "#": "1060 Beacon St, Unit A (009B-07-20)",
    "$": 473600,
    "address": "1060 Beacon St, Unit A",
    "parcel_id": "009B-07-20",
    "owner1": "BRILLHART, STEVEN RODNEY JR",
    "owner2": "HOGAN, CARA ELIZABETH",
    "current_taxes": 4849.66,
    "new_taxes_no_override": 5059.17,
    "override_total_1": 5202.72,
    "override_increase_1": 143.55
  },
  {
    "#": "1060 Beacon St, Unit B (009B-07-21)",
    "$": 403500,
    "address": "1060 Beacon St, Unit B",
    "parcel_id": "009B-07-21",
    "owner1": "TANKARD, AUDRIA L",
    "owner2": "",
    "current_taxes": 496.91,
    "new_taxes_no_override": 518.38,
    "override_total_1": 533.09,
    "override_increase_1": 14.71
  },
  {
    "#": "1060 Beacon St, Unit C (009B-07-22)",
    "$": 316000,
    "address": "1060 Beacon St, Unit C",
    "parcel_id": "009B-07-22",
    "owner1": "ZHANG, FEIXUE",
    "owner2": "",
    "current_taxes": 3235.84,
    "new_taxes_no_override": 3375.63,
    "override_total_1": 3471.41,
    "override_increase_1": 95.78
  },
  {
    "#": "1061 Beacon St (116-20-00)",
    "$": 2976700,
    "address": "1061 Beacon St",
    "parcel_id": "116-20-00",
    "owner1": "1061 BEACON STREET LLC",
    "owner2": "",
    "current_taxes": 30481.41,
    "new_taxes_no_override": 31798.21,
    "override_total_1": 32700.46,
    "override_increase_1": 902.25
  },
  {
    "#": "1063 Beacon St (116-19-00)",
    "$": 3699900,
    "address": "1063 Beacon St",
    "parcel_id": "116-19-00",
    "owner1": "HANEY TR, MATTHEW",
    "owner2": "",
    "current_taxes": 37886.98,
    "new_taxes_no_override": 39523.7,
    "override_total_1": 40645.15,
    "override_increase_1": 1121.45
  },
  {
    "#": "1064 Beacon St, Unit 1 & Prk (009B-07-41)",
    "$": 638700,
    "address": "1064 Beacon St, Unit 1 & Prk",
    "parcel_id": "009B-07-41",
    "owner1": "TANASIJEVIC TRS, MILENKO & OLIVERA",
    "owner2": "",
    "current_taxes": 6540.29,
    "new_taxes_no_override": 6822.83,
    "override_total_1": 7016.42,
    "override_increase_1": 193.59
  },
  {
    "#": "1064 Beacon St, Unit 10 (009B-07-50)",
    "$": 751700,
    "address": "1064 Beacon St, Unit 10",
    "parcel_id": "009B-07-50",
    "owner1": "LAWTON, JOHN GRANT & BESSIE LEE & RALPH",
    "owner2": "",
    "current_taxes": 4062.47,
    "new_taxes_no_override": 4237.97,
    "override_total_1": 4358.22,
    "override_increase_1": 120.25
  },
  {
    "#": "1064 Beacon St, Unit 11 (009B-07-51)",
    "$": 515300,
    "address": "1064 Beacon St, Unit 11",
    "parcel_id": "009B-07-51",
    "owner1": "STEIN, ELLEN S",
    "owner2": "",
    "current_taxes": 1641.74,
    "new_taxes_no_override": 1712.66,
    "override_total_1": 1761.26,
    "override_increase_1": 48.6
  },
  {
    "#": "1064 Beacon St, Unit 12 (009B-07-52)",
    "$": 480200,
    "address": "1064 Beacon St, Unit 12",
    "parcel_id": "009B-07-52",
    "owner1": "BRILLHART, AMANDA ROSE",
    "owner2": "",
    "current_taxes": 1282.31,
    "new_taxes_no_override": 1337.71,
    "override_total_1": 1375.66,
    "override_increase_1": 37.96
  },
  {
    "#": "1064 Beacon St, Unit 12A (009B-07-53)",
    "$": 734800,
    "address": "1064 Beacon St, Unit 12A",
    "parcel_id": "009B-07-53",
    "owner1": "SUN, DYANNA",
    "owner2": "YUNG, RICKY",
    "current_taxes": 3889.42,
    "new_taxes_no_override": 4057.44,
    "override_total_1": 4172.57,
    "override_increase_1": 115.13
  },
  {
    "#": "1064 Beacon St, Unit 14 & Prk (009B-07-54)",
    "$": 760400,
    "address": "1064 Beacon St, Unit 14 & Prk",
    "parcel_id": "009B-07-54",
    "owner1": "PICARIELLO TRS, JOYCE ANN & MICHAEL",
    "owner2": "",
    "current_taxes": 7786.5,
    "new_taxes_no_override": 8122.88,
    "override_total_1": 8353.36,
    "override_increase_1": 230.48
  },
  {
    "#": "1064 Beacon St, Unit 15 (009B-07-55)",
    "$": 558900,
    "address": "1064 Beacon St, Unit 15",
    "parcel_id": "009B-07-55",
    "owner1": "GLASER, LOREN",
    "owner2": "",
    "current_taxes": 2088.2,
    "new_taxes_no_override": 2178.41,
    "override_total_1": 2240.22,
    "override_increase_1": 61.81
  },
  {
    "#": "1064 Beacon St, Unit 16 & Prk (009B-07-56)",
    "$": 542100,
    "address": "1064 Beacon St, Unit 16 & Prk",
    "parcel_id": "009B-07-56",
    "owner1": "KAMAL TRS, PANKAJ & SONIA",
    "owner2": "",
    "current_taxes": 5551.1,
    "new_taxes_no_override": 5790.91,
    "override_total_1": 5955.22,
    "override_increase_1": 164.31
  },
  {
    "#": "1064 Beacon St, Unit 2 (009B-07-42)",
    "$": 654400,
    "address": "1064 Beacon St, Unit 2",
    "parcel_id": "009B-07-42",
    "owner1": "XIAO TR, DAILI",
    "owner2": "",
    "current_taxes": 6701.06,
    "new_taxes_no_override": 6990.55,
    "override_total_1": 7188.9,
    "override_increase_1": 198.35
  },
  {
    "#": "1064 Beacon St, Unit 3 & Prk (009B-07-43)",
    "$": 563800,
    "address": "1064 Beacon St, Unit 3 & Prk",
    "parcel_id": "009B-07-43",
    "owner1": "LEW, EMILY & HELEN E",
    "owner2": "",
    "current_taxes": 2138.38,
    "new_taxes_no_override": 2230.76,
    "override_total_1": 2294.05,
    "override_increase_1": 63.3
  },
  {
    "#": "1064 Beacon St, Unit 4 & P-C (009B-07-44)",
    "$": 542100,
    "address": "1064 Beacon St, Unit 4 & P-C",
    "parcel_id": "009B-07-44",
    "owner1": "OFFICER TR, ARLENN J",
    "owner2": "",
    "current_taxes": 5551.1,
    "new_taxes_no_override": 5790.91,
    "override_total_1": 5955.22,
    "override_increase_1": 164.31
  },
  {
    "#": "1064 Beacon St, Unit 5 & P10 (009B-07-45)",
    "$": 799300,
    "address": "1064 Beacon St, Unit 5 & P10",
    "parcel_id": "009B-07-45",
    "owner1": "VAN DISSEL TR, GERALDINE J",
    "owner2": "",
    "current_taxes": 8184.83,
    "new_taxes_no_override": 8538.41,
    "override_total_1": 8780.69,
    "override_increase_1": 242.27
  },
  {
    "#": "1064 Beacon St, Unit 6 (009B-07-46)",
    "$": 710400,
    "address": "1064 Beacon St, Unit 6",
    "parcel_id": "009B-07-46",
    "owner1": "LIU, TIEWEN",
    "owner2": "",
    "current_taxes": 3639.56,
    "new_taxes_no_override": 3796.79,
    "override_total_1": 3904.52,
    "override_increase_1": 107.73
  },
  {
    "#": "1064 Beacon St, Unit 7 (009B-07-47)",
    "$": 588000,
    "address": "1064 Beacon St, Unit 7",
    "parcel_id": "009B-07-47",
    "owner1": "LLORENTE, LISA",
    "owner2": "",
    "current_taxes": 2386.19,
    "new_taxes_no_override": 2489.27,
    "override_total_1": 2559.9,
    "override_increase_1": 70.63
  },
  {
    "#": "1064 Beacon St, Unit 8 & Prk (009B-07-48)",
    "$": 571200,
    "address": "1064 Beacon St, Unit 8 & Prk",
    "parcel_id": "009B-07-48",
    "owner1": "TSANG TRS, VIVIAN WING SZE",
    "owner2": "POON, MUK FAI CHRISTOPHER",
    "current_taxes": 5849.09,
    "new_taxes_no_override": 6101.77,
    "override_total_1": 6274.9,
    "override_increase_1": 173.13
  },
  {
    "#": "1064 Beacon St, Unit 9 & Prk (009B-07-49)",
    "$": 783000,
    "address": "1064 Beacon St, Unit 9 & Prk",
    "parcel_id": "009B-07-49",
    "owner1": "TROXELL TR, JAMES",
    "owner2": "",
    "current_taxes": 8017.92,
    "new_taxes_no_override": 8364.29,
    "override_total_1": 8601.62,
    "override_increase_1": 237.33
  },
  {
    "#": "1064 Beacon St, Unit A (009B-07-39)",
    "$": 349500,
    "address": "1064 Beacon St, Unit A",
    "parcel_id": "009B-07-39",
    "owner1": "FORTUNATO TRS, ANTHONY J & JENNIFER A",
    "owner2": "",
    "current_taxes": 3578.88,
    "new_taxes_no_override": 3733.49,
    "override_total_1": 3839.42,
    "override_increase_1": 105.93
  },
  {
    "#": "1064 Beacon St, Unit B (009B-07-57)",
    "$": 378400,
    "address": "1064 Beacon St, Unit B",
    "parcel_id": "009B-07-57",
    "owner1": "BEACON GATE CONDO ASSOCIATION",
    "owner2": "C/O CERTIFIED PROPERTY MGMT",
    "current_taxes": 3874.82,
    "new_taxes_no_override": 4042.21,
    "override_total_1": 4156.91,
    "override_increase_1": 114.69
  },
  {
    "#": "1064 Beacon St, Unit C (009B-07-58)",
    "$": 326300,
    "address": "1064 Beacon St, Unit C",
    "parcel_id": "009B-07-58",
    "owner1": "BEACON GATE CONDO ASSOCIATION",
    "owner2": "C/O CERTIFIED PROPERTY MGMT",
    "current_taxes": 3341.31,
    "new_taxes_no_override": 3485.65,
    "override_total_1": 3584.56,
    "override_increase_1": 98.9
  },
  {
    "#": "1064 Beacon St, Unit D (009B-07-40)",
    "$": 390800,
    "address": "1064 Beacon St, Unit D",
    "parcel_id": "009B-07-40",
    "owner1": "EINHORN, IGNAT",
    "owner2": "",
    "current_taxes": 4001.79,
    "new_taxes_no_override": 4174.67,
    "override_total_1": 4293.12,
    "override_increase_1": 118.45
  },
  {
    "#": "1065 Beacon St (116-18-00)",
    "$": 3428000,
    "address": "1065 Beacon St",
    "parcel_id": "116-18-00",
    "owner1": "SIX CONN LLC",
    "owner2": "",
    "current_taxes": 35102.72,
    "new_taxes_no_override": 36619.16,
    "override_total_1": 37658.2,
    "override_increase_1": 1039.04
  },
  {
    "#": "1067 Beacon St (116-17-00)",
    "$": 3704100,
    "address": "1067 Beacon St",
    "parcel_id": "116-17-00",
    "owner1": "KRAMER, PETER & GERRY",
    "owner2": "",
    "current_taxes": 34295.05,
    "new_taxes_no_override": 35776.6,
    "override_total_1": 36791.73,
    "override_increase_1": 1015.13
  },
  {
    "#": "1069 Beacon St (116-15-00)",
    "$": 7348400,
    "address": "1069 Beacon St",
    "parcel_id": "116-15-00",
    "owner1": "HANEY TR, MATTHEW",
    "owner2": "",
    "current_taxes": 75247.62,
    "new_taxes_no_override": 78498.32,
    "override_total_1": 80725.65,
    "override_increase_1": 2227.33
  },
  {
    "#": "1070 Beacon St (009B-09-00)",
    "$": 12960600,
    "address": "1070 Beacon St",
    "parcel_id": "009B-09-00",
    "owner1": "TEN SEVENTY TENANTS HOUSING CO",
    "owner2": "C/O JENNIFER PORTER",
    "current_taxes": 132716.54,
    "new_taxes_no_override": 138449.89,
    "override_total_1": 142378.3,
    "override_increase_1": 3928.41
  },
  {
    "#": "1073 Beacon St (116-14-00)",
    "$": 3913000,
    "address": "1073 Beacon St",
    "parcel_id": "116-14-00",
    "owner1": "LI, HONGYING",
    "owner2": "LIU, YANG HUA",
    "current_taxes": 40069.12,
    "new_taxes_no_override": 41800.11,
    "override_total_1": 42986.15,
    "override_increase_1": 1186.05
  },
  {
    "#": "1075 Beacon St (116-13-00)",
    "$": 2749600,
    "address": "1075 Beacon St",
    "parcel_id": "116-13-00",
    "owner1": "CIVITARESE, ELIZABETH L",
    "owner2": "",
    "current_taxes": 24520.97,
    "new_taxes_no_override": 25580.28,
    "override_total_1": 26306.1,
    "override_increase_1": 725.82
  },
  {
    "#": "1077 Beacon St (116-12-00)",
    "$": 2932600,
    "address": "1077 Beacon St",
    "parcel_id": "116-12-00",
    "owner1": "1077 BEACON ST LLC",
    "owner2": "HANDLER BEACON ST LLC",
    "current_taxes": 30029.82,
    "new_taxes_no_override": 31327.11,
    "override_total_1": 32215.99,
    "override_increase_1": 888.88
  },
  {
    "#": "1079 Beacon St, Unit 1 & P6 (116-10-08)",
    "$": 1178900,
    "address": "1079 Beacon St, Unit 1 & P6",
    "parcel_id": "116-10-08",
    "owner1": "RUBIN, ROBIN M",
    "owner2": "MACDONALD, THOMAS",
    "current_taxes": 8437.0,
    "new_taxes_no_override": 8801.48,
    "override_total_1": 9051.21,
    "override_increase_1": 249.74
  },
  {
    "#": "1079 Beacon St, Unit 2 (116-10-01)",
    "$": 989200,
    "address": "1079 Beacon St, Unit 2",
    "parcel_id": "116-10-01",
    "owner1": "GAGNE, ROBERT",
    "owner2": "TAKICAWA, KUNIE",
    "current_taxes": 10129.41,
    "new_taxes_no_override": 10567.0,
    "override_total_1": 10866.83,
    "override_increase_1": 299.83
  },
  {
    "#": "1079 Beacon St, Unit 3 (116-10-02)",
    "$": 917500,
    "address": "1079 Beacon St, Unit 3",
    "parcel_id": "116-10-02",
    "owner1": "HORVATH, JULIE R",
    "owner2": "",
    "current_taxes": 5760.27,
    "new_taxes_no_override": 6009.11,
    "override_total_1": 6179.62,
    "override_increase_1": 170.5
  },
  {
    "#": "1079 Beacon St, Unit 4 & P4 (116-10-03)",
    "$": 1038700,
    "address": "1079 Beacon St, Unit 4 & P4",
    "parcel_id": "116-10-03",
    "owner1": "MASTROMONACO, JULIE A",
    "owner2": "",
    "current_taxes": 7001.35,
    "new_taxes_no_override": 7303.81,
    "override_total_1": 7511.05,
    "override_increase_1": 207.24
  },
  {
    "#": "1079 Beacon St, Unit 5 & P5 (116-10-04)",
    "$": 966000,
    "address": "1079 Beacon St, Unit 5 & P5",
    "parcel_id": "116-10-04",
    "owner1": "QUON, JUSTIN L & AMANDA L",
    "owner2": "",
    "current_taxes": 6256.91,
    "new_taxes_no_override": 6527.21,
    "override_total_1": 6712.41,
    "override_increase_1": 185.2
  },
  {
    "#": "1079 Beacon St, Unit 6 & P8 (116-10-05)",
    "$": 1320300,
    "address": "1079 Beacon St, Unit 6 & P8",
    "parcel_id": "116-10-05",
    "owner1": "BARBARAS, LARRY",
    "owner2": "GUY, SALLY",
    "current_taxes": 9884.94,
    "new_taxes_no_override": 10311.97,
    "override_total_1": 10604.56,
    "override_increase_1": 292.59
  },
  {
    "#": "1079 Beacon St, Unit 7 & P3 (116-10-06)",
    "$": 1258600,
    "address": "1079 Beacon St, Unit 7 & P3",
    "parcel_id": "116-10-06",
    "owner1": "ZUBILLAGA, BERNARDO",
    "owner2": "HERRERA DE ZUBILLAGA, SUSANA",
    "current_taxes": 12888.06,
    "new_taxes_no_override": 13444.82,
    "override_total_1": 13826.31,
    "override_increase_1": 381.49
  },
  {
    "#": "1080 Beacon St, Unit 1A (009B-10-03)",
    "$": 1578100,
    "address": "1080 Beacon St, Unit 1A",
    "parcel_id": "009B-10-03",
    "owner1": "HASELWANDTER TR, ELIZABETH M",
    "owner2": "",
    "current_taxes": 16159.74,
    "new_taxes_no_override": 16857.84,
    "override_total_1": 17336.17,
    "override_increase_1": 478.33
  },
  {
    "#": "1080 Beacon St, Unit 1B (009B-10-04)",
    "$": 659900,
    "address": "1080 Beacon St, Unit 1B",
    "parcel_id": "009B-10-04",
    "owner1": "OMARY, BISHR",
    "owner2": "",
    "current_taxes": 6757.38,
    "new_taxes_no_override": 7049.3,
    "override_total_1": 7249.32,
    "override_increase_1": 200.02
  },
  {
    "#": "1080 Beacon St, Unit 1C (009B-10-05)",
    "$": 541600,
    "address": "1080 Beacon St, Unit 1C",
    "parcel_id": "009B-10-05",
    "owner1": "DEVANEY, KEVIN J",
    "owner2": "",
    "current_taxes": 5545.98,
    "new_taxes_no_override": 5785.57,
    "override_total_1": 5949.73,
    "override_increase_1": 164.16
  },
  {
    "#": "1080 Beacon St, Unit 1D (009B-10-06)",
    "$": 659600,
    "address": "1080 Beacon St, Unit 1D",
    "parcel_id": "009B-10-06",
    "owner1": "SHEN, RUOBING",
    "owner2": "",
    "current_taxes": 6754.3,
    "new_taxes_no_override": 7046.09,
    "override_total_1": 7246.01,
    "override_increase_1": 199.93
  },
  {
    "#": "1080 Beacon St, Unit 2A (009B-10-07)",
    "$": 1788300,
    "address": "1080 Beacon St, Unit 2A",
    "parcel_id": "009B-10-07",
    "owner1": "HU TRS, XUEQIN",
    "owner2": "",
    "current_taxes": 14677.26,
    "new_taxes_no_override": 15311.32,
    "override_total_1": 15745.76,
    "override_increase_1": 434.45
  },
  {
    "#": "1080 Beacon St, Unit 2B (009B-10-08)",
    "$": 722900,
    "address": "1080 Beacon St, Unit 2B",
    "parcel_id": "009B-10-08",
    "owner1": "ZHANG, AMY & WEI",
    "owner2": "LU, TONGJUN",
    "current_taxes": 3767.56,
    "new_taxes_no_override": 3930.32,
    "override_total_1": 4041.84,
    "override_increase_1": 111.52
  },
  {
    "#": "1080 Beacon St, Unit 2C (009B-10-09)",
    "$": 563400,
    "address": "1080 Beacon St, Unit 2C",
    "parcel_id": "009B-10-09",
    "owner1": "HE, PING N",
    "owner2": "XU, AMY JIA",
    "current_taxes": 5769.22,
    "new_taxes_no_override": 6018.45,
    "override_total_1": 6189.22,
    "override_increase_1": 170.77
  },
  {
    "#": "1080 Beacon St, Unit 2D (009B-10-10)",
    "$": 807200,
    "address": "1080 Beacon St, Unit 2D",
    "parcel_id": "009B-10-10",
    "owner1": "NELSON, TERESA E",
    "owner2": "STERN, DIANE S",
    "current_taxes": 4630.79,
    "new_taxes_no_override": 4830.84,
    "override_total_1": 4967.91,
    "override_increase_1": 137.07
  },
  {
    "#": "1080 Beacon St, Unit 3A (009B-10-11)",
    "$": 824300,
    "address": "1080 Beacon St, Unit 3A",
    "parcel_id": "009B-10-11",
    "owner1": "CARDOZO, MARIO G & CECILIA E B",
    "owner2": "",
    "current_taxes": 8440.83,
    "new_taxes_no_override": 8805.47,
    "override_total_1": 9055.32,
    "override_increase_1": 249.85
  },
  {
    "#": "1080 Beacon St, Unit 3B (009B-10-12)",
    "$": 973200,
    "address": "1080 Beacon St, Unit 3B",
    "parcel_id": "009B-10-12",
    "owner1": "ANGHELESCU, DORALINA",
    "owner2": "",
    "current_taxes": 9965.57,
    "new_taxes_no_override": 10396.08,
    "override_total_1": 10691.06,
    "override_increase_1": 294.98
  },
  {
    "#": "1080 Beacon St, Unit 3C (009B-10-13)",
    "$": 730000,
    "address": "1080 Beacon St, Unit 3C",
    "parcel_id": "009B-10-13",
    "owner1": "BAJIC, SIBINKA",
    "owner2": "",
    "current_taxes": 7475.2,
    "new_taxes_no_override": 7798.13,
    "override_total_1": 8019.39,
    "override_increase_1": 221.27
  },
  {
    "#": "1080 Beacon St, Unit 3D (009B-10-14)",
    "$": 575200,
    "address": "1080 Beacon St, Unit 3D",
    "parcel_id": "009B-10-14",
    "owner1": "NOIMAN, LIRON",
    "owner2": "",
    "current_taxes": 5890.05,
    "new_taxes_no_override": 6144.5,
    "override_total_1": 6318.85,
    "override_increase_1": 174.35
  },
  {
    "#": "1080 Beacon St, Unit 3E (009B-10-15)",
    "$": 809900,
    "address": "1080 Beacon St, Unit 3E",
    "parcel_id": "009B-10-15",
    "owner1": "LEVITT, RACHEL",
    "owner2": "",
    "current_taxes": 4658.44,
    "new_taxes_no_override": 4859.68,
    "override_total_1": 4997.57,
    "override_increase_1": 137.89
  },
  {
    "#": "1080 Beacon St, Unit 4A (009B-10-16)",
    "$": 819000,
    "address": "1080 Beacon St, Unit 4A",
    "parcel_id": "009B-10-16",
    "owner1": "BENADE, JOHANNES GERHARDUS & MARIET",
    "owner2": "",
    "current_taxes": 4751.63,
    "new_taxes_no_override": 4956.9,
    "override_total_1": 5097.55,
    "override_increase_1": 140.65
  },
  {
    "#": "1080 Beacon St, Unit 4B (009B-10-17)",
    "$": 1040700,
    "address": "1080 Beacon St, Unit 4B",
    "parcel_id": "009B-10-17",
    "owner1": "NATHAN, LUCAS",
    "owner2": "TARANTAL, ERIKA V",
    "current_taxes": 7021.83,
    "new_taxes_no_override": 7325.17,
    "override_total_1": 7533.02,
    "override_increase_1": 207.85
  },
  {
    "#": "1080 Beacon St, Unit 4C (009B-10-18)",
    "$": 729100,
    "address": "1080 Beacon St, Unit 4C",
    "parcel_id": "009B-10-18",
    "owner1": "WALKER, DAVID A & MADELINE ELISABETH",
    "owner2": "",
    "current_taxes": 3831.05,
    "new_taxes_no_override": 3996.55,
    "override_total_1": 4109.95,
    "override_increase_1": 113.4
  },
  {
    "#": "1080 Beacon St, Unit 4D (009B-10-19)",
    "$": 556600,
    "address": "1080 Beacon St, Unit 4D",
    "parcel_id": "009B-10-19",
    "owner1": "OTTEN, CYNTHIA",
    "owner2": "",
    "current_taxes": 5699.58,
    "new_taxes_no_override": 5945.8,
    "override_total_1": 6114.51,
    "override_increase_1": 168.71
  },
  {
    "#": "1080 Beacon St, Unit 4E (009B-10-20)",
    "$": 789800,
    "address": "1080 Beacon St, Unit 4E",
    "parcel_id": "009B-10-20",
    "owner1": "LEIKHIM, PAUL J",
    "owner2": "",
    "current_taxes": 4452.62,
    "new_taxes_no_override": 4644.97,
    "override_total_1": 4776.77,
    "override_increase_1": 131.8
  },
  {
    "#": "1080 Beacon St, Unit 5A (009B-10-21)",
    "$": 831800,
    "address": "1080 Beacon St, Unit 5A",
    "parcel_id": "009B-10-21",
    "owner1": "SCHORGE, JOHN O",
    "owner2": "",
    "current_taxes": 8517.63,
    "new_taxes_no_override": 8885.59,
    "override_total_1": 9137.71,
    "override_increase_1": 252.12
  },
  {
    "#": "1080 Beacon St, Unit 5B (009B-10-22)",
    "$": 1039500,
    "address": "1080 Beacon St, Unit 5B",
    "parcel_id": "009B-10-22",
    "owner1": "TEMPERO, JAMES L & EILEEN M",
    "owner2": "",
    "current_taxes": 7009.55,
    "new_taxes_no_override": 7312.36,
    "override_total_1": 7519.85,
    "override_increase_1": 207.48
  },
  {
    "#": "1080 Beacon St, Unit 5C (009B-10-23)",
    "$": 761200,
    "address": "1080 Beacon St, Unit 5C",
    "parcel_id": "009B-10-23",
    "owner1": "CHANG TRS, DAVID & ROBERT & MICHAEL",
    "owner2": "",
    "current_taxes": 7794.69,
    "new_taxes_no_override": 8131.42,
    "override_total_1": 8362.14,
    "override_increase_1": 230.72
  },
  {
    "#": "1080 Beacon St, Unit 5D (009B-10-24)",
    "$": 703700,
    "address": "1080 Beacon St, Unit 5D",
    "parcel_id": "009B-10-24",
    "owner1": "CHU, CAROL",
    "owner2": "",
    "current_taxes": 3570.95,
    "new_taxes_no_override": 3725.22,
    "override_total_1": 3830.92,
    "override_increase_1": 105.7
  },
  {
    "#": "1080 Beacon St, Unit 5E (009B-10-25)",
    "$": 811500,
    "address": "1080 Beacon St, Unit 5E",
    "parcel_id": "009B-10-25",
    "owner1": "DEQUEANT, MARY-LEE",
    "owner2": "",
    "current_taxes": 8309.76,
    "new_taxes_no_override": 8668.74,
    "override_total_1": 8914.71,
    "override_increase_1": 245.97
  },
  {
    "#": "1080 Beacon St, Unit 6A (009B-10-26)",
    "$": 2008600,
    "address": "1080 Beacon St, Unit 6A",
    "parcel_id": "009B-10-26",
    "owner1": "LYONS TR, JOHN J",
    "owner2": "",
    "current_taxes": 20568.06,
    "new_taxes_no_override": 21456.6,
    "override_total_1": 22065.41,
    "override_increase_1": 608.81
  },
  {
    "#": "1080 Beacon St, Unit 6B (009B-10-27)",
    "$": 841600,
    "address": "1080 Beacon St, Unit 6B",
    "parcel_id": "009B-10-27",
    "owner1": "SULLIVAN, NICOLA & GEOFFREY",
    "owner2": "",
    "current_taxes": 8617.98,
    "new_taxes_no_override": 8990.28,
    "override_total_1": 9245.37,
    "override_increase_1": 255.09
  },
  {
    "#": "1080 Beacon St, Unit 6C (009B-10-28)",
    "$": 635200,
    "address": "1080 Beacon St, Unit 6C",
    "parcel_id": "009B-10-28",
    "owner1": "SULLIVAN, NICOLA & GEOFFREY",
    "owner2": "",
    "current_taxes": 6504.45,
    "new_taxes_no_override": 6785.44,
    "override_total_1": 6977.97,
    "override_increase_1": 192.53
  },
  {
    "#": "1080 Beacon St, Unit 6D (009B-10-29)",
    "$": 802600,
    "address": "1080 Beacon St, Unit 6D",
    "parcel_id": "009B-10-29",
    "owner1": "WALSH STEVENSON, CHERYL",
    "owner2": "",
    "current_taxes": 4583.69,
    "new_taxes_no_override": 4781.71,
    "override_total_1": 4917.38,
    "override_increase_1": 135.68
  },
  {
    "#": "1080 Beacon St, Unit G1B1 (009B-10-30)",
    "$": 670300,
    "address": "1080 Beacon St, Unit G1B1",
    "parcel_id": "009B-10-30",
    "owner1": "FELLING, WILLIAM D",
    "owner2": "C/O CAPITOL REALTY GROUP",
    "current_taxes": 6863.87,
    "new_taxes_no_override": 7160.39,
    "override_total_1": 7363.56,
    "override_increase_1": 203.17
  },
  {
    "#": "1080 Beacon St, Unit G2B2 (009B-10-01)",
    "$": 845500,
    "address": "1080 Beacon St, Unit G2B2",
    "parcel_id": "009B-10-01",
    "owner1": "MORAES, DANIEL R & MARIA GABRIELLA BONFIM",
    "owner2": "",
    "current_taxes": 5022.99,
    "new_taxes_no_override": 5239.98,
    "override_total_1": 5388.66,
    "override_increase_1": 148.68
  },
  {
    "#": "1080 Beacon St, Unit G3B3 (009B-10-02)",
    "$": 588400,
    "address": "1080 Beacon St, Unit G3B3",
    "parcel_id": "009B-10-02",
    "owner1": "ARGILAGOS, CARLOS",
    "owner2": "BRUETT, LINDA",
    "current_taxes": 6025.22,
    "new_taxes_no_override": 6285.51,
    "override_total_1": 6463.86,
    "override_increase_1": 178.35
  },
  {
    "#": "1081 Beacon St, Unit 8 & P2 (116-10-07)",
    "$": 1453900,
    "address": "1081 Beacon St, Unit 8 & P2",
    "parcel_id": "116-10-07",
    "owner1": "VAN SLYKE, LARA",
    "owner2": "ROSEN, BARRY R",
    "current_taxes": 11253.0,
    "new_taxes_no_override": 11739.13,
    "override_total_1": 12072.22,
    "override_increase_1": 333.09
  },
  {
    "#": "1083 Beacon St, Unit 1 & P9 (116-09-04)",
    "$": 1291200,
    "address": "1083 Beacon St, Unit 1 & P9",
    "parcel_id": "116-09-04",
    "owner1": "TUTTMAN, CORY S",
    "owner2": "PHILLIPS, MARIANNE",
    "current_taxes": 9586.95,
    "new_taxes_no_override": 10001.11,
    "override_total_1": 10284.88,
    "override_increase_1": 283.77
  },
  {
    "#": "1083 Beacon St, Unit 2 (116-09-01)",
    "$": 957600,
    "address": "1083 Beacon St, Unit 2",
    "parcel_id": "116-09-01",
    "owner1": "MAKEDON, FILLIA",
    "owner2": "",
    "current_taxes": 9805.82,
    "new_taxes_no_override": 10229.43,
    "override_total_1": 10519.68,
    "override_increase_1": 290.25
  },
  {
    "#": "1083 Beacon St, Unit 3 (116-09-02)",
    "$": 958800,
    "address": "1083 Beacon St, Unit 3",
    "parcel_id": "116-09-02",
    "owner1": "VITSEV, OLEG",
    "owner2": "REVINA, SVETLANA",
    "current_taxes": 6183.18,
    "new_taxes_no_override": 6450.29,
    "override_total_1": 6633.32,
    "override_increase_1": 183.02
  },
  {
    "#": "1083 Beacon St, Unit 4 & P-B (116-09-03)",
    "$": 1306200,
    "address": "1083 Beacon St, Unit 4 & P-B",
    "parcel_id": "116-09-03",
    "owner1": "GIANNAKOPOULOS, GEORGE ILIAS",
    "owner2": "LLINAS, ANGELA CRISTINA CASTILLO",
    "current_taxes": 9740.55,
    "new_taxes_no_override": 10161.34,
    "override_total_1": 10449.66,
    "override_increase_1": 288.32
  },
  {
    "#": "1085 Beacon St (116-08-00)",
    "$": 2736900,
    "address": "1085 Beacon St",
    "parcel_id": "116-08-00",
    "owner1": "ANTHONY TR, BARBARA A",
    "owner2": "",
    "current_taxes": 37474.93,
    "new_taxes_no_override": 39093.85,
    "override_total_1": 40203.1,
    "override_increase_1": 1109.26
  },
  {
    "#": "1087 Beacon St (116-07-00)",
    "$": 2526400,
    "address": "1087 Beacon St",
    "parcel_id": "116-07-00",
    "owner1": "GLOTH, DAVID A",
    "owner2": "",
    "current_taxes": 43353.02,
    "new_taxes_no_override": 45225.87,
    "override_total_1": 46509.12,
    "override_increase_1": 1283.25
  },
  {
    "#": "1089 Beacon St (116-06-00)",
    "$": 3732200,
    "address": "1089 Beacon St",
    "parcel_id": "116-06-00",
    "owner1": "BERET LLC",
    "owner2": "",
    "current_taxes": 38217.73,
    "new_taxes_no_override": 39868.74,
    "override_total_1": 40999.98,
    "override_increase_1": 1131.24
  },
  {
    "#": "1090 Beacon St (009B-11-00)",
    "$": 8425200,
    "address": "1090 Beacon St",
    "parcel_id": "009B-11-00",
    "owner1": "AMORY GARDENS REALTY LLC",
    "owner2": "C/O GARRETT AND JESSE CHRISTOPHER",
    "current_taxes": 86274.05,
    "new_taxes_no_override": 90001.09,
    "override_total_1": 92554.8,
    "override_increase_1": 2553.71
  },
  {
    "#": "1093 Beacon St (116-05-00)",
    "$": 5373800,
    "address": "1093 Beacon St",
    "parcel_id": "116-05-00",
    "owner1": "1093 BEACON STREET DEVELOPMENT LLC",
    "owner2": "",
    "current_taxes": 92214.41,
    "new_taxes_no_override": 96198.07,
    "override_total_1": 98927.62,
    "override_increase_1": 2729.55
  },
  {
    "#": "1100 Beacon St (009B-12-00)",
    "$": 8955000,
    "address": "1100 Beacon St",
    "parcel_id": "009B-12-00",
    "owner1": "AMORY GARDENS REALTY LLC",
    "owner2": "C/O GARRETT AND JESSE CHRISTOPHER",
    "current_taxes": 91699.2,
    "new_taxes_no_override": 95660.61,
    "override_total_1": 98374.9,
    "override_increase_1": 2714.3
  },
  {
    "#": "1101 Beacon St (117-09-00)",
    "$": 25940600,
    "address": "1101 Beacon St",
    "parcel_id": "117-09-00",
    "owner1": "1101 BEACON STREET ASSOC LP",
    "owner2": "C/O THE HAMILTON CO",
    "current_taxes": 445140.7,
    "new_taxes_no_override": 464370.78,
    "override_total_1": 477546.94,
    "override_increase_1": 13176.16
  },
  {
    "#": "1110 Beacon St (009B-13-00)",
    "$": 7935700,
    "address": "1110 Beacon St",
    "parcel_id": "009B-13-00",
    "owner1": "1110-1120 BEACON STREET LLC",
    "owner2": "C/O DANNIN MANAGEMENT CORP",
    "current_taxes": 81261.57,
    "new_taxes_no_override": 84772.07,
    "override_total_1": 87177.41,
    "override_increase_1": 2405.34
  },
  {
    "#": "1111 Beacon St (117-06-00)",
    "$": 38204500,
    "address": "1111 Beacon St",
    "parcel_id": "117-06-00",
    "owner1": "1101 BEACON STREET ASSOC LP",
    "owner2": "C/O THE HAMILTON CO",
    "current_taxes": 391214.08,
    "new_taxes_no_override": 408114.53,
    "override_total_1": 419694.47,
    "override_increase_1": 11579.94
  },
  {
    "#": "1120 Beacon St (009B-14-00)",
    "$": 9659200,
    "address": "1120 Beacon St",
    "parcel_id": "009B-14-00",
    "owner1": "1110-1120 BEACON STREET LLC",
    "owner2": "C/O DANNIN MANAGEMENT CORP",
    "current_taxes": 98910.21,
    "new_taxes_no_override": 103183.13,
    "override_total_1": 106110.87,
    "override_increase_1": 2927.74
  },
  {
    "#": "1122 Beacon St (009-03-00)",
    "$": 1966800,
    "address": "1122 Beacon St",
    "parcel_id": "009-03-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O HALLS POND",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "1126 Beacon St, Unit 1 (010-01-02)",
    "$": 1850700,
    "address": "1126 Beacon St, Unit 1",
    "parcel_id": "010-01-02",
    "owner1": "HERMAN, MYRON S & HELEN YOMTOV",
    "owner2": "",
    "current_taxes": 15316.23,
    "new_taxes_no_override": 15977.89,
    "override_total_1": 16431.25,
    "override_increase_1": 453.36
  },
  {
    "#": "1126 Beacon St, Unit 2 & P1-2 (010-01-03)",
    "$": 1979600,
    "address": "1126 Beacon St, Unit 2 & P1-2",
    "parcel_id": "010-01-03",
    "owner1": "SWARTZ, DOUGLAS A & KIMBERLY A",
    "owner2": "",
    "current_taxes": 16636.17,
    "new_taxes_no_override": 17354.85,
    "override_total_1": 17847.28,
    "override_increase_1": 492.43
  },
  {
    "#": "1126 Beacon St, Unit P3 (010-01-04)",
    "$": 51600,
    "address": "1126 Beacon St, Unit P3",
    "parcel_id": "010-01-04",
    "owner1": "SCHORGE, JOHN O",
    "owner2": "",
    "current_taxes": 528.38,
    "new_taxes_no_override": 551.21,
    "override_total_1": 566.85,
    "override_increase_1": 15.64
  },
  {
    "#": "1126 Beacon St, Unit P4 (010-01-05)",
    "$": 51600,
    "address": "1126 Beacon St, Unit P4",
    "parcel_id": "010-01-05",
    "owner1": "TEMPERO, JAMES L & EILEEN M",
    "owner2": "",
    "current_taxes": 528.38,
    "new_taxes_no_override": 551.21,
    "override_total_1": 566.85,
    "override_increase_1": 15.64
  },
  {
    "#": "1126 Beacon St, Unit P5 (010-01-06)",
    "$": 52300,
    "address": "1126 Beacon St, Unit P5",
    "parcel_id": "010-01-06",
    "owner1": "HASELWANDTER TR, ELIZABETH M",
    "owner2": "",
    "current_taxes": 535.55,
    "new_taxes_no_override": 558.69,
    "override_total_1": 574.54,
    "override_increase_1": 15.85
  },
  {
    "#": "1128 Beacon St (010-01-01)",
    "$": 2786000,
    "address": "1128 Beacon St",
    "parcel_id": "010-01-01",
    "owner1": "HAGOPIAN TRS, RAHEL T",
    "owner2": "SARKISSIAN, RAFFI DER",
    "current_taxes": 24893.71,
    "new_taxes_no_override": 25969.12,
    "override_total_1": 26705.97,
    "override_increase_1": 736.85
  },
  {
    "#": "1129 Beacon St (118-13-14)",
    "$": 35849800,
    "address": "1129 Beacon St",
    "parcel_id": "118-13-14",
    "owner1": "CHATHAM PARK NOMINEE TRUST",
    "owner2": "C/O GORIN H N INC",
    "current_taxes": 411467.87,
    "new_taxes_no_override": 429243.28,
    "override_total_1": 441422.73,
    "override_increase_1": 12179.45
  },
  {
    "#": "1140 Beacon St, Unit 101 G19-20-21 (010-02-05)",
    "$": 3375800,
    "address": "1140 Beacon St, Unit 101 G19-20-21",
    "parcel_id": "010-02-05",
    "owner1": "AXELROD, DORIS TOBY",
    "owner2": "MARKS, LAWRENCE J",
    "current_taxes": 30933.26,
    "new_taxes_no_override": 32269.58,
    "override_total_1": 33185.2,
    "override_increase_1": 915.62
  },
  {
    "#": "1140 Beacon St, Unit 102 G13-14 (010-02-06)",
    "$": 2769600,
    "address": "1140 Beacon St, Unit 102 G13-14",
    "parcel_id": "010-02-06",
    "owner1": "LUCAS, BRADLEY A",
    "owner2": "",
    "current_taxes": 24725.77,
    "new_taxes_no_override": 25793.92,
    "override_total_1": 26525.81,
    "override_increase_1": 731.88
  },
  {
    "#": "1140 Beacon St, Unit 103 &G3-G4 (010-02-07)",
    "$": 2417000,
    "address": "1140 Beacon St, Unit 103 &G3-G4",
    "parcel_id": "010-02-07",
    "owner1": "LEVY TR, GAIL STEINKOHL",
    "owner2": "",
    "current_taxes": 21115.15,
    "new_taxes_no_override": 22027.32,
    "override_total_1": 22652.33,
    "override_increase_1": 625.01
  },
  {
    "#": "1140 Beacon St, Unit 104 & G1-2 (010-02-08)",
    "$": 2907300,
    "address": "1140 Beacon St, Unit 104 & G1-2",
    "parcel_id": "010-02-08",
    "owner1": "WONG TRS, DAVID",
    "owner2": "KUBO, REIKO",
    "current_taxes": 29770.75,
    "new_taxes_no_override": 31056.85,
    "override_total_1": 31938.06,
    "override_increase_1": 881.21
  },
  {
    "#": "1140 Beacon St, Unit 105 G9-10-27 (010-02-09)",
    "$": 3675900,
    "address": "1140 Beacon St, Unit 105 G9-10-27",
    "parcel_id": "010-02-09",
    "owner1": "COHEN, STEPHEN M L & CAROL F",
    "owner2": "",
    "current_taxes": 37641.22,
    "new_taxes_no_override": 39267.32,
    "override_total_1": 40381.5,
    "override_increase_1": 1114.18
  },
  {
    "#": "1140 Beacon St, Unit 201 G23&24 (010-02-10)",
    "$": 3091500,
    "address": "1140 Beacon St, Unit 201 G23&24",
    "parcel_id": "010-02-10",
    "owner1": "LANDAY LIFE ESTATE, SHEILA D",
    "owner2": "",
    "current_taxes": 31656.96,
    "new_taxes_no_override": 33024.54,
    "override_total_1": 33961.59,
    "override_increase_1": 937.05
  },
  {
    "#": "1140 Beacon St, Unit 202 G15-16 (010-02-11)",
    "$": 2793100,
    "address": "1140 Beacon St, Unit 202 G15-16",
    "parcel_id": "010-02-11",
    "owner1": "ULLIAN, STEPHEN & ELAINE",
    "owner2": "",
    "current_taxes": 24966.41,
    "new_taxes_no_override": 26044.96,
    "override_total_1": 26783.96,
    "override_increase_1": 739.01
  },
  {
    "#": "1140 Beacon St, Unit 203 G5-6 (010-02-12)",
    "$": 3088000,
    "address": "1140 Beacon St, Unit 203 G5-6",
    "parcel_id": "010-02-12",
    "owner1": "HARRINGTON TRS, RONNIE S & JEREMY G",
    "owner2": "",
    "current_taxes": 27986.19,
    "new_taxes_no_override": 29195.19,
    "override_total_1": 30023.58,
    "override_increase_1": 828.39
  },
  {
    "#": "1140 Beacon St, Unit 204 G30&31 (010-02-13)",
    "$": 2842300,
    "address": "1140 Beacon St, Unit 204 G30&31",
    "parcel_id": "010-02-13",
    "owner1": "SURYAMEGA, TR, REUBEN",
    "owner2": "",
    "current_taxes": 29105.15,
    "new_taxes_no_override": 30362.49,
    "override_total_1": 31224.0,
    "override_increase_1": 861.51
  },
  {
    "#": "1140 Beacon St, Unit 301 & 3 G (010-02-14)",
    "$": 3173200,
    "address": "1140 Beacon St, Unit 301 & 3 G",
    "parcel_id": "010-02-14",
    "owner1": "TOVAR, TR, MONICA LYNN",
    "owner2": "",
    "current_taxes": 32493.57,
    "new_taxes_no_override": 33897.29,
    "override_total_1": 34859.1,
    "override_increase_1": 961.81
  },
  {
    "#": "1140 Beacon St, Unit 302 G25&26 (010-02-15)",
    "$": 2791100,
    "address": "1140 Beacon St, Unit 302 G25&26",
    "parcel_id": "010-02-15",
    "owner1": "COHEN TR, DEBORAH J",
    "owner2": "",
    "current_taxes": 28580.86,
    "new_taxes_no_override": 29815.55,
    "override_total_1": 30661.55,
    "override_increase_1": 845.99
  },
  {
    "#": "1140 Beacon St, Unit 303 G11&12 (010-02-16)",
    "$": 3149500,
    "address": "1140 Beacon St, Unit 303 G11&12",
    "parcel_id": "010-02-16",
    "owner1": "GLAZMAN, LEV",
    "owner2": "ROYTBERG, ALINA",
    "current_taxes": 28615.95,
    "new_taxes_no_override": 29852.16,
    "override_total_1": 30699.19,
    "override_increase_1": 847.03
  },
  {
    "#": "1140 Beacon St, Unit 304  G7-8 (010-02-17)",
    "$": 2998500,
    "address": "1140 Beacon St, Unit 304  G7-8",
    "parcel_id": "010-02-17",
    "owner1": "TANASHIAN TRS, ABRAHAM & AUDREY",
    "owner2": "",
    "current_taxes": 30704.64,
    "new_taxes_no_override": 32031.08,
    "override_total_1": 32939.94,
    "override_increase_1": 908.86
  },
  {
    "#": "1140 Beacon St, Unit 305 G28-29 (010-02-18)",
    "$": 2852600,
    "address": "1140 Beacon St, Unit 305 G28-29",
    "parcel_id": "010-02-18",
    "owner1": "OLSTEIN, MICHAEL S",
    "owner2": "",
    "current_taxes": 25575.69,
    "new_taxes_no_override": 26680.56,
    "override_total_1": 27437.6,
    "override_increase_1": 757.04
  },
  {
    "#": "1160 Beacon St, Unit 101 & 4 Pk (011-01-06)",
    "$": 3139600,
    "address": "1160 Beacon St, Unit 101 & 4 Pk",
    "parcel_id": "011-01-06",
    "owner1": "MODIGLIANI, SERGIO & SUZANNE",
    "owner2": "",
    "current_taxes": 28514.57,
    "new_taxes_no_override": 29746.4,
    "override_total_1": 30590.43,
    "override_increase_1": 844.03
  },
  {
    "#": "1160 Beacon St, Unit 102&G18&24 (011-01-07)",
    "$": 2366500,
    "address": "1160 Beacon St, Unit 102&G18&24",
    "parcel_id": "011-01-07",
    "owner1": "ROSENTHAL TR, STEVEN P",
    "owner2": "C/O NORTHERN TRUST ATTN SHARON COHEN",
    "current_taxes": 24232.96,
    "new_taxes_no_override": 25279.82,
    "override_total_1": 25997.12,
    "override_increase_1": 717.3
  },
  {
    "#": "1160 Beacon St, Unit 103 P3&12 (011-01-08)",
    "$": 1854300,
    "address": "1160 Beacon St, Unit 103 P3&12",
    "parcel_id": "011-01-08",
    "owner1": "CHINMAN, TRS, RICHARD A",
    "owner2": "",
    "current_taxes": 15353.1,
    "new_taxes_no_override": 16016.35,
    "override_total_1": 16470.81,
    "override_increase_1": 454.45
  },
  {
    "#": "1160 Beacon St, Unit 104 P7&17 (011-01-09)",
    "$": 2047200,
    "address": "1160 Beacon St, Unit 104 P7&17",
    "parcel_id": "011-01-09",
    "owner1": "LIPSETT, DEBORAH & BARRY",
    "owner2": "",
    "current_taxes": 17328.39,
    "new_taxes_no_override": 18076.98,
    "override_total_1": 18589.9,
    "override_increase_1": 512.92
  },
  {
    "#": "1160 Beacon St, Unit 201 P5-25 (011-01-10)",
    "$": 2833000,
    "address": "1160 Beacon St, Unit 201 P5-25",
    "parcel_id": "011-01-10",
    "owner1": "GROSSMAN TRS, AMY & MARY ELLEN",
    "owner2": "",
    "current_taxes": 29009.92,
    "new_taxes_no_override": 30263.15,
    "override_total_1": 31121.84,
    "override_increase_1": 858.69
  },
  {
    "#": "1160 Beacon St, Unit 202 & P15 (011-01-11)",
    "$": 2301700,
    "address": "1160 Beacon St, Unit 202 & P15",
    "parcel_id": "011-01-11",
    "owner1": "HAGOPIAN, FRANCES",
    "owner2": "MESSINA, ANTHONY",
    "current_taxes": 23569.41,
    "new_taxes_no_override": 24587.61,
    "override_total_1": 25285.26,
    "override_increase_1": 697.65
  },
  {
    "#": "1160 Beacon St, Unit 203 & P2 (011-01-12)",
    "$": 1794700,
    "address": "1160 Beacon St, Unit 203 & P2",
    "parcel_id": "011-01-12",
    "owner1": "SOKOLOFF TRS, MIRIAM K & JEFFREY B",
    "owner2": "",
    "current_taxes": 18377.73,
    "new_taxes_no_override": 19171.65,
    "override_total_1": 19715.63,
    "override_increase_1": 543.98
  },
  {
    "#": "1160 Beacon St, Unit 204 & P19 (011-01-13)",
    "$": 1947700,
    "address": "1160 Beacon St, Unit 204 & P19",
    "parcel_id": "011-01-13",
    "owner1": "ASSARAT, VICHAI & KETANA",
    "owner2": "",
    "current_taxes": 19944.45,
    "new_taxes_no_override": 20806.05,
    "override_total_1": 21396.41,
    "override_increase_1": 590.36
  },
  {
    "#": "1160 Beacon St, Unit 205 & P14 (011-01-14)",
    "$": 2592500,
    "address": "1160 Beacon St, Unit 205 & P14",
    "parcel_id": "011-01-14",
    "owner1": "HARMONY AMORY LLC",
    "owner2": "",
    "current_taxes": 26547.2,
    "new_taxes_no_override": 27694.04,
    "override_total_1": 28479.84,
    "override_increase_1": 785.8
  },
  {
    "#": "1160 Beacon St, Unit 301 P21&22 (011-01-15)",
    "$": 2847500,
    "address": "1160 Beacon St, Unit 301 P21&22",
    "parcel_id": "011-01-15",
    "owner1": "FREISHTAT TRS, HARVEY & BRENDA",
    "owner2": "",
    "current_taxes": 29158.4,
    "new_taxes_no_override": 30418.04,
    "override_total_1": 31281.13,
    "override_increase_1": 863.09
  },
  {
    "#": "1160 Beacon St, Unit 302 & P4 (011-01-16)",
    "$": 2289100,
    "address": "1160 Beacon St, Unit 302 & P4",
    "parcel_id": "011-01-16",
    "owner1": "GITTINGER, DIANE F",
    "owner2": "",
    "current_taxes": 19805.45,
    "new_taxes_no_override": 20661.05,
    "override_total_1": 21247.29,
    "override_increase_1": 586.24
  },
  {
    "#": "1160 Beacon St, Unit 303 G6&13 (011-01-17)",
    "$": 3499300,
    "address": "1160 Beacon St, Unit 303 G6&13",
    "parcel_id": "011-01-17",
    "owner1": "CAPLAN TR, BRENDA F",
    "owner2": "",
    "current_taxes": 32197.9,
    "new_taxes_no_override": 33588.85,
    "override_total_1": 34541.91,
    "override_increase_1": 953.06
  },
  {
    "#": "1160 Beacon St, Unit 304 P20&23 (011-01-18)",
    "$": 2700900,
    "address": "1160 Beacon St, Unit 304 P20&23",
    "parcel_id": "011-01-18",
    "owner1": "NEMZOFF BERMAN TR, RUTH E",
    "owner2": "",
    "current_taxes": 24022.28,
    "new_taxes_no_override": 25060.04,
    "override_total_1": 25771.1,
    "override_increase_1": 711.06
  },
  {
    "#": "1160 Beacon St, Unit Pha P10&11 (011-01-19)",
    "$": 2976600,
    "address": "1160 Beacon St, Unit Pha P10&11",
    "parcel_id": "011-01-19",
    "owner1": "BENSON TR, MARILYN W",
    "owner2": "",
    "current_taxes": 26845.45,
    "new_taxes_no_override": 28005.17,
    "override_total_1": 28799.8,
    "override_increase_1": 794.63
  },
  {
    "#": "1160 Beacon St, Unit Phb P8&9 (011-01-20)",
    "$": 3217100,
    "address": "1160 Beacon St, Unit Phb P8&9",
    "parcel_id": "011-01-20",
    "owner1": "UNGERLEIDER, JEANE",
    "owner2": "",
    "current_taxes": 29308.17,
    "new_taxes_no_override": 30574.28,
    "override_total_1": 31441.8,
    "override_increase_1": 867.52
  },
  {
    "#": "1170 Beacon St, Unit Office (011-01-05)",
    "$": 3148000,
    "address": "1170 Beacon St, Unit Office",
    "parcel_id": "011-01-05",
    "owner1": "BROOKLINE PROPERTY  MANAGEMENT, GROUP LLC TR",
    "owner2": "",
    "current_taxes": 54019.68,
    "new_taxes_no_override": 56353.33,
    "override_total_1": 57952.31,
    "override_increase_1": 1598.98
  },
  {
    "#": "1177 Beacon St (123-01-02)",
    "$": 19017700,
    "address": "1177 Beacon St",
    "parcel_id": "123-01-02",
    "owner1": "TEMPLE OHABEI SHALOM",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "1180 Beacon St, Unit 1A (042-09-03)",
    "$": 723300,
    "address": "1180 Beacon St, Unit 1A",
    "parcel_id": "042-09-03",
    "owner1": "BLOTNER, MARK",
    "owner2": "",
    "current_taxes": 12411.83,
    "new_taxes_no_override": 12948.02,
    "override_total_1": 13315.41,
    "override_increase_1": 367.39
  },
  {
    "#": "1180 Beacon St, Unit 1B (042-09-04)",
    "$": 826600,
    "address": "1180 Beacon St, Unit 1B",
    "parcel_id": "042-09-04",
    "owner1": "SANTOPIETRO, FRANK J & MARY LOU",
    "owner2": "",
    "current_taxes": 14184.46,
    "new_taxes_no_override": 14797.23,
    "override_total_1": 15217.09,
    "override_increase_1": 419.86
  },
  {
    "#": "1180 Beacon St, Unit 1C (042-09-05)",
    "$": 939300,
    "address": "1180 Beacon St, Unit 1C",
    "parcel_id": "042-09-05",
    "owner1": "BLOTNER, MARK & AMY",
    "owner2": "",
    "current_taxes": 16118.39,
    "new_taxes_no_override": 16814.7,
    "override_total_1": 17291.81,
    "override_increase_1": 477.1
  },
  {
    "#": "1180 Beacon St, Unit 1D (042-09-06)",
    "$": 350700,
    "address": "1180 Beacon St, Unit 1D",
    "parcel_id": "042-09-06",
    "owner1": "LEE, JOSEPH & SARAH GEUNHEE",
    "owner2": "",
    "current_taxes": 6018.01,
    "new_taxes_no_override": 6277.99,
    "override_total_1": 6456.12,
    "override_increase_1": 178.13
  },
  {
    "#": "1180 Beacon St, Unit 2A (042-09-07)",
    "$": 723300,
    "address": "1180 Beacon St, Unit 2A",
    "parcel_id": "042-09-07",
    "owner1": "SHAH, TR, SANDHYA",
    "owner2": "",
    "current_taxes": 12411.83,
    "new_taxes_no_override": 12948.02,
    "override_total_1": 13315.41,
    "override_increase_1": 367.39
  },
  {
    "#": "1180 Beacon St, Unit 2B (042-09-08)",
    "$": 826600,
    "address": "1180 Beacon St, Unit 2B",
    "parcel_id": "042-09-08",
    "owner1": "HJK PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 14184.46,
    "new_taxes_no_override": 14797.23,
    "override_total_1": 15217.09,
    "override_increase_1": 419.86
  },
  {
    "#": "1180 Beacon St, Unit 2C (042-09-09)",
    "$": 939300,
    "address": "1180 Beacon St, Unit 2C",
    "parcel_id": "042-09-09",
    "owner1": "MYLIGHTHOUSE LLC",
    "owner2": "",
    "current_taxes": 16118.39,
    "new_taxes_no_override": 16814.7,
    "override_total_1": 17291.81,
    "override_increase_1": 477.1
  },
  {
    "#": "1180 Beacon St, Unit 2D (042-09-10)",
    "$": 398300,
    "address": "1180 Beacon St, Unit 2D",
    "parcel_id": "042-09-10",
    "owner1": "LEE, SHIAO Y",
    "owner2": "",
    "current_taxes": 6834.83,
    "new_taxes_no_override": 7130.09,
    "override_total_1": 7332.41,
    "override_increase_1": 202.31
  },
  {
    "#": "1180 Beacon St, Unit 3A (042-09-11)",
    "$": 723300,
    "address": "1180 Beacon St, Unit 3A",
    "parcel_id": "042-09-11",
    "owner1": "WILLMODAN LLC",
    "owner2": "",
    "current_taxes": 12411.83,
    "new_taxes_no_override": 12948.02,
    "override_total_1": 13315.41,
    "override_increase_1": 367.39
  },
  {
    "#": "1180 Beacon St, Unit 3B (042-09-12)",
    "$": 826600,
    "address": "1180 Beacon St, Unit 3B",
    "parcel_id": "042-09-12",
    "owner1": "FARKAS TRS, GEORGE & CLAIRE B",
    "owner2": "",
    "current_taxes": 14184.46,
    "new_taxes_no_override": 14797.23,
    "override_total_1": 15217.09,
    "override_increase_1": 419.86
  },
  {
    "#": "1180 Beacon St, Unit 3C (042-09-13)",
    "$": 939300,
    "address": "1180 Beacon St, Unit 3C",
    "parcel_id": "042-09-13",
    "owner1": "NOOR ASSOCIATES LLC",
    "owner2": "",
    "current_taxes": 16118.39,
    "new_taxes_no_override": 16814.7,
    "override_total_1": 17291.81,
    "override_increase_1": 477.1
  },
  {
    "#": "1180 Beacon St, Unit 3D (042-09-14)",
    "$": 398300,
    "address": "1180 Beacon St, Unit 3D",
    "parcel_id": "042-09-14",
    "owner1": "FARKAS TRS, GEORGE & CLAIRE B",
    "owner2": "",
    "current_taxes": 6834.83,
    "new_taxes_no_override": 7130.09,
    "override_total_1": 7332.41,
    "override_increase_1": 202.31
  },
  {
    "#": "1180 Beacon St, Unit 4A (042-09-15)",
    "$": 723300,
    "address": "1180 Beacon St, Unit 4A",
    "parcel_id": "042-09-15",
    "owner1": "SUNRISE PROPERTY LLC",
    "owner2": "",
    "current_taxes": 12411.83,
    "new_taxes_no_override": 12948.02,
    "override_total_1": 13315.41,
    "override_increase_1": 367.39
  },
  {
    "#": "1180 Beacon St, Unit 4B (042-09-16)",
    "$": 826600,
    "address": "1180 Beacon St, Unit 4B",
    "parcel_id": "042-09-16",
    "owner1": "1180 BEACON REALTY PARTNERS LLC",
    "owner2": "",
    "current_taxes": 14184.46,
    "new_taxes_no_override": 14797.23,
    "override_total_1": 15217.09,
    "override_increase_1": 419.86
  },
  {
    "#": "1180 Beacon St, Unit 4C (042-09-17)",
    "$": 1023600,
    "address": "1180 Beacon St, Unit 4C",
    "parcel_id": "042-09-17",
    "owner1": "MORNINGWAVE PROPERTIES INC",
    "owner2": "",
    "current_taxes": 17564.98,
    "new_taxes_no_override": 18323.79,
    "override_total_1": 18843.71,
    "override_increase_1": 519.92
  },
  {
    "#": "1180 Beacon St, Unit 4D (042-09-18)",
    "$": 398300,
    "address": "1180 Beacon St, Unit 4D",
    "parcel_id": "042-09-18",
    "owner1": "SANTOPIETRO, FRANK J & MARY LOU",
    "owner2": "",
    "current_taxes": 6834.83,
    "new_taxes_no_override": 7130.09,
    "override_total_1": 7332.41,
    "override_increase_1": 202.31
  },
  {
    "#": "1180 Beacon St, Unit 5A (042-09-19)",
    "$": 723300,
    "address": "1180 Beacon St, Unit 5A",
    "parcel_id": "042-09-19",
    "owner1": "KOMER, TR, R ROGER",
    "owner2": "",
    "current_taxes": 12411.83,
    "new_taxes_no_override": 12948.02,
    "override_total_1": 13315.41,
    "override_increase_1": 367.39
  },
  {
    "#": "1180 Beacon St, Unit 5B (042-09-20)",
    "$": 826600,
    "address": "1180 Beacon St, Unit 5B",
    "parcel_id": "042-09-20",
    "owner1": "KOMER, TR, R ROGER",
    "owner2": "",
    "current_taxes": 14184.46,
    "new_taxes_no_override": 14797.23,
    "override_total_1": 15217.09,
    "override_increase_1": 419.86
  },
  {
    "#": "1180 Beacon St, Unit 5C (042-09-21)",
    "$": 939300,
    "address": "1180 Beacon St, Unit 5C",
    "parcel_id": "042-09-21",
    "owner1": "CAPLAN TRS, MICHAEL",
    "owner2": "MOLLOD, DANIEL",
    "current_taxes": 16118.39,
    "new_taxes_no_override": 16814.7,
    "override_total_1": 17291.81,
    "override_increase_1": 477.1
  },
  {
    "#": "1180 Beacon St, Unit 5D (042-09-22)",
    "$": 398300,
    "address": "1180 Beacon St, Unit 5D",
    "parcel_id": "042-09-22",
    "owner1": "MILL STREET BEACON STREET LLC",
    "owner2": "",
    "current_taxes": 6834.83,
    "new_taxes_no_override": 7130.09,
    "override_total_1": 7332.41,
    "override_increase_1": 202.31
  },
  {
    "#": "1180 Beacon St, Unit 6A (042-09-23)",
    "$": 723300,
    "address": "1180 Beacon St, Unit 6A",
    "parcel_id": "042-09-23",
    "owner1": "1180 BEACON SUITE 6A LLC",
    "owner2": "",
    "current_taxes": 12411.83,
    "new_taxes_no_override": 12948.02,
    "override_total_1": 13315.41,
    "override_increase_1": 367.39
  },
  {
    "#": "1180 Beacon St, Unit 6B (042-09-24)",
    "$": 826600,
    "address": "1180 Beacon St, Unit 6B",
    "parcel_id": "042-09-24",
    "owner1": "1180 BEACON LLC",
    "owner2": "",
    "current_taxes": 14184.46,
    "new_taxes_no_override": 14797.23,
    "override_total_1": 15217.09,
    "override_increase_1": 419.86
  },
  {
    "#": "1180 Beacon St, Unit 6C (042-09-25)",
    "$": 939300,
    "address": "1180 Beacon St, Unit 6C",
    "parcel_id": "042-09-25",
    "owner1": "HUANG, TR, BERNARD L",
    "owner2": "",
    "current_taxes": 16118.39,
    "new_taxes_no_override": 16814.7,
    "override_total_1": 17291.81,
    "override_increase_1": 477.1
  },
  {
    "#": "1180 Beacon St, Unit 6D (042-09-26)",
    "$": 398300,
    "address": "1180 Beacon St, Unit 6D",
    "parcel_id": "042-09-26",
    "owner1": "WARD REALTY TRUST",
    "owner2": "C/O BITTNER, JENNIFER",
    "current_taxes": 6834.83,
    "new_taxes_no_override": 7130.09,
    "override_total_1": 7332.41,
    "override_increase_1": 202.31
  },
  {
    "#": "1180 Beacon St, Unit 7A (042-09-27)",
    "$": 723300,
    "address": "1180 Beacon St, Unit 7A",
    "parcel_id": "042-09-27",
    "owner1": "LEE, SHIAO YU",
    "owner2": "",
    "current_taxes": 12411.83,
    "new_taxes_no_override": 12948.02,
    "override_total_1": 13315.41,
    "override_increase_1": 367.39
  },
  {
    "#": "1180 Beacon St, Unit 7B (042-09-28)",
    "$": 826600,
    "address": "1180 Beacon St, Unit 7B",
    "parcel_id": "042-09-28",
    "owner1": "YEE, SHIAO YU",
    "owner2": "",
    "current_taxes": 14184.46,
    "new_taxes_no_override": 14797.23,
    "override_total_1": 15217.09,
    "override_increase_1": 419.86
  },
  {
    "#": "1180 Beacon St, Unit 7C (042-09-29)",
    "$": 939300,
    "address": "1180 Beacon St, Unit 7C",
    "parcel_id": "042-09-29",
    "owner1": "ELYSTAN LLC",
    "owner2": "",
    "current_taxes": 16118.39,
    "new_taxes_no_override": 16814.7,
    "override_total_1": 17291.81,
    "override_increase_1": 477.1
  },
  {
    "#": "1180 Beacon St, Unit 7D (042-09-30)",
    "$": 434100,
    "address": "1180 Beacon St, Unit 7D",
    "parcel_id": "042-09-30",
    "owner1": "MORNINGWAVE PROPERTIES INC",
    "owner2": "",
    "current_taxes": 7449.16,
    "new_taxes_no_override": 7770.96,
    "override_total_1": 7991.46,
    "override_increase_1": 220.5
  },
  {
    "#": "1180 Beacon St, Unit 8A (042-09-31)",
    "$": 1444900,
    "address": "1180 Beacon St, Unit 8A",
    "parcel_id": "042-09-31",
    "owner1": "FISCHBEIN MEDICAL ASSOC PC",
    "owner2": "C/O BRUCE PASTOR",
    "current_taxes": 24794.48,
    "new_taxes_no_override": 25865.6,
    "override_total_1": 26599.52,
    "override_increase_1": 733.92
  },
  {
    "#": "1180 Beacon St, Unit 8C (042-09-32)",
    "$": 939300,
    "address": "1180 Beacon St, Unit 8C",
    "parcel_id": "042-09-32",
    "owner1": "S J DREW LLC",
    "owner2": "C/O BRUCE PASTOR",
    "current_taxes": 16118.39,
    "new_taxes_no_override": 16814.7,
    "override_total_1": 17291.81,
    "override_increase_1": 477.1
  },
  {
    "#": "1180 Beacon St, Unit 8D (042-09-33)",
    "$": 398300,
    "address": "1180 Beacon St, Unit 8D",
    "parcel_id": "042-09-33",
    "owner1": "FISCHBEIN MEDICAL ASSOC PC",
    "owner2": "C/O BRUCE PASTOR",
    "current_taxes": 6834.83,
    "new_taxes_no_override": 7130.09,
    "override_total_1": 7332.41,
    "override_increase_1": 202.31
  },
  {
    "#": "1180 Beacon St, Unit A (042-09-34)",
    "$": 926900,
    "address": "1180 Beacon St, Unit A",
    "parcel_id": "042-09-34",
    "owner1": "1180 BEACON A LLC",
    "owner2": "",
    "current_taxes": 15905.6,
    "new_taxes_no_override": 16592.72,
    "override_total_1": 17063.53,
    "override_increase_1": 470.81
  },
  {
    "#": "1180 Beacon St, Unit B (042-09-01)",
    "$": 253000,
    "address": "1180 Beacon St, Unit B",
    "parcel_id": "042-09-01",
    "owner1": "BUTTS, JEFFREY",
    "owner2": "",
    "current_taxes": 4341.48,
    "new_taxes_no_override": 4529.03,
    "override_total_1": 4657.54,
    "override_increase_1": 128.51
  },
  {
    "#": "1180 Beacon St, Unit D-S (042-09-02)",
    "$": 293000,
    "address": "1180 Beacon St, Unit D-S",
    "parcel_id": "042-09-02",
    "owner1": "NORTHEAST FAMILY REAL ESTATE LLC",
    "owner2": "",
    "current_taxes": 5027.88,
    "new_taxes_no_override": 5245.08,
    "override_total_1": 5393.91,
    "override_increase_1": 148.83
  },
  {
    "#": "1195 Beacon St, Unit 1 (124-11-01)",
    "$": 1151000,
    "address": "1195 Beacon St, Unit 1",
    "parcel_id": "124-11-01",
    "owner1": "GOLD TRS, RICHARD A & ROSALYN B",
    "owner2": "",
    "current_taxes": 19751.16,
    "new_taxes_no_override": 20604.41,
    "override_total_1": 21189.04,
    "override_increase_1": 584.63
  },
  {
    "#": "1195 Beacon St, Unit 2 (124-11-02)",
    "$": 1350500,
    "address": "1195 Beacon St, Unit 2",
    "parcel_id": "124-11-02",
    "owner1": "KERN, KENNETH L JR & KARIN M K",
    "owner2": "",
    "current_taxes": 10194.19,
    "new_taxes_no_override": 10634.58,
    "override_total_1": 10936.33,
    "override_increase_1": 301.75
  },
  {
    "#": "1195 Beacon St, Unit 3 (124-11-03)",
    "$": 1324500,
    "address": "1195 Beacon St, Unit 3",
    "parcel_id": "124-11-03",
    "owner1": "LEMESHOV, SVETLANA",
    "owner2": "KHOTINER, ALEXANDER",
    "current_taxes": 9927.95,
    "new_taxes_no_override": 10356.84,
    "override_total_1": 10650.7,
    "override_increase_1": 293.87
  },
  {
    "#": "1197 Beacon St (124-10-00)",
    "$": 2793400,
    "address": "1197 Beacon St",
    "parcel_id": "124-10-00",
    "owner1": "GREEN TRS, LISA F",
    "owner2": "ENFIELD, RICHARD S",
    "current_taxes": 28604.42,
    "new_taxes_no_override": 29840.13,
    "override_total_1": 30686.82,
    "override_increase_1": 846.69
  },
  {
    "#": "1199 Beacon St, Unit 1 & Ps1 (124-09-01)",
    "$": 1633000,
    "address": "1199 Beacon St, Unit 1 & Ps1",
    "parcel_id": "124-09-01",
    "owner1": "RSH REALTY LLC",
    "owner2": "C/O BROOKLINE DENTAL CENTER",
    "current_taxes": 28022.28,
    "new_taxes_no_override": 29232.84,
    "override_total_1": 30062.3,
    "override_increase_1": 829.46
  },
  {
    "#": "1199 Beacon St, Unit 2 & P4 (124-09-02)",
    "$": 1594800,
    "address": "1199 Beacon St, Unit 2 & P4",
    "parcel_id": "124-09-02",
    "owner1": "ERION, MARK D",
    "owner2": "ZHANG, BEI B",
    "current_taxes": 12695.82,
    "new_taxes_no_override": 13244.28,
    "override_total_1": 13620.08,
    "override_increase_1": 375.8
  },
  {
    "#": "1199 Beacon St, Unit 3 & Ps-2 (124-09-03)",
    "$": 1704700,
    "address": "1199 Beacon St, Unit 3 & Ps-2",
    "parcel_id": "124-09-03",
    "owner1": "LOUCA TRS, JOSEPH B & NANCY S",
    "owner2": "",
    "current_taxes": 17456.13,
    "new_taxes_no_override": 18210.23,
    "override_total_1": 18726.94,
    "override_increase_1": 516.7
  },
  {
    "#": "1199 Beacon St, Unit 4 & Ps-3 (124-09-04)",
    "$": 1663900,
    "address": "1199 Beacon St, Unit 4 & Ps-3",
    "parcel_id": "124-09-04",
    "owner1": "HANRAHAN, MEREDITH A",
    "owner2": "",
    "current_taxes": 13403.4,
    "new_taxes_no_override": 13982.43,
    "override_total_1": 14379.17,
    "override_increase_1": 396.74
  },
  {
    "#": "1200 Beacon St (042-11-01)",
    "$": 76800000,
    "address": "1200 Beacon St",
    "parcel_id": "042-11-01",
    "owner1": "90210 BEACON OWNER LLC",
    "owner2": "",
    "current_taxes": 1317888.0,
    "new_taxes_no_override": 1374820.76,
    "override_total_1": 1413830.25,
    "override_increase_1": 39009.48
  },
  {
    "#": "1203 Beacon St (124-08-00)",
    "$": 3868300,
    "address": "1203 Beacon St",
    "parcel_id": "124-08-00",
    "owner1": "1203 BEACON ST LLC",
    "owner2": "",
    "current_taxes": 39611.39,
    "new_taxes_no_override": 41322.6,
    "override_total_1": 42495.1,
    "override_increase_1": 1172.5
  },
  {
    "#": "1209 Beacon St (124-07-00)",
    "$": 21982900,
    "address": "1209 Beacon St",
    "parcel_id": "124-07-00",
    "owner1": "FIELD CORP",
    "owner2": "",
    "current_taxes": 225104.9,
    "new_taxes_no_override": 234829.43,
    "override_total_1": 241492.54,
    "override_increase_1": 6663.11
  },
  {
    "#": "1223 Beacon St (124-04-06)",
    "$": 28482700,
    "address": "1223 Beacon St",
    "parcel_id": "124-04-06",
    "owner1": "HAMPTON COURT REALTY LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 332966.09,
    "new_taxes_no_override": 347350.23,
    "override_total_1": 357206.02,
    "override_increase_1": 9855.8
  },
  {
    "#": "1232 Beacon St (043-09-00)",
    "$": 4665700,
    "address": "1232 Beacon St",
    "parcel_id": "043-09-00",
    "owner1": "NORA LLC",
    "owner2": "",
    "current_taxes": 47776.77,
    "new_taxes_no_override": 49840.73,
    "override_total_1": 51254.92,
    "override_increase_1": 1414.19
  },
  {
    "#": "1236 Beacon St, Unit 1 (043-10-01)",
    "$": 835700,
    "address": "1236 Beacon St, Unit 1",
    "parcel_id": "043-10-01",
    "owner1": "SARNA, JEREMY",
    "owner2": "",
    "current_taxes": 4922.63,
    "new_taxes_no_override": 5135.29,
    "override_total_1": 5281.0,
    "override_increase_1": 145.71
  },
  {
    "#": "1236 Beacon St, Unit 2 (043-10-02)",
    "$": 787000,
    "address": "1236 Beacon St, Unit 2",
    "parcel_id": "043-10-02",
    "owner1": "HENNARICHS, DUANE M & AMY",
    "owner2": "",
    "current_taxes": 8058.88,
    "new_taxes_no_override": 8407.02,
    "override_total_1": 8645.57,
    "override_increase_1": 238.54
  },
  {
    "#": "1236 Beacon St, Unit 3 (043-10-03)",
    "$": 879600,
    "address": "1236 Beacon St, Unit 3",
    "parcel_id": "043-10-03",
    "owner1": "WITT, SAMUEL BROWN",
    "owner2": "",
    "current_taxes": 9007.1,
    "new_taxes_no_override": 9396.21,
    "override_total_1": 9662.82,
    "override_increase_1": 266.61
  },
  {
    "#": "1236 Beacon St, Unit 4 (043-10-04)",
    "$": 812600,
    "address": "1236 Beacon St, Unit 4",
    "parcel_id": "043-10-04",
    "owner1": "HAENSCHEN, KATHERINE",
    "owner2": "ABUSHALL, HANY",
    "current_taxes": 4686.09,
    "new_taxes_no_override": 4888.53,
    "override_total_1": 5027.24,
    "override_increase_1": 138.71
  },
  {
    "#": "1236 Beacon St, Unit 5 (043-10-05)",
    "$": 879600,
    "address": "1236 Beacon St, Unit 5",
    "parcel_id": "043-10-05",
    "owner1": "AHMAD, KAMAL & SHARMI",
    "owner2": "",
    "current_taxes": 9007.1,
    "new_taxes_no_override": 9396.21,
    "override_total_1": 9662.82,
    "override_increase_1": 266.61
  },
  {
    "#": "1236 Beacon St, Unit 6 & Pk-G (043-10-06)",
    "$": 879600,
    "address": "1236 Beacon St, Unit 6 & Pk-G",
    "parcel_id": "043-10-06",
    "owner1": "STEIN, DEBORAH R",
    "owner2": "",
    "current_taxes": 5372.17,
    "new_taxes_no_override": 5604.25,
    "override_total_1": 5763.26,
    "override_increase_1": 159.02
  },
  {
    "#": "1240 Beacon St (043-11-00)",
    "$": 6267900,
    "address": "1240 Beacon St",
    "parcel_id": "043-11-00",
    "owner1": "1240 BEACON LLC",
    "owner2": "",
    "current_taxes": 64183.3,
    "new_taxes_no_override": 66956.02,
    "override_total_1": 68855.84,
    "override_increase_1": 1899.83
  },
  {
    "#": "1243 Beacon St, Unit 2A & G12 (160-06-01)",
    "$": 518700,
    "address": "1243 Beacon St, Unit 2A & G12",
    "parcel_id": "160-06-01",
    "owner1": "PAN, YAROSLAV",
    "owner2": "",
    "current_taxes": 5311.49,
    "new_taxes_no_override": 5540.95,
    "override_total_1": 5698.17,
    "override_increase_1": 157.22
  },
  {
    "#": "1243 Beacon St, Unit 2B & G8 (160-06-02)",
    "$": 906400,
    "address": "1243 Beacon St, Unit 2B & G8",
    "parcel_id": "160-06-02",
    "owner1": "RICHARDSON, JANNELLE E",
    "owner2": "",
    "current_taxes": 5646.6,
    "new_taxes_no_override": 5890.53,
    "override_total_1": 6057.67,
    "override_increase_1": 167.14
  },
  {
    "#": "1243 Beacon St, Unit 2C & G38 (160-06-03)",
    "$": 773600,
    "address": "1243 Beacon St, Unit 2C & G38",
    "parcel_id": "160-06-03",
    "owner1": "REN, JIA",
    "owner2": "C/O SENTRY PROPERTY MANAGEMENT CORP.",
    "current_taxes": 7921.66,
    "new_taxes_no_override": 8263.88,
    "override_total_1": 8498.36,
    "override_increase_1": 234.48
  },
  {
    "#": "1243 Beacon St, Unit 2D & G13 (160-06-04)",
    "$": 581900,
    "address": "1243 Beacon St, Unit 2D & G13",
    "parcel_id": "160-06-04",
    "owner1": "TILLINGER, MINA",
    "owner2": "WERCHOL, MARCIA",
    "current_taxes": 5958.66,
    "new_taxes_no_override": 6216.07,
    "override_total_1": 6392.45,
    "override_increase_1": 176.38
  },
  {
    "#": "1243 Beacon St, Unit 2E & G37 (160-06-05)",
    "$": 470500,
    "address": "1243 Beacon St, Unit 2E & G37",
    "parcel_id": "160-06-05",
    "owner1": "YEE, WILBERT",
    "owner2": "",
    "current_taxes": 1182.99,
    "new_taxes_no_override": 1234.1,
    "override_total_1": 1269.11,
    "override_increase_1": 35.02
  },
  {
    "#": "1243 Beacon St, Unit 3A & G9 (160-06-06)",
    "$": 891000,
    "address": "1243 Beacon St, Unit 3A & G9",
    "parcel_id": "160-06-06",
    "owner1": "KIM, JIHYE A",
    "owner2": "C/O SENTRY PROPERTY MGMT CORP",
    "current_taxes": 9123.84,
    "new_taxes_no_override": 9517.99,
    "override_total_1": 9788.06,
    "override_increase_1": 270.07
  },
  {
    "#": "1243 Beacon St, Unit 3B & G17 (160-06-07)",
    "$": 805300,
    "address": "1243 Beacon St, Unit 3B & G17",
    "parcel_id": "160-06-07",
    "owner1": "HSU, DONG",
    "owner2": "ZHENG, PING",
    "current_taxes": 8246.27,
    "new_taxes_no_override": 8602.51,
    "override_total_1": 8846.6,
    "override_increase_1": 244.09
  },
  {
    "#": "1243 Beacon St, Unit 3C & G14 (160-06-08)",
    "$": 881900,
    "address": "1243 Beacon St, Unit 3C & G14",
    "parcel_id": "160-06-08",
    "owner1": "WANG TRS, HUAJUN",
    "owner2": "LIU , XIANQI",
    "current_taxes": 9030.66,
    "new_taxes_no_override": 9420.78,
    "override_total_1": 9688.09,
    "override_increase_1": 267.31
  },
  {
    "#": "1243 Beacon St, Unit 3D & G21 (160-06-09)",
    "$": 709200,
    "address": "1243 Beacon St, Unit 3D & G21",
    "parcel_id": "160-06-09",
    "owner1": "PFIZENMAIER TRS, PAUL A & LAUREEN M",
    "owner2": "",
    "current_taxes": 3627.27,
    "new_taxes_no_override": 3783.97,
    "override_total_1": 3891.34,
    "override_increase_1": 107.37
  },
  {
    "#": "1243 Beacon St, Unit 3E & G22 (160-06-10)",
    "$": 506700,
    "address": "1243 Beacon St, Unit 3E & G22",
    "parcel_id": "160-06-10",
    "owner1": "KERMAN, TRACY L",
    "owner2": "C/O SENTRY PROP MGMT CORP",
    "current_taxes": 5188.61,
    "new_taxes_no_override": 5412.76,
    "override_total_1": 5566.34,
    "override_increase_1": 153.58
  },
  {
    "#": "1243 Beacon St, Unit 4A & G5 (160-06-11)",
    "$": 866600,
    "address": "1243 Beacon St, Unit 4A & G5",
    "parcel_id": "160-06-11",
    "owner1": "WRIGHT, TRS, HAROLD S",
    "owner2": "",
    "current_taxes": 8873.98,
    "new_taxes_no_override": 9257.34,
    "override_total_1": 9520.01,
    "override_increase_1": 262.67
  },
  {
    "#": "1243 Beacon St, Unit 4B & G26 (160-06-12)",
    "$": 820700,
    "address": "1243 Beacon St, Unit 4B & G26",
    "parcel_id": "160-06-12",
    "owner1": "ALENCAR, RAQUEL  OLIVA",
    "owner2": "",
    "current_taxes": 8403.97,
    "new_taxes_no_override": 8767.02,
    "override_total_1": 9015.78,
    "override_increase_1": 248.76
  },
  {
    "#": "1243 Beacon St, Unit 4C & G39 (160-06-13)",
    "$": 901200,
    "address": "1243 Beacon St, Unit 4C & G39",
    "parcel_id": "160-06-13",
    "owner1": "IZRAYLOVICH, DAVID",
    "owner2": "DROZNINA, IRINA",
    "current_taxes": 5593.35,
    "new_taxes_no_override": 5834.98,
    "override_total_1": 6000.55,
    "override_increase_1": 165.56
  },
  {
    "#": "1243 Beacon St, Unit 4D & G4 (160-06-14)",
    "$": 683500,
    "address": "1243 Beacon St, Unit 4D & G4",
    "parcel_id": "160-06-14",
    "owner1": "HUNG TR, ALVIN",
    "owner2": "CHEN, TZU-HSIU",
    "current_taxes": 6999.04,
    "new_taxes_no_override": 7301.4,
    "override_total_1": 7508.57,
    "override_increase_1": 207.17
  },
  {
    "#": "1243 Beacon St, Unit 4E & G15 (160-06-15)",
    "$": 511500,
    "address": "1243 Beacon St, Unit 4E & G15",
    "parcel_id": "160-06-15",
    "owner1": "TOLIN, TRS, RONALD H & BARSHA A",
    "owner2": "",
    "current_taxes": 5237.76,
    "new_taxes_no_override": 5464.03,
    "override_total_1": 5619.07,
    "override_increase_1": 155.04
  },
  {
    "#": "1243 Beacon St, Unit 5A & G1 (160-06-16)",
    "$": 724900,
    "address": "1243 Beacon St, Unit 5A & G1",
    "parcel_id": "160-06-16",
    "owner1": "VIGLIROLO HOLDINGS LLC",
    "owner2": "",
    "current_taxes": 7422.98,
    "new_taxes_no_override": 7743.65,
    "override_total_1": 7963.37,
    "override_increase_1": 219.72
  },
  {
    "#": "1243 Beacon St, Unit 5B & G35 (160-06-17)",
    "$": 812500,
    "address": "1243 Beacon St, Unit 5B & G35",
    "parcel_id": "160-06-17",
    "owner1": "SMITH, JEREMY & WENDY & JORDAN",
    "owner2": "",
    "current_taxes": 8320.0,
    "new_taxes_no_override": 8679.42,
    "override_total_1": 8925.7,
    "override_increase_1": 246.27
  },
  {
    "#": "1243 Beacon St, Unit 5C & G20 (160-06-18)",
    "$": 905800,
    "address": "1243 Beacon St, Unit 5C & G20",
    "parcel_id": "160-06-18",
    "owner1": "PARINEJAD, REZA",
    "owner2": "",
    "current_taxes": 9275.39,
    "new_taxes_no_override": 9676.09,
    "override_total_1": 9950.64,
    "override_increase_1": 274.55
  },
  {
    "#": "1243 Beacon St, Unit 5D & G36 (160-06-19)",
    "$": 717600,
    "address": "1243 Beacon St, Unit 5D & G36",
    "parcel_id": "160-06-19",
    "owner1": "GERVAIS, MAURICE & FRANCOISE & GERVAIS",
    "owner2": "",
    "current_taxes": 3713.29,
    "new_taxes_no_override": 3873.7,
    "override_total_1": 3983.62,
    "override_increase_1": 109.91
  },
  {
    "#": "1243 Beacon St, Unit 5E & G33 (160-06-20)",
    "$": 516800,
    "address": "1243 Beacon St, Unit 5E & G33",
    "parcel_id": "160-06-20",
    "owner1": "GOLDSTEIN TR, SHIRLEY R",
    "owner2": "",
    "current_taxes": 1657.1,
    "new_taxes_no_override": 1728.69,
    "override_total_1": 1777.74,
    "override_increase_1": 49.05
  },
  {
    "#": "1243 Beacon St, Unit 6A & G30 (160-06-21)",
    "$": 906400,
    "address": "1243 Beacon St, Unit 6A & G30",
    "parcel_id": "160-06-21",
    "owner1": "LAM TR, MARGARET C",
    "owner2": "",
    "current_taxes": 9281.54,
    "new_taxes_no_override": 9682.5,
    "override_total_1": 9957.24,
    "override_increase_1": 274.73
  },
  {
    "#": "1243 Beacon St, Unit 6B & G11 (160-06-22)",
    "$": 821400,
    "address": "1243 Beacon St, Unit 6B & G11",
    "parcel_id": "160-06-22",
    "owner1": "BOGDANOV, BRANKA",
    "owner2": "",
    "current_taxes": 8411.14,
    "new_taxes_no_override": 8774.5,
    "override_total_1": 9023.47,
    "override_increase_1": 248.97
  },
  {
    "#": "1243 Beacon St, Unit 6C & G24 (160-06-23)",
    "$": 889600,
    "address": "1243 Beacon St, Unit 6C & G24",
    "parcel_id": "160-06-23",
    "owner1": "VIARISIO, GUIDO & NELSSY",
    "owner2": "",
    "current_taxes": 5474.57,
    "new_taxes_no_override": 5711.07,
    "override_total_1": 5873.12,
    "override_increase_1": 162.05
  },
  {
    "#": "1243 Beacon St, Unit 6D & G2 (160-06-24)",
    "$": 691900,
    "address": "1243 Beacon St, Unit 6D & G2",
    "parcel_id": "160-06-24",
    "owner1": "HUANG, WILLIAM WEI-LIEN",
    "owner2": "",
    "current_taxes": 7085.06,
    "new_taxes_no_override": 7391.13,
    "override_total_1": 7600.85,
    "override_increase_1": 209.72
  },
  {
    "#": "1243 Beacon St, Unit 6E & G32 (160-06-25)",
    "$": 532200,
    "address": "1243 Beacon St, Unit 6E & G32",
    "parcel_id": "160-06-25",
    "owner1": "KWAN, TERRY",
    "owner2": "",
    "current_taxes": 5449.73,
    "new_taxes_no_override": 5685.16,
    "override_total_1": 5846.47,
    "override_increase_1": 161.31
  },
  {
    "#": "1243 Beacon St, Unit 7A & G7 (160-06-26)",
    "$": 896100,
    "address": "1243 Beacon St, Unit 7A & G7",
    "parcel_id": "160-06-26",
    "owner1": "S & V PROFESSIONAL MANAGEMENT LLC",
    "owner2": "",
    "current_taxes": 9176.06,
    "new_taxes_no_override": 9572.47,
    "override_total_1": 9844.08,
    "override_increase_1": 271.61
  },
  {
    "#": "1243 Beacon St, Unit 7B & G19 (160-06-27)",
    "$": 782100,
    "address": "1243 Beacon St, Unit 7B & G19",
    "parcel_id": "160-06-27",
    "owner1": "PTGB LLC",
    "owner2": "",
    "current_taxes": 8008.7,
    "new_taxes_no_override": 8354.68,
    "override_total_1": 8591.73,
    "override_increase_1": 237.06
  },
  {
    "#": "1243 Beacon St, Unit 7C & G23 (160-06-28)",
    "$": 905000,
    "address": "1243 Beacon St, Unit 7C & G23",
    "parcel_id": "160-06-28",
    "owner1": "DROGOBETSKY, YANA",
    "owner2": "",
    "current_taxes": 9267.2,
    "new_taxes_no_override": 9667.54,
    "override_total_1": 9941.85,
    "override_increase_1": 274.31
  },
  {
    "#": "1243 Beacon St, Unit 7D & G16 (160-06-29)",
    "$": 691900,
    "address": "1243 Beacon St, Unit 7D & G16",
    "parcel_id": "160-06-29",
    "owner1": "LI, PENGPENG",
    "owner2": "ZHANG, SIYU",
    "current_taxes": 7085.06,
    "new_taxes_no_override": 7391.13,
    "override_total_1": 7600.85,
    "override_increase_1": 209.72
  },
  {
    "#": "1243 Beacon St, Unit 7E & G27 (160-06-30)",
    "$": 516800,
    "address": "1243 Beacon St, Unit 7E & G27",
    "parcel_id": "160-06-30",
    "owner1": "PARPOS, ARGIRIOS & AVRA",
    "owner2": "MARTHINSEN, EFFIMIA",
    "current_taxes": 5292.03,
    "new_taxes_no_override": 5520.65,
    "override_total_1": 5677.29,
    "override_increase_1": 156.64
  },
  {
    "#": "1243 Beacon St, Unit 8A & G6 (160-06-31)",
    "$": 906400,
    "address": "1243 Beacon St, Unit 8A & G6",
    "parcel_id": "160-06-31",
    "owner1": "NAEH, EHUD",
    "owner2": "",
    "current_taxes": 9281.54,
    "new_taxes_no_override": 9682.5,
    "override_total_1": 9957.24,
    "override_increase_1": 274.73
  },
  {
    "#": "1243 Beacon St, Unit 8B & G18 (160-06-32)",
    "$": 821400,
    "address": "1243 Beacon St, Unit 8B & G18",
    "parcel_id": "160-06-32",
    "owner1": "NEGM TR, WALID Y",
    "owner2": "",
    "current_taxes": 8411.14,
    "new_taxes_no_override": 8774.5,
    "override_total_1": 9023.47,
    "override_increase_1": 248.97
  },
  {
    "#": "1243 Beacon St, Unit 8C & G31 (160-06-33)",
    "$": 889600,
    "address": "1243 Beacon St, Unit 8C & G31",
    "parcel_id": "160-06-33",
    "owner1": "1243 LLC",
    "owner2": "",
    "current_taxes": 9109.5,
    "new_taxes_no_override": 9503.03,
    "override_total_1": 9772.67,
    "override_increase_1": 269.64
  },
  {
    "#": "1243 Beacon St, Unit 8D & G3 (160-06-34)",
    "$": 691900,
    "address": "1243 Beacon St, Unit 8D & G3",
    "parcel_id": "160-06-34",
    "owner1": "VELICHANSKY, HENRIETTA",
    "owner2": "ITSKOVICH, YANA",
    "current_taxes": 3450.12,
    "new_taxes_no_override": 3599.17,
    "override_total_1": 3701.29,
    "override_increase_1": 102.12
  },
  {
    "#": "1243 Beacon St, Unit 8E & G29 (160-06-35)",
    "$": 516800,
    "address": "1243 Beacon St, Unit 8E & G29",
    "parcel_id": "160-06-35",
    "owner1": "WILCOX, JAMES C & SUSAN C",
    "owner2": "",
    "current_taxes": 5292.03,
    "new_taxes_no_override": 5520.65,
    "override_total_1": 5677.29,
    "override_increase_1": 156.64
  },
  {
    "#": "1243 Beacon St, Unit Ph A & G25 (160-06-36)",
    "$": 878900,
    "address": "1243 Beacon St, Unit Ph A & G25",
    "parcel_id": "160-06-36",
    "owner1": "LAM TRS, NORMAN Y",
    "owner2": "LAM, KIN CHUNG & CHRISTINE",
    "current_taxes": 8999.94,
    "new_taxes_no_override": 9388.74,
    "override_total_1": 9655.14,
    "override_increase_1": 266.4
  },
  {
    "#": "1243 Beacon St, Unit Ph B & G40 (160-06-37)",
    "$": 805300,
    "address": "1243 Beacon St, Unit Ph B & G40",
    "parcel_id": "160-06-37",
    "owner1": "GILBERT, ROBERT E",
    "owner2": "",
    "current_taxes": 8246.27,
    "new_taxes_no_override": 8602.51,
    "override_total_1": 8846.6,
    "override_increase_1": 244.09
  },
  {
    "#": "1243 Beacon St, Unit Ph C & G10 (160-06-38)",
    "$": 905000,
    "address": "1243 Beacon St, Unit Ph C & G10",
    "parcel_id": "160-06-38",
    "owner1": "YAAR TRS, ISRAEL & MINA",
    "owner2": "",
    "current_taxes": 9267.2,
    "new_taxes_no_override": 9667.54,
    "override_total_1": 9941.85,
    "override_increase_1": 274.31
  },
  {
    "#": "1243 Beacon St, Unit Ph D & G26 (160-06-39)",
    "$": 691900,
    "address": "1243 Beacon St, Unit Ph D & G26",
    "parcel_id": "160-06-39",
    "owner1": "MURRA, NICOLE V & CHERYL M",
    "owner2": "",
    "current_taxes": 7085.06,
    "new_taxes_no_override": 7391.13,
    "override_total_1": 7600.85,
    "override_increase_1": 209.72
  },
  {
    "#": "1243 Beacon St, Unit Ph E & G34 (160-06-40)",
    "$": 588100,
    "address": "1243 Beacon St, Unit Ph E & G34",
    "parcel_id": "160-06-40",
    "owner1": "PAPAIOANNOU ET AL, GARYFALLIA",
    "owner2": "",
    "current_taxes": 2387.21,
    "new_taxes_no_override": 2490.34,
    "override_total_1": 2561.0,
    "override_increase_1": 70.66
  },
  {
    "#": "1244 Beacon St, Unit 1 (043-12-03)",
    "$": 1227200,
    "address": "1244 Beacon St, Unit 1",
    "parcel_id": "043-12-03",
    "owner1": "GRUSH, OLGA",
    "owner2": "",
    "current_taxes": 8931.59,
    "new_taxes_no_override": 9317.43,
    "override_total_1": 9581.81,
    "override_increase_1": 264.38
  },
  {
    "#": "1244 Beacon St, Unit 2 (043-12-01)",
    "$": 1270700,
    "address": "1244 Beacon St, Unit 2",
    "parcel_id": "043-12-01",
    "owner1": "LOH TR, PHILIPPINA",
    "owner2": "",
    "current_taxes": 9377.03,
    "new_taxes_no_override": 9782.12,
    "override_total_1": 10059.68,
    "override_increase_1": 277.56
  },
  {
    "#": "1244 Beacon St, Unit 3 (043-12-02)",
    "$": 1286000,
    "address": "1244 Beacon St, Unit 3",
    "parcel_id": "043-12-02",
    "owner1": "HACKBARTH, VIKTORIA",
    "owner2": "",
    "current_taxes": 9533.71,
    "new_taxes_no_override": 9945.57,
    "override_total_1": 10227.76,
    "override_increase_1": 282.2
  },
  {
    "#": "1247 Beacon St (160-05-00)",
    "$": 7293200,
    "address": "1247 Beacon St",
    "parcel_id": "160-05-00",
    "owner1": "NORA LLC",
    "owner2": "",
    "current_taxes": 105973.31,
    "new_taxes_no_override": 110551.36,
    "override_total_1": 113688.17,
    "override_increase_1": 3136.81
  },
  {
    "#": "1248 Beacon St, Unit 1 & P1 (043-13-01)",
    "$": 1382100,
    "address": "1248 Beacon St, Unit 1 & P1",
    "parcel_id": "043-13-01",
    "owner1": "CHERNEV TRS, YORDAN STANIMIROV & ROSELYN",
    "owner2": "",
    "current_taxes": 10517.77,
    "new_taxes_no_override": 10972.14,
    "override_total_1": 11283.46,
    "override_increase_1": 311.33
  },
  {
    "#": "1248 Beacon St, Unit 2 & P2 (043-13-02)",
    "$": 1976000,
    "address": "1248 Beacon St, Unit 2 & P2",
    "parcel_id": "043-13-02",
    "owner1": "FANG, JUNJIE",
    "owner2": "WANG, ZHAO",
    "current_taxes": 20234.24,
    "new_taxes_no_override": 21108.36,
    "override_total_1": 21707.29,
    "override_increase_1": 598.93
  },
  {
    "#": "1248 Beacon St, Unit 3 & P3 (043-13-03)",
    "$": 2176400,
    "address": "1248 Beacon St, Unit 3 & P3",
    "parcel_id": "043-13-03",
    "owner1": "QUEENAN, JANE",
    "owner2": "",
    "current_taxes": 22286.34,
    "new_taxes_no_override": 23249.11,
    "override_total_1": 23908.79,
    "override_increase_1": 659.68
  },
  {
    "#": "1248 Beacon St, Unit 4 & P4 (043-13-04)",
    "$": 2350200,
    "address": "1248 Beacon St, Unit 4 & P4",
    "parcel_id": "043-13-04",
    "owner1": "LABASTIDA, CARLOS CHIAPA",
    "owner2": "PRINA, SILVIA",
    "current_taxes": 20431.11,
    "new_taxes_no_override": 21313.73,
    "override_total_1": 21918.49,
    "override_increase_1": 604.76
  },
  {
    "#": "1253 Beacon St, Unit 1Bb (160-04-01)",
    "$": 476500,
    "address": "1253 Beacon St, Unit 1Bb",
    "parcel_id": "160-04-01",
    "owner1": "MARBLE, JUSTIN & HETAL",
    "owner2": "",
    "current_taxes": 4879.36,
    "new_taxes_no_override": 5090.15,
    "override_total_1": 5234.58,
    "override_increase_1": 144.43
  },
  {
    "#": "1253 Beacon St, Unit 2Bb (160-04-02)",
    "$": 325000,
    "address": "1253 Beacon St, Unit 2Bb",
    "parcel_id": "160-04-02",
    "owner1": "LEWIS, STEPHEN PATRICK",
    "owner2": "",
    "current_taxes": 3328.0,
    "new_taxes_no_override": 3471.77,
    "override_total_1": 3570.28,
    "override_increase_1": 98.51
  },
  {
    "#": "1253 Beacon St, Unit 3Bb (160-04-03)",
    "$": 407600,
    "address": "1253 Beacon St, Unit 3Bb",
    "parcel_id": "160-04-03",
    "owner1": "SONNY, ABRAHAM",
    "owner2": "JOSEPH, LEE",
    "current_taxes": 4173.82,
    "new_taxes_no_override": 4354.13,
    "override_total_1": 4477.67,
    "override_increase_1": 123.55
  },
  {
    "#": "1253 Beacon St, Unit 4Bb (160-04-04)",
    "$": 356900,
    "address": "1253 Beacon St, Unit 4Bb",
    "parcel_id": "160-04-04",
    "owner1": "FANNING TRS, MAX",
    "owner2": "MERRILL, JACK K JR",
    "current_taxes": 365.47,
    "new_taxes_no_override": 381.26,
    "override_total_1": 392.08,
    "override_increase_1": 10.82
  },
  {
    "#": "1253 Beacon St, Unit A (160-04-29)",
    "$": 355200,
    "address": "1253 Beacon St, Unit A",
    "parcel_id": "160-04-29",
    "owner1": "CHAPIN TR, DAVID C",
    "owner2": "",
    "current_taxes": 3637.25,
    "new_taxes_no_override": 3794.38,
    "override_total_1": 3902.04,
    "override_increase_1": 107.66
  },
  {
    "#": "1253 Beacon St, Unit A-1 (160-04-05)",
    "$": 520400,
    "address": "1253 Beacon St, Unit A-1",
    "parcel_id": "160-04-05",
    "owner1": "BOUCAI TRS, GEORGETTE L",
    "owner2": "",
    "current_taxes": 5328.9,
    "new_taxes_no_override": 5559.11,
    "override_total_1": 5716.84,
    "override_increase_1": 157.74
  },
  {
    "#": "1253 Beacon St, Unit A-2 (160-04-06)",
    "$": 499400,
    "address": "1253 Beacon St, Unit A-2",
    "parcel_id": "160-04-06",
    "owner1": "CHAPIN, STEPHEN W",
    "owner2": "",
    "current_taxes": 5113.86,
    "new_taxes_no_override": 5334.78,
    "override_total_1": 5486.15,
    "override_increase_1": 151.37
  },
  {
    "#": "1253 Beacon St, Unit A-3 (160-04-07)",
    "$": 323400,
    "address": "1253 Beacon St, Unit A-3",
    "parcel_id": "160-04-07",
    "owner1": "SHARAF TR, ALAN B",
    "owner2": "",
    "current_taxes": 3311.62,
    "new_taxes_no_override": 3454.68,
    "override_total_1": 3552.71,
    "override_increase_1": 98.02
  },
  {
    "#": "1253 Beacon St, Unit A-4 (160-04-08)",
    "$": 319700,
    "address": "1253 Beacon St, Unit A-4",
    "parcel_id": "160-04-08",
    "owner1": "SHARAF TR, ALAN B",
    "owner2": "",
    "current_taxes": 3273.73,
    "new_taxes_no_override": 3415.16,
    "override_total_1": 3512.06,
    "override_increase_1": 96.9
  },
  {
    "#": "1253 Beacon St, Unit A-5 (160-04-09)",
    "$": 374800,
    "address": "1253 Beacon St, Unit A-5",
    "parcel_id": "160-04-09",
    "owner1": "CHAPIN TR, DAVID C",
    "owner2": "",
    "current_taxes": 3837.95,
    "new_taxes_no_override": 4003.75,
    "override_total_1": 4117.35,
    "override_increase_1": 113.6
  },
  {
    "#": "1253 Beacon St, Unit A-6 (160-04-10)",
    "$": 350800,
    "address": "1253 Beacon St, Unit A-6",
    "parcel_id": "160-04-10",
    "owner1": "SHARAF TR, ALAN B",
    "owner2": "",
    "current_taxes": 3592.19,
    "new_taxes_no_override": 3747.37,
    "override_total_1": 3853.7,
    "override_increase_1": 106.33
  },
  {
    "#": "1253 Beacon St, Unit A-7 (160-04-11)",
    "$": 522100,
    "address": "1253 Beacon St, Unit A-7",
    "parcel_id": "160-04-11",
    "owner1": "INBAR, NOAH & GALIT",
    "owner2": "",
    "current_taxes": 5346.3,
    "new_taxes_no_override": 5577.26,
    "override_total_1": 5735.51,
    "override_increase_1": 158.25
  },
  {
    "#": "1253 Beacon St, Unit A-8 (160-04-12)",
    "$": 274900,
    "address": "1253 Beacon St, Unit A-8",
    "parcel_id": "160-04-12",
    "owner1": "BOUCAI TRS, GEORGETTE L",
    "owner2": "",
    "current_taxes": 2814.98,
    "new_taxes_no_override": 2936.59,
    "override_total_1": 3019.91,
    "override_increase_1": 83.32
  },
  {
    "#": "1253 Beacon St, Unit B-1 (160-04-13)",
    "$": 578500,
    "address": "1253 Beacon St, Unit B-1",
    "parcel_id": "160-04-13",
    "owner1": "SHARAF TR, ALAN B",
    "owner2": "",
    "current_taxes": 5923.84,
    "new_taxes_no_override": 6179.75,
    "override_total_1": 6355.1,
    "override_increase_1": 175.35
  },
  {
    "#": "1253 Beacon St, Unit B-2 (160-04-14)",
    "$": 515700,
    "address": "1253 Beacon St, Unit B-2",
    "parcel_id": "160-04-14",
    "owner1": "BOUCAI TRS, GEORGETTE L",
    "owner2": "",
    "current_taxes": 5280.77,
    "new_taxes_no_override": 5508.9,
    "override_total_1": 5665.21,
    "override_increase_1": 156.31
  },
  {
    "#": "1253 Beacon St, Unit B-3 (160-04-15)",
    "$": 324800,
    "address": "1253 Beacon St, Unit B-3",
    "parcel_id": "160-04-15",
    "owner1": "PARK, TRS, EDWARD K-RICHARD-KENNETH",
    "owner2": "",
    "current_taxes": 3325.95,
    "new_taxes_no_override": 3469.63,
    "override_total_1": 3568.08,
    "override_increase_1": 98.45
  },
  {
    "#": "1253 Beacon St, Unit B-4 (160-04-16)",
    "$": 323500,
    "address": "1253 Beacon St, Unit B-4",
    "parcel_id": "160-04-16",
    "owner1": "BOUCAI TRS, GEORGETTE L",
    "owner2": "",
    "current_taxes": 3312.64,
    "new_taxes_no_override": 3455.75,
    "override_total_1": 3553.8,
    "override_increase_1": 98.05
  },
  {
    "#": "1253 Beacon St, Unit B-5 (160-04-17)",
    "$": 403900,
    "address": "1253 Beacon St, Unit B-5",
    "parcel_id": "160-04-17",
    "owner1": "OU, YI-CHUN",
    "owner2": "",
    "current_taxes": 4135.94,
    "new_taxes_no_override": 4314.61,
    "override_total_1": 4437.04,
    "override_increase_1": 122.42
  },
  {
    "#": "1253 Beacon St, Unit B-6 (160-04-18)",
    "$": 365900,
    "address": "1253 Beacon St, Unit B-6",
    "parcel_id": "160-04-18",
    "owner1": "SATO, SHIGERU",
    "owner2": "C/O ABLE REAL ESTATE USA INC",
    "current_taxes": 3746.82,
    "new_taxes_no_override": 3908.68,
    "override_total_1": 4019.59,
    "override_increase_1": 110.91
  },
  {
    "#": "1253 Beacon St, Unit B-7 (160-04-19)",
    "$": 388400,
    "address": "1253 Beacon St, Unit B-7",
    "parcel_id": "160-04-19",
    "owner1": "CHEUNG, KA K & HELEN L",
    "owner2": "",
    "current_taxes": 3977.22,
    "new_taxes_no_override": 4149.04,
    "override_total_1": 4266.76,
    "override_increase_1": 117.73
  },
  {
    "#": "1253 Beacon St, Unit B-8 (160-04-20)",
    "$": 375600,
    "address": "1253 Beacon St, Unit B-8",
    "parcel_id": "160-04-20",
    "owner1": "ERK REALTY TRUST",
    "owner2": "",
    "current_taxes": 3846.14,
    "new_taxes_no_override": 4012.29,
    "override_total_1": 4126.14,
    "override_increase_1": 113.85
  },
  {
    "#": "1253 Beacon St, Unit C-1 (160-04-21)",
    "$": 595900,
    "address": "1253 Beacon St, Unit C-1",
    "parcel_id": "160-04-21",
    "owner1": "HEID-IRRENO, MARIA JANETH",
    "owner2": "IRRENO, ALEXANDRA",
    "current_taxes": 2467.08,
    "new_taxes_no_override": 2573.66,
    "override_total_1": 2646.68,
    "override_increase_1": 73.03
  },
  {
    "#": "1253 Beacon St, Unit C-2 (160-04-22)",
    "$": 515700,
    "address": "1253 Beacon St, Unit C-2",
    "parcel_id": "160-04-22",
    "owner1": "CHAPIN TR, DAVID C",
    "owner2": "",
    "current_taxes": 5280.77,
    "new_taxes_no_override": 5508.9,
    "override_total_1": 5665.21,
    "override_increase_1": 156.31
  },
  {
    "#": "1253 Beacon St, Unit C-3 (160-04-23)",
    "$": 332300,
    "address": "1253 Beacon St, Unit C-3",
    "parcel_id": "160-04-23",
    "owner1": "CHANG, QING",
    "owner2": "JIANG, SHAN",
    "current_taxes": 3402.75,
    "new_taxes_no_override": 3549.75,
    "override_total_1": 3650.47,
    "override_increase_1": 100.72
  },
  {
    "#": "1253 Beacon St, Unit C-4 (160-04-24)",
    "$": 319500,
    "address": "1253 Beacon St, Unit C-4",
    "parcel_id": "160-04-24",
    "owner1": "CHAPIN TR, DAVID C",
    "owner2": "",
    "current_taxes": 3271.68,
    "new_taxes_no_override": 3413.02,
    "override_total_1": 3509.86,
    "override_increase_1": 96.84
  },
  {
    "#": "1253 Beacon St, Unit C-5 (160-04-25)",
    "$": 374800,
    "address": "1253 Beacon St, Unit C-5",
    "parcel_id": "160-04-25",
    "owner1": "ERK REALTY TRUST",
    "owner2": "",
    "current_taxes": 3837.95,
    "new_taxes_no_override": 4003.75,
    "override_total_1": 4117.35,
    "override_increase_1": 113.6
  },
  {
    "#": "1253 Beacon St, Unit C-6 (160-04-26)",
    "$": 365900,
    "address": "1253 Beacon St, Unit C-6",
    "parcel_id": "160-04-26",
    "owner1": "ERK REALTY TRUST",
    "owner2": "",
    "current_taxes": 3746.82,
    "new_taxes_no_override": 3908.68,
    "override_total_1": 4019.59,
    "override_increase_1": 110.91
  },
  {
    "#": "1253 Beacon St, Unit C-7 (160-04-27)",
    "$": 393900,
    "address": "1253 Beacon St, Unit C-7",
    "parcel_id": "160-04-27",
    "owner1": "CHANG, ALISA CHING-HSIUNG",
    "owner2": "",
    "current_taxes": 4033.54,
    "new_taxes_no_override": 4207.79,
    "override_total_1": 4327.18,
    "override_increase_1": 119.39
  },
  {
    "#": "1253 Beacon St, Unit C-8 (160-04-28)",
    "$": 404700,
    "address": "1253 Beacon St, Unit C-8",
    "parcel_id": "160-04-28",
    "owner1": "GRIFFIN TR, PAUL V JR",
    "owner2": "CHAPIN TR, DAVID C",
    "current_taxes": 4144.13,
    "new_taxes_no_override": 4323.16,
    "override_total_1": 4445.82,
    "override_increase_1": 122.67
  },
  {
    "#": "1258 Beacon St, Unit 1 (044-01-01)",
    "$": 2075900,
    "address": "1258 Beacon St, Unit 1",
    "parcel_id": "044-01-01",
    "owner1": "BROWER TRS, MICHAEL C",
    "owner2": "SCOLNIK, JULIE",
    "current_taxes": 17622.28,
    "new_taxes_no_override": 18383.56,
    "override_total_1": 18905.18,
    "override_increase_1": 521.62
  },
  {
    "#": "1258 Beacon St, Unit 2 (044-01-02)",
    "$": 1631800,
    "address": "1258 Beacon St, Unit 2",
    "parcel_id": "044-01-02",
    "owner1": "KFOURY, ASSAF J",
    "owner2": "GENDZIER-KFOURY, IRENE",
    "current_taxes": 13074.7,
    "new_taxes_no_override": 13639.53,
    "override_total_1": 14026.54,
    "override_increase_1": 387.01
  },
  {
    "#": "1258 Beacon St, Unit 3 (044-01-03)",
    "$": 2153500,
    "address": "1258 Beacon St, Unit 3",
    "parcel_id": "044-01-03",
    "owner1": "BRAUNSTEIN, ARTHUR & RENSKE",
    "owner2": "",
    "current_taxes": 18416.91,
    "new_taxes_no_override": 19212.52,
    "override_total_1": 19757.66,
    "override_increase_1": 545.14
  },
  {
    "#": "1258 Beacon St, Unit 4 (044-01-04)",
    "$": 1896600,
    "address": "1258 Beacon St, Unit 4",
    "parcel_id": "044-01-04",
    "owner1": "HAMILTON, WILLIAM G",
    "owner2": "BLOCK, DEBRA S",
    "current_taxes": 15786.25,
    "new_taxes_no_override": 16468.22,
    "override_total_1": 16935.49,
    "override_increase_1": 467.27
  },
  {
    "#": "1258 Beacon St, Unit 5 (044-01-05)",
    "$": 2153500,
    "address": "1258 Beacon St, Unit 5",
    "parcel_id": "044-01-05",
    "owner1": "STEINBERG TR, GERALD G",
    "owner2": "",
    "current_taxes": 18416.91,
    "new_taxes_no_override": 19212.52,
    "override_total_1": 19757.66,
    "override_increase_1": 545.14
  },
  {
    "#": "1258 Beacon St, Unit 6 (044-01-06)",
    "$": 1888900,
    "address": "1258 Beacon St, Unit 6",
    "parcel_id": "044-01-06",
    "owner1": "KIMIA, AMIR & TAMAR",
    "owner2": "",
    "current_taxes": 15707.4,
    "new_taxes_no_override": 16385.96,
    "override_total_1": 16850.9,
    "override_increase_1": 464.94
  },
  {
    "#": "1258 Beacon St, Unit 7 (044-01-07)",
    "$": 2172400,
    "address": "1258 Beacon St, Unit 7",
    "parcel_id": "044-01-07",
    "owner1": "BERMAN, STUART M & ILEANA",
    "owner2": "",
    "current_taxes": 22245.38,
    "new_taxes_no_override": 23206.38,
    "override_total_1": 23864.84,
    "override_increase_1": 658.46
  },
  {
    "#": "1258 Beacon St, Unit 8 (044-01-08)",
    "$": 1971100,
    "address": "1258 Beacon St, Unit 8",
    "parcel_id": "044-01-08",
    "owner1": "HOUSTON, JULIAN T",
    "owner2": "SUSAN, LEVINE",
    "current_taxes": 16549.13,
    "new_taxes_no_override": 17264.05,
    "override_total_1": 17753.91,
    "override_increase_1": 489.85
  },
  {
    "#": "1264 Beacon St, Unit 1 (044-01-09)",
    "$": 1506600,
    "address": "1264 Beacon St, Unit 1",
    "parcel_id": "044-01-09",
    "owner1": "SHAW, LISBETH",
    "owner2": "KRIGSMAN, MICHAEL",
    "current_taxes": 11792.65,
    "new_taxes_no_override": 12302.09,
    "override_total_1": 12651.15,
    "override_increase_1": 349.06
  },
  {
    "#": "1264 Beacon St, Unit 2 (044-01-10)",
    "$": 1759400,
    "address": "1264 Beacon St, Unit 2",
    "parcel_id": "044-01-10",
    "owner1": "MEYER, ROBERT & ANNE",
    "owner2": "",
    "current_taxes": 14381.32,
    "new_taxes_no_override": 15002.59,
    "override_total_1": 15428.28,
    "override_increase_1": 425.69
  },
  {
    "#": "1264 Beacon St, Unit 3 (044-01-11)",
    "$": 1550800,
    "address": "1264 Beacon St, Unit 3",
    "parcel_id": "044-01-11",
    "owner1": "KEESAN TR, LINDA C",
    "owner2": "",
    "current_taxes": 15880.19,
    "new_taxes_no_override": 16566.21,
    "override_total_1": 17036.27,
    "override_increase_1": 470.05
  },
  {
    "#": "1264 Beacon St, Unit 4 (044-01-12)",
    "$": 1689300,
    "address": "1264 Beacon St, Unit 4",
    "parcel_id": "044-01-12",
    "owner1": "1264 BEACON STREET LLC",
    "owner2": "",
    "current_taxes": 17298.43,
    "new_taxes_no_override": 18045.72,
    "override_total_1": 18557.76,
    "override_increase_1": 512.03
  },
  {
    "#": "1264 Beacon St, Unit 5 (044-01-13)",
    "$": 1762800,
    "address": "1264 Beacon St, Unit 5",
    "parcel_id": "044-01-13",
    "owner1": "WINTERS RONALDSON, EDWARD & ELIZABETH",
    "owner2": "",
    "current_taxes": 18051.07,
    "new_taxes_no_override": 18830.88,
    "override_total_1": 19365.19,
    "override_increase_1": 534.31
  },
  {
    "#": "1264 Beacon St, Unit 6 (044-01-14)",
    "$": 1898700,
    "address": "1264 Beacon St, Unit 6",
    "parcel_id": "044-01-14",
    "owner1": "RIDKER, PAUL & SUSAN",
    "owner2": "",
    "current_taxes": 19442.69,
    "new_taxes_no_override": 20282.61,
    "override_total_1": 20858.12,
    "override_increase_1": 575.5
  },
  {
    "#": "1264 Beacon St, Unit 7 (044-01-15)",
    "$": 1689300,
    "address": "1264 Beacon St, Unit 7",
    "parcel_id": "044-01-15",
    "owner1": "BROVARSKI TR, EDWARD J",
    "owner2": "BROWN, PETER R V",
    "current_taxes": 13663.5,
    "new_taxes_no_override": 14253.76,
    "override_total_1": 14658.2,
    "override_increase_1": 404.44
  },
  {
    "#": "1264 Beacon St, Unit 8 (044-01-16)",
    "$": 1731000,
    "address": "1264 Beacon St, Unit 8",
    "parcel_id": "044-01-16",
    "owner1": "ZINTL, PAUL A",
    "owner2": "FROST, ELISABETH P",
    "current_taxes": 14090.51,
    "new_taxes_no_override": 14699.22,
    "override_total_1": 15116.3,
    "override_increase_1": 417.08
  },
  {
    "#": "1265 Beacon St, Unit 1001 17&48 (160-02-36)",
    "$": 1256300,
    "address": "1265 Beacon St, Unit 1001 17&48",
    "parcel_id": "160-02-36",
    "owner1": "FANUCCI, KRISTINA",
    "owner2": "",
    "current_taxes": 12864.51,
    "new_taxes_no_override": 13420.26,
    "override_total_1": 13801.05,
    "override_increase_1": 380.79
  },
  {
    "#": "1265 Beacon St, Unit 1002 & P9 (160-02-37)",
    "$": 1143200,
    "address": "1265 Beacon St, Unit 1002 & P9",
    "parcel_id": "160-02-37",
    "owner1": "WEITER TR, JOHN J",
    "owner2": "",
    "current_taxes": 8071.43,
    "new_taxes_no_override": 8420.12,
    "override_total_1": 8659.03,
    "override_increase_1": 238.91
  },
  {
    "#": "1265 Beacon St, Unit 1003 35&54 (160-02-38)",
    "$": 1592500,
    "address": "1265 Beacon St, Unit 1003 35&54",
    "parcel_id": "160-02-38",
    "owner1": "RUBINO TRS, WINNIE & RICHARD",
    "owner2": "",
    "current_taxes": 12672.27,
    "new_taxes_no_override": 13219.71,
    "override_total_1": 13594.81,
    "override_increase_1": 375.1
  },
  {
    "#": "1265 Beacon St, Unit 1004 P3&56 (160-02-39)",
    "$": 1497500,
    "address": "1265 Beacon St, Unit 1004 P3&56",
    "parcel_id": "160-02-39",
    "owner1": "BAROUCH, EYTAN",
    "owner2": "",
    "current_taxes": 11699.47,
    "new_taxes_no_override": 12204.89,
    "override_total_1": 12551.19,
    "override_increase_1": 346.3
  },
  {
    "#": "1265 Beacon St, Unit 301 & P23 (160-02-41)",
    "$": 1087400,
    "address": "1265 Beacon St, Unit 301 & P23",
    "parcel_id": "160-02-41",
    "owner1": "RAYNOR, JANINE",
    "owner2": "",
    "current_taxes": 7500.04,
    "new_taxes_no_override": 7824.04,
    "override_total_1": 8046.04,
    "override_increase_1": 222.0
  },
  {
    "#": "1265 Beacon St, Unit 302 & P36 (160-02-01)",
    "$": 965700,
    "address": "1265 Beacon St, Unit 302 & P36",
    "parcel_id": "160-02-01",
    "owner1": "LEESER, MIRIAM E",
    "owner2": "COOPER, ROBERT C B",
    "current_taxes": 9888.77,
    "new_taxes_no_override": 10315.96,
    "override_total_1": 10608.67,
    "override_increase_1": 292.71
  },
  {
    "#": "1265 Beacon St, Unit 303 & P25 (160-02-02)",
    "$": 908400,
    "address": "1265 Beacon St, Unit 303 & P25",
    "parcel_id": "160-02-02",
    "owner1": "SUVARUCHIPORN, PAUL M & SUPINDA",
    "owner2": "",
    "current_taxes": 9302.02,
    "new_taxes_no_override": 9703.87,
    "override_total_1": 9979.21,
    "override_increase_1": 275.34
  },
  {
    "#": "1265 Beacon St, Unit 304 P18&22 (160-02-03)",
    "$": 1068400,
    "address": "1265 Beacon St, Unit 304 P18&22",
    "parcel_id": "160-02-03",
    "owner1": "RAYNOR, AMANDA",
    "owner2": "",
    "current_taxes": 7305.48,
    "new_taxes_no_override": 7621.08,
    "override_total_1": 7837.32,
    "override_increase_1": 216.24
  },
  {
    "#": "1265 Beacon St, Unit 305 & P11 (160-02-04)",
    "$": 898100,
    "address": "1265 Beacon St, Unit 305 & P11",
    "parcel_id": "160-02-04",
    "owner1": "WU TR, FUJUN",
    "owner2": "",
    "current_taxes": 9196.54,
    "new_taxes_no_override": 9593.83,
    "override_total_1": 9866.05,
    "override_increase_1": 272.22
  },
  {
    "#": "1265 Beacon St, Unit 306 & P33 (160-02-05)",
    "$": 905100,
    "address": "1265 Beacon St, Unit 306 & P33",
    "parcel_id": "160-02-05",
    "owner1": "CUMMINGS, SANDRA & RICHARD",
    "owner2": "",
    "current_taxes": 9268.22,
    "new_taxes_no_override": 9668.61,
    "override_total_1": 9942.95,
    "override_increase_1": 274.34
  },
  {
    "#": "1265 Beacon St, Unit 401 & P6 (160-02-06)",
    "$": 1085600,
    "address": "1265 Beacon St, Unit 401 & P6",
    "parcel_id": "160-02-06",
    "owner1": "NUTT-POWELL, THOMAS F",
    "owner2": "RANDALL, BONNIE",
    "current_taxes": 11116.54,
    "new_taxes_no_override": 11596.77,
    "override_total_1": 11925.82,
    "override_increase_1": 329.05
  },
  {
    "#": "1265 Beacon St, Unit 402 & P31 (160-02-07)",
    "$": 1183700,
    "address": "1265 Beacon St, Unit 402 & P31",
    "parcel_id": "160-02-07",
    "owner1": "DIAMOND, AMY & ANDREW & ELIZABETH",
    "owner2": "",
    "current_taxes": 8486.15,
    "new_taxes_no_override": 8852.75,
    "override_total_1": 9103.94,
    "override_increase_1": 251.19
  },
  {
    "#": "1265 Beacon St, Unit 403 & P42 (160-02-08)",
    "$": 901300,
    "address": "1265 Beacon St, Unit 403 & P42",
    "parcel_id": "160-02-08",
    "owner1": "ROBINSON, KEN",
    "owner2": "",
    "current_taxes": 5594.38,
    "new_taxes_no_override": 5836.06,
    "override_total_1": 6001.65,
    "override_increase_1": 165.59
  },
  {
    "#": "1265 Beacon St, Unit 404 & P29 (160-02-09)",
    "$": 995900,
    "address": "1265 Beacon St, Unit 404 & P29",
    "parcel_id": "160-02-09",
    "owner1": "LEWMANOMONT, SANGUANKIAT",
    "owner2": "",
    "current_taxes": 10198.02,
    "new_taxes_no_override": 10638.57,
    "override_total_1": 10940.44,
    "override_increase_1": 301.86
  },
  {
    "#": "1265 Beacon St, Unit 405 & P8 (160-02-10)",
    "$": 976900,
    "address": "1265 Beacon St, Unit 405 & P8",
    "parcel_id": "160-02-10",
    "owner1": "SHRAYER TRS, MAXIM D",
    "owner2": "LASSER, KAREN E",
    "current_taxes": 10003.46,
    "new_taxes_no_override": 10435.61,
    "override_total_1": 10731.71,
    "override_increase_1": 296.1
  },
  {
    "#": "1265 Beacon St, Unit 406 & P7 (160-02-11)",
    "$": 977000,
    "address": "1265 Beacon St, Unit 406 & P7",
    "parcel_id": "160-02-11",
    "owner1": "SDBA FAMILY REALTY LLC",
    "owner2": "C/O STEVEN THOMPSON",
    "current_taxes": 10004.48,
    "new_taxes_no_override": 10436.67,
    "override_total_1": 10732.81,
    "override_increase_1": 296.13
  },
  {
    "#": "1265 Beacon St, Unit 501 & P26 (160-02-12)",
    "$": 1064100,
    "address": "1265 Beacon St, Unit 501 & P26",
    "parcel_id": "160-02-12",
    "owner1": "BUGAJSKI, WLODEK & JESSICA",
    "owner2": "",
    "current_taxes": 7261.45,
    "new_taxes_no_override": 7575.14,
    "override_total_1": 7790.08,
    "override_increase_1": 214.94
  },
  {
    "#": "1265 Beacon St, Unit 502 & P52 (160-02-13)",
    "$": 1112800,
    "address": "1265 Beacon St, Unit 502 & P52",
    "parcel_id": "160-02-13",
    "owner1": "MOSKOWITZ, MICHAEL J & RACHEL",
    "owner2": "",
    "current_taxes": 7760.14,
    "new_taxes_no_override": 8095.38,
    "override_total_1": 8325.08,
    "override_increase_1": 229.7
  },
  {
    "#": "1265 Beacon St, Unit 503 & P27 (160-02-14)",
    "$": 1002900,
    "address": "1265 Beacon St, Unit 503 & P27",
    "parcel_id": "160-02-14",
    "owner1": "KAUNDINYA, VIJAYA & MURALI",
    "owner2": "",
    "current_taxes": 6634.76,
    "new_taxes_no_override": 6921.38,
    "override_total_1": 7117.77,
    "override_increase_1": 196.39
  },
  {
    "#": "1265 Beacon St, Unit 504 & P45 (160-02-15)",
    "$": 996800,
    "address": "1265 Beacon St, Unit 504 & P45",
    "parcel_id": "160-02-15",
    "owner1": "MILUTIN TR, SLAVENKA",
    "owner2": "",
    "current_taxes": 6572.3,
    "new_taxes_no_override": 6856.22,
    "override_total_1": 7050.76,
    "override_increase_1": 194.54
  },
  {
    "#": "1265 Beacon St, Unit 505 & P43 (160-02-16)",
    "$": 1030500,
    "address": "1265 Beacon St, Unit 505 & P43",
    "parcel_id": "160-02-16",
    "owner1": "KUELL, MICHAEL P",
    "owner2": "COBB, JENNIFER",
    "current_taxes": 10552.32,
    "new_taxes_no_override": 11008.18,
    "override_total_1": 11320.53,
    "override_increase_1": 312.35
  },
  {
    "#": "1265 Beacon St, Unit 506 & P32 (160-02-17)",
    "$": 1005100,
    "address": "1265 Beacon St, Unit 506 & P32",
    "parcel_id": "160-02-17",
    "owner1": "GORLOV, ELLA",
    "owner2": "",
    "current_taxes": 6657.29,
    "new_taxes_no_override": 6944.88,
    "override_total_1": 7141.94,
    "override_increase_1": 197.06
  },
  {
    "#": "1265 Beacon St, Unit 601 P2-40 (160-02-18)",
    "$": 1195100,
    "address": "1265 Beacon St, Unit 601 P2-40",
    "parcel_id": "160-02-18",
    "owner1": "GRANOVSKY TR, NANCY",
    "owner2": "",
    "current_taxes": 8602.89,
    "new_taxes_no_override": 8974.53,
    "override_total_1": 9229.18,
    "override_increase_1": 254.65
  },
  {
    "#": "1265 Beacon St, Unit 602 & P37 (160-02-19)",
    "$": 1092500,
    "address": "1265 Beacon St, Unit 602 & P37",
    "parcel_id": "160-02-19",
    "owner1": "CHENG TRS, DORIS & JOSEPH",
    "owner2": "",
    "current_taxes": 7552.27,
    "new_taxes_no_override": 7878.53,
    "override_total_1": 8102.08,
    "override_increase_1": 223.55
  },
  {
    "#": "1265 Beacon St, Unit 603 & P13 (160-02-20)",
    "$": 1002800,
    "address": "1265 Beacon St, Unit 603 & P13",
    "parcel_id": "160-02-20",
    "owner1": "KERIL, LUCILLE & ESTHER",
    "owner2": "",
    "current_taxes": 10268.67,
    "new_taxes_no_override": 10712.28,
    "override_total_1": 11016.23,
    "override_increase_1": 303.95
  },
  {
    "#": "1265 Beacon St, Unit 604 P1-16 (160-02-21)",
    "$": 1154200,
    "address": "1265 Beacon St, Unit 604 P1-16",
    "parcel_id": "160-02-21",
    "owner1": "JALLOW, FUZIEH",
    "owner2": "",
    "current_taxes": 8184.07,
    "new_taxes_no_override": 8537.62,
    "override_total_1": 8779.87,
    "override_increase_1": 242.25
  },
  {
    "#": "1265 Beacon St, Unit 605 & P38 (160-02-22)",
    "$": 1033200,
    "address": "1265 Beacon St, Unit 605 & P38",
    "parcel_id": "160-02-22",
    "owner1": "KOZEK, LAURA",
    "owner2": "PUNWANI, VIKRAM S",
    "current_taxes": 10579.97,
    "new_taxes_no_override": 11037.02,
    "override_total_1": 11350.19,
    "override_increase_1": 313.17
  },
  {
    "#": "1265 Beacon St, Unit 606 & P41 (160-02-23)",
    "$": 987400,
    "address": "1265 Beacon St, Unit 606 & P41",
    "parcel_id": "160-02-23",
    "owner1": "SOLOMON TRS, BEKA",
    "owner2": "FISHER, RICHARD A",
    "current_taxes": 10110.98,
    "new_taxes_no_override": 10547.77,
    "override_total_1": 10847.06,
    "override_increase_1": 299.29
  },
  {
    "#": "1265 Beacon St, Unit 701 & P15 (160-02-24)",
    "$": 1065100,
    "address": "1265 Beacon St, Unit 701 & P15",
    "parcel_id": "160-02-24",
    "owner1": "BACKENROTH-MAAYAN TR, REBECCA",
    "owner2": "",
    "current_taxes": 10906.62,
    "new_taxes_no_override": 11377.79,
    "override_total_1": 11700.62,
    "override_increase_1": 322.84
  },
  {
    "#": "1265 Beacon St, Unit 702 P10-50 (160-02-25)",
    "$": 1256700,
    "address": "1265 Beacon St, Unit 702 P10-50",
    "parcel_id": "160-02-25",
    "owner1": "ROBY TR, MARILYN W",
    "owner2": "",
    "current_taxes": 9233.67,
    "new_taxes_no_override": 9632.56,
    "override_total_1": 9905.88,
    "override_increase_1": 273.32
  },
  {
    "#": "1265 Beacon St, Unit 703 & 4 Pk (160-02-26)",
    "$": 1390900,
    "address": "1265 Beacon St, Unit 703 & 4 Pk",
    "parcel_id": "160-02-26",
    "owner1": "WELENSKY, TR, C FRED",
    "owner2": "",
    "current_taxes": 10607.88,
    "new_taxes_no_override": 11066.14,
    "override_total_1": 11380.13,
    "override_increase_1": 313.99
  },
  {
    "#": "1265 Beacon St, Unit 704 P30-34 (160-02-27)",
    "$": 1508600,
    "address": "1265 Beacon St, Unit 704 P30-34",
    "parcel_id": "160-02-27",
    "owner1": "TAUB TRS, DAVID J & JUDITH A",
    "owner2": "",
    "current_taxes": 11813.13,
    "new_taxes_no_override": 12323.46,
    "override_total_1": 12673.13,
    "override_increase_1": 349.67
  },
  {
    "#": "1265 Beacon St, Unit 801 & P14 P20 (160-02-28)",
    "$": 1264600,
    "address": "1265 Beacon St, Unit 801 & P14 P20",
    "parcel_id": "160-02-28",
    "owner1": "BAKOR, RUTY",
    "owner2": "",
    "current_taxes": 9314.57,
    "new_taxes_no_override": 9716.96,
    "override_total_1": 9992.67,
    "override_increase_1": 275.71
  },
  {
    "#": "1265 Beacon St, Unit 802 P5-21 (160-02-29)",
    "$": 1280600,
    "address": "1265 Beacon St, Unit 802 P5-21",
    "parcel_id": "160-02-29",
    "owner1": "TADVALKAR, GAURI",
    "owner2": "",
    "current_taxes": 9478.41,
    "new_taxes_no_override": 9887.88,
    "override_total_1": 10168.44,
    "override_increase_1": 280.56
  },
  {
    "#": "1265 Beacon St, Unit 803 & P-55 (160-02-30)",
    "$": 1416700,
    "address": "1265 Beacon St, Unit 803 & P-55",
    "parcel_id": "160-02-30",
    "owner1": "PRASAD, ALOK R",
    "owner2": "SRIVASTAVA, ANITA N",
    "current_taxes": 14507.01,
    "new_taxes_no_override": 15133.71,
    "override_total_1": 15563.12,
    "override_increase_1": 429.41
  },
  {
    "#": "1265 Beacon St, Unit 804 P47-49 (160-02-31)",
    "$": 1475900,
    "address": "1265 Beacon St, Unit 804 P47-49",
    "parcel_id": "160-02-31",
    "owner1": "PALTIEL, HARRIET J",
    "owner2": "GRINBERG, ERIC L",
    "current_taxes": 11478.28,
    "new_taxes_no_override": 11974.14,
    "override_total_1": 12313.9,
    "override_increase_1": 339.76
  },
  {
    "#": "1265 Beacon St, Unit 901 & P12 (160-02-32)",
    "$": 1246300,
    "address": "1265 Beacon St, Unit 901 & P12",
    "parcel_id": "160-02-32",
    "owner1": "STRASSFELD TRS, GAIL SARA",
    "owner2": "SACHS, GEORGE MORRISON",
    "current_taxes": 9127.18,
    "new_taxes_no_override": 9521.47,
    "override_total_1": 9791.64,
    "override_increase_1": 270.16
  },
  {
    "#": "1265 Beacon St, Unit 902 & P39 (160-02-33)",
    "$": 1133800,
    "address": "1265 Beacon St, Unit 902 & P39",
    "parcel_id": "160-02-33",
    "owner1": "LEE, TRS, ELAINE EE LENG-AILEEN AI",
    "owner2": "",
    "current_taxes": 11610.11,
    "new_taxes_no_override": 12111.67,
    "override_total_1": 12455.33,
    "override_increase_1": 343.66
  },
  {
    "#": "1265 Beacon St, Unit 903 & P28&57 (160-02-34)",
    "$": 1566300,
    "address": "1265 Beacon St, Unit 903 & P28&57",
    "parcel_id": "160-02-34",
    "owner1": "CHAPMAN, HERRICK",
    "owner2": "COHEN, LIZABETH",
    "current_taxes": 12403.98,
    "new_taxes_no_override": 12939.83,
    "override_total_1": 13306.99,
    "override_increase_1": 367.16
  },
  {
    "#": "1265 Beacon St, Unit 904 P44-46 (160-02-35)",
    "$": 1480100,
    "address": "1265 Beacon St, Unit 904 P44-46",
    "parcel_id": "160-02-35",
    "owner1": "",
    "owner2": "",
    "current_taxes": 11521.29,
    "new_taxes_no_override": 12019.01,
    "override_total_1": 12360.04,
    "override_increase_1": 341.03
  },
  {
    "#": "1270 Beacon St, Unit 1B (044-03-08)",
    "$": 933500,
    "address": "1270 Beacon St, Unit 1B",
    "parcel_id": "044-03-08",
    "owner1": "ZAPOLSKI, DEBORAH",
    "owner2": "SEREMET, SCOTT A",
    "current_taxes": 5924.11,
    "new_taxes_no_override": 6180.03,
    "override_total_1": 6355.39,
    "override_increase_1": 175.35
  },
  {
    "#": "1272 Beacon St, Unit 1 (044-03-10)",
    "$": 1567200,
    "address": "1272 Beacon St, Unit 1",
    "parcel_id": "044-03-10",
    "owner1": "GARNICK, DEBORAH W",
    "owner2": "WOOD, RICHARD J",
    "current_taxes": 12413.19,
    "new_taxes_no_override": 12949.44,
    "override_total_1": 13316.87,
    "override_increase_1": 367.43
  },
  {
    "#": "1272 Beacon St, Unit 2 (044-03-01)",
    "$": 1625600,
    "address": "1272 Beacon St, Unit 2",
    "parcel_id": "044-03-01",
    "owner1": "POURRAHIMI TRS, SHAHIN",
    "owner2": "MOSSAVAT, MINOU",
    "current_taxes": 13011.21,
    "new_taxes_no_override": 13573.29,
    "override_total_1": 13958.43,
    "override_increase_1": 385.13
  },
  {
    "#": "1272 Beacon St, Unit 2B (044-03-09)",
    "$": 945700,
    "address": "1272 Beacon St, Unit 2B",
    "parcel_id": "044-03-09",
    "owner1": "GOLDSMITH, SCOTT",
    "owner2": "",
    "current_taxes": 6049.03,
    "new_taxes_no_override": 6310.35,
    "override_total_1": 6489.4,
    "override_increase_1": 179.05
  },
  {
    "#": "1272 Beacon St, Unit 3 (044-03-02)",
    "$": 1849400,
    "address": "1272 Beacon St, Unit 3",
    "parcel_id": "044-03-02",
    "owner1": "WAGNER TR, ELIZA",
    "owner2": "REYZIN, LEONID",
    "current_taxes": 15302.92,
    "new_taxes_no_override": 15964.01,
    "override_total_1": 16416.97,
    "override_increase_1": 452.97
  },
  {
    "#": "1272 Beacon St, Unit 4 (044-03-03)",
    "$": 1636100,
    "address": "1272 Beacon St, Unit 4",
    "parcel_id": "044-03-03",
    "owner1": "BERNE, REBECCA",
    "owner2": "",
    "current_taxes": 13118.73,
    "new_taxes_no_override": 13685.46,
    "override_total_1": 14073.77,
    "override_increase_1": 388.31
  },
  {
    "#": "1272 Beacon St, Unit 5 (044-03-04)",
    "$": 1769800,
    "address": "1272 Beacon St, Unit 5",
    "parcel_id": "044-03-04",
    "owner1": "WHITE, THOMAS E III & SARA P",
    "owner2": "",
    "current_taxes": 14487.82,
    "new_taxes_no_override": 15113.69,
    "override_total_1": 15542.53,
    "override_increase_1": 428.84
  },
  {
    "#": "1272 Beacon St, Unit 6 (044-03-05)",
    "$": 1800700,
    "address": "1272 Beacon St, Unit 6",
    "parcel_id": "044-03-05",
    "owner1": "CHESROW TRS, SOPHIA",
    "owner2": "PLATT, CHARLES R",
    "current_taxes": 18439.17,
    "new_taxes_no_override": 19235.74,
    "override_total_1": 19781.54,
    "override_increase_1": 545.8
  },
  {
    "#": "1272 Beacon St, Unit 7 (044-03-06)",
    "$": 1749700,
    "address": "1272 Beacon St, Unit 7",
    "parcel_id": "044-03-06",
    "owner1": "STANISH TRS, TIMOTHY P",
    "owner2": "GLASS, CAROLYN A",
    "current_taxes": 14281.99,
    "new_taxes_no_override": 14898.97,
    "override_total_1": 15321.72,
    "override_increase_1": 422.75
  },
  {
    "#": "1272 Beacon St, Unit 8 (044-03-07)",
    "$": 1748200,
    "address": "1272 Beacon St, Unit 8",
    "parcel_id": "044-03-07",
    "owner1": "WEISS, ALAN A & JUDITH B",
    "owner2": "",
    "current_taxes": 14266.63,
    "new_taxes_no_override": 14882.95,
    "override_total_1": 15305.24,
    "override_increase_1": 422.29
  },
  {
    "#": "1278 Beacon St (044-04-00)",
    "$": 74929200,
    "address": "1278 Beacon St",
    "parcel_id": "044-04-00",
    "owner1": "PH BROOKLINE OWNER LLC",
    "owner2": "",
    "current_taxes": 855411.66,
    "new_taxes_no_override": 892365.44,
    "override_total_1": 917685.63,
    "override_increase_1": 25320.19
  },
  {
    "#": "1285 Beacon St (161-04-00)",
    "$": 19131500,
    "address": "1285 Beacon St",
    "parcel_id": "161-04-00",
    "owner1": "1285 BEACON INVESTORS LLC",
    "owner2": "",
    "current_taxes": 328296.54,
    "new_taxes_no_override": 342478.95,
    "override_total_1": 352196.53,
    "override_increase_1": 9717.58
  },
  {
    "#": "1292 Beacon St (045-02-00)",
    "$": 8710200,
    "address": "1292 Beacon St",
    "parcel_id": "045-02-00",
    "owner1": "DELLE REALTY LLC",
    "owner2": "",
    "current_taxes": 149467.03,
    "new_taxes_no_override": 155924.01,
    "override_total_1": 160348.23,
    "override_increase_1": 4424.22
  },
  {
    "#": "1295 Beacon St (161-03-01)",
    "$": 5112300,
    "address": "1295 Beacon St",
    "parcel_id": "161-03-01",
    "owner1": "UNITED STATES OF AMERICA",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "1297 Beacon St (161-03-00)",
    "$": 5262100,
    "address": "1297 Beacon St",
    "parcel_id": "161-03-00",
    "owner1": "1295-1297 BEACON ST LLC",
    "owner2": "",
    "current_taxes": 90297.64,
    "new_taxes_no_override": 94198.5,
    "override_total_1": 96871.31,
    "override_increase_1": 2672.81
  },
  {
    "#": "1299 Beacon St, Unit A (161-02-01)",
    "$": 4636100,
    "address": "1299 Beacon St, Unit A",
    "parcel_id": "161-02-01",
    "owner1": "BRIGHTON ALLSTON PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 79555.48,
    "new_taxes_no_override": 82992.28,
    "override_total_1": 85347.12,
    "override_increase_1": 2354.84
  },
  {
    "#": "1309 Beacon St (161-02-00)",
    "$": 27585300,
    "address": "1309 Beacon St",
    "parcel_id": "161-02-00",
    "owner1": "SPELLMAN ET AL TRS, K",
    "owner2": "C/O K S COMPANY TRUST",
    "current_taxes": 473363.75,
    "new_taxes_no_override": 493813.06,
    "override_total_1": 507824.63,
    "override_increase_1": 14011.57
  },
  {
    "#": "1310 Beacon St (045-03-00)",
    "$": 19797800,
    "address": "1310 Beacon St",
    "parcel_id": "045-03-00",
    "owner1": "COOLIDGE PLAZA LLC",
    "owner2": "",
    "current_taxes": 339730.25,
    "new_taxes_no_override": 354406.6,
    "override_total_1": 364462.61,
    "override_increase_1": 10056.02
  },
  {
    "#": "1319 Beacon St (161-01-00)",
    "$": 10308400,
    "address": "1319 Beacon St",
    "parcel_id": "161-01-00",
    "owner1": "HARVARD & BEACON LLC",
    "owner2": "C/O SPELLMAN VENTURES LLC KYLE SPELLMAN",
    "current_taxes": 176892.14,
    "new_taxes_no_override": 184533.88,
    "override_total_1": 189769.89,
    "override_increase_1": 5236.01
  },
  {
    "#": "1324 Beacon St (082-10-11)",
    "$": 41182700,
    "address": "1324 Beacon St",
    "parcel_id": "082-10-11",
    "owner1": "PIERCE BUILDING ASSOCIATES",
    "owner2": "",
    "current_taxes": 706695.13,
    "new_taxes_no_override": 737224.36,
    "override_total_1": 758142.54,
    "override_increase_1": 20918.18
  },
  {
    "#": "1329 Beacon St (163-01-00)",
    "$": 14130900,
    "address": "1329 Beacon St",
    "parcel_id": "163-01-00",
    "owner1": "COOLIDGE CORNER ASSOC LLC",
    "owner2": "",
    "current_taxes": 242486.24,
    "new_taxes_no_override": 252961.65,
    "override_total_1": 260139.24,
    "override_increase_1": 7177.59
  },
  {
    "#": "1341 Beacon St (163-10-00)",
    "$": 5528200,
    "address": "1341 Beacon St",
    "parcel_id": "163-10-00",
    "owner1": "S-BNK BROOKLINE LLC",
    "owner2": "C/O CHESTNUT HILL REALTY",
    "current_taxes": 94863.91,
    "new_taxes_no_override": 98962.03,
    "override_total_1": 101770.0,
    "override_increase_1": 2807.97
  },
  {
    "#": "1343 Beacon St (163-09-00)",
    "$": 2810900,
    "address": "1343 Beacon St",
    "parcel_id": "163-09-00",
    "owner1": "RAMON REALTY LLC",
    "owner2": "",
    "current_taxes": 37536.86,
    "new_taxes_no_override": 39158.45,
    "override_total_1": 40269.54,
    "override_increase_1": 1111.09
  },
  {
    "#": "1345 Beacon St, Unit A (163-08-00)",
    "$": 2709600,
    "address": "1345 Beacon St, Unit A",
    "parcel_id": "163-08-00",
    "owner1": "WEBSTER-COOLIDGE ASSOCIATES LLC",
    "owner2": "C/O SALTER & KAHN INC",
    "current_taxes": 36183.79,
    "new_taxes_no_override": 37746.93,
    "override_total_1": 38817.97,
    "override_increase_1": 1071.04
  },
  {
    "#": "1347 Beacon St (163-07-00)",
    "$": 2743500,
    "address": "1347 Beacon St",
    "parcel_id": "163-07-00",
    "owner1": "WEBSTER-COOLIDGE ASSOCIATES LLC",
    "owner2": "C/O SALTER & KAHN INC",
    "current_taxes": 32270.16,
    "new_taxes_no_override": 33664.23,
    "override_total_1": 34619.43,
    "override_increase_1": 955.2
  },
  {
    "#": "1351 Beacon St (163-06-00)",
    "$": 18551600,
    "address": "1351 Beacon St",
    "parcel_id": "163-06-00",
    "owner1": "WEBSTER-COOLIDGE ASSOCIATES LLC",
    "owner2": "C/O SALTER & KAHN INC",
    "current_taxes": 263142.63,
    "new_taxes_no_override": 274510.39,
    "override_total_1": 282299.41,
    "override_increase_1": 7789.02
  },
  {
    "#": "1356 Beacon St (082-12-00)",
    "$": 1949000,
    "address": "1356 Beacon St",
    "parcel_id": "082-12-00",
    "owner1": "BEACON 1356 LLC",
    "owner2": "C/O PATTERSON, JANET",
    "current_taxes": 33444.84,
    "new_taxes_no_override": 34889.66,
    "override_total_1": 35879.62,
    "override_increase_1": 989.97
  },
  {
    "#": "1360 Beacon St (082-13-00)",
    "$": 4892100,
    "address": "1360 Beacon St",
    "parcel_id": "082-13-00",
    "owner1": "BEACON STREET VENTURE LLC",
    "owner2": "C/O PATTERSON JANET",
    "current_taxes": 83948.44,
    "new_taxes_no_override": 87575.01,
    "override_total_1": 90059.89,
    "override_increase_1": 2484.87
  },
  {
    "#": "1366 Beacon St, Unit 203 (083-09-02)",
    "$": 402400,
    "address": "1366 Beacon St, Unit 203",
    "parcel_id": "083-09-02",
    "owner1": "LEE TR, JULIA GOON",
    "owner2": "",
    "current_taxes": 6905.18,
    "new_taxes_no_override": 7203.48,
    "override_total_1": 7407.88,
    "override_increase_1": 204.39
  },
  {
    "#": "1366 Beacon St, Unit R-1 (083-09-12)",
    "$": 2224100,
    "address": "1366 Beacon St, Unit R-1",
    "parcel_id": "083-09-12",
    "owner1": "WONG TRS, EDDIE C & CHUNG SHING",
    "owner2": "",
    "current_taxes": 38165.56,
    "new_taxes_no_override": 39814.31,
    "override_total_1": 40944.01,
    "override_increase_1": 1129.7
  },
  {
    "#": "1368 Beacon St, Unit 201 (083-09-17)",
    "$": 595700,
    "address": "1368 Beacon St, Unit 201",
    "parcel_id": "083-09-17",
    "owner1": "LEE TR, JULIA GOON",
    "owner2": "",
    "current_taxes": 10222.21,
    "new_taxes_no_override": 10663.81,
    "override_total_1": 10966.39,
    "override_increase_1": 302.58
  },
  {
    "#": "1368 Beacon St, Unit 202 (083-09-01)",
    "$": 351300,
    "address": "1368 Beacon St, Unit 202",
    "parcel_id": "083-09-01",
    "owner1": "LEE TR, JULIA GOON",
    "owner2": "",
    "current_taxes": 6028.31,
    "new_taxes_no_override": 6288.73,
    "override_total_1": 6467.17,
    "override_increase_1": 178.44
  },
  {
    "#": "1368 Beacon St, Unit 204 (083-09-03)",
    "$": 396100,
    "address": "1368 Beacon St, Unit 204",
    "parcel_id": "083-09-03",
    "owner1": "AMERICAN FORTUNE RE CORP",
    "owner2": "",
    "current_taxes": 6797.08,
    "new_taxes_no_override": 7090.71,
    "override_total_1": 7291.91,
    "override_increase_1": 201.19
  },
  {
    "#": "1368 Beacon St, Unit 205 (083-09-04)",
    "$": 204300,
    "address": "1368 Beacon St, Unit 205",
    "parcel_id": "083-09-04",
    "owner1": "BRADEREM LLC",
    "owner2": "",
    "current_taxes": 3505.79,
    "new_taxes_no_override": 3657.24,
    "override_total_1": 3761.01,
    "override_increase_1": 103.77
  },
  {
    "#": "1368 Beacon St, Unit 206 (083-09-05)",
    "$": 182300,
    "address": "1368 Beacon St, Unit 206",
    "parcel_id": "083-09-05",
    "owner1": "BRADEREM LLC",
    "owner2": "",
    "current_taxes": 3128.27,
    "new_taxes_no_override": 3263.41,
    "override_total_1": 3356.01,
    "override_increase_1": 92.6
  },
  {
    "#": "1368 Beacon St, Unit 207 (083-09-06)",
    "$": 675800,
    "address": "1368 Beacon St, Unit 207",
    "parcel_id": "083-09-06",
    "owner1": "LEE TR, JULIA GOON",
    "owner2": "",
    "current_taxes": 11596.73,
    "new_taxes_no_override": 12097.71,
    "override_total_1": 12440.97,
    "override_increase_1": 343.26
  },
  {
    "#": "1368 Beacon St, Unit 208 (083-09-07)",
    "$": 187000,
    "address": "1368 Beacon St, Unit 208",
    "parcel_id": "083-09-07",
    "owner1": "GRAZIANO TR, FRANCESCA",
    "owner2": "",
    "current_taxes": 3208.92,
    "new_taxes_no_override": 3347.55,
    "override_total_1": 3442.53,
    "override_increase_1": 94.98
  },
  {
    "#": "1368 Beacon St, Unit 209 (083-09-08)",
    "$": 375700,
    "address": "1368 Beacon St, Unit 209",
    "parcel_id": "083-09-08",
    "owner1": "DAVOUDI, HAMID",
    "owner2": "WEISHAAR, COLLEEN",
    "current_taxes": 6447.01,
    "new_taxes_no_override": 6725.52,
    "override_total_1": 6916.35,
    "override_increase_1": 190.83
  },
  {
    "#": "1368 Beacon St, Unit 210 (083-09-09)",
    "$": 365500,
    "address": "1368 Beacon St, Unit 210",
    "parcel_id": "083-09-09",
    "owner1": "MEKLIR TR, BARRY",
    "owner2": "",
    "current_taxes": 6271.98,
    "new_taxes_no_override": 6542.93,
    "override_total_1": 6728.58,
    "override_increase_1": 185.65
  },
  {
    "#": "1368 Beacon St, Unit 211 (083-09-10)",
    "$": 318300,
    "address": "1368 Beacon St, Unit 211",
    "parcel_id": "083-09-10",
    "owner1": "ALLIED CAPITAL PROPERTIES INC",
    "owner2": "",
    "current_taxes": 5462.03,
    "new_taxes_no_override": 5697.99,
    "override_total_1": 5859.67,
    "override_increase_1": 161.68
  },
  {
    "#": "1368 Beacon St, Unit 212 (083-09-11)",
    "$": 493100,
    "address": "1368 Beacon St, Unit 212",
    "parcel_id": "083-09-11",
    "owner1": "LEE TR, JULIA GOON",
    "owner2": "",
    "current_taxes": 8461.6,
    "new_taxes_no_override": 8827.14,
    "override_total_1": 9077.6,
    "override_increase_1": 250.46
  },
  {
    "#": "1370 Beacon St, Unit R-2 (083-09-13)",
    "$": 2482700,
    "address": "1370 Beacon St, Unit R-2",
    "parcel_id": "083-09-13",
    "owner1": "STOLLER TR, ROBERT S",
    "owner2": "",
    "current_taxes": 42603.13,
    "new_taxes_no_override": 44443.59,
    "override_total_1": 45704.64,
    "override_increase_1": 1261.05
  },
  {
    "#": "1371 Beacon St (164-01-00)",
    "$": 39319700,
    "address": "1371 Beacon St",
    "parcel_id": "164-01-00",
    "owner1": "BEACON PARK ASSOCIATES",
    "owner2": "C/O THE DRUKER COMPANY",
    "current_taxes": 465145.15,
    "new_taxes_no_override": 485239.42,
    "override_total_1": 499007.72,
    "override_increase_1": 13768.3
  },
  {
    "#": "1372 Beacon St, Unit R-3 (083-09-14)",
    "$": 953400,
    "address": "1372 Beacon St, Unit R-3",
    "parcel_id": "083-09-14",
    "owner1": "LAM, JOHN Q & SUSAN T",
    "owner2": "",
    "current_taxes": 16360.34,
    "new_taxes_no_override": 17067.11,
    "override_total_1": 17551.37,
    "override_increase_1": 484.27
  },
  {
    "#": "1374 Beacon St, Unit R-4A (083-09-16)",
    "$": 767300,
    "address": "1374 Beacon St, Unit R-4A",
    "parcel_id": "083-09-16",
    "owner1": "1376A BEACON STREET LLC",
    "owner2": "",
    "current_taxes": 13166.87,
    "new_taxes_no_override": 13735.68,
    "override_total_1": 14125.42,
    "override_increase_1": 389.74
  },
  {
    "#": "1375 Beacon St, Unit A (165-21-00)",
    "$": 10111800,
    "address": "1375 Beacon St, Unit A",
    "parcel_id": "165-21-00",
    "owner1": "B-PRIME REALTY LLC",
    "owner2": "",
    "current_taxes": 173518.49,
    "new_taxes_no_override": 181014.49,
    "override_total_1": 186150.64,
    "override_increase_1": 5136.15
  },
  {
    "#": "1376 Beacon St, Unit R-4B (083-09-15)",
    "$": 1549400,
    "address": "1376 Beacon St, Unit R-4B",
    "parcel_id": "083-09-15",
    "owner1": "1376A BEACON STREET LLC",
    "owner2": "",
    "current_taxes": 26587.7,
    "new_taxes_no_override": 27736.29,
    "override_total_1": 28523.28,
    "override_increase_1": 787.0
  },
  {
    "#": "1378 Beacon St, Unit A (083-10-13)",
    "$": 28959700,
    "address": "1378 Beacon St, Unit A",
    "parcel_id": "083-10-13",
    "owner1": "1378-1390 BEACON STREET LLC",
    "owner2": "",
    "current_taxes": 344606.92,
    "new_taxes_no_override": 359493.94,
    "override_total_1": 369694.3,
    "override_increase_1": 10200.36
  },
  {
    "#": "1394 Beacon St, Unit A (084-01-00)",
    "$": 3296100,
    "address": "1394 Beacon St, Unit A",
    "parcel_id": "084-01-00",
    "owner1": "1396 REDHOUSE LLC",
    "owner2": "",
    "current_taxes": 41268.46,
    "new_taxes_no_override": 43051.26,
    "override_total_1": 44272.8,
    "override_increase_1": 1221.55
  },
  {
    "#": "1397 Beacon St (165-20-22)",
    "$": 27915400,
    "address": "1397 Beacon St",
    "parcel_id": "165-20-22",
    "owner1": "REGENT APARTMENTS LLC",
    "owner2": "C/O NORDBLOM CO",
    "current_taxes": 285853.7,
    "new_taxes_no_override": 298202.58,
    "override_total_1": 306663.85,
    "override_increase_1": 8461.27
  },
  {
    "#": "1398 Beacon St, Unit 1 & P3 (084-02-01)",
    "$": 689700,
    "address": "1398 Beacon St, Unit 1 & P3",
    "parcel_id": "084-02-01",
    "owner1": "HASSAN TRS, MAXIM N",
    "owner2": "",
    "current_taxes": 11835.25,
    "new_taxes_no_override": 12346.53,
    "override_total_1": 12696.86,
    "override_increase_1": 350.32
  },
  {
    "#": "1398 Beacon St, Unit 2 & Prk 1 (084-02-02)",
    "$": 733400,
    "address": "1398 Beacon St, Unit 2 & Prk 1",
    "parcel_id": "084-02-02",
    "owner1": "KANDT, BRANDON",
    "owner2": "TSAO, ELAINE",
    "current_taxes": 7510.02,
    "new_taxes_no_override": 7834.45,
    "override_total_1": 8056.75,
    "override_increase_1": 222.3
  },
  {
    "#": "1398 Beacon St, Unit 3 (084-02-03)",
    "$": 632000,
    "address": "1398 Beacon St, Unit 3",
    "parcel_id": "084-02-03",
    "owner1": "KANDT, BRANDON",
    "owner2": "TSAO, ELAINE",
    "current_taxes": 6471.68,
    "new_taxes_no_override": 6751.26,
    "override_total_1": 6942.82,
    "override_increase_1": 191.56
  },
  {
    "#": "1398 Beacon St, Unit 4 & Prk 2 (084-02-04)",
    "$": 730100,
    "address": "1398 Beacon St, Unit 4 & Prk 2",
    "parcel_id": "084-02-04",
    "owner1": "KANDT, BRANDON",
    "owner2": "",
    "current_taxes": 7476.22,
    "new_taxes_no_override": 7799.19,
    "override_total_1": 8020.49,
    "override_increase_1": 221.3
  },
  {
    "#": "1400 Beacon St, Unit 1 (084-03-01)",
    "$": 966600,
    "address": "1400 Beacon St, Unit 1",
    "parcel_id": "084-03-01",
    "owner1": "NGUYEN TRS, BICH THI&TU QUYNH THI",
    "owner2": "NGUYEN-HO , TIFFANY BICH NGOC",
    "current_taxes": 16586.86,
    "new_taxes_no_override": 17303.41,
    "override_total_1": 17794.38,
    "override_increase_1": 490.97
  },
  {
    "#": "1400 Beacon St, Unit 2 (084-03-02)",
    "$": 704500,
    "address": "1400 Beacon St, Unit 2",
    "parcel_id": "084-03-02",
    "owner1": "MARSHALL, CHRISTOPHER & KATHLEEN",
    "owner2": "",
    "current_taxes": 3579.15,
    "new_taxes_no_override": 3733.77,
    "override_total_1": 3839.71,
    "override_increase_1": 105.94
  },
  {
    "#": "1400 Beacon St, Unit 3 & P2 (084-03-03)",
    "$": 627600,
    "address": "1400 Beacon St, Unit 3 & P2",
    "parcel_id": "084-03-03",
    "owner1": "BARBER, MARK M & MEGAN TASCA",
    "owner2": "",
    "current_taxes": 6426.62,
    "new_taxes_no_override": 6704.25,
    "override_total_1": 6894.48,
    "override_increase_1": 190.23
  },
  {
    "#": "1400 Beacon St, Unit 4 (084-03-04)",
    "$": 947300,
    "address": "1400 Beacon St, Unit 4",
    "parcel_id": "084-03-04",
    "owner1": "59 HEMENWAY STREET LLC",
    "owner2": "",
    "current_taxes": 9700.35,
    "new_taxes_no_override": 10119.41,
    "override_total_1": 10406.54,
    "override_increase_1": 287.13
  },
  {
    "#": "1402 Beacon St, Unit 1 (084-04-01)",
    "$": 856300,
    "address": "1402 Beacon St, Unit 1",
    "parcel_id": "084-04-01",
    "owner1": "REYMONDE TRS, ROME",
    "owner2": "LEVY TRS, RONGEN",
    "current_taxes": 14694.11,
    "new_taxes_no_override": 15328.9,
    "override_total_1": 15763.84,
    "override_increase_1": 434.95
  },
  {
    "#": "1402 Beacon St, Unit 2 & P6 (084-04-02)",
    "$": 736300,
    "address": "1402 Beacon St, Unit 2 & P6",
    "parcel_id": "084-04-02",
    "owner1": "1402 BEACON UNIT 2 LLC",
    "owner2": "",
    "current_taxes": 7539.71,
    "new_taxes_no_override": 7865.43,
    "override_total_1": 8088.6,
    "override_increase_1": 223.18
  },
  {
    "#": "1402 Beacon St, Unit 3 & P4 (084-04-03)",
    "$": 670500,
    "address": "1402 Beacon St, Unit 3 & P4",
    "parcel_id": "084-04-03",
    "owner1": "1402 BEACON UNIT 3 LLC",
    "owner2": "",
    "current_taxes": 6865.92,
    "new_taxes_no_override": 7162.53,
    "override_total_1": 7365.76,
    "override_increase_1": 203.23
  },
  {
    "#": "1402 Beacon St, Unit 4 (084-04-04)",
    "$": 1113300,
    "address": "1402 Beacon St, Unit 4",
    "parcel_id": "084-04-04",
    "owner1": "BIGELOW, GREGORY A & DARIA",
    "owner2": "",
    "current_taxes": 7765.26,
    "new_taxes_no_override": 8100.72,
    "override_total_1": 8330.57,
    "override_increase_1": 229.85
  },
  {
    "#": "1404 Beacon St (084-05-00)",
    "$": 6148300,
    "address": "1404 Beacon St",
    "parcel_id": "084-05-00",
    "owner1": "1404-1406 BEACON STREET LLC",
    "owner2": "",
    "current_taxes": 87439.91,
    "new_taxes_no_override": 91217.31,
    "override_total_1": 93805.54,
    "override_increase_1": 2588.22
  },
  {
    "#": "1407 Beacon St, Unit 1 (165-18-12)",
    "$": 400700,
    "address": "1407 Beacon St, Unit 1",
    "parcel_id": "165-18-12",
    "owner1": "NEUWIRTH, DONALD",
    "owner2": "VALERIO, ROSEMARY A",
    "current_taxes": 4103.17,
    "new_taxes_no_override": 4280.43,
    "override_total_1": 4401.88,
    "override_increase_1": 121.45
  },
  {
    "#": "1407 Beacon St, Unit 10 (165-18-09)",
    "$": 784500,
    "address": "1407 Beacon St, Unit 10",
    "parcel_id": "165-18-09",
    "owner1": "WONG, EDORA",
    "owner2": "WONG TRS, LEP FOO & LISA XIE",
    "current_taxes": 4398.35,
    "new_taxes_no_override": 4588.36,
    "override_total_1": 4718.55,
    "override_increase_1": 130.19
  },
  {
    "#": "1407 Beacon St, Unit 11 (165-18-10)",
    "$": 324800,
    "address": "1407 Beacon St, Unit 11",
    "parcel_id": "165-18-10",
    "owner1": "ZDJELAR, SANDA",
    "owner2": "",
    "current_taxes": 3325.95,
    "new_taxes_no_override": 3469.63,
    "override_total_1": 3568.08,
    "override_increase_1": 98.45
  },
  {
    "#": "1407 Beacon St, Unit 12 (165-18-11)",
    "$": 822200,
    "address": "1407 Beacon St, Unit 12",
    "parcel_id": "165-18-11",
    "owner1": "TSANG, YOU-KONG & LILLA C",
    "owner2": "",
    "current_taxes": 8419.33,
    "new_taxes_no_override": 8783.05,
    "override_total_1": 9032.26,
    "override_increase_1": 249.21
  },
  {
    "#": "1407 Beacon St, Unit 2 (165-18-01)",
    "$": 499600,
    "address": "1407 Beacon St, Unit 2",
    "parcel_id": "165-18-01",
    "owner1": "65 DENTON ROAD LLC",
    "owner2": "",
    "current_taxes": 5115.9,
    "new_taxes_no_override": 5336.91,
    "override_total_1": 5488.34,
    "override_increase_1": 151.43
  },
  {
    "#": "1407 Beacon St, Unit 3 (165-18-02)",
    "$": 421900,
    "address": "1407 Beacon St, Unit 3",
    "parcel_id": "165-18-02",
    "owner1": "TAKAREWSKI, JOSEPH J",
    "owner2": "SATO, CRAIG M",
    "current_taxes": 685.32,
    "new_taxes_no_override": 714.93,
    "override_total_1": 735.21,
    "override_increase_1": 20.29
  },
  {
    "#": "1407 Beacon St, Unit 4 (165-18-03)",
    "$": 641200,
    "address": "1407 Beacon St, Unit 4",
    "parcel_id": "165-18-03",
    "owner1": "WU, FRANK Y & FANG",
    "owner2": "",
    "current_taxes": 6565.89,
    "new_taxes_no_override": 6849.54,
    "override_total_1": 7043.89,
    "override_increase_1": 194.35
  },
  {
    "#": "1407 Beacon St, Unit 5 (165-18-04)",
    "$": 326500,
    "address": "1407 Beacon St, Unit 5",
    "parcel_id": "165-18-04",
    "owner1": "HOFFMAN TR, JANICE",
    "owner2": "",
    "current_taxes": 3343.36,
    "new_taxes_no_override": 3487.79,
    "override_total_1": 3586.76,
    "override_increase_1": 98.96
  },
  {
    "#": "1407 Beacon St, Unit 6 (165-18-05)",
    "$": 669300,
    "address": "1407 Beacon St, Unit 6",
    "parcel_id": "165-18-05",
    "owner1": "CHENG TRS, CYNTHIA C & THOMAS W",
    "owner2": "",
    "current_taxes": 6853.63,
    "new_taxes_no_override": 7149.71,
    "override_total_1": 7352.57,
    "override_increase_1": 202.87
  },
  {
    "#": "1407 Beacon St, Unit 7 (165-18-06)",
    "$": 673800,
    "address": "1407 Beacon St, Unit 7",
    "parcel_id": "165-18-06",
    "owner1": "FLEWELLING TR, JUDITH H",
    "owner2": "",
    "current_taxes": 3264.78,
    "new_taxes_no_override": 3405.82,
    "override_total_1": 3502.46,
    "override_increase_1": 96.64
  },
  {
    "#": "1407 Beacon St, Unit 8 (165-18-07)",
    "$": 311800,
    "address": "1407 Beacon St, Unit 8",
    "parcel_id": "165-18-07",
    "owner1": "1407 BEACON UNIT 8 LLC",
    "owner2": "",
    "current_taxes": 3192.83,
    "new_taxes_no_override": 3330.76,
    "override_total_1": 3425.27,
    "override_increase_1": 94.51
  },
  {
    "#": "1407 Beacon St, Unit 9 (165-18-08)",
    "$": 665200,
    "address": "1407 Beacon St, Unit 9",
    "parcel_id": "165-18-08",
    "owner1": "GU, XIN",
    "owner2": "",
    "current_taxes": 6811.65,
    "new_taxes_no_override": 7105.91,
    "override_total_1": 7307.54,
    "override_increase_1": 201.62
  },
  {
    "#": "1408 Beacon St, Unit 1 & P1 (084-07-01)",
    "$": 851700,
    "address": "1408 Beacon St, Unit 1 & P1",
    "parcel_id": "084-07-01",
    "owner1": "PRINCE, TENLEY & BENJAMIN J",
    "owner2": "",
    "current_taxes": 14615.17,
    "new_taxes_no_override": 15246.55,
    "override_total_1": 15679.15,
    "override_increase_1": 432.61
  },
  {
    "#": "1408 Beacon St, Unit 2 (084-07-02)",
    "$": 633100,
    "address": "1408 Beacon St, Unit 2",
    "parcel_id": "084-07-02",
    "owner1": "LINDEN BEACON, RESIDENTIAL LLC",
    "owner2": "",
    "current_taxes": 10864.0,
    "new_taxes_no_override": 11333.32,
    "override_total_1": 11654.9,
    "override_increase_1": 321.57
  },
  {
    "#": "1408 Beacon St, Unit 3 & P-2 (084-07-03)",
    "$": 731400,
    "address": "1408 Beacon St, Unit 3 & P-2",
    "parcel_id": "084-07-03",
    "owner1": "LINDLEY, CHARLES R & IAN C",
    "owner2": "",
    "current_taxes": 3854.6,
    "new_taxes_no_override": 4021.12,
    "override_total_1": 4135.21,
    "override_increase_1": 114.1
  },
  {
    "#": "1408 Beacon St, Unit 4 & P3 (084-07-04)",
    "$": 1040700,
    "address": "1408 Beacon St, Unit 4 & P3",
    "parcel_id": "084-07-04",
    "owner1": "GOROKHOV, ROMAN",
    "owner2": "",
    "current_taxes": 7021.83,
    "new_taxes_no_override": 7325.17,
    "override_total_1": 7533.02,
    "override_increase_1": 207.85
  },
  {
    "#": "1408 Beacon St, Unit B (084-07-05)",
    "$": 533700,
    "address": "1408 Beacon St, Unit B",
    "parcel_id": "084-07-05",
    "owner1": "PRINCE, TENLEY & BENJAMIN J",
    "owner2": "",
    "current_taxes": 5465.09,
    "new_taxes_no_override": 5701.18,
    "override_total_1": 5862.95,
    "override_increase_1": 161.77
  },
  {
    "#": "1410 Beacon St, Unit B (084-08-00)",
    "$": 3839600,
    "address": "1410 Beacon St, Unit B",
    "parcel_id": "084-08-00",
    "owner1": "BEACON 1410 LLC",
    "owner2": "",
    "current_taxes": 65887.54,
    "new_taxes_no_override": 68733.88,
    "override_total_1": 70684.15,
    "override_increase_1": 1950.27
  },
  {
    "#": "1411 Beacon St (165-16-17)",
    "$": 11262700,
    "address": "1411 Beacon St",
    "parcel_id": "165-16-17",
    "owner1": "MCNEIL, EO D",
    "owner2": "C/O E K E REALTY",
    "current_taxes": 193267.93,
    "new_taxes_no_override": 201617.1,
    "override_total_1": 207337.84,
    "override_increase_1": 5720.73
  },
  {
    "#": "1416 Beacon St (090-01-00)",
    "$": 3529300,
    "address": "1416 Beacon St",
    "parcel_id": "090-01-00",
    "owner1": "BEACON SUMMIT REALTY CORP",
    "owner2": "C/O RULLO, MARCELLO",
    "current_taxes": 60562.79,
    "new_taxes_no_override": 63179.1,
    "override_total_1": 64971.76,
    "override_increase_1": 1792.66
  },
  {
    "#": "1417 Beacon St (165-15-00)",
    "$": 3755500,
    "address": "1417 Beacon St",
    "parcel_id": "165-15-00",
    "owner1": "CHAN  TRS, DAVID C W  & CATHERINE T",
    "owner2": "C/O R BROWN PARTNERS",
    "current_taxes": 38456.32,
    "new_taxes_no_override": 40117.63,
    "override_total_1": 41255.94,
    "override_increase_1": 1138.31
  },
  {
    "#": "1419 Beacon St (165-14-00)",
    "$": 3379700,
    "address": "1419 Beacon St",
    "parcel_id": "165-14-00",
    "owner1": "1419 BEACON STREET DEVELOPMENT LLC",
    "owner2": "",
    "current_taxes": 57995.65,
    "new_taxes_no_override": 60501.06,
    "override_total_1": 62217.73,
    "override_increase_1": 1716.67
  },
  {
    "#": "1423 Beacon St (165-13-00)",
    "$": 1929500,
    "address": "1423 Beacon St",
    "parcel_id": "165-13-00",
    "owner1": "STOCK TR, SARA",
    "owner2": "",
    "current_taxes": 33110.22,
    "new_taxes_no_override": 34540.58,
    "override_total_1": 35520.64,
    "override_increase_1": 980.06
  },
  {
    "#": "1429 Beacon St (165-12-00)",
    "$": 5301200,
    "address": "1429 Beacon St",
    "parcel_id": "165-12-00",
    "owner1": "EDEN BEACON STREET LLC",
    "owner2": "",
    "current_taxes": 83635.47,
    "new_taxes_no_override": 87248.52,
    "override_total_1": 89724.13,
    "override_increase_1": 2475.61
  },
  {
    "#": "1430 Beacon St, Unit A (090-02-00)",
    "$": 1989100,
    "address": "1430 Beacon St, Unit A",
    "parcel_id": "090-02-00",
    "owner1": "AM PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 34132.96,
    "new_taxes_no_override": 35607.5,
    "override_total_1": 36617.84,
    "override_increase_1": 1010.34
  },
  {
    "#": "1440 Beacon St (090-03-05)",
    "$": 55241500,
    "address": "1440 Beacon St",
    "parcel_id": "090-03-05",
    "owner1": "1440 BEACON STREET APARTMENTS  LLC",
    "owner2": "C/O WINGATE CAPITAL ASSOC",
    "current_taxes": 565672.96,
    "new_taxes_no_override": 590110.03,
    "override_total_1": 606853.95,
    "override_increase_1": 16743.92
  },
  {
    "#": "1443 Beacon St (214-31-34)",
    "$": 90321900,
    "address": "1443 Beacon St",
    "parcel_id": "214-31-34",
    "owner1": "1443 BEACON LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 943605.89,
    "new_taxes_no_override": 984369.66,
    "override_total_1": 1012300.4,
    "override_increase_1": 27930.73
  },
  {
    "#": "1450 Beacon St, Unit 101 (090-06-05)",
    "$": 542300,
    "address": "1450 Beacon St, Unit 101",
    "parcel_id": "090-06-05",
    "owner1": "BARNES, THOMAS",
    "owner2": "CAGGIANO, TAYLA",
    "current_taxes": 5553.15,
    "new_taxes_no_override": 5793.05,
    "override_total_1": 5957.42,
    "override_increase_1": 164.37
  },
  {
    "#": "1450 Beacon St, Unit 102 (090-06-06)",
    "$": 494100,
    "address": "1450 Beacon St, Unit 102",
    "parcel_id": "090-06-06",
    "owner1": "HUANG, JIANHUA",
    "owner2": "YANG, LICHUN",
    "current_taxes": 5059.58,
    "new_taxes_no_override": 5278.15,
    "override_total_1": 5427.92,
    "override_increase_1": 149.76
  },
  {
    "#": "1450 Beacon St, Unit 103 (090-06-07)",
    "$": 368500,
    "address": "1450 Beacon St, Unit 103",
    "parcel_id": "090-06-07",
    "owner1": "HAMMOND, SARA M",
    "owner2": "",
    "current_taxes": 3773.44,
    "new_taxes_no_override": 3936.45,
    "override_total_1": 4048.15,
    "override_increase_1": 111.69
  },
  {
    "#": "1450 Beacon St, Unit 141 (090-06-08)",
    "$": 551500,
    "address": "1450 Beacon St, Unit 141",
    "parcel_id": "090-06-08",
    "owner1": "VALENCIA, NICOLAS ISAZA",
    "owner2": "",
    "current_taxes": 5647.36,
    "new_taxes_no_override": 5891.33,
    "override_total_1": 6058.49,
    "override_increase_1": 167.16
  },
  {
    "#": "1450 Beacon St, Unit 142 (090-06-09)",
    "$": 607900,
    "address": "1450 Beacon St, Unit 142",
    "parcel_id": "090-06-09",
    "owner1": "TTG PROPERTIES & INVESTMENTS LLC",
    "owner2": "",
    "current_taxes": 6224.9,
    "new_taxes_no_override": 6493.82,
    "override_total_1": 6678.07,
    "override_increase_1": 184.26
  },
  {
    "#": "1450 Beacon St, Unit 143 (090-06-10)",
    "$": 387000,
    "address": "1450 Beacon St, Unit 143",
    "parcel_id": "090-06-10",
    "owner1": "SU-HSIAO TRS, SHU-CHIANG SUSAN",
    "owner2": "SU, HUNG-CHANG HUBERT",
    "current_taxes": 3962.88,
    "new_taxes_no_override": 4134.08,
    "override_total_1": 4251.38,
    "override_increase_1": 117.3
  },
  {
    "#": "1450 Beacon St, Unit 201 (090-06-11)",
    "$": 676300,
    "address": "1450 Beacon St, Unit 201",
    "parcel_id": "090-06-11",
    "owner1": "SONG, XIANG",
    "owner2": "ZHANG, XIAOYU",
    "current_taxes": 3290.38,
    "new_taxes_no_override": 3432.52,
    "override_total_1": 3529.92,
    "override_increase_1": 97.4
  },
  {
    "#": "1450 Beacon St, Unit 202 (090-06-12)",
    "$": 515500,
    "address": "1450 Beacon St, Unit 202",
    "parcel_id": "090-06-12",
    "owner1": "POPAT, BANSI & RISHI",
    "owner2": "",
    "current_taxes": 5278.72,
    "new_taxes_no_override": 5506.76,
    "override_total_1": 5663.01,
    "override_increase_1": 156.25
  },
  {
    "#": "1450 Beacon St, Unit 203 (090-06-13)",
    "$": 526000,
    "address": "1450 Beacon St, Unit 203",
    "parcel_id": "090-06-13",
    "owner1": "STELLICK, SUSAN R",
    "owner2": "",
    "current_taxes": 1751.31,
    "new_taxes_no_override": 1826.97,
    "override_total_1": 1878.81,
    "override_increase_1": 51.84
  },
  {
    "#": "1450 Beacon St, Unit 204 (090-06-14)",
    "$": 459000,
    "address": "1450 Beacon St, Unit 204",
    "parcel_id": "090-06-14",
    "owner1": "PURICE, OLESEA",
    "owner2": "",
    "current_taxes": 1065.23,
    "new_taxes_no_override": 1111.25,
    "override_total_1": 1142.78,
    "override_increase_1": 31.53
  },
  {
    "#": "1450 Beacon St, Unit 241 (090-06-15)",
    "$": 535100,
    "address": "1450 Beacon St, Unit 241",
    "parcel_id": "090-06-15",
    "owner1": "SHAFER, DOUGLAS L",
    "owner2": "",
    "current_taxes": 5479.42,
    "new_taxes_no_override": 5716.13,
    "override_total_1": 5878.32,
    "override_increase_1": 162.19
  },
  {
    "#": "1450 Beacon St, Unit 242 (090-06-16)",
    "$": 623000,
    "address": "1450 Beacon St, Unit 242",
    "parcel_id": "090-06-16",
    "owner1": "HUANG, WEIXING",
    "owner2": "",
    "current_taxes": 2744.59,
    "new_taxes_no_override": 2863.16,
    "override_total_1": 2944.4,
    "override_increase_1": 81.24
  },
  {
    "#": "1450 Beacon St, Unit 243 (090-06-17)",
    "$": 574400,
    "address": "1450 Beacon St, Unit 243",
    "parcel_id": "090-06-17",
    "owner1": "ZHANG, PEI",
    "owner2": "",
    "current_taxes": 2246.92,
    "new_taxes_no_override": 2343.99,
    "override_total_1": 2410.5,
    "override_increase_1": 66.51
  },
  {
    "#": "1450 Beacon St, Unit 244 (090-06-18)",
    "$": 497100,
    "address": "1450 Beacon St, Unit 244",
    "parcel_id": "090-06-18",
    "owner1": "CARDENAS, MARIA RUIZ",
    "owner2": "GRIFFON, MAXIME",
    "current_taxes": 5090.3,
    "new_taxes_no_override": 5310.2,
    "override_total_1": 5460.87,
    "override_increase_1": 150.67
  },
  {
    "#": "1450 Beacon St, Unit 301 (090-06-19)",
    "$": 619100,
    "address": "1450 Beacon St, Unit 301",
    "parcel_id": "090-06-19",
    "owner1": "SHUGA LLC",
    "owner2": "",
    "current_taxes": 2704.65,
    "new_taxes_no_override": 2821.49,
    "override_total_1": 2901.55,
    "override_increase_1": 80.06
  },
  {
    "#": "1450 Beacon St, Unit 302 (090-06-20)",
    "$": 540000,
    "address": "1450 Beacon St, Unit 302",
    "parcel_id": "090-06-20",
    "owner1": "RANGI, ROOPA",
    "owner2": "",
    "current_taxes": 5529.6,
    "new_taxes_no_override": 5768.48,
    "override_total_1": 5932.15,
    "override_increase_1": 163.68
  },
  {
    "#": "1450 Beacon St, Unit 303 (090-06-21)",
    "$": 527800,
    "address": "1450 Beacon St, Unit 303",
    "parcel_id": "090-06-21",
    "owner1": "LUBOWSKY, DAVID & MICHELE",
    "owner2": "",
    "current_taxes": 5404.67,
    "new_taxes_no_override": 5638.15,
    "override_total_1": 5798.13,
    "override_increase_1": 159.98
  },
  {
    "#": "1450 Beacon St, Unit 304 (090-06-22)",
    "$": 457000,
    "address": "1450 Beacon St, Unit 304",
    "parcel_id": "090-06-22",
    "owner1": "WINSTON TR, NEAL A",
    "owner2": "",
    "current_taxes": 4679.68,
    "new_taxes_no_override": 4881.84,
    "override_total_1": 5020.36,
    "override_increase_1": 138.52
  },
  {
    "#": "1450 Beacon St, Unit 341 (090-06-23)",
    "$": 545000,
    "address": "1450 Beacon St, Unit 341",
    "parcel_id": "090-06-23",
    "owner1": "CHAN, EDDY & SO WAI WONG",
    "owner2": "",
    "current_taxes": 5580.8,
    "new_taxes_no_override": 5821.89,
    "override_total_1": 5987.08,
    "override_increase_1": 165.19
  },
  {
    "#": "1450 Beacon St, Unit 342 (090-06-24)",
    "$": 659900,
    "address": "1450 Beacon St, Unit 342",
    "parcel_id": "090-06-24",
    "owner1": "CHEN, LINGHAI",
    "owner2": "",
    "current_taxes": 6757.38,
    "new_taxes_no_override": 7049.3,
    "override_total_1": 7249.32,
    "override_increase_1": 200.02
  },
  {
    "#": "1450 Beacon St, Unit 343 (090-06-25)",
    "$": 574400,
    "address": "1450 Beacon St, Unit 343",
    "parcel_id": "090-06-25",
    "owner1": "SUCAKA, ZANNA",
    "owner2": "",
    "current_taxes": 2246.92,
    "new_taxes_no_override": 2343.99,
    "override_total_1": 2410.5,
    "override_increase_1": 66.51
  },
  {
    "#": "1450 Beacon St, Unit 344 (090-06-26)",
    "$": 521600,
    "address": "1450 Beacon St, Unit 344",
    "parcel_id": "090-06-26",
    "owner1": "CARREIRO, ERIN PAIGE",
    "owner2": "WHEELER CARREIRO, SHELLEY",
    "current_taxes": 1706.25,
    "new_taxes_no_override": 1779.96,
    "override_total_1": 1830.46,
    "override_increase_1": 50.51
  },
  {
    "#": "1450 Beacon St, Unit 401 (090-06-27)",
    "$": 675900,
    "address": "1450 Beacon St, Unit 401",
    "parcel_id": "090-06-27",
    "owner1": "FEOKTISTOVA, OLESIA",
    "owner2": "",
    "current_taxes": 6921.22,
    "new_taxes_no_override": 7220.22,
    "override_total_1": 7425.08,
    "override_increase_1": 204.87
  },
  {
    "#": "1450 Beacon St, Unit 402 (090-06-28)",
    "$": 540000,
    "address": "1450 Beacon St, Unit 402",
    "parcel_id": "090-06-28",
    "owner1": "MENON, RESHMA & BINDU S",
    "owner2": "",
    "current_taxes": 5529.6,
    "new_taxes_no_override": 5768.48,
    "override_total_1": 5932.15,
    "override_increase_1": 163.68
  },
  {
    "#": "1450 Beacon St, Unit 403 (090-06-29)",
    "$": 649000,
    "address": "1450 Beacon St, Unit 403",
    "parcel_id": "090-06-29",
    "owner1": "TAUBES, CHRISTOPHER & BITA",
    "owner2": "",
    "current_taxes": 6645.76,
    "new_taxes_no_override": 6932.86,
    "override_total_1": 7129.57,
    "override_increase_1": 196.71
  },
  {
    "#": "1450 Beacon St, Unit 404 (090-06-30)",
    "$": 467600,
    "address": "1450 Beacon St, Unit 404",
    "parcel_id": "090-06-30",
    "owner1": "RUSSOLILLO, JOELLE A",
    "owner2": "",
    "current_taxes": 4788.22,
    "new_taxes_no_override": 4995.07,
    "override_total_1": 5136.8,
    "override_increase_1": 141.73
  },
  {
    "#": "1450 Beacon St, Unit 441 (090-06-31)",
    "$": 535100,
    "address": "1450 Beacon St, Unit 441",
    "parcel_id": "090-06-31",
    "owner1": "DUFORT, FAY J",
    "owner2": "",
    "current_taxes": 5479.42,
    "new_taxes_no_override": 5716.13,
    "override_total_1": 5878.32,
    "override_increase_1": 162.19
  },
  {
    "#": "1450 Beacon St, Unit 442 (090-06-32)",
    "$": 659900,
    "address": "1450 Beacon St, Unit 442",
    "parcel_id": "090-06-32",
    "owner1": "QUILLEN, CARL B",
    "owner2": "",
    "current_taxes": 3122.44,
    "new_taxes_no_override": 3257.33,
    "override_total_1": 3349.75,
    "override_increase_1": 92.42
  },
  {
    "#": "1450 Beacon St, Unit 443 (090-06-33)",
    "$": 492700,
    "address": "1450 Beacon St, Unit 443",
    "parcel_id": "090-06-33",
    "owner1": "MANN, KEVIN D",
    "owner2": "",
    "current_taxes": 5045.25,
    "new_taxes_no_override": 5263.2,
    "override_total_1": 5412.54,
    "override_increase_1": 149.34
  },
  {
    "#": "1450 Beacon St, Unit 444 (090-06-34)",
    "$": 459800,
    "address": "1450 Beacon St, Unit 444",
    "parcel_id": "090-06-34",
    "owner1": "BOUDREAU, DANIEL",
    "owner2": "",
    "current_taxes": 4708.35,
    "new_taxes_no_override": 4911.75,
    "override_total_1": 5051.12,
    "override_increase_1": 139.37
  },
  {
    "#": "1450 Beacon St, Unit 501 (090-06-35)",
    "$": 690900,
    "address": "1450 Beacon St, Unit 501",
    "parcel_id": "090-06-35",
    "owner1": "WONG, ROBERT",
    "owner2": "ZHANG, PIAOXUE",
    "current_taxes": 3439.88,
    "new_taxes_no_override": 3588.48,
    "override_total_1": 3690.3,
    "override_increase_1": 101.82
  },
  {
    "#": "1450 Beacon St, Unit 502 (090-06-36)",
    "$": 545600,
    "address": "1450 Beacon St, Unit 502",
    "parcel_id": "090-06-36",
    "owner1": "LIANG, HONG YAN",
    "owner2": "",
    "current_taxes": 5586.94,
    "new_taxes_no_override": 5828.3,
    "override_total_1": 5993.67,
    "override_increase_1": 165.37
  },
  {
    "#": "1450 Beacon St, Unit 503 (090-06-37)",
    "$": 535800,
    "address": "1450 Beacon St, Unit 503",
    "parcel_id": "090-06-37",
    "owner1": "RUSAK, OLGA LIA",
    "owner2": "",
    "current_taxes": 5486.59,
    "new_taxes_no_override": 5723.61,
    "override_total_1": 5886.01,
    "override_increase_1": 162.4
  },
  {
    "#": "1450 Beacon St, Unit 504 (090-06-38)",
    "$": 484800,
    "address": "1450 Beacon St, Unit 504",
    "parcel_id": "090-06-38",
    "owner1": "POWELL, ADAM COOPER & JENNIFER LUO",
    "owner2": "",
    "current_taxes": 4964.35,
    "new_taxes_no_override": 5178.81,
    "override_total_1": 5325.75,
    "override_increase_1": 146.94
  },
  {
    "#": "1450 Beacon St, Unit 541 (090-06-39)",
    "$": 550800,
    "address": "1450 Beacon St, Unit 541",
    "parcel_id": "090-06-39",
    "owner1": "PETERSON, KAARA",
    "owner2": "",
    "current_taxes": 2005.26,
    "new_taxes_no_override": 2091.89,
    "override_total_1": 2151.24,
    "override_increase_1": 59.36
  },
  {
    "#": "1450 Beacon St, Unit 542 (090-06-40)",
    "$": 670400,
    "address": "1450 Beacon St, Unit 542",
    "parcel_id": "090-06-40",
    "owner1": "WATTS, ELIZABETH",
    "owner2": "",
    "current_taxes": 3229.96,
    "new_taxes_no_override": 3369.49,
    "override_total_1": 3465.1,
    "override_increase_1": 95.61
  },
  {
    "#": "1450 Beacon St, Unit 543 (090-06-41)",
    "$": 618600,
    "address": "1450 Beacon St, Unit 543",
    "parcel_id": "090-06-41",
    "owner1": "LUKOWSKI TRS, THOMAS W & ANNE",
    "owner2": "",
    "current_taxes": 6334.46,
    "new_taxes_no_override": 6608.11,
    "override_total_1": 6795.61,
    "override_increase_1": 187.5
  },
  {
    "#": "1450 Beacon St, Unit 544 (090-06-42)",
    "$": 535000,
    "address": "1450 Beacon St, Unit 544",
    "parcel_id": "090-06-42",
    "owner1": "GRABER, KERRI A",
    "owner2": "",
    "current_taxes": 5478.4,
    "new_taxes_no_override": 5715.07,
    "override_total_1": 5877.23,
    "override_increase_1": 162.16
  },
  {
    "#": "1450 Beacon St, Unit 601 (090-06-43)",
    "$": 690900,
    "address": "1450 Beacon St, Unit 601",
    "parcel_id": "090-06-43",
    "owner1": "YANG, LISHANG C",
    "owner2": "",
    "current_taxes": 7074.82,
    "new_taxes_no_override": 7380.45,
    "override_total_1": 7589.87,
    "override_increase_1": 209.41
  },
  {
    "#": "1450 Beacon St, Unit 602 (090-06-44)",
    "$": 565400,
    "address": "1450 Beacon St, Unit 602",
    "parcel_id": "090-06-44",
    "owner1": "JANSEN, PETER",
    "owner2": "",
    "current_taxes": 5789.7,
    "new_taxes_no_override": 6039.82,
    "override_total_1": 6211.19,
    "override_increase_1": 171.38
  },
  {
    "#": "1450 Beacon St, Unit 603 (090-06-45)",
    "$": 592400,
    "address": "1450 Beacon St, Unit 603",
    "parcel_id": "090-06-45",
    "owner1": "TAMIR, AMNON & SHARON",
    "owner2": "",
    "current_taxes": 6066.18,
    "new_taxes_no_override": 6328.24,
    "override_total_1": 6507.8,
    "override_increase_1": 179.56
  },
  {
    "#": "1450 Beacon St, Unit 604 (090-06-46)",
    "$": 492700,
    "address": "1450 Beacon St, Unit 604",
    "parcel_id": "090-06-46",
    "owner1": "SHIROMANI, MAGALY",
    "owner2": "",
    "current_taxes": 1410.31,
    "new_taxes_no_override": 1471.24,
    "override_total_1": 1512.98,
    "override_increase_1": 41.75
  },
  {
    "#": "1450 Beacon St, Unit 641 (090-06-47)",
    "$": 560100,
    "address": "1450 Beacon St, Unit 641",
    "parcel_id": "090-06-47",
    "owner1": "ZHANG, QI",
    "owner2": "",
    "current_taxes": 2100.49,
    "new_taxes_no_override": 2191.23,
    "override_total_1": 2253.41,
    "override_increase_1": 62.17
  },
  {
    "#": "1450 Beacon St, Unit 642 (090-06-48)",
    "$": 675700,
    "address": "1450 Beacon St, Unit 642",
    "parcel_id": "090-06-48",
    "owner1": "DRISCOLL, KEVIN F",
    "owner2": "KARSTEN, VERENA",
    "current_taxes": 6919.17,
    "new_taxes_no_override": 7218.08,
    "override_total_1": 7422.89,
    "override_increase_1": 204.81
  },
  {
    "#": "1450 Beacon St, Unit 643 (090-06-49)",
    "$": 634400,
    "address": "1450 Beacon St, Unit 643",
    "parcel_id": "090-06-49",
    "owner1": "CHAN, LEE ANN",
    "owner2": "",
    "current_taxes": 6496.26,
    "new_taxes_no_override": 6776.9,
    "override_total_1": 6969.19,
    "override_increase_1": 192.29
  },
  {
    "#": "1450 Beacon St, Unit 644 (090-06-50)",
    "$": 535000,
    "address": "1450 Beacon St, Unit 644",
    "parcel_id": "090-06-50",
    "owner1": "ROZOVSKY TRS, WALTER A & LYDIA & IRINA A",
    "owner2": "",
    "current_taxes": 5478.4,
    "new_taxes_no_override": 5715.07,
    "override_total_1": 5877.23,
    "override_increase_1": 162.16
  },
  {
    "#": "1450 Beacon St, Unit 701 (090-06-51)",
    "$": 689000,
    "address": "1450 Beacon St, Unit 701",
    "parcel_id": "090-06-51",
    "owner1": "FULLER, SARAH HOPE",
    "owner2": "CUPPONE, DAMIANO",
    "current_taxes": 3420.43,
    "new_taxes_no_override": 3568.19,
    "override_total_1": 3669.44,
    "override_increase_1": 101.24
  },
  {
    "#": "1450 Beacon St, Unit 702 (090-06-52)",
    "$": 570600,
    "address": "1450 Beacon St, Unit 702",
    "parcel_id": "090-06-52",
    "owner1": "MO, XI & ERZHAN",
    "owner2": "ZHENG, YUE",
    "current_taxes": 5842.94,
    "new_taxes_no_override": 6095.36,
    "override_total_1": 6268.31,
    "override_increase_1": 172.95
  },
  {
    "#": "1450 Beacon St, Unit 703 (090-06-53)",
    "$": 581900,
    "address": "1450 Beacon St, Unit 703",
    "parcel_id": "090-06-53",
    "owner1": "MICHALS, EVAN H & EMILY R",
    "owner2": "",
    "current_taxes": 5958.66,
    "new_taxes_no_override": 6216.07,
    "override_total_1": 6392.45,
    "override_increase_1": 176.38
  },
  {
    "#": "1450 Beacon St, Unit 704 (090-06-54)",
    "$": 482100,
    "address": "1450 Beacon St, Unit 704",
    "parcel_id": "090-06-54",
    "owner1": "BARRETT TR, SHANNON K",
    "owner2": "",
    "current_taxes": 1301.77,
    "new_taxes_no_override": 1358.01,
    "override_total_1": 1396.54,
    "override_increase_1": 38.53
  },
  {
    "#": "1450 Beacon St, Unit 741 (090-06-55)",
    "$": 586500,
    "address": "1450 Beacon St, Unit 741",
    "parcel_id": "090-06-55",
    "owner1": "CHAUDHURY, NEEL",
    "owner2": "",
    "current_taxes": 2370.83,
    "new_taxes_no_override": 2473.25,
    "override_total_1": 2543.43,
    "override_increase_1": 70.18
  },
  {
    "#": "1450 Beacon St, Unit 742 (090-06-56)",
    "$": 659900,
    "address": "1450 Beacon St, Unit 742",
    "parcel_id": "090-06-56",
    "owner1": "LEI, ANGELA",
    "owner2": "",
    "current_taxes": 3122.44,
    "new_taxes_no_override": 3257.33,
    "override_total_1": 3349.75,
    "override_increase_1": 92.42
  },
  {
    "#": "1450 Beacon St, Unit 743 (090-06-57)",
    "$": 634400,
    "address": "1450 Beacon St, Unit 743",
    "parcel_id": "090-06-57",
    "owner1": "DONG, FAN",
    "owner2": "",
    "current_taxes": 6496.26,
    "new_taxes_no_override": 6776.9,
    "override_total_1": 6969.19,
    "override_increase_1": 192.29
  },
  {
    "#": "1450 Beacon St, Unit 744 (090-06-58)",
    "$": 550800,
    "address": "1450 Beacon St, Unit 744",
    "parcel_id": "090-06-58",
    "owner1": "LINKAGE2 HOLDINGS LLC",
    "owner2": "",
    "current_taxes": 5640.19,
    "new_taxes_no_override": 5883.85,
    "override_total_1": 6050.8,
    "override_increase_1": 166.95
  },
  {
    "#": "1450 Beacon St, Unit 801 (090-06-59)",
    "$": 675500,
    "address": "1450 Beacon St, Unit 801",
    "parcel_id": "090-06-59",
    "owner1": "SHEA, PAUL L",
    "owner2": "",
    "current_taxes": 3282.19,
    "new_taxes_no_override": 3423.98,
    "override_total_1": 3521.13,
    "override_increase_1": 97.15
  },
  {
    "#": "1450 Beacon St, Unit 802 (090-06-60)",
    "$": 570600,
    "address": "1450 Beacon St, Unit 802",
    "parcel_id": "090-06-60",
    "owner1": "BAJAL PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 5842.94,
    "new_taxes_no_override": 6095.36,
    "override_total_1": 6268.31,
    "override_increase_1": 172.95
  },
  {
    "#": "1450 Beacon St, Unit 803 (090-06-61)",
    "$": 698500,
    "address": "1450 Beacon St, Unit 803",
    "parcel_id": "090-06-61",
    "owner1": "WONG, SIMON & SAU CHUN",
    "owner2": "",
    "current_taxes": 7152.64,
    "new_taxes_no_override": 7461.63,
    "override_total_1": 7673.35,
    "override_increase_1": 211.72
  },
  {
    "#": "1450 Beacon St, Unit 804 (090-06-62)",
    "$": 482800,
    "address": "1450 Beacon St, Unit 804",
    "parcel_id": "090-06-62",
    "owner1": "GREEN, DAVID D",
    "owner2": "",
    "current_taxes": 1308.94,
    "new_taxes_no_override": 1365.49,
    "override_total_1": 1404.23,
    "override_increase_1": 38.74
  },
  {
    "#": "1450 Beacon St, Unit 841 (090-06-63)",
    "$": 570600,
    "address": "1450 Beacon St, Unit 841",
    "parcel_id": "090-06-63",
    "owner1": "GRANT, CALLUM H",
    "owner2": "",
    "current_taxes": 2208.01,
    "new_taxes_no_override": 2303.4,
    "override_total_1": 2368.75,
    "override_increase_1": 65.36
  },
  {
    "#": "1450 Beacon St, Unit 842 (090-06-64)",
    "$": 686200,
    "address": "1450 Beacon St, Unit 842",
    "parcel_id": "090-06-64",
    "owner1": "SOLTERO, INGRID",
    "owner2": "",
    "current_taxes": 3391.75,
    "new_taxes_no_override": 3538.27,
    "override_total_1": 3638.67,
    "override_increase_1": 100.4
  },
  {
    "#": "1450 Beacon St, Unit 843 (090-06-65)",
    "$": 515200,
    "address": "1450 Beacon St, Unit 843",
    "parcel_id": "090-06-65",
    "owner1": "SO, OLIVIA",
    "owner2": "YU, PUI FAN",
    "current_taxes": 5275.65,
    "new_taxes_no_override": 5503.56,
    "override_total_1": 5659.72,
    "override_increase_1": 156.16
  },
  {
    "#": "1450 Beacon St, Unit 844 (090-06-66)",
    "$": 535000,
    "address": "1450 Beacon St, Unit 844",
    "parcel_id": "090-06-66",
    "owner1": "FELLER, BRIAN",
    "owner2": "",
    "current_taxes": 5478.4,
    "new_taxes_no_override": 5715.07,
    "override_total_1": 5877.23,
    "override_increase_1": 162.16
  },
  {
    "#": "1450 Beacon St, Unit B01 (090-06-01)",
    "$": 431700,
    "address": "1450 Beacon St, Unit B01",
    "parcel_id": "090-06-01",
    "owner1": "WALTRIP, CATHERINE & WILLIAM",
    "owner2": "",
    "current_taxes": 4420.61,
    "new_taxes_no_override": 4611.58,
    "override_total_1": 4742.43,
    "override_increase_1": 130.85
  },
  {
    "#": "1450 Beacon St, Unit B02 (090-06-02)",
    "$": 373400,
    "address": "1450 Beacon St, Unit B02",
    "parcel_id": "090-06-02",
    "owner1": "HALVORSEN, YUAN DI  C",
    "owner2": "",
    "current_taxes": 3823.62,
    "new_taxes_no_override": 3988.8,
    "override_total_1": 4101.98,
    "override_increase_1": 113.18
  },
  {
    "#": "1450 Beacon St, Unit B41 (090-06-03)",
    "$": 386000,
    "address": "1450 Beacon St, Unit B41",
    "parcel_id": "090-06-03",
    "owner1": "MALHOTRA, PRAVEEN K & ROMEE",
    "owner2": "",
    "current_taxes": 3952.64,
    "new_taxes_no_override": 4123.39,
    "override_total_1": 4240.39,
    "override_increase_1": 117.0
  },
  {
    "#": "1450 Beacon St, Unit B42 (090-06-04)",
    "$": 411100,
    "address": "1450 Beacon St, Unit B42",
    "parcel_id": "090-06-04",
    "owner1": "GATES TR, LIORA LIEBERMAN",
    "owner2": "",
    "current_taxes": 4209.66,
    "new_taxes_no_override": 4391.52,
    "override_total_1": 4516.12,
    "override_increase_1": 124.61
  },
  {
    "#": "1455 Beacon St (214-30-00)",
    "$": 11933200,
    "address": "1455 Beacon St",
    "parcel_id": "214-30-00",
    "owner1": "METROPOLE BEACON LLC",
    "owner2": "",
    "current_taxes": 122195.97,
    "new_taxes_no_override": 127474.84,
    "override_total_1": 131091.84,
    "override_increase_1": 3617.0
  },
  {
    "#": "1459 Beacon St (214-29-00)",
    "$": 6907600,
    "address": "1459 Beacon St",
    "parcel_id": "214-29-00",
    "owner1": "PAPPAS, CYNTHIA",
    "owner2": "",
    "current_taxes": 70733.82,
    "new_taxes_no_override": 73789.52,
    "override_total_1": 75883.24,
    "override_increase_1": 2093.72
  },
  {
    "#": "1463 Beacon St (214-28-00)",
    "$": 8479900,
    "address": "1463 Beacon St",
    "parcel_id": "214-28-00",
    "owner1": "RPI 1463 BEACON LLC",
    "owner2": "C/O KINROSS REAL ESTATE",
    "current_taxes": 86834.18,
    "new_taxes_no_override": 90585.42,
    "override_total_1": 93155.71,
    "override_increase_1": 2570.29
  },
  {
    "#": "1469 Beacon St (214-27-00)",
    "$": 6903000,
    "address": "1469 Beacon St",
    "parcel_id": "214-27-00",
    "owner1": "LEEDER, TR, EARLE",
    "owner2": "",
    "current_taxes": 70686.72,
    "new_taxes_no_override": 73740.39,
    "override_total_1": 75832.71,
    "override_increase_1": 2092.33
  },
  {
    "#": "1470 Beacon St (089-01-00)",
    "$": 19873300,
    "address": "1470 Beacon St",
    "parcel_id": "089-01-00",
    "owner1": "PRINCETON WILMINGTON LLC",
    "owner2": "C/O PRINCETON PROPERTIES, HOWARD REEF",
    "current_taxes": 203502.59,
    "new_taxes_no_override": 212293.9,
    "override_total_1": 218317.58,
    "override_increase_1": 6023.68
  },
  {
    "#": "1471 Beacon St, Unit 1 (214-26-01)",
    "$": 1669900,
    "address": "1471 Beacon St, Unit 1",
    "parcel_id": "214-26-01",
    "owner1": "JAWS EQUITY OWNER 64 LLC",
    "owner2": "",
    "current_taxes": 17099.78,
    "new_taxes_no_override": 17838.49,
    "override_total_1": 18344.64,
    "override_increase_1": 506.15
  },
  {
    "#": "1471 Beacon St, Unit 10 (214-26-10)",
    "$": 1585000,
    "address": "1471 Beacon St, Unit 10",
    "parcel_id": "214-26-10",
    "owner1": "RAHMA, OSAMA",
    "owner2": "YAZIGI, SHASA",
    "current_taxes": 16230.4,
    "new_taxes_no_override": 16931.55,
    "override_total_1": 17411.97,
    "override_increase_1": 480.42
  },
  {
    "#": "1471 Beacon St, Unit 2 & P1 (214-26-02)",
    "$": 1856800,
    "address": "1471 Beacon St, Unit 2 & P1",
    "parcel_id": "214-26-02",
    "owner1": "YEN, EARL",
    "owner2": "",
    "current_taxes": 19013.63,
    "new_taxes_no_override": 19835.02,
    "override_total_1": 20397.82,
    "override_increase_1": 562.8
  },
  {
    "#": "1471 Beacon St, Unit 3 (214-26-03)",
    "$": 1517700,
    "address": "1471 Beacon St, Unit 3",
    "parcel_id": "214-26-03",
    "owner1": "YANG, LINYA",
    "owner2": "",
    "current_taxes": 11906.31,
    "new_taxes_no_override": 12420.66,
    "override_total_1": 12773.09,
    "override_increase_1": 352.43
  },
  {
    "#": "1471 Beacon St, Unit 4 (214-26-04)",
    "$": 1522500,
    "address": "1471 Beacon St, Unit 4",
    "parcel_id": "214-26-04",
    "owner1": "DUMAS, BRENDA D",
    "owner2": "",
    "current_taxes": 11955.47,
    "new_taxes_no_override": 12471.95,
    "override_total_1": 12825.83,
    "override_increase_1": 353.88
  },
  {
    "#": "1471 Beacon St, Unit 5 (214-26-05)",
    "$": 1639300,
    "address": "1471 Beacon St, Unit 5",
    "parcel_id": "214-26-05",
    "owner1": "CUSHINSKY, STEVEN M & ELIZABETH G",
    "owner2": "",
    "current_taxes": 13151.5,
    "new_taxes_no_override": 13719.64,
    "override_total_1": 14108.93,
    "override_increase_1": 389.28
  },
  {
    "#": "1471 Beacon St, Unit 6 (214-26-06)",
    "$": 1533200,
    "address": "1471 Beacon St, Unit 6",
    "parcel_id": "214-26-06",
    "owner1": "LIU, JINAN",
    "owner2": "",
    "current_taxes": 15699.97,
    "new_taxes_no_override": 16378.21,
    "override_total_1": 16842.93,
    "override_increase_1": 464.72
  },
  {
    "#": "1471 Beacon St, Unit 7 (214-26-07)",
    "$": 1561100,
    "address": "1471 Beacon St, Unit 7",
    "parcel_id": "214-26-07",
    "owner1": "HELMAN TR, DAVID N",
    "owner2": "",
    "current_taxes": 12350.73,
    "new_taxes_no_override": 12884.28,
    "override_total_1": 13249.86,
    "override_increase_1": 365.58
  },
  {
    "#": "1471 Beacon St, Unit 8 (214-26-08)",
    "$": 1533200,
    "address": "1471 Beacon St, Unit 8",
    "parcel_id": "214-26-08",
    "owner1": "SPECK, JEFF B & ALICE O",
    "owner2": "",
    "current_taxes": 15699.97,
    "new_taxes_no_override": 16378.21,
    "override_total_1": 16842.93,
    "override_increase_1": 464.72
  },
  {
    "#": "1471 Beacon St, Unit 9 & P2 (214-26-09)",
    "$": 1646400,
    "address": "1471 Beacon St, Unit 9 & P2",
    "parcel_id": "214-26-09",
    "owner1": "HAIG, HAROLD",
    "owner2": "",
    "current_taxes": 16859.14,
    "new_taxes_no_override": 17587.45,
    "override_total_1": 18086.49,
    "override_increase_1": 499.03
  },
  {
    "#": "1473 Beacon St (214-25-00)",
    "$": 1605500,
    "address": "1473 Beacon St",
    "parcel_id": "214-25-00",
    "owner1": "SANIEOFF TR, SYROOS",
    "owner2": "",
    "current_taxes": 16440.32,
    "new_taxes_no_override": 17150.54,
    "override_total_1": 17637.18,
    "override_increase_1": 486.63
  },
  {
    "#": "1476 Beacon St (089-02-00)",
    "$": 4057700,
    "address": "1476 Beacon St",
    "parcel_id": "089-02-00",
    "owner1": "DORFMAN TRS, JEROLD A",
    "owner2": "LISCHINSKY, R",
    "current_taxes": 41550.85,
    "new_taxes_no_override": 43345.85,
    "override_total_1": 44575.75,
    "override_increase_1": 1229.91
  },
  {
    "#": "1477 Beacon St (214-23-24)",
    "$": 33987500,
    "address": "1477 Beacon St",
    "parcel_id": "214-23-24",
    "owner1": "BEACON PROPERTY REALTY LLC",
    "owner2": "",
    "current_taxes": 348032.0,
    "new_taxes_no_override": 363066.98,
    "override_total_1": 373368.73,
    "override_increase_1": 10301.75
  },
  {
    "#": "1482 Beacon St (089-03-04)",
    "$": 9634000,
    "address": "1482 Beacon St",
    "parcel_id": "089-03-04",
    "owner1": "SANIEOFF, TR, PARVIZ",
    "owner2": "C/O SANIEOFF ESHAGH",
    "current_taxes": 98652.16,
    "new_taxes_no_override": 102913.93,
    "override_total_1": 105834.04,
    "override_increase_1": 2920.1
  },
  {
    "#": "1485 Beacon St (214-22-00)",
    "$": 2356800,
    "address": "1485 Beacon St",
    "parcel_id": "214-22-00",
    "owner1": "1485 BEACON STREET LLC",
    "owner2": "",
    "current_taxes": 28188.58,
    "new_taxes_no_override": 29406.33,
    "override_total_1": 30240.71,
    "override_increase_1": 834.38
  },
  {
    "#": "1487 Beacon St, Unit 1 (214-21-01)",
    "$": 828800,
    "address": "1487 Beacon St, Unit 1",
    "parcel_id": "214-21-01",
    "owner1": "GUGGENHEIM, EVAN R & JOCELYN R",
    "owner2": "",
    "current_taxes": 4851.98,
    "new_taxes_no_override": 5061.59,
    "override_total_1": 5205.2,
    "override_increase_1": 143.62
  },
  {
    "#": "1487 Beacon St, Unit 2 (214-21-02)",
    "$": 757200,
    "address": "1487 Beacon St, Unit 2",
    "parcel_id": "214-21-02",
    "owner1": "MELIGNANO TRS, ALYSSA M & VITA M",
    "owner2": "",
    "current_taxes": 4118.79,
    "new_taxes_no_override": 4296.72,
    "override_total_1": 4418.64,
    "override_increase_1": 121.92
  },
  {
    "#": "1487 Beacon St, Unit 3 (214-21-03)",
    "$": 858000,
    "address": "1487 Beacon St, Unit 3",
    "parcel_id": "214-21-03",
    "owner1": "SCHLESIER, DANIELLE",
    "owner2": "",
    "current_taxes": 5150.99,
    "new_taxes_no_override": 5373.51,
    "override_total_1": 5525.98,
    "override_increase_1": 152.47
  },
  {
    "#": "1487 Beacon St, Unit 4 (214-21-04)",
    "$": 865000,
    "address": "1487 Beacon St, Unit 4",
    "parcel_id": "214-21-04",
    "owner1": "RADMAND TR, ARIAN J",
    "owner2": "",
    "current_taxes": 8857.6,
    "new_taxes_no_override": 9240.25,
    "override_total_1": 9502.43,
    "override_increase_1": 262.18
  },
  {
    "#": "1488 Beacon St, Unit 1 & P9 (089-05-09)",
    "$": 637700,
    "address": "1488 Beacon St, Unit 1 & P9",
    "parcel_id": "089-05-09",
    "owner1": "WOODBURY, ABIGAIL M",
    "owner2": "",
    "current_taxes": 2895.11,
    "new_taxes_no_override": 3020.18,
    "override_total_1": 3105.87,
    "override_increase_1": 85.7
  },
  {
    "#": "1488 Beacon St, Unit 2 & P5 (089-05-10)",
    "$": 644300,
    "address": "1488 Beacon St, Unit 2 & P5",
    "parcel_id": "089-05-10",
    "owner1": "MARANCI, ANAHID",
    "owner2": "",
    "current_taxes": 2962.7,
    "new_taxes_no_override": 3090.69,
    "override_total_1": 3178.38,
    "override_increase_1": 87.7
  },
  {
    "#": "1488 Beacon St, Unit 3 & P8 (089-05-11)",
    "$": 826300,
    "address": "1488 Beacon St, Unit 3 & P8",
    "parcel_id": "089-05-11",
    "owner1": "GUREVICH TR, IRINA",
    "owner2": "",
    "current_taxes": 8461.31,
    "new_taxes_no_override": 8826.84,
    "override_total_1": 9077.29,
    "override_increase_1": 250.45
  },
  {
    "#": "1488 Beacon St, Unit 4 (089-05-12)",
    "$": 634500,
    "address": "1488 Beacon St, Unit 4",
    "parcel_id": "089-05-12",
    "owner1": "BCT PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 6497.28,
    "new_taxes_no_override": 6777.96,
    "override_total_1": 6970.28,
    "override_increase_1": 192.32
  },
  {
    "#": "1488 Beacon St, Unit 5 & P12 (089-05-13)",
    "$": 813100,
    "address": "1488 Beacon St, Unit 5 & P12",
    "parcel_id": "089-05-13",
    "owner1": "WINSTON, RICHARD L",
    "owner2": "",
    "current_taxes": 4691.21,
    "new_taxes_no_override": 4893.87,
    "override_total_1": 5032.73,
    "override_increase_1": 138.86
  },
  {
    "#": "1488 Beacon St, Unit 6 & P13 (089-05-14)",
    "$": 743800,
    "address": "1488 Beacon St, Unit 6 & P13",
    "parcel_id": "089-05-14",
    "owner1": "SUN, LIMIN",
    "owner2": "DONG, CHUNLING",
    "current_taxes": 3981.58,
    "new_taxes_no_override": 4153.58,
    "override_total_1": 4271.44,
    "override_increase_1": 117.85
  },
  {
    "#": "1488 Beacon St, Unit B (089-05-08)",
    "$": 478000,
    "address": "1488 Beacon St, Unit B",
    "parcel_id": "089-05-08",
    "owner1": "LAMM, ROBERT",
    "owner2": "",
    "current_taxes": 4894.72,
    "new_taxes_no_override": 5106.17,
    "override_total_1": 5251.06,
    "override_increase_1": 144.88
  },
  {
    "#": "1489 Beacon St (214-20-00)",
    "$": 3183800,
    "address": "1489 Beacon St",
    "parcel_id": "214-20-00",
    "owner1": "AMND REALTY LLC",
    "owner2": "",
    "current_taxes": 32602.11,
    "new_taxes_no_override": 34010.52,
    "override_total_1": 34975.54,
    "override_increase_1": 965.02
  },
  {
    "#": "1490 Beacon St, Unit 1 (089-05-16)",
    "$": 628800,
    "address": "1490 Beacon St, Unit 1",
    "parcel_id": "089-05-16",
    "owner1": "SHEPARDSON, LYNN",
    "owner2": "",
    "current_taxes": 6438.91,
    "new_taxes_no_override": 6717.07,
    "override_total_1": 6907.66,
    "override_increase_1": 190.59
  },
  {
    "#": "1490 Beacon St, Unit 2 (089-05-17)",
    "$": 669200,
    "address": "1490 Beacon St, Unit 2",
    "parcel_id": "089-05-17",
    "owner1": "JIANG, KUISUO",
    "owner2": "C/O JASON GELL SIGNER PRTY MGMT",
    "current_taxes": 6852.61,
    "new_taxes_no_override": 7148.64,
    "override_total_1": 7351.48,
    "override_increase_1": 202.84
  },
  {
    "#": "1490 Beacon St, Unit 3 (089-05-18)",
    "$": 654300,
    "address": "1490 Beacon St, Unit 3",
    "parcel_id": "089-05-18",
    "owner1": "CHIN, THOMAS & LI YAN",
    "owner2": "",
    "current_taxes": 6700.03,
    "new_taxes_no_override": 6989.47,
    "override_total_1": 7187.79,
    "override_increase_1": 198.32
  },
  {
    "#": "1490 Beacon St, Unit 4 & P16 (089-05-19)",
    "$": 872800,
    "address": "1490 Beacon St, Unit 4 & P16",
    "parcel_id": "089-05-19",
    "owner1": "NOKHODBERIZ, SEYEDMEHDI SADEGHZADEH",
    "owner2": "HONARYAR, NILOOFAR",
    "current_taxes": 5302.54,
    "new_taxes_no_override": 5531.61,
    "override_total_1": 5688.56,
    "override_increase_1": 156.96
  },
  {
    "#": "1490 Beacon St, Unit 5 (089-05-20)",
    "$": 642500,
    "address": "1490 Beacon St, Unit 5",
    "parcel_id": "089-05-20",
    "owner1": "REZAVKER, JOSHUA",
    "owner2": "RUBIN, SOPHIE",
    "current_taxes": 2944.27,
    "new_taxes_no_override": 3071.46,
    "override_total_1": 3158.61,
    "override_increase_1": 87.15
  },
  {
    "#": "1490 Beacon St, Unit 6 & P23 (089-05-21)",
    "$": 860200,
    "address": "1490 Beacon St, Unit 6 & P23",
    "parcel_id": "089-05-21",
    "owner1": "MEI, MARVIN",
    "owner2": "",
    "current_taxes": 8808.45,
    "new_taxes_no_override": 9188.98,
    "override_total_1": 9449.71,
    "override_increase_1": 260.73
  },
  {
    "#": "1490 Beacon St, Unit B (089-05-15)",
    "$": 521700,
    "address": "1490 Beacon St, Unit B",
    "parcel_id": "089-05-15",
    "owner1": "CIPULLO, EDWARD J",
    "owner2": "",
    "current_taxes": 5342.21,
    "new_taxes_no_override": 5572.99,
    "override_total_1": 5731.12,
    "override_increase_1": 158.13
  },
  {
    "#": "1491 Beacon St, Unit 1 (214-19-01)",
    "$": 488600,
    "address": "1491 Beacon St, Unit 1",
    "parcel_id": "214-19-01",
    "owner1": "PALMQUIST, CINDY T & DAVID A",
    "owner2": "",
    "current_taxes": 1368.33,
    "new_taxes_no_override": 1427.44,
    "override_total_1": 1467.94,
    "override_increase_1": 40.5
  },
  {
    "#": "1491 Beacon St, Unit 2 (214-19-02)",
    "$": 571000,
    "address": "1491 Beacon St, Unit 2",
    "parcel_id": "214-19-02",
    "owner1": "LINDENBAUM, MARC B",
    "owner2": "",
    "current_taxes": 2212.11,
    "new_taxes_no_override": 2307.67,
    "override_total_1": 2373.15,
    "override_increase_1": 65.48
  },
  {
    "#": "1491 Beacon St, Unit 3 (214-19-03)",
    "$": 606800,
    "address": "1491 Beacon St, Unit 3",
    "parcel_id": "214-19-03",
    "owner1": "RICE, JOHN A",
    "owner2": "POWERS, JENNE",
    "current_taxes": 2578.7,
    "new_taxes_no_override": 2690.1,
    "override_total_1": 2766.43,
    "override_increase_1": 76.33
  },
  {
    "#": "1491 Beacon St, Unit 4 (214-19-04)",
    "$": 593000,
    "address": "1491 Beacon St, Unit 4",
    "parcel_id": "214-19-04",
    "owner1": "GREEN, JONATHAN D & DIANA R",
    "owner2": "",
    "current_taxes": 2437.39,
    "new_taxes_no_override": 2542.69,
    "override_total_1": 2614.83,
    "override_increase_1": 72.15
  },
  {
    "#": "1492 Beacon St, Unit 1 (089-05-22)",
    "$": 620400,
    "address": "1492 Beacon St, Unit 1",
    "parcel_id": "089-05-22",
    "owner1": "MOCHIDA, GANESHWARAN HITOSHI",
    "owner2": "",
    "current_taxes": 2717.96,
    "new_taxes_no_override": 2835.38,
    "override_total_1": 2915.83,
    "override_increase_1": 80.45
  },
  {
    "#": "1492 Beacon St, Unit 2 (089-05-23)",
    "$": 690000,
    "address": "1492 Beacon St, Unit 2",
    "parcel_id": "089-05-23",
    "owner1": "READE, BARBARA A",
    "owner2": "",
    "current_taxes": 3430.67,
    "new_taxes_no_override": 3578.87,
    "override_total_1": 3680.42,
    "override_increase_1": 101.55
  },
  {
    "#": "1492 Beacon St, Unit 3 (089-05-24)",
    "$": 599900,
    "address": "1492 Beacon St, Unit 3",
    "parcel_id": "089-05-24",
    "owner1": "CHANG, TZU-HSIEN",
    "owner2": "CHEN, MIN-HUA",
    "current_taxes": 2508.04,
    "new_taxes_no_override": 2616.39,
    "override_total_1": 2690.63,
    "override_increase_1": 74.24
  },
  {
    "#": "1492 Beacon St, Unit 4 & P10 (089-05-25)",
    "$": 788200,
    "address": "1492 Beacon St, Unit 4 & P10",
    "parcel_id": "089-05-25",
    "owner1": "GOTTESMAN TRS, MICHAEL D & ELISE BLOCK",
    "owner2": "",
    "current_taxes": 8071.17,
    "new_taxes_no_override": 8419.84,
    "override_total_1": 8658.75,
    "override_increase_1": 238.91
  },
  {
    "#": "1492 Beacon St, Unit 5 & P14 (089-05-26)",
    "$": 733600,
    "address": "1492 Beacon St, Unit 5 & P14",
    "parcel_id": "089-05-26",
    "owner1": "KIRKOV, IVAYLO M",
    "owner2": "VASSILEVA, YOANA",
    "current_taxes": 7512.06,
    "new_taxes_no_override": 7836.58,
    "override_total_1": 8058.94,
    "override_increase_1": 222.36
  },
  {
    "#": "1492 Beacon St, Unit 6 & P15 (089-05-27)",
    "$": 862200,
    "address": "1492 Beacon St, Unit 6 & P15",
    "parcel_id": "089-05-27",
    "owner1": "SUNDBERG, AIMEE K",
    "owner2": "",
    "current_taxes": 5193.99,
    "new_taxes_no_override": 5418.37,
    "override_total_1": 5572.11,
    "override_increase_1": 153.74
  },
  {
    "#": "1493 Beacon St, Unit 1 (214-18-02)",
    "$": 634100,
    "address": "1493 Beacon St, Unit 1",
    "parcel_id": "214-18-02",
    "owner1": "MILLER, ANNA & IRINA",
    "owner2": "",
    "current_taxes": 6493.18,
    "new_taxes_no_override": 6773.69,
    "override_total_1": 6965.88,
    "override_increase_1": 192.2
  },
  {
    "#": "1493 Beacon St, Unit 2 (214-18-03)",
    "$": 732900,
    "address": "1493 Beacon St, Unit 2",
    "parcel_id": "214-18-03",
    "owner1": "CHARY, RAMDAS VENKATA",
    "owner2": "",
    "current_taxes": 7504.9,
    "new_taxes_no_override": 7829.11,
    "override_total_1": 8051.26,
    "override_increase_1": 222.15
  },
  {
    "#": "1493 Beacon St, Unit 3 & P3 (214-18-04)",
    "$": 772700,
    "address": "1493 Beacon St, Unit 3 & P3",
    "parcel_id": "214-18-04",
    "owner1": "SEIBERG, MEREDITH S",
    "owner2": "",
    "current_taxes": 4277.51,
    "new_taxes_no_override": 4462.3,
    "override_total_1": 4588.91,
    "override_increase_1": 126.61
  },
  {
    "#": "1493 Beacon St, Unit G (214-18-01)",
    "$": 643600,
    "address": "1493 Beacon St, Unit G",
    "parcel_id": "214-18-01",
    "owner1": "KAFLE, BIR B",
    "owner2": "",
    "current_taxes": 6590.46,
    "new_taxes_no_override": 6875.17,
    "override_total_1": 7070.25,
    "override_increase_1": 195.08
  },
  {
    "#": "1494 Beacon St, Unit 1 (089-05-28)",
    "$": 754300,
    "address": "1494 Beacon St, Unit 1",
    "parcel_id": "089-05-28",
    "owner1": "CHIO, CHAMI",
    "owner2": "",
    "current_taxes": 4089.1,
    "new_taxes_no_override": 4265.75,
    "override_total_1": 4386.79,
    "override_increase_1": 121.04
  },
  {
    "#": "1494 Beacon St, Unit 2 & P4 (089-05-29)",
    "$": 800400,
    "address": "1494 Beacon St, Unit 2 & P4",
    "parcel_id": "089-05-29",
    "owner1": "MIR, JOAQUIN A & JULITA",
    "owner2": "MUNARRIZ, RICARDO",
    "current_taxes": 8196.1,
    "new_taxes_no_override": 8550.17,
    "override_total_1": 8792.78,
    "override_increase_1": 242.6
  },
  {
    "#": "1494 Beacon St, Unit 3 & P19 (089-05-30)",
    "$": 805600,
    "address": "1494 Beacon St, Unit 3 & P19",
    "parcel_id": "089-05-30",
    "owner1": "IGUCHI, YASUYO",
    "owner2": "MCCORMICK, WILLIAM H",
    "current_taxes": 4614.41,
    "new_taxes_no_override": 4813.75,
    "override_total_1": 4950.34,
    "override_increase_1": 136.59
  },
  {
    "#": "1495 Beacon St, Unit 1 & P1 (214-17-02)",
    "$": 699400,
    "address": "1495 Beacon St, Unit 1 & P1",
    "parcel_id": "214-17-02",
    "owner1": "STAVISKY TR, NATALIA",
    "owner2": "",
    "current_taxes": 7161.86,
    "new_taxes_no_override": 7471.25,
    "override_total_1": 7683.24,
    "override_increase_1": 211.99
  },
  {
    "#": "1495 Beacon St, Unit 2 & P2 (214-17-03)",
    "$": 739500,
    "address": "1495 Beacon St, Unit 2 & P2",
    "parcel_id": "214-17-03",
    "owner1": "GILLIGAN TR, LEIGH A",
    "owner2": "",
    "current_taxes": 7572.48,
    "new_taxes_no_override": 7899.61,
    "override_total_1": 8123.76,
    "override_increase_1": 224.15
  },
  {
    "#": "1495 Beacon St, Unit 3 & P3 (214-17-04)",
    "$": 704800,
    "address": "1495 Beacon St, Unit 3 & P3",
    "parcel_id": "214-17-04",
    "owner1": "1495 THREE BEACON LLC",
    "owner2": "",
    "current_taxes": 7217.15,
    "new_taxes_no_override": 7528.93,
    "override_total_1": 7742.56,
    "override_increase_1": 213.63
  },
  {
    "#": "1495 Beacon St, Unit G & Pk Sp G (214-17-01)",
    "$": 699200,
    "address": "1495 Beacon St, Unit G & Pk Sp G",
    "parcel_id": "214-17-01",
    "owner1": "ZHAO, ZHONGSHU",
    "owner2": "",
    "current_taxes": 7159.81,
    "new_taxes_no_override": 7469.11,
    "override_total_1": 7681.04,
    "override_increase_1": 211.93
  },
  {
    "#": "1496 Beacon St, Unit 1 P-17 (089-05-31)",
    "$": 808300,
    "address": "1496 Beacon St, Unit 1 P-17",
    "parcel_id": "089-05-31",
    "owner1": "WISEMAN, ELENA",
    "owner2": "",
    "current_taxes": 8276.99,
    "new_taxes_no_override": 8634.56,
    "override_total_1": 8879.55,
    "override_increase_1": 245.0
  },
  {
    "#": "1496 Beacon St, Unit 2 (089-05-32)",
    "$": 625400,
    "address": "1496 Beacon St, Unit 2",
    "parcel_id": "089-05-32",
    "owner1": "FERGUSON, FRANK",
    "owner2": "BUCCITELLI, MARIE",
    "current_taxes": 2769.16,
    "new_taxes_no_override": 2888.79,
    "override_total_1": 2970.75,
    "override_increase_1": 81.97
  },
  {
    "#": "1496 Beacon St, Unit 3 (089-05-33)",
    "$": 687500,
    "address": "1496 Beacon St, Unit 3",
    "parcel_id": "089-05-33",
    "owner1": "PETERBURGSKY, IRINA",
    "owner2": "",
    "current_taxes": 3405.07,
    "new_taxes_no_override": 3552.17,
    "override_total_1": 3652.96,
    "override_increase_1": 100.79
  },
  {
    "#": "1496 Beacon St, Unit 4 & P18 (089-05-34)",
    "$": 737500,
    "address": "1496 Beacon St, Unit 4 & P18",
    "parcel_id": "089-05-34",
    "owner1": "HEALY, ADAM & ADRIANA",
    "owner2": "",
    "current_taxes": 7552.0,
    "new_taxes_no_override": 7878.25,
    "override_total_1": 8101.79,
    "override_increase_1": 223.54
  },
  {
    "#": "1496 Beacon St, Unit 5 (089-05-35)",
    "$": 797500,
    "address": "1496 Beacon St, Unit 5",
    "parcel_id": "089-05-35",
    "owner1": "KUBATIN, VLADIMIR M",
    "owner2": "ZHAI, QING",
    "current_taxes": 8166.4,
    "new_taxes_no_override": 8519.19,
    "override_total_1": 8760.91,
    "override_increase_1": 241.73
  },
  {
    "#": "1496 Beacon St, Unit 6 & P20 (089-05-36)",
    "$": 754000,
    "address": "1496 Beacon St, Unit 6 & P20",
    "parcel_id": "089-05-36",
    "owner1": "KHANSHAN, FARIBA",
    "owner2": "",
    "current_taxes": 4086.03,
    "new_taxes_no_override": 4262.55,
    "override_total_1": 4383.49,
    "override_increase_1": 120.95
  },
  {
    "#": "1498 Beacon St, Unit 1 & P22 (089-05-37)",
    "$": 650100,
    "address": "1498 Beacon St, Unit 1 & P22",
    "parcel_id": "089-05-37",
    "owner1": "MCANDREW, RAYMOND",
    "owner2": "",
    "current_taxes": 6657.02,
    "new_taxes_no_override": 6944.6,
    "override_total_1": 7141.65,
    "override_increase_1": 197.05
  },
  {
    "#": "1498 Beacon St, Unit 2 & P24 (089-05-38)",
    "$": 789600,
    "address": "1498 Beacon St, Unit 2 & P24",
    "parcel_id": "089-05-38",
    "owner1": "CHIO, CHAMI",
    "owner2": "LEE, PATRICK",
    "current_taxes": 8085.5,
    "new_taxes_no_override": 8434.79,
    "override_total_1": 8674.12,
    "override_increase_1": 239.33
  },
  {
    "#": "1498 Beacon St, Unit 3 (089-05-39)",
    "$": 595800,
    "address": "1498 Beacon St, Unit 3",
    "parcel_id": "089-05-39",
    "owner1": "CICCARIELLO, JOSEPHINE",
    "owner2": "",
    "current_taxes": 2466.06,
    "new_taxes_no_override": 2572.59,
    "override_total_1": 2645.59,
    "override_increase_1": 73.0
  },
  {
    "#": "1498 Beacon St, Unit 4 & P11 (089-05-40)",
    "$": 859500,
    "address": "1498 Beacon St, Unit 4 & P11",
    "parcel_id": "089-05-40",
    "owner1": "ZOU, JING",
    "owner2": "",
    "current_taxes": 8801.28,
    "new_taxes_no_override": 9181.5,
    "override_total_1": 9442.01,
    "override_increase_1": 260.52
  },
  {
    "#": "1498 Beacon St, Unit 5 (089-05-41)",
    "$": 721700,
    "address": "1498 Beacon St, Unit 5",
    "parcel_id": "089-05-41",
    "owner1": "DESAI, DARASH",
    "owner2": "FERNANDES, FALLON M",
    "current_taxes": 7390.21,
    "new_taxes_no_override": 7709.47,
    "override_total_1": 7928.22,
    "override_increase_1": 218.75
  },
  {
    "#": "1498 Beacon St, Unit 6 (089-05-42)",
    "$": 804700,
    "address": "1498 Beacon St, Unit 6",
    "parcel_id": "089-05-42",
    "owner1": "MELNIKOVA, ANNA",
    "owner2": "",
    "current_taxes": 4605.19,
    "new_taxes_no_override": 4804.13,
    "override_total_1": 4940.45,
    "override_increase_1": 136.31
  },
  {
    "#": "1500 Beacon St, Unit 1 & P7 (089-05-44)",
    "$": 847200,
    "address": "1500 Beacon St, Unit 1 & P7",
    "parcel_id": "089-05-44",
    "owner1": "KATS TRS, SAMUEL",
    "owner2": "VAYSMAN, ELLA",
    "current_taxes": 5040.39,
    "new_taxes_no_override": 5258.13,
    "override_total_1": 5407.33,
    "override_increase_1": 149.2
  },
  {
    "#": "1500 Beacon St, Unit 2 & P3 (089-05-45)",
    "$": 779300,
    "address": "1500 Beacon St, Unit 2 & P3",
    "parcel_id": "089-05-45",
    "owner1": "RAJAPAKSE, SUDHEERA & JALINI M",
    "owner2": "",
    "current_taxes": 7980.03,
    "new_taxes_no_override": 8324.77,
    "override_total_1": 8560.98,
    "override_increase_1": 236.21
  },
  {
    "#": "1500 Beacon St, Unit 3 & P2 (089-05-46)",
    "$": 867900,
    "address": "1500 Beacon St, Unit 3 & P2",
    "parcel_id": "089-05-46",
    "owner1": "ROZENOER, NADINE",
    "owner2": "",
    "current_taxes": 5252.36,
    "new_taxes_no_override": 5479.26,
    "override_total_1": 5634.73,
    "override_increase_1": 155.47
  },
  {
    "#": "1500 Beacon St, Unit 4 & P-1 (089-05-47)",
    "$": 778300,
    "address": "1500 Beacon St, Unit 4 & P-1",
    "parcel_id": "089-05-47",
    "owner1": "GROSSMAN, CYNTHIA",
    "owner2": "",
    "current_taxes": 4334.86,
    "new_taxes_no_override": 4522.13,
    "override_total_1": 4650.44,
    "override_increase_1": 128.31
  },
  {
    "#": "1500 Beacon St, Unit 5 & P6 (089-05-48)",
    "$": 835500,
    "address": "1500 Beacon St, Unit 5 & P6",
    "parcel_id": "089-05-48",
    "owner1": "FREEMAN, CLIFFORD M & PAMELA S",
    "owner2": "",
    "current_taxes": 8555.52,
    "new_taxes_no_override": 8925.12,
    "override_total_1": 9178.36,
    "override_increase_1": 253.24
  },
  {
    "#": "1500 Beacon St, Unit 6 & P21 (089-05-49)",
    "$": 732700,
    "address": "1500 Beacon St, Unit 6 & P21",
    "parcel_id": "089-05-49",
    "owner1": "JJIE LLC",
    "owner2": "",
    "current_taxes": 7502.85,
    "new_taxes_no_override": 7826.97,
    "override_total_1": 8049.06,
    "override_increase_1": 222.08
  },
  {
    "#": "1500 Beacon St, Unit B (089-05-43)",
    "$": 629700,
    "address": "1500 Beacon St, Unit B",
    "parcel_id": "089-05-43",
    "owner1": "THINH, PHAM HY",
    "owner2": "NGUYET, NGUYEN THI MINH",
    "current_taxes": 2813.19,
    "new_taxes_no_override": 2934.72,
    "override_total_1": 3017.99,
    "override_increase_1": 83.27
  },
  {
    "#": "1501 Beacon St (214-15-16)",
    "$": 79505200,
    "address": "1501 Beacon St",
    "parcel_id": "214-15-16",
    "owner1": "1501 BEACON STREET LLC",
    "owner2": "C/O SULLIVAN CO",
    "current_taxes": 814133.25,
    "new_taxes_no_override": 849303.81,
    "override_total_1": 873402.15,
    "override_increase_1": 24098.34
  },
  {
    "#": "1514 Beacon St, Unit 1 (089-09-01)",
    "$": 983800,
    "address": "1514 Beacon St, Unit 1",
    "parcel_id": "089-09-01",
    "owner1": "GELLER, JESSE",
    "owner2": "",
    "current_taxes": 6439.18,
    "new_taxes_no_override": 6717.35,
    "override_total_1": 6907.95,
    "override_increase_1": 190.6
  },
  {
    "#": "1514 Beacon St, Unit 2 (089-09-02)",
    "$": 422900,
    "address": "1514 Beacon St, Unit 2",
    "parcel_id": "089-09-02",
    "owner1": "GELLER, JESSE",
    "owner2": "",
    "current_taxes": 4330.5,
    "new_taxes_no_override": 4517.58,
    "override_total_1": 4645.76,
    "override_increase_1": 128.18
  },
  {
    "#": "1514 Beacon St, Unit 21 (089-09-05)",
    "$": 1249200,
    "address": "1514 Beacon St, Unit 21",
    "parcel_id": "089-09-05",
    "owner1": "ALBAN TRS, LUDWIG & MARSHA",
    "owner2": "",
    "current_taxes": 9156.87,
    "new_taxes_no_override": 9552.45,
    "override_total_1": 9823.49,
    "override_increase_1": 271.04
  },
  {
    "#": "1514 Beacon St, Unit 22 (089-09-06)",
    "$": 573000,
    "address": "1514 Beacon St, Unit 22",
    "parcel_id": "089-09-06",
    "owner1": "KALBERG TRS, STEPHEN",
    "owner2": "NOVIKOVA, GAYANE",
    "current_taxes": 5867.52,
    "new_taxes_no_override": 6121.0,
    "override_total_1": 6294.68,
    "override_increase_1": 173.68
  },
  {
    "#": "1514 Beacon St, Unit 23 (089-09-07)",
    "$": 974200,
    "address": "1514 Beacon St, Unit 23",
    "parcel_id": "089-09-07",
    "owner1": "MELYAN TR, ZARE",
    "owner2": "",
    "current_taxes": 9975.81,
    "new_taxes_no_override": 10406.76,
    "override_total_1": 10702.05,
    "override_increase_1": 295.28
  },
  {
    "#": "1514 Beacon St, Unit 24 (089-09-08)",
    "$": 998800,
    "address": "1514 Beacon St, Unit 24",
    "parcel_id": "089-09-08",
    "owner1": "EASTANDK LLC",
    "owner2": "",
    "current_taxes": 10227.71,
    "new_taxes_no_override": 10669.55,
    "override_total_1": 10972.29,
    "override_increase_1": 302.74
  },
  {
    "#": "1514 Beacon St, Unit 25 (089-09-09)",
    "$": 902100,
    "address": "1514 Beacon St, Unit 25",
    "parcel_id": "089-09-09",
    "owner1": "HOLTZ, ROBIN WILKINS & ANDREW A",
    "owner2": "",
    "current_taxes": 5602.57,
    "new_taxes_no_override": 5844.6,
    "override_total_1": 6010.44,
    "override_increase_1": 165.84
  },
  {
    "#": "1514 Beacon St, Unit 26 (089-09-10)",
    "$": 983600,
    "address": "1514 Beacon St, Unit 26",
    "parcel_id": "089-09-10",
    "owner1": "WHITE, DAN S & NANCY P",
    "owner2": "",
    "current_taxes": 6437.13,
    "new_taxes_no_override": 6715.21,
    "override_total_1": 6905.75,
    "override_increase_1": 190.54
  },
  {
    "#": "1514 Beacon St, Unit 27 (089-09-11)",
    "$": 573000,
    "address": "1514 Beacon St, Unit 27",
    "parcel_id": "089-09-11",
    "owner1": "LYONS, SHARI M",
    "owner2": "",
    "current_taxes": 5867.52,
    "new_taxes_no_override": 6121.0,
    "override_total_1": 6294.68,
    "override_increase_1": 173.68
  },
  {
    "#": "1514 Beacon St, Unit 28 (089-09-12)",
    "$": 1414300,
    "address": "1514 Beacon St, Unit 28",
    "parcel_id": "089-09-12",
    "owner1": "RIVAS, TRS, JANNETH M & ANA B",
    "owner2": "",
    "current_taxes": 14482.43,
    "new_taxes_no_override": 15108.07,
    "override_total_1": 15536.75,
    "override_increase_1": 428.68
  },
  {
    "#": "1514 Beacon St, Unit 31 (089-09-13)",
    "$": 1249100,
    "address": "1514 Beacon St, Unit 31",
    "parcel_id": "089-09-13",
    "owner1": "RIELY, ANDREW",
    "owner2": "",
    "current_taxes": 9155.85,
    "new_taxes_no_override": 9551.38,
    "override_total_1": 9822.4,
    "override_increase_1": 271.01
  },
  {
    "#": "1514 Beacon St, Unit 32 (089-09-14)",
    "$": 573000,
    "address": "1514 Beacon St, Unit 32",
    "parcel_id": "089-09-14",
    "owner1": "FREDERICK, CYNTHIA M",
    "owner2": "",
    "current_taxes": 5867.52,
    "new_taxes_no_override": 6121.0,
    "override_total_1": 6294.68,
    "override_increase_1": 173.68
  },
  {
    "#": "1514 Beacon St, Unit 33 (089-09-15)",
    "$": 931300,
    "address": "1514 Beacon St, Unit 33",
    "parcel_id": "089-09-15",
    "owner1": "GRINEV, ELENA A",
    "owner2": "",
    "current_taxes": 5901.58,
    "new_taxes_no_override": 6156.53,
    "override_total_1": 6331.22,
    "override_increase_1": 174.69
  },
  {
    "#": "1514 Beacon St, Unit 34 (089-09-16)",
    "$": 1055400,
    "address": "1514 Beacon St, Unit 34",
    "parcel_id": "089-09-16",
    "owner1": "ZHU, MIRIAM YUNLING",
    "owner2": "",
    "current_taxes": 7172.36,
    "new_taxes_no_override": 7482.21,
    "override_total_1": 7694.51,
    "override_increase_1": 212.3
  },
  {
    "#": "1514 Beacon St, Unit 35 (089-09-17)",
    "$": 953100,
    "address": "1514 Beacon St, Unit 35",
    "parcel_id": "089-09-17",
    "owner1": "LIPPE, WENDY",
    "owner2": "",
    "current_taxes": 9759.74,
    "new_taxes_no_override": 10181.36,
    "override_total_1": 10470.25,
    "override_increase_1": 288.89
  },
  {
    "#": "1514 Beacon St, Unit 36 (089-09-18)",
    "$": 944000,
    "address": "1514 Beacon St, Unit 36",
    "parcel_id": "089-09-18",
    "owner1": "LIPPE, WENDY",
    "owner2": "",
    "current_taxes": 9666.56,
    "new_taxes_no_override": 10084.16,
    "override_total_1": 10370.29,
    "override_increase_1": 286.13
  },
  {
    "#": "1514 Beacon St, Unit 37 (089-09-19)",
    "$": 593700,
    "address": "1514 Beacon St, Unit 37",
    "parcel_id": "089-09-19",
    "owner1": "LIPPE, WENDY",
    "owner2": "",
    "current_taxes": 6079.49,
    "new_taxes_no_override": 6342.12,
    "override_total_1": 6522.08,
    "override_increase_1": 179.95
  },
  {
    "#": "1514 Beacon St, Unit 38 (089-09-20)",
    "$": 1446700,
    "address": "1514 Beacon St, Unit 38",
    "parcel_id": "089-09-20",
    "owner1": "LIPPE, WENDY",
    "owner2": "",
    "current_taxes": 11179.27,
    "new_taxes_no_override": 11662.21,
    "override_total_1": 11993.12,
    "override_increase_1": 330.91
  },
  {
    "#": "1514 Beacon St, Unit 41 (089-09-21)",
    "$": 1344300,
    "address": "1514 Beacon St, Unit 41",
    "parcel_id": "089-09-21",
    "owner1": "KIM, YONGBUM & HYEONJU",
    "owner2": "",
    "current_taxes": 13765.63,
    "new_taxes_no_override": 14360.31,
    "override_total_1": 14767.77,
    "override_increase_1": 407.46
  },
  {
    "#": "1514 Beacon St, Unit 42 (089-09-22)",
    "$": 608600,
    "address": "1514 Beacon St, Unit 42",
    "parcel_id": "089-09-22",
    "owner1": "MEGALE TR, MEGAN A",
    "owner2": "",
    "current_taxes": 2597.13,
    "new_taxes_no_override": 2709.33,
    "override_total_1": 2786.2,
    "override_increase_1": 76.88
  },
  {
    "#": "1514 Beacon St, Unit 43 (089-09-23)",
    "$": 983600,
    "address": "1514 Beacon St, Unit 43",
    "parcel_id": "089-09-23",
    "owner1": "GROSS, PAUL W",
    "owner2": "CANO, MARYORY",
    "current_taxes": 6437.13,
    "new_taxes_no_override": 6715.21,
    "override_total_1": 6905.75,
    "override_increase_1": 190.54
  },
  {
    "#": "1514 Beacon St, Unit 44 (089-09-24)",
    "$": 1017200,
    "address": "1514 Beacon St, Unit 44",
    "parcel_id": "089-09-24",
    "owner1": "ROZOVSKY, ANATOLY",
    "owner2": "",
    "current_taxes": 6781.19,
    "new_taxes_no_override": 7074.14,
    "override_total_1": 7274.86,
    "override_increase_1": 200.72
  },
  {
    "#": "1514 Beacon St, Unit 45 (089-09-25)",
    "$": 1099000,
    "address": "1514 Beacon St, Unit 45",
    "parcel_id": "089-09-25",
    "owner1": "ASHRAFI, NOUSHIN",
    "owner2": "",
    "current_taxes": 7618.83,
    "new_taxes_no_override": 7947.96,
    "override_total_1": 8173.48,
    "override_increase_1": 225.52
  },
  {
    "#": "1514 Beacon St, Unit 46 (089-09-26)",
    "$": 957500,
    "address": "1514 Beacon St, Unit 46",
    "parcel_id": "089-09-26",
    "owner1": "MILOUSHEFF, ZACK",
    "owner2": "DIMITRIEVA, DOBRINA",
    "current_taxes": 9804.8,
    "new_taxes_no_override": 10228.37,
    "override_total_1": 10518.59,
    "override_increase_1": 290.22
  },
  {
    "#": "1514 Beacon St, Unit 47 (089-09-27)",
    "$": 629200,
    "address": "1514 Beacon St, Unit 47",
    "parcel_id": "089-09-27",
    "owner1": "LEAVITT, JONATHAN P",
    "owner2": "FELLOWS, MARYJANE",
    "current_taxes": 6443.01,
    "new_taxes_no_override": 6721.35,
    "override_total_1": 6912.06,
    "override_increase_1": 190.71
  },
  {
    "#": "1514 Beacon St, Unit 48 (089-09-28)",
    "$": 1344300,
    "address": "1514 Beacon St, Unit 48",
    "parcel_id": "089-09-28",
    "owner1": "LEAVITT, JONATHAN P",
    "owner2": "FELLOWS, MARYJANE",
    "current_taxes": 13765.63,
    "new_taxes_no_override": 14360.31,
    "override_total_1": 14767.77,
    "override_increase_1": 407.46
  },
  {
    "#": "1514 Beacon St, Unit 51 (089-09-29)",
    "$": 1358400,
    "address": "1514 Beacon St, Unit 51",
    "parcel_id": "089-09-29",
    "owner1": "ZIMETBAUM, PETER",
    "owner2": "",
    "current_taxes": 10275.08,
    "new_taxes_no_override": 10718.96,
    "override_total_1": 11023.11,
    "override_increase_1": 304.14
  },
  {
    "#": "1514 Beacon St, Unit 52 (089-09-30)",
    "$": 560700,
    "address": "1514 Beacon St, Unit 52",
    "parcel_id": "089-09-30",
    "owner1": "RUNCK, BRIAN C",
    "owner2": "",
    "current_taxes": 5741.57,
    "new_taxes_no_override": 5989.61,
    "override_total_1": 6159.56,
    "override_increase_1": 169.95
  },
  {
    "#": "1514 Beacon St, Unit 53 (089-09-31)",
    "$": 1021700,
    "address": "1514 Beacon St, Unit 53",
    "parcel_id": "089-09-31",
    "owner1": "WILLIAMS, STEPHEN A",
    "owner2": "",
    "current_taxes": 10462.21,
    "new_taxes_no_override": 10914.18,
    "override_total_1": 11223.86,
    "override_increase_1": 309.68
  },
  {
    "#": "1514 Beacon St, Unit 54 (089-09-32)",
    "$": 1139900,
    "address": "1514 Beacon St, Unit 54",
    "parcel_id": "089-09-32",
    "owner1": "WANG, PETER",
    "owner2": "HAINES, HEATHER",
    "current_taxes": 8037.64,
    "new_taxes_no_override": 8384.87,
    "override_total_1": 8622.78,
    "override_increase_1": 237.91
  },
  {
    "#": "1514 Beacon St, Unit 55 (089-09-33)",
    "$": 922700,
    "address": "1514 Beacon St, Unit 55",
    "parcel_id": "089-09-33",
    "owner1": "ODONNELL TRS, C PATRICK JR & KENDRA STEARNS",
    "owner2": "",
    "current_taxes": 9448.45,
    "new_taxes_no_override": 9856.62,
    "override_total_1": 10136.3,
    "override_increase_1": 279.67
  },
  {
    "#": "1514 Beacon St, Unit 56 (089-09-34)",
    "$": 949300,
    "address": "1514 Beacon St, Unit 56",
    "parcel_id": "089-09-34",
    "owner1": "ODONNELL TRS, C PATRICK JR & KENDRA STEARNS",
    "owner2": "",
    "current_taxes": 9720.83,
    "new_taxes_no_override": 10140.77,
    "override_total_1": 10428.51,
    "override_increase_1": 287.74
  },
  {
    "#": "1514 Beacon St, Unit 57 (089-09-35)",
    "$": 629300,
    "address": "1514 Beacon St, Unit 57",
    "parcel_id": "089-09-35",
    "owner1": "YAO, TZY JYUN",
    "owner2": "",
    "current_taxes": 6444.03,
    "new_taxes_no_override": 6722.41,
    "override_total_1": 6913.16,
    "override_increase_1": 190.74
  },
  {
    "#": "1514 Beacon St, Unit 58 (089-09-36)",
    "$": 1426800,
    "address": "1514 Beacon St, Unit 58",
    "parcel_id": "089-09-36",
    "owner1": "YAO, TZY JYUN",
    "owner2": "",
    "current_taxes": 10975.5,
    "new_taxes_no_override": 11449.64,
    "override_total_1": 11774.52,
    "override_increase_1": 324.87
  },
  {
    "#": "1514 Beacon St, Unit 8 (089-09-03)",
    "$": 983700,
    "address": "1514 Beacon St, Unit 8",
    "parcel_id": "089-09-03",
    "owner1": "BENJAMIN, MICHAEL S & RONNA C",
    "owner2": "",
    "current_taxes": 6438.15,
    "new_taxes_no_override": 6716.28,
    "override_total_1": 6906.85,
    "override_increase_1": 190.57
  },
  {
    "#": "1514 Beacon St, Unit 9 (089-09-04)",
    "$": 445300,
    "address": "1514 Beacon St, Unit 9",
    "parcel_id": "089-09-04",
    "owner1": "BENJAMIN, MICHAEL S & RONNA C",
    "owner2": "",
    "current_taxes": 4559.87,
    "new_taxes_no_override": 4756.86,
    "override_total_1": 4891.83,
    "override_increase_1": 134.97
  },
  {
    "#": "1514 Beacon St, Unit P1 (089-09-37)",
    "$": 114000,
    "address": "1514 Beacon St, Unit P1",
    "parcel_id": "089-09-37",
    "owner1": "GRINEV, ELENA",
    "owner2": "",
    "current_taxes": 1167.36,
    "new_taxes_no_override": 1217.79,
    "override_total_1": 1252.34,
    "override_increase_1": 34.55
  },
  {
    "#": "1514 Beacon St, Unit P10 (089-09-46)",
    "$": 114000,
    "address": "1514 Beacon St, Unit P10",
    "parcel_id": "089-09-46",
    "owner1": "GELLER, JESSE",
    "owner2": "",
    "current_taxes": 1167.36,
    "new_taxes_no_override": 1217.79,
    "override_total_1": 1252.34,
    "override_increase_1": 34.55
  },
  {
    "#": "1514 Beacon St, Unit P11 (089-09-47)",
    "$": 114000,
    "address": "1514 Beacon St, Unit P11",
    "parcel_id": "089-09-47",
    "owner1": "HOLTZ, ANDREW A & ROBIN",
    "owner2": "",
    "current_taxes": 1167.36,
    "new_taxes_no_override": 1217.79,
    "override_total_1": 1252.34,
    "override_increase_1": 34.55
  },
  {
    "#": "1514 Beacon St, Unit P12 (089-09-48)",
    "$": 114000,
    "address": "1514 Beacon St, Unit P12",
    "parcel_id": "089-09-48",
    "owner1": "LIPPE, WENDY",
    "owner2": "",
    "current_taxes": 1167.36,
    "new_taxes_no_override": 1217.79,
    "override_total_1": 1252.34,
    "override_increase_1": 34.55
  },
  {
    "#": "1514 Beacon St, Unit P13 (089-09-49)",
    "$": 114000,
    "address": "1514 Beacon St, Unit P13",
    "parcel_id": "089-09-49",
    "owner1": "ODONNELL TRS, C PATRICK JR & KENDRA STEARNS",
    "owner2": "",
    "current_taxes": 1167.36,
    "new_taxes_no_override": 1217.79,
    "override_total_1": 1252.34,
    "override_increase_1": 34.55
  },
  {
    "#": "1514 Beacon St, Unit P14 (089-09-50)",
    "$": 114000,
    "address": "1514 Beacon St, Unit P14",
    "parcel_id": "089-09-50",
    "owner1": "MEGALE TR, MEGAN A",
    "owner2": "",
    "current_taxes": 1167.36,
    "new_taxes_no_override": 1217.79,
    "override_total_1": 1252.34,
    "override_increase_1": 34.55
  },
  {
    "#": "1514 Beacon St, Unit P15 (089-09-51)",
    "$": 114000,
    "address": "1514 Beacon St, Unit P15",
    "parcel_id": "089-09-51",
    "owner1": "ZHU, MIRIAM YUNLING",
    "owner2": "",
    "current_taxes": 1167.36,
    "new_taxes_no_override": 1217.79,
    "override_total_1": 1252.34,
    "override_increase_1": 34.55
  },
  {
    "#": "1514 Beacon St, Unit P16 (089-09-52)",
    "$": 114000,
    "address": "1514 Beacon St, Unit P16",
    "parcel_id": "089-09-52",
    "owner1": "ALBAN TRS, LUDWIG & MARSHA",
    "owner2": "",
    "current_taxes": 1167.36,
    "new_taxes_no_override": 1217.79,
    "override_total_1": 1252.34,
    "override_increase_1": 34.55
  },
  {
    "#": "1514 Beacon St, Unit P17 (089-09-53)",
    "$": 114000,
    "address": "1514 Beacon St, Unit P17",
    "parcel_id": "089-09-53",
    "owner1": "WANG, PETER",
    "owner2": "HAINES, HEATHER",
    "current_taxes": 1167.36,
    "new_taxes_no_override": 1217.79,
    "override_total_1": 1252.34,
    "override_increase_1": 34.55
  },
  {
    "#": "1514 Beacon St, Unit P18 (089-09-54)",
    "$": 114000,
    "address": "1514 Beacon St, Unit P18",
    "parcel_id": "089-09-54",
    "owner1": "ROZOVSKY, ANATOLY",
    "owner2": "",
    "current_taxes": 1167.36,
    "new_taxes_no_override": 1217.79,
    "override_total_1": 1252.34,
    "override_increase_1": 34.55
  },
  {
    "#": "1514 Beacon St, Unit P19 (089-09-55)",
    "$": 114000,
    "address": "1514 Beacon St, Unit P19",
    "parcel_id": "089-09-55",
    "owner1": "BENJAMIN, MICHAEL S & RONNA C",
    "owner2": "",
    "current_taxes": 1167.36,
    "new_taxes_no_override": 1217.79,
    "override_total_1": 1252.34,
    "override_increase_1": 34.55
  },
  {
    "#": "1514 Beacon St, Unit P2 (089-09-38)",
    "$": 114000,
    "address": "1514 Beacon St, Unit P2",
    "parcel_id": "089-09-38",
    "owner1": "MILOUSHEFF, ZACK",
    "owner2": "DIMITRIEVA, DOBRINA",
    "current_taxes": 1167.36,
    "new_taxes_no_override": 1217.79,
    "override_total_1": 1252.34,
    "override_increase_1": 34.55
  },
  {
    "#": "1514 Beacon St, Unit P20 (089-09-56)",
    "$": 114000,
    "address": "1514 Beacon St, Unit P20",
    "parcel_id": "089-09-56",
    "owner1": "WHITE, DAN S & NANCY P",
    "owner2": "",
    "current_taxes": 1167.36,
    "new_taxes_no_override": 1217.79,
    "override_total_1": 1252.34,
    "override_increase_1": 34.55
  },
  {
    "#": "1514 Beacon St, Unit P21 (089-09-57)",
    "$": 114000,
    "address": "1514 Beacon St, Unit P21",
    "parcel_id": "089-09-57",
    "owner1": "BENJAMIN, MICHAEL S & RONNA C",
    "owner2": "",
    "current_taxes": 1167.36,
    "new_taxes_no_override": 1217.79,
    "override_total_1": 1252.34,
    "override_increase_1": 34.55
  },
  {
    "#": "1514 Beacon St, Unit P22 (089-09-58)",
    "$": 114000,
    "address": "1514 Beacon St, Unit P22",
    "parcel_id": "089-09-58",
    "owner1": "RIVAS, TRS, JANNETH M & ANA B",
    "owner2": "",
    "current_taxes": 1167.36,
    "new_taxes_no_override": 1217.79,
    "override_total_1": 1252.34,
    "override_increase_1": 34.55
  },
  {
    "#": "1514 Beacon St, Unit P23C (089-09-59)",
    "$": 114000,
    "address": "1514 Beacon St, Unit P23C",
    "parcel_id": "089-09-59",
    "owner1": "LYONS, SHARI M",
    "owner2": "",
    "current_taxes": 1167.36,
    "new_taxes_no_override": 1217.79,
    "override_total_1": 1252.34,
    "override_increase_1": 34.55
  },
  {
    "#": "1514 Beacon St, Unit P24 (089-09-60)",
    "$": 114000,
    "address": "1514 Beacon St, Unit P24",
    "parcel_id": "089-09-60",
    "owner1": "ODONNELL TRS, C PATRICK JR & KENDRA STEARNS",
    "owner2": "",
    "current_taxes": 1167.36,
    "new_taxes_no_override": 1217.79,
    "override_total_1": 1252.34,
    "override_increase_1": 34.55
  },
  {
    "#": "1514 Beacon St, Unit P25 (089-09-61)",
    "$": 114000,
    "address": "1514 Beacon St, Unit P25",
    "parcel_id": "089-09-61",
    "owner1": "LIPPE, WENDY",
    "owner2": "",
    "current_taxes": 1167.36,
    "new_taxes_no_override": 1217.79,
    "override_total_1": 1252.34,
    "override_increase_1": 34.55
  },
  {
    "#": "1514 Beacon St, Unit P26 (089-09-62)",
    "$": 114000,
    "address": "1514 Beacon St, Unit P26",
    "parcel_id": "089-09-62",
    "owner1": "ODONNELL TRS, C PATRICK JR & KENDRA STEARNS",
    "owner2": "",
    "current_taxes": 1167.36,
    "new_taxes_no_override": 1217.79,
    "override_total_1": 1252.34,
    "override_increase_1": 34.55
  },
  {
    "#": "1514 Beacon St, Unit P27 (089-09-63)",
    "$": 114000,
    "address": "1514 Beacon St, Unit P27",
    "parcel_id": "089-09-63",
    "owner1": "YAO, TZY JYUN",
    "owner2": "",
    "current_taxes": 1167.36,
    "new_taxes_no_override": 1217.79,
    "override_total_1": 1252.34,
    "override_increase_1": 34.55
  },
  {
    "#": "1514 Beacon St, Unit P28 (089-09-64)",
    "$": 114000,
    "address": "1514 Beacon St, Unit P28",
    "parcel_id": "089-09-64",
    "owner1": "YAO, TZY JYUN",
    "owner2": "",
    "current_taxes": 1167.36,
    "new_taxes_no_override": 1217.79,
    "override_total_1": 1252.34,
    "override_increase_1": 34.55
  },
  {
    "#": "1514 Beacon St, Unit P3 (089-09-39)",
    "$": 114000,
    "address": "1514 Beacon St, Unit P3",
    "parcel_id": "089-09-39",
    "owner1": "KIM, YONGBUM",
    "owner2": "",
    "current_taxes": 1167.36,
    "new_taxes_no_override": 1217.79,
    "override_total_1": 1252.34,
    "override_increase_1": 34.55
  },
  {
    "#": "1514 Beacon St, Unit P4 (089-09-40)",
    "$": 114000,
    "address": "1514 Beacon St, Unit P4",
    "parcel_id": "089-09-40",
    "owner1": "EASTANDK LLC",
    "owner2": "",
    "current_taxes": 1167.36,
    "new_taxes_no_override": 1217.79,
    "override_total_1": 1252.34,
    "override_increase_1": 34.55
  },
  {
    "#": "1514 Beacon St, Unit P5C (089-09-41)",
    "$": 114000,
    "address": "1514 Beacon St, Unit P5C",
    "parcel_id": "089-09-41",
    "owner1": "RIELY, ANDREW",
    "owner2": "",
    "current_taxes": 1167.36,
    "new_taxes_no_override": 1217.79,
    "override_total_1": 1252.34,
    "override_increase_1": 34.55
  },
  {
    "#": "1514 Beacon St, Unit P6 (089-09-42)",
    "$": 114000,
    "address": "1514 Beacon St, Unit P6",
    "parcel_id": "089-09-42",
    "owner1": "LIPPE, WENDY",
    "owner2": "",
    "current_taxes": 1167.36,
    "new_taxes_no_override": 1217.79,
    "override_total_1": 1252.34,
    "override_increase_1": 34.55
  },
  {
    "#": "1514 Beacon St, Unit P7 (089-09-43)",
    "$": 114000,
    "address": "1514 Beacon St, Unit P7",
    "parcel_id": "089-09-43",
    "owner1": "LEAVITT, JONATHAN P",
    "owner2": "FELLOWS, MARYJANE",
    "current_taxes": 1167.36,
    "new_taxes_no_override": 1217.79,
    "override_total_1": 1252.34,
    "override_increase_1": 34.55
  },
  {
    "#": "1514 Beacon St, Unit P8 (089-09-44)",
    "$": 114000,
    "address": "1514 Beacon St, Unit P8",
    "parcel_id": "089-09-44",
    "owner1": "LIPPE, WENDY",
    "owner2": "",
    "current_taxes": 1167.36,
    "new_taxes_no_override": 1217.79,
    "override_total_1": 1252.34,
    "override_increase_1": 34.55
  },
  {
    "#": "1514 Beacon St, Unit P9 (089-09-45)",
    "$": 114000,
    "address": "1514 Beacon St, Unit P9",
    "parcel_id": "089-09-45",
    "owner1": "ASHRAFI, NOUSIN",
    "owner2": "",
    "current_taxes": 1167.36,
    "new_taxes_no_override": 1217.79,
    "override_total_1": 1252.34,
    "override_increase_1": 34.55
  },
  {
    "#": "1515 Beacon St (214-14-00)",
    "$": 2850900,
    "address": "1515 Beacon St",
    "parcel_id": "214-14-00",
    "owner1": "YEE TR, NINOTCHKA Y P",
    "owner2": "",
    "current_taxes": 29193.22,
    "new_taxes_no_override": 30454.37,
    "override_total_1": 31318.49,
    "override_increase_1": 864.12
  },
  {
    "#": "1517 Beacon St, Unit 1 (214-13-01)",
    "$": 1324500,
    "address": "1517 Beacon St, Unit 1",
    "parcel_id": "214-13-01",
    "owner1": "GOODMAN, COLE ALEXANDER",
    "owner2": "MERCEDES, MIGUELINA",
    "current_taxes": 13562.88,
    "new_taxes_no_override": 14148.8,
    "override_total_1": 14550.26,
    "override_increase_1": 401.46
  },
  {
    "#": "1517 Beacon St, Unit 2 (214-13-02)",
    "$": 1834800,
    "address": "1517 Beacon St, Unit 2",
    "parcel_id": "214-13-02",
    "owner1": "WINTER, SUSAN WEINSTEIN & HARLAND S",
    "owner2": "",
    "current_taxes": 15153.42,
    "new_taxes_no_override": 15808.05,
    "override_total_1": 16256.59,
    "override_increase_1": 448.54
  },
  {
    "#": "1517 Beacon St, Unit 3 (214-13-03)",
    "$": 2140200,
    "address": "1517 Beacon St, Unit 3",
    "parcel_id": "214-13-03",
    "owner1": "MILNE TRS, JILL C & G TODD",
    "owner2": "",
    "current_taxes": 18280.71,
    "new_taxes_no_override": 19070.44,
    "override_total_1": 19611.55,
    "override_increase_1": 541.11
  },
  {
    "#": "1517 Beacon St, Unit 4 (214-13-04)",
    "$": 2144700,
    "address": "1517 Beacon St, Unit 4",
    "parcel_id": "214-13-04",
    "owner1": "SU, KEVIN",
    "owner2": "LIN, SHU YEN",
    "current_taxes": 21961.73,
    "new_taxes_no_override": 22910.48,
    "override_total_1": 23560.54,
    "override_increase_1": 650.07
  },
  {
    "#": "1519 Beacon St, Unit 1 (214-12-01)",
    "$": 1218700,
    "address": "1519 Beacon St, Unit 1",
    "parcel_id": "214-12-01",
    "owner1": "KANN, JACQUELINE",
    "owner2": "",
    "current_taxes": 8844.55,
    "new_taxes_no_override": 9226.63,
    "override_total_1": 9488.43,
    "override_increase_1": 261.8
  },
  {
    "#": "1519 Beacon St, Unit 2 (214-12-02)",
    "$": 1291600,
    "address": "1519 Beacon St, Unit 2",
    "parcel_id": "214-12-02",
    "owner1": "GORDON, AMY",
    "owner2": "ABRAMS, EDWARD N",
    "current_taxes": 9591.05,
    "new_taxes_no_override": 10005.38,
    "override_total_1": 10289.28,
    "override_increase_1": 283.9
  },
  {
    "#": "1519 Beacon St, Unit 3 & P3 (214-12-03)",
    "$": 1546200,
    "address": "1519 Beacon St, Unit 3 & P3",
    "parcel_id": "214-12-03",
    "owner1": "TRELSTAD, BRIAN & PIPER",
    "owner2": "",
    "current_taxes": 12198.15,
    "new_taxes_no_override": 12725.11,
    "override_total_1": 13086.18,
    "override_increase_1": 361.07
  },
  {
    "#": "1521 Beacon St, Unit 1 (214-11-03)",
    "$": 1262800,
    "address": "1521 Beacon St, Unit 1",
    "parcel_id": "214-11-03",
    "owner1": "CASSIS, BEATRICE BORNO",
    "owner2": "FOELL, DAVID V",
    "current_taxes": 12931.07,
    "new_taxes_no_override": 13489.69,
    "override_total_1": 13872.45,
    "override_increase_1": 382.76
  },
  {
    "#": "1521 Beacon St, Unit 2 & G2 (214-11-01)",
    "$": 1351700,
    "address": "1521 Beacon St, Unit 2 & G2",
    "parcel_id": "214-11-01",
    "owner1": "MCGRAW TR, HARRIET B",
    "owner2": "",
    "current_taxes": 10206.47,
    "new_taxes_no_override": 10647.39,
    "override_total_1": 10949.5,
    "override_increase_1": 302.11
  },
  {
    "#": "1521 Beacon St, Unit 3 (214-11-02)",
    "$": 1360600,
    "address": "1521 Beacon St, Unit 3",
    "parcel_id": "214-11-02",
    "owner1": "CASSIS, BEATRICE S",
    "owner2": "",
    "current_taxes": 10297.61,
    "new_taxes_no_override": 10742.47,
    "override_total_1": 11047.28,
    "override_increase_1": 304.81
  },
  {
    "#": "1525 Beacon St (214-10-00)",
    "$": 5130700,
    "address": "1525 Beacon St",
    "parcel_id": "214-10-00",
    "owner1": "MELIKIAN-CATE TRS, JOANNE P",
    "owner2": "SHIPMAN TRS, ADAM KNIGHT",
    "current_taxes": 52538.37,
    "new_taxes_no_override": 54808.03,
    "override_total_1": 56363.16,
    "override_increase_1": 1555.14
  },
  {
    "#": "1529 Beacon St (214-09-01)",
    "$": 885000,
    "address": "1529 Beacon St",
    "parcel_id": "214-09-01",
    "owner1": "LANA REALTY 1529 LLC",
    "owner2": "",
    "current_taxes": 9062.4,
    "new_taxes_no_override": 9453.9,
    "override_total_1": 9722.14,
    "override_increase_1": 268.25
  },
  {
    "#": "1530 Beacon St (089-10-00)",
    "$": 51256900,
    "address": "1530 Beacon St",
    "parcel_id": "089-10-00",
    "owner1": "BROOKLINE BARCLAY HOUSE LLC",
    "owner2": "C/O JENNIFER MCCART",
    "current_taxes": 524870.66,
    "new_taxes_no_override": 547545.07,
    "override_total_1": 563081.24,
    "override_increase_1": 15536.17
  },
  {
    "#": "1531 Beacon St (214-09-00)",
    "$": 2392300,
    "address": "1531 Beacon St",
    "parcel_id": "214-09-00",
    "owner1": "ARNFELD, LEO & LORRAINE N",
    "owner2": "",
    "current_taxes": 20862.22,
    "new_taxes_no_override": 21763.47,
    "override_total_1": 22380.99,
    "override_increase_1": 617.52
  },
  {
    "#": "1537 Beacon St (214-08-00)",
    "$": 4077000,
    "address": "1537 Beacon St",
    "parcel_id": "214-08-00",
    "owner1": "1537 BEACON STREET LLC",
    "owner2": "",
    "current_taxes": 41748.48,
    "new_taxes_no_override": 43552.01,
    "override_total_1": 44787.77,
    "override_increase_1": 1235.76
  },
  {
    "#": "1550 Beacon St (091-01-00)",
    "$": 46041700,
    "address": "1550 Beacon St",
    "parcel_id": "091-01-00",
    "owner1": "HRCA BROOKLINE HSNG",
    "owner2": "",
    "current_taxes": 503398.17,
    "new_taxes_no_override": 525144.97,
    "override_total_1": 540045.56,
    "override_increase_1": 14900.59
  },
  {
    "#": "1555 Beacon St (215-23-00)",
    "$": 5189800,
    "address": "1555 Beacon St",
    "parcel_id": "215-23-00",
    "owner1": "PARVIS CENTER LLC ET AL",
    "owner2": "SYROOS HYSLOP LLC",
    "current_taxes": 53143.55,
    "new_taxes_no_override": 55439.35,
    "override_total_1": 57012.4,
    "override_increase_1": 1573.05
  },
  {
    "#": "1559 Beacon St (215-22-00)",
    "$": 3448100,
    "address": "1559 Beacon St",
    "parcel_id": "215-22-00",
    "owner1": "CHOW TR, JOHN J",
    "owner2": "",
    "current_taxes": 31673.61,
    "new_taxes_no_override": 33041.91,
    "override_total_1": 33979.45,
    "override_increase_1": 937.54
  },
  {
    "#": "1561 Beacon St (215-21-00)",
    "$": 3808000,
    "address": "1561 Beacon St",
    "parcel_id": "215-21-00",
    "owner1": "CHOW TR, JOHN J",
    "owner2": "",
    "current_taxes": 38993.92,
    "new_taxes_no_override": 40678.46,
    "override_total_1": 41832.68,
    "override_increase_1": 1154.22
  },
  {
    "#": "1563 Beacon St, Unit 1 (215-20-03)",
    "$": 1069600,
    "address": "1563 Beacon St, Unit 1",
    "parcel_id": "215-20-03",
    "owner1": "MARTIN, JOHN CHRISTOPHER G",
    "owner2": "MURRAY, TARA",
    "current_taxes": 7317.77,
    "new_taxes_no_override": 7633.9,
    "override_total_1": 7850.5,
    "override_increase_1": 216.61
  },
  {
    "#": "1563 Beacon St, Unit 2 (215-20-01)",
    "$": 1099500,
    "address": "1563 Beacon St, Unit 2",
    "parcel_id": "215-20-01",
    "owner1": "MUSHLIN, LEONARD & DALE",
    "owner2": "",
    "current_taxes": 7623.95,
    "new_taxes_no_override": 7953.3,
    "override_total_1": 8178.97,
    "override_increase_1": 225.67
  },
  {
    "#": "1563 Beacon St, Unit 3 (215-20-02)",
    "$": 1226100,
    "address": "1563 Beacon St, Unit 3",
    "parcel_id": "215-20-02",
    "owner1": "BOGDANOV, ALEXANDER",
    "owner2": "WONG, LOVIE",
    "current_taxes": 8920.33,
    "new_taxes_no_override": 9305.69,
    "override_total_1": 9569.73,
    "override_increase_1": 264.04
  },
  {
    "#": "1566 Beacon St (091-03-00)",
    "$": 5926800,
    "address": "1566 Beacon St",
    "parcel_id": "091-03-00",
    "owner1": "TEMPLE BETH ZION",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "1569 Beacon St (215-19-00)",
    "$": 12096000,
    "address": "1569 Beacon St",
    "parcel_id": "215-19-00",
    "owner1": "MAJESTIC LIMITED PARTNERSHIP",
    "owner2": "",
    "current_taxes": 123863.04,
    "new_taxes_no_override": 129213.92,
    "override_total_1": 132880.27,
    "override_increase_1": 3666.35
  },
  {
    "#": "1572 Beacon St (091-04-00)",
    "$": 2243000,
    "address": "1572 Beacon St",
    "parcel_id": "091-04-00",
    "owner1": "BIRGER, GAIL",
    "owner2": "C/O KEPNES",
    "current_taxes": 22968.32,
    "new_taxes_no_override": 23960.55,
    "override_total_1": 24640.41,
    "override_increase_1": 679.86
  },
  {
    "#": "1574 Beacon St, Unit 1 (091-05-01)",
    "$": 1983100,
    "address": "1574 Beacon St, Unit 1",
    "parcel_id": "091-05-01",
    "owner1": "BORDERS QUARTERS LLC",
    "owner2": "",
    "current_taxes": 20306.94,
    "new_taxes_no_override": 21184.2,
    "override_total_1": 21785.29,
    "override_increase_1": 601.09
  },
  {
    "#": "1574 Beacon St, Unit 2 (091-05-02)",
    "$": 2536000,
    "address": "1574 Beacon St, Unit 2",
    "parcel_id": "091-05-02",
    "owner1": "PARGENDLER, MARIANA",
    "owner2": "",
    "current_taxes": 25968.64,
    "new_taxes_no_override": 27090.49,
    "override_total_1": 27859.16,
    "override_increase_1": 768.67
  },
  {
    "#": "1574 Beacon St, Unit 3 (091-05-03)",
    "$": 627000,
    "address": "1574 Beacon St, Unit 3",
    "parcel_id": "091-05-03",
    "owner1": "COHEN, OHAD",
    "owner2": "BIJUR, ANSUYA",
    "current_taxes": 6420.48,
    "new_taxes_no_override": 6697.84,
    "override_total_1": 6887.89,
    "override_increase_1": 190.05
  },
  {
    "#": "1575 Beacon St, Unit 1F & P3 (215-18-02)",
    "$": 623000,
    "address": "1575 Beacon St, Unit 1F & P3",
    "parcel_id": "215-18-02",
    "owner1": "1575 BEACON ST 1F LLC",
    "owner2": "",
    "current_taxes": 6379.52,
    "new_taxes_no_override": 6655.12,
    "override_total_1": 6843.95,
    "override_increase_1": 188.83
  },
  {
    "#": "1575 Beacon St, Unit 1R & P5 (215-18-03)",
    "$": 796200,
    "address": "1575 Beacon St, Unit 1R & P5",
    "parcel_id": "215-18-03",
    "owner1": "BENNETT, TR, BARBARA J",
    "owner2": "",
    "current_taxes": 4518.15,
    "new_taxes_no_override": 4713.33,
    "override_total_1": 4847.07,
    "override_increase_1": 133.74
  },
  {
    "#": "1575 Beacon St, Unit 2F & P4 (215-18-04)",
    "$": 675300,
    "address": "1575 Beacon St, Unit 2F & P4",
    "parcel_id": "215-18-04",
    "owner1": "1575 BEACON STREET REALTY LLC",
    "owner2": "",
    "current_taxes": 6915.07,
    "new_taxes_no_override": 7213.8,
    "override_total_1": 7418.49,
    "override_increase_1": 204.69
  },
  {
    "#": "1575 Beacon St, Unit 2R & P1 (215-18-05)",
    "$": 747800,
    "address": "1575 Beacon St, Unit 2R & P1",
    "parcel_id": "215-18-05",
    "owner1": "TAIEB, ERIC G & SHARONA",
    "owner2": "",
    "current_taxes": 7657.47,
    "new_taxes_no_override": 7988.27,
    "override_total_1": 8214.93,
    "override_increase_1": 226.66
  },
  {
    "#": "1575 Beacon St, Unit 3F & P6 (215-18-06)",
    "$": 773600,
    "address": "1575 Beacon St, Unit 3F & P6",
    "parcel_id": "215-18-06",
    "owner1": "LISS, ALAN S",
    "owner2": "",
    "current_taxes": 7921.66,
    "new_taxes_no_override": 8263.88,
    "override_total_1": 8498.36,
    "override_increase_1": 234.48
  },
  {
    "#": "1575 Beacon St, Unit 3R & P7 (215-18-07)",
    "$": 606000,
    "address": "1575 Beacon St, Unit 3R & P7",
    "parcel_id": "215-18-07",
    "owner1": "NICHOLS, HAROLD F JR & CAROLANNE L",
    "owner2": "",
    "current_taxes": 6205.44,
    "new_taxes_no_override": 6473.52,
    "override_total_1": 6657.2,
    "override_increase_1": 183.68
  },
  {
    "#": "1575 Beacon St, Unit Br & P2 (215-18-01)",
    "$": 437200,
    "address": "1575 Beacon St, Unit Br & P2",
    "parcel_id": "215-18-01",
    "owner1": "VAZQUEZ, RAFAEL",
    "owner2": "",
    "current_taxes": 4476.93,
    "new_taxes_no_override": 4670.33,
    "override_total_1": 4802.85,
    "override_increase_1": 132.52
  },
  {
    "#": "1577 Beacon St (215-17-00)",
    "$": 2895200,
    "address": "1577 Beacon St",
    "parcel_id": "215-17-00",
    "owner1": "SCHMAHMANN REALTY LLC",
    "owner2": "C/O SCHMAHMANN DAVID",
    "current_taxes": 49681.63,
    "new_taxes_no_override": 51827.88,
    "override_total_1": 53298.45,
    "override_increase_1": 1470.58
  },
  {
    "#": "1578 Beacon St (091-06-00)",
    "$": 6382300,
    "address": "1578 Beacon St",
    "parcel_id": "091-06-00",
    "owner1": "MHRE LLC TR",
    "owner2": "C/O ATLAS GROUP",
    "current_taxes": 65354.75,
    "new_taxes_no_override": 68178.08,
    "override_total_1": 70112.58,
    "override_increase_1": 1934.5
  },
  {
    "#": "1580 Beacon St (091-06-01)",
    "$": 2797100,
    "address": "1580 Beacon St",
    "parcel_id": "091-06-01",
    "owner1": "MHRE LLC TR",
    "owner2": "C/O ATLAS GROUP",
    "current_taxes": 28642.3,
    "new_taxes_no_override": 29879.65,
    "override_total_1": 30727.46,
    "override_increase_1": 847.81
  },
  {
    "#": "1581 Beacon St, Unit 1 (215-16-01)",
    "$": 1331500,
    "address": "1581 Beacon St, Unit 1",
    "parcel_id": "215-16-01",
    "owner1": "BOSTON CENTER FOR MODERN",
    "owner2": "PSYCHOANALYTIC STUDIES INC",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "1581 Beacon St, Unit 2 (215-16-02)",
    "$": 1361100,
    "address": "1581 Beacon St, Unit 2",
    "parcel_id": "215-16-02",
    "owner1": "BOSTON CENTER FOR MODERN",
    "owner2": "PSYCHOANALYTIC STUDIES INC",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "1581 Beacon St, Unit 3 (215-16-03)",
    "$": 286000,
    "address": "1581 Beacon St, Unit 3",
    "parcel_id": "215-16-03",
    "owner1": "BOSTON CENTER FOR MODERN",
    "owner2": "PSYCHOANALYTIC STUDIES INC",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "1581 Beacon St, Unit 4 (215-16-04)",
    "$": 2079200,
    "address": "1581 Beacon St, Unit 4",
    "parcel_id": "215-16-04",
    "owner1": "BOSTON CENTER FOR MODERN",
    "owner2": "PSYCHOANALYTIC STUDIES INC",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "1581 Beacon St, Unit 5 (215-16-05)",
    "$": 2184100,
    "address": "1581 Beacon St, Unit 5",
    "parcel_id": "215-16-05",
    "owner1": "SHARAF TR, ALAN B",
    "owner2": "",
    "current_taxes": 37479.16,
    "new_taxes_no_override": 39098.26,
    "override_total_1": 40207.64,
    "override_increase_1": 1109.38
  },
  {
    "#": "1581 Beacon St, Unit 6 (215-16-06)",
    "$": 1259000,
    "address": "1581 Beacon St, Unit 6",
    "parcel_id": "215-16-06",
    "owner1": "BOSTON CENTER FOR MODERN",
    "owner2": "PSYCHOANALYTIC STUDIES INC",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "1581 Beacon St, Unit 7 (215-16-07)",
    "$": 1179200,
    "address": "1581 Beacon St, Unit 7",
    "parcel_id": "215-16-07",
    "owner1": "BOSTON CENTER FOR MODERN",
    "owner2": "PSYCHOANALYTIC STUDIES INC",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "1584 Beacon St, Unit 1 (091-06-04)",
    "$": 983600,
    "address": "1584 Beacon St, Unit 1",
    "parcel_id": "091-06-04",
    "owner1": "RANDHAWA, KARANDEEP",
    "owner2": "SAVANT, DEVINA",
    "current_taxes": 10072.06,
    "new_taxes_no_override": 10507.17,
    "override_total_1": 10805.31,
    "override_increase_1": 298.13
  },
  {
    "#": "1584 Beacon St, Unit 2 (091-06-05)",
    "$": 973400,
    "address": "1584 Beacon St, Unit 2",
    "parcel_id": "091-06-05",
    "owner1": "ELIAS, ERIC & CAREN KRAMER",
    "owner2": "",
    "current_taxes": 6332.68,
    "new_taxes_no_override": 6606.25,
    "override_total_1": 6793.7,
    "override_increase_1": 187.45
  },
  {
    "#": "1584 Beacon St, Unit 3 (091-06-06)",
    "$": 980200,
    "address": "1584 Beacon St, Unit 3",
    "parcel_id": "091-06-06",
    "owner1": "PHIMISTER, ELIZABETH G",
    "owner2": "",
    "current_taxes": 6402.31,
    "new_taxes_no_override": 6678.89,
    "override_total_1": 6868.4,
    "override_increase_1": 189.51
  },
  {
    "#": "1584 Beacon St, Unit A (091-06-03)",
    "$": 491700,
    "address": "1584 Beacon St, Unit A",
    "parcel_id": "091-06-03",
    "owner1": "JIANG, KEXUAN",
    "owner2": "",
    "current_taxes": 1400.07,
    "new_taxes_no_override": 1460.55,
    "override_total_1": 1502.0,
    "override_increase_1": 41.44
  },
  {
    "#": "1588 Beacon St, Unit 1 (091-07-03)",
    "$": 1024200,
    "address": "1588 Beacon St, Unit 1",
    "parcel_id": "091-07-03",
    "owner1": "SOOD, ASHOK K",
    "owner2": "ROSIN, SVETLANA",
    "current_taxes": 6852.87,
    "new_taxes_no_override": 7148.91,
    "override_total_1": 7351.76,
    "override_increase_1": 202.84
  },
  {
    "#": "1588 Beacon St, Unit 2 (091-07-04)",
    "$": 1032500,
    "address": "1588 Beacon St, Unit 2",
    "parcel_id": "091-07-04",
    "owner1": "GURELI, ROYSI",
    "owner2": "",
    "current_taxes": 6937.87,
    "new_taxes_no_override": 7237.59,
    "override_total_1": 7442.95,
    "override_increase_1": 205.36
  },
  {
    "#": "1588 Beacon St, Unit 3 (091-07-05)",
    "$": 1040200,
    "address": "1588 Beacon St, Unit 3",
    "parcel_id": "091-07-05",
    "owner1": "KHATCHATRIAN TRS, VAROUJAN",
    "owner2": "ARAZYAN, ALVARD",
    "current_taxes": 7016.71,
    "new_taxes_no_override": 7319.83,
    "override_total_1": 7527.53,
    "override_increase_1": 207.69
  },
  {
    "#": "1588 Beacon St, Unit G (091-07-02)",
    "$": 440100,
    "address": "1588 Beacon St, Unit G",
    "parcel_id": "091-07-02",
    "owner1": "HAZEN, ERIC S",
    "owner2": "STOUTLAND, SARA E",
    "current_taxes": 4506.62,
    "new_taxes_no_override": 4701.31,
    "override_total_1": 4834.7,
    "override_increase_1": 133.4
  },
  {
    "#": "1589 Beacon St (215-14-15)",
    "$": 14632400,
    "address": "1589 Beacon St",
    "parcel_id": "215-14-15",
    "owner1": "BEACON 1589 ASSOC LLC",
    "owner2": "C/O FINEBERG MANAGEMENT INC",
    "current_taxes": 149835.78,
    "new_taxes_no_override": 156308.69,
    "override_total_1": 160743.82,
    "override_increase_1": 4435.14
  },
  {
    "#": "1592 Beacon St (091-07-01)",
    "$": 3658400,
    "address": "1592 Beacon St",
    "parcel_id": "091-07-01",
    "owner1": "1592 BEACON ST LLC",
    "owner2": "C/O DARROW EVERETT",
    "current_taxes": 37462.02,
    "new_taxes_no_override": 39080.38,
    "override_total_1": 40189.26,
    "override_increase_1": 1108.88
  },
  {
    "#": "1600 Beacon St, Unit 1001 & G39 (091-69-04)",
    "$": 908300,
    "address": "1600 Beacon St, Unit 1001 & G39",
    "parcel_id": "091-69-04",
    "owner1": "SHMOLAK TRS, BLUMIT",
    "owner2": "RABINOVICH, AKIVA E",
    "current_taxes": 9300.99,
    "new_taxes_no_override": 9702.79,
    "override_total_1": 9978.1,
    "override_increase_1": 275.31
  },
  {
    "#": "1600 Beacon St, Unit 1002 & G44 (091-69-05)",
    "$": 911400,
    "address": "1600 Beacon St, Unit 1002 & G44",
    "parcel_id": "091-69-05",
    "owner1": "LILUO LLC",
    "owner2": "",
    "current_taxes": 9332.74,
    "new_taxes_no_override": 9735.91,
    "override_total_1": 10012.16,
    "override_increase_1": 276.25
  },
  {
    "#": "1600 Beacon St, Unit 1003 & G93 (091-69-06)",
    "$": 775700,
    "address": "1600 Beacon St, Unit 1003 & G93",
    "parcel_id": "091-69-06",
    "owner1": "WHITE, DAVID S",
    "owner2": "",
    "current_taxes": 4308.23,
    "new_taxes_no_override": 4494.35,
    "override_total_1": 4621.87,
    "override_increase_1": 127.52
  },
  {
    "#": "1600 Beacon St, Unit 1004 & G10 (091-69-07)",
    "$": 612600,
    "address": "1600 Beacon St, Unit 1004 & G10",
    "parcel_id": "091-69-07",
    "owner1": "BOZDOGAN, SIBEL",
    "owner2": "PARSONS, SINAN BOZDOGAN",
    "current_taxes": 2638.09,
    "new_taxes_no_override": 2752.06,
    "override_total_1": 2830.14,
    "override_increase_1": 78.09
  },
  {
    "#": "1600 Beacon St, Unit 1005 & G28 (091-69-08)",
    "$": 755300,
    "address": "1600 Beacon St, Unit 1005 & G28",
    "parcel_id": "091-69-08",
    "owner1": "BECKER, AMY",
    "owner2": "",
    "current_taxes": 4099.34,
    "new_taxes_no_override": 4276.43,
    "override_total_1": 4397.77,
    "override_increase_1": 121.34
  },
  {
    "#": "1600 Beacon St, Unit 1006 & G42 (091-69-09)",
    "$": 1006600,
    "address": "1600 Beacon St, Unit 1006 & G42",
    "parcel_id": "091-69-09",
    "owner1": "PU, LIQUN",
    "owner2": "",
    "current_taxes": 10307.58,
    "new_taxes_no_override": 10752.87,
    "override_total_1": 11057.97,
    "override_increase_1": 305.1
  },
  {
    "#": "1600 Beacon St, Unit 1007 & G35 (091-69-10)",
    "$": 689200,
    "address": "1600 Beacon St, Unit 1007 & G35",
    "parcel_id": "091-69-10",
    "owner1": "BICE, SARAH L & STEVEN K",
    "owner2": "",
    "current_taxes": 3422.47,
    "new_taxes_no_override": 3570.32,
    "override_total_1": 3671.63,
    "override_increase_1": 101.31
  },
  {
    "#": "1600 Beacon St, Unit 1008 & G94 (091-69-11)",
    "$": 792600,
    "address": "1600 Beacon St, Unit 1008 & G94",
    "parcel_id": "091-69-11",
    "owner1": "EVCIMEN, AYHAN & NET",
    "owner2": "",
    "current_taxes": 8116.22,
    "new_taxes_no_override": 8466.84,
    "override_total_1": 8707.08,
    "override_increase_1": 240.24
  },
  {
    "#": "1600 Beacon St, Unit 1009 & G19 (091-69-12)",
    "$": 757000,
    "address": "1600 Beacon St, Unit 1009 & G19",
    "parcel_id": "091-69-12",
    "owner1": "1600 BEACON SHULKIN LLC",
    "owner2": "",
    "current_taxes": 7751.68,
    "new_taxes_no_override": 8086.55,
    "override_total_1": 8316.0,
    "override_increase_1": 229.45
  },
  {
    "#": "1600 Beacon St, Unit 101 (091-08-01)",
    "$": 541500,
    "address": "1600 Beacon St, Unit 101",
    "parcel_id": "091-08-01",
    "owner1": "MARCUS TRS, SANDRA E",
    "owner2": "ONEILL, CHARLES T",
    "current_taxes": 5544.96,
    "new_taxes_no_override": 5784.5,
    "override_total_1": 5948.63,
    "override_increase_1": 164.13
  },
  {
    "#": "1600 Beacon St, Unit 1010 & G27 (091-69-13)",
    "$": 792000,
    "address": "1600 Beacon St, Unit 1010 & G27",
    "parcel_id": "091-69-13",
    "owner1": "NG TRS, FRANK M & JEANNE H",
    "owner2": "",
    "current_taxes": 8110.08,
    "new_taxes_no_override": 8460.44,
    "override_total_1": 8700.49,
    "override_increase_1": 240.06
  },
  {
    "#": "1600 Beacon St, Unit 1011 & G63 (091-69-14)",
    "$": 905200,
    "address": "1600 Beacon St, Unit 1011 & G63",
    "parcel_id": "091-69-14",
    "owner1": "FIRST KEY REALTY LLC",
    "owner2": "",
    "current_taxes": 9269.25,
    "new_taxes_no_override": 9669.68,
    "override_total_1": 9944.05,
    "override_increase_1": 274.37
  },
  {
    "#": "1600 Beacon St, Unit 1012 & G45 (091-69-15)",
    "$": 905200,
    "address": "1600 Beacon St, Unit 1012 & G45",
    "parcel_id": "091-69-15",
    "owner1": "ANSE LLC",
    "owner2": "",
    "current_taxes": 9269.25,
    "new_taxes_no_override": 9669.68,
    "override_total_1": 9944.05,
    "override_increase_1": 274.37
  },
  {
    "#": "1600 Beacon St, Unit 102 (091-08-02)",
    "$": 403800,
    "address": "1600 Beacon St, Unit 102",
    "parcel_id": "091-08-02",
    "owner1": "KIM, JUNGSOO",
    "owner2": "",
    "current_taxes": 499.98,
    "new_taxes_no_override": 521.58,
    "override_total_1": 536.38,
    "override_increase_1": 14.8
  },
  {
    "#": "1600 Beacon St, Unit 103 (091-08-03)",
    "$": 514400,
    "address": "1600 Beacon St, Unit 103",
    "parcel_id": "091-08-03",
    "owner1": "LIEBMANN TRS, JUDITH K",
    "owner2": "GIBSON TR, MARSHAL D",
    "current_taxes": 5267.46,
    "new_taxes_no_override": 5495.01,
    "override_total_1": 5650.93,
    "override_increase_1": 155.92
  },
  {
    "#": "1600 Beacon St, Unit 104 (091-08-04)",
    "$": 438900,
    "address": "1600 Beacon St, Unit 104",
    "parcel_id": "091-08-04",
    "owner1": "ROBILLARD, CHRISTOPHER L",
    "owner2": "",
    "current_taxes": 4494.34,
    "new_taxes_no_override": 4688.5,
    "override_total_1": 4821.53,
    "override_increase_1": 133.03
  },
  {
    "#": "1600 Beacon St, Unit 105 (091-08-05)",
    "$": 402400,
    "address": "1600 Beacon St, Unit 105",
    "parcel_id": "091-08-05",
    "owner1": "YU, ZHI",
    "owner2": "",
    "current_taxes": 485.64,
    "new_taxes_no_override": 506.62,
    "override_total_1": 520.99,
    "override_increase_1": 14.37
  },
  {
    "#": "1600 Beacon St, Unit 106 (091-08-06)",
    "$": 207200,
    "address": "1600 Beacon St, Unit 106",
    "parcel_id": "091-08-06",
    "owner1": "LAPKIN, MARINA",
    "owner2": "",
    "current_taxes": 212.17,
    "new_taxes_no_override": 221.34,
    "override_total_1": 227.62,
    "override_increase_1": 6.28
  },
  {
    "#": "1600 Beacon St, Unit 107 (091-08-07)",
    "$": 263600,
    "address": "1600 Beacon St, Unit 107",
    "parcel_id": "091-08-07",
    "owner1": "WONG, MIMI N",
    "owner2": "",
    "current_taxes": 269.93,
    "new_taxes_no_override": 281.59,
    "override_total_1": 289.58,
    "override_increase_1": 7.99
  },
  {
    "#": "1600 Beacon St, Unit 1101 & G37 (091-69-16)",
    "$": 929600,
    "address": "1600 Beacon St, Unit 1101 & G37",
    "parcel_id": "091-69-16",
    "owner1": "CIEPLINSKA, AGNIESZKA",
    "owner2": "",
    "current_taxes": 9519.1,
    "new_taxes_no_override": 9930.33,
    "override_total_1": 10212.09,
    "override_increase_1": 281.77
  },
  {
    "#": "1600 Beacon St, Unit 1102 & G25 (091-69-17)",
    "$": 940800,
    "address": "1600 Beacon St, Unit 1102 & G25",
    "parcel_id": "091-69-17",
    "owner1": "RIOS TR, ARACELI",
    "owner2": "",
    "current_taxes": 9633.79,
    "new_taxes_no_override": 10049.97,
    "override_total_1": 10335.13,
    "override_increase_1": 285.16
  },
  {
    "#": "1600 Beacon St, Unit 1103 & G52 (091-69-18)",
    "$": 1318800,
    "address": "1600 Beacon St, Unit 1103 & G52",
    "parcel_id": "091-69-18",
    "owner1": "KATSAFANAS, PETER P",
    "owner2": "SLEVENS, DANIELLE L",
    "current_taxes": 9869.58,
    "new_taxes_no_override": 10295.95,
    "override_total_1": 10588.09,
    "override_increase_1": 292.14
  },
  {
    "#": "1600 Beacon St, Unit 1104 & G1 (091-69-19)",
    "$": 615200,
    "address": "1600 Beacon St, Unit 1104 & G1",
    "parcel_id": "091-69-19",
    "owner1": "YEO, CHEUW C & CHIN-CHIN",
    "owner2": "",
    "current_taxes": 6299.65,
    "new_taxes_no_override": 6571.79,
    "override_total_1": 6758.26,
    "override_increase_1": 186.47
  },
  {
    "#": "1600 Beacon St, Unit 1106 & G60 (091-69-20)",
    "$": 1008100,
    "address": "1600 Beacon St, Unit 1106 & G60",
    "parcel_id": "091-69-20",
    "owner1": "THIRD AVENUE REALTY LLC",
    "owner2": "",
    "current_taxes": 10322.94,
    "new_taxes_no_override": 10768.89,
    "override_total_1": 11074.45,
    "override_increase_1": 305.56
  },
  {
    "#": "1600 Beacon St, Unit 1107 (091-69-21)",
    "$": 656300,
    "address": "1600 Beacon St, Unit 1107",
    "parcel_id": "091-69-21",
    "owner1": "72 CLYDE STREET LLC",
    "owner2": "",
    "current_taxes": 6720.51,
    "new_taxes_no_override": 7010.84,
    "override_total_1": 7209.76,
    "override_increase_1": 198.93
  },
  {
    "#": "1600 Beacon St, Unit 1108 & G88 (091-69-22)",
    "$": 820100,
    "address": "1600 Beacon St, Unit 1108 & G88",
    "parcel_id": "091-69-22",
    "owner1": "ARYANPOUR, SHADI",
    "owner2": "FAROKHZAD, OMID",
    "current_taxes": 8397.82,
    "new_taxes_no_override": 8760.61,
    "override_total_1": 9009.18,
    "override_increase_1": 248.58
  },
  {
    "#": "1600 Beacon St, Unit 1109 & G50 (091-69-23)",
    "$": 776400,
    "address": "1600 Beacon St, Unit 1109 & G50",
    "parcel_id": "091-69-23",
    "owner1": "ANSE LLC",
    "owner2": "",
    "current_taxes": 7950.34,
    "new_taxes_no_override": 8293.79,
    "override_total_1": 8529.12,
    "override_increase_1": 235.33
  },
  {
    "#": "1600 Beacon St, Unit 1110 & G7 (091-69-24)",
    "$": 812400,
    "address": "1600 Beacon St, Unit 1110 & G7",
    "parcel_id": "091-69-24",
    "owner1": "ASSENS, NATHALIE",
    "owner2": "",
    "current_taxes": 8318.98,
    "new_taxes_no_override": 8678.36,
    "override_total_1": 8924.6,
    "override_increase_1": 246.24
  },
  {
    "#": "1600 Beacon St, Unit 1111 & G33 (091-69-25)",
    "$": 937300,
    "address": "1600 Beacon St, Unit 1111 & G33",
    "parcel_id": "091-69-25",
    "owner1": "CHANA TRS, AMY RENEE & SAAJAN SINGH",
    "owner2": "",
    "current_taxes": 5963.02,
    "new_taxes_no_override": 6220.62,
    "override_total_1": 6397.13,
    "override_increase_1": 176.51
  },
  {
    "#": "1600 Beacon St, Unit 1112 & G90 (091-69-26)",
    "$": 932700,
    "address": "1600 Beacon St, Unit 1112 & G90",
    "parcel_id": "091-69-26",
    "owner1": "BRISTLECONE PINE LIMITED LLC",
    "owner2": "",
    "current_taxes": 9550.85,
    "new_taxes_no_override": 9963.45,
    "override_total_1": 10246.15,
    "override_increase_1": 282.71
  },
  {
    "#": "1600 Beacon St, Unit 201 (091-08-08)",
    "$": 692600,
    "address": "1600 Beacon St, Unit 201",
    "parcel_id": "091-08-08",
    "owner1": "ABRISHAMIAN TR, NIKI",
    "owner2": "",
    "current_taxes": 7092.22,
    "new_taxes_no_override": 7398.6,
    "override_total_1": 7608.53,
    "override_increase_1": 209.93
  },
  {
    "#": "1600 Beacon St, Unit 202 (091-08-09)",
    "$": 697100,
    "address": "1600 Beacon St, Unit 202",
    "parcel_id": "091-08-09",
    "owner1": "MITCHELL, MICHAEL E",
    "owner2": "",
    "current_taxes": 7138.3,
    "new_taxes_no_override": 7446.67,
    "override_total_1": 7657.97,
    "override_increase_1": 211.29
  },
  {
    "#": "1600 Beacon St, Unit 203 (091-08-10)",
    "$": 231700,
    "address": "1600 Beacon St, Unit 203",
    "parcel_id": "091-08-10",
    "owner1": "CHEN, YUHONG",
    "owner2": "",
    "current_taxes": 237.26,
    "new_taxes_no_override": 247.51,
    "override_total_1": 254.53,
    "override_increase_1": 7.02
  },
  {
    "#": "1600 Beacon St, Unit 205 (091-08-11)",
    "$": 579500,
    "address": "1600 Beacon St, Unit 205",
    "parcel_id": "091-08-11",
    "owner1": "BLUM, DANIEL E",
    "owner2": "RODITI, ELYSE FLORA",
    "current_taxes": 5934.08,
    "new_taxes_no_override": 6190.43,
    "override_total_1": 6366.08,
    "override_increase_1": 175.65
  },
  {
    "#": "1600 Beacon St, Unit 206 & G80 (091-08-12)",
    "$": 775600,
    "address": "1600 Beacon St, Unit 206 & G80",
    "parcel_id": "091-08-12",
    "owner1": "SANE, RADHIKA S",
    "owner2": "",
    "current_taxes": 7942.14,
    "new_taxes_no_override": 8285.24,
    "override_total_1": 8520.33,
    "override_increase_1": 235.09
  },
  {
    "#": "1600 Beacon St, Unit 207 (091-08-13)",
    "$": 572100,
    "address": "1600 Beacon St, Unit 207",
    "parcel_id": "091-08-13",
    "owner1": "BAKSHI, SALINA S",
    "owner2": "UPADHYAY, VIVEK",
    "current_taxes": 5858.3,
    "new_taxes_no_override": 6111.38,
    "override_total_1": 6284.78,
    "override_increase_1": 173.41
  },
  {
    "#": "1600 Beacon St, Unit 208 & G72 (091-08-14)",
    "$": 730900,
    "address": "1600 Beacon St, Unit 208 & G72",
    "parcel_id": "091-08-14",
    "owner1": "SALGAN, SUSAN",
    "owner2": "",
    "current_taxes": 7484.42,
    "new_taxes_no_override": 7807.75,
    "override_total_1": 8029.29,
    "override_increase_1": 221.54
  },
  {
    "#": "1600 Beacon St, Unit 209 & G75 (091-08-15)",
    "$": 714600,
    "address": "1600 Beacon St, Unit 209 & G75",
    "parcel_id": "091-08-15",
    "owner1": "BLOOM, JUDITH",
    "owner2": "",
    "current_taxes": 3682.57,
    "new_taxes_no_override": 3841.66,
    "override_total_1": 3950.66,
    "override_increase_1": 109.0
  },
  {
    "#": "1600 Beacon St, Unit 210 & G78 (091-08-16)",
    "$": 730900,
    "address": "1600 Beacon St, Unit 210 & G78",
    "parcel_id": "091-08-16",
    "owner1": "WIEDERECHT, JONATHAN",
    "owner2": "KILIC, KEVSAR NUR",
    "current_taxes": 7484.42,
    "new_taxes_no_override": 7807.75,
    "override_total_1": 8029.29,
    "override_increase_1": 221.54
  },
  {
    "#": "1600 Beacon St, Unit 211&G38 (091-08-17)",
    "$": 834900,
    "address": "1600 Beacon St, Unit 211&G38",
    "parcel_id": "091-08-17",
    "owner1": "BHATIA, SAMIR",
    "owner2": "",
    "current_taxes": 4914.44,
    "new_taxes_no_override": 5126.74,
    "override_total_1": 5272.21,
    "override_increase_1": 145.47
  },
  {
    "#": "1600 Beacon St, Unit 212 & G82 (091-08-18)",
    "$": 834900,
    "address": "1600 Beacon St, Unit 212 & G82",
    "parcel_id": "091-08-18",
    "owner1": "HAWES, GREGORY",
    "owner2": "ROVIS, MARIA",
    "current_taxes": 8549.38,
    "new_taxes_no_override": 8918.71,
    "override_total_1": 9171.77,
    "override_increase_1": 253.06
  },
  {
    "#": "1600 Beacon St, Unit 301 (091-08-19)",
    "$": 253200,
    "address": "1600 Beacon St, Unit 301",
    "parcel_id": "091-08-19",
    "owner1": "LI, QUANGANG",
    "owner2": "DONG, PIN ZHU",
    "current_taxes": 259.28,
    "new_taxes_no_override": 270.48,
    "override_total_1": 278.16,
    "override_increase_1": 7.67
  },
  {
    "#": "1600 Beacon St, Unit 302&G92 (091-08-20)",
    "$": 840100,
    "address": "1600 Beacon St, Unit 302&G92",
    "parcel_id": "091-08-20",
    "owner1": "SLEVENS, JANIE",
    "owner2": "",
    "current_taxes": 4967.69,
    "new_taxes_no_override": 5182.29,
    "override_total_1": 5329.34,
    "override_increase_1": 147.04
  },
  {
    "#": "1600 Beacon St, Unit 303 (091-08-21)",
    "$": 594800,
    "address": "1600 Beacon St, Unit 303",
    "parcel_id": "091-08-21",
    "owner1": "RADELJEVIC, ANA",
    "owner2": "",
    "current_taxes": 6090.75,
    "new_taxes_no_override": 6353.87,
    "override_total_1": 6534.16,
    "override_increase_1": 180.29
  },
  {
    "#": "1600 Beacon St, Unit 304&G57 (091-08-22)",
    "$": 565100,
    "address": "1600 Beacon St, Unit 304&G57",
    "parcel_id": "091-08-22",
    "owner1": "HIRSHMAN, MICHAEL",
    "owner2": "",
    "current_taxes": 5786.62,
    "new_taxes_no_override": 6036.6,
    "override_total_1": 6207.89,
    "override_increase_1": 171.28
  },
  {
    "#": "1600 Beacon St, Unit 305& G11 (091-08-23)",
    "$": 713000,
    "address": "1600 Beacon St, Unit 305& G11",
    "parcel_id": "091-08-23",
    "owner1": "GANAPATHI TRS, SANKARAN",
    "owner2": "",
    "current_taxes": 7301.12,
    "new_taxes_no_override": 7616.53,
    "override_total_1": 7832.64,
    "override_increase_1": 216.11
  },
  {
    "#": "1600 Beacon St, Unit 306 & G21 (091-08-24)",
    "$": 904000,
    "address": "1600 Beacon St, Unit 306 & G21",
    "parcel_id": "091-08-24",
    "owner1": "RSVP BEACON LLC",
    "owner2": "",
    "current_taxes": 9256.96,
    "new_taxes_no_override": 9656.86,
    "override_total_1": 9930.87,
    "override_increase_1": 274.01
  },
  {
    "#": "1600 Beacon St, Unit 307 (091-08-25)",
    "$": 237900,
    "address": "1600 Beacon St, Unit 307",
    "parcel_id": "091-08-25",
    "owner1": "IP, MICHAEL CHUN",
    "owner2": "",
    "current_taxes": 243.61,
    "new_taxes_no_override": 254.13,
    "override_total_1": 261.34,
    "override_increase_1": 7.21
  },
  {
    "#": "1600 Beacon St, Unit 308 & G20 (091-08-26)",
    "$": 747400,
    "address": "1600 Beacon St, Unit 308 & G20",
    "parcel_id": "091-08-26",
    "owner1": "GOLDEN, BRANDON & ROCHELLE",
    "owner2": "",
    "current_taxes": 4018.44,
    "new_taxes_no_override": 4192.04,
    "override_total_1": 4310.98,
    "override_increase_1": 118.95
  },
  {
    "#": "1600 Beacon St, Unit 309 & G5 (091-08-27)",
    "$": 698100,
    "address": "1600 Beacon St, Unit 309 & G5",
    "parcel_id": "091-08-27",
    "owner1": "YU TR, LOUISE Y",
    "owner2": "",
    "current_taxes": 3513.61,
    "new_taxes_no_override": 3665.4,
    "override_total_1": 3769.4,
    "override_increase_1": 104.0
  },
  {
    "#": "1600 Beacon St, Unit 310 & G13 (091-08-28)",
    "$": 749300,
    "address": "1600 Beacon St, Unit 310 & G13",
    "parcel_id": "091-08-28",
    "owner1": "MAHALINGAIAH, HALEVOOR & THEJA",
    "owner2": "",
    "current_taxes": 7672.83,
    "new_taxes_no_override": 8004.3,
    "override_total_1": 8231.41,
    "override_increase_1": 227.12
  },
  {
    "#": "1600 Beacon St, Unit 311 (091-08-29)",
    "$": 744700,
    "address": "1600 Beacon St, Unit 311",
    "parcel_id": "091-08-29",
    "owner1": "KONISKY TRS, KAREN A & RAYMOND A",
    "owner2": "",
    "current_taxes": 7625.73,
    "new_taxes_no_override": 7955.16,
    "override_total_1": 8180.88,
    "override_increase_1": 225.72
  },
  {
    "#": "1600 Beacon St, Unit 312 & G85 (091-08-30)",
    "$": 834900,
    "address": "1600 Beacon St, Unit 312 & G85",
    "parcel_id": "091-08-30",
    "owner1": "BEACON POND COMPANY LLC",
    "owner2": "",
    "current_taxes": 8549.38,
    "new_taxes_no_override": 8918.71,
    "override_total_1": 9171.77,
    "override_increase_1": 253.06
  },
  {
    "#": "1600 Beacon St, Unit 401 & G95 (091-08-31)",
    "$": 837700,
    "address": "1600 Beacon St, Unit 401 & G95",
    "parcel_id": "091-08-31",
    "owner1": "PATRIZI, SILVIA",
    "owner2": "SORCINI, ANDREA",
    "current_taxes": 8578.05,
    "new_taxes_no_override": 8948.62,
    "override_total_1": 9202.53,
    "override_increase_1": 253.91
  },
  {
    "#": "1600 Beacon St, Unit 402 (091-08-32)",
    "$": 770100,
    "address": "1600 Beacon St, Unit 402",
    "parcel_id": "091-08-32",
    "owner1": "TARAZI TRS, E MICHAEL & JEANNIE",
    "owner2": "TARAZI, ZACHARY JOHANN & ELISABETH GERDA",
    "current_taxes": 4250.89,
    "new_taxes_no_override": 4434.53,
    "override_total_1": 4560.35,
    "override_increase_1": 125.83
  },
  {
    "#": "1600 Beacon St, Unit 403 (091-08-33)",
    "$": 595200,
    "address": "1600 Beacon St, Unit 403",
    "parcel_id": "091-08-33",
    "owner1": "FISCHER LIFE ESTATE, SUSAN L",
    "owner2": "",
    "current_taxes": 2459.91,
    "new_taxes_no_override": 2566.18,
    "override_total_1": 2638.99,
    "override_increase_1": 72.81
  },
  {
    "#": "1600 Beacon St, Unit 404 & G97 (091-08-34)",
    "$": 565100,
    "address": "1600 Beacon St, Unit 404 & G97",
    "parcel_id": "091-08-34",
    "owner1": "DILMAGHANI, CYRUS",
    "owner2": "",
    "current_taxes": 2151.69,
    "new_taxes_no_override": 2244.64,
    "override_total_1": 2308.33,
    "override_increase_1": 63.69
  },
  {
    "#": "1600 Beacon St, Unit 405 & G43 (091-08-35)",
    "$": 713000,
    "address": "1600 Beacon St, Unit 405 & G43",
    "parcel_id": "091-08-35",
    "owner1": "HERNANDEZ, OSMIN & ARICHAYA",
    "owner2": "",
    "current_taxes": 7301.12,
    "new_taxes_no_override": 7616.53,
    "override_total_1": 7832.64,
    "override_increase_1": 216.11
  },
  {
    "#": "1600 Beacon St, Unit 406 (091-08-36)",
    "$": 859900,
    "address": "1600 Beacon St, Unit 406",
    "parcel_id": "091-08-36",
    "owner1": "ROSADO, REBECCA",
    "owner2": "",
    "current_taxes": 5170.44,
    "new_taxes_no_override": 5393.8,
    "override_total_1": 5546.85,
    "override_increase_1": 153.05
  },
  {
    "#": "1600 Beacon St, Unit 407 (091-08-37)",
    "$": 572100,
    "address": "1600 Beacon St, Unit 407",
    "parcel_id": "091-08-37",
    "owner1": "KO, KATIE",
    "owner2": "",
    "current_taxes": 2223.37,
    "new_taxes_no_override": 2319.42,
    "override_total_1": 2385.23,
    "override_increase_1": 65.81
  },
  {
    "#": "1600 Beacon St, Unit 408 & G3 (091-08-38)",
    "$": 747400,
    "address": "1600 Beacon St, Unit 408 & G3",
    "parcel_id": "091-08-38",
    "owner1": "CHEEVER, PETER J",
    "owner2": "",
    "current_taxes": 7653.38,
    "new_taxes_no_override": 7984.01,
    "override_total_1": 8210.55,
    "override_increase_1": 226.54
  },
  {
    "#": "1600 Beacon St, Unit 409 & G66 (091-08-39)",
    "$": 714600,
    "address": "1600 Beacon St, Unit 409 & G66",
    "parcel_id": "091-08-39",
    "owner1": "OHARA, EDEL",
    "owner2": "ONEILL, PHILIP",
    "current_taxes": 7317.5,
    "new_taxes_no_override": 7633.62,
    "override_total_1": 7850.21,
    "override_increase_1": 216.6
  },
  {
    "#": "1600 Beacon St, Unit 410 & G49 (091-08-40)",
    "$": 774200,
    "address": "1600 Beacon St, Unit 410 & G49",
    "parcel_id": "091-08-40",
    "owner1": "GREENBERG TR, SUSAN",
    "owner2": "",
    "current_taxes": 7927.81,
    "new_taxes_no_override": 8270.29,
    "override_total_1": 8504.95,
    "override_increase_1": 234.66
  },
  {
    "#": "1600 Beacon St, Unit 411 & G41 (091-08-41)",
    "$": 834900,
    "address": "1600 Beacon St, Unit 411 & G41",
    "parcel_id": "091-08-41",
    "owner1": "THIRD AVENUE REALTY LLC",
    "owner2": "",
    "current_taxes": 8549.38,
    "new_taxes_no_override": 8918.71,
    "override_total_1": 9171.77,
    "override_increase_1": 253.06
  },
  {
    "#": "1600 Beacon St, Unit 412 & G89 (091-08-42)",
    "$": 903800,
    "address": "1600 Beacon St, Unit 412 & G89",
    "parcel_id": "091-08-42",
    "owner1": "AHN, PAUL B",
    "owner2": "LIN, SURU",
    "current_taxes": 5619.98,
    "new_taxes_no_override": 5862.76,
    "override_total_1": 6029.11,
    "override_increase_1": 166.35
  },
  {
    "#": "1600 Beacon St, Unit 501 & G23 (091-08-43)",
    "$": 837700,
    "address": "1600 Beacon St, Unit 501 & G23",
    "parcel_id": "091-08-43",
    "owner1": "LIN, NAIJIE",
    "owner2": "LEE, YOONJUNG",
    "current_taxes": 8578.05,
    "new_taxes_no_override": 8948.62,
    "override_total_1": 9202.53,
    "override_increase_1": 253.91
  },
  {
    "#": "1600 Beacon St, Unit 502 & G8 (091-08-44)",
    "$": 840600,
    "address": "1600 Beacon St, Unit 502 & G8",
    "parcel_id": "091-08-44",
    "owner1": "LEE TRS, EUI IN & JAMIE & DAVID",
    "owner2": "",
    "current_taxes": 8607.74,
    "new_taxes_no_override": 8979.59,
    "override_total_1": 9234.38,
    "override_increase_1": 254.79
  },
  {
    "#": "1600 Beacon St, Unit 503 (091-08-45)",
    "$": 233100,
    "address": "1600 Beacon St, Unit 503",
    "parcel_id": "091-08-45",
    "owner1": "LUO, ADA XIAOSHAN MAI",
    "owner2": "",
    "current_taxes": 238.69,
    "new_taxes_no_override": 249.0,
    "override_total_1": 256.07,
    "override_increase_1": 7.07
  },
  {
    "#": "1600 Beacon St, Unit 504 (091-08-46)",
    "$": 494700,
    "address": "1600 Beacon St, Unit 504",
    "parcel_id": "091-08-46",
    "owner1": "NOVICH, BRUCE E & SUSAN & COREY E",
    "owner2": "",
    "current_taxes": 5065.73,
    "new_taxes_no_override": 5284.57,
    "override_total_1": 5434.52,
    "override_increase_1": 149.95
  },
  {
    "#": "1600 Beacon St, Unit 505 (091-08-47)",
    "$": 579500,
    "address": "1600 Beacon St, Unit 505",
    "parcel_id": "091-08-47",
    "owner1": "LI, BING",
    "owner2": "",
    "current_taxes": 5934.08,
    "new_taxes_no_override": 6190.43,
    "override_total_1": 6366.08,
    "override_increase_1": 175.65
  },
  {
    "#": "1600 Beacon St, Unit 506 & Pksps (091-08-48)",
    "$": 1597100,
    "address": "1600 Beacon St, Unit 506 & Pksps",
    "parcel_id": "091-08-48",
    "owner1": "LMN GROUP LLC",
    "owner2": "",
    "current_taxes": 16354.3,
    "new_taxes_no_override": 17060.81,
    "override_total_1": 17544.89,
    "override_increase_1": 484.09
  },
  {
    "#": "1600 Beacon St, Unit 507 & G34 (091-08-49)",
    "$": 704500,
    "address": "1600 Beacon St, Unit 507 & G34",
    "parcel_id": "091-08-49",
    "owner1": "HUR, YONG",
    "owner2": "OGATA, YUMI",
    "current_taxes": 7214.08,
    "new_taxes_no_override": 7525.73,
    "override_total_1": 7739.27,
    "override_increase_1": 213.54
  },
  {
    "#": "1600 Beacon St, Unit 508 & G31 (091-08-50)",
    "$": 747400,
    "address": "1600 Beacon St, Unit 508 & G31",
    "parcel_id": "091-08-50",
    "owner1": "JAEGER, ELLEN",
    "owner2": "",
    "current_taxes": 7653.38,
    "new_taxes_no_override": 7984.01,
    "override_total_1": 8210.55,
    "override_increase_1": 226.54
  },
  {
    "#": "1600 Beacon St, Unit 509 (091-08-51)",
    "$": 580900,
    "address": "1600 Beacon St, Unit 509",
    "parcel_id": "091-08-51",
    "owner1": "NGUYEN, ANDREW",
    "owner2": "",
    "current_taxes": 5948.42,
    "new_taxes_no_override": 6205.39,
    "override_total_1": 6381.46,
    "override_increase_1": 176.07
  },
  {
    "#": "1600 Beacon St, Unit 510 (091-08-52)",
    "$": 661000,
    "address": "1600 Beacon St, Unit 510",
    "parcel_id": "091-08-52",
    "owner1": "CATALTEPE TRS, SULE & OGUZ",
    "owner2": "",
    "current_taxes": 6768.64,
    "new_taxes_no_override": 7061.05,
    "override_total_1": 7261.4,
    "override_increase_1": 200.35
  },
  {
    "#": "1600 Beacon St, Unit 511 & G69 (091-08-53)",
    "$": 839100,
    "address": "1600 Beacon St, Unit 511 & G69",
    "parcel_id": "091-08-53",
    "owner1": "CED BROOKLINE LLC",
    "owner2": "",
    "current_taxes": 8592.38,
    "new_taxes_no_override": 8963.57,
    "override_total_1": 9217.91,
    "override_increase_1": 254.33
  },
  {
    "#": "1600 Beacon St, Unit 512 & G2 (091-08-54)",
    "$": 860300,
    "address": "1600 Beacon St, Unit 512 & G2",
    "parcel_id": "091-08-54",
    "owner1": "SONG, THOMAS & LEAH K",
    "owner2": "",
    "current_taxes": 5174.54,
    "new_taxes_no_override": 5398.08,
    "override_total_1": 5551.25,
    "override_increase_1": 153.17
  },
  {
    "#": "1600 Beacon St, Unit 601 (091-08-55)",
    "$": 792700,
    "address": "1600 Beacon St, Unit 601",
    "parcel_id": "091-08-55",
    "owner1": "CHEN, HUI-CHUN",
    "owner2": "",
    "current_taxes": 8117.25,
    "new_taxes_no_override": 8467.92,
    "override_total_1": 8708.19,
    "override_increase_1": 240.27
  },
  {
    "#": "1600 Beacon St, Unit 602 & G74 (091-08-56)",
    "$": 885900,
    "address": "1600 Beacon St, Unit 602 & G74",
    "parcel_id": "091-08-56",
    "owner1": "CARROLL, SERA A",
    "owner2": "",
    "current_taxes": 5436.68,
    "new_taxes_no_override": 5671.54,
    "override_total_1": 5832.47,
    "override_increase_1": 160.93
  },
  {
    "#": "1600 Beacon St, Unit 603 (091-08-57)",
    "$": 648600,
    "address": "1600 Beacon St, Unit 603",
    "parcel_id": "091-08-57",
    "owner1": "NEWMAN, CAROL B",
    "owner2": "",
    "current_taxes": 3006.73,
    "new_taxes_no_override": 3136.62,
    "override_total_1": 3225.62,
    "override_increase_1": 89.0
  },
  {
    "#": "1600 Beacon St, Unit 604 (091-08-58)",
    "$": 513500,
    "address": "1600 Beacon St, Unit 604",
    "parcel_id": "091-08-58",
    "owner1": "FAN, ZIRU",
    "owner2": "",
    "current_taxes": 5258.24,
    "new_taxes_no_override": 5485.4,
    "override_total_1": 5641.04,
    "override_increase_1": 155.64
  },
  {
    "#": "1600 Beacon St, Unit 605 (091-08-59)",
    "$": 626100,
    "address": "1600 Beacon St, Unit 605",
    "parcel_id": "091-08-59",
    "owner1": "SHEPSIS, MICHAEL",
    "owner2": "",
    "current_taxes": 6411.26,
    "new_taxes_no_override": 6688.23,
    "override_total_1": 6878.0,
    "override_increase_1": 189.77
  },
  {
    "#": "1600 Beacon St, Unit 606 & G9 (091-08-60)",
    "$": 955600,
    "address": "1600 Beacon St, Unit 606 & G9",
    "parcel_id": "091-08-60",
    "owner1": "GUALDONI, ANNABELLA L & OSCAR & MERCEDES",
    "owner2": "",
    "current_taxes": 6150.41,
    "new_taxes_no_override": 6416.11,
    "override_total_1": 6598.16,
    "override_increase_1": 182.05
  },
  {
    "#": "1600 Beacon St, Unit 607 & G47 (091-08-61)",
    "$": 704500,
    "address": "1600 Beacon St, Unit 607 & G47",
    "parcel_id": "091-08-61",
    "owner1": "HARDENBERGH, ALLISON SANDELLA",
    "owner2": "",
    "current_taxes": 7214.08,
    "new_taxes_no_override": 7525.73,
    "override_total_1": 7739.27,
    "override_increase_1": 213.54
  },
  {
    "#": "1600 Beacon St, Unit 608 & G40 (091-08-62)",
    "$": 747400,
    "address": "1600 Beacon St, Unit 608 & G40",
    "parcel_id": "091-08-62",
    "owner1": "FIRST KEY REALTY LLC",
    "owner2": "",
    "current_taxes": 7653.38,
    "new_taxes_no_override": 7984.01,
    "override_total_1": 8210.55,
    "override_increase_1": 226.54
  },
  {
    "#": "1600 Beacon St, Unit 609 (091-08-63)",
    "$": 627700,
    "address": "1600 Beacon St, Unit 609",
    "parcel_id": "091-08-63",
    "owner1": "PRYNKO, NATALIA",
    "owner2": "",
    "current_taxes": 6427.65,
    "new_taxes_no_override": 6705.32,
    "override_total_1": 6895.58,
    "override_increase_1": 190.26
  },
  {
    "#": "1600 Beacon St, Unit 610 & G79 (091-08-64)",
    "$": 748300,
    "address": "1600 Beacon St, Unit 610 & G79",
    "parcel_id": "091-08-64",
    "owner1": "ABUR, ALI",
    "owner2": "TANYERI-ABUR, AYSEN I",
    "current_taxes": 7662.59,
    "new_taxes_no_override": 7993.61,
    "override_total_1": 8220.43,
    "override_increase_1": 226.81
  },
  {
    "#": "1600 Beacon St, Unit 611 & G14 (091-08-65)",
    "$": 879800,
    "address": "1600 Beacon St, Unit 611 & G14",
    "parcel_id": "091-08-65",
    "owner1": "OHARA TR, EDEL",
    "owner2": "",
    "current_taxes": 9009.15,
    "new_taxes_no_override": 9398.35,
    "override_total_1": 9665.02,
    "override_increase_1": 266.67
  },
  {
    "#": "1600 Beacon St, Unit 612 & G56 (091-08-66)",
    "$": 879800,
    "address": "1600 Beacon St, Unit 612 & G56",
    "parcel_id": "091-08-66",
    "owner1": "GOODARZI, GOLNAZ",
    "owner2": "",
    "current_taxes": 5374.22,
    "new_taxes_no_override": 5606.39,
    "override_total_1": 5765.46,
    "override_increase_1": 159.08
  },
  {
    "#": "1600 Beacon St, Unit 701 & G6 (091-08-67)",
    "$": 882800,
    "address": "1600 Beacon St, Unit 701 & G6",
    "parcel_id": "091-08-67",
    "owner1": "MILLER, JESSICA",
    "owner2": "",
    "current_taxes": 9039.87,
    "new_taxes_no_override": 9430.39,
    "override_total_1": 9697.97,
    "override_increase_1": 267.58
  },
  {
    "#": "1600 Beacon St, Unit 702 & G84 (091-08-68)",
    "$": 914500,
    "address": "1600 Beacon St, Unit 702 & G84",
    "parcel_id": "091-08-68",
    "owner1": "SIMONS, LEONARD M & SHEILA TAMKIN",
    "owner2": "",
    "current_taxes": 5729.55,
    "new_taxes_no_override": 5977.07,
    "override_total_1": 6146.66,
    "override_increase_1": 169.59
  },
  {
    "#": "1600 Beacon St, Unit 703 & G59 (091-08-69)",
    "$": 731200,
    "address": "1600 Beacon St, Unit 703 & G59",
    "parcel_id": "091-08-69",
    "owner1": "OWADES TR, MACKENZIE M",
    "owner2": "",
    "current_taxes": 7487.49,
    "new_taxes_no_override": 7810.95,
    "override_total_1": 8032.58,
    "override_increase_1": 221.63
  },
  {
    "#": "1600 Beacon St, Unit 704 & G87 (091-08-70)",
    "$": 612600,
    "address": "1600 Beacon St, Unit 704 & G87",
    "parcel_id": "091-08-70",
    "owner1": "NAVARRETTE, RACHEL",
    "owner2": "",
    "current_taxes": 2638.09,
    "new_taxes_no_override": 2752.06,
    "override_total_1": 2830.14,
    "override_increase_1": 78.09
  },
  {
    "#": "1600 Beacon St, Unit 705 & G32 (091-08-71)",
    "$": 720000,
    "address": "1600 Beacon St, Unit 705 & G32",
    "parcel_id": "091-08-71",
    "owner1": "KIMURA, TAKASHI",
    "owner2": "",
    "current_taxes": 3737.87,
    "new_taxes_no_override": 3899.35,
    "override_total_1": 4009.99,
    "override_increase_1": 110.64
  },
  {
    "#": "1600 Beacon St, Unit 706 & G77 (091-08-72)",
    "$": 957200,
    "address": "1600 Beacon St, Unit 706 & G77",
    "parcel_id": "091-08-72",
    "owner1": "FETVACI, EMINE F",
    "owner2": "STAR, DANIEL",
    "current_taxes": 6166.79,
    "new_taxes_no_override": 6433.2,
    "override_total_1": 6615.73,
    "override_increase_1": 182.54
  },
  {
    "#": "1600 Beacon St, Unit 707 & G54 (091-08-73)",
    "$": 705600,
    "address": "1600 Beacon St, Unit 707 & G54",
    "parcel_id": "091-08-73",
    "owner1": "KEERY FAMILY LTD PARTNERSHIP",
    "owner2": "",
    "current_taxes": 7225.34,
    "new_taxes_no_override": 7537.47,
    "override_total_1": 7751.34,
    "override_increase_1": 213.87
  },
  {
    "#": "1600 Beacon St, Unit 708 & G81 (091-08-74)",
    "$": 748600,
    "address": "1600 Beacon St, Unit 708 & G81",
    "parcel_id": "091-08-74",
    "owner1": "LEE, DING DING KELLY",
    "owner2": "PATTERSON, CRAIG",
    "current_taxes": 7665.66,
    "new_taxes_no_override": 7996.82,
    "override_total_1": 8223.72,
    "override_increase_1": 226.9
  },
  {
    "#": "1600 Beacon St, Unit 709 (091-08-75)",
    "$": 645300,
    "address": "1600 Beacon St, Unit 709",
    "parcel_id": "091-08-75",
    "owner1": "SHAH, PARUL",
    "owner2": "",
    "current_taxes": 6607.87,
    "new_taxes_no_override": 6893.33,
    "override_total_1": 7088.92,
    "override_increase_1": 195.59
  },
  {
    "#": "1600 Beacon St, Unit 710 & G29 (091-08-76)",
    "$": 749500,
    "address": "1600 Beacon St, Unit 710 & G29",
    "parcel_id": "091-08-76",
    "owner1": "YEO, CHEUW CHIE & CHIN CHIN",
    "owner2": "",
    "current_taxes": 7674.88,
    "new_taxes_no_override": 8006.43,
    "override_total_1": 8233.61,
    "override_increase_1": 227.18
  },
  {
    "#": "1600 Beacon St, Unit 711 & G71 (091-08-77)",
    "$": 881200,
    "address": "1600 Beacon St, Unit 711 & G71",
    "parcel_id": "091-08-77",
    "owner1": "EILAM TR, REVITAL",
    "owner2": "",
    "current_taxes": 9023.49,
    "new_taxes_no_override": 9413.3,
    "override_total_1": 9680.4,
    "override_increase_1": 267.1
  },
  {
    "#": "1600 Beacon St, Unit 712 & G53 (091-08-78)",
    "$": 881200,
    "address": "1600 Beacon St, Unit 712 & G53",
    "parcel_id": "091-08-78",
    "owner1": "CHOY TRS, ELENA",
    "owner2": "GRAVLIN, ERIC",
    "current_taxes": 9023.49,
    "new_taxes_no_override": 9413.3,
    "override_total_1": 9680.4,
    "override_increase_1": 267.1
  },
  {
    "#": "1600 Beacon St, Unit 801 & G46 (091-08-79)",
    "$": 884300,
    "address": "1600 Beacon St, Unit 801 & G46",
    "parcel_id": "091-08-79",
    "owner1": "EILAM TR, IDO",
    "owner2": "",
    "current_taxes": 9055.23,
    "new_taxes_no_override": 9446.42,
    "override_total_1": 9714.45,
    "override_increase_1": 268.03
  },
  {
    "#": "1600 Beacon St, Unit 802 (091-08-80)",
    "$": 796800,
    "address": "1600 Beacon St, Unit 802",
    "parcel_id": "091-08-80",
    "owner1": "RSVP BEACON LLC",
    "owner2": "",
    "current_taxes": 8159.23,
    "new_taxes_no_override": 8511.71,
    "override_total_1": 8753.22,
    "override_increase_1": 241.51
  },
  {
    "#": "1600 Beacon St, Unit 803 & G86 (091-08-81)",
    "$": 773700,
    "address": "1600 Beacon St, Unit 803 & G86",
    "parcel_id": "091-08-81",
    "owner1": "JACOBSON, ROBERT J",
    "owner2": "",
    "current_taxes": 4287.75,
    "new_taxes_no_override": 4472.98,
    "override_total_1": 4599.9,
    "override_increase_1": 126.92
  },
  {
    "#": "1600 Beacon St, Unit 804 (091-08-82)",
    "$": 495500,
    "address": "1600 Beacon St, Unit 804",
    "parcel_id": "091-08-82",
    "owner1": "GARCIA, EDUARDO",
    "owner2": "",
    "current_taxes": 1438.99,
    "new_taxes_no_override": 1501.15,
    "override_total_1": 1543.75,
    "override_increase_1": 42.59
  },
  {
    "#": "1600 Beacon St, Unit 805 & G68 (091-08-83)",
    "$": 755300,
    "address": "1600 Beacon St, Unit 805 & G68",
    "parcel_id": "091-08-83",
    "owner1": "METAFORA TRS, ROBERT & DONNA",
    "owner2": "MCALOON, JUSTIN",
    "current_taxes": 7734.27,
    "new_taxes_no_override": 8068.39,
    "override_total_1": 8297.32,
    "override_increase_1": 228.93
  },
  {
    "#": "1600 Beacon St, Unit 806 (091-08-84)",
    "$": 881000,
    "address": "1600 Beacon St, Unit 806",
    "parcel_id": "091-08-84",
    "owner1": "RSVP BEACON LLC",
    "owner2": "",
    "current_taxes": 9021.44,
    "new_taxes_no_override": 9411.17,
    "override_total_1": 9678.2,
    "override_increase_1": 267.03
  },
  {
    "#": "1600 Beacon St, Unit 807 & G55 (091-08-85)",
    "$": 746000,
    "address": "1600 Beacon St, Unit 807 & G55",
    "parcel_id": "091-08-85",
    "owner1": "MCCARTHY, JOHN E III",
    "owner2": "",
    "current_taxes": 4004.11,
    "new_taxes_no_override": 4177.09,
    "override_total_1": 4295.61,
    "override_increase_1": 118.52
  },
  {
    "#": "1600 Beacon St, Unit 808 & G58 (091-08-86)",
    "$": 767400,
    "address": "1600 Beacon St, Unit 808 & G58",
    "parcel_id": "091-08-86",
    "owner1": "WARD, COLLIN",
    "owner2": "",
    "current_taxes": 7858.18,
    "new_taxes_no_override": 8197.65,
    "override_total_1": 8430.26,
    "override_increase_1": 232.6
  },
  {
    "#": "1600 Beacon St, Unit 809 & G30 (091-08-87)",
    "$": 715700,
    "address": "1600 Beacon St, Unit 809 & G30",
    "parcel_id": "091-08-87",
    "owner1": "ERLICH, SIMON & FREIDA",
    "owner2": "",
    "current_taxes": 7328.77,
    "new_taxes_no_override": 7645.37,
    "override_total_1": 7862.3,
    "override_increase_1": 216.93
  },
  {
    "#": "1600 Beacon St, Unit 810 (091-08-88)",
    "$": 696500,
    "address": "1600 Beacon St, Unit 810",
    "parcel_id": "091-08-88",
    "owner1": "GANGESWATER HOLDINGS LLC",
    "owner2": "",
    "current_taxes": 7132.16,
    "new_taxes_no_override": 7440.27,
    "override_total_1": 7651.38,
    "override_increase_1": 211.11
  },
  {
    "#": "1600 Beacon St, Unit 811 & G65 (091-08-89)",
    "$": 881200,
    "address": "1600 Beacon St, Unit 811 & G65",
    "parcel_id": "091-08-89",
    "owner1": "CHITRA, EDRIC A & MAXIMILLIAN  A",
    "owner2": "",
    "current_taxes": 9023.49,
    "new_taxes_no_override": 9413.3,
    "override_total_1": 9680.4,
    "override_increase_1": 267.1
  },
  {
    "#": "1600 Beacon St, Unit 812 & G24 (091-08-90)",
    "$": 881200,
    "address": "1600 Beacon St, Unit 812 & G24",
    "parcel_id": "091-08-90",
    "owner1": "MOY TR, LIEHAR",
    "owner2": "",
    "current_taxes": 9023.49,
    "new_taxes_no_override": 9413.3,
    "override_total_1": 9680.4,
    "override_increase_1": 267.1
  },
  {
    "#": "1600 Beacon St, Unit 901 & G96 (091-08-91)",
    "$": 935700,
    "address": "1600 Beacon St, Unit 901 & G96",
    "parcel_id": "091-08-91",
    "owner1": "TOPPAN, CHARLES F",
    "owner2": "",
    "current_taxes": 5946.63,
    "new_taxes_no_override": 6203.52,
    "override_total_1": 6379.54,
    "override_increase_1": 176.02
  },
  {
    "#": "1600 Beacon St, Unit 902 & G16 (091-08-92)",
    "$": 938800,
    "address": "1600 Beacon St, Unit 902 & G16",
    "parcel_id": "091-08-92",
    "owner1": "STERNWEILER, MARYLEN R I",
    "owner2": "",
    "current_taxes": 5978.38,
    "new_taxes_no_override": 6236.65,
    "override_total_1": 6413.61,
    "override_increase_1": 176.96
  },
  {
    "#": "1600 Beacon St, Unit 903 & G26 (091-08-93)",
    "$": 773200,
    "address": "1600 Beacon St, Unit 903 & G26",
    "parcel_id": "091-08-93",
    "owner1": "J & A REALTY LLC",
    "owner2": "C/O ARLENE LEHANE",
    "current_taxes": 7917.57,
    "new_taxes_no_override": 8259.61,
    "override_total_1": 8493.97,
    "override_increase_1": 234.36
  },
  {
    "#": "1600 Beacon St, Unit 904 (091-08-94)",
    "$": 514300,
    "address": "1600 Beacon St, Unit 904",
    "parcel_id": "091-08-94",
    "owner1": "1600 BEACON U904 LLC",
    "owner2": "",
    "current_taxes": 5266.43,
    "new_taxes_no_override": 5493.94,
    "override_total_1": 5649.83,
    "override_increase_1": 155.89
  },
  {
    "#": "1600 Beacon St, Unit 905 & G51 (091-08-95)",
    "$": 755300,
    "address": "1600 Beacon St, Unit 905 & G51",
    "parcel_id": "091-08-95",
    "owner1": "NEVIS, AMY RUTH",
    "owner2": "KAMHOLTZ, MATTHEW A",
    "current_taxes": 7734.27,
    "new_taxes_no_override": 8068.39,
    "override_total_1": 8297.32,
    "override_increase_1": 228.93
  },
  {
    "#": "1600 Beacon St, Unit 906 (091-08-96)",
    "$": 978100,
    "address": "1600 Beacon St, Unit 906",
    "parcel_id": "091-08-96",
    "owner1": "JIANG, HONG",
    "owner2": "",
    "current_taxes": 10015.74,
    "new_taxes_no_override": 10448.42,
    "override_total_1": 10744.89,
    "override_increase_1": 296.47
  },
  {
    "#": "1600 Beacon St, Unit 907 & G12 (091-08-97)",
    "$": 763800,
    "address": "1600 Beacon St, Unit 907 & G12",
    "parcel_id": "091-08-97",
    "owner1": "WAN, MILLIE MIAO-CHEUNG",
    "owner2": "WIDJAJA, SUGIHARTO S",
    "current_taxes": 7821.31,
    "new_taxes_no_override": 8159.19,
    "override_total_1": 8390.7,
    "override_increase_1": 231.51
  },
  {
    "#": "1600 Beacon St, Unit 908 & G73 (091-08-98)",
    "$": 792600,
    "address": "1600 Beacon St, Unit 908 & G73",
    "parcel_id": "091-08-98",
    "owner1": "POULOS TR, GEORGIA",
    "owner2": "",
    "current_taxes": 8116.22,
    "new_taxes_no_override": 8466.84,
    "override_total_1": 8707.08,
    "override_increase_1": 240.24
  },
  {
    "#": "1600 Beacon St, Unit 909 & G4 (091-08-99)",
    "$": 757000,
    "address": "1600 Beacon St, Unit 909 & G4",
    "parcel_id": "091-08-99",
    "owner1": "KAPLAN, MICHAEL A",
    "owner2": "",
    "current_taxes": 4116.75,
    "new_taxes_no_override": 4294.59,
    "override_total_1": 4416.45,
    "override_increase_1": 121.86
  },
  {
    "#": "1600 Beacon St, Unit 910 (091-69-01)",
    "$": 696500,
    "address": "1600 Beacon St, Unit 910",
    "parcel_id": "091-69-01",
    "owner1": "PAGOREK, GEORGE J & EVELYNNE K",
    "owner2": "",
    "current_taxes": 7132.16,
    "new_taxes_no_override": 7440.27,
    "override_total_1": 7651.38,
    "override_increase_1": 211.11
  },
  {
    "#": "1600 Beacon St, Unit 911 & G48 (091-69-02)",
    "$": 932700,
    "address": "1600 Beacon St, Unit 911 & G48",
    "parcel_id": "091-69-02",
    "owner1": "AZOULAY, SALOMON",
    "owner2": "",
    "current_taxes": 9550.85,
    "new_taxes_no_override": 9963.45,
    "override_total_1": 10246.15,
    "override_increase_1": 282.71
  },
  {
    "#": "1600 Beacon St, Unit 912 & G91 (091-69-03)",
    "$": 932700,
    "address": "1600 Beacon St, Unit 912 & G91",
    "parcel_id": "091-69-03",
    "owner1": "BUDUO, DEBRA",
    "owner2": "",
    "current_taxes": 5915.91,
    "new_taxes_no_override": 6171.48,
    "override_total_1": 6346.59,
    "override_increase_1": 175.11
  },
  {
    "#": "1600 Beacon St, Unit G17 (091-69-39)",
    "$": 88500,
    "address": "1600 Beacon St, Unit G17",
    "parcel_id": "091-69-39",
    "owner1": "RSVP BEACON LLC",
    "owner2": "",
    "current_taxes": 906.24,
    "new_taxes_no_override": 945.39,
    "override_total_1": 972.21,
    "override_increase_1": 26.82
  },
  {
    "#": "1600 Beacon St, Unit G18 (091-69-37)",
    "$": 90800,
    "address": "1600 Beacon St, Unit G18",
    "parcel_id": "091-69-37",
    "owner1": "METAFORA TRS, ROBERT& DONNA C & CHRISTOPHER",
    "owner2": "MCALOON TRS, JUSTIN",
    "current_taxes": 929.79,
    "new_taxes_no_override": 969.96,
    "override_total_1": 997.48,
    "override_increase_1": 27.52
  },
  {
    "#": "1600 Beacon St, Unit G22 (091-69-38)",
    "$": 90800,
    "address": "1600 Beacon St, Unit G22",
    "parcel_id": "091-69-38",
    "owner1": "SHEPSIS, MICHAEL",
    "owner2": "",
    "current_taxes": 929.79,
    "new_taxes_no_override": 969.96,
    "override_total_1": 997.48,
    "override_increase_1": 27.52
  },
  {
    "#": "1600 Beacon St, Unit G36 (091-69-33)",
    "$": 90800,
    "address": "1600 Beacon St, Unit G36",
    "parcel_id": "091-69-33",
    "owner1": "RADELJEVIC, ANA",
    "owner2": "",
    "current_taxes": 929.79,
    "new_taxes_no_override": 969.96,
    "override_total_1": 997.48,
    "override_increase_1": 27.52
  },
  {
    "#": "1600 Beacon St, Unit G61 (091-69-29)",
    "$": 90800,
    "address": "1600 Beacon St, Unit G61",
    "parcel_id": "091-69-29",
    "owner1": "MARCUS TRS, SANDRA E",
    "owner2": "ONEILL, CHARLES T",
    "current_taxes": 929.79,
    "new_taxes_no_override": 969.96,
    "override_total_1": 997.48,
    "override_increase_1": 27.52
  },
  {
    "#": "1600 Beacon St, Unit G62 (091-69-31)",
    "$": 90800,
    "address": "1600 Beacon St, Unit G62",
    "parcel_id": "091-69-31",
    "owner1": "BAKSHI, SALINA S",
    "owner2": "UPADHYAY, VIVEK",
    "current_taxes": 929.79,
    "new_taxes_no_override": 969.96,
    "override_total_1": 997.48,
    "override_increase_1": 27.52
  },
  {
    "#": "1600 Beacon St, Unit G64 (091-69-32)",
    "$": 90800,
    "address": "1600 Beacon St, Unit G64",
    "parcel_id": "091-69-32",
    "owner1": "BHATIA, SAMIR",
    "owner2": "",
    "current_taxes": 929.79,
    "new_taxes_no_override": 969.96,
    "override_total_1": 997.48,
    "override_increase_1": 27.52
  },
  {
    "#": "1600 Beacon St, Unit G67 (091-69-30)",
    "$": 90800,
    "address": "1600 Beacon St, Unit G67",
    "parcel_id": "091-69-30",
    "owner1": "MITCHELL, MICHAEL",
    "owner2": "",
    "current_taxes": 929.79,
    "new_taxes_no_override": 969.96,
    "override_total_1": 997.48,
    "override_increase_1": 27.52
  },
  {
    "#": "1600 Beacon St, Unit G76 (091-69-35)",
    "$": 90800,
    "address": "1600 Beacon St, Unit G76",
    "parcel_id": "091-69-35",
    "owner1": "FAN, ZIRU",
    "owner2": "",
    "current_taxes": 929.79,
    "new_taxes_no_override": 969.96,
    "override_total_1": 997.48,
    "override_increase_1": 27.52
  },
  {
    "#": "1600 Beacon St, Unit G83 (091-69-27)",
    "$": 90800,
    "address": "1600 Beacon St, Unit G83",
    "parcel_id": "091-69-27",
    "owner1": "PRYNKO, NATALIA",
    "owner2": "",
    "current_taxes": 929.79,
    "new_taxes_no_override": 969.96,
    "override_total_1": 997.48,
    "override_increase_1": 27.52
  },
  {
    "#": "1600 Beacon St, Unit P100 (091-69-41)",
    "$": 52500,
    "address": "1600 Beacon St, Unit P100",
    "parcel_id": "091-69-41",
    "owner1": "TARAZI TRS, E MICHAEL & JEANNIE",
    "owner2": "TARAZI, ZACHARY JOHANN & ELISABETH GERDA",
    "current_taxes": 537.6,
    "new_taxes_no_override": 560.82,
    "override_total_1": 576.74,
    "override_increase_1": 15.91
  },
  {
    "#": "1600 Beacon St, Unit P101 (091-69-42)",
    "$": 52500,
    "address": "1600 Beacon St, Unit P101",
    "parcel_id": "091-69-42",
    "owner1": "TARAZI TRS, E MICHAEL & JEANNIE",
    "owner2": "TARAZI, ZACHARY JOHANN & ELISABETH GERDA",
    "current_taxes": 537.6,
    "new_taxes_no_override": 560.82,
    "override_total_1": 576.74,
    "override_increase_1": 15.91
  },
  {
    "#": "1600 Beacon St, Unit P107 (091-69-36)",
    "$": 49000,
    "address": "1600 Beacon St, Unit P107",
    "parcel_id": "091-69-36",
    "owner1": "RSVP BEACON LLC",
    "owner2": "",
    "current_taxes": 501.76,
    "new_taxes_no_override": 523.44,
    "override_total_1": 538.29,
    "override_increase_1": 14.85
  },
  {
    "#": "1600 Beacon St, Unit P108 (091-69-34)",
    "$": 49000,
    "address": "1600 Beacon St, Unit P108",
    "parcel_id": "091-69-34",
    "owner1": "CATALTEPE, SULE & OGUZ",
    "owner2": "",
    "current_taxes": 501.76,
    "new_taxes_no_override": 523.44,
    "override_total_1": 538.29,
    "override_increase_1": 14.85
  },
  {
    "#": "1600 Beacon St, Unit P115 (091-69-43)",
    "$": 52500,
    "address": "1600 Beacon St, Unit P115",
    "parcel_id": "091-69-43",
    "owner1": "KONISKY, KAREN A & RAYMOND A",
    "owner2": "",
    "current_taxes": 537.6,
    "new_taxes_no_override": 560.82,
    "override_total_1": 576.74,
    "override_increase_1": 15.91
  },
  {
    "#": "1600 Beacon St, Unit P118 (091-69-40)",
    "$": 52500,
    "address": "1600 Beacon St, Unit P118",
    "parcel_id": "091-69-40",
    "owner1": "72 CLYDE STREET LLC",
    "owner2": "",
    "current_taxes": 537.6,
    "new_taxes_no_override": 560.82,
    "override_total_1": 576.74,
    "override_increase_1": 15.91
  },
  {
    "#": "1601 Beacon St, Unit 201 P7-P4 (215-13-01)",
    "$": 1597900,
    "address": "1601 Beacon St, Unit 201 P7-P4",
    "parcel_id": "215-13-01",
    "owner1": "AL-MASRI, GLORIA J",
    "owner2": "",
    "current_taxes": 12727.56,
    "new_taxes_no_override": 13277.39,
    "override_total_1": 13654.13,
    "override_increase_1": 376.74
  },
  {
    "#": "1601 Beacon St, Unit 202 P1-P9 (215-13-02)",
    "$": 1373100,
    "address": "1601 Beacon St, Unit 202 P1-P9",
    "parcel_id": "215-13-02",
    "owner1": "OSTROWSKI, PAUL",
    "owner2": "",
    "current_taxes": 10425.61,
    "new_taxes_no_override": 10876.0,
    "override_total_1": 11184.59,
    "override_increase_1": 308.6
  },
  {
    "#": "1601 Beacon St, Unit 203 P14&11 (215-13-03)",
    "$": 1635800,
    "address": "1601 Beacon St, Unit 203 P14&11",
    "parcel_id": "215-13-03",
    "owner1": "GIORDANO TR, JULIA",
    "owner2": "C/O LOSCALZO ALEX",
    "current_taxes": 16750.59,
    "new_taxes_no_override": 17474.22,
    "override_total_1": 17970.03,
    "override_increase_1": 495.82
  },
  {
    "#": "1601 Beacon St, Unit 301 P6-P5 (215-13-04)",
    "$": 1597900,
    "address": "1601 Beacon St, Unit 301 P6-P5",
    "parcel_id": "215-13-04",
    "owner1": "BLUMENTHAL, MARK A & STEPHANIE J",
    "owner2": "",
    "current_taxes": 12727.56,
    "new_taxes_no_override": 13277.39,
    "override_total_1": 13654.13,
    "override_increase_1": 376.74
  },
  {
    "#": "1601 Beacon St, Unit 302 & P8 (215-13-05)",
    "$": 1330400,
    "address": "1601 Beacon St, Unit 302 & P8",
    "parcel_id": "215-13-05",
    "owner1": "SOROKA TR, DINA",
    "owner2": "GOLDSTEIN, ALAN & STANLEY",
    "current_taxes": 9988.36,
    "new_taxes_no_override": 10419.86,
    "override_total_1": 10715.51,
    "override_increase_1": 295.66
  },
  {
    "#": "1601 Beacon St, Unit 303 & P16 (215-13-06)",
    "$": 1571200,
    "address": "1601 Beacon St, Unit 303 & P16",
    "parcel_id": "215-13-06",
    "owner1": "SCHULTZ, MARC F & DEBRA F",
    "owner2": "",
    "current_taxes": 12454.15,
    "new_taxes_no_override": 12992.17,
    "override_total_1": 13360.81,
    "override_increase_1": 368.64
  },
  {
    "#": "1601 Beacon St, Unit 401 P18-P2 (215-13-07)",
    "$": 1597900,
    "address": "1601 Beacon St, Unit 401 P18-P2",
    "parcel_id": "215-13-07",
    "owner1": "TAGARIS, AMALIA",
    "owner2": "",
    "current_taxes": 12727.56,
    "new_taxes_no_override": 13277.39,
    "override_total_1": 13654.13,
    "override_increase_1": 376.74
  },
  {
    "#": "1601 Beacon St, Unit 402 & P3 (215-13-08)",
    "$": 1309700,
    "address": "1601 Beacon St, Unit 402 & P3",
    "parcel_id": "215-13-08",
    "owner1": "WELLS-FEDERMAN TR, CAROL",
    "owner2": "",
    "current_taxes": 13411.33,
    "new_taxes_no_override": 13990.7,
    "override_total_1": 14387.67,
    "override_increase_1": 396.98
  },
  {
    "#": "1601 Beacon St, Unit 403 & P15 (215-13-09)",
    "$": 1571200,
    "address": "1601 Beacon St, Unit 403 & P15",
    "parcel_id": "215-13-09",
    "owner1": "VAYSBURD, REBECCA",
    "owner2": "",
    "current_taxes": 16089.09,
    "new_taxes_no_override": 16784.14,
    "override_total_1": 17260.38,
    "override_increase_1": 476.24
  },
  {
    "#": "1601 Beacon St, Unit P10 (215-13-11)",
    "$": 49000,
    "address": "1601 Beacon St, Unit P10",
    "parcel_id": "215-13-11",
    "owner1": "SCHULTZ, MARC F & DEBRA F",
    "owner2": "",
    "current_taxes": 501.76,
    "new_taxes_no_override": 523.44,
    "override_total_1": 538.29,
    "override_increase_1": 14.85
  },
  {
    "#": "1601 Beacon St, Unit P12 (215-13-10)",
    "$": 49000,
    "address": "1601 Beacon St, Unit P12",
    "parcel_id": "215-13-10",
    "owner1": "SOROKA, DINA",
    "owner2": "GOLDSTEIN, ALAN & STANLEY",
    "current_taxes": 501.76,
    "new_taxes_no_override": 523.44,
    "override_total_1": 538.29,
    "override_increase_1": 14.85
  },
  {
    "#": "1609 Beacon St (215-12-00)",
    "$": 7904900,
    "address": "1609 Beacon St",
    "parcel_id": "215-12-00",
    "owner1": "ARIEL TRS ET AL, MOSHE & DAVID",
    "owner2": "",
    "current_taxes": 124165.85,
    "new_taxes_no_override": 129529.81,
    "override_total_1": 133205.12,
    "override_increase_1": 3675.31
  },
  {
    "#": "1614 Beacon St, Unit 1 & 2 Pk Sps (092-01-01)",
    "$": 1356600,
    "address": "1614 Beacon St, Unit 1 & 2 Pk Sps",
    "parcel_id": "092-01-01",
    "owner1": "BELKIN, MATTHEW S & LYNN D",
    "owner2": "",
    "current_taxes": 10256.65,
    "new_taxes_no_override": 10699.74,
    "override_total_1": 11003.33,
    "override_increase_1": 303.6
  },
  {
    "#": "1614 Beacon St, Unit 2 &  1 Gar 1 Out  (092-01-02)",
    "$": 2258300,
    "address": "1614 Beacon St, Unit 2 &  1 Gar 1 Out ",
    "parcel_id": "092-01-02",
    "owner1": "LADERBERG TR, ROMNEY K",
    "owner2": "",
    "current_taxes": 23124.99,
    "new_taxes_no_override": 24123.99,
    "override_total_1": 24808.49,
    "override_increase_1": 684.5
  },
  {
    "#": "1616 Beacon St (092-02-00)",
    "$": 3007400,
    "address": "1616 Beacon St",
    "parcel_id": "092-02-00",
    "owner1": "1616 BEACON ST LLC",
    "owner2": "",
    "current_taxes": 30795.78,
    "new_taxes_no_override": 32126.16,
    "override_total_1": 33037.71,
    "override_increase_1": 911.56
  },
  {
    "#": "1618 Beacon St, Unit 1 (092-03-02)",
    "$": 1172400,
    "address": "1618 Beacon St, Unit 1",
    "parcel_id": "092-03-02",
    "owner1": "1618 BEACON STREET DEVELOPMENT LLC",
    "owner2": "",
    "current_taxes": 12005.38,
    "new_taxes_no_override": 12524.01,
    "override_total_1": 12879.37,
    "override_increase_1": 355.36
  },
  {
    "#": "1618 Beacon St, Unit 2 & P4-5 (092-03-03)",
    "$": 1792400,
    "address": "1618 Beacon St, Unit 2 & P4-5",
    "parcel_id": "092-03-03",
    "owner1": "ZHU, WENJIA",
    "owner2": "",
    "current_taxes": 14719.24,
    "new_taxes_no_override": 15355.11,
    "override_total_1": 15790.8,
    "override_increase_1": 435.69
  },
  {
    "#": "1618 Beacon St, Unit 3 & P3 (092-03-04)",
    "$": 655700,
    "address": "1618 Beacon St, Unit 3 & P3",
    "parcel_id": "092-03-04",
    "owner1": "NENACHEVA TRS, ANNA",
    "owner2": "AGRANOVICH TR, LEV",
    "current_taxes": 6714.37,
    "new_taxes_no_override": 7004.43,
    "override_total_1": 7203.18,
    "override_increase_1": 198.75
  },
  {
    "#": "1618 Beacon St, Unit 4 & 2 Gar Sps (092-03-05)",
    "$": 2671800,
    "address": "1618 Beacon St, Unit 4 & 2 Gar Sps",
    "parcel_id": "092-03-05",
    "owner1": "LANGHAMMER TR, DENISE",
    "owner2": "",
    "current_taxes": 27359.23,
    "new_taxes_no_override": 28541.15,
    "override_total_1": 29350.98,
    "override_increase_1": 809.83
  },
  {
    "#": "1618 Beacon St, Unit 5 & P1-2 (092-03-06)",
    "$": 1713100,
    "address": "1618 Beacon St, Unit 5 & P1-2",
    "parcel_id": "092-03-06",
    "owner1": "SHERMAN TRS, ROGER N",
    "owner2": "",
    "current_taxes": 17542.14,
    "new_taxes_no_override": 18299.96,
    "override_total_1": 18819.21,
    "override_increase_1": 519.25
  },
  {
    "#": "1618 Beacon St, Unit C (092-03-01)",
    "$": 158600,
    "address": "1618 Beacon St, Unit C",
    "parcel_id": "092-03-01",
    "owner1": "SEAPORT MEDSPA HOLDINGS LLC",
    "owner2": "",
    "current_taxes": 2721.58,
    "new_taxes_no_override": 2839.15,
    "override_total_1": 2919.71,
    "override_increase_1": 80.56
  },
  {
    "#": "1620 Beacon St (092-04-00)",
    "$": 3534800,
    "address": "1620 Beacon St",
    "parcel_id": "092-04-00",
    "owner1": "1620 BEACON STREET LLC",
    "owner2": "",
    "current_taxes": 52848.36,
    "new_taxes_no_override": 55131.41,
    "override_total_1": 56695.72,
    "override_increase_1": 1564.31
  },
  {
    "#": "1622 Beacon St, Unit A (092-05-00)",
    "$": 2928900,
    "address": "1622 Beacon St, Unit A",
    "parcel_id": "092-05-00",
    "owner1": "YADEGAR-NAGHI, TRS, JEANNETTE",
    "owner2": "DWORK, BERNARD A",
    "current_taxes": 43571.92,
    "new_taxes_no_override": 45454.23,
    "override_total_1": 46743.96,
    "override_increase_1": 1289.73
  },
  {
    "#": "1623 Beacon St (216-17-00)",
    "$": 1585700,
    "address": "1623 Beacon St",
    "parcel_id": "216-17-00",
    "owner1": "WASHINGTON SQ CORNER, PROPERTIES COMPANY LLC",
    "owner2": "",
    "current_taxes": 27210.61,
    "new_taxes_no_override": 28386.11,
    "override_total_1": 29191.54,
    "override_increase_1": 805.43
  },
  {
    "#": "1624 Beacon St (092-06-00)",
    "$": 7166100,
    "address": "1624 Beacon St",
    "parcel_id": "092-06-00",
    "owner1": "KNAPP ENTERPRISES LLC",
    "owner2": "",
    "current_taxes": 122970.28,
    "new_taxes_no_override": 128282.6,
    "override_total_1": 131922.52,
    "override_increase_1": 3639.92
  },
  {
    "#": "1627 Beacon St (216-17-01)",
    "$": 2681300,
    "address": "1627 Beacon St",
    "parcel_id": "216-17-01",
    "owner1": "K & R BROOKLINE REALITY INC",
    "owner2": "",
    "current_taxes": 46011.11,
    "new_taxes_no_override": 47998.79,
    "override_total_1": 49360.72,
    "override_increase_1": 1361.93
  },
  {
    "#": "1629 Beacon St (216-18-00)",
    "$": 3487100,
    "address": "1629 Beacon St",
    "parcel_id": "216-18-00",
    "owner1": "BEACON STREET REALTY LLC",
    "owner2": "",
    "current_taxes": 59838.64,
    "new_taxes_no_override": 62423.67,
    "override_total_1": 64194.89,
    "override_increase_1": 1771.22
  },
  {
    "#": "1634 Beacon St, Unit A (101-01-28)",
    "$": 6500700,
    "address": "1634 Beacon St, Unit A",
    "parcel_id": "101-01-28",
    "owner1": "DALY, TR, GAEL T",
    "owner2": "C/O PREFERRED REALTY CORP",
    "current_taxes": 101655.42,
    "new_taxes_no_override": 106046.93,
    "override_total_1": 109055.93,
    "override_increase_1": 3009.0
  },
  {
    "#": "1641 Beacon St (217-21-22)",
    "$": 9091800,
    "address": "1641 Beacon St",
    "parcel_id": "217-21-22",
    "owner1": "TAW PROPERTIES COMPANY LLC",
    "owner2": "",
    "current_taxes": 156015.29,
    "new_taxes_no_override": 162755.15,
    "override_total_1": 167373.2,
    "override_increase_1": 4618.05
  },
  {
    "#": "1646 Beacon St (101-02-00)",
    "$": 4122800,
    "address": "1646 Beacon St",
    "parcel_id": "101-02-00",
    "owner1": "SEAGLASS ASSOCIATES  LLP",
    "owner2": "C/O SALTER & KAHN INC",
    "current_taxes": 70747.25,
    "new_taxes_no_override": 73803.53,
    "override_total_1": 75897.65,
    "override_increase_1": 2094.12
  },
  {
    "#": "1653 Beacon St, Unit A (217-23-00)",
    "$": 3927300,
    "address": "1653 Beacon St, Unit A",
    "parcel_id": "217-23-00",
    "owner1": "ALT PROPERTIES COMPANY LLC",
    "owner2": "",
    "current_taxes": 67392.47,
    "new_taxes_no_override": 70303.82,
    "override_total_1": 72298.64,
    "override_increase_1": 1994.82
  },
  {
    "#": "1657 Beacon St (217-24-25)",
    "$": 4437100,
    "address": "1657 Beacon St",
    "parcel_id": "217-24-25",
    "owner1": "WERNICK PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 76140.64,
    "new_taxes_no_override": 79429.92,
    "override_total_1": 81683.68,
    "override_increase_1": 2253.76
  },
  {
    "#": "1658 Beacon St (101-03-00)",
    "$": 3659100,
    "address": "1658 Beacon St",
    "parcel_id": "101-03-00",
    "owner1": "CHEW ET AL TRS, JERRY",
    "owner2": "",
    "current_taxes": 37469.18,
    "new_taxes_no_override": 39087.85,
    "override_total_1": 40196.94,
    "override_increase_1": 1109.09
  },
  {
    "#": "1665 Beacon St, Unit A (224-31-00)",
    "$": 4125000,
    "address": "1665 Beacon St, Unit A",
    "parcel_id": "224-31-00",
    "owner1": "RASA REALTY LLC",
    "owner2": "",
    "current_taxes": 70785.0,
    "new_taxes_no_override": 73842.91,
    "override_total_1": 75938.15,
    "override_increase_1": 2095.24
  },
  {
    "#": "1668 Beacon St (101-04-05)",
    "$": 5580100,
    "address": "1668 Beacon St",
    "parcel_id": "101-04-05",
    "owner1": "STANETSKY MEMORIAL CHAPELS INC",
    "owner2": "C/O SCI MANAGEMENT, ATTN PROP TAX DEPT",
    "current_taxes": 95754.52,
    "new_taxes_no_override": 99891.12,
    "override_total_1": 102725.45,
    "override_increase_1": 2834.33
  },
  {
    "#": "1673 Beacon St (224-29-30)",
    "$": 11983500,
    "address": "1673 Beacon St",
    "parcel_id": "224-29-30",
    "owner1": "STAVROU LIMITED PARTNERSHIP",
    "owner2": "",
    "current_taxes": 125195.04,
    "new_taxes_no_override": 130603.47,
    "override_total_1": 134309.24,
    "override_increase_1": 3705.77
  },
  {
    "#": "1674 Beacon St (101-06-00)",
    "$": 2553900,
    "address": "1674 Beacon St",
    "parcel_id": "101-06-00",
    "owner1": "FUCHS, TR, ILYA",
    "owner2": "C/O KIRZNER & FUCHS LLC",
    "current_taxes": 41030.3,
    "new_taxes_no_override": 42802.81,
    "override_total_1": 44017.31,
    "override_increase_1": 1214.5
  },
  {
    "#": "1676 Beacon St (101-07-00)",
    "$": 2285800,
    "address": "1676 Beacon St",
    "parcel_id": "101-07-00",
    "owner1": "SHAHROOZ, FARHAD & SUSAN A",
    "owner2": "",
    "current_taxes": 30950.08,
    "new_taxes_no_override": 32287.12,
    "override_total_1": 33203.25,
    "override_increase_1": 916.12
  },
  {
    "#": "1678 Beacon St (101-08-00)",
    "$": 2531800,
    "address": "1678 Beacon St",
    "parcel_id": "101-08-00",
    "owner1": "ARIEL, ET AL TRS, MOSHE",
    "owner2": "",
    "current_taxes": 40845.15,
    "new_taxes_no_override": 42609.66,
    "override_total_1": 43818.68,
    "override_increase_1": 1209.02
  },
  {
    "#": "1680 Beacon St (101-09-00)",
    "$": 3415400,
    "address": "1680 Beacon St",
    "parcel_id": "101-09-00",
    "owner1": "ARIEL, ET AL TRS, DAVID",
    "owner2": "",
    "current_taxes": 55811.7,
    "new_taxes_no_override": 58222.77,
    "override_total_1": 59874.79,
    "override_increase_1": 1652.03
  },
  {
    "#": "1682 Beacon St (101-10-00)",
    "$": 3520100,
    "address": "1682 Beacon St",
    "parcel_id": "101-10-00",
    "owner1": "SMZ REALTY LLC",
    "owner2": "",
    "current_taxes": 53635.22,
    "new_taxes_no_override": 55952.26,
    "override_total_1": 57539.86,
    "override_increase_1": 1587.6
  },
  {
    "#": "1683 Beacon St (224-28-00)",
    "$": 2461600,
    "address": "1683 Beacon St",
    "parcel_id": "224-28-00",
    "owner1": "1683 BEACON STREET LLC",
    "owner2": "",
    "current_taxes": 33043.3,
    "new_taxes_no_override": 34470.77,
    "override_total_1": 35448.85,
    "override_increase_1": 978.08
  },
  {
    "#": "1684 Beacon St (101-11-00)",
    "$": 3569300,
    "address": "1684 Beacon St",
    "parcel_id": "101-11-00",
    "owner1": "BEACON 19 PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 48091.06,
    "new_taxes_no_override": 50168.59,
    "override_total_1": 51592.09,
    "override_increase_1": 1423.5
  },
  {
    "#": "1685 Beacon St (224-27-00)",
    "$": 2411700,
    "address": "1685 Beacon St",
    "parcel_id": "224-27-00",
    "owner1": "1685 BEACON STREET LLC",
    "owner2": "",
    "current_taxes": 30036.3,
    "new_taxes_no_override": 31333.87,
    "override_total_1": 32222.94,
    "override_increase_1": 889.07
  },
  {
    "#": "1688 Beacon St (101-12-00)",
    "$": 10135300,
    "address": "1688 Beacon St",
    "parcel_id": "101-12-00",
    "owner1": "1688-1694 BEACON STREET LLC",
    "owner2": "",
    "current_taxes": 103785.47,
    "new_taxes_no_override": 108269.0,
    "override_total_1": 111341.05,
    "override_increase_1": 3072.05
  },
  {
    "#": "1689 Beacon St (224-26-00)",
    "$": 3666000,
    "address": "1689 Beacon St",
    "parcel_id": "224-26-00",
    "owner1": "1689 BEACON LLC",
    "owner2": "",
    "current_taxes": 37539.84,
    "new_taxes_no_override": 39161.56,
    "override_total_1": 40272.74,
    "override_increase_1": 1111.18
  },
  {
    "#": "1691 Beacon St, Unit 1 & 3 Park (224-25-02)",
    "$": 868200,
    "address": "1691 Beacon St, Unit 1 & 3 Park",
    "parcel_id": "224-25-02",
    "owner1": "GALLI LLC",
    "owner2": "",
    "current_taxes": 14898.31,
    "new_taxes_no_override": 15541.92,
    "override_total_1": 15982.91,
    "override_increase_1": 440.99
  },
  {
    "#": "1691 Beacon St, Unit 2 & P2 (224-25-03)",
    "$": 968500,
    "address": "1691 Beacon St, Unit 2 & P2",
    "parcel_id": "224-25-03",
    "owner1": "GALLI LLC",
    "owner2": "",
    "current_taxes": 9917.44,
    "new_taxes_no_override": 10345.87,
    "override_total_1": 10639.43,
    "override_increase_1": 293.56
  },
  {
    "#": "1691 Beacon St, Unit 3 (224-25-04)",
    "$": 906000,
    "address": "1691 Beacon St, Unit 3",
    "parcel_id": "224-25-04",
    "owner1": "GALLI LLC",
    "owner2": "",
    "current_taxes": 9277.44,
    "new_taxes_no_override": 9678.23,
    "override_total_1": 9952.84,
    "override_increase_1": 274.61
  },
  {
    "#": "1691 Beacon St, Unit B 3 Pk Sps (224-25-01)",
    "$": 1034600,
    "address": "1691 Beacon St, Unit B 3 Pk Sps",
    "parcel_id": "224-25-01",
    "owner1": "GALLI LLC",
    "owner2": "",
    "current_taxes": 17753.74,
    "new_taxes_no_override": 18520.7,
    "override_total_1": 19046.21,
    "override_increase_1": 525.51
  },
  {
    "#": "1693 Beacon St (224-24-00)",
    "$": 3050900,
    "address": "1693 Beacon St",
    "parcel_id": "224-24-00",
    "owner1": "VALENTE, TR, BENEDETTO",
    "owner2": "",
    "current_taxes": 34479.71,
    "new_taxes_no_override": 35969.23,
    "override_total_1": 36989.83,
    "override_increase_1": 1020.6
  },
  {
    "#": "1694 Beacon St (101-13-00)",
    "$": 6194100,
    "address": "1694 Beacon St",
    "parcel_id": "101-13-00",
    "owner1": "1688-1694 BEACON STREET LLC",
    "owner2": "",
    "current_taxes": 63427.58,
    "new_taxes_no_override": 66167.65,
    "override_total_1": 68045.11,
    "override_increase_1": 1877.46
  },
  {
    "#": "1696 Beacon St (101-14-00)",
    "$": 5564800,
    "address": "1696 Beacon St",
    "parcel_id": "101-14-00",
    "owner1": "EVANGELAKOS, TR, CHARLES C",
    "owner2": "",
    "current_taxes": 95491.97,
    "new_taxes_no_override": 99617.22,
    "override_total_1": 102443.79,
    "override_increase_1": 2826.56
  },
  {
    "#": "1705 Beacon St (225-24-25)",
    "$": 1235400,
    "address": "1705 Beacon St",
    "parcel_id": "225-24-25",
    "owner1": "TA BROOKLINE LLC",
    "owner2": "",
    "current_taxes": 21199.46,
    "new_taxes_no_override": 22115.28,
    "override_total_1": 22742.78,
    "override_increase_1": 627.5
  },
  {
    "#": "1710 Beacon St (102-01-00)",
    "$": 2977100,
    "address": "1710 Beacon St",
    "parcel_id": "102-01-00",
    "owner1": "CONGREGATION MACHSEKE TORAH &, BETH PINCHAS",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "1712 Beacon St (102-02-00)",
    "$": 1841800,
    "address": "1712 Beacon St",
    "parcel_id": "102-02-00",
    "owner1": "SLD 1712 BEACON LLC",
    "owner2": "C/O MARC SCHWARTZ MGR",
    "current_taxes": 23409.13,
    "new_taxes_no_override": 24420.4,
    "override_total_1": 25113.31,
    "override_increase_1": 692.91
  },
  {
    "#": "1714 Beacon St (102-03-00)",
    "$": 2058900,
    "address": "1714 Beacon St",
    "parcel_id": "102-03-00",
    "owner1": "AMF CO INC",
    "owner2": "",
    "current_taxes": 25752.57,
    "new_taxes_no_override": 26865.08,
    "override_total_1": 27627.36,
    "override_increase_1": 762.28
  },
  {
    "#": "1716 Beacon St (102-04-00)",
    "$": 2886800,
    "address": "1716 Beacon St",
    "parcel_id": "102-04-00",
    "owner1": "LORCH TRS, DANNA M & JEFFREY K",
    "owner2": "",
    "current_taxes": 29560.83,
    "new_taxes_no_override": 30837.86,
    "override_total_1": 31712.86,
    "override_increase_1": 875.0
  },
  {
    "#": "1717 Beacon St (225-26-00)",
    "$": 10443000,
    "address": "1717 Beacon St",
    "parcel_id": "225-26-00",
    "owner1": "TA BROOKLINE LLC",
    "owner2": "",
    "current_taxes": 179201.88,
    "new_taxes_no_override": 186943.4,
    "override_total_1": 192247.78,
    "override_increase_1": 5304.38
  },
  {
    "#": "1718 Beacon St (102-05-00)",
    "$": 2466800,
    "address": "1718 Beacon St",
    "parcel_id": "102-05-00",
    "owner1": "1718 BEACON STREET LLC",
    "owner2": "",
    "current_taxes": 25260.03,
    "new_taxes_no_override": 26351.26,
    "override_total_1": 27098.96,
    "override_increase_1": 747.7
  },
  {
    "#": "1720 Beacon St (102-06-00)",
    "$": 2750000,
    "address": "1720 Beacon St",
    "parcel_id": "102-06-00",
    "owner1": "SLD 1720 BEACON LLC",
    "owner2": "",
    "current_taxes": 32139.87,
    "new_taxes_no_override": 33528.31,
    "override_total_1": 34479.65,
    "override_increase_1": 951.34
  },
  {
    "#": "1722 Beacon St (102-07-00)",
    "$": 2590100,
    "address": "1722 Beacon St",
    "parcel_id": "102-07-00",
    "owner1": "HAMBLIN JR TRS, BRUCE W & ELLEN R",
    "owner2": "C/O 1722 BEACON ST REALTY",
    "current_taxes": 26522.62,
    "new_taxes_no_override": 27668.4,
    "override_total_1": 28453.47,
    "override_increase_1": 785.07
  },
  {
    "#": "1724 Beacon St, Unit 1 & Pk Sp A (102-08-01)",
    "$": 572100,
    "address": "1724 Beacon St, Unit 1 & Pk Sp A",
    "parcel_id": "102-08-01",
    "owner1": "BOGDANOV, ALEXANDER",
    "owner2": "BOGDANOVA, TATYANA",
    "current_taxes": 2223.37,
    "new_taxes_no_override": 2319.42,
    "override_total_1": 2385.23,
    "override_increase_1": 65.81
  },
  {
    "#": "1724 Beacon St, Unit 2 & Pk Sp B (102-08-02)",
    "$": 1080100,
    "address": "1724 Beacon St, Unit 2 & Pk Sp B",
    "parcel_id": "102-08-02",
    "owner1": "PATEL- JUNANKAR, DIPU",
    "owner2": "",
    "current_taxes": 7425.29,
    "new_taxes_no_override": 7746.06,
    "override_total_1": 7965.85,
    "override_increase_1": 219.79
  },
  {
    "#": "1724 Beacon St, Unit 3 & Pk Sp C (102-08-03)",
    "$": 1481900,
    "address": "1724 Beacon St, Unit 3 & Pk Sp C",
    "parcel_id": "102-08-03",
    "owner1": "WINKELMAN, HENRY T & MARIANNE K",
    "owner2": "",
    "current_taxes": 11539.72,
    "new_taxes_no_override": 12038.24,
    "override_total_1": 12379.81,
    "override_increase_1": 341.58
  },
  {
    "#": "1726 Beacon St (102-09-00)",
    "$": 2309200,
    "address": "1726 Beacon St",
    "parcel_id": "102-09-00",
    "owner1": "SLD 1726 BEACON LLC",
    "owner2": "",
    "current_taxes": 23646.21,
    "new_taxes_no_override": 24667.73,
    "override_total_1": 25367.65,
    "override_increase_1": 699.93
  },
  {
    "#": "1728 Beacon St (102-10-00)",
    "$": 2579900,
    "address": "1728 Beacon St",
    "parcel_id": "102-10-00",
    "owner1": "SCHWARTZ, TRS, MARC R & HOWARD",
    "owner2": "",
    "current_taxes": 26418.18,
    "new_taxes_no_override": 27559.45,
    "override_total_1": 28341.42,
    "override_increase_1": 781.98
  },
  {
    "#": "1730 Beacon St (102-11-00)",
    "$": 2831600,
    "address": "1730 Beacon St",
    "parcel_id": "102-11-00",
    "owner1": "R O F E H INC",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "1731 Beacon St, Unit 1002 P160 (225-28-73)",
    "$": 806200,
    "address": "1731 Beacon St, Unit 1002 P160",
    "parcel_id": "225-28-73",
    "owner1": "SCHILLER TRS, MIKHAIL & SOPHIE",
    "owner2": "",
    "current_taxes": 8255.49,
    "new_taxes_no_override": 8612.13,
    "override_total_1": 8856.49,
    "override_increase_1": 244.36
  },
  {
    "#": "1731 Beacon St, Unit 1003 P226 (225-28-74)",
    "$": 1178900,
    "address": "1731 Beacon St, Unit 1003 P226",
    "parcel_id": "225-28-74",
    "owner1": "LANA REALTY 1003 LLC",
    "owner2": "",
    "current_taxes": 12071.94,
    "new_taxes_no_override": 12593.45,
    "override_total_1": 12950.78,
    "override_increase_1": 357.33
  },
  {
    "#": "1731 Beacon St, Unit 1004 & P31 (225-28-75)",
    "$": 806200,
    "address": "1731 Beacon St, Unit 1004 & P31",
    "parcel_id": "225-28-75",
    "owner1": "CLAYMAN TRS, JUDITH",
    "owner2": "",
    "current_taxes": 8255.49,
    "new_taxes_no_override": 8612.13,
    "override_total_1": 8856.49,
    "override_increase_1": 244.36
  },
  {
    "#": "1731 Beacon St, Unit 1006 & P45 (225-28-76)",
    "$": 683400,
    "address": "1731 Beacon St, Unit 1006 & P45",
    "parcel_id": "225-28-76",
    "owner1": "BURDENKO TRS, MICHAEL N & GALINA B",
    "owner2": "",
    "current_taxes": 6998.02,
    "new_taxes_no_override": 7300.33,
    "override_total_1": 7507.48,
    "override_increase_1": 207.14
  },
  {
    "#": "1731 Beacon St, Unit 1007 P191 (225-28-77)",
    "$": 642500,
    "address": "1731 Beacon St, Unit 1007 P191",
    "parcel_id": "225-28-77",
    "owner1": "GORDON, TR, SIDNEY",
    "owner2": "",
    "current_taxes": 6579.2,
    "new_taxes_no_override": 6863.42,
    "override_total_1": 7058.17,
    "override_increase_1": 194.74
  },
  {
    "#": "1731 Beacon St, Unit 1008 P142 (225-28-78)",
    "$": 655200,
    "address": "1731 Beacon St, Unit 1008 P142",
    "parcel_id": "225-28-78",
    "owner1": "MAIDEN TR, BORIS B",
    "owner2": "",
    "current_taxes": 6709.25,
    "new_taxes_no_override": 6999.09,
    "override_total_1": 7197.68,
    "override_increase_1": 198.59
  },
  {
    "#": "1731 Beacon St, Unit 1009 & P72 (225-28-79)",
    "$": 642500,
    "address": "1731 Beacon St, Unit 1009 & P72",
    "parcel_id": "225-28-79",
    "owner1": "ETCOVITCH, ERIC M",
    "owner2": "",
    "current_taxes": 2944.27,
    "new_taxes_no_override": 3071.46,
    "override_total_1": 3158.61,
    "override_increase_1": 87.15
  },
  {
    "#": "1731 Beacon St, Unit 101 & P174 (225-27-08)",
    "$": 873300,
    "address": "1731 Beacon St, Unit 101 & P174",
    "parcel_id": "225-27-08",
    "owner1": "HOU, PETER CHUANYI",
    "owner2": "RUIKO, ISHII",
    "current_taxes": 5307.66,
    "new_taxes_no_override": 5536.95,
    "override_total_1": 5694.06,
    "override_increase_1": 157.11
  },
  {
    "#": "1731 Beacon St, Unit 1010 & P37 (225-28-80)",
    "$": 850300,
    "address": "1731 Beacon St, Unit 1010 & P37",
    "parcel_id": "225-28-80",
    "owner1": "KAUFMAN, MERAV",
    "owner2": "MANGOUBI, OREN RAMI",
    "current_taxes": 5072.14,
    "new_taxes_no_override": 5291.26,
    "override_total_1": 5441.39,
    "override_increase_1": 150.14
  },
  {
    "#": "1731 Beacon St, Unit 1011 & P63 (225-28-81)",
    "$": 654800,
    "address": "1731 Beacon St, Unit 1011 & P63",
    "parcel_id": "225-28-81",
    "owner1": "CHENG, HAIING",
    "owner2": "LIU, PIXU",
    "current_taxes": 6705.15,
    "new_taxes_no_override": 6994.81,
    "override_total_1": 7193.28,
    "override_increase_1": 198.47
  },
  {
    "#": "1731 Beacon St, Unit 1013 &P192 (225-28-82)",
    "$": 638300,
    "address": "1731 Beacon St, Unit 1013 &P192",
    "parcel_id": "225-28-82",
    "owner1": "SHAGRIN TRS, JONATHAN M & BARBARA E",
    "owner2": "",
    "current_taxes": 6536.19,
    "new_taxes_no_override": 6818.55,
    "override_total_1": 7012.02,
    "override_increase_1": 193.47
  },
  {
    "#": "1731 Beacon St, Unit 1015 & P28 (225-28-83)",
    "$": 726400,
    "address": "1731 Beacon St, Unit 1015 & P28",
    "parcel_id": "225-28-83",
    "owner1": "HYMAN , MARA & JULIAN & FRANCINE",
    "owner2": "",
    "current_taxes": 3803.4,
    "new_taxes_no_override": 3967.71,
    "override_total_1": 4080.29,
    "override_increase_1": 112.58
  },
  {
    "#": "1731 Beacon St, Unit 102 & P47 (225-27-09)",
    "$": 707600,
    "address": "1731 Beacon St, Unit 102 & P47",
    "parcel_id": "225-27-09",
    "owner1": "SNEIRSON TR, ROBERT",
    "owner2": "",
    "current_taxes": 7245.82,
    "new_taxes_no_override": 7558.84,
    "override_total_1": 7773.32,
    "override_increase_1": 214.48
  },
  {
    "#": "1731 Beacon St, Unit 104 & P220 (225-27-10)",
    "$": 707600,
    "address": "1731 Beacon St, Unit 104 & P220",
    "parcel_id": "225-27-10",
    "owner1": "VOURAS, LISA",
    "owner2": "",
    "current_taxes": 7245.82,
    "new_taxes_no_override": 7558.84,
    "override_total_1": 7773.32,
    "override_increase_1": 214.48
  },
  {
    "#": "1731 Beacon St, Unit 105 & P224 (225-27-11)",
    "$": 587200,
    "address": "1731 Beacon St, Unit 105 & P224",
    "parcel_id": "225-27-11",
    "owner1": "SKOLER, SHEREE P",
    "owner2": "",
    "current_taxes": 2377.99,
    "new_taxes_no_override": 2480.72,
    "override_total_1": 2551.11,
    "override_increase_1": 70.39
  },
  {
    "#": "1731 Beacon St, Unit 106 & P27 (225-27-12)",
    "$": 574300,
    "address": "1731 Beacon St, Unit 106 & P27",
    "parcel_id": "225-27-12",
    "owner1": "BELITSKY TRS, BORIS & ELENA",
    "owner2": "",
    "current_taxes": 5880.83,
    "new_taxes_no_override": 6134.88,
    "override_total_1": 6308.95,
    "override_increase_1": 174.07
  },
  {
    "#": "1731 Beacon St, Unit 107 & P118 (225-27-13)",
    "$": 594500,
    "address": "1731 Beacon St, Unit 107 & P118",
    "parcel_id": "225-27-13",
    "owner1": "PAN, WEIKANG",
    "owner2": "WU, ALI",
    "current_taxes": 2452.75,
    "new_taxes_no_override": 2558.71,
    "override_total_1": 2631.31,
    "override_increase_1": 72.6
  },
  {
    "#": "1731 Beacon St, Unit 108 & P130 (225-27-14)",
    "$": 602100,
    "address": "1731 Beacon St, Unit 108 & P130",
    "parcel_id": "225-27-14",
    "owner1": "FOZDAR, MANISH A & RITA M",
    "owner2": "",
    "current_taxes": 6165.5,
    "new_taxes_no_override": 6431.85,
    "override_total_1": 6614.35,
    "override_increase_1": 182.5
  },
  {
    "#": "1731 Beacon St, Unit 109 & P136 (225-27-15)",
    "$": 581800,
    "address": "1731 Beacon St, Unit 109 & P136",
    "parcel_id": "225-27-15",
    "owner1": "JIANG, ZHEN Y",
    "owner2": "ZHOU, QING LIN",
    "current_taxes": 5957.63,
    "new_taxes_no_override": 6215.0,
    "override_total_1": 6391.35,
    "override_increase_1": 176.35
  },
  {
    "#": "1731 Beacon St, Unit 110  & P17 (225-27-16)",
    "$": 686700,
    "address": "1731 Beacon St, Unit 110  & P17",
    "parcel_id": "225-27-16",
    "owner1": "BRODSKAYA, MARINA",
    "owner2": "AYZICHEK, ALFRED",
    "current_taxes": 3396.87,
    "new_taxes_no_override": 3543.61,
    "override_total_1": 3644.16,
    "override_increase_1": 100.55
  },
  {
    "#": "1731 Beacon St, Unit 1102 P107 (225-28-84)",
    "$": 806200,
    "address": "1731 Beacon St, Unit 1102 P107",
    "parcel_id": "225-28-84",
    "owner1": "TALI, ALI RAKHSHANDEH",
    "owner2": "HAJHARIRI, SIMA",
    "current_taxes": 4620.55,
    "new_taxes_no_override": 4820.16,
    "override_total_1": 4956.93,
    "override_increase_1": 136.77
  },
  {
    "#": "1731 Beacon St, Unit 1103 P109 (225-28-85)",
    "$": 1259900,
    "address": "1731 Beacon St, Unit 1103 P109",
    "parcel_id": "225-28-85",
    "owner1": "SPECTOR TRS, MYRON & JOANNE",
    "owner2": "",
    "current_taxes": 12901.38,
    "new_taxes_no_override": 13458.72,
    "override_total_1": 13840.6,
    "override_increase_1": 381.88
  },
  {
    "#": "1731 Beacon St, Unit 1104 & P52 (225-28-86)",
    "$": 868100,
    "address": "1731 Beacon St, Unit 1104 & P52",
    "parcel_id": "225-28-86",
    "owner1": "LEVITON, ALAN & ROBERTA E",
    "owner2": "",
    "current_taxes": 8889.34,
    "new_taxes_no_override": 9273.36,
    "override_total_1": 9536.48,
    "override_increase_1": 263.12
  },
  {
    "#": "1731 Beacon St, Unit 1106 & P61 (225-28-87)",
    "$": 665000,
    "address": "1731 Beacon St, Unit 1106 & P61",
    "parcel_id": "225-28-87",
    "owner1": "WISEMAN, SUSAN",
    "owner2": "",
    "current_taxes": 3174.67,
    "new_taxes_no_override": 3311.82,
    "override_total_1": 3405.79,
    "override_increase_1": 93.97
  },
  {
    "#": "1731 Beacon St, Unit 1107 & P85 (225-28-88)",
    "$": 642500,
    "address": "1731 Beacon St, Unit 1107 & P85",
    "parcel_id": "225-28-88",
    "owner1": "WOODHOUSE, BETTY F",
    "owner2": "",
    "current_taxes": 2944.27,
    "new_taxes_no_override": 3071.46,
    "override_total_1": 3158.61,
    "override_increase_1": 87.15
  },
  {
    "#": "1731 Beacon St, Unit 1108 & P19 (225-28-89)",
    "$": 652700,
    "address": "1731 Beacon St, Unit 1108 & P19",
    "parcel_id": "225-28-89",
    "owner1": "REYNOLDS TRS, CATHERINE M & DOULGAS J",
    "owner2": "",
    "current_taxes": 6683.65,
    "new_taxes_no_override": 6972.38,
    "override_total_1": 7170.22,
    "override_increase_1": 197.84
  },
  {
    "#": "1731 Beacon St, Unit 1109 & P67 (225-28-90)",
    "$": 642500,
    "address": "1731 Beacon St, Unit 1109 & P67",
    "parcel_id": "225-28-90",
    "owner1": "DUPRE TR, CLAUDIA J",
    "owner2": "",
    "current_taxes": 2944.27,
    "new_taxes_no_override": 3071.46,
    "override_total_1": 3158.61,
    "override_increase_1": 87.15
  },
  {
    "#": "1731 Beacon St, Unit 111 & P225 (225-27-17)",
    "$": 608500,
    "address": "1731 Beacon St, Unit 111 & P225",
    "parcel_id": "225-27-17",
    "owner1": "BALMAZI TR, LEON",
    "owner2": "",
    "current_taxes": 6231.04,
    "new_taxes_no_override": 6500.22,
    "override_total_1": 6684.66,
    "override_increase_1": 184.44
  },
  {
    "#": "1731 Beacon St, Unit 1110 & P20 (225-28-91)",
    "$": 850300,
    "address": "1731 Beacon St, Unit 1110 & P20",
    "parcel_id": "225-28-91",
    "owner1": "ANSE LLC",
    "owner2": "",
    "current_taxes": 8707.07,
    "new_taxes_no_override": 9083.22,
    "override_total_1": 9340.94,
    "override_increase_1": 257.73
  },
  {
    "#": "1731 Beacon St, Unit 1111 P154 (225-28-92)",
    "$": 642500,
    "address": "1731 Beacon St, Unit 1111 P154",
    "parcel_id": "225-28-92",
    "owner1": "GREEN, NATHAN & SHONA N",
    "owner2": "",
    "current_taxes": 2944.27,
    "new_taxes_no_override": 3071.46,
    "override_total_1": 3158.61,
    "override_increase_1": 87.15
  },
  {
    "#": "1731 Beacon St, Unit 1113 P162 (225-28-93)",
    "$": 686800,
    "address": "1731 Beacon St, Unit 1113 P162",
    "parcel_id": "225-28-93",
    "owner1": "SCHILLER, ILYA",
    "owner2": "",
    "current_taxes": 7032.83,
    "new_taxes_no_override": 7336.65,
    "override_total_1": 7544.82,
    "override_increase_1": 208.17
  },
  {
    "#": "1731 Beacon St, Unit 1115 P164 (225-28-94)",
    "$": 726400,
    "address": "1731 Beacon St, Unit 1115 P164",
    "parcel_id": "225-28-94",
    "owner1": "PRINKO, PAVEL A",
    "owner2": "",
    "current_taxes": 7438.34,
    "new_taxes_no_override": 7759.68,
    "override_total_1": 7979.85,
    "override_increase_1": 220.17
  },
  {
    "#": "1731 Beacon St, Unit 113 G-133 (225-27-18)",
    "$": 566800,
    "address": "1731 Beacon St, Unit 113 G-133",
    "parcel_id": "225-27-18",
    "owner1": "SUH, EDWIN",
    "owner2": "HOU, SHUIQUING",
    "current_taxes": 5804.03,
    "new_taxes_no_override": 6054.76,
    "override_total_1": 6226.56,
    "override_increase_1": 171.8
  },
  {
    "#": "1731 Beacon St, Unit 114 & P70 (225-27-19)",
    "$": 928200,
    "address": "1731 Beacon St, Unit 114 & P70",
    "parcel_id": "225-27-19",
    "owner1": "1731-114 BEACON LLC",
    "owner2": "",
    "current_taxes": 9504.77,
    "new_taxes_no_override": 9915.38,
    "override_total_1": 10196.72,
    "override_increase_1": 281.34
  },
  {
    "#": "1731 Beacon St, Unit 115 & P179 (225-27-20)",
    "$": 590900,
    "address": "1731 Beacon St, Unit 115 & P179",
    "parcel_id": "225-27-20",
    "owner1": "TAWA, LUCILLE",
    "owner2": "",
    "current_taxes": 2415.88,
    "new_taxes_no_override": 2520.25,
    "override_total_1": 2591.76,
    "override_increase_1": 71.51
  },
  {
    "#": "1731 Beacon St, Unit 116 & P208 (225-27-21)",
    "$": 855800,
    "address": "1731 Beacon St, Unit 116 & P208",
    "parcel_id": "225-27-21",
    "owner1": "JIANG, ZHEN",
    "owner2": "ZHOU, QIONGLIN",
    "current_taxes": 5128.46,
    "new_taxes_no_override": 5350.01,
    "override_total_1": 5501.81,
    "override_increase_1": 151.8
  },
  {
    "#": "1731 Beacon St, Unit 118 & P201 (225-27-22)",
    "$": 852400,
    "address": "1731 Beacon St, Unit 118 & P201",
    "parcel_id": "225-27-22",
    "owner1": "SOLOMON, KATHLEEN DAVIS & ISAAC H S",
    "owner2": "",
    "current_taxes": 5093.64,
    "new_taxes_no_override": 5313.69,
    "override_total_1": 5464.46,
    "override_increase_1": 150.77
  },
  {
    "#": "1731 Beacon St, Unit 119&P121 (225-27-23)",
    "$": 622400,
    "address": "1731 Beacon St, Unit 119&P121",
    "parcel_id": "225-27-23",
    "owner1": "BHAN, PARDAMAN S&HARPAL K& AMAN",
    "owner2": "",
    "current_taxes": 6373.38,
    "new_taxes_no_override": 6648.71,
    "override_total_1": 6837.36,
    "override_increase_1": 188.65
  },
  {
    "#": "1731 Beacon St, Unit 120 & P186 (225-27-24)",
    "$": 759200,
    "address": "1731 Beacon St, Unit 120 & P186",
    "parcel_id": "225-27-24",
    "owner1": "HOLZER, JACOB C & HELEN E",
    "owner2": "",
    "current_taxes": 4139.27,
    "new_taxes_no_override": 4318.09,
    "override_total_1": 4440.61,
    "override_increase_1": 122.52
  },
  {
    "#": "1731 Beacon St, Unit 1202 & P48 (225-28-95)",
    "$": 806200,
    "address": "1731 Beacon St, Unit 1202 & P48",
    "parcel_id": "225-28-95",
    "owner1": "COLBY TR, ANDREA",
    "owner2": "",
    "current_taxes": 4620.55,
    "new_taxes_no_override": 4820.16,
    "override_total_1": 4956.93,
    "override_increase_1": 136.77
  },
  {
    "#": "1731 Beacon St, Unit 1203 P104 (225-28-96)",
    "$": 1284700,
    "address": "1731 Beacon St, Unit 1203 P104",
    "parcel_id": "225-28-96",
    "owner1": "ALLON, YOTAM",
    "owner2": "MALKIN, BRACHA",
    "current_taxes": 9520.39,
    "new_taxes_no_override": 9931.67,
    "override_total_1": 10213.47,
    "override_increase_1": 281.8
  },
  {
    "#": "1731 Beacon St, Unit 1204 & P77 (225-28-97)",
    "$": 830700,
    "address": "1731 Beacon St, Unit 1204 & P77",
    "parcel_id": "225-28-97",
    "owner1": "LEVIN TR, GEDALY",
    "owner2": "",
    "current_taxes": 8506.37,
    "new_taxes_no_override": 8873.85,
    "override_total_1": 9125.63,
    "override_increase_1": 251.79
  },
  {
    "#": "1731 Beacon St, Unit 1206 & G-3 (225-28-98)",
    "$": 689500,
    "address": "1731 Beacon St, Unit 1206 & G-3",
    "parcel_id": "225-28-98",
    "owner1": "IBSB LINE LLC",
    "owner2": "",
    "current_taxes": 7060.48,
    "new_taxes_no_override": 7365.49,
    "override_total_1": 7574.48,
    "override_increase_1": 208.99
  },
  {
    "#": "1731 Beacon St, Unit 1207 & P76 (225-28-99)",
    "$": 683000,
    "address": "1731 Beacon St, Unit 1207 & P76",
    "parcel_id": "225-28-99",
    "owner1": "BASKIN, GENNADY & EMMA",
    "owner2": "",
    "current_taxes": 6993.92,
    "new_taxes_no_override": 7296.06,
    "override_total_1": 7503.08,
    "override_increase_1": 207.02
  },
  {
    "#": "1731 Beacon St, Unit 1208 & P51 (225-29-01)",
    "$": 665000,
    "address": "1731 Beacon St, Unit 1208 & P51",
    "parcel_id": "225-29-01",
    "owner1": "QIU, YILING",
    "owner2": "FANG, ZI",
    "current_taxes": 6809.6,
    "new_taxes_no_override": 7103.77,
    "override_total_1": 7305.34,
    "override_increase_1": 201.56
  },
  {
    "#": "1731 Beacon St, Unit 1209 P173 (225-29-02)",
    "$": 689100,
    "address": "1731 Beacon St, Unit 1209 P173",
    "parcel_id": "225-29-02",
    "owner1": "KESNER, JEFFREY",
    "owner2": "",
    "current_taxes": 7056.38,
    "new_taxes_no_override": 7361.22,
    "override_total_1": 7570.08,
    "override_increase_1": 208.87
  },
  {
    "#": "1731 Beacon St, Unit 1210 P132 (225-29-03)",
    "$": 850300,
    "address": "1731 Beacon St, Unit 1210 P132",
    "parcel_id": "225-29-03",
    "owner1": "VOLYNSKAYA, JULIA",
    "owner2": "",
    "current_taxes": 5072.14,
    "new_taxes_no_override": 5291.26,
    "override_total_1": 5441.39,
    "override_increase_1": 150.14
  },
  {
    "#": "1731 Beacon St, Unit 1211 P180 (225-29-04)",
    "$": 673300,
    "address": "1731 Beacon St, Unit 1211 P180",
    "parcel_id": "225-29-04",
    "owner1": "ENNIS, ALEXANDER C",
    "owner2": "",
    "current_taxes": 3259.66,
    "new_taxes_no_override": 3400.48,
    "override_total_1": 3496.96,
    "override_increase_1": 96.49
  },
  {
    "#": "1731 Beacon St, Unit 1213 G-19 (225-29-05)",
    "$": 624700,
    "address": "1731 Beacon St, Unit 1213 G-19",
    "parcel_id": "225-29-05",
    "owner1": "TANG, GUI LING HU",
    "owner2": "LIN, CATHRINE",
    "current_taxes": 6396.93,
    "new_taxes_no_override": 6673.28,
    "override_total_1": 6862.63,
    "override_increase_1": 189.35
  },
  {
    "#": "1731 Beacon St, Unit 1215 & P36 (225-29-06)",
    "$": 665000,
    "address": "1731 Beacon St, Unit 1215 & P36",
    "parcel_id": "225-29-06",
    "owner1": "ZAYAS, INNA",
    "owner2": "",
    "current_taxes": 3174.67,
    "new_taxes_no_override": 3311.82,
    "override_total_1": 3405.79,
    "override_increase_1": 93.97
  },
  {
    "#": "1731 Beacon St, Unit 124 & P181 (225-27-25)",
    "$": 873300,
    "address": "1731 Beacon St, Unit 124 & P181",
    "parcel_id": "225-27-25",
    "owner1": "REGENCY PARK 124 LLC",
    "owner2": "",
    "current_taxes": 8942.59,
    "new_taxes_no_override": 9328.91,
    "override_total_1": 9593.61,
    "override_increase_1": 264.7
  },
  {
    "#": "1731 Beacon St, Unit 125 & P222 (225-27-26)",
    "$": 853300,
    "address": "1731 Beacon St, Unit 125 & P222",
    "parcel_id": "225-27-26",
    "owner1": "WENZEL-DONOVAN, HILARIE LORN",
    "owner2": "",
    "current_taxes": 5102.86,
    "new_taxes_no_override": 5323.3,
    "override_total_1": 5474.35,
    "override_increase_1": 151.04
  },
  {
    "#": "1731 Beacon St, Unit 1402 & P14 (225-29-07)",
    "$": 817600,
    "address": "1731 Beacon St, Unit 1402 & P14",
    "parcel_id": "225-29-07",
    "owner1": "MONTERO, BEATRIZ",
    "owner2": "PASSARO, DESIREE",
    "current_taxes": 8372.22,
    "new_taxes_no_override": 8733.9,
    "override_total_1": 8981.72,
    "override_increase_1": 247.82
  },
  {
    "#": "1731 Beacon St, Unit 1403 P203 (225-29-08)",
    "$": 1259900,
    "address": "1731 Beacon St, Unit 1403 P203",
    "parcel_id": "225-29-08",
    "owner1": "GOLDSTEIN, ALAN",
    "owner2": "SPIEL, MELISSA",
    "current_taxes": 9266.44,
    "new_taxes_no_override": 9666.75,
    "override_total_1": 9941.04,
    "override_increase_1": 274.29
  },
  {
    "#": "1731 Beacon St, Unit 1404 & P108 (225-29-09)",
    "$": 806200,
    "address": "1731 Beacon St, Unit 1404 & P108",
    "parcel_id": "225-29-09",
    "owner1": "ANDERSON, DEBORAH",
    "owner2": "",
    "current_taxes": 4620.55,
    "new_taxes_no_override": 4820.16,
    "override_total_1": 4956.93,
    "override_increase_1": 136.77
  },
  {
    "#": "1731 Beacon St, Unit 1406 G-13 (225-29-10)",
    "$": 702100,
    "address": "1731 Beacon St, Unit 1406 G-13",
    "parcel_id": "225-29-10",
    "owner1": "HEFFRON, ELIZABETH S",
    "owner2": "",
    "current_taxes": 7189.5,
    "new_taxes_no_override": 7500.09,
    "override_total_1": 7712.9,
    "override_increase_1": 212.81
  },
  {
    "#": "1731 Beacon St, Unit 1407 & P43 (225-29-11)",
    "$": 715700,
    "address": "1731 Beacon St, Unit 1407 & P43",
    "parcel_id": "225-29-11",
    "owner1": "LATIFPOUR, ROUDABEH",
    "owner2": "",
    "current_taxes": 3693.83,
    "new_taxes_no_override": 3853.4,
    "override_total_1": 3962.74,
    "override_increase_1": 109.34
  },
  {
    "#": "1731 Beacon St, Unit 1408 & P15 (225-29-12)",
    "$": 719800,
    "address": "1731 Beacon St, Unit 1408 & P15",
    "parcel_id": "225-29-12",
    "owner1": "SCHWARTZ, JEFFREY G & LAURA",
    "owner2": "",
    "current_taxes": 7370.75,
    "new_taxes_no_override": 7689.17,
    "override_total_1": 7907.34,
    "override_increase_1": 218.17
  },
  {
    "#": "1731 Beacon St, Unit 1409 & P91 (225-29-13)",
    "$": 661000,
    "address": "1731 Beacon St, Unit 1409 & P91",
    "parcel_id": "225-29-13",
    "owner1": "WISE, MARCIA & NATHAN",
    "owner2": "",
    "current_taxes": 3133.71,
    "new_taxes_no_override": 3269.09,
    "override_total_1": 3361.84,
    "override_increase_1": 92.76
  },
  {
    "#": "1731 Beacon St, Unit 1410 & P92 (225-29-14)",
    "$": 850300,
    "address": "1731 Beacon St, Unit 1410 & P92",
    "parcel_id": "225-29-14",
    "owner1": "WIDOFF, SHELLEY G",
    "owner2": "",
    "current_taxes": 5072.14,
    "new_taxes_no_override": 5291.26,
    "override_total_1": 5441.39,
    "override_increase_1": 150.14
  },
  {
    "#": "1731 Beacon St, Unit 1411 & P35 (225-29-15)",
    "$": 656900,
    "address": "1731 Beacon St, Unit 1411 & P35",
    "parcel_id": "225-29-15",
    "owner1": "KARIMI, ALI",
    "owner2": "",
    "current_taxes": 3091.72,
    "new_taxes_no_override": 3225.28,
    "override_total_1": 3316.8,
    "override_increase_1": 91.51
  },
  {
    "#": "1731 Beacon St, Unit 1413 & P24 (225-29-16)",
    "$": 640400,
    "address": "1731 Beacon St, Unit 1413 & P24",
    "parcel_id": "225-29-16",
    "owner1": "ATINIZIAN, ARI D",
    "owner2": "",
    "current_taxes": 2922.76,
    "new_taxes_no_override": 3049.02,
    "override_total_1": 3135.54,
    "override_increase_1": 86.51
  },
  {
    "#": "1731 Beacon St, Unit 1415 P155 (225-29-17)",
    "$": 667000,
    "address": "1731 Beacon St, Unit 1415 P155",
    "parcel_id": "225-29-17",
    "owner1": "SAYABOVORN, AJCHARA",
    "owner2": "",
    "current_taxes": 3195.15,
    "new_taxes_no_override": 3333.18,
    "override_total_1": 3427.76,
    "override_increase_1": 94.58
  },
  {
    "#": "1731 Beacon St, Unit 1502 & P10 (225-29-18)",
    "$": 830600,
    "address": "1731 Beacon St, Unit 1502 & P10",
    "parcel_id": "225-29-18",
    "owner1": "WU, SHANG & BAO CHEN",
    "owner2": "",
    "current_taxes": 8505.34,
    "new_taxes_no_override": 8872.77,
    "override_total_1": 9124.53,
    "override_increase_1": 251.76
  },
  {
    "#": "1731 Beacon St, Unit 1503 & P64 (225-29-19)",
    "$": 1211900,
    "address": "1731 Beacon St, Unit 1503 & P64",
    "parcel_id": "225-29-19",
    "owner1": "LOZADA, ITALO G-NANCY B-IGOR A",
    "owner2": "",
    "current_taxes": 8774.92,
    "new_taxes_no_override": 9154.0,
    "override_total_1": 9413.73,
    "override_increase_1": 259.74
  },
  {
    "#": "1731 Beacon St, Unit 1504&P40 (225-29-20)",
    "$": 886800,
    "address": "1731 Beacon St, Unit 1504&P40",
    "parcel_id": "225-29-20",
    "owner1": "PETRUZZIELLO TR, GINA",
    "owner2": "",
    "current_taxes": 5445.9,
    "new_taxes_no_override": 5681.16,
    "override_total_1": 5842.36,
    "override_increase_1": 161.2
  },
  {
    "#": "1731 Beacon St, Unit 1506& P126 (225-29-21)",
    "$": 634300,
    "address": "1731 Beacon St, Unit 1506& P126",
    "parcel_id": "225-29-21",
    "owner1": "PETRUZZIELLO TR, GINA",
    "owner2": "",
    "current_taxes": 6495.23,
    "new_taxes_no_override": 6775.82,
    "override_total_1": 6968.08,
    "override_increase_1": 192.26
  },
  {
    "#": "1731 Beacon St, Unit 1507 P105 (225-29-22)",
    "$": 715600,
    "address": "1731 Beacon St, Unit 1507 P105",
    "parcel_id": "225-29-22",
    "owner1": "MIRA PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 7327.74,
    "new_taxes_no_override": 7644.3,
    "override_total_1": 7861.2,
    "override_increase_1": 216.9
  },
  {
    "#": "1731 Beacon St, Unit 1508 P165 (225-29-23)",
    "$": 689400,
    "address": "1731 Beacon St, Unit 1508 P165",
    "parcel_id": "225-29-23",
    "owner1": "SMITH TR, MARILYN T",
    "owner2": "",
    "current_taxes": 3424.52,
    "new_taxes_no_override": 3572.46,
    "override_total_1": 3673.83,
    "override_increase_1": 101.37
  },
  {
    "#": "1731 Beacon St, Unit 1509 & P56 (225-29-24)",
    "$": 656900,
    "address": "1731 Beacon St, Unit 1509 & P56",
    "parcel_id": "225-29-24",
    "owner1": "KOOCHER, TRS, NINA S",
    "owner2": "",
    "current_taxes": 6726.66,
    "new_taxes_no_override": 7017.25,
    "override_total_1": 7216.36,
    "override_increase_1": 199.11
  },
  {
    "#": "1731 Beacon St, Unit 1511 P177 (225-29-25)",
    "$": 715700,
    "address": "1731 Beacon St, Unit 1511 P177",
    "parcel_id": "225-29-25",
    "owner1": "FUCHS, CAROLIN",
    "owner2": "",
    "current_taxes": 3693.83,
    "new_taxes_no_override": 3853.4,
    "override_total_1": 3962.74,
    "override_increase_1": 109.34
  },
  {
    "#": "1731 Beacon St, Unit 1513 & P58 (225-29-26)",
    "$": 638200,
    "address": "1731 Beacon St, Unit 1513 & P58",
    "parcel_id": "225-29-26",
    "owner1": "AVDOKHIN, ALEXEY & ELENA",
    "owner2": "",
    "current_taxes": 6535.17,
    "new_taxes_no_override": 6817.49,
    "override_total_1": 7010.93,
    "override_increase_1": 193.44
  },
  {
    "#": "1731 Beacon St, Unit 1515 & P7 (225-29-27)",
    "$": 676200,
    "address": "1731 Beacon St, Unit 1515 & P7",
    "parcel_id": "225-29-27",
    "owner1": "KAUFMAN TR, LYDIA S",
    "owner2": "",
    "current_taxes": 3289.35,
    "new_taxes_no_override": 3431.45,
    "override_total_1": 3528.81,
    "override_increase_1": 97.36
  },
  {
    "#": "1731 Beacon St, Unit 202 & P59 (225-27-27)",
    "$": 787500,
    "address": "1731 Beacon St, Unit 202 & P59",
    "parcel_id": "225-27-27",
    "owner1": "WONG, ALBERT Y",
    "owner2": "CHAN, HOW-CHING F",
    "current_taxes": 8064.0,
    "new_taxes_no_override": 8412.36,
    "override_total_1": 8651.06,
    "override_increase_1": 238.69
  },
  {
    "#": "1731 Beacon St, Unit 203 & P197 (225-27-28)",
    "$": 506800,
    "address": "1731 Beacon St, Unit 203 & P197",
    "parcel_id": "225-27-28",
    "owner1": "COHEN, ANNALEE",
    "owner2": "",
    "current_taxes": 5189.63,
    "new_taxes_no_override": 5413.82,
    "override_total_1": 5567.44,
    "override_increase_1": 153.61
  },
  {
    "#": "1731 Beacon St, Unit 204 & P167 (225-27-29)",
    "$": 758400,
    "address": "1731 Beacon St, Unit 204 & P167",
    "parcel_id": "225-27-29",
    "owner1": "COLLINS, WILLIAM J & PIEDAD M",
    "owner2": "",
    "current_taxes": 7766.02,
    "new_taxes_no_override": 8101.51,
    "override_total_1": 8331.39,
    "override_increase_1": 229.87
  },
  {
    "#": "1731 Beacon St, Unit 205 & P122 (225-27-30)",
    "$": 578800,
    "address": "1731 Beacon St, Unit 205 & P122",
    "parcel_id": "225-27-30",
    "owner1": "LERRA TRS, THOMAS R & LOIS M",
    "owner2": "",
    "current_taxes": 5926.91,
    "new_taxes_no_override": 6182.95,
    "override_total_1": 6358.39,
    "override_increase_1": 175.44
  },
  {
    "#": "1731 Beacon St, Unit 206 & P134 (225-27-31)",
    "$": 687400,
    "address": "1731 Beacon St, Unit 206 & P134",
    "parcel_id": "225-27-31",
    "owner1": "IBSB LINE LLC",
    "owner2": "",
    "current_taxes": 7038.98,
    "new_taxes_no_override": 7343.06,
    "override_total_1": 7551.42,
    "override_increase_1": 208.35
  },
  {
    "#": "1731 Beacon St, Unit 207 & P215 (225-27-32)",
    "$": 673300,
    "address": "1731 Beacon St, Unit 207 & P215",
    "parcel_id": "225-27-32",
    "owner1": "ABRAMS TR, DIANE",
    "owner2": "",
    "current_taxes": 3259.66,
    "new_taxes_no_override": 3400.48,
    "override_total_1": 3496.96,
    "override_increase_1": 96.49
  },
  {
    "#": "1731 Beacon St, Unit 208 & P137 (225-27-33)",
    "$": 634600,
    "address": "1731 Beacon St, Unit 208 & P137",
    "parcel_id": "225-27-33",
    "owner1": "MILLER TRS, CHRISTOPHER & ABIGAIL K",
    "owner2": "",
    "current_taxes": 2863.37,
    "new_taxes_no_override": 2987.07,
    "override_total_1": 3071.82,
    "override_increase_1": 84.76
  },
  {
    "#": "1731 Beacon St, Unit 209 & P119 (225-27-34)",
    "$": 636000,
    "address": "1731 Beacon St, Unit 209 & P119",
    "parcel_id": "225-27-34",
    "owner1": "XIAO, YUE",
    "owner2": "",
    "current_taxes": 2877.71,
    "new_taxes_no_override": 3002.03,
    "override_total_1": 3087.21,
    "override_increase_1": 85.18
  },
  {
    "#": "1731 Beacon St, Unit 210 & P178 (225-27-35)",
    "$": 758400,
    "address": "1731 Beacon St, Unit 210 & P178",
    "parcel_id": "225-27-35",
    "owner1": "RUDNICK TR, LESLEE A",
    "owner2": "",
    "current_taxes": 7766.02,
    "new_taxes_no_override": 8101.51,
    "override_total_1": 8331.39,
    "override_increase_1": 229.87
  },
  {
    "#": "1731 Beacon St, Unit 211 & P135 (225-27-36)",
    "$": 594700,
    "address": "1731 Beacon St, Unit 211 & P135",
    "parcel_id": "225-27-36",
    "owner1": "KARAA, SHOREH T & FADI",
    "owner2": "",
    "current_taxes": 6089.73,
    "new_taxes_no_override": 6352.81,
    "override_total_1": 6533.06,
    "override_increase_1": 180.26
  },
  {
    "#": "1731 Beacon St, Unit 213 & P93 (225-27-37)",
    "$": 579800,
    "address": "1731 Beacon St, Unit 213 & P93",
    "parcel_id": "225-27-37",
    "owner1": "BLUMBERG, MARK A",
    "owner2": "",
    "current_taxes": 5937.15,
    "new_taxes_no_override": 6193.63,
    "override_total_1": 6369.37,
    "override_increase_1": 175.74
  },
  {
    "#": "1731 Beacon St, Unit 215 & P166 (225-27-38)",
    "$": 683400,
    "address": "1731 Beacon St, Unit 215 & P166",
    "parcel_id": "225-27-38",
    "owner1": "YEUNG, JEAN N",
    "owner2": "",
    "current_taxes": 3363.08,
    "new_taxes_no_override": 3508.37,
    "override_total_1": 3607.91,
    "override_increase_1": 99.55
  },
  {
    "#": "1731 Beacon St, Unit 217 & P187 (225-27-39)",
    "$": 777800,
    "address": "1731 Beacon St, Unit 217 & P187",
    "parcel_id": "225-27-39",
    "owner1": "BACHMAN TRS, ROBERT & LAURETTE",
    "owner2": "",
    "current_taxes": 7964.67,
    "new_taxes_no_override": 8308.74,
    "override_total_1": 8544.5,
    "override_increase_1": 235.75
  },
  {
    "#": "1731 Beacon St, Unit 219 & P159 (225-27-40)",
    "$": 602100,
    "address": "1731 Beacon St, Unit 219 & P159",
    "parcel_id": "225-27-40",
    "owner1": "CADBURY AMBER LLC",
    "owner2": "",
    "current_taxes": 6165.5,
    "new_taxes_no_override": 6431.85,
    "override_total_1": 6614.35,
    "override_increase_1": 182.5
  },
  {
    "#": "1731 Beacon St, Unit 221 & P74 (225-27-41)",
    "$": 682700,
    "address": "1731 Beacon St, Unit 221 & P74",
    "parcel_id": "225-27-41",
    "owner1": "RASHKOVSKY TR, ZHANNA",
    "owner2": "",
    "current_taxes": 3355.91,
    "new_taxes_no_override": 3500.89,
    "override_total_1": 3600.22,
    "override_increase_1": 99.33
  },
  {
    "#": "1731 Beacon St, Unit 222 & P12 (225-27-42)",
    "$": 479000,
    "address": "1731 Beacon St, Unit 222 & P12",
    "parcel_id": "225-27-42",
    "owner1": "CELLI, ROMULO K",
    "owner2": "",
    "current_taxes": 4904.96,
    "new_taxes_no_override": 5116.85,
    "override_total_1": 5262.04,
    "override_increase_1": 145.19
  },
  {
    "#": "1731 Beacon St, Unit 223 & P212 (225-27-43)",
    "$": 473900,
    "address": "1731 Beacon St, Unit 223 & P212",
    "parcel_id": "225-27-43",
    "owner1": "HUVOS TRS, MONIQUE C & PHILIP A",
    "owner2": "",
    "current_taxes": 4852.74,
    "new_taxes_no_override": 5062.38,
    "override_total_1": 5206.02,
    "override_increase_1": 143.64
  },
  {
    "#": "1731 Beacon St, Unit 301 & P97 (225-27-44)",
    "$": 486900,
    "address": "1731 Beacon St, Unit 301 & P97",
    "parcel_id": "225-27-44",
    "owner1": "LI, QIYUAN",
    "owner2": "",
    "current_taxes": 4985.86,
    "new_taxes_no_override": 5201.25,
    "override_total_1": 5348.83,
    "override_increase_1": 147.58
  },
  {
    "#": "1731 Beacon St, Unit 302 & P98 (225-27-45)",
    "$": 767000,
    "address": "1731 Beacon St, Unit 302 & P98",
    "parcel_id": "225-27-45",
    "owner1": "LEGOR, CAROLINE WHITNEY",
    "owner2": "",
    "current_taxes": 7854.08,
    "new_taxes_no_override": 8193.38,
    "override_total_1": 8425.86,
    "override_increase_1": 232.48
  },
  {
    "#": "1731 Beacon St, Unit 303 & P190 (225-27-46)",
    "$": 491900,
    "address": "1731 Beacon St, Unit 303 & P190",
    "parcel_id": "225-27-46",
    "owner1": "GRANOFF TRS, CHARLES A & ANGEL CANADA",
    "owner2": "",
    "current_taxes": 5037.06,
    "new_taxes_no_override": 5254.66,
    "override_total_1": 5403.76,
    "override_increase_1": 149.1
  },
  {
    "#": "1731 Beacon St, Unit 304 & P73 (225-27-47)",
    "$": 758400,
    "address": "1731 Beacon St, Unit 304 & P73",
    "parcel_id": "225-27-47",
    "owner1": "TYAGI, SATISH K",
    "owner2": "",
    "current_taxes": 7766.02,
    "new_taxes_no_override": 8101.51,
    "override_total_1": 8331.39,
    "override_increase_1": 229.87
  },
  {
    "#": "1731 Beacon St, Unit 305 & P11 (225-27-48)",
    "$": 578800,
    "address": "1731 Beacon St, Unit 305 & P11",
    "parcel_id": "225-27-48",
    "owner1": "RABONOVITZ, TR, MICHAEL",
    "owner2": "",
    "current_taxes": 5926.91,
    "new_taxes_no_override": 6182.95,
    "override_total_1": 6358.39,
    "override_increase_1": 175.44
  },
  {
    "#": "1731 Beacon St, Unit 306 & P136 (225-27-49)",
    "$": 655200,
    "address": "1731 Beacon St, Unit 306 & P136",
    "parcel_id": "225-27-49",
    "owner1": "BROWN LIFE ESTATE, PHYLLIS",
    "owner2": "C/O BROWN, LARRY",
    "current_taxes": 6709.25,
    "new_taxes_no_override": 6999.09,
    "override_total_1": 7197.68,
    "override_increase_1": 198.59
  },
  {
    "#": "1731 Beacon St, Unit 307 & P120 (225-27-50)",
    "$": 594700,
    "address": "1731 Beacon St, Unit 307 & P120",
    "parcel_id": "225-27-50",
    "owner1": "MOSNER, ELLEN",
    "owner2": "",
    "current_taxes": 6089.73,
    "new_taxes_no_override": 6352.81,
    "override_total_1": 6533.06,
    "override_increase_1": 180.26
  },
  {
    "#": "1731 Beacon St, Unit 308 & P147 (225-27-51)",
    "$": 634300,
    "address": "1731 Beacon St, Unit 308 & P147",
    "parcel_id": "225-27-51",
    "owner1": "IMBER, MICHELLE L",
    "owner2": "",
    "current_taxes": 2860.3,
    "new_taxes_no_override": 2983.86,
    "override_total_1": 3068.53,
    "override_increase_1": 84.66
  },
  {
    "#": "1731 Beacon St, Unit 309 & P140 (225-27-52)",
    "$": 666700,
    "address": "1731 Beacon St, Unit 309 & P140",
    "parcel_id": "225-27-52",
    "owner1": "WIENER, MONA & MARTIN D",
    "owner2": "",
    "current_taxes": 6827.01,
    "new_taxes_no_override": 7121.94,
    "override_total_1": 7324.02,
    "override_increase_1": 202.08
  },
  {
    "#": "1731 Beacon St, Unit 310 & P57 (225-27-53)",
    "$": 758400,
    "address": "1731 Beacon St, Unit 310 & P57",
    "parcel_id": "225-27-53",
    "owner1": "CAPTAIIN CANDYCE LLC",
    "owner2": "",
    "current_taxes": 7766.02,
    "new_taxes_no_override": 8101.51,
    "override_total_1": 8331.39,
    "override_increase_1": 229.87
  },
  {
    "#": "1731 Beacon St, Unit 311 & P146 (225-27-54)",
    "$": 594700,
    "address": "1731 Beacon St, Unit 311 & P146",
    "parcel_id": "225-27-54",
    "owner1": "1731 BEACON STREET LLC",
    "owner2": "",
    "current_taxes": 6089.73,
    "new_taxes_no_override": 6352.81,
    "override_total_1": 6533.06,
    "override_increase_1": 180.26
  },
  {
    "#": "1731 Beacon St, Unit 312 (225-27-55)",
    "$": 587300,
    "address": "1731 Beacon St, Unit 312",
    "parcel_id": "225-27-55",
    "owner1": "MEZRAHI, AIDA",
    "owner2": "",
    "current_taxes": 2379.02,
    "new_taxes_no_override": 2481.79,
    "override_total_1": 2552.21,
    "override_increase_1": 70.42
  },
  {
    "#": "1731 Beacon St, Unit 313 & P143 (225-27-56)",
    "$": 588700,
    "address": "1731 Beacon St, Unit 313 & P143",
    "parcel_id": "225-27-56",
    "owner1": "GATELY, JOHN",
    "owner2": "",
    "current_taxes": 2393.35,
    "new_taxes_no_override": 2496.74,
    "override_total_1": 2567.59,
    "override_increase_1": 70.84
  },
  {
    "#": "1731 Beacon St, Unit 314 & P113 (225-27-57)",
    "$": 501800,
    "address": "1731 Beacon St, Unit 314 & P113",
    "parcel_id": "225-27-57",
    "owner1": "LANA REALTY 314 LLC",
    "owner2": "",
    "current_taxes": 5138.43,
    "new_taxes_no_override": 5360.41,
    "override_total_1": 5512.51,
    "override_increase_1": 152.1
  },
  {
    "#": "1731 Beacon St, Unit 315 & P54 (225-27-58)",
    "$": 683400,
    "address": "1731 Beacon St, Unit 315 & P54",
    "parcel_id": "225-27-58",
    "owner1": "KORNBERG LIFE ESTATE, RACHEL",
    "owner2": "C/O NEIL ARESTY",
    "current_taxes": 6998.02,
    "new_taxes_no_override": 7300.33,
    "override_total_1": 7507.48,
    "override_increase_1": 207.14
  },
  {
    "#": "1731 Beacon St, Unit 316 & P5 (225-27-59)",
    "$": 481700,
    "address": "1731 Beacon St, Unit 316 & P5",
    "parcel_id": "225-27-59",
    "owner1": "MIKHEYEVA, YELENA",
    "owner2": "",
    "current_taxes": 4932.61,
    "new_taxes_no_override": 5145.7,
    "override_total_1": 5291.7,
    "override_increase_1": 146.01
  },
  {
    "#": "1731 Beacon St, Unit 317 & P65 (225-27-60)",
    "$": 829800,
    "address": "1731 Beacon St, Unit 317 & P65",
    "parcel_id": "225-27-60",
    "owner1": "APELSTEIN TRS, JAMES & NATALIA",
    "owner2": "",
    "current_taxes": 4862.22,
    "new_taxes_no_override": 5072.27,
    "override_total_1": 5216.19,
    "override_increase_1": 143.92
  },
  {
    "#": "1731 Beacon St, Unit 318 & P101 (225-27-61)",
    "$": 505600,
    "address": "1731 Beacon St, Unit 318 & P101",
    "parcel_id": "225-27-61",
    "owner1": "SHNAYDER, OLGA & LYUDMILA",
    "owner2": "",
    "current_taxes": 1542.41,
    "new_taxes_no_override": 1609.04,
    "override_total_1": 1654.7,
    "override_increase_1": 45.66
  },
  {
    "#": "1731 Beacon St, Unit 319 G-211 (225-27-62)",
    "$": 665000,
    "address": "1731 Beacon St, Unit 319 G-211",
    "parcel_id": "225-27-62",
    "owner1": "KURTZ, SHARYN LYNN",
    "owner2": "",
    "current_taxes": 3174.67,
    "new_taxes_no_override": 3311.82,
    "override_total_1": 3405.79,
    "override_increase_1": 93.97
  },
  {
    "#": "1731 Beacon St, Unit 320 & P209 (225-27-63)",
    "$": 486900,
    "address": "1731 Beacon St, Unit 320 & P209",
    "parcel_id": "225-27-63",
    "owner1": "STICH, MICHELLE",
    "owner2": "",
    "current_taxes": 4985.86,
    "new_taxes_no_override": 5201.25,
    "override_total_1": 5348.83,
    "override_increase_1": 147.58
  },
  {
    "#": "1731 Beacon St, Unit 321 & P8 (225-27-64)",
    "$": 687000,
    "address": "1731 Beacon St, Unit 321 & P8",
    "parcel_id": "225-27-64",
    "owner1": "WAYNE, RICHARD D",
    "owner2": "",
    "current_taxes": 3399.95,
    "new_taxes_no_override": 3546.83,
    "override_total_1": 3647.47,
    "override_increase_1": 100.64
  },
  {
    "#": "1731 Beacon St, Unit 322 & G-84 (225-27-65)",
    "$": 506800,
    "address": "1731 Beacon St, Unit 322 & G-84",
    "parcel_id": "225-27-65",
    "owner1": "ELIAHOU LIFE ESTATE , SHOSHANA",
    "owner2": "",
    "current_taxes": 1554.7,
    "new_taxes_no_override": 1621.86,
    "override_total_1": 1667.88,
    "override_increase_1": 46.02
  },
  {
    "#": "1731 Beacon St, Unit 323 & P4 (225-27-66)",
    "$": 486900,
    "address": "1731 Beacon St, Unit 323 & P4",
    "parcel_id": "225-27-66",
    "owner1": "SHRIBER, MIA S",
    "owner2": "",
    "current_taxes": 1350.92,
    "new_taxes_no_override": 1409.28,
    "override_total_1": 1449.27,
    "override_increase_1": 39.99
  },
  {
    "#": "1731 Beacon St, Unit 324 & P66 (225-27-67)",
    "$": 547600,
    "address": "1731 Beacon St, Unit 324 & P66",
    "parcel_id": "225-27-67",
    "owner1": "SCHWARTZ TR, DAVID A",
    "owner2": "",
    "current_taxes": 5607.42,
    "new_taxes_no_override": 5849.66,
    "override_total_1": 6015.64,
    "override_increase_1": 165.98
  },
  {
    "#": "1731 Beacon St, Unit 325 & P46 (225-27-68)",
    "$": 473900,
    "address": "1731 Beacon St, Unit 325 & P46",
    "parcel_id": "225-27-68",
    "owner1": "ALTMAN, DAVID S",
    "owner2": "",
    "current_taxes": 4852.74,
    "new_taxes_no_override": 5062.38,
    "override_total_1": 5206.02,
    "override_increase_1": 143.64
  },
  {
    "#": "1731 Beacon St, Unit 401 & P115 (225-27-69)",
    "$": 473900,
    "address": "1731 Beacon St, Unit 401 & P115",
    "parcel_id": "225-27-69",
    "owner1": "1731 B LLC",
    "owner2": "",
    "current_taxes": 4852.74,
    "new_taxes_no_override": 5062.38,
    "override_total_1": 5206.02,
    "override_increase_1": 143.64
  },
  {
    "#": "1731 Beacon St, Unit 402 & P185 (225-27-70)",
    "$": 850300,
    "address": "1731 Beacon St, Unit 402 & P185",
    "parcel_id": "225-27-70",
    "owner1": "MILLER, KAREN J",
    "owner2": "",
    "current_taxes": 5072.14,
    "new_taxes_no_override": 5291.26,
    "override_total_1": 5441.39,
    "override_increase_1": 150.14
  },
  {
    "#": "1731 Beacon St, Unit 403 & P117 (225-27-71)",
    "$": 479000,
    "address": "1731 Beacon St, Unit 403 & P117",
    "parcel_id": "225-27-71",
    "owner1": "RUSSO, TR, ROBERT W",
    "owner2": "",
    "current_taxes": 4904.96,
    "new_taxes_no_override": 5116.85,
    "override_total_1": 5262.04,
    "override_increase_1": 145.19
  },
  {
    "#": "1731 Beacon St, Unit 404 & P150 (225-27-72)",
    "$": 839700,
    "address": "1731 Beacon St, Unit 404 & P150",
    "parcel_id": "225-27-72",
    "owner1": "ANSE LLC",
    "owner2": "",
    "current_taxes": 8598.53,
    "new_taxes_no_override": 8969.99,
    "override_total_1": 9224.5,
    "override_increase_1": 254.52
  },
  {
    "#": "1731 Beacon St, Unit 405 & P213 (225-27-73)",
    "$": 578800,
    "address": "1731 Beacon St, Unit 405 & P213",
    "parcel_id": "225-27-73",
    "owner1": "LOZADA RIVAS, ITALO A-IGOR A-NANCY M",
    "owner2": "",
    "current_taxes": 5926.91,
    "new_taxes_no_override": 6182.95,
    "override_total_1": 6358.39,
    "override_increase_1": 175.44
  },
  {
    "#": "1731 Beacon St, Unit 406 & P129 (225-27-74)",
    "$": 587300,
    "address": "1731 Beacon St, Unit 406 & P129",
    "parcel_id": "225-27-74",
    "owner1": "ALTMAN, LEAH",
    "owner2": "",
    "current_taxes": 2379.02,
    "new_taxes_no_override": 2481.79,
    "override_total_1": 2552.21,
    "override_increase_1": 70.42
  },
  {
    "#": "1731 Beacon St, Unit 407 & P210 (225-27-75)",
    "$": 673200,
    "address": "1731 Beacon St, Unit 407 & P210",
    "parcel_id": "225-27-75",
    "owner1": "AMIOT, DIANNE REDMOND & JOSEPH EDWARD",
    "owner2": "",
    "current_taxes": 6893.57,
    "new_taxes_no_override": 7191.37,
    "override_total_1": 7395.42,
    "override_increase_1": 204.05
  },
  {
    "#": "1731 Beacon St, Unit 408 & P139 (225-27-76)",
    "$": 658500,
    "address": "1731 Beacon St, Unit 408 & P139",
    "parcel_id": "225-27-76",
    "owner1": "SHON-BAKER TR, RITA SHAO-LIN",
    "owner2": "",
    "current_taxes": 6743.04,
    "new_taxes_no_override": 7034.34,
    "override_total_1": 7233.93,
    "override_increase_1": 199.59
  },
  {
    "#": "1731 Beacon St, Unit 409 G-151 (225-27-77)",
    "$": 594700,
    "address": "1731 Beacon St, Unit 409 G-151",
    "parcel_id": "225-27-77",
    "owner1": "GRUSZKA TR, CAROLE J",
    "owner2": "",
    "current_taxes": 2454.79,
    "new_taxes_no_override": 2560.84,
    "override_total_1": 2633.5,
    "override_increase_1": 72.66
  },
  {
    "#": "1731 Beacon St, Unit 410 & P33 (225-27-78)",
    "$": 758400,
    "address": "1731 Beacon St, Unit 410 & P33",
    "parcel_id": "225-27-78",
    "owner1": "GORDON, ROBERT & PHYLLIS",
    "owner2": "",
    "current_taxes": 4131.08,
    "new_taxes_no_override": 4309.54,
    "override_total_1": 4431.82,
    "override_increase_1": 122.28
  },
  {
    "#": "1731 Beacon St, Unit 411 G-144 (225-27-79)",
    "$": 673300,
    "address": "1731 Beacon St, Unit 411 G-144",
    "parcel_id": "225-27-79",
    "owner1": "BARBIASZ TR, JANE E",
    "owner2": "",
    "current_taxes": 3259.66,
    "new_taxes_no_override": 3400.48,
    "override_total_1": 3496.96,
    "override_increase_1": 96.49
  },
  {
    "#": "1731 Beacon St, Unit 412 & P6 (225-27-80)",
    "$": 634300,
    "address": "1731 Beacon St, Unit 412 & P6",
    "parcel_id": "225-27-80",
    "owner1": "GOLDSTEIN, GILA",
    "owner2": "",
    "current_taxes": 2860.3,
    "new_taxes_no_override": 2983.86,
    "override_total_1": 3068.53,
    "override_increase_1": 84.66
  },
  {
    "#": "1731 Beacon St, Unit 413 & P193 (225-27-81)",
    "$": 579800,
    "address": "1731 Beacon St, Unit 413 & P193",
    "parcel_id": "225-27-81",
    "owner1": "TANG, GUI LING HU",
    "owner2": "LIN, CATHERINE",
    "current_taxes": 2302.22,
    "new_taxes_no_override": 2401.68,
    "override_total_1": 2469.82,
    "override_increase_1": 68.15
  },
  {
    "#": "1731 Beacon St, Unit 414 & P198 (225-27-82)",
    "$": 532400,
    "address": "1731 Beacon St, Unit 414 & P198",
    "parcel_id": "225-27-82",
    "owner1": "LEE, JAMES A  & SOURI S",
    "owner2": "",
    "current_taxes": 1816.84,
    "new_taxes_no_override": 1895.33,
    "override_total_1": 1949.11,
    "override_increase_1": 53.78
  },
  {
    "#": "1731 Beacon St, Unit 415 & P55 (225-27-83)",
    "$": 632200,
    "address": "1731 Beacon St, Unit 415 & P55",
    "parcel_id": "225-27-83",
    "owner1": "ANSE LLC",
    "owner2": "",
    "current_taxes": 6473.73,
    "new_taxes_no_override": 6753.4,
    "override_total_1": 6945.02,
    "override_increase_1": 191.62
  },
  {
    "#": "1731 Beacon St, Unit 416 & P153 (225-27-84)",
    "$": 501800,
    "address": "1731 Beacon St, Unit 416 & P153",
    "parcel_id": "225-27-84",
    "owner1": "ELOVITZ, JUDITH A",
    "owner2": "",
    "current_taxes": 5138.43,
    "new_taxes_no_override": 5360.41,
    "override_total_1": 5512.51,
    "override_increase_1": 152.1
  },
  {
    "#": "1731 Beacon St, Unit 417 & P218 (225-27-85)",
    "$": 758400,
    "address": "1731 Beacon St, Unit 417 & P218",
    "parcel_id": "225-27-85",
    "owner1": "ALBERT TRS, LAWRENCE G",
    "owner2": "ROSENBAUM, TAMAR A-A",
    "current_taxes": 7766.02,
    "new_taxes_no_override": 8101.51,
    "override_total_1": 8331.39,
    "override_increase_1": 229.87
  },
  {
    "#": "1731 Beacon St, Unit 418 & P1 (225-27-86)",
    "$": 501800,
    "address": "1731 Beacon St, Unit 418 & P1",
    "parcel_id": "225-27-86",
    "owner1": "KEO, KASYLA",
    "owner2": "",
    "current_taxes": 1503.5,
    "new_taxes_no_override": 1568.45,
    "override_total_1": 1612.95,
    "override_increase_1": 44.5
  },
  {
    "#": "1731 Beacon St, Unit 419 & P126 (225-27-87)",
    "$": 649100,
    "address": "1731 Beacon St, Unit 419 & P126",
    "parcel_id": "225-27-87",
    "owner1": "HOFFMAN TRS, KENNETH B & ROBERTA F",
    "owner2": "",
    "current_taxes": 6646.78,
    "new_taxes_no_override": 6933.92,
    "override_total_1": 7130.67,
    "override_increase_1": 196.74
  },
  {
    "#": "1731 Beacon St, Unit 420 & P88 (225-27-88)",
    "$": 486900,
    "address": "1731 Beacon St, Unit 420 & P88",
    "parcel_id": "225-27-88",
    "owner1": "BROWNBAUM REAL ESTATE, INVESTMENT LLC",
    "owner2": "",
    "current_taxes": 4985.86,
    "new_taxes_no_override": 5201.25,
    "override_total_1": 5348.83,
    "override_increase_1": 147.58
  },
  {
    "#": "1731 Beacon St, Unit 421 & P221 (225-27-89)",
    "$": 668400,
    "address": "1731 Beacon St, Unit 421 & P221",
    "parcel_id": "225-27-89",
    "owner1": "DUMITRIU, TR, DELIA P",
    "owner2": "",
    "current_taxes": 3209.48,
    "new_taxes_no_override": 3348.13,
    "override_total_1": 3443.13,
    "override_increase_1": 95.0
  },
  {
    "#": "1731 Beacon St, Unit 422 & P171 (225-27-90)",
    "$": 495700,
    "address": "1731 Beacon St, Unit 422 & P171",
    "parcel_id": "225-27-90",
    "owner1": "BULATOV TRS, VASILY V  & MARINA V",
    "owner2": "",
    "current_taxes": 5075.97,
    "new_taxes_no_override": 5295.25,
    "override_total_1": 5445.5,
    "override_increase_1": 150.25
  },
  {
    "#": "1731 Beacon St, Unit 423 & P127 (225-27-91)",
    "$": 523400,
    "address": "1731 Beacon St, Unit 423 & P127",
    "parcel_id": "225-27-91",
    "owner1": "ASTE, MARIE F",
    "owner2": "",
    "current_taxes": 1724.68,
    "new_taxes_no_override": 1799.19,
    "override_total_1": 1850.24,
    "override_increase_1": 51.05
  },
  {
    "#": "1731 Beacon St, Unit 424 G-114 (225-27-92)",
    "$": 486900,
    "address": "1731 Beacon St, Unit 424 G-114",
    "parcel_id": "225-27-92",
    "owner1": "BURDENKO TR, GALINA",
    "owner2": "",
    "current_taxes": 4985.86,
    "new_taxes_no_override": 5201.25,
    "override_total_1": 5348.83,
    "override_increase_1": 147.58
  },
  {
    "#": "1731 Beacon St, Unit 425 & P87 (225-27-93)",
    "$": 514800,
    "address": "1731 Beacon St, Unit 425 & P87",
    "parcel_id": "225-27-93",
    "owner1": "INBAR, NOAH & GALIT",
    "owner2": "",
    "current_taxes": 5271.55,
    "new_taxes_no_override": 5499.28,
    "override_total_1": 5655.32,
    "override_increase_1": 156.04
  },
  {
    "#": "1731 Beacon St, Unit 501 & P42 (225-27-94)",
    "$": 486800,
    "address": "1731 Beacon St, Unit 501 & P42",
    "parcel_id": "225-27-94",
    "owner1": "REGENCY TWINS LLC",
    "owner2": "",
    "current_taxes": 4984.83,
    "new_taxes_no_override": 5200.17,
    "override_total_1": 5347.73,
    "override_increase_1": 147.55
  },
  {
    "#": "1731 Beacon St, Unit 502 & P62 (225-27-95)",
    "$": 758400,
    "address": "1731 Beacon St, Unit 502 & P62",
    "parcel_id": "225-27-95",
    "owner1": "GABEL, ETTA S",
    "owner2": "",
    "current_taxes": 7766.02,
    "new_taxes_no_override": 8101.51,
    "override_total_1": 8331.39,
    "override_increase_1": 229.87
  },
  {
    "#": "1731 Beacon St, Unit 503 & P102 (225-27-96)",
    "$": 490100,
    "address": "1731 Beacon St, Unit 503 & P102",
    "parcel_id": "225-27-96",
    "owner1": "FUCHS, IRINA",
    "owner2": "MIRKIN, LEONID",
    "current_taxes": 1383.69,
    "new_taxes_no_override": 1443.47,
    "override_total_1": 1484.42,
    "override_increase_1": 40.96
  },
  {
    "#": "1731 Beacon St, Unit 504 & P78 (225-27-97)",
    "$": 832600,
    "address": "1731 Beacon St, Unit 504 & P78",
    "parcel_id": "225-27-97",
    "owner1": "SATTIN, BENJAMIN",
    "owner2": "FIXSEN, ALYSSA",
    "current_taxes": 4890.89,
    "new_taxes_no_override": 5102.18,
    "override_total_1": 5246.95,
    "override_increase_1": 144.77
  },
  {
    "#": "1731 Beacon St, Unit 505 & P81 (225-27-98)",
    "$": 673300,
    "address": "1731 Beacon St, Unit 505 & P81",
    "parcel_id": "225-27-98",
    "owner1": "BOGDANOV TRS, OLGA & JACOB",
    "owner2": "",
    "current_taxes": 3259.66,
    "new_taxes_no_override": 3400.48,
    "override_total_1": 3496.96,
    "override_increase_1": 96.49
  },
  {
    "#": "1731 Beacon St, Unit 506 & P169 (225-27-99)",
    "$": 665000,
    "address": "1731 Beacon St, Unit 506 & P169",
    "parcel_id": "225-27-99",
    "owner1": "MIKHEYEVA, YELENA",
    "owner2": "NAGORNIY, ALEKSANDR",
    "current_taxes": 6809.6,
    "new_taxes_no_override": 7103.77,
    "override_total_1": 7305.34,
    "override_increase_1": 201.56
  },
  {
    "#": "1731 Beacon St, Unit 507 & P71 (225-28-01)",
    "$": 622100,
    "address": "1731 Beacon St, Unit 507 & P71",
    "parcel_id": "225-28-01",
    "owner1": "CHEEVER, PETER J",
    "owner2": "",
    "current_taxes": 6370.3,
    "new_taxes_no_override": 6645.5,
    "override_total_1": 6834.06,
    "override_increase_1": 188.56
  },
  {
    "#": "1731 Beacon St, Unit 508 & P223 (225-28-02)",
    "$": 665000,
    "address": "1731 Beacon St, Unit 508 & P223",
    "parcel_id": "225-28-02",
    "owner1": "ABDUL-AZIZ, SAMA E",
    "owner2": "YANG, DAVID D",
    "current_taxes": 3174.67,
    "new_taxes_no_override": 3311.82,
    "override_total_1": 3405.79,
    "override_increase_1": 93.97
  },
  {
    "#": "1731 Beacon St, Unit 509 & P41 (225-28-03)",
    "$": 678600,
    "address": "1731 Beacon St, Unit 509 & P41",
    "parcel_id": "225-28-03",
    "owner1": "GARNET PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 6948.86,
    "new_taxes_no_override": 7249.05,
    "override_total_1": 7454.74,
    "override_increase_1": 205.69
  },
  {
    "#": "1731 Beacon St, Unit 510 & P34 (225-28-04)",
    "$": 758400,
    "address": "1731 Beacon St, Unit 510 & P34",
    "parcel_id": "225-28-04",
    "owner1": "OLIVA, RAPHAEL T & CAROL S",
    "owner2": "",
    "current_taxes": 4131.08,
    "new_taxes_no_override": 4309.54,
    "override_total_1": 4431.82,
    "override_increase_1": 122.28
  },
  {
    "#": "1731 Beacon St, Unit 511 & P89 (225-28-05)",
    "$": 686000,
    "address": "1731 Beacon St, Unit 511 & P89",
    "parcel_id": "225-28-05",
    "owner1": "JALALI, PADIDEH",
    "owner2": "",
    "current_taxes": 7024.64,
    "new_taxes_no_override": 7328.1,
    "override_total_1": 7536.03,
    "override_increase_1": 207.93
  },
  {
    "#": "1731 Beacon St, Unit 512 & P75 (225-28-06)",
    "$": 665000,
    "address": "1731 Beacon St, Unit 512 & P75",
    "parcel_id": "225-28-06",
    "owner1": "RADHAKRISHNAN, MAHALAKSHMI",
    "owner2": "KUNTAMUKKALA, VINAYA B",
    "current_taxes": 6809.6,
    "new_taxes_no_override": 7103.77,
    "override_total_1": 7305.34,
    "override_increase_1": 201.56
  },
  {
    "#": "1731 Beacon St, Unit 513 & P194 (225-28-07)",
    "$": 579800,
    "address": "1731 Beacon St, Unit 513 & P194",
    "parcel_id": "225-28-07",
    "owner1": "1731 BEACON LLC",
    "owner2": "C/O JULIE LIPSETT",
    "current_taxes": 5937.15,
    "new_taxes_no_override": 6193.63,
    "override_total_1": 6369.37,
    "override_increase_1": 175.74
  },
  {
    "#": "1731 Beacon St, Unit 514 & P29 (225-28-08)",
    "$": 486900,
    "address": "1731 Beacon St, Unit 514 & P29",
    "parcel_id": "225-28-08",
    "owner1": "SOHBOFF, TRS, DAVID",
    "owner2": "",
    "current_taxes": 4985.86,
    "new_taxes_no_override": 5201.25,
    "override_total_1": 5348.83,
    "override_increase_1": 147.58
  },
  {
    "#": "1731 Beacon St, Unit 515 & P202 (225-28-09)",
    "$": 683400,
    "address": "1731 Beacon St, Unit 515 & P202",
    "parcel_id": "225-28-09",
    "owner1": "KALOWSKI TR, NATHAN",
    "owner2": "",
    "current_taxes": 6998.02,
    "new_taxes_no_override": 7300.33,
    "override_total_1": 7507.48,
    "override_increase_1": 207.14
  },
  {
    "#": "1731 Beacon St, Unit 516 & P86 (225-28-10)",
    "$": 486900,
    "address": "1731 Beacon St, Unit 516 & P86",
    "parcel_id": "225-28-10",
    "owner1": "BRONFMAN, JOANIE",
    "owner2": "MACMILLAN, NEAL J",
    "current_taxes": 4985.86,
    "new_taxes_no_override": 5201.25,
    "override_total_1": 5348.83,
    "override_increase_1": 147.58
  },
  {
    "#": "1731 Beacon St, Unit 517 & P205 (225-28-11)",
    "$": 758400,
    "address": "1731 Beacon St, Unit 517 & P205",
    "parcel_id": "225-28-11",
    "owner1": "BRONFMAN, JOANIE & MACMILLAN",
    "owner2": "",
    "current_taxes": 4131.08,
    "new_taxes_no_override": 4309.54,
    "override_total_1": 4431.82,
    "override_increase_1": 122.28
  },
  {
    "#": "1731 Beacon St, Unit 518 & P110 (225-28-12)",
    "$": 486900,
    "address": "1731 Beacon St, Unit 518 & P110",
    "parcel_id": "225-28-12",
    "owner1": "PEARLSTEIN, ROBERT A",
    "owner2": "",
    "current_taxes": 4985.86,
    "new_taxes_no_override": 5201.25,
    "override_total_1": 5348.83,
    "override_increase_1": 147.58
  },
  {
    "#": "1731 Beacon St, Unit 519 & P195 (225-28-13)",
    "$": 648600,
    "address": "1731 Beacon St, Unit 519 & P195",
    "parcel_id": "225-28-13",
    "owner1": "BERGMAN TR, MARY S",
    "owner2": "",
    "current_taxes": 3006.73,
    "new_taxes_no_override": 3136.62,
    "override_total_1": 3225.62,
    "override_increase_1": 89.0
  },
  {
    "#": "1731 Beacon St, Unit 520 & P207 (225-28-14)",
    "$": 523400,
    "address": "1731 Beacon St, Unit 520 & P207",
    "parcel_id": "225-28-14",
    "owner1": "AL-NAIB, MAY",
    "owner2": "",
    "current_taxes": 5359.62,
    "new_taxes_no_override": 5591.16,
    "override_total_1": 5749.8,
    "override_increase_1": 158.64
  },
  {
    "#": "1731 Beacon St, Unit 521 G-103 (225-28-15)",
    "$": 682700,
    "address": "1731 Beacon St, Unit 521 G-103",
    "parcel_id": "225-28-15",
    "owner1": "BRILL, MARIUS",
    "owner2": "",
    "current_taxes": 6990.85,
    "new_taxes_no_override": 7292.85,
    "override_total_1": 7499.78,
    "override_increase_1": 206.93
  },
  {
    "#": "1731 Beacon St, Unit 522 & P157 (225-28-16)",
    "$": 529000,
    "address": "1731 Beacon St, Unit 522 & P157",
    "parcel_id": "225-28-16",
    "owner1": "SOHBOFF TR, DAVID A",
    "owner2": "",
    "current_taxes": 5416.96,
    "new_taxes_no_override": 5650.97,
    "override_total_1": 5811.31,
    "override_increase_1": 160.34
  },
  {
    "#": "1731 Beacon St, Unit 523 & P158 (225-28-17)",
    "$": 486900,
    "address": "1731 Beacon St, Unit 523 & P158",
    "parcel_id": "225-28-17",
    "owner1": "MASTERMAN TRS, JAMES D & ANDREA W",
    "owner2": "",
    "current_taxes": 4985.86,
    "new_taxes_no_override": 5201.25,
    "override_total_1": 5348.83,
    "override_increase_1": 147.58
  },
  {
    "#": "1731 Beacon St, Unit 524 & P116 (225-28-18)",
    "$": 554200,
    "address": "1731 Beacon St, Unit 524 & P116",
    "parcel_id": "225-28-18",
    "owner1": "STRUNINA, ELENA",
    "owner2": "",
    "current_taxes": 2040.07,
    "new_taxes_no_override": 2128.2,
    "override_total_1": 2188.59,
    "override_increase_1": 60.39
  },
  {
    "#": "1731 Beacon St, Unit 525 & P161 (225-28-19)",
    "$": 485100,
    "address": "1731 Beacon St, Unit 525 & P161",
    "parcel_id": "225-28-19",
    "owner1": "REILLY, MAUREEN L",
    "owner2": "",
    "current_taxes": 1332.49,
    "new_taxes_no_override": 1390.05,
    "override_total_1": 1429.5,
    "override_increase_1": 39.44
  },
  {
    "#": "1731 Beacon St, Unit 602 & P79 (225-28-20)",
    "$": 850300,
    "address": "1731 Beacon St, Unit 602 & P79",
    "parcel_id": "225-28-20",
    "owner1": "BARBIASZ, MARY ELLEN",
    "owner2": "",
    "current_taxes": 8707.07,
    "new_taxes_no_override": 9083.22,
    "override_total_1": 9340.94,
    "override_increase_1": 257.73
  },
  {
    "#": "1731 Beacon St, Unit 603 & P94 (225-28-21)",
    "$": 491800,
    "address": "1731 Beacon St, Unit 603 & P94",
    "parcel_id": "225-28-21",
    "owner1": "BERNSTEIN, HERBERT J",
    "owner2": "STERN, JESSICA",
    "current_taxes": 1401.1,
    "new_taxes_no_override": 1461.63,
    "override_total_1": 1503.1,
    "override_increase_1": 41.47
  },
  {
    "#": "1731 Beacon St, Unit 604 & P145 (225-28-22)",
    "$": 758400,
    "address": "1731 Beacon St, Unit 604 & P145",
    "parcel_id": "225-28-22",
    "owner1": "BROWN, TRS, DAVID J",
    "owner2": "MULLER, CORINNE",
    "current_taxes": 7766.02,
    "new_taxes_no_override": 8101.51,
    "override_total_1": 8331.39,
    "override_increase_1": 229.87
  },
  {
    "#": "1731 Beacon St, Unit 605 & P23 (225-28-23)",
    "$": 651000,
    "address": "1731 Beacon St, Unit 605 & P23",
    "parcel_id": "225-28-23",
    "owner1": "FENG, HAO",
    "owner2": "WANG, QINGYAN",
    "current_taxes": 3031.31,
    "new_taxes_no_override": 3162.26,
    "override_total_1": 3251.99,
    "override_increase_1": 89.73
  },
  {
    "#": "1731 Beacon St, Unit 606 & P32 (225-28-24)",
    "$": 613800,
    "address": "1731 Beacon St, Unit 606 & P32",
    "parcel_id": "225-28-24",
    "owner1": "REGENCY TWINS LLC",
    "owner2": "",
    "current_taxes": 6285.31,
    "new_taxes_no_override": 6556.84,
    "override_total_1": 6742.88,
    "override_increase_1": 186.05
  },
  {
    "#": "1731 Beacon St, Unit 607 & P90 (225-28-25)",
    "$": 660900,
    "address": "1731 Beacon St, Unit 607 & P90",
    "parcel_id": "225-28-25",
    "owner1": "BROWN, TRS, DAVID J",
    "owner2": "MULLER, CORINNE",
    "current_taxes": 6767.62,
    "new_taxes_no_override": 7059.98,
    "override_total_1": 7260.3,
    "override_increase_1": 200.32
  },
  {
    "#": "1731 Beacon St, Unit 608 & P100 (225-28-26)",
    "$": 670300,
    "address": "1731 Beacon St, Unit 608 & P100",
    "parcel_id": "225-28-26",
    "owner1": "JM CONSTRUCTION & DESIGN LLC",
    "owner2": "",
    "current_taxes": 6863.87,
    "new_taxes_no_override": 7160.39,
    "override_total_1": 7363.56,
    "override_increase_1": 203.17
  },
  {
    "#": "1731 Beacon St, Unit 609 & P21 (225-28-27)",
    "$": 673300,
    "address": "1731 Beacon St, Unit 609 & P21",
    "parcel_id": "225-28-27",
    "owner1": "VOHRA, ROHIT & GAYATRI",
    "owner2": "",
    "current_taxes": 6894.59,
    "new_taxes_no_override": 7192.44,
    "override_total_1": 7396.52,
    "override_increase_1": 204.08
  },
  {
    "#": "1731 Beacon St, Unit 610 & P131 (225-28-28)",
    "$": 817600,
    "address": "1731 Beacon St, Unit 610 & P131",
    "parcel_id": "225-28-28",
    "owner1": "KARP, NANCY",
    "owner2": "",
    "current_taxes": 4737.29,
    "new_taxes_no_override": 4941.94,
    "override_total_1": 5082.16,
    "override_increase_1": 140.22
  },
  {
    "#": "1731 Beacon St, Unit 611 & P182 (225-28-29)",
    "$": 642500,
    "address": "1731 Beacon St, Unit 611 & P182",
    "parcel_id": "225-28-29",
    "owner1": "PRINCE, ALEXANDER & VICTORIA L",
    "owner2": "",
    "current_taxes": 6579.2,
    "new_taxes_no_override": 6863.42,
    "override_total_1": 7058.17,
    "override_increase_1": 194.74
  },
  {
    "#": "1731 Beacon St, Unit 613 & P149 (225-28-30)",
    "$": 605600,
    "address": "1731 Beacon St, Unit 613 & P149",
    "parcel_id": "225-28-30",
    "owner1": "SALOW, BARRY J",
    "owner2": "",
    "current_taxes": 2566.41,
    "new_taxes_no_override": 2677.28,
    "override_total_1": 2753.24,
    "override_increase_1": 75.97
  },
  {
    "#": "1731 Beacon St, Unit 615 & P38 (225-28-31)",
    "$": 667000,
    "address": "1731 Beacon St, Unit 615 & P38",
    "parcel_id": "225-28-31",
    "owner1": "CHEEVER, PETER J",
    "owner2": "",
    "current_taxes": 6830.08,
    "new_taxes_no_override": 7125.14,
    "override_total_1": 7327.31,
    "override_increase_1": 202.17
  },
  {
    "#": "1731 Beacon St, Unit 617 & P30 (225-28-32)",
    "$": 758400,
    "address": "1731 Beacon St, Unit 617 & P30",
    "parcel_id": "225-28-32",
    "owner1": "BRONFMAN, JOANIE",
    "owner2": "MACMILLAN, NEAL J",
    "current_taxes": 7766.02,
    "new_taxes_no_override": 8101.51,
    "override_total_1": 8331.39,
    "override_increase_1": 229.87
  },
  {
    "#": "1731 Beacon St, Unit 619 & P80 (225-28-33)",
    "$": 665000,
    "address": "1731 Beacon St, Unit 619 & P80",
    "parcel_id": "225-28-33",
    "owner1": "KANTOR, SARAH",
    "owner2": "",
    "current_taxes": 6809.6,
    "new_taxes_no_override": 7103.77,
    "override_total_1": 7305.34,
    "override_increase_1": 201.56
  },
  {
    "#": "1731 Beacon St, Unit 621 & P176 (225-28-34)",
    "$": 689300,
    "address": "1731 Beacon St, Unit 621 & P176",
    "parcel_id": "225-28-34",
    "owner1": "LI, MINGWEI",
    "owner2": "FENG, YINNIAN",
    "current_taxes": 7058.43,
    "new_taxes_no_override": 7363.35,
    "override_total_1": 7572.28,
    "override_increase_1": 208.93
  },
  {
    "#": "1731 Beacon St, Unit 623 & P206 (225-28-35)",
    "$": 486900,
    "address": "1731 Beacon St, Unit 623 & P206",
    "parcel_id": "225-28-35",
    "owner1": "GOTO, YOZO & KOZUE",
    "owner2": "",
    "current_taxes": 1350.92,
    "new_taxes_no_override": 1409.28,
    "override_total_1": 1449.27,
    "override_increase_1": 39.99
  },
  {
    "#": "1731 Beacon St, Unit 702 & P204 (225-28-36)",
    "$": 850300,
    "address": "1731 Beacon St, Unit 702 & P204",
    "parcel_id": "225-28-36",
    "owner1": "KALOGEROPOULOS, GEORGE",
    "owner2": "PRYNKO, NATALIA",
    "current_taxes": 8707.07,
    "new_taxes_no_override": 9083.22,
    "override_total_1": 9340.94,
    "override_increase_1": 257.73
  },
  {
    "#": "1731 Beacon St, Unit 703 & P96 (225-28-37)",
    "$": 1259900,
    "address": "1731 Beacon St, Unit 703 & P96",
    "parcel_id": "225-28-37",
    "owner1": "EIGHT ONE REGENCY LLC",
    "owner2": "",
    "current_taxes": 12901.38,
    "new_taxes_no_override": 13458.72,
    "override_total_1": 13840.6,
    "override_increase_1": 381.88
  },
  {
    "#": "1731 Beacon St, Unit 704 & P9 (225-28-38)",
    "$": 830100,
    "address": "1731 Beacon St, Unit 704 & P9",
    "parcel_id": "225-28-38",
    "owner1": "KLIBANER, MICHAEL & TEMMA",
    "owner2": "",
    "current_taxes": 8500.22,
    "new_taxes_no_override": 8867.43,
    "override_total_1": 9119.04,
    "override_increase_1": 251.61
  },
  {
    "#": "1731 Beacon St, Unit 706 & P217 (225-28-39)",
    "$": 639600,
    "address": "1731 Beacon St, Unit 706 & P217",
    "parcel_id": "225-28-39",
    "owner1": "NOVACK, LEWIS A",
    "owner2": "",
    "current_taxes": 2914.57,
    "new_taxes_no_override": 3040.48,
    "override_total_1": 3126.75,
    "override_increase_1": 86.27
  },
  {
    "#": "1731 Beacon St, Unit 707 & P82 (225-28-40)",
    "$": 691900,
    "address": "1731 Beacon St, Unit 707 & P82",
    "parcel_id": "225-28-40",
    "owner1": "ZHONG, SHUO",
    "owner2": "",
    "current_taxes": 3450.12,
    "new_taxes_no_override": 3599.17,
    "override_total_1": 3701.29,
    "override_increase_1": 102.12
  },
  {
    "#": "1731 Beacon St, Unit 708 & P152 (225-28-41)",
    "$": 665000,
    "address": "1731 Beacon St, Unit 708 & P152",
    "parcel_id": "225-28-41",
    "owner1": "YAKHKIND, ALEKSANDRA & LEONID",
    "owner2": "SMIMOVA, TAMARA",
    "current_taxes": 6809.6,
    "new_taxes_no_override": 7103.77,
    "override_total_1": 7305.34,
    "override_increase_1": 201.56
  },
  {
    "#": "1731 Beacon St, Unit 709 & P163 (225-28-42)",
    "$": 678700,
    "address": "1731 Beacon St, Unit 709 & P163",
    "parcel_id": "225-28-42",
    "owner1": "MILEWICH, CAROL ESTHER",
    "owner2": "",
    "current_taxes": 6949.89,
    "new_taxes_no_override": 7250.13,
    "override_total_1": 7455.84,
    "override_increase_1": 205.72
  },
  {
    "#": "1731 Beacon St, Unit 710 & P189 (225-28-43)",
    "$": 850300,
    "address": "1731 Beacon St, Unit 710 & P189",
    "parcel_id": "225-28-43",
    "owner1": "NASH, SUSAN COLLINS",
    "owner2": "",
    "current_taxes": 5072.14,
    "new_taxes_no_override": 5291.26,
    "override_total_1": 5441.39,
    "override_increase_1": 150.14
  },
  {
    "#": "1731 Beacon St, Unit 711 & P50 (225-28-44)",
    "$": 642500,
    "address": "1731 Beacon St, Unit 711 & P50",
    "parcel_id": "225-28-44",
    "owner1": "LANA REALTY 711 LLC",
    "owner2": "",
    "current_taxes": 6579.2,
    "new_taxes_no_override": 6863.42,
    "override_total_1": 7058.17,
    "override_increase_1": 194.74
  },
  {
    "#": "1731 Beacon St, Unit 713 & P138 (225-28-45)",
    "$": 650200,
    "address": "1731 Beacon St, Unit 713 & P138",
    "parcel_id": "225-28-45",
    "owner1": "RUI JIAN LLC",
    "owner2": "",
    "current_taxes": 6658.05,
    "new_taxes_no_override": 6945.68,
    "override_total_1": 7142.76,
    "override_increase_1": 197.08
  },
  {
    "#": "1731 Beacon St, Unit 715 & P216 (225-28-46)",
    "$": 675100,
    "address": "1731 Beacon St, Unit 715 & P216",
    "parcel_id": "225-28-46",
    "owner1": "PERRAS TR, MARYRUTH",
    "owner2": "",
    "current_taxes": 6913.02,
    "new_taxes_no_override": 7211.66,
    "override_total_1": 7416.29,
    "override_increase_1": 204.63
  },
  {
    "#": "1731 Beacon St, Unit 717 & P44 (225-28-47)",
    "$": 758400,
    "address": "1731 Beacon St, Unit 717 & P44",
    "parcel_id": "225-28-47",
    "owner1": "EISENBERG, RONALD",
    "owner2": "SCHIFF, ZINA",
    "current_taxes": 4131.08,
    "new_taxes_no_override": 4309.54,
    "override_total_1": 4431.82,
    "override_increase_1": 122.28
  },
  {
    "#": "1731 Beacon St, Unit 719 & P199 (225-28-48)",
    "$": 652700,
    "address": "1731 Beacon St, Unit 719 & P199",
    "parcel_id": "225-28-48",
    "owner1": "SALZBANK TR, SHARON",
    "owner2": "",
    "current_taxes": 3048.71,
    "new_taxes_no_override": 3180.41,
    "override_total_1": 3270.66,
    "override_increase_1": 90.24
  },
  {
    "#": "1731 Beacon St, Unit 721 & P83 (225-28-49)",
    "$": 682700,
    "address": "1731 Beacon St, Unit 721 & P83",
    "parcel_id": "225-28-49",
    "owner1": "LEE, I-CHEN",
    "owner2": "LI, YEN-DER",
    "current_taxes": 3355.91,
    "new_taxes_no_override": 3500.89,
    "override_total_1": 3600.22,
    "override_increase_1": 99.33
  },
  {
    "#": "1731 Beacon St, Unit 723 & P95 (225-28-50)",
    "$": 547600,
    "address": "1731 Beacon St, Unit 723 & P95",
    "parcel_id": "225-28-50",
    "owner1": "SAF BOSTON LLC",
    "owner2": "",
    "current_taxes": 5607.42,
    "new_taxes_no_override": 5849.66,
    "override_total_1": 6015.64,
    "override_increase_1": 165.98
  },
  {
    "#": "1731 Beacon St, Unit 802 G-219 (225-28-51)",
    "$": 870200,
    "address": "1731 Beacon St, Unit 802 G-219",
    "parcel_id": "225-28-51",
    "owner1": "SUCIU, GABRIEL L & ANCA M & DIANA J",
    "owner2": "",
    "current_taxes": 8910.85,
    "new_taxes_no_override": 9295.8,
    "override_total_1": 9559.56,
    "override_increase_1": 263.76
  },
  {
    "#": "1731 Beacon St, Unit 803 & P106 (225-28-52)",
    "$": 1225600,
    "address": "1731 Beacon St, Unit 803 & P106",
    "parcel_id": "225-28-52",
    "owner1": "WONG, ALBERT YAO CHEE",
    "owner2": "CHAN, HOW-CHING FERNADINA",
    "current_taxes": 8915.21,
    "new_taxes_no_override": 9300.35,
    "override_total_1": 9564.24,
    "override_increase_1": 263.89
  },
  {
    "#": "1731 Beacon St, Unit 804 & P112 (225-28-53)",
    "$": 850300,
    "address": "1731 Beacon St, Unit 804 & P112",
    "parcel_id": "225-28-53",
    "owner1": "EVCIMEN, NET & AYHAN",
    "owner2": "",
    "current_taxes": 5072.14,
    "new_taxes_no_override": 5291.26,
    "override_total_1": 5441.39,
    "override_increase_1": 150.14
  },
  {
    "#": "1731 Beacon St, Unit 806 & P170 (225-28-54)",
    "$": 690000,
    "address": "1731 Beacon St, Unit 806 & P170",
    "parcel_id": "225-28-54",
    "owner1": "ASTE, MARIE FRANCESCA",
    "owner2": "",
    "current_taxes": 7065.6,
    "new_taxes_no_override": 7370.83,
    "override_total_1": 7579.98,
    "override_increase_1": 209.14
  },
  {
    "#": "1731 Beacon St, Unit 807 & P184 (225-28-55)",
    "$": 663400,
    "address": "1731 Beacon St, Unit 807 & P184",
    "parcel_id": "225-28-55",
    "owner1": "LANGER, IRINA & VLADIMIR & EDWARD",
    "owner2": "",
    "current_taxes": 3158.28,
    "new_taxes_no_override": 3294.72,
    "override_total_1": 3388.2,
    "override_increase_1": 93.49
  },
  {
    "#": "1731 Beacon St, Unit 808 & P176 (225-28-56)",
    "$": 666400,
    "address": "1731 Beacon St, Unit 808 & P176",
    "parcel_id": "225-28-56",
    "owner1": "QIN, SHAN",
    "owner2": "HE, XIAOMEI",
    "current_taxes": 6823.94,
    "new_taxes_no_override": 7118.73,
    "override_total_1": 7320.72,
    "override_increase_1": 201.99
  },
  {
    "#": "1731 Beacon St, Unit 809 & P168 (225-28-57)",
    "$": 636000,
    "address": "1731 Beacon St, Unit 809 & P168",
    "parcel_id": "225-28-57",
    "owner1": "WANG, LIJUAN",
    "owner2": "",
    "current_taxes": 2877.71,
    "new_taxes_no_override": 3002.03,
    "override_total_1": 3087.21,
    "override_increase_1": 85.18
  },
  {
    "#": "1731 Beacon St, Unit 810 & P18 (225-28-58)",
    "$": 806200,
    "address": "1731 Beacon St, Unit 810 & P18",
    "parcel_id": "225-28-58",
    "owner1": "LIMON, SYLVAN",
    "owner2": "",
    "current_taxes": 4620.55,
    "new_taxes_no_override": 4820.16,
    "override_total_1": 4956.93,
    "override_increase_1": 136.77
  },
  {
    "#": "1731 Beacon St, Unit 811 & P39 (225-28-59)",
    "$": 662300,
    "address": "1731 Beacon St, Unit 811 & P39",
    "parcel_id": "225-28-59",
    "owner1": "CONN, BARBARA",
    "owner2": "",
    "current_taxes": 6781.95,
    "new_taxes_no_override": 7074.93,
    "override_total_1": 7275.68,
    "override_increase_1": 200.75
  },
  {
    "#": "1731 Beacon St, Unit 813 & P124 (225-28-60)",
    "$": 626100,
    "address": "1731 Beacon St, Unit 813 & P124",
    "parcel_id": "225-28-60",
    "owner1": "LABUN, GRIGORIY",
    "owner2": "GERSHMAN, ELAINE",
    "current_taxes": 6411.26,
    "new_taxes_no_override": 6688.23,
    "override_total_1": 6878.0,
    "override_increase_1": 189.77
  },
  {
    "#": "1731 Beacon St, Unit 815 & P53 (225-28-61)",
    "$": 708900,
    "address": "1731 Beacon St, Unit 815 & P53",
    "parcel_id": "225-28-61",
    "owner1": "DEVINE, COREY",
    "owner2": "",
    "current_taxes": 3624.2,
    "new_taxes_no_override": 3780.77,
    "override_total_1": 3888.04,
    "override_increase_1": 107.28
  },
  {
    "#": "1731 Beacon St, Unit 902 & P125 (225-28-62)",
    "$": 784100,
    "address": "1731 Beacon St, Unit 902 & P125",
    "parcel_id": "225-28-62",
    "owner1": "ROSENBERG TR, SHERRYL L",
    "owner2": "",
    "current_taxes": 4394.25,
    "new_taxes_no_override": 4584.08,
    "override_total_1": 4714.15,
    "override_increase_1": 130.07
  },
  {
    "#": "1731 Beacon St, Unit 903 & P49 (225-28-63)",
    "$": 1178900,
    "address": "1731 Beacon St, Unit 903 & P49",
    "parcel_id": "225-28-63",
    "owner1": "BROWN, DAVID J",
    "owner2": "",
    "current_taxes": 8437.0,
    "new_taxes_no_override": 8801.48,
    "override_total_1": 9051.21,
    "override_increase_1": 249.74
  },
  {
    "#": "1731 Beacon St, Unit 904 & P200 (225-28-64)",
    "$": 850300,
    "address": "1731 Beacon St, Unit 904 & P200",
    "parcel_id": "225-28-64",
    "owner1": "ROMM TR, EUGENIA S",
    "owner2": "",
    "current_taxes": 8707.07,
    "new_taxes_no_override": 9083.22,
    "override_total_1": 9340.94,
    "override_increase_1": 257.73
  },
  {
    "#": "1731 Beacon St, Unit 906 & P-2 (225-28-65)",
    "$": 634200,
    "address": "1731 Beacon St, Unit 906 & P-2",
    "parcel_id": "225-28-65",
    "owner1": "BROWN, CATHY E",
    "owner2": "",
    "current_taxes": 2859.27,
    "new_taxes_no_override": 2982.79,
    "override_total_1": 3067.42,
    "override_increase_1": 84.63
  },
  {
    "#": "1731 Beacon St, Unit 907 & P188 (225-28-66)",
    "$": 691900,
    "address": "1731 Beacon St, Unit 907 & P188",
    "parcel_id": "225-28-66",
    "owner1": "JEZIERSKI , AMELIA C",
    "owner2": "",
    "current_taxes": 7085.06,
    "new_taxes_no_override": 7391.13,
    "override_total_1": 7600.85,
    "override_increase_1": 209.72
  },
  {
    "#": "1731 Beacon St, Unit 908 & P16 (225-28-67)",
    "$": 634300,
    "address": "1731 Beacon St, Unit 908 & P16",
    "parcel_id": "225-28-67",
    "owner1": "LO, CHI-CHEUNG & ANN MARIE",
    "owner2": "",
    "current_taxes": 6495.23,
    "new_taxes_no_override": 6775.82,
    "override_total_1": 6968.08,
    "override_increase_1": 192.26
  },
  {
    "#": "1731 Beacon St, Unit 909 & P183 (225-28-68)",
    "$": 673300,
    "address": "1731 Beacon St, Unit 909 & P183",
    "parcel_id": "225-28-68",
    "owner1": "CATALAN, H ROBERT",
    "owner2": "C/O CATALAN, JOHN",
    "current_taxes": 6894.59,
    "new_taxes_no_override": 7192.44,
    "override_total_1": 7396.52,
    "override_increase_1": 204.08
  },
  {
    "#": "1731 Beacon St, Unit 910 & P26 (225-28-69)",
    "$": 806200,
    "address": "1731 Beacon St, Unit 910 & P26",
    "parcel_id": "225-28-69",
    "owner1": "CHOY TRS, ELENA",
    "owner2": "GRAVLIN, ERIC",
    "current_taxes": 8255.49,
    "new_taxes_no_override": 8612.13,
    "override_total_1": 8856.49,
    "override_increase_1": 244.36
  },
  {
    "#": "1731 Beacon St, Unit 911 & P141 (225-28-70)",
    "$": 642500,
    "address": "1731 Beacon St, Unit 911 & P141",
    "parcel_id": "225-28-70",
    "owner1": "ROSENBAUM, RONALD",
    "owner2": "",
    "current_taxes": 6579.2,
    "new_taxes_no_override": 6863.42,
    "override_total_1": 7058.17,
    "override_increase_1": 194.74
  },
  {
    "#": "1731 Beacon St, Unit 913 & P175 (225-28-71)",
    "$": 626100,
    "address": "1731 Beacon St, Unit 913 & P175",
    "parcel_id": "225-28-71",
    "owner1": "WANTMAN, MICHAEL",
    "owner2": "",
    "current_taxes": 2776.33,
    "new_taxes_no_override": 2896.27,
    "override_total_1": 2978.45,
    "override_increase_1": 82.18
  },
  {
    "#": "1731 Beacon St, Unit 915 & P172 (225-28-72)",
    "$": 693800,
    "address": "1731 Beacon St, Unit 915 & P172",
    "parcel_id": "225-28-72",
    "owner1": "SUN, MENG",
    "owner2": "LIANG, SIYONG",
    "current_taxes": 7104.51,
    "new_taxes_no_override": 7411.42,
    "override_total_1": 7621.72,
    "override_increase_1": 210.29
  },
  {
    "#": "1731 Beacon St, Unit D-10 & P68 (225-27-04)",
    "$": 777800,
    "address": "1731 Beacon St, Unit D-10 & P68",
    "parcel_id": "225-27-04",
    "owner1": "ZELLNER, TR, ELLEN R",
    "owner2": "",
    "current_taxes": 4329.74,
    "new_taxes_no_override": 4516.78,
    "override_total_1": 4644.95,
    "override_increase_1": 128.16
  },
  {
    "#": "1731 Beacon St, Unit D-15 & P25 (225-27-05)",
    "$": 598400,
    "address": "1731 Beacon St, Unit D-15 & P25",
    "parcel_id": "225-27-05",
    "owner1": "ZHANG, HAO & YUAN XUE",
    "owner2": "LEE, ZHENG XIU",
    "current_taxes": 6127.62,
    "new_taxes_no_override": 6392.33,
    "override_total_1": 6573.71,
    "override_increase_1": 181.38
  },
  {
    "#": "1731 Beacon St, Unit D-19 &  P156 (225-27-06)",
    "$": 602100,
    "address": "1731 Beacon St, Unit D-19 &  P156",
    "parcel_id": "225-27-06",
    "owner1": "VINAS TRS, JOSE A",
    "owner2": "OLIVERA, LIZETTE",
    "current_taxes": 2530.57,
    "new_taxes_no_override": 2639.89,
    "override_total_1": 2714.8,
    "override_increase_1": 74.9
  },
  {
    "#": "1731 Beacon St, Unit D-2 G-123 (225-29-29)",
    "$": 777800,
    "address": "1731 Beacon St, Unit D-2 G-123",
    "parcel_id": "225-29-29",
    "owner1": "SPECTOR, TRS, JOANNE & MYRON",
    "owner2": "",
    "current_taxes": 7964.67,
    "new_taxes_no_override": 8308.74,
    "override_total_1": 8544.5,
    "override_increase_1": 235.75
  },
  {
    "#": "1731 Beacon St, Unit D-23 & P99 (225-27-07)",
    "$": 852300,
    "address": "1731 Beacon St, Unit D-23 & P99",
    "parcel_id": "225-27-07",
    "owner1": "ABRAMSKIY, VLADISLAV",
    "owner2": "ABRAMSKAYA, NATALIYA",
    "current_taxes": 5092.62,
    "new_taxes_no_override": 5312.62,
    "override_total_1": 5463.36,
    "override_increase_1": 150.74
  },
  {
    "#": "1731 Beacon St, Unit D-4 & P22 (225-27-01)",
    "$": 696400,
    "address": "1731 Beacon St, Unit D-4 & P22",
    "parcel_id": "225-27-01",
    "owner1": "TAMKIN, LAURENCE J",
    "owner2": "",
    "current_taxes": 7131.14,
    "new_taxes_no_override": 7439.21,
    "override_total_1": 7650.29,
    "override_increase_1": 211.08
  },
  {
    "#": "1731 Beacon St, Unit D-6 & P69 (225-27-02)",
    "$": 574300,
    "address": "1731 Beacon St, Unit D-6 & P69",
    "parcel_id": "225-27-02",
    "owner1": "WU, JENNIFER",
    "owner2": "",
    "current_taxes": 5880.83,
    "new_taxes_no_override": 6134.88,
    "override_total_1": 6308.95,
    "override_increase_1": 174.07
  },
  {
    "#": "1731 Beacon St, Unit D-8 & P214 (225-27-03)",
    "$": 574300,
    "address": "1731 Beacon St, Unit D-8 & P214",
    "parcel_id": "225-27-03",
    "owner1": "FRANKLIN, CRAIG A & LISA A",
    "owner2": "",
    "current_taxes": 5880.83,
    "new_taxes_no_override": 6134.88,
    "override_total_1": 6308.95,
    "override_increase_1": 174.07
  },
  {
    "#": "1731 Beacon St, Unit P111 (225-29-28)",
    "$": 82500,
    "address": "1731 Beacon St, Unit P111",
    "parcel_id": "225-29-28",
    "owner1": "MEZRAHI, AIDA",
    "owner2": "",
    "current_taxes": 844.8,
    "new_taxes_no_override": 881.3,
    "override_total_1": 906.3,
    "override_increase_1": 25.01
  },
  {
    "#": "1732 Beacon St (102-12-00)",
    "$": 2811400,
    "address": "1732 Beacon St",
    "parcel_id": "102-12-00",
    "owner1": "RIEMER, ADAM",
    "owner2": "",
    "current_taxes": 28788.74,
    "new_taxes_no_override": 30032.41,
    "override_total_1": 30884.56,
    "override_increase_1": 852.15
  },
  {
    "#": "1734 Beacon St (102-13-03)",
    "$": 2174900,
    "address": "1734 Beacon St",
    "parcel_id": "102-13-03",
    "owner1": "WANG, WEIWEN",
    "owner2": "FANG, LAN",
    "current_taxes": 18636.04,
    "new_taxes_no_override": 19441.12,
    "override_total_1": 19992.74,
    "override_increase_1": 551.63
  },
  {
    "#": "1736 Beacon St (102-14-00)",
    "$": 2259600,
    "address": "1736 Beacon St",
    "parcel_id": "102-14-00",
    "owner1": "1736 BEACON STREET LLC",
    "owner2": "",
    "current_taxes": 23138.3,
    "new_taxes_no_override": 24137.87,
    "override_total_1": 24822.77,
    "override_increase_1": 684.89
  },
  {
    "#": "1738 Beacon St (102-15-00)",
    "$": 2291600,
    "address": "1738 Beacon St",
    "parcel_id": "102-15-00",
    "owner1": "PARK, KEE CHOON & EUNHAI GRACE",
    "owner2": "",
    "current_taxes": 23465.98,
    "new_taxes_no_override": 24479.71,
    "override_total_1": 25174.3,
    "override_increase_1": 694.59
  },
  {
    "#": "1740 Beacon St (102-16-00)",
    "$": 2876500,
    "address": "1740 Beacon St",
    "parcel_id": "102-16-00",
    "owner1": "1740 BEACON OWNER LLC",
    "owner2": "",
    "current_taxes": 29455.36,
    "new_taxes_no_override": 30727.83,
    "override_total_1": 31599.71,
    "override_increase_1": 871.88
  },
  {
    "#": "1742 Beacon St, Unit 1 (102-17-01)",
    "$": 423700,
    "address": "1742 Beacon St, Unit 1",
    "parcel_id": "102-17-01",
    "owner1": "YAZDI, OMID & SARA",
    "owner2": "",
    "current_taxes": 703.75,
    "new_taxes_no_override": 734.15,
    "override_total_1": 754.98,
    "override_increase_1": 20.83
  },
  {
    "#": "1742 Beacon St, Unit 2 (102-17-02)",
    "$": 558700,
    "address": "1742 Beacon St, Unit 2",
    "parcel_id": "102-17-02",
    "owner1": "BLOKHIN, YAN",
    "owner2": "",
    "current_taxes": 5721.09,
    "new_taxes_no_override": 5968.24,
    "override_total_1": 6137.59,
    "override_increase_1": 169.34
  },
  {
    "#": "1742 Beacon St, Unit 3 (102-17-03)",
    "$": 505400,
    "address": "1742 Beacon St, Unit 3",
    "parcel_id": "102-17-03",
    "owner1": "ARUTA TR, MICHAEL GEORGE",
    "owner2": "",
    "current_taxes": 1540.36,
    "new_taxes_no_override": 1606.9,
    "override_total_1": 1652.5,
    "override_increase_1": 45.59
  },
  {
    "#": "1742 Beacon St, Unit 4 (102-17-04)",
    "$": 713500,
    "address": "1742 Beacon St, Unit 4",
    "parcel_id": "102-17-04",
    "owner1": "DB LIBERTY LLC",
    "owner2": "",
    "current_taxes": 7306.24,
    "new_taxes_no_override": 7621.87,
    "override_total_1": 7838.13,
    "override_increase_1": 216.26
  },
  {
    "#": "1742 Beacon St, Unit 5 (102-17-05)",
    "$": 572300,
    "address": "1742 Beacon St, Unit 5",
    "parcel_id": "102-17-05",
    "owner1": "BENJAMIN, JAMES ANTHONY",
    "owner2": "",
    "current_taxes": 2225.42,
    "new_taxes_no_override": 2321.56,
    "override_total_1": 2387.43,
    "override_increase_1": 65.87
  },
  {
    "#": "1742 Beacon St, Unit 6 & P4 (102-17-06)",
    "$": 712200,
    "address": "1742 Beacon St, Unit 6 & P4",
    "parcel_id": "102-17-06",
    "owner1": "AVRAM TR, MONICA",
    "owner2": "",
    "current_taxes": 7292.93,
    "new_taxes_no_override": 7607.98,
    "override_total_1": 7823.86,
    "override_increase_1": 215.87
  },
  {
    "#": "1742 Beacon St, Unit 7 (102-17-07)",
    "$": 906900,
    "address": "1742 Beacon St, Unit 7",
    "parcel_id": "102-17-07",
    "owner1": "GLASER, ROBYN L",
    "owner2": "",
    "current_taxes": 5651.72,
    "new_taxes_no_override": 5895.87,
    "override_total_1": 6063.17,
    "override_increase_1": 167.29
  },
  {
    "#": "1748 Beacon St (102-18-00)",
    "$": 3701200,
    "address": "1748 Beacon St",
    "parcel_id": "102-18-00",
    "owner1": "1748 BEACON STREET LLC",
    "owner2": "C/O PAUL DERBA",
    "current_taxes": 37900.29,
    "new_taxes_no_override": 39537.58,
    "override_total_1": 40659.43,
    "override_increase_1": 1121.85
  },
  {
    "#": "1750 Beacon St (102-19-00)",
    "$": 3750200,
    "address": "1750 Beacon St",
    "parcel_id": "102-19-00",
    "owner1": "GLOTH, TR, HY",
    "owner2": "",
    "current_taxes": 64353.43,
    "new_taxes_no_override": 67133.5,
    "override_total_1": 69038.36,
    "override_increase_1": 1904.86
  },
  {
    "#": "1751 Beacon St (225-53-00)",
    "$": 3153800,
    "address": "1751 Beacon St",
    "parcel_id": "225-53-00",
    "owner1": "BEACON STREET 1751 LLC",
    "owner2": "",
    "current_taxes": 40588.56,
    "new_taxes_no_override": 42341.99,
    "override_total_1": 43543.41,
    "override_increase_1": 1201.42
  },
  {
    "#": "1752 Beacon St, Unit 1 & P1-P2 (102-20-05)",
    "$": 1269800,
    "address": "1752 Beacon St, Unit 1 & P1-P2",
    "parcel_id": "102-20-05",
    "owner1": "ILIADES, ALEXANDROS",
    "owner2": "",
    "current_taxes": 13002.75,
    "new_taxes_no_override": 13564.47,
    "override_total_1": 13949.35,
    "override_increase_1": 384.88
  },
  {
    "#": "1752 Beacon St, Unit 3 (102-20-02)",
    "$": 931100,
    "address": "1752 Beacon St, Unit 3",
    "parcel_id": "102-20-02",
    "owner1": "HEILBRUNN, LORRAINE J",
    "owner2": "",
    "current_taxes": 5899.53,
    "new_taxes_no_override": 6154.39,
    "override_total_1": 6329.02,
    "override_increase_1": 174.63
  },
  {
    "#": "1752 Beacon St, Unit 4 & P3 (102-20-03)",
    "$": 1368900,
    "address": "1752 Beacon St, Unit 4 & P3",
    "parcel_id": "102-20-03",
    "owner1": "DECTER, NICOLE H & JONATHAN P",
    "owner2": "",
    "current_taxes": 10382.6,
    "new_taxes_no_override": 10831.13,
    "override_total_1": 11138.45,
    "override_increase_1": 307.32
  },
  {
    "#": "1753 Beacon St, Unit 1 (225-54-01)",
    "$": 351200,
    "address": "1753 Beacon St, Unit 1",
    "parcel_id": "225-54-01",
    "owner1": "BAIO, BEI",
    "owner2": "GUO, NAN & DONG",
    "current_taxes": 3596.29,
    "new_taxes_no_override": 3751.65,
    "override_total_1": 3858.1,
    "override_increase_1": 106.45
  },
  {
    "#": "1753 Beacon St, Unit 2 & P2 (225-54-02)",
    "$": 725700,
    "address": "1753 Beacon St, Unit 2 & P2",
    "parcel_id": "225-54-02",
    "owner1": "SALL, TERRY J",
    "owner2": "",
    "current_taxes": 7431.17,
    "new_taxes_no_override": 7752.2,
    "override_total_1": 7972.16,
    "override_increase_1": 219.96
  },
  {
    "#": "1753 Beacon St, Unit 3 (225-54-03)",
    "$": 722800,
    "address": "1753 Beacon St, Unit 3",
    "parcel_id": "225-54-03",
    "owner1": "SHUSTA, MICHAEL & CAROLINE",
    "owner2": "",
    "current_taxes": 3766.54,
    "new_taxes_no_override": 3929.25,
    "override_total_1": 4040.74,
    "override_increase_1": 111.49
  },
  {
    "#": "1753 Beacon St, Unit 4 (225-54-04)",
    "$": 1076300,
    "address": "1753 Beacon St, Unit 4",
    "parcel_id": "225-54-04",
    "owner1": "HARMON, JUDSON",
    "owner2": "GIBILISCO, LAUREN",
    "current_taxes": 7386.38,
    "new_taxes_no_override": 7705.47,
    "override_total_1": 7924.11,
    "override_increase_1": 218.64
  },
  {
    "#": "1754 Beacon St (102-21-00)",
    "$": 1096300,
    "address": "1754 Beacon St",
    "parcel_id": "102-21-00",
    "owner1": "PINE STREET INN INC",
    "owner2": "",
    "current_taxes": 11226.11,
    "new_taxes_no_override": 11711.08,
    "override_total_1": 12043.37,
    "override_increase_1": 332.29
  },
  {
    "#": "1755 Beacon St, Unit 1 (225-55-05)",
    "$": 1908400,
    "address": "1755 Beacon St, Unit 1",
    "parcel_id": "225-55-05",
    "owner1": "STRYDOM TR, MARINUS",
    "owner2": "",
    "current_taxes": 15907.08,
    "new_taxes_no_override": 16594.27,
    "override_total_1": 17065.12,
    "override_increase_1": 470.85
  },
  {
    "#": "1755 Beacon St, Unit 2 (225-55-02)",
    "$": 1885400,
    "address": "1755 Beacon St, Unit 2",
    "parcel_id": "225-55-02",
    "owner1": "FURIOLI, CLOTILDE",
    "owner2": "KITABGI, HADRIEN",
    "current_taxes": 19306.5,
    "new_taxes_no_override": 20140.54,
    "override_total_1": 20712.01,
    "override_increase_1": 571.47
  },
  {
    "#": "1755 Beacon St, Unit 3 (225-55-03)",
    "$": 1817200,
    "address": "1755 Beacon St, Unit 3",
    "parcel_id": "225-55-03",
    "owner1": "MARIN LIFE ESTATE, CRAIG & CAROLE",
    "owner2": "",
    "current_taxes": 14973.19,
    "new_taxes_no_override": 15620.03,
    "override_total_1": 16063.24,
    "override_increase_1": 443.21
  },
  {
    "#": "1756 Beacon St, Unit 1 (102-22-01)",
    "$": 782300,
    "address": "1756 Beacon St, Unit 1",
    "parcel_id": "102-22-01",
    "owner1": "GOSSNER, SAMUEL A",
    "owner2": "",
    "current_taxes": 8010.75,
    "new_taxes_no_override": 8356.81,
    "override_total_1": 8593.93,
    "override_increase_1": 237.12
  },
  {
    "#": "1756 Beacon St, Unit 2 (102-22-02)",
    "$": 1790500,
    "address": "1756 Beacon St, Unit 2",
    "parcel_id": "102-22-02",
    "owner1": "WANG, YANG & XUETING",
    "owner2": "",
    "current_taxes": 14699.79,
    "new_taxes_no_override": 15334.82,
    "override_total_1": 15769.93,
    "override_increase_1": 435.11
  },
  {
    "#": "1756 Beacon St, Unit 3 (102-22-03)",
    "$": 1077100,
    "address": "1756 Beacon St, Unit 3",
    "parcel_id": "102-22-03",
    "owner1": "WIDLUND, HANS",
    "owner2": "ILIC, NINA",
    "current_taxes": 7394.57,
    "new_taxes_no_override": 7714.02,
    "override_total_1": 7932.89,
    "override_increase_1": 218.88
  },
  {
    "#": "1757 Beacon St, Unit 1 & P3 (225-56-03)",
    "$": 1448400,
    "address": "1757 Beacon St, Unit 1 & P3",
    "parcel_id": "225-56-03",
    "owner1": "TREMONT STREET ASSOCIATES MA LLC TR",
    "owner2": "",
    "current_taxes": 14831.62,
    "new_taxes_no_override": 15472.35,
    "override_total_1": 15911.36,
    "override_increase_1": 439.02
  },
  {
    "#": "1757 Beacon St, Unit 2 (225-56-01)",
    "$": 1162500,
    "address": "1757 Beacon St, Unit 2",
    "parcel_id": "225-56-01",
    "owner1": "ELASMAR, TR, LATIFE Y",
    "owner2": "",
    "current_taxes": 8269.07,
    "new_taxes_no_override": 8626.29,
    "override_total_1": 8871.06,
    "override_increase_1": 244.76
  },
  {
    "#": "1757 Beacon St, Unit 3 & P-2 (225-56-02)",
    "$": 1526400,
    "address": "1757 Beacon St, Unit 3 & P-2",
    "parcel_id": "225-56-02",
    "owner1": "ELASMAR TRS, LATIFE",
    "owner2": "ELASMAR TRS, MICHEL G & KATHLEEN SIM",
    "current_taxes": 15630.34,
    "new_taxes_no_override": 16305.57,
    "override_total_1": 16768.23,
    "override_increase_1": 462.66
  },
  {
    "#": "1758 Beacon St (102-23-00)",
    "$": 2497000,
    "address": "1758 Beacon St",
    "parcel_id": "102-23-00",
    "owner1": "HACKER TR, JEFFREY L",
    "owner2": "",
    "current_taxes": 34924.61,
    "new_taxes_no_override": 36433.35,
    "override_total_1": 37467.12,
    "override_increase_1": 1033.77
  },
  {
    "#": "1759 Beacon St, Unit 1 (225-57-01)",
    "$": 2034400,
    "address": "1759 Beacon St, Unit 1",
    "parcel_id": "225-57-01",
    "owner1": "DENNIE, ANDREW & LAN",
    "owner2": "",
    "current_taxes": 17197.32,
    "new_taxes_no_override": 17940.24,
    "override_total_1": 18449.28,
    "override_increase_1": 509.04
  },
  {
    "#": "1759 Beacon St, Unit 2 (225-57-02)",
    "$": 1469800,
    "address": "1759 Beacon St, Unit 2",
    "parcel_id": "225-57-02",
    "owner1": "SCHORGE, SHARON",
    "owner2": "",
    "current_taxes": 11415.82,
    "new_taxes_no_override": 11908.98,
    "override_total_1": 12246.89,
    "override_increase_1": 337.91
  },
  {
    "#": "1760 Beacon St (102-24-00)",
    "$": 3208100,
    "address": "1760 Beacon St",
    "parcel_id": "102-24-00",
    "owner1": "COMPTON TR, PHOEBE",
    "owner2": "",
    "current_taxes": 29216.01,
    "new_taxes_no_override": 30478.14,
    "override_total_1": 31342.94,
    "override_increase_1": 864.79
  },
  {
    "#": "1761 Beacon St, Unit 1 (225-58-01)",
    "$": 1970900,
    "address": "1761 Beacon St, Unit 1",
    "parcel_id": "225-58-01",
    "owner1": "PARSONS, AMY",
    "owner2": "",
    "current_taxes": 16547.08,
    "new_taxes_no_override": 17261.91,
    "override_total_1": 17751.71,
    "override_increase_1": 489.79
  },
  {
    "#": "1761 Beacon St, Unit 2 & Pk Sp A (225-58-02)",
    "$": 2468600,
    "address": "1761 Beacon St, Unit 2 & Pk Sp A",
    "parcel_id": "225-58-02",
    "owner1": "HOANG, VAN",
    "owner2": "",
    "current_taxes": 25278.46,
    "new_taxes_no_override": 26370.49,
    "override_total_1": 27118.73,
    "override_increase_1": 748.24
  },
  {
    "#": "1762 Beacon St, Unit 1 & P1 (102-25-01)",
    "$": 1310400,
    "address": "1762 Beacon St, Unit 1 & P1",
    "parcel_id": "102-25-01",
    "owner1": "GEYGAN TRS, JAMES P & ERIN J",
    "owner2": "",
    "current_taxes": 9783.56,
    "new_taxes_no_override": 10206.21,
    "override_total_1": 10495.8,
    "override_increase_1": 289.59
  },
  {
    "#": "1762 Beacon St, Unit 2 & P4 (102-25-02)",
    "$": 1642100,
    "address": "1762 Beacon St, Unit 2 & P4",
    "parcel_id": "102-25-02",
    "owner1": "GABBAY TRS, SOLOMON A & CAROLYN JACOBY",
    "owner2": "C/O SOLOMON A GABBAY 1996 TRUST",
    "current_taxes": 16815.1,
    "new_taxes_no_override": 17541.51,
    "override_total_1": 18039.24,
    "override_increase_1": 497.73
  },
  {
    "#": "1762 Beacon St, Unit 3 & P3 (102-25-03)",
    "$": 1574100,
    "address": "1762 Beacon St, Unit 3 & P3",
    "parcel_id": "102-25-03",
    "owner1": "NABIEL, HEMAYAT",
    "owner2": "TALUKDAR, LAVINA",
    "current_taxes": 12483.85,
    "new_taxes_no_override": 13023.15,
    "override_total_1": 13392.67,
    "override_increase_1": 369.52
  },
  {
    "#": "1762 Beacon St, Unit 4 & P2 (102-25-04)",
    "$": 1599800,
    "address": "1762 Beacon St, Unit 4 & P2",
    "parcel_id": "102-25-04",
    "owner1": "TAVARES TR, GISELE ADRIANE",
    "owner2": "",
    "current_taxes": 12747.02,
    "new_taxes_no_override": 13297.69,
    "override_total_1": 13675.0,
    "override_increase_1": 377.31
  },
  {
    "#": "1763 Beacon St, Unit 1 P1 7 (225-59-03)",
    "$": 1217800,
    "address": "1763 Beacon St, Unit 1 P1 7",
    "parcel_id": "225-59-03",
    "owner1": "GUZMAN, FELIPE A",
    "owner2": "GARCES, CAMILA A",
    "current_taxes": 8835.34,
    "new_taxes_no_override": 9217.03,
    "override_total_1": 9478.55,
    "override_increase_1": 261.53
  },
  {
    "#": "1763 Beacon St, Unit 2 & P2 (225-59-04)",
    "$": 1196300,
    "address": "1763 Beacon St, Unit 2 & P2",
    "parcel_id": "225-59-04",
    "owner1": "MENE XAVIER, CLAUDIA REGINA",
    "owner2": "",
    "current_taxes": 12250.11,
    "new_taxes_no_override": 12779.31,
    "override_total_1": 13141.92,
    "override_increase_1": 362.6
  },
  {
    "#": "1763 Beacon St, Unit 3 & P-3 (225-59-05)",
    "$": 1163400,
    "address": "1763 Beacon St, Unit 3 & P-3",
    "parcel_id": "225-59-05",
    "owner1": "JONES, EMMA & CLAY",
    "owner2": "",
    "current_taxes": 8278.28,
    "new_taxes_no_override": 8635.9,
    "override_total_1": 8880.94,
    "override_increase_1": 245.04
  },
  {
    "#": "1763 Beacon St, Unit 4 & P4 (225-59-06)",
    "$": 705400,
    "address": "1763 Beacon St, Unit 4 & P4",
    "parcel_id": "225-59-06",
    "owner1": "JONES, CLAY & EMMA",
    "owner2": "",
    "current_taxes": 7223.3,
    "new_taxes_no_override": 7535.35,
    "override_total_1": 7749.16,
    "override_increase_1": 213.81
  },
  {
    "#": "1763 Beacon St, Unit A & P6 (225-59-01)",
    "$": 491900,
    "address": "1763 Beacon St, Unit A & P6",
    "parcel_id": "225-59-01",
    "owner1": "LI, LIZA",
    "owner2": "MOI, NELSON",
    "current_taxes": 5037.06,
    "new_taxes_no_override": 5254.66,
    "override_total_1": 5403.76,
    "override_increase_1": 149.1
  },
  {
    "#": "1763 Beacon St, Unit B & P5 (225-59-02)",
    "$": 583800,
    "address": "1763 Beacon St, Unit B & P5",
    "parcel_id": "225-59-02",
    "owner1": "HUANG, JUAN JUAN & SHAN SHAN",
    "owner2": "",
    "current_taxes": 2343.18,
    "new_taxes_no_override": 2444.41,
    "override_total_1": 2513.76,
    "override_increase_1": 69.36
  },
  {
    "#": "1768 Beacon St, Unit 1 (102-26-02)",
    "$": 606300,
    "address": "1768 Beacon St, Unit 1",
    "parcel_id": "102-26-02",
    "owner1": "ANZELLOTTI, CHRISTOPHER & ANTHONY P",
    "owner2": "",
    "current_taxes": 6208.51,
    "new_taxes_no_override": 6476.72,
    "override_total_1": 6660.49,
    "override_increase_1": 183.77
  },
  {
    "#": "1768 Beacon St, Unit 2 (102-26-03)",
    "$": 710300,
    "address": "1768 Beacon St, Unit 2",
    "parcel_id": "102-26-03",
    "owner1": "NALEPA, KAZIMIERZ",
    "owner2": "",
    "current_taxes": 7273.47,
    "new_taxes_no_override": 7587.68,
    "override_total_1": 7802.98,
    "override_increase_1": 215.29
  },
  {
    "#": "1768 Beacon St, Unit 21 (102-26-06)",
    "$": 682500,
    "address": "1768 Beacon St, Unit 21",
    "parcel_id": "102-26-06",
    "owner1": "XU, WENJIA",
    "owner2": "",
    "current_taxes": 6988.8,
    "new_taxes_no_override": 7290.72,
    "override_total_1": 7497.58,
    "override_increase_1": 206.87
  },
  {
    "#": "1768 Beacon St, Unit 22 (102-26-07)",
    "$": 735800,
    "address": "1768 Beacon St, Unit 22",
    "parcel_id": "102-26-07",
    "owner1": "WITHERS TRS, JOHN W & CAROL R",
    "owner2": "",
    "current_taxes": 7534.59,
    "new_taxes_no_override": 7860.08,
    "override_total_1": 8083.11,
    "override_increase_1": 223.02
  },
  {
    "#": "1768 Beacon St, Unit 23 (102-26-08)",
    "$": 721400,
    "address": "1768 Beacon St, Unit 23",
    "parcel_id": "102-26-08",
    "owner1": "HERSCH, STEVEN",
    "owner2": "ROSAS, HERMINIA DIANA",
    "current_taxes": 7387.14,
    "new_taxes_no_override": 7706.26,
    "override_total_1": 7924.92,
    "override_increase_1": 218.66
  },
  {
    "#": "1768 Beacon St, Unit 24 (102-26-09)",
    "$": 607600,
    "address": "1768 Beacon St, Unit 24",
    "parcel_id": "102-26-09",
    "owner1": "SHAAR, ALON & ANNA",
    "owner2": "",
    "current_taxes": 6221.82,
    "new_taxes_no_override": 6490.6,
    "override_total_1": 6674.77,
    "override_increase_1": 184.17
  },
  {
    "#": "1768 Beacon St, Unit 3 (102-26-04)",
    "$": 706100,
    "address": "1768 Beacon St, Unit 3",
    "parcel_id": "102-26-04",
    "owner1": "GAST TR, JAMES ARTHUR",
    "owner2": "",
    "current_taxes": 7230.46,
    "new_taxes_no_override": 7542.82,
    "override_total_1": 7756.84,
    "override_increase_1": 214.02
  },
  {
    "#": "1768 Beacon St, Unit 31 (102-26-10)",
    "$": 682500,
    "address": "1768 Beacon St, Unit 31",
    "parcel_id": "102-26-10",
    "owner1": "MOSLEY, CAOIMHE M",
    "owner2": "",
    "current_taxes": 6988.8,
    "new_taxes_no_override": 7290.72,
    "override_total_1": 7497.58,
    "override_increase_1": 206.87
  },
  {
    "#": "1768 Beacon St, Unit 32 (102-26-11)",
    "$": 710300,
    "address": "1768 Beacon St, Unit 32",
    "parcel_id": "102-26-11",
    "owner1": "ROCKWOOD, TR, MARION B",
    "owner2": "",
    "current_taxes": 3638.54,
    "new_taxes_no_override": 3795.72,
    "override_total_1": 3903.43,
    "override_increase_1": 107.7
  },
  {
    "#": "1768 Beacon St, Unit 33 (102-26-12)",
    "$": 721400,
    "address": "1768 Beacon St, Unit 33",
    "parcel_id": "102-26-12",
    "owner1": "ABBOTT, JOHN R & NANCY E",
    "owner2": "LAZOWSKI  TRS, DANA K & DAVID",
    "current_taxes": 7387.14,
    "new_taxes_no_override": 7706.26,
    "override_total_1": 7924.92,
    "override_increase_1": 218.66
  },
  {
    "#": "1768 Beacon St, Unit 34 (102-26-13)",
    "$": 617800,
    "address": "1768 Beacon St, Unit 34",
    "parcel_id": "102-26-13",
    "owner1": "CATENZA TR, MARIA SHEILA",
    "owner2": "",
    "current_taxes": 2691.34,
    "new_taxes_no_override": 2807.61,
    "override_total_1": 2887.27,
    "override_increase_1": 79.66
  },
  {
    "#": "1768 Beacon St, Unit 4 (102-26-05)",
    "$": 633100,
    "address": "1768 Beacon St, Unit 4",
    "parcel_id": "102-26-05",
    "owner1": "LUTFI, NASSIB",
    "owner2": "",
    "current_taxes": 6482.94,
    "new_taxes_no_override": 6763.0,
    "override_total_1": 6954.9,
    "override_increase_1": 191.9
  },
  {
    "#": "1768 Beacon St, Unit 41 (102-26-14)",
    "$": 657000,
    "address": "1768 Beacon St, Unit 41",
    "parcel_id": "102-26-14",
    "owner1": "NOWINSKI, LISA",
    "owner2": "",
    "current_taxes": 6727.68,
    "new_taxes_no_override": 7018.32,
    "override_total_1": 7217.46,
    "override_increase_1": 199.14
  },
  {
    "#": "1768 Beacon St, Unit 42 (102-26-15)",
    "$": 710300,
    "address": "1768 Beacon St, Unit 42",
    "parcel_id": "102-26-15",
    "owner1": "BISSETT TR, AMELIA",
    "owner2": "",
    "current_taxes": 7273.47,
    "new_taxes_no_override": 7587.68,
    "override_total_1": 7802.98,
    "override_increase_1": 215.29
  },
  {
    "#": "1768 Beacon St, Unit 43 (102-26-16)",
    "$": 695900,
    "address": "1768 Beacon St, Unit 43",
    "parcel_id": "102-26-16",
    "owner1": "GOURDOUPI, HARICLIA JOYCE",
    "owner2": "",
    "current_taxes": 3491.08,
    "new_taxes_no_override": 3641.89,
    "override_total_1": 3745.23,
    "override_increase_1": 103.34
  },
  {
    "#": "1768 Beacon St, Unit 44 (102-26-17)",
    "$": 607600,
    "address": "1768 Beacon St, Unit 44",
    "parcel_id": "102-26-17",
    "owner1": "SLODKI, SHARON R",
    "owner2": "",
    "current_taxes": 2586.89,
    "new_taxes_no_override": 2698.64,
    "override_total_1": 2775.22,
    "override_increase_1": 76.57
  },
  {
    "#": "1768 Beacon St, Unit B (102-26-01)",
    "$": 566900,
    "address": "1768 Beacon St, Unit B",
    "parcel_id": "102-26-01",
    "owner1": "ABBOTT, JOHN R & NANCY E",
    "owner2": "",
    "current_taxes": 2170.12,
    "new_taxes_no_override": 2263.87,
    "override_total_1": 2328.1,
    "override_increase_1": 64.24
  },
  {
    "#": "1773 Beacon St (234-02-00)",
    "$": 11286000,
    "address": "1773 Beacon St",
    "parcel_id": "234-02-00",
    "owner1": "ALL SAINTS PARISH",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "1774 Beacon St, Unit 1 (106-01-01)",
    "$": 653300,
    "address": "1774 Beacon St, Unit 1",
    "parcel_id": "106-01-01",
    "owner1": "HEPOLA  TR, PAMELA SUSAN",
    "owner2": "",
    "current_taxes": 6689.79,
    "new_taxes_no_override": 6978.79,
    "override_total_1": 7176.81,
    "override_increase_1": 198.02
  },
  {
    "#": "1774 Beacon St, Unit 2-3 & P1 (106-01-07)",
    "$": 821900,
    "address": "1774 Beacon St, Unit 2-3 & P1",
    "parcel_id": "106-01-07",
    "owner1": "1774 BEACON STREET LLC",
    "owner2": "",
    "current_taxes": 8416.26,
    "new_taxes_no_override": 8779.84,
    "override_total_1": 9028.96,
    "override_increase_1": 249.12
  },
  {
    "#": "1774 Beacon St, Unit 4 & P3 (106-01-04)",
    "$": 771100,
    "address": "1774 Beacon St, Unit 4 & P3",
    "parcel_id": "106-01-04",
    "owner1": "NOLAN, RICHARD C & MARY",
    "owner2": "",
    "current_taxes": 7896.06,
    "new_taxes_no_override": 8237.17,
    "override_total_1": 8470.89,
    "override_increase_1": 233.72
  },
  {
    "#": "1774 Beacon St, Unit 5 & Prk 2 (106-01-05)",
    "$": 833600,
    "address": "1774 Beacon St, Unit 5 & Prk 2",
    "parcel_id": "106-01-05",
    "owner1": "ARMSTRONG, VICTORIA T",
    "owner2": "",
    "current_taxes": 8536.06,
    "new_taxes_no_override": 8904.82,
    "override_total_1": 9157.49,
    "override_increase_1": 252.67
  },
  {
    "#": "1774 Beacon St, Unit 6 & P4 (106-01-06)",
    "$": 727000,
    "address": "1774 Beacon St, Unit 6 & P4",
    "parcel_id": "106-01-06",
    "owner1": "VAZIRI, SONYA M",
    "owner2": "",
    "current_taxes": 7444.48,
    "new_taxes_no_override": 7766.08,
    "override_total_1": 7986.44,
    "override_increase_1": 220.36
  },
  {
    "#": "1776 Beacon St (106-02-00)",
    "$": 2956500,
    "address": "1776 Beacon St",
    "parcel_id": "106-02-00",
    "owner1": "BEACON 1776 INVESTMENT PARTNERS LLC",
    "owner2": "",
    "current_taxes": 32314.58,
    "new_taxes_no_override": 33710.57,
    "override_total_1": 34667.08,
    "override_increase_1": 956.51
  },
  {
    "#": "1778 Beacon St, Unit 101 (106-03-01)",
    "$": 528600,
    "address": "1778 Beacon St, Unit 101",
    "parcel_id": "106-03-01",
    "owner1": "PFAU, ANNIKA & JAKOB",
    "owner2": "",
    "current_taxes": 1777.93,
    "new_taxes_no_override": 1854.74,
    "override_total_1": 1907.36,
    "override_increase_1": 52.63
  },
  {
    "#": "1778 Beacon St, Unit 102 & P-A (106-03-02)",
    "$": 929500,
    "address": "1778 Beacon St, Unit 102 & P-A",
    "parcel_id": "106-03-02",
    "owner1": "DOUBEK, JILLIAN",
    "owner2": "",
    "current_taxes": 5883.15,
    "new_taxes_no_override": 6137.3,
    "override_total_1": 6311.44,
    "override_increase_1": 174.14
  },
  {
    "#": "1778 Beacon St, Unit 201 (106-03-03)",
    "$": 632900,
    "address": "1778 Beacon St, Unit 201",
    "parcel_id": "106-03-03",
    "owner1": "LEON TR, SONIA A",
    "owner2": "",
    "current_taxes": 6480.9,
    "new_taxes_no_override": 6760.87,
    "override_total_1": 6952.71,
    "override_increase_1": 191.83
  },
  {
    "#": "1778 Beacon St, Unit 301 (106-03-04)",
    "$": 830300,
    "address": "1778 Beacon St, Unit 301",
    "parcel_id": "106-03-04",
    "owner1": "SAVCHENKO, ALEXANDER",
    "owner2": "",
    "current_taxes": 4867.34,
    "new_taxes_no_override": 5077.61,
    "override_total_1": 5221.68,
    "override_increase_1": 144.07
  },
  {
    "#": "1778 Beacon St, Unit 302 & P-B (106-03-05)",
    "$": 968600,
    "address": "1778 Beacon St, Unit 302 & P-B",
    "parcel_id": "106-03-05",
    "owner1": "STONE, ROBERT G",
    "owner2": "",
    "current_taxes": 6283.53,
    "new_taxes_no_override": 6554.98,
    "override_total_1": 6740.97,
    "override_increase_1": 185.99
  },
  {
    "#": "1780 Beacon St, Unit 4 (106-04-09)",
    "$": 921400,
    "address": "1780 Beacon St, Unit 4",
    "parcel_id": "106-04-09",
    "owner1": "1780 BEACON TRUST LLC",
    "owner2": "",
    "current_taxes": 9435.14,
    "new_taxes_no_override": 9842.74,
    "override_total_1": 10122.02,
    "override_increase_1": 279.28
  },
  {
    "#": "1780 Beacon St, Unit 5 (106-04-10)",
    "$": 1009500,
    "address": "1780 Beacon St, Unit 5",
    "parcel_id": "106-04-10",
    "owner1": "1780 BEACON TRUST LLC",
    "owner2": "",
    "current_taxes": 10337.28,
    "new_taxes_no_override": 10783.85,
    "override_total_1": 11089.83,
    "override_increase_1": 305.98
  },
  {
    "#": "1780 Beacon St, Unit 6 (106-04-11)",
    "$": 1009400,
    "address": "1780 Beacon St, Unit 6",
    "parcel_id": "106-04-11",
    "owner1": "1780 BEACON TRUST LLC",
    "owner2": "",
    "current_taxes": 10336.26,
    "new_taxes_no_override": 10782.79,
    "override_total_1": 11088.74,
    "override_increase_1": 305.95
  },
  {
    "#": "1782 Beacon St, Unit 1 & P2 (106-04-06)",
    "$": 2152300,
    "address": "1782 Beacon St, Unit 1 & P2",
    "parcel_id": "106-04-06",
    "owner1": "PROBOLUS TR, JOHN X",
    "owner2": "",
    "current_taxes": 22039.55,
    "new_taxes_no_override": 22991.66,
    "override_total_1": 23644.03,
    "override_increase_1": 652.37
  },
  {
    "#": "1782 Beacon St, Unit 2 & P1 (106-04-07)",
    "$": 1585300,
    "address": "1782 Beacon St, Unit 2 & P1",
    "parcel_id": "106-04-07",
    "owner1": "SOOBEN, KEVIN",
    "owner2": "KEATING, KAREN",
    "current_taxes": 16233.47,
    "new_taxes_no_override": 16934.76,
    "override_total_1": 17415.27,
    "override_increase_1": 480.51
  },
  {
    "#": "1782 Beacon St, Unit 3 & P3 (106-04-08)",
    "$": 1628400,
    "address": "1782 Beacon St, Unit 3 & P3",
    "parcel_id": "106-04-08",
    "owner1": "CHASIN, GEOFFREY & STELLA O",
    "owner2": "",
    "current_taxes": 13039.88,
    "new_taxes_no_override": 13603.2,
    "override_total_1": 13989.18,
    "override_increase_1": 385.98
  },
  {
    "#": "1784 Beacon St (106-06-00)",
    "$": 1387000,
    "address": "1784 Beacon St",
    "parcel_id": "106-06-00",
    "owner1": "SANIEOFF TR, SYROOS",
    "owner2": "",
    "current_taxes": 23800.92,
    "new_taxes_no_override": 24829.12,
    "override_total_1": 25533.63,
    "override_increase_1": 704.51
  },
  {
    "#": "1788 Beacon St (106-07-00)",
    "$": 7089600,
    "address": "1788 Beacon St",
    "parcel_id": "106-07-00",
    "owner1": "TREMONT PROPERTY LP",
    "owner2": "",
    "current_taxes": 72597.5,
    "new_taxes_no_override": 75733.71,
    "override_total_1": 77882.6,
    "override_increase_1": 2148.89
  },
  {
    "#": "1789 Beacon St (234-03-00)",
    "$": 5305500,
    "address": "1789 Beacon St",
    "parcel_id": "234-03-00",
    "owner1": "ALL SAINTS PARISH",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "1791 Beacon St (234-04-00)",
    "$": 2729400,
    "address": "1791 Beacon St",
    "parcel_id": "234-04-00",
    "owner1": "PETERSEN TR, KAREN E",
    "owner2": "",
    "current_taxes": 24314.12,
    "new_taxes_no_override": 25364.49,
    "override_total_1": 26084.19,
    "override_increase_1": 719.7
  },
  {
    "#": "1793 Beacon St, Unit 3 (234-05-03)",
    "$": 852100,
    "address": "1793 Beacon St, Unit 3",
    "parcel_id": "234-05-03",
    "owner1": "HO TR, ANDREW POJUNG",
    "owner2": "",
    "current_taxes": 8725.5,
    "new_taxes_no_override": 9102.44,
    "override_total_1": 9360.72,
    "override_increase_1": 258.27
  },
  {
    "#": "1793 Beacon St, Unit 4 (234-05-04)",
    "$": 529800,
    "address": "1793 Beacon St, Unit 4",
    "parcel_id": "234-05-04",
    "owner1": "PAUZE, KATHY J",
    "owner2": "",
    "current_taxes": 5425.15,
    "new_taxes_no_override": 5659.52,
    "override_total_1": 5820.1,
    "override_increase_1": 160.58
  },
  {
    "#": "1793 Beacon St, Unit 5 & P5 (234-05-05)",
    "$": 846100,
    "address": "1793 Beacon St, Unit 5 & P5",
    "parcel_id": "234-05-05",
    "owner1": "BELOUS, ANDREY",
    "owner2": "VAINER, ELENA",
    "current_taxes": 8664.06,
    "new_taxes_no_override": 9038.35,
    "override_total_1": 9294.8,
    "override_increase_1": 256.46
  },
  {
    "#": "1793 Beacon St, Unit 6 (234-05-06)",
    "$": 529800,
    "address": "1793 Beacon St, Unit 6",
    "parcel_id": "234-05-06",
    "owner1": "CHEUNG, MEI PO",
    "owner2": "",
    "current_taxes": 5425.15,
    "new_taxes_no_override": 5659.52,
    "override_total_1": 5820.1,
    "override_increase_1": 160.58
  },
  {
    "#": "1793 Beacon St, Unit Th-1 (234-05-01)",
    "$": 1040500,
    "address": "1793 Beacon St, Unit Th-1",
    "parcel_id": "234-05-01",
    "owner1": "GANJEI, ALBERT",
    "owner2": "",
    "current_taxes": 10654.72,
    "new_taxes_no_override": 11115.0,
    "override_total_1": 11430.38,
    "override_increase_1": 315.38
  },
  {
    "#": "1793 Beacon St, Unit Th-2 (234-05-02)",
    "$": 614700,
    "address": "1793 Beacon St, Unit Th-2",
    "parcel_id": "234-05-02",
    "owner1": "HUTCHISON, WARREN D III",
    "owner2": "",
    "current_taxes": 6294.53,
    "new_taxes_no_override": 6566.45,
    "override_total_1": 6752.77,
    "override_increase_1": 186.32
  },
  {
    "#": "1795 Beacon St, Unit 1 (234-06-03)",
    "$": 1060000,
    "address": "1795 Beacon St, Unit 1",
    "parcel_id": "234-06-03",
    "owner1": "KNIFFIN TR, MARK A",
    "owner2": "",
    "current_taxes": 7219.47,
    "new_taxes_no_override": 7531.35,
    "override_total_1": 7745.05,
    "override_increase_1": 213.7
  },
  {
    "#": "1795 Beacon St, Unit 1A & Gar C (234-06-04)",
    "$": 683800,
    "address": "1795 Beacon St, Unit 1A & Gar C",
    "parcel_id": "234-06-04",
    "owner1": "FESSLER, NATHAN E",
    "owner2": "CHAZAN, SYDNEY D",
    "current_taxes": 3367.18,
    "new_taxes_no_override": 3512.64,
    "override_total_1": 3612.31,
    "override_increase_1": 99.67
  },
  {
    "#": "1795 Beacon St, Unit 2 & Gar B (234-06-01)",
    "$": 1254800,
    "address": "1795 Beacon St, Unit 2 & Gar B",
    "parcel_id": "234-06-01",
    "owner1": "JACOBSON, JOSEPH & SHARON",
    "owner2": "",
    "current_taxes": 9214.22,
    "new_taxes_no_override": 9612.27,
    "override_total_1": 9885.02,
    "override_increase_1": 272.74
  },
  {
    "#": "1795 Beacon St, Unit 3 (234-06-02)",
    "$": 1289700,
    "address": "1795 Beacon St, Unit 3",
    "parcel_id": "234-06-02",
    "owner1": "FAUST, FLORENT",
    "owner2": "LAVENE, NATHALIE",
    "current_taxes": 9571.59,
    "new_taxes_no_override": 9985.08,
    "override_total_1": 10268.4,
    "override_increase_1": 283.32
  },
  {
    "#": "1796 Beacon St (107-01-00)",
    "$": 2119400,
    "address": "1796 Beacon St",
    "parcel_id": "107-01-00",
    "owner1": "METROPOLITAN REALTY LLC",
    "owner2": "",
    "current_taxes": 21702.66,
    "new_taxes_no_override": 22640.21,
    "override_total_1": 23282.61,
    "override_increase_1": 642.4
  },
  {
    "#": "1797 Beacon St (234-07-00)",
    "$": 3542100,
    "address": "1797 Beacon St",
    "parcel_id": "234-07-00",
    "owner1": "VAID, KULDIP K & ANANYA A",
    "owner2": "",
    "current_taxes": 36271.1,
    "new_taxes_no_override": 37838.01,
    "override_total_1": 38911.64,
    "override_increase_1": 1073.62
  },
  {
    "#": "1798 Beacon St (107-02-00)",
    "$": 2262000,
    "address": "1798 Beacon St",
    "parcel_id": "107-02-00",
    "owner1": "GEORGAKLIS, CLIFTON C",
    "owner2": "",
    "current_taxes": 30165.64,
    "new_taxes_no_override": 31468.8,
    "override_total_1": 32361.7,
    "override_increase_1": 892.9
  },
  {
    "#": "1799 Beacon St (234-08-00)",
    "$": 2591100,
    "address": "1799 Beacon St",
    "parcel_id": "234-08-00",
    "owner1": "SANIEOFF, MONDANY",
    "owner2": "C/O ROBERT E FIREMAN ESQ",
    "current_taxes": 26532.86,
    "new_taxes_no_override": 27679.08,
    "override_total_1": 28464.45,
    "override_increase_1": 785.37
  },
  {
    "#": "1800 Beacon St (107-03-00)",
    "$": 4075800,
    "address": "1800 Beacon St",
    "parcel_id": "107-03-00",
    "owner1": "ZION, HEATHER HOLZMAN",
    "owner2": "TAYLOR, GERARD ART",
    "current_taxes": 41736.19,
    "new_taxes_no_override": 43539.19,
    "override_total_1": 44774.58,
    "override_increase_1": 1235.39
  },
  {
    "#": "1801 Beacon St (234-09-00)",
    "$": 4721900,
    "address": "1801 Beacon St",
    "parcel_id": "234-09-00",
    "owner1": "1801 BEACON ST LLC",
    "owner2": "",
    "current_taxes": 48352.26,
    "new_taxes_no_override": 50441.08,
    "override_total_1": 51872.3,
    "override_increase_1": 1431.23
  },
  {
    "#": "1802 Beacon St (107-04-00)",
    "$": 3457600,
    "address": "1802 Beacon St",
    "parcel_id": "107-04-00",
    "owner1": "NEWBOLD TRS, MICHAEL F & BETH T",
    "owner2": "",
    "current_taxes": 31770.89,
    "new_taxes_no_override": 33143.39,
    "override_total_1": 34083.81,
    "override_increase_1": 940.42
  },
  {
    "#": "1803 Beacon St (234-10-00)",
    "$": 3124100,
    "address": "1803 Beacon St",
    "parcel_id": "234-10-00",
    "owner1": "SLD 1803 BEACON LLC",
    "owner2": "",
    "current_taxes": 31990.78,
    "new_taxes_no_override": 33372.78,
    "override_total_1": 34319.71,
    "override_increase_1": 946.93
  },
  {
    "#": "1804 Beacon St (107-05-00)",
    "$": 2646100,
    "address": "1804 Beacon St",
    "parcel_id": "107-05-00",
    "owner1": "REISMAN TRS, JOEL M & OLGA C",
    "owner2": "",
    "current_taxes": 23461.13,
    "new_taxes_no_override": 24474.65,
    "override_total_1": 25169.1,
    "override_increase_1": 694.45
  },
  {
    "#": "1805 Beacon St (234-11-00)",
    "$": 3187000,
    "address": "1805 Beacon St",
    "parcel_id": "234-11-00",
    "owner1": "WHITE TR, SHEILA ROGOVIN",
    "owner2": "",
    "current_taxes": 32634.88,
    "new_taxes_no_override": 34044.71,
    "override_total_1": 35010.7,
    "override_increase_1": 965.99
  },
  {
    "#": "1806 Beacon St (107-06-00)",
    "$": 2528100,
    "address": "1806 Beacon St",
    "parcel_id": "107-06-00",
    "owner1": "KIRASIROV, VLADIMIR",
    "owner2": "BEREKETOVA, TATYANA",
    "current_taxes": 22252.81,
    "new_taxes_no_override": 23214.13,
    "override_total_1": 23872.81,
    "override_increase_1": 658.68
  },
  {
    "#": "1807 Beacon St, Unit 1 & Pk 4 (234-12-02)",
    "$": 760600,
    "address": "1807 Beacon St, Unit 1 & Pk 4",
    "parcel_id": "234-12-02",
    "owner1": "CRUSBERG, THEODORE & MARIE",
    "owner2": "",
    "current_taxes": 4153.61,
    "new_taxes_no_override": 4333.05,
    "override_total_1": 4455.99,
    "override_increase_1": 122.95
  },
  {
    "#": "1807 Beacon St, Unit 1A & Pk 2 (234-12-03)",
    "$": 546500,
    "address": "1807 Beacon St, Unit 1A & Pk 2",
    "parcel_id": "234-12-03",
    "owner1": "STEPHANIAN, LEVON WESTLEIGH",
    "owner2": "",
    "current_taxes": 1961.23,
    "new_taxes_no_override": 2045.96,
    "override_total_1": 2104.01,
    "override_increase_1": 58.05
  },
  {
    "#": "1807 Beacon St, Unit 2 & P3 (234-12-04)",
    "$": 1129500,
    "address": "1807 Beacon St, Unit 2 & P3",
    "parcel_id": "234-12-04",
    "owner1": "ANIS, ELIZA BARTLETT & KARIM",
    "owner2": "",
    "current_taxes": 7931.15,
    "new_taxes_no_override": 8273.78,
    "override_total_1": 8508.54,
    "override_increase_1": 234.76
  },
  {
    "#": "1807 Beacon St, Unit 3 & P-5 (234-12-05)",
    "$": 1389200,
    "address": "1807 Beacon St, Unit 3 & P-5",
    "parcel_id": "234-12-05",
    "owner1": "LOUGHNANE, CHRISTOPHER & SHANNON",
    "owner2": "",
    "current_taxes": 10590.47,
    "new_taxes_no_override": 11047.98,
    "override_total_1": 11361.46,
    "override_increase_1": 313.48
  },
  {
    "#": "1807 Beacon St, Unit G & P1 (234-12-01)",
    "$": 645900,
    "address": "1807 Beacon St, Unit G & P1",
    "parcel_id": "234-12-01",
    "owner1": "GILLIS, ERNEST M",
    "owner2": "TOH, MADELEINE L",
    "current_taxes": 2979.08,
    "new_taxes_no_override": 3107.78,
    "override_total_1": 3195.96,
    "override_increase_1": 88.18
  },
  {
    "#": "1808 Beacon St (107-07-00)",
    "$": 2440100,
    "address": "1808 Beacon St",
    "parcel_id": "107-07-00",
    "owner1": "VAN HAEREN, PASCAL & MIEKO",
    "owner2": "",
    "current_taxes": 21351.69,
    "new_taxes_no_override": 22274.08,
    "override_total_1": 22906.09,
    "override_increase_1": 632.01
  },
  {
    "#": "1809 Beacon St (234-13-00)",
    "$": 3036400,
    "address": "1809 Beacon St",
    "parcel_id": "234-13-00",
    "owner1": "GROZALSKY, SAMUEL & MARJORIE A & MARC E & JILL R",
    "owner2": "",
    "current_taxes": 31092.74,
    "new_taxes_no_override": 32435.95,
    "override_total_1": 33356.29,
    "override_increase_1": 920.35
  },
  {
    "#": "1810 Beacon St (107-08-00)",
    "$": 2693200,
    "address": "1810 Beacon St",
    "parcel_id": "107-08-00",
    "owner1": "KAGLE TRS, DAVID M",
    "owner2": "BAYLUS, SUSAN L",
    "current_taxes": 23943.43,
    "new_taxes_no_override": 24977.79,
    "override_total_1": 25686.51,
    "override_increase_1": 708.73
  },
  {
    "#": "1811 Beacon St (234-14-00)",
    "$": 2622100,
    "address": "1811 Beacon St",
    "parcel_id": "234-14-00",
    "owner1": "CHRISTOPHER TR, MARY ANN",
    "owner2": "",
    "current_taxes": 23215.37,
    "new_taxes_no_override": 24218.27,
    "override_total_1": 24905.45,
    "override_increase_1": 687.17
  },
  {
    "#": "1812 Beacon St (107-09-00)",
    "$": 2558900,
    "address": "1812 Beacon St",
    "parcel_id": "107-09-00",
    "owner1": "LANSING, ANGUS & BARBARA",
    "owner2": "",
    "current_taxes": 22568.2,
    "new_taxes_no_override": 23543.15,
    "override_total_1": 24211.16,
    "override_increase_1": 668.02
  },
  {
    "#": "1815 Beacon St (234-15-00)",
    "$": 2655100,
    "address": "1815 Beacon St",
    "parcel_id": "234-15-00",
    "owner1": "LAUFER, TRS, DAVID-SIMA-DEBORA",
    "owner2": "",
    "current_taxes": 27188.22,
    "new_taxes_no_override": 28362.75,
    "override_total_1": 29167.52,
    "override_increase_1": 804.77
  },
  {
    "#": "1817 Beacon St (234-16-00)",
    "$": 3258100,
    "address": "1817 Beacon St",
    "parcel_id": "234-16-00",
    "owner1": "URGO TR, LOUISE S",
    "owner2": "",
    "current_taxes": 33362.94,
    "new_taxes_no_override": 34804.22,
    "override_total_1": 35791.76,
    "override_increase_1": 987.54
  },
  {
    "#": "1819 Beacon St (234-17-00)",
    "$": 3787100,
    "address": "1819 Beacon St",
    "parcel_id": "234-17-00",
    "owner1": "WOOD-DYER TR, PAULA",
    "owner2": "",
    "current_taxes": 38779.9,
    "new_taxes_no_override": 40455.19,
    "override_total_1": 41603.08,
    "override_increase_1": 1147.89
  },
  {
    "#": "1821 Beacon St (234-18-00)",
    "$": 2543300,
    "address": "1821 Beacon St",
    "parcel_id": "234-18-00",
    "owner1": "DRISCOLL, WILLIAM G",
    "owner2": "",
    "current_taxes": 26043.39,
    "new_taxes_no_override": 27168.46,
    "override_total_1": 27939.35,
    "override_increase_1": 770.88
  },
  {
    "#": "1822 Beacon St (108-13-00)",
    "$": 4093800,
    "address": "1822 Beacon St",
    "parcel_id": "108-13-00",
    "owner1": "TREMONT PROPERTY LP",
    "owner2": "",
    "current_taxes": 41920.51,
    "new_taxes_no_override": 43731.48,
    "override_total_1": 44972.32,
    "override_increase_1": 1240.85
  },
  {
    "#": "1824 Beacon St, Unit 1 (108-14-01)",
    "$": 939700,
    "address": "1824 Beacon St, Unit 1",
    "parcel_id": "108-14-01",
    "owner1": "TICKLE, TIMOTHY LEE",
    "owner2": "ALLBRIGHT, ERIC FRANCIS",
    "current_taxes": 9622.53,
    "new_taxes_no_override": 10038.22,
    "override_total_1": 10323.05,
    "override_increase_1": 284.83
  },
  {
    "#": "1824 Beacon St, Unit 2 (108-14-02)",
    "$": 1145000,
    "address": "1824 Beacon St, Unit 2",
    "parcel_id": "108-14-02",
    "owner1": "KRISHNAMACHARI TRS, NARASIMHAN",
    "owner2": "TAHER, ZAHIDA",
    "current_taxes": 8089.87,
    "new_taxes_no_override": 8439.35,
    "override_total_1": 8678.81,
    "override_increase_1": 239.46
  },
  {
    "#": "1824 Beacon St, Unit 3 (108-14-03)",
    "$": 1181600,
    "address": "1824 Beacon St, Unit 3",
    "parcel_id": "108-14-03",
    "owner1": "MCCARTHY, JOHN E",
    "owner2": "",
    "current_taxes": 8464.65,
    "new_taxes_no_override": 8830.32,
    "override_total_1": 9080.88,
    "override_increase_1": 250.55
  },
  {
    "#": "1824 Beacon St, Unit 4 (108-14-04)",
    "$": 1186600,
    "address": "1824 Beacon St, Unit 4",
    "parcel_id": "108-14-04",
    "owner1": "MEIGHAN, GRAHAM P",
    "owner2": "SHARAF, ABIGAIL",
    "current_taxes": 8515.85,
    "new_taxes_no_override": 8883.73,
    "override_total_1": 9135.8,
    "override_increase_1": 252.07
  },
  {
    "#": "1824 Beacon St, Unit 5 (108-14-05)",
    "$": 1145000,
    "address": "1824 Beacon St, Unit 5",
    "parcel_id": "108-14-05",
    "owner1": "SEIFERT, JULIE E & VICTORIA",
    "owner2": "",
    "current_taxes": 8089.87,
    "new_taxes_no_override": 8439.35,
    "override_total_1": 8678.81,
    "override_increase_1": 239.46
  },
  {
    "#": "1824 Beacon St, Unit 6 (108-14-06)",
    "$": 1193000,
    "address": "1824 Beacon St, Unit 6",
    "parcel_id": "108-14-06",
    "owner1": "BITTNER, ANDREW B",
    "owner2": "CUNIBERTI, LEIGHA",
    "current_taxes": 8581.39,
    "new_taxes_no_override": 8952.11,
    "override_total_1": 9206.12,
    "override_increase_1": 254.01
  },
  {
    "#": "1824 Beacon St, Unit 7 (108-14-07)",
    "$": 1160700,
    "address": "1824 Beacon St, Unit 7",
    "parcel_id": "108-14-07",
    "owner1": "ISKENDERIAN TR, SHERI A",
    "owner2": "",
    "current_taxes": 8250.63,
    "new_taxes_no_override": 8607.06,
    "override_total_1": 8851.28,
    "override_increase_1": 244.22
  },
  {
    "#": "1834 Beacon St, Unit 1 (108-15-02)",
    "$": 494200,
    "address": "1834 Beacon St, Unit 1",
    "parcel_id": "108-15-02",
    "owner1": "SANTILLI, MARY JO",
    "owner2": "",
    "current_taxes": 1425.67,
    "new_taxes_no_override": 1487.26,
    "override_total_1": 1529.46,
    "override_increase_1": 42.2
  },
  {
    "#": "1834 Beacon St, Unit 10 (108-15-11)",
    "$": 529900,
    "address": "1834 Beacon St, Unit 10",
    "parcel_id": "108-15-11",
    "owner1": "HIRSCH, YANIV",
    "owner2": "",
    "current_taxes": 5426.18,
    "new_taxes_no_override": 5660.59,
    "override_total_1": 5821.21,
    "override_increase_1": 160.61
  },
  {
    "#": "1834 Beacon St, Unit 11 (108-15-12)",
    "$": 572900,
    "address": "1834 Beacon St, Unit 11",
    "parcel_id": "108-15-12",
    "owner1": "SHEN TRS, ZHENXIN",
    "owner2": "HANG, LONG",
    "current_taxes": 5866.5,
    "new_taxes_no_override": 6119.93,
    "override_total_1": 6293.58,
    "override_increase_1": 173.65
  },
  {
    "#": "1834 Beacon St, Unit 12 (108-15-13)",
    "$": 578600,
    "address": "1834 Beacon St, Unit 12",
    "parcel_id": "108-15-13",
    "owner1": "LIANG, LEI",
    "owner2": "XU, XIAOYIN",
    "current_taxes": 5924.86,
    "new_taxes_no_override": 6180.81,
    "override_total_1": 6356.19,
    "override_increase_1": 175.38
  },
  {
    "#": "1834 Beacon St, Unit 12A (108-15-14)",
    "$": 539800,
    "address": "1834 Beacon St, Unit 12A",
    "parcel_id": "108-15-14",
    "owner1": "SIMPSON, JENNIFER",
    "owner2": "",
    "current_taxes": 5527.55,
    "new_taxes_no_override": 5766.34,
    "override_total_1": 5929.96,
    "override_increase_1": 163.62
  },
  {
    "#": "1834 Beacon St, Unit 14 (108-15-15)",
    "$": 504400,
    "address": "1834 Beacon St, Unit 14",
    "parcel_id": "108-15-15",
    "owner1": "LIU, LUPING",
    "owner2": "NI, JIANQUAN",
    "current_taxes": 1530.12,
    "new_taxes_no_override": 1596.22,
    "override_total_1": 1641.51,
    "override_increase_1": 45.29
  },
  {
    "#": "1834 Beacon St, Unit 15 (108-15-16)",
    "$": 584800,
    "address": "1834 Beacon St, Unit 15",
    "parcel_id": "108-15-16",
    "owner1": "HOFFMAN, ANA",
    "owner2": "",
    "current_taxes": 5988.35,
    "new_taxes_no_override": 6247.05,
    "override_total_1": 6424.3,
    "override_increase_1": 177.26
  },
  {
    "#": "1834 Beacon St, Unit 16 (108-15-17)",
    "$": 578600,
    "address": "1834 Beacon St, Unit 16",
    "parcel_id": "108-15-17",
    "owner1": "PKR REALTY LLC",
    "owner2": "",
    "current_taxes": 5924.86,
    "new_taxes_no_override": 6180.81,
    "override_total_1": 6356.19,
    "override_increase_1": 175.38
  },
  {
    "#": "1834 Beacon St, Unit 2 (108-15-03)",
    "$": 491600,
    "address": "1834 Beacon St, Unit 2",
    "parcel_id": "108-15-03",
    "owner1": "FUCHS, DONNA",
    "owner2": "",
    "current_taxes": 5033.98,
    "new_taxes_no_override": 5251.45,
    "override_total_1": 5400.45,
    "override_increase_1": 149.01
  },
  {
    "#": "1834 Beacon St, Unit 3 (108-15-04)",
    "$": 550900,
    "address": "1834 Beacon St, Unit 3",
    "parcel_id": "108-15-04",
    "owner1": "BELENKII, MARK",
    "owner2": "",
    "current_taxes": 5641.22,
    "new_taxes_no_override": 5884.92,
    "override_total_1": 6051.9,
    "override_increase_1": 166.98
  },
  {
    "#": "1834 Beacon St, Unit 4 (108-15-05)",
    "$": 546000,
    "address": "1834 Beacon St, Unit 4",
    "parcel_id": "108-15-05",
    "owner1": "ALIZADEH TR, ELIZABETH",
    "owner2": "",
    "current_taxes": 5591.04,
    "new_taxes_no_override": 5832.57,
    "override_total_1": 5998.07,
    "override_increase_1": 165.49
  },
  {
    "#": "1834 Beacon St, Unit 5 (108-15-06)",
    "$": 555900,
    "address": "1834 Beacon St, Unit 5",
    "parcel_id": "108-15-06",
    "owner1": "ASTROG DAVIDSON LLC",
    "owner2": "",
    "current_taxes": 5692.42,
    "new_taxes_no_override": 5938.33,
    "override_total_1": 6106.83,
    "override_increase_1": 168.5
  },
  {
    "#": "1834 Beacon St, Unit 6 (108-15-07)",
    "$": 528000,
    "address": "1834 Beacon St, Unit 6",
    "parcel_id": "108-15-07",
    "owner1": "QUIGLEY REALTY LLC",
    "owner2": "",
    "current_taxes": 5406.72,
    "new_taxes_no_override": 5640.29,
    "override_total_1": 5800.33,
    "override_increase_1": 160.04
  },
  {
    "#": "1834 Beacon St, Unit 7 (108-15-08)",
    "$": 592600,
    "address": "1834 Beacon St, Unit 7",
    "parcel_id": "108-15-08",
    "owner1": "STOLYAR, LINA",
    "owner2": "",
    "current_taxes": 2433.29,
    "new_taxes_no_override": 2538.41,
    "override_total_1": 2610.43,
    "override_increase_1": 72.03
  },
  {
    "#": "1834 Beacon St, Unit 8 (108-15-09)",
    "$": 553800,
    "address": "1834 Beacon St, Unit 8",
    "parcel_id": "108-15-09",
    "owner1": "CHANPONGSANG, SOMPIT",
    "owner2": "SAYABOVORN, KIRATI",
    "current_taxes": 2035.98,
    "new_taxes_no_override": 2123.93,
    "override_total_1": 2184.2,
    "override_increase_1": 60.27
  },
  {
    "#": "1834 Beacon St, Unit 9 (108-15-10)",
    "$": 565300,
    "address": "1834 Beacon St, Unit 9",
    "parcel_id": "108-15-10",
    "owner1": "POON, DAVID",
    "owner2": "",
    "current_taxes": 2153.74,
    "new_taxes_no_override": 2246.78,
    "override_total_1": 2310.53,
    "override_increase_1": 63.75
  },
  {
    "#": "1834 Beacon St, Unit B1 (108-15-34)",
    "$": 463600,
    "address": "1834 Beacon St, Unit B1",
    "parcel_id": "108-15-34",
    "owner1": "YEE, ROBERT",
    "owner2": "",
    "current_taxes": 4747.26,
    "new_taxes_no_override": 4952.34,
    "override_total_1": 5092.86,
    "override_increase_1": 140.52
  },
  {
    "#": "1834 Beacon St, Unit B2 (108-15-01)",
    "$": 357500,
    "address": "1834 Beacon St, Unit B2",
    "parcel_id": "108-15-01",
    "owner1": "LEE TRS, DONNA",
    "owner2": "",
    "current_taxes": 3660.8,
    "new_taxes_no_override": 3818.95,
    "override_total_1": 3927.31,
    "override_increase_1": 108.36
  },
  {
    "#": "1841 Beacon St (234-19-00)",
    "$": 5515500,
    "address": "1841 Beacon St",
    "parcel_id": "234-19-00",
    "owner1": "CHINESE CHRISTIAN CHURCH OF NE",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "1842 Beacon St, Unit 100 (110-01-01)",
    "$": 1721000,
    "address": "1842 Beacon St, Unit 100",
    "parcel_id": "110-01-01",
    "owner1": "BKMK LLC",
    "owner2": "",
    "current_taxes": 29532.36,
    "new_taxes_no_override": 30808.16,
    "override_total_1": 31682.32,
    "override_increase_1": 874.16
  },
  {
    "#": "1842 Beacon St, Unit 101 (110-01-02)",
    "$": 1406500,
    "address": "1842 Beacon St, Unit 101",
    "parcel_id": "110-01-02",
    "owner1": "BKMK LLC",
    "owner2": "",
    "current_taxes": 24135.54,
    "new_taxes_no_override": 25178.2,
    "override_total_1": 25892.61,
    "override_increase_1": 714.41
  },
  {
    "#": "1842 Beacon St, Unit 102 (110-01-03)",
    "$": 812900,
    "address": "1842 Beacon St, Unit 102",
    "parcel_id": "110-01-03",
    "owner1": "BKMK LLC",
    "owner2": "",
    "current_taxes": 13949.36,
    "new_taxes_no_override": 14551.97,
    "override_total_1": 14964.87,
    "override_increase_1": 412.9
  },
  {
    "#": "1842 Beacon St, Unit 201 (110-01-04)",
    "$": 644000,
    "address": "1842 Beacon St, Unit 201",
    "parcel_id": "110-01-04",
    "owner1": "OHRI TRS, GOVERDHAN L & NEETA",
    "owner2": "",
    "current_taxes": 11051.04,
    "new_taxes_no_override": 11528.44,
    "override_total_1": 11855.56,
    "override_increase_1": 327.11
  },
  {
    "#": "1842 Beacon St, Unit 202 (110-01-05)",
    "$": 960600,
    "address": "1842 Beacon St, Unit 202",
    "parcel_id": "110-01-05",
    "owner1": "MOSAIC BOSTON CHURCH INC",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "1842 Beacon St, Unit 203 (110-01-06)",
    "$": 541700,
    "address": "1842 Beacon St, Unit 203",
    "parcel_id": "110-01-06",
    "owner1": "RZG REAL ESTATE HOLDING LLC",
    "owner2": "C/O REUVEN ZASLAVSKI",
    "current_taxes": 9295.57,
    "new_taxes_no_override": 9697.14,
    "override_total_1": 9972.29,
    "override_increase_1": 275.15
  },
  {
    "#": "1842 Beacon St, Unit 205 (110-01-07)",
    "$": 659800,
    "address": "1842 Beacon St, Unit 205",
    "parcel_id": "110-01-07",
    "owner1": "SUITE 205 REALTY LLC",
    "owner2": "",
    "current_taxes": 11322.17,
    "new_taxes_no_override": 11811.29,
    "override_total_1": 12146.42,
    "override_increase_1": 335.14
  },
  {
    "#": "1842 Beacon St, Unit 206 (110-01-08)",
    "$": 809600,
    "address": "1842 Beacon St, Unit 206",
    "parcel_id": "110-01-08",
    "owner1": "BEACON DENTAL REALTY LLC",
    "owner2": "",
    "current_taxes": 13892.74,
    "new_taxes_no_override": 14492.91,
    "override_total_1": 14904.13,
    "override_increase_1": 411.23
  },
  {
    "#": "1842 Beacon St, Unit 207 (110-01-09)",
    "$": 615800,
    "address": "1842 Beacon St, Unit 207",
    "parcel_id": "110-01-09",
    "owner1": "1842 BEACON STREET REALTY LLC",
    "owner2": "",
    "current_taxes": 10567.13,
    "new_taxes_no_override": 11023.63,
    "override_total_1": 11336.42,
    "override_increase_1": 312.79
  },
  {
    "#": "1842 Beacon St, Unit 209 (110-01-10)",
    "$": 646400,
    "address": "1842 Beacon St, Unit 209",
    "parcel_id": "110-01-10",
    "owner1": "1842 BEACON STREET REALTY LLC",
    "owner2": "",
    "current_taxes": 11092.22,
    "new_taxes_no_override": 11571.4,
    "override_total_1": 11899.73,
    "override_increase_1": 328.33
  },
  {
    "#": "1842 Beacon St, Unit 300 (110-01-11)",
    "$": 342600,
    "address": "1842 Beacon St, Unit 300",
    "parcel_id": "110-01-11",
    "owner1": "XIE, WEN JIAN",
    "owner2": "",
    "current_taxes": 5879.02,
    "new_taxes_no_override": 6132.99,
    "override_total_1": 6307.01,
    "override_increase_1": 174.02
  },
  {
    "#": "1842 Beacon St, Unit 301 (110-01-12)",
    "$": 1332900,
    "address": "1842 Beacon St, Unit 301",
    "parcel_id": "110-01-12",
    "owner1": "SBHK LLC",
    "owner2": "C/O HYEJIN KWAK",
    "current_taxes": 22872.56,
    "new_taxes_no_override": 23860.65,
    "override_total_1": 24537.68,
    "override_increase_1": 677.03
  },
  {
    "#": "1842 Beacon St, Unit 302 (110-01-13)",
    "$": 874300,
    "address": "1842 Beacon St, Unit 302",
    "parcel_id": "110-01-13",
    "owner1": "994 WALNUT LLC",
    "owner2": "",
    "current_taxes": 15002.99,
    "new_taxes_no_override": 15651.12,
    "override_total_1": 16095.21,
    "override_increase_1": 444.09
  },
  {
    "#": "1842 Beacon St, Unit 303 (110-01-14)",
    "$": 1040000,
    "address": "1842 Beacon St, Unit 303",
    "parcel_id": "110-01-14",
    "owner1": "AGH HOLDINGS LLC",
    "owner2": "",
    "current_taxes": 17846.4,
    "new_taxes_no_override": 18617.36,
    "override_total_1": 19145.62,
    "override_increase_1": 528.25
  },
  {
    "#": "1842 Beacon St, Unit 305 (110-01-16)",
    "$": 767000,
    "address": "1842 Beacon St, Unit 305",
    "parcel_id": "110-01-16",
    "owner1": "IB REALTY COMPANY LLC",
    "owner2": "",
    "current_taxes": 13161.72,
    "new_taxes_no_override": 13730.31,
    "override_total_1": 14119.89,
    "override_increase_1": 389.59
  },
  {
    "#": "1842 Beacon St, Unit 306 (110-01-17)",
    "$": 514300,
    "address": "1842 Beacon St, Unit 306",
    "parcel_id": "110-01-17",
    "owner1": "TRBLEE LLC",
    "owner2": "",
    "current_taxes": 8825.39,
    "new_taxes_no_override": 9206.65,
    "override_total_1": 9467.88,
    "override_increase_1": 261.23
  },
  {
    "#": "1842 Beacon St, Unit 401 (110-01-18)",
    "$": 1191100,
    "address": "1842 Beacon St, Unit 401",
    "parcel_id": "110-01-18",
    "owner1": "TSI REALTY LLC",
    "owner2": "C/O AMIT SACHDEO, THE SMILE INSTITUTE",
    "current_taxes": 20439.28,
    "new_taxes_no_override": 21322.26,
    "override_total_1": 21927.26,
    "override_increase_1": 605.0
  },
  {
    "#": "1842 Beacon St, Unit 402 (110-01-20)",
    "$": 1021700,
    "address": "1842 Beacon St, Unit 402",
    "parcel_id": "110-01-20",
    "owner1": "AOC REALTY LLC",
    "owner2": "",
    "current_taxes": 17532.37,
    "new_taxes_no_override": 18289.77,
    "override_total_1": 18808.73,
    "override_increase_1": 518.96
  },
  {
    "#": "1842 Beacon St, Unit 403 (110-01-21)",
    "$": 635300,
    "address": "1842 Beacon St, Unit 403",
    "parcel_id": "110-01-21",
    "owner1": "1842 BEACON ST SUITE 403 LLC",
    "owner2": "C/O ARICK MARTIN",
    "current_taxes": 10901.75,
    "new_taxes_no_override": 11372.71,
    "override_total_1": 11695.4,
    "override_increase_1": 322.69
  },
  {
    "#": "1842 Beacon St, Unit 403A (110-01-24)",
    "$": 448500,
    "address": "1842 Beacon St, Unit 403A",
    "parcel_id": "110-01-24",
    "owner1": "MEDIA CULTURE PSYCHIATRY LLC",
    "owner2": "",
    "current_taxes": 7696.26,
    "new_taxes_no_override": 8028.74,
    "override_total_1": 8256.55,
    "override_increase_1": 227.81
  },
  {
    "#": "1842 Beacon St, Unit 404 (110-01-22)",
    "$": 890700,
    "address": "1842 Beacon St, Unit 404",
    "parcel_id": "110-01-22",
    "owner1": "SISAKHTI, SAM",
    "owner2": "",
    "current_taxes": 15284.41,
    "new_taxes_no_override": 15944.7,
    "override_total_1": 16397.12,
    "override_increase_1": 452.42
  },
  {
    "#": "1842 Beacon St, Unit 405 (110-01-23)",
    "$": 811900,
    "address": "1842 Beacon St, Unit 405",
    "parcel_id": "110-01-23",
    "owner1": "BEACON VIEW LLC",
    "owner2": "",
    "current_taxes": 13932.2,
    "new_taxes_no_override": 14534.07,
    "override_total_1": 14946.46,
    "override_increase_1": 412.39
  },
  {
    "#": "1850 Beacon St, Unit 201 & P201 (110-04-20)",
    "$": 824300,
    "address": "1850 Beacon St, Unit 201 & P201",
    "parcel_id": "110-04-20",
    "owner1": "KHROMOVA, SVETLANA",
    "owner2": "",
    "current_taxes": 8440.83,
    "new_taxes_no_override": 8805.47,
    "override_total_1": 9055.32,
    "override_increase_1": 249.85
  },
  {
    "#": "1850 Beacon St, Unit 202 (110-04-01)",
    "$": 801300,
    "address": "1850 Beacon St, Unit 202",
    "parcel_id": "110-04-01",
    "owner1": "WU, YU-HUAI",
    "owner2": "",
    "current_taxes": 8205.31,
    "new_taxes_no_override": 8559.78,
    "override_total_1": 8802.66,
    "override_increase_1": 242.88
  },
  {
    "#": "1850 Beacon St, Unit 203 (110-04-02)",
    "$": 718200,
    "address": "1850 Beacon St, Unit 203",
    "parcel_id": "110-04-02",
    "owner1": "LEE, WENDY K & DANIEL I",
    "owner2": "",
    "current_taxes": 7354.37,
    "new_taxes_no_override": 7672.08,
    "override_total_1": 7889.77,
    "override_increase_1": 217.69
  },
  {
    "#": "1850 Beacon St, Unit 204 & P204 (110-04-03)",
    "$": 900700,
    "address": "1850 Beacon St, Unit 204 & P204",
    "parcel_id": "110-04-03",
    "owner1": "CHANG, VIVIEN",
    "owner2": "",
    "current_taxes": 9223.17,
    "new_taxes_no_override": 9621.61,
    "override_total_1": 9894.62,
    "override_increase_1": 273.01
  },
  {
    "#": "1850 Beacon St, Unit 301 (110-04-04)",
    "$": 979300,
    "address": "1850 Beacon St, Unit 301",
    "parcel_id": "110-04-04",
    "owner1": "LESSES TRS, GLENN",
    "owner2": "FUND, CLAIRE K",
    "current_taxes": 10028.03,
    "new_taxes_no_override": 10461.24,
    "override_total_1": 10758.07,
    "override_increase_1": 296.83
  },
  {
    "#": "1850 Beacon St, Unit 302 (110-04-05)",
    "$": 787100,
    "address": "1850 Beacon St, Unit 302",
    "parcel_id": "110-04-05",
    "owner1": "DANG, QUYNH",
    "owner2": "",
    "current_taxes": 8059.9,
    "new_taxes_no_override": 8408.09,
    "override_total_1": 8646.66,
    "override_increase_1": 238.57
  },
  {
    "#": "1850 Beacon St, Unit 303 (110-04-06)",
    "$": 716800,
    "address": "1850 Beacon St, Unit 303",
    "parcel_id": "110-04-06",
    "owner1": "HASKAL TR, HAIM M",
    "owner2": "",
    "current_taxes": 7340.03,
    "new_taxes_no_override": 7657.12,
    "override_total_1": 7874.38,
    "override_increase_1": 217.26
  },
  {
    "#": "1850 Beacon St, Unit 304 (110-04-07)",
    "$": 979100,
    "address": "1850 Beacon St, Unit 304",
    "parcel_id": "110-04-07",
    "owner1": "BERLUTI, MICHELLE M",
    "owner2": "",
    "current_taxes": 10025.98,
    "new_taxes_no_override": 10459.1,
    "override_total_1": 10755.87,
    "override_increase_1": 296.77
  },
  {
    "#": "1850 Beacon St, Unit 401 & G401 (110-04-08)",
    "$": 871500,
    "address": "1850 Beacon St, Unit 401 & G401",
    "parcel_id": "110-04-08",
    "owner1": "RICHARDSON, MONIQUE K",
    "owner2": "",
    "current_taxes": 5289.23,
    "new_taxes_no_override": 5517.72,
    "override_total_1": 5674.29,
    "override_increase_1": 156.56
  },
  {
    "#": "1850 Beacon St, Unit 402 (110-04-09)",
    "$": 787000,
    "address": "1850 Beacon St, Unit 402",
    "parcel_id": "110-04-09",
    "owner1": "LIN, BRUNO & PO CHING",
    "owner2": "",
    "current_taxes": 4423.95,
    "new_taxes_no_override": 4615.06,
    "override_total_1": 4746.01,
    "override_increase_1": 130.95
  },
  {
    "#": "1850 Beacon St, Unit 403 (110-04-10)",
    "$": 746500,
    "address": "1850 Beacon St, Unit 403",
    "parcel_id": "110-04-10",
    "owner1": "SU, HSIEN-LIN & CHIN-LUNG",
    "owner2": "",
    "current_taxes": 4009.23,
    "new_taxes_no_override": 4182.43,
    "override_total_1": 4301.1,
    "override_increase_1": 118.67
  },
  {
    "#": "1850 Beacon St, Unit 404 (110-04-11)",
    "$": 1114900,
    "address": "1850 Beacon St, Unit 404",
    "parcel_id": "110-04-11",
    "owner1": "GODBOUT, ET AL, BLAKE J",
    "owner2": "",
    "current_taxes": 11416.58,
    "new_taxes_no_override": 11909.78,
    "override_total_1": 12247.71,
    "override_increase_1": 337.93
  },
  {
    "#": "1850 Beacon St, Unit 501 & P501 (110-04-12)",
    "$": 869600,
    "address": "1850 Beacon St, Unit 501 & P501",
    "parcel_id": "110-04-12",
    "owner1": "SHLOSMAN, TR, FELIX",
    "owner2": "",
    "current_taxes": 8904.7,
    "new_taxes_no_override": 9289.38,
    "override_total_1": 9552.96,
    "override_increase_1": 263.58
  },
  {
    "#": "1850 Beacon St, Unit 502 & P520 (110-04-13)",
    "$": 788500,
    "address": "1850 Beacon St, Unit 502 & P520",
    "parcel_id": "110-04-13",
    "owner1": "SHLOSMAN TRS, EVA",
    "owner2": "",
    "current_taxes": 4439.31,
    "new_taxes_no_override": 4631.09,
    "override_total_1": 4762.49,
    "override_increase_1": 131.4
  },
  {
    "#": "1850 Beacon St, Unit 503 & G503 (110-04-14)",
    "$": 720600,
    "address": "1850 Beacon St, Unit 503 & G503",
    "parcel_id": "110-04-14",
    "owner1": "POGGYS, MARLINE",
    "owner2": "",
    "current_taxes": 3744.01,
    "new_taxes_no_override": 3905.75,
    "override_total_1": 4016.57,
    "override_increase_1": 110.82
  },
  {
    "#": "1850 Beacon St, Unit 504 (110-04-15)",
    "$": 852700,
    "address": "1850 Beacon St, Unit 504",
    "parcel_id": "110-04-15",
    "owner1": "KUNG, JANICE",
    "owner2": "",
    "current_taxes": 8731.65,
    "new_taxes_no_override": 9108.86,
    "override_total_1": 9367.31,
    "override_increase_1": 258.46
  },
  {
    "#": "1850 Beacon St, Unit 601 & P601 (110-04-16)",
    "$": 836700,
    "address": "1850 Beacon St, Unit 601 & P601",
    "parcel_id": "110-04-16",
    "owner1": "CHUNG, DAVID C",
    "owner2": "CHI, ANNE",
    "current_taxes": 4932.87,
    "new_taxes_no_override": 5145.97,
    "override_total_1": 5291.98,
    "override_increase_1": 146.01
  },
  {
    "#": "1850 Beacon St, Unit 602 & P602 (110-04-17)",
    "$": 807000,
    "address": "1850 Beacon St, Unit 602 & P602",
    "parcel_id": "110-04-17",
    "owner1": "ZIMMERMAN, WENDY R",
    "owner2": "AUGAT, JUSTIN C",
    "current_taxes": 8263.68,
    "new_taxes_no_override": 8620.67,
    "override_total_1": 8865.28,
    "override_increase_1": 244.6
  },
  {
    "#": "1850 Beacon St, Unit 603 & P603 (110-04-18)",
    "$": 744700,
    "address": "1850 Beacon St, Unit 603 & P603",
    "parcel_id": "110-04-18",
    "owner1": "CHUNG, DAVID CHE-HUNG",
    "owner2": "CHI, ANNE",
    "current_taxes": 7625.73,
    "new_taxes_no_override": 7955.16,
    "override_total_1": 8180.88,
    "override_increase_1": 225.72
  },
  {
    "#": "1850 Beacon St, Unit 604 & P604 (110-04-19)",
    "$": 957500,
    "address": "1850 Beacon St, Unit 604 & P604",
    "parcel_id": "110-04-19",
    "owner1": "WONG, ALFRED K & AIDAY",
    "owner2": "",
    "current_taxes": 9804.8,
    "new_taxes_no_override": 10228.37,
    "override_total_1": 10518.59,
    "override_increase_1": 290.22
  },
  {
    "#": "1853 Beacon St (235-22-00)",
    "$": 2413600,
    "address": "1853 Beacon St",
    "parcel_id": "235-22-00",
    "owner1": "MOO, CHARLES A&LAUREN R&DAVID",
    "owner2": "",
    "current_taxes": 21080.33,
    "new_taxes_no_override": 21991.0,
    "override_total_1": 22614.98,
    "override_increase_1": 623.98
  },
  {
    "#": "1855 Beacon St (235-21-00)",
    "$": 2344200,
    "address": "1855 Beacon St",
    "parcel_id": "235-21-00",
    "owner1": "SLD 1855 BEACON LLC",
    "owner2": "",
    "current_taxes": 24004.61,
    "new_taxes_no_override": 25041.61,
    "override_total_1": 25752.15,
    "override_increase_1": 710.54
  },
  {
    "#": "1856 Beacon St, Unit 2A & G19 (110-05-02)",
    "$": 720400,
    "address": "1856 Beacon St, Unit 2A & G19",
    "parcel_id": "110-05-02",
    "owner1": "BURKHART, LOUISE M",
    "owner2": "LADD, BRIAN K",
    "current_taxes": 3741.96,
    "new_taxes_no_override": 3903.61,
    "override_total_1": 4014.37,
    "override_increase_1": 110.76
  },
  {
    "#": "1856 Beacon St, Unit 2B (110-05-03)",
    "$": 602900,
    "address": "1856 Beacon St, Unit 2B",
    "parcel_id": "110-05-03",
    "owner1": "LI LIFE ESTATE, JENNY JEN-I",
    "owner2": "",
    "current_taxes": 2538.76,
    "new_taxes_no_override": 2648.43,
    "override_total_1": 2723.58,
    "override_increase_1": 75.15
  },
  {
    "#": "1856 Beacon St, Unit 2C & G18 (110-05-04)",
    "$": 671400,
    "address": "1856 Beacon St, Unit 2C & G18",
    "parcel_id": "110-05-04",
    "owner1": "BRODSKY, DEBORAH D & RICHARD",
    "owner2": "",
    "current_taxes": 6875.14,
    "new_taxes_no_override": 7172.15,
    "override_total_1": 7375.65,
    "override_increase_1": 203.5
  },
  {
    "#": "1856 Beacon St, Unit 2D & P4 (110-05-05)",
    "$": 720600,
    "address": "1856 Beacon St, Unit 2D & P4",
    "parcel_id": "110-05-05",
    "owner1": "CORDANI, CAROLINE N",
    "owner2": "",
    "current_taxes": 7378.94,
    "new_taxes_no_override": 7697.71,
    "override_total_1": 7916.13,
    "override_increase_1": 218.42
  },
  {
    "#": "1856 Beacon St, Unit 2E&P5 (110-05-06)",
    "$": 649300,
    "address": "1856 Beacon St, Unit 2E&P5",
    "parcel_id": "110-05-06",
    "owner1": "GAJRIA, KETAN",
    "owner2": "MAKDA, MEHER",
    "current_taxes": 3013.9,
    "new_taxes_no_override": 3144.1,
    "override_total_1": 3233.31,
    "override_increase_1": 89.21
  },
  {
    "#": "1856 Beacon St, Unit 2F & G12 (110-05-07)",
    "$": 703100,
    "address": "1856 Beacon St, Unit 2F & G12",
    "parcel_id": "110-05-07",
    "owner1": "DVORKIN, SVETLANA",
    "owner2": "C/O FACTOROVICH LARISA",
    "current_taxes": 7199.74,
    "new_taxes_no_override": 7510.77,
    "override_total_1": 7723.88,
    "override_increase_1": 213.11
  },
  {
    "#": "1856 Beacon St, Unit 3A (110-05-08)",
    "$": 666900,
    "address": "1856 Beacon St, Unit 3A",
    "parcel_id": "110-05-08",
    "owner1": "CHIN TRS, AH LEK & JANICE KUNG",
    "owner2": "",
    "current_taxes": 6829.06,
    "new_taxes_no_override": 7124.08,
    "override_total_1": 7326.22,
    "override_increase_1": 202.14
  },
  {
    "#": "1856 Beacon St, Unit 3B (110-05-09)",
    "$": 582300,
    "address": "1856 Beacon St, Unit 3B",
    "parcel_id": "110-05-09",
    "owner1": "HIRSCH, YANIV&RONIT&WILHELM",
    "owner2": "",
    "current_taxes": 5962.75,
    "new_taxes_no_override": 6220.34,
    "override_total_1": 6396.84,
    "override_increase_1": 176.5
  },
  {
    "#": "1856 Beacon St, Unit 3C & P3 (110-05-10)",
    "$": 647400,
    "address": "1856 Beacon St, Unit 3C & P3",
    "parcel_id": "110-05-10",
    "owner1": "LEHOTZKY, DAVID",
    "owner2": "WIBOWO, MARSHA CHRISTANVIA",
    "current_taxes": 2994.44,
    "new_taxes_no_override": 3123.8,
    "override_total_1": 3212.44,
    "override_increase_1": 88.64
  },
  {
    "#": "1856 Beacon St, Unit 3D & G8 (110-05-11)",
    "$": 665900,
    "address": "1856 Beacon St, Unit 3D & G8",
    "parcel_id": "110-05-11",
    "owner1": "LAM, PATRICK K & SOCHING A",
    "owner2": "",
    "current_taxes": 6818.82,
    "new_taxes_no_override": 7113.39,
    "override_total_1": 7315.23,
    "override_increase_1": 201.84
  },
  {
    "#": "1856 Beacon St, Unit 3E & P2 (110-05-12)",
    "$": 738700,
    "address": "1856 Beacon St, Unit 3E & P2",
    "parcel_id": "110-05-12",
    "owner1": "LEUNG, YVONNE C",
    "owner2": "",
    "current_taxes": 7564.29,
    "new_taxes_no_override": 7891.07,
    "override_total_1": 8114.97,
    "override_increase_1": 223.9
  },
  {
    "#": "1856 Beacon St, Unit 3F & P1 (110-05-13)",
    "$": 683900,
    "address": "1856 Beacon St, Unit 3F & P1",
    "parcel_id": "110-05-13",
    "owner1": "LEF TRS, ISAAC & NADIA",
    "owner2": "",
    "current_taxes": 3368.2,
    "new_taxes_no_override": 3513.71,
    "override_total_1": 3613.4,
    "override_increase_1": 99.7
  },
  {
    "#": "1856 Beacon St, Unit 6A & P20 (110-05-14)",
    "$": 763700,
    "address": "1856 Beacon St, Unit 6A & P20",
    "parcel_id": "110-05-14",
    "owner1": "TAN TR, MAY L",
    "owner2": "",
    "current_taxes": 7820.29,
    "new_taxes_no_override": 8158.13,
    "override_total_1": 8389.61,
    "override_increase_1": 231.48
  },
  {
    "#": "1856 Beacon St, Unit 6B & P17 (110-05-15)",
    "$": 697500,
    "address": "1856 Beacon St, Unit 6B & P17",
    "parcel_id": "110-05-15",
    "owner1": "YONG, YIM HON",
    "owner2": "CHI, YIN HA",
    "current_taxes": 3507.47,
    "new_taxes_no_override": 3658.99,
    "override_total_1": 3762.81,
    "override_increase_1": 103.82
  },
  {
    "#": "1856 Beacon St, Unit 6C (110-05-16)",
    "$": 605600,
    "address": "1856 Beacon St, Unit 6C",
    "parcel_id": "110-05-16",
    "owner1": "CHAN, CHI NGAI",
    "owner2": "HUANG, HAN",
    "current_taxes": 2566.41,
    "new_taxes_no_override": 2677.28,
    "override_total_1": 2753.24,
    "override_increase_1": 75.97
  },
  {
    "#": "1856 Beacon St, Unit 6D (110-05-17)",
    "$": 607300,
    "address": "1856 Beacon St, Unit 6D",
    "parcel_id": "110-05-17",
    "owner1": "POVOLOTSKY, ALEXANDER R & INNA",
    "owner2": "",
    "current_taxes": 2583.82,
    "new_taxes_no_override": 2695.44,
    "override_total_1": 2771.92,
    "override_increase_1": 76.48
  },
  {
    "#": "1856 Beacon St, Unit 6E & P11 (110-05-18)",
    "$": 690000,
    "address": "1856 Beacon St, Unit 6E & P11",
    "parcel_id": "110-05-18",
    "owner1": "SHEN, MORGAN",
    "owner2": "WEN, LIDA",
    "current_taxes": 7065.6,
    "new_taxes_no_override": 7370.83,
    "override_total_1": 7579.98,
    "override_increase_1": 209.14
  },
  {
    "#": "1856 Beacon St, Unit 6F & P10 (110-05-19)",
    "$": 791900,
    "address": "1856 Beacon St, Unit 6F & P10",
    "parcel_id": "110-05-19",
    "owner1": "SWEI, ALIYA EMIRA",
    "owner2": "BARRON, KATHLEEN",
    "current_taxes": 4474.12,
    "new_taxes_no_override": 4667.4,
    "override_total_1": 4799.84,
    "override_increase_1": 132.43
  },
  {
    "#": "1856 Beacon St, Unit P6 (110-05-27)",
    "$": 49000,
    "address": "1856 Beacon St, Unit P6",
    "parcel_id": "110-05-27",
    "owner1": "KUNG, JANICE",
    "owner2": "",
    "current_taxes": 501.76,
    "new_taxes_no_override": 523.44,
    "override_total_1": 538.29,
    "override_increase_1": 14.85
  },
  {
    "#": "1856 Beacon St, Unit Pha & G15 (110-05-20)",
    "$": 780400,
    "address": "1856 Beacon St, Unit Pha & G15",
    "parcel_id": "110-05-20",
    "owner1": "ZHANG, MINGWAN",
    "owner2": "YANG, XI",
    "current_taxes": 4356.36,
    "new_taxes_no_override": 4544.55,
    "override_total_1": 4673.5,
    "override_increase_1": 128.95
  },
  {
    "#": "1856 Beacon St, Unit Phb (110-05-21)",
    "$": 693600,
    "address": "1856 Beacon St, Unit Phb",
    "parcel_id": "110-05-21",
    "owner1": "PRILUTSKY, BORIS & GERENE LOUISE",
    "owner2": "",
    "current_taxes": 3467.53,
    "new_taxes_no_override": 3617.33,
    "override_total_1": 3719.97,
    "override_increase_1": 102.64
  },
  {
    "#": "1856 Beacon St, Unit Phc&P13 (110-05-22)",
    "$": 773200,
    "address": "1856 Beacon St, Unit Phc&P13",
    "parcel_id": "110-05-22",
    "owner1": "CHEN, YIMING",
    "owner2": "TRUONG, TUAN",
    "current_taxes": 7917.57,
    "new_taxes_no_override": 8259.61,
    "override_total_1": 8493.97,
    "override_increase_1": 234.36
  },
  {
    "#": "1856 Beacon St, Unit Phd & G9 (110-05-23)",
    "$": 747500,
    "address": "1856 Beacon St, Unit Phd & G9",
    "parcel_id": "110-05-23",
    "owner1": "COATES, MICHAEL",
    "owner2": "",
    "current_taxes": 7654.4,
    "new_taxes_no_override": 7985.07,
    "override_total_1": 8211.64,
    "override_increase_1": 226.57
  },
  {
    "#": "1856 Beacon St, Unit Phe & G7 (110-05-24)",
    "$": 725100,
    "address": "1856 Beacon St, Unit Phe & G7",
    "parcel_id": "110-05-24",
    "owner1": "COOPER, YURI",
    "owner2": "",
    "current_taxes": 3790.09,
    "new_taxes_no_override": 3953.82,
    "override_total_1": 4066.01,
    "override_increase_1": 112.19
  },
  {
    "#": "1856 Beacon St, Unit Phf & P21 (110-05-25)",
    "$": 814400,
    "address": "1856 Beacon St, Unit Phf & P21",
    "parcel_id": "110-05-25",
    "owner1": "NG, CHUN Y & DEBORAH L",
    "owner2": "",
    "current_taxes": 8339.46,
    "new_taxes_no_override": 8699.72,
    "override_total_1": 8946.57,
    "override_increase_1": 246.85
  },
  {
    "#": "1856 Beacon St, Unit Ter & G14 (110-05-01)",
    "$": 850300,
    "address": "1856 Beacon St, Unit Ter & G14",
    "parcel_id": "110-05-01",
    "owner1": "RICKLAN, SARAH",
    "owner2": "SALINGER, ELLIOT",
    "current_taxes": 5072.14,
    "new_taxes_no_override": 5291.26,
    "override_total_1": 5441.39,
    "override_increase_1": 150.14
  },
  {
    "#": "1857 Beacon St, Unit 1 (235-20-02)",
    "$": 1038400,
    "address": "1857 Beacon St, Unit 1",
    "parcel_id": "235-20-02",
    "owner1": "GILBERT, MICHAEL BRADLEY",
    "owner2": "",
    "current_taxes": 6998.28,
    "new_taxes_no_override": 7300.61,
    "override_total_1": 7507.75,
    "override_increase_1": 207.15
  },
  {
    "#": "1857 Beacon St, Unit 2 (235-20-03)",
    "$": 1157200,
    "address": "1857 Beacon St, Unit 2",
    "parcel_id": "235-20-03",
    "owner1": "COHEN, LOUISE G",
    "owner2": "",
    "current_taxes": 8214.79,
    "new_taxes_no_override": 8569.67,
    "override_total_1": 8812.83,
    "override_increase_1": 243.16
  },
  {
    "#": "1857 Beacon St, Unit 3 & P1-2 (235-20-04)",
    "$": 1154100,
    "address": "1857 Beacon St, Unit 3 & P1-2",
    "parcel_id": "235-20-04",
    "owner1": "JANDOVA, IVA",
    "owner2": "",
    "current_taxes": 11817.98,
    "new_taxes_no_override": 12328.52,
    "override_total_1": 12678.33,
    "override_increase_1": 349.81
  },
  {
    "#": "1857 Beacon St, Unit G (235-20-01)",
    "$": 839100,
    "address": "1857 Beacon St, Unit G",
    "parcel_id": "235-20-01",
    "owner1": "1857 BEACON G REALTY LLC",
    "owner2": "",
    "current_taxes": 8592.38,
    "new_taxes_no_override": 8963.57,
    "override_total_1": 9217.91,
    "override_increase_1": 254.33
  },
  {
    "#": "1859 Beacon St (235-19-00)",
    "$": 2442300,
    "address": "1859 Beacon St",
    "parcel_id": "235-19-00",
    "owner1": "NG, HENRY H  & ANNA C",
    "owner2": "HON YEE & NANCY",
    "current_taxes": 21374.22,
    "new_taxes_no_override": 22297.59,
    "override_total_1": 22930.26,
    "override_increase_1": 632.68
  },
  {
    "#": "1861 Beacon St, Unit 1 & G5 P2 (235-18-02)",
    "$": 1251000,
    "address": "1861 Beacon St, Unit 1 & G5 P2",
    "parcel_id": "235-18-02",
    "owner1": "SILBERMAN, BRIAN C",
    "owner2": "METOUDI, LEAH A",
    "current_taxes": 12810.24,
    "new_taxes_no_override": 13363.64,
    "override_total_1": 13742.83,
    "override_increase_1": 379.18
  },
  {
    "#": "1861 Beacon St, Unit 2 & P4 G6 (235-18-03)",
    "$": 1393200,
    "address": "1861 Beacon St, Unit 2 & P4 G6",
    "parcel_id": "235-18-03",
    "owner1": "VIKTOROV, VICTOR & CARA",
    "owner2": "",
    "current_taxes": 14266.37,
    "new_taxes_no_override": 14882.68,
    "override_total_1": 15304.96,
    "override_increase_1": 422.28
  },
  {
    "#": "1861 Beacon St, Unit 3 & G6 P3 (235-18-04)",
    "$": 1396400,
    "address": "1861 Beacon St, Unit 3 & G6 P3",
    "parcel_id": "235-18-04",
    "owner1": "SOORENKO TRS, PETER & FELICE",
    "owner2": "",
    "current_taxes": 10664.2,
    "new_taxes_no_override": 11124.89,
    "override_total_1": 11440.55,
    "override_increase_1": 315.66
  },
  {
    "#": "1861 Beacon St, Unit B & P1 (235-18-01)",
    "$": 1084400,
    "address": "1861 Beacon St, Unit B & P1",
    "parcel_id": "235-18-01",
    "owner1": "BRENNAN, KARA B",
    "owner2": "",
    "current_taxes": 11104.26,
    "new_taxes_no_override": 11583.96,
    "override_total_1": 11912.65,
    "override_increase_1": 328.69
  },
  {
    "#": "1862 Beacon St (110-06-07)",
    "$": 15722600,
    "address": "1862 Beacon St",
    "parcel_id": "110-06-07",
    "owner1": "RESERVOIR COURT LP",
    "owner2": "",
    "current_taxes": 160999.42,
    "new_taxes_no_override": 167954.59,
    "override_total_1": 172720.18,
    "override_increase_1": 4765.58
  },
  {
    "#": "1863 Beacon St, Unit 1 (235-17-03)",
    "$": 1048100,
    "address": "1863 Beacon St, Unit 1",
    "parcel_id": "235-17-03",
    "owner1": "CACCIOLA, EUGENE J",
    "owner2": "",
    "current_taxes": 10732.54,
    "new_taxes_no_override": 11196.19,
    "override_total_1": 11513.87,
    "override_increase_1": 317.68
  },
  {
    "#": "1863 Beacon St, Unit 2 (235-17-01)",
    "$": 1195600,
    "address": "1863 Beacon St, Unit 2",
    "parcel_id": "235-17-01",
    "owner1": "CACCIOLA, EUGENE J",
    "owner2": "",
    "current_taxes": 12242.94,
    "new_taxes_no_override": 12771.84,
    "override_total_1": 13134.23,
    "override_increase_1": 362.39
  },
  {
    "#": "1863 Beacon St, Unit 3 (235-17-02)",
    "$": 1322900,
    "address": "1863 Beacon St, Unit 3",
    "parcel_id": "235-17-02",
    "owner1": "STEADMAN, JOHN W & OPHELIA",
    "owner2": "",
    "current_taxes": 13546.5,
    "new_taxes_no_override": 14131.71,
    "override_total_1": 14532.69,
    "override_increase_1": 400.98
  },
  {
    "#": "1865 Beacon St, Unit 1 (235-16-02)",
    "$": 1386000,
    "address": "1865 Beacon St, Unit 1",
    "parcel_id": "235-16-02",
    "owner1": "MURPHY, PATRICK",
    "owner2": "SIMMONS, JOHN",
    "current_taxes": 10557.71,
    "new_taxes_no_override": 11013.8,
    "override_total_1": 11326.31,
    "override_increase_1": 312.51
  },
  {
    "#": "1865 Beacon St, Unit 1A (235-16-01)",
    "$": 734200,
    "address": "1865 Beacon St, Unit 1A",
    "parcel_id": "235-16-01",
    "owner1": "CHARNEY, GREGORY & PAULINA",
    "owner2": "",
    "current_taxes": 7518.21,
    "new_taxes_no_override": 7843.0,
    "override_total_1": 8065.54,
    "override_increase_1": 222.54
  },
  {
    "#": "1865 Beacon St, Unit 2 (235-16-03)",
    "$": 1340400,
    "address": "1865 Beacon St, Unit 2",
    "parcel_id": "235-16-03",
    "owner1": "PAPAKOSTAS, GEORGE I & LORI",
    "owner2": "",
    "current_taxes": 10090.76,
    "new_taxes_no_override": 10526.68,
    "override_total_1": 10825.37,
    "override_increase_1": 298.69
  },
  {
    "#": "1865 Beacon St, Unit 3 (235-16-04)",
    "$": 1262700,
    "address": "1865 Beacon St, Unit 3",
    "parcel_id": "235-16-04",
    "owner1": "LAI, YING-JU",
    "owner2": "SCHIFF, JONATHAN",
    "current_taxes": 12930.05,
    "new_taxes_no_override": 13488.63,
    "override_total_1": 13871.36,
    "override_increase_1": 382.73
  },
  {
    "#": "1867 Beacon St, Unit 1 (235-15-02)",
    "$": 1207900,
    "address": "1867 Beacon St, Unit 1",
    "parcel_id": "235-15-02",
    "owner1": "FRY, JOHN & ANDREA",
    "owner2": "",
    "current_taxes": 8733.96,
    "new_taxes_no_override": 9111.27,
    "override_total_1": 9369.79,
    "override_increase_1": 258.53
  },
  {
    "#": "1867 Beacon St, Unit 1B (235-15-01)",
    "$": 800900,
    "address": "1867 Beacon St, Unit 1B",
    "parcel_id": "235-15-01",
    "owner1": "DISIPIO, ANTHONY & JOSEPH",
    "owner2": "",
    "current_taxes": 8201.22,
    "new_taxes_no_override": 8555.51,
    "override_total_1": 8798.27,
    "override_increase_1": 242.76
  },
  {
    "#": "1867 Beacon St, Unit 2 & P7 (235-15-03)",
    "$": 915000,
    "address": "1867 Beacon St, Unit 2 & P7",
    "parcel_id": "235-15-03",
    "owner1": "LSM MANAGEMENT LLC",
    "owner2": "",
    "current_taxes": 9369.6,
    "new_taxes_no_override": 9774.37,
    "override_total_1": 10051.71,
    "override_increase_1": 277.34
  },
  {
    "#": "1867 Beacon St, Unit 3 & P2 (235-15-04)",
    "$": 546600,
    "address": "1867 Beacon St, Unit 3 & P2",
    "parcel_id": "235-15-04",
    "owner1": "NAGALINGAM, VASUDEVAN & THANUSHA VASUDEVAN",
    "owner2": "",
    "current_taxes": 5597.18,
    "new_taxes_no_override": 5838.98,
    "override_total_1": 6004.65,
    "override_increase_1": 165.68
  },
  {
    "#": "1867 Beacon St, Unit 4 & P4 P8 (235-15-05)",
    "$": 938600,
    "address": "1867 Beacon St, Unit 4 & P4 P8",
    "parcel_id": "235-15-05",
    "owner1": "ROSANSKY TR, JULIE",
    "owner2": "",
    "current_taxes": 9611.26,
    "new_taxes_no_override": 10026.47,
    "override_total_1": 10310.96,
    "override_increase_1": 284.49
  },
  {
    "#": "1867 Beacon St, Unit 5 & P3 (235-15-06)",
    "$": 546600,
    "address": "1867 Beacon St, Unit 5 & P3",
    "parcel_id": "235-15-06",
    "owner1": "LITMANOVICH, DIANA",
    "owner2": "BRANOVER, ALEXANDER",
    "current_taxes": 5597.18,
    "new_taxes_no_override": 5838.98,
    "override_total_1": 6004.65,
    "override_increase_1": 165.68
  },
  {
    "#": "1869 Beacon St, Unit 1 (235-14-01)",
    "$": 1094800,
    "address": "1869 Beacon St, Unit 1",
    "parcel_id": "235-14-01",
    "owner1": "LOBUE TRS, JOHN W & LAURIE J",
    "owner2": "",
    "current_taxes": 7575.82,
    "new_taxes_no_override": 7903.1,
    "override_total_1": 8127.34,
    "override_increase_1": 224.24
  },
  {
    "#": "1869 Beacon St, Unit 2 (235-14-02)",
    "$": 1299200,
    "address": "1869 Beacon St, Unit 2",
    "parcel_id": "235-14-02",
    "owner1": "LEIGHFIELD TR, PATRICIA A",
    "owner2": "",
    "current_taxes": 9668.87,
    "new_taxes_no_override": 10086.57,
    "override_total_1": 10372.76,
    "override_increase_1": 286.2
  },
  {
    "#": "1869 Beacon St, Unit 3 (235-14-03)",
    "$": 1393100,
    "address": "1869 Beacon St, Unit 3",
    "parcel_id": "235-14-03",
    "owner1": "DONICA, CHRISTINE M",
    "owner2": "AMENO, GIUSEPPE",
    "current_taxes": 10630.41,
    "new_taxes_no_override": 11089.64,
    "override_total_1": 11404.3,
    "override_increase_1": 314.66
  },
  {
    "#": "1869 Beacon St, Unit 4 (235-14-04)",
    "$": 1429400,
    "address": "1869 Beacon St, Unit 4",
    "parcel_id": "235-14-04",
    "owner1": "PAUL, ROBERT J & PAULA",
    "owner2": "",
    "current_taxes": 11002.12,
    "new_taxes_no_override": 11477.41,
    "override_total_1": 11803.07,
    "override_increase_1": 325.66
  },
  {
    "#": "1871 Beacon St (235-13-00)",
    "$": 4114800,
    "address": "1871 Beacon St",
    "parcel_id": "235-13-00",
    "owner1": "1871 BEACON LLC",
    "owner2": "",
    "current_taxes": 42135.55,
    "new_taxes_no_override": 43955.81,
    "override_total_1": 45203.02,
    "override_increase_1": 1247.21
  },
  {
    "#": "1874 Beacon St, Unit 1  (110-08-05)",
    "$": 369600,
    "address": "1874 Beacon St, Unit 1 ",
    "parcel_id": "110-08-05",
    "owner1": "GHORBANI, HOSSEIN",
    "owner2": "",
    "current_taxes": 3784.7,
    "new_taxes_no_override": 3948.2,
    "override_total_1": 4060.23,
    "override_increase_1": 112.03
  },
  {
    "#": "1874 Beacon St, Unit 2 (110-08-01)",
    "$": 574700,
    "address": "1874 Beacon St, Unit 2",
    "parcel_id": "110-08-01",
    "owner1": "GORHAM CAPITAL LLC",
    "owner2": "C/O SHAHRYAR SANIEOFF",
    "current_taxes": 5884.93,
    "new_taxes_no_override": 6139.16,
    "override_total_1": 6313.35,
    "override_increase_1": 174.19
  },
  {
    "#": "1874 Beacon St, Unit 3 (110-08-02)",
    "$": 719900,
    "address": "1874 Beacon St, Unit 3",
    "parcel_id": "110-08-02",
    "owner1": "CHAN, BRYAN C & CASSIDY",
    "owner2": "",
    "current_taxes": 7371.78,
    "new_taxes_no_override": 7690.24,
    "override_total_1": 7908.45,
    "override_increase_1": 218.2
  },
  {
    "#": "1874 Beacon St, Unit 4 (110-08-03)",
    "$": 752600,
    "address": "1874 Beacon St, Unit 4",
    "parcel_id": "110-08-03",
    "owner1": "KHAIT TR, IGOR",
    "owner2": "",
    "current_taxes": 4071.69,
    "new_taxes_no_override": 4247.59,
    "override_total_1": 4368.11,
    "override_increase_1": 120.52
  },
  {
    "#": "1874 Beacon St, Unit 5 & P-5 (110-08-04)",
    "$": 579200,
    "address": "1874 Beacon St, Unit 5 & P-5",
    "parcel_id": "110-08-04",
    "owner1": "ROSENSTRAUCH, PAUL L",
    "owner2": "",
    "current_taxes": 2296.07,
    "new_taxes_no_override": 2395.26,
    "override_total_1": 2463.22,
    "override_increase_1": 67.96
  },
  {
    "#": "1876 Beacon St (110-09-00)",
    "$": 793300,
    "address": "1876 Beacon St",
    "parcel_id": "110-09-00",
    "owner1": "CARITAS COMMUNITIES INC",
    "owner2": "",
    "current_taxes": 8123.39,
    "new_taxes_no_override": 8474.32,
    "override_total_1": 8714.77,
    "override_increase_1": 240.45
  },
  {
    "#": "1878 Beacon St (110-10-00)",
    "$": 2550500,
    "address": "1878 Beacon St",
    "parcel_id": "110-10-00",
    "owner1": "CHOW TR, JOHN J",
    "owner2": "",
    "current_taxes": 26117.12,
    "new_taxes_no_override": 27245.38,
    "override_total_1": 28018.45,
    "override_increase_1": 773.07
  },
  {
    "#": "1880 Beacon St, Unit 1 (110-11-08)",
    "$": 331800,
    "address": "1880 Beacon St, Unit 1",
    "parcel_id": "110-11-08",
    "owner1": "YAM ORR SHAKED LLC",
    "owner2": "",
    "current_taxes": 3397.63,
    "new_taxes_no_override": 3544.41,
    "override_total_1": 3644.98,
    "override_increase_1": 100.57
  },
  {
    "#": "1880 Beacon St, Unit 2 (110-11-01)",
    "$": 645500,
    "address": "1880 Beacon St, Unit 2",
    "parcel_id": "110-11-01",
    "owner1": "PAL RE LLC",
    "owner2": "",
    "current_taxes": 6609.92,
    "new_taxes_no_override": 6895.47,
    "override_total_1": 7091.12,
    "override_increase_1": 195.65
  },
  {
    "#": "1880 Beacon St, Unit 3 (110-11-02)",
    "$": 486700,
    "address": "1880 Beacon St, Unit 3",
    "parcel_id": "110-11-02",
    "owner1": "YAM ORR SHAKED LLC",
    "owner2": "",
    "current_taxes": 4983.81,
    "new_taxes_no_override": 5199.11,
    "override_total_1": 5346.63,
    "override_increase_1": 147.52
  },
  {
    "#": "1880 Beacon St, Unit 4 (110-11-03)",
    "$": 624900,
    "address": "1880 Beacon St, Unit 4",
    "parcel_id": "110-11-03",
    "owner1": "LO, WOONGNOR GLORIA",
    "owner2": "",
    "current_taxes": 2764.04,
    "new_taxes_no_override": 2883.45,
    "override_total_1": 2965.26,
    "override_increase_1": 81.82
  },
  {
    "#": "1880 Beacon St, Unit 5 (110-11-04)",
    "$": 461400,
    "address": "1880 Beacon St, Unit 5",
    "parcel_id": "110-11-04",
    "owner1": "MALHOTRA, PRAVEEN K & ROMEE",
    "owner2": "",
    "current_taxes": 4724.74,
    "new_taxes_no_override": 4928.85,
    "override_total_1": 5068.7,
    "override_increase_1": 139.85
  },
  {
    "#": "1880 Beacon St, Unit 6 (110-11-05)",
    "$": 434900,
    "address": "1880 Beacon St, Unit 6",
    "parcel_id": "110-11-05",
    "owner1": "STIFLER LEGACY PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 4453.38,
    "new_taxes_no_override": 4645.77,
    "override_total_1": 4777.59,
    "override_increase_1": 131.82
  },
  {
    "#": "1880 Beacon St, Unit 7 (110-11-06)",
    "$": 599300,
    "address": "1880 Beacon St, Unit 7",
    "parcel_id": "110-11-06",
    "owner1": "BERELOWITZ, CARL D",
    "owner2": "",
    "current_taxes": 2501.9,
    "new_taxes_no_override": 2609.98,
    "override_total_1": 2684.04,
    "override_increase_1": 74.06
  },
  {
    "#": "1880 Beacon St, Unit 8 (110-11-07)",
    "$": 524700,
    "address": "1880 Beacon St, Unit 8",
    "parcel_id": "110-11-07",
    "owner1": "BRENS, IVAN A & CORINNE A",
    "owner2": "",
    "current_taxes": 1737.99,
    "new_taxes_no_override": 1813.07,
    "override_total_1": 1864.52,
    "override_increase_1": 51.44
  },
  {
    "#": "1887 Beacon St, Unit 1 (237-04-04)",
    "$": 970800,
    "address": "1887 Beacon St, Unit 1",
    "parcel_id": "237-04-04",
    "owner1": "CHAN TRS, DEBBIE B H & TING YIN",
    "owner2": "",
    "current_taxes": 9940.99,
    "new_taxes_no_override": 10370.44,
    "override_total_1": 10664.69,
    "override_increase_1": 294.25
  },
  {
    "#": "1887 Beacon St, Unit 2 (237-04-01)",
    "$": 1019400,
    "address": "1887 Beacon St, Unit 2",
    "parcel_id": "237-04-01",
    "owner1": "BERLOW, MATTHEW",
    "owner2": "YAJIMA, CHIYO",
    "current_taxes": 6803.72,
    "new_taxes_no_override": 7097.64,
    "override_total_1": 7299.03,
    "override_increase_1": 201.39
  },
  {
    "#": "1887 Beacon St, Unit 3 (237-04-02)",
    "$": 1048500,
    "address": "1887 Beacon St, Unit 3",
    "parcel_id": "237-04-02",
    "owner1": "BECCARI, MARTINA",
    "owner2": "GEREIGE, JESSICA",
    "current_taxes": 7101.71,
    "new_taxes_no_override": 7408.5,
    "override_total_1": 7618.71,
    "override_increase_1": 210.21
  },
  {
    "#": "1887 Beacon St, Unit 4 (237-04-03)",
    "$": 489600,
    "address": "1887 Beacon St, Unit 4",
    "parcel_id": "237-04-03",
    "owner1": "CHAN TRS, DEBBIE B H & TING YIN",
    "owner2": "",
    "current_taxes": 5013.5,
    "new_taxes_no_override": 5230.08,
    "override_total_1": 5378.48,
    "override_increase_1": 148.4
  },
  {
    "#": "1888 Beacon St (111-01-00)",
    "$": 2736100,
    "address": "1888 Beacon St",
    "parcel_id": "111-01-00",
    "owner1": "SOO HOO TRS, PETER & SHIRLEY S",
    "owner2": "",
    "current_taxes": 28017.66,
    "new_taxes_no_override": 29228.02,
    "override_total_1": 30057.35,
    "override_increase_1": 829.32
  },
  {
    "#": "1890 Beacon St (111-02-00)",
    "$": 2283100,
    "address": "1890 Beacon St",
    "parcel_id": "111-02-00",
    "owner1": "HALPERN TR, DIANE J",
    "owner2": "",
    "current_taxes": 25428.77,
    "new_taxes_no_override": 26527.29,
    "override_total_1": 27279.98,
    "override_increase_1": 752.69
  },
  {
    "#": "1891 Beacon St, Unit 1 (237-05-03)",
    "$": 1418300,
    "address": "1891 Beacon St, Unit 1",
    "parcel_id": "237-05-03",
    "owner1": "YOOK TR, BYEONGSEO",
    "owner2": "",
    "current_taxes": 14523.39,
    "new_taxes_no_override": 15150.8,
    "override_total_1": 15580.69,
    "override_increase_1": 429.89
  },
  {
    "#": "1891 Beacon St, Unit 2 (237-05-01)",
    "$": 1128700,
    "address": "1891 Beacon St, Unit 2",
    "parcel_id": "237-05-01",
    "owner1": "SARTAKMUK LLC",
    "owner2": "",
    "current_taxes": 11557.89,
    "new_taxes_no_override": 12057.19,
    "override_total_1": 12399.3,
    "override_increase_1": 342.11
  },
  {
    "#": "1891 Beacon St, Unit 3 (237-05-02)",
    "$": 1131900,
    "address": "1891 Beacon St, Unit 3",
    "parcel_id": "237-05-02",
    "owner1": "WADE, PAUL J",
    "owner2": "",
    "current_taxes": 7955.72,
    "new_taxes_no_override": 8299.41,
    "override_total_1": 8534.9,
    "override_increase_1": 235.49
  },
  {
    "#": "1892 Beacon St, Unit 1 (111-03-03)",
    "$": 736000,
    "address": "1892 Beacon St, Unit 1",
    "parcel_id": "111-03-03",
    "owner1": "SKVERSKY TR, PHILIP K",
    "owner2": "",
    "current_taxes": 3901.71,
    "new_taxes_no_override": 4070.26,
    "override_total_1": 4185.75,
    "override_increase_1": 115.49
  },
  {
    "#": "1892 Beacon St, Unit 2 (111-03-01)",
    "$": 769100,
    "address": "1892 Beacon St, Unit 2",
    "parcel_id": "111-03-01",
    "owner1": "PICKER, CHRISTIAN & HELEN",
    "owner2": "",
    "current_taxes": 4240.65,
    "new_taxes_no_override": 4423.85,
    "override_total_1": 4549.37,
    "override_increase_1": 125.52
  },
  {
    "#": "1892 Beacon St, Unit 3 (111-03-02)",
    "$": 925500,
    "address": "1892 Beacon St, Unit 3",
    "parcel_id": "111-03-02",
    "owner1": "EDGERTON, JOHN",
    "owner2": "UPSHAW, HEATHER",
    "current_taxes": 5842.19,
    "new_taxes_no_override": 6094.57,
    "override_total_1": 6267.5,
    "override_increase_1": 172.93
  },
  {
    "#": "1894 Beacon St (111-04-00)",
    "$": 2514300,
    "address": "1894 Beacon St",
    "parcel_id": "111-04-00",
    "owner1": "ZUBER, JOSHUA J",
    "owner2": "",
    "current_taxes": 22111.5,
    "new_taxes_no_override": 23066.72,
    "override_total_1": 23721.22,
    "override_increase_1": 654.5
  },
  {
    "#": "1895 Beacon St, Unit 1 (237-06-04)",
    "$": 1232300,
    "address": "1895 Beacon St, Unit 1",
    "parcel_id": "237-06-04",
    "owner1": "STELIN, IGOR",
    "owner2": "RABINOVICH, DONNA",
    "current_taxes": 8983.82,
    "new_taxes_no_override": 9371.92,
    "override_total_1": 9637.84,
    "override_increase_1": 265.92
  },
  {
    "#": "1895 Beacon St, Unit 2 (237-06-01)",
    "$": 1296900,
    "address": "1895 Beacon St, Unit 2",
    "parcel_id": "237-06-01",
    "owner1": "HICKEY, MARY ELIZABETH",
    "owner2": "KERNER, CHRISTOPHER R",
    "current_taxes": 13280.26,
    "new_taxes_no_override": 13853.97,
    "override_total_1": 14247.06,
    "override_increase_1": 393.1
  },
  {
    "#": "1895 Beacon St, Unit 3 & P3 (237-06-02)",
    "$": 1322100,
    "address": "1895 Beacon St, Unit 3 & P3",
    "parcel_id": "237-06-02",
    "owner1": "BROWN, VICTORIA ELIZABETH",
    "owner2": "TERRACE, THOMAS ORIE JR",
    "current_taxes": 9903.37,
    "new_taxes_no_override": 10331.2,
    "override_total_1": 10624.34,
    "override_increase_1": 293.14
  },
  {
    "#": "1895 Beacon St, Unit 4 (237-06-03)",
    "$": 661300,
    "address": "1895 Beacon St, Unit 4",
    "parcel_id": "237-06-03",
    "owner1": "NG, CHUN",
    "owner2": "LEONG, DEBORAH W",
    "current_taxes": 6771.71,
    "new_taxes_no_override": 7064.25,
    "override_total_1": 7264.69,
    "override_increase_1": 200.44
  },
  {
    "#": "1896 Beacon St, Unit 1 (111-05-03)",
    "$": 1038000,
    "address": "1896 Beacon St, Unit 1",
    "parcel_id": "111-05-03",
    "owner1": "MIZER, KELLY CLIFFORD & LEONA LYNN",
    "owner2": "",
    "current_taxes": 6994.19,
    "new_taxes_no_override": 7296.34,
    "override_total_1": 7503.37,
    "override_increase_1": 207.03
  },
  {
    "#": "1896 Beacon St, Unit 2 (111-05-01)",
    "$": 859100,
    "address": "1896 Beacon St, Unit 2",
    "parcel_id": "111-05-01",
    "owner1": "SADOVNIKOV, LEONID",
    "owner2": "",
    "current_taxes": 5162.25,
    "new_taxes_no_override": 5385.26,
    "override_total_1": 5538.06,
    "override_increase_1": 152.8
  },
  {
    "#": "1896 Beacon St, Unit 3 (111-05-02)",
    "$": 884500,
    "address": "1896 Beacon St, Unit 3",
    "parcel_id": "111-05-02",
    "owner1": "JONES, PATRICK & ELISE",
    "owner2": "",
    "current_taxes": 5422.35,
    "new_taxes_no_override": 5656.6,
    "override_total_1": 5817.1,
    "override_increase_1": 160.5
  },
  {
    "#": "1897 Beacon St (237-07-00)",
    "$": 3474200,
    "address": "1897 Beacon St",
    "parcel_id": "237-07-00",
    "owner1": "LOONAT PROPERTIES INC",
    "owner2": "",
    "current_taxes": 35575.81,
    "new_taxes_no_override": 37112.68,
    "override_total_1": 38165.73,
    "override_increase_1": 1053.04
  },
  {
    "#": "1898 Beacon St, Unit 1 & P1 (111-06-01)",
    "$": 404300,
    "address": "1898 Beacon St, Unit 1 & P1",
    "parcel_id": "111-06-01",
    "owner1": "TAM, WAIYIN",
    "owner2": "KONG, LINJIU",
    "current_taxes": 505.1,
    "new_taxes_no_override": 526.92,
    "override_total_1": 541.87,
    "override_increase_1": 14.95
  },
  {
    "#": "1898 Beacon St, Unit 2 & Prk 2 (111-06-02)",
    "$": 460600,
    "address": "1898 Beacon St, Unit 2 & Prk 2",
    "parcel_id": "111-06-02",
    "owner1": "XIE, XING JUAN",
    "owner2": "CHEN, WILLIAM WAIKUEN",
    "current_taxes": 1081.61,
    "new_taxes_no_override": 1128.34,
    "override_total_1": 1160.35,
    "override_increase_1": 32.02
  },
  {
    "#": "1898 Beacon St, Unit 3 & P3 (111-06-03)",
    "$": 1036500,
    "address": "1898 Beacon St, Unit 3 & P3",
    "parcel_id": "111-06-03",
    "owner1": "WOO, MICHELLE C & CINDY G",
    "owner2": "",
    "current_taxes": 10613.76,
    "new_taxes_no_override": 11072.27,
    "override_total_1": 11386.44,
    "override_increase_1": 314.17
  },
  {
    "#": "1898 Beacon St, Unit 4 & Prk 4 (111-06-04)",
    "$": 1055900,
    "address": "1898 Beacon St, Unit 4 & Prk 4",
    "parcel_id": "111-06-04",
    "owner1": "BARON TR, JENNIFER",
    "owner2": "",
    "current_taxes": 7177.48,
    "new_taxes_no_override": 7487.55,
    "override_total_1": 7700.0,
    "override_increase_1": 212.45
  },
  {
    "#": "1898 Beacon St, Unit 5 (111-06-05)",
    "$": 1088000,
    "address": "1898 Beacon St, Unit 5",
    "parcel_id": "111-06-05",
    "owner1": "GEBAUER, ARMIN S",
    "owner2": "CHUNG, KELLY S",
    "current_taxes": 7506.19,
    "new_taxes_no_override": 7830.46,
    "override_total_1": 8052.64,
    "override_increase_1": 222.18
  },
  {
    "#": "1900 Beacon St, Unit 1 (111-07-03)",
    "$": 1041500,
    "address": "1900 Beacon St, Unit 1",
    "parcel_id": "111-07-03",
    "owner1": "SHOWALTER, LARRY P & LOIS A",
    "owner2": "",
    "current_taxes": 7030.03,
    "new_taxes_no_override": 7333.73,
    "override_total_1": 7541.82,
    "override_increase_1": 208.09
  },
  {
    "#": "1900 Beacon St, Unit 2 (111-07-01)",
    "$": 1073900,
    "address": "1900 Beacon St, Unit 2",
    "parcel_id": "111-07-01",
    "owner1": "CHOW, KAREN K",
    "owner2": "",
    "current_taxes": 7361.8,
    "new_taxes_no_override": 7679.83,
    "override_total_1": 7897.74,
    "override_increase_1": 217.91
  },
  {
    "#": "1900 Beacon St, Unit 3 & P2 P3 (111-07-02)",
    "$": 1086500,
    "address": "1900 Beacon St, Unit 3 & P2 P3",
    "parcel_id": "111-07-02",
    "owner1": "GURVICH, NADIA",
    "owner2": "",
    "current_taxes": 7490.83,
    "new_taxes_no_override": 7814.43,
    "override_total_1": 8036.16,
    "override_increase_1": 221.73
  },
  {
    "#": "1901 Beacon St (237-08-00)",
    "$": 3398800,
    "address": "1901 Beacon St",
    "parcel_id": "237-08-00",
    "owner1": "BORIS-BERKOWITZ FAMILY LIMITED PARTNERSHIP",
    "owner2": "",
    "current_taxes": 34803.71,
    "new_taxes_no_override": 36307.23,
    "override_total_1": 37337.42,
    "override_increase_1": 1030.19
  },
  {
    "#": "1902 Beacon St, Unit 1 (111-08-01)",
    "$": 910500,
    "address": "1902 Beacon St, Unit 1",
    "parcel_id": "111-08-01",
    "owner1": "TAM, MELISSA W S",
    "owner2": "C/O YU MELISSA W S",
    "current_taxes": 5688.59,
    "new_taxes_no_override": 5934.34,
    "override_total_1": 6102.72,
    "override_increase_1": 168.38
  },
  {
    "#": "1902 Beacon St, Unit 2 (111-08-02)",
    "$": 914400,
    "address": "1902 Beacon St, Unit 2",
    "parcel_id": "111-08-02",
    "owner1": "YU, JIMMY K & KEN K",
    "owner2": "",
    "current_taxes": 5728.52,
    "new_taxes_no_override": 5975.99,
    "override_total_1": 6145.56,
    "override_increase_1": 169.56
  },
  {
    "#": "1902 Beacon St, Unit 3 (111-08-03)",
    "$": 945400,
    "address": "1902 Beacon St, Unit 3",
    "parcel_id": "111-08-03",
    "owner1": "YU, JIMMY K",
    "owner2": "TAM, MELISSA W S",
    "current_taxes": 9680.9,
    "new_taxes_no_override": 10099.11,
    "override_total_1": 10385.67,
    "override_increase_1": 286.55
  },
  {
    "#": "1904 Beacon St (111-09-00)",
    "$": 3269300,
    "address": "1904 Beacon St",
    "parcel_id": "111-09-00",
    "owner1": "TROVATO TR, MARJORIE",
    "owner2": "",
    "current_taxes": 29842.7,
    "new_taxes_no_override": 31131.9,
    "override_total_1": 32015.25,
    "override_increase_1": 883.34
  },
  {
    "#": "1905 Beacon St (237-09-00)",
    "$": 3165800,
    "address": "1905 Beacon St",
    "parcel_id": "237-09-00",
    "owner1": "SANIEOFF, KHOSRO",
    "owner2": "",
    "current_taxes": 32417.79,
    "new_taxes_no_override": 33818.24,
    "override_total_1": 34777.81,
    "override_increase_1": 959.57
  },
  {
    "#": "1906 Beacon St (111-10-00)",
    "$": 3560900,
    "address": "1906 Beacon St",
    "parcel_id": "111-10-00",
    "owner1": "1906 BEACON STREET LLC",
    "owner2": "",
    "current_taxes": 36463.62,
    "new_taxes_no_override": 38038.85,
    "override_total_1": 39118.17,
    "override_increase_1": 1079.32
  },
  {
    "#": "1908 Beacon St (111-11-00)",
    "$": 3171400,
    "address": "1908 Beacon St",
    "parcel_id": "111-11-00",
    "owner1": "DRAY, TRS, ISSAC & JOANNE S",
    "owner2": "",
    "current_taxes": 39449.25,
    "new_taxes_no_override": 41153.46,
    "override_total_1": 42321.16,
    "override_increase_1": 1167.7
  },
  {
    "#": "1909 Beacon St (237-10-00)",
    "$": 3021400,
    "address": "1909 Beacon St",
    "parcel_id": "237-10-00",
    "owner1": "IRVING, PEARL R",
    "owner2": "LEVIN, MAYNARD TS",
    "current_taxes": 30939.14,
    "new_taxes_no_override": 32275.71,
    "override_total_1": 33191.51,
    "override_increase_1": 915.8
  },
  {
    "#": "1911 Beacon St (237-11-00)",
    "$": 3038200,
    "address": "1911 Beacon St",
    "parcel_id": "237-11-00",
    "owner1": "DRISCOLL, WILLIAM G",
    "owner2": "",
    "current_taxes": 31111.17,
    "new_taxes_no_override": 32455.17,
    "override_total_1": 33376.06,
    "override_increase_1": 920.89
  },
  {
    "#": "1915 Beacon St, Unit 1 & P4 (237-12-11)",
    "$": 547900,
    "address": "1915 Beacon St, Unit 1 & P4",
    "parcel_id": "237-12-11",
    "owner1": "MCCARTY, WILLIAM & LISA",
    "owner2": "",
    "current_taxes": 5610.5,
    "new_taxes_no_override": 5852.87,
    "override_total_1": 6018.94,
    "override_increase_1": 166.07
  },
  {
    "#": "1915 Beacon St, Unit 10 & P5 (237-12-17)",
    "$": 501000,
    "address": "1915 Beacon St, Unit 10 & P5",
    "parcel_id": "237-12-17",
    "owner1": "JACKEL, ERICH M",
    "owner2": "",
    "current_taxes": 5130.24,
    "new_taxes_no_override": 5351.87,
    "override_total_1": 5503.72,
    "override_increase_1": 151.86
  },
  {
    "#": "1915 Beacon St, Unit 1A & P1 (237-12-18)",
    "$": 462900,
    "address": "1915 Beacon St, Unit 1A & P1",
    "parcel_id": "237-12-18",
    "owner1": "ROSENBERG, SHARON R",
    "owner2": "",
    "current_taxes": 1105.16,
    "new_taxes_no_override": 1152.9,
    "override_total_1": 1185.62,
    "override_increase_1": 32.71
  },
  {
    "#": "1915 Beacon St, Unit 2 & 3 & P7 (237-12-12)",
    "$": 669900,
    "address": "1915 Beacon St, Unit 2 & 3 & P7",
    "parcel_id": "237-12-12",
    "owner1": "COLLYMORE-PHILLIPS, SHERLA",
    "owner2": "",
    "current_taxes": 3224.84,
    "new_taxes_no_override": 3364.15,
    "override_total_1": 3459.61,
    "override_increase_1": 95.46
  },
  {
    "#": "1915 Beacon St, Unit 4 (237-12-13)",
    "$": 661300,
    "address": "1915 Beacon St, Unit 4",
    "parcel_id": "237-12-13",
    "owner1": "MAGID, MARINA",
    "owner2": "BEZVERKHNY, BORIS S",
    "current_taxes": 6771.71,
    "new_taxes_no_override": 7064.25,
    "override_total_1": 7264.69,
    "override_increase_1": 200.44
  },
  {
    "#": "1915 Beacon St, Unit 5 & 6 (237-12-14)",
    "$": 678600,
    "address": "1915 Beacon St, Unit 5 & 6",
    "parcel_id": "237-12-14",
    "owner1": "PERRY TR, CYNTHIA G",
    "owner2": "",
    "current_taxes": 6948.86,
    "new_taxes_no_override": 7249.05,
    "override_total_1": 7454.74,
    "override_increase_1": 205.69
  },
  {
    "#": "1915 Beacon St, Unit 7 & P7 (237-12-15)",
    "$": 599100,
    "address": "1915 Beacon St, Unit 7 & P7",
    "parcel_id": "237-12-15",
    "owner1": "ROCHA, JENNIFER",
    "owner2": "",
    "current_taxes": 6134.78,
    "new_taxes_no_override": 6399.8,
    "override_total_1": 6581.39,
    "override_increase_1": 181.59
  },
  {
    "#": "1915 Beacon St, Unit 8 9 Pk 2 (237-12-16)",
    "$": 678600,
    "address": "1915 Beacon St, Unit 8 9 Pk 2",
    "parcel_id": "237-12-16",
    "owner1": "CHENG, ASHLEY",
    "owner2": "LEUNG, RAYMOND C",
    "current_taxes": 3313.93,
    "new_taxes_no_override": 3457.09,
    "override_total_1": 3555.18,
    "override_increase_1": 98.09
  },
  {
    "#": " Beacon St (101-29-00)",
    "$": 2000000,
    "address": " Beacon St",
    "parcel_id": "101-29-00",
    "owner1": "SEAGLASS ASSOCIATES LLP",
    "owner2": "C/O SALTER & KAHN INC",
    "current_taxes": 34320.0,
    "new_taxes_no_override": 35802.62,
    "override_total_1": 36818.5,
    "override_increase_1": 1015.87
  },
  {
    "#": " Beacon St (124-07-01)",
    "$": 424600,
    "address": " Beacon St",
    "parcel_id": "124-07-01",
    "owner1": "HAMPTON COURT REALTY LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 4347.9,
    "new_taxes_no_override": 4535.73,
    "override_total_1": 4664.43,
    "override_increase_1": 128.7
  },
  {
    "#": " Beacon St (214-71-08)",
    "$": 356200,
    "address": " Beacon St",
    "parcel_id": "214-71-08",
    "owner1": "BEACON PROPERTY REALTY LLC",
    "owner2": "",
    "current_taxes": 3647.49,
    "new_taxes_no_override": 3805.06,
    "override_total_1": 3913.03,
    "override_increase_1": 107.97
  },
  {
    "#": "4 Beaconsfield Rd (228-14-01)",
    "$": 482100,
    "address": "4 Beaconsfield Rd",
    "parcel_id": "228-14-01",
    "owner1": "COTTLE, THOMAS J & KAY",
    "owner2": "",
    "current_taxes": 4936.7,
    "new_taxes_no_override": 5149.97,
    "override_total_1": 5296.09,
    "override_increase_1": 146.13
  },
  {
    "#": "12 Beaconsfield Rd (228-14-00)",
    "$": 2328700,
    "address": "12 Beaconsfield Rd",
    "parcel_id": "228-14-00",
    "owner1": "COTTLE, THOMAS J & KAY",
    "owner2": "",
    "current_taxes": 20210.95,
    "new_taxes_no_override": 21084.06,
    "override_total_1": 21682.31,
    "override_increase_1": 598.24
  },
  {
    "#": "14 Beaconsfield Rd (228-13-00)",
    "$": 1429900,
    "address": "14 Beaconsfield Rd",
    "parcel_id": "228-13-00",
    "owner1": "COTTLE, THOMAS J & KAY",
    "owner2": "",
    "current_taxes": 14642.18,
    "new_taxes_no_override": 15274.72,
    "override_total_1": 15708.13,
    "override_increase_1": 433.41
  },
  {
    "#": "15 Beaconsfield Rd (227-15-00)",
    "$": 1961500,
    "address": "15 Beaconsfield Rd",
    "parcel_id": "227-15-00",
    "owner1": "SHORE, BEVERLY",
    "owner2": "",
    "current_taxes": 16450.83,
    "new_taxes_no_override": 17161.51,
    "override_total_1": 17648.45,
    "override_increase_1": 486.94
  },
  {
    "#": "18 Beaconsfield Rd (228-12-01)",
    "$": 1243000,
    "address": "18 Beaconsfield Rd",
    "parcel_id": "228-12-01",
    "owner1": "COTTLE , THOMAS J & KAY",
    "owner2": "",
    "current_taxes": 12728.32,
    "new_taxes_no_override": 13278.18,
    "override_total_1": 13654.94,
    "override_increase_1": 376.76
  },
  {
    "#": "24 Beaconsfield Rd, Unit 1 (228-11-01)",
    "$": 1784800,
    "address": "24 Beaconsfield Rd, Unit 1",
    "parcel_id": "228-11-01",
    "owner1": "WONG, AMY W",
    "owner2": "MEDOLO, JOSEPH E",
    "current_taxes": 18276.35,
    "new_taxes_no_override": 19065.89,
    "override_total_1": 19606.87,
    "override_increase_1": 540.98
  },
  {
    "#": "25 Beaconsfield Rd (227-16-00)",
    "$": 2736500,
    "address": "25 Beaconsfield Rd",
    "parcel_id": "227-16-00",
    "owner1": "CHURCHILL, CHARLES E & MYRIEME",
    "owner2": "",
    "current_taxes": 24386.83,
    "new_taxes_no_override": 25440.34,
    "override_total_1": 26162.19,
    "override_increase_1": 721.85
  },
  {
    "#": "26 Beaconsfield Rd, Unit 2 (228-11-02)",
    "$": 1747900,
    "address": "26 Beaconsfield Rd, Unit 2",
    "parcel_id": "228-11-02",
    "owner1": "LEVI, ANDREW",
    "owner2": "KHON, ORLY",
    "current_taxes": 14263.56,
    "new_taxes_no_override": 14879.75,
    "override_total_1": 15301.95,
    "override_increase_1": 422.2
  },
  {
    "#": "28 Beaconsfield Rd (228-10-00)",
    "$": 1770200,
    "address": "28 Beaconsfield Rd",
    "parcel_id": "228-10-00",
    "owner1": "SPUNT, NATHAN & EMILY",
    "owner2": "",
    "current_taxes": 18126.85,
    "new_taxes_no_override": 18909.93,
    "override_total_1": 19446.48,
    "override_increase_1": 536.55
  },
  {
    "#": "31 Beaconsfield Rd (227-17-00)",
    "$": 2069600,
    "address": "31 Beaconsfield Rd",
    "parcel_id": "227-17-00",
    "owner1": "REDDY, PRAKASH & SAILAJA",
    "owner2": "",
    "current_taxes": 21192.7,
    "new_taxes_no_override": 22108.22,
    "override_total_1": 22735.53,
    "override_increase_1": 627.3
  },
  {
    "#": "34 Beaconsfield Rd (228-09-00)",
    "$": 1766100,
    "address": "34 Beaconsfield Rd",
    "parcel_id": "228-09-00",
    "owner1": "SPUNT, NATHAN & EMILY F",
    "owner2": "",
    "current_taxes": 18084.86,
    "new_taxes_no_override": 18866.13,
    "override_total_1": 19401.44,
    "override_increase_1": 535.31
  },
  {
    "#": "37 Beaconsfield Rd, Unit 37 (227-18-01)",
    "$": 1205000,
    "address": "37 Beaconsfield Rd, Unit 37",
    "parcel_id": "227-18-01",
    "owner1": "EMAS LLC",
    "owner2": "",
    "current_taxes": 12339.2,
    "new_taxes_no_override": 12872.25,
    "override_total_1": 13237.49,
    "override_increase_1": 365.24
  },
  {
    "#": "37 Beaconsfield Rd, Unit 39 (227-18-02)",
    "$": 1772500,
    "address": "37 Beaconsfield Rd, Unit 39",
    "parcel_id": "227-18-02",
    "owner1": "WHALEN, STEPHEN M & ELISABETH J",
    "owner2": "",
    "current_taxes": 18150.4,
    "new_taxes_no_override": 18934.5,
    "override_total_1": 19471.75,
    "override_increase_1": 537.25
  },
  {
    "#": "40 Beaconsfield Rd, Unit 40 (228-08-01)",
    "$": 1315600,
    "address": "40 Beaconsfield Rd, Unit 40",
    "parcel_id": "228-08-01",
    "owner1": "SPUNT, NATHAN & EMILY",
    "owner2": "",
    "current_taxes": 13471.74,
    "new_taxes_no_override": 14053.72,
    "override_total_1": 14452.48,
    "override_increase_1": 398.76
  },
  {
    "#": "40 Beaconsfield Rd, Unit 42 (228-08-02)",
    "$": 947200,
    "address": "40 Beaconsfield Rd, Unit 42",
    "parcel_id": "228-08-02",
    "owner1": "WU, LI",
    "owner2": "TRENCHER, MICHAEL G",
    "current_taxes": 6064.39,
    "new_taxes_no_override": 6326.37,
    "override_total_1": 6505.88,
    "override_increase_1": 179.51
  },
  {
    "#": "43 Beaconsfield Rd, Unit 43 (227-19-01)",
    "$": 878500,
    "address": "43 Beaconsfield Rd, Unit 43",
    "parcel_id": "227-19-01",
    "owner1": "ROTELLA, CARLO",
    "owner2": "KLEIN, CHRISTINA",
    "current_taxes": 8995.84,
    "new_taxes_no_override": 9384.46,
    "override_total_1": 9650.74,
    "override_increase_1": 266.28
  },
  {
    "#": "45 Beaconsfield Rd, Unit 45 (227-19-02)",
    "$": 975500,
    "address": "45 Beaconsfield Rd, Unit 45",
    "parcel_id": "227-19-02",
    "owner1": "BRODSKY, DINA",
    "owner2": "",
    "current_taxes": 9989.12,
    "new_taxes_no_override": 10420.65,
    "override_total_1": 10716.33,
    "override_increase_1": 295.68
  },
  {
    "#": "46 Beaconsfield Rd, Unit 1 (228-07-01)",
    "$": 838600,
    "address": "46 Beaconsfield Rd, Unit 1",
    "parcel_id": "228-07-01",
    "owner1": "LOWE, ROSALINE",
    "owner2": "",
    "current_taxes": 4952.33,
    "new_taxes_no_override": 5166.27,
    "override_total_1": 5312.86,
    "override_increase_1": 146.59
  },
  {
    "#": "46 Beaconsfield Rd, Unit 2 (228-07-02)",
    "$": 856800,
    "address": "46 Beaconsfield Rd, Unit 2",
    "parcel_id": "228-07-02",
    "owner1": "CHAVEZ, GUSTAVO",
    "owner2": "",
    "current_taxes": 5138.7,
    "new_taxes_no_override": 5360.69,
    "override_total_1": 5512.8,
    "override_increase_1": 152.11
  },
  {
    "#": "51 Beaconsfield Rd, Unit 1 (227-20-01)",
    "$": 962600,
    "address": "51 Beaconsfield Rd, Unit 1",
    "parcel_id": "227-20-01",
    "owner1": "KLEIN, CHRISTINA",
    "owner2": "ROTELLA, CARLO",
    "current_taxes": 6222.09,
    "new_taxes_no_override": 6490.88,
    "override_total_1": 6675.06,
    "override_increase_1": 184.17
  },
  {
    "#": "51 Beaconsfield Rd, Unit 2 (227-20-02)",
    "$": 1393100,
    "address": "51 Beaconsfield Rd, Unit 2",
    "parcel_id": "227-20-02",
    "owner1": "KLEIN, CHRISTINA",
    "owner2": "ROTELLA, CARLO",
    "current_taxes": 14265.34,
    "new_taxes_no_override": 14881.6,
    "override_total_1": 15303.86,
    "override_increase_1": 422.25
  },
  {
    "#": "52 Beaconsfield Rd, Unit 52 (228-06-01)",
    "$": 834900,
    "address": "52 Beaconsfield Rd, Unit 52",
    "parcel_id": "228-06-01",
    "owner1": "FABER, ANNE F",
    "owner2": "",
    "current_taxes": 4914.44,
    "new_taxes_no_override": 5126.74,
    "override_total_1": 5272.21,
    "override_increase_1": 145.47
  },
  {
    "#": "54 Beaconsfield Rd, Unit 54 (228-06-02)",
    "$": 1265300,
    "address": "54 Beaconsfield Rd, Unit 54",
    "parcel_id": "228-06-02",
    "owner1": "GROOT, NATALIE & JAMESON",
    "owner2": "",
    "current_taxes": 12956.67,
    "new_taxes_no_override": 13516.4,
    "override_total_1": 13899.92,
    "override_increase_1": 383.52
  },
  {
    "#": "57 Beaconsfield Rd, Unit 57 (227-21-01)",
    "$": 1018800,
    "address": "57 Beaconsfield Rd, Unit 57",
    "parcel_id": "227-21-01",
    "owner1": "BROCKMANN, NATHANIEL & SHARON MOIRA-JANE",
    "owner2": "",
    "current_taxes": 10432.51,
    "new_taxes_no_override": 10883.19,
    "override_total_1": 11192.0,
    "override_increase_1": 308.8
  },
  {
    "#": "58 Beaconsfield Rd (228-05-00)",
    "$": 1544800,
    "address": "58 Beaconsfield Rd",
    "parcel_id": "228-05-00",
    "owner1": "WU, CHIEN-PING & NANCY",
    "owner2": "",
    "current_taxes": 15818.75,
    "new_taxes_no_override": 16502.12,
    "override_total_1": 16970.35,
    "override_increase_1": 468.24
  },
  {
    "#": "59 Beaconsfield Rd, Unit 59 (227-21-02)",
    "$": 1523600,
    "address": "59 Beaconsfield Rd, Unit 59",
    "parcel_id": "227-21-02",
    "owner1": "BROCKMAN, NATHANIEL",
    "owner2": "",
    "current_taxes": 11966.73,
    "new_taxes_no_override": 12483.69,
    "override_total_1": 12837.91,
    "override_increase_1": 354.22
  },
  {
    "#": "62 Beaconsfield Rd, Unit 62-1 & P1 P4 (228-04-01)",
    "$": 1036800,
    "address": "62 Beaconsfield Rd, Unit 62-1 & P1 P4",
    "parcel_id": "228-04-01",
    "owner1": "GROVER, SANDEEP C & PRITI",
    "owner2": "",
    "current_taxes": 6981.9,
    "new_taxes_no_override": 7283.52,
    "override_total_1": 7490.18,
    "override_increase_1": 206.66
  },
  {
    "#": "62 Beaconsfield Rd, Unit 64-2 P2 P3 (228-04-02)",
    "$": 1082000,
    "address": "62 Beaconsfield Rd, Unit 64-2 P2 P3",
    "parcel_id": "228-04-02",
    "owner1": "DOUGAN, STEPHANIE K & MICHAEL L",
    "owner2": "",
    "current_taxes": 11079.68,
    "new_taxes_no_override": 11558.32,
    "override_total_1": 11886.28,
    "override_increase_1": 327.96
  },
  {
    "#": "63 Beaconsfield Rd, Unit 1 (227-22-01)",
    "$": 871200,
    "address": "63 Beaconsfield Rd, Unit 1",
    "parcel_id": "227-22-01",
    "owner1": "BUSH, MCKENNA & RYAN",
    "owner2": "",
    "current_taxes": 8921.09,
    "new_taxes_no_override": 9306.48,
    "override_total_1": 9570.55,
    "override_increase_1": 264.06
  },
  {
    "#": "63 Beaconsfield Rd, Unit 2 (227-22-02)",
    "$": 1308400,
    "address": "63 Beaconsfield Rd, Unit 2",
    "parcel_id": "227-22-02",
    "owner1": "DAY TR, EMILY FOSTER",
    "owner2": "",
    "current_taxes": 9763.08,
    "new_taxes_no_override": 10184.85,
    "override_total_1": 10473.83,
    "override_increase_1": 288.99
  },
  {
    "#": "69 Beaconsfield Rd (227-23-00)",
    "$": 2026300,
    "address": "69 Beaconsfield Rd",
    "parcel_id": "227-23-00",
    "owner1": "KARLAPUDI, BHANU",
    "owner2": "VATTIKUTI, SRIVANDANA",
    "current_taxes": 20749.31,
    "new_taxes_no_override": 21645.68,
    "override_total_1": 22259.86,
    "override_increase_1": 614.18
  },
  {
    "#": "70 Beaconsfield Rd (228-03-00)",
    "$": 2584000,
    "address": "70 Beaconsfield Rd",
    "parcel_id": "228-03-00",
    "owner1": "SWAMY, CHARU & LAKSHMANA",
    "owner2": "",
    "current_taxes": 22825.23,
    "new_taxes_no_override": 23811.28,
    "override_total_1": 24486.91,
    "override_increase_1": 675.63
  },
  {
    "#": "75 Beaconsfield Rd, Unit 1 & P3-4 (227-24-01)",
    "$": 1835100,
    "address": "75 Beaconsfield Rd, Unit 1 & P3-4",
    "parcel_id": "227-24-01",
    "owner1": "GUPTA, NAMRATA",
    "owner2": "GERVAIS, FRANCOIS",
    "current_taxes": 15156.49,
    "new_taxes_no_override": 15811.25,
    "override_total_1": 16259.88,
    "override_increase_1": 448.63
  },
  {
    "#": "75 Beaconsfield Rd, Unit 2 & P1-2 (227-24-02)",
    "$": 1963500,
    "address": "75 Beaconsfield Rd, Unit 2 & P1-2",
    "parcel_id": "227-24-02",
    "owner1": "MATUSON, RONALD & ROBERTA CHINSKY",
    "owner2": "",
    "current_taxes": 16471.31,
    "new_taxes_no_override": 17182.87,
    "override_total_1": 17670.42,
    "override_increase_1": 487.55
  },
  {
    "#": "76 Beaconsfield Rd (228-02-00)",
    "$": 2305600,
    "address": "76 Beaconsfield Rd",
    "parcel_id": "228-02-00",
    "owner1": "POWELL TR, STEPHEN HAROLD",
    "owner2": "",
    "current_taxes": 19974.41,
    "new_taxes_no_override": 20837.3,
    "override_total_1": 21428.55,
    "override_increase_1": 591.24
  },
  {
    "#": "83 Beaconsfield Rd (227-25-00)",
    "$": 2427900,
    "address": "83 Beaconsfield Rd",
    "parcel_id": "227-25-00",
    "owner1": "CHU, SIU-STEVEN-BARRY",
    "owner2": "",
    "current_taxes": 24861.7,
    "new_taxes_no_override": 25935.73,
    "override_total_1": 26671.63,
    "override_increase_1": 735.91
  },
  {
    "#": "84 Beaconsfield Rd (228-01-02)",
    "$": 2814500,
    "address": "84 Beaconsfield Rd",
    "parcel_id": "228-01-02",
    "owner1": "MISHKIN, DANIEL S & STEPHANIE",
    "owner2": "",
    "current_taxes": 25185.55,
    "new_taxes_no_override": 26273.57,
    "override_total_1": 27019.06,
    "override_increase_1": 745.49
  },
  {
    "#": "86 Beaconsfield Rd (228-01-01)",
    "$": 2873100,
    "address": "86 Beaconsfield Rd",
    "parcel_id": "228-01-01",
    "owner1": "OVIEDO, JAIME A",
    "owner2": "CERDA, SANDRA R",
    "current_taxes": 25785.61,
    "new_taxes_no_override": 26899.55,
    "override_total_1": 27662.8,
    "override_increase_1": 763.25
  },
  {
    "#": "89 Beaconsfield Rd (225-01-01)",
    "$": 3142900,
    "address": "89 Beaconsfield Rd",
    "parcel_id": "225-01-01",
    "owner1": "MARTINEZ, MICHAEL S & ROXANNE E",
    "owner2": "",
    "current_taxes": 28548.36,
    "new_taxes_no_override": 29781.65,
    "override_total_1": 30626.68,
    "override_increase_1": 845.03
  },
  {
    "#": "94 Beaconsfield Rd, Unit 100 (226-10-01)",
    "$": 1790900,
    "address": "94 Beaconsfield Rd, Unit 100",
    "parcel_id": "226-10-01",
    "owner1": "CLAYTON TR, MARLENE B",
    "owner2": "",
    "current_taxes": 30731.84,
    "new_taxes_no_override": 32059.46,
    "override_total_1": 32969.12,
    "override_increase_1": 909.66
  },
  {
    "#": "94 Beaconsfield Rd, Unit 201 & P12 (226-10-02)",
    "$": 628900,
    "address": "94 Beaconsfield Rd, Unit 201 & P12",
    "parcel_id": "226-10-02",
    "owner1": "SHVARTS, VALENTINA",
    "owner2": "",
    "current_taxes": 2805.0,
    "new_taxes_no_override": 2926.18,
    "override_total_1": 3009.2,
    "override_increase_1": 83.03
  },
  {
    "#": "94 Beaconsfield Rd, Unit 202 & P13 (226-10-03)",
    "$": 656000,
    "address": "94 Beaconsfield Rd, Unit 202 & P13",
    "parcel_id": "226-10-03",
    "owner1": "BERKSHIRE INVESTMENTS LLC",
    "owner2": "",
    "current_taxes": 6717.44,
    "new_taxes_no_override": 7007.63,
    "override_total_1": 7206.47,
    "override_increase_1": 198.84
  },
  {
    "#": "94 Beaconsfield Rd, Unit 203 & P14 (226-10-04)",
    "$": 652400,
    "address": "94 Beaconsfield Rd, Unit 203 & P14",
    "parcel_id": "226-10-04",
    "owner1": "ABUKHADRA, HANA KANAAN Y",
    "owner2": "SALEM, ZIAD MK",
    "current_taxes": 6680.58,
    "new_taxes_no_override": 6969.18,
    "override_total_1": 7166.93,
    "override_increase_1": 197.75
  },
  {
    "#": "94 Beaconsfield Rd, Unit 301 & Pk 4 (226-10-05)",
    "$": 650700,
    "address": "94 Beaconsfield Rd, Unit 301 & Pk 4",
    "parcel_id": "226-10-05",
    "owner1": "CHENG, LIYANG S & HANSONG",
    "owner2": "",
    "current_taxes": 3028.23,
    "new_taxes_no_override": 3159.05,
    "override_total_1": 3248.69,
    "override_increase_1": 89.64
  },
  {
    "#": "94 Beaconsfield Rd, Unit 302 & Pk 3 (226-10-06)",
    "$": 687800,
    "address": "94 Beaconsfield Rd, Unit 302 & Pk 3",
    "parcel_id": "226-10-06",
    "owner1": "MERCURY POINT LLC",
    "owner2": "C/O PETER B KANG",
    "current_taxes": 7043.07,
    "new_taxes_no_override": 7347.33,
    "override_total_1": 7555.81,
    "override_increase_1": 208.47
  },
  {
    "#": "94 Beaconsfield Rd, Unit 303 Pk 10 (226-10-07)",
    "$": 687700,
    "address": "94 Beaconsfield Rd, Unit 303 Pk 10",
    "parcel_id": "226-10-07",
    "owner1": "VISWANATHA, RAGHUVIR",
    "owner2": "",
    "current_taxes": 3407.11,
    "new_taxes_no_override": 3554.3,
    "override_total_1": 3655.15,
    "override_increase_1": 100.85
  },
  {
    "#": "100 Beaconsfield Rd (226-09-00)",
    "$": 2433900,
    "address": "100 Beaconsfield Rd",
    "parcel_id": "226-09-00",
    "owner1": "BOSTON EDISON CO",
    "owner2": "C/O NSTAR  PROPERTY TAX DEPT",
    "current_taxes": 41765.72,
    "new_taxes_no_override": 43570.0,
    "override_total_1": 44806.26,
    "override_increase_1": 1236.27
  },
  {
    "#": "101 Beaconsfield Rd, Unit 101 (225-72-04)",
    "$": 994300,
    "address": "101 Beaconsfield Rd, Unit 101",
    "parcel_id": "225-72-04",
    "owner1": "JOHNSON, DONALD E",
    "owner2": "",
    "current_taxes": 6546.7,
    "new_taxes_no_override": 6829.52,
    "override_total_1": 7023.3,
    "override_increase_1": 193.78
  },
  {
    "#": "103 Beaconsfield Rd, Unit 103 (225-72-05)",
    "$": 983700,
    "address": "103 Beaconsfield Rd, Unit 103",
    "parcel_id": "225-72-05",
    "owner1": "TANG, CHIA HSI",
    "owner2": "",
    "current_taxes": 10073.09,
    "new_taxes_no_override": 10508.25,
    "override_total_1": 10806.41,
    "override_increase_1": 298.16
  },
  {
    "#": "105 Beaconsfield Rd, Unit 105 (225-72-06)",
    "$": 1140100,
    "address": "105 Beaconsfield Rd, Unit 105",
    "parcel_id": "225-72-06",
    "owner1": "105 BEACONSFIELD ROAD LLC",
    "owner2": "",
    "current_taxes": 11674.62,
    "new_taxes_no_override": 12178.96,
    "override_total_1": 12524.53,
    "override_increase_1": 345.57
  },
  {
    "#": "107 Beaconsfield Rd, Unit 107 (225-72-07)",
    "$": 1149900,
    "address": "107 Beaconsfield Rd, Unit 107",
    "parcel_id": "225-72-07",
    "owner1": "PEPPER, EDITH S",
    "owner2": "",
    "current_taxes": 8140.04,
    "new_taxes_no_override": 8491.69,
    "override_total_1": 8732.63,
    "override_increase_1": 240.95
  },
  {
    "#": "109 Beaconsfield Rd, Unit 109 (225-72-08)",
    "$": 1173500,
    "address": "109 Beaconsfield Rd, Unit 109",
    "parcel_id": "225-72-08",
    "owner1": "ULYANOVA, NATALIA P",
    "owner2": "SHIPITSIN, MICHAIL V",
    "current_taxes": 12016.64,
    "new_taxes_no_override": 12535.76,
    "override_total_1": 12891.45,
    "override_increase_1": 355.69
  },
  {
    "#": "111 Beaconsfield Rd, Unit 111 (225-72-09)",
    "$": 1166200,
    "address": "111 Beaconsfield Rd, Unit 111",
    "parcel_id": "225-72-09",
    "owner1": "PETLER, MEIR",
    "owner2": "TAMAR, OR-ELL",
    "current_taxes": 8306.95,
    "new_taxes_no_override": 8665.81,
    "override_total_1": 8911.7,
    "override_increase_1": 245.89
  },
  {
    "#": "113 Beaconsfield Rd, Unit 113 (225-72-10)",
    "$": 1345900,
    "address": "113 Beaconsfield Rd, Unit 113",
    "parcel_id": "225-72-10",
    "owner1": "CHEN, XIAO",
    "owner2": "XU, SHENGMEI",
    "current_taxes": 10147.08,
    "new_taxes_no_override": 10585.43,
    "override_total_1": 10885.79,
    "override_increase_1": 300.35
  },
  {
    "#": "115 Beaconsfield Rd, Unit 115 (225-72-11)",
    "$": 1140000,
    "address": "115 Beaconsfield Rd, Unit 115",
    "parcel_id": "225-72-11",
    "owner1": "CHIN, AH LEK & JANICE KUNG",
    "owner2": "",
    "current_taxes": 8038.67,
    "new_taxes_no_override": 8385.94,
    "override_total_1": 8623.89,
    "override_increase_1": 237.94
  },
  {
    "#": "117 Beaconsfield Rd, Unit 117 (225-72-12)",
    "$": 1156500,
    "address": "117 Beaconsfield Rd, Unit 117",
    "parcel_id": "225-72-12",
    "owner1": "GOLDSTEIN, STEVEN D",
    "owner2": "DENG, HUI J",
    "current_taxes": 8207.63,
    "new_taxes_no_override": 8562.2,
    "override_total_1": 8805.15,
    "override_increase_1": 242.95
  },
  {
    "#": "119 Beaconsfield Rd, Unit 119 (225-72-13)",
    "$": 1144600,
    "address": "119 Beaconsfield Rd, Unit 119",
    "parcel_id": "225-72-13",
    "owner1": "ALIZADEH TR, ELIZABETH M",
    "owner2": "",
    "current_taxes": 11720.7,
    "new_taxes_no_override": 12227.03,
    "override_total_1": 12573.97,
    "override_increase_1": 346.93
  },
  {
    "#": "120 Beaconsfield Rd, Unit 1 & G 6A-7 (226-06-01)",
    "$": 1124100,
    "address": "120 Beaconsfield Rd, Unit 1 & G 6A-7",
    "parcel_id": "226-06-01",
    "owner1": "SNIDER TRS, CHARLES R & SHEILA M",
    "owner2": "",
    "current_taxes": 7875.85,
    "new_taxes_no_override": 8216.09,
    "override_total_1": 8449.21,
    "override_increase_1": 233.13
  },
  {
    "#": "120 Beaconsfield Rd, Unit 10 & G27 (226-06-10)",
    "$": 792700,
    "address": "120 Beaconsfield Rd, Unit 10 & G27",
    "parcel_id": "226-06-10",
    "owner1": "GUTMAN, ROSTISLAV",
    "owner2": "",
    "current_taxes": 4482.31,
    "new_taxes_no_override": 4675.95,
    "override_total_1": 4808.62,
    "override_increase_1": 132.68
  },
  {
    "#": "120 Beaconsfield Rd, Unit 11 & G15 (226-06-11)",
    "$": 792700,
    "address": "120 Beaconsfield Rd, Unit 11 & G15",
    "parcel_id": "226-06-11",
    "owner1": "KOVALEV, ALEKSANDER",
    "owner2": "KOVALEVA, ANNA",
    "current_taxes": 4482.31,
    "new_taxes_no_override": 4675.95,
    "override_total_1": 4808.62,
    "override_increase_1": 132.68
  },
  {
    "#": "120 Beaconsfield Rd, Unit 12 & G2 (226-06-12)",
    "$": 812500,
    "address": "120 Beaconsfield Rd, Unit 12 & G2",
    "parcel_id": "226-06-12",
    "owner1": "LEE, KIN K",
    "owner2": "WRIGHT-LEE, BEATRICE L",
    "current_taxes": 4685.07,
    "new_taxes_no_override": 4887.47,
    "override_total_1": 5026.14,
    "override_increase_1": 138.68
  },
  {
    "#": "120 Beaconsfield Rd, Unit 14 & G26 (226-06-13)",
    "$": 792700,
    "address": "120 Beaconsfield Rd, Unit 14 & G26",
    "parcel_id": "226-06-13",
    "owner1": "GRAND, JONATHAN H",
    "owner2": "",
    "current_taxes": 4482.31,
    "new_taxes_no_override": 4675.95,
    "override_total_1": 4808.62,
    "override_increase_1": 132.68
  },
  {
    "#": "120 Beaconsfield Rd, Unit 15 & G12 (226-06-14)",
    "$": 865500,
    "address": "120 Beaconsfield Rd, Unit 15 & G12",
    "parcel_id": "226-06-14",
    "owner1": "GHOSH, NEAL & RACHEL",
    "owner2": "",
    "current_taxes": 5227.79,
    "new_taxes_no_override": 5453.63,
    "override_total_1": 5608.37,
    "override_increase_1": 154.74
  },
  {
    "#": "120 Beaconsfield Rd, Unit 15A & G17 (226-06-15)",
    "$": 918900,
    "address": "120 Beaconsfield Rd, Unit 15A & G17",
    "parcel_id": "226-06-15",
    "owner1": "LEVIN TRS, KLIMENTY & SOFIA",
    "owner2": "LECOCQ, NATALIYA LEVIN",
    "current_taxes": 5774.6,
    "new_taxes_no_override": 6024.06,
    "override_total_1": 6194.99,
    "override_increase_1": 170.93
  },
  {
    "#": "120 Beaconsfield Rd, Unit 16 & G24 (226-06-16)",
    "$": 792700,
    "address": "120 Beaconsfield Rd, Unit 16 & G24",
    "parcel_id": "226-06-16",
    "owner1": "GINZBURG, GARRY & KATIA",
    "owner2": "",
    "current_taxes": 4482.31,
    "new_taxes_no_override": 4675.95,
    "override_total_1": 4808.62,
    "override_increase_1": 132.68
  },
  {
    "#": "120 Beaconsfield Rd, Unit 17 & G14 (226-06-17)",
    "$": 792700,
    "address": "120 Beaconsfield Rd, Unit 17 & G14",
    "parcel_id": "226-06-17",
    "owner1": "BRUCE TR, ALICE R",
    "owner2": "",
    "current_taxes": 4482.31,
    "new_taxes_no_override": 4675.95,
    "override_total_1": 4808.62,
    "override_increase_1": 132.68
  },
  {
    "#": "120 Beaconsfield Rd, Unit 18 & G28 (226-06-18)",
    "$": 897500,
    "address": "120 Beaconsfield Rd, Unit 18 & G28",
    "parcel_id": "226-06-18",
    "owner1": "SVERDLICHENKO TRS, ANDREY GRIGORIEVICH",
    "owner2": "ERSHOVA, OLGA BORISOVNA",
    "current_taxes": 5555.47,
    "new_taxes_no_override": 5795.47,
    "override_total_1": 5959.91,
    "override_increase_1": 164.44
  },
  {
    "#": "120 Beaconsfield Rd, Unit 19 & G23 (226-06-19)",
    "$": 813200,
    "address": "120 Beaconsfield Rd, Unit 19 & G23",
    "parcel_id": "226-06-19",
    "owner1": "GARZON SANCHEZ, DIEGO",
    "owner2": "VALERO MUNOZ, MARIA",
    "current_taxes": 4692.23,
    "new_taxes_no_override": 4894.93,
    "override_total_1": 5033.82,
    "override_increase_1": 138.89
  },
  {
    "#": "120 Beaconsfield Rd, Unit 2 & G20 (226-06-02)",
    "$": 1136100,
    "address": "120 Beaconsfield Rd, Unit 2 & G20",
    "parcel_id": "226-06-02",
    "owner1": "HASEGAWA, KOHEI & KEIKO",
    "owner2": "",
    "current_taxes": 7998.73,
    "new_taxes_no_override": 8344.28,
    "override_total_1": 8581.04,
    "override_increase_1": 236.76
  },
  {
    "#": "120 Beaconsfield Rd, Unit 20 & G10 (226-06-20)",
    "$": 876500,
    "address": "120 Beaconsfield Rd, Unit 20 & G10",
    "parcel_id": "226-06-20",
    "owner1": "KITAZAWA TR, SHUNYA",
    "owner2": "",
    "current_taxes": 8975.36,
    "new_taxes_no_override": 9363.1,
    "override_total_1": 9628.77,
    "override_increase_1": 265.67
  },
  {
    "#": "120 Beaconsfield Rd, Unit 21 & G4 (226-06-21)",
    "$": 792700,
    "address": "120 Beaconsfield Rd, Unit 21 & G4",
    "parcel_id": "226-06-21",
    "owner1": "ASHLEY, LINDA",
    "owner2": "",
    "current_taxes": 4482.31,
    "new_taxes_no_override": 4675.95,
    "override_total_1": 4808.62,
    "override_increase_1": 132.68
  },
  {
    "#": "120 Beaconsfield Rd, Unit 22 & G19 (226-06-22)",
    "$": 877000,
    "address": "120 Beaconsfield Rd, Unit 22 & G19",
    "parcel_id": "226-06-22",
    "owner1": "MCINERNEY, AMY L",
    "owner2": "",
    "current_taxes": 5345.55,
    "new_taxes_no_override": 5576.48,
    "override_total_1": 5734.71,
    "override_increase_1": 158.23
  },
  {
    "#": "120 Beaconsfield Rd, Unit 3 & G3 (226-06-03)",
    "$": 1186600,
    "address": "120 Beaconsfield Rd, Unit 3 & G3",
    "parcel_id": "226-06-03",
    "owner1": "LASDEN TR, DEVRA B",
    "owner2": "",
    "current_taxes": 8515.85,
    "new_taxes_no_override": 8883.73,
    "override_total_1": 9135.8,
    "override_increase_1": 252.07
  },
  {
    "#": "120 Beaconsfield Rd, Unit 4 & G13 (226-06-04)",
    "$": 1344600,
    "address": "120 Beaconsfield Rd, Unit 4 & G13",
    "parcel_id": "226-06-04",
    "owner1": "HOOT, ANDREW E & JOYCE W",
    "owner2": "",
    "current_taxes": 10133.77,
    "new_taxes_no_override": 10571.55,
    "override_total_1": 10871.51,
    "override_increase_1": 299.96
  },
  {
    "#": "120 Beaconsfield Rd, Unit 5 & G21-31 (226-06-05)",
    "$": 1403600,
    "address": "120 Beaconsfield Rd, Unit 5 & G21-31",
    "parcel_id": "226-06-05",
    "owner1": "AHN, JAEHAN",
    "owner2": "YI, ANISE",
    "current_taxes": 14372.86,
    "new_taxes_no_override": 14993.77,
    "override_total_1": 15419.2,
    "override_increase_1": 425.44
  },
  {
    "#": "120 Beaconsfield Rd, Unit 6 & G41-37 (226-06-06)",
    "$": 1094300,
    "address": "120 Beaconsfield Rd, Unit 6 & G41-37",
    "parcel_id": "226-06-06",
    "owner1": "TOVAR, JAIRO ERNESTO RODRIGUEZ",
    "owner2": "",
    "current_taxes": 7570.7,
    "new_taxes_no_override": 7897.75,
    "override_total_1": 8121.85,
    "override_increase_1": 224.09
  },
  {
    "#": "120 Beaconsfield Rd, Unit 7 & G1 (226-06-07)",
    "$": 845400,
    "address": "120 Beaconsfield Rd, Unit 7 & G1",
    "parcel_id": "226-06-07",
    "owner1": "YURKOVSKY, GREGORY & JANNA",
    "owner2": "",
    "current_taxes": 5021.96,
    "new_taxes_no_override": 5238.91,
    "override_total_1": 5387.56,
    "override_increase_1": 148.65
  },
  {
    "#": "120 Beaconsfield Rd, Unit 8 & G6 (226-06-08)",
    "$": 792700,
    "address": "120 Beaconsfield Rd, Unit 8 & G6",
    "parcel_id": "226-06-08",
    "owner1": "WENG, YUJIN",
    "owner2": "",
    "current_taxes": 4482.31,
    "new_taxes_no_override": 4675.95,
    "override_total_1": 4808.62,
    "override_increase_1": 132.68
  },
  {
    "#": "120 Beaconsfield Rd, Unit 9 & G9 (226-06-09)",
    "$": 836000,
    "address": "120 Beaconsfield Rd, Unit 9 & G9",
    "parcel_id": "226-06-09",
    "owner1": "DARDON, MARIA ELENA CABANE",
    "owner2": "MARTINS, BRUNO DUARTE FONSECA",
    "current_taxes": 4925.71,
    "new_taxes_no_override": 5138.5,
    "override_total_1": 5284.3,
    "override_increase_1": 145.8
  },
  {
    "#": "120 Beaconsfield Rd, Unit G-40 (226-06-34)",
    "$": 82500,
    "address": "120 Beaconsfield Rd, Unit G-40",
    "parcel_id": "226-06-34",
    "owner1": "NEEDELL, EDWARD B",
    "owner2": "",
    "current_taxes": 844.8,
    "new_taxes_no_override": 881.3,
    "override_total_1": 906.3,
    "override_increase_1": 25.01
  },
  {
    "#": "120 Beaconsfield Rd, Unit G33   (226-06-40)",
    "$": 42000,
    "address": "120 Beaconsfield Rd, Unit G33  ",
    "parcel_id": "226-06-40",
    "owner1": "ZUSSMAN TR, JODIE",
    "owner2": "C/O LEE KIN & BEATRICE L WRIGHT",
    "current_taxes": 430.08,
    "new_taxes_no_override": 448.66,
    "override_total_1": 461.39,
    "override_increase_1": 12.73
  },
  {
    "#": "120 Beaconsfield Rd, Unit G34 (226-06-41)",
    "$": 41300,
    "address": "120 Beaconsfield Rd, Unit G34",
    "parcel_id": "226-06-41",
    "owner1": "ZUSSMAN TR, JODIE",
    "owner2": "C/O MCINERNEY AMY LEE",
    "current_taxes": 422.91,
    "new_taxes_no_override": 441.18,
    "override_total_1": 453.7,
    "override_increase_1": 12.52
  },
  {
    "#": "120 Beaconsfield Rd, Unit G35 (226-06-38)",
    "$": 42000,
    "address": "120 Beaconsfield Rd, Unit G35",
    "parcel_id": "226-06-38",
    "owner1": "KARBASSI TRS, JESSICA && MICHAEL",
    "owner2": "",
    "current_taxes": 430.08,
    "new_taxes_no_override": 448.66,
    "override_total_1": 461.39,
    "override_increase_1": 12.73
  },
  {
    "#": "120 Beaconsfield Rd, Unit G43 (226-06-39)",
    "$": 42000,
    "address": "120 Beaconsfield Rd, Unit G43",
    "parcel_id": "226-06-39",
    "owner1": "LUISO, PETER J",
    "owner2": "",
    "current_taxes": 430.08,
    "new_taxes_no_override": 448.66,
    "override_total_1": 461.39,
    "override_increase_1": 12.73
  },
  {
    "#": "120 Beaconsfield Rd, Unit P 32 (226-06-37)",
    "$": 90800,
    "address": "120 Beaconsfield Rd, Unit P 32",
    "parcel_id": "226-06-37",
    "owner1": "MANN, JAMES JOSEPH JR",
    "owner2": "HIRSCH, HEATHER ANNE",
    "current_taxes": 929.79,
    "new_taxes_no_override": 969.96,
    "override_total_1": 997.48,
    "override_increase_1": 27.52
  },
  {
    "#": "120 Beaconsfield Rd, Unit P-29&30 (226-06-35)",
    "$": 165000,
    "address": "120 Beaconsfield Rd, Unit P-29&30",
    "parcel_id": "226-06-35",
    "owner1": "DURAN, RICHARD",
    "owner2": "SAN DOVAL, ALEXI",
    "current_taxes": 1689.6,
    "new_taxes_no_override": 1762.59,
    "override_total_1": 1812.6,
    "override_increase_1": 50.01
  },
  {
    "#": "120 Beaconsfield Rd, Unit P36 (226-06-36)",
    "$": 90800,
    "address": "120 Beaconsfield Rd, Unit P36",
    "parcel_id": "226-06-36",
    "owner1": "GEIFMAN, ABRAM",
    "owner2": "C/O GEIFMAN, NIKOLAI",
    "current_taxes": 929.79,
    "new_taxes_no_override": 969.96,
    "override_total_1": 997.48,
    "override_increase_1": 27.52
  },
  {
    "#": "120 Beaconsfield Rd, Unit T-1 & G5 (226-06-23)",
    "$": 730200,
    "address": "120 Beaconsfield Rd, Unit T-1 & G5",
    "parcel_id": "226-06-23",
    "owner1": "MEYER, ALEKSANDER",
    "owner2": "CLARK, DUTCH COMERFORD",
    "current_taxes": 7477.25,
    "new_taxes_no_override": 7800.27,
    "override_total_1": 8021.59,
    "override_increase_1": 221.33
  },
  {
    "#": "120 Beaconsfield Rd, Unit T-2 & G25 (226-06-24)",
    "$": 745200,
    "address": "120 Beaconsfield Rd, Unit T-2 & G25",
    "parcel_id": "226-06-24",
    "owner1": "VASQUEZ, MAURICIO RODRIGUEZ",
    "owner2": "",
    "current_taxes": 3995.91,
    "new_taxes_no_override": 4168.53,
    "override_total_1": 4286.81,
    "override_increase_1": 118.28
  },
  {
    "#": "120 Beaconsfield Rd, Unit T-3 & G8 (226-06-25)",
    "$": 735800,
    "address": "120 Beaconsfield Rd, Unit T-3 & G8",
    "parcel_id": "226-06-25",
    "owner1": "LIN, YIU-CHANG",
    "owner2": "",
    "current_taxes": 3899.66,
    "new_taxes_no_override": 4068.13,
    "override_total_1": 4183.56,
    "override_increase_1": 115.43
  },
  {
    "#": "120 Beaconsfield Rd, Unit T-4 & G11 (226-06-26)",
    "$": 1215300,
    "address": "120 Beaconsfield Rd, Unit T-4 & G11",
    "parcel_id": "226-06-26",
    "owner1": "RAY, MANDIRA",
    "owner2": "",
    "current_taxes": 8809.74,
    "new_taxes_no_override": 9190.32,
    "override_total_1": 9451.09,
    "override_increase_1": 260.77
  },
  {
    "#": "120 Beaconsfield Rd, Unit T-5 & G16 (226-06-27)",
    "$": 1256400,
    "address": "120 Beaconsfield Rd, Unit T-5 & G16",
    "parcel_id": "226-06-27",
    "owner1": "KIM, DANIEL E",
    "owner2": "",
    "current_taxes": 12865.54,
    "new_taxes_no_override": 13421.33,
    "override_total_1": 13802.15,
    "override_increase_1": 380.82
  },
  {
    "#": "120 Beaconsfield Rd, Unit T-6 & G18 (226-06-28)",
    "$": 601600,
    "address": "120 Beaconsfield Rd, Unit T-6 & G18",
    "parcel_id": "226-06-28",
    "owner1": "LERMAN, EUGENE",
    "owner2": "",
    "current_taxes": 2525.45,
    "new_taxes_no_override": 2634.55,
    "override_total_1": 2709.3,
    "override_increase_1": 74.75
  },
  {
    "#": "120 Beaconsfield Rd, Unit T-7 & G22 (226-06-29)",
    "$": 776100,
    "address": "120 Beaconsfield Rd, Unit T-7 & G22",
    "parcel_id": "226-06-29",
    "owner1": "FREED, JANET C",
    "owner2": "",
    "current_taxes": 4312.33,
    "new_taxes_no_override": 4498.62,
    "override_total_1": 4626.27,
    "override_increase_1": 127.64
  },
  {
    "#": "120 Beaconsfield Rd, Unit T-8 G38-42 (226-06-30)",
    "$": 1015000,
    "address": "120 Beaconsfield Rd, Unit T-8 G38-42",
    "parcel_id": "226-06-30",
    "owner1": "POON, SUSAN M",
    "owner2": "",
    "current_taxes": 6758.67,
    "new_taxes_no_override": 7050.64,
    "override_total_1": 7250.7,
    "override_increase_1": 200.06
  },
  {
    "#": "120 Beaconsfield Rd, Unit T-9 & G39 (226-06-31)",
    "$": 795800,
    "address": "120 Beaconsfield Rd, Unit T-9 & G39",
    "parcel_id": "226-06-31",
    "owner1": "SLAVEN TRS, RYAN",
    "owner2": "JARTMAN, JOY W",
    "current_taxes": 8148.99,
    "new_taxes_no_override": 8501.03,
    "override_total_1": 8742.24,
    "override_increase_1": 241.21
  },
  {
    "#": "121 Beaconsfield Rd, Unit 121&P21 (225-72-00)",
    "$": 1009100,
    "address": "121 Beaconsfield Rd, Unit 121&P21",
    "parcel_id": "225-72-00",
    "owner1": "GILLIGAN, AILISH",
    "owner2": "BROWN, MICHAEL S",
    "current_taxes": 6698.25,
    "new_taxes_no_override": 6987.61,
    "override_total_1": 7185.88,
    "override_increase_1": 198.27
  },
  {
    "#": "123 Beaconsfield Rd, Unit 123 (225-72-01)",
    "$": 890500,
    "address": "123 Beaconsfield Rd, Unit 123",
    "parcel_id": "225-72-01",
    "owner1": "LAM, SHUI FONG & JOHN S",
    "owner2": "",
    "current_taxes": 5483.79,
    "new_taxes_no_override": 5720.69,
    "override_total_1": 5883.01,
    "override_increase_1": 162.32
  },
  {
    "#": "124 Beaconsfield Rd (226-01-00)",
    "$": 14400,
    "address": "124 Beaconsfield Rd",
    "parcel_id": "226-01-00",
    "owner1": "COMMONWEALTH OF MASSACHUSETTS",
    "owner2": "C/O MASS BAY TRANSIT AUTHORITY",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "125 Beaconsfield Rd, Unit 125 (225-72-02)",
    "$": 1140000,
    "address": "125 Beaconsfield Rd, Unit 125",
    "parcel_id": "225-72-02",
    "owner1": "CHU, YUE S",
    "owner2": "",
    "current_taxes": 8038.67,
    "new_taxes_no_override": 8385.94,
    "override_total_1": 8623.89,
    "override_increase_1": 237.94
  },
  {
    "#": "127 Beaconsfield Rd, Unit 127 (225-72-03)",
    "$": 1144700,
    "address": "127 Beaconsfield Rd, Unit 127",
    "parcel_id": "225-72-03",
    "owner1": "HUANG, XIAOHUA",
    "owner2": "YAN, TING",
    "current_taxes": 11721.73,
    "new_taxes_no_override": 12228.11,
    "override_total_1": 12575.07,
    "override_increase_1": 346.96
  },
  {
    "#": "128 Beaconsfield Rd, Unit 1 & 13G (226-02-56)",
    "$": 718900,
    "address": "128 Beaconsfield Rd, Unit 1 & 13G",
    "parcel_id": "226-02-56",
    "owner1": "WANG, YUXUAN",
    "owner2": "SHEN, LUE",
    "current_taxes": 3726.6,
    "new_taxes_no_override": 3887.59,
    "override_total_1": 3997.9,
    "override_increase_1": 110.31
  },
  {
    "#": "128 Beaconsfield Rd, Unit 2 (226-02-01)",
    "$": 535200,
    "address": "128 Beaconsfield Rd, Unit 2",
    "parcel_id": "226-02-01",
    "owner1": "COOK TR, HENRY M",
    "owner2": "",
    "current_taxes": 5480.45,
    "new_taxes_no_override": 5717.21,
    "override_total_1": 5879.43,
    "override_increase_1": 162.22
  },
  {
    "#": "128 Beaconsfield Rd, Unit 3 (226-02-02)",
    "$": 654900,
    "address": "128 Beaconsfield Rd, Unit 3",
    "parcel_id": "226-02-02",
    "owner1": "TISBURY TOURS INC",
    "owner2": "C/O GELFAND RENNERT & FELDMAN",
    "current_taxes": 6706.18,
    "new_taxes_no_override": 6995.89,
    "override_total_1": 7194.39,
    "override_increase_1": 198.5
  },
  {
    "#": "128 Beaconsfield Rd, Unit 4 & G1 (226-02-03)",
    "$": 596100,
    "address": "128 Beaconsfield Rd, Unit 4 & G1",
    "parcel_id": "226-02-03",
    "owner1": "BOUCAI TR, GEORGETTE L",
    "owner2": "",
    "current_taxes": 6104.06,
    "new_taxes_no_override": 6367.76,
    "override_total_1": 6548.44,
    "override_increase_1": 180.68
  },
  {
    "#": "128 Beaconsfield Rd, Unit 5 (226-02-04)",
    "$": 771900,
    "address": "128 Beaconsfield Rd, Unit 5",
    "parcel_id": "226-02-04",
    "owner1": "WONG, FRANK",
    "owner2": "",
    "current_taxes": 7904.26,
    "new_taxes_no_override": 8245.72,
    "override_total_1": 8479.69,
    "override_increase_1": 233.97
  },
  {
    "#": "128 Beaconsfield Rd, Unit 6 (226-02-05)",
    "$": 543400,
    "address": "128 Beaconsfield Rd, Unit 6",
    "parcel_id": "226-02-05",
    "owner1": "AN, NING",
    "owner2": "YU, SI PING",
    "current_taxes": 5564.42,
    "new_taxes_no_override": 5804.8,
    "override_total_1": 5969.51,
    "override_increase_1": 164.71
  },
  {
    "#": "132 Beaconsfield Rd, Unit 1 & G4 (226-02-06)",
    "$": 570100,
    "address": "132 Beaconsfield Rd, Unit 1 & G4",
    "parcel_id": "226-02-06",
    "owner1": "SHARAF TR, ALAN B",
    "owner2": "",
    "current_taxes": 5837.82,
    "new_taxes_no_override": 6090.01,
    "override_total_1": 6262.81,
    "override_increase_1": 172.8
  },
  {
    "#": "132 Beaconsfield Rd, Unit 2 & P22 (226-02-07)",
    "$": 635500,
    "address": "132 Beaconsfield Rd, Unit 2 & P22",
    "parcel_id": "226-02-07",
    "owner1": "BOUCAI TR, GEORGETTE L",
    "owner2": "",
    "current_taxes": 6507.52,
    "new_taxes_no_override": 6788.64,
    "override_total_1": 6981.27,
    "override_increase_1": 192.62
  },
  {
    "#": "132 Beaconsfield Rd, Unit 3 & P3 (226-02-08)",
    "$": 535200,
    "address": "132 Beaconsfield Rd, Unit 3 & P3",
    "parcel_id": "226-02-08",
    "owner1": "COOK TR, HENRY M",
    "owner2": "",
    "current_taxes": 5480.45,
    "new_taxes_no_override": 5717.21,
    "override_total_1": 5879.43,
    "override_increase_1": 162.22
  },
  {
    "#": "132 Beaconsfield Rd, Unit 4 (226-02-09)",
    "$": 654900,
    "address": "132 Beaconsfield Rd, Unit 4",
    "parcel_id": "226-02-09",
    "owner1": "SANTOSA, JUNE C",
    "owner2": "",
    "current_taxes": 3071.24,
    "new_taxes_no_override": 3203.92,
    "override_total_1": 3294.83,
    "override_increase_1": 90.91
  },
  {
    "#": "132 Beaconsfield Rd, Unit 5 & P50 (226-02-10)",
    "$": 535200,
    "address": "132 Beaconsfield Rd, Unit 5 & P50",
    "parcel_id": "226-02-10",
    "owner1": "BROWN TR, DIANE",
    "owner2": "",
    "current_taxes": 1845.51,
    "new_taxes_no_override": 1925.24,
    "override_total_1": 1979.86,
    "override_increase_1": 54.63
  },
  {
    "#": "132 Beaconsfield Rd, Unit 6 (226-02-11)",
    "$": 663000,
    "address": "132 Beaconsfield Rd, Unit 6",
    "parcel_id": "226-02-11",
    "owner1": "HARNISH TR, JOAN",
    "owner2": "",
    "current_taxes": 6789.12,
    "new_taxes_no_override": 7082.41,
    "override_total_1": 7283.37,
    "override_increase_1": 200.96
  },
  {
    "#": "133 Beaconsfield Rd, Unit 11 & P20 (225-71-23)",
    "$": 460500,
    "address": "133 Beaconsfield Rd, Unit 11 & P20",
    "parcel_id": "225-71-23",
    "owner1": "ALTON BEACONSFIELD LLC",
    "owner2": "C/O ALEXANDRA CRIVON - COLDWELL BANKER",
    "current_taxes": 4715.52,
    "new_taxes_no_override": 4919.23,
    "override_total_1": 5058.81,
    "override_increase_1": 139.58
  },
  {
    "#": "133 Beaconsfield Rd, Unit 12 & P-5 (225-71-01)",
    "$": 482800,
    "address": "133 Beaconsfield Rd, Unit 12 & P-5",
    "parcel_id": "225-71-01",
    "owner1": "SHAO, HUACHUAN",
    "owner2": "WOLENSKI, FRANCIS",
    "current_taxes": 4943.87,
    "new_taxes_no_override": 5157.45,
    "override_total_1": 5303.78,
    "override_increase_1": 146.34
  },
  {
    "#": "133 Beaconsfield Rd, Unit 14 & P2 (225-71-02)",
    "$": 435500,
    "address": "133 Beaconsfield Rd, Unit 14 & P2",
    "parcel_id": "225-71-02",
    "owner1": "GOLDMAN, TRS, ARYEH S",
    "owner2": "",
    "current_taxes": 4459.52,
    "new_taxes_no_override": 4652.17,
    "override_total_1": 4784.17,
    "override_increase_1": 132.0
  },
  {
    "#": "133 Beaconsfield Rd, Unit 15 & P3 (225-71-03)",
    "$": 448300,
    "address": "133 Beaconsfield Rd, Unit 15 & P3",
    "parcel_id": "225-71-03",
    "owner1": "PHLR LLC",
    "owner2": "",
    "current_taxes": 4590.59,
    "new_taxes_no_override": 4788.9,
    "override_total_1": 4924.78,
    "override_increase_1": 135.88
  },
  {
    "#": "133 Beaconsfield Rd, Unit 16 (225-71-04)",
    "$": 482800,
    "address": "133 Beaconsfield Rd, Unit 16",
    "parcel_id": "225-71-04",
    "owner1": "ONART, RYAN CONLON & SEAN",
    "owner2": "",
    "current_taxes": 4943.87,
    "new_taxes_no_override": 5157.45,
    "override_total_1": 5303.78,
    "override_increase_1": 146.34
  },
  {
    "#": "133 Beaconsfield Rd, Unit 21 & P1 (225-71-05)",
    "$": 568500,
    "address": "133 Beaconsfield Rd, Unit 21 & P1",
    "parcel_id": "225-71-05",
    "owner1": "KONG, YUAN",
    "owner2": "MA, HAOBO",
    "current_taxes": 5821.44,
    "new_taxes_no_override": 6072.93,
    "override_total_1": 6245.24,
    "override_increase_1": 172.31
  },
  {
    "#": "133 Beaconsfield Rd, Unit 22 (225-71-06)",
    "$": 568500,
    "address": "133 Beaconsfield Rd, Unit 22",
    "parcel_id": "225-71-06",
    "owner1": "MODRICAMIN, TR, MIRIAM",
    "owner2": "",
    "current_taxes": 5821.44,
    "new_taxes_no_override": 6072.93,
    "override_total_1": 6245.24,
    "override_increase_1": 172.31
  },
  {
    "#": "133 Beaconsfield Rd, Unit 23 & P14 (225-71-07)",
    "$": 613400,
    "address": "133 Beaconsfield Rd, Unit 23 & P14",
    "parcel_id": "225-71-07",
    "owner1": "XU, DONGJIN",
    "owner2": "",
    "current_taxes": 6281.22,
    "new_taxes_no_override": 6552.57,
    "override_total_1": 6738.49,
    "override_increase_1": 185.92
  },
  {
    "#": "133 Beaconsfield Rd, Unit 24 & P25 (225-71-08)",
    "$": 647600,
    "address": "133 Beaconsfield Rd, Unit 24 & P25",
    "parcel_id": "225-71-08",
    "owner1": "JAUW, RIA",
    "owner2": "",
    "current_taxes": 2996.49,
    "new_taxes_no_override": 3125.94,
    "override_total_1": 3214.63,
    "override_increase_1": 88.7
  },
  {
    "#": "133 Beaconsfield Rd, Unit 25 (225-71-09)",
    "$": 601500,
    "address": "133 Beaconsfield Rd, Unit 25",
    "parcel_id": "225-71-09",
    "owner1": "GLASSOFF, ERIC & INGRID",
    "owner2": "",
    "current_taxes": 6159.36,
    "new_taxes_no_override": 6425.44,
    "override_total_1": 6607.76,
    "override_increase_1": 182.32
  },
  {
    "#": "133 Beaconsfield Rd, Unit 26 & P4 (225-71-10)",
    "$": 568500,
    "address": "133 Beaconsfield Rd, Unit 26 & P4",
    "parcel_id": "225-71-10",
    "owner1": "KOVALEV LIFE ESTATE, ALEKSANDR",
    "owner2": "KOVALEVA LIFE ESTATE, ANNA",
    "current_taxes": 5821.44,
    "new_taxes_no_override": 6072.93,
    "override_total_1": 6245.24,
    "override_increase_1": 172.31
  },
  {
    "#": "133 Beaconsfield Rd, Unit 31 (225-71-11)",
    "$": 587900,
    "address": "133 Beaconsfield Rd, Unit 31",
    "parcel_id": "225-71-11",
    "owner1": "KATZ, ELLEN S",
    "owner2": "",
    "current_taxes": 6020.1,
    "new_taxes_no_override": 6280.17,
    "override_total_1": 6458.36,
    "override_increase_1": 178.19
  },
  {
    "#": "133 Beaconsfield Rd, Unit 32 & P7 (225-71-12)",
    "$": 587900,
    "address": "133 Beaconsfield Rd, Unit 32 & P7",
    "parcel_id": "225-71-12",
    "owner1": "GOLDMAN, TRS, DAVID M",
    "owner2": "",
    "current_taxes": 6020.1,
    "new_taxes_no_override": 6280.17,
    "override_total_1": 6458.36,
    "override_increase_1": 178.19
  },
  {
    "#": "133 Beaconsfield Rd, Unit 33 (225-71-13)",
    "$": 613400,
    "address": "133 Beaconsfield Rd, Unit 33",
    "parcel_id": "225-71-13",
    "owner1": "COOK TR, HENRY M",
    "owner2": "",
    "current_taxes": 6281.22,
    "new_taxes_no_override": 6552.57,
    "override_total_1": 6738.49,
    "override_increase_1": 185.92
  },
  {
    "#": "133 Beaconsfield Rd, Unit 34 (225-71-14)",
    "$": 647600,
    "address": "133 Beaconsfield Rd, Unit 34",
    "parcel_id": "225-71-14",
    "owner1": "SAYED TRS, SOHAIL & SHAHANA",
    "owner2": "",
    "current_taxes": 6631.42,
    "new_taxes_no_override": 6917.9,
    "override_total_1": 7114.19,
    "override_increase_1": 196.29
  },
  {
    "#": "133 Beaconsfield Rd, Unit 35 (225-71-15)",
    "$": 587900,
    "address": "133 Beaconsfield Rd, Unit 35",
    "parcel_id": "225-71-15",
    "owner1": "REED TR, PEILIN",
    "owner2": "",
    "current_taxes": 6020.1,
    "new_taxes_no_override": 6280.17,
    "override_total_1": 6458.36,
    "override_increase_1": 178.19
  },
  {
    "#": "133 Beaconsfield Rd, Unit 36 (225-71-16)",
    "$": 588000,
    "address": "133 Beaconsfield Rd, Unit 36",
    "parcel_id": "225-71-16",
    "owner1": "TAN, TOM Z",
    "owner2": "ZHOU, LISA H",
    "current_taxes": 6021.12,
    "new_taxes_no_override": 6281.23,
    "override_total_1": 6459.46,
    "override_increase_1": 178.23
  },
  {
    "#": "133 Beaconsfield Rd, Unit 41 & P21 (225-71-17)",
    "$": 599600,
    "address": "133 Beaconsfield Rd, Unit 41 & P21",
    "parcel_id": "225-71-17",
    "owner1": "LIU, HONG",
    "owner2": "",
    "current_taxes": 6139.9,
    "new_taxes_no_override": 6405.14,
    "override_total_1": 6586.88,
    "override_increase_1": 181.74
  },
  {
    "#": "133 Beaconsfield Rd, Unit 42 & P8 (225-71-18)",
    "$": 587900,
    "address": "133 Beaconsfield Rd, Unit 42 & P8",
    "parcel_id": "225-71-18",
    "owner1": "BROOKWATER TRUST LLC",
    "owner2": "",
    "current_taxes": 6020.1,
    "new_taxes_no_override": 6280.17,
    "override_total_1": 6458.36,
    "override_increase_1": 178.19
  },
  {
    "#": "133 Beaconsfield Rd, Unit 43 & P13 (225-71-19)",
    "$": 621200,
    "address": "133 Beaconsfield Rd, Unit 43 & P13",
    "parcel_id": "225-71-19",
    "owner1": "ALBERT TRS, LAURENCE G & TAMAR A",
    "owner2": "C/O REGENTS TRUST",
    "current_taxes": 6361.09,
    "new_taxes_no_override": 6635.89,
    "override_total_1": 6824.18,
    "override_increase_1": 188.29
  },
  {
    "#": "133 Beaconsfield Rd, Unit 44 & P18 (225-71-20)",
    "$": 684500,
    "address": "133 Beaconsfield Rd, Unit 44 & P18",
    "parcel_id": "225-71-20",
    "owner1": "KATZ, TR, ELLEN S",
    "owner2": "",
    "current_taxes": 7009.28,
    "new_taxes_no_override": 7312.08,
    "override_total_1": 7519.56,
    "override_increase_1": 207.47
  },
  {
    "#": "133 Beaconsfield Rd, Unit 45 (225-71-21)",
    "$": 587900,
    "address": "133 Beaconsfield Rd, Unit 45",
    "parcel_id": "225-71-21",
    "owner1": "GOLDMAN, TR, DAVID",
    "owner2": "",
    "current_taxes": 6020.1,
    "new_taxes_no_override": 6280.17,
    "override_total_1": 6458.36,
    "override_increase_1": 178.19
  },
  {
    "#": "133 Beaconsfield Rd, Unit 46 & P19 (225-71-22)",
    "$": 587900,
    "address": "133 Beaconsfield Rd, Unit 46 & P19",
    "parcel_id": "225-71-22",
    "owner1": "MARGOLINA, ALLA",
    "owner2": "",
    "current_taxes": 2385.16,
    "new_taxes_no_override": 2488.2,
    "override_total_1": 2558.8,
    "override_increase_1": 70.6
  },
  {
    "#": "135 Beaconsfield Rd, Unit 1 & P7 (225-66-27)",
    "$": 1165300,
    "address": "135 Beaconsfield Rd, Unit 1 & P7",
    "parcel_id": "225-66-27",
    "owner1": "WAKEFIELD, JOHN F & BARBARA P",
    "owner2": "",
    "current_taxes": 8297.74,
    "new_taxes_no_override": 8656.2,
    "override_total_1": 8901.82,
    "override_increase_1": 245.61
  },
  {
    "#": "135 Beaconsfield Rd, Unit 2 (225-66-01)",
    "$": 1261400,
    "address": "135 Beaconsfield Rd, Unit 2",
    "parcel_id": "225-66-01",
    "owner1": "LOYOLA TRS, BRUNO MOTA",
    "owner2": "DRUMMOND, ISABELA CRISTINA FERRERIRA",
    "current_taxes": 9281.8,
    "new_taxes_no_override": 9682.77,
    "override_total_1": 9957.52,
    "override_increase_1": 274.74
  },
  {
    "#": "135 Beaconsfield Rd, Unit 3 (225-66-02)",
    "$": 1126000,
    "address": "135 Beaconsfield Rd, Unit 3",
    "parcel_id": "225-66-02",
    "owner1": "DICHTER, THOMAS ALAN",
    "owner2": "IMADOJEMU, SOTONYE",
    "current_taxes": 7895.31,
    "new_taxes_no_override": 8236.39,
    "override_total_1": 8470.09,
    "override_increase_1": 233.7
  },
  {
    "#": "136 Beaconsfield Rd, Unit 1 (226-02-12)",
    "$": 635600,
    "address": "136 Beaconsfield Rd, Unit 1",
    "parcel_id": "226-02-12",
    "owner1": "SILBERT, SANDRA L",
    "owner2": "",
    "current_taxes": 2873.61,
    "new_taxes_no_override": 2997.75,
    "override_total_1": 3082.81,
    "override_increase_1": 85.06
  },
  {
    "#": "136 Beaconsfield Rd, Unit 2 & P10 (226-02-13)",
    "$": 535200,
    "address": "136 Beaconsfield Rd, Unit 2 & P10",
    "parcel_id": "226-02-13",
    "owner1": "GOLDMAN, JAYNE",
    "owner2": "",
    "current_taxes": 1845.51,
    "new_taxes_no_override": 1925.24,
    "override_total_1": 1979.86,
    "override_increase_1": 54.63
  },
  {
    "#": "136 Beaconsfield Rd, Unit 3 & P48 (226-02-14)",
    "$": 663000,
    "address": "136 Beaconsfield Rd, Unit 3 & P48",
    "parcel_id": "226-02-14",
    "owner1": "SEADIA, TR, MICHAEL & JOSHUA",
    "owner2": "",
    "current_taxes": 6789.12,
    "new_taxes_no_override": 7082.41,
    "override_total_1": 7283.37,
    "override_increase_1": 200.96
  },
  {
    "#": "136 Beaconsfield Rd, Unit 4 (226-02-15)",
    "$": 535200,
    "address": "136 Beaconsfield Rd, Unit 4",
    "parcel_id": "226-02-15",
    "owner1": "WALLACE, JEAN",
    "owner2": "",
    "current_taxes": 1845.51,
    "new_taxes_no_override": 1925.24,
    "override_total_1": 1979.86,
    "override_increase_1": 54.63
  },
  {
    "#": "136 Beaconsfield Rd, Unit 5 (226-02-16)",
    "$": 654900,
    "address": "136 Beaconsfield Rd, Unit 5",
    "parcel_id": "226-02-16",
    "owner1": "KWONG TR, DEBBY T C",
    "owner2": "",
    "current_taxes": 6706.18,
    "new_taxes_no_override": 6995.89,
    "override_total_1": 7194.39,
    "override_increase_1": 198.5
  },
  {
    "#": "136 Beaconsfield Rd, Unit 6 (226-02-17)",
    "$": 546900,
    "address": "136 Beaconsfield Rd, Unit 6",
    "parcel_id": "226-02-17",
    "owner1": "SCOTT, DUNCAN A & ASLI",
    "owner2": "",
    "current_taxes": 5600.26,
    "new_taxes_no_override": 5842.19,
    "override_total_1": 6007.96,
    "override_increase_1": 165.77
  },
  {
    "#": "137 Beaconsfield Rd, Unit 1 (225-66-04)",
    "$": 1136700,
    "address": "137 Beaconsfield Rd, Unit 1",
    "parcel_id": "225-66-04",
    "owner1": "BOLAND TRS, MARTHA M",
    "owner2": "STEVENS, KATHLEEN B",
    "current_taxes": 8004.87,
    "new_taxes_no_override": 8350.68,
    "override_total_1": 8587.62,
    "override_increase_1": 236.94
  },
  {
    "#": "137 Beaconsfield Rd, Unit 2 (225-66-05)",
    "$": 767000,
    "address": "137 Beaconsfield Rd, Unit 2",
    "parcel_id": "225-66-05",
    "owner1": "RICHARDSON, JEFFREY W",
    "owner2": "PALMER, SUSAN",
    "current_taxes": 4219.15,
    "new_taxes_no_override": 4401.42,
    "override_total_1": 4526.3,
    "override_increase_1": 124.89
  },
  {
    "#": "137 Beaconsfield Rd, Unit 3 (225-66-06)",
    "$": 1136800,
    "address": "137 Beaconsfield Rd, Unit 3",
    "parcel_id": "225-66-06",
    "owner1": "XIE, TAO",
    "owner2": "SUN, JIA",
    "current_taxes": 8005.9,
    "new_taxes_no_override": 8351.75,
    "override_total_1": 8588.73,
    "override_increase_1": 236.97
  },
  {
    "#": "137 Beaconsfield Rd, Unit 4 (225-66-07)",
    "$": 902000,
    "address": "137 Beaconsfield Rd, Unit 4",
    "parcel_id": "225-66-07",
    "owner1": "ROBBE TRS, MICHAEL E & ZACHARY L",
    "owner2": "",
    "current_taxes": 5601.55,
    "new_taxes_no_override": 5843.54,
    "override_total_1": 6009.34,
    "override_increase_1": 165.81
  },
  {
    "#": "137 Beaconsfield Rd, Unit 5 (225-66-08)",
    "$": 1157800,
    "address": "137 Beaconsfield Rd, Unit 5",
    "parcel_id": "225-66-08",
    "owner1": "LI, TAO",
    "owner2": "CHEN, MINGHUI",
    "current_taxes": 8220.94,
    "new_taxes_no_override": 8576.08,
    "override_total_1": 8819.42,
    "override_increase_1": 243.34
  },
  {
    "#": "137 Beaconsfield Rd, Unit 6 (225-66-09)",
    "$": 979000,
    "address": "137 Beaconsfield Rd, Unit 6",
    "parcel_id": "225-66-09",
    "owner1": "MERRIWEATHER LLC",
    "owner2": "",
    "current_taxes": 10024.96,
    "new_taxes_no_override": 10458.04,
    "override_total_1": 10754.78,
    "override_increase_1": 296.74
  },
  {
    "#": "137 Beaconsfield Rd, Unit B (225-66-03)",
    "$": 447600,
    "address": "137 Beaconsfield Rd, Unit B",
    "parcel_id": "225-66-03",
    "owner1": "GARBER, JASON S",
    "owner2": "",
    "current_taxes": 948.49,
    "new_taxes_no_override": 989.46,
    "override_total_1": 1017.54,
    "override_increase_1": 28.08
  },
  {
    "#": "139 Beaconsfield Rd, Unit 1 (225-66-12)",
    "$": 1247800,
    "address": "139 Beaconsfield Rd, Unit 1",
    "parcel_id": "225-66-12",
    "owner1": "JIA, DI",
    "owner2": "",
    "current_taxes": 9142.54,
    "new_taxes_no_override": 9537.5,
    "override_total_1": 9808.12,
    "override_increase_1": 270.62
  },
  {
    "#": "139 Beaconsfield Rd, Unit 2 (225-66-13)",
    "$": 1152700,
    "address": "139 Beaconsfield Rd, Unit 2",
    "parcel_id": "225-66-13",
    "owner1": "JACOBS, EDWARD S & ELIZABETH S",
    "owner2": "",
    "current_taxes": 8168.71,
    "new_taxes_no_override": 8521.6,
    "override_total_1": 8763.39,
    "override_increase_1": 241.79
  },
  {
    "#": "139 Beaconsfield Rd, Unit 3 (225-66-14)",
    "$": 1113300,
    "address": "139 Beaconsfield Rd, Unit 3",
    "parcel_id": "225-66-14",
    "owner1": "LANCOURT TR, JOAN",
    "owner2": "",
    "current_taxes": 7765.26,
    "new_taxes_no_override": 8100.72,
    "override_total_1": 8330.57,
    "override_increase_1": 229.85
  },
  {
    "#": "139 Beaconsfield Rd, Unit 4 (225-66-15)",
    "$": 1121600,
    "address": "139 Beaconsfield Rd, Unit 4",
    "parcel_id": "225-66-15",
    "owner1": "GRAY TRS, ROBERT L & MARTHA COLLINS",
    "owner2": "",
    "current_taxes": 11485.18,
    "new_taxes_no_override": 11981.34,
    "override_total_1": 12321.3,
    "override_increase_1": 339.96
  },
  {
    "#": "139 Beaconsfield Rd, Unit 5 (225-66-16)",
    "$": 1235200,
    "address": "139 Beaconsfield Rd, Unit 5",
    "parcel_id": "225-66-16",
    "owner1": "PITTMAN, TRAVIS",
    "owner2": "GLASS, KIMBERLY",
    "current_taxes": 9013.51,
    "new_taxes_no_override": 9402.89,
    "override_total_1": 9669.69,
    "override_increase_1": 266.8
  },
  {
    "#": "139 Beaconsfield Rd, Unit 6 (225-66-17)",
    "$": 1247800,
    "address": "139 Beaconsfield Rd, Unit 6",
    "parcel_id": "225-66-17",
    "owner1": "NIELSON, ELENA HIGGERSON & LARS RUSSELL",
    "owner2": "",
    "current_taxes": 12777.47,
    "new_taxes_no_override": 13329.46,
    "override_total_1": 13707.67,
    "override_increase_1": 378.21
  },
  {
    "#": "139 Beaconsfield Rd, Unit B1 &P14 (225-66-10)",
    "$": 708700,
    "address": "139 Beaconsfield Rd, Unit B1 &P14",
    "parcel_id": "225-66-10",
    "owner1": "NEGRI, ELIYA FISHMAN & YARIN ZVI",
    "owner2": "",
    "current_taxes": 7257.09,
    "new_taxes_no_override": 7570.6,
    "override_total_1": 7785.41,
    "override_increase_1": 214.81
  },
  {
    "#": "139 Beaconsfield Rd, Unit B2 (225-66-11)",
    "$": 444900,
    "address": "139 Beaconsfield Rd, Unit B2",
    "parcel_id": "225-66-11",
    "owner1": "SHANKARANARAYANA, SHUBHA HARIHALLY",
    "owner2": "",
    "current_taxes": 4555.78,
    "new_taxes_no_override": 4752.59,
    "override_total_1": 4887.44,
    "override_increase_1": 134.85
  },
  {
    "#": "140 Beaconsfield Rd, Unit 1 & P25 (226-02-18)",
    "$": 535200,
    "address": "140 Beaconsfield Rd, Unit 1 & P25",
    "parcel_id": "226-02-18",
    "owner1": "SMITH, JOSEPH",
    "owner2": "",
    "current_taxes": 5480.45,
    "new_taxes_no_override": 5717.21,
    "override_total_1": 5879.43,
    "override_increase_1": 162.22
  },
  {
    "#": "140 Beaconsfield Rd, Unit 2 (226-02-19)",
    "$": 581100,
    "address": "140 Beaconsfield Rd, Unit 2",
    "parcel_id": "226-02-19",
    "owner1": "DOWLATSHAHI, EMMILIA ASSAL & ARRIYAN SAMANDAR",
    "owner2": "",
    "current_taxes": 5950.46,
    "new_taxes_no_override": 6207.52,
    "override_total_1": 6383.65,
    "override_increase_1": 176.13
  },
  {
    "#": "140 Beaconsfield Rd, Unit 3 (226-02-20)",
    "$": 564300,
    "address": "140 Beaconsfield Rd, Unit 3",
    "parcel_id": "226-02-20",
    "owner1": "GANCHI, LEYLA S",
    "owner2": "",
    "current_taxes": 5778.43,
    "new_taxes_no_override": 6028.06,
    "override_total_1": 6199.1,
    "override_increase_1": 171.04
  },
  {
    "#": "140 Beaconsfield Rd, Unit 4 & P23 (226-02-21)",
    "$": 689300,
    "address": "140 Beaconsfield Rd, Unit 4 & P23",
    "parcel_id": "226-02-21",
    "owner1": "SHARAF TR, ALAN B",
    "owner2": "",
    "current_taxes": 7058.43,
    "new_taxes_no_override": 7363.35,
    "override_total_1": 7572.28,
    "override_increase_1": 208.93
  },
  {
    "#": "140 Beaconsfield Rd, Unit 5 (226-02-22)",
    "$": 564300,
    "address": "140 Beaconsfield Rd, Unit 5",
    "parcel_id": "226-02-22",
    "owner1": "LEE, DONG HOON",
    "owner2": "PARK, ANNA",
    "current_taxes": 2143.5,
    "new_taxes_no_override": 2236.1,
    "override_total_1": 2299.55,
    "override_increase_1": 63.45
  },
  {
    "#": "140 Beaconsfield Rd, Unit 6 (226-02-23)",
    "$": 790900,
    "address": "140 Beaconsfield Rd, Unit 6",
    "parcel_id": "226-02-23",
    "owner1": "PORTER TRS, RICHARD M & SUSAN L",
    "owner2": "",
    "current_taxes": 8098.82,
    "new_taxes_no_override": 8448.69,
    "override_total_1": 8688.41,
    "override_increase_1": 239.73
  },
  {
    "#": "141 Beaconsfield Rd, Unit 1 (225-66-18)",
    "$": 1136800,
    "address": "141 Beaconsfield Rd, Unit 1",
    "parcel_id": "225-66-18",
    "owner1": "SHACK, THOMAS G III & MONICA S",
    "owner2": "",
    "current_taxes": 11640.83,
    "new_taxes_no_override": 12143.71,
    "override_total_1": 12488.28,
    "override_increase_1": 344.57
  },
  {
    "#": "141 Beaconsfield Rd, Unit 2 & P24 (225-66-19)",
    "$": 951500,
    "address": "141 Beaconsfield Rd, Unit 2 & P24",
    "parcel_id": "225-66-19",
    "owner1": "SIEGEL, BARBARA J",
    "owner2": "",
    "current_taxes": 9743.36,
    "new_taxes_no_override": 10164.27,
    "override_total_1": 10452.68,
    "override_increase_1": 288.4
  },
  {
    "#": "141 Beaconsfield Rd, Unit 3 (225-66-20)",
    "$": 1126500,
    "address": "141 Beaconsfield Rd, Unit 3",
    "parcel_id": "225-66-20",
    "owner1": "CHRISTY, MICHELLE D",
    "owner2": "",
    "current_taxes": 7900.43,
    "new_taxes_no_override": 8241.73,
    "override_total_1": 8475.58,
    "override_increase_1": 233.85
  },
  {
    "#": "141 Beaconsfield Rd, Unit 4 (225-66-21)",
    "$": 771700,
    "address": "141 Beaconsfield Rd, Unit 4",
    "parcel_id": "225-66-21",
    "owner1": "MEI, MARGERY W",
    "owner2": "",
    "current_taxes": 7902.21,
    "new_taxes_no_override": 8243.59,
    "override_total_1": 8477.49,
    "override_increase_1": 233.91
  },
  {
    "#": "141 Beaconsfield Rd, Unit 5 (225-66-22)",
    "$": 1092200,
    "address": "141 Beaconsfield Rd, Unit 5",
    "parcel_id": "225-66-22",
    "owner1": "WEBBER, THOMAS P",
    "owner2": "",
    "current_taxes": 7549.19,
    "new_taxes_no_override": 7875.32,
    "override_total_1": 8098.77,
    "override_increase_1": 223.46
  },
  {
    "#": "141 Beaconsfield Rd, Unit 6 (225-66-23)",
    "$": 928200,
    "address": "141 Beaconsfield Rd, Unit 6",
    "parcel_id": "225-66-23",
    "owner1": "KOTKIN, LEONID & MARINA",
    "owner2": "",
    "current_taxes": 9504.77,
    "new_taxes_no_override": 9915.38,
    "override_total_1": 10196.72,
    "override_increase_1": 281.34
  },
  {
    "#": "143 Beaconsfield Rd, Unit 1 (225-66-24)",
    "$": 1125900,
    "address": "143 Beaconsfield Rd, Unit 1",
    "parcel_id": "225-66-24",
    "owner1": "DAVIN, KENNETH J",
    "owner2": "ABELES, BERTINA E",
    "current_taxes": 7894.28,
    "new_taxes_no_override": 8235.31,
    "override_total_1": 8468.98,
    "override_increase_1": 233.67
  },
  {
    "#": "143 Beaconsfield Rd, Unit 2 (225-66-25)",
    "$": 1165300,
    "address": "143 Beaconsfield Rd, Unit 2",
    "parcel_id": "225-66-25",
    "owner1": "EVANS, KELLY ANN",
    "owner2": "SEITELMAN, DAVID",
    "current_taxes": 8297.74,
    "new_taxes_no_override": 8656.2,
    "override_total_1": 8901.82,
    "override_increase_1": 245.61
  },
  {
    "#": "143 Beaconsfield Rd, Unit 3 (225-66-26)",
    "$": 1153600,
    "address": "143 Beaconsfield Rd, Unit 3",
    "parcel_id": "225-66-26",
    "owner1": "FLAGLER, SHERI",
    "owner2": "",
    "current_taxes": 8177.93,
    "new_taxes_no_override": 8531.22,
    "override_total_1": 8773.28,
    "override_increase_1": 242.07
  },
  {
    "#": "146 Beaconsfield Rd, Unit 1 & P56 (226-02-26)",
    "$": 512100,
    "address": "146 Beaconsfield Rd, Unit 1 & P56",
    "parcel_id": "226-02-26",
    "owner1": "PALMROTH TR, NATASHA",
    "owner2": "",
    "current_taxes": 1608.97,
    "new_taxes_no_override": 1678.48,
    "override_total_1": 1726.1,
    "override_increase_1": 47.63
  },
  {
    "#": "146 Beaconsfield Rd, Unit 2 (226-02-27)",
    "$": 411900,
    "address": "146 Beaconsfield Rd, Unit 2",
    "parcel_id": "226-02-27",
    "owner1": "SHARAF TR, ALAN B",
    "owner2": "",
    "current_taxes": 4217.86,
    "new_taxes_no_override": 4400.07,
    "override_total_1": 4524.92,
    "override_increase_1": 124.85
  },
  {
    "#": "146 Beaconsfield Rd, Unit 3 (226-02-28)",
    "$": 512100,
    "address": "146 Beaconsfield Rd, Unit 3",
    "parcel_id": "226-02-28",
    "owner1": "CHEN, CYNTHIA & JUN RONG",
    "owner2": "",
    "current_taxes": 1608.97,
    "new_taxes_no_override": 1678.48,
    "override_total_1": 1726.1,
    "override_increase_1": 47.63
  },
  {
    "#": "146 Beaconsfield Rd, Unit 4 (226-02-29)",
    "$": 502600,
    "address": "146 Beaconsfield Rd, Unit 4",
    "parcel_id": "226-02-29",
    "owner1": "COHEN, TR, LYNNE",
    "owner2": "C/O FRIEDMAN LYNNE",
    "current_taxes": 5146.62,
    "new_taxes_no_override": 5368.95,
    "override_total_1": 5521.29,
    "override_increase_1": 152.34
  },
  {
    "#": "146 Beaconsfield Rd, Unit 5  (226-02-30)",
    "$": 592200,
    "address": "146 Beaconsfield Rd, Unit 5 ",
    "parcel_id": "226-02-30",
    "owner1": "GROSSACK, SAMUEL JOSEPH & RICHARD GERALD",
    "owner2": "",
    "current_taxes": 2429.19,
    "new_taxes_no_override": 2534.13,
    "override_total_1": 2606.04,
    "override_increase_1": 71.9
  },
  {
    "#": "146 Beaconsfield Rd, Unit 6 & P2 (226-02-31)",
    "$": 483700,
    "address": "146 Beaconsfield Rd, Unit 6 & P2",
    "parcel_id": "226-02-31",
    "owner1": "BOUCAI TR, GEORGETTE L",
    "owner2": "",
    "current_taxes": 4953.09,
    "new_taxes_no_override": 5167.06,
    "override_total_1": 5313.67,
    "override_increase_1": 146.61
  },
  {
    "#": "146 Beaconsfield Rd, Unit T1 & P54 (226-02-24)",
    "$": 488400,
    "address": "146 Beaconsfield Rd, Unit T1 & P54",
    "parcel_id": "226-02-24",
    "owner1": "BAKER, MARSHA E",
    "owner2": "FORSDICK, HARRY C",
    "current_taxes": 5001.22,
    "new_taxes_no_override": 5217.27,
    "override_total_1": 5365.31,
    "override_increase_1": 148.04
  },
  {
    "#": "146 Beaconsfield Rd, Unit T2 & P45 (226-02-25)",
    "$": 400600,
    "address": "146 Beaconsfield Rd, Unit T2 & P45",
    "parcel_id": "226-02-25",
    "owner1": "ZHOU, ZHIQIANG",
    "owner2": "JI, FANG",
    "current_taxes": 4102.14,
    "new_taxes_no_override": 4279.35,
    "override_total_1": 4400.78,
    "override_increase_1": 121.42
  },
  {
    "#": "149 Beaconsfield Rd, Unit A-2 (225-65-08)",
    "$": 933100,
    "address": "149 Beaconsfield Rd, Unit A-2",
    "parcel_id": "225-65-08",
    "owner1": "BALCARCEL, ANA LAURA",
    "owner2": "",
    "current_taxes": 5920.01,
    "new_taxes_no_override": 6175.75,
    "override_total_1": 6350.99,
    "override_increase_1": 175.23
  },
  {
    "#": "149 Beaconsfield Rd, Unit A-3 (225-65-10)",
    "$": 894700,
    "address": "149 Beaconsfield Rd, Unit A-3",
    "parcel_id": "225-65-10",
    "owner1": "CHANG, CHUAN M",
    "owner2": "",
    "current_taxes": 5526.79,
    "new_taxes_no_override": 5765.55,
    "override_total_1": 5929.14,
    "override_increase_1": 163.59
  },
  {
    "#": "149 Beaconsfield Rd, Unit A-4 & P7 (225-65-12)",
    "$": 959900,
    "address": "149 Beaconsfield Rd, Unit A-4 & P7",
    "parcel_id": "225-65-12",
    "owner1": "KRISHNASAMY, SHAMBHO",
    "owner2": "",
    "current_taxes": 9829.38,
    "new_taxes_no_override": 10254.01,
    "override_total_1": 10544.96,
    "override_increase_1": 290.95
  },
  {
    "#": "149 Beaconsfield Rd, Unit A-G & G6 (225-65-06)",
    "$": 960000,
    "address": "149 Beaconsfield Rd, Unit A-G & G6",
    "parcel_id": "225-65-06",
    "owner1": "BAQUIS, GEORGE D & GAIL E",
    "owner2": "",
    "current_taxes": 6195.47,
    "new_taxes_no_override": 6463.11,
    "override_total_1": 6646.5,
    "override_increase_1": 183.39
  },
  {
    "#": "149 Beaconsfield Rd, Unit B-2 & P14 (225-65-09)",
    "$": 869300,
    "address": "149 Beaconsfield Rd, Unit B-2 & P14",
    "parcel_id": "225-65-09",
    "owner1": "ORLOVSKY, NATALIA",
    "owner2": "",
    "current_taxes": 8901.63,
    "new_taxes_no_override": 9286.18,
    "override_total_1": 9549.67,
    "override_increase_1": 263.49
  },
  {
    "#": "149 Beaconsfield Rd, Unit B-3 (225-65-11)",
    "$": 865000,
    "address": "149 Beaconsfield Rd, Unit B-3",
    "parcel_id": "225-65-11",
    "owner1": "AZMON, DAN & LINDA & CORY & LAUREN",
    "owner2": "",
    "current_taxes": 8857.6,
    "new_taxes_no_override": 9240.25,
    "override_total_1": 9502.43,
    "override_increase_1": 262.18
  },
  {
    "#": "149 Beaconsfield Rd, Unit B-4 (225-65-13)",
    "$": 987100,
    "address": "149 Beaconsfield Rd, Unit B-4",
    "parcel_id": "225-65-13",
    "owner1": "WOROBEC, THOMAS",
    "owner2": "",
    "current_taxes": 10107.9,
    "new_taxes_no_override": 10544.56,
    "override_total_1": 10843.76,
    "override_increase_1": 299.19
  },
  {
    "#": "149 Beaconsfield Rd, Unit B-G & G-11 (225-65-07)",
    "$": 940700,
    "address": "149 Beaconsfield Rd, Unit B-G & G-11",
    "parcel_id": "225-65-07",
    "owner1": "KIRSCH LIFE ESTATE, BRUNO & LUCY",
    "owner2": "",
    "current_taxes": 5997.83,
    "new_taxes_no_override": 6256.94,
    "override_total_1": 6434.47,
    "override_increase_1": 177.54
  },
  {
    "#": "150 Beaconsfield Rd, Unit 1 & P46 (226-02-34)",
    "$": 471100,
    "address": "150 Beaconsfield Rd, Unit 1 & P46",
    "parcel_id": "226-02-34",
    "owner1": "AMIRIAN, INNA",
    "owner2": "",
    "current_taxes": 4824.06,
    "new_taxes_no_override": 5032.46,
    "override_total_1": 5175.25,
    "override_increase_1": 142.79
  },
  {
    "#": "150 Beaconsfield Rd, Unit 2 (226-02-35)",
    "$": 606900,
    "address": "150 Beaconsfield Rd, Unit 2",
    "parcel_id": "226-02-35",
    "owner1": "BARKIN TRS, JOYCE F",
    "owner2": "",
    "current_taxes": 6214.66,
    "new_taxes_no_override": 6483.13,
    "override_total_1": 6667.09,
    "override_increase_1": 183.95
  },
  {
    "#": "150 Beaconsfield Rd, Unit 3 & P17 (226-02-36)",
    "$": 520300,
    "address": "150 Beaconsfield Rd, Unit 3 & P17",
    "parcel_id": "226-02-36",
    "owner1": "KIM, SOOJUNG & KYUNGJUNG",
    "owner2": "",
    "current_taxes": 5327.87,
    "new_taxes_no_override": 5558.03,
    "override_total_1": 5715.74,
    "override_increase_1": 157.7
  },
  {
    "#": "150 Beaconsfield Rd, Unit 4 & P14 (226-02-37)",
    "$": 512100,
    "address": "150 Beaconsfield Rd, Unit 4 & P14",
    "parcel_id": "226-02-37",
    "owner1": "BEIT-ARIE TRS, OREN",
    "owner2": "SHLONSKY, NAAMA BEIT-ARIE",
    "current_taxes": 5243.9,
    "new_taxes_no_override": 5470.44,
    "override_total_1": 5625.66,
    "override_increase_1": 155.22
  },
  {
    "#": "150 Beaconsfield Rd, Unit 5 (226-02-38)",
    "$": 479900,
    "address": "150 Beaconsfield Rd, Unit 5",
    "parcel_id": "226-02-38",
    "owner1": "TERRA FIRMA-YY LLC",
    "owner2": "",
    "current_taxes": 4914.18,
    "new_taxes_no_override": 5126.47,
    "override_total_1": 5271.93,
    "override_increase_1": 145.46
  },
  {
    "#": "150 Beaconsfield Rd, Unit 6 & P18 (226-02-39)",
    "$": 563200,
    "address": "150 Beaconsfield Rd, Unit 6 & P18",
    "parcel_id": "226-02-39",
    "owner1": "CHEN, YUANFANG",
    "owner2": "",
    "current_taxes": 5767.17,
    "new_taxes_no_override": 6016.31,
    "override_total_1": 6187.02,
    "override_increase_1": 170.71
  },
  {
    "#": "150 Beaconsfield Rd, Unit T1 (226-02-32)",
    "$": 400600,
    "address": "150 Beaconsfield Rd, Unit T1",
    "parcel_id": "226-02-32",
    "owner1": "TORRES, LEONARDO J",
    "owner2": "",
    "current_taxes": 4102.14,
    "new_taxes_no_override": 4279.35,
    "override_total_1": 4400.78,
    "override_increase_1": 121.42
  },
  {
    "#": "150 Beaconsfield Rd, Unit T2 & G11 (226-02-33)",
    "$": 493100,
    "address": "150 Beaconsfield Rd, Unit T2 & G11",
    "parcel_id": "226-02-33",
    "owner1": "ESHRAGHI, ARASH",
    "owner2": "",
    "current_taxes": 1414.41,
    "new_taxes_no_override": 1475.51,
    "override_total_1": 1517.38,
    "override_increase_1": 41.87
  },
  {
    "#": "6 Beals St, Unit 1 P-A (051-51-01)",
    "$": 753300,
    "address": "6 Beals St, Unit 1 P-A",
    "parcel_id": "051-51-01",
    "owner1": "AMERICAN PROSPERITY, REALTY LLC",
    "owner2": "C/O DANNIN MANAGEMENT CORP",
    "current_taxes": 7713.79,
    "new_taxes_no_override": 8047.03,
    "override_total_1": 8275.35,
    "override_increase_1": 228.33
  },
  {
    "#": "6 Beals St, Unit 2 & P-B (051-51-02)",
    "$": 817500,
    "address": "6 Beals St, Unit 2 & P-B",
    "parcel_id": "051-51-02",
    "owner1": "AMERICAN PROSPERITY, REALTY LLC",
    "owner2": "C/O DANNIN MANAGEMENT CORP",
    "current_taxes": 8371.2,
    "new_taxes_no_override": 8732.84,
    "override_total_1": 8980.62,
    "override_increase_1": 247.79
  },
  {
    "#": "6 Beals St, Unit 3 & P-C (051-51-03)",
    "$": 864500,
    "address": "6 Beals St, Unit 3 & P-C",
    "parcel_id": "051-51-03",
    "owner1": "AMERICAN PROSPERITY, REALTY LLC",
    "owner2": "C/O DANNIN MANAGEMENT CORP",
    "current_taxes": 8852.48,
    "new_taxes_no_override": 9234.91,
    "override_total_1": 9496.94,
    "override_increase_1": 262.03
  },
  {
    "#": "7 Beals St, Unit 1 P1 P4 (050-04-03)",
    "$": 1244100,
    "address": "7 Beals St, Unit 1 P1 P4",
    "parcel_id": "050-04-03",
    "owner1": "WEINTRAUB TRS, BENJAMIN & JILL",
    "owner2": "",
    "current_taxes": 9104.65,
    "new_taxes_no_override": 9497.97,
    "override_total_1": 9767.47,
    "override_increase_1": 269.5
  },
  {
    "#": "7 Beals St, Unit 2 & P2 P5 (050-04-01)",
    "$": 1178800,
    "address": "7 Beals St, Unit 2 & P2 P5",
    "parcel_id": "050-04-01",
    "owner1": "STRASSMANN, STEVE",
    "owner2": "",
    "current_taxes": 12070.91,
    "new_taxes_no_override": 12592.37,
    "override_total_1": 12949.67,
    "override_increase_1": 357.3
  },
  {
    "#": "7 Beals St, Unit 3 & P3 P6 (050-04-02)",
    "$": 1209700,
    "address": "7 Beals St, Unit 3 & P3 P6",
    "parcel_id": "050-04-02",
    "owner1": "STRASSMANN, DAPHNE",
    "owner2": "",
    "current_taxes": 8752.39,
    "new_taxes_no_override": 9130.49,
    "override_total_1": 9389.56,
    "override_increase_1": 259.07
  },
  {
    "#": "10 Beals St (051-50-00)",
    "$": 4946700,
    "address": "10 Beals St",
    "parcel_id": "051-50-00",
    "owner1": "OAK HILL PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 50654.21,
    "new_taxes_no_override": 52842.47,
    "override_total_1": 54341.84,
    "override_increase_1": 1499.36
  },
  {
    "#": "15 Beals St (050-05-00)",
    "$": 2802800,
    "address": "15 Beals St",
    "parcel_id": "050-05-00",
    "owner1": "GELMAN, RITA S",
    "owner2": "VULAKH, INNA",
    "current_taxes": 25065.74,
    "new_taxes_no_override": 26148.58,
    "override_total_1": 26890.53,
    "override_increase_1": 741.95
  },
  {
    "#": "16 Beals St (051-49-00)",
    "$": 2321700,
    "address": "16 Beals St",
    "parcel_id": "051-49-00",
    "owner1": "BOLES TRS, KATHERINE C",
    "owner2": "BRAWER, BARNEY J",
    "current_taxes": 20139.27,
    "new_taxes_no_override": 21009.29,
    "override_total_1": 21605.41,
    "override_increase_1": 596.12
  },
  {
    "#": "19 Beals St (050-06-00)",
    "$": 2675400,
    "address": "19 Beals St",
    "parcel_id": "050-06-00",
    "owner1": "COWENHOVEN, GARRET P & ANNA G",
    "owner2": "",
    "current_taxes": 23761.16,
    "new_taxes_no_override": 24787.64,
    "override_total_1": 25490.97,
    "override_increase_1": 703.33
  },
  {
    "#": "22 Beals St (051-48-00)",
    "$": 2122100,
    "address": "22 Beals St",
    "parcel_id": "051-48-00",
    "owner1": "RATHI TRS, PRABHULAL J & DRUPADI P",
    "owner2": "",
    "current_taxes": 18095.37,
    "new_taxes_no_override": 18877.09,
    "override_total_1": 19412.71,
    "override_increase_1": 535.62
  },
  {
    "#": "25 Beals St (050-07-00)",
    "$": 2357700,
    "address": "25 Beals St",
    "parcel_id": "050-07-00",
    "owner1": "LEVEY, DEBORAH A",
    "owner2": "WEINBERG, CRISPIN B",
    "current_taxes": 20507.91,
    "new_taxes_no_override": 21393.85,
    "override_total_1": 22000.89,
    "override_increase_1": 607.03
  },
  {
    "#": "26 Beals St, Unit 1 & Pk Sp (051-47-01)",
    "$": 1246900,
    "address": "26 Beals St, Unit 1 & Pk Sp",
    "parcel_id": "051-47-01",
    "owner1": "26-28 BEALS STREET LLC",
    "owner2": "",
    "current_taxes": 12768.26,
    "new_taxes_no_override": 13319.85,
    "override_total_1": 13697.79,
    "override_increase_1": 377.94
  },
  {
    "#": "26 Beals St, Unit 2 & 1G 1P (051-47-02)",
    "$": 2136200,
    "address": "26 Beals St, Unit 2 & 1G 1P",
    "parcel_id": "051-47-02",
    "owner1": "CASTRO, DANIEL & KIMBERLY",
    "owner2": "",
    "current_taxes": 21874.69,
    "new_taxes_no_override": 22819.68,
    "override_total_1": 23467.17,
    "override_increase_1": 647.49
  },
  {
    "#": "29 Beals St (050-08-00)",
    "$": 2264600,
    "address": "29 Beals St",
    "parcel_id": "050-08-00",
    "owner1": "WEST, ANN F",
    "owner2": "",
    "current_taxes": 19554.57,
    "new_taxes_no_override": 20399.33,
    "override_total_1": 20978.14,
    "override_increase_1": 578.82
  },
  {
    "#": "30 Beals St (051-46-00)",
    "$": 3726500,
    "address": "30 Beals St",
    "parcel_id": "051-46-00",
    "owner1": "BHIDE, HEMANT ADITYA & POOJA BHAGAT",
    "owner2": "",
    "current_taxes": 34524.43,
    "new_taxes_no_override": 36015.89,
    "override_total_1": 37037.81,
    "override_increase_1": 1021.92
  },
  {
    "#": "34 Beals St (051-45-00)",
    "$": 2346200,
    "address": "34 Beals St",
    "parcel_id": "051-45-00",
    "owner1": "ERICSON, BENJAMIN J",
    "owner2": "DYAL-CHAND, RASHMI",
    "current_taxes": 20390.15,
    "new_taxes_no_override": 21271.0,
    "override_total_1": 21874.55,
    "override_increase_1": 603.55
  },
  {
    "#": "35 Beals St (050-09-00)",
    "$": 2702900,
    "address": "35 Beals St",
    "parcel_id": "050-09-00",
    "owner1": "YEE TRS, VINCENT & CAMELLIA H",
    "owner2": "",
    "current_taxes": 24042.76,
    "new_taxes_no_override": 25081.41,
    "override_total_1": 25793.07,
    "override_increase_1": 711.67
  },
  {
    "#": "36 Beals St (051-44-00)",
    "$": 2170300,
    "address": "36 Beals St",
    "parcel_id": "051-44-00",
    "owner1": "BROOKS, DOUGLAS M & AVIVA A",
    "owner2": "",
    "current_taxes": 18588.94,
    "new_taxes_no_override": 19391.98,
    "override_total_1": 19942.21,
    "override_increase_1": 550.23
  },
  {
    "#": "38 Beals St (051-43-00)",
    "$": 2205600,
    "address": "38 Beals St",
    "parcel_id": "051-43-00",
    "owner1": "PALMER, MATTHEW B",
    "owner2": "ARRIGONI, ELDA",
    "current_taxes": 18950.41,
    "new_taxes_no_override": 19769.07,
    "override_total_1": 20330.0,
    "override_increase_1": 560.93
  },
  {
    "#": "39 Beals St (050-10-00)",
    "$": 2819800,
    "address": "39 Beals St",
    "parcel_id": "050-10-00",
    "owner1": "WOJCIK, TRS, MICHAEL A & JANE H",
    "owner2": "",
    "current_taxes": 25239.82,
    "new_taxes_no_override": 26330.18,
    "override_total_1": 27077.28,
    "override_increase_1": 747.1
  },
  {
    "#": "40 Beals St (051-42-00)",
    "$": 1969400,
    "address": "40 Beals St",
    "parcel_id": "051-42-00",
    "owner1": "40 BEALS LLC",
    "owner2": "",
    "current_taxes": 20166.66,
    "new_taxes_no_override": 21037.86,
    "override_total_1": 21634.79,
    "override_increase_1": 596.93
  },
  {
    "#": "43 Beals St (050-11-00)",
    "$": 2670400,
    "address": "43 Beals St",
    "parcel_id": "050-11-00",
    "owner1": "FUNG TRS, ARCHON & DEBORAH D",
    "owner2": "",
    "current_taxes": 23709.96,
    "new_taxes_no_override": 24734.23,
    "override_total_1": 25436.05,
    "override_increase_1": 701.81
  },
  {
    "#": "44 Beals St (051-41-00)",
    "$": 2753600,
    "address": "44 Beals St",
    "parcel_id": "051-41-00",
    "owner1": "MEHLMAN, JEFFREY",
    "owner2": "BORINSKY, ALICIA",
    "current_taxes": 24561.93,
    "new_taxes_no_override": 25623.01,
    "override_total_1": 26350.04,
    "override_increase_1": 727.03
  },
  {
    "#": "49 Beals St (050-12-03)",
    "$": 2569900,
    "address": "49 Beals St",
    "parcel_id": "050-12-03",
    "owner1": "MORA TRS, ELIZABETH",
    "owner2": "KANDARIAN, SUSAN C",
    "current_taxes": 22680.84,
    "new_taxes_no_override": 23660.65,
    "override_total_1": 24332.01,
    "override_increase_1": 671.35
  },
  {
    "#": "50 Beals St (051-40-00)",
    "$": 2007200,
    "address": "50 Beals St",
    "parcel_id": "051-40-00",
    "owner1": "GLUZ, ARNOLD & ANNETTE",
    "owner2": "ARONOVITCH, AVIVA A & DOV B",
    "current_taxes": 20553.73,
    "new_taxes_no_override": 21441.65,
    "override_total_1": 22050.04,
    "override_increase_1": 608.39
  },
  {
    "#": "51 Beals St (050-13-00)",
    "$": 2299000,
    "address": "51 Beals St",
    "parcel_id": "050-13-00",
    "owner1": "51-57 BEALS STREET LLC",
    "owner2": "C/O PINE STREET INN INC",
    "current_taxes": 23541.76,
    "new_taxes_no_override": 24558.76,
    "override_total_1": 25255.6,
    "override_increase_1": 696.84
  },
  {
    "#": "54 Beals St (051-39-01)",
    "$": 1694700,
    "address": "54 Beals St",
    "parcel_id": "051-39-01",
    "owner1": "TAYLOR TR, ALLEN",
    "owner2": "",
    "current_taxes": 13718.79,
    "new_taxes_no_override": 14311.44,
    "override_total_1": 14717.52,
    "override_increase_1": 406.08
  },
  {
    "#": "55 Beals St (050-14-00)",
    "$": 1720000,
    "address": "55 Beals St",
    "parcel_id": "050-14-00",
    "owner1": "51-57 BEALS STREET LLC",
    "owner2": "C/O PINE STREET INN INC",
    "current_taxes": 17612.8,
    "new_taxes_no_override": 18373.67,
    "override_total_1": 18895.01,
    "override_increase_1": 521.34
  },
  {
    "#": "56 Beals St (051-39-00)",
    "$": 2005400,
    "address": "56 Beals St",
    "parcel_id": "051-39-00",
    "owner1": "QUINONEZ, LUIS GUILLERMO",
    "owner2": "BROWN, MORGAN LEIGH",
    "current_taxes": 16900.36,
    "new_taxes_no_override": 17630.46,
    "override_total_1": 18130.71,
    "override_increase_1": 500.25
  },
  {
    "#": "58 Beals St (051-38-00)",
    "$": 2574800,
    "address": "58 Beals St",
    "parcel_id": "051-38-00",
    "owner1": "HABER, ANDREW T & ANN I",
    "owner2": "",
    "current_taxes": 22731.02,
    "new_taxes_no_override": 23713.0,
    "override_total_1": 24385.84,
    "override_increase_1": 672.84
  },
  {
    "#": "60 Beals St (051-37-00)",
    "$": 2299800,
    "address": "60 Beals St",
    "parcel_id": "051-37-00",
    "owner1": "STONE, ERIC",
    "owner2": "POST, SARAH",
    "current_taxes": 19915.02,
    "new_taxes_no_override": 20775.35,
    "override_total_1": 21364.83,
    "override_increase_1": 589.48
  },
  {
    "#": "63 Beals St (050-15-03)",
    "$": 2372600,
    "address": "63 Beals St",
    "parcel_id": "050-15-03",
    "owner1": "POOLE, DAVID B",
    "owner2": "CAVALLARO, ROSANNA",
    "current_taxes": 20660.49,
    "new_taxes_no_override": 21553.02,
    "override_total_1": 22164.57,
    "override_increase_1": 611.55
  },
  {
    "#": "66 Beals St (051-36-00)",
    "$": 2373500,
    "address": "66 Beals St",
    "parcel_id": "051-36-00",
    "owner1": "COVEN, MARK S",
    "owner2": "LEVENSON, JUDY",
    "current_taxes": 20669.71,
    "new_taxes_no_override": 21562.64,
    "override_total_1": 22174.46,
    "override_increase_1": 611.82
  },
  {
    "#": "67 Beals St (050-16-00)",
    "$": 2115200,
    "address": "67 Beals St",
    "parcel_id": "050-16-00",
    "owner1": "DEUTSCH, STEPHEN",
    "owner2": "SIEVER, ELLEN",
    "current_taxes": 18024.71,
    "new_taxes_no_override": 18803.38,
    "override_total_1": 19336.91,
    "override_increase_1": 533.53
  },
  {
    "#": "70 Beals St (051-35-00)",
    "$": 2001300,
    "address": "70 Beals St",
    "parcel_id": "051-35-00",
    "owner1": "IGUCHI, TRS, MINEKO",
    "owner2": "",
    "current_taxes": 16858.38,
    "new_taxes_no_override": 17586.66,
    "override_total_1": 18085.67,
    "override_increase_1": 499.01
  },
  {
    "#": "73 Beals St (050-17-00)",
    "$": 2925100,
    "address": "73 Beals St",
    "parcel_id": "050-17-00",
    "owner1": "SANCHEZ-DAHL, MAGDALENA & ROBERTO D",
    "owner2": "",
    "current_taxes": 26318.09,
    "new_taxes_no_override": 27455.03,
    "override_total_1": 28234.05,
    "override_increase_1": 779.02
  },
  {
    "#": "74 Beals St (051-34-00)",
    "$": 2477100,
    "address": "74 Beals St",
    "parcel_id": "051-34-00",
    "owner1": "KLEINMAN, ELISSA C",
    "owner2": "LEJEUNE, SIMON MW",
    "current_taxes": 21730.57,
    "new_taxes_no_override": 22669.33,
    "override_total_1": 23312.56,
    "override_increase_1": 643.22
  },
  {
    "#": "77 Beals St, Unit 3 (050-18-02)",
    "$": 1326700,
    "address": "77 Beals St, Unit 3",
    "parcel_id": "050-18-02",
    "owner1": "ROTH TR, ROBIN L",
    "owner2": "",
    "current_taxes": 9950.47,
    "new_taxes_no_override": 10380.33,
    "override_total_1": 10674.86,
    "override_increase_1": 294.53
  },
  {
    "#": "79 Beals St, Unit 1 & P79-1 (050-18-03)",
    "$": 788000,
    "address": "79 Beals St, Unit 1 & P79-1",
    "parcel_id": "050-18-03",
    "owner1": "RASMUSSEN TRS, ROBERT A",
    "owner2": "MENZL , SYLVIA N",
    "current_taxes": 4434.19,
    "new_taxes_no_override": 4625.75,
    "override_total_1": 4757.0,
    "override_increase_1": 131.25
  },
  {
    "#": "79 Beals St, Unit 2 & P79-2 (050-18-01)",
    "$": 1040600,
    "address": "79 Beals St, Unit 2 & P79-2",
    "parcel_id": "050-18-01",
    "owner1": "LEVY , PHILIP T",
    "owner2": "",
    "current_taxes": 7020.81,
    "new_taxes_no_override": 7324.11,
    "override_total_1": 7531.92,
    "override_increase_1": 207.82
  },
  {
    "#": "80 Beals St (051-33-00)",
    "$": 2493700,
    "address": "80 Beals St",
    "parcel_id": "051-33-00",
    "owner1": "MILSTEIN, JOSEPH B & SUSAN E",
    "owner2": "",
    "current_taxes": 21900.55,
    "new_taxes_no_override": 22846.65,
    "override_total_1": 23494.91,
    "override_increase_1": 648.26
  },
  {
    "#": "83 Beals St (050-19-00)",
    "$": 2037600,
    "address": "83 Beals St",
    "parcel_id": "050-19-00",
    "owner1": "UNITED STATES OF AMERICA",
    "owner2": "C/O SECR OF THE INTERIOR",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "84 Beals St, Unit 1 (051-32-01)",
    "$": 1563700,
    "address": "84 Beals St, Unit 1",
    "parcel_id": "051-32-01",
    "owner1": "PARTHASARATHY, KAUSHIK SARANATH",
    "owner2": "SESHADRI, ASWINI KADAMBI",
    "current_taxes": 12377.35,
    "new_taxes_no_override": 12912.05,
    "override_total_1": 13278.42,
    "override_increase_1": 366.37
  },
  {
    "#": "84 Beals St, Unit 2 (051-32-02)",
    "$": 1837000,
    "address": "84 Beals St, Unit 2",
    "parcel_id": "051-32-02",
    "owner1": "NAAMAD, AMNON & RACHEL",
    "owner2": "",
    "current_taxes": 15175.95,
    "new_taxes_no_override": 15831.55,
    "override_total_1": 16280.76,
    "override_increase_1": 449.21
  },
  {
    "#": "85 Beals St (050-20-00)",
    "$": 1766200,
    "address": "85 Beals St",
    "parcel_id": "050-20-00",
    "owner1": "JAGAROO, VINOTH",
    "owner2": "",
    "current_taxes": 18085.89,
    "new_taxes_no_override": 18867.2,
    "override_total_1": 19402.54,
    "override_increase_1": 535.34
  },
  {
    "#": "88 Beals St, Unit 1 (051-31-01)",
    "$": 1538000,
    "address": "88 Beals St, Unit 1",
    "parcel_id": "051-31-01",
    "owner1": "KLAWITER, ERIC C",
    "owner2": "ANDERSON, ERIKA",
    "current_taxes": 12114.19,
    "new_taxes_no_override": 12637.52,
    "override_total_1": 12996.1,
    "override_increase_1": 358.58
  },
  {
    "#": "88 Beals St, Unit 2 (051-31-02)",
    "$": 1687200,
    "address": "88 Beals St, Unit 2",
    "parcel_id": "051-31-02",
    "owner1": "LEVITSKY, STEVEN R",
    "owner2": "MINEO, LIZ G",
    "current_taxes": 13641.99,
    "new_taxes_no_override": 14231.32,
    "override_total_1": 14635.13,
    "override_increase_1": 403.8
  },
  {
    "#": "91 Beals St, Unit 1 (050-21-02)",
    "$": 1156300,
    "address": "91 Beals St, Unit 1",
    "parcel_id": "050-21-02",
    "owner1": "BELSON, PETER S",
    "owner2": "SCHAFFEL, M L",
    "current_taxes": 8205.58,
    "new_taxes_no_override": 8560.06,
    "override_total_1": 8802.95,
    "override_increase_1": 242.89
  },
  {
    "#": "91 Beals St, Unit 2 (050-21-01)",
    "$": 1200800,
    "address": "91 Beals St, Unit 2",
    "parcel_id": "050-21-01",
    "owner1": "VOSS TRS, JOHN P & NIRA EFRAT",
    "owner2": "",
    "current_taxes": 8661.26,
    "new_taxes_no_override": 9035.43,
    "override_total_1": 9291.8,
    "override_increase_1": 256.37
  },
  {
    "#": "92 Beals St (051-30-00)",
    "$": 2243400,
    "address": "92 Beals St",
    "parcel_id": "051-30-00",
    "owner1": "STOLOW TRS, LOREN S",
    "owner2": "HEINEMAN , MITCHELL C",
    "current_taxes": 19337.48,
    "new_taxes_no_override": 20172.86,
    "override_total_1": 20745.25,
    "override_increase_1": 572.39
  },
  {
    "#": "95 Beals St, Unit 1 (050-22-01)",
    "$": 2195000,
    "address": "95 Beals St, Unit 1",
    "parcel_id": "050-22-01",
    "owner1": "FEIBELMAN, ANDREW S & ELAINE L B",
    "owner2": "",
    "current_taxes": 18841.87,
    "new_taxes_no_override": 19655.84,
    "override_total_1": 20213.56,
    "override_increase_1": 557.72
  },
  {
    "#": "95 Beals St, Unit 2 (050-22-02)",
    "$": 2575000,
    "address": "95 Beals St, Unit 2",
    "parcel_id": "050-22-02",
    "owner1": "HAHN-FOURNIER TR, MARTHA",
    "owner2": "",
    "current_taxes": 22733.07,
    "new_taxes_no_override": 23715.14,
    "override_total_1": 24388.04,
    "override_increase_1": 672.9
  },
  {
    "#": "96 Beals St, Unit 1 & Pk A (051-29-01)",
    "$": 2001300,
    "address": "96 Beals St, Unit 1 & Pk A",
    "parcel_id": "051-29-01",
    "owner1": "ZITTING, JUKKA & KIRSI-MARJA",
    "owner2": "",
    "current_taxes": 16858.38,
    "new_taxes_no_override": 17586.66,
    "override_total_1": 18085.67,
    "override_increase_1": 499.01
  },
  {
    "#": "96 Beals St, Unit 2 & Pk B (051-29-02)",
    "$": 2458100,
    "address": "96 Beals St, Unit 2 & Pk B",
    "parcel_id": "051-29-02",
    "owner1": "NAVARRO, FRANCISCO",
    "owner2": "BOLLMAN, BROOKE",
    "current_taxes": 21536.01,
    "new_taxes_no_override": 22466.37,
    "override_total_1": 23103.83,
    "override_increase_1": 637.47
  },
  {
    "#": "99 Beals St (050-23-00)",
    "$": 2143100,
    "address": "99 Beals St",
    "parcel_id": "050-23-00",
    "owner1": "GREENE TR, B SUSAN",
    "owner2": "",
    "current_taxes": 21945.34,
    "new_taxes_no_override": 22893.38,
    "override_total_1": 23542.96,
    "override_increase_1": 649.58
  },
  {
    "#": "100 Beals St (051-28-00)",
    "$": 2334300,
    "address": "100 Beals St",
    "parcel_id": "051-28-00",
    "owner1": "SMALL, SEYMOUR",
    "owner2": "RACHLIN, JOAN",
    "current_taxes": 23903.23,
    "new_taxes_no_override": 24935.85,
    "override_total_1": 25643.39,
    "override_increase_1": 707.54
  },
  {
    "#": "106 Beals St, Unit 1 (051-27-01)",
    "$": 707200,
    "address": "106 Beals St, Unit 1",
    "parcel_id": "051-27-01",
    "owner1": "SPANEAS ET AL, LESLIE D",
    "owner2": "LOECHLER, E L",
    "current_taxes": 7241.73,
    "new_taxes_no_override": 7554.57,
    "override_total_1": 7768.93,
    "override_increase_1": 214.36
  },
  {
    "#": "106 Beals St, Unit 3 (051-27-03)",
    "$": 1141400,
    "address": "106 Beals St, Unit 3",
    "parcel_id": "051-27-03",
    "owner1": "SPANEAS ET AL, LESLIE D",
    "owner2": "LOECHLER, E L",
    "current_taxes": 8053.0,
    "new_taxes_no_override": 8400.89,
    "override_total_1": 8639.26,
    "override_increase_1": 238.37
  },
  {
    "#": "112 Beals St, Unit 2 &  P3-4 (052-10-06)",
    "$": 1507100,
    "address": "112 Beals St, Unit 2 &  P3-4",
    "parcel_id": "052-10-06",
    "owner1": "ANTONY, ELIZABETH & BRENT",
    "owner2": "",
    "current_taxes": 11797.77,
    "new_taxes_no_override": 12307.43,
    "override_total_1": 12656.65,
    "override_increase_1": 349.21
  },
  {
    "#": "10 Beech Rd (120-18-00)",
    "$": 5161100,
    "address": "10 Beech Rd",
    "parcel_id": "120-18-00",
    "owner1": "SCHOEN, ROBERT J & CATHLEEN A",
    "owner2": "",
    "current_taxes": 49214.73,
    "new_taxes_no_override": 51340.81,
    "override_total_1": 52797.56,
    "override_increase_1": 1456.76
  },
  {
    "#": "16 Beech Rd (120-17-00)",
    "$": 4026100,
    "address": "16 Beech Rd",
    "parcel_id": "120-17-00",
    "owner1": "SILER, SANDRA M",
    "owner2": "",
    "current_taxes": 37592.33,
    "new_taxes_no_override": 39216.32,
    "override_total_1": 40329.05,
    "override_increase_1": 1112.73
  },
  {
    "#": "26 Beech Rd (120-16-00)",
    "$": 9504400,
    "address": "26 Beech Rd",
    "parcel_id": "120-16-00",
    "owner1": "KITTLER TR, JAMES M",
    "owner2": "C/O JDJ FAMILY OFFICE SERVICES-K BOLTON",
    "current_taxes": 97325.06,
    "new_taxes_no_override": 101529.5,
    "override_total_1": 104410.32,
    "override_increase_1": 2880.82
  },
  {
    "#": "34 Beech Rd (120-15-00)",
    "$": 4911200,
    "address": "34 Beech Rd",
    "parcel_id": "120-15-00",
    "owner1": "HACKEL, MICHAEL R",
    "owner2": "REMIS, DANIELLE F",
    "current_taxes": 46655.75,
    "new_taxes_no_override": 48671.28,
    "override_total_1": 50052.29,
    "override_increase_1": 1381.01
  },
  {
    "#": "42 Beech Rd (120-14-00)",
    "$": 5240400,
    "address": "42 Beech Rd",
    "parcel_id": "120-14-00",
    "owner1": "METRAL, MAX E & ALEXANDRA",
    "owner2": "",
    "current_taxes": 53661.7,
    "new_taxes_no_override": 55979.89,
    "override_total_1": 57568.27,
    "override_increase_1": 1588.39
  },
  {
    "#": "48 Beech Rd (120-13-00)",
    "$": 4419500,
    "address": "48 Beech Rd",
    "parcel_id": "120-13-00",
    "owner1": "48 BEECH ROAD LLC",
    "owner2": "",
    "current_taxes": 41620.75,
    "new_taxes_no_override": 43418.77,
    "override_total_1": 44650.74,
    "override_increase_1": 1231.97
  },
  {
    "#": "60 Beech Rd (120-12-00)",
    "$": 4641500,
    "address": "60 Beech Rd",
    "parcel_id": "120-12-00",
    "owner1": "DIAMOND, JEFFREY A",
    "owner2": "NADLER, ELLEN A",
    "current_taxes": 43894.03,
    "new_taxes_no_override": 45790.25,
    "override_total_1": 47089.52,
    "override_increase_1": 1299.26
  },
  {
    "#": "62 Beech Rd (120-11-00)",
    "$": 6996600,
    "address": "62 Beech Rd",
    "parcel_id": "120-11-00",
    "owner1": "JACOB, JONAH",
    "owner2": "",
    "current_taxes": 68010.25,
    "new_taxes_no_override": 70948.29,
    "override_total_1": 72961.4,
    "override_increase_1": 2013.1
  },
  {
    "#": "9 Beecher Rd (251-08-01)",
    "$": 5812600,
    "address": "9 Beecher Rd",
    "parcel_id": "251-08-01",
    "owner1": "KING TR, GARY",
    "owner2": "",
    "current_taxes": 55886.09,
    "new_taxes_no_override": 58300.37,
    "override_total_1": 59954.6,
    "override_increase_1": 1654.23
  },
  {
    "#": "24 Beecher Rd (251-06-00)",
    "$": 3087200,
    "address": "24 Beecher Rd",
    "parcel_id": "251-06-00",
    "owner1": "DADGAR TRS, ARDESHIR & MAHASTI N",
    "owner2": "",
    "current_taxes": 27977.99,
    "new_taxes_no_override": 29186.64,
    "override_total_1": 30014.79,
    "override_increase_1": 828.15
  },
  {
    "#": "6 Bellingham Dr (369-03-00)",
    "$": 1387000,
    "address": "6 Bellingham Dr",
    "parcel_id": "369-03-00",
    "owner1": "SHAO, HUACHUAN",
    "owner2": "WOLENSKI, FRANCIS",
    "current_taxes": 10567.95,
    "new_taxes_no_override": 11024.49,
    "override_total_1": 11337.3,
    "override_increase_1": 312.81
  },
  {
    "#": "12 Bellingham Dr (369-02-00)",
    "$": 2509500,
    "address": "12 Bellingham Dr",
    "parcel_id": "369-02-00",
    "owner1": "SPECTOR, JONATHAN",
    "owner2": "LIPTON, LIANNA",
    "current_taxes": 22062.35,
    "new_taxes_no_override": 23015.44,
    "override_total_1": 23668.49,
    "override_increase_1": 653.05
  },
  {
    "#": "15 Bellingham Dr (368-06-00)",
    "$": 1267700,
    "address": "15 Bellingham Dr",
    "parcel_id": "368-06-00",
    "owner1": "KAMENETSKY TRS, GREGORY A & ELENA M",
    "owner2": "",
    "current_taxes": 9346.31,
    "new_taxes_no_override": 9750.07,
    "override_total_1": 10026.72,
    "override_increase_1": 276.65
  },
  {
    "#": "18 Bellingham Dr (369-01-00)",
    "$": 1671900,
    "address": "18 Bellingham Dr",
    "parcel_id": "369-01-00",
    "owner1": "FRENKEL, VADIM & IRINA",
    "owner2": "",
    "current_taxes": 13485.32,
    "new_taxes_no_override": 14067.89,
    "override_total_1": 14467.05,
    "override_increase_1": 399.17
  },
  {
    "#": "21 Bellingham Dr (368-07-00)",
    "$": 1431700,
    "address": "21 Bellingham Dr",
    "parcel_id": "368-07-00",
    "owner1": "SIDELL TR, PAMELA",
    "owner2": "",
    "current_taxes": 11025.67,
    "new_taxes_no_override": 11501.98,
    "override_total_1": 11828.34,
    "override_increase_1": 326.36
  },
  {
    "#": "22 Bellingham Dr (369-01-01)",
    "$": 0,
    "address": "22 Bellingham Dr",
    "parcel_id": "369-01-01",
    "owner1": "GLASSMAN, JOSEPH M & ANNIE M",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "25 Bellingham Dr (370-29-01)",
    "$": 1598300,
    "address": "25 Bellingham Dr",
    "parcel_id": "370-29-01",
    "owner1": "BARSHAK, JASON & MIRIAM BARON",
    "owner2": "",
    "current_taxes": 12731.66,
    "new_taxes_no_override": 13281.67,
    "override_total_1": 13658.52,
    "override_increase_1": 376.86
  },
  {
    "#": "10 Bellingham Rd (369-13-00)",
    "$": 2280100,
    "address": "10 Bellingham Rd",
    "parcel_id": "369-13-00",
    "owner1": "SONG, CHENHUI",
    "owner2": "GUAN, BEI",
    "current_taxes": 19713.29,
    "new_taxes_no_override": 20564.9,
    "override_total_1": 21148.42,
    "override_increase_1": 583.51
  },
  {
    "#": "11 Bellingham Rd (371-20-00)",
    "$": 2004600,
    "address": "11 Bellingham Rd",
    "parcel_id": "371-20-00",
    "owner1": "FAT, IULIU C & IOANA",
    "owner2": "",
    "current_taxes": 16892.17,
    "new_taxes_no_override": 17621.91,
    "override_total_1": 18121.92,
    "override_increase_1": 500.01
  },
  {
    "#": "18 Bellingham Rd (369-12-00)",
    "$": 2102500,
    "address": "18 Bellingham Rd",
    "parcel_id": "369-12-00",
    "owner1": "KHORASANI TRS, RAMIN",
    "owner2": "BOILEAU, NATHALIE",
    "current_taxes": 17894.67,
    "new_taxes_no_override": 18667.72,
    "override_total_1": 19197.4,
    "override_increase_1": 529.68
  },
  {
    "#": "19 Bellingham Rd (371-21-00)",
    "$": 2000700,
    "address": "19 Bellingham Rd",
    "parcel_id": "371-21-00",
    "owner1": "VIKTOROV, VICTOR & CARA",
    "owner2": "",
    "current_taxes": 16852.23,
    "new_taxes_no_override": 17580.25,
    "override_total_1": 18079.07,
    "override_increase_1": 498.83
  },
  {
    "#": "22 Bellingham Rd (369-11-00)",
    "$": 2045700,
    "address": "22 Bellingham Rd",
    "parcel_id": "369-11-00",
    "owner1": "DANDREA, JONATHAN KELLY",
    "owner2": "JAN, FARHANA",
    "current_taxes": 17313.03,
    "new_taxes_no_override": 18060.95,
    "override_total_1": 18573.42,
    "override_increase_1": 512.47
  },
  {
    "#": "28 Bellingham Rd (369-09-10)",
    "$": 1807600,
    "address": "28 Bellingham Rd",
    "parcel_id": "369-09-10",
    "owner1": "POUSSAINT TRS, ALVIN F",
    "owner2": "NETHERSOLE ET AL, SHARI",
    "current_taxes": 14874.89,
    "new_taxes_no_override": 15517.49,
    "override_total_1": 15957.78,
    "override_increase_1": 440.3
  },
  {
    "#": "34 Bellingham Rd (369-08-00)",
    "$": 1040400,
    "address": "34 Bellingham Rd",
    "parcel_id": "369-08-00",
    "owner1": "TEHRANCHI, KIAN MAHMOUD",
    "owner2": "LUCAS, PAIGE MEREDITH",
    "current_taxes": 10653.7,
    "new_taxes_no_override": 11113.94,
    "override_total_1": 11429.29,
    "override_increase_1": 315.35
  },
  {
    "#": "35 Bellingham Rd (371-22-23)",
    "$": 1903900,
    "address": "35 Bellingham Rd",
    "parcel_id": "371-22-23",
    "owner1": "GONCALVES, ALAIN",
    "owner2": "CORUJAN, ALINA GABRILA",
    "current_taxes": 15861.0,
    "new_taxes_no_override": 16546.2,
    "override_total_1": 17015.68,
    "override_increase_1": 469.49
  },
  {
    "#": "38 Bellingham Rd (369-07-00)",
    "$": 830500,
    "address": "38 Bellingham Rd",
    "parcel_id": "369-07-00",
    "owner1": "TEHRANCHI, KIAN MAHMOUD",
    "owner2": "LUCAS, PAIGE MEREDITH",
    "current_taxes": 8504.32,
    "new_taxes_no_override": 8871.71,
    "override_total_1": 9123.43,
    "override_increase_1": 251.73
  },
  {
    "#": "50 Bellingham Rd (369-05-06)",
    "$": 2514600,
    "address": "50 Bellingham Rd",
    "parcel_id": "369-05-06",
    "owner1": "PLACHY, TOMAS & CYNTHIA",
    "owner2": "",
    "current_taxes": 25749.5,
    "new_taxes_no_override": 26861.88,
    "override_total_1": 27624.06,
    "override_increase_1": 762.19
  },
  {
    "#": "55 Bellingham Rd (371-12-00)",
    "$": 1521600,
    "address": "55 Bellingham Rd",
    "parcel_id": "371-12-00",
    "owner1": "MIAO, JIANJUN",
    "owner2": "JIANG, QIAN",
    "current_taxes": 11946.25,
    "new_taxes_no_override": 12462.33,
    "override_total_1": 12815.94,
    "override_increase_1": 353.61
  },
  {
    "#": "59 Bellingham Rd (371-11-00)",
    "$": 2263100,
    "address": "59 Bellingham Rd",
    "parcel_id": "371-11-00",
    "owner1": "CHUNG, RAYMOND T",
    "owner2": "ABRACZINSKAS, D R",
    "current_taxes": 19539.21,
    "new_taxes_no_override": 20383.3,
    "override_total_1": 20961.66,
    "override_increase_1": 578.36
  },
  {
    "#": "60 Bellingham Rd (369-04-00)",
    "$": 1549200,
    "address": "60 Bellingham Rd",
    "parcel_id": "369-04-00",
    "owner1": "SELVIN TRS, GERALD J",
    "owner2": "ALPERT, IRIS S",
    "current_taxes": 12228.87,
    "new_taxes_no_override": 12757.16,
    "override_total_1": 13119.13,
    "override_increase_1": 361.97
  },
  {
    "#": "65 Bellingham Rd (371-10-24)",
    "$": 1808500,
    "address": "65 Bellingham Rd",
    "parcel_id": "371-10-24",
    "owner1": "GOLDSTEIN ET AL TRS, ALAN R",
    "owner2": "BROWN TR, MICHAEL D",
    "current_taxes": 18519.04,
    "new_taxes_no_override": 19319.06,
    "override_total_1": 19867.23,
    "override_increase_1": 548.16
  },
  {
    "#": "77 Bellingham Rd (371-26-00)",
    "$": 1821600,
    "address": "77 Bellingham Rd",
    "parcel_id": "371-26-00",
    "owner1": "MUKHERJEE, JOIA S",
    "owner2": "",
    "current_taxes": 15018.25,
    "new_taxes_no_override": 15667.04,
    "override_total_1": 16111.58,
    "override_increase_1": 444.54
  },
  {
    "#": "80 Bellingham Rd (368-05-00)",
    "$": 1412500,
    "address": "80 Bellingham Rd",
    "parcel_id": "368-05-00",
    "owner1": "ROUHANIFARD, SARA",
    "owner2": "WANUNU, MENI",
    "current_taxes": 10829.07,
    "new_taxes_no_override": 11296.89,
    "override_total_1": 11617.43,
    "override_increase_1": 320.54
  },
  {
    "#": "89 Bellingham Rd (371-27-28)",
    "$": 3167000,
    "address": "89 Bellingham Rd",
    "parcel_id": "371-27-28",
    "owner1": "GOLDMAN, DAVID M",
    "owner2": "",
    "current_taxes": 28795.15,
    "new_taxes_no_override": 30039.1,
    "override_total_1": 30891.44,
    "override_increase_1": 852.34
  },
  {
    "#": "90 Bellingham Rd (368-04-00)",
    "$": 1388200,
    "address": "90 Bellingham Rd",
    "parcel_id": "368-04-00",
    "owner1": "CHABAD LUBAVITCH OF CHESTNUT HILL INC",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "99 Bellingham Rd (371-01-00)",
    "$": 1317300,
    "address": "99 Bellingham Rd",
    "parcel_id": "371-01-00",
    "owner1": "HWANG, DAVID DELCHI & SARAH",
    "owner2": "",
    "current_taxes": 9854.22,
    "new_taxes_no_override": 10279.92,
    "override_total_1": 10571.61,
    "override_increase_1": 291.68
  },
  {
    "#": "100 Bellingham Rd (368-02-03)",
    "$": 1500700,
    "address": "100 Bellingham Rd",
    "parcel_id": "368-02-03",
    "owner1": "CHABAD LUBAVITCH OF CHESTNUT HILL INC",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "111 Bellingham Rd (364A-06-00)",
    "$": 1278100,
    "address": "111 Bellingham Rd",
    "parcel_id": "364A-06-00",
    "owner1": "KASHANI TRS, OMRI",
    "owner2": "USHAKOV-KASHANI, KATHY",
    "current_taxes": 9452.81,
    "new_taxes_no_override": 9861.17,
    "override_total_1": 10140.97,
    "override_increase_1": 279.8
  },
  {
    "#": "114 Bellingham Rd (364-03-00)",
    "$": 1403600,
    "address": "114 Bellingham Rd",
    "parcel_id": "364-03-00",
    "owner1": "PARK LIFE ESTATE, BARRY A & HARRIET F",
    "owner2": "",
    "current_taxes": 10737.93,
    "new_taxes_no_override": 11201.81,
    "override_total_1": 11519.65,
    "override_increase_1": 317.84
  },
  {
    "#": "120 Bellingham Rd (364-04-00)",
    "$": 1259600,
    "address": "120 Bellingham Rd",
    "parcel_id": "364-04-00",
    "owner1": "KESSLER, JOLENE K",
    "owner2": "",
    "current_taxes": 9263.37,
    "new_taxes_no_override": 9663.55,
    "override_total_1": 9937.74,
    "override_increase_1": 274.2
  },
  {
    "#": "121 Bellingham Rd (364A-07-00)",
    "$": 1194800,
    "address": "121 Bellingham Rd",
    "parcel_id": "364A-07-00",
    "owner1": "GALLAGHER, NEIL JAMES JR",
    "owner2": "MANN, NAOMI",
    "current_taxes": 8599.82,
    "new_taxes_no_override": 8971.33,
    "override_total_1": 9225.89,
    "override_increase_1": 254.55
  },
  {
    "#": "124 Bellingham Rd (364-05-00)",
    "$": 1227400,
    "address": "124 Bellingham Rd",
    "parcel_id": "364-05-00",
    "owner1": "ALTMAN TRS, ALBERT & LYNDA",
    "owner2": "",
    "current_taxes": 8933.64,
    "new_taxes_no_override": 9319.57,
    "override_total_1": 9584.01,
    "override_increase_1": 264.44
  },
  {
    "#": "128 Bellingham Rd (364-06-00)",
    "$": 1516800,
    "address": "128 Bellingham Rd",
    "parcel_id": "364-06-00",
    "owner1": "BERMAN, JANE",
    "owner2": "",
    "current_taxes": 11897.1,
    "new_taxes_no_override": 12411.05,
    "override_total_1": 12763.21,
    "override_increase_1": 352.15
  },
  {
    "#": "130 Bellingham Rd (364-07-00)",
    "$": 1807200,
    "address": "130 Bellingham Rd",
    "parcel_id": "364-07-00",
    "owner1": "HERRINGTON, SHELBY",
    "owner2": "",
    "current_taxes": 14870.79,
    "new_taxes_no_override": 15513.21,
    "override_total_1": 15953.38,
    "override_increase_1": 440.18
  },
  {
    "#": "136 Bellingham Rd (364-08-00)",
    "$": 1591400,
    "address": "136 Bellingham Rd",
    "parcel_id": "364-08-00",
    "owner1": "RODRIGUEZ, PERLA MICHELLE MACIP",
    "owner2": "HERRERA, FELIPE FLORES",
    "current_taxes": 12661.0,
    "new_taxes_no_override": 13207.96,
    "override_total_1": 13582.72,
    "override_increase_1": 374.77
  },
  {
    "#": "139 Bellingham Rd (364A-08-00)",
    "$": 1651000,
    "address": "139 Bellingham Rd",
    "parcel_id": "364A-08-00",
    "owner1": "SINGH, AMANDEEP",
    "owner2": "",
    "current_taxes": 16906.24,
    "new_taxes_no_override": 17636.59,
    "override_total_1": 18137.01,
    "override_increase_1": 500.42
  },
  {
    "#": "142 Bellingham Rd (364-09-00)",
    "$": 2596300,
    "address": "142 Bellingham Rd",
    "parcel_id": "364-09-00",
    "owner1": "SACKS, BRUCE",
    "owner2": "SUAREZ, JOELLE S & FERNANDO PEREZ",
    "current_taxes": 22951.18,
    "new_taxes_no_override": 23942.67,
    "override_total_1": 24622.03,
    "override_increase_1": 679.35
  },
  {
    "#": "145 Bellingham Rd (364A-09-00)",
    "$": 1630800,
    "address": "145 Bellingham Rd",
    "parcel_id": "364A-09-00",
    "owner1": "XU, YANG",
    "owner2": "",
    "current_taxes": 13064.46,
    "new_taxes_no_override": 13628.84,
    "override_total_1": 14015.55,
    "override_increase_1": 386.71
  },
  {
    "#": "146 Bellingham Rd (364-10-00)",
    "$": 1617200,
    "address": "146 Bellingham Rd",
    "parcel_id": "364-10-00",
    "owner1": "SULLIVAN, TIMOTHY & JENNIFER",
    "owner2": "",
    "current_taxes": 12925.19,
    "new_taxes_no_override": 13483.56,
    "override_total_1": 13866.14,
    "override_increase_1": 382.59
  },
  {
    "#": "151 Bellingham Rd (364A-10-00)",
    "$": 2290400,
    "address": "151 Bellingham Rd",
    "parcel_id": "364A-10-00",
    "owner1": "ZHOU, JUN",
    "owner2": "LIU, YANG",
    "current_taxes": 19818.76,
    "new_taxes_no_override": 20674.93,
    "override_total_1": 21261.57,
    "override_increase_1": 586.64
  },
  {
    "#": "154 Bellingham Rd (364-11-00)",
    "$": 1123000,
    "address": "154 Bellingham Rd",
    "parcel_id": "364-11-00",
    "owner1": "KOBAYASHI, RYAN L & KRISTA M",
    "owner2": "",
    "current_taxes": 7864.59,
    "new_taxes_no_override": 8204.34,
    "override_total_1": 8437.13,
    "override_increase_1": 232.79
  },
  {
    "#": "157 Bellingham Rd (364A-11-00)",
    "$": 1219200,
    "address": "157 Bellingham Rd",
    "parcel_id": "364A-11-00",
    "owner1": "ALLAIRE, ALAN & SARALYNN",
    "owner2": "",
    "current_taxes": 8849.67,
    "new_taxes_no_override": 9231.98,
    "override_total_1": 9493.93,
    "override_increase_1": 261.95
  },
  {
    "#": "160 Bellingham Rd (364-12-00)",
    "$": 2312300,
    "address": "160 Bellingham Rd",
    "parcel_id": "364-12-00",
    "owner1": "PANTEKIDIS, JOHN",
    "owner2": "LASKOU, MELETIA",
    "current_taxes": 20043.02,
    "new_taxes_no_override": 20908.88,
    "override_total_1": 21502.15,
    "override_increase_1": 593.27
  },
  {
    "#": "163 Bellingham Rd (364A-01-00)",
    "$": 1439600,
    "address": "163 Bellingham Rd",
    "parcel_id": "364A-01-00",
    "owner1": "CHABAD LUBAVITCH OF CHESTNUT HILL INC",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "9 Belmont Rd (424-02-00)",
    "$": 1605500,
    "address": "9 Belmont Rd",
    "parcel_id": "424-02-00",
    "owner1": "COYLE, EDWARD C",
    "owner2": "ODONOVAN, JAMES",
    "current_taxes": 16440.32,
    "new_taxes_no_override": 17150.54,
    "override_total_1": 17637.18,
    "override_increase_1": 486.63
  },
  {
    "#": "10 Belmont Rd (424A-08-00)",
    "$": 1184800,
    "address": "10 Belmont Rd",
    "parcel_id": "424A-08-00",
    "owner1": "KONG TRS, FAI &  SUSAN",
    "owner2": "KONG-WONG TR, HELEN HING YEE",
    "current_taxes": 12132.35,
    "new_taxes_no_override": 12656.47,
    "override_total_1": 13015.59,
    "override_increase_1": 359.12
  },
  {
    "#": "15 Belmont Rd, Unit 1 (424-03-01)",
    "$": 677700,
    "address": "15 Belmont Rd, Unit 1",
    "parcel_id": "424-03-01",
    "owner1": "KADIS LIFE ESTATE, DORIS",
    "owner2": "",
    "current_taxes": 3304.71,
    "new_taxes_no_override": 3447.47,
    "override_total_1": 3545.29,
    "override_increase_1": 97.82
  },
  {
    "#": "15 Belmont Rd, Unit 2 (424-03-02)",
    "$": 721400,
    "address": "15 Belmont Rd, Unit 2",
    "parcel_id": "424-03-02",
    "owner1": "PICARD, ELIOT B",
    "owner2": "",
    "current_taxes": 7387.14,
    "new_taxes_no_override": 7706.26,
    "override_total_1": 7924.92,
    "override_increase_1": 218.66
  },
  {
    "#": "16 Belmont Rd (424A-09-00)",
    "$": 1683100,
    "address": "16 Belmont Rd",
    "parcel_id": "424A-09-00",
    "owner1": "BERENT TRS, IRIS",
    "owner2": "BITRAN TRS, SAUL",
    "current_taxes": 13600.01,
    "new_taxes_no_override": 14187.53,
    "override_total_1": 14590.09,
    "override_increase_1": 402.56
  },
  {
    "#": "20 Belmont Rd (424A-10-00)",
    "$": 1130400,
    "address": "20 Belmont Rd",
    "parcel_id": "424A-10-00",
    "owner1": "CHAN, JOANNA HOI YING",
    "owner2": "",
    "current_taxes": 7940.36,
    "new_taxes_no_override": 8283.38,
    "override_total_1": 8518.42,
    "override_increase_1": 235.03
  },
  {
    "#": "21 Belmont Rd (424-04-00)",
    "$": 1112500,
    "address": "21 Belmont Rd",
    "parcel_id": "424-04-00",
    "owner1": "LANIN, GREGORY & YULIA",
    "owner2": "",
    "current_taxes": 7757.07,
    "new_taxes_no_override": 8092.18,
    "override_total_1": 8321.78,
    "override_increase_1": 229.61
  },
  {
    "#": "1 Benjamin Pl, Unit 1 (442-18-11)",
    "$": 1047000,
    "address": "1 Benjamin Pl, Unit 1",
    "parcel_id": "442-18-11",
    "owner1": "UNDERWOOD, CRAIG",
    "owner2": "",
    "current_taxes": 7086.35,
    "new_taxes_no_override": 7392.48,
    "override_total_1": 7602.24,
    "override_increase_1": 209.76
  },
  {
    "#": "2 Benjamin Pl, Unit 2 & P2 (442-18-01)",
    "$": 1039000,
    "address": "2 Benjamin Pl, Unit 2 & P2",
    "parcel_id": "442-18-01",
    "owner1": "CASTILLO, PATRICIA",
    "owner2": "",
    "current_taxes": 10639.36,
    "new_taxes_no_override": 11098.98,
    "override_total_1": 11413.91,
    "override_increase_1": 314.93
  },
  {
    "#": "3 Benjamin Pl, Unit 3 (442-18-02)",
    "$": 1107600,
    "address": "3 Benjamin Pl, Unit 3",
    "parcel_id": "442-18-02",
    "owner1": "SPECTOR, JOYCE DAVIS",
    "owner2": "",
    "current_taxes": 7706.89,
    "new_taxes_no_override": 8039.83,
    "override_total_1": 8267.95,
    "override_increase_1": 228.12
  },
  {
    "#": "4 Benjamin Pl, Unit 4 (442-18-03)",
    "$": 1148300,
    "address": "4 Benjamin Pl, Unit 4",
    "parcel_id": "442-18-03",
    "owner1": "LEIFER, ALEXANDER & BROOKE",
    "owner2": "",
    "current_taxes": 8123.66,
    "new_taxes_no_override": 8474.6,
    "override_total_1": 8715.06,
    "override_increase_1": 240.46
  },
  {
    "#": "5 Benjamin Pl, Unit 5 (442-18-04)",
    "$": 1138100,
    "address": "5 Benjamin Pl, Unit 5",
    "parcel_id": "442-18-04",
    "owner1": "LEVEY TR, STUART",
    "owner2": "",
    "current_taxes": 11654.14,
    "new_taxes_no_override": 12157.6,
    "override_total_1": 12502.56,
    "override_increase_1": 344.96
  },
  {
    "#": "6 Benjamin Pl, Unit 6 (442-18-05)",
    "$": 1091200,
    "address": "6 Benjamin Pl, Unit 6",
    "parcel_id": "442-18-05",
    "owner1": "SAYEED-SHAH, UMER",
    "owner2": "SHAH, AZADEH",
    "current_taxes": 7538.95,
    "new_taxes_no_override": 7864.63,
    "override_total_1": 8087.79,
    "override_increase_1": 223.15
  },
  {
    "#": "7 Benjamin Pl, Unit 7 (442-18-06)",
    "$": 1084600,
    "address": "7 Benjamin Pl, Unit 7",
    "parcel_id": "442-18-06",
    "owner1": "MADORE, BRUNO",
    "owner2": "",
    "current_taxes": 7471.37,
    "new_taxes_no_override": 7794.13,
    "override_total_1": 8015.29,
    "override_increase_1": 221.15
  },
  {
    "#": "8 Benjamin Pl, Unit 8 (442-18-07)",
    "$": 1103100,
    "address": "8 Benjamin Pl, Unit 8",
    "parcel_id": "442-18-07",
    "owner1": "BECK TRS, ALAN DODGE & DEBORAH LISANSKY",
    "owner2": "",
    "current_taxes": 7660.81,
    "new_taxes_no_override": 7991.76,
    "override_total_1": 8218.52,
    "override_increase_1": 226.76
  },
  {
    "#": "9 Benjamin Pl, Unit 9 (442-18-08)",
    "$": 1077200,
    "address": "9 Benjamin Pl, Unit 9",
    "parcel_id": "442-18-08",
    "owner1": "KIM, SEONHO",
    "owner2": "LEE, HWAJOO",
    "current_taxes": 11030.53,
    "new_taxes_no_override": 11507.05,
    "override_total_1": 11833.55,
    "override_increase_1": 326.5
  },
  {
    "#": "10 Benjamin Pl, Unit 10 & P10 (442-18-09)",
    "$": 1057600,
    "address": "10 Benjamin Pl, Unit 10 & P10",
    "parcel_id": "442-18-09",
    "owner1": "HEIMLICH TRS, LAWRENCE A & ARLINE S",
    "owner2": "",
    "current_taxes": 7194.89,
    "new_taxes_no_override": 7505.71,
    "override_total_1": 7718.68,
    "override_increase_1": 212.97
  },
  {
    "#": "11 Benjamin Pl, Unit 11  Pk 11 (442-18-10)",
    "$": 1108800,
    "address": "11 Benjamin Pl, Unit 11  Pk 11",
    "parcel_id": "442-18-10",
    "owner1": "VIGIL, DOMINICO",
    "owner2": "ANDZELM, MILENA",
    "current_taxes": 11354.11,
    "new_taxes_no_override": 11844.61,
    "override_total_1": 12180.69,
    "override_increase_1": 336.08
  },
  {
    "#": "8 Beresford Rd (412-08-01)",
    "$": 3232400,
    "address": "8 Beresford Rd",
    "parcel_id": "412-08-01",
    "owner1": "BALTER TR, BRADLEY R",
    "owner2": "",
    "current_taxes": 33099.78,
    "new_taxes_no_override": 34529.69,
    "override_total_1": 35509.44,
    "override_increase_1": 979.75
  },
  {
    "#": "16 Beresford Rd (412-09-00)",
    "$": 3281300,
    "address": "16 Beresford Rd",
    "parcel_id": "412-09-00",
    "owner1": "NAHIRNY, JAMES J & JANET L",
    "owner2": "",
    "current_taxes": 29965.58,
    "new_taxes_no_override": 31260.09,
    "override_total_1": 32147.07,
    "override_increase_1": 886.98
  },
  {
    "#": "22 Beresford Rd (412-10-00)",
    "$": 3484400,
    "address": "22 Beresford Rd",
    "parcel_id": "412-10-00",
    "owner1": "COX, DAVID & DEBRA",
    "owner2": "",
    "current_taxes": 35680.26,
    "new_taxes_no_override": 37221.65,
    "override_total_1": 38277.78,
    "override_increase_1": 1056.14
  },
  {
    "#": "29 Beresford Rd (413-05-00)",
    "$": 1688000,
    "address": "29 Beresford Rd",
    "parcel_id": "413-05-00",
    "owner1": "STAHLER, EMILY",
    "owner2": "",
    "current_taxes": 13650.19,
    "new_taxes_no_override": 14239.88,
    "override_total_1": 14643.92,
    "override_increase_1": 404.05
  },
  {
    "#": "30 Beresford Rd (412-11-00)",
    "$": 1767200,
    "address": "30 Beresford Rd",
    "parcel_id": "412-11-00",
    "owner1": "CUNNINGHAM, THOMAS L",
    "owner2": "",
    "current_taxes": 14461.19,
    "new_taxes_no_override": 15085.91,
    "override_total_1": 15513.96,
    "override_increase_1": 428.05
  },
  {
    "#": "36 Beresford Rd (412-12-00)",
    "$": 2423600,
    "address": "36 Beresford Rd",
    "parcel_id": "412-12-00",
    "owner1": "FINOCCHIO, STEPHEN",
    "owner2": "PROSHINA, ALEXANDRA",
    "current_taxes": 21182.73,
    "new_taxes_no_override": 22097.82,
    "override_total_1": 22724.83,
    "override_increase_1": 627.01
  },
  {
    "#": "37 Beresford Rd (413-04-00)",
    "$": 2588500,
    "address": "37 Beresford Rd",
    "parcel_id": "413-04-00",
    "owner1": "MASON, JEREMY & SOPHIA",
    "owner2": "",
    "current_taxes": 22871.31,
    "new_taxes_no_override": 23859.35,
    "override_total_1": 24536.34,
    "override_increase_1": 676.99
  },
  {
    "#": "44 Beresford Rd (412-13-00)",
    "$": 1532000,
    "address": "44 Beresford Rd",
    "parcel_id": "412-13-00",
    "owner1": "GOLDEN, ROBERT A & ODILE",
    "owner2": "",
    "current_taxes": 12052.75,
    "new_taxes_no_override": 12573.43,
    "override_total_1": 12930.19,
    "override_increase_1": 356.76
  },
  {
    "#": "45 Beresford Rd (413-03-00)",
    "$": 2302800,
    "address": "45 Beresford Rd",
    "parcel_id": "413-03-00",
    "owner1": "OLDHAM, WILLIAM M",
    "owner2": "SCHREINER-OLDHAM, JULIE ANN",
    "current_taxes": 19945.74,
    "new_taxes_no_override": 20807.4,
    "override_total_1": 21397.79,
    "override_increase_1": 590.39
  },
  {
    "#": "50 Beresford Rd (412-14-00)",
    "$": 2996100,
    "address": "50 Beresford Rd",
    "parcel_id": "412-14-00",
    "owner1": "FRANKS TRS, LISA",
    "owner2": "SICHKO, SAMUEL C",
    "current_taxes": 27045.13,
    "new_taxes_no_override": 28213.48,
    "override_total_1": 29014.02,
    "override_increase_1": 800.54
  },
  {
    "#": "51 Beresford Rd (413-02-00)",
    "$": 1899200,
    "address": "51 Beresford Rd",
    "parcel_id": "413-02-00",
    "owner1": "WIDDICOMBE TRS, ABBOTT COTTON",
    "owner2": "HOUGHTELING, PEARL DELANO",
    "current_taxes": 15812.87,
    "new_taxes_no_override": 16495.99,
    "override_total_1": 16964.05,
    "override_increase_1": 468.06
  },
  {
    "#": "57 Beresford Rd (413-01-00)",
    "$": 3012900,
    "address": "57 Beresford Rd",
    "parcel_id": "413-01-00",
    "owner1": "JACOBS, NEIL H",
    "owner2": "POSIN, DEBORAH A",
    "current_taxes": 27217.16,
    "new_taxes_no_override": 28392.94,
    "override_total_1": 29198.57,
    "override_increase_1": 805.63
  },
  {
    "#": " Beresford Rd (413-06-00)",
    "$": 148400,
    "address": " Beresford Rd",
    "parcel_id": "413-06-00",
    "owner1": "STAHLER, EMILY",
    "owner2": "",
    "current_taxes": 1519.62,
    "new_taxes_no_override": 1585.27,
    "override_total_1": 1630.25,
    "override_increase_1": 44.98
  },
  {
    "#": " Beresford Rd (413-07-00)",
    "$": 119000,
    "address": " Beresford Rd",
    "parcel_id": "413-07-00",
    "owner1": "MIR, JULITA",
    "owner2": "MUNARRIZ, RICARDO",
    "current_taxes": 1218.56,
    "new_taxes_no_override": 1271.2,
    "override_total_1": 1307.27,
    "override_increase_1": 36.07
  },
  {
    "#": "9 Berkeley Ct, Unit 9 (176-08-03)",
    "$": 1065900,
    "address": "9 Berkeley Ct, Unit 9",
    "parcel_id": "176-08-03",
    "owner1": "ING, MELISSA E",
    "owner2": "",
    "current_taxes": 10914.82,
    "new_taxes_no_override": 11386.34,
    "override_total_1": 11709.42,
    "override_increase_1": 323.08
  },
  {
    "#": "10 Berkeley Ct (176-12-00)",
    "$": 2022000,
    "address": "10 Berkeley Ct",
    "parcel_id": "176-12-00",
    "owner1": "MULCAHY TR, MICHAEL J",
    "owner2": "",
    "current_taxes": 20705.28,
    "new_taxes_no_override": 21599.75,
    "override_total_1": 22212.62,
    "override_increase_1": 612.88
  },
  {
    "#": "11 Berkeley Ct, Unit 11 (176-08-04)",
    "$": 997300,
    "address": "11 Berkeley Ct, Unit 11",
    "parcel_id": "176-08-04",
    "owner1": "ING, MELISSA",
    "owner2": "",
    "current_taxes": 6577.42,
    "new_taxes_no_override": 6861.56,
    "override_total_1": 7056.26,
    "override_increase_1": 194.69
  },
  {
    "#": "14 Berkeley Ct, Unit 1 (176-11-01)",
    "$": 1081700,
    "address": "14 Berkeley Ct, Unit 1",
    "parcel_id": "176-11-01",
    "owner1": "DEYCH, MARCIA & MATVEY",
    "owner2": "",
    "current_taxes": 7441.67,
    "new_taxes_no_override": 7763.15,
    "override_total_1": 7983.42,
    "override_increase_1": 220.27
  },
  {
    "#": "14 Berkeley Ct, Unit 2 (176-11-02)",
    "$": 853600,
    "address": "14 Berkeley Ct, Unit 2",
    "parcel_id": "176-11-02",
    "owner1": "KUSTYANTO, GUSTI F",
    "owner2": "",
    "current_taxes": 5105.93,
    "new_taxes_no_override": 5326.51,
    "override_total_1": 5477.64,
    "override_increase_1": 151.14
  },
  {
    "#": "15 Berkeley Ct, Unit 1 (176-09-01)",
    "$": 2051500,
    "address": "15 Berkeley Ct, Unit 1",
    "parcel_id": "176-09-01",
    "owner1": "SHEININ, MAXIM",
    "owner2": "SHEELA-MOHAN, ANUTTAMA",
    "current_taxes": 17372.43,
    "new_taxes_no_override": 18122.92,
    "override_total_1": 18637.14,
    "override_increase_1": 514.22
  },
  {
    "#": "15 Berkeley Ct, Unit 2 (176-09-02)",
    "$": 1698500,
    "address": "15 Berkeley Ct, Unit 2",
    "parcel_id": "176-09-02",
    "owner1": "HAINER, RAYMOND",
    "owner2": "WEISS, EMILY",
    "current_taxes": 13757.71,
    "new_taxes_no_override": 14352.04,
    "override_total_1": 14759.27,
    "override_increase_1": 407.23
  },
  {
    "#": "18 Berkeley Ct (176-10-00)",
    "$": 1896600,
    "address": "18 Berkeley Ct",
    "parcel_id": "176-10-00",
    "owner1": "KEAVENEY, EDWARD G & LINDA J",
    "owner2": "",
    "current_taxes": 15786.25,
    "new_taxes_no_override": 16468.22,
    "override_total_1": 16935.49,
    "override_increase_1": 467.27
  },
  {
    "#": "2 Beverly Rd (403-04-00)",
    "$": 1494900,
    "address": "2 Beverly Rd",
    "parcel_id": "403-04-00",
    "owner1": "COHEN, LEWIS J & SUSAN E",
    "owner2": "",
    "current_taxes": 11672.84,
    "new_taxes_no_override": 12177.11,
    "override_total_1": 12522.62,
    "override_increase_1": 345.52
  },
  {
    "#": "12 Beverly Rd (403-05-00)",
    "$": 2392600,
    "address": "12 Beverly Rd",
    "parcel_id": "403-05-00",
    "owner1": "BIREN, MARVIN A & ELLEN C",
    "owner2": "",
    "current_taxes": 20865.29,
    "new_taxes_no_override": 21766.67,
    "override_total_1": 22384.28,
    "override_increase_1": 617.61
  },
  {
    "#": "19 Beverly Rd (405-06-00)",
    "$": 2395100,
    "address": "19 Beverly Rd",
    "parcel_id": "405-06-00",
    "owner1": "HIRSCH TRS, JAMES A & KAREN KLEIN",
    "owner2": "",
    "current_taxes": 20890.89,
    "new_taxes_no_override": 21793.38,
    "override_total_1": 22411.75,
    "override_increase_1": 618.37
  },
  {
    "#": "22 Beverly Rd (403-06-00)",
    "$": 2240400,
    "address": "22 Beverly Rd",
    "parcel_id": "403-06-00",
    "owner1": "CLONEY, CHRISTOPHER R",
    "owner2": "DRISCOLL, KATE",
    "current_taxes": 19306.76,
    "new_taxes_no_override": 20140.81,
    "override_total_1": 20712.29,
    "override_increase_1": 571.48
  },
  {
    "#": "29 Beverly Rd (405-05-00)",
    "$": 2283100,
    "address": "29 Beverly Rd",
    "parcel_id": "405-05-00",
    "owner1": "GABBAY TR, DENISE A",
    "owner2": "",
    "current_taxes": 19744.01,
    "new_taxes_no_override": 20596.95,
    "override_total_1": 21181.37,
    "override_increase_1": 584.42
  },
  {
    "#": "30 Beverly Rd (403-07-00)",
    "$": 1409900,
    "address": "30 Beverly Rd",
    "parcel_id": "403-07-00",
    "owner1": "CONNOLLY, SUSAN A",
    "owner2": "BREC, SHERRY L",
    "current_taxes": 10802.44,
    "new_taxes_no_override": 11269.11,
    "override_total_1": 11588.86,
    "override_increase_1": 319.75
  },
  {
    "#": "36 Beverly Rd (403-08-00)",
    "$": 1754000,
    "address": "36 Beverly Rd",
    "parcel_id": "403-08-00",
    "owner1": "SPITZ, NANCY",
    "owner2": "",
    "current_taxes": 14326.03,
    "new_taxes_no_override": 14944.91,
    "override_total_1": 15368.96,
    "override_increase_1": 424.05
  },
  {
    "#": "37 Beverly Rd (405-04-00)",
    "$": 1786000,
    "address": "37 Beverly Rd",
    "parcel_id": "405-04-00",
    "owner1": "MANCINI, JARED M & ABBIE BA",
    "owner2": "",
    "current_taxes": 18288.64,
    "new_taxes_no_override": 19078.71,
    "override_total_1": 19620.05,
    "override_increase_1": 541.34
  },
  {
    "#": "44 Beverly Rd (403-09-00)",
    "$": 1955100,
    "address": "44 Beverly Rd",
    "parcel_id": "403-09-00",
    "owner1": "CHERNIN, PHILIP R",
    "owner2": "HSU, ALICIA",
    "current_taxes": 16385.29,
    "new_taxes_no_override": 17093.13,
    "override_total_1": 17578.14,
    "override_increase_1": 485.0
  },
  {
    "#": "45 Beverly Rd (405-03-00)",
    "$": 1752900,
    "address": "45 Beverly Rd",
    "parcel_id": "405-03-00",
    "owner1": "HUANG, FRANK",
    "owner2": "LING, KARA",
    "current_taxes": 17949.7,
    "new_taxes_no_override": 18725.13,
    "override_total_1": 19256.44,
    "override_increase_1": 531.31
  },
  {
    "#": "52 Beverly Rd (403-10-00)",
    "$": 2158600,
    "address": "52 Beverly Rd",
    "parcel_id": "403-10-00",
    "owner1": "SCHOLLE TRS, ELIZABETH H & OLIVER C JR",
    "owner2": "",
    "current_taxes": 18469.13,
    "new_taxes_no_override": 19267.0,
    "override_total_1": 19813.68,
    "override_increase_1": 546.69
  },
  {
    "#": "53 Beverly Rd (405-02-00)",
    "$": 2135800,
    "address": "53 Beverly Rd",
    "parcel_id": "405-02-00",
    "owner1": "MOOSE, SANDRA O",
    "owner2": "",
    "current_taxes": 18235.66,
    "new_taxes_no_override": 19023.44,
    "override_total_1": 19563.22,
    "override_increase_1": 539.78
  },
  {
    "#": "59 Beverly Rd (405-01-00)",
    "$": 1352300,
    "address": "59 Beverly Rd",
    "parcel_id": "405-01-00",
    "owner1": "DI, LINGHUI",
    "owner2": "",
    "current_taxes": 13847.55,
    "new_taxes_no_override": 14445.76,
    "override_total_1": 14855.65,
    "override_increase_1": 409.89
  },
  {
    "#": "60 Beverly Rd (403-11-00)",
    "$": 1830300,
    "address": "60 Beverly Rd",
    "parcel_id": "403-11-00",
    "owner1": "MCNAMARA, DANIEL O & ASHLEY M",
    "owner2": "",
    "current_taxes": 15107.34,
    "new_taxes_no_override": 15759.98,
    "override_total_1": 16207.15,
    "override_increase_1": 447.18
  },
  {
    "#": "66 Beverly Rd (403-12-00)",
    "$": 1926300,
    "address": "66 Beverly Rd",
    "parcel_id": "403-12-00",
    "owner1": "FINNAN, AIDAN",
    "owner2": "THALL, CAROLYN",
    "current_taxes": 16090.38,
    "new_taxes_no_override": 16785.48,
    "override_total_1": 17261.76,
    "override_increase_1": 476.28
  },
  {
    "#": "72 Beverly Rd (403-13-00)",
    "$": 2268300,
    "address": "72 Beverly Rd",
    "parcel_id": "403-13-00",
    "owner1": "LITT TRS, ERIC E & DIETRA KAY",
    "owner2": "",
    "current_taxes": 19592.46,
    "new_taxes_no_override": 20438.85,
    "override_total_1": 21018.79,
    "override_increase_1": 579.94
  },
  {
    "#": "73 Beverly Rd (404-04-00)",
    "$": 1016200,
    "address": "73 Beverly Rd",
    "parcel_id": "404-04-00",
    "owner1": "SEHGAL, SANKALP",
    "owner2": "AHLUWALIA, MONICA",
    "current_taxes": 10405.89,
    "new_taxes_no_override": 10855.42,
    "override_total_1": 11163.44,
    "override_increase_1": 308.01
  },
  {
    "#": "78 Beverly Rd (403-14-00)",
    "$": 1996900,
    "address": "78 Beverly Rd",
    "parcel_id": "403-14-00",
    "owner1": "JHA, SHAMBHU NATH & ANAMIKA MANTRA",
    "owner2": "",
    "current_taxes": 16813.32,
    "new_taxes_no_override": 17539.66,
    "override_total_1": 18037.33,
    "override_increase_1": 497.67
  },
  {
    "#": "79 Beverly Rd (404-03-01)",
    "$": 1554600,
    "address": "79 Beverly Rd",
    "parcel_id": "404-03-01",
    "owner1": "GOMEZ-ISLA, MARIA TERESA",
    "owner2": "SOTO, OSCAR",
    "current_taxes": 12284.17,
    "new_taxes_no_override": 12814.85,
    "override_total_1": 13178.46,
    "override_increase_1": 363.61
  },
  {
    "#": "86 Beverly Rd (403-15-00)",
    "$": 1696600,
    "address": "86 Beverly Rd",
    "parcel_id": "403-15-00",
    "owner1": "ARNOLD, BARBARA",
    "owner2": "",
    "current_taxes": 13738.25,
    "new_taxes_no_override": 14331.74,
    "override_total_1": 14738.39,
    "override_increase_1": 406.65
  },
  {
    "#": "87 Beverly Rd (404-03-00)",
    "$": 2298700,
    "address": "87 Beverly Rd",
    "parcel_id": "404-03-00",
    "owner1": "BARON TR, BEVERLY WIRTH",
    "owner2": "",
    "current_taxes": 19903.75,
    "new_taxes_no_override": 20763.59,
    "override_total_1": 21352.74,
    "override_increase_1": 589.15
  },
  {
    "#": "92 Beverly Rd (403-16-00)",
    "$": 2675200,
    "address": "92 Beverly Rd",
    "parcel_id": "403-16-00",
    "owner1": "TALIB TRS, SHAMS",
    "owner2": "DEL BIONDO, ISABEL",
    "current_taxes": 27394.05,
    "new_taxes_no_override": 28577.47,
    "override_total_1": 29388.34,
    "override_increase_1": 810.86
  },
  {
    "#": "95 Beverly Rd (404-02-00)",
    "$": 1606000,
    "address": "95 Beverly Rd",
    "parcel_id": "404-02-00",
    "owner1": "GREENBERGER TR, JOAN E & NORTON J",
    "owner2": "",
    "current_taxes": 12810.51,
    "new_taxes_no_override": 13363.92,
    "override_total_1": 13743.12,
    "override_increase_1": 379.19
  },
  {
    "#": "100 Beverly Rd (403-17-00)",
    "$": 2051200,
    "address": "100 Beverly Rd",
    "parcel_id": "403-17-00",
    "owner1": "HUMMER, MARY C",
    "owner2": "C/O DECKER MARY CLARE",
    "current_taxes": 17369.35,
    "new_taxes_no_override": 18119.71,
    "override_total_1": 18633.84,
    "override_increase_1": 514.13
  },
  {
    "#": "105 Beverly Rd (404-01-00)",
    "$": 2219700,
    "address": "105 Beverly Rd",
    "parcel_id": "404-01-00",
    "owner1": "CLARK, JON",
    "owner2": "STEADMAN, KIMBERLY",
    "current_taxes": 19094.79,
    "new_taxes_no_override": 19919.68,
    "override_total_1": 20484.89,
    "override_increase_1": 565.21
  },
  {
    "#": "110 Beverly Rd (403-18-19)",
    "$": 1380100,
    "address": "110 Beverly Rd",
    "parcel_id": "403-18-19",
    "owner1": "WEINRAUCH, SHERYL S",
    "owner2": "",
    "current_taxes": 10497.29,
    "new_taxes_no_override": 10950.77,
    "override_total_1": 11261.49,
    "override_increase_1": 310.72
  },
  {
    "#": "111 Beverly Rd (398B-05-00)",
    "$": 2231800,
    "address": "111 Beverly Rd",
    "parcel_id": "398B-05-00",
    "owner1": "ZAMBRI, CHARLES J III",
    "owner2": "OBRIEN, MARGARET M",
    "current_taxes": 19218.7,
    "new_taxes_no_override": 20048.95,
    "override_total_1": 20617.82,
    "override_increase_1": 568.87
  },
  {
    "#": "120 Beverly Rd (398A-01-00)",
    "$": 1597300,
    "address": "120 Beverly Rd",
    "parcel_id": "398A-01-00",
    "owner1": "KODSI TRS, GINETTE",
    "owner2": "KODSI-HASSON, LEVANA",
    "current_taxes": 12721.42,
    "new_taxes_no_override": 13270.99,
    "override_total_1": 13647.54,
    "override_increase_1": 376.55
  },
  {
    "#": "121 Beverly Rd (398B-04-00)",
    "$": 1597300,
    "address": "121 Beverly Rd",
    "parcel_id": "398B-04-00",
    "owner1": "LEICHTNER, ALAN M & JUDITH E",
    "owner2": "",
    "current_taxes": 12721.42,
    "new_taxes_no_override": 13270.99,
    "override_total_1": 13647.54,
    "override_increase_1": 376.55
  },
  {
    "#": "129 Beverly Rd (398B-03-00)",
    "$": 2203900,
    "address": "129 Beverly Rd",
    "parcel_id": "398B-03-00",
    "owner1": "MAYER, ROBERT & OLA",
    "owner2": "",
    "current_taxes": 18933.0,
    "new_taxes_no_override": 19750.91,
    "override_total_1": 20311.32,
    "override_increase_1": 560.42
  },
  {
    "#": "130 Beverly Rd (398A-02-00)",
    "$": 1548000,
    "address": "130 Beverly Rd",
    "parcel_id": "398A-02-00",
    "owner1": "HOLBROOK, SEAN",
    "owner2": "MARINO, LIA",
    "current_taxes": 12216.59,
    "new_taxes_no_override": 12744.35,
    "override_total_1": 13105.96,
    "override_increase_1": 361.61
  },
  {
    "#": "132 Beverly Rd (398A-03-00)",
    "$": 1988500,
    "address": "132 Beverly Rd",
    "parcel_id": "398A-03-00",
    "owner1": "HAMMER, MARK M",
    "owner2": "GOOPTU, MAHASWETA",
    "current_taxes": 16727.31,
    "new_taxes_no_override": 17449.93,
    "override_total_1": 17945.06,
    "override_increase_1": 495.13
  },
  {
    "#": "135 Beverly Rd (398B-02-01)",
    "$": 1854300,
    "address": "135 Beverly Rd",
    "parcel_id": "398B-02-01",
    "owner1": "BREEN, DAVID",
    "owner2": "HARRINGTON, MICHAEL",
    "current_taxes": 15353.1,
    "new_taxes_no_override": 16016.35,
    "override_total_1": 16470.81,
    "override_increase_1": 454.45
  },
  {
    "#": "136 Beverly Rd (398A-03-01)",
    "$": 1375600,
    "address": "136 Beverly Rd",
    "parcel_id": "398A-03-01",
    "owner1": "D'ARISTA, DIANE S",
    "owner2": "FABER, JOANNE L",
    "current_taxes": 10451.21,
    "new_taxes_no_override": 10902.7,
    "override_total_1": 11212.06,
    "override_increase_1": 309.36
  },
  {
    "#": "141 Beverly Rd (398B-02-00)",
    "$": 1601000,
    "address": "141 Beverly Rd",
    "parcel_id": "398B-02-00",
    "owner1": "EPSTEIN TR, JANE I",
    "owner2": "",
    "current_taxes": 12759.31,
    "new_taxes_no_override": 13310.51,
    "override_total_1": 13688.19,
    "override_increase_1": 377.68
  },
  {
    "#": "142 Beverly Rd (398A-04-00)",
    "$": 1942700,
    "address": "142 Beverly Rd",
    "parcel_id": "398A-04-00",
    "owner1": "MASUOKA TR, LORIANNE",
    "owner2": "",
    "current_taxes": 19893.25,
    "new_taxes_no_override": 20752.64,
    "override_total_1": 21341.48,
    "override_increase_1": 588.84
  },
  {
    "#": "146 Beverly Rd (398A-05-00)",
    "$": 1968300,
    "address": "146 Beverly Rd",
    "parcel_id": "398A-05-00",
    "owner1": "ENGELMAN, JEFFREY A & DANA A",
    "owner2": "",
    "current_taxes": 16520.46,
    "new_taxes_no_override": 17234.14,
    "override_total_1": 17723.15,
    "override_increase_1": 489.01
  },
  {
    "#": "152 Beverly Rd (398A-06-00)",
    "$": 1659100,
    "address": "152 Beverly Rd",
    "parcel_id": "398A-06-00",
    "owner1": "EPSTEIN, LAWRENCE",
    "owner2": "CUNNINGHAM, DOROTHY",
    "current_taxes": 13354.25,
    "new_taxes_no_override": 13931.15,
    "override_total_1": 14326.44,
    "override_increase_1": 395.29
  },
  {
    "#": "160 Beverly Rd (398A-07-00)",
    "$": 1516200,
    "address": "160 Beverly Rd",
    "parcel_id": "398A-07-00",
    "owner1": "ATT, WAEL & GHIZLANE",
    "owner2": "",
    "current_taxes": 15525.89,
    "new_taxes_no_override": 16196.61,
    "override_total_1": 16656.17,
    "override_increase_1": 459.57
  },
  {
    "#": "205 Beverly Rd (398B-01-00)",
    "$": 45220700,
    "address": "205 Beverly Rd",
    "parcel_id": "398B-01-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O EDITH C BAKER SCHOOL/PLAYGRD",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "210 Beverly Rd (398-08-02)",
    "$": 1910200,
    "address": "210 Beverly Rd",
    "parcel_id": "398-08-02",
    "owner1": "COHEN, SARAH",
    "owner2": "BEAUSSANT, YVAN",
    "current_taxes": 15925.51,
    "new_taxes_no_override": 16613.49,
    "override_total_1": 17084.89,
    "override_increase_1": 471.4
  },
  {
    "#": "219 Beverly Rd (398B-06-00)",
    "$": 26567100,
    "address": "219 Beverly Rd",
    "parcel_id": "398B-06-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O D BLAKELEY HOAR SANCTUARY",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "220 Beverly Rd (398-10-00)",
    "$": 1094500,
    "address": "220 Beverly Rd",
    "parcel_id": "398-10-00",
    "owner1": "PETERS, DANIEL A & RITA P",
    "owner2": "",
    "current_taxes": 7572.75,
    "new_taxes_no_override": 7899.89,
    "override_total_1": 8124.05,
    "override_increase_1": 224.15
  },
  {
    "#": "223 Beverly Rd (392-16-00)",
    "$": 1145000,
    "address": "223 Beverly Rd",
    "parcel_id": "392-16-00",
    "owner1": "SNEIDER, ARTHUR & REBECCA S",
    "owner2": "",
    "current_taxes": 8089.87,
    "new_taxes_no_override": 8439.35,
    "override_total_1": 8678.81,
    "override_increase_1": 239.46
  },
  {
    "#": "224 Beverly Rd (393-01-00)",
    "$": 1211700,
    "address": "224 Beverly Rd",
    "parcel_id": "393-01-00",
    "owner1": "AIKINS, TR, LOUISE",
    "owner2": "",
    "current_taxes": 8772.87,
    "new_taxes_no_override": 9151.86,
    "override_total_1": 9411.53,
    "override_increase_1": 259.68
  },
  {
    "#": "229 Beverly Rd (392-15-00)",
    "$": 1743000,
    "address": "229 Beverly Rd",
    "parcel_id": "392-15-00",
    "owner1": "SHERMAN, DAVID A",
    "owner2": "HUGHES, JENNIFER K",
    "current_taxes": 14213.39,
    "new_taxes_no_override": 14827.41,
    "override_total_1": 15248.12,
    "override_increase_1": 420.72
  },
  {
    "#": "230 Beverly Rd (393-02-00)",
    "$": 1505300,
    "address": "230 Beverly Rd",
    "parcel_id": "393-02-00",
    "owner1": "MIRKIN TRS, HOWARD I & RENA P",
    "owner2": "",
    "current_taxes": 11779.34,
    "new_taxes_no_override": 12288.21,
    "override_total_1": 12636.88,
    "override_increase_1": 348.67
  },
  {
    "#": "233 Beverly Rd (392-14-00)",
    "$": 1238600,
    "address": "233 Beverly Rd",
    "parcel_id": "392-14-00",
    "owner1": "WONG, JUDY",
    "owner2": "HSIEH, EDWARD-TSING ZONE-LIAN WU",
    "current_taxes": 12683.26,
    "new_taxes_no_override": 13231.18,
    "override_total_1": 13606.6,
    "override_increase_1": 375.42
  },
  {
    "#": "236 Beverly Rd (393-03-00)",
    "$": 1589800,
    "address": "236 Beverly Rd",
    "parcel_id": "393-03-00",
    "owner1": "GUO, HENG",
    "owner2": "PAN, ZHIHENG",
    "current_taxes": 12644.62,
    "new_taxes_no_override": 13190.87,
    "override_total_1": 13565.15,
    "override_increase_1": 374.28
  },
  {
    "#": "239 Beverly Rd (392-13-00)",
    "$": 1455100,
    "address": "239 Beverly Rd",
    "parcel_id": "392-13-00",
    "owner1": "FRIEDMAN, JAMES & VIRGINIA",
    "owner2": "",
    "current_taxes": 11265.29,
    "new_taxes_no_override": 11751.95,
    "override_total_1": 12085.4,
    "override_increase_1": 333.45
  },
  {
    "#": "242 Beverly Rd (393-04-00)",
    "$": 1419400,
    "address": "242 Beverly Rd",
    "parcel_id": "393-04-00",
    "owner1": "JAFFE TRS, BRUCE C",
    "owner2": "CRESWELL, JANE A",
    "current_taxes": 10899.72,
    "new_taxes_no_override": 11370.59,
    "override_total_1": 11693.22,
    "override_increase_1": 322.63
  },
  {
    "#": "243 Beverly Rd (392-12-00)",
    "$": 1352200,
    "address": "243 Beverly Rd",
    "parcel_id": "392-12-00",
    "owner1": "POLLARD TRS, ROBERT W",
    "owner2": "WILCKE, MARILYN A",
    "current_taxes": 10211.59,
    "new_taxes_no_override": 10652.73,
    "override_total_1": 10954.99,
    "override_increase_1": 302.26
  },
  {
    "#": "248 Beverly Rd (393-05-00)",
    "$": 1383400,
    "address": "248 Beverly Rd",
    "parcel_id": "393-05-00",
    "owner1": "VIGO LIFE ESTATE, EVELYN",
    "owner2": "",
    "current_taxes": 10531.08,
    "new_taxes_no_override": 10986.02,
    "override_total_1": 11297.74,
    "override_increase_1": 311.72
  },
  {
    "#": "249 Beverly Rd (392-11-00)",
    "$": 1636200,
    "address": "249 Beverly Rd",
    "parcel_id": "392-11-00",
    "owner1": "LETTERMAN, JENNIFER",
    "owner2": "",
    "current_taxes": 13119.75,
    "new_taxes_no_override": 13686.52,
    "override_total_1": 14074.87,
    "override_increase_1": 388.34
  },
  {
    "#": "253 Beverly Rd (392-10-00)",
    "$": 1260900,
    "address": "253 Beverly Rd",
    "parcel_id": "392-10-00",
    "owner1": "MORRISSEY, KELLEY",
    "owner2": "",
    "current_taxes": 9276.68,
    "new_taxes_no_override": 9677.43,
    "override_total_1": 9952.02,
    "override_increase_1": 274.59
  },
  {
    "#": "254 Beverly Rd (393-06-00)",
    "$": 1421000,
    "address": "254 Beverly Rd",
    "parcel_id": "393-06-00",
    "owner1": "DORF, MARTIN E & JUDY",
    "owner2": "",
    "current_taxes": 10916.11,
    "new_taxes_no_override": 11387.69,
    "override_total_1": 11710.8,
    "override_increase_1": 323.12
  },
  {
    "#": "257 Beverly Rd (392-09-00)",
    "$": 1364600,
    "address": "257 Beverly Rd",
    "parcel_id": "392-09-00",
    "owner1": "ENESCU, DANIEL",
    "owner2": "ANGHEL-ENESCU, IRINA",
    "current_taxes": 10338.57,
    "new_taxes_no_override": 10785.2,
    "override_total_1": 11091.22,
    "override_increase_1": 306.02
  },
  {
    "#": "260 Beverly Rd (393-07-00)",
    "$": 1995300,
    "address": "260 Beverly Rd",
    "parcel_id": "393-07-00",
    "owner1": "SCHNEIDER, SAMUEL M & SONIA P",
    "owner2": "",
    "current_taxes": 16796.94,
    "new_taxes_no_override": 17522.57,
    "override_total_1": 18019.76,
    "override_increase_1": 497.19
  },
  {
    "#": "263 Beverly Rd (392-08-00)",
    "$": 1381800,
    "address": "263 Beverly Rd",
    "parcel_id": "392-08-00",
    "owner1": "KENAGY, PETER E & SARA E",
    "owner2": "",
    "current_taxes": 10514.7,
    "new_taxes_no_override": 10968.94,
    "override_total_1": 11280.17,
    "override_increase_1": 311.24
  },
  {
    "#": "267 Beverly Rd (392-07-00)",
    "$": 1363400,
    "address": "267 Beverly Rd",
    "parcel_id": "392-07-00",
    "owner1": "DAL COROBBO, CHARLES A",
    "owner2": "DONG, DEBORAH",
    "current_taxes": 10326.28,
    "new_taxes_no_override": 10772.38,
    "override_total_1": 11078.03,
    "override_increase_1": 305.66
  },
  {
    "#": "268 Beverly Rd (393-08-00)",
    "$": 1257700,
    "address": "268 Beverly Rd",
    "parcel_id": "393-08-00",
    "owner1": "BRACKEN TRS, ALYSON & MATTHEW",
    "owner2": "",
    "current_taxes": 9243.91,
    "new_taxes_no_override": 9643.25,
    "override_total_1": 9916.87,
    "override_increase_1": 273.62
  },
  {
    "#": "271 Beverly Rd (392-06-00)",
    "$": 1214700,
    "address": "271 Beverly Rd",
    "parcel_id": "392-06-00",
    "owner1": "GOLDHABER, REEVE I & SAMUEL Z",
    "owner2": "",
    "current_taxes": 8803.59,
    "new_taxes_no_override": 9183.91,
    "override_total_1": 9444.49,
    "override_increase_1": 260.59
  },
  {
    "#": "274 Beverly Rd (393-09-00)",
    "$": 1533900,
    "address": "274 Beverly Rd",
    "parcel_id": "393-09-00",
    "owner1": "HOLSINGER, BRENT L",
    "owner2": "TONI-HOLSINGER, LAURA",
    "current_taxes": 12072.2,
    "new_taxes_no_override": 12593.72,
    "override_total_1": 12951.06,
    "override_increase_1": 357.34
  },
  {
    "#": "275 Beverly Rd (392-05-00)",
    "$": 1522300,
    "address": "275 Beverly Rd",
    "parcel_id": "392-05-00",
    "owner1": "SCHLOSBERG, ALAN R & ELIZABETH",
    "owner2": "",
    "current_taxes": 11953.42,
    "new_taxes_no_override": 12469.81,
    "override_total_1": 12823.63,
    "override_increase_1": 353.82
  },
  {
    "#": "279 Beverly Rd (392-04-00)",
    "$": 1366600,
    "address": "279 Beverly Rd",
    "parcel_id": "392-04-00",
    "owner1": "ARICO-MUENDEL, CHRISTOPHER C & DIANNE F",
    "owner2": "",
    "current_taxes": 10359.05,
    "new_taxes_no_override": 10806.56,
    "override_total_1": 11113.19,
    "override_increase_1": 306.63
  },
  {
    "#": "280 Beverly Rd (393-10-00)",
    "$": 1217100,
    "address": "280 Beverly Rd",
    "parcel_id": "393-10-00",
    "owner1": "REGOLINO, AUSTIN",
    "owner2": "",
    "current_taxes": 8828.17,
    "new_taxes_no_override": 9209.55,
    "override_total_1": 9470.86,
    "override_increase_1": 261.31
  },
  {
    "#": "285 Beverly Rd (392-03-00)",
    "$": 1723100,
    "address": "285 Beverly Rd",
    "parcel_id": "392-03-00",
    "owner1": "KOOCHER, ROBIN C & GERALD P",
    "owner2": "",
    "current_taxes": 14009.61,
    "new_taxes_no_override": 14614.83,
    "override_total_1": 15029.51,
    "override_increase_1": 414.68
  },
  {
    "#": "286 Beverly Rd (393-11-00)",
    "$": 1433000,
    "address": "286 Beverly Rd",
    "parcel_id": "393-11-00",
    "owner1": "PRASAD TRS, ANIL",
    "owner2": "SHETTY, PRASADINI",
    "current_taxes": 11038.99,
    "new_taxes_no_override": 11515.87,
    "override_total_1": 11842.63,
    "override_increase_1": 326.75
  },
  {
    "#": "290 Beverly Rd (393-12-00)",
    "$": 1650300,
    "address": "290 Beverly Rd",
    "parcel_id": "393-12-00",
    "owner1": "FRIEDMAN, WALTER A",
    "owner2": "BURGIN, SUSAN",
    "current_taxes": 13264.14,
    "new_taxes_no_override": 13837.15,
    "override_total_1": 14229.77,
    "override_increase_1": 392.62
  },
  {
    "#": "291 Beverly Rd (392-02-00)",
    "$": 1452700,
    "address": "291 Beverly Rd",
    "parcel_id": "392-02-00",
    "owner1": "BORA, IMRAN",
    "owner2": "PANCHOLI, DULARI",
    "current_taxes": 11240.71,
    "new_taxes_no_override": 11726.31,
    "override_total_1": 12059.03,
    "override_increase_1": 332.73
  },
  {
    "#": "296 Beverly Rd (393-13-00)",
    "$": 1278300,
    "address": "296 Beverly Rd",
    "parcel_id": "393-13-00",
    "owner1": "ROSS, CALVIN C & JANICE I",
    "owner2": "",
    "current_taxes": 9454.86,
    "new_taxes_no_override": 9863.31,
    "override_total_1": 10143.17,
    "override_increase_1": 279.86
  },
  {
    "#": "299 Beverly Rd (392-01-00)",
    "$": 1571600,
    "address": "299 Beverly Rd",
    "parcel_id": "392-01-00",
    "owner1": "OCONNOR, DANIEL F & ELIZABETH F",
    "owner2": "",
    "current_taxes": 12458.25,
    "new_taxes_no_override": 12996.45,
    "override_total_1": 13365.21,
    "override_increase_1": 368.76
  },
  {
    "#": "300 Beverly Rd (393-14-00)",
    "$": 1250900,
    "address": "300 Beverly Rd",
    "parcel_id": "393-14-00",
    "owner1": "TREMBLAY TR, RONALD E",
    "owner2": "",
    "current_taxes": 9174.28,
    "new_taxes_no_override": 9570.61,
    "override_total_1": 9842.17,
    "override_increase_1": 271.56
  },
  {
    "#": "6 Blake Rd (228-32-00)",
    "$": 2474600,
    "address": "6 Blake Rd",
    "parcel_id": "228-32-00",
    "owner1": "GOPIN, STEVEN D & PAULA S",
    "owner2": "",
    "current_taxes": 21704.97,
    "new_taxes_no_override": 22642.62,
    "override_total_1": 23285.09,
    "override_increase_1": 642.47
  },
  {
    "#": "12 Blake Rd (228-31-01)",
    "$": 1801800,
    "address": "12 Blake Rd",
    "parcel_id": "228-31-01",
    "owner1": "GOPIN TR, PAULINE M",
    "owner2": "",
    "current_taxes": 14815.5,
    "new_taxes_no_override": 15455.53,
    "override_total_1": 15894.07,
    "override_increase_1": 438.54
  },
  {
    "#": "16 Blake Rd (228-31-02)",
    "$": 2049100,
    "address": "16 Blake Rd",
    "parcel_id": "228-31-02",
    "owner1": "WAGNER, STEPHEN",
    "owner2": "GUPTA, MEGHA",
    "current_taxes": 20982.78,
    "new_taxes_no_override": 21889.24,
    "override_total_1": 22510.33,
    "override_increase_1": 621.09
  },
  {
    "#": "17 Blake Rd (203-08-00)",
    "$": 2327400,
    "address": "17 Blake Rd",
    "parcel_id": "203-08-00",
    "owner1": "POLUMBAUM TR, NYNA BRAEL",
    "owner2": "",
    "current_taxes": 20197.64,
    "new_taxes_no_override": 21070.18,
    "override_total_1": 21668.03,
    "override_increase_1": 597.85
  },
  {
    "#": "21 Blake Rd (203-09-00)",
    "$": 2232800,
    "address": "21 Blake Rd",
    "parcel_id": "203-09-00",
    "owner1": "SEIDEL, PAUL A",
    "owner2": "KIM, JULEE",
    "current_taxes": 19228.94,
    "new_taxes_no_override": 20059.63,
    "override_total_1": 20628.81,
    "override_increase_1": 569.18
  },
  {
    "#": "24 Blake Rd (228-30-01)",
    "$": 2164900,
    "address": "24 Blake Rd",
    "parcel_id": "228-30-01",
    "owner1": "FRIEDMAN, DANIEL J & EMILY R",
    "owner2": "",
    "current_taxes": 22168.58,
    "new_taxes_no_override": 23126.26,
    "override_total_1": 23782.45,
    "override_increase_1": 656.19
  },
  {
    "#": "36 Blake Rd (204-20-00)",
    "$": 2505500,
    "address": "36 Blake Rd",
    "parcel_id": "204-20-00",
    "owner1": "MCMASTERS, DANIEL & MALGORZATA",
    "owner2": "",
    "current_taxes": 22021.39,
    "new_taxes_no_override": 22972.71,
    "override_total_1": 23624.55,
    "override_increase_1": 651.83
  },
  {
    "#": "40 Blake Rd (204-19-00)",
    "$": 3239800,
    "address": "40 Blake Rd",
    "parcel_id": "204-19-00",
    "owner1": "LEVINE TRS, ROBERT AARON & TOBIE G",
    "owner2": "",
    "current_taxes": 29540.62,
    "new_taxes_no_override": 30816.77,
    "override_total_1": 31691.18,
    "override_increase_1": 874.4
  },
  {
    "#": "43 Blake Rd (205-02-00)",
    "$": 2967500,
    "address": "43 Blake Rd",
    "parcel_id": "205-02-00",
    "owner1": "KARL, CHRISTIAN & MARIANNE NOURZAD",
    "owner2": "",
    "current_taxes": 26752.27,
    "new_taxes_no_override": 27907.97,
    "override_total_1": 28699.84,
    "override_increase_1": 791.87
  },
  {
    "#": "46 Blake Rd (204-18-00)",
    "$": 2909400,
    "address": "46 Blake Rd",
    "parcel_id": "204-18-00",
    "owner1": "KEPPELER, JESSICA D & NICHOLAS D",
    "owner2": "",
    "current_taxes": 26157.32,
    "new_taxes_no_override": 27287.32,
    "override_total_1": 28061.57,
    "override_increase_1": 774.26
  },
  {
    "#": "49 Blake Rd (205-03-00)",
    "$": 2161500,
    "address": "49 Blake Rd",
    "parcel_id": "205-03-00",
    "owner1": "GEWURZ, BENJAMIN & SARA",
    "owner2": "",
    "current_taxes": 18498.83,
    "new_taxes_no_override": 19297.98,
    "override_total_1": 19845.54,
    "override_increase_1": 547.57
  },
  {
    "#": "50 Blake Rd (204-17-00)",
    "$": 2665900,
    "address": "50 Blake Rd",
    "parcel_id": "204-17-00",
    "owner1": "JUSTER, KENNETH G & ANNA E HOUSLEY",
    "owner2": "",
    "current_taxes": 23663.88,
    "new_taxes_no_override": 24686.16,
    "override_total_1": 25386.61,
    "override_increase_1": 700.45
  },
  {
    "#": "54 Blake Rd (204-16-00)",
    "$": 2801300,
    "address": "54 Blake Rd",
    "parcel_id": "204-16-00",
    "owner1": "HEBERT, MATTHEW L",
    "owner2": "ASIMACOPOULOS, ELENI PATRICIA",
    "current_taxes": 25050.38,
    "new_taxes_no_override": 26132.56,
    "override_total_1": 26874.05,
    "override_increase_1": 741.49
  },
  {
    "#": "55 Blake Rd (205-04-00)",
    "$": 2154900,
    "address": "55 Blake Rd",
    "parcel_id": "205-04-00",
    "owner1": "BERLINER, JEFFREY E & RONNA D",
    "owner2": "",
    "current_taxes": 18431.24,
    "new_taxes_no_override": 19227.47,
    "override_total_1": 19773.03,
    "override_increase_1": 545.56
  },
  {
    "#": "60 Blake Rd (204-15-00)",
    "$": 2636300,
    "address": "60 Blake Rd",
    "parcel_id": "204-15-00",
    "owner1": "GROSSMAN TRS, ANN CAROL",
    "owner2": "ARNOLD, GEOFFREY H",
    "current_taxes": 23360.78,
    "new_taxes_no_override": 24369.97,
    "override_total_1": 25061.44,
    "override_increase_1": 691.48
  },
  {
    "#": "61 Blake Rd (205-05-00)",
    "$": 2541100,
    "address": "61 Blake Rd",
    "parcel_id": "205-05-00",
    "owner1": "LEVIN, CAROL S",
    "owner2": "",
    "current_taxes": 22385.93,
    "new_taxes_no_override": 23353.0,
    "override_total_1": 24015.63,
    "override_increase_1": 662.62
  },
  {
    "#": "64 Blake Rd (204-14-00)",
    "$": 2531000,
    "address": "64 Blake Rd",
    "parcel_id": "204-14-00",
    "owner1": "KOREN, PAULA & GIDEON",
    "owner2": "",
    "current_taxes": 22282.51,
    "new_taxes_no_override": 23245.11,
    "override_total_1": 23904.68,
    "override_increase_1": 659.56
  },
  {
    "#": "65 Blake Rd (205-06-00)",
    "$": 1955800,
    "address": "65 Blake Rd",
    "parcel_id": "205-06-00",
    "owner1": "YANOWITZ, IRA S & ELAINE P",
    "owner2": "",
    "current_taxes": 16392.46,
    "new_taxes_no_override": 17100.61,
    "override_total_1": 17585.83,
    "override_increase_1": 485.22
  },
  {
    "#": "72 Blake Rd (204-13-00)",
    "$": 2357800,
    "address": "72 Blake Rd",
    "parcel_id": "204-13-00",
    "owner1": "EAGLE, ANNA MINARD & JOSHUA",
    "owner2": "",
    "current_taxes": 20508.94,
    "new_taxes_no_override": 21394.93,
    "override_total_1": 22001.99,
    "override_increase_1": 607.06
  },
  {
    "#": "75 Blake Rd (205-07-00)",
    "$": 2545100,
    "address": "75 Blake Rd",
    "parcel_id": "205-07-00",
    "owner1": "LIU, SHAN",
    "owner2": "GORMLEY, BRIAN",
    "current_taxes": 22426.89,
    "new_taxes_no_override": 23395.73,
    "override_total_1": 24059.57,
    "override_increase_1": 663.84
  },
  {
    "#": "83 Blake Rd (205A-08-01)",
    "$": 2722200,
    "address": "83 Blake Rd",
    "parcel_id": "205A-08-01",
    "owner1": "SEELY TR, ELLEN W",
    "owner2": "",
    "current_taxes": 24240.39,
    "new_taxes_no_override": 25287.57,
    "override_total_1": 26005.09,
    "override_increase_1": 717.52
  },
  {
    "#": "91 Blake Rd (205A-08-00)",
    "$": 2712700,
    "address": "91 Blake Rd",
    "parcel_id": "205A-08-00",
    "owner1": "TUNG LIFE ESTATE, SYLVIA C",
    "owner2": "",
    "current_taxes": 24143.11,
    "new_taxes_no_override": 25186.09,
    "override_total_1": 25900.73,
    "override_increase_1": 714.64
  },
  {
    "#": "95 Blake Rd (205A-09-00)",
    "$": 2482500,
    "address": "95 Blake Rd",
    "parcel_id": "205A-09-00",
    "owner1": "CHINCA, ALAIN & KAREN",
    "owner2": "",
    "current_taxes": 21785.87,
    "new_taxes_no_override": 22727.02,
    "override_total_1": 23371.88,
    "override_increase_1": 644.86
  },
  {
    "#": "101 Blake Rd (205A-09-01)",
    "$": 2928300,
    "address": "101 Blake Rd",
    "parcel_id": "205A-09-01",
    "owner1": "GUREN TRS, ADAM M",
    "owner2": "LEWANDOWSKI, KATHERINE CHAFFEE",
    "current_taxes": 26350.86,
    "new_taxes_no_override": 27489.22,
    "override_total_1": 28269.2,
    "override_increase_1": 779.99
  },
  {
    "#": "72 Bonad Rd (380-01-00)",
    "$": 14800,
    "address": "72 Bonad Rd",
    "parcel_id": "380-01-00",
    "owner1": "SEAVER, CAROLYN",
    "owner2": "",
    "current_taxes": 151.55,
    "new_taxes_no_override": 158.1,
    "override_total_1": 162.58,
    "override_increase_1": 4.49
  },
  {
    "#": "75 Bonad Rd (379-09-00)",
    "$": 188100,
    "address": "75 Bonad Rd",
    "parcel_id": "379-09-00",
    "owner1": "DEMPSEY, SEAN",
    "owner2": "GABILONDO, MAGDALENA",
    "current_taxes": 1926.14,
    "new_taxes_no_override": 2009.35,
    "override_total_1": 2066.36,
    "override_increase_1": 57.01
  },
  {
    "#": "78 Bonad Rd (380-02-00)",
    "$": 1682100,
    "address": "78 Bonad Rd",
    "parcel_id": "380-02-00",
    "owner1": "ODAY, SCOTT & LILIANA",
    "owner2": "",
    "current_taxes": 13589.77,
    "new_taxes_no_override": 14176.85,
    "override_total_1": 14579.11,
    "override_increase_1": 402.26
  },
  {
    "#": "79 Bonad Rd (379-08-00)",
    "$": 1336600,
    "address": "79 Bonad Rd",
    "parcel_id": "379-08-00",
    "owner1": "OCONNOR, MICHAEL F & ALLISON M",
    "owner2": "",
    "current_taxes": 10051.85,
    "new_taxes_no_override": 10486.09,
    "override_total_1": 10783.62,
    "override_increase_1": 297.53
  },
  {
    "#": "80 Bonad Rd (380-03-00)",
    "$": 1619800,
    "address": "80 Bonad Rd",
    "parcel_id": "380-03-00",
    "owner1": "MCCAUSLAND, FINNIAN",
    "owner2": "MCGRATH, MARTINA",
    "current_taxes": 12951.82,
    "new_taxes_no_override": 13511.34,
    "override_total_1": 13894.71,
    "override_increase_1": 383.37
  },
  {
    "#": "83 Bonad Rd (379-07-00)",
    "$": 1163600,
    "address": "83 Bonad Rd",
    "parcel_id": "379-07-00",
    "owner1": "BAYER, AMY E",
    "owner2": "",
    "current_taxes": 8280.33,
    "new_taxes_no_override": 8638.04,
    "override_total_1": 8883.14,
    "override_increase_1": 245.1
  },
  {
    "#": "84 Bonad Rd (380-04-00)",
    "$": 1710000,
    "address": "84 Bonad Rd",
    "parcel_id": "380-04-00",
    "owner1": "SUDEC, JOSHUA & JESSICA SANTARELLI",
    "owner2": "",
    "current_taxes": 13875.47,
    "new_taxes_no_override": 14474.89,
    "override_total_1": 14885.6,
    "override_increase_1": 410.71
  },
  {
    "#": "87 Bonad Rd (379-06-00)",
    "$": 979900,
    "address": "87 Bonad Rd",
    "parcel_id": "379-06-00",
    "owner1": "IVCEVIC, NIKICA",
    "owner2": "HOFFNAGLE, ALISON G",
    "current_taxes": 10034.18,
    "new_taxes_no_override": 10467.66,
    "override_total_1": 10764.67,
    "override_increase_1": 297.01
  },
  {
    "#": "88 Bonad Rd (380-05-00)",
    "$": 1170400,
    "address": "88 Bonad Rd",
    "parcel_id": "380-05-00",
    "owner1": "SENESKI, MARK",
    "owner2": "CHANG, I TING",
    "current_taxes": 8349.96,
    "new_taxes_no_override": 8710.68,
    "override_total_1": 8957.84,
    "override_increase_1": 247.16
  },
  {
    "#": "110 Bonad Rd (383-24-00)",
    "$": 1174800,
    "address": "110 Bonad Rd",
    "parcel_id": "383-24-00",
    "owner1": "HSU, PING HUANG & HSIU MEI",
    "owner2": "",
    "current_taxes": 8395.02,
    "new_taxes_no_override": 8757.68,
    "override_total_1": 9006.18,
    "override_increase_1": 248.49
  },
  {
    "#": "111 Bonad Rd (382-02-00)",
    "$": 1331400,
    "address": "111 Bonad Rd",
    "parcel_id": "382-02-00",
    "owner1": "GOLDMAN, ANNA L & WILLIAM I",
    "owner2": "",
    "current_taxes": 9998.6,
    "new_taxes_no_override": 10430.54,
    "override_total_1": 10726.5,
    "override_increase_1": 295.96
  },
  {
    "#": "114 Bonad Rd (383-23-00)",
    "$": 1262200,
    "address": "114 Bonad Rd",
    "parcel_id": "383-23-00",
    "owner1": "TSENG, MING TOU",
    "owner2": "CHIU, CHU",
    "current_taxes": 9289.99,
    "new_taxes_no_override": 9691.32,
    "override_total_1": 9966.3,
    "override_increase_1": 274.98
  },
  {
    "#": "117 Bonad Rd (382-03-00)",
    "$": 1033600,
    "address": "117 Bonad Rd",
    "parcel_id": "382-03-00",
    "owner1": "HARRINGTON, ARTHUR W & BEATRICE",
    "owner2": "",
    "current_taxes": 6949.13,
    "new_taxes_no_override": 7249.33,
    "override_total_1": 7455.03,
    "override_increase_1": 205.69
  },
  {
    "#": "118 Bonad Rd (383-22-00)",
    "$": 1053000,
    "address": "118 Bonad Rd",
    "parcel_id": "383-22-00",
    "owner1": "GRINBLAT TR, VITALY",
    "owner2": "",
    "current_taxes": 7147.79,
    "new_taxes_no_override": 7456.57,
    "override_total_1": 7668.15,
    "override_increase_1": 211.57
  },
  {
    "#": "121 Bonad Rd (382-04-00)",
    "$": 1088800,
    "address": "121 Bonad Rd",
    "parcel_id": "382-04-00",
    "owner1": "YU, CHUN",
    "owner2": "SUN, XIANGAO",
    "current_taxes": 7514.38,
    "new_taxes_no_override": 7839.0,
    "override_total_1": 8061.43,
    "override_increase_1": 222.43
  },
  {
    "#": "122 Bonad Rd (383-21-00)",
    "$": 968400,
    "address": "122 Bonad Rd",
    "parcel_id": "383-21-00",
    "owner1": "KOPELEV, YEVGENY & YELENA",
    "owner2": "",
    "current_taxes": 6281.48,
    "new_taxes_no_override": 6552.84,
    "override_total_1": 6738.77,
    "override_increase_1": 185.93
  },
  {
    "#": "125 Bonad Rd (382-05-00)",
    "$": 1135000,
    "address": "125 Bonad Rd",
    "parcel_id": "382-05-00",
    "owner1": "TOE, AUNG",
    "owner2": "",
    "current_taxes": 7987.47,
    "new_taxes_no_override": 8332.53,
    "override_total_1": 8568.96,
    "override_increase_1": 236.43
  },
  {
    "#": "126 Bonad Rd (383-20-00)",
    "$": 1266200,
    "address": "126 Bonad Rd",
    "parcel_id": "383-20-00",
    "owner1": "THIAGARAJAN, RAVI",
    "owner2": "",
    "current_taxes": 9330.95,
    "new_taxes_no_override": 9734.05,
    "override_total_1": 10010.24,
    "override_increase_1": 276.2
  },
  {
    "#": "129 Bonad Rd (382-06-00)",
    "$": 1155700,
    "address": "129 Bonad Rd",
    "parcel_id": "382-06-00",
    "owner1": "BRINEY TRS, ANDREW L",
    "owner2": "SHORT, ANNE H",
    "current_taxes": 11834.37,
    "new_taxes_no_override": 12345.61,
    "override_total_1": 12695.91,
    "override_increase_1": 350.3
  },
  {
    "#": "130 Bonad Rd (383-19-00)",
    "$": 1362400,
    "address": "130 Bonad Rd",
    "parcel_id": "383-19-00",
    "owner1": "MEYERS TRS, MICHAEL C",
    "owner2": "FEINGOLD MEYERS, AMY",
    "current_taxes": 10316.04,
    "new_taxes_no_override": 10761.69,
    "override_total_1": 11067.05,
    "override_increase_1": 305.35
  },
  {
    "#": "132 Bonad Rd (383-18-00)",
    "$": 1350500,
    "address": "132 Bonad Rd",
    "parcel_id": "383-18-00",
    "owner1": "KARALIS, GEORGE J & LISA M",
    "owner2": "",
    "current_taxes": 10194.19,
    "new_taxes_no_override": 10634.58,
    "override_total_1": 10936.33,
    "override_increase_1": 301.75
  },
  {
    "#": "133 Bonad Rd (382-07-00)",
    "$": 1001600,
    "address": "133 Bonad Rd",
    "parcel_id": "382-07-00",
    "owner1": "CHERNYKH, ANDREY",
    "owner2": "KARAVANNYKH, NADEZHDA",
    "current_taxes": 6621.45,
    "new_taxes_no_override": 6907.5,
    "override_total_1": 7103.49,
    "override_increase_1": 195.99
  },
  {
    "#": "136 Bonad Rd (383-17-00)",
    "$": 1315800,
    "address": "136 Bonad Rd",
    "parcel_id": "383-17-00",
    "owner1": "NEWMARK, KEVIN",
    "owner2": "LACOUTURE, HELEN",
    "current_taxes": 9838.86,
    "new_taxes_no_override": 10263.9,
    "override_total_1": 10555.13,
    "override_increase_1": 291.23
  },
  {
    "#": "137 Bonad Rd (382-08-00)",
    "$": 1284200,
    "address": "137 Bonad Rd",
    "parcel_id": "382-08-00",
    "owner1": "GLADSTONE, DAVID L & JOANNE N",
    "owner2": "",
    "current_taxes": 9515.27,
    "new_taxes_no_override": 9926.33,
    "override_total_1": 10207.98,
    "override_increase_1": 281.65
  },
  {
    "#": "140 Bonad Rd (383-16-00)",
    "$": 1132300,
    "address": "140 Bonad Rd",
    "parcel_id": "383-16-00",
    "owner1": "JURICH TR, MARILYN",
    "owner2": "",
    "current_taxes": 7959.82,
    "new_taxes_no_override": 8303.68,
    "override_total_1": 8539.29,
    "override_increase_1": 235.61
  },
  {
    "#": "141 Bonad Rd (382-09-00)",
    "$": 1170500,
    "address": "141 Bonad Rd",
    "parcel_id": "382-09-00",
    "owner1": "HARRIS, CHRISTOPHER E",
    "owner2": "",
    "current_taxes": 8350.99,
    "new_taxes_no_override": 8711.75,
    "override_total_1": 8958.94,
    "override_increase_1": 247.19
  },
  {
    "#": "145 Bonad Rd (382-10-00)",
    "$": 1110600,
    "address": "145 Bonad Rd",
    "parcel_id": "382-10-00",
    "owner1": "GRIFFIN, THOMAS MATTHEW",
    "owner2": "DALY GRIFFIN, EOWYN ANNE",
    "current_taxes": 7737.61,
    "new_taxes_no_override": 8071.87,
    "override_total_1": 8300.91,
    "override_increase_1": 229.03
  },
  {
    "#": "146 Bonad Rd (383-14-15)",
    "$": 1584800,
    "address": "146 Bonad Rd",
    "parcel_id": "383-14-15",
    "owner1": "GALLITANO, THOMAS J",
    "owner2": "TALMERS, MARGARET",
    "current_taxes": 12593.42,
    "new_taxes_no_override": 13137.46,
    "override_total_1": 13510.22,
    "override_increase_1": 372.77
  },
  {
    "#": "149 Bonad Rd (382-11-00)",
    "$": 1842000,
    "address": "149 Bonad Rd",
    "parcel_id": "382-11-00",
    "owner1": "GRUHN, LESLIE A",
    "owner2": "KLAUSSEN, KARL",
    "current_taxes": 15227.15,
    "new_taxes_no_override": 15884.96,
    "override_total_1": 16335.69,
    "override_increase_1": 450.72
  },
  {
    "#": "161 Bonad Rd (385-01-00)",
    "$": 1176700,
    "address": "161 Bonad Rd",
    "parcel_id": "385-01-00",
    "owner1": "AMOS, SOPHIE",
    "owner2": "CRAWFORD, DERRICK",
    "current_taxes": 8414.47,
    "new_taxes_no_override": 8777.98,
    "override_total_1": 9027.04,
    "override_increase_1": 249.07
  },
  {
    "#": "165 Bonad Rd (385-02-00)",
    "$": 1127000,
    "address": "165 Bonad Rd",
    "parcel_id": "385-02-00",
    "owner1": "EMMETT, COLLEEN",
    "owner2": "ENGELAND, EMILY",
    "current_taxes": 7905.55,
    "new_taxes_no_override": 8247.07,
    "override_total_1": 8481.07,
    "override_increase_1": 234.0
  },
  {
    "#": "166 Bonad Rd (386-19-00)",
    "$": 986300,
    "address": "166 Bonad Rd",
    "parcel_id": "386-19-00",
    "owner1": "NAZARI, SAM",
    "owner2": "",
    "current_taxes": 6464.78,
    "new_taxes_no_override": 6744.06,
    "override_total_1": 6935.42,
    "override_increase_1": 191.36
  },
  {
    "#": "169 Bonad Rd (385-03-00)",
    "$": 1199100,
    "address": "169 Bonad Rd",
    "parcel_id": "385-03-00",
    "owner1": "RODRIGUEZ, LUIS GUILLO",
    "owner2": "RUANO, MARIA ESTHER HERNANDEZ",
    "current_taxes": 8643.85,
    "new_taxes_no_override": 9017.26,
    "override_total_1": 9273.12,
    "override_increase_1": 255.86
  },
  {
    "#": "170 Bonad Rd (386-18-00)",
    "$": 1290000,
    "address": "170 Bonad Rd",
    "parcel_id": "386-18-00",
    "owner1": "MCMAHON TR, ELIZABETH K",
    "owner2": "",
    "current_taxes": 9574.67,
    "new_taxes_no_override": 9988.3,
    "override_total_1": 10271.71,
    "override_increase_1": 283.41
  },
  {
    "#": "173 Bonad Rd (385-04-00)",
    "$": 1137500,
    "address": "173 Bonad Rd",
    "parcel_id": "385-04-00",
    "owner1": "WILSON, CHARLES & MEREDITH",
    "owner2": "",
    "current_taxes": 8013.07,
    "new_taxes_no_override": 8359.23,
    "override_total_1": 8596.42,
    "override_increase_1": 237.19
  },
  {
    "#": "174 Bonad Rd (386-17-00)",
    "$": 1283100,
    "address": "174 Bonad Rd",
    "parcel_id": "386-17-00",
    "owner1": "CASEY, PAUL B",
    "owner2": "KELLEHER, JOAN",
    "current_taxes": 9504.01,
    "new_taxes_no_override": 9914.58,
    "override_total_1": 10195.9,
    "override_increase_1": 281.32
  },
  {
    "#": "177 Bonad Rd (385-05-00)",
    "$": 1140700,
    "address": "177 Bonad Rd",
    "parcel_id": "385-05-00",
    "owner1": "CHOU, LAISHENG",
    "owner2": "ZHANG, JIALING",
    "current_taxes": 8045.83,
    "new_taxes_no_override": 8393.41,
    "override_total_1": 8631.57,
    "override_increase_1": 238.16
  },
  {
    "#": "180 Bonad Rd (386-16-00)",
    "$": 1632300,
    "address": "180 Bonad Rd",
    "parcel_id": "386-16-00",
    "owner1": "TSENG, CHENG YIN & CHIU MEI",
    "owner2": "",
    "current_taxes": 13079.82,
    "new_taxes_no_override": 13644.87,
    "override_total_1": 14032.03,
    "override_increase_1": 387.16
  },
  {
    "#": "181 Bonad Rd (385-06-00)",
    "$": 1104500,
    "address": "181 Bonad Rd",
    "parcel_id": "385-06-00",
    "owner1": "SOUZA, SANDRA L",
    "owner2": "DEGLORIA, ALFRED",
    "current_taxes": 7675.15,
    "new_taxes_no_override": 8006.72,
    "override_total_1": 8233.9,
    "override_increase_1": 227.18
  },
  {
    "#": "184 Bonad Rd (386-15-00)",
    "$": 1069000,
    "address": "184 Bonad Rd",
    "parcel_id": "386-15-00",
    "owner1": "BEASLEY, KEITH L & JOAN B",
    "owner2": "",
    "current_taxes": 7311.63,
    "new_taxes_no_override": 7627.49,
    "override_total_1": 7843.92,
    "override_increase_1": 216.42
  },
  {
    "#": "186 Bonad Rd (386-14-00)",
    "$": 1162500,
    "address": "186 Bonad Rd",
    "parcel_id": "386-14-00",
    "owner1": "WARREN, MARK WESLEY",
    "owner2": "",
    "current_taxes": 8269.07,
    "new_taxes_no_override": 8626.29,
    "override_total_1": 8871.06,
    "override_increase_1": 244.76
  },
  {
    "#": "187 Bonad Rd (385-07-00)",
    "$": 1109800,
    "address": "187 Bonad Rd",
    "parcel_id": "385-07-00",
    "owner1": "COOPERSMITH, ROBERT",
    "owner2": "TISHELMAN, AMY",
    "current_taxes": 7729.42,
    "new_taxes_no_override": 8063.33,
    "override_total_1": 8292.12,
    "override_increase_1": 228.79
  },
  {
    "#": "191 Bonad Rd (385-08-00)",
    "$": 1620800,
    "address": "191 Bonad Rd",
    "parcel_id": "385-08-00",
    "owner1": "JAY TRS, EDWARD W JR & HEIDI S",
    "owner2": "",
    "current_taxes": 12962.06,
    "new_taxes_no_override": 13522.02,
    "override_total_1": 13905.7,
    "override_increase_1": 383.68
  },
  {
    "#": "192 Bonad Rd (386-13-00)",
    "$": 1048300,
    "address": "192 Bonad Rd",
    "parcel_id": "386-13-00",
    "owner1": "GONG TRS, BING F & JOYCE",
    "owner2": "",
    "current_taxes": 7099.66,
    "new_taxes_no_override": 7406.37,
    "override_total_1": 7616.52,
    "override_increase_1": 210.15
  },
  {
    "#": "195 Bonad Rd (385-09-00)",
    "$": 1966600,
    "address": "195 Bonad Rd",
    "parcel_id": "385-09-00",
    "owner1": "TRAVAYIAKIS TRS, KONSTANTINOS & CAROL",
    "owner2": "",
    "current_taxes": 16503.05,
    "new_taxes_no_override": 17215.98,
    "override_total_1": 17704.47,
    "override_increase_1": 488.49
  },
  {
    "#": "196 Bonad Rd (386-12-00)",
    "$": 1133600,
    "address": "196 Bonad Rd",
    "parcel_id": "386-12-00",
    "owner1": "LINDBLOM, JENNY L & SUZANNE M",
    "owner2": "",
    "current_taxes": 7973.13,
    "new_taxes_no_override": 8317.57,
    "override_total_1": 8553.57,
    "override_increase_1": 236.0
  },
  {
    "#": "205 Bonad Rd (391-15-00)",
    "$": 1295700,
    "address": "205 Bonad Rd",
    "parcel_id": "391-15-00",
    "owner1": "SANDERS, ZACHARY B & BETHANY A",
    "owner2": "",
    "current_taxes": 9633.03,
    "new_taxes_no_override": 10049.18,
    "override_total_1": 10334.31,
    "override_increase_1": 285.14
  },
  {
    "#": "209 Bonad Rd (391-16-00)",
    "$": 990800,
    "address": "209 Bonad Rd",
    "parcel_id": "391-16-00",
    "owner1": "FELDMAN TR, DEBORAH E",
    "owner2": "",
    "current_taxes": 6510.86,
    "new_taxes_no_override": 6792.13,
    "override_total_1": 6984.85,
    "override_increase_1": 192.72
  },
  {
    "#": "210 Bonad Rd (390-12-00)",
    "$": 1298900,
    "address": "210 Bonad Rd",
    "parcel_id": "390-12-00",
    "owner1": "MISTRETTA, LAUREN",
    "owner2": "DEAN, ANDREW",
    "current_taxes": 9665.8,
    "new_taxes_no_override": 10083.36,
    "override_total_1": 10369.47,
    "override_increase_1": 286.11
  },
  {
    "#": "213 Bonad Rd (391-17-00)",
    "$": 1212600,
    "address": "213 Bonad Rd",
    "parcel_id": "391-17-00",
    "owner1": "SPOOL, IRA",
    "owner2": "",
    "current_taxes": 8782.09,
    "new_taxes_no_override": 9161.48,
    "override_total_1": 9421.43,
    "override_increase_1": 259.95
  },
  {
    "#": "214 Bonad Rd (390-11-00)",
    "$": 1288500,
    "address": "214 Bonad Rd",
    "parcel_id": "390-11-00",
    "owner1": "GILAD TRS, SHALEV & SHULA",
    "owner2": "",
    "current_taxes": 9559.31,
    "new_taxes_no_override": 9972.27,
    "override_total_1": 10255.23,
    "override_increase_1": 282.96
  },
  {
    "#": "217 Bonad Rd (391-18-00)",
    "$": 1470100,
    "address": "217 Bonad Rd",
    "parcel_id": "391-18-00",
    "owner1": "YI, RONG",
    "owner2": "MU, DANHAI",
    "current_taxes": 11418.89,
    "new_taxes_no_override": 11912.19,
    "override_total_1": 12250.19,
    "override_increase_1": 338.0
  },
  {
    "#": "218 Bonad Rd (390-10-00)",
    "$": 1092600,
    "address": "218 Bonad Rd",
    "parcel_id": "390-10-00",
    "owner1": "FURMAN, JEROME F & SANDRA",
    "owner2": "",
    "current_taxes": 7553.29,
    "new_taxes_no_override": 7879.59,
    "override_total_1": 8103.17,
    "override_increase_1": 223.58
  },
  {
    "#": "222 Bonad Rd (390-09-00)",
    "$": 1350700,
    "address": "222 Bonad Rd",
    "parcel_id": "390-09-00",
    "owner1": "VARADARAJAN, VINITHA",
    "owner2": "SHASTRY, MAHESH CHANDRAMOULI",
    "current_taxes": 10196.23,
    "new_taxes_no_override": 10636.71,
    "override_total_1": 10938.52,
    "override_increase_1": 301.81
  },
  {
    "#": "223 Bonad Rd (391-19-00)",
    "$": 1433200,
    "address": "223 Bonad Rd",
    "parcel_id": "391-19-00",
    "owner1": "HAN, JUN",
    "owner2": "",
    "current_taxes": 14675.97,
    "new_taxes_no_override": 15309.97,
    "override_total_1": 15744.38,
    "override_increase_1": 434.41
  },
  {
    "#": "226 Bonad Rd (390-08-01)",
    "$": 1068100,
    "address": "226 Bonad Rd",
    "parcel_id": "390-08-01",
    "owner1": "KALFIN, JUDY",
    "owner2": "",
    "current_taxes": 10937.34,
    "new_taxes_no_override": 11409.83,
    "override_total_1": 11733.58,
    "override_increase_1": 323.75
  },
  {
    "#": "227 Bonad Rd (391-20-00)",
    "$": 1458300,
    "address": "227 Bonad Rd",
    "parcel_id": "391-20-00",
    "owner1": "MATTA, ANDRE PALMA DA CUNHA & GABRIELA DIECKMANN JEOLAS",
    "owner2": "",
    "current_taxes": 11298.06,
    "new_taxes_no_override": 11786.14,
    "override_total_1": 12120.56,
    "override_increase_1": 334.42
  },
  {
    "#": "230 Bonad Rd (390-08-00)",
    "$": 1072400,
    "address": "230 Bonad Rd",
    "parcel_id": "390-08-00",
    "owner1": "CHEN, HUICHAO",
    "owner2": "XU, XIANGJIN",
    "current_taxes": 7346.44,
    "new_taxes_no_override": 7663.81,
    "override_total_1": 7881.26,
    "override_increase_1": 217.45
  },
  {
    "#": "233 Bonad Rd (391-21-00)",
    "$": 1166600,
    "address": "233 Bonad Rd",
    "parcel_id": "391-21-00",
    "owner1": "STOLLER, TR, GERTRUDE",
    "owner2": "",
    "current_taxes": 8311.05,
    "new_taxes_no_override": 8670.09,
    "override_total_1": 8916.09,
    "override_increase_1": 246.01
  },
  {
    "#": "234 Bonad Rd (390-07-00)",
    "$": 1360000,
    "address": "234 Bonad Rd",
    "parcel_id": "390-07-00",
    "owner1": "NISTLER, MERYL & TIMOTHY",
    "owner2": "",
    "current_taxes": 10291.47,
    "new_taxes_no_override": 10736.06,
    "override_total_1": 11040.69,
    "override_increase_1": 304.63
  },
  {
    "#": "237 Bonad Rd (391-22-00)",
    "$": 1618500,
    "address": "237 Bonad Rd",
    "parcel_id": "391-22-00",
    "owner1": "MARK, STEVEN R & JOANNA R",
    "owner2": "",
    "current_taxes": 12938.51,
    "new_taxes_no_override": 13497.45,
    "override_total_1": 13880.43,
    "override_increase_1": 382.98
  },
  {
    "#": "238 Bonad Rd (390-06-00)",
    "$": 1307200,
    "address": "238 Bonad Rd",
    "parcel_id": "390-06-00",
    "owner1": "LOPEZ, SARA OCANA",
    "owner2": "MORENO, DAVID VICARIO",
    "current_taxes": 9750.79,
    "new_taxes_no_override": 10172.02,
    "override_total_1": 10460.65,
    "override_increase_1": 288.62
  },
  {
    "#": "241 Bonad Rd (391-23-00)",
    "$": 1330700,
    "address": "241 Bonad Rd",
    "parcel_id": "391-23-00",
    "owner1": "WISE TRS, ADAM K & ANN STARNBACH",
    "owner2": "",
    "current_taxes": 9991.43,
    "new_taxes_no_override": 10423.06,
    "override_total_1": 10718.81,
    "override_increase_1": 295.75
  },
  {
    "#": "244 Bonad Rd (390-05-00)",
    "$": 1600000,
    "address": "244 Bonad Rd",
    "parcel_id": "390-05-00",
    "owner1": "VESTIN, SUSAN M & JEROME EYTAN",
    "owner2": "",
    "current_taxes": 12749.07,
    "new_taxes_no_override": 13299.83,
    "override_total_1": 13677.2,
    "override_increase_1": 377.37
  },
  {
    "#": "247 Bonad Rd (391-23-01)",
    "$": 1515200,
    "address": "247 Bonad Rd",
    "parcel_id": "391-23-01",
    "owner1": "WONG, EUGENE K",
    "owner2": "SONNENSCHEIN, IRIS",
    "current_taxes": 11880.71,
    "new_taxes_no_override": 12393.96,
    "override_total_1": 12745.63,
    "override_increase_1": 351.67
  },
  {
    "#": "250 Bonad Rd (390-04-00)",
    "$": 1257100,
    "address": "250 Bonad Rd",
    "parcel_id": "390-04-00",
    "owner1": "ELSTEIN, ELANA",
    "owner2": "KEISLER, JEFFREY M",
    "current_taxes": 9237.77,
    "new_taxes_no_override": 9636.84,
    "override_total_1": 9910.28,
    "override_increase_1": 273.44
  },
  {
    "#": "251 Bonad Rd (391-24-00)",
    "$": 1193500,
    "address": "251 Bonad Rd",
    "parcel_id": "391-24-00",
    "owner1": "ZILBERMAN, MARK V & IRINA S",
    "owner2": "",
    "current_taxes": 8586.51,
    "new_taxes_no_override": 8957.45,
    "override_total_1": 9211.61,
    "override_increase_1": 254.16
  },
  {
    "#": "256 Bonad Rd (390-03-00)",
    "$": 1133200,
    "address": "256 Bonad Rd",
    "parcel_id": "390-03-00",
    "owner1": "GOLDFINE, RICHARD",
    "owner2": "",
    "current_taxes": 7969.03,
    "new_taxes_no_override": 8313.29,
    "override_total_1": 8549.18,
    "override_increase_1": 235.88
  },
  {
    "#": "257 Bonad Rd (391-25-00)",
    "$": 1589000,
    "address": "257 Bonad Rd",
    "parcel_id": "391-25-00",
    "owner1": "ITALIANO TRS, LAUREN E & JOSEPH E JR",
    "owner2": "",
    "current_taxes": 12636.43,
    "new_taxes_no_override": 13182.32,
    "override_total_1": 13556.36,
    "override_increase_1": 374.04
  },
  {
    "#": "262 Bonad Rd (390-02-00)",
    "$": 1213400,
    "address": "262 Bonad Rd",
    "parcel_id": "390-02-00",
    "owner1": "BUDD TR, BERTRAM",
    "owner2": "",
    "current_taxes": 8790.28,
    "new_taxes_no_override": 9170.02,
    "override_total_1": 9430.21,
    "override_increase_1": 260.19
  },
  {
    "#": "263 Bonad Rd (391-26-00)",
    "$": 1521600,
    "address": "263 Bonad Rd",
    "parcel_id": "391-26-00",
    "owner1": "DULBERG, ET AL, HARVEY N",
    "owner2": "",
    "current_taxes": 11946.25,
    "new_taxes_no_override": 12462.33,
    "override_total_1": 12815.94,
    "override_increase_1": 353.61
  },
  {
    "#": "269 Bonad Rd (391-27-00)",
    "$": 1382200,
    "address": "269 Bonad Rd",
    "parcel_id": "391-27-00",
    "owner1": "RANGASWAMY, PUNEETH NETTEKERE",
    "owner2": "RAMALINGAIAH, BHARGAVI BELATHUR",
    "current_taxes": 10518.79,
    "new_taxes_no_override": 10973.2,
    "override_total_1": 11284.56,
    "override_increase_1": 311.36
  },
  {
    "#": "15 Borland St (118-15-00)",
    "$": 3662900,
    "address": "15 Borland St",
    "parcel_id": "118-15-00",
    "owner1": "ROCK TR, LAURA K",
    "owner2": "",
    "current_taxes": 33873.16,
    "new_taxes_no_override": 35336.48,
    "override_total_1": 36339.13,
    "override_increase_1": 1002.65
  },
  {
    "#": "21 Borland St (118-16-00)",
    "$": 3459600,
    "address": "21 Borland St",
    "parcel_id": "118-16-00",
    "owner1": "OPERT TRS, LAWRENCE R",
    "owner2": "MITCHELL, STEPHANIE",
    "current_taxes": 35426.3,
    "new_taxes_no_override": 36956.72,
    "override_total_1": 38005.33,
    "override_increase_1": 1048.62
  },
  {
    "#": "32 Borland St (117-04-00)",
    "$": 4022400,
    "address": "32 Borland St",
    "parcel_id": "117-04-00",
    "owner1": "PRICE TRS, ALKES L & MEGAN ELLIS",
    "owner2": "",
    "current_taxes": 37554.44,
    "new_taxes_no_override": 39176.79,
    "override_total_1": 40288.4,
    "override_increase_1": 1111.61
  },
  {
    "#": "2 Bowker St (145-11-00)",
    "$": 1865200,
    "address": "2 Bowker St",
    "parcel_id": "145-11-00",
    "owner1": "BARTEL, DAVID P",
    "owner2": "",
    "current_taxes": 15464.71,
    "new_taxes_no_override": 16132.79,
    "override_total_1": 16590.54,
    "override_increase_1": 457.76
  },
  {
    "#": "8 Bowker St (145-10-00)",
    "$": 1770900,
    "address": "8 Bowker St",
    "parcel_id": "145-10-00",
    "owner1": "FARLOW LIFE ESTATE, MARTHA A",
    "owner2": "",
    "current_taxes": 14499.08,
    "new_taxes_no_override": 15125.44,
    "override_total_1": 15554.61,
    "override_increase_1": 429.17
  },
  {
    "#": "9 Bowker St (146-08-01)",
    "$": 1838400,
    "address": "9 Bowker St",
    "parcel_id": "146-08-01",
    "owner1": "MORIARTY TRS, SUSAN E",
    "owner2": "MURPHY, PATRICIA E",
    "current_taxes": 18825.22,
    "new_taxes_no_override": 19638.47,
    "override_total_1": 20195.7,
    "override_increase_1": 557.23
  },
  {
    "#": "10 Bowker St (145-09-00)",
    "$": 1768100,
    "address": "10 Bowker St",
    "parcel_id": "145-09-00",
    "owner1": "KELLEY, CHERYL M",
    "owner2": "",
    "current_taxes": 14470.41,
    "new_taxes_no_override": 15095.53,
    "override_total_1": 15523.86,
    "override_increase_1": 428.32
  },
  {
    "#": "14 Bowker St (145-08-00)",
    "$": 1845900,
    "address": "14 Bowker St",
    "parcel_id": "145-08-00",
    "owner1": "LEE ET AL TRS, PETER K",
    "owner2": "",
    "current_taxes": 15267.08,
    "new_taxes_no_override": 15926.62,
    "override_total_1": 16378.52,
    "override_increase_1": 451.91
  },
  {
    "#": "15 Bowker St (146-09-00)",
    "$": 1863100,
    "address": "15 Bowker St",
    "parcel_id": "146-09-00",
    "owner1": "WILLIAMSON, ET AL, ROBERT S",
    "owner2": "",
    "current_taxes": 15443.21,
    "new_taxes_no_override": 16110.36,
    "override_total_1": 16567.48,
    "override_increase_1": 457.12
  },
  {
    "#": "16 Bowker St (145-07-00)",
    "$": 1880000,
    "address": "16 Bowker St",
    "parcel_id": "145-07-00",
    "owner1": "ROWE, MARTIN & CINDY",
    "owner2": "",
    "current_taxes": 15616.27,
    "new_taxes_no_override": 16290.89,
    "override_total_1": 16753.13,
    "override_increase_1": 462.24
  },
  {
    "#": "17 Bowker St (146-10-00)",
    "$": 2141100,
    "address": "17 Bowker St",
    "parcel_id": "146-10-00",
    "owner1": "HO, CAROLYN Y",
    "owner2": "",
    "current_taxes": 18289.93,
    "new_taxes_no_override": 19080.05,
    "override_total_1": 19621.44,
    "override_increase_1": 541.38
  },
  {
    "#": "18 Bowker St (145-07-01)",
    "$": 2117500,
    "address": "18 Bowker St",
    "parcel_id": "145-07-01",
    "owner1": "WANG, XIAOWEN",
    "owner2": "HAN, BINGHONG",
    "current_taxes": 18048.27,
    "new_taxes_no_override": 18827.96,
    "override_total_1": 19362.18,
    "override_increase_1": 534.23
  },
  {
    "#": "19 Bowker St (146-11-00)",
    "$": 2058800,
    "address": "19 Bowker St",
    "parcel_id": "146-11-00",
    "owner1": "ZECRI, FREDERIC & ANGELA",
    "owner2": "",
    "current_taxes": 17447.18,
    "new_taxes_no_override": 18200.9,
    "override_total_1": 18717.33,
    "override_increase_1": 516.44
  },
  {
    "#": "21 Bowker St (146-11-01)",
    "$": 1869300,
    "address": "21 Bowker St",
    "parcel_id": "146-11-01",
    "owner1": "TUCKER, NATHANIEL B III",
    "owner2": "WONG TUCKER, ALICE",
    "current_taxes": 15506.7,
    "new_taxes_no_override": 16176.59,
    "override_total_1": 16635.59,
    "override_increase_1": 459.0
  },
  {
    "#": "22 Bowker St (145-06-00)",
    "$": 2390500,
    "address": "22 Bowker St",
    "parcel_id": "145-06-00",
    "owner1": "GREENSTEIN, ILANA",
    "owner2": "MACIAS, MANUEL",
    "current_taxes": 20843.79,
    "new_taxes_no_override": 21744.24,
    "override_total_1": 22361.22,
    "override_increase_1": 616.98
  },
  {
    "#": "24 Bowker St, Unit 1 (145-05-01)",
    "$": 1935800,
    "address": "24 Bowker St, Unit 1",
    "parcel_id": "145-05-01",
    "owner1": "STEIN, MARY LYNETTE",
    "owner2": "LEVY, JONATHAN M",
    "current_taxes": 16187.66,
    "new_taxes_no_override": 16886.97,
    "override_total_1": 17366.12,
    "override_increase_1": 479.15
  },
  {
    "#": "24 Bowker St, Unit 2 (145-05-02)",
    "$": 1808500,
    "address": "24 Bowker St, Unit 2",
    "parcel_id": "145-05-02",
    "owner1": "LEITER, RICHARD & STEPHANIE",
    "owner2": "",
    "current_taxes": 14884.11,
    "new_taxes_no_override": 15527.1,
    "override_total_1": 15967.67,
    "override_increase_1": 440.57
  },
  {
    "#": "25 Bowker St (146-12-00)",
    "$": 2031900,
    "address": "25 Bowker St",
    "parcel_id": "146-12-00",
    "owner1": "WOODMAN TR, MELISSA HALE",
    "owner2": "",
    "current_taxes": 20806.66,
    "new_taxes_no_override": 21705.51,
    "override_total_1": 22321.38,
    "override_increase_1": 615.88
  },
  {
    "#": "27 Bowker St (146-12-01)",
    "$": 1785400,
    "address": "27 Bowker St",
    "parcel_id": "146-12-01",
    "owner1": "LAU TRS, CHI CHUNG & TOY SOO",
    "owner2": "",
    "current_taxes": 14647.56,
    "new_taxes_no_override": 15280.33,
    "override_total_1": 15713.9,
    "override_increase_1": 433.57
  },
  {
    "#": "30 Bowker St (145-04-01)",
    "$": 1677000,
    "address": "30 Bowker St",
    "parcel_id": "145-04-01",
    "owner1": "MURRAY, PATRICIA & NAGANO T",
    "owner2": "",
    "current_taxes": 13537.55,
    "new_taxes_no_override": 14122.37,
    "override_total_1": 14523.08,
    "override_increase_1": 400.71
  },
  {
    "#": "31 Bowker St, Unit 1 (146-13-01)",
    "$": 1159800,
    "address": "31 Bowker St, Unit 1",
    "parcel_id": "146-13-01",
    "owner1": "NOBREGA, ARTHUR B & MARIAH C",
    "owner2": "",
    "current_taxes": 8241.42,
    "new_taxes_no_override": 8597.45,
    "override_total_1": 8841.4,
    "override_increase_1": 243.95
  },
  {
    "#": "31 Bowker St, Unit 2 (146-13-02)",
    "$": 1307300,
    "address": "31 Bowker St, Unit 2",
    "parcel_id": "146-13-02",
    "owner1": "MARTIN, ALEXA",
    "owner2": "",
    "current_taxes": 9751.82,
    "new_taxes_no_override": 10173.1,
    "override_total_1": 10461.75,
    "override_increase_1": 288.65
  },
  {
    "#": "32 Bowker St (145-04-00)",
    "$": 1684200,
    "address": "32 Bowker St",
    "parcel_id": "145-04-00",
    "owner1": "PERRY TRS, FREDERICK S JR",
    "owner2": "SMITH, SARAH W R",
    "current_taxes": 17246.21,
    "new_taxes_no_override": 17991.25,
    "override_total_1": 18501.73,
    "override_increase_1": 510.49
  },
  {
    "#": "34 Bowker St, Unit 34 (145-03-01)",
    "$": 1772700,
    "address": "34 Bowker St, Unit 34",
    "parcel_id": "145-03-01",
    "owner1": "DABORA, SANDRA",
    "owner2": "SIMON, DAVID",
    "current_taxes": 14517.51,
    "new_taxes_no_override": 15144.67,
    "override_total_1": 15574.38,
    "override_increase_1": 429.72
  },
  {
    "#": "35 Bowker St (146-14-00)",
    "$": 1821400,
    "address": "35 Bowker St",
    "parcel_id": "146-14-00",
    "owner1": "COGLIANO, JAMES & ALEXIS",
    "owner2": "",
    "current_taxes": 15016.2,
    "new_taxes_no_override": 15664.9,
    "override_total_1": 16109.38,
    "override_increase_1": 444.48
  },
  {
    "#": "36 Bowker St, Unit 36 (145-03-02)",
    "$": 1815300,
    "address": "36 Bowker St, Unit 36",
    "parcel_id": "145-03-02",
    "owner1": "FARIAS, MICHAEL J & KRISTIN",
    "owner2": "",
    "current_taxes": 14953.74,
    "new_taxes_no_override": 15599.74,
    "override_total_1": 16042.37,
    "override_increase_1": 442.63
  },
  {
    "#": "38 Bowker St (145-02-01)",
    "$": 1473300,
    "address": "38 Bowker St",
    "parcel_id": "145-02-01",
    "owner1": "38 BOWKER LLC",
    "owner2": "",
    "current_taxes": 15086.59,
    "new_taxes_no_override": 15738.33,
    "override_total_1": 16184.89,
    "override_increase_1": 446.56
  },
  {
    "#": "40 Bowker St (145-02-00)",
    "$": 1868500,
    "address": "40 Bowker St",
    "parcel_id": "145-02-00",
    "owner1": "OBRIEN, WILLIAM V & LAURA P",
    "owner2": "",
    "current_taxes": 15498.51,
    "new_taxes_no_override": 16168.05,
    "override_total_1": 16626.8,
    "override_increase_1": 458.76
  },
  {
    "#": "41 Bowker St (146-15-00)",
    "$": 2016300,
    "address": "41 Bowker St",
    "parcel_id": "146-15-00",
    "owner1": "AXELROD TR, SARAH T",
    "owner2": "",
    "current_taxes": 17011.98,
    "new_taxes_no_override": 17746.9,
    "override_total_1": 18250.45,
    "override_increase_1": 503.55
  },
  {
    "#": "45 Bowker St, Unit 43 (146-16-01)",
    "$": 2210700,
    "address": "45 Bowker St, Unit 43",
    "parcel_id": "146-16-01",
    "owner1": "HAQ, SIDDIQUE L",
    "owner2": "MURRAY, SARAH",
    "current_taxes": 19002.63,
    "new_taxes_no_override": 19823.54,
    "override_total_1": 20386.02,
    "override_increase_1": 562.48
  },
  {
    "#": "45 Bowker St, Unit 45 (146-16-02)",
    "$": 1741500,
    "address": "45 Bowker St, Unit 45",
    "parcel_id": "146-16-02",
    "owner1": "BATHLA, GUNJAN",
    "owner2": "FINN, PATRICK",
    "current_taxes": 17832.96,
    "new_taxes_no_override": 18603.34,
    "override_total_1": 19131.2,
    "override_increase_1": 527.86
  },
  {
    "#": "47 Bowker St (146-17-00)",
    "$": 1983500,
    "address": "47 Bowker St",
    "parcel_id": "146-17-00",
    "owner1": "QI, ZHENYU",
    "owner2": "BAO, YAJING",
    "current_taxes": 16676.11,
    "new_taxes_no_override": 17396.52,
    "override_total_1": 17890.13,
    "override_increase_1": 493.61
  },
  {
    "#": "14 Boylston Pl (189-23-00)",
    "$": 1377300,
    "address": "14 Boylston Pl",
    "parcel_id": "189-23-00",
    "owner1": "EMAD REALTY LLC",
    "owner2": "",
    "current_taxes": 23634.47,
    "new_taxes_no_override": 24655.48,
    "override_total_1": 25355.06,
    "override_increase_1": 699.58
  },
  {
    "#": "19 Boylston St (185-03-00)",
    "$": 1654400,
    "address": "19 Boylston St",
    "parcel_id": "185-03-00",
    "owner1": "BOSTON EDISON CO",
    "owner2": "C/O NSTAR PROPERTY TAX DEPT",
    "current_taxes": 28389.5,
    "new_taxes_no_override": 29615.93,
    "override_total_1": 30456.26,
    "override_increase_1": 840.33
  },
  {
    "#": "20 Boylston St, Unit 1 & G11-G13 (318-45-03)",
    "$": 1323900,
    "address": "20 Boylston St, Unit 1 & G11-G13",
    "parcel_id": "318-45-03",
    "owner1": "SHETH BROTHERS LLC",
    "owner2": "",
    "current_taxes": 13556.74,
    "new_taxes_no_override": 14142.39,
    "override_total_1": 14543.67,
    "override_increase_1": 401.28
  },
  {
    "#": "20 Boylston St, Unit 10 & G22 (318-45-12)",
    "$": 1364400,
    "address": "20 Boylston St, Unit 10 & G22",
    "parcel_id": "318-45-12",
    "owner1": "ZHONG, WEI TAN",
    "owner2": "RUAN, TINA",
    "current_taxes": 13971.46,
    "new_taxes_no_override": 14575.03,
    "override_total_1": 14988.58,
    "override_increase_1": 413.56
  },
  {
    "#": "20 Boylston St, Unit 11 & G4 (318-45-13)",
    "$": 1371100,
    "address": "20 Boylston St, Unit 11 & G4",
    "parcel_id": "318-45-13",
    "owner1": "LEE, PHILIP & CHLOE",
    "owner2": "",
    "current_taxes": 14040.06,
    "new_taxes_no_override": 14646.59,
    "override_total_1": 15062.18,
    "override_increase_1": 415.59
  },
  {
    "#": "20 Boylston St, Unit 12 & G5 (318-45-14)",
    "$": 1398300,
    "address": "20 Boylston St, Unit 12 & G5",
    "parcel_id": "318-45-14",
    "owner1": "FRANKIW, LUKE",
    "owner2": "",
    "current_taxes": 10683.66,
    "new_taxes_no_override": 11145.19,
    "override_total_1": 11461.43,
    "override_increase_1": 316.24
  },
  {
    "#": "20 Boylston St, Unit 14 & G24 G25 (318-45-15)",
    "$": 1735200,
    "address": "20 Boylston St, Unit 14 & G24 G25",
    "parcel_id": "318-45-15",
    "owner1": "BRAUER TRS, SHELLEY B",
    "owner2": "HEY, JEAN L D",
    "current_taxes": 14133.51,
    "new_taxes_no_override": 14744.08,
    "override_total_1": 15162.43,
    "override_increase_1": 418.35
  },
  {
    "#": "20 Boylston St, Unit 15 & G21 (318-45-16)",
    "$": 1513700,
    "address": "20 Boylston St, Unit 15 & G21",
    "parcel_id": "318-45-16",
    "owner1": "KANG, HYUNG CHUL",
    "owner2": "",
    "current_taxes": 15500.29,
    "new_taxes_no_override": 16169.9,
    "override_total_1": 16628.71,
    "override_increase_1": 458.81
  },
  {
    "#": "20 Boylston St, Unit 2 & G2-G3 (318-45-04)",
    "$": 1406700,
    "address": "20 Boylston St, Unit 2 & G2-G3",
    "parcel_id": "318-45-04",
    "owner1": "SHETH BROTHERS LLC",
    "owner2": "",
    "current_taxes": 14404.61,
    "new_taxes_no_override": 15026.89,
    "override_total_1": 15453.27,
    "override_increase_1": 426.38
  },
  {
    "#": "20 Boylston St, Unit 3 & G12 (318-45-05)",
    "$": 1080600,
    "address": "20 Boylston St, Unit 3 & G12",
    "parcel_id": "318-45-05",
    "owner1": "CALTRIDER, STEVEN",
    "owner2": "",
    "current_taxes": 11065.34,
    "new_taxes_no_override": 11543.36,
    "override_total_1": 11870.9,
    "override_increase_1": 327.53
  },
  {
    "#": "20 Boylston St, Unit 4 & G16 (318-45-06)",
    "$": 1472900,
    "address": "20 Boylston St, Unit 4 & G16",
    "parcel_id": "318-45-06",
    "owner1": "KORCHMAR, GENNADY & MARIANA",
    "owner2": "",
    "current_taxes": 11447.56,
    "new_taxes_no_override": 11942.09,
    "override_total_1": 12280.94,
    "override_increase_1": 338.85
  },
  {
    "#": "20 Boylston St, Unit 5 & G17 (318-45-07)",
    "$": 1364400,
    "address": "20 Boylston St, Unit 5 & G17",
    "parcel_id": "318-45-07",
    "owner1": "KORCHMAR, GENNADY & MARIANA",
    "owner2": "",
    "current_taxes": 13971.46,
    "new_taxes_no_override": 14575.03,
    "override_total_1": 14988.58,
    "override_increase_1": 413.56
  },
  {
    "#": "20 Boylston St, Unit 6  (318-45-08)",
    "$": 1144200,
    "address": "20 Boylston St, Unit 6 ",
    "parcel_id": "318-45-08",
    "owner1": "ZHL INTERNATIONAL LLC",
    "owner2": "",
    "current_taxes": 11716.61,
    "new_taxes_no_override": 12222.77,
    "override_total_1": 12569.58,
    "override_increase_1": 346.81
  },
  {
    "#": "20 Boylston St, Unit 7 & G1 (318-45-09)",
    "$": 1316800,
    "address": "20 Boylston St, Unit 7 & G1",
    "parcel_id": "318-45-09",
    "owner1": "ZAIGER TR, ADAM M",
    "owner2": "",
    "current_taxes": 13484.03,
    "new_taxes_no_override": 14066.54,
    "override_total_1": 14465.67,
    "override_increase_1": 399.13
  },
  {
    "#": "20 Boylston St, Unit 8 & G14 (318-45-10)",
    "$": 990700,
    "address": "20 Boylston St, Unit 8 & G14",
    "parcel_id": "318-45-10",
    "owner1": "KALINICHENKO, BORIS",
    "owner2": "",
    "current_taxes": 10144.77,
    "new_taxes_no_override": 10583.02,
    "override_total_1": 10883.31,
    "override_increase_1": 300.29
  },
  {
    "#": "20 Boylston St, Unit 9 & G19-G20 (318-45-11)",
    "$": 1562800,
    "address": "20 Boylston St, Unit 9 & G19-G20",
    "parcel_id": "318-45-11",
    "owner1": "NG, NANCY",
    "owner2": "",
    "current_taxes": 16003.07,
    "new_taxes_no_override": 16694.4,
    "override_total_1": 17168.09,
    "override_increase_1": 473.69
  },
  {
    "#": "20 Boylston St, Unit Cs1 (318-45-01)",
    "$": 2978100,
    "address": "20 Boylston St, Unit Cs1",
    "parcel_id": "318-45-01",
    "owner1": "KENWOOD INVESTMENTS LLC",
    "owner2": "",
    "current_taxes": 51104.2,
    "new_taxes_no_override": 53311.9,
    "override_total_1": 54824.59,
    "override_increase_1": 1512.68
  },
  {
    "#": "20 Boylston St, Unit Cs2 (318-45-02)",
    "$": 669900,
    "address": "20 Boylston St, Unit Cs2",
    "parcel_id": "318-45-02",
    "owner1": "KENWOOD INVESTMENTS LLC",
    "owner2": "",
    "current_taxes": 11495.48,
    "new_taxes_no_override": 11992.08,
    "override_total_1": 12332.35,
    "override_increase_1": 340.27
  },
  {
    "#": "20 Boylston St, Unit G15 (318-45-19)",
    "$": 97300,
    "address": "20 Boylston St, Unit G15",
    "parcel_id": "318-45-19",
    "owner1": "LEARN, CHRISTOPHER P",
    "owner2": "GOLDBERG, SARAH W",
    "current_taxes": 996.35,
    "new_taxes_no_override": 1039.39,
    "override_total_1": 1068.88,
    "override_increase_1": 29.49
  },
  {
    "#": "20 Boylston St, Unit G18 (318-45-20)",
    "$": 98800,
    "address": "20 Boylston St, Unit G18",
    "parcel_id": "318-45-20",
    "owner1": "SCAGLIOLA TR, BRIAN",
    "owner2": "",
    "current_taxes": 1011.71,
    "new_taxes_no_override": 1055.42,
    "override_total_1": 1085.36,
    "override_increase_1": 29.95
  },
  {
    "#": "20 Boylston St, Unit G23 (318-45-22)",
    "$": 108400,
    "address": "20 Boylston St, Unit G23",
    "parcel_id": "318-45-22",
    "owner1": "129 WALNUT STREET LLC",
    "owner2": "",
    "current_taxes": 1110.02,
    "new_taxes_no_override": 1157.97,
    "override_total_1": 1190.83,
    "override_increase_1": 32.86
  },
  {
    "#": "20 Boylston St, Unit G6 (318-45-17)",
    "$": 98800,
    "address": "20 Boylston St, Unit G6",
    "parcel_id": "318-45-17",
    "owner1": "ZHL INTERNATIONAL LLC",
    "owner2": "",
    "current_taxes": 1011.71,
    "new_taxes_no_override": 1055.42,
    "override_total_1": 1085.36,
    "override_increase_1": 29.95
  },
  {
    "#": "20 Boylston St, Unit G7-8 (318-45-18)",
    "$": 212400,
    "address": "20 Boylston St, Unit G7-8",
    "parcel_id": "318-45-18",
    "owner1": "KENWOOD INVESTMENTS LLC",
    "owner2": "",
    "current_taxes": 2174.98,
    "new_taxes_no_override": 2268.94,
    "override_total_1": 2333.32,
    "override_increase_1": 64.38
  },
  {
    "#": "20 Boylston St, Unit G9-10 (318-45-21)",
    "$": 197500,
    "address": "20 Boylston St, Unit G9-10",
    "parcel_id": "318-45-21",
    "owner1": "AUDITORE, JAMES A",
    "owner2": "",
    "current_taxes": 2022.4,
    "new_taxes_no_override": 2109.77,
    "override_total_1": 2169.63,
    "override_increase_1": 59.86
  },
  {
    "#": "22 Boylston St (318-40-00)",
    "$": 723500,
    "address": "22 Boylston St",
    "parcel_id": "318-40-00",
    "owner1": "WASHINGTON 160 LLC",
    "owner2": "",
    "current_taxes": 12415.26,
    "new_taxes_no_override": 12951.6,
    "override_total_1": 13319.09,
    "override_increase_1": 367.49
  },
  {
    "#": "31 Boylston St (185-04-05)",
    "$": 5956700,
    "address": "31 Boylston St",
    "parcel_id": "185-04-05",
    "owner1": "RUIZ & RODRIGUEZ LLC",
    "owner2": "",
    "current_taxes": 60996.61,
    "new_taxes_no_override": 63631.66,
    "override_total_1": 65437.16,
    "override_increase_1": 1805.5
  },
  {
    "#": "43 Boylston St, Unit 1 (185-06-01)",
    "$": 936600,
    "address": "43 Boylston St, Unit 1",
    "parcel_id": "185-06-01",
    "owner1": "BECKER, MICHAEL A",
    "owner2": "",
    "current_taxes": 9590.78,
    "new_taxes_no_override": 10005.1,
    "override_total_1": 10288.99,
    "override_increase_1": 283.89
  },
  {
    "#": "43 Boylston St, Unit 2 (185-06-02)",
    "$": 674600,
    "address": "43 Boylston St, Unit 2",
    "parcel_id": "185-06-02",
    "owner1": "JURGENS, JULIE A & CARL E",
    "owner2": "CUNNINGHAM, CAROL A",
    "current_taxes": 6907.9,
    "new_taxes_no_override": 7206.32,
    "override_total_1": 7410.8,
    "override_increase_1": 204.47
  },
  {
    "#": "43 Boylston St, Unit 3 (185-06-03)",
    "$": 674600,
    "address": "43 Boylston St, Unit 3",
    "parcel_id": "185-06-03",
    "owner1": "PATEL, TARUN R & VISHAL",
    "owner2": "",
    "current_taxes": 6907.9,
    "new_taxes_no_override": 7206.32,
    "override_total_1": 7410.8,
    "override_increase_1": 204.47
  },
  {
    "#": "48 Boylston St (318-38-00)",
    "$": 1603200,
    "address": "48 Boylston St",
    "parcel_id": "318-38-00",
    "owner1": "48 BOYLSTON STREET LLC",
    "owner2": "",
    "current_taxes": 27510.91,
    "new_taxes_no_override": 28699.38,
    "override_total_1": 29513.7,
    "override_increase_1": 814.32
  },
  {
    "#": "49 Boylston St (185-07-00)",
    "$": 1911900,
    "address": "49 Boylston St",
    "parcel_id": "185-07-00",
    "owner1": "GROSS, TR, NORMAN",
    "owner2": "C/O ROSEN, ALISON",
    "current_taxes": 20941.93,
    "new_taxes_no_override": 21846.62,
    "override_total_1": 22466.5,
    "override_increase_1": 619.88
  },
  {
    "#": "50 Boylston St, Unit 1 (318-37-01)",
    "$": 418900,
    "address": "50 Boylston St, Unit 1",
    "parcel_id": "318-37-01",
    "owner1": "PHAN, KATIE",
    "owner2": "",
    "current_taxes": 7188.32,
    "new_taxes_no_override": 7498.86,
    "override_total_1": 7711.63,
    "override_increase_1": 212.77
  },
  {
    "#": "50 Boylston St, Unit 2 (318-37-02)",
    "$": 610900,
    "address": "50 Boylston St, Unit 2",
    "parcel_id": "318-37-02",
    "owner1": "RYAN, NEIL A & TRACY A",
    "owner2": "",
    "current_taxes": 6255.62,
    "new_taxes_no_override": 6525.86,
    "override_total_1": 6711.03,
    "override_increase_1": 185.17
  },
  {
    "#": "50 Boylston St, Unit 3 (318-37-03)",
    "$": 949100,
    "address": "50 Boylston St, Unit 3",
    "parcel_id": "318-37-03",
    "owner1": "STEWART WOOD LLC",
    "owner2": "",
    "current_taxes": 9718.78,
    "new_taxes_no_override": 10138.63,
    "override_total_1": 10426.31,
    "override_increase_1": 287.68
  },
  {
    "#": "51 Boylston St (185-08-00)",
    "$": 789000,
    "address": "51 Boylston St",
    "parcel_id": "185-08-00",
    "owner1": "FOX TR, MYRON J",
    "owner2": "C/O ROLLINS ROLLINS & FOX PC",
    "current_taxes": 13539.24,
    "new_taxes_no_override": 14124.14,
    "override_total_1": 14524.9,
    "override_increase_1": 400.76
  },
  {
    "#": "55 Boylston St (185-09-10)",
    "$": 1472800,
    "address": "55 Boylston St",
    "parcel_id": "185-09-10",
    "owner1": "FOX TR, MYRON J",
    "owner2": "C/O ROLLINS ROLLINS &  FOX PC",
    "current_taxes": 21221.03,
    "new_taxes_no_override": 22137.78,
    "override_total_1": 22765.92,
    "override_increase_1": 628.14
  },
  {
    "#": "65 Boylston St (185-11-00)",
    "$": 1049800,
    "address": "65 Boylston St",
    "parcel_id": "185-11-00",
    "owner1": "FOX TR, MYRON J",
    "owner2": "C/O ROLLINS ROLLINS & FOX P C",
    "current_taxes": 18014.57,
    "new_taxes_no_override": 18792.8,
    "override_total_1": 19326.03,
    "override_increase_1": 533.23
  },
  {
    "#": "68 Boylston St (318-34-35)",
    "$": 3417400,
    "address": "68 Boylston St",
    "parcel_id": "318-34-35",
    "owner1": "POURATI TRS, FLORA",
    "owner2": "",
    "current_taxes": 34994.18,
    "new_taxes_no_override": 36505.93,
    "override_total_1": 37541.76,
    "override_increase_1": 1035.83
  },
  {
    "#": "71 Boylston St (185-12-00)",
    "$": 1582600,
    "address": "71 Boylston St",
    "parcel_id": "185-12-00",
    "owner1": "RISSE, TR, JOHN G",
    "owner2": "",
    "current_taxes": 20586.6,
    "new_taxes_no_override": 21475.94,
    "override_total_1": 22085.3,
    "override_increase_1": 609.36
  },
  {
    "#": "75 Boylston St, Unit B (185-13-01)",
    "$": 4008300,
    "address": "75 Boylston St, Unit B",
    "parcel_id": "185-13-01",
    "owner1": "ARIEL, TR, MOSHE",
    "owner2": "",
    "current_taxes": 68782.43,
    "new_taxes_no_override": 71753.83,
    "override_total_1": 73789.79,
    "override_increase_1": 2035.96
  },
  {
    "#": "75 Boylston St, Unit C (185-13-02)",
    "$": 1944400,
    "address": "75 Boylston St, Unit C",
    "parcel_id": "185-13-02",
    "owner1": "JALESS LLC",
    "owner2": "C/O SOUSA DESIGN INC.",
    "current_taxes": 33365.9,
    "new_taxes_no_override": 34807.31,
    "override_total_1": 35794.94,
    "override_increase_1": 987.63
  },
  {
    "#": "75 Boylston St, Unit R1 & P-H (185-13-03)",
    "$": 354500,
    "address": "75 Boylston St, Unit R1 & P-H",
    "parcel_id": "185-13-03",
    "owner1": "LANE, JACOB M",
    "owner2": "",
    "current_taxes": 3630.08,
    "new_taxes_no_override": 3786.9,
    "override_total_1": 3894.35,
    "override_increase_1": 107.45
  },
  {
    "#": "75 Boylston St, Unit R2 P-E&F (185-13-04)",
    "$": 1064600,
    "address": "75 Boylston St, Unit R2 P-E&F",
    "parcel_id": "185-13-04",
    "owner1": "LI, SHI J",
    "owner2": "SONG, YAN",
    "current_taxes": 7266.57,
    "new_taxes_no_override": 7580.49,
    "override_total_1": 7795.58,
    "override_increase_1": 215.09
  },
  {
    "#": "75 Boylston St, Unit R3 & P-A (185-13-05)",
    "$": 1041900,
    "address": "75 Boylston St, Unit R3 & P-A",
    "parcel_id": "185-13-05",
    "owner1": "WEI, YI",
    "owner2": "C/O MIKI HONDA",
    "current_taxes": 10669.06,
    "new_taxes_no_override": 11129.96,
    "override_total_1": 11445.77,
    "override_increase_1": 315.8
  },
  {
    "#": "75 Boylston St, Unit R4 & P-D (185-13-06)",
    "$": 957400,
    "address": "75 Boylston St, Unit R4 & P-D",
    "parcel_id": "185-13-06",
    "owner1": "YANG, POK KWAN & SAU KING",
    "owner2": "",
    "current_taxes": 9803.78,
    "new_taxes_no_override": 10227.3,
    "override_total_1": 10517.5,
    "override_increase_1": 290.19
  },
  {
    "#": "75 Boylston St, Unit R5 Pk B C (185-13-07)",
    "$": 1082800,
    "address": "75 Boylston St, Unit R5 Pk B C",
    "parcel_id": "185-13-07",
    "owner1": "MEHTA, CHIRAG",
    "owner2": "CHAVDA, CARINA",
    "current_taxes": 7452.94,
    "new_taxes_no_override": 7774.91,
    "override_total_1": 7995.51,
    "override_increase_1": 220.61
  },
  {
    "#": "82 Boylston St (318-33-00)",
    "$": 847200,
    "address": "82 Boylston St",
    "parcel_id": "318-33-00",
    "owner1": "POLYHRONOPOULOS TR, NICHOLAS",
    "owner2": "",
    "current_taxes": 14537.95,
    "new_taxes_no_override": 15165.99,
    "override_total_1": 15596.31,
    "override_increase_1": 430.32
  },
  {
    "#": "87 Boylston St (185-15-00)",
    "$": 1754800,
    "address": "87 Boylston St",
    "parcel_id": "185-15-00",
    "owner1": "PERRY, FREDERICK",
    "owner2": "SMITH, SARAH",
    "current_taxes": 30112.37,
    "new_taxes_no_override": 31413.22,
    "override_total_1": 32304.55,
    "override_increase_1": 891.33
  },
  {
    "#": "88 Boylston St (318-32-00)",
    "$": 1698200,
    "address": "88 Boylston St",
    "parcel_id": "318-32-00",
    "owner1": "TCS REAL ESTATE LLC",
    "owner2": "",
    "current_taxes": 19975.18,
    "new_taxes_no_override": 20838.11,
    "override_total_1": 21429.37,
    "override_increase_1": 591.27
  },
  {
    "#": "94 Boylston St (318-31-00)",
    "$": 984200,
    "address": "94 Boylston St",
    "parcel_id": "318-31-00",
    "owner1": "KIM, CHRISTINE K & ALEXANDRA",
    "owner2": "",
    "current_taxes": 10078.21,
    "new_taxes_no_override": 10513.59,
    "override_total_1": 10811.9,
    "override_increase_1": 298.32
  },
  {
    "#": "95 Boylston St (185-16-00)",
    "$": 1435400,
    "address": "95 Boylston St",
    "parcel_id": "185-16-00",
    "owner1": "BUI, AMY MYHANH",
    "owner2": "",
    "current_taxes": 18174.9,
    "new_taxes_no_override": 18960.06,
    "override_total_1": 19498.03,
    "override_increase_1": 537.98
  },
  {
    "#": "96 Boylston St, Unit Of (318-30-04)",
    "$": 215600,
    "address": "96 Boylston St, Unit Of",
    "parcel_id": "318-30-04",
    "owner1": "DONIGIAN, JACK",
    "owner2": "",
    "current_taxes": 3699.7,
    "new_taxes_no_override": 3859.53,
    "override_total_1": 3969.04,
    "override_increase_1": 109.51
  },
  {
    "#": "98 Boylston St, Unit 1 (318-30-01)",
    "$": 601800,
    "address": "98 Boylston St, Unit 1",
    "parcel_id": "318-30-01",
    "owner1": "ZHU, SHIKAI",
    "owner2": "ZHOU, YU",
    "current_taxes": 6162.43,
    "new_taxes_no_override": 6428.65,
    "override_total_1": 6611.05,
    "override_increase_1": 182.41
  },
  {
    "#": "98 Boylston St, Unit 2 (318-30-02)",
    "$": 611100,
    "address": "98 Boylston St, Unit 2",
    "parcel_id": "318-30-02",
    "owner1": "DONIGIAN, JACK",
    "owner2": "",
    "current_taxes": 6257.66,
    "new_taxes_no_override": 6527.99,
    "override_total_1": 6713.22,
    "override_increase_1": 185.23
  },
  {
    "#": "98 Boylston St, Unit 3 (318-30-03)",
    "$": 688900,
    "address": "98 Boylston St, Unit 3",
    "parcel_id": "318-30-03",
    "owner1": "DONIGIAN, JACK",
    "owner2": "",
    "current_taxes": 7054.34,
    "new_taxes_no_override": 7359.09,
    "override_total_1": 7567.9,
    "override_increase_1": 208.81
  },
  {
    "#": "99 Boylston St, Unit A (185-17-00)",
    "$": 1744700,
    "address": "99 Boylston St, Unit A",
    "parcel_id": "185-17-00",
    "owner1": "ZHANG, JUN",
    "owner2": "",
    "current_taxes": 17865.73,
    "new_taxes_no_override": 18637.53,
    "override_total_1": 19166.36,
    "override_increase_1": 528.83
  },
  {
    "#": "111 Boylston St (185-18-27)",
    "$": 51951800,
    "address": "111 Boylston St",
    "parcel_id": "185-18-27",
    "owner1": "CLAREMONT BROOKLINE SUITES LLC",
    "owner2": "",
    "current_taxes": 891492.89,
    "new_taxes_no_override": 930005.38,
    "override_total_1": 956393.57,
    "override_increase_1": 26388.19
  },
  {
    "#": "120 Boylston St (318-28-29)",
    "$": 2821900,
    "address": "120 Boylston St",
    "parcel_id": "318-28-29",
    "owner1": "CLAREMONT BOYLSTON LLC",
    "owner2": "",
    "current_taxes": 48423.8,
    "new_taxes_no_override": 50515.71,
    "override_total_1": 51949.05,
    "override_increase_1": 1433.34
  },
  {
    "#": "128 Boylston St (318-25-27)",
    "$": 3158700,
    "address": "128 Boylston St",
    "parcel_id": "318-25-27",
    "owner1": "TITANIUM GROUP LLC",
    "owner2": "",
    "current_taxes": 54203.29,
    "new_taxes_no_override": 56544.87,
    "override_total_1": 58149.29,
    "override_increase_1": 1604.42
  },
  {
    "#": "146 Boylston St (318-24-00)",
    "$": 1588200,
    "address": "146 Boylston St",
    "parcel_id": "318-24-00",
    "owner1": "TITANIUM GROUP LLC",
    "owner2": "",
    "current_taxes": 19953.48,
    "new_taxes_no_override": 20815.47,
    "override_total_1": 21406.09,
    "override_increase_1": 590.62
  },
  {
    "#": "153 Boylston St (186-01-02)",
    "$": 8602700,
    "address": "153 Boylston St",
    "parcel_id": "186-01-02",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O BOYLSTON PLAYGROUND",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "154 Boylston St (318-23-00)",
    "$": 1771200,
    "address": "154 Boylston St",
    "parcel_id": "318-23-00",
    "owner1": "BROOKLINE IMPROVEMNT COALITION",
    "owner2": "C/O THE MACKIN GROUP INC",
    "current_taxes": 18137.09,
    "new_taxes_no_override": 18920.61,
    "override_total_1": 19457.47,
    "override_increase_1": 536.86
  },
  {
    "#": "158 Boylston St (318-22-00)",
    "$": 1129000,
    "address": "158 Boylston St",
    "parcel_id": "318-22-00",
    "owner1": "CAI, TIANRUN",
    "owner2": "",
    "current_taxes": 7926.03,
    "new_taxes_no_override": 8268.43,
    "override_total_1": 8503.04,
    "override_increase_1": 234.61
  },
  {
    "#": "194 Boylston St (318-20-00)",
    "$": 19381000,
    "address": "194 Boylston St",
    "parcel_id": "318-20-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O OLD LINCOLN SCHOOL",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "199 Boylston St (186-03-07)",
    "$": 6887300,
    "address": "199 Boylston St",
    "parcel_id": "186-03-07",
    "owner1": "JANE DEVELOPMENT LLC",
    "owner2": "",
    "current_taxes": 70525.95,
    "new_taxes_no_override": 73572.67,
    "override_total_1": 75660.24,
    "override_increase_1": 2087.57
  },
  {
    "#": "211 Boylston St (186-04-00)",
    "$": 1781900,
    "address": "211 Boylston St",
    "parcel_id": "186-04-00",
    "owner1": "ECD REALTY LLC",
    "owner2": "",
    "current_taxes": 23329.49,
    "new_taxes_no_override": 24337.32,
    "override_total_1": 25027.88,
    "override_increase_1": 690.55
  },
  {
    "#": "233 Boylston St (187-05-00)",
    "$": 2018600,
    "address": "233 Boylston St",
    "parcel_id": "187-05-00",
    "owner1": "BRYANT LLC",
    "owner2": "",
    "current_taxes": 20670.46,
    "new_taxes_no_override": 21563.42,
    "override_total_1": 22175.27,
    "override_increase_1": 611.85
  },
  {
    "#": "241 Boylston St (187-06-00)",
    "$": 1238900,
    "address": "241 Boylston St",
    "parcel_id": "187-06-00",
    "owner1": "ARIAS, TEODORA & SOLEDAD",
    "owner2": "",
    "current_taxes": 9051.4,
    "new_taxes_no_override": 9442.42,
    "override_total_1": 9710.34,
    "override_increase_1": 267.92
  },
  {
    "#": "265 Boylston St (188-04-06)",
    "$": 3533200,
    "address": "265 Boylston St",
    "parcel_id": "188-04-06",
    "owner1": "DB REAL ESTATE ASSETS I LLC",
    "owner2": "C/O PROPERTY TAX",
    "current_taxes": 60629.71,
    "new_taxes_no_override": 63248.91,
    "override_total_1": 65043.55,
    "override_increase_1": 1794.64
  },
  {
    "#": "270 Boylston St (318-18-00)",
    "$": 7557600,
    "address": "270 Boylston St",
    "parcel_id": "318-18-00",
    "owner1": "U HAUL REAL ESTATE CO",
    "owner2": "C/O PROPERTY TAX",
    "current_taxes": 129688.42,
    "new_taxes_no_override": 135290.96,
    "override_total_1": 139129.74,
    "override_increase_1": 3838.78
  },
  {
    "#": "275 Boylston St (188-07-00)",
    "$": 2059400,
    "address": "275 Boylston St",
    "parcel_id": "188-07-00",
    "owner1": "M AND S LIMITED PARTNERSHIP",
    "owner2": "",
    "current_taxes": 35339.3,
    "new_taxes_no_override": 36865.96,
    "override_total_1": 37912.0,
    "override_increase_1": 1046.04
  },
  {
    "#": "296 Boylston St (318-17-00)",
    "$": 3377700,
    "address": "296 Boylston St",
    "parcel_id": "318-17-00",
    "owner1": "BOSTON EDISON CO",
    "owner2": "C/O NSTAR  PROPERTY TAX DEPT",
    "current_taxes": 57961.33,
    "new_taxes_no_override": 60465.26,
    "override_total_1": 62180.91,
    "override_increase_1": 1715.66
  },
  {
    "#": "303 Boylston St (189-11-15)",
    "$": 13146900,
    "address": "303 Boylston St",
    "parcel_id": "189-11-15",
    "owner1": "SOKA GAKKAI INTERNATIONAL USA",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "308 Boylston St (318-14-16)",
    "$": 23536700,
    "address": "308 Boylston St",
    "parcel_id": "318-14-16",
    "owner1": "ONEILL, TR, GERARD T",
    "owner2": "C/O BROOKLINE VW AUDI",
    "current_taxes": 403889.77,
    "new_taxes_no_override": 421337.81,
    "override_total_1": 433292.95,
    "override_increase_1": 11955.14
  },
  {
    "#": "323 Boylston St, Unit 2-101&Ul29-30 (189-32-48)",
    "$": 1161700,
    "address": "323 Boylston St, Unit 2-101&Ul29-30",
    "parcel_id": "189-32-48",
    "owner1": "QUILTY, OWEN M",
    "owner2": "WONG, FIONA L",
    "current_taxes": 8260.87,
    "new_taxes_no_override": 8617.74,
    "override_total_1": 8862.26,
    "override_increase_1": 244.52
  },
  {
    "#": "323 Boylston St, Unit 2-102&Ll28-33 (189-32-49)",
    "$": 919800,
    "address": "323 Boylston St, Unit 2-102&Ll28-33",
    "parcel_id": "189-32-49",
    "owner1": "ZHANG, CHENG-ZHONG",
    "owner2": "LI, YUCHEN",
    "current_taxes": 9418.75,
    "new_taxes_no_override": 9825.64,
    "override_total_1": 10104.43,
    "override_increase_1": 278.8
  },
  {
    "#": "323 Boylston St, Unit 2-103&Ll 1 (189-32-50)",
    "$": 460200,
    "address": "323 Boylston St, Unit 2-103&Ll 1",
    "parcel_id": "189-32-50",
    "owner1": "BROWN, SASHAMARLE L",
    "owner2": "BROWNE, MISHON",
    "current_taxes": 1077.51,
    "new_taxes_no_override": 1124.06,
    "override_total_1": 1155.95,
    "override_increase_1": 31.89
  },
  {
    "#": "323 Boylston St, Unit 2-104&7Pk (189-32-77)",
    "$": 1951900,
    "address": "323 Boylston St, Unit 2-104&7Pk",
    "parcel_id": "189-32-77",
    "owner1": "LIN TR, YUNG",
    "owner2": "",
    "current_taxes": 33494.6,
    "new_taxes_no_override": 34941.57,
    "override_total_1": 35933.01,
    "override_increase_1": 991.44
  },
  {
    "#": "323 Boylston St, Unit 2-201&Ll27-32 (189-32-51)",
    "$": 1156500,
    "address": "323 Boylston St, Unit 2-201&Ll27-32",
    "parcel_id": "189-32-51",
    "owner1": "PONARCHAN, PORNTULA",
    "owner2": "",
    "current_taxes": 11842.56,
    "new_taxes_no_override": 12354.16,
    "override_total_1": 12704.7,
    "override_increase_1": 350.54
  },
  {
    "#": "323 Boylston St, Unit 2-202& Ll2 (189-32-52)",
    "$": 331000,
    "address": "323 Boylston St, Unit 2-202& Ll2",
    "parcel_id": "189-32-52",
    "owner1": "KHALIPSKAYA, LILIYA",
    "owner2": "GRESSEL, YURIY",
    "current_taxes": 338.94,
    "new_taxes_no_override": 353.58,
    "override_total_1": 363.61,
    "override_increase_1": 10.03
  },
  {
    "#": "323 Boylston St, Unit 2-203&Ll26-31 (189-32-53)",
    "$": 1105400,
    "address": "323 Boylston St, Unit 2-203&Ll26-31",
    "parcel_id": "189-32-53",
    "owner1": "SUN  , YU",
    "owner2": "",
    "current_taxes": 7684.36,
    "new_taxes_no_override": 8016.32,
    "override_total_1": 8243.78,
    "override_increase_1": 227.46
  },
  {
    "#": "323 Boylston St, Unit 2-204&Ll3 (189-32-54)",
    "$": 331000,
    "address": "323 Boylston St, Unit 2-204&Ll3",
    "parcel_id": "189-32-54",
    "owner1": "FURMAN, MARYANA Y",
    "owner2": "",
    "current_taxes": 338.94,
    "new_taxes_no_override": 353.58,
    "override_total_1": 363.61,
    "override_increase_1": 10.03
  },
  {
    "#": "323 Boylston St, Unit 2-205&Ll25-30 (189-32-55)",
    "$": 1097200,
    "address": "323 Boylston St, Unit 2-205&Ll25-30",
    "parcel_id": "189-32-55",
    "owner1": "KORMAN, ALEXANDRA V",
    "owner2": "",
    "current_taxes": 11235.33,
    "new_taxes_no_override": 11720.7,
    "override_total_1": 12053.26,
    "override_increase_1": 332.57
  },
  {
    "#": "323 Boylston St, Unit 2-206& Ul5-11 (189-32-56)",
    "$": 1185100,
    "address": "323 Boylston St, Unit 2-206& Ul5-11",
    "parcel_id": "189-32-56",
    "owner1": "YANG, SHUYA",
    "owner2": "",
    "current_taxes": 12135.42,
    "new_taxes_no_override": 12659.67,
    "override_total_1": 13018.88,
    "override_increase_1": 359.21
  },
  {
    "#": "323 Boylston St, Unit 2-301&Ll14-23 (189-32-57)",
    "$": 1156500,
    "address": "323 Boylston St, Unit 2-301&Ll14-23",
    "parcel_id": "189-32-57",
    "owner1": "LIU, XIULIN",
    "owner2": "",
    "current_taxes": 11842.56,
    "new_taxes_no_override": 12354.16,
    "override_total_1": 12704.7,
    "override_increase_1": 350.54
  },
  {
    "#": "323 Boylston St, Unit 2-302&Ll4 (189-32-58)",
    "$": 331000,
    "address": "323 Boylston St, Unit 2-302&Ll4",
    "parcel_id": "189-32-58",
    "owner1": "ADAMS, ALMA C",
    "owner2": "",
    "current_taxes": 338.94,
    "new_taxes_no_override": 353.58,
    "override_total_1": 363.61,
    "override_increase_1": 10.03
  },
  {
    "#": "323 Boylston St, Unit 2-303&Ll24-29 (189-32-59)",
    "$": 1134000,
    "address": "323 Boylston St, Unit 2-303&Ll24-29",
    "parcel_id": "189-32-59",
    "owner1": "BUI, TRUNG VAN",
    "owner2": "TRINH, PHUONG DOAN",
    "current_taxes": 11612.16,
    "new_taxes_no_override": 12113.81,
    "override_total_1": 12457.53,
    "override_increase_1": 343.72
  },
  {
    "#": "323 Boylston St, Unit 2-304&Ul17-18 (189-32-60)",
    "$": 1051700,
    "address": "323 Boylston St, Unit 2-304&Ul17-18",
    "parcel_id": "189-32-60",
    "owner1": "GRIFFIN TRS, LIAM K & AMY E",
    "owner2": "",
    "current_taxes": 10769.41,
    "new_taxes_no_override": 11234.65,
    "override_total_1": 11553.42,
    "override_increase_1": 318.77
  },
  {
    "#": "323 Boylston St, Unit 2-305 & Ul27-28 (189-32-61)",
    "$": 1096700,
    "address": "323 Boylston St, Unit 2-305 & Ul27-28",
    "parcel_id": "189-32-61",
    "owner1": "JIAN, BO",
    "owner2": "",
    "current_taxes": 7595.27,
    "new_taxes_no_override": 7923.39,
    "override_total_1": 8148.21,
    "override_increase_1": 224.82
  },
  {
    "#": "323 Boylston St, Unit 2-306&Ll11-22 (189-32-62)",
    "$": 1169900,
    "address": "323 Boylston St, Unit 2-306&Ll11-22",
    "parcel_id": "189-32-62",
    "owner1": "COUGHLIN, GREGORY J",
    "owner2": "",
    "current_taxes": 11979.78,
    "new_taxes_no_override": 12497.31,
    "override_total_1": 12851.91,
    "override_increase_1": 354.6
  },
  {
    "#": "323 Boylston St, Unit 2-401&Ll10-21 (189-32-63)",
    "$": 1121900,
    "address": "323 Boylston St, Unit 2-401&Ll10-21",
    "parcel_id": "189-32-63",
    "owner1": "HARDWICKE, M GREER",
    "owner2": "WILSON, CHRISTOPHER P",
    "current_taxes": 7853.32,
    "new_taxes_no_override": 8192.58,
    "override_total_1": 8425.04,
    "override_increase_1": 232.46
  },
  {
    "#": "323 Boylston St, Unit 2-402&Ll17-18 (189-32-64)",
    "$": 1062100,
    "address": "323 Boylston St, Unit 2-402&Ll17-18",
    "parcel_id": "189-32-64",
    "owner1": "CHANG, SERENA L",
    "owner2": "TJEN, HIANTHAI",
    "current_taxes": 7240.97,
    "new_taxes_no_override": 7553.78,
    "override_total_1": 7768.11,
    "override_increase_1": 214.33
  },
  {
    "#": "323 Boylston St, Unit 2-403&Ll19-20 (189-32-65)",
    "$": 1134000,
    "address": "323 Boylston St, Unit 2-403&Ll19-20",
    "parcel_id": "189-32-65",
    "owner1": "GARBER, MIRIAM",
    "owner2": "",
    "current_taxes": 11612.16,
    "new_taxes_no_override": 12113.81,
    "override_total_1": 12457.53,
    "override_increase_1": 343.72
  },
  {
    "#": "323 Boylston St, Unit 2-404&Ll12-13 (189-32-66)",
    "$": 1051700,
    "address": "323 Boylston St, Unit 2-404&Ll12-13",
    "parcel_id": "189-32-66",
    "owner1": "THORNTON, TERRY L-GEORGIA M-ADAM M",
    "owner2": "",
    "current_taxes": 10769.41,
    "new_taxes_no_override": 11234.65,
    "override_total_1": 11553.42,
    "override_increase_1": 318.77
  },
  {
    "#": "323 Boylston St, Unit 2-405&Ul6-12 (189-32-67)",
    "$": 1096700,
    "address": "323 Boylston St, Unit 2-405&Ul6-12",
    "parcel_id": "189-32-67",
    "owner1": "KAN, FIONA",
    "owner2": "",
    "current_taxes": 11230.21,
    "new_taxes_no_override": 11715.36,
    "override_total_1": 12047.77,
    "override_increase_1": 332.41
  },
  {
    "#": "323 Boylston St, Unit 2-406&Ul13-14 (189-32-68)",
    "$": 1169900,
    "address": "323 Boylston St, Unit 2-406&Ul13-14",
    "parcel_id": "189-32-68",
    "owner1": "SASHIN TR, DAPHNE R",
    "owner2": "",
    "current_taxes": 11979.78,
    "new_taxes_no_override": 12497.31,
    "override_total_1": 12851.91,
    "override_increase_1": 354.6
  },
  {
    "#": "323 Boylston St, Unit 2-501&Ul15-16 (189-32-69)",
    "$": 1208900,
    "address": "323 Boylston St, Unit 2-501&Ul15-16",
    "parcel_id": "189-32-69",
    "owner1": "PATEL, SANDIP V & VANDITA",
    "owner2": "",
    "current_taxes": 12379.14,
    "new_taxes_no_override": 12913.92,
    "override_total_1": 13280.34,
    "override_increase_1": 366.42
  },
  {
    "#": "323 Boylston St, Unit 2-502&Ul3-9 (189-32-70)",
    "$": 1278700,
    "address": "323 Boylston St, Unit 2-502&Ul3-9",
    "parcel_id": "189-32-70",
    "owner1": "HOHMAN, RICHARD J",
    "owner2": "CHU, ELAINE HOHMAN",
    "current_taxes": 9458.95,
    "new_taxes_no_override": 9867.58,
    "override_total_1": 10147.56,
    "override_increase_1": 279.98
  },
  {
    "#": "323 Boylston St, Unit 2-503&Ll15-16 (189-32-71)",
    "$": 1155000,
    "address": "323 Boylston St, Unit 2-503&Ll15-16",
    "parcel_id": "189-32-71",
    "owner1": "LEE, PO-SHUN",
    "owner2": "YANG, AMY HAN-JU",
    "current_taxes": 11827.2,
    "new_taxes_no_override": 12338.14,
    "override_total_1": 12688.22,
    "override_increase_1": 350.09
  },
  {
    "#": "323 Boylston St, Unit 2-504&Ul25-26 (189-32-72)",
    "$": 1016200,
    "address": "323 Boylston St, Unit 2-504&Ul25-26",
    "parcel_id": "189-32-72",
    "owner1": "NAUFFAL, MARY & VICTOR",
    "owner2": "",
    "current_taxes": 6770.95,
    "new_taxes_no_override": 7063.46,
    "override_total_1": 7263.88,
    "override_increase_1": 200.42
  },
  {
    "#": "323 Boylston St, Unit 2-601&Ul23-24 (189-32-73)",
    "$": 1146100,
    "address": "323 Boylston St, Unit 2-601&Ul23-24",
    "parcel_id": "189-32-73",
    "owner1": "PATEL, SANDIP V & ADITYA S",
    "owner2": "",
    "current_taxes": 11736.06,
    "new_taxes_no_override": 12243.06,
    "override_total_1": 12590.45,
    "override_increase_1": 347.39
  },
  {
    "#": "323 Boylston St, Unit 2-602&Ul21-22 (189-32-74)",
    "$": 1036500,
    "address": "323 Boylston St, Unit 2-602&Ul21-22",
    "parcel_id": "189-32-74",
    "owner1": "AGRANOVICH TRS, LEV",
    "owner2": "NENACHEVA, ANNA",
    "current_taxes": 10613.76,
    "new_taxes_no_override": 11072.27,
    "override_total_1": 11386.44,
    "override_increase_1": 314.17
  },
  {
    "#": "323 Boylston St, Unit 2-603&Ul19-20 (189-32-75)",
    "$": 1137900,
    "address": "323 Boylston St, Unit 2-603&Ul19-20",
    "parcel_id": "189-32-75",
    "owner1": "BOYCE, KEITH GARRY",
    "owner2": "RADOVINSKY, LUCY",
    "current_taxes": 8017.16,
    "new_taxes_no_override": 8363.5,
    "override_total_1": 8600.81,
    "override_increase_1": 237.31
  },
  {
    "#": "323 Boylston St, Unit 2-604&Ul4-10 (189-32-76)",
    "$": 1015800,
    "address": "323 Boylston St, Unit 2-604&Ul4-10",
    "parcel_id": "189-32-76",
    "owner1": "FERNANDEZ, LUIS",
    "owner2": "",
    "current_taxes": 6766.86,
    "new_taxes_no_override": 7059.19,
    "override_total_1": 7259.49,
    "override_increase_1": 200.3
  },
  {
    "#": "345 Boylston St (189-24-29)",
    "$": 4528100,
    "address": "345 Boylston St",
    "parcel_id": "189-24-29",
    "owner1": "GLOBAL COMPANIES LLC",
    "owner2": "C/O ALLIANCE ENERGY LLC, ATTN TAX DEPT",
    "current_taxes": 77702.2,
    "new_taxes_no_override": 81058.94,
    "override_total_1": 83358.92,
    "override_increase_1": 2299.99
  },
  {
    "#": "358 Boylston St (319-12-00)",
    "$": 4396100,
    "address": "358 Boylston St",
    "parcel_id": "319-12-00",
    "owner1": "SANIEOFF, TRS, SYROOS & SIEON",
    "owner2": "",
    "current_taxes": 75437.08,
    "new_taxes_no_override": 78695.96,
    "override_total_1": 80928.9,
    "override_increase_1": 2232.94
  },
  {
    "#": "361 Boylston St (190-02-00)",
    "$": 8535000,
    "address": "361 Boylston St",
    "parcel_id": "190-02-00",
    "owner1": "361-375 BOYLSTON ST LLC",
    "owner2": "",
    "current_taxes": 146460.6,
    "new_taxes_no_override": 152787.7,
    "override_total_1": 157122.93,
    "override_increase_1": 4335.23
  },
  {
    "#": "370 Boylston St, Unit 1 (319-09-05)",
    "$": 1235800,
    "address": "370 Boylston St, Unit 1",
    "parcel_id": "319-09-05",
    "owner1": "SANIEOFF TRS, SIEON & SYROOS",
    "owner2": "",
    "current_taxes": 21206.33,
    "new_taxes_no_override": 22122.44,
    "override_total_1": 22750.15,
    "override_increase_1": 627.71
  },
  {
    "#": "372 Boylston St, Unit 2 (319-09-01)",
    "$": 103500,
    "address": "372 Boylston St, Unit 2",
    "parcel_id": "319-09-01",
    "owner1": "SANIEOFF TRS, SIEON & SYROOS",
    "owner2": "",
    "current_taxes": 1776.06,
    "new_taxes_no_override": 1852.79,
    "override_total_1": 1905.36,
    "override_increase_1": 52.57
  },
  {
    "#": "374 Boylston St, Unit 3 (319-09-02)",
    "$": 703300,
    "address": "374 Boylston St, Unit 3",
    "parcel_id": "319-09-02",
    "owner1": "TOBIN, PHYLLIS S",
    "owner2": "C/O A & B REALTY",
    "current_taxes": 12068.63,
    "new_taxes_no_override": 12589.99,
    "override_total_1": 12947.23,
    "override_increase_1": 357.23
  },
  {
    "#": "374 Boylston St, Unit 4 (319-09-03)",
    "$": 526400,
    "address": "374 Boylston St, Unit 4",
    "parcel_id": "319-09-03",
    "owner1": "TOBIN, PHYLLIS S",
    "owner2": "C/O A & B REALTY",
    "current_taxes": 9033.02,
    "new_taxes_no_override": 9423.25,
    "override_total_1": 9690.62,
    "override_increase_1": 267.38
  },
  {
    "#": "374 Boylston St, Unit 5 (319-09-04)",
    "$": 366400,
    "address": "374 Boylston St, Unit 5",
    "parcel_id": "319-09-04",
    "owner1": "TOBIN, PHYLLIS S",
    "owner2": "C/O A & B REALTY",
    "current_taxes": 6287.42,
    "new_taxes_no_override": 6559.04,
    "override_total_1": 6745.14,
    "override_increase_1": 186.11
  },
  {
    "#": "384 Boylston St (319-08-00)",
    "$": 1895000,
    "address": "384 Boylston St",
    "parcel_id": "319-08-00",
    "owner1": "LEE, HARRY & JUDITH",
    "owner2": "",
    "current_taxes": 15769.87,
    "new_taxes_no_override": 16451.13,
    "override_total_1": 16917.92,
    "override_increase_1": 466.79
  },
  {
    "#": "391 Boylston St (191-15-00)",
    "$": 2276100,
    "address": "391 Boylston St",
    "parcel_id": "191-15-00",
    "owner1": "CALM, JANET STEIN & FRED",
    "owner2": "",
    "current_taxes": 19672.33,
    "new_taxes_no_override": 20522.17,
    "override_total_1": 21104.48,
    "override_increase_1": 582.3
  },
  {
    "#": "397 Boylston St (191-16-00)",
    "$": 1669800,
    "address": "397 Boylston St",
    "parcel_id": "191-16-00",
    "owner1": "LEUNG, ELIZABETH WON WAH",
    "owner2": "",
    "current_taxes": 13463.82,
    "new_taxes_no_override": 14045.46,
    "override_total_1": 14443.99,
    "override_increase_1": 398.53
  },
  {
    "#": "401 Boylston St (191-17-00)",
    "$": 2116600,
    "address": "401 Boylston St",
    "parcel_id": "191-17-00",
    "owner1": "KIM, THERESA & JOHN",
    "owner2": "",
    "current_taxes": 18039.05,
    "new_taxes_no_override": 18818.34,
    "override_total_1": 19352.29,
    "override_increase_1": 533.96
  },
  {
    "#": "402 Boylston St (320A-16-00)",
    "$": 1679100,
    "address": "402 Boylston St",
    "parcel_id": "320A-16-00",
    "owner1": "SNOVER TR, PAUL S",
    "owner2": "",
    "current_taxes": 17193.98,
    "new_taxes_no_override": 17936.76,
    "override_total_1": 18445.7,
    "override_increase_1": 508.94
  },
  {
    "#": "420 Boylston St (321-12-02)",
    "$": 1280300,
    "address": "420 Boylston St",
    "parcel_id": "321-12-02",
    "owner1": "BOYLSTON STREET 420 LLC",
    "owner2": "",
    "current_taxes": 13110.27,
    "new_taxes_no_override": 13676.63,
    "override_total_1": 14064.7,
    "override_increase_1": 388.06
  },
  {
    "#": "424 Boylston St (321-12-01)",
    "$": 1305900,
    "address": "424 Boylston St",
    "parcel_id": "321-12-01",
    "owner1": "MULMING, DULYAWAT",
    "owner2": "",
    "current_taxes": 9737.48,
    "new_taxes_no_override": 10158.14,
    "override_total_1": 10446.37,
    "override_increase_1": 288.23
  },
  {
    "#": "428 Boylston St (321-12-00)",
    "$": 1346000,
    "address": "428 Boylston St",
    "parcel_id": "321-12-00",
    "owner1": "MURPHY TR, CAROL",
    "owner2": "",
    "current_taxes": 10148.11,
    "new_taxes_no_override": 10586.51,
    "override_total_1": 10886.89,
    "override_increase_1": 300.38
  },
  {
    "#": "440 Boylston St (321-11-00)",
    "$": 2595100,
    "address": "440 Boylston St",
    "parcel_id": "321-11-00",
    "owner1": "PEARLMUTTER, MARK D",
    "owner2": "DYMSZA, MADELINE P",
    "current_taxes": 22938.89,
    "new_taxes_no_override": 23929.85,
    "override_total_1": 24608.84,
    "override_increase_1": 678.99
  },
  {
    "#": "452 Boylston St (321-10-00)",
    "$": 1957500,
    "address": "452 Boylston St",
    "parcel_id": "321-10-00",
    "owner1": "CAMPBELL, DAVID L",
    "owner2": "SPENCER, HOLLY A",
    "current_taxes": 16409.87,
    "new_taxes_no_override": 17118.78,
    "override_total_1": 17604.51,
    "override_increase_1": 485.73
  },
  {
    "#": "462 Boylston St (321-09-00)",
    "$": 1466000,
    "address": "462 Boylston St",
    "parcel_id": "321-09-00",
    "owner1": "STITT, EDWARD T & WILLA ZOE",
    "owner2": "",
    "current_taxes": 11376.91,
    "new_taxes_no_override": 11868.39,
    "override_total_1": 12205.15,
    "override_increase_1": 336.76
  },
  {
    "#": "481 Boylston St (253-04-00)",
    "$": 2954200,
    "address": "481 Boylston St",
    "parcel_id": "253-04-00",
    "owner1": "DI RIENZO, MARIO",
    "owner2": "",
    "current_taxes": 30251.01,
    "new_taxes_no_override": 31557.85,
    "override_total_1": 32453.28,
    "override_increase_1": 895.43
  },
  {
    "#": "483 Boylston St, Unit 1 (253-05-03)",
    "$": 1248900,
    "address": "483 Boylston St, Unit 1",
    "parcel_id": "253-05-03",
    "owner1": "COLLINS TR, JOAN",
    "owner2": "",
    "current_taxes": 9153.8,
    "new_taxes_no_override": 9549.24,
    "override_total_1": 9820.2,
    "override_increase_1": 270.95
  },
  {
    "#": "483 Boylston St, Unit 2 (253-05-01)",
    "$": 1287000,
    "address": "483 Boylston St, Unit 2",
    "parcel_id": "253-05-01",
    "owner1": "KITAYGORDSKY, VLADIMIR",
    "owner2": "RICCI, YANA KITAYGORDSKY",
    "current_taxes": 9543.95,
    "new_taxes_no_override": 9956.25,
    "override_total_1": 10238.75,
    "override_increase_1": 282.5
  },
  {
    "#": "483 Boylston St, Unit 3 (253-05-02)",
    "$": 1335900,
    "address": "483 Boylston St, Unit 3",
    "parcel_id": "253-05-02",
    "owner1": "AL ANSARI, MOHAMMAD A",
    "owner2": "TAMI, LEILA",
    "current_taxes": 10044.68,
    "new_taxes_no_override": 10478.61,
    "override_total_1": 10775.93,
    "override_increase_1": 297.32
  },
  {
    "#": "487 Boylston St, Unit 1 (253-06-03)",
    "$": 1435000,
    "address": "487 Boylston St, Unit 1",
    "parcel_id": "253-06-03",
    "owner1": "TARANTINO, JOANN M",
    "owner2": "",
    "current_taxes": 11059.47,
    "new_taxes_no_override": 11537.24,
    "override_total_1": 11864.6,
    "override_increase_1": 327.36
  },
  {
    "#": "487 Boylston St, Unit 2 (253-06-01)",
    "$": 1354400,
    "address": "487 Boylston St, Unit 2",
    "parcel_id": "253-06-01",
    "owner1": "PELTON, MARVIN LEE",
    "owner2": "GOGOL, ANASTASIA",
    "current_taxes": 10234.12,
    "new_taxes_no_override": 10676.23,
    "override_total_1": 10979.16,
    "override_increase_1": 302.93
  },
  {
    "#": "487 Boylston St, Unit 3 (253-06-02)",
    "$": 1367000,
    "address": "487 Boylston St, Unit 3",
    "parcel_id": "253-06-02",
    "owner1": "FELLEISEN, MATTHIAS",
    "owner2": "",
    "current_taxes": 10363.15,
    "new_taxes_no_override": 10810.84,
    "override_total_1": 11117.59,
    "override_increase_1": 306.75
  },
  {
    "#": "489 Boylston St, Unit 1 (253-07-03)",
    "$": 1084200,
    "address": "489 Boylston St, Unit 1",
    "parcel_id": "253-07-03",
    "owner1": "DONG, YUNSHENG",
    "owner2": "",
    "current_taxes": 11102.21,
    "new_taxes_no_override": 11581.83,
    "override_total_1": 11910.45,
    "override_increase_1": 328.63
  },
  {
    "#": "489 Boylston St, Unit 2 (253-07-01)",
    "$": 1367500,
    "address": "489 Boylston St, Unit 2",
    "parcel_id": "253-07-01",
    "owner1": "FERRARA, LIVIO",
    "owner2": "",
    "current_taxes": 14003.2,
    "new_taxes_no_override": 14608.14,
    "override_total_1": 15022.63,
    "override_increase_1": 414.49
  },
  {
    "#": "489 Boylston St, Unit 3 (253-07-02)",
    "$": 1393900,
    "address": "489 Boylston St, Unit 3",
    "parcel_id": "253-07-02",
    "owner1": "MORNINGWAVE PROPERTIES INC",
    "owner2": "",
    "current_taxes": 14273.54,
    "new_taxes_no_override": 14890.16,
    "override_total_1": 15312.65,
    "override_increase_1": 422.5
  },
  {
    "#": "495 Boylston St, Unit A (253-08-03)",
    "$": 1274200,
    "address": "495 Boylston St, Unit A",
    "parcel_id": "253-08-03",
    "owner1": "ALLEN TR, LYNNE DAPHNE",
    "owner2": "",
    "current_taxes": 9412.87,
    "new_taxes_no_override": 9819.51,
    "override_total_1": 10098.13,
    "override_increase_1": 278.62
  },
  {
    "#": "495 Boylston St, Unit B (253-08-01)",
    "$": 1303100,
    "address": "495 Boylston St, Unit B",
    "parcel_id": "253-08-01",
    "owner1": "PRUNTY TR, HOWARD B",
    "owner2": "CHAFKIN PRUNTY, RANDEE ELLEN",
    "current_taxes": 13343.74,
    "new_taxes_no_override": 13920.19,
    "override_total_1": 14315.16,
    "override_increase_1": 394.97
  },
  {
    "#": "495 Boylston St, Unit C (253-08-02)",
    "$": 1275500,
    "address": "495 Boylston St, Unit C",
    "parcel_id": "253-08-02",
    "owner1": "WETZLER TRS, LEE M",
    "owner2": "GUTTORSMEN, HILDE",
    "current_taxes": 9426.19,
    "new_taxes_no_override": 9833.4,
    "override_total_1": 10112.42,
    "override_increase_1": 279.02
  },
  {
    "#": "497 Boylston St (253-09-00)",
    "$": 3110600,
    "address": "497 Boylston St",
    "parcel_id": "253-09-00",
    "owner1": "YANG, QUI LIN",
    "owner2": "CHEN, JING LIANG & KE TONG",
    "current_taxes": 31852.54,
    "new_taxes_no_override": 33228.57,
    "override_total_1": 34171.4,
    "override_increase_1": 942.84
  },
  {
    "#": "501 Boylston St (253-10-00)",
    "$": 3726600,
    "address": "501 Boylston St",
    "parcel_id": "253-10-00",
    "owner1": "ZOU, ZONG ZI & LI XIANG",
    "owner2": "",
    "current_taxes": 38160.38,
    "new_taxes_no_override": 39808.91,
    "override_total_1": 40938.46,
    "override_increase_1": 1129.55
  },
  {
    "#": "503 Boylston St, Unit 1 (253-11-06)",
    "$": 909300,
    "address": "503 Boylston St, Unit 1",
    "parcel_id": "253-11-06",
    "owner1": "IVANOV, PAVEL",
    "owner2": "IVANOVA, VICTORIA",
    "current_taxes": 5676.3,
    "new_taxes_no_override": 5921.52,
    "override_total_1": 6089.53,
    "override_increase_1": 168.02
  },
  {
    "#": "503 Boylston St, Unit 2 (253-11-01)",
    "$": 573200,
    "address": "503 Boylston St, Unit 2",
    "parcel_id": "253-11-01",
    "owner1": "OMBRELLO TRS, LEON",
    "owner2": "HEPNER, LAURA VIRGINIA",
    "current_taxes": 2234.63,
    "new_taxes_no_override": 2331.17,
    "override_total_1": 2397.31,
    "override_increase_1": 66.15
  },
  {
    "#": "503 Boylston St, Unit 3 (253-11-02)",
    "$": 715200,
    "address": "503 Boylston St, Unit 3",
    "parcel_id": "253-11-02",
    "owner1": "GONYER, DOMINIQUE S G",
    "owner2": "GIL, KRISS R",
    "current_taxes": 3688.71,
    "new_taxes_no_override": 3848.06,
    "override_total_1": 3957.25,
    "override_increase_1": 109.19
  },
  {
    "#": "503 Boylston St, Unit 4 (253-11-03)",
    "$": 573700,
    "address": "503 Boylston St, Unit 4",
    "parcel_id": "253-11-03",
    "owner1": "MAYS, JAMES",
    "owner2": "XIAO, MEILA",
    "current_taxes": 5874.69,
    "new_taxes_no_override": 6128.48,
    "override_total_1": 6302.37,
    "override_increase_1": 173.89
  },
  {
    "#": "503 Boylston St, Unit 5 (253-11-04)",
    "$": 702600,
    "address": "503 Boylston St, Unit 5",
    "parcel_id": "253-11-04",
    "owner1": "AYALA, OSCAR SANCHEZ",
    "owner2": "",
    "current_taxes": 3559.69,
    "new_taxes_no_override": 3713.47,
    "override_total_1": 3818.84,
    "override_increase_1": 105.37
  },
  {
    "#": "503 Boylston St, Unit 6 (253-11-05)",
    "$": 623400,
    "address": "503 Boylston St, Unit 6",
    "parcel_id": "253-11-05",
    "owner1": "GENDREAU, ERIN & KEVIN R & SEANNA T",
    "owner2": "",
    "current_taxes": 2748.68,
    "new_taxes_no_override": 2867.42,
    "override_total_1": 2948.78,
    "override_increase_1": 81.36
  },
  {
    "#": "509 Boylston St, Unit 509 (252-02-38)",
    "$": 1933100,
    "address": "509 Boylston St, Unit 509",
    "parcel_id": "252-02-38",
    "owner1": "AMZALLAG, ARNAUD",
    "owner2": "SHNAPER, SOPHIE",
    "current_taxes": 16160.01,
    "new_taxes_no_override": 16858.12,
    "override_total_1": 17336.46,
    "override_increase_1": 478.34
  },
  {
    "#": "511 Boylston St, Unit 511 (252-02-01)",
    "$": 1851100,
    "address": "511 Boylston St, Unit 511",
    "parcel_id": "252-02-01",
    "owner1": "SHAHBAZI, KAMRAN",
    "owner2": "SOUFI, FIROUZEH",
    "current_taxes": 15320.33,
    "new_taxes_no_override": 15982.17,
    "override_total_1": 16435.65,
    "override_increase_1": 453.48
  },
  {
    "#": "517 Boylston St, Unit 517 (252-02-02)",
    "$": 1864000,
    "address": "517 Boylston St, Unit 517",
    "parcel_id": "252-02-02",
    "owner1": "HESTER, JOHN N & ELIZABETH L",
    "owner2": "",
    "current_taxes": 15452.43,
    "new_taxes_no_override": 16119.97,
    "override_total_1": 16577.37,
    "override_increase_1": 457.39
  },
  {
    "#": "523 Boylston St, Unit 523 (252-02-03)",
    "$": 1899700,
    "address": "523 Boylston St, Unit 523",
    "parcel_id": "252-02-03",
    "owner1": "CHARLUPSKI TR, HELEN",
    "owner2": "",
    "current_taxes": 15817.99,
    "new_taxes_no_override": 16501.33,
    "override_total_1": 16969.54,
    "override_increase_1": 468.21
  },
  {
    "#": "525 Boylston St, Unit 525 (252-02-04)",
    "$": 1722200,
    "address": "525 Boylston St, Unit 525",
    "parcel_id": "252-02-04",
    "owner1": "PETER TRS, GEORGES & CAROLYN M",
    "owner2": "",
    "current_taxes": 17635.33,
    "new_taxes_no_override": 18397.18,
    "override_total_1": 18919.18,
    "override_increase_1": 522.01
  },
  {
    "#": "527 Boylston St, Unit 527 (252-02-05)",
    "$": 1848800,
    "address": "527 Boylston St, Unit 527",
    "parcel_id": "252-02-05",
    "owner1": "HSUEH, MING-JEN",
    "owner2": "KANG, YEAWON",
    "current_taxes": 15296.78,
    "new_taxes_no_override": 15957.6,
    "override_total_1": 16410.39,
    "override_increase_1": 452.78
  },
  {
    "#": "529 Boylston St, Unit 529 (252-02-06)",
    "$": 1895700,
    "address": "529 Boylston St, Unit 529",
    "parcel_id": "252-02-06",
    "owner1": "LEWIN, JOEL L & ARLENE S",
    "owner2": "",
    "current_taxes": 15777.03,
    "new_taxes_no_override": 16458.6,
    "override_total_1": 16925.6,
    "override_increase_1": 467.0
  },
  {
    "#": "531 Boylston St, Unit 531 (252-02-07)",
    "$": 1683800,
    "address": "531 Boylston St, Unit 531",
    "parcel_id": "252-02-07",
    "owner1": "SOLOMONT, AHRON & SHEERA",
    "owner2": "",
    "current_taxes": 13607.18,
    "new_taxes_no_override": 14195.01,
    "override_total_1": 14597.78,
    "override_increase_1": 402.77
  },
  {
    "#": "533 Boylston St, Unit 533 (252-02-08)",
    "$": 1756500,
    "address": "533 Boylston St, Unit 533",
    "parcel_id": "252-02-08",
    "owner1": "SCHREMPP, DANIELA C RAMIREZ",
    "owner2": "LITEPLO, ANDREW",
    "current_taxes": 14351.63,
    "new_taxes_no_override": 14971.62,
    "override_total_1": 15396.43,
    "override_increase_1": 424.81
  },
  {
    "#": "535 Boylston St, Unit 535 (252-02-09)",
    "$": 1805100,
    "address": "535 Boylston St, Unit 535",
    "parcel_id": "252-02-09",
    "owner1": "VEYSSI, BABEK & SHIFTEH",
    "owner2": "",
    "current_taxes": 14849.29,
    "new_taxes_no_override": 15490.78,
    "override_total_1": 15930.32,
    "override_increase_1": 439.54
  },
  {
    "#": "537 Boylston St, Unit 537 (252-02-10)",
    "$": 1912100,
    "address": "537 Boylston St, Unit 537",
    "parcel_id": "252-02-10",
    "owner1": "CIAMPA, DEVON",
    "owner2": "",
    "current_taxes": 15944.97,
    "new_taxes_no_override": 16633.79,
    "override_total_1": 17105.76,
    "override_increase_1": 471.97
  },
  {
    "#": "539 Boylston St, Unit 539 (252-02-11)",
    "$": 1644100,
    "address": "539 Boylston St, Unit 539",
    "parcel_id": "252-02-11",
    "owner1": "NEEDELL, ET AL, EDWARD B",
    "owner2": "",
    "current_taxes": 13200.65,
    "new_taxes_no_override": 13770.92,
    "override_total_1": 14161.66,
    "override_increase_1": 390.74
  },
  {
    "#": "541 Boylston St, Unit 541 (252-02-12)",
    "$": 3011000,
    "address": "541 Boylston St, Unit 541",
    "parcel_id": "252-02-12",
    "owner1": "GORDON TR, SUSAN E",
    "owner2": "",
    "current_taxes": 27197.71,
    "new_taxes_no_override": 28372.65,
    "override_total_1": 29177.7,
    "override_increase_1": 805.05
  },
  {
    "#": "543 Boylston St, Unit 543 (252-02-13)",
    "$": 2716300,
    "address": "543 Boylston St, Unit 543",
    "parcel_id": "252-02-13",
    "owner1": "COOMBS, PATRICIA A",
    "owner2": "",
    "current_taxes": 27814.91,
    "new_taxes_no_override": 29016.51,
    "override_total_1": 29839.84,
    "override_increase_1": 823.32
  },
  {
    "#": "545 Boylston St, Unit 545 (252-02-14)",
    "$": 2637200,
    "address": "545 Boylston St, Unit 545",
    "parcel_id": "252-02-14",
    "owner1": "SETTEL, KENNETH",
    "owner2": "KLINE, LINDA",
    "current_taxes": 23369.99,
    "new_taxes_no_override": 24379.57,
    "override_total_1": 25071.33,
    "override_increase_1": 691.75
  },
  {
    "#": "547 Boylston St, Unit 547 (252-02-15)",
    "$": 1915800,
    "address": "547 Boylston St, Unit 547",
    "parcel_id": "252-02-15",
    "owner1": "SLAVIN, THOMAS",
    "owner2": "",
    "current_taxes": 19617.79,
    "new_taxes_no_override": 20465.28,
    "override_total_1": 21045.97,
    "override_increase_1": 580.69
  },
  {
    "#": "549 Boylston St, Unit 549 (252-02-16)",
    "$": 1537500,
    "address": "549 Boylston St, Unit 549",
    "parcel_id": "252-02-16",
    "owner1": "SOLOMON, MILLY R & HAROLD S",
    "owner2": "",
    "current_taxes": 15744.0,
    "new_taxes_no_override": 16424.14,
    "override_total_1": 16890.16,
    "override_increase_1": 466.02
  },
  {
    "#": "551 Boylston St, Unit 551 (252-02-17)",
    "$": 1580300,
    "address": "551 Boylston St, Unit 551",
    "parcel_id": "252-02-17",
    "owner1": "LEINWAND, JO-ANN & C MARTIN",
    "owner2": "",
    "current_taxes": 12547.34,
    "new_taxes_no_override": 13089.39,
    "override_total_1": 13460.79,
    "override_increase_1": 371.4
  },
  {
    "#": "553 Boylston St, Unit 553 (252-02-18)",
    "$": 1531300,
    "address": "553 Boylston St, Unit 553",
    "parcel_id": "252-02-18",
    "owner1": "COX, EMILY & DAVID",
    "owner2": "",
    "current_taxes": 12045.58,
    "new_taxes_no_override": 12565.95,
    "override_total_1": 12922.5,
    "override_increase_1": 356.55
  },
  {
    "#": "555 Boylston St, Unit 555 (252-02-19)",
    "$": 2050600,
    "address": "555 Boylston St, Unit 555",
    "parcel_id": "252-02-19",
    "owner1": "92502 REALTY LLC",
    "owner2": "",
    "current_taxes": 20998.14,
    "new_taxes_no_override": 21905.26,
    "override_total_1": 22526.8,
    "override_increase_1": 621.54
  },
  {
    "#": "557 Boylston St, Unit 557 (252-02-20)",
    "$": 1602600,
    "address": "557 Boylston St, Unit 557",
    "parcel_id": "252-02-20",
    "owner1": "HAMED, NIMA A",
    "owner2": "DICKEY, RENEE",
    "current_taxes": 16410.62,
    "new_taxes_no_override": 17119.56,
    "override_total_1": 17605.31,
    "override_increase_1": 485.75
  },
  {
    "#": "559 Boylston St, Unit 559 (252-02-21)",
    "$": 1677900,
    "address": "559 Boylston St, Unit 559",
    "parcel_id": "252-02-21",
    "owner1": "OGARA, PATRICK T & LAURA",
    "owner2": "",
    "current_taxes": 13546.76,
    "new_taxes_no_override": 14131.98,
    "override_total_1": 14532.96,
    "override_increase_1": 400.98
  },
  {
    "#": "561 Boylston St, Unit 561 (252-02-22)",
    "$": 1651600,
    "address": "561 Boylston St, Unit 561",
    "parcel_id": "252-02-22",
    "owner1": "BRENNER TRS, FELICE",
    "owner2": "POLLETS, DAN F",
    "current_taxes": 13277.45,
    "new_taxes_no_override": 13851.04,
    "override_total_1": 14244.05,
    "override_increase_1": 393.01
  },
  {
    "#": "563 Boylston St, Unit 563 (252-02-23)",
    "$": 1678900,
    "address": "563 Boylston St, Unit 563",
    "parcel_id": "252-02-23",
    "owner1": "SLAVIN TR, THOMAS D",
    "owner2": "",
    "current_taxes": 13557.0,
    "new_taxes_no_override": 14142.66,
    "override_total_1": 14543.95,
    "override_increase_1": 401.29
  },
  {
    "#": "565 Boylston St, Unit 565 (252-02-24)",
    "$": 2203500,
    "address": "565 Boylston St, Unit 565",
    "parcel_id": "252-02-24",
    "owner1": "FLYNN, MICHAEL & KIMBERLY",
    "owner2": "",
    "current_taxes": 18928.91,
    "new_taxes_no_override": 19746.64,
    "override_total_1": 20306.93,
    "override_increase_1": 560.3
  },
  {
    "#": "567 Boylston St, Unit 567 (252-02-25)",
    "$": 1667500,
    "address": "567 Boylston St, Unit 567",
    "parcel_id": "252-02-25",
    "owner1": "SHAPIRO, SHARON",
    "owner2": "",
    "current_taxes": 13440.27,
    "new_taxes_no_override": 14020.89,
    "override_total_1": 14418.72,
    "override_increase_1": 397.83
  },
  {
    "#": "569 Boylston St, Unit 569 (252-02-26)",
    "$": 1919400,
    "address": "569 Boylston St, Unit 569",
    "parcel_id": "252-02-26",
    "owner1": "EDENIUS, MALTE A",
    "owner2": "",
    "current_taxes": 16019.72,
    "new_taxes_no_override": 16711.77,
    "override_total_1": 17185.96,
    "override_increase_1": 474.18
  },
  {
    "#": "571 Boylston St, Unit 571 (252-02-27)",
    "$": 1694100,
    "address": "571 Boylston St, Unit 571",
    "parcel_id": "252-02-27",
    "owner1": "FIRESTONE, WILLIAM",
    "owner2": "",
    "current_taxes": 17347.58,
    "new_taxes_no_override": 18097.0,
    "override_total_1": 18610.48,
    "override_increase_1": 513.49
  },
  {
    "#": "615 Boylston St (254-04-01)",
    "$": 369000,
    "address": "615 Boylston St",
    "parcel_id": "254-04-01",
    "owner1": "MERCHIA, JAGJIWAN",
    "owner2": "",
    "current_taxes": 3778.56,
    "new_taxes_no_override": 3941.79,
    "override_total_1": 4053.64,
    "override_increase_1": 111.85
  },
  {
    "#": "617 Boylston St (254-04-02)",
    "$": 3526200,
    "address": "617 Boylston St",
    "parcel_id": "254-04-02",
    "owner1": "MERCHIA, JAGJIWAN",
    "owner2": "",
    "current_taxes": 36108.29,
    "new_taxes_no_override": 37668.17,
    "override_total_1": 38736.97,
    "override_increase_1": 1068.81
  },
  {
    "#": "619 Boylston St (254-03-03)",
    "$": 10938600,
    "address": "619 Boylston St",
    "parcel_id": "254-03-03",
    "owner1": "BOYLSTON BROOKLINE LLC",
    "owner2": "",
    "current_taxes": 112011.26,
    "new_taxes_no_override": 116850.15,
    "override_total_1": 120165.68,
    "override_increase_1": 3315.53
  },
  {
    "#": "621 Boylston St (254-04-03)",
    "$": 2167300,
    "address": "621 Boylston St",
    "parcel_id": "254-04-03",
    "owner1": "KEOUGH TR, JOHN M",
    "owner2": "",
    "current_taxes": 22193.15,
    "new_taxes_no_override": 23151.89,
    "override_total_1": 23808.81,
    "override_increase_1": 656.92
  },
  {
    "#": "623 Boylston St (254-04-04)",
    "$": 510400,
    "address": "623 Boylston St",
    "parcel_id": "254-04-04",
    "owner1": "KEOUGH TR, JOHN M",
    "owner2": "",
    "current_taxes": 5226.5,
    "new_taxes_no_override": 5452.28,
    "override_total_1": 5606.99,
    "override_increase_1": 154.7
  },
  {
    "#": "683 Boylston St (255-03-00)",
    "$": 2471400,
    "address": "683 Boylston St",
    "parcel_id": "255-03-00",
    "owner1": "SOLOVEY, EDWARD & ERIN",
    "owner2": "",
    "current_taxes": 21672.2,
    "new_taxes_no_override": 22608.44,
    "override_total_1": 23249.94,
    "override_increase_1": 641.5
  },
  {
    "#": "691 Boylston St (255-04-00)",
    "$": 2508900,
    "address": "691 Boylston St",
    "parcel_id": "255-04-00",
    "owner1": "BIRO LLC",
    "owner2": "",
    "current_taxes": 25691.14,
    "new_taxes_no_override": 26801.0,
    "override_total_1": 27561.45,
    "override_increase_1": 760.46
  },
  {
    "#": "697 Boylston St (255-05-00)",
    "$": 2200300,
    "address": "697 Boylston St",
    "parcel_id": "255-05-00",
    "owner1": "ESCOBAR, JOSE & LAURA",
    "owner2": "",
    "current_taxes": 18896.14,
    "new_taxes_no_override": 19712.45,
    "override_total_1": 20271.78,
    "override_increase_1": 559.33
  },
  {
    "#": "703 Boylston St (255-06-00)",
    "$": 2333300,
    "address": "703 Boylston St",
    "parcel_id": "255-06-00",
    "owner1": "OMALLEY, MARTIN",
    "owner2": "IONOVA, ELENA",
    "current_taxes": 23892.99,
    "new_taxes_no_override": 24925.17,
    "override_total_1": 25632.4,
    "override_increase_1": 707.23
  },
  {
    "#": "709 Boylston St (255-07-00)",
    "$": 2732100,
    "address": "709 Boylston St",
    "parcel_id": "255-07-00",
    "owner1": "CHAN, KENNETH C",
    "owner2": "YING, YEE H",
    "current_taxes": 24341.77,
    "new_taxes_no_override": 25393.33,
    "override_total_1": 26113.85,
    "override_increase_1": 720.52
  },
  {
    "#": "728 Boylston St (276-13-00)",
    "$": 1402600,
    "address": "728 Boylston St",
    "parcel_id": "276-13-00",
    "owner1": "WING, ALVIN L & ANITA L",
    "owner2": "",
    "current_taxes": 10727.69,
    "new_taxes_no_override": 11191.13,
    "override_total_1": 11508.67,
    "override_increase_1": 317.54
  },
  {
    "#": "734 Boylston St (276-12-00)",
    "$": 1934000,
    "address": "734 Boylston St",
    "parcel_id": "276-12-00",
    "owner1": "KELLY TRS, FRANCIS M MONA E",
    "owner2": "",
    "current_taxes": 16169.23,
    "new_taxes_no_override": 16867.74,
    "override_total_1": 17346.35,
    "override_increase_1": 478.61
  },
  {
    "#": "740 Boylston St (276-11-01)",
    "$": 1412500,
    "address": "740 Boylston St",
    "parcel_id": "276-11-01",
    "owner1": "LEE TRS, WENDY W W & JOHN C Y",
    "owner2": "",
    "current_taxes": 10829.07,
    "new_taxes_no_override": 11296.89,
    "override_total_1": 11617.43,
    "override_increase_1": 320.54
  },
  {
    "#": "744 Boylston St (276-11-00)",
    "$": 1675700,
    "address": "744 Boylston St",
    "parcel_id": "276-11-00",
    "owner1": "744 BOYLSTON STREET LLC",
    "owner2": "MARIE DIMARCO",
    "current_taxes": 17159.17,
    "new_taxes_no_override": 17900.45,
    "override_total_1": 18408.36,
    "override_increase_1": 507.91
  },
  {
    "#": "748 Boylston St, Unit 1 & G2 (276-10-02)",
    "$": 913400,
    "address": "748 Boylston St, Unit 1 & G2",
    "parcel_id": "276-10-02",
    "owner1": "MAJUMDER, PRADIP K & ANAMIKA",
    "owner2": "",
    "current_taxes": 5718.28,
    "new_taxes_no_override": 5965.31,
    "override_total_1": 6134.57,
    "override_increase_1": 169.26
  },
  {
    "#": "748 Boylston St, Unit 2 & G1 (276-10-03)",
    "$": 930600,
    "address": "748 Boylston St, Unit 2 & G1",
    "parcel_id": "276-10-03",
    "owner1": "MORRIS, CHARON P",
    "owner2": "",
    "current_taxes": 5894.41,
    "new_taxes_no_override": 6149.05,
    "override_total_1": 6323.52,
    "override_increase_1": 174.47
  },
  {
    "#": "752 Boylston St (276-10-00)",
    "$": 1508000,
    "address": "752 Boylston St",
    "parcel_id": "276-10-00",
    "owner1": "LIN, TR, SANDRA M",
    "owner2": "C/O LIN MICHAEL C",
    "current_taxes": 15441.92,
    "new_taxes_no_override": 16109.01,
    "override_total_1": 16566.09,
    "override_increase_1": 457.08
  },
  {
    "#": "753 Boylston St (272-05-00)",
    "$": 1433400,
    "address": "753 Boylston St",
    "parcel_id": "272-05-00",
    "owner1": "WANG, DAVID",
    "owner2": "ZANG, LILY",
    "current_taxes": 14678.02,
    "new_taxes_no_override": 15312.11,
    "override_total_1": 15746.58,
    "override_increase_1": 434.47
  },
  {
    "#": "755 Boylston St (272-06-00)",
    "$": 1813700,
    "address": "755 Boylston St",
    "parcel_id": "272-06-00",
    "owner1": "755 BOYLSTON STREET DEVELOPMENT LLC",
    "owner2": "",
    "current_taxes": 18572.29,
    "new_taxes_no_override": 19374.61,
    "override_total_1": 19924.35,
    "override_increase_1": 549.74
  },
  {
    "#": "757 Boylston St (272-07-00)",
    "$": 1404800,
    "address": "757 Boylston St",
    "parcel_id": "272-07-00",
    "owner1": "TREECE, DONNA L",
    "owner2": "",
    "current_taxes": 10750.22,
    "new_taxes_no_override": 11214.63,
    "override_total_1": 11532.84,
    "override_increase_1": 318.21
  },
  {
    "#": "759 Boylston St (272-08-00)",
    "$": 1498500,
    "address": "759 Boylston St",
    "parcel_id": "272-08-00",
    "owner1": "FONG, SIMON MING & MONA YUEN",
    "owner2": "",
    "current_taxes": 11709.71,
    "new_taxes_no_override": 12215.57,
    "override_total_1": 12562.18,
    "override_increase_1": 346.61
  },
  {
    "#": "765 Boylston St, Unit 1 (272-09-01)",
    "$": 450900,
    "address": "765 Boylston St, Unit 1",
    "parcel_id": "272-09-01",
    "owner1": "GUO, YANCHI",
    "owner2": "",
    "current_taxes": 4617.22,
    "new_taxes_no_override": 4816.68,
    "override_total_1": 4953.35,
    "override_increase_1": 136.67
  },
  {
    "#": "765 Boylston St, Unit 2 (272-09-02)",
    "$": 549500,
    "address": "765 Boylston St, Unit 2",
    "parcel_id": "272-09-02",
    "owner1": "SPERL, CYNTHIA R",
    "owner2": "",
    "current_taxes": 5626.88,
    "new_taxes_no_override": 5869.96,
    "override_total_1": 6036.52,
    "override_increase_1": 166.56
  },
  {
    "#": "765 Boylston St, Unit 3 (272-09-03)",
    "$": 793400,
    "address": "765 Boylston St, Unit 3",
    "parcel_id": "272-09-03",
    "owner1": "KARABAS, MUSTAFA",
    "owner2": "DEMIRSOY, IPEK",
    "current_taxes": 8124.42,
    "new_taxes_no_override": 8475.39,
    "override_total_1": 8715.88,
    "override_increase_1": 240.48
  },
  {
    "#": "769 Boylston St, Unit 1 (272-10-01)",
    "$": 576900,
    "address": "769 Boylston St, Unit 1",
    "parcel_id": "272-10-01",
    "owner1": "ANDREAZI, JOSE C",
    "owner2": "PHAT, SARAH R",
    "current_taxes": 2272.52,
    "new_taxes_no_override": 2370.69,
    "override_total_1": 2437.96,
    "override_increase_1": 67.27
  },
  {
    "#": "769 Boylston St, Unit 2 (272-10-02)",
    "$": 555600,
    "address": "769 Boylston St, Unit 2",
    "parcel_id": "272-10-02",
    "owner1": "HOSTAILLER, FRANCOIS",
    "owner2": "",
    "current_taxes": 2054.41,
    "new_taxes_no_override": 2143.16,
    "override_total_1": 2203.97,
    "override_increase_1": 60.81
  },
  {
    "#": "769 Boylston St, Unit 3 (272-10-03)",
    "$": 589200,
    "address": "769 Boylston St, Unit 3",
    "parcel_id": "272-10-03",
    "owner1": "HOLLAND, MARGARET",
    "owner2": "LEIGHTON, JONAH",
    "current_taxes": 6033.41,
    "new_taxes_no_override": 6294.05,
    "override_total_1": 6472.64,
    "override_increase_1": 178.59
  },
  {
    "#": "770 Boylston St (276-06-09)",
    "$": 9283200,
    "address": "770 Boylston St",
    "parcel_id": "276-06-09",
    "owner1": "ROMAN CATHOLIC ARCHBISHOP",
    "owner2": "C/O PAUL MORIN -MGR",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "771 Boylston St, Unit 1 & P1 (272-11-01)",
    "$": 707200,
    "address": "771 Boylston St, Unit 1 & P1",
    "parcel_id": "272-11-01",
    "owner1": "SIMMONS, JOSEPH ROBERT",
    "owner2": "TAPALYAN, SARIN",
    "current_taxes": 3606.79,
    "new_taxes_no_override": 3762.6,
    "override_total_1": 3869.36,
    "override_increase_1": 106.76
  },
  {
    "#": "771 Boylston St, Unit 2 & P-2 (272-11-02)",
    "$": 709300,
    "address": "771 Boylston St, Unit 2 & P-2",
    "parcel_id": "272-11-02",
    "owner1": "NATARAJAN, JOSHUA ARUN & ABHILASHA",
    "owner2": "",
    "current_taxes": 3628.3,
    "new_taxes_no_override": 3785.04,
    "override_total_1": 3892.44,
    "override_increase_1": 107.4
  },
  {
    "#": "771 Boylston St, Unit 3 & P-3 (272-11-03)",
    "$": 676800,
    "address": "771 Boylston St, Unit 3 & P-3",
    "parcel_id": "272-11-03",
    "owner1": "SINERATE, NICHOLAS J",
    "owner2": "",
    "current_taxes": 6930.43,
    "new_taxes_no_override": 7229.82,
    "override_total_1": 7434.97,
    "override_increase_1": 205.14
  },
  {
    "#": "774 Boylston St (276-20-01)",
    "$": 3238600,
    "address": "774 Boylston St",
    "parcel_id": "276-20-01",
    "owner1": "ROMAN CATHOLIC ARCHBISHOP",
    "owner2": "C/O PAUL MORIN-R E MGR",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "775 Boylston St (273-01-00)",
    "$": 1455100,
    "address": "775 Boylston St",
    "parcel_id": "273-01-00",
    "owner1": "KHAN, EJAZ M",
    "owner2": "",
    "current_taxes": 11265.29,
    "new_taxes_no_override": 11751.95,
    "override_total_1": 12085.4,
    "override_increase_1": 333.45
  },
  {
    "#": "777 Boylston St (273-04-00)",
    "$": 1189900,
    "address": "777 Boylston St",
    "parcel_id": "273-04-00",
    "owner1": "OSORNO, ALBERT O & GILDARDO A",
    "owner2": "OSORNO ET AL, FREDY & MARTHA",
    "current_taxes": 12184.58,
    "new_taxes_no_override": 12710.95,
    "override_total_1": 13071.62,
    "override_increase_1": 360.66
  },
  {
    "#": "781 Boylston St, Unit 1 (274-01-01)",
    "$": 505500,
    "address": "781 Boylston St, Unit 1",
    "parcel_id": "274-01-01",
    "owner1": "LI, DAVID",
    "owner2": "KANG, JOSEPHINE",
    "current_taxes": 5176.32,
    "new_taxes_no_override": 5399.94,
    "override_total_1": 5553.16,
    "override_increase_1": 153.22
  },
  {
    "#": "781 Boylston St, Unit 2 (274-01-02)",
    "$": 530900,
    "address": "781 Boylston St, Unit 2",
    "parcel_id": "274-01-02",
    "owner1": "NGUYEN, LIEM",
    "owner2": "",
    "current_taxes": 5436.42,
    "new_taxes_no_override": 5671.27,
    "override_total_1": 5832.19,
    "override_increase_1": 160.92
  },
  {
    "#": "781 Boylston St, Unit 3 (274-01-03)",
    "$": 586900,
    "address": "781 Boylston St, Unit 3",
    "parcel_id": "274-01-03",
    "owner1": "781 BOYLSTON REALTY LLC",
    "owner2": "C/O 404 PLAINSBORO REALTY LLC",
    "current_taxes": 6009.86,
    "new_taxes_no_override": 6269.49,
    "override_total_1": 6447.38,
    "override_increase_1": 177.89
  },
  {
    "#": "783 Boylston St (274-02-00)",
    "$": 1227100,
    "address": "783 Boylston St",
    "parcel_id": "274-02-00",
    "owner1": "JACOBS, EDELTRAUD",
    "owner2": "",
    "current_taxes": 8930.57,
    "new_taxes_no_override": 9316.37,
    "override_total_1": 9580.72,
    "override_increase_1": 264.34
  },
  {
    "#": "787 Boylston St (274-03-00)",
    "$": 1172700,
    "address": "787 Boylston St",
    "parcel_id": "274-03-00",
    "owner1": "WARWICK TR, HELEN A",
    "owner2": "",
    "current_taxes": 12008.45,
    "new_taxes_no_override": 12527.22,
    "override_total_1": 12882.67,
    "override_increase_1": 355.45
  },
  {
    "#": "789 Boylston St (274-04-00)",
    "$": 2148700,
    "address": "789 Boylston St",
    "parcel_id": "274-04-00",
    "owner1": "DEMARAIS TR, LISA",
    "owner2": "",
    "current_taxes": 22002.69,
    "new_taxes_no_override": 22953.21,
    "override_total_1": 23604.49,
    "override_increase_1": 651.28
  },
  {
    "#": "794 Boylston St (276-03-04)",
    "$": 2190500,
    "address": "794 Boylston St",
    "parcel_id": "276-03-04",
    "owner1": "AMF CO INC",
    "owner2": "",
    "current_taxes": 22430.72,
    "new_taxes_no_override": 23399.73,
    "override_total_1": 24063.68,
    "override_increase_1": 663.95
  },
  {
    "#": "797 Boylston St (275-07-09)",
    "$": 1872700,
    "address": "797 Boylston St",
    "parcel_id": "275-07-09",
    "owner1": "SUDALTER TRS, MARK B",
    "owner2": "TANKEL, STEPHEN C",
    "current_taxes": 32135.53,
    "new_taxes_no_override": 33523.78,
    "override_total_1": 34475.0,
    "override_increase_1": 951.21
  },
  {
    "#": "800 Boylston St (276-01-00)",
    "$": 1931300,
    "address": "800 Boylston St",
    "parcel_id": "276-01-00",
    "owner1": "FARHO LLC",
    "owner2": "",
    "current_taxes": 33141.11,
    "new_taxes_no_override": 34572.81,
    "override_total_1": 35553.78,
    "override_increase_1": 980.98
  },
  {
    "#": "803 Boylston St (275-10-00)",
    "$": 2185300,
    "address": "803 Boylston St",
    "parcel_id": "275-10-00",
    "owner1": "TN CAPITAL LLC",
    "owner2": "",
    "current_taxes": 26864.05,
    "new_taxes_no_override": 28024.58,
    "override_total_1": 28819.75,
    "override_increase_1": 795.18
  },
  {
    "#": "809 Boylston St, Unit 1 (275-11-01)",
    "$": 676300,
    "address": "809 Boylston St, Unit 1",
    "parcel_id": "275-11-01",
    "owner1": "CHANG, JOANNA G & JUSTIN M",
    "owner2": "",
    "current_taxes": 3290.38,
    "new_taxes_no_override": 3432.52,
    "override_total_1": 3529.92,
    "override_increase_1": 97.4
  },
  {
    "#": "809 Boylston St, Unit 2 & G2 (275-11-02)",
    "$": 711000,
    "address": "809 Boylston St, Unit 2 & G2",
    "parcel_id": "275-11-02",
    "owner1": "MUSONERA, JOSHUA N",
    "owner2": "",
    "current_taxes": 7280.64,
    "new_taxes_no_override": 7595.16,
    "override_total_1": 7810.67,
    "override_increase_1": 215.51
  },
  {
    "#": "809 Boylston St, Unit 3 & G3 (275-11-03)",
    "$": 975700,
    "address": "809 Boylston St, Unit 3 & G3",
    "parcel_id": "275-11-03",
    "owner1": "KING, JAMES",
    "owner2": "CHEN, RACHEL",
    "current_taxes": 9991.17,
    "new_taxes_no_override": 10422.79,
    "override_total_1": 10718.53,
    "override_increase_1": 295.74
  },
  {
    "#": "811 Boylston St, Unit 1 & 2 Pk Sps (275-12-01)",
    "$": 1093200,
    "address": "811 Boylston St, Unit 1 & 2 Pk Sps",
    "parcel_id": "275-12-01",
    "owner1": "KARABAS, IPEK DEMIRSORY & MUSTAFA",
    "owner2": "",
    "current_taxes": 7559.43,
    "new_taxes_no_override": 7886.0,
    "override_total_1": 8109.76,
    "override_increase_1": 223.76
  },
  {
    "#": "811 Boylston St, Unit 2 & 2 Pk Sps (275-12-02)",
    "$": 1093200,
    "address": "811 Boylston St, Unit 2 & 2 Pk Sps",
    "parcel_id": "275-12-02",
    "owner1": "BAILEY, STEPHEN & AMY",
    "owner2": "",
    "current_taxes": 11194.37,
    "new_taxes_no_override": 11677.97,
    "override_total_1": 12009.32,
    "override_increase_1": 331.35
  },
  {
    "#": "815 Boylston St (275-16-00)",
    "$": 1565700,
    "address": "815 Boylston St",
    "parcel_id": "275-16-00",
    "owner1": "815-823 BOYLSTON STREET LLC",
    "owner2": "",
    "current_taxes": 26867.41,
    "new_taxes_no_override": 28028.08,
    "override_total_1": 28823.36,
    "override_increase_1": 795.28
  },
  {
    "#": "824 Boylston St (437-10-00)",
    "$": 10034800,
    "address": "824 Boylston St",
    "parcel_id": "437-10-00",
    "owner1": "CHESTNUT EQUITY PARTNERS II LLC",
    "owner2": "C/O AEGEAN CAPITAL LLC",
    "current_taxes": 172197.17,
    "new_taxes_no_override": 179636.09,
    "override_total_1": 184733.12,
    "override_increase_1": 5097.04
  },
  {
    "#": "827 Boylston St (277-01-01)",
    "$": 5229700,
    "address": "827 Boylston St",
    "parcel_id": "277-01-01",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O FIRE STATION #4",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "830 Boylston St (437-09-00)",
    "$": 25646700,
    "address": "830 Boylston St",
    "parcel_id": "437-09-00",
    "owner1": "THE BRIGHAM & WOMENS HOSPITAL INC",
    "owner2": "C/O TAX DIRECTOR",
    "current_taxes": 74538.15,
    "new_taxes_no_override": 77758.2,
    "override_total_1": 79964.53,
    "override_increase_1": 2206.33
  },
  {
    "#": "840 Boylston St (437-08-01)",
    "$": 10807100,
    "address": "840 Boylston St",
    "parcel_id": "437-08-01",
    "owner1": "BRIGHAM & WOMEN'S HOSPITAL INC",
    "owner2": "ATTN; DIRECTOR OF REAL ESTATE",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "845 Boylston St (278C-19-00)",
    "$": 2621300,
    "address": "845 Boylston St",
    "parcel_id": "278C-19-00",
    "owner1": "NINE JOHN STREET LLC",
    "owner2": "",
    "current_taxes": 44981.51,
    "new_taxes_no_override": 46924.71,
    "override_total_1": 48256.16,
    "override_increase_1": 1331.45
  },
  {
    "#": "850 Boylston St (437-08-00)",
    "$": 91449100,
    "address": "850 Boylston St",
    "parcel_id": "437-08-00",
    "owner1": "BRIGHAM & WOMEN'S HOSPITAL INC",
    "owner2": "ATTN; DIRECTOR OF REAL ESTATE",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "910 Boylston St (437-04-06)",
    "$": 72619000,
    "address": "910 Boylston St",
    "parcel_id": "437-04-06",
    "owner1": "CHESTNUT HILL BENEVOLENT ASSOC",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "990 Boylston St (437-04-01)",
    "$": 5494600,
    "address": "990 Boylston St",
    "parcel_id": "437-04-01",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O SINGLETREE HILL RESERVOIR",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "1014 Boylston St (437-03-00)",
    "$": 11904200,
    "address": "1014 Boylston St",
    "parcel_id": "437-03-00",
    "owner1": "SHEEHAN TR, PATRICK J",
    "owner2": "",
    "current_taxes": 118264.07,
    "new_taxes_no_override": 123373.08,
    "override_total_1": 126873.69,
    "override_increase_1": 3500.62
  },
  {
    "#": "1020 Boylston St (437-02-00)",
    "$": 2646600,
    "address": "1020 Boylston St",
    "parcel_id": "437-02-00",
    "owner1": "CURTIS, STEVEN A  & PETER A",
    "owner2": "CURTIS, MATTHEW A & SALLY A",
    "current_taxes": 23466.25,
    "new_taxes_no_override": 24479.99,
    "override_total_1": 25174.59,
    "override_increase_1": 694.6
  },
  {
    "#": "1025 Boylston St (278C-31-00)",
    "$": 2439600,
    "address": "1025 Boylston St",
    "parcel_id": "278C-31-00",
    "owner1": "DUTTA, BISWADEB",
    "owner2": "",
    "current_taxes": 21346.57,
    "new_taxes_no_override": 22268.74,
    "override_total_1": 22900.6,
    "override_increase_1": 631.86
  },
  {
    "#": "1033 Boylston St (278C-32-00)",
    "$": 1915900,
    "address": "1033 Boylston St",
    "parcel_id": "278C-32-00",
    "owner1": "ZELMAN, DANIEL",
    "owner2": "",
    "current_taxes": 19618.82,
    "new_taxes_no_override": 20466.35,
    "override_total_1": 21047.07,
    "override_increase_1": 580.72
  },
  {
    "#": "1039 Boylston St (278C-33-00)",
    "$": 3234100,
    "address": "1039 Boylston St",
    "parcel_id": "278C-33-00",
    "owner1": "BHOGAL, GURMINDER K",
    "owner2": "MEHTA, MRIDUL",
    "current_taxes": 29482.25,
    "new_taxes_no_override": 30755.88,
    "override_total_1": 31628.56,
    "override_increase_1": 872.67
  },
  {
    "#": "1041 Boylston St (278C-34-00)",
    "$": 3099000,
    "address": "1041 Boylston St",
    "parcel_id": "278C-34-00",
    "owner1": "SHURE, ANDREW F & DEBRA",
    "owner2": "",
    "current_taxes": 31733.76,
    "new_taxes_no_override": 33104.66,
    "override_total_1": 34043.98,
    "override_increase_1": 939.32
  },
  {
    "#": "1093 Boylston St (284-14-02)",
    "$": 1287900,
    "address": "1093 Boylston St",
    "parcel_id": "284-14-02",
    "owner1": "MAYDAL LLC",
    "owner2": "",
    "current_taxes": 13188.1,
    "new_taxes_no_override": 13757.83,
    "override_total_1": 14148.19,
    "override_increase_1": 390.37
  },
  {
    "#": "1101 Boylston St (284-15-00)",
    "$": 2394900,
    "address": "1101 Boylston St",
    "parcel_id": "284-15-00",
    "owner1": "CLINE, CAROLYN A",
    "owner2": "GORDON, MARCUS",
    "current_taxes": 20888.84,
    "new_taxes_no_override": 21791.24,
    "override_total_1": 22409.55,
    "override_increase_1": 618.31
  },
  {
    "#": "1106 Boylston St (434-02-00)",
    "$": 2023800,
    "address": "1106 Boylston St",
    "parcel_id": "434-02-00",
    "owner1": "PEPI, VINCENT",
    "owner2": "CHOU, RUBY",
    "current_taxes": 17088.78,
    "new_taxes_no_override": 17827.02,
    "override_total_1": 18332.84,
    "override_increase_1": 505.83
  },
  {
    "#": "1109 Boylston St (284-16-00)",
    "$": 3111200,
    "address": "1109 Boylston St",
    "parcel_id": "284-16-00",
    "owner1": "PAN, JASON S & AMY H",
    "owner2": "",
    "current_taxes": 28223.75,
    "new_taxes_no_override": 29443.02,
    "override_total_1": 30278.44,
    "override_increase_1": 835.42
  },
  {
    "#": "1117 Boylston St (284-17-00)",
    "$": 3309900,
    "address": "1117 Boylston St",
    "parcel_id": "284-17-00",
    "owner1": "ZWERLING TR, SUSAN J",
    "owner2": "",
    "current_taxes": 30258.44,
    "new_taxes_no_override": 31565.6,
    "override_total_1": 32461.25,
    "override_increase_1": 895.65
  },
  {
    "#": "1125 Boylston St (284-18-00)",
    "$": 18982000,
    "address": "1125 Boylston St",
    "parcel_id": "284-18-00",
    "owner1": "LONGYEAR FOUNDATION",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "1140 Boylston St (433-20-02)",
    "$": 1657800,
    "address": "1140 Boylston St",
    "parcel_id": "433-20-02",
    "owner1": "INCHIERCA, NICHOLAS G & DEBRA J",
    "owner2": "",
    "current_taxes": 13340.94,
    "new_taxes_no_override": 13917.27,
    "override_total_1": 14312.16,
    "override_increase_1": 394.89
  },
  {
    "#": "1148 Boylston St (433-19-00)",
    "$": 1812100,
    "address": "1148 Boylston St",
    "parcel_id": "433-19-00",
    "owner1": "GROPPER, JEROME",
    "owner2": "",
    "current_taxes": 14920.97,
    "new_taxes_no_override": 15565.56,
    "override_total_1": 16007.22,
    "override_increase_1": 441.66
  },
  {
    "#": "1154 Boylston St (433-17-00)",
    "$": 4332400,
    "address": "1154 Boylston St",
    "parcel_id": "433-17-00",
    "owner1": "WE CLOSE THE DEAL LLC",
    "owner2": "",
    "current_taxes": 74343.98,
    "new_taxes_no_override": 77555.64,
    "override_total_1": 79756.22,
    "override_increase_1": 2200.58
  },
  {
    "#": "1162 Boylston St, Unit 1 (433-16-02)",
    "$": 288000,
    "address": "1162 Boylston St, Unit 1",
    "parcel_id": "433-16-02",
    "owner1": "YEUNG, CHI WAH",
    "owner2": "YE, HUI SHI",
    "current_taxes": 294.91,
    "new_taxes_no_override": 307.65,
    "override_total_1": 316.38,
    "override_increase_1": 8.73
  },
  {
    "#": "1162 Boylston St, Unit 2 (433-16-03)",
    "$": 313800,
    "address": "1162 Boylston St, Unit 2",
    "parcel_id": "433-16-03",
    "owner1": "MONGRE, RAJ KUMAR",
    "owner2": "",
    "current_taxes": 321.33,
    "new_taxes_no_override": 335.21,
    "override_total_1": 344.72,
    "override_increase_1": 9.51
  },
  {
    "#": "1162 Boylston St, Unit 3 (433-16-04)",
    "$": 285000,
    "address": "1162 Boylston St, Unit 3",
    "parcel_id": "433-16-04",
    "owner1": "WONG, PAUL B & MAY W",
    "owner2": "",
    "current_taxes": 291.84,
    "new_taxes_no_override": 304.45,
    "override_total_1": 313.09,
    "override_increase_1": 8.64
  },
  {
    "#": "1164 Boylston St, Unit 1 (433-16-05)",
    "$": 305200,
    "address": "1164 Boylston St, Unit 1",
    "parcel_id": "433-16-05",
    "owner1": "SHAFRANSKIY, SERGEY & NATALIYA",
    "owner2": "",
    "current_taxes": 312.52,
    "new_taxes_no_override": 326.02,
    "override_total_1": 335.27,
    "override_increase_1": 9.25
  },
  {
    "#": "1164 Boylston St, Unit 2 (433-16-06)",
    "$": 297700,
    "address": "1164 Boylston St, Unit 2",
    "parcel_id": "433-16-06",
    "owner1": "GERZON, ALEKSANDR & KATHERINE",
    "owner2": "",
    "current_taxes": 304.84,
    "new_taxes_no_override": 318.01,
    "override_total_1": 327.03,
    "override_increase_1": 9.02
  },
  {
    "#": "1164 Boylston St, Unit 3 (433-16-07)",
    "$": 297700,
    "address": "1164 Boylston St, Unit 3",
    "parcel_id": "433-16-07",
    "owner1": "CHEN, YONG YUAN  & MEI YUN",
    "owner2": "",
    "current_taxes": 304.84,
    "new_taxes_no_override": 318.01,
    "override_total_1": 327.03,
    "override_increase_1": 9.02
  },
  {
    "#": "1180 Boylston St (433-11-12)",
    "$": 7143000,
    "address": "1180 Boylston St",
    "parcel_id": "433-11-12",
    "owner1": "CHESTNUT HILL INVESTMENTS LLC",
    "owner2": "",
    "current_taxes": 77094.2,
    "new_taxes_no_override": 80424.67,
    "override_total_1": 82706.66,
    "override_increase_1": 2281.99
  },
  {
    "#": "1182 Boylston St (427-09-00)",
    "$": 3549900,
    "address": "1182 Boylston St",
    "parcel_id": "427-09-00",
    "owner1": "FRAZER 1182 HOLDINGS LP",
    "owner2": "",
    "current_taxes": 60916.28,
    "new_taxes_no_override": 63547.86,
    "override_total_1": 65350.99,
    "override_increase_1": 1803.12
  },
  {
    "#": "1190 Boylston St (427-10-00)",
    "$": 675900,
    "address": "1190 Boylston St",
    "parcel_id": "427-10-00",
    "owner1": "ROCKLAND TRUST COMPANY",
    "owner2": "",
    "current_taxes": 11598.44,
    "new_taxes_no_override": 12099.49,
    "override_total_1": 12442.81,
    "override_increase_1": 343.31
  },
  {
    "#": "1192 Boylston St (427-08-00)",
    "$": 2718000,
    "address": "1192 Boylston St",
    "parcel_id": "427-08-00",
    "owner1": "CHESTNUT HILL COOPERATIVE BANK",
    "owner2": "C/O ROCKLAND TRUST, FACILITIES DEPT",
    "current_taxes": 46640.88,
    "new_taxes_no_override": 48655.77,
    "override_total_1": 50036.34,
    "override_increase_1": 1380.57
  },
  {
    "#": "1195 Boylston St (286-06-00)",
    "$": 8137700,
    "address": "1195 Boylston St",
    "parcel_id": "286-06-00",
    "owner1": "CHESTNUT HILL CVS INC 1862-02",
    "owner2": "C/O CVS PHARMACY INC #1862-02, STORE ACCT DEPT",
    "current_taxes": 139642.93,
    "new_taxes_no_override": 145675.5,
    "override_total_1": 149808.94,
    "override_increase_1": 4133.43
  },
  {
    "#": "1198 Boylston St (427-04-05)",
    "$": 7800500,
    "address": "1198 Boylston St",
    "parcel_id": "427-04-05",
    "owner1": "1198-1210 BOYLSTON STREET ASSC",
    "owner2": "C/O GJS MANAGEMENT LLC",
    "current_taxes": 94996.9,
    "new_taxes_no_override": 99100.77,
    "override_total_1": 101912.67,
    "override_increase_1": 2811.91
  },
  {
    "#": "1207 Boylston St (286-05-00)",
    "$": 14194300,
    "address": "1207 Boylston St",
    "parcel_id": "286-05-00",
    "owner1": "CHESTNUT HILL SHOPPING, CENTER LLC",
    "owner2": "C/O WS ASSET MGMT INC DEIRDRE GEOGHEGAM",
    "current_taxes": 243574.19,
    "new_taxes_no_override": 254096.6,
    "override_total_1": 261306.39,
    "override_increase_1": 7209.8
  },
  {
    "#": "1212 Boylston St (427-03-00)",
    "$": 1790000,
    "address": "1212 Boylston St",
    "parcel_id": "427-03-00",
    "owner1": "1212-1220 BOYLSTON LLC",
    "owner2": "C/O BROOKLINE BANK-AP",
    "current_taxes": 30716.4,
    "new_taxes_no_override": 32043.35,
    "override_total_1": 32952.55,
    "override_increase_1": 909.21
  },
  {
    "#": "1216 Boylston St (427-02-00)",
    "$": 1743500,
    "address": "1216 Boylston St",
    "parcel_id": "427-02-00",
    "owner1": "1212-1220 BOYLSTON LLC",
    "owner2": "C/O BROOKLINE BANK-AP",
    "current_taxes": 29918.46,
    "new_taxes_no_override": 31210.94,
    "override_total_1": 32096.52,
    "override_increase_1": 885.59
  },
  {
    "#": "1218 Boylston St (427-01-00)",
    "$": 2316900,
    "address": "1218 Boylston St",
    "parcel_id": "427-01-00",
    "owner1": "1212-1220 BOYLSTON LLC",
    "owner2": "C/O BROOKLINE BANK-AP",
    "current_taxes": 39758.0,
    "new_taxes_no_override": 41475.55,
    "override_total_1": 42652.38,
    "override_increase_1": 1176.84
  },
  {
    "#": "1228 Boylston St (426-05-00)",
    "$": 7113800,
    "address": "1228 Boylston St",
    "parcel_id": "426-05-00",
    "owner1": "S-BNK CHESTNUT HILL LLC",
    "owner2": "C/O SANTANDER BANK",
    "current_taxes": 122072.81,
    "new_taxes_no_override": 127346.36,
    "override_total_1": 130959.71,
    "override_increase_1": 3613.36
  },
  {
    "#": "1234 Boylston St (426-04-01)",
    "$": 9500100,
    "address": "1234 Boylston St",
    "parcel_id": "426-04-01",
    "owner1": "MARGOLIS, TRS, CALVIN & FREDERIC",
    "owner2": "C/O THE GROWTH COMPANIES",
    "current_taxes": 163021.72,
    "new_taxes_no_override": 170064.26,
    "override_total_1": 174889.7,
    "override_increase_1": 4825.44
  },
  {
    "#": "1244 Boylston St (426-01-03)",
    "$": 30503900,
    "address": "1244 Boylston St",
    "parcel_id": "426-01-03",
    "owner1": "MARGOLIS ET AL TRS, CALVIN",
    "owner2": "C/O DURBAN ASSOCIATES",
    "current_taxes": 523446.92,
    "new_taxes_no_override": 546059.83,
    "override_total_1": 561553.86,
    "override_increase_1": 15494.03
  },
  {
    "#": "1268 Boylston St (425-07-09)",
    "$": 3820500,
    "address": "1268 Boylston St",
    "parcel_id": "425-07-09",
    "owner1": "BERGER TRS, STANLEY I",
    "owner2": "MARGOLIS, F H",
    "current_taxes": 65559.78,
    "new_taxes_no_override": 68391.96,
    "override_total_1": 70332.53,
    "override_increase_1": 1940.57
  },
  {
    "#": "1280 Boylston St (425-10-00)",
    "$": 19281800,
    "address": "1280 Boylston St",
    "parcel_id": "425-10-00",
    "owner1": "STARIKOV TR, FRED",
    "owner2": "",
    "current_taxes": 330875.69,
    "new_taxes_no_override": 345169.52,
    "override_total_1": 354963.44,
    "override_increase_1": 9793.92
  },
  {
    "#": "1290 Boylston St (425-10-01)",
    "$": 2166700,
    "address": "1290 Boylston St",
    "parcel_id": "425-10-01",
    "owner1": "STARIKOV TR, FRED",
    "owner2": "",
    "current_taxes": 37180.57,
    "new_taxes_no_override": 38786.77,
    "override_total_1": 39887.32,
    "override_increase_1": 1100.54
  },
  {
    "#": "1300 Boylston St (425-11-00)",
    "$": 12546500,
    "address": "1300 Boylston St",
    "parcel_id": "425-11-00",
    "owner1": "STARIKOV TR, FRED",
    "owner2": "",
    "current_taxes": 215297.94,
    "new_taxes_no_override": 224598.81,
    "override_total_1": 230971.63,
    "override_increase_1": 6372.82
  },
  {
    "#": "1330 Boylston St (425-12-00)",
    "$": 29000000,
    "address": "1330 Boylston St",
    "parcel_id": "425-12-00",
    "owner1": "STARIKOV TR, FRED",
    "owner2": "",
    "current_taxes": 497640.0,
    "new_taxes_no_override": 519138.05,
    "override_total_1": 533868.19,
    "override_increase_1": 14730.14
  },
  {
    "#": "3 Bradford Ter, Unit 1 (048-11-13)",
    "$": 1001600,
    "address": "3 Bradford Ter, Unit 1",
    "parcel_id": "048-11-13",
    "owner1": "HE TRS, CHEN",
    "owner2": "CHEN, DELING",
    "current_taxes": 10256.38,
    "new_taxes_no_override": 10699.46,
    "override_total_1": 11003.04,
    "override_increase_1": 303.59
  },
  {
    "#": "3 Bradford Ter, Unit 2 (048-11-14)",
    "$": 1053400,
    "address": "3 Bradford Ter, Unit 2",
    "parcel_id": "048-11-14",
    "owner1": "SAMIEI, AHMAD",
    "owner2": "YAZDANI, AZAM",
    "current_taxes": 7151.88,
    "new_taxes_no_override": 7460.84,
    "override_total_1": 7672.54,
    "override_increase_1": 211.7
  },
  {
    "#": "3 Bradford Ter, Unit 3 (048-11-15)",
    "$": 1084400,
    "address": "3 Bradford Ter, Unit 3",
    "parcel_id": "048-11-15",
    "owner1": "MATWEY, VIDA",
    "owner2": "",
    "current_taxes": 11104.26,
    "new_taxes_no_override": 11583.96,
    "override_total_1": 11912.65,
    "override_increase_1": 328.69
  },
  {
    "#": "3 Bradford Ter, Unit 4 (048-11-16)",
    "$": 1037000,
    "address": "3 Bradford Ter, Unit 4",
    "parcel_id": "048-11-16",
    "owner1": "LEBOVITZ, MICHAEL C & MARGARET C",
    "owner2": "",
    "current_taxes": 10618.88,
    "new_taxes_no_override": 11077.62,
    "override_total_1": 11391.93,
    "override_increase_1": 314.32
  },
  {
    "#": "3 Bradford Ter, Unit 5 (048-11-17)",
    "$": 1091000,
    "address": "3 Bradford Ter, Unit 5",
    "parcel_id": "048-11-17",
    "owner1": "MIRAN, DAMIEN MICHAEL",
    "owner2": "RAMIREZ, KATIUSKA JOHANA",
    "current_taxes": 11171.84,
    "new_taxes_no_override": 11654.46,
    "override_total_1": 11985.15,
    "override_increase_1": 330.69
  },
  {
    "#": "3 Bradford Ter, Unit 6 & P1 (048-11-18)",
    "$": 1218200,
    "address": "3 Bradford Ter, Unit 6 & P1",
    "parcel_id": "048-11-18",
    "owner1": "WEISKOTT, ERIC",
    "owner2": "WARNER, ANA SOFIA",
    "current_taxes": 8839.43,
    "new_taxes_no_override": 9221.29,
    "override_total_1": 9482.94,
    "override_increase_1": 261.65
  },
  {
    "#": "4 Bradford Ter, Unit 4-1 (048-11-30)",
    "$": 1081700,
    "address": "4 Bradford Ter, Unit 4-1",
    "parcel_id": "048-11-30",
    "owner1": "BOYLE, GREGORY & SANDRA",
    "owner2": "",
    "current_taxes": 7441.67,
    "new_taxes_no_override": 7763.15,
    "override_total_1": 7983.42,
    "override_increase_1": 220.27
  },
  {
    "#": "4 Bradford Ter, Unit 4-2 & P7 (048-11-31)",
    "$": 1063400,
    "address": "4 Bradford Ter, Unit 4-2 & P7",
    "parcel_id": "048-11-31",
    "owner1": "LIPUMA, JOSEPH",
    "owner2": "ROARK, MARY",
    "current_taxes": 7254.28,
    "new_taxes_no_override": 7567.66,
    "override_total_1": 7782.39,
    "override_increase_1": 214.73
  },
  {
    "#": "4 Bradford Ter, Unit 4-3 (048-11-32)",
    "$": 1075500,
    "address": "4 Bradford Ter, Unit 4-3",
    "parcel_id": "048-11-32",
    "owner1": "HUEBNER, FRAUKE",
    "owner2": "",
    "current_taxes": 7378.19,
    "new_taxes_no_override": 7696.93,
    "override_total_1": 7915.32,
    "override_increase_1": 218.39
  },
  {
    "#": "4 Bradford Ter, Unit 4-4 (048-11-33)",
    "$": 1128000,
    "address": "4 Bradford Ter, Unit 4-4",
    "parcel_id": "048-11-33",
    "owner1": "LEUNG, GRACE SZE WAN",
    "owner2": "CHAN, YICK BUN",
    "current_taxes": 7915.79,
    "new_taxes_no_override": 8257.75,
    "override_total_1": 8492.06,
    "override_increase_1": 234.31
  },
  {
    "#": "4 Bradford Ter, Unit 4-5 (048-11-34)",
    "$": 1035100,
    "address": "4 Bradford Ter, Unit 4-5",
    "parcel_id": "048-11-34",
    "owner1": "BERGER, LYDIA T",
    "owner2": "",
    "current_taxes": 6964.49,
    "new_taxes_no_override": 7265.36,
    "override_total_1": 7471.5,
    "override_increase_1": 206.15
  },
  {
    "#": "4 Bradford Ter, Unit 4-6 (048-11-35)",
    "$": 1229900,
    "address": "4 Bradford Ter, Unit 4-6",
    "parcel_id": "048-11-35",
    "owner1": "SPRINGER, MARC K",
    "owner2": "HANSON, ANNE E",
    "current_taxes": 8959.24,
    "new_taxes_no_override": 9346.28,
    "override_total_1": 9611.47,
    "override_increase_1": 265.19
  },
  {
    "#": "9 Bradford Ter, Unit 1 (048-11-19)",
    "$": 1005400,
    "address": "9 Bradford Ter, Unit 1",
    "parcel_id": "048-11-19",
    "owner1": "HALLER, HELEN",
    "owner2": "EPWORTH, JEREMY",
    "current_taxes": 6660.36,
    "new_taxes_no_override": 6948.09,
    "override_total_1": 7145.23,
    "override_increase_1": 197.15
  },
  {
    "#": "9 Bradford Ter, Unit 2 (048-11-20)",
    "$": 1209200,
    "address": "9 Bradford Ter, Unit 2",
    "parcel_id": "048-11-20",
    "owner1": "",
    "owner2": "",
    "current_taxes": 8747.27,
    "new_taxes_no_override": 9125.15,
    "override_total_1": 9384.07,
    "override_increase_1": 258.92
  },
  {
    "#": "9 Bradford Ter, Unit 3 (048-11-21)",
    "$": 1036500,
    "address": "9 Bradford Ter, Unit 3",
    "parcel_id": "048-11-21",
    "owner1": "SALVATORE, MARK & KELLY",
    "owner2": "",
    "current_taxes": 6978.83,
    "new_taxes_no_override": 7280.32,
    "override_total_1": 7486.89,
    "override_increase_1": 206.57
  },
  {
    "#": "9 Bradford Ter, Unit 4 (048-11-22)",
    "$": 1258400,
    "address": "9 Bradford Ter, Unit 4",
    "parcel_id": "048-11-22",
    "owner1": "SONG, MIN HYOUNG",
    "owner2": "KIM, GRACE SUNGHAE",
    "current_taxes": 9251.08,
    "new_taxes_no_override": 9650.73,
    "override_total_1": 9924.56,
    "override_increase_1": 273.83
  },
  {
    "#": "9 Bradford Ter, Unit 5 (048-11-23)",
    "$": 1036600,
    "address": "9 Bradford Ter, Unit 5",
    "parcel_id": "048-11-23",
    "owner1": "CHOI, SE HOON",
    "owner2": "SEO, JI HEUI",
    "current_taxes": 6979.85,
    "new_taxes_no_override": 7281.38,
    "override_total_1": 7487.98,
    "override_increase_1": 206.6
  },
  {
    "#": "9 Bradford Ter, Unit 6 & P3 (048-11-24)",
    "$": 1377200,
    "address": "9 Bradford Ter, Unit 6 & P3",
    "parcel_id": "048-11-24",
    "owner1": "PENG, HAIYING",
    "owner2": "ZHAO, JEAN JING",
    "current_taxes": 10467.59,
    "new_taxes_no_override": 10919.79,
    "override_total_1": 11229.63,
    "override_increase_1": 309.84
  },
  {
    "#": "9 Bradford Ter, Unit 7 (048-11-25)",
    "$": 851200,
    "address": "9 Bradford Ter, Unit 7",
    "parcel_id": "048-11-25",
    "owner1": "PRAKASH, MADHAVI RATNAM",
    "owner2": "",
    "current_taxes": 8716.29,
    "new_taxes_no_override": 9092.83,
    "override_total_1": 9350.84,
    "override_increase_1": 258.0
  },
  {
    "#": "10 Bradford Ter, Unit 1 (048-11-36)",
    "$": 935000,
    "address": "10 Bradford Ter, Unit 1",
    "parcel_id": "048-11-36",
    "owner1": "REN, BOYU",
    "owner2": "HE, YUTONG",
    "current_taxes": 5939.47,
    "new_taxes_no_override": 6196.06,
    "override_total_1": 6371.86,
    "override_increase_1": 175.81
  },
  {
    "#": "10 Bradford Ter, Unit 2 (048-11-37)",
    "$": 1053000,
    "address": "10 Bradford Ter, Unit 2",
    "parcel_id": "048-11-37",
    "owner1": "MEYERS TR, ANNE R",
    "owner2": "",
    "current_taxes": 7147.79,
    "new_taxes_no_override": 7456.57,
    "override_total_1": 7668.15,
    "override_increase_1": 211.57
  },
  {
    "#": "10 Bradford Ter, Unit 3 (048-11-38)",
    "$": 1019000,
    "address": "10 Bradford Ter, Unit 3",
    "parcel_id": "048-11-38",
    "owner1": "TILEARCIO, MARION",
    "owner2": "WEINBLATT, DANIEL",
    "current_taxes": 6799.63,
    "new_taxes_no_override": 7093.37,
    "override_total_1": 7294.64,
    "override_increase_1": 201.27
  },
  {
    "#": "10 Bradford Ter, Unit 4 (048-11-39)",
    "$": 1049100,
    "address": "10 Bradford Ter, Unit 4",
    "parcel_id": "048-11-39",
    "owner1": "COUTTS, MARISA ANNE",
    "owner2": "",
    "current_taxes": 7107.85,
    "new_taxes_no_override": 7414.91,
    "override_total_1": 7625.3,
    "override_increase_1": 210.39
  },
  {
    "#": "10 Bradford Ter, Unit 5 (048-11-40)",
    "$": 1029700,
    "address": "10 Bradford Ter, Unit 5",
    "parcel_id": "048-11-40",
    "owner1": "MAITRA TRS, SAIBAL",
    "owner2": "MUKHERJEE, ARINDAM",
    "current_taxes": 6909.19,
    "new_taxes_no_override": 7207.67,
    "override_total_1": 7412.18,
    "override_increase_1": 204.51
  },
  {
    "#": "10 Bradford Ter, Unit 6 (048-11-41)",
    "$": 1031600,
    "address": "10 Bradford Ter, Unit 6",
    "parcel_id": "048-11-41",
    "owner1": "KAM-HANSEN TR, SLAVENKA",
    "owner2": "",
    "current_taxes": 10563.58,
    "new_taxes_no_override": 11019.93,
    "override_total_1": 11332.61,
    "override_increase_1": 312.68
  },
  {
    "#": "10 Bradford Ter, Unit 7 (048-11-42)",
    "$": 679900,
    "address": "10 Bradford Ter, Unit 7",
    "parcel_id": "048-11-42",
    "owner1": "LANDA, AMBAREEN RAFAT-KHAN",
    "owner2": "",
    "current_taxes": 3327.24,
    "new_taxes_no_override": 3470.98,
    "override_total_1": 3569.46,
    "override_increase_1": 98.49
  },
  {
    "#": "16 Brington Rd (190-11-00)",
    "$": 1842700,
    "address": "16 Brington Rd",
    "parcel_id": "190-11-00",
    "owner1": "CRANE, DANIEL J & HATSUHO",
    "owner2": "",
    "current_taxes": 15234.31,
    "new_taxes_no_override": 15892.43,
    "override_total_1": 16343.37,
    "override_increase_1": 450.94
  },
  {
    "#": "19 Brington Rd, Unit 1 (191-01-02)",
    "$": 886800,
    "address": "19 Brington Rd, Unit 1",
    "parcel_id": "191-01-02",
    "owner1": "AHN, JEAN P",
    "owner2": "MURPHY, JOHN",
    "current_taxes": 5445.9,
    "new_taxes_no_override": 5681.16,
    "override_total_1": 5842.36,
    "override_increase_1": 161.2
  },
  {
    "#": "20 Brington Rd, Unit 20 (190-10-01)",
    "$": 955400,
    "address": "20 Brington Rd, Unit 20",
    "parcel_id": "190-10-01",
    "owner1": "KRIER, JOEL B",
    "owner2": "LEE, AUDREY J",
    "current_taxes": 6148.36,
    "new_taxes_no_override": 6413.97,
    "override_total_1": 6595.96,
    "override_increase_1": 181.99
  },
  {
    "#": "21 Brington Rd, Unit 2 & Prk B (191-01-03)",
    "$": 1200400,
    "address": "21 Brington Rd, Unit 2 & Prk B",
    "parcel_id": "191-01-03",
    "owner1": "MORHAIME, VALERIE",
    "owner2": "EPSTEIN, ELI K",
    "current_taxes": 8657.16,
    "new_taxes_no_override": 9031.15,
    "override_total_1": 9287.4,
    "override_increase_1": 256.25
  },
  {
    "#": "22 Brington Rd, Unit 22 (190-10-02)",
    "$": 918600,
    "address": "22 Brington Rd, Unit 22",
    "parcel_id": "190-10-02",
    "owner1": "SMITH, KIM N",
    "owner2": "WEINER, DANIEL C",
    "current_taxes": 5771.53,
    "new_taxes_no_override": 6020.86,
    "override_total_1": 6191.7,
    "override_increase_1": 170.84
  },
  {
    "#": "25 Brington Rd (191-02-00)",
    "$": 1661600,
    "address": "25 Brington Rd",
    "parcel_id": "191-02-00",
    "owner1": "225 BRINGTON ROAD JV LLC",
    "owner2": "",
    "current_taxes": 13379.85,
    "new_taxes_no_override": 13957.86,
    "override_total_1": 14353.9,
    "override_increase_1": 396.04
  },
  {
    "#": "26 Brington Rd (190-09-00)",
    "$": 2204700,
    "address": "26 Brington Rd",
    "parcel_id": "190-09-00",
    "owner1": "OUDENS, MATTHEW T & ZAMIRA K",
    "owner2": "",
    "current_taxes": 18941.19,
    "new_taxes_no_override": 19759.45,
    "override_total_1": 20320.11,
    "override_increase_1": 560.66
  },
  {
    "#": "29 Brington Rd (191-03-00)",
    "$": 1880500,
    "address": "29 Brington Rd",
    "parcel_id": "191-03-00",
    "owner1": "LIMBO TR, DIANE",
    "owner2": "",
    "current_taxes": 19256.32,
    "new_taxes_no_override": 20088.19,
    "override_total_1": 20658.18,
    "override_increase_1": 569.99
  },
  {
    "#": "33 Brington Rd (191-04-00)",
    "$": 1616500,
    "address": "33 Brington Rd",
    "parcel_id": "191-04-00",
    "owner1": "TOM, HOON & PHYLLIS",
    "owner2": "",
    "current_taxes": 12918.03,
    "new_taxes_no_override": 13476.09,
    "override_total_1": 13858.46,
    "override_increase_1": 382.37
  },
  {
    "#": "34 Brington Rd (190-08-00)",
    "$": 3114800,
    "address": "34 Brington Rd",
    "parcel_id": "190-08-00",
    "owner1": "OFMAN, EKATERINA M & PETER U",
    "owner2": "",
    "current_taxes": 28260.62,
    "new_taxes_no_override": 29481.48,
    "override_total_1": 30317.99,
    "override_increase_1": 836.51
  },
  {
    "#": "37 Brington Rd (191-05-00)",
    "$": 1701900,
    "address": "37 Brington Rd",
    "parcel_id": "191-05-00",
    "owner1": "CHUNG TRS, CECILIA  & CALVIN",
    "owner2": "",
    "current_taxes": 17427.46,
    "new_taxes_no_override": 18180.33,
    "override_total_1": 18696.18,
    "override_increase_1": 515.85
  },
  {
    "#": "41 Brington Rd (191-06-00)",
    "$": 1920500,
    "address": "41 Brington Rd",
    "parcel_id": "191-06-00",
    "owner1": "MAHON TRS, THOMAS J & JOAN C",
    "owner2": "",
    "current_taxes": 16030.99,
    "new_taxes_no_override": 16723.53,
    "override_total_1": 17198.05,
    "override_increase_1": 474.52
  },
  {
    "#": "42 Brington Rd (190-07-00)",
    "$": 2268300,
    "address": "42 Brington Rd",
    "parcel_id": "190-07-00",
    "owner1": "SHELAT, ABHI",
    "owner2": "BROTHERS, CAMMY",
    "current_taxes": 19592.46,
    "new_taxes_no_override": 20438.85,
    "override_total_1": 21018.79,
    "override_increase_1": 579.94
  },
  {
    "#": "43 Brington Rd (191-30-00)",
    "$": 2559300,
    "address": "43 Brington Rd",
    "parcel_id": "191-30-00",
    "owner1": "DEMPSEY, JOHN P",
    "owner2": "SCOTT, MARY C",
    "current_taxes": 22572.3,
    "new_taxes_no_override": 23547.42,
    "override_total_1": 24215.56,
    "override_increase_1": 668.14
  },
  {
    "#": "45 Brington Rd, Unit A (191-07-00)",
    "$": 1781200,
    "address": "45 Brington Rd, Unit A",
    "parcel_id": "191-07-00",
    "owner1": "GARBER ET AL, JONATHAN",
    "owner2": "HOFFMAN, PHYLLIS KLEIN",
    "current_taxes": 18239.49,
    "new_taxes_no_override": 19027.44,
    "override_total_1": 19567.32,
    "override_increase_1": 539.89
  },
  {
    "#": "47 Brington Rd, Unit A, Unit 1 (191-08-01)",
    "$": 859700,
    "address": "47 Brington Rd, Unit A, Unit 1",
    "parcel_id": "191-08-01",
    "owner1": "BAKER, MILDRED H",
    "owner2": "",
    "current_taxes": 5168.39,
    "new_taxes_no_override": 5391.66,
    "override_total_1": 5544.65,
    "override_increase_1": 152.98
  },
  {
    "#": "47 Brington Rd, Unit A, Unit 2 (191-08-02)",
    "$": 1424400,
    "address": "47 Brington Rd, Unit A, Unit 2",
    "parcel_id": "191-08-02",
    "owner1": "FOWLER, GREGORY M",
    "owner2": "CHAN, BOPHAMEALY",
    "current_taxes": 10950.92,
    "new_taxes_no_override": 11424.0,
    "override_total_1": 11748.15,
    "override_increase_1": 324.15
  },
  {
    "#": "49 Brington Rd (191-07-01)",
    "$": 432200,
    "address": "49 Brington Rd",
    "parcel_id": "191-07-01",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O VACANT PARCEL/REAR 43 BRINGTN",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "51 Brington Rd (191-31-00)",
    "$": 2459900,
    "address": "51 Brington Rd",
    "parcel_id": "191-31-00",
    "owner1": "BRANDT TRS, ERIC S",
    "owner2": "SULLIVAN, MARY THOMAS",
    "current_taxes": 21554.44,
    "new_taxes_no_override": 22485.59,
    "override_total_1": 23123.6,
    "override_increase_1": 638.01
  },
  {
    "#": "53 Brington Rd (191-10-00)",
    "$": 1981200,
    "address": "53 Brington Rd",
    "parcel_id": "191-10-00",
    "owner1": "MADELEY, JOSHUA & DENISE",
    "owner2": "",
    "current_taxes": 16652.55,
    "new_taxes_no_override": 17371.94,
    "override_total_1": 17864.86,
    "override_increase_1": 492.92
  },
  {
    "#": "59 Brington Rd, Unit 59 (191-11-01)",
    "$": 1860000,
    "address": "59 Brington Rd, Unit 59",
    "parcel_id": "191-11-01",
    "owner1": "JOSEPH, JESSICA ELIZABETH",
    "owner2": "SMITH, SEAN PHILIP",
    "current_taxes": 15411.47,
    "new_taxes_no_override": 16077.25,
    "override_total_1": 16533.43,
    "override_increase_1": 456.18
  },
  {
    "#": "59 Brington Rd, Unit 61 (191-11-02)",
    "$": 1675400,
    "address": "59 Brington Rd, Unit 61",
    "parcel_id": "191-11-02",
    "owner1": "LINDENBAUM, ERIC",
    "owner2": "",
    "current_taxes": 13521.16,
    "new_taxes_no_override": 14105.27,
    "override_total_1": 14505.5,
    "override_increase_1": 400.23
  },
  {
    "#": "63 Brington Rd, Unit 1 (191-12-01)",
    "$": 1108500,
    "address": "63 Brington Rd, Unit 1",
    "parcel_id": "191-12-01",
    "owner1": "JAMPEL, JULIE B",
    "owner2": "",
    "current_taxes": 7716.11,
    "new_taxes_no_override": 8049.45,
    "override_total_1": 8277.84,
    "override_increase_1": 228.4
  },
  {
    "#": "64 Brington Rd (190-06-00)",
    "$": 2200900,
    "address": "64 Brington Rd",
    "parcel_id": "190-06-00",
    "owner1": "SANDERS TR, JANET L",
    "owner2": "",
    "current_taxes": 18902.28,
    "new_taxes_no_override": 19718.86,
    "override_total_1": 20278.37,
    "override_increase_1": 559.51
  },
  {
    "#": "65 Brington Rd, Unit 2 (191-12-02)",
    "$": 1175900,
    "address": "65 Brington Rd, Unit 2",
    "parcel_id": "191-12-02",
    "owner1": "JAMPEL, JULIE B",
    "owner2": "",
    "current_taxes": 12041.22,
    "new_taxes_no_override": 12561.4,
    "override_total_1": 12917.82,
    "override_increase_1": 356.42
  },
  {
    "#": "68 Brington Rd (190-05-00)",
    "$": 1489800,
    "address": "68 Brington Rd",
    "parcel_id": "190-05-00",
    "owner1": "DE KOSTER, CINDY ELIAS",
    "owner2": "",
    "current_taxes": 11620.62,
    "new_taxes_no_override": 12122.63,
    "override_total_1": 12466.6,
    "override_increase_1": 343.97
  },
  {
    "#": "69 Brington Rd (191-13-00)",
    "$": 1708800,
    "address": "69 Brington Rd",
    "parcel_id": "191-13-00",
    "owner1": "MORGAN, BARBARA J & JOAN M",
    "owner2": "",
    "current_taxes": 13863.18,
    "new_taxes_no_override": 14462.07,
    "override_total_1": 14872.42,
    "override_increase_1": 410.35
  },
  {
    "#": "70 Brington Rd (190-04-00)",
    "$": 1765000,
    "address": "70 Brington Rd",
    "parcel_id": "190-04-00",
    "owner1": "SULLIVAN, WALTER C",
    "owner2": "MALINN, MAUREEN M",
    "current_taxes": 14438.67,
    "new_taxes_no_override": 15062.42,
    "override_total_1": 15489.81,
    "override_increase_1": 427.38
  },
  {
    "#": "77 Brington Rd (191-14-00)",
    "$": 2248100,
    "address": "77 Brington Rd",
    "parcel_id": "191-14-00",
    "owner1": "HARTSHORN, ANDREW P",
    "owner2": "LU, JING",
    "current_taxes": 19385.61,
    "new_taxes_no_override": 20223.07,
    "override_total_1": 20796.88,
    "override_increase_1": 573.81
  },
  {
    "#": "78 Brington Rd (190-03-00)",
    "$": 1701900,
    "address": "78 Brington Rd",
    "parcel_id": "190-03-00",
    "owner1": "MUELLER, DIANNE",
    "owner2": "",
    "current_taxes": 13792.52,
    "new_taxes_no_override": 14388.36,
    "override_total_1": 14796.62,
    "override_increase_1": 408.26
  },
  {
    "#": "1 Brook St (143-01-00)",
    "$": 2390300,
    "address": "1 Brook St",
    "parcel_id": "143-01-00",
    "owner1": "TAUBE, ROBERTL",
    "owner2": "MCCARRELL, SHARON L",
    "current_taxes": 24476.67,
    "new_taxes_no_override": 25534.06,
    "override_total_1": 26258.57,
    "override_increase_1": 724.51
  },
  {
    "#": "19 Brook St (144-01-01)",
    "$": 2401400,
    "address": "19 Brook St",
    "parcel_id": "144-01-01",
    "owner1": "GRIMBERG, SHARON NAOMI",
    "owner2": "FRUMKIN, PETER",
    "current_taxes": 20955.4,
    "new_taxes_no_override": 21860.67,
    "override_total_1": 22480.95,
    "override_increase_1": 620.28
  },
  {
    "#": "24 Brook St (145-22-00)",
    "$": 1873800,
    "address": "24 Brook St",
    "parcel_id": "145-22-00",
    "owner1": "BROOK POND LLC",
    "owner2": "SAINI TR, VEENA C",
    "current_taxes": 19187.71,
    "new_taxes_no_override": 20016.62,
    "override_total_1": 20584.58,
    "override_increase_1": 567.96
  },
  {
    "#": "25 Brook St (144-02-00)",
    "$": 2172700,
    "address": "25 Brook St",
    "parcel_id": "144-02-00",
    "owner1": "COWNIE, RICHARD",
    "owner2": "LANDAY, LORI R",
    "current_taxes": 18613.51,
    "new_taxes_no_override": 19417.61,
    "override_total_1": 19968.57,
    "override_increase_1": 550.96
  },
  {
    "#": "26 Brook St (145-21-01)",
    "$": 2015700,
    "address": "26 Brook St",
    "parcel_id": "145-21-01",
    "owner1": "SHEA, JOHN M",
    "owner2": "DEZELL, MAUREEN",
    "current_taxes": 17005.83,
    "new_taxes_no_override": 17740.48,
    "override_total_1": 18243.85,
    "override_increase_1": 503.37
  },
  {
    "#": "27 Brook St (144-02-01)",
    "$": 2159200,
    "address": "27 Brook St",
    "parcel_id": "144-02-01",
    "owner1": "MUSSAFI, MICHELLE H",
    "owner2": "ABRAMSON, JUSTIN J",
    "current_taxes": 18475.27,
    "new_taxes_no_override": 19273.4,
    "override_total_1": 19820.27,
    "override_increase_1": 546.87
  },
  {
    "#": "28 Brook St, Unit 28 (145-21-02)",
    "$": 1733000,
    "address": "28 Brook St, Unit 28",
    "parcel_id": "145-21-02",
    "owner1": "TURLAND, KATHLEEN L",
    "owner2": "",
    "current_taxes": 14110.99,
    "new_taxes_no_override": 14720.58,
    "override_total_1": 15138.27,
    "override_increase_1": 417.69
  },
  {
    "#": "30 Brook St, Unit 30 (145-21-03)",
    "$": 1797100,
    "address": "30 Brook St, Unit 30",
    "parcel_id": "145-21-03",
    "owner1": "RICH TRS, JOHN",
    "owner2": "COOPER, INGRID E",
    "current_taxes": 14767.37,
    "new_taxes_no_override": 15405.32,
    "override_total_1": 15842.43,
    "override_increase_1": 437.11
  },
  {
    "#": "31 Brook St (144-03-00)",
    "$": 2273900,
    "address": "31 Brook St",
    "parcel_id": "144-03-00",
    "owner1": "GERBER, STEVEN J & NANCY",
    "owner2": "",
    "current_taxes": 19649.8,
    "new_taxes_no_override": 20498.67,
    "override_total_1": 21080.31,
    "override_increase_1": 581.63
  },
  {
    "#": "32 Brook St (145-20-01)",
    "$": 2206300,
    "address": "32 Brook St",
    "parcel_id": "145-20-01",
    "owner1": "BOER, ALEXANDER J",
    "owner2": "ZWASKA, ERIN",
    "current_taxes": 18957.58,
    "new_taxes_no_override": 19776.55,
    "override_total_1": 20337.69,
    "override_increase_1": 561.14
  },
  {
    "#": "33 Brook St (144-04-00)",
    "$": 2204600,
    "address": "33 Brook St",
    "parcel_id": "144-04-00",
    "owner1": "MOY TRS, GEORGE K G & ALICE H",
    "owner2": "",
    "current_taxes": 18940.17,
    "new_taxes_no_override": 19758.39,
    "override_total_1": 20319.01,
    "override_increase_1": 560.63
  },
  {
    "#": "34 Brook St (145-20-02)",
    "$": 2055900,
    "address": "34 Brook St",
    "parcel_id": "145-20-02",
    "owner1": "CAHILL, PATRICK & OLGA",
    "owner2": "",
    "current_taxes": 17417.48,
    "new_taxes_no_override": 18169.92,
    "override_total_1": 18685.47,
    "override_increase_1": 515.56
  },
  {
    "#": "37 Brook St (144-05-00)",
    "$": 2538700,
    "address": "37 Brook St",
    "parcel_id": "144-05-00",
    "owner1": "MOY TRS, GEORGE K G & ALICE H",
    "owner2": "",
    "current_taxes": 25996.29,
    "new_taxes_no_override": 27119.33,
    "override_total_1": 27888.82,
    "override_increase_1": 769.49
  },
  {
    "#": "40 Brook St (145-19-01)",
    "$": 1972700,
    "address": "40 Brook St",
    "parcel_id": "145-19-01",
    "owner1": "EGAN TRS, BRIAN JAMES & MARIA DEMETRA",
    "owner2": "",
    "current_taxes": 16565.51,
    "new_taxes_no_override": 17281.14,
    "override_total_1": 17771.48,
    "override_increase_1": 490.34
  },
  {
    "#": "41 Brook St (144-06-00)",
    "$": 1722500,
    "address": "41 Brook St",
    "parcel_id": "144-06-00",
    "owner1": "BURGUNDY REALTY LLC",
    "owner2": "",
    "current_taxes": 17638.4,
    "new_taxes_no_override": 18400.38,
    "override_total_1": 18922.48,
    "override_increase_1": 522.1
  },
  {
    "#": "42 Brook St (145-19-00)",
    "$": 2021000,
    "address": "42 Brook St",
    "parcel_id": "145-19-00",
    "owner1": "EDDY, MATTHEW W R",
    "owner2": "PELMAS, SARAH H",
    "current_taxes": 17060.11,
    "new_taxes_no_override": 17797.11,
    "override_total_1": 18302.09,
    "override_increase_1": 504.98
  },
  {
    "#": "44 Brook St, Unit 44 (145-18-01)",
    "$": 2010600,
    "address": "44 Brook St, Unit 44",
    "parcel_id": "145-18-01",
    "owner1": "RODRIGUEZ, DANIEL & CHRISTINE",
    "owner2": "",
    "current_taxes": 16953.61,
    "new_taxes_no_override": 17686.01,
    "override_total_1": 18187.83,
    "override_increase_1": 501.83
  },
  {
    "#": "45 Brook St (144-07-00)",
    "$": 1742000,
    "address": "45 Brook St",
    "parcel_id": "144-07-00",
    "owner1": "MULHANE, JOHN T & ELIZABETH A",
    "owner2": "",
    "current_taxes": 14203.15,
    "new_taxes_no_override": 14816.73,
    "override_total_1": 15237.14,
    "override_increase_1": 420.41
  },
  {
    "#": "46 Brook St, Unit 46 (145-18-02)",
    "$": 1931100,
    "address": "46 Brook St, Unit 46",
    "parcel_id": "145-18-02",
    "owner1": "DOLLINGER, JULIE BETH",
    "owner2": "",
    "current_taxes": 16139.53,
    "new_taxes_no_override": 16836.76,
    "override_total_1": 17314.49,
    "override_increase_1": 477.73
  },
  {
    "#": "47 Brook St (144-08-00)",
    "$": 2232100,
    "address": "47 Brook St",
    "parcel_id": "144-08-00",
    "owner1": "MOLLER, ANNE & ANDREW",
    "owner2": "",
    "current_taxes": 22856.7,
    "new_taxes_no_override": 23844.11,
    "override_total_1": 24520.67,
    "override_increase_1": 676.56
  },
  {
    "#": "48 Brook St (145-17-00)",
    "$": 2145400,
    "address": "48 Brook St",
    "parcel_id": "145-17-00",
    "owner1": "OUELLETTE, RICHARD RENE & DIANNE C",
    "owner2": "",
    "current_taxes": 18333.96,
    "new_taxes_no_override": 19125.99,
    "override_total_1": 19668.67,
    "override_increase_1": 542.69
  },
  {
    "#": "50 Brook St (145-16-00)",
    "$": 2162900,
    "address": "50 Brook St",
    "parcel_id": "145-16-00",
    "owner1": "PERRY, FRANK D & JENNIFER C",
    "owner2": "",
    "current_taxes": 18513.16,
    "new_taxes_no_override": 19312.93,
    "override_total_1": 19860.92,
    "override_increase_1": 547.99
  },
  {
    "#": "52 Brook St (145-15-00)",
    "$": 2058100,
    "address": "52 Brook St",
    "parcel_id": "145-15-00",
    "owner1": "SHORETT, PETER M",
    "owner2": "KALOWSKI, MICHELLE N",
    "current_taxes": 17440.01,
    "new_taxes_no_override": 18193.42,
    "override_total_1": 18709.64,
    "override_increase_1": 516.22
  },
  {
    "#": "53 Brook St (144-09-00)",
    "$": 2103600,
    "address": "53 Brook St",
    "parcel_id": "144-09-00",
    "owner1": "HODGSON, HOLDEN KIRK",
    "owner2": "",
    "current_taxes": 21540.86,
    "new_taxes_no_override": 22471.43,
    "override_total_1": 23109.03,
    "override_increase_1": 637.61
  },
  {
    "#": "54 Brook St (145-14-00)",
    "$": 1777300,
    "address": "54 Brook St",
    "parcel_id": "145-14-00",
    "owner1": "BULLITT, ESTHER A",
    "owner2": "",
    "current_taxes": 14564.62,
    "new_taxes_no_override": 15193.81,
    "override_total_1": 15624.92,
    "override_increase_1": 431.11
  },
  {
    "#": "55 Brook St (144-10-00)",
    "$": 1998300,
    "address": "55 Brook St",
    "parcel_id": "144-10-00",
    "owner1": "DERRIS, AUSTIN & AMY",
    "owner2": "",
    "current_taxes": 16827.66,
    "new_taxes_no_override": 17554.61,
    "override_total_1": 18052.71,
    "override_increase_1": 498.1
  },
  {
    "#": "58 Brook St (145-13-00)",
    "$": 2704400,
    "address": "58 Brook St",
    "parcel_id": "145-13-00",
    "owner1": "BRAUNS, ROBERT",
    "owner2": "BALL, VALERIE",
    "current_taxes": 24058.12,
    "new_taxes_no_override": 25097.43,
    "override_total_1": 25809.55,
    "override_increase_1": 712.12
  },
  {
    "#": "59 Brook St (144-11-00)",
    "$": 2383300,
    "address": "59 Brook St",
    "parcel_id": "144-11-00",
    "owner1": "JOHNSSON TRS, PIERRE",
    "owner2": "KAMINSKI, KATHRYN",
    "current_taxes": 24404.99,
    "new_taxes_no_override": 25459.29,
    "override_total_1": 26181.67,
    "override_increase_1": 722.39
  },
  {
    "#": "61 Brook St (144-12-00)",
    "$": 2571500,
    "address": "61 Brook St",
    "parcel_id": "144-12-00",
    "owner1": "WAGNER, GREGORY R",
    "owner2": "SPIELER, EMILY A",
    "current_taxes": 22697.23,
    "new_taxes_no_override": 23677.75,
    "override_total_1": 24349.59,
    "override_increase_1": 671.84
  },
  {
    "#": "65 Brook St (144-13-00)",
    "$": 2512500,
    "address": "65 Brook St",
    "parcel_id": "144-13-00",
    "owner1": "HARRINGTON TRS, ROBERT C & JEFFREY K",
    "owner2": "",
    "current_taxes": 25728.0,
    "new_taxes_no_override": 26839.45,
    "override_total_1": 27601.0,
    "override_increase_1": 761.55
  },
  {
    "#": "69 Brook St (152-01-00)",
    "$": 1842400,
    "address": "69 Brook St",
    "parcel_id": "152-01-00",
    "owner1": "PFOHL, STEPHEN J",
    "owner2": "",
    "current_taxes": 15231.24,
    "new_taxes_no_override": 15889.23,
    "override_total_1": 16340.07,
    "override_increase_1": 450.84
  },
  {
    "#": "75 Brook St, Unit 1 (152-02-01)",
    "$": 935400,
    "address": "75 Brook St, Unit 1",
    "parcel_id": "152-02-01",
    "owner1": "RAO, MEENAKSHI",
    "owner2": "RUTLIN, MICHAEL",
    "current_taxes": 9578.5,
    "new_taxes_no_override": 9992.29,
    "override_total_1": 10275.81,
    "override_increase_1": 283.52
  },
  {
    "#": "75 Brook St, Unit 2 (152-02-02)",
    "$": 1110300,
    "address": "75 Brook St, Unit 2",
    "parcel_id": "152-02-02",
    "owner1": "RUTLIN, MICHAEL",
    "owner2": "RAO, MEENAKSHI",
    "current_taxes": 7734.54,
    "new_taxes_no_override": 8068.67,
    "override_total_1": 8297.61,
    "override_increase_1": 228.94
  },
  {
    "#": "76 Brook St, Unit 1 (151-01-01)",
    "$": 794300,
    "address": "76 Brook St, Unit 1",
    "parcel_id": "151-01-01",
    "owner1": "COHN TR, LINDA C",
    "owner2": "",
    "current_taxes": 4498.7,
    "new_taxes_no_override": 4693.04,
    "override_total_1": 4826.21,
    "override_increase_1": 133.16
  },
  {
    "#": "76 Brook St, Unit 2 (151-01-02)",
    "$": 1176600,
    "address": "76 Brook St, Unit 2",
    "parcel_id": "151-01-02",
    "owner1": "SHEA TRS, SANDRA L",
    "owner2": "SCHECHTER, WILLIAM E",
    "current_taxes": 8413.45,
    "new_taxes_no_override": 8776.91,
    "override_total_1": 9025.95,
    "override_increase_1": 249.04
  },
  {
    "#": "77 Brook St, Unit 1 (152-03-01)",
    "$": 990200,
    "address": "77 Brook St, Unit 1",
    "parcel_id": "152-03-01",
    "owner1": "ERNST TR, CHRISTINE",
    "owner2": "",
    "current_taxes": 6504.71,
    "new_taxes_no_override": 6785.71,
    "override_total_1": 6978.25,
    "override_increase_1": 192.54
  },
  {
    "#": "77 Brook St, Unit 2 (152-03-02)",
    "$": 1283600,
    "address": "77 Brook St, Unit 2",
    "parcel_id": "152-03-02",
    "owner1": "GUMPERT, RICHARD H",
    "owner2": "FINUCANE, LAUREN",
    "current_taxes": 9509.13,
    "new_taxes_no_override": 9919.92,
    "override_total_1": 10201.39,
    "override_increase_1": 281.47
  },
  {
    "#": "79 Brook St (152-04-00)",
    "$": 3479100,
    "address": "79 Brook St",
    "parcel_id": "152-04-00",
    "owner1": "R J REALTY LIMITED PARTNERSHIP",
    "owner2": "",
    "current_taxes": 35625.98,
    "new_taxes_no_override": 37165.02,
    "override_total_1": 38219.55,
    "override_increase_1": 1054.53
  },
  {
    "#": "82 Brook St (151-15-00)",
    "$": 2687800,
    "address": "82 Brook St",
    "parcel_id": "151-15-00",
    "owner1": "MCCARRELL, SHARON L",
    "owner2": "",
    "current_taxes": 23888.14,
    "new_taxes_no_override": 24920.11,
    "override_total_1": 25627.2,
    "override_increase_1": 707.09
  },
  {
    "#": "83 Brook St (152-05-00)",
    "$": 2736400,
    "address": "83 Brook St",
    "parcel_id": "152-05-00",
    "owner1": "BROOKLINE RENTAL LLC",
    "owner2": "",
    "current_taxes": 28020.74,
    "new_taxes_no_override": 29231.24,
    "override_total_1": 30060.65,
    "override_increase_1": 829.41
  },
  {
    "#": "86 Brook St (151-14-00)",
    "$": 3023400,
    "address": "86 Brook St",
    "parcel_id": "151-14-00",
    "owner1": "86 BROOK LLC",
    "owner2": "",
    "current_taxes": 30959.62,
    "new_taxes_no_override": 32297.08,
    "override_total_1": 33213.48,
    "override_increase_1": 916.4
  },
  {
    "#": "87 Brook St (152-06-00)",
    "$": 2228700,
    "address": "87 Brook St",
    "parcel_id": "152-06-00",
    "owner1": "LI TRS, JIANYI",
    "owner2": "XIONG TRS, ZHILING",
    "current_taxes": 22821.89,
    "new_taxes_no_override": 23807.8,
    "override_total_1": 24483.32,
    "override_increase_1": 675.53
  },
  {
    "#": "88 Brook St (151-13-00)",
    "$": 1816200,
    "address": "88 Brook St",
    "parcel_id": "151-13-00",
    "owner1": "LEE LIFE ESTATE, KIN CHUN & MAN CHING YIP",
    "owner2": "",
    "current_taxes": 14962.95,
    "new_taxes_no_override": 15609.35,
    "override_total_1": 16052.25,
    "override_increase_1": 442.9
  },
  {
    "#": "90 Brook St (151-12-00)",
    "$": 1796700,
    "address": "90 Brook St",
    "parcel_id": "151-12-00",
    "owner1": "LONGWOOD PROPERTY GROUP LLC",
    "owner2": "",
    "current_taxes": 18398.21,
    "new_taxes_no_override": 19193.01,
    "override_total_1": 19737.6,
    "override_increase_1": 544.59
  },
  {
    "#": "94 Brook St (151-11-00)",
    "$": 2031000,
    "address": "94 Brook St",
    "parcel_id": "151-11-00",
    "owner1": "SHICK, LAWTON",
    "owner2": "HELEN A, SHIH",
    "current_taxes": 20797.44,
    "new_taxes_no_override": 21695.89,
    "override_total_1": 22311.49,
    "override_increase_1": 615.6
  },
  {
    "#": "96 Brook St, Unit 1 (151-10-03)",
    "$": 523300,
    "address": "96 Brook St, Unit 1",
    "parcel_id": "151-10-03",
    "owner1": "FERRARO, NICOLE",
    "owner2": "",
    "current_taxes": 5358.59,
    "new_taxes_no_override": 5590.08,
    "override_total_1": 5748.7,
    "override_increase_1": 158.61
  },
  {
    "#": "96 Brook St, Unit 2 (151-10-01)",
    "$": 604100,
    "address": "96 Brook St, Unit 2",
    "parcel_id": "151-10-01",
    "owner1": "BROADNAX, JOHN P",
    "owner2": "DENOOYER, ANNA J",
    "current_taxes": 6185.98,
    "new_taxes_no_override": 6453.21,
    "override_total_1": 6636.32,
    "override_increase_1": 183.11
  },
  {
    "#": "96 Brook St, Unit 3 (151-10-02)",
    "$": 698500,
    "address": "96 Brook St, Unit 3",
    "parcel_id": "151-10-02",
    "owner1": "KUO, CHUEH-LING",
    "owner2": "YU, WEN-HAN",
    "current_taxes": 3517.71,
    "new_taxes_no_override": 3669.68,
    "override_total_1": 3773.8,
    "override_increase_1": 104.12
  },
  {
    "#": "98 Brook St, Unit 100 & P2 (149-01-02)",
    "$": 1145200,
    "address": "98 Brook St, Unit 100 & P2",
    "parcel_id": "149-01-02",
    "owner1": "WELKER TR, KARIN M",
    "owner2": "",
    "current_taxes": 8091.91,
    "new_taxes_no_override": 8441.48,
    "override_total_1": 8681.0,
    "override_increase_1": 239.52
  },
  {
    "#": "98 Brook St, Unit 98 & P1 (149-01-01)",
    "$": 1274000,
    "address": "98 Brook St, Unit 98 & P1",
    "parcel_id": "149-01-01",
    "owner1": "98 BROOK LLC",
    "owner2": "",
    "current_taxes": 13045.76,
    "new_taxes_no_override": 13609.34,
    "override_total_1": 13995.49,
    "override_increase_1": 386.15
  },
  {
    "#": "105 Brook St (153-02-00)",
    "$": 2993800,
    "address": "105 Brook St",
    "parcel_id": "153-02-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O WARD PLAYGROUND",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "106 Brook St (149-38-03)",
    "$": 2135700,
    "address": "106 Brook St",
    "parcel_id": "149-38-03",
    "owner1": "MORSE, ABRAHAM",
    "owner2": "",
    "current_taxes": 21869.57,
    "new_taxes_no_override": 22814.34,
    "override_total_1": 23461.67,
    "override_increase_1": 647.34
  },
  {
    "#": "110 Brook St (149-37-00)",
    "$": 165100,
    "address": "110 Brook St",
    "parcel_id": "149-37-00",
    "owner1": "BITAR, NABIL & GHADA",
    "owner2": "",
    "current_taxes": 1690.62,
    "new_taxes_no_override": 1763.65,
    "override_total_1": 1813.7,
    "override_increase_1": 50.04
  },
  {
    "#": "114 Brook St, Unit 1 (149-36-01)",
    "$": 533400,
    "address": "114 Brook St, Unit 1",
    "parcel_id": "149-36-01",
    "owner1": "BROWN, TIMOTHY J & CHRISTINE L & RILEY M",
    "owner2": "",
    "current_taxes": 5462.02,
    "new_taxes_no_override": 5697.98,
    "override_total_1": 5859.66,
    "override_increase_1": 161.68
  },
  {
    "#": "114 Brook St, Unit 2 (149-36-02)",
    "$": 587900,
    "address": "114 Brook St, Unit 2",
    "parcel_id": "149-36-02",
    "owner1": "CHENG, LIYANG S",
    "owner2": "",
    "current_taxes": 6020.1,
    "new_taxes_no_override": 6280.17,
    "override_total_1": 6458.36,
    "override_increase_1": 178.19
  },
  {
    "#": "114 Brook St, Unit 3 (149-36-03)",
    "$": 603500,
    "address": "114 Brook St, Unit 3",
    "parcel_id": "149-36-03",
    "owner1": "KINLAY, STEPHANIE HEATHER",
    "owner2": "",
    "current_taxes": 2544.91,
    "new_taxes_no_override": 2654.85,
    "override_total_1": 2730.18,
    "override_increase_1": 75.33
  },
  {
    "#": "116 Brook St (149-35-00)",
    "$": 1933200,
    "address": "116 Brook St",
    "parcel_id": "149-35-00",
    "owner1": "BITAR, NABIL & GHADA",
    "owner2": "",
    "current_taxes": 19795.97,
    "new_taxes_no_override": 20651.16,
    "override_total_1": 21237.12,
    "override_increase_1": 585.96
  },
  {
    "#": "120 Brook St, Unit 1 (149-34-01)",
    "$": 561700,
    "address": "120 Brook St, Unit 1",
    "parcel_id": "149-34-01",
    "owner1": "KAY TR, KATHLEEN",
    "owner2": "",
    "current_taxes": 2116.87,
    "new_taxes_no_override": 2208.32,
    "override_total_1": 2270.98,
    "override_increase_1": 62.66
  },
  {
    "#": "120 Brook St, Unit 2 (149-34-02)",
    "$": 616500,
    "address": "120 Brook St, Unit 2",
    "parcel_id": "149-34-02",
    "owner1": "SILVERMAN, JASON L & SONIA S",
    "owner2": "",
    "current_taxes": 6312.96,
    "new_taxes_no_override": 6585.68,
    "override_total_1": 6772.54,
    "override_increase_1": 186.86
  },
  {
    "#": "120 Brook St, Unit 3 (149-34-03)",
    "$": 614900,
    "address": "120 Brook St, Unit 3",
    "parcel_id": "149-34-03",
    "owner1": "MISHRA TR, JYOTI",
    "owner2": "",
    "current_taxes": 6296.58,
    "new_taxes_no_override": 6568.59,
    "override_total_1": 6754.97,
    "override_increase_1": 186.38
  },
  {
    "#": "121 Brook St (153-04-00)",
    "$": 4236100,
    "address": "121 Brook St",
    "parcel_id": "153-04-00",
    "owner1": "NORA LLC",
    "owner2": "",
    "current_taxes": 43377.66,
    "new_taxes_no_override": 45251.57,
    "override_total_1": 46535.55,
    "override_increase_1": 1283.98
  },
  {
    "#": "129 Brook St (153-05-00)",
    "$": 3767300,
    "address": "129 Brook St",
    "parcel_id": "153-05-00",
    "owner1": "NORA LLC",
    "owner2": "",
    "current_taxes": 38577.15,
    "new_taxes_no_override": 40243.68,
    "override_total_1": 41385.57,
    "override_increase_1": 1141.88
  },
  {
    "#": "139 Brook St, Unit 1 (153-06-01)",
    "$": 688200,
    "address": "139 Brook St, Unit 1",
    "parcel_id": "153-06-01",
    "owner1": "ZHANG, DUO",
    "owner2": "WANG, XIAOYUM",
    "current_taxes": 7047.17,
    "new_taxes_no_override": 7351.61,
    "override_total_1": 7560.2,
    "override_increase_1": 208.6
  },
  {
    "#": "139 Brook St, Unit 2 (153-06-02)",
    "$": 1073500,
    "address": "139 Brook St, Unit 2",
    "parcel_id": "153-06-02",
    "owner1": "LI, ZHEN CHANG",
    "owner2": "YE, LIAN FANG",
    "current_taxes": 7357.71,
    "new_taxes_no_override": 7675.56,
    "override_total_1": 7893.35,
    "override_increase_1": 217.79
  },
  {
    "#": "139 Brook St, Unit 3 (153-06-03)",
    "$": 686000,
    "address": "139 Brook St, Unit 3",
    "parcel_id": "153-06-03",
    "owner1": "RUAN, CHANG YI",
    "owner2": "",
    "current_taxes": 3389.71,
    "new_taxes_no_override": 3536.15,
    "override_total_1": 3636.48,
    "override_increase_1": 100.34
  },
  {
    "#": "139 Brook St, Unit 4 (153-06-04)",
    "$": 1063800,
    "address": "139 Brook St, Unit 4",
    "parcel_id": "153-06-04",
    "owner1": "RUAN, JIAN YI",
    "owner2": "CHEN RUAN, XING CI",
    "current_taxes": 7258.38,
    "new_taxes_no_override": 7571.94,
    "override_total_1": 7786.79,
    "override_increase_1": 214.85
  },
  {
    "#": "147 Brook St, Unit 1& P3-G4 (153-07-03)",
    "$": 1044000,
    "address": "147 Brook St, Unit 1& P3-G4",
    "parcel_id": "153-07-03",
    "owner1": "DATTA, RAKESH & NEETA",
    "owner2": "",
    "current_taxes": 10690.56,
    "new_taxes_no_override": 11152.39,
    "override_total_1": 11468.83,
    "override_increase_1": 316.44
  },
  {
    "#": "147 Brook St, Unit 2 & P7 (153-07-01)",
    "$": 995700,
    "address": "147 Brook St, Unit 2 & P7",
    "parcel_id": "153-07-01",
    "owner1": "KONNIKOV TRS, GENNADY & NELLIE",
    "owner2": "",
    "current_taxes": 10195.97,
    "new_taxes_no_override": 10636.44,
    "override_total_1": 10938.24,
    "override_increase_1": 301.8
  },
  {
    "#": "147 Brook St, Unit 3 P1 P2 P9 (153-07-02)",
    "$": 1785500,
    "address": "147 Brook St, Unit 3 P1 P2 P9",
    "parcel_id": "153-07-02",
    "owner1": "TAYI, ALOK",
    "owner2": "LEE, ELAINE",
    "current_taxes": 14648.59,
    "new_taxes_no_override": 15281.41,
    "override_total_1": 15715.01,
    "override_increase_1": 433.6
  },
  {
    "#": "147 Brook St, Unit Pk Sp 10 (153-07-07)",
    "$": 49000,
    "address": "147 Brook St, Unit Pk Sp 10",
    "parcel_id": "153-07-07",
    "owner1": "KONNIKOV TRS, GENNADY & NELLIE",
    "owner2": "",
    "current_taxes": 501.76,
    "new_taxes_no_override": 523.44,
    "override_total_1": 538.29,
    "override_increase_1": 14.85
  },
  {
    "#": "147 Brook St, Unit Pk Sp 6 (153-07-05)",
    "$": 49000,
    "address": "147 Brook St, Unit Pk Sp 6",
    "parcel_id": "153-07-05",
    "owner1": "JOHNSTON, IAN & SHADI",
    "owner2": "",
    "current_taxes": 501.76,
    "new_taxes_no_override": 523.44,
    "override_total_1": 538.29,
    "override_increase_1": 14.85
  },
  {
    "#": "147 Brook St, Unit Pk Sp 8 (153-07-06)",
    "$": 49000,
    "address": "147 Brook St, Unit Pk Sp 8",
    "parcel_id": "153-07-06",
    "owner1": "KONNIKOV TRS, GENNADY & NELLIE",
    "owner2": "",
    "current_taxes": 501.76,
    "new_taxes_no_override": 523.44,
    "override_total_1": 538.29,
    "override_increase_1": 14.85
  },
  {
    "#": "147 Brook St, Unit Pk Sp G5 (153-07-04)",
    "$": 90800,
    "address": "147 Brook St, Unit Pk Sp G5",
    "parcel_id": "153-07-04",
    "owner1": "KURLANDER TR, KAREN A",
    "owner2": "",
    "current_taxes": 929.79,
    "new_taxes_no_override": 969.96,
    "override_total_1": 997.48,
    "override_increase_1": 27.52
  },
  {
    "#": "167 Brook St (153-08-00)",
    "$": 1897900,
    "address": "167 Brook St",
    "parcel_id": "153-08-00",
    "owner1": "KENDALL, AMOS",
    "owner2": "ROSS, CARRIE",
    "current_taxes": 15799.56,
    "new_taxes_no_override": 16482.1,
    "override_total_1": 16949.77,
    "override_increase_1": 467.67
  },
  {
    "#": "551 Brookline Ave, Unit 1 & P3 (134-13-12)",
    "$": 771500,
    "address": "551 Brookline Ave, Unit 1 & P3",
    "parcel_id": "134-13-12",
    "owner1": "STADNICKI, ALFRED P",
    "owner2": "TISHA, LEE F",
    "current_taxes": 7900.16,
    "new_taxes_no_override": 8241.45,
    "override_total_1": 8475.29,
    "override_increase_1": 233.84
  },
  {
    "#": "551 Brookline Ave, Unit 2 & P4 (134-13-01)",
    "$": 754700,
    "address": "551 Brookline Ave, Unit 2 & P4",
    "parcel_id": "134-13-01",
    "owner1": "ZUBOV, DMITRI",
    "owner2": "MIRONOVA, EKATERINA",
    "current_taxes": 4093.19,
    "new_taxes_no_override": 4270.02,
    "override_total_1": 4391.17,
    "override_increase_1": 121.16
  },
  {
    "#": "551 Brookline Ave, Unit 3 (134-13-02)",
    "$": 750400,
    "address": "551 Brookline Ave, Unit 3",
    "parcel_id": "134-13-02",
    "owner1": "TAN, PHILIP J",
    "owner2": "",
    "current_taxes": 7684.1,
    "new_taxes_no_override": 8016.05,
    "override_total_1": 8243.5,
    "override_increase_1": 227.45
  },
  {
    "#": "551 Brookline Ave, Unit 4 & P5 (134-13-03)",
    "$": 842600,
    "address": "551 Brookline Ave, Unit 4 & P5",
    "parcel_id": "134-13-03",
    "owner1": "BRYANT, ISABEL & BARBARA",
    "owner2": "",
    "current_taxes": 8628.22,
    "new_taxes_no_override": 9000.96,
    "override_total_1": 9256.35,
    "override_increase_1": 255.4
  },
  {
    "#": "551 Brookline Ave, Unit 5 & P1 (134-13-04)",
    "$": 822300,
    "address": "551 Brookline Ave, Unit 5 & P1",
    "parcel_id": "134-13-04",
    "owner1": "LIU, ANDREW",
    "owner2": "YANG-LIU, YANMEN",
    "current_taxes": 4785.42,
    "new_taxes_no_override": 4992.15,
    "override_total_1": 5133.8,
    "override_increase_1": 141.65
  },
  {
    "#": "551 Brookline Ave, Unit 6 & P2 (134-13-05)",
    "$": 842700,
    "address": "551 Brookline Ave, Unit 6 & P2",
    "parcel_id": "134-13-05",
    "owner1": "MELGUIZO, LAURA BRAVO",
    "owner2": "",
    "current_taxes": 4994.31,
    "new_taxes_no_override": 5210.06,
    "override_total_1": 5357.9,
    "override_increase_1": 147.83
  },
  {
    "#": "553 Brookline Ave (134-14-00)",
    "$": 4436700,
    "address": "553 Brookline Ave",
    "parcel_id": "134-14-00",
    "owner1": "PENG, TRS, JAMES LI-WEI & NANCY T",
    "owner2": "",
    "current_taxes": 45431.81,
    "new_taxes_no_override": 47394.46,
    "override_total_1": 48739.25,
    "override_increase_1": 1344.78
  },
  {
    "#": "599 Brookline Ave (137-01-02)",
    "$": 26396400,
    "address": "599 Brookline Ave",
    "parcel_id": "137-01-02",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O JAMES J LYNCH RECREATION CNTR",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "608 Brookline Ave (135-23-00)",
    "$": 220700,
    "address": "608 Brookline Ave",
    "parcel_id": "135-23-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O VACANT PARCEL/ABUT 610 BRKLINE",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "610 Brookline Ave (135-19-22)",
    "$": 2435600,
    "address": "610 Brookline Ave",
    "parcel_id": "135-19-22",
    "owner1": "BROOKLINE ICE & COAL CO",
    "owner2": "",
    "current_taxes": 41794.9,
    "new_taxes_no_override": 43600.44,
    "override_total_1": 44837.57,
    "override_increase_1": 1237.13
  },
  {
    "#": "636 Brookline Ave (135-17-18)",
    "$": 2087900,
    "address": "636 Brookline Ave",
    "parcel_id": "135-17-18",
    "owner1": "ELIE ON BROOKLINE AVE LLC",
    "owner2": "",
    "current_taxes": 35828.36,
    "new_taxes_no_override": 37376.15,
    "override_total_1": 38436.66,
    "override_increase_1": 1060.52
  },
  {
    "#": "646 Brookline Ave (135-15-00)",
    "$": 2797500,
    "address": "646 Brookline Ave",
    "parcel_id": "135-15-00",
    "owner1": "VAJRADHATU OF MASS INC",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "654 Brookline Ave (135-14-00)",
    "$": 1022900,
    "address": "654 Brookline Ave",
    "parcel_id": "135-14-00",
    "owner1": "CLAREMONT BROOKLINE LAND LLC",
    "owner2": "",
    "current_taxes": 17552.96,
    "new_taxes_no_override": 18311.25,
    "override_total_1": 18830.82,
    "override_increase_1": 519.57
  },
  {
    "#": "666 Brookline Ave (135-12-13)",
    "$": 2123200,
    "address": "666 Brookline Ave",
    "parcel_id": "135-12-13",
    "owner1": "CLAREMONT BROOKLINE LAND LLC",
    "owner2": "",
    "current_taxes": 36434.11,
    "new_taxes_no_override": 38008.06,
    "override_total_1": 39086.51,
    "override_increase_1": 1078.45
  },
  {
    "#": "676 Brookline Ave (135-10-11)",
    "$": 4105400,
    "address": "676 Brookline Ave",
    "parcel_id": "135-10-11",
    "owner1": "CLAREMONT BROOKLINE LAND II LLC",
    "owner2": "",
    "current_taxes": 70448.66,
    "new_taxes_no_override": 73492.04,
    "override_total_1": 75577.32,
    "override_increase_1": 2085.28
  },
  {
    "#": "700 Brookline Ave (135-01-00)",
    "$": 66600000,
    "address": "700 Brookline Ave",
    "parcel_id": "135-01-00",
    "owner1": "CLAREMONT BROOKLINE DEVELOPMENT LLC",
    "owner2": "",
    "current_taxes": 1142856.0,
    "new_taxes_no_override": 1192227.38,
    "override_total_1": 1226055.92,
    "override_increase_1": 33828.54
  },
  {
    "#": " Brookline Ave (134A-01-00)",
    "$": 18405300,
    "address": " Brookline Ave",
    "parcel_id": "134A-01-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O THE RIVERWAY",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "1 Brookline Pl (138-02-00)",
    "$": 102409700,
    "address": "1 Brookline Pl",
    "parcel_id": "138-02-00",
    "owner1": "BCH WASHINGTON STREET LLC",
    "owner2": "C/O KEYPOINT PARTNERS LLC",
    "current_taxes": 1757350.45,
    "new_taxes_no_override": 1833267.99,
    "override_total_1": 1885285.56,
    "override_increase_1": 52017.57
  },
  {
    "#": "2 Brookline Pl (138-01-00)",
    "$": 101807600,
    "address": "2 Brookline Pl",
    "parcel_id": "138-01-00",
    "owner1": "BCH PEARL STREET LLC",
    "owner2": "C/O CHILDRENS HOSPITAL CORP",
    "current_taxes": 1747018.42,
    "new_taxes_no_override": 1822489.62,
    "override_total_1": 1874201.36,
    "override_increase_1": 51711.75
  },
  {
    "#": "5 Brookline Pl (138-03-00)",
    "$": 5145400,
    "address": "5 Brookline Pl",
    "parcel_id": "138-03-00",
    "owner1": "BCH BROOKLINE AVENUE LLC",
    "owner2": "C/O CHILDRENS HOSPITAL CORP",
    "current_taxes": 52688.9,
    "new_taxes_no_override": 54965.06,
    "override_total_1": 56524.65,
    "override_increase_1": 1559.59
  },
  {
    "#": "10 Brookline Pl West (139-27-44)",
    "$": 151093500,
    "address": "10 Brookline Pl West",
    "parcel_id": "139-27-44",
    "owner1": "10 BP REALTY LLC",
    "owner2": "",
    "current_taxes": 2592764.46,
    "new_taxes_no_override": 2704771.88,
    "override_total_1": 2781517.71,
    "override_increase_1": 76745.83
  },
  {
    "#": "8 Browne St, Unit 1 (041-07-03)",
    "$": 1920500,
    "address": "8 Browne St, Unit 1",
    "parcel_id": "041-07-03",
    "owner1": "SWANSON, BENJAMIN NEAL & RACHEL N",
    "owner2": "",
    "current_taxes": 16030.99,
    "new_taxes_no_override": 16723.53,
    "override_total_1": 17198.05,
    "override_increase_1": 474.52
  },
  {
    "#": "8 Browne St, Unit 2 (041-07-01)",
    "$": 1513100,
    "address": "8 Browne St, Unit 2",
    "parcel_id": "041-07-01",
    "owner1": "SOLOMON, SAMUEL H",
    "owner2": "",
    "current_taxes": 11859.21,
    "new_taxes_no_override": 12371.53,
    "override_total_1": 12722.56,
    "override_increase_1": 351.03
  },
  {
    "#": "8 Browne St, Unit 3 (041-07-02)",
    "$": 1756000,
    "address": "8 Browne St, Unit 3",
    "parcel_id": "041-07-02",
    "owner1": "VICKERS, SCOTT C & MATILDE M",
    "owner2": "",
    "current_taxes": 14346.51,
    "new_taxes_no_override": 14966.28,
    "override_total_1": 15390.94,
    "override_increase_1": 424.66
  },
  {
    "#": "10 Browne St (041-06-00)",
    "$": 3592600,
    "address": "10 Browne St",
    "parcel_id": "041-06-00",
    "owner1": "LEE-BROWN LIMITED PARTNERSHIP",
    "owner2": "",
    "current_taxes": 36788.22,
    "new_taxes_no_override": 38377.47,
    "override_total_1": 39466.4,
    "override_increase_1": 1088.93
  },
  {
    "#": "12 Browne St, Unit 1 (041-05-01)",
    "$": 1433700,
    "address": "12 Browne St, Unit 1",
    "parcel_id": "041-05-01",
    "owner1": "ENNIS, RAY EVAN",
    "owner2": "",
    "current_taxes": 14681.09,
    "new_taxes_no_override": 15315.31,
    "override_total_1": 15749.87,
    "override_increase_1": 434.56
  },
  {
    "#": "12 Browne St, Unit 2 (041-05-02)",
    "$": 1647600,
    "address": "12 Browne St, Unit 2",
    "parcel_id": "041-05-02",
    "owner1": "TODD BARRETT, KARLA",
    "owner2": "",
    "current_taxes": 16871.42,
    "new_taxes_no_override": 17600.27,
    "override_total_1": 18099.66,
    "override_increase_1": 499.39
  },
  {
    "#": "12 Browne St, Unit 3 (041-05-03)",
    "$": 1576400,
    "address": "12 Browne St, Unit 3",
    "parcel_id": "041-05-03",
    "owner1": "KIRSCHENBAUM, IRA N",
    "owner2": "",
    "current_taxes": 12507.4,
    "new_taxes_no_override": 13047.72,
    "override_total_1": 13417.94,
    "override_increase_1": 370.22
  },
  {
    "#": "14 Browne St, Unit 1 & P3 (041-04-01)",
    "$": 1736500,
    "address": "14 Browne St, Unit 1 & P3",
    "parcel_id": "041-04-01",
    "owner1": "ISAIA, RUSSELL E & JANICE L",
    "owner2": "",
    "current_taxes": 14146.83,
    "new_taxes_no_override": 14757.97,
    "override_total_1": 15176.72,
    "override_increase_1": 418.75
  },
  {
    "#": "14 Browne St, Unit 1A (041-04-04)",
    "$": 819700,
    "address": "14 Browne St, Unit 1A",
    "parcel_id": "041-04-04",
    "owner1": "PHAM, PHUONG CHAN",
    "owner2": "LEFKOWITZ, RONAN",
    "current_taxes": 4758.79,
    "new_taxes_no_override": 4964.37,
    "override_total_1": 5105.23,
    "override_increase_1": 140.86
  },
  {
    "#": "14 Browne St, Unit 2 (041-04-02)",
    "$": 1684400,
    "address": "14 Browne St, Unit 2",
    "parcel_id": "041-04-02",
    "owner1": "CASTELLI TRS, GABRIELE & ANDREA",
    "owner2": "",
    "current_taxes": 13613.32,
    "new_taxes_no_override": 14201.42,
    "override_total_1": 14604.37,
    "override_increase_1": 402.95
  },
  {
    "#": "14 Browne St, Unit 3 (041-04-03)",
    "$": 1781900,
    "address": "14 Browne St, Unit 3",
    "parcel_id": "041-04-03",
    "owner1": "LANE, KENNETH D & CARLA P",
    "owner2": "",
    "current_taxes": 14611.72,
    "new_taxes_no_override": 15242.95,
    "override_total_1": 15675.45,
    "override_increase_1": 432.51
  },
  {
    "#": "16 Browne St (041-03-00)",
    "$": 4293600,
    "address": "16 Browne St",
    "parcel_id": "041-03-00",
    "owner1": "ROSENBERG, TR, NORMAN",
    "owner2": "",
    "current_taxes": 43966.46,
    "new_taxes_no_override": 45865.81,
    "override_total_1": 47167.22,
    "override_increase_1": 1301.41
  },
  {
    "#": "17 Browne St (039-08-00)",
    "$": 2713200,
    "address": "17 Browne St",
    "parcel_id": "039-08-00",
    "owner1": "HAVENS 2ND, WOODROW W",
    "owner2": "HAVENS, JUDITH",
    "current_taxes": 24148.23,
    "new_taxes_no_override": 25191.43,
    "override_total_1": 25906.22,
    "override_increase_1": 714.79
  },
  {
    "#": "18 Browne St, Unit 1 (041-02-04)",
    "$": 1412900,
    "address": "18 Browne St, Unit 1",
    "parcel_id": "041-02-04",
    "owner1": "BRAWER TRS, JEFFREY DAVID & MARCIE HUNTER",
    "owner2": "",
    "current_taxes": 10833.16,
    "new_taxes_no_override": 11301.15,
    "override_total_1": 11621.81,
    "override_increase_1": 320.66
  },
  {
    "#": "18 Browne St, Unit 2 (041-02-01)",
    "$": 1778100,
    "address": "18 Browne St, Unit 2",
    "parcel_id": "041-02-01",
    "owner1": "CHEN, KEXI",
    "owner2": "LAN, TAO",
    "current_taxes": 14572.81,
    "new_taxes_no_override": 15202.36,
    "override_total_1": 15633.71,
    "override_increase_1": 431.36
  },
  {
    "#": "18 Browne St, Unit 3 (041-02-02)",
    "$": 1773000,
    "address": "18 Browne St, Unit 3",
    "parcel_id": "041-02-02",
    "owner1": "ROGERS, CHRISTINE GIMBEL & JAMES BANKS",
    "owner2": "",
    "current_taxes": 14520.59,
    "new_taxes_no_override": 15147.88,
    "override_total_1": 15577.69,
    "override_increase_1": 429.81
  },
  {
    "#": "18 Browne St, Unit 4 (041-02-03)",
    "$": 519000,
    "address": "18 Browne St, Unit 4",
    "parcel_id": "041-02-03",
    "owner1": "COLLEEN TR",
    "owner2": "",
    "current_taxes": 1679.63,
    "new_taxes_no_override": 1752.19,
    "override_total_1": 1801.91,
    "override_increase_1": 49.72
  },
  {
    "#": "23 Browne St (039-09-00)",
    "$": 3805400,
    "address": "23 Browne St",
    "parcel_id": "039-09-00",
    "owner1": "LESTER TR, BRIAN W",
    "owner2": "",
    "current_taxes": 35332.36,
    "new_taxes_no_override": 36858.72,
    "override_total_1": 37904.56,
    "override_increase_1": 1045.84
  },
  {
    "#": "36 Browne St, Unit 1 (040-08-01)",
    "$": 735400,
    "address": "36 Browne St, Unit 1",
    "parcel_id": "040-08-01",
    "owner1": "EL ABBOUD, CELINE",
    "owner2": "CAFFEY, WILLIAM JAMES",
    "current_taxes": 3895.56,
    "new_taxes_no_override": 4063.85,
    "override_total_1": 4179.16,
    "override_increase_1": 115.31
  },
  {
    "#": "36 Browne St, Unit 2 (040-08-02)",
    "$": 801200,
    "address": "36 Browne St, Unit 2",
    "parcel_id": "040-08-02",
    "owner1": "MCLAUGHLIN, WILLIAM J",
    "owner2": "POLOS, S CHRISTIEN",
    "current_taxes": 8204.29,
    "new_taxes_no_override": 8558.72,
    "override_total_1": 8801.56,
    "override_increase_1": 242.85
  },
  {
    "#": "36 Browne St, Unit 3 (040-08-03)",
    "$": 838800,
    "address": "36 Browne St, Unit 3",
    "parcel_id": "040-08-03",
    "owner1": "JAEGER FAMILY LLC",
    "owner2": "",
    "current_taxes": 8589.31,
    "new_taxes_no_override": 8960.37,
    "override_total_1": 9214.61,
    "override_increase_1": 254.24
  },
  {
    "#": "36 Browne St, Unit 4 (040-08-04)",
    "$": 785700,
    "address": "36 Browne St, Unit 4",
    "parcel_id": "040-08-04",
    "owner1": "LIU, YINGJIE",
    "owner2": "",
    "current_taxes": 8045.57,
    "new_taxes_no_override": 8393.14,
    "override_total_1": 8631.29,
    "override_increase_1": 238.15
  },
  {
    "#": "36 Browne St, Unit 5 (040-08-05)",
    "$": 838700,
    "address": "36 Browne St, Unit 5",
    "parcel_id": "040-08-05",
    "owner1": "CHIU, DAVID",
    "owner2": "MCCLURE, ERIN E",
    "current_taxes": 8588.29,
    "new_taxes_no_override": 8959.3,
    "override_total_1": 9213.52,
    "override_increase_1": 254.21
  },
  {
    "#": "36 Browne St, Unit 6 (040-08-06)",
    "$": 783700,
    "address": "36 Browne St, Unit 6",
    "parcel_id": "040-08-06",
    "owner1": "SULISTIO, JOELLE",
    "owner2": "HATZIS, NICHOLAS",
    "current_taxes": 4390.15,
    "new_taxes_no_override": 4579.8,
    "override_total_1": 4709.75,
    "override_increase_1": 129.95
  },
  {
    "#": "38 Browne St, Unit 1 (040-08-07)",
    "$": 621200,
    "address": "38 Browne St, Unit 1",
    "parcel_id": "040-08-07",
    "owner1": "AYOTTE, JEANNINE M",
    "owner2": "",
    "current_taxes": 2726.15,
    "new_taxes_no_override": 2843.92,
    "override_total_1": 2924.61,
    "override_increase_1": 80.69
  },
  {
    "#": "38 Browne St, Unit 2 (040-08-08)",
    "$": 602700,
    "address": "38 Browne St, Unit 2",
    "parcel_id": "040-08-08",
    "owner1": "BROOKLINE HOUSING AUTHORITY",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "38 Browne St, Unit 3 (040-08-09)",
    "$": 621200,
    "address": "38 Browne St, Unit 3",
    "parcel_id": "040-08-09",
    "owner1": "REGINA, VIOLET M",
    "owner2": "",
    "current_taxes": 2726.15,
    "new_taxes_no_override": 2843.92,
    "override_total_1": 2924.61,
    "override_increase_1": 80.69
  },
  {
    "#": "38 Browne St, Unit 4 (040-08-10)",
    "$": 695100,
    "address": "38 Browne St, Unit 4",
    "parcel_id": "040-08-10",
    "owner1": "LIU, WENHAN",
    "owner2": "LI, QIYANG",
    "current_taxes": 7117.82,
    "new_taxes_no_override": 7425.31,
    "override_total_1": 7636.0,
    "override_increase_1": 210.69
  },
  {
    "#": "38 Browne St, Unit 5 (040-08-11)",
    "$": 726300,
    "address": "38 Browne St, Unit 5",
    "parcel_id": "040-08-11",
    "owner1": "DONOHUE TRS, JAMES P",
    "owner2": "GROVER, MARTHA S",
    "current_taxes": 7437.31,
    "new_taxes_no_override": 7758.6,
    "override_total_1": 7978.75,
    "override_increase_1": 220.14
  },
  {
    "#": "38 Browne St, Unit 6 (040-08-12)",
    "$": 595500,
    "address": "38 Browne St, Unit 6",
    "parcel_id": "040-08-12",
    "owner1": "ELLIS, GALEN M",
    "owner2": "SRIKANTH, PRIYA",
    "current_taxes": 2462.99,
    "new_taxes_no_override": 2569.39,
    "override_total_1": 2642.3,
    "override_increase_1": 72.9
  },
  {
    "#": "40 Browne St, Unit 1 (040-08-13)",
    "$": 707400,
    "address": "40 Browne St, Unit 1",
    "parcel_id": "040-08-13",
    "owner1": "PELISSIER, CARMEN M",
    "owner2": "FOOTE, RICHARD",
    "current_taxes": 3608.84,
    "new_taxes_no_override": 3764.74,
    "override_total_1": 3871.56,
    "override_increase_1": 106.82
  },
  {
    "#": "40 Browne St, Unit 2 (040-08-14)",
    "$": 514700,
    "address": "40 Browne St, Unit 2",
    "parcel_id": "040-08-14",
    "owner1": "JOHNSON  TR, MICHAEL R",
    "owner2": "",
    "current_taxes": 1635.59,
    "new_taxes_no_override": 1706.25,
    "override_total_1": 1754.66,
    "override_increase_1": 48.41
  },
  {
    "#": "40 Browne St, Unit 3 (040-08-15)",
    "$": 822800,
    "address": "40 Browne St, Unit 3",
    "parcel_id": "040-08-15",
    "owner1": "GUO, LIHONG",
    "owner2": "",
    "current_taxes": 8425.47,
    "new_taxes_no_override": 8789.45,
    "override_total_1": 9038.84,
    "override_increase_1": 249.39
  },
  {
    "#": "40 Browne St, Unit 4 (040-08-16)",
    "$": 588200,
    "address": "40 Browne St, Unit 4",
    "parcel_id": "040-08-16",
    "owner1": "WANG, LU",
    "owner2": "",
    "current_taxes": 2388.23,
    "new_taxes_no_override": 2491.4,
    "override_total_1": 2562.09,
    "override_increase_1": 70.69
  },
  {
    "#": "40 Browne St, Unit 5 (040-08-17)",
    "$": 816700,
    "address": "40 Browne St, Unit 5",
    "parcel_id": "040-08-17",
    "owner1": "ZARKER, CYNTHIA ERICKSON",
    "owner2": "",
    "current_taxes": 4728.07,
    "new_taxes_no_override": 4932.32,
    "override_total_1": 5072.27,
    "override_increase_1": 139.95
  },
  {
    "#": "40 Browne St, Unit 6 (040-08-18)",
    "$": 613700,
    "address": "40 Browne St, Unit 6",
    "parcel_id": "040-08-18",
    "owner1": "GILL, THOMAS K",
    "owner2": "",
    "current_taxes": 2649.35,
    "new_taxes_no_override": 2763.8,
    "override_total_1": 2842.22,
    "override_increase_1": 78.42
  },
  {
    "#": "42 Browne St, Unit 1 (040-08-19)",
    "$": 714800,
    "address": "42 Browne St, Unit 1",
    "parcel_id": "040-08-19",
    "owner1": "SANTIAGO, ALEX G & RACHEL",
    "owner2": "",
    "current_taxes": 7319.55,
    "new_taxes_no_override": 7635.75,
    "override_total_1": 7852.41,
    "override_increase_1": 216.66
  },
  {
    "#": "42 Browne St, Unit 2 (040-08-20)",
    "$": 722200,
    "address": "42 Browne St, Unit 2",
    "parcel_id": "040-08-20",
    "owner1": "MELEPPATTU, SHIMI",
    "owner2": "KUNHIKANDIYIL, NIDHISH",
    "current_taxes": 7395.33,
    "new_taxes_no_override": 7714.81,
    "override_total_1": 7933.71,
    "override_increase_1": 218.9
  },
  {
    "#": "42 Browne St, Unit 3 (040-08-21)",
    "$": 710900,
    "address": "42 Browne St, Unit 3",
    "parcel_id": "040-08-21",
    "owner1": "ZUCKOFF, EVE",
    "owner2": "",
    "current_taxes": 3644.68,
    "new_taxes_no_override": 3802.13,
    "override_total_1": 3910.01,
    "override_increase_1": 107.88
  },
  {
    "#": "42 Browne St, Unit 4 (040-08-22)",
    "$": 810600,
    "address": "42 Browne St, Unit 4",
    "parcel_id": "040-08-22",
    "owner1": "OCONNOR, RUTH",
    "owner2": "MONNIER, RICHARD",
    "current_taxes": 4665.61,
    "new_taxes_no_override": 4867.16,
    "override_total_1": 5005.27,
    "override_increase_1": 138.1
  },
  {
    "#": "42 Browne St, Unit 5 (040-08-23)",
    "$": 714800,
    "address": "42 Browne St, Unit 5",
    "parcel_id": "040-08-23",
    "owner1": "INDEFATIGABLE GROUP LIMITED LLC",
    "owner2": "",
    "current_taxes": 7319.55,
    "new_taxes_no_override": 7635.75,
    "override_total_1": 7852.41,
    "override_increase_1": 216.66
  },
  {
    "#": "42 Browne St, Unit 6 (040-08-24)",
    "$": 810600,
    "address": "42 Browne St, Unit 6",
    "parcel_id": "040-08-24",
    "owner1": "ARUMUGAM, THANGAMUTHU & VASANTHI",
    "owner2": "",
    "current_taxes": 8300.54,
    "new_taxes_no_override": 8659.12,
    "override_total_1": 8904.82,
    "override_increase_1": 245.7
  },
  {
    "#": "44 Browne St, Unit 1 (040-08-25)",
    "$": 839800,
    "address": "44 Browne St, Unit 1",
    "parcel_id": "040-08-25",
    "owner1": "SETHUNARAYANAN, JAYANTHI",
    "owner2": "NARAYANAN, CHIDAMBARAM",
    "current_taxes": 4964.62,
    "new_taxes_no_override": 5179.09,
    "override_total_1": 5326.04,
    "override_increase_1": 146.95
  },
  {
    "#": "44 Browne St, Unit 2 (040-08-26)",
    "$": 618200,
    "address": "44 Browne St, Unit 2",
    "parcel_id": "040-08-26",
    "owner1": "GOLDENTHAL, ABBY",
    "owner2": "",
    "current_taxes": 6330.37,
    "new_taxes_no_override": 6603.84,
    "override_total_1": 6791.22,
    "override_increase_1": 187.38
  },
  {
    "#": "44 Browne St, Unit 3 (040-08-27)",
    "$": 833600,
    "address": "44 Browne St, Unit 3",
    "parcel_id": "040-08-27",
    "owner1": "CHOI, JAE IL &  JUNG YOON",
    "owner2": "",
    "current_taxes": 4901.13,
    "new_taxes_no_override": 5112.86,
    "override_total_1": 5257.93,
    "override_increase_1": 145.07
  },
  {
    "#": "44 Browne St, Unit 4 (040-08-28)",
    "$": 697400,
    "address": "44 Browne St, Unit 4",
    "parcel_id": "040-08-28",
    "owner1": "BIRON, CYNTHIA P",
    "owner2": "",
    "current_taxes": 3506.44,
    "new_taxes_no_override": 3657.92,
    "override_total_1": 3761.71,
    "override_increase_1": 103.79
  },
  {
    "#": "44 Browne St, Unit 5 (040-08-29)",
    "$": 839800,
    "address": "44 Browne St, Unit 5",
    "parcel_id": "040-08-29",
    "owner1": "CHANG, TUNLIAN & PINGYAO & WEILYNN C",
    "owner2": "",
    "current_taxes": 8599.55,
    "new_taxes_no_override": 8971.05,
    "override_total_1": 9225.6,
    "override_increase_1": 254.55
  },
  {
    "#": "44 Browne St, Unit 6 (040-08-30)",
    "$": 726400,
    "address": "44 Browne St, Unit 6",
    "parcel_id": "040-08-30",
    "owner1": "CATIN, CATHERINE L",
    "owner2": "C/O USCG AIR STATION-T HOBAICA",
    "current_taxes": 7438.34,
    "new_taxes_no_override": 7759.68,
    "override_total_1": 7979.85,
    "override_increase_1": 220.17
  },
  {
    "#": "46 Browne St, Unit 1 (040-08-31)",
    "$": 499400,
    "address": "46 Browne St, Unit 1",
    "parcel_id": "040-08-31",
    "owner1": "SANCHEZ, ABEL & EMMA",
    "owner2": "",
    "current_taxes": 5113.86,
    "new_taxes_no_override": 5334.78,
    "override_total_1": 5486.15,
    "override_increase_1": 151.37
  },
  {
    "#": "46 Browne St, Unit 2 (040-08-32)",
    "$": 811300,
    "address": "46 Browne St, Unit 2",
    "parcel_id": "040-08-32",
    "owner1": "HARROWITZ TRS, NANCY",
    "owner2": "WATTERS, AUGUST",
    "current_taxes": 4672.78,
    "new_taxes_no_override": 4874.64,
    "override_total_1": 5012.96,
    "override_increase_1": 138.31
  },
  {
    "#": "46 Browne St, Unit 3 (040-08-33)",
    "$": 613800,
    "address": "46 Browne St, Unit 3",
    "parcel_id": "040-08-33",
    "owner1": "WANG TR, HAIDONG",
    "owner2": "",
    "current_taxes": 6285.31,
    "new_taxes_no_override": 6556.84,
    "override_total_1": 6742.88,
    "override_increase_1": 186.05
  },
  {
    "#": "46 Browne St, Unit 4 (040-08-34)",
    "$": 822900,
    "address": "46 Browne St, Unit 4",
    "parcel_id": "040-08-34",
    "owner1": "PAPPER, ROBIN E & MARTIN",
    "owner2": "",
    "current_taxes": 8426.5,
    "new_taxes_no_override": 8790.52,
    "override_total_1": 9039.95,
    "override_increase_1": 249.42
  },
  {
    "#": "46 Browne St, Unit 5 (040-08-35)",
    "$": 685000,
    "address": "46 Browne St, Unit 5",
    "parcel_id": "040-08-35",
    "owner1": "CHAN, BARBARA Y",
    "owner2": "LY, GREGORY J",
    "current_taxes": 3379.47,
    "new_taxes_no_override": 3525.46,
    "override_total_1": 3625.5,
    "override_increase_1": 100.03
  },
  {
    "#": "46 Browne St, Unit 6 (040-08-36)",
    "$": 822800,
    "address": "46 Browne St, Unit 6",
    "parcel_id": "040-08-36",
    "owner1": "AMINPOUR, FARHAD",
    "owner2": "",
    "current_taxes": 8425.47,
    "new_taxes_no_override": 8789.45,
    "override_total_1": 9038.84,
    "override_increase_1": 249.39
  },
  {
    "#": "48 Browne St, Unit 1 (040-08-37)",
    "$": 600900,
    "address": "48 Browne St, Unit 1",
    "parcel_id": "040-08-37",
    "owner1": "HUNG, ERIC K",
    "owner2": "REDFERN, RENEE C",
    "current_taxes": 2518.28,
    "new_taxes_no_override": 2627.07,
    "override_total_1": 2701.61,
    "override_increase_1": 74.54
  },
  {
    "#": "48 Browne St, Unit 2 (040-08-38)",
    "$": 621200,
    "address": "48 Browne St, Unit 2",
    "parcel_id": "040-08-38",
    "owner1": "PEHLKE, LINDA OLSON",
    "owner2": "",
    "current_taxes": 2726.15,
    "new_taxes_no_override": 2843.92,
    "override_total_1": 2924.61,
    "override_increase_1": 80.69
  },
  {
    "#": "48 Browne St, Unit 3 (040-08-39)",
    "$": 583600,
    "address": "48 Browne St, Unit 3",
    "parcel_id": "040-08-39",
    "owner1": "FINE TRS, JANET E",
    "owner2": "HARDOON TR, LAURENCE E",
    "current_taxes": 5976.06,
    "new_taxes_no_override": 6234.23,
    "override_total_1": 6411.12,
    "override_increase_1": 176.89
  },
  {
    "#": "48 Browne St, Unit 4 (040-08-40)",
    "$": 709000,
    "address": "48 Browne St, Unit 4",
    "parcel_id": "040-08-40",
    "owner1": "REEVES TR, MARY SUSAN",
    "owner2": "",
    "current_taxes": 7260.16,
    "new_taxes_no_override": 7573.8,
    "override_total_1": 7788.7,
    "override_increase_1": 214.9
  },
  {
    "#": "48 Browne St, Unit 5 (040-08-41)",
    "$": 666000,
    "address": "48 Browne St, Unit 5",
    "parcel_id": "040-08-41",
    "owner1": "SOBOL, TR, ARLENE",
    "owner2": "",
    "current_taxes": 6819.84,
    "new_taxes_no_override": 7114.46,
    "override_total_1": 7316.32,
    "override_increase_1": 201.87
  },
  {
    "#": "48 Browne St, Unit 6 (040-08-42)",
    "$": 699100,
    "address": "48 Browne St, Unit 6",
    "parcel_id": "040-08-42",
    "owner1": "BROWN, SHANNON",
    "owner2": "DOWNING, IAN P",
    "current_taxes": 7158.78,
    "new_taxes_no_override": 7468.04,
    "override_total_1": 7679.94,
    "override_increase_1": 211.9
  },
  {
    "#": "50 Browne St, Unit 1 (040-08-43)",
    "$": 676500,
    "address": "50 Browne St, Unit 1",
    "parcel_id": "040-08-43",
    "owner1": "WOLFSON, DANIEL A",
    "owner2": "",
    "current_taxes": 3292.43,
    "new_taxes_no_override": 3434.66,
    "override_total_1": 3532.12,
    "override_increase_1": 97.46
  },
  {
    "#": "50 Browne St, Unit 2 (040-08-44)",
    "$": 729300,
    "address": "50 Browne St, Unit 2",
    "parcel_id": "040-08-44",
    "owner1": "WATKINS, GRACE",
    "owner2": "",
    "current_taxes": 7468.03,
    "new_taxes_no_override": 7790.65,
    "override_total_1": 8011.7,
    "override_increase_1": 221.05
  },
  {
    "#": "50 Browne St, Unit 3 (040-08-45)",
    "$": 801200,
    "address": "50 Browne St, Unit 3",
    "parcel_id": "040-08-45",
    "owner1": "MOLIN, JACOB",
    "owner2": "",
    "current_taxes": 4569.35,
    "new_taxes_no_override": 4766.75,
    "override_total_1": 4902.0,
    "override_increase_1": 135.25
  },
  {
    "#": "50 Browne St, Unit 4 (040-08-46)",
    "$": 838700,
    "address": "50 Browne St, Unit 4",
    "parcel_id": "040-08-46",
    "owner1": "LEE, JULIANNE J",
    "owner2": "",
    "current_taxes": 4953.35,
    "new_taxes_no_override": 5167.33,
    "override_total_1": 5313.95,
    "override_increase_1": 146.62
  },
  {
    "#": "50 Browne St, Unit 5 (040-08-47)",
    "$": 794900,
    "address": "50 Browne St, Unit 5",
    "parcel_id": "040-08-47",
    "owner1": "WECHARATANA, MATHEW",
    "owner2": "",
    "current_taxes": 8139.78,
    "new_taxes_no_override": 8491.42,
    "override_total_1": 8732.36,
    "override_increase_1": 240.94
  },
  {
    "#": "50 Browne St, Unit 6 (040-08-48)",
    "$": 838800,
    "address": "50 Browne St, Unit 6",
    "parcel_id": "040-08-48",
    "owner1": "ZALTAS, A DAVID",
    "owner2": "",
    "current_taxes": 8589.31,
    "new_taxes_no_override": 8960.37,
    "override_total_1": 9214.61,
    "override_increase_1": 254.24
  },
  {
    "#": "56 Browne St, Unit 56-1 (040-06-01)",
    "$": 1493600,
    "address": "56 Browne St, Unit 56-1",
    "parcel_id": "040-06-01",
    "owner1": "PASERMAN, M DANIELE & ANAT SHAKED",
    "owner2": "",
    "current_taxes": 11659.53,
    "new_taxes_no_override": 12163.22,
    "override_total_1": 12508.34,
    "override_increase_1": 345.12
  },
  {
    "#": "56 Browne St, Unit 56-2 (040-06-02)",
    "$": 1591500,
    "address": "56 Browne St, Unit 56-2",
    "parcel_id": "040-06-02",
    "owner1": "MONTGOMERY TR, LAURA",
    "owner2": "",
    "current_taxes": 12662.03,
    "new_taxes_no_override": 13209.03,
    "override_total_1": 13583.83,
    "override_increase_1": 374.8
  },
  {
    "#": "56 Browne St, Unit 56-3 (040-06-03)",
    "$": 1539900,
    "address": "56 Browne St, Unit 56-3",
    "parcel_id": "040-06-03",
    "owner1": "BANDOPADHYAYA TRS, ARINDAM",
    "owner2": "BAEK , INMEE",
    "current_taxes": 12133.64,
    "new_taxes_no_override": 12657.81,
    "override_total_1": 13016.97,
    "override_increase_1": 359.16
  },
  {
    "#": "56 Browne St, Unit 56-B (040-06-10)",
    "$": 555400,
    "address": "56 Browne St, Unit 56-B",
    "parcel_id": "040-06-10",
    "owner1": "SHEA, MERRILL",
    "owner2": "",
    "current_taxes": 2052.36,
    "new_taxes_no_override": 2141.02,
    "override_total_1": 2201.77,
    "override_increase_1": 60.75
  },
  {
    "#": "60 Browne St, Unit 60-1 (040-06-04)",
    "$": 1301200,
    "address": "60 Browne St, Unit 60-1",
    "parcel_id": "040-06-04",
    "owner1": "LEIFER, PAULINE",
    "owner2": "GUTMAN, ELAD",
    "current_taxes": 9689.35,
    "new_taxes_no_override": 10107.93,
    "override_total_1": 10394.73,
    "override_increase_1": 286.8
  },
  {
    "#": "60 Browne St, Unit 60-2 (040-06-05)",
    "$": 1558400,
    "address": "60 Browne St, Unit 60-2",
    "parcel_id": "040-06-05",
    "owner1": "WYNNE, RICHARD C & ANA VERA",
    "owner2": "",
    "current_taxes": 12323.08,
    "new_taxes_no_override": 12855.44,
    "override_total_1": 13220.2,
    "override_increase_1": 364.76
  },
  {
    "#": "60 Browne St, Unit 60-3 (040-06-06)",
    "$": 1253000,
    "address": "60 Browne St, Unit 60-3",
    "parcel_id": "040-06-06",
    "owner1": "STRASSER, ZACHARY",
    "owner2": "RIZVI, NOREEN",
    "current_taxes": 12830.72,
    "new_taxes_no_override": 13385.01,
    "override_total_1": 13764.8,
    "override_increase_1": 379.79
  },
  {
    "#": "60 Browne St, Unit 60-4 (040-06-07)",
    "$": 1530600,
    "address": "60 Browne St, Unit 60-4",
    "parcel_id": "040-06-07",
    "owner1": "LOUIK TR, CAROL",
    "owner2": "",
    "current_taxes": 12038.41,
    "new_taxes_no_override": 12558.47,
    "override_total_1": 12914.81,
    "override_increase_1": 356.34
  },
  {
    "#": "60 Browne St, Unit 60-5 (040-06-08)",
    "$": 1241900,
    "address": "60 Browne St, Unit 60-5",
    "parcel_id": "040-06-08",
    "owner1": "VON WAGNER, ELIZABETH L",
    "owner2": "ROSENBAUM, STEPHEN M & GRAZIA F",
    "current_taxes": 12717.06,
    "new_taxes_no_override": 13266.44,
    "override_total_1": 13642.86,
    "override_increase_1": 376.42
  },
  {
    "#": "60 Browne St, Unit 60-6 (040-06-09)",
    "$": 1498400,
    "address": "60 Browne St, Unit 60-6",
    "parcel_id": "040-06-09",
    "owner1": "SHREFFLER, JOHN R & ANNE C",
    "owner2": "",
    "current_taxes": 11708.68,
    "new_taxes_no_override": 12214.49,
    "override_total_1": 12561.07,
    "override_increase_1": 346.58
  },
  {
    "#": "74 Browne St (035-35-00)",
    "$": 4418500,
    "address": "74 Browne St",
    "parcel_id": "035-35-00",
    "owner1": "74 BROWNE STREET LLC",
    "owner2": "",
    "current_taxes": 45245.44,
    "new_taxes_no_override": 47200.04,
    "override_total_1": 48539.31,
    "override_increase_1": 1339.27
  },
  {
    "#": "77 Browne St (036-18-00)",
    "$": 2971100,
    "address": "77 Browne St",
    "parcel_id": "036-18-00",
    "owner1": "LAGOS TRS, CONSTANTINE B & LILLIAN",
    "owner2": "WALSH, DAVID O & THERESA",
    "current_taxes": 26789.13,
    "new_taxes_no_override": 27946.42,
    "override_total_1": 28739.38,
    "override_increase_1": 792.96
  },
  {
    "#": "78 Browne St, Unit 1 & P1-Op1 (035-34-03)",
    "$": 996900,
    "address": "78 Browne St, Unit 1 & P1-Op1",
    "parcel_id": "035-34-03",
    "owner1": "TULIPANI, MICHAEL J",
    "owner2": "MEUS, JENNIFER A",
    "current_taxes": 10208.26,
    "new_taxes_no_override": 10649.26,
    "override_total_1": 10951.42,
    "override_increase_1": 302.16
  },
  {
    "#": "78 Browne St, Unit 2 & P2-Op2 (035-34-01)",
    "$": 1067100,
    "address": "78 Browne St, Unit 2 & P2-Op2",
    "parcel_id": "035-34-01",
    "owner1": "SHOHAM, MARK E",
    "owner2": "",
    "current_taxes": 10927.1,
    "new_taxes_no_override": 11399.15,
    "override_total_1": 11722.59,
    "override_increase_1": 323.44
  },
  {
    "#": "78 Browne St, Unit 3 & P3-Ap3 (035-34-02)",
    "$": 1082500,
    "address": "78 Browne St, Unit 3 & P3-Ap3",
    "parcel_id": "035-34-02",
    "owner1": "BEYZAROV, GENNADY",
    "owner2": "ROSENBAUM, DEBORAH",
    "current_taxes": 11084.8,
    "new_taxes_no_override": 11563.66,
    "override_total_1": 11891.77,
    "override_increase_1": 328.11
  },
  {
    "#": "78 Browne St, Unit C & Op-C (035-34-04)",
    "$": 427700,
    "address": "78 Browne St, Unit C & Op-C",
    "parcel_id": "035-34-04",
    "owner1": "BROWNE STREET REALTY TRUST LLC",
    "owner2": "",
    "current_taxes": 4379.65,
    "new_taxes_no_override": 4568.85,
    "override_total_1": 4698.49,
    "override_increase_1": 129.64
  },
  {
    "#": "78 Browne St, Unit Op3 (035-34-05)",
    "$": 49000,
    "address": "78 Browne St, Unit Op3",
    "parcel_id": "035-34-05",
    "owner1": "YANG, YUFENG",
    "owner2": "",
    "current_taxes": 501.76,
    "new_taxes_no_override": 523.44,
    "override_total_1": 538.29,
    "override_increase_1": 14.85
  },
  {
    "#": "80 Browne St, Unit 1 (035-33-02)",
    "$": 801300,
    "address": "80 Browne St, Unit 1",
    "parcel_id": "035-33-02",
    "owner1": "RUSSELL, LEFTERKICA",
    "owner2": "",
    "current_taxes": 8205.31,
    "new_taxes_no_override": 8559.78,
    "override_total_1": 8802.66,
    "override_increase_1": 242.88
  },
  {
    "#": "80 Browne St, Unit 2 (035-33-03)",
    "$": 872700,
    "address": "80 Browne St, Unit 2",
    "parcel_id": "035-33-03",
    "owner1": "YANG, YUFENG",
    "owner2": "",
    "current_taxes": 8936.45,
    "new_taxes_no_override": 9322.5,
    "override_total_1": 9587.02,
    "override_increase_1": 264.52
  },
  {
    "#": "80 Browne St, Unit 3 (035-33-04)",
    "$": 866200,
    "address": "80 Browne St, Unit 3",
    "parcel_id": "035-33-04",
    "owner1": "MA, CHENG",
    "owner2": "JACOBS, MICHAEL",
    "current_taxes": 8869.89,
    "new_taxes_no_override": 9253.07,
    "override_total_1": 9515.62,
    "override_increase_1": 262.55
  },
  {
    "#": "80 Browne St, Unit B1 (035-33-01)",
    "$": 419400,
    "address": "80 Browne St, Unit B1",
    "parcel_id": "035-33-01",
    "owner1": "PELTON, JORDAN C WILSON",
    "owner2": "",
    "current_taxes": 4294.66,
    "new_taxes_no_override": 4480.19,
    "override_total_1": 4607.31,
    "override_increase_1": 127.12
  },
  {
    "#": "82 Browne St, Unit 1 (035-32-03)",
    "$": 941800,
    "address": "82 Browne St, Unit 1",
    "parcel_id": "035-32-03",
    "owner1": "PARIS, JOSHUA & BETHANIA MONTAS",
    "owner2": "",
    "current_taxes": 9644.03,
    "new_taxes_no_override": 10060.65,
    "override_total_1": 10346.12,
    "override_increase_1": 285.46
  },
  {
    "#": "82 Browne St, Unit 2 (035-32-01)",
    "$": 1029500,
    "address": "82 Browne St, Unit 2",
    "parcel_id": "035-32-01",
    "owner1": "DREESE TRS, KEVIN T & JENNIFER R",
    "owner2": "",
    "current_taxes": 6907.15,
    "new_taxes_no_override": 7205.54,
    "override_total_1": 7409.99,
    "override_increase_1": 204.45
  },
  {
    "#": "82 Browne St, Unit 3 (035-32-02)",
    "$": 1000300,
    "address": "82 Browne St, Unit 3",
    "parcel_id": "035-32-02",
    "owner1": "SLIZ, JOSIAH & ADRIENNE E",
    "owner2": "",
    "current_taxes": 6608.14,
    "new_taxes_no_override": 6893.61,
    "override_total_1": 7089.21,
    "override_increase_1": 195.6
  },
  {
    "#": "83 Browne St (036-19-00)",
    "$": 3076700,
    "address": "83 Browne St",
    "parcel_id": "036-19-00",
    "owner1": "LIU, TRS, WILSON-NELSON-JASON",
    "owner2": "",
    "current_taxes": 27870.47,
    "new_taxes_no_override": 29074.47,
    "override_total_1": 29899.44,
    "override_increase_1": 824.97
  },
  {
    "#": "84 Browne St (035-31-00)",
    "$": 3144600,
    "address": "84 Browne St",
    "parcel_id": "035-31-00",
    "owner1": "LAPUCK TR, KENNETH M",
    "owner2": "",
    "current_taxes": 32200.7,
    "new_taxes_no_override": 33591.77,
    "override_total_1": 34544.91,
    "override_increase_1": 953.14
  },
  {
    "#": "85 Browne St (036-20-00)",
    "$": 2588300,
    "address": "85 Browne St",
    "parcel_id": "036-20-00",
    "owner1": "LEE, ET AL TRS, SHUE HONG",
    "owner2": "C/O LEE EDWARD",
    "current_taxes": 26504.19,
    "new_taxes_no_override": 27649.17,
    "override_total_1": 28433.7,
    "override_increase_1": 784.52
  },
  {
    "#": "86 Browne St (035-30-00)",
    "$": 2431000,
    "address": "86 Browne St",
    "parcel_id": "035-30-00",
    "owner1": "TOW, WAI Y & KAIN M",
    "owner2": "",
    "current_taxes": 24893.44,
    "new_taxes_no_override": 25968.84,
    "override_total_1": 26705.68,
    "override_increase_1": 736.85
  },
  {
    "#": "87 Browne St, Unit 1 (036-21-03)",
    "$": 913300,
    "address": "87 Browne St, Unit 1",
    "parcel_id": "036-21-03",
    "owner1": "DUNCANSON, WYNTER J",
    "owner2": "",
    "current_taxes": 9352.19,
    "new_taxes_no_override": 9756.2,
    "override_total_1": 10033.03,
    "override_increase_1": 276.82
  },
  {
    "#": "87 Browne St, Unit 2 (036-21-01)",
    "$": 991100,
    "address": "87 Browne St, Unit 2",
    "parcel_id": "036-21-01",
    "owner1": "BROWN, ALASTAIR",
    "owner2": "JOHNSON, ELIZABETH",
    "current_taxes": 6513.93,
    "new_taxes_no_override": 6795.33,
    "override_total_1": 6988.14,
    "override_increase_1": 192.81
  },
  {
    "#": "87 Browne St, Unit 3 (036-21-02)",
    "$": 971700,
    "address": "87 Browne St, Unit 3",
    "parcel_id": "036-21-02",
    "owner1": "LL PEGASI LLC",
    "owner2": "",
    "current_taxes": 9950.21,
    "new_taxes_no_override": 10380.06,
    "override_total_1": 10674.59,
    "override_increase_1": 294.53
  },
  {
    "#": "88 Browne St (035-29-00)",
    "$": 3464300,
    "address": "88 Browne St",
    "parcel_id": "035-29-00",
    "owner1": "SALEH TR, EVELYN A",
    "owner2": "BROWNE STREET REALTY TRUST",
    "current_taxes": 35474.43,
    "new_taxes_no_override": 37006.93,
    "override_total_1": 38056.97,
    "override_increase_1": 1050.04
  },
  {
    "#": "90 Browne St (035-28-00)",
    "$": 2888100,
    "address": "90 Browne St",
    "parcel_id": "035-28-00",
    "owner1": "REARDON TR, ANDREW J",
    "owner2": "",
    "current_taxes": 29574.14,
    "new_taxes_no_override": 30851.74,
    "override_total_1": 31727.14,
    "override_increase_1": 875.39
  },
  {
    "#": "92 Browne St (035-27-00)",
    "$": 2540100,
    "address": "92 Browne St",
    "parcel_id": "035-27-00",
    "owner1": "YONG TRS, KENNETH",
    "owner2": "LEW, LISA",
    "current_taxes": 26010.62,
    "new_taxes_no_override": 27134.28,
    "override_total_1": 27904.19,
    "override_increase_1": 769.91
  },
  {
    "#": "94 Browne St (035-26-00)",
    "$": 2112600,
    "address": "94 Browne St",
    "parcel_id": "035-26-00",
    "owner1": "ZHAO, YUTING",
    "owner2": "",
    "current_taxes": 21633.02,
    "new_taxes_no_override": 22567.57,
    "override_total_1": 23207.9,
    "override_increase_1": 640.34
  },
  {
    "#": "96 Browne St, Unit 1 (035-25-03)",
    "$": 865500,
    "address": "96 Browne St, Unit 1",
    "parcel_id": "035-25-03",
    "owner1": "WALLACH, TRACY",
    "owner2": "",
    "current_taxes": 5227.79,
    "new_taxes_no_override": 5453.63,
    "override_total_1": 5608.37,
    "override_increase_1": 154.74
  },
  {
    "#": "96 Browne St, Unit 2 (035-25-01)",
    "$": 847900,
    "address": "96 Browne St, Unit 2",
    "parcel_id": "035-25-01",
    "owner1": "WISH TR, KATIA",
    "owner2": "",
    "current_taxes": 5047.56,
    "new_taxes_no_override": 5265.61,
    "override_total_1": 5415.02,
    "override_increase_1": 149.41
  },
  {
    "#": "96 Browne St, Unit 3 (035-25-02)",
    "$": 837100,
    "address": "96 Browne St, Unit 3",
    "parcel_id": "035-25-02",
    "owner1": "TORCHALLA, ELIAS",
    "owner2": "SAILER, CLARA",
    "current_taxes": 4936.97,
    "new_taxes_no_override": 5150.25,
    "override_total_1": 5296.38,
    "override_increase_1": 146.13
  },
  {
    "#": "100 Browne St, Unit 1 (035-24-01)",
    "$": 1616200,
    "address": "100 Browne St, Unit 1",
    "parcel_id": "035-24-01",
    "owner1": "ETAIX, FRANCOIS & ELISABETH",
    "owner2": "",
    "current_taxes": 12914.95,
    "new_taxes_no_override": 13472.88,
    "override_total_1": 13855.16,
    "override_increase_1": 382.28
  },
  {
    "#": "100 Browne St, Unit 2 (035-24-02)",
    "$": 1671300,
    "address": "100 Browne St, Unit 2",
    "parcel_id": "035-24-02",
    "owner1": "LEE, MARGARET ELIZABETH",
    "owner2": "",
    "current_taxes": 17114.11,
    "new_taxes_no_override": 17853.44,
    "override_total_1": 18360.02,
    "override_increase_1": 506.58
  },
  {
    "#": "101 Browne St (036-22-00)",
    "$": 2095300,
    "address": "101 Browne St",
    "parcel_id": "036-22-00",
    "owner1": "GORMAN III, JAMES R",
    "owner2": "",
    "current_taxes": 21455.87,
    "new_taxes_no_override": 22382.76,
    "override_total_1": 23017.86,
    "override_increase_1": 635.09
  },
  {
    "#": "102 Browne St, Unit 1 (035-23-01)",
    "$": 861700,
    "address": "102 Browne St, Unit 1",
    "parcel_id": "035-23-01",
    "owner1": "SARIN, ANNIKA",
    "owner2": "DREYFUS, MARC",
    "current_taxes": 5188.87,
    "new_taxes_no_override": 5413.03,
    "override_total_1": 5566.62,
    "override_increase_1": 153.59
  },
  {
    "#": "102 Browne St, Unit 2 (035-23-02)",
    "$": 1066000,
    "address": "102 Browne St, Unit 2",
    "parcel_id": "035-23-02",
    "owner1": "GORE, PRASANNA R",
    "owner2": "",
    "current_taxes": 7280.91,
    "new_taxes_no_override": 7595.45,
    "override_total_1": 7810.96,
    "override_increase_1": 215.51
  },
  {
    "#": "103 Browne St, Unit 1 (036-23-01)",
    "$": 1116900,
    "address": "103 Browne St, Unit 1",
    "parcel_id": "036-23-01",
    "owner1": "POURATI, FLORA G TR",
    "owner2": "",
    "current_taxes": 11437.06,
    "new_taxes_no_override": 11931.14,
    "override_total_1": 12269.68,
    "override_increase_1": 338.54
  },
  {
    "#": "103 Browne St, Unit 2 (036-23-02)",
    "$": 723000,
    "address": "103 Browne St, Unit 2",
    "parcel_id": "036-23-02",
    "owner1": "POURATI TR, FLORA G",
    "owner2": "",
    "current_taxes": 7403.52,
    "new_taxes_no_override": 7723.35,
    "override_total_1": 7942.5,
    "override_increase_1": 219.14
  },
  {
    "#": "103 Browne St, Unit 3 (036-23-03)",
    "$": 751000,
    "address": "103 Browne St, Unit 3",
    "parcel_id": "036-23-03",
    "owner1": "POURATI, TR, FLORA G",
    "owner2": "",
    "current_taxes": 7690.24,
    "new_taxes_no_override": 8022.46,
    "override_total_1": 8250.09,
    "override_increase_1": 227.63
  },
  {
    "#": "105 Browne St, Unit 1 & Sp 1 (036-24-01)",
    "$": 929100,
    "address": "105 Browne St, Unit 1 & Sp 1",
    "parcel_id": "036-24-01",
    "owner1": "STONE, CHRISTOPHER & ELISE COUTURE",
    "owner2": "",
    "current_taxes": 5879.05,
    "new_taxes_no_override": 6133.02,
    "override_total_1": 6307.04,
    "override_increase_1": 174.02
  },
  {
    "#": "105 Browne St, Unit 2 & Sp 2 (036-24-02)",
    "$": 953800,
    "address": "105 Browne St, Unit 2 & Sp 2",
    "parcel_id": "036-24-02",
    "owner1": "BAILEN, ROBERT & NATASHA",
    "owner2": "",
    "current_taxes": 6131.98,
    "new_taxes_no_override": 6396.88,
    "override_total_1": 6578.39,
    "override_increase_1": 181.51
  },
  {
    "#": "105 Browne St, Unit 3 & P3 (036-24-03)",
    "$": 929000,
    "address": "105 Browne St, Unit 3 & P3",
    "parcel_id": "036-24-03",
    "owner1": "SOULARD, PATRICIA",
    "owner2": "",
    "current_taxes": 9512.96,
    "new_taxes_no_override": 9923.92,
    "override_total_1": 10205.5,
    "override_increase_1": 281.58
  },
  {
    "#": "106 Browne St, Unit 1 & P1 (035-22-01)",
    "$": 1119100,
    "address": "106 Browne St, Unit 1 & P1",
    "parcel_id": "035-22-01",
    "owner1": "HAYASHI, RIEKO",
    "owner2": "",
    "current_taxes": 7824.65,
    "new_taxes_no_override": 8162.67,
    "override_total_1": 8394.28,
    "override_increase_1": 231.61
  },
  {
    "#": "106 Browne St, Unit 2 & P2 (035-22-02)",
    "$": 940300,
    "address": "106 Browne St, Unit 2 & P2",
    "parcel_id": "035-22-02",
    "owner1": "ROTOW TR, KATHLEEN MARIE",
    "owner2": "",
    "current_taxes": 5993.74,
    "new_taxes_no_override": 6252.67,
    "override_total_1": 6430.08,
    "override_increase_1": 177.41
  },
  {
    "#": "106 Browne St, Unit 3 & P3 (035-22-03)",
    "$": 981400,
    "address": "106 Browne St, Unit 3 & P3",
    "parcel_id": "035-22-03",
    "owner1": "GOLDSMITH TR, TESSA ANN",
    "owner2": "",
    "current_taxes": 6414.6,
    "new_taxes_no_override": 6691.71,
    "override_total_1": 6881.58,
    "override_increase_1": 189.87
  },
  {
    "#": "107 Browne St, Unit 1 (036-25-03)",
    "$": 934700,
    "address": "107 Browne St, Unit 1",
    "parcel_id": "036-25-03",
    "owner1": "MULLER, CORINNE",
    "owner2": "",
    "current_taxes": 9571.33,
    "new_taxes_no_override": 9984.81,
    "override_total_1": 10268.12,
    "override_increase_1": 283.31
  },
  {
    "#": "107 Browne St, Unit 2 & P3 P4 (036-25-01)",
    "$": 984000,
    "address": "107 Browne St, Unit 2 & P3 P4",
    "parcel_id": "036-25-01",
    "owner1": "DOYLE, LEONA",
    "owner2": "MARINO-ENRIQUEZ, ADRIAN",
    "current_taxes": 10076.16,
    "new_taxes_no_override": 10511.45,
    "override_total_1": 10809.7,
    "override_increase_1": 298.25
  },
  {
    "#": "107 Browne St, Unit 3 (036-25-02)",
    "$": 986500,
    "address": "107 Browne St, Unit 3",
    "parcel_id": "036-25-02",
    "owner1": "NIELSEN, BRAD & LIORA",
    "owner2": "",
    "current_taxes": 6466.83,
    "new_taxes_no_override": 6746.2,
    "override_total_1": 6937.62,
    "override_increase_1": 191.42
  },
  {
    "#": "110 Browne St, Unit 1 (035-21-03)",
    "$": 830300,
    "address": "110 Browne St, Unit 1",
    "parcel_id": "035-21-03",
    "owner1": "BERK, LEWIS W",
    "owner2": "HALPERIN, LUCILA",
    "current_taxes": 4867.34,
    "new_taxes_no_override": 5077.61,
    "override_total_1": 5221.68,
    "override_increase_1": 144.07
  },
  {
    "#": "110 Browne St, Unit 2 & P2 (035-21-01)",
    "$": 776500,
    "address": "110 Browne St, Unit 2 & P2",
    "parcel_id": "035-21-01",
    "owner1": "RAJADHYAKSHA, MILIND M & ANJALI M",
    "owner2": "",
    "current_taxes": 7951.36,
    "new_taxes_no_override": 8294.86,
    "override_total_1": 8530.22,
    "override_increase_1": 235.36
  },
  {
    "#": "110 Browne St, Unit 3 (035-21-02)",
    "$": 881700,
    "address": "110 Browne St, Unit 3",
    "parcel_id": "035-21-02",
    "owner1": "RACER, CATHERINE",
    "owner2": "",
    "current_taxes": 5393.67,
    "new_taxes_no_override": 5626.68,
    "override_total_1": 5786.33,
    "override_increase_1": 159.65
  },
  {
    "#": "111 Browne St, Unit 1 G-1 (036-26-01)",
    "$": 952800,
    "address": "111 Browne St, Unit 1 G-1",
    "parcel_id": "036-26-01",
    "owner1": "KOCHI TR, SIMS K",
    "owner2": "",
    "current_taxes": 9756.67,
    "new_taxes_no_override": 10178.16,
    "override_total_1": 10466.96,
    "override_increase_1": 288.8
  },
  {
    "#": "111 Browne St, Unit 2 & P-2 (036-26-02)",
    "$": 945400,
    "address": "111 Browne St, Unit 2 & P-2",
    "parcel_id": "036-26-02",
    "owner1": "KOCHI TR, CHRISTINE M C",
    "owner2": "",
    "current_taxes": 6045.96,
    "new_taxes_no_override": 6307.15,
    "override_total_1": 6486.11,
    "override_increase_1": 178.96
  },
  {
    "#": "111 Browne St, Unit 3 (036-26-03)",
    "$": 954200,
    "address": "111 Browne St, Unit 3",
    "parcel_id": "036-26-03",
    "owner1": "GOON LIFE ESTATE, SERENA",
    "owner2": "",
    "current_taxes": 6136.07,
    "new_taxes_no_override": 6401.15,
    "override_total_1": 6582.78,
    "override_increase_1": 181.63
  },
  {
    "#": "112 Browne St, Unit 1 & P-B (035-20-01)",
    "$": 874400,
    "address": "112 Browne St, Unit 1 & P-B",
    "parcel_id": "035-20-01",
    "owner1": "DENTON, JENNIFER E & JAMES Q",
    "owner2": "",
    "current_taxes": 5318.92,
    "new_taxes_no_override": 5548.7,
    "override_total_1": 5706.14,
    "override_increase_1": 157.44
  },
  {
    "#": "112 Browne St, Unit 2 & P-A (035-20-02)",
    "$": 851100,
    "address": "112 Browne St, Unit 2 & P-A",
    "parcel_id": "035-20-02",
    "owner1": "DENTON, JENNIFER E",
    "owner2": "",
    "current_taxes": 5080.33,
    "new_taxes_no_override": 5299.8,
    "override_total_1": 5450.18,
    "override_increase_1": 150.38
  },
  {
    "#": "112 Browne St, Unit 3 & P-C (035-20-03)",
    "$": 865900,
    "address": "112 Browne St, Unit 3 & P-C",
    "parcel_id": "035-20-03",
    "owner1": "HICKOX, MARC",
    "owner2": "",
    "current_taxes": 5231.88,
    "new_taxes_no_override": 5457.9,
    "override_total_1": 5612.76,
    "override_increase_1": 154.86
  },
  {
    "#": "115 Browne St (036-27-00)",
    "$": 2427900,
    "address": "115 Browne St",
    "parcel_id": "036-27-00",
    "owner1": "POURATI TR, FLORA",
    "owner2": "",
    "current_taxes": 24861.7,
    "new_taxes_no_override": 25935.73,
    "override_total_1": 26671.63,
    "override_increase_1": 735.91
  },
  {
    "#": "116 Browne St (035-19-00)",
    "$": 2495800,
    "address": "116 Browne St",
    "parcel_id": "035-19-00",
    "owner1": "STILLMAN, EZRA",
    "owner2": "",
    "current_taxes": 25556.99,
    "new_taxes_no_override": 26661.05,
    "override_total_1": 27417.54,
    "override_increase_1": 756.49
  },
  {
    "#": "119 Browne St (036-28-00)",
    "$": 2060200,
    "address": "119 Browne St",
    "parcel_id": "036-28-00",
    "owner1": "SUN, QIUNING",
    "owner2": "",
    "current_taxes": 21096.45,
    "new_taxes_no_override": 22007.82,
    "override_total_1": 22632.27,
    "override_increase_1": 624.45
  },
  {
    "#": "120 Browne St (035-18-00)",
    "$": 4898300,
    "address": "120 Browne St",
    "parcel_id": "035-18-00",
    "owner1": "120 BROWNE ST LLC",
    "owner2": "C/O STILLMAN EZRA MGR",
    "current_taxes": 50158.59,
    "new_taxes_no_override": 52325.44,
    "override_total_1": 53810.14,
    "override_increase_1": 1484.69
  },
  {
    "#": "121 Browne St (036-29-00)",
    "$": 2388600,
    "address": "121 Browne St",
    "parcel_id": "036-29-00",
    "owner1": "XU, YUNKANG",
    "owner2": "WANG, YUN",
    "current_taxes": 24459.26,
    "new_taxes_no_override": 25515.9,
    "override_total_1": 26239.89,
    "override_increase_1": 723.99
  },
  {
    "#": "124 Browne St (035-17-00)",
    "$": 1909800,
    "address": "124 Browne St",
    "parcel_id": "035-17-00",
    "owner1": "BEL INVESTMENT LLC",
    "owner2": "",
    "current_taxes": 19556.35,
    "new_taxes_no_override": 20401.18,
    "override_total_1": 20980.05,
    "override_increase_1": 578.87
  },
  {
    "#": "125 Browne St, Unit 1 (036-30-01)",
    "$": 871500,
    "address": "125 Browne St, Unit 1",
    "parcel_id": "036-30-01",
    "owner1": "WINSTON, JAMES L",
    "owner2": "",
    "current_taxes": 5289.23,
    "new_taxes_no_override": 5517.72,
    "override_total_1": 5674.29,
    "override_increase_1": 156.56
  },
  {
    "#": "125 Browne St, Unit 2 (036-30-02)",
    "$": 900500,
    "address": "125 Browne St, Unit 2",
    "parcel_id": "036-30-02",
    "owner1": "ROBINS, BONNIE",
    "owner2": "",
    "current_taxes": 9221.12,
    "new_taxes_no_override": 9619.47,
    "override_total_1": 9892.42,
    "override_increase_1": 272.95
  },
  {
    "#": "125 Browne St, Unit 3 (036-30-03)",
    "$": 857500,
    "address": "125 Browne St, Unit 3",
    "parcel_id": "036-30-03",
    "owner1": "NAUMOV TRS, GEORGE",
    "owner2": "PIRALKOVA, YANA",
    "current_taxes": 8780.8,
    "new_taxes_no_override": 9160.13,
    "override_total_1": 9420.04,
    "override_increase_1": 259.91
  },
  {
    "#": "126 Browne St, Unit 1 (035-16-03)",
    "$": 564300,
    "address": "126 Browne St, Unit 1",
    "parcel_id": "035-16-03",
    "owner1": "SMITH, EILEEN",
    "owner2": "",
    "current_taxes": 5778.43,
    "new_taxes_no_override": 6028.06,
    "override_total_1": 6199.1,
    "override_increase_1": 171.04
  },
  {
    "#": "126 Browne St, Unit 2 & Pk Sp (035-16-01)",
    "$": 611600,
    "address": "126 Browne St, Unit 2 & Pk Sp",
    "parcel_id": "035-16-01",
    "owner1": "TIAN, YE",
    "owner2": "",
    "current_taxes": 6262.78,
    "new_taxes_no_override": 6533.33,
    "override_total_1": 6718.71,
    "override_increase_1": 185.38
  },
  {
    "#": "126 Browne St, Unit 3 (035-16-02)",
    "$": 670000,
    "address": "126 Browne St, Unit 3",
    "parcel_id": "035-16-02",
    "owner1": "OWEN, JOHN B & CHRISTINE L",
    "owner2": "",
    "current_taxes": 3225.87,
    "new_taxes_no_override": 3365.23,
    "override_total_1": 3460.71,
    "override_increase_1": 95.49
  },
  {
    "#": "127 Browne St, Unit 1 G-E& P-A (036-31-03)",
    "$": 868500,
    "address": "127 Browne St, Unit 1 G-E& P-A",
    "parcel_id": "036-31-03",
    "owner1": "XU, SANDY NI",
    "owner2": "SAARELA, HANS MARTEN SODERBLOM",
    "current_taxes": 5258.51,
    "new_taxes_no_override": 5485.68,
    "override_total_1": 5641.33,
    "override_increase_1": 155.65
  },
  {
    "#": "127 Browne St, Unit 2 & P-B (036-31-01)",
    "$": 774300,
    "address": "127 Browne St, Unit 2 & P-B",
    "parcel_id": "036-31-01",
    "owner1": "JANKOVIC, DEJAN & DRAGANA BOLCIC",
    "owner2": "",
    "current_taxes": 4293.9,
    "new_taxes_no_override": 4479.4,
    "override_total_1": 4606.5,
    "override_increase_1": 127.1
  },
  {
    "#": "127 Browne St, Unit 3  G-D  Pc (036-31-02)",
    "$": 879800,
    "address": "127 Browne St, Unit 3  G-D  Pc",
    "parcel_id": "036-31-02",
    "owner1": "BERGERON, RAYMOND J",
    "owner2": "",
    "current_taxes": 5374.22,
    "new_taxes_no_override": 5606.39,
    "override_total_1": 5765.46,
    "override_increase_1": 159.08
  },
  {
    "#": "15 Buckminster Rd (192-17-00)",
    "$": 4503600,
    "address": "15 Buckminster Rd",
    "parcel_id": "192-17-00",
    "owner1": "ALIZADEH, BABAK & ELIZABETH",
    "owner2": "",
    "current_taxes": 42481.93,
    "new_taxes_no_override": 44317.15,
    "override_total_1": 45574.61,
    "override_increase_1": 1257.47
  },
  {
    "#": "20 Buckminster Rd, Unit 1 (253-03-03)",
    "$": 1730200,
    "address": "20 Buckminster Rd, Unit 1",
    "parcel_id": "253-03-03",
    "owner1": "NAGLE, STEVE & LAURIE",
    "owner2": "",
    "current_taxes": 14082.31,
    "new_taxes_no_override": 14690.67,
    "override_total_1": 15107.5,
    "override_increase_1": 416.84
  },
  {
    "#": "20 Buckminster Rd, Unit 2 (253-03-01)",
    "$": 1626200,
    "address": "20 Buckminster Rd, Unit 2",
    "parcel_id": "253-03-01",
    "owner1": "PERLMUTTER TRS, MARTIN J",
    "owner2": "GREGSON TRS, ANNETTE",
    "current_taxes": 13017.35,
    "new_taxes_no_override": 13579.7,
    "override_total_1": 13965.01,
    "override_increase_1": 385.31
  },
  {
    "#": "20 Buckminster Rd, Unit 3 (253-03-02)",
    "$": 508800,
    "address": "20 Buckminster Rd, Unit 3",
    "parcel_id": "253-03-02",
    "owner1": "MCGRATH TR, CHERYL E",
    "owner2": "",
    "current_taxes": 5210.11,
    "new_taxes_no_override": 5435.19,
    "override_total_1": 5589.41,
    "override_increase_1": 154.22
  },
  {
    "#": "28 Buckminster Rd (253-02-01)",
    "$": 2475700,
    "address": "28 Buckminster Rd",
    "parcel_id": "253-02-01",
    "owner1": "SKOFF, HILLEL D & ROBERTA S",
    "owner2": "",
    "current_taxes": 21716.23,
    "new_taxes_no_override": 22654.37,
    "override_total_1": 23297.17,
    "override_increase_1": 642.8
  },
  {
    "#": "39 Buckminster Rd (231-39-00)",
    "$": 4399100,
    "address": "39 Buckminster Rd",
    "parcel_id": "231-39-00",
    "owner1": "CHOI ET AL, DERRICK",
    "owner2": "TSENG, ALICE Y",
    "current_taxes": 41411.85,
    "new_taxes_no_override": 43200.84,
    "override_total_1": 44426.63,
    "override_increase_1": 1225.79
  },
  {
    "#": "42 Buckminster Rd (252-10-00)",
    "$": 2247400,
    "address": "42 Buckminster Rd",
    "parcel_id": "252-10-00",
    "owner1": "SILOBRCIC, JOSKO",
    "owner2": "SIMIC, PETRA",
    "current_taxes": 23013.38,
    "new_taxes_no_override": 24007.56,
    "override_total_1": 24688.75,
    "override_increase_1": 681.2
  },
  {
    "#": "49 Buckminster Rd (231-35-02)",
    "$": 3175200,
    "address": "49 Buckminster Rd",
    "parcel_id": "231-35-02",
    "owner1": "SHAKESPEARE TRS, MATTHEW M",
    "owner2": "BACKUS, FREDERICK W",
    "current_taxes": 28879.11,
    "new_taxes_no_override": 30126.69,
    "override_total_1": 30981.51,
    "override_increase_1": 854.82
  },
  {
    "#": "54 Buckminster Rd (252-09-01)",
    "$": 3254700,
    "address": "54 Buckminster Rd",
    "parcel_id": "252-09-01",
    "owner1": "BEN-AKIVA, TR, MOSHE E",
    "owner2": "",
    "current_taxes": 29693.19,
    "new_taxes_no_override": 30975.94,
    "override_total_1": 31854.85,
    "override_increase_1": 878.92
  },
  {
    "#": "62 Buckminster Rd (252-09-00)",
    "$": 8744300,
    "address": "62 Buckminster Rd",
    "parcel_id": "252-09-00",
    "owner1": "ARCARI TR, GIUSEPPE A",
    "owner2": "",
    "current_taxes": 89541.63,
    "new_taxes_no_override": 93409.83,
    "override_total_1": 96060.26,
    "override_increase_1": 2650.43
  },
  {
    "#": "63 Buckminster Rd (231-40-00)",
    "$": 5335300,
    "address": "63 Buckminster Rd",
    "parcel_id": "231-40-00",
    "owner1": "GREER, EDWARD",
    "owner2": "LEIBERMAN, JUDITH",
    "current_taxes": 50998.54,
    "new_taxes_no_override": 53201.68,
    "override_total_1": 54711.23,
    "override_increase_1": 1509.56
  },
  {
    "#": "67 Buckminster Rd (231-41-00)",
    "$": 3226900,
    "address": "67 Buckminster Rd",
    "parcel_id": "231-41-00",
    "owner1": "KOLLURI, SURYA P & MINI R",
    "owner2": "",
    "current_taxes": 29408.52,
    "new_taxes_no_override": 30678.97,
    "override_total_1": 31549.46,
    "override_increase_1": 870.49
  },
  {
    "#": "70 Buckminster Rd (252-08-02)",
    "$": 3501900,
    "address": "70 Buckminster Rd",
    "parcel_id": "252-08-02",
    "owner1": "WEINGRAM, SETH E",
    "owner2": "CAIN, VICTORIA E M",
    "current_taxes": 35859.46,
    "new_taxes_no_override": 37408.59,
    "override_total_1": 38470.03,
    "override_increase_1": 1061.44
  },
  {
    "#": "76 Buckminster Rd (252-08-01)",
    "$": 2905000,
    "address": "76 Buckminster Rd",
    "parcel_id": "252-08-01",
    "owner1": "EISENBERG, DAVID & LAURA",
    "owner2": "",
    "current_taxes": 26112.27,
    "new_taxes_no_override": 27240.32,
    "override_total_1": 28013.24,
    "override_increase_1": 772.92
  },
  {
    "#": "79 Buckminster Rd (231-42-00)",
    "$": 4435900,
    "address": "79 Buckminster Rd",
    "parcel_id": "231-42-00",
    "owner1": "FREY, DAVID M",
    "owner2": "CHENG, HAO",
    "current_taxes": 41788.68,
    "new_taxes_no_override": 43593.95,
    "override_total_1": 44830.9,
    "override_increase_1": 1236.94
  },
  {
    "#": "82 Buckminster Rd (252-08-00)",
    "$": 3170000,
    "address": "82 Buckminster Rd",
    "parcel_id": "252-08-00",
    "owner1": "SADUN, RAFAELLA",
    "owner2": "DANCONA, VITO LEVI",
    "current_taxes": 28825.87,
    "new_taxes_no_override": 30071.15,
    "override_total_1": 30924.39,
    "override_increase_1": 853.25
  },
  {
    "#": "90 Buckminster Rd (252-07-00)",
    "$": 2392700,
    "address": "90 Buckminster Rd",
    "parcel_id": "252-07-00",
    "owner1": "CELMASTER, WILLIAM",
    "owner2": "GREENBERG, ROBYN",
    "current_taxes": 20866.31,
    "new_taxes_no_override": 21767.73,
    "override_total_1": 22385.38,
    "override_increase_1": 617.64
  },
  {
    "#": "95 Buckminster Rd (247-16-00)",
    "$": 2393900,
    "address": "95 Buckminster Rd",
    "parcel_id": "247-16-00",
    "owner1": "RATH TRS, HENRY C",
    "owner2": "SUTTON, GLORIA H",
    "current_taxes": 20878.6,
    "new_taxes_no_override": 21780.56,
    "override_total_1": 22398.56,
    "override_increase_1": 618.01
  },
  {
    "#": "104 Buckminster Rd (252-02-28)",
    "$": 1711700,
    "address": "104 Buckminster Rd",
    "parcel_id": "252-02-28",
    "owner1": "SHARP TRS, HELEN L",
    "owner2": "C/O THE BOSTON FAMILY OFFICE",
    "current_taxes": 17527.81,
    "new_taxes_no_override": 18285.01,
    "override_total_1": 18803.83,
    "override_increase_1": 518.82
  },
  {
    "#": "115 Buckminster Rd (247-18-00)",
    "$": 5465800,
    "address": "115 Buckminster Rd",
    "parcel_id": "247-18-00",
    "owner1": "LESCHLY, STIG",
    "owner2": "",
    "current_taxes": 52334.86,
    "new_taxes_no_override": 54595.73,
    "override_total_1": 56144.84,
    "override_increase_1": 1549.11
  },
  {
    "#": "123 Buckminster Rd (247-19-00)",
    "$": 4013700,
    "address": "123 Buckminster Rd",
    "parcel_id": "247-19-00",
    "owner1": "SALOMON, SHLOMO & GULMIRA ASISOVA",
    "owner2": "",
    "current_taxes": 37465.35,
    "new_taxes_no_override": 39083.85,
    "override_total_1": 40192.83,
    "override_increase_1": 1108.97
  },
  {
    "#": "130 Buckminster Rd (252-06-00)",
    "$": 3045400,
    "address": "130 Buckminster Rd",
    "parcel_id": "252-06-00",
    "owner1": "RICH, BENJAMIN E",
    "owner2": "GYPSON, BRENDA C",
    "current_taxes": 27549.96,
    "new_taxes_no_override": 28740.12,
    "override_total_1": 29555.6,
    "override_increase_1": 815.48
  },
  {
    "#": "133 Buckminster Rd (247-20-00)",
    "$": 2978700,
    "address": "133 Buckminster Rd",
    "parcel_id": "247-20-00",
    "owner1": "SHAPIRO, BRAM & JENNIFER D",
    "owner2": "",
    "current_taxes": 26866.95,
    "new_taxes_no_override": 28027.6,
    "override_total_1": 28822.86,
    "override_increase_1": 795.26
  },
  {
    "#": "141 Buckminster Rd (247-21-00)",
    "$": 4725100,
    "address": "141 Buckminster Rd",
    "parcel_id": "247-21-00",
    "owner1": "ROMANOW, DANIEL L",
    "owner2": "ZELERMYER, B A",
    "current_taxes": 44750.09,
    "new_taxes_no_override": 46683.29,
    "override_total_1": 48007.9,
    "override_increase_1": 1324.6
  },
  {
    "#": "149 Buckminster Rd (247-22-00)",
    "$": 4341700,
    "address": "149 Buckminster Rd",
    "parcel_id": "247-22-00",
    "owner1": "FISCH, TR, ALAN",
    "owner2": "",
    "current_taxes": 40824.07,
    "new_taxes_no_override": 42587.67,
    "override_total_1": 43796.06,
    "override_increase_1": 1208.39
  },
  {
    "#": "150 Buckminster Rd (251-07-00)",
    "$": 2933900,
    "address": "150 Buckminster Rd",
    "parcel_id": "251-07-00",
    "owner1": "ROUBENOFF TR, RONENN",
    "owner2": "",
    "current_taxes": 26408.2,
    "new_taxes_no_override": 27549.03,
    "override_total_1": 28330.72,
    "override_increase_1": 781.68
  },
  {
    "#": "161 Buckminster Rd (247-23-00)",
    "$": 3618600,
    "address": "161 Buckminster Rd",
    "parcel_id": "247-23-00",
    "owner1": "BILLOW, GERALD J",
    "owner2": "KELLMAN, BARBARA S",
    "current_taxes": 33419.53,
    "new_taxes_no_override": 34863.25,
    "override_total_1": 35852.47,
    "override_increase_1": 989.22
  },
  {
    "#": "169 Buckminster Rd (247-24-00)",
    "$": 3505500,
    "address": "169 Buckminster Rd",
    "parcel_id": "247-24-00",
    "owner1": "CHOW, JOSEPH & SELINA J",
    "owner2": "",
    "current_taxes": 32261.39,
    "new_taxes_no_override": 33655.08,
    "override_total_1": 34610.02,
    "override_increase_1": 954.94
  },
  {
    "#": "172 Buckminster Rd (248-09-00)",
    "$": 3540100,
    "address": "172 Buckminster Rd",
    "parcel_id": "248-09-00",
    "owner1": "YANG, YONG",
    "owner2": "ZHENG, MINCHEN",
    "current_taxes": 32615.69,
    "new_taxes_no_override": 34024.69,
    "override_total_1": 34990.11,
    "override_increase_1": 965.42
  },
  {
    "#": "177 Buckminster Rd (247-25-00)",
    "$": 4672600,
    "address": "177 Buckminster Rd",
    "parcel_id": "247-25-00",
    "owner1": "KING TR, CECILIA PHILION",
    "owner2": "",
    "current_taxes": 44212.49,
    "new_taxes_no_override": 46122.47,
    "override_total_1": 47431.16,
    "override_increase_1": 1308.69
  },
  {
    "#": "182 Buckminster Rd (248-08-00)",
    "$": 5013200,
    "address": "182 Buckminster Rd",
    "parcel_id": "248-08-00",
    "owner1": "DILLON, JAMES J",
    "owner2": "WISKE, MARTHA STONE",
    "current_taxes": 47700.23,
    "new_taxes_no_override": 49760.88,
    "override_total_1": 51172.81,
    "override_increase_1": 1411.93
  },
  {
    "#": "185 Buckminster Rd (247-26-00)",
    "$": 5713300,
    "address": "185 Buckminster Rd",
    "parcel_id": "247-26-00",
    "owner1": "CHUANG, JOHN & LYNNE",
    "owner2": "C/O AQUENT",
    "current_taxes": 54869.26,
    "new_taxes_no_override": 57239.61,
    "override_total_1": 58863.74,
    "override_increase_1": 1624.13
  },
  {
    "#": "191 Buckminster Rd (247-27-00)",
    "$": 3816400,
    "address": "191 Buckminster Rd",
    "parcel_id": "247-27-00",
    "owner1": "RABINER, PAVEL & JENNIFER",
    "owner2": "",
    "current_taxes": 35445.0,
    "new_taxes_no_override": 36976.22,
    "override_total_1": 38025.4,
    "override_increase_1": 1049.17
  },
  {
    "#": "194 Buckminster Rd (248-07-00)",
    "$": 3669000,
    "address": "194 Buckminster Rd",
    "parcel_id": "248-07-00",
    "owner1": "HOLLEY, MICHAEL & ONI",
    "owner2": "",
    "current_taxes": 33935.63,
    "new_taxes_no_override": 35401.65,
    "override_total_1": 36406.14,
    "override_increase_1": 1004.49
  },
  {
    "#": "201 Buckminster Rd (247-28-00)",
    "$": 4063500,
    "address": "201 Buckminster Rd",
    "parcel_id": "247-28-00",
    "owner1": "MYERS TRS, BETH ELLEN",
    "owner2": "FLAHERTY, PETER G",
    "current_taxes": 37975.31,
    "new_taxes_no_override": 39615.84,
    "override_total_1": 40739.91,
    "override_increase_1": 1124.07
  },
  {
    "#": "206 Buckminster Rd (248-06-00)",
    "$": 4841700,
    "address": "206 Buckminster Rd",
    "parcel_id": "248-06-00",
    "owner1": "LAINE, CHRISTOPHER N",
    "owner2": "HALFIN, MARCIA A",
    "current_taxes": 45944.07,
    "new_taxes_no_override": 47928.85,
    "override_total_1": 49288.8,
    "override_increase_1": 1359.94
  },
  {
    "#": "209 Buckminster Rd (247-29-00)",
    "$": 3886200,
    "address": "209 Buckminster Rd",
    "parcel_id": "247-29-00",
    "owner1": "KIRSHNER TRS, DAVID A",
    "owner2": "FRAUENTHAL, BETSY J",
    "current_taxes": 36159.75,
    "new_taxes_no_override": 37721.85,
    "override_total_1": 38792.18,
    "override_increase_1": 1070.33
  },
  {
    "#": "214 Buckminster Rd (248-05-00)",
    "$": 2961700,
    "address": "214 Buckminster Rd",
    "parcel_id": "248-05-00",
    "owner1": "GELFAND-ABRAMS, LISA",
    "owner2": "ABRAMS, ALAN",
    "current_taxes": 26692.87,
    "new_taxes_no_override": 27846.0,
    "override_total_1": 28636.11,
    "override_increase_1": 790.11
  },
  {
    "#": "219 Buckminster Rd (247-30-00)",
    "$": 3107600,
    "address": "219 Buckminster Rd",
    "parcel_id": "247-30-00",
    "owner1": "SALVIN TRS, ROBERT L & SPRING R",
    "owner2": "",
    "current_taxes": 31821.82,
    "new_taxes_no_override": 33196.52,
    "override_total_1": 34138.45,
    "override_increase_1": 941.93
  },
  {
    "#": "220 Buckminster Rd (248-04-00)",
    "$": 4147100,
    "address": "220 Buckminster Rd",
    "parcel_id": "248-04-00",
    "owner1": "GRAND TR, MYRA M",
    "owner2": "",
    "current_taxes": 38831.37,
    "new_taxes_no_override": 40508.89,
    "override_total_1": 41658.29,
    "override_increase_1": 1149.41
  },
  {
    "#": "230 Buckminster Rd (248-03-00)",
    "$": 3828100,
    "address": "230 Buckminster Rd",
    "parcel_id": "248-03-00",
    "owner1": "ENOS, JEFFREY D & MIRIAM",
    "owner2": "",
    "current_taxes": 35564.81,
    "new_taxes_no_override": 37101.21,
    "override_total_1": 38153.93,
    "override_increase_1": 1052.72
  },
  {
    "#": "233 Buckminster Rd (246-03-00)",
    "$": 3824600,
    "address": "233 Buckminster Rd",
    "parcel_id": "246-03-00",
    "owner1": "MICHAEL TRS ET AL, MICHAEL L & CAROL B",
    "owner2": "C/O DAY PITNEY LLP, LEIHA MACAULEY ESQ",
    "current_taxes": 35528.97,
    "new_taxes_no_override": 37063.82,
    "override_total_1": 38115.48,
    "override_increase_1": 1051.66
  },
  {
    "#": "236 Buckminster Rd (248-02-00)",
    "$": 3324400,
    "address": "236 Buckminster Rd",
    "parcel_id": "248-02-00",
    "owner1": "LEE, LINDA",
    "owner2": "",
    "current_taxes": 30406.92,
    "new_taxes_no_override": 31720.5,
    "override_total_1": 32620.54,
    "override_increase_1": 900.04
  },
  {
    "#": "241 Buckminster Rd (246-04-00)",
    "$": 3563600,
    "address": "241 Buckminster Rd",
    "parcel_id": "246-04-00",
    "owner1": "BRAININ TRS, ROBERT L",
    "owner2": "KEAN, NICOLA J",
    "current_taxes": 32856.33,
    "new_taxes_no_override": 34275.72,
    "override_total_1": 35248.27,
    "override_increase_1": 972.55
  },
  {
    "#": "248 Buckminster Rd (248-01-00)",
    "$": 6313500,
    "address": "248 Buckminster Rd",
    "parcel_id": "248-01-00",
    "owner1": "KENNEDY, CRAIG GAYEN",
    "owner2": "BLINOVA, ANNA",
    "current_taxes": 64650.24,
    "new_taxes_no_override": 67443.13,
    "override_total_1": 69356.78,
    "override_increase_1": 1913.65
  },
  {
    "#": "249 Buckminster Rd (246-05-00)",
    "$": 3391000,
    "address": "249 Buckminster Rd",
    "parcel_id": "246-05-00",
    "owner1": "POWELL, MICHAEL & DEVON",
    "owner2": "",
    "current_taxes": 31088.91,
    "new_taxes_no_override": 32431.95,
    "override_total_1": 33352.18,
    "override_increase_1": 920.23
  },
  {
    "#": "270 Buckminster Rd (244-04-01)",
    "$": 3449700,
    "address": "270 Buckminster Rd",
    "parcel_id": "244-04-01",
    "owner1": "MCLEOD TRS, TRACEY",
    "owner2": "MORRIS, KWAME",
    "current_taxes": 31689.99,
    "new_taxes_no_override": 33059.0,
    "override_total_1": 33997.02,
    "override_increase_1": 938.02
  },
  {
    "#": "282 Buckminster Rd (244-04-00)",
    "$": 4274900,
    "address": "282 Buckminster Rd",
    "parcel_id": "244-04-00",
    "owner1": "GOLDSTEIN, JEROME & MARLENE K",
    "owner2": "",
    "current_taxes": 40140.04,
    "new_taxes_no_override": 41874.09,
    "override_total_1": 43062.23,
    "override_increase_1": 1188.15
  },
  {
    "#": "283 Buckminster Rd (243-08-00)",
    "$": 3488700,
    "address": "283 Buckminster Rd",
    "parcel_id": "243-08-00",
    "owner1": "FRANKEL TR, INNA",
    "owner2": "",
    "current_taxes": 35724.29,
    "new_taxes_no_override": 37267.58,
    "override_total_1": 38325.02,
    "override_increase_1": 1057.44
  },
  {
    "#": "291 Buckminster Rd (243-09-00)",
    "$": 4609200,
    "address": "291 Buckminster Rd",
    "parcel_id": "243-09-00",
    "owner1": "YAN, BINGCHEN",
    "owner2": "PAN, YUE",
    "current_taxes": 43563.27,
    "new_taxes_no_override": 45445.2,
    "override_total_1": 46734.68,
    "override_increase_1": 1289.47
  },
  {
    "#": "294 Buckminster Rd (244-03-00)",
    "$": 6939800,
    "address": "294 Buckminster Rd",
    "parcel_id": "244-03-00",
    "owner1": "MEGAN TR, DAVID",
    "owner2": "C/O JESSICA SCHMITZ",
    "current_taxes": 71063.55,
    "new_taxes_no_override": 74133.5,
    "override_total_1": 76236.98,
    "override_increase_1": 2103.48
  },
  {
    "#": "297 Buckminster Rd (243-10-00)",
    "$": 3893200,
    "address": "297 Buckminster Rd",
    "parcel_id": "243-10-00",
    "owner1": "FRIEDBERG TR, JAYNE BENNETT",
    "owner2": "",
    "current_taxes": 36231.43,
    "new_taxes_no_override": 37796.63,
    "override_total_1": 38869.08,
    "override_increase_1": 1072.45
  },
  {
    "#": "305 Buckminster Rd (243-11-00)",
    "$": 3071800,
    "address": "305 Buckminster Rd",
    "parcel_id": "243-11-00",
    "owner1": "MIZRAHI, DONNA ACKERMANN & ILAN",
    "owner2": "",
    "current_taxes": 27820.3,
    "new_taxes_no_override": 29022.14,
    "override_total_1": 29845.62,
    "override_increase_1": 823.48
  },
  {
    "#": "306 Buckminster Rd (244-02-00)",
    "$": 4122400,
    "address": "306 Buckminster Rd",
    "parcel_id": "244-02-00",
    "owner1": "JACOBSON, DANIEL R",
    "owner2": "ABUHOFF, NANETTE",
    "current_taxes": 38578.44,
    "new_taxes_no_override": 40245.03,
    "override_total_1": 41386.95,
    "override_increase_1": 1141.92
  },
  {
    "#": "309 Buckminster Rd (243-12-00)",
    "$": 2453500,
    "address": "309 Buckminster Rd",
    "parcel_id": "243-12-00",
    "owner1": "MITTEL TR, SHAARI C",
    "owner2": "",
    "current_taxes": 21488.91,
    "new_taxes_no_override": 22417.23,
    "override_total_1": 23053.3,
    "override_increase_1": 636.07
  },
  {
    "#": "315 Buckminster Rd (243-13-00)",
    "$": 3650200,
    "address": "315 Buckminster Rd",
    "parcel_id": "243-13-00",
    "owner1": "ZHANG TR, YUNYI",
    "owner2": "",
    "current_taxes": 37378.05,
    "new_taxes_no_override": 38992.78,
    "override_total_1": 40099.17,
    "override_increase_1": 1106.39
  },
  {
    "#": "337 Buckminster Rd (258-01-00)",
    "$": 5780100,
    "address": "337 Buckminster Rd",
    "parcel_id": "258-01-00",
    "owner1": "BROWN, CHRISTOPHER THOMAS",
    "owner2": "WIEDERSCHAIN, DMITRI G",
    "current_taxes": 55553.29,
    "new_taxes_no_override": 57953.19,
    "override_total_1": 59597.57,
    "override_increase_1": 1644.38
  },
  {
    "#": "345 Buckminster Rd (258-02-00)",
    "$": 6113900,
    "address": "345 Buckminster Rd",
    "parcel_id": "258-02-00",
    "owner1": "THORNE, NATHAN & NATALIE",
    "owner2": "",
    "current_taxes": 62606.34,
    "new_taxes_no_override": 65310.93,
    "override_total_1": 67164.08,
    "override_increase_1": 1853.15
  },
  {
    "#": "348 Buckminster Rd (257-11-00)",
    "$": 5074900,
    "address": "348 Buckminster Rd",
    "parcel_id": "257-11-00",
    "owner1": "TANDON TRS, MANISH",
    "owner2": "RAMCHANDANI, SHIRLY",
    "current_taxes": 48332.04,
    "new_taxes_no_override": 50419.98,
    "override_total_1": 51850.61,
    "override_increase_1": 1430.63
  },
  {
    "#": "355 Buckminster Rd (258-03-04)",
    "$": 7881800,
    "address": "355 Buckminster Rd",
    "parcel_id": "258-03-04",
    "owner1": "DOGANIS TR, YANNIS",
    "owner2": "",
    "current_taxes": 80709.63,
    "new_taxes_no_override": 84196.29,
    "override_total_1": 86585.29,
    "override_increase_1": 2389.01
  },
  {
    "#": "364 Buckminster Rd (257-10-00)",
    "$": 9120900,
    "address": "364 Buckminster Rd",
    "parcel_id": "257-10-00",
    "owner1": "EDGERLEY, PAUL B & SANDRA M",
    "owner2": "",
    "current_taxes": 93398.02,
    "new_taxes_no_override": 97432.81,
    "override_total_1": 100197.4,
    "override_increase_1": 2764.58
  },
  {
    "#": "100 Cabot St (437-55-00)",
    "$": 9646500,
    "address": "100 Cabot St",
    "parcel_id": "437-55-00",
    "owner1": "PUTZIGER TR, MICHAEL T",
    "owner2": "",
    "current_taxes": 98780.16,
    "new_taxes_no_override": 103047.46,
    "override_total_1": 105971.36,
    "override_increase_1": 2923.89
  },
  {
    "#": "107 Cabot St (437-59-00)",
    "$": 1601300,
    "address": "107 Cabot St",
    "parcel_id": "437-59-00",
    "owner1": "COUTURE TR, MICHAEL",
    "owner2": "",
    "current_taxes": 16397.31,
    "new_taxes_no_override": 17105.67,
    "override_total_1": 17591.03,
    "override_increase_1": 485.36
  },
  {
    "#": "119 Cabot St (437-57-00)",
    "$": 6552600,
    "address": "119 Cabot St",
    "parcel_id": "437-57-00",
    "owner1": "BCEC LLC",
    "owner2": "",
    "current_taxes": 67098.62,
    "new_taxes_no_override": 69997.28,
    "override_total_1": 71983.4,
    "override_increase_1": 1986.12
  },
  {
    "#": "120 Cabot St (437-54-00)",
    "$": 7807400,
    "address": "120 Cabot St",
    "parcel_id": "437-54-00",
    "owner1": "PENN TR, JONATHAN",
    "owner2": "",
    "current_taxes": 79947.78,
    "new_taxes_no_override": 83401.52,
    "override_total_1": 85767.98,
    "override_increase_1": 2366.45
  },
  {
    "#": "130 Cabot St (437-53-00)",
    "$": 7454100,
    "address": "130 Cabot St",
    "parcel_id": "437-53-00",
    "owner1": "SINTETOS, TR, CHRISTOPHER",
    "owner2": "",
    "current_taxes": 76329.98,
    "new_taxes_no_override": 79627.44,
    "override_total_1": 81886.8,
    "override_increase_1": 2259.37
  },
  {
    "#": "161 Cabot St (437-44-00)",
    "$": 6479500,
    "address": "161 Cabot St",
    "parcel_id": "437-44-00",
    "owner1": "BLEYLEBEN, PETER & CHRISTA",
    "owner2": "",
    "current_taxes": 62715.15,
    "new_taxes_no_override": 65424.44,
    "override_total_1": 67280.81,
    "override_increase_1": 1856.37
  },
  {
    "#": "177 Cabot St (437-43-00)",
    "$": 5511400,
    "address": "177 Cabot St",
    "parcel_id": "437-43-00",
    "owner1": "JOSHI, KRITEN J & VICTORIA A",
    "owner2": "",
    "current_taxes": 52801.8,
    "new_taxes_no_override": 55082.84,
    "override_total_1": 56645.77,
    "override_increase_1": 1562.93
  },
  {
    "#": "180 Cabot St (437-48-00)",
    "$": 8384900,
    "address": "180 Cabot St",
    "parcel_id": "437-48-00",
    "owner1": "RHEINGOLD, LAURENCE M & LINDA C",
    "owner2": "",
    "current_taxes": 82226.44,
    "new_taxes_no_override": 85778.62,
    "override_total_1": 88212.52,
    "override_increase_1": 2433.9
  },
  {
    "#": "192 Cabot St (437-49-00)",
    "$": 169100,
    "address": "192 Cabot St",
    "parcel_id": "437-49-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O VACANT PARCEL REAR 70 LYMAN",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "195 Cabot St (437-42-00)",
    "$": 7499700,
    "address": "195 Cabot St",
    "parcel_id": "437-42-00",
    "owner1": "KANDIAH, GAJAKARNAN V & ELISABETH M",
    "owner2": "",
    "current_taxes": 76796.93,
    "new_taxes_no_override": 80114.56,
    "override_total_1": 82387.75,
    "override_increase_1": 2273.19
  },
  {
    "#": "208 Cabot St (437-35-00)",
    "$": 4534300,
    "address": "208 Cabot St",
    "parcel_id": "437-35-00",
    "owner1": "CINRAY REALTY DEVELOPMENT LLC",
    "owner2": "",
    "current_taxes": 46431.23,
    "new_taxes_no_override": 48437.06,
    "override_total_1": 49811.42,
    "override_increase_1": 1374.36
  },
  {
    "#": " Cabot St (437-05-02)",
    "$": 231100,
    "address": " Cabot St",
    "parcel_id": "437-05-02",
    "owner1": "PUTZIGER TR, MICHAEL T",
    "owner2": "",
    "current_taxes": 2366.46,
    "new_taxes_no_override": 2468.69,
    "override_total_1": 2538.74,
    "override_increase_1": 70.05
  },
  {
    "#": " Cabot St (437-47-02)",
    "$": 143800,
    "address": " Cabot St",
    "parcel_id": "437-47-02",
    "owner1": "R FAMILY HOUSE LLC",
    "owner2": "",
    "current_taxes": 1472.51,
    "new_taxes_no_override": 1536.12,
    "override_total_1": 1579.71,
    "override_increase_1": 43.59
  },
  {
    "#": "11 Cameron St, Unit 1 & P1 (188-09-01)",
    "$": 1044200,
    "address": "11 Cameron St, Unit 1 & P1",
    "parcel_id": "188-09-01",
    "owner1": "CORELLO TRS, JUDITH",
    "owner2": "VEILLET, MARC",
    "current_taxes": 10692.61,
    "new_taxes_no_override": 11154.53,
    "override_total_1": 11471.03,
    "override_increase_1": 316.5
  },
  {
    "#": "11 Cameron St, Unit 2 & P2 (188-09-02)",
    "$": 957300,
    "address": "11 Cameron St, Unit 2 & P2",
    "parcel_id": "188-09-02",
    "owner1": "LEE, KYU HA",
    "owner2": "SEO, SUMI",
    "current_taxes": 9802.75,
    "new_taxes_no_override": 10226.23,
    "override_total_1": 10516.39,
    "override_increase_1": 290.16
  },
  {
    "#": "11 Cameron St, Unit 3 & P3 (188-09-03)",
    "$": 1310300,
    "address": "11 Cameron St, Unit 3 & P3",
    "parcel_id": "188-09-03",
    "owner1": "GREGOIRE, NICHOLAS A & RONALD",
    "owner2": "POLLOCK, MELISSA",
    "current_taxes": 9782.54,
    "new_taxes_no_override": 10205.15,
    "override_total_1": 10494.71,
    "override_increase_1": 289.56
  },
  {
    "#": "15 Cameron St (188-10-00)",
    "$": 1519400,
    "address": "15 Cameron St",
    "parcel_id": "188-10-00",
    "owner1": "KOVALKO TR, YOLANTA M",
    "owner2": "",
    "current_taxes": 15558.66,
    "new_taxes_no_override": 16230.79,
    "override_total_1": 16691.33,
    "override_increase_1": 460.54
  },
  {
    "#": "20 Cameron St, Unit 101 & P23 (189-09-11)",
    "$": 665500,
    "address": "20 Cameron St, Unit 101 & P23",
    "parcel_id": "189-09-11",
    "owner1": "FERNANDEZ, ZORAIDA & OSCAR",
    "owner2": "",
    "current_taxes": 3179.79,
    "new_taxes_no_override": 3317.16,
    "override_total_1": 3411.28,
    "override_increase_1": 94.12
  },
  {
    "#": "20 Cameron St, Unit 102 & P24 (189-09-12)",
    "$": 678300,
    "address": "20 Cameron St, Unit 102 & P24",
    "parcel_id": "189-09-12",
    "owner1": "TIRUMANI, SREE HARSHA",
    "owner2": "",
    "current_taxes": 6945.79,
    "new_taxes_no_override": 7245.85,
    "override_total_1": 7451.44,
    "override_increase_1": 205.6
  },
  {
    "#": "20 Cameron St, Unit 103 & P13 (189-09-13)",
    "$": 678200,
    "address": "20 Cameron St, Unit 103 & P13",
    "parcel_id": "189-09-13",
    "owner1": "CAPLAN, CYNTHIA",
    "owner2": "",
    "current_taxes": 3309.83,
    "new_taxes_no_override": 3452.81,
    "override_total_1": 3550.79,
    "override_increase_1": 97.97
  },
  {
    "#": "20 Cameron St, Unit 104 & P12 (189-09-14)",
    "$": 678300,
    "address": "20 Cameron St, Unit 104 & P12",
    "parcel_id": "189-09-14",
    "owner1": "SAJI, MICHAEL",
    "owner2": "KWAN, CHARLENE",
    "current_taxes": 6945.79,
    "new_taxes_no_override": 7245.85,
    "override_total_1": 7451.44,
    "override_increase_1": 205.6
  },
  {
    "#": "20 Cameron St, Unit 201 & P22 (189-09-15)",
    "$": 676900,
    "address": "20 Cameron St, Unit 201 & P22",
    "parcel_id": "189-09-15",
    "owner1": "CHANG, MARTY YUANFAN",
    "owner2": "WANG, YA-YUN",
    "current_taxes": 6931.46,
    "new_taxes_no_override": 7230.9,
    "override_total_1": 7436.07,
    "override_increase_1": 205.17
  },
  {
    "#": "20 Cameron St, Unit 202 & P25 (189-09-16)",
    "$": 677600,
    "address": "20 Cameron St, Unit 202 & P25",
    "parcel_id": "189-09-16",
    "owner1": "GUPTA, SUNISH & RAMA",
    "owner2": "",
    "current_taxes": 3303.69,
    "new_taxes_no_override": 3446.41,
    "override_total_1": 3544.2,
    "override_increase_1": 97.79
  },
  {
    "#": "20 Cameron St, Unit 203 & P11 (189-09-17)",
    "$": 677900,
    "address": "20 Cameron St, Unit 203 & P11",
    "parcel_id": "189-09-17",
    "owner1": "CHONG, PUI SIO",
    "owner2": "ZHAO, ELBIN CHONG",
    "current_taxes": 3306.76,
    "new_taxes_no_override": 3449.61,
    "override_total_1": 3547.49,
    "override_increase_1": 97.88
  },
  {
    "#": "20 Cameron St, Unit 204 & P10 (189-09-18)",
    "$": 677900,
    "address": "20 Cameron St, Unit 204 & P10",
    "parcel_id": "189-09-18",
    "owner1": "CHEN, YEN HENG",
    "owner2": "CHANG, WEI YI",
    "current_taxes": 6941.7,
    "new_taxes_no_override": 7241.58,
    "override_total_1": 7447.06,
    "override_increase_1": 205.47
  },
  {
    "#": "20 Cameron St, Unit 301 & P18 (189-09-19)",
    "$": 677600,
    "address": "20 Cameron St, Unit 301 & P18",
    "parcel_id": "189-09-19",
    "owner1": "ABUJOUB TRS, AMIN & AIDA",
    "owner2": "",
    "current_taxes": 6938.62,
    "new_taxes_no_override": 7238.37,
    "override_total_1": 7443.75,
    "override_increase_1": 205.38
  },
  {
    "#": "20 Cameron St, Unit 302 & P21 (189-09-20)",
    "$": 676900,
    "address": "20 Cameron St, Unit 302 & P21",
    "parcel_id": "189-09-20",
    "owner1": "YU, CHUN",
    "owner2": "SUN, XIANGAO",
    "current_taxes": 6931.46,
    "new_taxes_no_override": 7230.9,
    "override_total_1": 7436.07,
    "override_increase_1": 205.17
  },
  {
    "#": "20 Cameron St, Unit 303 & P9 (189-09-21)",
    "$": 677600,
    "address": "20 Cameron St, Unit 303 & P9",
    "parcel_id": "189-09-21",
    "owner1": "PANORCHAN, PORNTULA",
    "owner2": "",
    "current_taxes": 6938.62,
    "new_taxes_no_override": 7238.37,
    "override_total_1": 7443.75,
    "override_increase_1": 205.38
  },
  {
    "#": "20 Cameron St, Unit 304 & P8 (189-09-22)",
    "$": 676900,
    "address": "20 Cameron St, Unit 304 & P8",
    "parcel_id": "189-09-22",
    "owner1": "CHEN, KAI",
    "owner2": "FU, LING",
    "current_taxes": 6931.46,
    "new_taxes_no_override": 7230.9,
    "override_total_1": 7436.07,
    "override_increase_1": 205.17
  },
  {
    "#": "20 Cameron St, Unit 401 P15&17 (189-09-23)",
    "$": 909500,
    "address": "20 Cameron St, Unit 401 P15&17",
    "parcel_id": "189-09-23",
    "owner1": "GUPTA, SUNISH",
    "owner2": "",
    "current_taxes": 5678.35,
    "new_taxes_no_override": 5923.65,
    "override_total_1": 6091.73,
    "override_increase_1": 168.08
  },
  {
    "#": "20 Cameron St, Unit 402 P14&16 (189-09-24)",
    "$": 925300,
    "address": "20 Cameron St, Unit 402 P14&16",
    "parcel_id": "189-09-24",
    "owner1": "KIRTHIVASAN, BHARAT",
    "owner2": "RAGHAVAN, APARNA",
    "current_taxes": 5840.14,
    "new_taxes_no_override": 6092.43,
    "override_total_1": 6265.3,
    "override_increase_1": 172.87
  },
  {
    "#": "23 Cameron St (188-11-00)",
    "$": 1108300,
    "address": "23 Cameron St",
    "parcel_id": "188-11-00",
    "owner1": "PLANCON, THOMAS E",
    "owner2": "HOZID, AMY S P",
    "current_taxes": 7714.06,
    "new_taxes_no_override": 8047.31,
    "override_total_1": 8275.64,
    "override_increase_1": 228.34
  },
  {
    "#": "30 Cameron St, Unit 1 P1 P8 (189-08-01)",
    "$": 794000,
    "address": "30 Cameron St, Unit 1 P1 P8",
    "parcel_id": "189-08-01",
    "owner1": "KAPLAN, LOUIS & ROBERTA",
    "owner2": "",
    "current_taxes": 4495.63,
    "new_taxes_no_override": 4689.84,
    "override_total_1": 4822.91,
    "override_increase_1": 133.07
  },
  {
    "#": "30 Cameron St, Unit 2 P2 P9 (189-08-02)",
    "$": 742300,
    "address": "30 Cameron St, Unit 2 P2 P9",
    "parcel_id": "189-08-02",
    "owner1": "DAS, UDAYAN",
    "owner2": "BANERJEE, DALIYA",
    "current_taxes": 3966.22,
    "new_taxes_no_override": 4137.56,
    "override_total_1": 4254.96,
    "override_increase_1": 117.4
  },
  {
    "#": "30 Cameron St, Unit 3 P3 P10 (189-08-03)",
    "$": 771500,
    "address": "30 Cameron St, Unit 3 P3 P10",
    "parcel_id": "189-08-03",
    "owner1": "CHOI, KYUNG AE",
    "owner2": "",
    "current_taxes": 7900.16,
    "new_taxes_no_override": 8241.45,
    "override_total_1": 8475.29,
    "override_increase_1": 233.84
  },
  {
    "#": "30 Cameron St, Unit 4 & P4-11 (189-08-04)",
    "$": 794000,
    "address": "30 Cameron St, Unit 4 & P4-11",
    "parcel_id": "189-08-04",
    "owner1": "REN, XINPING",
    "owner2": "ZHU, LIBEN",
    "current_taxes": 8130.56,
    "new_taxes_no_override": 8481.8,
    "override_total_1": 8722.46,
    "override_increase_1": 240.66
  },
  {
    "#": "30 Cameron St, Unit 5 P5 P12 (189-08-05)",
    "$": 800500,
    "address": "30 Cameron St, Unit 5 P5 P12",
    "parcel_id": "189-08-05",
    "owner1": "TAN, SIONG KIM",
    "owner2": "LAU, SIEW LIN",
    "current_taxes": 8197.12,
    "new_taxes_no_override": 8551.24,
    "override_total_1": 8793.87,
    "override_increase_1": 242.63
  },
  {
    "#": "30 Cameron St, Unit 6 P6 P13 (189-08-06)",
    "$": 794000,
    "address": "30 Cameron St, Unit 6 P6 P13",
    "parcel_id": "189-08-06",
    "owner1": "CHU, CHIH-CHI",
    "owner2": "LEE, AVA",
    "current_taxes": 4495.63,
    "new_taxes_no_override": 4689.84,
    "override_total_1": 4822.91,
    "override_increase_1": 133.07
  },
  {
    "#": "30 Cameron St, Unit 7 P7 P14 (189-08-07)",
    "$": 784500,
    "address": "30 Cameron St, Unit 7 P7 P14",
    "parcel_id": "189-08-07",
    "owner1": "LI, KAIYUAN & QIAN",
    "owner2": "",
    "current_taxes": 8033.28,
    "new_taxes_no_override": 8380.32,
    "override_total_1": 8618.1,
    "override_increase_1": 237.79
  },
  {
    "#": "40 Cameron St (189-05-01)",
    "$": 4163000,
    "address": "40 Cameron St",
    "parcel_id": "189-05-01",
    "owner1": "CP INVESTMENT LLC",
    "owner2": "",
    "current_taxes": 42629.12,
    "new_taxes_no_override": 44470.7,
    "override_total_1": 45732.52,
    "override_increase_1": 1261.82
  },
  {
    "#": "43 Cameron St (187-08-00)",
    "$": 542000,
    "address": "43 Cameron St",
    "parcel_id": "187-08-00",
    "owner1": "7 SMYTHE STREET LLC",
    "owner2": "",
    "current_taxes": 5550.08,
    "new_taxes_no_override": 5789.84,
    "override_total_1": 5954.13,
    "override_increase_1": 164.28
  },
  {
    "#": "46 Cameron St, Unit A (189-05-02)",
    "$": 1509900,
    "address": "46 Cameron St, Unit A",
    "parcel_id": "189-05-02",
    "owner1": "HALFORD, BRITTNE A",
    "owner2": "SIMON, KEVIN M",
    "current_taxes": 11826.44,
    "new_taxes_no_override": 12337.34,
    "override_total_1": 12687.4,
    "override_increase_1": 350.06
  },
  {
    "#": "46 Cameron St, Unit B (189-05-03)",
    "$": 1452700,
    "address": "46 Cameron St, Unit B",
    "parcel_id": "189-05-03",
    "owner1": "GAUDINO, JOSEPH & SHONALI GUPTA",
    "owner2": "",
    "current_taxes": 11240.71,
    "new_taxes_no_override": 11726.31,
    "override_total_1": 12059.03,
    "override_increase_1": 332.73
  },
  {
    "#": "48 Cameron St, Unit 48 (189-04-01)",
    "$": 1351400,
    "address": "48 Cameron St, Unit 48",
    "parcel_id": "189-04-01",
    "owner1": "HEWITT, JOSEPH D & ELIZABETH F",
    "owner2": "",
    "current_taxes": 13838.34,
    "new_taxes_no_override": 14436.16,
    "override_total_1": 14845.77,
    "override_increase_1": 409.61
  },
  {
    "#": "50 Cameron St, Unit 50 (189-04-02)",
    "$": 1249100,
    "address": "50 Cameron St, Unit 50",
    "parcel_id": "189-04-02",
    "owner1": "BICHIMER, STEVEN",
    "owner2": "WHITE, COLLEEN",
    "current_taxes": 9155.85,
    "new_taxes_no_override": 9551.38,
    "override_total_1": 9822.4,
    "override_increase_1": 271.01
  },
  {
    "#": "58 Cameron St, Unit 1 (186-08-01)",
    "$": 1485800,
    "address": "58 Cameron St, Unit 1",
    "parcel_id": "186-08-01",
    "owner1": "SHUI, BING",
    "owner2": "",
    "current_taxes": 11579.66,
    "new_taxes_no_override": 12079.9,
    "override_total_1": 12422.66,
    "override_increase_1": 342.76
  },
  {
    "#": "60 Cameron St, Unit 2 (186-08-02)",
    "$": 1485800,
    "address": "60 Cameron St, Unit 2",
    "parcel_id": "186-08-02",
    "owner1": "PAIK, YOUNGIK & VERONIKA",
    "owner2": "",
    "current_taxes": 15214.59,
    "new_taxes_no_override": 15871.86,
    "override_total_1": 16322.21,
    "override_increase_1": 450.35
  },
  {
    "#": "62 Cameron St, Unit 3 (186-08-03)",
    "$": 1570000,
    "address": "62 Cameron St, Unit 3",
    "parcel_id": "186-08-03",
    "owner1": "LARSEN TR, ELIAS",
    "owner2": "",
    "current_taxes": 16076.8,
    "new_taxes_no_override": 16771.32,
    "override_total_1": 17247.19,
    "override_increase_1": 475.87
  },
  {
    "#": "3 Carlton St (114-01-00)",
    "$": 2963500,
    "address": "3 Carlton St",
    "parcel_id": "114-01-00",
    "owner1": "STADFELD, PAUL",
    "owner2": "",
    "current_taxes": 30346.24,
    "new_taxes_no_override": 31657.2,
    "override_total_1": 32555.45,
    "override_increase_1": 898.25
  },
  {
    "#": "5 Carlton St (114-01-01)",
    "$": 2933900,
    "address": "5 Carlton St",
    "parcel_id": "114-01-01",
    "owner1": "PFORR TR, NINA PALMER",
    "owner2": "",
    "current_taxes": 26408.2,
    "new_taxes_no_override": 27549.03,
    "override_total_1": 28330.72,
    "override_increase_1": 781.68
  },
  {
    "#": "11 Carlton St (114-01-02)",
    "$": 3445600,
    "address": "11 Carlton St",
    "parcel_id": "114-01-02",
    "owner1": "KLEIN, YOSEF YITZCHOK & RACHEL EVE",
    "owner2": "",
    "current_taxes": 31648.01,
    "new_taxes_no_override": 33015.2,
    "override_total_1": 33951.99,
    "override_increase_1": 936.78
  },
  {
    "#": "15 Carlton St (114-02-00)",
    "$": 3348800,
    "address": "15 Carlton St",
    "parcel_id": "114-02-00",
    "owner1": "RAYNES TRS, ANTHONY E & MAUREEN T",
    "owner2": "",
    "current_taxes": 30656.78,
    "new_taxes_no_override": 31981.15,
    "override_total_1": 32888.59,
    "override_increase_1": 907.44
  },
  {
    "#": "17 Carlton St, Unit 17 (114-03-05)",
    "$": 1702800,
    "address": "17 Carlton St, Unit 17",
    "parcel_id": "114-03-05",
    "owner1": "TEMIN, NATHANIEL N",
    "owner2": "DAMON, JILL R",
    "current_taxes": 13801.74,
    "new_taxes_no_override": 14397.98,
    "override_total_1": 14806.51,
    "override_increase_1": 408.53
  },
  {
    "#": "19 Carlton St, Unit 19 (114-03-01)",
    "$": 1436600,
    "address": "19 Carlton St, Unit 19",
    "parcel_id": "114-03-01",
    "owner1": "WONG TRS, TAI NGAR",
    "owner2": "LIN, CAI CAI",
    "current_taxes": 14710.78,
    "new_taxes_no_override": 15346.29,
    "override_total_1": 15781.72,
    "override_increase_1": 435.44
  },
  {
    "#": "21 Carlton St, Unit 21 (114-03-02)",
    "$": 1436600,
    "address": "21 Carlton St, Unit 21",
    "parcel_id": "114-03-02",
    "owner1": "WALATA, EDWARD F",
    "owner2": "C/O FIDUCIARY TRUST CO",
    "current_taxes": 14710.78,
    "new_taxes_no_override": 15346.29,
    "override_total_1": 15781.72,
    "override_increase_1": 435.44
  },
  {
    "#": "22 Carlton St (115-02-00)",
    "$": 6616600,
    "address": "22 Carlton St",
    "parcel_id": "115-02-00",
    "owner1": "22 CARLTON LLC",
    "owner2": "",
    "current_taxes": 67753.98,
    "new_taxes_no_override": 70680.95,
    "override_total_1": 72686.47,
    "override_increase_1": 2005.52
  },
  {
    "#": "23 Carlton St, Unit 23 (114-03-03)",
    "$": 1728900,
    "address": "23 Carlton St, Unit 23",
    "parcel_id": "114-03-03",
    "owner1": "LI, WEN",
    "owner2": "NISHIMURA, YUKITOSHI",
    "current_taxes": 14069.0,
    "new_taxes_no_override": 14676.78,
    "override_total_1": 15093.22,
    "override_increase_1": 416.44
  },
  {
    "#": "25 Carlton St, Unit 25R (114-03-04)",
    "$": 1694000,
    "address": "25 Carlton St, Unit 25R",
    "parcel_id": "114-03-04",
    "owner1": "LIN TR, LUCIA",
    "owner2": "",
    "current_taxes": 13711.63,
    "new_taxes_no_override": 14303.97,
    "override_total_1": 14709.84,
    "override_increase_1": 405.86
  },
  {
    "#": "37 Carlton St (112-01-02)",
    "$": 4004500,
    "address": "37 Carlton St",
    "parcel_id": "112-01-02",
    "owner1": "BOSTON UNIVERSITY TRS",
    "owner2": "C/O GENERAL ACCOUNTING 4TH FLR",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "40 Carlton St (116-01-25)",
    "$": 13385800,
    "address": "40 Carlton St",
    "parcel_id": "116-01-25",
    "owner1": "BROOKLINE BRILLIANCE REALTY LLC",
    "owner2": "C/O DANNIN MANAGEMENT CORP",
    "current_taxes": 137070.59,
    "new_taxes_no_override": 142992.04,
    "override_total_1": 147049.33,
    "override_increase_1": 4057.29
  },
  {
    "#": "41 Carlton St, Unit 1 P-A (112-03-04)",
    "$": 1115300,
    "address": "41 Carlton St, Unit 1 P-A",
    "parcel_id": "112-03-04",
    "owner1": "WAERSTAD, HILDE",
    "owner2": "",
    "current_taxes": 7785.74,
    "new_taxes_no_override": 8122.08,
    "override_total_1": 8352.54,
    "override_increase_1": 230.46
  },
  {
    "#": "41 Carlton St, Unit 2 (112-03-01)",
    "$": 884600,
    "address": "41 Carlton St, Unit 2",
    "parcel_id": "112-03-01",
    "owner1": "WALLACH, KAREN",
    "owner2": "",
    "current_taxes": 5423.37,
    "new_taxes_no_override": 5657.66,
    "override_total_1": 5818.19,
    "override_increase_1": 160.53
  },
  {
    "#": "41 Carlton St, Unit 3 & Pk Sp-B (112-03-02)",
    "$": 913200,
    "address": "41 Carlton St, Unit 3 & Pk Sp-B",
    "parcel_id": "112-03-02",
    "owner1": "SUN TRS, HUIMIN",
    "owner2": "HAN, ZHAORUI",
    "current_taxes": 9351.17,
    "new_taxes_no_override": 9755.14,
    "override_total_1": 10031.94,
    "override_increase_1": 276.79
  },
  {
    "#": "41 Carlton St, Unit 4 (112-03-03)",
    "$": 1011200,
    "address": "41 Carlton St, Unit 4",
    "parcel_id": "112-03-03",
    "owner1": "EASTER, SARAH RAE & NICKOLAS",
    "owner2": "",
    "current_taxes": 10354.69,
    "new_taxes_no_override": 10802.01,
    "override_total_1": 11108.51,
    "override_increase_1": 306.5
  },
  {
    "#": "43 Carlton St, Unit 1 (112-04-04)",
    "$": 1199000,
    "address": "43 Carlton St, Unit 1",
    "parcel_id": "112-04-04",
    "owner1": "TO, LINH THUY",
    "owner2": "",
    "current_taxes": 8642.83,
    "new_taxes_no_override": 9016.2,
    "override_total_1": 9272.03,
    "override_increase_1": 255.83
  },
  {
    "#": "43 Carlton St, Unit 2 (112-04-01)",
    "$": 948000,
    "address": "43 Carlton St, Unit 2",
    "parcel_id": "112-04-01",
    "owner1": "CERFOLIO, LAVERNE A",
    "owner2": "BUTLER, TIMOTHY P",
    "current_taxes": 6072.59,
    "new_taxes_no_override": 6334.93,
    "override_total_1": 6514.67,
    "override_increase_1": 179.75
  },
  {
    "#": "43 Carlton St, Unit 3 & P-B (112-04-02)",
    "$": 910800,
    "address": "43 Carlton St, Unit 3 & P-B",
    "parcel_id": "112-04-02",
    "owner1": "KOKA, BABU V & ARUNA",
    "owner2": "",
    "current_taxes": 9326.59,
    "new_taxes_no_override": 9729.5,
    "override_total_1": 10005.57,
    "override_increase_1": 276.07
  },
  {
    "#": "43 Carlton St, Unit 4 (112-04-03)",
    "$": 1044500,
    "address": "43 Carlton St, Unit 4",
    "parcel_id": "112-04-03",
    "owner1": "EDELSON, GLENN D",
    "owner2": "",
    "current_taxes": 7060.75,
    "new_taxes_no_override": 7365.77,
    "override_total_1": 7574.77,
    "override_increase_1": 209.0
  },
  {
    "#": "45 Carlton St (112-05-00)",
    "$": 4247500,
    "address": "45 Carlton St",
    "parcel_id": "112-05-00",
    "owner1": "OAK HILL PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 43494.4,
    "new_taxes_no_override": 45373.36,
    "override_total_1": 46660.79,
    "override_increase_1": 1287.43
  },
  {
    "#": "67 Carlton St, Unit 1 & P1 (001-15-04)",
    "$": 1292300,
    "address": "67 Carlton St, Unit 1 & P1",
    "parcel_id": "001-15-04",
    "owner1": "TOY, JOHN S & ROSEMARY",
    "owner2": "",
    "current_taxes": 13233.15,
    "new_taxes_no_override": 13804.82,
    "override_total_1": 14196.52,
    "override_increase_1": 391.7
  },
  {
    "#": "67 Carlton St, Unit 2 & P2 (001-15-01)",
    "$": 1317700,
    "address": "67 Carlton St, Unit 2 & P2",
    "parcel_id": "001-15-01",
    "owner1": "PEAK, DAVID",
    "owner2": "ARAI, MAYA",
    "current_taxes": 9858.31,
    "new_taxes_no_override": 10284.19,
    "override_total_1": 10575.99,
    "override_increase_1": 291.81
  },
  {
    "#": "67 Carlton St, Unit 3 (001-15-02)",
    "$": 1150500,
    "address": "67 Carlton St, Unit 3",
    "parcel_id": "001-15-02",
    "owner1": "STICKELLS, STEPHEN C",
    "owner2": "",
    "current_taxes": 8146.19,
    "new_taxes_no_override": 8498.11,
    "override_total_1": 8739.23,
    "override_increase_1": 241.13
  },
  {
    "#": "67 Carlton St, Unit 4 & P4-P5 (001-15-03)",
    "$": 1149400,
    "address": "67 Carlton St, Unit 4 & P4-P5",
    "parcel_id": "001-15-03",
    "owner1": "STICKELLS, STEPHEN C",
    "owner2": "",
    "current_taxes": 11769.86,
    "new_taxes_no_override": 12278.32,
    "override_total_1": 12626.71,
    "override_increase_1": 348.39
  },
  {
    "#": "71 Carlton St (001-16-00)",
    "$": 2881100,
    "address": "71 Carlton St",
    "parcel_id": "001-16-00",
    "owner1": "WARREN, PAUL J",
    "owner2": "EVENSON, AMY",
    "current_taxes": 25867.53,
    "new_taxes_no_override": 26985.01,
    "override_total_1": 27750.69,
    "override_increase_1": 765.68
  },
  {
    "#": "79 Carlton St (001-17-00)",
    "$": 4464000,
    "address": "79 Carlton St",
    "parcel_id": "001-17-00",
    "owner1": "ERICSSON, STAFFAN",
    "owner2": "",
    "current_taxes": 42076.43,
    "new_taxes_no_override": 43894.13,
    "override_total_1": 45139.59,
    "override_increase_1": 1245.46
  },
  {
    "#": "82 Carlton St (009A-07-00)",
    "$": 4131500,
    "address": "82 Carlton St",
    "parcel_id": "009A-07-00",
    "owner1": "MAZANDI-ISEKE, ET AL, RICHARD J",
    "owner2": "",
    "current_taxes": 38671.63,
    "new_taxes_no_override": 40342.24,
    "override_total_1": 41486.92,
    "override_increase_1": 1144.68
  },
  {
    "#": "89 Carlton St (001-18-00)",
    "$": 3985000,
    "address": "89 Carlton St",
    "parcel_id": "001-18-00",
    "owner1": "KANES, STEVEN R",
    "owner2": "MOORE, NANCY J",
    "current_taxes": 37171.47,
    "new_taxes_no_override": 38777.28,
    "override_total_1": 39877.55,
    "override_increase_1": 1100.28
  },
  {
    "#": "90 Carlton St (009A-06-00)",
    "$": 3575900,
    "address": "90 Carlton St",
    "parcel_id": "009A-06-00",
    "owner1": "HIGGINS, THOMAS T",
    "owner2": "KANE, CONSTANCE F",
    "current_taxes": 32982.28,
    "new_taxes_no_override": 34407.11,
    "override_total_1": 35383.39,
    "override_increase_1": 976.28
  },
  {
    "#": "95 Carlton St (001-19-00)",
    "$": 5709000,
    "address": "95 Carlton St",
    "parcel_id": "001-19-00",
    "owner1": "TEMPEL, JEAN C",
    "owner2": "WILSON, PETER A",
    "current_taxes": 54825.23,
    "new_taxes_no_override": 57193.68,
    "override_total_1": 58816.51,
    "override_increase_1": 1622.83
  },
  {
    "#": "98 Carlton St (009A-05-00)",
    "$": 5259900,
    "address": "98 Carlton St",
    "parcel_id": "009A-05-00",
    "owner1": "CHAUDHURI, AMRIT",
    "owner2": "",
    "current_taxes": 50226.44,
    "new_taxes_no_override": 52396.22,
    "override_total_1": 53882.92,
    "override_increase_1": 1486.7
  },
  {
    "#": "111 Carlton St (002-06-00)",
    "$": 3877000,
    "address": "111 Carlton St",
    "parcel_id": "002-06-00",
    "owner1": "SULAK, LAWRENCE R & ELIZABETH C",
    "owner2": "",
    "current_taxes": 36065.55,
    "new_taxes_no_override": 37623.58,
    "override_total_1": 38691.12,
    "override_increase_1": 1067.54
  },
  {
    "#": "121 Carlton St (002-07-00)",
    "$": 3907600,
    "address": "121 Carlton St",
    "parcel_id": "002-07-00",
    "owner1": "RDF CORPORATION",
    "owner2": "",
    "current_taxes": 40013.82,
    "new_taxes_no_override": 41742.42,
    "override_total_1": 42926.83,
    "override_increase_1": 1184.41
  },
  {
    "#": "122 Carlton St (003-05-00)",
    "$": 3126000,
    "address": "122 Carlton St",
    "parcel_id": "003-05-00",
    "owner1": "BOGOCH, ELEANOR S",
    "owner2": "",
    "current_taxes": 32010.24,
    "new_taxes_no_override": 33393.08,
    "override_total_1": 34340.59,
    "override_increase_1": 947.5
  },
  {
    "#": "131 Carlton St (005-15-00)",
    "$": 5217300,
    "address": "131 Carlton St",
    "parcel_id": "005-15-00",
    "owner1": "LIEBERMAN, EVAN & AMY",
    "owner2": "",
    "current_taxes": 49790.22,
    "new_taxes_no_override": 51941.16,
    "override_total_1": 53414.95,
    "override_increase_1": 1473.79
  },
  {
    "#": "132 Carlton St (004-04-00)",
    "$": 4633200,
    "address": "132 Carlton St",
    "parcel_id": "004-04-00",
    "owner1": "LEDBETTER, MONTY STEPHEN",
    "owner2": "",
    "current_taxes": 43809.03,
    "new_taxes_no_override": 45701.58,
    "override_total_1": 46998.33,
    "override_increase_1": 1296.75
  },
  {
    "#": "141 Carlton St (005-01-00)",
    "$": 4523700,
    "address": "141 Carlton St",
    "parcel_id": "005-01-00",
    "owner1": "BOSTON UNIVERSITY TRS",
    "owner2": "C/O GENERAL ACCOUNTING 4TH FLR",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "146 Carlton St (004-03-00)",
    "$": 2485800,
    "address": "146 Carlton St",
    "parcel_id": "004-03-00",
    "owner1": "BOSTON UNIVERSITY TRS",
    "owner2": "C/O GENERAL ACCOUNTING 4TH FLR",
    "current_taxes": 25454.59,
    "new_taxes_no_override": 26554.23,
    "override_total_1": 27307.68,
    "override_increase_1": 753.46
  },
  {
    "#": "5 Cary Rd (434-05-00)",
    "$": 1876500,
    "address": "5 Cary Rd",
    "parcel_id": "434-05-00",
    "owner1": "PINYOCHON, SURAPHONG & SUDAMANEE",
    "owner2": "",
    "current_taxes": 15580.43,
    "new_taxes_no_override": 16253.5,
    "override_total_1": 16714.69,
    "override_increase_1": 461.18
  },
  {
    "#": "9 Cary Rd (434-06-00)",
    "$": 2757600,
    "address": "9 Cary Rd",
    "parcel_id": "434-06-00",
    "owner1": "HAN, BILLY P",
    "owner2": "MENDEL, MARILYN",
    "current_taxes": 24602.89,
    "new_taxes_no_override": 25665.73,
    "override_total_1": 26393.98,
    "override_increase_1": 728.25
  },
  {
    "#": "10 Cary Rd (435-02-00)",
    "$": 4312800,
    "address": "10 Cary Rd",
    "parcel_id": "435-02-00",
    "owner1": "BROOKS, STEVEN J & KIM GAINSBORO",
    "owner2": "",
    "current_taxes": 40528.14,
    "new_taxes_no_override": 42278.96,
    "override_total_1": 43478.59,
    "override_increase_1": 1199.63
  },
  {
    "#": "17 Cary Rd (434-07-00)",
    "$": 2804500,
    "address": "17 Cary Rd",
    "parcel_id": "434-07-00",
    "owner1": "COHEN, ROBERT A",
    "owner2": "SHIP, AMY N",
    "current_taxes": 25083.15,
    "new_taxes_no_override": 26166.74,
    "override_total_1": 26909.2,
    "override_increase_1": 742.46
  },
  {
    "#": "3 Catlin Rd, Unit 3 (252-02-29)",
    "$": 1806300,
    "address": "3 Catlin Rd, Unit 3",
    "parcel_id": "252-02-29",
    "owner1": "CHAMBLISS, JOHN D",
    "owner2": "",
    "current_taxes": 14861.58,
    "new_taxes_no_override": 15503.6,
    "override_total_1": 15943.5,
    "override_increase_1": 439.9
  },
  {
    "#": "5 Catlin Rd, Unit 5 (252-02-30)",
    "$": 1850200,
    "address": "5 Catlin Rd, Unit 5",
    "parcel_id": "252-02-30",
    "owner1": "MORENO, EVELYN V & RUBEN P",
    "owner2": "",
    "current_taxes": 15311.11,
    "new_taxes_no_override": 15972.55,
    "override_total_1": 16425.76,
    "override_increase_1": 453.21
  },
  {
    "#": "15 Catlin Rd, Unit 15 (252-02-31)",
    "$": 2957400,
    "address": "15 Catlin Rd, Unit 15",
    "parcel_id": "252-02-31",
    "owner1": "CATLIN ROAD LLC",
    "owner2": "",
    "current_taxes": 30283.78,
    "new_taxes_no_override": 31592.04,
    "override_total_1": 32488.44,
    "override_increase_1": 896.4
  },
  {
    "#": "17 Catlin Rd, Unit 17 (252-02-32)",
    "$": 2866800,
    "address": "17 Catlin Rd, Unit 17",
    "parcel_id": "252-02-32",
    "owner1": "OSTER, GERRY",
    "owner2": "BAUMRIND, LYDIA",
    "current_taxes": 25721.1,
    "new_taxes_no_override": 26832.25,
    "override_total_1": 27593.6,
    "override_increase_1": 761.34
  },
  {
    "#": "19 Catlin Rd, Unit 19 (252-02-33)",
    "$": 2539700,
    "address": "19 Catlin Rd, Unit 19",
    "parcel_id": "252-02-33",
    "owner1": "EDELMAN, CHERYL & ELAZER R",
    "owner2": "",
    "current_taxes": 22371.59,
    "new_taxes_no_override": 23338.04,
    "override_total_1": 24000.24,
    "override_increase_1": 662.2
  },
  {
    "#": "29 Catlin Rd, Unit 29 (252-02-34)",
    "$": 2135100,
    "address": "29 Catlin Rd, Unit 29",
    "parcel_id": "252-02-34",
    "owner1": "SPENCER, BARBARA",
    "owner2": "GREGORY TR, ROBERT B",
    "current_taxes": 18228.49,
    "new_taxes_no_override": 19015.96,
    "override_total_1": 19555.52,
    "override_increase_1": 539.56
  },
  {
    "#": "30 Catlin Rd (254-02-03)",
    "$": 4048000,
    "address": "30 Catlin Rd",
    "parcel_id": "254-02-03",
    "owner1": "THAM TRS, NICHOLAS MING QIANG",
    "owner2": "MATSUMOTO, YURI",
    "current_taxes": 37816.59,
    "new_taxes_no_override": 39450.27,
    "override_total_1": 40569.64,
    "override_increase_1": 1119.37
  },
  {
    "#": "31 Catlin Rd (254-15-02)",
    "$": 5251500,
    "address": "31 Catlin Rd",
    "parcel_id": "254-15-02",
    "owner1": "JIANG, QI",
    "owner2": "",
    "current_taxes": 53775.36,
    "new_taxes_no_override": 56098.46,
    "override_total_1": 57690.21,
    "override_increase_1": 1591.75
  },
  {
    "#": "2 Cedar Rd (419B-16-00)",
    "$": 2718000,
    "address": "2 Cedar Rd",
    "parcel_id": "419B-16-00",
    "owner1": "WILKER  TR, JAMES R",
    "owner2": "",
    "current_taxes": 24197.39,
    "new_taxes_no_override": 25242.72,
    "override_total_1": 25958.96,
    "override_increase_1": 716.24
  },
  {
    "#": "7 Cedar Rd (420-03-00)",
    "$": 2621900,
    "address": "7 Cedar Rd",
    "parcel_id": "420-03-00",
    "owner1": "MOGOLLON, ANDRES D & MARIA J",
    "owner2": "",
    "current_taxes": 23213.32,
    "new_taxes_no_override": 24216.14,
    "override_total_1": 24903.25,
    "override_increase_1": 687.11
  },
  {
    "#": "15 Cedar Rd (420-02-00)",
    "$": 4773200,
    "address": "15 Cedar Rd",
    "parcel_id": "420-02-00",
    "owner1": "LI, GUOYAN",
    "owner2": "ZHANG, JINXIN",
    "current_taxes": 48877.57,
    "new_taxes_no_override": 50989.08,
    "override_total_1": 52435.86,
    "override_increase_1": 1446.78
  },
  {
    "#": "16 Cedar Rd (419B-03-00)",
    "$": 2653900,
    "address": "16 Cedar Rd",
    "parcel_id": "419B-03-00",
    "owner1": "JENSEN, FRANCES E",
    "owner2": "",
    "current_taxes": 27175.94,
    "new_taxes_no_override": 28349.94,
    "override_total_1": 29154.35,
    "override_increase_1": 804.41
  },
  {
    "#": "21 Cedar Rd (420-01-00)",
    "$": 5957300,
    "address": "21 Cedar Rd",
    "parcel_id": "420-01-00",
    "owner1": "KILLEEN TR, MATTHEW D",
    "owner2": "C/O WHEATLIEGH II TRUST",
    "current_taxes": 61002.75,
    "new_taxes_no_override": 63638.07,
    "override_total_1": 65443.75,
    "override_increase_1": 1805.68
  },
  {
    "#": "30 Cedar Rd (419B-04-00)",
    "$": 3320400,
    "address": "30 Cedar Rd",
    "parcel_id": "419B-04-00",
    "owner1": "LI, XIAOJUN",
    "owner2": "JIANG, HONGYU",
    "current_taxes": 30365.96,
    "new_taxes_no_override": 31677.77,
    "override_total_1": 32576.6,
    "override_increase_1": 898.83
  },
  {
    "#": "37 Cedar Rd (420-23-00)",
    "$": 4848400,
    "address": "37 Cedar Rd",
    "parcel_id": "420-23-00",
    "owner1": "BLOOMBERG, JEFFREY C",
    "owner2": "LUNTZ-BLOOMBERG, SUZANNE F",
    "current_taxes": 46012.68,
    "new_taxes_no_override": 48000.43,
    "override_total_1": 49362.4,
    "override_increase_1": 1361.98
  },
  {
    "#": "40 Cedar Rd (419B-05-00)",
    "$": 4039500,
    "address": "40 Cedar Rd",
    "parcel_id": "419B-05-00",
    "owner1": "BERGER TR, BARRY M",
    "owner2": "",
    "current_taxes": 37729.55,
    "new_taxes_no_override": 39359.47,
    "override_total_1": 40476.26,
    "override_increase_1": 1116.79
  },
  {
    "#": "45 Cedar Rd (420-22-00)",
    "$": 5089400,
    "address": "45 Cedar Rd",
    "parcel_id": "420-22-00",
    "owner1": "LI, HAIXIANG",
    "owner2": "",
    "current_taxes": 52115.46,
    "new_taxes_no_override": 54366.85,
    "override_total_1": 55909.47,
    "override_increase_1": 1542.62
  },
  {
    "#": "48 Cedar Rd (419B-06-01)",
    "$": 3620400,
    "address": "48 Cedar Rd",
    "parcel_id": "419B-06-01",
    "owner1": "POLLARD, CHARLES F JR & MARY E F",
    "owner2": "",
    "current_taxes": 33437.96,
    "new_taxes_no_override": 34882.48,
    "override_total_1": 35872.24,
    "override_increase_1": 989.76
  },
  {
    "#": "63 Cedar Rd (420-21-00)",
    "$": 5103000,
    "address": "63 Cedar Rd",
    "parcel_id": "420-21-00",
    "owner1": "LIODAKIS, EMMANOUIL",
    "owner2": "MAKATOUNI, AIKATERINI",
    "current_taxes": 52254.72,
    "new_taxes_no_override": 54512.12,
    "override_total_1": 56058.86,
    "override_increase_1": 1546.74
  },
  {
    "#": "12 Centre St (083-07-00)",
    "$": 5604900,
    "address": "12 Centre St",
    "parcel_id": "083-07-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O CENTRE ST PARKING LOT WEST",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "25 Centre St (082-14-00)",
    "$": 12157900,
    "address": "25 Centre St",
    "parcel_id": "082-14-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O CENTRE ST PARKING LOT EAST",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "30 Centre St (083-06-00)",
    "$": 2250900,
    "address": "30 Centre St",
    "parcel_id": "083-06-00",
    "owner1": "B & B LODGING HOUSES LLC",
    "owner2": "",
    "current_taxes": 23049.22,
    "new_taxes_no_override": 24044.95,
    "override_total_1": 24727.2,
    "override_increase_1": 682.26
  },
  {
    "#": "32 Centre St (083-05-00)",
    "$": 2593700,
    "address": "32 Centre St",
    "parcel_id": "083-05-00",
    "owner1": "B & B LODGING HOUSES LLC",
    "owner2": "",
    "current_taxes": 26559.49,
    "new_taxes_no_override": 27706.86,
    "override_total_1": 28493.02,
    "override_increase_1": 786.16
  },
  {
    "#": "34 Centre St (083-04-00)",
    "$": 2182900,
    "address": "34 Centre St",
    "parcel_id": "083-04-00",
    "owner1": "B & B LODGING HOUSES LLC",
    "owner2": "",
    "current_taxes": 22352.9,
    "new_taxes_no_override": 23318.55,
    "override_total_1": 23980.19,
    "override_increase_1": 661.65
  },
  {
    "#": "40 Centre St (083-03-00)",
    "$": 10201500,
    "address": "40 Centre St",
    "parcel_id": "083-03-00",
    "owner1": "FORTY CENTRE STREET LLC",
    "owner2": "C/O ROTH ROBERT",
    "current_taxes": 104463.36,
    "new_taxes_no_override": 108976.18,
    "override_total_1": 112068.29,
    "override_increase_1": 3092.12
  },
  {
    "#": "41 Centre St, Unit 101 (082-20-30)",
    "$": 900400,
    "address": "41 Centre St, Unit 101",
    "parcel_id": "082-20-30",
    "owner1": "FELDMAN TRS, SHELLEY R",
    "owner2": "",
    "current_taxes": 5585.16,
    "new_taxes_no_override": 5826.44,
    "override_total_1": 5991.76,
    "override_increase_1": 165.32
  },
  {
    "#": "41 Centre St, Unit 102 & P102 (082-20-01)",
    "$": 795900,
    "address": "41 Centre St, Unit 102 & P102",
    "parcel_id": "082-20-01",
    "owner1": "CHANG, TIFFANY & JESSICA",
    "owner2": "",
    "current_taxes": 4515.08,
    "new_taxes_no_override": 4710.13,
    "override_total_1": 4843.78,
    "override_increase_1": 133.65
  },
  {
    "#": "41 Centre St, Unit 103 (082-20-02)",
    "$": 830600,
    "address": "41 Centre St, Unit 103",
    "parcel_id": "082-20-02",
    "owner1": "BERKOVITZ TRS, JOEL & JAY",
    "owner2": "",
    "current_taxes": 4870.41,
    "new_taxes_no_override": 5080.81,
    "override_total_1": 5224.98,
    "override_increase_1": 144.16
  },
  {
    "#": "41 Centre St, Unit 104 & P104-33 (082-20-03)",
    "$": 1008700,
    "address": "41 Centre St, Unit 104 & P104-33",
    "parcel_id": "082-20-03",
    "owner1": "BROWN, MERIDITH S",
    "owner2": "",
    "current_taxes": 6694.15,
    "new_taxes_no_override": 6983.34,
    "override_total_1": 7181.48,
    "override_increase_1": 198.15
  },
  {
    "#": "41 Centre St, Unit 105 (082-20-04)",
    "$": 941900,
    "address": "41 Centre St, Unit 105",
    "parcel_id": "082-20-04",
    "owner1": "HEIST TR, ROBERT P",
    "owner2": "",
    "current_taxes": 6010.12,
    "new_taxes_no_override": 6269.76,
    "override_total_1": 6447.66,
    "override_increase_1": 177.9
  },
  {
    "#": "41 Centre St, Unit 106 & P106 (082-20-05)",
    "$": 728700,
    "address": "41 Centre St, Unit 106 & P106",
    "parcel_id": "082-20-05",
    "owner1": "WEENE, DAVID",
    "owner2": "",
    "current_taxes": 3826.95,
    "new_taxes_no_override": 3992.27,
    "override_total_1": 4105.55,
    "override_increase_1": 113.28
  },
  {
    "#": "41 Centre St, Unit 201 (082-20-06)",
    "$": 995500,
    "address": "41 Centre St, Unit 201",
    "parcel_id": "082-20-06",
    "owner1": "BYUN, EUNJI",
    "owner2": "",
    "current_taxes": 10193.92,
    "new_taxes_no_override": 10634.3,
    "override_total_1": 10936.04,
    "override_increase_1": 301.74
  },
  {
    "#": "41 Centre St, Unit 202 & P202 (082-20-07)",
    "$": 1003300,
    "address": "41 Centre St, Unit 202 & P202",
    "parcel_id": "082-20-07",
    "owner1": "NISSAISORAKARN, PITCHAPHON & VORAVECH",
    "owner2": "",
    "current_taxes": 6638.86,
    "new_taxes_no_override": 6925.66,
    "override_total_1": 7122.17,
    "override_increase_1": 196.51
  },
  {
    "#": "41 Centre St, Unit 203 & P203 (082-20-08)",
    "$": 785200,
    "address": "41 Centre St, Unit 203 & P203",
    "parcel_id": "082-20-08",
    "owner1": "MOMIN, AL S",
    "owner2": "ROVERUD, ELIN M",
    "current_taxes": 4405.51,
    "new_taxes_no_override": 4595.83,
    "override_total_1": 4726.23,
    "override_increase_1": 130.4
  },
  {
    "#": "41 Centre St, Unit 204 (082-20-09)",
    "$": 948300,
    "address": "41 Centre St, Unit 204",
    "parcel_id": "082-20-09",
    "owner1": "KODURI TRS, PRASADRAO & ANURADHA",
    "owner2": "",
    "current_taxes": 9710.59,
    "new_taxes_no_override": 10130.09,
    "override_total_1": 10417.52,
    "override_increase_1": 287.43
  },
  {
    "#": "41 Centre St, Unit 205 & P34 & P205 (082-20-10)",
    "$": 1014200,
    "address": "41 Centre St, Unit 205 & P34 & P205",
    "parcel_id": "082-20-10",
    "owner1": "TANG TR, ZHIQI JESSICA YU",
    "owner2": "",
    "current_taxes": 10385.41,
    "new_taxes_no_override": 10834.06,
    "override_total_1": 11141.47,
    "override_increase_1": 307.41
  },
  {
    "#": "41 Centre St, Unit 206 (082-20-11)",
    "$": 932200,
    "address": "41 Centre St, Unit 206",
    "parcel_id": "082-20-11",
    "owner1": "WINTMAN, KENNETH",
    "owner2": "",
    "current_taxes": 5910.79,
    "new_taxes_no_override": 6166.14,
    "override_total_1": 6341.1,
    "override_increase_1": 174.96
  },
  {
    "#": "41 Centre St, Unit 207 & P207-P35 (082-20-12)",
    "$": 962300,
    "address": "41 Centre St, Unit 207 & P207-P35",
    "parcel_id": "082-20-12",
    "owner1": "SCHEIN, IGOR & LUCILLE SHORE",
    "owner2": "",
    "current_taxes": 9853.95,
    "new_taxes_no_override": 10279.64,
    "override_total_1": 10571.32,
    "override_increase_1": 291.68
  },
  {
    "#": "41 Centre St, Unit 208 & P208 (082-20-13)",
    "$": 881200,
    "address": "41 Centre St, Unit 208 & P208",
    "parcel_id": "082-20-13",
    "owner1": "SAVOS, SAMANTHA & EMILY ANNE",
    "owner2": "",
    "current_taxes": 9023.49,
    "new_taxes_no_override": 9413.3,
    "override_total_1": 9680.4,
    "override_increase_1": 267.1
  },
  {
    "#": "41 Centre St, Unit 301 & P301 (082-20-14)",
    "$": 982500,
    "address": "41 Centre St, Unit 301 & P301",
    "parcel_id": "082-20-14",
    "owner1": "ARNSTEIN TR, KATHARINE B",
    "owner2": "",
    "current_taxes": 6425.87,
    "new_taxes_no_override": 6703.47,
    "override_total_1": 6893.67,
    "override_increase_1": 190.21
  },
  {
    "#": "41 Centre St, Unit 302 302&32 (082-20-15)",
    "$": 1013300,
    "address": "41 Centre St, Unit 302 302&32",
    "parcel_id": "082-20-15",
    "owner1": "SCHECHNER, DAVID & SHIFRA & MIRIAM H",
    "owner2": "",
    "current_taxes": 6741.26,
    "new_taxes_no_override": 7032.48,
    "override_total_1": 7232.02,
    "override_increase_1": 199.54
  },
  {
    "#": "41 Centre St, Unit 303 41&303 (082-20-16)",
    "$": 903100,
    "address": "41 Centre St, Unit 303 41&303",
    "parcel_id": "082-20-16",
    "owner1": "STEVANOVIC, DARKO",
    "owner2": "",
    "current_taxes": 5612.81,
    "new_taxes_no_override": 5855.28,
    "override_total_1": 6021.42,
    "override_increase_1": 166.14
  },
  {
    "#": "41 Centre St, Unit 304 (082-20-17)",
    "$": 927500,
    "address": "41 Centre St, Unit 304",
    "parcel_id": "082-20-17",
    "owner1": "MALLAMPATI, SESHAGIRI R",
    "owner2": "",
    "current_taxes": 9497.6,
    "new_taxes_no_override": 9907.9,
    "override_total_1": 10189.03,
    "override_increase_1": 281.13
  },
  {
    "#": "41 Centre St, Unit 305 (082-20-18)",
    "$": 950000,
    "address": "41 Centre St, Unit 305",
    "parcel_id": "082-20-18",
    "owner1": "IVANOV, PLAMEN CH & CHRSTINA J M WRIGHT",
    "owner2": "",
    "current_taxes": 9728.0,
    "new_taxes_no_override": 10148.25,
    "override_total_1": 10436.2,
    "override_increase_1": 287.95
  },
  {
    "#": "41 Centre St, Unit 306 & P306-P37 (082-20-19)",
    "$": 953300,
    "address": "41 Centre St, Unit 306 & P306-P37",
    "parcel_id": "082-20-19",
    "owner1": "WOLTMAN, LEON D",
    "owner2": "C/O BROOKE FERRIS WOLTMAN",
    "current_taxes": 6126.86,
    "new_taxes_no_override": 6391.54,
    "override_total_1": 6572.9,
    "override_increase_1": 181.36
  },
  {
    "#": "41 Centre St, Unit 307 (082-20-20)",
    "$": 1021100,
    "address": "41 Centre St, Unit 307",
    "parcel_id": "082-20-20",
    "owner1": "PREMINGER, SUSAN",
    "owner2": "",
    "current_taxes": 10456.06,
    "new_taxes_no_override": 10907.76,
    "override_total_1": 11217.26,
    "override_increase_1": 309.5
  },
  {
    "#": "41 Centre St, Unit 308 (082-20-21)",
    "$": 892100,
    "address": "41 Centre St, Unit 308",
    "parcel_id": "082-20-21",
    "owner1": "DANILOVICH TR, YANN",
    "owner2": "",
    "current_taxes": 5500.17,
    "new_taxes_no_override": 5737.78,
    "override_total_1": 5900.58,
    "override_increase_1": 162.81
  },
  {
    "#": "41 Centre St, Unit 401 & P401 (082-20-22)",
    "$": 974600,
    "address": "41 Centre St, Unit 401 & P401",
    "parcel_id": "082-20-22",
    "owner1": "DECTER TR, DAVID R",
    "owner2": "",
    "current_taxes": 6344.97,
    "new_taxes_no_override": 6619.07,
    "override_total_1": 6806.88,
    "override_increase_1": 187.81
  },
  {
    "#": "41 Centre St, Unit 402 & P40-42 (082-20-23)",
    "$": 995800,
    "address": "41 Centre St, Unit 402 & P40-42",
    "parcel_id": "082-20-23",
    "owner1": "HUNG, KRISTIN & CALEB & FANI",
    "owner2": "C/O KRISTIN HUNG",
    "current_taxes": 10196.99,
    "new_taxes_no_override": 10637.5,
    "override_total_1": 10939.33,
    "override_increase_1": 301.83
  },
  {
    "#": "41 Centre St, Unit 403 & P403&42 (082-20-24)",
    "$": 875300,
    "address": "41 Centre St, Unit 403 & P403&42",
    "parcel_id": "082-20-24",
    "owner1": "SWEI, ABDULLAH",
    "owner2": "BARRON, KATHLEEN",
    "current_taxes": 8963.07,
    "new_taxes_no_override": 9350.27,
    "override_total_1": 9615.58,
    "override_increase_1": 265.31
  },
  {
    "#": "41 Centre St, Unit 404 (082-20-25)",
    "$": 927500,
    "address": "41 Centre St, Unit 404",
    "parcel_id": "082-20-25",
    "owner1": "MOH, WEN YEA & PAUL",
    "owner2": "",
    "current_taxes": 5862.67,
    "new_taxes_no_override": 6115.94,
    "override_total_1": 6289.47,
    "override_increase_1": 173.54
  },
  {
    "#": "41 Centre St, Unit 405 (082-20-26)",
    "$": 972200,
    "address": "41 Centre St, Unit 405",
    "parcel_id": "082-20-26",
    "owner1": "SCHACHTER-KAHL, LIVIA",
    "owner2": "SCHACHTER, LEVANTO G",
    "current_taxes": 9955.33,
    "new_taxes_no_override": 10385.4,
    "override_total_1": 10680.08,
    "override_increase_1": 294.68
  },
  {
    "#": "41 Centre St, Unit 406 (082-20-27)",
    "$": 953000,
    "address": "41 Centre St, Unit 406",
    "parcel_id": "082-20-27",
    "owner1": "KWAK TRS, ROBERT DANIEL",
    "owner2": "BAE, EUNHAK",
    "current_taxes": 9758.72,
    "new_taxes_no_override": 10180.3,
    "override_total_1": 10469.15,
    "override_increase_1": 288.86
  },
  {
    "#": "41 Centre St, Unit 407 (082-20-28)",
    "$": 946700,
    "address": "41 Centre St, Unit 407",
    "parcel_id": "082-20-28",
    "owner1": "BATELMAN LIFE ESTATE, RASHEL",
    "owner2": "",
    "current_taxes": 6059.27,
    "new_taxes_no_override": 6321.03,
    "override_total_1": 6500.38,
    "override_increase_1": 179.35
  },
  {
    "#": "41 Centre St, Unit 408 (082-20-29)",
    "$": 900600,
    "address": "41 Centre St, Unit 408",
    "parcel_id": "082-20-29",
    "owner1": "KARAS TR, KIERA L",
    "owner2": "",
    "current_taxes": 9222.14,
    "new_taxes_no_override": 9620.54,
    "override_total_1": 9893.51,
    "override_increase_1": 272.98
  },
  {
    "#": "50 Centre St, Unit 2 (083-01-01)",
    "$": 1645400,
    "address": "50 Centre St, Unit 2",
    "parcel_id": "083-01-01",
    "owner1": "SHERAK, DONALD L",
    "owner2": "",
    "current_taxes": 13213.96,
    "new_taxes_no_override": 13784.8,
    "override_total_1": 14175.94,
    "override_increase_1": 391.13
  },
  {
    "#": "51 Centre St (082-21-00)",
    "$": 2981400,
    "address": "51 Centre St",
    "parcel_id": "082-21-00",
    "owner1": "SANIEOFF, PARVIZ",
    "owner2": "",
    "current_taxes": 30529.54,
    "new_taxes_no_override": 31848.42,
    "override_total_1": 32752.09,
    "override_increase_1": 903.67
  },
  {
    "#": "53 Centre St (082-22-00)",
    "$": 2980700,
    "address": "53 Centre St",
    "parcel_id": "082-22-00",
    "owner1": "KROHN  ET AL TRS, HERBERT F",
    "owner2": "ROSENSTEIN TR, HARRIET C",
    "current_taxes": 26887.43,
    "new_taxes_no_override": 28048.97,
    "override_total_1": 28844.83,
    "override_increase_1": 795.87
  },
  {
    "#": "61 Centre St (082-23-00)",
    "$": 3143700,
    "address": "61 Centre St",
    "parcel_id": "082-23-00",
    "owner1": "PATEL, ASHTON & NIKUR",
    "owner2": "",
    "current_taxes": 28556.55,
    "new_taxes_no_override": 29790.19,
    "override_total_1": 30635.47,
    "override_increase_1": 845.27
  },
  {
    "#": "62 Centre St (080-04-00)",
    "$": 4252600,
    "address": "62 Centre St",
    "parcel_id": "080-04-00",
    "owner1": "LAGADINOS, KRIS J & GEORGIA",
    "owner2": "",
    "current_taxes": 43546.62,
    "new_taxes_no_override": 45427.83,
    "override_total_1": 46716.81,
    "override_increase_1": 1288.98
  },
  {
    "#": "69 Centre St, Unit 1 & P3-4 (081-06-02)",
    "$": 1893300,
    "address": "69 Centre St, Unit 1 & P3-4",
    "parcel_id": "081-06-02",
    "owner1": "SWARTZ, CHARLES & LINDA",
    "owner2": "",
    "current_taxes": 15752.46,
    "new_taxes_no_override": 16432.97,
    "override_total_1": 16899.24,
    "override_increase_1": 466.27
  },
  {
    "#": "70 Centre St (080-02-00)",
    "$": 20921000,
    "address": "70 Centre St",
    "parcel_id": "080-02-00",
    "owner1": "CENTREBROOK LTD PARTNERSHIP",
    "owner2": "",
    "current_taxes": 214231.04,
    "new_taxes_no_override": 223485.82,
    "override_total_1": 229827.06,
    "override_increase_1": 6341.24
  },
  {
    "#": "75 Centre St (081-07-00)",
    "$": 3292500,
    "address": "75 Centre St",
    "parcel_id": "081-07-00",
    "owner1": "WEINSTOCK, REBECCA L",
    "owner2": "HEFFESS, ALEJANDRO",
    "current_taxes": 30080.27,
    "new_taxes_no_override": 31379.74,
    "override_total_1": 32270.11,
    "override_increase_1": 890.38
  },
  {
    "#": "85 Centre St, Unit 3 (078-09-03)",
    "$": 1030100,
    "address": "85 Centre St, Unit 3",
    "parcel_id": "078-09-03",
    "owner1": "SOOHOO, LISA XU",
    "owner2": "",
    "current_taxes": 10548.22,
    "new_taxes_no_override": 11003.9,
    "override_total_1": 11316.13,
    "override_increase_1": 312.23
  },
  {
    "#": "87 Centre St, Unit 2 & P2 (078-09-02)",
    "$": 1109400,
    "address": "87 Centre St, Unit 2 & P2",
    "parcel_id": "078-09-02",
    "owner1": "AMES, ANDREW",
    "owner2": "",
    "current_taxes": 7725.32,
    "new_taxes_no_override": 8059.05,
    "override_total_1": 8287.72,
    "override_increase_1": 228.67
  },
  {
    "#": "89 Centre St, Unit 1  P1&13 (078-09-01)",
    "$": 1230900,
    "address": "89 Centre St, Unit 1  P1&13",
    "parcel_id": "078-09-01",
    "owner1": "ZHANG, SHI",
    "owner2": "",
    "current_taxes": 8969.48,
    "new_taxes_no_override": 9356.96,
    "override_total_1": 9622.46,
    "override_increase_1": 265.5
  },
  {
    "#": "93 Centre St, Unit 1 (078-12-03)",
    "$": 1417700,
    "address": "93 Centre St, Unit 1",
    "parcel_id": "078-12-03",
    "owner1": "LIU, MIN WEI & CHUEI YU",
    "owner2": "",
    "current_taxes": 10882.31,
    "new_taxes_no_override": 11352.43,
    "override_total_1": 11674.54,
    "override_increase_1": 322.12
  },
  {
    "#": "93 Centre St, Unit 2 (078-12-01)",
    "$": 1153300,
    "address": "93 Centre St, Unit 2",
    "parcel_id": "078-12-01",
    "owner1": "KARPEI, VALERY & EUGENIA",
    "owner2": "",
    "current_taxes": 8174.86,
    "new_taxes_no_override": 8528.01,
    "override_total_1": 8769.99,
    "override_increase_1": 241.98
  },
  {
    "#": "93 Centre St, Unit 3 (078-12-02)",
    "$": 1178500,
    "address": "93 Centre St, Unit 3",
    "parcel_id": "078-12-02",
    "owner1": "TAING, SCOTT BOU",
    "owner2": "WERNER, LILLIAN",
    "current_taxes": 8432.91,
    "new_taxes_no_override": 8797.21,
    "override_total_1": 9046.83,
    "override_increase_1": 249.61
  },
  {
    "#": "95 Centre St, Unit 1 (078-13-01)",
    "$": 1533300,
    "address": "95 Centre St, Unit 1",
    "parcel_id": "078-13-01",
    "owner1": "HARAN, MOHIT",
    "owner2": "SURANA, SHILPA",
    "current_taxes": 15700.99,
    "new_taxes_no_override": 16379.27,
    "override_total_1": 16844.02,
    "override_increase_1": 464.75
  },
  {
    "#": "95 Centre St, Unit 2 (078-13-02)",
    "$": 1267800,
    "address": "95 Centre St, Unit 2",
    "parcel_id": "078-13-02",
    "owner1": "KAMHOLTZ, AARON N",
    "owner2": "BELL, SAMARA",
    "current_taxes": 9347.34,
    "new_taxes_no_override": 9751.15,
    "override_total_1": 10027.83,
    "override_increase_1": 276.68
  },
  {
    "#": "95 Centre St, Unit 3 (078-13-03)",
    "$": 1273000,
    "address": "95 Centre St, Unit 3",
    "parcel_id": "078-13-03",
    "owner1": "KURTULUS, FIDAN ANA",
    "owner2": "",
    "current_taxes": 13035.52,
    "new_taxes_no_override": 13598.65,
    "override_total_1": 13984.51,
    "override_increase_1": 385.85
  },
  {
    "#": "97 Centre St (078-14-00)",
    "$": 2928000,
    "address": "97 Centre St",
    "parcel_id": "078-14-00",
    "owner1": "LIU, TR, MICHAEL CHUNG NGOK",
    "owner2": "",
    "current_taxes": 29982.72,
    "new_taxes_no_override": 31277.97,
    "override_total_1": 32165.46,
    "override_increase_1": 887.49
  },
  {
    "#": "100 Centre St (079-01-00)",
    "$": 40204300,
    "address": "100 Centre St",
    "parcel_id": "079-01-00",
    "owner1": "HRCA BROOKLINE HOUSING",
    "owner2": "",
    "current_taxes": 411692.03,
    "new_taxes_no_override": 429477.13,
    "override_total_1": 441663.21,
    "override_increase_1": 12186.08
  },
  {
    "#": "103 Centre St, Unit 103 (078-15-01)",
    "$": 2361900,
    "address": "103 Centre St, Unit 103",
    "parcel_id": "078-15-01",
    "owner1": "DARLAND, WENDY",
    "owner2": "FARMAN, SUZANNE",
    "current_taxes": 20550.92,
    "new_taxes_no_override": 21438.72,
    "override_total_1": 22047.03,
    "override_increase_1": 608.31
  },
  {
    "#": "105 Centre St, Unit 105 (078-15-02)",
    "$": 2139100,
    "address": "105 Centre St, Unit 105",
    "parcel_id": "078-15-02",
    "owner1": "MULLEN, JENNIFER",
    "owner2": "CALABRO, MATHEW",
    "current_taxes": 18269.45,
    "new_taxes_no_override": 19058.69,
    "override_total_1": 19599.47,
    "override_increase_1": 540.78
  },
  {
    "#": "107 Centre St, Unit 107A (078-16-01)",
    "$": 1415100,
    "address": "107 Centre St, Unit 107A",
    "parcel_id": "078-16-01",
    "owner1": "GRAU, ZAKARY & MINA MANOLOVA",
    "owner2": "",
    "current_taxes": 10855.69,
    "new_taxes_no_override": 11324.66,
    "override_total_1": 11645.98,
    "override_increase_1": 321.33
  },
  {
    "#": "107 Centre St, Unit 107B (078-16-02)",
    "$": 1376600,
    "address": "107 Centre St, Unit 107B",
    "parcel_id": "078-16-02",
    "owner1": "CHU, WEN-YING",
    "owner2": "",
    "current_taxes": 10461.45,
    "new_taxes_no_override": 10913.38,
    "override_total_1": 11223.04,
    "override_increase_1": 309.66
  },
  {
    "#": "108 Centre St (079-20-00)",
    "$": 9256600,
    "address": "108 Centre St",
    "parcel_id": "079-20-00",
    "owner1": "HSL 108 CENTRE LLC",
    "owner2": "C/O HEBREW SENIORLIFE INC",
    "current_taxes": 94787.58,
    "new_taxes_no_override": 98882.4,
    "override_total_1": 101688.12,
    "override_increase_1": 2805.71
  },
  {
    "#": "109 Centre St, Unit 109A (078-16-03)",
    "$": 1529400,
    "address": "109 Centre St, Unit 109A",
    "parcel_id": "078-16-03",
    "owner1": "MCFOWLAND , EDWARD III",
    "owner2": "MAROTTA, VERONICA",
    "current_taxes": 12026.12,
    "new_taxes_no_override": 12545.65,
    "override_total_1": 12901.62,
    "override_increase_1": 355.97
  },
  {
    "#": "109 Centre St, Unit 109B (078-16-04)",
    "$": 1386500,
    "address": "109 Centre St, Unit 109B",
    "parcel_id": "078-16-04",
    "owner1": "NOKED TR, SARAH SONNENFELD",
    "owner2": "",
    "current_taxes": 14197.76,
    "new_taxes_no_override": 14811.1,
    "override_total_1": 15231.36,
    "override_increase_1": 420.25
  },
  {
    "#": "111 Centre St, Unit 111A & G7 (078-16-05)",
    "$": 1456900,
    "address": "111 Centre St, Unit 111A & G7",
    "parcel_id": "078-16-05",
    "owner1": "KAWESCH, LANCE A",
    "owner2": "",
    "current_taxes": 14918.66,
    "new_taxes_no_override": 15563.15,
    "override_total_1": 16004.74,
    "override_increase_1": 441.59
  },
  {
    "#": "111 Centre St, Unit 111B & G8 (078-16-06)",
    "$": 1500100,
    "address": "111 Centre St, Unit 111B & G8",
    "parcel_id": "078-16-06",
    "owner1": "HARRIS, PAUL EUGENE",
    "owner2": "STRECKER, MARY",
    "current_taxes": 11726.09,
    "new_taxes_no_override": 12232.66,
    "override_total_1": 12579.75,
    "override_increase_1": 347.09
  },
  {
    "#": "113 Centre St, Unit 113A (078-16-07)",
    "$": 1445600,
    "address": "113 Centre St, Unit 113A",
    "parcel_id": "078-16-07",
    "owner1": "GREINER, ASHLEY",
    "owner2": "GORDON, JEREMY",
    "current_taxes": 11168.01,
    "new_taxes_no_override": 11650.47,
    "override_total_1": 11981.04,
    "override_increase_1": 330.57
  },
  {
    "#": "113 Centre St, Unit 113B (078-16-08)",
    "$": 1331400,
    "address": "113 Centre St, Unit 113B",
    "parcel_id": "078-16-08",
    "owner1": "HOGENBOOM, DANIEL O",
    "owner2": "SASSAROLI, ELISABETTA",
    "current_taxes": 9998.6,
    "new_taxes_no_override": 10430.54,
    "override_total_1": 10726.5,
    "override_increase_1": 295.96
  },
  {
    "#": "120 Centre St (079-16-19)",
    "$": 24369000,
    "address": "120 Centre St",
    "parcel_id": "079-16-19",
    "owner1": "HRCA BROOKLINE HOUSING",
    "owner2": "",
    "current_taxes": 249538.56,
    "new_taxes_no_override": 260318.63,
    "override_total_1": 267704.97,
    "override_increase_1": 7386.34
  },
  {
    "#": "121 Centre St, Unit 201 G17-18 (078-17-01)",
    "$": 1176200,
    "address": "121 Centre St, Unit 201 G17-18",
    "parcel_id": "078-17-01",
    "owner1": "DEANGELO, DANIEL & ILENE & ROBERT",
    "owner2": "",
    "current_taxes": 8409.35,
    "new_taxes_no_override": 8772.63,
    "override_total_1": 9021.55,
    "override_increase_1": 248.92
  },
  {
    "#": "121 Centre St, Unit 202 & G7 (078-17-02)",
    "$": 1043000,
    "address": "121 Centre St, Unit 202 & G7",
    "parcel_id": "078-17-02",
    "owner1": "LIPOVETSKIY, SVETLANA",
    "owner2": "",
    "current_taxes": 7045.39,
    "new_taxes_no_override": 7349.75,
    "override_total_1": 7558.29,
    "override_increase_1": 208.54
  },
  {
    "#": "121 Centre St, Unit 203 G11-13 (078-17-03)",
    "$": 1113500,
    "address": "121 Centre St, Unit 203 G11-13",
    "parcel_id": "078-17-03",
    "owner1": "COOLIDGE CORNER UNIT 203 LLC",
    "owner2": "",
    "current_taxes": 11402.24,
    "new_taxes_no_override": 11894.82,
    "override_total_1": 12232.32,
    "override_increase_1": 337.51
  },
  {
    "#": "121 Centre St, Unit 301 & G4-5 (078-17-04)",
    "$": 1176200,
    "address": "121 Centre St, Unit 301 & G4-5",
    "parcel_id": "078-17-04",
    "owner1": "JAIN, ABISHEK & RACHANA VORA",
    "owner2": "",
    "current_taxes": 12044.29,
    "new_taxes_no_override": 12564.6,
    "override_total_1": 12921.11,
    "override_increase_1": 356.51
  },
  {
    "#": "121 Centre St, Unit 302 & G1 (078-17-05)",
    "$": 1043000,
    "address": "121 Centre St, Unit 302 & G1",
    "parcel_id": "078-17-05",
    "owner1": "SOHEILIAN TRS, RASAM & RAHAM",
    "owner2": "",
    "current_taxes": 7045.39,
    "new_taxes_no_override": 7349.75,
    "override_total_1": 7558.29,
    "override_increase_1": 208.54
  },
  {
    "#": "121 Centre St, Unit 303 & G8-9 (078-17-06)",
    "$": 1113500,
    "address": "121 Centre St, Unit 303 & G8-9",
    "parcel_id": "078-17-06",
    "owner1": "KENNEDY TR, SHARON C",
    "owner2": "",
    "current_taxes": 11402.24,
    "new_taxes_no_override": 11894.82,
    "override_total_1": 12232.32,
    "override_increase_1": 337.51
  },
  {
    "#": "121 Centre St, Unit Garage 10 (078-17-11)",
    "$": 90800,
    "address": "121 Centre St, Unit Garage 10",
    "parcel_id": "078-17-11",
    "owner1": "HARAN, MOHIT",
    "owner2": "SURANA, SHILPA",
    "current_taxes": 929.79,
    "new_taxes_no_override": 969.96,
    "override_total_1": 997.48,
    "override_increase_1": 27.52
  },
  {
    "#": "121 Centre St, Unit Garage 12 (078-17-10)",
    "$": 90800,
    "address": "121 Centre St, Unit Garage 12",
    "parcel_id": "078-17-10",
    "owner1": "KURTULUS, FIDAN ANA",
    "owner2": "",
    "current_taxes": 929.79,
    "new_taxes_no_override": 969.96,
    "override_total_1": 997.48,
    "override_increase_1": 27.52
  },
  {
    "#": "121 Centre St, Unit Ph1 & G2-3 (078-17-07)",
    "$": 1176200,
    "address": "121 Centre St, Unit Ph1 & G2-3",
    "parcel_id": "078-17-07",
    "owner1": "FRYE, RUSSELL H",
    "owner2": "",
    "current_taxes": 12044.29,
    "new_taxes_no_override": 12564.6,
    "override_total_1": 12921.11,
    "override_increase_1": 356.51
  },
  {
    "#": "121 Centre St, Unit Ph2 G14-15 (078-17-08)",
    "$": 1151400,
    "address": "121 Centre St, Unit Ph2 G14-15",
    "parcel_id": "078-17-08",
    "owner1": "ROBINSON LIFE ESTATE, ESTHER",
    "owner2": "",
    "current_taxes": 11790.34,
    "new_taxes_no_override": 12299.68,
    "override_total_1": 12648.68,
    "override_increase_1": 348.99
  },
  {
    "#": "121 Centre St, Unit Ph3 G6-16 (078-17-09)",
    "$": 1113500,
    "address": "121 Centre St, Unit Ph3 G6-16",
    "parcel_id": "078-17-09",
    "owner1": "KAYITI, PRATIMA & SUNIL",
    "owner2": "",
    "current_taxes": 11402.24,
    "new_taxes_no_override": 11894.82,
    "override_total_1": 12232.32,
    "override_increase_1": 337.51
  },
  {
    "#": "123 Centre St (078-18-00)",
    "$": 3077300,
    "address": "123 Centre St",
    "parcel_id": "078-18-00",
    "owner1": "SIMESTER, DUNCAN & SANDRA",
    "owner2": "",
    "current_taxes": 31511.55,
    "new_taxes_no_override": 32872.85,
    "override_total_1": 33805.59,
    "override_increase_1": 932.74
  },
  {
    "#": "129 Centre St (078-19-00)",
    "$": 2982700,
    "address": "129 Centre St",
    "parcel_id": "078-19-00",
    "owner1": "ADAMS TR, ERNEST C",
    "owner2": "",
    "current_taxes": 26907.91,
    "new_taxes_no_override": 28070.33,
    "override_total_1": 28866.81,
    "override_increase_1": 796.47
  },
  {
    "#": "4 Channing Rd (255-01-01)",
    "$": 5376800,
    "address": "4 Channing Rd",
    "parcel_id": "255-01-01",
    "owner1": "SAKOULIS TRS, GEORGIOS",
    "owner2": "KHOEI, BRANDI",
    "current_taxes": 55058.43,
    "new_taxes_no_override": 57436.95,
    "override_total_1": 59066.68,
    "override_increase_1": 1629.73
  },
  {
    "#": "14 Channing Rd (255-12-00)",
    "$": 4670600,
    "address": "14 Channing Rd",
    "parcel_id": "255-12-00",
    "owner1": "JONES, DAVID A",
    "owner2": "VREELAND, CYNTHIA D",
    "current_taxes": 44192.01,
    "new_taxes_no_override": 46101.1,
    "override_total_1": 47409.19,
    "override_increase_1": 1308.08
  },
  {
    "#": "19 Channing Rd (256-04-00)",
    "$": 5565300,
    "address": "19 Channing Rd",
    "parcel_id": "256-04-00",
    "owner1": "TABOR, STANLEY & NATHALIE",
    "owner2": "",
    "current_taxes": 53353.74,
    "new_taxes_no_override": 55658.62,
    "override_total_1": 57237.89,
    "override_increase_1": 1579.27
  },
  {
    "#": "27 Channing Rd (256-05-00)",
    "$": 3970700,
    "address": "27 Channing Rd",
    "parcel_id": "256-05-00",
    "owner1": "GHOMIZADEH, MOHAMMAD H M",
    "owner2": "NAKHAEI, ROUHANGIZ",
    "current_taxes": 37025.03,
    "new_taxes_no_override": 38624.51,
    "override_total_1": 39720.45,
    "override_increase_1": 1095.94
  },
  {
    "#": "30 Channing Rd (255-10-00)",
    "$": 4066000,
    "address": "30 Channing Rd",
    "parcel_id": "255-10-00",
    "owner1": "ALLEN, RICHARD E & ALICE",
    "owner2": "",
    "current_taxes": 38000.91,
    "new_taxes_no_override": 39642.55,
    "override_total_1": 40767.38,
    "override_increase_1": 1124.83
  },
  {
    "#": "38 Channing Rd (255-09-00)",
    "$": 3606000,
    "address": "38 Channing Rd",
    "parcel_id": "255-09-00",
    "owner1": "LIN, JARSHEN",
    "owner2": "LAI, MESOU",
    "current_taxes": 33290.51,
    "new_taxes_no_override": 34728.66,
    "override_total_1": 35714.06,
    "override_increase_1": 985.4
  },
  {
    "#": "46 Channing Rd (255-08-00)",
    "$": 2763000,
    "address": "46 Channing Rd",
    "parcel_id": "255-08-00",
    "owner1": "RINNE, MIKAEL L & TIFFANY",
    "owner2": "",
    "current_taxes": 24658.19,
    "new_taxes_no_override": 25723.42,
    "override_total_1": 26453.31,
    "override_increase_1": 729.88
  },
  {
    "#": "20 Chapel St, Unit A1001 (121D-04-73)",
    "$": 1217900,
    "address": "20 Chapel St, Unit A1001",
    "parcel_id": "121D-04-73",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 12471.3,
    "new_taxes_no_override": 13010.06,
    "override_total_1": 13379.21,
    "override_increase_1": 369.15
  },
  {
    "#": "20 Chapel St, Unit A1002 (121D-04-74)",
    "$": 1105700,
    "address": "20 Chapel St, Unit A1002",
    "parcel_id": "121D-04-74",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 11322.37,
    "new_taxes_no_override": 11811.5,
    "override_total_1": 12146.64,
    "override_increase_1": 335.14
  },
  {
    "#": "20 Chapel St, Unit A1003 (121D-04-75)",
    "$": 911000,
    "address": "20 Chapel St, Unit A1003",
    "parcel_id": "121D-04-75",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 9328.64,
    "new_taxes_no_override": 9731.64,
    "override_total_1": 10007.76,
    "override_increase_1": 276.13
  },
  {
    "#": "20 Chapel St, Unit A1004 (121D-04-76)",
    "$": 898200,
    "address": "20 Chapel St, Unit A1004",
    "parcel_id": "121D-04-76",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 9197.57,
    "new_taxes_no_override": 9594.91,
    "override_total_1": 9867.15,
    "override_increase_1": 272.25
  },
  {
    "#": "20 Chapel St, Unit A1005 (121D-04-77)",
    "$": 898200,
    "address": "20 Chapel St, Unit A1005",
    "parcel_id": "121D-04-77",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 9197.57,
    "new_taxes_no_override": 9594.91,
    "override_total_1": 9867.15,
    "override_increase_1": 272.25
  },
  {
    "#": "20 Chapel St, Unit A1006 (121D-04-78)",
    "$": 911000,
    "address": "20 Chapel St, Unit A1006",
    "parcel_id": "121D-04-78",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 9328.64,
    "new_taxes_no_override": 9731.64,
    "override_total_1": 10007.76,
    "override_increase_1": 276.13
  },
  {
    "#": "20 Chapel St, Unit A1007 (121D-04-79)",
    "$": 922600,
    "address": "20 Chapel St, Unit A1007",
    "parcel_id": "121D-04-79",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 9447.42,
    "new_taxes_no_override": 9855.55,
    "override_total_1": 10135.19,
    "override_increase_1": 279.64
  },
  {
    "#": "20 Chapel St, Unit A1008 (121D-04-80)",
    "$": 911000,
    "address": "20 Chapel St, Unit A1008",
    "parcel_id": "121D-04-80",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 9328.64,
    "new_taxes_no_override": 9731.64,
    "override_total_1": 10007.76,
    "override_increase_1": 276.13
  },
  {
    "#": "20 Chapel St, Unit A1009 (121D-04-81)",
    "$": 1277000,
    "address": "20 Chapel St, Unit A1009",
    "parcel_id": "121D-04-81",
    "owner1": "ALDEN VIEW LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 13076.48,
    "new_taxes_no_override": 13641.38,
    "override_total_1": 14028.45,
    "override_increase_1": 387.06
  },
  {
    "#": "20 Chapel St, Unit A1010 (121D-04-82)",
    "$": 1102800,
    "address": "20 Chapel St, Unit A1010",
    "parcel_id": "121D-04-82",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 11292.67,
    "new_taxes_no_override": 11780.51,
    "override_total_1": 12114.78,
    "override_increase_1": 334.26
  },
  {
    "#": "20 Chapel St, Unit A301 (121D-04-01)",
    "$": 501800,
    "address": "20 Chapel St, Unit A301",
    "parcel_id": "121D-04-01",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 5138.43,
    "new_taxes_no_override": 5360.41,
    "override_total_1": 5512.51,
    "override_increase_1": 152.1
  },
  {
    "#": "20 Chapel St, Unit A302 (121D-04-02)",
    "$": 575700,
    "address": "20 Chapel St, Unit A302",
    "parcel_id": "121D-04-02",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 5895.17,
    "new_taxes_no_override": 6149.84,
    "override_total_1": 6324.34,
    "override_increase_1": 174.5
  },
  {
    "#": "20 Chapel St, Unit A303 (121D-04-03)",
    "$": 726300,
    "address": "20 Chapel St, Unit A303",
    "parcel_id": "121D-04-03",
    "owner1": "CARPENITO TRS, HENRY F & NATALIYA V",
    "owner2": "",
    "current_taxes": 7437.31,
    "new_taxes_no_override": 7758.6,
    "override_total_1": 7978.75,
    "override_increase_1": 220.14
  },
  {
    "#": "20 Chapel St, Unit A304 (121D-04-04)",
    "$": 602000,
    "address": "20 Chapel St, Unit A304",
    "parcel_id": "121D-04-04",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 6164.48,
    "new_taxes_no_override": 6430.79,
    "override_total_1": 6613.25,
    "override_increase_1": 182.47
  },
  {
    "#": "20 Chapel St, Unit A305 (121D-04-05)",
    "$": 599900,
    "address": "20 Chapel St, Unit A305",
    "parcel_id": "121D-04-05",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 6142.98,
    "new_taxes_no_override": 6408.36,
    "override_total_1": 6590.19,
    "override_increase_1": 181.83
  },
  {
    "#": "20 Chapel St, Unit A306 (121D-04-06)",
    "$": 632400,
    "address": "20 Chapel St, Unit A306",
    "parcel_id": "121D-04-06",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 6475.78,
    "new_taxes_no_override": 6755.53,
    "override_total_1": 6947.22,
    "override_increase_1": 191.68
  },
  {
    "#": "20 Chapel St, Unit A307 (121D-04-07)",
    "$": 632400,
    "address": "20 Chapel St, Unit A307",
    "parcel_id": "121D-04-07",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 6475.78,
    "new_taxes_no_override": 6755.53,
    "override_total_1": 6947.22,
    "override_increase_1": 191.68
  },
  {
    "#": "20 Chapel St, Unit A308 (121D-04-08)",
    "$": 630400,
    "address": "20 Chapel St, Unit A308",
    "parcel_id": "121D-04-08",
    "owner1": "WINGJIRANIRUN, MANIDA & NIRAMON",
    "owner2": "",
    "current_taxes": 6455.3,
    "new_taxes_no_override": 6734.17,
    "override_total_1": 6925.25,
    "override_increase_1": 191.08
  },
  {
    "#": "20 Chapel St, Unit A309 (121D-04-09)",
    "$": 401100,
    "address": "20 Chapel St, Unit A309",
    "parcel_id": "121D-04-09",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 4107.26,
    "new_taxes_no_override": 4284.69,
    "override_total_1": 4406.27,
    "override_increase_1": 121.57
  },
  {
    "#": "20 Chapel St, Unit A310 (121D-04-10)",
    "$": 655300,
    "address": "20 Chapel St, Unit A310",
    "parcel_id": "121D-04-10",
    "owner1": "SMITH, LEE Q",
    "owner2": "",
    "current_taxes": 3075.34,
    "new_taxes_no_override": 3208.19,
    "override_total_1": 3299.22,
    "override_increase_1": 91.03
  },
  {
    "#": "20 Chapel St, Unit A311 (121D-04-11)",
    "$": 425700,
    "address": "20 Chapel St, Unit A311",
    "parcel_id": "121D-04-11",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 4359.17,
    "new_taxes_no_override": 4547.49,
    "override_total_1": 4676.52,
    "override_increase_1": 129.03
  },
  {
    "#": "20 Chapel St, Unit A312 (121D-04-12)",
    "$": 767500,
    "address": "20 Chapel St, Unit A312",
    "parcel_id": "121D-04-12",
    "owner1": "RAPPAPORT, ALLISON",
    "owner2": "",
    "current_taxes": 7859.2,
    "new_taxes_no_override": 8198.72,
    "override_total_1": 8431.35,
    "override_increase_1": 232.63
  },
  {
    "#": "20 Chapel St, Unit A401 (121D-04-13)",
    "$": 1183900,
    "address": "20 Chapel St, Unit A401",
    "parcel_id": "121D-04-13",
    "owner1": "SHIMADA, NAOKI & MIDORI",
    "owner2": "",
    "current_taxes": 12123.14,
    "new_taxes_no_override": 12646.86,
    "override_total_1": 13005.7,
    "override_increase_1": 358.84
  },
  {
    "#": "20 Chapel St, Unit A402 (121D-04-14)",
    "$": 1045500,
    "address": "20 Chapel St, Unit A402",
    "parcel_id": "121D-04-14",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 10705.92,
    "new_taxes_no_override": 11168.42,
    "override_total_1": 11485.31,
    "override_increase_1": 316.9
  },
  {
    "#": "20 Chapel St, Unit A403 (121D-04-15)",
    "$": 725300,
    "address": "20 Chapel St, Unit A403",
    "parcel_id": "121D-04-15",
    "owner1": "BERIK, ANNA",
    "owner2": "WALSH, SAMANTHA",
    "current_taxes": 7427.07,
    "new_taxes_no_override": 7747.92,
    "override_total_1": 7967.76,
    "override_increase_1": 219.84
  },
  {
    "#": "20 Chapel St, Unit A404 (121D-04-16)",
    "$": 790100,
    "address": "20 Chapel St, Unit A404",
    "parcel_id": "121D-04-16",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 8090.62,
    "new_taxes_no_override": 8440.13,
    "override_total_1": 8679.62,
    "override_increase_1": 239.48
  },
  {
    "#": "20 Chapel St, Unit A405 (121D-04-17)",
    "$": 790100,
    "address": "20 Chapel St, Unit A405",
    "parcel_id": "121D-04-17",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 8090.62,
    "new_taxes_no_override": 8440.13,
    "override_total_1": 8679.62,
    "override_increase_1": 239.48
  },
  {
    "#": "20 Chapel St, Unit A406 (121D-04-18)",
    "$": 801100,
    "address": "20 Chapel St, Unit A406",
    "parcel_id": "121D-04-18",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 8203.26,
    "new_taxes_no_override": 8557.64,
    "override_total_1": 8800.46,
    "override_increase_1": 242.82
  },
  {
    "#": "20 Chapel St, Unit A407 (121D-04-19)",
    "$": 810900,
    "address": "20 Chapel St, Unit A407",
    "parcel_id": "121D-04-19",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 8303.62,
    "new_taxes_no_override": 8662.34,
    "override_total_1": 8908.12,
    "override_increase_1": 245.79
  },
  {
    "#": "20 Chapel St, Unit A408 (121D-04-20)",
    "$": 801100,
    "address": "20 Chapel St, Unit A408",
    "parcel_id": "121D-04-20",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 8203.26,
    "new_taxes_no_override": 8557.64,
    "override_total_1": 8800.46,
    "override_increase_1": 242.82
  },
  {
    "#": "20 Chapel St, Unit A409 (121D-04-21)",
    "$": 1161500,
    "address": "20 Chapel St, Unit A409",
    "parcel_id": "121D-04-21",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 11893.76,
    "new_taxes_no_override": 12407.57,
    "override_total_1": 12759.63,
    "override_increase_1": 352.06
  },
  {
    "#": "20 Chapel St, Unit A410 (121D-04-22)",
    "$": 1042800,
    "address": "20 Chapel St, Unit A410",
    "parcel_id": "121D-04-22",
    "owner1": "YNA PROPERTIES LLC",
    "owner2": "C/O BOSTON CONDOMINIUM MGMT",
    "current_taxes": 10678.27,
    "new_taxes_no_override": 11139.57,
    "override_total_1": 11455.65,
    "override_increase_1": 316.08
  },
  {
    "#": "20 Chapel St, Unit A501 (121D-04-23)",
    "$": 1217900,
    "address": "20 Chapel St, Unit A501",
    "parcel_id": "121D-04-23",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 12471.3,
    "new_taxes_no_override": 13010.06,
    "override_total_1": 13379.21,
    "override_increase_1": 369.15
  },
  {
    "#": "20 Chapel St, Unit A502 (121D-04-24)",
    "$": 1105800,
    "address": "20 Chapel St, Unit A502",
    "parcel_id": "121D-04-24",
    "owner1": "MURRAY, JOHN S",
    "owner2": "",
    "current_taxes": 7688.46,
    "new_taxes_no_override": 8020.6,
    "override_total_1": 8248.18,
    "override_increase_1": 227.58
  },
  {
    "#": "20 Chapel St, Unit A503 (121D-04-25)",
    "$": 787900,
    "address": "20 Chapel St, Unit A503",
    "parcel_id": "121D-04-25",
    "owner1": "WANG, HONG",
    "owner2": "",
    "current_taxes": 8068.1,
    "new_taxes_no_override": 8416.64,
    "override_total_1": 8655.46,
    "override_increase_1": 238.82
  },
  {
    "#": "20 Chapel St, Unit A504 (121D-04-26)",
    "$": 898200,
    "address": "20 Chapel St, Unit A504",
    "parcel_id": "121D-04-26",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 9197.57,
    "new_taxes_no_override": 9594.91,
    "override_total_1": 9867.15,
    "override_increase_1": 272.25
  },
  {
    "#": "20 Chapel St, Unit A505 (121D-04-27)",
    "$": 898200,
    "address": "20 Chapel St, Unit A505",
    "parcel_id": "121D-04-27",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 9197.57,
    "new_taxes_no_override": 9594.91,
    "override_total_1": 9867.15,
    "override_increase_1": 272.25
  },
  {
    "#": "20 Chapel St, Unit A506 (121D-04-28)",
    "$": 889100,
    "address": "20 Chapel St, Unit A506",
    "parcel_id": "121D-04-28",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 9104.38,
    "new_taxes_no_override": 9497.69,
    "override_total_1": 9767.18,
    "override_increase_1": 269.49
  },
  {
    "#": "20 Chapel St, Unit A507 (121D-04-29)",
    "$": 922600,
    "address": "20 Chapel St, Unit A507",
    "parcel_id": "121D-04-29",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 9447.42,
    "new_taxes_no_override": 9855.55,
    "override_total_1": 10135.19,
    "override_increase_1": 279.64
  },
  {
    "#": "20 Chapel St, Unit A508 (121D-04-30)",
    "$": 889100,
    "address": "20 Chapel St, Unit A508",
    "parcel_id": "121D-04-30",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 9104.38,
    "new_taxes_no_override": 9497.69,
    "override_total_1": 9767.18,
    "override_increase_1": 269.49
  },
  {
    "#": "20 Chapel St, Unit A509 (121D-04-31)",
    "$": 1194900,
    "address": "20 Chapel St, Unit A509",
    "parcel_id": "121D-04-31",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 12235.78,
    "new_taxes_no_override": 12764.37,
    "override_total_1": 13126.54,
    "override_increase_1": 362.18
  },
  {
    "#": "20 Chapel St, Unit A510 (121D-04-32)",
    "$": 1020800,
    "address": "20 Chapel St, Unit A510",
    "parcel_id": "121D-04-32",
    "owner1": "LWOOD A510 LLC",
    "owner2": "",
    "current_taxes": 10452.99,
    "new_taxes_no_override": 10904.56,
    "override_total_1": 11213.97,
    "override_increase_1": 309.41
  },
  {
    "#": "20 Chapel St, Unit A601 (121D-04-33)",
    "$": 1300000,
    "address": "20 Chapel St, Unit A601",
    "parcel_id": "121D-04-33",
    "owner1": "LONGWOOD PROPERTY HOLDINGS LLC",
    "owner2": "",
    "current_taxes": 13312.0,
    "new_taxes_no_override": 13887.08,
    "override_total_1": 14281.11,
    "override_increase_1": 394.04
  },
  {
    "#": "20 Chapel St, Unit A602 (121D-04-34)",
    "$": 1023700,
    "address": "20 Chapel St, Unit A602",
    "parcel_id": "121D-04-34",
    "owner1": "MACIAS, ALVARO A",
    "owner2": "NEIRA, JENNIFER MARIE",
    "current_taxes": 10482.69,
    "new_taxes_no_override": 10935.54,
    "override_total_1": 11245.83,
    "override_increase_1": 310.29
  },
  {
    "#": "20 Chapel St, Unit A603 (121D-04-35)",
    "$": 911100,
    "address": "20 Chapel St, Unit A603",
    "parcel_id": "121D-04-35",
    "owner1": "LTOWERS A603 LLC",
    "owner2": "",
    "current_taxes": 9329.66,
    "new_taxes_no_override": 9732.7,
    "override_total_1": 10008.86,
    "override_increase_1": 276.16
  },
  {
    "#": "20 Chapel St, Unit A604 (121D-04-36)",
    "$": 898200,
    "address": "20 Chapel St, Unit A604",
    "parcel_id": "121D-04-36",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 9197.57,
    "new_taxes_no_override": 9594.91,
    "override_total_1": 9867.15,
    "override_increase_1": 272.25
  },
  {
    "#": "20 Chapel St, Unit A605 (121D-04-37)",
    "$": 898200,
    "address": "20 Chapel St, Unit A605",
    "parcel_id": "121D-04-37",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 9197.57,
    "new_taxes_no_override": 9594.91,
    "override_total_1": 9867.15,
    "override_increase_1": 272.25
  },
  {
    "#": "20 Chapel St, Unit A606 (121D-04-38)",
    "$": 911000,
    "address": "20 Chapel St, Unit A606",
    "parcel_id": "121D-04-38",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 9328.64,
    "new_taxes_no_override": 9731.64,
    "override_total_1": 10007.76,
    "override_increase_1": 276.13
  },
  {
    "#": "20 Chapel St, Unit A607 (121D-04-39)",
    "$": 922600,
    "address": "20 Chapel St, Unit A607",
    "parcel_id": "121D-04-39",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 9447.42,
    "new_taxes_no_override": 9855.55,
    "override_total_1": 10135.19,
    "override_increase_1": 279.64
  },
  {
    "#": "20 Chapel St, Unit A608 (121D-04-40)",
    "$": 911000,
    "address": "20 Chapel St, Unit A608",
    "parcel_id": "121D-04-40",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 9328.64,
    "new_taxes_no_override": 9731.64,
    "override_total_1": 10007.76,
    "override_increase_1": 276.13
  },
  {
    "#": "20 Chapel St, Unit A609 (121D-04-41)",
    "$": 1194900,
    "address": "20 Chapel St, Unit A609",
    "parcel_id": "121D-04-41",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 12235.78,
    "new_taxes_no_override": 12764.37,
    "override_total_1": 13126.54,
    "override_increase_1": 362.18
  },
  {
    "#": "20 Chapel St, Unit A610 (121D-04-42)",
    "$": 1020800,
    "address": "20 Chapel St, Unit A610",
    "parcel_id": "121D-04-42",
    "owner1": "AMINI, ALEXANDER",
    "owner2": "SOLEIMANY, AVA",
    "current_taxes": 6818.06,
    "new_taxes_no_override": 7112.6,
    "override_total_1": 7314.41,
    "override_increase_1": 201.81
  },
  {
    "#": "20 Chapel St, Unit A701 (121D-04-43)",
    "$": 1217900,
    "address": "20 Chapel St, Unit A701",
    "parcel_id": "121D-04-43",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 12471.3,
    "new_taxes_no_override": 13010.06,
    "override_total_1": 13379.21,
    "override_increase_1": 369.15
  },
  {
    "#": "20 Chapel St, Unit A702 (121D-04-44)",
    "$": 1105700,
    "address": "20 Chapel St, Unit A702",
    "parcel_id": "121D-04-44",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 11322.37,
    "new_taxes_no_override": 11811.5,
    "override_total_1": 12146.64,
    "override_increase_1": 335.14
  },
  {
    "#": "20 Chapel St, Unit A703 (121D-04-45)",
    "$": 911200,
    "address": "20 Chapel St, Unit A703",
    "parcel_id": "121D-04-45",
    "owner1": "GFP MANAGEMENT LLC",
    "owner2": "",
    "current_taxes": 9330.69,
    "new_taxes_no_override": 9733.78,
    "override_total_1": 10009.96,
    "override_increase_1": 276.19
  },
  {
    "#": "20 Chapel St, Unit A704 (121D-04-46)",
    "$": 898300,
    "address": "20 Chapel St, Unit A704",
    "parcel_id": "121D-04-46",
    "owner1": "TIMBUSH INVESTMENTS LLC",
    "owner2": "",
    "current_taxes": 9198.59,
    "new_taxes_no_override": 9595.97,
    "override_total_1": 9868.25,
    "override_increase_1": 272.28
  },
  {
    "#": "20 Chapel St, Unit A705 (121D-04-47)",
    "$": 898200,
    "address": "20 Chapel St, Unit A705",
    "parcel_id": "121D-04-47",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 9197.57,
    "new_taxes_no_override": 9594.91,
    "override_total_1": 9867.15,
    "override_increase_1": 272.25
  },
  {
    "#": "20 Chapel St, Unit A706 (121D-04-48)",
    "$": 911000,
    "address": "20 Chapel St, Unit A706",
    "parcel_id": "121D-04-48",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 9328.64,
    "new_taxes_no_override": 9731.64,
    "override_total_1": 10007.76,
    "override_increase_1": 276.13
  },
  {
    "#": "20 Chapel St, Unit A707 (121D-04-49)",
    "$": 922600,
    "address": "20 Chapel St, Unit A707",
    "parcel_id": "121D-04-49",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 9447.42,
    "new_taxes_no_override": 9855.55,
    "override_total_1": 10135.19,
    "override_increase_1": 279.64
  },
  {
    "#": "20 Chapel St, Unit A708 (121D-04-50)",
    "$": 911000,
    "address": "20 Chapel St, Unit A708",
    "parcel_id": "121D-04-50",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 9328.64,
    "new_taxes_no_override": 9731.64,
    "override_total_1": 10007.76,
    "override_increase_1": 276.13
  },
  {
    "#": "20 Chapel St, Unit A709 (121D-04-51)",
    "$": 1194900,
    "address": "20 Chapel St, Unit A709",
    "parcel_id": "121D-04-51",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 12235.78,
    "new_taxes_no_override": 12764.37,
    "override_total_1": 13126.54,
    "override_increase_1": 362.18
  },
  {
    "#": "20 Chapel St, Unit A710 (121D-04-52)",
    "$": 1102900,
    "address": "20 Chapel St, Unit A710",
    "parcel_id": "121D-04-52",
    "owner1": "CHUN, SUN YOUNG",
    "owner2": "",
    "current_taxes": 7658.76,
    "new_taxes_no_override": 7989.62,
    "override_total_1": 8216.32,
    "override_increase_1": 226.7
  },
  {
    "#": "20 Chapel St, Unit A801 (121D-04-53)",
    "$": 1188300,
    "address": "20 Chapel St, Unit A801",
    "parcel_id": "121D-04-53",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 12168.19,
    "new_taxes_no_override": 12693.86,
    "override_total_1": 13054.03,
    "override_increase_1": 360.18
  },
  {
    "#": "20 Chapel St, Unit A802 (121D-04-54)",
    "$": 1105700,
    "address": "20 Chapel St, Unit A802",
    "parcel_id": "121D-04-54",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 11322.37,
    "new_taxes_no_override": 11811.5,
    "override_total_1": 12146.64,
    "override_increase_1": 335.14
  },
  {
    "#": "20 Chapel St, Unit A803 (121D-04-55)",
    "$": 911000,
    "address": "20 Chapel St, Unit A803",
    "parcel_id": "121D-04-55",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 9328.64,
    "new_taxes_no_override": 9731.64,
    "override_total_1": 10007.76,
    "override_increase_1": 276.13
  },
  {
    "#": "20 Chapel St, Unit A804 (121D-04-56)",
    "$": 898200,
    "address": "20 Chapel St, Unit A804",
    "parcel_id": "121D-04-56",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 9197.57,
    "new_taxes_no_override": 9594.91,
    "override_total_1": 9867.15,
    "override_increase_1": 272.25
  },
  {
    "#": "20 Chapel St, Unit A805 (121D-04-57)",
    "$": 898200,
    "address": "20 Chapel St, Unit A805",
    "parcel_id": "121D-04-57",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 9197.57,
    "new_taxes_no_override": 9594.91,
    "override_total_1": 9867.15,
    "override_increase_1": 272.25
  },
  {
    "#": "20 Chapel St, Unit A806 (121D-04-58)",
    "$": 911000,
    "address": "20 Chapel St, Unit A806",
    "parcel_id": "121D-04-58",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 9328.64,
    "new_taxes_no_override": 9731.64,
    "override_total_1": 10007.76,
    "override_increase_1": 276.13
  },
  {
    "#": "20 Chapel St, Unit A807 (121D-04-59)",
    "$": 922600,
    "address": "20 Chapel St, Unit A807",
    "parcel_id": "121D-04-59",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 9447.42,
    "new_taxes_no_override": 9855.55,
    "override_total_1": 10135.19,
    "override_increase_1": 279.64
  },
  {
    "#": "20 Chapel St, Unit A808 (121D-04-60)",
    "$": 911000,
    "address": "20 Chapel St, Unit A808",
    "parcel_id": "121D-04-60",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 9328.64,
    "new_taxes_no_override": 9731.64,
    "override_total_1": 10007.76,
    "override_increase_1": 276.13
  },
  {
    "#": "20 Chapel St, Unit A809 (121D-04-61)",
    "$": 1194900,
    "address": "20 Chapel St, Unit A809",
    "parcel_id": "121D-04-61",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 12235.78,
    "new_taxes_no_override": 12764.37,
    "override_total_1": 13126.54,
    "override_increase_1": 362.18
  },
  {
    "#": "20 Chapel St, Unit A810 (121D-04-62)",
    "$": 1102800,
    "address": "20 Chapel St, Unit A810",
    "parcel_id": "121D-04-62",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 11292.67,
    "new_taxes_no_override": 11780.51,
    "override_total_1": 12114.78,
    "override_increase_1": 334.26
  },
  {
    "#": "20 Chapel St, Unit A901 (121D-04-63)",
    "$": 1217900,
    "address": "20 Chapel St, Unit A901",
    "parcel_id": "121D-04-63",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 12471.3,
    "new_taxes_no_override": 13010.06,
    "override_total_1": 13379.21,
    "override_increase_1": 369.15
  },
  {
    "#": "20 Chapel St, Unit A902 (121D-04-64)",
    "$": 1105700,
    "address": "20 Chapel St, Unit A902",
    "parcel_id": "121D-04-64",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 11322.37,
    "new_taxes_no_override": 11811.5,
    "override_total_1": 12146.64,
    "override_increase_1": 335.14
  },
  {
    "#": "20 Chapel St, Unit A903 (121D-04-65)",
    "$": 911000,
    "address": "20 Chapel St, Unit A903",
    "parcel_id": "121D-04-65",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 9328.64,
    "new_taxes_no_override": 9731.64,
    "override_total_1": 10007.76,
    "override_increase_1": 276.13
  },
  {
    "#": "20 Chapel St, Unit A904 (121D-04-66)",
    "$": 898200,
    "address": "20 Chapel St, Unit A904",
    "parcel_id": "121D-04-66",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 9197.57,
    "new_taxes_no_override": 9594.91,
    "override_total_1": 9867.15,
    "override_increase_1": 272.25
  },
  {
    "#": "20 Chapel St, Unit A905 (121D-04-67)",
    "$": 898200,
    "address": "20 Chapel St, Unit A905",
    "parcel_id": "121D-04-67",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 9197.57,
    "new_taxes_no_override": 9594.91,
    "override_total_1": 9867.15,
    "override_increase_1": 272.25
  },
  {
    "#": "20 Chapel St, Unit A906 (121D-04-68)",
    "$": 870000,
    "address": "20 Chapel St, Unit A906",
    "parcel_id": "121D-04-68",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 8908.8,
    "new_taxes_no_override": 9293.66,
    "override_total_1": 9557.36,
    "override_increase_1": 263.7
  },
  {
    "#": "20 Chapel St, Unit A907 (121D-04-69)",
    "$": 922600,
    "address": "20 Chapel St, Unit A907",
    "parcel_id": "121D-04-69",
    "owner1": "LION RIVER PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 9447.42,
    "new_taxes_no_override": 9855.55,
    "override_total_1": 10135.19,
    "override_increase_1": 279.64
  },
  {
    "#": "20 Chapel St, Unit A908 (121D-04-70)",
    "$": 870000,
    "address": "20 Chapel St, Unit A908",
    "parcel_id": "121D-04-70",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 8908.8,
    "new_taxes_no_override": 9293.66,
    "override_total_1": 9557.36,
    "override_increase_1": 263.7
  },
  {
    "#": "20 Chapel St, Unit A909 (121D-04-71)",
    "$": 1194900,
    "address": "20 Chapel St, Unit A909",
    "parcel_id": "121D-04-71",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 12235.78,
    "new_taxes_no_override": 12764.37,
    "override_total_1": 13126.54,
    "override_increase_1": 362.18
  },
  {
    "#": "20 Chapel St, Unit A910 (121D-04-72)",
    "$": 1102800,
    "address": "20 Chapel St, Unit A910",
    "parcel_id": "121D-04-72",
    "owner1": "ALDEN TOWER LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 11292.67,
    "new_taxes_no_override": 11780.51,
    "override_total_1": 12114.78,
    "override_increase_1": 334.26
  },
  {
    "#": "20 Chapel St, Unit Aph1 (121D-04-83)",
    "$": 3515200,
    "address": "20 Chapel St, Unit Aph1",
    "parcel_id": "121D-04-83",
    "owner1": "ALDEN VIEW LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 35995.65,
    "new_taxes_no_override": 37550.66,
    "override_total_1": 38616.13,
    "override_increase_1": 1065.47
  },
  {
    "#": "20 Chapel St, Unit Aph2 (121D-04-84)",
    "$": 2053800,
    "address": "20 Chapel St, Unit Aph2",
    "parcel_id": "121D-04-84",
    "owner1": "RUBENSTEIN, MICHAEL I & BONNIE J",
    "owner2": "",
    "current_taxes": 21030.91,
    "new_taxes_no_override": 21939.45,
    "override_total_1": 22561.96,
    "override_increase_1": 622.51
  },
  {
    "#": "20 Chapel St, Unit Aph3 (121D-04-85)",
    "$": 2172000,
    "address": "20 Chapel St, Unit Aph3",
    "parcel_id": "121D-04-85",
    "owner1": "LIU, HAITAO",
    "owner2": "",
    "current_taxes": 18606.35,
    "new_taxes_no_override": 19410.14,
    "override_total_1": 19960.89,
    "override_increase_1": 550.75
  },
  {
    "#": "20 Chapel St, Unit Aph4 (121D-04-86)",
    "$": 2615100,
    "address": "20 Chapel St, Unit Aph4",
    "parcel_id": "121D-04-86",
    "owner1": "ATLAS TR, ROBIN A",
    "owner2": "HERMAN TR, TALIA N",
    "current_taxes": 26778.62,
    "new_taxes_no_override": 27935.46,
    "override_total_1": 28728.1,
    "override_increase_1": 792.65
  },
  {
    "#": "20 Chapel St, Unit Aph5 (121D-04-87)",
    "$": 3391900,
    "address": "20 Chapel St, Unit Aph5",
    "parcel_id": "121D-04-87",
    "owner1": "PARIBOS INC",
    "owner2": "C/O SADKA AUDREY",
    "current_taxes": 34733.06,
    "new_taxes_no_override": 36233.53,
    "override_total_1": 37261.63,
    "override_increase_1": 1028.1
  },
  {
    "#": "20 Chapel St, Unit B1001 (121A-04-74)",
    "$": 885800,
    "address": "20 Chapel St, Unit B1001",
    "parcel_id": "121A-04-74",
    "owner1": "BEGARA, DIEGO",
    "owner2": "CRIADO, MARTA",
    "current_taxes": 9070.59,
    "new_taxes_no_override": 9462.44,
    "override_total_1": 9730.93,
    "override_increase_1": 268.49
  },
  {
    "#": "20 Chapel St, Unit B1003 (121B-04-84)",
    "$": 1632500,
    "address": "20 Chapel St, Unit B1003",
    "parcel_id": "121B-04-84",
    "owner1": "BRISS, BARRY S & ANN E",
    "owner2": "",
    "current_taxes": 13081.87,
    "new_taxes_no_override": 13647.01,
    "override_total_1": 14034.23,
    "override_increase_1": 387.22
  },
  {
    "#": "20 Chapel St, Unit B1004 (121A-04-77)",
    "$": 984100,
    "address": "20 Chapel St, Unit B1004",
    "parcel_id": "121A-04-77",
    "owner1": "XU, HONG",
    "owner2": "ZHAO, DAYAO",
    "current_taxes": 10077.18,
    "new_taxes_no_override": 10512.51,
    "override_total_1": 10810.8,
    "override_increase_1": 298.28
  },
  {
    "#": "20 Chapel St, Unit B1005 (121A-04-78)",
    "$": 623400,
    "address": "20 Chapel St, Unit B1005",
    "parcel_id": "121A-04-78",
    "owner1": "BERNHOLZ, MALTE",
    "owner2": "GIBBONS, EUGENIA",
    "current_taxes": 6383.62,
    "new_taxes_no_override": 6659.39,
    "override_total_1": 6848.35,
    "override_increase_1": 188.96
  },
  {
    "#": "20 Chapel St, Unit B1006 (121A-04-79)",
    "$": 608400,
    "address": "20 Chapel St, Unit B1006",
    "parcel_id": "121A-04-79",
    "owner1": "CAO, JENNIFER",
    "owner2": "WANG, VIVIAN",
    "current_taxes": 6230.02,
    "new_taxes_no_override": 6499.16,
    "override_total_1": 6683.57,
    "override_increase_1": 184.41
  },
  {
    "#": "20 Chapel St, Unit B1007 (121A-04-80)",
    "$": 1011200,
    "address": "20 Chapel St, Unit B1007",
    "parcel_id": "121A-04-80",
    "owner1": "SARTOR INVESTMENTS LLC",
    "owner2": "",
    "current_taxes": 10354.69,
    "new_taxes_no_override": 10802.01,
    "override_total_1": 11108.51,
    "override_increase_1": 306.5
  },
  {
    "#": "20 Chapel St, Unit B1008 (121A-04-81)",
    "$": 917400,
    "address": "20 Chapel St, Unit B1008",
    "parcel_id": "121A-04-81",
    "owner1": "SEQUEIRA TRS, REGINALD M & EMALYNN S",
    "owner2": "",
    "current_taxes": 9394.18,
    "new_taxes_no_override": 9800.01,
    "override_total_1": 10078.08,
    "override_increase_1": 278.07
  },
  {
    "#": "20 Chapel St, Unit B1009 (121A-04-82)",
    "$": 902000,
    "address": "20 Chapel St, Unit B1009",
    "parcel_id": "121A-04-82",
    "owner1": "SAFAR ET AL, AHMAD MAZEN",
    "owner2": "C/O FENWAY PROPERTY, M FOLEY",
    "current_taxes": 9236.48,
    "new_taxes_no_override": 9635.5,
    "override_total_1": 9908.9,
    "override_increase_1": 273.4
  },
  {
    "#": "20 Chapel St, Unit B1011 (121A-04-83)",
    "$": 1150500,
    "address": "20 Chapel St, Unit B1011",
    "parcel_id": "121A-04-83",
    "owner1": "ARKY, RONALD",
    "owner2": "",
    "current_taxes": 11781.12,
    "new_taxes_no_override": 12290.06,
    "override_total_1": 12638.79,
    "override_increase_1": 348.72
  },
  {
    "#": "20 Chapel St, Unit B1012 (121A-04-84)",
    "$": 1152600,
    "address": "20 Chapel St, Unit B1012",
    "parcel_id": "121A-04-84",
    "owner1": "GHARAVY TR, GOLLAM HASSAN",
    "owner2": "",
    "current_taxes": 11802.62,
    "new_taxes_no_override": 12312.49,
    "override_total_1": 12661.85,
    "override_increase_1": 349.36
  },
  {
    "#": "20 Chapel St, Unit B301 (121A-04-01)",
    "$": 875000,
    "address": "20 Chapel St, Unit B301",
    "parcel_id": "121A-04-01",
    "owner1": "NALAMATI, SWARNALATHA & RAVI P",
    "owner2": "",
    "current_taxes": 5325.07,
    "new_taxes_no_override": 5555.11,
    "override_total_1": 5712.74,
    "override_increase_1": 157.62
  },
  {
    "#": "20 Chapel St, Unit B303 (121A-04-02)",
    "$": 886100,
    "address": "20 Chapel St, Unit B303",
    "parcel_id": "121A-04-02",
    "owner1": "NATEGHI, VAFA & NIKY",
    "owner2": "MAHINRAD, JINOOS",
    "current_taxes": 9073.66,
    "new_taxes_no_override": 9465.64,
    "override_total_1": 9734.22,
    "override_increase_1": 268.58
  },
  {
    "#": "20 Chapel St, Unit B304 (121A-04-03)",
    "$": 709100,
    "address": "20 Chapel St, Unit B304",
    "parcel_id": "121A-04-03",
    "owner1": "LT B304 LLC",
    "owner2": "",
    "current_taxes": 7261.18,
    "new_taxes_no_override": 7574.86,
    "override_total_1": 7789.79,
    "override_increase_1": 214.93
  },
  {
    "#": "20 Chapel St, Unit B305 (121A-04-04)",
    "$": 470400,
    "address": "20 Chapel St, Unit B305",
    "parcel_id": "121A-04-04",
    "owner1": "LT B305 LLC",
    "owner2": "",
    "current_taxes": 4816.9,
    "new_taxes_no_override": 5024.99,
    "override_total_1": 5167.57,
    "override_increase_1": 142.58
  },
  {
    "#": "20 Chapel St, Unit B306 (121A-04-05)",
    "$": 648400,
    "address": "20 Chapel St, Unit B306",
    "parcel_id": "121A-04-05",
    "owner1": "BELLO, DHIMITER & ANILA & ELISA",
    "owner2": "",
    "current_taxes": 3004.68,
    "new_taxes_no_override": 3134.48,
    "override_total_1": 3223.42,
    "override_increase_1": 88.94
  },
  {
    "#": "20 Chapel St, Unit B307 (121A-04-06)",
    "$": 657700,
    "address": "20 Chapel St, Unit B307",
    "parcel_id": "121A-04-06",
    "owner1": "CHU, PHILIP",
    "owner2": "GUO, JESSICA",
    "current_taxes": 6734.85,
    "new_taxes_no_override": 7025.8,
    "override_total_1": 7225.15,
    "override_increase_1": 199.35
  },
  {
    "#": "20 Chapel St, Unit B308 (121A-04-07)",
    "$": 607600,
    "address": "20 Chapel St, Unit B308",
    "parcel_id": "121A-04-07",
    "owner1": "SHAH TR, NITA A",
    "owner2": "",
    "current_taxes": 6221.82,
    "new_taxes_no_override": 6490.6,
    "override_total_1": 6674.77,
    "override_increase_1": 184.17
  },
  {
    "#": "20 Chapel St, Unit B309 (121A-04-08)",
    "$": 794200,
    "address": "20 Chapel St, Unit B309",
    "parcel_id": "121A-04-08",
    "owner1": "ZHOU, NING",
    "owner2": "",
    "current_taxes": 8132.61,
    "new_taxes_no_override": 8483.94,
    "override_total_1": 8724.66,
    "override_increase_1": 240.73
  },
  {
    "#": "20 Chapel St, Unit B311 (121C-04-01)",
    "$": 599000,
    "address": "20 Chapel St, Unit B311",
    "parcel_id": "121C-04-01",
    "owner1": "CHEN, DINGZI",
    "owner2": "",
    "current_taxes": 6133.76,
    "new_taxes_no_override": 6398.74,
    "override_total_1": 6580.3,
    "override_increase_1": 181.56
  },
  {
    "#": "20 Chapel St, Unit B312 (121C-04-02)",
    "$": 540400,
    "address": "20 Chapel St, Unit B312",
    "parcel_id": "121C-04-02",
    "owner1": "LU, CHUNLING",
    "owner2": "LIU, HUIHUA",
    "current_taxes": 5533.7,
    "new_taxes_no_override": 5772.76,
    "override_total_1": 5936.55,
    "override_increase_1": 163.8
  },
  {
    "#": "20 Chapel St, Unit B313 (121C-04-03)",
    "$": 487800,
    "address": "20 Chapel St, Unit B313",
    "parcel_id": "121C-04-03",
    "owner1": "LEE, MICHELLE",
    "owner2": "",
    "current_taxes": 4995.07,
    "new_taxes_no_override": 5210.86,
    "override_total_1": 5358.71,
    "override_increase_1": 147.85
  },
  {
    "#": "20 Chapel St, Unit B401 (121A-04-11)",
    "$": 793200,
    "address": "20 Chapel St, Unit B401",
    "parcel_id": "121A-04-11",
    "owner1": "SHAH, HEMANT & SHAAN & MOULIKTA",
    "owner2": "",
    "current_taxes": 8122.37,
    "new_taxes_no_override": 8473.26,
    "override_total_1": 8713.68,
    "override_increase_1": 240.42
  },
  {
    "#": "20 Chapel St, Unit B402 (121A-04-12)",
    "$": 807000,
    "address": "20 Chapel St, Unit B402",
    "parcel_id": "121A-04-12",
    "owner1": "VITOLO, THOMAS J",
    "owner2": "TARANTO, JENNIFER A",
    "current_taxes": 8263.68,
    "new_taxes_no_override": 8620.67,
    "override_total_1": 8865.28,
    "override_increase_1": 244.6
  },
  {
    "#": "20 Chapel St, Unit B403 (121A-04-13)",
    "$": 753700,
    "address": "20 Chapel St, Unit B403",
    "parcel_id": "121A-04-13",
    "owner1": "LO, TIFFANY FANG-TING",
    "owner2": "MCGEE, TIMOTHY J",
    "current_taxes": 7717.89,
    "new_taxes_no_override": 8051.3,
    "override_total_1": 8279.75,
    "override_increase_1": 228.45
  },
  {
    "#": "20 Chapel St, Unit B404 (121A-04-14)",
    "$": 959400,
    "address": "20 Chapel St, Unit B404",
    "parcel_id": "121A-04-14",
    "owner1": "BURGUNDY PRYTANIA LLC",
    "owner2": "C/O NEIL HYMAN",
    "current_taxes": 9824.26,
    "new_taxes_no_override": 10248.67,
    "override_total_1": 10539.47,
    "override_increase_1": 290.8
  },
  {
    "#": "20 Chapel St, Unit B405 (121A-04-15)",
    "$": 529900,
    "address": "20 Chapel St, Unit B405",
    "parcel_id": "121A-04-15",
    "owner1": "GIBBONS, MARIA E",
    "owner2": "BERNHOLZ, MALTE",
    "current_taxes": 5426.18,
    "new_taxes_no_override": 5660.59,
    "override_total_1": 5821.21,
    "override_increase_1": 160.61
  },
  {
    "#": "20 Chapel St, Unit B406 (121A-04-16)",
    "$": 528200,
    "address": "20 Chapel St, Unit B406",
    "parcel_id": "121A-04-16",
    "owner1": "LEE, MUNHYANG",
    "owner2": "KIM, HONG-KI",
    "current_taxes": 5408.77,
    "new_taxes_no_override": 5642.43,
    "override_total_1": 5802.53,
    "override_increase_1": 160.1
  },
  {
    "#": "20 Chapel St, Unit B407 (121A-04-17)",
    "$": 881500,
    "address": "20 Chapel St, Unit B407",
    "parcel_id": "121A-04-17",
    "owner1": "HEALY, REGINA",
    "owner2": "SLOANE, ROBERT",
    "current_taxes": 5391.63,
    "new_taxes_no_override": 5624.55,
    "override_total_1": 5784.14,
    "override_increase_1": 159.59
  },
  {
    "#": "20 Chapel St, Unit B408 (121A-04-18)",
    "$": 784600,
    "address": "20 Chapel St, Unit B408",
    "parcel_id": "121A-04-18",
    "owner1": "GHARAVY TR, GOLLAM HASSAN",
    "owner2": "",
    "current_taxes": 8034.3,
    "new_taxes_no_override": 8381.38,
    "override_total_1": 8619.2,
    "override_increase_1": 237.82
  },
  {
    "#": "20 Chapel St, Unit B409 (121A-04-19)",
    "$": 770100,
    "address": "20 Chapel St, Unit B409",
    "parcel_id": "121A-04-19",
    "owner1": "ZABAK, STEVE",
    "owner2": "MATOOK, ELAINA",
    "current_taxes": 7885.82,
    "new_taxes_no_override": 8226.49,
    "override_total_1": 8459.91,
    "override_increase_1": 233.42
  },
  {
    "#": "20 Chapel St, Unit B411 (121A-04-20)",
    "$": 1090700,
    "address": "20 Chapel St, Unit B411",
    "parcel_id": "121A-04-20",
    "owner1": "LI, JIE",
    "owner2": "",
    "current_taxes": 11168.77,
    "new_taxes_no_override": 11651.26,
    "override_total_1": 11981.86,
    "override_increase_1": 330.6
  },
  {
    "#": "20 Chapel St, Unit B412 (121A-04-21)",
    "$": 1110800,
    "address": "20 Chapel St, Unit B412",
    "parcel_id": "121A-04-21",
    "owner1": "LEVITON TRS, HELEN A & ALAN E",
    "owner2": "",
    "current_taxes": 7739.66,
    "new_taxes_no_override": 8074.01,
    "override_total_1": 8303.11,
    "override_increase_1": 229.09
  },
  {
    "#": "20 Chapel St, Unit B501 (121A-04-22)",
    "$": 860800,
    "address": "20 Chapel St, Unit B501",
    "parcel_id": "121A-04-22",
    "owner1": "WANG, YI HONG",
    "owner2": "LIU, YONG JUN",
    "current_taxes": 8814.59,
    "new_taxes_no_override": 9195.38,
    "override_total_1": 9456.29,
    "override_increase_1": 260.91
  },
  {
    "#": "20 Chapel St, Unit B502 (121A-04-23)",
    "$": 909200,
    "address": "20 Chapel St, Unit B502",
    "parcel_id": "121A-04-23",
    "owner1": "GHARAVY TR, GOLLAM HASSAN",
    "owner2": "",
    "current_taxes": 9310.21,
    "new_taxes_no_override": 9712.41,
    "override_total_1": 9987.99,
    "override_increase_1": 275.58
  },
  {
    "#": "20 Chapel St, Unit B503 (121A-04-24)",
    "$": 859200,
    "address": "20 Chapel St, Unit B503",
    "parcel_id": "121A-04-24",
    "owner1": "GROSSMAN, LEA HAPNER",
    "owner2": "",
    "current_taxes": 5163.27,
    "new_taxes_no_override": 5386.32,
    "override_total_1": 5539.16,
    "override_increase_1": 152.83
  },
  {
    "#": "20 Chapel St, Unit B504 (121A-04-25)",
    "$": 983100,
    "address": "20 Chapel St, Unit B504",
    "parcel_id": "121A-04-25",
    "owner1": "LEE, SANG WON",
    "owner2": "",
    "current_taxes": 6432.01,
    "new_taxes_no_override": 6709.87,
    "override_total_1": 6900.26,
    "override_increase_1": 190.39
  },
  {
    "#": "20 Chapel St, Unit B505 (121A-04-26)",
    "$": 563800,
    "address": "20 Chapel St, Unit B505",
    "parcel_id": "121A-04-26",
    "owner1": "LIU, CHI HSIU",
    "owner2": "",
    "current_taxes": 5773.31,
    "new_taxes_no_override": 6022.72,
    "override_total_1": 6193.61,
    "override_increase_1": 170.89
  },
  {
    "#": "20 Chapel St, Unit B506 (121A-04-27)",
    "$": 561900,
    "address": "20 Chapel St, Unit B506",
    "parcel_id": "121A-04-27",
    "owner1": "SHIFFMAN, KAREN",
    "owner2": "",
    "current_taxes": 2118.92,
    "new_taxes_no_override": 2210.46,
    "override_total_1": 2273.18,
    "override_increase_1": 62.72
  },
  {
    "#": "20 Chapel St, Unit B507 (121A-04-28)",
    "$": 1018200,
    "address": "20 Chapel St, Unit B507",
    "parcel_id": "121A-04-28",
    "owner1": "GUO, JESSICA",
    "owner2": "CHU, PHILIP",
    "current_taxes": 10426.37,
    "new_taxes_no_override": 10876.79,
    "override_total_1": 11185.41,
    "override_increase_1": 308.62
  },
  {
    "#": "20 Chapel St, Unit B509 (121B-04-82)",
    "$": 1550100,
    "address": "20 Chapel St, Unit B509",
    "parcel_id": "121B-04-82",
    "owner1": "HU, ZHUTING",
    "owner2": "WU, MING-RU",
    "current_taxes": 15873.02,
    "new_taxes_no_override": 16558.73,
    "override_total_1": 17028.58,
    "override_increase_1": 469.84
  },
  {
    "#": "20 Chapel St, Unit B511 (121A-04-31)",
    "$": 1152300,
    "address": "20 Chapel St, Unit B511",
    "parcel_id": "121A-04-31",
    "owner1": "LOPEZ TRS, SUSANA GIL & JUAN MARIA DAVILA",
    "owner2": "",
    "current_taxes": 11799.55,
    "new_taxes_no_override": 12309.29,
    "override_total_1": 12658.56,
    "override_increase_1": 349.27
  },
  {
    "#": "20 Chapel St, Unit B512 (121A-04-32)",
    "$": 1173000,
    "address": "20 Chapel St, Unit B512",
    "parcel_id": "121A-04-32",
    "owner1": "ZANDI-NEJAD, KAMBIZ",
    "owner2": "TAKAKURA, AYUMI",
    "current_taxes": 12011.52,
    "new_taxes_no_override": 12530.42,
    "override_total_1": 12885.96,
    "override_increase_1": 355.54
  },
  {
    "#": "20 Chapel St, Unit B601 (121A-04-33)",
    "$": 751300,
    "address": "20 Chapel St, Unit B601",
    "parcel_id": "121A-04-33",
    "owner1": "FANELLI, MARIA LUDOVICA",
    "owner2": "",
    "current_taxes": 7693.31,
    "new_taxes_no_override": 8025.66,
    "override_total_1": 8253.38,
    "override_increase_1": 227.72
  },
  {
    "#": "20 Chapel St, Unit B602 (121A-04-34)",
    "$": 896000,
    "address": "20 Chapel St, Unit B602",
    "parcel_id": "121A-04-34",
    "owner1": "AMYNA LLC",
    "owner2": "C/O BOSTON CONDO MGMT",
    "current_taxes": 9175.04,
    "new_taxes_no_override": 9571.4,
    "override_total_1": 9842.98,
    "override_increase_1": 271.58
  },
  {
    "#": "20 Chapel St, Unit B603 (121A-04-35)",
    "$": 840100,
    "address": "20 Chapel St, Unit B603",
    "parcel_id": "121A-04-35",
    "owner1": "WANG, CAROLYN FANG",
    "owner2": "",
    "current_taxes": 8602.62,
    "new_taxes_no_override": 8974.25,
    "override_total_1": 9228.89,
    "override_increase_1": 254.64
  },
  {
    "#": "20 Chapel St, Unit B604& P22 (121A-04-36)",
    "$": 984200,
    "address": "20 Chapel St, Unit B604& P22",
    "parcel_id": "121A-04-36",
    "owner1": "YOO, JIMIN LAUREN",
    "owner2": "",
    "current_taxes": 6443.27,
    "new_taxes_no_override": 6721.62,
    "override_total_1": 6912.34,
    "override_increase_1": 190.72
  },
  {
    "#": "20 Chapel St, Unit B605 (121A-04-37)",
    "$": 692400,
    "address": "20 Chapel St, Unit B605",
    "parcel_id": "121A-04-37",
    "owner1": "HU, ZHUTING",
    "owner2": "WU, MING RU",
    "current_taxes": 7090.18,
    "new_taxes_no_override": 7396.48,
    "override_total_1": 7606.35,
    "override_increase_1": 209.87
  },
  {
    "#": "20 Chapel St, Unit B606 (121A-04-38)",
    "$": 561900,
    "address": "20 Chapel St, Unit B606",
    "parcel_id": "121A-04-38",
    "owner1": "ASHRAFZADEH, HELEN C & AMIN",
    "owner2": "",
    "current_taxes": 2118.92,
    "new_taxes_no_override": 2210.46,
    "override_total_1": 2273.18,
    "override_increase_1": 62.72
  },
  {
    "#": "20 Chapel St, Unit B607 (121A-04-39)",
    "$": 1033100,
    "address": "20 Chapel St, Unit B607",
    "parcel_id": "121A-04-39",
    "owner1": "FRASER, BETH & MALCOLM",
    "owner2": "",
    "current_taxes": 10578.94,
    "new_taxes_no_override": 11035.95,
    "override_total_1": 11349.09,
    "override_increase_1": 313.14
  },
  {
    "#": "20 Chapel St, Unit B608 (121A-04-40)",
    "$": 917400,
    "address": "20 Chapel St, Unit B608",
    "parcel_id": "121A-04-40",
    "owner1": "BILLER, TOBY & LEAH",
    "owner2": "",
    "current_taxes": 9394.18,
    "new_taxes_no_override": 9800.01,
    "override_total_1": 10078.08,
    "override_increase_1": 278.07
  },
  {
    "#": "20 Chapel St, Unit B609 (121A-04-41)",
    "$": 880000,
    "address": "20 Chapel St, Unit B609",
    "parcel_id": "121A-04-41",
    "owner1": "AHUJA, GAURAV & VINTI",
    "owner2": "",
    "current_taxes": 9011.2,
    "new_taxes_no_override": 9400.48,
    "override_total_1": 9667.22,
    "override_increase_1": 266.73
  },
  {
    "#": "20 Chapel St, Unit B611 (121A-04-42)",
    "$": 2257400,
    "address": "20 Chapel St, Unit B611",
    "parcel_id": "121A-04-42",
    "owner1": "COLTON TRS, THEODORE & CAROLYN M",
    "owner2": "",
    "current_taxes": 23115.78,
    "new_taxes_no_override": 24114.38,
    "override_total_1": 24798.61,
    "override_increase_1": 684.23
  },
  {
    "#": "20 Chapel St, Unit B701 (121A-04-43)",
    "$": 880000,
    "address": "20 Chapel St, Unit B701",
    "parcel_id": "121A-04-43",
    "owner1": "NG, LE GE LOIS HUANG & PENG TENG",
    "owner2": "",
    "current_taxes": 9011.2,
    "new_taxes_no_override": 9400.48,
    "override_total_1": 9667.22,
    "override_increase_1": 266.73
  },
  {
    "#": "20 Chapel St, Unit B702 (121A-04-44)",
    "$": 896000,
    "address": "20 Chapel St, Unit B702",
    "parcel_id": "121A-04-44",
    "owner1": "NIGAM, ARVIND KUMAR",
    "owner2": "",
    "current_taxes": 9175.04,
    "new_taxes_no_override": 9571.4,
    "override_total_1": 9842.98,
    "override_increase_1": 271.58
  },
  {
    "#": "20 Chapel St, Unit B703 (121A-04-45)",
    "$": 859200,
    "address": "20 Chapel St, Unit B703",
    "parcel_id": "121A-04-45",
    "owner1": "ARTINIAN TRS, MIHRAN & ALICE",
    "owner2": "",
    "current_taxes": 8798.21,
    "new_taxes_no_override": 9178.29,
    "override_total_1": 9438.72,
    "override_increase_1": 260.43
  },
  {
    "#": "20 Chapel St, Unit B704 (121A-04-46)",
    "$": 982400,
    "address": "20 Chapel St, Unit B704",
    "parcel_id": "121A-04-46",
    "owner1": "AYCI, AYSE NUR",
    "owner2": "",
    "current_taxes": 10059.78,
    "new_taxes_no_override": 10494.36,
    "override_total_1": 10792.13,
    "override_increase_1": 297.77
  },
  {
    "#": "20 Chapel St, Unit B705 (121A-04-47)",
    "$": 591200,
    "address": "20 Chapel St, Unit B705",
    "parcel_id": "121A-04-47",
    "owner1": "ARW BOSTON LUXURY PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 6053.89,
    "new_taxes_no_override": 6315.42,
    "override_total_1": 6494.61,
    "override_increase_1": 179.2
  },
  {
    "#": "20 Chapel St, Unit B706 (121A-04-48)",
    "$": 605400,
    "address": "20 Chapel St, Unit B706",
    "parcel_id": "121A-04-48",
    "owner1": "SCHURSKY TRS, MELVIN D JR & SONIA",
    "owner2": "",
    "current_taxes": 6199.3,
    "new_taxes_no_override": 6467.11,
    "override_total_1": 6650.61,
    "override_increase_1": 183.5
  },
  {
    "#": "20 Chapel St, Unit B707 (121A-04-49)",
    "$": 1031300,
    "address": "20 Chapel St, Unit B707",
    "parcel_id": "121A-04-49",
    "owner1": "CHAN, WALTER W-Y & DONNELLY W-B",
    "owner2": "",
    "current_taxes": 10560.51,
    "new_taxes_no_override": 11016.72,
    "override_total_1": 11329.32,
    "override_increase_1": 312.59
  },
  {
    "#": "20 Chapel St, Unit B709 (121B-04-98)",
    "$": 1550000,
    "address": "20 Chapel St, Unit B709",
    "parcel_id": "121B-04-98",
    "owner1": "BASS TR, LEAH",
    "owner2": "",
    "current_taxes": 12237.07,
    "new_taxes_no_override": 12765.71,
    "override_total_1": 13127.93,
    "override_increase_1": 362.22
  },
  {
    "#": "20 Chapel St, Unit B711 (121A-04-52)",
    "$": 1147200,
    "address": "20 Chapel St, Unit B711",
    "parcel_id": "121A-04-52",
    "owner1": "CHEN TR, CHEN-HUI",
    "owner2": "",
    "current_taxes": 11747.33,
    "new_taxes_no_override": 12254.81,
    "override_total_1": 12602.54,
    "override_increase_1": 347.72
  },
  {
    "#": "20 Chapel St, Unit B712 (121B-04-89)",
    "$": 1173100,
    "address": "20 Chapel St, Unit B712",
    "parcel_id": "121B-04-89",
    "owner1": "RICCIARDI TRS, ALBERT W",
    "owner2": "ATKINSON, CHERYL",
    "current_taxes": 12012.54,
    "new_taxes_no_override": 12531.48,
    "override_total_1": 12887.05,
    "override_increase_1": 355.57
  },
  {
    "#": "20 Chapel St, Unit B801 (121A-04-55)",
    "$": 879900,
    "address": "20 Chapel St, Unit B801",
    "parcel_id": "121A-04-55",
    "owner1": "ZHAO, DAYAO & WARREN",
    "owner2": "XU, HONG",
    "current_taxes": 9010.18,
    "new_taxes_no_override": 9399.42,
    "override_total_1": 9666.12,
    "override_increase_1": 266.7
  },
  {
    "#": "20 Chapel St, Unit B802 (121A-04-56)",
    "$": 896100,
    "address": "20 Chapel St, Unit B802",
    "parcel_id": "121A-04-56",
    "owner1": "WEBER, HORST CHRISTIAN",
    "owner2": "KIM, HAESOOK T",
    "current_taxes": 9176.06,
    "new_taxes_no_override": 9572.47,
    "override_total_1": 9844.08,
    "override_increase_1": 271.61
  },
  {
    "#": "20 Chapel St, Unit B803 (121A-04-57)",
    "$": 881100,
    "address": "20 Chapel St, Unit B803",
    "parcel_id": "121A-04-57",
    "owner1": "CARPENITO TRS, HENRY F & NATALIYA V",
    "owner2": "ROSE DALE REALTY TRUST",
    "current_taxes": 9022.46,
    "new_taxes_no_override": 9412.23,
    "override_total_1": 9679.3,
    "override_increase_1": 267.06
  },
  {
    "#": "20 Chapel St, Unit B805 (121B-04-90)",
    "$": 1588600,
    "address": "20 Chapel St, Unit B805",
    "parcel_id": "121B-04-90",
    "owner1": "MANDL, BETTE & ALEXANDER",
    "owner2": "",
    "current_taxes": 12632.33,
    "new_taxes_no_override": 13178.05,
    "override_total_1": 13551.96,
    "override_increase_1": 373.92
  },
  {
    "#": "20 Chapel St, Unit B807 (121B-04-83)",
    "$": 1600500,
    "address": "20 Chapel St, Unit B807",
    "parcel_id": "121B-04-83",
    "owner1": "HYLTON, KEITH N",
    "owner2": "",
    "current_taxes": 12754.19,
    "new_taxes_no_override": 13305.17,
    "override_total_1": 13682.7,
    "override_increase_1": 377.52
  },
  {
    "#": "20 Chapel St, Unit B808 (121A-04-62)",
    "$": 895500,
    "address": "20 Chapel St, Unit B808",
    "parcel_id": "121A-04-62",
    "owner1": "ZANDINEJAD, KEVIAN & HASSAN",
    "owner2": "AKBAR, SOUSANAK NAIMI",
    "current_taxes": 5534.99,
    "new_taxes_no_override": 5774.1,
    "override_total_1": 5937.94,
    "override_increase_1": 163.84
  },
  {
    "#": "20 Chapel St, Unit B809 (121A-04-63)",
    "$": 880200,
    "address": "20 Chapel St, Unit B809",
    "parcel_id": "121A-04-63",
    "owner1": "HUA, LANQI",
    "owner2": "DONG, FENG",
    "current_taxes": 9013.25,
    "new_taxes_no_override": 9402.62,
    "override_total_1": 9669.41,
    "override_increase_1": 266.79
  },
  {
    "#": "20 Chapel St, Unit B811 (121B-04-91)",
    "$": 2257300,
    "address": "20 Chapel St, Unit B811",
    "parcel_id": "121B-04-91",
    "owner1": "YEN, EARL",
    "owner2": "TONG, LUCENE",
    "current_taxes": 23114.75,
    "new_taxes_no_override": 24113.31,
    "override_total_1": 24797.5,
    "override_increase_1": 684.2
  },
  {
    "#": "20 Chapel St, Unit B901 (121A-04-66)",
    "$": 2313800,
    "address": "20 Chapel St, Unit B901",
    "parcel_id": "121A-04-66",
    "owner1": "WEEKS, OLIVIA G",
    "owner2": "",
    "current_taxes": 20058.38,
    "new_taxes_no_override": 20924.9,
    "override_total_1": 21518.63,
    "override_increase_1": 593.73
  },
  {
    "#": "20 Chapel St, Unit B904 (121A-04-67)",
    "$": 884600,
    "address": "20 Chapel St, Unit B904",
    "parcel_id": "121A-04-67",
    "owner1": "UCHIDA, TAKAHIRO",
    "owner2": "",
    "current_taxes": 9058.3,
    "new_taxes_no_override": 9449.62,
    "override_total_1": 9717.74,
    "override_increase_1": 268.13
  },
  {
    "#": "20 Chapel St, Unit B905 (121A-04-68)",
    "$": 1423000,
    "address": "20 Chapel St, Unit B905",
    "parcel_id": "121A-04-68",
    "owner1": "MOHAN, ADITYA",
    "owner2": "ADAMSON-MOHAN, CAROLYN LOUISE",
    "current_taxes": 14571.52,
    "new_taxes_no_override": 15201.01,
    "override_total_1": 15632.33,
    "override_increase_1": 431.32
  },
  {
    "#": "20 Chapel St, Unit B907 (121A-04-69)",
    "$": 1011200,
    "address": "20 Chapel St, Unit B907",
    "parcel_id": "121A-04-69",
    "owner1": "OKADA, YOSHIO",
    "owner2": "",
    "current_taxes": 10354.69,
    "new_taxes_no_override": 10802.01,
    "override_total_1": 11108.51,
    "override_increase_1": 306.5
  },
  {
    "#": "20 Chapel St, Unit B908 (121A-04-70)",
    "$": 895500,
    "address": "20 Chapel St, Unit B908",
    "parcel_id": "121A-04-70",
    "owner1": "HALL TR, JESSICA",
    "owner2": "",
    "current_taxes": 9169.92,
    "new_taxes_no_override": 9566.06,
    "override_total_1": 9837.49,
    "override_increase_1": 271.43
  },
  {
    "#": "20 Chapel St, Unit B909 (121A-04-71)",
    "$": 900300,
    "address": "20 Chapel St, Unit B909",
    "parcel_id": "121A-04-71",
    "owner1": "ZHANG, JIAHE",
    "owner2": "",
    "current_taxes": 5584.14,
    "new_taxes_no_override": 5825.37,
    "override_total_1": 5990.67,
    "override_increase_1": 165.29
  },
  {
    "#": "20 Chapel St, Unit B911 (121A-04-72)",
    "$": 1135900,
    "address": "20 Chapel St, Unit B911",
    "parcel_id": "121A-04-72",
    "owner1": "WAERSTAD TRS, GUNN M & KJELL ROBT",
    "owner2": "",
    "current_taxes": 11631.62,
    "new_taxes_no_override": 12134.11,
    "override_total_1": 12478.4,
    "override_increase_1": 344.3
  },
  {
    "#": "20 Chapel St, Unit B912& P23 (121A-04-73)",
    "$": 1142900,
    "address": "20 Chapel St, Unit B912& P23",
    "parcel_id": "121A-04-73",
    "owner1": "LEAVITT, DANIEL & LEAH",
    "owner2": "",
    "current_taxes": 11703.3,
    "new_taxes_no_override": 12208.88,
    "override_total_1": 12555.3,
    "override_increase_1": 346.42
  },
  {
    "#": "20 Chapel St, Unit Bph1 (121A-04-85)",
    "$": 974200,
    "address": "20 Chapel St, Unit Bph1",
    "parcel_id": "121A-04-85",
    "owner1": "CAO, HUIPING",
    "owner2": "",
    "current_taxes": 9975.81,
    "new_taxes_no_override": 10406.76,
    "override_total_1": 10702.05,
    "override_increase_1": 295.28
  },
  {
    "#": "20 Chapel St, Unit Bph11 (121B-04-88)",
    "$": 2716300,
    "address": "20 Chapel St, Unit Bph11",
    "parcel_id": "121B-04-88",
    "owner1": "PUNGLIA, NEERAJ & JAYA",
    "owner2": "",
    "current_taxes": 27814.91,
    "new_taxes_no_override": 29016.51,
    "override_total_1": 29839.84,
    "override_increase_1": 823.32
  },
  {
    "#": "20 Chapel St, Unit Bph3 (121B-04-85)",
    "$": 1705500,
    "address": "20 Chapel St, Unit Bph3",
    "parcel_id": "121B-04-85",
    "owner1": "NARDELL, EDWARD A",
    "owner2": "",
    "current_taxes": 13829.39,
    "new_taxes_no_override": 14426.82,
    "override_total_1": 14836.17,
    "override_increase_1": 409.35
  },
  {
    "#": "20 Chapel St, Unit Bph5 (121B-04-86)",
    "$": 1704100,
    "address": "20 Chapel St, Unit Bph5",
    "parcel_id": "121B-04-86",
    "owner1": "SAMI, NEVIT JOHN",
    "owner2": "AMINI-SAMI, ASHLEY",
    "current_taxes": 13815.05,
    "new_taxes_no_override": 14411.86,
    "override_total_1": 14820.79,
    "override_increase_1": 408.93
  },
  {
    "#": "20 Chapel St, Unit Bph7 (121A-04-90)",
    "$": 876700,
    "address": "20 Chapel St, Unit Bph7",
    "parcel_id": "121A-04-90",
    "owner1": "LIU, JIACHENG",
    "owner2": "",
    "current_taxes": 8977.41,
    "new_taxes_no_override": 9365.23,
    "override_total_1": 9630.97,
    "override_increase_1": 265.73
  },
  {
    "#": "20 Chapel St, Unit Bph9 (121B-04-87)",
    "$": 3088700,
    "address": "20 Chapel St, Unit Bph9",
    "parcel_id": "121B-04-87",
    "owner1": "20 CHAPEL STREET PARTNERS LLC",
    "owner2": "C/O CHOATE HALL & STEWART LLP",
    "current_taxes": 31628.29,
    "new_taxes_no_override": 32994.63,
    "override_total_1": 33930.83,
    "override_increase_1": 936.2
  },
  {
    "#": "20 Chapel St, Unit C1001 (121B-04-65)",
    "$": 2368000,
    "address": "20 Chapel St, Unit C1001",
    "parcel_id": "121B-04-65",
    "owner1": "SEDGWICK, SALLY S",
    "owner2": "HYLTON, PETER W",
    "current_taxes": 20613.39,
    "new_taxes_no_override": 21503.89,
    "override_total_1": 22114.04,
    "override_increase_1": 610.16
  },
  {
    "#": "20 Chapel St, Unit C1005 (121B-04-92)",
    "$": 1436500,
    "address": "20 Chapel St, Unit C1005",
    "parcel_id": "121B-04-92",
    "owner1": "HOROWITZ, SANFORD & ELLEN G",
    "owner2": "",
    "current_taxes": 11074.83,
    "new_taxes_no_override": 11553.26,
    "override_total_1": 11881.08,
    "override_increase_1": 327.81
  },
  {
    "#": "20 Chapel St, Unit C1007 (121B-04-93)",
    "$": 1579000,
    "address": "20 Chapel St, Unit C1007",
    "parcel_id": "121B-04-93",
    "owner1": "KCEDP ASSOCIATES LLC",
    "owner2": "",
    "current_taxes": 16168.96,
    "new_taxes_no_override": 16867.46,
    "override_total_1": 17346.06,
    "override_increase_1": 478.6
  },
  {
    "#": "20 Chapel St, Unit C1009 (121B-04-94)",
    "$": 1647800,
    "address": "20 Chapel St, Unit C1009",
    "parcel_id": "121B-04-94",
    "owner1": "KILBOURNE TR, JEAN",
    "owner2": "",
    "current_taxes": 13238.54,
    "new_taxes_no_override": 13810.44,
    "override_total_1": 14202.31,
    "override_increase_1": 391.86
  },
  {
    "#": "20 Chapel St, Unit C1011 (121B-04-72)",
    "$": 1122700,
    "address": "20 Chapel St, Unit C1011",
    "parcel_id": "121B-04-72",
    "owner1": "QURESHI, ZARINA",
    "owner2": "",
    "current_taxes": 11496.45,
    "new_taxes_no_override": 11993.1,
    "override_total_1": 12333.39,
    "override_increase_1": 340.29
  },
  {
    "#": "20 Chapel St, Unit C1012 (121B-04-73)",
    "$": 1172500,
    "address": "20 Chapel St, Unit C1012",
    "parcel_id": "121B-04-73",
    "owner1": "RAMAN, VENKAT & CHITRA",
    "owner2": "",
    "current_taxes": 8371.47,
    "new_taxes_no_override": 8733.12,
    "override_total_1": 8980.91,
    "override_increase_1": 247.8
  },
  {
    "#": "20 Chapel St, Unit C304 (121B-04-03)",
    "$": 606800,
    "address": "20 Chapel St, Unit C304",
    "parcel_id": "121B-04-03",
    "owner1": "PAVLOTSKY, OLGA & ALEX",
    "owner2": "",
    "current_taxes": 6213.63,
    "new_taxes_no_override": 6482.06,
    "override_total_1": 6665.98,
    "override_increase_1": 183.92
  },
  {
    "#": "20 Chapel St, Unit C305 (121B-04-04)",
    "$": 578800,
    "address": "20 Chapel St, Unit C305",
    "parcel_id": "121B-04-04",
    "owner1": "LION RIVER PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 5926.91,
    "new_taxes_no_override": 6182.95,
    "override_total_1": 6358.39,
    "override_increase_1": 175.44
  },
  {
    "#": "20 Chapel St, Unit C306 (121B-04-05)",
    "$": 590400,
    "address": "20 Chapel St, Unit C306",
    "parcel_id": "121B-04-05",
    "owner1": "WANG, DONG",
    "owner2": "",
    "current_taxes": 2410.76,
    "new_taxes_no_override": 2514.9,
    "override_total_1": 2586.26,
    "override_increase_1": 71.36
  },
  {
    "#": "20 Chapel St, Unit C307 (121B-04-06)",
    "$": 669200,
    "address": "20 Chapel St, Unit C307",
    "parcel_id": "121B-04-06",
    "owner1": "KRASKER, JENNIE",
    "owner2": "",
    "current_taxes": 3217.67,
    "new_taxes_no_override": 3356.67,
    "override_total_1": 3451.92,
    "override_increase_1": 95.24
  },
  {
    "#": "20 Chapel St, Unit C308 (121B-04-07)",
    "$": 542700,
    "address": "20 Chapel St, Unit C308",
    "parcel_id": "121B-04-07",
    "owner1": "20 CHAPEL STREET UNIT C308 LLC",
    "owner2": "",
    "current_taxes": 5557.25,
    "new_taxes_no_override": 5797.32,
    "override_total_1": 5961.82,
    "override_increase_1": 164.49
  },
  {
    "#": "20 Chapel St, Unit C309 (121B-04-08)",
    "$": 605900,
    "address": "20 Chapel St, Unit C309",
    "parcel_id": "121B-04-08",
    "owner1": "PRASAD TR, RAY",
    "owner2": "",
    "current_taxes": 6204.42,
    "new_taxes_no_override": 6472.45,
    "override_total_1": 6656.1,
    "override_increase_1": 183.65
  },
  {
    "#": "20 Chapel St, Unit C311 (121B-04-09)",
    "$": 643100,
    "address": "20 Chapel St, Unit C311",
    "parcel_id": "121B-04-09",
    "owner1": "SWEENEY, STEVEN P",
    "owner2": "",
    "current_taxes": 6585.34,
    "new_taxes_no_override": 6869.83,
    "override_total_1": 7064.75,
    "override_increase_1": 194.93
  },
  {
    "#": "20 Chapel St, Unit C312 (121B-04-10)",
    "$": 347600,
    "address": "20 Chapel St, Unit C312",
    "parcel_id": "121B-04-10",
    "owner1": "YOON, SUNG SIK",
    "owner2": "KIM, EUN",
    "current_taxes": 3559.42,
    "new_taxes_no_override": 3713.19,
    "override_total_1": 3818.55,
    "override_increase_1": 105.36
  },
  {
    "#": "20 Chapel St, Unit C401 (121C-04-04)",
    "$": 823100,
    "address": "20 Chapel St, Unit C401",
    "parcel_id": "121C-04-04",
    "owner1": "KARP, GEORGE I",
    "owner2": "ROSENTHAL, SUSAN R",
    "current_taxes": 8428.54,
    "new_taxes_no_override": 8792.65,
    "override_total_1": 9042.14,
    "override_increase_1": 249.48
  },
  {
    "#": "20 Chapel St, Unit C403 (121C-04-05)",
    "$": 1490500,
    "address": "20 Chapel St, Unit C403",
    "parcel_id": "121C-04-05",
    "owner1": "SCHWARTZSTEIN, SARAH M",
    "owner2": "",
    "current_taxes": 11627.79,
    "new_taxes_no_override": 12130.11,
    "override_total_1": 12474.29,
    "override_increase_1": 344.18
  },
  {
    "#": "20 Chapel St, Unit C404 (121B-04-12)",
    "$": 365400,
    "address": "20 Chapel St, Unit C404",
    "parcel_id": "121B-04-12",
    "owner1": "GORDON, CHRISTY C & LOUIS",
    "owner2": "",
    "current_taxes": 374.17,
    "new_taxes_no_override": 390.33,
    "override_total_1": 401.41,
    "override_increase_1": 11.08
  },
  {
    "#": "20 Chapel St, Unit C405 (121B-04-13)",
    "$": 543000,
    "address": "20 Chapel St, Unit C405",
    "parcel_id": "121B-04-13",
    "owner1": "ZHOU, FRANK M & ZHI QIANG",
    "owner2": "JI, FANG",
    "current_taxes": 5560.32,
    "new_taxes_no_override": 5800.53,
    "override_total_1": 5965.11,
    "override_increase_1": 164.59
  },
  {
    "#": "20 Chapel St, Unit C406 (121B-04-14)",
    "$": 528200,
    "address": "20 Chapel St, Unit C406",
    "parcel_id": "121B-04-14",
    "owner1": "FARIAS, DOMINGO",
    "owner2": "GUTIERREZ, MASSIEL",
    "current_taxes": 5408.77,
    "new_taxes_no_override": 5642.43,
    "override_total_1": 5802.53,
    "override_increase_1": 160.1
  },
  {
    "#": "20 Chapel St, Unit C407 (121B-04-15)",
    "$": 882900,
    "address": "20 Chapel St, Unit C407",
    "parcel_id": "121B-04-15",
    "owner1": "YACOUB, JOUMANA",
    "owner2": "C/O SEA DAR CONSTRUCTION",
    "current_taxes": 9040.9,
    "new_taxes_no_override": 9431.47,
    "override_total_1": 9699.08,
    "override_increase_1": 267.61
  },
  {
    "#": "20 Chapel St, Unit C408 (121B-04-16)",
    "$": 784600,
    "address": "20 Chapel St, Unit C408",
    "parcel_id": "121B-04-16",
    "owner1": "CONVICER, RICHARD G",
    "owner2": "",
    "current_taxes": 4399.37,
    "new_taxes_no_override": 4589.42,
    "override_total_1": 4719.64,
    "override_increase_1": 130.22
  },
  {
    "#": "20 Chapel St, Unit C409 (121B-04-17)",
    "$": 771400,
    "address": "20 Chapel St, Unit C409",
    "parcel_id": "121B-04-17",
    "owner1": "TARAZI TRS, NAKHLE A & RANDA",
    "owner2": "",
    "current_taxes": 7899.14,
    "new_taxes_no_override": 8240.38,
    "override_total_1": 8474.2,
    "override_increase_1": 233.81
  },
  {
    "#": "20 Chapel St, Unit C411 (121B-04-18)",
    "$": 1125900,
    "address": "20 Chapel St, Unit C411",
    "parcel_id": "121B-04-18",
    "owner1": "WONG, ANITA L",
    "owner2": "",
    "current_taxes": 7894.28,
    "new_taxes_no_override": 8235.31,
    "override_total_1": 8468.98,
    "override_increase_1": 233.67
  },
  {
    "#": "20 Chapel St, Unit C412 (121B-04-19)",
    "$": 1015300,
    "address": "20 Chapel St, Unit C412",
    "parcel_id": "121B-04-19",
    "owner1": "HAYEK REALTY LLC",
    "owner2": "",
    "current_taxes": 10396.67,
    "new_taxes_no_override": 10845.81,
    "override_total_1": 11153.55,
    "override_increase_1": 307.74
  },
  {
    "#": "20 Chapel St, Unit C501 (121C-04-06)",
    "$": 943000,
    "address": "20 Chapel St, Unit C501",
    "parcel_id": "121C-04-06",
    "owner1": "SHROCK, ELLEN",
    "owner2": "",
    "current_taxes": 6021.39,
    "new_taxes_no_override": 6281.51,
    "override_total_1": 6459.75,
    "override_increase_1": 178.23
  },
  {
    "#": "20 Chapel St, Unit C503 (121C-04-07)",
    "$": 1363200,
    "address": "20 Chapel St, Unit C503",
    "parcel_id": "121C-04-07",
    "owner1": "CASTA, ALFONSA",
    "owner2": "",
    "current_taxes": 10324.23,
    "new_taxes_no_override": 10770.24,
    "override_total_1": 11075.83,
    "override_increase_1": 305.6
  },
  {
    "#": "20 Chapel St, Unit C504 (121B-04-21)",
    "$": 1010000,
    "address": "20 Chapel St, Unit C504",
    "parcel_id": "121B-04-21",
    "owner1": "HU, ZHUTING",
    "owner2": "WU, MING-RU",
    "current_taxes": 6707.47,
    "new_taxes_no_override": 6997.23,
    "override_total_1": 7195.77,
    "override_increase_1": 198.54
  },
  {
    "#": "20 Chapel St, Unit C505 (121B-04-22)",
    "$": 563800,
    "address": "20 Chapel St, Unit C505",
    "parcel_id": "121B-04-22",
    "owner1": "DILIBERO TR, STEFANIE E",
    "owner2": "",
    "current_taxes": 5773.31,
    "new_taxes_no_override": 6022.72,
    "override_total_1": 6193.61,
    "override_increase_1": 170.89
  },
  {
    "#": "20 Chapel St, Unit C506 (121B-04-23)",
    "$": 567200,
    "address": "20 Chapel St, Unit C506",
    "parcel_id": "121B-04-23",
    "owner1": "LI, HAILAN & FENGMAI",
    "owner2": "",
    "current_taxes": 5808.13,
    "new_taxes_no_override": 6059.04,
    "override_total_1": 6230.96,
    "override_increase_1": 171.92
  },
  {
    "#": "20 Chapel St, Unit C507 (121B-04-24)",
    "$": 1066600,
    "address": "20 Chapel St, Unit C507",
    "parcel_id": "121B-04-24",
    "owner1": "SHROCK, CHRISTINE LEE",
    "owner2": "",
    "current_taxes": 7287.05,
    "new_taxes_no_override": 7601.85,
    "override_total_1": 7817.55,
    "override_increase_1": 215.7
  },
  {
    "#": "20 Chapel St, Unit C508 (121B-04-25)",
    "$": 895500,
    "address": "20 Chapel St, Unit C508",
    "parcel_id": "121B-04-25",
    "owner1": "ROKHLENKO, ANNA",
    "owner2": "GUROK, GALINA",
    "current_taxes": 9169.92,
    "new_taxes_no_override": 9566.06,
    "override_total_1": 9837.49,
    "override_increase_1": 271.43
  },
  {
    "#": "20 Chapel St, Unit C509 (121B-04-26)",
    "$": 879900,
    "address": "20 Chapel St, Unit C509",
    "parcel_id": "121B-04-26",
    "owner1": "ASBUN, JESSICA",
    "owner2": "",
    "current_taxes": 9010.18,
    "new_taxes_no_override": 9399.42,
    "override_total_1": 9666.12,
    "override_increase_1": 266.7
  },
  {
    "#": "20 Chapel St, Unit C511 (121B-04-27)",
    "$": 1122700,
    "address": "20 Chapel St, Unit C511",
    "parcel_id": "121B-04-27",
    "owner1": "RONDER TR, CHRISTINA L",
    "owner2": "",
    "current_taxes": 11496.45,
    "new_taxes_no_override": 11993.1,
    "override_total_1": 12333.39,
    "override_increase_1": 340.29
  },
  {
    "#": "20 Chapel St, Unit C512 (121B-04-28)",
    "$": 1172500,
    "address": "20 Chapel St, Unit C512",
    "parcel_id": "121B-04-28",
    "owner1": "RONDER TR, CHRISTINA L",
    "owner2": "",
    "current_taxes": 12006.4,
    "new_taxes_no_override": 12525.08,
    "override_total_1": 12880.47,
    "override_increase_1": 355.39
  },
  {
    "#": "20 Chapel St, Unit C601 (121C-04-08)",
    "$": 937500,
    "address": "20 Chapel St, Unit C601",
    "parcel_id": "121C-04-08",
    "owner1": "GC CONDO LLC",
    "owner2": "",
    "current_taxes": 9600.0,
    "new_taxes_no_override": 10014.72,
    "override_total_1": 10298.88,
    "override_increase_1": 284.16
  },
  {
    "#": "20 Chapel St, Unit C603 (121C-04-09)",
    "$": 1460400,
    "address": "20 Chapel St, Unit C603",
    "parcel_id": "121C-04-09",
    "owner1": "ALESINA TR, SUSAN E",
    "owner2": "",
    "current_taxes": 14954.5,
    "new_taxes_no_override": 15600.53,
    "override_total_1": 16043.19,
    "override_increase_1": 442.65
  },
  {
    "#": "20 Chapel St, Unit C604 (121B-04-30)",
    "$": 1009900,
    "address": "20 Chapel St, Unit C604",
    "parcel_id": "121B-04-30",
    "owner1": "FANELLI, MARIA LUDOVICA",
    "owner2": "",
    "current_taxes": 10341.38,
    "new_taxes_no_override": 10788.13,
    "override_total_1": 11094.23,
    "override_increase_1": 306.1
  },
  {
    "#": "20 Chapel St, Unit C605 (121B-04-31)",
    "$": 563800,
    "address": "20 Chapel St, Unit C605",
    "parcel_id": "121B-04-31",
    "owner1": "JOSHI, GIRISH & SUMAN",
    "owner2": "",
    "current_taxes": 5773.31,
    "new_taxes_no_override": 6022.72,
    "override_total_1": 6193.61,
    "override_increase_1": 170.89
  },
  {
    "#": "20 Chapel St, Unit C606 (121B-04-32)",
    "$": 561900,
    "address": "20 Chapel St, Unit C606",
    "parcel_id": "121B-04-32",
    "owner1": "COSTA, MADALENA",
    "owner2": "",
    "current_taxes": 2118.92,
    "new_taxes_no_override": 2210.46,
    "override_total_1": 2273.18,
    "override_increase_1": 62.72
  },
  {
    "#": "20 Chapel St, Unit C607 (121B-04-33)",
    "$": 1055500,
    "address": "20 Chapel St, Unit C607",
    "parcel_id": "121B-04-33",
    "owner1": "KRASNE, MARGARET D",
    "owner2": "",
    "current_taxes": 10808.32,
    "new_taxes_no_override": 11275.24,
    "override_total_1": 11595.17,
    "override_increase_1": 319.93
  },
  {
    "#": "20 Chapel St, Unit C609 (121B-04-99)",
    "$": 1595600,
    "address": "20 Chapel St, Unit C609",
    "parcel_id": "121B-04-99",
    "owner1": "OESTREICHER TRS, LEE",
    "owner2": "MIRANDA-NAON, ALEJANDRA",
    "current_taxes": 12704.01,
    "new_taxes_no_override": 13252.82,
    "override_total_1": 13628.86,
    "override_increase_1": 376.04
  },
  {
    "#": "20 Chapel St, Unit C611 (121B-04-36)",
    "$": 1152400,
    "address": "20 Chapel St, Unit C611",
    "parcel_id": "121B-04-36",
    "owner1": "BELL TRS, ELIZABETH N P & DAVID PETER",
    "owner2": "",
    "current_taxes": 8165.64,
    "new_taxes_no_override": 8518.4,
    "override_total_1": 8760.1,
    "override_increase_1": 241.7
  },
  {
    "#": "20 Chapel St, Unit C612 (121B-04-37)",
    "$": 1182000,
    "address": "20 Chapel St, Unit C612",
    "parcel_id": "121B-04-37",
    "owner1": "KARP, GEORGE I",
    "owner2": "ROSENTHAL, SUSAN R",
    "current_taxes": 12103.68,
    "new_taxes_no_override": 12626.56,
    "override_total_1": 12984.83,
    "override_increase_1": 358.27
  },
  {
    "#": "20 Chapel St, Unit C701 (121B-04-38)",
    "$": 2364800,
    "address": "20 Chapel St, Unit C701",
    "parcel_id": "121B-04-38",
    "owner1": "VITAVILLE INTERNATIONAL LTD",
    "owner2": "C/O UBS AG ATTN: LORENZ LOBSIGER",
    "current_taxes": 24215.55,
    "new_taxes_no_override": 25261.66,
    "override_total_1": 25978.44,
    "override_increase_1": 716.78
  },
  {
    "#": "20 Chapel St, Unit C704 (121B-04-39)",
    "$": 984100,
    "address": "20 Chapel St, Unit C704",
    "parcel_id": "121B-04-39",
    "owner1": "SHIN, DANIEL & SEUNG-UON",
    "owner2": "",
    "current_taxes": 10077.18,
    "new_taxes_no_override": 10512.51,
    "override_total_1": 10810.8,
    "override_increase_1": 298.28
  },
  {
    "#": "20 Chapel St, Unit C705 (121B-04-40)",
    "$": 714300,
    "address": "20 Chapel St, Unit C705",
    "parcel_id": "121B-04-40",
    "owner1": "LIU, JING",
    "owner2": "",
    "current_taxes": 7314.43,
    "new_taxes_no_override": 7630.41,
    "override_total_1": 7846.92,
    "override_increase_1": 216.51
  },
  {
    "#": "20 Chapel St, Unit C706 (121B-04-41)",
    "$": 561900,
    "address": "20 Chapel St, Unit C706",
    "parcel_id": "121B-04-41",
    "owner1": "PENG, HAIYING",
    "owner2": "ZHAO, JEAN",
    "current_taxes": 5753.86,
    "new_taxes_no_override": 6002.43,
    "override_total_1": 6172.74,
    "override_increase_1": 170.31
  },
  {
    "#": "20 Chapel St, Unit C707 (121B-04-42)",
    "$": 929200,
    "address": "20 Chapel St, Unit C707",
    "parcel_id": "121B-04-42",
    "owner1": "YIALAMAS, MARIA",
    "owner2": "",
    "current_taxes": 5880.07,
    "new_taxes_no_override": 6134.09,
    "override_total_1": 6308.14,
    "override_increase_1": 174.05
  },
  {
    "#": "20 Chapel St, Unit C709 (121C-04-10)",
    "$": 1746000,
    "address": "20 Chapel St, Unit C709",
    "parcel_id": "121C-04-10",
    "owner1": "LIU, CHANG",
    "owner2": "",
    "current_taxes": 14244.11,
    "new_taxes_no_override": 14859.46,
    "override_total_1": 15281.08,
    "override_increase_1": 421.63
  },
  {
    "#": "20 Chapel St, Unit C711 (121B-04-45)",
    "$": 1122700,
    "address": "20 Chapel St, Unit C711",
    "parcel_id": "121B-04-45",
    "owner1": "CHATHAM 711 LLC",
    "owner2": "C/O SHIRLEY SAUNDERS",
    "current_taxes": 11496.45,
    "new_taxes_no_override": 11993.1,
    "override_total_1": 12333.39,
    "override_increase_1": 340.29
  },
  {
    "#": "20 Chapel St, Unit C712 (121B-04-46)",
    "$": 1142900,
    "address": "20 Chapel St, Unit C712",
    "parcel_id": "121B-04-46",
    "owner1": "ALBRIGHT TRS, LARS L & LAWSON A",
    "owner2": "",
    "current_taxes": 11703.3,
    "new_taxes_no_override": 12208.88,
    "override_total_1": 12555.3,
    "override_increase_1": 346.42
  },
  {
    "#": "20 Chapel St, Unit C801 (121B-04-47)",
    "$": 2265300,
    "address": "20 Chapel St, Unit C801",
    "parcel_id": "121B-04-47",
    "owner1": "GREEN, MARK V & KAREN F",
    "owner2": "",
    "current_taxes": 19561.74,
    "new_taxes_no_override": 20406.81,
    "override_total_1": 20985.83,
    "override_increase_1": 579.03
  },
  {
    "#": "20 Chapel St, Unit C805 (121B-04-48)",
    "$": 1423500,
    "address": "20 Chapel St, Unit C805",
    "parcel_id": "121B-04-48",
    "owner1": "MORSE, PHOEBE",
    "owner2": "",
    "current_taxes": 10941.71,
    "new_taxes_no_override": 11414.39,
    "override_total_1": 11738.27,
    "override_increase_1": 323.87
  },
  {
    "#": "20 Chapel St, Unit C806 (121B-04-49)",
    "$": 862700,
    "address": "20 Chapel St, Unit C806",
    "parcel_id": "121B-04-49",
    "owner1": "CASAS DE SEQUEIRAS LLC",
    "owner2": "",
    "current_taxes": 8834.05,
    "new_taxes_no_override": 9215.68,
    "override_total_1": 9477.17,
    "override_increase_1": 261.49
  },
  {
    "#": "20 Chapel St, Unit C807 (121B-04-50)",
    "$": 779200,
    "address": "20 Chapel St, Unit C807",
    "parcel_id": "121B-04-50",
    "owner1": "YOU, SHAO FANG & JASON C",
    "owner2": "HU, JIAN YUN",
    "current_taxes": 7979.01,
    "new_taxes_no_override": 8323.7,
    "override_total_1": 8559.88,
    "override_increase_1": 236.18
  },
  {
    "#": "20 Chapel St, Unit C809 (121C-04-11)",
    "$": 1746000,
    "address": "20 Chapel St, Unit C809",
    "parcel_id": "121C-04-11",
    "owner1": "GUO, JESSICA",
    "owner2": "CHU, PHILIP",
    "current_taxes": 17879.04,
    "new_taxes_no_override": 18651.41,
    "override_total_1": 19180.63,
    "override_increase_1": 529.22
  },
  {
    "#": "20 Chapel St, Unit C811 (121C-04-12)",
    "$": 2336300,
    "address": "20 Chapel St, Unit C811",
    "parcel_id": "121C-04-12",
    "owner1": "TIGER, JEFFREY B",
    "owner2": "GARBERN, JESSICA C",
    "current_taxes": 20288.78,
    "new_taxes_no_override": 21165.26,
    "override_total_1": 21765.8,
    "override_increase_1": 600.55
  },
  {
    "#": "20 Chapel St, Unit C901 (121B-04-56)",
    "$": 2335300,
    "address": "20 Chapel St, Unit C901",
    "parcel_id": "121B-04-56",
    "owner1": "COLE TRS, ANNE REMMER",
    "owner2": "FOX, CHRISTOPHER",
    "current_taxes": 23913.47,
    "new_taxes_no_override": 24946.53,
    "override_total_1": 25654.37,
    "override_increase_1": 707.84
  },
  {
    "#": "20 Chapel St, Unit C905 (121C-04-13)",
    "$": 1420100,
    "address": "20 Chapel St, Unit C905",
    "parcel_id": "121C-04-13",
    "owner1": "TAILLARD, JEROME",
    "owner2": "DA COSTA, MADALENA DAMASIO",
    "current_taxes": 10906.89,
    "new_taxes_no_override": 11378.07,
    "override_total_1": 11700.91,
    "override_increase_1": 322.84
  },
  {
    "#": "20 Chapel St, Unit C907 (121C-04-14)",
    "$": 1444300,
    "address": "20 Chapel St, Unit C907",
    "parcel_id": "121C-04-14",
    "owner1": "CHATHAM 907 LLC",
    "owner2": "",
    "current_taxes": 14789.63,
    "new_taxes_no_override": 15428.54,
    "override_total_1": 15866.32,
    "override_increase_1": 437.77
  },
  {
    "#": "20 Chapel St, Unit C909 (121C-04-15)",
    "$": 1595700,
    "address": "20 Chapel St, Unit C909",
    "parcel_id": "121C-04-15",
    "owner1": "BRISKMAN, EUGENE F",
    "owner2": "",
    "current_taxes": 12705.03,
    "new_taxes_no_override": 13253.89,
    "override_total_1": 13629.96,
    "override_increase_1": 376.07
  },
  {
    "#": "20 Chapel St, Unit C911 (121B-04-63)",
    "$": 1117600,
    "address": "20 Chapel St, Unit C911",
    "parcel_id": "121B-04-63",
    "owner1": "LIU, PAK WAI & WENDY WING-HENG",
    "owner2": "LAM, KIT CHUN",
    "current_taxes": 11444.22,
    "new_taxes_no_override": 11938.61,
    "override_total_1": 12277.36,
    "override_increase_1": 338.75
  },
  {
    "#": "20 Chapel St, Unit C912 (121B-04-64)",
    "$": 1140600,
    "address": "20 Chapel St, Unit C912",
    "parcel_id": "121B-04-64",
    "owner1": "DEMOKRITOU, FILIOS",
    "owner2": "",
    "current_taxes": 8044.81,
    "new_taxes_no_override": 8392.35,
    "override_total_1": 8630.47,
    "override_increase_1": 238.13
  },
  {
    "#": "20 Chapel St, Unit Cph1 (121B-04-74)",
    "$": 2716500,
    "address": "20 Chapel St, Unit Cph1",
    "parcel_id": "121B-04-74",
    "owner1": "GOLDBERG, ALFRED & JOAN",
    "owner2": "",
    "current_taxes": 24182.03,
    "new_taxes_no_override": 25226.69,
    "override_total_1": 25942.48,
    "override_increase_1": 715.79
  },
  {
    "#": "20 Chapel St, Unit Cph11 (121B-04-97)",
    "$": 2745200,
    "address": "20 Chapel St, Unit Cph11",
    "parcel_id": "121B-04-97",
    "owner1": "SADKA, RONNIE & AUDREY",
    "owner2": "",
    "current_taxes": 24475.91,
    "new_taxes_no_override": 25533.27,
    "override_total_1": 26257.76,
    "override_increase_1": 724.49
  },
  {
    "#": "20 Chapel St, Unit Cph5 (121B-04-95)",
    "$": 1926500,
    "address": "20 Chapel St, Unit Cph5",
    "parcel_id": "121B-04-95",
    "owner1": "HE, NING",
    "owner2": "WAN, MEI MEI",
    "current_taxes": 19727.36,
    "new_taxes_no_override": 20579.58,
    "override_total_1": 21163.51,
    "override_increase_1": 583.93
  },
  {
    "#": "20 Chapel St, Unit Cph7 (121B-04-77)",
    "$": 1937700,
    "address": "20 Chapel St, Unit Cph7",
    "parcel_id": "121B-04-77",
    "owner1": "CHATHAM PH-07 LLC",
    "owner2": "C/O SHIRLEY SAUNDERS",
    "current_taxes": 19842.05,
    "new_taxes_no_override": 20699.23,
    "override_total_1": 21286.55,
    "override_increase_1": 587.32
  },
  {
    "#": "20 Chapel St, Unit Cph9 (121B-04-96)",
    "$": 1873100,
    "address": "20 Chapel St, Unit Cph9",
    "parcel_id": "121B-04-96",
    "owner1": "SADKA, RONNIE & AUDREY",
    "owner2": "",
    "current_taxes": 19180.54,
    "new_taxes_no_override": 20009.14,
    "override_total_1": 20576.88,
    "override_increase_1": 567.74
  },
  {
    "#": "20 Chapel St, Unit Cs01 (121B-04-01)",
    "$": 2682200,
    "address": "20 Chapel St, Unit Cs01",
    "parcel_id": "121B-04-01",
    "owner1": "CHABAD OF BROOKLINE INC",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "20 Chapel St, Unit Cs02 (121B-04-02)",
    "$": 4070500,
    "address": "20 Chapel St, Unit Cs02",
    "parcel_id": "121B-04-02",
    "owner1": "MOSAIC BOSTON CHURCH INC",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "2 Charles St, Unit Office (160-01-01)",
    "$": 4870400,
    "address": "2 Charles St, Unit Office",
    "parcel_id": "160-01-01",
    "owner1": "VESUVIO LLC",
    "owner2": "C/O WELLINGTON PROPERTY MANAGEMENT GRP",
    "current_taxes": 83576.06,
    "new_taxes_no_override": 87186.55,
    "override_total_1": 89660.4,
    "override_increase_1": 2473.85
  },
  {
    "#": "11 Charles St (161-05-06)",
    "$": 5955500,
    "address": "11 Charles St",
    "parcel_id": "161-05-06",
    "owner1": "TEMPLE SINAI",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "14 Chatham Cir (118-07-00)",
    "$": 3477500,
    "address": "14 Chatham Cir",
    "parcel_id": "118-07-00",
    "owner1": "MEHLMAN, TRS, BERNARD H",
    "owner2": "",
    "current_taxes": 31974.67,
    "new_taxes_no_override": 33355.98,
    "override_total_1": 34302.43,
    "override_increase_1": 946.45
  },
  {
    "#": "15 Chatham Cir (118-04-00)",
    "$": 3128400,
    "address": "15 Chatham Cir",
    "parcel_id": "118-04-00",
    "owner1": "GREENSPAN TRS, MIRIAM & HARVEY P",
    "owner2": "",
    "current_taxes": 28399.88,
    "new_taxes_no_override": 29626.75,
    "override_total_1": 30467.39,
    "override_increase_1": 840.64
  },
  {
    "#": "17 Chatham Cir (118-05-00)",
    "$": 4457400,
    "address": "17 Chatham Cir",
    "parcel_id": "118-05-00",
    "owner1": "DALEY, SEAN P & SUSAN HELMS",
    "owner2": "",
    "current_taxes": 42008.84,
    "new_taxes_no_override": 43823.62,
    "override_total_1": 45067.08,
    "override_increase_1": 1243.46
  },
  {
    "#": "18 Chatham Cir (118-06-00)",
    "$": 3898100,
    "address": "18 Chatham Cir",
    "parcel_id": "118-06-00",
    "owner1": "CUKRAS TRS, ANTHONY",
    "owner2": "TOLANCY, SARA",
    "current_taxes": 36281.61,
    "new_taxes_no_override": 37848.98,
    "override_total_1": 38922.91,
    "override_increase_1": 1073.94
  },
  {
    "#": "7 Chatham St (117-02-00)",
    "$": 5465500,
    "address": "7 Chatham St",
    "parcel_id": "117-02-00",
    "owner1": "GOLDE TRS, ELLEN S",
    "owner2": "",
    "current_taxes": 52331.79,
    "new_taxes_no_override": 54592.52,
    "override_total_1": 56141.54,
    "override_increase_1": 1549.02
  },
  {
    "#": "15 Chatham St (117-03-00)",
    "$": 7062000,
    "address": "15 Chatham St",
    "parcel_id": "117-03-00",
    "owner1": "INKER TR, LESLEY",
    "owner2": "",
    "current_taxes": 72314.88,
    "new_taxes_no_override": 75438.88,
    "override_total_1": 77579.4,
    "override_increase_1": 2140.52
  },
  {
    "#": "33 Chatham St (118-01-00)",
    "$": 3985400,
    "address": "33 Chatham St",
    "parcel_id": "118-01-00",
    "owner1": "ELLEDGE, STEPHEN G",
    "owner2": "KURODA, MITZI I",
    "current_taxes": 37175.56,
    "new_taxes_no_override": 38781.54,
    "override_total_1": 39881.94,
    "override_increase_1": 1100.4
  },
  {
    "#": "39 Chatham St (118-02-00)",
    "$": 3982300,
    "address": "39 Chatham St",
    "parcel_id": "118-02-00",
    "owner1": "JACOBS TRS, JASON A",
    "owner2": "PINCUS, ALLISON R",
    "current_taxes": 37143.82,
    "new_taxes_no_override": 38748.43,
    "override_total_1": 39847.89,
    "override_increase_1": 1099.46
  },
  {
    "#": "47 Chatham St (118-03-00)",
    "$": 3903200,
    "address": "47 Chatham St",
    "parcel_id": "118-03-00",
    "owner1": "MANDELL, JAMES & VALERIE S",
    "owner2": "",
    "current_taxes": 36333.83,
    "new_taxes_no_override": 37903.45,
    "override_total_1": 38978.93,
    "override_increase_1": 1075.48
  },
  {
    "#": "57 Chatham St (118-08-00)",
    "$": 3317000,
    "address": "57 Chatham St",
    "parcel_id": "118-08-00",
    "owner1": "LJEFF LLC",
    "owner2": "",
    "current_taxes": 33966.08,
    "new_taxes_no_override": 35433.41,
    "override_total_1": 36438.81,
    "override_increase_1": 1005.4
  },
  {
    "#": "65 Chatham St (118-09-00)",
    "$": 3979200,
    "address": "65 Chatham St",
    "parcel_id": "118-09-00",
    "owner1": "UPADHYAY, JULIE & SAMEER",
    "owner2": "",
    "current_taxes": 37112.07,
    "new_taxes_no_override": 38715.31,
    "override_total_1": 39813.83,
    "override_increase_1": 1098.52
  },
  {
    "#": "73 Chatham St (118-10-00)",
    "$": 4315700,
    "address": "73 Chatham St",
    "parcel_id": "118-10-00",
    "owner1": "SANG TRS, DELIA N",
    "owner2": "HUGHES, MARK S",
    "current_taxes": 40557.83,
    "new_taxes_no_override": 42309.93,
    "override_total_1": 43510.44,
    "override_increase_1": 1200.51
  },
  {
    "#": "17 Chesham Rd (246-06-00)",
    "$": 3590900,
    "address": "17 Chesham Rd",
    "parcel_id": "246-06-00",
    "owner1": "HOGUET TRS, GEORGE R & MARIE I",
    "owner2": "",
    "current_taxes": 36770.82,
    "new_taxes_no_override": 38359.32,
    "override_total_1": 39447.74,
    "override_increase_1": 1088.42
  },
  {
    "#": "25 Chesham Rd (246-07-00)",
    "$": 2581900,
    "address": "25 Chesham Rd",
    "parcel_id": "246-07-00",
    "owner1": "WINKLER, DEBORAH",
    "owner2": "KRAKAUER, DAVID B",
    "current_taxes": 22803.72,
    "new_taxes_no_override": 23788.84,
    "override_total_1": 24463.83,
    "override_increase_1": 674.99
  },
  {
    "#": "26 Chesham Rd (245-09-00)",
    "$": 3093900,
    "address": "26 Chesham Rd",
    "parcel_id": "245-09-00",
    "owner1": "ELLIS, CHAD",
    "owner2": "BLAIS, PATRICIA",
    "current_taxes": 28046.6,
    "new_taxes_no_override": 29258.21,
    "override_total_1": 30088.39,
    "override_increase_1": 830.18
  },
  {
    "#": "399 Chestnut Hill Ave (238-01-00)",
    "$": 26213400,
    "address": "399 Chestnut Hill Ave",
    "parcel_id": "238-01-00",
    "owner1": "CLEVELAND CIRCLE HOTEL OWNER LLC",
    "owner2": "",
    "current_taxes": 449821.94,
    "new_taxes_no_override": 469254.25,
    "override_total_1": 482568.98,
    "override_increase_1": 13314.73
  },
  {
    "#": "399 Chestnut Hill Ave (238-01-01)",
    "$": 407800,
    "address": "399 Chestnut Hill Ave",
    "parcel_id": "238-01-01",
    "owner1": "CLEVELAND CIRCLE HOTEL OWNER LLC",
    "owner2": "",
    "current_taxes": 6997.85,
    "new_taxes_no_override": 7300.16,
    "override_total_1": 7507.29,
    "override_increase_1": 207.14
  },
  {
    "#": "400 Chestnut Hill Ave (237-13-00)",
    "$": 15883100,
    "address": "400 Chestnut Hill Ave",
    "parcel_id": "237-13-00",
    "owner1": "COMMONWEALTH OF MASSACHUSETTS",
    "owner2": "C/O MASS BAY TRANSIT AUTHORITY",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "416 Chestnut Hill Ave (239-01-00)",
    "$": 2766300,
    "address": "416 Chestnut Hill Ave",
    "parcel_id": "239-01-00",
    "owner1": "COMMONWEALTH OF MASSACHUSETTS",
    "owner2": "C/O MASS BAY TRANSIT AUTHORITY",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "419 Chestnut Hill Ave (264-01-01)",
    "$": 58900,
    "address": "419 Chestnut Hill Ave",
    "parcel_id": "264-01-01",
    "owner1": "COMMONWEALTH OF MASSACHUSETTS",
    "owner2": "C/O MASS BAY TRANSIT AUTHORITY",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "447 Chestnut Hill Ave (263-06-00)",
    "$": 3145300,
    "address": "447 Chestnut Hill Ave",
    "parcel_id": "263-06-00",
    "owner1": "TRUSTEES OF EMMANUEL COLLEGE",
    "owner2": "",
    "current_taxes": 32207.87,
    "new_taxes_no_override": 33599.25,
    "override_total_1": 34552.6,
    "override_increase_1": 953.35
  },
  {
    "#": "452 Chestnut Hill Ave (241-07-00)",
    "$": 3798300,
    "address": "452 Chestnut Hill Ave",
    "parcel_id": "241-07-00",
    "owner1": "OSMANI, MOHAMMAD & YOUSAF",
    "owner2": "",
    "current_taxes": 35259.66,
    "new_taxes_no_override": 36782.88,
    "override_total_1": 37826.56,
    "override_increase_1": 1043.69
  },
  {
    "#": "459 Chestnut Hill Ave (263-07-00)",
    "$": 3585500,
    "address": "459 Chestnut Hill Ave",
    "parcel_id": "263-07-00",
    "owner1": "MICALI, DANIELA CARUSO",
    "owner2": "",
    "current_taxes": 33080.59,
    "new_taxes_no_override": 34509.67,
    "override_total_1": 35488.86,
    "override_increase_1": 979.19
  },
  {
    "#": "462 Chestnut Hill Ave (241-06-00)",
    "$": 3847700,
    "address": "462 Chestnut Hill Ave",
    "parcel_id": "241-06-00",
    "owner1": "SANER, SANDRA & PAUL A",
    "owner2": "",
    "current_taxes": 35765.51,
    "new_taxes_no_override": 37310.58,
    "override_total_1": 38369.24,
    "override_increase_1": 1058.66
  },
  {
    "#": "473 Chestnut Hill Ave (259-01-00)",
    "$": 3130400,
    "address": "473 Chestnut Hill Ave",
    "parcel_id": "259-01-00",
    "owner1": "FELDMAN, NATALIE SARAH",
    "owner2": "ZAGORSKY, BENJAMIN MEYERS",
    "current_taxes": 28420.36,
    "new_taxes_no_override": 29648.12,
    "override_total_1": 30489.36,
    "override_increase_1": 841.24
  },
  {
    "#": "474 Chestnut Hill Ave (242-03-00)",
    "$": 2257600,
    "address": "474 Chestnut Hill Ave",
    "parcel_id": "242-03-00",
    "owner1": "PROCTOR, LELIA B",
    "owner2": "",
    "current_taxes": 19482.89,
    "new_taxes_no_override": 20324.55,
    "override_total_1": 20901.24,
    "override_increase_1": 576.69
  },
  {
    "#": "505 Chestnut Hill Ave (267-19-00)",
    "$": 3111600,
    "address": "505 Chestnut Hill Ave",
    "parcel_id": "267-19-00",
    "owner1": "CATALANO, FELIPE",
    "owner2": "SORIANO, MICHELLE ANN",
    "current_taxes": 31862.78,
    "new_taxes_no_override": 33239.25,
    "override_total_1": 34182.39,
    "override_increase_1": 943.14
  },
  {
    "#": "509 Chestnut Hill Ave (267-20-00)",
    "$": 4086600,
    "address": "509 Chestnut Hill Ave",
    "parcel_id": "267-20-00",
    "owner1": "ANAND TR, MADHAV",
    "owner2": "",
    "current_taxes": 41846.78,
    "new_taxes_no_override": 43654.56,
    "override_total_1": 44893.23,
    "override_increase_1": 1238.66
  },
  {
    "#": "511 Chestnut Hill Ave (267-21-00)",
    "$": 8310000,
    "address": "511 Chestnut Hill Ave",
    "parcel_id": "267-21-00",
    "owner1": "ANAND TR, MADHAV",
    "owner2": "",
    "current_taxes": 85094.4,
    "new_taxes_no_override": 88770.48,
    "override_total_1": 91289.27,
    "override_increase_1": 2518.79
  },
  {
    "#": "540 Chestnut Hill Ave (257-08-09)",
    "$": 6022500,
    "address": "540 Chestnut Hill Ave",
    "parcel_id": "257-08-09",
    "owner1": "BROWN TR, NICHOLAS",
    "owner2": "",
    "current_taxes": 61670.4,
    "new_taxes_no_override": 64334.56,
    "override_total_1": 66160.01,
    "override_increase_1": 1825.44
  },
  {
    "#": "545 Chestnut Hill Ave (267-22-00)",
    "$": 4649400,
    "address": "545 Chestnut Hill Ave",
    "parcel_id": "267-22-00",
    "owner1": "FALZON, MARIA D",
    "owner2": "KIRBY, EDWARD L JR",
    "current_taxes": 47609.86,
    "new_taxes_no_override": 49666.61,
    "override_total_1": 51075.86,
    "override_increase_1": 1409.25
  },
  {
    "#": "559 Chestnut Hill Ave (267-23-00)",
    "$": 3392700,
    "address": "559 Chestnut Hill Ave",
    "parcel_id": "267-23-00",
    "owner1": "CATER TRS, WILLIE J & GLORIA J",
    "owner2": "",
    "current_taxes": 31106.31,
    "new_taxes_no_override": 32450.1,
    "override_total_1": 33370.85,
    "override_increase_1": 920.75
  },
  {
    "#": "591 Chestnut Hill Ave (269A-17-19)",
    "$": 4604400,
    "address": "591 Chestnut Hill Ave",
    "parcel_id": "269A-17-19",
    "owner1": "CARTER, J JACQUES",
    "owner2": "FERRILL, LUELLA",
    "current_taxes": 43514.12,
    "new_taxes_no_override": 45393.93,
    "override_total_1": 46681.95,
    "override_increase_1": 1288.02
  },
  {
    "#": "605 Chestnut Hill Ave (269A-20-00)",
    "$": 2281100,
    "address": "605 Chestnut Hill Ave",
    "parcel_id": "269A-20-00",
    "owner1": "FERNANDO, JUDITH S",
    "owner2": "RAMSEY, ALVIN L JR",
    "current_taxes": 19723.53,
    "new_taxes_no_override": 20575.59,
    "override_total_1": 21159.4,
    "override_increase_1": 583.82
  },
  {
    "#": "615 Chestnut Hill Ave (269A-21-00)",
    "$": 2252100,
    "address": "615 Chestnut Hill Ave",
    "parcel_id": "269A-21-00",
    "owner1": "JAYASHANKAR, RAJ",
    "owner2": "SUBRAMANIAN, NIRUPAMA",
    "current_taxes": 19426.57,
    "new_taxes_no_override": 20265.8,
    "override_total_1": 20840.82,
    "override_increase_1": 575.03
  },
  {
    "#": "616 Chestnut Hill Ave (256A-17-00)",
    "$": 1300700,
    "address": "616 Chestnut Hill Ave",
    "parcel_id": "256A-17-00",
    "owner1": "VASQUEZ, JAIME",
    "owner2": "",
    "current_taxes": 9684.23,
    "new_taxes_no_override": 10102.59,
    "override_total_1": 10389.24,
    "override_increase_1": 286.65
  },
  {
    "#": "622 Chestnut Hill Ave (256A-16-00)",
    "$": 1101700,
    "address": "622 Chestnut Hill Ave",
    "parcel_id": "256A-16-00",
    "owner1": "LIPSON, ROGER R & ALBERTA L",
    "owner2": "",
    "current_taxes": 7646.47,
    "new_taxes_no_override": 7976.8,
    "override_total_1": 8203.13,
    "override_increase_1": 226.34
  },
  {
    "#": "625 Chestnut Hill Ave (269A-22-00)",
    "$": 1366700,
    "address": "625 Chestnut Hill Ave",
    "parcel_id": "269A-22-00",
    "owner1": "WANG, MATTHEW",
    "owner2": "",
    "current_taxes": 13995.01,
    "new_taxes_no_override": 14599.59,
    "override_total_1": 15013.85,
    "override_increase_1": 414.25
  },
  {
    "#": "628 Chestnut Hill Ave (256A-15-00)",
    "$": 1190400,
    "address": "628 Chestnut Hill Ave",
    "parcel_id": "256A-15-00",
    "owner1": "CHENG, WEN WEN TUNG",
    "owner2": "",
    "current_taxes": 12189.7,
    "new_taxes_no_override": 12716.3,
    "override_total_1": 13077.11,
    "override_increase_1": 360.82
  },
  {
    "#": "629 Chestnut Hill Ave, Unit 629-1 (269A-23-01)",
    "$": 481800,
    "address": "629 Chestnut Hill Ave, Unit 629-1",
    "parcel_id": "269A-23-01",
    "owner1": "WEN ET AL, QUAN",
    "owner2": "C/O ADAMIDIS, DEBBIE",
    "current_taxes": 4933.63,
    "new_taxes_no_override": 5146.76,
    "override_total_1": 5292.8,
    "override_increase_1": 146.04
  },
  {
    "#": "629 Chestnut Hill Ave, Unit 629-2 (269A-23-02)",
    "$": 905100,
    "address": "629 Chestnut Hill Ave, Unit 629-2",
    "parcel_id": "269A-23-02",
    "owner1": "STERN, MAX D",
    "owner2": "BURNHAM, MARGARET",
    "current_taxes": 9268.22,
    "new_taxes_no_override": 9668.61,
    "override_total_1": 9942.95,
    "override_increase_1": 274.34
  },
  {
    "#": "631 Chestnut Hill Ave, Unit 631 & P1 (269A-23-03)",
    "$": 794200,
    "address": "631 Chestnut Hill Ave, Unit 631 & P1",
    "parcel_id": "269A-23-03",
    "owner1": "MATARAZA, JOHN J III & JENNIFER M",
    "owner2": "",
    "current_taxes": 4497.67,
    "new_taxes_no_override": 4691.97,
    "override_total_1": 4825.1,
    "override_increase_1": 133.13
  },
  {
    "#": "633 Chestnut Hill Ave (269A-24-00)",
    "$": 1501200,
    "address": "633 Chestnut Hill Ave",
    "parcel_id": "269A-24-00",
    "owner1": "RHEE, CHANU",
    "owner2": "CHEN, XI",
    "current_taxes": 11737.35,
    "new_taxes_no_override": 12244.4,
    "override_total_1": 12591.83,
    "override_increase_1": 347.43
  },
  {
    "#": "634 Chestnut Hill Ave (256A-14-00)",
    "$": 1381200,
    "address": "634 Chestnut Hill Ave",
    "parcel_id": "256A-14-00",
    "owner1": "NAGGAR LIFE ESTATE, REGINA",
    "owner2": "",
    "current_taxes": 10508.55,
    "new_taxes_no_override": 10962.52,
    "override_total_1": 11273.57,
    "override_increase_1": 311.05
  },
  {
    "#": "635 Chestnut Hill Ave, Unit 1 & P3-4 (269A-25-01)",
    "$": 1760600,
    "address": "635 Chestnut Hill Ave, Unit 1 & P3-4",
    "parcel_id": "269A-25-01",
    "owner1": "HAWES, GREGORY",
    "owner2": "ROVIS, MARIA GABRIELLA",
    "current_taxes": 14393.61,
    "new_taxes_no_override": 15015.41,
    "override_total_1": 15441.46,
    "override_increase_1": 426.05
  },
  {
    "#": "635 Chestnut Hill Ave, Unit 2 & P1-2 (269A-25-02)",
    "$": 1745700,
    "address": "635 Chestnut Hill Ave, Unit 2 & P1-2",
    "parcel_id": "269A-25-02",
    "owner1": "PENG, CHUNLI",
    "owner2": "",
    "current_taxes": 17875.97,
    "new_taxes_no_override": 18648.21,
    "override_total_1": 19177.34,
    "override_increase_1": 529.13
  },
  {
    "#": "639 Chestnut Hill Ave, Unit 1 & P5 (269A-26-01)",
    "$": 688800,
    "address": "639 Chestnut Hill Ave, Unit 1 & P5",
    "parcel_id": "269A-26-01",
    "owner1": "PATWARDHAN, DHRUV & RUTUJA KHARE",
    "owner2": "",
    "current_taxes": 3418.38,
    "new_taxes_no_override": 3566.05,
    "override_total_1": 3667.24,
    "override_increase_1": 101.18
  },
  {
    "#": "639 Chestnut Hill Ave, Unit 2 & P3-4 (269A-26-02)",
    "$": 712100,
    "address": "639 Chestnut Hill Ave, Unit 2 & P3-4",
    "parcel_id": "269A-26-02",
    "owner1": "IM, NAKYUNG",
    "owner2": "",
    "current_taxes": 3656.97,
    "new_taxes_no_override": 3814.95,
    "override_total_1": 3923.2,
    "override_increase_1": 108.25
  },
  {
    "#": "639 Chestnut Hill Ave, Unit 3 & P1 P2 (269A-26-03)",
    "$": 922100,
    "address": "639 Chestnut Hill Ave, Unit 3 & P1 P2",
    "parcel_id": "269A-26-03",
    "owner1": "PAGE, BENJAMIN",
    "owner2": "",
    "current_taxes": 5807.37,
    "new_taxes_no_override": 6058.25,
    "override_total_1": 6230.15,
    "override_increase_1": 171.9
  },
  {
    "#": "641 Chestnut Hill Ave (269A-27-00)",
    "$": 988600,
    "address": "641 Chestnut Hill Ave",
    "parcel_id": "269A-27-00",
    "owner1": "641 CHESTNUT AVE LLC",
    "owner2": "",
    "current_taxes": 10123.26,
    "new_taxes_no_override": 10560.58,
    "override_total_1": 10860.23,
    "override_increase_1": 299.65
  },
  {
    "#": "642 Chestnut Hill Ave (256A-13-02)",
    "$": 1726800,
    "address": "642 Chestnut Hill Ave",
    "parcel_id": "256A-13-02",
    "owner1": "MONTROND, ALBERTO M",
    "owner2": "SAVOIA, ELENA",
    "current_taxes": 14047.5,
    "new_taxes_no_override": 14654.35,
    "override_total_1": 15070.16,
    "override_increase_1": 415.81
  },
  {
    "#": "643 Chestnut Hill Ave, Unit 1 P 1 & 2 (269A-28-03)",
    "$": 741400,
    "address": "643 Chestnut Hill Ave, Unit 1 P 1 & 2",
    "parcel_id": "269A-28-03",
    "owner1": "BACON, ROBERT & AMY",
    "owner2": "",
    "current_taxes": 3957.0,
    "new_taxes_no_override": 4127.94,
    "override_total_1": 4245.07,
    "override_increase_1": 117.13
  },
  {
    "#": "643 Chestnut Hill Ave, Unit 2 & P3-P4 (269A-28-01)",
    "$": 763700,
    "address": "643 Chestnut Hill Ave, Unit 2 & P3-P4",
    "parcel_id": "269A-28-01",
    "owner1": "MOORTHY, SYONA & CHETAN S",
    "owner2": "CHHEDA, SADHANA",
    "current_taxes": 4185.35,
    "new_taxes_no_override": 4366.16,
    "override_total_1": 4490.04,
    "override_increase_1": 123.89
  },
  {
    "#": "643 Chestnut Hill Ave, Unit 3 & P5-6 (269A-28-02)",
    "$": 1037800,
    "address": "643 Chestnut Hill Ave, Unit 3 & P5-6",
    "parcel_id": "269A-28-02",
    "owner1": "REGAN, COLM",
    "owner2": "DUBE, CAROL MILBURY",
    "current_taxes": 6992.14,
    "new_taxes_no_override": 7294.2,
    "override_total_1": 7501.17,
    "override_increase_1": 206.97
  },
  {
    "#": "645 Chestnut Hill Ave (269A-29-00)",
    "$": 973700,
    "address": "645 Chestnut Hill Ave",
    "parcel_id": "269A-29-00",
    "owner1": "CHAN, KAM M & LAN S",
    "owner2": "",
    "current_taxes": 6335.75,
    "new_taxes_no_override": 6609.45,
    "override_total_1": 6796.99,
    "override_increase_1": 187.54
  },
  {
    "#": "650 Chestnut Hill Ave (256A-12-01)",
    "$": 1114100,
    "address": "650 Chestnut Hill Ave",
    "parcel_id": "256A-12-01",
    "owner1": "CHU, BENNY P & SIUMAN",
    "owner2": "",
    "current_taxes": 7773.45,
    "new_taxes_no_override": 8109.26,
    "override_total_1": 8339.36,
    "override_increase_1": 230.09
  },
  {
    "#": "651 Chestnut Hill Ave (269A-30-00)",
    "$": 2177700,
    "address": "651 Chestnut Hill Ave",
    "parcel_id": "269A-30-00",
    "owner1": "CASEY, JOSEPH B",
    "owner2": "",
    "current_taxes": 18664.71,
    "new_taxes_no_override": 19471.03,
    "override_total_1": 20023.5,
    "override_increase_1": 552.48
  },
  {
    "#": "653 Chestnut Hill Ave (269A-31-00)",
    "$": 1267600,
    "address": "653 Chestnut Hill Ave",
    "parcel_id": "269A-31-00",
    "owner1": "HEFTER, JESSE & BRENDA",
    "owner2": "",
    "current_taxes": 9345.29,
    "new_taxes_no_override": 9749.01,
    "override_total_1": 10025.63,
    "override_increase_1": 276.62
  },
  {
    "#": "654 Chestnut Hill Ave (256A-12-00)",
    "$": 1425500,
    "address": "654 Chestnut Hill Ave",
    "parcel_id": "256A-12-00",
    "owner1": "BARBARIN, EDWIN ANDRES",
    "owner2": "GAN, SIEW TIN",
    "current_taxes": 10962.19,
    "new_taxes_no_override": 11435.76,
    "override_total_1": 11760.24,
    "override_increase_1": 324.48
  },
  {
    "#": "656 Chestnut Hill Ave (256A-11-01)",
    "$": 1080300,
    "address": "656 Chestnut Hill Ave",
    "parcel_id": "256A-11-01",
    "owner1": "WU, HUIQING & RUNLIN",
    "owner2": "KANG, XUEZHEN",
    "current_taxes": 7427.34,
    "new_taxes_no_override": 7748.2,
    "override_total_1": 7968.05,
    "override_increase_1": 219.85
  },
  {
    "#": "657 Chestnut Hill Ave (269A-32-00)",
    "$": 1139900,
    "address": "657 Chestnut Hill Ave",
    "parcel_id": "269A-32-00",
    "owner1": "TSOLOV, PLAMEN & SAORI",
    "owner2": "",
    "current_taxes": 8037.64,
    "new_taxes_no_override": 8384.87,
    "override_total_1": 8622.78,
    "override_increase_1": 237.91
  },
  {
    "#": "660 Chestnut Hill Ave (256A-11-00)",
    "$": 1147200,
    "address": "660 Chestnut Hill Ave",
    "parcel_id": "256A-11-00",
    "owner1": "HEFTER, SHEERA & BRENDA & JESSE",
    "owner2": "",
    "current_taxes": 8112.39,
    "new_taxes_no_override": 8462.85,
    "override_total_1": 8702.97,
    "override_increase_1": 240.13
  },
  {
    "#": "661 Chestnut Hill Ave, Unit 661 (269A-33-01)",
    "$": 1603200,
    "address": "661 Chestnut Hill Ave, Unit 661",
    "parcel_id": "269A-33-01",
    "owner1": "CUI, LONGQUAN",
    "owner2": "ZHAO, QIAN",
    "current_taxes": 16416.77,
    "new_taxes_no_override": 17125.97,
    "override_total_1": 17611.91,
    "override_increase_1": 485.94
  },
  {
    "#": "661 Chestnut Hill Ave, Unit 663 (269A-33-02)",
    "$": 1597500,
    "address": "661 Chestnut Hill Ave, Unit 663",
    "parcel_id": "269A-33-02",
    "owner1": "SILK, ELI M & ANN WILLMAN",
    "owner2": "",
    "current_taxes": 12723.47,
    "new_taxes_no_override": 13273.12,
    "override_total_1": 13649.74,
    "override_increase_1": 376.61
  },
  {
    "#": "662 Chestnut Hill Ave (256A-10-00)",
    "$": 1833200,
    "address": "662 Chestnut Hill Ave",
    "parcel_id": "256A-10-00",
    "owner1": "GALATIS, TR, FRANCES J",
    "owner2": "",
    "current_taxes": 15137.03,
    "new_taxes_no_override": 15790.95,
    "override_total_1": 16239.01,
    "override_increase_1": 448.06
  },
  {
    "#": "667 Chestnut Hill Ave (269A-34-00)",
    "$": 1631900,
    "address": "667 Chestnut Hill Ave",
    "parcel_id": "269A-34-00",
    "owner1": "BHIMANI, ARIF G",
    "owner2": "",
    "current_taxes": 13075.72,
    "new_taxes_no_override": 13640.59,
    "override_total_1": 14027.63,
    "override_increase_1": 387.04
  },
  {
    "#": "671 Chestnut Hill Ave (269A-35-00)",
    "$": 1440700,
    "address": "671 Chestnut Hill Ave",
    "parcel_id": "269A-35-00",
    "owner1": "OGRADY, JOHN MICHAEL & EILEEN",
    "owner2": "",
    "current_taxes": 11117.83,
    "new_taxes_no_override": 11598.12,
    "override_total_1": 11927.21,
    "override_increase_1": 329.09
  },
  {
    "#": "672 Chestnut Hill Ave (256A-09-00)",
    "$": 2525900,
    "address": "672 Chestnut Hill Ave",
    "parcel_id": "256A-09-00",
    "owner1": "MURPHY, D PAUL & ANABELLE",
    "owner2": "",
    "current_taxes": 22230.28,
    "new_taxes_no_override": 23190.63,
    "override_total_1": 23848.64,
    "override_increase_1": 658.02
  },
  {
    "#": "675 Chestnut Hill Ave (269A-36-00)",
    "$": 1163800,
    "address": "675 Chestnut Hill Ave",
    "parcel_id": "269A-36-00",
    "owner1": "PORTER, COLIN",
    "owner2": "MCGINNESS, ELIZABETH",
    "current_taxes": 11917.31,
    "new_taxes_no_override": 12432.14,
    "override_total_1": 12784.89,
    "override_increase_1": 352.75
  },
  {
    "#": "1 Chestnut Pl (329-13-00)",
    "$": 6955900,
    "address": "1 Chestnut Pl",
    "parcel_id": "329-13-00",
    "owner1": "RIEHL, PETER W",
    "owner2": "HORNE, ALLISON",
    "current_taxes": 67593.48,
    "new_taxes_no_override": 70513.52,
    "override_total_1": 72514.29,
    "override_increase_1": 2000.77
  },
  {
    "#": "11 Chestnut Pl (329-14-01)",
    "$": 6449700,
    "address": "11 Chestnut Pl",
    "parcel_id": "329-14-01",
    "owner1": "KLEMPNER, BRYCE",
    "owner2": "AFRICA, JULIA",
    "current_taxes": 62409.99,
    "new_taxes_no_override": 65106.1,
    "override_total_1": 66953.44,
    "override_increase_1": 1847.34
  },
  {
    "#": "13 Chestnut Pl (329-14-02)",
    "$": 2069600,
    "address": "13 Chestnut Pl",
    "parcel_id": "329-14-02",
    "owner1": "KLEMPNER, BRYCE",
    "owner2": "AFRICA, JULIA",
    "current_taxes": 21192.7,
    "new_taxes_no_override": 22108.22,
    "override_total_1": 22735.53,
    "override_increase_1": 627.3
  },
  {
    "#": "18 Chestnut Pl, Unit 18 (330-15-00)",
    "$": 1122900,
    "address": "18 Chestnut Pl, Unit 18",
    "parcel_id": "330-15-00",
    "owner1": "KAUFMAN TRS, SUSAN",
    "owner2": "",
    "current_taxes": 7863.56,
    "new_taxes_no_override": 8203.27,
    "override_total_1": 8436.03,
    "override_increase_1": 232.76
  },
  {
    "#": "22 Chestnut Pl, Unit 102 & P121 (330-11-02)",
    "$": 703900,
    "address": "22 Chestnut Pl, Unit 102 & P121",
    "parcel_id": "330-11-02",
    "owner1": "REN, YINXIA",
    "owner2": "",
    "current_taxes": 7207.94,
    "new_taxes_no_override": 7519.32,
    "override_total_1": 7732.68,
    "override_increase_1": 213.36
  },
  {
    "#": "22 Chestnut Pl, Unit 103 & P112 (330-11-03)",
    "$": 558500,
    "address": "22 Chestnut Pl, Unit 103 & P112",
    "parcel_id": "330-11-03",
    "owner1": "WHELAN, DEIRDRE",
    "owner2": "",
    "current_taxes": 2084.11,
    "new_taxes_no_override": 2174.14,
    "override_total_1": 2235.83,
    "override_increase_1": 61.69
  },
  {
    "#": "22 Chestnut Pl, Unit 104 & P117 (330-11-04)",
    "$": 658300,
    "address": "22 Chestnut Pl, Unit 104 & P117",
    "parcel_id": "330-11-04",
    "owner1": "GUI, FU",
    "owner2": "JIANG, JIE",
    "current_taxes": 3106.06,
    "new_taxes_no_override": 3240.24,
    "override_total_1": 3332.18,
    "override_increase_1": 91.94
  },
  {
    "#": "22 Chestnut Pl, Unit 105 & P111 (330-11-05)",
    "$": 680000,
    "address": "22 Chestnut Pl, Unit 105 & P111",
    "parcel_id": "330-11-05",
    "owner1": "HE, XIANBAO",
    "owner2": "LAI, JUYING",
    "current_taxes": 3328.27,
    "new_taxes_no_override": 3472.05,
    "override_total_1": 3570.57,
    "override_increase_1": 98.52
  },
  {
    "#": "22 Chestnut Pl, Unit 106 & P8 (330-11-06)",
    "$": 570400,
    "address": "22 Chestnut Pl, Unit 106 & P8",
    "parcel_id": "330-11-06",
    "owner1": "YANAGISAWA, GEORGE K & YURIKO I",
    "owner2": "",
    "current_taxes": 2205.96,
    "new_taxes_no_override": 2301.26,
    "override_total_1": 2366.55,
    "override_increase_1": 65.3
  },
  {
    "#": "22 Chestnut Pl, Unit 107 & P51 (330-11-07)",
    "$": 517900,
    "address": "22 Chestnut Pl, Unit 107 & P51",
    "parcel_id": "330-11-07",
    "owner1": "GALLAGHER-MEDEIROS, EMILY",
    "owner2": "",
    "current_taxes": 1668.36,
    "new_taxes_no_override": 1740.43,
    "override_total_1": 1789.82,
    "override_increase_1": 49.38
  },
  {
    "#": "22 Chestnut Pl, Unit 108 & P114 (330-11-08)",
    "$": 525100,
    "address": "22 Chestnut Pl, Unit 108 & P114",
    "parcel_id": "330-11-08",
    "owner1": "DANIELS, RACHEL A",
    "owner2": "",
    "current_taxes": 1742.09,
    "new_taxes_no_override": 1817.35,
    "override_total_1": 1868.91,
    "override_increase_1": 51.57
  },
  {
    "#": "22 Chestnut Pl, Unit 109 & P113 (330-11-09)",
    "$": 375500,
    "address": "22 Chestnut Pl, Unit 109 & P113",
    "parcel_id": "330-11-09",
    "owner1": "KADISH, ELIZABETH B",
    "owner2": "",
    "current_taxes": 384.51,
    "new_taxes_no_override": 401.12,
    "override_total_1": 412.5,
    "override_increase_1": 11.38
  },
  {
    "#": "22 Chestnut Pl, Unit 110 & P40 (330-11-10)",
    "$": 579600,
    "address": "22 Chestnut Pl, Unit 110 & P40",
    "parcel_id": "330-11-10",
    "owner1": "HSU, LI & CHING",
    "owner2": "",
    "current_taxes": 2300.17,
    "new_taxes_no_override": 2399.54,
    "override_total_1": 2467.62,
    "override_increase_1": 68.09
  },
  {
    "#": "22 Chestnut Pl, Unit 111 & P120 (330-11-11)",
    "$": 580300,
    "address": "22 Chestnut Pl, Unit 111 & P120",
    "parcel_id": "330-11-11",
    "owner1": "TANRIKULU, LISA & OSMAN",
    "owner2": "",
    "current_taxes": 2307.34,
    "new_taxes_no_override": 2407.02,
    "override_total_1": 2475.31,
    "override_increase_1": 68.3
  },
  {
    "#": "22 Chestnut Pl, Unit 112 & P92 (330-11-12)",
    "$": 707300,
    "address": "22 Chestnut Pl, Unit 112 & P92",
    "parcel_id": "330-11-12",
    "owner1": "SIMMONS, DAIMON PETER",
    "owner2": "TOSKA, JONIDA",
    "current_taxes": 3607.82,
    "new_taxes_no_override": 3763.68,
    "override_total_1": 3870.47,
    "override_increase_1": 106.79
  },
  {
    "#": "22 Chestnut Pl, Unit 114 & P56 (330-11-13)",
    "$": 674500,
    "address": "22 Chestnut Pl, Unit 114 & P56",
    "parcel_id": "330-11-13",
    "owner1": "CAO, YANHUA",
    "owner2": "",
    "current_taxes": 6906.88,
    "new_taxes_no_override": 7205.26,
    "override_total_1": 7409.7,
    "override_increase_1": 204.44
  },
  {
    "#": "22 Chestnut Pl, Unit 115 & P75 (330-11-14)",
    "$": 517100,
    "address": "22 Chestnut Pl, Unit 115 & P75",
    "parcel_id": "330-11-14",
    "owner1": "WANG TRS, GINGKUO & SHO YA",
    "owner2": "",
    "current_taxes": 5295.1,
    "new_taxes_no_override": 5523.85,
    "override_total_1": 5680.58,
    "override_increase_1": 156.73
  },
  {
    "#": "22 Chestnut Pl, Unit 116 & P22 (330-11-15)",
    "$": 671100,
    "address": "22 Chestnut Pl, Unit 116 & P22",
    "parcel_id": "330-11-15",
    "owner1": "SNELL TR, BRADLEY A",
    "owner2": "",
    "current_taxes": 3237.13,
    "new_taxes_no_override": 3376.97,
    "override_total_1": 3472.79,
    "override_increase_1": 95.82
  },
  {
    "#": "22 Chestnut Pl, Unit 117 P67&73 (330-11-16)",
    "$": 660900,
    "address": "22 Chestnut Pl, Unit 117 P67&73",
    "parcel_id": "330-11-16",
    "owner1": "ENG, MELISSA & DANIEL",
    "owner2": "",
    "current_taxes": 6767.62,
    "new_taxes_no_override": 7059.98,
    "override_total_1": 7260.3,
    "override_increase_1": 200.32
  },
  {
    "#": "22 Chestnut Pl, Unit 201 & P62 (330-11-17)",
    "$": 673800,
    "address": "22 Chestnut Pl, Unit 201 & P62",
    "parcel_id": "330-11-17",
    "owner1": "QIU, JINGYI",
    "owner2": "ZHENG, YUCHEN",
    "current_taxes": 3264.78,
    "new_taxes_no_override": 3405.82,
    "override_total_1": 3502.46,
    "override_increase_1": 96.64
  },
  {
    "#": "22 Chestnut Pl, Unit 202 & P64 (330-11-18)",
    "$": 517900,
    "address": "22 Chestnut Pl, Unit 202 & P64",
    "parcel_id": "330-11-18",
    "owner1": "MISTRY, KAVITA",
    "owner2": "",
    "current_taxes": 1668.36,
    "new_taxes_no_override": 1740.43,
    "override_total_1": 1789.82,
    "override_increase_1": 49.38
  },
  {
    "#": "22 Chestnut Pl, Unit 203 & P44 (330-11-19)",
    "$": 554400,
    "address": "22 Chestnut Pl, Unit 203 & P44",
    "parcel_id": "330-11-19",
    "owner1": "LI, HONGYUN",
    "owner2": "",
    "current_taxes": 2042.12,
    "new_taxes_no_override": 2130.34,
    "override_total_1": 2190.79,
    "override_increase_1": 60.45
  },
  {
    "#": "22 Chestnut Pl, Unit 204 & P115 (330-11-20)",
    "$": 665400,
    "address": "22 Chestnut Pl, Unit 204 & P115",
    "parcel_id": "330-11-20",
    "owner1": "WANG, YING",
    "owner2": "",
    "current_taxes": 6813.7,
    "new_taxes_no_override": 7108.05,
    "override_total_1": 7309.74,
    "override_increase_1": 201.69
  },
  {
    "#": "22 Chestnut Pl, Unit 205 & P20 (330-11-21)",
    "$": 715000,
    "address": "22 Chestnut Pl, Unit 205 & P20",
    "parcel_id": "330-11-21",
    "owner1": "DAVIDSON LIFE ESTATE, ALEXANDER & IRINA M",
    "owner2": "",
    "current_taxes": 3686.67,
    "new_taxes_no_override": 3845.93,
    "override_total_1": 3955.06,
    "override_increase_1": 109.13
  },
  {
    "#": "22 Chestnut Pl, Unit 206 & P58 (330-11-22)",
    "$": 544200,
    "address": "22 Chestnut Pl, Unit 206 & P58",
    "parcel_id": "330-11-22",
    "owner1": "KINSCHERFF, ROBERT THOMSON",
    "owner2": "LANE, AMY-FEONA",
    "current_taxes": 5572.61,
    "new_taxes_no_override": 5813.35,
    "override_total_1": 5978.3,
    "override_increase_1": 164.95
  },
  {
    "#": "22 Chestnut Pl, Unit 207 & P98 (330-11-23)",
    "$": 570300,
    "address": "22 Chestnut Pl, Unit 207 & P98",
    "parcel_id": "330-11-23",
    "owner1": "CLAYMAN, LISA",
    "owner2": "",
    "current_taxes": 2204.94,
    "new_taxes_no_override": 2300.19,
    "override_total_1": 2365.46,
    "override_increase_1": 65.27
  },
  {
    "#": "22 Chestnut Pl, Unit 208 & P63 (330-11-24)",
    "$": 535000,
    "address": "22 Chestnut Pl, Unit 208 & P63",
    "parcel_id": "330-11-24",
    "owner1": "MADABHUSHI, SRAVYA & RAVI",
    "owner2": "",
    "current_taxes": 1843.47,
    "new_taxes_no_override": 1923.11,
    "override_total_1": 1977.67,
    "override_increase_1": 54.57
  },
  {
    "#": "22 Chestnut Pl, Unit 209 & P41 (330-11-25)",
    "$": 389100,
    "address": "22 Chestnut Pl, Unit 209 & P41",
    "parcel_id": "330-11-25",
    "owner1": "GALLAGHER, EMILY R",
    "owner2": "",
    "current_taxes": 3984.38,
    "new_taxes_no_override": 4156.51,
    "override_total_1": 4274.44,
    "override_increase_1": 117.94
  },
  {
    "#": "22 Chestnut Pl, Unit 210 & P2 (330-11-26)",
    "$": 569700,
    "address": "22 Chestnut Pl, Unit 210 & P2",
    "parcel_id": "330-11-26",
    "owner1": "KINIRY TR, EDWARD J",
    "owner2": "",
    "current_taxes": 5833.73,
    "new_taxes_no_override": 6085.75,
    "override_total_1": 6258.43,
    "override_increase_1": 172.68
  },
  {
    "#": "22 Chestnut Pl, Unit 211 & P89 (330-11-27)",
    "$": 566800,
    "address": "22 Chestnut Pl, Unit 211 & P89",
    "parcel_id": "330-11-27",
    "owner1": "ASHER, ISAAC",
    "owner2": "",
    "current_taxes": 2169.1,
    "new_taxes_no_override": 2262.81,
    "override_total_1": 2327.01,
    "override_increase_1": 64.21
  },
  {
    "#": "22 Chestnut Pl, Unit 212 & P11 (330-11-28)",
    "$": 715400,
    "address": "22 Chestnut Pl, Unit 212 & P11",
    "parcel_id": "330-11-28",
    "owner1": "FRADKOV TR, ANNA",
    "owner2": "",
    "current_taxes": 3690.76,
    "new_taxes_no_override": 3850.2,
    "override_total_1": 3959.45,
    "override_increase_1": 109.25
  },
  {
    "#": "22 Chestnut Pl, Unit 214 17&116 (330-11-29)",
    "$": 708600,
    "address": "22 Chestnut Pl, Unit 214 17&116",
    "parcel_id": "330-11-29",
    "owner1": "SCHARF ESTATE LLC",
    "owner2": "SCHARF, JONATHAN L",
    "current_taxes": 7256.06,
    "new_taxes_no_override": 7569.52,
    "override_total_1": 7784.3,
    "override_increase_1": 214.78
  },
  {
    "#": "22 Chestnut Pl, Unit 215 & P37 (330-11-30)",
    "$": 554400,
    "address": "22 Chestnut Pl, Unit 215 & P37",
    "parcel_id": "330-11-30",
    "owner1": "BEHROOZI, MEHDI",
    "owner2": "",
    "current_taxes": 5677.06,
    "new_taxes_no_override": 5922.31,
    "override_total_1": 6090.35,
    "override_increase_1": 168.04
  },
  {
    "#": "22 Chestnut Pl, Unit 216 & P13 (330-11-31)",
    "$": 670000,
    "address": "22 Chestnut Pl, Unit 216 & P13",
    "parcel_id": "330-11-31",
    "owner1": "RIVERA, FEDERICO",
    "owner2": "WU, FENG",
    "current_taxes": 6860.8,
    "new_taxes_no_override": 7157.19,
    "override_total_1": 7360.27,
    "override_increase_1": 203.08
  },
  {
    "#": "22 Chestnut Pl, Unit 217 & P123 (330-11-32)",
    "$": 666700,
    "address": "22 Chestnut Pl, Unit 217 & P123",
    "parcel_id": "330-11-32",
    "owner1": "LOPATIN TRS, ALEXANDER & YELENA",
    "owner2": "",
    "current_taxes": 3192.07,
    "new_taxes_no_override": 3329.97,
    "override_total_1": 3424.45,
    "override_increase_1": 94.49
  },
  {
    "#": "22 Chestnut Pl, Unit 301 & P38 (330-11-33)",
    "$": 658200,
    "address": "22 Chestnut Pl, Unit 301 & P38",
    "parcel_id": "330-11-33",
    "owner1": "BUDMAN TR, RAISA S",
    "owner2": "",
    "current_taxes": 3105.03,
    "new_taxes_no_override": 3239.17,
    "override_total_1": 3331.08,
    "override_increase_1": 91.91
  },
  {
    "#": "22 Chestnut Pl, Unit 302 & P90 (330-11-34)",
    "$": 537700,
    "address": "22 Chestnut Pl, Unit 302 & P90",
    "parcel_id": "330-11-34",
    "owner1": "SCHRAGE, REBECCA K & MICHAEL M",
    "owner2": "",
    "current_taxes": 5506.05,
    "new_taxes_no_override": 5743.91,
    "override_total_1": 5906.89,
    "override_increase_1": 162.98
  },
  {
    "#": "22 Chestnut Pl, Unit 303 & P29 (330-11-35)",
    "$": 569300,
    "address": "22 Chestnut Pl, Unit 303 & P29",
    "parcel_id": "330-11-35",
    "owner1": "BANAR TRS, SOPHIA V",
    "owner2": "BROOK, SIMON V",
    "current_taxes": 5829.63,
    "new_taxes_no_override": 6081.47,
    "override_total_1": 6254.03,
    "override_increase_1": 172.56
  },
  {
    "#": "22 Chestnut Pl, Unit 304 & P76 (330-11-36)",
    "$": 674900,
    "address": "22 Chestnut Pl, Unit 304 & P76",
    "parcel_id": "330-11-36",
    "owner1": "ITO, AKI TANAKA",
    "owner2": "",
    "current_taxes": 3276.04,
    "new_taxes_no_override": 3417.56,
    "override_total_1": 3514.54,
    "override_increase_1": 96.97
  },
  {
    "#": "22 Chestnut Pl, Unit 305 & P71 (330-11-37)",
    "$": 692000,
    "address": "22 Chestnut Pl, Unit 305 & P71",
    "parcel_id": "330-11-37",
    "owner1": "MANDEL, NANCY",
    "owner2": "",
    "current_taxes": 3451.15,
    "new_taxes_no_override": 3600.24,
    "override_total_1": 3702.39,
    "override_increase_1": 102.15
  },
  {
    "#": "22 Chestnut Pl, Unit 306 & P84 (330-11-38)",
    "$": 562500,
    "address": "22 Chestnut Pl, Unit 306 & P84",
    "parcel_id": "330-11-38",
    "owner1": "WANG, HUIHONG",
    "owner2": "",
    "current_taxes": 5760.0,
    "new_taxes_no_override": 6008.83,
    "override_total_1": 6179.33,
    "override_increase_1": 170.5
  },
  {
    "#": "22 Chestnut Pl, Unit 307 & P119 (330-11-39)",
    "$": 538700,
    "address": "22 Chestnut Pl, Unit 307 & P119",
    "parcel_id": "330-11-39",
    "owner1": "LI, YIFEI",
    "owner2": "GU, RONG",
    "current_taxes": 1881.35,
    "new_taxes_no_override": 1962.62,
    "override_total_1": 2018.31,
    "override_increase_1": 55.69
  },
  {
    "#": "22 Chestnut Pl, Unit 308 & P45 (330-11-40)",
    "$": 534900,
    "address": "22 Chestnut Pl, Unit 308 & P45",
    "parcel_id": "330-11-40",
    "owner1": "KAPOOR, SEERAT",
    "owner2": "",
    "current_taxes": 1842.44,
    "new_taxes_no_override": 1922.03,
    "override_total_1": 1976.57,
    "override_increase_1": 54.54
  },
  {
    "#": "22 Chestnut Pl, Unit 309 & P85 (330-11-41)",
    "$": 401900,
    "address": "22 Chestnut Pl, Unit 309 & P85",
    "parcel_id": "330-11-41",
    "owner1": "NORTH AMERICAN CONSULTING SRV",
    "owner2": "",
    "current_taxes": 4115.46,
    "new_taxes_no_override": 4293.25,
    "override_total_1": 4415.07,
    "override_increase_1": 121.82
  },
  {
    "#": "22 Chestnut Pl, Unit 310 & P88 (330-11-42)",
    "$": 539500,
    "address": "22 Chestnut Pl, Unit 310 & P88",
    "parcel_id": "330-11-42",
    "owner1": "BASSIACOS, JORG",
    "owner2": "",
    "current_taxes": 5524.48,
    "new_taxes_no_override": 5763.14,
    "override_total_1": 5926.66,
    "override_increase_1": 163.52
  },
  {
    "#": "22 Chestnut Pl, Unit 311 & P72 (330-11-43)",
    "$": 563200,
    "address": "22 Chestnut Pl, Unit 311 & P72",
    "parcel_id": "330-11-43",
    "owner1": "ANTIKAROV, VLADIMIR",
    "owner2": "",
    "current_taxes": 5767.17,
    "new_taxes_no_override": 6016.31,
    "override_total_1": 6187.02,
    "override_increase_1": 170.71
  },
  {
    "#": "22 Chestnut Pl, Unit 312 & P35 (330-11-44)",
    "$": 673600,
    "address": "22 Chestnut Pl, Unit 312 & P35",
    "parcel_id": "330-11-44",
    "owner1": "VELICHANSKY, LEONID & LEANNE",
    "owner2": "",
    "current_taxes": 6897.66,
    "new_taxes_no_override": 7195.64,
    "override_total_1": 7399.81,
    "override_increase_1": 204.17
  },
  {
    "#": "22 Chestnut Pl, Unit 314 P82-83 (330-11-45)",
    "$": 773300,
    "address": "22 Chestnut Pl, Unit 314 P82-83",
    "parcel_id": "330-11-45",
    "owner1": "LUAN, BAI",
    "owner2": "ZHOU, MENGYING",
    "current_taxes": 4283.66,
    "new_taxes_no_override": 4468.71,
    "override_total_1": 4595.51,
    "override_increase_1": 126.8
  },
  {
    "#": "22 Chestnut Pl, Unit 315 & P34 (330-11-46)",
    "$": 583900,
    "address": "22 Chestnut Pl, Unit 315 & P34",
    "parcel_id": "330-11-46",
    "owner1": "LUAN, BAI",
    "owner2": "ZHOU, MENGYING",
    "current_taxes": 5979.14,
    "new_taxes_no_override": 6237.44,
    "override_total_1": 6414.42,
    "override_increase_1": 176.98
  },
  {
    "#": "22 Chestnut Pl, Unit 316 P47&50 (330-11-47)",
    "$": 745300,
    "address": "22 Chestnut Pl, Unit 316 P47&50",
    "parcel_id": "330-11-47",
    "owner1": "AU-YEUNG, PO YEE ROSA",
    "owner2": "",
    "current_taxes": 7631.87,
    "new_taxes_no_override": 7961.57,
    "override_total_1": 8187.47,
    "override_increase_1": 225.9
  },
  {
    "#": "22 Chestnut Pl, Unit 317 P81-33 (330-11-48)",
    "$": 763300,
    "address": "22 Chestnut Pl, Unit 317 P81-33",
    "parcel_id": "330-11-48",
    "owner1": "LISOVSKY, MIKHAIL",
    "owner2": "STAROSELSKAYA, IRINA",
    "current_taxes": 7816.19,
    "new_taxes_no_override": 8153.85,
    "override_total_1": 8385.21,
    "override_increase_1": 231.36
  },
  {
    "#": "22 Chestnut Pl, Unit 401 & P12 (330-11-49)",
    "$": 782100,
    "address": "22 Chestnut Pl, Unit 401 & P12",
    "parcel_id": "330-11-49",
    "owner1": "LEVI TRS, PAUL A JR",
    "owner2": "BALK ET AL, MARK D",
    "current_taxes": 4373.77,
    "new_taxes_no_override": 4562.72,
    "override_total_1": 4692.18,
    "override_increase_1": 129.46
  },
  {
    "#": "22 Chestnut Pl, Unit 402 & P87 (330-11-50)",
    "$": 570300,
    "address": "22 Chestnut Pl, Unit 402 & P87",
    "parcel_id": "330-11-50",
    "owner1": "SEREBRYANIK, IRINA",
    "owner2": "ZAVIZION, BORIS",
    "current_taxes": 5839.87,
    "new_taxes_no_override": 6092.15,
    "override_total_1": 6265.01,
    "override_increase_1": 172.86
  },
  {
    "#": "22 Chestnut Pl, Unit 403 & P95 (330-11-51)",
    "$": 593100,
    "address": "22 Chestnut Pl, Unit 403 & P95",
    "parcel_id": "330-11-51",
    "owner1": "ZHU, RUIQI",
    "owner2": "",
    "current_taxes": 2438.41,
    "new_taxes_no_override": 2543.75,
    "override_total_1": 2615.93,
    "override_increase_1": 72.18
  },
  {
    "#": "22 Chestnut Pl, Unit 404 & P99 (330-11-52)",
    "$": 656900,
    "address": "22 Chestnut Pl, Unit 404 & P99",
    "parcel_id": "330-11-52",
    "owner1": "FISHER, LISTO A",
    "owner2": "RODMAN, LYDIA CARR",
    "current_taxes": 3091.72,
    "new_taxes_no_override": 3225.28,
    "override_total_1": 3316.8,
    "override_increase_1": 91.51
  },
  {
    "#": "22 Chestnut Pl, Unit 405 & P28 (330-11-53)",
    "$": 737900,
    "address": "22 Chestnut Pl, Unit 405 & P28",
    "parcel_id": "330-11-53",
    "owner1": "DALLAL TRS, AMIR DAVID & RONNA M",
    "owner2": "",
    "current_taxes": 3921.16,
    "new_taxes_no_override": 4090.55,
    "override_total_1": 4206.62,
    "override_increase_1": 116.07
  },
  {
    "#": "22 Chestnut Pl, Unit 406 & P21 (330-11-54)",
    "$": 600900,
    "address": "22 Chestnut Pl, Unit 406 & P21",
    "parcel_id": "330-11-54",
    "owner1": "CURNIN TR, BRENDA BOCINA",
    "owner2": "",
    "current_taxes": 6153.22,
    "new_taxes_no_override": 6419.04,
    "override_total_1": 6601.17,
    "override_increase_1": 182.14
  },
  {
    "#": "22 Chestnut Pl, Unit 407 & P49 (330-11-55)",
    "$": 538400,
    "address": "22 Chestnut Pl, Unit 407 & P49",
    "parcel_id": "330-11-55",
    "owner1": "STELIN, IGOR",
    "owner2": "RODOS, INNA STELIN",
    "current_taxes": 5513.22,
    "new_taxes_no_override": 5751.39,
    "override_total_1": 5914.58,
    "override_increase_1": 163.19
  },
  {
    "#": "22 Chestnut Pl, Unit 408 & P46 (330-11-56)",
    "$": 532800,
    "address": "22 Chestnut Pl, Unit 408 & P46",
    "parcel_id": "330-11-56",
    "owner1": "TAO, JENKANG",
    "owner2": "",
    "current_taxes": 5455.87,
    "new_taxes_no_override": 5691.56,
    "override_total_1": 5853.06,
    "override_increase_1": 161.49
  },
  {
    "#": "22 Chestnut Pl, Unit 409 & P91 (330-11-57)",
    "$": 398400,
    "address": "22 Chestnut Pl, Unit 409 & P91",
    "parcel_id": "330-11-57",
    "owner1": "VA CAPITAL LLC",
    "owner2": "",
    "current_taxes": 4079.62,
    "new_taxes_no_override": 4255.86,
    "override_total_1": 4376.62,
    "override_increase_1": 120.76
  },
  {
    "#": "22 Chestnut Pl, Unit 410 & P80 (330-11-58)",
    "$": 556400,
    "address": "22 Chestnut Pl, Unit 410 & P80",
    "parcel_id": "330-11-58",
    "owner1": "YAKIMOVA, TATIANA",
    "owner2": "SOLSTAD, KATERINA",
    "current_taxes": 2062.6,
    "new_taxes_no_override": 2151.7,
    "override_total_1": 2212.76,
    "override_increase_1": 61.05
  },
  {
    "#": "22 Chestnut Pl, Unit 411 & P77 (330-11-59)",
    "$": 580600,
    "address": "22 Chestnut Pl, Unit 411 & P77",
    "parcel_id": "330-11-59",
    "owner1": "PERICH, JANE J",
    "owner2": "",
    "current_taxes": 2310.41,
    "new_taxes_no_override": 2410.22,
    "override_total_1": 2478.61,
    "override_increase_1": 68.39
  },
  {
    "#": "22 Chestnut Pl, Unit 412 25&100 (330-11-60)",
    "$": 808900,
    "address": "22 Chestnut Pl, Unit 412 25&100",
    "parcel_id": "330-11-60",
    "owner1": "LEE, SEUNGYEON",
    "owner2": "KIM, MARIA",
    "current_taxes": 4648.2,
    "new_taxes_no_override": 4849.0,
    "override_total_1": 4986.59,
    "override_increase_1": 137.59
  },
  {
    "#": "22 Chestnut Pl, Unit 414 & P14 (330-11-61)",
    "$": 686400,
    "address": "22 Chestnut Pl, Unit 414 & P14",
    "parcel_id": "330-11-61",
    "owner1": "YANG, TIANZHONG",
    "owner2": "WANG, XIAOLIN",
    "current_taxes": 7028.74,
    "new_taxes_no_override": 7332.38,
    "override_total_1": 7540.43,
    "override_increase_1": 208.05
  },
  {
    "#": "22 Chestnut Pl, Unit 415 P43 (330-11-62)",
    "$": 538400,
    "address": "22 Chestnut Pl, Unit 415 P43",
    "parcel_id": "330-11-62",
    "owner1": "BUDMAN TR, EVA",
    "owner2": "",
    "current_taxes": 1878.28,
    "new_taxes_no_override": 1959.42,
    "override_total_1": 2015.02,
    "override_increase_1": 55.6
  },
  {
    "#": "22 Chestnut Pl, Unit 416 & P15 (330-11-63)",
    "$": 692200,
    "address": "22 Chestnut Pl, Unit 416 & P15",
    "parcel_id": "330-11-63",
    "owner1": "CONRAD, ET AL TRS, CHESTER H",
    "owner2": "",
    "current_taxes": 7088.13,
    "new_taxes_no_override": 7394.34,
    "override_total_1": 7604.15,
    "override_increase_1": 209.81
  },
  {
    "#": "22 Chestnut Pl, Unit 417 P7-79 (330-11-64)",
    "$": 798900,
    "address": "22 Chestnut Pl, Unit 417 P7-79",
    "parcel_id": "330-11-64",
    "owner1": "PEARL TR, KAREN",
    "owner2": "",
    "current_taxes": 4545.8,
    "new_taxes_no_override": 4742.18,
    "override_total_1": 4876.73,
    "override_increase_1": 134.56
  },
  {
    "#": "22 Chestnut Pl, Unit 501 & P9 (330-11-65)",
    "$": 752100,
    "address": "22 Chestnut Pl, Unit 501 & P9",
    "parcel_id": "330-11-65",
    "owner1": "WEISSENBORN, ODILE A",
    "owner2": "",
    "current_taxes": 7701.5,
    "new_taxes_no_override": 8034.2,
    "override_total_1": 8262.17,
    "override_increase_1": 227.96
  },
  {
    "#": "22 Chestnut Pl, Unit 502 & P10 (330-11-66)",
    "$": 584200,
    "address": "22 Chestnut Pl, Unit 502 & P10",
    "parcel_id": "330-11-66",
    "owner1": "SHORE TR, FELIX",
    "owner2": "",
    "current_taxes": 2347.27,
    "new_taxes_no_override": 2448.67,
    "override_total_1": 2518.15,
    "override_increase_1": 69.48
  },
  {
    "#": "22 Chestnut Pl, Unit 503 & P3 (330-11-67)",
    "$": 569000,
    "address": "22 Chestnut Pl, Unit 503 & P3",
    "parcel_id": "330-11-67",
    "owner1": "GURER, CAGAN",
    "owner2": "BOZKURT-GURER, FUNDA",
    "current_taxes": 5826.56,
    "new_taxes_no_override": 6078.27,
    "override_total_1": 6250.73,
    "override_increase_1": 172.47
  },
  {
    "#": "22 Chestnut Pl, Unit 504 & P74 (330-11-68)",
    "$": 657300,
    "address": "22 Chestnut Pl, Unit 504 & P74",
    "parcel_id": "330-11-68",
    "owner1": "SHERMAN, MARIA",
    "owner2": "",
    "current_taxes": 3095.82,
    "new_taxes_no_override": 3229.56,
    "override_total_1": 3321.2,
    "override_increase_1": 91.64
  },
  {
    "#": "22 Chestnut Pl, Unit 505 & P96 (330-11-69)",
    "$": 776700,
    "address": "22 Chestnut Pl, Unit 505 & P96",
    "parcel_id": "330-11-69",
    "owner1": "KADIS, TR, ELAYNE",
    "owner2": "",
    "current_taxes": 7953.41,
    "new_taxes_no_override": 8297.0,
    "override_total_1": 8532.42,
    "override_increase_1": 235.42
  },
  {
    "#": "22 Chestnut Pl, Unit 506 & P69 (330-11-70)",
    "$": 603700,
    "address": "22 Chestnut Pl, Unit 506 & P69",
    "parcel_id": "330-11-70",
    "owner1": "STROBEL TR, JOANNE L",
    "owner2": "C/O ISAAC A KOT",
    "current_taxes": 6181.89,
    "new_taxes_no_override": 6448.95,
    "override_total_1": 6631.93,
    "override_increase_1": 182.98
  },
  {
    "#": "22 Chestnut Pl, Unit 507 & P24 (330-11-71)",
    "$": 584200,
    "address": "22 Chestnut Pl, Unit 507 & P24",
    "parcel_id": "330-11-71",
    "owner1": "GUO, RUI",
    "owner2": "WANG, YIN",
    "current_taxes": 5982.21,
    "new_taxes_no_override": 6240.64,
    "override_total_1": 6417.71,
    "override_increase_1": 177.07
  },
  {
    "#": "22 Chestnut Pl, Unit 508 & P52 (330-11-72)",
    "$": 532100,
    "address": "22 Chestnut Pl, Unit 508 & P52",
    "parcel_id": "330-11-72",
    "owner1": "BERENSTEIN, ARKADY",
    "owner2": "SHTEYER, IRINA",
    "current_taxes": 5448.7,
    "new_taxes_no_override": 5684.08,
    "override_total_1": 5845.37,
    "override_increase_1": 161.28
  },
  {
    "#": "22 Chestnut Pl, Unit 509 & P122 (330-11-73)",
    "$": 400600,
    "address": "22 Chestnut Pl, Unit 509 & P122",
    "parcel_id": "330-11-73",
    "owner1": "YUAN, CHANGZHENG",
    "owner2": "",
    "current_taxes": 467.21,
    "new_taxes_no_override": 487.39,
    "override_total_1": 501.22,
    "override_increase_1": 13.83
  },
  {
    "#": "22 Chestnut Pl, Unit 510 & P118 (330-11-74)",
    "$": 538400,
    "address": "22 Chestnut Pl, Unit 510 & P118",
    "parcel_id": "330-11-74",
    "owner1": "JABARA TR, HAIFA J",
    "owner2": "",
    "current_taxes": 1878.28,
    "new_taxes_no_override": 1959.42,
    "override_total_1": 2015.02,
    "override_increase_1": 55.6
  },
  {
    "#": "22 Chestnut Pl, Unit 511 & P78 (330-11-75)",
    "$": 562200,
    "address": "22 Chestnut Pl, Unit 511 & P78",
    "parcel_id": "330-11-75",
    "owner1": "SEBESTYEN TR, JUDITH R",
    "owner2": "",
    "current_taxes": 5756.93,
    "new_taxes_no_override": 6005.63,
    "override_total_1": 6176.03,
    "override_increase_1": 170.41
  },
  {
    "#": "22 Chestnut Pl, Unit 512 & P1 (330-11-76)",
    "$": 783600,
    "address": "22 Chestnut Pl, Unit 512 & P1",
    "parcel_id": "330-11-76",
    "owner1": "EYSMANN TR, CELIA F",
    "owner2": "",
    "current_taxes": 4389.13,
    "new_taxes_no_override": 4578.74,
    "override_total_1": 4708.66,
    "override_increase_1": 129.92
  },
  {
    "#": "22 Chestnut Pl, Unit 514 P5 P6 (330-11-77)",
    "$": 1332200,
    "address": "22 Chestnut Pl, Unit 514 P5 P6",
    "parcel_id": "330-11-77",
    "owner1": "SOREF TRS, RICHARD A & GALINA CHAUSOVSKY",
    "owner2": "",
    "current_taxes": 10006.79,
    "new_taxes_no_override": 10439.08,
    "override_total_1": 10735.28,
    "override_increase_1": 296.2
  },
  {
    "#": "22 Chestnut Pl, Unit 516 & P39 (330-11-78)",
    "$": 509000,
    "address": "22 Chestnut Pl, Unit 516 & P39",
    "parcel_id": "330-11-78",
    "owner1": "PIRYATINSKY, MAXIM & IRENE",
    "owner2": "",
    "current_taxes": 5212.16,
    "new_taxes_no_override": 5437.33,
    "override_total_1": 5591.61,
    "override_increase_1": 154.28
  },
  {
    "#": "22 Chestnut Pl, Unit 517 P27&36 (330-11-79)",
    "$": 788700,
    "address": "22 Chestnut Pl, Unit 517 P27&36",
    "parcel_id": "330-11-79",
    "owner1": "ARUIN, KIRA",
    "owner2": "",
    "current_taxes": 4441.35,
    "new_taxes_no_override": 4633.22,
    "override_total_1": 4764.68,
    "override_increase_1": 131.46
  },
  {
    "#": "22 Chestnut Pl, Unit 601 P30 (330-11-80)",
    "$": 737600,
    "address": "22 Chestnut Pl, Unit 601 P30",
    "parcel_id": "330-11-80",
    "owner1": "REGIS, EILEEN",
    "owner2": "",
    "current_taxes": 3918.09,
    "new_taxes_no_override": 4087.35,
    "override_total_1": 4203.33,
    "override_increase_1": 115.98
  },
  {
    "#": "22 Chestnut Pl, Unit 602 & P23 (330-11-81)",
    "$": 657500,
    "address": "22 Chestnut Pl, Unit 602 & P23",
    "parcel_id": "330-11-81",
    "owner1": "SHPIGEL LIFE ESTATE, ALBERT & IRENE",
    "owner2": "",
    "current_taxes": 3097.87,
    "new_taxes_no_override": 3231.7,
    "override_total_1": 3323.39,
    "override_increase_1": 91.7
  },
  {
    "#": "22 Chestnut Pl, Unit 603 & P48 (330-11-82)",
    "$": 553300,
    "address": "22 Chestnut Pl, Unit 603 & P48",
    "parcel_id": "330-11-82",
    "owner1": "MANDEL TRS, LAURA CONRAD & MICHAEL J",
    "owner2": "",
    "current_taxes": 5665.79,
    "new_taxes_no_override": 5910.55,
    "override_total_1": 6078.26,
    "override_increase_1": 167.71
  },
  {
    "#": "22 Chestnut Pl, Unit 604 & P70 (330-11-83)",
    "$": 730700,
    "address": "22 Chestnut Pl, Unit 604 & P70",
    "parcel_id": "330-11-83",
    "owner1": "CONRAD, TRS, CHESTER H",
    "owner2": "",
    "current_taxes": 7482.37,
    "new_taxes_no_override": 7805.61,
    "override_total_1": 8027.09,
    "override_increase_1": 221.48
  },
  {
    "#": "22 Chestnut Pl, Unit 605 P93-94 (330-11-84)",
    "$": 846100,
    "address": "22 Chestnut Pl, Unit 605 P93-94",
    "parcel_id": "330-11-84",
    "owner1": "MUTCHLER, ARIELLA",
    "owner2": "JOHNSON, THEODORE",
    "current_taxes": 5029.13,
    "new_taxes_no_override": 5246.39,
    "override_total_1": 5395.25,
    "override_increase_1": 148.86
  },
  {
    "#": "22 Chestnut Pl, Unit 606 & P42 (330-11-85)",
    "$": 561200,
    "address": "22 Chestnut Pl, Unit 606 & P42",
    "parcel_id": "330-11-85",
    "owner1": "ABBASI, NAZANIN",
    "owner2": "",
    "current_taxes": 5746.69,
    "new_taxes_no_override": 5994.95,
    "override_total_1": 6165.05,
    "override_increase_1": 170.1
  },
  {
    "#": "22 Chestnut Pl, Unit 607 P97 P4 (330-11-86)",
    "$": 673400,
    "address": "22 Chestnut Pl, Unit 607 P97 P4",
    "parcel_id": "330-11-86",
    "owner1": "LI, JINGYAN",
    "owner2": "",
    "current_taxes": 6895.62,
    "new_taxes_no_override": 7193.51,
    "override_total_1": 7397.62,
    "override_increase_1": 204.11
  },
  {
    "#": "22 Chestnut Pl, Unit 608 & P66 (330-11-87)",
    "$": 519700,
    "address": "22 Chestnut Pl, Unit 608 & P66",
    "parcel_id": "330-11-87",
    "owner1": "GIBBONS, MYLES P & TRACY L",
    "owner2": "",
    "current_taxes": 5321.73,
    "new_taxes_no_override": 5551.63,
    "override_total_1": 5709.15,
    "override_increase_1": 157.52
  },
  {
    "#": "22 Chestnut Pl, Unit 609 & P86 (330-11-88)",
    "$": 397700,
    "address": "22 Chestnut Pl, Unit 609 & P86",
    "parcel_id": "330-11-88",
    "owner1": "BARTOLONI, GUIDO",
    "owner2": "SMITH-BARTOLONI, JULIE",
    "current_taxes": 4072.45,
    "new_taxes_no_override": 4248.38,
    "override_total_1": 4368.92,
    "override_increase_1": 120.54
  },
  {
    "#": "22 Chestnut Pl, Unit 610 & P54 (330-11-89)",
    "$": 548600,
    "address": "22 Chestnut Pl, Unit 610 & P54",
    "parcel_id": "330-11-89",
    "owner1": "WEISZ, NAOMI",
    "owner2": "",
    "current_taxes": 1982.73,
    "new_taxes_no_override": 2068.38,
    "override_total_1": 2127.07,
    "override_increase_1": 58.69
  },
  {
    "#": "22 Chestnut Pl, Unit 611 & P61 (330-11-90)",
    "$": 587000,
    "address": "22 Chestnut Pl, Unit 611 & P61",
    "parcel_id": "330-11-90",
    "owner1": "MICHELSON, ILYA",
    "owner2": "",
    "current_taxes": 2375.95,
    "new_taxes_no_override": 2478.59,
    "override_total_1": 2548.92,
    "override_increase_1": 70.33
  },
  {
    "#": "22 Chestnut Pl, Unit 612 & P32 (330-11-91)",
    "$": 821600,
    "address": "22 Chestnut Pl, Unit 612 & P32",
    "parcel_id": "330-11-91",
    "owner1": "SALEEM, SALEENA",
    "owner2": "",
    "current_taxes": 4778.25,
    "new_taxes_no_override": 4984.67,
    "override_total_1": 5126.11,
    "override_increase_1": 141.44
  },
  {
    "#": "22 Chestnut Pl, Unit 614 P16&60 (330-11-92)",
    "$": 789100,
    "address": "22 Chestnut Pl, Unit 614 P16&60",
    "parcel_id": "330-11-92",
    "owner1": "RIESE TRS, MICHELE J MAY & RICHARD J",
    "owner2": "",
    "current_taxes": 4445.45,
    "new_taxes_no_override": 4637.49,
    "override_total_1": 4769.08,
    "override_increase_1": 131.59
  },
  {
    "#": "22 Chestnut Pl, Unit 615 & P55 (330-11-93)",
    "$": 554000,
    "address": "22 Chestnut Pl, Unit 615 & P55",
    "parcel_id": "330-11-93",
    "owner1": "RIESE TRS, MICHELE J MAY & RICHARD J",
    "owner2": "",
    "current_taxes": 5672.96,
    "new_taxes_no_override": 5918.03,
    "override_total_1": 6085.95,
    "override_increase_1": 167.92
  },
  {
    "#": "22 Chestnut Pl, Unit 616 & P26 (330-11-94)",
    "$": 782500,
    "address": "22 Chestnut Pl, Unit 616 & P26",
    "parcel_id": "330-11-94",
    "owner1": "MILLER, KYLE & LEAH",
    "owner2": "",
    "current_taxes": 8012.8,
    "new_taxes_no_override": 8358.95,
    "override_total_1": 8596.13,
    "override_increase_1": 237.18
  },
  {
    "#": "22 Chestnut Pl, Unit 617 & P18 (330-11-95)",
    "$": 740000,
    "address": "22 Chestnut Pl, Unit 617 & P18",
    "parcel_id": "330-11-95",
    "owner1": "SHEKTMAN TRS, ALEXANDER & IZABELLA",
    "owner2": "",
    "current_taxes": 3942.67,
    "new_taxes_no_override": 4112.99,
    "override_total_1": 4229.7,
    "override_increase_1": 116.7
  },
  {
    "#": "22 Chestnut Pl, Unit G-1 & P19 (330-11-01)",
    "$": 606900,
    "address": "22 Chestnut Pl, Unit G-1 & P19",
    "parcel_id": "330-11-01",
    "owner1": "HANGAI, SHO & MAYUMI",
    "owner2": "",
    "current_taxes": 6214.66,
    "new_taxes_no_override": 6483.13,
    "override_total_1": 6667.09,
    "override_increase_1": 183.95
  },
  {
    "#": "22 Chestnut Pl, Unit G-2 (330-12-00)",
    "$": 623100,
    "address": "22 Chestnut Pl, Unit G-2",
    "parcel_id": "330-12-00",
    "owner1": "SARGENT ESTATES CONDO TRUST",
    "owner2": "C/O PREMIER PROPERTY SOLUTIONS",
    "current_taxes": 6380.54,
    "new_taxes_no_override": 6656.18,
    "override_total_1": 6845.04,
    "override_increase_1": 188.86
  },
  {
    "#": "22 Chestnut Pl, Unit M-1 & P59 (330-11-96)",
    "$": 336700,
    "address": "22 Chestnut Pl, Unit M-1 & P59",
    "parcel_id": "330-11-96",
    "owner1": "WAHI, MADHU A",
    "owner2": "MOAZED, DANESH",
    "current_taxes": 3447.81,
    "new_taxes_no_override": 3596.76,
    "override_total_1": 3698.81,
    "override_increase_1": 102.06
  },
  {
    "#": "22 Chestnut Pl, Unit M-2 & P65 (330-11-97)",
    "$": 373400,
    "address": "22 Chestnut Pl, Unit M-2 & P65",
    "parcel_id": "330-11-97",
    "owner1": "ZHANG, YICHEN",
    "owner2": "",
    "current_taxes": 3823.62,
    "new_taxes_no_override": 3988.8,
    "override_total_1": 4101.98,
    "override_increase_1": 113.18
  },
  {
    "#": "22 Chestnut Pl, Unit M-3 & P68 (330-11-98)",
    "$": 375400,
    "address": "22 Chestnut Pl, Unit M-3 & P68",
    "parcel_id": "330-11-98",
    "owner1": "FIDYK, NANCY-ZBIGNIEW R-STELLA",
    "owner2": "",
    "current_taxes": 3844.1,
    "new_taxes_no_override": 4010.17,
    "override_total_1": 4123.95,
    "override_increase_1": 113.79
  },
  {
    "#": "22 Chestnut Pl, Unit M-4 & P57 (330-11-99)",
    "$": 295100,
    "address": "22 Chestnut Pl, Unit M-4 & P57",
    "parcel_id": "330-11-99",
    "owner1": "LEVINE, VLADIMIR",
    "owner2": "",
    "current_taxes": 3021.82,
    "new_taxes_no_override": 3152.36,
    "override_total_1": 3241.81,
    "override_increase_1": 89.45
  },
  {
    "#": "22 Chestnut Pl, Unit P31 (330-12-01)",
    "$": 90800,
    "address": "22 Chestnut Pl, Unit P31",
    "parcel_id": "330-12-01",
    "owner1": "PIRYATINSKY, MAXIM & IRENE",
    "owner2": "",
    "current_taxes": 929.79,
    "new_taxes_no_override": 969.96,
    "override_total_1": 997.48,
    "override_increase_1": 27.52
  },
  {
    "#": "29 Chestnut Pl (329-15-00)",
    "$": 4293700,
    "address": "29 Chestnut Pl",
    "parcel_id": "329-15-00",
    "owner1": "URMY, THOMAS V JR & DEANNE S",
    "owner2": "",
    "current_taxes": 40332.55,
    "new_taxes_no_override": 42074.92,
    "override_total_1": 43268.76,
    "override_increase_1": 1193.84
  },
  {
    "#": "35 Chestnut Pl (329-16-00)",
    "$": 4379300,
    "address": "35 Chestnut Pl",
    "parcel_id": "329-16-00",
    "owner1": "COONEY, ET AL, CHARLES L",
    "owner2": "",
    "current_taxes": 41209.1,
    "new_taxes_no_override": 42989.33,
    "override_total_1": 44209.12,
    "override_increase_1": 1219.79
  },
  {
    "#": "10 Chestnut St (317-07-00)",
    "$": 1868300,
    "address": "10 Chestnut St",
    "parcel_id": "317-07-00",
    "owner1": "PIPER TRS, RICHARD S",
    "owner2": "COLES , ANN S",
    "current_taxes": 15496.46,
    "new_taxes_no_override": 16165.91,
    "override_total_1": 16624.6,
    "override_increase_1": 458.7
  },
  {
    "#": "14 Chestnut St (317-06-00)",
    "$": 2157000,
    "address": "14 Chestnut St",
    "parcel_id": "317-06-00",
    "owner1": "KINLAY TRS, SCOTT & JOANNE",
    "owner2": "",
    "current_taxes": 18452.75,
    "new_taxes_no_override": 19249.91,
    "override_total_1": 19796.11,
    "override_increase_1": 546.2
  },
  {
    "#": "20 Chestnut St (317-05-00)",
    "$": 2563900,
    "address": "20 Chestnut St",
    "parcel_id": "317-05-00",
    "owner1": "TAYLOR III, FREDERICK",
    "owner2": "BROWNE, FLORENCE",
    "current_taxes": 26254.34,
    "new_taxes_no_override": 27388.53,
    "override_total_1": 28165.66,
    "override_increase_1": 777.13
  },
  {
    "#": "26 Chestnut St (317-04-00)",
    "$": 4191500,
    "address": "26 Chestnut St",
    "parcel_id": "317-04-00",
    "owner1": "COONEY TR, CHARLES",
    "owner2": "",
    "current_taxes": 42648.58,
    "new_taxes_no_override": 44491.0,
    "override_total_1": 45753.4,
    "override_increase_1": 1262.4
  },
  {
    "#": "27 Chestnut St (329-12-00)",
    "$": 3008600,
    "address": "27 Chestnut St",
    "parcel_id": "329-12-00",
    "owner1": "BUCKNER TRS, NOEL A JR",
    "owner2": "MAISEL, ROBIN S",
    "current_taxes": 27173.13,
    "new_taxes_no_override": 28347.01,
    "override_total_1": 29151.33,
    "override_increase_1": 804.32
  },
  {
    "#": "33 Chestnut St (329-12-01)",
    "$": 2689000,
    "address": "33 Chestnut St",
    "parcel_id": "329-12-01",
    "owner1": "DOLLE TRS, MAXINE J & THOMAS P",
    "owner2": "",
    "current_taxes": 23900.43,
    "new_taxes_no_override": 24932.93,
    "override_total_1": 25640.38,
    "override_increase_1": 707.45
  },
  {
    "#": "36 Chestnut St (317-03-00)",
    "$": 1307700,
    "address": "36 Chestnut St",
    "parcel_id": "317-03-00",
    "owner1": "GOLDSTEIN, ERIC H",
    "owner2": "",
    "current_taxes": 9755.91,
    "new_taxes_no_override": 10177.37,
    "override_total_1": 10466.14,
    "override_increase_1": 288.77
  },
  {
    "#": "40 Chestnut St (317-02-00)",
    "$": 1350800,
    "address": "40 Chestnut St",
    "parcel_id": "317-02-00",
    "owner1": "JOHN, ARTHUR W  & BILJANA D & ADRIANA V",
    "owner2": "",
    "current_taxes": 10197.26,
    "new_taxes_no_override": 10637.78,
    "override_total_1": 10939.62,
    "override_increase_1": 301.84
  },
  {
    "#": "46 Chestnut St (317-01-00)",
    "$": 1450200,
    "address": "46 Chestnut St",
    "parcel_id": "317-01-00",
    "owner1": "CULLINANE, EDWARD T",
    "owner2": "",
    "current_taxes": 11215.11,
    "new_taxes_no_override": 11699.6,
    "override_total_1": 12031.57,
    "override_increase_1": 331.97
  },
  {
    "#": "52 Chestnut St (316A-09-00)",
    "$": 1401300,
    "address": "52 Chestnut St",
    "parcel_id": "316A-09-00",
    "owner1": "MCCONE , NANCY",
    "owner2": "CODY, KARIN",
    "current_taxes": 10714.38,
    "new_taxes_no_override": 11177.24,
    "override_total_1": 11494.39,
    "override_increase_1": 317.15
  },
  {
    "#": "56 Chestnut St (316A-08-00)",
    "$": 1062300,
    "address": "56 Chestnut St",
    "parcel_id": "316A-08-00",
    "owner1": "OBERG, GERALD & JEAN",
    "owner2": "",
    "current_taxes": 7243.02,
    "new_taxes_no_override": 7555.92,
    "override_total_1": 7770.31,
    "override_increase_1": 214.39
  },
  {
    "#": "60 Chestnut St, Unit 1 (316A-07-01)",
    "$": 657600,
    "address": "60 Chestnut St, Unit 1",
    "parcel_id": "316A-07-01",
    "owner1": "JENNER, NANCY",
    "owner2": "",
    "current_taxes": 6733.82,
    "new_taxes_no_override": 7024.72,
    "override_total_1": 7224.04,
    "override_increase_1": 199.32
  },
  {
    "#": "60 Chestnut St, Unit 2 (316A-07-02)",
    "$": 649500,
    "address": "60 Chestnut St, Unit 2",
    "parcel_id": "316A-07-02",
    "owner1": "PAREKH, SERENA",
    "owner2": "",
    "current_taxes": 3015.95,
    "new_taxes_no_override": 3146.24,
    "override_total_1": 3235.51,
    "override_increase_1": 89.27
  },
  {
    "#": "60 Chestnut St, Unit 3 (316A-07-03)",
    "$": 809000,
    "address": "60 Chestnut St, Unit 3",
    "parcel_id": "316A-07-03",
    "owner1": "JEMELKA, IVAN",
    "owner2": "JEMELKOV, MARIE",
    "current_taxes": 4649.23,
    "new_taxes_no_override": 4850.08,
    "override_total_1": 4987.69,
    "override_increase_1": 137.62
  },
  {
    "#": "62 Chestnut St, Unit 1 (316A-06-03)",
    "$": 716700,
    "address": "62 Chestnut St, Unit 1",
    "parcel_id": "316A-06-03",
    "owner1": "ZHOGINA, YULIA",
    "owner2": "",
    "current_taxes": 3704.07,
    "new_taxes_no_override": 3864.09,
    "override_total_1": 3973.73,
    "override_increase_1": 109.64
  },
  {
    "#": "62 Chestnut St, Unit 2 (316A-06-01)",
    "$": 708800,
    "address": "62 Chestnut St, Unit 2",
    "parcel_id": "316A-06-01",
    "owner1": "MORAN, HUGH DUFFY & KATHERINE",
    "owner2": "",
    "current_taxes": 3623.18,
    "new_taxes_no_override": 3779.7,
    "override_total_1": 3886.95,
    "override_increase_1": 107.25
  },
  {
    "#": "62 Chestnut St, Unit 3 (316A-06-02)",
    "$": 720400,
    "address": "62 Chestnut St, Unit 3",
    "parcel_id": "316A-06-02",
    "owner1": "PAGITSAS, EFI K",
    "owner2": "",
    "current_taxes": 7376.9,
    "new_taxes_no_override": 7695.58,
    "override_total_1": 7913.94,
    "override_increase_1": 218.36
  },
  {
    "#": "66 Chestnut St (316A-05-00)",
    "$": 1621800,
    "address": "66 Chestnut St",
    "parcel_id": "316A-05-00",
    "owner1": "66 CHESTNUT STREET LLC",
    "owner2": "",
    "current_taxes": 16607.23,
    "new_taxes_no_override": 17324.66,
    "override_total_1": 17816.24,
    "override_increase_1": 491.57
  },
  {
    "#": "68 Chestnut St, Unit 1 (316A-04-03)",
    "$": 767500,
    "address": "68 Chestnut St, Unit 1",
    "parcel_id": "316A-04-03",
    "owner1": "BOSE, JENNIFER",
    "owner2": "",
    "current_taxes": 4224.27,
    "new_taxes_no_override": 4406.76,
    "override_total_1": 4531.8,
    "override_increase_1": 125.04
  },
  {
    "#": "68 Chestnut St, Unit 2 (316A-04-01)",
    "$": 757800,
    "address": "68 Chestnut St, Unit 2",
    "parcel_id": "316A-04-01",
    "owner1": "MCCARTHY, CHRISTOPHER J",
    "owner2": "",
    "current_taxes": 7759.87,
    "new_taxes_no_override": 8095.1,
    "override_total_1": 8324.79,
    "override_increase_1": 229.69
  },
  {
    "#": "68 Chestnut St, Unit 3 (316A-04-02)",
    "$": 748700,
    "address": "68 Chestnut St, Unit 3",
    "parcel_id": "316A-04-02",
    "owner1": "GARMAN, CHRIS J",
    "owner2": "ZIMMERMANN, EMILY C",
    "current_taxes": 4031.75,
    "new_taxes_no_override": 4205.92,
    "override_total_1": 4325.26,
    "override_increase_1": 119.34
  },
  {
    "#": "70 Chestnut St, Unit 1 (316A-03-03)",
    "$": 843100,
    "address": "70 Chestnut St, Unit 1",
    "parcel_id": "316A-03-03",
    "owner1": "SABEV, STOYAN",
    "owner2": "SABEVA, KALINA",
    "current_taxes": 4998.41,
    "new_taxes_no_override": 5214.34,
    "override_total_1": 5362.29,
    "override_increase_1": 147.95
  },
  {
    "#": "70 Chestnut St, Unit 2 (316A-03-01)",
    "$": 774200,
    "address": "70 Chestnut St, Unit 2",
    "parcel_id": "316A-03-01",
    "owner1": "CHOI, SUNG HEE",
    "owner2": "FERRER LUNA, RUBEN",
    "current_taxes": 4292.87,
    "new_taxes_no_override": 4478.32,
    "override_total_1": 4605.39,
    "override_increase_1": 127.07
  },
  {
    "#": "70 Chestnut St, Unit 3 (316A-03-02)",
    "$": 990400,
    "address": "70 Chestnut St, Unit 3",
    "parcel_id": "316A-03-02",
    "owner1": "SCHNAAS, CHRISTIAN",
    "owner2": "BARRERO, CECILIA",
    "current_taxes": 10141.7,
    "new_taxes_no_override": 10579.82,
    "override_total_1": 10880.02,
    "override_increase_1": 300.19
  },
  {
    "#": "74 Chestnut St, Unit 1 (316A-02-01)",
    "$": 657100,
    "address": "74 Chestnut St, Unit 1",
    "parcel_id": "316A-02-01",
    "owner1": "LIU, BING",
    "owner2": "DU, TING",
    "current_taxes": 3093.77,
    "new_taxes_no_override": 3227.42,
    "override_total_1": 3319.0,
    "override_increase_1": 91.58
  },
  {
    "#": "74 Chestnut St, Unit 2 (316A-02-02)",
    "$": 655600,
    "address": "74 Chestnut St, Unit 2",
    "parcel_id": "316A-02-02",
    "owner1": "DEBRUIN, DAVID & MARGARET",
    "owner2": "",
    "current_taxes": 3078.41,
    "new_taxes_no_override": 3211.4,
    "override_total_1": 3302.52,
    "override_increase_1": 91.12
  },
  {
    "#": "74 Chestnut St, Unit 3 (316A-02-03)",
    "$": 1010500,
    "address": "74 Chestnut St, Unit 3",
    "parcel_id": "316A-02-03",
    "owner1": "BICKFORD, JOSHUA",
    "owner2": "COLLINS, ERIN",
    "current_taxes": 10347.52,
    "new_taxes_no_override": 10794.53,
    "override_total_1": 11100.82,
    "override_increase_1": 306.29
  },
  {
    "#": "79 Chestnut St, Unit 1 (330-08-03)",
    "$": 409800,
    "address": "79 Chestnut St, Unit 1",
    "parcel_id": "330-08-03",
    "owner1": "SHARAF, ET AL TR, ALAN B",
    "owner2": "",
    "current_taxes": 4196.35,
    "new_taxes_no_override": 4377.63,
    "override_total_1": 4501.84,
    "override_increase_1": 124.21
  },
  {
    "#": "79 Chestnut St, Unit 1B (330-08-46)",
    "$": 349900,
    "address": "79 Chestnut St, Unit 1B",
    "parcel_id": "330-08-46",
    "owner1": "SHARAF, ET AL TR, ALAN B",
    "owner2": "",
    "current_taxes": 3582.98,
    "new_taxes_no_override": 3737.76,
    "override_total_1": 3843.82,
    "override_increase_1": 106.06
  },
  {
    "#": "79 Chestnut St, Unit 2 (330-08-04)",
    "$": 409800,
    "address": "79 Chestnut St, Unit 2",
    "parcel_id": "330-08-04",
    "owner1": "SHARAF, ET AL TR, ALAN B",
    "owner2": "",
    "current_taxes": 4196.35,
    "new_taxes_no_override": 4377.63,
    "override_total_1": 4501.84,
    "override_increase_1": 124.21
  },
  {
    "#": "79 Chestnut St, Unit 2B (330-08-02)",
    "$": 350400,
    "address": "79 Chestnut St, Unit 2B",
    "parcel_id": "330-08-02",
    "owner1": "SHARAF, ET AL TR, ALAN B",
    "owner2": "",
    "current_taxes": 3588.1,
    "new_taxes_no_override": 3743.11,
    "override_total_1": 3849.31,
    "override_increase_1": 106.21
  },
  {
    "#": "79 Chestnut St, Unit 3 (330-08-05)",
    "$": 409800,
    "address": "79 Chestnut St, Unit 3",
    "parcel_id": "330-08-05",
    "owner1": "SHARAF, ET AL TR, ALAN B",
    "owner2": "",
    "current_taxes": 4196.35,
    "new_taxes_no_override": 4377.63,
    "override_total_1": 4501.84,
    "override_increase_1": 124.21
  },
  {
    "#": "79 Chestnut St, Unit 4 (330-08-06)",
    "$": 409800,
    "address": "79 Chestnut St, Unit 4",
    "parcel_id": "330-08-06",
    "owner1": "SHARAF, ET AL TR, ALAN B",
    "owner2": "",
    "current_taxes": 4196.35,
    "new_taxes_no_override": 4377.63,
    "override_total_1": 4501.84,
    "override_increase_1": 124.21
  },
  {
    "#": "79 Chestnut St, Unit 5 & P-52 (330-08-07)",
    "$": 448200,
    "address": "79 Chestnut St, Unit 5 & P-52",
    "parcel_id": "330-08-07",
    "owner1": "LIU, ZHIYU",
    "owner2": "",
    "current_taxes": 4589.57,
    "new_taxes_no_override": 4787.84,
    "override_total_1": 4923.69,
    "override_increase_1": 135.85
  },
  {
    "#": "79 Chestnut St, Unit 6 (330-08-08)",
    "$": 421700,
    "address": "79 Chestnut St, Unit 6",
    "parcel_id": "330-08-08",
    "owner1": "SHARAF, ET AL TR, ALAN B",
    "owner2": "",
    "current_taxes": 4318.21,
    "new_taxes_no_override": 4504.76,
    "override_total_1": 4632.58,
    "override_increase_1": 127.82
  },
  {
    "#": "80 Chestnut St (316A-01-00)",
    "$": 2127000,
    "address": "80 Chestnut St",
    "parcel_id": "316A-01-00",
    "owner1": "SCHWABISH, MARC",
    "owner2": "HUANG, LISA",
    "current_taxes": 21780.48,
    "new_taxes_no_override": 22721.4,
    "override_total_1": 23366.1,
    "override_increase_1": 644.7
  },
  {
    "#": "85 Chestnut St, Unit 1 (330-08-10)",
    "$": 414500,
    "address": "85 Chestnut St, Unit 1",
    "parcel_id": "330-08-10",
    "owner1": "SHARAF, ET AL TR, ALAN B",
    "owner2": "",
    "current_taxes": 4244.48,
    "new_taxes_no_override": 4427.84,
    "override_total_1": 4553.48,
    "override_increase_1": 125.64
  },
  {
    "#": "85 Chestnut St, Unit 1B (330-08-09)",
    "$": 348500,
    "address": "85 Chestnut St, Unit 1B",
    "parcel_id": "330-08-09",
    "owner1": "SHARAF, ET AL TR, ALAN B",
    "owner2": "",
    "current_taxes": 3568.64,
    "new_taxes_no_override": 3722.81,
    "override_total_1": 3828.44,
    "override_increase_1": 105.63
  },
  {
    "#": "85 Chestnut St, Unit 2 (330-08-11)",
    "$": 409800,
    "address": "85 Chestnut St, Unit 2",
    "parcel_id": "330-08-11",
    "owner1": "SHARAF, ET AL TR, ALAN B",
    "owner2": "",
    "current_taxes": 4196.35,
    "new_taxes_no_override": 4377.63,
    "override_total_1": 4501.84,
    "override_increase_1": 124.21
  },
  {
    "#": "85 Chestnut St, Unit 3 (330-08-12)",
    "$": 409900,
    "address": "85 Chestnut St, Unit 3",
    "parcel_id": "330-08-12",
    "owner1": "MACGILLIVRAY, KATE A",
    "owner2": "",
    "current_taxes": 562.44,
    "new_taxes_no_override": 586.74,
    "override_total_1": 603.39,
    "override_increase_1": 16.65
  },
  {
    "#": "85 Chestnut St, Unit 4 & P42 (330-08-13)",
    "$": 409800,
    "address": "85 Chestnut St, Unit 4 & P42",
    "parcel_id": "330-08-13",
    "owner1": "DAMODARAN, VINODKUMAR",
    "owner2": "",
    "current_taxes": 4196.35,
    "new_taxes_no_override": 4377.63,
    "override_total_1": 4501.84,
    "override_increase_1": 124.21
  },
  {
    "#": "85 Chestnut St, Unit 5 & P36 (330-08-14)",
    "$": 456000,
    "address": "85 Chestnut St, Unit 5 & P36",
    "parcel_id": "330-08-14",
    "owner1": "CHAN, GLORIA K H",
    "owner2": "",
    "current_taxes": 4669.44,
    "new_taxes_no_override": 4871.16,
    "override_total_1": 5009.38,
    "override_increase_1": 138.22
  },
  {
    "#": "85 Chestnut St, Unit 6 (330-08-15)",
    "$": 409800,
    "address": "85 Chestnut St, Unit 6",
    "parcel_id": "330-08-15",
    "owner1": "SHARAF, ET AL TR, ALAN B",
    "owner2": "",
    "current_taxes": 4196.35,
    "new_taxes_no_override": 4377.63,
    "override_total_1": 4501.84,
    "override_increase_1": 124.21
  },
  {
    "#": "86 Chestnut St (316-20-00)",
    "$": 1608900,
    "address": "86 Chestnut St",
    "parcel_id": "316-20-00",
    "owner1": "MEZA TR, FRANK G",
    "owner2": "",
    "current_taxes": 16475.14,
    "new_taxes_no_override": 17186.87,
    "override_total_1": 17674.53,
    "override_increase_1": 487.66
  },
  {
    "#": "90 Chestnut St, Unit 1 (316-19-01)",
    "$": 1323800,
    "address": "90 Chestnut St, Unit 1",
    "parcel_id": "316-19-01",
    "owner1": "FROIS, CHRISTIAN",
    "owner2": "",
    "current_taxes": 9920.78,
    "new_taxes_no_override": 10349.36,
    "override_total_1": 10643.01,
    "override_increase_1": 293.66
  },
  {
    "#": "91 Chestnut St, Unit 1 (330-08-18)",
    "$": 463300,
    "address": "91 Chestnut St, Unit 1",
    "parcel_id": "330-08-18",
    "owner1": "SHARAF, ET AL TR, ALAN B",
    "owner2": "",
    "current_taxes": 4744.19,
    "new_taxes_no_override": 4949.14,
    "override_total_1": 5089.57,
    "override_increase_1": 140.43
  },
  {
    "#": "91 Chestnut St, Unit 1B (330-08-16)",
    "$": 307400,
    "address": "91 Chestnut St, Unit 1B",
    "parcel_id": "330-08-16",
    "owner1": "SHARAF, ET AL TR, ALAN B",
    "owner2": "",
    "current_taxes": 3147.78,
    "new_taxes_no_override": 3283.76,
    "override_total_1": 3376.94,
    "override_increase_1": 93.17
  },
  {
    "#": "91 Chestnut St, Unit 2 (330-08-19)",
    "$": 480300,
    "address": "91 Chestnut St, Unit 2",
    "parcel_id": "330-08-19",
    "owner1": "GUPTA, RAVI & PRAVEENA",
    "owner2": "",
    "current_taxes": 4918.27,
    "new_taxes_no_override": 5130.74,
    "override_total_1": 5276.32,
    "override_increase_1": 145.58
  },
  {
    "#": "91 Chestnut St, Unit 2B (330-08-17)",
    "$": 316600,
    "address": "91 Chestnut St, Unit 2B",
    "parcel_id": "330-08-17",
    "owner1": "SHARAF, ET AL TR, ALAN B",
    "owner2": "",
    "current_taxes": 3241.98,
    "new_taxes_no_override": 3382.03,
    "override_total_1": 3478.0,
    "override_increase_1": 95.96
  },
  {
    "#": "91 Chestnut St, Unit 3 & P9 (330-08-20)",
    "$": 492200,
    "address": "91 Chestnut St, Unit 3 & P9",
    "parcel_id": "330-08-20",
    "owner1": "ZHU, LIBIN",
    "owner2": "CUI, RUTAO",
    "current_taxes": 5040.13,
    "new_taxes_no_override": 5257.86,
    "override_total_1": 5407.05,
    "override_increase_1": 149.19
  },
  {
    "#": "91 Chestnut St, Unit 4 (330-08-21)",
    "$": 548200,
    "address": "91 Chestnut St, Unit 4",
    "parcel_id": "330-08-21",
    "owner1": "YE, MIKE",
    "owner2": "",
    "current_taxes": 1978.63,
    "new_taxes_no_override": 2064.11,
    "override_total_1": 2122.67,
    "override_increase_1": 58.57
  },
  {
    "#": "91 Chestnut St, Unit 5 (330-08-22)",
    "$": 480300,
    "address": "91 Chestnut St, Unit 5",
    "parcel_id": "330-08-22",
    "owner1": "XU, RONG",
    "owner2": "SONG, LEI",
    "current_taxes": 4918.27,
    "new_taxes_no_override": 5130.74,
    "override_total_1": 5276.32,
    "override_increase_1": 145.58
  },
  {
    "#": "91 Chestnut St, Unit 6 (330-08-23)",
    "$": 485100,
    "address": "91 Chestnut St, Unit 6",
    "parcel_id": "330-08-23",
    "owner1": "LI, RONG",
    "owner2": "ZHOU, XIONGWEI",
    "current_taxes": 4967.42,
    "new_taxes_no_override": 5182.01,
    "override_total_1": 5329.05,
    "override_increase_1": 147.04
  },
  {
    "#": "92 Chestnut St, Unit 2 (316-19-02)",
    "$": 1305300,
    "address": "92 Chestnut St, Unit 2",
    "parcel_id": "316-19-02",
    "owner1": "LABASTIDA, GUADALUPE MARLENE",
    "owner2": "JOHNSON, MATTHEW",
    "current_taxes": 9731.34,
    "new_taxes_no_override": 10151.73,
    "override_total_1": 10439.78,
    "override_increase_1": 288.05
  },
  {
    "#": "94 Chestnut St, Unit 3 (316-19-03)",
    "$": 1188300,
    "address": "94 Chestnut St, Unit 3",
    "parcel_id": "316-19-03",
    "owner1": "SHIMBORI, NATSUMI & HIROYUKI",
    "owner2": "",
    "current_taxes": 8533.26,
    "new_taxes_no_override": 8901.9,
    "override_total_1": 9154.48,
    "override_increase_1": 252.58
  },
  {
    "#": "95 Chestnut St, Unit 1 (330-08-25)",
    "$": 409800,
    "address": "95 Chestnut St, Unit 1",
    "parcel_id": "330-08-25",
    "owner1": "SHARAF, ET AL TR, ALAN B",
    "owner2": "",
    "current_taxes": 4196.35,
    "new_taxes_no_override": 4377.63,
    "override_total_1": 4501.84,
    "override_increase_1": 124.21
  },
  {
    "#": "95 Chestnut St, Unit 1B (330-08-24)",
    "$": 369200,
    "address": "95 Chestnut St, Unit 1B",
    "parcel_id": "330-08-24",
    "owner1": "SHARAF, ET AL TR, ALAN B",
    "owner2": "",
    "current_taxes": 3780.61,
    "new_taxes_no_override": 3943.93,
    "override_total_1": 4055.84,
    "override_increase_1": 111.91
  },
  {
    "#": "95 Chestnut St, Unit 2 (330-08-26)",
    "$": 409800,
    "address": "95 Chestnut St, Unit 2",
    "parcel_id": "330-08-26",
    "owner1": "SHARAF, ET AL TR, ALAN B",
    "owner2": "",
    "current_taxes": 4196.35,
    "new_taxes_no_override": 4377.63,
    "override_total_1": 4501.84,
    "override_increase_1": 124.21
  },
  {
    "#": "95 Chestnut St, Unit 3 & P14 (330-08-27)",
    "$": 409800,
    "address": "95 Chestnut St, Unit 3 & P14",
    "parcel_id": "330-08-27",
    "owner1": "YU, JIE TING & WILLIAM",
    "owner2": "",
    "current_taxes": 4196.35,
    "new_taxes_no_override": 4377.63,
    "override_total_1": 4501.84,
    "override_increase_1": 124.21
  },
  {
    "#": "95 Chestnut St, Unit 4 (330-08-28)",
    "$": 409800,
    "address": "95 Chestnut St, Unit 4",
    "parcel_id": "330-08-28",
    "owner1": "SHARAF, ET AL TR, ALAN B",
    "owner2": "",
    "current_taxes": 4196.35,
    "new_taxes_no_override": 4377.63,
    "override_total_1": 4501.84,
    "override_increase_1": 124.21
  },
  {
    "#": "95 Chestnut St, Unit 5 (330-08-29)",
    "$": 409800,
    "address": "95 Chestnut St, Unit 5",
    "parcel_id": "330-08-29",
    "owner1": "SHARAF, ET AL TR, ALAN B",
    "owner2": "",
    "current_taxes": 4196.35,
    "new_taxes_no_override": 4377.63,
    "override_total_1": 4501.84,
    "override_increase_1": 124.21
  },
  {
    "#": "95 Chestnut St, Unit 6 (330-08-30)",
    "$": 409800,
    "address": "95 Chestnut St, Unit 6",
    "parcel_id": "330-08-30",
    "owner1": "SHARMA, BANDANA",
    "owner2": "",
    "current_taxes": 561.42,
    "new_taxes_no_override": 585.67,
    "override_total_1": 602.29,
    "override_increase_1": 16.62
  },
  {
    "#": "96 Chestnut St, Unit 1 (316-18-01)",
    "$": 535900,
    "address": "96 Chestnut St, Unit 1",
    "parcel_id": "316-18-01",
    "owner1": "AKMURADOV, ISMAIL",
    "owner2": "ARATOVSKAYA, ANNA",
    "current_taxes": 5487.62,
    "new_taxes_no_override": 5724.69,
    "override_total_1": 5887.12,
    "override_increase_1": 162.43
  },
  {
    "#": "96 Chestnut St, Unit 2 (316-18-02)",
    "$": 541700,
    "address": "96 Chestnut St, Unit 2",
    "parcel_id": "316-18-02",
    "owner1": "WELCH, MARY C",
    "owner2": "HADLEY, MARTHA J",
    "current_taxes": 1912.07,
    "new_taxes_no_override": 1994.67,
    "override_total_1": 2051.27,
    "override_increase_1": 56.6
  },
  {
    "#": "96 Chestnut St, Unit 3 (316-18-03)",
    "$": 599000,
    "address": "96 Chestnut St, Unit 3",
    "parcel_id": "316-18-03",
    "owner1": "TOLAN, DEAN R",
    "owner2": "",
    "current_taxes": 6133.76,
    "new_taxes_no_override": 6398.74,
    "override_total_1": 6580.3,
    "override_increase_1": 181.56
  },
  {
    "#": "98 Chestnut St (316-17-00)",
    "$": 1695100,
    "address": "98 Chestnut St",
    "parcel_id": "316-17-00",
    "owner1": "KIM, SEULLKI DAVID",
    "owner2": "",
    "current_taxes": 17357.82,
    "new_taxes_no_override": 18107.68,
    "override_total_1": 18621.47,
    "override_increase_1": 513.79
  },
  {
    "#": "99 Chestnut St, Unit 1 & P19 (330-08-32)",
    "$": 429800,
    "address": "99 Chestnut St, Unit 1 & P19",
    "parcel_id": "330-08-32",
    "owner1": "GOLYSHKIN, ARTEM",
    "owner2": "",
    "current_taxes": 4401.15,
    "new_taxes_no_override": 4591.28,
    "override_total_1": 4721.55,
    "override_increase_1": 130.27
  },
  {
    "#": "99 Chestnut St, Unit 1B (330-08-31)",
    "$": 362400,
    "address": "99 Chestnut St, Unit 1B",
    "parcel_id": "330-08-31",
    "owner1": "SHARAF, ET AL TR, ALAN B",
    "owner2": "",
    "current_taxes": 3710.98,
    "new_taxes_no_override": 3871.29,
    "override_total_1": 3981.14,
    "override_increase_1": 109.85
  },
  {
    "#": "99 Chestnut St, Unit 2 (330-08-33)",
    "$": 416900,
    "address": "99 Chestnut St, Unit 2",
    "parcel_id": "330-08-33",
    "owner1": "ZHAO, YUN",
    "owner2": "MIN, DUAN",
    "current_taxes": 4269.06,
    "new_taxes_no_override": 4453.48,
    "override_total_1": 4579.85,
    "override_increase_1": 126.36
  },
  {
    "#": "99 Chestnut St, Unit 3 (330-08-34)",
    "$": 409800,
    "address": "99 Chestnut St, Unit 3",
    "parcel_id": "330-08-34",
    "owner1": "SHARAF, ET AL TR, ALAN B",
    "owner2": "",
    "current_taxes": 4196.35,
    "new_taxes_no_override": 4377.63,
    "override_total_1": 4501.84,
    "override_increase_1": 124.21
  },
  {
    "#": "99 Chestnut St, Unit 4 & P33 (330-08-35)",
    "$": 435400,
    "address": "99 Chestnut St, Unit 4 & P33",
    "parcel_id": "330-08-35",
    "owner1": "PIRYATINSKY, MAXIM & IRENE",
    "owner2": "",
    "current_taxes": 4458.5,
    "new_taxes_no_override": 4651.11,
    "override_total_1": 4783.08,
    "override_increase_1": 131.97
  },
  {
    "#": "99 Chestnut St, Unit 5 (330-08-36)",
    "$": 409800,
    "address": "99 Chestnut St, Unit 5",
    "parcel_id": "330-08-36",
    "owner1": "SHARAF, ET AL TR, ALAN B",
    "owner2": "",
    "current_taxes": 4196.35,
    "new_taxes_no_override": 4377.63,
    "override_total_1": 4501.84,
    "override_increase_1": 124.21
  },
  {
    "#": "99 Chestnut St, Unit 6 (330-08-37)",
    "$": 409800,
    "address": "99 Chestnut St, Unit 6",
    "parcel_id": "330-08-37",
    "owner1": "SHARAF, ET AL TR, ALAN B",
    "owner2": "",
    "current_taxes": 4196.35,
    "new_taxes_no_override": 4377.63,
    "override_total_1": 4501.84,
    "override_increase_1": 124.21
  },
  {
    "#": "100 Chestnut St (316-16-00)",
    "$": 1033100,
    "address": "100 Chestnut St",
    "parcel_id": "316-16-00",
    "owner1": "JOHNSON TRS, ERIC D",
    "owner2": "OLFF, NINA L",
    "current_taxes": 6944.01,
    "new_taxes_no_override": 7243.99,
    "override_total_1": 7449.53,
    "override_increase_1": 205.54
  },
  {
    "#": "105 Chestnut St, Unit 1 (330-08-40)",
    "$": 473500,
    "address": "105 Chestnut St, Unit 1",
    "parcel_id": "330-08-40",
    "owner1": "SHARAF, ET AL TR, ALAN B",
    "owner2": "",
    "current_taxes": 4848.64,
    "new_taxes_no_override": 5058.1,
    "override_total_1": 5201.62,
    "override_increase_1": 143.52
  },
  {
    "#": "105 Chestnut St, Unit 1B (330-08-38)",
    "$": 304000,
    "address": "105 Chestnut St, Unit 1B",
    "parcel_id": "330-08-38",
    "owner1": "SHARAF, ET AL TR, ALAN B",
    "owner2": "",
    "current_taxes": 3112.96,
    "new_taxes_no_override": 3247.44,
    "override_total_1": 3339.58,
    "override_increase_1": 92.14
  },
  {
    "#": "105 Chestnut St, Unit 2 P26-P27 (330-08-41)",
    "$": 500700,
    "address": "105 Chestnut St, Unit 2 P26-P27",
    "parcel_id": "330-08-41",
    "owner1": "CAI, LILI",
    "owner2": "JIN, YAN",
    "current_taxes": 5127.17,
    "new_taxes_no_override": 5348.66,
    "override_total_1": 5500.43,
    "override_increase_1": 151.76
  },
  {
    "#": "105 Chestnut St, Unit 2B (330-08-39)",
    "$": 324100,
    "address": "105 Chestnut St, Unit 2B",
    "parcel_id": "330-08-39",
    "owner1": "SHARAF, ET AL TR, ALAN B",
    "owner2": "",
    "current_taxes": 3318.78,
    "new_taxes_no_override": 3462.15,
    "override_total_1": 3560.39,
    "override_increase_1": 98.24
  },
  {
    "#": "105 Chestnut St, Unit 3 (330-08-42)",
    "$": 480300,
    "address": "105 Chestnut St, Unit 3",
    "parcel_id": "330-08-42",
    "owner1": "MEAD, PETER A",
    "owner2": "",
    "current_taxes": 4918.27,
    "new_taxes_no_override": 5130.74,
    "override_total_1": 5276.32,
    "override_increase_1": 145.58
  },
  {
    "#": "105 Chestnut St, Unit 4 (330-08-43)",
    "$": 500400,
    "address": "105 Chestnut St, Unit 4",
    "parcel_id": "330-08-43",
    "owner1": "CHEN TR, YANHONG",
    "owner2": "",
    "current_taxes": 5124.1,
    "new_taxes_no_override": 5345.46,
    "override_total_1": 5497.13,
    "override_increase_1": 151.67
  },
  {
    "#": "105 Chestnut St, Unit 5 (330-08-44)",
    "$": 500400,
    "address": "105 Chestnut St, Unit 5",
    "parcel_id": "330-08-44",
    "owner1": "LIN TRS, JIAN",
    "owner2": "DENG, BIJIA",
    "current_taxes": 5124.1,
    "new_taxes_no_override": 5345.46,
    "override_total_1": 5497.13,
    "override_increase_1": 151.67
  },
  {
    "#": "105 Chestnut St, Unit 6 (330-08-45)",
    "$": 480300,
    "address": "105 Chestnut St, Unit 6",
    "parcel_id": "330-08-45",
    "owner1": "SHARAF, ET AL TR, ALAN B",
    "owner2": "",
    "current_taxes": 4918.27,
    "new_taxes_no_override": 5130.74,
    "override_total_1": 5276.32,
    "override_increase_1": 145.58
  },
  {
    "#": "108 Chestnut St (316-15-00)",
    "$": 1872600,
    "address": "108 Chestnut St",
    "parcel_id": "316-15-00",
    "owner1": "GERTEL TR, ALAN D",
    "owner2": "",
    "current_taxes": 19175.42,
    "new_taxes_no_override": 20003.8,
    "override_total_1": 20571.39,
    "override_increase_1": 567.59
  },
  {
    "#": "108 Chestnut St (316-15-01)",
    "$": 86500,
    "address": "108 Chestnut St",
    "parcel_id": "316-15-01",
    "owner1": "GERTEL TR, ALAN D",
    "owner2": "",
    "current_taxes": 885.76,
    "new_taxes_no_override": 924.02,
    "override_total_1": 950.24,
    "override_increase_1": 26.22
  },
  {
    "#": "108 Chestnut St (316-15-02)",
    "$": 85500,
    "address": "108 Chestnut St",
    "parcel_id": "316-15-02",
    "owner1": "NANSUBUGA, RONAH",
    "owner2": "",
    "current_taxes": 875.52,
    "new_taxes_no_override": 913.34,
    "override_total_1": 939.26,
    "override_increase_1": 25.92
  },
  {
    "#": "108 Chestnut St (316-15-04)",
    "$": 86100,
    "address": "108 Chestnut St",
    "parcel_id": "316-15-04",
    "owner1": "OCONNOR TR, JEAN M",
    "owner2": "",
    "current_taxes": 881.66,
    "new_taxes_no_override": 919.75,
    "override_total_1": 945.84,
    "override_increase_1": 26.1
  },
  {
    "#": "110 Chestnut St, Unit 1 (316-14-02)",
    "$": 598700,
    "address": "110 Chestnut St, Unit 1",
    "parcel_id": "316-14-02",
    "owner1": "MINDREAU, ELIZABETH R & NICOLAS",
    "owner2": "",
    "current_taxes": 2495.75,
    "new_taxes_no_override": 2603.57,
    "override_total_1": 2677.44,
    "override_increase_1": 73.87
  },
  {
    "#": "110 Chestnut St, Unit 2 (316-14-03)",
    "$": 644700,
    "address": "110 Chestnut St, Unit 2",
    "parcel_id": "316-14-03",
    "owner1": "LEE, WILLIAM",
    "owner2": "",
    "current_taxes": 6601.73,
    "new_taxes_no_override": 6886.92,
    "override_total_1": 7082.34,
    "override_increase_1": 195.41
  },
  {
    "#": "110 Chestnut St (316-14-00)",
    "$": 1318900,
    "address": "110 Chestnut St",
    "parcel_id": "316-14-00",
    "owner1": "STROM, ADAM",
    "owner2": "SMITH-GARCES, SANDY",
    "current_taxes": 13505.54,
    "new_taxes_no_override": 14088.98,
    "override_total_1": 14488.74,
    "override_increase_1": 399.76
  },
  {
    "#": "111 Chestnut St (330-08-00)",
    "$": 1121600,
    "address": "111 Chestnut St",
    "parcel_id": "330-08-00",
    "owner1": "KOULMANDA TR, MARIA",
    "owner2": "",
    "current_taxes": 7850.25,
    "new_taxes_no_override": 8189.38,
    "override_total_1": 8421.75,
    "override_increase_1": 232.37
  },
  {
    "#": "112 Chestnut St, Unit A (316-13-01)",
    "$": 1184800,
    "address": "112 Chestnut St, Unit A",
    "parcel_id": "316-13-01",
    "owner1": "SHARMA, RAMAN & RAJNI",
    "owner2": "",
    "current_taxes": 12132.35,
    "new_taxes_no_override": 12656.47,
    "override_total_1": 13015.59,
    "override_increase_1": 359.12
  },
  {
    "#": "112 Chestnut St, Unit 1 (316-13-02)",
    "$": 599800,
    "address": "112 Chestnut St, Unit 1",
    "parcel_id": "316-13-02",
    "owner1": "ROW, KALPANA",
    "owner2": "",
    "current_taxes": 2507.02,
    "new_taxes_no_override": 2615.32,
    "override_total_1": 2689.53,
    "override_increase_1": 74.21
  },
  {
    "#": "112 Chestnut St, Unit 2 (316-13-03)",
    "$": 624800,
    "address": "112 Chestnut St, Unit 2",
    "parcel_id": "316-13-03",
    "owner1": "CORDNER, RICHARD S & SUSAN L",
    "owner2": "",
    "current_taxes": 2763.02,
    "new_taxes_no_override": 2882.38,
    "override_total_1": 2964.17,
    "override_increase_1": 81.79
  },
  {
    "#": "112 Chestnut St, Unit 3 & P1 P3 (316-13-04)",
    "$": 939500,
    "address": "112 Chestnut St, Unit 3 & P1 P3",
    "parcel_id": "316-13-04",
    "owner1": "WOZNIAK TRS, EARL A & JANA D",
    "owner2": "",
    "current_taxes": 5985.55,
    "new_taxes_no_override": 6244.13,
    "override_total_1": 6421.3,
    "override_increase_1": 177.17
  },
  {
    "#": "114 Chestnut St, Unit 1 (316-12-01)",
    "$": 930600,
    "address": "114 Chestnut St, Unit 1",
    "parcel_id": "316-12-01",
    "owner1": "FAGAN, STEPHANIE E & JOSEPH T",
    "owner2": "",
    "current_taxes": 5894.41,
    "new_taxes_no_override": 6149.05,
    "override_total_1": 6323.52,
    "override_increase_1": 174.47
  },
  {
    "#": "114 Chestnut St, Unit 2 (316-12-02)",
    "$": 1188000,
    "address": "114 Chestnut St, Unit 2",
    "parcel_id": "316-12-02",
    "owner1": "AMY, EILEEN M",
    "owner2": "BERINSTEIN, EDUARDO H",
    "current_taxes": 8530.19,
    "new_taxes_no_override": 8898.69,
    "override_total_1": 9151.19,
    "override_increase_1": 252.49
  },
  {
    "#": "115 Chestnut St (330-07-02)",
    "$": 1051300,
    "address": "115 Chestnut St",
    "parcel_id": "330-07-02",
    "owner1": "AUDEH, ZUHEIR & SIHAM",
    "owner2": "",
    "current_taxes": 7130.38,
    "new_taxes_no_override": 7438.41,
    "override_total_1": 7649.47,
    "override_increase_1": 211.06
  },
  {
    "#": "116 Chestnut St (316-11-00)",
    "$": 1545900,
    "address": "116 Chestnut St",
    "parcel_id": "316-11-00",
    "owner1": "OCONNOR TR, JEAN M",
    "owner2": "",
    "current_taxes": 12195.08,
    "new_taxes_no_override": 12721.91,
    "override_total_1": 13082.88,
    "override_increase_1": 360.97
  },
  {
    "#": "117 Chestnut St (330-07-01)",
    "$": 1308600,
    "address": "117 Chestnut St",
    "parcel_id": "330-07-01",
    "owner1": "CHO, FRED Y M & SIU H",
    "owner2": "",
    "current_taxes": 13400.06,
    "new_taxes_no_override": 13978.94,
    "override_total_1": 14375.58,
    "override_increase_1": 396.64
  },
  {
    "#": "121 Chestnut St, Unit 121 (330-07-03)",
    "$": 775400,
    "address": "121 Chestnut St, Unit 121",
    "parcel_id": "330-07-03",
    "owner1": "REYELT, WILLIAM & OLIVIA",
    "owner2": "",
    "current_taxes": 7940.1,
    "new_taxes_no_override": 8283.11,
    "override_total_1": 8518.14,
    "override_increase_1": 235.03
  },
  {
    "#": "121 Chestnut St, Unit 123 (330-07-04)",
    "$": 780100,
    "address": "121 Chestnut St, Unit 123",
    "parcel_id": "330-07-04",
    "owner1": "REYELT, WILLIAM & OLIVIA",
    "owner2": "",
    "current_taxes": 7988.22,
    "new_taxes_no_override": 8333.31,
    "override_total_1": 8569.76,
    "override_increase_1": 236.45
  },
  {
    "#": "122 Chestnut St (316-10-00)",
    "$": 1237800,
    "address": "122 Chestnut St",
    "parcel_id": "316-10-00",
    "owner1": "MILLER, BETH",
    "owner2": "HALLOCK, THOMAS",
    "current_taxes": 9040.14,
    "new_taxes_no_override": 9430.67,
    "override_total_1": 9698.26,
    "override_increase_1": 267.59
  },
  {
    "#": "124 Chestnut St, Unit 1 (316-09-03)",
    "$": 795800,
    "address": "124 Chestnut St, Unit 1",
    "parcel_id": "316-09-03",
    "owner1": "MELTON TR, GINGER",
    "owner2": "",
    "current_taxes": 4514.06,
    "new_taxes_no_override": 4709.07,
    "override_total_1": 4842.68,
    "override_increase_1": 133.62
  },
  {
    "#": "124 Chestnut St, Unit 2 (316-09-01)",
    "$": 767900,
    "address": "124 Chestnut St, Unit 2",
    "parcel_id": "316-09-01",
    "owner1": "TUCKER, FRANCES",
    "owner2": "",
    "current_taxes": 4228.36,
    "new_taxes_no_override": 4411.03,
    "override_total_1": 4536.18,
    "override_increase_1": 125.16
  },
  {
    "#": "124 Chestnut St, Unit 3 (316-09-02)",
    "$": 991800,
    "address": "124 Chestnut St, Unit 3",
    "parcel_id": "316-09-02",
    "owner1": "EPSTEIN TRS, PAUL P & SASKIA",
    "owner2": "C/O EPSTEIN , LESLIE",
    "current_taxes": 6521.1,
    "new_taxes_no_override": 6802.81,
    "override_total_1": 6995.84,
    "override_increase_1": 193.02
  },
  {
    "#": "126 Chestnut St, Unit 1 (316-08-01)",
    "$": 853800,
    "address": "126 Chestnut St, Unit 1",
    "parcel_id": "316-08-01",
    "owner1": "BROWN, DEBORAH MARIE",
    "owner2": "",
    "current_taxes": 5107.98,
    "new_taxes_no_override": 5328.64,
    "override_total_1": 5479.84,
    "override_increase_1": 151.2
  },
  {
    "#": "126 Chestnut St, Unit 2 (316-08-02)",
    "$": 852500,
    "address": "126 Chestnut St, Unit 2",
    "parcel_id": "316-08-02",
    "owner1": "ALPHONSUS, JAMES",
    "owner2": "BROWN, LISA MARIE",
    "current_taxes": 5094.67,
    "new_taxes_no_override": 5314.76,
    "override_total_1": 5465.56,
    "override_increase_1": 150.8
  },
  {
    "#": "126 Chestnut St, Unit 3 (316-08-03)",
    "$": 882600,
    "address": "126 Chestnut St, Unit 3",
    "parcel_id": "316-08-03",
    "owner1": "POSTNIKOV, ALEXANDER",
    "owner2": "",
    "current_taxes": 5402.89,
    "new_taxes_no_override": 5636.29,
    "override_total_1": 5796.22,
    "override_increase_1": 159.93
  },
  {
    "#": "127 Chestnut St (330-06-02)",
    "$": 1424000,
    "address": "127 Chestnut St",
    "parcel_id": "330-06-02",
    "owner1": "ROSE TRS, LANDON CARTER",
    "owner2": "LEADER, MARTHA LOIS",
    "current_taxes": 10946.83,
    "new_taxes_no_override": 11419.73,
    "override_total_1": 11743.76,
    "override_increase_1": 324.03
  },
  {
    "#": "128 Chestnut St, Unit 1 (316-07-01)",
    "$": 600300,
    "address": "128 Chestnut St, Unit 1",
    "parcel_id": "316-07-01",
    "owner1": "WANG TRS, DAVID S",
    "owner2": "KUOHUNG, WENDY",
    "current_taxes": 6147.07,
    "new_taxes_no_override": 6412.62,
    "override_total_1": 6594.58,
    "override_increase_1": 181.95
  },
  {
    "#": "128 Chestnut St, Unit 2 (316-07-02)",
    "$": 629700,
    "address": "128 Chestnut St, Unit 2",
    "parcel_id": "316-07-02",
    "owner1": "SAMARASAN, DIANA",
    "owner2": "",
    "current_taxes": 2813.19,
    "new_taxes_no_override": 2934.72,
    "override_total_1": 3017.99,
    "override_increase_1": 83.27
  },
  {
    "#": "128 Chestnut St, Unit 3 (316-07-03)",
    "$": 629700,
    "address": "128 Chestnut St, Unit 3",
    "parcel_id": "316-07-03",
    "owner1": "RUPOV, ANGEL",
    "owner2": "MINCHEVA, SVETLA",
    "current_taxes": 2813.19,
    "new_taxes_no_override": 2934.72,
    "override_total_1": 3017.99,
    "override_increase_1": 83.27
  },
  {
    "#": "133 Chestnut St, Unit 1 (330-06-05)",
    "$": 1428000,
    "address": "133 Chestnut St, Unit 1",
    "parcel_id": "330-06-05",
    "owner1": "GUJRAL, HARNEET",
    "owner2": "SINGH, HARSHABAD",
    "current_taxes": 10987.79,
    "new_taxes_no_override": 11462.46,
    "override_total_1": 11787.7,
    "override_increase_1": 325.24
  },
  {
    "#": "133 Chestnut St, Unit 2 (330-06-06)",
    "$": 1595500,
    "address": "133 Chestnut St, Unit 2",
    "parcel_id": "330-06-06",
    "owner1": "CHANG TRS, HYUNIL KALEB & CELINA CHOI",
    "owner2": "",
    "current_taxes": 12702.99,
    "new_taxes_no_override": 13251.76,
    "override_total_1": 13627.77,
    "override_increase_1": 376.01
  },
  {
    "#": "135 Chestnut St, Unit 1 (330-06-03)",
    "$": 1003700,
    "address": "135 Chestnut St, Unit 1",
    "parcel_id": "330-06-03",
    "owner1": "NARVA, ADAMS S",
    "owner2": "MARTIN, PAULA",
    "current_taxes": 6642.95,
    "new_taxes_no_override": 6929.93,
    "override_total_1": 7126.56,
    "override_increase_1": 196.63
  },
  {
    "#": "137 Chestnut St, Unit 2 (330-06-04)",
    "$": 1256700,
    "address": "137 Chestnut St, Unit 2",
    "parcel_id": "330-06-04",
    "owner1": "CHENG TRS, SHEUNG HUN",
    "owner2": "ONG TRS, WAI MUN",
    "current_taxes": 9233.67,
    "new_taxes_no_override": 9632.56,
    "override_total_1": 9905.88,
    "override_increase_1": 273.32
  },
  {
    "#": "141 Chestnut St (330-05-02)",
    "$": 1535400,
    "address": "141 Chestnut St",
    "parcel_id": "330-05-02",
    "owner1": "GUZMAN, ARIEL & YAEL",
    "owner2": "",
    "current_taxes": 12087.56,
    "new_taxes_no_override": 12609.74,
    "override_total_1": 12967.53,
    "override_increase_1": 357.79
  },
  {
    "#": "145 Chestnut St (330-05-01)",
    "$": 1258700,
    "address": "145 Chestnut St",
    "parcel_id": "330-05-01",
    "owner1": "YAKHKIND TRS, LEONID",
    "owner2": "SMIRNOVA, TAMARA",
    "current_taxes": 9254.15,
    "new_taxes_no_override": 9653.93,
    "override_total_1": 9927.85,
    "override_increase_1": 273.92
  },
  {
    "#": "148 Chestnut St (303-01-00)",
    "$": 1544800,
    "address": "148 Chestnut St",
    "parcel_id": "303-01-00",
    "owner1": "SUN, JIUSONG",
    "owner2": "",
    "current_taxes": 15818.75,
    "new_taxes_no_override": 16502.12,
    "override_total_1": 16970.35,
    "override_increase_1": 468.24
  },
  {
    "#": "149 Chestnut St (330-05-00)",
    "$": 1491300,
    "address": "149 Chestnut St",
    "parcel_id": "330-05-00",
    "owner1": "MCDONNELL LIFE ESTATE, DOREEN H",
    "owner2": "",
    "current_taxes": 11635.98,
    "new_taxes_no_override": 12138.65,
    "override_total_1": 12483.08,
    "override_increase_1": 344.43
  },
  {
    "#": "156 Chestnut St, Unit 1 P1&2 (302-05-01)",
    "$": 853200,
    "address": "156 Chestnut St, Unit 1 P1&2",
    "parcel_id": "302-05-01",
    "owner1": "WHELAN TRS, BRIAN D",
    "owner2": "ESTRADA-MADRIGAL, WENDY",
    "current_taxes": 5101.83,
    "new_taxes_no_override": 5322.23,
    "override_total_1": 5473.24,
    "override_increase_1": 151.01
  },
  {
    "#": "156 Chestnut St, Unit 2 & P-4 (302-05-02)",
    "$": 838300,
    "address": "156 Chestnut St, Unit 2 & P-4",
    "parcel_id": "302-05-02",
    "owner1": "SCHENKMAN, ALEX D",
    "owner2": "MUSSER, MELISSA",
    "current_taxes": 4949.26,
    "new_taxes_no_override": 5163.07,
    "override_total_1": 5309.57,
    "override_increase_1": 146.5
  },
  {
    "#": "156 Chestnut St, Unit 3 & P3 (302-05-03)",
    "$": 750600,
    "address": "156 Chestnut St, Unit 3 & P3",
    "parcel_id": "302-05-03",
    "owner1": "LAFRANCE, LISA M",
    "owner2": "",
    "current_taxes": 4051.21,
    "new_taxes_no_override": 4226.22,
    "override_total_1": 4346.14,
    "override_increase_1": 119.92
  },
  {
    "#": "160 Chestnut St (302-04-00)",
    "$": 1712200,
    "address": "160 Chestnut St",
    "parcel_id": "302-04-00",
    "owner1": "ANTONIOU, STEPHANOS",
    "owner2": "",
    "current_taxes": 13897.99,
    "new_taxes_no_override": 14498.38,
    "override_total_1": 14909.76,
    "override_increase_1": 411.38
  },
  {
    "#": "162 Chestnut St (302-03-00)",
    "$": 1861300,
    "address": "162 Chestnut St",
    "parcel_id": "302-03-00",
    "owner1": "FISCHER, ANDREW M & LINDA",
    "owner2": "WARNER TRS, CHERYL K & DONALD A",
    "current_taxes": 19059.71,
    "new_taxes_no_override": 19883.09,
    "override_total_1": 20447.26,
    "override_increase_1": 564.17
  },
  {
    "#": "165 Chestnut St (330-02-15)",
    "$": 23643100,
    "address": "165 Chestnut St",
    "parcel_id": "330-02-15",
    "owner1": "HOME FOR AGED WOMEN",
    "owner2": "C/O GENESIS HEALTHCARE CORP - A ROSSKAM",
    "current_taxes": 242105.34,
    "new_taxes_no_override": 252564.29,
    "override_total_1": 259730.61,
    "override_increase_1": 7166.32
  },
  {
    "#": "166 Chestnut St, Unit 1 (302-02-01)",
    "$": 747100,
    "address": "166 Chestnut St, Unit 1",
    "parcel_id": "302-02-01",
    "owner1": "WANG, GUOXIAO",
    "owner2": "WU, XIAODI",
    "current_taxes": 7650.3,
    "new_taxes_no_override": 7980.79,
    "override_total_1": 8207.24,
    "override_increase_1": 226.45
  },
  {
    "#": "166 Chestnut St, Unit 2 (302-02-02)",
    "$": 771800,
    "address": "166 Chestnut St, Unit 2",
    "parcel_id": "302-02-02",
    "owner1": "SUNSHINE, ELIZABETH",
    "owner2": "",
    "current_taxes": 4268.3,
    "new_taxes_no_override": 4452.69,
    "override_total_1": 4579.03,
    "override_increase_1": 126.34
  },
  {
    "#": "166 Chestnut St, Unit 3 (302-02-03)",
    "$": 693400,
    "address": "166 Chestnut St, Unit 3",
    "parcel_id": "302-02-03",
    "owner1": "CAHOON, AMY B",
    "owner2": "",
    "current_taxes": 3465.48,
    "new_taxes_no_override": 3615.19,
    "override_total_1": 3717.77,
    "override_increase_1": 102.58
  },
  {
    "#": "167 Chestnut St (330-01-00)",
    "$": 78300,
    "address": "167 Chestnut St",
    "parcel_id": "330-01-00",
    "owner1": "CABOT ESTATES CONDOMINIUM TRUST",
    "owner2": "",
    "current_taxes": 801.79,
    "new_taxes_no_override": 836.43,
    "override_total_1": 860.16,
    "override_increase_1": 23.73
  },
  {
    "#": "186 Chestnut St (301-28-00)",
    "$": 42869000,
    "address": "186 Chestnut St",
    "parcel_id": "301-28-00",
    "owner1": "BROOKLINE HOUSING AUTHORITY",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": " Chestnut St (316A-12-01)",
    "$": 138900,
    "address": " Chestnut St",
    "parcel_id": "316A-12-01",
    "owner1": "66 CHESTNUT STREET LLC",
    "owner2": "",
    "current_taxes": 1422.34,
    "new_taxes_no_override": 1483.79,
    "override_total_1": 1525.89,
    "override_increase_1": 42.1
  },
  {
    "#": "6 Chilton St (009-07-00)",
    "$": 4998800,
    "address": "6 Chilton St",
    "parcel_id": "009-07-00",
    "owner1": "KOTLER TR, RONNI",
    "owner2": "",
    "current_taxes": 47552.78,
    "new_taxes_no_override": 49607.06,
    "override_total_1": 51014.62,
    "override_increase_1": 1407.56
  },
  {
    "#": "7 Chilton St (009A-01-00)",
    "$": 3326700,
    "address": "7 Chilton St",
    "parcel_id": "009A-01-00",
    "owner1": "CHASEN, BARBARA Z",
    "owner2": "",
    "current_taxes": 30430.47,
    "new_taxes_no_override": 31745.07,
    "override_total_1": 32645.81,
    "override_increase_1": 900.74
  },
  {
    "#": "15 Chilton St (009A-02-00)",
    "$": 3410100,
    "address": "15 Chilton St",
    "parcel_id": "009A-02-00",
    "owner1": "SANDERS, CHARLES H",
    "owner2": "",
    "current_taxes": 31284.49,
    "new_taxes_no_override": 32635.98,
    "override_total_1": 33562.0,
    "override_increase_1": 926.02
  },
  {
    "#": "16 Chilton St (009-06-00)",
    "$": 5010000,
    "address": "16 Chilton St",
    "parcel_id": "009-06-00",
    "owner1": "MOGHTADER, PAUL & SARAH",
    "owner2": "",
    "current_taxes": 47667.47,
    "new_taxes_no_override": 49726.7,
    "override_total_1": 51137.66,
    "override_increase_1": 1410.96
  },
  {
    "#": "21 Chilton St (009A-03-00)",
    "$": 4210900,
    "address": "21 Chilton St",
    "parcel_id": "009A-03-00",
    "owner1": "VOLPE TRS, JOSEPH J & SARA",
    "owner2": "",
    "current_taxes": 39484.68,
    "new_taxes_no_override": 41190.42,
    "override_total_1": 42359.16,
    "override_increase_1": 1168.75
  },
  {
    "#": "26 Chilton St (009-04-05)",
    "$": 5208500,
    "address": "26 Chilton St",
    "parcel_id": "009-04-05",
    "owner1": "BAE TRS, EUNHAK",
    "owner2": "KWAK TRS, ROBERT DANIEL",
    "current_taxes": 49700.11,
    "new_taxes_no_override": 51847.15,
    "override_total_1": 53318.28,
    "override_increase_1": 1471.12
  },
  {
    "#": "27 Chilton St (009A-04-00)",
    "$": 3849200,
    "address": "27 Chilton St",
    "parcel_id": "009A-04-00",
    "owner1": "ARNSTEIN, DOLPHIA NANDI & MATTHEW",
    "owner2": "",
    "current_taxes": 35780.87,
    "new_taxes_no_override": 37326.6,
    "override_total_1": 38385.72,
    "override_increase_1": 1059.11
  },
  {
    "#": "208 Church St (379-01-00)",
    "$": 670700,
    "address": "208 Church St",
    "parcel_id": "379-01-00",
    "owner1": "FRIEDMAN, SONIA",
    "owner2": "WEINHOUSE, GERALD L",
    "current_taxes": 6867.97,
    "new_taxes_no_override": 7164.67,
    "override_total_1": 7367.96,
    "override_increase_1": 203.29
  },
  {
    "#": "6 Churchill St (009B-06-00)",
    "$": 3015200,
    "address": "6 Churchill St",
    "parcel_id": "009B-06-00",
    "owner1": "WEINER TR, HELEN E",
    "owner2": "",
    "current_taxes": 27240.71,
    "new_taxes_no_override": 28417.51,
    "override_total_1": 29223.83,
    "override_increase_1": 806.33
  },
  {
    "#": "12 Churchill St (009B-05-00)",
    "$": 3070100,
    "address": "12 Churchill St",
    "parcel_id": "009B-05-00",
    "owner1": "DREYER TRS, JOHN R",
    "owner2": "CUTLER, JONATHAN D",
    "current_taxes": 27802.89,
    "new_taxes_no_override": 29003.97,
    "override_total_1": 29826.94,
    "override_increase_1": 822.97
  },
  {
    "#": "18 Churchill St (009B-04-00)",
    "$": 2571900,
    "address": "18 Churchill St",
    "parcel_id": "009B-04-00",
    "owner1": "KWAN, THEODORE H",
    "owner2": "MOULTON, ANDREW S",
    "current_taxes": 22701.32,
    "new_taxes_no_override": 23682.02,
    "override_total_1": 24353.98,
    "override_increase_1": 671.96
  },
  {
    "#": "24 Churchill St (009B-03-00)",
    "$": 2152800,
    "address": "24 Churchill St",
    "parcel_id": "009B-03-00",
    "owner1": "RESLER, W MICHAEL",
    "owner2": "LUTCAVAGE, CHARLES",
    "current_taxes": 18409.74,
    "new_taxes_no_override": 19205.04,
    "override_total_1": 19749.97,
    "override_increase_1": 544.93
  },
  {
    "#": "30 Churchill St (009B-01-00)",
    "$": 2607300,
    "address": "30 Churchill St",
    "parcel_id": "009B-01-00",
    "owner1": "CHRISTOPHER, TR, SHERRY",
    "owner2": "C/O GARRETT OR JESSE CHRISTOPHER",
    "current_taxes": 26698.75,
    "new_taxes_no_override": 27852.14,
    "override_total_1": 28642.42,
    "override_increase_1": 790.28
  },
  {
    "#": "4 Circuit Rd (281-06-00)",
    "$": 2919000,
    "address": "4 Circuit Rd",
    "parcel_id": "281-06-00",
    "owner1": "WRIGHT, JOSHUA P",
    "owner2": "",
    "current_taxes": 26255.63,
    "new_taxes_no_override": 27389.87,
    "override_total_1": 28167.04,
    "override_increase_1": 777.17
  },
  {
    "#": "5 Circuit Rd (279-11-00)",
    "$": 3511800,
    "address": "5 Circuit Rd",
    "parcel_id": "279-11-00",
    "owner1": "AVORN, JEROME L",
    "owner2": "TUCKER, KAREN L",
    "current_taxes": 32325.9,
    "new_taxes_no_override": 33722.38,
    "override_total_1": 34679.23,
    "override_increase_1": 956.85
  },
  {
    "#": "10 Circuit Rd (281-05-00)",
    "$": 2973900,
    "address": "10 Circuit Rd",
    "parcel_id": "281-05-00",
    "owner1": "GALL, JEREMIAH & ANNA",
    "owner2": "",
    "current_taxes": 30452.74,
    "new_taxes_no_override": 31768.3,
    "override_total_1": 32669.7,
    "override_increase_1": 901.4
  },
  {
    "#": "15 Circuit Rd (279-12-01)",
    "$": 4571900,
    "address": "15 Circuit Rd",
    "parcel_id": "279-12-01",
    "owner1": "DINWOODEY, JONATHAN & DANYA",
    "owner2": "",
    "current_taxes": 43181.32,
    "new_taxes_no_override": 45046.75,
    "override_total_1": 46324.92,
    "override_increase_1": 1278.17
  },
  {
    "#": "16 Circuit Rd (281-04-00)",
    "$": 2868500,
    "address": "16 Circuit Rd",
    "parcel_id": "281-04-00",
    "owner1": "BROWNE, MARCIA J",
    "owner2": "CLARK, JEFFREY W",
    "current_taxes": 25738.51,
    "new_taxes_no_override": 26850.41,
    "override_total_1": 27612.27,
    "override_increase_1": 761.86
  },
  {
    "#": "20 Circuit Rd (281-03-00)",
    "$": 3206300,
    "address": "20 Circuit Rd",
    "parcel_id": "281-03-00",
    "owner1": "EVANS TR, RUSSELL B",
    "owner2": "",
    "current_taxes": 29197.58,
    "new_taxes_no_override": 30458.92,
    "override_total_1": 31323.16,
    "override_increase_1": 864.25
  },
  {
    "#": "23 Circuit Rd (279-12-02)",
    "$": 4396300,
    "address": "23 Circuit Rd",
    "parcel_id": "279-12-02",
    "owner1": "THURMOND TR, KATHLEEN F",
    "owner2": "",
    "current_taxes": 41383.18,
    "new_taxes_no_override": 43170.93,
    "override_total_1": 44395.88,
    "override_increase_1": 1224.94
  },
  {
    "#": "26 Circuit Rd (281-02-00)",
    "$": 2795200,
    "address": "26 Circuit Rd",
    "parcel_id": "281-02-00",
    "owner1": "BENKA, RICHARD W & CARLA W",
    "owner2": "",
    "current_taxes": 24987.91,
    "new_taxes_no_override": 26067.39,
    "override_total_1": 26807.03,
    "override_increase_1": 739.64
  },
  {
    "#": "33 Circuit Rd (279-13-14)",
    "$": 4468300,
    "address": "33 Circuit Rd",
    "parcel_id": "279-13-14",
    "owner1": "CROMWELL, GORDON P & WENDY M",
    "owner2": "",
    "current_taxes": 42120.46,
    "new_taxes_no_override": 43940.06,
    "override_total_1": 45186.83,
    "override_increase_1": 1246.77
  },
  {
    "#": "35 Circuit Rd (279-15-00)",
    "$": 1597100,
    "address": "35 Circuit Rd",
    "parcel_id": "279-15-00",
    "owner1": "LUBY, STEVEN C",
    "owner2": "KACZOR, KRISTINE L",
    "current_taxes": 16354.3,
    "new_taxes_no_override": 17060.81,
    "override_total_1": 17544.89,
    "override_increase_1": 484.09
  },
  {
    "#": "37 Circuit Rd (279-16-00)",
    "$": 4432300,
    "address": "37 Circuit Rd",
    "parcel_id": "279-16-00",
    "owner1": "TINGUE, CHARLES HOWARD & CAITLIN GOODMAN",
    "owner2": "",
    "current_taxes": 41751.82,
    "new_taxes_no_override": 43555.5,
    "override_total_1": 44791.35,
    "override_increase_1": 1235.85
  },
  {
    "#": "43 Circuit Rd (279-17-18)",
    "$": 4303800,
    "address": "43 Circuit Rd",
    "parcel_id": "279-17-18",
    "owner1": "SALTZMAN, DAVID & JULIE",
    "owner2": "",
    "current_taxes": 40435.98,
    "new_taxes_no_override": 42182.81,
    "override_total_1": 43379.72,
    "override_increase_1": 1196.91
  },
  {
    "#": "44 Circuit Rd (281-01-00)",
    "$": 5377400,
    "address": "44 Circuit Rd",
    "parcel_id": "281-01-00",
    "owner1": "FARRELL, MICHAEL W",
    "owner2": "ASBURY, ELEANOR SYDNEY",
    "current_taxes": 51429.64,
    "new_taxes_no_override": 53651.4,
    "override_total_1": 55173.72,
    "override_increase_1": 1522.32
  },
  {
    "#": "62 Circuit Rd (280-02-00)",
    "$": 4115800,
    "address": "62 Circuit Rd",
    "parcel_id": "280-02-00",
    "owner1": "CLUETT, JONATHAN C",
    "owner2": "BEACH, JENNIFER",
    "current_taxes": 38510.86,
    "new_taxes_no_override": 40174.53,
    "override_total_1": 41314.45,
    "override_increase_1": 1139.92
  },
  {
    "#": "70 Circuit Rd (280-01-00)",
    "$": 4347700,
    "address": "70 Circuit Rd",
    "parcel_id": "280-01-00",
    "owner1": "CULLINANE TRS, AGNES M & SUZANNE",
    "owner2": "KEHOE, WILLIAM F",
    "current_taxes": 40885.51,
    "new_taxes_no_override": 42651.76,
    "override_total_1": 43861.98,
    "override_increase_1": 1210.21
  },
  {
    "#": "2 City View Rd (091-44-00)",
    "$": 1869000,
    "address": "2 City View Rd",
    "parcel_id": "091-44-00",
    "owner1": "ROSENGARD TR, PENINAH S",
    "owner2": "",
    "current_taxes": 15503.63,
    "new_taxes_no_override": 16173.39,
    "override_total_1": 16632.29,
    "override_increase_1": 458.91
  },
  {
    "#": "6 City View Rd (091-43-00)",
    "$": 1895600,
    "address": "6 City View Rd",
    "parcel_id": "091-43-00",
    "owner1": "LERRA, THOMAS W & DENA",
    "owner2": "",
    "current_taxes": 15776.01,
    "new_taxes_no_override": 16457.53,
    "override_total_1": 16924.5,
    "override_increase_1": 466.97
  },
  {
    "#": "10 City View Rd (091-42-00)",
    "$": 1794400,
    "address": "10 City View Rd",
    "parcel_id": "091-42-00",
    "owner1": "MICHAELS TRS, RONALD",
    "owner2": "JANTZEN, KATHERINE A",
    "current_taxes": 14739.72,
    "new_taxes_no_override": 15376.48,
    "override_total_1": 15812.77,
    "override_increase_1": 436.3
  },
  {
    "#": "14 City View Rd (091-41-00)",
    "$": 1683000,
    "address": "14 City View Rd",
    "parcel_id": "091-41-00",
    "owner1": "CORES LIFE ESTATE, SIDNEY L",
    "owner2": "",
    "current_taxes": 13598.99,
    "new_taxes_no_override": 14186.47,
    "override_total_1": 14589.0,
    "override_increase_1": 402.53
  },
  {
    "#": "18 City View Rd (091-40-00)",
    "$": 1867100,
    "address": "18 City View Rd",
    "parcel_id": "091-40-00",
    "owner1": "NANCARROW, WILLIAM J & CHERYL M",
    "owner2": "",
    "current_taxes": 15484.17,
    "new_taxes_no_override": 16153.09,
    "override_total_1": 16611.42,
    "override_increase_1": 458.33
  },
  {
    "#": "22 City View Rd (091-39-00)",
    "$": 2175400,
    "address": "22 City View Rd",
    "parcel_id": "091-39-00",
    "owner1": "DING, RUIJIAN & HONG",
    "owner2": "JIANG, WENYI",
    "current_taxes": 18641.16,
    "new_taxes_no_override": 19446.46,
    "override_total_1": 19998.24,
    "override_increase_1": 551.78
  },
  {
    "#": "7 Claflin Path, Unit 1 (220-11-01)",
    "$": 1109400,
    "address": "7 Claflin Path, Unit 1",
    "parcel_id": "220-11-01",
    "owner1": "DUMAS TRS, KENNETH A & DANIELLE R",
    "owner2": "",
    "current_taxes": 7725.32,
    "new_taxes_no_override": 8059.05,
    "override_total_1": 8287.72,
    "override_increase_1": 228.67
  },
  {
    "#": "7 Claflin Path, Unit 2 (220-11-02)",
    "$": 1418000,
    "address": "7 Claflin Path, Unit 2",
    "parcel_id": "220-11-02",
    "owner1": "GREENZANG, STEVEN S & VIRGINIA R",
    "owner2": "",
    "current_taxes": 10885.39,
    "new_taxes_no_override": 11355.64,
    "override_total_1": 11677.85,
    "override_increase_1": 322.21
  },
  {
    "#": "11 Claflin Path (220-12-00)",
    "$": 2514500,
    "address": "11 Claflin Path",
    "parcel_id": "220-12-00",
    "owner1": "ITKIN ET AL, DINA",
    "owner2": "SMOLYAR, OLGA",
    "current_taxes": 22113.55,
    "new_taxes_no_override": 23068.86,
    "override_total_1": 23723.42,
    "override_increase_1": 654.56
  },
  {
    "#": "15 Claflin Path, Unit 1 (220-13-02)",
    "$": 995400,
    "address": "15 Claflin Path, Unit 1",
    "parcel_id": "220-13-02",
    "owner1": "EWENSTEIN, BRUCE & PAULA",
    "owner2": "",
    "current_taxes": 6557.96,
    "new_taxes_no_override": 6841.26,
    "override_total_1": 7035.38,
    "override_increase_1": 194.12
  },
  {
    "#": "15 Claflin Path, Unit 2 & G2 (220-13-01)",
    "$": 1642500,
    "address": "15 Claflin Path, Unit 2 & G2",
    "parcel_id": "220-13-01",
    "owner1": "MIDDELEER, ALEXANDER B",
    "owner2": "PACKER, ELIZABETH M",
    "current_taxes": 13184.27,
    "new_taxes_no_override": 13753.83,
    "override_total_1": 14144.08,
    "override_increase_1": 390.25
  },
  {
    "#": "16 Claflin Path (220-15-00)",
    "$": 38200,
    "address": "16 Claflin Path",
    "parcel_id": "220-15-00",
    "owner1": "ITKIN ET AL, DINA",
    "owner2": "SMOLYAR, OLGA",
    "current_taxes": 391.17,
    "new_taxes_no_override": 408.07,
    "override_total_1": 419.65,
    "override_increase_1": 11.58
  },
  {
    "#": " Claflin Path (220-08-00)",
    "$": 51300,
    "address": " Claflin Path",
    "parcel_id": "220-08-00",
    "owner1": "ITKIN ET AL, DINA",
    "owner2": "SMOLYAR, OLGA",
    "current_taxes": 525.31,
    "new_taxes_no_override": 548.0,
    "override_total_1": 563.55,
    "override_increase_1": 15.55
  },
  {
    "#": "2 Claflin Rd (220-72-00)",
    "$": 10756700,
    "address": "2 Claflin Rd",
    "parcel_id": "220-72-00",
    "owner1": "TRI CORNER REALTY LLC",
    "owner2": "C/O JEFF KLEIN",
    "current_taxes": 110148.61,
    "new_taxes_no_override": 114907.03,
    "override_total_1": 118167.43,
    "override_increase_1": 3260.4
  },
  {
    "#": "6 Claflin Rd, Unit 1 (220-71-01)",
    "$": 1296700,
    "address": "6 Claflin Rd, Unit 1",
    "parcel_id": "220-71-01",
    "owner1": "EL TAYEBY, AHMAD HISHAM",
    "owner2": "TAYEBY, LETITIA DIANE",
    "current_taxes": 13278.21,
    "new_taxes_no_override": 13851.83,
    "override_total_1": 14244.86,
    "override_increase_1": 393.04
  },
  {
    "#": "6 Claflin Rd, Unit 2 (220-71-02)",
    "$": 1968500,
    "address": "6 Claflin Rd, Unit 2",
    "parcel_id": "220-71-02",
    "owner1": "BAHRI TR, NAMDAR",
    "owner2": "",
    "current_taxes": 20157.44,
    "new_taxes_no_override": 21028.24,
    "override_total_1": 21624.9,
    "override_increase_1": 596.66
  },
  {
    "#": "6 Claflin Rd, Unit 3 (220-71-03)",
    "$": 1809300,
    "address": "6 Claflin Rd, Unit 3",
    "parcel_id": "220-71-03",
    "owner1": "SCHUTZMAN, ZACHARY",
    "owner2": "",
    "current_taxes": 18527.23,
    "new_taxes_no_override": 19327.61,
    "override_total_1": 19876.01,
    "override_increase_1": 548.41
  },
  {
    "#": "6 Claflin Rd, Unit 4 (220-71-04)",
    "$": 1717900,
    "address": "6 Claflin Rd, Unit 4",
    "parcel_id": "220-71-04",
    "owner1": "0604 CLAFLIN LLC",
    "owner2": "",
    "current_taxes": 17591.3,
    "new_taxes_no_override": 18351.24,
    "override_total_1": 18871.95,
    "override_increase_1": 520.7
  },
  {
    "#": "9 Claflin Rd (221-01-00)",
    "$": 2988800,
    "address": "9 Claflin Rd",
    "parcel_id": "221-01-00",
    "owner1": "GLICKLER TR, BARBARA HAVUMAKI",
    "owner2": "",
    "current_taxes": 26970.38,
    "new_taxes_no_override": 28135.5,
    "override_total_1": 28933.82,
    "override_increase_1": 798.32
  },
  {
    "#": "10 Claflin Rd, Unit 1 (220-70-03)",
    "$": 1073000,
    "address": "10 Claflin Rd, Unit 1",
    "parcel_id": "220-70-03",
    "owner1": "CHUTE, MARGARET E",
    "owner2": "JAMOUS, DANIEL",
    "current_taxes": 7352.59,
    "new_taxes_no_override": 7670.22,
    "override_total_1": 7887.86,
    "override_increase_1": 217.64
  },
  {
    "#": "10 Claflin Rd, Unit 2 (220-70-01)",
    "$": 1079800,
    "address": "10 Claflin Rd, Unit 2",
    "parcel_id": "220-70-01",
    "owner1": "DIETER TR, MARGA",
    "owner2": "",
    "current_taxes": 7422.22,
    "new_taxes_no_override": 7742.86,
    "override_total_1": 7962.56,
    "override_increase_1": 219.7
  },
  {
    "#": "10 Claflin Rd, Unit 3 (220-70-02)",
    "$": 1115900,
    "address": "10 Claflin Rd, Unit 3",
    "parcel_id": "220-70-02",
    "owner1": "SOVACOOL, BENJAMIN K",
    "owner2": "",
    "current_taxes": 7791.88,
    "new_taxes_no_override": 8128.49,
    "override_total_1": 8359.13,
    "override_increase_1": 230.64
  },
  {
    "#": "11 Claflin Rd, Unit 1 (221-02-01)",
    "$": 1322100,
    "address": "11 Claflin Rd, Unit 1",
    "parcel_id": "221-02-01",
    "owner1": "GROSSMAN, HINDELL S",
    "owner2": "",
    "current_taxes": 9903.37,
    "new_taxes_no_override": 10331.2,
    "override_total_1": 10624.34,
    "override_increase_1": 293.14
  },
  {
    "#": "11 Claflin Rd, Unit 2 (221-02-02)",
    "$": 1126000,
    "address": "11 Claflin Rd, Unit 2",
    "parcel_id": "221-02-02",
    "owner1": "STEPHAN, LUKE",
    "owner2": "LEIVA, STEPHANIE",
    "current_taxes": 7895.31,
    "new_taxes_no_override": 8236.39,
    "override_total_1": 8470.09,
    "override_increase_1": 233.7
  },
  {
    "#": "11 Claflin Rd, Unit 3 (221-02-03)",
    "$": 1140000,
    "address": "11 Claflin Rd, Unit 3",
    "parcel_id": "221-02-03",
    "owner1": "DALTON TRS, DIANE M",
    "owner2": "ELLIS, THERESA D",
    "current_taxes": 8038.67,
    "new_taxes_no_override": 8385.94,
    "override_total_1": 8623.89,
    "override_increase_1": 237.94
  },
  {
    "#": "14 Claflin Rd, Unit 1 (220-69-03)",
    "$": 1125100,
    "address": "14 Claflin Rd, Unit 1",
    "parcel_id": "220-69-03",
    "owner1": "HARRISON TR, TRACY M",
    "owner2": "",
    "current_taxes": 7886.09,
    "new_taxes_no_override": 8226.77,
    "override_total_1": 8460.2,
    "override_increase_1": 233.43
  },
  {
    "#": "14 Claflin Rd, Unit 2 (220-69-01)",
    "$": 1079900,
    "address": "14 Claflin Rd, Unit 2",
    "parcel_id": "220-69-01",
    "owner1": "BAUCH, DANIEL J",
    "owner2": "",
    "current_taxes": 11058.18,
    "new_taxes_no_override": 11535.89,
    "override_total_1": 11863.22,
    "override_increase_1": 327.32
  },
  {
    "#": "14 Claflin Rd, Unit 3 (220-69-02)",
    "$": 1076600,
    "address": "14 Claflin Rd, Unit 3",
    "parcel_id": "220-69-02",
    "owner1": "91-93 NEWTONVILLE AVE LLC",
    "owner2": "",
    "current_taxes": 7389.45,
    "new_taxes_no_override": 7708.67,
    "override_total_1": 7927.4,
    "override_increase_1": 218.73
  },
  {
    "#": "15 Claflin Rd, Unit 1 (221-03-01)",
    "$": 954200,
    "address": "15 Claflin Rd, Unit 1",
    "parcel_id": "221-03-01",
    "owner1": "SONG, JANE",
    "owner2": "",
    "current_taxes": 6136.07,
    "new_taxes_no_override": 6401.15,
    "override_total_1": 6582.78,
    "override_increase_1": 181.63
  },
  {
    "#": "15 Claflin Rd, Unit 2 (221-03-02)",
    "$": 1041100,
    "address": "15 Claflin Rd, Unit 2",
    "parcel_id": "221-03-02",
    "owner1": "KEENHOLTZ, ROBERTA",
    "owner2": "",
    "current_taxes": 10660.86,
    "new_taxes_no_override": 11121.41,
    "override_total_1": 11436.97,
    "override_increase_1": 315.56
  },
  {
    "#": "15 Claflin Rd, Unit 3 (221-03-03)",
    "$": 1046300,
    "address": "15 Claflin Rd, Unit 3",
    "parcel_id": "221-03-03",
    "owner1": "ZHANG, JANE JAN CHEN & QING",
    "owner2": "",
    "current_taxes": 7079.18,
    "new_taxes_no_override": 7385.0,
    "override_total_1": 7594.54,
    "override_increase_1": 209.54
  },
  {
    "#": "16 Claflin Rd, Unit 1 (220-68-03)",
    "$": 994700,
    "address": "16 Claflin Rd, Unit 1",
    "parcel_id": "220-68-03",
    "owner1": "GREENE, PHILLIPS T",
    "owner2": "BRESLAWSKI, KAREN",
    "current_taxes": 6550.79,
    "new_taxes_no_override": 6833.78,
    "override_total_1": 7027.69,
    "override_increase_1": 193.9
  },
  {
    "#": "16 Claflin Rd, Unit 2 (220-68-01)",
    "$": 1131100,
    "address": "16 Claflin Rd, Unit 2",
    "parcel_id": "220-68-01",
    "owner1": "SHIMONY, ETHAN",
    "owner2": "",
    "current_taxes": 7947.53,
    "new_taxes_no_override": 8290.86,
    "override_total_1": 8526.11,
    "override_increase_1": 235.25
  },
  {
    "#": "16 Claflin Rd, Unit 3 (220-68-02)",
    "$": 1273200,
    "address": "16 Claflin Rd, Unit 3",
    "parcel_id": "220-68-02",
    "owner1": "CUPPLES, ADAM & ALIZA",
    "owner2": "",
    "current_taxes": 9402.63,
    "new_taxes_no_override": 9808.82,
    "override_total_1": 10087.14,
    "override_increase_1": 278.32
  },
  {
    "#": "19 Claflin Rd (221-04-00)",
    "$": 3266600,
    "address": "19 Claflin Rd",
    "parcel_id": "221-04-00",
    "owner1": "WALSH, GREGORY J & MARY D",
    "owner2": "",
    "current_taxes": 29815.05,
    "new_taxes_no_override": 31103.06,
    "override_total_1": 31985.59,
    "override_increase_1": 882.53
  },
  {
    "#": "20 Claflin Rd, Unit 1 (220-67-02)",
    "$": 1071900,
    "address": "20 Claflin Rd, Unit 1",
    "parcel_id": "220-67-02",
    "owner1": "CASTELINO, CLAUDIA NEETA",
    "owner2": "",
    "current_taxes": 7341.32,
    "new_taxes_no_override": 7658.47,
    "override_total_1": 7875.77,
    "override_increase_1": 217.3
  },
  {
    "#": "20 Claflin Rd, Unit 2 (220-67-03)",
    "$": 1051900,
    "address": "20 Claflin Rd, Unit 2",
    "parcel_id": "220-67-03",
    "owner1": "MCNULTY, ANNE H W & ERIC J",
    "owner2": "",
    "current_taxes": 7136.52,
    "new_taxes_no_override": 7444.82,
    "override_total_1": 7656.06,
    "override_increase_1": 211.24
  },
  {
    "#": "20 Claflin Rd, Unit 3 (220-67-04)",
    "$": 1059400,
    "address": "20 Claflin Rd, Unit 3",
    "parcel_id": "220-67-04",
    "owner1": "KEENER, ELLIS BARLOW JR & JESSICA",
    "owner2": "",
    "current_taxes": 7213.32,
    "new_taxes_no_override": 7524.94,
    "override_total_1": 7738.45,
    "override_increase_1": 213.51
  },
  {
    "#": "20 Claflin Rd, Unit A (220-67-01)",
    "$": 371900,
    "address": "20 Claflin Rd, Unit A",
    "parcel_id": "220-67-01",
    "owner1": "MA, JIAN",
    "owner2": "",
    "current_taxes": 3808.26,
    "new_taxes_no_override": 3972.78,
    "override_total_1": 4085.5,
    "override_increase_1": 112.72
  },
  {
    "#": "22 Claflin Rd (220-66-00)",
    "$": 2740100,
    "address": "22 Claflin Rd",
    "parcel_id": "220-66-00",
    "owner1": "LEE TRS, WAI S",
    "owner2": "LEE, WILLIAM L & THOMAS Y",
    "current_taxes": 24423.69,
    "new_taxes_no_override": 25478.79,
    "override_total_1": 26201.73,
    "override_increase_1": 722.94
  },
  {
    "#": "23 Claflin Rd, Unit 1 (221-05-03)",
    "$": 1456100,
    "address": "23 Claflin Rd, Unit 1",
    "parcel_id": "221-05-03",
    "owner1": "MANN, JAMES JOSEPH JR",
    "owner2": "HIRSCH, HEATHER ANNE",
    "current_taxes": 11275.53,
    "new_taxes_no_override": 11762.63,
    "override_total_1": 12096.39,
    "override_increase_1": 333.76
  },
  {
    "#": "23 Claflin Rd, Unit 2 (221-05-01)",
    "$": 1094200,
    "address": "23 Claflin Rd, Unit 2",
    "parcel_id": "221-05-01",
    "owner1": "BALASUBRAMANIAN, PADMA",
    "owner2": "BHARARTI, PRATYUSH",
    "current_taxes": 7569.67,
    "new_taxes_no_override": 7896.68,
    "override_total_1": 8120.74,
    "override_increase_1": 224.06
  },
  {
    "#": "23 Claflin Rd, Unit 3 (221-05-02)",
    "$": 1215800,
    "address": "23 Claflin Rd, Unit 3",
    "parcel_id": "221-05-02",
    "owner1": "SAFFRON INVESTMENT LIMITED PAR",
    "owner2": "",
    "current_taxes": 12449.79,
    "new_taxes_no_override": 12987.62,
    "override_total_1": 13356.13,
    "override_increase_1": 368.51
  },
  {
    "#": "26 Claflin Rd (220-65-00)",
    "$": 3833200,
    "address": "26 Claflin Rd",
    "parcel_id": "220-65-00",
    "owner1": "CHAN TRS, KENNETH KC & ARTHUR HUI & YUNG-YEE H",
    "owner2": "",
    "current_taxes": 39251.97,
    "new_taxes_no_override": 40947.66,
    "override_total_1": 42109.51,
    "override_increase_1": 1161.86
  },
  {
    "#": "27 Claflin Rd, Unit 1 (221-06-01)",
    "$": 1119600,
    "address": "27 Claflin Rd, Unit 1",
    "parcel_id": "221-06-01",
    "owner1": "WEINSTEIN, KEITH & MARSHA",
    "owner2": "",
    "current_taxes": 7829.77,
    "new_taxes_no_override": 8168.02,
    "override_total_1": 8399.78,
    "override_increase_1": 231.76
  },
  {
    "#": "27 Claflin Rd, Unit 2 (221-06-02)",
    "$": 951100,
    "address": "27 Claflin Rd, Unit 2",
    "parcel_id": "221-06-02",
    "owner1": "FRIEDMAN, HARRY K",
    "owner2": "",
    "current_taxes": 6104.33,
    "new_taxes_no_override": 6368.04,
    "override_total_1": 6548.73,
    "override_increase_1": 180.69
  },
  {
    "#": "27 Claflin Rd, Unit 3 (221-06-03)",
    "$": 956400,
    "address": "27 Claflin Rd, Unit 3",
    "parcel_id": "221-06-03",
    "owner1": "PORTER TR, BEVERLY M",
    "owner2": "",
    "current_taxes": 6158.6,
    "new_taxes_no_override": 6424.65,
    "override_total_1": 6606.95,
    "override_increase_1": 182.29
  },
  {
    "#": "30 Claflin Rd (220-64-00)",
    "$": 2843700,
    "address": "30 Claflin Rd",
    "parcel_id": "220-64-00",
    "owner1": "30 CLAFLIN ROAD LLC",
    "owner2": "",
    "current_taxes": 29119.49,
    "new_taxes_no_override": 30377.45,
    "override_total_1": 31239.39,
    "override_increase_1": 861.94
  },
  {
    "#": "31 Claflin Rd, Unit 1 (221-07-01)",
    "$": 1514300,
    "address": "31 Claflin Rd, Unit 1",
    "parcel_id": "221-07-01",
    "owner1": "POST, ELIZABETH",
    "owner2": "",
    "current_taxes": 11871.5,
    "new_taxes_no_override": 12384.35,
    "override_total_1": 12735.75,
    "override_increase_1": 351.4
  },
  {
    "#": "31 Claflin Rd, Unit 2 (221-07-02)",
    "$": 1217600,
    "address": "31 Claflin Rd, Unit 2",
    "parcel_id": "221-07-02",
    "owner1": "WHITE, ALISON O",
    "owner2": "",
    "current_taxes": 12468.22,
    "new_taxes_no_override": 13006.85,
    "override_total_1": 13375.91,
    "override_increase_1": 369.06
  },
  {
    "#": "31 Claflin Rd, Unit 3 (221-07-03)",
    "$": 1290500,
    "address": "31 Claflin Rd, Unit 3",
    "parcel_id": "221-07-03",
    "owner1": "LOMAX, DIONNE C",
    "owner2": "",
    "current_taxes": 13214.72,
    "new_taxes_no_override": 13785.6,
    "override_total_1": 14176.75,
    "override_increase_1": 391.16
  },
  {
    "#": "32 Claflin Rd (220-63-00)",
    "$": 2836600,
    "address": "32 Claflin Rd",
    "parcel_id": "220-63-00",
    "owner1": "AARON ROSE LLC",
    "owner2": "",
    "current_taxes": 29046.78,
    "new_taxes_no_override": 30301.6,
    "override_total_1": 31161.39,
    "override_increase_1": 859.78
  },
  {
    "#": "35 Claflin Rd (221-08-00)",
    "$": 2260400,
    "address": "35 Claflin Rd",
    "parcel_id": "221-08-00",
    "owner1": "WONG, CHAU KAM WAN",
    "owner2": "",
    "current_taxes": 19511.56,
    "new_taxes_no_override": 20354.46,
    "override_total_1": 20932.0,
    "override_increase_1": 577.54
  },
  {
    "#": "36 Claflin Rd, Unit 1 (220-62-01)",
    "$": 1317300,
    "address": "36 Claflin Rd, Unit 1",
    "parcel_id": "220-62-01",
    "owner1": "BROWN, JACOB R",
    "owner2": "LEOPOLD, BRYNN C",
    "current_taxes": 9854.22,
    "new_taxes_no_override": 10279.92,
    "override_total_1": 10571.61,
    "override_increase_1": 291.68
  },
  {
    "#": "36 Claflin Rd, Unit 1A (220-62-04)",
    "$": 778200,
    "address": "36 Claflin Rd, Unit 1A",
    "parcel_id": "220-62-04",
    "owner1": "SHASHOUA, MICHAEL",
    "owner2": "",
    "current_taxes": 7968.77,
    "new_taxes_no_override": 8313.02,
    "override_total_1": 8548.9,
    "override_increase_1": 235.88
  },
  {
    "#": "36 Claflin Rd, Unit 2 (220-62-02)",
    "$": 1367600,
    "address": "36 Claflin Rd, Unit 2",
    "parcel_id": "220-62-02",
    "owner1": "KIM, SOO-HWA",
    "owner2": "BASU, SANJAY",
    "current_taxes": 10369.29,
    "new_taxes_no_override": 10817.24,
    "override_total_1": 11124.17,
    "override_increase_1": 306.93
  },
  {
    "#": "36 Claflin Rd, Unit 3 (220-62-03)",
    "$": 1377300,
    "address": "36 Claflin Rd, Unit 3",
    "parcel_id": "220-62-03",
    "owner1": "MEDOW, MITCHELL A",
    "owner2": "SOBEL-MEDOW, JANET R",
    "current_taxes": 10468.62,
    "new_taxes_no_override": 10920.86,
    "override_total_1": 11230.74,
    "override_increase_1": 309.87
  },
  {
    "#": "37 Claflin Rd (221-09-00)",
    "$": 4648800,
    "address": "37 Claflin Rd",
    "parcel_id": "221-09-00",
    "owner1": "RUSSELL, ET AL  TRS, WILLIAM W",
    "owner2": "C/O FIELD CORP",
    "current_taxes": 47603.71,
    "new_taxes_no_override": 49660.19,
    "override_total_1": 51069.26,
    "override_increase_1": 1409.07
  },
  {
    "#": "40 Claflin Rd, Unit 1 & P2 (220-61-03)",
    "$": 1223700,
    "address": "40 Claflin Rd, Unit 1 & P2",
    "parcel_id": "220-61-03",
    "owner1": "BECK TR, KATHRYN L",
    "owner2": "",
    "current_taxes": 8895.75,
    "new_taxes_no_override": 9280.05,
    "override_total_1": 9543.36,
    "override_increase_1": 263.31
  },
  {
    "#": "40 Claflin Rd, Unit 2 (220-61-01)",
    "$": 1142200,
    "address": "40 Claflin Rd, Unit 2",
    "parcel_id": "220-61-01",
    "owner1": "KRUEL, QUENTIN Z & STEPHANIE",
    "owner2": "",
    "current_taxes": 8061.19,
    "new_taxes_no_override": 8409.43,
    "override_total_1": 8648.04,
    "override_increase_1": 238.61
  },
  {
    "#": "40 Claflin Rd, Unit 3 & P-1 (220-61-02)",
    "$": 1115400,
    "address": "40 Claflin Rd, Unit 3 & P-1",
    "parcel_id": "220-61-02",
    "owner1": "HUANG, JIE",
    "owner2": "",
    "current_taxes": 7786.76,
    "new_taxes_no_override": 8123.15,
    "override_total_1": 8353.64,
    "override_increase_1": 230.49
  },
  {
    "#": "45 Clarence St (068-13-00)",
    "$": 2525300,
    "address": "45 Clarence St",
    "parcel_id": "068-13-00",
    "owner1": "TERRY, DAVID P",
    "owner2": "MILES, EMILY",
    "current_taxes": 22224.14,
    "new_taxes_no_override": 23184.22,
    "override_total_1": 23842.06,
    "override_increase_1": 657.83
  },
  {
    "#": "8 Clark Ct (317-14-00)",
    "$": 1873100,
    "address": "8 Clark Ct",
    "parcel_id": "317-14-00",
    "owner1": "INSINGER, MORI",
    "owner2": "MESSIQUA, DIANE NANCY",
    "current_taxes": 15545.61,
    "new_taxes_no_override": 16217.18,
    "override_total_1": 16677.33,
    "override_increase_1": 460.15
  },
  {
    "#": "9 Clark Ct (317-10-00)",
    "$": 1427700,
    "address": "9 Clark Ct",
    "parcel_id": "317-10-00",
    "owner1": "SAETTI, DONALD E & DOROTHY G",
    "owner2": "LARKIN, BARBARA F",
    "current_taxes": 10984.71,
    "new_taxes_no_override": 11459.25,
    "override_total_1": 11784.4,
    "override_increase_1": 325.15
  },
  {
    "#": "12 Clark Ct (317-13-00)",
    "$": 1651900,
    "address": "12 Clark Ct",
    "parcel_id": "317-13-00",
    "owner1": "LOWN TR, BETH",
    "owner2": "",
    "current_taxes": 13280.52,
    "new_taxes_no_override": 13854.24,
    "override_total_1": 14247.34,
    "override_increase_1": 393.1
  },
  {
    "#": "15 Clark Ct (317-11-00)",
    "$": 1906600,
    "address": "15 Clark Ct",
    "parcel_id": "317-11-00",
    "owner1": "TOOLE TR, TAMYRA A",
    "owner2": "",
    "current_taxes": 15888.65,
    "new_taxes_no_override": 16575.04,
    "override_total_1": 17045.34,
    "override_increase_1": 470.3
  },
  {
    "#": "16 Clark Ct (317-12-00)",
    "$": 1723400,
    "address": "16 Clark Ct",
    "parcel_id": "317-12-00",
    "owner1": "WILLIAMS, ADAM G & ELIZABETH",
    "owner2": "",
    "current_taxes": 14012.68,
    "new_taxes_no_override": 14618.03,
    "override_total_1": 15032.8,
    "override_increase_1": 414.78
  },
  {
    "#": "2 Clark Rd (192-09-11)",
    "$": 22648500,
    "address": "2 Clark Rd",
    "parcel_id": "192-09-11",
    "owner1": "2 CLARK ROAD LLC",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "7 Clark Rd, Unit 1 (191-18-02)",
    "$": 1223300,
    "address": "7 Clark Rd, Unit 1",
    "parcel_id": "191-18-02",
    "owner1": "SCHACHNIK TRS, LUCIANA & GILSON",
    "owner2": "",
    "current_taxes": 8891.66,
    "new_taxes_no_override": 9275.78,
    "override_total_1": 9538.97,
    "override_increase_1": 263.19
  },
  {
    "#": "9 Clark Rd, Unit 2 (191-18-01)",
    "$": 1410500,
    "address": "9 Clark Rd, Unit 2",
    "parcel_id": "191-18-01",
    "owner1": "ROBINSON, THOMAS D",
    "owner2": "",
    "current_taxes": 10808.59,
    "new_taxes_no_override": 11275.52,
    "override_total_1": 11595.46,
    "override_increase_1": 319.93
  },
  {
    "#": "11 Clark Rd, Unit 1 (191-19-01)",
    "$": 914100,
    "address": "11 Clark Rd, Unit 1",
    "parcel_id": "191-19-01",
    "owner1": "JACOBS, BRUCE & CATHY",
    "owner2": "",
    "current_taxes": 9360.38,
    "new_taxes_no_override": 9764.75,
    "override_total_1": 10041.82,
    "override_increase_1": 277.07
  },
  {
    "#": "11 Clark Rd, Unit 2 (191-19-02)",
    "$": 1235100,
    "address": "11 Clark Rd, Unit 2",
    "parcel_id": "191-19-02",
    "owner1": "DANNING, DAVID",
    "owner2": "WAGMAN, NANCY",
    "current_taxes": 9012.49,
    "new_taxes_no_override": 9401.83,
    "override_total_1": 9668.6,
    "override_increase_1": 266.77
  },
  {
    "#": "17 Clark Rd (191-20-00)",
    "$": 2263500,
    "address": "17 Clark Rd",
    "parcel_id": "191-20-00",
    "owner1": "YEO, BEE KENG",
    "owner2": "",
    "current_taxes": 23178.24,
    "new_taxes_no_override": 24179.54,
    "override_total_1": 24865.62,
    "override_increase_1": 686.08
  },
  {
    "#": "21 Clark Rd (191-21-00)",
    "$": 2683500,
    "address": "21 Clark Rd",
    "parcel_id": "191-21-00",
    "owner1": "PORTER, DAVID C & JULIE B",
    "owner2": "",
    "current_taxes": 23844.11,
    "new_taxes_no_override": 24874.18,
    "override_total_1": 25579.96,
    "override_increase_1": 705.79
  },
  {
    "#": "25 Clark Rd (191-21-01)",
    "$": 2494500,
    "address": "25 Clark Rd",
    "parcel_id": "191-21-01",
    "owner1": "SINHA, BHARATI",
    "owner2": "",
    "current_taxes": 21908.75,
    "new_taxes_no_override": 22855.21,
    "override_total_1": 23503.71,
    "override_increase_1": 648.5
  },
  {
    "#": "32 Clark Rd (192-07-02)",
    "$": 2169900,
    "address": "32 Clark Rd",
    "parcel_id": "192-07-02",
    "owner1": "TAROKH TR, VAHID",
    "owner2": "",
    "current_taxes": 22219.78,
    "new_taxes_no_override": 23179.67,
    "override_total_1": 23837.38,
    "override_increase_1": 657.71
  },
  {
    "#": "33 Clark Rd, Unit 1 (191-22-02)",
    "$": 1707300,
    "address": "33 Clark Rd, Unit 1",
    "parcel_id": "191-22-02",
    "owner1": "JACOBS, BRUCE & CATHY",
    "owner2": "",
    "current_taxes": 13847.82,
    "new_taxes_no_override": 14446.05,
    "override_total_1": 14855.94,
    "override_increase_1": 409.9
  },
  {
    "#": "33 Clark Rd, Unit 2 & P4 P5 (191-22-01)",
    "$": 1721200,
    "address": "33 Clark Rd, Unit 2 & P4 P5",
    "parcel_id": "191-22-01",
    "owner1": "LEWIS, VICTOR A",
    "owner2": "RESNIK, ELLEN J",
    "current_taxes": 13990.15,
    "new_taxes_no_override": 14594.52,
    "override_total_1": 15008.63,
    "override_increase_1": 414.11
  },
  {
    "#": "36 Clark Rd (192-07-01)",
    "$": 2435300,
    "address": "36 Clark Rd",
    "parcel_id": "192-07-01",
    "owner1": "ARNFELD, GEN PARTNERS, LEO & LORRAINE",
    "owner2": "",
    "current_taxes": 24937.47,
    "new_taxes_no_override": 26014.77,
    "override_total_1": 26752.92,
    "override_increase_1": 738.15
  },
  {
    "#": "39 Clark Rd (191-23-00)",
    "$": 2866300,
    "address": "39 Clark Rd",
    "parcel_id": "191-23-00",
    "owner1": "MCCORKLE TR, ROBERT V",
    "owner2": "CAYEM TR, MERI",
    "current_taxes": 25715.98,
    "new_taxes_no_override": 26826.91,
    "override_total_1": 27588.1,
    "override_increase_1": 761.19
  },
  {
    "#": "40 Clark Rd (192-07-00)",
    "$": 2153800,
    "address": "40 Clark Rd",
    "parcel_id": "192-07-00",
    "owner1": "STRATHMORE ROAD CO LLC",
    "owner2": "C/O SANIEOFF",
    "current_taxes": 22054.91,
    "new_taxes_no_override": 23007.68,
    "override_total_1": 23660.51,
    "override_increase_1": 652.83
  },
  {
    "#": "43 Clark Rd, Unit 1 (191-24-01)",
    "$": 1190800,
    "address": "43 Clark Rd, Unit 1",
    "parcel_id": "191-24-01",
    "owner1": "ROBINSON TRS, MARY REDNER",
    "owner2": "THIEL TR, MARY MARTHA",
    "current_taxes": 8558.86,
    "new_taxes_no_override": 8928.6,
    "override_total_1": 9181.95,
    "override_increase_1": 253.34
  },
  {
    "#": "43 Clark Rd, Unit 2 (191-24-02)",
    "$": 1728600,
    "address": "43 Clark Rd, Unit 2",
    "parcel_id": "191-24-02",
    "owner1": "SANDITEN TR, JUDITH M",
    "owner2": "",
    "current_taxes": 14065.93,
    "new_taxes_no_override": 14673.58,
    "override_total_1": 15089.93,
    "override_increase_1": 416.35
  },
  {
    "#": "44 Clark Rd (192-06-02)",
    "$": 2957900,
    "address": "44 Clark Rd",
    "parcel_id": "192-06-02",
    "owner1": "TSENG, KAREN C",
    "owner2": "TRAN, TUAN D",
    "current_taxes": 26653.96,
    "new_taxes_no_override": 27805.41,
    "override_total_1": 28594.37,
    "override_increase_1": 788.96
  },
  {
    "#": "47 Clark Rd, Unit 47 (191-25-01)",
    "$": 1516700,
    "address": "47 Clark Rd, Unit 47",
    "parcel_id": "191-25-01",
    "owner1": "TABRAHAM, JACQUELINE & MATTHEW",
    "owner2": "",
    "current_taxes": 11896.07,
    "new_taxes_no_override": 12409.98,
    "override_total_1": 12762.1,
    "override_increase_1": 352.12
  },
  {
    "#": "48 Clark Rd, Unit 48 (192-06-03)",
    "$": 1845200,
    "address": "48 Clark Rd, Unit 48",
    "parcel_id": "192-06-03",
    "owner1": "JAFFE, JACOB & YAEL",
    "owner2": "",
    "current_taxes": 15259.91,
    "new_taxes_no_override": 15919.14,
    "override_total_1": 16370.83,
    "override_increase_1": 451.69
  },
  {
    "#": "49 Clark Rd, Unit 49 (191-25-02)",
    "$": 1462000,
    "address": "49 Clark Rd, Unit 49",
    "parcel_id": "191-25-02",
    "owner1": "RUDNER, DAVID ZELCER",
    "owner2": "",
    "current_taxes": 11335.95,
    "new_taxes_no_override": 11825.66,
    "override_total_1": 12161.21,
    "override_increase_1": 335.54
  },
  {
    "#": "50 Clark Rd, Unit 50 (192-06-04)",
    "$": 1845200,
    "address": "50 Clark Rd, Unit 50",
    "parcel_id": "192-06-04",
    "owner1": "OH, KEVIN & ELIZABETH",
    "owner2": "",
    "current_taxes": 18894.85,
    "new_taxes_no_override": 19711.11,
    "override_total_1": 20270.4,
    "override_increase_1": 559.29
  },
  {
    "#": "51 Clark Rd (191-26-00)",
    "$": 2031800,
    "address": "51 Clark Rd",
    "parcel_id": "191-26-00",
    "owner1": "COSTELLO, JOHN T  JR",
    "owner2": "",
    "current_taxes": 17170.7,
    "new_taxes_no_override": 17912.47,
    "override_total_1": 18420.73,
    "override_increase_1": 508.25
  },
  {
    "#": "54 Clark Rd (192-05-00)",
    "$": 2547200,
    "address": "54 Clark Rd",
    "parcel_id": "192-05-00",
    "owner1": "NOTMAN TR, MALKAH T",
    "owner2": "",
    "current_taxes": 26083.33,
    "new_taxes_no_override": 27210.13,
    "override_total_1": 27982.2,
    "override_increase_1": 772.07
  },
  {
    "#": "55 Clark Rd (191-27-00)",
    "$": 1876700,
    "address": "55 Clark Rd",
    "parcel_id": "191-27-00",
    "owner1": "PAIK, YOUNGIK & VERONIKA",
    "owner2": "",
    "current_taxes": 15582.47,
    "new_taxes_no_override": 16255.63,
    "override_total_1": 16716.87,
    "override_increase_1": 461.24
  },
  {
    "#": "61 Clark Rd (191-28-00)",
    "$": 2889900,
    "address": "61 Clark Rd",
    "parcel_id": "191-28-00",
    "owner1": "STOLYAROV, YURY & GALINA",
    "owner2": "",
    "current_taxes": 25957.64,
    "new_taxes_no_override": 27079.01,
    "override_total_1": 27847.36,
    "override_increase_1": 768.35
  },
  {
    "#": "62 Clark Rd, Unit 1 & P1 P2 P5 (192-04-02)",
    "$": 1547800,
    "address": "62 Clark Rd, Unit 1 & P1 P2 P5",
    "parcel_id": "192-04-02",
    "owner1": "MALKESMAN, OZ",
    "owner2": "POKER-MALKESMAN, NAAMA",
    "current_taxes": 12214.54,
    "new_taxes_no_override": 12742.21,
    "override_total_1": 13103.76,
    "override_increase_1": 361.55
  },
  {
    "#": "62 Clark Rd, Unit 2 & P3 P4 (192-04-01)",
    "$": 1427600,
    "address": "62 Clark Rd, Unit 2 & P3 P4",
    "parcel_id": "192-04-01",
    "owner1": "HARINGTON, ROBERT",
    "owner2": "NADASH, PAMELA",
    "current_taxes": 10983.69,
    "new_taxes_no_override": 11458.19,
    "override_total_1": 11783.3,
    "override_increase_1": 325.12
  },
  {
    "#": "70 Clark Rd (192-03-00)",
    "$": 2191200,
    "address": "70 Clark Rd",
    "parcel_id": "192-03-00",
    "owner1": "PATEL, ANIRUDDH D",
    "owner2": "BURTON, JENNIFER S",
    "current_taxes": 18802.95,
    "new_taxes_no_override": 19615.24,
    "override_total_1": 20171.8,
    "override_increase_1": 556.57
  },
  {
    "#": "76 Clark Rd, Unit 1 & G1 G2 (192-02-01)",
    "$": 2196400,
    "address": "76 Clark Rd, Unit 1 & G1 G2",
    "parcel_id": "192-02-01",
    "owner1": "SHIANG TR, ELAINE LI",
    "owner2": "",
    "current_taxes": 22491.14,
    "new_taxes_no_override": 23462.76,
    "override_total_1": 24128.49,
    "override_increase_1": 665.74
  },
  {
    "#": "76 Clark Rd, Unit 2 & G3 G4 (192-02-02)",
    "$": 2156300,
    "address": "76 Clark Rd, Unit 2 & G3 G4",
    "parcel_id": "192-02-02",
    "owner1": "DALZIEL, NIGEL J",
    "owner2": "KORMAN, ALEXANDRA V",
    "current_taxes": 18445.58,
    "new_taxes_no_override": 19242.43,
    "override_total_1": 19788.42,
    "override_increase_1": 545.99
  },
  {
    "#": "83 Clark Rd (191-29-00)",
    "$": 1445900,
    "address": "83 Clark Rd",
    "parcel_id": "191-29-00",
    "owner1": "COMMONWEALTH OF MASSACHUSETTS",
    "owner2": "C/O MASS BAY TRANSIT AUTHORITY",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "95 Clark Rd (229-01-00)",
    "$": 2703900,
    "address": "95 Clark Rd",
    "parcel_id": "229-01-00",
    "owner1": "FULD TRS, SUSAN D & LEONARD M",
    "owner2": "",
    "current_taxes": 27687.94,
    "new_taxes_no_override": 28884.06,
    "override_total_1": 29703.62,
    "override_increase_1": 819.56
  },
  {
    "#": "98 Clark Rd (231-36-02)",
    "$": 1615700,
    "address": "98 Clark Rd",
    "parcel_id": "231-36-02",
    "owner1": "DOUGAN, STEPHANIE & MICHAEL",
    "owner2": "",
    "current_taxes": 16544.77,
    "new_taxes_no_override": 17259.5,
    "override_total_1": 17749.23,
    "override_increase_1": 489.73
  },
  {
    "#": "101 Clark Rd (229-02-00)",
    "$": 2474100,
    "address": "101 Clark Rd",
    "parcel_id": "229-02-00",
    "owner1": "MATHIAS, DONNA M",
    "owner2": "JACOBSON, JONATHAN",
    "current_taxes": 21699.85,
    "new_taxes_no_override": 22637.28,
    "override_total_1": 23279.6,
    "override_increase_1": 642.32
  },
  {
    "#": "104 Clark Rd (231-36-01)",
    "$": 1942300,
    "address": "104 Clark Rd",
    "parcel_id": "231-36-01",
    "owner1": "GUTTELL, ANDREW M",
    "owner2": "SHASHOUA, KAREN",
    "current_taxes": 16254.22,
    "new_taxes_no_override": 16956.4,
    "override_total_1": 17437.53,
    "override_increase_1": 481.12
  },
  {
    "#": "107 Clark Rd (229-03-00)",
    "$": 3184100,
    "address": "107 Clark Rd",
    "parcel_id": "229-03-00",
    "owner1": "HAAS, CRAIG II",
    "owner2": "TAHILLANI, PRIYA J",
    "current_taxes": 28970.25,
    "new_taxes_no_override": 30221.76,
    "override_total_1": 31079.28,
    "override_increase_1": 857.52
  },
  {
    "#": "110 Clark Rd (231-38-02)",
    "$": 2664400,
    "address": "110 Clark Rd",
    "parcel_id": "231-38-02",
    "owner1": "CHENG, KA MING",
    "owner2": "TSANG, SUM YEE",
    "current_taxes": 23648.52,
    "new_taxes_no_override": 24670.14,
    "override_total_1": 25370.13,
    "override_increase_1": 700.0
  },
  {
    "#": "115 Clark Rd (229-04-00)",
    "$": 2811800,
    "address": "115 Clark Rd",
    "parcel_id": "229-04-00",
    "owner1": "MARCUS, ELLEN R",
    "owner2": "",
    "current_taxes": 28792.83,
    "new_taxes_no_override": 30036.68,
    "override_total_1": 30888.95,
    "override_increase_1": 852.27
  },
  {
    "#": "116 Clark Rd (231-35-01)",
    "$": 2639000,
    "address": "116 Clark Rd",
    "parcel_id": "231-35-01",
    "owner1": "MAYFIELD, ET AL, PHILIP",
    "owner2": "",
    "current_taxes": 23388.43,
    "new_taxes_no_override": 24398.81,
    "override_total_1": 25091.11,
    "override_increase_1": 692.3
  },
  {
    "#": "121 Clark Rd (229-05-00)",
    "$": 2660400,
    "address": "121 Clark Rd",
    "parcel_id": "229-05-00",
    "owner1": "WITTELS, NORMAN & JILL J",
    "owner2": "",
    "current_taxes": 23607.56,
    "new_taxes_no_override": 24627.41,
    "override_total_1": 25326.19,
    "override_increase_1": 698.78
  },
  {
    "#": "122 Clark Rd (231-35-00)",
    "$": 2971500,
    "address": "122 Clark Rd",
    "parcel_id": "231-35-00",
    "owner1": "CHAUKOS, JAMES & CHRISTINE",
    "owner2": "",
    "current_taxes": 26793.23,
    "new_taxes_no_override": 27950.7,
    "override_total_1": 28743.78,
    "override_increase_1": 793.08
  },
  {
    "#": "126 Clark Rd (231-34-00)",
    "$": 2659900,
    "address": "126 Clark Rd",
    "parcel_id": "231-34-00",
    "owner1": "MEYERS TRS, ALAN S",
    "owner2": "ATTIANESE TRS, BARBARA J",
    "current_taxes": 23602.44,
    "new_taxes_no_override": 24622.07,
    "override_total_1": 25320.7,
    "override_increase_1": 698.63
  },
  {
    "#": "129 Clark Rd (229-06-00)",
    "$": 2448600,
    "address": "129 Clark Rd",
    "parcel_id": "229-06-00",
    "owner1": "DRAPKIN, MARK & ROSA",
    "owner2": "",
    "current_taxes": 21438.73,
    "new_taxes_no_override": 22364.88,
    "override_total_1": 22999.47,
    "override_increase_1": 634.59
  },
  {
    "#": "132 Clark Rd, Unit A (231-33-02)",
    "$": 1694000,
    "address": "132 Clark Rd, Unit A",
    "parcel_id": "231-33-02",
    "owner1": "NEWBILL, MEISAN LIM",
    "owner2": "",
    "current_taxes": 13711.63,
    "new_taxes_no_override": 14303.97,
    "override_total_1": 14709.84,
    "override_increase_1": 405.86
  },
  {
    "#": "132 Clark Rd, Unit B (231-33-01)",
    "$": 1674200,
    "address": "132 Clark Rd, Unit B",
    "parcel_id": "231-33-01",
    "owner1": "SHIVERS, HILLARY & OLIN G",
    "owner2": "",
    "current_taxes": 13508.87,
    "new_taxes_no_override": 14092.45,
    "override_total_1": 14492.32,
    "override_increase_1": 399.86
  },
  {
    "#": "135 Clark Rd (229-07-00)",
    "$": 2602300,
    "address": "135 Clark Rd",
    "parcel_id": "229-07-00",
    "owner1": "GAINES, DEBORAH",
    "owner2": "MORGENSTERN, JANE E",
    "current_taxes": 23012.62,
    "new_taxes_no_override": 24006.77,
    "override_total_1": 24687.94,
    "override_increase_1": 681.17
  },
  {
    "#": "140 Clark Rd (231-32-00)",
    "$": 2711800,
    "address": "140 Clark Rd",
    "parcel_id": "231-32-00",
    "owner1": "WEISS, HOWARD A",
    "owner2": "ROHAN, SHANNON LYNN",
    "current_taxes": 24133.9,
    "new_taxes_no_override": 25176.48,
    "override_total_1": 25890.85,
    "override_increase_1": 714.36
  },
  {
    "#": "141 Clark Rd (229-08-00)",
    "$": 2118000,
    "address": "141 Clark Rd",
    "parcel_id": "229-08-00",
    "owner1": "MARTON TRS, CLARA & HOWARD Z",
    "owner2": "",
    "current_taxes": 18053.39,
    "new_taxes_no_override": 18833.3,
    "override_total_1": 19367.68,
    "override_increase_1": 534.38
  },
  {
    "#": "144 Clark Rd (231-31-00)",
    "$": 2943800,
    "address": "144 Clark Rd",
    "parcel_id": "231-31-00",
    "owner1": "LIENAU, ODETTE",
    "owner2": "RANA, AZIZ",
    "current_taxes": 26509.58,
    "new_taxes_no_override": 27654.79,
    "override_total_1": 28439.48,
    "override_increase_1": 784.68
  },
  {
    "#": "147 Clark Rd (229-09-00)",
    "$": 2212300,
    "address": "147 Clark Rd",
    "parcel_id": "229-09-00",
    "owner1": "CUNNINGHAM, DAYNA L",
    "owner2": "THOMPSON, JAMES",
    "current_taxes": 22653.95,
    "new_taxes_no_override": 23632.6,
    "override_total_1": 24303.16,
    "override_increase_1": 670.56
  },
  {
    "#": "150 Clark Rd, Unit 1 (231-30-01)",
    "$": 2051500,
    "address": "150 Clark Rd, Unit 1",
    "parcel_id": "231-30-01",
    "owner1": "HEUBERGER, JULIE",
    "owner2": "",
    "current_taxes": 17372.43,
    "new_taxes_no_override": 18122.92,
    "override_total_1": 18637.14,
    "override_increase_1": 514.22
  },
  {
    "#": "150 Clark Rd, Unit 2 (231-30-02)",
    "$": 1951500,
    "address": "150 Clark Rd, Unit 2",
    "parcel_id": "231-30-02",
    "owner1": "JAFFE, ARON",
    "owner2": "DE VITA, SERENA",
    "current_taxes": 16348.43,
    "new_taxes_no_override": 17054.68,
    "override_total_1": 17538.6,
    "override_increase_1": 483.91
  },
  {
    "#": "152 Clark Rd (231-29-00)",
    "$": 3020600,
    "address": "152 Clark Rd",
    "parcel_id": "231-29-00",
    "owner1": "FUTUREPROOF LLC",
    "owner2": "",
    "current_taxes": 30930.94,
    "new_taxes_no_override": 32267.16,
    "override_total_1": 33182.71,
    "override_increase_1": 915.56
  },
  {
    "#": "157 Clark Rd (229-10-00)",
    "$": 2284200,
    "address": "157 Clark Rd",
    "parcel_id": "229-10-00",
    "owner1": "PERTEL, PETER E & DONNA G",
    "owner2": "",
    "current_taxes": 19755.27,
    "new_taxes_no_override": 20608.7,
    "override_total_1": 21193.45,
    "override_increase_1": 584.76
  },
  {
    "#": "160 Clark Rd (231-28-00)",
    "$": 2310300,
    "address": "160 Clark Rd",
    "parcel_id": "231-28-00",
    "owner1": "YOUNG, WILLIAM & KELLY",
    "owner2": "",
    "current_taxes": 20022.54,
    "new_taxes_no_override": 20887.51,
    "override_total_1": 21480.18,
    "override_increase_1": 592.67
  },
  {
    "#": "161 Clark Rd (229-11-00)",
    "$": 1624500,
    "address": "161 Clark Rd",
    "parcel_id": "229-11-00",
    "owner1": "HARMON, SUSAN J",
    "owner2": "",
    "current_taxes": 12999.95,
    "new_taxes_no_override": 13561.55,
    "override_total_1": 13946.35,
    "override_increase_1": 384.8
  },
  {
    "#": "166 Clark Rd (231-27-00)",
    "$": 2125600,
    "address": "166 Clark Rd",
    "parcel_id": "231-27-00",
    "owner1": "WEI, ROBERT S & HOLLY",
    "owner2": "",
    "current_taxes": 18131.21,
    "new_taxes_no_override": 18914.48,
    "override_total_1": 19451.16,
    "override_increase_1": 536.68
  },
  {
    "#": "169 Clark Rd (229-12-00)",
    "$": 2080500,
    "address": "169 Clark Rd",
    "parcel_id": "229-12-00",
    "owner1": "FIERMAN TRS, EUGENE J & JANET B",
    "owner2": "",
    "current_taxes": 17669.39,
    "new_taxes_no_override": 18432.71,
    "override_total_1": 18955.72,
    "override_increase_1": 523.01
  },
  {
    "#": "170 Clark Rd (231-26-00)",
    "$": 1932800,
    "address": "170 Clark Rd",
    "parcel_id": "231-26-00",
    "owner1": "KOS TR, DONNA M",
    "owner2": "",
    "current_taxes": 16156.94,
    "new_taxes_no_override": 16854.92,
    "override_total_1": 17333.17,
    "override_increase_1": 478.25
  },
  {
    "#": "175 Clark Rd (229-13-00)",
    "$": 1943100,
    "address": "175 Clark Rd",
    "parcel_id": "229-13-00",
    "owner1": "SMITH, ALEXANDER N & KATRINA A S",
    "owner2": "",
    "current_taxes": 16262.41,
    "new_taxes_no_override": 16964.95,
    "override_total_1": 17446.31,
    "override_increase_1": 481.37
  },
  {
    "#": "180 Clark Rd (231-24-25)",
    "$": 2548700,
    "address": "180 Clark Rd",
    "parcel_id": "231-24-25",
    "owner1": "KEELEY, SAM C",
    "owner2": "MORANDI, MELISSA A",
    "current_taxes": 26098.69,
    "new_taxes_no_override": 27226.15,
    "override_total_1": 27998.67,
    "override_increase_1": 772.52
  },
  {
    "#": "181 Clark Rd (229-14-00)",
    "$": 2341200,
    "address": "181 Clark Rd",
    "parcel_id": "229-14-00",
    "owner1": "RYSMAN, MARC",
    "owner2": "EPHRAIM, MICHELLE",
    "current_taxes": 20338.95,
    "new_taxes_no_override": 21217.59,
    "override_total_1": 21819.63,
    "override_increase_1": 602.03
  },
  {
    "#": "184 Clark Rd (231-23-00)",
    "$": 2246000,
    "address": "184 Clark Rd",
    "parcel_id": "231-23-00",
    "owner1": "RADIN, CHARLES A",
    "owner2": "MUGI, HANAO",
    "current_taxes": 22999.04,
    "new_taxes_no_override": 23992.6,
    "override_total_1": 24673.37,
    "override_increase_1": 680.77
  },
  {
    "#": "187 Clark Rd (229-15-00)",
    "$": 1572600,
    "address": "187 Clark Rd",
    "parcel_id": "229-15-00",
    "owner1": "ERSKINE, ANDREW",
    "owner2": "XU, JENNY",
    "current_taxes": 16103.42,
    "new_taxes_no_override": 16799.09,
    "override_total_1": 17275.75,
    "override_increase_1": 476.66
  },
  {
    "#": "188 Clark Rd, Unit 1 (231-22-01)",
    "$": 1117600,
    "address": "188 Clark Rd, Unit 1",
    "parcel_id": "231-22-01",
    "owner1": "COHEN, NORMAN B & DEBORAH",
    "owner2": "",
    "current_taxes": 7809.29,
    "new_taxes_no_override": 8146.65,
    "override_total_1": 8377.81,
    "override_increase_1": 231.15
  },
  {
    "#": "188 Clark Rd, Unit 2 (231-22-02)",
    "$": 1141600,
    "address": "188 Clark Rd, Unit 2",
    "parcel_id": "231-22-02",
    "owner1": "GABBE, DAVID",
    "owner2": "FELDMAN, LESLIE",
    "current_taxes": 8055.05,
    "new_taxes_no_override": 8403.03,
    "override_total_1": 8641.46,
    "override_increase_1": 238.43
  },
  {
    "#": "193 Clark Rd (229-16-00)",
    "$": 1949900,
    "address": "193 Clark Rd",
    "parcel_id": "229-16-00",
    "owner1": "NUSSBAUM, JEREMY",
    "owner2": "",
    "current_taxes": 16332.04,
    "new_taxes_no_override": 17037.58,
    "override_total_1": 17521.01,
    "override_increase_1": 483.43
  },
  {
    "#": "194 Clark Rd (231-21-00)",
    "$": 2260900,
    "address": "194 Clark Rd",
    "parcel_id": "231-21-00",
    "owner1": "MACFADDEN, TODD",
    "owner2": "BACHILLER, PATRICIA",
    "current_taxes": 19516.68,
    "new_taxes_no_override": 20359.8,
    "override_total_1": 20937.49,
    "override_increase_1": 577.69
  },
  {
    "#": "198 Clark Rd (231-20-00)",
    "$": 2040300,
    "address": "198 Clark Rd",
    "parcel_id": "231-20-00",
    "owner1": "YANG, XU",
    "owner2": "ZHANG, XU",
    "current_taxes": 17257.74,
    "new_taxes_no_override": 18003.27,
    "override_total_1": 18514.1,
    "override_increase_1": 510.83
  },
  {
    "#": "199 Clark Rd (229-17-00)",
    "$": 2157600,
    "address": "199 Clark Rd",
    "parcel_id": "229-17-00",
    "owner1": "SPUNT, NATHAN & EMILY F",
    "owner2": "",
    "current_taxes": 18458.89,
    "new_taxes_no_override": 19256.31,
    "override_total_1": 19802.7,
    "override_increase_1": 546.38
  },
  {
    "#": "204 Clark Rd (231-19-00)",
    "$": 2227900,
    "address": "204 Clark Rd",
    "parcel_id": "231-19-00",
    "owner1": "SOLOMON, JONATHAN M",
    "owner2": "ABRAMS, IRENE T",
    "current_taxes": 19178.76,
    "new_taxes_no_override": 20007.28,
    "override_total_1": 20574.97,
    "override_increase_1": 567.69
  },
  {
    "#": "205 Clark Rd (229-18-00)",
    "$": 1845900,
    "address": "205 Clark Rd",
    "parcel_id": "229-18-00",
    "owner1": "SANDLER, DAVID M",
    "owner2": "",
    "current_taxes": 15267.08,
    "new_taxes_no_override": 15926.62,
    "override_total_1": 16378.52,
    "override_increase_1": 451.91
  },
  {
    "#": "206 Clark Rd (231-18-00)",
    "$": 2529400,
    "address": "206 Clark Rd",
    "parcel_id": "231-18-00",
    "owner1": "TIMON, CHRISTY L",
    "owner2": "FABER, ABRAM R",
    "current_taxes": 22266.12,
    "new_taxes_no_override": 23228.02,
    "override_total_1": 23887.09,
    "override_increase_1": 659.08
  },
  {
    "#": "209 Clark Rd (229-19-00)",
    "$": 1814100,
    "address": "209 Clark Rd",
    "parcel_id": "229-19-00",
    "owner1": "MURPHY, JENNIFER L",
    "owner2": "MOTA, JULIO",
    "current_taxes": 14941.45,
    "new_taxes_no_override": 15586.92,
    "override_total_1": 16029.19,
    "override_increase_1": 442.27
  },
  {
    "#": "212 Clark Rd (231-17-00)",
    "$": 2252600,
    "address": "212 Clark Rd",
    "parcel_id": "231-17-00",
    "owner1": "ORTIZ, ABIGAIL E",
    "owner2": "",
    "current_taxes": 23066.62,
    "new_taxes_no_override": 24063.1,
    "override_total_1": 24745.87,
    "override_increase_1": 682.77
  },
  {
    "#": "215 Clark Rd (229-20-00)",
    "$": 1837800,
    "address": "215 Clark Rd",
    "parcel_id": "229-20-00",
    "owner1": "INGLIS, ANDREW",
    "owner2": "MOLINA, ELIZABETH",
    "current_taxes": 18819.07,
    "new_taxes_no_override": 19632.05,
    "override_total_1": 20189.1,
    "override_increase_1": 557.04
  },
  {
    "#": "216 Clark Rd (231-16-00)",
    "$": 2699100,
    "address": "216 Clark Rd",
    "parcel_id": "231-16-00",
    "owner1": "COHEN TRS, ANDREA L",
    "owner2": "ZACK TRS, CARL J",
    "current_taxes": 24003.85,
    "new_taxes_no_override": 25040.82,
    "override_total_1": 25751.33,
    "override_increase_1": 710.51
  },
  {
    "#": "219 Clark Rd (229-21-00)",
    "$": 2028800,
    "address": "219 Clark Rd",
    "parcel_id": "229-21-00",
    "owner1": "PIROZZOLO, JACK W",
    "owner2": "DEPEW, ANNE G",
    "current_taxes": 17139.98,
    "new_taxes_no_override": 17880.43,
    "override_total_1": 18387.77,
    "override_increase_1": 507.34
  },
  {
    "#": "222 Clark Rd (231-15-00)",
    "$": 1815700,
    "address": "222 Clark Rd",
    "parcel_id": "231-15-00",
    "owner1": "MARSHALL, MICHAEL K",
    "owner2": "SCHNEIDER, RHODA E",
    "current_taxes": 14957.83,
    "new_taxes_no_override": 15604.01,
    "override_total_1": 16046.76,
    "override_increase_1": 442.75
  },
  {
    "#": "225 Clark Rd (229-22-00)",
    "$": 1834900,
    "address": "225 Clark Rd",
    "parcel_id": "229-22-00",
    "owner1": "GOODMAN, RICHARD D & SANDRA A",
    "owner2": "",
    "current_taxes": 15154.44,
    "new_taxes_no_override": 15809.11,
    "override_total_1": 16257.68,
    "override_increase_1": 448.57
  },
  {
    "#": "226 Clark Rd (231-14-00)",
    "$": 2174800,
    "address": "226 Clark Rd",
    "parcel_id": "231-14-00",
    "owner1": "DOWD, MICHAEL V",
    "owner2": "HUMMEL, AMY L",
    "current_taxes": 18635.02,
    "new_taxes_no_override": 19440.05,
    "override_total_1": 19991.65,
    "override_increase_1": 551.6
  },
  {
    "#": "229 Clark Rd (229-23-00)",
    "$": 2148900,
    "address": "229 Clark Rd",
    "parcel_id": "229-23-00",
    "owner1": "FITZPATRICK TR, KATHLEEN M",
    "owner2": "",
    "current_taxes": 22004.74,
    "new_taxes_no_override": 22955.34,
    "override_total_1": 23606.69,
    "override_increase_1": 651.34
  },
  {
    "#": "230 Clark Rd (231-13-00)",
    "$": 1935300,
    "address": "230 Clark Rd",
    "parcel_id": "231-13-00",
    "owner1": "PINTO, TAMAR",
    "owner2": "",
    "current_taxes": 16182.54,
    "new_taxes_no_override": 16881.63,
    "override_total_1": 17360.63,
    "override_increase_1": 479.0
  },
  {
    "#": "233 Clark Rd (229-24-00)",
    "$": 1817400,
    "address": "233 Clark Rd",
    "parcel_id": "229-24-00",
    "owner1": "CHINIARA, JOHN & ELLEN",
    "owner2": "",
    "current_taxes": 14975.24,
    "new_taxes_no_override": 15622.17,
    "override_total_1": 16065.44,
    "override_increase_1": 443.27
  },
  {
    "#": "238 Clark Rd (231-12-00)",
    "$": 2651700,
    "address": "238 Clark Rd",
    "parcel_id": "231-12-00",
    "owner1": "REBELLO, GLEESON N & ANURADHA S",
    "owner2": "",
    "current_taxes": 23518.47,
    "new_taxes_no_override": 24534.47,
    "override_total_1": 25230.61,
    "override_increase_1": 696.15
  },
  {
    "#": "239 Clark Rd (229-25-00)",
    "$": 2189300,
    "address": "239 Clark Rd",
    "parcel_id": "229-25-00",
    "owner1": "BRODY, ANDREW & ALLISON J",
    "owner2": "",
    "current_taxes": 18783.5,
    "new_taxes_no_override": 19594.95,
    "override_total_1": 20150.94,
    "override_increase_1": 555.99
  },
  {
    "#": "242 Clark Rd (231-11-00)",
    "$": 2259000,
    "address": "242 Clark Rd",
    "parcel_id": "231-11-00",
    "owner1": "EIFERMAN, JACK A",
    "owner2": "FISHER, FERN S",
    "current_taxes": 19497.23,
    "new_taxes_no_override": 20339.51,
    "override_total_1": 20916.63,
    "override_increase_1": 577.12
  },
  {
    "#": "243 Clark Rd (229-26-00)",
    "$": 1949100,
    "address": "243 Clark Rd",
    "parcel_id": "229-26-00",
    "owner1": "NEWMAN, SCOTT T & JUDITH A",
    "owner2": "",
    "current_taxes": 16323.85,
    "new_taxes_no_override": 17029.04,
    "override_total_1": 17512.23,
    "override_increase_1": 483.19
  },
  {
    "#": "246 Clark Rd (231-10-00)",
    "$": 2263400,
    "address": "246 Clark Rd",
    "parcel_id": "231-10-00",
    "owner1": "HARRIS, ADAM & JENNIFER",
    "owner2": "",
    "current_taxes": 19542.28,
    "new_taxes_no_override": 20386.51,
    "override_total_1": 20964.96,
    "override_increase_1": 578.45
  },
  {
    "#": "250 Clark Rd (231-09-00)",
    "$": 2273300,
    "address": "250 Clark Rd",
    "parcel_id": "231-09-00",
    "owner1": "OCONNOR TRS, DAVID L & DARIA L",
    "owner2": "",
    "current_taxes": 19643.66,
    "new_taxes_no_override": 20492.27,
    "override_total_1": 21073.72,
    "override_increase_1": 581.45
  },
  {
    "#": "253 Clark Rd (229-27-00)",
    "$": 3298900,
    "address": "253 Clark Rd",
    "parcel_id": "229-27-00",
    "owner1": "COHEN TRS, ALEXANDER LI",
    "owner2": "ANAND, MALLIKA",
    "current_taxes": 30145.8,
    "new_taxes_no_override": 31448.1,
    "override_total_1": 32340.41,
    "override_increase_1": 892.32
  },
  {
    "#": "255 Clark Rd (229-28-00)",
    "$": 3455600,
    "address": "255 Clark Rd",
    "parcel_id": "229-28-00",
    "owner1": "STEPHENSON, JAMES B & DANIELLE D",
    "owner2": "",
    "current_taxes": 35385.34,
    "new_taxes_no_override": 36913.99,
    "override_total_1": 37961.39,
    "override_increase_1": 1047.41
  },
  {
    "#": "256 Clark Rd (231-08-00)",
    "$": 1927500,
    "address": "256 Clark Rd",
    "parcel_id": "231-08-00",
    "owner1": "PODSZUS, EDWARD S",
    "owner2": "",
    "current_taxes": 16102.67,
    "new_taxes_no_override": 16798.31,
    "override_total_1": 17274.94,
    "override_increase_1": 476.64
  },
  {
    "#": "260 Clark Rd (231-07-00)",
    "$": 2087700,
    "address": "260 Clark Rd",
    "parcel_id": "231-07-00",
    "owner1": "QIAN, WEI",
    "owner2": "",
    "current_taxes": 17743.11,
    "new_taxes_no_override": 18509.61,
    "override_total_1": 19034.81,
    "override_increase_1": 525.2
  },
  {
    "#": "261 Clark Rd (229-29-00)",
    "$": 2436300,
    "address": "261 Clark Rd",
    "parcel_id": "229-29-00",
    "owner1": "FUKUDA, JAMES T & HELENE DAWN",
    "owner2": "",
    "current_taxes": 21312.78,
    "new_taxes_no_override": 22233.49,
    "override_total_1": 22864.35,
    "override_increase_1": 630.86
  },
  {
    "#": "266 Clark Rd (231-06-00)",
    "$": 2139000,
    "address": "266 Clark Rd",
    "parcel_id": "231-06-00",
    "owner1": "SONERU, ALLISON R & CHRISTIAN P",
    "owner2": "",
    "current_taxes": 18268.43,
    "new_taxes_no_override": 19057.63,
    "override_total_1": 19598.37,
    "override_increase_1": 540.75
  },
  {
    "#": "269 Clark Rd (229-30-00)",
    "$": 2110300,
    "address": "269 Clark Rd",
    "parcel_id": "229-30-00",
    "owner1": "SMITH 3RD, WILSON F",
    "owner2": "SMITH, MERRILL",
    "current_taxes": 17974.54,
    "new_taxes_no_override": 18751.04,
    "override_total_1": 19283.09,
    "override_increase_1": 532.05
  },
  {
    "#": "270 Clark Rd (231-05-00)",
    "$": 2624000,
    "address": "270 Clark Rd",
    "parcel_id": "231-05-00",
    "owner1": "MUND, MICHELLE & MATTHEW",
    "owner2": "",
    "current_taxes": 23234.83,
    "new_taxes_no_override": 24238.57,
    "override_total_1": 24926.33,
    "override_increase_1": 687.75
  },
  {
    "#": "279 Clark Rd (229-31-00)",
    "$": 2108000,
    "address": "279 Clark Rd",
    "parcel_id": "229-31-00",
    "owner1": "LAMB, JOHN & KATHLEEN",
    "owner2": "",
    "current_taxes": 17950.99,
    "new_taxes_no_override": 18726.47,
    "override_total_1": 19257.82,
    "override_increase_1": 531.35
  },
  {
    "#": "280 Clark Rd (231-04-00)",
    "$": 2726200,
    "address": "280 Clark Rd",
    "parcel_id": "231-04-00",
    "owner1": "EUVRARD, ERIC",
    "owner2": "HUANG, MEI MEI",
    "current_taxes": 24281.35,
    "new_taxes_no_override": 25330.3,
    "override_total_1": 26049.03,
    "override_increase_1": 718.73
  },
  {
    "#": "285 Clark Rd (229-32-00)",
    "$": 2348900,
    "address": "285 Clark Rd",
    "parcel_id": "229-32-00",
    "owner1": "OTTAWAY, JAMES W",
    "owner2": "VELDER, KATRIN A",
    "current_taxes": 20417.8,
    "new_taxes_no_override": 21299.85,
    "override_total_1": 21904.22,
    "override_increase_1": 604.37
  },
  {
    "#": "286 Clark Rd (231-03-00)",
    "$": 2276000,
    "address": "286 Clark Rd",
    "parcel_id": "231-03-00",
    "owner1": "FRANK TRS, DANIEL & NORMA A",
    "owner2": "",
    "current_taxes": 19671.31,
    "new_taxes_no_override": 20521.11,
    "override_total_1": 21103.38,
    "override_increase_1": 582.27
  },
  {
    "#": "295 Clark Rd (229-33-00)",
    "$": 2170600,
    "address": "295 Clark Rd",
    "parcel_id": "229-33-00",
    "owner1": "RUDY, JOHN T",
    "owner2": "LOBB, ANNELENA L",
    "current_taxes": 18592.01,
    "new_taxes_no_override": 19395.18,
    "override_total_1": 19945.51,
    "override_increase_1": 550.32
  },
  {
    "#": "301 Clark Rd (229-34-00)",
    "$": 2173000,
    "address": "301 Clark Rd",
    "parcel_id": "229-34-00",
    "owner1": "SIMKISS, GILLIAN V",
    "owner2": "",
    "current_taxes": 22251.52,
    "new_taxes_no_override": 23212.79,
    "override_total_1": 23871.43,
    "override_increase_1": 658.64
  },
  {
    "#": "305 Clark Rd (229-35-00)",
    "$": 2351700,
    "address": "305 Clark Rd",
    "parcel_id": "229-35-00",
    "owner1": "CORNELL, RUPA & JASON",
    "owner2": "",
    "current_taxes": 20446.47,
    "new_taxes_no_override": 21329.76,
    "override_total_1": 21934.97,
    "override_increase_1": 605.22
  },
  {
    "#": "308 Clark Rd (230-06-02)",
    "$": 4065200,
    "address": "308 Clark Rd",
    "parcel_id": "230-06-02",
    "owner1": "REDBURN, JEREMY & JENNIFER",
    "owner2": "",
    "current_taxes": 37992.71,
    "new_taxes_no_override": 39634.0,
    "override_total_1": 40758.58,
    "override_increase_1": 1124.58
  },
  {
    "#": "311 Clark Rd (229-36-00)",
    "$": 2034200,
    "address": "311 Clark Rd",
    "parcel_id": "229-36-00",
    "owner1": "ZANONI, IVAN",
    "owner2": "PONTIROLI, FRANCESCA ANN RACHELE",
    "current_taxes": 17195.27,
    "new_taxes_no_override": 17938.11,
    "override_total_1": 18447.09,
    "override_increase_1": 508.98
  },
  {
    "#": "314 Clark Rd (230-06-01)",
    "$": 4316700,
    "address": "314 Clark Rd",
    "parcel_id": "230-06-01",
    "owner1": "KLEBANER, STAN",
    "owner2": "GOLDSTEIN, ELENA",
    "current_taxes": 40568.07,
    "new_taxes_no_override": 42320.61,
    "override_total_1": 43521.43,
    "override_increase_1": 1200.81
  },
  {
    "#": "317 Clark Rd (229-37-00)",
    "$": 1667800,
    "address": "317 Clark Rd",
    "parcel_id": "229-37-00",
    "owner1": "KAYAKACHOIAN, GARY",
    "owner2": "",
    "current_taxes": 17078.27,
    "new_taxes_no_override": 17816.05,
    "override_total_1": 18321.57,
    "override_increase_1": 505.52
  },
  {
    "#": "323 Clark Rd (229-38-00)",
    "$": 2235000,
    "address": "323 Clark Rd",
    "parcel_id": "229-38-00",
    "owner1": "THALER, MATTHEW J",
    "owner2": "SEGEL, MARISA S",
    "current_taxes": 19251.47,
    "new_taxes_no_override": 20083.13,
    "override_total_1": 20652.98,
    "override_increase_1": 569.84
  },
  {
    "#": "326 Clark Rd (230-05-00)",
    "$": 3104100,
    "address": "326 Clark Rd",
    "parcel_id": "230-05-00",
    "owner1": "REED, THOMAS A & SARAH B",
    "owner2": "",
    "current_taxes": 28151.05,
    "new_taxes_no_override": 29367.18,
    "override_total_1": 30200.45,
    "override_increase_1": 833.27
  },
  {
    "#": "327 Clark Rd (229-39-00)",
    "$": 2281700,
    "address": "327 Clark Rd",
    "parcel_id": "229-39-00",
    "owner1": "ERICKSON, BRETT D",
    "owner2": "ASCOLI, ELIZABETH R",
    "current_taxes": 23364.61,
    "new_taxes_no_override": 24373.96,
    "override_total_1": 25065.55,
    "override_increase_1": 691.59
  },
  {
    "#": "330 Clark Rd (230-04-00)",
    "$": 2985600,
    "address": "330 Clark Rd",
    "parcel_id": "230-04-00",
    "owner1": "BERKE, CARL & BARBARA B",
    "owner2": "",
    "current_taxes": 26937.61,
    "new_taxes_no_override": 28101.31,
    "override_total_1": 28898.67,
    "override_increase_1": 797.35
  },
  {
    "#": "333 Clark Rd (229-40-00)",
    "$": 2440700,
    "address": "333 Clark Rd",
    "parcel_id": "229-40-00",
    "owner1": "CONNELLY TRS, VINCENT MICHAEL",
    "owner2": "RICCIOTTI , HOPE ANNE",
    "current_taxes": 21357.83,
    "new_taxes_no_override": 22280.49,
    "override_total_1": 22912.68,
    "override_increase_1": 632.19
  },
  {
    "#": "336 Clark Rd (230-03-00)",
    "$": 2238500,
    "address": "336 Clark Rd",
    "parcel_id": "230-03-00",
    "owner1": "HELMSTADTER, TRS, JOYCE H & DAVID R",
    "owner2": "",
    "current_taxes": 19287.31,
    "new_taxes_no_override": 20120.52,
    "override_total_1": 20691.43,
    "override_increase_1": 570.9
  },
  {
    "#": "339 Clark Rd (229-41-00)",
    "$": 2086400,
    "address": "339 Clark Rd",
    "parcel_id": "229-41-00",
    "owner1": "SAPOLSKY, TRS, SUSAN E",
    "owner2": "",
    "current_taxes": 17729.8,
    "new_taxes_no_override": 18495.73,
    "override_total_1": 19020.53,
    "override_increase_1": 524.8
  },
  {
    "#": "342 Clark Rd (230-02-00)",
    "$": 2456800,
    "address": "342 Clark Rd",
    "parcel_id": "230-02-00",
    "owner1": "POTERE, LOGAN M & BETHANY R",
    "owner2": "",
    "current_taxes": 25157.63,
    "new_taxes_no_override": 26244.44,
    "override_total_1": 26989.11,
    "override_increase_1": 744.67
  },
  {
    "#": "349 Clark Rd (229-42-00)",
    "$": 2193100,
    "address": "349 Clark Rd",
    "parcel_id": "229-42-00",
    "owner1": "LANGE TR, LOIS P",
    "owner2": "",
    "current_taxes": 18822.41,
    "new_taxes_no_override": 19635.54,
    "override_total_1": 20192.68,
    "override_increase_1": 557.14
  },
  {
    "#": "351 Clark Rd (229-43-00)",
    "$": 2200800,
    "address": "351 Clark Rd",
    "parcel_id": "229-43-00",
    "owner1": "JENSEN TR, DAVID J",
    "owner2": "",
    "current_taxes": 22536.19,
    "new_taxes_no_override": 23509.75,
    "override_total_1": 24176.82,
    "override_increase_1": 667.07
  },
  {
    "#": "11 Clearwater Rd (377-15-00)",
    "$": 1696900,
    "address": "11 Clearwater Rd",
    "parcel_id": "377-15-00",
    "owner1": "RAVID, SHMUEL & KATY",
    "owner2": "",
    "current_taxes": 13741.32,
    "new_taxes_no_override": 14334.95,
    "override_total_1": 14741.69,
    "override_increase_1": 406.74
  },
  {
    "#": "12 Clearwater Rd (376A-31-00)",
    "$": 1311600,
    "address": "12 Clearwater Rd",
    "parcel_id": "376A-31-00",
    "owner1": "GIFFORD, MATTHEW",
    "owner2": "GATELY, ERIN K",
    "current_taxes": 9795.85,
    "new_taxes_no_override": 10219.03,
    "override_total_1": 10508.99,
    "override_increase_1": 289.96
  },
  {
    "#": "15 Clearwater Rd (377-16-00)",
    "$": 1178100,
    "address": "15 Clearwater Rd",
    "parcel_id": "377-16-00",
    "owner1": "NACHTIGAL, DANIEL",
    "owner2": "BECK-NACHTIGAL, ANAT",
    "current_taxes": 8428.81,
    "new_taxes_no_override": 8792.93,
    "override_total_1": 9042.43,
    "override_increase_1": 249.49
  },
  {
    "#": "17 Clearwater Rd (377-17-00)",
    "$": 1292900,
    "address": "17 Clearwater Rd",
    "parcel_id": "377-17-00",
    "owner1": "PERALTA TRS, ADELQUI O",
    "owner2": "COSTANZO, CECILIA A",
    "current_taxes": 9604.36,
    "new_taxes_no_override": 10019.27,
    "override_total_1": 10303.56,
    "override_increase_1": 284.29
  },
  {
    "#": "18 Clearwater Rd (376A-30-00)",
    "$": 1241600,
    "address": "18 Clearwater Rd",
    "parcel_id": "376A-30-00",
    "owner1": "KHETTRY, URMILA",
    "owner2": "",
    "current_taxes": 9079.05,
    "new_taxes_no_override": 9471.26,
    "override_total_1": 9740.0,
    "override_increase_1": 268.74
  },
  {
    "#": "21 Clearwater Rd (377-18-00)",
    "$": 1105300,
    "address": "21 Clearwater Rd",
    "parcel_id": "377-18-00",
    "owner1": "OGINO, SHUJI & YOSHIE",
    "owner2": "",
    "current_taxes": 7683.34,
    "new_taxes_no_override": 8015.26,
    "override_total_1": 8242.69,
    "override_increase_1": 227.43
  },
  {
    "#": "22 Clearwater Rd (376A-29-00)",
    "$": 1467200,
    "address": "22 Clearwater Rd",
    "parcel_id": "376A-29-00",
    "owner1": "STEVENS TRS, DEAN P",
    "owner2": "JOHNSTON, JENNIFER",
    "current_taxes": 15024.13,
    "new_taxes_no_override": 15673.17,
    "override_total_1": 16117.89,
    "override_increase_1": 444.71
  },
  {
    "#": "25 Clearwater Rd (377-19-00)",
    "$": 1470500,
    "address": "25 Clearwater Rd",
    "parcel_id": "377-19-00",
    "owner1": "MERKEL, JOSEPH & ERIN",
    "owner2": "",
    "current_taxes": 11422.99,
    "new_taxes_no_override": 11916.46,
    "override_total_1": 12254.58,
    "override_increase_1": 338.12
  },
  {
    "#": "26 Clearwater Rd (376A-28-00)",
    "$": 1530900,
    "address": "26 Clearwater Rd",
    "parcel_id": "376A-28-00",
    "owner1": "FRIEDMAN TRS, PETER & PAMELA",
    "owner2": "",
    "current_taxes": 12041.48,
    "new_taxes_no_override": 12561.67,
    "override_total_1": 12918.1,
    "override_increase_1": 356.43
  },
  {
    "#": "30 Clearwater Rd (376A-27-00)",
    "$": 1299600,
    "address": "30 Clearwater Rd",
    "parcel_id": "376A-27-00",
    "owner1": "GRIEVES, GLENN & ANNE",
    "owner2": "",
    "current_taxes": 9672.97,
    "new_taxes_no_override": 10090.84,
    "override_total_1": 10377.16,
    "override_increase_1": 286.32
  },
  {
    "#": "33 Clearwater Rd (377-21-00)",
    "$": 1572700,
    "address": "33 Clearwater Rd",
    "parcel_id": "377-21-00",
    "owner1": "TERRANOVA, JOHN F JR",
    "owner2": "",
    "current_taxes": 16104.45,
    "new_taxes_no_override": 16800.16,
    "override_total_1": 17276.85,
    "override_increase_1": 476.69
  },
  {
    "#": "34 Clearwater Rd (376A-26-00)",
    "$": 1357000,
    "address": "34 Clearwater Rd",
    "parcel_id": "376A-26-00",
    "owner1": "GARVEY, KATHERINE C & MATTHEW P",
    "owner2": "",
    "current_taxes": 10260.75,
    "new_taxes_no_override": 10704.01,
    "override_total_1": 11007.73,
    "override_increase_1": 303.72
  },
  {
    "#": "38 Clearwater Rd (376A-25-00)",
    "$": 1323500,
    "address": "38 Clearwater Rd",
    "parcel_id": "376A-25-00",
    "owner1": "GRIFFEN TR, SARAH BOLLING",
    "owner2": "",
    "current_taxes": 9917.71,
    "new_taxes_no_override": 10346.16,
    "override_total_1": 10639.72,
    "override_increase_1": 293.56
  },
  {
    "#": "39 Clearwater Rd (377-22-00)",
    "$": 1200100,
    "address": "39 Clearwater Rd",
    "parcel_id": "377-22-00",
    "owner1": "FAYYAD TR, LANA MAHMOUD",
    "owner2": "",
    "current_taxes": 8654.09,
    "new_taxes_no_override": 9027.95,
    "override_total_1": 9284.11,
    "override_increase_1": 256.16
  },
  {
    "#": "42 Clearwater Rd (376A-24-00)",
    "$": 1319900,
    "address": "42 Clearwater Rd",
    "parcel_id": "376A-24-00",
    "owner1": "YEE TRS, DANNY & YA LING",
    "owner2": "",
    "current_taxes": 9880.84,
    "new_taxes_no_override": 10307.69,
    "override_total_1": 10600.17,
    "override_increase_1": 292.47
  },
  {
    "#": "45 Clearwater Rd (377-23-00)",
    "$": 1182100,
    "address": "45 Clearwater Rd",
    "parcel_id": "377-23-00",
    "owner1": "WAGNER, ERNEST",
    "owner2": "HA, HYELIN",
    "current_taxes": 8469.77,
    "new_taxes_no_override": 8835.66,
    "override_total_1": 9086.37,
    "override_increase_1": 250.71
  },
  {
    "#": "46 Clearwater Rd (376A-23-00)",
    "$": 1422600,
    "address": "46 Clearwater Rd",
    "parcel_id": "376A-23-00",
    "owner1": "FORD, JENNIFER B & ROBERT W",
    "owner2": "",
    "current_taxes": 10932.49,
    "new_taxes_no_override": 11404.77,
    "override_total_1": 11728.38,
    "override_increase_1": 323.6
  },
  {
    "#": "50 Clearwater Rd (376A-22-00)",
    "$": 1199900,
    "address": "50 Clearwater Rd",
    "parcel_id": "376A-22-00",
    "owner1": "BALLARD TRS, ARIELLE",
    "owner2": "ANIS, TAMER",
    "current_taxes": 8652.04,
    "new_taxes_no_override": 9025.81,
    "override_total_1": 9281.91,
    "override_increase_1": 256.1
  },
  {
    "#": "51 Clearwater Rd (377-24-00)",
    "$": 1200600,
    "address": "51 Clearwater Rd",
    "parcel_id": "377-24-00",
    "owner1": "BROWN TRS, LEONARD H & PHYLIS L",
    "owner2": "",
    "current_taxes": 8659.21,
    "new_taxes_no_override": 9033.29,
    "override_total_1": 9289.6,
    "override_increase_1": 256.31
  },
  {
    "#": "52 Clearwater Rd (376A-21-00)",
    "$": 1168900,
    "address": "52 Clearwater Rd",
    "parcel_id": "376A-21-00",
    "owner1": "LEVINE, NORMA J & DAVID E",
    "owner2": "",
    "current_taxes": 8334.6,
    "new_taxes_no_override": 8694.65,
    "override_total_1": 8941.36,
    "override_increase_1": 246.7
  },
  {
    "#": "56 Clearwater Rd (376A-20-00)",
    "$": 2489500,
    "address": "56 Clearwater Rd",
    "parcel_id": "376A-20-00",
    "owner1": "LEVI, ANDREW",
    "owner2": "SANIEOFF, JAMIE",
    "current_taxes": 25492.48,
    "new_taxes_no_override": 26593.76,
    "override_total_1": 27348.33,
    "override_increase_1": 754.58
  },
  {
    "#": "57 Clearwater Rd (377-25-00)",
    "$": 1341600,
    "address": "57 Clearwater Rd",
    "parcel_id": "377-25-00",
    "owner1": "BEACH, DOUGLAS",
    "owner2": "",
    "current_taxes": 10103.05,
    "new_taxes_no_override": 10539.5,
    "override_total_1": 10838.55,
    "override_increase_1": 299.05
  },
  {
    "#": "60 Clearwater Rd (376A-19-00)",
    "$": 1671700,
    "address": "60 Clearwater Rd",
    "parcel_id": "376A-19-00",
    "owner1": "DIOUF, KHADY",
    "owner2": "DIAGNE, OUSMANE",
    "current_taxes": 13483.27,
    "new_taxes_no_override": 14065.75,
    "override_total_1": 14464.85,
    "override_increase_1": 399.1
  },
  {
    "#": "64 Clearwater Rd (376A-18-00)",
    "$": 1559700,
    "address": "64 Clearwater Rd",
    "parcel_id": "376A-18-00",
    "owner1": "RUSSELL, RUSS E & BETSY Y",
    "owner2": "",
    "current_taxes": 12336.39,
    "new_taxes_no_override": 12869.32,
    "override_total_1": 13234.48,
    "override_increase_1": 365.16
  },
  {
    "#": "3 Cleveland Rd (264B-10-00)",
    "$": 3313200,
    "address": "3 Cleveland Rd",
    "parcel_id": "264B-10-00",
    "owner1": "VINEBURGH, PHILIP T",
    "owner2": "",
    "current_taxes": 30292.23,
    "new_taxes_no_override": 31600.85,
    "override_total_1": 32497.5,
    "override_increase_1": 896.65
  },
  {
    "#": "7 Cleveland Rd (264B-11-00)",
    "$": 3350800,
    "address": "7 Cleveland Rd",
    "parcel_id": "264B-11-00",
    "owner1": "GREENBLATT, LEE J",
    "owner2": "BABER, LAURA",
    "current_taxes": 30677.26,
    "new_taxes_no_override": 32002.52,
    "override_total_1": 32910.56,
    "override_increase_1": 908.05
  },
  {
    "#": "15 Cleveland Rd (264B-12-00)",
    "$": 3300600,
    "address": "15 Cleveland Rd",
    "parcel_id": "264B-12-00",
    "owner1": "FIFER, MICHAEL A",
    "owner2": "FELSENSTEIN, DONNA",
    "current_taxes": 30163.21,
    "new_taxes_no_override": 31466.26,
    "override_total_1": 32359.09,
    "override_increase_1": 892.83
  },
  {
    "#": "16 Cleveland Rd (264C-02-00)",
    "$": 3191600,
    "address": "16 Cleveland Rd",
    "parcel_id": "264C-02-00",
    "owner1": "BRITTON TRS, O'NEIL A & KATHRYN A",
    "owner2": "",
    "current_taxes": 29047.05,
    "new_taxes_no_override": 30301.88,
    "override_total_1": 31161.68,
    "override_increase_1": 859.79
  },
  {
    "#": "24 Cleveland Rd (264C-01-00)",
    "$": 3215300,
    "address": "24 Cleveland Rd",
    "parcel_id": "264C-01-00",
    "owner1": "HYCHONG, STEVE",
    "owner2": "LIN, NANCY",
    "current_taxes": 29289.74,
    "new_taxes_no_override": 30555.06,
    "override_total_1": 31422.03,
    "override_increase_1": 866.98
  },
  {
    "#": "25 Cleveland Rd (264B-13-00)",
    "$": 2842100,
    "address": "25 Cleveland Rd",
    "parcel_id": "264B-13-00",
    "owner1": "JONES, MARC J",
    "owner2": "SHARON, SIMPSON",
    "current_taxes": 25468.17,
    "new_taxes_no_override": 26568.39,
    "override_total_1": 27322.25,
    "override_increase_1": 753.86
  },
  {
    "#": "39 Cleveland Rd (265-09-00)",
    "$": 2346300,
    "address": "39 Cleveland Rd",
    "parcel_id": "265-09-00",
    "owner1": "ROSENBLATT, DANA E & MERLIN B",
    "owner2": "",
    "current_taxes": 20391.18,
    "new_taxes_no_override": 21272.08,
    "override_total_1": 21875.66,
    "override_increase_1": 603.58
  },
  {
    "#": "40 Cleveland Rd (265A-05-00)",
    "$": 1670100,
    "address": "40 Cleveland Rd",
    "parcel_id": "265A-05-00",
    "owner1": "WYNER, STEPHEN R",
    "owner2": "",
    "current_taxes": 17101.82,
    "new_taxes_no_override": 17840.62,
    "override_total_1": 18346.83,
    "override_increase_1": 506.21
  },
  {
    "#": "45 Cleveland Rd (265-10-00)",
    "$": 2779900,
    "address": "45 Cleveland Rd",
    "parcel_id": "265-10-00",
    "owner1": "SANIEOFF TR, ESHAGH",
    "owner2": "",
    "current_taxes": 24831.24,
    "new_taxes_no_override": 25903.95,
    "override_total_1": 26638.95,
    "override_increase_1": 735.0
  },
  {
    "#": "50 Cleveland Rd (265A-04-00)",
    "$": 3068500,
    "address": "50 Cleveland Rd",
    "parcel_id": "265A-04-00",
    "owner1": "SELLERS, WILLIAM R",
    "owner2": "LEE, MARIANNE Y",
    "current_taxes": 27786.51,
    "new_taxes_no_override": 28986.89,
    "override_total_1": 29809.37,
    "override_increase_1": 822.48
  },
  {
    "#": "51 Cleveland Rd (265-11-00)",
    "$": 2333400,
    "address": "51 Cleveland Rd",
    "parcel_id": "265-11-00",
    "owner1": "SLOMIAK TR, CHRISTOPHER",
    "owner2": "",
    "current_taxes": 23894.02,
    "new_taxes_no_override": 24926.24,
    "override_total_1": 25633.5,
    "override_increase_1": 707.26
  },
  {
    "#": "57 Cleveland Rd (265-12-00)",
    "$": 3823600,
    "address": "57 Cleveland Rd",
    "parcel_id": "265-12-00",
    "owner1": "KO, DANIEL",
    "owner2": "KONETSOVSKA, THEODORA",
    "current_taxes": 35518.73,
    "new_taxes_no_override": 37053.14,
    "override_total_1": 38104.49,
    "override_increase_1": 1051.35
  },
  {
    "#": "62 Cleveland Rd (265A-03-00)",
    "$": 3382300,
    "address": "62 Cleveland Rd",
    "parcel_id": "265A-03-00",
    "owner1": "GUAN, QIAN",
    "owner2": "ZHENG, TAO",
    "current_taxes": 30999.82,
    "new_taxes_no_override": 32339.01,
    "override_total_1": 33256.61,
    "override_increase_1": 917.59
  },
  {
    "#": "63 Cleveland Rd (265-13-00)",
    "$": 2131100,
    "address": "63 Cleveland Rd",
    "parcel_id": "265-13-00",
    "owner1": "QIAN, YOUQIANG",
    "owner2": "DU, XIAOFEN HELEN",
    "current_taxes": 18187.53,
    "new_taxes_no_override": 18973.23,
    "override_total_1": 19511.58,
    "override_increase_1": 538.35
  },
  {
    "#": "69 Cleveland Rd (265-14-00)",
    "$": 1841400,
    "address": "69 Cleveland Rd",
    "parcel_id": "265-14-00",
    "owner1": "BLOOD, ROGER F & SARAH S",
    "owner2": "",
    "current_taxes": 15221.0,
    "new_taxes_no_override": 15878.55,
    "override_total_1": 16329.09,
    "override_increase_1": 450.54
  },
  {
    "#": "70 Cleveland Rd (265A-02-00)",
    "$": 1723100,
    "address": "70 Cleveland Rd",
    "parcel_id": "265A-02-00",
    "owner1": "WANG, JULIA Y",
    "owner2": "ROEHRL, MICHAEL H  A",
    "current_taxes": 14009.61,
    "new_taxes_no_override": 14614.83,
    "override_total_1": 15029.51,
    "override_increase_1": 414.68
  },
  {
    "#": "77 Cleveland Rd (265-15-00)",
    "$": 1856300,
    "address": "77 Cleveland Rd",
    "parcel_id": "265-15-00",
    "owner1": "NANDAKUMAR, A K & JYOTHI",
    "owner2": "",
    "current_taxes": 15373.58,
    "new_taxes_no_override": 16037.72,
    "override_total_1": 16492.78,
    "override_increase_1": 455.06
  },
  {
    "#": "1 Clinton Path, Unit 1 (235-23-01)",
    "$": 860200,
    "address": "1 Clinton Path, Unit 1",
    "parcel_id": "235-23-01",
    "owner1": "FABRICK, KURT C",
    "owner2": "",
    "current_taxes": 8808.45,
    "new_taxes_no_override": 9188.98,
    "override_total_1": 9449.71,
    "override_increase_1": 260.73
  },
  {
    "#": "1 Clinton Path, Unit 2& P2 (235-23-02)",
    "$": 2024800,
    "address": "1 Clinton Path, Unit 2& P2",
    "parcel_id": "235-23-02",
    "owner1": "PETRUKHIN TR, KONSTANTIN E",
    "owner2": "",
    "current_taxes": 20733.95,
    "new_taxes_no_override": 21629.66,
    "override_total_1": 22243.38,
    "override_increase_1": 613.72
  },
  {
    "#": "1 Clinton Path, Unit 3 (235-23-03)",
    "$": 1158200,
    "address": "1 Clinton Path, Unit 3",
    "parcel_id": "235-23-03",
    "owner1": "TREY, GARY",
    "owner2": "",
    "current_taxes": 11859.97,
    "new_taxes_no_override": 12372.32,
    "override_total_1": 12723.38,
    "override_increase_1": 351.06
  },
  {
    "#": "9 Clinton Path, Unit 1 (235-01-03)",
    "$": 1063800,
    "address": "9 Clinton Path, Unit 1",
    "parcel_id": "235-01-03",
    "owner1": "MARCUS, ROBERT J & JOAN ROSE",
    "owner2": "",
    "current_taxes": 10893.31,
    "new_taxes_no_override": 11363.9,
    "override_total_1": 11686.34,
    "override_increase_1": 322.44
  },
  {
    "#": "9 Clinton Path, Unit 2 & P1 (235-01-01)",
    "$": 1001000,
    "address": "9 Clinton Path, Unit 2 & P1",
    "parcel_id": "235-01-01",
    "owner1": "SURMACHEVSKA, NATALYA",
    "owner2": "VED, VYAS PRANIT GANESH RAO UPADRASHTA",
    "current_taxes": 10250.24,
    "new_taxes_no_override": 10693.05,
    "override_total_1": 10996.46,
    "override_increase_1": 303.41
  },
  {
    "#": "9 Clinton Path, Unit 3 (235-01-02)",
    "$": 1029200,
    "address": "9 Clinton Path, Unit 3",
    "parcel_id": "235-01-02",
    "owner1": "LIN, TR, YU-LAN",
    "owner2": "",
    "current_taxes": 6904.07,
    "new_taxes_no_override": 7202.33,
    "override_total_1": 7406.69,
    "override_increase_1": 204.36
  },
  {
    "#": "26 Clinton Path (234-01-00)",
    "$": 34801500,
    "address": "26 Clinton Path",
    "parcel_id": "234-01-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O JEAN WALDSTEIN PLAYGROUND",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "3 Clinton Rd (231-43-00)",
    "$": 3533800,
    "address": "3 Clinton Rd",
    "parcel_id": "231-43-00",
    "owner1": "ZANINI, MICHELE",
    "owner2": "MOTTURA, LUDOVICA",
    "current_taxes": 32551.18,
    "new_taxes_no_override": 33957.39,
    "override_total_1": 34920.91,
    "override_increase_1": 963.51
  },
  {
    "#": "11 Clinton Rd (231-44-00)",
    "$": 3830400,
    "address": "11 Clinton Rd",
    "parcel_id": "231-44-00",
    "owner1": "FORMAN, SAMUEL A & YULIKA E",
    "owner2": "",
    "current_taxes": 35588.36,
    "new_taxes_no_override": 37125.78,
    "override_total_1": 38179.19,
    "override_increase_1": 1053.42
  },
  {
    "#": "19 Clinton Rd (231-45-00)",
    "$": 3852300,
    "address": "19 Clinton Rd",
    "parcel_id": "231-45-00",
    "owner1": "TOLIS, GEORGE & SHANNON",
    "owner2": "",
    "current_taxes": 35812.62,
    "new_taxes_no_override": 37359.73,
    "override_total_1": 38419.78,
    "override_increase_1": 1060.05
  },
  {
    "#": "20 Clinton Rd (247-15-17)",
    "$": 3339100,
    "address": "20 Clinton Rd",
    "parcel_id": "247-15-17",
    "owner1": "MEHTA, NORI FRANCES REIDT & SHREYAS NIKHIL",
    "owner2": "",
    "current_taxes": 30557.45,
    "new_taxes_no_override": 31877.53,
    "override_total_1": 32782.03,
    "override_increase_1": 904.5
  },
  {
    "#": "25 Clinton Rd (231-46-00)",
    "$": 3733900,
    "address": "25 Clinton Rd",
    "parcel_id": "231-46-00",
    "owner1": "THOMAS, ROBERT J",
    "owner2": "HERTZ, ROSANNA",
    "current_taxes": 34600.2,
    "new_taxes_no_override": 36094.93,
    "override_total_1": 37119.09,
    "override_increase_1": 1024.17
  },
  {
    "#": "30 Clinton Rd (247-14-00)",
    "$": 2729200,
    "address": "30 Clinton Rd",
    "parcel_id": "247-14-00",
    "owner1": "GANGULI, KRISTON & SUVRANU",
    "owner2": "",
    "current_taxes": 24312.07,
    "new_taxes_no_override": 25362.35,
    "override_total_1": 26081.99,
    "override_increase_1": 719.64
  },
  {
    "#": "33 Clinton Rd (231-47-00)",
    "$": 3507900,
    "address": "33 Clinton Rd",
    "parcel_id": "231-47-00",
    "owner1": "SUH TRS, ROBERT & CHRISTINA",
    "owner2": "",
    "current_taxes": 32285.96,
    "new_taxes_no_override": 33680.71,
    "override_total_1": 34636.38,
    "override_increase_1": 955.66
  },
  {
    "#": "38 Clinton Rd (247-13-00)",
    "$": 3138200,
    "address": "38 Clinton Rd",
    "parcel_id": "247-13-00",
    "owner1": "SEMPERT, DAVID & LENORE",
    "owner2": "",
    "current_taxes": 28500.23,
    "new_taxes_no_override": 29731.44,
    "override_total_1": 30575.05,
    "override_increase_1": 843.61
  },
  {
    "#": "39 Clinton Rd (231-48-00)",
    "$": 3064700,
    "address": "39 Clinton Rd",
    "parcel_id": "231-48-00",
    "owner1": "HOWRIGAN, GAIL A",
    "owner2": "",
    "current_taxes": 27747.59,
    "new_taxes_no_override": 28946.29,
    "override_total_1": 29767.61,
    "override_increase_1": 821.33
  },
  {
    "#": "46 Clinton Rd (247-12-02)",
    "$": 2852700,
    "address": "46 Clinton Rd",
    "parcel_id": "247-12-02",
    "owner1": "JELDEN, BYRON K & SHARONE KATZ",
    "owner2": "",
    "current_taxes": 25576.71,
    "new_taxes_no_override": 26681.62,
    "override_total_1": 27438.69,
    "override_increase_1": 757.07
  },
  {
    "#": "52 Clinton Rd (247-12-01)",
    "$": 3033000,
    "address": "52 Clinton Rd",
    "parcel_id": "247-12-01",
    "owner1": "BLECHNER, DEBRA & MARK",
    "owner2": "",
    "current_taxes": 27422.99,
    "new_taxes_no_override": 28607.66,
    "override_total_1": 29419.38,
    "override_increase_1": 811.72
  },
  {
    "#": "60 Clinton Rd (247-12-00)",
    "$": 4022700,
    "address": "60 Clinton Rd",
    "parcel_id": "247-12-00",
    "owner1": "COORDINATION COUNCIL",
    "owner2": "FOR N A AFFAIRS",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "67 Clinton Rd (231-49-00)",
    "$": 177900,
    "address": "67 Clinton Rd",
    "parcel_id": "231-49-00",
    "owner1": "COMMONWEALTH OF MASSACHUSETTS",
    "owner2": "C/O DIV OF CAPITAL ASSET MANAGEMNT",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "68 Clinton Rd (247-11-00)",
    "$": 4009400,
    "address": "68 Clinton Rd",
    "parcel_id": "247-11-00",
    "owner1": "CARVAJAL, ALEJANDRA V",
    "owner2": "KOSSNAR, AMY C",
    "current_taxes": 37421.32,
    "new_taxes_no_override": 39037.92,
    "override_total_1": 40145.59,
    "override_increase_1": 1107.67
  },
  {
    "#": "69 Clinton Rd (231-50-00)",
    "$": 2982200,
    "address": "69 Clinton Rd",
    "parcel_id": "231-50-00",
    "owner1": "SOLOMON, LESLEY",
    "owner2": "HIBBARD, DEREK",
    "current_taxes": 26902.79,
    "new_taxes_no_override": 28064.99,
    "override_total_1": 28861.31,
    "override_increase_1": 796.32
  },
  {
    "#": "75 Clinton Rd (231-51-00)",
    "$": 2192200,
    "address": "75 Clinton Rd",
    "parcel_id": "231-51-00",
    "owner1": "SCHOFIELD, SETH G",
    "owner2": "MITTAL, LEENA P",
    "current_taxes": 22448.13,
    "new_taxes_no_override": 23417.89,
    "override_total_1": 24082.35,
    "override_increase_1": 664.46
  },
  {
    "#": "78 Clinton Rd (247-10-00)",
    "$": 3621800,
    "address": "78 Clinton Rd",
    "parcel_id": "247-10-00",
    "owner1": "GIL, THOMER & JULIE ZESKIND",
    "owner2": "",
    "current_taxes": 37087.23,
    "new_taxes_no_override": 38689.4,
    "override_total_1": 39787.18,
    "override_increase_1": 1097.78
  },
  {
    "#": "79 Clinton Rd (231-52-00)",
    "$": 2260500,
    "address": "79 Clinton Rd",
    "parcel_id": "231-52-00",
    "owner1": "MARGALIT, RAN",
    "owner2": "MORESHET, HAMUTAL",
    "current_taxes": 19512.59,
    "new_taxes_no_override": 20355.53,
    "override_total_1": 20933.11,
    "override_increase_1": 577.57
  },
  {
    "#": "84 Clinton Rd (247-09-01)",
    "$": 4172400,
    "address": "84 Clinton Rd",
    "parcel_id": "247-09-01",
    "owner1": "POLACK, SHIFRA N & BARRY S",
    "owner2": "",
    "current_taxes": 39090.44,
    "new_taxes_no_override": 40779.15,
    "override_total_1": 41936.22,
    "override_increase_1": 1157.08
  },
  {
    "#": "87 Clinton Rd (231-53-00)",
    "$": 3457000,
    "address": "87 Clinton Rd",
    "parcel_id": "231-53-00",
    "owner1": "VISHLITZKY TRS, MIRYAM & RUTH",
    "owner2": "",
    "current_taxes": 31764.75,
    "new_taxes_no_override": 33136.99,
    "override_total_1": 34077.22,
    "override_increase_1": 940.24
  },
  {
    "#": "90 Clinton Rd (247-09-00)",
    "$": 3359300,
    "address": "90 Clinton Rd",
    "parcel_id": "247-09-00",
    "owner1": "JACOB TR, ANILA G",
    "owner2": "",
    "current_taxes": 30764.3,
    "new_taxes_no_override": 32093.32,
    "override_total_1": 33003.94,
    "override_increase_1": 910.62
  },
  {
    "#": "95 Clinton Rd (231-54-00)",
    "$": 3268200,
    "address": "95 Clinton Rd",
    "parcel_id": "231-54-00",
    "owner1": "MAYAR, VIPIN & RANJANA",
    "owner2": "",
    "current_taxes": 29831.43,
    "new_taxes_no_override": 31120.15,
    "override_total_1": 32003.16,
    "override_increase_1": 883.01
  },
  {
    "#": "98 Clinton Rd (247-08-00)",
    "$": 4041300,
    "address": "98 Clinton Rd",
    "parcel_id": "247-08-00",
    "owner1": "WILDERMAN TRS, SAM & BEATRICE",
    "owner2": "",
    "current_taxes": 37747.98,
    "new_taxes_no_override": 39378.69,
    "override_total_1": 40496.03,
    "override_increase_1": 1117.34
  },
  {
    "#": "103 Clinton Rd (231-55-00)",
    "$": 2576600,
    "address": "103 Clinton Rd",
    "parcel_id": "231-55-00",
    "owner1": "WOLFE, DAVID",
    "owner2": "MAK, PAULINE W F",
    "current_taxes": 22749.45,
    "new_taxes_no_override": 23732.23,
    "override_total_1": 24405.61,
    "override_increase_1": 673.38
  },
  {
    "#": "106 Clinton Rd (247-07-00)",
    "$": 5306700,
    "address": "106 Clinton Rd",
    "parcel_id": "247-07-00",
    "owner1": "SHANKAR, GANESH M & KALPANA  N",
    "owner2": "",
    "current_taxes": 50705.67,
    "new_taxes_no_override": 52896.15,
    "override_total_1": 54397.04,
    "override_increase_1": 1500.89
  },
  {
    "#": "111 Clinton Rd (231-56-00)",
    "$": 3055100,
    "address": "111 Clinton Rd",
    "parcel_id": "231-56-00",
    "owner1": "EPSTEIN, BETH LAUREN",
    "owner2": "",
    "current_taxes": 27649.29,
    "new_taxes_no_override": 28843.74,
    "override_total_1": 29662.16,
    "override_increase_1": 818.42
  },
  {
    "#": "114 Clinton Rd (247-06-00)",
    "$": 4988500,
    "address": "114 Clinton Rd",
    "parcel_id": "247-06-00",
    "owner1": "MINN, ENOCH & KAREN",
    "owner2": "",
    "current_taxes": 47447.31,
    "new_taxes_no_override": 49497.03,
    "override_total_1": 50901.47,
    "override_increase_1": 1404.44
  },
  {
    "#": "117 Clinton Rd (231-57-00)",
    "$": 4136300,
    "address": "117 Clinton Rd",
    "parcel_id": "231-57-00",
    "owner1": "GOSHKO, MARK P",
    "owner2": "",
    "current_taxes": 42355.71,
    "new_taxes_no_override": 44185.48,
    "override_total_1": 45439.21,
    "override_increase_1": 1253.73
  },
  {
    "#": "122 Clinton Rd (247-05-00)",
    "$": 5889300,
    "address": "122 Clinton Rd",
    "parcel_id": "247-05-00",
    "owner1": "MILIKOWSKY TRS, MATTHEW",
    "owner2": "ELDREDGE, NICOLE",
    "current_taxes": 56671.5,
    "new_taxes_no_override": 59119.71,
    "override_total_1": 60797.19,
    "override_increase_1": 1677.48
  },
  {
    "#": "125 Clinton Rd (231-58-00)",
    "$": 2724100,
    "address": "125 Clinton Rd",
    "parcel_id": "231-58-00",
    "owner1": "SCHMITT, PETER A",
    "owner2": "SEITINGER, SUSANNE",
    "current_taxes": 24259.85,
    "new_taxes_no_override": 25307.88,
    "override_total_1": 26025.97,
    "override_increase_1": 718.09
  },
  {
    "#": "128 Clinton Rd (247-04-00)",
    "$": 4233100,
    "address": "128 Clinton Rd",
    "parcel_id": "247-04-00",
    "owner1": "VAN ALLEN TRS, ELIEZER & LAUREN",
    "owner2": "",
    "current_taxes": 39712.01,
    "new_taxes_no_override": 41427.57,
    "override_total_1": 42603.04,
    "override_increase_1": 1175.48
  },
  {
    "#": "129 Clinton Rd (231-59-00)",
    "$": 2504300,
    "address": "129 Clinton Rd",
    "parcel_id": "231-59-00",
    "owner1": "ZAMENHOF, ROBERT G & RUTH L D",
    "owner2": "",
    "current_taxes": 22009.1,
    "new_taxes_no_override": 22959.89,
    "override_total_1": 23611.36,
    "override_increase_1": 651.47
  },
  {
    "#": "134 Clinton Rd (247-03-00)",
    "$": 3746900,
    "address": "134 Clinton Rd",
    "parcel_id": "247-03-00",
    "owner1": "HALLEE TR, MICHELLE A",
    "owner2": "WONG TR, GORDON G",
    "current_taxes": 34733.32,
    "new_taxes_no_override": 36233.8,
    "override_total_1": 37261.91,
    "override_increase_1": 1028.11
  },
  {
    "#": "137 Clinton Rd (231-60-00)",
    "$": 4609600,
    "address": "137 Clinton Rd",
    "parcel_id": "231-60-00",
    "owner1": "KELLEHER, RAYMOND J",
    "owner2": "",
    "current_taxes": 43567.37,
    "new_taxes_no_override": 45449.48,
    "override_total_1": 46739.07,
    "override_increase_1": 1289.59
  },
  {
    "#": "142 Clinton Rd (247-02-00)",
    "$": 2743200,
    "address": "142 Clinton Rd",
    "parcel_id": "247-02-00",
    "owner1": "COX, ROBERT",
    "owner2": "KOVEL, DARA",
    "current_taxes": 24455.43,
    "new_taxes_no_override": 25511.9,
    "override_total_1": 26235.79,
    "override_increase_1": 723.88
  },
  {
    "#": "147 Clinton Rd (231-01-00)",
    "$": 3769800,
    "address": "147 Clinton Rd",
    "parcel_id": "231-01-00",
    "owner1": "URETSKY, STEWART & ELANAH",
    "owner2": "",
    "current_taxes": 34967.82,
    "new_taxes_no_override": 36478.43,
    "override_total_1": 37513.48,
    "override_increase_1": 1035.05
  },
  {
    "#": "158 Clinton Rd (246-01-00)",
    "$": 3483100,
    "address": "158 Clinton Rd",
    "parcel_id": "246-01-00",
    "owner1": "DANIELS TRS, JOAN & WENDI",
    "owner2": "",
    "current_taxes": 32032.01,
    "new_taxes_no_override": 33415.79,
    "override_total_1": 34363.94,
    "override_increase_1": 948.15
  },
  {
    "#": "161 Clinton Rd (230-09-00)",
    "$": 2585200,
    "address": "161 Clinton Rd",
    "parcel_id": "230-09-00",
    "owner1": "JRJ BROOKFLEET LLC",
    "owner2": "",
    "current_taxes": 26472.45,
    "new_taxes_no_override": 27616.06,
    "override_total_1": 28399.64,
    "override_increase_1": 783.58
  },
  {
    "#": "166 Clinton Rd (246-08-00)",
    "$": 2499800,
    "address": "166 Clinton Rd",
    "parcel_id": "246-08-00",
    "owner1": "DINSMORE, JONATHAN H",
    "owner2": "BOSCH, IRENE B",
    "current_taxes": 21963.02,
    "new_taxes_no_override": 22911.82,
    "override_total_1": 23561.93,
    "override_increase_1": 650.11
  },
  {
    "#": "167 Clinton Rd (230-10-00)",
    "$": 2427000,
    "address": "167 Clinton Rd",
    "parcel_id": "230-10-00",
    "owner1": "SMITH, TRS, LEIGH H & JEAN G",
    "owner2": "",
    "current_taxes": 21217.55,
    "new_taxes_no_override": 22134.15,
    "override_total_1": 22762.19,
    "override_increase_1": 628.04
  },
  {
    "#": "171 Clinton Rd (230-11-00)",
    "$": 3255800,
    "address": "171 Clinton Rd",
    "parcel_id": "230-11-00",
    "owner1": "MILLER, JONATHAN B",
    "owner2": "JUPITER, MARISA B",
    "current_taxes": 29704.46,
    "new_taxes_no_override": 30987.69,
    "override_total_1": 31866.94,
    "override_increase_1": 879.25
  },
  {
    "#": "176 Clinton Rd (245-08-00)",
    "$": 3815400,
    "address": "176 Clinton Rd",
    "parcel_id": "245-08-00",
    "owner1": "NEEL, DANA",
    "owner2": "MACRAE, ANDREW",
    "current_taxes": 35434.76,
    "new_taxes_no_override": 36965.54,
    "override_total_1": 38014.41,
    "override_increase_1": 1048.87
  },
  {
    "#": "179 Clinton Rd (230-12-00)",
    "$": 2804800,
    "address": "179 Clinton Rd",
    "parcel_id": "230-12-00",
    "owner1": "BAKER, CHARLES",
    "owner2": "PIZZELLA, DOROTHY J",
    "current_taxes": 25086.22,
    "new_taxes_no_override": 26169.94,
    "override_total_1": 26912.5,
    "override_increase_1": 742.55
  },
  {
    "#": "183 Clinton Rd (230-13-00)",
    "$": 2777800,
    "address": "183 Clinton Rd",
    "parcel_id": "230-13-00",
    "owner1": "HAN TRS, MING",
    "owner2": "ZHANG, YUNYI",
    "current_taxes": 24809.74,
    "new_taxes_no_override": 25881.52,
    "override_total_1": 26615.89,
    "override_increase_1": 734.37
  },
  {
    "#": "189 Clinton Rd (230-14-00)",
    "$": 2735500,
    "address": "189 Clinton Rd",
    "parcel_id": "230-14-00",
    "owner1": "RUBENSTEIN, JOSHUA M",
    "owner2": "JANOWS, JILL A",
    "current_taxes": 24376.59,
    "new_taxes_no_override": 25429.66,
    "override_total_1": 26151.21,
    "override_increase_1": 721.55
  },
  {
    "#": "197 Clinton Rd (230-15-00)",
    "$": 2607000,
    "address": "197 Clinton Rd",
    "parcel_id": "230-15-00",
    "owner1": "REMOLD TRS, HEINRICH G J & EILEEN",
    "owner2": "",
    "current_taxes": 23060.75,
    "new_taxes_no_override": 24056.97,
    "override_total_1": 24739.57,
    "override_increase_1": 682.6
  },
  {
    "#": "203 Clinton Rd (230-16-00)",
    "$": 2821500,
    "address": "203 Clinton Rd",
    "parcel_id": "230-16-00",
    "owner1": "LEES, TRS, ROBERT S & ANN M",
    "owner2": "",
    "current_taxes": 25257.23,
    "new_taxes_no_override": 26348.34,
    "override_total_1": 27095.96,
    "override_increase_1": 747.61
  },
  {
    "#": "204 Clinton Rd (245-07-00)",
    "$": 3037100,
    "address": "204 Clinton Rd",
    "parcel_id": "245-07-00",
    "owner1": "KRISHNAN, CHANDRASEKHARAN",
    "owner2": "WEIR, DASCHA",
    "current_taxes": 31099.9,
    "new_taxes_no_override": 32443.42,
    "override_total_1": 33363.97,
    "override_increase_1": 920.56
  },
  {
    "#": "233 Clinton Rd (233-06-00)",
    "$": 2349600,
    "address": "233 Clinton Rd",
    "parcel_id": "233-06-00",
    "owner1": "GRINSPOON, SARA LANDIS",
    "owner2": "",
    "current_taxes": 24059.9,
    "new_taxes_no_override": 25099.29,
    "override_total_1": 25811.46,
    "override_increase_1": 712.17
  },
  {
    "#": "239 Clinton Rd (233-05-00)",
    "$": 2412900,
    "address": "239 Clinton Rd",
    "parcel_id": "233-05-00",
    "owner1": "HARRIS, MITCHEL B & ELIZABETH",
    "owner2": "",
    "current_taxes": 21073.16,
    "new_taxes_no_override": 21983.52,
    "override_total_1": 22607.29,
    "override_increase_1": 623.77
  },
  {
    "#": "240 Clinton Rd (232-10-00)",
    "$": 2993200,
    "address": "240 Clinton Rd",
    "parcel_id": "232-10-00",
    "owner1": "SMITH TRS, TRAVIS",
    "owner2": "GARBER, BROOKE",
    "current_taxes": 30650.37,
    "new_taxes_no_override": 31974.47,
    "override_total_1": 32881.72,
    "override_increase_1": 907.25
  },
  {
    "#": "245 Clinton Rd (233-04-00)",
    "$": 2581700,
    "address": "245 Clinton Rd",
    "parcel_id": "233-04-00",
    "owner1": "KURYS TRS, TINA M & DANIEL J",
    "owner2": "",
    "current_taxes": 22801.67,
    "new_taxes_no_override": 23786.7,
    "override_total_1": 24461.63,
    "override_increase_1": 674.93
  },
  {
    "#": "246 Clinton Rd (232-09-00)",
    "$": 2500200,
    "address": "246 Clinton Rd",
    "parcel_id": "232-09-00",
    "owner1": "JOSLIN LIFE ESTATE, YALTA I",
    "owner2": "",
    "current_taxes": 21967.11,
    "new_taxes_no_override": 22916.09,
    "override_total_1": 23566.32,
    "override_increase_1": 650.23
  },
  {
    "#": "249 Clinton Rd (233-03-00)",
    "$": 2314400,
    "address": "249 Clinton Rd",
    "parcel_id": "233-03-00",
    "owner1": "SHAPIRO, DANIEL",
    "owner2": "WEITZ-SHAPIRO, REBECCA B",
    "current_taxes": 20064.52,
    "new_taxes_no_override": 20931.31,
    "override_total_1": 21525.22,
    "override_increase_1": 593.91
  },
  {
    "#": "252 Clinton Rd (232-08-00)",
    "$": 2871800,
    "address": "252 Clinton Rd",
    "parcel_id": "232-08-00",
    "owner1": "FARONE, MARK C",
    "owner2": "SCHULMAN, MADELEINE C",
    "current_taxes": 25772.3,
    "new_taxes_no_override": 26885.66,
    "override_total_1": 27648.52,
    "override_increase_1": 762.86
  },
  {
    "#": "255 Clinton Rd (233-02-00)",
    "$": 2693600,
    "address": "255 Clinton Rd",
    "parcel_id": "233-02-00",
    "owner1": "SHEA, JOHN R",
    "owner2": "STUTTS, LIZA B",
    "current_taxes": 23947.53,
    "new_taxes_no_override": 24982.06,
    "override_total_1": 25690.91,
    "override_increase_1": 708.85
  },
  {
    "#": "261 Clinton Rd (233-01-00)",
    "$": 2470000,
    "address": "261 Clinton Rd",
    "parcel_id": "233-01-00",
    "owner1": "BLOOD, ALEXANDER JORDAN",
    "owner2": "FRAICHE, ARIANE",
    "current_taxes": 21657.87,
    "new_taxes_no_override": 22593.49,
    "override_total_1": 23234.56,
    "override_increase_1": 641.07
  },
  {
    "#": "262 Clinton Rd (232-07-00)",
    "$": 3712800,
    "address": "262 Clinton Rd",
    "parcel_id": "232-07-00",
    "owner1": "BERNSTEIN, ANDREW J",
    "owner2": "SHOBACK, J S",
    "current_taxes": 34384.14,
    "new_taxes_no_override": 35869.53,
    "override_total_1": 36887.31,
    "override_increase_1": 1017.77
  },
  {
    "#": "271 Clinton Rd (239-12-13)",
    "$": 3964000,
    "address": "271 Clinton Rd",
    "parcel_id": "239-12-13",
    "owner1": "AZAR, NATHALIE F & DIMITRI T",
    "owner2": "",
    "current_taxes": 40591.36,
    "new_taxes_no_override": 42344.91,
    "override_total_1": 43546.41,
    "override_increase_1": 1201.5
  },
  {
    "#": "278 Clinton Rd (240-05-00)",
    "$": 2695200,
    "address": "278 Clinton Rd",
    "parcel_id": "240-05-00",
    "owner1": "278 CLINTON ROAD LLC",
    "owner2": "",
    "current_taxes": 27598.85,
    "new_taxes_no_override": 28791.12,
    "override_total_1": 29608.05,
    "override_increase_1": 816.93
  },
  {
    "#": "285 Clinton Rd (239-11-00)",
    "$": 3108400,
    "address": "285 Clinton Rd",
    "parcel_id": "239-11-00",
    "owner1": "ALVES TRS, CARLOS MANUEL GREGORIO",
    "owner2": "PEREIRA, SILVIA ISABEL MARECOS GONCALVES",
    "current_taxes": 28195.08,
    "new_taxes_no_override": 29413.11,
    "override_total_1": 30247.68,
    "override_increase_1": 834.57
  },
  {
    "#": "286 Clinton Rd (240-04-00)",
    "$": 3149600,
    "address": "286 Clinton Rd",
    "parcel_id": "240-04-00",
    "owner1": "NISSMAN TR, JOAN L",
    "owner2": "",
    "current_taxes": 28616.97,
    "new_taxes_no_override": 29853.22,
    "override_total_1": 30700.29,
    "override_increase_1": 847.06
  },
  {
    "#": "289 Clinton Rd (239-10-00)",
    "$": 2566400,
    "address": "289 Clinton Rd",
    "parcel_id": "239-10-00",
    "owner1": "MILLER, JOHN & MARTHA",
    "owner2": "",
    "current_taxes": 22645.0,
    "new_taxes_no_override": 23623.26,
    "override_total_1": 24293.56,
    "override_increase_1": 670.29
  },
  {
    "#": "292 Clinton Rd (240-03-00)",
    "$": 2677800,
    "address": "292 Clinton Rd",
    "parcel_id": "240-03-00",
    "owner1": "LYONS, LEONARD A",
    "owner2": "RYAN, SHEILA A",
    "current_taxes": 23785.74,
    "new_taxes_no_override": 24813.28,
    "override_total_1": 25517.34,
    "override_increase_1": 704.06
  },
  {
    "#": "295 Clinton Rd (239-09-00)",
    "$": 2557500,
    "address": "295 Clinton Rd",
    "parcel_id": "239-09-00",
    "owner1": "DESAI, ANUPAM MADHUSUDAN",
    "owner2": "MAKHIJA, MONICA ARTI",
    "current_taxes": 22553.87,
    "new_taxes_no_override": 23528.2,
    "override_total_1": 24195.79,
    "override_increase_1": 667.59
  },
  {
    "#": "300 Clinton Rd (240-02-00)",
    "$": 2766300,
    "address": "300 Clinton Rd",
    "parcel_id": "240-02-00",
    "owner1": "KAPLAN, GLENN S",
    "owner2": "RING, DIANE M",
    "current_taxes": 24691.98,
    "new_taxes_no_override": 25758.67,
    "override_total_1": 26489.56,
    "override_increase_1": 730.88
  },
  {
    "#": "301 Clinton Rd (239-08-00)",
    "$": 2324700,
    "address": "301 Clinton Rd",
    "parcel_id": "239-08-00",
    "owner1": "KRAMER, PAUL A",
    "owner2": "MORRISON, SKYE",
    "current_taxes": 20169.99,
    "new_taxes_no_override": 21041.33,
    "override_total_1": 21638.37,
    "override_increase_1": 597.03
  },
  {
    "#": "311 Clinton Rd (239-07-00)",
    "$": 3068700,
    "address": "311 Clinton Rd",
    "parcel_id": "239-07-00",
    "owner1": "BALAKRISHNAN TRS, VAIDYANATHAPURAM",
    "owner2": "SRINIVASAN, JAYASHRI",
    "current_taxes": 31423.49,
    "new_taxes_no_override": 32780.98,
    "override_total_1": 33711.12,
    "override_increase_1": 930.14
  },
  {
    "#": "319 Clinton Rd (239-06-00)",
    "$": 2932800,
    "address": "319 Clinton Rd",
    "parcel_id": "239-06-00",
    "owner1": "MUSTO, WILLIAM P",
    "owner2": "MCCLINTOCK, CLAIRE S",
    "current_taxes": 26396.94,
    "new_taxes_no_override": 27537.29,
    "override_total_1": 28318.64,
    "override_increase_1": 781.35
  },
  {
    "#": "327 Clinton Rd (239-05-00)",
    "$": 2765100,
    "address": "327 Clinton Rd",
    "parcel_id": "239-05-00",
    "owner1": "DASSEL, SARA & KURT",
    "owner2": "",
    "current_taxes": 24679.69,
    "new_taxes_no_override": 25745.85,
    "override_total_1": 26476.37,
    "override_increase_1": 730.52
  },
  {
    "#": "330 Clinton Rd (241-09-00)",
    "$": 3399000,
    "address": "330 Clinton Rd",
    "parcel_id": "241-09-00",
    "owner1": "ESTRADA JR, CARLOS R",
    "owner2": "TABESH, BITA",
    "current_taxes": 31170.83,
    "new_taxes_no_override": 32517.41,
    "override_total_1": 33440.07,
    "override_increase_1": 922.66
  },
  {
    "#": "335 Clinton Rd (239-04-00)",
    "$": 2360400,
    "address": "335 Clinton Rd",
    "parcel_id": "239-04-00",
    "owner1": "CRUM TRS, TUCKER R & CHRISTOPHER P",
    "owner2": "",
    "current_taxes": 20535.56,
    "new_taxes_no_override": 21422.7,
    "override_total_1": 22030.55,
    "override_increase_1": 607.85
  },
  {
    "#": "338 Clinton Rd (241-08-00)",
    "$": 3516900,
    "address": "338 Clinton Rd",
    "parcel_id": "241-08-00",
    "owner1": "PEARSON, KIMBERLY H",
    "owner2": "",
    "current_taxes": 36013.06,
    "new_taxes_no_override": 37568.82,
    "override_total_1": 38634.81,
    "override_increase_1": 1065.99
  },
  {
    "#": "345 Clinton Rd (239-03-00)",
    "$": 2534800,
    "address": "345 Clinton Rd",
    "parcel_id": "239-03-00",
    "owner1": "KOZLOV, SIMON",
    "owner2": "KOGAN, ANNA",
    "current_taxes": 25956.35,
    "new_taxes_no_override": 27077.66,
    "override_total_1": 27845.97,
    "override_increase_1": 768.31
  },
  {
    "#": "351 Clinton Rd (239-02-00)",
    "$": 2425700,
    "address": "351 Clinton Rd",
    "parcel_id": "239-02-00",
    "owner1": "SOPEL, GEORGE C & SARAH R",
    "owner2": "",
    "current_taxes": 21204.23,
    "new_taxes_no_override": 22120.25,
    "override_total_1": 22747.9,
    "override_increase_1": 627.65
  },
  {
    "#": "357 Clinton Rd (239-01-02)",
    "$": 2221100,
    "address": "357 Clinton Rd",
    "parcel_id": "239-01-02",
    "owner1": "HURLBUT, LOUISE ALICE",
    "owner2": "CAUDLE, JONES RICHARD III",
    "current_taxes": 22744.06,
    "new_taxes_no_override": 23726.6,
    "override_total_1": 24399.83,
    "override_increase_1": 673.22
  },
  {
    "#": "370 Clinton Rd (263-05-00)",
    "$": 5052500,
    "address": "370 Clinton Rd",
    "parcel_id": "263-05-00",
    "owner1": "TAJUDDIN, WAQAR & SADAF W",
    "owner2": "",
    "current_taxes": 48102.67,
    "new_taxes_no_override": 50180.71,
    "override_total_1": 51604.54,
    "override_increase_1": 1423.84
  },
  {
    "#": "375 Clinton Rd (264-01-00)",
    "$": 3152100,
    "address": "375 Clinton Rd",
    "parcel_id": "264-01-00",
    "owner1": "CHOUMENKOVITCH, NICOLAS & SILVINA",
    "owner2": "",
    "current_taxes": 28642.57,
    "new_taxes_no_override": 29879.93,
    "override_total_1": 30727.75,
    "override_increase_1": 847.82
  },
  {
    "#": "376 Clinton Rd (263-04-00)",
    "$": 3358500,
    "address": "376 Clinton Rd",
    "parcel_id": "263-04-00",
    "owner1": "YORRA TRS, NANCY G & MARK L",
    "owner2": "",
    "current_taxes": 30756.11,
    "new_taxes_no_override": 32084.77,
    "override_total_1": 32995.15,
    "override_increase_1": 910.38
  },
  {
    "#": "381 Clinton Rd (264-02-00)",
    "$": 2188200,
    "address": "381 Clinton Rd",
    "parcel_id": "264-02-00",
    "owner1": "KIBRICK TR, JOHN D",
    "owner2": "",
    "current_taxes": 18772.23,
    "new_taxes_no_override": 19583.19,
    "override_total_1": 20138.85,
    "override_increase_1": 555.66
  },
  {
    "#": "385 Clinton Rd (264-03-00)",
    "$": 2833900,
    "address": "385 Clinton Rd",
    "parcel_id": "264-03-00",
    "owner1": "SELLAM TRS, CELINE & RONY",
    "owner2": "",
    "current_taxes": 25384.2,
    "new_taxes_no_override": 26480.8,
    "override_total_1": 27232.17,
    "override_increase_1": 751.37
  },
  {
    "#": "393 Clinton Rd (264-04-00)",
    "$": 3867500,
    "address": "393 Clinton Rd",
    "parcel_id": "264-04-00",
    "owner1": "HANNA, COURTNEY A",
    "owner2": "RENKES, THOMAS G",
    "current_taxes": 39603.2,
    "new_taxes_no_override": 41314.06,
    "override_total_1": 42486.31,
    "override_increase_1": 1172.25
  },
  {
    "#": "401 Clinton Rd (264-04-01)",
    "$": 2624700,
    "address": "401 Clinton Rd",
    "parcel_id": "264-04-01",
    "owner1": "BARLOW, LEONARD",
    "owner2": "LEFER, ELISA",
    "current_taxes": 23241.99,
    "new_taxes_no_override": 24246.04,
    "override_total_1": 24934.01,
    "override_increase_1": 687.96
  },
  {
    "#": "404 Clinton Rd (262-04-00)",
    "$": 2304700,
    "address": "404 Clinton Rd",
    "parcel_id": "262-04-00",
    "owner1": "LUCAS, ALAN & JANE",
    "owner2": "",
    "current_taxes": 19965.19,
    "new_taxes_no_override": 20827.69,
    "override_total_1": 21418.66,
    "override_increase_1": 590.97
  },
  {
    "#": "405 Clinton Rd (264-05-00)",
    "$": 2628500,
    "address": "405 Clinton Rd",
    "parcel_id": "264-05-00",
    "owner1": "GERBER, MARK N",
    "owner2": "CLIMO, AMY C",
    "current_taxes": 23280.91,
    "new_taxes_no_override": 24286.65,
    "override_total_1": 24975.76,
    "override_increase_1": 689.11
  },
  {
    "#": "411 Clinton Rd (264-06-00)",
    "$": 2623400,
    "address": "411 Clinton Rd",
    "parcel_id": "264-06-00",
    "owner1": "STEWART TR, ALEXANDRA THAYER",
    "owner2": "",
    "current_taxes": 26863.62,
    "new_taxes_no_override": 28024.13,
    "override_total_1": 28819.29,
    "override_increase_1": 795.16
  },
  {
    "#": "416 Clinton Rd (262-03-00)",
    "$": 3507500,
    "address": "416 Clinton Rd",
    "parcel_id": "262-03-00",
    "owner1": "KHURANA, VIKRAM",
    "owner2": "CHUNG, CHEE YEUN",
    "current_taxes": 32281.87,
    "new_taxes_no_override": 33676.45,
    "override_total_1": 34631.99,
    "override_increase_1": 955.54
  },
  {
    "#": "419 Clinton Rd (264-07-00)",
    "$": 2447300,
    "address": "419 Clinton Rd",
    "parcel_id": "264-07-00",
    "owner1": "WEINREB, SANDRA B & YAAKOV Y",
    "owner2": "",
    "current_taxes": 21425.42,
    "new_taxes_no_override": 22351.0,
    "override_total_1": 22985.19,
    "override_increase_1": 634.19
  },
  {
    "#": "425 Clinton Rd (264-08-00)",
    "$": 2116400,
    "address": "425 Clinton Rd",
    "parcel_id": "264-08-00",
    "owner1": "PEREZ, MARCOS LOPEZ",
    "owner2": "SEGEL, JENNIFER",
    "current_taxes": 18037.0,
    "new_taxes_no_override": 18816.2,
    "override_total_1": 19350.09,
    "override_increase_1": 533.9
  },
  {
    "#": "433 Clinton Rd (264-09-00)",
    "$": 3463100,
    "address": "433 Clinton Rd",
    "parcel_id": "264-09-00",
    "owner1": "BARBIELLINI, BERNARDO G",
    "owner2": "ECHALAS, A J",
    "current_taxes": 31827.21,
    "new_taxes_no_override": 33202.15,
    "override_total_1": 34144.23,
    "override_increase_1": 942.09
  },
  {
    "#": "434 Clinton Rd (264A-12-00)",
    "$": 2929500,
    "address": "434 Clinton Rd",
    "parcel_id": "264A-12-00",
    "owner1": "XAVIER, RAMNIK J",
    "owner2": "",
    "current_taxes": 26363.15,
    "new_taxes_no_override": 27502.04,
    "override_total_1": 28282.39,
    "override_increase_1": 780.35
  },
  {
    "#": "455 Clinton Rd (264D-04-00)",
    "$": 2335400,
    "address": "455 Clinton Rd",
    "parcel_id": "264D-04-00",
    "owner1": "VAIDYA, VISHAL S & ALKA V",
    "owner2": "",
    "current_taxes": 20279.56,
    "new_taxes_no_override": 21155.64,
    "override_total_1": 21755.91,
    "override_increase_1": 600.27
  },
  {
    "#": "465 Clinton Rd (264D-03-00)",
    "$": 1541100,
    "address": "465 Clinton Rd",
    "parcel_id": "264D-03-00",
    "owner1": "SIMONS TR, ELLEN L",
    "owner2": "",
    "current_taxes": 15780.86,
    "new_taxes_no_override": 16462.59,
    "override_total_1": 16929.71,
    "override_increase_1": 467.11
  },
  {
    "#": "471 Clinton Rd (264D-02-00)",
    "$": 1625600,
    "address": "471 Clinton Rd",
    "parcel_id": "264D-02-00",
    "owner1": "WOOTTON, MICHAEL",
    "owner2": "ROSALES, ANA MARIA",
    "current_taxes": 13011.21,
    "new_taxes_no_override": 13573.29,
    "override_total_1": 13958.43,
    "override_increase_1": 385.13
  },
  {
    "#": "477 Clinton Rd (264D-01-00)",
    "$": 1811400,
    "address": "477 Clinton Rd",
    "parcel_id": "264D-01-00",
    "owner1": "DAVIDYUK, GALINA",
    "owner2": "",
    "current_taxes": 14913.8,
    "new_taxes_no_override": 15558.08,
    "override_total_1": 15999.52,
    "override_increase_1": 441.45
  },
  {
    "#": "478 Clinton Rd (265-01-00)",
    "$": 2797900,
    "address": "478 Clinton Rd",
    "parcel_id": "265-01-00",
    "owner1": "GOSUM LLC",
    "owner2": "",
    "current_taxes": 28650.5,
    "new_taxes_no_override": 29888.2,
    "override_total_1": 30736.26,
    "override_increase_1": 848.05
  },
  {
    "#": "485 Clinton Rd (265-25-00)",
    "$": 1802100,
    "address": "485 Clinton Rd",
    "parcel_id": "265-25-00",
    "owner1": "HYNES, BARRY",
    "owner2": "",
    "current_taxes": 18453.5,
    "new_taxes_no_override": 19250.69,
    "override_total_1": 19796.91,
    "override_increase_1": 546.22
  },
  {
    "#": "486 Clinton Rd (265-26-00)",
    "$": 2652200,
    "address": "486 Clinton Rd",
    "parcel_id": "265-26-00",
    "owner1": "SANIEOFF, KHOSRO",
    "owner2": "",
    "current_taxes": 27158.53,
    "new_taxes_no_override": 28331.78,
    "override_total_1": 29135.67,
    "override_increase_1": 803.89
  },
  {
    "#": "491 Clinton Rd (265-24-00)",
    "$": 2131500,
    "address": "491 Clinton Rd",
    "parcel_id": "265-24-00",
    "owner1": "HUANG, DANIEL CHEIN-HAU",
    "owner2": "CHU, SARAH GRACE",
    "current_taxes": 18191.63,
    "new_taxes_no_override": 18977.51,
    "override_total_1": 19515.98,
    "override_increase_1": 538.47
  },
  {
    "#": "492 Clinton Rd (265-27-00)",
    "$": 2510000,
    "address": "492 Clinton Rd",
    "parcel_id": "265-27-00",
    "owner1": "492 CLINTON LLC",
    "owner2": "",
    "current_taxes": 25702.4,
    "new_taxes_no_override": 26812.74,
    "override_total_1": 27573.53,
    "override_increase_1": 760.79
  },
  {
    "#": "497 Clinton Rd (265-23-00)",
    "$": 1721600,
    "address": "497 Clinton Rd",
    "parcel_id": "265-23-00",
    "owner1": "RUBIN TRS, SANDRA & DANA",
    "owner2": "",
    "current_taxes": 13994.25,
    "new_taxes_no_override": 14598.8,
    "override_total_1": 15013.03,
    "override_increase_1": 414.23
  },
  {
    "#": "500 Clinton Rd (265-28-00)",
    "$": 1967800,
    "address": "500 Clinton Rd",
    "parcel_id": "265-28-00",
    "owner1": "SANIEOFF, BAHRAM",
    "owner2": "",
    "current_taxes": 16515.34,
    "new_taxes_no_override": 17228.8,
    "override_total_1": 17717.66,
    "override_increase_1": 488.85
  },
  {
    "#": "503 Clinton Rd (265-22-00)",
    "$": 1702200,
    "address": "503 Clinton Rd",
    "parcel_id": "265-22-00",
    "owner1": "PARRY, DAVID L",
    "owner2": "ORLOFF, HOLLY",
    "current_taxes": 13795.59,
    "new_taxes_no_override": 14391.56,
    "override_total_1": 14799.91,
    "override_increase_1": 408.35
  },
  {
    "#": "506 Clinton Rd (265-29-00)",
    "$": 1700700,
    "address": "506 Clinton Rd",
    "parcel_id": "265-29-00",
    "owner1": "KIM, SIMON S",
    "owner2": "PARK, SANG EUN",
    "current_taxes": 13780.23,
    "new_taxes_no_override": 14375.54,
    "override_total_1": 14783.43,
    "override_increase_1": 407.89
  },
  {
    "#": "509 Clinton Rd (265-21-00)",
    "$": 1717000,
    "address": "509 Clinton Rd",
    "parcel_id": "265-21-00",
    "owner1": "GLAZER, IRVING & DALE",
    "owner2": "",
    "current_taxes": 13947.15,
    "new_taxes_no_override": 14549.67,
    "override_total_1": 14962.5,
    "override_increase_1": 412.84
  },
  {
    "#": "510 Clinton Rd (265-30-00)",
    "$": 1929400,
    "address": "510 Clinton Rd",
    "parcel_id": "265-30-00",
    "owner1": "YEE TR, LILLIE L",
    "owner2": "",
    "current_taxes": 16122.12,
    "new_taxes_no_override": 16818.6,
    "override_total_1": 17295.81,
    "override_increase_1": 477.21
  },
  {
    "#": "515 Clinton Rd (265-20-00)",
    "$": 1791100,
    "address": "515 Clinton Rd",
    "parcel_id": "265-20-00",
    "owner1": "GONZALEZ, ALEJANDRO",
    "owner2": "RAJABIUN, SERENA",
    "current_taxes": 14705.93,
    "new_taxes_no_override": 15341.23,
    "override_total_1": 15776.52,
    "override_increase_1": 435.3
  },
  {
    "#": "520 Clinton Rd (265-31-00)",
    "$": 1812100,
    "address": "520 Clinton Rd",
    "parcel_id": "265-31-00",
    "owner1": "CHEN, PING",
    "owner2": "LU, QING",
    "current_taxes": 14920.97,
    "new_taxes_no_override": 15565.56,
    "override_total_1": 16007.22,
    "override_increase_1": 441.66
  },
  {
    "#": "521 Clinton Rd (265-19-00)",
    "$": 2012400,
    "address": "521 Clinton Rd",
    "parcel_id": "265-19-00",
    "owner1": "BAGLEY, LUKE T",
    "owner2": "CHIUMENTI, ANNA S",
    "current_taxes": 16972.04,
    "new_taxes_no_override": 17705.23,
    "override_total_1": 18207.6,
    "override_increase_1": 502.37
  },
  {
    "#": "524 Clinton Rd (265-32-00)",
    "$": 3250900,
    "address": "524 Clinton Rd",
    "parcel_id": "265-32-00",
    "owner1": "SANIEOFF, ESHAGH & AREZOU",
    "owner2": "",
    "current_taxes": 33289.22,
    "new_taxes_no_override": 34727.31,
    "override_total_1": 35712.68,
    "override_increase_1": 985.36
  },
  {
    "#": "529 Clinton Rd (265-18-00)",
    "$": 1561700,
    "address": "529 Clinton Rd",
    "parcel_id": "265-18-00",
    "owner1": "FOSHKO, EDWARD &  NATALIE",
    "owner2": "",
    "current_taxes": 12356.87,
    "new_taxes_no_override": 12890.69,
    "override_total_1": 13256.45,
    "override_increase_1": 365.76
  },
  {
    "#": "530 Clinton Rd (265-33-00)",
    "$": 3156400,
    "address": "530 Clinton Rd",
    "parcel_id": "265-33-00",
    "owner1": "LANGLEY, JANCY MORGAN",
    "owner2": "GOODMAN, BRIAN S",
    "current_taxes": 28686.6,
    "new_taxes_no_override": 29925.86,
    "override_total_1": 30774.98,
    "override_increase_1": 849.12
  },
  {
    "#": "535 Clinton Rd (265-16-02)",
    "$": 1820800,
    "address": "535 Clinton Rd",
    "parcel_id": "265-16-02",
    "owner1": "NIKOLOV, KALIN",
    "owner2": "NIKOLOVA, HRISTINA",
    "current_taxes": 18644.99,
    "new_taxes_no_override": 19450.45,
    "override_total_1": 20002.35,
    "override_increase_1": 551.89
  },
  {
    "#": "536 Clinton Rd (265-34-00)",
    "$": 2248300,
    "address": "536 Clinton Rd",
    "parcel_id": "265-34-00",
    "owner1": "YEE TRS, LEE H & ELAINE Y",
    "owner2": "",
    "current_taxes": 19387.66,
    "new_taxes_no_override": 20225.21,
    "override_total_1": 20799.08,
    "override_increase_1": 573.87
  },
  {
    "#": "539 Clinton Rd (265-35-00)",
    "$": 2586100,
    "address": "539 Clinton Rd",
    "parcel_id": "265-35-00",
    "owner1": "YEE, ESTHER Y P",
    "owner2": "",
    "current_taxes": 22846.73,
    "new_taxes_no_override": 23833.71,
    "override_total_1": 24509.97,
    "override_increase_1": 676.26
  },
  {
    "#": " Clinton Rd (240-04-01)",
    "$": 10900,
    "address": " Clinton Rd",
    "parcel_id": "240-04-01",
    "owner1": "ABROMSON, ET AL, MORTON C",
    "owner2": "",
    "current_taxes": 111.62,
    "new_taxes_no_override": 116.44,
    "override_total_1": 119.75,
    "override_increase_1": 3.3
  },
  {
    "#": "16 Clyde St (338-23-00)",
    "$": 6568300,
    "address": "16 Clyde St",
    "parcel_id": "338-23-00",
    "owner1": "SANTRY, CHARLES N & ANNETTE D",
    "owner2": "",
    "current_taxes": 63624.46,
    "new_taxes_no_override": 66373.04,
    "override_total_1": 68256.32,
    "override_increase_1": 1883.28
  },
  {
    "#": "30 Clyde St (338-22-09)",
    "$": 6685200,
    "address": "30 Clyde St",
    "parcel_id": "338-22-09",
    "owner1": "CHIANG, HSING CHIANG",
    "owner2": "",
    "current_taxes": 64821.51,
    "new_taxes_no_override": 67621.8,
    "override_total_1": 69540.52,
    "override_increase_1": 1918.72
  },
  {
    "#": "38 Clyde St (338-10-00)",
    "$": 5451300,
    "address": "38 Clyde St",
    "parcel_id": "338-10-00",
    "owner1": "SKEFFINGTON, JAMES J JR & RENEE H",
    "owner2": "",
    "current_taxes": 52186.38,
    "new_taxes_no_override": 54440.83,
    "override_total_1": 55985.55,
    "override_increase_1": 1544.72
  },
  {
    "#": "39 Clyde St (439-20-21)",
    "$": 7895800,
    "address": "39 Clyde St",
    "parcel_id": "439-20-21",
    "owner1": "DEXAIE PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 80852.99,
    "new_taxes_no_override": 84345.84,
    "override_total_1": 86739.09,
    "override_increase_1": 2393.25
  },
  {
    "#": "54 Clyde St (338-20-11)",
    "$": 5253200,
    "address": "54 Clyde St",
    "parcel_id": "338-20-11",
    "owner1": "SWARTZ, J SCOTT & ESMERALDA",
    "owner2": "",
    "current_taxes": 50157.83,
    "new_taxes_no_override": 52324.65,
    "override_total_1": 53809.32,
    "override_increase_1": 1484.67
  },
  {
    "#": "57 Clyde St (439-21-01)",
    "$": 9533200,
    "address": "57 Clyde St",
    "parcel_id": "439-21-01",
    "owner1": "BUDGE, NANCY",
    "owner2": "",
    "current_taxes": 97619.97,
    "new_taxes_no_override": 101837.15,
    "override_total_1": 104726.7,
    "override_increase_1": 2889.55
  },
  {
    "#": "68 Clyde St (338-12-19)",
    "$": 6403100,
    "address": "68 Clyde St",
    "parcel_id": "338-12-19",
    "owner1": "CLYDE STREET PARTNERS LLC",
    "owner2": "",
    "current_taxes": 65567.74,
    "new_taxes_no_override": 68400.27,
    "override_total_1": 70341.07,
    "override_increase_1": 1940.81
  },
  {
    "#": "74 Clyde St (338-13-18)",
    "$": 4043800,
    "address": "74 Clyde St",
    "parcel_id": "338-13-18",
    "owner1": "MOSES, DEBORAH W",
    "owner2": "",
    "current_taxes": 37773.58,
    "new_taxes_no_override": 39405.4,
    "override_total_1": 40523.5,
    "override_increase_1": 1118.1
  },
  {
    "#": "75 Clyde St (439-21-02)",
    "$": 6731400,
    "address": "75 Clyde St",
    "parcel_id": "439-21-02",
    "owner1": "BUDGE, NANCY",
    "owner2": "",
    "current_taxes": 65294.6,
    "new_taxes_no_override": 68115.33,
    "override_total_1": 70048.05,
    "override_increase_1": 1932.72
  },
  {
    "#": "88 Clyde St (338-16-00)",
    "$": 7081300,
    "address": "88 Clyde St",
    "parcel_id": "338-16-00",
    "owner1": "COHEE, KEVIN",
    "owner2": "WILLIAMS, TERI",
    "current_taxes": 72512.51,
    "new_taxes_no_override": 75645.05,
    "override_total_1": 77791.42,
    "override_increase_1": 2146.37
  },
  {
    "#": "99 Clyde St (439-25-01)",
    "$": 5657700,
    "address": "99 Clyde St",
    "parcel_id": "439-25-01",
    "owner1": "SUCOFF TR, ANDREW C",
    "owner2": "C/O GOODWIN PROCTER",
    "current_taxes": 57934.85,
    "new_taxes_no_override": 60437.64,
    "override_total_1": 62152.51,
    "override_increase_1": 1714.87
  },
  {
    "#": "106 Clyde St (339-13-00)",
    "$": 8472000,
    "address": "106 Clyde St",
    "parcel_id": "339-13-00",
    "owner1": "DANGELO, DAVID & STEPHANIE",
    "owner2": "",
    "current_taxes": 86753.28,
    "new_taxes_no_override": 90501.02,
    "override_total_1": 93068.92,
    "override_increase_1": 2567.9
  },
  {
    "#": "120 Clyde St (339-12-00)",
    "$": 8767700,
    "address": "120 Clyde St",
    "parcel_id": "339-12-00",
    "owner1": "ELFLAND, LYNNE",
    "owner2": "",
    "current_taxes": 86146.31,
    "new_taxes_no_override": 89867.83,
    "override_total_1": 92417.76,
    "override_increase_1": 2549.93
  },
  {
    "#": "130 Clyde St (339-14-00)",
    "$": 4135100,
    "address": "130 Clyde St",
    "parcel_id": "339-14-00",
    "owner1": "KERNER, J THOMAS",
    "owner2": "MURPHY, M KATE",
    "current_taxes": 38708.49,
    "new_taxes_no_override": 40380.7,
    "override_total_1": 41526.47,
    "override_increase_1": 1145.77
  },
  {
    "#": "142 Clyde St (339-10-11)",
    "$": 15964300,
    "address": "142 Clyde St",
    "parcel_id": "339-10-11",
    "owner1": "THE GOVERNMENT OF JAPAN",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "145 Clyde St (439-48-50)",
    "$": 27198900,
    "address": "145 Clyde St",
    "parcel_id": "439-48-50",
    "owner1": "MALT TR, R BRADFORD",
    "owner2": "",
    "current_taxes": 278516.74,
    "new_taxes_no_override": 290548.66,
    "override_total_1": 298792.76,
    "override_increase_1": 8244.1
  },
  {
    "#": "155 Clyde St (439-56-71)",
    "$": 12237900,
    "address": "155 Clyde St",
    "parcel_id": "439-56-71",
    "owner1": "SYDA FOUNDATION",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "180 Clyde St (339-09-00)",
    "$": 10146400,
    "address": "180 Clyde St",
    "parcel_id": "339-09-00",
    "owner1": "SCHADE, PATRICIA E P & CHRISTIAN S",
    "owner2": "",
    "current_taxes": 100264.2,
    "new_taxes_no_override": 104595.61,
    "override_total_1": 107563.43,
    "override_increase_1": 2967.82
  },
  {
    "#": "181 Clyde St (439-81-04)",
    "$": 8073800,
    "address": "181 Clyde St",
    "parcel_id": "439-81-04",
    "owner1": "ROSENFELD, DONALD",
    "owner2": "",
    "current_taxes": 82675.71,
    "new_taxes_no_override": 86247.3,
    "override_total_1": 88694.5,
    "override_increase_1": 2447.2
  },
  {
    "#": "191 Clyde St (441-01-00)",
    "$": 97633400,
    "address": "191 Clyde St",
    "parcel_id": "441-01-00",
    "owner1": "COUNTRY CLUB, THE",
    "owner2": "",
    "current_taxes": 1655260.5,
    "new_taxes_no_override": 1726767.75,
    "override_total_1": 1775763.46,
    "override_increase_1": 48995.71
  },
  {
    "#": "198 Clyde St (339-15-00)",
    "$": 7483500,
    "address": "198 Clyde St",
    "parcel_id": "339-15-00",
    "owner1": "HYNES TRS, THOMAS J JR",
    "owner2": "COHEN, KIMBERLY E",
    "current_taxes": 76631.04,
    "new_taxes_no_override": 79941.5,
    "override_total_1": 82209.78,
    "override_increase_1": 2268.28
  },
  {
    "#": "204 Clyde St (339-16-00)",
    "$": 7865700,
    "address": "204 Clyde St",
    "parcel_id": "339-16-00",
    "owner1": "RONTAL TRS, DAVID",
    "owner2": "LEVENTHAL, EMILY",
    "current_taxes": 80544.77,
    "new_taxes_no_override": 84024.3,
    "override_total_1": 86408.43,
    "override_increase_1": 2384.13
  },
  {
    "#": "220 Clyde St (339-07-01)",
    "$": 7079500,
    "address": "220 Clyde St",
    "parcel_id": "339-07-01",
    "owner1": "MARONI TR, KEVIN J",
    "owner2": "",
    "current_taxes": 72494.08,
    "new_taxes_no_override": 75625.82,
    "override_total_1": 77771.65,
    "override_increase_1": 2145.82
  },
  {
    "#": "246 Clyde St (347-05-01)",
    "$": 1123000,
    "address": "246 Clyde St",
    "parcel_id": "347-05-01",
    "owner1": "THE COUNTRY CLUB",
    "owner2": "",
    "current_taxes": 11499.52,
    "new_taxes_no_override": 11996.3,
    "override_total_1": 12336.69,
    "override_increase_1": 340.39
  },
  {
    "#": "254 Clyde St, Unit 1 & P1A (347-05-02)",
    "$": 600000,
    "address": "254 Clyde St, Unit 1 & P1A",
    "parcel_id": "347-05-02",
    "owner1": "DEL ALCAZAR, CARLOS R GIL",
    "owner2": "",
    "current_taxes": 6144.0,
    "new_taxes_no_override": 6409.42,
    "override_total_1": 6591.28,
    "override_increase_1": 181.86
  },
  {
    "#": "254 Clyde St, Unit 2 Prk-2A-B (347-05-03)",
    "$": 623500,
    "address": "254 Clyde St, Unit 2 Prk-2A-B",
    "parcel_id": "347-05-03",
    "owner1": "MAO, PINGPING",
    "owner2": "",
    "current_taxes": 2749.71,
    "new_taxes_no_override": 2868.5,
    "override_total_1": 2949.89,
    "override_increase_1": 81.39
  },
  {
    "#": "254 Clyde St, Unit 3 Prk-3A-B (347-05-04)",
    "$": 751300,
    "address": "254 Clyde St, Unit 3 Prk-3A-B",
    "parcel_id": "347-05-04",
    "owner1": "DEL ALCAZAR, CARLOS R GIL",
    "owner2": "WEISS, JENNIFER B",
    "current_taxes": 4058.38,
    "new_taxes_no_override": 4233.7,
    "override_total_1": 4353.83,
    "override_increase_1": 120.13
  },
  {
    "#": "256 Clyde St (347-04-00)",
    "$": 1020600,
    "address": "256 Clyde St",
    "parcel_id": "347-04-00",
    "owner1": "LI TR, MEEI-HUEY",
    "owner2": "",
    "current_taxes": 6816.01,
    "new_taxes_no_override": 7110.46,
    "override_total_1": 7312.22,
    "override_increase_1": 201.75
  },
  {
    "#": "268 Clyde St (340-16-00)",
    "$": 849700,
    "address": "268 Clyde St",
    "parcel_id": "340-16-00",
    "owner1": "SOLTOFF, MICHAEL P",
    "owner2": "ALLEN, ASTRID A",
    "current_taxes": 5065.99,
    "new_taxes_no_override": 5284.84,
    "override_total_1": 5434.79,
    "override_increase_1": 149.95
  },
  {
    "#": "272 Clyde St (340-15-00)",
    "$": 1083800,
    "address": "272 Clyde St",
    "parcel_id": "340-15-00",
    "owner1": "DONOVAN LIFE ESTATES, MARY P & JOHN T",
    "owner2": "",
    "current_taxes": 7463.18,
    "new_taxes_no_override": 7785.59,
    "override_total_1": 8006.5,
    "override_increase_1": 220.91
  },
  {
    "#": "276 Clyde St (340-14-00)",
    "$": 1078300,
    "address": "276 Clyde St",
    "parcel_id": "340-14-00",
    "owner1": "CHASE, JONATHAN D",
    "owner2": "KENNEALLY CHASE, JODY A",
    "current_taxes": 7406.86,
    "new_taxes_no_override": 7726.84,
    "override_total_1": 7946.08,
    "override_increase_1": 219.24
  },
  {
    "#": "280 Clyde St (340-13-00)",
    "$": 1255900,
    "address": "280 Clyde St",
    "parcel_id": "340-13-00",
    "owner1": "KOVALKO TR, YOLANTA M",
    "owner2": "",
    "current_taxes": 12860.42,
    "new_taxes_no_override": 13415.99,
    "override_total_1": 13796.66,
    "override_increase_1": 380.67
  },
  {
    "#": "286 Clyde St (340-12-00)",
    "$": 1209500,
    "address": "286 Clyde St",
    "parcel_id": "340-12-00",
    "owner1": "HARRIS, SEAN",
    "owner2": "PASSLEY HARRIS, SYLVIA",
    "current_taxes": 8750.35,
    "new_taxes_no_override": 9128.37,
    "override_total_1": 9387.38,
    "override_increase_1": 259.01
  },
  {
    "#": "290 Clyde St (340-11-09)",
    "$": 1022200,
    "address": "290 Clyde St",
    "parcel_id": "340-11-09",
    "owner1": "MCCUE, PATRICIA A",
    "owner2": "",
    "current_taxes": 6832.39,
    "new_taxes_no_override": 7127.55,
    "override_total_1": 7329.79,
    "override_increase_1": 202.24
  },
  {
    "#": "294 Clyde St (340-09-01)",
    "$": 1286000,
    "address": "294 Clyde St",
    "parcel_id": "340-09-01",
    "owner1": "BUBALO, JENAN & MAJA",
    "owner2": "",
    "current_taxes": 9533.71,
    "new_taxes_no_override": 9945.57,
    "override_total_1": 10227.76,
    "override_increase_1": 282.2
  },
  {
    "#": "298 Clyde St (340-10-00)",
    "$": 931100,
    "address": "298 Clyde St",
    "parcel_id": "340-10-00",
    "owner1": "WEN, XIU QIONG",
    "owner2": "CHOI, CONNIE H & CHRISTINE H",
    "current_taxes": 5899.53,
    "new_taxes_no_override": 6154.39,
    "override_total_1": 6329.02,
    "override_increase_1": 174.63
  },
  {
    "#": "302 Clyde St (340-10-01)",
    "$": 1106100,
    "address": "302 Clyde St",
    "parcel_id": "340-10-01",
    "owner1": "302 CLYDE STREET REALTY LLP",
    "owner2": "",
    "current_taxes": 11326.46,
    "new_taxes_no_override": 11815.76,
    "override_total_1": 12151.03,
    "override_increase_1": 335.26
  },
  {
    "#": "324 Clyde St, Unit 324 (342-07-03)",
    "$": 1320800,
    "address": "324 Clyde St, Unit 324",
    "parcel_id": "342-07-03",
    "owner1": "SUN TRS, LIXIN",
    "owner2": "LIU, YU",
    "current_taxes": 9890.06,
    "new_taxes_no_override": 10317.31,
    "override_total_1": 10610.06,
    "override_increase_1": 292.75
  },
  {
    "#": "334 Clyde St (343-01-00)",
    "$": 1683500,
    "address": "334 Clyde St",
    "parcel_id": "343-01-00",
    "owner1": "MARKET 244 LLC",
    "owner2": "",
    "current_taxes": 17239.04,
    "new_taxes_no_override": 17983.77,
    "override_total_1": 18494.04,
    "override_increase_1": 510.28
  },
  {
    "#": "336 Clyde St (343-12-00)",
    "$": 1295100,
    "address": "336 Clyde St",
    "parcel_id": "343-12-00",
    "owner1": "JANSONS, DACE & ANDRIS",
    "owner2": "",
    "current_taxes": 9626.89,
    "new_taxes_no_override": 10042.77,
    "override_total_1": 10327.73,
    "override_increase_1": 284.96
  },
  {
    "#": "342 Clyde St (343-11-00)",
    "$": 1383700,
    "address": "342 Clyde St",
    "parcel_id": "343-11-00",
    "owner1": "COLEMAN, TRS, JOHN D & KATHLEEN",
    "owner2": "",
    "current_taxes": 10534.15,
    "new_taxes_no_override": 10989.23,
    "override_total_1": 11301.04,
    "override_increase_1": 311.81
  },
  {
    "#": "344 Clyde St (343-10-00)",
    "$": 1557500,
    "address": "344 Clyde St",
    "parcel_id": "343-10-00",
    "owner1": "LUBY, STEVEN C",
    "owner2": "KACZOR, KRISTINE L",
    "current_taxes": 15948.8,
    "new_taxes_no_override": 16637.79,
    "override_total_1": 17109.87,
    "override_increase_1": 472.08
  },
  {
    "#": "352 Clyde St, Unit 1 (344-01-01)",
    "$": 1069500,
    "address": "352 Clyde St, Unit 1",
    "parcel_id": "344-01-01",
    "owner1": "CHEN, YULUN",
    "owner2": "CHANG, SHIU CHIN",
    "current_taxes": 10951.68,
    "new_taxes_no_override": 11424.79,
    "override_total_1": 11748.96,
    "override_increase_1": 324.17
  },
  {
    "#": "352 Clyde St, Unit 2 (344-01-02)",
    "$": 832000,
    "address": "352 Clyde St, Unit 2",
    "parcel_id": "344-01-02",
    "owner1": "ROQUE, JOSEPHINE ANN L",
    "owner2": "",
    "current_taxes": 4884.75,
    "new_taxes_no_override": 5095.77,
    "override_total_1": 5240.36,
    "override_increase_1": 144.59
  },
  {
    "#": "352 Clyde St, Unit 3 (344-01-03)",
    "$": 832000,
    "address": "352 Clyde St, Unit 3",
    "parcel_id": "344-01-03",
    "owner1": "GISIGER, ANGELINA L",
    "owner2": "",
    "current_taxes": 4884.75,
    "new_taxes_no_override": 5095.77,
    "override_total_1": 5240.36,
    "override_increase_1": 144.59
  },
  {
    "#": "356 Clyde St (344-12-00)",
    "$": 1031100,
    "address": "356 Clyde St",
    "parcel_id": "344-12-00",
    "owner1": "LIN, CHANGREN",
    "owner2": "CHEN, JIANYUN",
    "current_taxes": 10558.46,
    "new_taxes_no_override": 11014.59,
    "override_total_1": 11327.12,
    "override_increase_1": 312.53
  },
  {
    "#": "362 Clyde St (344-11-00)",
    "$": 1569400,
    "address": "362 Clyde St",
    "parcel_id": "344-11-00",
    "owner1": "LAM, NORMAN",
    "owner2": "WU, CARRIE C",
    "current_taxes": 12435.72,
    "new_taxes_no_override": 12972.94,
    "override_total_1": 13341.04,
    "override_increase_1": 368.1
  },
  {
    "#": "365 Clyde St (441-52-02)",
    "$": 6663800,
    "address": "365 Clyde St",
    "parcel_id": "441-52-02",
    "owner1": "MUKEN, ROSS & MELISSA",
    "owner2": "",
    "current_taxes": 68237.31,
    "new_taxes_no_override": 71185.16,
    "override_total_1": 73204.99,
    "override_increase_1": 2019.82
  },
  {
    "#": "370 Clyde St (344-10-01)",
    "$": 1729800,
    "address": "370 Clyde St",
    "parcel_id": "344-10-01",
    "owner1": "ENGLE TRS, ELIZABETH C",
    "owner2": "DENNEHY, PAUL J",
    "current_taxes": 14078.22,
    "new_taxes_no_override": 14686.4,
    "override_total_1": 15103.11,
    "override_increase_1": 416.72
  },
  {
    "#": "26 Codman Rd (333-03-00)",
    "$": 4105600,
    "address": "26 Codman Rd",
    "parcel_id": "333-03-00",
    "owner1": "BODEN, KATHARINE C",
    "owner2": "",
    "current_taxes": 38406.41,
    "new_taxes_no_override": 40065.57,
    "override_total_1": 41202.4,
    "override_increase_1": 1136.83
  },
  {
    "#": "30 Codman Rd (333-02-00)",
    "$": 10805900,
    "address": "30 Codman Rd",
    "parcel_id": "333-02-00",
    "owner1": "GORDON, DOUGLAS & TONI",
    "owner2": "",
    "current_taxes": 107017.48,
    "new_taxes_no_override": 111640.64,
    "override_total_1": 114808.35,
    "override_increase_1": 3167.72
  },
  {
    "#": "36 Codman Rd (333-01-00)",
    "$": 7094700,
    "address": "36 Codman Rd",
    "parcel_id": "333-01-00",
    "owner1": "MCNAY, COLIN S & ANNE",
    "owner2": "",
    "current_taxes": 69014.79,
    "new_taxes_no_override": 71996.23,
    "override_total_1": 74039.07,
    "override_increase_1": 2042.84
  },
  {
    "#": "41 Codman Rd (329-01-00)",
    "$": 3948800,
    "address": "41 Codman Rd",
    "parcel_id": "329-01-00",
    "owner1": "41 CODMAN ROAD LLC",
    "owner2": "",
    "current_taxes": 40435.71,
    "new_taxes_no_override": 42182.53,
    "override_total_1": 43379.43,
    "override_increase_1": 1196.9
  },
  {
    "#": "59 Codman Rd (329-02-00)",
    "$": 8105500,
    "address": "59 Codman Rd",
    "parcel_id": "329-02-00",
    "owner1": "SERVISON, ROGER T & KRISTIN L",
    "owner2": "",
    "current_taxes": 79365.39,
    "new_taxes_no_override": 82793.97,
    "override_total_1": 85143.19,
    "override_increase_1": 2349.22
  },
  {
    "#": "60 Codman Rd (328-14-00)",
    "$": 3001100,
    "address": "60 Codman Rd",
    "parcel_id": "328-14-00",
    "owner1": "MCNAY, COLIN & ANNE",
    "owner2": "",
    "current_taxes": 30731.26,
    "new_taxes_no_override": 32058.85,
    "override_total_1": 32968.5,
    "override_increase_1": 909.65
  },
  {
    "#": "62 Codman Rd (328-13-00)",
    "$": 3001100,
    "address": "62 Codman Rd",
    "parcel_id": "328-13-00",
    "owner1": "HOLY NATIVITY CONVENT INC",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "70 Codman Rd (328-12-00)",
    "$": 15955300,
    "address": "70 Codman Rd",
    "parcel_id": "328-12-00",
    "owner1": "HOLY NATIVITY CONVENT INC",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "77 Codman Rd (329-03-00)",
    "$": 3362800,
    "address": "77 Codman Rd",
    "parcel_id": "329-03-00",
    "owner1": "SERVISON, ROGER & KRISTIN",
    "owner2": "",
    "current_taxes": 34435.07,
    "new_taxes_no_override": 35922.67,
    "override_total_1": 36941.94,
    "override_increase_1": 1019.28
  },
  {
    "#": "99 Codman Rd (329-04-00)",
    "$": 2544700,
    "address": "99 Codman Rd",
    "parcel_id": "329-04-00",
    "owner1": "KIRK TRS, MICHAEL J",
    "owner2": "RIZOPOULOS, NATASHA",
    "current_taxes": 22422.79,
    "new_taxes_no_override": 23391.45,
    "override_total_1": 24055.17,
    "override_increase_1": 663.71
  },
  {
    "#": "100 Codman Rd (328-11-00)",
    "$": 4913200,
    "address": "100 Codman Rd",
    "parcel_id": "328-11-00",
    "owner1": "MCFADDEN, MARY",
    "owner2": "STIFLER, LAWRENCE",
    "current_taxes": 46676.23,
    "new_taxes_no_override": 48692.64,
    "override_total_1": 50074.26,
    "override_increase_1": 1381.62
  },
  {
    "#": "103 Codman Rd (329-04-01)",
    "$": 13100,
    "address": "103 Codman Rd",
    "parcel_id": "329-04-01",
    "owner1": "GREENWALD, MICHAEL A & BARBARA",
    "owner2": "",
    "current_taxes": 134.14,
    "new_taxes_no_override": 139.93,
    "override_total_1": 143.91,
    "override_increase_1": 3.97
  },
  {
    "#": "104 Codman Rd (328-10-01)",
    "$": 8346600,
    "address": "104 Codman Rd",
    "parcel_id": "328-10-01",
    "owner1": "GREENWALD, BARBARA G",
    "owner2": "",
    "current_taxes": 85469.18,
    "new_taxes_no_override": 89161.45,
    "override_total_1": 91691.34,
    "override_increase_1": 2529.89
  },
  {
    "#": "108 Codman Rd (328-10-00)",
    "$": 4927600,
    "address": "108 Codman Rd",
    "parcel_id": "328-10-00",
    "owner1": "ROOK TR, JOAN",
    "owner2": "",
    "current_taxes": 46823.69,
    "new_taxes_no_override": 48846.47,
    "override_total_1": 50232.45,
    "override_increase_1": 1385.98
  },
  {
    "#": "120 Codman Rd (328-09-00)",
    "$": 3379600,
    "address": "120 Codman Rd",
    "parcel_id": "328-09-00",
    "owner1": "SEVERO, STEPHEN",
    "owner2": "ORLOVA, YULIYA",
    "current_taxes": 30972.17,
    "new_taxes_no_override": 32310.17,
    "override_total_1": 33226.94,
    "override_increase_1": 916.78
  },
  {
    "#": "8 Colbourne Cres, Unit 1 (218-01-01)",
    "$": 740300,
    "address": "8 Colbourne Cres, Unit 1",
    "parcel_id": "218-01-01",
    "owner1": "LI, HONGDOU & CHAO",
    "owner2": "",
    "current_taxes": 3945.74,
    "new_taxes_no_override": 4116.2,
    "override_total_1": 4232.99,
    "override_increase_1": 116.79
  },
  {
    "#": "8 Colbourne Cres, Unit 2 (218-01-02)",
    "$": 1220100,
    "address": "8 Colbourne Cres, Unit 2",
    "parcel_id": "218-01-02",
    "owner1": "TANG, JUN",
    "owner2": "ZHANG, XIN",
    "current_taxes": 12493.82,
    "new_taxes_no_override": 13033.55,
    "override_total_1": 13403.37,
    "override_increase_1": 369.82
  },
  {
    "#": "8 Colbourne Cres, Unit 3 (218-01-03)",
    "$": 1232400,
    "address": "8 Colbourne Cres, Unit 3",
    "parcel_id": "218-01-03",
    "owner1": "AL NASHASHIBI, SARRI",
    "owner2": "",
    "current_taxes": 8984.84,
    "new_taxes_no_override": 9372.99,
    "override_total_1": 9638.94,
    "override_increase_1": 265.95
  },
  {
    "#": "8 Colbourne Cres, Unit 4 (218-01-04)",
    "$": 1209900,
    "address": "8 Colbourne Cres, Unit 4",
    "parcel_id": "218-01-04",
    "owner1": "EGAN, CHRISTOPHER L&ANN DOHERTY",
    "owner2": "",
    "current_taxes": 8754.44,
    "new_taxes_no_override": 9132.63,
    "override_total_1": 9391.76,
    "override_increase_1": 259.13
  },
  {
    "#": "9 Colbourne Cres, Unit 1 (219-04-01)",
    "$": 1301100,
    "address": "9 Colbourne Cres, Unit 1",
    "parcel_id": "219-04-01",
    "owner1": "LAUMANN, CHRISTOPHER RICHARD",
    "owner2": "CHANDRAN, ANUSHYA",
    "current_taxes": 13323.26,
    "new_taxes_no_override": 13898.82,
    "override_total_1": 14293.19,
    "override_increase_1": 394.37
  },
  {
    "#": "9 Colbourne Cres, Unit 2 (219-04-02)",
    "$": 1506900,
    "address": "9 Colbourne Cres, Unit 2",
    "parcel_id": "219-04-02",
    "owner1": "SINGLETON, KRISTAN",
    "owner2": "ZIERTEN, STEPHANIE MARIE",
    "current_taxes": 11795.72,
    "new_taxes_no_override": 12305.3,
    "override_total_1": 12654.45,
    "override_increase_1": 349.15
  },
  {
    "#": "11 Colbourne Cres, Unit 1 (219-05-01)",
    "$": 1116700,
    "address": "11 Colbourne Cres, Unit 1",
    "parcel_id": "219-05-01",
    "owner1": "NUDELMAN, TODD",
    "owner2": "SOLOMON, AMY",
    "current_taxes": 11435.01,
    "new_taxes_no_override": 11929.0,
    "override_total_1": 12267.48,
    "override_increase_1": 338.48
  },
  {
    "#": "11 Colbourne Cres, Unit 2 (219-05-02)",
    "$": 809200,
    "address": "11 Colbourne Cres, Unit 2",
    "parcel_id": "219-05-02",
    "owner1": "BOLFEK, ANELA",
    "owner2": "",
    "current_taxes": 8286.21,
    "new_taxes_no_override": 8644.17,
    "override_total_1": 8889.45,
    "override_increase_1": 245.27
  },
  {
    "#": "11 Colbourne Cres, Unit 3 (219-05-03)",
    "$": 812000,
    "address": "11 Colbourne Cres, Unit 3",
    "parcel_id": "219-05-03",
    "owner1": "MA, TIANLE",
    "owner2": "",
    "current_taxes": 4679.95,
    "new_taxes_no_override": 4882.12,
    "override_total_1": 5020.65,
    "override_increase_1": 138.53
  },
  {
    "#": "12 Colbourne Cres, Unit 1 & P1 (218-25-03)",
    "$": 906700,
    "address": "12 Colbourne Cres, Unit 1 & P1",
    "parcel_id": "218-25-03",
    "owner1": "CUI, QI",
    "owner2": "",
    "current_taxes": 5649.67,
    "new_taxes_no_override": 5893.74,
    "override_total_1": 6060.97,
    "override_increase_1": 167.23
  },
  {
    "#": "12 Colbourne Cres, Unit 2 (218-25-01)",
    "$": 1030200,
    "address": "12 Colbourne Cres, Unit 2",
    "parcel_id": "218-25-01",
    "owner1": "NAJAVITS, LISA M",
    "owner2": "",
    "current_taxes": 10549.25,
    "new_taxes_no_override": 11004.98,
    "override_total_1": 11317.24,
    "override_increase_1": 312.26
  },
  {
    "#": "12 Colbourne Cres, Unit 3 & P4 (218-25-02)",
    "$": 892500,
    "address": "12 Colbourne Cres, Unit 3 & P4",
    "parcel_id": "218-25-02",
    "owner1": "KALAVRI, VASILIKI",
    "owner2": "LIAGOURIS, IOANNIS",
    "current_taxes": 5504.27,
    "new_taxes_no_override": 5742.05,
    "override_total_1": 5904.98,
    "override_increase_1": 162.93
  },
  {
    "#": "14 Colbourne Cres, Unit 1 (218-24-03)",
    "$": 857600,
    "address": "14 Colbourne Cres, Unit 1",
    "parcel_id": "218-24-03",
    "owner1": "ROTA, MARYELLEN",
    "owner2": "",
    "current_taxes": 8781.82,
    "new_taxes_no_override": 9161.19,
    "override_total_1": 9421.14,
    "override_increase_1": 259.94
  },
  {
    "#": "14 Colbourne Cres, Unit 2 (218-24-01)",
    "$": 864800,
    "address": "14 Colbourne Cres, Unit 2",
    "parcel_id": "218-24-01",
    "owner1": "WIETHOFF, ANDREA J",
    "owner2": "",
    "current_taxes": 5220.62,
    "new_taxes_no_override": 5446.15,
    "override_total_1": 5600.68,
    "override_increase_1": 154.53
  },
  {
    "#": "14 Colbourne Cres, Unit 3 & P-B (218-24-02)",
    "$": 839600,
    "address": "14 Colbourne Cres, Unit 3 & P-B",
    "parcel_id": "218-24-02",
    "owner1": "PEARSON, MARGARET W",
    "owner2": "",
    "current_taxes": 4962.57,
    "new_taxes_no_override": 5176.95,
    "override_total_1": 5323.85,
    "override_increase_1": 146.89
  },
  {
    "#": "15 Colbourne Cres, Unit 1 (219-06-01)",
    "$": 1365500,
    "address": "15 Colbourne Cres, Unit 1",
    "parcel_id": "219-06-01",
    "owner1": "KIM, MICHAEL",
    "owner2": "",
    "current_taxes": 10347.79,
    "new_taxes_no_override": 10794.81,
    "override_total_1": 11101.11,
    "override_increase_1": 306.29
  },
  {
    "#": "15 Colbourne Cres, Unit 2 (219-06-02)",
    "$": 704000,
    "address": "15 Colbourne Cres, Unit 2",
    "parcel_id": "219-06-02",
    "owner1": "CHALLAPALLI TRS, RAM M & SRIDEVI",
    "owner2": "",
    "current_taxes": 7208.96,
    "new_taxes_no_override": 7520.39,
    "override_total_1": 7733.77,
    "override_increase_1": 213.39
  },
  {
    "#": "15 Colbourne Cres, Unit 3 (219-06-03)",
    "$": 802500,
    "address": "15 Colbourne Cres, Unit 3",
    "parcel_id": "219-06-03",
    "owner1": "SAHOO TRS, AMARESHA P",
    "owner2": "JUNEJA, PRIYANKA",
    "current_taxes": 8217.6,
    "new_taxes_no_override": 8572.6,
    "override_total_1": 8815.84,
    "override_increase_1": 243.24
  },
  {
    "#": "18 Colbourne Cres (218-23-00)",
    "$": 2303300,
    "address": "18 Colbourne Cres",
    "parcel_id": "218-23-00",
    "owner1": "BACKENROTH-MAAYAN, REBECCA",
    "owner2": "",
    "current_taxes": 23585.79,
    "new_taxes_no_override": 24604.7,
    "override_total_1": 25302.84,
    "override_increase_1": 698.14
  },
  {
    "#": "21 Colbourne Cres, Unit 1 (219-07-01)",
    "$": 1657300,
    "address": "21 Colbourne Cres, Unit 1",
    "parcel_id": "219-07-01",
    "owner1": "BERGER, ALIZA",
    "owner2": "ROSENBERG, SOLOMON",
    "current_taxes": 16970.75,
    "new_taxes_no_override": 17703.89,
    "override_total_1": 18206.22,
    "override_increase_1": 502.33
  },
  {
    "#": "21 Colbourne Cres, Unit 2 (219-07-02)",
    "$": 1886900,
    "address": "21 Colbourne Cres, Unit 2",
    "parcel_id": "219-07-02",
    "owner1": "BEN ASHER, NOAM",
    "owner2": "GERSHON, PNINA",
    "current_taxes": 19321.86,
    "new_taxes_no_override": 20156.56,
    "override_total_1": 20728.49,
    "override_increase_1": 571.93
  },
  {
    "#": "22 Colbourne Cres, Unit 1 (218-22-01)",
    "$": 2034700,
    "address": "22 Colbourne Cres, Unit 1",
    "parcel_id": "218-22-01",
    "owner1": "CERAJ, IVICA & VANJA KLEPAC",
    "owner2": "",
    "current_taxes": 17200.39,
    "new_taxes_no_override": 17943.45,
    "override_total_1": 18452.58,
    "override_increase_1": 509.13
  },
  {
    "#": "22 Colbourne Cres, Unit 2 (218-22-02)",
    "$": 2515300,
    "address": "22 Colbourne Cres, Unit 2",
    "parcel_id": "218-22-02",
    "owner1": "JENNINGS TR, ANNE E",
    "owner2": "",
    "current_taxes": 25756.67,
    "new_taxes_no_override": 26869.36,
    "override_total_1": 27631.76,
    "override_increase_1": 762.4
  },
  {
    "#": "26 Colbourne Cres, Unit 26 (218-21-01)",
    "$": 3575800,
    "address": "26 Colbourne Cres, Unit 26",
    "parcel_id": "218-21-01",
    "owner1": "EDELMAN TRS, ALAN S",
    "owner2": "HADEN, SUSAN T",
    "current_taxes": 36616.19,
    "new_taxes_no_override": 38198.01,
    "override_total_1": 39281.85,
    "override_increase_1": 1083.84
  },
  {
    "#": "26 Colbourne Cres, Unit 28 (218-21-02)",
    "$": 3870800,
    "address": "26 Colbourne Cres, Unit 28",
    "parcel_id": "218-21-02",
    "owner1": "WEILERSTEIN, VIVIAN H & DONALD L",
    "owner2": "",
    "current_taxes": 39636.99,
    "new_taxes_no_override": 41349.31,
    "override_total_1": 42522.56,
    "override_increase_1": 1173.25
  },
  {
    "#": "29 Colbourne Cres (219-08-00)",
    "$": 3210100,
    "address": "29 Colbourne Cres",
    "parcel_id": "219-08-00",
    "owner1": "BILLMAN, DOUGLAS",
    "owner2": "MANDES, ZOE",
    "current_taxes": 29236.49,
    "new_taxes_no_override": 30499.51,
    "override_total_1": 31364.91,
    "override_increase_1": 865.4
  },
  {
    "#": "32 Colbourne Cres (218-20-00)",
    "$": 2568100,
    "address": "32 Colbourne Cres",
    "parcel_id": "218-20-00",
    "owner1": "STOYANOV, IVAN D",
    "owner2": "NIKOLOVA, MARIANA M",
    "current_taxes": 26297.34,
    "new_taxes_no_override": 27433.39,
    "override_total_1": 28211.79,
    "override_increase_1": 778.4
  },
  {
    "#": "34 Colbourne Cres (218-19-00)",
    "$": 2714000,
    "address": "34 Colbourne Cres",
    "parcel_id": "218-19-00",
    "owner1": "OLAUGHLIN, KEVIN A",
    "owner2": "",
    "current_taxes": 24156.43,
    "new_taxes_no_override": 25199.99,
    "override_total_1": 25915.02,
    "override_increase_1": 715.03
  },
  {
    "#": "36 Colbourne Cres (218-18-00)",
    "$": 3102300,
    "address": "36 Colbourne Cres",
    "parcel_id": "218-18-00",
    "owner1": "36 COLBOURNE CRESCENT LLC",
    "owner2": "",
    "current_taxes": 31767.55,
    "new_taxes_no_override": 33139.91,
    "override_total_1": 34080.23,
    "override_increase_1": 940.32
  },
  {
    "#": "37 Colbourne Cres (219-09-00)",
    "$": 3729300,
    "address": "37 Colbourne Cres",
    "parcel_id": "219-09-00",
    "owner1": "SHAKHNOVICH, BORIS",
    "owner2": "HO-SUI, SHANNAN J",
    "current_taxes": 38188.03,
    "new_taxes_no_override": 39837.75,
    "override_total_1": 40968.12,
    "override_increase_1": 1130.37
  },
  {
    "#": "51 Colbourne Cres (219-10-00)",
    "$": 3470700,
    "address": "51 Colbourne Cres",
    "parcel_id": "219-10-00",
    "owner1": "SHUSHAN, DAVID & JAMIE HORR",
    "owner2": "",
    "current_taxes": 31905.03,
    "new_taxes_no_override": 33283.33,
    "override_total_1": 34227.72,
    "override_increase_1": 944.39
  },
  {
    "#": "56 Colbourne Cres (218-28-00)",
    "$": 2181200,
    "address": "56 Colbourne Cres",
    "parcel_id": "218-28-00",
    "owner1": "LEIMAN, SHERI",
    "owner2": "GARBER, JEFFERY",
    "current_taxes": 22335.49,
    "new_taxes_no_override": 23300.38,
    "override_total_1": 23961.51,
    "override_increase_1": 661.13
  },
  {
    "#": "61 Colbourne Cres (219-11-00)",
    "$": 2275800,
    "address": "61 Colbourne Cres",
    "parcel_id": "219-11-00",
    "owner1": "YETMAN TRS, NANCY C",
    "owner2": "C/O RYAN, LLC",
    "current_taxes": 23304.19,
    "new_taxes_no_override": 24310.93,
    "override_total_1": 25000.74,
    "override_increase_1": 689.8
  },
  {
    "#": "64 Colbourne Cres (218-30-00)",
    "$": 2902800,
    "address": "64 Colbourne Cres",
    "parcel_id": "218-30-00",
    "owner1": "GARBER, JEFFREY R",
    "owner2": "LEIMAN, SHERI",
    "current_taxes": 26089.74,
    "new_taxes_no_override": 27216.82,
    "override_total_1": 27989.07,
    "override_increase_1": 772.26
  },
  {
    "#": "65 Colbourne Cres (219-12-00)",
    "$": 2812000,
    "address": "65 Colbourne Cres",
    "parcel_id": "219-12-00",
    "owner1": "GUTH, SUSAN B T",
    "owner2": "",
    "current_taxes": 25159.95,
    "new_taxes_no_override": 26246.86,
    "override_total_1": 26991.59,
    "override_increase_1": 744.73
  },
  {
    "#": "72 Colbourne Cres (218-26-00)",
    "$": 3443300,
    "address": "72 Colbourne Cres",
    "parcel_id": "218-26-00",
    "owner1": "WEINER TR, MIRIAM",
    "owner2": "",
    "current_taxes": 31624.46,
    "new_taxes_no_override": 32990.64,
    "override_total_1": 33926.72,
    "override_increase_1": 936.08
  },
  {
    "#": "86 Colbourne Cres (218-32-00)",
    "$": 2224300,
    "address": "86 Colbourne Cres",
    "parcel_id": "218-32-00",
    "owner1": "SULLIVAN, BRIGID W",
    "owner2": "",
    "current_taxes": 22776.83,
    "new_taxes_no_override": 23760.79,
    "override_total_1": 24434.98,
    "override_increase_1": 674.19
  },
  {
    "#": "93 Colbourne Cres (220-41-00)",
    "$": 2922100,
    "address": "93 Colbourne Cres",
    "parcel_id": "220-41-00",
    "owner1": "BAUER, SILAS & ANDREA",
    "owner2": "",
    "current_taxes": 26287.37,
    "new_taxes_no_override": 27422.98,
    "override_total_1": 28201.09,
    "override_increase_1": 778.11
  },
  {
    "#": "99 Colbourne Cres (220-42-00)",
    "$": 2085200,
    "address": "99 Colbourne Cres",
    "parcel_id": "220-42-00",
    "owner1": "MANARAS, JOHN T & SUSAN Y",
    "owner2": "",
    "current_taxes": 17717.51,
    "new_taxes_no_override": 18482.91,
    "override_total_1": 19007.34,
    "override_increase_1": 524.44
  },
  {
    "#": "100 Colbourne Cres (218-16-01)",
    "$": 2452400,
    "address": "100 Colbourne Cres",
    "parcel_id": "218-16-01",
    "owner1": "FONG, TAMARA G",
    "owner2": "HENDERSON, JOEL M",
    "current_taxes": 21477.64,
    "new_taxes_no_override": 22405.47,
    "override_total_1": 23041.21,
    "override_increase_1": 635.74
  },
  {
    "#": "103 Colbourne Cres (220-43-00)",
    "$": 2305100,
    "address": "103 Colbourne Cres",
    "parcel_id": "220-43-00",
    "owner1": "ADLER TR, AARON M",
    "owner2": "",
    "current_taxes": 23604.22,
    "new_taxes_no_override": 24623.92,
    "override_total_1": 25322.61,
    "override_increase_1": 698.68
  },
  {
    "#": "106 Colbourne Cres (218-17-00)",
    "$": 2629500,
    "address": "106 Colbourne Cres",
    "parcel_id": "218-17-00",
    "owner1": "WAHI, MADHU",
    "owner2": "MOAZED, DANESH",
    "current_taxes": 23291.15,
    "new_taxes_no_override": 24297.33,
    "override_total_1": 24986.75,
    "override_increase_1": 689.42
  },
  {
    "#": "107 Colbourne Cres (220-44-00)",
    "$": 2623000,
    "address": "107 Colbourne Cres",
    "parcel_id": "220-44-00",
    "owner1": "KRAUSE, DIANE E",
    "owner2": "HAGAN, CRAIG I",
    "current_taxes": 23224.59,
    "new_taxes_no_override": 24227.89,
    "override_total_1": 24915.34,
    "override_increase_1": 687.45
  },
  {
    "#": "113 Colbourne Cres (220-44-01)",
    "$": 3308000,
    "address": "113 Colbourne Cres",
    "parcel_id": "220-44-01",
    "owner1": "REES TRS, MICHAEL K & SUSAN S",
    "owner2": "ADAM S & JONATHAN",
    "current_taxes": 30238.99,
    "new_taxes_no_override": 31545.31,
    "override_total_1": 32440.39,
    "override_increase_1": 895.07
  },
  {
    "#": "121 Colbourne Cres (220-45-00)",
    "$": 3177500,
    "address": "121 Colbourne Cres",
    "parcel_id": "220-45-00",
    "owner1": "PARADISE, JOSHUA",
    "owner2": "KOGAN, MARIA",
    "current_taxes": 28902.67,
    "new_taxes_no_override": 30151.27,
    "override_total_1": 31006.78,
    "override_increase_1": 855.52
  },
  {
    "#": "6 Colchester St (115A-01-00)",
    "$": 91000,
    "address": "6 Colchester St",
    "parcel_id": "115A-01-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O RIVERWAY",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "7 Colchester St (115-03-00)",
    "$": 6956900,
    "address": "7 Colchester St",
    "parcel_id": "115-03-00",
    "owner1": "7 COLCHESTER LLC",
    "owner2": "",
    "current_taxes": 71238.66,
    "new_taxes_no_override": 74316.17,
    "override_total_1": 76424.83,
    "override_increase_1": 2108.66
  },
  {
    "#": "19 Colchester St (115-04-00)",
    "$": 8168800,
    "address": "19 Colchester St",
    "parcel_id": "115-04-00",
    "owner1": "RDF CORPORATION",
    "owner2": "C/O NARESH PURI",
    "current_taxes": 83648.51,
    "new_taxes_no_override": 87262.13,
    "override_total_1": 89738.12,
    "override_increase_1": 2476.0
  },
  {
    "#": "25 Colchester St (115-05-02)",
    "$": 4115900,
    "address": "25 Colchester St",
    "parcel_id": "115-05-02",
    "owner1": "FROST TR, RICHARD VH",
    "owner2": "",
    "current_taxes": 38511.88,
    "new_taxes_no_override": 40175.59,
    "override_total_1": 41315.54,
    "override_increase_1": 1139.95
  },
  {
    "#": "27 Colchester St (115-05-03)",
    "$": 4694600,
    "address": "27 Colchester St",
    "parcel_id": "115-05-03",
    "owner1": "MADIGAN, AINE & DAVID",
    "owner2": "",
    "current_taxes": 44437.77,
    "new_taxes_no_override": 46357.48,
    "override_total_1": 47672.84,
    "override_increase_1": 1315.36
  },
  {
    "#": "29 Colchester St (115-05-04)",
    "$": 3799700,
    "address": "29 Colchester St",
    "parcel_id": "115-05-04",
    "owner1": "PFEFFER, MARC A",
    "owner2": "BOWLER, MARIANNE B",
    "current_taxes": 38908.93,
    "new_taxes_no_override": 40589.8,
    "override_total_1": 41741.5,
    "override_increase_1": 1151.7
  },
  {
    "#": "60 Colchester St (121-05-00)",
    "$": 7827700,
    "address": "60 Colchester St",
    "parcel_id": "121-05-00",
    "owner1": "CHRIST CHURCH LONGWOOD TRUST",
    "owner2": "C/O STEPHEN T SEARS, TRS",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "67 Colchester St (120-02-00)",
    "$": 3617700,
    "address": "67 Colchester St",
    "parcel_id": "120-02-00",
    "owner1": "GELLER LIFE ESTATE, MAX",
    "owner2": "",
    "current_taxes": 33410.31,
    "new_taxes_no_override": 34853.64,
    "override_total_1": 35842.58,
    "override_increase_1": 988.95
  },
  {
    "#": "71 Colchester St (120-03-00)",
    "$": 2880200,
    "address": "71 Colchester St",
    "parcel_id": "120-03-00",
    "owner1": "LEBOW TRS, FREDERICK S",
    "owner2": "KALAN, KATHRYN L",
    "current_taxes": 25858.31,
    "new_taxes_no_override": 26975.39,
    "override_total_1": 27740.79,
    "override_increase_1": 765.41
  },
  {
    "#": "77 Colchester St (120-04-00)",
    "$": 5384000,
    "address": "77 Colchester St",
    "parcel_id": "120-04-00",
    "owner1": "DABORA, EMIL M",
    "owner2": "NAKAYAMA, EMILIE",
    "current_taxes": 51497.23,
    "new_taxes_no_override": 53721.91,
    "override_total_1": 55246.23,
    "override_increase_1": 1524.32
  },
  {
    "#": "87 Colchester St (120-05-00)",
    "$": 4156100,
    "address": "87 Colchester St",
    "parcel_id": "120-05-00",
    "owner1": "GOLDMAN TR, RACHEL K",
    "owner2": "",
    "current_taxes": 38923.53,
    "new_taxes_no_override": 40605.03,
    "override_total_1": 41757.16,
    "override_increase_1": 1152.14
  },
  {
    "#": "99 Colchester St (120-06-00)",
    "$": 3124200,
    "address": "99 Colchester St",
    "parcel_id": "120-06-00",
    "owner1": "HARLEV, DORON & SHAYLA KASUTO",
    "owner2": "",
    "current_taxes": 28356.87,
    "new_taxes_no_override": 29581.89,
    "override_total_1": 30421.25,
    "override_increase_1": 839.36
  },
  {
    "#": "101 Colchester St (120-07-00)",
    "$": 2732000,
    "address": "101 Colchester St",
    "parcel_id": "120-07-00",
    "owner1": "RENZ, PETER",
    "owner2": "WILEY, HEATHER",
    "current_taxes": 24340.75,
    "new_taxes_no_override": 25392.27,
    "override_total_1": 26112.76,
    "override_increase_1": 720.49
  },
  {
    "#": "103 Colchester St (120-08-00)",
    "$": 3370800,
    "address": "103 Colchester St",
    "parcel_id": "120-08-00",
    "owner1": "WRIGHT, JAMES A III & MELISSA SCHWAB",
    "owner2": "",
    "current_taxes": 30882.06,
    "new_taxes_no_override": 32216.16,
    "override_total_1": 33130.27,
    "override_increase_1": 914.11
  },
  {
    "#": "105 Colchester St (120-09-00)",
    "$": 2600100,
    "address": "105 Colchester St",
    "parcel_id": "120-09-00",
    "owner1": "ROBBINS, MICHAEL",
    "owner2": "",
    "current_taxes": 22990.09,
    "new_taxes_no_override": 23983.26,
    "override_total_1": 24663.77,
    "override_increase_1": 680.51
  },
  {
    "#": "116 Colchester St (121-03-00)",
    "$": 3565400,
    "address": "116 Colchester St",
    "parcel_id": "121-03-00",
    "owner1": "JEWISH HEALTH ORGANIZATION INC",
    "owner2": "",
    "current_taxes": 36509.7,
    "new_taxes_no_override": 38086.92,
    "override_total_1": 39167.61,
    "override_increase_1": 1080.69
  },
  {
    "#": "119 Colchester St (120-10-00)",
    "$": 3571000,
    "address": "119 Colchester St",
    "parcel_id": "120-10-00",
    "owner1": "JEWISH HEALTH ORGANIZATION INC",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "9 Columbia St, Unit 2 (074-02-02)",
    "$": 1353300,
    "address": "9 Columbia St, Unit 2",
    "parcel_id": "074-02-02",
    "owner1": "ZIEBER, RAZ & NOGA",
    "owner2": "",
    "current_taxes": 10222.86,
    "new_taxes_no_override": 10664.49,
    "override_total_1": 10967.08,
    "override_increase_1": 302.6
  },
  {
    "#": "11 Columbia St, Unit 1 (074-02-01)",
    "$": 1019800,
    "address": "11 Columbia St, Unit 1",
    "parcel_id": "074-02-01",
    "owner1": "MURPHY, MARGARET K",
    "owner2": "PATSOPOULOS, NIKOLAOS",
    "current_taxes": 6807.82,
    "new_taxes_no_override": 7101.92,
    "override_total_1": 7303.43,
    "override_increase_1": 201.51
  },
  {
    "#": "12 Columbia St (075-66-00)",
    "$": 1916100,
    "address": "12 Columbia St",
    "parcel_id": "075-66-00",
    "owner1": "FISCH, MARCIA E",
    "owner2": "",
    "current_taxes": 15985.93,
    "new_taxes_no_override": 16676.52,
    "override_total_1": 17149.71,
    "override_increase_1": 473.18
  },
  {
    "#": "15 Columbia St (074-03-00)",
    "$": 3220400,
    "address": "15 Columbia St",
    "parcel_id": "074-03-00",
    "owner1": "WINGERTER TR, JULIE RENEE",
    "owner2": "LIEBERMAN TR, SETH WILLIAM",
    "current_taxes": 29341.96,
    "new_taxes_no_override": 30609.53,
    "override_total_1": 31478.05,
    "override_increase_1": 868.52
  },
  {
    "#": "16 Columbia St (075-65-00)",
    "$": 1982300,
    "address": "16 Columbia St",
    "parcel_id": "075-65-00",
    "owner1": "VANDERKAY, JUDITH A",
    "owner2": "",
    "current_taxes": 16663.82,
    "new_taxes_no_override": 17383.7,
    "override_total_1": 17876.95,
    "override_increase_1": 493.25
  },
  {
    "#": "19 Columbia St (074-04-00)",
    "$": 2674300,
    "address": "19 Columbia St",
    "parcel_id": "074-04-00",
    "owner1": "LIN, BRIAN M",
    "owner2": "ANDRES-MATEOS, EVA",
    "current_taxes": 23749.9,
    "new_taxes_no_override": 24775.9,
    "override_total_1": 25478.89,
    "override_increase_1": 703.0
  },
  {
    "#": "22 Columbia St (075-64-00)",
    "$": 2912800,
    "address": "22 Columbia St",
    "parcel_id": "075-64-00",
    "owner1": "SILBEY, JESSICA",
    "owner2": "DRESSER, KEITH",
    "current_taxes": 26192.14,
    "new_taxes_no_override": 27323.64,
    "override_total_1": 28098.93,
    "override_increase_1": 775.29
  },
  {
    "#": "25 Columbia St (074-05-00)",
    "$": 2594100,
    "address": "25 Columbia St",
    "parcel_id": "074-05-00",
    "owner1": "KATZ TRS, NATHAN",
    "owner2": "KATZ-JOTKOWITZ, TOVA E",
    "current_taxes": 22928.65,
    "new_taxes_no_override": 23919.17,
    "override_total_1": 24597.86,
    "override_increase_1": 678.69
  },
  {
    "#": "26 Columbia St (075-63-00)",
    "$": 2613400,
    "address": "26 Columbia St",
    "parcel_id": "075-63-00",
    "owner1": "KOLODNER, ANNA",
    "owner2": "GOLD, MONTY E",
    "current_taxes": 23126.28,
    "new_taxes_no_override": 24125.34,
    "override_total_1": 24809.87,
    "override_increase_1": 684.54
  },
  {
    "#": "29 Columbia St, Unit A (074-06-03)",
    "$": 3048000,
    "address": "29 Columbia St, Unit A",
    "parcel_id": "074-06-03",
    "owner1": "KATZ, PAMELA C & STEVEN R",
    "owner2": "",
    "current_taxes": 27576.59,
    "new_taxes_no_override": 28767.9,
    "override_total_1": 29584.17,
    "override_increase_1": 816.27
  },
  {
    "#": "30 Columbia St, Unit 2 & G-3 (075-62-01)",
    "$": 950800,
    "address": "30 Columbia St, Unit 2 & G-3",
    "parcel_id": "075-62-01",
    "owner1": "SINGH, RAJANI",
    "owner2": "",
    "current_taxes": 6101.26,
    "new_taxes_no_override": 6364.83,
    "override_total_1": 6545.43,
    "override_increase_1": 180.6
  },
  {
    "#": "30 Columbia St, Unit 3 & G4 (075-62-02)",
    "$": 877700,
    "address": "30 Columbia St, Unit 3 & G4",
    "parcel_id": "075-62-02",
    "owner1": "URBIN REYES, ANA",
    "owner2": "",
    "current_taxes": 5352.71,
    "new_taxes_no_override": 5583.95,
    "override_total_1": 5742.39,
    "override_increase_1": 158.44
  },
  {
    "#": "32 Columbia St, Unit 1 & P-1-2 (075-62-03)",
    "$": 1732000,
    "address": "32 Columbia St, Unit 1 & P-1-2",
    "parcel_id": "075-62-03",
    "owner1": "SAVOS TRS, CHRISTOPHER & ELISSA",
    "owner2": "",
    "current_taxes": 14100.75,
    "new_taxes_no_override": 14709.9,
    "override_total_1": 15127.28,
    "override_increase_1": 417.38
  },
  {
    "#": "33 Columbia St (074-07-00)",
    "$": 2693800,
    "address": "33 Columbia St",
    "parcel_id": "074-07-00",
    "owner1": "DANZIGER TRS, JOHN",
    "owner2": "REINHARDT , EMMA",
    "current_taxes": 23949.58,
    "new_taxes_no_override": 24984.2,
    "override_total_1": 25693.11,
    "override_increase_1": 708.91
  },
  {
    "#": "36 Columbia St (075-61-00)",
    "$": 2302600,
    "address": "36 Columbia St",
    "parcel_id": "075-61-00",
    "owner1": "REJMAN, TRS, ZEV",
    "owner2": "LEOPOLD, DORA",
    "current_taxes": 19943.69,
    "new_taxes_no_override": 20805.26,
    "override_total_1": 21395.59,
    "override_increase_1": 590.33
  },
  {
    "#": "39 Columbia St, Unit 1 (074-08-01)",
    "$": 1828200,
    "address": "39 Columbia St, Unit 1",
    "parcel_id": "074-08-01",
    "owner1": "FAIBER, NEIL & LEORA",
    "owner2": "",
    "current_taxes": 15085.83,
    "new_taxes_no_override": 15737.54,
    "override_total_1": 16184.08,
    "override_increase_1": 446.54
  },
  {
    "#": "39 Columbia St, Unit 2 (074-08-02)",
    "$": 2131000,
    "address": "39 Columbia St, Unit 2",
    "parcel_id": "074-08-02",
    "owner1": "SHERMAN, JONATHAN A S",
    "owner2": "WOON, LISA M",
    "current_taxes": 18186.51,
    "new_taxes_no_override": 18972.17,
    "override_total_1": 19510.49,
    "override_increase_1": 538.32
  },
  {
    "#": "40 Columbia St (075-60-00)",
    "$": 1950400,
    "address": "40 Columbia St",
    "parcel_id": "075-60-00",
    "owner1": "BLOOMSTEIN, JUDITH",
    "owner2": "",
    "current_taxes": 16337.16,
    "new_taxes_no_override": 17042.93,
    "override_total_1": 17526.51,
    "override_increase_1": 483.58
  },
  {
    "#": "45 Columbia St (074-09-00)",
    "$": 3069800,
    "address": "45 Columbia St",
    "parcel_id": "074-09-00",
    "owner1": "EISEN-CUADRA, ALEX",
    "owner2": "ARCAYA, MARIANA",
    "current_taxes": 27799.82,
    "new_taxes_no_override": 29000.77,
    "override_total_1": 29823.65,
    "override_increase_1": 822.87
  },
  {
    "#": "46 Columbia St (075-59-00)",
    "$": 2315500,
    "address": "46 Columbia St",
    "parcel_id": "075-59-00",
    "owner1": "HOUSMAN, ROBERT E & SUE T",
    "owner2": "",
    "current_taxes": 20075.79,
    "new_taxes_no_override": 20943.06,
    "override_total_1": 21537.31,
    "override_increase_1": 594.24
  },
  {
    "#": "50 Columbia St (075-58-03)",
    "$": 2939000,
    "address": "50 Columbia St",
    "parcel_id": "075-58-03",
    "owner1": "RABINOVICH, AKIVA",
    "owner2": "SHMOLAK, BLUMIT",
    "current_taxes": 26460.43,
    "new_taxes_no_override": 27603.52,
    "override_total_1": 28386.75,
    "override_increase_1": 783.23
  },
  {
    "#": "51 Columbia St (074-10-00)",
    "$": 2671100,
    "address": "51 Columbia St",
    "parcel_id": "074-10-00",
    "owner1": "ABER TRS, CYNTHIA S & JOHN W",
    "owner2": "",
    "current_taxes": 23717.13,
    "new_taxes_no_override": 24741.71,
    "override_total_1": 25443.74,
    "override_increase_1": 702.03
  },
  {
    "#": "60 Columbia St (075-55-00)",
    "$": 2486200,
    "address": "60 Columbia St",
    "parcel_id": "075-55-00",
    "owner1": "ROSENTHAL, MARTIN",
    "owner2": "NEWMAN, JODY L",
    "current_taxes": 21823.75,
    "new_taxes_no_override": 22766.54,
    "override_total_1": 23412.52,
    "override_increase_1": 645.98
  },
  {
    "#": "61 Columbia St, Unit 1 (074-11-01)",
    "$": 1278800,
    "address": "61 Columbia St, Unit 1",
    "parcel_id": "074-11-01",
    "owner1": "FANNING, MATTHEW & EMILY GEAMAN",
    "owner2": "",
    "current_taxes": 9459.98,
    "new_taxes_no_override": 9868.65,
    "override_total_1": 10148.67,
    "override_increase_1": 280.02
  },
  {
    "#": "61 Columbia St, Unit 2 (074-11-02)",
    "$": 1401600,
    "address": "61 Columbia St, Unit 2",
    "parcel_id": "074-11-02",
    "owner1": "SAMPLE, SCOTT & LAURA",
    "owner2": "",
    "current_taxes": 10717.45,
    "new_taxes_no_override": 11180.44,
    "override_total_1": 11497.68,
    "override_increase_1": 317.24
  },
  {
    "#": "66 Columbia St, Unit 1 (075-54-01)",
    "$": 1390500,
    "address": "66 Columbia St, Unit 1",
    "parcel_id": "075-54-01",
    "owner1": "FELDMAN, BENJAMIN H & JANNA D",
    "owner2": "",
    "current_taxes": 14238.72,
    "new_taxes_no_override": 14853.83,
    "override_total_1": 15275.3,
    "override_increase_1": 421.47
  },
  {
    "#": "66 Columbia St, Unit 2 (075-54-02)",
    "$": 1613200,
    "address": "66 Columbia St, Unit 2",
    "parcel_id": "075-54-02",
    "owner1": "ALLEN, BREE",
    "owner2": "WILLIAMSON, SARAH",
    "current_taxes": 16519.17,
    "new_taxes_no_override": 17232.8,
    "override_total_1": 17721.77,
    "override_increase_1": 488.97
  },
  {
    "#": "70 Columbia St, Unit 1 (075-53-01)",
    "$": 2112500,
    "address": "70 Columbia St, Unit 1",
    "parcel_id": "075-53-01",
    "owner1": "HOUSMAN TR, MARK",
    "owner2": "",
    "current_taxes": 17997.07,
    "new_taxes_no_override": 18774.54,
    "override_total_1": 19307.26,
    "override_increase_1": 532.71
  },
  {
    "#": "70 Columbia St, Unit 2 (075-53-02)",
    "$": 2359400,
    "address": "70 Columbia St, Unit 2",
    "parcel_id": "075-53-02",
    "owner1": "SONNABEND, KIM",
    "owner2": "",
    "current_taxes": 20525.32,
    "new_taxes_no_override": 21412.01,
    "override_total_1": 22019.56,
    "override_increase_1": 607.55
  },
  {
    "#": "76 Columbia St (075-52-00)",
    "$": 2373600,
    "address": "76 Columbia St",
    "parcel_id": "075-52-00",
    "owner1": "VICTORIA, MARIA LUISA",
    "owner2": "",
    "current_taxes": 20670.73,
    "new_taxes_no_override": 21563.71,
    "override_total_1": 22175.56,
    "override_increase_1": 611.85
  },
  {
    "#": "80 Columbia St, Unit 1 (075-51-01)",
    "$": 2257600,
    "address": "80 Columbia St, Unit 1",
    "parcel_id": "075-51-01",
    "owner1": "ADLER TRS, IRIS S",
    "owner2": "TEICHMAN, SHERMAN M W",
    "current_taxes": 23117.82,
    "new_taxes_no_override": 24116.51,
    "override_total_1": 24800.8,
    "override_increase_1": 684.29
  },
  {
    "#": "80 Columbia St, Unit 2 (075-51-02)",
    "$": 2382200,
    "address": "80 Columbia St, Unit 2",
    "parcel_id": "075-51-02",
    "owner1": "ALTSCHULER, SARI BETH",
    "owner2": "",
    "current_taxes": 24393.73,
    "new_taxes_no_override": 25447.54,
    "override_total_1": 26169.59,
    "override_increase_1": 722.05
  },
  {
    "#": "88 Columbia St (075-50-00)",
    "$": 2775100,
    "address": "88 Columbia St",
    "parcel_id": "075-50-00",
    "owner1": "TARLIN, BETSY",
    "owner2": "",
    "current_taxes": 24782.09,
    "new_taxes_no_override": 25852.68,
    "override_total_1": 26586.23,
    "override_increase_1": 733.55
  },
  {
    "#": "89 Columbia St (073-11-00)",
    "$": 7497000,
    "address": "89 Columbia St",
    "parcel_id": "073-11-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O COOLIDGE PLAYGROUND",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "90 Columbia St, Unit 90 (075-49-01)",
    "$": 2624600,
    "address": "90 Columbia St, Unit 90",
    "parcel_id": "075-49-01",
    "owner1": "TALMOR, DANIEL & MAZAL",
    "owner2": "",
    "current_taxes": 23240.97,
    "new_taxes_no_override": 24244.98,
    "override_total_1": 24932.91,
    "override_increase_1": 687.93
  },
  {
    "#": "90 Columbia St, Unit 92 (075-49-02)",
    "$": 2621800,
    "address": "90 Columbia St, Unit 92",
    "parcel_id": "075-49-02",
    "owner1": "FISH, EDWARD T & NINA G",
    "owner2": "",
    "current_taxes": 23212.3,
    "new_taxes_no_override": 24215.07,
    "override_total_1": 24902.16,
    "override_increase_1": 687.08
  },
  {
    "#": "96 Columbia St (075-48-00)",
    "$": 3244000,
    "address": "96 Columbia St",
    "parcel_id": "075-48-00",
    "owner1": "SHULMAN TR, ENID L",
    "owner2": "",
    "current_taxes": 29583.63,
    "new_taxes_no_override": 30861.64,
    "override_total_1": 31737.32,
    "override_increase_1": 875.68
  },
  {
    "#": "100 Columbia St, Unit 1 (075-47-01)",
    "$": 1180200,
    "address": "100 Columbia St, Unit 1",
    "parcel_id": "075-47-01",
    "owner1": "FAHEY, SARAH C & LAWRENCE H",
    "owner2": "",
    "current_taxes": 8450.31,
    "new_taxes_no_override": 8815.36,
    "override_total_1": 9065.49,
    "override_increase_1": 250.13
  },
  {
    "#": "100 Columbia St, Unit 2 (075-47-02)",
    "$": 1436600,
    "address": "100 Columbia St, Unit 2",
    "parcel_id": "075-47-02",
    "owner1": "POKHAREL, ANURODH & JAMIE",
    "owner2": "",
    "current_taxes": 14710.78,
    "new_taxes_no_override": 15346.29,
    "override_total_1": 15781.72,
    "override_increase_1": 435.44
  },
  {
    "#": "104 Columbia St (075-46-00)",
    "$": 2099900,
    "address": "104 Columbia St",
    "parcel_id": "075-46-00",
    "owner1": "STEINER TRS, KENNETH",
    "owner2": "MCKAIN TRS, SUSAN",
    "current_taxes": 21502.98,
    "new_taxes_no_override": 22431.91,
    "override_total_1": 23068.4,
    "override_increase_1": 636.49
  },
  {
    "#": "108 Columbia St, Unit 1 (075-45-01)",
    "$": 1019300,
    "address": "108 Columbia St, Unit 1",
    "parcel_id": "075-45-01",
    "owner1": "KERRIGAN, DAVID & TERESA",
    "owner2": "",
    "current_taxes": 10437.63,
    "new_taxes_no_override": 10888.54,
    "override_total_1": 11197.49,
    "override_increase_1": 308.95
  },
  {
    "#": "108 Columbia St, Unit 2 (075-45-02)",
    "$": 1632300,
    "address": "108 Columbia St, Unit 2",
    "parcel_id": "075-45-02",
    "owner1": "REED, ANNIE",
    "owner2": "GRAY, PHILIP",
    "current_taxes": 13079.82,
    "new_taxes_no_override": 13644.87,
    "override_total_1": 14032.03,
    "override_increase_1": 387.16
  },
  {
    "#": "109 Columbia St (072-19-00)",
    "$": 2013800,
    "address": "109 Columbia St",
    "parcel_id": "072-19-00",
    "owner1": "MEYERS, DAVID L",
    "owner2": "TEJEDOR, CAROLINA",
    "current_taxes": 16986.38,
    "new_taxes_no_override": 17720.19,
    "override_total_1": 18222.99,
    "override_increase_1": 502.8
  },
  {
    "#": "112 Columbia St, Unit 1 & P-A-B (075-44-01)",
    "$": 1032000,
    "address": "112 Columbia St, Unit 1 & P-A-B",
    "parcel_id": "075-44-01",
    "owner1": "KOTLOV TRS, MARI",
    "owner2": "FINE, JONATHAN",
    "current_taxes": 6932.75,
    "new_taxes_no_override": 7232.24,
    "override_total_1": 7437.45,
    "override_increase_1": 205.21
  },
  {
    "#": "112 Columbia St, Unit 2 Pk C D (075-44-02)",
    "$": 1296400,
    "address": "112 Columbia St, Unit 2 Pk C D",
    "parcel_id": "075-44-02",
    "owner1": "LANDE, DIANE L",
    "owner2": "WEINTRAUB, ROBERT J",
    "current_taxes": 9640.2,
    "new_taxes_no_override": 10056.66,
    "override_total_1": 10342.01,
    "override_increase_1": 285.35
  },
  {
    "#": "116 Columbia St (075-43-00)",
    "$": 2549000,
    "address": "116 Columbia St",
    "parcel_id": "075-43-00",
    "owner1": "MMN LLC",
    "owner2": "",
    "current_taxes": 26101.76,
    "new_taxes_no_override": 27229.36,
    "override_total_1": 28001.97,
    "override_increase_1": 772.61
  },
  {
    "#": "120 Columbia St, Unit 1 (075-42-02)",
    "$": 1129100,
    "address": "120 Columbia St, Unit 1",
    "parcel_id": "075-42-02",
    "owner1": "LEWIS, CRAIG P",
    "owner2": "LILLEY, MEREDITH A",
    "current_taxes": 7927.05,
    "new_taxes_no_override": 8269.5,
    "override_total_1": 8504.14,
    "override_increase_1": 234.64
  },
  {
    "#": "120 Columbia St, Unit 2 (075-42-01)",
    "$": 1048000,
    "address": "120 Columbia St, Unit 2",
    "parcel_id": "075-42-01",
    "owner1": "BALDWIN TR, SYLVIA",
    "owner2": "",
    "current_taxes": 7096.59,
    "new_taxes_no_override": 7403.16,
    "override_total_1": 7613.22,
    "override_increase_1": 210.06
  },
  {
    "#": "124 Columbia St (075-41-00)",
    "$": 2229800,
    "address": "124 Columbia St",
    "parcel_id": "075-41-00",
    "owner1": "CHAN, YOK K",
    "owner2": "WAI, Y M",
    "current_taxes": 19198.22,
    "new_taxes_no_override": 20027.58,
    "override_total_1": 20595.85,
    "override_increase_1": 568.27
  },
  {
    "#": "128 Columbia St (075-40-00)",
    "$": 2120200,
    "address": "128 Columbia St",
    "parcel_id": "075-40-00",
    "owner1": "KO TRS, SHU YU & ADA TAK YUNG & ALBERT TAK WAH",
    "owner2": "",
    "current_taxes": 21710.85,
    "new_taxes_no_override": 22648.76,
    "override_total_1": 23291.4,
    "override_increase_1": 642.64
  },
  {
    "#": "132 Columbia St (075-39-00)",
    "$": 2419600,
    "address": "132 Columbia St",
    "parcel_id": "075-39-00",
    "owner1": "CHIN TR, CLAY",
    "owner2": "",
    "current_taxes": 21141.77,
    "new_taxes_no_override": 22055.09,
    "override_total_1": 22680.89,
    "override_increase_1": 625.8
  },
  {
    "#": "133 Columbia St (071-22-00)",
    "$": 2787900,
    "address": "133 Columbia St",
    "parcel_id": "071-22-00",
    "owner1": "SCHWARZ, IRINA",
    "owner2": "",
    "current_taxes": 24913.16,
    "new_taxes_no_override": 25989.41,
    "override_total_1": 26726.84,
    "override_increase_1": 737.43
  },
  {
    "#": "136 Columbia St (075-38-00)",
    "$": 2623600,
    "address": "136 Columbia St",
    "parcel_id": "075-38-00",
    "owner1": "YEUNG TRS, MAN & SHUET MUI",
    "owner2": "",
    "current_taxes": 23230.73,
    "new_taxes_no_override": 24234.3,
    "override_total_1": 24921.93,
    "override_increase_1": 687.63
  },
  {
    "#": "139 Columbia St (071-23-00)",
    "$": 2303700,
    "address": "139 Columbia St",
    "parcel_id": "071-23-00",
    "owner1": "DER, HARRY & JEFFREY",
    "owner2": "",
    "current_taxes": 19954.95,
    "new_taxes_no_override": 20817.0,
    "override_total_1": 21407.67,
    "override_increase_1": 590.67
  },
  {
    "#": "140 Columbia St (075-37-00)",
    "$": 2456900,
    "address": "140 Columbia St",
    "parcel_id": "075-37-00",
    "owner1": "BROOKLINE COLUMBIA 2FAM LLC",
    "owner2": "",
    "current_taxes": 25158.66,
    "new_taxes_no_override": 26245.51,
    "override_total_1": 26990.21,
    "override_increase_1": 744.7
  },
  {
    "#": "144 Columbia St (075-36-00)",
    "$": 2271700,
    "address": "144 Columbia St",
    "parcel_id": "075-36-00",
    "owner1": "ENG TR, PAUL",
    "owner2": "C/O ENG FAMILY LLC",
    "current_taxes": 23262.21,
    "new_taxes_no_override": 24267.14,
    "override_total_1": 24955.7,
    "override_increase_1": 688.56
  },
  {
    "#": "1 Columbia Ter (075-56-00)",
    "$": 2779600,
    "address": "1 Columbia Ter",
    "parcel_id": "075-56-00",
    "owner1": "WONG TRS, GENE L & DORIS Y K",
    "owner2": "",
    "current_taxes": 24828.17,
    "new_taxes_no_override": 25900.75,
    "override_total_1": 26635.66,
    "override_increase_1": 734.91
  },
  {
    "#": "7 Columbia Ter (075-57-00)",
    "$": 2681200,
    "address": "7 Columbia Ter",
    "parcel_id": "075-57-00",
    "owner1": "MARKS, BARBARA GOLD",
    "owner2": "",
    "current_taxes": 23820.55,
    "new_taxes_no_override": 24849.6,
    "override_total_1": 25554.69,
    "override_increase_1": 705.09
  },
  {
    "#": "730 Commonwealth Ave (007-05-09)",
    "$": 56994600,
    "address": "730 Commonwealth Ave",
    "parcel_id": "007-05-09",
    "owner1": "TRUSTEES OF BOSTON UNIVERSITY",
    "owner2": "",
    "current_taxes": 78242.53,
    "new_taxes_no_override": 81622.61,
    "override_total_1": 83938.59,
    "override_increase_1": 2315.98
  },
  {
    "#": "808 Commonwealth Ave (017-01-00)",
    "$": 57203200,
    "address": "808 Commonwealth Ave",
    "parcel_id": "017-01-00",
    "owner1": "BOSTON UNIVERSITY TRS",
    "owner2": "C/O GENERAL ACCOUNTING 4TH FLR",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "820 Commonwealth Ave (017-02-07)",
    "$": 59140800,
    "address": "820 Commonwealth Ave",
    "parcel_id": "017-02-07",
    "owner1": "BOSTON UNIVERSITY TRS",
    "owner2": "C/O GENERAL ACCOUNTING 4TH FLR",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "830 Commonwealth Ave (017-03-00)",
    "$": 7938500,
    "address": "830 Commonwealth Ave",
    "parcel_id": "017-03-00",
    "owner1": "BOSTON UNIVERSITY TRS",
    "owner2": "C/O GENERAL ACCOUNTING 4TH FLR",
    "current_taxes": 68112.33,
    "new_taxes_no_override": 71054.78,
    "override_total_1": 73070.91,
    "override_increase_1": 2016.12
  },
  {
    "#": "850 Commonwealth Ave (017-04-00)",
    "$": 3111600,
    "address": "850 Commonwealth Ave",
    "parcel_id": "017-04-00",
    "owner1": "HERAIKI, EMILE",
    "owner2": "",
    "current_taxes": 53395.06,
    "new_taxes_no_override": 55701.73,
    "override_total_1": 57282.22,
    "override_increase_1": 1580.49
  },
  {
    "#": "860 Commonwealth Ave (018-04-05)",
    "$": 20702200,
    "address": "860 Commonwealth Ave",
    "parcel_id": "018-04-05",
    "owner1": "GROSSMAN, BERNARD D & MORTON S",
    "owner2": "C/O THE GROSSMAN COMPANIES",
    "current_taxes": 355249.75,
    "new_taxes_no_override": 370596.54,
    "override_total_1": 381111.93,
    "override_increase_1": 10515.39
  },
  {
    "#": "874 Commonwealth Ave (018-03-00)",
    "$": 14574500,
    "address": "874 Commonwealth Ave",
    "parcel_id": "018-03-00",
    "owner1": "290 MCCLELLAN HIGHWAY LLC",
    "owner2": "",
    "current_taxes": 250098.42,
    "new_taxes_no_override": 260902.67,
    "override_total_1": 268305.58,
    "override_increase_1": 7402.91
  },
  {
    "#": "882 Commonwealth Ave (018-02-00)",
    "$": 30324200,
    "address": "882 Commonwealth Ave",
    "parcel_id": "018-02-00",
    "owner1": "TRUSTEES OF BOSTON UNIVERSITY",
    "owner2": "C/O GENERAL ACCOUNTING 4TH FLR",
    "current_taxes": 125912.19,
    "new_taxes_no_override": 131351.6,
    "override_total_1": 135078.6,
    "override_increase_1": 3727.0
  },
  {
    "#": "890 Commonwealth Ave (018-01-00)",
    "$": 17613000,
    "address": "890 Commonwealth Ave",
    "parcel_id": "018-01-00",
    "owner1": "TRUSTEES OF BOSTON UNIVERSITY",
    "owner2": "C/O GENERAL ACCOUNTING 4TH FLR",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "900 Commonwealth Ave (019-01-00)",
    "$": 27830300,
    "address": "900 Commonwealth Ave",
    "parcel_id": "019-01-00",
    "owner1": "HOWE TR, DEREK A",
    "owner2": "C/O SIS PROPERTY MANAGEMENT",
    "current_taxes": 76380.81,
    "new_taxes_no_override": 79680.46,
    "override_total_1": 81941.33,
    "override_increase_1": 2260.87
  },
  {
    "#": "910 Commonwealth Ave (019-10-00)",
    "$": 7511800,
    "address": "910 Commonwealth Ave",
    "parcel_id": "019-10-00",
    "owner1": "TRUSTEES OF BOSTON UNIVERSITY",
    "owner2": "C/O GENERAL ACCOUNTING 4TH FL",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "916 Commonwealth Ave (019-08-09)",
    "$": 16259600,
    "address": "916 Commonwealth Ave",
    "parcel_id": "019-08-09",
    "owner1": "HOWE TR, DEREK A",
    "owner2": "C/O SIS PROPERTY MANAGEMENT",
    "current_taxes": 242817.07,
    "new_taxes_no_override": 253306.77,
    "override_total_1": 260494.15,
    "override_increase_1": 7187.39
  },
  {
    "#": "928 Commonwealth Ave (019-07-00)",
    "$": 14069300,
    "address": "928 Commonwealth Ave",
    "parcel_id": "019-07-00",
    "owner1": "TRUSTEES OF BOSTON UNIVERSITY",
    "owner2": "C/O GENERAL ACCOUNTING 4TH FLR",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "930 Commonwealth Ave (019-05-12)",
    "$": 48318400,
    "address": "930 Commonwealth Ave",
    "parcel_id": "019-05-12",
    "owner1": "HOWE TR, DEREK A",
    "owner2": "C/O SIS PROPERTY MANAGEMENT",
    "current_taxes": 82734.54,
    "new_taxes_no_override": 86308.67,
    "override_total_1": 88757.61,
    "override_increase_1": 2448.94
  },
  {
    "#": "950 Commonwealth Ave (028-01-03)",
    "$": 4958900,
    "address": "950 Commonwealth Ave",
    "parcel_id": "028-01-03",
    "owner1": "BROOKLINE REALTY LLC",
    "owner2": "",
    "current_taxes": 85094.72,
    "new_taxes_no_override": 88770.81,
    "override_total_1": 91289.62,
    "override_increase_1": 2518.8
  },
  {
    "#": "966 Commonwealth Ave (028-01-01)",
    "$": 3781800,
    "address": "966 Commonwealth Ave",
    "parcel_id": "028-01-01",
    "owner1": "BROOKLINE REALTY LLC",
    "owner2": "",
    "current_taxes": 64895.69,
    "new_taxes_no_override": 67699.18,
    "override_total_1": 69620.1,
    "override_increase_1": 1920.91
  },
  {
    "#": "972 Commonwealth Ave (028-01-00)",
    "$": 5076500,
    "address": "972 Commonwealth Ave",
    "parcel_id": "028-01-00",
    "owner1": "BROOKLINE REALTY LLC",
    "owner2": "",
    "current_taxes": 87112.74,
    "new_taxes_no_override": 90876.01,
    "override_total_1": 93454.55,
    "override_increase_1": 2578.54
  },
  {
    "#": "996 Commonwealth Ave (027-36-37)",
    "$": 2838500,
    "address": "996 Commonwealth Ave",
    "parcel_id": "027-36-37",
    "owner1": "BROOKLINE REALTY LLC",
    "owner2": "",
    "current_taxes": 48708.66,
    "new_taxes_no_override": 50812.87,
    "override_total_1": 52254.65,
    "override_increase_1": 1441.78
  },
  {
    "#": "1010 Commonwealth Ave (027-35-00)",
    "$": 27151500,
    "address": "1010 Commonwealth Ave",
    "parcel_id": "027-35-00",
    "owner1": "PLEASANT STREET ASSOCIATES INC",
    "owner2": "C/O TRIAD GROUP",
    "current_taxes": 465919.74,
    "new_taxes_no_override": 486047.47,
    "override_total_1": 499838.7,
    "override_increase_1": 13791.22
  },
  {
    "#": "1016 Commonwealth Ave (056-14-00)",
    "$": 3165500,
    "address": "1016 Commonwealth Ave",
    "parcel_id": "056-14-00",
    "owner1": "1018 COMM LLC",
    "owner2": "",
    "current_taxes": 54319.98,
    "new_taxes_no_override": 56666.6,
    "override_total_1": 58274.47,
    "override_increase_1": 1607.87
  },
  {
    "#": "1020 Commonwealth Ave, Unit B (056-13-00)",
    "$": 3427900,
    "address": "1020 Commonwealth Ave, Unit B",
    "parcel_id": "056-13-00",
    "owner1": "1020 COMM AVE REALTY LLC",
    "owner2": "",
    "current_taxes": 58822.76,
    "new_taxes_no_override": 61363.9,
    "override_total_1": 63105.06,
    "override_increase_1": 1741.15
  },
  {
    "#": "1022 Commonwealth Ave, Unit 1024 (056-12-00)",
    "$": 4662100,
    "address": "1022 Commonwealth Ave, Unit 1024",
    "parcel_id": "056-12-00",
    "owner1": "1022 COMMONWEALTH LLC",
    "owner2": "C/O RAVELSON SCOTT",
    "current_taxes": 80001.64,
    "new_taxes_no_override": 83457.71,
    "override_total_1": 85825.76,
    "override_increase_1": 2368.05
  },
  {
    "#": "1028 Commonwealth Ave (056-11-00)",
    "$": 7175300,
    "address": "1028 Commonwealth Ave",
    "parcel_id": "056-11-00",
    "owner1": "1026 COMMONWEALTH AV LLC",
    "owner2": "",
    "current_taxes": 85888.34,
    "new_taxes_no_override": 89598.72,
    "override_total_1": 92141.01,
    "override_increase_1": 2542.29
  },
  {
    "#": "1030 Commonwealth Ave (056-10-00)",
    "$": 3275700,
    "address": "1030 Commonwealth Ave",
    "parcel_id": "056-10-00",
    "owner1": "ADVANCED COMMONWEALTH GROUP LLC",
    "owner2": "",
    "current_taxes": 56211.01,
    "new_taxes_no_override": 58639.33,
    "override_total_1": 60303.17,
    "override_increase_1": 1663.85
  },
  {
    "#": "1032 Commonwealth Ave (056-09-00)",
    "$": 4767300,
    "address": "1032 Commonwealth Ave",
    "parcel_id": "056-09-00",
    "owner1": "1026 COMMONWEALTH AV LLC",
    "owner2": "",
    "current_taxes": 60697.52,
    "new_taxes_no_override": 63319.65,
    "override_total_1": 65116.3,
    "override_increase_1": 1796.65
  },
  {
    "#": "1034 Commonwealth Ave (056-08-00)",
    "$": 2317200,
    "address": "1034 Commonwealth Ave",
    "parcel_id": "056-08-00",
    "owner1": "NEW ENGLAND DAIRY & FOOD CNCL",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "1040 Commonwealth Ave (055-17-21)",
    "$": 9493600,
    "address": "1040 Commonwealth Ave",
    "parcel_id": "055-17-21",
    "owner1": "WALCOTT CORPORATION",
    "owner2": "",
    "current_taxes": 162910.18,
    "new_taxes_no_override": 169947.9,
    "override_total_1": 174770.04,
    "override_increase_1": 4822.14
  },
  {
    "#": "1056 Commonwealth Ave (055-17-02)",
    "$": 0,
    "address": "1056 Commonwealth Ave",
    "parcel_id": "055-17-02",
    "owner1": "KELLEHER FAMILY LLC",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "1066 Commonwealth Ave (055-17-01)",
    "$": 0,
    "address": "1066 Commonwealth Ave",
    "parcel_id": "055-17-01",
    "owner1": "KELLEHER FAMILY LLC",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "1082 Commonwealth Ave (057-21-04)",
    "$": 0,
    "address": "1082 Commonwealth Ave",
    "parcel_id": "057-21-04",
    "owner1": "TE2 REAL ESTATE LLC",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "1086 Commonwealth Ave (057-21-03)",
    "$": 0,
    "address": "1086 Commonwealth Ave",
    "parcel_id": "057-21-03",
    "owner1": "REDMONT REAL ESTATE LC",
    "owner2": "C/O ROTENBERG MGT CO INC",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "1092 Commonwealth Ave (057-21-02)",
    "$": 0,
    "address": "1092 Commonwealth Ave",
    "parcel_id": "057-21-02",
    "owner1": "FIELD CORP MASS CORP",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "1106 Commonwealth Ave (057-21-01)",
    "$": 0,
    "address": "1106 Commonwealth Ave",
    "parcel_id": "057-21-01",
    "owner1": "NORA HOUSE LLC",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "1140 Commonwealth Ave (070-31-00)",
    "$": 0,
    "address": "1140 Commonwealth Ave",
    "parcel_id": "070-31-00",
    "owner1": "ALIMAR REALTY LLC",
    "owner2": "FISHER ALI LLC",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "1142 Commonwealth Ave (070-30-00)",
    "$": 0,
    "address": "1142 Commonwealth Ave",
    "parcel_id": "070-30-00",
    "owner1": "COMMONWEALTH 1144 LP",
    "owner2": "C/O STARR SALLY A",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "1148 Commonwealth Ave (070-29-00)",
    "$": 0,
    "address": "1148 Commonwealth Ave",
    "parcel_id": "070-29-00",
    "owner1": "COMMONWEALTH 1144 LP",
    "owner2": "C/O STARR SALLY A",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "1152 Commonwealth Ave, Unit A (070-28-00)",
    "$": 0,
    "address": "1152 Commonwealth Ave, Unit A",
    "parcel_id": "070-28-00",
    "owner1": "COMMONWEALTH 1144 LP",
    "owner2": "C/O STARR SALLY A",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "1156 Commonwealth Ave (070-27-00)",
    "$": 0,
    "address": "1156 Commonwealth Ave",
    "parcel_id": "070-27-00",
    "owner1": "COMMONWEALTH 1144 LP",
    "owner2": "C/O STARR SALLY A",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "1158 Commonwealth Ave (070-26-00)",
    "$": 0,
    "address": "1158 Commonwealth Ave",
    "parcel_id": "070-26-00",
    "owner1": "COMMONWEALTH 1144 LP",
    "owner2": "C/O STARR SALLY A",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "1168 Commonwealth Ave (070-23-25)",
    "$": 26269100,
    "address": "1168 Commonwealth Ave",
    "parcel_id": "070-23-25",
    "owner1": "ATLANTA REAL ESTATE HOLDINGS LLC",
    "owner2": "C/O ASBURY AUTOMOTIVE GROUP INC",
    "current_taxes": 450777.76,
    "new_taxes_no_override": 470251.36,
    "override_total_1": 483594.38,
    "override_increase_1": 13343.02
  },
  {
    "#": " Commonwealth Ave (007-01-00)",
    "$": 54955900,
    "address": " Commonwealth Ave",
    "parcel_id": "007-01-00",
    "owner1": "COMMONWEALTH OF MASSACHUSETTS",
    "owner2": "C/O MASS TURNPIKE AUTHORITY",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "3 Conant Rd (360-12-00)",
    "$": 867400,
    "address": "3 Conant Rd",
    "parcel_id": "360-12-00",
    "owner1": "ROGERS, MICHAEL & MAURA A",
    "owner2": "",
    "current_taxes": 5247.24,
    "new_taxes_no_override": 5473.92,
    "override_total_1": 5629.24,
    "override_increase_1": 155.32
  },
  {
    "#": "6 Conant Rd (359-07-00)",
    "$": 1234500,
    "address": "6 Conant Rd",
    "parcel_id": "359-07-00",
    "owner1": "LINDENBERG, JULIA",
    "owner2": "",
    "current_taxes": 9006.35,
    "new_taxes_no_override": 9395.42,
    "override_total_1": 9662.01,
    "override_increase_1": 266.59
  },
  {
    "#": "7 Conant Rd (360-13-00)",
    "$": 1368400,
    "address": "7 Conant Rd",
    "parcel_id": "360-13-00",
    "owner1": "LAPANN, CANDICE",
    "owner2": "RITTER, KIMBERLY",
    "current_taxes": 10377.48,
    "new_taxes_no_override": 10825.79,
    "override_total_1": 11132.96,
    "override_increase_1": 307.17
  },
  {
    "#": "11 Conant Rd (360-14-00)",
    "$": 1277800,
    "address": "11 Conant Rd",
    "parcel_id": "360-14-00",
    "owner1": "AARONSON, SETH & AMY",
    "owner2": "",
    "current_taxes": 9449.74,
    "new_taxes_no_override": 9857.97,
    "override_total_1": 10137.68,
    "override_increase_1": 279.71
  },
  {
    "#": "12 Conant Rd (359-06-00)",
    "$": 1340000,
    "address": "12 Conant Rd",
    "parcel_id": "359-06-00",
    "owner1": "GENSLER, ROBERT  & MARYSIA",
    "owner2": "",
    "current_taxes": 10086.67,
    "new_taxes_no_override": 10522.41,
    "override_total_1": 10820.98,
    "override_increase_1": 298.57
  },
  {
    "#": "15 Conant Rd (360-15-00)",
    "$": 1078600,
    "address": "15 Conant Rd",
    "parcel_id": "360-15-00",
    "owner1": "CAFLISCH, AMELIA I",
    "owner2": "",
    "current_taxes": 11044.86,
    "new_taxes_no_override": 11522.0,
    "override_total_1": 11848.93,
    "override_increase_1": 326.93
  },
  {
    "#": "16 Conant Rd (359-05-00)",
    "$": 1460900,
    "address": "16 Conant Rd",
    "parcel_id": "359-05-00",
    "owner1": "HERNANDEZ, JOSE",
    "owner2": "UROSA, DANIELA",
    "current_taxes": 11324.68,
    "new_taxes_no_override": 11813.91,
    "override_total_1": 12149.12,
    "override_increase_1": 335.21
  },
  {
    "#": "19 Conant Rd (360-16-00)",
    "$": 1054900,
    "address": "19 Conant Rd",
    "parcel_id": "360-16-00",
    "owner1": "FETZER, NICHOLAS B & JENNIFER",
    "owner2": "",
    "current_taxes": 7167.24,
    "new_taxes_no_override": 7476.86,
    "override_total_1": 7689.02,
    "override_increase_1": 212.15
  },
  {
    "#": "20 Conant Rd (359-04-00)",
    "$": 982500,
    "address": "20 Conant Rd",
    "parcel_id": "359-04-00",
    "owner1": "CRISTO, WILLIAM & CHRISTINE",
    "owner2": "",
    "current_taxes": 10060.8,
    "new_taxes_no_override": 10495.43,
    "override_total_1": 10793.23,
    "override_increase_1": 297.8
  },
  {
    "#": "23 Conant Rd (360-17-00)",
    "$": 1156800,
    "address": "23 Conant Rd",
    "parcel_id": "360-17-00",
    "owner1": "BELAMARICH, THOMAS & BERENICE",
    "owner2": "",
    "current_taxes": 8210.7,
    "new_taxes_no_override": 8565.4,
    "override_total_1": 8808.44,
    "override_increase_1": 243.04
  },
  {
    "#": "24 Conant Rd (359-03-00)",
    "$": 1227200,
    "address": "24 Conant Rd",
    "parcel_id": "359-03-00",
    "owner1": "ANDERSEN, SCOTT R",
    "owner2": "ROSS, NANCY E",
    "current_taxes": 8931.59,
    "new_taxes_no_override": 9317.43,
    "override_total_1": 9581.81,
    "override_increase_1": 264.38
  },
  {
    "#": "27 Conant Rd (360-01-00)",
    "$": 1173400,
    "address": "27 Conant Rd",
    "parcel_id": "360-01-00",
    "owner1": "LIN, ZHUANGSHENG",
    "owner2": "YOU, XIAOMENG",
    "current_taxes": 8380.68,
    "new_taxes_no_override": 8742.73,
    "override_total_1": 8990.79,
    "override_increase_1": 248.07
  },
  {
    "#": "28 Conant Rd (359-02-00)",
    "$": 2449100,
    "address": "28 Conant Rd",
    "parcel_id": "359-02-00",
    "owner1": "CHEN, TING-HSU",
    "owner2": "KANG, LIH HSUEH",
    "current_taxes": 21443.85,
    "new_taxes_no_override": 22370.22,
    "override_total_1": 23004.96,
    "override_increase_1": 634.74
  },
  {
    "#": "8 Coolidge St (076-23-00)",
    "$": 1953500,
    "address": "8 Coolidge St",
    "parcel_id": "076-23-00",
    "owner1": "KOPANS, CAROLYN ROSENTHAL",
    "owner2": "",
    "current_taxes": 16368.91,
    "new_taxes_no_override": 17076.05,
    "override_total_1": 17560.57,
    "override_increase_1": 484.52
  },
  {
    "#": "9 Coolidge St (077-01-01)",
    "$": 2889200,
    "address": "9 Coolidge St",
    "parcel_id": "077-01-01",
    "owner1": "STOLER TRS, MELVIN H & KAREN T",
    "owner2": "",
    "current_taxes": 25950.47,
    "new_taxes_no_override": 27071.53,
    "override_total_1": 27839.66,
    "override_increase_1": 768.13
  },
  {
    "#": "15 Coolidge St (077-25-00)",
    "$": 2311200,
    "address": "15 Coolidge St",
    "parcel_id": "077-25-00",
    "owner1": "MADOFF TRS, LAWRENCE C",
    "owner2": "ENG, NANCY C",
    "current_taxes": 20031.75,
    "new_taxes_no_override": 20897.12,
    "override_total_1": 21490.06,
    "override_increase_1": 592.94
  },
  {
    "#": "16 Coolidge St (076-22-00)",
    "$": 2427700,
    "address": "16 Coolidge St",
    "parcel_id": "076-22-00",
    "owner1": "BAKER, MICHELE S",
    "owner2": "MORGAN, JAMES L IV",
    "current_taxes": 21224.71,
    "new_taxes_no_override": 22141.62,
    "override_total_1": 22769.87,
    "override_increase_1": 628.25
  },
  {
    "#": "17 Coolidge St (077-26-00)",
    "$": 2447000,
    "address": "17 Coolidge St",
    "parcel_id": "077-26-00",
    "owner1": "GREENBERG, HAYLEY B",
    "owner2": "CABANAS, MANUEL",
    "current_taxes": 21422.35,
    "new_taxes_no_override": 22347.8,
    "override_total_1": 22981.9,
    "override_increase_1": 634.1
  },
  {
    "#": "20 Coolidge St (076-21-00)",
    "$": 2036400,
    "address": "20 Coolidge St",
    "parcel_id": "076-21-00",
    "owner1": "NICKERSON LIFE ESTATE, MARY B",
    "owner2": "",
    "current_taxes": 17217.8,
    "new_taxes_no_override": 17961.61,
    "override_total_1": 18471.26,
    "override_increase_1": 509.65
  },
  {
    "#": "21 Coolidge St (077-03-00)",
    "$": 1894100,
    "address": "21 Coolidge St",
    "parcel_id": "077-03-00",
    "owner1": "PRINGLE, MICHAEL J & ANNETTE E",
    "owner2": "",
    "current_taxes": 15760.65,
    "new_taxes_no_override": 16441.51,
    "override_total_1": 16908.03,
    "override_increase_1": 466.52
  },
  {
    "#": "23 Coolidge St (077-04-00)",
    "$": 2004500,
    "address": "23 Coolidge St",
    "parcel_id": "077-04-00",
    "owner1": "LAU ET AL TRS, MAN KEUN YUEN",
    "owner2": "",
    "current_taxes": 16891.15,
    "new_taxes_no_override": 17620.85,
    "override_total_1": 18120.83,
    "override_increase_1": 499.98
  },
  {
    "#": "26 Coolidge St (076-20-00)",
    "$": 2441900,
    "address": "26 Coolidge St",
    "parcel_id": "076-20-00",
    "owner1": "SHAFFER, STEVEN E",
    "owner2": "WELLS, HEIDI K",
    "current_taxes": 21370.12,
    "new_taxes_no_override": 22293.31,
    "override_total_1": 22925.86,
    "override_increase_1": 632.56
  },
  {
    "#": "30 Coolidge St (076-19-00)",
    "$": 2127300,
    "address": "30 Coolidge St",
    "parcel_id": "076-19-00",
    "owner1": "BENNETT TR, NANCY L",
    "owner2": "",
    "current_taxes": 18148.62,
    "new_taxes_no_override": 18932.64,
    "override_total_1": 19469.84,
    "override_increase_1": 537.2
  },
  {
    "#": "31 Coolidge St (077-05-00)",
    "$": 2147500,
    "address": "31 Coolidge St",
    "parcel_id": "077-05-00",
    "owner1": "EVANS, THOMAS W & DONNA M",
    "owner2": "",
    "current_taxes": 18355.47,
    "new_taxes_no_override": 19148.43,
    "override_total_1": 19691.75,
    "override_increase_1": 543.32
  },
  {
    "#": "34 Coolidge St (076-18-00)",
    "$": 2026600,
    "address": "34 Coolidge St",
    "parcel_id": "076-18-00",
    "owner1": "MOSGOFIAN TR, CATHERINE",
    "owner2": "",
    "current_taxes": 17117.45,
    "new_taxes_no_override": 17856.92,
    "override_total_1": 18363.6,
    "override_increase_1": 506.68
  },
  {
    "#": "35 Coolidge St (077-06-00)",
    "$": 2097000,
    "address": "35 Coolidge St",
    "parcel_id": "077-06-00",
    "owner1": "LEE III, HENRY",
    "owner2": "LEE, MARY R",
    "current_taxes": 17838.35,
    "new_taxes_no_override": 18608.97,
    "override_total_1": 19136.98,
    "override_increase_1": 528.02
  },
  {
    "#": "40 Coolidge St (076-17-00)",
    "$": 2442300,
    "address": "40 Coolidge St",
    "parcel_id": "076-17-00",
    "owner1": "VAYSBURD, LEV & VICTORIA",
    "owner2": "",
    "current_taxes": 21374.22,
    "new_taxes_no_override": 22297.59,
    "override_total_1": 22930.26,
    "override_increase_1": 632.68
  },
  {
    "#": "41 Coolidge St (077-07-00)",
    "$": 2352500,
    "address": "41 Coolidge St",
    "parcel_id": "077-07-00",
    "owner1": "JACOBS, MICHAEL",
    "owner2": "SEGE, IRENE J",
    "current_taxes": 20454.67,
    "new_taxes_no_override": 21338.31,
    "override_total_1": 21943.77,
    "override_increase_1": 605.46
  },
  {
    "#": "42 Coolidge St, Unit 1 (076-16-01)",
    "$": 2240100,
    "address": "42 Coolidge St, Unit 1",
    "parcel_id": "076-16-01",
    "owner1": "KAPUR, GAUTAM",
    "owner2": "SHANKAR, SANGEETA",
    "current_taxes": 22938.62,
    "new_taxes_no_override": 23929.57,
    "override_total_1": 24608.55,
    "override_increase_1": 678.98
  },
  {
    "#": "42 Coolidge St, Unit 2 (076-16-02)",
    "$": 2753800,
    "address": "42 Coolidge St, Unit 2",
    "parcel_id": "076-16-02",
    "owner1": "NATARAJAN, PRADEEP",
    "owner2": "KOHLI, PUJA",
    "current_taxes": 24563.98,
    "new_taxes_no_override": 25625.14,
    "override_total_1": 26352.24,
    "override_increase_1": 727.09
  },
  {
    "#": "45 Coolidge St (077-08-00)",
    "$": 2637700,
    "address": "45 Coolidge St",
    "parcel_id": "077-08-00",
    "owner1": "BUCKLEY, CAROLINE",
    "owner2": "MCMAHON, COLM",
    "current_taxes": 23375.11,
    "new_taxes_no_override": 24384.91,
    "override_total_1": 25076.82,
    "override_increase_1": 691.9
  },
  {
    "#": "48 Coolidge St, Unit 1 & P1 (076-15-01)",
    "$": 1173500,
    "address": "48 Coolidge St, Unit 1 & P1",
    "parcel_id": "076-15-01",
    "owner1": "ROSENBERG TR, LYNN A",
    "owner2": "",
    "current_taxes": 8381.71,
    "new_taxes_no_override": 8743.8,
    "override_total_1": 8991.9,
    "override_increase_1": 248.1
  },
  {
    "#": "48 Coolidge St, Unit 2 & P2 (076-15-02)",
    "$": 1321800,
    "address": "48 Coolidge St, Unit 2 & P2",
    "parcel_id": "076-15-02",
    "owner1": "PALMER, JULIE R",
    "owner2": "",
    "current_taxes": 9900.3,
    "new_taxes_no_override": 10327.99,
    "override_total_1": 10621.04,
    "override_increase_1": 293.05
  },
  {
    "#": "54 Coolidge St (076-14-00)",
    "$": 1934800,
    "address": "54 Coolidge St",
    "parcel_id": "076-14-00",
    "owner1": "SON, CHANG-HEE",
    "owner2": "EUNKYUNG, HELEN",
    "current_taxes": 16177.42,
    "new_taxes_no_override": 16876.28,
    "override_total_1": 17355.14,
    "override_increase_1": 478.85
  },
  {
    "#": "64 Coolidge St (067-07-00)",
    "$": 3357300,
    "address": "64 Coolidge St",
    "parcel_id": "067-07-00",
    "owner1": "ECHELMAN, JANET",
    "owner2": "",
    "current_taxes": 30743.82,
    "new_taxes_no_override": 32071.95,
    "override_total_1": 32981.97,
    "override_increase_1": 910.02
  },
  {
    "#": "69 Coolidge St (066-12-00)",
    "$": 3422900,
    "address": "69 Coolidge St",
    "parcel_id": "066-12-00",
    "owner1": "CROMPTON, BRIAN",
    "owner2": "WYMAN, LISA",
    "current_taxes": 35050.5,
    "new_taxes_no_override": 36564.68,
    "override_total_1": 37602.18,
    "override_increase_1": 1037.49
  },
  {
    "#": "70 Coolidge St (067-06-00)",
    "$": 2098400,
    "address": "70 Coolidge St",
    "parcel_id": "067-06-00",
    "owner1": "PUSHAK, LUDMILA & SVETLANA & OLGA",
    "owner2": "",
    "current_taxes": 17852.68,
    "new_taxes_no_override": 18623.92,
    "override_total_1": 19152.36,
    "override_increase_1": 528.44
  },
  {
    "#": "73 Coolidge St (066-13-00)",
    "$": 2706200,
    "address": "73 Coolidge St",
    "parcel_id": "066-13-00",
    "owner1": "ROSENBAUM TRS, LEE R & MARILYN OTT",
    "owner2": "",
    "current_taxes": 24076.55,
    "new_taxes_no_override": 25116.66,
    "override_total_1": 25829.32,
    "override_increase_1": 712.67
  },
  {
    "#": "74 Coolidge St (067-05-00)",
    "$": 1985900,
    "address": "74 Coolidge St",
    "parcel_id": "067-05-00",
    "owner1": "ZAPPALA ET AL TRS, LENA",
    "owner2": "DEGHMANE, CARMELA A",
    "current_taxes": 16700.68,
    "new_taxes_no_override": 17422.15,
    "override_total_1": 17916.49,
    "override_increase_1": 494.34
  },
  {
    "#": "78 Coolidge St (067-04-00)",
    "$": 2032600,
    "address": "78 Coolidge St",
    "parcel_id": "067-04-00",
    "owner1": "FOTOPOULOS TR, ANASTASIOS N",
    "owner2": "",
    "current_taxes": 17178.89,
    "new_taxes_no_override": 17921.02,
    "override_total_1": 18429.51,
    "override_increase_1": 508.5
  },
  {
    "#": "79 Coolidge St (066-14-00)",
    "$": 3186500,
    "address": "79 Coolidge St",
    "parcel_id": "066-14-00",
    "owner1": "PARK TR, JENNIFER",
    "owner2": "",
    "current_taxes": 28994.83,
    "new_taxes_no_override": 30247.41,
    "override_total_1": 31105.65,
    "override_increase_1": 858.25
  },
  {
    "#": "83 Coolidge St (066-15-00)",
    "$": 2304800,
    "address": "83 Coolidge St",
    "parcel_id": "066-15-00",
    "owner1": "MAURER, CHRISTOPHER H",
    "owner2": "IGLESIAS, M E",
    "current_taxes": 19966.22,
    "new_taxes_no_override": 20828.76,
    "override_total_1": 21419.76,
    "override_increase_1": 591.0
  },
  {
    "#": "84 Coolidge St (067-03-00)",
    "$": 2182100,
    "address": "84 Coolidge St",
    "parcel_id": "067-03-00",
    "owner1": "MOY LIFE ESTATE, KWOK HAY & SO SIM",
    "owner2": "",
    "current_taxes": 18709.77,
    "new_taxes_no_override": 19518.03,
    "override_total_1": 20071.84,
    "override_increase_1": 553.81
  },
  {
    "#": "87 Coolidge St, Unit 1 (066-16-01)",
    "$": 1049100,
    "address": "87 Coolidge St, Unit 1",
    "parcel_id": "066-16-01",
    "owner1": "REICHELT, KIMBERLY SKLAR & MARK W",
    "owner2": "",
    "current_taxes": 10742.78,
    "new_taxes_no_override": 11206.87,
    "override_total_1": 11524.85,
    "override_increase_1": 317.99
  },
  {
    "#": "87 Coolidge St, Unit 2 (066-16-02)",
    "$": 1493100,
    "address": "87 Coolidge St, Unit 2",
    "parcel_id": "066-16-02",
    "owner1": "REICHELT, KIMBERLY SKLAR & MARK W",
    "owner2": "",
    "current_taxes": 15289.34,
    "new_taxes_no_override": 15949.84,
    "override_total_1": 16402.4,
    "override_increase_1": 452.56
  },
  {
    "#": "88 Coolidge St, Unit 1 (067-02-01)",
    "$": 1448100,
    "address": "88 Coolidge St, Unit 1",
    "parcel_id": "067-02-01",
    "owner1": "OLIVE, CHRISTOPHER D",
    "owner2": "GERZON, INNA",
    "current_taxes": 11193.61,
    "new_taxes_no_override": 11677.17,
    "override_total_1": 12008.5,
    "override_increase_1": 331.33
  },
  {
    "#": "88 Coolidge St, Unit 2 (067-02-02)",
    "$": 1619800,
    "address": "88 Coolidge St, Unit 2",
    "parcel_id": "067-02-02",
    "owner1": "TANNA, GAURAV ATUL",
    "owner2": "SANE, KOMAL MADHUKAR",
    "current_taxes": 16586.75,
    "new_taxes_no_override": 17303.3,
    "override_total_1": 17794.27,
    "override_increase_1": 490.97
  },
  {
    "#": "91 Coolidge St (066-17-00)",
    "$": 2929300,
    "address": "91 Coolidge St",
    "parcel_id": "066-17-00",
    "owner1": "ALTMAN, GARY D",
    "owner2": "FERBER, JUDITH R",
    "current_taxes": 26361.1,
    "new_taxes_no_override": 27499.9,
    "override_total_1": 28280.19,
    "override_increase_1": 780.29
  },
  {
    "#": "92 Coolidge St, Unit 1 (067-01-01)",
    "$": 1356400,
    "address": "92 Coolidge St, Unit 1",
    "parcel_id": "067-01-01",
    "owner1": "MINNEY, RICHARD",
    "owner2": "",
    "current_taxes": 13889.54,
    "new_taxes_no_override": 14489.57,
    "override_total_1": 14900.7,
    "override_increase_1": 411.13
  },
  {
    "#": "92 Coolidge St, Unit 2 (067-01-02)",
    "$": 1499100,
    "address": "92 Coolidge St, Unit 2",
    "parcel_id": "067-01-02",
    "owner1": "KAUFMAN, AVI NATHANIEL",
    "owner2": "KURTZ, SHIRA MIRIAM",
    "current_taxes": 11715.85,
    "new_taxes_no_override": 12221.97,
    "override_total_1": 12568.76,
    "override_increase_1": 346.79
  },
  {
    "#": "95 Coolidge St (066-18-00)",
    "$": 2460600,
    "address": "95 Coolidge St",
    "parcel_id": "066-18-00",
    "owner1": "95 COOLIDGE ST LLC",
    "owner2": "",
    "current_taxes": 25196.54,
    "new_taxes_no_override": 26285.03,
    "override_total_1": 27030.85,
    "override_increase_1": 745.82
  },
  {
    "#": "100 Coolidge St (068-12-00)",
    "$": 2636800,
    "address": "100 Coolidge St",
    "parcel_id": "068-12-00",
    "owner1": "WIDICAN, RAYMOND",
    "owner2": "",
    "current_taxes": 23365.9,
    "new_taxes_no_override": 24375.31,
    "override_total_1": 25066.94,
    "override_increase_1": 691.63
  },
  {
    "#": "101 Coolidge St (065-01-00)",
    "$": 2441100,
    "address": "101 Coolidge St",
    "parcel_id": "065-01-00",
    "owner1": "EFFRON, DAWN D & MORRIS L",
    "owner2": "",
    "current_taxes": 21361.93,
    "new_taxes_no_override": 22284.77,
    "override_total_1": 22917.08,
    "override_increase_1": 632.31
  },
  {
    "#": "104 Coolidge St (068-11-00)",
    "$": 3160600,
    "address": "104 Coolidge St",
    "parcel_id": "068-11-00",
    "owner1": "MAHALINGAM, MEERA",
    "owner2": "DHINGRA, JAGDISH K",
    "current_taxes": 28729.61,
    "new_taxes_no_override": 29970.73,
    "override_total_1": 30821.13,
    "override_increase_1": 850.4
  },
  {
    "#": "110 Coolidge St (068-10-00)",
    "$": 2302600,
    "address": "110 Coolidge St",
    "parcel_id": "068-10-00",
    "owner1": "ROSEN, DANIEL M",
    "owner2": "SACCO, DENA T",
    "current_taxes": 19943.69,
    "new_taxes_no_override": 20805.26,
    "override_total_1": 21395.59,
    "override_increase_1": 590.33
  },
  {
    "#": "111 Coolidge St, Unit 1 (065-02-01)",
    "$": 1121400,
    "address": "111 Coolidge St, Unit 1",
    "parcel_id": "065-02-01",
    "owner1": "SILVERSTONE, LEE",
    "owner2": "",
    "current_taxes": 11483.14,
    "new_taxes_no_override": 11979.21,
    "override_total_1": 12319.11,
    "override_increase_1": 339.9
  },
  {
    "#": "111 Coolidge St, Unit 2 (065-02-02)",
    "$": 1122100,
    "address": "111 Coolidge St, Unit 2",
    "parcel_id": "065-02-02",
    "owner1": "BURRAGE ET AL TRS, NICHOLAS R & CHARLOTTE C",
    "owner2": "",
    "current_taxes": 7855.37,
    "new_taxes_no_override": 8194.72,
    "override_total_1": 8427.24,
    "override_increase_1": 232.52
  },
  {
    "#": "111 Coolidge St, Unit 3 (065-02-03)",
    "$": 712100,
    "address": "111 Coolidge St, Unit 3",
    "parcel_id": "065-02-03",
    "owner1": "CHAN, WAI CHEUNG",
    "owner2": "",
    "current_taxes": 3656.97,
    "new_taxes_no_override": 3814.95,
    "override_total_1": 3923.2,
    "override_increase_1": 108.25
  },
  {
    "#": "114 Coolidge St (068-09-00)",
    "$": 2165100,
    "address": "114 Coolidge St",
    "parcel_id": "068-09-00",
    "owner1": "BURRAGE ET AL TRS, MARIE S",
    "owner2": "",
    "current_taxes": 18535.69,
    "new_taxes_no_override": 19336.43,
    "override_total_1": 19885.09,
    "override_increase_1": 548.66
  },
  {
    "#": "119 Coolidge St (065-03-00)",
    "$": 3534500,
    "address": "119 Coolidge St",
    "parcel_id": "065-03-00",
    "owner1": "LIEBMAN, ANDREW P",
    "owner2": "BENITEZ, MARIA D P",
    "current_taxes": 32558.35,
    "new_taxes_no_override": 33964.87,
    "override_total_1": 34928.6,
    "override_increase_1": 963.73
  },
  {
    "#": "120 Coolidge St (068-08-00)",
    "$": 3068900,
    "address": "120 Coolidge St",
    "parcel_id": "068-08-00",
    "owner1": "PITTMAN TR, ROBERT",
    "owner2": "NOBLE TR, JOANN",
    "current_taxes": 27790.6,
    "new_taxes_no_override": 28991.15,
    "override_total_1": 29813.76,
    "override_increase_1": 822.6
  },
  {
    "#": "124 Coolidge St (068-07-00)",
    "$": 2387400,
    "address": "124 Coolidge St",
    "parcel_id": "068-07-00",
    "owner1": "BROOMELL, CHRISTOPHER",
    "owner2": "KAPLAN, DIANE",
    "current_taxes": 24446.98,
    "new_taxes_no_override": 25503.09,
    "override_total_1": 26226.72,
    "override_increase_1": 723.63
  },
  {
    "#": "125 Coolidge St (065-04-00)",
    "$": 2293300,
    "address": "125 Coolidge St",
    "parcel_id": "065-04-00",
    "owner1": "BEN-OZAR, NOAM",
    "owner2": "FINEGOLD, SARAH",
    "current_taxes": 23483.39,
    "new_taxes_no_override": 24497.87,
    "override_total_1": 25192.98,
    "override_increase_1": 695.11
  },
  {
    "#": "127 Coolidge St, Unit 1 (065-05-01)",
    "$": 1124400,
    "address": "127 Coolidge St, Unit 1",
    "parcel_id": "065-05-01",
    "owner1": "GABRIEL, MARK",
    "owner2": "",
    "current_taxes": 7878.92,
    "new_taxes_no_override": 8219.29,
    "override_total_1": 8452.51,
    "override_increase_1": 233.22
  },
  {
    "#": "127 Coolidge St, Unit 2 (065-05-02)",
    "$": 1135000,
    "address": "127 Coolidge St, Unit 2",
    "parcel_id": "065-05-02",
    "owner1": "MCGOLDRICK, MARY M",
    "owner2": "",
    "current_taxes": 7987.47,
    "new_taxes_no_override": 8332.53,
    "override_total_1": 8568.96,
    "override_increase_1": 236.43
  },
  {
    "#": "128 Coolidge St (068-06-00)",
    "$": 2442200,
    "address": "128 Coolidge St",
    "parcel_id": "068-06-00",
    "owner1": "MULLIN, THOMAS",
    "owner2": "MULLIN, MARY ANN",
    "current_taxes": 21373.19,
    "new_taxes_no_override": 22296.51,
    "override_total_1": 22929.16,
    "override_increase_1": 632.65
  },
  {
    "#": "132 Coolidge St (068-05-00)",
    "$": 3079600,
    "address": "132 Coolidge St",
    "parcel_id": "068-05-00",
    "owner1": "ELDAR LISSAI, ADI",
    "owner2": "LISSAI, GIDON",
    "current_taxes": 27900.17,
    "new_taxes_no_override": 29105.46,
    "override_total_1": 29931.3,
    "override_increase_1": 825.85
  },
  {
    "#": "133 Coolidge St, Unit 1 (065-06-01)",
    "$": 1043700,
    "address": "133 Coolidge St, Unit 1",
    "parcel_id": "065-06-01",
    "owner1": "WEI, XINGYU",
    "owner2": "",
    "current_taxes": 7052.55,
    "new_taxes_no_override": 7357.22,
    "override_total_1": 7565.98,
    "override_increase_1": 208.76
  },
  {
    "#": "133 Coolidge St, Unit 2 (065-06-02)",
    "$": 1035400,
    "address": "133 Coolidge St, Unit 2",
    "parcel_id": "065-06-02",
    "owner1": "KINDREGAN, JOHN F",
    "owner2": "",
    "current_taxes": 6967.56,
    "new_taxes_no_override": 7268.56,
    "override_total_1": 7474.8,
    "override_increase_1": 206.24
  },
  {
    "#": "136 Coolidge St (068-04-00)",
    "$": 2143800,
    "address": "136 Coolidge St",
    "parcel_id": "068-04-00",
    "owner1": "WIENER TRS, MARVIN E & CLAIRE M",
    "owner2": "",
    "current_taxes": 18317.58,
    "new_taxes_no_override": 19108.9,
    "override_total_1": 19651.1,
    "override_increase_1": 542.2
  },
  {
    "#": "137 Coolidge St (065-07-00)",
    "$": 2483600,
    "address": "137 Coolidge St",
    "parcel_id": "065-07-00",
    "owner1": "RUTHCHILD, ROCHELLE G",
    "owner2": "",
    "current_taxes": 21797.13,
    "new_taxes_no_override": 22738.77,
    "override_total_1": 23383.96,
    "override_increase_1": 645.2
  },
  {
    "#": "142 Coolidge St (068-27-00)",
    "$": 4425400,
    "address": "142 Coolidge St",
    "parcel_id": "068-27-00",
    "owner1": "COOLIDGE 142-144 LLC",
    "owner2": "",
    "current_taxes": 45316.1,
    "new_taxes_no_override": 47273.76,
    "override_total_1": 48615.11,
    "override_increase_1": 1341.36
  },
  {
    "#": "143 Coolidge St (065-08-00)",
    "$": 2225300,
    "address": "143 Coolidge St",
    "parcel_id": "065-08-00",
    "owner1": "143 COOLIDGE LLC",
    "owner2": "",
    "current_taxes": 22787.07,
    "new_taxes_no_override": 23771.47,
    "override_total_1": 24445.97,
    "override_increase_1": 674.5
  },
  {
    "#": "144 Coolidge St (068-26-00)",
    "$": 2663300,
    "address": "144 Coolidge St",
    "parcel_id": "068-26-00",
    "owner1": "COOLIDGE 142-144 LLC",
    "owner2": "",
    "current_taxes": 27272.19,
    "new_taxes_no_override": 28450.35,
    "override_total_1": 29257.61,
    "override_increase_1": 807.26
  },
  {
    "#": "146 Coolidge St (068-25-00)",
    "$": 2248200,
    "address": "146 Coolidge St",
    "parcel_id": "068-25-00",
    "owner1": "LOOMOS TR, NICHOLAS",
    "owner2": "",
    "current_taxes": 23021.57,
    "new_taxes_no_override": 24016.1,
    "override_total_1": 24697.54,
    "override_increase_1": 681.44
  },
  {
    "#": "147 Coolidge St (065-09-00)",
    "$": 2331200,
    "address": "147 Coolidge St",
    "parcel_id": "065-09-00",
    "owner1": "JALALI, PADIDEH",
    "owner2": "",
    "current_taxes": 20236.55,
    "new_taxes_no_override": 21110.77,
    "override_total_1": 21709.77,
    "override_increase_1": 599.0
  },
  {
    "#": "155 Coolidge St (061-06-00)",
    "$": 2522900,
    "address": "155 Coolidge St",
    "parcel_id": "061-06-00",
    "owner1": "WINSTON TR, RICHARD L",
    "owner2": "",
    "current_taxes": 25834.5,
    "new_taxes_no_override": 26950.55,
    "override_total_1": 27715.25,
    "override_increase_1": 764.7
  },
  {
    "#": "156 Coolidge St (060-09-00)",
    "$": 2994500,
    "address": "156 Coolidge St",
    "parcel_id": "060-09-00",
    "owner1": "LEE TRS, BING K B& KIN K&LILY M L",
    "owner2": "",
    "current_taxes": 27028.75,
    "new_taxes_no_override": 28196.39,
    "override_total_1": 28996.44,
    "override_increase_1": 800.05
  },
  {
    "#": "159 Coolidge St (061-05-00)",
    "$": 2320200,
    "address": "159 Coolidge St",
    "parcel_id": "061-05-00",
    "owner1": "ARNFELD, GEN PARTNERS, LEO & LORRAINE",
    "owner2": "",
    "current_taxes": 23758.85,
    "new_taxes_no_override": 24785.23,
    "override_total_1": 25488.49,
    "override_increase_1": 703.26
  },
  {
    "#": "162 Coolidge St, Unit 162 (060-10-01)",
    "$": 1590700,
    "address": "162 Coolidge St, Unit 162",
    "parcel_id": "060-10-01",
    "owner1": "KAUFMAN TR, SUSAN L",
    "owner2": "SCHULTZ TR, LAURA E",
    "current_taxes": 12653.83,
    "new_taxes_no_override": 13200.48,
    "override_total_1": 13575.03,
    "override_increase_1": 374.55
  },
  {
    "#": "162 Coolidge St, Unit 164 (060-10-02)",
    "$": 1694600,
    "address": "162 Coolidge St, Unit 164",
    "parcel_id": "060-10-02",
    "owner1": "LI, JONATHAN",
    "owner2": "LEVASSEUR, JESSICA",
    "current_taxes": 13717.77,
    "new_taxes_no_override": 14310.38,
    "override_total_1": 14716.42,
    "override_increase_1": 406.05
  },
  {
    "#": "163 Coolidge St (061-04-00)",
    "$": 2732200,
    "address": "163 Coolidge St",
    "parcel_id": "061-04-00",
    "owner1": "ARNFELD, GEN PARTNERS, LEO & LORRAINE",
    "owner2": "",
    "current_taxes": 27977.73,
    "new_taxes_no_override": 29186.37,
    "override_total_1": 30014.51,
    "override_increase_1": 828.14
  },
  {
    "#": "165 Coolidge St (061-03-00)",
    "$": 1346400,
    "address": "165 Coolidge St",
    "parcel_id": "061-03-00",
    "owner1": "HANEY TR, MATTHEW",
    "owner2": "",
    "current_taxes": 13787.14,
    "new_taxes_no_override": 14382.74,
    "override_total_1": 14790.84,
    "override_increase_1": 408.1
  },
  {
    "#": "166 Coolidge St, Unit 1-166 (060-11-01)",
    "$": 1251900,
    "address": "166 Coolidge St, Unit 1-166",
    "parcel_id": "060-11-01",
    "owner1": "PEMSTEIN TR, LISA B",
    "owner2": "",
    "current_taxes": 9184.52,
    "new_taxes_no_override": 9581.29,
    "override_total_1": 9853.15,
    "override_increase_1": 271.86
  },
  {
    "#": "168 Coolidge St, Unit 2-168 (060-11-02)",
    "$": 1455200,
    "address": "168 Coolidge St, Unit 2-168",
    "parcel_id": "060-11-02",
    "owner1": "BEHRMAN TRS, RICHARD H",
    "owner2": "DOUKAS, ANDREA V",
    "current_taxes": 11266.31,
    "new_taxes_no_override": 11753.01,
    "override_total_1": 12086.5,
    "override_increase_1": 333.48
  },
  {
    "#": "170 Coolidge St (060-12-00)",
    "$": 2012100,
    "address": "170 Coolidge St",
    "parcel_id": "060-12-00",
    "owner1": "SHONER TRS, JOEL & ELLEN",
    "owner2": "",
    "current_taxes": 20603.9,
    "new_taxes_no_override": 21493.99,
    "override_total_1": 22103.86,
    "override_increase_1": 609.88
  },
  {
    "#": "176 Coolidge St (060-13-00)",
    "$": 2881100,
    "address": "176 Coolidge St",
    "parcel_id": "060-13-00",
    "owner1": "176 COOLIDGE STREET LLC",
    "owner2": "C/O LYNCH FINK HARRINGTON & GRAY LLP",
    "current_taxes": 29502.46,
    "new_taxes_no_override": 30776.97,
    "override_total_1": 31650.24,
    "override_increase_1": 873.27
  },
  {
    "#": "177 Coolidge St (061-01-00)",
    "$": 2570800,
    "address": "177 Coolidge St",
    "parcel_id": "061-01-00",
    "owner1": "OHALLORAN TRS, JEAN J & BRIAN T",
    "owner2": "",
    "current_taxes": 22690.06,
    "new_taxes_no_override": 23670.27,
    "override_total_1": 24341.9,
    "override_increase_1": 671.63
  },
  {
    "#": "3 Copley St (030-03-00)",
    "$": 2280900,
    "address": "3 Copley St",
    "parcel_id": "030-03-00",
    "owner1": "ZARRILLO TR, MARK J",
    "owner2": "",
    "current_taxes": 19721.48,
    "new_taxes_no_override": 20573.45,
    "override_total_1": 21157.2,
    "override_increase_1": 583.76
  },
  {
    "#": "4 Copley St (031-01-00)",
    "$": 2429500,
    "address": "4 Copley St",
    "parcel_id": "031-01-00",
    "owner1": "SIRAJ TRS, RAAD A",
    "owner2": "MAKARECHIAN, ABAN",
    "current_taxes": 21243.15,
    "new_taxes_no_override": 22160.85,
    "override_total_1": 22789.65,
    "override_increase_1": 628.8
  },
  {
    "#": "10 Copley St (031-13-00)",
    "$": 2334800,
    "address": "10 Copley St",
    "parcel_id": "031-13-00",
    "owner1": "WOOD, DARIEN",
    "owner2": "BARBERIS, EMANUELA",
    "current_taxes": 20273.42,
    "new_taxes_no_override": 21149.23,
    "override_total_1": 21749.32,
    "override_increase_1": 600.09
  },
  {
    "#": "11 Copley St (030-04-00)",
    "$": 3196000,
    "address": "11 Copley St",
    "parcel_id": "030-04-00",
    "owner1": "PEASE, ROBERT M",
    "owner2": "WINGARD, CAROL A",
    "current_taxes": 32727.04,
    "new_taxes_no_override": 34140.85,
    "override_total_1": 35109.57,
    "override_increase_1": 968.72
  },
  {
    "#": "16 Copley St (031-12-00)",
    "$": 2948300,
    "address": "16 Copley St",
    "parcel_id": "031-12-00",
    "owner1": "CLANCY, ANDRIA",
    "owner2": "",
    "current_taxes": 30190.59,
    "new_taxes_no_override": 31494.82,
    "override_total_1": 32388.46,
    "override_increase_1": 893.64
  },
  {
    "#": "19 Copley St (030-05-00)",
    "$": 2294700,
    "address": "19 Copley St",
    "parcel_id": "030-05-00",
    "owner1": "MILLER, ROBERT MYLES",
    "owner2": "WINITZER, JILL",
    "current_taxes": 19862.79,
    "new_taxes_no_override": 20720.86,
    "override_total_1": 21308.8,
    "override_increase_1": 587.94
  },
  {
    "#": "20 Copley St (031-11-00)",
    "$": 2453800,
    "address": "20 Copley St",
    "parcel_id": "031-11-00",
    "owner1": "HOLLISTER TRS, ROBERT M",
    "owner2": "DONAHER, CATHERINE",
    "current_taxes": 21491.98,
    "new_taxes_no_override": 22420.43,
    "override_total_1": 23056.6,
    "override_increase_1": 636.16
  },
  {
    "#": "25 Copley St (030-06-00)",
    "$": 2773900,
    "address": "25 Copley St",
    "parcel_id": "030-06-00",
    "owner1": "WEINBERG TRS, AMY SHULMAN & ROBERT A",
    "owner2": "",
    "current_taxes": 24769.8,
    "new_taxes_no_override": 25839.86,
    "override_total_1": 26573.04,
    "override_increase_1": 733.19
  },
  {
    "#": "28 Copley St (031-10-00)",
    "$": 2733300,
    "address": "28 Copley St",
    "parcel_id": "031-10-00",
    "owner1": "GLADSTONE, CAROL W",
    "owner2": "WHIPPLE, BEN C",
    "current_taxes": 24354.06,
    "new_taxes_no_override": 25406.16,
    "override_total_1": 26127.04,
    "override_increase_1": 720.88
  },
  {
    "#": "29 Copley St (030-07-00)",
    "$": 2515200,
    "address": "29 Copley St",
    "parcel_id": "030-07-00",
    "owner1": "LIVERMORE TR, JEANNE M",
    "owner2": "",
    "current_taxes": 25755.65,
    "new_taxes_no_override": 26868.29,
    "override_total_1": 27630.66,
    "override_increase_1": 762.37
  },
  {
    "#": "9 Corey Rd, Unit 1 (102-26-18)",
    "$": 627400,
    "address": "9 Corey Rd, Unit 1",
    "parcel_id": "102-26-18",
    "owner1": "PARIKH, RAJIV SUDHIR & BHAIRAVI RAJIV & SHIVANI",
    "owner2": "",
    "current_taxes": 2789.64,
    "new_taxes_no_override": 2910.15,
    "override_total_1": 2992.73,
    "override_increase_1": 82.57
  },
  {
    "#": "9 Corey Rd, Unit 2 (102-26-19)",
    "$": 565100,
    "address": "9 Corey Rd, Unit 2",
    "parcel_id": "102-26-19",
    "owner1": "KARIM, OBAID",
    "owner2": "",
    "current_taxes": 5786.62,
    "new_taxes_no_override": 6036.6,
    "override_total_1": 6207.89,
    "override_increase_1": 171.28
  },
  {
    "#": "9 Corey Rd, Unit 3 (102-26-20)",
    "$": 617000,
    "address": "9 Corey Rd, Unit 3",
    "parcel_id": "102-26-20",
    "owner1": "DELLOSTRITTO, LAURA",
    "owner2": "",
    "current_taxes": 2683.15,
    "new_taxes_no_override": 2799.06,
    "override_total_1": 2878.48,
    "override_increase_1": 79.42
  },
  {
    "#": "9 Corey Rd, Unit 4 (102-26-21)",
    "$": 657000,
    "address": "9 Corey Rd, Unit 4",
    "parcel_id": "102-26-21",
    "owner1": "BADAKER, NATALIYA V & YUNA",
    "owner2": "C/O NATALIYA B BELKIN",
    "current_taxes": 6727.68,
    "new_taxes_no_override": 7018.32,
    "override_total_1": 7217.46,
    "override_increase_1": 199.14
  },
  {
    "#": "9 Corey Rd, Unit 5 (102-26-22)",
    "$": 639700,
    "address": "9 Corey Rd, Unit 5",
    "parcel_id": "102-26-22",
    "owner1": "WANG, CHENGFANG",
    "owner2": "",
    "current_taxes": 6550.53,
    "new_taxes_no_override": 6833.51,
    "override_total_1": 7027.41,
    "override_increase_1": 193.9
  },
  {
    "#": "9 Corey Rd, Unit 6 (102-26-23)",
    "$": 626000,
    "address": "9 Corey Rd, Unit 6",
    "parcel_id": "102-26-23",
    "owner1": "JAQUA, DAVID L",
    "owner2": "",
    "current_taxes": 6410.24,
    "new_taxes_no_override": 6687.16,
    "override_total_1": 6876.91,
    "override_increase_1": 189.74
  },
  {
    "#": "9 Corey Rd, Unit 7 (102-26-24)",
    "$": 657000,
    "address": "9 Corey Rd, Unit 7",
    "parcel_id": "102-26-24",
    "owner1": "LIU, LI",
    "owner2": "TAN, WEITIAN",
    "current_taxes": 3092.75,
    "new_taxes_no_override": 3226.36,
    "override_total_1": 3317.9,
    "override_increase_1": 91.55
  },
  {
    "#": "9 Corey Rd, Unit 9 (102-26-26)",
    "$": 641300,
    "address": "9 Corey Rd, Unit 9",
    "parcel_id": "102-26-26",
    "owner1": "MANDE, ARJUN H",
    "owner2": "PALLAVI, KALIA",
    "current_taxes": 2931.98,
    "new_taxes_no_override": 3058.64,
    "override_total_1": 3145.43,
    "override_increase_1": 86.79
  },
  {
    "#": "9 Corey Rd, Unit C-8 (102-26-25)",
    "$": 619700,
    "address": "9 Corey Rd, Unit C-8",
    "parcel_id": "102-26-25",
    "owner1": "PATEL, MONA M",
    "owner2": "",
    "current_taxes": 6345.73,
    "new_taxes_no_override": 6619.87,
    "override_total_1": 6807.7,
    "override_increase_1": 187.83
  },
  {
    "#": "12 Corey Rd (106-16-00)",
    "$": 2930600,
    "address": "12 Corey Rd",
    "parcel_id": "106-16-00",
    "owner1": "MANCUSI TRS, PETER J & MIRANDA DANILOFF",
    "owner2": "",
    "current_taxes": 26374.41,
    "new_taxes_no_override": 27513.78,
    "override_total_1": 28294.47,
    "override_increase_1": 780.68
  },
  {
    "#": "14 Corey Rd (106-15-00)",
    "$": 3299300,
    "address": "14 Corey Rd",
    "parcel_id": "106-15-00",
    "owner1": "KAHNE, DANIEL E & SUZANNE W",
    "owner2": "",
    "current_taxes": 30149.9,
    "new_taxes_no_override": 31452.38,
    "override_total_1": 32344.81,
    "override_increase_1": 892.44
  },
  {
    "#": "16 Corey Rd (106-14-00)",
    "$": 2797400,
    "address": "16 Corey Rd",
    "parcel_id": "106-14-00",
    "owner1": "BARDIN, JAMES W",
    "owner2": "CHANYASULKIT, CHRIS",
    "current_taxes": 25010.44,
    "new_taxes_no_override": 26090.89,
    "override_total_1": 26831.2,
    "override_increase_1": 740.31
  },
  {
    "#": "17 Corey Rd (102-27-00)",
    "$": 2671200,
    "address": "17 Corey Rd",
    "parcel_id": "102-27-00",
    "owner1": "RICH, MICHAEL O",
    "owner2": "SHRIER, LYDIA",
    "current_taxes": 23718.15,
    "new_taxes_no_override": 24742.77,
    "override_total_1": 25444.83,
    "override_increase_1": 702.06
  },
  {
    "#": "37 Corey Rd (103-04-00)",
    "$": 2627000,
    "address": "37 Corey Rd",
    "parcel_id": "103-04-00",
    "owner1": "GONZALEZ TR, MARILYN M",
    "owner2": "",
    "current_taxes": 23265.55,
    "new_taxes_no_override": 24270.62,
    "override_total_1": 24959.28,
    "override_increase_1": 688.66
  },
  {
    "#": "42 Corey Rd (105-15-00)",
    "$": 2413000,
    "address": "42 Corey Rd",
    "parcel_id": "105-15-00",
    "owner1": "HUSSAIN TR, IFFAT A",
    "owner2": "",
    "current_taxes": 21074.19,
    "new_taxes_no_override": 21984.6,
    "override_total_1": 22608.39,
    "override_increase_1": 623.8
  },
  {
    "#": "47 Corey Rd (103-05-00)",
    "$": 2980300,
    "address": "47 Corey Rd",
    "parcel_id": "103-05-00",
    "owner1": "STRECK, GARY & JILL",
    "owner2": "",
    "current_taxes": 26883.34,
    "new_taxes_no_override": 28044.7,
    "override_total_1": 28840.45,
    "override_increase_1": 795.75
  },
  {
    "#": "48 Corey Rd (105-14-00)",
    "$": 2655200,
    "address": "48 Corey Rd",
    "parcel_id": "105-14-00",
    "owner1": "RADLER, EDWARD C & MARIE",
    "owner2": "",
    "current_taxes": 23554.31,
    "new_taxes_no_override": 24571.86,
    "override_total_1": 25269.06,
    "override_increase_1": 697.21
  },
  {
    "#": "58 Corey Rd (104-01-00)",
    "$": 2103700,
    "address": "58 Corey Rd",
    "parcel_id": "104-01-00",
    "owner1": "BARON TR, JENNIFER",
    "owner2": "",
    "current_taxes": 21541.89,
    "new_taxes_no_override": 22472.5,
    "override_total_1": 23110.14,
    "override_increase_1": 637.64
  },
  {
    "#": "59 Corey Rd (099-10-00)",
    "$": 1786000,
    "address": "59 Corey Rd",
    "parcel_id": "099-10-00",
    "owner1": "SARGON, ROSALIND",
    "owner2": "",
    "current_taxes": 14653.71,
    "new_taxes_no_override": 15286.75,
    "override_total_1": 15720.5,
    "override_increase_1": 433.75
  },
  {
    "#": "17 Cotswold Rd (247-31-32)",
    "$": 3696600,
    "address": "17 Cotswold Rd",
    "parcel_id": "247-31-32",
    "owner1": "LEE, W DAVID",
    "owner2": "YOUNGERMAN, EVE F",
    "current_taxes": 34218.25,
    "new_taxes_no_override": 35696.48,
    "override_total_1": 36709.34,
    "override_increase_1": 1012.86
  },
  {
    "#": "20 Cotswold Rd (246-02-00)",
    "$": 2553700,
    "address": "20 Cotswold Rd",
    "parcel_id": "246-02-00",
    "owner1": "GLICK, STEPHEN J S",
    "owner2": "CLARKSON, JULIA A E",
    "current_taxes": 22514.95,
    "new_taxes_no_override": 23487.6,
    "override_total_1": 24154.04,
    "override_increase_1": 666.44
  },
  {
    "#": "25 Cotswold Rd (247-01-00)",
    "$": 3403700,
    "address": "25 Cotswold Rd",
    "parcel_id": "247-01-00",
    "owner1": "GUZMAN, RAUL J & MARY R BETH",
    "owner2": "",
    "current_taxes": 31218.95,
    "new_taxes_no_override": 32567.61,
    "override_total_1": 33491.69,
    "override_increase_1": 924.08
  },
  {
    "#": "46 Cotswold Rd (230-08-00)",
    "$": 3463000,
    "address": "46 Cotswold Rd",
    "parcel_id": "230-08-00",
    "owner1": "CHERRY, ELYSE D",
    "owner2": "",
    "current_taxes": 31826.19,
    "new_taxes_no_override": 33201.08,
    "override_total_1": 34143.14,
    "override_increase_1": 942.06
  },
  {
    "#": "47 Cotswold Rd (231-02-00)",
    "$": 2746000,
    "address": "47 Cotswold Rd",
    "parcel_id": "231-02-00",
    "owner1": "DORFMAN, JEREMY B & KATHERINE STEWART",
    "owner2": "",
    "current_taxes": 24484.11,
    "new_taxes_no_override": 25541.82,
    "override_total_1": 26266.55,
    "override_increase_1": 724.73
  },
  {
    "#": "54 Cotswold Rd (230-07-00)",
    "$": 2913400,
    "address": "54 Cotswold Rd",
    "parcel_id": "230-07-00",
    "owner1": "SILVERMAN, STEPHEN M",
    "owner2": "SISSON, BARBARA",
    "current_taxes": 26198.28,
    "new_taxes_no_override": 27330.05,
    "override_total_1": 28105.51,
    "override_increase_1": 775.47
  },
  {
    "#": "10 Cottage Farm Rd (012-05-01)",
    "$": 7319300,
    "address": "10 Cottage Farm Rd",
    "parcel_id": "012-05-01",
    "owner1": "BOSTON UNIVERSITY TRS",
    "owner2": "C/O GENERAL ACCOUNTING 4TH FLR",
    "current_taxes": 74949.63,
    "new_taxes_no_override": 78187.45,
    "override_total_1": 80405.96,
    "override_increase_1": 2218.51
  },
  {
    "#": "24 Cottage Farm Rd (012-05-00)",
    "$": 10131600,
    "address": "24 Cottage Farm Rd",
    "parcel_id": "012-05-00",
    "owner1": "BOSTON UNIVERSITY TRS",
    "owner2": "C/O GENERAL ACCOUNTING 4TH FLR",
    "current_taxes": 103747.58,
    "new_taxes_no_override": 108229.48,
    "override_total_1": 111300.4,
    "override_increase_1": 3070.93
  },
  {
    "#": "43 Cottage Farm Rd (015-01-00)",
    "$": 4406700,
    "address": "43 Cottage Farm Rd",
    "parcel_id": "015-01-00",
    "owner1": "SHELDON TRS, JONATHAN A & SARAH M",
    "owner2": "",
    "current_taxes": 41489.67,
    "new_taxes_no_override": 43282.02,
    "override_total_1": 44510.12,
    "override_increase_1": 1228.09
  },
  {
    "#": "51 Cottage Farm Rd (015-02-00)",
    "$": 2533000,
    "address": "51 Cottage Farm Rd",
    "parcel_id": "015-02-00",
    "owner1": "OLAFSSON  LIFE ESTATE, THOMAS R JR & LOUISE A",
    "owner2": "",
    "current_taxes": 22302.99,
    "new_taxes_no_override": 23266.48,
    "override_total_1": 23926.65,
    "override_increase_1": 660.17
  },
  {
    "#": "54 Cottage Farm Rd (016-03-00)",
    "$": 3176100,
    "address": "54 Cottage Farm Rd",
    "parcel_id": "016-03-00",
    "owner1": "MUFSON TRS, MICHAEL & MARILYN J",
    "owner2": "",
    "current_taxes": 28888.33,
    "new_taxes_no_override": 30136.31,
    "override_total_1": 30991.4,
    "override_increase_1": 855.09
  },
  {
    "#": "55 Cottage Farm Rd (015-02-01)",
    "$": 2464900,
    "address": "55 Cottage Farm Rd",
    "parcel_id": "015-02-01",
    "owner1": "PMU REALTY LLC",
    "owner2": "",
    "current_taxes": 25240.58,
    "new_taxes_no_override": 26330.97,
    "override_total_1": 27078.09,
    "override_increase_1": 747.12
  },
  {
    "#": "25 Cottage St (351-12-02)",
    "$": 6782700,
    "address": "25 Cottage St",
    "parcel_id": "351-12-02",
    "owner1": "BALL TR, ROBERT P",
    "owner2": "",
    "current_taxes": 69454.85,
    "new_taxes_no_override": 72455.3,
    "override_total_1": 74511.16,
    "override_increase_1": 2055.86
  },
  {
    "#": "39 Cottage St (352-01-02)",
    "$": 5652700,
    "address": "39 Cottage St",
    "parcel_id": "352-01-02",
    "owner1": "WARREN COTTAGE VENTURES LLC",
    "owner2": "",
    "current_taxes": 57883.65,
    "new_taxes_no_override": 60384.22,
    "override_total_1": 62097.58,
    "override_increase_1": 1713.36
  },
  {
    "#": "40 Cottage St (332-03-09)",
    "$": 36294800,
    "address": "40 Cottage St",
    "parcel_id": "332-03-09",
    "owner1": "SUMMERA LLC",
    "owner2": "",
    "current_taxes": 371658.75,
    "new_taxes_no_override": 387714.41,
    "override_total_1": 398715.51,
    "override_increase_1": 11001.1
  },
  {
    "#": "45 Cottage St (352-02-00)",
    "$": 11897300,
    "address": "45 Cottage St",
    "parcel_id": "352-02-00",
    "owner1": "GEISBERG, SAMUEL P & MIRA A",
    "owner2": "",
    "current_taxes": 118193.42,
    "new_taxes_no_override": 123299.38,
    "override_total_1": 126797.9,
    "override_increase_1": 3498.53
  },
  {
    "#": "63 Cottage St (352-17-00)",
    "$": 3243300,
    "address": "63 Cottage St",
    "parcel_id": "352-17-00",
    "owner1": "GEISBERG, SAMUEL & MIRA",
    "owner2": "",
    "current_taxes": 33211.39,
    "new_taxes_no_override": 34646.12,
    "override_total_1": 35629.18,
    "override_increase_1": 983.06
  },
  {
    "#": "75 Cottage St (352-16-00)",
    "$": 6907900,
    "address": "75 Cottage St",
    "parcel_id": "352-16-00",
    "owner1": "CHAUDHURY, ANJAN",
    "owner2": "SHAH, SANDHYA",
    "current_taxes": 67101.96,
    "new_taxes_no_override": 70000.76,
    "override_total_1": 71986.98,
    "override_increase_1": 1986.22
  },
  {
    "#": "80 Cottage St (332-02-00)",
    "$": 3000700,
    "address": "80 Cottage St",
    "parcel_id": "332-02-00",
    "owner1": "YIN, BAOHONG",
    "owner2": "",
    "current_taxes": 30727.17,
    "new_taxes_no_override": 32054.58,
    "override_total_1": 32964.11,
    "override_increase_1": 909.52
  },
  {
    "#": "85 Cottage St (352-04-00)",
    "$": 6839600,
    "address": "85 Cottage St",
    "parcel_id": "352-04-00",
    "owner1": "REEDERS, STEPHEN T & JING-ZHOU",
    "owner2": "",
    "current_taxes": 66402.57,
    "new_taxes_no_override": 69271.16,
    "override_total_1": 71236.68,
    "override_increase_1": 1965.52
  },
  {
    "#": "88 Cottage St (332-01-00)",
    "$": 24660100,
    "address": "88 Cottage St",
    "parcel_id": "332-01-00",
    "owner1": "YIN, BAOHONG",
    "owner2": "",
    "current_taxes": 252519.42,
    "new_taxes_no_override": 263428.26,
    "override_total_1": 270902.83,
    "override_increase_1": 7474.57
  },
  {
    "#": "100 Cottage St (331-06-01)",
    "$": 7732300,
    "address": "100 Cottage St",
    "parcel_id": "331-06-01",
    "owner1": "WYRICK TR, JULIE",
    "owner2": "",
    "current_taxes": 79178.75,
    "new_taxes_no_override": 82599.27,
    "override_total_1": 84942.96,
    "override_increase_1": 2343.69
  },
  {
    "#": "120 Cottage St (331-06-02)",
    "$": 1375100,
    "address": "120 Cottage St",
    "parcel_id": "331-06-02",
    "owner1": "BROOKLINE CONSERVATION LAND TR",
    "owner2": "EDWARD LAWRENCE, TRS, EDWARD P",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "126 Cottage St (331-06-00)",
    "$": 4588100,
    "address": "126 Cottage St",
    "parcel_id": "331-06-00",
    "owner1": "SOMANI, ALOK K",
    "owner2": "DEVITRE, ARSHEYA D",
    "current_taxes": 43347.21,
    "new_taxes_no_override": 45219.81,
    "override_total_1": 46502.89,
    "override_increase_1": 1283.08
  },
  {
    "#": "144 Cottage St (331-10-00)",
    "$": 6167000,
    "address": "144 Cottage St",
    "parcel_id": "331-10-00",
    "owner1": "DYMECKI, SUSAN M",
    "owner2": "",
    "current_taxes": 59515.15,
    "new_taxes_no_override": 62086.2,
    "override_total_1": 63847.85,
    "override_increase_1": 1761.65
  },
  {
    "#": "150 Cottage St (331-09-01)",
    "$": 2697000,
    "address": "150 Cottage St",
    "parcel_id": "331-09-01",
    "owner1": "ARGIROS TR, ALEXANDER A",
    "owner2": "",
    "current_taxes": 27617.28,
    "new_taxes_no_override": 28810.35,
    "override_total_1": 29627.82,
    "override_increase_1": 817.47
  },
  {
    "#": "152 Cottage St (331-09-00)",
    "$": 1123400,
    "address": "152 Cottage St",
    "parcel_id": "331-09-00",
    "owner1": "BASS TRS, MICHAEL A",
    "owner2": "SAUNDERS, GARY L",
    "current_taxes": 11503.62,
    "new_taxes_no_override": 12000.58,
    "override_total_1": 12341.08,
    "override_increase_1": 340.51
  },
  {
    "#": "3 Country Rd (340-01-00)",
    "$": 984200,
    "address": "3 Country Rd",
    "parcel_id": "340-01-00",
    "owner1": "SULLIVAN, JOHN P & JULI A",
    "owner2": "",
    "current_taxes": 6443.27,
    "new_taxes_no_override": 6721.62,
    "override_total_1": 6912.34,
    "override_increase_1": 190.72
  },
  {
    "#": "10 Country Rd (347-03-00)",
    "$": 2027000,
    "address": "10 Country Rd",
    "parcel_id": "347-03-00",
    "owner1": "POUCHE, KEVIN J",
    "owner2": "",
    "current_taxes": 20756.48,
    "new_taxes_no_override": 21653.16,
    "override_total_1": 22267.55,
    "override_increase_1": 614.39
  },
  {
    "#": "11 Country Rd (340-02-00)",
    "$": 982600,
    "address": "11 Country Rd",
    "parcel_id": "340-02-00",
    "owner1": "SEVERINGHAUS, CHARLES L & CAROL ANN",
    "owner2": "",
    "current_taxes": 6426.89,
    "new_taxes_no_override": 6704.53,
    "override_total_1": 6894.77,
    "override_increase_1": 190.24
  },
  {
    "#": "17 Country Rd (340-03-00)",
    "$": 855900,
    "address": "17 Country Rd",
    "parcel_id": "340-03-00",
    "owner1": "MCMAHON, JOSEPH J & REGINA M",
    "owner2": "",
    "current_taxes": 5129.48,
    "new_taxes_no_override": 5351.07,
    "override_total_1": 5502.91,
    "override_increase_1": 151.83
  },
  {
    "#": "18 Country Rd (347-02-00)",
    "$": 1289600,
    "address": "18 Country Rd",
    "parcel_id": "347-02-00",
    "owner1": "PANG TRS, PUIKONG THOMAS",
    "owner2": "LUK TRS, WENDY PIK CHAY",
    "current_taxes": 9570.57,
    "new_taxes_no_override": 9984.02,
    "override_total_1": 10267.31,
    "override_increase_1": 283.29
  },
  {
    "#": "30 Country Rd (346-09-00)",
    "$": 2158800,
    "address": "30 Country Rd",
    "parcel_id": "346-09-00",
    "owner1": "ZHANG, LIHUI",
    "owner2": "",
    "current_taxes": 18471.18,
    "new_taxes_no_override": 19269.13,
    "override_total_1": 19815.88,
    "override_increase_1": 546.75
  },
  {
    "#": "35 Country Rd (341-03-00)",
    "$": 1189200,
    "address": "35 Country Rd",
    "parcel_id": "341-03-00",
    "owner1": "TOM, TEDDY & NANCY",
    "owner2": "YICK, K",
    "current_taxes": 8542.47,
    "new_taxes_no_override": 8911.5,
    "override_total_1": 9164.36,
    "override_increase_1": 252.86
  },
  {
    "#": "36 Country Rd (346-07-08)",
    "$": 953800,
    "address": "36 Country Rd",
    "parcel_id": "346-07-08",
    "owner1": "RAFFERTY, MICHAEL J & JULIE F",
    "owner2": "",
    "current_taxes": 6131.98,
    "new_taxes_no_override": 6396.88,
    "override_total_1": 6578.39,
    "override_increase_1": 181.51
  },
  {
    "#": "17 Crafts Rd (278C-25-00)",
    "$": 2268200,
    "address": "17 Crafts Rd",
    "parcel_id": "278C-25-00",
    "owner1": "GALLUCCI, GERMAN O & MILICA",
    "owner2": "",
    "current_taxes": 19591.43,
    "new_taxes_no_override": 20437.78,
    "override_total_1": 21017.69,
    "override_increase_1": 579.91
  },
  {
    "#": "19 Crafts Rd (278C-36-37)",
    "$": 4252600,
    "address": "19 Crafts Rd",
    "parcel_id": "278C-36-37",
    "owner1": "CARVOLTH, PYRS",
    "owner2": "BUERMAN, GRETA & GUNTHER",
    "current_taxes": 39911.69,
    "new_taxes_no_override": 41635.88,
    "override_total_1": 42817.26,
    "override_increase_1": 1181.39
  },
  {
    "#": "20 Crafts Rd (279-05-01)",
    "$": 2913600,
    "address": "20 Crafts Rd",
    "parcel_id": "279-05-01",
    "owner1": "RYAN, KEVIN A & MARILYN S",
    "owner2": "",
    "current_taxes": 26200.33,
    "new_taxes_no_override": 27332.18,
    "override_total_1": 28107.71,
    "override_increase_1": 775.53
  },
  {
    "#": "21 Crafts Rd (278C-35-00)",
    "$": 4900100,
    "address": "21 Crafts Rd",
    "parcel_id": "278C-35-00",
    "owner1": "THOMPSON, JEFFREY L & ELISABETH A",
    "owner2": "",
    "current_taxes": 46542.09,
    "new_taxes_no_override": 48552.71,
    "override_total_1": 49930.35,
    "override_increase_1": 1377.65
  },
  {
    "#": "23 Crafts Rd (278C-29-02)",
    "$": 5761600,
    "address": "23 Crafts Rd",
    "parcel_id": "278C-29-02",
    "owner1": "HAGERTY, THOMAS M & JEANNE",
    "owner2": "",
    "current_taxes": 55363.85,
    "new_taxes_no_override": 57755.57,
    "override_total_1": 59394.34,
    "override_increase_1": 1638.77
  },
  {
    "#": "24 Crafts Rd (279-05-00)",
    "$": 4281500,
    "address": "24 Crafts Rd",
    "parcel_id": "279-05-00",
    "owner1": "GREENBERG, ILENE  R",
    "owner2": "",
    "current_taxes": 40207.63,
    "new_taxes_no_override": 41944.6,
    "override_total_1": 43134.75,
    "override_increase_1": 1190.15
  },
  {
    "#": "27 Crafts Rd (278C-26-00)",
    "$": 2709300,
    "address": "27 Crafts Rd",
    "parcel_id": "278C-26-00",
    "owner1": "SEGAL, MICHAEL M & LYNN F",
    "owner2": "",
    "current_taxes": 24108.3,
    "new_taxes_no_override": 25149.78,
    "override_total_1": 25863.38,
    "override_increase_1": 713.61
  },
  {
    "#": "32 Crafts Rd (279-04-00)",
    "$": 3636400,
    "address": "32 Crafts Rd",
    "parcel_id": "279-04-00",
    "owner1": "BLUM, NANCY R",
    "owner2": "",
    "current_taxes": 33601.8,
    "new_taxes_no_override": 35053.4,
    "override_total_1": 36048.01,
    "override_increase_1": 994.61
  },
  {
    "#": "35 Crafts Rd (278C-27-00)",
    "$": 4212300,
    "address": "35 Crafts Rd",
    "parcel_id": "278C-27-00",
    "owner1": "ZUG, DAVID B & MEGAN C",
    "owner2": "",
    "current_taxes": 39499.02,
    "new_taxes_no_override": 41205.38,
    "override_total_1": 42374.55,
    "override_increase_1": 1169.17
  },
  {
    "#": "40 Crafts Rd (279-03-00)",
    "$": 2262800,
    "address": "40 Crafts Rd",
    "parcel_id": "279-03-00",
    "owner1": "YANG, ZHAOYU",
    "owner2": "",
    "current_taxes": 19536.14,
    "new_taxes_no_override": 20380.1,
    "override_total_1": 20958.37,
    "override_increase_1": 578.27
  },
  {
    "#": "41 Crafts Rd (278C-28-00)",
    "$": 2305700,
    "address": "41 Crafts Rd",
    "parcel_id": "278C-28-00",
    "owner1": "ASHBY TRS, JOHN H & ROSEMARY",
    "owner2": "",
    "current_taxes": 19975.43,
    "new_taxes_no_override": 20838.37,
    "override_total_1": 21429.64,
    "override_increase_1": 591.27
  },
  {
    "#": "42 Crafts Rd (279-02-00)",
    "$": 2005600,
    "address": "42 Crafts Rd",
    "parcel_id": "279-02-00",
    "owner1": "GARVEY, PETER B",
    "owner2": "GARVEY-DOWD, MARIA T",
    "current_taxes": 20537.34,
    "new_taxes_no_override": 21424.55,
    "override_total_1": 22032.46,
    "override_increase_1": 607.91
  },
  {
    "#": "46 Crafts Rd (279-01-00)",
    "$": 3340500,
    "address": "46 Crafts Rd",
    "parcel_id": "279-01-00",
    "owner1": "MAY, DORIS S",
    "owner2": "",
    "current_taxes": 30571.79,
    "new_taxes_no_override": 31892.49,
    "override_total_1": 32797.42,
    "override_increase_1": 904.92
  },
  {
    "#": "47 Crafts Rd (278C-29-00)",
    "$": 3840000,
    "address": "47 Crafts Rd",
    "parcel_id": "278C-29-00",
    "owner1": "CLARKSON JR, BAYARD D",
    "owner2": "AUSTRIAN, SUSAN",
    "current_taxes": 35686.67,
    "new_taxes_no_override": 37228.33,
    "override_total_1": 38284.66,
    "override_increase_1": 1056.33
  },
  {
    "#": "65 Crafts Rd (278D-01-00)",
    "$": 4567700,
    "address": "65 Crafts Rd",
    "parcel_id": "278D-01-00",
    "owner1": "HRESKO, M TIMOTHY",
    "owner2": "GRAVALLESE, ELLEN M",
    "current_taxes": 43138.31,
    "new_taxes_no_override": 45001.88,
    "override_total_1": 46278.78,
    "override_increase_1": 1276.89
  },
  {
    "#": "76 Crafts Rd (280-19-20)",
    "$": 4845200,
    "address": "76 Crafts Rd",
    "parcel_id": "280-19-20",
    "owner1": "SALAM, ANTONINA",
    "owner2": "",
    "current_taxes": 45979.91,
    "new_taxes_no_override": 47966.24,
    "override_total_1": 49327.25,
    "override_increase_1": 1361.01
  },
  {
    "#": "79 Crafts Rd (278D-02-00)",
    "$": 5762200,
    "address": "79 Crafts Rd",
    "parcel_id": "278D-02-00",
    "owner1": "THE REPUBLIC OF TURKEY",
    "owner2": "C/O EMBASSY OF THE REPUBLIC OF, TURKEY",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "96 Crafts Rd (280-18-00)",
    "$": 5344600,
    "address": "96 Crafts Rd",
    "parcel_id": "280-18-00",
    "owner1": "MALLOY, CHRISTOPHER & MOLLY",
    "owner2": "",
    "current_taxes": 51093.77,
    "new_taxes_no_override": 53301.02,
    "override_total_1": 54813.4,
    "override_increase_1": 1512.38
  },
  {
    "#": "99 Crafts Rd (278D-03-00)",
    "$": 6553200,
    "address": "99 Crafts Rd",
    "parcel_id": "278D-03-00",
    "owner1": "CALVILLO, RICARDO C & KATHERINA",
    "owner2": "",
    "current_taxes": 67104.77,
    "new_taxes_no_override": 70003.7,
    "override_total_1": 71990.0,
    "override_increase_1": 1986.3
  },
  {
    "#": "106 Crafts Rd (280-17-00)",
    "$": 4526000,
    "address": "106 Crafts Rd",
    "parcel_id": "280-17-00",
    "owner1": "BRIGGIN, CLIFFORD S & IRENE",
    "owner2": "",
    "current_taxes": 42711.31,
    "new_taxes_no_override": 44556.44,
    "override_total_1": 45820.69,
    "override_increase_1": 1264.25
  },
  {
    "#": "107 Crafts Rd (278D-05-00)",
    "$": 4955400,
    "address": "107 Crafts Rd",
    "parcel_id": "278D-05-00",
    "owner1": "CAVANAGH, RICHARD E & PATRICIA ANN",
    "owner2": "",
    "current_taxes": 47108.36,
    "new_taxes_no_override": 49143.44,
    "override_total_1": 50537.85,
    "override_increase_1": 1394.41
  },
  {
    "#": "116 Crafts Rd (280-16-00)",
    "$": 1374200,
    "address": "116 Crafts Rd",
    "parcel_id": "280-16-00",
    "owner1": "HARPER TRS, GORDON P & MARY JILL ROBINSON",
    "owner2": "",
    "current_taxes": 14071.81,
    "new_taxes_no_override": 14679.71,
    "override_total_1": 15096.24,
    "override_increase_1": 416.53
  },
  {
    "#": "119 Crafts Rd (278D-06-00)",
    "$": 2990900,
    "address": "119 Crafts Rd",
    "parcel_id": "278D-06-00",
    "owner1": "SMITH, JAMES P",
    "owner2": "MILLER, JOAN D",
    "current_taxes": 26991.88,
    "new_taxes_no_override": 28157.93,
    "override_total_1": 28956.89,
    "override_increase_1": 798.96
  },
  {
    "#": "127 Crafts Rd (278D-07-00)",
    "$": 2673700,
    "address": "127 Crafts Rd",
    "parcel_id": "278D-07-00",
    "owner1": "FRIGERIO, FEDERICO",
    "owner2": "BAKER, MEGHAN",
    "current_taxes": 27378.69,
    "new_taxes_no_override": 28561.45,
    "override_total_1": 29371.86,
    "override_increase_1": 810.41
  },
  {
    "#": "128 Crafts Rd (280-15-00)",
    "$": 4270500,
    "address": "128 Crafts Rd",
    "parcel_id": "280-15-00",
    "owner1": "HARPER TRS, GORDON P & MARY JILL ROBINSON",
    "owner2": "",
    "current_taxes": 43729.92,
    "new_taxes_no_override": 45619.05,
    "override_total_1": 46913.46,
    "override_increase_1": 1294.41
  },
  {
    "#": "135 Crafts Rd (278D-08-00)",
    "$": 4567200,
    "address": "135 Crafts Rd",
    "parcel_id": "278D-08-00",
    "owner1": "SKALLEBERG, ANABELLE DESANGLES & ATLE",
    "owner2": "",
    "current_taxes": 43133.19,
    "new_taxes_no_override": 44996.54,
    "override_total_1": 46273.29,
    "override_increase_1": 1276.74
  },
  {
    "#": "142 Crafts Rd (280-13-14)",
    "$": 7260700,
    "address": "142 Crafts Rd",
    "parcel_id": "280-13-14",
    "owner1": "HAWTHORNE, JENNIFER HILTON",
    "owner2": "",
    "current_taxes": 70714.63,
    "new_taxes_no_override": 73769.5,
    "override_total_1": 75862.66,
    "override_increase_1": 2093.15
  },
  {
    "#": "153 Crafts Rd (278D-09-00)",
    "$": 3589200,
    "address": "153 Crafts Rd",
    "parcel_id": "278D-09-00",
    "owner1": "ARNSTEIN ET AL, EDWARD R",
    "owner2": "",
    "current_taxes": 33118.47,
    "new_taxes_no_override": 34549.19,
    "override_total_1": 35529.49,
    "override_increase_1": 980.31
  },
  {
    "#": "165 Crafts Rd (278-19-00)",
    "$": 2940700,
    "address": "165 Crafts Rd",
    "parcel_id": "278-19-00",
    "owner1": "SAMPSON, CHRISTIAN E & MEGAN C",
    "owner2": "",
    "current_taxes": 26477.83,
    "new_taxes_no_override": 27621.67,
    "override_total_1": 28405.42,
    "override_increase_1": 783.74
  },
  {
    "#": "171 Crafts Rd (278-19-01)",
    "$": 2822500,
    "address": "171 Crafts Rd",
    "parcel_id": "278-19-01",
    "owner1": "PASCIUCCO, MARC E & SARAH L",
    "owner2": "",
    "current_taxes": 25267.47,
    "new_taxes_no_override": 26359.02,
    "override_total_1": 27106.94,
    "override_increase_1": 747.92
  },
  {
    "#": "200 Crafts Rd (265A-01-00)",
    "$": 2032400,
    "address": "200 Crafts Rd",
    "parcel_id": "265A-01-00",
    "owner1": "WALZ, THOMAS",
    "owner2": "",
    "current_taxes": 20811.78,
    "new_taxes_no_override": 21710.85,
    "override_total_1": 22326.88,
    "override_increase_1": 616.03
  },
  {
    "#": "206 Crafts Rd (265A-11-00)",
    "$": 2793800,
    "address": "206 Crafts Rd",
    "parcel_id": "265A-11-00",
    "owner1": "GROBSTEIN, LISA",
    "owner2": "",
    "current_taxes": 24973.58,
    "new_taxes_no_override": 26052.44,
    "override_total_1": 26791.66,
    "override_increase_1": 739.22
  },
  {
    "#": "212 Crafts Rd (265A-10-00)",
    "$": 1962600,
    "address": "212 Crafts Rd",
    "parcel_id": "265A-10-00",
    "owner1": "STUTZMAN, BYRON W & NANCY C",
    "owner2": "",
    "current_taxes": 16462.09,
    "new_taxes_no_override": 17173.25,
    "override_total_1": 17660.53,
    "override_increase_1": 487.28
  },
  {
    "#": "215 Crafts Rd, Unit 1 (277-13-03)",
    "$": 858200,
    "address": "215 Crafts Rd, Unit 1",
    "parcel_id": "277-13-03",
    "owner1": "FLORES, ANGEL FABIAN UGALDE",
    "owner2": "ESTRADA, MARIA DE LOURDES CORDERO",
    "current_taxes": 8787.97,
    "new_taxes_no_override": 9167.61,
    "override_total_1": 9427.73,
    "override_increase_1": 260.12
  },
  {
    "#": "215 Crafts Rd, Unit 2 (277-13-01)",
    "$": 705900,
    "address": "215 Crafts Rd, Unit 2",
    "parcel_id": "277-13-01",
    "owner1": "CAVEDON, JOELCIRA",
    "owner2": "",
    "current_taxes": 7228.42,
    "new_taxes_no_override": 7540.69,
    "override_total_1": 7754.65,
    "override_increase_1": 213.96
  },
  {
    "#": "215 Crafts Rd, Unit 3 (277-13-02)",
    "$": 700400,
    "address": "215 Crafts Rd, Unit 3",
    "parcel_id": "277-13-02",
    "owner1": "KATS, JULIA",
    "owner2": "NICHOLS, HUNTER",
    "current_taxes": 3537.16,
    "new_taxes_no_override": 3689.97,
    "override_total_1": 3794.67,
    "override_increase_1": 104.7
  },
  {
    "#": "219 Crafts Rd, Unit 2 (277-14-01)",
    "$": 774900,
    "address": "219 Crafts Rd, Unit 2",
    "parcel_id": "277-14-01",
    "owner1": "BEIN, AMIR & MAYA",
    "owner2": "",
    "current_taxes": 4300.04,
    "new_taxes_no_override": 4485.8,
    "override_total_1": 4613.08,
    "override_increase_1": 127.28
  },
  {
    "#": "219 Crafts Rd, Unit 3 (277-14-02)",
    "$": 720500,
    "address": "219 Crafts Rd, Unit 3",
    "parcel_id": "277-14-02",
    "owner1": "RICHARDSON, MATTHEW WORTH & VIOLET JIN",
    "owner2": "",
    "current_taxes": 3742.99,
    "new_taxes_no_override": 3904.69,
    "override_total_1": 4015.48,
    "override_increase_1": 110.79
  },
  {
    "#": "221 Crafts Rd, Unit 1 (277-14-03)",
    "$": 690700,
    "address": "221 Crafts Rd, Unit 1",
    "parcel_id": "277-14-03",
    "owner1": "TSU, C MEI-AN",
    "owner2": "",
    "current_taxes": 3437.83,
    "new_taxes_no_override": 3586.34,
    "override_total_1": 3688.1,
    "override_increase_1": 101.76
  },
  {
    "#": "225 Crafts Rd (277-15-00)",
    "$": 1715300,
    "address": "225 Crafts Rd",
    "parcel_id": "277-15-00",
    "owner1": "WANG, Y RICHARD",
    "owner2": "LEE, YANG W",
    "current_taxes": 13929.74,
    "new_taxes_no_override": 14531.5,
    "override_total_1": 14943.83,
    "override_increase_1": 412.32
  },
  {
    "#": "233 Crafts Rd (277-16-00)",
    "$": 1603900,
    "address": "233 Crafts Rd",
    "parcel_id": "277-16-00",
    "owner1": "PRIMILSKY, NATALIE T",
    "owner2": "",
    "current_taxes": 12789.0,
    "new_taxes_no_override": 13341.48,
    "override_total_1": 13720.04,
    "override_increase_1": 378.55
  },
  {
    "#": "241 Crafts Rd (277-17-00)",
    "$": 1819900,
    "address": "241 Crafts Rd",
    "parcel_id": "277-17-00",
    "owner1": "COLEY, CHRISTOPHER M",
    "owner2": "SUDA, DIANE",
    "current_taxes": 15000.84,
    "new_taxes_no_override": 15648.88,
    "override_total_1": 16092.9,
    "override_increase_1": 444.02
  },
  {
    "#": "247 Crafts Rd (277-18-00)",
    "$": 1969600,
    "address": "247 Crafts Rd",
    "parcel_id": "277-18-00",
    "owner1": "SU, ZHAOHUI",
    "owner2": "SUN, XIN",
    "current_taxes": 16533.77,
    "new_taxes_no_override": 17248.03,
    "override_total_1": 17737.43,
    "override_increase_1": 489.4
  },
  {
    "#": "3 Craftsland Rd (423-20-00)",
    "$": 2157000,
    "address": "3 Craftsland Rd",
    "parcel_id": "423-20-00",
    "owner1": "PANGBURN, BRETT D & SARAH L",
    "owner2": "",
    "current_taxes": 18452.75,
    "new_taxes_no_override": 19249.91,
    "override_total_1": 19796.11,
    "override_increase_1": 546.2
  },
  {
    "#": "4 Craftsland Rd (423-21-00)",
    "$": 1548900,
    "address": "4 Craftsland Rd",
    "parcel_id": "423-21-00",
    "owner1": "SUTHERLAND, ALLAN J & ANN E",
    "owner2": "",
    "current_taxes": 12225.8,
    "new_taxes_no_override": 12753.95,
    "override_total_1": 13115.84,
    "override_increase_1": 361.88
  },
  {
    "#": "9 Craftsland Rd (423-19-00)",
    "$": 1163200,
    "address": "9 Craftsland Rd",
    "parcel_id": "423-19-00",
    "owner1": "LUCAS TRS, ROBERT J & TARA M",
    "owner2": "C/O LUCAS ROBERT F",
    "current_taxes": 11911.17,
    "new_taxes_no_override": 12425.73,
    "override_total_1": 12778.3,
    "override_increase_1": 352.57
  },
  {
    "#": "10 Craftsland Rd (423-22-00)",
    "$": 1425700,
    "address": "10 Craftsland Rd",
    "parcel_id": "423-22-00",
    "owner1": "BHADELIA, NAHID",
    "owner2": "",
    "current_taxes": 10964.23,
    "new_taxes_no_override": 11437.88,
    "override_total_1": 11762.43,
    "override_increase_1": 324.54
  },
  {
    "#": "15 Craftsland Rd (423-18-00)",
    "$": 1117300,
    "address": "15 Craftsland Rd",
    "parcel_id": "423-18-00",
    "owner1": "BRESLIN, TRS, GREGORY P & MARGIE M",
    "owner2": "",
    "current_taxes": 7806.22,
    "new_taxes_no_override": 8143.45,
    "override_total_1": 8374.51,
    "override_increase_1": 231.06
  },
  {
    "#": "16 Craftsland Rd (423-23-00)",
    "$": 1958900,
    "address": "16 Craftsland Rd",
    "parcel_id": "423-23-00",
    "owner1": "LILLEHEI, CRAIG W & BEBERLY T",
    "owner2": "",
    "current_taxes": 16424.2,
    "new_taxes_no_override": 17133.73,
    "override_total_1": 17619.88,
    "override_increase_1": 486.16
  },
  {
    "#": "19 Craftsland Rd (423-17-00)",
    "$": 1392100,
    "address": "19 Craftsland Rd",
    "parcel_id": "423-17-00",
    "owner1": "YANG, HEEJUNG",
    "owner2": "PAIK, HYUN II",
    "current_taxes": 10620.17,
    "new_taxes_no_override": 11078.96,
    "override_total_1": 11393.32,
    "override_increase_1": 314.36
  },
  {
    "#": "22 Craftsland Rd (423-24-00)",
    "$": 1502300,
    "address": "22 Craftsland Rd",
    "parcel_id": "423-24-00",
    "owner1": "HOFFMAN LIFE ESTATE, KENNETH B & ROBERTA F",
    "owner2": "",
    "current_taxes": 11748.62,
    "new_taxes_no_override": 12256.16,
    "override_total_1": 12603.92,
    "override_increase_1": 347.76
  },
  {
    "#": "25 Craftsland Rd (423-16-00)",
    "$": 1505600,
    "address": "25 Craftsland Rd",
    "parcel_id": "423-16-00",
    "owner1": "TREVITHICK, PAUL & SUSAN M",
    "owner2": "",
    "current_taxes": 11782.41,
    "new_taxes_no_override": 12291.41,
    "override_total_1": 12640.17,
    "override_increase_1": 348.76
  },
  {
    "#": "26 Craftsland Rd (423-25-00)",
    "$": 1600500,
    "address": "26 Craftsland Rd",
    "parcel_id": "423-25-00",
    "owner1": "EDGERS TRS, LEWIS & KAREN",
    "owner2": "",
    "current_taxes": 12754.19,
    "new_taxes_no_override": 13305.17,
    "override_total_1": 13682.7,
    "override_increase_1": 377.52
  },
  {
    "#": "31 Craftsland Rd (423-15-00)",
    "$": 1478100,
    "address": "31 Craftsland Rd",
    "parcel_id": "423-15-00",
    "owner1": "YU, MICHELLE & JEEYUEN",
    "owner2": "",
    "current_taxes": 11500.81,
    "new_taxes_no_override": 11997.64,
    "override_total_1": 12338.07,
    "override_increase_1": 340.42
  },
  {
    "#": "32 Craftsland Rd (423-26-00)",
    "$": 1295400,
    "address": "32 Craftsland Rd",
    "parcel_id": "423-26-00",
    "owner1": "LAZAR TR, MARIAN JOAN",
    "owner2": "",
    "current_taxes": 9629.96,
    "new_taxes_no_override": 10045.97,
    "override_total_1": 10331.02,
    "override_increase_1": 285.05
  },
  {
    "#": "36 Craftsland Rd (423-27-00)",
    "$": 1490500,
    "address": "36 Craftsland Rd",
    "parcel_id": "423-27-00",
    "owner1": "KARLIN, BARBARA",
    "owner2": "GEORGE, LINDA S",
    "current_taxes": 11627.79,
    "new_taxes_no_override": 12130.11,
    "override_total_1": 12474.29,
    "override_increase_1": 344.18
  },
  {
    "#": "42 Craftsland Rd (423-28-00)",
    "$": 1314600,
    "address": "42 Craftsland Rd",
    "parcel_id": "423-28-00",
    "owner1": "MURPHY, WILLIAM F & MARY G",
    "owner2": "",
    "current_taxes": 9826.57,
    "new_taxes_no_override": 10251.08,
    "override_total_1": 10541.94,
    "override_increase_1": 290.87
  },
  {
    "#": "46 Craftsland Rd (423-29-00)",
    "$": 1310800,
    "address": "46 Craftsland Rd",
    "parcel_id": "423-29-00",
    "owner1": "ZOLLNER, BRADLEY M",
    "owner2": "OH, HEIDI M",
    "current_taxes": 9787.66,
    "new_taxes_no_override": 10210.49,
    "override_total_1": 10500.2,
    "override_increase_1": 289.71
  },
  {
    "#": "47 Craftsland Rd (423-13-14)",
    "$": 2598400,
    "address": "47 Craftsland Rd",
    "parcel_id": "423-13-14",
    "owner1": "CALKINS, MATTHEW",
    "owner2": "",
    "current_taxes": 22972.68,
    "new_taxes_no_override": 23965.1,
    "override_total_1": 24645.09,
    "override_increase_1": 679.99
  },
  {
    "#": "50 Craftsland Rd (423-30-00)",
    "$": 1412100,
    "address": "50 Craftsland Rd",
    "parcel_id": "423-30-00",
    "owner1": "DEWEY TRS, TALBOT JR",
    "owner2": "MORLEY, SUSAN",
    "current_taxes": 10824.97,
    "new_taxes_no_override": 11292.61,
    "override_total_1": 11613.03,
    "override_increase_1": 320.42
  },
  {
    "#": "53 Craftsland Rd (423-12-00)",
    "$": 1287500,
    "address": "53 Craftsland Rd",
    "parcel_id": "423-12-00",
    "owner1": "CHUBINSKY TR, ERIC D",
    "owner2": "",
    "current_taxes": 13184.0,
    "new_taxes_no_override": 13753.55,
    "override_total_1": 14143.8,
    "override_increase_1": 390.25
  },
  {
    "#": "56 Craftsland Rd (423-31-00)",
    "$": 1714500,
    "address": "56 Craftsland Rd",
    "parcel_id": "423-31-00",
    "owner1": "BARTCZAK TRS, NORMAN & RITA",
    "owner2": "",
    "current_taxes": 13921.55,
    "new_taxes_no_override": 14522.96,
    "override_total_1": 14935.04,
    "override_increase_1": 412.08
  },
  {
    "#": "57 Craftsland Rd (423-11-00)",
    "$": 1686400,
    "address": "57 Craftsland Rd",
    "parcel_id": "423-11-00",
    "owner1": "THORNTON, ANNA C",
    "owner2": "GAMBLE, ROBERT L",
    "current_taxes": 13633.8,
    "new_taxes_no_override": 14222.78,
    "override_total_1": 14626.34,
    "override_increase_1": 403.56
  },
  {
    "#": "62 Craftsland Rd (423-32-00)",
    "$": 1179100,
    "address": "62 Craftsland Rd",
    "parcel_id": "423-32-00",
    "owner1": "MARTIN, MICHAEL C",
    "owner2": "HOFFMAN, GAIL L",
    "current_taxes": 8439.05,
    "new_taxes_no_override": 8803.62,
    "override_total_1": 9053.41,
    "override_increase_1": 249.8
  },
  {
    "#": "63 Craftsland Rd (423-10-00)",
    "$": 1247000,
    "address": "63 Craftsland Rd",
    "parcel_id": "423-10-00",
    "owner1": "KAHN TRS, JANICE S",
    "owner2": "",
    "current_taxes": 9134.35,
    "new_taxes_no_override": 9528.95,
    "override_total_1": 9799.33,
    "override_increase_1": 270.38
  },
  {
    "#": "67 Craftsland Rd (423-09-00)",
    "$": 1857900,
    "address": "67 Craftsland Rd",
    "parcel_id": "423-09-00",
    "owner1": "COHEN, LESLIE G & DEAN B",
    "owner2": "",
    "current_taxes": 15389.96,
    "new_taxes_no_override": 16054.81,
    "override_total_1": 16510.35,
    "override_increase_1": 455.54
  },
  {
    "#": "68 Craftsland Rd (423-33-00)",
    "$": 1787800,
    "address": "68 Craftsland Rd",
    "parcel_id": "423-33-00",
    "owner1": "SCHLONDORFF, JOHANNES",
    "owner2": "PANDHARIPANDE, PARI V",
    "current_taxes": 18307.07,
    "new_taxes_no_override": 19097.94,
    "override_total_1": 19639.82,
    "override_increase_1": 541.89
  },
  {
    "#": "70 Craftsland Rd (423-41-00)",
    "$": 1286700,
    "address": "70 Craftsland Rd",
    "parcel_id": "423-41-00",
    "owner1": "LORRAWAY TR, MAXENE MEISTERMAN",
    "owner2": "",
    "current_taxes": 9540.87,
    "new_taxes_no_override": 9953.04,
    "override_total_1": 10235.45,
    "override_increase_1": 282.41
  },
  {
    "#": "71 Craftsland Rd (423-08-02)",
    "$": 1985000,
    "address": "71 Craftsland Rd",
    "parcel_id": "423-08-02",
    "owner1": "CUNNINGHAM TRS, JOHN J",
    "owner2": "LEVENSON, SETH L",
    "current_taxes": 16691.47,
    "new_taxes_no_override": 17412.54,
    "override_total_1": 17906.61,
    "override_increase_1": 494.07
  },
  {
    "#": "74 Craftsland Rd (423-34-35)",
    "$": 1748300,
    "address": "74 Craftsland Rd",
    "parcel_id": "423-34-35",
    "owner1": "GOOD TRS, MICHAEL I & BAMBI Z",
    "owner2": "",
    "current_taxes": 14267.66,
    "new_taxes_no_override": 14884.02,
    "override_total_1": 15306.35,
    "override_increase_1": 422.32
  },
  {
    "#": "75 Craftsland Rd (423-08-01)",
    "$": 1704100,
    "address": "75 Craftsland Rd",
    "parcel_id": "423-08-01",
    "owner1": "WIES TRS, SELWYN C & GILLIAM",
    "owner2": "",
    "current_taxes": 13815.05,
    "new_taxes_no_override": 14411.86,
    "override_total_1": 14820.79,
    "override_increase_1": 408.93
  },
  {
    "#": "79 Craftsland Rd (423-08-00)",
    "$": 1607100,
    "address": "79 Craftsland Rd",
    "parcel_id": "423-08-00",
    "owner1": "FISCHER TRS, LAWRENCE DREW & MARCY GREENBERG",
    "owner2": "",
    "current_taxes": 12821.77,
    "new_taxes_no_override": 13375.67,
    "override_total_1": 13755.19,
    "override_increase_1": 379.52
  },
  {
    "#": "80 Craftsland Rd (423-40-00)",
    "$": 2118100,
    "address": "80 Craftsland Rd",
    "parcel_id": "423-40-00",
    "owner1": "DONATELLI, DARYL C & JENNIFER E",
    "owner2": "",
    "current_taxes": 18054.41,
    "new_taxes_no_override": 18834.36,
    "override_total_1": 19368.77,
    "override_increase_1": 534.41
  },
  {
    "#": "83 Craftsland Rd (423-07-00)",
    "$": 1399200,
    "address": "83 Craftsland Rd",
    "parcel_id": "423-07-00",
    "owner1": "VOGEL, REBECCA A",
    "owner2": "BRYAN, EMILY",
    "current_taxes": 10692.87,
    "new_taxes_no_override": 11154.8,
    "override_total_1": 11471.31,
    "override_increase_1": 316.51
  },
  {
    "#": "87 Craftsland Rd (423-06-01)",
    "$": 1553400,
    "address": "87 Craftsland Rd",
    "parcel_id": "423-06-01",
    "owner1": "BUTTON TR, LINDA C",
    "owner2": "",
    "current_taxes": 12271.88,
    "new_taxes_no_override": 12802.03,
    "override_total_1": 13165.27,
    "override_increase_1": 363.25
  },
  {
    "#": "88 Craftsland Rd (423-36-00)",
    "$": 2052800,
    "address": "88 Craftsland Rd",
    "parcel_id": "423-36-00",
    "owner1": "HOWE, JACOB A",
    "owner2": "CHIANG, JENNIFER D",
    "current_taxes": 17385.74,
    "new_taxes_no_override": 18136.8,
    "override_total_1": 18651.42,
    "override_increase_1": 514.62
  },
  {
    "#": "90 Craftsland Rd (423-37-00)",
    "$": 1520000,
    "address": "90 Craftsland Rd",
    "parcel_id": "423-37-00",
    "owner1": "FORTIER, BENTE M",
    "owner2": "",
    "current_taxes": 11929.87,
    "new_taxes_no_override": 12445.24,
    "override_total_1": 12798.36,
    "override_increase_1": 353.12
  },
  {
    "#": "95 Craftsland Rd (423-06-00)",
    "$": 1160700,
    "address": "95 Craftsland Rd",
    "parcel_id": "423-06-00",
    "owner1": "SHEN, QIUCHEN",
    "owner2": "GUO, CHUNNI",
    "current_taxes": 11885.57,
    "new_taxes_no_override": 12399.03,
    "override_total_1": 12750.84,
    "override_increase_1": 351.81
  },
  {
    "#": "96 Craftsland Rd (423-38-00)",
    "$": 1517700,
    "address": "96 Craftsland Rd",
    "parcel_id": "423-38-00",
    "owner1": "DILIBERO LIFE ESTATE, ROBERT J & ELLEN D",
    "owner2": "",
    "current_taxes": 11906.31,
    "new_taxes_no_override": 12420.66,
    "override_total_1": 12773.09,
    "override_increase_1": 352.43
  },
  {
    "#": "100 Craftsland Rd (423-39-00)",
    "$": 2120800,
    "address": "100 Craftsland Rd",
    "parcel_id": "423-39-00",
    "owner1": "KAHN, ADAM P",
    "owner2": "SMITH, KIMBERLY C",
    "current_taxes": 18082.06,
    "new_taxes_no_override": 18863.2,
    "override_total_1": 19398.43,
    "override_increase_1": 535.23
  },
  {
    "#": "7 Craig Pl (027-07-00)",
    "$": 2296100,
    "address": "7 Craig Pl",
    "parcel_id": "027-07-00",
    "owner1": "7-9 CRAIG PLACE LLC",
    "owner2": "C/O BAILEY MANNIX",
    "current_taxes": 23512.06,
    "new_taxes_no_override": 24527.78,
    "override_total_1": 25223.74,
    "override_increase_1": 695.96
  },
  {
    "#": "11 Craig Pl, Unit 1 & P1 (027-08-03)",
    "$": 1068200,
    "address": "11 Craig Pl, Unit 1 & P1",
    "parcel_id": "027-08-03",
    "owner1": "SHIMAN, LAWRENCE H",
    "owner2": "RIFAS, SHERYL",
    "current_taxes": 7303.43,
    "new_taxes_no_override": 7618.94,
    "override_total_1": 7835.12,
    "override_increase_1": 216.18
  },
  {
    "#": "11 Craig Pl, Unit 2 & P2 (027-08-04)",
    "$": 1251400,
    "address": "11 Craig Pl, Unit 2 & P2",
    "parcel_id": "027-08-04",
    "owner1": "MCKEOWN, MICHAEL",
    "owner2": "SPENCER, SARAH J",
    "current_taxes": 9179.4,
    "new_taxes_no_override": 9575.95,
    "override_total_1": 9847.66,
    "override_increase_1": 271.71
  },
  {
    "#": "15 Craig Pl (027-08-02)",
    "$": 1754600,
    "address": "15 Craig Pl",
    "parcel_id": "027-08-02",
    "owner1": "ROLFS, ANDREAS",
    "owner2": "ZUO, DONGMEI",
    "current_taxes": 17967.1,
    "new_taxes_no_override": 18743.28,
    "override_total_1": 19275.1,
    "override_increase_1": 531.83
  },
  {
    "#": "17 Craig Pl (027-08-01)",
    "$": 1946500,
    "address": "17 Craig Pl",
    "parcel_id": "027-08-01",
    "owner1": "SOLOMON, RODNEY C & KATHLEEN",
    "owner2": "PRESSMAN TR, KAREN",
    "current_taxes": 19932.16,
    "new_taxes_no_override": 20793.23,
    "override_total_1": 21383.22,
    "override_increase_1": 589.99
  },
  {
    "#": "11 Cramond Rd (438-04-00)",
    "$": 8545500,
    "address": "11 Cramond Rd",
    "parcel_id": "438-04-00",
    "owner1": "HOLLAND PARK INVESTMENTS LLC",
    "owner2": "",
    "current_taxes": 87505.92,
    "new_taxes_no_override": 91286.18,
    "override_total_1": 93876.35,
    "override_increase_1": 2590.18
  },
  {
    "#": "18 Cramond Rd (439-05-00)",
    "$": 7154000,
    "address": "18 Cramond Rd",
    "parcel_id": "439-05-00",
    "owner1": "ALLEN TRS, ROBERT L JR",
    "owner2": "NAHED, BRIAN",
    "current_taxes": 69622.03,
    "new_taxes_no_override": 72629.7,
    "override_total_1": 74690.51,
    "override_increase_1": 2060.81
  },
  {
    "#": "30 Cramond Rd (439-04-00)",
    "$": 10744800,
    "address": "30 Cramond Rd",
    "parcel_id": "439-04-00",
    "owner1": "GRINBERG, ROBERT A",
    "owner2": "",
    "current_taxes": 106391.82,
    "new_taxes_no_override": 110987.95,
    "override_total_1": 114137.14,
    "override_increase_1": 3149.2
  },
  {
    "#": "48 Cramond Rd (439-03-00)",
    "$": 6632500,
    "address": "48 Cramond Rd",
    "parcel_id": "439-03-00",
    "owner1": "LAMPERT, JOAN L",
    "owner2": "",
    "current_taxes": 64281.87,
    "new_taxes_no_override": 67058.85,
    "override_total_1": 68961.59,
    "override_increase_1": 1902.74
  },
  {
    "#": "59 Cramond Rd (438-02-06)",
    "$": 10880700,
    "address": "59 Cramond Rd",
    "parcel_id": "438-02-06",
    "owner1": "MARTIGNETTI, CARMINE A & BETH V",
    "owner2": "",
    "current_taxes": 111418.37,
    "new_taxes_no_override": 116231.64,
    "override_total_1": 119529.63,
    "override_increase_1": 3297.98
  },
  {
    "#": "60 Cramond Rd (439-01-02)",
    "$": 13226300,
    "address": "60 Cramond Rd",
    "parcel_id": "439-01-02",
    "owner1": "FRIEZE TR, KENNETH S",
    "owner2": "",
    "current_taxes": 131802.38,
    "new_taxes_no_override": 137496.24,
    "override_total_1": 141397.59,
    "override_increase_1": 3901.35
  },
  {
    "#": "16 Crowninshield Rd (028-10-00)",
    "$": 2242700,
    "address": "16 Crowninshield Rd",
    "parcel_id": "028-10-00",
    "owner1": "BOYNTON, ELEANOR F",
    "owner2": "WEIGHART, SCOTT G",
    "current_taxes": 19330.31,
    "new_taxes_no_override": 20165.38,
    "override_total_1": 20737.56,
    "override_increase_1": 572.18
  },
  {
    "#": "21 Crowninshield Rd, Unit 11 (027-38-04)",
    "$": 350800,
    "address": "21 Crowninshield Rd, Unit 11",
    "parcel_id": "027-38-04",
    "owner1": "OWEN, BRIAN & KATY",
    "owner2": "",
    "current_taxes": 3592.19,
    "new_taxes_no_override": 3747.37,
    "override_total_1": 3853.7,
    "override_increase_1": 106.33
  },
  {
    "#": "21 Crowninshield Rd, Unit 15 (027-38-05)",
    "$": 2127600,
    "address": "21 Crowninshield Rd, Unit 15",
    "parcel_id": "027-38-05",
    "owner1": "WU, DANIEL HONG-KENNETH",
    "owner2": "",
    "current_taxes": 18151.69,
    "new_taxes_no_override": 18935.84,
    "override_total_1": 19473.13,
    "override_increase_1": 537.29
  },
  {
    "#": "21 Crowninshield Rd, Unit 17 (027-38-06)",
    "$": 2130700,
    "address": "21 Crowninshield Rd, Unit 17",
    "parcel_id": "027-38-06",
    "owner1": "MIAO, WEI",
    "owner2": "",
    "current_taxes": 21818.37,
    "new_taxes_no_override": 22760.92,
    "override_total_1": 23406.75,
    "override_increase_1": 645.82
  },
  {
    "#": "21 Crowninshield Rd, Unit 19 (027-38-07)",
    "$": 2132400,
    "address": "21 Crowninshield Rd, Unit 19",
    "parcel_id": "027-38-07",
    "owner1": "SHEN, ZHU",
    "owner2": "JI, YOU",
    "current_taxes": 21835.78,
    "new_taxes_no_override": 22779.09,
    "override_total_1": 23425.42,
    "override_increase_1": 646.34
  },
  {
    "#": "21 Crowninshield Rd, Unit 21 (027-38-08)",
    "$": 2052200,
    "address": "21 Crowninshield Rd, Unit 21",
    "parcel_id": "027-38-08",
    "owner1": "JOHNSON TR, ROBBIN S",
    "owner2": "",
    "current_taxes": 21014.53,
    "new_taxes_no_override": 21922.36,
    "override_total_1": 22544.39,
    "override_increase_1": 622.03
  },
  {
    "#": "21 Crowninshield Rd, Unit 5 (027-38-01)",
    "$": 2055500,
    "address": "21 Crowninshield Rd, Unit 5",
    "parcel_id": "027-38-01",
    "owner1": "ZHANG, CHAO",
    "owner2": "HU, ANQI",
    "current_taxes": 21048.32,
    "new_taxes_no_override": 21957.61,
    "override_total_1": 22580.64,
    "override_increase_1": 623.03
  },
  {
    "#": "21 Crowninshield Rd, Unit 7 (027-38-02)",
    "$": 350800,
    "address": "21 Crowninshield Rd, Unit 7",
    "parcel_id": "027-38-02",
    "owner1": "GUERRERO BAEZ, JOHAN M",
    "owner2": "GUERRERO, IRANYA M",
    "current_taxes": 3592.19,
    "new_taxes_no_override": 3747.37,
    "override_total_1": 3853.7,
    "override_increase_1": 106.33
  },
  {
    "#": "21 Crowninshield Rd, Unit 9 (027-38-03)",
    "$": 2129500,
    "address": "21 Crowninshield Rd, Unit 9",
    "parcel_id": "027-38-03",
    "owner1": "WU, PIN JOU",
    "owner2": "",
    "current_taxes": 18171.15,
    "new_taxes_no_override": 18956.14,
    "override_total_1": 19494.01,
    "override_increase_1": 537.87
  },
  {
    "#": "25 Crowninshield Rd (027-40-00)",
    "$": 2466300,
    "address": "25 Crowninshield Rd",
    "parcel_id": "027-40-00",
    "owner1": "BELLOW TR, JANIS",
    "owner2": "",
    "current_taxes": 25254.91,
    "new_taxes_no_override": 26345.92,
    "override_total_1": 27093.47,
    "override_increase_1": 747.55
  },
  {
    "#": "26 Crowninshield Rd (029-08-00)",
    "$": 2363500,
    "address": "26 Crowninshield Rd",
    "parcel_id": "029-08-00",
    "owner1": "SCOTTO TR, BARBARA C",
    "owner2": "",
    "current_taxes": 20567.31,
    "new_taxes_no_override": 21455.82,
    "override_total_1": 22064.61,
    "override_increase_1": 608.79
  },
  {
    "#": "29 Crowninshield Rd (027-41-00)",
    "$": 2943000,
    "address": "29 Crowninshield Rd",
    "parcel_id": "027-41-00",
    "owner1": "SUCOFF TR, ANDREW C",
    "owner2": "C/O GOODWIN PROCTER LLP",
    "current_taxes": 30136.32,
    "new_taxes_no_override": 31438.21,
    "override_total_1": 32330.24,
    "override_increase_1": 892.04
  },
  {
    "#": "35 Crowninshield Rd (027-42-00)",
    "$": 2593000,
    "address": "35 Crowninshield Rd",
    "parcel_id": "027-42-00",
    "owner1": "MAO, CHARLOTTE A",
    "owner2": "BROWN, MICHAEL H",
    "current_taxes": 22917.39,
    "new_taxes_no_override": 23907.42,
    "override_total_1": 24585.78,
    "override_increase_1": 678.35
  },
  {
    "#": "38 Crowninshield Rd (029-07-00)",
    "$": 2948000,
    "address": "38 Crowninshield Rd",
    "parcel_id": "029-07-00",
    "owner1": "FLEMING, NANCY GREEN",
    "owner2": "",
    "current_taxes": 26552.59,
    "new_taxes_no_override": 27699.66,
    "override_total_1": 28485.62,
    "override_increase_1": 785.96
  },
  {
    "#": "39 Crowninshield Rd (027-43-00)",
    "$": 2579100,
    "address": "39 Crowninshield Rd",
    "parcel_id": "027-43-00",
    "owner1": "MOSTOFSKY, TR, LEE Z",
    "owner2": "C/O MOSTOFSKY LEE Z & RITA",
    "current_taxes": 22775.05,
    "new_taxes_no_override": 23758.93,
    "override_total_1": 24433.07,
    "override_increase_1": 674.14
  },
  {
    "#": "43 Crowninshield Rd (027-44-00)",
    "$": 2356000,
    "address": "43 Crowninshield Rd",
    "parcel_id": "027-44-00",
    "owner1": "MNOOKIN, SETH A & SARA JAMES",
    "owner2": "",
    "current_taxes": 20490.51,
    "new_taxes_no_override": 21375.7,
    "override_total_1": 21982.22,
    "override_increase_1": 606.52
  },
  {
    "#": "47 Crowninshield Rd (027-45-00)",
    "$": 2785200,
    "address": "47 Crowninshield Rd",
    "parcel_id": "027-45-00",
    "owner1": "MCINTURFF, SCOTT",
    "owner2": "ROBERTS, PAMELA",
    "current_taxes": 24885.51,
    "new_taxes_no_override": 25960.56,
    "override_total_1": 26697.18,
    "override_increase_1": 736.61
  },
  {
    "#": "50 Crowninshield Rd (030-08-00)",
    "$": 4075000,
    "address": "50 Crowninshield Rd",
    "parcel_id": "030-08-00",
    "owner1": "DALGARNO, DAVID C",
    "owner2": "HOCHBERG, BRENDA J",
    "current_taxes": 38093.07,
    "new_taxes_no_override": 39738.69,
    "override_total_1": 40866.25,
    "override_increase_1": 1127.55
  },
  {
    "#": "53 Crowninshield Rd (027-46-00)",
    "$": 3833900,
    "address": "53 Crowninshield Rd",
    "parcel_id": "027-46-00",
    "owner1": "YANG",
    "owner2": "EKMEKCI, MEHMET",
    "current_taxes": 39259.14,
    "new_taxes_no_override": 40955.13,
    "override_total_1": 42117.21,
    "override_increase_1": 1162.07
  },
  {
    "#": "59 Crowninshield Rd (027-47-00)",
    "$": 2356400,
    "address": "59 Crowninshield Rd",
    "parcel_id": "027-47-00",
    "owner1": "PELZMAN, ROBIN C",
    "owner2": "",
    "current_taxes": 20494.6,
    "new_taxes_no_override": 21379.97,
    "override_total_1": 21986.61,
    "override_increase_1": 606.64
  },
  {
    "#": "61 Crowninshield Rd (027-48-00)",
    "$": 2225800,
    "address": "61 Crowninshield Rd",
    "parcel_id": "027-48-00",
    "owner1": "SCHLOSSER, KENNETH D & ASGEDET",
    "owner2": "",
    "current_taxes": 19157.26,
    "new_taxes_no_override": 19984.85,
    "override_total_1": 20551.91,
    "override_increase_1": 567.05
  },
  {
    "#": "67 Crowninshield Rd (027-49-00)",
    "$": 3287700,
    "address": "67 Crowninshield Rd",
    "parcel_id": "027-49-00",
    "owner1": "BADRI, OMAR",
    "owner2": "MOUSTAFA, FARAH",
    "current_taxes": 33666.05,
    "new_taxes_no_override": 35120.42,
    "override_total_1": 36116.94,
    "override_increase_1": 996.52
  },
  {
    "#": "71 Crowninshield Rd (027-50-00)",
    "$": 2441400,
    "address": "71 Crowninshield Rd",
    "parcel_id": "027-50-00",
    "owner1": "FRIEDMAN TRS, FRANKLIN D",
    "owner2": "KIANOVSKY, SARAH B",
    "current_taxes": 21365.0,
    "new_taxes_no_override": 22287.97,
    "override_total_1": 22920.37,
    "override_increase_1": 632.4
  },
  {
    "#": "75 Crowninshield Rd (027-51-00)",
    "$": 2401700,
    "address": "75 Crowninshield Rd",
    "parcel_id": "027-51-00",
    "owner1": "BOCHES TRS, EDWARD E & BARBARA A",
    "owner2": "",
    "current_taxes": 24593.41,
    "new_taxes_no_override": 25655.85,
    "override_total_1": 26383.81,
    "override_increase_1": 727.96
  },
  {
    "#": "78 Crowninshield Rd (031-09-00)",
    "$": 2872000,
    "address": "78 Crowninshield Rd",
    "parcel_id": "031-09-00",
    "owner1": "SAX, PAUL E & CAROLYN F",
    "owner2": "",
    "current_taxes": 25774.35,
    "new_taxes_no_override": 26887.8,
    "override_total_1": 27650.72,
    "override_increase_1": 762.92
  },
  {
    "#": "81 Crowninshield Rd (027-52-00)",
    "$": 2301000,
    "address": "81 Crowninshield Rd",
    "parcel_id": "027-52-00",
    "owner1": "GIVELBER, DANIEL J & FRANCES G",
    "owner2": "",
    "current_taxes": 19927.31,
    "new_taxes_no_override": 20788.17,
    "override_total_1": 21378.02,
    "override_increase_1": 589.85
  },
  {
    "#": "84 Crowninshield Rd (031-08-00)",
    "$": 3115500,
    "address": "84 Crowninshield Rd",
    "parcel_id": "031-08-00",
    "owner1": "CHEN TRS, YEN-CHING & SUE HWE",
    "owner2": "",
    "current_taxes": 28267.79,
    "new_taxes_no_override": 29488.96,
    "override_total_1": 30325.69,
    "override_increase_1": 836.73
  },
  {
    "#": "87 Crowninshield Rd (027-53-00)",
    "$": 3054200,
    "address": "87 Crowninshield Rd",
    "parcel_id": "027-53-00",
    "owner1": "87 CROWNINSHIELD LLC",
    "owner2": "",
    "current_taxes": 31275.01,
    "new_taxes_no_override": 32626.09,
    "override_total_1": 33551.83,
    "override_increase_1": 925.74
  },
  {
    "#": "91 Crowninshield Rd (027-54-00)",
    "$": 2379500,
    "address": "91 Crowninshield Rd",
    "parcel_id": "027-54-00",
    "owner1": "KICKHAM, ROBERT T & DOROTHY & TIMOTHY",
    "owner2": "",
    "current_taxes": 20731.15,
    "new_taxes_no_override": 21626.74,
    "override_total_1": 22240.38,
    "override_increase_1": 613.64
  },
  {
    "#": "95 Crowninshield Rd (027-55-00)",
    "$": 2195000,
    "address": "95 Crowninshield Rd",
    "parcel_id": "027-55-00",
    "owner1": "OREN, RONNY",
    "owner2": "GRINBERG, ACHIKAM OREN",
    "current_taxes": 18841.87,
    "new_taxes_no_override": 19655.84,
    "override_total_1": 20213.56,
    "override_increase_1": 557.72
  },
  {
    "#": "98 Crowninshield Rd (031-06-00)",
    "$": 3380100,
    "address": "98 Crowninshield Rd",
    "parcel_id": "031-06-00",
    "owner1": "WEINRIB, ESTEE & RICHARD",
    "owner2": "",
    "current_taxes": 30977.29,
    "new_taxes_no_override": 32315.51,
    "override_total_1": 33232.44,
    "override_increase_1": 916.93
  },
  {
    "#": "99 Crowninshield Rd, Unit B4 & G19 (027-01-40)",
    "$": 851800,
    "address": "99 Crowninshield Rd, Unit B4 & G19",
    "parcel_id": "027-01-40",
    "owner1": "MAHLMANN, MARY M",
    "owner2": "",
    "current_taxes": 5087.5,
    "new_taxes_no_override": 5307.28,
    "override_total_1": 5457.87,
    "override_increase_1": 150.59
  },
  {
    "#": "101 Crowninshield Rd, Unit B8&G38 39 (027-01-44)",
    "$": 1440500,
    "address": "101 Crowninshield Rd, Unit B8&G38 39",
    "parcel_id": "027-01-44",
    "owner1": "SHIN TRS, EDWARD K",
    "owner2": "LAI , MICHELLE JS",
    "current_taxes": 11115.79,
    "new_taxes_no_override": 11595.99,
    "override_total_1": 11925.02,
    "override_increase_1": 329.03
  },
  {
    "#": "102 Crowninshield Rd (031-05-00)",
    "$": 2112300,
    "address": "102 Crowninshield Rd",
    "parcel_id": "031-05-00",
    "owner1": "GILBERT TRS, STEVEN D",
    "owner2": "TOOMEY , MAURA",
    "current_taxes": 17995.02,
    "new_taxes_no_override": 18772.4,
    "override_total_1": 19305.06,
    "override_increase_1": 532.65
  },
  {
    "#": "103 Crowninshield Rd, Unit B7&G17 18 (027-01-43)",
    "$": 1412000,
    "address": "103 Crowninshield Rd, Unit B7&G17 18",
    "parcel_id": "027-01-43",
    "owner1": "YU, YUE YANG",
    "owner2": "LIU, SHELLEY H",
    "current_taxes": 14458.88,
    "new_taxes_no_override": 15083.5,
    "override_total_1": 15511.49,
    "override_increase_1": 427.98
  },
  {
    "#": "105 Crowninshield Rd, Unit B3 & G33 (027-01-39)",
    "$": 821700,
    "address": "105 Crowninshield Rd, Unit B3 & G33",
    "parcel_id": "027-01-39",
    "owner1": "BERGER, ETHAN ISAAC",
    "owner2": "",
    "current_taxes": 4779.27,
    "new_taxes_no_override": 4985.73,
    "override_total_1": 5127.2,
    "override_increase_1": 141.47
  },
  {
    "#": "107 Crowninshield Rd, Unit B2 & G57 (027-01-38)",
    "$": 851800,
    "address": "107 Crowninshield Rd, Unit B2 & G57",
    "parcel_id": "027-01-38",
    "owner1": "FIELDS, MICHAEL",
    "owner2": "",
    "current_taxes": 5087.5,
    "new_taxes_no_override": 5307.28,
    "override_total_1": 5457.87,
    "override_increase_1": 150.59
  },
  {
    "#": "108 Crowninshield Rd (031-04-00)",
    "$": 2097100,
    "address": "108 Crowninshield Rd",
    "parcel_id": "031-04-00",
    "owner1": "TOBON, GABRIEL",
    "owner2": "YEN, ANGELA",
    "current_taxes": 17839.37,
    "new_taxes_no_override": 18610.03,
    "override_total_1": 19138.08,
    "override_increase_1": 528.05
  },
  {
    "#": "109 Crowninshield Rd, Unit B6&G34 35 (027-01-42)",
    "$": 1468500,
    "address": "109 Crowninshield Rd, Unit B6&G34 35",
    "parcel_id": "027-01-42",
    "owner1": "FREEDMAN TR, BURT B",
    "owner2": "",
    "current_taxes": 11402.51,
    "new_taxes_no_override": 11895.1,
    "override_total_1": 12232.61,
    "override_increase_1": 337.51
  },
  {
    "#": "111 Crowninshield Rd, Unit B5&G36 37 (027-01-41)",
    "$": 1455000,
    "address": "111 Crowninshield Rd, Unit B5&G36 37",
    "parcel_id": "027-01-41",
    "owner1": "SRIVASTAVA, SIDDHARTH & AMBIKA",
    "owner2": "",
    "current_taxes": 11264.27,
    "new_taxes_no_override": 11750.89,
    "override_total_1": 12084.31,
    "override_increase_1": 333.42
  },
  {
    "#": "113 Crowninshield Rd, Unit B1 & G27 (027-01-37)",
    "$": 853300,
    "address": "113 Crowninshield Rd, Unit B1 & G27",
    "parcel_id": "027-01-37",
    "owner1": "MIZER, KELLY C",
    "owner2": "",
    "current_taxes": 8737.79,
    "new_taxes_no_override": 9115.26,
    "override_total_1": 9373.9,
    "override_increase_1": 258.64
  },
  {
    "#": "115 Crowninshield Rd, Unit C3 & G20 (027-01-47)",
    "$": 860900,
    "address": "115 Crowninshield Rd, Unit C3 & G20",
    "parcel_id": "027-01-47",
    "owner1": "BURGUNDY PRYTANIA LLC",
    "owner2": "C/O NEIL HYMAN MANAGER",
    "current_taxes": 8815.62,
    "new_taxes_no_override": 9196.45,
    "override_total_1": 9457.4,
    "override_increase_1": 260.94
  },
  {
    "#": "117 Crowninshield Rd, Unit C2 & G54 (027-01-46)",
    "$": 875100,
    "address": "117 Crowninshield Rd, Unit C2 & G54",
    "parcel_id": "027-01-46",
    "owner1": "CHIBNIK, LORI B",
    "owner2": "",
    "current_taxes": 5326.09,
    "new_taxes_no_override": 5556.18,
    "override_total_1": 5713.83,
    "override_increase_1": 157.65
  },
  {
    "#": "119 Crowninshield Rd, Unit C1 & G23 (027-01-45)",
    "$": 947100,
    "address": "119 Crowninshield Rd, Unit C1 & G23",
    "parcel_id": "027-01-45",
    "owner1": "LAI TRS, MICHELLE JS",
    "owner2": "SHIN , EDWARD K",
    "current_taxes": 9698.3,
    "new_taxes_no_override": 10117.27,
    "override_total_1": 10404.34,
    "override_increase_1": 287.07
  },
  {
    "#": "121 Crowninshield Rd, Unit C6&G62-63 (027-01-50)",
    "$": 1581000,
    "address": "121 Crowninshield Rd, Unit C6&G62-63",
    "parcel_id": "027-01-50",
    "owner1": "KIMEL, KLAUS",
    "owner2": "TRIPOLSKI-KIMEL, MARIA",
    "current_taxes": 12554.51,
    "new_taxes_no_override": 13096.86,
    "override_total_1": 13468.48,
    "override_increase_1": 371.61
  },
  {
    "#": "123 Crowninshield Rd, Unit C5& G60 61 (027-01-49)",
    "$": 1496500,
    "address": "123 Crowninshield Rd, Unit C5& G60 61",
    "parcel_id": "027-01-49",
    "owner1": "JOHNSON, GEOFFREY T",
    "owner2": "GARNER, BARBARA",
    "current_taxes": 11689.23,
    "new_taxes_no_override": 12194.2,
    "override_total_1": 12540.21,
    "override_increase_1": 346.0
  },
  {
    "#": "125 Crowninshield Rd, Unit C4&G58 59 (027-01-48)",
    "$": 1655200,
    "address": "125 Crowninshield Rd, Unit C4&G58 59",
    "parcel_id": "027-01-48",
    "owner1": "RAMACHANDRAN, SATYA K",
    "owner2": "KRISHNA, PRIYA",
    "current_taxes": 13314.31,
    "new_taxes_no_override": 13889.49,
    "override_total_1": 14283.59,
    "override_increase_1": 394.1
  },
  {
    "#": "15 Cumberland Ave (297-09-00)",
    "$": 2687400,
    "address": "15 Cumberland Ave",
    "parcel_id": "297-09-00",
    "owner1": "JOHNSON TR, ANTHONY G",
    "owner2": "",
    "current_taxes": 23884.04,
    "new_taxes_no_override": 24915.83,
    "override_total_1": 25622.8,
    "override_increase_1": 706.97
  },
  {
    "#": "21 Cumberland Ave (296-08-00)",
    "$": 2191700,
    "address": "21 Cumberland Ave",
    "parcel_id": "296-08-00",
    "owner1": "KELLEY, NICHOLAS M & HELEN H",
    "owner2": "",
    "current_taxes": 18808.07,
    "new_taxes_no_override": 19620.58,
    "override_total_1": 20177.3,
    "override_increase_1": 556.72
  },
  {
    "#": "30 Cumberland Ave, Unit W-1 & P-6 (299-01-01)",
    "$": 759500,
    "address": "30 Cumberland Ave, Unit W-1 & P-6",
    "parcel_id": "299-01-01",
    "owner1": "JONES, ANNE & BRUCE",
    "owner2": "",
    "current_taxes": 4142.35,
    "new_taxes_no_override": 4321.3,
    "override_total_1": 4443.91,
    "override_increase_1": 122.61
  },
  {
    "#": "30 Cumberland Ave, Unit W-3 & P-7A (299-01-03)",
    "$": 880500,
    "address": "30 Cumberland Ave, Unit W-3 & P-7A",
    "parcel_id": "299-01-03",
    "owner1": "GLYNN, ROBERT J & SHEENA M",
    "owner2": "",
    "current_taxes": 9016.32,
    "new_taxes_no_override": 9405.83,
    "override_total_1": 9672.71,
    "override_increase_1": 266.88
  },
  {
    "#": "30 Cumberland Ave, Unit W-4 & P-8 (299-01-04)",
    "$": 880600,
    "address": "30 Cumberland Ave, Unit W-4 & P-8",
    "parcel_id": "299-01-04",
    "owner1": "RYNOWECER, CAMRAN",
    "owner2": "ESPIRITU-RYNOWECER, JENNIFER",
    "current_taxes": 9017.34,
    "new_taxes_no_override": 9406.89,
    "override_total_1": 9673.8,
    "override_increase_1": 266.91
  },
  {
    "#": "30 Cumberland Ave, Unit W-5 P9-90 (299-01-05)",
    "$": 976400,
    "address": "30 Cumberland Ave, Unit W-5 P9-90",
    "parcel_id": "299-01-05",
    "owner1": "LAMONT, ELIZABETH",
    "owner2": "",
    "current_taxes": 6363.4,
    "new_taxes_no_override": 6638.3,
    "override_total_1": 6826.66,
    "override_increase_1": 188.36
  },
  {
    "#": "30 Cumberland Ave, Unit W2 P1&7 (299-01-02)",
    "$": 976300,
    "address": "30 Cumberland Ave, Unit W2 P1&7",
    "parcel_id": "299-01-02",
    "owner1": "DEGAR, BARBARA A",
    "owner2": "",
    "current_taxes": 6362.38,
    "new_taxes_no_override": 6637.23,
    "override_total_1": 6825.56,
    "override_increase_1": 188.33
  },
  {
    "#": "38 Cumberland Ave (299-46-00)",
    "$": 2151700,
    "address": "38 Cumberland Ave",
    "parcel_id": "299-46-00",
    "owner1": "APTEKAR TR, LUCILLE",
    "owner2": "",
    "current_taxes": 18398.47,
    "new_taxes_no_override": 19193.28,
    "override_total_1": 19737.88,
    "override_increase_1": 544.59
  },
  {
    "#": "43 Cumberland Ave (295-11-12)",
    "$": 951400,
    "address": "43 Cumberland Ave",
    "parcel_id": "295-11-12",
    "owner1": "HAWTHORN  ASSOCIATES",
    "owner2": "C/O GADSBY EDWARD N",
    "current_taxes": 9742.34,
    "new_taxes_no_override": 10163.21,
    "override_total_1": 10451.58,
    "override_increase_1": 288.37
  },
  {
    "#": "47 Cumberland Ave (295-13-00)",
    "$": 2780800,
    "address": "47 Cumberland Ave",
    "parcel_id": "295-13-00",
    "owner1": "HUGHES TRS, MICHAEL D",
    "owner2": "WILLIAMS , PAIGE L",
    "current_taxes": 24840.46,
    "new_taxes_no_override": 25913.57,
    "override_total_1": 26648.85,
    "override_increase_1": 735.28
  },
  {
    "#": "50 Cumberland Ave (299-45-00)",
    "$": 2369000,
    "address": "50 Cumberland Ave",
    "parcel_id": "299-45-00",
    "owner1": "MAHERAS TRS, GREGORY & ELIZABETH W",
    "owner2": "",
    "current_taxes": 20623.63,
    "new_taxes_no_override": 21514.57,
    "override_total_1": 22125.03,
    "override_increase_1": 610.46
  },
  {
    "#": "11 Cushing Rd (320-07-00)",
    "$": 1903300,
    "address": "11 Cushing Rd",
    "parcel_id": "320-07-00",
    "owner1": "KEAVENEY, THOMAS G & KATHRYN J",
    "owner2": "",
    "current_taxes": 15854.86,
    "new_taxes_no_override": 16539.79,
    "override_total_1": 17009.09,
    "override_increase_1": 469.3
  },
  {
    "#": "12 Cushing Rd (320A-06-00)",
    "$": 2081000,
    "address": "12 Cushing Rd",
    "parcel_id": "320A-06-00",
    "owner1": "JANES, KENNETH & MONIKA",
    "owner2": "",
    "current_taxes": 17674.51,
    "new_taxes_no_override": 18438.05,
    "override_total_1": 18961.21,
    "override_increase_1": 523.17
  },
  {
    "#": "17 Cushing Rd (320-08-00)",
    "$": 1760700,
    "address": "17 Cushing Rd",
    "parcel_id": "320-08-00",
    "owner1": "NALLY TRS, THOMAS JOHN & SUSAN BROWNLEE",
    "owner2": "",
    "current_taxes": 14394.63,
    "new_taxes_no_override": 15016.48,
    "override_total_1": 15442.56,
    "override_increase_1": 426.08
  },
  {
    "#": "18 Cushing Rd (320A-05-00)",
    "$": 1759000,
    "address": "18 Cushing Rd",
    "parcel_id": "320A-05-00",
    "owner1": "POULOS, THEODORE J",
    "owner2": "",
    "current_taxes": 14377.23,
    "new_taxes_no_override": 14998.33,
    "override_total_1": 15423.89,
    "override_increase_1": 425.57
  },
  {
    "#": "22 Cushing Rd (320A-04-00)",
    "$": 3880300,
    "address": "22 Cushing Rd",
    "parcel_id": "320A-04-00",
    "owner1": "ABUSHARKH TRS, BASEL & IBRAHIM",
    "owner2": "",
    "current_taxes": 36099.34,
    "new_taxes_no_override": 37658.83,
    "override_total_1": 38727.37,
    "override_increase_1": 1068.54
  },
  {
    "#": "23 Cushing Rd (320-09-00)",
    "$": 3091800,
    "address": "23 Cushing Rd",
    "parcel_id": "320-09-00",
    "owner1": "BOWDITCH, ROBERT S & LOUISE J",
    "owner2": "C/O LWCO",
    "current_taxes": 31660.03,
    "new_taxes_no_override": 33027.74,
    "override_total_1": 33964.88,
    "override_increase_1": 937.14
  },
  {
    "#": "28 Cushing Rd (320A-03-00)",
    "$": 3515800,
    "address": "28 Cushing Rd",
    "parcel_id": "320A-03-00",
    "owner1": "CHAUDRY, GULRAIZ A & FARIHA",
    "owner2": "",
    "current_taxes": 32366.86,
    "new_taxes_no_override": 33765.11,
    "override_total_1": 34723.17,
    "override_increase_1": 958.06
  },
  {
    "#": "7 Cutler Ln (437-15-01)",
    "$": 7275600,
    "address": "7 Cutler Ln",
    "parcel_id": "437-15-01",
    "owner1": "7 CUTLER LANE LLC",
    "owner2": "",
    "current_taxes": 74502.14,
    "new_taxes_no_override": 77720.63,
    "override_total_1": 79925.9,
    "override_increase_1": 2205.26
  },
  {
    "#": "25 Cutler Ln (437-16-00)",
    "$": 5113400,
    "address": "25 Cutler Ln",
    "parcel_id": "437-16-00",
    "owner1": "HAMILTON TR, KATHERINE ELIZABETH",
    "owner2": "",
    "current_taxes": 52361.22,
    "new_taxes_no_override": 54623.22,
    "override_total_1": 56173.12,
    "override_increase_1": 1549.89
  },
  {
    "#": "32 Cutler Ln (437-24-00)",
    "$": 6146600,
    "address": "32 Cutler Ln",
    "parcel_id": "437-24-00",
    "owner1": "KAUFMAN, MARC",
    "owner2": "",
    "current_taxes": 59306.25,
    "new_taxes_no_override": 61868.28,
    "override_total_1": 63623.74,
    "override_increase_1": 1755.47
  },
  {
    "#": "33 Cutler Ln (437-17-00)",
    "$": 6296500,
    "address": "33 Cutler Ln",
    "parcel_id": "437-17-00",
    "owner1": "J DERENZO PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 64476.16,
    "new_taxes_no_override": 67261.53,
    "override_total_1": 69170.02,
    "override_increase_1": 1908.49
  },
  {
    "#": "41 Cutler Ln (437-18-00)",
    "$": 4318700,
    "address": "41 Cutler Ln",
    "parcel_id": "437-18-00",
    "owner1": "RAO TRS, AMIT & SHIBANI SAIN",
    "owner2": "",
    "current_taxes": 40588.55,
    "new_taxes_no_override": 42341.98,
    "override_total_1": 43543.4,
    "override_increase_1": 1201.42
  },
  {
    "#": "50 Cutler Ln (437-23-00)",
    "$": 6584500,
    "address": "50 Cutler Ln",
    "parcel_id": "437-23-00",
    "owner1": "SCHWARTZ, DEBORAH M & MARC R",
    "owner2": "",
    "current_taxes": 63790.35,
    "new_taxes_no_override": 66546.09,
    "override_total_1": 68434.29,
    "override_increase_1": 1888.19
  },
  {
    "#": "51 Cutler Ln (437-19-00)",
    "$": 1843100,
    "address": "51 Cutler Ln",
    "parcel_id": "437-19-00",
    "owner1": "ENG, SUE ANNE",
    "owner2": "",
    "current_taxes": 15238.41,
    "new_taxes_no_override": 15896.71,
    "override_total_1": 16347.77,
    "override_increase_1": 451.06
  },
  {
    "#": "65 Cutler Ln (437-20-00)",
    "$": 3076100,
    "address": "65 Cutler Ln",
    "parcel_id": "437-20-00",
    "owner1": "SAIVETZ, CAROL R",
    "owner2": "",
    "current_taxes": 27864.33,
    "new_taxes_no_override": 29068.07,
    "override_total_1": 29892.85,
    "override_increase_1": 824.78
  },
  {
    "#": "66 Cutler Ln (437-27-03)",
    "$": 5996200,
    "address": "66 Cutler Ln",
    "parcel_id": "437-27-03",
    "owner1": "CHANG, YU-JU",
    "owner2": "",
    "current_taxes": 61401.09,
    "new_taxes_no_override": 64053.62,
    "override_total_1": 65871.09,
    "override_increase_1": 1817.47
  },
  {
    "#": "77 Cutler Ln (437-21-00)",
    "$": 3082100,
    "address": "77 Cutler Ln",
    "parcel_id": "437-21-00",
    "owner1": "LANE ET AL TRS, JANICE R",
    "owner2": "POSNER, NORMAN",
    "current_taxes": 27925.77,
    "new_taxes_no_override": 29132.16,
    "override_total_1": 29958.77,
    "override_increase_1": 826.6
  },
  {
    "#": "88 Cutler Ln (437-27-02)",
    "$": 7705500,
    "address": "88 Cutler Ln",
    "parcel_id": "437-27-02",
    "owner1": "THE CUTLER LANE LLC",
    "owner2": "",
    "current_taxes": 78904.32,
    "new_taxes_no_override": 82312.99,
    "override_total_1": 84648.55,
    "override_increase_1": 2335.57
  },
  {
    "#": "89 Cutler Ln (437-22-00)",
    "$": 2806500,
    "address": "89 Cutler Ln",
    "parcel_id": "437-22-00",
    "owner1": "ROIFF, MARCIA S",
    "owner2": "",
    "current_taxes": 25103.63,
    "new_taxes_no_override": 26188.11,
    "override_total_1": 26931.17,
    "override_increase_1": 743.07
  },
  {
    "#": "6 Cypress St (177-37-00)",
    "$": 2685400,
    "address": "6 Cypress St",
    "parcel_id": "177-37-00",
    "owner1": "LEE RETAIL INVESTMENTS LLC",
    "owner2": "",
    "current_taxes": 46081.46,
    "new_taxes_no_override": 48072.18,
    "override_total_1": 49436.19,
    "override_increase_1": 1364.01
  },
  {
    "#": "14 Cypress St (177-36-00)",
    "$": 1710400,
    "address": "14 Cypress St",
    "parcel_id": "177-36-00",
    "owner1": "PHELAN TRS, ROBERT & SOLEDAD",
    "owner2": "",
    "current_taxes": 13879.56,
    "new_taxes_no_override": 14479.16,
    "override_total_1": 14889.99,
    "override_increase_1": 410.83
  },
  {
    "#": "18 Cypress St (177-35-00)",
    "$": 1648900,
    "address": "18 Cypress St",
    "parcel_id": "177-35-00",
    "owner1": "IOKHVID, DMITRIY",
    "owner2": "EYDLIN, LYUBA",
    "current_taxes": 13249.8,
    "new_taxes_no_override": 13822.19,
    "override_total_1": 14214.39,
    "override_increase_1": 392.19
  },
  {
    "#": "19 Cypress St (195-09-00)",
    "$": 21110000,
    "address": "19 Cypress St",
    "parcel_id": "195-09-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O CYPRESS ST PLAYGROUND",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "21 Cypress St, Unit B (200-16-00)",
    "$": 2746400,
    "address": "21 Cypress St, Unit B",
    "parcel_id": "200-16-00",
    "owner1": "21 CYPRESS STREET LLC",
    "owner2": "",
    "current_taxes": 28123.14,
    "new_taxes_no_override": 29338.06,
    "override_total_1": 30170.5,
    "override_increase_1": 832.44
  },
  {
    "#": "23 Cypress St, Unit B (200-16-01)",
    "$": 2614900,
    "address": "23 Cypress St, Unit B",
    "parcel_id": "200-16-01",
    "owner1": "FEINGOLD TR, DAVID S",
    "owner2": "",
    "current_taxes": 23141.64,
    "new_taxes_no_override": 24141.36,
    "override_total_1": 24826.35,
    "override_increase_1": 684.99
  },
  {
    "#": "25 Cypress St, Unit B (200-16-02)",
    "$": 2777200,
    "address": "25 Cypress St, Unit B",
    "parcel_id": "200-16-02",
    "owner1": "PARKER, C STEPHEN JR & KATHLEEN KING & RACHEL WARNER &  JOSHUA STEPHEN",
    "owner2": "",
    "current_taxes": 24803.59,
    "new_taxes_no_override": 25875.11,
    "override_total_1": 26609.29,
    "override_increase_1": 734.19
  },
  {
    "#": "26 Cypress St, Unit 1 (177-25-05)",
    "$": 1103500,
    "address": "26 Cypress St, Unit 1",
    "parcel_id": "177-25-05",
    "owner1": "LEVENTHAL, NANCY M",
    "owner2": "",
    "current_taxes": 7664.91,
    "new_taxes_no_override": 7996.03,
    "override_total_1": 8222.92,
    "override_increase_1": 226.88
  },
  {
    "#": "27 Cypress St (200-17-00)",
    "$": 2219100,
    "address": "27 Cypress St",
    "parcel_id": "200-17-00",
    "owner1": "HORN, DALIT B & DANIEL M",
    "owner2": "",
    "current_taxes": 19088.65,
    "new_taxes_no_override": 19913.28,
    "override_total_1": 20478.3,
    "override_increase_1": 565.02
  },
  {
    "#": "30 Cypress St, Unit 1 (177-25-03)",
    "$": 990200,
    "address": "30 Cypress St, Unit 1",
    "parcel_id": "177-25-03",
    "owner1": "BAKUM, JAMES A",
    "owner2": "PERUGINI, GIOIA C",
    "current_taxes": 10139.65,
    "new_taxes_no_override": 10577.68,
    "override_total_1": 10877.82,
    "override_increase_1": 300.13
  },
  {
    "#": "30 Cypress St, Unit 2 (177-25-04)",
    "$": 1557800,
    "address": "30 Cypress St, Unit 2",
    "parcel_id": "177-25-04",
    "owner1": "LI, XIABIN & MAY",
    "owner2": "",
    "current_taxes": 15951.87,
    "new_taxes_no_override": 16640.99,
    "override_total_1": 17113.17,
    "override_increase_1": 472.18
  },
  {
    "#": "34 Cypress St (177-24-00)",
    "$": 2284000,
    "address": "34 Cypress St",
    "parcel_id": "177-24-00",
    "owner1": "STILLMAN, LAURA",
    "owner2": "",
    "current_taxes": 19753.23,
    "new_taxes_no_override": 20606.57,
    "override_total_1": 21191.27,
    "override_increase_1": 584.7
  },
  {
    "#": "35 Cypress St (200-01-00)",
    "$": 2669500,
    "address": "35 Cypress St",
    "parcel_id": "200-01-00",
    "owner1": "SAFRAN FOER, JOSHUA PETER",
    "owner2": "FOER, DINAH",
    "current_taxes": 23700.75,
    "new_taxes_no_override": 24724.62,
    "override_total_1": 25426.16,
    "override_increase_1": 701.54
  },
  {
    "#": "36 Cypress St (177-23-00)",
    "$": 2361900,
    "address": "36 Cypress St",
    "parcel_id": "177-23-00",
    "owner1": "JACHIMOWICZ, FELEK",
    "owner2": "LAPID, VERA",
    "current_taxes": 20550.92,
    "new_taxes_no_override": 21438.72,
    "override_total_1": 22047.03,
    "override_increase_1": 608.31
  },
  {
    "#": "39 Cypress St (198-07-00)",
    "$": 2038400,
    "address": "39 Cypress St",
    "parcel_id": "198-07-00",
    "owner1": "CAPIN, JOHN A",
    "owner2": "",
    "current_taxes": 17238.28,
    "new_taxes_no_override": 17982.97,
    "override_total_1": 18493.23,
    "override_increase_1": 510.25
  },
  {
    "#": "41 Cypress St, Unit 1 (198-07-02)",
    "$": 1232200,
    "address": "41 Cypress St, Unit 1",
    "parcel_id": "198-07-02",
    "owner1": "CARRASCO, RUBEN",
    "owner2": "",
    "current_taxes": 12617.73,
    "new_taxes_no_override": 13162.82,
    "override_total_1": 13536.3,
    "override_increase_1": 373.48
  },
  {
    "#": "41 Cypress St, Unit 2 (198-07-03)",
    "$": 1214200,
    "address": "41 Cypress St, Unit 2",
    "parcel_id": "198-07-03",
    "owner1": "MURRAY, TELF",
    "owner2": "FERRAGAMO, CARA",
    "current_taxes": 8798.47,
    "new_taxes_no_override": 9178.56,
    "override_total_1": 9439.0,
    "override_increase_1": 260.43
  },
  {
    "#": "42 Cypress St (179-11-01)",
    "$": 2239100,
    "address": "42 Cypress St",
    "parcel_id": "179-11-01",
    "owner1": "KALNINS, RENATA Z",
    "owner2": "",
    "current_taxes": 19293.45,
    "new_taxes_no_override": 20126.93,
    "override_total_1": 20698.01,
    "override_increase_1": 571.09
  },
  {
    "#": "44 Cypress St (179-11-00)",
    "$": 2614500,
    "address": "44 Cypress St",
    "parcel_id": "179-11-00",
    "owner1": "PEDERSEN, PALLE",
    "owner2": "KIM, NAM HEUI",
    "current_taxes": 23137.55,
    "new_taxes_no_override": 24137.09,
    "override_total_1": 24821.96,
    "override_increase_1": 684.87
  },
  {
    "#": "47 Cypress St, Unit 1 (198-08-01)",
    "$": 921000,
    "address": "47 Cypress St, Unit 1",
    "parcel_id": "198-08-01",
    "owner1": "ROZEK, KATHLEEN H",
    "owner2": "",
    "current_taxes": 5796.11,
    "new_taxes_no_override": 6046.5,
    "override_total_1": 6218.07,
    "override_increase_1": 171.56
  },
  {
    "#": "47 Cypress St, Unit 3 (198-08-03)",
    "$": 1506700,
    "address": "47 Cypress St, Unit 3",
    "parcel_id": "198-08-03",
    "owner1": "WOOD, DAVID C",
    "owner2": "FERRY, ELIZABETH E",
    "current_taxes": 11793.67,
    "new_taxes_no_override": 12303.16,
    "override_total_1": 12652.25,
    "override_increase_1": 349.09
  },
  {
    "#": "49 Cypress St, Unit 2 & P13-18 (198-08-02)",
    "$": 875900,
    "address": "49 Cypress St, Unit 2 & P13-18",
    "parcel_id": "198-08-02",
    "owner1": "FERRY TRS, DAVID R & ELIZABETH E & STEPHEN E",
    "owner2": "",
    "current_taxes": 8969.22,
    "new_taxes_no_override": 9356.69,
    "override_total_1": 9622.18,
    "override_increase_1": 265.49
  },
  {
    "#": "49 Cypress St, Unit 4 (198-08-04)",
    "$": 1490300,
    "address": "49 Cypress St, Unit 4",
    "parcel_id": "198-08-04",
    "owner1": "HO, CONNIE",
    "owner2": "LIU, DAVID",
    "current_taxes": 11625.74,
    "new_taxes_no_override": 12127.97,
    "override_total_1": 12472.09,
    "override_increase_1": 344.12
  },
  {
    "#": "54 Cypress St (179-10-00)",
    "$": 3399300,
    "address": "54 Cypress St",
    "parcel_id": "179-10-00",
    "owner1": "TOULOUMTZIS, MICHAEL P",
    "owner2": "OWEN, IRENE R",
    "current_taxes": 34808.83,
    "new_taxes_no_override": 36312.57,
    "override_total_1": 37342.91,
    "override_increase_1": 1030.34
  },
  {
    "#": "62 Cypress St, Unit 1 (180-03-01)",
    "$": 959400,
    "address": "62 Cypress St, Unit 1",
    "parcel_id": "180-03-01",
    "owner1": "LEE TR, JIA NA",
    "owner2": "",
    "current_taxes": 9824.26,
    "new_taxes_no_override": 10248.67,
    "override_total_1": 10539.47,
    "override_increase_1": 290.8
  },
  {
    "#": "62 Cypress St, Unit 3 (180-03-03)",
    "$": 949300,
    "address": "62 Cypress St, Unit 3",
    "parcel_id": "180-03-03",
    "owner1": "62 CYPRESS STREET LLC",
    "owner2": "",
    "current_taxes": 9720.83,
    "new_taxes_no_override": 10140.77,
    "override_total_1": 10428.51,
    "override_increase_1": 287.74
  },
  {
    "#": "62 Cypress St, Unit 5 (180-03-05)",
    "$": 941100,
    "address": "62 Cypress St, Unit 5",
    "parcel_id": "180-03-05",
    "owner1": "GARCIA, RICARDO",
    "owner2": "PUIG, ENRIQUETA",
    "current_taxes": 9636.86,
    "new_taxes_no_override": 10053.17,
    "override_total_1": 10338.42,
    "override_increase_1": 285.25
  },
  {
    "#": "64 Cypress St, Unit 1 (180-03-06)",
    "$": 936600,
    "address": "64 Cypress St, Unit 1",
    "parcel_id": "180-03-06",
    "owner1": "SOUSA LIFE ESTATE, CAROLE A",
    "owner2": "",
    "current_taxes": 5955.85,
    "new_taxes_no_override": 6213.14,
    "override_total_1": 6389.44,
    "override_increase_1": 176.29
  },
  {
    "#": "64 Cypress St, Unit 2 (180-03-07)",
    "$": 995800,
    "address": "64 Cypress St, Unit 2",
    "parcel_id": "180-03-07",
    "owner1": "JONES, STEVEN M & CATHERINE R",
    "owner2": "",
    "current_taxes": 6562.06,
    "new_taxes_no_override": 6845.54,
    "override_total_1": 7039.78,
    "override_increase_1": 194.24
  },
  {
    "#": "64 Cypress St, Unit 4 (180-03-09)",
    "$": 1126800,
    "address": "64 Cypress St, Unit 4",
    "parcel_id": "180-03-09",
    "owner1": "FILLER TRS, DEBORAH L",
    "owner2": "ABRAMS, ANN C",
    "current_taxes": 7903.5,
    "new_taxes_no_override": 8244.93,
    "override_total_1": 8478.87,
    "override_increase_1": 233.94
  },
  {
    "#": "69 Cypress St (197-01-00)",
    "$": 2783400,
    "address": "69 Cypress St",
    "parcel_id": "197-01-00",
    "owner1": "CHILDRENS CENTER OF BROOKLINE",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "70 Cypress St, Unit 1 (180-03-11)",
    "$": 1067200,
    "address": "70 Cypress St, Unit 1",
    "parcel_id": "180-03-11",
    "owner1": "GORDETSKY TR, SHARON",
    "owner2": "",
    "current_taxes": 7293.19,
    "new_taxes_no_override": 7608.26,
    "override_total_1": 7824.13,
    "override_increase_1": 215.88
  },
  {
    "#": "70 Cypress St, Unit 3 (180-03-13)",
    "$": 885600,
    "address": "70 Cypress St, Unit 3",
    "parcel_id": "180-03-13",
    "owner1": "CONSTANTINO, PAUL R",
    "owner2": "MARCOM, MARY F",
    "current_taxes": 5433.61,
    "new_taxes_no_override": 5668.34,
    "override_total_1": 5829.18,
    "override_increase_1": 160.83
  },
  {
    "#": "70 Cypress St, Unit 5 (180-03-14)",
    "$": 1205900,
    "address": "70 Cypress St, Unit 5",
    "parcel_id": "180-03-14",
    "owner1": "RINGQUIST, MICHAEL & EURIDICE R",
    "owner2": "",
    "current_taxes": 8713.48,
    "new_taxes_no_override": 9089.9,
    "override_total_1": 9347.82,
    "override_increase_1": 257.92
  },
  {
    "#": "72 Cypress St, Unit 1 (180-03-15)",
    "$": 912700,
    "address": "72 Cypress St, Unit 1",
    "parcel_id": "180-03-15",
    "owner1": "ERKKINEN, MICHAEL G",
    "owner2": "CHALLET, ANNA",
    "current_taxes": 5711.11,
    "new_taxes_no_override": 5957.83,
    "override_total_1": 6126.88,
    "override_increase_1": 169.05
  },
  {
    "#": "72 Cypress St, Unit 2 (180-03-16)",
    "$": 928800,
    "address": "72 Cypress St, Unit 2",
    "parcel_id": "180-03-16",
    "owner1": "PATEL, SANJAY",
    "owner2": "",
    "current_taxes": 9510.91,
    "new_taxes_no_override": 9921.78,
    "override_total_1": 10203.3,
    "override_increase_1": 281.52
  },
  {
    "#": "72 Cypress St, Unit 4 & P5 (180-03-18)",
    "$": 1024300,
    "address": "72 Cypress St, Unit 4 & P5",
    "parcel_id": "180-03-18",
    "owner1": "GIMENO, REBECCA MARCELINA",
    "owner2": "BEKKELI, KAI",
    "current_taxes": 10488.83,
    "new_taxes_no_override": 10941.95,
    "override_total_1": 11252.42,
    "override_increase_1": 310.47
  },
  {
    "#": "76 Cypress St, Unit 1 (180-02-01)",
    "$": 955600,
    "address": "76 Cypress St, Unit 1",
    "parcel_id": "180-02-01",
    "owner1": "JACOBSEN, KAREN",
    "owner2": "",
    "current_taxes": 6150.41,
    "new_taxes_no_override": 6416.11,
    "override_total_1": 6598.16,
    "override_increase_1": 182.05
  },
  {
    "#": "76 Cypress St, Unit 3 (180-02-03)",
    "$": 1083300,
    "address": "76 Cypress St, Unit 3",
    "parcel_id": "180-02-03",
    "owner1": "PINSKY, LAURA",
    "owner2": "",
    "current_taxes": 7458.06,
    "new_taxes_no_override": 7780.25,
    "override_total_1": 8001.01,
    "override_increase_1": 220.76
  },
  {
    "#": "78 Cypress St, Unit 2 & P-2 (180-02-02)",
    "$": 1401500,
    "address": "78 Cypress St, Unit 2 & P-2",
    "parcel_id": "180-02-02",
    "owner1": "RADDAY TR, ANNE C A",
    "owner2": "",
    "current_taxes": 10716.43,
    "new_taxes_no_override": 11179.38,
    "override_total_1": 11496.59,
    "override_increase_1": 317.21
  },
  {
    "#": "78 Cypress St, Unit 4 (180-02-04)",
    "$": 1074100,
    "address": "78 Cypress St, Unit 4",
    "parcel_id": "180-02-04",
    "owner1": "SEGERS, TR, ELIZABETH R",
    "owner2": "",
    "current_taxes": 7363.85,
    "new_taxes_no_override": 7681.97,
    "override_total_1": 7899.94,
    "override_increase_1": 217.97
  },
  {
    "#": "79 Cypress St (197-02-00)",
    "$": 2164000,
    "address": "79 Cypress St",
    "parcel_id": "197-02-00",
    "owner1": "GOODMAN TRS, ALAN M & PAMELA A",
    "owner2": "",
    "current_taxes": 18524.43,
    "new_taxes_no_override": 19324.69,
    "override_total_1": 19873.01,
    "override_increase_1": 548.32
  },
  {
    "#": "83 Cypress St (197-03-00)",
    "$": 2008300,
    "address": "83 Cypress St",
    "parcel_id": "197-03-00",
    "owner1": "HEINE, WALTER F & VELVIZHI RANGANATHAN",
    "owner2": "",
    "current_taxes": 16930.06,
    "new_taxes_no_override": 17661.44,
    "override_total_1": 18162.57,
    "override_increase_1": 501.13
  },
  {
    "#": "86 Cypress St, Unit 5 (180-01-01)",
    "$": 945800,
    "address": "86 Cypress St, Unit 5",
    "parcel_id": "180-01-01",
    "owner1": "SHAPIRO, RONNIE",
    "owner2": "",
    "current_taxes": 6050.06,
    "new_taxes_no_override": 6311.42,
    "override_total_1": 6490.5,
    "override_increase_1": 179.08
  },
  {
    "#": "86 Cypress St, Unit 7 (180-01-03)",
    "$": 1482700,
    "address": "86 Cypress St, Unit 7",
    "parcel_id": "180-01-03",
    "owner1": "FONT, ET AL, LOUIS P",
    "owner2": "",
    "current_taxes": 11547.91,
    "new_taxes_no_override": 12046.78,
    "override_total_1": 12388.6,
    "override_increase_1": 341.82
  },
  {
    "#": "90 Cypress St (181-04-00)",
    "$": 7677200,
    "address": "90 Cypress St",
    "parcel_id": "181-04-00",
    "owner1": "CYPRESS DAVIS LJS LLC",
    "owner2": "",
    "current_taxes": 78614.53,
    "new_taxes_no_override": 82010.68,
    "override_total_1": 84337.67,
    "override_increase_1": 2326.99
  },
  {
    "#": "98 Cypress St (181-02-03)",
    "$": 2832200,
    "address": "98 Cypress St",
    "parcel_id": "181-02-03",
    "owner1": "98 CYPRESS STREET LLC",
    "owner2": "",
    "current_taxes": 29001.73,
    "new_taxes_no_override": 30254.6,
    "override_total_1": 31113.06,
    "override_increase_1": 858.45
  },
  {
    "#": "102 Cypress St (181-01-00)",
    "$": 3532900,
    "address": "102 Cypress St",
    "parcel_id": "181-01-00",
    "owner1": "TUCK TR, RICHARD L",
    "owner2": "C/O TUCK BENJAMIN",
    "current_taxes": 36176.9,
    "new_taxes_no_override": 37739.74,
    "override_total_1": 38810.58,
    "override_increase_1": 1070.84
  },
  {
    "#": "110 Cypress St, Unit 101 Gu2&5 (189-32-02)",
    "$": 1213800,
    "address": "110 Cypress St, Unit 101 Gu2&5",
    "parcel_id": "189-32-02",
    "owner1": "SAWHNEY, VINEY & POONAM",
    "owner2": "",
    "current_taxes": 12429.31,
    "new_taxes_no_override": 12966.26,
    "override_total_1": 13334.16,
    "override_increase_1": 367.91
  },
  {
    "#": "110 Cypress St, Unit 102 Gu3&6 (189-32-03)",
    "$": 263400,
    "address": "110 Cypress St, Unit 102 Gu3&6",
    "parcel_id": "189-32-03",
    "owner1": "STEINBERGH TRS, ALEX M",
    "owner2": "BOWDEN, S R",
    "current_taxes": 2697.22,
    "new_taxes_no_override": 2813.74,
    "override_total_1": 2893.58,
    "override_increase_1": 79.84
  },
  {
    "#": "110 Cypress St, Unit 103 G72&27 (189-32-04)",
    "$": 1233400,
    "address": "110 Cypress St, Unit 103 G72&27",
    "parcel_id": "189-32-04",
    "owner1": "SMITH TRS, JOAN G & KEVIN J",
    "owner2": "",
    "current_taxes": 8995.08,
    "new_taxes_no_override": 9383.67,
    "override_total_1": 9649.92,
    "override_increase_1": 266.25
  },
  {
    "#": "110 Cypress St, Unit 104 G14&20 (189-32-05)",
    "$": 989700,
    "address": "110 Cypress St, Unit 104 G14&20",
    "parcel_id": "189-32-05",
    "owner1": "LAMMERS, NAOKO",
    "owner2": "",
    "current_taxes": 10134.53,
    "new_taxes_no_override": 10572.34,
    "override_total_1": 10872.32,
    "override_increase_1": 299.98
  },
  {
    "#": "110 Cypress St, Unit 105 Gu7&8 (189-32-06)",
    "$": 1262600,
    "address": "110 Cypress St, Unit 105 Gu7&8",
    "parcel_id": "189-32-06",
    "owner1": "PARK, SANDRA",
    "owner2": "ROBERTS, CARMICHAEL S JR",
    "current_taxes": 12929.02,
    "new_taxes_no_override": 13487.55,
    "override_total_1": 13870.25,
    "override_increase_1": 382.7
  },
  {
    "#": "110 Cypress St, Unit 106 G13&19 (189-32-07)",
    "$": 230100,
    "address": "110 Cypress St, Unit 106 G13&19",
    "parcel_id": "189-32-07",
    "owner1": "STEINBERGH TRS, ALEX M",
    "owner2": "BOWDEN, S R",
    "current_taxes": 2356.22,
    "new_taxes_no_override": 2458.01,
    "override_total_1": 2527.75,
    "override_increase_1": 69.74
  },
  {
    "#": "110 Cypress St, Unit 107 G44&45 (189-32-08)",
    "$": 1112500,
    "address": "110 Cypress St, Unit 107 G44&45",
    "parcel_id": "189-32-08",
    "owner1": "DIMOV, NELLY & IVAYIO",
    "owner2": "",
    "current_taxes": 7757.07,
    "new_taxes_no_override": 8092.18,
    "override_total_1": 8321.78,
    "override_increase_1": 229.61
  },
  {
    "#": "110 Cypress St, Unit 108 Ul9-10 (189-32-09)",
    "$": 1171500,
    "address": "110 Cypress St, Unit 108 Ul9-10",
    "parcel_id": "189-32-09",
    "owner1": "SRISWASDI, PATCHAREE",
    "owner2": "",
    "current_taxes": 11996.16,
    "new_taxes_no_override": 12514.39,
    "override_total_1": 12869.48,
    "override_increase_1": 355.09
  },
  {
    "#": "110 Cypress St, Unit 109 G11&17 (189-32-10)",
    "$": 263400,
    "address": "110 Cypress St, Unit 109 G11&17",
    "parcel_id": "189-32-10",
    "owner1": "STEINBERGH TRS, ALEX M",
    "owner2": "BOWDEN, S R",
    "current_taxes": 2697.22,
    "new_taxes_no_override": 2813.74,
    "override_total_1": 2893.58,
    "override_increase_1": 79.84
  },
  {
    "#": "110 Cypress St, Unit 112 & Ul1-4-16-26 (189-32-01)",
    "$": 1625100,
    "address": "110 Cypress St, Unit 112 & Ul1-4-16-26",
    "parcel_id": "189-32-01",
    "owner1": "SAWHNEY, VINEY & POONAM",
    "owner2": "",
    "current_taxes": 16641.02,
    "new_taxes_no_override": 17359.91,
    "override_total_1": 17852.49,
    "override_increase_1": 492.57
  },
  {
    "#": "110 Cypress St, Unit 201 Gl1&20 (189-32-11)",
    "$": 1064300,
    "address": "110 Cypress St, Unit 201 Gl1&20",
    "parcel_id": "189-32-11",
    "owner1": "SHETH, KEVIN",
    "owner2": "",
    "current_taxes": 10898.43,
    "new_taxes_no_override": 11369.24,
    "override_total_1": 11691.84,
    "override_increase_1": 322.59
  },
  {
    "#": "110 Cypress St, Unit 202 Gl2&21 (189-32-12)",
    "$": 230100,
    "address": "110 Cypress St, Unit 202 Gl2&21",
    "parcel_id": "189-32-12",
    "owner1": "STEINBERGH TRS, ALEX M",
    "owner2": "BOWDEN, S R",
    "current_taxes": 2356.22,
    "new_taxes_no_override": 2458.01,
    "override_total_1": 2527.75,
    "override_increase_1": 69.74
  },
  {
    "#": "110 Cypress St, Unit 203 Gl3&22 (189-32-13)",
    "$": 1071500,
    "address": "110 Cypress St, Unit 203 Gl3&22",
    "parcel_id": "189-32-13",
    "owner1": "TORRES-HOUSSAMI, ANA",
    "owner2": "",
    "current_taxes": 7337.23,
    "new_taxes_no_override": 7654.2,
    "override_total_1": 7871.38,
    "override_increase_1": 217.18
  },
  {
    "#": "110 Cypress St, Unit 204 G41&42 (189-32-14)",
    "$": 692500,
    "address": "110 Cypress St, Unit 204 G41&42",
    "parcel_id": "189-32-14",
    "owner1": "LI, YIWEI",
    "owner2": "",
    "current_taxes": 3456.27,
    "new_taxes_no_override": 3605.58,
    "override_total_1": 3707.89,
    "override_increase_1": 102.31
  },
  {
    "#": "110 Cypress St, Unit 205 Gl4&23 (189-32-15)",
    "$": 1124100,
    "address": "110 Cypress St, Unit 205 Gl4&23",
    "parcel_id": "189-32-15",
    "owner1": "BRADBURY, MICHAEL",
    "owner2": "LI, BIN",
    "current_taxes": 7875.85,
    "new_taxes_no_override": 8216.09,
    "override_total_1": 8449.21,
    "override_increase_1": 233.13
  },
  {
    "#": "110 Cypress St, Unit 206 Gl5&24 (189-32-16)",
    "$": 1094700,
    "address": "110 Cypress St, Unit 206 Gl5&24",
    "parcel_id": "189-32-16",
    "owner1": "BUDNEY, ALBERT J",
    "owner2": "KAREN, VICKERS",
    "current_taxes": 11209.73,
    "new_taxes_no_override": 11693.99,
    "override_total_1": 12025.8,
    "override_increase_1": 331.81
  },
  {
    "#": "110 Cypress St, Unit 207 Gl6&25 (189-32-17)",
    "$": 981200,
    "address": "110 Cypress St, Unit 207 Gl6&25",
    "parcel_id": "189-32-17",
    "owner1": "ZHANG, YANG",
    "owner2": "",
    "current_taxes": 10047.49,
    "new_taxes_no_override": 10481.54,
    "override_total_1": 10778.95,
    "override_increase_1": 297.41
  },
  {
    "#": "110 Cypress St, Unit 208 G53&61 (189-32-18)",
    "$": 230100,
    "address": "110 Cypress St, Unit 208 G53&61",
    "parcel_id": "189-32-18",
    "owner1": "STEINBERGH TRS, ALEX M",
    "owner2": "BOWDEN, S R",
    "current_taxes": 2356.22,
    "new_taxes_no_override": 2458.01,
    "override_total_1": 2527.75,
    "override_increase_1": 69.74
  },
  {
    "#": "110 Cypress St, Unit 209 G52&60 (189-32-19)",
    "$": 1015300,
    "address": "110 Cypress St, Unit 209 G52&60",
    "parcel_id": "189-32-19",
    "owner1": "PANTIC TR, ZORICA",
    "owner2": "",
    "current_taxes": 10396.67,
    "new_taxes_no_override": 10845.81,
    "override_total_1": 11153.55,
    "override_increase_1": 307.74
  },
  {
    "#": "110 Cypress St, Unit 210 G51&59 (189-32-20)",
    "$": 973500,
    "address": "110 Cypress St, Unit 210 G51&59",
    "parcel_id": "189-32-20",
    "owner1": "PENTAKOTA, SUJATHA",
    "owner2": "",
    "current_taxes": 6333.71,
    "new_taxes_no_override": 6607.33,
    "override_total_1": 6794.8,
    "override_increase_1": 187.48
  },
  {
    "#": "110 Cypress St, Unit 211Gl50-58 (189-32-21)",
    "$": 1143300,
    "address": "110 Cypress St, Unit 211Gl50-58",
    "parcel_id": "189-32-21",
    "owner1": "NAYAK, LAKSHMI",
    "owner2": "",
    "current_taxes": 8072.46,
    "new_taxes_no_override": 8421.19,
    "override_total_1": 8660.14,
    "override_increase_1": 238.94
  },
  {
    "#": "110 Cypress St, Unit 212Gl57-48 (189-32-22)",
    "$": 1114300,
    "address": "110 Cypress St, Unit 212Gl57-48",
    "parcel_id": "189-32-22",
    "owner1": "ANER, MUSA & ELDA ESIM",
    "owner2": "",
    "current_taxes": 11410.43,
    "new_taxes_no_override": 11903.36,
    "override_total_1": 12241.11,
    "override_increase_1": 337.75
  },
  {
    "#": "110 Cypress St, Unit 301 G13&32 (189-32-23)",
    "$": 1062200,
    "address": "110 Cypress St, Unit 301 G13&32",
    "parcel_id": "189-32-23",
    "owner1": "CHAKIR, MEHDI",
    "owner2": "KAPUSCINSKI, KINGA",
    "current_taxes": 10876.93,
    "new_taxes_no_override": 11346.81,
    "override_total_1": 11668.77,
    "override_increase_1": 321.96
  },
  {
    "#": "110 Cypress St, Unit 302 G14&33 (189-32-24)",
    "$": 877500,
    "address": "110 Cypress St, Unit 302 G14&33",
    "parcel_id": "189-32-24",
    "owner1": "HAJER TRS, MARILYN B & ROB",
    "owner2": "",
    "current_taxes": 8985.6,
    "new_taxes_no_override": 9373.78,
    "override_total_1": 9639.75,
    "override_increase_1": 265.97
  },
  {
    "#": "110 Cypress St, Unit 303 G15&34 (189-32-25)",
    "$": 1071500,
    "address": "110 Cypress St, Unit 303 G15&34",
    "parcel_id": "189-32-25",
    "owner1": "FRIEDMAN, JACK",
    "owner2": "LEGASSIE, TODD M",
    "current_taxes": 7337.23,
    "new_taxes_no_override": 7654.2,
    "override_total_1": 7871.38,
    "override_increase_1": 217.18
  },
  {
    "#": "110 Cypress St, Unit 304 G16&35 (189-32-26)",
    "$": 686200,
    "address": "110 Cypress St, Unit 304 G16&35",
    "parcel_id": "189-32-26",
    "owner1": "LEE, SEOUNG BUM",
    "owner2": "KIM, HEE YOUNG",
    "current_taxes": 7026.69,
    "new_taxes_no_override": 7330.24,
    "override_total_1": 7538.23,
    "override_increase_1": 207.99
  },
  {
    "#": "110 Cypress St, Unit 305 G67&68 (189-32-27)",
    "$": 1131400,
    "address": "110 Cypress St, Unit 305 G67&68",
    "parcel_id": "189-32-27",
    "owner1": "HOCHMAN, ELLEN",
    "owner2": "",
    "current_taxes": 7950.6,
    "new_taxes_no_override": 8294.07,
    "override_total_1": 8529.4,
    "override_increase_1": 235.34
  },
  {
    "#": "110 Cypress St, Unit 306 G69&70 (189-32-28)",
    "$": 1093400,
    "address": "110 Cypress St, Unit 306 G69&70",
    "parcel_id": "189-32-28",
    "owner1": "PETRAS JR, JOSEPH R",
    "owner2": "",
    "current_taxes": 11196.42,
    "new_taxes_no_override": 11680.11,
    "override_total_1": 12011.52,
    "override_increase_1": 331.41
  },
  {
    "#": "110 Cypress St, Unit 307 G17&36 (189-32-29)",
    "$": 984600,
    "address": "110 Cypress St, Unit 307 G17&36",
    "parcel_id": "189-32-29",
    "owner1": "CHANG, CHIA-RUI",
    "owner2": "",
    "current_taxes": 6447.37,
    "new_taxes_no_override": 6725.9,
    "override_total_1": 6916.74,
    "override_increase_1": 190.84
  },
  {
    "#": "110 Cypress St, Unit 308 G18&37 (189-32-30)",
    "$": 987200,
    "address": "110 Cypress St, Unit 308 G18&37",
    "parcel_id": "189-32-30",
    "owner1": "KUNG, PETER",
    "owner2": "KETWAROO, KAVITA",
    "current_taxes": 6473.99,
    "new_taxes_no_override": 6753.67,
    "override_total_1": 6945.3,
    "override_increase_1": 191.63
  },
  {
    "#": "110 Cypress St, Unit 309 G11&30 (189-32-31)",
    "$": 1012800,
    "address": "110 Cypress St, Unit 309 G11&30",
    "parcel_id": "189-32-31",
    "owner1": "HOASJOE TR, KAY YIN KWAN",
    "owner2": "",
    "current_taxes": 6736.14,
    "new_taxes_no_override": 7027.14,
    "override_total_1": 7226.53,
    "override_increase_1": 199.39
  },
  {
    "#": "110 Cypress St, Unit 310Gl46-55 (189-32-32)",
    "$": 970100,
    "address": "110 Cypress St, Unit 310Gl46-55",
    "parcel_id": "189-32-32",
    "owner1": "DIEDA, DYAN",
    "owner2": "BHATIA, JASVINDER S",
    "current_taxes": 6298.89,
    "new_taxes_no_override": 6571.0,
    "override_total_1": 6757.45,
    "override_increase_1": 186.45
  },
  {
    "#": "110 Cypress St, Unit 311 G44&49 (189-32-33)",
    "$": 1145500,
    "address": "110 Cypress St, Unit 311 G44&49",
    "parcel_id": "189-32-33",
    "owner1": "YANASE, KUMIKO",
    "owner2": "",
    "current_taxes": 8094.99,
    "new_taxes_no_override": 8444.69,
    "override_total_1": 8684.31,
    "override_increase_1": 239.61
  },
  {
    "#": "110 Cypress St, Unit 312 G47&56 (189-32-34)",
    "$": 1108300,
    "address": "110 Cypress St, Unit 312 G47&56",
    "parcel_id": "189-32-34",
    "owner1": "ZIMMET TR, SUZANNA",
    "owner2": "",
    "current_taxes": 7714.06,
    "new_taxes_no_override": 8047.31,
    "override_total_1": 8275.64,
    "override_increase_1": 228.34
  },
  {
    "#": "110 Cypress St, Unit Ph-1 G7&26 (189-32-35)",
    "$": 1029000,
    "address": "110 Cypress St, Unit Ph-1 G7&26",
    "parcel_id": "189-32-35",
    "owner1": "KOZONO, DAVID",
    "owner2": "",
    "current_taxes": 6902.03,
    "new_taxes_no_override": 7200.2,
    "override_total_1": 7404.5,
    "override_increase_1": 204.3
  },
  {
    "#": "110 Cypress St, Unit Ph-2 G8&27 (189-32-36)",
    "$": 861700,
    "address": "110 Cypress St, Unit Ph-2 G8&27",
    "parcel_id": "189-32-36",
    "owner1": "LIU, JASON W",
    "owner2": "KWAN, AMY M",
    "current_taxes": 8823.81,
    "new_taxes_no_override": 9205.0,
    "override_total_1": 9466.18,
    "override_increase_1": 261.18
  },
  {
    "#": "110 Cypress St, Unit Ph10 & Ul15-21 (189-32-44)",
    "$": 970100,
    "address": "110 Cypress St, Unit Ph10 & Ul15-21",
    "parcel_id": "189-32-44",
    "owner1": "LEE, JIA NA",
    "owner2": "C/O JIA NA LEE",
    "current_taxes": 9933.82,
    "new_taxes_no_override": 10362.96,
    "override_total_1": 10657.0,
    "override_increase_1": 294.04
  },
  {
    "#": "110 Cypress St, Unit Ph11 &Ll40-43 (189-32-45)",
    "$": 978200,
    "address": "110 Cypress St, Unit Ph11 &Ll40-43",
    "parcel_id": "189-32-45",
    "owner1": "RIELLA, LEONARDO & CRISTIAN",
    "owner2": "",
    "current_taxes": 10016.77,
    "new_taxes_no_override": 10449.49,
    "override_total_1": 10745.99,
    "override_increase_1": 296.5
  },
  {
    "#": "110 Cypress St, Unit Ph12 & Ll12-31 (189-32-46)",
    "$": 1007700,
    "address": "110 Cypress St, Unit Ph12 & Ll12-31",
    "parcel_id": "189-32-46",
    "owner1": "ALTAN, BETUL S",
    "owner2": "",
    "current_taxes": 10318.85,
    "new_taxes_no_override": 10764.62,
    "override_total_1": 11070.06,
    "override_increase_1": 305.44
  },
  {
    "#": "110 Cypress St, Unit Ph3 Ll9-28 (189-32-37)",
    "$": 1022200,
    "address": "110 Cypress St, Unit Ph3 Ll9-28",
    "parcel_id": "189-32-37",
    "owner1": "PAYTON, MARIE",
    "owner2": "",
    "current_taxes": 6832.39,
    "new_taxes_no_override": 7127.55,
    "override_total_1": 7329.79,
    "override_increase_1": 202.24
  },
  {
    "#": "110 Cypress St, Unit Ph4 G19&38 (189-32-38)",
    "$": 663700,
    "address": "110 Cypress St, Unit Ph4 G19&38",
    "parcel_id": "189-32-38",
    "owner1": "GOODWIN, MARJORIE A",
    "owner2": "",
    "current_taxes": 6796.29,
    "new_taxes_no_override": 7089.89,
    "override_total_1": 7291.06,
    "override_increase_1": 201.17
  },
  {
    "#": "110 Cypress St, Unit Ph5 G64&65 (189-32-39)",
    "$": 1215900,
    "address": "110 Cypress St, Unit Ph5 G64&65",
    "parcel_id": "189-32-39",
    "owner1": "YANG, LI-SHANG CHEN & JUEI MAO",
    "owner2": "",
    "current_taxes": 8815.88,
    "new_taxes_no_override": 9196.73,
    "override_total_1": 9457.68,
    "override_increase_1": 260.95
  },
  {
    "#": "110 Cypress St, Unit Ph6 G62-63 (189-32-40)",
    "$": 1095100,
    "address": "110 Cypress St, Unit Ph6 G62-63",
    "parcel_id": "189-32-40",
    "owner1": "BONAUTO TR, STEVEN J",
    "owner2": "",
    "current_taxes": 11213.82,
    "new_taxes_no_override": 11698.26,
    "override_total_1": 12030.19,
    "override_increase_1": 331.93
  },
  {
    "#": "110 Cypress St, Unit Ph7 G45&54 (189-32-41)",
    "$": 834100,
    "address": "110 Cypress St, Unit Ph7 G45&54",
    "parcel_id": "189-32-41",
    "owner1": "BALSAS, MARY",
    "owner2": "",
    "current_taxes": 4906.25,
    "new_taxes_no_override": 5118.2,
    "override_total_1": 5263.43,
    "override_increase_1": 145.23
  },
  {
    "#": "110 Cypress St, Unit Ph8 G10&29 (189-32-42)",
    "$": 975200,
    "address": "110 Cypress St, Unit Ph8 G10&29",
    "parcel_id": "189-32-42",
    "owner1": "PATEL, SANDIP & ADITYA S",
    "owner2": "",
    "current_taxes": 6351.11,
    "new_taxes_no_override": 6625.48,
    "override_total_1": 6813.47,
    "override_increase_1": 187.99
  },
  {
    "#": "110 Cypress St, Unit Ph9 G66&71 (189-32-43)",
    "$": 895000,
    "address": "110 Cypress St, Unit Ph9 G66&71",
    "parcel_id": "189-32-43",
    "owner1": "KANG, JIAWEN",
    "owner2": "",
    "current_taxes": 9164.8,
    "new_taxes_no_override": 9560.72,
    "override_total_1": 9832.0,
    "override_increase_1": 271.28
  },
  {
    "#": "110 Cypress St, Unit Pk Sps (189-32-47)",
    "$": 892500,
    "address": "110 Cypress St, Unit Pk Sps",
    "parcel_id": "189-32-47",
    "owner1": "CYPRESS PARKING LJS LLC",
    "owner2": "",
    "current_taxes": 9139.2,
    "new_taxes_no_override": 9534.01,
    "override_total_1": 9804.53,
    "override_increase_1": 270.52
  },
  {
    "#": "116 Cypress St (189-31-00)",
    "$": 1716500,
    "address": "116 Cypress St",
    "parcel_id": "189-31-00",
    "owner1": "116 CYPRESS LLC",
    "owner2": "",
    "current_taxes": 29455.14,
    "new_taxes_no_override": 30727.6,
    "override_total_1": 31599.47,
    "override_increase_1": 871.87
  },
  {
    "#": "120 Cypress St (189-30-00)",
    "$": 1111800,
    "address": "120 Cypress St",
    "parcel_id": "189-30-00",
    "owner1": "EMAD REALTY LLC",
    "owner2": "",
    "current_taxes": 19078.49,
    "new_taxes_no_override": 19902.68,
    "override_total_1": 20467.4,
    "override_increase_1": 564.72
  },
  {
    "#": "131 Cypress St (190-01-00)",
    "$": 8410300,
    "address": "131 Cypress St",
    "parcel_id": "190-01-00",
    "owner1": "131 CYPRESS ST LLC",
    "owner2": "",
    "current_taxes": 106491.7,
    "new_taxes_no_override": 111092.14,
    "override_total_1": 114244.3,
    "override_increase_1": 3152.15
  },
  {
    "#": "144 Cypress St (318-13-00)",
    "$": 1822500,
    "address": "144 Cypress St",
    "parcel_id": "318-13-00",
    "owner1": "144 CYPRESS LLC",
    "owner2": "",
    "current_taxes": 19534.05,
    "new_taxes_no_override": 20377.92,
    "override_total_1": 20956.13,
    "override_increase_1": 578.21
  },
  {
    "#": "150 Cypress St (318-12-00)",
    "$": 2138200,
    "address": "150 Cypress St",
    "parcel_id": "318-12-00",
    "owner1": "FLESSAS, THEODORE W",
    "owner2": "KURKER, BERTINA J",
    "current_taxes": 18260.23,
    "new_taxes_no_override": 19049.07,
    "override_total_1": 19589.57,
    "override_increase_1": 540.5
  },
  {
    "#": "153 Cypress St (319-01-00)",
    "$": 1800600,
    "address": "153 Cypress St",
    "parcel_id": "319-01-00",
    "owner1": "MARGULIES, JENNY MARIE SEARLES & KENDRA MARIE",
    "owner2": "",
    "current_taxes": 14803.21,
    "new_taxes_no_override": 15442.71,
    "override_total_1": 15880.88,
    "override_increase_1": 438.18
  },
  {
    "#": "156 Cypress St (318-03-01)",
    "$": 1489500,
    "address": "156 Cypress St",
    "parcel_id": "318-03-01",
    "owner1": "PEARL, RONALD & SARAH",
    "owner2": "",
    "current_taxes": 11617.55,
    "new_taxes_no_override": 12119.43,
    "override_total_1": 12463.31,
    "override_increase_1": 343.88
  },
  {
    "#": "157 Cypress St, Unit 1 (320-01-01)",
    "$": 1416100,
    "address": "157 Cypress St, Unit 1",
    "parcel_id": "320-01-01",
    "owner1": "GOULD-CALABRO, JODY",
    "owner2": "GOULD, RODNEY & NANCY",
    "current_taxes": 10865.93,
    "new_taxes_no_override": 11335.34,
    "override_total_1": 11656.97,
    "override_increase_1": 321.63
  },
  {
    "#": "157 Cypress St, Unit 2 (320-01-02)",
    "$": 1696600,
    "address": "157 Cypress St, Unit 2",
    "parcel_id": "320-01-02",
    "owner1": "FRICKER, ERIN & ZACHARY",
    "owner2": "",
    "current_taxes": 13738.25,
    "new_taxes_no_override": 14331.74,
    "override_total_1": 14738.39,
    "override_increase_1": 406.65
  },
  {
    "#": "158 Cypress St (318-03-00)",
    "$": 1588900,
    "address": "158 Cypress St",
    "parcel_id": "318-03-00",
    "owner1": "ALLEN, RICHARD E & ALICE E",
    "owner2": "",
    "current_taxes": 16270.34,
    "new_taxes_no_override": 16973.22,
    "override_total_1": 17454.82,
    "override_increase_1": 481.6
  },
  {
    "#": "161 Cypress St (320-02-00)",
    "$": 2438400,
    "address": "161 Cypress St",
    "parcel_id": "320-02-00",
    "owner1": "MEIKLEJOHN, D RANDOLPH",
    "owner2": "SOKAL, DIANE",
    "current_taxes": 21334.28,
    "new_taxes_no_override": 22255.92,
    "override_total_1": 22887.42,
    "override_increase_1": 631.49
  },
  {
    "#": "162 Cypress St (318-02-00)",
    "$": 2071400,
    "address": "162 Cypress St",
    "parcel_id": "318-02-00",
    "owner1": "KALLAHER, CHRISTOPHER H",
    "owner2": "KAPLAN, CLAIRE E",
    "current_taxes": 17576.2,
    "new_taxes_no_override": 18335.49,
    "override_total_1": 18855.75,
    "override_increase_1": 520.26
  },
  {
    "#": "165 Cypress St (320-03-00)",
    "$": 1723500,
    "address": "165 Cypress St",
    "parcel_id": "320-03-00",
    "owner1": "MATYKA LIFE ESTATE, BARBARA A",
    "owner2": "",
    "current_taxes": 14013.71,
    "new_taxes_no_override": 14619.1,
    "override_total_1": 15033.91,
    "override_increase_1": 414.81
  },
  {
    "#": "168 Cypress St, Unit 168 (318-01-02)",
    "$": 962600,
    "address": "168 Cypress St, Unit 168",
    "parcel_id": "318-01-02",
    "owner1": "GENDELMAN TRS, DAVID S",
    "owner2": "ZUCKERMAN, DEBORAH",
    "current_taxes": 9857.02,
    "new_taxes_no_override": 10282.84,
    "override_total_1": 10574.61,
    "override_increase_1": 291.77
  },
  {
    "#": "170 Cypress St, Unit 170 (318-01-03)",
    "$": 1138200,
    "address": "170 Cypress St, Unit 170",
    "parcel_id": "318-01-03",
    "owner1": "VAZQUEZ, RAFAEL",
    "owner2": "",
    "current_taxes": 8020.23,
    "new_taxes_no_override": 8366.7,
    "override_total_1": 8604.1,
    "override_increase_1": 237.4
  },
  {
    "#": "171 Cypress St (320-03-01)",
    "$": 1667900,
    "address": "171 Cypress St",
    "parcel_id": "320-03-01",
    "owner1": "MITSIU, NICHOLAOS",
    "owner2": "",
    "current_taxes": 13444.36,
    "new_taxes_no_override": 14025.16,
    "override_total_1": 14423.11,
    "override_increase_1": 397.95
  },
  {
    "#": "175 Cypress St (320-04-00)",
    "$": 1691800,
    "address": "175 Cypress St",
    "parcel_id": "320-04-00",
    "owner1": "LAI LIFE ESTATE, KIN LUN & SUSANNA",
    "owner2": "",
    "current_taxes": 13689.1,
    "new_taxes_no_override": 14280.47,
    "override_total_1": 14685.67,
    "override_increase_1": 405.2
  },
  {
    "#": "193 Cypress St (317-20-00)",
    "$": 2249400,
    "address": "193 Cypress St",
    "parcel_id": "317-20-00",
    "owner1": "TUCK TR, BENJAMIN S",
    "owner2": "",
    "current_taxes": 23033.86,
    "new_taxes_no_override": 24028.92,
    "override_total_1": 24710.73,
    "override_increase_1": 681.8
  },
  {
    "#": "195 Cypress St, Unit 1 (317-21-01)",
    "$": 896700,
    "address": "195 Cypress St, Unit 1",
    "parcel_id": "317-21-01",
    "owner1": "FLANDERS TR, RACHEL",
    "owner2": "",
    "current_taxes": 5547.27,
    "new_taxes_no_override": 5786.91,
    "override_total_1": 5951.11,
    "override_increase_1": 164.2
  },
  {
    "#": "195 Cypress St, Unit 2 (317-21-02)",
    "$": 860200,
    "address": "195 Cypress St, Unit 2",
    "parcel_id": "317-21-02",
    "owner1": "TALISSE, CHRISTY & CHARLES & EDWARD A & PAMELA KIM",
    "owner2": "",
    "current_taxes": 5173.51,
    "new_taxes_no_override": 5397.01,
    "override_total_1": 5550.14,
    "override_increase_1": 153.14
  },
  {
    "#": "195 Cypress St, Unit 3 (317-21-03)",
    "$": 1155600,
    "address": "195 Cypress St, Unit 3",
    "parcel_id": "317-21-03",
    "owner1": "MERKELY, GERGO",
    "owner2": "KARADY, JULIA",
    "current_taxes": 8198.41,
    "new_taxes_no_override": 8552.58,
    "override_total_1": 8795.25,
    "override_increase_1": 242.67
  },
  {
    "#": "205 Cypress St (317-25-00)",
    "$": 6359400,
    "address": "205 Cypress St",
    "parcel_id": "317-25-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O CLARK PLAYGROUND",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "215 Cypress St (317-30-00)",
    "$": 1723800,
    "address": "215 Cypress St",
    "parcel_id": "317-30-00",
    "owner1": "LEE TR, JULIA GOON",
    "owner2": "LEE, WAI C",
    "current_taxes": 17651.71,
    "new_taxes_no_override": 18414.26,
    "override_total_1": 18936.75,
    "override_increase_1": 522.49
  },
  {
    "#": "217 Cypress St, Unit 1 (317-31-01)",
    "$": 629800,
    "address": "217 Cypress St, Unit 1",
    "parcel_id": "317-31-01",
    "owner1": "HYDE TRS, JONATHAN R & KAORI S",
    "owner2": "",
    "current_taxes": 2814.22,
    "new_taxes_no_override": 2935.79,
    "override_total_1": 3019.1,
    "override_increase_1": 83.3
  },
  {
    "#": "217 Cypress St, Unit 2 (317-31-02)",
    "$": 619100,
    "address": "217 Cypress St, Unit 2",
    "parcel_id": "317-31-02",
    "owner1": "GORDON, EMILY J",
    "owner2": "",
    "current_taxes": 2704.65,
    "new_taxes_no_override": 2821.49,
    "override_total_1": 2901.55,
    "override_increase_1": 80.06
  },
  {
    "#": "217 Cypress St, Unit 3 (317-31-03)",
    "$": 925100,
    "address": "217 Cypress St, Unit 3",
    "parcel_id": "317-31-03",
    "owner1": "BURNS, MATTHEW",
    "owner2": "",
    "current_taxes": 9473.02,
    "new_taxes_no_override": 9882.25,
    "override_total_1": 10162.66,
    "override_increase_1": 280.4
  },
  {
    "#": "224 Cypress St (307-03-00)",
    "$": 1296500,
    "address": "224 Cypress St",
    "parcel_id": "307-03-00",
    "owner1": "CYPRESS STREET 224 LLC",
    "owner2": "",
    "current_taxes": 22247.94,
    "new_taxes_no_override": 23209.05,
    "override_total_1": 23867.59,
    "override_increase_1": 658.54
  },
  {
    "#": "227 Cypress St (317-32-33)",
    "$": 2809600,
    "address": "227 Cypress St",
    "parcel_id": "317-32-33",
    "owner1": "RAKERALL REALTY LLC",
    "owner2": "",
    "current_taxes": 48212.74,
    "new_taxes_no_override": 50295.53,
    "override_total_1": 51722.63,
    "override_increase_1": 1427.1
  },
  {
    "#": "229 Cypress St (317-34-00)",
    "$": 1017800,
    "address": "229 Cypress St",
    "parcel_id": "317-34-00",
    "owner1": "CUMMINS, PATRICE R",
    "owner2": "",
    "current_taxes": 6787.34,
    "new_taxes_no_override": 7080.55,
    "override_total_1": 7281.46,
    "override_increase_1": 200.91
  },
  {
    "#": "230 Cypress St (307-01-02)",
    "$": 1342700,
    "address": "230 Cypress St",
    "parcel_id": "307-01-02",
    "owner1": "ELIE ON CYPRESS STREET LLC",
    "owner2": "",
    "current_taxes": 23040.73,
    "new_taxes_no_override": 24036.09,
    "override_total_1": 24718.1,
    "override_increase_1": 682.01
  },
  {
    "#": "234 Cypress St (306-06-00)",
    "$": 1488400,
    "address": "234 Cypress St",
    "parcel_id": "306-06-00",
    "owner1": "CYPRESS STREET 234 REALTY LLC",
    "owner2": "",
    "current_taxes": 15241.22,
    "new_taxes_no_override": 15899.64,
    "override_total_1": 16350.78,
    "override_increase_1": 451.14
  },
  {
    "#": "235 Cypress St (316-23-00)",
    "$": 7883300,
    "address": "235 Cypress St",
    "parcel_id": "316-23-00",
    "owner1": "HAMILTON CYPRESS LLC",
    "owner2": "",
    "current_taxes": 135277.43,
    "new_taxes_no_override": 141121.41,
    "override_total_1": 145125.63,
    "override_increase_1": 4004.21
  },
  {
    "#": "236 Cypress St (306-05-00)",
    "$": 1539300,
    "address": "236 Cypress St",
    "parcel_id": "306-05-00",
    "owner1": "WOO WOO REALTY LLC",
    "owner2": "",
    "current_taxes": 15762.43,
    "new_taxes_no_override": 16443.37,
    "override_total_1": 16909.93,
    "override_increase_1": 466.57
  },
  {
    "#": "238 Cypress St (306-04-00)",
    "$": 1311800,
    "address": "238 Cypress St",
    "parcel_id": "306-04-00",
    "owner1": "CHAO, PO Y & JOSEPHINE C S H",
    "owner2": "",
    "current_taxes": 9797.9,
    "new_taxes_no_override": 10221.17,
    "override_total_1": 10511.19,
    "override_increase_1": 290.02
  },
  {
    "#": "240 Cypress St (306-03-00)",
    "$": 1375300,
    "address": "240 Cypress St",
    "parcel_id": "306-03-00",
    "owner1": "YUEN, WENDY & RICKY S & SAI W",
    "owner2": "",
    "current_taxes": 10448.14,
    "new_taxes_no_override": 10899.5,
    "override_total_1": 11208.76,
    "override_increase_1": 309.26
  },
  {
    "#": "241 Cypress St, Unit 241 P81-93 (316-24-01)",
    "$": 1290600,
    "address": "241 Cypress St, Unit 241 P81-93",
    "parcel_id": "316-24-01",
    "owner1": "PERRY, MANUEL J",
    "owner2": "FINE, MADELINE C",
    "current_taxes": 9580.81,
    "new_taxes_no_override": 9994.7,
    "override_total_1": 10278.29,
    "override_increase_1": 283.59
  },
  {
    "#": "243 Cypress St, Unit 243 & P80 (316-24-02)",
    "$": 227600,
    "address": "243 Cypress St, Unit 243 & P80",
    "parcel_id": "316-24-02",
    "owner1": "KLAYMAN, FAYE JUDITH",
    "owner2": "",
    "current_taxes": 233.06,
    "new_taxes_no_override": 243.13,
    "override_total_1": 250.03,
    "override_increase_1": 6.9
  },
  {
    "#": "244 Cypress St, Unit 2 (306-02-04)",
    "$": 482200,
    "address": "244 Cypress St, Unit 2",
    "parcel_id": "306-02-04",
    "owner1": "STURDEVANT, ZACH & CARA",
    "owner2": "",
    "current_taxes": 1302.79,
    "new_taxes_no_override": 1359.07,
    "override_total_1": 1397.63,
    "override_increase_1": 38.56
  },
  {
    "#": "244 Cypress St, Unit 3 (306-02-02)",
    "$": 784100,
    "address": "244 Cypress St, Unit 3",
    "parcel_id": "306-02-02",
    "owner1": "MITCHELL, AMIR & LIAT",
    "owner2": "",
    "current_taxes": 4394.25,
    "new_taxes_no_override": 4584.08,
    "override_total_1": 4714.15,
    "override_increase_1": 130.07
  },
  {
    "#": "245 Cypress St, Unit 245 & P61 (316-24-03)",
    "$": 267800,
    "address": "245 Cypress St, Unit 245 & P61",
    "parcel_id": "316-24-03",
    "owner1": "BRASIL, EMILIA C",
    "owner2": "",
    "current_taxes": 274.23,
    "new_taxes_no_override": 286.08,
    "override_total_1": 294.19,
    "override_increase_1": 8.12
  },
  {
    "#": "246 Cypress St, Unit 1 (306-02-01)",
    "$": 470000,
    "address": "246 Cypress St, Unit 1",
    "parcel_id": "306-02-01",
    "owner1": "DINARDI, CHRISTINA",
    "owner2": "WOO, KEVIN",
    "current_taxes": 4812.8,
    "new_taxes_no_override": 5020.71,
    "override_total_1": 5163.17,
    "override_increase_1": 142.46
  },
  {
    "#": "246 Cypress St, Unit 4 (306-02-03)",
    "$": 794600,
    "address": "246 Cypress St, Unit 4",
    "parcel_id": "306-02-03",
    "owner1": "ZHANG, BONING",
    "owner2": "LIU, XIN",
    "current_taxes": 4501.77,
    "new_taxes_no_override": 4696.25,
    "override_total_1": 4829.5,
    "override_increase_1": 133.25
  },
  {
    "#": "247 Cypress St, Unit 247 79&G92 (316-24-04)",
    "$": 1290600,
    "address": "247 Cypress St, Unit 247 79&G92",
    "parcel_id": "316-24-04",
    "owner1": "OUCHI, KEI & TOMOKO",
    "owner2": "",
    "current_taxes": 9580.81,
    "new_taxes_no_override": 9994.7,
    "override_total_1": 10278.29,
    "override_increase_1": 283.59
  },
  {
    "#": "248 Cypress St (306-01-00)",
    "$": 1065800,
    "address": "248 Cypress St",
    "parcel_id": "306-01-00",
    "owner1": "CYPRESS STREET 248 LLC",
    "owner2": "",
    "current_taxes": 18289.13,
    "new_taxes_no_override": 19079.22,
    "override_total_1": 19620.58,
    "override_increase_1": 541.36
  },
  {
    "#": "249 Cypress St, Unit 249 P78-90 (316-24-05)",
    "$": 1361800,
    "address": "249 Cypress St, Unit 249 P78-90",
    "parcel_id": "316-24-05",
    "owner1": "MEHRA, POOJA",
    "owner2": "KHETARPAL, SUMEET ANAND",
    "current_taxes": 10309.9,
    "new_taxes_no_override": 10755.29,
    "override_total_1": 11060.46,
    "override_increase_1": 305.17
  },
  {
    "#": "251 Cypress St, Unit 251 P77-89 (316-24-06)",
    "$": 1535100,
    "address": "251 Cypress St, Unit 251 P77-89",
    "parcel_id": "316-24-06",
    "owner1": "HUANG, RAYMOND & HSIN FANG",
    "owner2": "",
    "current_taxes": 12084.49,
    "new_taxes_no_override": 12606.54,
    "override_total_1": 12964.24,
    "override_increase_1": 357.7
  },
  {
    "#": "252 Cypress St (305-04-00)",
    "$": 1394500,
    "address": "252 Cypress St",
    "parcel_id": "305-04-00",
    "owner1": "SCHER, VITALIJ & ASYA",
    "owner2": "",
    "current_taxes": 14279.68,
    "new_taxes_no_override": 14896.56,
    "override_total_1": 15319.24,
    "override_increase_1": 422.68
  },
  {
    "#": "253 Cypress St, Unit 253 P76-88 (316-24-07)",
    "$": 1341600,
    "address": "253 Cypress St, Unit 253 P76-88",
    "parcel_id": "316-24-07",
    "owner1": "BRINK TRS, ELISABETH P & ROBERT J",
    "owner2": "",
    "current_taxes": 10103.05,
    "new_taxes_no_override": 10539.5,
    "override_total_1": 10838.55,
    "override_increase_1": 299.05
  },
  {
    "#": "254 Cypress St (305-03-00)",
    "$": 1006800,
    "address": "254 Cypress St",
    "parcel_id": "305-03-00",
    "owner1": "DUGGAN, ROBERT FRANCIS JR & KEVIN MICHAEL",
    "owner2": "",
    "current_taxes": 6674.7,
    "new_taxes_no_override": 6963.05,
    "override_total_1": 7160.62,
    "override_increase_1": 197.57
  },
  {
    "#": "255 Cypress St, Unit 255 P75-87 (316-24-08)",
    "$": 1400100,
    "address": "255 Cypress St, Unit 255 P75-87",
    "parcel_id": "316-24-08",
    "owner1": "GADJEVA, MIHELA",
    "owner2": "MIRCHEV, ROSSEN",
    "current_taxes": 14337.02,
    "new_taxes_no_override": 14956.38,
    "override_total_1": 15380.76,
    "override_increase_1": 424.38
  },
  {
    "#": "257 Cypress St, Unit 257 P74-86 (316-24-09)",
    "$": 1341600,
    "address": "257 Cypress St, Unit 257 P74-86",
    "parcel_id": "316-24-09",
    "owner1": "LEE, BERNARD & BRITT",
    "owner2": "",
    "current_taxes": 13737.98,
    "new_taxes_no_override": 14331.46,
    "override_total_1": 14738.1,
    "override_increase_1": 406.64
  },
  {
    "#": "258 Cypress St (305-02-00)",
    "$": 1360800,
    "address": "258 Cypress St",
    "parcel_id": "305-02-00",
    "owner1": "MZ PROPERTY LAND TRUST  LLC",
    "owner2": "",
    "current_taxes": 13934.59,
    "new_taxes_no_override": 14536.56,
    "override_total_1": 14949.03,
    "override_increase_1": 412.46
  },
  {
    "#": "259 Cypress St, Unit 259 P73-91 (316-24-10)",
    "$": 1341600,
    "address": "259 Cypress St, Unit 259 P73-91",
    "parcel_id": "316-24-10",
    "owner1": "BENSONOFF, MARK & MILA",
    "owner2": "",
    "current_taxes": 10103.05,
    "new_taxes_no_override": 10539.5,
    "override_total_1": 10838.55,
    "override_increase_1": 299.05
  },
  {
    "#": "261 Cypress St, Unit 261 P72-85 (316-24-11)",
    "$": 1320800,
    "address": "261 Cypress St, Unit 261 P72-85",
    "parcel_id": "316-24-11",
    "owner1": "CODY, ANNE E",
    "owner2": "FORMAN, BENJAMIN K",
    "current_taxes": 9890.06,
    "new_taxes_no_override": 10317.31,
    "override_total_1": 10610.06,
    "override_increase_1": 292.75
  },
  {
    "#": "263 Cypress St, Unit 263 P71-84 (316-24-12)",
    "$": 1341600,
    "address": "263 Cypress St, Unit 263 P71-84",
    "parcel_id": "316-24-12",
    "owner1": "YANG, ZENAN",
    "owner2": "",
    "current_taxes": 10103.05,
    "new_taxes_no_override": 10539.5,
    "override_total_1": 10838.55,
    "override_increase_1": 299.05
  },
  {
    "#": "264 Cypress St (305-01-00)",
    "$": 1327800,
    "address": "264 Cypress St",
    "parcel_id": "305-01-00",
    "owner1": "HANSEL, DAVID & MELINDA",
    "owner2": "",
    "current_taxes": 9961.74,
    "new_taxes_no_override": 10392.09,
    "override_total_1": 10686.95,
    "override_increase_1": 294.87
  },
  {
    "#": "265 Cypress St, Unit 265 P70-83 (316-24-13)",
    "$": 1290600,
    "address": "265 Cypress St, Unit 265 P70-83",
    "parcel_id": "316-24-13",
    "owner1": "LEVINE TRS, HERBERT",
    "owner2": "MILLER, LOUISE INA",
    "current_taxes": 9580.81,
    "new_taxes_no_override": 9994.7,
    "override_total_1": 10278.29,
    "override_increase_1": 283.59
  },
  {
    "#": "267 Cypress St, Unit 267 P69-82 (316-24-14)",
    "$": 1290600,
    "address": "267 Cypress St, Unit 267 P69-82",
    "parcel_id": "316-24-14",
    "owner1": "BYRNE, SARAH",
    "owner2": "",
    "current_taxes": 9580.81,
    "new_taxes_no_override": 9994.7,
    "override_total_1": 10278.29,
    "override_increase_1": 283.59
  },
  {
    "#": "268 Cypress St (304-06-00)",
    "$": 1468600,
    "address": "268 Cypress St",
    "parcel_id": "304-06-00",
    "owner1": "JOHNSON, DONALD & LISA M HOULIHAN",
    "owner2": "C/O CALBOSTON DEVELOPMENT LLC",
    "current_taxes": 15038.46,
    "new_taxes_no_override": 15688.12,
    "override_total_1": 16133.26,
    "override_increase_1": 445.14
  },
  {
    "#": "275 Cypress St, Unit 101 & P18 (316-25-01)",
    "$": 609100,
    "address": "275 Cypress St, Unit 101 & P18",
    "parcel_id": "316-25-01",
    "owner1": "CUMMINGS, JENNIFER  H",
    "owner2": "",
    "current_taxes": 6237.18,
    "new_taxes_no_override": 6506.63,
    "override_total_1": 6691.25,
    "override_increase_1": 184.62
  },
  {
    "#": "275 Cypress St, Unit 103 & P19 (316-25-02)",
    "$": 524800,
    "address": "275 Cypress St, Unit 103 & P19",
    "parcel_id": "316-25-02",
    "owner1": "COHEN TRS, STEWART I & CLAUDINE S",
    "owner2": "",
    "current_taxes": 5373.95,
    "new_taxes_no_override": 5606.1,
    "override_total_1": 5765.17,
    "override_increase_1": 159.07
  },
  {
    "#": "275 Cypress St, Unit 105 & P20 (316-25-03)",
    "$": 594900,
    "address": "275 Cypress St, Unit 105 & P20",
    "parcel_id": "316-25-03",
    "owner1": "LEISTER ET AL, EMILY MARIA",
    "owner2": "LAPRADE, NATHAN MARK",
    "current_taxes": 6091.78,
    "new_taxes_no_override": 6354.94,
    "override_total_1": 6535.26,
    "override_increase_1": 180.32
  },
  {
    "#": "275 Cypress St, Unit 201 & P21 (316-25-04)",
    "$": 233300,
    "address": "275 Cypress St, Unit 201 & P21",
    "parcel_id": "316-25-04",
    "owner1": "SHIRK, ABBIGAIL W",
    "owner2": "",
    "current_taxes": 238.9,
    "new_taxes_no_override": 249.22,
    "override_total_1": 256.29,
    "override_increase_1": 7.07
  },
  {
    "#": "275 Cypress St, Unit 202 & P22 (316-25-05)",
    "$": 968100,
    "address": "275 Cypress St, Unit 202 & P22",
    "parcel_id": "316-25-05",
    "owner1": "WABER TR, DEBORAH P",
    "owner2": "",
    "current_taxes": 6278.41,
    "new_taxes_no_override": 6549.64,
    "override_total_1": 6735.48,
    "override_increase_1": 185.84
  },
  {
    "#": "275 Cypress St, Unit 203 & P23 (316-25-06)",
    "$": 577600,
    "address": "275 Cypress St, Unit 203 & P23",
    "parcel_id": "316-25-06",
    "owner1": "PRUSS TR, ROBIN ANN",
    "owner2": "",
    "current_taxes": 2279.69,
    "new_taxes_no_override": 2378.17,
    "override_total_1": 2445.65,
    "override_increase_1": 67.48
  },
  {
    "#": "275 Cypress St, Unit 204 & P24 (316-25-07)",
    "$": 752600,
    "address": "275 Cypress St, Unit 204 & P24",
    "parcel_id": "316-25-07",
    "owner1": "BLOOM TR, DEBORAH F",
    "owner2": "",
    "current_taxes": 7706.62,
    "new_taxes_no_override": 8039.55,
    "override_total_1": 8267.66,
    "override_increase_1": 228.12
  },
  {
    "#": "275 Cypress St, Unit 205 & P25 (316-25-08)",
    "$": 621600,
    "address": "275 Cypress St, Unit 205 & P25",
    "parcel_id": "316-25-08",
    "owner1": "RANDALL, EDIN T",
    "owner2": "",
    "current_taxes": 2730.25,
    "new_taxes_no_override": 2848.2,
    "override_total_1": 2929.01,
    "override_increase_1": 80.82
  },
  {
    "#": "275 Cypress St, Unit 301 & P26 (316-25-09)",
    "$": 622300,
    "address": "275 Cypress St, Unit 301 & P26",
    "parcel_id": "316-25-09",
    "owner1": "CAI, ZHENG",
    "owner2": "",
    "current_taxes": 6372.35,
    "new_taxes_no_override": 6647.64,
    "override_total_1": 6836.26,
    "override_increase_1": 188.62
  },
  {
    "#": "275 Cypress St, Unit 302 & P30 (316-25-10)",
    "$": 874900,
    "address": "275 Cypress St, Unit 302 & P30",
    "parcel_id": "316-25-10",
    "owner1": "SADREYEV, RUSLAN",
    "owner2": "",
    "current_taxes": 5324.04,
    "new_taxes_no_override": 5554.04,
    "override_total_1": 5711.63,
    "override_increase_1": 157.59
  },
  {
    "#": "275 Cypress St, Unit 303 & P31 (316-25-11)",
    "$": 562100,
    "address": "275 Cypress St, Unit 303 & P31",
    "parcel_id": "316-25-11",
    "owner1": "PENG, CHENGUANG",
    "owner2": "",
    "current_taxes": 5755.9,
    "new_taxes_no_override": 6004.55,
    "override_total_1": 6174.93,
    "override_increase_1": 170.37
  },
  {
    "#": "275 Cypress St, Unit 304 & P32 (316-25-12)",
    "$": 763200,
    "address": "275 Cypress St, Unit 304 & P32",
    "parcel_id": "316-25-12",
    "owner1": "DEBENEDICTIS, ANNAMARIA",
    "owner2": "",
    "current_taxes": 4180.23,
    "new_taxes_no_override": 4360.82,
    "override_total_1": 4484.55,
    "override_increase_1": 123.73
  },
  {
    "#": "275 Cypress St, Unit 305 & P33 (316-25-13)",
    "$": 619000,
    "address": "275 Cypress St, Unit 305 & P33",
    "parcel_id": "316-25-13",
    "owner1": "XIE, HAIYI",
    "owner2": "LI, FANG",
    "current_taxes": 6338.56,
    "new_taxes_no_override": 6612.39,
    "override_total_1": 6800.01,
    "override_increase_1": 187.62
  },
  {
    "#": "275 Cypress St, Unit 401 & P34 (316-25-14)",
    "$": 274100,
    "address": "275 Cypress St, Unit 401 & P34",
    "parcel_id": "316-25-14",
    "owner1": "KOWALSKI, JANUSZ & MIROSLAWA",
    "owner2": "",
    "current_taxes": 280.68,
    "new_taxes_no_override": 292.81,
    "override_total_1": 301.11,
    "override_increase_1": 8.31
  },
  {
    "#": "275 Cypress St, Unit 402 & P35 (316-25-15)",
    "$": 757200,
    "address": "275 Cypress St, Unit 402 & P35",
    "parcel_id": "316-25-15",
    "owner1": "GALPER, TATIANA BONSOVNA",
    "owner2": "KANEVSKY, GREGORY E",
    "current_taxes": 7753.73,
    "new_taxes_no_override": 8088.69,
    "override_total_1": 8318.2,
    "override_increase_1": 229.51
  },
  {
    "#": "275 Cypress St, Unit 403 & P36 (316-25-16)",
    "$": 846300,
    "address": "275 Cypress St, Unit 403 & P36",
    "parcel_id": "316-25-16",
    "owner1": "KRIENSKY TR, SANDRA G",
    "owner2": "",
    "current_taxes": 5031.18,
    "new_taxes_no_override": 5248.53,
    "override_total_1": 5397.45,
    "override_increase_1": 148.92
  },
  {
    "#": "275 Cypress St, Unit 404 & P37 (316-25-17)",
    "$": 754400,
    "address": "275 Cypress St, Unit 404 & P37",
    "parcel_id": "316-25-17",
    "owner1": "DINERMAN, RUTH E",
    "owner2": "",
    "current_taxes": 4090.12,
    "new_taxes_no_override": 4266.81,
    "override_total_1": 4387.88,
    "override_increase_1": 121.07
  },
  {
    "#": "276 Cypress St, Unit 101 & P1 (304-05-01)",
    "$": 622200,
    "address": "276 Cypress St, Unit 101 & P1",
    "parcel_id": "304-05-01",
    "owner1": "LI, YONGLIN",
    "owner2": "ZHENG, HANQIAO",
    "current_taxes": 2736.39,
    "new_taxes_no_override": 2854.6,
    "override_total_1": 2935.6,
    "override_increase_1": 81.0
  },
  {
    "#": "276 Cypress St, Unit 201 & P2 (304-05-02)",
    "$": 617400,
    "address": "276 Cypress St, Unit 201 & P2",
    "parcel_id": "304-05-02",
    "owner1": "276 CYPRESS STREET #201 LLC",
    "owner2": "",
    "current_taxes": 6322.18,
    "new_taxes_no_override": 6595.3,
    "override_total_1": 6782.43,
    "override_increase_1": 187.14
  },
  {
    "#": "276 Cypress St, Unit 301 & P3 (304-05-03)",
    "$": 649300,
    "address": "276 Cypress St, Unit 301 & P3",
    "parcel_id": "304-05-03",
    "owner1": "MERRELL, THOMAS & JUSTIN R",
    "owner2": "",
    "current_taxes": 3013.9,
    "new_taxes_no_override": 3144.1,
    "override_total_1": 3233.31,
    "override_increase_1": 89.21
  },
  {
    "#": "278 Cypress St (304-04-00)",
    "$": 1261300,
    "address": "278 Cypress St",
    "parcel_id": "304-04-00",
    "owner1": "JOSHI TR, SHUBH R",
    "owner2": "C/O BAIJ JOSHI",
    "current_taxes": 12915.71,
    "new_taxes_no_override": 13473.67,
    "override_total_1": 13855.97,
    "override_increase_1": 382.31
  },
  {
    "#": "280 Cypress St (304-03-00)",
    "$": 1108600,
    "address": "280 Cypress St",
    "parcel_id": "304-03-00",
    "owner1": "CHANG, WEI LIN & AILSA C H",
    "owner2": "",
    "current_taxes": 11352.06,
    "new_taxes_no_override": 11842.47,
    "override_total_1": 12178.49,
    "override_increase_1": 336.02
  },
  {
    "#": "282 Cypress St (304-01-02)",
    "$": 1901400,
    "address": "282 Cypress St",
    "parcel_id": "304-01-02",
    "owner1": "DEWING, STAINER K",
    "owner2": "",
    "current_taxes": 19470.34,
    "new_taxes_no_override": 20311.46,
    "override_total_1": 20887.78,
    "override_increase_1": 576.32
  },
  {
    "#": "293 Cypress St (303-11-00)",
    "$": 1971200,
    "address": "293 Cypress St",
    "parcel_id": "303-11-00",
    "owner1": "STAMERIS TRS, MICHAEL A & JOHN N",
    "owner2": "CONSTANTINE, ANDREA E",
    "current_taxes": 25198.81,
    "new_taxes_no_override": 26287.4,
    "override_total_1": 27033.28,
    "override_increase_1": 745.88
  },
  {
    "#": "296 Cypress St (308-82-83)",
    "$": 15184100,
    "address": "296 Cypress St",
    "parcel_id": "308-82-83",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O MARGARET E ROBINSON PLAYGROUND",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "299 Cypress St, Unit 299 (303-13-13)",
    "$": 1533800,
    "address": "299 Cypress St, Unit 299",
    "parcel_id": "303-13-13",
    "owner1": "MABON TR, CAROLINE C",
    "owner2": "",
    "current_taxes": 12071.18,
    "new_taxes_no_override": 12592.65,
    "override_total_1": 12949.96,
    "override_increase_1": 357.31
  },
  {
    "#": "299 Cypress St, Unit 301 (303-13-14)",
    "$": 1524000,
    "address": "299 Cypress St, Unit 301",
    "parcel_id": "303-13-14",
    "owner1": "MATIAS, ALBERTO RUZO",
    "owner2": "CANTERO, JUDITH AGUDO",
    "current_taxes": 15605.76,
    "new_taxes_no_override": 16279.93,
    "override_total_1": 16741.86,
    "override_increase_1": 461.93
  },
  {
    "#": "299 Cypress St, Unit 303 (303-13-15)",
    "$": 1324400,
    "address": "299 Cypress St, Unit 303",
    "parcel_id": "303-13-15",
    "owner1": "ABRAMSON, MAYA",
    "owner2": "",
    "current_taxes": 9926.92,
    "new_taxes_no_override": 10355.76,
    "override_total_1": 10649.6,
    "override_increase_1": 293.84
  },
  {
    "#": "317 Cypress St (302-11-00)",
    "$": 1269900,
    "address": "317 Cypress St",
    "parcel_id": "302-11-00",
    "owner1": "AUDEH, MARK",
    "owner2": "",
    "current_taxes": 9368.84,
    "new_taxes_no_override": 9773.57,
    "override_total_1": 10050.89,
    "override_increase_1": 277.32
  },
  {
    "#": "321 Cypress St (302-12-00)",
    "$": 1050500,
    "address": "321 Cypress St",
    "parcel_id": "302-12-00",
    "owner1": "STEVENS, TRS, PHILIP ERNEST",
    "owner2": "C/O ONE STOP MARKET",
    "current_taxes": 18026.58,
    "new_taxes_no_override": 18805.33,
    "override_total_1": 19338.92,
    "override_increase_1": 533.59
  },
  {
    "#": "327 Cypress St (302-13-00)",
    "$": 1490500,
    "address": "327 Cypress St",
    "parcel_id": "302-13-00",
    "owner1": "SCOCCIA, SAUDRO & AURENITA P",
    "owner2": "",
    "current_taxes": 11627.79,
    "new_taxes_no_override": 12130.11,
    "override_total_1": 12474.29,
    "override_increase_1": 344.18
  },
  {
    "#": "329 Cypress St (302-14-01)",
    "$": 88000,
    "address": "329 Cypress St",
    "parcel_id": "302-14-01",
    "owner1": "SCHWARTZ, JOAN",
    "owner2": "",
    "current_taxes": 901.12,
    "new_taxes_no_override": 940.05,
    "override_total_1": 966.72,
    "override_increase_1": 26.67
  },
  {
    "#": "331 Cypress St (302-14-00)",
    "$": 1398000,
    "address": "331 Cypress St",
    "parcel_id": "302-14-00",
    "owner1": "NAPOE, GNANKANG SARAH",
    "owner2": "RUITLEDGE, LEE JAMES",
    "current_taxes": 14315.52,
    "new_taxes_no_override": 14933.95,
    "override_total_1": 15357.69,
    "override_increase_1": 423.74
  },
  {
    "#": " Cypress St (200-16-03)",
    "$": 166400,
    "address": " Cypress St",
    "parcel_id": "200-16-03",
    "owner1": "21 CYPRESS STREET LLC",
    "owner2": "",
    "current_taxes": 1703.94,
    "new_taxes_no_override": 1777.55,
    "override_total_1": 1827.99,
    "override_increase_1": 50.44
  },
  {
    "#": " Cypress St (200-16-04)",
    "$": 168400,
    "address": " Cypress St",
    "parcel_id": "200-16-04",
    "owner1": "FEINGOLD, TR, DAVID S",
    "owner2": "",
    "current_taxes": 1724.42,
    "new_taxes_no_override": 1798.91,
    "override_total_1": 1849.96,
    "override_increase_1": 51.04
  },
  {
    "#": " Cypress St (200-16-05)",
    "$": 129100,
    "address": " Cypress St",
    "parcel_id": "200-16-05",
    "owner1": "PARKER, C STEPHEN JR& KATHLEEN KING & JOSHUA STEPHEN & RACHEL WARNER",
    "owner2": "",
    "current_taxes": 1321.98,
    "new_taxes_no_override": 1379.09,
    "override_total_1": 1418.22,
    "override_increase_1": 39.13
  },
  {
    "#": "15 Dale St (341-14-00)",
    "$": 1032700,
    "address": "15 Dale St",
    "parcel_id": "341-14-00",
    "owner1": "SULLIVAN, KEVIN & LAURIANNE",
    "owner2": "",
    "current_taxes": 6939.91,
    "new_taxes_no_override": 7239.71,
    "override_total_1": 7445.14,
    "override_increase_1": 205.42
  },
  {
    "#": "23 Dale St (341-15-00)",
    "$": 1004300,
    "address": "23 Dale St",
    "parcel_id": "341-15-00",
    "owner1": "LI, CONG",
    "owner2": "ZHAO, JINGYI",
    "current_taxes": 6649.1,
    "new_taxes_no_override": 6936.34,
    "override_total_1": 7133.15,
    "override_increase_1": 196.81
  },
  {
    "#": "25 Dale St (341-15-01)",
    "$": 990100,
    "address": "25 Dale St",
    "parcel_id": "341-15-01",
    "owner1": "LEE, JEONG II & HYEON IM",
    "owner2": "",
    "current_taxes": 6503.69,
    "new_taxes_no_override": 6784.65,
    "override_total_1": 6977.16,
    "override_increase_1": 192.51
  },
  {
    "#": "27 Dale St (341-16-00)",
    "$": 1026000,
    "address": "27 Dale St",
    "parcel_id": "341-16-00",
    "owner1": "OSTROVSKY, ALEXANDER & IRINA",
    "owner2": "",
    "current_taxes": 6871.31,
    "new_taxes_no_override": 7168.15,
    "override_total_1": 7371.54,
    "override_increase_1": 203.39
  },
  {
    "#": "31 Dale St (341-17-00)",
    "$": 957700,
    "address": "31 Dale St",
    "parcel_id": "341-17-00",
    "owner1": "SOBEL TR, SARAH BETH",
    "owner2": "",
    "current_taxes": 9806.85,
    "new_taxes_no_override": 10230.51,
    "override_total_1": 10520.79,
    "override_increase_1": 290.28
  },
  {
    "#": "32 Dale St (340-08-00)",
    "$": 1718900,
    "address": "32 Dale St",
    "parcel_id": "340-08-00",
    "owner1": "JAMES, KEVIN & SHARON & DONALD",
    "owner2": "",
    "current_taxes": 13966.6,
    "new_taxes_no_override": 14569.96,
    "override_total_1": 14983.37,
    "override_increase_1": 413.41
  },
  {
    "#": "35 Dale St (341-18-00)",
    "$": 1444600,
    "address": "35 Dale St",
    "parcel_id": "341-18-00",
    "owner1": "BELL TRS, PAUL N & ELLEN S",
    "owner2": "",
    "current_taxes": 11157.77,
    "new_taxes_no_override": 11639.79,
    "override_total_1": 11970.06,
    "override_increase_1": 330.27
  },
  {
    "#": "38 Dale St (340-06-07)",
    "$": 1028300,
    "address": "38 Dale St",
    "parcel_id": "340-06-07",
    "owner1": "KALAANY, NADA Y",
    "owner2": "",
    "current_taxes": 6894.86,
    "new_taxes_no_override": 7192.72,
    "override_total_1": 7396.81,
    "override_increase_1": 204.09
  },
  {
    "#": "39 Dale St (341-19-00)",
    "$": 1176400,
    "address": "39 Dale St",
    "parcel_id": "341-19-00",
    "owner1": "LITTLETON TR, JAMES R",
    "owner2": "",
    "current_taxes": 8411.4,
    "new_taxes_no_override": 8774.77,
    "override_total_1": 9023.75,
    "override_increase_1": 248.98
  },
  {
    "#": "43 Dale St (341-20-00)",
    "$": 1049200,
    "address": "43 Dale St",
    "parcel_id": "341-20-00",
    "owner1": "YEE TRS, JANET",
    "owner2": "",
    "current_taxes": 10743.81,
    "new_taxes_no_override": 11207.94,
    "override_total_1": 11525.96,
    "override_increase_1": 318.02
  },
  {
    "#": "44 Dale St (340-05-00)",
    "$": 1067700,
    "address": "44 Dale St",
    "parcel_id": "340-05-00",
    "owner1": "LI, ZHE & RONG",
    "owner2": "",
    "current_taxes": 7298.31,
    "new_taxes_no_override": 7613.6,
    "override_total_1": 7829.63,
    "override_increase_1": 216.03
  },
  {
    "#": "48 Dale St (340-04-00)",
    "$": 1096600,
    "address": "48 Dale St",
    "parcel_id": "340-04-00",
    "owner1": "LOUIE TR, PEGGIE SIU HING",
    "owner2": "",
    "current_taxes": 7594.25,
    "new_taxes_no_override": 7922.32,
    "override_total_1": 8147.11,
    "override_increase_1": 224.79
  },
  {
    "#": "49 Dale St (341-01-02)",
    "$": 974100,
    "address": "49 Dale St",
    "parcel_id": "341-01-02",
    "owner1": "LUBETZKY, ITAMAR",
    "owner2": "",
    "current_taxes": 6339.85,
    "new_taxes_no_override": 6613.73,
    "override_total_1": 6801.39,
    "override_increase_1": 187.66
  },
  {
    "#": "59 Dale St (346-10-00)",
    "$": 1081400,
    "address": "59 Dale St",
    "parcel_id": "346-10-00",
    "owner1": "GAVALE, UDREKH",
    "owner2": "MAYEKAR, APURVA",
    "current_taxes": 7438.6,
    "new_taxes_no_override": 7759.95,
    "override_total_1": 7980.13,
    "override_increase_1": 220.18
  },
  {
    "#": "65 Dale St (346-11-00)",
    "$": 950300,
    "address": "65 Dale St",
    "parcel_id": "346-11-00",
    "owner1": "YAU TRS, WING GEE  & FLORENCE",
    "owner2": "",
    "current_taxes": 6096.14,
    "new_taxes_no_override": 6359.49,
    "override_total_1": 6539.94,
    "override_increase_1": 180.45
  },
  {
    "#": "66 Dale St (347-01-04)",
    "$": 1316400,
    "address": "66 Dale St",
    "parcel_id": "347-01-04",
    "owner1": "SCHWARTZ, DAVID & DEBRA DIAMOND",
    "owner2": "",
    "current_taxes": 13479.94,
    "new_taxes_no_override": 14062.27,
    "override_total_1": 14461.28,
    "override_increase_1": 399.01
  },
  {
    "#": "69 Dale St (346-12-00)",
    "$": 1154800,
    "address": "69 Dale St",
    "parcel_id": "346-12-00",
    "owner1": "ABAMELIK, BRIAN & BIANNA",
    "owner2": "",
    "current_taxes": 8190.22,
    "new_taxes_no_override": 8544.04,
    "override_total_1": 8786.47,
    "override_increase_1": 242.43
  },
  {
    "#": "72 Dale St (347-01-03)",
    "$": 1081400,
    "address": "72 Dale St",
    "parcel_id": "347-01-03",
    "owner1": "VYADRO TRS, OLEG & INNA",
    "owner2": "",
    "current_taxes": 11073.54,
    "new_taxes_no_override": 11551.92,
    "override_total_1": 11879.69,
    "override_increase_1": 327.78
  },
  {
    "#": "73 Dale St (346-13-00)",
    "$": 1054800,
    "address": "73 Dale St",
    "parcel_id": "346-13-00",
    "owner1": "MISCI, STANISLAVA K",
    "owner2": "",
    "current_taxes": 7166.22,
    "new_taxes_no_override": 7475.8,
    "override_total_1": 7687.92,
    "override_increase_1": 212.12
  },
  {
    "#": "77 Dale St (346-14-00)",
    "$": 1115400,
    "address": "77 Dale St",
    "parcel_id": "346-14-00",
    "owner1": "EISENBERG TRS, NAVA",
    "owner2": "ROBINSON, DAVID N",
    "current_taxes": 7786.76,
    "new_taxes_no_override": 8123.15,
    "override_total_1": 8353.64,
    "override_increase_1": 230.49
  },
  {
    "#": "78 Dale St (347-01-02)",
    "$": 2118900,
    "address": "78 Dale St",
    "parcel_id": "347-01-02",
    "owner1": "ZHA, CHARLES H",
    "owner2": "HUANG, QING",
    "current_taxes": 18062.6,
    "new_taxes_no_override": 18842.9,
    "override_total_1": 19377.56,
    "override_increase_1": 534.65
  },
  {
    "#": "79 Dale St (346-15-00)",
    "$": 935100,
    "address": "79 Dale St",
    "parcel_id": "346-15-00",
    "owner1": "MORALES, EDITH M & OSCAR",
    "owner2": "",
    "current_taxes": 9575.42,
    "new_taxes_no_override": 9989.08,
    "override_total_1": 10272.51,
    "override_increase_1": 283.43
  },
  {
    "#": "85 Dale St (346-16-00)",
    "$": 1332200,
    "address": "85 Dale St",
    "parcel_id": "346-16-00",
    "owner1": "BANKS TRS, ESTELLE H & JOSEPH I",
    "owner2": "C/O EVAN BANKS",
    "current_taxes": 13641.73,
    "new_taxes_no_override": 14231.05,
    "override_total_1": 14634.85,
    "override_increase_1": 403.8
  },
  {
    "#": "86 Dale St (347-01-01)",
    "$": 2299800,
    "address": "86 Dale St",
    "parcel_id": "347-01-01",
    "owner1": "ROSEN, YIGAL & SOPHIA",
    "owner2": "",
    "current_taxes": 19915.02,
    "new_taxes_no_override": 20775.35,
    "override_total_1": 21364.83,
    "override_increase_1": 589.48
  },
  {
    "#": "91 Dale St (346-17-00)",
    "$": 1553300,
    "address": "91 Dale St",
    "parcel_id": "346-17-00",
    "owner1": "ROSS, MD, JOHN J",
    "owner2": "SANDEL, MD, MEGAN T",
    "current_taxes": 12270.86,
    "new_taxes_no_override": 12800.96,
    "override_total_1": 13164.18,
    "override_increase_1": 363.22
  },
  {
    "#": "92 Dale St (347-18-00)",
    "$": 1413500,
    "address": "92 Dale St",
    "parcel_id": "347-18-00",
    "owner1": "CHANG, ANDY E & LANYIN",
    "owner2": "",
    "current_taxes": 10839.31,
    "new_taxes_no_override": 11307.57,
    "override_total_1": 11628.41,
    "override_increase_1": 320.84
  },
  {
    "#": "95 Dale St (346-18-00)",
    "$": 1898400,
    "address": "95 Dale St",
    "parcel_id": "346-18-00",
    "owner1": "WOLFF, JONATHAN & SARA",
    "owner2": "",
    "current_taxes": 15804.68,
    "new_taxes_no_override": 16487.44,
    "override_total_1": 16955.26,
    "override_increase_1": 467.82
  },
  {
    "#": "99 Dale St (346-19-00)",
    "$": 1838800,
    "address": "99 Dale St",
    "parcel_id": "346-19-00",
    "owner1": "JOHNSON, GLENN M & LISA ANN RUBIN",
    "owner2": "",
    "current_taxes": 15194.38,
    "new_taxes_no_override": 15850.78,
    "override_total_1": 16300.53,
    "override_increase_1": 449.75
  },
  {
    "#": "100 Dale St (347-19-00)",
    "$": 1448900,
    "address": "100 Dale St",
    "parcel_id": "347-19-00",
    "owner1": "NOY TRS, ELAN & RINAT",
    "owner2": "",
    "current_taxes": 11201.8,
    "new_taxes_no_override": 11685.72,
    "override_total_1": 12017.29,
    "override_increase_1": 331.57
  },
  {
    "#": "101 Dale St (346-20-00)",
    "$": 100,
    "address": "101 Dale St",
    "parcel_id": "346-20-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O VACANT PARCEL/ABUT 99 DALE",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "7 Dana St (197-07-00)",
    "$": 2700100,
    "address": "7 Dana St",
    "parcel_id": "197-07-00",
    "owner1": "GOLDMAN, ANNE L",
    "owner2": "",
    "current_taxes": 27649.02,
    "new_taxes_no_override": 28843.46,
    "override_total_1": 29661.87,
    "override_increase_1": 818.41
  },
  {
    "#": "11 Dana St (197-08-00)",
    "$": 2059700,
    "address": "11 Dana St",
    "parcel_id": "197-08-00",
    "owner1": "DAHLSTEDT, EDWARD",
    "owner2": "CASELLA, KRISTEL",
    "current_taxes": 17456.39,
    "new_taxes_no_override": 18210.51,
    "override_total_1": 18727.22,
    "override_increase_1": 516.71
  },
  {
    "#": "12 Dana St (196-03-00)",
    "$": 2411100,
    "address": "12 Dana St",
    "parcel_id": "196-03-00",
    "owner1": "KINOL, JOHN & ALAINA",
    "owner2": "",
    "current_taxes": 21054.73,
    "new_taxes_no_override": 21964.29,
    "override_total_1": 22587.51,
    "override_increase_1": 623.22
  },
  {
    "#": "14 Dana St (196-02-00)",
    "$": 2368000,
    "address": "14 Dana St",
    "parcel_id": "196-02-00",
    "owner1": "DESAI, NIRAV K & AVANI J",
    "owner2": "",
    "current_taxes": 24248.32,
    "new_taxes_no_override": 25295.85,
    "override_total_1": 26013.6,
    "override_increase_1": 717.75
  },
  {
    "#": "22 Dana St (196-01-03)",
    "$": 2577300,
    "address": "22 Dana St",
    "parcel_id": "196-01-03",
    "owner1": "CAO, JING WEI",
    "owner2": "ZHANG, SU",
    "current_taxes": 22756.62,
    "new_taxes_no_override": 23739.71,
    "override_total_1": 24413.3,
    "override_increase_1": 673.6
  },
  {
    "#": "10 Davis Ave (183-11-00)",
    "$": 5121800,
    "address": "10 Davis Ave",
    "parcel_id": "183-11-00",
    "owner1": "10 DAVIS AVENUE LLC",
    "owner2": "",
    "current_taxes": 52447.23,
    "new_taxes_no_override": 54712.95,
    "override_total_1": 56265.39,
    "override_increase_1": 1552.44
  },
  {
    "#": "14 Davis Ave (183-10-00)",
    "$": 5584400,
    "address": "14 Davis Ave",
    "parcel_id": "183-10-00",
    "owner1": "14-16 DAVIS AVE EXCHANGE LLC",
    "owner2": "",
    "current_taxes": 57184.26,
    "new_taxes_no_override": 59654.62,
    "override_total_1": 61347.27,
    "override_increase_1": 1692.65
  },
  {
    "#": "15 Davis Ave, Unit 1A (176-02-01)",
    "$": 1123900,
    "address": "15 Davis Ave, Unit 1A",
    "parcel_id": "176-02-01",
    "owner1": "ANDERSON, ELIZABETH B",
    "owner2": "",
    "current_taxes": 7873.8,
    "new_taxes_no_override": 8213.95,
    "override_total_1": 8447.01,
    "override_increase_1": 233.06
  },
  {
    "#": "15 Davis Ave, Unit 1B (176-02-04)",
    "$": 1027100,
    "address": "15 Davis Ave, Unit 1B",
    "parcel_id": "176-02-04",
    "owner1": "WIMBERLY, LAURA KEANE & FREDERICK  DAVIS",
    "owner2": "",
    "current_taxes": 6882.57,
    "new_taxes_no_override": 7179.9,
    "override_total_1": 7383.62,
    "override_increase_1": 203.72
  },
  {
    "#": "15 Davis Ave, Unit 1C (176-02-07)",
    "$": 560500,
    "address": "15 Davis Ave, Unit 1C",
    "parcel_id": "176-02-07",
    "owner1": "GAUCH, BRIAN",
    "owner2": "EVALYN, LAWRENCE",
    "current_taxes": 5739.52,
    "new_taxes_no_override": 5987.47,
    "override_total_1": 6157.36,
    "override_increase_1": 169.89
  },
  {
    "#": "15 Davis Ave, Unit 2A (176-02-02)",
    "$": 1216600,
    "address": "15 Davis Ave, Unit 2A",
    "parcel_id": "176-02-02",
    "owner1": "TREDE TR, ANNA KATHARINA",
    "owner2": "",
    "current_taxes": 12457.98,
    "new_taxes_no_override": 12996.16,
    "override_total_1": 13364.92,
    "override_increase_1": 368.76
  },
  {
    "#": "15 Davis Ave, Unit 2B (176-02-05)",
    "$": 778300,
    "address": "15 Davis Ave, Unit 2B",
    "parcel_id": "176-02-05",
    "owner1": "KIRBY, SVETLANA A",
    "owner2": "",
    "current_taxes": 4334.86,
    "new_taxes_no_override": 4522.13,
    "override_total_1": 4650.44,
    "override_increase_1": 128.31
  },
  {
    "#": "15 Davis Ave, Unit 2C (176-02-08)",
    "$": 848100,
    "address": "15 Davis Ave, Unit 2C",
    "parcel_id": "176-02-08",
    "owner1": "ANDUKURI, ADINARAYANA",
    "owner2": "VEMU, ANNAPURNA",
    "current_taxes": 8684.54,
    "new_taxes_no_override": 9059.71,
    "override_total_1": 9316.77,
    "override_increase_1": 257.06
  },
  {
    "#": "15 Davis Ave, Unit 3A (176-02-03)",
    "$": 1101200,
    "address": "15 Davis Ave, Unit 3A",
    "parcel_id": "176-02-03",
    "owner1": "NOTIS, MITCHELL J & AMY G",
    "owner2": "",
    "current_taxes": 7641.35,
    "new_taxes_no_override": 7971.46,
    "override_total_1": 8197.64,
    "override_increase_1": 226.18
  },
  {
    "#": "15 Davis Ave, Unit 3B (176-02-06)",
    "$": 826600,
    "address": "15 Davis Ave, Unit 3B",
    "parcel_id": "176-02-06",
    "owner1": "ZHOU, XIAOQING & XIAOFEI",
    "owner2": "",
    "current_taxes": 4829.45,
    "new_taxes_no_override": 5038.08,
    "override_total_1": 5181.03,
    "override_increase_1": 142.95
  },
  {
    "#": "15 Davis Ave, Unit 3C (176-02-09)",
    "$": 860100,
    "address": "15 Davis Ave, Unit 3C",
    "parcel_id": "176-02-09",
    "owner1": "MORE, CHARLES V",
    "owner2": "SORENSEN, PIA M",
    "current_taxes": 5172.49,
    "new_taxes_no_override": 5395.94,
    "override_total_1": 5549.05,
    "override_increase_1": 153.11
  },
  {
    "#": "17 Davis Ave, Unit 1 (176-03-01)",
    "$": 1897000,
    "address": "17 Davis Ave, Unit 1",
    "parcel_id": "176-03-01",
    "owner1": "DOMINY, MICHAEL W",
    "owner2": "CORRAL, XIOMARA",
    "current_taxes": 15790.35,
    "new_taxes_no_override": 16472.49,
    "override_total_1": 16939.89,
    "override_increase_1": 467.39
  },
  {
    "#": "17 Davis Ave, Unit 2 (176-03-02)",
    "$": 1394900,
    "address": "17 Davis Ave, Unit 2",
    "parcel_id": "176-03-02",
    "owner1": "DOMINY, MICHAEL W",
    "owner2": "CORRAL, XIOMARA",
    "current_taxes": 14283.78,
    "new_taxes_no_override": 14900.84,
    "override_total_1": 15323.64,
    "override_increase_1": 422.8
  },
  {
    "#": "17 Davis Ave, Unit 3 (176-03-03)",
    "$": 1749900,
    "address": "17 Davis Ave, Unit 3",
    "parcel_id": "176-03-03",
    "owner1": "ROBINSON, BENJAMIN J & SARAH N",
    "owner2": "",
    "current_taxes": 14284.04,
    "new_taxes_no_override": 14901.11,
    "override_total_1": 15323.92,
    "override_increase_1": 422.81
  },
  {
    "#": "18 Davis Ave, Unit 1 (183-09-01)",
    "$": 883600,
    "address": "18 Davis Ave, Unit 1",
    "parcel_id": "183-09-01",
    "owner1": "GEDIMAN, SCOTT & STACY F",
    "owner2": "",
    "current_taxes": 9048.06,
    "new_taxes_no_override": 9438.94,
    "override_total_1": 9706.76,
    "override_increase_1": 267.82
  },
  {
    "#": "18 Davis Ave, Unit 2 (183-09-02)",
    "$": 899900,
    "address": "18 Davis Ave, Unit 2",
    "parcel_id": "183-09-02",
    "owner1": "GEDIMAN, SCOTT",
    "owner2": "",
    "current_taxes": 9214.98,
    "new_taxes_no_override": 9613.07,
    "override_total_1": 9885.83,
    "override_increase_1": 272.76
  },
  {
    "#": "18 Davis Ave, Unit 3 (183-09-03)",
    "$": 647200,
    "address": "18 Davis Ave, Unit 3",
    "parcel_id": "183-09-03",
    "owner1": "GEDIMAN, SCOTT",
    "owner2": "",
    "current_taxes": 6627.33,
    "new_taxes_no_override": 6913.63,
    "override_total_1": 7109.8,
    "override_increase_1": 196.17
  },
  {
    "#": "22 Davis Ave, Unit 1 & G1 (183-08-04)",
    "$": 899200,
    "address": "22 Davis Ave, Unit 1 & G1",
    "parcel_id": "183-08-04",
    "owner1": "RAMAKRISHNAN, SRUTHI & SUBRAMANIAM",
    "owner2": "LITTLE, JAMES",
    "current_taxes": 9207.81,
    "new_taxes_no_override": 9605.59,
    "override_total_1": 9878.14,
    "override_increase_1": 272.55
  },
  {
    "#": "22 Davis Ave, Unit 2 & G2 (183-08-05)",
    "$": 1024300,
    "address": "22 Davis Ave, Unit 2 & G2",
    "parcel_id": "183-08-05",
    "owner1": "STAVISKY, NATALIA",
    "owner2": "MESAROVICH, ALEK",
    "current_taxes": 6853.9,
    "new_taxes_no_override": 7149.99,
    "override_total_1": 7352.86,
    "override_increase_1": 202.88
  },
  {
    "#": "23 Davis Ave (176-04-01)",
    "$": 2512600,
    "address": "23 Davis Ave",
    "parcel_id": "176-04-01",
    "owner1": "MCHUGH ET AL, KENNETH W & JANICE C",
    "owner2": "",
    "current_taxes": 25729.02,
    "new_taxes_no_override": 26840.51,
    "override_total_1": 27602.09,
    "override_increase_1": 761.58
  },
  {
    "#": "24 Davis Ave (183-08-02)",
    "$": 1802500,
    "address": "24 Davis Ave",
    "parcel_id": "183-08-02",
    "owner1": "MOOR, BENJAMIN & REBECCA",
    "owner2": "",
    "current_taxes": 14822.67,
    "new_taxes_no_override": 15463.01,
    "override_total_1": 15901.76,
    "override_increase_1": 438.75
  },
  {
    "#": "25 Davis Ave (176-05-00)",
    "$": 2477300,
    "address": "25 Davis Ave",
    "parcel_id": "176-05-00",
    "owner1": "HELVARG TR, DEBORAH",
    "owner2": "C/O DELGADO, JANE",
    "current_taxes": 25367.55,
    "new_taxes_no_override": 26463.43,
    "override_total_1": 27214.31,
    "override_increase_1": 750.88
  },
  {
    "#": "26 Davis Ave (183-08-01)",
    "$": 1755400,
    "address": "26 Davis Ave",
    "parcel_id": "183-08-01",
    "owner1": "KRESCHEVSKY, MARA",
    "owner2": "LIPSITT, STEVEN D",
    "current_taxes": 14340.36,
    "new_taxes_no_override": 14959.86,
    "override_total_1": 15384.34,
    "override_increase_1": 424.47
  },
  {
    "#": "28 Davis Ave (183-08-00)",
    "$": 2129400,
    "address": "28 Davis Ave",
    "parcel_id": "183-08-00",
    "owner1": "MILLER, CASSANDRA",
    "owner2": "SCHMIDT, NICHOLAS",
    "current_taxes": 18170.12,
    "new_taxes_no_override": 18955.07,
    "override_total_1": 19492.9,
    "override_increase_1": 537.84
  },
  {
    "#": "30 Davis Ave (183-07-00)",
    "$": 2506700,
    "address": "30 Davis Ave",
    "parcel_id": "183-07-00",
    "owner1": "RUBENSTEIN, JOSHUA E & TARA L",
    "owner2": "",
    "current_taxes": 22033.67,
    "new_taxes_no_override": 22985.52,
    "override_total_1": 23637.72,
    "override_increase_1": 652.2
  },
  {
    "#": "31 Davis Ave, Unit 1 (176-06-01)",
    "$": 992700,
    "address": "31 Davis Ave, Unit 1",
    "parcel_id": "176-06-01",
    "owner1": "31 DAVIS AVE LLC",
    "owner2": "",
    "current_taxes": 10165.25,
    "new_taxes_no_override": 10604.39,
    "override_total_1": 10905.28,
    "override_increase_1": 300.89
  },
  {
    "#": "31 Davis Ave, Unit 2 (176-06-02)",
    "$": 1553700,
    "address": "31 Davis Ave, Unit 2",
    "parcel_id": "176-06-02",
    "owner1": "ODONNELL, WILLIAM JAMES & REBEKAH K",
    "owner2": "",
    "current_taxes": 12274.95,
    "new_taxes_no_override": 12805.23,
    "override_total_1": 13168.57,
    "override_increase_1": 363.34
  },
  {
    "#": "32 Davis Ave (183-06-01)",
    "$": 1561200,
    "address": "32 Davis Ave",
    "parcel_id": "183-06-01",
    "owner1": "POLLAK TRS, MARTIN R",
    "owner2": "CORREA , PATRICIA",
    "current_taxes": 12351.75,
    "new_taxes_no_override": 12885.35,
    "override_total_1": 13250.96,
    "override_increase_1": 365.61
  },
  {
    "#": "34 Davis Ave, Unit 1 & P1 (183-06-02)",
    "$": 1203300,
    "address": "34 Davis Ave, Unit 1 & P1",
    "parcel_id": "183-06-02",
    "owner1": "FOLCO, PABLO & MARIANA",
    "owner2": "",
    "current_taxes": 12321.79,
    "new_taxes_no_override": 12854.09,
    "override_total_1": 13218.82,
    "override_increase_1": 364.72
  },
  {
    "#": "34 Davis Ave, Unit 2 & P2 (183-06-03)",
    "$": 1228300,
    "address": "34 Davis Ave, Unit 2 & P2",
    "parcel_id": "183-06-03",
    "owner1": "ZERVAS, GEORGIOS",
    "owner2": "GOLDBERG, SHARON",
    "current_taxes": 8942.86,
    "new_taxes_no_override": 9329.19,
    "override_total_1": 9593.9,
    "override_increase_1": 264.71
  },
  {
    "#": "34 Davis Ave, Unit 3 & P3-4 (183-06-04)",
    "$": 1973400,
    "address": "34 Davis Ave, Unit 3 & P3-4",
    "parcel_id": "183-06-04",
    "owner1": "YUEN, ANTHONY SHEUNG LAI",
    "owner2": "KIM, LIYOUNG",
    "current_taxes": 16572.68,
    "new_taxes_no_override": 17288.62,
    "override_total_1": 17779.17,
    "override_increase_1": 490.55
  },
  {
    "#": "35 Davis Ave (176-07-00)",
    "$": 3902300,
    "address": "35 Davis Ave",
    "parcel_id": "176-07-00",
    "owner1": "SHEAR, DAVID",
    "owner2": "CHEN, ERIN",
    "current_taxes": 39959.55,
    "new_taxes_no_override": 41685.8,
    "override_total_1": 42868.61,
    "override_increase_1": 1182.8
  },
  {
    "#": "36 Davis Ave, Unit 1 (183-05-01)",
    "$": 1077000,
    "address": "36 Davis Ave, Unit 1",
    "parcel_id": "183-05-01",
    "owner1": "SHAMA TRS, STEVEN K & JEANNIE L",
    "owner2": "",
    "current_taxes": 11028.48,
    "new_taxes_no_override": 11504.91,
    "override_total_1": 11831.35,
    "override_increase_1": 326.44
  },
  {
    "#": "36 Davis Ave, Unit 2 (183-05-02)",
    "$": 1267500,
    "address": "36 Davis Ave, Unit 2",
    "parcel_id": "183-05-02",
    "owner1": "MAYFIELD POINT LLC",
    "owner2": "",
    "current_taxes": 12979.2,
    "new_taxes_no_override": 13539.9,
    "override_total_1": 13924.09,
    "override_increase_1": 384.18
  },
  {
    "#": "40 Davis Ave, Unit 40 (183-04-01)",
    "$": 2346900,
    "address": "40 Davis Ave, Unit 40",
    "parcel_id": "183-04-01",
    "owner1": "FABBRI, WILLIAM O & ANNE E GOEBEL",
    "owner2": "",
    "current_taxes": 24032.26,
    "new_taxes_no_override": 25070.45,
    "override_total_1": 25781.81,
    "override_increase_1": 711.35
  },
  {
    "#": "42 Davis Ave, Unit 42 (183-04-02)",
    "$": 1545900,
    "address": "42 Davis Ave, Unit 42",
    "parcel_id": "183-04-02",
    "owner1": "KAMHOLZ, ANDREW & BARBARA W",
    "owner2": "",
    "current_taxes": 12195.08,
    "new_taxes_no_override": 12721.91,
    "override_total_1": 13082.88,
    "override_increase_1": 360.97
  },
  {
    "#": "43 Davis Ave, Unit 1 (176-08-10)",
    "$": 1202200,
    "address": "43 Davis Ave, Unit 1",
    "parcel_id": "176-08-10",
    "owner1": "CIATTO TRS, CARLO",
    "owner2": "DONEPUDI, MRUDULA",
    "current_taxes": 8675.59,
    "new_taxes_no_override": 9050.38,
    "override_total_1": 9307.17,
    "override_increase_1": 256.8
  },
  {
    "#": "43 Davis Ave, Unit 2 (176-08-11)",
    "$": 1401200,
    "address": "43 Davis Ave, Unit 2",
    "parcel_id": "176-08-11",
    "owner1": "BERGSTEIN, BRIAN ALAN",
    "owner2": "HEEFNER, GRETCHEN ANN",
    "current_taxes": 10713.35,
    "new_taxes_no_override": 11176.17,
    "override_total_1": 11493.28,
    "override_increase_1": 317.12
  },
  {
    "#": "44 Davis Ave, Unit 44 (183-04-03)",
    "$": 1560400,
    "address": "44 Davis Ave, Unit 44",
    "parcel_id": "183-04-03",
    "owner1": "DOAN, VINH",
    "owner2": "LIU, ZONG CHENG",
    "current_taxes": 12343.56,
    "new_taxes_no_override": 12876.8,
    "override_total_1": 13242.17,
    "override_increase_1": 365.37
  },
  {
    "#": "49 Davis Ave, Unit 1 (176-13-01)",
    "$": 1081900,
    "address": "49 Davis Ave, Unit 1",
    "parcel_id": "176-13-01",
    "owner1": "CURTIS TRS, BRIAN & PATRICIA",
    "owner2": "",
    "current_taxes": 7443.72,
    "new_taxes_no_override": 7765.29,
    "override_total_1": 7985.62,
    "override_increase_1": 220.33
  },
  {
    "#": "49 Davis Ave, Unit 2 (176-13-02)",
    "$": 1354600,
    "address": "49 Davis Ave, Unit 2",
    "parcel_id": "176-13-02",
    "owner1": "HAMMOND, ALYSA DIANE",
    "owner2": "AGGARWAL, VIKRAM",
    "current_taxes": 10236.17,
    "new_taxes_no_override": 10678.37,
    "override_total_1": 10981.36,
    "override_increase_1": 302.99
  },
  {
    "#": "50 Davis Ave, Unit 50 (183-03-03)",
    "$": 3256300,
    "address": "50 Davis Ave, Unit 50",
    "parcel_id": "183-03-03",
    "owner1": "ARNOLD TR, KATHRYN KOVITZ",
    "owner2": "",
    "current_taxes": 33344.51,
    "new_taxes_no_override": 34784.99,
    "override_total_1": 35771.99,
    "override_increase_1": 987.0
  },
  {
    "#": "50 Davis Ave, Unit 52 & Ps 2 & 5 (183-03-04)",
    "$": 1273900,
    "address": "50 Davis Ave, Unit 52 & Ps 2 & 5",
    "parcel_id": "183-03-04",
    "owner1": "BARRETT, ALEXANDRA & SETH",
    "owner2": "",
    "current_taxes": 9409.8,
    "new_taxes_no_override": 9816.3,
    "override_total_1": 10094.83,
    "override_increase_1": 278.53
  },
  {
    "#": "53 Davis Ave, Unit 53 (176-14-01)",
    "$": 2593900,
    "address": "53 Davis Ave, Unit 53",
    "parcel_id": "176-14-01",
    "owner1": "HARDY, FRANKLIN V & LAURA C",
    "owner2": "PIERCE, JOSHUA T & CAROLINE",
    "current_taxes": 26561.54,
    "new_taxes_no_override": 27709.0,
    "override_total_1": 28495.22,
    "override_increase_1": 786.22
  },
  {
    "#": "54 Davis Ave (183-03-01)",
    "$": 2741200,
    "address": "54 Davis Ave",
    "parcel_id": "183-03-01",
    "owner1": "HORNE, MARTHA CLAIRE",
    "owner2": "BUINEVICIUS, ARIS",
    "current_taxes": 28069.89,
    "new_taxes_no_override": 29282.51,
    "override_total_1": 30113.38,
    "override_increase_1": 830.87
  },
  {
    "#": "55 Davis Ave, Unit 55 (176-14-02)",
    "$": 2967400,
    "address": "55 Davis Ave, Unit 55",
    "parcel_id": "176-14-02",
    "owner1": "GOODHART, LUCY",
    "owner2": "BENNETT, GORDON",
    "current_taxes": 26751.24,
    "new_taxes_no_override": 27906.89,
    "override_total_1": 28698.73,
    "override_increase_1": 791.84
  },
  {
    "#": "58 Davis Ave (183-02-00)",
    "$": 2799700,
    "address": "58 Davis Ave",
    "parcel_id": "183-02-00",
    "owner1": "EASTLAND, JULIET",
    "owner2": "",
    "current_taxes": 25033.99,
    "new_taxes_no_override": 26115.46,
    "override_total_1": 26856.46,
    "override_increase_1": 741.01
  },
  {
    "#": "60 Davis Ave (183-01-00)",
    "$": 3265000,
    "address": "60 Davis Ave",
    "parcel_id": "183-01-00",
    "owner1": "KIRBY, TR, JULIA F",
    "owner2": "",
    "current_taxes": 29798.67,
    "new_taxes_no_override": 31085.97,
    "override_total_1": 31968.01,
    "override_increase_1": 882.04
  },
  {
    "#": "68 Davis Ave (182-17-00)",
    "$": 2443800,
    "address": "68 Davis Ave",
    "parcel_id": "182-17-00",
    "owner1": "BAER, MARK J",
    "owner2": "SHULMAN, SHANNA M",
    "current_taxes": 21389.58,
    "new_taxes_no_override": 22313.61,
    "override_total_1": 22946.74,
    "override_increase_1": 633.13
  },
  {
    "#": "74 Davis Ave (182-16-00)",
    "$": 4696000,
    "address": "74 Davis Ave",
    "parcel_id": "182-16-00",
    "owner1": "OSBORNE, CHARLES & ANTONIA",
    "owner2": "",
    "current_taxes": 44452.11,
    "new_taxes_no_override": 46372.44,
    "override_total_1": 47688.22,
    "override_increase_1": 1315.78
  },
  {
    "#": "82 Davis Ave (182-15-00)",
    "$": 2409300,
    "address": "82 Davis Ave",
    "parcel_id": "182-15-00",
    "owner1": "SZETO, DAVID K & KAREN L K",
    "owner2": "",
    "current_taxes": 21036.3,
    "new_taxes_no_override": 21945.07,
    "override_total_1": 22567.74,
    "override_increase_1": 622.67
  },
  {
    "#": "84 Davis Ave, Unit 1 (182-14-02)",
    "$": 1106700,
    "address": "84 Davis Ave, Unit 1",
    "parcel_id": "182-14-02",
    "owner1": "KRAMER TR, PHILIP A",
    "owner2": "",
    "current_taxes": 7697.67,
    "new_taxes_no_override": 8030.21,
    "override_total_1": 8258.06,
    "override_increase_1": 227.85
  },
  {
    "#": "84 Davis Ave, Unit 2 (182-14-03)",
    "$": 1435100,
    "address": "84 Davis Ave, Unit 2",
    "parcel_id": "182-14-03",
    "owner1": "VEYTSKIN, IGOR B",
    "owner2": "ELECTRIS, CHRISTI E",
    "current_taxes": 11060.49,
    "new_taxes_no_override": 11538.3,
    "override_total_1": 11865.69,
    "override_increase_1": 327.39
  },
  {
    "#": "88 Davis Ave (182-14-00)",
    "$": 2543300,
    "address": "88 Davis Ave",
    "parcel_id": "182-14-00",
    "owner1": "JI, FANG",
    "owner2": "ZHOU, ZHI QIANG",
    "current_taxes": 22408.46,
    "new_taxes_no_override": 23376.51,
    "override_total_1": 24039.8,
    "override_increase_1": 663.29
  },
  {
    "#": "92 Davis Ave (182-13-01)",
    "$": 1927200,
    "address": "92 Davis Ave",
    "parcel_id": "182-13-01",
    "owner1": "BUCHMAN TR, AMIE LOUISA",
    "owner2": "",
    "current_taxes": 16099.59,
    "new_taxes_no_override": 16795.09,
    "override_total_1": 17271.64,
    "override_increase_1": 476.55
  },
  {
    "#": "96 Davis Ave (182-13-00)",
    "$": 2102700,
    "address": "96 Davis Ave",
    "parcel_id": "182-13-00",
    "owner1": "CHUNG, SHING-JONG",
    "owner2": "CHOU, HSIN-CHUAN",
    "current_taxes": 17896.71,
    "new_taxes_no_override": 18669.85,
    "override_total_1": 19199.59,
    "override_increase_1": 529.74
  },
  {
    "#": "100 Davis Ave (182-12-00)",
    "$": 2044300,
    "address": "100 Davis Ave",
    "parcel_id": "182-12-00",
    "owner1": "",
    "owner2": "WOLF, PAMELA J",
    "current_taxes": 17298.7,
    "new_taxes_no_override": 18046.0,
    "override_total_1": 18558.05,
    "override_increase_1": 512.04
  },
  {
    "#": "102 Davis Ave (182-11-00)",
    "$": 2223300,
    "address": "102 Davis Ave",
    "parcel_id": "182-11-00",
    "owner1": "BRUNO, CLARKE",
    "owner2": "BRAVERMAN, JULIE",
    "current_taxes": 19131.66,
    "new_taxes_no_override": 19958.15,
    "override_total_1": 20524.44,
    "override_increase_1": 566.3
  },
  {
    "#": "106 Davis Ave (182-10-00)",
    "$": 2034500,
    "address": "106 Davis Ave",
    "parcel_id": "182-10-00",
    "owner1": "ANDERSON TRS, WILLIAM A",
    "owner2": "CAVEY, MARY CATHERINE",
    "current_taxes": 17198.35,
    "new_taxes_no_override": 17941.32,
    "override_total_1": 18450.39,
    "override_increase_1": 509.07
  },
  {
    "#": "109 Davis Ave, Unit 2 & P4 (179-01-02)",
    "$": 1040100,
    "address": "109 Davis Ave, Unit 2 & P4",
    "parcel_id": "179-01-02",
    "owner1": "BLOCH, TAMARA",
    "owner2": "",
    "current_taxes": 7015.69,
    "new_taxes_no_override": 7318.77,
    "override_total_1": 7526.43,
    "override_increase_1": 207.66
  },
  {
    "#": "109 Davis Ave, Unit 3 P1 P5 (179-01-03)",
    "$": 1556000,
    "address": "109 Davis Ave, Unit 3 P1 P5",
    "parcel_id": "179-01-03",
    "owner1": "YEH TRS, JOSEPH C",
    "owner2": "TSAO, CYNTHIA C",
    "current_taxes": 15933.44,
    "new_taxes_no_override": 16621.76,
    "override_total_1": 17093.39,
    "override_increase_1": 471.63
  },
  {
    "#": "110 Davis Ave (182-09-00)",
    "$": 1973700,
    "address": "110 Davis Ave",
    "parcel_id": "182-09-00",
    "owner1": "WEBLER, STEVEN C",
    "owner2": "HUNTLEY, MARTHA E",
    "current_taxes": 16575.75,
    "new_taxes_no_override": 17291.82,
    "override_total_1": 17782.46,
    "override_increase_1": 490.64
  },
  {
    "#": "111 Davis Ave, Unit 1 & P2-P3 (179-01-01)",
    "$": 1191600,
    "address": "111 Davis Ave, Unit 1 & P2-P3",
    "parcel_id": "179-01-01",
    "owner1": "SCHEIN, ADAM",
    "owner2": "KILROY, CAITLIN",
    "current_taxes": 8567.05,
    "new_taxes_no_override": 8937.15,
    "override_total_1": 9190.73,
    "override_increase_1": 253.58
  },
  {
    "#": "112 Davis Ave (182-08-00)",
    "$": 1898800,
    "address": "112 Davis Ave",
    "parcel_id": "182-08-00",
    "owner1": "SENNOTT, JANICE D",
    "owner2": "DIPESA, SUSAN",
    "current_taxes": 15808.78,
    "new_taxes_no_override": 16491.72,
    "override_total_1": 16959.66,
    "override_increase_1": 467.94
  },
  {
    "#": "114 Davis Ave, Unit 1 & Pk Sp A (182-07-01)",
    "$": 1624100,
    "address": "114 Davis Ave, Unit 1 & Pk Sp A",
    "parcel_id": "182-07-01",
    "owner1": "PANKO TRS, MIKHAIL",
    "owner2": "AMERESEKERE, MAITHRI",
    "current_taxes": 12995.85,
    "new_taxes_no_override": 13557.27,
    "override_total_1": 13941.95,
    "override_increase_1": 384.68
  },
  {
    "#": "114 Davis Ave, Unit 2 & Pk Sp B (182-07-02)",
    "$": 1227200,
    "address": "114 Davis Ave, Unit 2 & Pk Sp B",
    "parcel_id": "182-07-02",
    "owner1": "JIANG, KELVIN & TIEN M",
    "owner2": "",
    "current_taxes": 8931.59,
    "new_taxes_no_override": 9317.43,
    "override_total_1": 9581.81,
    "override_increase_1": 264.38
  },
  {
    "#": "114 Davis Ave, Unit 3 & Pk Sp C (182-07-03)",
    "$": 1323500,
    "address": "114 Davis Ave, Unit 3 & Pk Sp C",
    "parcel_id": "182-07-03",
    "owner1": "SIEGEL, STEVEN",
    "owner2": "SILBERHOLZ, ELIZABETH",
    "current_taxes": 9917.71,
    "new_taxes_no_override": 10346.16,
    "override_total_1": 10639.72,
    "override_increase_1": 293.56
  },
  {
    "#": "117 Davis Ave (179-02-00)",
    "$": 2139200,
    "address": "117 Davis Ave",
    "parcel_id": "179-02-00",
    "owner1": "BOYD, CHRISTOPHER G",
    "owner2": "AQUILINE, CARIN",
    "current_taxes": 18270.47,
    "new_taxes_no_override": 19059.75,
    "override_total_1": 19600.56,
    "override_increase_1": 540.81
  },
  {
    "#": "118 Davis Ave (182-06-00)",
    "$": 1900400,
    "address": "118 Davis Ave",
    "parcel_id": "182-06-00",
    "owner1": "MCDONALD, K DAVID JR",
    "owner2": "ARADO-MCDONALD, MARIA T",
    "current_taxes": 15825.16,
    "new_taxes_no_override": 16508.81,
    "override_total_1": 16977.23,
    "override_increase_1": 468.42
  },
  {
    "#": "122 Davis Ave, Unit 1 & P1-P2 (182-05-01)",
    "$": 1249400,
    "address": "122 Davis Ave, Unit 1 & P1-P2",
    "parcel_id": "182-05-01",
    "owner1": "SCHRAM, ALIX",
    "owner2": "LIPSEY, DANIEL",
    "current_taxes": 9158.92,
    "new_taxes_no_override": 9554.59,
    "override_total_1": 9825.69,
    "override_increase_1": 271.1
  },
  {
    "#": "122 Davis Ave, Unit 2 & P3-P4 (182-05-02)",
    "$": 1185200,
    "address": "122 Davis Ave, Unit 2 & P3-P4",
    "parcel_id": "182-05-02",
    "owner1": "MACDONALD, JAMES & PAN",
    "owner2": "",
    "current_taxes": 8501.51,
    "new_taxes_no_override": 8868.78,
    "override_total_1": 9120.42,
    "override_increase_1": 251.64
  },
  {
    "#": "122 Davis Ave, Unit 3 & P5-P6 (182-05-03)",
    "$": 1592300,
    "address": "122 Davis Ave, Unit 3 & P5-P6",
    "parcel_id": "182-05-03",
    "owner1": "FRY, CAROLINE CLAUDE",
    "owner2": "",
    "current_taxes": 12670.22,
    "new_taxes_no_override": 13217.57,
    "override_total_1": 13592.61,
    "override_increase_1": 375.04
  },
  {
    "#": "123 Davis Ave (179-03-00)",
    "$": 2092800,
    "address": "123 Davis Ave",
    "parcel_id": "179-03-00",
    "owner1": "SHIEL, BARRY A",
    "owner2": "PIESZAK, JENNIFER",
    "current_taxes": 17795.34,
    "new_taxes_no_override": 18564.1,
    "override_total_1": 19090.84,
    "override_increase_1": 526.74
  },
  {
    "#": "124 Davis Ave, Unit 1 & P-B (182-04-02)",
    "$": 919200,
    "address": "124 Davis Ave, Unit 1 & P-B",
    "parcel_id": "182-04-02",
    "owner1": "ROSETO, JAMES P",
    "owner2": "ESCALANTE, CATALINA G",
    "current_taxes": 5777.67,
    "new_taxes_no_override": 6027.27,
    "override_total_1": 6198.28,
    "override_increase_1": 171.02
  },
  {
    "#": "124 Davis Ave, Unit 2 (182-04-03)",
    "$": 847600,
    "address": "124 Davis Ave, Unit 2",
    "parcel_id": "182-04-03",
    "owner1": "HOPP, WALTER D & THERESA",
    "owner2": "",
    "current_taxes": 5044.49,
    "new_taxes_no_override": 5262.41,
    "override_total_1": 5411.73,
    "override_increase_1": 149.32
  },
  {
    "#": "124 Davis Ave, Unit 3 & Pk-A (182-04-04)",
    "$": 1380900,
    "address": "124 Davis Ave, Unit 3 & Pk-A",
    "parcel_id": "182-04-04",
    "owner1": "KIM, PHILLIP H & SOYOUNG L",
    "owner2": "",
    "current_taxes": 10505.48,
    "new_taxes_no_override": 10959.32,
    "override_total_1": 11270.28,
    "override_increase_1": 310.96
  },
  {
    "#": "128 Davis Ave, Unit A (182-03-03)",
    "$": 1128200,
    "address": "128 Davis Ave, Unit A",
    "parcel_id": "182-03-03",
    "owner1": "FLANDERS TR, AARON",
    "owner2": "",
    "current_taxes": 7917.83,
    "new_taxes_no_override": 8259.88,
    "override_total_1": 8494.25,
    "override_increase_1": 234.37
  },
  {
    "#": "128 Davis Ave, Unit B (182-03-01)",
    "$": 1084000,
    "address": "128 Davis Ave, Unit B",
    "parcel_id": "182-03-01",
    "owner1": "UNTERMAN, KAREN & SHIMON",
    "owner2": "",
    "current_taxes": 7465.23,
    "new_taxes_no_override": 7787.73,
    "override_total_1": 8008.7,
    "override_increase_1": 220.97
  },
  {
    "#": "128 Davis Ave, Unit C (182-03-02)",
    "$": 1183200,
    "address": "128 Davis Ave, Unit C",
    "parcel_id": "182-03-02",
    "owner1": "BAKER, JONATHAN",
    "owner2": "DIMOCK, JESSICA",
    "current_taxes": 8481.03,
    "new_taxes_no_override": 8847.41,
    "override_total_1": 9098.45,
    "override_increase_1": 251.04
  },
  {
    "#": "131 Davis Ave, Unit 1 & P5 P7 (180-09-01)",
    "$": 969100,
    "address": "131 Davis Ave, Unit 1 & P5 P7",
    "parcel_id": "180-09-01",
    "owner1": "GUTHIER, CHRISTIAN VINZENZ & ROMY",
    "owner2": "",
    "current_taxes": 6288.65,
    "new_taxes_no_override": 6560.32,
    "override_total_1": 6746.46,
    "override_increase_1": 186.14
  },
  {
    "#": "131 Davis Ave, Unit 2 P6 P8 (180-09-02)",
    "$": 1788800,
    "address": "131 Davis Ave, Unit 2 P6 P8",
    "parcel_id": "180-09-02",
    "owner1": "FIALA, JAMES G JR",
    "owner2": "HENNESSY, ROBIN M",
    "current_taxes": 18317.31,
    "new_taxes_no_override": 19108.62,
    "override_total_1": 19650.81,
    "override_increase_1": 542.19
  },
  {
    "#": "134 Davis Ave, Unit 1 & P4 (181-06-01)",
    "$": 1319400,
    "address": "134 Davis Ave, Unit 1 & P4",
    "parcel_id": "181-06-01",
    "owner1": "BHATNAGAR TRS, SAURABHA & JENNIFER M",
    "owner2": "",
    "current_taxes": 9875.72,
    "new_taxes_no_override": 10302.35,
    "override_total_1": 10594.67,
    "override_increase_1": 292.32
  },
  {
    "#": "134 Davis Ave, Unit 2 & P3 (181-06-02)",
    "$": 1274900,
    "address": "134 Davis Ave, Unit 2 & P3",
    "parcel_id": "181-06-02",
    "owner1": "TOMER, MARVA",
    "owner2": "STEINER, EITAN",
    "current_taxes": 9420.04,
    "new_taxes_no_override": 9826.99,
    "override_total_1": 10105.82,
    "override_increase_1": 278.83
  },
  {
    "#": "134 Davis Ave, Unit 3 & P1 P2 (181-06-03)",
    "$": 1542700,
    "address": "134 Davis Ave, Unit 3 & P1 P2",
    "parcel_id": "181-06-03",
    "owner1": "LYONS, SHAWN & JESSICA",
    "owner2": "",
    "current_taxes": 12162.31,
    "new_taxes_no_override": 12687.72,
    "override_total_1": 13047.73,
    "override_increase_1": 360.0
  },
  {
    "#": "135 Davis Ave, Unit 1 & P1-3 (180-09-03)",
    "$": 935500,
    "address": "135 Davis Ave, Unit 1 & P1-3",
    "parcel_id": "180-09-03",
    "owner1": "VINOGRAD, JOSEPH",
    "owner2": "BURKSTEIN, HERSH",
    "current_taxes": 9579.52,
    "new_taxes_no_override": 9993.36,
    "override_total_1": 10276.91,
    "override_increase_1": 283.55
  },
  {
    "#": "135 Davis Ave, Unit 2 & P2-4 (180-09-04)",
    "$": 1782600,
    "address": "135 Davis Ave, Unit 2 & P2-4",
    "parcel_id": "180-09-04",
    "owner1": "MACDONALD, BRYAN",
    "owner2": "LEHOCZKY, JESSICA",
    "current_taxes": 14618.89,
    "new_taxes_no_override": 15250.43,
    "override_total_1": 15683.15,
    "override_increase_1": 432.72
  },
  {
    "#": "138 Davis Ave, Unit 1 & Pk Sp (181-05-01)",
    "$": 962600,
    "address": "138 Davis Ave, Unit 1 & Pk Sp",
    "parcel_id": "181-05-01",
    "owner1": "PALMACCI TRS, LAWRENCE L & SUSANNE M",
    "owner2": "",
    "current_taxes": 9857.02,
    "new_taxes_no_override": 10282.84,
    "override_total_1": 10574.61,
    "override_increase_1": 291.77
  },
  {
    "#": "138 Davis Ave, Unit 2 (181-05-02)",
    "$": 954900,
    "address": "138 Davis Ave, Unit 2",
    "parcel_id": "181-05-02",
    "owner1": "FISHMAN, DANIEL & ALIX REBECCA LEESER",
    "owner2": "",
    "current_taxes": 6143.24,
    "new_taxes_no_override": 6408.63,
    "override_total_1": 6590.47,
    "override_increase_1": 181.84
  },
  {
    "#": "138 Davis Ave, Unit 3 & Pk Sp (181-05-03)",
    "$": 1139800,
    "address": "138 Davis Ave, Unit 3 & Pk Sp",
    "parcel_id": "181-05-03",
    "owner1": "BRINKLEY, NOEL & JULIANA",
    "owner2": "",
    "current_taxes": 11671.55,
    "new_taxes_no_override": 12175.76,
    "override_total_1": 12521.24,
    "override_increase_1": 345.48
  },
  {
    "#": "139 Davis Ave, Unit 6 (180-01-02)",
    "$": 1303700,
    "address": "139 Davis Ave, Unit 6",
    "parcel_id": "180-01-02",
    "owner1": "BELL TR, WILLIAM WALLACE III",
    "owner2": "",
    "current_taxes": 9714.95,
    "new_taxes_no_override": 10134.64,
    "override_total_1": 10422.2,
    "override_increase_1": 287.56
  },
  {
    "#": "139 Davis Ave, Unit 8 (180-01-04)",
    "$": 1501200,
    "address": "139 Davis Ave, Unit 8",
    "parcel_id": "180-01-04",
    "owner1": "KANE, CHARLES J & CHRISTINE A",
    "owner2": "",
    "current_taxes": 11737.35,
    "new_taxes_no_override": 12244.4,
    "override_total_1": 12591.83,
    "override_increase_1": 347.43
  },
  {
    "#": "151 Davis Ave (197-04-00)",
    "$": 2395900,
    "address": "151 Davis Ave",
    "parcel_id": "197-04-00",
    "owner1": "SMALL TRS, JONATHAN J",
    "owner2": "SINGER, JAYNE M",
    "current_taxes": 20899.08,
    "new_taxes_no_override": 21801.92,
    "override_total_1": 22420.53,
    "override_increase_1": 618.61
  },
  {
    "#": "155 Davis Ave (197-05-00)",
    "$": 2235500,
    "address": "155 Davis Ave",
    "parcel_id": "197-05-00",
    "owner1": "GOLDBERG TRS, MARCIA B",
    "owner2": "GROSSMAN, ALAN D",
    "current_taxes": 19256.59,
    "new_taxes_no_override": 20088.47,
    "override_total_1": 20658.47,
    "override_increase_1": 570.0
  },
  {
    "#": "161 Davis Ave (197-06-00)",
    "$": 3898700,
    "address": "161 Davis Ave",
    "parcel_id": "197-06-00",
    "owner1": "LAPIDUS TR, FOTOULLA NICOLE",
    "owner2": "",
    "current_taxes": 39922.69,
    "new_taxes_no_override": 41647.35,
    "override_total_1": 42829.06,
    "override_increase_1": 1181.71
  },
  {
    "#": "165 Davis Ave (196-04-00)",
    "$": 1940900,
    "address": "165 Davis Ave",
    "parcel_id": "196-04-00",
    "owner1": "YEE TR, DANNY",
    "owner2": "",
    "current_taxes": 19874.82,
    "new_taxes_no_override": 20733.41,
    "override_total_1": 21321.71,
    "override_increase_1": 588.29
  },
  {
    "#": "173 Davis Ave (196-05-00)",
    "$": 5574700,
    "address": "173 Davis Ave",
    "parcel_id": "196-05-00",
    "owner1": "SAUNDERS, TR, DONALD L",
    "owner2": "C/O SAUNDERS ASSOCIATES",
    "current_taxes": 57084.93,
    "new_taxes_no_override": 59551.0,
    "override_total_1": 61240.71,
    "override_increase_1": 1689.71
  },
  {
    "#": "175 Davis Ave (196-06-02)",
    "$": 1667000,
    "address": "175 Davis Ave",
    "parcel_id": "196-06-02",
    "owner1": "CLASBY TRS, THOMAS V",
    "owner2": "RIVERS, DEBORAH J",
    "current_taxes": 13435.15,
    "new_taxes_no_override": 14015.55,
    "override_total_1": 14413.23,
    "override_increase_1": 397.68
  },
  {
    "#": "177 Davis Ave (196-06-01)",
    "$": 1710300,
    "address": "177 Davis Ave",
    "parcel_id": "196-06-01",
    "owner1": "COWHERD TR, SARAH M",
    "owner2": "",
    "current_taxes": 13878.54,
    "new_taxes_no_override": 14478.09,
    "override_total_1": 14888.9,
    "override_increase_1": 410.8
  },
  {
    "#": "179 Davis Ave (196-06-00)",
    "$": 1765400,
    "address": "179 Davis Ave",
    "parcel_id": "196-06-00",
    "owner1": "BECK, FERN B",
    "owner2": "",
    "current_taxes": 14442.76,
    "new_taxes_no_override": 15066.69,
    "override_total_1": 15494.19,
    "override_increase_1": 427.51
  },
  {
    "#": "181 Davis Ave, Unit 1 & P2-3 (196-07-01)",
    "$": 1460400,
    "address": "181 Davis Ave, Unit 1 & P2-3",
    "parcel_id": "196-07-01",
    "owner1": "KATSAVOUNIDIS, EROTOKRITOS",
    "owner2": "DI CREDICO, ALESSANDRA",
    "current_taxes": 11319.56,
    "new_taxes_no_override": 11808.56,
    "override_total_1": 12143.62,
    "override_increase_1": 335.06
  },
  {
    "#": "181 Davis Ave, Unit 2 Prk 4 5 (196-07-02)",
    "$": 1890000,
    "address": "181 Davis Ave, Unit 2 Prk 4 5",
    "parcel_id": "196-07-02",
    "owner1": "COLTOF, GIDEON",
    "owner2": "KAREVA, IRINA GEORGIEVNA",
    "current_taxes": 15718.67,
    "new_taxes_no_override": 16397.72,
    "override_total_1": 16862.99,
    "override_increase_1": 465.27
  },
  {
    "#": "181 Davis Ave, Unit 3 & Prk #1 (196-07-03)",
    "$": 1071800,
    "address": "181 Davis Ave, Unit 3 & Prk #1",
    "parcel_id": "196-07-03",
    "owner1": "TOCCI TRS, CATHERINE",
    "owner2": "CAMERON, TERESA A",
    "current_taxes": 7340.3,
    "new_taxes_no_override": 7657.4,
    "override_total_1": 7874.67,
    "override_increase_1": 217.27
  },
  {
    "#": "185 Davis Ave, Unit 1 (196-08-08)",
    "$": 1147800,
    "address": "185 Davis Ave, Unit 1",
    "parcel_id": "196-08-08",
    "owner1": "CORONGES, KATHRYN",
    "owner2": "",
    "current_taxes": 8118.54,
    "new_taxes_no_override": 8469.26,
    "override_total_1": 8709.57,
    "override_increase_1": 240.31
  },
  {
    "#": "185 Davis Ave, Unit 2 (196-08-01)",
    "$": 1122000,
    "address": "185 Davis Ave, Unit 2",
    "parcel_id": "196-08-01",
    "owner1": "SMITH, CONNIE M",
    "owner2": "C/O BARR CONNIE SMITH",
    "current_taxes": 11489.28,
    "new_taxes_no_override": 11985.62,
    "override_total_1": 12325.7,
    "override_increase_1": 340.08
  },
  {
    "#": "185 Davis Ave, Unit 3 (196-08-02)",
    "$": 1142100,
    "address": "185 Davis Ave, Unit 3",
    "parcel_id": "196-08-02",
    "owner1": "RICE, CHARLOTTE",
    "owner2": "SHALES, EZRA",
    "current_taxes": 8060.17,
    "new_taxes_no_override": 8408.37,
    "override_total_1": 8646.95,
    "override_increase_1": 238.58
  },
  {
    "#": "185 Davis Ave, Unit 4 (196-08-03)",
    "$": 1094000,
    "address": "185 Davis Ave, Unit 4",
    "parcel_id": "196-08-03",
    "owner1": "CHEN, GUO Y",
    "owner2": "ZHANG, YOU X",
    "current_taxes": 7567.63,
    "new_taxes_no_override": 7894.55,
    "override_total_1": 8118.55,
    "override_increase_1": 224.0
  },
  {
    "#": "185 Davis Ave, Unit 5 & P-P1 (196-08-04)",
    "$": 1133000,
    "address": "185 Davis Ave, Unit 5 & P-P1",
    "parcel_id": "196-08-04",
    "owner1": "CONWAY TR, KEVIN A",
    "owner2": "",
    "current_taxes": 7966.99,
    "new_taxes_no_override": 8311.16,
    "override_total_1": 8546.99,
    "override_increase_1": 235.82
  },
  {
    "#": "185 Davis Ave, Unit 6 & P-6 (196-08-05)",
    "$": 1159700,
    "address": "185 Davis Ave, Unit 6 & P-6",
    "parcel_id": "196-08-05",
    "owner1": "PRATT-OTTO TRS, STEPHEN & DRUSILLA H",
    "owner2": "",
    "current_taxes": 8240.39,
    "new_taxes_no_override": 8596.37,
    "override_total_1": 8840.29,
    "override_increase_1": 243.92
  },
  {
    "#": "185 Davis Ave, Unit 7 (196-08-06)",
    "$": 1052500,
    "address": "185 Davis Ave, Unit 7",
    "parcel_id": "196-08-06",
    "owner1": "ZHAO, MENGYAO",
    "owner2": "LI, HENG",
    "current_taxes": 10777.6,
    "new_taxes_no_override": 11243.19,
    "override_total_1": 11562.21,
    "override_increase_1": 319.02
  },
  {
    "#": "185 Davis Ave, Unit 8 & P7 (196-08-07)",
    "$": 1026900,
    "address": "185 Davis Ave, Unit 8 & P7",
    "parcel_id": "196-08-07",
    "owner1": "SARTOR, EMMETT ALTON",
    "owner2": "SAXENA, ANEETA RANI",
    "current_taxes": 10515.46,
    "new_taxes_no_override": 10969.73,
    "override_total_1": 11280.99,
    "override_increase_1": 311.26
  },
  {
    "#": "191 Davis Ave (196-09-00)",
    "$": 2692800,
    "address": "191 Davis Ave",
    "parcel_id": "196-09-00",
    "owner1": "CHAO TRS, NING LABBISH",
    "owner2": "HAN , LEIN FANG",
    "current_taxes": 23939.34,
    "new_taxes_no_override": 24973.52,
    "override_total_1": 25682.12,
    "override_increase_1": 708.6
  },
  {
    "#": "195 Davis Ave, Unit 1 Pa&B (196-10-05)",
    "$": 1075600,
    "address": "195 Davis Ave, Unit 1 Pa&B",
    "parcel_id": "196-10-05",
    "owner1": "KOENEN, KARESTAN C",
    "owner2": "",
    "current_taxes": 7379.21,
    "new_taxes_no_override": 7697.99,
    "override_total_1": 7916.42,
    "override_increase_1": 218.42
  },
  {
    "#": "195 Davis Ave, Unit 2 & Pk-C (196-10-01)",
    "$": 624600,
    "address": "195 Davis Ave, Unit 2 & Pk-C",
    "parcel_id": "196-10-01",
    "owner1": "MALINN , MEREDITH",
    "owner2": "OBOY, EILEEN STRONG & KEVIN",
    "current_taxes": 6395.9,
    "new_taxes_no_override": 6672.2,
    "override_total_1": 6861.52,
    "override_increase_1": 189.32
  },
  {
    "#": "195 Davis Ave, Unit 3&Pk-E H (196-10-02)",
    "$": 1277300,
    "address": "195 Davis Ave, Unit 3&Pk-E H",
    "parcel_id": "196-10-02",
    "owner1": "WOFFORD, JENNIFER ALLISON",
    "owner2": "",
    "current_taxes": 9444.62,
    "new_taxes_no_override": 9852.63,
    "override_total_1": 10132.19,
    "override_increase_1": 279.56
  },
  {
    "#": "195 Davis Ave, Unit 4 & Pk-D (196-10-03)",
    "$": 924700,
    "address": "195 Davis Ave, Unit 4 & Pk-D",
    "parcel_id": "196-10-03",
    "owner1": "ROBINSON, THOMAS W",
    "owner2": "",
    "current_taxes": 5833.99,
    "new_taxes_no_override": 6086.02,
    "override_total_1": 6258.7,
    "override_increase_1": 172.69
  },
  {
    "#": "195 Davis Ave, Unit Pk- F (196-10-07)",
    "$": 49000,
    "address": "195 Davis Ave, Unit Pk- F",
    "parcel_id": "196-10-07",
    "owner1": "SASSU, NICOLE MARIE",
    "owner2": "",
    "current_taxes": 501.76,
    "new_taxes_no_override": 523.44,
    "override_total_1": 538.29,
    "override_increase_1": 14.85
  },
  {
    "#": "195 Davis Ave, Unit Pk- G (196-10-08)",
    "$": 49000,
    "address": "195 Davis Ave, Unit Pk- G",
    "parcel_id": "196-10-08",
    "owner1": "SASSU, NICOLE MARIE",
    "owner2": "",
    "current_taxes": 501.76,
    "new_taxes_no_override": 523.44,
    "override_total_1": 538.29,
    "override_increase_1": 14.85
  },
  {
    "#": "201 Davis Ave (196-11-00)",
    "$": 2523800,
    "address": "201 Davis Ave",
    "parcel_id": "196-11-00",
    "owner1": "FONG TRS, SHELTON &  RITA M",
    "owner2": "",
    "current_taxes": 22208.78,
    "new_taxes_no_override": 23168.2,
    "override_total_1": 23825.58,
    "override_increase_1": 657.38
  },
  {
    "#": "205 Davis Ave (196-12-00)",
    "$": 3021900,
    "address": "205 Davis Ave",
    "parcel_id": "196-12-00",
    "owner1": "LIPSCHULTZ TRS, BRUCE & ROCHELLE W",
    "owner2": "",
    "current_taxes": 27309.32,
    "new_taxes_no_override": 28489.08,
    "override_total_1": 29297.44,
    "override_increase_1": 808.36
  },
  {
    "#": "4 Davis Ct (183-14-00)",
    "$": 2125500,
    "address": "4 Davis Ct",
    "parcel_id": "183-14-00",
    "owner1": "4 DAVIS COURT LLC",
    "owner2": "",
    "current_taxes": 36473.58,
    "new_taxes_no_override": 38049.24,
    "override_total_1": 39128.86,
    "override_increase_1": 1079.62
  },
  {
    "#": "12 Davis Ct, Unit 1 (183-13-01)",
    "$": 1219400,
    "address": "12 Davis Ct, Unit 1",
    "parcel_id": "183-13-01",
    "owner1": "LOCKWOOD, JAMES P",
    "owner2": "",
    "current_taxes": 8851.72,
    "new_taxes_no_override": 9234.11,
    "override_total_1": 9496.13,
    "override_increase_1": 262.01
  },
  {
    "#": "12 Davis Ct, Unit 2 (183-13-02)",
    "$": 466700,
    "address": "12 Davis Ct, Unit 2",
    "parcel_id": "183-13-02",
    "owner1": "LU, MEI JUNG",
    "owner2": "OBRIEN, ANGELINA",
    "current_taxes": 4779.01,
    "new_taxes_no_override": 4985.46,
    "override_total_1": 5126.92,
    "override_increase_1": 141.46
  },
  {
    "#": "12 Davis Ct, Unit 3 (183-13-03)",
    "$": 530800,
    "address": "12 Davis Ct, Unit 3",
    "parcel_id": "183-13-03",
    "owner1": "ENG, BRANDON",
    "owner2": "",
    "current_taxes": 5435.39,
    "new_taxes_no_override": 5670.2,
    "override_total_1": 5831.09,
    "override_increase_1": 160.89
  },
  {
    "#": "12 Dean Rd (225-60-00)",
    "$": 5415600,
    "address": "12 Dean Rd",
    "parcel_id": "225-60-00",
    "owner1": "DEAN ROAD COMPANY LLC",
    "owner2": "",
    "current_taxes": 55455.74,
    "new_taxes_no_override": 57851.43,
    "override_total_1": 59492.92,
    "override_increase_1": 1641.49
  },
  {
    "#": "18 Dean Rd (225-61-00)",
    "$": 4300100,
    "address": "18 Dean Rd",
    "parcel_id": "225-61-00",
    "owner1": "WEI, COURTNEY XIAOPENG",
    "owner2": "",
    "current_taxes": 44033.02,
    "new_taxes_no_override": 45935.25,
    "override_total_1": 47238.62,
    "override_increase_1": 1303.38
  },
  {
    "#": "20 Dean Rd (225-62-00)",
    "$": 4220400,
    "address": "20 Dean Rd",
    "parcel_id": "225-62-00",
    "owner1": "SANIEOFF, TR, SYROOS",
    "owner2": "",
    "current_taxes": 43216.9,
    "new_taxes_no_override": 45083.87,
    "override_total_1": 46363.09,
    "override_increase_1": 1279.22
  },
  {
    "#": "24 Dean Rd, Unit 1 (225-63-03)",
    "$": 1498700,
    "address": "24 Dean Rd, Unit 1",
    "parcel_id": "225-63-03",
    "owner1": "LOETERMAN TRS, BEN & MARDI H",
    "owner2": "",
    "current_taxes": 11711.75,
    "new_taxes_no_override": 12217.7,
    "override_total_1": 12564.37,
    "override_increase_1": 346.67
  },
  {
    "#": "24 Dean Rd, Unit 2  (225-63-01)",
    "$": 1541100,
    "address": "24 Dean Rd, Unit 2 ",
    "parcel_id": "225-63-01",
    "owner1": "HEALY TRS, JOHN L & KATE E",
    "owner2": "",
    "current_taxes": 15780.86,
    "new_taxes_no_override": 16462.59,
    "override_total_1": 16929.71,
    "override_increase_1": 467.11
  },
  {
    "#": "24 Dean Rd, Unit 3 (225-63-02)",
    "$": 1667100,
    "address": "24 Dean Rd, Unit 3",
    "parcel_id": "225-63-02",
    "owner1": "NOVIK, OLGA",
    "owner2": "",
    "current_taxes": 17071.1,
    "new_taxes_no_override": 17808.57,
    "override_total_1": 18313.88,
    "override_increase_1": 505.3
  },
  {
    "#": "26 Dean Rd, Unit 1 (225-64-03)",
    "$": 1752400,
    "address": "26 Dean Rd, Unit 1",
    "parcel_id": "225-64-03",
    "owner1": "DOBKIN, BENJAMIN LEE",
    "owner2": "SHNEYDERMAN, YANA",
    "current_taxes": 14309.64,
    "new_taxes_no_override": 14927.82,
    "override_total_1": 15351.38,
    "override_increase_1": 423.57
  },
  {
    "#": "26 Dean Rd, Unit 2 & P3-4 (225-64-01)",
    "$": 1544900,
    "address": "26 Dean Rd, Unit 2 & P3-4",
    "parcel_id": "225-64-01",
    "owner1": "DRUSKIN, VLADIMIR",
    "owner2": "TAZIYAKOVA, MARINA",
    "current_taxes": 12184.84,
    "new_taxes_no_override": 12711.23,
    "override_total_1": 13071.9,
    "override_increase_1": 360.67
  },
  {
    "#": "26 Dean Rd, Unit 3 (225-64-02)",
    "$": 1482400,
    "address": "26 Dean Rd, Unit 3",
    "parcel_id": "225-64-02",
    "owner1": "MCKINNEY, JILL L",
    "owner2": "KELLEHE, P A",
    "current_taxes": 11544.84,
    "new_taxes_no_override": 12043.58,
    "override_total_1": 12385.3,
    "override_increase_1": 341.73
  },
  {
    "#": "30 Dean Rd, Unit C-2 & P9 (225-65-02)",
    "$": 1039700,
    "address": "30 Dean Rd, Unit C-2 & P9",
    "parcel_id": "225-65-02",
    "owner1": "KELLEY TR, VICKI RUBIN",
    "owner2": "",
    "current_taxes": 7011.59,
    "new_taxes_no_override": 7314.49,
    "override_total_1": 7522.03,
    "override_increase_1": 207.54
  },
  {
    "#": "30 Dean Rd, Unit C-3 (225-65-04)",
    "$": 1085300,
    "address": "30 Dean Rd, Unit C-3",
    "parcel_id": "225-65-04",
    "owner1": "MCCREADIE, GINA M",
    "owner2": "",
    "current_taxes": 7478.54,
    "new_taxes_no_override": 7801.61,
    "override_total_1": 8022.98,
    "override_increase_1": 221.36
  },
  {
    "#": "30 Dean Rd, Unit C-G & P12 (225-65-14)",
    "$": 1052500,
    "address": "30 Dean Rd, Unit C-G & P12",
    "parcel_id": "225-65-14",
    "owner1": "SHAFRAN TRS, HANK",
    "owner2": "DELISI, TONI",
    "current_taxes": 7142.67,
    "new_taxes_no_override": 7451.23,
    "override_total_1": 7662.66,
    "override_increase_1": 211.42
  },
  {
    "#": "30 Dean Rd, Unit D-2 P15-G8 (225-65-03)",
    "$": 1305000,
    "address": "30 Dean Rd, Unit D-2 P15-G8",
    "parcel_id": "225-65-03",
    "owner1": "GAGE TR, PETER L",
    "owner2": "JUPIN, CATHY A",
    "current_taxes": 9728.27,
    "new_taxes_no_override": 10148.53,
    "override_total_1": 10436.49,
    "override_increase_1": 287.96
  },
  {
    "#": "30 Dean Rd, Unit D-3 (225-65-05)",
    "$": 1352300,
    "address": "30 Dean Rd, Unit D-3",
    "parcel_id": "225-65-05",
    "owner1": "WONG, PETER PUI TO",
    "owner2": "BERLOW, SARAH",
    "current_taxes": 13847.55,
    "new_taxes_no_override": 14445.76,
    "override_total_1": 14855.65,
    "override_increase_1": 409.89
  },
  {
    "#": "30 Dean Rd, Unit D-G (225-65-01)",
    "$": 1249900,
    "address": "30 Dean Rd, Unit D-G",
    "parcel_id": "225-65-01",
    "owner1": "KAYE, JAMES A",
    "owner2": "RUBIN, KIM D",
    "current_taxes": 9164.04,
    "new_taxes_no_override": 9559.93,
    "override_total_1": 9831.18,
    "override_increase_1": 271.26
  },
  {
    "#": "38 Dean Rd, Unit 1 & P26 (226-02-41)",
    "$": 635500,
    "address": "38 Dean Rd, Unit 1 & P26",
    "parcel_id": "226-02-41",
    "owner1": "BOUCAI TR, GEORGETTE L",
    "owner2": "",
    "current_taxes": 6507.52,
    "new_taxes_no_override": 6788.64,
    "override_total_1": 6981.27,
    "override_increase_1": 192.62
  },
  {
    "#": "38 Dean Rd, Unit 2 & P24 (226-02-42)",
    "$": 535200,
    "address": "38 Dean Rd, Unit 2 & P24",
    "parcel_id": "226-02-42",
    "owner1": "SHARAF TR, ALAN B",
    "owner2": "",
    "current_taxes": 5480.45,
    "new_taxes_no_override": 5717.21,
    "override_total_1": 5879.43,
    "override_increase_1": 162.22
  },
  {
    "#": "38 Dean Rd, Unit 3 (226-02-43)",
    "$": 654900,
    "address": "38 Dean Rd, Unit 3",
    "parcel_id": "226-02-43",
    "owner1": "HERMAN TR, LORI B",
    "owner2": "OROZCO, SARA",
    "current_taxes": 6706.18,
    "new_taxes_no_override": 6995.89,
    "override_total_1": 7194.39,
    "override_increase_1": 198.5
  },
  {
    "#": "38 Dean Rd, Unit 4 & P11 (226-02-44)",
    "$": 535200,
    "address": "38 Dean Rd, Unit 4 & P11",
    "parcel_id": "226-02-44",
    "owner1": "HUSSAIN, AMINA AYYAZ",
    "owner2": "",
    "current_taxes": 1845.51,
    "new_taxes_no_override": 1925.24,
    "override_total_1": 1979.86,
    "override_increase_1": 54.63
  },
  {
    "#": "38 Dean Rd, Unit 5 & G15 (226-02-45)",
    "$": 689800,
    "address": "38 Dean Rd, Unit 5 & G15",
    "parcel_id": "226-02-45",
    "owner1": "SHARAF TR, ALAN B",
    "owner2": "",
    "current_taxes": 7063.55,
    "new_taxes_no_override": 7368.7,
    "override_total_1": 7577.78,
    "override_increase_1": 209.08
  },
  {
    "#": "38 Dean Rd, Unit 6 & G14 (226-02-46)",
    "$": 617100,
    "address": "38 Dean Rd, Unit 6 & G14",
    "parcel_id": "226-02-46",
    "owner1": "BOUCAI TR, GEORGETTE L",
    "owner2": "",
    "current_taxes": 6319.1,
    "new_taxes_no_override": 6592.09,
    "override_total_1": 6779.13,
    "override_increase_1": 187.05
  },
  {
    "#": "38 Dean Rd, Unit T1 (226-02-55)",
    "$": 584300,
    "address": "38 Dean Rd, Unit T1",
    "parcel_id": "226-02-55",
    "owner1": "YANG, RUINAN & ZHIHANG",
    "owner2": "",
    "current_taxes": 5983.23,
    "new_taxes_no_override": 6241.71,
    "override_total_1": 6418.81,
    "override_increase_1": 177.1
  },
  {
    "#": "38 Dean Rd, Unit T2 & G10 (226-02-40)",
    "$": 489500,
    "address": "38 Dean Rd, Unit T2 & G10",
    "parcel_id": "226-02-40",
    "owner1": "SHARMA, BIMLA",
    "owner2": "",
    "current_taxes": 5012.48,
    "new_taxes_no_override": 5229.02,
    "override_total_1": 5377.39,
    "override_increase_1": 148.37
  },
  {
    "#": "42 Dean Rd, Unit 1 (226-02-49)",
    "$": 471100,
    "address": "42 Dean Rd, Unit 1",
    "parcel_id": "226-02-49",
    "owner1": "ITZKOWITZ TRS, HERBERT H & JUDITH B",
    "owner2": "",
    "current_taxes": 4824.06,
    "new_taxes_no_override": 5032.46,
    "override_total_1": 5175.25,
    "override_increase_1": 142.79
  },
  {
    "#": "42 Dean Rd, Unit 2 & G9 (226-02-50)",
    "$": 547000,
    "address": "42 Dean Rd, Unit 2 & G9",
    "parcel_id": "226-02-50",
    "owner1": "SHARAF TR, ALAN B",
    "owner2": "",
    "current_taxes": 5601.28,
    "new_taxes_no_override": 5843.26,
    "override_total_1": 6009.05,
    "override_increase_1": 165.8
  },
  {
    "#": "42 Dean Rd, Unit 3 (226-02-51)",
    "$": 471100,
    "address": "42 Dean Rd, Unit 3",
    "parcel_id": "226-02-51",
    "owner1": "MIGLIORE, ALBERTO",
    "owner2": "",
    "current_taxes": 1189.13,
    "new_taxes_no_override": 1240.5,
    "override_total_1": 1275.7,
    "override_increase_1": 35.2
  },
  {
    "#": "42 Dean Rd, Unit 4 (226-02-52)",
    "$": 512100,
    "address": "42 Dean Rd, Unit 4",
    "parcel_id": "226-02-52",
    "owner1": "MOHIUDDIN TR, SHAHEEDA",
    "owner2": "",
    "current_taxes": 5243.9,
    "new_taxes_no_override": 5470.44,
    "override_total_1": 5625.66,
    "override_increase_1": 155.22
  },
  {
    "#": "42 Dean Rd, Unit 5 & P16 (226-02-53)",
    "$": 471100,
    "address": "42 Dean Rd, Unit 5 & P16",
    "parcel_id": "226-02-53",
    "owner1": "YU, KYONG JA",
    "owner2": "",
    "current_taxes": 4824.06,
    "new_taxes_no_override": 5032.46,
    "override_total_1": 5175.25,
    "override_increase_1": 142.79
  },
  {
    "#": "42 Dean Rd, Unit 6 & P12 (226-02-54)",
    "$": 623700,
    "address": "42 Dean Rd, Unit 6 & P12",
    "parcel_id": "226-02-54",
    "owner1": "LEE, ANDREW FOOK HEI",
    "owner2": "HUI, MING WAI",
    "current_taxes": 6386.69,
    "new_taxes_no_override": 6662.6,
    "override_total_1": 6851.64,
    "override_increase_1": 189.05
  },
  {
    "#": "42 Dean Rd, Unit T1 (226-02-47)",
    "$": 404400,
    "address": "42 Dean Rd, Unit T1",
    "parcel_id": "226-02-47",
    "owner1": "SHOHAM, MARK E",
    "owner2": "",
    "current_taxes": 4141.06,
    "new_taxes_no_override": 4319.95,
    "override_total_1": 4442.53,
    "override_increase_1": 122.58
  },
  {
    "#": "42 Dean Rd, Unit T2 & P52 (226-02-48)",
    "$": 438700,
    "address": "42 Dean Rd, Unit T2 & P52",
    "parcel_id": "226-02-48",
    "owner1": "BOUCAI TR, GEORGETTE L",
    "owner2": "",
    "current_taxes": 4492.29,
    "new_taxes_no_override": 4686.36,
    "override_total_1": 4819.33,
    "override_increase_1": 132.97
  },
  {
    "#": "61 Dean Rd (233-07-00)",
    "$": 3254200,
    "address": "61 Dean Rd",
    "parcel_id": "233-07-00",
    "owner1": "ALTSHULER, DAVID M & JILL S",
    "owner2": "",
    "current_taxes": 29688.07,
    "new_taxes_no_override": 30970.59,
    "override_total_1": 31849.36,
    "override_increase_1": 878.77
  },
  {
    "#": "64 Dean Rd (230-01-00)",
    "$": 2775400,
    "address": "64 Dean Rd",
    "parcel_id": "230-01-00",
    "owner1": "MOSES GARDNER LLC",
    "owner2": "",
    "current_taxes": 28420.1,
    "new_taxes_no_override": 29647.85,
    "override_total_1": 30489.08,
    "override_increase_1": 841.23
  },
  {
    "#": "73 Dean Rd (232-01-00)",
    "$": 3030900,
    "address": "73 Dean Rd",
    "parcel_id": "232-01-00",
    "owner1": "PIERPONT, ALEX & LISA",
    "owner2": "",
    "current_taxes": 27401.48,
    "new_taxes_no_override": 28585.22,
    "override_total_1": 29396.31,
    "override_increase_1": 811.08
  },
  {
    "#": "78 Dean Rd (245-06-00)",
    "$": 2934800,
    "address": "78 Dean Rd",
    "parcel_id": "245-06-00",
    "owner1": "FOLEY TR, MELISSA A",
    "owner2": "",
    "current_taxes": 26417.42,
    "new_taxes_no_override": 27558.65,
    "override_total_1": 28340.61,
    "override_increase_1": 781.96
  },
  {
    "#": "85 Dean Rd (232-02-00)",
    "$": 3406000,
    "address": "85 Dean Rd",
    "parcel_id": "232-02-00",
    "owner1": "KURD, ALAN M",
    "owner2": "ESSELEN, KATHARINE M",
    "current_taxes": 31242.51,
    "new_taxes_no_override": 32592.19,
    "override_total_1": 33516.96,
    "override_increase_1": 924.78
  },
  {
    "#": "86 Dean Rd (245-05-00)",
    "$": 3875200,
    "address": "86 Dean Rd",
    "parcel_id": "245-05-00",
    "owner1": "TACKEFF, ROGER ELIOT & MARYANNE MONROE",
    "owner2": "",
    "current_taxes": 36047.11,
    "new_taxes_no_override": 37604.35,
    "override_total_1": 38671.34,
    "override_increase_1": 1066.99
  },
  {
    "#": "92 Dean Rd (245-04-00)",
    "$": 2401300,
    "address": "92 Dean Rd",
    "parcel_id": "245-04-00",
    "owner1": "SHAHROOZ TRS, SUSAN A & FARHAD",
    "owner2": "",
    "current_taxes": 24589.31,
    "new_taxes_no_override": 25651.57,
    "override_total_1": 26379.41,
    "override_increase_1": 727.84
  },
  {
    "#": "93 Dean Rd (232-03-00)",
    "$": 4552300,
    "address": "93 Dean Rd",
    "parcel_id": "232-03-00",
    "owner1": "CHOSLOVSKY TRS, MARLA",
    "owner2": "GREENBERG, PAUL E",
    "current_taxes": 42980.62,
    "new_taxes_no_override": 44837.38,
    "override_total_1": 46109.61,
    "override_increase_1": 1272.23
  },
  {
    "#": "96 Dean Rd (245-03-00)",
    "$": 3874100,
    "address": "96 Dean Rd",
    "parcel_id": "245-03-00",
    "owner1": "COMTOIS, MARCEL D",
    "owner2": "CROWLEY, MEREDITH ADAMS",
    "current_taxes": 36035.85,
    "new_taxes_no_override": 37592.6,
    "override_total_1": 38659.26,
    "override_increase_1": 1066.66
  },
  {
    "#": "101 Dean Rd (232-04-00)",
    "$": 3886700,
    "address": "101 Dean Rd",
    "parcel_id": "232-04-00",
    "owner1": "DONIKIAN, CLAUDINE A",
    "owner2": "BLAKE, CHRISTOPHER T",
    "current_taxes": 39799.81,
    "new_taxes_no_override": 41519.16,
    "override_total_1": 42697.24,
    "override_increase_1": 1178.07
  },
  {
    "#": "102 Dean Rd (243-06-00)",
    "$": 5198700,
    "address": "102 Dean Rd",
    "parcel_id": "243-06-00",
    "owner1": "KUTUZOV, MIKHAIL",
    "owner2": "",
    "current_taxes": 53234.69,
    "new_taxes_no_override": 55534.43,
    "override_total_1": 57110.18,
    "override_increase_1": 1575.75
  },
  {
    "#": "107 Dean Rd (240-07-00)",
    "$": 3957200,
    "address": "107 Dean Rd",
    "parcel_id": "240-07-00",
    "owner1": "TOMER, NADAV & DANIELA RUTH",
    "owner2": "",
    "current_taxes": 36886.79,
    "new_taxes_no_override": 38480.3,
    "override_total_1": 39572.15,
    "override_increase_1": 1091.85
  },
  {
    "#": "110 Dean Rd (243-05-00)",
    "$": 3134600,
    "address": "110 Dean Rd",
    "parcel_id": "243-05-00",
    "owner1": "KUZMAN ET AL, SYLVIA",
    "owner2": "CRAWFORD, BLAIR",
    "current_taxes": 32098.3,
    "new_taxes_no_override": 33484.95,
    "override_total_1": 34435.06,
    "override_increase_1": 950.11
  },
  {
    "#": "115 Dean Rd (240-08-00)",
    "$": 3048900,
    "address": "115 Dean Rd",
    "parcel_id": "240-08-00",
    "owner1": "GREATREX TRS, TONI S & ALEXANDRA",
    "owner2": "",
    "current_taxes": 31220.74,
    "new_taxes_no_override": 32569.48,
    "override_total_1": 33493.61,
    "override_increase_1": 924.13
  },
  {
    "#": "118 Dean Rd (243-04-00)",
    "$": 4530700,
    "address": "118 Dean Rd",
    "parcel_id": "243-04-00",
    "owner1": "",
    "owner2": "",
    "current_taxes": 42759.43,
    "new_taxes_no_override": 44606.64,
    "override_total_1": 45872.32,
    "override_increase_1": 1265.68
  },
  {
    "#": "123 Dean Rd (240-09-11)",
    "$": 3567800,
    "address": "123 Dean Rd",
    "parcel_id": "240-09-11",
    "owner1": "FLEGER-BERMAN TR, LINDA",
    "owner2": "",
    "current_taxes": 36534.27,
    "new_taxes_no_override": 38112.55,
    "override_total_1": 39193.96,
    "override_increase_1": 1081.41
  },
  {
    "#": "124 Dean Rd (243-03-00)",
    "$": 3897400,
    "address": "124 Dean Rd",
    "parcel_id": "243-03-00",
    "owner1": "KUTKA, MICHAEL",
    "owner2": "FENNESSEY, FIONA",
    "current_taxes": 36274.44,
    "new_taxes_no_override": 37841.5,
    "override_total_1": 38915.22,
    "override_increase_1": 1073.72
  },
  {
    "#": "129 Dean Rd (240-10-00)",
    "$": 4216800,
    "address": "129 Dean Rd",
    "parcel_id": "240-10-00",
    "owner1": "LENESS, ANTHONY H & KATHARINE B",
    "owner2": "",
    "current_taxes": 39545.1,
    "new_taxes_no_override": 41253.45,
    "override_total_1": 42423.98,
    "override_increase_1": 1170.53
  },
  {
    "#": "130 Dean Rd (243-02-00)",
    "$": 4386400,
    "address": "130 Dean Rd",
    "parcel_id": "243-02-00",
    "owner1": "DESAI  TRS, MAYUR M & SHILPA J",
    "owner2": "",
    "current_taxes": 41281.8,
    "new_taxes_no_override": 43065.17,
    "override_total_1": 44287.12,
    "override_increase_1": 1221.94
  },
  {
    "#": "156 Dean Rd (258-08-00)",
    "$": 4377000,
    "address": "156 Dean Rd",
    "parcel_id": "258-08-00",
    "owner1": "DANESH, HELEN K",
    "owner2": "",
    "current_taxes": 41185.55,
    "new_taxes_no_override": 42964.77,
    "override_total_1": 44183.86,
    "override_increase_1": 1219.09
  },
  {
    "#": "163 Dean Rd (241-02-01)",
    "$": 3622000,
    "address": "163 Dean Rd",
    "parcel_id": "241-02-01",
    "owner1": "ZOCCHI TR, MARY E",
    "owner2": "",
    "current_taxes": 37089.28,
    "new_taxes_no_override": 38691.54,
    "override_total_1": 39789.38,
    "override_increase_1": 1097.84
  },
  {
    "#": "164 Dean Rd (258-07-00)",
    "$": 5690600,
    "address": "164 Dean Rd",
    "parcel_id": "258-07-00",
    "owner1": "RUDERMAN, JAY & SHIRA",
    "owner2": "",
    "current_taxes": 54636.81,
    "new_taxes_no_override": 56997.12,
    "override_total_1": 58614.37,
    "override_increase_1": 1617.25
  },
  {
    "#": "172 Dean Rd (258-06-00)",
    "$": 4361200,
    "address": "172 Dean Rd",
    "parcel_id": "258-06-00",
    "owner1": "SABHARWAL TRS, SUMEET & VISHAKHA",
    "owner2": "",
    "current_taxes": 41023.75,
    "new_taxes_no_override": 42795.98,
    "override_total_1": 44010.28,
    "override_increase_1": 1214.3
  },
  {
    "#": "177 Dean Rd (242-01-00)",
    "$": 3594300,
    "address": "177 Dean Rd",
    "parcel_id": "242-01-00",
    "owner1": "CASTING TRS, TANES & CLOTILDE",
    "owner2": "",
    "current_taxes": 33170.7,
    "new_taxes_no_override": 34603.67,
    "override_total_1": 35585.53,
    "override_increase_1": 981.85
  },
  {
    "#": "184 Dean Rd (258-05-00)",
    "$": 4643300,
    "address": "184 Dean Rd",
    "parcel_id": "258-05-00",
    "owner1": "ROPER TR, MICHAEL J",
    "owner2": "",
    "current_taxes": 43912.46,
    "new_taxes_no_override": 45809.48,
    "override_total_1": 47109.29,
    "override_increase_1": 1299.81
  },
  {
    "#": "185 Dean Rd (242-02-00)",
    "$": 3497700,
    "address": "185 Dean Rd",
    "parcel_id": "242-02-00",
    "owner1": "TUCH, DAVID",
    "owner2": "WIEGELL, METTE",
    "current_taxes": 35816.45,
    "new_taxes_no_override": 37363.72,
    "override_total_1": 38423.89,
    "override_increase_1": 1060.17
  },
  {
    "#": "198 Dean Rd (267-18-00)",
    "$": 3496600,
    "address": "198 Dean Rd",
    "parcel_id": "267-18-00",
    "owner1": "SCHUSTER-YAMNITSKY TRS, JULIE",
    "owner2": "YAMNITSKY, BORIS",
    "current_taxes": 32170.25,
    "new_taxes_no_override": 33560.0,
    "override_total_1": 34512.24,
    "override_increase_1": 952.24
  },
  {
    "#": "199 Dean Rd (259-02-00)",
    "$": 2908700,
    "address": "199 Dean Rd",
    "parcel_id": "259-02-00",
    "owner1": "SHAHROOZ, KAMYAR & DEENA",
    "owner2": "",
    "current_taxes": 26150.15,
    "new_taxes_no_override": 27279.84,
    "override_total_1": 28053.88,
    "override_increase_1": 774.04
  },
  {
    "#": "207 Dean Rd (259-03-00)",
    "$": 3964200,
    "address": "207 Dean Rd",
    "parcel_id": "259-03-00",
    "owner1": "MULLIKEN, JOHN",
    "owner2": "CHERNOCK, ARIANNE",
    "current_taxes": 36958.47,
    "new_taxes_no_override": 38555.08,
    "override_total_1": 39649.05,
    "override_increase_1": 1093.97
  },
  {
    "#": "212 Dean Rd (267-17-00)",
    "$": 3419700,
    "address": "212 Dean Rd",
    "parcel_id": "267-17-00",
    "owner1": "MOREMEN, PHILIP M",
    "owner2": "MORGAN, A MITRA",
    "current_taxes": 31382.79,
    "new_taxes_no_override": 32738.53,
    "override_total_1": 33667.46,
    "override_increase_1": 928.93
  },
  {
    "#": "228 Dean Rd (267-12-13)",
    "$": 3378000,
    "address": "228 Dean Rd",
    "parcel_id": "267-12-13",
    "owner1": "ZELKHA, MOUSSA",
    "owner2": "SANIEOFF, PARVANEH",
    "current_taxes": 30955.79,
    "new_taxes_no_override": 32293.08,
    "override_total_1": 33209.37,
    "override_increase_1": 916.29
  },
  {
    "#": "237 Dean Rd (260-04-00)",
    "$": 3621200,
    "address": "237 Dean Rd",
    "parcel_id": "260-04-00",
    "owner1": "THALER, MATTHEW",
    "owner2": "SEGEL, MARISA",
    "current_taxes": 33446.15,
    "new_taxes_no_override": 34891.02,
    "override_total_1": 35881.03,
    "override_increase_1": 990.01
  },
  {
    "#": "240 Dean Rd (267-11-00)",
    "$": 3925300,
    "address": "240 Dean Rd",
    "parcel_id": "267-11-00",
    "owner1": "LEE, DANIEL J",
    "owner2": "",
    "current_taxes": 36560.14,
    "new_taxes_no_override": 38139.54,
    "override_total_1": 39221.72,
    "override_increase_1": 1082.18
  },
  {
    "#": "249 Dean Rd (261-02-00)",
    "$": 3106900,
    "address": "249 Dean Rd",
    "parcel_id": "261-02-00",
    "owner1": "ROSENTHAL TRS, DAVID S & SALLY ABRAHMS",
    "owner2": "",
    "current_taxes": 28179.72,
    "new_taxes_no_override": 29397.08,
    "override_total_1": 30231.2,
    "override_increase_1": 834.12
  },
  {
    "#": "250 Dean Rd (267-10-00)",
    "$": 2866400,
    "address": "250 Dean Rd",
    "parcel_id": "267-10-00",
    "owner1": "HUTCHISON, WARREN D & JANET V",
    "owner2": "",
    "current_taxes": 25717.0,
    "new_taxes_no_override": 26827.97,
    "override_total_1": 27589.2,
    "override_increase_1": 761.22
  },
  {
    "#": "257 Dean Rd (261-03-00)",
    "$": 2536400,
    "address": "257 Dean Rd",
    "parcel_id": "261-03-00",
    "owner1": "CHANG, KUN-TEE",
    "owner2": "",
    "current_taxes": 22337.8,
    "new_taxes_no_override": 23302.79,
    "override_total_1": 23963.99,
    "override_increase_1": 661.2
  },
  {
    "#": "260 Dean Rd (267-09-00)",
    "$": 3561900,
    "address": "260 Dean Rd",
    "parcel_id": "267-09-00",
    "owner1": "LAUREATE BW 2150 LLC",
    "owner2": "C/O LAW OFFICE OF Z TAN PLCC 110 - SANHAN HUNG",
    "current_taxes": 36473.86,
    "new_taxes_no_override": 38049.53,
    "override_total_1": 39129.16,
    "override_increase_1": 1079.63
  },
  {
    "#": "265 Dean Rd (261-04-00)",
    "$": 3825400,
    "address": "265 Dean Rd",
    "parcel_id": "261-04-00",
    "owner1": "GEENTY, JONATHAN & KELLY",
    "owner2": "",
    "current_taxes": 35537.16,
    "new_taxes_no_override": 37072.37,
    "override_total_1": 38124.27,
    "override_increase_1": 1051.9
  },
  {
    "#": "266 Dean Rd (267-08-00)",
    "$": 2724300,
    "address": "266 Dean Rd",
    "parcel_id": "267-08-00",
    "owner1": "ANDREE, FREDERICK W H & DEBORAH",
    "owner2": "",
    "current_taxes": 24261.9,
    "new_taxes_no_override": 25310.01,
    "override_total_1": 26028.17,
    "override_increase_1": 718.15
  },
  {
    "#": "271 Dean Rd (261-05-00)",
    "$": 3729800,
    "address": "271 Dean Rd",
    "parcel_id": "261-05-00",
    "owner1": "HABER, EDWARD F",
    "owner2": "LOGAN, JAMIE",
    "current_taxes": 34558.22,
    "new_taxes_no_override": 36051.14,
    "override_total_1": 37074.06,
    "override_increase_1": 1022.92
  },
  {
    "#": "274 Dean Rd (267-07-00)",
    "$": 3030200,
    "address": "274 Dean Rd",
    "parcel_id": "267-07-00",
    "owner1": "HAMBLETT, CHRISTOPHER L",
    "owner2": "",
    "current_taxes": 27394.31,
    "new_taxes_no_override": 28577.74,
    "override_total_1": 29388.62,
    "override_increase_1": 810.87
  },
  {
    "#": "275 Dean Rd (261-06-00)",
    "$": 3321400,
    "address": "275 Dean Rd",
    "parcel_id": "261-06-00",
    "owner1": "KRAVETZ, SHAWN W & JILL R",
    "owner2": "",
    "current_taxes": 30376.2,
    "new_taxes_no_override": 31688.45,
    "override_total_1": 32587.59,
    "override_increase_1": 899.14
  },
  {
    "#": "284 Dean Rd (267-06-00)",
    "$": 3155000,
    "address": "284 Dean Rd",
    "parcel_id": "267-06-00",
    "owner1": "ROCKEFELLER, LISA ANDERSON",
    "owner2": "SEBELIUS, EDWARD KEITH",
    "current_taxes": 32307.2,
    "new_taxes_no_override": 33702.87,
    "override_total_1": 34659.16,
    "override_increase_1": 956.29
  },
  {
    "#": "285 Dean Rd (261-07-00)",
    "$": 3105600,
    "address": "285 Dean Rd",
    "parcel_id": "261-07-00",
    "owner1": "REID, SCOTT K",
    "owner2": "CHOU, MARY TAO-PEI",
    "current_taxes": 28166.41,
    "new_taxes_no_override": 29383.2,
    "override_total_1": 30216.92,
    "override_increase_1": 833.73
  },
  {
    "#": "294 Dean Rd (267-05-00)",
    "$": 3932700,
    "address": "294 Dean Rd",
    "parcel_id": "267-05-00",
    "owner1": "DYKEMAN TRS, DAVID J & DANIELLE E",
    "owner2": "",
    "current_taxes": 36635.91,
    "new_taxes_no_override": 38218.58,
    "override_total_1": 39303.0,
    "override_increase_1": 1084.42
  },
  {
    "#": "302 Dean Rd (267-04-00)",
    "$": 3078800,
    "address": "302 Dean Rd",
    "parcel_id": "267-04-00",
    "owner1": "CHEN, TR, MARTHA A",
    "owner2": "",
    "current_taxes": 31526.91,
    "new_taxes_no_override": 32888.87,
    "override_total_1": 33822.07,
    "override_increase_1": 933.2
  },
  {
    "#": "305 Dean Rd (264C-07-00)",
    "$": 3029900,
    "address": "305 Dean Rd",
    "parcel_id": "264C-07-00",
    "owner1": "SANIEOFF, ASHKAN",
    "owner2": "",
    "current_taxes": 31026.18,
    "new_taxes_no_override": 32366.51,
    "override_total_1": 33284.89,
    "override_increase_1": 918.37
  },
  {
    "#": "311 Dean Rd (264C-08-00)",
    "$": 3413100,
    "address": "311 Dean Rd",
    "parcel_id": "264C-08-00",
    "owner1": "ASCHKENASY TR, MIRIAM T",
    "owner2": "",
    "current_taxes": 31315.21,
    "new_taxes_no_override": 32668.03,
    "override_total_1": 33594.96,
    "override_increase_1": 926.93
  },
  {
    "#": "312 Dean Rd (267-02-03)",
    "$": 4457000,
    "address": "312 Dean Rd",
    "parcel_id": "267-02-03",
    "owner1": "CHEN, YEN-LIN E",
    "owner2": "DO, DAIHUNG V",
    "current_taxes": 42004.75,
    "new_taxes_no_override": 43819.36,
    "override_total_1": 45062.7,
    "override_increase_1": 1243.34
  },
  {
    "#": "319 Dean Rd (264C-09-00)",
    "$": 3339100,
    "address": "319 Dean Rd",
    "parcel_id": "264C-09-00",
    "owner1": "DEVENS, WILLIAM & SHANNON",
    "owner2": "",
    "current_taxes": 30557.45,
    "new_taxes_no_override": 31877.53,
    "override_total_1": 32782.03,
    "override_increase_1": 904.5
  },
  {
    "#": "9 Denny Rd (278D-11-00)",
    "$": 3769800,
    "address": "9 Denny Rd",
    "parcel_id": "278D-11-00",
    "owner1": "PILGRIM, DAVID M",
    "owner2": "RAWLINS, KIMBERLY",
    "current_taxes": 34967.82,
    "new_taxes_no_override": 36478.43,
    "override_total_1": 37513.48,
    "override_increase_1": 1035.05
  },
  {
    "#": "19 Denny Rd (278D-12-00)",
    "$": 3453200,
    "address": "19 Denny Rd",
    "parcel_id": "278D-12-00",
    "owner1": "CORN, RICHARD I",
    "owner2": "FOX, JANIS H",
    "current_taxes": 31725.83,
    "new_taxes_no_override": 33096.39,
    "override_total_1": 34035.47,
    "override_increase_1": 939.08
  },
  {
    "#": "28 Denny Rd (278B-10-00)",
    "$": 3183600,
    "address": "28 Denny Rd",
    "parcel_id": "278B-10-00",
    "owner1": "CLAY, BRIAN & JULIA",
    "owner2": "",
    "current_taxes": 28965.13,
    "new_taxes_no_override": 30216.42,
    "override_total_1": 31073.79,
    "override_increase_1": 857.37
  },
  {
    "#": "29 Denny Rd (278D-13-00)",
    "$": 2822200,
    "address": "29 Denny Rd",
    "parcel_id": "278D-13-00",
    "owner1": "DAHMEN, LLOYD C & GENE D",
    "owner2": "",
    "current_taxes": 25264.39,
    "new_taxes_no_override": 26355.81,
    "override_total_1": 27103.64,
    "override_increase_1": 747.83
  },
  {
    "#": "36 Denny Rd (278B-09-00)",
    "$": 3568800,
    "address": "36 Denny Rd",
    "parcel_id": "278B-09-00",
    "owner1": "KARLEN, JON E & FRANCES W",
    "owner2": "",
    "current_taxes": 32909.58,
    "new_taxes_no_override": 34331.27,
    "override_total_1": 35305.4,
    "override_increase_1": 974.12
  },
  {
    "#": "39 Denny Rd (278D-13-01)",
    "$": 2239300,
    "address": "39 Denny Rd",
    "parcel_id": "278D-13-01",
    "owner1": "LADD, JAMES E",
    "owner2": "",
    "current_taxes": 22930.43,
    "new_taxes_no_override": 23921.02,
    "override_total_1": 24599.77,
    "override_increase_1": 678.74
  },
  {
    "#": "48 Denny Rd (278B-08-00)",
    "$": 2978800,
    "address": "48 Denny Rd",
    "parcel_id": "278B-08-00",
    "owner1": "BAGNANI TRS, DAVID A & ELIZABETH S",
    "owner2": "",
    "current_taxes": 26867.98,
    "new_taxes_no_override": 28028.68,
    "override_total_1": 28823.97,
    "override_increase_1": 795.29
  },
  {
    "#": "59 Denny Rd (278D-14-01)",
    "$": 2813200,
    "address": "59 Denny Rd",
    "parcel_id": "278D-14-01",
    "owner1": "LAWRENCE TR, EDWARD P",
    "owner2": "C/O AMES MARY",
    "current_taxes": 28807.17,
    "new_taxes_no_override": 30051.64,
    "override_total_1": 30904.33,
    "override_increase_1": 852.69
  },
  {
    "#": "60 Denny Rd (278B-07-00)",
    "$": 4189600,
    "address": "60 Denny Rd",
    "parcel_id": "278B-07-00",
    "owner1": "RUBYSUROCK LLC",
    "owner2": "",
    "current_taxes": 39266.57,
    "new_taxes_no_override": 40962.89,
    "override_total_1": 42125.18,
    "override_increase_1": 1162.29
  },
  {
    "#": "69 Denny Rd (278D-15-00)",
    "$": 5487700,
    "address": "69 Denny Rd",
    "parcel_id": "278D-15-00",
    "owner1": "KHAN, BADAR",
    "owner2": "HAQUE, MASARATH",
    "current_taxes": 56194.05,
    "new_taxes_no_override": 58621.63,
    "override_total_1": 60284.98,
    "override_increase_1": 1663.34
  },
  {
    "#": "76 Denny Rd (278B-06-00)",
    "$": 4702900,
    "address": "76 Denny Rd",
    "parcel_id": "278B-06-00",
    "owner1": "BROWN, STUART & INGVILD",
    "owner2": "",
    "current_taxes": 48157.7,
    "new_taxes_no_override": 50238.11,
    "override_total_1": 51663.58,
    "override_increase_1": 1425.47
  },
  {
    "#": "11 Devon Rd (284-01-00)",
    "$": 14800,
    "address": "11 Devon Rd",
    "parcel_id": "284-01-00",
    "owner1": "ZINK, BRAXTON W & ANDRINA WILLIAMS",
    "owner2": "",
    "current_taxes": 151.55,
    "new_taxes_no_override": 158.1,
    "override_total_1": 162.58,
    "override_increase_1": 4.49
  },
  {
    "#": "17 Devon Rd (284-02-00)",
    "$": 4077300,
    "address": "17 Devon Rd",
    "parcel_id": "284-02-00",
    "owner1": "LAVALLEE, DAVID G & CHRISTINA M",
    "owner2": "",
    "current_taxes": 38116.62,
    "new_taxes_no_override": 39763.26,
    "override_total_1": 40891.51,
    "override_increase_1": 1128.25
  },
  {
    "#": "27 Devon Rd (284-03-04)",
    "$": 4312700,
    "address": "27 Devon Rd",
    "parcel_id": "284-03-04",
    "owner1": "CHAN, I TSENG",
    "owner2": "PI, HAO TAN",
    "current_taxes": 40527.11,
    "new_taxes_no_override": 42277.88,
    "override_total_1": 43477.48,
    "override_increase_1": 1199.6
  },
  {
    "#": "37 Devon Rd (284-05-00)",
    "$": 2848000,
    "address": "37 Devon Rd",
    "parcel_id": "284-05-00",
    "owner1": "FARRINGTON  TRS, CHARLES F JR  & ANNE S",
    "owner2": "",
    "current_taxes": 25528.59,
    "new_taxes_no_override": 26631.43,
    "override_total_1": 27387.07,
    "override_increase_1": 755.65
  },
  {
    "#": "38 Devon Rd (283-06-00)",
    "$": 4392200,
    "address": "38 Devon Rd",
    "parcel_id": "283-06-00",
    "owner1": "KAPUSTA, MATTHEW C & LORNA R",
    "owner2": "",
    "current_taxes": 41341.19,
    "new_taxes_no_override": 43127.13,
    "override_total_1": 44350.83,
    "override_increase_1": 1223.7
  },
  {
    "#": "45 Devon Rd (284-06-00)",
    "$": 6194900,
    "address": "45 Devon Rd",
    "parcel_id": "284-06-00",
    "owner1": "HALFPENNY, DAVID M",
    "owner2": "WEITZEL, MARY M",
    "current_taxes": 63435.78,
    "new_taxes_no_override": 66176.21,
    "override_total_1": 68053.9,
    "override_increase_1": 1877.7
  },
  {
    "#": "48 Devon Rd (283-05-00)",
    "$": 3791500,
    "address": "48 Devon Rd",
    "parcel_id": "283-05-00",
    "owner1": "OLSEN, ELIZABETH B H& JOHN M III",
    "owner2": "",
    "current_taxes": 35190.03,
    "new_taxes_no_override": 36710.24,
    "override_total_1": 37751.86,
    "override_increase_1": 1041.62
  },
  {
    "#": "55 Devon Rd (284-07-00)",
    "$": 5973800,
    "address": "55 Devon Rd",
    "parcel_id": "284-07-00",
    "owner1": "CURRY, WILLIAM T JR",
    "owner2": "NORDHAUS, REBECCA",
    "current_taxes": 57536.78,
    "new_taxes_no_override": 60022.37,
    "override_total_1": 61725.46,
    "override_increase_1": 1703.09
  },
  {
    "#": "7 Devotion St (049-15-01)",
    "$": 2557400,
    "address": "7 Devotion St",
    "parcel_id": "049-15-01",
    "owner1": "GIBCO II REALTY LLC",
    "owner2": "",
    "current_taxes": 26187.78,
    "new_taxes_no_override": 27319.09,
    "override_total_1": 28094.25,
    "override_increase_1": 775.16
  },
  {
    "#": "9 Devotion St (049-16-00)",
    "$": 2698900,
    "address": "9 Devotion St",
    "parcel_id": "049-16-00",
    "owner1": "KCEKOB LLC",
    "owner2": "",
    "current_taxes": 27636.74,
    "new_taxes_no_override": 28830.65,
    "override_total_1": 29648.69,
    "override_increase_1": 818.05
  },
  {
    "#": "19 Devotion St (049-10-00)",
    "$": 6538700,
    "address": "19 Devotion St",
    "parcel_id": "049-10-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O COOLIDGE CORNER SCHOOL PLAYGROUND",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "9 Doran Rd, Unit 1 (267-29-01)",
    "$": 1421700,
    "address": "9 Doran Rd, Unit 1",
    "parcel_id": "267-29-01",
    "owner1": "ANTHONY, JODI",
    "owner2": "",
    "current_taxes": 10923.27,
    "new_taxes_no_override": 11395.16,
    "override_total_1": 11718.48,
    "override_increase_1": 323.33
  },
  {
    "#": "9 Doran Rd, Unit 2 (267-29-02)",
    "$": 1411900,
    "address": "9 Doran Rd, Unit 2",
    "parcel_id": "267-29-02",
    "owner1": "ROBERTS, NATHALIE & THADDEUS",
    "owner2": "",
    "current_taxes": 10822.92,
    "new_taxes_no_override": 11290.47,
    "override_total_1": 11610.83,
    "override_increase_1": 320.36
  },
  {
    "#": "14 Doran Rd (268-03-00)",
    "$": 1245300,
    "address": "14 Doran Rd",
    "parcel_id": "268-03-00",
    "owner1": "BERDE TRS, CHARLES B & EVELYN M",
    "owner2": "",
    "current_taxes": 9116.94,
    "new_taxes_no_override": 9510.79,
    "override_total_1": 9780.65,
    "override_increase_1": 269.86
  },
  {
    "#": "15 Doran Rd (267-31-00)",
    "$": 1170300,
    "address": "15 Doran Rd",
    "parcel_id": "267-31-00",
    "owner1": "O`DEA, MARGO E",
    "owner2": "",
    "current_taxes": 8348.94,
    "new_taxes_no_override": 8709.61,
    "override_total_1": 8956.74,
    "override_increase_1": 247.13
  },
  {
    "#": "15 Doran Rd (267-32-00)",
    "$": 1188900,
    "address": "15 Doran Rd",
    "parcel_id": "267-32-00",
    "owner1": "BAJWA, YOUSAF",
    "owner2": "KOCHINKE, SAVANNAH",
    "current_taxes": 12174.34,
    "new_taxes_no_override": 12700.27,
    "override_total_1": 13060.63,
    "override_increase_1": 360.36
  },
  {
    "#": "15 Doran Rd (267-33-00)",
    "$": 1108200,
    "address": "15 Doran Rd",
    "parcel_id": "267-33-00",
    "owner1": "WILLIAMS ET AL, WILLIAM G",
    "owner2": "DORAN RD LLC",
    "current_taxes": 7713.03,
    "new_taxes_no_override": 8046.23,
    "override_total_1": 8274.54,
    "override_increase_1": 228.31
  },
  {
    "#": "17 Doran Rd (267-34-00)",
    "$": 1968400,
    "address": "17 Doran Rd",
    "parcel_id": "267-34-00",
    "owner1": "EPSTEIN, MICHAEL & GALINA",
    "owner2": "GOLDMAN, ALENA",
    "current_taxes": 16521.48,
    "new_taxes_no_override": 17235.21,
    "override_total_1": 17724.24,
    "override_increase_1": 489.04
  },
  {
    "#": "18 Doran Rd, Unit 18 (268-02-01)",
    "$": 1523600,
    "address": "18 Doran Rd, Unit 18",
    "parcel_id": "268-02-01",
    "owner1": "PRATT, STEPHEN",
    "owner2": "",
    "current_taxes": 11966.73,
    "new_taxes_no_override": 12483.69,
    "override_total_1": 12837.91,
    "override_increase_1": 354.22
  },
  {
    "#": "18 Doran Rd, Unit 20 (268-02-02)",
    "$": 1391600,
    "address": "18 Doran Rd, Unit 20",
    "parcel_id": "268-02-02",
    "owner1": "HUFFMAN, BRANDON MICHAEL & CHELSEY",
    "owner2": "",
    "current_taxes": 10615.05,
    "new_taxes_no_override": 11073.62,
    "override_total_1": 11387.83,
    "override_increase_1": 314.21
  },
  {
    "#": "21 Doran Rd (267-35-00)",
    "$": 1403100,
    "address": "21 Doran Rd",
    "parcel_id": "267-35-00",
    "owner1": "BEZZERIDES, ANN M & VASSILIOS",
    "owner2": "",
    "current_taxes": 10732.81,
    "new_taxes_no_override": 11196.47,
    "override_total_1": 11514.16,
    "override_increase_1": 317.69
  },
  {
    "#": "5 Downing Rd (095-04-01)",
    "$": 2124100,
    "address": "5 Downing Rd",
    "parcel_id": "095-04-01",
    "owner1": "MUSMON, LINDA M Y & EDWARD M",
    "owner2": "",
    "current_taxes": 18115.85,
    "new_taxes_no_override": 18898.45,
    "override_total_1": 19434.68,
    "override_increase_1": 536.23
  },
  {
    "#": "9 Downing Rd (095-05-00)",
    "$": 3393300,
    "address": "9 Downing Rd",
    "parcel_id": "095-05-00",
    "owner1": "BURNS TRS, PADRAIC",
    "owner2": "",
    "current_taxes": 31112.46,
    "new_taxes_no_override": 32456.52,
    "override_total_1": 33377.45,
    "override_increase_1": 920.93
  },
  {
    "#": "10 Downing Rd (096-09-00)",
    "$": 3026300,
    "address": "10 Downing Rd",
    "parcel_id": "096-09-00",
    "owner1": "ABUELO, CAROLINA",
    "owner2": "LEARY, JONATHAN",
    "current_taxes": 27354.38,
    "new_taxes_no_override": 28536.09,
    "override_total_1": 29345.78,
    "override_increase_1": 809.69
  },
  {
    "#": "16 Downing Rd (096-08-00)",
    "$": 3192000,
    "address": "16 Downing Rd",
    "parcel_id": "096-08-00",
    "owner1": "LEVIN, PETER D",
    "owner2": "KAUFMAN, SAMARA L",
    "current_taxes": 29051.15,
    "new_taxes_no_override": 30306.16,
    "override_total_1": 31166.07,
    "override_increase_1": 859.91
  },
  {
    "#": "25 Downing Rd (097-06-00)",
    "$": 2798800,
    "address": "25 Downing Rd",
    "parcel_id": "097-06-00",
    "owner1": "ABRAMSON TR, MURRAY A",
    "owner2": "",
    "current_taxes": 25024.78,
    "new_taxes_no_override": 26105.85,
    "override_total_1": 26846.58,
    "override_increase_1": 740.73
  },
  {
    "#": "26 Downing Rd (096-07-00)",
    "$": 2453300,
    "address": "26 Downing Rd",
    "parcel_id": "096-07-00",
    "owner1": "KLEIN, ALLON M & ROOHIA",
    "owner2": "",
    "current_taxes": 25121.79,
    "new_taxes_no_override": 26207.05,
    "override_total_1": 26950.66,
    "override_increase_1": 743.6
  },
  {
    "#": "5 Druce St (240-06-00)",
    "$": 4816300,
    "address": "5 Druce St",
    "parcel_id": "240-06-00",
    "owner1": "MCELROY, MICHAEL & ROSEMARY",
    "owner2": "",
    "current_taxes": 45683.98,
    "new_taxes_no_override": 47657.53,
    "override_total_1": 49009.77,
    "override_increase_1": 1352.25
  },
  {
    "#": "8 Druce St (232-06-00)",
    "$": 3598500,
    "address": "8 Druce St",
    "parcel_id": "232-06-00",
    "owner1": "HOOGASIAN, SETH",
    "owner2": "",
    "current_taxes": 36848.64,
    "new_taxes_no_override": 38440.5,
    "override_total_1": 39531.22,
    "override_increase_1": 1090.72
  },
  {
    "#": "12 Druce St (232-05-00)",
    "$": 2566600,
    "address": "12 Druce St",
    "parcel_id": "232-05-00",
    "owner1": "ACAR, ARTUG",
    "owner2": "SMITH, LORIE",
    "current_taxes": 26281.98,
    "new_taxes_no_override": 27417.36,
    "override_total_1": 28195.31,
    "override_increase_1": 777.95
  },
  {
    "#": "36 Druce St (245-02-00)",
    "$": 3626400,
    "address": "36 Druce St",
    "parcel_id": "245-02-00",
    "owner1": "GREEN, BENJAMIN & CELIA",
    "owner2": "",
    "current_taxes": 33499.4,
    "new_taxes_no_override": 34946.57,
    "override_total_1": 35938.16,
    "override_increase_1": 991.58
  },
  {
    "#": "43 Druce St (243-07-00)",
    "$": 3278800,
    "address": "43 Druce St",
    "parcel_id": "243-07-00",
    "owner1": "FARZANEH-FAR, RAMIN",
    "owner2": "TARTER, LAURA",
    "current_taxes": 29939.98,
    "new_taxes_no_override": 31233.39,
    "override_total_1": 32119.61,
    "override_increase_1": 886.22
  },
  {
    "#": "50 Druce St (245-01-00)",
    "$": 46430900,
    "address": "50 Druce St",
    "parcel_id": "245-01-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O RUNKLE SCHOOL",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "79 Druce St (244-05-00)",
    "$": 3900000,
    "address": "79 Druce St",
    "parcel_id": "244-05-00",
    "owner1": "HARTZBAND TRS, PAMELA IRENE",
    "owner2": "GROOPMAN , JEROME ELLIOT",
    "current_taxes": 36301.07,
    "new_taxes_no_override": 37869.28,
    "override_total_1": 38943.79,
    "override_increase_1": 1074.51
  },
  {
    "#": "1 Dudley St (325-09-00)",
    "$": 6461400,
    "address": "1 Dudley St",
    "parcel_id": "325-09-00",
    "owner1": "ROSENZWEIG, FRANCINE & DAVID M",
    "owner2": "",
    "current_taxes": 62529.8,
    "new_taxes_no_override": 65231.09,
    "override_total_1": 67081.97,
    "override_increase_1": 1850.88
  },
  {
    "#": "20 Dudley St (326-01-03)",
    "$": 4179100,
    "address": "20 Dudley St",
    "parcel_id": "326-01-03",
    "owner1": "DARBELOFF TRS, MATTHEW A & BRIT J",
    "owner2": "",
    "current_taxes": 39159.05,
    "new_taxes_no_override": 40850.72,
    "override_total_1": 42009.83,
    "override_increase_1": 1159.11
  },
  {
    "#": "23 Dudley St (325-01-00)",
    "$": 3681300,
    "address": "23 Dudley St",
    "parcel_id": "325-01-00",
    "owner1": "MORGAN, CRAIG A & SUJEY",
    "owner2": "",
    "current_taxes": 34061.58,
    "new_taxes_no_override": 35533.04,
    "override_total_1": 36541.26,
    "override_increase_1": 1008.22
  },
  {
    "#": "30 Dudley St (326-23-00)",
    "$": 3395100,
    "address": "30 Dudley St",
    "parcel_id": "326-23-00",
    "owner1": "WEIL, BRENT RICHARD & LISA MARIE WISMAN",
    "owner2": "",
    "current_taxes": 34765.82,
    "new_taxes_no_override": 36267.7,
    "override_total_1": 37296.77,
    "override_increase_1": 1029.07
  },
  {
    "#": "46 Dudley St (326-21-22)",
    "$": 8271300,
    "address": "46 Dudley St",
    "parcel_id": "326-21-22",
    "owner1": "GERSTNER, ELIZABETH",
    "owner2": "LAKDAWALA, NEAL",
    "current_taxes": 84698.11,
    "new_taxes_no_override": 88357.07,
    "override_total_1": 90864.13,
    "override_increase_1": 2507.06
  },
  {
    "#": "54 Dudley St (326-20-09)",
    "$": 4466200,
    "address": "54 Dudley St",
    "parcel_id": "326-20-09",
    "owner1": "COMSTOCK, MARY B",
    "owner2": "",
    "current_taxes": 42098.95,
    "new_taxes_no_override": 43917.62,
    "override_total_1": 45163.75,
    "override_increase_1": 1246.13
  },
  {
    "#": "64 Dudley St (326-19-00)",
    "$": 8407600,
    "address": "64 Dudley St",
    "parcel_id": "326-19-00",
    "owner1": "SIKORA, BROOKE",
    "owner2": "GEHRE, LARS",
    "current_taxes": 86093.82,
    "new_taxes_no_override": 89813.07,
    "override_total_1": 92361.45,
    "override_increase_1": 2548.38
  },
  {
    "#": "68 Dudley St (326-10-00)",
    "$": 4507100,
    "address": "68 Dudley St",
    "parcel_id": "326-10-00",
    "owner1": "O`BRIEN TR, PATRICIA",
    "owner2": "BADARACCO, JOSEPH L JR",
    "current_taxes": 42517.77,
    "new_taxes_no_override": 44354.54,
    "override_total_1": 45613.06,
    "override_increase_1": 1258.53
  },
  {
    "#": "80 Dudley St (326-18-00)",
    "$": 7874000,
    "address": "80 Dudley St",
    "parcel_id": "326-18-00",
    "owner1": "MERRILL TR, MICHAEL W",
    "owner2": "",
    "current_taxes": 80629.76,
    "new_taxes_no_override": 84112.97,
    "override_total_1": 86499.61,
    "override_increase_1": 2386.64
  },
  {
    "#": "92 Dudley St (326-16-05)",
    "$": 4673800,
    "address": "92 Dudley St",
    "parcel_id": "326-16-05",
    "owner1": "CLAYTON, PAUL B & HILDETE F",
    "owner2": "",
    "current_taxes": 44224.78,
    "new_taxes_no_override": 46135.29,
    "override_total_1": 47444.34,
    "override_increase_1": 1309.05
  },
  {
    "#": "94 Dudley St, Unit 1 & 2 Pksp (326-16-01)",
    "$": 1159500,
    "address": "94 Dudley St, Unit 1 & 2 Pksp",
    "parcel_id": "326-16-01",
    "owner1": "LEVY, YALI",
    "owner2": "LIPINER, MAAYAN",
    "current_taxes": 8238.35,
    "new_taxes_no_override": 8594.25,
    "override_total_1": 8838.1,
    "override_increase_1": 243.86
  },
  {
    "#": "94 Dudley St, Unit 2 & 2 Pksp (326-16-02)",
    "$": 1144600,
    "address": "94 Dudley St, Unit 2 & 2 Pksp",
    "parcel_id": "326-16-02",
    "owner1": "LEVY, YALI",
    "owner2": "LIPINER, MAAYAN",
    "current_taxes": 11720.7,
    "new_taxes_no_override": 12227.03,
    "override_total_1": 12573.97,
    "override_increase_1": 346.93
  },
  {
    "#": "94 Dudley St, Unit 3 & 2 Pksp (326-16-03)",
    "$": 1152200,
    "address": "94 Dudley St, Unit 3 & 2 Pksp",
    "parcel_id": "326-16-03",
    "owner1": "CABOT TR, MARGARET R",
    "owner2": "",
    "current_taxes": 11798.53,
    "new_taxes_no_override": 12308.23,
    "override_total_1": 12657.46,
    "override_increase_1": 349.24
  },
  {
    "#": "111 Dudley St (324-10-00)",
    "$": 28428300,
    "address": "111 Dudley St",
    "parcel_id": "324-10-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O RESERVOIR PARK",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "112 Dudley St (326-15-00)",
    "$": 3568800,
    "address": "112 Dudley St",
    "parcel_id": "326-15-00",
    "owner1": "REUNING, CHRISTOPHER",
    "owner2": "KIM, MIN JUNG",
    "current_taxes": 32909.58,
    "new_taxes_no_override": 34331.27,
    "override_total_1": 35305.4,
    "override_increase_1": 974.12
  },
  {
    "#": "128 Dudley St (334-30-00)",
    "$": 2406500,
    "address": "128 Dudley St",
    "parcel_id": "334-30-00",
    "owner1": "HARRINGTON, MAUREEN",
    "owner2": "",
    "current_taxes": 24642.56,
    "new_taxes_no_override": 25707.12,
    "override_total_1": 26436.54,
    "override_increase_1": 729.42
  },
  {
    "#": "140 Dudley St (334-29-00)",
    "$": 3013800,
    "address": "140 Dudley St",
    "parcel_id": "334-29-00",
    "owner1": "HARRINGTON, MAUREEN ANN",
    "owner2": "",
    "current_taxes": 27226.38,
    "new_taxes_no_override": 28402.56,
    "override_total_1": 29208.46,
    "override_increase_1": 805.9
  },
  {
    "#": "145 Dudley St (335-01-00)",
    "$": 457600,
    "address": "145 Dudley St",
    "parcel_id": "335-01-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O DUDLEY TRIANGLE",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "150 Dudley St (334-27-28)",
    "$": 3319300,
    "address": "150 Dudley St",
    "parcel_id": "334-27-28",
    "owner1": "LANCASTRE, MANUEL",
    "owner2": "",
    "current_taxes": 30354.7,
    "new_taxes_no_override": 31666.02,
    "override_total_1": 32564.52,
    "override_increase_1": 898.5
  },
  {
    "#": "170 Dudley St (334-26-00)",
    "$": 2452600,
    "address": "170 Dudley St",
    "parcel_id": "334-26-00",
    "owner1": "MALONEY, BRIAN A & SANDRA M",
    "owner2": "",
    "current_taxes": 21479.69,
    "new_taxes_no_override": 22407.61,
    "override_total_1": 23043.41,
    "override_increase_1": 635.8
  },
  {
    "#": "178 Dudley St (334-25-00)",
    "$": 3222600,
    "address": "178 Dudley St",
    "parcel_id": "334-25-00",
    "owner1": "CHEN, XINGGUO",
    "owner2": "WU, QIONG",
    "current_taxes": 29364.49,
    "new_taxes_no_override": 30633.04,
    "override_total_1": 31502.22,
    "override_increase_1": 869.19
  },
  {
    "#": "190 Dudley St (334-23-00)",
    "$": 3055400,
    "address": "190 Dudley St",
    "parcel_id": "334-23-00",
    "owner1": "RYAN TR, SCOTT",
    "owner2": "",
    "current_taxes": 27652.36,
    "new_taxes_no_override": 28846.94,
    "override_total_1": 29665.45,
    "override_increase_1": 818.51
  },
  {
    "#": "200 Dudley St (334-22-00)",
    "$": 2252000,
    "address": "200 Dudley St",
    "parcel_id": "334-22-00",
    "owner1": "DEVON, BRUCE",
    "owner2": "VERONICA, N N",
    "current_taxes": 19425.55,
    "new_taxes_no_override": 20264.73,
    "override_total_1": 20839.73,
    "override_increase_1": 575.0
  },
  {
    "#": "226 Dudley St (350-19-20)",
    "$": 8271000,
    "address": "226 Dudley St",
    "parcel_id": "350-19-20",
    "owner1": "FARBER, LISA M & CHARLES W",
    "owner2": "",
    "current_taxes": 81060.11,
    "new_taxes_no_override": 84561.91,
    "override_total_1": 86961.29,
    "override_increase_1": 2399.38
  },
  {
    "#": "240 Dudley St (350-18-00)",
    "$": 8778200,
    "address": "240 Dudley St",
    "parcel_id": "350-18-00",
    "owner1": "HARLEV TRS, SHAYLA KASUTO & DORON",
    "owner2": "",
    "current_taxes": 89888.77,
    "new_taxes_no_override": 93771.96,
    "override_total_1": 96432.67,
    "override_increase_1": 2660.71
  },
  {
    "#": "243 Dudley St (349-13-00)",
    "$": 6467500,
    "address": "243 Dudley St",
    "parcel_id": "349-13-00",
    "owner1": "GATES TRS, ANDREW ALBERT",
    "owner2": "",
    "current_taxes": 62592.27,
    "new_taxes_no_override": 65296.26,
    "override_total_1": 67148.99,
    "override_increase_1": 1852.73
  },
  {
    "#": "248 Dudley St (350-04-00)",
    "$": 3649100,
    "address": "248 Dudley St",
    "parcel_id": "350-04-00",
    "owner1": "RUTHERFURD, JOHN JR & CAROLINE G",
    "owner2": "",
    "current_taxes": 37366.78,
    "new_taxes_no_override": 38981.02,
    "override_total_1": 40087.08,
    "override_increase_1": 1106.06
  },
  {
    "#": "255 Dudley St (349-14-00)",
    "$": 8209400,
    "address": "255 Dudley St",
    "parcel_id": "349-14-00",
    "owner1": "DALY, JEREMIAH II & ELIZABETH",
    "owner2": "",
    "current_taxes": 80429.32,
    "new_taxes_no_override": 83903.87,
    "override_total_1": 86284.57,
    "override_increase_1": 2380.71
  },
  {
    "#": "265 Dudley St (349-15-00)",
    "$": 5607300,
    "address": "265 Dudley St",
    "parcel_id": "349-15-00",
    "owner1": "SHAPIRO, TR, CINDI M",
    "owner2": "",
    "current_taxes": 57418.75,
    "new_taxes_no_override": 59899.24,
    "override_total_1": 61598.83,
    "override_increase_1": 1699.6
  },
  {
    "#": "274 Dudley St (350-03-00)",
    "$": 5203200,
    "address": "274 Dudley St",
    "parcel_id": "350-03-00",
    "owner1": "FIRESTONE, DAVID & KAREN",
    "owner2": "",
    "current_taxes": 49645.83,
    "new_taxes_no_override": 51790.53,
    "override_total_1": 53260.05,
    "override_increase_1": 1469.52
  },
  {
    "#": "280 Dudley St (350-02-00)",
    "$": 7454400,
    "address": "280 Dudley St",
    "parcel_id": "350-02-00",
    "owner1": "EWING TR, JENNIFER S",
    "owner2": "",
    "current_taxes": 76333.06,
    "new_taxes_no_override": 79630.65,
    "override_total_1": 81890.11,
    "override_increase_1": 2259.46
  },
  {
    "#": "285 Dudley St (349-16-00)",
    "$": 5197200,
    "address": "285 Dudley St",
    "parcel_id": "349-16-00",
    "owner1": "HAWKINS TR, DAVID F",
    "owner2": "",
    "current_taxes": 53219.33,
    "new_taxes_no_override": 55518.41,
    "override_total_1": 57093.7,
    "override_increase_1": 1575.29
  },
  {
    "#": "300 Dudley St (350-01-00)",
    "$": 5607000,
    "address": "300 Dudley St",
    "parcel_id": "350-01-00",
    "owner1": "HIRSCHFELD, BRIAN J",
    "owner2": "AMES, MARY I",
    "current_taxes": 57415.68,
    "new_taxes_no_override": 59896.04,
    "override_total_1": 61595.54,
    "override_increase_1": 1699.5
  },
  {
    "#": "305 Dudley St (349-17-00)",
    "$": 9120400,
    "address": "305 Dudley St",
    "parcel_id": "349-17-00",
    "owner1": "MARKS, ET AL TRS, RICHARD",
    "owner2": "C/O JEREMY SCLAR | W/S DEVELOPMENT",
    "current_taxes": 93392.9,
    "new_taxes_no_override": 97427.47,
    "override_total_1": 100191.9,
    "override_increase_1": 2764.43
  },
  {
    "#": "320 Dudley St (350-17-00)",
    "$": 5052700,
    "address": "320 Dudley St",
    "parcel_id": "350-17-00",
    "owner1": "FISHER, JULIAN HART",
    "owner2": "",
    "current_taxes": 48104.71,
    "new_taxes_no_override": 50182.83,
    "override_total_1": 51606.73,
    "override_increase_1": 1423.9
  },
  {
    "#": "9 Duffley Ct (275-13-00)",
    "$": 1227300,
    "address": "9 Duffley Ct",
    "parcel_id": "275-13-00",
    "owner1": "MROZ JR, EDMUND A",
    "owner2": "SHAPIRO, CELIA B",
    "current_taxes": 8932.62,
    "new_taxes_no_override": 9318.51,
    "override_total_1": 9582.91,
    "override_increase_1": 264.41
  },
  {
    "#": "10 Duffley Ct (275-15-04)",
    "$": 1582500,
    "address": "10 Duffley Ct",
    "parcel_id": "275-15-04",
    "owner1": "10 DUFFLEY LLC",
    "owner2": "",
    "current_taxes": 16204.8,
    "new_taxes_no_override": 16904.85,
    "override_total_1": 17384.51,
    "override_increase_1": 479.66
  },
  {
    "#": "14 Duffley Ct (275-14-00)",
    "$": 1549800,
    "address": "14 Duffley Ct",
    "parcel_id": "275-14-00",
    "owner1": "LI, YING",
    "owner2": "",
    "current_taxes": 12235.02,
    "new_taxes_no_override": 12763.57,
    "override_total_1": 13125.73,
    "override_increase_1": 362.16
  },
  {
    "#": "10 Dummer St (015-03-01)",
    "$": 3211100,
    "address": "10 Dummer St",
    "parcel_id": "015-03-01",
    "owner1": "10 DUMMER STREET REALTY LLC",
    "owner2": "",
    "current_taxes": 32881.66,
    "new_taxes_no_override": 34302.15,
    "override_total_1": 35275.44,
    "override_increase_1": 973.3
  },
  {
    "#": "14 Dummer St (015-03-00)",
    "$": 2369000,
    "address": "14 Dummer St",
    "parcel_id": "015-03-00",
    "owner1": "MAB COMMUNITY SERVICES INC",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "40 Dummer St (016-02-00)",
    "$": 2015900,
    "address": "40 Dummer St",
    "parcel_id": "016-02-00",
    "owner1": "PAZAM LLC",
    "owner2": "",
    "current_taxes": 20642.82,
    "new_taxes_no_override": 21534.59,
    "override_total_1": 22145.62,
    "override_increase_1": 611.03
  },
  {
    "#": "47 Dummer St (017-06-00)",
    "$": 4425300,
    "address": "47 Dummer St",
    "parcel_id": "017-06-00",
    "owner1": "BOSTON UNIVERSITY TRS",
    "owner2": "C/O GENERAL ACCOUNTING 4TH FLR",
    "current_taxes": 22781.44,
    "new_taxes_no_override": 23765.6,
    "override_total_1": 24439.93,
    "override_increase_1": 674.33
  },
  {
    "#": "86 Dummer St (021-16-00)",
    "$": 10295000,
    "address": "86 Dummer St",
    "parcel_id": "021-16-00",
    "owner1": "86 DUMMER LLC",
    "owner2": "C/O BROOKLINE HOUSING AUTHORITY",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "115 Dummer St (019-02-00)",
    "$": 5402200,
    "address": "115 Dummer St",
    "parcel_id": "019-02-00",
    "owner1": "NATIONAL STUDIOS LLC",
    "owner2": "",
    "current_taxes": 92701.75,
    "new_taxes_no_override": 96706.47,
    "override_total_1": 99450.44,
    "override_increase_1": 2743.97
  },
  {
    "#": "121 Dummer St (019-11-00)",
    "$": 8990400,
    "address": "121 Dummer St",
    "parcel_id": "019-11-00",
    "owner1": "CULBERT, ET AL TRS, ANDREW",
    "owner2": "C/O SIS PROPERTY MANAGEMENT",
    "current_taxes": 154275.26,
    "new_taxes_no_override": 160939.95,
    "override_total_1": 165506.5,
    "override_increase_1": 4566.55
  },
  {
    "#": "22 Dunster Rd (284-21-00)",
    "$": 2602800,
    "address": "22 Dunster Rd",
    "parcel_id": "284-21-00",
    "owner1": "POWER TR, LEO F III",
    "owner2": "",
    "current_taxes": 23017.74,
    "new_taxes_no_override": 24012.11,
    "override_total_1": 24693.43,
    "override_increase_1": 681.33
  },
  {
    "#": "26 Dunster Rd (284-20-00)",
    "$": 2950600,
    "address": "26 Dunster Rd",
    "parcel_id": "284-20-00",
    "owner1": "BLAND TRS, ROBERT P",
    "owner2": "SLOAN, DAVID SCOTT",
    "current_taxes": 30214.14,
    "new_taxes_no_override": 31519.39,
    "override_total_1": 32413.73,
    "override_increase_1": 894.34
  },
  {
    "#": "40 Dunster Rd (284-19-00)",
    "$": 7893600,
    "address": "40 Dunster Rd",
    "parcel_id": "284-19-00",
    "owner1": "DUNSTER CH LLC",
    "owner2": "",
    "current_taxes": 80830.46,
    "new_taxes_no_override": 84322.34,
    "override_total_1": 86714.92,
    "override_increase_1": 2392.58
  },
  {
    "#": "83 Dunster Rd (433-01-00)",
    "$": 1483600,
    "address": "83 Dunster Rd",
    "parcel_id": "433-01-00",
    "owner1": "BRECKE TR, ANN Y",
    "owner2": "",
    "current_taxes": 15192.06,
    "new_taxes_no_override": 15848.36,
    "override_total_1": 16298.04,
    "override_increase_1": 449.68
  },
  {
    "#": "4 Dwight St, Unit 1 (046-14-04)",
    "$": 1397900,
    "address": "4 Dwight St, Unit 1",
    "parcel_id": "046-14-04",
    "owner1": "GROSSBARD TRS, ELLIOTT B & ELAYNE L",
    "owner2": "",
    "current_taxes": 10679.56,
    "new_taxes_no_override": 11140.92,
    "override_total_1": 11457.03,
    "override_increase_1": 316.11
  },
  {
    "#": "4 Dwight St, Unit 2 (046-14-01)",
    "$": 1423700,
    "address": "4 Dwight St, Unit 2",
    "parcel_id": "046-14-01",
    "owner1": "MAYEW, KEVIN J",
    "owner2": "REE, THECLA",
    "current_taxes": 10943.75,
    "new_taxes_no_override": 11416.52,
    "override_total_1": 11740.45,
    "override_increase_1": 323.94
  },
  {
    "#": "4 Dwight St, Unit 2A (046-14-03)",
    "$": 660100,
    "address": "4 Dwight St, Unit 2A",
    "parcel_id": "046-14-03",
    "owner1": "DOOLEY FAIRCHILD, SIRA M",
    "owner2": "",
    "current_taxes": 3124.49,
    "new_taxes_no_override": 3259.47,
    "override_total_1": 3351.95,
    "override_increase_1": 92.48
  },
  {
    "#": "4 Dwight St, Unit 3 (046-14-02)",
    "$": 1433100,
    "address": "4 Dwight St, Unit 3",
    "parcel_id": "046-14-02",
    "owner1": "BAKER, ANNI",
    "owner2": "",
    "current_taxes": 11040.01,
    "new_taxes_no_override": 11516.94,
    "override_total_1": 11843.72,
    "override_increase_1": 326.78
  },
  {
    "#": "8 Dwight St (046-13-00)",
    "$": 3177800,
    "address": "8 Dwight St",
    "parcel_id": "046-13-00",
    "owner1": "WONG, ANDREW L & HANS L",
    "owner2": "",
    "current_taxes": 28905.74,
    "new_taxes_no_override": 30154.47,
    "override_total_1": 31010.08,
    "override_increase_1": 855.61
  },
  {
    "#": "10 Dwight St (046-12-00)",
    "$": 2999500,
    "address": "10 Dwight St",
    "parcel_id": "046-12-00",
    "owner1": "WONG TRS, JUDITH J & HANS L",
    "owner2": "HALLORAN, ETHEL WONG",
    "current_taxes": 27079.95,
    "new_taxes_no_override": 28249.8,
    "override_total_1": 29051.37,
    "override_increase_1": 801.57
  },
  {
    "#": "15 Dwight St (035-44-00)",
    "$": 2255600,
    "address": "15 Dwight St",
    "parcel_id": "035-44-00",
    "owner1": "COMMONWEALTH OF MASSACHUSETTS",
    "owner2": "C/O DIV OF CAPITAL ASSET MANAGEMNT",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "21 Dwight St (035-45-00)",
    "$": 2795000,
    "address": "21 Dwight St",
    "parcel_id": "035-45-00",
    "owner1": "KAUFMAN, KEVIN J & JODI L",
    "owner2": "",
    "current_taxes": 24985.87,
    "new_taxes_no_override": 26065.26,
    "override_total_1": 26804.84,
    "override_increase_1": 739.58
  },
  {
    "#": "25 Dwight St (035-46-00)",
    "$": 3399700,
    "address": "25 Dwight St",
    "parcel_id": "035-46-00",
    "owner1": "REDER, MILTON A",
    "owner2": "",
    "current_taxes": 31177.99,
    "new_taxes_no_override": 32524.88,
    "override_total_1": 33447.75,
    "override_increase_1": 922.87
  },
  {
    "#": "28 Dwight St, Unit 2 (047-13-02)",
    "$": 2470400,
    "address": "28 Dwight St, Unit 2",
    "parcel_id": "047-13-02",
    "owner1": "SOUCY TR, ROBERT M",
    "owner2": "",
    "current_taxes": 25296.9,
    "new_taxes_no_override": 26389.73,
    "override_total_1": 27138.51,
    "override_increase_1": 748.79
  },
  {
    "#": "30 Dwight St, Unit 3 (047-13-03)",
    "$": 2470400,
    "address": "30 Dwight St, Unit 3",
    "parcel_id": "047-13-03",
    "owner1": "ANDELMAN, DAVID I",
    "owner2": "",
    "current_taxes": 25296.9,
    "new_taxes_no_override": 26389.73,
    "override_total_1": 27138.51,
    "override_increase_1": 748.79
  },
  {
    "#": "31 Dwight St (035-47-00)",
    "$": 3179200,
    "address": "31 Dwight St",
    "parcel_id": "035-47-00",
    "owner1": "SUDALTER TRS, MARK B",
    "owner2": "TANKEL, STEPHEN C",
    "current_taxes": 32555.01,
    "new_taxes_no_override": 33961.39,
    "override_total_1": 34925.01,
    "override_increase_1": 963.63
  },
  {
    "#": "32 Dwight St, Unit 4 (047-13-04)",
    "$": 2547200,
    "address": "32 Dwight St, Unit 4",
    "parcel_id": "047-13-04",
    "owner1": "KRETSCHMER, MATTHIAS",
    "owner2": "BARADARAN, KHANDAN",
    "current_taxes": 22448.39,
    "new_taxes_no_override": 23418.16,
    "override_total_1": 24082.63,
    "override_increase_1": 664.47
  },
  {
    "#": "33 Dwight St (035-48-00)",
    "$": 4114600,
    "address": "33 Dwight St",
    "parcel_id": "035-48-00",
    "owner1": "YEE, TR, NORMAN",
    "owner2": "",
    "current_taxes": 42133.5,
    "new_taxes_no_override": 43953.67,
    "override_total_1": 45200.82,
    "override_increase_1": 1247.15
  },
  {
    "#": "36 Dwight St, Unit 1 (047-12-06)",
    "$": 665800,
    "address": "36 Dwight St, Unit 1",
    "parcel_id": "047-12-06",
    "owner1": "GODDESS, STEVEN J & SHEILA I",
    "owner2": "",
    "current_taxes": 3182.86,
    "new_taxes_no_override": 3320.36,
    "override_total_1": 3414.57,
    "override_increase_1": 94.21
  },
  {
    "#": "36 Dwight St, Unit 2 (047-12-01)",
    "$": 646100,
    "address": "36 Dwight St, Unit 2",
    "parcel_id": "047-12-01",
    "owner1": "ZIPURSKY, JAY MORRIS & KIMBERLY J",
    "owner2": "",
    "current_taxes": 2981.13,
    "new_taxes_no_override": 3109.91,
    "override_total_1": 3198.16,
    "override_increase_1": 88.24
  },
  {
    "#": "36 Dwight St, Unit 3 (047-12-02)",
    "$": 691100,
    "address": "36 Dwight St, Unit 3",
    "parcel_id": "047-12-02",
    "owner1": "FARBSTEIN TRS, AVRAHAM & LILI",
    "owner2": "",
    "current_taxes": 7076.86,
    "new_taxes_no_override": 7382.58,
    "override_total_1": 7592.06,
    "override_increase_1": 209.48
  },
  {
    "#": "36 Dwight St, Unit 4 (047-12-03)",
    "$": 694700,
    "address": "36 Dwight St, Unit 4",
    "parcel_id": "047-12-03",
    "owner1": "SUN, JING",
    "owner2": "XU, TIANLEI",
    "current_taxes": 7113.73,
    "new_taxes_no_override": 7421.04,
    "override_total_1": 7631.61,
    "override_increase_1": 210.57
  },
  {
    "#": "36 Dwight St, Unit 5 (047-12-04)",
    "$": 670200,
    "address": "36 Dwight St, Unit 5",
    "parcel_id": "047-12-04",
    "owner1": "LI, ZHENGNAN",
    "owner2": "",
    "current_taxes": 6862.85,
    "new_taxes_no_override": 7159.33,
    "override_total_1": 7362.47,
    "override_increase_1": 203.14
  },
  {
    "#": "36 Dwight St, Unit 6 (047-12-05)",
    "$": 683000,
    "address": "36 Dwight St, Unit 6",
    "parcel_id": "047-12-05",
    "owner1": "MAERTENS, OPHELIA",
    "owner2": "",
    "current_taxes": 6993.92,
    "new_taxes_no_override": 7296.06,
    "override_total_1": 7503.08,
    "override_increase_1": 207.02
  },
  {
    "#": "37 Dwight St (035-49-00)",
    "$": 3541400,
    "address": "37 Dwight St",
    "parcel_id": "035-49-00",
    "owner1": "LEUNG TR, VIVIAN",
    "owner2": "",
    "current_taxes": 36263.94,
    "new_taxes_no_override": 37830.54,
    "override_total_1": 38903.95,
    "override_increase_1": 1073.41
  },
  {
    "#": "39 Dwight St (035-50-00)",
    "$": 3535000,
    "address": "39 Dwight St",
    "parcel_id": "035-50-00",
    "owner1": "SOO HOO TRS, PETER & SHIRLEY S",
    "owner2": "",
    "current_taxes": 36198.4,
    "new_taxes_no_override": 37762.17,
    "override_total_1": 38833.64,
    "override_increase_1": 1071.47
  },
  {
    "#": "41 Dwight St, Unit 1 (035-51-03)",
    "$": 1083800,
    "address": "41 Dwight St, Unit 1",
    "parcel_id": "035-51-03",
    "owner1": "PENNY, ROBERT",
    "owner2": "",
    "current_taxes": 7463.18,
    "new_taxes_no_override": 7785.59,
    "override_total_1": 8006.5,
    "override_increase_1": 220.91
  },
  {
    "#": "41 Dwight St, Unit 2 (035-51-01)",
    "$": 1254200,
    "address": "41 Dwight St, Unit 2",
    "parcel_id": "035-51-01",
    "owner1": "GORDON, NORMA & NEAL F",
    "owner2": "",
    "current_taxes": 9208.07,
    "new_taxes_no_override": 9605.86,
    "override_total_1": 9878.42,
    "override_increase_1": 272.56
  },
  {
    "#": "41 Dwight St, Unit 3 (035-51-02)",
    "$": 1254200,
    "address": "41 Dwight St, Unit 3",
    "parcel_id": "035-51-02",
    "owner1": "EWING, SAM",
    "owner2": "",
    "current_taxes": 12843.01,
    "new_taxes_no_override": 13397.83,
    "override_total_1": 13777.98,
    "override_increase_1": 380.15
  },
  {
    "#": "43 Dwight St, Unit 1 (035-52-01)",
    "$": 2131400,
    "address": "43 Dwight St, Unit 1",
    "parcel_id": "035-52-01",
    "owner1": "CHIN, STEPHANIE",
    "owner2": "CHANG, ANDREW",
    "current_taxes": 18190.6,
    "new_taxes_no_override": 18976.43,
    "override_total_1": 19514.88,
    "override_increase_1": 538.44
  },
  {
    "#": "43 Dwight St, Unit 2 & P3 (035-52-02)",
    "$": 1751900,
    "address": "43 Dwight St, Unit 2 & P3",
    "parcel_id": "035-52-02",
    "owner1": "CHANG, KORNEL & LAURA",
    "owner2": "",
    "current_taxes": 14304.52,
    "new_taxes_no_override": 14922.48,
    "override_total_1": 15345.89,
    "override_increase_1": 423.41
  },
  {
    "#": "43 Dwight St, Unit 3 & P1 P2 (035-52-03)",
    "$": 1847900,
    "address": "43 Dwight St, Unit 3 & P1 P2",
    "parcel_id": "035-52-03",
    "owner1": "LI, BRIAN & CERINA",
    "owner2": "",
    "current_taxes": 15287.56,
    "new_taxes_no_override": 15947.98,
    "override_total_1": 16400.49,
    "override_increase_1": 452.51
  },
  {
    "#": "45 Dwight St (035-53-00)",
    "$": 3168700,
    "address": "45 Dwight St",
    "parcel_id": "035-53-00",
    "owner1": "45 DWIGHT LLC",
    "owner2": "",
    "current_taxes": 32447.49,
    "new_taxes_no_override": 33849.22,
    "override_total_1": 34809.67,
    "override_increase_1": 960.45
  },
  {
    "#": "48 Dwight St, Unit 1 & P21 (047-10-06)",
    "$": 501600,
    "address": "48 Dwight St, Unit 1 & P21",
    "parcel_id": "047-10-06",
    "owner1": "PURSLEY, ZACHARIAH JAMES",
    "owner2": "STODDARD, GRETCHEN MARIE",
    "current_taxes": 1501.45,
    "new_taxes_no_override": 1566.31,
    "override_total_1": 1610.76,
    "override_increase_1": 44.44
  },
  {
    "#": "48 Dwight St, Unit 2 (047-10-07)",
    "$": 538400,
    "address": "48 Dwight St, Unit 2",
    "parcel_id": "047-10-07",
    "owner1": "ZHANG, DAFANG & ZHIJING",
    "owner2": "ZHAO, HUILING",
    "current_taxes": 5513.22,
    "new_taxes_no_override": 5751.39,
    "override_total_1": 5914.58,
    "override_increase_1": 163.19
  },
  {
    "#": "48 Dwight St, Unit 3 & P28 (047-10-08)",
    "$": 589700,
    "address": "48 Dwight St, Unit 3 & P28",
    "parcel_id": "047-10-08",
    "owner1": "GOLDBLATT, MARK J",
    "owner2": "KAUFFMAN, CAROL M",
    "current_taxes": 6038.53,
    "new_taxes_no_override": 6299.39,
    "override_total_1": 6478.13,
    "override_increase_1": 178.74
  },
  {
    "#": "48 Dwight St, Unit 4 & P18 (047-10-09)",
    "$": 608400,
    "address": "48 Dwight St, Unit 4 & P18",
    "parcel_id": "047-10-09",
    "owner1": "WILLIAMS TR, SYBIL",
    "owner2": "",
    "current_taxes": 2595.08,
    "new_taxes_no_override": 2707.19,
    "override_total_1": 2784.0,
    "override_increase_1": 76.81
  },
  {
    "#": "48 Dwight St, Unit 5 & P1 (047-10-10)",
    "$": 589700,
    "address": "48 Dwight St, Unit 5 & P1",
    "parcel_id": "047-10-10",
    "owner1": "BECKETT TR, ROBERT",
    "owner2": "",
    "current_taxes": 6038.53,
    "new_taxes_no_override": 6299.39,
    "override_total_1": 6478.13,
    "override_increase_1": 178.74
  },
  {
    "#": "48 Dwight St, Unit 6 & P24 (047-10-11)",
    "$": 608400,
    "address": "48 Dwight St, Unit 6 & P24",
    "parcel_id": "047-10-11",
    "owner1": "LIU, EVAN Y",
    "owner2": "",
    "current_taxes": 2595.08,
    "new_taxes_no_override": 2707.19,
    "override_total_1": 2784.0,
    "override_increase_1": 76.81
  },
  {
    "#": "54 Dwight St, Unit 1 & P25 (047-10-12)",
    "$": 830100,
    "address": "54 Dwight St, Unit 1 & P25",
    "parcel_id": "047-10-12",
    "owner1": "GRINBERG, BORIS & TATYANA",
    "owner2": "",
    "current_taxes": 8500.22,
    "new_taxes_no_override": 8867.43,
    "override_total_1": 9119.04,
    "override_increase_1": 251.61
  },
  {
    "#": "54 Dwight St, Unit 2 & P22 (047-10-13)",
    "$": 853600,
    "address": "54 Dwight St, Unit 2 & P22",
    "parcel_id": "047-10-13",
    "owner1": "PINE TR, ELENA",
    "owner2": "",
    "current_taxes": 8740.86,
    "new_taxes_no_override": 9118.47,
    "override_total_1": 9377.19,
    "override_increase_1": 258.73
  },
  {
    "#": "54 Dwight St, Unit 3 (047-10-14)",
    "$": 824000,
    "address": "54 Dwight St, Unit 3",
    "parcel_id": "047-10-14",
    "owner1": "WONG TRS, STEPHEN KENNETH & ALICIA TANG",
    "owner2": "",
    "current_taxes": 8437.76,
    "new_taxes_no_override": 8802.27,
    "override_total_1": 9052.03,
    "override_increase_1": 249.76
  },
  {
    "#": "54 Dwight St, Unit 4 & P9 (047-10-15)",
    "$": 930200,
    "address": "54 Dwight St, Unit 4 & P9",
    "parcel_id": "047-10-15",
    "owner1": "PARK, EUNSIL",
    "owner2": "SON, KILHO",
    "current_taxes": 5890.31,
    "new_taxes_no_override": 6144.77,
    "override_total_1": 6319.12,
    "override_increase_1": 174.35
  },
  {
    "#": "54 Dwight St, Unit 5 & P11 (047-10-16)",
    "$": 984000,
    "address": "54 Dwight St, Unit 5 & P11",
    "parcel_id": "047-10-16",
    "owner1": "CORONA TRS, ALVARO LOERA & TRANG",
    "owner2": "",
    "current_taxes": 10076.16,
    "new_taxes_no_override": 10511.45,
    "override_total_1": 10809.7,
    "override_increase_1": 298.25
  },
  {
    "#": "54 Dwight St, Unit 6& P15 (047-10-17)",
    "$": 930200,
    "address": "54 Dwight St, Unit 6& P15",
    "parcel_id": "047-10-17",
    "owner1": "WANG, HAIYUN & QI",
    "owner2": "",
    "current_taxes": 5890.31,
    "new_taxes_no_override": 6144.77,
    "override_total_1": 6319.12,
    "override_increase_1": 174.35
  },
  {
    "#": "56 Dwight St, Unit 1 & P7 (047-10-18)",
    "$": 852600,
    "address": "56 Dwight St, Unit 1 & P7",
    "parcel_id": "047-10-18",
    "owner1": "HERRAIZ, PABLO",
    "owner2": "DEGUADIANA, GLORIA GARCIA",
    "current_taxes": 5095.69,
    "new_taxes_no_override": 5315.82,
    "override_total_1": 5466.66,
    "override_increase_1": 150.83
  },
  {
    "#": "56 Dwight St, Unit 2 & P29 (047-10-19)",
    "$": 886200,
    "address": "56 Dwight St, Unit 2 & P29",
    "parcel_id": "047-10-19",
    "owner1": "ROYTMAN, NATALY",
    "owner2": "",
    "current_taxes": 5439.75,
    "new_taxes_no_override": 5674.75,
    "override_total_1": 5835.76,
    "override_increase_1": 161.02
  },
  {
    "#": "56 Dwight St, Unit 3 & P3 (047-10-20)",
    "$": 985200,
    "address": "56 Dwight St, Unit 3 & P3",
    "parcel_id": "047-10-20",
    "owner1": "REGEV, KEREN",
    "owner2": "",
    "current_taxes": 10088.45,
    "new_taxes_no_override": 10524.27,
    "override_total_1": 10822.89,
    "override_increase_1": 298.62
  },
  {
    "#": "57 Dwight St (033-02-00)",
    "$": 1961600,
    "address": "57 Dwight St",
    "parcel_id": "033-02-00",
    "owner1": "WAXWING LLC",
    "owner2": "",
    "current_taxes": 33661.06,
    "new_taxes_no_override": 35115.22,
    "override_total_1": 36111.59,
    "override_increase_1": 996.37
  },
  {
    "#": "58 Dwight St, Unit 1 & P2 (047-10-21)",
    "$": 889600,
    "address": "58 Dwight St, Unit 1 & P2",
    "parcel_id": "047-10-21",
    "owner1": "DESHPANDE, MIHIR",
    "owner2": "DABHADE, SHRUTI",
    "current_taxes": 5474.57,
    "new_taxes_no_override": 5711.07,
    "override_total_1": 5873.12,
    "override_increase_1": 162.05
  },
  {
    "#": "58 Dwight St, Unit 2 (047-10-22)",
    "$": 638700,
    "address": "58 Dwight St, Unit 2",
    "parcel_id": "047-10-22",
    "owner1": "ERZURUMLU, SADIK SINAN",
    "owner2": "",
    "current_taxes": 6540.29,
    "new_taxes_no_override": 6822.83,
    "override_total_1": 7016.42,
    "override_increase_1": 193.59
  },
  {
    "#": "58 Dwight St, Unit 3 & P19 (047-10-23)",
    "$": 889600,
    "address": "58 Dwight St, Unit 3 & P19",
    "parcel_id": "047-10-23",
    "owner1": "SOMOZA, LUIS",
    "owner2": "BOSQUE, MONICA CRESPO",
    "current_taxes": 5474.57,
    "new_taxes_no_override": 5711.07,
    "override_total_1": 5873.12,
    "override_increase_1": 162.05
  },
  {
    "#": "58 Dwight St, Unit 4 & P27 (047-10-24)",
    "$": 845300,
    "address": "58 Dwight St, Unit 4 & P27",
    "parcel_id": "047-10-24",
    "owner1": "THERIAULT, DAVID & SUSAN G",
    "owner2": "",
    "current_taxes": 8655.87,
    "new_taxes_no_override": 9029.8,
    "override_total_1": 9286.02,
    "override_increase_1": 256.21
  },
  {
    "#": "58 Dwight St, Unit 5 & P13 (047-10-25)",
    "$": 854100,
    "address": "58 Dwight St, Unit 5 & P13",
    "parcel_id": "047-10-25",
    "owner1": "POST, DUDLEY LELAND",
    "owner2": "",
    "current_taxes": 5111.05,
    "new_taxes_no_override": 5331.85,
    "override_total_1": 5483.13,
    "override_increase_1": 151.29
  },
  {
    "#": "58 Dwight St, Unit 6 & P10 (047-10-26)",
    "$": 833200,
    "address": "58 Dwight St, Unit 6 & P10",
    "parcel_id": "047-10-26",
    "owner1": "FRIEDMAN, LESLIE C",
    "owner2": "",
    "current_taxes": 4897.03,
    "new_taxes_no_override": 5108.58,
    "override_total_1": 5253.53,
    "override_increase_1": 144.95
  },
  {
    "#": "60 Dwight St, Unit 1 & P14 (047-10-27)",
    "$": 792000,
    "address": "60 Dwight St, Unit 1 & P14",
    "parcel_id": "047-10-27",
    "owner1": "BOUCHARD TR, MARY E",
    "owner2": "",
    "current_taxes": 8110.08,
    "new_taxes_no_override": 8460.44,
    "override_total_1": 8700.49,
    "override_increase_1": 240.06
  },
  {
    "#": "60 Dwight St, Unit 2 & P4 (047-10-28)",
    "$": 847300,
    "address": "60 Dwight St, Unit 2 & P4",
    "parcel_id": "047-10-28",
    "owner1": "RABINOVITZ, ZORI & INBAL",
    "owner2": "",
    "current_taxes": 8676.35,
    "new_taxes_no_override": 9051.17,
    "override_total_1": 9307.99,
    "override_increase_1": 256.82
  },
  {
    "#": "60 Dwight St, Unit 3 & P16 (047-10-29)",
    "$": 856700,
    "address": "60 Dwight St, Unit 3 & P16",
    "parcel_id": "047-10-29",
    "owner1": "KOLARIK, ANTHONY J & LISA S",
    "owner2": "",
    "current_taxes": 5137.67,
    "new_taxes_no_override": 5359.62,
    "override_total_1": 5511.69,
    "override_increase_1": 152.08
  },
  {
    "#": "62 Dwight St, Unit 1 & P20 (047-10-30)",
    "$": 833800,
    "address": "62 Dwight St, Unit 1 & P20",
    "parcel_id": "047-10-30",
    "owner1": "MOSTOFSKY, TR, LEE Z",
    "owner2": "",
    "current_taxes": 8538.11,
    "new_taxes_no_override": 8906.96,
    "override_total_1": 9159.68,
    "override_increase_1": 252.73
  },
  {
    "#": "62 Dwight St, Unit 2 (047-10-31)",
    "$": 772700,
    "address": "62 Dwight St, Unit 2",
    "parcel_id": "047-10-31",
    "owner1": "HA, GEEHYUNG",
    "owner2": "HONG, SAE HWA",
    "current_taxes": 4277.51,
    "new_taxes_no_override": 4462.3,
    "override_total_1": 4588.91,
    "override_increase_1": 126.61
  },
  {
    "#": "62 Dwight St, Unit 3 & P17 (047-10-32)",
    "$": 863000,
    "address": "62 Dwight St, Unit 3 & P17",
    "parcel_id": "047-10-32",
    "owner1": "HEARST TR, NANCY R",
    "owner2": "",
    "current_taxes": 5202.19,
    "new_taxes_no_override": 5426.92,
    "override_total_1": 5580.91,
    "override_increase_1": 153.98
  },
  {
    "#": "62 Dwight St, Unit 4 (047-10-33)",
    "$": 838500,
    "address": "62 Dwight St, Unit 4",
    "parcel_id": "047-10-33",
    "owner1": "ZARA, JUDITH SYDELLE",
    "owner2": "",
    "current_taxes": 4951.31,
    "new_taxes_no_override": 5165.21,
    "override_total_1": 5311.77,
    "override_increase_1": 146.56
  },
  {
    "#": "62 Dwight St, Unit 5 & P12 (047-10-34)",
    "$": 941000,
    "address": "62 Dwight St, Unit 5 & P12",
    "parcel_id": "047-10-34",
    "owner1": "KONOFF, JOSHUA",
    "owner2": "ZHONG, QUIZI",
    "current_taxes": 9635.84,
    "new_taxes_no_override": 10052.11,
    "override_total_1": 10337.33,
    "override_increase_1": 285.22
  },
  {
    "#": "62 Dwight St, Unit 6 & P8 (047-10-35)",
    "$": 873400,
    "address": "62 Dwight St, Unit 6 & P8",
    "parcel_id": "047-10-35",
    "owner1": "PERLSTEIN, HOWARD",
    "owner2": "",
    "current_taxes": 5308.68,
    "new_taxes_no_override": 5538.01,
    "override_total_1": 5695.15,
    "override_increase_1": 157.14
  },
  {
    "#": "9 East Milton Rd (318-04-00)",
    "$": 988100,
    "address": "9 East Milton Rd",
    "parcel_id": "318-04-00",
    "owner1": "O`ROURKE, HERBERT F",
    "owner2": "C/O GEIGER MARIE",
    "current_taxes": 10118.14,
    "new_taxes_no_override": 10555.24,
    "override_total_1": 10854.74,
    "override_increase_1": 299.5
  },
  {
    "#": "10 East Milton Rd (318-11-00)",
    "$": 2178200,
    "address": "10 East Milton Rd",
    "parcel_id": "318-11-00",
    "owner1": "MOTSIS, JOHN C",
    "owner2": "",
    "current_taxes": 18669.83,
    "new_taxes_no_override": 19476.37,
    "override_total_1": 20028.99,
    "override_increase_1": 552.63
  },
  {
    "#": "11 East Milton Rd (318-05-00)",
    "$": 2044300,
    "address": "11 East Milton Rd",
    "parcel_id": "318-05-00",
    "owner1": "FREDERICA LLC",
    "owner2": "",
    "current_taxes": 20933.63,
    "new_taxes_no_override": 21837.96,
    "override_total_1": 22457.6,
    "override_increase_1": 619.64
  },
  {
    "#": "14 East Milton Rd (318-10-00)",
    "$": 2085600,
    "address": "14 East Milton Rd",
    "parcel_id": "318-10-00",
    "owner1": "ARAUJO, PAUL",
    "owner2": "",
    "current_taxes": 21356.54,
    "new_taxes_no_override": 22279.14,
    "override_total_1": 22911.3,
    "override_increase_1": 632.15
  },
  {
    "#": "15 East Milton Rd (318-06-00)",
    "$": 2063100,
    "address": "15 East Milton Rd",
    "parcel_id": "318-06-00",
    "owner1": "EVEREST PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 21126.14,
    "new_taxes_no_override": 22038.79,
    "override_total_1": 22664.12,
    "override_increase_1": 625.33
  },
  {
    "#": "17 East Milton Rd (318-07-00)",
    "$": 2144300,
    "address": "17 East Milton Rd",
    "parcel_id": "318-07-00",
    "owner1": "LU, YANG SHI",
    "owner2": "XU, AMY",
    "current_taxes": 21957.63,
    "new_taxes_no_override": 22906.2,
    "override_total_1": 23556.15,
    "override_increase_1": 649.95
  },
  {
    "#": "18 East Milton Rd (318-09-00)",
    "$": 2587800,
    "address": "18 East Milton Rd",
    "parcel_id": "318-09-00",
    "owner1": "ROSENBLATT TR, HAROLD R",
    "owner2": "",
    "current_taxes": 22864.14,
    "new_taxes_no_override": 23851.87,
    "override_total_1": 24528.65,
    "override_increase_1": 676.78
  },
  {
    "#": "20 East Milton Rd, Unit 1 (318-08-01)",
    "$": 829400,
    "address": "20 East Milton Rd, Unit 1",
    "parcel_id": "318-08-01",
    "owner1": "DANAHY, MAUREEN",
    "owner2": "MOORE, RICHARD",
    "current_taxes": 4858.12,
    "new_taxes_no_override": 5067.99,
    "override_total_1": 5211.79,
    "override_increase_1": 143.8
  },
  {
    "#": "20 East Milton Rd, Unit 2 (318-08-02)",
    "$": 812000,
    "address": "20 East Milton Rd, Unit 2",
    "parcel_id": "318-08-02",
    "owner1": "WANG, YIHAN",
    "owner2": "XIA, FEN",
    "current_taxes": 8314.88,
    "new_taxes_no_override": 8674.08,
    "override_total_1": 8920.2,
    "override_increase_1": 246.12
  },
  {
    "#": "20 East Milton Rd, Unit 3 (318-08-03)",
    "$": 867600,
    "address": "20 East Milton Rd, Unit 3",
    "parcel_id": "318-08-03",
    "owner1": "BUTTY, VINCENT L",
    "owner2": "JIANG, WENYU",
    "current_taxes": 5249.29,
    "new_taxes_no_override": 5476.06,
    "override_total_1": 5631.44,
    "override_increase_1": 155.38
  },
  {
    "#": "1 Edgehill Rd (299-31-00)",
    "$": 2895500,
    "address": "1 Edgehill Rd",
    "parcel_id": "299-31-00",
    "owner1": "SHICK, LAWTON",
    "owner2": "SHIH, HELEN A",
    "current_taxes": 26014.99,
    "new_taxes_no_override": 27138.84,
    "override_total_1": 27908.88,
    "override_increase_1": 770.04
  },
  {
    "#": "12 Edgehill Rd (299-43-00)",
    "$": 103700,
    "address": "12 Edgehill Rd",
    "parcel_id": "299-43-00",
    "owner1": "CLOETINGH, JEFFREY SCOTT",
    "owner2": "BUNDY, LAUREN TESS",
    "current_taxes": 1061.89,
    "new_taxes_no_override": 1107.76,
    "override_total_1": 1139.2,
    "override_increase_1": 31.43
  },
  {
    "#": "17 Edgehill Rd (299-32-00)",
    "$": 2532800,
    "address": "17 Edgehill Rd",
    "parcel_id": "299-32-00",
    "owner1": "KLAUSSEN TR, ANITA RUTHLING",
    "owner2": "",
    "current_taxes": 22300.94,
    "new_taxes_no_override": 23264.34,
    "override_total_1": 23924.45,
    "override_increase_1": 660.11
  },
  {
    "#": "19 Edgehill Rd (299-33-00)",
    "$": 3009200,
    "address": "19 Edgehill Rd",
    "parcel_id": "299-33-00",
    "owner1": "JONAS TR, EMILY ANNE",
    "owner2": "",
    "current_taxes": 30814.21,
    "new_taxes_no_override": 32145.38,
    "override_total_1": 33057.48,
    "override_increase_1": 912.1
  },
  {
    "#": "20 Edgehill Rd (299-42-00)",
    "$": 3186500,
    "address": "20 Edgehill Rd",
    "parcel_id": "299-42-00",
    "owner1": "MEYER, THOMAS A & JENNIFER A",
    "owner2": "",
    "current_taxes": 28994.83,
    "new_taxes_no_override": 30247.41,
    "override_total_1": 31105.65,
    "override_increase_1": 858.25
  },
  {
    "#": "25 Edgehill Rd (299-34-00)",
    "$": 2533400,
    "address": "25 Edgehill Rd",
    "parcel_id": "299-34-00",
    "owner1": "STAHL TRS, JONATHAN MICHAEL & WENDY REBECCA",
    "owner2": "",
    "current_taxes": 22307.08,
    "new_taxes_no_override": 23270.75,
    "override_total_1": 23931.04,
    "override_increase_1": 660.29
  },
  {
    "#": "26 Edgehill Rd (299-41-00)",
    "$": 3519700,
    "address": "26 Edgehill Rd",
    "parcel_id": "299-41-00",
    "owner1": "DOBBIN, FRANK R",
    "owner2": "LAMONT, MICHELE",
    "current_taxes": 32406.79,
    "new_taxes_no_override": 33806.76,
    "override_total_1": 34766.0,
    "override_increase_1": 959.24
  },
  {
    "#": "29 Edgehill Rd (299-35-00)",
    "$": 2184900,
    "address": "29 Edgehill Rd",
    "parcel_id": "299-35-00",
    "owner1": "BROWN, SEAN E & KERRY E J",
    "owner2": "",
    "current_taxes": 18738.44,
    "new_taxes_no_override": 19547.94,
    "override_total_1": 20102.6,
    "override_increase_1": 554.66
  },
  {
    "#": "33 Edgehill Rd (299-36-00)",
    "$": 6039200,
    "address": "33 Edgehill Rd",
    "parcel_id": "299-36-00",
    "owner1": "RAHMAN, GHULAM SAMDANI & NIELA",
    "owner2": "",
    "current_taxes": 58206.47,
    "new_taxes_no_override": 60720.99,
    "override_total_1": 62443.9,
    "override_increase_1": 1722.91
  },
  {
    "#": "36 Edgehill Rd (299-40-00)",
    "$": 4328200,
    "address": "36 Edgehill Rd",
    "parcel_id": "299-40-00",
    "owner1": "RIZIKA, MARNE",
    "owner2": "",
    "current_taxes": 40685.83,
    "new_taxes_no_override": 42443.46,
    "override_total_1": 43647.76,
    "override_increase_1": 1204.3
  },
  {
    "#": "41 Edgehill Rd (299-37-00)",
    "$": 4560800,
    "address": "41 Edgehill Rd",
    "parcel_id": "299-37-00",
    "owner1": "MAILER-HOWAT, REBECCA",
    "owner2": "",
    "current_taxes": 43067.66,
    "new_taxes_no_override": 44928.18,
    "override_total_1": 46202.99,
    "override_increase_1": 1274.8
  },
  {
    "#": "44 Edgehill Rd (299-39-00)",
    "$": 4523900,
    "address": "44 Edgehill Rd",
    "parcel_id": "299-39-00",
    "owner1": "LIPSITZ TRS, LOUISE P & LEWIS A",
    "owner2": "",
    "current_taxes": 42689.8,
    "new_taxes_no_override": 44534.0,
    "override_total_1": 45797.62,
    "override_increase_1": 1263.62
  },
  {
    "#": "50 Edgehill Rd (299-38-00)",
    "$": 4799800,
    "address": "50 Edgehill Rd",
    "parcel_id": "299-38-00",
    "owner1": "ARROYO, JORGE G",
    "owner2": "",
    "current_taxes": 45515.02,
    "new_taxes_no_override": 47481.27,
    "override_total_1": 48828.51,
    "override_increase_1": 1347.24
  },
  {
    "#": "6 Edwin St (317-29-00)",
    "$": 1868900,
    "address": "6 Edwin St",
    "parcel_id": "317-29-00",
    "owner1": "KWOK, SUI FAN",
    "owner2": "LIN, YONG HE",
    "current_taxes": 19137.54,
    "new_taxes_no_override": 19964.28,
    "override_total_1": 20530.75,
    "override_increase_1": 566.47
  },
  {
    "#": "8 Edwin St (317-28-00)",
    "$": 2392600,
    "address": "8 Edwin St",
    "parcel_id": "317-28-00",
    "owner1": "HARRINGTON, PHILIP J & JO ANN",
    "owner2": "",
    "current_taxes": 20865.29,
    "new_taxes_no_override": 21766.67,
    "override_total_1": 22384.28,
    "override_increase_1": 617.61
  },
  {
    "#": "12 Edwin St, Unit 1 (317-27-01)",
    "$": 1155600,
    "address": "12 Edwin St, Unit 1",
    "parcel_id": "317-27-01",
    "owner1": "BACA, CHRISTOPHER",
    "owner2": "PETERS, WHITNEY",
    "current_taxes": 8198.41,
    "new_taxes_no_override": 8552.58,
    "override_total_1": 8795.25,
    "override_increase_1": 242.67
  },
  {
    "#": "12 Edwin St, Unit 2 (317-27-02)",
    "$": 1165200,
    "address": "12 Edwin St, Unit 2",
    "parcel_id": "317-27-02",
    "owner1": "REYES GAIDO, OSCAR EDUARDO",
    "owner2": "JUZWIAK, EMLY ELIZABETH",
    "current_taxes": 11931.65,
    "new_taxes_no_override": 12447.1,
    "override_total_1": 12800.27,
    "override_increase_1": 353.18
  },
  {
    "#": "12 Edwin St, Unit 3 (317-27-03)",
    "$": 1273900,
    "address": "12 Edwin St, Unit 3",
    "parcel_id": "317-27-03",
    "owner1": "SZALLASI, ZOLTAN",
    "owner2": "",
    "current_taxes": 13044.74,
    "new_taxes_no_override": 13608.27,
    "override_total_1": 13994.4,
    "override_increase_1": 386.12
  },
  {
    "#": "16 Edwin St (317-26-00)",
    "$": 1564800,
    "address": "16 Edwin St",
    "parcel_id": "317-26-00",
    "owner1": "HARRIS, MICHAEL H",
    "owner2": "PERALTA, MARISA",
    "current_taxes": 12388.62,
    "new_taxes_no_override": 12923.81,
    "override_total_1": 13290.51,
    "override_increase_1": 366.7
  },
  {
    "#": "14 Egmont St, Unit A1-1 (022-05-01)",
    "$": 1271200,
    "address": "14 Egmont St, Unit A1-1",
    "parcel_id": "022-05-01",
    "owner1": "PANT, BHASKAR & HEMANGINI",
    "owner2": "",
    "current_taxes": 9382.15,
    "new_taxes_no_override": 9787.46,
    "override_total_1": 10065.17,
    "override_increase_1": 277.71
  },
  {
    "#": "14 Egmont St, Unit A1-2 (022-05-02)",
    "$": 1305600,
    "address": "14 Egmont St, Unit A1-2",
    "parcel_id": "022-05-02",
    "owner1": "FEITH TR, DINA",
    "owner2": "",
    "current_taxes": 9734.41,
    "new_taxes_no_override": 10154.94,
    "override_total_1": 10443.08,
    "override_increase_1": 288.14
  },
  {
    "#": "14 Egmont St, Unit A1-3 (022-05-03)",
    "$": 1832300,
    "address": "14 Egmont St, Unit A1-3",
    "parcel_id": "022-05-03",
    "owner1": "MILLER, BRENDAN & MARCIE",
    "owner2": "",
    "current_taxes": 15127.82,
    "new_taxes_no_override": 15781.34,
    "override_total_1": 16229.13,
    "override_increase_1": 447.78
  },
  {
    "#": "14 Egmont St, Unit A2-1 (022-05-04)",
    "$": 1170700,
    "address": "14 Egmont St, Unit A2-1",
    "parcel_id": "022-05-04",
    "owner1": "EDELSON, JILL A",
    "owner2": "",
    "current_taxes": 8353.03,
    "new_taxes_no_override": 8713.88,
    "override_total_1": 8961.13,
    "override_increase_1": 247.25
  },
  {
    "#": "14 Egmont St, Unit A2-2 (022-05-05)",
    "$": 1259200,
    "address": "14 Egmont St, Unit A2-2",
    "parcel_id": "022-05-05",
    "owner1": "CHOWDHURY, DIPANJAN",
    "owner2": "",
    "current_taxes": 12894.21,
    "new_taxes_no_override": 13451.24,
    "override_total_1": 13832.91,
    "override_increase_1": 381.67
  },
  {
    "#": "14 Egmont St, Unit A2-3 (022-05-06)",
    "$": 1261400,
    "address": "14 Egmont St, Unit A2-3",
    "parcel_id": "022-05-06",
    "owner1": "GILMAN, AARON M & SUSAN K",
    "owner2": "",
    "current_taxes": 9281.8,
    "new_taxes_no_override": 9682.77,
    "override_total_1": 9957.52,
    "override_increase_1": 274.74
  },
  {
    "#": "20 Egmont St, Unit B1-1 (022-03-01)",
    "$": 1212700,
    "address": "20 Egmont St, Unit B1-1",
    "parcel_id": "022-03-01",
    "owner1": "GRINBERG TR, ROSA",
    "owner2": "",
    "current_taxes": 8783.11,
    "new_taxes_no_override": 9162.54,
    "override_total_1": 9422.52,
    "override_increase_1": 259.98
  },
  {
    "#": "20 Egmont St, Unit B1-2 (022-03-02)",
    "$": 1224900,
    "address": "20 Egmont St, Unit B1-2",
    "parcel_id": "022-03-02",
    "owner1": "BABADUSTOV, GRIGORY",
    "owner2": "",
    "current_taxes": 8908.04,
    "new_taxes_no_override": 9292.87,
    "override_total_1": 9556.55,
    "override_increase_1": 263.68
  },
  {
    "#": "20 Egmont St, Unit B1-3 (022-03-03)",
    "$": 1270700,
    "address": "20 Egmont St, Unit B1-3",
    "parcel_id": "022-03-03",
    "owner1": "HAN, MAY",
    "owner2": "",
    "current_taxes": 13011.97,
    "new_taxes_no_override": 13574.09,
    "override_total_1": 13959.24,
    "override_increase_1": 385.15
  },
  {
    "#": "20 Egmont St, Unit B2-1 (022-03-04)",
    "$": 1197000,
    "address": "20 Egmont St, Unit B2-1",
    "parcel_id": "022-03-04",
    "owner1": "SPRINGER, MICHAEL",
    "owner2": "BRENNER, TAMARA",
    "current_taxes": 8622.35,
    "new_taxes_no_override": 8994.84,
    "override_total_1": 9250.06,
    "override_increase_1": 255.22
  },
  {
    "#": "20 Egmont St, Unit B2-2 (022-03-05)",
    "$": 1270700,
    "address": "20 Egmont St, Unit B2-2",
    "parcel_id": "022-03-05",
    "owner1": "DEWINTER TRS, URBAIN J",
    "owner2": "",
    "current_taxes": 9377.03,
    "new_taxes_no_override": 9782.12,
    "override_total_1": 10059.68,
    "override_increase_1": 277.56
  },
  {
    "#": "20 Egmont St, Unit B2-3 (022-03-06)",
    "$": 1270700,
    "address": "20 Egmont St, Unit B2-3",
    "parcel_id": "022-03-06",
    "owner1": "DESAI, MICHAEL E",
    "owner2": "SIMMONS, SHERI L",
    "current_taxes": 9377.03,
    "new_taxes_no_override": 9782.12,
    "override_total_1": 10059.68,
    "override_increase_1": 277.56
  },
  {
    "#": "26 Egmont St, Unit C1-1 (022-01-01)",
    "$": 1242700,
    "address": "26 Egmont St, Unit C1-1",
    "parcel_id": "022-01-01",
    "owner1": "MADVA, ELIZABETH",
    "owner2": "MCDERMOTT, GREGORY",
    "current_taxes": 9090.31,
    "new_taxes_no_override": 9483.01,
    "override_total_1": 9752.08,
    "override_increase_1": 269.07
  },
  {
    "#": "26 Egmont St, Unit C1-2 & Pk (022-01-02)",
    "$": 1270700,
    "address": "26 Egmont St, Unit C1-2 & Pk",
    "parcel_id": "022-01-02",
    "owner1": "MANTOVANELLI, FEDERICO GIORGIO",
    "owner2": "GRIWERT, KATHERINE ELIZABETH",
    "current_taxes": 9377.03,
    "new_taxes_no_override": 9782.12,
    "override_total_1": 10059.68,
    "override_increase_1": 277.56
  },
  {
    "#": "26 Egmont St, Unit C1-3 (022-01-03)",
    "$": 1270700,
    "address": "26 Egmont St, Unit C1-3",
    "parcel_id": "022-01-03",
    "owner1": "YU, XU",
    "owner2": "LICHTERFELD, MATHIAS",
    "current_taxes": 9377.03,
    "new_taxes_no_override": 9782.12,
    "override_total_1": 10059.68,
    "override_increase_1": 277.56
  },
  {
    "#": "26 Egmont St, Unit C2-1 (022-01-04)",
    "$": 1288200,
    "address": "26 Egmont St, Unit C2-1",
    "parcel_id": "022-01-04",
    "owner1": "WANG, FIONA",
    "owner2": "",
    "current_taxes": 13191.17,
    "new_taxes_no_override": 13761.03,
    "override_total_1": 14151.49,
    "override_increase_1": 390.46
  },
  {
    "#": "26 Egmont St, Unit C2-2 (022-01-05)",
    "$": 1305700,
    "address": "26 Egmont St, Unit C2-2",
    "parcel_id": "022-01-05",
    "owner1": "XU, YIFAN",
    "owner2": "WENG, DEMING",
    "current_taxes": 13370.37,
    "new_taxes_no_override": 13947.97,
    "override_total_1": 14343.73,
    "override_increase_1": 395.76
  },
  {
    "#": "26 Egmont St, Unit C2-3 (022-01-07)",
    "$": 1305800,
    "address": "26 Egmont St, Unit C2-3",
    "parcel_id": "022-01-07",
    "owner1": "BOLINGER, CHRISTOPHER NEWTON",
    "owner2": "KRONENBERG, LEAH JOY",
    "current_taxes": 9736.46,
    "new_taxes_no_override": 10157.08,
    "override_total_1": 10445.27,
    "override_increase_1": 288.2
  },
  {
    "#": "54 Egmont St, Unit 1 (023-01-01)",
    "$": 678100,
    "address": "54 Egmont St, Unit 1",
    "parcel_id": "023-01-01",
    "owner1": "EGMONT PARK 38 CONDOS LLC",
    "owner2": "C/O MAIN STREET REALTY",
    "current_taxes": 6943.74,
    "new_taxes_no_override": 7243.71,
    "override_total_1": 7449.24,
    "override_increase_1": 205.53
  },
  {
    "#": "54 Egmont St, Unit 2 (023-01-02)",
    "$": 618900,
    "address": "54 Egmont St, Unit 2",
    "parcel_id": "023-01-02",
    "owner1": "EGMONT PARK 38 CONDOS LLC",
    "owner2": "C/O MAIN STREET REALTY",
    "current_taxes": 6337.54,
    "new_taxes_no_override": 6611.32,
    "override_total_1": 6798.91,
    "override_increase_1": 187.59
  },
  {
    "#": "54 Egmont St, Unit 21 Pk Sps (023-01-91)",
    "$": 1036700,
    "address": "54 Egmont St, Unit 21 Pk Sps",
    "parcel_id": "023-01-91",
    "owner1": "EGMONT PARK 38 CONDOS LLC",
    "owner2": "C/O MAIN ST REALTY",
    "current_taxes": 10615.81,
    "new_taxes_no_override": 11074.41,
    "override_total_1": 11388.64,
    "override_increase_1": 314.23
  },
  {
    "#": "54 Egmont St, Unit 3 (023-01-03)",
    "$": 684900,
    "address": "54 Egmont St, Unit 3",
    "parcel_id": "023-01-03",
    "owner1": "EGMONT PARK 38 CONDOS LLC",
    "owner2": "C/O MAIN STREET REALTY",
    "current_taxes": 7013.38,
    "new_taxes_no_override": 7316.36,
    "override_total_1": 7523.95,
    "override_increase_1": 207.6
  },
  {
    "#": "54 Egmont St, Unit 4 (023-01-04)",
    "$": 635900,
    "address": "54 Egmont St, Unit 4",
    "parcel_id": "023-01-04",
    "owner1": "KA FAI REALTY LLC",
    "owner2": "",
    "current_taxes": 6511.62,
    "new_taxes_no_override": 6792.92,
    "override_total_1": 6985.67,
    "override_increase_1": 192.74
  },
  {
    "#": "54 Egmont St, Unit 5 (023-01-05)",
    "$": 696800,
    "address": "54 Egmont St, Unit 5",
    "parcel_id": "023-01-05",
    "owner1": "EGMONT PARK 38 CONDOS LLC",
    "owner2": "C/O MAIN STREET REALTY",
    "current_taxes": 7135.23,
    "new_taxes_no_override": 7443.47,
    "override_total_1": 7654.67,
    "override_increase_1": 211.2
  },
  {
    "#": "54 Egmont St, Unit 6 (023-01-06)",
    "$": 635900,
    "address": "54 Egmont St, Unit 6",
    "parcel_id": "023-01-06",
    "owner1": "759 REAL ESTATE LLC",
    "owner2": "",
    "current_taxes": 6511.62,
    "new_taxes_no_override": 6792.92,
    "override_total_1": 6985.67,
    "override_increase_1": 192.74
  },
  {
    "#": "54 Egmont St, Unit 8 Pk Sps (023-01-95)",
    "$": 480000,
    "address": "54 Egmont St, Unit 8 Pk Sps",
    "parcel_id": "023-01-95",
    "owner1": "KAI FEUNG 88 LLC",
    "owner2": "",
    "current_taxes": 4915.2,
    "new_taxes_no_override": 5127.54,
    "override_total_1": 5273.03,
    "override_increase_1": 145.49
  },
  {
    "#": "54 Egmont St, Unit P19 (023-01-94)",
    "$": 49000,
    "address": "54 Egmont St, Unit P19",
    "parcel_id": "023-01-94",
    "owner1": "KA FAI REALTY LLC",
    "owner2": "",
    "current_taxes": 501.76,
    "new_taxes_no_override": 523.44,
    "override_total_1": 538.29,
    "override_increase_1": 14.85
  },
  {
    "#": "54 Egmont St, Unit P2 & P4 (023-01-92)",
    "$": 98000,
    "address": "54 Egmont St, Unit P2 & P4",
    "parcel_id": "023-01-92",
    "owner1": "WANG DAT 88 LLC",
    "owner2": "",
    "current_taxes": 1003.52,
    "new_taxes_no_override": 1046.87,
    "override_total_1": 1076.58,
    "override_increase_1": 29.7
  },
  {
    "#": "54 Egmont St, Unit P6 P8 P10 (023-01-93)",
    "$": 147000,
    "address": "54 Egmont St, Unit P6 P8 P10",
    "parcel_id": "023-01-93",
    "owner1": "KA FAI 88 LLC",
    "owner2": "",
    "current_taxes": 1505.28,
    "new_taxes_no_override": 1570.31,
    "override_total_1": 1614.86,
    "override_increase_1": 44.56
  },
  {
    "#": "56 Egmont St, Unit 1 (023-01-07)",
    "$": 678100,
    "address": "56 Egmont St, Unit 1",
    "parcel_id": "023-01-07",
    "owner1": "EGMONT PARK 38 CONDOS LLC",
    "owner2": "C/O MAIN STREET REALTY",
    "current_taxes": 6943.74,
    "new_taxes_no_override": 7243.71,
    "override_total_1": 7449.24,
    "override_increase_1": 205.53
  },
  {
    "#": "56 Egmont St, Unit 2 (023-01-08)",
    "$": 661400,
    "address": "56 Egmont St, Unit 2",
    "parcel_id": "023-01-08",
    "owner1": "WANG DAT REALTY TRUST LLC",
    "owner2": "",
    "current_taxes": 6772.74,
    "new_taxes_no_override": 7065.32,
    "override_total_1": 7265.8,
    "override_increase_1": 200.47
  },
  {
    "#": "56 Egmont St, Unit 3 (023-01-09)",
    "$": 696800,
    "address": "56 Egmont St, Unit 3",
    "parcel_id": "023-01-09",
    "owner1": "EGMONT PARK 38 CONDOS LLC",
    "owner2": "C/O MAIN STREET REALTY",
    "current_taxes": 7135.23,
    "new_taxes_no_override": 7443.47,
    "override_total_1": 7654.67,
    "override_increase_1": 211.2
  },
  {
    "#": "56 Egmont St, Unit 4 (023-01-10)",
    "$": 636300,
    "address": "56 Egmont St, Unit 4",
    "parcel_id": "023-01-10",
    "owner1": "EGMONT PARK 38 CONDOS LLC",
    "owner2": "C/O MAIN STREET REALTY",
    "current_taxes": 6515.71,
    "new_taxes_no_override": 6797.19,
    "override_total_1": 6990.05,
    "override_increase_1": 192.87
  },
  {
    "#": "56 Egmont St, Unit 5 (023-01-11)",
    "$": 684900,
    "address": "56 Egmont St, Unit 5",
    "parcel_id": "023-01-11",
    "owner1": "EGMONT PARK 38 CONDOS LLC",
    "owner2": "C/O MAIN STREET REALTY",
    "current_taxes": 7013.38,
    "new_taxes_no_override": 7316.36,
    "override_total_1": 7523.95,
    "override_increase_1": 207.6
  },
  {
    "#": "56 Egmont St, Unit 6 (023-01-12)",
    "$": 643100,
    "address": "56 Egmont St, Unit 6",
    "parcel_id": "023-01-12",
    "owner1": "EGMONT PARK 38 CONDOS LLC",
    "owner2": "C/O MAIN STREET REALTY",
    "current_taxes": 6585.34,
    "new_taxes_no_override": 6869.83,
    "override_total_1": 7064.75,
    "override_increase_1": 194.93
  },
  {
    "#": "60 Egmont St, Unit 1 (023-01-13)",
    "$": 678100,
    "address": "60 Egmont St, Unit 1",
    "parcel_id": "023-01-13",
    "owner1": "EGMONT PARK 38 CONDOS LLC",
    "owner2": "C/O MAIN STREET REALTY",
    "current_taxes": 6943.74,
    "new_taxes_no_override": 7243.71,
    "override_total_1": 7449.24,
    "override_increase_1": 205.53
  },
  {
    "#": "60 Egmont St, Unit 2 (023-01-14)",
    "$": 661400,
    "address": "60 Egmont St, Unit 2",
    "parcel_id": "023-01-14",
    "owner1": "KAI FEUNG REALTY LLC",
    "owner2": "",
    "current_taxes": 6772.74,
    "new_taxes_no_override": 7065.32,
    "override_total_1": 7265.8,
    "override_increase_1": 200.47
  },
  {
    "#": "60 Egmont St, Unit 3 (023-01-15)",
    "$": 684900,
    "address": "60 Egmont St, Unit 3",
    "parcel_id": "023-01-15",
    "owner1": "EGMONT PARK 38 CONDOS LLC",
    "owner2": "C/O MAIN STREET REALTY",
    "current_taxes": 7013.38,
    "new_taxes_no_override": 7316.36,
    "override_total_1": 7523.95,
    "override_increase_1": 207.6
  },
  {
    "#": "60 Egmont St, Unit 4 (023-01-16)",
    "$": 643100,
    "address": "60 Egmont St, Unit 4",
    "parcel_id": "023-01-16",
    "owner1": "EGMONT PARK 38 CONDOS LLC",
    "owner2": "C/O MAIN STREET REALTY",
    "current_taxes": 6585.34,
    "new_taxes_no_override": 6869.83,
    "override_total_1": 7064.75,
    "override_increase_1": 194.93
  },
  {
    "#": "60 Egmont St, Unit 5 & P29 (023-01-17)",
    "$": 717200,
    "address": "60 Egmont St, Unit 5 & P29",
    "parcel_id": "023-01-17",
    "owner1": "WEI, HONG",
    "owner2": "YUANKUN, NI",
    "current_taxes": 7344.13,
    "new_taxes_no_override": 7661.4,
    "override_total_1": 7878.78,
    "override_increase_1": 217.39
  },
  {
    "#": "60 Egmont St, Unit 6 (023-01-18)",
    "$": 643100,
    "address": "60 Egmont St, Unit 6",
    "parcel_id": "023-01-18",
    "owner1": "EGMONT PARK 38 CONDOS LLC",
    "owner2": "C/O MAIN STREET REALTY",
    "current_taxes": 6585.34,
    "new_taxes_no_override": 6869.83,
    "override_total_1": 7064.75,
    "override_increase_1": 194.93
  },
  {
    "#": "62 Egmont St, Unit 1 (023-01-19)",
    "$": 682300,
    "address": "62 Egmont St, Unit 1",
    "parcel_id": "023-01-19",
    "owner1": "EGMONT PARK 38 CONDOS LLC",
    "owner2": "C/O MAIN STREET REALTY",
    "current_taxes": 6986.75,
    "new_taxes_no_override": 7288.58,
    "override_total_1": 7495.39,
    "override_increase_1": 206.81
  },
  {
    "#": "62 Egmont St, Unit 2 (023-01-20)",
    "$": 629100,
    "address": "62 Egmont St, Unit 2",
    "parcel_id": "023-01-20",
    "owner1": "EGMONT PARK 38 CONDOS LLC",
    "owner2": "C/O MAIN STREET REALTY",
    "current_taxes": 6441.98,
    "new_taxes_no_override": 6720.27,
    "override_total_1": 6910.96,
    "override_increase_1": 190.68
  },
  {
    "#": "62 Egmont St, Unit 3 (023-01-21)",
    "$": 696800,
    "address": "62 Egmont St, Unit 3",
    "parcel_id": "023-01-21",
    "owner1": "EGMONT PARK 38 CONDOS LLC",
    "owner2": "C/O MAIN STREET REALTY",
    "current_taxes": 7135.23,
    "new_taxes_no_override": 7443.47,
    "override_total_1": 7654.67,
    "override_increase_1": 211.2
  },
  {
    "#": "62 Egmont St, Unit 4 (023-01-22)",
    "$": 643100,
    "address": "62 Egmont St, Unit 4",
    "parcel_id": "023-01-22",
    "owner1": "EGMONT PARK 38 CONDOS LLC",
    "owner2": "C/O MAIN STREET REALTY",
    "current_taxes": 6585.34,
    "new_taxes_no_override": 6869.83,
    "override_total_1": 7064.75,
    "override_increase_1": 194.93
  },
  {
    "#": "62 Egmont St, Unit 5 (023-01-23)",
    "$": 684900,
    "address": "62 Egmont St, Unit 5",
    "parcel_id": "023-01-23",
    "owner1": "EGMONT PARK 38 CONDOS LLC",
    "owner2": "C/O MAIN STREET REALTY",
    "current_taxes": 7013.38,
    "new_taxes_no_override": 7316.36,
    "override_total_1": 7523.95,
    "override_increase_1": 207.6
  },
  {
    "#": "62 Egmont St, Unit 6 (023-01-24)",
    "$": 643100,
    "address": "62 Egmont St, Unit 6",
    "parcel_id": "023-01-24",
    "owner1": "EGMONT PARK 38 CONDOS LLC",
    "owner2": "C/O MAIN STREET REALTY",
    "current_taxes": 6585.34,
    "new_taxes_no_override": 6869.83,
    "override_total_1": 7064.75,
    "override_increase_1": 194.93
  },
  {
    "#": "66 Egmont St, Unit 1 (023-01-25)",
    "$": 731200,
    "address": "66 Egmont St, Unit 1",
    "parcel_id": "023-01-25",
    "owner1": "SUGARMAN, DAVID M",
    "owner2": "KACHKA, FLORINA",
    "current_taxes": 7487.49,
    "new_taxes_no_override": 7810.95,
    "override_total_1": 8032.58,
    "override_increase_1": 221.63
  },
  {
    "#": "66 Egmont St, Unit 2 (023-01-26)",
    "$": 636300,
    "address": "66 Egmont St, Unit 2",
    "parcel_id": "023-01-26",
    "owner1": "EGMONT PARK 38 CONDOS LLC",
    "owner2": "C/O MAIN STREET REALTY",
    "current_taxes": 6515.71,
    "new_taxes_no_override": 6797.19,
    "override_total_1": 6990.05,
    "override_increase_1": 192.87
  },
  {
    "#": "66 Egmont St, Unit 3 (023-01-27)",
    "$": 731200,
    "address": "66 Egmont St, Unit 3",
    "parcel_id": "023-01-27",
    "owner1": "WANG DAT 88 LLC",
    "owner2": "",
    "current_taxes": 7487.49,
    "new_taxes_no_override": 7810.95,
    "override_total_1": 8032.58,
    "override_increase_1": 221.63
  },
  {
    "#": "66 Egmont St, Unit 4 (023-01-28)",
    "$": 643100,
    "address": "66 Egmont St, Unit 4",
    "parcel_id": "023-01-28",
    "owner1": "EGMONT PARK 38 CONDOS LLC",
    "owner2": "C/O MAIN STREET REALTY",
    "current_taxes": 6585.34,
    "new_taxes_no_override": 6869.83,
    "override_total_1": 7064.75,
    "override_increase_1": 194.93
  },
  {
    "#": "66 Egmont St, Unit 5 (023-01-29)",
    "$": 696800,
    "address": "66 Egmont St, Unit 5",
    "parcel_id": "023-01-29",
    "owner1": "EGMONT PARK 38 CONDOS LLC",
    "owner2": "C/O MAIN STREET REALTY",
    "current_taxes": 7135.23,
    "new_taxes_no_override": 7443.47,
    "override_total_1": 7654.67,
    "override_increase_1": 211.2
  },
  {
    "#": "66 Egmont St, Unit 6 (023-01-30)",
    "$": 643100,
    "address": "66 Egmont St, Unit 6",
    "parcel_id": "023-01-30",
    "owner1": "EGMONT PARK 38 CONDOS LLC",
    "owner2": "C/O MAIN STREET REALTY",
    "current_taxes": 6585.34,
    "new_taxes_no_override": 6869.83,
    "override_total_1": 7064.75,
    "override_increase_1": 194.93
  },
  {
    "#": "68 Egmont St, Unit 1 (023-01-31)",
    "$": 731200,
    "address": "68 Egmont St, Unit 1",
    "parcel_id": "023-01-31",
    "owner1": "KA FAI LLC",
    "owner2": "",
    "current_taxes": 7487.49,
    "new_taxes_no_override": 7810.95,
    "override_total_1": 8032.58,
    "override_increase_1": 221.63
  },
  {
    "#": "68 Egmont St, Unit 2 (023-01-32)",
    "$": 661400,
    "address": "68 Egmont St, Unit 2",
    "parcel_id": "023-01-32",
    "owner1": "WANG DAT 88 LLC",
    "owner2": "C/O WANG DAT REALTY TRUST LLC",
    "current_taxes": 6772.74,
    "new_taxes_no_override": 7065.32,
    "override_total_1": 7265.8,
    "override_increase_1": 200.47
  },
  {
    "#": "68 Egmont St, Unit 3 & P18 (023-01-33)",
    "$": 717200,
    "address": "68 Egmont St, Unit 3 & P18",
    "parcel_id": "023-01-33",
    "owner1": "WAXMAN, JANET",
    "owner2": "",
    "current_taxes": 3709.19,
    "new_taxes_no_override": 3869.43,
    "override_total_1": 3979.22,
    "override_increase_1": 109.79
  },
  {
    "#": "68 Egmont St, Unit 4 & P17 (023-01-34)",
    "$": 656300,
    "address": "68 Egmont St, Unit 4 & P17",
    "parcel_id": "023-01-34",
    "owner1": "INBAR, NOAH & GALIT",
    "owner2": "",
    "current_taxes": 6720.51,
    "new_taxes_no_override": 7010.84,
    "override_total_1": 7209.76,
    "override_increase_1": 198.93
  },
  {
    "#": "68 Egmont St, Unit 5 (023-01-35)",
    "$": 696800,
    "address": "68 Egmont St, Unit 5",
    "parcel_id": "023-01-35",
    "owner1": "WANG DAT REALTY TRUST LLC",
    "owner2": "",
    "current_taxes": 7135.23,
    "new_taxes_no_override": 7443.47,
    "override_total_1": 7654.67,
    "override_increase_1": 211.2
  },
  {
    "#": "68 Egmont St, Unit 6 (023-01-36)",
    "$": 635900,
    "address": "68 Egmont St, Unit 6",
    "parcel_id": "023-01-36",
    "owner1": "WANG DAT REALTY TRUST LLC",
    "owner2": "",
    "current_taxes": 6511.62,
    "new_taxes_no_override": 6792.92,
    "override_total_1": 6985.67,
    "override_increase_1": 192.74
  },
  {
    "#": "72 Egmont St, Unit 1 (023-01-37)",
    "$": 731200,
    "address": "72 Egmont St, Unit 1",
    "parcel_id": "023-01-37",
    "owner1": "KA FAI REALTY LLC",
    "owner2": "",
    "current_taxes": 7487.49,
    "new_taxes_no_override": 7810.95,
    "override_total_1": 8032.58,
    "override_increase_1": 221.63
  },
  {
    "#": "72 Egmont St, Unit 2 (023-01-38)",
    "$": 661400,
    "address": "72 Egmont St, Unit 2",
    "parcel_id": "023-01-38",
    "owner1": "WANG DAT REALTY TRUST LLC",
    "owner2": "",
    "current_taxes": 6772.74,
    "new_taxes_no_override": 7065.32,
    "override_total_1": 7265.8,
    "override_increase_1": 200.47
  },
  {
    "#": "72 Egmont St, Unit 3 (023-01-39)",
    "$": 731200,
    "address": "72 Egmont St, Unit 3",
    "parcel_id": "023-01-39",
    "owner1": "KAI FEUNG REALTY LLC",
    "owner2": "",
    "current_taxes": 7487.49,
    "new_taxes_no_override": 7810.95,
    "override_total_1": 8032.58,
    "override_increase_1": 221.63
  },
  {
    "#": "72 Egmont St, Unit 4 (023-01-40)",
    "$": 635900,
    "address": "72 Egmont St, Unit 4",
    "parcel_id": "023-01-40",
    "owner1": "BABYONYSHEV, MARINA & NADIA",
    "owner2": "",
    "current_taxes": 2876.68,
    "new_taxes_no_override": 3000.95,
    "override_total_1": 3086.1,
    "override_increase_1": 85.15
  },
  {
    "#": "72 Egmont St, Unit 5 (023-01-41)",
    "$": 769000,
    "address": "72 Egmont St, Unit 5",
    "parcel_id": "023-01-41",
    "owner1": "EGMONT PARK 38 CONDOS LLC",
    "owner2": "C/O MAIN STREET REALTY",
    "current_taxes": 7874.56,
    "new_taxes_no_override": 8214.74,
    "override_total_1": 8447.83,
    "override_increase_1": 233.09
  },
  {
    "#": "72 Egmont St, Unit 6 (023-01-42)",
    "$": 635900,
    "address": "72 Egmont St, Unit 6",
    "parcel_id": "023-01-42",
    "owner1": "WANG DAT 88 LLC",
    "owner2": "",
    "current_taxes": 6511.62,
    "new_taxes_no_override": 6792.92,
    "override_total_1": 6985.67,
    "override_increase_1": 192.74
  },
  {
    "#": "74 Egmont St, Unit 1 (023-01-43)",
    "$": 731200,
    "address": "74 Egmont St, Unit 1",
    "parcel_id": "023-01-43",
    "owner1": "WANG DAT 88 LLC",
    "owner2": "",
    "current_taxes": 7487.49,
    "new_taxes_no_override": 7810.95,
    "override_total_1": 8032.58,
    "override_increase_1": 221.63
  },
  {
    "#": "74 Egmont St, Unit 2 (023-01-44)",
    "$": 618900,
    "address": "74 Egmont St, Unit 2",
    "parcel_id": "023-01-44",
    "owner1": "KAI FEUNG REALTY LLC",
    "owner2": "",
    "current_taxes": 6337.54,
    "new_taxes_no_override": 6611.32,
    "override_total_1": 6798.91,
    "override_increase_1": 187.59
  },
  {
    "#": "74 Egmont St, Unit 3 (023-01-45)",
    "$": 731200,
    "address": "74 Egmont St, Unit 3",
    "parcel_id": "023-01-45",
    "owner1": "WANG DAT 88 LLC",
    "owner2": "",
    "current_taxes": 7487.49,
    "new_taxes_no_override": 7810.95,
    "override_total_1": 8032.58,
    "override_increase_1": 221.63
  },
  {
    "#": "74 Egmont St, Unit 4 & P7 (023-01-46)",
    "$": 656300,
    "address": "74 Egmont St, Unit 4 & P7",
    "parcel_id": "023-01-46",
    "owner1": "SANIEOFF, SIEON",
    "owner2": "",
    "current_taxes": 6720.51,
    "new_taxes_no_override": 7010.84,
    "override_total_1": 7209.76,
    "override_increase_1": 198.93
  },
  {
    "#": "74 Egmont St, Unit 5 (023-01-47)",
    "$": 684900,
    "address": "74 Egmont St, Unit 5",
    "parcel_id": "023-01-47",
    "owner1": "WANG DAT 88 LLC",
    "owner2": "",
    "current_taxes": 7013.38,
    "new_taxes_no_override": 7316.36,
    "override_total_1": 7523.95,
    "override_increase_1": 207.6
  },
  {
    "#": "74 Egmont St, Unit 6 & P23 (023-01-48)",
    "$": 663500,
    "address": "74 Egmont St, Unit 6 & P23",
    "parcel_id": "023-01-48",
    "owner1": "ANDERSON, MARTIN R",
    "owner2": "",
    "current_taxes": 3159.31,
    "new_taxes_no_override": 3295.79,
    "override_total_1": 3389.31,
    "override_increase_1": 93.52
  },
  {
    "#": "76 Egmont St, Unit 1 & 4 Park (023-01-49)",
    "$": 1776600,
    "address": "76 Egmont St, Unit 1 & 4 Park",
    "parcel_id": "023-01-49",
    "owner1": "WANG DAT 88 LLC",
    "owner2": "",
    "current_taxes": 18192.38,
    "new_taxes_no_override": 18978.29,
    "override_total_1": 19516.79,
    "override_increase_1": 538.49
  },
  {
    "#": "76 Egmont St, Unit 3 (023-01-50)",
    "$": 735500,
    "address": "76 Egmont St, Unit 3",
    "parcel_id": "023-01-50",
    "owner1": "WANG DAT 88 LLC",
    "owner2": "",
    "current_taxes": 7531.52,
    "new_taxes_no_override": 7856.88,
    "override_total_1": 8079.81,
    "override_increase_1": 222.93
  },
  {
    "#": "76 Egmont St, Unit 4 (023-01-51)",
    "$": 661400,
    "address": "76 Egmont St, Unit 4",
    "parcel_id": "023-01-51",
    "owner1": "WANG DAT 88 LLC",
    "owner2": "",
    "current_taxes": 6772.74,
    "new_taxes_no_override": 7065.32,
    "override_total_1": 7265.8,
    "override_increase_1": 200.47
  },
  {
    "#": "76 Egmont St, Unit 5 (023-01-52)",
    "$": 735500,
    "address": "76 Egmont St, Unit 5",
    "parcel_id": "023-01-52",
    "owner1": "WANG DAT 88 LLC",
    "owner2": "",
    "current_taxes": 7531.52,
    "new_taxes_no_override": 7856.88,
    "override_total_1": 8079.81,
    "override_increase_1": 222.93
  },
  {
    "#": "76 Egmont St, Unit 6 (023-01-53)",
    "$": 661400,
    "address": "76 Egmont St, Unit 6",
    "parcel_id": "023-01-53",
    "owner1": "WANG DAT 88 LLC",
    "owner2": "",
    "current_taxes": 6772.74,
    "new_taxes_no_override": 7065.32,
    "override_total_1": 7265.8,
    "override_increase_1": 200.47
  },
  {
    "#": "76 Egmont St, Unit B (023-01-54)",
    "$": 529200,
    "address": "76 Egmont St, Unit B",
    "parcel_id": "023-01-54",
    "owner1": "GREENSPAN, TIMOTHY T",
    "owner2": "",
    "current_taxes": 5419.01,
    "new_taxes_no_override": 5653.11,
    "override_total_1": 5813.51,
    "override_increase_1": 160.4
  },
  {
    "#": "5 Elba St (029-03-00)",
    "$": 2457200,
    "address": "5 Elba St",
    "parcel_id": "029-03-00",
    "owner1": "OREN, JOSEPH & BRAHA",
    "owner2": "",
    "current_taxes": 21526.79,
    "new_taxes_no_override": 22456.75,
    "override_total_1": 23093.94,
    "override_increase_1": 637.19
  },
  {
    "#": "6 Elba St (030-01-00)",
    "$": 2562900,
    "address": "6 Elba St",
    "parcel_id": "030-01-00",
    "owner1": "WJY LLC",
    "owner2": "",
    "current_taxes": 22609.16,
    "new_taxes_no_override": 23585.88,
    "override_total_1": 24255.11,
    "override_increase_1": 669.23
  },
  {
    "#": "9 Elba St (029-04-00)",
    "$": 3136700,
    "address": "9 Elba St",
    "parcel_id": "029-04-00",
    "owner1": "CHEN TRS, HENRY G",
    "owner2": "TING, ELIZABETH",
    "current_taxes": 28484.87,
    "new_taxes_no_override": 29715.42,
    "override_total_1": 30558.57,
    "override_increase_1": 843.15
  },
  {
    "#": "12 Elba St (030-11-00)",
    "$": 2785500,
    "address": "12 Elba St",
    "parcel_id": "030-11-00",
    "owner1": "EGOZY TR, YAIR",
    "owner2": "",
    "current_taxes": 24888.59,
    "new_taxes_no_override": 25963.78,
    "override_total_1": 26700.48,
    "override_increase_1": 736.7
  },
  {
    "#": "18 Elba St (030-10-00)",
    "$": 2374000,
    "address": "18 Elba St",
    "parcel_id": "030-10-00",
    "owner1": "LEVENSON, THOMAS",
    "owner2": "SEIDMAN, KATHA",
    "current_taxes": 20674.83,
    "new_taxes_no_override": 21567.98,
    "override_total_1": 22179.96,
    "override_increase_1": 611.97
  },
  {
    "#": "21 Elba St (029-05-00)",
    "$": 3029100,
    "address": "21 Elba St",
    "parcel_id": "029-05-00",
    "owner1": "PEARLMAN  TRS, CHESTER A JR & EDITH G",
    "owner2": "C/O PEARLMAN, CHARLES",
    "current_taxes": 31017.98,
    "new_taxes_no_override": 32357.96,
    "override_total_1": 33276.09,
    "override_increase_1": 918.13
  },
  {
    "#": "24 Elba St (030-09-00)",
    "$": 2732400,
    "address": "24 Elba St",
    "parcel_id": "030-09-00",
    "owner1": "IRVINGS, TRS, MARK L & SUSAN P",
    "owner2": "",
    "current_taxes": 24344.84,
    "new_taxes_no_override": 25396.54,
    "override_total_1": 26117.14,
    "override_increase_1": 720.61
  },
  {
    "#": "27 Elba St (029-06-00)",
    "$": 2744200,
    "address": "27 Elba St",
    "parcel_id": "029-06-00",
    "owner1": "ZHAN, BIHUA",
    "owner2": "",
    "current_taxes": 24465.67,
    "new_taxes_no_override": 25522.59,
    "override_total_1": 26246.77,
    "override_increase_1": 724.18
  },
  {
    "#": "1 Eliot Ave (274-05-00)",
    "$": 1195600,
    "address": "1 Eliot Ave",
    "parcel_id": "274-05-00",
    "owner1": "BIRAN, ANAT & SHAI",
    "owner2": "",
    "current_taxes": 8608.01,
    "new_taxes_no_override": 8979.88,
    "override_total_1": 9234.67,
    "override_increase_1": 254.8
  },
  {
    "#": "5 Eliot Ave (274-06-00)",
    "$": 1598800,
    "address": "5 Eliot Ave",
    "parcel_id": "274-06-00",
    "owner1": "BZ ELIOT AVE LLC",
    "owner2": "",
    "current_taxes": 16371.71,
    "new_taxes_no_override": 17078.97,
    "override_total_1": 17563.57,
    "override_increase_1": 484.6
  },
  {
    "#": "8 Eliot Ave (275-06-00)",
    "$": 1419400,
    "address": "8 Eliot Ave",
    "parcel_id": "275-06-00",
    "owner1": "MCUBE LLC",
    "owner2": "",
    "current_taxes": 14534.66,
    "new_taxes_no_override": 15162.56,
    "override_total_1": 15592.78,
    "override_increase_1": 430.23
  },
  {
    "#": "6 Eliot Cres (272-13-00)",
    "$": 1742800,
    "address": "6 Eliot Cres",
    "parcel_id": "272-13-00",
    "owner1": "HILLS JR, WILLIAM P",
    "owner2": "SCHOFFMANN, SHARON",
    "current_taxes": 14211.34,
    "new_taxes_no_override": 14825.27,
    "override_total_1": 15245.93,
    "override_increase_1": 420.66
  },
  {
    "#": "12 Eliot Cres (273-02-00)",
    "$": 1694400,
    "address": "12 Eliot Cres",
    "parcel_id": "273-02-00",
    "owner1": "KHAN, IQBAL",
    "owner2": "",
    "current_taxes": 13715.72,
    "new_taxes_no_override": 14308.24,
    "override_total_1": 14714.22,
    "override_increase_1": 405.99
  },
  {
    "#": "16 Eliot Cres (273-03-00)",
    "$": 1673200,
    "address": "16 Eliot Cres",
    "parcel_id": "273-03-00",
    "owner1": "KHAN, IQBAL",
    "owner2": "ARA, SHAMEEN",
    "current_taxes": 17133.57,
    "new_taxes_no_override": 17873.74,
    "override_total_1": 18380.89,
    "override_increase_1": 507.15
  },
  {
    "#": "19 Eliot Cres, Unit 1 & A-D (271-02-01)",
    "$": 1130300,
    "address": "19 Eliot Cres, Unit 1 & A-D",
    "parcel_id": "271-02-01",
    "owner1": "GRAHAM, ROBERT & ANALIA",
    "owner2": "",
    "current_taxes": 7939.34,
    "new_taxes_no_override": 8282.32,
    "override_total_1": 8517.32,
    "override_increase_1": 235.0
  },
  {
    "#": "19 Eliot Cres, Unit 2 & P-C (271-02-02)",
    "$": 912900,
    "address": "19 Eliot Cres, Unit 2 & P-C",
    "parcel_id": "271-02-02",
    "owner1": "GREENE, ERIC",
    "owner2": "COHEN, DALIA",
    "current_taxes": 9348.1,
    "new_taxes_no_override": 9751.94,
    "override_total_1": 10028.64,
    "override_increase_1": 276.7
  },
  {
    "#": "19 Eliot Cres, Unit 3 & P-B (271-02-03)",
    "$": 887200,
    "address": "19 Eliot Cres, Unit 3 & P-B",
    "parcel_id": "271-02-03",
    "owner1": "GUO, WEIHUI",
    "owner2": "",
    "current_taxes": 9084.93,
    "new_taxes_no_override": 9477.4,
    "override_total_1": 9746.31,
    "override_increase_1": 268.91
  },
  {
    "#": "25 Eliot Cres (271-03-00)",
    "$": 1176700,
    "address": "25 Eliot Cres",
    "parcel_id": "271-03-00",
    "owner1": "MONTERO, WILHELM C",
    "owner2": "LAM, MAN YIN MIMI",
    "current_taxes": 8414.47,
    "new_taxes_no_override": 8777.98,
    "override_total_1": 9027.04,
    "override_increase_1": 249.07
  },
  {
    "#": "29 Eliot Cres (271-03-01)",
    "$": 1297700,
    "address": "29 Eliot Cres",
    "parcel_id": "271-03-01",
    "owner1": "PRUSTY TR, DEEPANWITA",
    "owner2": "",
    "current_taxes": 13288.45,
    "new_taxes_no_override": 13862.51,
    "override_total_1": 14255.85,
    "override_increase_1": 393.34
  },
  {
    "#": "32 Eliot Cres (275-05-00)",
    "$": 1270300,
    "address": "32 Eliot Cres",
    "parcel_id": "275-05-00",
    "owner1": "KILPATRICK, ERIC",
    "owner2": "CONZON, VANESSA",
    "current_taxes": 9372.94,
    "new_taxes_no_override": 9777.85,
    "override_total_1": 10055.29,
    "override_increase_1": 277.44
  },
  {
    "#": "35 Eliot Cres (271-04-00)",
    "$": 1128400,
    "address": "35 Eliot Cres",
    "parcel_id": "271-04-00",
    "owner1": "HRESKO ETAL, PHILLIP",
    "owner2": "MANCINI, LINDA",
    "current_taxes": 7919.88,
    "new_taxes_no_override": 8262.02,
    "override_total_1": 8496.45,
    "override_increase_1": 234.43
  },
  {
    "#": "36 Eliot Cres (275-04-00)",
    "$": 1377700,
    "address": "36 Eliot Cres",
    "parcel_id": "275-04-00",
    "owner1": "SIBERT, MARTHA",
    "owner2": "",
    "current_taxes": 10472.71,
    "new_taxes_no_override": 10925.13,
    "override_total_1": 11235.12,
    "override_increase_1": 309.99
  },
  {
    "#": "39 Eliot Cres, Unit 101 (271-05-01)",
    "$": 1026400,
    "address": "39 Eliot Cres, Unit 101",
    "parcel_id": "271-05-01",
    "owner1": "MINICH, JOANNE CASE",
    "owner2": "",
    "current_taxes": 6875.4,
    "new_taxes_no_override": 7172.42,
    "override_total_1": 7375.93,
    "override_increase_1": 203.51
  },
  {
    "#": "39 Eliot Cres, Unit 201 (271-05-02)",
    "$": 858900,
    "address": "39 Eliot Cres, Unit 201",
    "parcel_id": "271-05-02",
    "owner1": "GU, APRIL",
    "owner2": "C/O LEIP",
    "current_taxes": 8795.14,
    "new_taxes_no_override": 9175.09,
    "override_total_1": 9435.43,
    "override_increase_1": 260.34
  },
  {
    "#": "39 Eliot Cres, Unit 301 (271-05-03)",
    "$": 1172900,
    "address": "39 Eliot Cres, Unit 301",
    "parcel_id": "271-05-03",
    "owner1": "WOTZAK, MARK & ERICA",
    "owner2": "",
    "current_taxes": 8375.56,
    "new_taxes_no_override": 8737.38,
    "override_total_1": 8985.3,
    "override_increase_1": 247.92
  },
  {
    "#": "40 Eliot Cres (275-03-00)",
    "$": 1325300,
    "address": "40 Eliot Cres",
    "parcel_id": "275-03-00",
    "owner1": "LINAS, BENJAMIN",
    "owner2": "GOLDMAN, DEBORAH",
    "current_taxes": 9936.14,
    "new_taxes_no_override": 10365.38,
    "override_total_1": 10659.49,
    "override_increase_1": 294.11
  },
  {
    "#": "46 Eliot Cres (275-02-00)",
    "$": 1402200,
    "address": "46 Eliot Cres",
    "parcel_id": "275-02-00",
    "owner1": "NIKOLOV, KALIN",
    "owner2": "NIKOLOVA, HRISTINA",
    "current_taxes": 10723.59,
    "new_taxes_no_override": 11186.85,
    "override_total_1": 11504.27,
    "override_increase_1": 317.42
  },
  {
    "#": "48 Eliot Cres (275-01-00)",
    "$": 1621900,
    "address": "48 Eliot Cres",
    "parcel_id": "275-01-00",
    "owner1": "HUANG, TIMOTHY & YA LIN",
    "owner2": "",
    "current_taxes": 12973.32,
    "new_taxes_no_override": 13533.77,
    "override_total_1": 13917.78,
    "override_increase_1": 384.01
  },
  {
    "#": "55 Eliot Cres, Unit 1 (271-06-01)",
    "$": 960700,
    "address": "55 Eliot Cres, Unit 1",
    "parcel_id": "271-06-01",
    "owner1": "SOHRABI, NAVID & ADRIANA",
    "owner2": "",
    "current_taxes": 9837.57,
    "new_taxes_no_override": 10262.55,
    "override_total_1": 10553.75,
    "override_increase_1": 291.19
  },
  {
    "#": "55 Eliot Cres, Unit 2 (271-06-02)",
    "$": 1289800,
    "address": "55 Eliot Cres, Unit 2",
    "parcel_id": "271-06-02",
    "owner1": "BARRIOS, JENNIFER",
    "owner2": "ROMERO, JUAN PABLO",
    "current_taxes": 13207.55,
    "new_taxes_no_override": 13778.12,
    "override_total_1": 14169.06,
    "override_increase_1": 390.94
  },
  {
    "#": "59 Eliot Cres, Unit 1 (271-07-01)",
    "$": 772400,
    "address": "59 Eliot Cres, Unit 1",
    "parcel_id": "271-07-01",
    "owner1": "LACKEY, JOANNA",
    "owner2": "",
    "current_taxes": 4274.44,
    "new_taxes_no_override": 4459.1,
    "override_total_1": 4585.62,
    "override_increase_1": 126.52
  },
  {
    "#": "59 Eliot Cres, Unit 2 (271-07-02)",
    "$": 1330400,
    "address": "59 Eliot Cres, Unit 2",
    "parcel_id": "271-07-02",
    "owner1": "SIEDLECKI, JENNIFER M",
    "owner2": "",
    "current_taxes": 9988.36,
    "new_taxes_no_override": 10419.86,
    "override_total_1": 10715.51,
    "override_increase_1": 295.66
  },
  {
    "#": "3 Eliot St (269A-36-01)",
    "$": 4304900,
    "address": "3 Eliot St",
    "parcel_id": "269A-36-01",
    "owner1": "ELIOT STREET ASSOCIATION INC",
    "owner2": "",
    "current_taxes": 44082.18,
    "new_taxes_no_override": 45986.53,
    "override_total_1": 47291.36,
    "override_increase_1": 1304.83
  },
  {
    "#": "19 Eliot St (269A-42-00)",
    "$": 1353400,
    "address": "19 Eliot St",
    "parcel_id": "269A-42-00",
    "owner1": "YEE, ROBERT S & KIM K",
    "owner2": "",
    "current_taxes": 10223.88,
    "new_taxes_no_override": 10665.55,
    "override_total_1": 10968.18,
    "override_increase_1": 302.63
  },
  {
    "#": "20 Eliot St (272-03-04)",
    "$": 1527200,
    "address": "20 Eliot St",
    "parcel_id": "272-03-04",
    "owner1": "BERMAN, JONATHAN C & ERICA M",
    "owner2": "",
    "current_taxes": 15638.53,
    "new_taxes_no_override": 16314.11,
    "override_total_1": 16777.01,
    "override_increase_1": 462.9
  },
  {
    "#": "24 Eliot St (272-02-01)",
    "$": 1367100,
    "address": "24 Eliot St",
    "parcel_id": "272-02-01",
    "owner1": "TRACY, MICHAELA S",
    "owner2": "HAYDON, TYLER R",
    "current_taxes": 10364.17,
    "new_taxes_no_override": 10811.9,
    "override_total_1": 11118.68,
    "override_increase_1": 306.78
  },
  {
    "#": "25 Eliot St (269A-43-00)",
    "$": 1532600,
    "address": "25 Eliot St",
    "parcel_id": "269A-43-00",
    "owner1": "WILLIAMS, RODERICK J & LOPAMUDRA",
    "owner2": "",
    "current_taxes": 12058.89,
    "new_taxes_no_override": 12579.83,
    "override_total_1": 12936.78,
    "override_increase_1": 356.94
  },
  {
    "#": "28 Eliot St (272-02-00)",
    "$": 1291700,
    "address": "28 Eliot St",
    "parcel_id": "272-02-00",
    "owner1": "SCOTT, BRIAN J & CANDACE J",
    "owner2": "",
    "current_taxes": 13227.01,
    "new_taxes_no_override": 13798.42,
    "override_total_1": 14189.94,
    "override_increase_1": 391.52
  },
  {
    "#": "29 Eliot St (269A-44-00)",
    "$": 1327900,
    "address": "29 Eliot St",
    "parcel_id": "269A-44-00",
    "owner1": "LU, MINGYANG",
    "owner2": "CHEN, MAN",
    "current_taxes": 9962.76,
    "new_taxes_no_override": 10393.15,
    "override_total_1": 10688.05,
    "override_increase_1": 294.9
  },
  {
    "#": "30 Eliot St (272-01-00)",
    "$": 1011800,
    "address": "30 Eliot St",
    "parcel_id": "272-01-00",
    "owner1": "MCMANUS, THOMAS O & MARY",
    "owner2": "",
    "current_taxes": 6725.9,
    "new_taxes_no_override": 7016.46,
    "override_total_1": 7215.55,
    "override_increase_1": 199.09
  },
  {
    "#": "35 Eliot St (269A-45-00)",
    "$": 1259600,
    "address": "35 Eliot St",
    "parcel_id": "269A-45-00",
    "owner1": "SULLIVAN, TIMOTHY J JR",
    "owner2": "",
    "current_taxes": 12898.3,
    "new_taxes_no_override": 13455.51,
    "override_total_1": 13837.3,
    "override_increase_1": 381.79
  },
  {
    "#": "39 Eliot St (269A-46-00)",
    "$": 3205400,
    "address": "39 Eliot St",
    "parcel_id": "269A-46-00",
    "owner1": "SIMMONS TRS, ROBERT G & DIANE C",
    "owner2": "",
    "current_taxes": 29188.36,
    "new_taxes_no_override": 30449.3,
    "override_total_1": 31313.27,
    "override_increase_1": 863.98
  },
  {
    "#": "43 Eliot St (269A-47-00)",
    "$": 1733000,
    "address": "43 Eliot St",
    "parcel_id": "269A-47-00",
    "owner1": "HELLERSTEIN, SUSAN C",
    "owner2": "TRIEDMAN, JOHN K",
    "current_taxes": 14110.99,
    "new_taxes_no_override": 14720.58,
    "override_total_1": 15138.27,
    "override_increase_1": 417.69
  },
  {
    "#": "47 Eliot St (269A-48-00)",
    "$": 1705700,
    "address": "47 Eliot St",
    "parcel_id": "269A-48-00",
    "owner1": "HONOROFF, BRADLEY M & JANE E",
    "owner2": "",
    "current_taxes": 13831.43,
    "new_taxes_no_override": 14428.95,
    "override_total_1": 14838.36,
    "override_increase_1": 409.41
  },
  {
    "#": "51 Eliot St, Unit 1 & G2 P4 (269A-49-01)",
    "$": 1429900,
    "address": "51 Eliot St, Unit 1 & G2 P4",
    "parcel_id": "269A-49-01",
    "owner1": "JONES, FRANCIS A II",
    "owner2": "THAKURIA, MANISHA",
    "current_taxes": 14642.18,
    "new_taxes_no_override": 15274.72,
    "override_total_1": 15708.13,
    "override_increase_1": 433.41
  },
  {
    "#": "51 Eliot St, Unit 2 & G1 P3 (269A-49-02)",
    "$": 1705400,
    "address": "51 Eliot St, Unit 2 & G1 P3",
    "parcel_id": "269A-49-02",
    "owner1": "WINSHALL TR, SUSAN M",
    "owner2": "",
    "current_taxes": 13828.36,
    "new_taxes_no_override": 14425.75,
    "override_total_1": 14835.06,
    "override_increase_1": 409.32
  },
  {
    "#": "55 Eliot St, Unit 1 (269A-01-01)",
    "$": 959000,
    "address": "55 Eliot St, Unit 1",
    "parcel_id": "269A-01-01",
    "owner1": "DOANE, ANDREA E",
    "owner2": "",
    "current_taxes": 6185.23,
    "new_taxes_no_override": 6452.43,
    "override_total_1": 6635.51,
    "override_increase_1": 183.08
  },
  {
    "#": "55 Eliot St, Unit 2 (269A-01-02)",
    "$": 1078800,
    "address": "55 Eliot St, Unit 2",
    "parcel_id": "269A-01-02",
    "owner1": "BICHARA-GARCIA, DAVID ALBERTO",
    "owner2": "MANDELBAUM, LUCIA",
    "current_taxes": 7411.98,
    "new_taxes_no_override": 7732.18,
    "override_total_1": 7951.57,
    "override_increase_1": 219.39
  },
  {
    "#": "60 Eliot St (271-01-00)",
    "$": 2768800,
    "address": "60 Eliot St",
    "parcel_id": "271-01-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O ELIOT STREET PARK",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "67 Eliot St (269-17-00)",
    "$": 3447100,
    "address": "67 Eliot St",
    "parcel_id": "269-17-00",
    "owner1": "67 ELIOT STREET BROOKLINE LLC",
    "owner2": "",
    "current_taxes": 35298.3,
    "new_taxes_no_override": 36823.19,
    "override_total_1": 37868.02,
    "override_increase_1": 1044.83
  },
  {
    "#": "71 Eliot St (269-18-00)",
    "$": 1129500,
    "address": "71 Eliot St",
    "parcel_id": "269-18-00",
    "owner1": "O`SHEA, JUSTIN M & LAURA P",
    "owner2": "",
    "current_taxes": 7931.15,
    "new_taxes_no_override": 8273.78,
    "override_total_1": 8508.54,
    "override_increase_1": 234.76
  },
  {
    "#": "75 Eliot St (269-18-01)",
    "$": 1185900,
    "address": "75 Eliot St",
    "parcel_id": "269-18-01",
    "owner1": "MARTINO, ANDREW P & LISA",
    "owner2": "",
    "current_taxes": 8508.68,
    "new_taxes_no_override": 8876.25,
    "override_total_1": 9128.11,
    "override_increase_1": 251.86
  },
  {
    "#": "77 Eliot St (269-19-00)",
    "$": 1361600,
    "address": "77 Eliot St",
    "parcel_id": "269-19-00",
    "owner1": "FEAU, SONIA",
    "owner2": "PETRALIA, FILIPPO",
    "current_taxes": 13942.78,
    "new_taxes_no_override": 14545.11,
    "override_total_1": 14957.81,
    "override_increase_1": 412.71
  },
  {
    "#": "79 Eliot St (269-20-00)",
    "$": 1249100,
    "address": "79 Eliot St",
    "parcel_id": "269-20-00",
    "owner1": "MILOSEVIC, BOGDAN",
    "owner2": "BOROJEVIC, KSENIJA",
    "current_taxes": 9155.85,
    "new_taxes_no_override": 9551.38,
    "override_total_1": 9822.4,
    "override_increase_1": 271.01
  },
  {
    "#": "83 Eliot St (269-21-00)",
    "$": 1197900,
    "address": "83 Eliot St",
    "parcel_id": "269-21-00",
    "owner1": "RILEY, JOHN W",
    "owner2": "NOREK, GREGORY B",
    "current_taxes": 8631.56,
    "new_taxes_no_override": 9004.44,
    "override_total_1": 9259.94,
    "override_increase_1": 255.49
  },
  {
    "#": "85 Eliot St (269-22-00)",
    "$": 1245700,
    "address": "85 Eliot St",
    "parcel_id": "269-22-00",
    "owner1": "ZURAWSKI, JONATHAN",
    "owner2": "MARIANI, JULIANA",
    "current_taxes": 9121.03,
    "new_taxes_no_override": 9515.06,
    "override_total_1": 9785.04,
    "override_increase_1": 269.98
  },
  {
    "#": "91 Eliot St (269-23-00)",
    "$": 1510600,
    "address": "91 Eliot St",
    "parcel_id": "269-23-00",
    "owner1": "SOHRABI, NAVID & ADRIANA",
    "owner2": "",
    "current_taxes": 11833.61,
    "new_taxes_no_override": 12344.82,
    "override_total_1": 12695.1,
    "override_increase_1": 350.27
  },
  {
    "#": "93 Eliot St (269-24-00)",
    "$": 1393600,
    "address": "93 Eliot St",
    "parcel_id": "269-24-00",
    "owner1": "BENHAIM, MICHAEL",
    "owner2": "DEL CASTILLO BENHAIM, SARAH",
    "current_taxes": 10635.53,
    "new_taxes_no_override": 11094.98,
    "override_total_1": 11409.8,
    "override_increase_1": 314.81
  },
  {
    "#": "95 Eliot St (269-25-04)",
    "$": 1199400,
    "address": "95 Eliot St",
    "parcel_id": "269-25-04",
    "owner1": "ROBINSON TR, MARY E",
    "owner2": "",
    "current_taxes": 8646.92,
    "new_taxes_no_override": 9020.47,
    "override_total_1": 9276.42,
    "override_increase_1": 255.95
  },
  {
    "#": "100 Eliot St (277-01-00)",
    "$": 32579700,
    "address": "100 Eliot St",
    "parcel_id": "277-01-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O HEATH SCHOOL",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "101 Eliot St (269-01-00)",
    "$": 1099600,
    "address": "101 Eliot St",
    "parcel_id": "269-01-00",
    "owner1": "JILINSKAIA TRS, EVGUENIA",
    "owner2": "MALIOUTOV, DMITRY & IGOR",
    "current_taxes": 7624.97,
    "new_taxes_no_override": 7954.37,
    "override_total_1": 8180.07,
    "override_increase_1": 225.7
  },
  {
    "#": "115 Eliot St (268-08-00)",
    "$": 1675700,
    "address": "115 Eliot St",
    "parcel_id": "268-08-00",
    "owner1": "KELLEY, TR, EUGENE J",
    "owner2": "",
    "current_taxes": 13524.23,
    "new_taxes_no_override": 14108.48,
    "override_total_1": 14508.79,
    "override_increase_1": 400.32
  },
  {
    "#": "119 Eliot St (268-01-00)",
    "$": 2088400,
    "address": "119 Eliot St",
    "parcel_id": "268-01-00",
    "owner1": "119 ELIOT STREET LLC",
    "owner2": "C/O MERRILL & MCGEARY",
    "current_taxes": 21385.22,
    "new_taxes_no_override": 22309.06,
    "override_total_1": 22942.06,
    "override_increase_1": 633.0
  },
  {
    "#": "125 Eliot St (267-37-00)",
    "$": 2049300,
    "address": "125 Eliot St",
    "parcel_id": "267-37-00",
    "owner1": "MIHALOPOULOS TR, PETER M",
    "owner2": "",
    "current_taxes": 20984.83,
    "new_taxes_no_override": 21891.37,
    "override_total_1": 22512.53,
    "override_increase_1": 621.15
  },
  {
    "#": "127 Eliot St (267-38-00)",
    "$": 1813600,
    "address": "127 Eliot St",
    "parcel_id": "267-38-00",
    "owner1": "127 ELIOT REALTY LLC",
    "owner2": "",
    "current_taxes": 18571.26,
    "new_taxes_no_override": 19373.54,
    "override_total_1": 19923.25,
    "override_increase_1": 549.71
  },
  {
    "#": "132 Eliot St (277-24-00)",
    "$": 1672400,
    "address": "132 Eliot St",
    "parcel_id": "277-24-00",
    "owner1": "BRADY-MYEROV, MONICA & ADAM",
    "owner2": "",
    "current_taxes": 17125.38,
    "new_taxes_no_override": 17865.2,
    "override_total_1": 18372.11,
    "override_increase_1": 506.91
  },
  {
    "#": "136 Eliot St (277-23-00)",
    "$": 1906900,
    "address": "136 Eliot St",
    "parcel_id": "277-23-00",
    "owner1": "PAPPAS, MATTEW & MIRIAM",
    "owner2": "",
    "current_taxes": 15891.72,
    "new_taxes_no_override": 16578.24,
    "override_total_1": 17048.64,
    "override_increase_1": 470.39
  },
  {
    "#": "140 Eliot St (277-22-00)",
    "$": 1680200,
    "address": "140 Eliot St",
    "parcel_id": "277-22-00",
    "owner1": "VERTER, BRADFORD J",
    "owner2": "FEAU, CLEMENTINE",
    "current_taxes": 17205.25,
    "new_taxes_no_override": 17948.52,
    "override_total_1": 18457.79,
    "override_increase_1": 509.28
  },
  {
    "#": "146 Eliot St (277-21-00)",
    "$": 1554400,
    "address": "146 Eliot St",
    "parcel_id": "277-21-00",
    "owner1": "LEVINE, SHARON A",
    "owner2": "OCONNELL, ANDREW",
    "current_taxes": 12282.12,
    "new_taxes_no_override": 12812.71,
    "override_total_1": 13176.26,
    "override_increase_1": 363.55
  },
  {
    "#": "149 Eliot St (267-40-00)",
    "$": 3303700,
    "address": "149 Eliot St",
    "parcel_id": "267-40-00",
    "owner1": "MERRILL TR, MICHAEL W",
    "owner2": "",
    "current_taxes": 30194.95,
    "new_taxes_no_override": 31499.37,
    "override_total_1": 32393.14,
    "override_increase_1": 893.77
  },
  {
    "#": "150 Eliot St (277-20-00)",
    "$": 2147700,
    "address": "150 Eliot St",
    "parcel_id": "277-20-00",
    "owner1": "WASSERMAN, NOAM T & CHANA S",
    "owner2": "",
    "current_taxes": 18357.51,
    "new_taxes_no_override": 19150.55,
    "override_total_1": 19693.94,
    "override_increase_1": 543.38
  },
  {
    "#": "154 Eliot St (277-19-00)",
    "$": 1812500,
    "address": "154 Eliot St",
    "parcel_id": "277-19-00",
    "owner1": "SILVER, JOYCE E",
    "owner2": "",
    "current_taxes": 14925.07,
    "new_taxes_no_override": 15569.83,
    "override_total_1": 16011.62,
    "override_increase_1": 441.78
  },
  {
    "#": "175 Eliot St (264C-10-00)",
    "$": 2304300,
    "address": "175 Eliot St",
    "parcel_id": "264C-10-00",
    "owner1": "KOMARNITSKY, PHILIP B & SVETLANA",
    "owner2": "",
    "current_taxes": 19961.1,
    "new_taxes_no_override": 20823.42,
    "override_total_1": 21414.27,
    "override_increase_1": 590.85
  },
  {
    "#": "180 Eliot St (265A-09-00)",
    "$": 1931400,
    "address": "180 Eliot St",
    "parcel_id": "265A-09-00",
    "owner1": "ZHAO TR, JING",
    "owner2": "",
    "current_taxes": 19777.54,
    "new_taxes_no_override": 20631.93,
    "override_total_1": 21217.34,
    "override_increase_1": 585.42
  },
  {
    "#": "183 Eliot St (264C-11-00)",
    "$": 2899100,
    "address": "183 Eliot St",
    "parcel_id": "264C-11-00",
    "owner1": "JOSELOW TR, MARSHA R",
    "owner2": "",
    "current_taxes": 29686.78,
    "new_taxes_no_override": 30969.25,
    "override_total_1": 31847.98,
    "override_increase_1": 878.73
  },
  {
    "#": "189 Eliot St (264C-12-00)",
    "$": 2851100,
    "address": "189 Eliot St",
    "parcel_id": "264C-12-00",
    "owner1": "SHUMAN, MELVIN R & ROBIN",
    "owner2": "",
    "current_taxes": 25560.33,
    "new_taxes_no_override": 26664.54,
    "override_total_1": 27421.12,
    "override_increase_1": 756.59
  },
  {
    "#": "194 Eliot St (265A-08-09)",
    "$": 3152400,
    "address": "194 Eliot St",
    "parcel_id": "265A-08-09",
    "owner1": "ZHAO TR, JING",
    "owner2": "",
    "current_taxes": 28645.64,
    "new_taxes_no_override": 29883.13,
    "override_total_1": 30731.04,
    "override_increase_1": 847.91
  },
  {
    "#": "195 Eliot St (264C-13-00)",
    "$": 2471900,
    "address": "195 Eliot St",
    "parcel_id": "264C-13-00",
    "owner1": "KLINE, DAVID M & AMY G",
    "owner2": "",
    "current_taxes": 21677.32,
    "new_taxes_no_override": 22613.78,
    "override_total_1": 23255.43,
    "override_increase_1": 641.65
  },
  {
    "#": "200 Eliot St (265A-07-00)",
    "$": 3227000,
    "address": "200 Eliot St",
    "parcel_id": "265A-07-00",
    "owner1": "SCHMIDT, VALENTINA & ALEXANDER",
    "owner2": "",
    "current_taxes": 29409.55,
    "new_taxes_no_override": 30680.04,
    "override_total_1": 31550.57,
    "override_increase_1": 870.52
  },
  {
    "#": "203 Eliot St (264C-14-00)",
    "$": 2333700,
    "address": "203 Eliot St",
    "parcel_id": "264C-14-00",
    "owner1": "HAMMOND, SYLVIA & CRAIG",
    "owner2": "",
    "current_taxes": 20262.15,
    "new_taxes_no_override": 21137.47,
    "override_total_1": 21737.23,
    "override_increase_1": 599.76
  },
  {
    "#": "208 Eliot St (265A-06-00)",
    "$": 3138200,
    "address": "208 Eliot St",
    "parcel_id": "265A-06-00",
    "owner1": "SHROFF, SUNIL",
    "owner2": "GROVER, MEERA",
    "current_taxes": 28500.23,
    "new_taxes_no_override": 29731.44,
    "override_total_1": 30575.05,
    "override_increase_1": 843.61
  },
  {
    "#": "230 Eliot St (265-08-00)",
    "$": 2390000,
    "address": "230 Eliot St",
    "parcel_id": "265-08-00",
    "owner1": "230 ELIOT STREET LLC",
    "owner2": "",
    "current_taxes": 24473.6,
    "new_taxes_no_override": 25530.86,
    "override_total_1": 26255.28,
    "override_increase_1": 724.42
  },
  {
    "#": "231 Eliot St (264B-24-00)",
    "$": 3211500,
    "address": "231 Eliot St",
    "parcel_id": "264B-24-00",
    "owner1": "FRENETTE, JULIA ERICKSEN",
    "owner2": "",
    "current_taxes": 32885.76,
    "new_taxes_no_override": 34306.42,
    "override_total_1": 35279.84,
    "override_increase_1": 973.42
  },
  {
    "#": "238 Eliot St (265-07-00)",
    "$": 2677200,
    "address": "238 Eliot St",
    "parcel_id": "265-07-00",
    "owner1": "TONG, JASON JU CHUAN",
    "owner2": "SHEN, EVELYN DAWN",
    "current_taxes": 23779.59,
    "new_taxes_no_override": 24806.87,
    "override_total_1": 25510.74,
    "override_increase_1": 703.88
  },
  {
    "#": "246 Eliot St (265-05-06)",
    "$": 3224000,
    "address": "246 Eliot St",
    "parcel_id": "265-05-06",
    "owner1": "SCHMIDT-HELLERAU LIFE ESTATE, CORDELIA",
    "owner2": "",
    "current_taxes": 29378.83,
    "new_taxes_no_override": 30648.0,
    "override_total_1": 31517.61,
    "override_increase_1": 869.61
  },
  {
    "#": "260 Eliot St (265-03-00)",
    "$": 3903000,
    "address": "260 Eliot St",
    "parcel_id": "265-03-00",
    "owner1": "CALMAS, JAMES J & RACHEL J",
    "owner2": "",
    "current_taxes": 36331.79,
    "new_taxes_no_override": 37901.32,
    "override_total_1": 38976.74,
    "override_increase_1": 1075.42
  },
  {
    "#": "261 Eliot St (264A-08-00)",
    "$": 2710100,
    "address": "261 Eliot St",
    "parcel_id": "264A-08-00",
    "owner1": "SANDS, AMY GROSSMAN",
    "owner2": "",
    "current_taxes": 24116.49,
    "new_taxes_no_override": 25158.32,
    "override_total_1": 25872.17,
    "override_increase_1": 713.85
  },
  {
    "#": "267 Eliot St (264A-09-00)",
    "$": 2775300,
    "address": "267 Eliot St",
    "parcel_id": "264A-09-00",
    "owner1": "RIZIKA, ADAM W",
    "owner2": "MINOSH, ELLEN",
    "current_taxes": 24784.14,
    "new_taxes_no_override": 25854.81,
    "override_total_1": 26588.43,
    "override_increase_1": 733.61
  },
  {
    "#": "270 Eliot St (265-02-00)",
    "$": 2564200,
    "address": "270 Eliot St",
    "parcel_id": "265-02-00",
    "owner1": "PROBSTEIN, SIDNEY C & LAURIE C",
    "owner2": "",
    "current_taxes": 22622.47,
    "new_taxes_no_override": 23599.76,
    "override_total_1": 24269.39,
    "override_increase_1": 669.63
  },
  {
    "#": "273 Eliot St (264A-10-00)",
    "$": 2719500,
    "address": "273 Eliot St",
    "parcel_id": "264A-10-00",
    "owner1": "GREENBERG, JEFFREY OLIVER",
    "owner2": "FREEDMAN, RACHEL ANN",
    "current_taxes": 24212.75,
    "new_taxes_no_override": 25258.74,
    "override_total_1": 25975.44,
    "override_increase_1": 716.7
  },
  {
    "#": "281 Eliot St (264A-11-00)",
    "$": 2242800,
    "address": "281 Eliot St",
    "parcel_id": "264A-11-00",
    "owner1": "SANIEOFF, FARAHNAZ P",
    "owner2": "",
    "current_taxes": 19331.34,
    "new_taxes_no_override": 20166.45,
    "override_total_1": 20738.66,
    "override_increase_1": 572.21
  },
  {
    "#": "290 Eliot St (264D-05-00)",
    "$": 1497100,
    "address": "290 Eliot St",
    "parcel_id": "264D-05-00",
    "owner1": "WONG, DONNA",
    "owner2": "MILES, MILO",
    "current_taxes": 11695.37,
    "new_taxes_no_override": 12200.61,
    "override_total_1": 12546.79,
    "override_increase_1": 346.18
  },
  {
    "#": "300 Eliot St (264D-01-01)",
    "$": 44900,
    "address": "300 Eliot St",
    "parcel_id": "264D-01-01",
    "owner1": "COMMONWEALTH OF MASSACHUSETTS",
    "owner2": "C/O MASS BAY TRANSIT AUTHORITY",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "101 Ellery Ct (388-01-02)",
    "$": 7911400,
    "address": "101 Ellery Ct",
    "parcel_id": "388-01-02",
    "owner1": "ROSB REALTY LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 81012.74,
    "new_taxes_no_override": 84512.49,
    "override_total_1": 86910.47,
    "override_increase_1": 2397.98
  },
  {
    "#": "4 Elm St (181-08-00)",
    "$": 1484500,
    "address": "4 Elm St",
    "parcel_id": "181-08-00",
    "owner1": "TULCHINSKY, JULIA",
    "owner2": "",
    "current_taxes": 11566.35,
    "new_taxes_no_override": 12066.02,
    "override_total_1": 12408.38,
    "override_increase_1": 342.36
  },
  {
    "#": "5 Elm St, Unit 1 & Pk A-B (182-01-03)",
    "$": 1170300,
    "address": "5 Elm St, Unit 1 & Pk A-B",
    "parcel_id": "182-01-03",
    "owner1": "ROWELL TRS, TIMOTHY W & KIMBERLY A",
    "owner2": "",
    "current_taxes": 8348.94,
    "new_taxes_no_override": 8709.61,
    "override_total_1": 8956.74,
    "override_increase_1": 247.13
  },
  {
    "#": "5 Elm St, Unit 2 & Pk E-F (182-01-04)",
    "$": 1161500,
    "address": "5 Elm St, Unit 2 & Pk E-F",
    "parcel_id": "182-01-04",
    "owner1": "JONES, TIMOTHY",
    "owner2": "TRUFANOVA, VERONIKA",
    "current_taxes": 8258.83,
    "new_taxes_no_override": 8615.61,
    "override_total_1": 8860.07,
    "override_increase_1": 244.46
  },
  {
    "#": "5 Elm St, Unit 3 & Pk C-D (182-01-05)",
    "$": 1167400,
    "address": "5 Elm St, Unit 3 & Pk C-D",
    "parcel_id": "182-01-05",
    "owner1": "HA, PAUL",
    "owner2": "LUNDSAGER, EVA",
    "current_taxes": 8319.24,
    "new_taxes_no_override": 8678.63,
    "override_total_1": 8924.88,
    "override_increase_1": 246.25
  },
  {
    "#": "6 Elm St (181-07-00)",
    "$": 2601000,
    "address": "6 Elm St",
    "parcel_id": "181-07-00",
    "owner1": "JSCW INVESTMENTS LLC",
    "owner2": "",
    "current_taxes": 26634.24,
    "new_taxes_no_override": 27784.84,
    "override_total_1": 28573.21,
    "override_increase_1": 788.37
  },
  {
    "#": "7 Elm St, Unit 1 & P5 P6 (182-02-01)",
    "$": 1059100,
    "address": "7 Elm St, Unit 1 & P5 P6",
    "parcel_id": "182-02-01",
    "owner1": "ROMANO, TERESE N",
    "owner2": "",
    "current_taxes": 7210.25,
    "new_taxes_no_override": 7521.73,
    "override_total_1": 7735.16,
    "override_increase_1": 213.42
  },
  {
    "#": "7 Elm St, Unit 2 & P3 P4 (182-02-02)",
    "$": 1042400,
    "address": "7 Elm St, Unit 2 & P3 P4",
    "parcel_id": "182-02-02",
    "owner1": "RAYBOULD, MICHAEL J & TOBY A",
    "owner2": "",
    "current_taxes": 7039.24,
    "new_taxes_no_override": 7343.34,
    "override_total_1": 7551.7,
    "override_increase_1": 208.36
  },
  {
    "#": "7 Elm St, Unit 3 & P1-P2 (182-02-03)",
    "$": 1443100,
    "address": "7 Elm St, Unit 3 & P1-P2",
    "parcel_id": "182-02-03",
    "owner1": "NUECES, DENISE DE LAS",
    "owner2": "ORTIZ, FAUSTO",
    "current_taxes": 11142.41,
    "new_taxes_no_override": 11623.76,
    "override_total_1": 11953.58,
    "override_increase_1": 329.82
  },
  {
    "#": "8 Elm St, Unit 1 (180-08-01)",
    "$": 1684000,
    "address": "8 Elm St, Unit 1",
    "parcel_id": "180-08-01",
    "owner1": "MATTHEWS, CHRISTOPHER & CHRISTINE",
    "owner2": "",
    "current_taxes": 13609.23,
    "new_taxes_no_override": 14197.15,
    "override_total_1": 14599.98,
    "override_increase_1": 402.83
  },
  {
    "#": "10 Elm St, Unit 2 (180-08-02)",
    "$": 1670400,
    "address": "10 Elm St, Unit 2",
    "parcel_id": "180-08-02",
    "owner1": "KONG, TIANQING",
    "owner2": "XU, DAWSON",
    "current_taxes": 17104.9,
    "new_taxes_no_override": 17843.83,
    "override_total_1": 18350.14,
    "override_increase_1": 506.31
  },
  {
    "#": "13 Elm St (179-04-00)",
    "$": 2037500,
    "address": "13 Elm St",
    "parcel_id": "179-04-00",
    "owner1": "NASSER TRS, RICHARD M",
    "owner2": "WYNN, KATHLEEN M",
    "current_taxes": 17229.07,
    "new_taxes_no_override": 17973.37,
    "override_total_1": 18483.35,
    "override_increase_1": 509.98
  },
  {
    "#": "14 Elm St, Unit 1 (180-07-02)",
    "$": 2020100,
    "address": "14 Elm St, Unit 1",
    "parcel_id": "180-07-02",
    "owner1": "COHEN, ALEXANDER LORIN PASTOROK",
    "owner2": "TAYLOR, ELLA MARIAH",
    "current_taxes": 17050.89,
    "new_taxes_no_override": 17787.49,
    "override_total_1": 18292.19,
    "override_increase_1": 504.71
  },
  {
    "#": "15 Elm St (179-04-01)",
    "$": 2598900,
    "address": "15 Elm St",
    "parcel_id": "179-04-01",
    "owner1": "COLEMAN TRS, BRADLEY I",
    "owner2": "ROTNER , ANNIE S",
    "current_taxes": 22977.8,
    "new_taxes_no_override": 23970.44,
    "override_total_1": 24650.58,
    "override_increase_1": 680.14
  },
  {
    "#": "16 Elm St, Unit 2 (180-07-01)",
    "$": 1687600,
    "address": "16 Elm St, Unit 2",
    "parcel_id": "180-07-01",
    "owner1": "BECKER, ANDREW S & DEBORAH L",
    "owner2": "",
    "current_taxes": 13646.09,
    "new_taxes_no_override": 14235.6,
    "override_total_1": 14639.53,
    "override_increase_1": 403.92
  },
  {
    "#": "18 Elm St, Unit 1 (180-06-02)",
    "$": 1843300,
    "address": "18 Elm St, Unit 1",
    "parcel_id": "180-06-02",
    "owner1": "KITOV, REUVEN & ADI",
    "owner2": "",
    "current_taxes": 15240.46,
    "new_taxes_no_override": 15898.85,
    "override_total_1": 16349.97,
    "override_increase_1": 451.12
  },
  {
    "#": "19 Elm St (179-05-00)",
    "$": 1791800,
    "address": "19 Elm St",
    "parcel_id": "179-05-00",
    "owner1": "MACDONALD, BRYAN",
    "owner2": "LEHOCZKY, JESSICA",
    "current_taxes": 14713.1,
    "new_taxes_no_override": 15348.71,
    "override_total_1": 15784.21,
    "override_increase_1": 435.51
  },
  {
    "#": "20 Elm St, Unit 2 (180-06-01)",
    "$": 1632000,
    "address": "20 Elm St, Unit 2",
    "parcel_id": "180-06-01",
    "owner1": "WARD ET AL TRS, WILLIAM T",
    "owner2": "WISLER, MARTHA J",
    "current_taxes": 13076.75,
    "new_taxes_no_override": 13641.67,
    "override_total_1": 14028.74,
    "override_increase_1": 387.07
  },
  {
    "#": "23 Elm St (179-05-01)",
    "$": 2825300,
    "address": "23 Elm St",
    "parcel_id": "179-05-01",
    "owner1": "HARTIGAN, JOSEPH A JR & MARY ELLEN",
    "owner2": "",
    "current_taxes": 25296.14,
    "new_taxes_no_override": 26388.93,
    "override_total_1": 27137.7,
    "override_increase_1": 748.77
  },
  {
    "#": "24 Elm St, Unit 1 (180-05-02)",
    "$": 1931700,
    "address": "24 Elm St, Unit 1",
    "parcel_id": "180-05-02",
    "owner1": "LANSBURY, TONI F & PETER T",
    "owner2": "",
    "current_taxes": 16145.67,
    "new_taxes_no_override": 16843.16,
    "override_total_1": 17321.07,
    "override_increase_1": 477.91
  },
  {
    "#": "26 Elm St, Unit 2 (180-05-01)",
    "$": 1919700,
    "address": "26 Elm St, Unit 2",
    "parcel_id": "180-05-01",
    "owner1": "ENGLANDER, SCOTT L",
    "owner2": "BRUNI, JENNIFER",
    "current_taxes": 16022.79,
    "new_taxes_no_override": 16714.97,
    "override_total_1": 17189.25,
    "override_increase_1": 474.27
  },
  {
    "#": "27 Elm St (179-06-00)",
    "$": 1817500,
    "address": "27 Elm St",
    "parcel_id": "179-06-00",
    "owner1": "LEE TRS, DAVID K Y & MARGARET H",
    "owner2": "",
    "current_taxes": 18611.2,
    "new_taxes_no_override": 19415.2,
    "override_total_1": 19966.1,
    "override_increase_1": 550.89
  },
  {
    "#": "29 Elm St, Unit 1 (179-07-01)",
    "$": 1758400,
    "address": "29 Elm St, Unit 1",
    "parcel_id": "179-07-01",
    "owner1": "BERNARD, NATHAN A & CATHERINE K",
    "owner2": "",
    "current_taxes": 14371.08,
    "new_taxes_no_override": 14991.91,
    "override_total_1": 15417.29,
    "override_increase_1": 425.38
  },
  {
    "#": "29 Elm St, Unit 2 (179-07-02)",
    "$": 1418300,
    "address": "29 Elm St, Unit 2",
    "parcel_id": "179-07-02",
    "owner1": "MCGOVERN, CAITRIONA",
    "owner2": "OKE, ISDIN",
    "current_taxes": 14523.39,
    "new_taxes_no_override": 15150.8,
    "override_total_1": 15580.69,
    "override_increase_1": 429.89
  },
  {
    "#": "29 Elm St, Unit 3 (179-07-03)",
    "$": 1652900,
    "address": "29 Elm St, Unit 3",
    "parcel_id": "179-07-03",
    "owner1": "WICHS, DANIEL",
    "owner2": "LIBBY, ELIZABETH",
    "current_taxes": 13290.76,
    "new_taxes_no_override": 13864.92,
    "override_total_1": 14258.33,
    "override_increase_1": 393.41
  },
  {
    "#": "31 Elm St (179-08-00)",
    "$": 2814300,
    "address": "31 Elm St",
    "parcel_id": "179-08-00",
    "owner1": "CEELY, JONATHA K",
    "owner2": "",
    "current_taxes": 25183.5,
    "new_taxes_no_override": 26271.43,
    "override_total_1": 27016.86,
    "override_increase_1": 745.43
  },
  {
    "#": "35 Elm St, Unit 35 (179-09-01)",
    "$": 1495900,
    "address": "35 Elm St, Unit 35",
    "parcel_id": "179-09-01",
    "owner1": "HOCHLEUTNER TRS, BRIAN R & CLAIRE W",
    "owner2": "",
    "current_taxes": 11683.08,
    "new_taxes_no_override": 12187.79,
    "override_total_1": 12533.61,
    "override_increase_1": 345.82
  },
  {
    "#": "37 Elm St, Unit 37 (179-09-02)",
    "$": 1466500,
    "address": "37 Elm St, Unit 37",
    "parcel_id": "179-09-02",
    "owner1": "KELLY, TIMOTHY L & LISA R",
    "owner2": "",
    "current_taxes": 11382.03,
    "new_taxes_no_override": 11873.73,
    "override_total_1": 12210.64,
    "override_increase_1": 336.91
  },
  {
    "#": "6 Emerson St (179-19-00)",
    "$": 2143900,
    "address": "6 Emerson St",
    "parcel_id": "179-19-00",
    "owner1": "BURRINGTON TR, STEPHEN H",
    "owner2": "SWAINE TR, ABIGAIL A",
    "current_taxes": 18318.6,
    "new_taxes_no_override": 19109.96,
    "override_total_1": 19652.19,
    "override_increase_1": 542.23
  },
  {
    "#": "16 Emerson St (179-18-00)",
    "$": 3389100,
    "address": "16 Emerson St",
    "parcel_id": "179-18-00",
    "owner1": "GRANT, D GRAEME",
    "owner2": "SAILLANT, MEREDITH L",
    "current_taxes": 31069.45,
    "new_taxes_no_override": 32411.65,
    "override_total_1": 33331.31,
    "override_increase_1": 919.66
  },
  {
    "#": "17 Emerson St (178-01-00)",
    "$": 8349600,
    "address": "17 Emerson St",
    "parcel_id": "178-01-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O FORD PLAYGRND/EMERSON GARDENS",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "22 Emerson St (179-17-00)",
    "$": 3339300,
    "address": "22 Emerson St",
    "parcel_id": "179-17-00",
    "owner1": "OSBORN, LYNN C & WILLIAM C",
    "owner2": "",
    "current_taxes": 30559.5,
    "new_taxes_no_override": 31879.67,
    "override_total_1": 32784.23,
    "override_increase_1": 904.56
  },
  {
    "#": "28 Emerson St (179-16-00)",
    "$": 3137400,
    "address": "28 Emerson St",
    "parcel_id": "179-16-00",
    "owner1": "LAPIDUS TR, FOTOULLA NICOLE",
    "owner2": "",
    "current_taxes": 32126.98,
    "new_taxes_no_override": 33514.87,
    "override_total_1": 34465.82,
    "override_increase_1": 950.96
  },
  {
    "#": "34 Emerson St (179-15-00)",
    "$": 3861200,
    "address": "34 Emerson St",
    "parcel_id": "179-15-00",
    "owner1": "ENGELHORN, ANNEKATRIN",
    "owner2": "C/O JAMES GEARY",
    "current_taxes": 39538.69,
    "new_taxes_no_override": 41246.76,
    "override_total_1": 42417.11,
    "override_increase_1": 1170.35
  },
  {
    "#": "3 Englewood Ave, Unit 10 (108-15-27)",
    "$": 479200,
    "address": "3 Englewood Ave, Unit 10",
    "parcel_id": "108-15-27",
    "owner1": "QUIGLEY REALTY LLC",
    "owner2": "",
    "current_taxes": 4907.01,
    "new_taxes_no_override": 5118.99,
    "override_total_1": 5264.24,
    "override_increase_1": 145.25
  },
  {
    "#": "3 Englewood Ave, Unit 11 (108-15-28)",
    "$": 411300,
    "address": "3 Englewood Ave, Unit 11",
    "parcel_id": "108-15-28",
    "owner1": "RAJANI, SHONALI",
    "owner2": "",
    "current_taxes": 576.78,
    "new_taxes_no_override": 601.7,
    "override_total_1": 618.77,
    "override_increase_1": 17.07
  },
  {
    "#": "3 Englewood Ave, Unit 12 (108-15-29)",
    "$": 422900,
    "address": "3 Englewood Ave, Unit 12",
    "parcel_id": "108-15-29",
    "owner1": "SIOUFI, ET AL, HABIB A",
    "owner2": "",
    "current_taxes": 4330.5,
    "new_taxes_no_override": 4517.58,
    "override_total_1": 4645.76,
    "override_increase_1": 128.18
  },
  {
    "#": "3 Englewood Ave, Unit 12A (108-15-30)",
    "$": 483600,
    "address": "3 Englewood Ave, Unit 12A",
    "parcel_id": "108-15-30",
    "owner1": "GUAN, SHAWN H",
    "owner2": "LI, XIAOTONG",
    "current_taxes": 4952.06,
    "new_taxes_no_override": 5165.99,
    "override_total_1": 5312.57,
    "override_increase_1": 146.58
  },
  {
    "#": "3 Englewood Ave, Unit 14 (108-15-31)",
    "$": 425500,
    "address": "3 Englewood Ave, Unit 14",
    "parcel_id": "108-15-31",
    "owner1": "PESELMAN, ALEXANDER",
    "owner2": "",
    "current_taxes": 4357.12,
    "new_taxes_no_override": 4545.35,
    "override_total_1": 4674.32,
    "override_increase_1": 128.97
  },
  {
    "#": "3 Englewood Ave, Unit 15 (108-15-32)",
    "$": 421200,
    "address": "3 Englewood Ave, Unit 15",
    "parcel_id": "108-15-32",
    "owner1": "ZUO, DONGMEI",
    "owner2": "ROLFS, ANDREAS",
    "current_taxes": 4313.09,
    "new_taxes_no_override": 4499.42,
    "override_total_1": 4627.08,
    "override_increase_1": 127.67
  },
  {
    "#": "3 Englewood Ave, Unit 16 (108-15-33)",
    "$": 451200,
    "address": "3 Englewood Ave, Unit 16",
    "parcel_id": "108-15-33",
    "owner1": "TOW, RANDOLPH & SUSAN",
    "owner2": "",
    "current_taxes": 4620.29,
    "new_taxes_no_override": 4819.89,
    "override_total_1": 4956.65,
    "override_increase_1": 136.76
  },
  {
    "#": "3 Englewood Ave, Unit 1B (108-15-20)",
    "$": 570500,
    "address": "3 Englewood Ave, Unit 1B",
    "parcel_id": "108-15-20",
    "owner1": "HAMMITT, ZACHARY TAYLOR",
    "owner2": "FERNANDEZ, VICTORIA MYNN",
    "current_taxes": 2206.99,
    "new_taxes_no_override": 2302.33,
    "override_total_1": 2367.66,
    "override_increase_1": 65.33
  },
  {
    "#": "3 Englewood Ave, Unit 3 (108-15-21)",
    "$": 732900,
    "address": "3 Englewood Ave, Unit 3",
    "parcel_id": "108-15-21",
    "owner1": "AJ HOLDINGS LLC",
    "owner2": "",
    "current_taxes": 7504.9,
    "new_taxes_no_override": 7829.11,
    "override_total_1": 8051.26,
    "override_increase_1": 222.15
  },
  {
    "#": "3 Englewood Ave, Unit 4 (108-15-22)",
    "$": 759600,
    "address": "3 Englewood Ave, Unit 4",
    "parcel_id": "108-15-22",
    "owner1": "STOLYAR TRS, ARKADIY & NATALYA",
    "owner2": "",
    "current_taxes": 4143.37,
    "new_taxes_no_override": 4322.36,
    "override_total_1": 4445.01,
    "override_increase_1": 122.64
  },
  {
    "#": "3 Englewood Ave, Unit 5 (108-15-23)",
    "$": 771900,
    "address": "3 Englewood Ave, Unit 5",
    "parcel_id": "108-15-23",
    "owner1": "3 ENGLEWOOD AVENUE #5 LLC",
    "owner2": "",
    "current_taxes": 7904.26,
    "new_taxes_no_override": 8245.72,
    "override_total_1": 8479.69,
    "override_increase_1": 233.97
  },
  {
    "#": "3 Englewood Ave, Unit 6 (108-15-24)",
    "$": 461800,
    "address": "3 Englewood Ave, Unit 6",
    "parcel_id": "108-15-24",
    "owner1": "SOOD, GAURAV",
    "owner2": "",
    "current_taxes": 1093.9,
    "new_taxes_no_override": 1141.16,
    "override_total_1": 1173.54,
    "override_increase_1": 32.38
  },
  {
    "#": "3 Englewood Ave, Unit 8 (108-15-25)",
    "$": 449700,
    "address": "3 Englewood Ave, Unit 8",
    "parcel_id": "108-15-25",
    "owner1": "LI, AMY",
    "owner2": "",
    "current_taxes": 4604.93,
    "new_taxes_no_override": 4803.86,
    "override_total_1": 4940.17,
    "override_increase_1": 136.31
  },
  {
    "#": "3 Englewood Ave, Unit 9 (108-15-26)",
    "$": 485700,
    "address": "3 Englewood Ave, Unit 9",
    "parcel_id": "108-15-26",
    "owner1": "SUDALTER, TRS, MELVYN S & ALISON",
    "owner2": "",
    "current_taxes": 4973.57,
    "new_taxes_no_override": 5188.43,
    "override_total_1": 5335.65,
    "override_increase_1": 147.22
  },
  {
    "#": "3 Englewood Ave, Unit Bb (108-15-18)",
    "$": 313200,
    "address": "3 Englewood Ave, Unit Bb",
    "parcel_id": "108-15-18",
    "owner1": "MCNAMARA, MATTHEW & FRANK",
    "owner2": "",
    "current_taxes": 3207.17,
    "new_taxes_no_override": 3345.72,
    "override_total_1": 3440.65,
    "override_increase_1": 94.93
  },
  {
    "#": "3 Englewood Ave, Unit Gb (108-15-19)",
    "$": 382700,
    "address": "3 Englewood Ave, Unit Gb",
    "parcel_id": "108-15-19",
    "owner1": "KERPAN, JOHN P",
    "owner2": "",
    "current_taxes": 3918.85,
    "new_taxes_no_override": 4088.14,
    "override_total_1": 4204.14,
    "override_increase_1": 116.0
  },
  {
    "#": "11 Englewood Ave (108-16-00)",
    "$": 5221300,
    "address": "11 Englewood Ave",
    "parcel_id": "108-16-00",
    "owner1": "SANIEOFF TR, SYROOS",
    "owner2": "",
    "current_taxes": 53466.11,
    "new_taxes_no_override": 55775.85,
    "override_total_1": 57358.44,
    "override_increase_1": 1582.6
  },
  {
    "#": "15 Englewood Ave (108-25-00)",
    "$": 3682600,
    "address": "15 Englewood Ave",
    "parcel_id": "108-25-00",
    "owner1": "ENGLEWOOD 15 DEVELOPMENT LLC",
    "owner2": "",
    "current_taxes": 37709.82,
    "new_taxes_no_override": 39338.88,
    "override_total_1": 40455.09,
    "override_increase_1": 1116.21
  },
  {
    "#": "17 Englewood Ave (108-18-00)",
    "$": 3738800,
    "address": "17 Englewood Ave",
    "parcel_id": "108-18-00",
    "owner1": "RUSSELL, ET AL TRS, WILLIAM W",
    "owner2": "C/O FIELD CORP",
    "current_taxes": 38285.31,
    "new_taxes_no_override": 39939.24,
    "override_total_1": 41072.48,
    "override_increase_1": 1133.25
  },
  {
    "#": "19 Englewood Ave, Unit 19-1 & P77 (108-19-03)",
    "$": 579600,
    "address": "19 Englewood Ave, Unit 19-1 & P77",
    "parcel_id": "108-19-03",
    "owner1": "SINGH, BHAGAT & VANDANA",
    "owner2": "",
    "current_taxes": 5935.1,
    "new_taxes_no_override": 6191.5,
    "override_total_1": 6367.18,
    "override_increase_1": 175.68
  },
  {
    "#": "19 Englewood Ave, Unit 19-2 P-15 (108-19-04)",
    "$": 572400,
    "address": "19 Englewood Ave, Unit 19-2 P-15",
    "parcel_id": "108-19-04",
    "owner1": "HUANG, LIBO",
    "owner2": "LIANG, HAIYAN",
    "current_taxes": 5861.38,
    "new_taxes_no_override": 6114.59,
    "override_total_1": 6288.09,
    "override_increase_1": 173.5
  },
  {
    "#": "19 Englewood Ave, Unit 19-3 & P4 (108-19-05)",
    "$": 572400,
    "address": "19 Englewood Ave, Unit 19-3 & P4",
    "parcel_id": "108-19-05",
    "owner1": "GUO, JIANG",
    "owner2": "WANG, SHANSHAN",
    "current_taxes": 2226.44,
    "new_taxes_no_override": 2322.62,
    "override_total_1": 2388.52,
    "override_increase_1": 65.9
  },
  {
    "#": "19 Englewood Ave, Unit 19-4 & P72 (108-19-06)",
    "$": 572400,
    "address": "19 Englewood Ave, Unit 19-4 & P72",
    "parcel_id": "108-19-06",
    "owner1": "LOUI  LIFE ESTATE, CARLOS & MUSHAN",
    "owner2": "",
    "current_taxes": 2226.44,
    "new_taxes_no_override": 2322.62,
    "override_total_1": 2388.52,
    "override_increase_1": 65.9
  },
  {
    "#": "19 Englewood Ave, Unit 19-5 & P61 (108-19-07)",
    "$": 584300,
    "address": "19 Englewood Ave, Unit 19-5 & P61",
    "parcel_id": "108-19-07",
    "owner1": "BOYAR, RACHEL",
    "owner2": "",
    "current_taxes": 5983.23,
    "new_taxes_no_override": 6241.71,
    "override_total_1": 6418.81,
    "override_increase_1": 177.1
  },
  {
    "#": "19 Englewood Ave, Unit 19-6 & P5 (108-19-08)",
    "$": 584300,
    "address": "19 Englewood Ave, Unit 19-6 & P5",
    "parcel_id": "108-19-08",
    "owner1": "FEENEY, MICHAEL J",
    "owner2": "BARRY, KAREN M",
    "current_taxes": 2348.3,
    "new_taxes_no_override": 2449.75,
    "override_total_1": 2519.26,
    "override_increase_1": 69.51
  },
  {
    "#": "19 Englewood Ave, Unit 19-7 & P2 (108-19-09)",
    "$": 520200,
    "address": "19 Englewood Ave, Unit 19-7 & P2",
    "parcel_id": "108-19-09",
    "owner1": "ROUKHADZE, TOM",
    "owner2": "ROUKHADZE-BEKACHVILI, NINO",
    "current_taxes": 5326.85,
    "new_taxes_no_override": 5556.97,
    "override_total_1": 5714.64,
    "override_increase_1": 157.67
  },
  {
    "#": "20 Englewood Ave (110-02-00)",
    "$": 14060700,
    "address": "20 Englewood Ave",
    "parcel_id": "110-02-00",
    "owner1": "BENGLEWOOD LLC",
    "owner2": "C/O FEUERMAN, JEFFREY",
    "current_taxes": 143981.57,
    "new_taxes_no_override": 150201.57,
    "override_total_1": 154463.43,
    "override_increase_1": 4261.85
  },
  {
    "#": "21 Englewood Ave, Unit 21-1 & P76 (108-19-10)",
    "$": 589800,
    "address": "21 Englewood Ave, Unit 21-1 & P76",
    "parcel_id": "108-19-10",
    "owner1": "SANTOS, PATRICIA & MARIO C BUENO DOS & RUTE",
    "owner2": "",
    "current_taxes": 6039.55,
    "new_taxes_no_override": 6300.46,
    "override_total_1": 6479.23,
    "override_increase_1": 178.77
  },
  {
    "#": "21 Englewood Ave, Unit 21-2 (108-19-11)",
    "$": 572400,
    "address": "21 Englewood Ave, Unit 21-2",
    "parcel_id": "108-19-11",
    "owner1": "SHEN, CHEN",
    "owner2": "ZHU, ZHU",
    "current_taxes": 5861.38,
    "new_taxes_no_override": 6114.59,
    "override_total_1": 6288.09,
    "override_increase_1": 173.5
  },
  {
    "#": "21 Englewood Ave, Unit 21-3 & P62 (108-19-12)",
    "$": 572400,
    "address": "21 Englewood Ave, Unit 21-3 & P62",
    "parcel_id": "108-19-12",
    "owner1": "ROSKIN, MICHAEL & YEVGENIYA",
    "owner2": "",
    "current_taxes": 2226.44,
    "new_taxes_no_override": 2322.62,
    "override_total_1": 2388.52,
    "override_increase_1": 65.9
  },
  {
    "#": "21 Englewood Ave, Unit 21-4 & P34 (108-19-13)",
    "$": 572400,
    "address": "21 Englewood Ave, Unit 21-4 & P34",
    "parcel_id": "108-19-13",
    "owner1": "JOEL TR, DAVID",
    "owner2": "",
    "current_taxes": 5861.38,
    "new_taxes_no_override": 6114.59,
    "override_total_1": 6288.09,
    "override_increase_1": 173.5
  },
  {
    "#": "21 Englewood Ave, Unit 21-5 24&27 (108-19-14)",
    "$": 657100,
    "address": "21 Englewood Ave, Unit 21-5 24&27",
    "parcel_id": "108-19-14",
    "owner1": "PRETORIUS TR, ABRAHAM M",
    "owner2": "",
    "current_taxes": 6728.7,
    "new_taxes_no_override": 7019.38,
    "override_total_1": 7218.55,
    "override_increase_1": 199.17
  },
  {
    "#": "21 Englewood Ave, Unit 21-6 & P17 (108-19-15)",
    "$": 592400,
    "address": "21 Englewood Ave, Unit 21-6 & P17",
    "parcel_id": "108-19-15",
    "owner1": "ZHENG, HUI",
    "owner2": "YE, SUYUN",
    "current_taxes": 2431.24,
    "new_taxes_no_override": 2536.27,
    "override_total_1": 2608.23,
    "override_increase_1": 71.96
  },
  {
    "#": "23 Englewood Ave, Unit 23-1 (108-19-16)",
    "$": 582600,
    "address": "23 Englewood Ave, Unit 23-1",
    "parcel_id": "108-19-16",
    "owner1": "DRUCKER, MITCHELL",
    "owner2": "",
    "current_taxes": 2330.89,
    "new_taxes_no_override": 2431.58,
    "override_total_1": 2500.58,
    "override_increase_1": 68.99
  },
  {
    "#": "23 Englewood Ave, Unit 23-2 & P75 (108-19-17)",
    "$": 572400,
    "address": "23 Englewood Ave, Unit 23-2 & P75",
    "parcel_id": "108-19-17",
    "owner1": "DAVIDSON, IDA",
    "owner2": "",
    "current_taxes": 2226.44,
    "new_taxes_no_override": 2322.62,
    "override_total_1": 2388.52,
    "override_increase_1": 65.9
  },
  {
    "#": "23 Englewood Ave, Unit 23-3 & P8 (108-19-18)",
    "$": 572400,
    "address": "23 Englewood Ave, Unit 23-3 & P8",
    "parcel_id": "108-19-18",
    "owner1": "WEI, XIAOHUI",
    "owner2": "RHOADES, STEPHEN",
    "current_taxes": 5861.38,
    "new_taxes_no_override": 6114.59,
    "override_total_1": 6288.09,
    "override_increase_1": 173.5
  },
  {
    "#": "23 Englewood Ave, Unit 23-4 & P46 (108-19-19)",
    "$": 572400,
    "address": "23 Englewood Ave, Unit 23-4 & P46",
    "parcel_id": "108-19-19",
    "owner1": "XING, JIANGANG",
    "owner2": "ZHONG, ZHAOHUI",
    "current_taxes": 5861.38,
    "new_taxes_no_override": 6114.59,
    "override_total_1": 6288.09,
    "override_increase_1": 173.5
  },
  {
    "#": "23 Englewood Ave, Unit 23-5 & P9 (108-19-20)",
    "$": 584300,
    "address": "23 Englewood Ave, Unit 23-5 & P9",
    "parcel_id": "108-19-20",
    "owner1": "RODDY, CECILIA",
    "owner2": "",
    "current_taxes": 5983.23,
    "new_taxes_no_override": 6241.71,
    "override_total_1": 6418.81,
    "override_increase_1": 177.1
  },
  {
    "#": "23 Englewood Ave, Unit 23-6 & P6 (108-19-21)",
    "$": 584300,
    "address": "23 Englewood Ave, Unit 23-6 & P6",
    "parcel_id": "108-19-21",
    "owner1": "SCHAFFNER , BENNETT J & CHRISTOPHER",
    "owner2": "SUSSMAN, ANN",
    "current_taxes": 2348.3,
    "new_taxes_no_override": 2449.75,
    "override_total_1": 2519.26,
    "override_increase_1": 69.51
  },
  {
    "#": "25 Englewood Ave, Unit 25-1 & P12 (108-19-22)",
    "$": 572400,
    "address": "25 Englewood Ave, Unit 25-1 & P12",
    "parcel_id": "108-19-22",
    "owner1": "BERGMAN TRS, JON C & JACKIE L",
    "owner2": "",
    "current_taxes": 2226.44,
    "new_taxes_no_override": 2322.62,
    "override_total_1": 2388.52,
    "override_increase_1": 65.9
  },
  {
    "#": "25 Englewood Ave, Unit 25-2 & P7 (108-19-23)",
    "$": 597900,
    "address": "25 Englewood Ave, Unit 25-2 & P7",
    "parcel_id": "108-19-23",
    "owner1": "WU, SHUO CHIEH",
    "owner2": "ZHANG, GUI YUE",
    "current_taxes": 6122.5,
    "new_taxes_no_override": 6386.99,
    "override_total_1": 6568.22,
    "override_increase_1": 181.23
  },
  {
    "#": "25 Englewood Ave, Unit 25-3 & P13 (108-19-24)",
    "$": 579500,
    "address": "25 Englewood Ave, Unit 25-3 & P13",
    "parcel_id": "108-19-24",
    "owner1": "ZELJKOVIC, MIHAJLO",
    "owner2": "",
    "current_taxes": 2299.15,
    "new_taxes_no_override": 2398.47,
    "override_total_1": 2466.53,
    "override_increase_1": 68.05
  },
  {
    "#": "25 Englewood Ave, Unit 25-4 (108-19-25)",
    "$": 592400,
    "address": "25 Englewood Ave, Unit 25-4",
    "parcel_id": "108-19-25",
    "owner1": "HUANG, TSAI HUEY",
    "owner2": "",
    "current_taxes": 6066.18,
    "new_taxes_no_override": 6328.24,
    "override_total_1": 6507.8,
    "override_increase_1": 179.56
  },
  {
    "#": "25 Englewood Ave, Unit 25-5 & P11 (108-19-26)",
    "$": 584300,
    "address": "25 Englewood Ave, Unit 25-5 & P11",
    "parcel_id": "108-19-26",
    "owner1": "ZHOU, NANCY",
    "owner2": "",
    "current_taxes": 2348.3,
    "new_taxes_no_override": 2449.75,
    "override_total_1": 2519.26,
    "override_increase_1": 69.51
  },
  {
    "#": "25 Englewood Ave, Unit 25-6 & P32 (108-19-27)",
    "$": 572400,
    "address": "25 Englewood Ave, Unit 25-6 & P32",
    "parcel_id": "108-19-27",
    "owner1": "PETROZZINO, MARK & CATHERINE",
    "owner2": "",
    "current_taxes": 5861.38,
    "new_taxes_no_override": 6114.59,
    "override_total_1": 6288.09,
    "override_increase_1": 173.5
  },
  {
    "#": "27 Englewood Ave, Unit 27-1 (108-19-28)",
    "$": 572400,
    "address": "27 Englewood Ave, Unit 27-1",
    "parcel_id": "108-19-28",
    "owner1": "SERU-GARDNER TRS, RITA C",
    "owner2": "GARDNER TRS, WILLIAM DAVID",
    "current_taxes": 5861.38,
    "new_taxes_no_override": 6114.59,
    "override_total_1": 6288.09,
    "override_increase_1": 173.5
  },
  {
    "#": "27 Englewood Ave, Unit 27-2 & P40 (108-19-29)",
    "$": 597900,
    "address": "27 Englewood Ave, Unit 27-2 & P40",
    "parcel_id": "108-19-29",
    "owner1": "VORONINA TR, LYDIA",
    "owner2": "",
    "current_taxes": 2487.56,
    "new_taxes_no_override": 2595.02,
    "override_total_1": 2668.65,
    "override_increase_1": 73.63
  },
  {
    "#": "27 Englewood Ave, Unit 27-3 (108-19-30)",
    "$": 572400,
    "address": "27 Englewood Ave, Unit 27-3",
    "parcel_id": "108-19-30",
    "owner1": "DONOVAN, MARCIA",
    "owner2": "BENKOSKI, LORRAINE",
    "current_taxes": 5861.38,
    "new_taxes_no_override": 6114.59,
    "override_total_1": 6288.09,
    "override_increase_1": 173.5
  },
  {
    "#": "27 Englewood Ave, Unit 27-4 & P41 (108-19-31)",
    "$": 661000,
    "address": "27 Englewood Ave, Unit 27-4 & P41",
    "parcel_id": "108-19-31",
    "owner1": "TAHBAZ, NEGAR",
    "owner2": "",
    "current_taxes": 6768.64,
    "new_taxes_no_override": 7061.05,
    "override_total_1": 7261.4,
    "override_increase_1": 200.35
  },
  {
    "#": "27 Englewood Ave, Unit 27-5 & P25 (108-19-32)",
    "$": 584300,
    "address": "27 Englewood Ave, Unit 27-5 & P25",
    "parcel_id": "108-19-32",
    "owner1": "LEW, PATRICIA",
    "owner2": "",
    "current_taxes": 5983.23,
    "new_taxes_no_override": 6241.71,
    "override_total_1": 6418.81,
    "override_increase_1": 177.1
  },
  {
    "#": "27 Englewood Ave, Unit 27-6 & P23 (108-19-33)",
    "$": 584300,
    "address": "27 Englewood Ave, Unit 27-6 & P23",
    "parcel_id": "108-19-33",
    "owner1": "MARTIN, HOLLY H",
    "owner2": "",
    "current_taxes": 2348.3,
    "new_taxes_no_override": 2449.75,
    "override_total_1": 2519.26,
    "override_increase_1": 69.51
  },
  {
    "#": "29 Englewood Ave, Unit 29-1 (108-19-34)",
    "$": 572400,
    "address": "29 Englewood Ave, Unit 29-1",
    "parcel_id": "108-19-34",
    "owner1": "PAIGE, JEFFREY M & ESTHER",
    "owner2": "",
    "current_taxes": 2226.44,
    "new_taxes_no_override": 2322.62,
    "override_total_1": 2388.52,
    "override_increase_1": 65.9
  },
  {
    "#": "29 Englewood Ave, Unit 29-2 & P37 (108-19-35)",
    "$": 592400,
    "address": "29 Englewood Ave, Unit 29-2 & P37",
    "parcel_id": "108-19-35",
    "owner1": "GANCHI, LEYLA S",
    "owner2": "",
    "current_taxes": 6066.18,
    "new_taxes_no_override": 6328.24,
    "override_total_1": 6507.8,
    "override_increase_1": 179.56
  },
  {
    "#": "29 Englewood Ave, Unit 29-3 & P14 (108-19-36)",
    "$": 660900,
    "address": "29 Englewood Ave, Unit 29-3 & P14",
    "parcel_id": "108-19-36",
    "owner1": "GOIHBERG, POLINA & EDUWARD",
    "owner2": "",
    "current_taxes": 3132.68,
    "new_taxes_no_override": 3268.01,
    "override_total_1": 3360.74,
    "override_increase_1": 92.73
  },
  {
    "#": "29 Englewood Ave, Unit 29-4 & P45 (108-19-37)",
    "$": 598000,
    "address": "29 Englewood Ave, Unit 29-4 & P45",
    "parcel_id": "108-19-37",
    "owner1": "WHITE TRS, SHEILA",
    "owner2": "ROGOVIN , MAX & LAUREN",
    "current_taxes": 2488.59,
    "new_taxes_no_override": 2596.1,
    "override_total_1": 2669.76,
    "override_increase_1": 73.66
  },
  {
    "#": "29 Englewood Ave, Unit 29-5 & P16 (108-19-38)",
    "$": 584300,
    "address": "29 Englewood Ave, Unit 29-5 & P16",
    "parcel_id": "108-19-38",
    "owner1": "MOOR, BENJAMIN & REBECCA",
    "owner2": "",
    "current_taxes": 5983.23,
    "new_taxes_no_override": 6241.71,
    "override_total_1": 6418.81,
    "override_increase_1": 177.1
  },
  {
    "#": "29 Englewood Ave, Unit 29-6 & P22 (108-19-39)",
    "$": 584300,
    "address": "29 Englewood Ave, Unit 29-6 & P22",
    "parcel_id": "108-19-39",
    "owner1": "CHU, VINCENT",
    "owner2": "",
    "current_taxes": 5983.23,
    "new_taxes_no_override": 6241.71,
    "override_total_1": 6418.81,
    "override_increase_1": 177.1
  },
  {
    "#": "31 Englewood Ave, Unit 1/2, Unit 1 & P3 (108-19-46)",
    "$": 572400,
    "address": "31 Englewood Ave, Unit 1/2, Unit 1 & P3",
    "parcel_id": "108-19-46",
    "owner1": "CHING, HENRY",
    "owner2": "",
    "current_taxes": 5861.38,
    "new_taxes_no_override": 6114.59,
    "override_total_1": 6288.09,
    "override_increase_1": 173.5
  },
  {
    "#": "31 Englewood Ave, Unit 1/2, Unit 2 & P80 (108-19-47)",
    "$": 572400,
    "address": "31 Englewood Ave, Unit 1/2, Unit 2 & P80",
    "parcel_id": "108-19-47",
    "owner1": "KURZMAN, ABBY",
    "owner2": "",
    "current_taxes": 2226.44,
    "new_taxes_no_override": 2322.62,
    "override_total_1": 2388.52,
    "override_increase_1": 65.9
  },
  {
    "#": "31 Englewood Ave, Unit 1/2, Unit 3 & P1 (108-19-48)",
    "$": 572400,
    "address": "31 Englewood Ave, Unit 1/2, Unit 3 & P1",
    "parcel_id": "108-19-48",
    "owner1": "PLATIKANOV, STEFAN",
    "owner2": "",
    "current_taxes": 5861.38,
    "new_taxes_no_override": 6114.59,
    "override_total_1": 6288.09,
    "override_increase_1": 173.5
  },
  {
    "#": "31 Englewood Ave, Unit 1/2, Unit 4 & P82 (108-19-49)",
    "$": 572400,
    "address": "31 Englewood Ave, Unit 1/2, Unit 4 & P82",
    "parcel_id": "108-19-49",
    "owner1": "COVINGTON, MISCHA L",
    "owner2": "",
    "current_taxes": 2226.44,
    "new_taxes_no_override": 2322.62,
    "override_total_1": 2388.52,
    "override_increase_1": 65.9
  },
  {
    "#": "31 Englewood Ave, Unit 1/2, Unit 5 & P26 (108-19-50)",
    "$": 584300,
    "address": "31 Englewood Ave, Unit 1/2, Unit 5 & P26",
    "parcel_id": "108-19-50",
    "owner1": "TATERKA, AMELIA M & SUSAN C",
    "owner2": "",
    "current_taxes": 5983.23,
    "new_taxes_no_override": 6241.71,
    "override_total_1": 6418.81,
    "override_increase_1": 177.1
  },
  {
    "#": "31 Englewood Ave, Unit 1/2, Unit 6 (108-19-51)",
    "$": 584300,
    "address": "31 Englewood Ave, Unit 1/2, Unit 6",
    "parcel_id": "108-19-51",
    "owner1": "LEE TRS, EMMELINE CHIN",
    "owner2": "",
    "current_taxes": 5983.23,
    "new_taxes_no_override": 6241.71,
    "override_total_1": 6418.81,
    "override_increase_1": 177.1
  },
  {
    "#": "31 Englewood Ave, Unit 1/2, Unit 7 (108-19-52)",
    "$": 442900,
    "address": "31 Englewood Ave, Unit 1/2, Unit 7",
    "parcel_id": "108-19-52",
    "owner1": "MILLER, ET AL, ANNE H",
    "owner2": "C/O DANNIN MANAGMENT",
    "current_taxes": 4535.3,
    "new_taxes_no_override": 4731.22,
    "override_total_1": 4865.47,
    "override_increase_1": 134.24
  },
  {
    "#": "31 Englewood Ave, Unit 31-1 & P67 (108-19-40)",
    "$": 587700,
    "address": "31 Englewood Ave, Unit 31-1 & P67",
    "parcel_id": "108-19-40",
    "owner1": "ULTAIGH TR, NIAMH",
    "owner2": "",
    "current_taxes": 2383.11,
    "new_taxes_no_override": 2486.06,
    "override_total_1": 2556.6,
    "override_increase_1": 70.54
  },
  {
    "#": "31 Englewood Ave, Unit 31-2 (108-19-41)",
    "$": 572400,
    "address": "31 Englewood Ave, Unit 31-2",
    "parcel_id": "108-19-41",
    "owner1": "ZHAO, YIFAN",
    "owner2": "",
    "current_taxes": 2226.44,
    "new_taxes_no_override": 2322.62,
    "override_total_1": 2388.52,
    "override_increase_1": 65.9
  },
  {
    "#": "31 Englewood Ave, Unit 31-3&P74 (108-19-42)",
    "$": 597900,
    "address": "31 Englewood Ave, Unit 31-3&P74",
    "parcel_id": "108-19-42",
    "owner1": "MASSE, CHRISTOPHE & CECILE",
    "owner2": "",
    "current_taxes": 6122.5,
    "new_taxes_no_override": 6386.99,
    "override_total_1": 6568.22,
    "override_increase_1": 181.23
  },
  {
    "#": "31 Englewood Ave, Unit 31-4 & P73 (108-19-43)",
    "$": 572400,
    "address": "31 Englewood Ave, Unit 31-4 & P73",
    "parcel_id": "108-19-43",
    "owner1": "PINSKY, EUGENE",
    "owner2": "",
    "current_taxes": 5861.38,
    "new_taxes_no_override": 6114.59,
    "override_total_1": 6288.09,
    "override_increase_1": 173.5
  },
  {
    "#": "31 Englewood Ave, Unit 31-6 (108-19-45)",
    "$": 584300,
    "address": "31 Englewood Ave, Unit 31-6",
    "parcel_id": "108-19-45",
    "owner1": "KULAPATNA, PORNTEP & PHATTEEPHR",
    "owner2": "",
    "current_taxes": 2348.3,
    "new_taxes_no_override": 2449.75,
    "override_total_1": 2519.26,
    "override_increase_1": 69.51
  },
  {
    "#": "31 Englewood Ave, Unit 5 (108-19-44)",
    "$": 584300,
    "address": "31 Englewood Ave, Unit 5",
    "parcel_id": "108-19-44",
    "owner1": "YUU, COLLEEN",
    "owner2": "",
    "current_taxes": 2348.3,
    "new_taxes_no_override": 2449.75,
    "override_total_1": 2519.26,
    "override_increase_1": 69.51
  },
  {
    "#": "37 Englewood Ave, Unit 1 (109-01-13)",
    "$": 980800,
    "address": "37 Englewood Ave, Unit 1",
    "parcel_id": "109-01-13",
    "owner1": "BEST, MICHAEL T",
    "owner2": "FINKENBINDER, ANNE C",
    "current_taxes": 6408.46,
    "new_taxes_no_override": 6685.31,
    "override_total_1": 6875.0,
    "override_increase_1": 189.69
  },
  {
    "#": "37 Englewood Ave, Unit 2 & P38 (109-01-14)",
    "$": 1012200,
    "address": "37 Englewood Ave, Unit 2 & P38",
    "parcel_id": "109-01-14",
    "owner1": "BOULIAS, KONSTANTINOS",
    "owner2": "CHALKIADAKI, ANGELIKI",
    "current_taxes": 6729.99,
    "new_taxes_no_override": 7020.73,
    "override_total_1": 7219.93,
    "override_increase_1": 199.21
  },
  {
    "#": "37 Englewood Ave, Unit 3 & P19 (109-01-15)",
    "$": 1165000,
    "address": "37 Englewood Ave, Unit 3 & P19",
    "parcel_id": "109-01-15",
    "owner1": "GHAZARIAN TR, SHADIN",
    "owner2": "",
    "current_taxes": 11929.6,
    "new_taxes_no_override": 12444.96,
    "override_total_1": 12798.07,
    "override_increase_1": 353.12
  },
  {
    "#": "37 Englewood Ave, Unit A (109-01-12)",
    "$": 592300,
    "address": "37 Englewood Ave, Unit A",
    "parcel_id": "109-01-12",
    "owner1": "HOULIHAN, PAUL J",
    "owner2": "",
    "current_taxes": 2430.22,
    "new_taxes_no_override": 2535.21,
    "override_total_1": 2607.14,
    "override_increase_1": 71.93
  },
  {
    "#": "89 Essex St (008-04-01)",
    "$": 4007200,
    "address": "89 Essex St",
    "parcel_id": "008-04-01",
    "owner1": "ANDERS, RICHARD",
    "owner2": "",
    "current_taxes": 37398.79,
    "new_taxes_no_override": 39014.42,
    "override_total_1": 40121.42,
    "override_increase_1": 1107.0
  },
  {
    "#": "130 Essex St (015-04-00)",
    "$": 3729600,
    "address": "130 Essex St",
    "parcel_id": "015-04-00",
    "owner1": "CUTLER, DAVID",
    "owner2": "LANDRUM, MARY BETH",
    "current_taxes": 34556.17,
    "new_taxes_no_override": 36049.0,
    "override_total_1": 37071.86,
    "override_increase_1": 1022.86
  },
  {
    "#": "143 Essex St (006A-05-00)",
    "$": 2964000,
    "address": "143 Essex St",
    "parcel_id": "006A-05-00",
    "owner1": "BOSTON UNIVERSITY TRS",
    "owner2": "C/O GENERAL ACCOUNTING 4TH FLR",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "2 Euston St, Unit 1 (002-16-07)",
    "$": 636800,
    "address": "2 Euston St, Unit 1",
    "parcel_id": "002-16-07",
    "owner1": "ZHOU, YUXIN",
    "owner2": "SHENG, XUEFEI",
    "current_taxes": 6520.83,
    "new_taxes_no_override": 6802.53,
    "override_total_1": 6995.55,
    "override_increase_1": 193.02
  },
  {
    "#": "2 Euston St, Unit 2 (002-16-01)",
    "$": 710700,
    "address": "2 Euston St, Unit 2",
    "parcel_id": "002-16-01",
    "owner1": "DIAZ, ELSA",
    "owner2": "",
    "current_taxes": 3642.63,
    "new_taxes_no_override": 3799.99,
    "override_total_1": 3907.81,
    "override_increase_1": 107.82
  },
  {
    "#": "2 Euston St, Unit 3 (002-16-02)",
    "$": 663100,
    "address": "2 Euston St, Unit 3",
    "parcel_id": "002-16-02",
    "owner1": "TSENG, CHENG YIN & CHIU MEI",
    "owner2": "",
    "current_taxes": 6790.14,
    "new_taxes_no_override": 7083.47,
    "override_total_1": 7284.46,
    "override_increase_1": 200.99
  },
  {
    "#": "2 Euston St, Unit 4 (002-16-03)",
    "$": 814300,
    "address": "2 Euston St, Unit 4",
    "parcel_id": "002-16-03",
    "owner1": "DENNERY, KRISTINE MICHELLE & SHAUN MICHAEL",
    "owner2": "",
    "current_taxes": 4703.5,
    "new_taxes_no_override": 4906.69,
    "override_total_1": 5045.91,
    "override_increase_1": 139.22
  },
  {
    "#": "2 Euston St, Unit 5 (002-16-04)",
    "$": 778500,
    "address": "2 Euston St, Unit 5",
    "parcel_id": "002-16-04",
    "owner1": "GALVIN TR, KEVIN D",
    "owner2": "",
    "current_taxes": 7971.84,
    "new_taxes_no_override": 8316.22,
    "override_total_1": 8552.19,
    "override_increase_1": 235.97
  },
  {
    "#": "2 Euston St, Unit 6 (002-16-05)",
    "$": 824100,
    "address": "2 Euston St, Unit 6",
    "parcel_id": "002-16-05",
    "owner1": "KRASIK, DAVID",
    "owner2": "",
    "current_taxes": 8438.78,
    "new_taxes_no_override": 8803.34,
    "override_total_1": 9053.12,
    "override_increase_1": 249.79
  },
  {
    "#": "2 Euston St, Unit 7 (002-16-06)",
    "$": 384800,
    "address": "2 Euston St, Unit 7",
    "parcel_id": "002-16-06",
    "owner1": "MONTERO, FLAVIO B",
    "owner2": "",
    "current_taxes": 3940.35,
    "new_taxes_no_override": 4110.57,
    "override_total_1": 4227.21,
    "override_increase_1": 116.63
  },
  {
    "#": "3 Euston St, Unit 1 (005-06-01)",
    "$": 679400,
    "address": "3 Euston St, Unit 1",
    "parcel_id": "005-06-01",
    "owner1": "AZIZ, AHMAR",
    "owner2": "NGUYEN, THUY THI HA",
    "current_taxes": 6957.06,
    "new_taxes_no_override": 7257.6,
    "override_total_1": 7463.53,
    "override_increase_1": 205.93
  },
  {
    "#": "3 Euston St, Unit 2 (005-06-02)",
    "$": 753600,
    "address": "3 Euston St, Unit 2",
    "parcel_id": "005-06-02",
    "owner1": "GUGLIELMINO, PAUL F",
    "owner2": "MINTCHEVA, RALISTA",
    "current_taxes": 7716.86,
    "new_taxes_no_override": 8050.23,
    "override_total_1": 8278.65,
    "override_increase_1": 228.42
  },
  {
    "#": "3 Euston St, Unit 3 (005-06-03)",
    "$": 735400,
    "address": "3 Euston St, Unit 3",
    "parcel_id": "005-06-03",
    "owner1": "LEE-HOOD, ELIZABETH",
    "owner2": "",
    "current_taxes": 3895.56,
    "new_taxes_no_override": 4063.85,
    "override_total_1": 4179.16,
    "override_increase_1": 115.31
  },
  {
    "#": "3 Euston St, Unit 4 (005-06-04)",
    "$": 702900,
    "address": "3 Euston St, Unit 4",
    "parcel_id": "005-06-04",
    "owner1": "NOBARI, FAEZEH SADEGH",
    "owner2": "",
    "current_taxes": 7197.7,
    "new_taxes_no_override": 7508.64,
    "override_total_1": 7721.69,
    "override_increase_1": 213.05
  },
  {
    "#": "3 Euston St, Unit 5 (005-06-05)",
    "$": 1318100,
    "address": "3 Euston St, Unit 5",
    "parcel_id": "005-06-05",
    "owner1": "DONG, AMY",
    "owner2": "",
    "current_taxes": 13497.34,
    "new_taxes_no_override": 14080.43,
    "override_total_1": 14479.95,
    "override_increase_1": 399.52
  },
  {
    "#": "3 Euston St, Unit B (005-06-06)",
    "$": 502200,
    "address": "3 Euston St, Unit B",
    "parcel_id": "005-06-06",
    "owner1": "HE, CHUAN",
    "owner2": "",
    "current_taxes": 5142.53,
    "new_taxes_no_override": 5364.69,
    "override_total_1": 5516.91,
    "override_increase_1": 152.22
  },
  {
    "#": "4 Euston St, Unit 1 (002-15-03)",
    "$": 1019900,
    "address": "4 Euston St, Unit 1",
    "parcel_id": "002-15-03",
    "owner1": "ZAHLTEN, ALEXANDER NIKOLAS & RINA SERIZAWA",
    "owner2": "",
    "current_taxes": 6808.84,
    "new_taxes_no_override": 7102.98,
    "override_total_1": 7304.52,
    "override_increase_1": 201.54
  },
  {
    "#": "4 Euston St, Unit 2 (002-15-01)",
    "$": 1062700,
    "address": "4 Euston St, Unit 2",
    "parcel_id": "002-15-01",
    "owner1": "GOLDSMITH III, ARTHUR AUSTIN",
    "owner2": "",
    "current_taxes": 7247.11,
    "new_taxes_no_override": 7560.19,
    "override_total_1": 7774.7,
    "override_increase_1": 214.51
  },
  {
    "#": "4 Euston St, Unit 3 (002-15-02)",
    "$": 1042400,
    "address": "4 Euston St, Unit 3",
    "parcel_id": "002-15-02",
    "owner1": "COOK TRS, CYNTHIA M & D ERNEST",
    "owner2": "",
    "current_taxes": 7039.24,
    "new_taxes_no_override": 7343.34,
    "override_total_1": 7551.7,
    "override_increase_1": 208.36
  },
  {
    "#": "5 Euston St (005-07-00)",
    "$": 3646300,
    "address": "5 Euston St",
    "parcel_id": "005-07-00",
    "owner1": "LEW, TRS, HONG HUN & CHESTER DEAN",
    "owner2": "",
    "current_taxes": 37338.11,
    "new_taxes_no_override": 38951.12,
    "override_total_1": 40056.32,
    "override_increase_1": 1105.21
  },
  {
    "#": "7 Euston St (005-08-00)",
    "$": 4095800,
    "address": "7 Euston St",
    "parcel_id": "005-08-00",
    "owner1": "BOSTON UNIVERSITY TRS",
    "owner2": "C/O GENERAL ACCOUNTING 4TH FLR",
    "current_taxes": 41940.99,
    "new_taxes_no_override": 43752.84,
    "override_total_1": 44994.29,
    "override_increase_1": 1241.45
  },
  {
    "#": "8 Euston St, Unit 1 & P-C (002-14-06)",
    "$": 734000,
    "address": "8 Euston St, Unit 1 & P-C",
    "parcel_id": "002-14-06",
    "owner1": "BANALIEVA, ELITSA",
    "owner2": "",
    "current_taxes": 7516.16,
    "new_taxes_no_override": 7840.86,
    "override_total_1": 8063.34,
    "override_increase_1": 222.48
  },
  {
    "#": "8 Euston St, Unit 2 (002-14-01)",
    "$": 598100,
    "address": "8 Euston St, Unit 2",
    "parcel_id": "002-14-01",
    "owner1": "WINGERTER, SARAH",
    "owner2": "",
    "current_taxes": 2489.61,
    "new_taxes_no_override": 2597.16,
    "override_total_1": 2670.85,
    "override_increase_1": 73.69
  },
  {
    "#": "8 Euston St, Unit 3 & Pk  D (002-14-02)",
    "$": 845200,
    "address": "8 Euston St, Unit 3 & Pk  D",
    "parcel_id": "002-14-02",
    "owner1": "LI, LESTER & CARRIE",
    "owner2": "",
    "current_taxes": 8654.85,
    "new_taxes_no_override": 9028.74,
    "override_total_1": 9284.92,
    "override_increase_1": 256.18
  },
  {
    "#": "8 Euston St, Unit 4 & P-B (002-14-03)",
    "$": 711500,
    "address": "8 Euston St, Unit 4 & P-B",
    "parcel_id": "002-14-03",
    "owner1": "YE, LIN",
    "owner2": "",
    "current_taxes": 7285.76,
    "new_taxes_no_override": 7600.5,
    "override_total_1": 7816.16,
    "override_increase_1": 215.66
  },
  {
    "#": "8 Euston St, Unit 5 & P- A (002-14-04)",
    "$": 830900,
    "address": "8 Euston St, Unit 5 & P- A",
    "parcel_id": "002-14-04",
    "owner1": "WAN, YANGXIAOYA",
    "owner2": "",
    "current_taxes": 4873.48,
    "new_taxes_no_override": 5084.01,
    "override_total_1": 5228.27,
    "override_increase_1": 144.26
  },
  {
    "#": "8 Euston St, Unit 6 (002-14-05)",
    "$": 598000,
    "address": "8 Euston St, Unit 6",
    "parcel_id": "002-14-05",
    "owner1": "KHOUW, TIMOTHY TAYLOR & LENING",
    "owner2": "",
    "current_taxes": 6123.52,
    "new_taxes_no_override": 6388.06,
    "override_total_1": 6569.31,
    "override_increase_1": 181.26
  },
  {
    "#": "11 Euston St (005-09-00)",
    "$": 3439200,
    "address": "11 Euston St",
    "parcel_id": "005-09-00",
    "owner1": "11 EUSTON STREET LLC",
    "owner2": "",
    "current_taxes": 35217.41,
    "new_taxes_no_override": 36738.8,
    "override_total_1": 37781.24,
    "override_increase_1": 1042.44
  },
  {
    "#": "12 Euston St, Unit 1 (002-13-03)",
    "$": 1215900,
    "address": "12 Euston St, Unit 1",
    "parcel_id": "002-13-03",
    "owner1": "SONNABEND, TR, ROBERT G",
    "owner2": "",
    "current_taxes": 12450.82,
    "new_taxes_no_override": 12988.7,
    "override_total_1": 13357.24,
    "override_increase_1": 368.54
  },
  {
    "#": "12 Euston St, Unit 2 (002-13-01)",
    "$": 1443500,
    "address": "12 Euston St, Unit 2",
    "parcel_id": "002-13-01",
    "owner1": "ASHTON-RICKARDT, PHILIP GEORGE & ANA-MARIA",
    "owner2": "",
    "current_taxes": 11146.51,
    "new_taxes_no_override": 11628.04,
    "override_total_1": 11957.98,
    "override_increase_1": 329.94
  },
  {
    "#": "12 Euston St, Unit 3 (002-13-02)",
    "$": 1261500,
    "address": "12 Euston St, Unit 3",
    "parcel_id": "002-13-02",
    "owner1": "THAYRE, HELENI K",
    "owner2": "",
    "current_taxes": 9282.83,
    "new_taxes_no_override": 9683.85,
    "override_total_1": 9958.62,
    "override_increase_1": 274.77
  },
  {
    "#": "15 Euston St, Unit 1 (005-10-02)",
    "$": 1890400,
    "address": "15 Euston St, Unit 1",
    "parcel_id": "005-10-02",
    "owner1": "KIM, OLIVIA SOOHAE",
    "owner2": "FALATO, ANTONIO",
    "current_taxes": 15722.76,
    "new_taxes_no_override": 16401.98,
    "override_total_1": 16867.38,
    "override_increase_1": 465.39
  },
  {
    "#": "15 Euston St, Unit 1A (005-10-01)",
    "$": 1011600,
    "address": "15 Euston St, Unit 1A",
    "parcel_id": "005-10-01",
    "owner1": "NODA TR, ELENA",
    "owner2": "",
    "current_taxes": 10358.78,
    "new_taxes_no_override": 10806.28,
    "override_total_1": 11112.9,
    "override_increase_1": 306.62
  },
  {
    "#": "15 Euston St, Unit 2 (005-10-03)",
    "$": 2024600,
    "address": "15 Euston St, Unit 2",
    "parcel_id": "005-10-03",
    "owner1": "FARZAN, MICHAEL R",
    "owner2": "CHOE, HYERYUN",
    "current_taxes": 20731.9,
    "new_taxes_no_override": 21627.52,
    "override_total_1": 22241.18,
    "override_increase_1": 613.66
  },
  {
    "#": "15 Euston St, Unit 3 (005-10-04)",
    "$": 2073600,
    "address": "15 Euston St, Unit 3",
    "parcel_id": "005-10-04",
    "owner1": "PHAN, HOAN MINH",
    "owner2": "",
    "current_taxes": 21233.66,
    "new_taxes_no_override": 22150.95,
    "override_total_1": 22779.47,
    "override_increase_1": 628.52
  },
  {
    "#": "16 Euston St (002-12-00)",
    "$": 4243800,
    "address": "16 Euston St",
    "parcel_id": "002-12-00",
    "owner1": "NORA LLC",
    "owner2": "C/O ALPHA MANAGEMENT",
    "current_taxes": 43456.51,
    "new_taxes_no_override": 45333.83,
    "override_total_1": 46620.14,
    "override_increase_1": 1286.31
  },
  {
    "#": "18 Euston St (002-11-00)",
    "$": 4243800,
    "address": "18 Euston St",
    "parcel_id": "002-11-00",
    "owner1": "NORA LLC",
    "owner2": "",
    "current_taxes": 43456.51,
    "new_taxes_no_override": 45333.83,
    "override_total_1": 46620.14,
    "override_increase_1": 1286.31
  },
  {
    "#": "19 Euston St (005-11-00)",
    "$": 3238800,
    "address": "19 Euston St",
    "parcel_id": "005-11-00",
    "owner1": "BOSTON UNIVERSITY TRS",
    "owner2": "C/O GENERAL ACCOUNTING 4TH FLR",
    "current_taxes": 33165.31,
    "new_taxes_no_override": 34598.05,
    "override_total_1": 35579.74,
    "override_increase_1": 981.69
  },
  {
    "#": "21 Euston St (005-12-00)",
    "$": 3277200,
    "address": "21 Euston St",
    "parcel_id": "005-12-00",
    "owner1": "NORA LLC",
    "owner2": "",
    "current_taxes": 33558.53,
    "new_taxes_no_override": 35008.26,
    "override_total_1": 36001.59,
    "override_increase_1": 993.33
  },
  {
    "#": "22 Euston St (002-10-00)",
    "$": 4243800,
    "address": "22 Euston St",
    "parcel_id": "002-10-00",
    "owner1": "NORA LLC",
    "owner2": "C/O ALPHA MANAGEMENT",
    "current_taxes": 43456.51,
    "new_taxes_no_override": 45333.83,
    "override_total_1": 46620.14,
    "override_increase_1": 1286.31
  },
  {
    "#": "24 Euston St, Unit 1 & P4-P5 (002-09-03)",
    "$": 1880200,
    "address": "24 Euston St, Unit 1 & P4-P5",
    "parcel_id": "002-09-03",
    "owner1": "LATIF, RAYMOND & SUMMER DEMBEK",
    "owner2": "",
    "current_taxes": 19253.25,
    "new_taxes_no_override": 20084.99,
    "override_total_1": 20654.89,
    "override_increase_1": 569.9
  },
  {
    "#": "24 Euston St, Unit 2 (002-09-01)",
    "$": 1563500,
    "address": "24 Euston St, Unit 2",
    "parcel_id": "002-09-01",
    "owner1": "ALBUQUERQUE, RUI & ANA",
    "owner2": "",
    "current_taxes": 12375.31,
    "new_taxes_no_override": 12909.92,
    "override_total_1": 13276.23,
    "override_increase_1": 366.31
  },
  {
    "#": "24 Euston St, Unit 3 (002-09-02)",
    "$": 1550500,
    "address": "24 Euston St, Unit 3",
    "parcel_id": "002-09-02",
    "owner1": "WINE, DAVID",
    "owner2": "RAZ, TAL",
    "current_taxes": 12242.19,
    "new_taxes_no_override": 12771.05,
    "override_total_1": 13133.42,
    "override_increase_1": 362.37
  },
  {
    "#": "25 Euston St, Unit 1 & P1-2 (005-13-01)",
    "$": 2526800,
    "address": "25 Euston St, Unit 1 & P1-2",
    "parcel_id": "005-13-01",
    "owner1": "KIM, DANIEL",
    "owner2": "",
    "current_taxes": 22239.5,
    "new_taxes_no_override": 23200.25,
    "override_total_1": 23858.54,
    "override_increase_1": 658.29
  },
  {
    "#": "25 Euston St, Unit 2 & P3 (005-13-02)",
    "$": 1826100,
    "address": "25 Euston St, Unit 2 & P3",
    "parcel_id": "005-13-02",
    "owner1": "ZHAN, BAO",
    "owner2": "",
    "current_taxes": 15064.33,
    "new_taxes_no_override": 15715.11,
    "override_total_1": 16161.01,
    "override_increase_1": 445.9
  },
  {
    "#": "25 Euston St, Unit 3 & P4 (005-13-03)",
    "$": 1842500,
    "address": "25 Euston St, Unit 3 & P4",
    "parcel_id": "005-13-03",
    "owner1": "SCHNEIDER, THOMAS WILLIAM & ELIZABETH PEARL",
    "owner2": "",
    "current_taxes": 15232.27,
    "new_taxes_no_override": 15890.3,
    "override_total_1": 16341.18,
    "override_increase_1": 450.88
  },
  {
    "#": "33 Euston St (005-14-00)",
    "$": 4691700,
    "address": "33 Euston St",
    "parcel_id": "005-14-00",
    "owner1": "SCHEMMER, JOHN A & ANN B",
    "owner2": "",
    "current_taxes": 44408.07,
    "new_taxes_no_override": 46326.5,
    "override_total_1": 47640.98,
    "override_increase_1": 1314.48
  },
  {
    "#": "36 Euston St (002-08-00)",
    "$": 3229700,
    "address": "36 Euston St",
    "parcel_id": "002-08-00",
    "owner1": "CHIN TRS, JOSEPHINE L",
    "owner2": "",
    "current_taxes": 29437.19,
    "new_taxes_no_override": 30708.88,
    "override_total_1": 31580.22,
    "override_increase_1": 871.34
  },
  {
    "#": "58 Euston St (003-04-00)",
    "$": 6342400,
    "address": "58 Euston St",
    "parcel_id": "003-04-00",
    "owner1": "TOSCANI, MICHELE",
    "owner2": "",
    "current_taxes": 61311.24,
    "new_taxes_no_override": 63959.89,
    "override_total_1": 65774.7,
    "override_increase_1": 1814.81
  },
  {
    "#": "1 Evans Rd, Unit 1 (096-01-01)",
    "$": 2259500,
    "address": "1 Evans Rd, Unit 1",
    "parcel_id": "096-01-01",
    "owner1": "ROBIN, JEREMY T",
    "owner2": "",
    "current_taxes": 19502.35,
    "new_taxes_no_override": 20344.85,
    "override_total_1": 20922.12,
    "override_increase_1": 577.27
  },
  {
    "#": "5 Evans Rd, Unit 2 & Garage (096-01-02)",
    "$": 1109200,
    "address": "5 Evans Rd, Unit 2 & Garage",
    "parcel_id": "096-01-02",
    "owner1": "SCHRAFT, TRS, CAROL & BRUCE",
    "owner2": "",
    "current_taxes": 11358.21,
    "new_taxes_no_override": 11848.88,
    "override_total_1": 12185.09,
    "override_increase_1": 336.2
  },
  {
    "#": "10 Evans Rd (100-18-00)",
    "$": 2898800,
    "address": "10 Evans Rd",
    "parcel_id": "100-18-00",
    "owner1": "MCLEAN, CHRISTOPHER JAMES & CARRIE GRACE",
    "owner2": "",
    "current_taxes": 29683.71,
    "new_taxes_no_override": 30966.05,
    "override_total_1": 31844.68,
    "override_increase_1": 878.64
  },
  {
    "#": "11 Evans Rd (096-02-00)",
    "$": 3345700,
    "address": "11 Evans Rd",
    "parcel_id": "096-02-00",
    "owner1": "MENDELS, DAVID R",
    "owner2": "YASSA, LEILA S",
    "current_taxes": 30625.03,
    "new_taxes_no_override": 31948.03,
    "override_total_1": 32854.53,
    "override_increase_1": 906.5
  },
  {
    "#": "15 Evans Rd (096-03-00)",
    "$": 3294700,
    "address": "15 Evans Rd",
    "parcel_id": "096-03-00",
    "owner1": "RANGANATHAN, REKHA",
    "owner2": "SUNDARAM, RAVI",
    "current_taxes": 30102.79,
    "new_taxes_no_override": 31403.23,
    "override_total_1": 32294.27,
    "override_increase_1": 891.04
  },
  {
    "#": "18 Evans Rd (100-17-00)",
    "$": 2768800,
    "address": "18 Evans Rd",
    "parcel_id": "100-17-00",
    "owner1": "EVANS BROOKLINE LLC",
    "owner2": "",
    "current_taxes": 28352.51,
    "new_taxes_no_override": 29577.34,
    "override_total_1": 30416.57,
    "override_increase_1": 839.23
  },
  {
    "#": "24 Evans Rd (100-16-00)",
    "$": 3105000,
    "address": "24 Evans Rd",
    "parcel_id": "100-16-00",
    "owner1": "JENSEN, TR, DAVID J",
    "owner2": "",
    "current_taxes": 31795.2,
    "new_taxes_no_override": 33168.75,
    "override_total_1": 34109.89,
    "override_increase_1": 941.14
  },
  {
    "#": "25 Evans Rd (096-04-00)",
    "$": 3250700,
    "address": "25 Evans Rd",
    "parcel_id": "096-04-00",
    "owner1": "KOSOWSKY TR, JOYCE I",
    "owner2": "",
    "current_taxes": 29652.23,
    "new_taxes_no_override": 30933.21,
    "override_total_1": 31810.91,
    "override_increase_1": 877.71
  },
  {
    "#": "30 Evans Rd (100-15-00)",
    "$": 3122400,
    "address": "30 Evans Rd",
    "parcel_id": "100-15-00",
    "owner1": "LEVISOHN, STEVEN R & SYBIL",
    "owner2": "",
    "current_taxes": 28338.44,
    "new_taxes_no_override": 29562.66,
    "override_total_1": 30401.48,
    "override_increase_1": 838.82
  },
  {
    "#": "31 Evans Rd (096-05-00)",
    "$": 2487600,
    "address": "31 Evans Rd",
    "parcel_id": "096-05-00",
    "owner1": "KIMELMAN TRS, HAVA & REUVEN RONALD",
    "owner2": "",
    "current_taxes": 21838.09,
    "new_taxes_no_override": 22781.5,
    "override_total_1": 23427.9,
    "override_increase_1": 646.41
  },
  {
    "#": "36 Evans Rd (100-14-00)",
    "$": 2484500,
    "address": "36 Evans Rd",
    "parcel_id": "100-14-00",
    "owner1": "WHITEHOUSE TR, JEANE L",
    "owner2": "",
    "current_taxes": 21806.35,
    "new_taxes_no_override": 22748.38,
    "override_total_1": 23393.85,
    "override_increase_1": 645.47
  },
  {
    "#": "37 Evans Rd (096-06-00)",
    "$": 3650800,
    "address": "37 Evans Rd",
    "parcel_id": "096-06-00",
    "owner1": "FORTESCUE, JONATHAN A",
    "owner2": "WATSON, SASHA",
    "current_taxes": 37384.19,
    "new_taxes_no_override": 38999.19,
    "override_total_1": 40105.76,
    "override_increase_1": 1106.57
  },
  {
    "#": "40 Evans Rd (100-13-00)",
    "$": 3157600,
    "address": "40 Evans Rd",
    "parcel_id": "100-13-00",
    "owner1": "DONOVAN, PAUL M II",
    "owner2": "TOSCHI, ELENA",
    "current_taxes": 32333.82,
    "new_taxes_no_override": 33730.64,
    "override_total_1": 34687.72,
    "override_increase_1": 957.08
  },
  {
    "#": "59 Evans Rd (098-06-00)",
    "$": 3462400,
    "address": "59 Evans Rd",
    "parcel_id": "098-06-00",
    "owner1": "SANDER, CHRIS",
    "owner2": "",
    "current_taxes": 35454.98,
    "new_taxes_no_override": 36986.64,
    "override_total_1": 38036.1,
    "override_increase_1": 1049.47
  },
  {
    "#": "60 Evans Rd (099-16-00)",
    "$": 3574100,
    "address": "60 Evans Rd",
    "parcel_id": "099-16-00",
    "owner1": "CHEN, BENJIE",
    "owner2": "FAN, MELINA",
    "current_taxes": 32963.85,
    "new_taxes_no_override": 34387.89,
    "override_total_1": 35363.62,
    "override_increase_1": 975.73
  },
  {
    "#": "66 Evans Rd (099-15-00)",
    "$": 3265600,
    "address": "66 Evans Rd",
    "parcel_id": "099-15-00",
    "owner1": "STOLL, PERRY",
    "owner2": "WANG, KARYN",
    "current_taxes": 29804.81,
    "new_taxes_no_override": 31092.38,
    "override_total_1": 31974.6,
    "override_increase_1": 882.22
  },
  {
    "#": "69 Evans Rd (098-07-00)",
    "$": 3364400,
    "address": "69 Evans Rd",
    "parcel_id": "098-07-00",
    "owner1": "CODDINGTON, MATHEW",
    "owner2": "PASSARELLI, BIANCA",
    "current_taxes": 34451.46,
    "new_taxes_no_override": 35939.76,
    "override_total_1": 36959.53,
    "override_increase_1": 1019.76
  },
  {
    "#": "72 Evans Rd (099-14-00)",
    "$": 3521700,
    "address": "72 Evans Rd",
    "parcel_id": "099-14-00",
    "owner1": "MCCORMACK, TIMOTHY J",
    "owner2": "",
    "current_taxes": 32427.27,
    "new_taxes_no_override": 33828.13,
    "override_total_1": 34787.98,
    "override_increase_1": 959.85
  },
  {
    "#": "77 Evans Rd (098-08-00)",
    "$": 3990000,
    "address": "77 Evans Rd",
    "parcel_id": "098-08-00",
    "owner1": "WEISMAN, SCOTT & ROBIN",
    "owner2": "",
    "current_taxes": 37222.67,
    "new_taxes_no_override": 38830.69,
    "override_total_1": 39932.48,
    "override_increase_1": 1101.79
  },
  {
    "#": "78 Evans Rd (099-13-00)",
    "$": 3390300,
    "address": "78 Evans Rd",
    "parcel_id": "099-13-00",
    "owner1": "VALLET LIFE ESTATE, JEAN-MARIE  P & EVELYNE P",
    "owner2": "",
    "current_taxes": 31081.74,
    "new_taxes_no_override": 32424.47,
    "override_total_1": 33344.49,
    "override_increase_1": 920.02
  },
  {
    "#": "82 Evans Rd (099-11-01)",
    "$": 4067400,
    "address": "82 Evans Rd",
    "parcel_id": "099-11-01",
    "owner1": "ISAKOFF ET AL TRS, STEVEN J",
    "owner2": "SPEAR, SHERRI L",
    "current_taxes": 38015.24,
    "new_taxes_no_override": 39657.5,
    "override_total_1": 40782.75,
    "override_increase_1": 1125.25
  },
  {
    "#": "87 Evans Rd (098-09-00)",
    "$": 3438200,
    "address": "87 Evans Rd",
    "parcel_id": "098-09-00",
    "owner1": "FRIEDMAN, HOWARD A",
    "owner2": "LEIBOWITZ, SHERRY S",
    "current_taxes": 31572.23,
    "new_taxes_no_override": 32936.15,
    "override_total_1": 33870.69,
    "override_increase_1": 934.54
  },
  {
    "#": "92 Evans Rd (099-11-00)",
    "$": 4951200,
    "address": "92 Evans Rd",
    "parcel_id": "099-11-00",
    "owner1": "CHANG, DAVID A & NICOLE G",
    "owner2": "",
    "current_taxes": 47065.35,
    "new_taxes_no_override": 49098.57,
    "override_total_1": 50491.71,
    "override_increase_1": 1393.13
  },
  {
    "#": "93 Evans Rd (098-10-00)",
    "$": 3243500,
    "address": "93 Evans Rd",
    "parcel_id": "098-10-00",
    "owner1": "LESSER, CAROL",
    "owner2": "",
    "current_taxes": 29578.51,
    "new_taxes_no_override": 30856.3,
    "override_total_1": 31731.83,
    "override_increase_1": 875.52
  },
  {
    "#": "99 Evans Rd (098-11-00)",
    "$": 3031100,
    "address": "99 Evans Rd",
    "parcel_id": "098-11-00",
    "owner1": "STEINBERGH, DAVID S",
    "owner2": "PRINGLE, CORINNA J",
    "current_taxes": 27403.53,
    "new_taxes_no_override": 28587.36,
    "override_total_1": 29398.51,
    "override_increase_1": 811.14
  },
  {
    "#": "4 Fairbanks St, Unit 1 (215-01-01)",
    "$": 601600,
    "address": "4 Fairbanks St, Unit 1",
    "parcel_id": "215-01-01",
    "owner1": "RIZK, ANDRE",
    "owner2": "",
    "current_taxes": 6160.38,
    "new_taxes_no_override": 6426.51,
    "override_total_1": 6608.86,
    "override_increase_1": 182.35
  },
  {
    "#": "4 Fairbanks St, Unit 2 (215-01-02)",
    "$": 1340200,
    "address": "4 Fairbanks St, Unit 2",
    "parcel_id": "215-01-02",
    "owner1": "RIZK, ANDRE",
    "owner2": "",
    "current_taxes": 13723.65,
    "new_taxes_no_override": 14316.51,
    "override_total_1": 14722.73,
    "override_increase_1": 406.22
  },
  {
    "#": "4 Fairbanks St, Unit 3 (215-01-03)",
    "$": 1620700,
    "address": "4 Fairbanks St, Unit 3",
    "parcel_id": "215-01-03",
    "owner1": "ZIMMER, SCOTT DAVID",
    "owner2": "GORRAIZ, MAGGIE",
    "current_taxes": 12961.03,
    "new_taxes_no_override": 13520.95,
    "override_total_1": 13904.59,
    "override_increase_1": 383.65
  },
  {
    "#": "4 Fairbanks St, Unit 4 (215-01-04)",
    "$": 1424100,
    "address": "4 Fairbanks St, Unit 4",
    "parcel_id": "215-01-04",
    "owner1": "YAUN TRS ET AL, YUAN",
    "owner2": "C/O BOSTON PROPERTY GROUP LLC",
    "current_taxes": 14582.78,
    "new_taxes_no_override": 15212.76,
    "override_total_1": 15644.41,
    "override_increase_1": 431.65
  },
  {
    "#": "5 Fairbanks St, Unit 5-2 & P1 (214-01-03)",
    "$": 854800,
    "address": "5 Fairbanks St, Unit 5-2 & P1",
    "parcel_id": "214-01-03",
    "owner1": "LIND, COURTNEY NICOLE",
    "owner2": "",
    "current_taxes": 5118.22,
    "new_taxes_no_override": 5339.33,
    "override_total_1": 5490.83,
    "override_increase_1": 151.5
  },
  {
    "#": "5 Fairbanks St, Unit 5-3 & P10 (214-01-04)",
    "$": 757400,
    "address": "5 Fairbanks St, Unit 5-3 & P10",
    "parcel_id": "214-01-04",
    "owner1": "WATERMAN TR, HAL I",
    "owner2": "",
    "current_taxes": 7755.78,
    "new_taxes_no_override": 8090.83,
    "override_total_1": 8320.4,
    "override_increase_1": 229.57
  },
  {
    "#": "8 Fairbanks St, Unit 1 (215-29-03)",
    "$": 905100,
    "address": "8 Fairbanks St, Unit 1",
    "parcel_id": "215-29-03",
    "owner1": "BARONOFSKY TRS, JERALD JAY & DEVORA ROSENSWEIG",
    "owner2": "",
    "current_taxes": 5633.29,
    "new_taxes_no_override": 5876.65,
    "override_total_1": 6043.39,
    "override_increase_1": 166.75
  },
  {
    "#": "8 Fairbanks St, Unit 2 (215-29-01)",
    "$": 1100100,
    "address": "8 Fairbanks St, Unit 2",
    "parcel_id": "215-29-01",
    "owner1": "AGAMOV, ANDREY & ALLA",
    "owner2": "",
    "current_taxes": 11265.02,
    "new_taxes_no_override": 11751.67,
    "override_total_1": 12085.11,
    "override_increase_1": 333.44
  },
  {
    "#": "8 Fairbanks St, Unit 3 (215-29-02)",
    "$": 1205000,
    "address": "8 Fairbanks St, Unit 3",
    "parcel_id": "215-29-02",
    "owner1": "FRANK-KAMENETSKII, MAXIM D & MARIA",
    "owner2": "",
    "current_taxes": 8704.27,
    "new_taxes_no_override": 9080.29,
    "override_total_1": 9337.94,
    "override_increase_1": 257.65
  },
  {
    "#": "9 Fairbanks St, Unit 1 (214-02-06)",
    "$": 1032200,
    "address": "9 Fairbanks St, Unit 1",
    "parcel_id": "214-02-06",
    "owner1": "ADAMS TRS, BRETT H & CHRISTINE M",
    "owner2": "",
    "current_taxes": 10569.73,
    "new_taxes_no_override": 11026.34,
    "override_total_1": 11339.21,
    "override_increase_1": 312.86
  },
  {
    "#": "9 Fairbanks St, Unit 2 (214-02-01)",
    "$": 1052100,
    "address": "9 Fairbanks St, Unit 2",
    "parcel_id": "214-02-01",
    "owner1": "MORRISSEY, STACY J",
    "owner2": "",
    "current_taxes": 7138.57,
    "new_taxes_no_override": 7446.96,
    "override_total_1": 7658.26,
    "override_increase_1": 211.3
  },
  {
    "#": "9 Fairbanks St, Unit 3 (214-02-02)",
    "$": 985300,
    "address": "9 Fairbanks St, Unit 3",
    "parcel_id": "214-02-02",
    "owner1": "FELDMAN TRS, ORNA",
    "owner2": "",
    "current_taxes": 6454.54,
    "new_taxes_no_override": 6733.38,
    "override_total_1": 6924.43,
    "override_increase_1": 191.05
  },
  {
    "#": "10 Fairbanks St (215-28-00)",
    "$": 3390800,
    "address": "10 Fairbanks St",
    "parcel_id": "215-28-00",
    "owner1": "LAU TRS, CHOW K",
    "owner2": "",
    "current_taxes": 34721.79,
    "new_taxes_no_override": 36221.77,
    "override_total_1": 37249.54,
    "override_increase_1": 1027.76
  },
  {
    "#": "14 Fairbanks St, Unit 1 (215-27-01)",
    "$": 1674300,
    "address": "14 Fairbanks St, Unit 1",
    "parcel_id": "215-27-01",
    "owner1": "RITTNER ETAL, PEDRO",
    "owner2": "LIEBER, DANIELLE & BARUCH",
    "current_taxes": 13509.9,
    "new_taxes_no_override": 14093.53,
    "override_total_1": 14493.42,
    "override_increase_1": 399.89
  },
  {
    "#": "14 Fairbanks St, Unit 2 (215-27-02)",
    "$": 1724000,
    "address": "14 Fairbanks St, Unit 2",
    "parcel_id": "215-27-02",
    "owner1": "CURLEY, MICHAEL D & SUSANA M TENTE",
    "owner2": "",
    "current_taxes": 14018.83,
    "new_taxes_no_override": 14624.44,
    "override_total_1": 15039.4,
    "override_increase_1": 414.96
  },
  {
    "#": "14 Fairbanks St, Unit 3 (215-27-03)",
    "$": 1684800,
    "address": "14 Fairbanks St, Unit 3",
    "parcel_id": "215-27-03",
    "owner1": "WINTERS, MARCUS & KELLY",
    "owner2": "",
    "current_taxes": 13617.42,
    "new_taxes_no_override": 14205.69,
    "override_total_1": 14608.77,
    "override_increase_1": 403.08
  },
  {
    "#": "15 Fairbanks St, Unit 1 (214-02-03)",
    "$": 1020200,
    "address": "15 Fairbanks St, Unit 1",
    "parcel_id": "214-02-03",
    "owner1": "THOMAS, KAITLYN & JACOB NATHANIEL",
    "owner2": "",
    "current_taxes": 10446.85,
    "new_taxes_no_override": 10898.15,
    "override_total_1": 11207.38,
    "override_increase_1": 309.23
  },
  {
    "#": "15 Fairbanks St, Unit 2 (214-02-04)",
    "$": 994100,
    "address": "15 Fairbanks St, Unit 2",
    "parcel_id": "214-02-04",
    "owner1": "KEFALAS, CATHERINE I",
    "owner2": "",
    "current_taxes": 6544.65,
    "new_taxes_no_override": 6827.38,
    "override_total_1": 7021.1,
    "override_increase_1": 193.72
  },
  {
    "#": "15 Fairbanks St, Unit 3 (214-02-05)",
    "$": 963200,
    "address": "15 Fairbanks St, Unit 3",
    "parcel_id": "214-02-05",
    "owner1": "KIRTIKAR, KUNAL",
    "owner2": "DHARIA, SHIVANI",
    "current_taxes": 6228.23,
    "new_taxes_no_override": 6497.29,
    "override_total_1": 6681.65,
    "override_increase_1": 184.36
  },
  {
    "#": "16 Fairbanks St, Unit 1 (215-26-01)",
    "$": 1031100,
    "address": "16 Fairbanks St, Unit 1",
    "parcel_id": "215-26-01",
    "owner1": "BENAYUN TRS, MEYER M & RONDA",
    "owner2": "",
    "current_taxes": 6923.53,
    "new_taxes_no_override": 7222.63,
    "override_total_1": 7427.56,
    "override_increase_1": 204.94
  },
  {
    "#": "16 Fairbanks St, Unit 2 (215-26-02)",
    "$": 1078600,
    "address": "16 Fairbanks St, Unit 2",
    "parcel_id": "215-26-02",
    "owner1": "CAMPBELL, THOMAS J & SUSAN H",
    "owner2": "",
    "current_taxes": 7409.93,
    "new_taxes_no_override": 7730.04,
    "override_total_1": 7949.37,
    "override_increase_1": 219.33
  },
  {
    "#": "16 Fairbanks St, Unit 3 (215-26-03)",
    "$": 1109300,
    "address": "16 Fairbanks St, Unit 3",
    "parcel_id": "215-26-03",
    "owner1": "HUSSAIN, MOHAMAD ANAS",
    "owner2": "SHABBIR, FAREENA",
    "current_taxes": 7724.3,
    "new_taxes_no_override": 8057.99,
    "override_total_1": 8286.63,
    "override_increase_1": 228.64
  },
  {
    "#": "17 Fairbanks St (214-03-07)",
    "$": 21410800,
    "address": "17 Fairbanks St",
    "parcel_id": "214-03-07",
    "owner1": "BEACON FAIRBANKS MANOR LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 219246.59,
    "new_taxes_no_override": 228718.04,
    "override_total_1": 235207.74,
    "override_increase_1": 6489.7
  },
  {
    "#": "20 Fairbanks St (215-24-25)",
    "$": 9885700,
    "address": "20 Fairbanks St",
    "parcel_id": "215-24-25",
    "owner1": "PARVIS CENTER LLC ET AL",
    "owner2": "SYROOS HYSLOP LLC",
    "current_taxes": 101229.57,
    "new_taxes_no_override": 105602.69,
    "override_total_1": 108599.08,
    "override_increase_1": 2996.4
  },
  {
    "#": "9 Fairgreen Pl, Unit 9 (442-01-09)",
    "$": 1387400,
    "address": "9 Fairgreen Pl, Unit 9",
    "parcel_id": "442-01-09",
    "owner1": "EHRLICH TR, WALTER",
    "owner2": "",
    "current_taxes": 10572.04,
    "new_taxes_no_override": 11028.75,
    "override_total_1": 11341.68,
    "override_increase_1": 312.93
  },
  {
    "#": "11 Fairgreen Pl, Unit 10 (442-01-10)",
    "$": 1397700,
    "address": "11 Fairgreen Pl, Unit 10",
    "parcel_id": "442-01-10",
    "owner1": "WELCH, SUSAN M & JOHN H",
    "owner2": "",
    "current_taxes": 10677.51,
    "new_taxes_no_override": 11138.78,
    "override_total_1": 11454.83,
    "override_increase_1": 316.05
  },
  {
    "#": "15 Fairgreen Pl, Unit 1 (442-01-01)",
    "$": 1393400,
    "address": "15 Fairgreen Pl, Unit 1",
    "parcel_id": "442-01-01",
    "owner1": "DALTON, D GRAY & JAMIE",
    "owner2": "",
    "current_taxes": 10633.48,
    "new_taxes_no_override": 11092.85,
    "override_total_1": 11407.6,
    "override_increase_1": 314.75
  },
  {
    "#": "17 Fairgreen Pl, Unit 2 (442-01-02)",
    "$": 1435200,
    "address": "17 Fairgreen Pl, Unit 2",
    "parcel_id": "442-01-02",
    "owner1": "MOORE TRS, THOMAS B",
    "owner2": "FRANCINI, JOHN F",
    "current_taxes": 14696.45,
    "new_taxes_no_override": 15331.34,
    "override_total_1": 15766.35,
    "override_increase_1": 435.01
  },
  {
    "#": "19 Fairgreen Pl, Unit 3 (442-01-03)",
    "$": 1413600,
    "address": "19 Fairgreen Pl, Unit 3",
    "parcel_id": "442-01-03",
    "owner1": "PILLSBURY ET AL TRS, KATHARINE C",
    "owner2": "JOSE, KATHARINE P",
    "current_taxes": 14475.26,
    "new_taxes_no_override": 15100.59,
    "override_total_1": 15529.06,
    "override_increase_1": 428.47
  },
  {
    "#": "21 Fairgreen Pl, Unit 4 (442-01-04)",
    "$": 1368800,
    "address": "21 Fairgreen Pl, Unit 4",
    "parcel_id": "442-01-04",
    "owner1": "WATERMAN TRS, FREDERICK",
    "owner2": "WEED, AMY",
    "current_taxes": 10381.58,
    "new_taxes_no_override": 10830.06,
    "override_total_1": 11137.36,
    "override_increase_1": 307.29
  },
  {
    "#": "23 Fairgreen Pl, Unit 12 (442-01-12)",
    "$": 1373300,
    "address": "23 Fairgreen Pl, Unit 12",
    "parcel_id": "442-01-12",
    "owner1": "CORNISH, JOHN M & CECILY D",
    "owner2": "",
    "current_taxes": 14062.59,
    "new_taxes_no_override": 14670.09,
    "override_total_1": 15086.35,
    "override_increase_1": 416.25
  },
  {
    "#": "25 Fairgreen Pl, Unit 11 (442-01-11)",
    "$": 1170500,
    "address": "25 Fairgreen Pl, Unit 11",
    "parcel_id": "442-01-11",
    "owner1": "COULTER TR, CHERYL S",
    "owner2": "",
    "current_taxes": 8350.99,
    "new_taxes_no_override": 8711.75,
    "override_total_1": 8958.94,
    "override_increase_1": 247.19
  },
  {
    "#": "27 Fairgreen Pl, Unit 5 (442-01-05)",
    "$": 1493000,
    "address": "27 Fairgreen Pl, Unit 5",
    "parcel_id": "442-01-05",
    "owner1": "FAIRGREEN 2014 LLC",
    "owner2": "",
    "current_taxes": 15288.32,
    "new_taxes_no_override": 15948.78,
    "override_total_1": 16401.31,
    "override_increase_1": 452.53
  },
  {
    "#": "29 Fairgreen Pl, Unit 6 (442-01-06)",
    "$": 1484100,
    "address": "29 Fairgreen Pl, Unit 6",
    "parcel_id": "442-01-06",
    "owner1": "WELD, ALEXANDER B",
    "owner2": "",
    "current_taxes": 11562.25,
    "new_taxes_no_override": 12061.74,
    "override_total_1": 12403.98,
    "override_increase_1": 342.24
  },
  {
    "#": "31 Fairgreen Pl, Unit 7 (442-01-07)",
    "$": 1493100,
    "address": "31 Fairgreen Pl, Unit 7",
    "parcel_id": "442-01-07",
    "owner1": "LOCKWOOD TRS, CHARLES C",
    "owner2": "PRATT, HAROLD I",
    "current_taxes": 15289.34,
    "new_taxes_no_override": 15949.84,
    "override_total_1": 16402.4,
    "override_increase_1": 452.56
  },
  {
    "#": "33 Fairgreen Pl, Unit 8 (442-01-08)",
    "$": 1540800,
    "address": "33 Fairgreen Pl, Unit 8",
    "parcel_id": "442-01-08",
    "owner1": "FAIRGREEN PLACE LLC",
    "owner2": "",
    "current_taxes": 15777.79,
    "new_taxes_no_override": 16459.39,
    "override_total_1": 16926.41,
    "override_increase_1": 467.02
  },
  {
    "#": "43 Fairgreen Pl (442-05-00)",
    "$": 2126900,
    "address": "43 Fairgreen Pl",
    "parcel_id": "442-05-00",
    "owner1": "ACES DEVELOPMENT LLC",
    "owner2": "",
    "current_taxes": 21779.46,
    "new_taxes_no_override": 22720.33,
    "override_total_1": 23365.0,
    "override_increase_1": 644.67
  },
  {
    "#": "44 Fairgreen Pl, Unit 9 (442-07-09)",
    "$": 1507000,
    "address": "44 Fairgreen Pl, Unit 9",
    "parcel_id": "442-07-09",
    "owner1": "SCHODLATZ TRS, DIANE R",
    "owner2": "",
    "current_taxes": 11796.75,
    "new_taxes_no_override": 12306.37,
    "override_total_1": 12655.55,
    "override_increase_1": 349.18
  },
  {
    "#": "46 Fairgreen Pl, Unit 10 (442-07-10)",
    "$": 1543800,
    "address": "46 Fairgreen Pl, Unit 10",
    "parcel_id": "442-07-10",
    "owner1": "MILLET TRS, CHRISTINA W & DAVID F",
    "owner2": "",
    "current_taxes": 12173.58,
    "new_taxes_no_override": 12699.48,
    "override_total_1": 13059.82,
    "override_increase_1": 360.34
  },
  {
    "#": "48 Fairgreen Pl, Unit 11 (442-07-11)",
    "$": 1626900,
    "address": "48 Fairgreen Pl, Unit 11",
    "parcel_id": "442-07-11",
    "owner1": "INGRAM, JOHN R",
    "owner2": "WALCOTT, DIANA P",
    "current_taxes": 16659.46,
    "new_taxes_no_override": 17379.15,
    "override_total_1": 17872.27,
    "override_increase_1": 493.12
  },
  {
    "#": "50 Fairgreen Pl, Unit 12 (442-07-12)",
    "$": 1117600,
    "address": "50 Fairgreen Pl, Unit 12",
    "parcel_id": "442-07-12",
    "owner1": "KATZ, ALEXANDER R",
    "owner2": "YONKER, LAINE E",
    "current_taxes": 7809.29,
    "new_taxes_no_override": 8146.65,
    "override_total_1": 8377.81,
    "override_increase_1": 231.15
  },
  {
    "#": "52 Fairgreen Pl, Unit 13 (442-07-13)",
    "$": 1335700,
    "address": "52 Fairgreen Pl, Unit 13",
    "parcel_id": "442-07-13",
    "owner1": "FREED TRS, JUSTIN M & ELIZABETH N",
    "owner2": "",
    "current_taxes": 13677.57,
    "new_taxes_no_override": 14268.44,
    "override_total_1": 14673.3,
    "override_increase_1": 404.86
  },
  {
    "#": "53 Fairgreen Pl, Unit 13 (442-06-13)",
    "$": 1371900,
    "address": "53 Fairgreen Pl, Unit 13",
    "parcel_id": "442-06-13",
    "owner1": "FRICK, TRS, GEORGE R & MARIAN R",
    "owner2": "",
    "current_taxes": 14048.26,
    "new_taxes_no_override": 14655.14,
    "override_total_1": 15070.97,
    "override_increase_1": 415.83
  },
  {
    "#": "54 Fairgreen Pl, Unit 14 (442-07-14)",
    "$": 1658800,
    "address": "54 Fairgreen Pl, Unit 14",
    "parcel_id": "442-07-14",
    "owner1": "BOWDRING TR, NANCY M",
    "owner2": "",
    "current_taxes": 13351.18,
    "new_taxes_no_override": 13927.95,
    "override_total_1": 14323.15,
    "override_increase_1": 395.19
  },
  {
    "#": "55 Fairgreen Pl, Unit 14 (442-06-14)",
    "$": 1583800,
    "address": "55 Fairgreen Pl, Unit 14",
    "parcel_id": "442-06-14",
    "owner1": "TRIPP  ET AL TRS, ROBERTA A",
    "owner2": "C/O BETHANY M  WOODS LLC",
    "current_taxes": 16218.11,
    "new_taxes_no_override": 16918.73,
    "override_total_1": 17398.79,
    "override_increase_1": 480.06
  },
  {
    "#": "56 Fairgreen Pl, Unit 8 (442-07-08)",
    "$": 1567300,
    "address": "56 Fairgreen Pl, Unit 8",
    "parcel_id": "442-07-08",
    "owner1": "56 FAIRGREEN LLC",
    "owner2": "",
    "current_taxes": 16049.15,
    "new_taxes_no_override": 16742.47,
    "override_total_1": 17217.53,
    "override_increase_1": 475.05
  },
  {
    "#": "57 Fairgreen Pl, Unit 15 (442-06-15)",
    "$": 1519900,
    "address": "57 Fairgreen Pl, Unit 15",
    "parcel_id": "442-06-15",
    "owner1": "HUGHES, GEORGE M & KATHLEEN M",
    "owner2": "",
    "current_taxes": 11928.84,
    "new_taxes_no_override": 12444.17,
    "override_total_1": 12797.26,
    "override_increase_1": 353.09
  },
  {
    "#": "58 Fairgreen Pl, Unit 7 (442-07-07)",
    "$": 1723300,
    "address": "58 Fairgreen Pl, Unit 7",
    "parcel_id": "442-07-07",
    "owner1": "BOARDMAN, WILLIAM H & ALICE K",
    "owner2": "",
    "current_taxes": 17646.59,
    "new_taxes_no_override": 18408.92,
    "override_total_1": 18931.26,
    "override_increase_1": 522.34
  },
  {
    "#": "59 Fairgreen Pl, Unit 16 (442-06-16)",
    "$": 1581300,
    "address": "59 Fairgreen Pl, Unit 16",
    "parcel_id": "442-06-16",
    "owner1": "TULLY, TIMOTHY & ELIZABETH",
    "owner2": "",
    "current_taxes": 16192.51,
    "new_taxes_no_override": 16892.03,
    "override_total_1": 17371.32,
    "override_increase_1": 479.3
  },
  {
    "#": "60 Fairgreen Pl, Unit 6 (442-07-06)",
    "$": 1895800,
    "address": "60 Fairgreen Pl, Unit 6",
    "parcel_id": "442-07-06",
    "owner1": "REECE, J BROOKS JR & JUDITH S",
    "owner2": "",
    "current_taxes": 15778.06,
    "new_taxes_no_override": 16459.67,
    "override_total_1": 16926.7,
    "override_increase_1": 467.03
  },
  {
    "#": "61 Fairgreen Pl, Unit 17 (442-06-17)",
    "$": 1516700,
    "address": "61 Fairgreen Pl, Unit 17",
    "parcel_id": "442-06-17",
    "owner1": "WOOLVERTON, THERESA M & WILLIAM H III",
    "owner2": "",
    "current_taxes": 11896.07,
    "new_taxes_no_override": 12409.98,
    "override_total_1": 12762.1,
    "override_increase_1": 352.12
  },
  {
    "#": "62 Fairgreen Pl, Unit 5 (442-07-05)",
    "$": 2179300,
    "address": "62 Fairgreen Pl, Unit 5",
    "parcel_id": "442-07-05",
    "owner1": "BELL, GEORGE DEB JR & CAROLINE M",
    "owner2": "",
    "current_taxes": 22316.03,
    "new_taxes_no_override": 23280.08,
    "override_total_1": 23940.64,
    "override_increase_1": 660.55
  },
  {
    "#": "63 Fairgreen Pl, Unit 18 (442-06-18)",
    "$": 1356200,
    "address": "63 Fairgreen Pl, Unit 18",
    "parcel_id": "442-06-18",
    "owner1": "HAMLIN, SANDRA L",
    "owner2": "",
    "current_taxes": 10252.55,
    "new_taxes_no_override": 10695.46,
    "override_total_1": 10998.94,
    "override_increase_1": 303.48
  },
  {
    "#": "64 Fairgreen Pl, Unit 4 (442-07-04)",
    "$": 1835900,
    "address": "64 Fairgreen Pl, Unit 4",
    "parcel_id": "442-07-04",
    "owner1": "HAYDOCK, CANDACE",
    "owner2": "",
    "current_taxes": 15164.68,
    "new_taxes_no_override": 15819.79,
    "override_total_1": 16268.67,
    "override_increase_1": 448.87
  },
  {
    "#": "65 Fairgreen Pl, Unit 19 (442-06-19)",
    "$": 1462900,
    "address": "65 Fairgreen Pl, Unit 19",
    "parcel_id": "442-06-19",
    "owner1": "PLATT, ALLEN WARD",
    "owner2": "",
    "current_taxes": 14980.1,
    "new_taxes_no_override": 15627.24,
    "override_total_1": 16070.65,
    "override_increase_1": 443.41
  },
  {
    "#": "66 Fairgreen Pl, Unit 3 (442-07-03)",
    "$": 2138500,
    "address": "66 Fairgreen Pl, Unit 3",
    "parcel_id": "442-07-03",
    "owner1": "GRANDIN TRS, JOHN L III & ANNE D",
    "owner2": "",
    "current_taxes": 21898.24,
    "new_taxes_no_override": 22844.24,
    "override_total_1": 23492.43,
    "override_increase_1": 648.19
  },
  {
    "#": "67 Fairgreen Pl, Unit 20 (442-06-20)",
    "$": 1946000,
    "address": "67 Fairgreen Pl, Unit 20",
    "parcel_id": "442-06-20",
    "owner1": "HOCH, STEVEN GEORGE & JANE",
    "owner2": "",
    "current_taxes": 19927.04,
    "new_taxes_no_override": 20787.89,
    "override_total_1": 21377.73,
    "override_increase_1": 589.84
  },
  {
    "#": "68 Fairgreen Pl, Unit 68 (442-07-02)",
    "$": 1967400,
    "address": "68 Fairgreen Pl, Unit 68",
    "parcel_id": "442-07-02",
    "owner1": "BURNES, KENNETT & BARBARA J",
    "owner2": "",
    "current_taxes": 20146.18,
    "new_taxes_no_override": 21016.49,
    "override_total_1": 21612.82,
    "override_increase_1": 596.33
  },
  {
    "#": "70 Fairgreen Pl, Unit 1 (442-07-01)",
    "$": 2029900,
    "address": "70 Fairgreen Pl, Unit 1",
    "parcel_id": "442-07-01",
    "owner1": "RUSSELL, DIANNE H",
    "owner2": "",
    "current_taxes": 20786.18,
    "new_taxes_no_override": 21684.14,
    "override_total_1": 22299.41,
    "override_increase_1": 615.27
  },
  {
    "#": " Fairgreen Pl (442-06-01)",
    "$": 50400,
    "address": " Fairgreen Pl",
    "parcel_id": "442-06-01",
    "owner1": "HOCH, STEVEN GEORGE & JANE",
    "owner2": "",
    "current_taxes": 516.1,
    "new_taxes_no_override": 538.4,
    "override_total_1": 553.67,
    "override_increase_1": 15.28
  },
  {
    "#": "12 Fairmount St (327-01-00)",
    "$": 2076600,
    "address": "12 Fairmount St",
    "parcel_id": "327-01-00",
    "owner1": "GLAZERMAN TRS, STEPHANIE",
    "owner2": "ROSENHEIM, JAY AARON",
    "current_taxes": 21264.38,
    "new_taxes_no_override": 22183.0,
    "override_total_1": 22812.43,
    "override_increase_1": 629.43
  },
  {
    "#": "21 Fairmount St (326-04-00)",
    "$": 2806400,
    "address": "21 Fairmount St",
    "parcel_id": "326-04-00",
    "owner1": "KALVERT, SETH J & RACHEL R",
    "owner2": "",
    "current_taxes": 25102.6,
    "new_taxes_no_override": 26187.03,
    "override_total_1": 26930.07,
    "override_increase_1": 743.04
  },
  {
    "#": "25 Fairmount St, Unit 25 (326-05-01)",
    "$": 1513800,
    "address": "25 Fairmount St, Unit 25",
    "parcel_id": "326-05-01",
    "owner1": "MACDONALD, CHRISTINE",
    "owner2": "CONWILL, MICHAEL",
    "current_taxes": 11866.38,
    "new_taxes_no_override": 12379.01,
    "override_total_1": 12730.25,
    "override_increase_1": 351.24
  },
  {
    "#": "25 Fairmount St, Unit 27 (326-05-02)",
    "$": 1452800,
    "address": "25 Fairmount St, Unit 27",
    "parcel_id": "326-05-02",
    "owner1": "SULLIVAN, JANET",
    "owner2": "",
    "current_taxes": 11241.74,
    "new_taxes_no_override": 11727.38,
    "override_total_1": 12060.14,
    "override_increase_1": 332.76
  },
  {
    "#": "33 Fairmount St (326-06-00)",
    "$": 2751600,
    "address": "33 Fairmount St",
    "parcel_id": "326-06-00",
    "owner1": "PENER, MARK L",
    "owner2": "BACON, KATHARINE D",
    "current_taxes": 24541.45,
    "new_taxes_no_override": 25601.64,
    "override_total_1": 26328.07,
    "override_increase_1": 726.43
  },
  {
    "#": "36 Fairmount St (334-02-01)",
    "$": 13150800,
    "address": "36 Fairmount St",
    "parcel_id": "334-02-01",
    "owner1": "DASSORI ET AL TRS, F DAVIS",
    "owner2": "C/O CHOATE HALL & STEWART",
    "current_taxes": 134664.19,
    "new_taxes_no_override": 140481.68,
    "override_total_1": 144467.74,
    "override_increase_1": 3986.06
  },
  {
    "#": "39 Fairmount St (326-07-00)",
    "$": 2789600,
    "address": "39 Fairmount St",
    "parcel_id": "326-07-00",
    "owner1": "ANDERSON, SCOTT & KATHERINE R",
    "owner2": "",
    "current_taxes": 24930.57,
    "new_taxes_no_override": 26007.57,
    "override_total_1": 26745.52,
    "override_increase_1": 737.94
  },
  {
    "#": "54 Fairmount St (334-34-00)",
    "$": 4944700,
    "address": "54 Fairmount St",
    "parcel_id": "334-34-00",
    "owner1": "MATIELLO, MARCELO & ERIN LYONS",
    "owner2": "",
    "current_taxes": 46998.79,
    "new_taxes_no_override": 49029.14,
    "override_total_1": 50420.3,
    "override_increase_1": 1391.16
  },
  {
    "#": "70 Fairmount St (334-33-00)",
    "$": 4550300,
    "address": "70 Fairmount St",
    "parcel_id": "334-33-00",
    "owner1": "ROBERTS, CARMICHAEL S JR",
    "owner2": "PARK, SANDRA",
    "current_taxes": 42960.14,
    "new_taxes_no_override": 44816.02,
    "override_total_1": 46087.64,
    "override_increase_1": 1271.62
  },
  {
    "#": "72 Fairmount St (334-32-00)",
    "$": 4374600,
    "address": "72 Fairmount St",
    "parcel_id": "334-32-00",
    "owner1": "BROWN-NAGIN, TOMIKO",
    "owner2": "NAGIN, DANIEL L",
    "current_taxes": 41160.97,
    "new_taxes_no_override": 42939.12,
    "override_total_1": 44157.49,
    "override_increase_1": 1218.36
  },
  {
    "#": "73 Fairmount St (326-11-00)",
    "$": 2830100,
    "address": "73 Fairmount St",
    "parcel_id": "326-11-00",
    "owner1": "SANDMEL TRS, CHARLES E F",
    "owner2": "SIMONETTI, BARBARA A",
    "current_taxes": 25345.29,
    "new_taxes_no_override": 26440.21,
    "override_total_1": 27190.43,
    "override_increase_1": 750.22
  },
  {
    "#": "81 Fairmount St (326-12-00)",
    "$": 3307100,
    "address": "81 Fairmount St",
    "parcel_id": "326-12-00",
    "owner1": "DICK, WILL K & SANDRA M",
    "owner2": "",
    "current_taxes": 30229.77,
    "new_taxes_no_override": 31535.7,
    "override_total_1": 32430.5,
    "override_increase_1": 894.8
  },
  {
    "#": "82 Fairmount St (334-31-00)",
    "$": 2670000,
    "address": "82 Fairmount St",
    "parcel_id": "334-31-00",
    "owner1": "HUEBNER, JOHN  & LOUISE CARTER",
    "owner2": "",
    "current_taxes": 27340.8,
    "new_taxes_no_override": 28521.92,
    "override_total_1": 29331.21,
    "override_increase_1": 809.29
  },
  {
    "#": "87 Fairmount St (326-13-00)",
    "$": 3725000,
    "address": "87 Fairmount St",
    "parcel_id": "326-13-00",
    "owner1": "PICKARD, EMMA",
    "owner2": "",
    "current_taxes": 38144.0,
    "new_taxes_no_override": 39791.82,
    "override_total_1": 40920.88,
    "override_increase_1": 1129.06
  },
  {
    "#": "99 Fairmount St (326-14-00)",
    "$": 2331400,
    "address": "99 Fairmount St",
    "parcel_id": "326-14-00",
    "owner1": "PAN, JOHN & CINDY",
    "owner2": "",
    "current_taxes": 20238.6,
    "new_taxes_no_override": 21112.91,
    "override_total_1": 21711.97,
    "override_increase_1": 599.06
  },
  {
    "#": "7 Fairway Rd (278-01-00)",
    "$": 2362000,
    "address": "7 Fairway Rd",
    "parcel_id": "278-01-00",
    "owner1": "MAH, DOUGLAS & JENNIFER",
    "owner2": "",
    "current_taxes": 20551.95,
    "new_taxes_no_override": 21439.79,
    "override_total_1": 22048.13,
    "override_increase_1": 608.34
  },
  {
    "#": "8 Fairway Rd (278C-18-00)",
    "$": 3198200,
    "address": "8 Fairway Rd",
    "parcel_id": "278C-18-00",
    "owner1": "ALGENDY, SHERIF",
    "owner2": "",
    "current_taxes": 29114.63,
    "new_taxes_no_override": 30372.38,
    "override_total_1": 31234.18,
    "override_increase_1": 861.79
  },
  {
    "#": "14 Fairway Rd (278C-17-00)",
    "$": 1727700,
    "address": "14 Fairway Rd",
    "parcel_id": "278C-17-00",
    "owner1": "MEMPEL, THORSTEN R",
    "owner2": "GOODARZI, KATAYOON",
    "current_taxes": 14056.71,
    "new_taxes_no_override": 14663.96,
    "override_total_1": 15080.04,
    "override_increase_1": 416.08
  },
  {
    "#": "21 Fairway Rd (278-02-00)",
    "$": 2299300,
    "address": "21 Fairway Rd",
    "parcel_id": "278-02-00",
    "owner1": "VLEUGELS, RUTH ANN",
    "owner2": "ANDERSON, KEITH EDWIN JR",
    "current_taxes": 19909.9,
    "new_taxes_no_override": 20770.01,
    "override_total_1": 21359.34,
    "override_increase_1": 589.33
  },
  {
    "#": "24 Fairway Rd (278C-16-00)",
    "$": 2293500,
    "address": "24 Fairway Rd",
    "parcel_id": "278C-16-00",
    "owner1": "FRONSAGLIA, MARGOT DONOHUE & DOMENIC",
    "owner2": "",
    "current_taxes": 19850.51,
    "new_taxes_no_override": 20708.05,
    "override_total_1": 21295.63,
    "override_increase_1": 587.58
  },
  {
    "#": "32 Fairway Rd (278C-15-00)",
    "$": 1944400,
    "address": "32 Fairway Rd",
    "parcel_id": "278C-15-00",
    "owner1": "GRIMES TR, WILLIAM W",
    "owner2": "STANFORD TR, MELINDA A",
    "current_taxes": 16275.72,
    "new_taxes_no_override": 16978.83,
    "override_total_1": 17460.59,
    "override_increase_1": 481.76
  },
  {
    "#": "33 Fairway Rd (278-03-00)",
    "$": 2786700,
    "address": "33 Fairway Rd",
    "parcel_id": "278-03-00",
    "owner1": "WEEKS, CHRISTOPHER L & KATHRYN H",
    "owner2": "",
    "current_taxes": 28535.81,
    "new_taxes_no_override": 29768.56,
    "override_total_1": 30613.22,
    "override_increase_1": 844.66
  },
  {
    "#": "42 Fairway Rd (278C-14-00)",
    "$": 2172900,
    "address": "42 Fairway Rd",
    "parcel_id": "278C-14-00",
    "owner1": "APPLEBAUM, EVAN & DANA GREENE",
    "owner2": "",
    "current_taxes": 18615.56,
    "new_taxes_no_override": 19419.75,
    "override_total_1": 19970.77,
    "override_increase_1": 551.02
  },
  {
    "#": "52 Fairway Rd (278C-13-00)",
    "$": 3609400,
    "address": "52 Fairway Rd",
    "parcel_id": "278C-13-00",
    "owner1": "CALMAS, RICHARD D & ELLEN S",
    "owner2": "",
    "current_taxes": 33325.32,
    "new_taxes_no_override": 34764.97,
    "override_total_1": 35751.4,
    "override_increase_1": 986.43
  },
  {
    "#": "62 Fairway Rd (278C-12-00)",
    "$": 2802800,
    "address": "62 Fairway Rd",
    "parcel_id": "278C-12-00",
    "owner1": "JALAN, RAJNEESH & RASHMI",
    "owner2": "",
    "current_taxes": 25065.74,
    "new_taxes_no_override": 26148.58,
    "override_total_1": 26890.53,
    "override_increase_1": 741.95
  },
  {
    "#": "69 Fairway Rd (278A-02-00)",
    "$": 2476200,
    "address": "69 Fairway Rd",
    "parcel_id": "278A-02-00",
    "owner1": "ST CLAIR TR, CORINNE M",
    "owner2": "",
    "current_taxes": 21721.35,
    "new_taxes_no_override": 22659.71,
    "override_total_1": 23302.66,
    "override_increase_1": 642.95
  },
  {
    "#": "72 Fairway Rd (278C-11-00)",
    "$": 2105800,
    "address": "72 Fairway Rd",
    "parcel_id": "278C-11-00",
    "owner1": "HARVEY, WILLIAM F",
    "owner2": "ATEMA, ANNEMIEKE",
    "current_taxes": 17928.46,
    "new_taxes_no_override": 18702.97,
    "override_total_1": 19233.65,
    "override_increase_1": 530.68
  },
  {
    "#": "77 Fairway Rd (278A-03-00)",
    "$": 2226600,
    "address": "77 Fairway Rd",
    "parcel_id": "278A-03-00",
    "owner1": "SANIEOFF TRS, ARASH & ASHKAN",
    "owner2": "",
    "current_taxes": 22800.38,
    "new_taxes_no_override": 23785.36,
    "override_total_1": 24460.25,
    "override_increase_1": 674.89
  },
  {
    "#": "82 Fairway Rd (278C-10-00)",
    "$": 2439400,
    "address": "82 Fairway Rd",
    "parcel_id": "278C-10-00",
    "owner1": "MORSE, DAVID P JR & ADLUMIA G",
    "owner2": "",
    "current_taxes": 21344.52,
    "new_taxes_no_override": 22266.6,
    "override_total_1": 22898.4,
    "override_increase_1": 631.8
  },
  {
    "#": "85 Fairway Rd (278A-04-00)",
    "$": 2807800,
    "address": "85 Fairway Rd",
    "parcel_id": "278A-04-00",
    "owner1": "RITTER, STEVEN J & SUSAN Y",
    "owner2": "",
    "current_taxes": 25116.94,
    "new_taxes_no_override": 26201.99,
    "override_total_1": 26945.45,
    "override_increase_1": 743.46
  },
  {
    "#": "92 Fairway Rd (278C-09-01)",
    "$": 3454700,
    "address": "92 Fairway Rd",
    "parcel_id": "278C-09-01",
    "owner1": "MALLOY, DONALD J & RUTH L",
    "owner2": "",
    "current_taxes": 31741.19,
    "new_taxes_no_override": 33112.41,
    "override_total_1": 34051.95,
    "override_increase_1": 939.54
  },
  {
    "#": "100 Fairway Rd (278C-09-00)",
    "$": 2144800,
    "address": "100 Fairway Rd",
    "parcel_id": "278C-09-00",
    "owner1": "TIRADO, RODRIGO & GLORIA",
    "owner2": "",
    "current_taxes": 18327.82,
    "new_taxes_no_override": 19119.58,
    "override_total_1": 19662.09,
    "override_increase_1": 542.5
  },
  {
    "#": "110 Fairway Rd (278C-08-01)",
    "$": 1772900,
    "address": "110 Fairway Rd",
    "parcel_id": "278C-08-01",
    "owner1": "BAZOBERRY, CARLOS F",
    "owner2": "",
    "current_taxes": 14519.56,
    "new_taxes_no_override": 15146.8,
    "override_total_1": 15576.58,
    "override_increase_1": 429.78
  },
  {
    "#": "120 Fairway Rd (278C-08-00)",
    "$": 2124500,
    "address": "120 Fairway Rd",
    "parcel_id": "278C-08-00",
    "owner1": "MASON, ASHLEY H & NATHANIEL S",
    "owner2": "",
    "current_taxes": 18119.95,
    "new_taxes_no_override": 18902.73,
    "override_total_1": 19439.08,
    "override_increase_1": 536.35
  },
  {
    "#": "127 Fairway Rd (278B-01-00)",
    "$": 5223200,
    "address": "127 Fairway Rd",
    "parcel_id": "278B-01-00",
    "owner1": "FERRERA TRS, DAVID L & VINITA C",
    "owner2": "",
    "current_taxes": 49850.63,
    "new_taxes_no_override": 52004.18,
    "override_total_1": 53479.76,
    "override_increase_1": 1475.58
  },
  {
    "#": "130 Fairway Rd (278C-07-00)",
    "$": 1757100,
    "address": "130 Fairway Rd",
    "parcel_id": "278C-07-00",
    "owner1": "FENTON, WHA J W",
    "owner2": "",
    "current_taxes": 14357.77,
    "new_taxes_no_override": 14978.03,
    "override_total_1": 15403.02,
    "override_increase_1": 424.99
  },
  {
    "#": "135 Fairway Rd (278B-02-00)",
    "$": 2039200,
    "address": "135 Fairway Rd",
    "parcel_id": "278B-02-00",
    "owner1": "CONDON, STEPHEN H & DOWLING D",
    "owner2": "",
    "current_taxes": 17246.47,
    "new_taxes_no_override": 17991.52,
    "override_total_1": 18502.01,
    "override_increase_1": 510.5
  },
  {
    "#": "140 Fairway Rd (278C-06-00)",
    "$": 2588600,
    "address": "140 Fairway Rd",
    "parcel_id": "278C-06-00",
    "owner1": "FLASHMAN TRS, ARTHUR S & SUSAN P",
    "owner2": "",
    "current_taxes": 22872.33,
    "new_taxes_no_override": 23860.41,
    "override_total_1": 24537.44,
    "override_increase_1": 677.02
  },
  {
    "#": "143 Fairway Rd (278B-03-00)",
    "$": 2521000,
    "address": "143 Fairway Rd",
    "parcel_id": "278B-03-00",
    "owner1": "SCHRODER, RICHARD M & JEANNINE S",
    "owner2": "",
    "current_taxes": 22180.11,
    "new_taxes_no_override": 23138.29,
    "override_total_1": 23794.82,
    "override_increase_1": 656.53
  },
  {
    "#": "150 Fairway Rd (278C-05-02)",
    "$": 2374000,
    "address": "150 Fairway Rd",
    "parcel_id": "278C-05-02",
    "owner1": "KIM, HOIL",
    "owner2": "GILLIGAN, ERIN M",
    "current_taxes": 20674.83,
    "new_taxes_no_override": 21567.98,
    "override_total_1": 22179.96,
    "override_increase_1": 611.97
  },
  {
    "#": "151 Fairway Rd (278B-04-00)",
    "$": 4718400,
    "address": "151 Fairway Rd",
    "parcel_id": "278B-04-00",
    "owner1": "BENE, GEORGE M",
    "owner2": "SIGNORELLI, FRANCESCA",
    "current_taxes": 44681.48,
    "new_taxes_no_override": 46611.72,
    "override_total_1": 47934.29,
    "override_increase_1": 1322.57
  },
  {
    "#": "160 Fairway Rd (278C-05-01)",
    "$": 2556500,
    "address": "160 Fairway Rd",
    "parcel_id": "278C-05-01",
    "owner1": "BOJOVIC, BRANKO",
    "owner2": "",
    "current_taxes": 22543.63,
    "new_taxes_no_override": 23517.51,
    "override_total_1": 24184.81,
    "override_increase_1": 667.29
  },
  {
    "#": "170 Fairway Rd (278C-05-00)",
    "$": 2342100,
    "address": "170 Fairway Rd",
    "parcel_id": "278C-05-00",
    "owner1": "FREDERICK TRS, JAMES L",
    "owner2": "KOUFMAN-FREDERICK, ANN",
    "current_taxes": 20348.17,
    "new_taxes_no_override": 21227.21,
    "override_total_1": 21829.52,
    "override_increase_1": 602.31
  },
  {
    "#": "176 Fairway Rd (278C-04-00)",
    "$": 2131200,
    "address": "176 Fairway Rd",
    "parcel_id": "278C-04-00",
    "owner1": "FERRARA, LIVIO",
    "owner2": "PAPPAS, DEMETRA",
    "current_taxes": 21823.49,
    "new_taxes_no_override": 22766.26,
    "override_total_1": 23412.24,
    "override_increase_1": 645.98
  },
  {
    "#": "180 Fairway Rd (278C-30-00)",
    "$": 2443500,
    "address": "180 Fairway Rd",
    "parcel_id": "278C-30-00",
    "owner1": "CHANDER, SUNEER & SEJAL P",
    "owner2": "",
    "current_taxes": 25021.44,
    "new_taxes_no_override": 26102.37,
    "override_total_1": 26843.0,
    "override_increase_1": 740.63
  },
  {
    "#": "192 Fairway Rd (278C-29-01)",
    "$": 2701200,
    "address": "192 Fairway Rd",
    "parcel_id": "278C-29-01",
    "owner1": "BLEIER, SCOTT R",
    "owner2": "NEOGI, TUHINA",
    "current_taxes": 24025.35,
    "new_taxes_no_override": 25063.25,
    "override_total_1": 25774.4,
    "override_increase_1": 711.15
  },
  {
    "#": "8 Feneno Ter (071-30-00)",
    "$": 11600,
    "address": "8 Feneno Ter",
    "parcel_id": "071-30-00",
    "owner1": "YUI HING CHAN FAMILY LLC",
    "owner2": "",
    "current_taxes": 118.78,
    "new_taxes_no_override": 123.91,
    "override_total_1": 127.43,
    "override_increase_1": 3.52
  },
  {
    "#": "10 Feneno Ter, Unit 10 (071-29-01)",
    "$": 1823800,
    "address": "10 Feneno Ter, Unit 10",
    "parcel_id": "071-29-01",
    "owner1": "EAVES, PIA LINA",
    "owner2": "",
    "current_taxes": 18675.71,
    "new_taxes_no_override": 19482.5,
    "override_total_1": 20035.3,
    "override_increase_1": 552.8
  },
  {
    "#": "10 Feneno Ter, Unit 12 (071-29-02)",
    "$": 1584800,
    "address": "10 Feneno Ter, Unit 12",
    "parcel_id": "071-29-02",
    "owner1": "NASH, ISHAN & JULIA BROWNELL",
    "owner2": "",
    "current_taxes": 16228.35,
    "new_taxes_no_override": 16929.41,
    "override_total_1": 17409.77,
    "override_increase_1": 480.36
  },
  {
    "#": "11 Feneno Ter (071-27-00)",
    "$": 986800,
    "address": "11 Feneno Ter",
    "parcel_id": "071-27-00",
    "owner1": "MEI TRS, THERESA R & MILES W",
    "owner2": "HMM REALTY TRUST",
    "current_taxes": 10104.83,
    "new_taxes_no_override": 10541.36,
    "override_total_1": 10840.46,
    "override_increase_1": 299.1
  },
  {
    "#": "15 Feneno Ter (071-28-00)",
    "$": 2320600,
    "address": "15 Feneno Ter",
    "parcel_id": "071-28-00",
    "owner1": "BIRNBAUM, BENJAMIN & DIANE",
    "owner2": "",
    "current_taxes": 20128.01,
    "new_taxes_no_override": 20997.54,
    "override_total_1": 21593.33,
    "override_increase_1": 595.79
  },
  {
    "#": "0 Fernwood Rd (439-80-00)",
    "$": 4058000,
    "address": "0 Fernwood Rd",
    "parcel_id": "439-80-00",
    "owner1": "SADR TRS, ALI",
    "owner2": "",
    "current_taxes": 41553.92,
    "new_taxes_no_override": 43349.05,
    "override_total_1": 44579.05,
    "override_increase_1": 1230.0
  },
  {
    "#": "6 Fernwood Rd (439-81-03)",
    "$": 6088400,
    "address": "6 Fernwood Rd",
    "parcel_id": "439-81-03",
    "owner1": "MITCHELL, JAMES H & NANCY B",
    "owner2": "",
    "current_taxes": 62345.22,
    "new_taxes_no_override": 65038.53,
    "override_total_1": 66883.95,
    "override_increase_1": 1845.42
  },
  {
    "#": "26 Fernwood Rd (439-81-02)",
    "$": 8482800,
    "address": "26 Fernwood Rd",
    "parcel_id": "439-81-02",
    "owner1": "JOHNSON, CHRISTOPHER & NEETI BHALLA",
    "owner2": "",
    "current_taxes": 86863.87,
    "new_taxes_no_override": 90616.39,
    "override_total_1": 93187.56,
    "override_increase_1": 2571.17
  },
  {
    "#": "28 Fernwood Rd (439-81-01)",
    "$": 10349900,
    "address": "28 Fernwood Rd",
    "parcel_id": "439-81-01",
    "owner1": "DINNEEN TR, JOHN",
    "owner2": "",
    "current_taxes": 105982.98,
    "new_taxes_no_override": 110561.44,
    "override_total_1": 113698.54,
    "override_increase_1": 3137.1
  },
  {
    "#": "50 Fernwood Rd (439-79-01)",
    "$": 4239400,
    "address": "50 Fernwood Rd",
    "parcel_id": "439-79-01",
    "owner1": "SADR TRS, ALI",
    "owner2": "",
    "current_taxes": 43411.46,
    "new_taxes_no_override": 45286.84,
    "override_total_1": 46571.81,
    "override_increase_1": 1284.98
  },
  {
    "#": "51 Fernwood Rd (439-47-00)",
    "$": 4411900,
    "address": "51 Fernwood Rd",
    "parcel_id": "439-47-00",
    "owner1": "BLOOSTEIN TR, MARC J",
    "owner2": "C/O ROPES & GRAY LLP",
    "current_taxes": 45177.86,
    "new_taxes_no_override": 47129.54,
    "override_total_1": 48466.81,
    "override_increase_1": 1337.26
  },
  {
    "#": "54 Fernwood Rd (439-78-00)",
    "$": 8700500,
    "address": "54 Fernwood Rd",
    "parcel_id": "439-78-00",
    "owner1": "MILES, MICHAEL A JR & KAREN HAWLEY",
    "owner2": "",
    "current_taxes": 85458.19,
    "new_taxes_no_override": 89149.98,
    "override_total_1": 91679.55,
    "override_increase_1": 2529.56
  },
  {
    "#": "60 Fernwood Rd (439-75-00)",
    "$": 7467200,
    "address": "60 Fernwood Rd",
    "parcel_id": "439-75-00",
    "owner1": "ODONNELL, THOMAS F III",
    "owner2": "WING-ODONNELL, CHRISTINA",
    "current_taxes": 72829.19,
    "new_taxes_no_override": 75975.41,
    "override_total_1": 78131.16,
    "override_increase_1": 2155.74
  },
  {
    "#": "66 Fernwood Rd (439-77-00)",
    "$": 6931800,
    "address": "66 Fernwood Rd",
    "parcel_id": "439-77-00",
    "owner1": "SCHERNECKER TRS, FRED & CAROLINE KEARNS",
    "owner2": "",
    "current_taxes": 70981.63,
    "new_taxes_no_override": 74048.04,
    "override_total_1": 76149.09,
    "override_increase_1": 2101.06
  },
  {
    "#": "74 Fernwood Rd (439-76-00)",
    "$": 5911600,
    "address": "74 Fernwood Rd",
    "parcel_id": "439-76-00",
    "owner1": "DALTON TRS, D GRAY",
    "owner2": "HAMMER TRS, STUART A",
    "current_taxes": 60534.78,
    "new_taxes_no_override": 63149.88,
    "override_total_1": 64941.71,
    "override_increase_1": 1791.83
  },
  {
    "#": "76 Fernwood Rd (439-85-86)",
    "$": 15433200,
    "address": "76 Fernwood Rd",
    "parcel_id": "439-85-86",
    "owner1": "DAVIS, JONATHAN G & MARGOT",
    "owner2": "",
    "current_taxes": 154401.03,
    "new_taxes_no_override": 161071.15,
    "override_total_1": 165641.42,
    "override_increase_1": 4570.27
  },
  {
    "#": "78 Fernwood Rd (439-74-00)",
    "$": 7644500,
    "address": "78 Fernwood Rd",
    "parcel_id": "439-74-00",
    "owner1": "HUNNEWELL TRS, OGDEN",
    "owner2": "MENOYO, ERIC F",
    "current_taxes": 74644.75,
    "new_taxes_no_override": 77869.4,
    "override_total_1": 80078.89,
    "override_increase_1": 2209.48
  },
  {
    "#": "80 Fernwood Rd (439-73-00)",
    "$": 6527700,
    "address": "80 Fernwood Rd",
    "parcel_id": "439-73-00",
    "owner1": "MATTINGLY, DAVID A",
    "owner2": "",
    "current_taxes": 63208.71,
    "new_taxes_no_override": 65939.33,
    "override_total_1": 67810.3,
    "override_increase_1": 1870.98
  },
  {
    "#": "82 Fernwood Rd (439-72-00)",
    "$": 6325200,
    "address": "82 Fernwood Rd",
    "parcel_id": "439-72-00",
    "owner1": "BASILICO, FREDERICK C",
    "owner2": "WALIGUNDA, JUDITH A",
    "current_taxes": 61135.11,
    "new_taxes_no_override": 63776.15,
    "override_total_1": 65585.75,
    "override_increase_1": 1809.6
  },
  {
    "#": "86 Fernwood Rd (439-55-00)",
    "$": 6645100,
    "address": "86 Fernwood Rd",
    "parcel_id": "439-55-00",
    "owner1": "BERGSTRAND TRS, MARGARET F",
    "owner2": "CONNOLLY, SARAH T",
    "current_taxes": 68045.82,
    "new_taxes_no_override": 70985.4,
    "override_total_1": 72999.56,
    "override_increase_1": 2014.16
  },
  {
    "#": "100 Fernwood Rd (439-54-00)",
    "$": 6471900,
    "address": "100 Fernwood Rd",
    "parcel_id": "439-54-00",
    "owner1": "VOGEL, RALPH B & DIANA G",
    "owner2": "",
    "current_taxes": 66272.26,
    "new_taxes_no_override": 69135.22,
    "override_total_1": 71096.88,
    "override_increase_1": 1961.66
  },
  {
    "#": "101 Fernwood Rd (439-49-00)",
    "$": 18128000,
    "address": "101 Fernwood Rd",
    "parcel_id": "439-49-00",
    "owner1": "ROTTENBERG TRS ET AL, DANIEL E",
    "owner2": "C/O GOULSTON & STORRS PC, REBECCA  MATEJEK",
    "current_taxes": 185630.72,
    "new_taxes_no_override": 193649.97,
    "override_total_1": 199144.64,
    "override_increase_1": 5494.67
  },
  {
    "#": "102 Fernwood Rd (439-53-00)",
    "$": 5727500,
    "address": "102 Fernwood Rd",
    "parcel_id": "439-53-00",
    "owner1": "GONZALEZ, MILAGROS",
    "owner2": "",
    "current_taxes": 58649.6,
    "new_taxes_no_override": 61183.26,
    "override_total_1": 62919.29,
    "override_increase_1": 1736.03
  },
  {
    "#": "104 Fernwood Rd (439-52-00)",
    "$": 6947900,
    "address": "104 Fernwood Rd",
    "parcel_id": "439-52-00",
    "owner1": "FRANKLIN, ADAM & ALANA",
    "owner2": "",
    "current_taxes": 71146.5,
    "new_taxes_no_override": 74220.03,
    "override_total_1": 76325.97,
    "override_increase_1": 2105.94
  },
  {
    "#": "106 Fernwood Rd (439-39-40)",
    "$": 18573000,
    "address": "106 Fernwood Rd",
    "parcel_id": "439-39-40",
    "owner1": "MARKLEY TRS, JEFFREY D",
    "owner2": "RAMESON, DEVON M",
    "current_taxes": 190187.52,
    "new_taxes_no_override": 198403.62,
    "override_total_1": 204033.17,
    "override_increase_1": 5629.55
  },
  {
    "#": "4 Fisher Ave (255-02-00)",
    "$": 3505500,
    "address": "4 Fisher Ave",
    "parcel_id": "255-02-00",
    "owner1": "DANDAGE, RAJ S",
    "owner2": "NADKARNI, ASHWINI",
    "current_taxes": 32261.39,
    "new_taxes_no_override": 33655.08,
    "override_total_1": 34610.02,
    "override_increase_1": 954.94
  },
  {
    "#": "7 Fisher Ave (254-07-00)",
    "$": 552600,
    "address": "7 Fisher Ave",
    "parcel_id": "254-07-00",
    "owner1": "KEOUGH TR, JOHN M",
    "owner2": "",
    "current_taxes": 5658.62,
    "new_taxes_no_override": 5903.07,
    "override_total_1": 6070.57,
    "override_increase_1": 167.5
  },
  {
    "#": "18 Fisher Ave (255-01-02)",
    "$": 4849800,
    "address": "18 Fisher Ave",
    "parcel_id": "255-01-02",
    "owner1": "LUU, GEORGE V H",
    "owner2": "GEORGALI, CHRYSI SPYRIDOULA",
    "current_taxes": 49661.95,
    "new_taxes_no_override": 51807.35,
    "override_total_1": 53277.34,
    "override_increase_1": 1469.99
  },
  {
    "#": "25 Fisher Ave (254-08-00)",
    "$": 5048400,
    "address": "25 Fisher Ave",
    "parcel_id": "254-08-00",
    "owner1": "KEOUGH, JOHN M",
    "owner2": "DOW, ANDREA",
    "current_taxes": 48060.68,
    "new_taxes_no_override": 50136.9,
    "override_total_1": 51559.5,
    "override_increase_1": 1422.6
  },
  {
    "#": "29 Fisher Ave (254-08-04)",
    "$": 57900,
    "address": "29 Fisher Ave",
    "parcel_id": "254-08-04",
    "owner1": "LEE TRS, BARBARA C",
    "owner2": "BASS, MICHAEL A",
    "current_taxes": 592.9,
    "new_taxes_no_override": 618.51,
    "override_total_1": 636.06,
    "override_increase_1": 17.55
  },
  {
    "#": "31 Fisher Ave (254-08-05)",
    "$": 56500,
    "address": "31 Fisher Ave",
    "parcel_id": "254-08-05",
    "owner1": "KEOUGH, JOHN M & ANDREA D",
    "owner2": "",
    "current_taxes": 578.56,
    "new_taxes_no_override": 603.55,
    "override_total_1": 620.68,
    "override_increase_1": 17.13
  },
  {
    "#": "34 Fisher Ave (254-08-03)",
    "$": 50300,
    "address": "34 Fisher Ave",
    "parcel_id": "254-08-03",
    "owner1": "LEE TRS, BARBARA C",
    "owner2": "BASS, MICHAEL A",
    "current_taxes": 515.07,
    "new_taxes_no_override": 537.32,
    "override_total_1": 552.57,
    "override_increase_1": 15.25
  },
  {
    "#": "35 Fisher Ave (254-09-00)",
    "$": 8857900,
    "address": "35 Fisher Ave",
    "parcel_id": "254-09-00",
    "owner1": "LEE TRS, BARBARA C",
    "owner2": "BASS, MICHAEL A",
    "current_taxes": 90704.9,
    "new_taxes_no_override": 94623.35,
    "override_total_1": 97308.22,
    "override_increase_1": 2684.87
  },
  {
    "#": "42 Fisher Ave (256-03-00)",
    "$": 6918500,
    "address": "42 Fisher Ave",
    "parcel_id": "256-03-00",
    "owner1": "SWARTZ, JULIE",
    "owner2": "",
    "current_taxes": 67210.51,
    "new_taxes_no_override": 70114.0,
    "override_total_1": 72103.44,
    "override_increase_1": 1989.43
  },
  {
    "#": "50 Fisher Ave (256-02-00)",
    "$": 4501900,
    "address": "50 Fisher Ave",
    "parcel_id": "256-02-00",
    "owner1": "EDGE, ALBERT",
    "owner2": "KASSENAAR, ANNE",
    "current_taxes": 42464.52,
    "new_taxes_no_override": 44298.99,
    "override_total_1": 45555.94,
    "override_increase_1": 1256.95
  },
  {
    "#": "71 Fisher Ave (250-12-03)",
    "$": 2314500,
    "address": "71 Fisher Ave",
    "parcel_id": "250-12-03",
    "owner1": "ROSENZWEIG , STANLEY",
    "owner2": "UNION, LAURI",
    "current_taxes": 23700.48,
    "new_taxes_no_override": 24724.34,
    "override_total_1": 25425.87,
    "override_increase_1": 701.53
  },
  {
    "#": "73 Fisher Ave (250-12-04)",
    "$": 2465300,
    "address": "73 Fisher Ave",
    "parcel_id": "250-12-04",
    "owner1": "ROSENZWEIG, STANLEY",
    "owner2": "UNION, LAURI",
    "current_taxes": 25244.67,
    "new_taxes_no_override": 26335.24,
    "override_total_1": 27082.48,
    "override_increase_1": 747.24
  },
  {
    "#": "93 Fisher Ave (250-13-02)",
    "$": 5443500,
    "address": "93 Fisher Ave",
    "parcel_id": "250-13-02",
    "owner1": "FEUERMAN TRS, RENE J & JEFFREY M",
    "owner2": "",
    "current_taxes": 52106.51,
    "new_taxes_no_override": 54357.51,
    "override_total_1": 55899.86,
    "override_increase_1": 1542.35
  },
  {
    "#": "99 Fisher Ave (250-13-01)",
    "$": 5436200,
    "address": "99 Fisher Ave",
    "parcel_id": "250-13-01",
    "owner1": "GODHWANI, SANJAY & VALERIE A",
    "owner2": "",
    "current_taxes": 52031.75,
    "new_taxes_no_override": 54279.52,
    "override_total_1": 55819.66,
    "override_increase_1": 1540.14
  },
  {
    "#": "100 Fisher Ave (256-01-00)",
    "$": 17384600,
    "address": "100 Fisher Ave",
    "parcel_id": "256-01-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O BOARD OF SELECTMEN",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "110 Fisher Ave (256-01-01)",
    "$": 2800900,
    "address": "110 Fisher Ave",
    "parcel_id": "256-01-01",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O TREASURERS OFFICE",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "123 Fisher Ave (250-01-05)",
    "$": 77169500,
    "address": "123 Fisher Ave",
    "parcel_id": "250-01-05",
    "owner1": "WELL BALFOUR BROOKLINE LANDLORD LLC",
    "owner2": "C/O PROPERTY VALUATION SERVICES",
    "current_taxes": 790215.68,
    "new_taxes_no_override": 824353.0,
    "override_total_1": 847743.38,
    "override_increase_1": 23390.38
  },
  {
    "#": "124 Fisher Ave (256-24-00)",
    "$": 2987900,
    "address": "124 Fisher Ave",
    "parcel_id": "256-24-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O TREASURERS OFFICE",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "150 Fisher Ave (256-21-23)",
    "$": 10660300,
    "address": "150 Fisher Ave",
    "parcel_id": "256-21-23",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O TREASURERS OFFICE",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "166 Fisher Ave (256-22-00)",
    "$": 6891700,
    "address": "166 Fisher Ave",
    "parcel_id": "256-22-00",
    "owner1": "GRUBBS, WILLIAM J",
    "owner2": "BERGSTROM, RICHARD H",
    "current_taxes": 66936.07,
    "new_taxes_no_override": 69827.71,
    "override_total_1": 71809.02,
    "override_increase_1": 1981.31
  },
  {
    "#": "169 Fisher Ave (249-01-00)",
    "$": 4289100,
    "address": "169 Fisher Ave",
    "parcel_id": "249-01-00",
    "owner1": "TYLER TR, JOYCE S",
    "owner2": "",
    "current_taxes": 40285.45,
    "new_taxes_no_override": 42025.78,
    "override_total_1": 43218.23,
    "override_increase_1": 1192.45
  },
  {
    "#": "184 Fisher Ave (257-01-00)",
    "$": 6324600,
    "address": "184 Fisher Ave",
    "parcel_id": "257-01-00",
    "owner1": "POSNER, ROBERT A",
    "owner2": "",
    "current_taxes": 64763.9,
    "new_taxes_no_override": 67561.7,
    "override_total_1": 69478.71,
    "override_increase_1": 1917.01
  },
  {
    "#": "195 Fisher Ave (244-01-00)",
    "$": 5089400,
    "address": "195 Fisher Ave",
    "parcel_id": "244-01-00",
    "owner1": "GUSS, YANA DOBKIN & DANIEL & SALOMON & CHAJUTA",
    "owner2": "",
    "current_taxes": 48480.52,
    "new_taxes_no_override": 50574.88,
    "override_total_1": 52009.9,
    "override_increase_1": 1435.02
  },
  {
    "#": "200 Fisher Ave (257-12-00)",
    "$": 5413500,
    "address": "200 Fisher Ave",
    "parcel_id": "257-12-00",
    "owner1": "SHEENA, DAVID & MARLENE",
    "owner2": "",
    "current_taxes": 55434.24,
    "new_taxes_no_override": 57829.0,
    "override_total_1": 59469.85,
    "override_increase_1": 1640.85
  },
  {
    "#": "207 Fisher Ave (243-14-00)",
    "$": 5602500,
    "address": "207 Fisher Ave",
    "parcel_id": "243-14-00",
    "owner1": "SUMMERS, LAWRENCE H",
    "owner2": "NEW, ELISA",
    "current_taxes": 57369.6,
    "new_taxes_no_override": 59847.97,
    "override_total_1": 61546.11,
    "override_increase_1": 1698.14
  },
  {
    "#": "219 Fisher Ave (243-01-00)",
    "$": 5339900,
    "address": "219 Fisher Ave",
    "parcel_id": "243-01-00",
    "owner1": "BRAVERMAN, DANIEL A",
    "owner2": "POLJAK, INA",
    "current_taxes": 54680.58,
    "new_taxes_no_override": 57042.78,
    "override_total_1": 58661.33,
    "override_increase_1": 1618.55
  },
  {
    "#": "233 Fisher Ave (240-12-00)",
    "$": 5032000,
    "address": "233 Fisher Ave",
    "parcel_id": "240-12-00",
    "owner1": "MAST, ROBERT E",
    "owner2": "CARLISLE, LINDA K",
    "current_taxes": 47892.75,
    "new_taxes_no_override": 49961.72,
    "override_total_1": 51379.34,
    "override_increase_1": 1417.63
  },
  {
    "#": "234 Fisher Ave (241-01-00)",
    "$": 5431900,
    "address": "234 Fisher Ave",
    "parcel_id": "241-01-00",
    "owner1": "KOZHEMIAKIN, ALEXANDER V & JENNIFER",
    "owner2": "",
    "current_taxes": 51987.72,
    "new_taxes_no_override": 54233.59,
    "override_total_1": 55772.43,
    "override_increase_1": 1538.84
  },
  {
    "#": "239 Fisher Ave (240-13-00)",
    "$": 422900,
    "address": "239 Fisher Ave",
    "parcel_id": "240-13-00",
    "owner1": "MAST, ROBERT E",
    "owner2": "CARLISLE, LINDA K",
    "current_taxes": 4330.5,
    "new_taxes_no_override": 4517.58,
    "override_total_1": 4645.76,
    "override_increase_1": 128.18
  },
  {
    "#": "244 Fisher Ave (241-13-00)",
    "$": 2761700,
    "address": "244 Fisher Ave",
    "parcel_id": "241-13-00",
    "owner1": "OSTRANDER, TRS, HARRY M & FRANCES L",
    "owner2": "",
    "current_taxes": 24644.87,
    "new_taxes_no_override": 25709.53,
    "override_total_1": 26439.02,
    "override_increase_1": 729.49
  },
  {
    "#": "246 Fisher Ave (241-12-00)",
    "$": 1517400,
    "address": "246 Fisher Ave",
    "parcel_id": "241-12-00",
    "owner1": "OSTRANDER, TRS, HARRY M & FRANCES L",
    "owner2": "",
    "current_taxes": 15538.18,
    "new_taxes_no_override": 16209.43,
    "override_total_1": 16669.36,
    "override_increase_1": 459.93
  },
  {
    "#": "247 Fisher Ave (240-14-00)",
    "$": 2985400,
    "address": "247 Fisher Ave",
    "parcel_id": "240-14-00",
    "owner1": "TKMM LLC",
    "owner2": "",
    "current_taxes": 26935.56,
    "new_taxes_no_override": 28099.18,
    "override_total_1": 28896.47,
    "override_increase_1": 797.29
  },
  {
    "#": "255 Fisher Ave (240-01-00)",
    "$": 4194000,
    "address": "255 Fisher Ave",
    "parcel_id": "240-01-00",
    "owner1": "BITRAN TRS, DEVORAH I & MARCO",
    "owner2": "",
    "current_taxes": 39311.63,
    "new_taxes_no_override": 41009.89,
    "override_total_1": 42173.52,
    "override_increase_1": 1163.62
  },
  {
    "#": "260 Fisher Ave (241-11-00)",
    "$": 2967700,
    "address": "260 Fisher Ave",
    "parcel_id": "241-11-00",
    "owner1": "AHMED, A RAZZAQUE",
    "owner2": "",
    "current_taxes": 26754.31,
    "new_taxes_no_override": 27910.1,
    "override_total_1": 28702.02,
    "override_increase_1": 791.93
  },
  {
    "#": "266 Fisher Ave (241-10-00)",
    "$": 3918400,
    "address": "266 Fisher Ave",
    "parcel_id": "241-10-00",
    "owner1": "ANDERSON TR, DAYNA L",
    "owner2": "",
    "current_taxes": 36489.48,
    "new_taxes_no_override": 38065.83,
    "override_total_1": 39145.91,
    "override_increase_1": 1080.09
  },
  {
    "#": " Fisher Ave (254-08-02)",
    "$": 120100,
    "address": " Fisher Ave",
    "parcel_id": "254-08-02",
    "owner1": "LEE TRS, BARBARA C",
    "owner2": "BASS, MICHAEL A",
    "current_taxes": 1229.82,
    "new_taxes_no_override": 1282.95,
    "override_total_1": 1319.35,
    "override_increase_1": 36.4
  },
  {
    "#": "2 Fiske Ter (071-35-37)",
    "$": 73400,
    "address": "2 Fiske Ter",
    "parcel_id": "071-35-37",
    "owner1": "10-18 BRAINERD ROAD LLC",
    "owner2": "C/O THE MOUNT VERNON CO",
    "current_taxes": 751.62,
    "new_taxes_no_override": 784.09,
    "override_total_1": 806.34,
    "override_increase_1": 22.25
  },
  {
    "#": "7 Fiske Ter (071-34-00)",
    "$": 2095600,
    "address": "7 Fiske Ter",
    "parcel_id": "071-34-00",
    "owner1": "TROYANOVSKY, ROMAN M & ALLA",
    "owner2": "",
    "current_taxes": 17824.01,
    "new_taxes_no_override": 18594.01,
    "override_total_1": 19121.6,
    "override_increase_1": 527.59
  },
  {
    "#": "181 Florence St (423-04-02)",
    "$": 260800,
    "address": "181 Florence St",
    "parcel_id": "423-04-02",
    "owner1": "CHIN TRS, STEVEN",
    "owner2": "WHITNEY, GREIG H & DEBORAH M",
    "current_taxes": 2670.59,
    "new_taxes_no_override": 2785.96,
    "override_total_1": 2865.01,
    "override_increase_1": 79.05
  },
  {
    "#": "1 Forest St (345-16-00)",
    "$": 1161000,
    "address": "1 Forest St",
    "parcel_id": "345-16-00",
    "owner1": "HODGKIN TR, DOMINIC",
    "owner2": "GOLD TR, DIANE",
    "current_taxes": 8253.71,
    "new_taxes_no_override": 8610.27,
    "override_total_1": 8854.58,
    "override_increase_1": 244.31
  },
  {
    "#": "8 Forest St (341-11-00)",
    "$": 1565400,
    "address": "8 Forest St",
    "parcel_id": "341-11-00",
    "owner1": "CHARBIT, MICHELE F",
    "owner2": "",
    "current_taxes": 12394.76,
    "new_taxes_no_override": 12930.21,
    "override_total_1": 13297.1,
    "override_increase_1": 366.88
  },
  {
    "#": "11 Forest St (345-17-00)",
    "$": 997900,
    "address": "11 Forest St",
    "parcel_id": "345-17-00",
    "owner1": "HOLLEY TR, CHRISTINE",
    "owner2": "",
    "current_taxes": 6583.56,
    "new_taxes_no_override": 6867.97,
    "override_total_1": 7062.84,
    "override_increase_1": 194.87
  },
  {
    "#": "12 Forest St (341-09-10)",
    "$": 1093700,
    "address": "12 Forest St",
    "parcel_id": "341-09-10",
    "owner1": "GHAFARI-ADLI, RAMIN",
    "owner2": "",
    "current_taxes": 7564.55,
    "new_taxes_no_override": 7891.34,
    "override_total_1": 8115.25,
    "override_increase_1": 223.91
  },
  {
    "#": "13 Forest St (345-18-00)",
    "$": 56100,
    "address": "13 Forest St",
    "parcel_id": "345-18-00",
    "owner1": "LERNER, VLADISLAV",
    "owner2": "LOSINA, ELENA",
    "current_taxes": 574.46,
    "new_taxes_no_override": 599.28,
    "override_total_1": 616.28,
    "override_increase_1": 17.0
  },
  {
    "#": "14 Forest St (341-08-00)",
    "$": 651300,
    "address": "14 Forest St",
    "parcel_id": "341-08-00",
    "owner1": "DIL, MAGHANI AHAD",
    "owner2": "",
    "current_taxes": 6669.31,
    "new_taxes_no_override": 6957.42,
    "override_total_1": 7154.84,
    "override_increase_1": 197.41
  },
  {
    "#": "19 Forest St (345-19-00)",
    "$": 2356000,
    "address": "19 Forest St",
    "parcel_id": "345-19-00",
    "owner1": "LERNER, VLADISLAV",
    "owner2": "LOSINA, ELENA",
    "current_taxes": 20490.51,
    "new_taxes_no_override": 21375.7,
    "override_total_1": 21982.22,
    "override_increase_1": 606.52
  },
  {
    "#": "21 Forest St (345-20-00)",
    "$": 1242100,
    "address": "21 Forest St",
    "parcel_id": "345-20-00",
    "owner1": "RITS TR, EHIEL",
    "owner2": "",
    "current_taxes": 12719.1,
    "new_taxes_no_override": 13268.57,
    "override_total_1": 13645.05,
    "override_increase_1": 376.49
  },
  {
    "#": "25 Forest St (345-21-00)",
    "$": 1540600,
    "address": "25 Forest St",
    "parcel_id": "345-21-00",
    "owner1": "STAVROPOULOS TR, PETER S",
    "owner2": "",
    "current_taxes": 15775.74,
    "new_taxes_no_override": 16457.25,
    "override_total_1": 16924.21,
    "override_increase_1": 466.96
  },
  {
    "#": "26 Forest St (341-06-07)",
    "$": 1304500,
    "address": "26 Forest St",
    "parcel_id": "341-06-07",
    "owner1": "DILMAGHANI, AHAD",
    "owner2": "",
    "current_taxes": 13358.08,
    "new_taxes_no_override": 13935.15,
    "override_total_1": 14330.55,
    "override_increase_1": 395.4
  },
  {
    "#": "32 Forest St (341-04-00)",
    "$": 1250900,
    "address": "32 Forest St",
    "parcel_id": "341-04-00",
    "owner1": "MIKHAYLOV, VLADIMIR V & NADEZHDA A",
    "owner2": "",
    "current_taxes": 9174.28,
    "new_taxes_no_override": 9570.61,
    "override_total_1": 9842.17,
    "override_increase_1": 271.56
  },
  {
    "#": "33 Forest St (345-22-23)",
    "$": 1278000,
    "address": "33 Forest St",
    "parcel_id": "345-22-23",
    "owner1": "GUERRA, JOSE A",
    "owner2": "MAZIARKA, ELIZABETH M",
    "current_taxes": 9451.79,
    "new_taxes_no_override": 9860.11,
    "override_total_1": 10139.88,
    "override_increase_1": 279.77
  },
  {
    "#": "39 Forest St (345-24-25)",
    "$": 1139100,
    "address": "39 Forest St",
    "parcel_id": "345-24-25",
    "owner1": "CHAN, DAVID W & JENNY K",
    "owner2": "",
    "current_taxes": 8029.45,
    "new_taxes_no_override": 8376.32,
    "override_total_1": 8613.99,
    "override_increase_1": 237.67
  },
  {
    "#": "47 Forest St (345-26-00)",
    "$": 1080200,
    "address": "47 Forest St",
    "parcel_id": "345-26-00",
    "owner1": "WUNG TRS, TEH C HIN & TENG TZE",
    "owner2": "",
    "current_taxes": 7426.31,
    "new_taxes_no_override": 7747.13,
    "override_total_1": 7966.95,
    "override_increase_1": 219.82
  },
  {
    "#": "53 Forest St (345-27-28)",
    "$": 1051700,
    "address": "53 Forest St",
    "parcel_id": "345-27-28",
    "owner1": "CEDARGREN, MARIA",
    "owner2": "",
    "current_taxes": 7134.47,
    "new_taxes_no_override": 7442.68,
    "override_total_1": 7653.86,
    "override_increase_1": 211.18
  },
  {
    "#": "54 Forest St (346-06-00)",
    "$": 1063100,
    "address": "54 Forest St",
    "parcel_id": "346-06-00",
    "owner1": "HANDLEY ET AL, AMY & WILLIAM",
    "owner2": "TOBIN , LINDA",
    "current_taxes": 7251.21,
    "new_taxes_no_override": 7564.46,
    "override_total_1": 7779.1,
    "override_increase_1": 214.64
  },
  {
    "#": "60 Forest St (346-04-05)",
    "$": 1332600,
    "address": "60 Forest St",
    "parcel_id": "346-04-05",
    "owner1": "RUDNICK, SHERRI ANN & BENJAMIN",
    "owner2": "",
    "current_taxes": 13645.82,
    "new_taxes_no_override": 14235.32,
    "override_total_1": 14639.24,
    "override_increase_1": 403.92
  },
  {
    "#": "63 Forest St (345-30-00)",
    "$": 1736500,
    "address": "63 Forest St",
    "parcel_id": "345-30-00",
    "owner1": "PHAN TR, LIEN T",
    "owner2": "",
    "current_taxes": 14146.83,
    "new_taxes_no_override": 14757.97,
    "override_total_1": 15176.72,
    "override_increase_1": 418.75
  },
  {
    "#": "64 Forest St (346-02-03)",
    "$": 1488700,
    "address": "64 Forest St",
    "parcel_id": "346-02-03",
    "owner1": "AZZI, JAMIL",
    "owner2": "EL AKIKI, GHANIA",
    "current_taxes": 11609.35,
    "new_taxes_no_override": 12110.87,
    "override_total_1": 12454.51,
    "override_increase_1": 343.64
  },
  {
    "#": "65 Forest St (345-30-01)",
    "$": 1688900,
    "address": "65 Forest St",
    "parcel_id": "345-30-01",
    "owner1": "WANG, XIAOBIN",
    "owner2": "XU, BENJAMIN PING",
    "current_taxes": 13659.4,
    "new_taxes_no_override": 14249.49,
    "override_total_1": 14653.8,
    "override_increase_1": 404.32
  },
  {
    "#": "66 Forest St (346-01-01)",
    "$": 1418200,
    "address": "66 Forest St",
    "parcel_id": "346-01-01",
    "owner1": "SHULMAN, ROBERT S & SHERRY R",
    "owner2": "",
    "current_taxes": 10887.43,
    "new_taxes_no_override": 11357.77,
    "override_total_1": 11680.03,
    "override_increase_1": 322.27
  },
  {
    "#": "68 Forest St (346-01-00)",
    "$": 1318500,
    "address": "68 Forest St",
    "parcel_id": "346-01-00",
    "owner1": "MAITRE TR, HELLA",
    "owner2": "",
    "current_taxes": 9866.51,
    "new_taxes_no_override": 10292.74,
    "override_total_1": 10584.79,
    "override_increase_1": 292.05
  },
  {
    "#": "2 Francis St (129-14-00)",
    "$": 1454200,
    "address": "2 Francis St",
    "parcel_id": "129-14-00",
    "owner1": "TINA BELLE LLC",
    "owner2": "",
    "current_taxes": 14891.01,
    "new_taxes_no_override": 15534.3,
    "override_total_1": 15975.08,
    "override_increase_1": 440.77
  },
  {
    "#": "8 Francis St (129-13-00)",
    "$": 1633100,
    "address": "8 Francis St",
    "parcel_id": "129-13-00",
    "owner1": "WU, TR, CHAO-TING",
    "owner2": "C/O CHURCH, GEORGE",
    "current_taxes": 16722.94,
    "new_taxes_no_override": 17445.37,
    "override_total_1": 17940.37,
    "override_increase_1": 495.0
  },
  {
    "#": "9 Francis St (126-07-00)",
    "$": 3067300,
    "address": "9 Francis St",
    "parcel_id": "126-07-00",
    "owner1": "CHONG DE PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 31409.15,
    "new_taxes_no_override": 32766.03,
    "override_total_1": 33695.74,
    "override_increase_1": 929.71
  },
  {
    "#": "10 Francis St (129-12-00)",
    "$": 1637500,
    "address": "10 Francis St",
    "parcel_id": "129-12-00",
    "owner1": "ZHOU, JIANHUA",
    "owner2": "SHAO, ZHAOHUI",
    "current_taxes": 13133.07,
    "new_taxes_no_override": 13700.42,
    "override_total_1": 14089.16,
    "override_increase_1": 388.74
  },
  {
    "#": "15 Francis St, Unit 11 & G2 (126-08-31)",
    "$": 694600,
    "address": "15 Francis St, Unit 11 & G2",
    "parcel_id": "126-08-31",
    "owner1": "COHEN, JONATHAN B&DONNA GORSHEL",
    "owner2": "",
    "current_taxes": 3477.77,
    "new_taxes_no_override": 3628.01,
    "override_total_1": 3730.95,
    "override_increase_1": 102.94
  },
  {
    "#": "15 Francis St, Unit 12 & P19 (126-08-01)",
    "$": 469100,
    "address": "15 Francis St, Unit 12 & P19",
    "parcel_id": "126-08-01",
    "owner1": "JOHNSON, DIANA C",
    "owner2": "",
    "current_taxes": 4803.58,
    "new_taxes_no_override": 5011.09,
    "override_total_1": 5153.28,
    "override_increase_1": 142.19
  },
  {
    "#": "15 Francis St, Unit 12A (126-08-02)",
    "$": 391500,
    "address": "15 Francis St, Unit 12A",
    "parcel_id": "126-08-02",
    "owner1": "HOUTCHENS, MARIA K",
    "owner2": "",
    "current_taxes": 4008.96,
    "new_taxes_no_override": 4182.15,
    "override_total_1": 4300.81,
    "override_increase_1": 118.67
  },
  {
    "#": "15 Francis St, Unit 14 & P18 (126-08-03)",
    "$": 664500,
    "address": "15 Francis St, Unit 14 & P18",
    "parcel_id": "126-08-03",
    "owner1": "LOGIN TRS, GARY R & MINDA A",
    "owner2": "",
    "current_taxes": 6804.48,
    "new_taxes_no_override": 7098.43,
    "override_total_1": 7299.85,
    "override_increase_1": 201.41
  },
  {
    "#": "15 Francis St, Unit 15 & G13 (126-08-04)",
    "$": 701700,
    "address": "15 Francis St, Unit 15 & G13",
    "parcel_id": "126-08-04",
    "owner1": "SUN, LIFANG",
    "owner2": "",
    "current_taxes": 3550.47,
    "new_taxes_no_override": 3703.85,
    "override_total_1": 3808.94,
    "override_increase_1": 105.09
  },
  {
    "#": "15 Francis St, Unit 16 & P15 (126-08-05)",
    "$": 575000,
    "address": "15 Francis St, Unit 16 & P15",
    "parcel_id": "126-08-05",
    "owner1": "KRUSE, LINDA",
    "owner2": "",
    "current_taxes": 2253.07,
    "new_taxes_no_override": 2350.4,
    "override_total_1": 2417.09,
    "override_increase_1": 66.69
  },
  {
    "#": "15 Francis St, Unit 18 & G9 (126-08-06)",
    "$": 697900,
    "address": "15 Francis St, Unit 18 & G9",
    "parcel_id": "126-08-06",
    "owner1": "XU, HAOXING",
    "owner2": "ZHANG, YING",
    "current_taxes": 7146.5,
    "new_taxes_no_override": 7455.23,
    "override_total_1": 7666.77,
    "override_increase_1": 211.54
  },
  {
    "#": "15 Francis St, Unit 21 G12-12A (126-08-07)",
    "$": 758000,
    "address": "15 Francis St, Unit 21 G12-12A",
    "parcel_id": "126-08-07",
    "owner1": "HUANG TRS, FU MEI",
    "owner2": "",
    "current_taxes": 7761.92,
    "new_taxes_no_override": 8097.23,
    "override_total_1": 8326.99,
    "override_increase_1": 229.75
  },
  {
    "#": "15 Francis St, Unit 22 & P16 (126-08-08)",
    "$": 471800,
    "address": "15 Francis St, Unit 22 & P16",
    "parcel_id": "126-08-08",
    "owner1": "CHETEOUI TRS, BARBARA J & JOSEPH S",
    "owner2": "",
    "current_taxes": 4831.23,
    "new_taxes_no_override": 5039.94,
    "override_total_1": 5182.94,
    "override_increase_1": 143.0
  },
  {
    "#": "15 Francis St, Unit 23 (126-08-09)",
    "$": 557700,
    "address": "15 Francis St, Unit 23",
    "parcel_id": "126-08-09",
    "owner1": "LEGRADI, SZILVIA & GABOR",
    "owner2": "",
    "current_taxes": 5710.85,
    "new_taxes_no_override": 5957.56,
    "override_total_1": 6126.6,
    "override_increase_1": 169.04
  },
  {
    "#": "15 Francis St, Unit 24 & G7 (126-08-10)",
    "$": 694100,
    "address": "15 Francis St, Unit 24 & G7",
    "parcel_id": "126-08-10",
    "owner1": "GROSS, CINDY-JO",
    "owner2": "",
    "current_taxes": 3472.65,
    "new_taxes_no_override": 3622.67,
    "override_total_1": 3725.46,
    "override_increase_1": 102.79
  },
  {
    "#": "15 Francis St, Unit 25 & G11 (126-08-11)",
    "$": 692200,
    "address": "15 Francis St, Unit 25 & G11",
    "parcel_id": "126-08-11",
    "owner1": "TAVARES TRS, MARIO A & CELIA L",
    "owner2": "",
    "current_taxes": 7088.13,
    "new_taxes_no_override": 7394.34,
    "override_total_1": 7604.15,
    "override_increase_1": 209.81
  },
  {
    "#": "15 Francis St, Unit 26 (126-08-12)",
    "$": 557000,
    "address": "15 Francis St, Unit 26",
    "parcel_id": "126-08-12",
    "owner1": "ODONNELL, CLAIRE",
    "owner2": "",
    "current_taxes": 2068.75,
    "new_taxes_no_override": 2158.12,
    "override_total_1": 2219.36,
    "override_increase_1": 61.24
  },
  {
    "#": "15 Francis St, Unit 27 (126-08-13)",
    "$": 397100,
    "address": "15 Francis St, Unit 27",
    "parcel_id": "126-08-13",
    "owner1": "WANG TR, YUWEN",
    "owner2": "",
    "current_taxes": 4066.3,
    "new_taxes_no_override": 4241.96,
    "override_total_1": 4362.33,
    "override_increase_1": 120.36
  },
  {
    "#": "15 Francis St, Unit 28 & G10 (126-08-14)",
    "$": 697900,
    "address": "15 Francis St, Unit 28 & G10",
    "parcel_id": "126-08-14",
    "owner1": "LYNCH, MAUREEN M",
    "owner2": "",
    "current_taxes": 7146.5,
    "new_taxes_no_override": 7455.23,
    "override_total_1": 7666.77,
    "override_increase_1": 211.54
  },
  {
    "#": "15 Francis St, Unit 31 & G5 (126-08-15)",
    "$": 700700,
    "address": "15 Francis St, Unit 31 & G5",
    "parcel_id": "126-08-15",
    "owner1": "MCGUIRE, ABIGAIL MANSON",
    "owner2": "",
    "current_taxes": 3540.23,
    "new_taxes_no_override": 3693.17,
    "override_total_1": 3797.96,
    "override_increase_1": 104.79
  },
  {
    "#": "15 Francis St, Unit 32 (126-08-16)",
    "$": 396900,
    "address": "15 Francis St, Unit 32",
    "parcel_id": "126-08-16",
    "owner1": "WEBLER, ELIZABETH & STEVEN C",
    "owner2": "HUNTLEY, MARTHA E",
    "current_taxes": 4064.26,
    "new_taxes_no_override": 4239.84,
    "override_total_1": 4360.14,
    "override_increase_1": 120.3
  },
  {
    "#": "15 Francis St, Unit 33 & G10A (126-08-17)",
    "$": 617400,
    "address": "15 Francis St, Unit 33 & G10A",
    "parcel_id": "126-08-17",
    "owner1": "JIN, FENGHUA",
    "owner2": "QIN, LEI",
    "current_taxes": 6322.18,
    "new_taxes_no_override": 6595.3,
    "override_total_1": 6782.43,
    "override_increase_1": 187.14
  },
  {
    "#": "15 Francis St, Unit 34 & P21 (126-08-18)",
    "$": 688300,
    "address": "15 Francis St, Unit 34 & P21",
    "parcel_id": "126-08-18",
    "owner1": "KHAN, TAIMUR H",
    "owner2": "",
    "current_taxes": 7048.19,
    "new_taxes_no_override": 7352.67,
    "override_total_1": 7561.3,
    "override_increase_1": 208.63
  },
  {
    "#": "15 Francis St, Unit 35 & G8 (126-08-19)",
    "$": 697000,
    "address": "15 Francis St, Unit 35 & G8",
    "parcel_id": "126-08-19",
    "owner1": "KWONG TR, KENNETH",
    "owner2": "",
    "current_taxes": 7137.28,
    "new_taxes_no_override": 7445.61,
    "override_total_1": 7656.87,
    "override_increase_1": 211.26
  },
  {
    "#": "15 Francis St, Unit 36 (126-08-20)",
    "$": 574800,
    "address": "15 Francis St, Unit 36",
    "parcel_id": "126-08-20",
    "owner1": "VAINSHTEIN, DINA",
    "owner2": "",
    "current_taxes": 2251.02,
    "new_taxes_no_override": 2348.26,
    "override_total_1": 2414.89,
    "override_increase_1": 66.63
  },
  {
    "#": "15 Francis St, Unit 37 (126-08-21)",
    "$": 398000,
    "address": "15 Francis St, Unit 37",
    "parcel_id": "126-08-21",
    "owner1": "ORAV, ENDEL JOHN",
    "owner2": "",
    "current_taxes": 440.59,
    "new_taxes_no_override": 459.62,
    "override_total_1": 472.66,
    "override_increase_1": 13.04
  },
  {
    "#": "15 Francis St, Unit 38 & P14 (126-08-22)",
    "$": 692100,
    "address": "15 Francis St, Unit 38 & P14",
    "parcel_id": "126-08-22",
    "owner1": "SZETO, PIK KI",
    "owner2": "WONG, KIN SANG",
    "current_taxes": 7087.1,
    "new_taxes_no_override": 7393.26,
    "override_total_1": 7603.04,
    "override_increase_1": 209.78
  },
  {
    "#": "15 Francis St, Unit 41 & G11A (126-08-23)",
    "$": 715600,
    "address": "15 Francis St, Unit 41 & G11A",
    "parcel_id": "126-08-23",
    "owner1": "ZHOU, JINGRONG",
    "owner2": "",
    "current_taxes": 7327.74,
    "new_taxes_no_override": 7644.3,
    "override_total_1": 7861.2,
    "override_increase_1": 216.9
  },
  {
    "#": "15 Francis St, Unit 42 & P20 (126-08-24)",
    "$": 428400,
    "address": "15 Francis St, Unit 42 & P20",
    "parcel_id": "126-08-24",
    "owner1": "LAM TRS, SIU KAI RAYMOND",
    "owner2": "WU, LILY HUILING",
    "current_taxes": 4386.82,
    "new_taxes_no_override": 4576.33,
    "override_total_1": 4706.18,
    "override_increase_1": 129.85
  },
  {
    "#": "15 Francis St, Unit 43 & G1 (126-08-25)",
    "$": 628400,
    "address": "15 Francis St, Unit 43 & G1",
    "parcel_id": "126-08-25",
    "owner1": "DONAHUE, MEGHAN E",
    "owner2": "",
    "current_taxes": 2799.88,
    "new_taxes_no_override": 2920.83,
    "override_total_1": 3003.71,
    "override_increase_1": 82.88
  },
  {
    "#": "15 Francis St, Unit 44 & P17 (126-08-26)",
    "$": 680700,
    "address": "15 Francis St, Unit 44 & P17",
    "parcel_id": "126-08-26",
    "owner1": "PALMER TR, DEBORAH S",
    "owner2": "",
    "current_taxes": 3335.43,
    "new_taxes_no_override": 3479.52,
    "override_total_1": 3578.25,
    "override_increase_1": 98.73
  },
  {
    "#": "15 Francis St, Unit 45 & P6 (126-08-27)",
    "$": 697900,
    "address": "15 Francis St, Unit 45 & P6",
    "parcel_id": "126-08-27",
    "owner1": "KOROLEVA, SVETLANA G",
    "owner2": "",
    "current_taxes": 3511.56,
    "new_taxes_no_override": 3663.26,
    "override_total_1": 3767.2,
    "override_increase_1": 103.94
  },
  {
    "#": "15 Francis St, Unit 46 & G3 (126-08-28)",
    "$": 637400,
    "address": "15 Francis St, Unit 46 & G3",
    "parcel_id": "126-08-28",
    "owner1": "ZHENG, XIAOZHANG",
    "owner2": "YE, YIHUA EMILY",
    "current_taxes": 6526.98,
    "new_taxes_no_override": 6808.95,
    "override_total_1": 7002.14,
    "override_increase_1": 193.2
  },
  {
    "#": "15 Francis St, Unit 47 & G4 (126-08-29)",
    "$": 494800,
    "address": "15 Francis St, Unit 47 & G4",
    "parcel_id": "126-08-29",
    "owner1": "GREENBERG, ALAN",
    "owner2": "",
    "current_taxes": 1431.82,
    "new_taxes_no_override": 1493.67,
    "override_total_1": 1536.06,
    "override_increase_1": 42.38
  },
  {
    "#": "15 Francis St, Unit 48 & P22 (126-08-30)",
    "$": 671500,
    "address": "15 Francis St, Unit 48 & P22",
    "parcel_id": "126-08-30",
    "owner1": "MAROTTA, STEPHEN JAMES & LAUREN LOUISE",
    "owner2": "",
    "current_taxes": 3241.23,
    "new_taxes_no_override": 3381.25,
    "override_total_1": 3477.19,
    "override_increase_1": 95.94
  },
  {
    "#": "20 Francis St (129-11-00)",
    "$": 3836800,
    "address": "20 Francis St",
    "parcel_id": "129-11-00",
    "owner1": "OTTO, GEOFFREY & NORMAN & CHARLOTTE",
    "owner2": "HUR, SUN",
    "current_taxes": 35653.9,
    "new_taxes_no_override": 37194.15,
    "override_total_1": 38249.5,
    "override_increase_1": 1055.36
  },
  {
    "#": "24 Francis St (129-22-00)",
    "$": 2514100,
    "address": "24 Francis St",
    "parcel_id": "129-22-00",
    "owner1": "BERGMAN TRS, DANIEL A",
    "owner2": "TURNBULL, KATHERINE C",
    "current_taxes": 22109.45,
    "new_taxes_no_override": 23064.58,
    "override_total_1": 23719.02,
    "override_increase_1": 654.44
  },
  {
    "#": "26 Francis St (129-23-00)",
    "$": 2414800,
    "address": "26 Francis St",
    "parcel_id": "129-23-00",
    "owner1": "DOBROTH TRS, MEGAN M",
    "owner2": "TURNBULL, NANCY C",
    "current_taxes": 21092.62,
    "new_taxes_no_override": 22003.82,
    "override_total_1": 22628.16,
    "override_increase_1": 624.34
  },
  {
    "#": "27 Francis St (126-09-00)",
    "$": 31801100,
    "address": "27 Francis St",
    "parcel_id": "126-09-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O LAWRENCE SCHOOL",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "30 Francis St (129-09-00)",
    "$": 2748600,
    "address": "30 Francis St",
    "parcel_id": "129-09-00",
    "owner1": "SHAPIRO, GREGG D",
    "owner2": "DOGAN, STACEY",
    "current_taxes": 24510.73,
    "new_taxes_no_override": 25569.59,
    "override_total_1": 26295.11,
    "override_increase_1": 725.52
  },
  {
    "#": "34 Francis St, Unit 34 (129-08-01)",
    "$": 2512800,
    "address": "34 Francis St, Unit 34",
    "parcel_id": "129-08-01",
    "owner1": "PRYCE, IMOGEN M",
    "owner2": "LARUSSO, NICHOLAS D",
    "current_taxes": 22096.14,
    "new_taxes_no_override": 23050.69,
    "override_total_1": 23704.74,
    "override_increase_1": 654.05
  },
  {
    "#": "36 Francis St, Unit 36 (129-08-02)",
    "$": 2267800,
    "address": "36 Francis St, Unit 36",
    "parcel_id": "129-08-02",
    "owner1": "STINY TRS, GEORGE N",
    "owner2": "KNIGHT , TERRY WEISSMAN",
    "current_taxes": 19587.34,
    "new_taxes_no_override": 20433.51,
    "override_total_1": 21013.3,
    "override_increase_1": 579.79
  },
  {
    "#": "44 Francis St (130-14-00)",
    "$": 2016600,
    "address": "44 Francis St",
    "parcel_id": "130-14-00",
    "owner1": "OSORNIO TRS, RIMA & LISA & ALEXANDER",
    "owner2": "",
    "current_taxes": 20649.98,
    "new_taxes_no_override": 21542.06,
    "override_total_1": 22153.3,
    "override_increase_1": 611.24
  },
  {
    "#": "48 Francis St (130-13-00)",
    "$": 2860800,
    "address": "48 Francis St",
    "parcel_id": "130-13-00",
    "owner1": "PENG, LUKE",
    "owner2": "CHIU, JOANNE",
    "current_taxes": 25659.66,
    "new_taxes_no_override": 26768.16,
    "override_total_1": 27527.68,
    "override_increase_1": 759.53
  },
  {
    "#": "54 Francis St (130-12-00)",
    "$": 2672400,
    "address": "54 Francis St",
    "parcel_id": "130-12-00",
    "owner1": "KOZAKEWICH, HARRY P W",
    "owner2": "",
    "current_taxes": 27365.38,
    "new_taxes_no_override": 28547.56,
    "override_total_1": 29357.58,
    "override_increase_1": 810.02
  },
  {
    "#": "57 Francis St (126-11-12)",
    "$": 1526300,
    "address": "57 Francis St",
    "parcel_id": "126-11-12",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O LONGWOOD PLAYGROUND",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "63 Francis St (126-13-00)",
    "$": 2651800,
    "address": "63 Francis St",
    "parcel_id": "126-13-00",
    "owner1": "SPINO, GREGORY A",
    "owner2": "DUGGAN, PATRICIA E",
    "current_taxes": 23519.5,
    "new_taxes_no_override": 24535.54,
    "override_total_1": 25231.72,
    "override_increase_1": 696.18
  },
  {
    "#": "65 Francis St (126-14-00)",
    "$": 2474300,
    "address": "65 Francis St",
    "parcel_id": "126-14-00",
    "owner1": "SABA DEVELOPMENT LLC",
    "owner2": "",
    "current_taxes": 25336.83,
    "new_taxes_no_override": 26431.38,
    "override_total_1": 27181.35,
    "override_increase_1": 749.97
  },
  {
    "#": "70 Francis St (131-16-00)",
    "$": 1687100,
    "address": "70 Francis St",
    "parcel_id": "131-16-00",
    "owner1": "70 FRANCIS STREET LLC",
    "owner2": "",
    "current_taxes": 17275.9,
    "new_taxes_no_override": 18022.22,
    "override_total_1": 18533.59,
    "override_increase_1": 511.37
  },
  {
    "#": "71 Francis St (126-15-00)",
    "$": 2621100,
    "address": "71 Francis St",
    "parcel_id": "126-15-00",
    "owner1": "SCANLON, JAMES P JR &  KATHLEEN M",
    "owner2": "",
    "current_taxes": 23205.13,
    "new_taxes_no_override": 24207.59,
    "override_total_1": 24894.46,
    "override_increase_1": 686.87
  },
  {
    "#": "72 Francis St (131-15-00)",
    "$": 1817300,
    "address": "72 Francis St",
    "parcel_id": "131-15-00",
    "owner1": "72 FRANCIS STREET LLC",
    "owner2": "",
    "current_taxes": 18609.15,
    "new_taxes_no_override": 19413.07,
    "override_total_1": 19963.9,
    "override_increase_1": 550.83
  },
  {
    "#": "75 Francis St, Unit 75-1 (126-16-03)",
    "$": 2107100,
    "address": "75 Francis St, Unit 75-1",
    "parcel_id": "126-16-03",
    "owner1": "BURNS TRS, DAVID M & FRUMIE L",
    "owner2": "",
    "current_taxes": 17941.77,
    "new_taxes_no_override": 18716.85,
    "override_total_1": 19247.93,
    "override_increase_1": 531.08
  },
  {
    "#": "75 Francis St, Unit 75-2 (126-16-04)",
    "$": 2272400,
    "address": "75 Francis St, Unit 75-2",
    "parcel_id": "126-16-04",
    "owner1": "LAUB, MICHAEL T",
    "owner2": "PARKER, MARGARET",
    "current_taxes": 19634.44,
    "new_taxes_no_override": 20482.65,
    "override_total_1": 21063.83,
    "override_increase_1": 581.18
  },
  {
    "#": "75 Francis St, Unit 77-1 (126-16-05)",
    "$": 2107100,
    "address": "75 Francis St, Unit 77-1",
    "parcel_id": "126-16-05",
    "owner1": "HAM, PAUL S & CATHERINE H",
    "owner2": "",
    "current_taxes": 17941.77,
    "new_taxes_no_override": 18716.85,
    "override_total_1": 19247.93,
    "override_increase_1": 531.08
  },
  {
    "#": "75 Francis St, Unit 77-2 (126-16-06)",
    "$": 2272300,
    "address": "75 Francis St, Unit 77-2",
    "parcel_id": "126-16-06",
    "owner1": "CONLEY, DARBY",
    "owner2": "",
    "current_taxes": 23268.35,
    "new_taxes_no_override": 24273.54,
    "override_total_1": 24962.29,
    "override_increase_1": 688.74
  },
  {
    "#": "78 Francis St, Unit F78 (131-14-13)",
    "$": 560300,
    "address": "78 Francis St, Unit F78",
    "parcel_id": "131-14-13",
    "owner1": "GARFI TR, JOELLE N",
    "owner2": "",
    "current_taxes": 5737.47,
    "new_taxes_no_override": 5985.33,
    "override_total_1": 6155.16,
    "override_increase_1": 169.83
  },
  {
    "#": "80 Francis St, Unit 1 (131-14-01)",
    "$": 720900,
    "address": "80 Francis St, Unit 1",
    "parcel_id": "131-14-01",
    "owner1": "ARGYRIADIS, NICOLE M",
    "owner2": "",
    "current_taxes": 3747.08,
    "new_taxes_no_override": 3908.95,
    "override_total_1": 4019.87,
    "override_increase_1": 110.91
  },
  {
    "#": "80 Francis St, Unit 2 (131-14-02)",
    "$": 751800,
    "address": "80 Francis St, Unit 2",
    "parcel_id": "131-14-02",
    "owner1": "XUE TRS, QUN",
    "owner2": "",
    "current_taxes": 7698.43,
    "new_taxes_no_override": 8031.0,
    "override_total_1": 8258.88,
    "override_increase_1": 227.87
  },
  {
    "#": "80 Francis St, Unit 3 (131-14-03)",
    "$": 785100,
    "address": "80 Francis St, Unit 3",
    "parcel_id": "131-14-03",
    "owner1": "SHERMAN, GLEN",
    "owner2": "PROTZMAN, HANNAH",
    "current_taxes": 4404.49,
    "new_taxes_no_override": 4594.76,
    "override_total_1": 4725.14,
    "override_increase_1": 130.37
  },
  {
    "#": "80 Francis St, Unit 4 (131-14-04)",
    "$": 751100,
    "address": "80 Francis St, Unit 4",
    "parcel_id": "131-14-04",
    "owner1": "SHIEDLIN, AVIVA",
    "owner2": "",
    "current_taxes": 4056.33,
    "new_taxes_no_override": 4231.56,
    "override_total_1": 4351.63,
    "override_increase_1": 120.07
  },
  {
    "#": "80 Francis St, Unit 5 (131-14-05)",
    "$": 773300,
    "address": "80 Francis St, Unit 5",
    "parcel_id": "131-14-05",
    "owner1": "GATTERBAUER, WOLFGANG",
    "owner2": "FINLEY, ANNA",
    "current_taxes": 4283.66,
    "new_taxes_no_override": 4468.71,
    "override_total_1": 4595.51,
    "override_increase_1": 126.8
  },
  {
    "#": "80 Francis St, Unit 6 (131-14-06)",
    "$": 751600,
    "address": "80 Francis St, Unit 6",
    "parcel_id": "131-14-06",
    "owner1": "INSTRUM, MARC S",
    "owner2": "BOWMAN, ELIZABETH C",
    "current_taxes": 4061.45,
    "new_taxes_no_override": 4236.9,
    "override_total_1": 4357.12,
    "override_increase_1": 120.22
  },
  {
    "#": "81 Francis St, Unit 2 (126-17-02)",
    "$": 786800,
    "address": "81 Francis St, Unit 2",
    "parcel_id": "126-17-02",
    "owner1": "RAMOS, BARTON",
    "owner2": "SOBEL, MICHELE A",
    "current_taxes": 4421.9,
    "new_taxes_no_override": 4612.93,
    "override_total_1": 4743.81,
    "override_increase_1": 130.89
  },
  {
    "#": "81 Francis St, Unit 4 (126-17-04)",
    "$": 768300,
    "address": "81 Francis St, Unit 4",
    "parcel_id": "126-17-04",
    "owner1": "STROMBERG, MATTHEW",
    "owner2": "MODABBER, YALDA",
    "current_taxes": 7867.39,
    "new_taxes_no_override": 8207.26,
    "override_total_1": 8440.14,
    "override_increase_1": 232.87
  },
  {
    "#": "81 Francis St, Unit 6 (126-17-06)",
    "$": 775100,
    "address": "81 Francis St, Unit 6",
    "parcel_id": "126-17-06",
    "owner1": "SHI, YUAN",
    "owner2": "",
    "current_taxes": 7937.02,
    "new_taxes_no_override": 8279.9,
    "override_total_1": 8514.84,
    "override_increase_1": 234.94
  },
  {
    "#": "83 Francis St, Unit 1 (126-17-01)",
    "$": 675800,
    "address": "83 Francis St, Unit 1",
    "parcel_id": "126-17-01",
    "owner1": "MYLES, BRIAN M & LOUISE M",
    "owner2": "",
    "current_taxes": 3285.26,
    "new_taxes_no_override": 3427.18,
    "override_total_1": 3524.43,
    "override_increase_1": 97.24
  },
  {
    "#": "83 Francis St, Unit 3 (126-17-03)",
    "$": 788500,
    "address": "83 Francis St, Unit 3",
    "parcel_id": "126-17-03",
    "owner1": "XU, QIONGLI",
    "owner2": "",
    "current_taxes": 8074.24,
    "new_taxes_no_override": 8423.05,
    "override_total_1": 8662.04,
    "override_increase_1": 239.0
  },
  {
    "#": "83 Francis St, Unit 5 (126-17-05)",
    "$": 761300,
    "address": "83 Francis St, Unit 5",
    "parcel_id": "126-17-05",
    "owner1": "FRANCIS HOLDING LLC",
    "owner2": "C/O HALL, THOMAS M",
    "current_taxes": 7795.71,
    "new_taxes_no_override": 8132.48,
    "override_total_1": 8363.24,
    "override_increase_1": 230.75
  },
  {
    "#": "85 Francis St, Unit 1 (126-18-01)",
    "$": 978200,
    "address": "85 Francis St, Unit 1",
    "parcel_id": "126-18-01",
    "owner1": "GOOLEY, DANA ANDREW",
    "owner2": "SEGAL, LEAH BETH YELLIN",
    "current_taxes": 6381.83,
    "new_taxes_no_override": 6657.53,
    "override_total_1": 6846.43,
    "override_increase_1": 188.9
  },
  {
    "#": "85 Francis St, Unit 2 (126-18-02)",
    "$": 964000,
    "address": "85 Francis St, Unit 2",
    "parcel_id": "126-18-02",
    "owner1": "MICHEL, NANCY WILLS",
    "owner2": "",
    "current_taxes": 6236.43,
    "new_taxes_no_override": 6505.84,
    "override_total_1": 6690.44,
    "override_increase_1": 184.6
  },
  {
    "#": "85 Francis St, Unit 3 (126-18-03)",
    "$": 1036700,
    "address": "85 Francis St, Unit 3",
    "parcel_id": "126-18-03",
    "owner1": "HAM, PAUL S & CATHERINE H",
    "owner2": "",
    "current_taxes": 10615.81,
    "new_taxes_no_override": 11074.41,
    "override_total_1": 11388.64,
    "override_increase_1": 314.23
  },
  {
    "#": "85 Francis St, Unit 4 (126-18-04)",
    "$": 1033100,
    "address": "85 Francis St, Unit 4",
    "parcel_id": "126-18-04",
    "owner1": "SARNER TRS, JONATHAN R & LAURENCE D",
    "owner2": "",
    "current_taxes": 10578.94,
    "new_taxes_no_override": 11035.95,
    "override_total_1": 11349.09,
    "override_increase_1": 313.14
  },
  {
    "#": "85 Francis St, Unit 5 (126-18-05)",
    "$": 1036700,
    "address": "85 Francis St, Unit 5",
    "parcel_id": "126-18-05",
    "owner1": "BURKE, BRIAN P & RENEE H",
    "owner2": "",
    "current_taxes": 6980.87,
    "new_taxes_no_override": 7282.44,
    "override_total_1": 7489.08,
    "override_increase_1": 206.63
  },
  {
    "#": "85 Francis St, Unit 6 (126-18-06)",
    "$": 1033100,
    "address": "85 Francis St, Unit 6",
    "parcel_id": "126-18-06",
    "owner1": "DODEK, WENDY L",
    "owner2": "JOVELLANOS, CESARIO L",
    "current_taxes": 6944.01,
    "new_taxes_no_override": 7243.99,
    "override_total_1": 7449.53,
    "override_increase_1": 205.54
  },
  {
    "#": "91 Francis St (126-19-00)",
    "$": 3618400,
    "address": "91 Francis St",
    "parcel_id": "126-19-00",
    "owner1": "SENAPATI, RAJESH",
    "owner2": "",
    "current_taxes": 33417.48,
    "new_taxes_no_override": 34861.12,
    "override_total_1": 35850.27,
    "override_increase_1": 989.16
  },
  {
    "#": "92 Francis St (132-26-00)",
    "$": 1496400,
    "address": "92 Francis St",
    "parcel_id": "132-26-00",
    "owner1": "WILKINSON, RONALD B",
    "owner2": "DOSSA, ALMAS",
    "current_taxes": 11688.2,
    "new_taxes_no_override": 12193.13,
    "override_total_1": 12539.1,
    "override_increase_1": 345.97
  },
  {
    "#": "94 Francis St (132-27-00)",
    "$": 1481000,
    "address": "94 Francis St",
    "parcel_id": "132-27-00",
    "owner1": "MOY, CONNIE & PAUL",
    "owner2": "",
    "current_taxes": 11530.51,
    "new_taxes_no_override": 12028.63,
    "override_total_1": 12369.93,
    "override_increase_1": 341.3
  },
  {
    "#": "97 Francis St (126-20-00)",
    "$": 3599600,
    "address": "97 Francis St",
    "parcel_id": "126-20-00",
    "owner1": "GERHART TRS, TOBIN N",
    "owner2": "DOHLMAN-GERHART, LENA E",
    "current_taxes": 33224.97,
    "new_taxes_no_override": 34660.29,
    "override_total_1": 35643.75,
    "override_increase_1": 983.46
  },
  {
    "#": "100 Francis St (132-11-00)",
    "$": 2757100,
    "address": "100 Francis St",
    "parcel_id": "132-11-00",
    "owner1": "STARK TR, JOHN THOMAS",
    "owner2": "",
    "current_taxes": 24597.77,
    "new_taxes_no_override": 25660.39,
    "override_total_1": 26388.49,
    "override_increase_1": 728.09
  },
  {
    "#": "103 Francis St (126-21-00)",
    "$": 2400000,
    "address": "103 Francis St",
    "parcel_id": "126-21-00",
    "owner1": "ELCOCK TR, CYNTHIA YUNG",
    "owner2": "",
    "current_taxes": 20941.07,
    "new_taxes_no_override": 21845.72,
    "override_total_1": 22465.58,
    "override_increase_1": 619.86
  },
  {
    "#": "106 Francis St (132-10-00)",
    "$": 2483000,
    "address": "106 Francis St",
    "parcel_id": "132-10-00",
    "owner1": "TUPA TRS, MYRON A",
    "owner2": "MCGINITY, KEREN R",
    "current_taxes": 21790.99,
    "new_taxes_no_override": 22732.36,
    "override_total_1": 23377.37,
    "override_increase_1": 645.01
  },
  {
    "#": "109 Francis St (126-22-01)",
    "$": 1896800,
    "address": "109 Francis St",
    "parcel_id": "126-22-01",
    "owner1": "LICURSE, JANE C & ADAM M",
    "owner2": "",
    "current_taxes": 15788.3,
    "new_taxes_no_override": 16470.35,
    "override_total_1": 16937.69,
    "override_increase_1": 467.33
  },
  {
    "#": "1 Franklin Ct (304-24-00)",
    "$": 1010000,
    "address": "1 Franklin Ct",
    "parcel_id": "304-24-00",
    "owner1": "SAMUEL, IDA",
    "owner2": "HENRY, ARMSTRONG ARUL",
    "current_taxes": 6707.47,
    "new_taxes_no_override": 6997.23,
    "override_total_1": 7195.77,
    "override_increase_1": 198.54
  },
  {
    "#": "2 Franklin Ct (304-23-00)",
    "$": 1027000,
    "address": "2 Franklin Ct",
    "parcel_id": "304-23-00",
    "owner1": "BRETELER TRS, RONALD J",
    "owner2": "LARSON, SYDNEY N",
    "current_taxes": 10516.48,
    "new_taxes_no_override": 10970.79,
    "override_total_1": 11282.08,
    "override_increase_1": 311.29
  },
  {
    "#": "3 Franklin Ct (304-22-00)",
    "$": 859300,
    "address": "3 Franklin Ct",
    "parcel_id": "304-22-00",
    "owner1": "CLINTON TRS, HELEN G & REGINA",
    "owner2": "",
    "current_taxes": 5164.3,
    "new_taxes_no_override": 5387.4,
    "override_total_1": 5540.26,
    "override_increase_1": 152.86
  },
  {
    "#": "4 Franklin Ct (304-21-00)",
    "$": 1078800,
    "address": "4 Franklin Ct",
    "parcel_id": "304-21-00",
    "owner1": "PALACE, SAMANTHA",
    "owner2": "REES, DANIEL",
    "current_taxes": 7411.98,
    "new_taxes_no_override": 7732.18,
    "override_total_1": 7951.57,
    "override_increase_1": 219.39
  },
  {
    "#": "5 Franklin Ct (304-20-00)",
    "$": 910400,
    "address": "5 Franklin Ct",
    "parcel_id": "304-20-00",
    "owner1": "ALLARA, ANN MARIE",
    "owner2": "",
    "current_taxes": 5687.56,
    "new_taxes_no_override": 5933.26,
    "override_total_1": 6101.61,
    "override_increase_1": 168.35
  },
  {
    "#": "3 Franklin St (307-33-00)",
    "$": 1723700,
    "address": "3 Franklin St",
    "parcel_id": "307-33-00",
    "owner1": "LANGDON LIFE ESTATE, MARY C",
    "owner2": "",
    "current_taxes": 17650.69,
    "new_taxes_no_override": 18413.2,
    "override_total_1": 18935.66,
    "override_increase_1": 522.46
  },
  {
    "#": "7 Franklin St, Unit 1 (307-34-01)",
    "$": 763300,
    "address": "7 Franklin St, Unit 1",
    "parcel_id": "307-34-01",
    "owner1": "KARR, DANIELLE L",
    "owner2": "",
    "current_taxes": 4181.26,
    "new_taxes_no_override": 4361.89,
    "override_total_1": 4485.66,
    "override_increase_1": 123.77
  },
  {
    "#": "7 Franklin St, Unit 2 (307-34-02)",
    "$": 635400,
    "address": "7 Franklin St, Unit 2",
    "parcel_id": "307-34-02",
    "owner1": "ZHOU, YIMING",
    "owner2": "GUO, SHUZHEN",
    "current_taxes": 2871.56,
    "new_taxes_no_override": 2995.61,
    "override_total_1": 3080.61,
    "override_increase_1": 85.0
  },
  {
    "#": "7 Franklin St, Unit 3 (307-34-03)",
    "$": 635500,
    "address": "7 Franklin St, Unit 3",
    "parcel_id": "307-34-03",
    "owner1": "MITCHELL, JESSICA",
    "owner2": "",
    "current_taxes": 2872.59,
    "new_taxes_no_override": 2996.69,
    "override_total_1": 3081.71,
    "override_increase_1": 85.03
  },
  {
    "#": "37 Franklin St (306-12-00)",
    "$": 1430600,
    "address": "37 Franklin St",
    "parcel_id": "306-12-00",
    "owner1": "GARCIA-ABRIL, ANTON",
    "owner2": "",
    "current_taxes": 11014.41,
    "new_taxes_no_override": 11490.23,
    "override_total_1": 11816.26,
    "override_increase_1": 326.03
  },
  {
    "#": "40 Franklin St (308-93-00)",
    "$": 1330400,
    "address": "40 Franklin St",
    "parcel_id": "308-93-00",
    "owner1": "SILBERMANN  ET AL TRS, ANDRIENNE G",
    "owner2": "WILLIAMS, BENJAMIN J JR",
    "current_taxes": 9988.36,
    "new_taxes_no_override": 10419.86,
    "override_total_1": 10715.51,
    "override_increase_1": 295.66
  },
  {
    "#": "41 Franklin St (306-13-00)",
    "$": 1644300,
    "address": "41 Franklin St",
    "parcel_id": "306-13-00",
    "owner1": "JENNINGS, EILEEN T",
    "owner2": "",
    "current_taxes": 13202.7,
    "new_taxes_no_override": 13773.06,
    "override_total_1": 14163.86,
    "override_increase_1": 390.8
  },
  {
    "#": "44 Franklin St (308-94-00)",
    "$": 1412100,
    "address": "44 Franklin St",
    "parcel_id": "308-94-00",
    "owner1": "HALLER, CRAIG A & CLAIRE A",
    "owner2": "",
    "current_taxes": 10824.97,
    "new_taxes_no_override": 11292.61,
    "override_total_1": 11613.03,
    "override_increase_1": 320.42
  },
  {
    "#": "50 Franklin St (308-95-00)",
    "$": 1718500,
    "address": "50 Franklin St",
    "parcel_id": "308-95-00",
    "owner1": "LU, BAO",
    "owner2": "CHEN, LIQING",
    "current_taxes": 13962.51,
    "new_taxes_no_override": 14565.69,
    "override_total_1": 14978.98,
    "override_increase_1": 413.29
  },
  {
    "#": "51 Franklin St (305-13-00)",
    "$": 1199200,
    "address": "51 Franklin St",
    "parcel_id": "305-13-00",
    "owner1": "MAHONY, THOMAS D & ELLEN W",
    "owner2": "",
    "current_taxes": 12279.81,
    "new_taxes_no_override": 12810.3,
    "override_total_1": 13173.78,
    "override_increase_1": 363.48
  },
  {
    "#": "54 Franklin St (308-95-01)",
    "$": 1351900,
    "address": "54 Franklin St",
    "parcel_id": "308-95-01",
    "owner1": "DISTEFANO TRS, PAMELA R",
    "owner2": "FORTI, ELIZABETH A",
    "current_taxes": 10208.52,
    "new_taxes_no_override": 10649.53,
    "override_total_1": 10951.7,
    "override_increase_1": 302.17
  },
  {
    "#": "55 Franklin St (305-15-00)",
    "$": 2209800,
    "address": "55 Franklin St",
    "parcel_id": "305-15-00",
    "owner1": "ROBERTS STREET REALTY LLC",
    "owner2": "",
    "current_taxes": 22628.35,
    "new_taxes_no_override": 23605.89,
    "override_total_1": 24275.69,
    "override_increase_1": 669.8
  },
  {
    "#": "60 Franklin St (308-95-02)",
    "$": 1359500,
    "address": "60 Franklin St",
    "parcel_id": "308-95-02",
    "owner1": "YEVICK, HANNAH",
    "owner2": "",
    "current_taxes": 10286.35,
    "new_taxes_no_override": 10730.72,
    "override_total_1": 11035.2,
    "override_increase_1": 304.48
  },
  {
    "#": "61 Franklin St (304-15-00)",
    "$": 1676000,
    "address": "61 Franklin St",
    "parcel_id": "304-15-00",
    "owner1": "GLYNN, TR, KATHERINE A",
    "owner2": "",
    "current_taxes": 17162.24,
    "new_taxes_no_override": 17903.65,
    "override_total_1": 18411.65,
    "override_increase_1": 508.0
  },
  {
    "#": "63 Franklin St (304-16-00)",
    "$": 1750400,
    "address": "63 Franklin St",
    "parcel_id": "304-16-00",
    "owner1": "GLYNN, TR, KATHERINE A",
    "owner2": "",
    "current_taxes": 17924.1,
    "new_taxes_no_override": 18698.42,
    "override_total_1": 19228.97,
    "override_increase_1": 530.55
  },
  {
    "#": "64 Franklin St (308-95-03)",
    "$": 1320600,
    "address": "64 Franklin St",
    "parcel_id": "308-95-03",
    "owner1": "ROTHSTEIN, NICHOLAS D & JENNIFER A",
    "owner2": "",
    "current_taxes": 9888.01,
    "new_taxes_no_override": 10315.17,
    "override_total_1": 10607.86,
    "override_increase_1": 292.69
  },
  {
    "#": "65 Franklin St (304-17-00)",
    "$": 878700,
    "address": "65 Franklin St",
    "parcel_id": "304-17-00",
    "owner1": "GALLAGHER TRS, RONALD P & BEVERLY M",
    "owner2": "",
    "current_taxes": 5362.95,
    "new_taxes_no_override": 5594.63,
    "override_total_1": 5753.37,
    "override_increase_1": 158.74
  },
  {
    "#": "67 Franklin St (304-18-00)",
    "$": 1285100,
    "address": "67 Franklin St",
    "parcel_id": "304-18-00",
    "owner1": "BUCAR ET AL, ELIZABETH MARIE",
    "owner2": "ZUBROW, ALEXIS",
    "current_taxes": 9524.49,
    "new_taxes_no_override": 9935.95,
    "override_total_1": 10217.87,
    "override_increase_1": 281.92
  },
  {
    "#": "68 Franklin St (308-95-04)",
    "$": 1435000,
    "address": "68 Franklin St",
    "parcel_id": "308-95-04",
    "owner1": "MCCLURE TRS, EDWARD D & DIANA L",
    "owner2": "",
    "current_taxes": 11059.47,
    "new_taxes_no_override": 11537.24,
    "override_total_1": 11864.6,
    "override_increase_1": 327.36
  },
  {
    "#": "70 Franklin St (308-95-05)",
    "$": 141500,
    "address": "70 Franklin St",
    "parcel_id": "308-95-05",
    "owner1": "BERTOLI, VINCENZO",
    "owner2": "POTTER, JULIA E",
    "current_taxes": 1448.96,
    "new_taxes_no_override": 1511.56,
    "override_total_1": 1554.44,
    "override_increase_1": 42.89
  },
  {
    "#": "81 Franklin St (304-19-00)",
    "$": 1250700,
    "address": "81 Franklin St",
    "parcel_id": "304-19-00",
    "owner1": "BERTOLI, VINCENZO",
    "owner2": "POTTER, JULIA E",
    "current_taxes": 9172.23,
    "new_taxes_no_override": 9568.47,
    "override_total_1": 9839.97,
    "override_increase_1": 271.5
  },
  {
    "#": "85 Franklin St (304-25-00)",
    "$": 1508200,
    "address": "85 Franklin St",
    "parcel_id": "304-25-00",
    "owner1": "SHIH, SU MIAO HSIAO",
    "owner2": "",
    "current_taxes": 11809.03,
    "new_taxes_no_override": 12319.18,
    "override_total_1": 12668.73,
    "override_increase_1": 349.55
  },
  {
    "#": "100 Franklin St (303-10-00)",
    "$": 1465500,
    "address": "100 Franklin St",
    "parcel_id": "303-10-00",
    "owner1": "66 CHESTNUT STREET LLC",
    "owner2": "",
    "current_taxes": 15006.72,
    "new_taxes_no_override": 15655.01,
    "override_total_1": 16099.21,
    "override_increase_1": 444.2
  },
  {
    "#": "101 Franklin St, Unit 1 & P2 (316-26-02)",
    "$": 897000,
    "address": "101 Franklin St, Unit 1 & P2",
    "parcel_id": "316-26-02",
    "owner1": "GANESAN, SANTOSH & NIRMALA",
    "owner2": "",
    "current_taxes": 9185.28,
    "new_taxes_no_override": 9582.08,
    "override_total_1": 9853.97,
    "override_increase_1": 271.88
  },
  {
    "#": "101 Franklin St, Unit 2 & P3 (316-26-03)",
    "$": 927300,
    "address": "101 Franklin St, Unit 2 & P3",
    "parcel_id": "316-26-03",
    "owner1": "XIE, GUANGXIN",
    "owner2": "",
    "current_taxes": 5860.62,
    "new_taxes_no_override": 6113.8,
    "override_total_1": 6287.27,
    "override_increase_1": 173.47
  },
  {
    "#": "101 Franklin St, Unit 3 & P4 (316-26-04)",
    "$": 941000,
    "address": "101 Franklin St, Unit 3 & P4",
    "parcel_id": "316-26-04",
    "owner1": "CHILDS, JOHN",
    "owner2": "FOGELMAN, PEGGY",
    "current_taxes": 6000.91,
    "new_taxes_no_override": 6260.15,
    "override_total_1": 6437.78,
    "override_increase_1": 177.63
  },
  {
    "#": "101 Franklin St, Unit G & P1 (316-26-01)",
    "$": 338400,
    "address": "101 Franklin St, Unit G & P1",
    "parcel_id": "316-26-01",
    "owner1": "ZACK, TRS, LINDA & MICHAEL",
    "owner2": "",
    "current_taxes": 3465.22,
    "new_taxes_no_override": 3614.92,
    "override_total_1": 3717.49,
    "override_increase_1": 102.57
  },
  {
    "#": "102 Franklin St (303-09-00)",
    "$": 1515200,
    "address": "102 Franklin St",
    "parcel_id": "303-09-00",
    "owner1": "66 CHESTNUT STREET LLC",
    "owner2": "",
    "current_taxes": 15515.65,
    "new_taxes_no_override": 16185.93,
    "override_total_1": 16645.19,
    "override_increase_1": 459.26
  },
  {
    "#": "104 Franklin St (303-08-00)",
    "$": 2237700,
    "address": "104 Franklin St",
    "parcel_id": "303-08-00",
    "owner1": "CHANG, STAINER K & SHIRLEY L",
    "owner2": "",
    "current_taxes": 22914.05,
    "new_taxes_no_override": 23903.94,
    "override_total_1": 24582.19,
    "override_increase_1": 678.26
  },
  {
    "#": "105 Franklin St, Unit 1 (316-03-01)",
    "$": 581600,
    "address": "105 Franklin St, Unit 1",
    "parcel_id": "316-03-01",
    "owner1": "SAWYER REI TWO LLC",
    "owner2": "",
    "current_taxes": 5955.58,
    "new_taxes_no_override": 6212.86,
    "override_total_1": 6389.15,
    "override_increase_1": 176.29
  },
  {
    "#": "105 Franklin St, Unit 2 (316-03-02)",
    "$": 626600,
    "address": "105 Franklin St, Unit 2",
    "parcel_id": "316-03-02",
    "owner1": "SUN, JIUSONG",
    "owner2": "",
    "current_taxes": 6416.38,
    "new_taxes_no_override": 6693.57,
    "override_total_1": 6883.49,
    "override_increase_1": 189.92
  },
  {
    "#": "105 Franklin St, Unit 3 (316-03-03)",
    "$": 626600,
    "address": "105 Franklin St, Unit 3",
    "parcel_id": "316-03-03",
    "owner1": "CHEUNG, ALEX CH",
    "owner2": "",
    "current_taxes": 6416.38,
    "new_taxes_no_override": 6693.57,
    "override_total_1": 6883.49,
    "override_increase_1": 189.92
  },
  {
    "#": "106 Franklin St, Unit 1 & P1 (303-07-01)",
    "$": 646700,
    "address": "106 Franklin St, Unit 1 & P1",
    "parcel_id": "303-07-01",
    "owner1": "BEA, KWANGHYUN",
    "owner2": "",
    "current_taxes": 6622.21,
    "new_taxes_no_override": 6908.29,
    "override_total_1": 7104.31,
    "override_increase_1": 196.02
  },
  {
    "#": "106 Franklin St, Unit 2 & P2 (303-07-02)",
    "$": 707700,
    "address": "106 Franklin St, Unit 2 & P2",
    "parcel_id": "303-07-02",
    "owner1": "ESPERANCE, MORGAN C",
    "owner2": "",
    "current_taxes": 3611.91,
    "new_taxes_no_override": 3767.94,
    "override_total_1": 3874.86,
    "override_increase_1": 106.91
  },
  {
    "#": "106 Franklin St, Unit 3 & P3 (303-07-03)",
    "$": 703200,
    "address": "106 Franklin St, Unit 3 & P3",
    "parcel_id": "303-07-03",
    "owner1": "CORCODEL, RADU-IOAN",
    "owner2": "LI, XIAOJUAN",
    "current_taxes": 7200.77,
    "new_taxes_no_override": 7511.84,
    "override_total_1": 7724.99,
    "override_increase_1": 213.14
  },
  {
    "#": "107 Franklin St (316-04-00)",
    "$": 1334100,
    "address": "107 Franklin St",
    "parcel_id": "316-04-00",
    "owner1": "LEI, MEI PING",
    "owner2": "",
    "current_taxes": 10026.25,
    "new_taxes_no_override": 10459.38,
    "override_total_1": 10756.16,
    "override_increase_1": 296.78
  },
  {
    "#": "109 Franklin St, Unit 1 & P3 P4 (316-05-01)",
    "$": 608900,
    "address": "109 Franklin St, Unit 1 & P3 P4",
    "parcel_id": "316-05-01",
    "owner1": "CAMPOS CARMONA, MARGARITA",
    "owner2": "MARTINEZ CAMPOS, IVON",
    "current_taxes": 6235.14,
    "new_taxes_no_override": 6504.5,
    "override_total_1": 6689.06,
    "override_increase_1": 184.56
  },
  {
    "#": "109 Franklin St, Unit 2 & P2 (316-05-02)",
    "$": 625000,
    "address": "109 Franklin St, Unit 2 & P2",
    "parcel_id": "316-05-02",
    "owner1": "GAO, CINDY QUN & CHEN LI",
    "owner2": "",
    "current_taxes": 6400.0,
    "new_taxes_no_override": 6676.48,
    "override_total_1": 6865.92,
    "override_increase_1": 189.44
  },
  {
    "#": "109 Franklin St, Unit 3 & P1 (316-05-03)",
    "$": 633200,
    "address": "109 Franklin St, Unit 3 & P1",
    "parcel_id": "316-05-03",
    "owner1": "CHEKANOV, SERGEY",
    "owner2": "",
    "current_taxes": 2849.03,
    "new_taxes_no_override": 2972.11,
    "override_total_1": 3056.44,
    "override_increase_1": 84.33
  },
  {
    "#": "110 Franklin St, Unit 1 (303-06-03)",
    "$": 756800,
    "address": "110 Franklin St, Unit 1",
    "parcel_id": "303-06-03",
    "owner1": "WANG, XIAOFAN",
    "owner2": "LEE, JAEMIN",
    "current_taxes": 4114.7,
    "new_taxes_no_override": 4292.46,
    "override_total_1": 4414.25,
    "override_increase_1": 121.8
  },
  {
    "#": "110 Franklin St, Unit 2 (303-06-01)",
    "$": 717400,
    "address": "110 Franklin St, Unit 2",
    "parcel_id": "303-06-01",
    "owner1": "MCGRANE TR, NINA",
    "owner2": "",
    "current_taxes": 3711.24,
    "new_taxes_no_override": 3871.57,
    "override_total_1": 3981.42,
    "override_increase_1": 109.85
  },
  {
    "#": "110 Franklin St, Unit 3 (303-06-02)",
    "$": 949700,
    "address": "110 Franklin St, Unit 3",
    "parcel_id": "303-06-02",
    "owner1": "FRIEND TR, AINE",
    "owner2": "",
    "current_taxes": 6089.99,
    "new_taxes_no_override": 6353.08,
    "override_total_1": 6533.34,
    "override_increase_1": 180.26
  },
  {
    "#": "112 Franklin St, Unit 1 (303-05-04)",
    "$": 687200,
    "address": "112 Franklin St, Unit 1",
    "parcel_id": "303-05-04",
    "owner1": "GOBLE, ROBERT L & ANNE F",
    "owner2": "",
    "current_taxes": 3401.99,
    "new_taxes_no_override": 3548.96,
    "override_total_1": 3649.65,
    "override_increase_1": 100.7
  },
  {
    "#": "112 Franklin St, Unit 2 (303-05-02)",
    "$": 712400,
    "address": "112 Franklin St, Unit 2",
    "parcel_id": "303-05-02",
    "owner1": "NDAO, ABDOULAYE & MARIE-JEANNE",
    "owner2": "",
    "current_taxes": 7294.98,
    "new_taxes_no_override": 7610.12,
    "override_total_1": 7826.05,
    "override_increase_1": 215.93
  },
  {
    "#": "112 Franklin St, Unit 3 (303-05-03)",
    "$": 834700,
    "address": "112 Franklin St, Unit 3",
    "parcel_id": "303-05-03",
    "owner1": "NANSUBUGA, RONAH",
    "owner2": "",
    "current_taxes": 8547.33,
    "new_taxes_no_override": 8916.57,
    "override_total_1": 9169.58,
    "override_increase_1": 253.0
  },
  {
    "#": "114 Franklin St (303-04-00)",
    "$": 1512500,
    "address": "114 Franklin St",
    "parcel_id": "303-04-00",
    "owner1": "TAM, TSANG",
    "owner2": "",
    "current_taxes": 11853.07,
    "new_taxes_no_override": 12365.12,
    "override_total_1": 12715.97,
    "override_increase_1": 350.85
  },
  {
    "#": "115 Franklin St, Unit 1 (316-06-04)",
    "$": 775900,
    "address": "115 Franklin St, Unit 1",
    "parcel_id": "316-06-04",
    "owner1": "CHRISTOV, NIKOLAY",
    "owner2": "CHRISTOVA, DIANA L",
    "current_taxes": 7945.22,
    "new_taxes_no_override": 8288.45,
    "override_total_1": 8523.63,
    "override_increase_1": 235.18
  },
  {
    "#": "115 Franklin St, Unit 2 (316-06-05)",
    "$": 1091200,
    "address": "115 Franklin St, Unit 2",
    "parcel_id": "316-06-05",
    "owner1": "WANG, YAOYU",
    "owner2": "",
    "current_taxes": 11173.89,
    "new_taxes_no_override": 11656.6,
    "override_total_1": 11987.35,
    "override_increase_1": 330.75
  },
  {
    "#": "117 Franklin St, Unit 1 (316-06-02)",
    "$": 776800,
    "address": "117 Franklin St, Unit 1",
    "parcel_id": "316-06-02",
    "owner1": "LANG, YUNG KANG",
    "owner2": "ZENG, YU",
    "current_taxes": 4319.5,
    "new_taxes_no_override": 4506.1,
    "override_total_1": 4633.96,
    "override_increase_1": 127.86
  },
  {
    "#": "117 Franklin St, Unit 2 (316-06-03)",
    "$": 1097000,
    "address": "117 Franklin St, Unit 2",
    "parcel_id": "316-06-03",
    "owner1": "LI, QUN",
    "owner2": "ZHU, ZHOUJING",
    "current_taxes": 7598.35,
    "new_taxes_no_override": 7926.6,
    "override_total_1": 8151.51,
    "override_increase_1": 224.91
  },
  {
    "#": "118 Franklin St, Unit 1 (303-03-01)",
    "$": 759500,
    "address": "118 Franklin St, Unit 1",
    "parcel_id": "303-03-01",
    "owner1": "CHACKER, STACEY",
    "owner2": "",
    "current_taxes": 7777.28,
    "new_taxes_no_override": 8113.26,
    "override_total_1": 8343.47,
    "override_increase_1": 230.21
  },
  {
    "#": "118 Franklin St, Unit 2 (303-03-02)",
    "$": 801500,
    "address": "118 Franklin St, Unit 2",
    "parcel_id": "303-03-02",
    "owner1": "SUN, JIUSONG",
    "owner2": "",
    "current_taxes": 8207.36,
    "new_taxes_no_override": 8561.92,
    "override_total_1": 8804.86,
    "override_increase_1": 242.94
  },
  {
    "#": "118 Franklin St, Unit 3 (303-03-03)",
    "$": 807600,
    "address": "118 Franklin St, Unit 3",
    "parcel_id": "303-03-03",
    "owner1": "DASSA, LEO",
    "owner2": "",
    "current_taxes": 4634.89,
    "new_taxes_no_override": 4835.12,
    "override_total_1": 4972.31,
    "override_increase_1": 137.19
  },
  {
    "#": "120 Franklin St, Unit 1 P-C (303-02-01)",
    "$": 1012900,
    "address": "120 Franklin St, Unit 1 P-C",
    "parcel_id": "303-02-01",
    "owner1": "SHORT, MICHAEL H",
    "owner2": "FRANKL, ELIZABETH A",
    "current_taxes": 6737.16,
    "new_taxes_no_override": 7028.21,
    "override_total_1": 7227.63,
    "override_increase_1": 199.42
  },
  {
    "#": "120 Franklin St, Unit 2 & Pk-B (303-02-02)",
    "$": 940400,
    "address": "120 Franklin St, Unit 2 & Pk-B",
    "parcel_id": "303-02-02",
    "owner1": "GORMAN, ELIZABETH",
    "owner2": "ZAHKA, GEORGE M",
    "current_taxes": 5994.76,
    "new_taxes_no_override": 6253.73,
    "override_total_1": 6431.18,
    "override_increase_1": 177.44
  },
  {
    "#": "120 Franklin St, Unit 3 & Pk-A (303-02-03)",
    "$": 976000,
    "address": "120 Franklin St, Unit 3 & Pk-A",
    "parcel_id": "303-02-03",
    "owner1": "FIDELLOW , BETH A TR & ALAN",
    "owner2": "",
    "current_taxes": 9994.24,
    "new_taxes_no_override": 10425.99,
    "override_total_1": 10721.82,
    "override_increase_1": 295.83
  },
  {
    "#": "95 Freeman St (012-03-00)",
    "$": 7692900,
    "address": "95 Freeman St",
    "parcel_id": "012-03-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O AMORY WOODS SANCTUARY",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "115 Freeman St, Unit 1 & G-B (026-01-42)",
    "$": 718800,
    "address": "115 Freeman St, Unit 1 & G-B",
    "parcel_id": "026-01-42",
    "owner1": "HIEBLINGER, YUEH-HUI",
    "owner2": "",
    "current_taxes": 3725.58,
    "new_taxes_no_override": 3886.53,
    "override_total_1": 3996.8,
    "override_increase_1": 110.28
  },
  {
    "#": "115 Freeman St, Unit 1A & G-A (026-01-01)",
    "$": 953300,
    "address": "115 Freeman St, Unit 1A & G-A",
    "parcel_id": "026-01-01",
    "owner1": "HAJJAR TR, REBECCA A",
    "owner2": "",
    "current_taxes": 6126.86,
    "new_taxes_no_override": 6391.54,
    "override_total_1": 6572.9,
    "override_increase_1": 181.36
  },
  {
    "#": "115 Freeman St, Unit 2 & G-M (026-01-02)",
    "$": 902600,
    "address": "115 Freeman St, Unit 2 & G-M",
    "parcel_id": "026-01-02",
    "owner1": "POWER TR, ANNE",
    "owner2": "",
    "current_taxes": 5607.69,
    "new_taxes_no_override": 5849.94,
    "override_total_1": 6015.93,
    "override_increase_1": 165.99
  },
  {
    "#": "115 Freeman St, Unit 2A & G-E (026-01-03)",
    "$": 907400,
    "address": "115 Freeman St, Unit 2A & G-E",
    "parcel_id": "026-01-03",
    "owner1": "HUGHES, LAURIE A",
    "owner2": "",
    "current_taxes": 5656.84,
    "new_taxes_no_override": 5901.22,
    "override_total_1": 6068.66,
    "override_increase_1": 167.44
  },
  {
    "#": "115 Freeman St, Unit 3 (026-01-04)",
    "$": 744100,
    "address": "115 Freeman St, Unit 3",
    "parcel_id": "026-01-04",
    "owner1": "SHAMES, JENNIE S",
    "owner2": "",
    "current_taxes": 3984.65,
    "new_taxes_no_override": 4156.79,
    "override_total_1": 4274.73,
    "override_increase_1": 117.95
  },
  {
    "#": "115 Freeman St, Unit 3A&G-R (026-01-05)",
    "$": 931900,
    "address": "115 Freeman St, Unit 3A&G-R",
    "parcel_id": "026-01-05",
    "owner1": "SCHMID TRS, RICHARD",
    "owner2": "JANNELLI, LAURIE",
    "current_taxes": 5907.72,
    "new_taxes_no_override": 6162.93,
    "override_total_1": 6337.8,
    "override_increase_1": 174.87
  },
  {
    "#": "119 Freeman St, Unit 1&G-I (026-01-06)",
    "$": 694300,
    "address": "119 Freeman St, Unit 1&G-I",
    "parcel_id": "026-01-06",
    "owner1": "SHAPIRO, JOYCE A",
    "owner2": "C/O GORDON JOYCE",
    "current_taxes": 7109.63,
    "new_taxes_no_override": 7416.77,
    "override_total_1": 7627.21,
    "override_increase_1": 210.45
  },
  {
    "#": "119 Freeman St, Unit 1A (026-01-07)",
    "$": 788000,
    "address": "119 Freeman St, Unit 1A",
    "parcel_id": "026-01-07",
    "owner1": "TENENBAUM ET AL, JOSHUA",
    "owner2": "BERNSTEIN, MIRA",
    "current_taxes": 4434.19,
    "new_taxes_no_override": 4625.75,
    "override_total_1": 4757.0,
    "override_increase_1": 131.25
  },
  {
    "#": "119 Freeman St, Unit 2 & G-H (026-01-08)",
    "$": 874200,
    "address": "119 Freeman St, Unit 2 & G-H",
    "parcel_id": "026-01-08",
    "owner1": "DBF FREEMAN PROPERTY MANAGEMENT LLC",
    "owner2": "",
    "current_taxes": 8951.81,
    "new_taxes_no_override": 9338.53,
    "override_total_1": 9603.5,
    "override_increase_1": 264.97
  },
  {
    "#": "119 Freeman St, Unit 2A & G-F (026-01-09)",
    "$": 981100,
    "address": "119 Freeman St, Unit 2A & G-F",
    "parcel_id": "026-01-09",
    "owner1": "ZHANG, HUI",
    "owner2": "FANG, XUELIANG",
    "current_taxes": 6411.53,
    "new_taxes_no_override": 6688.51,
    "override_total_1": 6878.29,
    "override_increase_1": 189.78
  },
  {
    "#": "119 Freeman St, Unit 3& G-C (026-01-10)",
    "$": 902700,
    "address": "119 Freeman St, Unit 3& G-C",
    "parcel_id": "026-01-10",
    "owner1": "HANENBERGER TRS, FRANK & MELISSA BRODIE",
    "owner2": "",
    "current_taxes": 9243.65,
    "new_taxes_no_override": 9642.98,
    "override_total_1": 9916.59,
    "override_increase_1": 273.61
  },
  {
    "#": "119 Freeman St, Unit 3A & G-J (026-01-11)",
    "$": 951900,
    "address": "119 Freeman St, Unit 3A & G-J",
    "parcel_id": "026-01-11",
    "owner1": "GU, YONG",
    "owner2": "YU, XIAOMEI",
    "current_taxes": 6112.52,
    "new_taxes_no_override": 6376.58,
    "override_total_1": 6557.51,
    "override_increase_1": 180.93
  },
  {
    "#": "123 Freeman St, Unit 1 (026-01-12)",
    "$": 643300,
    "address": "123 Freeman St, Unit 1",
    "parcel_id": "026-01-12",
    "owner1": "NITIKMAN, NANCY",
    "owner2": "",
    "current_taxes": 2952.46,
    "new_taxes_no_override": 3080.01,
    "override_total_1": 3167.4,
    "override_increase_1": 87.39
  },
  {
    "#": "123 Freeman St, Unit 1A & P-5 (026-01-13)",
    "$": 829000,
    "address": "123 Freeman St, Unit 1A & P-5",
    "parcel_id": "026-01-13",
    "owner1": "SUGARMAN TRS, PAUL R & ELLEN L",
    "owner2": "",
    "current_taxes": 8488.96,
    "new_taxes_no_override": 8855.68,
    "override_total_1": 9106.96,
    "override_increase_1": 251.27
  },
  {
    "#": "123 Freeman St, Unit 2 & G-L (026-01-14)",
    "$": 879600,
    "address": "123 Freeman St, Unit 2 & G-L",
    "parcel_id": "026-01-14",
    "owner1": "CHIU, GORDON",
    "owner2": "CHEUNG, MEGAN C",
    "current_taxes": 9007.1,
    "new_taxes_no_override": 9396.21,
    "override_total_1": 9662.82,
    "override_increase_1": 266.61
  },
  {
    "#": "123 Freeman St, Unit 2A (026-01-15)",
    "$": 810700,
    "address": "123 Freeman St, Unit 2A",
    "parcel_id": "026-01-15",
    "owner1": "DAUBER TRS, EDWARD J & CHERYL S",
    "owner2": "",
    "current_taxes": 8301.57,
    "new_taxes_no_override": 8660.2,
    "override_total_1": 8905.92,
    "override_increase_1": 245.73
  },
  {
    "#": "123 Freeman St, Unit 3&Gar G (026-01-16)",
    "$": 896200,
    "address": "123 Freeman St, Unit 3&Gar G",
    "parcel_id": "026-01-16",
    "owner1": "WANG, CHARLES",
    "owner2": "",
    "current_taxes": 5542.15,
    "new_taxes_no_override": 5781.57,
    "override_total_1": 5945.62,
    "override_increase_1": 164.05
  },
  {
    "#": "123 Freeman St, Unit 3A & G-D1 (026-01-17)",
    "$": 951900,
    "address": "123 Freeman St, Unit 3A & G-D1",
    "parcel_id": "026-01-17",
    "owner1": "WILHELM TRS, BARBARA B",
    "owner2": "",
    "current_taxes": 6112.52,
    "new_taxes_no_override": 6376.58,
    "override_total_1": 6557.51,
    "override_increase_1": 180.93
  },
  {
    "#": "127 Freeman St, Unit 1 (026-01-18)",
    "$": 668800,
    "address": "127 Freeman St, Unit 1",
    "parcel_id": "026-01-18",
    "owner1": "CARDIN, TRS, CAROLYN-JOY-VALLE C",
    "owner2": "",
    "current_taxes": 6848.51,
    "new_taxes_no_override": 7144.37,
    "override_total_1": 7347.08,
    "override_increase_1": 202.72
  },
  {
    "#": "127 Freeman St, Unit 1A&Gar O (026-01-19)",
    "$": 975700,
    "address": "127 Freeman St, Unit 1A&Gar O",
    "parcel_id": "026-01-19",
    "owner1": "ORETO TR, LEONARD",
    "owner2": "",
    "current_taxes": 6356.23,
    "new_taxes_no_override": 6630.82,
    "override_total_1": 6818.96,
    "override_increase_1": 188.14
  },
  {
    "#": "127 Freeman St, Unit 2 & G-P (026-01-20)",
    "$": 892300,
    "address": "127 Freeman St, Unit 2 & G-P",
    "parcel_id": "026-01-20",
    "owner1": "CAMPOBELLO, MARIE L",
    "owner2": "",
    "current_taxes": 5502.22,
    "new_taxes_no_override": 5739.92,
    "override_total_1": 5902.78,
    "override_increase_1": 162.87
  },
  {
    "#": "127 Freeman St, Unit 2A & P33 (026-01-21)",
    "$": 946000,
    "address": "127 Freeman St, Unit 2A & P33",
    "parcel_id": "026-01-21",
    "owner1": "DBF FREEMAN PROPERTY MANAGEMENT LLC",
    "owner2": "",
    "current_taxes": 9687.04,
    "new_taxes_no_override": 10105.52,
    "override_total_1": 10392.26,
    "override_increase_1": 286.74
  },
  {
    "#": "127 Freeman St, Unit 3 & G-K (026-01-22)",
    "$": 880700,
    "address": "127 Freeman St, Unit 3 & G-K",
    "parcel_id": "026-01-22",
    "owner1": "SPEARS, CRAIG D",
    "owner2": "",
    "current_taxes": 5383.43,
    "new_taxes_no_override": 5615.99,
    "override_total_1": 5775.34,
    "override_increase_1": 159.35
  },
  {
    "#": "127 Freeman St, Unit 3A & G-Q (026-01-23)",
    "$": 960000,
    "address": "127 Freeman St, Unit 3A & G-Q",
    "parcel_id": "026-01-23",
    "owner1": "MINKOFF, MARJORIE S",
    "owner2": "",
    "current_taxes": 6195.47,
    "new_taxes_no_override": 6463.11,
    "override_total_1": 6646.5,
    "override_increase_1": 183.39
  },
  {
    "#": "131 Freeman St, Unit 1 & G-Z (026-01-24)",
    "$": 719900,
    "address": "131 Freeman St, Unit 1 & G-Z",
    "parcel_id": "026-01-24",
    "owner1": "MARGOLIS, JULIE F",
    "owner2": "",
    "current_taxes": 7371.78,
    "new_taxes_no_override": 7690.24,
    "override_total_1": 7908.45,
    "override_increase_1": 218.2
  },
  {
    "#": "131 Freeman St, Unit 1A & G-X (026-01-25)",
    "$": 834100,
    "address": "131 Freeman St, Unit 1A & G-X",
    "parcel_id": "026-01-25",
    "owner1": "BUTT TRS, MOHAMED HANIF & MISHAL",
    "owner2": "IMAAM, MOHAMED AZIZ",
    "current_taxes": 8541.18,
    "new_taxes_no_override": 8910.16,
    "override_total_1": 9162.98,
    "override_increase_1": 252.82
  },
  {
    "#": "131 Freeman St, Unit 2 & G-N (026-01-26)",
    "$": 886100,
    "address": "131 Freeman St, Unit 2 & G-N",
    "parcel_id": "026-01-26",
    "owner1": "DBF PROPERTY MANAGEMENT LLC",
    "owner2": "",
    "current_taxes": 9073.66,
    "new_taxes_no_override": 9465.64,
    "override_total_1": 9734.22,
    "override_increase_1": 268.58
  },
  {
    "#": "131 Freeman St, Unit 2A (026-01-27)",
    "$": 818800,
    "address": "131 Freeman St, Unit 2A",
    "parcel_id": "026-01-27",
    "owner1": "OLAOGHAIRE, LITA",
    "owner2": "",
    "current_taxes": 8384.51,
    "new_taxes_no_override": 8746.72,
    "override_total_1": 8994.9,
    "override_increase_1": 248.18
  },
  {
    "#": "131 Freeman St, Unit 3 & G-D (026-01-28)",
    "$": 886900,
    "address": "131 Freeman St, Unit 3 & G-D",
    "parcel_id": "026-01-28",
    "owner1": "ISHAK, ANTHONY M",
    "owner2": "",
    "current_taxes": 5446.92,
    "new_taxes_no_override": 5682.23,
    "override_total_1": 5843.46,
    "override_increase_1": 161.23
  },
  {
    "#": "131 Freeman St, Unit 3A & G-S (026-01-29)",
    "$": 981000,
    "address": "131 Freeman St, Unit 3A & G-S",
    "parcel_id": "026-01-29",
    "owner1": "JOHNSON, DIANE M & TOM E",
    "owner2": "",
    "current_taxes": 6410.51,
    "new_taxes_no_override": 6687.44,
    "override_total_1": 6877.2,
    "override_increase_1": 189.75
  },
  {
    "#": "135 Freeman St, Unit 1 & G-Y (026-01-30)",
    "$": 709600,
    "address": "135 Freeman St, Unit 1 & G-Y",
    "parcel_id": "026-01-30",
    "owner1": "FUCCI TR, LINDA L",
    "owner2": "",
    "current_taxes": 3631.37,
    "new_taxes_no_override": 3788.25,
    "override_total_1": 3895.73,
    "override_increase_1": 107.49
  },
  {
    "#": "135 Freeman St, Unit 1A & G-W (026-01-31)",
    "$": 981100,
    "address": "135 Freeman St, Unit 1A & G-W",
    "parcel_id": "026-01-31",
    "owner1": "NARDONE, CARMELINA",
    "owner2": "",
    "current_taxes": 6411.53,
    "new_taxes_no_override": 6688.51,
    "override_total_1": 6878.29,
    "override_increase_1": 189.78
  },
  {
    "#": "135 Freeman St, Unit 2 (026-01-32)",
    "$": 725200,
    "address": "135 Freeman St, Unit 2",
    "parcel_id": "026-01-32",
    "owner1": "NESIC, MLADEN",
    "owner2": "ZIVKOVIC-ROTHMAN, MARINA",
    "current_taxes": 3791.11,
    "new_taxes_no_override": 3954.89,
    "override_total_1": 4067.1,
    "override_increase_1": 112.22
  },
  {
    "#": "135 Freeman St, Unit 2A (026-01-33)",
    "$": 818900,
    "address": "135 Freeman St, Unit 2A",
    "parcel_id": "026-01-33",
    "owner1": "BROWN ET AL, ALLYSON & WILLIAM J B &  NATALIE",
    "owner2": "",
    "current_taxes": 4750.6,
    "new_taxes_no_override": 4955.83,
    "override_total_1": 5096.44,
    "override_increase_1": 140.62
  },
  {
    "#": "135 Freeman St, Unit 3& G-V (026-01-34)",
    "$": 867100,
    "address": "135 Freeman St, Unit 3& G-V",
    "parcel_id": "026-01-34",
    "owner1": "NGAN TR, KAYLA",
    "owner2": "",
    "current_taxes": 8879.1,
    "new_taxes_no_override": 9262.68,
    "override_total_1": 9525.5,
    "override_increase_1": 262.82
  },
  {
    "#": "135 Freeman St, Unit 3A (026-01-35)",
    "$": 946100,
    "address": "135 Freeman St, Unit 3A",
    "parcel_id": "026-01-35",
    "owner1": "UNGLAUB, JONATHAN W",
    "owner2": "SUGIYAMA, NAOKO",
    "current_taxes": 6053.13,
    "new_taxes_no_override": 6314.63,
    "override_total_1": 6493.8,
    "override_increase_1": 179.17
  },
  {
    "#": "137 Freeman St, Unit 1 (026-01-36)",
    "$": 668800,
    "address": "137 Freeman St, Unit 1",
    "parcel_id": "026-01-36",
    "owner1": "JUNG, JADYN",
    "owner2": "",
    "current_taxes": 6848.51,
    "new_taxes_no_override": 7144.37,
    "override_total_1": 7347.08,
    "override_increase_1": 202.72
  },
  {
    "#": "137 Freeman St, Unit 1A&G-U (026-01-37)",
    "$": 981000,
    "address": "137 Freeman St, Unit 1A&G-U",
    "parcel_id": "026-01-37",
    "owner1": "MURRAY, IAIN",
    "owner2": "ETSON, CANDICE M",
    "current_taxes": 10045.44,
    "new_taxes_no_override": 10479.4,
    "override_total_1": 10776.75,
    "override_increase_1": 297.35
  },
  {
    "#": "137 Freeman St, Unit 2 & G-A1 (026-01-38)",
    "$": 892400,
    "address": "137 Freeman St, Unit 2 & G-A1",
    "parcel_id": "026-01-38",
    "owner1": "STRAZDIS, LUCIUS",
    "owner2": "JUODAITIS, VIDA",
    "current_taxes": 9138.18,
    "new_taxes_no_override": 9532.95,
    "override_total_1": 9803.44,
    "override_increase_1": 270.49
  },
  {
    "#": "137 Freeman St, Unit 2A (026-01-39)",
    "$": 969300,
    "address": "137 Freeman St, Unit 2A",
    "parcel_id": "026-01-39",
    "owner1": "IKEMOTO, TOSHIKO",
    "owner2": "",
    "current_taxes": 6290.7,
    "new_taxes_no_override": 6562.46,
    "override_total_1": 6748.66,
    "override_increase_1": 186.2
  },
  {
    "#": "137 Freeman St, Unit 3 (026-01-40)",
    "$": 714600,
    "address": "137 Freeman St, Unit 3",
    "parcel_id": "026-01-40",
    "owner1": "BARRINGER, MARGARET A",
    "owner2": "",
    "current_taxes": 3682.57,
    "new_taxes_no_override": 3841.66,
    "override_total_1": 3950.66,
    "override_increase_1": 109.0
  },
  {
    "#": "137 Freeman St, Unit 3A & G-T (026-01-41)",
    "$": 920100,
    "address": "137 Freeman St, Unit 3A & G-T",
    "parcel_id": "026-01-41",
    "owner1": "FITZGERALD TRS, NORMAN P & NATALIE A",
    "owner2": "",
    "current_taxes": 9421.82,
    "new_taxes_no_override": 9828.84,
    "override_total_1": 10107.73,
    "override_increase_1": 278.89
  },
  {
    "#": "143 Freeman St (026-08-09)",
    "$": 5508400,
    "address": "143 Freeman St",
    "parcel_id": "026-08-09",
    "owner1": "FREEMAN APARTMENTS LP",
    "owner2": "",
    "current_taxes": 56406.02,
    "new_taxes_no_override": 58842.76,
    "override_total_1": 60512.38,
    "override_increase_1": 1669.62
  },
  {
    "#": "175 Freeman St (024-01-00)",
    "$": 236704600,
    "address": "175 Freeman St",
    "parcel_id": "024-01-00",
    "owner1": "HAMILTON PARK TOWERS LLC",
    "owner2": "",
    "current_taxes": 2423855.1,
    "new_taxes_no_override": 2528565.64,
    "override_total_1": 2600311.75,
    "override_increase_1": 71746.11
  },
  {
    "#": "200 Freeman St, Unit 1 (036-02-01)",
    "$": 1296300,
    "address": "200 Freeman St, Unit 1",
    "parcel_id": "036-02-01",
    "owner1": "SZTUK, STEPHEN JR",
    "owner2": "DONAHUE, ELIZABETH",
    "current_taxes": 9639.18,
    "new_taxes_no_override": 10055.59,
    "override_total_1": 10340.91,
    "override_increase_1": 285.32
  },
  {
    "#": "200 Freeman St, Unit 2 (036-02-02)",
    "$": 1060200,
    "address": "200 Freeman St, Unit 2",
    "parcel_id": "036-02-02",
    "owner1": "200 FREEMAN 2 LLC",
    "owner2": "",
    "current_taxes": 10856.45,
    "new_taxes_no_override": 11325.45,
    "override_total_1": 11646.8,
    "override_increase_1": 321.35
  },
  {
    "#": "200 Freeman St, Unit 3 (036-02-03)",
    "$": 1124100,
    "address": "200 Freeman St, Unit 3",
    "parcel_id": "036-02-03",
    "owner1": "FERDINANDT, IMMO",
    "owner2": "",
    "current_taxes": 7875.85,
    "new_taxes_no_override": 8216.09,
    "override_total_1": 8449.21,
    "override_increase_1": 233.13
  },
  {
    "#": "201 Freeman St, Unit A1& G15 16 (027-01-51)",
    "$": 3601700,
    "address": "201 Freeman St, Unit A1& G15 16",
    "parcel_id": "027-01-51",
    "owner1": "BURLEY TR, ALICE D",
    "owner2": "",
    "current_taxes": 36881.41,
    "new_taxes_no_override": 38474.69,
    "override_total_1": 39566.38,
    "override_increase_1": 1091.69
  },
  {
    "#": "201 Freeman St, Unit A2&G21 22 (027-01-52)",
    "$": 2278300,
    "address": "201 Freeman St, Unit A2&G21 22",
    "parcel_id": "027-01-52",
    "owner1": "SULLIVAN TRS, DAVID G",
    "owner2": "NUSCHER, DAVID T",
    "current_taxes": 19694.86,
    "new_taxes_no_override": 20545.68,
    "override_total_1": 21128.65,
    "override_increase_1": 582.97
  },
  {
    "#": "201 Freeman St, Unit A3& G13 14 (027-01-53)",
    "$": 2600400,
    "address": "201 Freeman St, Unit A3& G13 14",
    "parcel_id": "027-01-53",
    "owner1": "FROLKIS, JOSEPH P",
    "owner2": "OVERMOYER, BETH A",
    "current_taxes": 22993.16,
    "new_taxes_no_override": 23986.46,
    "override_total_1": 24667.06,
    "override_increase_1": 680.6
  },
  {
    "#": "201 Freeman St, Unit A4& G11-12 (027-01-54)",
    "$": 2301400,
    "address": "201 Freeman St, Unit A4& G11-12",
    "parcel_id": "027-01-54",
    "owner1": "SANTOS, MARIO & RUTE",
    "owner2": "",
    "current_taxes": 19931.4,
    "new_taxes_no_override": 20792.44,
    "override_total_1": 21382.41,
    "override_increase_1": 589.97
  },
  {
    "#": "201 Freeman St, Unit A5&G9 G10 (027-01-55)",
    "$": 2597700,
    "address": "201 Freeman St, Unit A5&G9 G10",
    "parcel_id": "027-01-55",
    "owner1": "FOSTER TRS, BRETT A & OUIDA A",
    "owner2": "",
    "current_taxes": 22965.51,
    "new_taxes_no_override": 23957.62,
    "override_total_1": 24637.4,
    "override_increase_1": 679.78
  },
  {
    "#": "201 Freeman St, Unit A6&G48 49 (027-01-56)",
    "$": 2251300,
    "address": "201 Freeman St, Unit A6&G48 49",
    "parcel_id": "027-01-56",
    "owner1": "MEHTA REVOCABLE TRUST, NISHA",
    "owner2": "",
    "current_taxes": 23053.31,
    "new_taxes_no_override": 24049.21,
    "override_total_1": 24731.59,
    "override_increase_1": 682.38
  },
  {
    "#": "201 Freeman St, Unit A7& G50 51 (027-01-57)",
    "$": 2249200,
    "address": "201 Freeman St, Unit A7& G50 51",
    "parcel_id": "027-01-57",
    "owner1": "THE MEHTA FAMILY LLC",
    "owner2": "",
    "current_taxes": 23031.81,
    "new_taxes_no_override": 24026.78,
    "override_total_1": 24708.53,
    "override_increase_1": 681.74
  },
  {
    "#": "201 Freeman St, Unit A8&G55 G56 (027-01-58)",
    "$": 2984400,
    "address": "201 Freeman St, Unit A8&G55 G56",
    "parcel_id": "027-01-58",
    "owner1": "HUA, XIANGHONG",
    "owner2": "",
    "current_taxes": 30560.26,
    "new_taxes_no_override": 31880.46,
    "override_total_1": 32785.05,
    "override_increase_1": 904.58
  },
  {
    "#": "201 Freeman St, Unit A9&G52 53 (027-01-59)",
    "$": 2273500,
    "address": "201 Freeman St, Unit A9&G52 53",
    "parcel_id": "027-01-59",
    "owner1": "BERRY, LORI ABRAMS & JEFFREY M",
    "owner2": "",
    "current_taxes": 19645.71,
    "new_taxes_no_override": 20494.4,
    "override_total_1": 21075.92,
    "override_increase_1": 581.51
  },
  {
    "#": "202 Freeman St (036-01-02)",
    "$": 1800500,
    "address": "202 Freeman St",
    "parcel_id": "036-01-02",
    "owner1": "CHEN, EILEEN",
    "owner2": "MEI, MARVIN",
    "current_taxes": 14802.19,
    "new_taxes_no_override": 15441.64,
    "override_total_1": 15879.79,
    "override_increase_1": 438.14
  },
  {
    "#": "206 Freeman St (036-01-01)",
    "$": 1957400,
    "address": "206 Freeman St",
    "parcel_id": "036-01-01",
    "owner1": "POWERS, JOHN E & JULIANN",
    "owner2": "",
    "current_taxes": 16408.84,
    "new_taxes_no_override": 17117.7,
    "override_total_1": 17603.4,
    "override_increase_1": 485.7
  },
  {
    "#": "208 Freeman St (036-01-00)",
    "$": 1784800,
    "address": "208 Freeman St",
    "parcel_id": "036-01-00",
    "owner1": "SHAMOONI, MANSOUR & VICTORIA&AFSHIN",
    "owner2": "",
    "current_taxes": 18276.35,
    "new_taxes_no_override": 19065.89,
    "override_total_1": 19606.87,
    "override_increase_1": 540.98
  },
  {
    "#": "214 Freeman St (035-15-00)",
    "$": 2676800,
    "address": "214 Freeman St",
    "parcel_id": "035-15-00",
    "owner1": "DEAN ROAD COMPANY LLC",
    "owner2": "",
    "current_taxes": 27410.43,
    "new_taxes_no_override": 28594.56,
    "override_total_1": 29405.91,
    "override_increase_1": 811.35
  },
  {
    "#": "217 Freeman St (027-04-00)",
    "$": 2749900,
    "address": "217 Freeman St",
    "parcel_id": "027-04-00",
    "owner1": "GODFRIED FEINSTEIN, SUSAN",
    "owner2": "",
    "current_taxes": 24524.04,
    "new_taxes_no_override": 25583.48,
    "override_total_1": 26309.39,
    "override_increase_1": 725.91
  },
  {
    "#": "218 Freeman St, Unit 1 & P4 (035-14-01)",
    "$": 1096600,
    "address": "218 Freeman St, Unit 1 & P4",
    "parcel_id": "035-14-01",
    "owner1": "RODRIGUEZ-RIVERA, FRANCES P",
    "owner2": "NEEL, ANDREW J",
    "current_taxes": 7594.25,
    "new_taxes_no_override": 7922.32,
    "override_total_1": 8147.11,
    "override_increase_1": 224.79
  },
  {
    "#": "218 Freeman St, Unit 2 & P2 (035-14-02)",
    "$": 1186300,
    "address": "218 Freeman St, Unit 2 & P2",
    "parcel_id": "035-14-02",
    "owner1": "NORMAN-SALAKO, TITILOLA",
    "owner2": "DICKINSON, PAUL W",
    "current_taxes": 8512.78,
    "new_taxes_no_override": 8880.53,
    "override_total_1": 9132.51,
    "override_increase_1": 251.98
  },
  {
    "#": "218 Freeman St, Unit 3 & P1 & P3 (035-14-03)",
    "$": 1131600,
    "address": "218 Freeman St, Unit 3 & P1 & P3",
    "parcel_id": "035-14-03",
    "owner1": "COLLINS, ROSE M",
    "owner2": "",
    "current_taxes": 11587.58,
    "new_taxes_no_override": 12088.16,
    "override_total_1": 12431.16,
    "override_increase_1": 342.99
  },
  {
    "#": "218 Freeman St, Unit P5 (035-14-09)",
    "$": 49100,
    "address": "218 Freeman St, Unit P5",
    "parcel_id": "035-14-09",
    "owner1": "218P56789 FREEMAN ST LLC",
    "owner2": "",
    "current_taxes": 502.78,
    "new_taxes_no_override": 524.5,
    "override_total_1": 539.38,
    "override_increase_1": 14.88
  },
  {
    "#": "218 Freeman St, Unit P6 (035-14-05)",
    "$": 53900,
    "address": "218 Freeman St, Unit P6",
    "parcel_id": "035-14-05",
    "owner1": "218P56789 FREEMAN ST LLC",
    "owner2": "",
    "current_taxes": 551.94,
    "new_taxes_no_override": 575.78,
    "override_total_1": 592.12,
    "override_increase_1": 16.34
  },
  {
    "#": "218 Freeman St, Unit P7 (035-14-06)",
    "$": 48300,
    "address": "218 Freeman St, Unit P7",
    "parcel_id": "035-14-06",
    "owner1": "218P56789 FREEMAN ST LLC",
    "owner2": "",
    "current_taxes": 494.59,
    "new_taxes_no_override": 515.96,
    "override_total_1": 530.6,
    "override_increase_1": 14.64
  },
  {
    "#": "218 Freeman St, Unit P8 (035-14-07)",
    "$": 48300,
    "address": "218 Freeman St, Unit P8",
    "parcel_id": "035-14-07",
    "owner1": "218P56789 FREEMAN ST LLC",
    "owner2": "",
    "current_taxes": 494.59,
    "new_taxes_no_override": 515.96,
    "override_total_1": 530.6,
    "override_increase_1": 14.64
  },
  {
    "#": "218 Freeman St, Unit P9 (035-14-08)",
    "$": 48300,
    "address": "218 Freeman St, Unit P9",
    "parcel_id": "035-14-08",
    "owner1": "218P56789 FREEMAN ST LLC",
    "owner2": "",
    "current_taxes": 494.59,
    "new_taxes_no_override": 515.96,
    "override_total_1": 530.6,
    "override_increase_1": 14.64
  },
  {
    "#": "219 Freeman St (027-05-00)",
    "$": 2365800,
    "address": "219 Freeman St",
    "parcel_id": "027-05-00",
    "owner1": "ELINSON TR, HELEN Z",
    "owner2": "",
    "current_taxes": 20590.86,
    "new_taxes_no_override": 21480.39,
    "override_total_1": 22089.87,
    "override_increase_1": 609.49
  },
  {
    "#": "221 Freeman St, Unit 221 (027-06-01)",
    "$": 2081500,
    "address": "221 Freeman St, Unit 221",
    "parcel_id": "027-06-01",
    "owner1": "SOIFFER, ARIEL J",
    "owner2": "GARCIA SOIFFER, GEORGINA E",
    "current_taxes": 17679.63,
    "new_taxes_no_override": 18443.39,
    "override_total_1": 18966.71,
    "override_increase_1": 523.32
  },
  {
    "#": "221 Freeman St, Unit 223 (027-06-02)",
    "$": 2088300,
    "address": "221 Freeman St, Unit 223",
    "parcel_id": "027-06-02",
    "owner1": "PLANTS, TODD & TRACY COOGAN",
    "owner2": "",
    "current_taxes": 17749.26,
    "new_taxes_no_override": 18516.03,
    "override_total_1": 19041.41,
    "override_increase_1": 525.38
  },
  {
    "#": "222 Freeman St (035-13-00)",
    "$": 3450200,
    "address": "222 Freeman St",
    "parcel_id": "035-13-00",
    "owner1": "222 FREEMAN STREET LLC",
    "owner2": "",
    "current_taxes": 35330.05,
    "new_taxes_no_override": 36856.31,
    "override_total_1": 37902.08,
    "override_increase_1": 1045.77
  },
  {
    "#": "229 Freeman St, Unit 229-1&P27 (027-12-01)",
    "$": 1063200,
    "address": "229 Freeman St, Unit 229-1&P27",
    "parcel_id": "027-12-01",
    "owner1": "SAXE, CHRISTOPHER D",
    "owner2": "SAXE-VOORNHOUT, JOHANNA",
    "current_taxes": 7252.23,
    "new_taxes_no_override": 7565.53,
    "override_total_1": 7780.19,
    "override_increase_1": 214.67
  },
  {
    "#": "229 Freeman St, Unit 229-2&P6 (027-12-02)",
    "$": 895800,
    "address": "229 Freeman St, Unit 229-2&P6",
    "parcel_id": "027-12-02",
    "owner1": "CED BROOKLINE LLC",
    "owner2": "",
    "current_taxes": 9172.99,
    "new_taxes_no_override": 9569.26,
    "override_total_1": 9840.78,
    "override_increase_1": 271.52
  },
  {
    "#": "229 Freeman St, Unit 229-3& P1 (027-12-03)",
    "$": 918600,
    "address": "229 Freeman St, Unit 229-3& P1",
    "parcel_id": "027-12-03",
    "owner1": "SHAN, ZHIFANG",
    "owner2": "LI, RANYI",
    "current_taxes": 9406.46,
    "new_taxes_no_override": 9812.82,
    "override_total_1": 10091.25,
    "override_increase_1": 278.43
  },
  {
    "#": "229 Freeman St, Unit 229-4&P3 (027-12-04)",
    "$": 963200,
    "address": "229 Freeman St, Unit 229-4&P3",
    "parcel_id": "027-12-04",
    "owner1": "KING, ROBYN",
    "owner2": "HUFFMAN, MATHEW",
    "current_taxes": 6228.23,
    "new_taxes_no_override": 6497.29,
    "override_total_1": 6681.65,
    "override_increase_1": 184.36
  },
  {
    "#": "229 Freeman St, Unit 229-5&P8 (027-12-05)",
    "$": 912400,
    "address": "229 Freeman St, Unit 229-5&P8",
    "parcel_id": "027-12-05",
    "owner1": "DONAHUE, KIELAN HERTHA",
    "owner2": "TU, KAREN YIN",
    "current_taxes": 5708.04,
    "new_taxes_no_override": 5954.63,
    "override_total_1": 6123.59,
    "override_increase_1": 168.96
  },
  {
    "#": "229 Freeman St, Unit 229-6&P12 (027-12-06)",
    "$": 939500,
    "address": "229 Freeman St, Unit 229-6&P12",
    "parcel_id": "027-12-06",
    "owner1": "SAXENA, SAPNA",
    "owner2": "",
    "current_taxes": 9620.48,
    "new_taxes_no_override": 10036.08,
    "override_total_1": 10320.85,
    "override_increase_1": 284.77
  },
  {
    "#": "230 Freeman St, Unit 2 (035-12-02)",
    "$": 1593600,
    "address": "230 Freeman St, Unit 2",
    "parcel_id": "035-12-02",
    "owner1": "WONG, DAVID",
    "owner2": "PURUSHOTHAMAN, PADMINI",
    "current_taxes": 12683.53,
    "new_taxes_no_override": 13231.46,
    "override_total_1": 13606.89,
    "override_increase_1": 375.43
  },
  {
    "#": "231 Freeman St, Unit 231-1 &P26 (027-12-07)",
    "$": 1062300,
    "address": "231 Freeman St, Unit 231-1 &P26",
    "parcel_id": "027-12-07",
    "owner1": "NGAI, HOWARD & GWENDOLYN A",
    "owner2": "",
    "current_taxes": 10877.95,
    "new_taxes_no_override": 11347.88,
    "override_total_1": 11669.86,
    "override_increase_1": 321.99
  },
  {
    "#": "231 Freeman St, Unit 231-2 &P16 (027-12-08)",
    "$": 843900,
    "address": "231 Freeman St, Unit 231-2 &P16",
    "parcel_id": "027-12-08",
    "owner1": "YE, LIQING",
    "owner2": "",
    "current_taxes": 5006.6,
    "new_taxes_no_override": 5222.89,
    "override_total_1": 5371.08,
    "override_increase_1": 148.2
  },
  {
    "#": "231 Freeman St, Unit 231-3 (027-12-09)",
    "$": 895400,
    "address": "231 Freeman St, Unit 231-3",
    "parcel_id": "027-12-09",
    "owner1": "BUSSIERE, WILLIAM J JR & BRIDGET M F",
    "owner2": "",
    "current_taxes": 5533.96,
    "new_taxes_no_override": 5773.03,
    "override_total_1": 5936.83,
    "override_increase_1": 163.81
  },
  {
    "#": "231 Freeman St, Unit 231-4 (027-12-10)",
    "$": 901600,
    "address": "231 Freeman St, Unit 231-4",
    "parcel_id": "027-12-10",
    "owner1": "LEE, FRANK W & MARIE K",
    "owner2": "",
    "current_taxes": 9232.38,
    "new_taxes_no_override": 9631.22,
    "override_total_1": 9904.5,
    "override_increase_1": 273.28
  },
  {
    "#": "231 Freeman St, Unit 231-5 P22 (027-12-11)",
    "$": 901600,
    "address": "231 Freeman St, Unit 231-5 P22",
    "parcel_id": "027-12-11",
    "owner1": "DESAUTELS, KSENIA P",
    "owner2": "",
    "current_taxes": 5597.45,
    "new_taxes_no_override": 5839.26,
    "override_total_1": 6004.94,
    "override_increase_1": 165.68
  },
  {
    "#": "231 Freeman St, Unit 231-6 P23 (027-12-12)",
    "$": 901600,
    "address": "231 Freeman St, Unit 231-6 P23",
    "parcel_id": "027-12-12",
    "owner1": "AYALON, RIVKA & NIR",
    "owner2": "",
    "current_taxes": 9232.38,
    "new_taxes_no_override": 9631.22,
    "override_total_1": 9904.5,
    "override_increase_1": 273.28
  },
  {
    "#": "233 Freeman St, Unit 233-1 (027-12-13)",
    "$": 1005600,
    "address": "233 Freeman St, Unit 233-1",
    "parcel_id": "027-12-13",
    "owner1": "LI TR, YING",
    "owner2": "",
    "current_taxes": 10297.34,
    "new_taxes_no_override": 10742.19,
    "override_total_1": 11046.99,
    "override_increase_1": 304.8
  },
  {
    "#": "233 Freeman St, Unit 233-2&P2 (027-12-14)",
    "$": 846000,
    "address": "233 Freeman St, Unit 233-2&P2",
    "parcel_id": "027-12-14",
    "owner1": "ZUCK , JILLIAN F",
    "owner2": "ZUCK TRS, DWIGHT JONATHAN & SALLY ANN",
    "current_taxes": 5028.11,
    "new_taxes_no_override": 5245.32,
    "override_total_1": 5394.16,
    "override_increase_1": 148.83
  },
  {
    "#": "233 Freeman St, Unit 233-3 P24L (027-12-15)",
    "$": 1033200,
    "address": "233 Freeman St, Unit 233-3 P24L",
    "parcel_id": "027-12-15",
    "owner1": "GUO, SHANSHAN",
    "owner2": "BOGER, QUINTIN",
    "current_taxes": 6945.03,
    "new_taxes_no_override": 7245.06,
    "override_total_1": 7450.63,
    "override_increase_1": 205.57
  },
  {
    "#": "233 Freeman St, Unit 233-4 &P7 (027-12-16)",
    "$": 902200,
    "address": "233 Freeman St, Unit 233-4 &P7",
    "parcel_id": "027-12-16",
    "owner1": "ADLER, SUSAN P",
    "owner2": "",
    "current_taxes": 5603.59,
    "new_taxes_no_override": 5845.67,
    "override_total_1": 6011.53,
    "override_increase_1": 165.87
  },
  {
    "#": "233 Freeman St, Unit 233-5&P15 (027-12-17)",
    "$": 1033200,
    "address": "233 Freeman St, Unit 233-5&P15",
    "parcel_id": "027-12-17",
    "owner1": "YOUSIF, NEDA N",
    "owner2": "",
    "current_taxes": 6945.03,
    "new_taxes_no_override": 7245.06,
    "override_total_1": 7450.63,
    "override_increase_1": 205.57
  },
  {
    "#": "233 Freeman St, Unit 233-6 &P17 (027-12-18)",
    "$": 902200,
    "address": "233 Freeman St, Unit 233-6 &P17",
    "parcel_id": "027-12-18",
    "owner1": "REIDY, MINDA G",
    "owner2": "",
    "current_taxes": 9238.53,
    "new_taxes_no_override": 9637.63,
    "override_total_1": 9911.09,
    "override_increase_1": 273.46
  },
  {
    "#": "233 Freeman St, Unit 233-B (027-12-19)",
    "$": 722000,
    "address": "233 Freeman St, Unit 233-B",
    "parcel_id": "027-12-19",
    "owner1": "COSTA, MARIZA D",
    "owner2": "",
    "current_taxes": 3758.35,
    "new_taxes_no_override": 3920.71,
    "override_total_1": 4031.96,
    "override_increase_1": 111.25
  },
  {
    "#": "235 Freeman St, Unit 235-1&P25T (027-12-20)",
    "$": 1073700,
    "address": "235 Freeman St, Unit 235-1&P25T",
    "parcel_id": "027-12-20",
    "owner1": "SHERRY, ROBERT F",
    "owner2": "",
    "current_taxes": 7359.75,
    "new_taxes_no_override": 7677.69,
    "override_total_1": 7895.54,
    "override_increase_1": 217.85
  },
  {
    "#": "235 Freeman St, Unit 235-2 & P5 (027-12-21)",
    "$": 897400,
    "address": "235 Freeman St, Unit 235-2 & P5",
    "parcel_id": "027-12-21",
    "owner1": "HANKEN, JOY B",
    "owner2": "",
    "current_taxes": 5554.44,
    "new_taxes_no_override": 5794.39,
    "override_total_1": 5958.8,
    "override_increase_1": 164.41
  },
  {
    "#": "235 Freeman St, Unit 235-3 P22 (027-12-22)",
    "$": 891400,
    "address": "235 Freeman St, Unit 235-3 P22",
    "parcel_id": "027-12-22",
    "owner1": "ZHAO, BO",
    "owner2": "ZENG, QINGLIN",
    "current_taxes": 9127.94,
    "new_taxes_no_override": 9522.27,
    "override_total_1": 9792.45,
    "override_increase_1": 270.19
  },
  {
    "#": "235 Freeman St, Unit 235-4 &P20 (027-12-23)",
    "$": 962400,
    "address": "235 Freeman St, Unit 235-4 &P20",
    "parcel_id": "027-12-23",
    "owner1": "YANG, GUANG",
    "owner2": "",
    "current_taxes": 6220.04,
    "new_taxes_no_override": 6488.75,
    "override_total_1": 6672.86,
    "override_increase_1": 184.11
  },
  {
    "#": "235 Freeman St, Unit 235-5 &P19 (027-12-24)",
    "$": 907000,
    "address": "235 Freeman St, Unit 235-5 &P19",
    "parcel_id": "027-12-24",
    "owner1": "CHAN, BARDEN",
    "owner2": "",
    "current_taxes": 5652.75,
    "new_taxes_no_override": 5896.95,
    "override_total_1": 6064.27,
    "override_increase_1": 167.32
  },
  {
    "#": "235 Freeman St, Unit 235-6&P18 (027-12-25)",
    "$": 945400,
    "address": "235 Freeman St, Unit 235-6&P18",
    "parcel_id": "027-12-25",
    "owner1": "SUN TR, YUN",
    "owner2": "",
    "current_taxes": 9680.9,
    "new_taxes_no_override": 10099.11,
    "override_total_1": 10385.67,
    "override_increase_1": 286.55
  },
  {
    "#": "237 Freeman St (027-15-16)",
    "$": 6194400,
    "address": "237 Freeman St",
    "parcel_id": "027-15-16",
    "owner1": "237 FREEMAN LLC",
    "owner2": "C/O KINROSS REAL ESTATE",
    "current_taxes": 63430.66,
    "new_taxes_no_override": 66170.86,
    "override_total_1": 68048.41,
    "override_increase_1": 1877.55
  },
  {
    "#": "3 Fuller St, Unit 1 (079-14-06)",
    "$": 572000,
    "address": "3 Fuller St, Unit 1",
    "parcel_id": "079-14-06",
    "owner1": "PUNTELLI, KATHRYN",
    "owner2": "",
    "current_taxes": 2222.35,
    "new_taxes_no_override": 2318.36,
    "override_total_1": 2384.14,
    "override_increase_1": 65.78
  },
  {
    "#": "3 Fuller St, Unit 2 (079-14-01)",
    "$": 705800,
    "address": "3 Fuller St, Unit 2",
    "parcel_id": "079-14-01",
    "owner1": "COTE, MATTHEW",
    "owner2": "",
    "current_taxes": 3592.46,
    "new_taxes_no_override": 3747.65,
    "override_total_1": 3853.99,
    "override_increase_1": 106.34
  },
  {
    "#": "3 Fuller St, Unit 3 (079-14-02)",
    "$": 772400,
    "address": "3 Fuller St, Unit 3",
    "parcel_id": "079-14-02",
    "owner1": "SUBEDAR, NATASHA",
    "owner2": "HAKSAR, SIDHARTH J N",
    "current_taxes": 4274.44,
    "new_taxes_no_override": 4459.1,
    "override_total_1": 4585.62,
    "override_increase_1": 126.52
  },
  {
    "#": "3 Fuller St, Unit 4 (079-14-03)",
    "$": 740100,
    "address": "3 Fuller St, Unit 4",
    "parcel_id": "079-14-03",
    "owner1": "SON, KRISTA",
    "owner2": "",
    "current_taxes": 3943.69,
    "new_taxes_no_override": 4114.06,
    "override_total_1": 4230.79,
    "override_increase_1": 116.73
  },
  {
    "#": "3 Fuller St, Unit 5 (079-14-04)",
    "$": 764200,
    "address": "3 Fuller St, Unit 5",
    "parcel_id": "079-14-04",
    "owner1": "STRICK, MONA",
    "owner2": "",
    "current_taxes": 7825.41,
    "new_taxes_no_override": 8163.47,
    "override_total_1": 8395.1,
    "override_increase_1": 231.63
  },
  {
    "#": "3 Fuller St, Unit 6 (079-14-05)",
    "$": 755700,
    "address": "3 Fuller St, Unit 6",
    "parcel_id": "079-14-05",
    "owner1": "KIM, JISOO",
    "owner2": "",
    "current_taxes": 4103.43,
    "new_taxes_no_override": 4280.7,
    "override_total_1": 4402.16,
    "override_increase_1": 121.46
  },
  {
    "#": "4 Fuller St (077-23-00)",
    "$": 3732600,
    "address": "4 Fuller St",
    "parcel_id": "077-23-00",
    "owner1": "WONG TRS, LAP BOON & WAI LING",
    "owner2": "",
    "current_taxes": 38221.82,
    "new_taxes_no_override": 39873.0,
    "override_total_1": 41004.37,
    "override_increase_1": 1131.37
  },
  {
    "#": "5 Fuller St, Unit 1 (079-15-01)",
    "$": 1414800,
    "address": "5 Fuller St, Unit 1",
    "parcel_id": "079-15-01",
    "owner1": "STEELE, EMILIE D",
    "owner2": "",
    "current_taxes": 10852.62,
    "new_taxes_no_override": 11321.45,
    "override_total_1": 11642.69,
    "override_increase_1": 321.24
  },
  {
    "#": "5 Fuller St, Unit 2 & Pk 1A (079-15-02)",
    "$": 802300,
    "address": "5 Fuller St, Unit 2 & Pk 1A",
    "parcel_id": "079-15-02",
    "owner1": "WONG, JEFFREY YEE & CALVIN Y F",
    "owner2": "",
    "current_taxes": 4580.62,
    "new_taxes_no_override": 4778.5,
    "override_total_1": 4914.09,
    "override_increase_1": 135.59
  },
  {
    "#": "5 Fuller St, Unit 3 (079-15-03)",
    "$": 390800,
    "address": "5 Fuller St, Unit 3",
    "parcel_id": "079-15-03",
    "owner1": "COHEN, JOSEPH",
    "owner2": "C/O JOSH COHEN, SASSON",
    "current_taxes": 4001.79,
    "new_taxes_no_override": 4174.67,
    "override_total_1": 4293.12,
    "override_increase_1": 118.45
  },
  {
    "#": "5 Fuller St, Unit 4 (079-15-04)",
    "$": 704400,
    "address": "5 Fuller St, Unit 4",
    "parcel_id": "079-15-04",
    "owner1": "MYERS, CELESTINE",
    "owner2": "",
    "current_taxes": 7213.06,
    "new_taxes_no_override": 7524.66,
    "override_total_1": 7738.17,
    "override_increase_1": 213.51
  },
  {
    "#": "5 Fuller St, Unit 5 (079-15-05)",
    "$": 804000,
    "address": "5 Fuller St, Unit 5",
    "parcel_id": "079-15-05",
    "owner1": "COHEN, SASSON",
    "owner2": "C/O JOSH COHEN",
    "current_taxes": 8232.96,
    "new_taxes_no_override": 8588.62,
    "override_total_1": 8832.32,
    "override_increase_1": 243.7
  },
  {
    "#": "5 Fuller St, Unit 5B (079-15-08)",
    "$": 509700,
    "address": "5 Fuller St, Unit 5B",
    "parcel_id": "079-15-08",
    "owner1": "SHERMAN, MELISSA",
    "owner2": "C/O CUNNINGHAM",
    "current_taxes": 5219.33,
    "new_taxes_no_override": 5444.81,
    "override_total_1": 5599.3,
    "override_increase_1": 154.49
  },
  {
    "#": "5 Fuller St, Unit 6 (079-15-06)",
    "$": 390800,
    "address": "5 Fuller St, Unit 6",
    "parcel_id": "079-15-06",
    "owner1": "LOPATIN, ALEXANDER",
    "owner2": "",
    "current_taxes": 400.18,
    "new_taxes_no_override": 417.47,
    "override_total_1": 429.31,
    "override_increase_1": 11.85
  },
  {
    "#": "5 Fuller St, Unit 7 (079-15-07)",
    "$": 704400,
    "address": "5 Fuller St, Unit 7",
    "parcel_id": "079-15-07",
    "owner1": "LUCEY, NEIL",
    "owner2": "",
    "current_taxes": 3578.12,
    "new_taxes_no_override": 3732.69,
    "override_total_1": 3838.61,
    "override_increase_1": 105.91
  },
  {
    "#": "6 Fuller St, Unit 1 (077-22-01)",
    "$": 786100,
    "address": "6 Fuller St, Unit 1",
    "parcel_id": "077-22-01",
    "owner1": "MON TRS, PETER & MARY",
    "owner2": "",
    "current_taxes": 4414.73,
    "new_taxes_no_override": 4605.45,
    "override_total_1": 4736.12,
    "override_increase_1": 130.68
  },
  {
    "#": "6 Fuller St, Unit 1A (077-22-02)",
    "$": 534200,
    "address": "6 Fuller St, Unit 1A",
    "parcel_id": "077-22-02",
    "owner1": "MON TRS, PETER & MARY",
    "owner2": "",
    "current_taxes": 5470.21,
    "new_taxes_no_override": 5706.52,
    "override_total_1": 5868.44,
    "override_increase_1": 161.92
  },
  {
    "#": "6 Fuller St, Unit 2 (077-22-03)",
    "$": 1366000,
    "address": "6 Fuller St, Unit 2",
    "parcel_id": "077-22-03",
    "owner1": "MON TR, RICHARD",
    "owner2": "",
    "current_taxes": 13987.84,
    "new_taxes_no_override": 14592.11,
    "override_total_1": 15006.15,
    "override_increase_1": 414.04
  },
  {
    "#": "6 Fuller St, Unit 3 (077-22-04)",
    "$": 1366000,
    "address": "6 Fuller St, Unit 3",
    "parcel_id": "077-22-04",
    "owner1": "MON TR, EL JANE",
    "owner2": "",
    "current_taxes": 10352.91,
    "new_taxes_no_override": 10800.16,
    "override_total_1": 11106.6,
    "override_increase_1": 306.45
  },
  {
    "#": "10 Fuller St, Unit 1 (077-21-02)",
    "$": 1150700,
    "address": "10 Fuller St, Unit 1",
    "parcel_id": "077-21-02",
    "owner1": "KIM, OH MYO & YOONGU",
    "owner2": "",
    "current_taxes": 8148.23,
    "new_taxes_no_override": 8500.23,
    "override_total_1": 8741.42,
    "override_increase_1": 241.19
  },
  {
    "#": "10 Fuller St, Unit 2 (077-21-03)",
    "$": 1322600,
    "address": "10 Fuller St, Unit 2",
    "parcel_id": "077-21-03",
    "owner1": "LEBEL, JENNA",
    "owner2": "",
    "current_taxes": 9908.49,
    "new_taxes_no_override": 10336.54,
    "override_total_1": 10629.83,
    "override_increase_1": 293.29
  },
  {
    "#": "10 Fuller St, Unit 3 (077-21-04)",
    "$": 1350200,
    "address": "10 Fuller St, Unit 3",
    "parcel_id": "077-21-04",
    "owner1": "MONTEMURRO, LUIGI TARANTO",
    "owner2": "ROSSI, PAOLA",
    "current_taxes": 10191.11,
    "new_taxes_no_override": 10631.37,
    "override_total_1": 10933.02,
    "override_increase_1": 301.66
  },
  {
    "#": "10 Fuller St, Unit G (077-21-01)",
    "$": 749300,
    "address": "10 Fuller St, Unit G",
    "parcel_id": "077-21-01",
    "owner1": "LYNCH TRS, WILLIAM JOSEPH",
    "owner2": "FILIPPONE, EMILY ANN",
    "current_taxes": 4037.9,
    "new_taxes_no_override": 4212.34,
    "override_total_1": 4331.86,
    "override_increase_1": 119.52
  },
  {
    "#": "12 Fuller St (077-20-00)",
    "$": 3578600,
    "address": "12 Fuller St",
    "parcel_id": "077-20-00",
    "owner1": "CHAN TR, DAVID C W",
    "owner2": "C/O R BROWN PARTNERS",
    "current_taxes": 36644.86,
    "new_taxes_no_override": 38227.92,
    "override_total_1": 39312.61,
    "override_increase_1": 1084.69
  },
  {
    "#": "16 Fuller St (077-19-00)",
    "$": 3256400,
    "address": "16 Fuller St",
    "parcel_id": "077-19-00",
    "owner1": "WONG, TR, AGNES M L & TINA L",
    "owner2": "LEE, MAY SHANG & LILY M L",
    "current_taxes": 33345.54,
    "new_taxes_no_override": 34786.07,
    "override_total_1": 35773.1,
    "override_increase_1": 987.03
  },
  {
    "#": "18 Fuller St (077-18-00)",
    "$": 3584100,
    "address": "18 Fuller St",
    "parcel_id": "077-18-00",
    "owner1": "MARINELLO, LINDA B",
    "owner2": "GUERRA, MICHAEL J",
    "current_taxes": 36701.18,
    "new_taxes_no_override": 38286.67,
    "override_total_1": 39373.03,
    "override_increase_1": 1086.35
  },
  {
    "#": "20 Fuller St, Unit 20 (077-17-01)",
    "$": 3520100,
    "address": "20 Fuller St, Unit 20",
    "parcel_id": "077-17-01",
    "owner1": "MEANS, TERRY K & MELISSA L",
    "owner2": "",
    "current_taxes": 32410.89,
    "new_taxes_no_override": 33811.04,
    "override_total_1": 34770.4,
    "override_increase_1": 959.36
  },
  {
    "#": "20 Fuller St, Unit 22 (077-17-02)",
    "$": 3524000,
    "address": "20 Fuller St, Unit 22",
    "parcel_id": "077-17-02",
    "owner1": "BOUSCAREN, MICHAEL F & EDITH C",
    "owner2": "",
    "current_taxes": 32450.83,
    "new_taxes_no_override": 33852.71,
    "override_total_1": 34813.25,
    "override_increase_1": 960.54
  },
  {
    "#": "20 Fuller St, Unit 24 (077-17-03)",
    "$": 3408700,
    "address": "20 Fuller St, Unit 24",
    "parcel_id": "077-17-03",
    "owner1": "SOHN TRS, DAECHUL & HYEHYUN",
    "owner2": "",
    "current_taxes": 31270.15,
    "new_taxes_no_override": 32621.02,
    "override_total_1": 33546.62,
    "override_increase_1": 925.6
  },
  {
    "#": "30 Fuller St (077-15-16)",
    "$": 9775600,
    "address": "30 Fuller St",
    "parcel_id": "077-15-16",
    "owner1": "BASILE, ET AL TRS, ROBERT",
    "owner2": "",
    "current_taxes": 100102.14,
    "new_taxes_no_override": 104426.55,
    "override_total_1": 107389.58,
    "override_increase_1": 2963.02
  },
  {
    "#": "38 Fuller St (077-14-00)",
    "$": 2826700,
    "address": "38 Fuller St",
    "parcel_id": "077-14-00",
    "owner1": "SCHLOSSER, RALF W",
    "owner2": "PRABHU, ANJALI",
    "current_taxes": 25310.47,
    "new_taxes_no_override": 26403.88,
    "override_total_1": 27153.07,
    "override_increase_1": 749.19
  },
  {
    "#": "39 Fuller St, Unit 39 (078-20-01)",
    "$": 2743300,
    "address": "39 Fuller St, Unit 39",
    "parcel_id": "078-20-01",
    "owner1": "LEVY, DONALD & NANCY LUBIN",
    "owner2": "",
    "current_taxes": 24456.46,
    "new_taxes_no_override": 25512.98,
    "override_total_1": 26236.89,
    "override_increase_1": 723.91
  },
  {
    "#": "41 Fuller St, Unit 41 (078-20-02)",
    "$": 2323400,
    "address": "41 Fuller St, Unit 41",
    "parcel_id": "078-20-02",
    "owner1": "POPPER, STEPHEN R",
    "owner2": "CHURILLA, GEORGIA L",
    "current_taxes": 20156.68,
    "new_taxes_no_override": 21027.45,
    "override_total_1": 21624.09,
    "override_increase_1": 596.64
  },
  {
    "#": "44 Fuller St (077-13-00)",
    "$": 2333000,
    "address": "44 Fuller St",
    "parcel_id": "077-13-00",
    "owner1": "MAUCH, HAGEN R",
    "owner2": "KANCHANAVANIT, SAVIKA",
    "current_taxes": 20254.99,
    "new_taxes_no_override": 21130.01,
    "override_total_1": 21729.55,
    "override_increase_1": 599.55
  },
  {
    "#": "45 Fuller St (078-21-00)",
    "$": 2656700,
    "address": "45 Fuller St",
    "parcel_id": "078-21-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O FULLER ST PARKING LOT",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "62 Fuller St (066-09-00)",
    "$": 2447900,
    "address": "62 Fuller St",
    "parcel_id": "066-09-00",
    "owner1": "MITCHELL TR, KATHERINE CL",
    "owner2": "",
    "current_taxes": 25066.5,
    "new_taxes_no_override": 26149.37,
    "override_total_1": 26891.34,
    "override_increase_1": 741.97
  },
  {
    "#": "67 Fuller St (064-12-00)",
    "$": 2168800,
    "address": "67 Fuller St",
    "parcel_id": "064-12-00",
    "owner1": "EVANGELAKOS, WILLIAM",
    "owner2": "",
    "current_taxes": 18573.58,
    "new_taxes_no_override": 19375.96,
    "override_total_1": 19925.74,
    "override_increase_1": 549.78
  },
  {
    "#": "68 Fuller St (066-08-00)",
    "$": 2885000,
    "address": "68 Fuller St",
    "parcel_id": "066-08-00",
    "owner1": "AAKALU, ANAJLI G & GIRISH N",
    "owner2": "",
    "current_taxes": 29542.4,
    "new_taxes_no_override": 30818.63,
    "override_total_1": 31693.09,
    "override_increase_1": 874.46
  },
  {
    "#": "73 Fuller St, Unit 1 P-B (064-13-01)",
    "$": 1859900,
    "address": "73 Fuller St, Unit 1 P-B",
    "parcel_id": "064-13-01",
    "owner1": "VELENCHIK, ANN D",
    "owner2": "DOWNES, THOMAS A",
    "current_taxes": 15410.44,
    "new_taxes_no_override": 16076.17,
    "override_total_1": 16532.32,
    "override_increase_1": 456.15
  },
  {
    "#": "73 Fuller St, Unit 2 & P-A (064-13-02)",
    "$": 1937000,
    "address": "73 Fuller St, Unit 2 & P-A",
    "parcel_id": "064-13-02",
    "owner1": "DOBROW, IRA P",
    "owner2": "SENTERS, SIBYL S",
    "current_taxes": 16199.95,
    "new_taxes_no_override": 16899.79,
    "override_total_1": 17379.31,
    "override_increase_1": 479.52
  },
  {
    "#": "74 Fuller St (066-07-00)",
    "$": 2443400,
    "address": "74 Fuller St",
    "parcel_id": "066-07-00",
    "owner1": "PERLER, FRANCINE B",
    "owner2": "",
    "current_taxes": 21385.48,
    "new_taxes_no_override": 22309.33,
    "override_total_1": 22942.34,
    "override_increase_1": 633.01
  },
  {
    "#": "77 Fuller St (064-14-00)",
    "$": 2543700,
    "address": "77 Fuller St",
    "parcel_id": "064-14-00",
    "owner1": "BIGDA, DIANE",
    "owner2": "DOUGLASS, SCOTT",
    "current_taxes": 22412.55,
    "new_taxes_no_override": 23380.77,
    "override_total_1": 24044.18,
    "override_increase_1": 663.41
  },
  {
    "#": "78 Fuller St (066-06-00)",
    "$": 2062700,
    "address": "78 Fuller St",
    "parcel_id": "066-06-00",
    "owner1": "NAKAJIMA TRS, SHIGEHIRO & YASUKO",
    "owner2": "",
    "current_taxes": 21122.05,
    "new_taxes_no_override": 22034.52,
    "override_total_1": 22659.74,
    "override_increase_1": 625.21
  },
  {
    "#": "82 Fuller St, Unit 1 (066-05-03)",
    "$": 1173400,
    "address": "82 Fuller St, Unit 1",
    "parcel_id": "066-05-03",
    "owner1": "BLAKE-MCLAUGHLIN TRS, DORA & JUSTIN",
    "owner2": "",
    "current_taxes": 8380.68,
    "new_taxes_no_override": 8742.73,
    "override_total_1": 8990.79,
    "override_increase_1": 248.07
  },
  {
    "#": "82 Fuller St, Unit 2 (066-05-01)",
    "$": 1413300,
    "address": "82 Fuller St, Unit 2",
    "parcel_id": "066-05-01",
    "owner1": "BLAKE-MCLAUGHLIN TRS, DORA & JUSTIN",
    "owner2": "",
    "current_taxes": 14472.19,
    "new_taxes_no_override": 15097.39,
    "override_total_1": 15525.77,
    "override_increase_1": 428.38
  },
  {
    "#": "82 Fuller St, Unit 3 (066-05-02)",
    "$": 1383400,
    "address": "82 Fuller St, Unit 3",
    "parcel_id": "066-05-02",
    "owner1": "WALLACE, DEBRA KAY & ROBERT IAN",
    "owner2": "",
    "current_taxes": 10531.08,
    "new_taxes_no_override": 10986.02,
    "override_total_1": 11297.74,
    "override_increase_1": 311.72
  },
  {
    "#": "83 Fuller St, Unit 1 (064-15-01)",
    "$": 1737700,
    "address": "83 Fuller St, Unit 1",
    "parcel_id": "064-15-01",
    "owner1": "FELDMAN TRS, SAUL J & DORIS K",
    "owner2": "",
    "current_taxes": 14159.11,
    "new_taxes_no_override": 14770.78,
    "override_total_1": 15189.89,
    "override_increase_1": 419.11
  },
  {
    "#": "83 Fuller St, Unit 2 (064-15-02)",
    "$": 1760800,
    "address": "83 Fuller St, Unit 2",
    "parcel_id": "064-15-02",
    "owner1": "ARMAND TRS, PHILIPPE & WYNNE",
    "owner2": "",
    "current_taxes": 14395.66,
    "new_taxes_no_override": 15017.55,
    "override_total_1": 15443.66,
    "override_increase_1": 426.11
  },
  {
    "#": "84 Fuller St (066-04-00)",
    "$": 2883700,
    "address": "84 Fuller St",
    "parcel_id": "066-04-00",
    "owner1": "LAW TRS, HENRY N & QUEN G",
    "owner2": "",
    "current_taxes": 25894.15,
    "new_taxes_no_override": 27012.78,
    "override_total_1": 27779.24,
    "override_increase_1": 766.47
  },
  {
    "#": "87 Fuller St (064-16-00)",
    "$": 2584800,
    "address": "87 Fuller St",
    "parcel_id": "064-16-00",
    "owner1": "MICHISON, TIMOTHY J",
    "owner2": "FIELD, CHRISTINE",
    "current_taxes": 22833.42,
    "new_taxes_no_override": 23819.82,
    "override_total_1": 24495.69,
    "override_increase_1": 675.87
  },
  {
    "#": "88 Fuller St (066-03-00)",
    "$": 3010100,
    "address": "88 Fuller St",
    "parcel_id": "066-03-00",
    "owner1": "ROSE TRS ET AL, BERNICE & CHARLES M",
    "owner2": "ROSE, MARILYN",
    "current_taxes": 27188.49,
    "new_taxes_no_override": 28363.03,
    "override_total_1": 29167.81,
    "override_increase_1": 804.78
  },
  {
    "#": "90 Fuller St (066-01-01)",
    "$": 3732600,
    "address": "90 Fuller St",
    "parcel_id": "066-01-01",
    "owner1": "IZBICKI TRS, HOWARD",
    "owner2": "",
    "current_taxes": 38221.82,
    "new_taxes_no_override": 39873.0,
    "override_total_1": 41004.37,
    "override_increase_1": 1131.37
  },
  {
    "#": "91 Fuller St (064-17-00)",
    "$": 2476900,
    "address": "91 Fuller St",
    "parcel_id": "064-17-00",
    "owner1": "91 FULLER STREET LLC",
    "owner2": "",
    "current_taxes": 25363.46,
    "new_taxes_no_override": 26459.16,
    "override_total_1": 27209.92,
    "override_increase_1": 750.76
  },
  {
    "#": "93 Fuller St (064-18-00)",
    "$": 2540900,
    "address": "93 Fuller St",
    "parcel_id": "064-18-00",
    "owner1": "93 FULLER STREET LLC",
    "owner2": "",
    "current_taxes": 26018.82,
    "new_taxes_no_override": 27142.83,
    "override_total_1": 27912.99,
    "override_increase_1": 770.16
  },
  {
    "#": "95 Fuller St (064-19-00)",
    "$": 2477200,
    "address": "95 Fuller St",
    "parcel_id": "064-19-00",
    "owner1": "CHIN TRS, JIM K & MUN W",
    "owner2": "",
    "current_taxes": 21731.59,
    "new_taxes_no_override": 22670.39,
    "override_total_1": 23313.65,
    "override_increase_1": 643.26
  },
  {
    "#": "97 Fuller St, Unit 1 (064-20-01)",
    "$": 1438400,
    "address": "97 Fuller St, Unit 1",
    "parcel_id": "064-20-01",
    "owner1": "CHO TRS, WAI MING",
    "owner2": "CHAN, JOHN Y",
    "current_taxes": 11094.28,
    "new_taxes_no_override": 11573.55,
    "override_total_1": 11901.94,
    "override_increase_1": 328.39
  },
  {
    "#": "97 Fuller St, Unit 2 (064-20-02)",
    "$": 1512300,
    "address": "97 Fuller St, Unit 2",
    "parcel_id": "064-20-02",
    "owner1": "GIBBS, JENNIFER LYNN",
    "owner2": "PAGE, JENS EDWARD",
    "current_taxes": 11851.02,
    "new_taxes_no_override": 12362.98,
    "override_total_1": 12713.77,
    "override_increase_1": 350.79
  },
  {
    "#": "97 Fuller St, Unit 3 (064-20-03)",
    "$": 1496500,
    "address": "97 Fuller St, Unit 3",
    "parcel_id": "064-20-03",
    "owner1": "LUXENBERG, BENJAMIN",
    "owner2": "GOLD, NINA B",
    "current_taxes": 11689.23,
    "new_taxes_no_override": 12194.2,
    "override_total_1": 12540.21,
    "override_increase_1": 346.0
  },
  {
    "#": "97 Fuller St, Unit 4 (064-20-04)",
    "$": 668900,
    "address": "97 Fuller St, Unit 4",
    "parcel_id": "064-20-04",
    "owner1": "FULLER STREET MANAGEMENT LLC",
    "owner2": "",
    "current_taxes": 6849.54,
    "new_taxes_no_override": 7145.44,
    "override_total_1": 7348.19,
    "override_increase_1": 202.75
  },
  {
    "#": "98 Fuller St (066-01-00)",
    "$": 2672800,
    "address": "98 Fuller St",
    "parcel_id": "066-01-00",
    "owner1": "BECK, ANDREW",
    "owner2": "BRENNAN-KROHN, THEA",
    "current_taxes": 27369.47,
    "new_taxes_no_override": 28551.83,
    "override_total_1": 29361.97,
    "override_increase_1": 810.14
  },
  {
    "#": "102 Fuller St, Unit 1 (065-22-01)",
    "$": 2009100,
    "address": "102 Fuller St, Unit 1",
    "parcel_id": "065-22-01",
    "owner1": "MESSINA, KATRINA & MICHAEL",
    "owner2": "",
    "current_taxes": 16938.25,
    "new_taxes_no_override": 17669.98,
    "override_total_1": 18171.35,
    "override_increase_1": 501.37
  },
  {
    "#": "102 Fuller St, Unit 2 (065-22-02)",
    "$": 3167100,
    "address": "102 Fuller St, Unit 2",
    "parcel_id": "065-22-02",
    "owner1": "BERNSTEIN, DANIEL",
    "owner2": "",
    "current_taxes": 28796.17,
    "new_taxes_no_override": 30040.16,
    "override_total_1": 30892.53,
    "override_increase_1": 852.37
  },
  {
    "#": "103 Fuller St (063-15-00)",
    "$": 2534300,
    "address": "103 Fuller St",
    "parcel_id": "063-15-00",
    "owner1": "ORWANT, JON & ROBIN L",
    "owner2": "",
    "current_taxes": 22316.3,
    "new_taxes_no_override": 23280.36,
    "override_total_1": 23940.93,
    "override_increase_1": 660.56
  },
  {
    "#": "107 Fuller St (063-16-00)",
    "$": 2021800,
    "address": "107 Fuller St",
    "parcel_id": "063-16-00",
    "owner1": "VEROUGSTRAETE, MARIE-ANNE",
    "owner2": "",
    "current_taxes": 17068.3,
    "new_taxes_no_override": 17805.65,
    "override_total_1": 18310.87,
    "override_increase_1": 505.22
  },
  {
    "#": "108 Fuller St (065-21-00)",
    "$": 2225900,
    "address": "108 Fuller St",
    "parcel_id": "065-21-00",
    "owner1": "MOONEY, STEPHEN E",
    "owner2": "HOWARD, MARY T",
    "current_taxes": 19158.28,
    "new_taxes_no_override": 19985.92,
    "override_total_1": 20553.0,
    "override_increase_1": 567.09
  },
  {
    "#": "111 Fuller St (063-17-00)",
    "$": 2272900,
    "address": "111 Fuller St",
    "parcel_id": "063-17-00",
    "owner1": "AVERY, CHRISTOPHER N",
    "owner2": "",
    "current_taxes": 19639.56,
    "new_taxes_no_override": 20487.99,
    "override_total_1": 21069.32,
    "override_increase_1": 581.33
  },
  {
    "#": "112 Fuller St, Unit 1 (065-20-01)",
    "$": 894400,
    "address": "112 Fuller St, Unit 1",
    "parcel_id": "065-20-01",
    "owner1": "TAUBE, ELI",
    "owner2": "SHEMESH-TAUBE, KEREN",
    "current_taxes": 9158.66,
    "new_taxes_no_override": 9554.31,
    "override_total_1": 9825.41,
    "override_increase_1": 271.1
  },
  {
    "#": "112 Fuller St, Unit 2 (065-20-02)",
    "$": 1199000,
    "address": "112 Fuller St, Unit 2",
    "parcel_id": "065-20-02",
    "owner1": "TAUBE, ELI & KEREN SHEMESH",
    "owner2": "",
    "current_taxes": 8642.83,
    "new_taxes_no_override": 9016.2,
    "override_total_1": 9272.03,
    "override_increase_1": 255.83
  },
  {
    "#": "115 Fuller St (063-18-00)",
    "$": 2573700,
    "address": "115 Fuller St",
    "parcel_id": "063-18-00",
    "owner1": "FINE TRS, JANET E",
    "owner2": "HARDOON TR, LAURENCE E",
    "current_taxes": 22719.75,
    "new_taxes_no_override": 23701.24,
    "override_total_1": 24373.75,
    "override_increase_1": 672.5
  },
  {
    "#": "116 Fuller St (065-19-00)",
    "$": 2428200,
    "address": "116 Fuller St",
    "parcel_id": "065-19-00",
    "owner1": "SHER, MICHAEL S & JULIA B",
    "owner2": "",
    "current_taxes": 24864.77,
    "new_taxes_no_override": 25938.93,
    "override_total_1": 26674.93,
    "override_increase_1": 736.0
  },
  {
    "#": "119 Fuller St, Unit 1 (063-19-01)",
    "$": 1788300,
    "address": "119 Fuller St, Unit 1",
    "parcel_id": "063-19-01",
    "owner1": "TEMPLER, PAMELA H",
    "owner2": "GARON, MICHAEL S",
    "current_taxes": 14677.26,
    "new_taxes_no_override": 15311.32,
    "override_total_1": 15745.76,
    "override_increase_1": 434.45
  },
  {
    "#": "119 Fuller St, Unit 2 (063-19-02)",
    "$": 1787500,
    "address": "119 Fuller St, Unit 2",
    "parcel_id": "063-19-02",
    "owner1": "PARK, HAROLD",
    "owner2": "BOOKBINDER, SARAH R",
    "current_taxes": 14669.07,
    "new_taxes_no_override": 15302.77,
    "override_total_1": 15736.98,
    "override_increase_1": 434.2
  },
  {
    "#": "120 Fuller St (065-18-00)",
    "$": 2420500,
    "address": "120 Fuller St",
    "parcel_id": "065-18-00",
    "owner1": "KUHLMAN, THOMAS & ANJA",
    "owner2": "",
    "current_taxes": 21150.99,
    "new_taxes_no_override": 22064.71,
    "override_total_1": 22690.78,
    "override_increase_1": 626.07
  },
  {
    "#": "123 Fuller St (063-20-00)",
    "$": 1984900,
    "address": "123 Fuller St",
    "parcel_id": "063-20-00",
    "owner1": "123 FULLER LLC",
    "owner2": "",
    "current_taxes": 20325.38,
    "new_taxes_no_override": 21203.44,
    "override_total_1": 21805.07,
    "override_increase_1": 601.63
  },
  {
    "#": "127 Fuller St, Unit 1 P-1 (063-21-03)",
    "$": 1288500,
    "address": "127 Fuller St, Unit 1 P-1",
    "parcel_id": "063-21-03",
    "owner1": "BENTLEY, CHRISTOPHER L",
    "owner2": "",
    "current_taxes": 9559.31,
    "new_taxes_no_override": 9972.27,
    "override_total_1": 10255.23,
    "override_increase_1": 282.96
  },
  {
    "#": "127 Fuller St, Unit 2 (063-21-01)",
    "$": 1352200,
    "address": "127 Fuller St, Unit 2",
    "parcel_id": "063-21-01",
    "owner1": "BOLON, CRAIG & JUDITH Z",
    "owner2": "",
    "current_taxes": 10211.59,
    "new_taxes_no_override": 10652.73,
    "override_total_1": 10954.99,
    "override_increase_1": 302.26
  },
  {
    "#": "127 Fuller St, Unit 3 (063-21-02)",
    "$": 1359100,
    "address": "127 Fuller St, Unit 3",
    "parcel_id": "063-21-02",
    "owner1": "LOVEDAY, KENNETH S",
    "owner2": "HOFFMAN, ELLEN N",
    "current_taxes": 10282.25,
    "new_taxes_no_override": 10726.44,
    "override_total_1": 11030.8,
    "override_increase_1": 304.35
  },
  {
    "#": "128 Fuller St (065-17-00)",
    "$": 3213400,
    "address": "128 Fuller St",
    "parcel_id": "065-17-00",
    "owner1": "128 FULLER STREET LLC",
    "owner2": "",
    "current_taxes": 32905.22,
    "new_taxes_no_override": 34326.73,
    "override_total_1": 35300.72,
    "override_increase_1": 973.99
  },
  {
    "#": "130 Fuller St, Unit 1 (065-16-06)",
    "$": 642700,
    "address": "130 Fuller St, Unit 1",
    "parcel_id": "065-16-06",
    "owner1": "NICOLAI, GIOVANNI",
    "owner2": "ALBERTA, SILVIA",
    "current_taxes": 6581.25,
    "new_taxes_no_override": 6865.56,
    "override_total_1": 7060.36,
    "override_increase_1": 194.81
  },
  {
    "#": "130 Fuller St, Unit 2 (065-16-01)",
    "$": 606100,
    "address": "130 Fuller St, Unit 2",
    "parcel_id": "065-16-01",
    "owner1": "HENDRIX, CYNTHIA K",
    "owner2": "",
    "current_taxes": 2571.53,
    "new_taxes_no_override": 2682.62,
    "override_total_1": 2758.74,
    "override_increase_1": 76.12
  },
  {
    "#": "130 Fuller St, Unit 3 (065-16-02)",
    "$": 708600,
    "address": "130 Fuller St, Unit 3",
    "parcel_id": "065-16-02",
    "owner1": "JIANG, PEIYU",
    "owner2": "",
    "current_taxes": 3621.13,
    "new_taxes_no_override": 3777.56,
    "override_total_1": 3884.75,
    "override_increase_1": 107.19
  },
  {
    "#": "130 Fuller St, Unit 4 (065-16-03)",
    "$": 588800,
    "address": "130 Fuller St, Unit 4",
    "parcel_id": "065-16-03",
    "owner1": "KORN, YUVAL",
    "owner2": "",
    "current_taxes": 6029.31,
    "new_taxes_no_override": 6289.78,
    "override_total_1": 6468.24,
    "override_increase_1": 178.47
  },
  {
    "#": "130 Fuller St, Unit 5 (065-16-04)",
    "$": 800600,
    "address": "130 Fuller St, Unit 5",
    "parcel_id": "065-16-04",
    "owner1": "JANDOVA, IVA",
    "owner2": "",
    "current_taxes": 8198.14,
    "new_taxes_no_override": 8552.3,
    "override_total_1": 8794.96,
    "override_increase_1": 242.66
  },
  {
    "#": "130 Fuller St, Unit 6 (065-16-05)",
    "$": 578100,
    "address": "130 Fuller St, Unit 6",
    "parcel_id": "065-16-05",
    "owner1": "AOL REALTY LLC",
    "owner2": "",
    "current_taxes": 5919.74,
    "new_taxes_no_override": 6175.47,
    "override_total_1": 6350.7,
    "override_increase_1": 175.22
  },
  {
    "#": "131 Fuller St (063-22-00)",
    "$": 2753700,
    "address": "131 Fuller St",
    "parcel_id": "063-22-00",
    "owner1": "FRIED, ISAAC & NIVA",
    "owner2": "",
    "current_taxes": 28197.89,
    "new_taxes_no_override": 29416.04,
    "override_total_1": 30250.7,
    "override_increase_1": 834.66
  },
  {
    "#": "134 Fuller St, Unit 1 (065-15-01)",
    "$": 1004100,
    "address": "134 Fuller St, Unit 1",
    "parcel_id": "065-15-01",
    "owner1": "LIANSKI TRS, MAXIM & ANNA",
    "owner2": "",
    "current_taxes": 6647.05,
    "new_taxes_no_override": 6934.2,
    "override_total_1": 7130.96,
    "override_increase_1": 196.75
  },
  {
    "#": "134 Fuller St, Unit 2 (065-15-02)",
    "$": 1207600,
    "address": "134 Fuller St, Unit 2",
    "parcel_id": "065-15-02",
    "owner1": "ANDERSON, ASHER",
    "owner2": "REZEK, JOSEPH",
    "current_taxes": 8730.89,
    "new_taxes_no_override": 9108.06,
    "override_total_1": 9366.5,
    "override_increase_1": 258.43
  },
  {
    "#": "134 Fuller St, Unit 3 (065-15-03)",
    "$": 710600,
    "address": "134 Fuller St, Unit 3",
    "parcel_id": "065-15-03",
    "owner1": "CICCARESE, PAOLO NUNZIO",
    "owner2": "",
    "current_taxes": 7276.54,
    "new_taxes_no_override": 7590.89,
    "override_total_1": 7806.27,
    "override_increase_1": 215.39
  },
  {
    "#": "134 Fuller St, Unit 4 (065-15-04)",
    "$": 557900,
    "address": "134 Fuller St, Unit 4",
    "parcel_id": "065-15-04",
    "owner1": "FITZGERALD, CHRISTINE R",
    "owner2": "",
    "current_taxes": 5712.9,
    "new_taxes_no_override": 5959.7,
    "override_total_1": 6128.8,
    "override_increase_1": 169.1
  },
  {
    "#": "134 Fuller St, Unit B (065-15-05)",
    "$": 319800,
    "address": "134 Fuller St, Unit B",
    "parcel_id": "065-15-05",
    "owner1": "PATIENCE, MONIKA",
    "owner2": "",
    "current_taxes": 3274.75,
    "new_taxes_no_override": 3416.22,
    "override_total_1": 3513.15,
    "override_increase_1": 96.93
  },
  {
    "#": "135 Fuller St (063-23-00)",
    "$": 2798600,
    "address": "135 Fuller St",
    "parcel_id": "063-23-00",
    "owner1": "FRIED, ISAAC & NIVA",
    "owner2": "",
    "current_taxes": 25022.73,
    "new_taxes_no_override": 26103.71,
    "override_total_1": 26844.38,
    "override_increase_1": 740.67
  },
  {
    "#": "137 Fuller St (063-24-00)",
    "$": 2507500,
    "address": "137 Fuller St",
    "parcel_id": "063-24-00",
    "owner1": "LOUIE, KIN HUNG",
    "owner2": "",
    "current_taxes": 22041.87,
    "new_taxes_no_override": 22994.08,
    "override_total_1": 23646.52,
    "override_increase_1": 652.44
  },
  {
    "#": "138 Fuller St, Unit 1 (065-14-01)",
    "$": 1193000,
    "address": "138 Fuller St, Unit 1",
    "parcel_id": "065-14-01",
    "owner1": "MCGILL, GAEL CHRISTOPHE G",
    "owner2": "PARK, JEANNIE",
    "current_taxes": 8581.39,
    "new_taxes_no_override": 8952.11,
    "override_total_1": 9206.12,
    "override_increase_1": 254.01
  },
  {
    "#": "138 Fuller St, Unit 2 (065-14-02)",
    "$": 720800,
    "address": "138 Fuller St, Unit 2",
    "parcel_id": "065-14-02",
    "owner1": "LEE E, FU KEUNG & CHRISTOPHER",
    "owner2": "WAN, HELEN",
    "current_taxes": 3746.06,
    "new_taxes_no_override": 3907.89,
    "override_total_1": 4018.77,
    "override_increase_1": 110.88
  },
  {
    "#": "138 Fuller St, Unit 3 (065-14-03)",
    "$": 562700,
    "address": "138 Fuller St, Unit 3",
    "parcel_id": "065-14-03",
    "owner1": "BHANG, VANESSA",
    "owner2": "",
    "current_taxes": 5762.05,
    "new_taxes_no_override": 6010.97,
    "override_total_1": 6181.53,
    "override_increase_1": 170.56
  },
  {
    "#": "138 Fuller St, Unit 4 (065-14-04)",
    "$": 695300,
    "address": "138 Fuller St, Unit 4",
    "parcel_id": "065-14-04",
    "owner1": "DIMARIO, PETER E & STEPHANIE & E C",
    "owner2": "",
    "current_taxes": 7119.87,
    "new_taxes_no_override": 7427.45,
    "override_total_1": 7638.2,
    "override_increase_1": 210.75
  },
  {
    "#": "138 Fuller St, Unit 5 (065-14-05)",
    "$": 575300,
    "address": "138 Fuller St, Unit 5",
    "parcel_id": "065-14-05",
    "owner1": "ARONER, SARAH",
    "owner2": "",
    "current_taxes": 2256.14,
    "new_taxes_no_override": 2353.61,
    "override_total_1": 2420.39,
    "override_increase_1": 66.78
  },
  {
    "#": "138 Fuller St, Unit B (065-14-06)",
    "$": 312200,
    "address": "138 Fuller St, Unit B",
    "parcel_id": "065-14-06",
    "owner1": "PERRY, HEDY M",
    "owner2": "",
    "current_taxes": 3196.93,
    "new_taxes_no_override": 3335.04,
    "override_total_1": 3429.67,
    "override_increase_1": 94.63
  },
  {
    "#": "140 Fuller St, Unit 1 (065-13-05)",
    "$": 627400,
    "address": "140 Fuller St, Unit 1",
    "parcel_id": "065-13-05",
    "owner1": "MCSHANE, MARY P",
    "owner2": "",
    "current_taxes": 2789.64,
    "new_taxes_no_override": 2910.15,
    "override_total_1": 2992.73,
    "override_increase_1": 82.57
  },
  {
    "#": "140 Fuller St, Unit 2 (065-13-01)",
    "$": 616300,
    "address": "140 Fuller St, Unit 2",
    "parcel_id": "065-13-01",
    "owner1": "OBRIEN, KATHLEEN M",
    "owner2": "",
    "current_taxes": 2675.98,
    "new_taxes_no_override": 2791.58,
    "override_total_1": 2870.79,
    "override_increase_1": 79.21
  },
  {
    "#": "140 Fuller St, Unit 3 (065-13-02)",
    "$": 1208500,
    "address": "140 Fuller St, Unit 3",
    "parcel_id": "065-13-02",
    "owner1": "WHITE, ALLEN L",
    "owner2": "",
    "current_taxes": 8740.11,
    "new_taxes_no_override": 9117.68,
    "override_total_1": 9376.39,
    "override_increase_1": 258.71
  },
  {
    "#": "140 Fuller St, Unit 4 (065-13-03)",
    "$": 698000,
    "address": "140 Fuller St, Unit 4",
    "parcel_id": "065-13-03",
    "owner1": "CHELNEY, LEONARD & INNA",
    "owner2": "",
    "current_taxes": 3512.59,
    "new_taxes_no_override": 3664.33,
    "override_total_1": 3768.31,
    "override_increase_1": 103.97
  },
  {
    "#": "140 Fuller St, Unit 5 (065-13-04)",
    "$": 558800,
    "address": "140 Fuller St, Unit 5",
    "parcel_id": "065-13-04",
    "owner1": "OBRIEN, COLIN P",
    "owner2": "FERRARO, LAUREN",
    "current_taxes": 5722.11,
    "new_taxes_no_override": 5969.31,
    "override_total_1": 6138.68,
    "override_increase_1": 169.37
  },
  {
    "#": "141 Fuller St (063-25-00)",
    "$": 2447700,
    "address": "141 Fuller St",
    "parcel_id": "063-25-00",
    "owner1": "HO, CHRISTINA & TIMOTHY & BENJAMIN",
    "owner2": "HO TRS, PETER K & ANNA Y",
    "current_taxes": 21429.51,
    "new_taxes_no_override": 22355.26,
    "override_total_1": 22989.58,
    "override_increase_1": 634.31
  },
  {
    "#": "142 Fuller St, Unit 1 (065-12-01)",
    "$": 1160200,
    "address": "142 Fuller St, Unit 1",
    "parcel_id": "065-12-01",
    "owner1": "HOWARD TRS, NATHAN T",
    "owner2": "WHITE, ANNE E",
    "current_taxes": 8245.51,
    "new_taxes_no_override": 8601.72,
    "override_total_1": 8845.78,
    "override_increase_1": 244.07
  },
  {
    "#": "142 Fuller St, Unit 2& Pk Sp (065-12-02)",
    "$": 1513500,
    "address": "142 Fuller St, Unit 2& Pk Sp",
    "parcel_id": "065-12-02",
    "owner1": "LIRO, KIMBERLY",
    "owner2": "",
    "current_taxes": 11863.31,
    "new_taxes_no_override": 12375.8,
    "override_total_1": 12726.96,
    "override_increase_1": 351.15
  },
  {
    "#": "142 Fuller St, Unit 3 (065-12-03)",
    "$": 1510500,
    "address": "142 Fuller St, Unit 3",
    "parcel_id": "065-12-03",
    "owner1": "SHUKLA, PALLAVI",
    "owner2": "KUMAR, MIDHUN",
    "current_taxes": 11832.59,
    "new_taxes_no_override": 12343.76,
    "override_total_1": 12694.0,
    "override_increase_1": 350.24
  },
  {
    "#": "142 Fuller St, Unit 4 & Pk Sp (065-12-04)",
    "$": 1593600,
    "address": "142 Fuller St, Unit 4 & Pk Sp",
    "parcel_id": "065-12-04",
    "owner1": "ASKARBEK, AKERKE",
    "owner2": "",
    "current_taxes": 12683.53,
    "new_taxes_no_override": 13231.46,
    "override_total_1": 13606.89,
    "override_increase_1": 375.43
  },
  {
    "#": "143 Fuller St (063-26-00)",
    "$": 2421800,
    "address": "143 Fuller St",
    "parcel_id": "063-26-00",
    "owner1": "GEE, TRS, BOOY Y",
    "owner2": "",
    "current_taxes": 24799.23,
    "new_taxes_no_override": 25870.56,
    "override_total_1": 26604.61,
    "override_increase_1": 734.06
  },
  {
    "#": "147 Fuller St, Unit 1 (063-27-01)",
    "$": 971500,
    "address": "147 Fuller St, Unit 1",
    "parcel_id": "063-27-01",
    "owner1": "ALLEVA, ANDREA",
    "owner2": "SCIARRINO, CHRISTINE",
    "current_taxes": 9948.16,
    "new_taxes_no_override": 10377.92,
    "override_total_1": 10672.39,
    "override_increase_1": 294.47
  },
  {
    "#": "147 Fuller St, Unit 2 (063-27-02)",
    "$": 1126800,
    "address": "147 Fuller St, Unit 2",
    "parcel_id": "063-27-02",
    "owner1": "CARLSON, NELS",
    "owner2": "",
    "current_taxes": 7903.5,
    "new_taxes_no_override": 8244.93,
    "override_total_1": 8478.87,
    "override_increase_1": 233.94
  },
  {
    "#": "147 Fuller St, Unit 3 (063-27-03)",
    "$": 964500,
    "address": "147 Fuller St, Unit 3",
    "parcel_id": "063-27-03",
    "owner1": "ROTOW, JULIA K",
    "owner2": "",
    "current_taxes": 6241.55,
    "new_taxes_no_override": 6511.18,
    "override_total_1": 6695.93,
    "override_increase_1": 184.75
  },
  {
    "#": "148 Fuller St, Unit 1 (065-11-01)",
    "$": 1640500,
    "address": "148 Fuller St, Unit 1",
    "parcel_id": "065-11-01",
    "owner1": "ROCHE, CHRISTOPHER JOHN & MARIA ROSE",
    "owner2": "",
    "current_taxes": 16798.72,
    "new_taxes_no_override": 17524.42,
    "override_total_1": 18021.67,
    "override_increase_1": 497.24
  },
  {
    "#": "148 Fuller St, Unit 2 (065-11-02)",
    "$": 1835800,
    "address": "148 Fuller St, Unit 2",
    "parcel_id": "065-11-02",
    "owner1": "BERLINER, ALLEN I & EDWINA",
    "owner2": "",
    "current_taxes": 15163.66,
    "new_taxes_no_override": 15818.73,
    "override_total_1": 16267.57,
    "override_increase_1": 448.84
  },
  {
    "#": "149 Fuller St, Unit 1 (063-28-01)",
    "$": 1418300,
    "address": "149 Fuller St, Unit 1",
    "parcel_id": "063-28-01",
    "owner1": "LAVRINENKO, ANNA",
    "owner2": "ROEHL, RONALD",
    "current_taxes": 10888.46,
    "new_taxes_no_override": 11358.84,
    "override_total_1": 11681.14,
    "override_increase_1": 322.3
  },
  {
    "#": "149 Fuller St, Unit 2 (063-28-02)",
    "$": 1010200,
    "address": "149 Fuller St, Unit 2",
    "parcel_id": "063-28-02",
    "owner1": "GUZMAN, SHIGLIAM T",
    "owner2": "",
    "current_taxes": 6709.51,
    "new_taxes_no_override": 6999.36,
    "override_total_1": 7197.96,
    "override_increase_1": 198.6
  },
  {
    "#": "149 Fuller St, Unit 3 (063-28-03)",
    "$": 1004600,
    "address": "149 Fuller St, Unit 3",
    "parcel_id": "063-28-03",
    "owner1": "NAKADATE, LAUREL KATHERINE",
    "owner2": "MOODY, HIRAM FREDERICK III",
    "current_taxes": 6652.17,
    "new_taxes_no_override": 6939.54,
    "override_total_1": 7136.45,
    "override_increase_1": 196.9
  },
  {
    "#": "153 Fuller St, Unit 1 (063-29-02)",
    "$": 1024600,
    "address": "153 Fuller St, Unit 1",
    "parcel_id": "063-29-02",
    "owner1": "PARKER TRS, JAMES W & KRISTIN A",
    "owner2": "",
    "current_taxes": 6856.97,
    "new_taxes_no_override": 7153.19,
    "override_total_1": 7356.16,
    "override_increase_1": 202.97
  },
  {
    "#": "153 Fuller St, Unit 2 (063-29-03)",
    "$": 1046500,
    "address": "153 Fuller St, Unit 2",
    "parcel_id": "063-29-03",
    "owner1": "THOMAS, DOLORES R",
    "owner2": "",
    "current_taxes": 7081.23,
    "new_taxes_no_override": 7387.14,
    "override_total_1": 7596.74,
    "override_increase_1": 209.6
  },
  {
    "#": "153 Fuller St, Unit 3 (063-29-04)",
    "$": 1103900,
    "address": "153 Fuller St, Unit 3",
    "parcel_id": "063-29-04",
    "owner1": "SPILIOPOULOS, KONSTANTINOS",
    "owner2": "VOULGARAKI, ANASTASIA",
    "current_taxes": 7669.0,
    "new_taxes_no_override": 8000.3,
    "override_total_1": 8227.3,
    "override_increase_1": 227.0
  },
  {
    "#": "153 Fuller St, Unit A (063-29-05)",
    "$": 347000,
    "address": "153 Fuller St, Unit A",
    "parcel_id": "063-29-05",
    "owner1": "WILSON, GEOFFREY L & KEREN T",
    "owner2": "",
    "current_taxes": 3553.28,
    "new_taxes_no_override": 3706.78,
    "override_total_1": 3811.96,
    "override_increase_1": 105.18
  },
  {
    "#": "153 Fuller St, Unit B (063-29-01)",
    "$": 339400,
    "address": "153 Fuller St, Unit B",
    "parcel_id": "063-29-01",
    "owner1": "RENTALS ONE LLC",
    "owner2": "",
    "current_taxes": 3475.46,
    "new_taxes_no_override": 3625.6,
    "override_total_1": 3728.47,
    "override_increase_1": 102.87
  },
  {
    "#": "162 Fuller St, Unit 1 (061-08-01)",
    "$": 1316800,
    "address": "162 Fuller St, Unit 1",
    "parcel_id": "061-08-01",
    "owner1": "LEE, HSIEN-HSIN SEAN",
    "owner2": "LIU, ESTHER JYUE-CHYI",
    "current_taxes": 9849.1,
    "new_taxes_no_override": 10274.58,
    "override_total_1": 10566.11,
    "override_increase_1": 291.53
  },
  {
    "#": "162 Fuller St, Unit 2 (061-08-02)",
    "$": 1011000,
    "address": "162 Fuller St, Unit 2",
    "parcel_id": "061-08-02",
    "owner1": "SHAKHNOVICH, BORIS-EUGENE-MARSHA",
    "owner2": "",
    "current_taxes": 10352.64,
    "new_taxes_no_override": 10799.87,
    "override_total_1": 11106.31,
    "override_increase_1": 306.44
  },
  {
    "#": "162 Fuller St, Unit 3 (061-08-03)",
    "$": 1024900,
    "address": "162 Fuller St, Unit 3",
    "parcel_id": "061-08-03",
    "owner1": "GOLJA, ANNA",
    "owner2": "ENGEL, LAWRENCE H",
    "current_taxes": 6860.04,
    "new_taxes_no_override": 7156.39,
    "override_total_1": 7359.45,
    "override_increase_1": 203.06
  },
  {
    "#": "165 Fuller St (062-06-00)",
    "$": 2416200,
    "address": "165 Fuller St",
    "parcel_id": "062-06-00",
    "owner1": "JABLONSKI, ERICA F S & STEPHEN",
    "owner2": "",
    "current_taxes": 24741.89,
    "new_taxes_no_override": 25810.74,
    "override_total_1": 26543.1,
    "override_increase_1": 732.36
  },
  {
    "#": "166 Fuller St, Unit 1 (061-09-03)",
    "$": 870900,
    "address": "166 Fuller St, Unit 1",
    "parcel_id": "061-09-03",
    "owner1": "AUERBACH, MARTHA",
    "owner2": "",
    "current_taxes": 5283.08,
    "new_taxes_no_override": 5511.31,
    "override_total_1": 5667.69,
    "override_increase_1": 156.38
  },
  {
    "#": "166 Fuller St, Unit 2 (061-09-01)",
    "$": 1004500,
    "address": "166 Fuller St, Unit 2",
    "parcel_id": "061-09-01",
    "owner1": "DE ALMEIDA VAZ, BRUNO RICARDO",
    "owner2": "DE OLIVEIRA, MARINA GONCALVES CARREIRO",
    "current_taxes": 6651.15,
    "new_taxes_no_override": 6938.48,
    "override_total_1": 7135.35,
    "override_increase_1": 196.87
  },
  {
    "#": "166 Fuller St, Unit 3 (061-09-02)",
    "$": 1022900,
    "address": "166 Fuller St, Unit 3",
    "parcel_id": "061-09-02",
    "owner1": "ZHONG, LAN",
    "owner2": "SHI, DONGWEI",
    "current_taxes": 10474.5,
    "new_taxes_no_override": 10927.0,
    "override_total_1": 11237.04,
    "override_increase_1": 310.05
  },
  {
    "#": "169 Fuller St (062-07-00)",
    "$": 2206600,
    "address": "169 Fuller St",
    "parcel_id": "062-07-00",
    "owner1": "169 171 FULLER LLC",
    "owner2": "C/O OVSIEW PHYLLIS L",
    "current_taxes": 22595.58,
    "new_taxes_no_override": 23571.71,
    "override_total_1": 24240.54,
    "override_increase_1": 668.83
  },
  {
    "#": "172 Fuller St (061-10-00)",
    "$": 2034700,
    "address": "172 Fuller St",
    "parcel_id": "061-10-00",
    "owner1": "HANEY TRS, MATTHEW",
    "owner2": "C/O FHS REALTY TRUST",
    "current_taxes": 20835.33,
    "new_taxes_no_override": 21735.42,
    "override_total_1": 22352.14,
    "override_increase_1": 616.73
  },
  {
    "#": "175 Fuller St (062-08-00)",
    "$": 2929200,
    "address": "175 Fuller St",
    "parcel_id": "062-08-00",
    "owner1": "SOKOL, ALBERT L",
    "owner2": "HESSNER, MARIANNE J",
    "current_taxes": 26360.07,
    "new_taxes_no_override": 27498.83,
    "override_total_1": 28279.08,
    "override_increase_1": 780.26
  },
  {
    "#": "176 Fuller St, Unit 1 & P1 (061-02-01)",
    "$": 1471300,
    "address": "176 Fuller St, Unit 1 & P1",
    "parcel_id": "061-02-01",
    "owner1": "YOSHIOKA, MARI",
    "owner2": "FURUGORI, JOSEPH",
    "current_taxes": 11431.18,
    "new_taxes_no_override": 11925.01,
    "override_total_1": 12263.37,
    "override_increase_1": 338.36
  },
  {
    "#": "176 Fuller St, Unit 2 & P-A (061-02-02)",
    "$": 1651200,
    "address": "176 Fuller St, Unit 2 & P-A",
    "parcel_id": "061-02-02",
    "owner1": "MADSEN HARDY, WILLIAM & SARAH",
    "owner2": "",
    "current_taxes": 13273.35,
    "new_taxes_no_override": 13846.76,
    "override_total_1": 14239.65,
    "override_increase_1": 392.89
  },
  {
    "#": "183 Fuller St, Unit 1 (062-09-01)",
    "$": 284600,
    "address": "183 Fuller St, Unit 1",
    "parcel_id": "062-09-01",
    "owner1": "YASHINSKY TRS, RUSSELL & CHRISTINE S",
    "owner2": "YASHINSKY TR, JONATHAN",
    "current_taxes": 291.43,
    "new_taxes_no_override": 304.02,
    "override_total_1": 312.65,
    "override_increase_1": 8.63
  },
  {
    "#": "183 Fuller St, Unit 10 (062-09-10)",
    "$": 279300,
    "address": "183 Fuller St, Unit 10",
    "parcel_id": "062-09-10",
    "owner1": "STURTEVANT, RONALD J & ELLEN M",
    "owner2": "",
    "current_taxes": 2860.03,
    "new_taxes_no_override": 2983.58,
    "override_total_1": 3068.24,
    "override_increase_1": 84.66
  },
  {
    "#": "183 Fuller St, Unit 2 (062-09-02)",
    "$": 243600,
    "address": "183 Fuller St, Unit 2",
    "parcel_id": "062-09-02",
    "owner1": "DOUCETTE TRS, JOHN D & KATHLEEN M",
    "owner2": "",
    "current_taxes": 2494.46,
    "new_taxes_no_override": 2602.22,
    "override_total_1": 2676.06,
    "override_increase_1": 73.84
  },
  {
    "#": "183 Fuller St, Unit 3 (062-09-03)",
    "$": 421600,
    "address": "183 Fuller St, Unit 3",
    "parcel_id": "062-09-03",
    "owner1": "MULVIHILL TRS, VERONICA J",
    "owner2": "",
    "current_taxes": 4317.18,
    "new_taxes_no_override": 4503.68,
    "override_total_1": 4631.47,
    "override_increase_1": 127.79
  },
  {
    "#": "183 Fuller St, Unit 4 (062-09-04)",
    "$": 410900,
    "address": "183 Fuller St, Unit 4",
    "parcel_id": "062-09-04",
    "owner1": "FALCONE TRS, LAURA E",
    "owner2": "C/O ERIC FALCONE",
    "current_taxes": 4207.62,
    "new_taxes_no_override": 4389.39,
    "override_total_1": 4513.93,
    "override_increase_1": 124.55
  },
  {
    "#": "183 Fuller St, Unit 5 (062-09-05)",
    "$": 360000,
    "address": "183 Fuller St, Unit 5",
    "parcel_id": "062-09-05",
    "owner1": "APPEL TR, JO ANN",
    "owner2": "",
    "current_taxes": 3686.4,
    "new_taxes_no_override": 3845.65,
    "override_total_1": 3954.77,
    "override_increase_1": 109.12
  },
  {
    "#": "183 Fuller St, Unit 6 (062-09-06)",
    "$": 299200,
    "address": "183 Fuller St, Unit 6",
    "parcel_id": "062-09-06",
    "owner1": "KASTRINER TRS, MARTIN & RITA",
    "owner2": "",
    "current_taxes": 3063.81,
    "new_taxes_no_override": 3196.17,
    "override_total_1": 3286.86,
    "override_increase_1": 90.69
  },
  {
    "#": "183 Fuller St, Unit 7 (062-09-07)",
    "$": 287200,
    "address": "183 Fuller St, Unit 7",
    "parcel_id": "062-09-07",
    "owner1": "NATALE, SUSAN A & ALFRED Z",
    "owner2": "",
    "current_taxes": 2940.93,
    "new_taxes_no_override": 3067.98,
    "override_total_1": 3155.03,
    "override_increase_1": 87.05
  },
  {
    "#": "183 Fuller St, Unit 8 (062-09-08)",
    "$": 367900,
    "address": "183 Fuller St, Unit 8",
    "parcel_id": "062-09-08",
    "owner1": "PFEFFER TR, RUBIN H",
    "owner2": "",
    "current_taxes": 3767.3,
    "new_taxes_no_override": 3930.05,
    "override_total_1": 4041.56,
    "override_increase_1": 111.51
  },
  {
    "#": "183 Fuller St, Unit 9 (062-09-09)",
    "$": 229800,
    "address": "183 Fuller St, Unit 9",
    "parcel_id": "062-09-09",
    "owner1": "PRESS TRS, DIANE & JAY",
    "owner2": "",
    "current_taxes": 2353.15,
    "new_taxes_no_override": 2454.81,
    "override_total_1": 2524.46,
    "override_increase_1": 69.65
  },
  {
    "#": "192 Fuller St, Unit 2 (059-01-02)",
    "$": 1610500,
    "address": "192 Fuller St, Unit 2",
    "parcel_id": "059-01-02",
    "owner1": "GOLDFLESS TRS, SANDFORD K & EILEEN S",
    "owner2": "",
    "current_taxes": 12856.59,
    "new_taxes_no_override": 13411.99,
    "override_total_1": 13792.55,
    "override_increase_1": 380.56
  },
  {
    "#": "197 Fuller St (057-15-00)",
    "$": 2737100,
    "address": "197 Fuller St",
    "parcel_id": "057-15-00",
    "owner1": "KAWADA, CHARLES Y",
    "owner2": "HANSEN-KAWADA, JANET L",
    "current_taxes": 24392.97,
    "new_taxes_no_override": 25446.75,
    "override_total_1": 26168.78,
    "override_increase_1": 722.03
  },
  {
    "#": "202 Fuller St, Unit 1 (059-06-07)",
    "$": 679600,
    "address": "202 Fuller St, Unit 1",
    "parcel_id": "059-06-07",
    "owner1": "GULNIK, GENNADIY A & SOFYA M",
    "owner2": "",
    "current_taxes": 3324.17,
    "new_taxes_no_override": 3467.77,
    "override_total_1": 3566.17,
    "override_increase_1": 98.4
  },
  {
    "#": "202 Fuller St, Unit 2 (059-06-08)",
    "$": 749600,
    "address": "202 Fuller St, Unit 2",
    "parcel_id": "059-06-08",
    "owner1": "MILLER, KEVIN J & RAE ELLEN",
    "owner2": "",
    "current_taxes": 4040.97,
    "new_taxes_no_override": 4215.54,
    "override_total_1": 4335.15,
    "override_increase_1": 119.61
  },
  {
    "#": "202 Fuller St, Unit 3 (059-06-09)",
    "$": 753200,
    "address": "202 Fuller St, Unit 3",
    "parcel_id": "059-06-09",
    "owner1": "KIRAKOSYAN, ARAMAYIS",
    "owner2": "",
    "current_taxes": 4077.83,
    "new_taxes_no_override": 4253.99,
    "override_total_1": 4374.7,
    "override_increase_1": 120.7
  },
  {
    "#": "202 Fuller St, Unit 4 (059-06-10)",
    "$": 802400,
    "address": "202 Fuller St, Unit 4",
    "parcel_id": "059-06-10",
    "owner1": "KHUDYAKOV, POLYNA & KONSTANTIN",
    "owner2": "",
    "current_taxes": 4581.64,
    "new_taxes_no_override": 4779.57,
    "override_total_1": 4915.18,
    "override_increase_1": 135.62
  },
  {
    "#": "202 Fuller St, Unit 5 (059-06-11)",
    "$": 725700,
    "address": "202 Fuller St, Unit 5",
    "parcel_id": "059-06-11",
    "owner1": "LEVY TR, RICHARD",
    "owner2": "",
    "current_taxes": 3796.23,
    "new_taxes_no_override": 3960.23,
    "override_total_1": 4072.6,
    "override_increase_1": 112.37
  },
  {
    "#": "202 Fuller St, Unit 6 (059-06-12)",
    "$": 778800,
    "address": "202 Fuller St, Unit 6",
    "parcel_id": "059-06-12",
    "owner1": "LIMANOVSKIY, DMITRIY",
    "owner2": "NEVZOROVA, YELENA",
    "current_taxes": 4339.98,
    "new_taxes_no_override": 4527.47,
    "override_total_1": 4655.93,
    "override_increase_1": 128.46
  },
  {
    "#": "203 Fuller St (057-16-00)",
    "$": 2082500,
    "address": "203 Fuller St",
    "parcel_id": "057-16-00",
    "owner1": "DEA, PHILIP K & HELENA",
    "owner2": "",
    "current_taxes": 17689.87,
    "new_taxes_no_override": 18454.07,
    "override_total_1": 18977.69,
    "override_increase_1": 523.62
  },
  {
    "#": "207 Fuller St, Unit 207 (057-17-01)",
    "$": 1875600,
    "address": "207 Fuller St, Unit 207",
    "parcel_id": "057-17-01",
    "owner1": "HUCKFELDT TRS, R ROBERT & SHARON K",
    "owner2": "",
    "current_taxes": 15571.21,
    "new_taxes_no_override": 16243.89,
    "override_total_1": 16704.79,
    "override_increase_1": 460.91
  },
  {
    "#": "207 Fuller St, Unit 209 (057-17-02)",
    "$": 2308500,
    "address": "207 Fuller St, Unit 209",
    "parcel_id": "057-17-02",
    "owner1": "INGERMAN, AVNER",
    "owner2": "SOBOL, TAMAR",
    "current_taxes": 20004.11,
    "new_taxes_no_override": 20868.29,
    "override_total_1": 21460.41,
    "override_increase_1": 592.12
  },
  {
    "#": "208 Fuller St, Unit 1 (059-06-13)",
    "$": 689200,
    "address": "208 Fuller St, Unit 1",
    "parcel_id": "059-06-13",
    "owner1": "GOUTAS, MURIEL",
    "owner2": "",
    "current_taxes": 3422.47,
    "new_taxes_no_override": 3570.32,
    "override_total_1": 3671.63,
    "override_increase_1": 101.31
  },
  {
    "#": "208 Fuller St, Unit 2 (059-06-14)",
    "$": 788800,
    "address": "208 Fuller St, Unit 2",
    "parcel_id": "059-06-14",
    "owner1": "POURRAHIMI, NEGAAR",
    "owner2": "",
    "current_taxes": 4442.38,
    "new_taxes_no_override": 4634.29,
    "override_total_1": 4765.79,
    "override_increase_1": 131.49
  },
  {
    "#": "208 Fuller St, Unit 3 (059-06-15)",
    "$": 642200,
    "address": "208 Fuller St, Unit 3",
    "parcel_id": "059-06-15",
    "owner1": "CHIU TR, SHETEEN",
    "owner2": "",
    "current_taxes": 6576.13,
    "new_taxes_no_override": 6860.22,
    "override_total_1": 7054.87,
    "override_increase_1": 194.65
  },
  {
    "#": "208 Fuller St, Unit 4 (059-06-16)",
    "$": 758600,
    "address": "208 Fuller St, Unit 4",
    "parcel_id": "059-06-16",
    "owner1": "SILVA, CRAIG & LAUREN",
    "owner2": "",
    "current_taxes": 4133.13,
    "new_taxes_no_override": 4311.68,
    "override_total_1": 4434.02,
    "override_increase_1": 122.34
  },
  {
    "#": "208 Fuller St, Unit 5 (059-06-17)",
    "$": 788800,
    "address": "208 Fuller St, Unit 5",
    "parcel_id": "059-06-17",
    "owner1": "KAUFMAN LIFE ESTATE, MARINA & VLADIMIR",
    "owner2": "",
    "current_taxes": 4442.38,
    "new_taxes_no_override": 4634.29,
    "override_total_1": 4765.79,
    "override_increase_1": 131.49
  },
  {
    "#": "208 Fuller St, Unit 6 (059-06-18)",
    "$": 710900,
    "address": "208 Fuller St, Unit 6",
    "parcel_id": "059-06-18",
    "owner1": "WANG, JENNY",
    "owner2": "",
    "current_taxes": 7279.62,
    "new_taxes_no_override": 7594.1,
    "override_total_1": 7809.58,
    "override_increase_1": 215.48
  },
  {
    "#": "208 Fuller St, Unit 7 (059-06-19)",
    "$": 774100,
    "address": "208 Fuller St, Unit 7",
    "parcel_id": "059-06-19",
    "owner1": "DEYESSO, KRISTIAN A",
    "owner2": "",
    "current_taxes": 4291.85,
    "new_taxes_no_override": 4477.26,
    "override_total_1": 4604.3,
    "override_increase_1": 127.04
  },
  {
    "#": "208 Fuller St, Unit 8 (059-06-20)",
    "$": 795300,
    "address": "208 Fuller St, Unit 8",
    "parcel_id": "059-06-20",
    "owner1": "LOPEZ-CALVA, GABRIEL A",
    "owner2": "BAKER, OLESYA",
    "current_taxes": 4508.94,
    "new_taxes_no_override": 4703.73,
    "override_total_1": 4837.19,
    "override_increase_1": 133.46
  },
  {
    "#": "208 Fuller St, Unit 9 (059-06-21)",
    "$": 726500,
    "address": "208 Fuller St, Unit 9",
    "parcel_id": "059-06-21",
    "owner1": "FERRER, LAURA ALLAN",
    "owner2": "",
    "current_taxes": 3804.43,
    "new_taxes_no_override": 3968.78,
    "override_total_1": 4081.39,
    "override_increase_1": 112.61
  },
  {
    "#": "211 Fuller St (057-18-00)",
    "$": 1772700,
    "address": "211 Fuller St",
    "parcel_id": "057-18-00",
    "owner1": "MEI, MILES",
    "owner2": "",
    "current_taxes": 14517.51,
    "new_taxes_no_override": 15144.67,
    "override_total_1": 15574.38,
    "override_increase_1": 429.72
  },
  {
    "#": "217 Fuller St (057-19-00)",
    "$": 1926000,
    "address": "217 Fuller St",
    "parcel_id": "057-19-00",
    "owner1": "MEI TR, THERESA R",
    "owner2": "",
    "current_taxes": 19722.24,
    "new_taxes_no_override": 20574.24,
    "override_total_1": 21158.02,
    "override_increase_1": 583.78
  },
  {
    "#": "221 Fuller St (057-20-00)",
    "$": 1953400,
    "address": "221 Fuller St",
    "parcel_id": "057-20-00",
    "owner1": "MEI TR, THERESA R",
    "owner2": "",
    "current_taxes": 16367.88,
    "new_taxes_no_override": 17074.97,
    "override_total_1": 17559.46,
    "override_increase_1": 484.49
  },
  {
    "#": "224 Fuller St (058-04-00)",
    "$": 991000,
    "address": "224 Fuller St",
    "parcel_id": "058-04-00",
    "owner1": "HRT #1 PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 10147.84,
    "new_taxes_no_override": 10586.23,
    "override_total_1": 10886.6,
    "override_increase_1": 300.38
  },
  {
    "#": "225 Fuller St, Unit 225 & G231 (057-21-05)",
    "$": 1752300,
    "address": "225 Fuller St, Unit 225 & G231",
    "parcel_id": "057-21-05",
    "owner1": "CAVASENO, VINCENT & VICTORIA",
    "owner2": "",
    "current_taxes": 14308.62,
    "new_taxes_no_override": 14926.75,
    "override_total_1": 15350.29,
    "override_increase_1": 423.54
  },
  {
    "#": "227 Fuller St, Unit 227 (057-21-06)",
    "$": 1645300,
    "address": "227 Fuller St, Unit 227",
    "parcel_id": "057-21-06",
    "owner1": "CHEN, CHIEN HUA",
    "owner2": "",
    "current_taxes": 16847.87,
    "new_taxes_no_override": 17575.7,
    "override_total_1": 18074.39,
    "override_increase_1": 498.7
  },
  {
    "#": "229 Fuller St, Unit 229 (057-21-07)",
    "$": 1639600,
    "address": "229 Fuller St, Unit 229",
    "parcel_id": "057-21-07",
    "owner1": "PONTES  TRS, EDWARD JR & DEBORAH",
    "owner2": "",
    "current_taxes": 13154.57,
    "new_taxes_no_override": 13722.85,
    "override_total_1": 14112.22,
    "override_increase_1": 389.38
  },
  {
    "#": "231 Fuller St, Unit 231 G225 (057-21-08)",
    "$": 1596200,
    "address": "231 Fuller St, Unit 231 G225",
    "parcel_id": "057-21-08",
    "owner1": "WEISS TR, RACHEL B",
    "owner2": "",
    "current_taxes": 12710.15,
    "new_taxes_no_override": 13259.23,
    "override_total_1": 13635.45,
    "override_increase_1": 376.22
  },
  {
    "#": "2 Gardner Rd, Unit 1 (208-32-01)",
    "$": 1427600,
    "address": "2 Gardner Rd, Unit 1",
    "parcel_id": "208-32-01",
    "owner1": "ROSS TR, ELIZABETH H",
    "owner2": "",
    "current_taxes": 10983.69,
    "new_taxes_no_override": 11458.19,
    "override_total_1": 11783.3,
    "override_increase_1": 325.12
  },
  {
    "#": "2 Gardner Rd, Unit 2 P1&2 (208-32-02)",
    "$": 1361300,
    "address": "2 Gardner Rd, Unit 2 P1&2",
    "parcel_id": "208-32-02",
    "owner1": "KHAYKOVICH, BORIS & YAEL",
    "owner2": "",
    "current_taxes": 10304.78,
    "new_taxes_no_override": 10749.95,
    "override_total_1": 11054.97,
    "override_increase_1": 305.02
  },
  {
    "#": "2 Gardner Rd, Unit 3 (208-32-03)",
    "$": 1378200,
    "address": "2 Gardner Rd, Unit 3",
    "parcel_id": "208-32-03",
    "owner1": "EUSDEN, CAITLIN A",
    "owner2": "",
    "current_taxes": 14112.77,
    "new_taxes_no_override": 14722.44,
    "override_total_1": 15140.18,
    "override_increase_1": 417.74
  },
  {
    "#": "11 Gardner Rd, Unit 1A (210-17-03)",
    "$": 1465600,
    "address": "11 Gardner Rd, Unit 1A",
    "parcel_id": "210-17-03",
    "owner1": "DOYLE, JAMES N",
    "owner2": "GUISBOND, LISA A",
    "current_taxes": 11372.81,
    "new_taxes_no_override": 11864.12,
    "override_total_1": 12200.75,
    "override_increase_1": 336.64
  },
  {
    "#": "11 Gardner Rd, Unit 1B (210-17-02)",
    "$": 1670600,
    "address": "11 Gardner Rd, Unit 1B",
    "parcel_id": "210-17-02",
    "owner1": "NAZER, BOBAK",
    "owner2": "HSIA, STEPHANIE",
    "current_taxes": 13472.01,
    "new_taxes_no_override": 14054.0,
    "override_total_1": 14452.77,
    "override_increase_1": 398.77
  },
  {
    "#": "16 Gardner Rd (208-31-01)",
    "$": 2619000,
    "address": "16 Gardner Rd",
    "parcel_id": "208-31-01",
    "owner1": "ALEX S REALTY LLC",
    "owner2": "",
    "current_taxes": 26818.56,
    "new_taxes_no_override": 27977.12,
    "override_total_1": 28770.95,
    "override_increase_1": 793.83
  },
  {
    "#": "17 Gardner Rd (210-17-00)",
    "$": 2536700,
    "address": "17 Gardner Rd",
    "parcel_id": "210-17-00",
    "owner1": "THE EDD KAMP FAMILY LP",
    "owner2": "",
    "current_taxes": 25975.81,
    "new_taxes_no_override": 27097.96,
    "override_total_1": 27866.85,
    "override_increase_1": 768.88
  },
  {
    "#": "25 Gardner Rd (210-16-00)",
    "$": 4398400,
    "address": "25 Gardner Rd",
    "parcel_id": "210-16-00",
    "owner1": "SHIRAHAMA, TSURANOBU",
    "owner2": "",
    "current_taxes": 45039.62,
    "new_taxes_no_override": 46985.33,
    "override_total_1": 48318.5,
    "override_increase_1": 1333.17
  },
  {
    "#": "30 Gardner Rd (208-30-33)",
    "$": 22270300,
    "address": "30 Gardner Rd",
    "parcel_id": "208-30-33",
    "owner1": "COHEN, TR, HARRY A",
    "owner2": "",
    "current_taxes": 228047.87,
    "new_taxes_no_override": 237899.54,
    "override_total_1": 244649.75,
    "override_increase_1": 6750.22
  },
  {
    "#": "35 Gardner Rd (210-15-00)",
    "$": 5101800,
    "address": "35 Gardner Rd",
    "parcel_id": "210-15-00",
    "owner1": "BORCK, JACQUELYN",
    "owner2": "",
    "current_taxes": 48607.5,
    "new_taxes_no_override": 50707.34,
    "override_total_1": 52146.13,
    "override_increase_1": 1438.78
  },
  {
    "#": "40 Gardner Rd (208-29-00)",
    "$": 3072600,
    "address": "40 Gardner Rd",
    "parcel_id": "208-29-00",
    "owner1": "DUFFIELD, CHERYL K & JEREMY S",
    "owner2": "",
    "current_taxes": 27828.49,
    "new_taxes_no_override": 29030.68,
    "override_total_1": 29854.4,
    "override_increase_1": 823.72
  },
  {
    "#": "43 Gardner Rd, Unit 1 (210-14-04)",
    "$": 1298100,
    "address": "43 Gardner Rd, Unit 1",
    "parcel_id": "210-14-04",
    "owner1": "SVETNIK, VLADIMIR & LUBA & TANYA",
    "owner2": "",
    "current_taxes": 13292.54,
    "new_taxes_no_override": 13866.78,
    "override_total_1": 14260.24,
    "override_increase_1": 393.46
  },
  {
    "#": "43 Gardner Rd, Unit 2 (210-14-05)",
    "$": 1476200,
    "address": "43 Gardner Rd, Unit 2",
    "parcel_id": "210-14-05",
    "owner1": "NIKULIN, SERGE",
    "owner2": "SVETNIK, TATYANA",
    "current_taxes": 11481.35,
    "new_taxes_no_override": 11977.34,
    "override_total_1": 12317.19,
    "override_increase_1": 339.85
  },
  {
    "#": "46 Gardner Rd, Unit 1 (208-28-01)",
    "$": 1079600,
    "address": "46 Gardner Rd, Unit 1",
    "parcel_id": "208-28-01",
    "owner1": "SWEDBERG, DEBORAH R",
    "owner2": "CARLISLE, SUSAN E",
    "current_taxes": 7420.17,
    "new_taxes_no_override": 7740.72,
    "override_total_1": 7960.36,
    "override_increase_1": 219.64
  },
  {
    "#": "46 Gardner Rd, Unit 2 (208-28-02)",
    "$": 1668100,
    "address": "46 Gardner Rd, Unit 2",
    "parcel_id": "208-28-02",
    "owner1": "MILLER, DIANA",
    "owner2": "",
    "current_taxes": 17081.34,
    "new_taxes_no_override": 17819.25,
    "override_total_1": 18324.86,
    "override_increase_1": 505.61
  },
  {
    "#": "49 Gardner Rd (210-14-02)",
    "$": 2509800,
    "address": "49 Gardner Rd",
    "parcel_id": "210-14-02",
    "owner1": "LEW TRS, JUDY W",
    "owner2": "",
    "current_taxes": 22065.42,
    "new_taxes_no_override": 23018.65,
    "override_total_1": 23671.78,
    "override_increase_1": 653.14
  },
  {
    "#": "53 Gardner Rd, Unit 1 (210-14-06)",
    "$": 988300,
    "address": "53 Gardner Rd, Unit 1",
    "parcel_id": "210-14-06",
    "owner1": "JAKOVLJEVIC TRS, PREDRAG",
    "owner2": "NASSIF, DEBORAH S",
    "current_taxes": 6485.26,
    "new_taxes_no_override": 6765.42,
    "override_total_1": 6957.39,
    "override_increase_1": 191.96
  },
  {
    "#": "53 Gardner Rd, Unit 2 & G2 (210-14-07)",
    "$": 1045500,
    "address": "53 Gardner Rd, Unit 2 & G2",
    "parcel_id": "210-14-07",
    "owner1": "LIEB, DAVID J",
    "owner2": "SOLOMON, SALLY",
    "current_taxes": 7070.99,
    "new_taxes_no_override": 7376.46,
    "override_total_1": 7585.76,
    "override_increase_1": 209.3
  },
  {
    "#": "54 Gardner Rd (208-27-00)",
    "$": 3229400,
    "address": "54 Gardner Rd",
    "parcel_id": "208-27-00",
    "owner1": "KERSTEIN, MICHAEL",
    "owner2": "",
    "current_taxes": 29434.12,
    "new_taxes_no_override": 30705.67,
    "override_total_1": 31576.92,
    "override_increase_1": 871.25
  },
  {
    "#": "60 Gardner Rd, Unit 1 (208-26-03)",
    "$": 1320100,
    "address": "60 Gardner Rd, Unit 1",
    "parcel_id": "208-26-03",
    "owner1": "ARTZI, SHAY & NATALIE",
    "owner2": "",
    "current_taxes": 13517.82,
    "new_taxes_no_override": 14101.79,
    "override_total_1": 14501.92,
    "override_increase_1": 400.13
  },
  {
    "#": "60 Gardner Rd, Unit 2 (208-26-04)",
    "$": 2310900,
    "address": "60 Gardner Rd, Unit 2",
    "parcel_id": "208-26-04",
    "owner1": "ARTZI, SHAY & NATALIE",
    "owner2": "",
    "current_taxes": 23663.62,
    "new_taxes_no_override": 24685.89,
    "override_total_1": 25386.33,
    "override_increase_1": 700.44
  },
  {
    "#": "61 Gardner Rd, Unit 61 (210-13-02)",
    "$": 1647200,
    "address": "61 Gardner Rd, Unit 61",
    "parcel_id": "210-13-02",
    "owner1": "KRIVTSOV, ANDREI",
    "owner2": "KARAYEVA, TATYANA",
    "current_taxes": 13232.39,
    "new_taxes_no_override": 13804.03,
    "override_total_1": 14195.71,
    "override_increase_1": 391.68
  },
  {
    "#": "61 Gardner Rd, Unit 63 (210-13-03)",
    "$": 1223000,
    "address": "61 Gardner Rd, Unit 63",
    "parcel_id": "210-13-03",
    "owner1": "VAKNIN, DAVID & DALIT NOBELMAN",
    "owner2": "",
    "current_taxes": 8888.59,
    "new_taxes_no_override": 9272.58,
    "override_total_1": 9535.68,
    "override_increase_1": 263.1
  },
  {
    "#": "64 Gardner Rd (208-26-01)",
    "$": 3008700,
    "address": "64 Gardner Rd",
    "parcel_id": "208-26-01",
    "owner1": "ERLICHMAN, ISRAEL & BETH C",
    "owner2": "",
    "current_taxes": 27174.15,
    "new_taxes_no_override": 28348.07,
    "override_total_1": 29152.43,
    "override_increase_1": 804.35
  },
  {
    "#": "70 Gardner Rd (208-26-00)",
    "$": 2747200,
    "address": "70 Gardner Rd",
    "parcel_id": "208-26-00",
    "owner1": "EMILFARB, MICHAEL & EMILIYA",
    "owner2": "",
    "current_taxes": 24496.39,
    "new_taxes_no_override": 25554.63,
    "override_total_1": 26279.73,
    "override_increase_1": 725.09
  },
  {
    "#": "73 Gardner Rd, Unit 73 (210-11-06)",
    "$": 2840800,
    "address": "73 Gardner Rd, Unit 73",
    "parcel_id": "210-11-06",
    "owner1": "FLYNN, THOMAS J & ERIN R",
    "owner2": "",
    "current_taxes": 25454.86,
    "new_taxes_no_override": 26554.51,
    "override_total_1": 27307.97,
    "override_increase_1": 753.46
  },
  {
    "#": "73 Gardner Rd, Unit 75 (210-11-07)",
    "$": 3379100,
    "address": "73 Gardner Rd, Unit 75",
    "parcel_id": "210-11-07",
    "owner1": "EDWARDS TR, MARK",
    "owner2": "",
    "current_taxes": 30967.05,
    "new_taxes_no_override": 32304.83,
    "override_total_1": 33221.45,
    "override_increase_1": 916.62
  },
  {
    "#": "80 Gardner Rd (205A-16-00)",
    "$": 3605000,
    "address": "80 Gardner Rd",
    "parcel_id": "205A-16-00",
    "owner1": "FLEMING, JAMES E",
    "owner2": "MCCLAIN, LINDA C",
    "current_taxes": 33280.27,
    "new_taxes_no_override": 34717.98,
    "override_total_1": 35703.07,
    "override_increase_1": 985.1
  },
  {
    "#": "87 Gardner Rd (209-01-00)",
    "$": 2954100,
    "address": "87 Gardner Rd",
    "parcel_id": "209-01-00",
    "owner1": "LAICH, MARCUS & LAURA",
    "owner2": "",
    "current_taxes": 30249.98,
    "new_taxes_no_override": 31556.78,
    "override_total_1": 32452.18,
    "override_increase_1": 895.4
  },
  {
    "#": "92 Gardner Rd (205A-15-01)",
    "$": 2292500,
    "address": "92 Gardner Rd",
    "parcel_id": "205A-15-01",
    "owner1": "FRIEDLAND, AARON E",
    "owner2": "LIEBERT, AVIVA ELISE",
    "current_taxes": 19840.27,
    "new_taxes_no_override": 20697.37,
    "override_total_1": 21284.64,
    "override_increase_1": 587.27
  },
  {
    "#": "96 Gardner Rd (205A-15-00)",
    "$": 2970200,
    "address": "96 Gardner Rd",
    "parcel_id": "205A-15-00",
    "owner1": "WELDON TR, KARIN N",
    "owner2": "",
    "current_taxes": 26779.91,
    "new_taxes_no_override": 27936.8,
    "override_total_1": 28729.49,
    "override_increase_1": 792.69
  },
  {
    "#": "99 Gardner Rd (209-02-00)",
    "$": 2171300,
    "address": "99 Gardner Rd",
    "parcel_id": "209-02-00",
    "owner1": "CORNBLATH TR, POLLY S",
    "owner2": "",
    "current_taxes": 18599.18,
    "new_taxes_no_override": 19402.66,
    "override_total_1": 19953.2,
    "override_increase_1": 550.54
  },
  {
    "#": "104 Gardner Rd (205A-14-00)",
    "$": 3064200,
    "address": "104 Gardner Rd",
    "parcel_id": "205A-14-00",
    "owner1": "SILVERMAN, JASON L & SONIA S",
    "owner2": "",
    "current_taxes": 27742.47,
    "new_taxes_no_override": 28940.94,
    "override_total_1": 29762.12,
    "override_increase_1": 821.18
  },
  {
    "#": "105 Gardner Rd (209-02-01)",
    "$": 2846200,
    "address": "105 Gardner Rd",
    "parcel_id": "209-02-01",
    "owner1": "HUGHES, BRYAN R & POLLYANNA C",
    "owner2": "",
    "current_taxes": 25510.15,
    "new_taxes_no_override": 26612.19,
    "override_total_1": 27367.29,
    "override_increase_1": 755.1
  },
  {
    "#": "112 Gardner Rd (205A-13-00)",
    "$": 2680700,
    "address": "112 Gardner Rd",
    "parcel_id": "205A-13-00",
    "owner1": "ROSENBERG, WILLIAM S",
    "owner2": "SCHWINDER, TINA",
    "current_taxes": 23815.43,
    "new_taxes_no_override": 24844.26,
    "override_total_1": 25549.19,
    "override_increase_1": 704.94
  },
  {
    "#": "117 Gardner Rd (209A-05-00)",
    "$": 2634700,
    "address": "117 Gardner Rd",
    "parcel_id": "209A-05-00",
    "owner1": "SHUBENTSOV, TRS, YEFIM & VERA",
    "owner2": "",
    "current_taxes": 23344.39,
    "new_taxes_no_override": 24352.87,
    "override_total_1": 25043.86,
    "override_increase_1": 690.99
  },
  {
    "#": "118 Gardner Rd (205A-12-00)",
    "$": 2279500,
    "address": "118 Gardner Rd",
    "parcel_id": "205A-12-00",
    "owner1": "LINDFORS TRS, KARIN R",
    "owner2": "SLOTNICK TRS, WILLIAM E",
    "current_taxes": 19707.15,
    "new_taxes_no_override": 20558.5,
    "override_total_1": 21141.83,
    "override_increase_1": 583.33
  },
  {
    "#": "123 Gardner Rd (209A-06-00)",
    "$": 3623900,
    "address": "123 Gardner Rd",
    "parcel_id": "209A-06-00",
    "owner1": "SANIEOFF, YOUSEF",
    "owner2": "",
    "current_taxes": 37108.74,
    "new_taxes_no_override": 38711.84,
    "override_total_1": 39810.26,
    "override_increase_1": 1098.42
  },
  {
    "#": "128 Gardner Rd (205A-11-00)",
    "$": 1742000,
    "address": "128 Gardner Rd",
    "parcel_id": "205A-11-00",
    "owner1": "LU, JIE",
    "owner2": "",
    "current_taxes": 14203.15,
    "new_taxes_no_override": 14816.73,
    "override_total_1": 15237.14,
    "override_increase_1": 420.41
  },
  {
    "#": "130 Gardner Rd (205A-10-00)",
    "$": 1134400,
    "address": "130 Gardner Rd",
    "parcel_id": "205A-10-00",
    "owner1": "GUREN TRS, ADAM M",
    "owner2": "LEWANDOWSKI, KATHERINE CHAFFFEE",
    "current_taxes": 11616.26,
    "new_taxes_no_override": 12118.08,
    "override_total_1": 12461.92,
    "override_increase_1": 343.84
  },
  {
    "#": "131 Gardner Rd, Unit 1 (209A-07-01)",
    "$": 1472900,
    "address": "131 Gardner Rd, Unit 1",
    "parcel_id": "209A-07-01",
    "owner1": "COLLINS, BRIAN J",
    "owner2": "MORAN, BARBARA M",
    "current_taxes": 11447.56,
    "new_taxes_no_override": 11942.09,
    "override_total_1": 12280.94,
    "override_increase_1": 338.85
  },
  {
    "#": "131 Gardner Rd, Unit 2 (209A-07-02)",
    "$": 2104600,
    "address": "131 Gardner Rd, Unit 2",
    "parcel_id": "209A-07-02",
    "owner1": "KAZIS TRS, RICHARD F",
    "owner2": "MEDVEDOW, JILL S",
    "current_taxes": 21551.1,
    "new_taxes_no_override": 22482.11,
    "override_total_1": 23120.02,
    "override_increase_1": 637.91
  },
  {
    "#": "137 Gardner Rd (209A-08-00)",
    "$": 3439000,
    "address": "137 Gardner Rd",
    "parcel_id": "209A-08-00",
    "owner1": "BEKEFI, GEORGE & CHAIA",
    "owner2": "",
    "current_taxes": 31580.43,
    "new_taxes_no_override": 32944.7,
    "override_total_1": 33879.49,
    "override_increase_1": 934.78
  },
  {
    "#": "143 Gardner Rd (222-14-03)",
    "$": 2667200,
    "address": "143 Gardner Rd",
    "parcel_id": "222-14-03",
    "owner1": "LEBOWITZ, ELLIOT & BARBARA",
    "owner2": "",
    "current_taxes": 23677.19,
    "new_taxes_no_override": 24700.04,
    "override_total_1": 25400.89,
    "override_increase_1": 700.84
  },
  {
    "#": "150 Gardner Rd (204-12-00)",
    "$": 4709600,
    "address": "150 Gardner Rd",
    "parcel_id": "204-12-00",
    "owner1": "JUDD, ISAAC & ALISON",
    "owner2": "",
    "current_taxes": 44591.37,
    "new_taxes_no_override": 46517.72,
    "override_total_1": 47837.62,
    "override_increase_1": 1319.9
  },
  {
    "#": "151 Gardner Rd (222-14-04)",
    "$": 2357600,
    "address": "151 Gardner Rd",
    "parcel_id": "222-14-04",
    "owner1": "SAMANTA, RITIRUPA",
    "owner2": "",
    "current_taxes": 24141.82,
    "new_taxes_no_override": 25184.75,
    "override_total_1": 25899.34,
    "override_increase_1": 714.6
  },
  {
    "#": "155 Gardner Rd (222-14-05)",
    "$": 2638700,
    "address": "155 Gardner Rd",
    "parcel_id": "222-14-05",
    "owner1": "WEINSTOCK TR, JENNIFER C",
    "owner2": "",
    "current_taxes": 23385.35,
    "new_taxes_no_override": 24395.6,
    "override_total_1": 25087.8,
    "override_increase_1": 692.21
  },
  {
    "#": "161 Gardner Rd (222-15-00)",
    "$": 4035900,
    "address": "161 Gardner Rd",
    "parcel_id": "222-15-00",
    "owner1": "KATZ, NATHAN A & AMY",
    "owner2": "",
    "current_taxes": 37692.68,
    "new_taxes_no_override": 39321.0,
    "override_total_1": 40436.71,
    "override_increase_1": 1115.7
  },
  {
    "#": "164 Gardner Rd (204-11-00)",
    "$": 3771300,
    "address": "164 Gardner Rd",
    "parcel_id": "204-11-00",
    "owner1": "SHOAP, LESTER & MARY ANNE",
    "owner2": "",
    "current_taxes": 34983.18,
    "new_taxes_no_override": 36494.45,
    "override_total_1": 37529.96,
    "override_increase_1": 1035.5
  },
  {
    "#": "168 Gardner Rd (204-10-01)",
    "$": 2751100,
    "address": "168 Gardner Rd",
    "parcel_id": "204-10-01",
    "owner1": "ABBETT, SARAH K & JONATHAN M",
    "owner2": "",
    "current_taxes": 24536.33,
    "new_taxes_no_override": 25596.3,
    "override_total_1": 26322.57,
    "override_increase_1": 726.28
  },
  {
    "#": "171 Gardner Rd (222-15-01)",
    "$": 2664900,
    "address": "171 Gardner Rd",
    "parcel_id": "222-15-01",
    "owner1": "PIER, DANIELLE BENNETT",
    "owner2": "HENDERSON, DANIEL EDWARD",
    "current_taxes": 23653.64,
    "new_taxes_no_override": 24675.48,
    "override_total_1": 25375.62,
    "override_increase_1": 700.15
  },
  {
    "#": "174 Gardner Rd (204-10-00)",
    "$": 3367100,
    "address": "174 Gardner Rd",
    "parcel_id": "204-10-00",
    "owner1": "BENTLEY, MICHAEL",
    "owner2": "",
    "current_taxes": 34479.1,
    "new_taxes_no_override": 35968.6,
    "override_total_1": 36989.18,
    "override_increase_1": 1020.58
  },
  {
    "#": "177 Gardner Rd (222-15-02)",
    "$": 3024100,
    "address": "177 Gardner Rd",
    "parcel_id": "222-15-02",
    "owner1": "GEWURZ, RISA L",
    "owner2": "",
    "current_taxes": 27331.85,
    "new_taxes_no_override": 28512.59,
    "override_total_1": 29321.61,
    "override_increase_1": 809.02
  },
  {
    "#": "180 Gardner Rd (204-09-01)",
    "$": 2786600,
    "address": "180 Gardner Rd",
    "parcel_id": "204-09-01",
    "owner1": "ABRAMOV, RON & ESTHER",
    "owner2": "",
    "current_taxes": 24899.85,
    "new_taxes_no_override": 25975.52,
    "override_total_1": 26712.56,
    "override_increase_1": 737.04
  },
  {
    "#": "183 Gardner Rd (222-16-00)",
    "$": 2426400,
    "address": "183 Gardner Rd",
    "parcel_id": "222-16-00",
    "owner1": "DAVIDOW TRS, THOMAS D & CAROL",
    "owner2": "",
    "current_taxes": 21211.4,
    "new_taxes_no_override": 22127.73,
    "override_total_1": 22755.59,
    "override_increase_1": 627.86
  },
  {
    "#": "186 Gardner Rd (204-09-00)",
    "$": 2304700,
    "address": "186 Gardner Rd",
    "parcel_id": "204-09-00",
    "owner1": "GALPER, JONAS B & LINDA J",
    "owner2": "",
    "current_taxes": 19965.19,
    "new_taxes_no_override": 20827.69,
    "override_total_1": 21418.66,
    "override_increase_1": 590.97
  },
  {
    "#": "187 Gardner Rd (222-16-01)",
    "$": 2239600,
    "address": "187 Gardner Rd",
    "parcel_id": "222-16-01",
    "owner1": "HAMER TR, HELENITA S",
    "owner2": "",
    "current_taxes": 19298.57,
    "new_taxes_no_override": 20132.27,
    "override_total_1": 20703.51,
    "override_increase_1": 571.24
  },
  {
    "#": "193 Gardner Rd (222-17-00)",
    "$": 2938500,
    "address": "193 Gardner Rd",
    "parcel_id": "222-17-00",
    "owner1": "BRENDEL, REBECCA WEINTRAUB",
    "owner2": "",
    "current_taxes": 26455.31,
    "new_taxes_no_override": 27598.18,
    "override_total_1": 28381.26,
    "override_increase_1": 783.08
  },
  {
    "#": "194 Gardner Rd (204-08-00)",
    "$": 2899500,
    "address": "194 Gardner Rd",
    "parcel_id": "204-08-00",
    "owner1": "CUGINI, TR, JOSEPH A",
    "owner2": "",
    "current_taxes": 26055.95,
    "new_taxes_no_override": 27181.57,
    "override_total_1": 27952.82,
    "override_increase_1": 771.26
  },
  {
    "#": "197 Gardner Rd (222-17-01)",
    "$": 3104300,
    "address": "197 Gardner Rd",
    "parcel_id": "222-17-01",
    "owner1": "LADUZINSKI, COLLEEN E",
    "owner2": "",
    "current_taxes": 28153.1,
    "new_taxes_no_override": 29369.31,
    "override_total_1": 30202.65,
    "override_increase_1": 833.33
  },
  {
    "#": "200 Gardner Rd (204-07-01)",
    "$": 3334600,
    "address": "200 Gardner Rd",
    "parcel_id": "204-07-01",
    "owner1": "WEINSTEIN TRS, ROBERT S",
    "owner2": "GINSBURG, ELIZABETH S",
    "current_taxes": 30511.37,
    "new_taxes_no_override": 31829.46,
    "override_total_1": 32732.6,
    "override_increase_1": 903.14
  },
  {
    "#": "205 Gardner Rd (222-18-00)",
    "$": 2279000,
    "address": "205 Gardner Rd",
    "parcel_id": "222-18-00",
    "owner1": "PORITZ, ANDY H & RUTH",
    "owner2": "",
    "current_taxes": 19702.03,
    "new_taxes_no_override": 20553.16,
    "override_total_1": 21136.34,
    "override_increase_1": 583.18
  },
  {
    "#": "208 Gardner Rd (204-07-00)",
    "$": 2746300,
    "address": "208 Gardner Rd",
    "parcel_id": "204-07-00",
    "owner1": "MCCLUSKEY, ROBERT T & JEAN W",
    "owner2": "",
    "current_taxes": 28122.11,
    "new_taxes_no_override": 29336.99,
    "override_total_1": 30169.4,
    "override_increase_1": 832.41
  },
  {
    "#": "213 Gardner Rd (222-19-00)",
    "$": 3408200,
    "address": "213 Gardner Rd",
    "parcel_id": "222-19-00",
    "owner1": "LIVE OAK NUMBER ONE INC",
    "owner2": "",
    "current_taxes": 31265.03,
    "new_taxes_no_override": 32615.68,
    "override_total_1": 33541.12,
    "override_increase_1": 925.44
  },
  {
    "#": "216 Gardner Rd (204-06-00)",
    "$": 3256900,
    "address": "216 Gardner Rd",
    "parcel_id": "204-06-00",
    "owner1": "KATZ TRS, HOWARD M & ANN LEHMAN",
    "owner2": "",
    "current_taxes": 29715.72,
    "new_taxes_no_override": 30999.44,
    "override_total_1": 31879.02,
    "override_increase_1": 879.59
  },
  {
    "#": "221 Gardner Rd (222-20-05)",
    "$": 4085900,
    "address": "221 Gardner Rd",
    "parcel_id": "222-20-05",
    "owner1": "MATVEEV, ALEXANDER",
    "owner2": "ZLOCHISTI, MARINA",
    "current_taxes": 41839.62,
    "new_taxes_no_override": 43647.09,
    "override_total_1": 44885.54,
    "override_increase_1": 1238.45
  },
  {
    "#": "225 Gardner Rd (222-20-04)",
    "$": 3929400,
    "address": "225 Gardner Rd",
    "parcel_id": "222-20-04",
    "owner1": "HAO TR, JING",
    "owner2": "",
    "current_taxes": 36602.12,
    "new_taxes_no_override": 38183.33,
    "override_total_1": 39266.75,
    "override_increase_1": 1083.42
  },
  {
    "#": "11 Garrison Rd, Unit 1 (224-01-06)",
    "$": 528300,
    "address": "11 Garrison Rd, Unit 1",
    "parcel_id": "224-01-06",
    "owner1": "DONG, CHUANFEI",
    "owner2": "LIU, NAN",
    "current_taxes": 1774.86,
    "new_taxes_no_override": 1851.53,
    "override_total_1": 1904.07,
    "override_increase_1": 52.54
  },
  {
    "#": "11 Garrison Rd, Unit 2 (224-01-01)",
    "$": 744200,
    "address": "11 Garrison Rd, Unit 2",
    "parcel_id": "224-01-01",
    "owner1": "ZIMMERMAN, BRANDON",
    "owner2": "",
    "current_taxes": 7620.61,
    "new_taxes_no_override": 7949.82,
    "override_total_1": 8175.39,
    "override_increase_1": 225.57
  },
  {
    "#": "11 Garrison Rd, Unit 3 (224-01-02)",
    "$": 479600,
    "address": "11 Garrison Rd, Unit 3",
    "parcel_id": "224-01-02",
    "owner1": "YAZIGI TR ET AL, RIM",
    "owner2": "",
    "current_taxes": 4911.1,
    "new_taxes_no_override": 5123.26,
    "override_total_1": 5268.63,
    "override_increase_1": 145.37
  },
  {
    "#": "11 Garrison Rd, Unit 4 (224-01-03)",
    "$": 1211000,
    "address": "11 Garrison Rd, Unit 4",
    "parcel_id": "224-01-03",
    "owner1": "LI, CONG",
    "owner2": "GRONDIN, JULIEN LOUIS PHILIPPE",
    "current_taxes": 8765.71,
    "new_taxes_no_override": 9144.39,
    "override_total_1": 9403.85,
    "override_increase_1": 259.47
  },
  {
    "#": "11 Garrison Rd, Unit 5 (224-01-04)",
    "$": 1165000,
    "address": "11 Garrison Rd, Unit 5",
    "parcel_id": "224-01-04",
    "owner1": "GILL TRS, ROBERT J & VIRGINIA C",
    "owner2": "",
    "current_taxes": 8294.67,
    "new_taxes_no_override": 8653.0,
    "override_total_1": 8898.52,
    "override_increase_1": 245.52
  },
  {
    "#": "11 Garrison Rd, Unit 6 (224-01-05)",
    "$": 615400,
    "address": "11 Garrison Rd, Unit 6",
    "parcel_id": "224-01-05",
    "owner1": "PRUKOP TRS, CHRISTOPHER T",
    "owner2": "GILL, ROBERT J",
    "current_taxes": 2666.76,
    "new_taxes_no_override": 2781.96,
    "override_total_1": 2860.9,
    "override_increase_1": 78.94
  },
  {
    "#": "13 Garrison Rd, Unit 1 (224-02-05)",
    "$": 466200,
    "address": "13 Garrison Rd, Unit 1",
    "parcel_id": "224-02-05",
    "owner1": "UZUMCU, ALYSSA",
    "owner2": "",
    "current_taxes": 1138.95,
    "new_taxes_no_override": 1188.15,
    "override_total_1": 1221.87,
    "override_increase_1": 33.71
  },
  {
    "#": "13 Garrison Rd, Unit 2 & P-A (224-02-01)",
    "$": 642500,
    "address": "13 Garrison Rd, Unit 2 & P-A",
    "parcel_id": "224-02-01",
    "owner1": "MARTIN , SARA",
    "owner2": "JACOBOWITZ, ELLIOTT & JESSI",
    "current_taxes": 2944.27,
    "new_taxes_no_override": 3071.46,
    "override_total_1": 3158.61,
    "override_increase_1": 87.15
  },
  {
    "#": "13 Garrison Rd, Unit 3 (224-02-02)",
    "$": 373300,
    "address": "13 Garrison Rd, Unit 3",
    "parcel_id": "224-02-02",
    "owner1": "KRESS, NICHOLAS E",
    "owner2": "",
    "current_taxes": 3822.59,
    "new_taxes_no_override": 3987.73,
    "override_total_1": 4100.87,
    "override_increase_1": 113.15
  },
  {
    "#": "13 Garrison Rd, Unit 4 (224-02-03)",
    "$": 434400,
    "address": "13 Garrison Rd, Unit 4",
    "parcel_id": "224-02-03",
    "owner1": "GRB4 LLC",
    "owner2": "",
    "current_taxes": 4448.26,
    "new_taxes_no_override": 4640.42,
    "override_total_1": 4772.09,
    "override_increase_1": 131.67
  },
  {
    "#": "13 Garrison Rd, Unit 5 (224-02-04)",
    "$": 1237000,
    "address": "13 Garrison Rd, Unit 5",
    "parcel_id": "224-02-04",
    "owner1": "HYEP, IVAN",
    "owner2": "TUM, KIMBERLY",
    "current_taxes": 12666.88,
    "new_taxes_no_override": 13214.09,
    "override_total_1": 13589.03,
    "override_increase_1": 374.94
  },
  {
    "#": "15 Garrison Rd (224-03-00)",
    "$": 2850100,
    "address": "15 Garrison Rd",
    "parcel_id": "224-03-00",
    "owner1": "15 GARRISON LLC",
    "owner2": "",
    "current_taxes": 29185.02,
    "new_taxes_no_override": 30445.81,
    "override_total_1": 31309.69,
    "override_increase_1": 863.88
  },
  {
    "#": "16 Garrison Rd, Unit 1 (221-15-08)",
    "$": 925500,
    "address": "16 Garrison Rd, Unit 1",
    "parcel_id": "221-15-08",
    "owner1": "CHAN, ELIZABETH HUI",
    "owner2": "",
    "current_taxes": 9477.12,
    "new_taxes_no_override": 9886.53,
    "override_total_1": 10167.05,
    "override_increase_1": 280.52
  },
  {
    "#": "16 Garrison Rd, Unit 2 (221-15-01)",
    "$": 908400,
    "address": "16 Garrison Rd, Unit 2",
    "parcel_id": "221-15-01",
    "owner1": "MURPHY, WILLIAM E",
    "owner2": "",
    "current_taxes": 5667.08,
    "new_taxes_no_override": 5911.9,
    "override_total_1": 6079.64,
    "override_increase_1": 167.75
  },
  {
    "#": "16 Garrison Rd, Unit 3 (221-15-02)",
    "$": 896300,
    "address": "16 Garrison Rd, Unit 3",
    "parcel_id": "221-15-02",
    "owner1": "MOHIUDDIN TR, ROMANA",
    "owner2": "",
    "current_taxes": 5543.18,
    "new_taxes_no_override": 5782.65,
    "override_total_1": 5946.72,
    "override_increase_1": 164.08
  },
  {
    "#": "16 Garrison Rd, Unit 4 (221-15-03)",
    "$": 1049700,
    "address": "16 Garrison Rd, Unit 4",
    "parcel_id": "221-15-03",
    "owner1": "WINTHROP 168 LLC",
    "owner2": "",
    "current_taxes": 10748.93,
    "new_taxes_no_override": 11213.28,
    "override_total_1": 11531.45,
    "override_increase_1": 318.17
  },
  {
    "#": "16 Garrison Rd, Unit 5 (221-15-04)",
    "$": 925500,
    "address": "16 Garrison Rd, Unit 5",
    "parcel_id": "221-15-04",
    "owner1": "RISSER, THOMAS",
    "owner2": "",
    "current_taxes": 9477.12,
    "new_taxes_no_override": 9886.53,
    "override_total_1": 10167.05,
    "override_increase_1": 280.52
  },
  {
    "#": "16 Garrison Rd, Unit 6 (221-15-05)",
    "$": 1047000,
    "address": "16 Garrison Rd, Unit 6",
    "parcel_id": "221-15-05",
    "owner1": "ZHANG, NU",
    "owner2": "XIAO, QIN",
    "current_taxes": 10721.28,
    "new_taxes_no_override": 11184.44,
    "override_total_1": 11501.79,
    "override_increase_1": 317.35
  },
  {
    "#": "16 Garrison Rd, Unit 7 (221-15-06)",
    "$": 717800,
    "address": "16 Garrison Rd, Unit 7",
    "parcel_id": "221-15-06",
    "owner1": "KIM, TAEYOUNG",
    "owner2": "HUH, JINI",
    "current_taxes": 7350.27,
    "new_taxes_no_override": 7667.8,
    "override_total_1": 7885.37,
    "override_increase_1": 217.57
  },
  {
    "#": "16 Garrison Rd, Unit 8 (221-15-07)",
    "$": 593200,
    "address": "16 Garrison Rd, Unit 8",
    "parcel_id": "221-15-07",
    "owner1": "SIMPSON, WILLIAM MARSHALL",
    "owner2": "",
    "current_taxes": 6074.37,
    "new_taxes_no_override": 6336.78,
    "override_total_1": 6516.58,
    "override_increase_1": 179.8
  },
  {
    "#": "17 Garrison Rd, Unit 1 (224-04-03)",
    "$": 787500,
    "address": "17 Garrison Rd, Unit 1",
    "parcel_id": "224-04-03",
    "owner1": "ZHANG, ZHIYUAN",
    "owner2": "",
    "current_taxes": 8064.0,
    "new_taxes_no_override": 8412.36,
    "override_total_1": 8651.06,
    "override_increase_1": 238.69
  },
  {
    "#": "17 Garrison Rd, Unit 2 (224-04-01)",
    "$": 774500,
    "address": "17 Garrison Rd, Unit 2",
    "parcel_id": "224-04-01",
    "owner1": "STEFANIDAKIS, MICHAEL",
    "owner2": "",
    "current_taxes": 7930.88,
    "new_taxes_no_override": 8273.49,
    "override_total_1": 8508.25,
    "override_increase_1": 234.75
  },
  {
    "#": "17 Garrison Rd, Unit 3 (224-04-02)",
    "$": 1326800,
    "address": "17 Garrison Rd, Unit 3",
    "parcel_id": "224-04-02",
    "owner1": "MELCHER TR, SUSAN M B",
    "owner2": "",
    "current_taxes": 9951.5,
    "new_taxes_no_override": 10381.4,
    "override_total_1": 10675.97,
    "override_increase_1": 294.56
  },
  {
    "#": "19 Garrison Rd, Unit 1 (224-05-03)",
    "$": 818900,
    "address": "19 Garrison Rd, Unit 1",
    "parcel_id": "224-05-03",
    "owner1": "DUVAL, MICHELE T",
    "owner2": "",
    "current_taxes": 4750.6,
    "new_taxes_no_override": 4955.83,
    "override_total_1": 5096.44,
    "override_increase_1": 140.62
  },
  {
    "#": "19 Garrison Rd, Unit 2 (224-05-01)",
    "$": 813300,
    "address": "19 Garrison Rd, Unit 2",
    "parcel_id": "224-05-01",
    "owner1": "LIN, JIANGYIN",
    "owner2": "",
    "current_taxes": 4693.26,
    "new_taxes_no_override": 4896.01,
    "override_total_1": 5034.93,
    "override_increase_1": 138.92
  },
  {
    "#": "19 Garrison Rd, Unit 3 (224-05-02)",
    "$": 1321900,
    "address": "19 Garrison Rd, Unit 3",
    "parcel_id": "224-05-02",
    "owner1": "MEYERS, JOHN E",
    "owner2": "RETAN, KATHERINE A",
    "current_taxes": 9901.32,
    "new_taxes_no_override": 10329.06,
    "override_total_1": 10622.14,
    "override_increase_1": 293.08
  },
  {
    "#": "21 Garrison Rd (224-06-00)",
    "$": 2471100,
    "address": "21 Garrison Rd",
    "parcel_id": "224-06-00",
    "owner1": "PENDIAS, PAMELA",
    "owner2": "",
    "current_taxes": 21669.13,
    "new_taxes_no_override": 22605.24,
    "override_total_1": 23246.64,
    "override_increase_1": 641.41
  },
  {
    "#": "22 Garrison Rd, Unit 1 (221-14-06)",
    "$": 707400,
    "address": "22 Garrison Rd, Unit 1",
    "parcel_id": "221-14-06",
    "owner1": "NAPOLITANO, BRIAN N",
    "owner2": "NYAMWANDA, JACQUELINE A",
    "current_taxes": 3608.84,
    "new_taxes_no_override": 3764.74,
    "override_total_1": 3871.56,
    "override_increase_1": 106.82
  },
  {
    "#": "22 Garrison Rd, Unit 2 (221-14-01)",
    "$": 619200,
    "address": "22 Garrison Rd, Unit 2",
    "parcel_id": "221-14-01",
    "owner1": "MAO, ZHENHUA",
    "owner2": "WU, YUJUE",
    "current_taxes": 6340.61,
    "new_taxes_no_override": 6614.52,
    "override_total_1": 6802.21,
    "override_increase_1": 187.68
  },
  {
    "#": "22 Garrison Rd, Unit 3 (221-14-02)",
    "$": 737400,
    "address": "22 Garrison Rd, Unit 3",
    "parcel_id": "221-14-02",
    "owner1": "HSU, CAROLINE MARIE",
    "owner2": "",
    "current_taxes": 3916.04,
    "new_taxes_no_override": 4085.21,
    "override_total_1": 4201.13,
    "override_increase_1": 115.91
  },
  {
    "#": "22 Garrison Rd, Unit 4 (221-14-03)",
    "$": 680300,
    "address": "22 Garrison Rd, Unit 4",
    "parcel_id": "221-14-03",
    "owner1": "KORNFELD, B MINDE",
    "owner2": "",
    "current_taxes": 3331.34,
    "new_taxes_no_override": 3475.25,
    "override_total_1": 3573.86,
    "override_increase_1": 98.61
  },
  {
    "#": "22 Garrison Rd, Unit 5 (221-14-04)",
    "$": 725800,
    "address": "22 Garrison Rd, Unit 5",
    "parcel_id": "221-14-04",
    "owner1": "SHIPITSIN, MICHAIL",
    "owner2": "ULYANOVA, NATALIA P",
    "current_taxes": 7432.19,
    "new_taxes_no_override": 7753.26,
    "override_total_1": 7973.25,
    "override_increase_1": 219.99
  },
  {
    "#": "22 Garrison Rd, Unit 6 (221-14-05)",
    "$": 691900,
    "address": "22 Garrison Rd, Unit 6",
    "parcel_id": "221-14-05",
    "owner1": "MILLER, GARY",
    "owner2": "",
    "current_taxes": 3450.12,
    "new_taxes_no_override": 3599.17,
    "override_total_1": 3701.29,
    "override_increase_1": 102.12
  },
  {
    "#": "23 Garrison Rd (224-07-00)",
    "$": 2834100,
    "address": "23 Garrison Rd",
    "parcel_id": "224-07-00",
    "owner1": "OAK HILL PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 29021.18,
    "new_taxes_no_override": 30274.89,
    "override_total_1": 31133.92,
    "override_increase_1": 859.03
  },
  {
    "#": "25 Garrison Rd (224-08-00)",
    "$": 3553000,
    "address": "25 Garrison Rd",
    "parcel_id": "224-08-00",
    "owner1": "OAK HILL PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 36382.72,
    "new_taxes_no_override": 37954.45,
    "override_total_1": 39031.38,
    "override_increase_1": 1076.93
  },
  {
    "#": "33 Garrison Rd (224-09-00)",
    "$": 2396900,
    "address": "33 Garrison Rd",
    "parcel_id": "224-09-00",
    "owner1": "BLOOM TR, JILL BETZ",
    "owner2": "",
    "current_taxes": 20909.32,
    "new_taxes_no_override": 21812.6,
    "override_total_1": 22431.52,
    "override_increase_1": 618.92
  },
  {
    "#": "34 Garrison Rd, Unit 1 (223-17-01)",
    "$": 624400,
    "address": "34 Garrison Rd, Unit 1",
    "parcel_id": "223-17-01",
    "owner1": "EMORY, WENDY",
    "owner2": "",
    "current_taxes": 2758.92,
    "new_taxes_no_override": 2878.11,
    "override_total_1": 2959.77,
    "override_increase_1": 81.66
  },
  {
    "#": "34 Garrison Rd, Unit 1B (223-17-07)",
    "$": 538800,
    "address": "34 Garrison Rd, Unit 1B",
    "parcel_id": "223-17-07",
    "owner1": "RATCHFORD TR, RACHEL L",
    "owner2": "",
    "current_taxes": 1882.38,
    "new_taxes_no_override": 1963.7,
    "override_total_1": 2019.42,
    "override_increase_1": 55.72
  },
  {
    "#": "34 Garrison Rd, Unit 2 (223-17-02)",
    "$": 747200,
    "address": "34 Garrison Rd, Unit 2",
    "parcel_id": "223-17-02",
    "owner1": "TRICCA, JOSEPH ANTHONY",
    "owner2": "VO, LINDA",
    "current_taxes": 7651.33,
    "new_taxes_no_override": 7981.87,
    "override_total_1": 8208.35,
    "override_increase_1": 226.48
  },
  {
    "#": "34 Garrison Rd, Unit 3 (223-17-03)",
    "$": 785400,
    "address": "34 Garrison Rd, Unit 3",
    "parcel_id": "223-17-03",
    "owner1": "REED, GEORGE F & JENNIFER T",
    "owner2": "",
    "current_taxes": 4407.56,
    "new_taxes_no_override": 4597.97,
    "override_total_1": 4728.43,
    "override_increase_1": 130.46
  },
  {
    "#": "34 Garrison Rd, Unit 4 (223-17-04)",
    "$": 693700,
    "address": "34 Garrison Rd, Unit 4",
    "parcel_id": "223-17-04",
    "owner1": "KUTUZOV, MIKHAIL",
    "owner2": "",
    "current_taxes": 3468.55,
    "new_taxes_no_override": 3618.39,
    "override_total_1": 3721.06,
    "override_increase_1": 102.67
  },
  {
    "#": "34 Garrison Rd, Unit 5 (223-17-05)",
    "$": 760400,
    "address": "34 Garrison Rd, Unit 5",
    "parcel_id": "223-17-05",
    "owner1": "ZHANG, RUIOU P",
    "owner2": "YUAN, YI",
    "current_taxes": 4151.56,
    "new_taxes_no_override": 4330.91,
    "override_total_1": 4453.79,
    "override_increase_1": 122.89
  },
  {
    "#": "34 Garrison Rd, Unit 6 (223-17-06)",
    "$": 862700,
    "address": "34 Garrison Rd, Unit 6",
    "parcel_id": "223-17-06",
    "owner1": "WOHL, DONNA & EREZ & MAYA ROSE",
    "owner2": "",
    "current_taxes": 5199.11,
    "new_taxes_no_override": 5423.71,
    "override_total_1": 5577.61,
    "override_increase_1": 153.89
  },
  {
    "#": "35 Garrison Rd (224-10-00)",
    "$": 3915600,
    "address": "35 Garrison Rd",
    "parcel_id": "224-10-00",
    "owner1": "WOOD-DYER TR, PAULA",
    "owner2": "",
    "current_taxes": 40095.74,
    "new_taxes_no_override": 41827.88,
    "override_total_1": 43014.71,
    "override_increase_1": 1186.83
  },
  {
    "#": "37 Garrison Rd (224-11-00)",
    "$": 2786900,
    "address": "37 Garrison Rd",
    "parcel_id": "224-11-00",
    "owner1": "WOOD-DYER TR, PAULA",
    "owner2": "",
    "current_taxes": 28537.86,
    "new_taxes_no_override": 29770.7,
    "override_total_1": 30615.42,
    "override_increase_1": 844.72
  },
  {
    "#": "38 Garrison Rd, Unit 1 (223-16-03)",
    "$": 1295100,
    "address": "38 Garrison Rd, Unit 1",
    "parcel_id": "223-16-03",
    "owner1": "ORENGO LIFE ESTATE, ALBERTO & MARGARITA ELISA",
    "owner2": "",
    "current_taxes": 9626.89,
    "new_taxes_no_override": 10042.77,
    "override_total_1": 10327.73,
    "override_increase_1": 284.96
  },
  {
    "#": "38 Garrison Rd, Unit 2 (223-16-01)",
    "$": 1286000,
    "address": "38 Garrison Rd, Unit 2",
    "parcel_id": "223-16-01",
    "owner1": "FERGUSON, DAVID GRANT & ELIZABETH",
    "owner2": "",
    "current_taxes": 9533.71,
    "new_taxes_no_override": 9945.57,
    "override_total_1": 10227.76,
    "override_increase_1": 282.2
  },
  {
    "#": "38 Garrison Rd, Unit 3 (223-16-02)",
    "$": 1310000,
    "address": "38 Garrison Rd, Unit 3",
    "parcel_id": "223-16-02",
    "owner1": "SKILLINS TRS, DOUGLAS B & KAREN A J",
    "owner2": "",
    "current_taxes": 9779.47,
    "new_taxes_no_override": 10201.94,
    "override_total_1": 10491.42,
    "override_increase_1": 289.47
  },
  {
    "#": "39 Garrison Rd (224-12-00)",
    "$": 3076600,
    "address": "39 Garrison Rd",
    "parcel_id": "224-12-00",
    "owner1": "BROOKLINE PROPERTY AT GARRISON RD LLC",
    "owner2": "",
    "current_taxes": 31504.38,
    "new_taxes_no_override": 32865.37,
    "override_total_1": 33797.9,
    "override_increase_1": 932.53
  },
  {
    "#": "41 Garrison Rd (224-13-00)",
    "$": 2786600,
    "address": "41 Garrison Rd",
    "parcel_id": "224-13-00",
    "owner1": "BROOKLINE COMMUNITY MENTAL, HEALTH CTR",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "41 Garrison Rd (224-14-00)",
    "$": 2963700,
    "address": "41 Garrison Rd",
    "parcel_id": "224-14-00",
    "owner1": "BROOKLINE COMMUNITY, MENTAL HEALTH CTR",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "42 Garrison Rd, Unit 1 P1 P2 (223-15-03)",
    "$": 1846400,
    "address": "42 Garrison Rd, Unit 1 P1 P2",
    "parcel_id": "223-15-03",
    "owner1": "SMOLLER, KENNETH J & JAIME",
    "owner2": "",
    "current_taxes": 15272.2,
    "new_taxes_no_override": 15931.96,
    "override_total_1": 16384.02,
    "override_increase_1": 452.06
  },
  {
    "#": "42 Garrison Rd, Unit 2 & P6 (223-15-01)",
    "$": 1428200,
    "address": "42 Garrison Rd, Unit 2 & P6",
    "parcel_id": "223-15-01",
    "owner1": "LOSK, DANIEL & KATYA",
    "owner2": "",
    "current_taxes": 10989.83,
    "new_taxes_no_override": 11464.59,
    "override_total_1": 11789.89,
    "override_increase_1": 325.3
  },
  {
    "#": "42 Garrison Rd, Unit 3 & P4 (223-15-02)",
    "$": 1438800,
    "address": "42 Garrison Rd, Unit 3 & P4",
    "parcel_id": "223-15-02",
    "owner1": "LYONS, DANIEL W",
    "owner2": "CUSHING, STANLEY E",
    "current_taxes": 11098.38,
    "new_taxes_no_override": 11577.83,
    "override_total_1": 11906.34,
    "override_increase_1": 328.51
  },
  {
    "#": "45 Garrison Rd (224-15-00)",
    "$": 3542600,
    "address": "45 Garrison Rd",
    "parcel_id": "224-15-00",
    "owner1": "VMR PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 36276.22,
    "new_taxes_no_override": 37843.35,
    "override_total_1": 38917.13,
    "override_increase_1": 1073.78
  },
  {
    "#": "46 Garrison Rd, Unit 1 & P3 (223-14-03)",
    "$": 1269700,
    "address": "46 Garrison Rd, Unit 1 & P3",
    "parcel_id": "223-14-03",
    "owner1": "ROGELL TR, GILLIAN",
    "owner2": "",
    "current_taxes": 9366.79,
    "new_taxes_no_override": 9771.44,
    "override_total_1": 10048.69,
    "override_increase_1": 277.26
  },
  {
    "#": "46 Garrison Rd, Unit 2 & P1-2 (223-14-01)",
    "$": 1438000,
    "address": "46 Garrison Rd, Unit 2 & P1-2",
    "parcel_id": "223-14-01",
    "owner1": "MILLER TR, MATTHEW J",
    "owner2": "",
    "current_taxes": 11090.19,
    "new_taxes_no_override": 11569.29,
    "override_total_1": 11897.56,
    "override_increase_1": 328.27
  },
  {
    "#": "46 Garrison Rd, Unit 3 & P4 (223-14-02)",
    "$": 1421500,
    "address": "46 Garrison Rd, Unit 3 & P4",
    "parcel_id": "223-14-02",
    "owner1": "LOFTUS TRS, JONATHAN L",
    "owner2": "PANICH, DIANE",
    "current_taxes": 10921.23,
    "new_taxes_no_override": 11393.03,
    "override_total_1": 11716.3,
    "override_increase_1": 323.27
  },
  {
    "#": "47 Garrison Rd (224-16-00)",
    "$": 3029400,
    "address": "47 Garrison Rd",
    "parcel_id": "224-16-00",
    "owner1": "ALLEN, SCOTT M & SUSIE",
    "owner2": "",
    "current_taxes": 27386.12,
    "new_taxes_no_override": 28569.2,
    "override_total_1": 29379.83,
    "override_increase_1": 810.63
  },
  {
    "#": "49 Garrison Rd (224-17-00)",
    "$": 3105400,
    "address": "49 Garrison Rd",
    "parcel_id": "224-17-00",
    "owner1": "KARBASSI TRS, JESSICA & MICHAEL",
    "owner2": "",
    "current_taxes": 28164.36,
    "new_taxes_no_override": 29381.06,
    "override_total_1": 30214.73,
    "override_increase_1": 833.67
  },
  {
    "#": "50 Garrison Rd, Unit 1 (223-13-01)",
    "$": 1060900,
    "address": "50 Garrison Rd, Unit 1",
    "parcel_id": "223-13-01",
    "owner1": "BURSTEIN, MICHAEL A & NOMI B",
    "owner2": "",
    "current_taxes": 7228.68,
    "new_taxes_no_override": 7540.96,
    "override_total_1": 7754.93,
    "override_increase_1": 213.97
  },
  {
    "#": "50 Garrison Rd, Unit 2 (223-13-02)",
    "$": 1131500,
    "address": "50 Garrison Rd, Unit 2",
    "parcel_id": "223-13-02",
    "owner1": "BARR, JENNIFER & ANDREW",
    "owner2": "",
    "current_taxes": 7951.63,
    "new_taxes_no_override": 8295.14,
    "override_total_1": 8530.51,
    "override_increase_1": 235.37
  },
  {
    "#": "50 Garrison Rd, Unit 3 (223-13-03)",
    "$": 1130500,
    "address": "50 Garrison Rd, Unit 3",
    "parcel_id": "223-13-03",
    "owner1": "DURAN, RICHARD S",
    "owner2": "SAN DOVAL, ALEXI D",
    "current_taxes": 7941.39,
    "new_taxes_no_override": 8284.46,
    "override_total_1": 8519.52,
    "override_increase_1": 235.07
  },
  {
    "#": "50 Garrison Rd, Unit A (223-13-04)",
    "$": 424400,
    "address": "50 Garrison Rd, Unit A",
    "parcel_id": "223-13-04",
    "owner1": "DAVISON, ELEANOR S",
    "owner2": "",
    "current_taxes": 710.92,
    "new_taxes_no_override": 741.63,
    "override_total_1": 762.67,
    "override_increase_1": 21.04
  },
  {
    "#": "51 Garrison Rd (224-18-00)",
    "$": 2835200,
    "address": "51 Garrison Rd",
    "parcel_id": "224-18-00",
    "owner1": "TAYLOR, SIMON J",
    "owner2": "SALIB-TAYLOR, IRINIE",
    "current_taxes": 25397.51,
    "new_taxes_no_override": 26494.68,
    "override_total_1": 27246.45,
    "override_increase_1": 751.77
  },
  {
    "#": "53 Garrison Rd (224-19-00)",
    "$": 2383200,
    "address": "53 Garrison Rd",
    "parcel_id": "224-19-00",
    "owner1": "GINZBURG TRS, SVETLANA",
    "owner2": "",
    "current_taxes": 20769.03,
    "new_taxes_no_override": 21666.25,
    "override_total_1": 22281.02,
    "override_increase_1": 614.76
  },
  {
    "#": "54 Garrison Rd, Unit 54 (223-12-24)",
    "$": 696300,
    "address": "54 Garrison Rd, Unit 54",
    "parcel_id": "223-12-24",
    "owner1": "MILLER TRS, LORI R",
    "owner2": "HALBROOK, JOHN H",
    "current_taxes": 7130.11,
    "new_taxes_no_override": 7438.13,
    "override_total_1": 7649.18,
    "override_increase_1": 211.05
  },
  {
    "#": "55 Garrison Rd, Unit 1 (224-20-03)",
    "$": 1758600,
    "address": "55 Garrison Rd, Unit 1",
    "parcel_id": "224-20-03",
    "owner1": "ALLYN TR, NICOLE W",
    "owner2": "",
    "current_taxes": 14373.13,
    "new_taxes_no_override": 14994.05,
    "override_total_1": 15419.49,
    "override_increase_1": 425.44
  },
  {
    "#": "55 Garrison Rd, Unit 2 & P2 (224-20-01)",
    "$": 1221200,
    "address": "55 Garrison Rd, Unit 2 & P2",
    "parcel_id": "224-20-01",
    "owner1": "HURD, MARSHALL HINTON MCKANDY",
    "owner2": "RODRIGUEZ, ATHENA MARIA",
    "current_taxes": 8870.15,
    "new_taxes_no_override": 9253.34,
    "override_total_1": 9515.9,
    "override_increase_1": 262.56
  },
  {
    "#": "55 Garrison Rd, Unit 3 (224-20-02)",
    "$": 2028600,
    "address": "55 Garrison Rd, Unit 3",
    "parcel_id": "224-20-02",
    "owner1": "SEIGEL, MICHAEL & CAROLE",
    "owner2": "",
    "current_taxes": 17137.93,
    "new_taxes_no_override": 17878.29,
    "override_total_1": 18385.57,
    "override_increase_1": 507.28
  },
  {
    "#": "56 Garrison Rd, Unit 56 (223-12-25)",
    "$": 487100,
    "address": "56 Garrison Rd, Unit 56",
    "parcel_id": "223-12-25",
    "owner1": "ALMAGRO, JUAN PABLO",
    "owner2": "WEHMEYER, CARRIE",
    "current_taxes": 1352.97,
    "new_taxes_no_override": 1411.42,
    "override_total_1": 1451.47,
    "override_increase_1": 40.05
  },
  {
    "#": " Garrison Rd (224-22-00)",
    "$": 22000,
    "address": " Garrison Rd",
    "parcel_id": "224-22-00",
    "owner1": "BLOOM, JILL B",
    "owner2": "",
    "current_taxes": 225.28,
    "new_taxes_no_override": 235.01,
    "override_total_1": 241.68,
    "override_increase_1": 6.67
  },
  {
    "#": " Garrison Rd (224-22-01)",
    "$": 19800,
    "address": " Garrison Rd",
    "parcel_id": "224-22-01",
    "owner1": "BROOKLINE ASSOC MENTAL HEALTH",
    "owner2": "C/O COMMUNITY MENTAL HEALTH CR",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": " Garrison Rd (224-22-02)",
    "$": 17900,
    "address": " Garrison Rd",
    "parcel_id": "224-22-02",
    "owner1": "BROOKLINE COMMUNITY, MENTAL HEALTH CTR",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": " Garrison Rd (224-22-04)",
    "$": 53900,
    "address": " Garrison Rd",
    "parcel_id": "224-22-04",
    "owner1": "WOOD-DYER TR, PAULA",
    "owner2": "",
    "current_taxes": 551.94,
    "new_taxes_no_override": 575.78,
    "override_total_1": 592.12,
    "override_increase_1": 16.34
  },
  {
    "#": " Garrison Rd (224-22-05)",
    "$": 130900,
    "address": " Garrison Rd",
    "parcel_id": "224-22-05",
    "owner1": "WOOD-DYER, PAULA",
    "owner2": "",
    "current_taxes": 1340.42,
    "new_taxes_no_override": 1398.33,
    "override_total_1": 1438.0,
    "override_increase_1": 39.68
  },
  {
    "#": " Garrison Rd (224-22-06)",
    "$": 42700,
    "address": " Garrison Rd",
    "parcel_id": "224-22-06",
    "owner1": "KARBASSI, MICHAEL AFSHIN & JESSICA LAUREN",
    "owner2": "",
    "current_taxes": 437.25,
    "new_taxes_no_override": 456.14,
    "override_total_1": 469.08,
    "override_increase_1": 12.94
  },
  {
    "#": " Garrison Rd (224-22-07)",
    "$": 85500,
    "address": " Garrison Rd",
    "parcel_id": "224-22-07",
    "owner1": "TAYLOR, SIMON J",
    "owner2": "SALIB-TAYLOR, IRINIE",
    "current_taxes": 875.52,
    "new_taxes_no_override": 913.34,
    "override_total_1": 939.26,
    "override_increase_1": 25.92
  },
  {
    "#": "11 George Ln (352-06-00)",
    "$": 3917500,
    "address": "11 George Ln",
    "parcel_id": "352-06-00",
    "owner1": "SULLIVAN, JOHN & ASHLEIGH S",
    "owner2": "",
    "current_taxes": 36480.27,
    "new_taxes_no_override": 38056.22,
    "override_total_1": 39136.03,
    "override_increase_1": 1079.82
  },
  {
    "#": "29 George Ln (352-07-00)",
    "$": 4102500,
    "address": "29 George Ln",
    "parcel_id": "352-07-00",
    "owner1": "MITHOEFER, KAI",
    "owner2": "",
    "current_taxes": 38374.67,
    "new_taxes_no_override": 40032.46,
    "override_total_1": 41168.35,
    "override_increase_1": 1135.89
  },
  {
    "#": "30 George Ln (352-10-00)",
    "$": 5592200,
    "address": "30 George Ln",
    "parcel_id": "352-10-00",
    "owner1": "FREM TRS, GEORGE & RANIA",
    "owner2": "",
    "current_taxes": 57264.13,
    "new_taxes_no_override": 59737.94,
    "override_total_1": 61432.96,
    "override_increase_1": 1695.02
  },
  {
    "#": "35 George Ln (352-07-01)",
    "$": 5266500,
    "address": "35 George Ln",
    "parcel_id": "352-07-01",
    "owner1": "GEORGAKLIS, CLIFTON C & MARIA L",
    "owner2": "",
    "current_taxes": 50294.03,
    "new_taxes_no_override": 52466.73,
    "override_total_1": 53955.44,
    "override_increase_1": 1488.7
  },
  {
    "#": "3 Gibbs St, Unit 1 & P1-2 (052-10-05)",
    "$": 1488700,
    "address": "3 Gibbs St, Unit 1 & P1-2",
    "parcel_id": "052-10-05",
    "owner1": "SCHWAB, HILLARY ADA",
    "owner2": "JACOBSON, SCOTT RICHARD",
    "current_taxes": 11609.35,
    "new_taxes_no_override": 12110.87,
    "override_total_1": 12454.51,
    "override_increase_1": 343.64
  },
  {
    "#": "6 Gibbs St, Unit 2 (051-27-02)",
    "$": 728800,
    "address": "6 Gibbs St, Unit 2",
    "parcel_id": "051-27-02",
    "owner1": "BLOCH TRS, JEREMY EBIN",
    "owner2": "GREENWALD, ANNE LISA",
    "current_taxes": 7462.91,
    "new_taxes_no_override": 7785.31,
    "override_total_1": 8006.21,
    "override_increase_1": 220.9
  },
  {
    "#": "6 Gibbs St, Unit 4 (051-27-04)",
    "$": 1130500,
    "address": "6 Gibbs St, Unit 4",
    "parcel_id": "051-27-04",
    "owner1": "BLOCH TRS, JEREMY EBIN",
    "owner2": "GREENWALD, ANNE LISA",
    "current_taxes": 7941.39,
    "new_taxes_no_override": 8284.46,
    "override_total_1": 8519.52,
    "override_increase_1": 235.07
  },
  {
    "#": "9 Gibbs St, Unit 1 (052-10-02)",
    "$": 1568400,
    "address": "9 Gibbs St, Unit 1",
    "parcel_id": "052-10-02",
    "owner1": "LOUREIRO, NUNO GOMES",
    "owner2": "COSTA DIAS, INES DE ALMEIDA E",
    "current_taxes": 12425.48,
    "new_taxes_no_override": 12962.26,
    "override_total_1": 13330.05,
    "override_increase_1": 367.79
  },
  {
    "#": "9 Gibbs St, Unit 2 (052-10-03)",
    "$": 1490200,
    "address": "9 Gibbs St, Unit 2",
    "parcel_id": "052-10-03",
    "owner1": "COHEN, LOUISE J",
    "owner2": "",
    "current_taxes": 11624.71,
    "new_taxes_no_override": 12126.9,
    "override_total_1": 12470.99,
    "override_increase_1": 344.09
  },
  {
    "#": "9 Gibbs St, Unit 3 (052-10-04)",
    "$": 1521100,
    "address": "9 Gibbs St, Unit 3",
    "parcel_id": "052-10-04",
    "owner1": "GROBMAN , ANDREW R & DIANA W",
    "owner2": "",
    "current_taxes": 11941.13,
    "new_taxes_no_override": 12456.99,
    "override_total_1": 12810.44,
    "override_increase_1": 353.46
  },
  {
    "#": "11 Gibbs St (052-12-00)",
    "$": 2894400,
    "address": "11 Gibbs St",
    "parcel_id": "052-12-00",
    "owner1": "FASTEN TR, NOAH",
    "owner2": "BRAWARSKY, PHYLLIS",
    "current_taxes": 26003.72,
    "new_taxes_no_override": 27127.08,
    "override_total_1": 27896.79,
    "override_increase_1": 769.71
  },
  {
    "#": "12 Gibbs St, Unit 1 (051-22-01)",
    "$": 1058900,
    "address": "12 Gibbs St, Unit 1",
    "parcel_id": "051-22-01",
    "owner1": "DUNPHY, SCOTT",
    "owner2": "",
    "current_taxes": 7208.2,
    "new_taxes_no_override": 7519.59,
    "override_total_1": 7732.96,
    "override_increase_1": 213.36
  },
  {
    "#": "12 Gibbs St, Unit 2 & Gar C (051-22-02)",
    "$": 1171700,
    "address": "12 Gibbs St, Unit 2 & Gar C",
    "parcel_id": "051-22-02",
    "owner1": "SCHOEMAN TRS, BARBARA",
    "owner2": "ROTHSTEIN, ANDREW D",
    "current_taxes": 8363.27,
    "new_taxes_no_override": 8724.56,
    "override_total_1": 8972.12,
    "override_increase_1": 247.55
  },
  {
    "#": "12 Gibbs St, Unit 3 & Gar G (051-22-03)",
    "$": 1296100,
    "address": "12 Gibbs St, Unit 3 & Gar G",
    "parcel_id": "051-22-03",
    "owner1": "HA, SEUNG KYUN",
    "owner2": "KIM, NAYOUNG",
    "current_taxes": 9637.13,
    "new_taxes_no_override": 10053.45,
    "override_total_1": 10338.71,
    "override_increase_1": 285.26
  },
  {
    "#": "12 Gibbs St, Unit B & Prk 1 (051-22-26)",
    "$": 896800,
    "address": "12 Gibbs St, Unit B & Prk 1",
    "parcel_id": "051-22-26",
    "owner1": "ZHU, XIN",
    "owner2": "",
    "current_taxes": 5548.3,
    "new_taxes_no_override": 5787.99,
    "override_total_1": 5952.22,
    "override_increase_1": 164.23
  },
  {
    "#": "14 Gibbs St, Unit 1 & P9 (051-22-04)",
    "$": 1017100,
    "address": "14 Gibbs St, Unit 1 & P9",
    "parcel_id": "051-22-04",
    "owner1": "ALEKSANDROVICH, BENJAMIN & RITA",
    "owner2": "",
    "current_taxes": 6780.17,
    "new_taxes_no_override": 7073.07,
    "override_total_1": 7273.77,
    "override_increase_1": 200.69
  },
  {
    "#": "14 Gibbs St, Unit 2 & Prk 2 (051-22-05)",
    "$": 1136300,
    "address": "14 Gibbs St, Unit 2 & Prk 2",
    "parcel_id": "051-22-05",
    "owner1": "FINE, ALAN",
    "owner2": "ROSENBERG, CAROL L",
    "current_taxes": 8000.78,
    "new_taxes_no_override": 8346.41,
    "override_total_1": 8583.24,
    "override_increase_1": 236.82
  },
  {
    "#": "14 Gibbs St, Unit 3 & Gar H (051-22-06)",
    "$": 1197400,
    "address": "14 Gibbs St, Unit 3 & Gar H",
    "parcel_id": "051-22-06",
    "owner1": "MARK, ZSOLT",
    "owner2": "DUSHENKOV, DARIA",
    "current_taxes": 8626.44,
    "new_taxes_no_override": 8999.1,
    "override_total_1": 9254.44,
    "override_increase_1": 255.34
  },
  {
    "#": "14 Gibbs St, Unit Pk Sp (051-22-28)",
    "$": 52500,
    "address": "14 Gibbs St, Unit Pk Sp",
    "parcel_id": "051-22-28",
    "owner1": "ROSENBERG, CAROL L",
    "owner2": "FINE, ALAN",
    "current_taxes": 537.6,
    "new_taxes_no_override": 560.82,
    "override_total_1": 576.74,
    "override_increase_1": 15.91
  },
  {
    "#": "15 Gibbs St, Unit 1 (052-13-03)",
    "$": 1547700,
    "address": "15 Gibbs St, Unit 1",
    "parcel_id": "052-13-03",
    "owner1": "KOCHOWIEC, ALEXY J",
    "owner2": "ULMENKOVA, SVETLANA",
    "current_taxes": 12213.51,
    "new_taxes_no_override": 12741.13,
    "override_total_1": 13102.65,
    "override_increase_1": 361.52
  },
  {
    "#": "15 Gibbs St, Unit 2 (052-13-01)",
    "$": 1412800,
    "address": "15 Gibbs St, Unit 2",
    "parcel_id": "052-13-01",
    "owner1": "VALCHEV, ROSEN",
    "owner2": "LIU, LILY",
    "current_taxes": 10832.14,
    "new_taxes_no_override": 11300.09,
    "override_total_1": 11620.72,
    "override_increase_1": 320.63
  },
  {
    "#": "15 Gibbs St, Unit 3 (052-13-02)",
    "$": 1420600,
    "address": "15 Gibbs St, Unit 3",
    "parcel_id": "052-13-02",
    "owner1": "STEFANIDAKIS, MICHAEL",
    "owner2": "",
    "current_taxes": 10912.01,
    "new_taxes_no_override": 11383.41,
    "override_total_1": 11706.4,
    "override_increase_1": 323.0
  },
  {
    "#": "17 Gibbs St, Unit 1 (052-14-03)",
    "$": 1248800,
    "address": "17 Gibbs St, Unit 1",
    "parcel_id": "052-14-03",
    "owner1": "CHERNOBROV, GUY H",
    "owner2": "ABES, ADA",
    "current_taxes": 12787.71,
    "new_taxes_no_override": 13340.14,
    "override_total_1": 13718.66,
    "override_increase_1": 378.52
  },
  {
    "#": "17 Gibbs St, Unit 2 (052-14-01)",
    "$": 1309800,
    "address": "17 Gibbs St, Unit 2",
    "parcel_id": "052-14-01",
    "owner1": "LANDA, ALON",
    "owner2": "",
    "current_taxes": 9777.42,
    "new_taxes_no_override": 10199.8,
    "override_total_1": 10489.22,
    "override_increase_1": 289.41
  },
  {
    "#": "17 Gibbs St, Unit 3 (052-14-02)",
    "$": 1321500,
    "address": "17 Gibbs St, Unit 3",
    "parcel_id": "052-14-02",
    "owner1": "CHEN, WANG",
    "owner2": "QIN, LAN",
    "current_taxes": 9897.23,
    "new_taxes_no_override": 10324.79,
    "override_total_1": 10617.75,
    "override_increase_1": 292.96
  },
  {
    "#": "18 Gibbs St, Unit 1 &  P-11 (051-22-07)",
    "$": 1071000,
    "address": "18 Gibbs St, Unit 1 &  P-11",
    "parcel_id": "051-22-07",
    "owner1": "HEINEMANN, WILLIAM & LINDA",
    "owner2": "",
    "current_taxes": 7332.11,
    "new_taxes_no_override": 7648.86,
    "override_total_1": 7865.89,
    "override_increase_1": 217.03
  },
  {
    "#": "18 Gibbs St, Unit 2 & Gar K (051-22-08)",
    "$": 1253700,
    "address": "18 Gibbs St, Unit 2 & Gar K",
    "parcel_id": "051-22-08",
    "owner1": "WARREN, ANDREW COOPER & MOLLIE",
    "owner2": "",
    "current_taxes": 9202.95,
    "new_taxes_no_override": 9600.52,
    "override_total_1": 9872.92,
    "override_increase_1": 272.41
  },
  {
    "#": "18 Gibbs St, Unit 3 Gar E J (051-22-09)",
    "$": 1349100,
    "address": "18 Gibbs St, Unit 3 Gar E J",
    "parcel_id": "051-22-09",
    "owner1": "LAROCQUE, NICHOLAS HENRY & KAREN  FOSSUM",
    "owner2": "",
    "current_taxes": 10179.85,
    "new_taxes_no_override": 10619.62,
    "override_total_1": 10920.94,
    "override_increase_1": 301.32
  },
  {
    "#": "20 Gibbs St, Unit 1 (051-22-10)",
    "$": 1234900,
    "address": "20 Gibbs St, Unit 1",
    "parcel_id": "051-22-10",
    "owner1": "FINK TRS, ALICE H & RICHARD D",
    "owner2": "",
    "current_taxes": 9010.44,
    "new_taxes_no_override": 9399.69,
    "override_total_1": 9666.4,
    "override_increase_1": 266.71
  },
  {
    "#": "20 Gibbs St, Unit 2 G-F P-15 (051-22-11)",
    "$": 1308900,
    "address": "20 Gibbs St, Unit 2 G-F P-15",
    "parcel_id": "051-22-11",
    "owner1": "BELZER, AVRUM",
    "owner2": "RICHARDSON, MARTHA",
    "current_taxes": 9768.2,
    "new_taxes_no_override": 10190.19,
    "override_total_1": 10479.32,
    "override_increase_1": 289.14
  },
  {
    "#": "20 Gibbs St, Unit 3 & Gar L & A (051-22-12)",
    "$": 1359200,
    "address": "20 Gibbs St, Unit 3 & Gar L & A",
    "parcel_id": "051-22-12",
    "owner1": "CERNUSCHI, CLAUDE RICHARD",
    "owner2": "FORSTER, LYNN SUSAN",
    "current_taxes": 10283.27,
    "new_taxes_no_override": 10727.51,
    "override_total_1": 11031.89,
    "override_increase_1": 304.38
  },
  {
    "#": "21 Gibbs St (052-15-00)",
    "$": 3536200,
    "address": "21 Gibbs St",
    "parcel_id": "052-15-00",
    "owner1": "SARA REAL ESTATE LLC",
    "owner2": "C/O ALPHA MGMT CORP",
    "current_taxes": 36210.69,
    "new_taxes_no_override": 37774.99,
    "override_total_1": 38846.83,
    "override_increase_1": 1071.84
  },
  {
    "#": "25 Gibbs St (052-16-00)",
    "$": 3792700,
    "address": "25 Gibbs St",
    "parcel_id": "052-16-00",
    "owner1": "YAO TR, PETER HUAI CHUN",
    "owner2": "",
    "current_taxes": 38837.25,
    "new_taxes_no_override": 40515.02,
    "override_total_1": 41664.6,
    "override_increase_1": 1149.58
  },
  {
    "#": "26 Gibbs St, Unit 1 G-B P-10 (051-22-13)",
    "$": 951700,
    "address": "26 Gibbs St, Unit 1 G-B P-10",
    "parcel_id": "051-22-13",
    "owner1": "SIEGEL, JODEE D",
    "owner2": "",
    "current_taxes": 6110.47,
    "new_taxes_no_override": 6374.44,
    "override_total_1": 6555.31,
    "override_increase_1": 180.87
  },
  {
    "#": "26 Gibbs St, Unit 2 (051-22-14)",
    "$": 794800,
    "address": "26 Gibbs St, Unit 2",
    "parcel_id": "051-22-14",
    "owner1": "PERRAS TR, LAURA C",
    "owner2": "",
    "current_taxes": 4503.82,
    "new_taxes_no_override": 4698.39,
    "override_total_1": 4831.7,
    "override_increase_1": 133.31
  },
  {
    "#": "26 Gibbs St, Unit 3 & P5 (051-22-15)",
    "$": 846300,
    "address": "26 Gibbs St, Unit 3 & P5",
    "parcel_id": "051-22-15",
    "owner1": "XIAO, WEIYAO",
    "owner2": "XIE, XIAODAN",
    "current_taxes": 8666.11,
    "new_taxes_no_override": 9040.49,
    "override_total_1": 9297.0,
    "override_increase_1": 256.52
  },
  {
    "#": "26 Gibbs St, Unit 4 G-I Pk 4 (051-22-16)",
    "$": 1010900,
    "address": "26 Gibbs St, Unit 4 G-I Pk 4",
    "parcel_id": "051-22-16",
    "owner1": "ZINTL, AMY",
    "owner2": "",
    "current_taxes": 6716.68,
    "new_taxes_no_override": 7006.84,
    "override_total_1": 7205.65,
    "override_increase_1": 198.81
  },
  {
    "#": "26 Gibbs St, Unit 5 & Prk P (051-22-17)",
    "$": 854100,
    "address": "26 Gibbs St, Unit 5 & Prk P",
    "parcel_id": "051-22-17",
    "owner1": "PELHE, ALBERT",
    "owner2": "",
    "current_taxes": 5111.05,
    "new_taxes_no_override": 5331.85,
    "override_total_1": 5483.13,
    "override_increase_1": 151.29
  },
  {
    "#": "26 Gibbs St, Unit 6 & Prk 6 (051-22-18)",
    "$": 851900,
    "address": "26 Gibbs St, Unit 6 & Prk 6",
    "parcel_id": "051-22-18",
    "owner1": "LEE, JEFFREY P",
    "owner2": "STOTTS, ANTHANETTE",
    "current_taxes": 5088.52,
    "new_taxes_no_override": 5308.34,
    "override_total_1": 5458.96,
    "override_increase_1": 150.62
  },
  {
    "#": "30 Gibbs St, Unit 1 & Pk-M (051-22-19)",
    "$": 685500,
    "address": "30 Gibbs St, Unit 1 & Pk-M",
    "parcel_id": "051-22-19",
    "owner1": "KING TRS, GEORGE A JR",
    "owner2": "MORIO, SOPHIA M",
    "current_taxes": 7019.52,
    "new_taxes_no_override": 7322.76,
    "override_total_1": 7530.54,
    "override_increase_1": 207.78
  },
  {
    "#": "30 Gibbs St, Unit 2 & Prk 16 (051-22-20)",
    "$": 743400,
    "address": "30 Gibbs St, Unit 2 & Prk 16",
    "parcel_id": "051-22-20",
    "owner1": "LASS TR, BONNIE W",
    "owner2": "",
    "current_taxes": 3977.48,
    "new_taxes_no_override": 4149.31,
    "override_total_1": 4267.04,
    "override_increase_1": 117.73
  },
  {
    "#": "30 Gibbs St, Unit 3 & Prk 14 (051-22-21)",
    "$": 802100,
    "address": "30 Gibbs St, Unit 3 & Prk 14",
    "parcel_id": "051-22-21",
    "owner1": "PATEL, TR, RAVINDRA P",
    "owner2": "",
    "current_taxes": 4578.57,
    "new_taxes_no_override": 4776.36,
    "override_total_1": 4911.89,
    "override_increase_1": 135.53
  },
  {
    "#": "30 Gibbs St, Unit 4 & Prk N (051-22-22)",
    "$": 863900,
    "address": "30 Gibbs St, Unit 4 & Prk N",
    "parcel_id": "051-22-22",
    "owner1": "KOZOREZ, BORIS",
    "owner2": "KHACHIYAN, NONNA",
    "current_taxes": 8846.34,
    "new_taxes_no_override": 9228.5,
    "override_total_1": 9490.35,
    "override_increase_1": 261.85
  },
  {
    "#": "30 Gibbs St, Unit 5 & P18 (051-22-23)",
    "$": 815800,
    "address": "30 Gibbs St, Unit 5 & P18",
    "parcel_id": "051-22-23",
    "owner1": "WEINSTEIN, RICHARD B",
    "owner2": "",
    "current_taxes": 4718.86,
    "new_taxes_no_override": 4922.71,
    "override_total_1": 5062.39,
    "override_increase_1": 139.68
  },
  {
    "#": "30 Gibbs St, Unit 6 & Prk O (051-22-24)",
    "$": 863900,
    "address": "30 Gibbs St, Unit 6 & Prk O",
    "parcel_id": "051-22-24",
    "owner1": "CHOU, SHERRY HSIANG-YI",
    "owner2": "",
    "current_taxes": 8846.34,
    "new_taxes_no_override": 9228.5,
    "override_total_1": 9490.35,
    "override_increase_1": 261.85
  },
  {
    "#": "30 Gibbs St, Unit P4 (051-22-27)",
    "$": 52500,
    "address": "30 Gibbs St, Unit P4",
    "parcel_id": "051-22-27",
    "owner1": "PATEL TR, RAVINDRA P",
    "owner2": "",
    "current_taxes": 537.6,
    "new_taxes_no_override": 560.82,
    "override_total_1": 576.74,
    "override_increase_1": 15.91
  },
  {
    "#": "31 Gibbs St (052-17-00)",
    "$": 2556100,
    "address": "31 Gibbs St",
    "parcel_id": "052-17-00",
    "owner1": "SHIEBER, STUART M",
    "owner2": "WYNER, CASSIA",
    "current_taxes": 22539.53,
    "new_taxes_no_override": 23513.24,
    "override_total_1": 24180.41,
    "override_increase_1": 667.17
  },
  {
    "#": "47 Gibbs St, Unit R1 (062-04-01)",
    "$": 1084700,
    "address": "47 Gibbs St, Unit R1",
    "parcel_id": "062-04-01",
    "owner1": "LIU, FENG",
    "owner2": "",
    "current_taxes": 7472.39,
    "new_taxes_no_override": 7795.2,
    "override_total_1": 8016.38,
    "override_increase_1": 221.18
  },
  {
    "#": "60 Gibbs St (065-10-00)",
    "$": 1970200,
    "address": "60 Gibbs St",
    "parcel_id": "065-10-00",
    "owner1": "LEE, SHUE PON & SAU PING",
    "owner2": "",
    "current_taxes": 16539.91,
    "new_taxes_no_override": 17254.43,
    "override_total_1": 17744.02,
    "override_increase_1": 489.58
  },
  {
    "#": "63 Gibbs St, Unit 1 (061-07-01)",
    "$": 1007800,
    "address": "63 Gibbs St, Unit 1",
    "parcel_id": "061-07-01",
    "owner1": "WEI, XIAODUI",
    "owner2": "CHENG, JIASHENG",
    "current_taxes": 6684.94,
    "new_taxes_no_override": 6973.73,
    "override_total_1": 7171.6,
    "override_increase_1": 197.87
  },
  {
    "#": "63 Gibbs St, Unit 2 (061-07-02)",
    "$": 996600,
    "address": "63 Gibbs St, Unit 2",
    "parcel_id": "061-07-02",
    "owner1": "KASS TR, ELIZABETH",
    "owner2": "",
    "current_taxes": 6570.25,
    "new_taxes_no_override": 6854.08,
    "override_total_1": 7048.56,
    "override_increase_1": 194.48
  },
  {
    "#": "63 Gibbs St, Unit 3 (061-07-03)",
    "$": 1019000,
    "address": "63 Gibbs St, Unit 3",
    "parcel_id": "061-07-03",
    "owner1": "LIANSKI TRS, MAXIM & ANNA",
    "owner2": "KHANIN, LEONID",
    "current_taxes": 10434.56,
    "new_taxes_no_override": 10885.33,
    "override_total_1": 11194.2,
    "override_increase_1": 308.86
  },
  {
    "#": "77 Gibbs St, Unit 77-1 (060-07-01)",
    "$": 1132900,
    "address": "77 Gibbs St, Unit 77-1",
    "parcel_id": "060-07-01",
    "owner1": "AHARON, IDAN B",
    "owner2": "MORAG, MICHAL",
    "current_taxes": 7965.96,
    "new_taxes_no_override": 8310.09,
    "override_total_1": 8545.88,
    "override_increase_1": 235.79
  },
  {
    "#": "77 Gibbs St, Unit 77-2 (060-07-02)",
    "$": 1183300,
    "address": "77 Gibbs St, Unit 77-2",
    "parcel_id": "060-07-02",
    "owner1": "HAKIMIAN TRS, REZA M & MARGARET",
    "owner2": "",
    "current_taxes": 8482.06,
    "new_taxes_no_override": 8848.48,
    "override_total_1": 9099.55,
    "override_increase_1": 251.07
  },
  {
    "#": "77 Gibbs St, Unit 77-3 (060-07-03)",
    "$": 1183300,
    "address": "77 Gibbs St, Unit 77-3",
    "parcel_id": "060-07-03",
    "owner1": "WALIA, NITIN K",
    "owner2": "CHUDY, JENNIFER",
    "current_taxes": 12116.99,
    "new_taxes_no_override": 12640.44,
    "override_total_1": 12999.11,
    "override_increase_1": 358.66
  },
  {
    "#": "77 Gibbs St, Unit 79-1 (060-07-04)",
    "$": 1389200,
    "address": "77 Gibbs St, Unit 79-1",
    "parcel_id": "060-07-04",
    "owner1": "EHRENBERG, ISAAC & RAHEL",
    "owner2": "",
    "current_taxes": 10590.47,
    "new_taxes_no_override": 11047.98,
    "override_total_1": 11361.46,
    "override_increase_1": 313.48
  },
  {
    "#": "77 Gibbs St, Unit 79-2 (060-07-05)",
    "$": 1183200,
    "address": "77 Gibbs St, Unit 79-2",
    "parcel_id": "060-07-05",
    "owner1": "KWAN, LERMIN",
    "owner2": "LO, KAYI",
    "current_taxes": 8481.03,
    "new_taxes_no_override": 8847.41,
    "override_total_1": 9098.45,
    "override_increase_1": 251.04
  },
  {
    "#": "77 Gibbs St, Unit 79-3 (060-07-06)",
    "$": 1318500,
    "address": "77 Gibbs St, Unit 79-3",
    "parcel_id": "060-07-06",
    "owner1": "FRATTESI, TIMOTHY RICHARD",
    "owner2": "ZENTNER, CASSANDRA AILEEN",
    "current_taxes": 9866.51,
    "new_taxes_no_override": 10292.74,
    "override_total_1": 10584.79,
    "override_increase_1": 292.05
  },
  {
    "#": "78 Gibbs St (068-24-00)",
    "$": 2723100,
    "address": "78 Gibbs St",
    "parcel_id": "068-24-00",
    "owner1": "COOLIDGE 142-144 LLC",
    "owner2": "",
    "current_taxes": 27884.54,
    "new_taxes_no_override": 29089.15,
    "override_total_1": 29914.53,
    "override_increase_1": 825.38
  },
  {
    "#": "81 Gibbs St (060-06-00)",
    "$": 3410700,
    "address": "81 Gibbs St",
    "parcel_id": "060-06-00",
    "owner1": "FRIED TR, PAUL D",
    "owner2": "",
    "current_taxes": 34925.57,
    "new_taxes_no_override": 36434.35,
    "override_total_1": 37468.15,
    "override_increase_1": 1033.8
  },
  {
    "#": "14 Glen Rd (297-01-03)",
    "$": 2512700,
    "address": "14 Glen Rd",
    "parcel_id": "297-01-03",
    "owner1": "BALBONI, MARGOT NOTT",
    "owner2": "",
    "current_taxes": 22095.11,
    "new_taxes_no_override": 23049.62,
    "override_total_1": 23703.63,
    "override_increase_1": 654.02
  },
  {
    "#": "25 Glen Rd (296-04-00)",
    "$": 2076000,
    "address": "25 Glen Rd",
    "parcel_id": "296-04-00",
    "owner1": "BIZUP TRS, JOSEPH MICHAEL",
    "owner2": "CARACANSI, ANNMARIE",
    "current_taxes": 17623.31,
    "new_taxes_no_override": 18384.64,
    "override_total_1": 18906.29,
    "override_increase_1": 521.65
  },
  {
    "#": "26 Glen Rd (297-14-00)",
    "$": 2008900,
    "address": "26 Glen Rd",
    "parcel_id": "297-14-00",
    "owner1": "BORCAU, LAVINIA",
    "owner2": "",
    "current_taxes": 16936.2,
    "new_taxes_no_override": 17667.84,
    "override_total_1": 18169.16,
    "override_increase_1": 501.31
  },
  {
    "#": "30 Glen Rd (297-13-00)",
    "$": 2611800,
    "address": "30 Glen Rd",
    "parcel_id": "297-13-00",
    "owner1": "MICHELI, LYLE J",
    "owner2": "JENKS, ANNE",
    "current_taxes": 23109.9,
    "new_taxes_no_override": 24108.25,
    "override_total_1": 24792.3,
    "override_increase_1": 684.05
  },
  {
    "#": "31 Glen Rd (296-05-00)",
    "$": 2414100,
    "address": "31 Glen Rd",
    "parcel_id": "296-05-00",
    "owner1": "FIJAN, CHRISTIAN & KATHARINA",
    "owner2": "",
    "current_taxes": 21085.45,
    "new_taxes_no_override": 21996.34,
    "override_total_1": 22620.47,
    "override_increase_1": 624.13
  },
  {
    "#": "36 Glen Rd (297-12-00)",
    "$": 2567500,
    "address": "36 Glen Rd",
    "parcel_id": "297-12-00",
    "owner1": "WURSTER, ERIK",
    "owner2": "PACE, LYDIA",
    "current_taxes": 22656.27,
    "new_taxes_no_override": 23635.02,
    "override_total_1": 24305.65,
    "override_increase_1": 670.63
  },
  {
    "#": "37 Glen Rd (296-06-00)",
    "$": 2018100,
    "address": "37 Glen Rd",
    "parcel_id": "296-06-00",
    "owner1": "ZIMMERMAN TR, CATHERINE H",
    "owner2": "",
    "current_taxes": 17030.41,
    "new_taxes_no_override": 17766.12,
    "override_total_1": 18270.22,
    "override_increase_1": 504.1
  },
  {
    "#": "43 Glen Rd (296-07-00)",
    "$": 2069600,
    "address": "43 Glen Rd",
    "parcel_id": "296-07-00",
    "owner1": "NIES, ROBERT V",
    "owner2": "PARK, KARL C JR",
    "current_taxes": 17557.77,
    "new_taxes_no_override": 18316.27,
    "override_total_1": 18835.98,
    "override_increase_1": 519.71
  },
  {
    "#": "46 Glen Rd (297-10-11)",
    "$": 2114400,
    "address": "46 Glen Rd",
    "parcel_id": "297-10-11",
    "owner1": "KENNEDY, THOMAS B & JOANNA W",
    "owner2": "",
    "current_taxes": 18016.52,
    "new_taxes_no_override": 18794.83,
    "override_total_1": 19328.12,
    "override_increase_1": 533.29
  },
  {
    "#": "60 Glen Rd, Unit E, Unit 208 & P50 (299-01-23)",
    "$": 545200,
    "address": "60 Glen Rd, Unit E, Unit 208 & P50",
    "parcel_id": "299-01-23",
    "owner1": "GOYETTE, DANIELLE R",
    "owner2": "",
    "current_taxes": 1947.91,
    "new_taxes_no_override": 2032.06,
    "override_total_1": 2089.72,
    "override_increase_1": 57.66
  },
  {
    "#": "60 Glen Rd, Unit 101 & P-54 (299-01-49)",
    "$": 582700,
    "address": "60 Glen Rd, Unit 101 & P-54",
    "parcel_id": "299-01-49",
    "owner1": "MEIR TR, ISRAEL",
    "owner2": "",
    "current_taxes": 5966.85,
    "new_taxes_no_override": 6224.62,
    "override_total_1": 6401.24,
    "override_increase_1": 176.62
  },
  {
    "#": "60 Glen Rd, Unit 102 & P-40 (299-01-39)",
    "$": 900600,
    "address": "60 Glen Rd, Unit 102 & P-40",
    "parcel_id": "299-01-39",
    "owner1": "LEVINSON TRS, CYNTHIA Y & SANFORD",
    "owner2": "",
    "current_taxes": 9222.14,
    "new_taxes_no_override": 9620.54,
    "override_total_1": 9893.51,
    "override_increase_1": 272.98
  },
  {
    "#": "60 Glen Rd, Unit 103 & P58 (299-01-40)",
    "$": 677400,
    "address": "60 Glen Rd, Unit 103 & P58",
    "parcel_id": "299-01-40",
    "owner1": "ZHANG, JEFFREY Y",
    "owner2": "",
    "current_taxes": 3301.64,
    "new_taxes_no_override": 3444.27,
    "override_total_1": 3542.0,
    "override_increase_1": 97.73
  },
  {
    "#": "60 Glen Rd, Unit 104 & P-57 (299-01-41)",
    "$": 661200,
    "address": "60 Glen Rd, Unit 104 & P-57",
    "parcel_id": "299-01-41",
    "owner1": "BOCK, AMY",
    "owner2": "",
    "current_taxes": 3135.75,
    "new_taxes_no_override": 3271.21,
    "override_total_1": 3364.03,
    "override_increase_1": 92.82
  },
  {
    "#": "60 Glen Rd, Unit 105 & P73 (299-01-42)",
    "$": 524700,
    "address": "60 Glen Rd, Unit 105 & P73",
    "parcel_id": "299-01-42",
    "owner1": "BOCK, AMY",
    "owner2": "",
    "current_taxes": 5372.93,
    "new_taxes_no_override": 5605.04,
    "override_total_1": 5764.08,
    "override_increase_1": 159.04
  },
  {
    "#": "60 Glen Rd, Unit 106  & P17 (299-01-14)",
    "$": 758600,
    "address": "60 Glen Rd, Unit 106  & P17",
    "parcel_id": "299-01-14",
    "owner1": "EVERSON, CONSTANCE",
    "owner2": "",
    "current_taxes": 7768.06,
    "new_taxes_no_override": 8103.64,
    "override_total_1": 8333.57,
    "override_increase_1": 229.93
  },
  {
    "#": "60 Glen Rd, Unit 107 & P51 (299-01-15)",
    "$": 501100,
    "address": "60 Glen Rd, Unit 107 & P51",
    "parcel_id": "299-01-15",
    "owner1": "PARVATH, VEL",
    "owner2": "VEL, KAVITHA & HARINI",
    "current_taxes": 1496.33,
    "new_taxes_no_override": 1560.97,
    "override_total_1": 1605.26,
    "override_increase_1": 44.29
  },
  {
    "#": "60 Glen Rd, Unit 108 & P23 (299-01-16)",
    "$": 854200,
    "address": "60 Glen Rd, Unit 108 & P23",
    "parcel_id": "299-01-16",
    "owner1": "MICHENER, DEBORAH",
    "owner2": "",
    "current_taxes": 5112.07,
    "new_taxes_no_override": 5332.91,
    "override_total_1": 5484.23,
    "override_increase_1": 151.32
  },
  {
    "#": "60 Glen Rd, Unit 109 & P24 (299-01-17)",
    "$": 867000,
    "address": "60 Glen Rd, Unit 109 & P24",
    "parcel_id": "299-01-17",
    "owner1": "TEVEROVSKY LIFE ESTATE, ALEXANDER & BELLA",
    "owner2": "",
    "current_taxes": 5243.15,
    "new_taxes_no_override": 5469.65,
    "override_total_1": 5624.85,
    "override_increase_1": 155.2
  },
  {
    "#": "60 Glen Rd, Unit 110 & P4 (299-01-18)",
    "$": 590200,
    "address": "60 Glen Rd, Unit 110 & P4",
    "parcel_id": "299-01-18",
    "owner1": "KHAVINSON HOLDINGS LLC",
    "owner2": "",
    "current_taxes": 6043.65,
    "new_taxes_no_override": 6304.74,
    "override_total_1": 6483.63,
    "override_increase_1": 178.89
  },
  {
    "#": "60 Glen Rd, Unit 111 P31-87 (299-01-19)",
    "$": 941200,
    "address": "60 Glen Rd, Unit 111 P31-87",
    "parcel_id": "299-01-19",
    "owner1": "KNECHT, DZIDRA J",
    "owner2": "",
    "current_taxes": 6002.95,
    "new_taxes_no_override": 6262.28,
    "override_total_1": 6439.96,
    "override_increase_1": 177.69
  },
  {
    "#": "60 Glen Rd, Unit 112 & P-32 (299-01-20)",
    "$": 780400,
    "address": "60 Glen Rd, Unit 112 & P-32",
    "parcel_id": "299-01-20",
    "owner1": "KATZ LIFE ESTATE, NANCY R",
    "owner2": "",
    "current_taxes": 4356.36,
    "new_taxes_no_override": 4544.55,
    "override_total_1": 4673.5,
    "override_increase_1": 128.95
  },
  {
    "#": "60 Glen Rd, Unit 201 & P55 (299-01-50)",
    "$": 664100,
    "address": "60 Glen Rd, Unit 201 & P55",
    "parcel_id": "299-01-50",
    "owner1": "ANDERSON, DANIELLE",
    "owner2": "",
    "current_taxes": 3165.45,
    "new_taxes_no_override": 3302.2,
    "override_total_1": 3395.89,
    "override_increase_1": 93.7
  },
  {
    "#": "60 Glen Rd, Unit 202 & P-34 (299-01-43)",
    "$": 1161500,
    "address": "60 Glen Rd, Unit 202 & P-34",
    "parcel_id": "299-01-43",
    "owner1": "ALLARA, PAMELA",
    "owner2": "",
    "current_taxes": 8258.83,
    "new_taxes_no_override": 8615.61,
    "override_total_1": 8860.07,
    "override_increase_1": 244.46
  },
  {
    "#": "60 Glen Rd, Unit 203 & P-74 (299-01-44)",
    "$": 733900,
    "address": "60 Glen Rd, Unit 203 & P-74",
    "parcel_id": "299-01-44",
    "owner1": "PRATT, NICOLE C",
    "owner2": "",
    "current_taxes": 3880.2,
    "new_taxes_no_override": 4047.82,
    "override_total_1": 4162.68,
    "override_increase_1": 114.85
  },
  {
    "#": "60 Glen Rd, Unit 204 P37-38 (299-01-45)",
    "$": 1326200,
    "address": "60 Glen Rd, Unit 204 P37-38",
    "parcel_id": "299-01-45",
    "owner1": "GADSBY TR, EDWARD N JR",
    "owner2": "",
    "current_taxes": 9945.35,
    "new_taxes_no_override": 10374.99,
    "override_total_1": 10669.37,
    "override_increase_1": 294.38
  },
  {
    "#": "60 Glen Rd, Unit 205 & P36 (299-01-46)",
    "$": 946300,
    "address": "60 Glen Rd, Unit 205 & P36",
    "parcel_id": "299-01-46",
    "owner1": "VARGYAS, ELLEN",
    "owner2": "",
    "current_taxes": 6055.18,
    "new_taxes_no_override": 6316.76,
    "override_total_1": 6496.0,
    "override_increase_1": 179.23
  },
  {
    "#": "60 Glen Rd, Unit 206 P12-86 (299-01-21)",
    "$": 797800,
    "address": "60 Glen Rd, Unit 206 P12-86",
    "parcel_id": "299-01-21",
    "owner1": "DANN, ROBERT",
    "owner2": "",
    "current_taxes": 4534.54,
    "new_taxes_no_override": 4730.43,
    "override_total_1": 4864.65,
    "override_increase_1": 134.22
  },
  {
    "#": "60 Glen Rd, Unit 207 & P45 (299-01-22)",
    "$": 592100,
    "address": "60 Glen Rd, Unit 207 & P45",
    "parcel_id": "299-01-22",
    "owner1": "YU TRS, YONGJIAN",
    "owner2": "SHI, LIBING",
    "current_taxes": 6063.1,
    "new_taxes_no_override": 6325.03,
    "override_total_1": 6504.49,
    "override_increase_1": 179.47
  },
  {
    "#": "60 Glen Rd, Unit 209 & P-72 (299-01-24)",
    "$": 591200,
    "address": "60 Glen Rd, Unit 209 & P-72",
    "parcel_id": "299-01-24",
    "owner1": "XIE, JAMES J & XINMIN",
    "owner2": "LI, XIAOSU",
    "current_taxes": 6053.89,
    "new_taxes_no_override": 6315.42,
    "override_total_1": 6494.61,
    "override_increase_1": 179.2
  },
  {
    "#": "60 Glen Rd, Unit 210 & P-33 (299-01-25)",
    "$": 790000,
    "address": "60 Glen Rd, Unit 210 & P-33",
    "parcel_id": "299-01-25",
    "owner1": "GREW TRS, JOHN JR",
    "owner2": "",
    "current_taxes": 4454.67,
    "new_taxes_no_override": 4647.11,
    "override_total_1": 4778.97,
    "override_increase_1": 131.86
  },
  {
    "#": "60 Glen Rd, Unit 301 & P43 (299-01-47)",
    "$": 818000,
    "address": "60 Glen Rd, Unit 301 & P43",
    "parcel_id": "299-01-47",
    "owner1": "RICHLIN, ANDREW",
    "owner2": "",
    "current_taxes": 4741.39,
    "new_taxes_no_override": 4946.22,
    "override_total_1": 5086.56,
    "override_increase_1": 140.35
  },
  {
    "#": "60 Glen Rd, Unit 302 & P-35 (299-01-48)",
    "$": 1327500,
    "address": "60 Glen Rd, Unit 302 & P-35",
    "parcel_id": "299-01-48",
    "owner1": "MEIJER, HENDRIK A",
    "owner2": "SZAMBELAN, SUSAN I",
    "current_taxes": 13593.6,
    "new_taxes_no_override": 14180.84,
    "override_total_1": 14583.21,
    "override_increase_1": 402.37
  },
  {
    "#": "60 Glen Rd, Unit 303 & P10 (299-01-26)",
    "$": 657700,
    "address": "60 Glen Rd, Unit 303 & P10",
    "parcel_id": "299-01-26",
    "owner1": "CRIST, KATHRYN E",
    "owner2": "",
    "current_taxes": 3099.91,
    "new_taxes_no_override": 3233.83,
    "override_total_1": 3325.58,
    "override_increase_1": 91.76
  },
  {
    "#": "60 Glen Rd, Unit 304 & P44 (299-01-27)",
    "$": 618900,
    "address": "60 Glen Rd, Unit 304 & P44",
    "parcel_id": "299-01-27",
    "owner1": "ROSSELL, CHRISTINE HAMILTON & ELISE SORENSEN",
    "owner2": "",
    "current_taxes": 6337.54,
    "new_taxes_no_override": 6611.32,
    "override_total_1": 6798.91,
    "override_increase_1": 187.59
  },
  {
    "#": "60 Glen Rd, Unit 305 & P49 (299-01-28)",
    "$": 586800,
    "address": "60 Glen Rd, Unit 305 & P49",
    "parcel_id": "299-01-28",
    "owner1": "HALL, SYDNEY T",
    "owner2": "",
    "current_taxes": 2373.9,
    "new_taxes_no_override": 2476.45,
    "override_total_1": 2546.72,
    "override_increase_1": 70.27
  },
  {
    "#": "60 Glen Rd, Unit 306 & P48 (299-01-29)",
    "$": 604400,
    "address": "60 Glen Rd, Unit 306 & P48",
    "parcel_id": "299-01-29",
    "owner1": "WANG, BEILI",
    "owner2": "C/O BOSTON PROPERTY MGMT",
    "current_taxes": 6189.06,
    "new_taxes_no_override": 6456.43,
    "override_total_1": 6639.62,
    "override_increase_1": 183.2
  },
  {
    "#": "60 Glen Rd, Unit 307 & P11 (299-01-30)",
    "$": 679900,
    "address": "60 Glen Rd, Unit 307 & P11",
    "parcel_id": "299-01-30",
    "owner1": "ROSSELL, CHRISTINE HAMILTON & ELISE SORENSEN",
    "owner2": "",
    "current_taxes": 6962.18,
    "new_taxes_no_override": 7262.95,
    "override_total_1": 7469.03,
    "override_increase_1": 206.08
  },
  {
    "#": "60 Glen Rd, Unit P-1 & P-47 (299-01-06)",
    "$": 489700,
    "address": "60 Glen Rd, Unit P-1 & P-47",
    "parcel_id": "299-01-06",
    "owner1": "TREMBLAY, ROSS",
    "owner2": "LANE, KATHRYN",
    "current_taxes": 5014.53,
    "new_taxes_no_override": 5231.16,
    "override_total_1": 5379.59,
    "override_increase_1": 148.43
  },
  {
    "#": "60 Glen Rd, Unit P-2 & P-81 (299-01-07)",
    "$": 608700,
    "address": "60 Glen Rd, Unit P-2 & P-81",
    "parcel_id": "299-01-07",
    "owner1": "PHELAN, CYNTHIA E",
    "owner2": "",
    "current_taxes": 2598.15,
    "new_taxes_no_override": 2710.39,
    "override_total_1": 2787.3,
    "override_increase_1": 76.91
  },
  {
    "#": "60 Glen Rd, Unit P-3 & P-52 (299-01-08)",
    "$": 504800,
    "address": "60 Glen Rd, Unit P-3 & P-52",
    "parcel_id": "299-01-08",
    "owner1": "SECTISH TRS, THEODORE C",
    "owner2": "MCGRAW TR, MICHELLE A",
    "current_taxes": 1534.22,
    "new_taxes_no_override": 1600.5,
    "override_total_1": 1645.91,
    "override_increase_1": 45.41
  },
  {
    "#": "60 Glen Rd, Unit P-4 & P-21 (299-01-09)",
    "$": 837200,
    "address": "60 Glen Rd, Unit P-4 & P-21",
    "parcel_id": "299-01-09",
    "owner1": "VALERA FAMILY LLC",
    "owner2": "",
    "current_taxes": 8572.93,
    "new_taxes_no_override": 8943.28,
    "override_total_1": 9197.04,
    "override_increase_1": 253.76
  },
  {
    "#": "60 Glen Rd, Unit Pp-91 (299-01-73)",
    "$": 49000,
    "address": "60 Glen Rd, Unit Pp-91",
    "parcel_id": "299-01-73",
    "owner1": "NICKERSON, DAVID & REBECCA",
    "owner2": "",
    "current_taxes": 501.76,
    "new_taxes_no_override": 523.44,
    "override_total_1": 538.29,
    "override_increase_1": 14.85
  },
  {
    "#": "60 Glen Rd, Unit T-1 & P53 (299-01-31)",
    "$": 513400,
    "address": "60 Glen Rd, Unit T-1 & P53",
    "parcel_id": "299-01-31",
    "owner1": "PLOVNICK TR, BERNARD A",
    "owner2": "",
    "current_taxes": 1622.28,
    "new_taxes_no_override": 1692.36,
    "override_total_1": 1740.38,
    "override_increase_1": 48.02
  },
  {
    "#": "60 Glen Rd, Unit T-10 & P5 (299-01-11)",
    "$": 744000,
    "address": "60 Glen Rd, Unit T-10 & P5",
    "parcel_id": "299-01-11",
    "owner1": "KANG, ELITA T",
    "owner2": "",
    "current_taxes": 3983.63,
    "new_taxes_no_override": 4155.72,
    "override_total_1": 4273.64,
    "override_increase_1": 117.92
  },
  {
    "#": "60 Glen Rd, Unit T-11 & P16 (299-01-12)",
    "$": 779300,
    "address": "60 Glen Rd, Unit T-11 & P16",
    "parcel_id": "299-01-12",
    "owner1": "MOWRY, ROBERT D",
    "owner2": "",
    "current_taxes": 4345.1,
    "new_taxes_no_override": 4532.81,
    "override_total_1": 4661.42,
    "override_increase_1": 128.61
  },
  {
    "#": "60 Glen Rd, Unit T-2  & P82 (299-01-32)",
    "$": 659100,
    "address": "60 Glen Rd, Unit T-2  & P82",
    "parcel_id": "299-01-32",
    "owner1": "CHUN-ON ETAL, PATTRA",
    "owner2": "WARD, NONGLUX",
    "current_taxes": 6749.18,
    "new_taxes_no_override": 7040.74,
    "override_total_1": 7240.52,
    "override_increase_1": 199.78
  },
  {
    "#": "60 Glen Rd, Unit T-3 & P-83 (299-01-33)",
    "$": 700100,
    "address": "60 Glen Rd, Unit T-3 & P-83",
    "parcel_id": "299-01-33",
    "owner1": "POUTTU, ERNEST & MARY KAY",
    "owner2": "",
    "current_taxes": 7169.02,
    "new_taxes_no_override": 7478.72,
    "override_total_1": 7690.92,
    "override_increase_1": 212.2
  },
  {
    "#": "60 Glen Rd, Unit T-4 & P-84 (299-01-34)",
    "$": 887100,
    "address": "60 Glen Rd, Unit T-4 & P-84",
    "parcel_id": "299-01-34",
    "owner1": "BALMAZI TR, LEON",
    "owner2": "",
    "current_taxes": 9083.9,
    "new_taxes_no_override": 9476.32,
    "override_total_1": 9745.21,
    "override_increase_1": 268.88
  },
  {
    "#": "60 Glen Rd, Unit T-5 & P-85 (299-01-35)",
    "$": 876100,
    "address": "60 Glen Rd, Unit T-5 & P-85",
    "parcel_id": "299-01-35",
    "owner1": "HALEY  TR, SAUNDRA J",
    "owner2": "",
    "current_taxes": 5336.33,
    "new_taxes_no_override": 5566.86,
    "override_total_1": 5724.81,
    "override_increase_1": 157.96
  },
  {
    "#": "60 Glen Rd, Unit T-6 P56-68 (299-01-36)",
    "$": 807500,
    "address": "60 Glen Rd, Unit T-6 P56-68",
    "parcel_id": "299-01-36",
    "owner1": "POOLE, DOUGLAS & CHERYL FINN",
    "owner2": "",
    "current_taxes": 4633.87,
    "new_taxes_no_override": 4834.05,
    "override_total_1": 4971.22,
    "override_increase_1": 137.16
  },
  {
    "#": "60 Glen Rd, Unit T-7 & P76 (299-01-37)",
    "$": 606400,
    "address": "60 Glen Rd, Unit T-7 & P76",
    "parcel_id": "299-01-37",
    "owner1": "SWEET TRS, FRANK R III & HALEY C",
    "owner2": "MCCOWIN-SWEET, ROBIN A",
    "current_taxes": 6209.54,
    "new_taxes_no_override": 6477.79,
    "override_total_1": 6661.59,
    "override_increase_1": 183.8
  },
  {
    "#": "60 Glen Rd, Unit T-8 & P75 (299-01-38)",
    "$": 566500,
    "address": "60 Glen Rd, Unit T-8 & P75",
    "parcel_id": "299-01-38",
    "owner1": "TOOMEY, PAUL J JR",
    "owner2": "CONNELLY, ELIZABETH M",
    "current_taxes": 2166.03,
    "new_taxes_no_override": 2259.6,
    "override_total_1": 2323.72,
    "override_increase_1": 64.11
  },
  {
    "#": "60 Glen Rd, Unit T-9 & P46 (299-01-10)",
    "$": 578700,
    "address": "60 Glen Rd, Unit T-9 & P46",
    "parcel_id": "299-01-10",
    "owner1": "WANG, MEIYAO",
    "owner2": "",
    "current_taxes": 2290.95,
    "new_taxes_no_override": 2389.92,
    "override_total_1": 2457.73,
    "override_increase_1": 67.81
  },
  {
    "#": "60 Glen Rd, Unit T12 & P22-67 (299-01-13)",
    "$": 859100,
    "address": "60 Glen Rd, Unit T12 & P22-67",
    "parcel_id": "299-01-13",
    "owner1": "DONG, KEXUN",
    "owner2": "NIELSEN, AILEEN",
    "current_taxes": 8797.18,
    "new_taxes_no_override": 9177.22,
    "override_total_1": 9437.61,
    "override_increase_1": 260.4
  },
  {
    "#": "65 Glen Rd, Unit H-1 P2 92 (299-01-51)",
    "$": 668200,
    "address": "65 Glen Rd, Unit H-1 P2 92",
    "parcel_id": "299-01-51",
    "owner1": "AHART TR, LINDA J",
    "owner2": "",
    "current_taxes": 3207.43,
    "new_taxes_no_override": 3345.99,
    "override_total_1": 3440.93,
    "override_increase_1": 94.94
  },
  {
    "#": "65 Glen Rd, Unit H-11 & P25 (299-01-61)",
    "$": 607800,
    "address": "65 Glen Rd, Unit H-11 & P25",
    "parcel_id": "299-01-61",
    "owner1": "RAIA, JOSEPH M & BENEDICTA U",
    "owner2": "",
    "current_taxes": 6223.87,
    "new_taxes_no_override": 6492.74,
    "override_total_1": 6676.97,
    "override_increase_1": 184.23
  },
  {
    "#": "65 Glen Rd, Unit H-12 & P13 (299-01-62)",
    "$": 833100,
    "address": "65 Glen Rd, Unit H-12 & P13",
    "parcel_id": "299-01-62",
    "owner1": "MORGAN, ALEXANDRA",
    "owner2": "",
    "current_taxes": 4896.01,
    "new_taxes_no_override": 5107.52,
    "override_total_1": 5252.44,
    "override_increase_1": 144.92
  },
  {
    "#": "65 Glen Rd, Unit H-13 & P3 (299-01-63)",
    "$": 715100,
    "address": "65 Glen Rd, Unit H-13 & P3",
    "parcel_id": "299-01-63",
    "owner1": "SISAKHTI, SAM",
    "owner2": "",
    "current_taxes": 7322.62,
    "new_taxes_no_override": 7638.96,
    "override_total_1": 7855.71,
    "override_increase_1": 216.75
  },
  {
    "#": "65 Glen Rd, Unit H-2 P69-89 (299-01-52)",
    "$": 753700,
    "address": "65 Glen Rd, Unit H-2 P69-89",
    "parcel_id": "299-01-52",
    "owner1": "GREER, MAYA M",
    "owner2": "JENNINGS, RUSSELL W",
    "current_taxes": 7717.89,
    "new_taxes_no_override": 8051.3,
    "override_total_1": 8279.75,
    "override_increase_1": 228.45
  },
  {
    "#": "65 Glen Rd, Unit H-3 & P28 (299-01-53)",
    "$": 774800,
    "address": "65 Glen Rd, Unit H-3 & P28",
    "parcel_id": "299-01-53",
    "owner1": "QUINTANA TR, MINIVEILLE E",
    "owner2": "",
    "current_taxes": 4299.02,
    "new_taxes_no_override": 4484.74,
    "override_total_1": 4611.99,
    "override_increase_1": 127.25
  },
  {
    "#": "65 Glen Rd, Unit H-4 & P-30 (299-01-54)",
    "$": 806200,
    "address": "65 Glen Rd, Unit H-4 & P-30",
    "parcel_id": "299-01-54",
    "owner1": "LOBO, TARA ANAIS",
    "owner2": "SREENIVASULU, MANOJ BANGARU",
    "current_taxes": 8255.49,
    "new_taxes_no_override": 8612.13,
    "override_total_1": 8856.49,
    "override_increase_1": 244.36
  },
  {
    "#": "65 Glen Rd, Unit H-5 & P-26 (299-01-55)",
    "$": 732700,
    "address": "65 Glen Rd, Unit H-5 & P-26",
    "parcel_id": "299-01-55",
    "owner1": "KIYOTA, YUKA",
    "owner2": "",
    "current_taxes": 3867.91,
    "new_taxes_no_override": 4035.0,
    "override_total_1": 4149.49,
    "override_increase_1": 114.49
  },
  {
    "#": "65 Glen Rd, Unit H-6 & P15 (299-01-56)",
    "$": 907600,
    "address": "65 Glen Rd, Unit H-6 & P15",
    "parcel_id": "299-01-56",
    "owner1": "WANG ET AL, SHAONING & RUOBING",
    "owner2": "KIM, SANGBAE",
    "current_taxes": 5658.89,
    "new_taxes_no_override": 5903.35,
    "override_total_1": 6070.86,
    "override_increase_1": 167.5
  },
  {
    "#": "65 Glen Rd, Unit H-7 & P-29 (299-01-57)",
    "$": 910300,
    "address": "65 Glen Rd, Unit H-7 & P-29",
    "parcel_id": "299-01-57",
    "owner1": "SANIDAS, IOANNIS",
    "owner2": "TOUROUTOGLOU, ALEXANDRA",
    "current_taxes": 5686.54,
    "new_taxes_no_override": 5932.2,
    "override_total_1": 6100.52,
    "override_increase_1": 168.32
  },
  {
    "#": "65 Glen Rd, Unit H-8 & P-0 (299-01-58)",
    "$": 576100,
    "address": "65 Glen Rd, Unit H-8 & P-0",
    "parcel_id": "299-01-58",
    "owner1": "KOUNDAKJIAN, EDMUND J",
    "owner2": "SUSAN, MAI",
    "current_taxes": 5899.26,
    "new_taxes_no_override": 6154.11,
    "override_total_1": 6328.73,
    "override_increase_1": 174.62
  },
  {
    "#": "65 Glen Rd, Unit H-9 & P-27 (299-01-59)",
    "$": 730200,
    "address": "65 Glen Rd, Unit H-9 & P-27",
    "parcel_id": "299-01-59",
    "owner1": "LOMBE, MARGARET",
    "owner2": "",
    "current_taxes": 3842.31,
    "new_taxes_no_override": 4008.3,
    "override_total_1": 4122.03,
    "override_increase_1": 113.73
  },
  {
    "#": "65 Glen Rd, Unit H10 P14-88 (299-01-60)",
    "$": 988300,
    "address": "65 Glen Rd, Unit H10 P14-88",
    "parcel_id": "299-01-60",
    "owner1": "PARKER, MICHELE",
    "owner2": "BELFER, PERRY",
    "current_taxes": 10120.19,
    "new_taxes_no_override": 10557.38,
    "override_total_1": 10856.94,
    "override_increase_1": 299.56
  },
  {
    "#": "65 Glen Rd, Unit P 65 (299-01-75)",
    "$": 49000,
    "address": "65 Glen Rd, Unit P 65",
    "parcel_id": "299-01-75",
    "owner1": "SANIDAS, IOANNIS",
    "owner2": "TOUROUTOGLOU, ALEXANDRA",
    "current_taxes": 501.76,
    "new_taxes_no_override": 523.44,
    "override_total_1": 538.29,
    "override_increase_1": 14.85
  },
  {
    "#": "75 Glen Rd, Unit B-1 & P-70 (299-01-64)",
    "$": 566000,
    "address": "75 Glen Rd, Unit B-1 & P-70",
    "parcel_id": "299-01-64",
    "owner1": "BANERJEE, MODHURIN",
    "owner2": "",
    "current_taxes": 5795.84,
    "new_taxes_no_override": 6046.22,
    "override_total_1": 6217.78,
    "override_increase_1": 171.56
  },
  {
    "#": "75 Glen Rd, Unit B-2 & P71 (299-01-65)",
    "$": 566100,
    "address": "75 Glen Rd, Unit B-2 & P71",
    "parcel_id": "299-01-65",
    "owner1": "SARTORI, MAXANNE",
    "owner2": "",
    "current_taxes": 5796.86,
    "new_taxes_no_override": 6047.28,
    "override_total_1": 6218.87,
    "override_increase_1": 171.59
  },
  {
    "#": "75 Glen Rd, Unit B-3 & P62 (299-01-66)",
    "$": 608700,
    "address": "75 Glen Rd, Unit B-3 & P62",
    "parcel_id": "299-01-66",
    "owner1": "CONNORS, ALEXANDRA J",
    "owner2": "",
    "current_taxes": 2598.15,
    "new_taxes_no_override": 2710.39,
    "override_total_1": 2787.3,
    "override_increase_1": 76.91
  },
  {
    "#": "75 Glen Rd, Unit B-4 Pk 61 (299-01-67)",
    "$": 650700,
    "address": "75 Glen Rd, Unit B-4 Pk 61",
    "parcel_id": "299-01-67",
    "owner1": "ZABINSKY TR, INGRID",
    "owner2": "",
    "current_taxes": 3028.23,
    "new_taxes_no_override": 3159.05,
    "override_total_1": 3248.69,
    "override_increase_1": 89.64
  },
  {
    "#": "75 Glen Rd, Unit B-5 & P60 (299-01-68)",
    "$": 657400,
    "address": "75 Glen Rd, Unit B-5 & P60",
    "parcel_id": "299-01-68",
    "owner1": "LEAVITT TR, REBECCA M",
    "owner2": "",
    "current_taxes": 6731.78,
    "new_taxes_no_override": 7022.59,
    "override_total_1": 7221.85,
    "override_increase_1": 199.26
  },
  {
    "#": "75 Glen Rd, Unit B-6 & P59 (299-01-69)",
    "$": 654400,
    "address": "75 Glen Rd, Unit B-6 & P59",
    "parcel_id": "299-01-69",
    "owner1": "WOLF, TODD D &  NEIL & HOPE",
    "owner2": "ALLSHWANG, HARRIET",
    "current_taxes": 6701.06,
    "new_taxes_no_override": 6990.55,
    "override_total_1": 7188.9,
    "override_increase_1": 198.35
  },
  {
    "#": "81 Glen Rd, Unit S-1 P41-66 (299-01-70)",
    "$": 1036500,
    "address": "81 Glen Rd, Unit S-1 P41-66",
    "parcel_id": "299-01-70",
    "owner1": "SPIEGEL, DANIEL M",
    "owner2": "MANDEL, ELYSSA B",
    "current_taxes": 6978.83,
    "new_taxes_no_override": 7280.32,
    "override_total_1": 7486.89,
    "override_increase_1": 206.57
  },
  {
    "#": "81 Glen Rd, Unit S-2 P39-42 (299-01-71)",
    "$": 950500,
    "address": "81 Glen Rd, Unit S-2 P39-42",
    "parcel_id": "299-01-71",
    "owner1": "CHANG, JOYCE",
    "owner2": "GOMEZ, ERNEST D",
    "current_taxes": 9733.12,
    "new_taxes_no_override": 10153.59,
    "override_total_1": 10441.69,
    "override_increase_1": 288.1
  },
  {
    "#": "85 Glen Rd, Unit Nc13 & G19 (299-04-12)",
    "$": 926500,
    "address": "85 Glen Rd, Unit Nc13 & G19",
    "parcel_id": "299-04-12",
    "owner1": "MOUNT, JEANINE",
    "owner2": "",
    "current_taxes": 5852.43,
    "new_taxes_no_override": 6105.25,
    "override_total_1": 6278.49,
    "override_increase_1": 173.23
  },
  {
    "#": "85 Glen Rd, Unit Nc14 & P21 (299-04-13)",
    "$": 1424900,
    "address": "85 Glen Rd, Unit Nc14 & P21",
    "parcel_id": "299-04-13",
    "owner1": "SHAHRAMPOUR, SHAHIN",
    "owner2": "ZAREI, MAHSA",
    "current_taxes": 10956.04,
    "new_taxes_no_override": 11429.34,
    "override_total_1": 11753.64,
    "override_increase_1": 324.3
  },
  {
    "#": "85 Glen Rd, Unit Nc15& P20 (299-04-14)",
    "$": 890000,
    "address": "85 Glen Rd, Unit Nc15& P20",
    "parcel_id": "299-04-14",
    "owner1": "SANG, DOROTHY M",
    "owner2": "",
    "current_taxes": 5478.67,
    "new_taxes_no_override": 5715.35,
    "override_total_1": 5877.52,
    "override_increase_1": 162.17
  },
  {
    "#": "85 Glen Rd, Unit Nc16 &P22 P23 (299-04-15)",
    "$": 1427900,
    "address": "85 Glen Rd, Unit Nc16 &P22 P23",
    "parcel_id": "299-04-15",
    "owner1": "BELLON TR, JENNIFER R",
    "owner2": "",
    "current_taxes": 14621.7,
    "new_taxes_no_override": 15253.36,
    "override_total_1": 15686.16,
    "override_increase_1": 432.8
  },
  {
    "#": "87 Glen Rd, Unit Nc10 (299-04-09)",
    "$": 1328300,
    "address": "87 Glen Rd, Unit Nc10",
    "parcel_id": "299-04-09",
    "owner1": "PHOENIX SERIES BOSTON LLC",
    "owner2": "",
    "current_taxes": 13601.79,
    "new_taxes_no_override": 14189.39,
    "override_total_1": 14592.0,
    "override_increase_1": 402.61
  },
  {
    "#": "87 Glen Rd, Unit Nc11 & G15 (299-04-10)",
    "$": 911500,
    "address": "87 Glen Rd, Unit Nc11 & G15",
    "parcel_id": "299-04-10",
    "owner1": "KOLSKY, HELEN P",
    "owner2": "",
    "current_taxes": 5698.83,
    "new_taxes_no_override": 5945.02,
    "override_total_1": 6113.7,
    "override_increase_1": 168.69
  },
  {
    "#": "87 Glen Rd, Unit Nc12 & G16-17 (299-04-11)",
    "$": 1344700,
    "address": "87 Glen Rd, Unit Nc12 & G16-17",
    "parcel_id": "299-04-11",
    "owner1": "MORERA, CLAUDIO",
    "owner2": "ALMEA, EVA",
    "current_taxes": 10134.79,
    "new_taxes_no_override": 10572.61,
    "override_total_1": 10872.6,
    "override_increase_1": 299.99
  },
  {
    "#": "87 Glen Rd, Unit Nc9 & G14 (299-04-08)",
    "$": 884900,
    "address": "87 Glen Rd, Unit Nc9 & G14",
    "parcel_id": "299-04-08",
    "owner1": "UNO, HAJIME & TOSHIMI",
    "owner2": "",
    "current_taxes": 5426.44,
    "new_taxes_no_override": 5660.86,
    "override_total_1": 5821.48,
    "override_increase_1": 160.62
  },
  {
    "#": "87 Glen Rd, Unit Pk Sp 9 (299-04-17)",
    "$": 88500,
    "address": "87 Glen Rd, Unit Pk Sp 9",
    "parcel_id": "299-04-17",
    "owner1": "CHEN, YAN",
    "owner2": "BO, YU",
    "current_taxes": 906.24,
    "new_taxes_no_override": 945.39,
    "override_total_1": 972.21,
    "override_increase_1": 26.82
  },
  {
    "#": "89 Glen Rd, Unit Nc-7 & P15 (299-04-06)",
    "$": 928500,
    "address": "89 Glen Rd, Unit Nc-7 & P15",
    "parcel_id": "299-04-06",
    "owner1": "SAPSIS, THEMISTOKLIS",
    "owner2": "",
    "current_taxes": 5872.91,
    "new_taxes_no_override": 6126.62,
    "override_total_1": 6300.46,
    "override_increase_1": 173.84
  },
  {
    "#": "89 Glen Rd, Unit Nc-8 & P11 (299-04-07)",
    "$": 1172600,
    "address": "89 Glen Rd, Unit Nc-8 & P11",
    "parcel_id": "299-04-07",
    "owner1": "CORKIN, SETH",
    "owner2": "GRANAT, OLIVIA",
    "current_taxes": 8372.49,
    "new_taxes_no_override": 8734.18,
    "override_total_1": 8982.01,
    "override_increase_1": 247.83
  },
  {
    "#": "89 Glen Rd, Unit Nc5 G7 8 (299-04-04)",
    "$": 1112900,
    "address": "89 Glen Rd, Unit Nc5 G7 8",
    "parcel_id": "299-04-04",
    "owner1": "BI, DAPENG",
    "owner2": "",
    "current_taxes": 7761.16,
    "new_taxes_no_override": 8096.44,
    "override_total_1": 8326.17,
    "override_increase_1": 229.73
  },
  {
    "#": "89 Glen Rd, Unit Nc6 (299-04-05)",
    "$": 1126200,
    "address": "89 Glen Rd, Unit Nc6",
    "parcel_id": "299-04-05",
    "owner1": "CHEN, YAN",
    "owner2": "BO, YU",
    "current_taxes": 7897.35,
    "new_taxes_no_override": 8238.52,
    "override_total_1": 8472.28,
    "override_increase_1": 233.76
  },
  {
    "#": "91 Glen Rd, Unit G6 (299-04-18)",
    "$": 88500,
    "address": "91 Glen Rd, Unit G6",
    "parcel_id": "299-04-18",
    "owner1": "ABREAU TR, CYNTHIA M",
    "owner2": "",
    "current_taxes": 906.24,
    "new_taxes_no_override": 945.39,
    "override_total_1": 972.21,
    "override_increase_1": 26.82
  },
  {
    "#": "91 Glen Rd, Unit Nc-1 & G3 (299-04-16)",
    "$": 1019900,
    "address": "91 Glen Rd, Unit Nc-1 & G3",
    "parcel_id": "299-04-16",
    "owner1": "CUMMINGS, JENNIFER",
    "owner2": "",
    "current_taxes": 6808.84,
    "new_taxes_no_override": 7102.98,
    "override_total_1": 7304.52,
    "override_increase_1": 201.54
  },
  {
    "#": "91 Glen Rd, Unit Nc-3 & P4 (299-04-02)",
    "$": 871500,
    "address": "91 Glen Rd, Unit Nc-3 & P4",
    "parcel_id": "299-04-02",
    "owner1": "FUNG, MICHAEL K",
    "owner2": "YAN, SUSAN",
    "current_taxes": 8924.16,
    "new_taxes_no_override": 9309.68,
    "override_total_1": 9573.84,
    "override_increase_1": 264.16
  },
  {
    "#": "91 Glen Rd, Unit Nc-4 P5&18 (299-04-03)",
    "$": 1326000,
    "address": "91 Glen Rd, Unit Nc-4 P5&18",
    "parcel_id": "299-04-03",
    "owner1": "CERASANI, DONNA J",
    "owner2": "MUENZER, MATTHIAS G",
    "current_taxes": 9943.31,
    "new_taxes_no_override": 10372.86,
    "override_total_1": 10667.18,
    "override_increase_1": 294.32
  },
  {
    "#": "91 Glen Rd, Unit Nc2 & G1-2 (299-04-01)",
    "$": 1483800,
    "address": "91 Glen Rd, Unit Nc2 & G1-2",
    "parcel_id": "299-04-01",
    "owner1": "ABREAU, TR, CYNTHIA",
    "owner2": "",
    "current_taxes": 11559.18,
    "new_taxes_no_override": 12058.54,
    "override_total_1": 12400.69,
    "override_increase_1": 342.15
  },
  {
    "#": "11 Glenland Rd (425-02-00)",
    "$": 1535800,
    "address": "11 Glenland Rd",
    "parcel_id": "425-02-00",
    "owner1": "PATER, JUSTIN",
    "owner2": "TESCH, MEGAN",
    "current_taxes": 12091.66,
    "new_taxes_no_override": 12614.02,
    "override_total_1": 12971.93,
    "override_increase_1": 357.91
  },
  {
    "#": "12 Glenland Rd (424-23-00)",
    "$": 1522400,
    "address": "12 Glenland Rd",
    "parcel_id": "424-23-00",
    "owner1": "CARROLL TRS, PATRICK M & PAMELA A",
    "owner2": "",
    "current_taxes": 15589.38,
    "new_taxes_no_override": 16262.84,
    "override_total_1": 16724.29,
    "override_increase_1": 461.45
  },
  {
    "#": "15 Glenland Rd (425-01-00)",
    "$": 1439900,
    "address": "15 Glenland Rd",
    "parcel_id": "425-01-00",
    "owner1": "GLENLAND ROAD PARTNERS LLC",
    "owner2": "",
    "current_taxes": 14744.58,
    "new_taxes_no_override": 15381.55,
    "override_total_1": 15817.99,
    "override_increase_1": 436.44
  },
  {
    "#": "17 Glenland Rd (425-01-01)",
    "$": 3100,
    "address": "17 Glenland Rd",
    "parcel_id": "425-01-01",
    "owner1": "GLENLAND ROAD PARTNERS LLC",
    "owner2": "",
    "current_taxes": 31.74,
    "new_taxes_no_override": 33.11,
    "override_total_1": 34.05,
    "override_increase_1": 0.94
  },
  {
    "#": "18 Glenland Rd, Unit 1 (424-25-01)",
    "$": 863100,
    "address": "18 Glenland Rd, Unit 1",
    "parcel_id": "424-25-01",
    "owner1": "GILBERT, ABIGAIL",
    "owner2": "PINSKER SMITH, ERIC",
    "current_taxes": 5203.21,
    "new_taxes_no_override": 5427.99,
    "override_total_1": 5582.0,
    "override_increase_1": 154.02
  },
  {
    "#": "18 Glenland Rd, Unit 2 (424-25-02)",
    "$": 886600,
    "address": "18 Glenland Rd, Unit 2",
    "parcel_id": "424-25-02",
    "owner1": "RUPERT, TIMOTHY",
    "owner2": "",
    "current_taxes": 5443.85,
    "new_taxes_no_override": 5679.02,
    "override_total_1": 5840.16,
    "override_increase_1": 161.14
  },
  {
    "#": "18 Glenland Rd, Unit 3 (424-25-03)",
    "$": 654800,
    "address": "18 Glenland Rd, Unit 3",
    "parcel_id": "424-25-03",
    "owner1": "ZIMEL, DAVID M & HELENE G W",
    "owner2": "",
    "current_taxes": 3070.22,
    "new_taxes_no_override": 3202.85,
    "override_total_1": 3293.73,
    "override_increase_1": 90.88
  },
  {
    "#": "32 Glenland Rd (424-26-00)",
    "$": 55800,
    "address": "32 Glenland Rd",
    "parcel_id": "424-26-00",
    "owner1": "BULLARD LIFE ESTATE, JOSEPH W JR & VIRGINIA",
    "owner2": "",
    "current_taxes": 571.39,
    "new_taxes_no_override": 596.07,
    "override_total_1": 612.99,
    "override_increase_1": 16.91
  },
  {
    "#": "33 Glenland Rd, Unit 1 (424-28-01)",
    "$": 1961300,
    "address": "33 Glenland Rd, Unit 1",
    "parcel_id": "424-28-01",
    "owner1": "ALDRICH TRS, ALMA ISABEL ARNEDO",
    "owner2": "CUADRADO, AMADEO CASAS",
    "current_taxes": 16448.78,
    "new_taxes_no_override": 17159.37,
    "override_total_1": 17646.25,
    "override_increase_1": 486.88
  },
  {
    "#": "33 Glenland Rd, Unit 2 (424-28-02)",
    "$": 294600,
    "address": "33 Glenland Rd, Unit 2",
    "parcel_id": "424-28-02",
    "owner1": "EINARSDOTTIR, BRYNJA",
    "owner2": "ALMARSSON, ORN",
    "current_taxes": 3016.7,
    "new_taxes_no_override": 3147.02,
    "override_total_1": 3236.32,
    "override_increase_1": 89.29
  },
  {
    "#": "36 Glenland Rd, Unit 36 (424-30-01)",
    "$": 1857700,
    "address": "36 Glenland Rd, Unit 36",
    "parcel_id": "424-30-01",
    "owner1": "PROVOST TR, VIRGINIA M",
    "owner2": "",
    "current_taxes": 15387.91,
    "new_taxes_no_override": 16052.67,
    "override_total_1": 16508.15,
    "override_increase_1": 455.48
  },
  {
    "#": "39 Glenland Rd, Unit 39 (424-30-02)",
    "$": 1894600,
    "address": "39 Glenland Rd, Unit 39",
    "parcel_id": "424-30-02",
    "owner1": "IHTFP LLC",
    "owner2": "",
    "current_taxes": 19400.7,
    "new_taxes_no_override": 20238.81,
    "override_total_1": 20813.07,
    "override_increase_1": 574.26
  },
  {
    "#": "3 Glenoe Rd (430-05-00)",
    "$": 2832700,
    "address": "3 Glenoe Rd",
    "parcel_id": "430-05-00",
    "owner1": "3 GLENOE ROAD LLC",
    "owner2": "",
    "current_taxes": 29006.85,
    "new_taxes_no_override": 30259.95,
    "override_total_1": 31118.55,
    "override_increase_1": 858.6
  },
  {
    "#": "12 Glenoe Rd (431-06-00)",
    "$": 3206700,
    "address": "12 Glenoe Rd",
    "parcel_id": "431-06-00",
    "owner1": "GERSHWIN, STANLEY B",
    "owner2": "",
    "current_taxes": 29201.67,
    "new_taxes_no_override": 30463.18,
    "override_total_1": 31327.55,
    "override_increase_1": 864.37
  },
  {
    "#": "17 Glenoe Rd (430-06-00)",
    "$": 3742300,
    "address": "17 Glenoe Rd",
    "parcel_id": "430-06-00",
    "owner1": "SLOAN TR, DAVID SCOTT",
    "owner2": "",
    "current_taxes": 38321.15,
    "new_taxes_no_override": 39976.62,
    "override_total_1": 41110.93,
    "override_increase_1": 1134.31
  },
  {
    "#": "20 Glenoe Rd (431-05-00)",
    "$": 4444600,
    "address": "20 Glenoe Rd",
    "parcel_id": "431-05-00",
    "owner1": "BARKAN TRS, PETER  M & AMY P",
    "owner2": "",
    "current_taxes": 41877.77,
    "new_taxes_no_override": 43686.89,
    "override_total_1": 44926.47,
    "override_increase_1": 1239.58
  },
  {
    "#": "25 Glenoe Rd (430-07-00)",
    "$": 3777100,
    "address": "25 Glenoe Rd",
    "parcel_id": "430-07-00",
    "owner1": "LEVITAN, RICHARD L & SUSAN E",
    "owner2": "",
    "current_taxes": 35042.57,
    "new_taxes_no_override": 36556.41,
    "override_total_1": 37593.67,
    "override_increase_1": 1037.26
  },
  {
    "#": "28 Glenoe Rd (431-04-00)",
    "$": 5304800,
    "address": "28 Glenoe Rd",
    "parcel_id": "431-04-00",
    "owner1": "DIMASCIO, JOSEPH C & SARAH A",
    "owner2": "",
    "current_taxes": 50686.22,
    "new_taxes_no_override": 52875.86,
    "override_total_1": 54376.18,
    "override_increase_1": 1500.31
  },
  {
    "#": "39 Glenoe Rd (430-08-00)",
    "$": 3456100,
    "address": "39 Glenoe Rd",
    "parcel_id": "430-08-00",
    "owner1": "ROSS TR, ELINOR S",
    "owner2": "",
    "current_taxes": 31755.53,
    "new_taxes_no_override": 33127.37,
    "override_total_1": 34067.33,
    "override_increase_1": 939.96
  },
  {
    "#": "40 Glenoe Rd (431-03-00)",
    "$": 5011900,
    "address": "40 Glenoe Rd",
    "parcel_id": "431-03-00",
    "owner1": "MERINGOFF, ANGELA H & TODD A",
    "owner2": "",
    "current_taxes": 47686.92,
    "new_taxes_no_override": 49746.99,
    "override_total_1": 51158.53,
    "override_increase_1": 1411.53
  },
  {
    "#": "50 Glenoe Rd (431-02-00)",
    "$": 3604400,
    "address": "50 Glenoe Rd",
    "parcel_id": "431-02-00",
    "owner1": "STUART TRS, RALPH E JR & CAROL T",
    "owner2": "",
    "current_taxes": 33274.12,
    "new_taxes_no_override": 34711.56,
    "override_total_1": 35696.48,
    "override_increase_1": 984.91
  },
  {
    "#": "15 Goddard Ave (352-05-00)",
    "$": 2650100,
    "address": "15 Goddard Ave",
    "parcel_id": "352-05-00",
    "owner1": "SONNETT, MATTHEW & EILEEN",
    "owner2": "",
    "current_taxes": 23502.09,
    "new_taxes_no_override": 24517.38,
    "override_total_1": 25213.04,
    "override_increase_1": 695.66
  },
  {
    "#": "50 Goddard Ave (353-01-08)",
    "$": 54116900,
    "address": "50 Goddard Ave",
    "parcel_id": "353-01-08",
    "owner1": "HELLENIC COLLEGE INC",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "63 Goddard Ave (352-11-12)",
    "$": 14746400,
    "address": "63 Goddard Ave",
    "parcel_id": "352-11-12",
    "owner1": "FRIEDMAN, MARK A & VALERIE JO",
    "owner2": "",
    "current_taxes": 147368.2,
    "new_taxes_no_override": 153734.51,
    "override_total_1": 158096.6,
    "override_increase_1": 4362.1
  },
  {
    "#": "65 Goddard Ave (352-13-00)",
    "$": 8903400,
    "address": "65 Goddard Ave",
    "parcel_id": "352-13-00",
    "owner1": "MCAULIFFE TR, JENNIFER TOOLIN",
    "owner2": "",
    "current_taxes": 87535.88,
    "new_taxes_no_override": 91317.43,
    "override_total_1": 93908.49,
    "override_increase_1": 2591.06
  },
  {
    "#": "75 Goddard Ave (352-14-00)",
    "$": 7315600,
    "address": "75 Goddard Ave",
    "parcel_id": "352-14-00",
    "owner1": "CREAN, BRIAN K",
    "owner2": "",
    "current_taxes": 74911.74,
    "new_taxes_no_override": 78147.93,
    "override_total_1": 80365.31,
    "override_increase_1": 2217.39
  },
  {
    "#": "79 Goddard Ave (352-15-00)",
    "$": 3001700,
    "address": "79 Goddard Ave",
    "parcel_id": "352-15-00",
    "owner1": "PARK SCHOOL CORP",
    "owner2": "",
    "current_taxes": 30737.41,
    "new_taxes_no_override": 32065.27,
    "override_total_1": 32975.09,
    "override_increase_1": 909.83
  },
  {
    "#": "100 Goddard Ave (353-09-10)",
    "$": 11252200,
    "address": "100 Goddard Ave",
    "parcel_id": "353-09-10",
    "owner1": "SMITH, MARILYN RAY",
    "owner2": "FREIFELD, CHARLES",
    "current_taxes": 111587.59,
    "new_taxes_no_override": 116408.17,
    "override_total_1": 119711.17,
    "override_increase_1": 3302.99
  },
  {
    "#": "130 Goddard Ave (354-01-02)",
    "$": 5720200,
    "address": "130 Goddard Ave",
    "parcel_id": "354-01-02",
    "owner1": "KAVADAS, KATHRYN B",
    "owner2": "",
    "current_taxes": 58574.85,
    "new_taxes_no_override": 61105.28,
    "override_total_1": 62839.1,
    "override_increase_1": 1733.82
  },
  {
    "#": "133 Goddard Ave (355-11-00)",
    "$": 9277800,
    "address": "133 Goddard Ave",
    "parcel_id": "355-11-00",
    "owner1": "PARK SCHOOL CORPORATION",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "143 Goddard Ave (355-12-00)",
    "$": 4472300,
    "address": "143 Goddard Ave",
    "parcel_id": "355-12-00",
    "owner1": "PARK SCHOOL CORPORATION",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "162 Goddard Ave (354-01-00)",
    "$": 24019900,
    "address": "162 Goddard Ave",
    "parcel_id": "354-01-00",
    "owner1": "HELLENIC ASSOCIATION OF BOSTON",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "171 Goddard Ave (355-10-00)",
    "$": 90257400,
    "address": "171 Goddard Ave",
    "parcel_id": "355-10-00",
    "owner1": "PARK SCHOOL CORP",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "235 Goddard Ave (355-09-00)",
    "$": 6463200,
    "address": "235 Goddard Ave",
    "parcel_id": "355-09-00",
    "owner1": "PARK SCHOOL CORP",
    "owner2": "",
    "current_taxes": 44612.94,
    "new_taxes_no_override": 46540.22,
    "override_total_1": 47860.76,
    "override_increase_1": 1320.54
  },
  {
    "#": "255 Goddard Ave (355-08-00)",
    "$": 34720100,
    "address": "255 Goddard Ave",
    "parcel_id": "355-08-00",
    "owner1": "PARK SCHOOL CORP",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "265 Goddard Ave (355-07-00)",
    "$": 6379600,
    "address": "265 Goddard Ave",
    "parcel_id": "355-07-00",
    "owner1": "YOUNG JR TRS, J TALBOT",
    "owner2": "BRYANT, DAVID",
    "current_taxes": 61692.17,
    "new_taxes_no_override": 64357.27,
    "override_total_1": 66183.36,
    "override_increase_1": 1826.09
  },
  {
    "#": "271 Goddard Ave (355-06-00)",
    "$": 5271900,
    "address": "271 Goddard Ave",
    "parcel_id": "355-06-00",
    "owner1": "BOIT, CHARLES F D & ARISA S",
    "owner2": "",
    "current_taxes": 50349.32,
    "new_taxes_no_override": 52524.41,
    "override_total_1": 54014.75,
    "override_increase_1": 1490.34
  },
  {
    "#": "275 Goddard Ave (355-05-00)",
    "$": 3878300,
    "address": "275 Goddard Ave",
    "parcel_id": "355-05-00",
    "owner1": "LAWRENCE, ROBIN M & MARGARET H",
    "owner2": "",
    "current_taxes": 36078.86,
    "new_taxes_no_override": 37637.47,
    "override_total_1": 38705.4,
    "override_increase_1": 1067.93
  },
  {
    "#": "285 Goddard Ave (355-04-00)",
    "$": 3265600,
    "address": "285 Goddard Ave",
    "parcel_id": "355-04-00",
    "owner1": "ROSENBERG, THOMAS & VALERIE",
    "owner2": "",
    "current_taxes": 29804.81,
    "new_taxes_no_override": 31092.38,
    "override_total_1": 31974.6,
    "override_increase_1": 882.22
  },
  {
    "#": "287 Goddard Ave, Unit 287 (355-01-22)",
    "$": 1837600,
    "address": "287 Goddard Ave, Unit 287",
    "parcel_id": "355-01-22",
    "owner1": "ELLSWORTH TRS, FRANK E & PAMELA H",
    "owner2": "",
    "current_taxes": 15182.09,
    "new_taxes_no_override": 15837.96,
    "override_total_1": 16287.35,
    "override_increase_1": 449.39
  },
  {
    "#": "289 Goddard Ave, Unit 289 (355-01-01)",
    "$": 1936000,
    "address": "289 Goddard Ave, Unit 289",
    "parcel_id": "355-01-01",
    "owner1": "DANA, RICHARD M & DIANNE C",
    "owner2": "",
    "current_taxes": 16189.71,
    "new_taxes_no_override": 16889.11,
    "override_total_1": 17368.32,
    "override_increase_1": 479.22
  },
  {
    "#": "291 Goddard Ave, Unit 291 (355-01-02)",
    "$": 2343600,
    "address": "291 Goddard Ave, Unit 291",
    "parcel_id": "355-01-02",
    "owner1": "ROSS, RACHEL S & FRANKLIN A",
    "owner2": "",
    "current_taxes": 23998.46,
    "new_taxes_no_override": 25035.19,
    "override_total_1": 25745.55,
    "override_increase_1": 710.35
  },
  {
    "#": "293 Goddard Ave, Unit 293 (355-01-03)",
    "$": 2337900,
    "address": "293 Goddard Ave, Unit 293",
    "parcel_id": "355-01-03",
    "owner1": "CABOT TR, CHRISTINA D",
    "owner2": "C/O CABOT-WELLINGTON, LLC",
    "current_taxes": 20305.16,
    "new_taxes_no_override": 21182.34,
    "override_total_1": 21783.38,
    "override_increase_1": 601.03
  },
  {
    "#": "295 Goddard Ave, Unit 295 (355-01-04)",
    "$": 1759000,
    "address": "295 Goddard Ave, Unit 295",
    "parcel_id": "355-01-04",
    "owner1": "HEFFNER TR, LINDA J",
    "owner2": "",
    "current_taxes": 14377.23,
    "new_taxes_no_override": 14998.33,
    "override_total_1": 15423.89,
    "override_increase_1": 425.57
  },
  {
    "#": "297 Goddard Ave, Unit 297 (355-01-05)",
    "$": 2026000,
    "address": "297 Goddard Ave, Unit 297",
    "parcel_id": "355-01-05",
    "owner1": "SHEU TRS, ERIC G",
    "owner2": "CHO, NANCY L",
    "current_taxes": 17111.31,
    "new_taxes_no_override": 17850.52,
    "override_total_1": 18357.01,
    "override_increase_1": 506.49
  },
  {
    "#": "299 Goddard Ave, Unit 299 (355-01-06)",
    "$": 2090400,
    "address": "299 Goddard Ave, Unit 299",
    "parcel_id": "355-01-06",
    "owner1": "MARSTON, HELEN",
    "owner2": "",
    "current_taxes": 17770.76,
    "new_taxes_no_override": 18538.46,
    "override_total_1": 19064.47,
    "override_increase_1": 526.01
  },
  {
    "#": "301 Goddard Ave, Unit 301 (355-01-07)",
    "$": 1960000,
    "address": "301 Goddard Ave, Unit 301",
    "parcel_id": "355-01-07",
    "owner1": "WHITE, EDWARD B",
    "owner2": "",
    "current_taxes": 16435.47,
    "new_taxes_no_override": 17145.48,
    "override_total_1": 17631.97,
    "override_increase_1": 486.49
  },
  {
    "#": "303 Goddard Ave, Unit 303 (355-01-08)",
    "$": 2012300,
    "address": "303 Goddard Ave, Unit 303",
    "parcel_id": "355-01-08",
    "owner1": "BATCHELDER, SAMUEL L & MARION T",
    "owner2": "",
    "current_taxes": 16971.02,
    "new_taxes_no_override": 17704.17,
    "override_total_1": 18206.51,
    "override_increase_1": 502.34
  },
  {
    "#": "305 Goddard Ave, Unit 305 (355-01-09)",
    "$": 1883900,
    "address": "305 Goddard Ave, Unit 305",
    "parcel_id": "355-01-09",
    "owner1": "KIM, BYUNG KIL",
    "owner2": "SHIN, GRACE J",
    "current_taxes": 15656.2,
    "new_taxes_no_override": 16332.55,
    "override_total_1": 16795.97,
    "override_increase_1": 463.42
  },
  {
    "#": "307 Goddard Ave, Unit 307 (355-01-10)",
    "$": 1966400,
    "address": "307 Goddard Ave, Unit 307",
    "parcel_id": "355-01-10",
    "owner1": "ABERCROMBIE, ANNE H",
    "owner2": "",
    "current_taxes": 16501.0,
    "new_taxes_no_override": 17213.84,
    "override_total_1": 17702.27,
    "override_increase_1": 488.43
  },
  {
    "#": "309 Goddard Ave, Unit 309 (355-01-11)",
    "$": 1938800,
    "address": "309 Goddard Ave, Unit 309",
    "parcel_id": "355-01-11",
    "owner1": "MARSHALL, SHERYL R",
    "owner2": "",
    "current_taxes": 16218.38,
    "new_taxes_no_override": 16919.01,
    "override_total_1": 17399.08,
    "override_increase_1": 480.06
  },
  {
    "#": "311 Goddard Ave, Unit 311 (355-01-12)",
    "$": 1817400,
    "address": "311 Goddard Ave, Unit 311",
    "parcel_id": "355-01-12",
    "owner1": "KLEIN TRS, ANDREW J & JAMES R",
    "owner2": "ABBOTT TR, SUSAN L",
    "current_taxes": 18610.18,
    "new_taxes_no_override": 19414.14,
    "override_total_1": 19965.0,
    "override_increase_1": 550.86
  },
  {
    "#": "315 Goddard Ave, Unit 315 (355-01-13)",
    "$": 2281200,
    "address": "315 Goddard Ave, Unit 315",
    "parcel_id": "355-01-13",
    "owner1": "XU, LIN",
    "owner2": "",
    "current_taxes": 23359.49,
    "new_taxes_no_override": 24368.62,
    "override_total_1": 25060.06,
    "override_increase_1": 691.44
  },
  {
    "#": "317 Goddard Ave, Unit 317 (355-01-14)",
    "$": 1788200,
    "address": "317 Goddard Ave, Unit 317",
    "parcel_id": "355-01-14",
    "owner1": "DOORLY, TERENCE P & ROSEMARY C",
    "owner2": "",
    "current_taxes": 18311.17,
    "new_taxes_no_override": 19102.21,
    "override_total_1": 19644.22,
    "override_increase_1": 542.01
  },
  {
    "#": "319 Goddard Ave, Unit 319 (355-01-15)",
    "$": 1983700,
    "address": "319 Goddard Ave, Unit 319",
    "parcel_id": "355-01-15",
    "owner1": "DAVIS TR, SUSAN E",
    "owner2": "",
    "current_taxes": 16678.15,
    "new_taxes_no_override": 17398.65,
    "override_total_1": 17892.32,
    "override_increase_1": 493.67
  },
  {
    "#": "325 Goddard Ave (355-02-00)",
    "$": 4170200,
    "address": "325 Goddard Ave",
    "parcel_id": "355-02-00",
    "owner1": "HOUSTIS, NICHOLAS",
    "owner2": "LEE, PHILINA",
    "current_taxes": 42702.85,
    "new_taxes_no_override": 44547.61,
    "override_total_1": 45811.62,
    "override_increase_1": 1264.0
  },
  {
    "#": "329 Goddard Ave, Unit 329 (355-01-16)",
    "$": 2115800,
    "address": "329 Goddard Ave, Unit 329",
    "parcel_id": "355-01-16",
    "owner1": "TRIBE TRS, LAURENCE H",
    "owner2": "WESTLING , ELIZABETH",
    "current_taxes": 18030.86,
    "new_taxes_no_override": 18809.79,
    "override_total_1": 19343.51,
    "override_increase_1": 533.71
  },
  {
    "#": "331 Goddard Ave, Unit 331 (355-01-17)",
    "$": 1820300,
    "address": "331 Goddard Ave, Unit 331",
    "parcel_id": "355-01-17",
    "owner1": "DRISCOLL, ROSE MARY",
    "owner2": "",
    "current_taxes": 15004.94,
    "new_taxes_no_override": 15653.15,
    "override_total_1": 16097.3,
    "override_increase_1": 444.15
  },
  {
    "#": "333 Goddard Ave, Unit 333 (355-01-18)",
    "$": 2289300,
    "address": "333 Goddard Ave, Unit 333",
    "parcel_id": "355-01-18",
    "owner1": "SURKIN TRS, CAROL F & ELLIOT M",
    "owner2": "",
    "current_taxes": 19807.5,
    "new_taxes_no_override": 20663.18,
    "override_total_1": 21249.49,
    "override_increase_1": 586.3
  },
  {
    "#": "335 Goddard Ave, Unit 335 (355-01-19)",
    "$": 2166100,
    "address": "335 Goddard Ave, Unit 335",
    "parcel_id": "355-01-19",
    "owner1": "STEBBINS TRS, THEODORE E JR & SUSAN CRAGG RICCI",
    "owner2": "",
    "current_taxes": 18545.93,
    "new_taxes_no_override": 19347.11,
    "override_total_1": 19896.07,
    "override_increase_1": 548.96
  },
  {
    "#": "337 Goddard Ave, Unit 337 (355-01-20)",
    "$": 2017200,
    "address": "337 Goddard Ave, Unit 337",
    "parcel_id": "355-01-20",
    "owner1": "KANTROWITZ TRS, HARRIET A & WARREN",
    "owner2": "",
    "current_taxes": 17021.19,
    "new_taxes_no_override": 17756.51,
    "override_total_1": 18260.33,
    "override_increase_1": 503.83
  },
  {
    "#": "339 Goddard Ave, Unit 339 (355-01-21)",
    "$": 1889500,
    "address": "339 Goddard Ave, Unit 339",
    "parcel_id": "355-01-21",
    "owner1": "CHURCH, MARIA B",
    "owner2": "C/O WELCH & FORBES",
    "current_taxes": 19348.48,
    "new_taxes_no_override": 20184.33,
    "override_total_1": 20757.05,
    "override_increase_1": 572.72
  },
  {
    "#": "399 Goddard Ave (344-07-00)",
    "$": 1184400,
    "address": "399 Goddard Ave",
    "parcel_id": "344-07-00",
    "owner1": "GRIFFIN, ALEXANDER & ISABEL GERMOSEN",
    "owner2": "",
    "current_taxes": 8493.32,
    "new_taxes_no_override": 8860.23,
    "override_total_1": 9111.63,
    "override_increase_1": 251.4
  },
  {
    "#": "9 Goddard Cir (357-23-00)",
    "$": 2430000,
    "address": "9 Goddard Cir",
    "parcel_id": "357-23-00",
    "owner1": "WEISMAN, BARBARA F",
    "owner2": "",
    "current_taxes": 21248.27,
    "new_taxes_no_override": 22166.2,
    "override_total_1": 22795.14,
    "override_increase_1": 628.95
  },
  {
    "#": "10 Goddard Cir (357-28-00)",
    "$": 2719400,
    "address": "10 Goddard Cir",
    "parcel_id": "357-28-00",
    "owner1": "ALBERT, ROBERT I",
    "owner2": "",
    "current_taxes": 24211.72,
    "new_taxes_no_override": 25257.67,
    "override_total_1": 25974.33,
    "override_increase_1": 716.67
  },
  {
    "#": "22 Goddard Cir (357-27-00)",
    "$": 2941300,
    "address": "22 Goddard Cir",
    "parcel_id": "357-27-00",
    "owner1": "GALPERIN TR, LEO",
    "owner2": "",
    "current_taxes": 26483.98,
    "new_taxes_no_override": 27628.09,
    "override_total_1": 28412.01,
    "override_increase_1": 783.93
  },
  {
    "#": "25 Goddard Cir (357-24-00)",
    "$": 2534700,
    "address": "25 Goddard Cir",
    "parcel_id": "357-24-00",
    "owner1": "PEARLMAN, JUSTIN D",
    "owner2": "MARI, SARA",
    "current_taxes": 22320.39,
    "new_taxes_no_override": 23284.63,
    "override_total_1": 23945.31,
    "override_increase_1": 660.68
  },
  {
    "#": "29 Goddard Cir (357-25-00)",
    "$": 2624200,
    "address": "29 Goddard Cir",
    "parcel_id": "357-25-00",
    "owner1": "SCHRETTER, IRMA M",
    "owner2": "",
    "current_taxes": 26871.81,
    "new_taxes_no_override": 28032.67,
    "override_total_1": 28828.08,
    "override_increase_1": 795.41
  },
  {
    "#": "30 Goddard Cir (357-26-00)",
    "$": 3918000,
    "address": "30 Goddard Cir",
    "parcel_id": "357-26-00",
    "owner1": "THIRTY GODDARD CIRCLE LLC",
    "owner2": "C/O DEXTER SOUTHFIELD",
    "current_taxes": 40120.32,
    "new_taxes_no_override": 41853.52,
    "override_total_1": 43041.08,
    "override_increase_1": 1187.56
  },
  {
    "#": "3 Goodnough Rd (374-04-00)",
    "$": 2272500,
    "address": "3 Goodnough Rd",
    "parcel_id": "374-04-00",
    "owner1": "COBEY, FREDERICK",
    "owner2": "DALESSIO, ANA CATALINA",
    "current_taxes": 19635.47,
    "new_taxes_no_override": 20483.72,
    "override_total_1": 21064.93,
    "override_increase_1": 581.21
  },
  {
    "#": "8 Goodnough Rd (395-40-00)",
    "$": 1352200,
    "address": "8 Goodnough Rd",
    "parcel_id": "395-40-00",
    "owner1": "BALDWIN, DAVID H",
    "owner2": "",
    "current_taxes": 10211.59,
    "new_taxes_no_override": 10652.73,
    "override_total_1": 10954.99,
    "override_increase_1": 302.26
  },
  {
    "#": "9 Goodnough Rd (374-05-00)",
    "$": 2442000,
    "address": "9 Goodnough Rd",
    "parcel_id": "374-05-00",
    "owner1": "BARAS, SAMANTHA J",
    "owner2": "DAVE, RISHI",
    "current_taxes": 21371.15,
    "new_taxes_no_override": 22294.38,
    "override_total_1": 22926.97,
    "override_increase_1": 632.59
  },
  {
    "#": "15 Goodnough Rd (374-06-00)",
    "$": 1751000,
    "address": "15 Goodnough Rd",
    "parcel_id": "374-06-00",
    "owner1": "LEE, HENRI",
    "owner2": "SIRACUSE-LEE, DONNA",
    "current_taxes": 17930.24,
    "new_taxes_no_override": 18704.83,
    "override_total_1": 19235.56,
    "override_increase_1": 530.74
  },
  {
    "#": "16 Goodnough Rd (395-39-00)",
    "$": 1749700,
    "address": "16 Goodnough Rd",
    "parcel_id": "395-39-00",
    "owner1": "REALE, DANIEL S",
    "owner2": "",
    "current_taxes": 14281.99,
    "new_taxes_no_override": 14898.97,
    "override_total_1": 15321.72,
    "override_increase_1": 422.75
  },
  {
    "#": "19 Goodnough Rd (374-07-00)",
    "$": 1570200,
    "address": "19 Goodnough Rd",
    "parcel_id": "374-07-00",
    "owner1": "GU TR, YANJIE",
    "owner2": "",
    "current_taxes": 12443.91,
    "new_taxes_no_override": 12981.49,
    "override_total_1": 13349.83,
    "override_increase_1": 368.34
  },
  {
    "#": "22 Goodnough Rd (395-38-00)",
    "$": 1486300,
    "address": "22 Goodnough Rd",
    "parcel_id": "395-38-00",
    "owner1": "GIBSON, CHRISTOPHER J",
    "owner2": "DICHTEL, LAURA E",
    "current_taxes": 11584.78,
    "new_taxes_no_override": 12085.24,
    "override_total_1": 12428.15,
    "override_increase_1": 342.91
  },
  {
    "#": "25 Goodnough Rd (374-08-00)",
    "$": 1422700,
    "address": "25 Goodnough Rd",
    "parcel_id": "374-08-00",
    "owner1": "KIM, YOUNG-BUM & KYUNGAH",
    "owner2": "",
    "current_taxes": 10933.51,
    "new_taxes_no_override": 11405.84,
    "override_total_1": 11729.47,
    "override_increase_1": 323.63
  },
  {
    "#": "28 Goodnough Rd (395-37-00)",
    "$": 1462800,
    "address": "28 Goodnough Rd",
    "parcel_id": "395-37-00",
    "owner1": "TRILLING, JAMES A",
    "owner2": "",
    "current_taxes": 14979.07,
    "new_taxes_no_override": 15626.17,
    "override_total_1": 16069.55,
    "override_increase_1": 443.38
  },
  {
    "#": "29 Goodnough Rd (374-09-00)",
    "$": 1007000,
    "address": "29 Goodnough Rd",
    "parcel_id": "374-09-00",
    "owner1": "SHEINKOPF, ALEXA F",
    "owner2": "",
    "current_taxes": 10311.68,
    "new_taxes_no_override": 10757.14,
    "override_total_1": 11062.37,
    "override_increase_1": 305.23
  },
  {
    "#": "35 Goodnough Rd (374-10-00)",
    "$": 1769800,
    "address": "35 Goodnough Rd",
    "parcel_id": "374-10-00",
    "owner1": "OBRIEN TRS, STEPHEN B & CAROLINE",
    "owner2": "",
    "current_taxes": 14487.82,
    "new_taxes_no_override": 15113.69,
    "override_total_1": 15542.53,
    "override_increase_1": 428.84
  },
  {
    "#": "36 Goodnough Rd (395-36-00)",
    "$": 2156300,
    "address": "36 Goodnough Rd",
    "parcel_id": "395-36-00",
    "owner1": "GETMANSKY, MICHAEL",
    "owner2": "",
    "current_taxes": 18445.58,
    "new_taxes_no_override": 19242.43,
    "override_total_1": 19788.42,
    "override_increase_1": 545.99
  },
  {
    "#": "41 Goodnough Rd (374-11-00)",
    "$": 1504300,
    "address": "41 Goodnough Rd",
    "parcel_id": "374-11-00",
    "owner1": "BRYANT, NORA K & NATHAN",
    "owner2": "",
    "current_taxes": 11769.1,
    "new_taxes_no_override": 12277.53,
    "override_total_1": 12625.89,
    "override_increase_1": 348.37
  },
  {
    "#": "42 Goodnough Rd (395-35-00)",
    "$": 1497400,
    "address": "42 Goodnough Rd",
    "parcel_id": "395-35-00",
    "owner1": "NADERI TRS, TOM SOROOSH MEHDIZADEH & FOROOZ MEHDIZADEH",
    "owner2": "",
    "current_taxes": 15333.38,
    "new_taxes_no_override": 15995.78,
    "override_total_1": 16449.65,
    "override_increase_1": 453.87
  },
  {
    "#": "49 Goodnough Rd (374-12-00)",
    "$": 1483400,
    "address": "49 Goodnough Rd",
    "parcel_id": "374-12-00",
    "owner1": "CHAN, JOSEPH KIN HANG",
    "owner2": "VIDALE, LISA",
    "current_taxes": 11555.08,
    "new_taxes_no_override": 12054.26,
    "override_total_1": 12396.29,
    "override_increase_1": 342.03
  },
  {
    "#": "50 Goodnough Rd (395-34-00)",
    "$": 2279500,
    "address": "50 Goodnough Rd",
    "parcel_id": "395-34-00",
    "owner1": "GANJEI TRS, ALBERT & CAROLINE Y",
    "owner2": "",
    "current_taxes": 19707.15,
    "new_taxes_no_override": 20558.5,
    "override_total_1": 21141.83,
    "override_increase_1": 583.33
  },
  {
    "#": "54 Goodnough Rd (395-44-00)",
    "$": 709400,
    "address": "54 Goodnough Rd",
    "parcel_id": "395-44-00",
    "owner1": "KOHN, JEANETTE WAYNE",
    "owner2": "",
    "current_taxes": 7264.26,
    "new_taxes_no_override": 7578.08,
    "override_total_1": 7793.1,
    "override_increase_1": 215.02
  },
  {
    "#": "55 Goodnough Rd (374-13-00)",
    "$": 1450400,
    "address": "55 Goodnough Rd",
    "parcel_id": "374-13-00",
    "owner1": "LISAK, JESSICA",
    "owner2": "MICKLE, KHODY BLAKE",
    "current_taxes": 11217.16,
    "new_taxes_no_override": 11701.74,
    "override_total_1": 12033.77,
    "override_increase_1": 332.03
  },
  {
    "#": "59 Goodnough Rd (374-14-00)",
    "$": 1359400,
    "address": "59 Goodnough Rd",
    "parcel_id": "374-14-00",
    "owner1": "GOLDSTEIN, JAMES B",
    "owner2": "",
    "current_taxes": 10285.32,
    "new_taxes_no_override": 10729.65,
    "override_total_1": 11034.09,
    "override_increase_1": 304.45
  },
  {
    "#": "64 Goodnough Rd (395-43-00)",
    "$": 1560300,
    "address": "64 Goodnough Rd",
    "parcel_id": "395-43-00",
    "owner1": "KOHN, JEANNETTE W",
    "owner2": "",
    "current_taxes": 12342.54,
    "new_taxes_no_override": 12875.74,
    "override_total_1": 13241.08,
    "override_increase_1": 365.34
  },
  {
    "#": "65 Goodnough Rd (374-15-16)",
    "$": 1486200,
    "address": "65 Goodnough Rd",
    "parcel_id": "374-15-16",
    "owner1": "CHRISTOPHER, KENNETH B",
    "owner2": "HORKAN, CLARE",
    "current_taxes": 11583.75,
    "new_taxes_no_override": 12084.17,
    "override_total_1": 12427.05,
    "override_increase_1": 342.88
  },
  {
    "#": "72 Goodnough Rd (395-31-00)",
    "$": 1419100,
    "address": "72 Goodnough Rd",
    "parcel_id": "395-31-00",
    "owner1": "MCCAIN, ANDREA LEE",
    "owner2": "",
    "current_taxes": 10896.65,
    "new_taxes_no_override": 11367.39,
    "override_total_1": 11689.93,
    "override_increase_1": 322.54
  },
  {
    "#": "76 Goodnough Rd (395-30-00)",
    "$": 1863700,
    "address": "76 Goodnough Rd",
    "parcel_id": "395-30-00",
    "owner1": "LOBB, LESBIA & ROY",
    "owner2": "",
    "current_taxes": 15449.35,
    "new_taxes_no_override": 16116.76,
    "override_total_1": 16574.06,
    "override_increase_1": 457.3
  },
  {
    "#": "79 Goodnough Rd (374-17-00)",
    "$": 1440900,
    "address": "79 Goodnough Rd",
    "parcel_id": "374-17-00",
    "owner1": "GIOVANNUCCI TRS, EDWARD L",
    "owner2": "LIU, YAN",
    "current_taxes": 11119.88,
    "new_taxes_no_override": 11600.26,
    "override_total_1": 11929.41,
    "override_increase_1": 329.15
  },
  {
    "#": "11 Goodwin Pl (177-43-00)",
    "$": 2461800,
    "address": "11 Goodwin Pl",
    "parcel_id": "177-43-00",
    "owner1": "11-12 GOODWIN PLACE LLC",
    "owner2": "",
    "current_taxes": 25208.83,
    "new_taxes_no_override": 26297.85,
    "override_total_1": 27044.03,
    "override_increase_1": 746.18
  },
  {
    "#": "12 Goodwin Pl (177-44-00)",
    "$": 2456700,
    "address": "12 Goodwin Pl",
    "parcel_id": "177-44-00",
    "owner1": "11-12 GOODWIN PLACE LLC",
    "owner2": "",
    "current_taxes": 25156.61,
    "new_taxes_no_override": 26243.38,
    "override_total_1": 26988.01,
    "override_increase_1": 744.64
  },
  {
    "#": "3 Gorham Ave, Unit 5 (198-08-05)",
    "$": 933700,
    "address": "3 Gorham Ave, Unit 5",
    "parcel_id": "198-08-05",
    "owner1": "ALLRED TR, ELIZABETH NEWTON",
    "owner2": "",
    "current_taxes": 5926.15,
    "new_taxes_no_override": 6182.16,
    "override_total_1": 6357.57,
    "override_increase_1": 175.41
  },
  {
    "#": "3 Gorham Ave, Unit 7 (198-08-07)",
    "$": 1352100,
    "address": "3 Gorham Ave, Unit 7",
    "parcel_id": "198-08-07",
    "owner1": "PRATT, DORIS N",
    "owner2": "",
    "current_taxes": 10210.57,
    "new_taxes_no_override": 10651.67,
    "override_total_1": 10953.9,
    "override_increase_1": 302.23
  },
  {
    "#": "5 Gorham Ave, Unit 6 (198-08-06)",
    "$": 887400,
    "address": "5 Gorham Ave, Unit 6",
    "parcel_id": "198-08-06",
    "owner1": "WATKINS, RICHARD S",
    "owner2": "FAY, SARAH ANN",
    "current_taxes": 9086.98,
    "new_taxes_no_override": 9479.54,
    "override_total_1": 9748.51,
    "override_increase_1": 268.97
  },
  {
    "#": "5 Gorham Ave, Unit 8 (198-08-08)",
    "$": 1309700,
    "address": "5 Gorham Ave, Unit 8",
    "parcel_id": "198-08-08",
    "owner1": "WATKINS, RICHARD",
    "owner2": "FAY, SARAH A",
    "current_taxes": 9776.39,
    "new_taxes_no_override": 10198.73,
    "override_total_1": 10488.11,
    "override_increase_1": 289.38
  },
  {
    "#": "11 Gorham Ave (198-10-00)",
    "$": 3061400,
    "address": "11 Gorham Ave",
    "parcel_id": "198-10-00",
    "owner1": "LAIRD, SCHUYLER ALEXANDER & ALEXANDRA ARADER",
    "owner2": "",
    "current_taxes": 27713.8,
    "new_taxes_no_override": 28911.04,
    "override_total_1": 29731.36,
    "override_increase_1": 820.33
  },
  {
    "#": "12 Gorham Ave (197-10-00)",
    "$": 2601300,
    "address": "12 Gorham Ave",
    "parcel_id": "197-10-00",
    "owner1": "FRIEDMAN, DANIEL J",
    "owner2": "PIKTIALIS, DIANE S",
    "current_taxes": 23002.38,
    "new_taxes_no_override": 23996.08,
    "override_total_1": 24676.95,
    "override_increase_1": 680.87
  },
  {
    "#": "15 Gorham Ave (198-01-00)",
    "$": 2154500,
    "address": "15 Gorham Ave",
    "parcel_id": "198-01-00",
    "owner1": "COHEN, MARION",
    "owner2": "KORNFELD, MILTON",
    "current_taxes": 18427.15,
    "new_taxes_no_override": 19223.2,
    "override_total_1": 19768.65,
    "override_increase_1": 545.44
  },
  {
    "#": "16 Gorham Ave (197-09-00)",
    "$": 1977100,
    "address": "16 Gorham Ave",
    "parcel_id": "197-09-00",
    "owner1": "WONG TR, ELAINE D",
    "owner2": "",
    "current_taxes": 16610.57,
    "new_taxes_no_override": 17328.15,
    "override_total_1": 17819.82,
    "override_increase_1": 491.67
  },
  {
    "#": "21 Gorham Ave (199-01-00)",
    "$": 2441300,
    "address": "21 Gorham Ave",
    "parcel_id": "199-01-00",
    "owner1": "WEBER TR, MARK W",
    "owner2": "BRENNER, CATHIE M",
    "current_taxes": 21363.98,
    "new_taxes_no_override": 22286.9,
    "override_total_1": 22919.28,
    "override_increase_1": 632.37
  },
  {
    "#": "26 Gorham Ave (196-20-00)",
    "$": 3181500,
    "address": "26 Gorham Ave",
    "parcel_id": "196-20-00",
    "owner1": "TREISTMAN, ETHAN J & MARISSA HELLER",
    "owner2": "",
    "current_taxes": 28943.63,
    "new_taxes_no_override": 30193.99,
    "override_total_1": 31050.73,
    "override_increase_1": 856.73
  },
  {
    "#": "29 Gorham Ave, Unit 29 & P1-2-3 (199-02-01)",
    "$": 2734200,
    "address": "29 Gorham Ave, Unit 29 & P1-2-3",
    "parcel_id": "199-02-01",
    "owner1": "DICKINSON, JOHN & KAREN",
    "owner2": "",
    "current_taxes": 24363.27,
    "new_taxes_no_override": 25415.76,
    "override_total_1": 26136.92,
    "override_increase_1": 721.15
  },
  {
    "#": "29 Gorham Ave, Unit 31 & P4-5-6 (199-02-02)",
    "$": 2722500,
    "address": "29 Gorham Ave, Unit 31 & P4-5-6",
    "parcel_id": "199-02-02",
    "owner1": "CHASE, ANDREW DAVID",
    "owner2": "HAVLICEK, JENNIFER MARIE",
    "current_taxes": 24243.47,
    "new_taxes_no_override": 25290.79,
    "override_total_1": 26008.39,
    "override_increase_1": 717.61
  },
  {
    "#": "34 Gorham Ave (196-19-00)",
    "$": 3057400,
    "address": "34 Gorham Ave",
    "parcel_id": "196-19-00",
    "owner1": "RITTENBERG, EVE",
    "owner2": "LIEBMAN, JEFFREY B",
    "current_taxes": 27672.84,
    "new_taxes_no_override": 28868.31,
    "override_total_1": 29687.42,
    "override_increase_1": 819.12
  },
  {
    "#": "35 Gorham Ave, Unit 1 & P3-4 G5 (199-03-01)",
    "$": 1224100,
    "address": "35 Gorham Ave, Unit 1 & P3-4 G5",
    "parcel_id": "199-03-01",
    "owner1": "GREENE TR, NATHANAEL",
    "owner2": "",
    "current_taxes": 12534.78,
    "new_taxes_no_override": 13076.28,
    "override_total_1": 13447.31,
    "override_increase_1": 371.03
  },
  {
    "#": "35 Gorham Ave, Unit 2 & P1-2 G6 (199-03-02)",
    "$": 1564300,
    "address": "35 Gorham Ave, Unit 2 & P1-2 G6",
    "parcel_id": "199-03-02",
    "owner1": "BOSHELL, SEAMUS W",
    "owner2": "GREENE, JENNIFER R",
    "current_taxes": 12383.5,
    "new_taxes_no_override": 12918.47,
    "override_total_1": 13285.02,
    "override_increase_1": 366.55
  },
  {
    "#": "36 Gorham Ave, Unit 1 (196-18-01)",
    "$": 2390800,
    "address": "36 Gorham Ave, Unit 1",
    "parcel_id": "196-18-01",
    "owner1": "PETROVA, PETIA",
    "owner2": "IVANOV, GUEORGUI",
    "current_taxes": 20846.86,
    "new_taxes_no_override": 21747.44,
    "override_total_1": 22364.51,
    "override_increase_1": 617.07
  },
  {
    "#": "36 Gorham Ave, Unit 2 (196-18-02)",
    "$": 1667400,
    "address": "36 Gorham Ave, Unit 2",
    "parcel_id": "196-18-02",
    "owner1": "RETT, DOUGLAS JOHN & MELISA DIANE",
    "owner2": "",
    "current_taxes": 13439.24,
    "new_taxes_no_override": 14019.82,
    "override_total_1": 14417.62,
    "override_increase_1": 397.8
  },
  {
    "#": "37 Gorham Ave, Unit 1 (199-04-01)",
    "$": 920800,
    "address": "37 Gorham Ave, Unit 1",
    "parcel_id": "199-04-01",
    "owner1": "LEITER, MARK D & REBECCA B",
    "owner2": "",
    "current_taxes": 9428.99,
    "new_taxes_no_override": 9836.32,
    "override_total_1": 10115.42,
    "override_increase_1": 279.1
  },
  {
    "#": "37 Gorham Ave, Unit 2 (199-04-02)",
    "$": 1308900,
    "address": "37 Gorham Ave, Unit 2",
    "parcel_id": "199-04-02",
    "owner1": "LIN, JUAN K",
    "owner2": "LOPEZ-PINTADO, SARA",
    "current_taxes": 9768.2,
    "new_taxes_no_override": 10190.19,
    "override_total_1": 10479.32,
    "override_increase_1": 289.14
  },
  {
    "#": "38 Gorham Ave, Unit 38 & G1 G2 (196-17-01)",
    "$": 3204200,
    "address": "38 Gorham Ave, Unit 38 & G1 G2",
    "parcel_id": "196-17-01",
    "owner1": "WONG TRS, BRETT W S & ALEXANDRA K",
    "owner2": "",
    "current_taxes": 32811.01,
    "new_taxes_no_override": 34228.45,
    "override_total_1": 35199.65,
    "override_increase_1": 971.21
  },
  {
    "#": "38 Gorham Ave, Unit 40 & G3 G4 (196-17-02)",
    "$": 2849500,
    "address": "38 Gorham Ave, Unit 40 & G3 G4",
    "parcel_id": "196-17-02",
    "owner1": "KULBAK, GUY",
    "owner2": "GEVA, TAMAR S",
    "current_taxes": 29178.88,
    "new_taxes_no_override": 30439.41,
    "override_total_1": 31303.1,
    "override_increase_1": 863.69
  },
  {
    "#": "41 Gorham Ave, Unit 1 & Gar A P1 (199-05-01)",
    "$": 936000,
    "address": "41 Gorham Ave, Unit 1 & Gar A P1",
    "parcel_id": "199-05-01",
    "owner1": "ROSENSTOCK, H F TZVIYAH",
    "owner2": "BLOOMSTEIN, THEODORE MICHAEL",
    "current_taxes": 9584.64,
    "new_taxes_no_override": 9998.7,
    "override_total_1": 10282.4,
    "override_increase_1": 283.71
  },
  {
    "#": "41 Gorham Ave, Unit 2 & Gar B P2 (199-05-02)",
    "$": 1016600,
    "address": "41 Gorham Ave, Unit 2 & Gar B P2",
    "parcel_id": "199-05-02",
    "owner1": "SHORT, HILARY L",
    "owner2": "",
    "current_taxes": 6775.05,
    "new_taxes_no_override": 7067.73,
    "override_total_1": 7268.27,
    "override_increase_1": 200.54
  },
  {
    "#": "48 Gorham Ave (196-16-01)",
    "$": 2149600,
    "address": "48 Gorham Ave",
    "parcel_id": "196-16-01",
    "owner1": "HBW LLC",
    "owner2": "",
    "current_taxes": 22011.9,
    "new_taxes_no_override": 22962.81,
    "override_total_1": 23614.37,
    "override_increase_1": 651.55
  },
  {
    "#": "49 Gorham Ave (199-06-00)",
    "$": 2442400,
    "address": "49 Gorham Ave",
    "parcel_id": "199-06-00",
    "owner1": "HAYES TR, GERARD J",
    "owner2": "",
    "current_taxes": 21375.24,
    "new_taxes_no_override": 22298.65,
    "override_total_1": 22931.36,
    "override_increase_1": 632.71
  },
  {
    "#": "50 Gorham Ave (196-16-00)",
    "$": 2215700,
    "address": "50 Gorham Ave",
    "parcel_id": "196-16-00",
    "owner1": "BROWN, CORNELIA W",
    "owner2": "",
    "current_taxes": 19053.83,
    "new_taxes_no_override": 19876.96,
    "override_total_1": 20440.95,
    "override_increase_1": 563.99
  },
  {
    "#": "51 Gorham Ave, Unit 1 (199-07-02)",
    "$": 767300,
    "address": "51 Gorham Ave, Unit 1",
    "parcel_id": "199-07-02",
    "owner1": "PAKTINAT, MAHNAZ",
    "owner2": "",
    "current_taxes": 4222.22,
    "new_taxes_no_override": 4404.62,
    "override_total_1": 4529.6,
    "override_increase_1": 124.98
  },
  {
    "#": "51 Gorham Ave, Unit 2 (199-07-03)",
    "$": 791500,
    "address": "51 Gorham Ave, Unit 2",
    "parcel_id": "199-07-03",
    "owner1": "LIU, ZHUO",
    "owner2": "CHEN, ZHIKE",
    "current_taxes": 4470.03,
    "new_taxes_no_override": 4663.14,
    "override_total_1": 4795.45,
    "override_increase_1": 132.31
  },
  {
    "#": "51 Gorham Ave, Unit 3 (199-07-04)",
    "$": 791500,
    "address": "51 Gorham Ave, Unit 3",
    "parcel_id": "199-07-04",
    "owner1": "DESHARONE, AVITAL HILA",
    "owner2": "HYDE, ANDREW ERIC",
    "current_taxes": 4470.03,
    "new_taxes_no_override": 4663.14,
    "override_total_1": 4795.45,
    "override_increase_1": 132.31
  },
  {
    "#": "51 Gorham Ave, Unit G (199-07-01)",
    "$": 593700,
    "address": "51 Gorham Ave, Unit G",
    "parcel_id": "199-07-01",
    "owner1": "DEVLIN, SAMANTHA M",
    "owner2": "",
    "current_taxes": 6079.49,
    "new_taxes_no_override": 6342.12,
    "override_total_1": 6522.08,
    "override_increase_1": 179.95
  },
  {
    "#": "60 Gorham Ave (196-15-00)",
    "$": 6398100,
    "address": "60 Gorham Ave",
    "parcel_id": "196-15-00",
    "owner1": "PENG, TRS, JAMES LW & NANCY Y",
    "owner2": "",
    "current_taxes": 65516.54,
    "new_taxes_no_override": 68346.85,
    "override_total_1": 70286.14,
    "override_increase_1": 1939.29
  },
  {
    "#": "5 Grassmere Rd (391-13-14)",
    "$": 1580900,
    "address": "5 Grassmere Rd",
    "parcel_id": "391-13-14",
    "owner1": "PFOHO LLC",
    "owner2": "",
    "current_taxes": 16188.42,
    "new_taxes_no_override": 16887.76,
    "override_total_1": 17366.94,
    "override_increase_1": 479.18
  },
  {
    "#": "24 Grassmere Rd (386-11-00)",
    "$": 1406900,
    "address": "24 Grassmere Rd",
    "parcel_id": "386-11-00",
    "owner1": "WEISS, KRISTA",
    "owner2": "SUAREZ, LUIS",
    "current_taxes": 14406.66,
    "new_taxes_no_override": 15029.03,
    "override_total_1": 15455.46,
    "override_increase_1": 426.44
  },
  {
    "#": "25 Grassmere Rd (390-13-00)",
    "$": 1249900,
    "address": "25 Grassmere Rd",
    "parcel_id": "390-13-00",
    "owner1": "TOPPELBERG, CLAUDIO O & SARA B R",
    "owner2": "",
    "current_taxes": 9164.04,
    "new_taxes_no_override": 9559.93,
    "override_total_1": 9831.18,
    "override_increase_1": 271.26
  },
  {
    "#": "31 Grassmere Rd (390-14-00)",
    "$": 1151000,
    "address": "31 Grassmere Rd",
    "parcel_id": "390-14-00",
    "owner1": "WANG, HUA",
    "owner2": "DAI, NING",
    "current_taxes": 11786.24,
    "new_taxes_no_override": 12295.41,
    "override_total_1": 12644.28,
    "override_increase_1": 348.87
  },
  {
    "#": "32 Grassmere Rd (386-10-00)",
    "$": 1121400,
    "address": "32 Grassmere Rd",
    "parcel_id": "386-10-00",
    "owner1": "SALTMAN TRS, JAMES A",
    "owner2": "DONOHUE-SALTMAN TRS, ELLEN T",
    "current_taxes": 7848.2,
    "new_taxes_no_override": 8187.24,
    "override_total_1": 8419.55,
    "override_increase_1": 232.31
  },
  {
    "#": "13 Green Hill Rd (334-31-01)",
    "$": 1534800,
    "address": "13 Green Hill Rd",
    "parcel_id": "334-31-01",
    "owner1": "HUEBNER, ALEXANDRA M",
    "owner2": "",
    "current_taxes": 15716.35,
    "new_taxes_no_override": 16395.3,
    "override_total_1": 16860.5,
    "override_increase_1": 465.2
  },
  {
    "#": "24 Green Hill Rd (334-16-03)",
    "$": 6550500,
    "address": "24 Green Hill Rd",
    "parcel_id": "334-16-03",
    "owner1": "ANTHONY, SCOTT",
    "owner2": "",
    "current_taxes": 63442.19,
    "new_taxes_no_override": 66182.89,
    "override_total_1": 68060.78,
    "override_increase_1": 1877.89
  },
  {
    "#": "33 Green Hill Rd (334-20-00)",
    "$": 6069300,
    "address": "33 Green Hill Rd",
    "parcel_id": "334-20-00",
    "owner1": "CHEN, LIU-ER & DAWN",
    "owner2": "",
    "current_taxes": 58514.7,
    "new_taxes_no_override": 61042.54,
    "override_total_1": 62774.57,
    "override_increase_1": 1732.04
  },
  {
    "#": "36 Green Hill Rd (334-16-02)",
    "$": 10757000,
    "address": "36 Green Hill Rd",
    "parcel_id": "334-16-02",
    "owner1": "TREFLER, PAMELA L & ALAN N",
    "owner2": "",
    "current_taxes": 106516.75,
    "new_taxes_no_override": 111118.27,
    "override_total_1": 114271.17,
    "override_increase_1": 3152.9
  },
  {
    "#": "43 Green Hill Rd (334-23-01)",
    "$": 2148400,
    "address": "43 Green Hill Rd",
    "parcel_id": "334-23-01",
    "owner1": "RESOLUTION REALTY TRUST",
    "owner2": "",
    "current_taxes": 18364.68,
    "new_taxes_no_override": 19158.03,
    "override_total_1": 19701.63,
    "override_increase_1": 543.59
  },
  {
    "#": "44 Green Hill Rd (334-17-00)",
    "$": 11935700,
    "address": "44 Green Hill Rd",
    "parcel_id": "334-17-00",
    "owner1": "PORTER TR, MICHAEL E",
    "owner2": "",
    "current_taxes": 122221.57,
    "new_taxes_no_override": 127501.54,
    "override_total_1": 131119.3,
    "override_increase_1": 3617.76
  },
  {
    "#": "48 Green Hill Rd (334-16-00)",
    "$": 5511100,
    "address": "48 Green Hill Rd",
    "parcel_id": "334-16-00",
    "owner1": "ROSE, CLAYTON & JULIANNE",
    "owner2": "",
    "current_taxes": 56433.66,
    "new_taxes_no_override": 58871.59,
    "override_total_1": 60542.03,
    "override_increase_1": 1670.44
  },
  {
    "#": "14 Green St (047A-15-01)",
    "$": 6411300,
    "address": "14 Green St",
    "parcel_id": "047A-15-01",
    "owner1": "COOLIDGE CORNER GREEN LLC",
    "owner2": "",
    "current_taxes": 67869.88,
    "new_taxes_no_override": 70801.86,
    "override_total_1": 72810.81,
    "override_increase_1": 2008.95
  },
  {
    "#": "15 Green St, Unit 1 (045-06-24)",
    "$": 399300,
    "address": "15 Green St, Unit 1",
    "parcel_id": "045-06-24",
    "owner1": "GREENHILL LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 4088.83,
    "new_taxes_no_override": 4265.47,
    "override_total_1": 4386.5,
    "override_increase_1": 121.03
  },
  {
    "#": "15 Green St, Unit 2 (045-06-01)",
    "$": 543200,
    "address": "15 Green St, Unit 2",
    "parcel_id": "045-06-01",
    "owner1": "GREENHILL LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 5562.37,
    "new_taxes_no_override": 5802.66,
    "override_total_1": 5967.31,
    "override_increase_1": 164.65
  },
  {
    "#": "15 Green St, Unit 3 (045-06-02)",
    "$": 455900,
    "address": "15 Green St, Unit 3",
    "parcel_id": "045-06-02",
    "owner1": "GREENHILL LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 4668.42,
    "new_taxes_no_override": 4870.1,
    "override_total_1": 5008.28,
    "override_increase_1": 138.19
  },
  {
    "#": "15 Green St, Unit 4 (045-06-03)",
    "$": 527500,
    "address": "15 Green St, Unit 4",
    "parcel_id": "045-06-03",
    "owner1": "EINHORN, DONNA FUCHS & ROBERT",
    "owner2": "",
    "current_taxes": 5401.6,
    "new_taxes_no_override": 5634.95,
    "override_total_1": 5794.84,
    "override_increase_1": 159.89
  },
  {
    "#": "15 Green St, Unit 5 (045-06-04)",
    "$": 467900,
    "address": "15 Green St, Unit 5",
    "parcel_id": "045-06-04",
    "owner1": "XU TRS, YAN & RENA",
    "owner2": "",
    "current_taxes": 4791.3,
    "new_taxes_no_override": 4998.28,
    "override_total_1": 5140.11,
    "override_increase_1": 141.82
  },
  {
    "#": "15 Green St, Unit 6 (045-06-05)",
    "$": 539400,
    "address": "15 Green St, Unit 6",
    "parcel_id": "045-06-05",
    "owner1": "GREENHILL LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 5523.46,
    "new_taxes_no_override": 5762.07,
    "override_total_1": 5925.57,
    "override_increase_1": 163.49
  },
  {
    "#": "17 Green St, Unit 1 (045-06-06)",
    "$": 490000,
    "address": "17 Green St, Unit 1",
    "parcel_id": "045-06-06",
    "owner1": "GREENHILL LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 5017.6,
    "new_taxes_no_override": 5234.36,
    "override_total_1": 5382.88,
    "override_increase_1": 148.52
  },
  {
    "#": "17 Green St, Unit 1 (045-06-12)",
    "$": 407100,
    "address": "17 Green St, Unit 1",
    "parcel_id": "045-06-12",
    "owner1": "GREENHILL LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 4168.7,
    "new_taxes_no_override": 4348.79,
    "override_total_1": 4472.18,
    "override_increase_1": 123.39
  },
  {
    "#": "17 Green St, Unit 2 (045-06-07)",
    "$": 469100,
    "address": "17 Green St, Unit 2",
    "parcel_id": "045-06-07",
    "owner1": "GREENHILL LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 4803.58,
    "new_taxes_no_override": 5011.09,
    "override_total_1": 5153.28,
    "override_increase_1": 142.19
  },
  {
    "#": "17 Green St, Unit 2 (045-06-13)",
    "$": 495500,
    "address": "17 Green St, Unit 2",
    "parcel_id": "045-06-13",
    "owner1": "GREENHILL LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 5073.92,
    "new_taxes_no_override": 5293.11,
    "override_total_1": 5443.3,
    "override_increase_1": 150.19
  },
  {
    "#": "17 Green St, Unit 3 (045-06-08)",
    "$": 580000,
    "address": "17 Green St, Unit 3",
    "parcel_id": "045-06-08",
    "owner1": "FUCHS, DONNA",
    "owner2": "EINHORN, ROBERT",
    "current_taxes": 5939.2,
    "new_taxes_no_override": 6195.77,
    "override_total_1": 6371.57,
    "override_increase_1": 175.8
  },
  {
    "#": "17 Green St, Unit 3 (045-06-14)",
    "$": 340200,
    "address": "17 Green St, Unit 3",
    "parcel_id": "045-06-14",
    "owner1": "GREENHILL LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 3483.65,
    "new_taxes_no_override": 3634.14,
    "override_total_1": 3737.26,
    "override_increase_1": 103.12
  },
  {
    "#": "17 Green St, Unit 4 (045-06-09)",
    "$": 440600,
    "address": "17 Green St, Unit 4",
    "parcel_id": "045-06-09",
    "owner1": "SCHNEIDERMAN, JONATHAN",
    "owner2": "",
    "current_taxes": 4511.74,
    "new_taxes_no_override": 4706.65,
    "override_total_1": 4840.19,
    "override_increase_1": 133.55
  },
  {
    "#": "17 Green St, Unit 4 (045-06-15)",
    "$": 371000,
    "address": "17 Green St, Unit 4",
    "parcel_id": "045-06-15",
    "owner1": "GREENHILL LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 3799.04,
    "new_taxes_no_override": 3963.16,
    "override_total_1": 4075.61,
    "override_increase_1": 112.45
  },
  {
    "#": "17 Green St, Unit 5 (045-06-10)",
    "$": 583500,
    "address": "17 Green St, Unit 5",
    "parcel_id": "045-06-10",
    "owner1": "BERNSTEIN, DEENA",
    "owner2": "",
    "current_taxes": 5975.04,
    "new_taxes_no_override": 6233.16,
    "override_total_1": 6410.02,
    "override_increase_1": 176.86
  },
  {
    "#": "17 Green St, Unit 5 (045-06-16)",
    "$": 384200,
    "address": "17 Green St, Unit 5",
    "parcel_id": "045-06-16",
    "owner1": "GREENHILL LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 3934.21,
    "new_taxes_no_override": 4104.17,
    "override_total_1": 4220.62,
    "override_increase_1": 116.45
  },
  {
    "#": "17 Green St, Unit 6 (045-06-11)",
    "$": 440600,
    "address": "17 Green St, Unit 6",
    "parcel_id": "045-06-11",
    "owner1": "GREENHILL LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 4511.74,
    "new_taxes_no_override": 4706.65,
    "override_total_1": 4840.19,
    "override_increase_1": 133.55
  },
  {
    "#": "17 Green St, Unit 6 (045-06-17)",
    "$": 380600,
    "address": "17 Green St, Unit 6",
    "parcel_id": "045-06-17",
    "owner1": "GREENHILL LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 3897.34,
    "new_taxes_no_override": 4065.71,
    "override_total_1": 4181.07,
    "override_increase_1": 115.36
  },
  {
    "#": "19 Green St, Unit 1 (045-06-18)",
    "$": 523500,
    "address": "19 Green St, Unit 1",
    "parcel_id": "045-06-18",
    "owner1": "GREENHILL LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 5360.64,
    "new_taxes_no_override": 5592.22,
    "override_total_1": 5750.89,
    "override_increase_1": 158.67
  },
  {
    "#": "19 Green St, Unit 2 (045-06-19)",
    "$": 517900,
    "address": "19 Green St, Unit 2",
    "parcel_id": "045-06-19",
    "owner1": "GREENHILL LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 5303.3,
    "new_taxes_no_override": 5532.4,
    "override_total_1": 5689.38,
    "override_increase_1": 156.98
  },
  {
    "#": "19 Green St, Unit 3 (045-06-20)",
    "$": 570900,
    "address": "19 Green St, Unit 3",
    "parcel_id": "045-06-20",
    "owner1": "GREENHILL LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 5846.02,
    "new_taxes_no_override": 6098.57,
    "override_total_1": 6271.61,
    "override_increase_1": 173.04
  },
  {
    "#": "19 Green St, Unit 4 (045-06-21)",
    "$": 479700,
    "address": "19 Green St, Unit 4",
    "parcel_id": "045-06-21",
    "owner1": "GREENHILL LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 4912.13,
    "new_taxes_no_override": 5124.33,
    "override_total_1": 5269.73,
    "override_increase_1": 145.4
  },
  {
    "#": "19 Green St, Unit 5 (045-06-22)",
    "$": 582800,
    "address": "19 Green St, Unit 5",
    "parcel_id": "045-06-22",
    "owner1": "GREENHILL LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 5967.87,
    "new_taxes_no_override": 6225.68,
    "override_total_1": 6402.33,
    "override_increase_1": 176.65
  },
  {
    "#": "19 Green St, Unit 6 (045-06-23)",
    "$": 493300,
    "address": "19 Green St, Unit 6",
    "parcel_id": "045-06-23",
    "owner1": "GREENHILL LLC",
    "owner2": "",
    "current_taxes": 5051.39,
    "new_taxes_no_override": 5269.61,
    "override_total_1": 5419.13,
    "override_increase_1": 149.52
  },
  {
    "#": "21 Green St, Unit 1 (045-09-23)",
    "$": 1122200,
    "address": "21 Green St, Unit 1",
    "parcel_id": "045-09-23",
    "owner1": "SILVER, EVAN",
    "owner2": "ROBBINS, JILL",
    "current_taxes": 7856.39,
    "new_taxes_no_override": 8195.79,
    "override_total_1": 8428.34,
    "override_increase_1": 232.55
  },
  {
    "#": "21 Green St, Unit 2 (045-09-01)",
    "$": 1139400,
    "address": "21 Green St, Unit 2",
    "parcel_id": "045-09-01",
    "owner1": "LEVITAN, MATTHEW S",
    "owner2": "CIZEK, ELLEN M",
    "current_taxes": 8032.52,
    "new_taxes_no_override": 8379.52,
    "override_total_1": 8617.29,
    "override_increase_1": 237.76
  },
  {
    "#": "21 Green St, Unit 3 (045-09-02)",
    "$": 1152200,
    "address": "21 Green St, Unit 3",
    "parcel_id": "045-09-02",
    "owner1": "LAYTON, CHRISTINE N",
    "owner2": "",
    "current_taxes": 11798.53,
    "new_taxes_no_override": 12308.23,
    "override_total_1": 12657.46,
    "override_increase_1": 349.24
  },
  {
    "#": "25 Green St, Unit 1 (045-09-03)",
    "$": 1037900,
    "address": "25 Green St, Unit 1",
    "parcel_id": "045-09-03",
    "owner1": "YAMATIN, MATTHEW & CHIKAE",
    "owner2": "",
    "current_taxes": 6993.16,
    "new_taxes_no_override": 7295.26,
    "override_total_1": 7502.26,
    "override_increase_1": 207.0
  },
  {
    "#": "25 Green St, Unit 2 (045-09-04)",
    "$": 1046200,
    "address": "25 Green St, Unit 2",
    "parcel_id": "045-09-04",
    "owner1": "OBRIEN TR, SANDA",
    "owner2": "",
    "current_taxes": 10713.09,
    "new_taxes_no_override": 11175.9,
    "override_total_1": 11493.0,
    "override_increase_1": 317.11
  },
  {
    "#": "25 Green St, Unit 3 (045-09-05)",
    "$": 1086800,
    "address": "25 Green St, Unit 3",
    "parcel_id": "045-09-05",
    "owner1": "HABER, ANN I & ANDREW T",
    "owner2": "",
    "current_taxes": 11128.83,
    "new_taxes_no_override": 11609.6,
    "override_total_1": 11939.01,
    "override_increase_1": 329.41
  },
  {
    "#": "27 Green St, Unit B (045-09-06)",
    "$": 848300,
    "address": "27 Green St, Unit B",
    "parcel_id": "045-09-06",
    "owner1": "PROSSER, LISA",
    "owner2": "YASSIR, WALID K",
    "current_taxes": 8686.59,
    "new_taxes_no_override": 9061.85,
    "override_total_1": 9318.97,
    "override_increase_1": 257.12
  },
  {
    "#": "29 Green St, Unit 1 (045-09-07)",
    "$": 964100,
    "address": "29 Green St, Unit 1",
    "parcel_id": "045-09-07",
    "owner1": "COHEN, AARON ERICKSON & ELIZABETH ULLMAN",
    "owner2": "",
    "current_taxes": 6237.45,
    "new_taxes_no_override": 6506.91,
    "override_total_1": 6691.54,
    "override_increase_1": 184.63
  },
  {
    "#": "29 Green St, Unit 2 (045-09-08)",
    "$": 984000,
    "address": "29 Green St, Unit 2",
    "parcel_id": "045-09-08",
    "owner1": "BRAT, GABRIEL A",
    "owner2": "LAI, YVONNE",
    "current_taxes": 10076.16,
    "new_taxes_no_override": 10511.45,
    "override_total_1": 10809.7,
    "override_increase_1": 298.25
  },
  {
    "#": "29 Green St, Unit 3 (045-09-09)",
    "$": 992900,
    "address": "29 Green St, Unit 3",
    "parcel_id": "045-09-09",
    "owner1": "SLOPEN, NATALIE",
    "owner2": "DRAKE, CHRISTOPHER M",
    "current_taxes": 10167.3,
    "new_taxes_no_override": 10606.53,
    "override_total_1": 10907.48,
    "override_increase_1": 300.95
  },
  {
    "#": "45 Green St (046-05-00)",
    "$": 8126000,
    "address": "45 Green St",
    "parcel_id": "046-05-00",
    "owner1": "GREEN STREET PROPERTY OWNER LLC",
    "owner2": "C/O NORDBLOM CO INC",
    "current_taxes": 83210.24,
    "new_taxes_no_override": 86804.92,
    "override_total_1": 89267.95,
    "override_increase_1": 2463.02
  },
  {
    "#": "50 Green St, Unit 101 (047-16-01)",
    "$": 552200,
    "address": "50 Green St, Unit 101",
    "parcel_id": "047-16-01",
    "owner1": "ELESSAWI, ADAM L",
    "owner2": "SINGH, DAMINI",
    "current_taxes": 2019.59,
    "new_taxes_no_override": 2106.84,
    "override_total_1": 2166.62,
    "override_increase_1": 59.78
  },
  {
    "#": "50 Green St, Unit 102 (047-16-02)",
    "$": 545500,
    "address": "50 Green St, Unit 102",
    "parcel_id": "047-16-02",
    "owner1": "FOSTER, JACK & LAUREN",
    "owner2": "",
    "current_taxes": 5585.92,
    "new_taxes_no_override": 5827.23,
    "override_total_1": 5992.57,
    "override_increase_1": 165.34
  },
  {
    "#": "50 Green St, Unit 103 & P-45 (047-16-03)",
    "$": 583700,
    "address": "50 Green St, Unit 103 & P-45",
    "parcel_id": "047-16-03",
    "owner1": "ZHANG, LIANG",
    "owner2": "",
    "current_taxes": 5977.09,
    "new_taxes_no_override": 6235.3,
    "override_total_1": 6412.22,
    "override_increase_1": 176.92
  },
  {
    "#": "50 Green St, Unit 104 (047-16-04)",
    "$": 519700,
    "address": "50 Green St, Unit 104",
    "parcel_id": "047-16-04",
    "owner1": "FITZGIBBON ET AL TRS, DANIEL",
    "owner2": "C/O DAVID ALTMAN-MGR",
    "current_taxes": 5321.73,
    "new_taxes_no_override": 5551.63,
    "override_total_1": 5709.15,
    "override_increase_1": 157.52
  },
  {
    "#": "50 Green St, Unit 105 (047-16-05)",
    "$": 560900,
    "address": "50 Green St, Unit 105",
    "parcel_id": "047-16-05",
    "owner1": "JAY TRS, KEVIN R & SARA M",
    "owner2": "",
    "current_taxes": 5743.62,
    "new_taxes_no_override": 5991.74,
    "override_total_1": 6161.76,
    "override_increase_1": 170.01
  },
  {
    "#": "50 Green St, Unit 106 (047-16-06)",
    "$": 693100,
    "address": "50 Green St, Unit 106",
    "parcel_id": "047-16-06",
    "owner1": "WEISER TR, WENDY M",
    "owner2": "",
    "current_taxes": 3462.41,
    "new_taxes_no_override": 3611.99,
    "override_total_1": 3714.47,
    "override_increase_1": 102.49
  },
  {
    "#": "50 Green St, Unit 107 (047-16-07)",
    "$": 425600,
    "address": "50 Green St, Unit 107",
    "parcel_id": "047-16-07",
    "owner1": "LKCY UNO LLC",
    "owner2": "",
    "current_taxes": 4358.14,
    "new_taxes_no_override": 4546.41,
    "override_total_1": 4675.41,
    "override_increase_1": 129.0
  },
  {
    "#": "50 Green St, Unit 108 (047-16-08)",
    "$": 759100,
    "address": "50 Green St, Unit 108",
    "parcel_id": "047-16-08",
    "owner1": "PARK, JIHYE",
    "owner2": "",
    "current_taxes": 7773.18,
    "new_taxes_no_override": 8108.98,
    "override_total_1": 8339.07,
    "override_increase_1": 230.09
  },
  {
    "#": "50 Green St, Unit 109 (047-16-09)",
    "$": 684000,
    "address": "50 Green St, Unit 109",
    "parcel_id": "047-16-09",
    "owner1": "ARBISER, JACK L",
    "owner2": "",
    "current_taxes": 7004.16,
    "new_taxes_no_override": 7306.74,
    "override_total_1": 7514.06,
    "override_increase_1": 207.32
  },
  {
    "#": "50 Green St, Unit 110 & P-28 (047-16-10)",
    "$": 694700,
    "address": "50 Green St, Unit 110 & P-28",
    "parcel_id": "047-16-10",
    "owner1": "CHIQUIAR-RABINOVICH, SALOMON & ELIZABETH",
    "owner2": "",
    "current_taxes": 3478.79,
    "new_taxes_no_override": 3629.07,
    "override_total_1": 3732.05,
    "override_increase_1": 102.97
  },
  {
    "#": "50 Green St, Unit 111 & P-36 (047-16-11)",
    "$": 711700,
    "address": "50 Green St, Unit 111 & P-36",
    "parcel_id": "047-16-11",
    "owner1": "SUTELMAN, ALEX & ELLA & DANIEL",
    "owner2": "",
    "current_taxes": 3652.87,
    "new_taxes_no_override": 3810.67,
    "override_total_1": 3918.8,
    "override_increase_1": 108.12
  },
  {
    "#": "50 Green St, Unit 112 & P27 (047-16-12)",
    "$": 726200,
    "address": "50 Green St, Unit 112 & P27",
    "parcel_id": "047-16-12",
    "owner1": "CEDER, MICHAEL A",
    "owner2": "",
    "current_taxes": 3801.35,
    "new_taxes_no_override": 3965.57,
    "override_total_1": 4078.09,
    "override_increase_1": 112.52
  },
  {
    "#": "50 Green St, Unit 114 (047-16-13)",
    "$": 558300,
    "address": "50 Green St, Unit 114",
    "parcel_id": "047-16-13",
    "owner1": "HAYMANN HABER, ESTATE OF, HABER GUIDO",
    "owner2": "C/O PEREIRA, AMALIA",
    "current_taxes": 5716.99,
    "new_taxes_no_override": 5963.96,
    "override_total_1": 6133.19,
    "override_increase_1": 169.22
  },
  {
    "#": "50 Green St, Unit 115 (047-16-14)",
    "$": 539400,
    "address": "50 Green St, Unit 115",
    "parcel_id": "047-16-14",
    "owner1": "LIU, MIN W & CHUEI Y",
    "owner2": "",
    "current_taxes": 5523.46,
    "new_taxes_no_override": 5762.07,
    "override_total_1": 5925.57,
    "override_increase_1": 163.49
  },
  {
    "#": "50 Green St, Unit 116 (047-16-15)",
    "$": 564400,
    "address": "50 Green St, Unit 116",
    "parcel_id": "047-16-15",
    "owner1": "NGUYEN, CUC BACH",
    "owner2": "",
    "current_taxes": 2144.52,
    "new_taxes_no_override": 2237.16,
    "override_total_1": 2300.64,
    "override_increase_1": 63.48
  },
  {
    "#": "50 Green St, Unit 201 (047-16-16)",
    "$": 785000,
    "address": "50 Green St, Unit 201",
    "parcel_id": "047-16-16",
    "owner1": "GRACE TR, JUDITH I",
    "owner2": "",
    "current_taxes": 4403.47,
    "new_taxes_no_override": 4593.7,
    "override_total_1": 4724.04,
    "override_increase_1": 130.34
  },
  {
    "#": "50 Green St, Unit 202 (047-16-17)",
    "$": 811000,
    "address": "50 Green St, Unit 202",
    "parcel_id": "047-16-17",
    "owner1": "MOSES TR, ZENA P",
    "owner2": "",
    "current_taxes": 8304.64,
    "new_taxes_no_override": 8663.4,
    "override_total_1": 8909.22,
    "override_increase_1": 245.82
  },
  {
    "#": "50 Green St, Unit 203 & P6 (047-16-18)",
    "$": 663500,
    "address": "50 Green St, Unit 203 & P6",
    "parcel_id": "047-16-18",
    "owner1": "ZHAO, SHUAI",
    "owner2": "",
    "current_taxes": 6794.24,
    "new_taxes_no_override": 7087.75,
    "override_total_1": 7288.86,
    "override_increase_1": 201.11
  },
  {
    "#": "50 Green St, Unit 204 (047-16-19)",
    "$": 527900,
    "address": "50 Green St, Unit 204",
    "parcel_id": "047-16-19",
    "owner1": "GREEN STREET APARTMENTS LLC",
    "owner2": "",
    "current_taxes": 5405.7,
    "new_taxes_no_override": 5639.23,
    "override_total_1": 5799.23,
    "override_increase_1": 160.01
  },
  {
    "#": "50 Green St, Unit 205 (047-16-20)",
    "$": 543400,
    "address": "50 Green St, Unit 205",
    "parcel_id": "047-16-20",
    "owner1": "SELTZER, GABRIEL L",
    "owner2": "",
    "current_taxes": 1929.48,
    "new_taxes_no_override": 2012.83,
    "override_total_1": 2069.95,
    "override_increase_1": 57.11
  },
  {
    "#": "50 Green St, Unit 206 (047-16-21)",
    "$": 770200,
    "address": "50 Green St, Unit 206",
    "parcel_id": "047-16-21",
    "owner1": "FROYMAN, ALLA",
    "owner2": "",
    "current_taxes": 7886.85,
    "new_taxes_no_override": 8227.56,
    "override_total_1": 8461.01,
    "override_increase_1": 233.45
  },
  {
    "#": "50 Green St, Unit 207 (047-16-22)",
    "$": 395600,
    "address": "50 Green St, Unit 207",
    "parcel_id": "047-16-22",
    "owner1": "BREGER, CAROL",
    "owner2": "",
    "current_taxes": 4050.94,
    "new_taxes_no_override": 4225.94,
    "override_total_1": 4345.85,
    "override_increase_1": 119.91
  },
  {
    "#": "50 Green St, Unit 208 (047-16-23)",
    "$": 792800,
    "address": "50 Green St, Unit 208",
    "parcel_id": "047-16-23",
    "owner1": "50 GREEN STREET REALTY TRUST",
    "owner2": "C/O SHAPIRO HELEN TR",
    "current_taxes": 8118.27,
    "new_taxes_no_override": 8468.98,
    "override_total_1": 8709.28,
    "override_increase_1": 240.3
  },
  {
    "#": "50 Green St, Unit 209 (047-16-24)",
    "$": 740400,
    "address": "50 Green St, Unit 209",
    "parcel_id": "047-16-24",
    "owner1": "LIU, QIN",
    "owner2": "",
    "current_taxes": 7581.7,
    "new_taxes_no_override": 7909.23,
    "override_total_1": 8133.65,
    "override_increase_1": 224.42
  },
  {
    "#": "50 Green St, Unit 210 (047-16-25)",
    "$": 752000,
    "address": "50 Green St, Unit 210",
    "parcel_id": "047-16-25",
    "owner1": "SENDYK, HOWARD & LEA E",
    "owner2": "",
    "current_taxes": 4065.55,
    "new_taxes_no_override": 4241.18,
    "override_total_1": 4361.52,
    "override_increase_1": 120.34
  },
  {
    "#": "50 Green St, Unit 211 (047-16-26)",
    "$": 740400,
    "address": "50 Green St, Unit 211",
    "parcel_id": "047-16-26",
    "owner1": "GREEN ST APARTMENTS LLC",
    "owner2": "",
    "current_taxes": 7581.7,
    "new_taxes_no_override": 7909.23,
    "override_total_1": 8133.65,
    "override_increase_1": 224.42
  },
  {
    "#": "50 Green St, Unit 212 (047-16-27)",
    "$": 726200,
    "address": "50 Green St, Unit 212",
    "parcel_id": "047-16-27",
    "owner1": "SHUKLA, PALLAVI",
    "owner2": "",
    "current_taxes": 7436.29,
    "new_taxes_no_override": 7757.54,
    "override_total_1": 7977.65,
    "override_increase_1": 220.11
  },
  {
    "#": "50 Green St, Unit 214 (047-16-28)",
    "$": 619100,
    "address": "50 Green St, Unit 214",
    "parcel_id": "047-16-28",
    "owner1": "JA3 DEVELOPMENT LLC",
    "owner2": "",
    "current_taxes": 6339.58,
    "new_taxes_no_override": 6613.45,
    "override_total_1": 6801.1,
    "override_increase_1": 187.65
  },
  {
    "#": "50 Green St, Unit 215 & P35 (047-16-29)",
    "$": 544900,
    "address": "50 Green St, Unit 215 & P35",
    "parcel_id": "047-16-29",
    "owner1": "LIN ET AL TRS, JIAN",
    "owner2": "DENG, BIJIA",
    "current_taxes": 5579.78,
    "new_taxes_no_override": 5820.83,
    "override_total_1": 5985.99,
    "override_increase_1": 165.16
  },
  {
    "#": "50 Green St, Unit 216 & P48 (047-16-30)",
    "$": 593500,
    "address": "50 Green St, Unit 216 & P48",
    "parcel_id": "047-16-30",
    "owner1": "CHECHELNITSKY ET AL , YURI",
    "owner2": "KROL, INNA A",
    "current_taxes": 2442.51,
    "new_taxes_no_override": 2548.03,
    "override_total_1": 2620.32,
    "override_increase_1": 72.3
  },
  {
    "#": "50 Green St, Unit 301 (047-16-31)",
    "$": 827500,
    "address": "50 Green St, Unit 301",
    "parcel_id": "047-16-31",
    "owner1": "SALMAN LIFE ESTATE, NEZHAT",
    "owner2": "",
    "current_taxes": 4838.67,
    "new_taxes_no_override": 5047.7,
    "override_total_1": 5190.93,
    "override_increase_1": 143.22
  },
  {
    "#": "50 Green St, Unit 302  (047-16-32)",
    "$": 811100,
    "address": "50 Green St, Unit 302 ",
    "parcel_id": "047-16-32",
    "owner1": "NOAM LLC",
    "owner2": "",
    "current_taxes": 8305.66,
    "new_taxes_no_override": 8664.46,
    "override_total_1": 8910.31,
    "override_increase_1": 245.85
  },
  {
    "#": "50 Green St, Unit 303 (047-16-33)",
    "$": 597300,
    "address": "50 Green St, Unit 303",
    "parcel_id": "047-16-33",
    "owner1": "BAI, JIRONG",
    "owner2": "ZHU, RUI-YING",
    "current_taxes": 6116.35,
    "new_taxes_no_override": 6380.58,
    "override_total_1": 6561.62,
    "override_increase_1": 181.04
  },
  {
    "#": "50 Green St, Unit 304 (047-16-34)",
    "$": 519800,
    "address": "50 Green St, Unit 304",
    "parcel_id": "047-16-34",
    "owner1": "PARK, EUNSIL",
    "owner2": "SON, KILHO",
    "current_taxes": 5322.75,
    "new_taxes_no_override": 5552.69,
    "override_total_1": 5710.25,
    "override_increase_1": 157.55
  },
  {
    "#": "50 Green St, Unit 305 (047-16-35)",
    "$": 600800,
    "address": "50 Green St, Unit 305",
    "parcel_id": "047-16-35",
    "owner1": "LI, CYNTHIA",
    "owner2": "",
    "current_taxes": 6152.19,
    "new_taxes_no_override": 6417.96,
    "override_total_1": 6600.07,
    "override_increase_1": 182.1
  },
  {
    "#": "50 Green St, Unit 306 (047-16-36)",
    "$": 769200,
    "address": "50 Green St, Unit 306",
    "parcel_id": "047-16-36",
    "owner1": "AMCHISLAVSKAYA, IRINA",
    "owner2": "SHAEVICH, FELIKS",
    "current_taxes": 4241.67,
    "new_taxes_no_override": 4424.91,
    "override_total_1": 4550.46,
    "override_increase_1": 125.55
  },
  {
    "#": "50 Green St, Unit 307 (047-16-37)",
    "$": 425600,
    "address": "50 Green St, Unit 307",
    "parcel_id": "047-16-37",
    "owner1": "CHUNG, YEUN GOO",
    "owner2": "LEE, KEEHYUN",
    "current_taxes": 723.21,
    "new_taxes_no_override": 754.45,
    "override_total_1": 775.86,
    "override_increase_1": 21.41
  },
  {
    "#": "50 Green St, Unit 308 (047-16-38)",
    "$": 769100,
    "address": "50 Green St, Unit 308",
    "parcel_id": "047-16-38",
    "owner1": "MOLDAVSKIY, SVETLANA",
    "owner2": "MAKLIN, NISAN",
    "current_taxes": 7875.58,
    "new_taxes_no_override": 8215.81,
    "override_total_1": 8448.92,
    "override_increase_1": 233.12
  },
  {
    "#": "50 Green St, Unit 309 (047-16-39)",
    "$": 751500,
    "address": "50 Green St, Unit 309",
    "parcel_id": "047-16-39",
    "owner1": "FITZGIBBON, DANIEL H",
    "owner2": "",
    "current_taxes": 4060.43,
    "new_taxes_no_override": 4235.84,
    "override_total_1": 4356.03,
    "override_increase_1": 120.19
  },
  {
    "#": "50 Green St, Unit 310 (047-16-40)",
    "$": 775600,
    "address": "50 Green St, Unit 310",
    "parcel_id": "047-16-40",
    "owner1": "OSTROVSKI TRS, SERGE & SOPHIA",
    "owner2": "",
    "current_taxes": 7942.14,
    "new_taxes_no_override": 8285.24,
    "override_total_1": 8520.33,
    "override_increase_1": 235.09
  },
  {
    "#": "50 Green St, Unit 311  (047-16-41)",
    "$": 740400,
    "address": "50 Green St, Unit 311 ",
    "parcel_id": "047-16-41",
    "owner1": "ZHANG, SHUYUN",
    "owner2": "LIU, PING",
    "current_taxes": 7581.7,
    "new_taxes_no_override": 7909.23,
    "override_total_1": 8133.65,
    "override_increase_1": 224.42
  },
  {
    "#": "50 Green St, Unit 312 (047-16-42)",
    "$": 797100,
    "address": "50 Green St, Unit 312",
    "parcel_id": "047-16-42",
    "owner1": "MIYAI, ALICE CHEN & TOMIO",
    "owner2": "",
    "current_taxes": 4527.37,
    "new_taxes_no_override": 4722.95,
    "override_total_1": 4856.96,
    "override_increase_1": 134.01
  },
  {
    "#": "50 Green St, Unit 314 (047-16-43)",
    "$": 578100,
    "address": "50 Green St, Unit 314",
    "parcel_id": "047-16-43",
    "owner1": "FLETCHER TR, ELIZABETH M",
    "owner2": "",
    "current_taxes": 2284.81,
    "new_taxes_no_override": 2383.51,
    "override_total_1": 2451.14,
    "override_increase_1": 67.63
  },
  {
    "#": "50 Green St, Unit 315 (047-16-44)",
    "$": 562400,
    "address": "50 Green St, Unit 315",
    "parcel_id": "047-16-44",
    "owner1": "ANKORION, ITAMAR",
    "owner2": "RAMON, DANA",
    "current_taxes": 5758.98,
    "new_taxes_no_override": 6007.77,
    "override_total_1": 6178.23,
    "override_increase_1": 170.47
  },
  {
    "#": "50 Green St, Unit 316 & P15 (047-16-45)",
    "$": 569800,
    "address": "50 Green St, Unit 316 & P15",
    "parcel_id": "047-16-45",
    "owner1": "FENG, XIAOHUI",
    "owner2": "LU, YAN",
    "current_taxes": 5834.75,
    "new_taxes_no_override": 6086.81,
    "override_total_1": 6259.52,
    "override_increase_1": 172.71
  },
  {
    "#": "50 Green St, Unit 401 (047-16-46)",
    "$": 784900,
    "address": "50 Green St, Unit 401",
    "parcel_id": "047-16-46",
    "owner1": "KWIECIEN, ELAINE K",
    "owner2": "",
    "current_taxes": 4402.44,
    "new_taxes_no_override": 4592.63,
    "override_total_1": 4722.94,
    "override_increase_1": 130.31
  },
  {
    "#": "50 Green St, Unit 402 (047-16-47)",
    "$": 898200,
    "address": "50 Green St, Unit 402",
    "parcel_id": "047-16-47",
    "owner1": "RUBIN, RICHARD A & SUSAN D",
    "owner2": "",
    "current_taxes": 5562.63,
    "new_taxes_no_override": 5802.94,
    "override_total_1": 5967.59,
    "override_increase_1": 164.65
  },
  {
    "#": "50 Green St, Unit 403 (047-16-48)",
    "$": 631900,
    "address": "50 Green St, Unit 403",
    "parcel_id": "047-16-48",
    "owner1": "HARDOON TRS, LAURENCE E",
    "owner2": "FINE TR, JANET E",
    "current_taxes": 6470.66,
    "new_taxes_no_override": 6750.19,
    "override_total_1": 6941.72,
    "override_increase_1": 191.53
  },
  {
    "#": "50 Green St, Unit 404 (047-16-49)",
    "$": 562600,
    "address": "50 Green St, Unit 404",
    "parcel_id": "047-16-49",
    "owner1": "YESHAIAU, SHOSHANA",
    "owner2": "",
    "current_taxes": 2126.09,
    "new_taxes_no_override": 2217.94,
    "override_total_1": 2280.87,
    "override_increase_1": 62.93
  },
  {
    "#": "50 Green St, Unit 405 (047-16-50)",
    "$": 588200,
    "address": "50 Green St, Unit 405",
    "parcel_id": "047-16-50",
    "owner1": "GREEN STREET APARTMENTS LLC",
    "owner2": "",
    "current_taxes": 6023.17,
    "new_taxes_no_override": 6283.37,
    "override_total_1": 6461.66,
    "override_increase_1": 178.29
  },
  {
    "#": "50 Green St, Unit 406 (047-16-51)",
    "$": 750200,
    "address": "50 Green St, Unit 406",
    "parcel_id": "047-16-51",
    "owner1": "LEZBERG, TR, GEORGE M",
    "owner2": "C/O MALICK TR AMY",
    "current_taxes": 7682.05,
    "new_taxes_no_override": 8013.91,
    "override_total_1": 8241.3,
    "override_increase_1": 227.39
  },
  {
    "#": "50 Green St, Unit 407 (047-16-52)",
    "$": 405700,
    "address": "50 Green St, Unit 407",
    "parcel_id": "047-16-52",
    "owner1": "DUNCAN LIFE ESTATE, SUSAN",
    "owner2": "",
    "current_taxes": 4154.37,
    "new_taxes_no_override": 4333.84,
    "override_total_1": 4456.81,
    "override_increase_1": 122.97
  },
  {
    "#": "50 Green St, Unit 408 (047-16-53)",
    "$": 750200,
    "address": "50 Green St, Unit 408",
    "parcel_id": "047-16-53",
    "owner1": "PIES, JANICE M",
    "owner2": "",
    "current_taxes": 7682.05,
    "new_taxes_no_override": 8013.91,
    "override_total_1": 8241.3,
    "override_increase_1": 227.39
  },
  {
    "#": "50 Green St, Unit 409 (047-16-54)",
    "$": 740400,
    "address": "50 Green St, Unit 409",
    "parcel_id": "047-16-54",
    "owner1": "CARAGAY, ALEGRIA B",
    "owner2": "",
    "current_taxes": 7581.7,
    "new_taxes_no_override": 7909.23,
    "override_total_1": 8133.65,
    "override_increase_1": 224.42
  },
  {
    "#": "50 Green St, Unit 410 (047-16-55)",
    "$": 752000,
    "address": "50 Green St, Unit 410",
    "parcel_id": "047-16-55",
    "owner1": "BASEMAN TRS, HARRIS I & MARGARET M",
    "owner2": "",
    "current_taxes": 7700.48,
    "new_taxes_no_override": 8033.14,
    "override_total_1": 8261.07,
    "override_increase_1": 227.93
  },
  {
    "#": "50 Green St, Unit 411 (047-16-56)",
    "$": 740400,
    "address": "50 Green St, Unit 411",
    "parcel_id": "047-16-56",
    "owner1": "ZHANG, SHUYUN",
    "owner2": "LIU, PING",
    "current_taxes": 7581.7,
    "new_taxes_no_override": 7909.23,
    "override_total_1": 8133.65,
    "override_increase_1": 224.42
  },
  {
    "#": "50 Green St, Unit 412 (047-16-57)",
    "$": 767100,
    "address": "50 Green St, Unit 412",
    "parcel_id": "047-16-57",
    "owner1": "EDELMAN, DAVID & CAROL",
    "owner2": "",
    "current_taxes": 7855.1,
    "new_taxes_no_override": 8194.44,
    "override_total_1": 8426.95,
    "override_increase_1": 232.51
  },
  {
    "#": "50 Green St, Unit 414 (047-16-58)",
    "$": 613200,
    "address": "50 Green St, Unit 414",
    "parcel_id": "047-16-58",
    "owner1": "ANKORION, ITAMAR",
    "owner2": "RAMON, DANA",
    "current_taxes": 6279.17,
    "new_taxes_no_override": 6550.43,
    "override_total_1": 6736.29,
    "override_increase_1": 185.86
  },
  {
    "#": "50 Green St, Unit 415 (047-16-59)",
    "$": 583800,
    "address": "50 Green St, Unit 415",
    "parcel_id": "047-16-59",
    "owner1": "GREENE TR, B SUSAN",
    "owner2": "",
    "current_taxes": 5978.11,
    "new_taxes_no_override": 6236.36,
    "override_total_1": 6413.32,
    "override_increase_1": 176.95
  },
  {
    "#": "50 Green St, Unit 416 (047-16-60)",
    "$": 611000,
    "address": "50 Green St, Unit 416",
    "parcel_id": "047-16-60",
    "owner1": "COPPA TRS, DEBORAH M",
    "owner2": "COFFIN, SAMUEL ALDEN",
    "current_taxes": 6256.64,
    "new_taxes_no_override": 6526.93,
    "override_total_1": 6712.12,
    "override_increase_1": 185.2
  },
  {
    "#": "55 Green St (046-06-00)",
    "$": 5094700,
    "address": "55 Green St",
    "parcel_id": "046-06-00",
    "owner1": "55 GREEN STREET LLC",
    "owner2": "C/O DND HOMES LLC",
    "current_taxes": 52169.73,
    "new_taxes_no_override": 54423.46,
    "override_total_1": 55967.69,
    "override_increase_1": 1544.22
  },
  {
    "#": "59 Green St, Unit A (046-07-01)",
    "$": 3458000,
    "address": "59 Green St, Unit A",
    "parcel_id": "046-07-01",
    "owner1": "MARIASH, URI",
    "owner2": "ZAKRZEWSKI, BEATA JULIA",
    "current_taxes": 31774.99,
    "new_taxes_no_override": 33147.67,
    "override_total_1": 34088.21,
    "override_increase_1": 940.54
  },
  {
    "#": "59 Green St, Unit B (046-07-02)",
    "$": 2463400,
    "address": "59 Green St, Unit B",
    "parcel_id": "046-07-02",
    "owner1": "ROMANO, MARK T",
    "owner2": "JOY, MARCI A",
    "current_taxes": 21590.28,
    "new_taxes_no_override": 22522.98,
    "override_total_1": 23162.05,
    "override_increase_1": 639.07
  },
  {
    "#": "62 Green St (047-15-00)",
    "$": 15167800,
    "address": "62 Green St",
    "parcel_id": "047-15-00",
    "owner1": "YOUNG ISRAEL OF BROOKLINE",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "63 Green St (046-08-00)",
    "$": 2147200,
    "address": "63 Green St",
    "parcel_id": "046-08-00",
    "owner1": "WC GREEN 63 LLC",
    "owner2": "",
    "current_taxes": 21987.33,
    "new_taxes_no_override": 22937.18,
    "override_total_1": 23588.01,
    "override_increase_1": 650.82
  },
  {
    "#": "67 Green St, Unit 67 (046-09-01)",
    "$": 1423200,
    "address": "67 Green St, Unit 67",
    "parcel_id": "046-09-01",
    "owner1": "ROBERTS ETAL, SUSAN M",
    "owner2": "THUOTTE, ROSS",
    "current_taxes": 14573.57,
    "new_taxes_no_override": 15203.15,
    "override_total_1": 15634.53,
    "override_increase_1": 431.38
  },
  {
    "#": "69 Green St, Unit 69 (046-09-02)",
    "$": 1581200,
    "address": "69 Green St, Unit 69",
    "parcel_id": "046-09-02",
    "owner1": "ROBERTS TR, SUSAN M",
    "owner2": "",
    "current_taxes": 12556.55,
    "new_taxes_no_override": 13098.99,
    "override_total_1": 13470.67,
    "override_increase_1": 371.67
  },
  {
    "#": "71 Green St (046-10-00)",
    "$": 3264900,
    "address": "71 Green St",
    "parcel_id": "046-10-00",
    "owner1": "KIMOCHI DEVELOPMENT LLC",
    "owner2": "",
    "current_taxes": 33432.58,
    "new_taxes_no_override": 34876.87,
    "override_total_1": 35866.47,
    "override_increase_1": 989.6
  },
  {
    "#": "74 Green St, Unit 74-1 G1-2-3 (047-14-04)",
    "$": 2344800,
    "address": "74 Green St, Unit 74-1 G1-2-3",
    "parcel_id": "047-14-04",
    "owner1": "SCHULTHEIS, DWIGHT",
    "owner2": "HELLER, LAUREN",
    "current_taxes": 20375.82,
    "new_taxes_no_override": 21256.06,
    "override_total_1": 21859.18,
    "override_increase_1": 603.12
  },
  {
    "#": "74 Green St, Unit 74-2 G4G5 (047-14-05)",
    "$": 1624500,
    "address": "74 Green St, Unit 74-2 G4G5",
    "parcel_id": "047-14-05",
    "owner1": "FROYMAN, ALLA",
    "owner2": "",
    "current_taxes": 12999.95,
    "new_taxes_no_override": 13561.55,
    "override_total_1": 13946.35,
    "override_increase_1": 384.8
  },
  {
    "#": "74 Green St, Unit 74-3 G9 10 (047-14-06)",
    "$": 1797300,
    "address": "74 Green St, Unit 74-3 G9 10",
    "parcel_id": "047-14-06",
    "owner1": "FREISHTAT, LARA",
    "owner2": "",
    "current_taxes": 18404.35,
    "new_taxes_no_override": 19199.42,
    "override_total_1": 19744.19,
    "override_increase_1": 544.77
  },
  {
    "#": "74 Green St, Unit 74-4 G6 7 (047-14-07)",
    "$": 1662600,
    "address": "74 Green St, Unit 74-4 G6 7",
    "parcel_id": "047-14-07",
    "owner1": "GELBER TRS, RICHARD D & SHARI I",
    "owner2": "",
    "current_taxes": 13390.09,
    "new_taxes_no_override": 13968.54,
    "override_total_1": 14364.89,
    "override_increase_1": 396.35
  },
  {
    "#": "74 Green St, Unit 74-5 G8 11 (047-14-08)",
    "$": 1824700,
    "address": "74 Green St, Unit 74-5 G8 11",
    "parcel_id": "047-14-08",
    "owner1": "HALPERN, RONALD & SUSAN",
    "owner2": "",
    "current_taxes": 15049.99,
    "new_taxes_no_override": 15700.15,
    "override_total_1": 16145.63,
    "override_increase_1": 445.48
  },
  {
    "#": "76 Green St, Unit 76-1 G18 19 (047-14-09)",
    "$": 2292700,
    "address": "76 Green St, Unit 76-1 G18 19",
    "parcel_id": "047-14-09",
    "owner1": "HOMER TRS, CHARLES J",
    "owner2": "FABRICANT , JUDITH",
    "current_taxes": 19842.31,
    "new_taxes_no_override": 20699.5,
    "override_total_1": 21286.83,
    "override_increase_1": 587.33
  },
  {
    "#": "76 Green St, Unit 76-2 G15 16 (047-14-10)",
    "$": 1620900,
    "address": "76 Green St, Unit 76-2 G15 16",
    "parcel_id": "047-14-10",
    "owner1": "STARK TR, ANN ROBBINS",
    "owner2": "",
    "current_taxes": 16598.02,
    "new_taxes_no_override": 17315.05,
    "override_total_1": 17806.36,
    "override_increase_1": 491.3
  },
  {
    "#": "76 Green St, Unit 76-3 G21 22 (047-14-11)",
    "$": 1801600,
    "address": "76 Green St, Unit 76-3 G21 22",
    "parcel_id": "047-14-11",
    "owner1": "FOSTER, REBECCA & MICHAEL S",
    "owner2": "",
    "current_taxes": 14813.45,
    "new_taxes_no_override": 15453.39,
    "override_total_1": 15891.87,
    "override_increase_1": 438.48
  },
  {
    "#": "76 Green St, Unit 76-4 G17 20 (047-14-12)",
    "$": 1500000,
    "address": "76 Green St, Unit 76-4 G17 20",
    "parcel_id": "047-14-12",
    "owner1": "SCHNEPPER TRS, ROBERT CORY & BARBARA E",
    "owner2": "",
    "current_taxes": 15360.0,
    "new_taxes_no_override": 16023.55,
    "override_total_1": 16478.21,
    "override_increase_1": 454.66
  },
  {
    "#": "76 Green St, Unit 76-5 G13 14 (047-14-13)",
    "$": 1816900,
    "address": "76 Green St, Unit 76-5 G13 14",
    "parcel_id": "047-14-13",
    "owner1": "LIPSETT, DEBORAH COTTON & ROGER",
    "owner2": "",
    "current_taxes": 14970.12,
    "new_taxes_no_override": 15616.83,
    "override_total_1": 16059.94,
    "override_increase_1": 443.12
  },
  {
    "#": "81 Green St (046-11-00)",
    "$": 9605100,
    "address": "81 Green St",
    "parcel_id": "046-11-00",
    "owner1": "BRIDGE REALTY FAMILY LP",
    "owner2": "",
    "current_taxes": 98356.22,
    "new_taxes_no_override": 102605.21,
    "override_total_1": 105516.55,
    "override_increase_1": 2911.34
  },
  {
    "#": "82 Green St, Unit 1 (047-13-01)",
    "$": 2535900,
    "address": "82 Green St, Unit 1",
    "parcel_id": "047-13-01",
    "owner1": "WINICKOFF, RICHARD N & SUSAN A",
    "owner2": "",
    "current_taxes": 22332.68,
    "new_taxes_no_override": 23297.45,
    "override_total_1": 23958.5,
    "override_increase_1": 661.05
  },
  {
    "#": "82 Green St, Unit Pk Sp (047-13-05)",
    "$": 52500,
    "address": "82 Green St, Unit Pk Sp",
    "parcel_id": "047-13-05",
    "owner1": "KRETSCMER, MATTHIAS",
    "owner2": "BARADARAN, KHANDAN",
    "current_taxes": 537.6,
    "new_taxes_no_override": 560.82,
    "override_total_1": 576.74,
    "override_increase_1": 15.91
  },
  {
    "#": "3 Greenough Cir (200-13-00)",
    "$": 1619700,
    "address": "3 Greenough Cir",
    "parcel_id": "200-13-00",
    "owner1": "RICHMOND, CLINTON Q",
    "owner2": "FEDERSPIEL, S",
    "current_taxes": 12950.79,
    "new_taxes_no_override": 13510.26,
    "override_total_1": 13893.61,
    "override_increase_1": 383.34
  },
  {
    "#": "4 Greenough Cir (200-13-07)",
    "$": 1768800,
    "address": "4 Greenough Cir",
    "parcel_id": "200-13-07",
    "owner1": "ABEYARATNE, ROHAN & KESHINI",
    "owner2": "",
    "current_taxes": 14477.58,
    "new_taxes_no_override": 15103.01,
    "override_total_1": 15531.55,
    "override_increase_1": 428.54
  },
  {
    "#": "9 Greenough Cir (200-13-01)",
    "$": 2010300,
    "address": "9 Greenough Cir",
    "parcel_id": "200-13-01",
    "owner1": "COSTIGAN TRS, JASON G",
    "owner2": "KIM, CYNTHIA Y",
    "current_taxes": 16950.54,
    "new_taxes_no_override": 17682.8,
    "override_total_1": 18184.54,
    "override_increase_1": 501.74
  },
  {
    "#": "10 Greenough Cir (200-13-06)",
    "$": 1929700,
    "address": "10 Greenough Cir",
    "parcel_id": "200-13-06",
    "owner1": "LEFAIVRE, NADEZHDA S",
    "owner2": "",
    "current_taxes": 16125.19,
    "new_taxes_no_override": 16821.8,
    "override_total_1": 17299.1,
    "override_increase_1": 477.31
  },
  {
    "#": "15 Greenough Cir (200-13-02)",
    "$": 1938300,
    "address": "15 Greenough Cir",
    "parcel_id": "200-13-02",
    "owner1": "COHEN, MAYDAD & DARLA",
    "owner2": "",
    "current_taxes": 16213.26,
    "new_taxes_no_override": 16913.67,
    "override_total_1": 17393.59,
    "override_increase_1": 479.91
  },
  {
    "#": "16 Greenough Cir (200-13-05)",
    "$": 2250600,
    "address": "16 Greenough Cir",
    "parcel_id": "200-13-05",
    "owner1": "CHANG, SHAWN",
    "owner2": "KUO, HSU WAN",
    "current_taxes": 23046.14,
    "new_taxes_no_override": 24041.73,
    "override_total_1": 24723.9,
    "override_increase_1": 682.17
  },
  {
    "#": "17 Greenough Cir (200-13-03)",
    "$": 2131300,
    "address": "17 Greenough Cir",
    "parcel_id": "200-13-03",
    "owner1": "MITNICK, CAROLE D",
    "owner2": "JOHNSON, CHRISTOPHER M",
    "current_taxes": 18189.58,
    "new_taxes_no_override": 18975.37,
    "override_total_1": 19513.78,
    "override_increase_1": 538.41
  },
  {
    "#": "18 Greenough Cir (200-13-04)",
    "$": 1855200,
    "address": "18 Greenough Cir",
    "parcel_id": "200-13-04",
    "owner1": "LASKY, JEFFREY S & LAURIE B",
    "owner2": "",
    "current_taxes": 15362.31,
    "new_taxes_no_override": 16025.96,
    "override_total_1": 16480.69,
    "override_increase_1": 454.72
  },
  {
    "#": "3 Greenough St (207-07-00)",
    "$": 1638800,
    "address": "3 Greenough St",
    "parcel_id": "207-07-00",
    "owner1": "LEBOWITZ TRS, LISA & ROBERT",
    "owner2": "",
    "current_taxes": 16781.31,
    "new_taxes_no_override": 17506.26,
    "override_total_1": 18002.99,
    "override_increase_1": 496.73
  },
  {
    "#": "9 Greenough St (207-08-00)",
    "$": 2118100,
    "address": "9 Greenough St",
    "parcel_id": "207-08-00",
    "owner1": "HOLMSTROM TRS, DAVID",
    "owner2": "SHEPARD, BONNIE L",
    "current_taxes": 18054.41,
    "new_taxes_no_override": 18834.36,
    "override_total_1": 19368.77,
    "override_increase_1": 534.41
  },
  {
    "#": "12 Greenough St, Unit 1 (200-12-02)",
    "$": 1140400,
    "address": "12 Greenough St, Unit 1",
    "parcel_id": "200-12-02",
    "owner1": "BOUIX, LAURA & SYLVAIN",
    "owner2": "",
    "current_taxes": 11677.7,
    "new_taxes_no_override": 12182.18,
    "override_total_1": 12527.84,
    "override_increase_1": 345.66
  },
  {
    "#": "12 Greenough St, Unit 2 (200-12-03)",
    "$": 1648400,
    "address": "12 Greenough St, Unit 2",
    "parcel_id": "200-12-03",
    "owner1": "OSHER, JASON & MOLLY COHEN",
    "owner2": "",
    "current_taxes": 13244.68,
    "new_taxes_no_override": 13816.85,
    "override_total_1": 14208.89,
    "override_increase_1": 392.04
  },
  {
    "#": "15 Greenough St (207-09-00)",
    "$": 1918600,
    "address": "15 Greenough St",
    "parcel_id": "207-09-00",
    "owner1": "PEREZ, BEGONA RUIZ",
    "owner2": "STRACHAN, WILLIAM",
    "current_taxes": 19646.46,
    "new_taxes_no_override": 20495.19,
    "override_total_1": 21076.72,
    "override_increase_1": 581.54
  },
  {
    "#": "16 Greenough St, Unit 1 (200-11-02)",
    "$": 1542400,
    "address": "16 Greenough St, Unit 1",
    "parcel_id": "200-11-02",
    "owner1": "KUSTYANTO TR, CASSANDRA",
    "owner2": "",
    "current_taxes": 12159.24,
    "new_taxes_no_override": 12684.52,
    "override_total_1": 13044.43,
    "override_increase_1": 359.91
  },
  {
    "#": "16 Greenough St, Unit 2 (200-11-01)",
    "$": 1678000,
    "address": "16 Greenough St, Unit 2",
    "parcel_id": "200-11-01",
    "owner1": "DAVIS, JULIE",
    "owner2": "LAM, KHIEM",
    "current_taxes": 13547.79,
    "new_taxes_no_override": 14133.05,
    "override_total_1": 14534.07,
    "override_increase_1": 401.01
  },
  {
    "#": "22 Greenough St (200-10-00)",
    "$": 2590400,
    "address": "22 Greenough St",
    "parcel_id": "200-10-00",
    "owner1": "DOPAZO TR, ANTHONY",
    "owner2": "",
    "current_taxes": 26525.7,
    "new_taxes_no_override": 27671.61,
    "override_total_1": 28456.77,
    "override_increase_1": 785.16
  },
  {
    "#": "26 Greenough St (200-09-00)",
    "$": 2423200,
    "address": "26 Greenough St",
    "parcel_id": "200-09-00",
    "owner1": "MCCLAIN, JOHN B & KATHLEEN M",
    "owner2": "",
    "current_taxes": 21178.63,
    "new_taxes_no_override": 22093.55,
    "override_total_1": 22720.43,
    "override_increase_1": 626.89
  },
  {
    "#": "29 Greenough St (206-16-00)",
    "$": 2397400,
    "address": "29 Greenough St",
    "parcel_id": "206-16-00",
    "owner1": "RUDOLPH TRS, JEFFREY DAVID",
    "owner2": "SAWYER, SHERILYN JOY",
    "current_taxes": 20914.44,
    "new_taxes_no_override": 21817.94,
    "override_total_1": 22437.01,
    "override_increase_1": 619.07
  },
  {
    "#": "34 Greenough St (200-08-00)",
    "$": 2479300,
    "address": "34 Greenough St",
    "parcel_id": "200-08-00",
    "owner1": "SHAW, MAXINE",
    "owner2": "",
    "current_taxes": 25388.03,
    "new_taxes_no_override": 26484.79,
    "override_total_1": 27236.28,
    "override_increase_1": 751.49
  },
  {
    "#": "39 Greenough St (206-01-00)",
    "$": 1995600,
    "address": "39 Greenough St",
    "parcel_id": "206-01-00",
    "owner1": "HART, DAMON P & KATUSHKA M",
    "owner2": "",
    "current_taxes": 16800.01,
    "new_taxes_no_override": 17525.77,
    "override_total_1": 18023.05,
    "override_increase_1": 497.28
  },
  {
    "#": "47 Greenough St (201-01-00)",
    "$": 2368100,
    "address": "47 Greenough St",
    "parcel_id": "201-01-00",
    "owner1": "EBERT, BENJAMIN L & JANE E J",
    "owner2": "",
    "current_taxes": 24249.34,
    "new_taxes_no_override": 25296.91,
    "override_total_1": 26014.69,
    "override_increase_1": 717.78
  },
  {
    "#": "50 Greenough St (199-10-00)",
    "$": 2136100,
    "address": "50 Greenough St",
    "parcel_id": "199-10-00",
    "owner1": "SOLOMON HANCOCK LLC",
    "owner2": "",
    "current_taxes": 21873.66,
    "new_taxes_no_override": 22818.6,
    "override_total_1": 23466.06,
    "override_increase_1": 647.46
  },
  {
    "#": "53 Greenough St (201-02-00)",
    "$": 1755400,
    "address": "53 Greenough St",
    "parcel_id": "201-02-00",
    "owner1": "ROOS TRS, KAREN",
    "owner2": "LECOMPTE, CHARLES",
    "current_taxes": 14340.36,
    "new_taxes_no_override": 14959.86,
    "override_total_1": 15384.34,
    "override_increase_1": 424.47
  },
  {
    "#": "55 Greenough St (201-03-00)",
    "$": 1275500,
    "address": "55 Greenough St",
    "parcel_id": "201-03-00",
    "owner1": "MURPHY TRS, MARK",
    "owner2": "JOHNSON, SERENA C",
    "current_taxes": 9426.19,
    "new_taxes_no_override": 9833.4,
    "override_total_1": 10112.42,
    "override_increase_1": 279.02
  },
  {
    "#": "56 Greenough St, Unit 1 (199-09-06)",
    "$": 1131900,
    "address": "56 Greenough St, Unit 1",
    "parcel_id": "199-09-06",
    "owner1": "FIEDLER TR, ANITA",
    "owner2": "",
    "current_taxes": 7955.72,
    "new_taxes_no_override": 8299.41,
    "override_total_1": 8534.9,
    "override_increase_1": 235.49
  },
  {
    "#": "56 Greenough St, Unit 2 (199-09-01)",
    "$": 1223000,
    "address": "56 Greenough St, Unit 2",
    "parcel_id": "199-09-01",
    "owner1": "GOLDSTEIN, KIMBERLY A",
    "owner2": "",
    "current_taxes": 8888.59,
    "new_taxes_no_override": 9272.58,
    "override_total_1": 9535.68,
    "override_increase_1": 263.1
  },
  {
    "#": "56 Greenough St, Unit 3 (199-09-02)",
    "$": 1223000,
    "address": "56 Greenough St, Unit 3",
    "parcel_id": "199-09-02",
    "owner1": "LINDY, JEFFREY F",
    "owner2": "TAYLOR, GWENDOLYN H",
    "current_taxes": 8888.59,
    "new_taxes_no_override": 9272.58,
    "override_total_1": 9535.68,
    "override_increase_1": 263.1
  },
  {
    "#": "58 Greenough St, Unit 1 (199-09-03)",
    "$": 1142400,
    "address": "58 Greenough St, Unit 1",
    "parcel_id": "199-09-03",
    "owner1": "LEVINE, BETH A",
    "owner2": "",
    "current_taxes": 8063.24,
    "new_taxes_no_override": 8411.57,
    "override_total_1": 8650.24,
    "override_increase_1": 238.67
  },
  {
    "#": "58 Greenough St, Unit 2 (199-09-04)",
    "$": 1117600,
    "address": "58 Greenough St, Unit 2",
    "parcel_id": "199-09-04",
    "owner1": "YOFFEE, HARRIET",
    "owner2": "",
    "current_taxes": 7809.29,
    "new_taxes_no_override": 8146.65,
    "override_total_1": 8377.81,
    "override_increase_1": 231.15
  },
  {
    "#": "58 Greenough St, Unit 3 (199-09-05)",
    "$": 1109800,
    "address": "58 Greenough St, Unit 3",
    "parcel_id": "199-09-05",
    "owner1": "LANGSDORF, LISA A",
    "owner2": "COWLES, WILLIAM",
    "current_taxes": 7729.42,
    "new_taxes_no_override": 8063.33,
    "override_total_1": 8292.12,
    "override_increase_1": 228.79
  },
  {
    "#": "60 Greenough St (199-08-00)",
    "$": 4965900,
    "address": "60 Greenough St",
    "parcel_id": "199-08-00",
    "owner1": "ONE EVERGREEN LLC",
    "owner2": "",
    "current_taxes": 50850.82,
    "new_taxes_no_override": 53047.58,
    "override_total_1": 54552.76,
    "override_increase_1": 1505.18
  },
  {
    "#": "61 Greenough St, Unit 1 P-3 (201-04-01)",
    "$": 1106700,
    "address": "61 Greenough St, Unit 1 P-3",
    "parcel_id": "201-04-01",
    "owner1": "GAY, MATTHEW A & MICHELLE MEYER",
    "owner2": "",
    "current_taxes": 7697.67,
    "new_taxes_no_override": 8030.21,
    "override_total_1": 8258.06,
    "override_increase_1": 227.85
  },
  {
    "#": "61 Greenough St, Unit 2 & P-B (201-04-02)",
    "$": 1109200,
    "address": "61 Greenough St, Unit 2 & P-B",
    "parcel_id": "201-04-02",
    "owner1": "BRAUN JONES, CECILE & TAYLOR",
    "owner2": "",
    "current_taxes": 7723.27,
    "new_taxes_no_override": 8056.92,
    "override_total_1": 8285.52,
    "override_increase_1": 228.61
  },
  {
    "#": "61 Greenough St, Unit 3 (201-04-03)",
    "$": 1448600,
    "address": "61 Greenough St, Unit 3",
    "parcel_id": "201-04-03",
    "owner1": "BERGTHOLD, CHARLES K & KAREN R",
    "owner2": "",
    "current_taxes": 11198.73,
    "new_taxes_no_override": 11682.52,
    "override_total_1": 12014.0,
    "override_increase_1": 331.48
  },
  {
    "#": "65 Greenough St, Unit 1 (201-05-01)",
    "$": 1359500,
    "address": "65 Greenough St, Unit 1",
    "parcel_id": "201-05-01",
    "owner1": "TRIMBLE, DAVID",
    "owner2": "KLIMAN, JODIE",
    "current_taxes": 10286.35,
    "new_taxes_no_override": 10730.72,
    "override_total_1": 11035.2,
    "override_increase_1": 304.48
  },
  {
    "#": "65 Greenough St, Unit 2 (201-05-02)",
    "$": 1336400,
    "address": "65 Greenough St, Unit 2",
    "parcel_id": "201-05-02",
    "owner1": "RAPOPORT, TOM A & IRIS",
    "owner2": "",
    "current_taxes": 10049.8,
    "new_taxes_no_override": 10483.95,
    "override_total_1": 10781.43,
    "override_increase_1": 297.47
  },
  {
    "#": "65 Greenough St, Unit 3 & P5-P6 (201-05-03)",
    "$": 1339300,
    "address": "65 Greenough St, Unit 3 & P5-P6",
    "parcel_id": "201-05-03",
    "owner1": "LANGLOIS, XAVIER & LOUISA",
    "owner2": "",
    "current_taxes": 10079.5,
    "new_taxes_no_override": 10514.93,
    "override_total_1": 10813.29,
    "override_increase_1": 298.35
  },
  {
    "#": "71 Greenough St (201-06-00)",
    "$": 3384500,
    "address": "71 Greenough St",
    "parcel_id": "201-06-00",
    "owner1": "71 GREENOUGH ST LLC",
    "owner2": "",
    "current_taxes": 34657.28,
    "new_taxes_no_override": 36154.47,
    "override_total_1": 37180.33,
    "override_increase_1": 1025.86
  },
  {
    "#": "75 Greenough St, Unit 1 (201-07-03)",
    "$": 2963600,
    "address": "75 Greenough St, Unit 1",
    "parcel_id": "201-07-03",
    "owner1": "DICICCO, LEONARD & JENNA",
    "owner2": "",
    "current_taxes": 26712.33,
    "new_taxes_no_override": 27866.3,
    "override_total_1": 28656.99,
    "override_increase_1": 790.68
  },
  {
    "#": "75 Greenough St, Unit 2 (201-07-04)",
    "$": 3001700,
    "address": "75 Greenough St, Unit 2",
    "parcel_id": "201-07-04",
    "owner1": "WANG, TIEMEI",
    "owner2": "",
    "current_taxes": 30737.41,
    "new_taxes_no_override": 32065.27,
    "override_total_1": 32975.09,
    "override_increase_1": 909.83
  },
  {
    "#": "79 Greenough St (201-08-00)",
    "$": 1951500,
    "address": "79 Greenough St",
    "parcel_id": "201-08-00",
    "owner1": "WELCH, ANNE",
    "owner2": "",
    "current_taxes": 16348.43,
    "new_taxes_no_override": 17054.68,
    "override_total_1": 17538.6,
    "override_increase_1": 483.91
  },
  {
    "#": "80 Greenough St (196-14-00)",
    "$": 2218400,
    "address": "80 Greenough St",
    "parcel_id": "196-14-00",
    "owner1": "ROLFS TRS, ANDREAS",
    "owner2": "ZUO, DONGMEI",
    "current_taxes": 19081.48,
    "new_taxes_no_override": 19905.8,
    "override_total_1": 20470.61,
    "override_increase_1": 564.81
  },
  {
    "#": "81 Greenough St (201-09-00)",
    "$": 2150500,
    "address": "81 Greenough St",
    "parcel_id": "201-09-00",
    "owner1": "LIEM, G RAMSAY & JOAN H",
    "owner2": "",
    "current_taxes": 18386.19,
    "new_taxes_no_override": 19180.47,
    "override_total_1": 19724.7,
    "override_increase_1": 544.23
  },
  {
    "#": "86 Greenough St, Unit 1 (196-13-03)",
    "$": 1116200,
    "address": "86 Greenough St, Unit 1",
    "parcel_id": "196-13-03",
    "owner1": "GOISMAN, ET AL, ROBERT M",
    "owner2": "",
    "current_taxes": 7794.95,
    "new_taxes_no_override": 8131.69,
    "override_total_1": 8362.42,
    "override_increase_1": 230.73
  },
  {
    "#": "86 Greenough St, Unit 2 (196-13-01)",
    "$": 1144000,
    "address": "86 Greenough St, Unit 2",
    "parcel_id": "196-13-01",
    "owner1": "LANGERMANN, DANIEL & SHEILA",
    "owner2": "",
    "current_taxes": 8079.63,
    "new_taxes_no_override": 8428.67,
    "override_total_1": 8667.83,
    "override_increase_1": 239.16
  },
  {
    "#": "86 Greenough St, Unit 3 (196-13-02)",
    "$": 1116900,
    "address": "86 Greenough St, Unit 3",
    "parcel_id": "196-13-02",
    "owner1": "SASSU, NICOLE MARIE",
    "owner2": "",
    "current_taxes": 7802.12,
    "new_taxes_no_override": 8139.17,
    "override_total_1": 8370.11,
    "override_increase_1": 230.94
  },
  {
    "#": "87 Greenough St (201-10-00)",
    "$": 3415300,
    "address": "87 Greenough St",
    "parcel_id": "201-10-00",
    "owner1": "DAVIS TRS, STEVEN W",
    "owner2": "PETERSON, NICHOLAS J",
    "current_taxes": 31337.74,
    "new_taxes_no_override": 32691.53,
    "override_total_1": 33619.13,
    "override_increase_1": 927.6
  },
  {
    "#": "115 Greenough St (202-09-00)",
    "$": 160767600,
    "address": "115 Greenough St",
    "parcel_id": "202-09-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O HIGH SCHOOL",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "3 Greenway Ct, Unit 1 (047A-11-02)",
    "$": 1229000,
    "address": "3 Greenway Ct, Unit 1",
    "parcel_id": "047A-11-02",
    "owner1": "WU, ANDREW & KATHERINE",
    "owner2": "",
    "current_taxes": 12584.96,
    "new_taxes_no_override": 13128.63,
    "override_total_1": 13501.15,
    "override_increase_1": 372.51
  },
  {
    "#": "3 Greenway Ct, Unit 2 & Gar Sp (047A-11-03)",
    "$": 1408200,
    "address": "3 Greenway Ct, Unit 2 & Gar Sp",
    "parcel_id": "047A-11-03",
    "owner1": "GWAY CONDO LLC",
    "owner2": "C/O JDJ FAMILY OFFICE SERVICES",
    "current_taxes": 14419.97,
    "new_taxes_no_override": 15042.91,
    "override_total_1": 15469.74,
    "override_increase_1": 426.83
  },
  {
    "#": "3 Greenway Ct, Unit 3 & Gar Sp (047A-11-04)",
    "$": 1114700,
    "address": "3 Greenway Ct, Unit 3 & Gar Sp",
    "parcel_id": "047A-11-04",
    "owner1": "MICONDO REALTY LLC",
    "owner2": "",
    "current_taxes": 11414.53,
    "new_taxes_no_override": 11907.64,
    "override_total_1": 12245.51,
    "override_increase_1": 337.87
  },
  {
    "#": "3 Greenway Ct, Unit 4 & Pk A (047A-11-05)",
    "$": 1249600,
    "address": "3 Greenway Ct, Unit 4 & Pk A",
    "parcel_id": "047A-11-05",
    "owner1": "SUN, YE",
    "owner2": "",
    "current_taxes": 9160.97,
    "new_taxes_no_override": 9556.72,
    "override_total_1": 9827.89,
    "override_increase_1": 271.16
  },
  {
    "#": "3 Greenway Ct, Unit 5 & Pk Sp C (047A-11-06)",
    "$": 1142600,
    "address": "3 Greenway Ct, Unit 5 & Pk Sp C",
    "parcel_id": "047A-11-06",
    "owner1": "JULIAN, ISABELLA JACQUELINE",
    "owner2": "",
    "current_taxes": 8065.29,
    "new_taxes_no_override": 8413.71,
    "override_total_1": 8652.44,
    "override_increase_1": 238.73
  },
  {
    "#": "3 Greenway Ct, Unit 6 & Pk Sp  (047A-11-07)",
    "$": 1221300,
    "address": "3 Greenway Ct, Unit 6 & Pk Sp ",
    "parcel_id": "047A-11-07",
    "owner1": "ZHUO, JIAMIN",
    "owner2": "MAO, DAIYAN",
    "current_taxes": 8871.18,
    "new_taxes_no_override": 9254.41,
    "override_total_1": 9517.0,
    "override_increase_1": 262.59
  },
  {
    "#": "3 Greenway Ct, Unit A  (047A-11-01)",
    "$": 1007300,
    "address": "3 Greenway Ct, Unit A ",
    "parcel_id": "047A-11-01",
    "owner1": "CHRISTIANSEN, PHILIP & NELYA",
    "owner2": "",
    "current_taxes": 6679.82,
    "new_taxes_no_override": 6968.39,
    "override_total_1": 7166.11,
    "override_increase_1": 197.72
  },
  {
    "#": "4 Greenway Ct (047A-15-00)",
    "$": 4686300,
    "address": "4 Greenway Ct",
    "parcel_id": "047A-15-00",
    "owner1": "4 GREENWAY COURT LLC",
    "owner2": "",
    "current_taxes": 48956.06,
    "new_taxes_no_override": 51070.96,
    "override_total_1": 52520.06,
    "override_increase_1": 1449.1
  },
  {
    "#": "9 Greenway Ct (047A-12-00)",
    "$": 5090100,
    "address": "9 Greenway Ct",
    "parcel_id": "047A-12-00",
    "owner1": "KRAMER, TR, CARL",
    "owner2": "C/O METRO MANAGEMENT",
    "current_taxes": 52122.62,
    "new_taxes_no_override": 54374.32,
    "override_total_1": 55917.15,
    "override_increase_1": 1542.83
  },
  {
    "#": "10 Greenway Ct (047A-13-14)",
    "$": 9299700,
    "address": "10 Greenway Ct",
    "parcel_id": "047A-13-14",
    "owner1": "GREENWAY REALTY LLC",
    "owner2": "",
    "current_taxes": 95228.93,
    "new_taxes_no_override": 99342.82,
    "override_total_1": 102161.6,
    "override_increase_1": 2818.78
  },
  {
    "#": "4 Griggs Rd (212-16-04)",
    "$": 1748500,
    "address": "4 Griggs Rd",
    "parcel_id": "212-16-04",
    "owner1": "THOMPSON, ELISHA & DEBRA",
    "owner2": "",
    "current_taxes": 14269.71,
    "new_taxes_no_override": 14886.16,
    "override_total_1": 15308.54,
    "override_increase_1": 422.38
  },
  {
    "#": "5 Griggs Rd (214-56-00)",
    "$": 3226300,
    "address": "5 Griggs Rd",
    "parcel_id": "214-56-00",
    "owner1": "WOHLLEIB TR, LISA M",
    "owner2": "",
    "current_taxes": 29402.38,
    "new_taxes_no_override": 30672.56,
    "override_total_1": 31542.87,
    "override_increase_1": 870.31
  },
  {
    "#": "8 Griggs Rd (212-16-01)",
    "$": 1704900,
    "address": "8 Griggs Rd",
    "parcel_id": "212-16-01",
    "owner1": "WONG TR, JOSEPH J",
    "owner2": "WINTHER TR ET AL, KIMBERLY",
    "current_taxes": 13823.24,
    "new_taxes_no_override": 14420.4,
    "override_total_1": 14829.57,
    "override_increase_1": 409.17
  },
  {
    "#": "15 Griggs Rd (214-57-00)",
    "$": 3588200,
    "address": "15 Griggs Rd",
    "parcel_id": "214-57-00",
    "owner1": "ZUKER TRS, ROBERT M & MOLLY",
    "owner2": "",
    "current_taxes": 36743.17,
    "new_taxes_no_override": 38330.47,
    "override_total_1": 39418.07,
    "override_increase_1": 1087.6
  },
  {
    "#": "24 Griggs Rd (212-17-00)",
    "$": 2464000,
    "address": "24 Griggs Rd",
    "parcel_id": "212-17-00",
    "owner1": "JONES, BETH",
    "owner2": "",
    "current_taxes": 21596.43,
    "new_taxes_no_override": 22529.4,
    "override_total_1": 23168.65,
    "override_increase_1": 639.25
  },
  {
    "#": "30 Griggs Rd (212-18-00)",
    "$": 3097900,
    "address": "30 Griggs Rd",
    "parcel_id": "212-18-00",
    "owner1": "LOVICH, MARK & DEBORAH",
    "owner2": "",
    "current_taxes": 28087.56,
    "new_taxes_no_override": 29300.94,
    "override_total_1": 30132.33,
    "override_increase_1": 831.39
  },
  {
    "#": "33 Griggs Rd (213-01-00)",
    "$": 24980300,
    "address": "33 Griggs Rd",
    "parcel_id": "213-01-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O GRIGGS PARK",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "34 Griggs Rd (212-19-00)",
    "$": 2627800,
    "address": "34 Griggs Rd",
    "parcel_id": "212-19-00",
    "owner1": "FRAENKEL, DAN G & MARGARET D",
    "owner2": "",
    "current_taxes": 23273.74,
    "new_taxes_no_override": 24279.17,
    "override_total_1": 24968.07,
    "override_increase_1": 688.9
  },
  {
    "#": "40 Griggs Rd (212-20-00)",
    "$": 2588900,
    "address": "40 Griggs Rd",
    "parcel_id": "212-20-00",
    "owner1": "ROZEN, ISRAEL & MICHELE S",
    "owner2": "",
    "current_taxes": 22875.4,
    "new_taxes_no_override": 23863.62,
    "override_total_1": 24540.73,
    "override_increase_1": 677.11
  },
  {
    "#": "46 Griggs Rd (212-21-00)",
    "$": 2789700,
    "address": "46 Griggs Rd",
    "parcel_id": "212-21-00",
    "owner1": "KLEINBAUM, ADAM",
    "owner2": "BARENBAUM, RACHEL",
    "current_taxes": 24931.59,
    "new_taxes_no_override": 26008.63,
    "override_total_1": 26746.61,
    "override_increase_1": 737.98
  },
  {
    "#": "50 Griggs Rd (212-22-00)",
    "$": 2941200,
    "address": "50 Griggs Rd",
    "parcel_id": "212-22-00",
    "owner1": "BUDDING, LAUREN",
    "owner2": "COHEN, PIETER A",
    "current_taxes": 26482.95,
    "new_taxes_no_override": 27627.01,
    "override_total_1": 28410.91,
    "override_increase_1": 783.9
  },
  {
    "#": "56 Griggs Rd (212-23-00)",
    "$": 1880500,
    "address": "56 Griggs Rd",
    "parcel_id": "212-23-00",
    "owner1": "ALSSID TR, REBECCA C",
    "owner2": "",
    "current_taxes": 15621.39,
    "new_taxes_no_override": 16296.23,
    "override_total_1": 16758.63,
    "override_increase_1": 462.39
  },
  {
    "#": "59 Griggs Rd (214-71-01)",
    "$": 2782600,
    "address": "59 Griggs Rd",
    "parcel_id": "214-71-01",
    "owner1": "METZGER TRS, ERAN D & PATRICIA M",
    "owner2": "",
    "current_taxes": 24858.89,
    "new_taxes_no_override": 25932.79,
    "override_total_1": 26668.62,
    "override_increase_1": 735.82
  },
  {
    "#": "61 Griggs Rd (214-72-00)",
    "$": 2367100,
    "address": "61 Griggs Rd",
    "parcel_id": "214-72-00",
    "owner1": "LIU, ANDREAS",
    "owner2": "FRIAS, VALERIE",
    "current_taxes": 20604.17,
    "new_taxes_no_override": 21494.27,
    "override_total_1": 22104.15,
    "override_increase_1": 609.88
  },
  {
    "#": "63 Griggs Rd (214-72-01)",
    "$": 2606300,
    "address": "63 Griggs Rd",
    "parcel_id": "214-72-01",
    "owner1": "DICKENS ET AL TRS, JOSEPH R",
    "owner2": "BRIEGER, KATHARINE KREVANS",
    "current_taxes": 26688.51,
    "new_taxes_no_override": 27841.45,
    "override_total_1": 28631.43,
    "override_increase_1": 789.98
  },
  {
    "#": "64 Griggs Rd (212-31-00)",
    "$": 1571900,
    "address": "64 Griggs Rd",
    "parcel_id": "212-31-00",
    "owner1": "MADDOCKS, CHRISTOPHER & ARIEL",
    "owner2": "",
    "current_taxes": 12461.32,
    "new_taxes_no_override": 12999.65,
    "override_total_1": 13368.5,
    "override_increase_1": 368.86
  },
  {
    "#": "65 Griggs Rd (214-73-00)",
    "$": 2919300,
    "address": "65 Griggs Rd",
    "parcel_id": "214-73-00",
    "owner1": "BROVMAN, ETHAN",
    "owner2": "OWENS, GWEN",
    "current_taxes": 26258.7,
    "new_taxes_no_override": 27393.08,
    "override_total_1": 28170.33,
    "override_increase_1": 777.26
  },
  {
    "#": "66 Griggs Rd (212-32-00)",
    "$": 1817100,
    "address": "66 Griggs Rd",
    "parcel_id": "212-32-00",
    "owner1": "SLUTZMAN, JONATHAN E",
    "owner2": "WEISS, AMY M",
    "current_taxes": 14972.17,
    "new_taxes_no_override": 15618.97,
    "override_total_1": 16062.14,
    "override_increase_1": 443.18
  },
  {
    "#": "67 Griggs Rd (214-73-01)",
    "$": 2468100,
    "address": "67 Griggs Rd",
    "parcel_id": "214-73-01",
    "owner1": "OPPENHEIM TRS, MEERS",
    "owner2": "LANG, JESSICA",
    "current_taxes": 25273.34,
    "new_taxes_no_override": 26365.15,
    "override_total_1": 27113.24,
    "override_increase_1": 748.09
  },
  {
    "#": "69 Griggs Rd (214-74-00)",
    "$": 2652300,
    "address": "69 Griggs Rd",
    "parcel_id": "214-74-00",
    "owner1": "SCHNUR, SUSAN O",
    "owner2": "FISHMAN, LEONARD M",
    "current_taxes": 23524.62,
    "new_taxes_no_override": 24540.88,
    "override_total_1": 25237.21,
    "override_increase_1": 696.33
  },
  {
    "#": "71 Griggs Rd (214-74-01)",
    "$": 2654300,
    "address": "71 Griggs Rd",
    "parcel_id": "214-74-01",
    "owner1": "KOBULNIK, REUBEN",
    "owner2": "STERN, LAUREN D",
    "current_taxes": 23545.1,
    "new_taxes_no_override": 24562.25,
    "override_total_1": 25259.18,
    "override_increase_1": 696.93
  },
  {
    "#": "75 Griggs Rd, Unit 75 (214-75-01)",
    "$": 3345600,
    "address": "75 Griggs Rd, Unit 75",
    "parcel_id": "214-75-01",
    "owner1": "KIRK, ROBERT W & MARY L",
    "owner2": "",
    "current_taxes": 30624.01,
    "new_taxes_no_override": 31946.97,
    "override_total_1": 32853.44,
    "override_increase_1": 906.47
  },
  {
    "#": "75 Griggs Rd, Unit 77 (214-75-02)",
    "$": 3400800,
    "address": "75 Griggs Rd, Unit 77",
    "parcel_id": "214-75-02",
    "owner1": "GOLDBERG, MARK",
    "owner2": "KAISER, URSULA",
    "current_taxes": 31189.26,
    "new_taxes_no_override": 32536.64,
    "override_total_1": 33459.84,
    "override_increase_1": 923.2
  },
  {
    "#": "81 Griggs Rd (214-76-00)",
    "$": 2775100,
    "address": "81 Griggs Rd",
    "parcel_id": "214-76-00",
    "owner1": "MULSKI, TRS, SUSAN",
    "owner2": "MEYEROVITZ, MICHAEL",
    "current_taxes": 24782.09,
    "new_taxes_no_override": 25852.68,
    "override_total_1": 26586.23,
    "override_increase_1": 733.55
  },
  {
    "#": "85 Griggs Rd (214-77-00)",
    "$": 3058300,
    "address": "85 Griggs Rd",
    "parcel_id": "214-77-00",
    "owner1": "KOCH, REGINA MARIA",
    "owner2": "ROSENTHAL, MICHAEL HAYDEN",
    "current_taxes": 27682.06,
    "new_taxes_no_override": 28877.92,
    "override_total_1": 29697.31,
    "override_increase_1": 819.39
  },
  {
    "#": "86 Griggs Rd, Unit 12A & G15 (212-05-12)",
    "$": 952400,
    "address": "86 Griggs Rd, Unit 12A & G15",
    "parcel_id": "212-05-12",
    "owner1": "QUESENBERRY, RACHEL & MICHAEL STEPHEN",
    "owner2": "",
    "current_taxes": 9752.58,
    "new_taxes_no_override": 10173.89,
    "override_total_1": 10462.57,
    "override_increase_1": 288.68
  },
  {
    "#": "86 Griggs Rd, Unit 14 & G-11 (212-05-13)",
    "$": 914300,
    "address": "86 Griggs Rd, Unit 14 & G-11",
    "parcel_id": "212-05-13",
    "owner1": "DUMAS, ROBERT & HELENE",
    "owner2": "",
    "current_taxes": 5727.5,
    "new_taxes_no_override": 5974.93,
    "override_total_1": 6144.46,
    "override_increase_1": 169.53
  },
  {
    "#": "86 Griggs Rd, Unit 23 P17-18 (212-05-22)",
    "$": 796800,
    "address": "86 Griggs Rd, Unit 23 P17-18",
    "parcel_id": "212-05-22",
    "owner1": "FENG, KESHENG",
    "owner2": "LU, ZHEN",
    "current_taxes": 8159.23,
    "new_taxes_no_override": 8511.71,
    "override_total_1": 8753.22,
    "override_increase_1": 241.51
  },
  {
    "#": "86 Griggs Rd, Unit 24 & Prk 1 (212-05-23)",
    "$": 852300,
    "address": "86 Griggs Rd, Unit 24 & Prk 1",
    "parcel_id": "212-05-23",
    "owner1": "FANG, YI",
    "owner2": "YANG, MIN",
    "current_taxes": 8727.55,
    "new_taxes_no_override": 9104.58,
    "override_total_1": 9362.92,
    "override_increase_1": 258.34
  },
  {
    "#": "86 Griggs Rd, Unit 3 & P8 (212-05-02)",
    "$": 915500,
    "address": "86 Griggs Rd, Unit 3 & P8",
    "parcel_id": "212-05-02",
    "owner1": "TRIMBLE, ALEXANDRA",
    "owner2": "",
    "current_taxes": 5739.79,
    "new_taxes_no_override": 5987.75,
    "override_total_1": 6157.65,
    "override_increase_1": 169.9
  },
  {
    "#": "86 Griggs Rd, Unit 33 & P13 (212-05-32)",
    "$": 908300,
    "address": "86 Griggs Rd, Unit 33 & P13",
    "parcel_id": "212-05-32",
    "owner1": "PROKAEV, ALEXANDER",
    "owner2": "",
    "current_taxes": 5666.06,
    "new_taxes_no_override": 5910.83,
    "override_total_1": 6078.55,
    "override_increase_1": 167.72
  },
  {
    "#": "86 Griggs Rd, Unit 34 & G-12 (212-05-33)",
    "$": 740600,
    "address": "86 Griggs Rd, Unit 34 & G-12",
    "parcel_id": "212-05-33",
    "owner1": "JADD, LYNNE K",
    "owner2": "",
    "current_taxes": 3948.81,
    "new_taxes_no_override": 4119.4,
    "override_total_1": 4236.28,
    "override_increase_1": 116.88
  },
  {
    "#": "86 Griggs Rd, Unit 4 P22-23&G16 (212-05-03)",
    "$": 813700,
    "address": "86 Griggs Rd, Unit 4 P22-23&G16",
    "parcel_id": "212-05-03",
    "owner1": "LI TRS, JOSEPH & BETTY",
    "owner2": "",
    "current_taxes": 8332.29,
    "new_taxes_no_override": 8692.24,
    "override_total_1": 8938.88,
    "override_increase_1": 246.64
  },
  {
    "#": "94 Griggs Rd, Unit 1 & P11 (212-05-35)",
    "$": 567200,
    "address": "94 Griggs Rd, Unit 1 & P11",
    "parcel_id": "212-05-35",
    "owner1": "PELLAM TR, MICHELE",
    "owner2": "",
    "current_taxes": 5808.13,
    "new_taxes_no_override": 6059.04,
    "override_total_1": 6230.96,
    "override_increase_1": 171.92
  },
  {
    "#": "94 Griggs Rd, Unit 11 G13-14 (212-05-10)",
    "$": 994100,
    "address": "94 Griggs Rd, Unit 11 G13-14",
    "parcel_id": "212-05-10",
    "owner1": "JASON, LINDA",
    "owner2": "",
    "current_taxes": 10179.58,
    "new_taxes_no_override": 10619.34,
    "override_total_1": 10920.65,
    "override_increase_1": 301.32
  },
  {
    "#": "94 Griggs Rd, Unit 12 & P7-20 (212-05-11)",
    "$": 796300,
    "address": "94 Griggs Rd, Unit 12 & P7-20",
    "parcel_id": "212-05-11",
    "owner1": "LEYBZON, IGOR & ANNA",
    "owner2": "",
    "current_taxes": 4519.18,
    "new_taxes_no_override": 4714.41,
    "override_total_1": 4848.18,
    "override_increase_1": 133.77
  },
  {
    "#": "94 Griggs Rd, Unit 2 & P5 (212-05-01)",
    "$": 775500,
    "address": "94 Griggs Rd, Unit 2 & P5",
    "parcel_id": "212-05-01",
    "owner1": "LERNER, ELIZABETH J",
    "owner2": "HABERMAN, CHASIAH T",
    "current_taxes": 7941.12,
    "new_taxes_no_override": 8284.18,
    "override_total_1": 8519.23,
    "override_increase_1": 235.06
  },
  {
    "#": "94 Griggs Rd, Unit 21 & G-20 (212-05-20)",
    "$": 815500,
    "address": "94 Griggs Rd, Unit 21 & G-20",
    "parcel_id": "212-05-20",
    "owner1": "SCHOR PARTNERS LLC",
    "owner2": "",
    "current_taxes": 8350.72,
    "new_taxes_no_override": 8711.47,
    "override_total_1": 8958.65,
    "override_increase_1": 247.18
  },
  {
    "#": "94 Griggs Rd, Unit 22 & P-10 (212-05-21)",
    "$": 800600,
    "address": "94 Griggs Rd, Unit 22 & P-10",
    "parcel_id": "212-05-21",
    "owner1": "ARNAOUT, AMAL K",
    "owner2": "",
    "current_taxes": 8198.14,
    "new_taxes_no_override": 8552.3,
    "override_total_1": 8794.96,
    "override_increase_1": 242.66
  },
  {
    "#": "94 Griggs Rd, Unit 31 & P-12 (212-05-30)",
    "$": 758100,
    "address": "94 Griggs Rd, Unit 31 & P-12",
    "parcel_id": "212-05-30",
    "owner1": "HOFFER, RAYMOND",
    "owner2": "",
    "current_taxes": 4128.01,
    "new_taxes_no_override": 4306.34,
    "override_total_1": 4428.53,
    "override_increase_1": 122.19
  },
  {
    "#": "94 Griggs Rd, Unit 32 & P-14 (212-05-31)",
    "$": 906300,
    "address": "94 Griggs Rd, Unit 32 & P-14",
    "parcel_id": "212-05-31",
    "owner1": "SCHOR PARTNERS LLC",
    "owner2": "",
    "current_taxes": 9280.51,
    "new_taxes_no_override": 9681.43,
    "override_total_1": 9956.13,
    "override_increase_1": 274.7
  },
  {
    "#": "103 Griggs Rd (214-79-00)",
    "$": 2134700,
    "address": "103 Griggs Rd",
    "parcel_id": "214-79-00",
    "owner1": "ANANIAN, CLIFFORD SCOTT",
    "owner2": "WONG, JESSICA",
    "current_taxes": 18224.39,
    "new_taxes_no_override": 19011.68,
    "override_total_1": 19551.13,
    "override_increase_1": 539.44
  },
  {
    "#": "107 Griggs Rd, Unit 1 (214-79-02)",
    "$": 956800,
    "address": "107 Griggs Rd, Unit 1",
    "parcel_id": "214-79-02",
    "owner1": "KANTER, JOEL",
    "owner2": "LANGENTHAL, FREDRIKA",
    "current_taxes": 6162.7,
    "new_taxes_no_override": 6428.93,
    "override_total_1": 6611.34,
    "override_increase_1": 182.42
  },
  {
    "#": "107 Griggs Rd, Unit 2 P1 P2 (214-79-03)",
    "$": 1400100,
    "address": "107 Griggs Rd, Unit 2 P1 P2",
    "parcel_id": "214-79-03",
    "owner1": "PERKS, DONALD E & DOROTA",
    "owner2": "",
    "current_taxes": 10702.09,
    "new_taxes_no_override": 11164.42,
    "override_total_1": 11481.2,
    "override_increase_1": 316.78
  },
  {
    "#": "108 Griggs Rd, Unit 1  (212-29-01)",
    "$": 2738900,
    "address": "108 Griggs Rd, Unit 1 ",
    "parcel_id": "212-29-01",
    "owner1": "ZHOU, MIN",
    "owner2": "",
    "current_taxes": 24411.4,
    "new_taxes_no_override": 25465.97,
    "override_total_1": 26188.55,
    "override_increase_1": 722.58
  },
  {
    "#": "108 Griggs Rd, Unit 2 (212-29-02)",
    "$": 2606100,
    "address": "108 Griggs Rd, Unit 2",
    "parcel_id": "212-29-02",
    "owner1": "RYAN, KRISTEN & PATRICK",
    "owner2": "",
    "current_taxes": 26686.46,
    "new_taxes_no_override": 27839.32,
    "override_total_1": 28629.23,
    "override_increase_1": 789.92
  },
  {
    "#": "113 Griggs Rd (214-80-00)",
    "$": 2625700,
    "address": "113 Griggs Rd",
    "parcel_id": "214-80-00",
    "owner1": "DANIELS, JOHN L & JANE M",
    "owner2": "",
    "current_taxes": 23252.23,
    "new_taxes_no_override": 24256.73,
    "override_total_1": 24944.99,
    "override_increase_1": 688.27
  },
  {
    "#": "117 Griggs Rd (214-81-04)",
    "$": 2207000,
    "address": "117 Griggs Rd",
    "parcel_id": "214-81-04",
    "owner1": "AGBA TRS, CHIBUEZE O & NNEKA A",
    "owner2": "",
    "current_taxes": 18964.75,
    "new_taxes_no_override": 19784.03,
    "override_total_1": 20345.38,
    "override_increase_1": 561.36
  },
  {
    "#": "118 Griggs Rd, Unit 1 (212-30-01)",
    "$": 1403500,
    "address": "118 Griggs Rd, Unit 1",
    "parcel_id": "212-30-01",
    "owner1": "LUBIN, KIMBERLEY A & STEPHEN M",
    "owner2": "",
    "current_taxes": 10736.91,
    "new_taxes_no_override": 11200.74,
    "override_total_1": 11518.56,
    "override_increase_1": 317.81
  },
  {
    "#": "118 Griggs Rd, Unit 2 (212-30-02)",
    "$": 1750200,
    "address": "118 Griggs Rd, Unit 2",
    "parcel_id": "212-30-02",
    "owner1": "SHRAYBMAN, VLADISLAV & ALEXANDRA",
    "owner2": "",
    "current_taxes": 17922.05,
    "new_taxes_no_override": 18696.28,
    "override_total_1": 19226.78,
    "override_increase_1": 530.49
  },
  {
    "#": "121 Griggs Rd (214-82-00)",
    "$": 2772700,
    "address": "121 Griggs Rd",
    "parcel_id": "214-82-00",
    "owner1": "DONAHUE, SUSAN F",
    "owner2": "KOCH, CHRISTOPHER A",
    "current_taxes": 24757.51,
    "new_taxes_no_override": 25827.03,
    "override_total_1": 26559.86,
    "override_increase_1": 732.82
  },
  {
    "#": " Griggs Rd (214-71-02)",
    "$": 115700,
    "address": " Griggs Rd",
    "parcel_id": "214-71-02",
    "owner1": "GAEHDE, STEPHAN A & CHARLOTTE ADAMS",
    "owner2": "",
    "current_taxes": 1184.77,
    "new_taxes_no_override": 1235.95,
    "override_total_1": 1271.02,
    "override_increase_1": 35.07
  },
  {
    "#": " Griggs Rd (214-71-03)",
    "$": 111300,
    "address": " Griggs Rd",
    "parcel_id": "214-71-03",
    "owner1": "ROBERTSON, GAYLE A",
    "owner2": "LOPICCOLO, GREGORY B",
    "current_taxes": 1139.71,
    "new_taxes_no_override": 1188.95,
    "override_total_1": 1222.68,
    "override_increase_1": 33.74
  },
  {
    "#": " Griggs Rd (214-71-04)",
    "$": 113300,
    "address": " Griggs Rd",
    "parcel_id": "214-71-04",
    "owner1": "SMITH, KEVIN P",
    "owner2": "REALMUTO, TRINA A",
    "current_taxes": 1160.19,
    "new_taxes_no_override": 1210.31,
    "override_total_1": 1244.65,
    "override_increase_1": 34.34
  },
  {
    "#": " Griggs Rd (214-71-05)",
    "$": 113600,
    "address": " Griggs Rd",
    "parcel_id": "214-71-05",
    "owner1": "ECKEL, MALCOLM D",
    "owner2": "VANCE, SARAH",
    "current_taxes": 1163.26,
    "new_taxes_no_override": 1213.51,
    "override_total_1": 1247.95,
    "override_increase_1": 34.43
  },
  {
    "#": " Griggs Rd (214-71-06)",
    "$": 112900,
    "address": " Griggs Rd",
    "parcel_id": "214-71-06",
    "owner1": "GARONZIK TRS, RON",
    "owner2": "BEN-NATAN, SHULAMIT",
    "current_taxes": 1156.1,
    "new_taxes_no_override": 1206.04,
    "override_total_1": 1240.26,
    "override_increase_1": 34.22
  },
  {
    "#": "6 Griggs Ter (214-71-00)",
    "$": 2308100,
    "address": "6 Griggs Ter",
    "parcel_id": "214-71-00",
    "owner1": "ROBERTSON, GAYLE A",
    "owner2": "LOPICCOLO, GREGORY B",
    "current_taxes": 23634.94,
    "new_taxes_no_override": 24655.97,
    "override_total_1": 25355.56,
    "override_increase_1": 699.59
  },
  {
    "#": "7 Griggs Ter (214-70-01)",
    "$": 1915500,
    "address": "7 Griggs Ter",
    "parcel_id": "214-70-01",
    "owner1": "GAEHDE, STEPHAN A & CHARLOTTE ADAMS",
    "owner2": "",
    "current_taxes": 15979.79,
    "new_taxes_no_override": 16670.12,
    "override_total_1": 17143.12,
    "override_increase_1": 473.0
  },
  {
    "#": "8 Griggs Ter (214-70-00)",
    "$": 2890700,
    "address": "8 Griggs Ter",
    "parcel_id": "214-70-00",
    "owner1": "BRADY TR, DAVID P",
    "owner2": "",
    "current_taxes": 25965.83,
    "new_taxes_no_override": 27087.55,
    "override_total_1": 27856.14,
    "override_increase_1": 768.59
  },
  {
    "#": "9 Griggs Ter (214-69-02)",
    "$": 2253000,
    "address": "9 Griggs Ter",
    "parcel_id": "214-69-02",
    "owner1": "GARONZIK TR, RON",
    "owner2": "BEN-NATAN TR, SHULAMIT",
    "current_taxes": 19435.79,
    "new_taxes_no_override": 20275.42,
    "override_total_1": 20850.72,
    "override_increase_1": 575.3
  },
  {
    "#": "10 Griggs Ter (214-69-01)",
    "$": 2476300,
    "address": "10 Griggs Ter",
    "parcel_id": "214-69-01",
    "owner1": "SMITH, KEVIN P",
    "owner2": "REALMUTO, TRINA A",
    "current_taxes": 21722.38,
    "new_taxes_no_override": 22660.79,
    "override_total_1": 23303.77,
    "override_increase_1": 642.98
  },
  {
    "#": "11 Griggs Ter (214-69-00)",
    "$": 2633800,
    "address": "11 Griggs Ter",
    "parcel_id": "214-69-00",
    "owner1": "ECKEL, MALCOLM D",
    "owner2": "VANCE, SARAH",
    "current_taxes": 23335.18,
    "new_taxes_no_override": 24343.26,
    "override_total_1": 25033.98,
    "override_increase_1": 690.72
  },
  {
    "#": "12 Griggs Ter, Unit A (214-68-00)",
    "$": 2559300,
    "address": "12 Griggs Ter, Unit A",
    "parcel_id": "214-68-00",
    "owner1": "HERTZ, KENNETH",
    "owner2": "BOPPANA, SUSHMA",
    "current_taxes": 22572.3,
    "new_taxes_no_override": 23547.42,
    "override_total_1": 24215.56,
    "override_increase_1": 668.14
  },
  {
    "#": "14 Griggs Ter (214-67-00)",
    "$": 2203700,
    "address": "14 Griggs Ter",
    "parcel_id": "214-67-00",
    "owner1": "SWEITZER, NAOMI",
    "owner2": "SHALIT, ANDREW",
    "current_taxes": 18930.95,
    "new_taxes_no_override": 19748.77,
    "override_total_1": 20309.12,
    "override_increase_1": 560.36
  },
  {
    "#": "18 Griggs Ter (214-66-33)",
    "$": 3166100,
    "address": "18 Griggs Ter",
    "parcel_id": "214-66-33",
    "owner1": "BOSTON EDISON CO",
    "owner2": "C/O NSTAR  PROPERTY TAX DEPT",
    "current_taxes": 54330.28,
    "new_taxes_no_override": 56677.35,
    "override_total_1": 58285.52,
    "override_increase_1": 1608.18
  },
  {
    "#": "20 Griggs Ter (214-35-02)",
    "$": 2000,
    "address": "20 Griggs Ter",
    "parcel_id": "214-35-02",
    "owner1": "BOSTON EDISON CO",
    "owner2": "C/O N STAR PROPERTY TAX DEPT",
    "current_taxes": 20.48,
    "new_taxes_no_override": 21.36,
    "override_total_1": 21.97,
    "override_increase_1": 0.61
  },
  {
    "#": "21 Griggs Ter (214-65-00)",
    "$": 2993400,
    "address": "21 Griggs Ter",
    "parcel_id": "214-65-00",
    "owner1": "BARNETT, MARK A",
    "owner2": "GERGEN BARNETT, KATHERINE A",
    "current_taxes": 27017.48,
    "new_taxes_no_override": 28184.64,
    "override_total_1": 28984.35,
    "override_increase_1": 799.72
  },
  {
    "#": "23 Griggs Ter (214-64-00)",
    "$": 2553400,
    "address": "23 Griggs Ter",
    "parcel_id": "214-64-00",
    "owner1": "SKAGESTAD TRS, FINN PETER",
    "owner2": "OBER, ELAINE M",
    "current_taxes": 22511.88,
    "new_taxes_no_override": 23484.39,
    "override_total_1": 24150.74,
    "override_increase_1": 666.35
  },
  {
    "#": "40 Griggs Ter (214-59-00)",
    "$": 2342500,
    "address": "40 Griggs Ter",
    "parcel_id": "214-59-00",
    "owner1": "SPINGARN, ALEXANDRA HARRISON",
    "owner2": "",
    "current_taxes": 20352.27,
    "new_taxes_no_override": 21231.49,
    "override_total_1": 21833.92,
    "override_increase_1": 602.43
  },
  {
    "#": "42 Griggs Ter, Unit 1 & G & P (214-58-01)",
    "$": 2469200,
    "address": "42 Griggs Ter, Unit 1 & G & P",
    "parcel_id": "214-58-01",
    "owner1": "TAIEB TRS, SHARONA & ERIC G M",
    "owner2": "",
    "current_taxes": 21649.67,
    "new_taxes_no_override": 22584.94,
    "override_total_1": 23225.77,
    "override_increase_1": 640.83
  },
  {
    "#": "42 Griggs Ter, Unit 2 G-& 1 Pk (214-58-02)",
    "$": 1989600,
    "address": "42 Griggs Ter, Unit 2 G-& 1 Pk",
    "parcel_id": "214-58-02",
    "owner1": "SHAH, NAMRATA HEMANT",
    "owner2": "MARINI, ANDREA",
    "current_taxes": 16738.57,
    "new_taxes_no_override": 17461.68,
    "override_total_1": 17957.14,
    "override_increase_1": 495.46
  },
  {
    "#": "42 Griggs Ter, Unit 3 & Pk Sp (214-58-03)",
    "$": 1291100,
    "address": "42 Griggs Ter, Unit 3 & Pk Sp",
    "parcel_id": "214-58-03",
    "owner1": "SCHNEIDER, JOHANNA",
    "owner2": "",
    "current_taxes": 9585.93,
    "new_taxes_no_override": 10000.04,
    "override_total_1": 10283.79,
    "override_increase_1": 283.74
  },
  {
    "#": "47 Griggs Ter (214-57-02)",
    "$": 28800,
    "address": "47 Griggs Ter",
    "parcel_id": "214-57-02",
    "owner1": "ZUKER TRS, ROBERT M & MOLLY",
    "owner2": "",
    "current_taxes": 294.91,
    "new_taxes_no_override": 307.65,
    "override_total_1": 316.38,
    "override_increase_1": 8.73
  },
  {
    "#": " Griggs Ter (214-71-07)",
    "$": 112200,
    "address": " Griggs Ter",
    "parcel_id": "214-71-07",
    "owner1": "BRADY TR, DAVID P",
    "owner2": "",
    "current_taxes": 1148.93,
    "new_taxes_no_override": 1198.56,
    "override_total_1": 1232.57,
    "override_increase_1": 34.01
  },
  {
    "#": "31 Grove St (370-15-16)",
    "$": 16883700,
    "address": "31 Grove St",
    "parcel_id": "370-15-16",
    "owner1": "LONGVIEW DELL INC",
    "owner2": "",
    "current_taxes": 172889.09,
    "new_taxes_no_override": 180357.9,
    "override_total_1": 185475.42,
    "override_increase_1": 5117.52
  },
  {
    "#": "61 Grove St (370-20-00)",
    "$": 1629000,
    "address": "61 Grove St",
    "parcel_id": "370-20-00",
    "owner1": "MANN TR, KATHLEEN M",
    "owner2": "",
    "current_taxes": 13046.03,
    "new_taxes_no_override": 13609.62,
    "override_total_1": 13995.78,
    "override_increase_1": 386.16
  },
  {
    "#": "71 Grove St (370-21-00)",
    "$": 2478200,
    "address": "71 Grove St",
    "parcel_id": "370-21-00",
    "owner1": "ESSBER, GABI & JOELLE JREIJE",
    "owner2": "",
    "current_taxes": 21741.83,
    "new_taxes_no_override": 22681.08,
    "override_total_1": 23324.64,
    "override_increase_1": 643.56
  },
  {
    "#": "85 Grove St (370-22-23)",
    "$": 1509600,
    "address": "85 Grove St",
    "parcel_id": "370-22-23",
    "owner1": "CHIN, GEORGE H",
    "owner2": "MACINNIS, MARY",
    "current_taxes": 11823.37,
    "new_taxes_no_override": 12334.14,
    "override_total_1": 12684.11,
    "override_increase_1": 349.97
  },
  {
    "#": "91 Grove St (370-24-00)",
    "$": 899700,
    "address": "91 Grove St",
    "parcel_id": "370-24-00",
    "owner1": "CHARM, GERALD M",
    "owner2": "",
    "current_taxes": 9212.93,
    "new_taxes_no_override": 9610.93,
    "override_total_1": 9883.63,
    "override_increase_1": 272.7
  },
  {
    "#": "95 Grove St (370-25-00)",
    "$": 1512800,
    "address": "95 Grove St",
    "parcel_id": "370-25-00",
    "owner1": "PARLA, ERIKA & JOHN",
    "owner2": "",
    "current_taxes": 11856.14,
    "new_taxes_no_override": 12368.33,
    "override_total_1": 12719.27,
    "override_increase_1": 350.94
  },
  {
    "#": "96 Grove St (364-01-00)",
    "$": 31184500,
    "address": "96 Grove St",
    "parcel_id": "364-01-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O WALNUT HILLS CEMETERY",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "101 Grove St (370-26-27)",
    "$": 1976200,
    "address": "101 Grove St",
    "parcel_id": "370-26-27",
    "owner1": "KAPLAN TR, ALAN F",
    "owner2": "",
    "current_taxes": 16601.35,
    "new_taxes_no_override": 17318.53,
    "override_total_1": 17809.93,
    "override_increase_1": 491.4
  },
  {
    "#": "107 Grove St (370-28-00)",
    "$": 978100,
    "address": "107 Grove St",
    "parcel_id": "370-28-00",
    "owner1": "WONG, LILY S & SANDRA L",
    "owner2": "",
    "current_taxes": 6380.81,
    "new_taxes_no_override": 6656.46,
    "override_total_1": 6845.33,
    "override_increase_1": 188.87
  },
  {
    "#": "115 Grove St (370-29-00)",
    "$": 1247300,
    "address": "115 Grove St",
    "parcel_id": "370-29-00",
    "owner1": "LI, YIXUE & YUYU",
    "owner2": "LIU, JIAFEN",
    "current_taxes": 12772.35,
    "new_taxes_no_override": 13324.12,
    "override_total_1": 13702.18,
    "override_increase_1": 378.06
  },
  {
    "#": "121 Grove St (368-01-00)",
    "$": 1127100,
    "address": "121 Grove St",
    "parcel_id": "368-01-00",
    "owner1": "HAYES, ANNA B",
    "owner2": "",
    "current_taxes": 11541.5,
    "new_taxes_no_override": 12040.09,
    "override_total_1": 12381.72,
    "override_increase_1": 341.63
  },
  {
    "#": "122 Grove St (364-02-00)",
    "$": 1257500,
    "address": "122 Grove St",
    "parcel_id": "364-02-00",
    "owner1": "BEAVERBROOK STEP INC",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "144 Grove St (364A-05-00)",
    "$": 1380400,
    "address": "144 Grove St",
    "parcel_id": "364A-05-00",
    "owner1": "BROOK, OLGA R & ALEXANDER",
    "owner2": "",
    "current_taxes": 10500.36,
    "new_taxes_no_override": 10953.98,
    "override_total_1": 11264.79,
    "override_increase_1": 310.81
  },
  {
    "#": "145 Grove St (371-02-00)",
    "$": 1253900,
    "address": "145 Grove St",
    "parcel_id": "371-02-00",
    "owner1": "TARPEY, NATHAN & JIALU",
    "owner2": "",
    "current_taxes": 9205.0,
    "new_taxes_no_override": 9602.66,
    "override_total_1": 9875.12,
    "override_increase_1": 272.47
  },
  {
    "#": "150 Grove St (364A-04-00)",
    "$": 1246200,
    "address": "150 Grove St",
    "parcel_id": "364A-04-00",
    "owner1": "CAMPBELL TRS, KAREN A",
    "owner2": "",
    "current_taxes": 9126.15,
    "new_taxes_no_override": 9520.4,
    "override_total_1": 9790.53,
    "override_increase_1": 270.13
  },
  {
    "#": "151 Grove St (371-03-00)",
    "$": 1088200,
    "address": "151 Grove St",
    "parcel_id": "371-03-00",
    "owner1": "KELLY TRS, KEVIN A & MARY ELLEN A",
    "owner2": "",
    "current_taxes": 7508.23,
    "new_taxes_no_override": 7832.59,
    "override_total_1": 8054.83,
    "override_increase_1": 222.24
  },
  {
    "#": "156 Grove St (364A-03-00)",
    "$": 1495600,
    "address": "156 Grove St",
    "parcel_id": "364A-03-00",
    "owner1": "TIPPING, JAMES R & MARY J D",
    "owner2": "",
    "current_taxes": 11680.01,
    "new_taxes_no_override": 12184.59,
    "override_total_1": 12530.31,
    "override_increase_1": 345.73
  },
  {
    "#": "157 Grove St (371-04-06)",
    "$": 4362500,
    "address": "157 Grove St",
    "parcel_id": "371-04-06",
    "owner1": "PCT ASSOCIATES LLC",
    "owner2": "",
    "current_taxes": 44672.0,
    "new_taxes_no_override": 46601.83,
    "override_total_1": 47924.12,
    "override_increase_1": 1322.29
  },
  {
    "#": "162 Grove St (364A-02-00)",
    "$": 1198200,
    "address": "162 Grove St",
    "parcel_id": "364A-02-00",
    "owner1": "TENNANT, CARRIE",
    "owner2": "KROKIDIS, VASILEIOS",
    "current_taxes": 8634.63,
    "new_taxes_no_override": 9007.65,
    "override_total_1": 9263.23,
    "override_increase_1": 255.59
  },
  {
    "#": "183 Grove St (373-07-09)",
    "$": 13187800,
    "address": "183 Grove St",
    "parcel_id": "373-07-09",
    "owner1": "PARKWAY CENTRE ASSOCIATES LLC",
    "owner2": "",
    "current_taxes": 226302.65,
    "new_taxes_no_override": 236078.92,
    "override_total_1": 242777.48,
    "override_increase_1": 6698.56
  },
  {
    "#": "194 Grove St (375-01-00)",
    "$": 10532600,
    "address": "194 Grove St",
    "parcel_id": "375-01-00",
    "owner1": "TEMPLE EMETH",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "219 Grove St (394-14-00)",
    "$": 1146800,
    "address": "219 Grove St",
    "parcel_id": "394-14-00",
    "owner1": "LEE, SHERRY I C",
    "owner2": "",
    "current_taxes": 8108.3,
    "new_taxes_no_override": 8458.58,
    "override_total_1": 8698.58,
    "override_increase_1": 240.01
  },
  {
    "#": "226 Grove St (391-28-00)",
    "$": 1135800,
    "address": "226 Grove St",
    "parcel_id": "391-28-00",
    "owner1": "CASTELLANOS, DANIEL",
    "owner2": "YIN, SUELLEN MOLI",
    "current_taxes": 11630.59,
    "new_taxes_no_override": 12133.03,
    "override_total_1": 12477.3,
    "override_increase_1": 344.27
  },
  {
    "#": "229 Grove St (394-13-00)",
    "$": 1799900,
    "address": "229 Grove St",
    "parcel_id": "394-13-00",
    "owner1": "BALLIN, ZACHARY & SERENA",
    "owner2": "",
    "current_taxes": 14796.04,
    "new_taxes_no_override": 15435.23,
    "override_total_1": 15873.19,
    "override_increase_1": 437.96
  },
  {
    "#": "241 Grove St (393-15-00)",
    "$": 1763900,
    "address": "241 Grove St",
    "parcel_id": "393-15-00",
    "owner1": "BRACHA, ABIGAIL J",
    "owner2": "",
    "current_taxes": 14427.4,
    "new_taxes_no_override": 15050.66,
    "override_total_1": 15477.71,
    "override_increase_1": 427.05
  },
  {
    "#": "242 Grove St (390-01-00)",
    "$": 1364400,
    "address": "242 Grove St",
    "parcel_id": "390-01-00",
    "owner1": "RASSOULIAN TRS, SCOTT S",
    "owner2": "MORIDI, GEORGIA",
    "current_taxes": 13971.46,
    "new_taxes_no_override": 14575.03,
    "override_total_1": 14988.58,
    "override_increase_1": 413.56
  },
  {
    "#": "254 Grove St (390-25-00)",
    "$": 1123900,
    "address": "254 Grove St",
    "parcel_id": "390-25-00",
    "owner1": "PERENYI TR, DOLORES A",
    "owner2": "",
    "current_taxes": 11508.74,
    "new_taxes_no_override": 12005.92,
    "override_total_1": 12346.58,
    "override_increase_1": 340.66
  },
  {
    "#": "5 Hackensack Rd (361-05-00)",
    "$": 16300,
    "address": "5 Hackensack Rd",
    "parcel_id": "361-05-00",
    "owner1": "SLIPAKOFF, DANIEL J",
    "owner2": "PETOK, ALISON",
    "current_taxes": 166.91,
    "new_taxes_no_override": 174.12,
    "override_total_1": 179.06,
    "override_increase_1": 4.94
  },
  {
    "#": "7 Hackensack Rd (361-04-01)",
    "$": 14900,
    "address": "7 Hackensack Rd",
    "parcel_id": "361-04-01",
    "owner1": "SLIPAKOFF, DANIEL J",
    "owner2": "PETOK, ALISON",
    "current_taxes": 152.58,
    "new_taxes_no_override": 159.17,
    "override_total_1": 163.69,
    "override_increase_1": 4.52
  },
  {
    "#": "8 Hackensack Rd (358-02-00)",
    "$": 1094200,
    "address": "8 Hackensack Rd",
    "parcel_id": "358-02-00",
    "owner1": "CHEN, SHUO",
    "owner2": "",
    "current_taxes": 11204.61,
    "new_taxes_no_override": 11688.65,
    "override_total_1": 12020.31,
    "override_increase_1": 331.66
  },
  {
    "#": "16 Hackensack Rd (358-03-04)",
    "$": 1348100,
    "address": "16 Hackensack Rd",
    "parcel_id": "358-03-04",
    "owner1": "BOSE, SANDIP & RUMA R",
    "owner2": "",
    "current_taxes": 10169.61,
    "new_taxes_no_override": 10608.94,
    "override_total_1": 10909.96,
    "override_increase_1": 301.02
  },
  {
    "#": "22 Hackensack Rd (358-05-00)",
    "$": 870600,
    "address": "22 Hackensack Rd",
    "parcel_id": "358-05-00",
    "owner1": "BUCHINSKI TR, JULIE",
    "owner2": "",
    "current_taxes": 8914.94,
    "new_taxes_no_override": 9300.07,
    "override_total_1": 9563.95,
    "override_increase_1": 263.88
  },
  {
    "#": "26 Hackensack Rd (358-06-00)",
    "$": 1070900,
    "address": "26 Hackensack Rd",
    "parcel_id": "358-06-00",
    "owner1": "SIEMASKA, NICHOLAS",
    "owner2": "GOLDFARB, ZOE",
    "current_taxes": 7331.08,
    "new_taxes_no_override": 7647.78,
    "override_total_1": 7864.78,
    "override_increase_1": 217.0
  },
  {
    "#": "30 Hackensack Rd (358-07-00)",
    "$": 904100,
    "address": "30 Hackensack Rd",
    "parcel_id": "358-07-00",
    "owner1": "FIRTH TR, ROBERT A",
    "owner2": "",
    "current_taxes": 5623.05,
    "new_taxes_no_override": 5865.97,
    "override_total_1": 6032.41,
    "override_increase_1": 166.44
  },
  {
    "#": "31 Hackensack Rd (360-02-00)",
    "$": 1528500,
    "address": "31 Hackensack Rd",
    "parcel_id": "360-02-00",
    "owner1": "ROSENBERG TRS, DAVID B & RIVA B",
    "owner2": "",
    "current_taxes": 12016.91,
    "new_taxes_no_override": 12536.04,
    "override_total_1": 12891.74,
    "override_increase_1": 355.7
  },
  {
    "#": "34 Hackensack Rd (358-08-00)",
    "$": 15900,
    "address": "34 Hackensack Rd",
    "parcel_id": "358-08-00",
    "owner1": "GONG, AARON",
    "owner2": "JORDAN, JENNIFER",
    "current_taxes": 162.82,
    "new_taxes_no_override": 169.85,
    "override_total_1": 174.67,
    "override_increase_1": 4.82
  },
  {
    "#": "36 Hackensack Rd (358-09-00)",
    "$": 2400,
    "address": "36 Hackensack Rd",
    "parcel_id": "358-09-00",
    "owner1": "KLINE, JENNIFER",
    "owner2": "",
    "current_taxes": 24.58,
    "new_taxes_no_override": 25.64,
    "override_total_1": 26.37,
    "override_increase_1": 0.73
  },
  {
    "#": "41 Hackensack Rd (361-01-00)",
    "$": 1354700,
    "address": "41 Hackensack Rd",
    "parcel_id": "361-01-00",
    "owner1": "KHAN-TSETLINA, LISA M",
    "owner2": "",
    "current_taxes": 10237.19,
    "new_taxes_no_override": 10679.44,
    "override_total_1": 10982.46,
    "override_increase_1": 303.02
  },
  {
    "#": "43 Hackensack Rd (361-02-00)",
    "$": 1322200,
    "address": "43 Hackensack Rd",
    "parcel_id": "361-02-00",
    "owner1": "QUINN, STUART AIDAN",
    "owner2": "MEYER, STEFANIE",
    "current_taxes": 13539.33,
    "new_taxes_no_override": 14124.23,
    "override_total_1": 14524.99,
    "override_increase_1": 400.76
  },
  {
    "#": "49 Hackensack Rd (361-03-04)",
    "$": 1024200,
    "address": "49 Hackensack Rd",
    "parcel_id": "361-03-04",
    "owner1": "SONI, ADITI & RAKESH",
    "owner2": "",
    "current_taxes": 10487.81,
    "new_taxes_no_override": 10940.88,
    "override_total_1": 11251.32,
    "override_increase_1": 310.44
  },
  {
    "#": "139 Hackensack Rd (366-14-00)",
    "$": 67800,
    "address": "139 Hackensack Rd",
    "parcel_id": "366-14-00",
    "owner1": "BALLAL, RAHUL D & SONIA A",
    "owner2": "",
    "current_taxes": 694.27,
    "new_taxes_no_override": 724.26,
    "override_total_1": 744.81,
    "override_increase_1": 20.55
  },
  {
    "#": "149 Hackensack Rd (366-15-00)",
    "$": 39700,
    "address": "149 Hackensack Rd",
    "parcel_id": "366-15-00",
    "owner1": "LINO, KATHRYN L",
    "owner2": "",
    "current_taxes": 406.53,
    "new_taxes_no_override": 424.09,
    "override_total_1": 436.13,
    "override_increase_1": 12.03
  },
  {
    "#": "153 Hackensack Rd (366-16-00)",
    "$": 41500,
    "address": "153 Hackensack Rd",
    "parcel_id": "366-16-00",
    "owner1": "MAMALAKIS, PHILIP & GEORGIA",
    "owner2": "",
    "current_taxes": 424.96,
    "new_taxes_no_override": 443.32,
    "override_total_1": 455.9,
    "override_increase_1": 12.58
  },
  {
    "#": "3 Hall Rd (308-54-02)",
    "$": 1588200,
    "address": "3 Hall Rd",
    "parcel_id": "308-54-02",
    "owner1": "MEADE, JOAN G",
    "owner2": "",
    "current_taxes": 12628.23,
    "new_taxes_no_override": 13173.77,
    "override_total_1": 13547.57,
    "override_increase_1": 373.8
  },
  {
    "#": "4 Hall Rd (308-55-00)",
    "$": 1593100,
    "address": "4 Hall Rd",
    "parcel_id": "308-55-00",
    "owner1": "ALLEN, ANGELA M & MICHAEL D",
    "owner2": "",
    "current_taxes": 12678.41,
    "new_taxes_no_override": 13226.12,
    "override_total_1": 13601.4,
    "override_increase_1": 375.28
  },
  {
    "#": "11 Hall Rd (308-54-03)",
    "$": 1982200,
    "address": "11 Hall Rd",
    "parcel_id": "308-54-03",
    "owner1": "HANSON, ALIDA J",
    "owner2": "",
    "current_taxes": 16662.79,
    "new_taxes_no_override": 17382.62,
    "override_total_1": 17875.84,
    "override_increase_1": 493.22
  },
  {
    "#": "12 Hall Rd (308-55-01)",
    "$": 1796400,
    "address": "12 Hall Rd",
    "parcel_id": "308-55-01",
    "owner1": "SILBERMAN, SARAH H C & SAMUEL G",
    "owner2": "",
    "current_taxes": 14760.2,
    "new_taxes_no_override": 15397.84,
    "override_total_1": 15834.74,
    "override_increase_1": 436.9
  },
  {
    "#": "9 Hallwood Rd (370A-01-00)",
    "$": 3647700,
    "address": "9 Hallwood Rd",
    "parcel_id": "370A-01-00",
    "owner1": "HAN, XUE",
    "owner2": "BOYDEN, EDWARD S",
    "current_taxes": 33717.51,
    "new_taxes_no_override": 35174.11,
    "override_total_1": 36172.14,
    "override_increase_1": 998.04
  },
  {
    "#": "10 Hallwood Rd (370-13-00)",
    "$": 3121100,
    "address": "10 Hallwood Rd",
    "parcel_id": "370-13-00",
    "owner1": "OKEN, I RUSSELL & SHARA M",
    "owner2": "",
    "current_taxes": 28325.13,
    "new_taxes_no_override": 29548.78,
    "override_total_1": 30387.2,
    "override_increase_1": 838.42
  },
  {
    "#": "18 Hallwood Rd (370-12-00)",
    "$": 5300400,
    "address": "18 Hallwood Rd",
    "parcel_id": "370-12-00",
    "owner1": "CARPENTER, ROBERT J",
    "owner2": "MALONEY, KAREN B",
    "current_taxes": 50641.16,
    "new_taxes_no_override": 52828.86,
    "override_total_1": 54327.84,
    "override_increase_1": 1498.98
  },
  {
    "#": "21 Hallwood Rd (370A-02-00)",
    "$": 3220200,
    "address": "21 Hallwood Rd",
    "parcel_id": "370A-02-00",
    "owner1": "CANTER TR, JONATHAN D",
    "owner2": "",
    "current_taxes": 32974.85,
    "new_taxes_no_override": 34399.36,
    "override_total_1": 35375.42,
    "override_increase_1": 976.06
  },
  {
    "#": "22 Hallwood Rd (370-11-00)",
    "$": 3216300,
    "address": "22 Hallwood Rd",
    "parcel_id": "370-11-00",
    "owner1": "SOBERMAN, ROY J",
    "owner2": "KLIBANSKI, ANNE",
    "current_taxes": 29299.98,
    "new_taxes_no_override": 30565.74,
    "override_total_1": 31433.02,
    "override_increase_1": 867.28
  },
  {
    "#": "28 Hallwood Rd (370-10-00)",
    "$": 2847700,
    "address": "28 Hallwood Rd",
    "parcel_id": "370-10-00",
    "owner1": "LEE, PO-SHUN",
    "owner2": "YANG, AMY HAN-JU",
    "current_taxes": 25525.51,
    "new_taxes_no_override": 26628.21,
    "override_total_1": 27383.77,
    "override_increase_1": 755.56
  },
  {
    "#": "34 Hallwood Rd (370-09-00)",
    "$": 2148600,
    "address": "34 Hallwood Rd",
    "parcel_id": "370-09-00",
    "owner1": "GREEN, MYRNA",
    "owner2": "GREEN ET AL TRS, RICHARD",
    "current_taxes": 18366.73,
    "new_taxes_no_override": 19160.17,
    "override_total_1": 19703.83,
    "override_increase_1": 543.66
  },
  {
    "#": "45 Hallwood Rd (370A-03-00)",
    "$": 3176700,
    "address": "45 Hallwood Rd",
    "parcel_id": "370A-03-00",
    "owner1": "CABOT, CARLA P",
    "owner2": "",
    "current_taxes": 28894.47,
    "new_taxes_no_override": 30142.71,
    "override_total_1": 30997.99,
    "override_increase_1": 855.28
  },
  {
    "#": "46 Hallwood Rd (370-07-00)",
    "$": 3327400,
    "address": "46 Hallwood Rd",
    "parcel_id": "370-07-00",
    "owner1": "MASTERMAN TRS, SYDELL A & EDWARD I",
    "owner2": "",
    "current_taxes": 34072.58,
    "new_taxes_no_override": 35544.52,
    "override_total_1": 36553.06,
    "override_increase_1": 1008.55
  },
  {
    "#": "54 Hallwood Rd (370-06-00)",
    "$": 2121400,
    "address": "54 Hallwood Rd",
    "parcel_id": "370-06-00",
    "owner1": "BONAKDARPOUR TRS, MAJID",
    "owner2": "GHEYSSARI TR, SUSAN",
    "current_taxes": 18088.2,
    "new_taxes_no_override": 18869.61,
    "override_total_1": 19405.02,
    "override_increase_1": 535.41
  },
  {
    "#": "55 Hallwood Rd (370A-04-00)",
    "$": 4556000,
    "address": "55 Hallwood Rd",
    "parcel_id": "370A-04-00",
    "owner1": "ALLEN, ROBERT L JR",
    "owner2": "CONLEY, KENNA",
    "current_taxes": 43018.51,
    "new_taxes_no_override": 44876.91,
    "override_total_1": 46150.26,
    "override_increase_1": 1273.35
  },
  {
    "#": "70 Hallwood Rd (370-04-05)",
    "$": 5855400,
    "address": "70 Hallwood Rd",
    "parcel_id": "370-04-05",
    "owner1": "LEFFELL TRS, JONATHAN & MARLENE S",
    "owner2": "",
    "current_taxes": 56324.36,
    "new_taxes_no_override": 58757.57,
    "override_total_1": 60424.77,
    "override_increase_1": 1667.2
  },
  {
    "#": "77 Hallwood Rd (370A-06-07)",
    "$": 3253600,
    "address": "77 Hallwood Rd",
    "parcel_id": "370A-06-07",
    "owner1": "KEELEY TRS, SAMUEL C",
    "owner2": "MORANDI , MELISSA",
    "current_taxes": 33316.86,
    "new_taxes_no_override": 34756.15,
    "override_total_1": 35742.33,
    "override_increase_1": 986.18
  },
  {
    "#": "80 Hallwood Rd (370-03-00)",
    "$": 2860600,
    "address": "80 Hallwood Rd",
    "parcel_id": "370-03-00",
    "owner1": "ASCHKENASY, MIRIAM K",
    "owner2": "",
    "current_taxes": 29292.54,
    "new_taxes_no_override": 30557.98,
    "override_total_1": 31425.04,
    "override_increase_1": 867.06
  },
  {
    "#": " Hallwood Rd (370A-05-00)",
    "$": 318600,
    "address": " Hallwood Rd",
    "parcel_id": "370A-05-00",
    "owner1": "ALLEN, ROBERT L JR",
    "owner2": "CONLEY, KENNA",
    "current_taxes": 3262.46,
    "new_taxes_no_override": 3403.4,
    "override_total_1": 3499.97,
    "override_increase_1": 96.57
  },
  {
    "#": "6 Hamilton Rd, Unit 6-1 & P2-6 (058-01-01)",
    "$": 999900,
    "address": "6 Hamilton Rd, Unit 6-1 & P2-6",
    "parcel_id": "058-01-01",
    "owner1": "WANG, ALLEN & MEGUMI ELEINA",
    "owner2": "",
    "current_taxes": 6604.04,
    "new_taxes_no_override": 6889.33,
    "override_total_1": 7084.81,
    "override_increase_1": 195.48
  },
  {
    "#": "6 Hamilton Rd, Unit 6-2 (058-01-02)",
    "$": 1073000,
    "address": "6 Hamilton Rd, Unit 6-2",
    "parcel_id": "058-01-02",
    "owner1": "HALL TRS, MITCHELL",
    "owner2": "SCHNEIDER, JESSICA",
    "current_taxes": 7352.59,
    "new_taxes_no_override": 7670.22,
    "override_total_1": 7887.86,
    "override_increase_1": 217.64
  },
  {
    "#": "6 Hamilton Rd, Unit 6-3 (058-01-03)",
    "$": 963800,
    "address": "6 Hamilton Rd, Unit 6-3",
    "parcel_id": "058-01-03",
    "owner1": "RICE, JAMES A",
    "owner2": "",
    "current_taxes": 6234.38,
    "new_taxes_no_override": 6503.71,
    "override_total_1": 6688.24,
    "override_increase_1": 184.54
  },
  {
    "#": "6 Hamilton Rd, Unit 6-G P3 P9 (058-01-07)",
    "$": 450900,
    "address": "6 Hamilton Rd, Unit 6-G P3 P9",
    "parcel_id": "058-01-07",
    "owner1": "ELLIOT, AARON",
    "owner2": "",
    "current_taxes": 4617.22,
    "new_taxes_no_override": 4816.68,
    "override_total_1": 4953.35,
    "override_increase_1": 136.67
  },
  {
    "#": "8 Hamilton Rd, Unit 8-1&3 Pksp (058-01-04)",
    "$": 943100,
    "address": "8 Hamilton Rd, Unit 8-1&3 Pksp",
    "parcel_id": "058-01-04",
    "owner1": "TYTELL, JESSICA D & DAVID E",
    "owner2": "",
    "current_taxes": 6022.41,
    "new_taxes_no_override": 6282.58,
    "override_total_1": 6460.84,
    "override_increase_1": 178.26
  },
  {
    "#": "8 Hamilton Rd, Unit 8-2 P12B&D (058-01-05)",
    "$": 982400,
    "address": "8 Hamilton Rd, Unit 8-2 P12B&D",
    "parcel_id": "058-01-05",
    "owner1": "FISHER, MICHELLE H",
    "owner2": "",
    "current_taxes": 6424.84,
    "new_taxes_no_override": 6702.39,
    "override_total_1": 6892.57,
    "override_increase_1": 190.18
  },
  {
    "#": "8 Hamilton Rd, Unit 8-3 (058-01-06)",
    "$": 968000,
    "address": "8 Hamilton Rd, Unit 8-3",
    "parcel_id": "058-01-06",
    "owner1": "ACKERMAN, MYRA",
    "owner2": "",
    "current_taxes": 6277.39,
    "new_taxes_no_override": 6548.57,
    "override_total_1": 6734.38,
    "override_increase_1": 185.81
  },
  {
    "#": "9 Hamilton Rd (059-05-00)",
    "$": 1868400,
    "address": "9 Hamilton Rd",
    "parcel_id": "059-05-00",
    "owner1": "GUILLORY, BRADFORD J & JUNE R",
    "owner2": "",
    "current_taxes": 15497.48,
    "new_taxes_no_override": 16166.97,
    "override_total_1": 16625.7,
    "override_increase_1": 458.73
  },
  {
    "#": "14 Hamilton Rd (058-02-00)",
    "$": 5204000,
    "address": "14 Hamilton Rd",
    "parcel_id": "058-02-00",
    "owner1": "ALPHABLOX REALTY LLC",
    "owner2": "",
    "current_taxes": 53288.96,
    "new_taxes_no_override": 55591.04,
    "override_total_1": 57168.4,
    "override_increase_1": 1577.35
  },
  {
    "#": "19 Hamilton Rd, Unit 1 (059-06-22)",
    "$": 662800,
    "address": "19 Hamilton Rd, Unit 1",
    "parcel_id": "059-06-22",
    "owner1": "URVATER TR, ERNEST M",
    "owner2": "",
    "current_taxes": 6787.07,
    "new_taxes_no_override": 7080.27,
    "override_total_1": 7281.17,
    "override_increase_1": 200.9
  },
  {
    "#": "19 Hamilton Rd, Unit 2 (059-06-02)",
    "$": 686000,
    "address": "19 Hamilton Rd, Unit 2",
    "parcel_id": "059-06-02",
    "owner1": "YOON, SEUNG WHAN",
    "owner2": "YOO, JIYONG",
    "current_taxes": 7024.64,
    "new_taxes_no_override": 7328.1,
    "override_total_1": 7536.03,
    "override_increase_1": 207.93
  },
  {
    "#": "19 Hamilton Rd, Unit 3 (059-06-03)",
    "$": 698400,
    "address": "19 Hamilton Rd, Unit 3",
    "parcel_id": "059-06-03",
    "owner1": "LEE, ELIZABETH & SUSAN",
    "owner2": "",
    "current_taxes": 3516.68,
    "new_taxes_no_override": 3668.6,
    "override_total_1": 3772.69,
    "override_increase_1": 104.09
  },
  {
    "#": "19 Hamilton Rd, Unit 4 (059-06-04)",
    "$": 696600,
    "address": "19 Hamilton Rd, Unit 4",
    "parcel_id": "059-06-04",
    "owner1": "ZHAO, JING",
    "owner2": "WAN, LIMING",
    "current_taxes": 7133.18,
    "new_taxes_no_override": 7441.33,
    "override_total_1": 7652.48,
    "override_increase_1": 211.14
  },
  {
    "#": "19 Hamilton Rd, Unit 5 (059-06-05)",
    "$": 710200,
    "address": "19 Hamilton Rd, Unit 5",
    "parcel_id": "059-06-05",
    "owner1": "GUO, JIANPING",
    "owner2": "GENG, HONGYAN",
    "current_taxes": 3637.51,
    "new_taxes_no_override": 3794.65,
    "override_total_1": 3902.32,
    "override_increase_1": 107.67
  },
  {
    "#": "19 Hamilton Rd, Unit 6 (059-06-06)",
    "$": 665800,
    "address": "19 Hamilton Rd, Unit 6",
    "parcel_id": "059-06-06",
    "owner1": "HSUNG, RICHARD",
    "owner2": "DAI, JUN",
    "current_taxes": 6817.79,
    "new_taxes_no_override": 7112.32,
    "override_total_1": 7314.13,
    "override_increase_1": 201.81
  },
  {
    "#": "24 Hamilton Rd (058-03-00)",
    "$": 5460300,
    "address": "24 Hamilton Rd",
    "parcel_id": "058-03-00",
    "owner1": "HRT #1 PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 55913.47,
    "new_taxes_no_override": 58328.93,
    "override_total_1": 59983.97,
    "override_increase_1": 1655.04
  },
  {
    "#": "8 Hammond Pond Pky (418-13-01)",
    "$": 1680600,
    "address": "8 Hammond Pond Pky",
    "parcel_id": "418-13-01",
    "owner1": "URMAN, BORIS",
    "owner2": "",
    "current_taxes": 13574.41,
    "new_taxes_no_override": 14160.82,
    "override_total_1": 14562.63,
    "override_increase_1": 401.8
  },
  {
    "#": "16 Hammond Pond Pky (418-13-02)",
    "$": 1415000,
    "address": "16 Hammond Pond Pky",
    "parcel_id": "418-13-02",
    "owner1": "KOUPAIE, SEDIGHEH",
    "owner2": "",
    "current_taxes": 10854.67,
    "new_taxes_no_override": 11323.59,
    "override_total_1": 11644.89,
    "override_increase_1": 321.3
  },
  {
    "#": "24 Hammond Pond Pky, Unit 1 (418-14-04)",
    "$": 1402700,
    "address": "24 Hammond Pond Pky, Unit 1",
    "parcel_id": "418-14-04",
    "owner1": "WANG TRS, ZHIQIANG",
    "owner2": "REN, WEIPING",
    "current_taxes": 14363.65,
    "new_taxes_no_override": 14984.16,
    "override_total_1": 15409.32,
    "override_increase_1": 425.16
  },
  {
    "#": "26 Hammond Pond Pky, Unit 2 (418-14-03)",
    "$": 1244700,
    "address": "26 Hammond Pond Pky, Unit 2",
    "parcel_id": "418-14-03",
    "owner1": "NAKAYAMA, REIKO & YUICHI",
    "owner2": "",
    "current_taxes": 12745.73,
    "new_taxes_no_override": 13296.35,
    "override_total_1": 13673.62,
    "override_increase_1": 377.27
  },
  {
    "#": "32 Hammond Pond Pky (418-14-01)",
    "$": 1147800,
    "address": "32 Hammond Pond Pky",
    "parcel_id": "418-14-01",
    "owner1": "DAVAASAMBUU, GANMAA",
    "owner2": "",
    "current_taxes": 8118.54,
    "new_taxes_no_override": 8469.26,
    "override_total_1": 8709.57,
    "override_increase_1": 240.31
  },
  {
    "#": "36 Hammond Pond Pky (418-14-02)",
    "$": 982800,
    "address": "36 Hammond Pond Pky",
    "parcel_id": "418-14-02",
    "owner1": "AVETISYAN, LORA S",
    "owner2": "",
    "current_taxes": 6428.94,
    "new_taxes_no_override": 6706.67,
    "override_total_1": 6896.97,
    "override_increase_1": 190.3
  },
  {
    "#": "40 Hammond Pond Pky (418-15-00)",
    "$": 987600,
    "address": "40 Hammond Pond Pky",
    "parcel_id": "418-15-00",
    "owner1": "LEE, JE KYUN",
    "owner2": "HAE, KYUNG",
    "current_taxes": 6478.09,
    "new_taxes_no_override": 6757.94,
    "override_total_1": 6949.69,
    "override_increase_1": 191.75
  },
  {
    "#": "41 Hammond Pond Pky, Unit 41 (419-06-02)",
    "$": 1113200,
    "address": "41 Hammond Pond Pky, Unit 41",
    "parcel_id": "419-06-02",
    "owner1": "CHOU, JOHNSON",
    "owner2": "MAK, ANNA SHUIYU",
    "current_taxes": 11399.17,
    "new_taxes_no_override": 11891.61,
    "override_total_1": 12229.03,
    "override_increase_1": 337.42
  },
  {
    "#": "43 Hammond Pond Pky, Unit 43 (419-06-01)",
    "$": 1101600,
    "address": "43 Hammond Pond Pky, Unit 43",
    "parcel_id": "419-06-01",
    "owner1": "ZHAO, JINGHUI",
    "owner2": "YAN, YI",
    "current_taxes": 7645.45,
    "new_taxes_no_override": 7975.73,
    "override_total_1": 8202.04,
    "override_increase_1": 226.31
  },
  {
    "#": "44 Hammond Pond Pky (418-15-01)",
    "$": 981200,
    "address": "44 Hammond Pond Pky",
    "parcel_id": "418-15-01",
    "owner1": "NOEL, MAGALY A",
    "owner2": "",
    "current_taxes": 10047.49,
    "new_taxes_no_override": 10481.54,
    "override_total_1": 10778.95,
    "override_increase_1": 297.41
  },
  {
    "#": "47 Hammond Pond Pky, Unit 47 (419-06-03)",
    "$": 1110000,
    "address": "47 Hammond Pond Pky, Unit 47",
    "parcel_id": "419-06-03",
    "owner1": "BORRELLI, MARIA CATHERINE",
    "owner2": "",
    "current_taxes": 7731.47,
    "new_taxes_no_override": 8065.47,
    "override_total_1": 8294.32,
    "override_increase_1": 228.85
  },
  {
    "#": "48 Hammond Pond Pky (418-15-02)",
    "$": 978000,
    "address": "48 Hammond Pond Pky",
    "parcel_id": "418-15-02",
    "owner1": "HIRSCH TR, LEE ANN",
    "owner2": "",
    "current_taxes": 6379.79,
    "new_taxes_no_override": 6655.4,
    "override_total_1": 6844.24,
    "override_increase_1": 188.84
  },
  {
    "#": "52 Hammond Pond Pky (418-16-00)",
    "$": 1117400,
    "address": "52 Hammond Pond Pky",
    "parcel_id": "418-16-00",
    "owner1": "ENG, KENNETH W",
    "owner2": "LEE, MICHELLE J",
    "current_taxes": 7807.24,
    "new_taxes_no_override": 8144.51,
    "override_total_1": 8375.61,
    "override_increase_1": 231.09
  },
  {
    "#": "55 Hammond Pond Pky (419-05-00)",
    "$": 1786900,
    "address": "55 Hammond Pond Pky",
    "parcel_id": "419-05-00",
    "owner1": "LINDER TR, PAUL E",
    "owner2": "",
    "current_taxes": 14662.92,
    "new_taxes_no_override": 15296.36,
    "override_total_1": 15730.38,
    "override_increase_1": 434.02
  },
  {
    "#": "56 Hammond Pond Pky (418-16-01)",
    "$": 1142800,
    "address": "56 Hammond Pond Pky",
    "parcel_id": "418-16-01",
    "owner1": "MUMTAZ, MUHAMMAD & RAANA",
    "owner2": "",
    "current_taxes": 8067.34,
    "new_taxes_no_override": 8415.85,
    "override_total_1": 8654.64,
    "override_increase_1": 238.79
  },
  {
    "#": "60 Hammond Pond Pky (418-16-02)",
    "$": 991900,
    "address": "60 Hammond Pond Pky",
    "parcel_id": "418-16-02",
    "owner1": "DAS, GAUTHAM P",
    "owner2": "NACHAPPA, K RAKSHITHA",
    "current_taxes": 6522.12,
    "new_taxes_no_override": 6803.88,
    "override_total_1": 6996.93,
    "override_increase_1": 193.05
  },
  {
    "#": "63 Hammond Pond Pky (419-04-00)",
    "$": 1481100,
    "address": "63 Hammond Pond Pky",
    "parcel_id": "419-04-00",
    "owner1": "OKOUDJOU, KASSO A",
    "owner2": "LAWAL, ROAKHIYATH B",
    "current_taxes": 11531.53,
    "new_taxes_no_override": 12029.69,
    "override_total_1": 12371.03,
    "override_increase_1": 341.33
  },
  {
    "#": "64 Hammond Pond Pky (418-17-00)",
    "$": 1130800,
    "address": "64 Hammond Pond Pky",
    "parcel_id": "418-17-00",
    "owner1": "SCOLNICK, JILL D",
    "owner2": "",
    "current_taxes": 7944.46,
    "new_taxes_no_override": 8287.66,
    "override_total_1": 8522.82,
    "override_increase_1": 235.16
  },
  {
    "#": "68 Hammond Pond Pky (418-17-01)",
    "$": 1433100,
    "address": "68 Hammond Pond Pky",
    "parcel_id": "418-17-01",
    "owner1": "FLEISCHMAN, JAN",
    "owner2": "",
    "current_taxes": 11040.01,
    "new_taxes_no_override": 11516.94,
    "override_total_1": 11843.72,
    "override_increase_1": 326.78
  },
  {
    "#": "75 Hammond Pond Pky (419-03-00)",
    "$": 1971500,
    "address": "75 Hammond Pond Pky",
    "parcel_id": "419-03-00",
    "owner1": "GROIPEN, PAUL",
    "owner2": "",
    "current_taxes": 16553.23,
    "new_taxes_no_override": 17268.33,
    "override_total_1": 17758.31,
    "override_increase_1": 489.98
  },
  {
    "#": "231 Hammond Pond Pky (418-18-00)",
    "$": 31971700,
    "address": "231 Hammond Pond Pky",
    "parcel_id": "418-18-00",
    "owner1": "COMMONWEALTH OF MASSACHUSETTS",
    "owner2": "C/O DEPT CONSERVATION & RECREATION",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "271 Hammond Pond Pky (421-15-02)",
    "$": 1453000,
    "address": "271 Hammond Pond Pky",
    "parcel_id": "421-15-02",
    "owner1": "SHI, HUALIN",
    "owner2": "XUE, QIANG",
    "current_taxes": 11243.79,
    "new_taxes_no_override": 11729.52,
    "override_total_1": 12062.34,
    "override_increase_1": 332.82
  },
  {
    "#": "283 Hammond Pond Pky (421-15-01)",
    "$": 1089700,
    "address": "283 Hammond Pond Pky",
    "parcel_id": "421-15-01",
    "owner1": "LIU, XIAOXU",
    "owner2": "KAEWKET, DACHAMONT",
    "current_taxes": 7523.59,
    "new_taxes_no_override": 7848.61,
    "override_total_1": 8071.31,
    "override_increase_1": 222.7
  },
  {
    "#": "310 Hammond Pond Pky, Unit 101 & G23-31 (424-06-09)",
    "$": 1501400,
    "address": "310 Hammond Pond Pky, Unit 101 & G23-31",
    "parcel_id": "424-06-09",
    "owner1": "WEISS TR, HOWARD P",
    "owner2": "",
    "current_taxes": 11739.4,
    "new_taxes_no_override": 12246.54,
    "override_total_1": 12594.03,
    "override_increase_1": 347.49
  },
  {
    "#": "310 Hammond Pond Pky, Unit 102 & G13 G8 G33 (424-06-10)",
    "$": 321800,
    "address": "310 Hammond Pond Pky, Unit 102 & G13 G8 G33",
    "parcel_id": "424-06-10",
    "owner1": "DUKANCI, ESEN",
    "owner2": "",
    "current_taxes": 329.52,
    "new_taxes_no_override": 343.76,
    "override_total_1": 353.51,
    "override_increase_1": 9.75
  },
  {
    "#": "310 Hammond Pond Pky, Unit 103 & G14 (424-06-11)",
    "$": 321800,
    "address": "310 Hammond Pond Pky, Unit 103 & G14",
    "parcel_id": "424-06-11",
    "owner1": "NGUYEN, HIEU TRUNG",
    "owner2": "DO, CINDY TU",
    "current_taxes": 329.52,
    "new_taxes_no_override": 343.76,
    "override_total_1": 353.51,
    "override_increase_1": 9.75
  },
  {
    "#": "310 Hammond Pond Pky, Unit 201 & G11-12-15 (424-06-12)",
    "$": 1240100,
    "address": "310 Hammond Pond Pky, Unit 201 & G11-12-15",
    "parcel_id": "424-06-12",
    "owner1": "SHTEINFELD, ALEXANDER & SABINA",
    "owner2": "",
    "current_taxes": 9063.69,
    "new_taxes_no_override": 9455.24,
    "override_total_1": 9723.53,
    "override_increase_1": 268.29
  },
  {
    "#": "310 Hammond Pond Pky, Unit 202 & G18-19 (424-06-13)",
    "$": 1339600,
    "address": "310 Hammond Pond Pky, Unit 202 & G18-19",
    "parcel_id": "424-06-13",
    "owner1": "LEE TR, THOMAS J",
    "owner2": "",
    "current_taxes": 13717.5,
    "new_taxes_no_override": 14310.1,
    "override_total_1": 14716.13,
    "override_increase_1": 406.04
  },
  {
    "#": "310 Hammond Pond Pky, Unit 203 & G30 & G22 (424-06-14)",
    "$": 1275500,
    "address": "310 Hammond Pond Pky, Unit 203 & G30 & G22",
    "parcel_id": "424-06-14",
    "owner1": "RAEMER, WALLIS W & DANIEL B",
    "owner2": "",
    "current_taxes": 9426.19,
    "new_taxes_no_override": 9833.4,
    "override_total_1": 10112.42,
    "override_increase_1": 279.02
  },
  {
    "#": "310 Hammond Pond Pky, Unit 301&G20-21 (424-06-15)",
    "$": 1162100,
    "address": "310 Hammond Pond Pky, Unit 301&G20-21",
    "parcel_id": "424-06-15",
    "owner1": "EL-MERHI, FADI",
    "owner2": "",
    "current_taxes": 8264.97,
    "new_taxes_no_override": 8622.02,
    "override_total_1": 8866.66,
    "override_increase_1": 244.64
  },
  {
    "#": "310 Hammond Pond Pky, Unit 302&G17 9 10 (424-06-16)",
    "$": 1418000,
    "address": "310 Hammond Pond Pky, Unit 302&G17 9 10",
    "parcel_id": "424-06-16",
    "owner1": "GOLDING, BRAGE WILLIAM",
    "owner2": "",
    "current_taxes": 10885.39,
    "new_taxes_no_override": 11355.64,
    "override_total_1": 11677.85,
    "override_increase_1": 322.21
  },
  {
    "#": "310 Hammond Pond Pky, Unit 303&G24 25 (424-06-17)",
    "$": 1275500,
    "address": "310 Hammond Pond Pky, Unit 303&G24 25",
    "parcel_id": "424-06-17",
    "owner1": "GELLER TRS, MORTON A & LAUREL E & JEFFREY W",
    "owner2": "",
    "current_taxes": 13061.12,
    "new_taxes_no_override": 13625.36,
    "override_total_1": 14011.97,
    "override_increase_1": 386.61
  },
  {
    "#": "310 Hammond Pond Pky, Unit 401 &G1 2 16 (424-06-18)",
    "$": 1914900,
    "address": "310 Hammond Pond Pky, Unit 401 &G1 2 16",
    "parcel_id": "424-06-18",
    "owner1": "WANG, XIUYUN",
    "owner2": "",
    "current_taxes": 15973.64,
    "new_taxes_no_override": 16663.7,
    "override_total_1": 17136.52,
    "override_increase_1": 472.82
  },
  {
    "#": "310 Hammond Pond Pky, Unit 402 &G3 4 6 7 (424-06-19)",
    "$": 1958100,
    "address": "310 Hammond Pond Pky, Unit 402 &G3 4 6 7",
    "parcel_id": "424-06-19",
    "owner1": "CASTALDI, DAVID L & JUDITH A",
    "owner2": "",
    "current_taxes": 16416.01,
    "new_taxes_no_override": 17125.18,
    "override_total_1": 17611.1,
    "override_increase_1": 485.91
  },
  {
    "#": "310 Hammond Pond Pky, Unit G5 (424-06-25)",
    "$": 88400,
    "address": "310 Hammond Pond Pky, Unit G5",
    "parcel_id": "424-06-25",
    "owner1": "NGUYEN, HIEU TRUNG",
    "owner2": "DO, CINDY TU",
    "current_taxes": 905.22,
    "new_taxes_no_override": 944.33,
    "override_total_1": 971.12,
    "override_increase_1": 26.79
  },
  {
    "#": "320 Hammond Pond Pky (424-05-00)",
    "$": 8379900,
    "address": "320 Hammond Pond Pky",
    "parcel_id": "424-05-00",
    "owner1": "LEVENSON, TR, NORMAN A",
    "owner2": "C/O COPLEY MANAGEMENT",
    "current_taxes": 85810.18,
    "new_taxes_no_override": 89517.18,
    "override_total_1": 92057.16,
    "override_increase_1": 2539.98
  },
  {
    "#": "321 Hammond Pond Pky, Unit 101&G5 P49 (424-30-03)",
    "$": 1307600,
    "address": "321 Hammond Pond Pky, Unit 101&G5 P49",
    "parcel_id": "424-30-03",
    "owner1": "NIKNIAN TR, MINOO",
    "owner2": "",
    "current_taxes": 9754.89,
    "new_taxes_no_override": 10176.3,
    "override_total_1": 10465.05,
    "override_increase_1": 288.74
  },
  {
    "#": "321 Hammond Pond Pky, Unit 102 & G9 (424-30-04)",
    "$": 1075100,
    "address": "321 Hammond Pond Pky, Unit 102 & G9",
    "parcel_id": "424-30-04",
    "owner1": "TUDMAN, DAVID W",
    "owner2": "AGGARWAL, SHRUTI",
    "current_taxes": 11009.02,
    "new_taxes_no_override": 11484.61,
    "override_total_1": 11810.48,
    "override_increase_1": 325.87
  },
  {
    "#": "321 Hammond Pond Pky, Unit 103 & G20 (424-30-05)",
    "$": 1133700,
    "address": "321 Hammond Pond Pky, Unit 103 & G20",
    "parcel_id": "424-30-05",
    "owner1": "ZHAO, GUANZHOU",
    "owner2": "",
    "current_taxes": 11609.09,
    "new_taxes_no_override": 12110.6,
    "override_total_1": 12454.23,
    "override_increase_1": 343.63
  },
  {
    "#": "321 Hammond Pond Pky, Unit 104& G2G27 (424-30-06)",
    "$": 1141400,
    "address": "321 Hammond Pond Pky, Unit 104& G2G27",
    "parcel_id": "424-30-06",
    "owner1": "HARRIS, JUNE",
    "owner2": "",
    "current_taxes": 8053.0,
    "new_taxes_no_override": 8400.89,
    "override_total_1": 8639.26,
    "override_increase_1": 238.37
  },
  {
    "#": "321 Hammond Pond Pky, Unit 105 & G13-G14 (424-30-07)",
    "$": 1159100,
    "address": "321 Hammond Pond Pky, Unit 105 & G13-G14",
    "parcel_id": "424-30-07",
    "owner1": "RAYKHTSAUM TR, AZA",
    "owner2": "RAYKHTSAUM-TRATT, ANNA",
    "current_taxes": 11869.18,
    "new_taxes_no_override": 12381.93,
    "override_total_1": 12733.26,
    "override_increase_1": 351.33
  },
  {
    "#": "321 Hammond Pond Pky, Unit 106 & G10 (424-30-08)",
    "$": 970100,
    "address": "321 Hammond Pond Pky, Unit 106 & G10",
    "parcel_id": "424-30-08",
    "owner1": "FENG, YONG",
    "owner2": "XIA, YULIAN",
    "current_taxes": 6298.89,
    "new_taxes_no_override": 6571.0,
    "override_total_1": 6757.45,
    "override_increase_1": 186.45
  },
  {
    "#": "321 Hammond Pond Pky, Unit 107 & P45 (424-30-09)",
    "$": 511700,
    "address": "321 Hammond Pond Pky, Unit 107 & P45",
    "parcel_id": "424-30-09",
    "owner1": "BISHWOKARMA, BIMJHANA",
    "owner2": "RAHAMAN, ABDUL",
    "current_taxes": 1604.87,
    "new_taxes_no_override": 1674.2,
    "override_total_1": 1721.7,
    "override_increase_1": 47.5
  },
  {
    "#": "321 Hammond Pond Pky, Unit 108 & G3 G4 (424-30-10)",
    "$": 1890900,
    "address": "321 Hammond Pond Pky, Unit 108 & G3 G4",
    "parcel_id": "424-30-10",
    "owner1": "NELSON, WILLIAM K & SHERRY A",
    "owner2": "",
    "current_taxes": 19362.82,
    "new_taxes_no_override": 20199.29,
    "override_total_1": 20772.43,
    "override_increase_1": 573.14
  },
  {
    "#": "321 Hammond Pond Pky, Unit 109 & P44 (424-30-11)",
    "$": 331500,
    "address": "321 Hammond Pond Pky, Unit 109 & P44",
    "parcel_id": "424-30-11",
    "owner1": "KIM, YOUNG TAE",
    "owner2": "",
    "current_taxes": 339.46,
    "new_taxes_no_override": 354.12,
    "override_total_1": 364.17,
    "override_increase_1": 10.05
  },
  {
    "#": "321 Hammond Pond Pky, Unit 201 & G7 G8 (424-30-12)",
    "$": 1410300,
    "address": "321 Hammond Pond Pky, Unit 201 & G7 G8",
    "parcel_id": "424-30-12",
    "owner1": "LEVY, GARY E",
    "owner2": "HOLLIDAY-LEVY, MICHELLE R",
    "current_taxes": 14441.47,
    "new_taxes_no_override": 15065.34,
    "override_total_1": 15492.81,
    "override_increase_1": 427.47
  },
  {
    "#": "321 Hammond Pond Pky, Unit 202 & G6 (424-30-13)",
    "$": 1152800,
    "address": "321 Hammond Pond Pky, Unit 202 & G6",
    "parcel_id": "424-30-13",
    "owner1": "LIU, FENGLI",
    "owner2": "",
    "current_taxes": 11804.67,
    "new_taxes_no_override": 12314.63,
    "override_total_1": 12664.05,
    "override_increase_1": 349.42
  },
  {
    "#": "321 Hammond Pond Pky, Unit 203&G24P40 (424-30-14)",
    "$": 1274200,
    "address": "321 Hammond Pond Pky, Unit 203&G24P40",
    "parcel_id": "424-30-14",
    "owner1": "RAYKHTSAUM TR, AZA",
    "owner2": "",
    "current_taxes": 13047.81,
    "new_taxes_no_override": 13611.48,
    "override_total_1": 13997.69,
    "override_increase_1": 386.22
  },
  {
    "#": "321 Hammond Pond Pky, Unit 204&G23P42 (424-30-15)",
    "$": 1513000,
    "address": "321 Hammond Pond Pky, Unit 204&G23P42",
    "parcel_id": "424-30-15",
    "owner1": "FLOYD, PETER M",
    "owner2": "UTTAMSINGH, VINITA",
    "current_taxes": 11858.19,
    "new_taxes_no_override": 12370.46,
    "override_total_1": 12721.47,
    "override_increase_1": 351.0
  },
  {
    "#": "321 Hammond Pond Pky, Unit 205 & G11 (424-30-16)",
    "$": 1212800,
    "address": "321 Hammond Pond Pky, Unit 205 & G11",
    "parcel_id": "424-30-16",
    "owner1": "TUBA, GEOFFREY",
    "owner2": "",
    "current_taxes": 8784.14,
    "new_taxes_no_override": 9163.61,
    "override_total_1": 9423.63,
    "override_increase_1": 260.01
  },
  {
    "#": "321 Hammond Pond Pky, Unit 206 & P46 (424-30-17)",
    "$": 365200,
    "address": "321 Hammond Pond Pky, Unit 206 & P46",
    "parcel_id": "424-30-17",
    "owner1": "LEE, CHAU SHEUNG",
    "owner2": "",
    "current_taxes": 3739.65,
    "new_taxes_no_override": 3901.2,
    "override_total_1": 4011.9,
    "override_increase_1": 110.69
  },
  {
    "#": "321 Hammond Pond Pky, Unit 207 & G29 P36 (424-30-18)",
    "$": 1342800,
    "address": "321 Hammond Pond Pky, Unit 207 & G29 P36",
    "parcel_id": "424-30-18",
    "owner1": "ALTAN, BETUL S",
    "owner2": "",
    "current_taxes": 13750.27,
    "new_taxes_no_override": 14344.28,
    "override_total_1": 14751.29,
    "override_increase_1": 407.01
  },
  {
    "#": "321 Hammond Pond Pky, Unit 301&G16P48 (424-30-19)",
    "$": 1373200,
    "address": "321 Hammond Pond Pky, Unit 301&G16P48",
    "parcel_id": "424-30-19",
    "owner1": "CAO, GUANGJUN",
    "owner2": "ZENG, LAN",
    "current_taxes": 14061.57,
    "new_taxes_no_override": 14669.03,
    "override_total_1": 15085.25,
    "override_increase_1": 416.22
  },
  {
    "#": "321 Hammond Pond Pky, Unit 302&G32 P35 (424-30-20)",
    "$": 1180800,
    "address": "321 Hammond Pond Pky, Unit 302&G32 P35",
    "parcel_id": "424-30-20",
    "owner1": "ZAMFIR TR, LIDIA IOANA",
    "owner2": "",
    "current_taxes": 12091.39,
    "new_taxes_no_override": 12613.74,
    "override_total_1": 12971.64,
    "override_increase_1": 357.91
  },
  {
    "#": "321 Hammond Pond Pky, Unit 303 & G34-P41 (424-30-21)",
    "$": 1299900,
    "address": "321 Hammond Pond Pky, Unit 303 & G34-P41",
    "parcel_id": "424-30-21",
    "owner1": "SWEET, LYNNE D",
    "owner2": "REZENDES, THOMAS P",
    "current_taxes": 9676.04,
    "new_taxes_no_override": 10094.04,
    "override_total_1": 10380.46,
    "override_increase_1": 286.41
  },
  {
    "#": "321 Hammond Pond Pky, Unit 304&G12G26 (424-30-22)",
    "$": 1588500,
    "address": "321 Hammond Pond Pky, Unit 304&G12G26",
    "parcel_id": "424-30-22",
    "owner1": "DAVOS TRS, MARIA G",
    "owner2": "",
    "current_taxes": 12631.31,
    "new_taxes_no_override": 13176.98,
    "override_total_1": 13550.87,
    "override_increase_1": 373.89
  },
  {
    "#": "321 Hammond Pond Pky, Unit 305 & P47 (424-30-23)",
    "$": 331500,
    "address": "321 Hammond Pond Pky, Unit 305 & P47",
    "parcel_id": "424-30-23",
    "owner1": "NGUYEN, KIM NGAN T",
    "owner2": "",
    "current_taxes": 339.46,
    "new_taxes_no_override": 354.12,
    "override_total_1": 364.17,
    "override_increase_1": 10.05
  },
  {
    "#": "321 Hammond Pond Pky, Unit 306 & G33 (424-30-24)",
    "$": 1166200,
    "address": "321 Hammond Pond Pky, Unit 306 & G33",
    "parcel_id": "424-30-24",
    "owner1": "HIRAYAMA, MUNEKI",
    "owner2": "",
    "current_taxes": 8306.95,
    "new_taxes_no_override": 8665.81,
    "override_total_1": 8911.7,
    "override_increase_1": 245.89
  },
  {
    "#": "321 Hammond Pond Pky, Unit 307 &  G17-22 (424-30-25)",
    "$": 1398100,
    "address": "321 Hammond Pond Pky, Unit 307 &  G17-22",
    "parcel_id": "424-30-25",
    "owner1": "ASGHARI, NAJMEH",
    "owner2": "",
    "current_taxes": 14316.54,
    "new_taxes_no_override": 14935.01,
    "override_total_1": 15358.78,
    "override_increase_1": 423.77
  },
  {
    "#": "321 Hammond Pond Pky, Unit 401 & G15G28 (424-30-26)",
    "$": 1639300,
    "address": "321 Hammond Pond Pky, Unit 401 & G15G28",
    "parcel_id": "424-30-26",
    "owner1": "GROSS TR, LINDA",
    "owner2": "",
    "current_taxes": 13151.5,
    "new_taxes_no_override": 13719.64,
    "override_total_1": 14108.93,
    "override_increase_1": 389.28
  },
  {
    "#": "321 Hammond Pond Pky, Unit 402&G18 G25 (424-30-27)",
    "$": 1406500,
    "address": "321 Hammond Pond Pky, Unit 402&G18 G25",
    "parcel_id": "424-30-27",
    "owner1": "LONGHINE, JOHN PETER & PRISCILLA RUCKER",
    "owner2": "",
    "current_taxes": 10767.63,
    "new_taxes_no_override": 11232.79,
    "override_total_1": 11551.51,
    "override_increase_1": 318.72
  },
  {
    "#": "321 Hammond Pond Pky, Unit 403&G30 G31 (424-30-28)",
    "$": 1619400,
    "address": "321 Hammond Pond Pky, Unit 403&G30 G31",
    "parcel_id": "424-30-28",
    "owner1": "MERLIN TRS, KEITH S & HEIDI A",
    "owner2": "",
    "current_taxes": 12947.72,
    "new_taxes_no_override": 13507.06,
    "override_total_1": 13890.31,
    "override_increase_1": 383.25
  },
  {
    "#": "321 Hammond Pond Pky, Unit 404 &G19G21 (424-30-29)",
    "$": 1468900,
    "address": "321 Hammond Pond Pky, Unit 404 &G19G21",
    "parcel_id": "424-30-29",
    "owner1": "LIN, KEXUN",
    "owner2": "",
    "current_taxes": 15041.54,
    "new_taxes_no_override": 15691.33,
    "override_total_1": 16136.56,
    "override_increase_1": 445.23
  },
  {
    "#": "321 Hammond Pond Pky, Unit G1 (424-30-31)",
    "$": 87100,
    "address": "321 Hammond Pond Pky, Unit G1",
    "parcel_id": "424-30-31",
    "owner1": "GLENLAND ROAD LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 891.9,
    "new_taxes_no_override": 930.43,
    "override_total_1": 956.83,
    "override_increase_1": 26.4
  },
  {
    "#": "321 Hammond Pond Pky, Unit P43 (424-30-30)",
    "$": 51900,
    "address": "321 Hammond Pond Pky, Unit P43",
    "parcel_id": "424-30-30",
    "owner1": "HIRAYAMA, MUNEKI",
    "owner2": "",
    "current_taxes": 531.46,
    "new_taxes_no_override": 554.42,
    "override_total_1": 570.15,
    "override_increase_1": 15.73
  },
  {
    "#": "763 Hammond Pond Pky (424-09-00)",
    "$": 583000,
    "address": "763 Hammond Pond Pky",
    "parcel_id": "424-09-00",
    "owner1": "COMMONWEALTH OF MASSACHUSETTS",
    "owner2": "C/O DEPT CONSERVATION & RECREATION",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "564 Hammond St (285-01-04)",
    "$": 14290600,
    "address": "564 Hammond St",
    "parcel_id": "285-01-04",
    "owner1": "LONGWOOD CRICKET CLUB",
    "owner2": "",
    "current_taxes": 245226.7,
    "new_taxes_no_override": 255820.49,
    "override_total_1": 263079.2,
    "override_increase_1": 7258.71
  },
  {
    "#": "565 Hammond St (286-01-00)",
    "$": 1725600,
    "address": "565 Hammond St",
    "parcel_id": "286-01-00",
    "owner1": "BAKER, LYN",
    "owner2": "",
    "current_taxes": 17670.14,
    "new_taxes_no_override": 18433.49,
    "override_total_1": 18956.53,
    "override_increase_1": 523.04
  },
  {
    "#": "571 Hammond St (286-02-00)",
    "$": 1788500,
    "address": "571 Hammond St",
    "parcel_id": "286-02-00",
    "owner1": "ZHANG, XIN MING",
    "owner2": "QI, PEI MIN",
    "current_taxes": 14679.31,
    "new_taxes_no_override": 15313.46,
    "override_total_1": 15747.96,
    "override_increase_1": 434.51
  },
  {
    "#": "575 Hammond St (286-03-00)",
    "$": 1813300,
    "address": "575 Hammond St",
    "parcel_id": "286-03-00",
    "owner1": "VEYSSI TR, BABAK",
    "owner2": "C/O 575 HAMMOND STREET LLC",
    "current_taxes": 18568.19,
    "new_taxes_no_override": 19370.34,
    "override_total_1": 19919.95,
    "override_increase_1": 549.62
  },
  {
    "#": "577 Hammond St (286-04-00)",
    "$": 2011500,
    "address": "577 Hammond St",
    "parcel_id": "286-04-00",
    "owner1": "VEYSSI TR, BABAK",
    "owner2": "C/O 575 HAMMOND STREET LLC",
    "current_taxes": 20597.76,
    "new_taxes_no_override": 21487.58,
    "override_total_1": 22097.28,
    "override_increase_1": 609.69
  },
  {
    "#": "615 Hammond St (428-07-00)",
    "$": 1406900,
    "address": "615 Hammond St",
    "parcel_id": "428-07-00",
    "owner1": "CH REALTY VENTURES LLC",
    "owner2": "",
    "current_taxes": 14406.66,
    "new_taxes_no_override": 15029.03,
    "override_total_1": 15455.46,
    "override_increase_1": 426.44
  },
  {
    "#": "616 Hammond St (433-10-00)",
    "$": 3295700,
    "address": "616 Hammond St",
    "parcel_id": "433-10-00",
    "owner1": "GIAMAR REALTY LLC",
    "owner2": "",
    "current_taxes": 56554.21,
    "new_taxes_no_override": 58997.35,
    "override_total_1": 60671.36,
    "override_increase_1": 1674.0
  },
  {
    "#": "621 Hammond St (428-08-09)",
    "$": 2569400,
    "address": "621 Hammond St",
    "parcel_id": "428-08-09",
    "owner1": "HAMMOND REALTY VENTURES LLC",
    "owner2": "",
    "current_taxes": 44090.9,
    "new_taxes_no_override": 45995.63,
    "override_total_1": 47300.72,
    "override_increase_1": 1305.09
  },
  {
    "#": "629 Hammond St, Unit E101&2Pksp (429-02-16)",
    "$": 1074300,
    "address": "629 Hammond St, Unit E101&2Pksp",
    "parcel_id": "429-02-16",
    "owner1": "ZHANG, JUN",
    "owner2": "JI, YULIN",
    "current_taxes": 11000.83,
    "new_taxes_no_override": 11476.07,
    "override_total_1": 11801.69,
    "override_increase_1": 325.62
  },
  {
    "#": "629 Hammond St, Unit E103&G7677 (429-02-17)",
    "$": 1036800,
    "address": "629 Hammond St, Unit E103&G7677",
    "parcel_id": "429-02-17",
    "owner1": "JOO, SANG YONG & SOON JA",
    "owner2": "",
    "current_taxes": 6981.9,
    "new_taxes_no_override": 7283.52,
    "override_total_1": 7490.18,
    "override_increase_1": 206.66
  },
  {
    "#": "629 Hammond St, Unit E105&G74 (429-02-18)",
    "$": 892300,
    "address": "629 Hammond St, Unit E105&G74",
    "parcel_id": "429-02-18",
    "owner1": "JIN, XUESONG",
    "owner2": "",
    "current_taxes": 9137.15,
    "new_taxes_no_override": 9531.87,
    "override_total_1": 9802.33,
    "override_increase_1": 270.46
  },
  {
    "#": "629 Hammond St, Unit E107&G75 (429-02-19)",
    "$": 1094000,
    "address": "629 Hammond St, Unit E107&G75",
    "parcel_id": "429-02-19",
    "owner1": "HAAS TR, DAVIDA",
    "owner2": "",
    "current_taxes": 11202.56,
    "new_taxes_no_override": 11686.51,
    "override_total_1": 12018.11,
    "override_increase_1": 331.6
  },
  {
    "#": "629 Hammond St, Unit E109&G99 (429-02-20)",
    "$": 323400,
    "address": "629 Hammond St, Unit E109&G99",
    "parcel_id": "429-02-20",
    "owner1": "BAEK, SEUNG GYOU",
    "owner2": "",
    "current_taxes": 331.16,
    "new_taxes_no_override": 345.47,
    "override_total_1": 355.27,
    "override_increase_1": 9.8
  },
  {
    "#": "629 Hammond St, Unit E111&G8 9 (429-02-21)",
    "$": 1168100,
    "address": "629 Hammond St, Unit E111&G8 9",
    "parcel_id": "429-02-21",
    "owner1": "RHOADS, KEVIN J",
    "owner2": "YUEN, LISA L",
    "current_taxes": 8326.41,
    "new_taxes_no_override": 8686.11,
    "override_total_1": 8932.57,
    "override_increase_1": 246.46
  },
  {
    "#": "629 Hammond St, Unit E113&G85 (429-02-22)",
    "$": 1025600,
    "address": "629 Hammond St, Unit E113&G85",
    "parcel_id": "429-02-22",
    "owner1": "SHEVELYOV, VIKTOR & ALLA",
    "owner2": "SHEVELYOVA, ANNA",
    "current_taxes": 6867.21,
    "new_taxes_no_override": 7163.87,
    "override_total_1": 7367.14,
    "override_increase_1": 203.27
  },
  {
    "#": "629 Hammond St, Unit E115 & G60-P114 (429-02-23)",
    "$": 1001500,
    "address": "629 Hammond St, Unit E115 & G60-P114",
    "parcel_id": "429-02-23",
    "owner1": "POMORSKA, GRAZYNA",
    "owner2": "",
    "current_taxes": 10255.36,
    "new_taxes_no_override": 10698.39,
    "override_total_1": 11001.95,
    "override_increase_1": 303.56
  },
  {
    "#": "629 Hammond St, Unit E117&G102 (429-02-24)",
    "$": 322200,
    "address": "629 Hammond St, Unit E117&G102",
    "parcel_id": "429-02-24",
    "owner1": "LIU, BIN & HUI",
    "owner2": "",
    "current_taxes": 329.93,
    "new_taxes_no_override": 344.18,
    "override_total_1": 353.95,
    "override_increase_1": 9.77
  },
  {
    "#": "629 Hammond St, Unit E119 (429-02-25)",
    "$": 1252300,
    "address": "629 Hammond St, Unit E119",
    "parcel_id": "429-02-25",
    "owner1": "YOON, BYUNG-JUN",
    "owner2": "KIM, JUNGYEON",
    "current_taxes": 9188.62,
    "new_taxes_no_override": 9585.57,
    "override_total_1": 9857.55,
    "override_increase_1": 271.98
  },
  {
    "#": "629 Hammond St, Unit E201&2 Pk (429-02-26)",
    "$": 1026600,
    "address": "629 Hammond St, Unit E201&2 Pk",
    "parcel_id": "429-02-26",
    "owner1": "LI, YANG",
    "owner2": "LIU, JIA",
    "current_taxes": 10512.38,
    "new_taxes_no_override": 10966.51,
    "override_total_1": 11277.68,
    "override_increase_1": 311.17
  },
  {
    "#": "629 Hammond St, Unit E203 G2G70 (429-02-27)",
    "$": 1090800,
    "address": "629 Hammond St, Unit E203 G2G70",
    "parcel_id": "429-02-27",
    "owner1": "SUSSMAN TRS, LAWRENCE",
    "owner2": "STERLING, LAUREN",
    "current_taxes": 7534.86,
    "new_taxes_no_override": 7860.37,
    "override_total_1": 8083.4,
    "override_increase_1": 223.03
  },
  {
    "#": "629 Hammond St, Unit E205 G62-63 (429-02-28)",
    "$": 1029400,
    "address": "629 Hammond St, Unit E205 G62-63",
    "parcel_id": "429-02-28",
    "owner1": "SUMMER PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 10541.06,
    "new_taxes_no_override": 10996.43,
    "override_total_1": 11308.45,
    "override_increase_1": 312.02
  },
  {
    "#": "629 Hammond St, Unit E207 (429-02-29)",
    "$": 1179400,
    "address": "629 Hammond St, Unit E207",
    "parcel_id": "429-02-29",
    "owner1": "CONTOMPASIS, MICHAEL & JOAN F",
    "owner2": "",
    "current_taxes": 8442.12,
    "new_taxes_no_override": 8806.82,
    "override_total_1": 9056.71,
    "override_increase_1": 249.89
  },
  {
    "#": "629 Hammond St, Unit E209&G101 (429-02-30)",
    "$": 405300,
    "address": "629 Hammond St, Unit E209&G101",
    "parcel_id": "429-02-30",
    "owner1": "ING, ANNA & MANDY",
    "owner2": "",
    "current_taxes": 515.34,
    "new_taxes_no_override": 537.6,
    "override_total_1": 552.86,
    "override_increase_1": 15.25
  },
  {
    "#": "629 Hammond St, Unit E211 & G5-6-7 (429-02-31)",
    "$": 1254000,
    "address": "629 Hammond St, Unit E211 & G5-6-7",
    "parcel_id": "429-02-31",
    "owner1": "NAZER TRS, YAHYA & NASSRIN",
    "owner2": "",
    "current_taxes": 9206.03,
    "new_taxes_no_override": 9603.73,
    "override_total_1": 9876.23,
    "override_increase_1": 272.5
  },
  {
    "#": "629 Hammond St, Unit E213G71-72 (429-02-32)",
    "$": 1111400,
    "address": "629 Hammond St, Unit E213G71-72",
    "parcel_id": "429-02-32",
    "owner1": "BARON , CYNTHIA S & DAVID J",
    "owner2": "",
    "current_taxes": 11380.74,
    "new_taxes_no_override": 11872.39,
    "override_total_1": 12209.26,
    "override_increase_1": 336.87
  },
  {
    "#": "629 Hammond St, Unit E215&G65 (429-02-33)",
    "$": 931200,
    "address": "629 Hammond St, Unit E215&G65",
    "parcel_id": "429-02-33",
    "owner1": "STEINBACH, ROBERT J",
    "owner2": "STEINBACH ET AL TRS, ROBERTA J & JAIME",
    "current_taxes": 5900.55,
    "new_taxes_no_override": 6155.45,
    "override_total_1": 6330.11,
    "override_increase_1": 174.66
  },
  {
    "#": "629 Hammond St, Unit E217&G98 (429-02-34)",
    "$": 322200,
    "address": "629 Hammond St, Unit E217&G98",
    "parcel_id": "429-02-34",
    "owner1": "GOTO-HARDY, MEGUMI",
    "owner2": "",
    "current_taxes": 329.93,
    "new_taxes_no_override": 344.18,
    "override_total_1": 353.95,
    "override_increase_1": 9.77
  },
  {
    "#": "629 Hammond St, Unit E219 2 Pk (429-02-35)",
    "$": 1252400,
    "address": "629 Hammond St, Unit E219 2 Pk",
    "parcel_id": "429-02-35",
    "owner1": "KEE TRS, KERRY M",
    "owner2": "CHIN, KARIN",
    "current_taxes": 12824.58,
    "new_taxes_no_override": 13378.6,
    "override_total_1": 13758.21,
    "override_increase_1": 379.61
  },
  {
    "#": "629 Hammond St, Unit E301G68 69 (429-02-36)",
    "$": 1026600,
    "address": "629 Hammond St, Unit E301G68 69",
    "parcel_id": "429-02-36",
    "owner1": "GOLOD, ALEXANDER",
    "owner2": "SHMIDT, ALLA",
    "current_taxes": 6877.45,
    "new_taxes_no_override": 7174.56,
    "override_total_1": 7378.13,
    "override_increase_1": 203.57
  },
  {
    "#": "629 Hammond St, Unit E303 (429-02-37)",
    "$": 1090800,
    "address": "629 Hammond St, Unit E303",
    "parcel_id": "429-02-37",
    "owner1": "QIAN, RU-YING",
    "owner2": "QIAN-TSUCHIDA, DOROTHY",
    "current_taxes": 7534.86,
    "new_taxes_no_override": 7860.37,
    "override_total_1": 8083.4,
    "override_increase_1": 223.03
  },
  {
    "#": "629 Hammond St, Unit E305&G80 (429-02-38)",
    "$": 942600,
    "address": "629 Hammond St, Unit E305&G80",
    "parcel_id": "429-02-38",
    "owner1": "JACOBS TRS, ANDREW L & NEIL H",
    "owner2": "",
    "current_taxes": 6017.29,
    "new_taxes_no_override": 6277.24,
    "override_total_1": 6455.35,
    "override_increase_1": 178.11
  },
  {
    "#": "629 Hammond St, Unit E307G78 79 (429-02-39)",
    "$": 1179400,
    "address": "629 Hammond St, Unit E307G78 79",
    "parcel_id": "429-02-39",
    "owner1": "LEWIS TRS, PETER H & SUSAN K",
    "owner2": "",
    "current_taxes": 8442.12,
    "new_taxes_no_override": 8806.82,
    "override_total_1": 9056.71,
    "override_increase_1": 249.89
  },
  {
    "#": "629 Hammond St, Unit E309&G100 (429-02-40)",
    "$": 405300,
    "address": "629 Hammond St, Unit E309&G100",
    "parcel_id": "429-02-40",
    "owner1": "CHEN, PEGGY G & ALEX  YUAN FU",
    "owner2": "",
    "current_taxes": 515.34,
    "new_taxes_no_override": 537.6,
    "override_total_1": 552.86,
    "override_increase_1": 15.25
  },
  {
    "#": "629 Hammond St, Unit E311G12 13 (429-02-41)",
    "$": 1168100,
    "address": "629 Hammond St, Unit E311G12 13",
    "parcel_id": "429-02-41",
    "owner1": "QUIROGA, ARUNA CHONG",
    "owner2": "",
    "current_taxes": 8326.41,
    "new_taxes_no_override": 8686.11,
    "override_total_1": 8932.57,
    "override_increase_1": 246.46
  },
  {
    "#": "629 Hammond St, Unit E313 G84 89 (429-02-42)",
    "$": 1111400,
    "address": "629 Hammond St, Unit E313 G84 89",
    "parcel_id": "429-02-42",
    "owner1": "SCHUMANN, TANIA DE CASSIA L",
    "owner2": "",
    "current_taxes": 7745.8,
    "new_taxes_no_override": 8080.42,
    "override_total_1": 8309.69,
    "override_increase_1": 229.28
  },
  {
    "#": "629 Hammond St, Unit E315 G5864 (429-02-43)",
    "$": 1153500,
    "address": "629 Hammond St, Unit E315 G5864",
    "parcel_id": "429-02-43",
    "owner1": "ANCONINA TRS, BETHANY",
    "owner2": "SAFFRAN, JAY",
    "current_taxes": 11811.84,
    "new_taxes_no_override": 12322.11,
    "override_total_1": 12671.74,
    "override_increase_1": 349.63
  },
  {
    "#": "629 Hammond St, Unit E317&G81 (429-02-44)",
    "$": 865700,
    "address": "629 Hammond St, Unit E317&G81",
    "parcel_id": "429-02-44",
    "owner1": "GRINSHPUN TRS, VLADIMIR & ELLEN",
    "owner2": "",
    "current_taxes": 5229.83,
    "new_taxes_no_override": 5455.76,
    "override_total_1": 5610.56,
    "override_increase_1": 154.8
  },
  {
    "#": "629 Hammond St, Unit E319 (429-02-45)",
    "$": 1152700,
    "address": "629 Hammond St, Unit E319",
    "parcel_id": "429-02-45",
    "owner1": "BARRETT, JALEH F",
    "owner2": "",
    "current_taxes": 8168.71,
    "new_taxes_no_override": 8521.6,
    "override_total_1": 8763.39,
    "override_increase_1": 241.79
  },
  {
    "#": "629 Hammond St, Unit Eph1 & G94 G95 (429-02-46)",
    "$": 1024000,
    "address": "629 Hammond St, Unit Eph1 & G94 G95",
    "parcel_id": "429-02-46",
    "owner1": "ILICHEV, ALEXANDER",
    "owner2": "",
    "current_taxes": 10485.76,
    "new_taxes_no_override": 10938.74,
    "override_total_1": 11249.12,
    "override_increase_1": 310.38
  },
  {
    "#": "629 Hammond St, Unit Eph11 (429-02-51)",
    "$": 1156600,
    "address": "629 Hammond St, Unit Eph11",
    "parcel_id": "429-02-51",
    "owner1": "JOE , LISA L",
    "owner2": "WONG, JAMES S",
    "current_taxes": 11843.58,
    "new_taxes_no_override": 12355.22,
    "override_total_1": 12705.79,
    "override_increase_1": 350.57
  },
  {
    "#": "629 Hammond St, Unit Eph15 5688 (429-02-52)",
    "$": 961200,
    "address": "629 Hammond St, Unit Eph15 5688",
    "parcel_id": "429-02-52",
    "owner1": "MURATA TR, YOSHIATSU",
    "owner2": "",
    "current_taxes": 9842.69,
    "new_taxes_no_override": 10267.89,
    "override_total_1": 10559.24,
    "override_increase_1": 291.34
  },
  {
    "#": "629 Hammond St, Unit Eph17&G3 4 (429-02-53)",
    "$": 1194200,
    "address": "629 Hammond St, Unit Eph17&G3 4",
    "parcel_id": "429-02-53",
    "owner1": "KO, ALAN C",
    "owner2": "",
    "current_taxes": 12228.61,
    "new_taxes_no_override": 12756.89,
    "override_total_1": 13118.85,
    "override_increase_1": 361.97
  },
  {
    "#": "629 Hammond St, Unit Eph3&2Pksp (429-02-47)",
    "$": 1078200,
    "address": "629 Hammond St, Unit Eph3&2Pksp",
    "parcel_id": "429-02-47",
    "owner1": "PETRILLA TRS, JAMES A & ALEXIS A",
    "owner2": "",
    "current_taxes": 7405.83,
    "new_taxes_no_override": 7725.76,
    "override_total_1": 7944.97,
    "override_increase_1": 219.21
  },
  {
    "#": "629 Hammond St, Unit Eph5 G5787 (429-02-48)",
    "$": 1103500,
    "address": "629 Hammond St, Unit Eph5 G5787",
    "parcel_id": "429-02-48",
    "owner1": "TAYLOR TRS, EDWARD S JR & KIMBERLY L",
    "owner2": "",
    "current_taxes": 11299.84,
    "new_taxes_no_override": 11787.99,
    "override_total_1": 12122.47,
    "override_increase_1": 334.48
  },
  {
    "#": "629 Hammond St, Unit Eph7&G8283 (429-02-49)",
    "$": 1348000,
    "address": "629 Hammond St, Unit Eph7&G8283",
    "parcel_id": "429-02-49",
    "owner1": "ALOMARI, AHMAD",
    "owner2": "",
    "current_taxes": 10168.59,
    "new_taxes_no_override": 10607.87,
    "override_total_1": 10908.86,
    "override_increase_1": 300.99
  },
  {
    "#": "629 Hammond St, Unit Eph9 G5590 (429-02-50)",
    "$": 1104400,
    "address": "629 Hammond St, Unit Eph9 G5590",
    "parcel_id": "429-02-50",
    "owner1": "GROSS, JULIE",
    "owner2": "",
    "current_taxes": 7674.12,
    "new_taxes_no_override": 8005.64,
    "override_total_1": 8232.8,
    "override_increase_1": 227.15
  },
  {
    "#": "629 Hammond St, Unit G23 (429-02-75)",
    "$": 90800,
    "address": "629 Hammond St, Unit G23",
    "parcel_id": "429-02-75",
    "owner1": "MCCOLGAN, STEPHEN & YUKO",
    "owner2": "",
    "current_taxes": 929.79,
    "new_taxes_no_override": 969.96,
    "override_total_1": 997.48,
    "override_increase_1": 27.52
  },
  {
    "#": "629 Hammond St, Unit G42 (429-02-76)",
    "$": 90800,
    "address": "629 Hammond St, Unit G42",
    "parcel_id": "429-02-76",
    "owner1": "MCCOLGAN, STEPHEN & YUKO",
    "owner2": "",
    "current_taxes": 929.79,
    "new_taxes_no_override": 969.96,
    "override_total_1": 997.48,
    "override_increase_1": 27.52
  },
  {
    "#": "629 Hammond St, Unit G61 (429-02-77)",
    "$": 90800,
    "address": "629 Hammond St, Unit G61",
    "parcel_id": "429-02-77",
    "owner1": "STEINBACK, ROBERT M & ROBERTA J",
    "owner2": "",
    "current_taxes": 929.79,
    "new_taxes_no_override": 969.96,
    "override_total_1": 997.48,
    "override_increase_1": 27.52
  },
  {
    "#": "629 Hammond St, Unit G73 (429-02-78)",
    "$": 90800,
    "address": "629 Hammond St, Unit G73",
    "parcel_id": "429-02-78",
    "owner1": "JIN, XUESONG",
    "owner2": "",
    "current_taxes": 929.79,
    "new_taxes_no_override": 969.96,
    "override_total_1": 997.48,
    "override_increase_1": 27.52
  },
  {
    "#": "629 Hammond St, Unit Pk Sps (429-02-79)",
    "$": 279300,
    "address": "629 Hammond St, Unit Pk Sps",
    "parcel_id": "429-02-79",
    "owner1": "HAMMONDSWOOD AT CHESTNUT HILL CONDO TRUST- JULIE GROSS ET AL TRS",
    "owner2": "C/O BARKAN MGMT",
    "current_taxes": 2860.03,
    "new_taxes_no_override": 2983.58,
    "override_total_1": 3068.24,
    "override_increase_1": 84.66
  },
  {
    "#": "629 Hammond St, Unit W100 & G20 (429-02-54)",
    "$": 1021100,
    "address": "629 Hammond St, Unit W100 & G20",
    "parcel_id": "429-02-54",
    "owner1": "TOGAMI, KATSUHIRO & LEONA",
    "owner2": "",
    "current_taxes": 6821.13,
    "new_taxes_no_override": 7115.8,
    "override_total_1": 7317.71,
    "override_increase_1": 201.91
  },
  {
    "#": "629 Hammond St, Unit W102 & G16 17 (429-02-55)",
    "$": 1244300,
    "address": "629 Hammond St, Unit W102 & G16 17",
    "parcel_id": "429-02-55",
    "owner1": "LEVINE TRS, KENNETH R & ROBIN J",
    "owner2": "",
    "current_taxes": 9106.7,
    "new_taxes_no_override": 9500.11,
    "override_total_1": 9769.67,
    "override_increase_1": 269.56
  },
  {
    "#": "629 Hammond St, Unit W104&G4041 (429-02-56)",
    "$": 1247800,
    "address": "629 Hammond St, Unit W104&G4041",
    "parcel_id": "429-02-56",
    "owner1": "PILTCH TR, MARY E",
    "owner2": "",
    "current_taxes": 9142.54,
    "new_taxes_no_override": 9537.5,
    "override_total_1": 9808.12,
    "override_increase_1": 270.62
  },
  {
    "#": "629 Hammond St, Unit W106G48 49 (429-02-57)",
    "$": 1199900,
    "address": "629 Hammond St, Unit W106G48 49",
    "parcel_id": "429-02-57",
    "owner1": "HABER, JUDITH",
    "owner2": "",
    "current_taxes": 8652.04,
    "new_taxes_no_override": 9025.81,
    "override_total_1": 9281.91,
    "override_increase_1": 256.1
  },
  {
    "#": "629 Hammond St, Unit W108 & G33 (429-02-58)",
    "$": 447400,
    "address": "629 Hammond St, Unit W108 & G33",
    "parcel_id": "429-02-58",
    "owner1": "ALAEDDIN, MOHAMMED",
    "owner2": "LIGUORI, ANGELA",
    "current_taxes": 946.44,
    "new_taxes_no_override": 987.33,
    "override_total_1": 1015.34,
    "override_increase_1": 28.01
  },
  {
    "#": "629 Hammond St, Unit W110&G2122 (429-02-59)",
    "$": 1334700,
    "address": "629 Hammond St, Unit W110&G2122",
    "parcel_id": "429-02-59",
    "owner1": "VIVERO, SENEN",
    "owner2": "BARDALLO-VIVERO, GRACIELA",
    "current_taxes": 10032.39,
    "new_taxes_no_override": 10465.79,
    "override_total_1": 10762.75,
    "override_increase_1": 296.96
  },
  {
    "#": "629 Hammond St, Unit W112 & G30 (429-02-60)",
    "$": 322200,
    "address": "629 Hammond St, Unit W112 & G30",
    "parcel_id": "429-02-60",
    "owner1": "CHU, I-CHEN & YUEH CHING",
    "owner2": "",
    "current_taxes": 329.93,
    "new_taxes_no_override": 344.18,
    "override_total_1": 353.95,
    "override_increase_1": 9.77
  },
  {
    "#": "629 Hammond St, Unit W200&G3159 (429-02-61)",
    "$": 322200,
    "address": "629 Hammond St, Unit W200&G3159",
    "parcel_id": "429-02-61",
    "owner1": "KHALIL, MOHAMMED S",
    "owner2": "",
    "current_taxes": 329.93,
    "new_taxes_no_override": 344.18,
    "override_total_1": 353.95,
    "override_increase_1": 9.77
  },
  {
    "#": "629 Hammond St, Unit W202 & G24-G25 (429-02-62)",
    "$": 1292700,
    "address": "629 Hammond St, Unit W202 & G24-G25",
    "parcel_id": "429-02-62",
    "owner1": "MULLEN, EDWARD J",
    "owner2": "RODRIGUEZ, ANGELES T",
    "current_taxes": 9602.31,
    "new_taxes_no_override": 10017.13,
    "override_total_1": 10301.36,
    "override_increase_1": 284.23
  },
  {
    "#": "629 Hammond St, Unit W204G43 15 (429-02-63)",
    "$": 1316200,
    "address": "629 Hammond St, Unit W204G43 15",
    "parcel_id": "429-02-63",
    "owner1": "LLOYD, CHERYL R",
    "owner2": "",
    "current_taxes": 9842.95,
    "new_taxes_no_override": 10268.17,
    "override_total_1": 10559.52,
    "override_increase_1": 291.35
  },
  {
    "#": "629 Hammond St, Unit W206G10 11 (429-02-64)",
    "$": 1199100,
    "address": "629 Hammond St, Unit W206G10 11",
    "parcel_id": "429-02-64",
    "owner1": "AHERN, RICHARD P & ANGELA MAURICI",
    "owner2": "",
    "current_taxes": 12278.78,
    "new_taxes_no_override": 12809.22,
    "override_total_1": 13172.68,
    "override_increase_1": 363.45
  },
  {
    "#": "629 Hammond St, Unit W208 & G27-28 (429-02-65)",
    "$": 1106600,
    "address": "629 Hammond St, Unit W208 & G27-28",
    "parcel_id": "429-02-65",
    "owner1": "GOLDSTEIN, JAY & PHYLLIS & CRAIG",
    "owner2": "",
    "current_taxes": 7696.65,
    "new_taxes_no_override": 8029.15,
    "override_total_1": 8256.97,
    "override_increase_1": 227.82
  },
  {
    "#": "629 Hammond St, Unit W210 & G29-34-46 (429-02-66)",
    "$": 1452800,
    "address": "629 Hammond St, Unit W210 & G29-34-46",
    "parcel_id": "429-02-66",
    "owner1": "SCHWARTZ-GUTMAN TR, BARBARA",
    "owner2": "",
    "current_taxes": 11241.74,
    "new_taxes_no_override": 11727.38,
    "override_total_1": 12060.14,
    "override_increase_1": 332.76
  },
  {
    "#": "629 Hammond St, Unit W212 & G32 (429-02-67)",
    "$": 322200,
    "address": "629 Hammond St, Unit W212 & G32",
    "parcel_id": "429-02-67",
    "owner1": "FELDMAN, ALEKSANDRA S & VADIM I",
    "owner2": "",
    "current_taxes": 329.93,
    "new_taxes_no_override": 344.18,
    "override_total_1": 353.95,
    "override_increase_1": 9.77
  },
  {
    "#": "629 Hammond St, Unit Wph10 (429-02-72)",
    "$": 1175100,
    "address": "629 Hammond St, Unit Wph10",
    "parcel_id": "429-02-72",
    "owner1": "MCCOLGAN, STEPHEN & YUKO",
    "owner2": "",
    "current_taxes": 8398.09,
    "new_taxes_no_override": 8760.89,
    "override_total_1": 9009.47,
    "override_increase_1": 248.58
  },
  {
    "#": "629 Hammond St, Unit Wph12 (429-02-73)",
    "$": 1365600,
    "address": "629 Hammond St, Unit Wph12",
    "parcel_id": "429-02-73",
    "owner1": "DANIELS, MICHAEL D",
    "owner2": "",
    "current_taxes": 10348.81,
    "new_taxes_no_override": 10795.88,
    "override_total_1": 11102.2,
    "override_increase_1": 306.32
  },
  {
    "#": "629 Hammond St, Unit Wph14&2 Pk (429-02-74)",
    "$": 1010200,
    "address": "629 Hammond St, Unit Wph14&2 Pk",
    "parcel_id": "429-02-74",
    "owner1": "AHERN, RICHARD P",
    "owner2": "",
    "current_taxes": 10344.45,
    "new_taxes_no_override": 10791.33,
    "override_total_1": 11097.53,
    "override_increase_1": 306.2
  },
  {
    "#": "629 Hammond St, Unit Wph2 & G52 (429-02-68)",
    "$": 909800,
    "address": "629 Hammond St, Unit Wph2 & G52",
    "parcel_id": "429-02-68",
    "owner1": "CHAN, SHERWIN Y",
    "owner2": "",
    "current_taxes": 5681.42,
    "new_taxes_no_override": 5926.86,
    "override_total_1": 6095.03,
    "override_increase_1": 168.17
  },
  {
    "#": "629 Hammond St, Unit Wph4 G1454 (429-02-69)",
    "$": 1186400,
    "address": "629 Hammond St, Unit Wph4 G1454",
    "parcel_id": "429-02-69",
    "owner1": "PARMINDER TR, A",
    "owner2": "",
    "current_taxes": 12148.74,
    "new_taxes_no_override": 12673.57,
    "override_total_1": 13033.17,
    "override_increase_1": 359.6
  },
  {
    "#": "629 Hammond St, Unit Wph6 G4750 (429-02-70)",
    "$": 1290000,
    "address": "629 Hammond St, Unit Wph6 G4750",
    "parcel_id": "429-02-70",
    "owner1": "BOLZAN  TR, CHRISTINE M",
    "owner2": "",
    "current_taxes": 9574.67,
    "new_taxes_no_override": 9988.3,
    "override_total_1": 10271.71,
    "override_increase_1": 283.41
  },
  {
    "#": "629 Hammond St, Unit Wph8 (429-02-71)",
    "$": 1284500,
    "address": "629 Hammond St, Unit Wph8",
    "parcel_id": "429-02-71",
    "owner1": "CHACHARONE TR, STYLIANI",
    "owner2": "",
    "current_taxes": 9518.35,
    "new_taxes_no_override": 9929.54,
    "override_total_1": 10211.29,
    "override_increase_1": 281.74
  },
  {
    "#": "630 Hammond St, Unit 101 G19-20 (432-12-17)",
    "$": 1219700,
    "address": "630 Hammond St, Unit 101 G19-20",
    "parcel_id": "432-12-17",
    "owner1": "RANDO, JOANNE M",
    "owner2": "",
    "current_taxes": 8854.79,
    "new_taxes_no_override": 9237.32,
    "override_total_1": 9499.42,
    "override_increase_1": 262.1
  },
  {
    "#": "630 Hammond St, Unit 102 P39&40 (432-12-18)",
    "$": 1222500,
    "address": "630 Hammond St, Unit 102 P39&40",
    "parcel_id": "432-12-18",
    "owner1": "GOODMAN, MICHELLE H",
    "owner2": "",
    "current_taxes": 8883.47,
    "new_taxes_no_override": 9267.24,
    "override_total_1": 9530.19,
    "override_increase_1": 262.95
  },
  {
    "#": "630 Hammond St, Unit 103 P12&13 (432-12-19)",
    "$": 1359100,
    "address": "630 Hammond St, Unit 103 P12&13",
    "parcel_id": "432-12-19",
    "owner1": "STENGEL TR, HOLLY",
    "owner2": "",
    "current_taxes": 10282.25,
    "new_taxes_no_override": 10726.44,
    "override_total_1": 11030.8,
    "override_increase_1": 304.35
  },
  {
    "#": "630 Hammond St, Unit 104 G17&18 (432-12-20)",
    "$": 1207900,
    "address": "630 Hammond St, Unit 104 G17&18",
    "parcel_id": "432-12-20",
    "owner1": "DROOKER TRS, STEVEN & GENNA B",
    "owner2": "",
    "current_taxes": 12368.9,
    "new_taxes_no_override": 12903.24,
    "override_total_1": 13269.36,
    "override_increase_1": 366.12
  },
  {
    "#": "630 Hammond St, Unit 105 & G43 (432-12-21)",
    "$": 373800,
    "address": "630 Hammond St, Unit 105 & G43",
    "parcel_id": "432-12-21",
    "owner1": "LOPCI, SAIMIR",
    "owner2": "",
    "current_taxes": 382.77,
    "new_taxes_no_override": 399.31,
    "override_total_1": 410.64,
    "override_increase_1": 11.33
  },
  {
    "#": "630 Hammond St, Unit 106 & G24 (432-12-22)",
    "$": 370200,
    "address": "630 Hammond St, Unit 106 & G24",
    "parcel_id": "432-12-22",
    "owner1": "KNAUF, KRISTINE L",
    "owner2": "",
    "current_taxes": 379.08,
    "new_taxes_no_override": 395.46,
    "override_total_1": 406.68,
    "override_increase_1": 11.22
  },
  {
    "#": "630 Hammond St, Unit 107 G25-26 (432-12-23)",
    "$": 1224100,
    "address": "630 Hammond St, Unit 107 G25-26",
    "parcel_id": "432-12-23",
    "owner1": "WRICK TRS, KATHIE L",
    "owner2": "LURIA, CAROL A",
    "current_taxes": 8899.85,
    "new_taxes_no_override": 9284.32,
    "override_total_1": 9547.76,
    "override_increase_1": 263.44
  },
  {
    "#": "630 Hammond St, Unit 108 P14&15 (432-12-24)",
    "$": 1325500,
    "address": "630 Hammond St, Unit 108 P14&15",
    "parcel_id": "432-12-24",
    "owner1": "KUTIN TRS, MARILYN & JOSHUA",
    "owner2": "",
    "current_taxes": 9938.19,
    "new_taxes_no_override": 10367.52,
    "override_total_1": 10661.69,
    "override_increase_1": 294.17
  },
  {
    "#": "630 Hammond St, Unit 109 G9-36 (432-12-25)",
    "$": 1083200,
    "address": "630 Hammond St, Unit 109 G9-36",
    "parcel_id": "432-12-25",
    "owner1": "LEE TR, SUSANNA M",
    "owner2": "",
    "current_taxes": 7457.03,
    "new_taxes_no_override": 7779.17,
    "override_total_1": 7999.9,
    "override_increase_1": 220.73
  },
  {
    "#": "630 Hammond St, Unit 201 G6-50 (432-12-26)",
    "$": 1252400,
    "address": "630 Hammond St, Unit 201 G6-50",
    "parcel_id": "432-12-26",
    "owner1": "GORDON, TRS, CLAIRE L",
    "owner2": "",
    "current_taxes": 12824.58,
    "new_taxes_no_override": 13378.6,
    "override_total_1": 13758.21,
    "override_increase_1": 379.61
  },
  {
    "#": "630 Hammond St, Unit 202&G2-3 (432-12-27)",
    "$": 1252400,
    "address": "630 Hammond St, Unit 202&G2-3",
    "parcel_id": "432-12-27",
    "owner1": "GARR TR, PHYLLIS J",
    "owner2": "",
    "current_taxes": 9189.64,
    "new_taxes_no_override": 9586.63,
    "override_total_1": 9858.65,
    "override_increase_1": 272.01
  },
  {
    "#": "630 Hammond St, Unit 203 P21&22 (432-12-28)",
    "$": 1361100,
    "address": "630 Hammond St, Unit 203 P21&22",
    "parcel_id": "432-12-28",
    "owner1": "WU, QIONG",
    "owner2": "",
    "current_taxes": 13937.66,
    "new_taxes_no_override": 14539.77,
    "override_total_1": 14952.32,
    "override_increase_1": 412.55
  },
  {
    "#": "630 Hammond St, Unit 204 G7 G16 (432-12-29)",
    "$": 1207800,
    "address": "630 Hammond St, Unit 204 G7 G16",
    "parcel_id": "432-12-29",
    "owner1": "GIARDINO, ANGELA",
    "owner2": "",
    "current_taxes": 8732.94,
    "new_taxes_no_override": 9110.2,
    "override_total_1": 9368.7,
    "override_increase_1": 258.5
  },
  {
    "#": "630 Hammond St, Unit 205 G32-33 (432-12-30)",
    "$": 1038900,
    "address": "630 Hammond St, Unit 205 G32-33",
    "parcel_id": "432-12-30",
    "owner1": "WEI, LI",
    "owner2": "",
    "current_taxes": 10638.34,
    "new_taxes_no_override": 11097.92,
    "override_total_1": 11412.81,
    "override_increase_1": 314.89
  },
  {
    "#": "630 Hammond St, Unit 206 & G5 (432-12-31)",
    "$": 370200,
    "address": "630 Hammond St, Unit 206 & G5",
    "parcel_id": "432-12-31",
    "owner1": "ZAYSTEV, MIKHAIL & INESSA",
    "owner2": "",
    "current_taxes": 379.08,
    "new_taxes_no_override": 395.46,
    "override_total_1": 406.68,
    "override_increase_1": 11.22
  },
  {
    "#": "630 Hammond St, Unit 207 G10-11 (432-12-32)",
    "$": 1224100,
    "address": "630 Hammond St, Unit 207 G10-11",
    "parcel_id": "432-12-32",
    "owner1": "ROSEN TR, LENORE J",
    "owner2": "",
    "current_taxes": 8899.85,
    "new_taxes_no_override": 9284.32,
    "override_total_1": 9547.76,
    "override_increase_1": 263.44
  },
  {
    "#": "630 Hammond St, Unit 208 P27&28 (432-12-33)",
    "$": 1333100,
    "address": "630 Hammond St, Unit 208 P27&28",
    "parcel_id": "432-12-33",
    "owner1": "SCHWANBECK TR, JOHN R",
    "owner2": "",
    "current_taxes": 13650.94,
    "new_taxes_no_override": 14240.66,
    "override_total_1": 14644.73,
    "override_increase_1": 404.07
  },
  {
    "#": "630 Hammond St, Unit 209 G48-49 (432-12-34)",
    "$": 1083200,
    "address": "630 Hammond St, Unit 209 G48-49",
    "parcel_id": "432-12-34",
    "owner1": "LEE, KWANG WOO",
    "owner2": "PI, JUNGMIN",
    "current_taxes": 11091.97,
    "new_taxes_no_override": 11571.14,
    "override_total_1": 11899.47,
    "override_increase_1": 328.32
  },
  {
    "#": "630 Hammond St, Unit 301 P41&42 (432-12-35)",
    "$": 1997300,
    "address": "630 Hammond St, Unit 301 P41&42",
    "parcel_id": "432-12-35",
    "owner1": "MOHR TR, DOROTHY N",
    "owner2": "",
    "current_taxes": 16817.42,
    "new_taxes_no_override": 17543.93,
    "override_total_1": 18041.73,
    "override_increase_1": 497.8
  },
  {
    "#": "630 Hammond St, Unit 302 G29-30 (432-12-36)",
    "$": 2227900,
    "address": "630 Hammond St, Unit 302 G29-30",
    "parcel_id": "432-12-36",
    "owner1": "BRODY TRS, LAURENCE H & PHYLLIS H",
    "owner2": "",
    "current_taxes": 19178.76,
    "new_taxes_no_override": 20007.28,
    "override_total_1": 20574.97,
    "override_increase_1": 567.69
  },
  {
    "#": "630 Hammond St, Unit 303&G44&45 (432-12-37)",
    "$": 1438300,
    "address": "630 Hammond St, Unit 303&G44&45",
    "parcel_id": "432-12-37",
    "owner1": "DAVIS LIFE ESTATE, BRUCE & MARJORIE D",
    "owner2": "",
    "current_taxes": 11093.26,
    "new_taxes_no_override": 11572.49,
    "override_total_1": 11900.85,
    "override_increase_1": 328.36
  },
  {
    "#": "630 Hammond St, Unit 304 G46-47 (432-12-38)",
    "$": 2037400,
    "address": "630 Hammond St, Unit 304 G46-47",
    "parcel_id": "432-12-38",
    "owner1": "BRESNICK, ALAN P & ELLEN R",
    "owner2": "",
    "current_taxes": 20862.98,
    "new_taxes_no_override": 21764.26,
    "override_total_1": 22381.8,
    "override_increase_1": 617.54
  },
  {
    "#": "630 Hammond St, Unit 305 P37&38 (432-12-39)",
    "$": 1492100,
    "address": "630 Hammond St, Unit 305 P37&38",
    "parcel_id": "432-12-39",
    "owner1": "PRABHU TR, PRASHANT",
    "owner2": "",
    "current_taxes": 15279.1,
    "new_taxes_no_override": 15939.16,
    "override_total_1": 16391.42,
    "override_increase_1": 452.26
  },
  {
    "#": "640 Hammond St, Unit 101 3 Sps (432-10-12)",
    "$": 1683000,
    "address": "640 Hammond St, Unit 101 3 Sps",
    "parcel_id": "432-10-12",
    "owner1": "KARP, MICHAEL & CHARLENE",
    "owner2": "",
    "current_taxes": 13598.99,
    "new_taxes_no_override": 14186.47,
    "override_total_1": 14589.0,
    "override_increase_1": 402.53
  },
  {
    "#": "640 Hammond St, Unit 102&P1-P9 (432-10-13)",
    "$": 2269500,
    "address": "640 Hammond St, Unit 102&P1-P9",
    "parcel_id": "432-10-13",
    "owner1": "KAY, KAREN R & BARRY C",
    "owner2": "",
    "current_taxes": 19604.75,
    "new_taxes_no_override": 20451.68,
    "override_total_1": 21031.98,
    "override_increase_1": 580.3
  },
  {
    "#": "640 Hammond St, Unit 201 G3-G12 (432-10-14)",
    "$": 1749600,
    "address": "640 Hammond St, Unit 201 G3-G12",
    "parcel_id": "432-10-14",
    "owner1": "BALDINI TRS, EDWARD B & ELIZABETH H",
    "owner2": "",
    "current_taxes": 17915.9,
    "new_taxes_no_override": 18689.87,
    "override_total_1": 19220.18,
    "override_increase_1": 530.31
  },
  {
    "#": "640 Hammond St, Unit 202 & G1-5 (432-10-15)",
    "$": 2223400,
    "address": "640 Hammond St, Unit 202 & G1-5",
    "parcel_id": "432-10-15",
    "owner1": "NATHANSON, SINAIA BENOR",
    "owner2": "",
    "current_taxes": 22767.62,
    "new_taxes_no_override": 23751.18,
    "override_total_1": 24425.1,
    "override_increase_1": 673.92
  },
  {
    "#": "640 Hammond St, Unit 301 P6-7 (432-10-16)",
    "$": 1612700,
    "address": "640 Hammond St, Unit 301 P6-7",
    "parcel_id": "432-10-16",
    "owner1": "GRANDBERG TRS, MERLE L & JAMES H",
    "owner2": "",
    "current_taxes": 12879.11,
    "new_taxes_no_override": 13435.49,
    "override_total_1": 13816.71,
    "override_increase_1": 381.22
  },
  {
    "#": "640 Hammond St, Unit 302 & 3 Sp (432-10-17)",
    "$": 2262800,
    "address": "640 Hammond St, Unit 302 & 3 Sp",
    "parcel_id": "432-10-17",
    "owner1": "PALTER TR, ROBERT M",
    "owner2": "",
    "current_taxes": 23171.07,
    "new_taxes_no_override": 24172.06,
    "override_total_1": 24857.92,
    "override_increase_1": 685.86
  },
  {
    "#": "642 Hammond St, Unit 642 (432-10-18)",
    "$": 2110200,
    "address": "642 Hammond St, Unit 642",
    "parcel_id": "432-10-18",
    "owner1": "ABULAF, HAYATI & VERDA",
    "owner2": "",
    "current_taxes": 17973.51,
    "new_taxes_no_override": 18749.97,
    "override_total_1": 19281.98,
    "override_increase_1": 532.02
  },
  {
    "#": "644 Hammond St, Unit 644 (432-10-19)",
    "$": 2112500,
    "address": "644 Hammond St, Unit 644",
    "parcel_id": "432-10-19",
    "owner1": "CHOW, PETER V & ROSANA P",
    "owner2": "",
    "current_taxes": 21632.0,
    "new_taxes_no_override": 22566.5,
    "override_total_1": 23206.81,
    "override_increase_1": 640.31
  },
  {
    "#": "645 Hammond St, Unit 1-2 (429-16-04)",
    "$": 1202600,
    "address": "645 Hammond St, Unit 1-2",
    "parcel_id": "429-16-04",
    "owner1": "ARNOLD, MATTHEW",
    "owner2": "WECHTER, JILL",
    "current_taxes": 8679.69,
    "new_taxes_no_override": 9054.65,
    "override_total_1": 9311.57,
    "override_increase_1": 256.92
  },
  {
    "#": "645 Hammond St, Unit 3 (429-16-03)",
    "$": 879700,
    "address": "645 Hammond St, Unit 3",
    "parcel_id": "429-16-03",
    "owner1": "SHARMA, SHARAD",
    "owner2": "",
    "current_taxes": 5373.19,
    "new_taxes_no_override": 5605.31,
    "override_total_1": 5764.36,
    "override_increase_1": 159.05
  },
  {
    "#": "648 Hammond St, Unit 648 (432-10-20)",
    "$": 1821900,
    "address": "648 Hammond St, Unit 648",
    "parcel_id": "432-10-20",
    "owner1": "PFEFFER, RUBIN",
    "owner2": "",
    "current_taxes": 18656.26,
    "new_taxes_no_override": 19462.21,
    "override_total_1": 20014.44,
    "override_increase_1": 552.23
  },
  {
    "#": "652 Hammond St (432-08-00)",
    "$": 22537500,
    "address": "652 Hammond St",
    "parcel_id": "432-08-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O SOULE RECREATION CENTER",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "655 Hammond St (429-18-00)",
    "$": 1293900,
    "address": "655 Hammond St",
    "parcel_id": "429-18-00",
    "owner1": "KENNEY TR, CHRISTA M",
    "owner2": "",
    "current_taxes": 9614.6,
    "new_taxes_no_override": 10029.95,
    "override_total_1": 10314.54,
    "override_increase_1": 284.59
  },
  {
    "#": "661 Hammond St (429-19-00)",
    "$": 1206600,
    "address": "661 Hammond St",
    "parcel_id": "429-19-00",
    "owner1": "CHEN, LI FEN & WEI XIAO",
    "owner2": "",
    "current_taxes": 12355.58,
    "new_taxes_no_override": 12889.34,
    "override_total_1": 13255.07,
    "override_increase_1": 365.73
  },
  {
    "#": "663 Hammond St (429-17-00)",
    "$": 1164100,
    "address": "663 Hammond St",
    "parcel_id": "429-17-00",
    "owner1": "KENNEY TR, CHRISTA M",
    "owner2": "",
    "current_taxes": 11920.38,
    "new_taxes_no_override": 12435.34,
    "override_total_1": 12788.18,
    "override_increase_1": 352.84
  },
  {
    "#": "665 Hammond St (429-20-00)",
    "$": 1265200,
    "address": "665 Hammond St",
    "parcel_id": "429-20-00",
    "owner1": "WONG, RONALD",
    "owner2": "LEE, ANNY",
    "current_taxes": 12955.65,
    "new_taxes_no_override": 13515.33,
    "override_total_1": 13898.82,
    "override_increase_1": 383.49
  },
  {
    "#": "671 Hammond St (429-21-00)",
    "$": 1341000,
    "address": "671 Hammond St",
    "parcel_id": "429-21-00",
    "owner1": "CHOU, CHARLES",
    "owner2": "HUANG, RIMING",
    "current_taxes": 10096.91,
    "new_taxes_no_override": 10533.1,
    "override_total_1": 10831.97,
    "override_increase_1": 298.87
  },
  {
    "#": "673 Hammond St (429-21-01)",
    "$": 1195400,
    "address": "673 Hammond St",
    "parcel_id": "429-21-01",
    "owner1": "LI, YIZHEN",
    "owner2": "",
    "current_taxes": 8605.96,
    "new_taxes_no_override": 8977.74,
    "override_total_1": 9232.47,
    "override_increase_1": 254.74
  },
  {
    "#": "675 Hammond St, Unit 1 (429-22-05)",
    "$": 758100,
    "address": "675 Hammond St, Unit 1",
    "parcel_id": "429-22-05",
    "owner1": "CLINTON, LEROY",
    "owner2": "RODRIGUEZ, ADRIANA",
    "current_taxes": 4128.01,
    "new_taxes_no_override": 4306.34,
    "override_total_1": 4428.53,
    "override_increase_1": 122.19
  },
  {
    "#": "675 Hammond St, Unit 2 & P2 (429-22-03)",
    "$": 752500,
    "address": "675 Hammond St, Unit 2 & P2",
    "parcel_id": "429-22-03",
    "owner1": "FITCHOROV, IVAN & RAINA N",
    "owner2": "",
    "current_taxes": 4070.67,
    "new_taxes_no_override": 4246.52,
    "override_total_1": 4367.01,
    "override_increase_1": 120.49
  },
  {
    "#": "675 Hammond St, Unit 3 (429-22-04)",
    "$": 1102900,
    "address": "675 Hammond St, Unit 3",
    "parcel_id": "429-22-04",
    "owner1": "IKONNE, SYLVIA I",
    "owner2": "",
    "current_taxes": 7658.76,
    "new_taxes_no_override": 7989.62,
    "override_total_1": 8216.32,
    "override_increase_1": 226.7
  },
  {
    "#": "675 Hammond St (429-22-01)",
    "$": 1253900,
    "address": "675 Hammond St",
    "parcel_id": "429-22-01",
    "owner1": "LEE, DANIEL & JULIA",
    "owner2": "",
    "current_taxes": 9205.0,
    "new_taxes_no_override": 9602.66,
    "override_total_1": 9875.12,
    "override_increase_1": 272.47
  },
  {
    "#": "676 Hammond St (432-36-00)",
    "$": 2414700,
    "address": "676 Hammond St",
    "parcel_id": "432-36-00",
    "owner1": "JOSEPH, HUGH M",
    "owner2": "BRUNT, MELANIE J",
    "current_taxes": 21091.59,
    "new_taxes_no_override": 22002.75,
    "override_total_1": 22627.06,
    "override_increase_1": 624.31
  },
  {
    "#": "677 Hammond St (429-22-02)",
    "$": 1251900,
    "address": "677 Hammond St",
    "parcel_id": "429-22-02",
    "owner1": "NUGENT, YOLITA C",
    "owner2": "WHITON, ADAM M",
    "current_taxes": 9184.52,
    "new_taxes_no_override": 9581.29,
    "override_total_1": 9853.15,
    "override_increase_1": 271.86
  },
  {
    "#": "679 Hammond St, Unit A (429-26-00)",
    "$": 44300,
    "address": "679 Hammond St, Unit A",
    "parcel_id": "429-26-00",
    "owner1": "ROURKE JR, JAMES C",
    "owner2": "",
    "current_taxes": 453.63,
    "new_taxes_no_override": 473.23,
    "override_total_1": 486.65,
    "override_increase_1": 13.43
  },
  {
    "#": "679 Hammond St (429-25-00)",
    "$": 981800,
    "address": "679 Hammond St",
    "parcel_id": "429-25-00",
    "owner1": "ROURKE JR, JAMES C",
    "owner2": "",
    "current_taxes": 6418.7,
    "new_taxes_no_override": 6695.99,
    "override_total_1": 6885.98,
    "override_increase_1": 189.99
  },
  {
    "#": "681 Hammond St, Unit  683A (429-23-03)",
    "$": 1986900,
    "address": "681 Hammond St, Unit  683A",
    "parcel_id": "429-23-03",
    "owner1": "GATES TRS, PETER R & DEBORAH M",
    "owner2": "",
    "current_taxes": 16710.92,
    "new_taxes_no_override": 17432.83,
    "override_total_1": 17927.47,
    "override_increase_1": 494.64
  },
  {
    "#": "681 Hammond St, Unit 681A (429-23-01)",
    "$": 2016600,
    "address": "681 Hammond St, Unit 681A",
    "parcel_id": "429-23-01",
    "owner1": "MARQUSEE TR, JOANNE",
    "owner2": "",
    "current_taxes": 17015.05,
    "new_taxes_no_override": 17750.1,
    "override_total_1": 18253.75,
    "override_increase_1": 503.65
  },
  {
    "#": "681 Hammond St, Unit 681B (429-23-02)",
    "$": 1949700,
    "address": "681 Hammond St, Unit 681B",
    "parcel_id": "429-23-02",
    "owner1": "NURME, LISA B",
    "owner2": "",
    "current_taxes": 16329.99,
    "new_taxes_no_override": 17035.45,
    "override_total_1": 17518.81,
    "override_increase_1": 483.37
  },
  {
    "#": "681 Hammond St, Unit 683B (429-23-04)",
    "$": 1996300,
    "address": "681 Hammond St, Unit 683B",
    "parcel_id": "429-23-04",
    "owner1": "BERMAN TRS, HENRY L & CAROLE B",
    "owner2": "",
    "current_taxes": 16807.18,
    "new_taxes_no_override": 17533.25,
    "override_total_1": 18030.74,
    "override_increase_1": 497.49
  },
  {
    "#": "682 Hammond St (432-35-00)",
    "$": 5338800,
    "address": "682 Hammond St",
    "parcel_id": "432-35-00",
    "owner1": "SCIACCA TRS, KIMBERLY A & RICHARD J",
    "owner2": "",
    "current_taxes": 54669.31,
    "new_taxes_no_override": 57031.02,
    "override_total_1": 58649.24,
    "override_increase_1": 1618.21
  },
  {
    "#": "686 Hammond St (432-34-00)",
    "$": 2843700,
    "address": "686 Hammond St",
    "parcel_id": "432-34-00",
    "owner1": "KRAFT, JONATHAN A & PATRICIA L",
    "owner2": "C/O THE KRAFT GROUP",
    "current_taxes": 29119.49,
    "new_taxes_no_override": 30377.45,
    "override_total_1": 31239.39,
    "override_increase_1": 861.94
  },
  {
    "#": "687 Hammond St (429-29-00)",
    "$": 1296300,
    "address": "687 Hammond St",
    "parcel_id": "429-29-00",
    "owner1": "LEUNG ET AL, RICHARD C",
    "owner2": "C/O YEE LAI HA",
    "current_taxes": 13274.11,
    "new_taxes_no_override": 13847.55,
    "override_total_1": 14240.47,
    "override_increase_1": 392.91
  },
  {
    "#": "689 Hammond St, Unit 1 (429-30-01)",
    "$": 1492200,
    "address": "689 Hammond St, Unit 1",
    "parcel_id": "429-30-01",
    "owner1": "CHADBOURNE, MARK E",
    "owner2": "",
    "current_taxes": 11645.19,
    "new_taxes_no_override": 12148.26,
    "override_total_1": 12492.96,
    "override_increase_1": 344.7
  },
  {
    "#": "689 Hammond St, Unit 2 (429-30-02)",
    "$": 1674900,
    "address": "689 Hammond St, Unit 2",
    "parcel_id": "429-30-02",
    "owner1": "ELBERT, ALEC M & VERONIKA",
    "owner2": "",
    "current_taxes": 13516.04,
    "new_taxes_no_override": 14099.93,
    "override_total_1": 14500.01,
    "override_increase_1": 400.07
  },
  {
    "#": "693 Hammond St, Unit 1 (429-31-04)",
    "$": 1125500,
    "address": "693 Hammond St, Unit 1",
    "parcel_id": "429-31-04",
    "owner1": "GEORGE, DIANNE KAY",
    "owner2": "",
    "current_taxes": 7890.19,
    "new_taxes_no_override": 8231.05,
    "override_total_1": 8464.6,
    "override_increase_1": 233.55
  },
  {
    "#": "695 Hammond St, Unit 2 (429-31-01)",
    "$": 1125500,
    "address": "695 Hammond St, Unit 2",
    "parcel_id": "429-31-01",
    "owner1": "BESIN, GILLES",
    "owner2": "DESAULLE, INGRID",
    "current_taxes": 7890.19,
    "new_taxes_no_override": 8231.05,
    "override_total_1": 8464.6,
    "override_increase_1": 233.55
  },
  {
    "#": "697 Hammond St, Unit 3 (429-31-02)",
    "$": 1136500,
    "address": "697 Hammond St, Unit 3",
    "parcel_id": "429-31-02",
    "owner1": "ERRISHI, ALI & MADELINE",
    "owner2": "",
    "current_taxes": 11637.76,
    "new_taxes_no_override": 12140.51,
    "override_total_1": 12484.99,
    "override_increase_1": 344.48
  },
  {
    "#": "699 Hammond St, Unit 4 (429-31-03)",
    "$": 1123600,
    "address": "699 Hammond St, Unit 4",
    "parcel_id": "429-31-03",
    "owner1": "BURKE, PHILIP",
    "owner2": "",
    "current_taxes": 7870.73,
    "new_taxes_no_override": 8210.75,
    "override_total_1": 8443.72,
    "override_increase_1": 232.97
  },
  {
    "#": "701 Hammond St (429-44-00)",
    "$": 1508500,
    "address": "701 Hammond St",
    "parcel_id": "429-44-00",
    "owner1": "PAK, TO HYONG",
    "owner2": "CHUNG, CHUN HEE",
    "current_taxes": 11812.11,
    "new_taxes_no_override": 12322.39,
    "override_total_1": 12672.03,
    "override_increase_1": 349.64
  },
  {
    "#": "705 Hammond St, Unit 1 (429-34-01)",
    "$": 1747100,
    "address": "705 Hammond St, Unit 1",
    "parcel_id": "429-34-01",
    "owner1": "BENJAMIN, DAVID",
    "owner2": "HUANG, SICONG",
    "current_taxes": 17890.3,
    "new_taxes_no_override": 18663.16,
    "override_total_1": 19192.71,
    "override_increase_1": 529.55
  },
  {
    "#": "705 Hammond St, Unit 2 (429-34-02)",
    "$": 1790000,
    "address": "705 Hammond St, Unit 2",
    "parcel_id": "429-34-02",
    "owner1": "JACOBS, KATHLEEN",
    "owner2": "",
    "current_taxes": 18329.6,
    "new_taxes_no_override": 19121.44,
    "override_total_1": 19663.99,
    "override_increase_1": 542.56
  },
  {
    "#": "709 Hammond St (429-35-00)",
    "$": 2260500,
    "address": "709 Hammond St",
    "parcel_id": "429-35-00",
    "owner1": "SHABELSKY TRS, ALEX & LARISA",
    "owner2": "",
    "current_taxes": 23147.52,
    "new_taxes_no_override": 24147.49,
    "override_total_1": 24832.66,
    "override_increase_1": 685.17
  },
  {
    "#": "715 Hammond St, Unit 8 (429-36-08)",
    "$": 631900,
    "address": "715 Hammond St, Unit 8",
    "parcel_id": "429-36-08",
    "owner1": "JHA, SAKET & MEENAKSHI",
    "owner2": "",
    "current_taxes": 6470.66,
    "new_taxes_no_override": 6750.19,
    "override_total_1": 6941.72,
    "override_increase_1": 191.53
  },
  {
    "#": "717 Hammond St, Unit 7 (429-36-01)",
    "$": 675400,
    "address": "717 Hammond St, Unit 7",
    "parcel_id": "429-36-01",
    "owner1": "BUGBEE, FRANCES",
    "owner2": "",
    "current_taxes": 6916.1,
    "new_taxes_no_override": 7214.88,
    "override_total_1": 7419.59,
    "override_increase_1": 204.72
  },
  {
    "#": "719 Hammond St, Unit 6 (429-36-02)",
    "$": 707000,
    "address": "719 Hammond St, Unit 6",
    "parcel_id": "429-36-02",
    "owner1": "HONG, MINKI",
    "owner2": "LEE, HANNA",
    "current_taxes": 3604.75,
    "new_taxes_no_override": 3760.48,
    "override_total_1": 3867.18,
    "override_increase_1": 106.7
  },
  {
    "#": "721 Hammond St, Unit 5 (429-36-03)",
    "$": 713200,
    "address": "721 Hammond St, Unit 5",
    "parcel_id": "429-36-03",
    "owner1": "SOLODIUK, JOSEPH N & JEAN C",
    "owner2": "",
    "current_taxes": 7303.17,
    "new_taxes_no_override": 7618.67,
    "override_total_1": 7834.84,
    "override_increase_1": 216.17
  },
  {
    "#": "723 Hammond St, Unit 4 (429-36-04)",
    "$": 705000,
    "address": "723 Hammond St, Unit 4",
    "parcel_id": "429-36-04",
    "owner1": "IRUSA, KARINA F",
    "owner2": "DONAVAN, TERENCE E",
    "current_taxes": 7219.2,
    "new_taxes_no_override": 7531.07,
    "override_total_1": 7744.76,
    "override_increase_1": 213.69
  },
  {
    "#": "725 Hammond St, Unit 3 (429-36-05)",
    "$": 700700,
    "address": "725 Hammond St, Unit 3",
    "parcel_id": "429-36-05",
    "owner1": "BYRD TR, WILLIAM W",
    "owner2": "",
    "current_taxes": 3540.23,
    "new_taxes_no_override": 3693.17,
    "override_total_1": 3797.96,
    "override_increase_1": 104.79
  },
  {
    "#": "727 Hammond St, Unit 2 (429-36-06)",
    "$": 655500,
    "address": "727 Hammond St, Unit 2",
    "parcel_id": "429-36-06",
    "owner1": "LEE, LAI FONG & NIGEL",
    "owner2": "",
    "current_taxes": 3077.39,
    "new_taxes_no_override": 3210.33,
    "override_total_1": 3301.42,
    "override_increase_1": 91.09
  },
  {
    "#": "729 Hammond St, Unit 1 (429-36-07)",
    "$": 542200,
    "address": "729 Hammond St, Unit 1",
    "parcel_id": "429-36-07",
    "owner1": "TURNER, JULIET",
    "owner2": "",
    "current_taxes": 5552.13,
    "new_taxes_no_override": 5791.98,
    "override_total_1": 5956.33,
    "override_increase_1": 164.34
  },
  {
    "#": "750 Hammond St (430-04-02)",
    "$": 3651600,
    "address": "750 Hammond St",
    "parcel_id": "430-04-02",
    "owner1": "SAMAD, TAREK A",
    "owner2": "RAYES, NATHALIE",
    "current_taxes": 37392.38,
    "new_taxes_no_override": 39007.73,
    "override_total_1": 40114.55,
    "override_increase_1": 1106.81
  },
  {
    "#": "756 Hammond St (430-04-01)",
    "$": 2319100,
    "address": "756 Hammond St",
    "parcel_id": "430-04-01",
    "owner1": "WINSTEN, JAY A",
    "owner2": "GREENE, PENELOPE J",
    "current_taxes": 20112.65,
    "new_taxes_no_override": 20981.52,
    "override_total_1": 21576.85,
    "override_increase_1": 595.33
  },
  {
    "#": "764 Hammond St (430-04-00)",
    "$": 2195800,
    "address": "764 Hammond St",
    "parcel_id": "430-04-00",
    "owner1": "FELDMAN TRS, BARRY A",
    "owner2": "",
    "current_taxes": 22484.99,
    "new_taxes_no_override": 23456.34,
    "override_total_1": 24121.9,
    "override_increase_1": 665.56
  },
  {
    "#": "791 Hammond St, Unit Rear (422-01-03)",
    "$": 2667600,
    "address": "791 Hammond St, Unit Rear",
    "parcel_id": "422-01-03",
    "owner1": "BEAVER COUNTRY DAY SCHOOL INC",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "791 Hammond St (429-37-39)",
    "$": 61451600,
    "address": "791 Hammond St",
    "parcel_id": "429-37-39",
    "owner1": "BEAVER COUNTRY DAY SCHOOL INC",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "796 Hammond St (441-47-00)",
    "$": 18402700,
    "address": "796 Hammond St",
    "parcel_id": "441-47-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O DANE PARK",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "811 Hammond St (420-04-00)",
    "$": 2219400,
    "address": "811 Hammond St",
    "parcel_id": "420-04-00",
    "owner1": "RITTENBERG, JON & ARDASHA",
    "owner2": "",
    "current_taxes": 19091.72,
    "new_taxes_no_override": 19916.48,
    "override_total_1": 20481.6,
    "override_increase_1": 565.11
  },
  {
    "#": "828 Hammond St (441-45-01)",
    "$": 2963500,
    "address": "828 Hammond St",
    "parcel_id": "441-45-01",
    "owner1": "ORLIN, JAMES B",
    "owner2": "PALERMO, LARK JUREV",
    "current_taxes": 30346.24,
    "new_taxes_no_override": 31657.2,
    "override_total_1": 32555.45,
    "override_increase_1": 898.25
  },
  {
    "#": "849 Hammond St (419B-17-00)",
    "$": 2603000,
    "address": "849 Hammond St",
    "parcel_id": "419B-17-00",
    "owner1": "WANG, WEI",
    "owner2": "",
    "current_taxes": 23019.79,
    "new_taxes_no_override": 24014.24,
    "override_total_1": 24695.63,
    "override_increase_1": 681.39
  },
  {
    "#": "854 Hammond St (441-46-00)",
    "$": 2763100,
    "address": "854 Hammond St",
    "parcel_id": "441-46-00",
    "owner1": "NANGLE, RICHARD A",
    "owner2": "FLANAGAN, JANE M",
    "current_taxes": 24659.21,
    "new_taxes_no_override": 25724.49,
    "override_total_1": 26454.4,
    "override_increase_1": 729.91
  },
  {
    "#": "856 Hammond St (441-45-00)",
    "$": 3722700,
    "address": "856 Hammond St",
    "parcel_id": "441-45-00",
    "owner1": "NEGRON, JOSE & DOMINIKA KOVACS",
    "owner2": "",
    "current_taxes": 38120.45,
    "new_taxes_no_override": 39767.25,
    "override_total_1": 40895.62,
    "override_increase_1": 1128.37
  },
  {
    "#": "860 Hammond St (441-44-00)",
    "$": 10601100,
    "address": "860 Hammond St",
    "parcel_id": "441-44-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O DANE PARK",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "870 Hammond St (441-43-00)",
    "$": 26210400,
    "address": "870 Hammond St",
    "parcel_id": "441-43-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O DPW GARAGE",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "895 Hammond St (419A-05-00)",
    "$": 3786600,
    "address": "895 Hammond St",
    "parcel_id": "419A-05-00",
    "owner1": "BRUNN, CARSTEN & NUNTAWADEE",
    "owner2": "",
    "current_taxes": 38774.78,
    "new_taxes_no_override": 40449.85,
    "override_total_1": 41597.58,
    "override_increase_1": 1147.73
  },
  {
    "#": "905 Hammond St (419A-04-00)",
    "$": 3974000,
    "address": "905 Hammond St",
    "parcel_id": "419A-04-00",
    "owner1": "HUNTSMAN, CAROLE A",
    "owner2": "",
    "current_taxes": 40693.76,
    "new_taxes_no_override": 42451.73,
    "override_total_1": 43656.27,
    "override_increase_1": 1204.54
  },
  {
    "#": "935 Hammond St (419-10-00)",
    "$": 1943600,
    "address": "935 Hammond St",
    "parcel_id": "419-10-00",
    "owner1": "CARR TRS, DANIEL B",
    "owner2": "",
    "current_taxes": 19902.46,
    "new_taxes_no_override": 20762.25,
    "override_total_1": 21351.36,
    "override_increase_1": 589.11
  },
  {
    "#": "945 Hammond St (419-09-00)",
    "$": 1985500,
    "address": "945 Hammond St",
    "parcel_id": "419-09-00",
    "owner1": "RONA, ILYAS J & C ANGELICA",
    "owner2": "",
    "current_taxes": 20331.52,
    "new_taxes_no_override": 21209.84,
    "override_total_1": 21811.65,
    "override_increase_1": 601.81
  },
  {
    "#": "955 Hammond St (419-08-00)",
    "$": 2480500,
    "address": "955 Hammond St",
    "parcel_id": "419-08-00",
    "owner1": "GHOBBEH, FARSHAD",
    "owner2": "AMIRIFELI, SEPIDEH",
    "current_taxes": 25400.32,
    "new_taxes_no_override": 26497.61,
    "override_total_1": 27249.46,
    "override_increase_1": 751.85
  },
  {
    "#": "962 Hammond St (441-42-00)",
    "$": 7698800,
    "address": "962 Hammond St",
    "parcel_id": "441-42-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O FIRE STATION #6",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "965 Hammond St (419-07-00)",
    "$": 1984400,
    "address": "965 Hammond St",
    "parcel_id": "419-07-00",
    "owner1": "DELANY, ELIAS S & DEBORAH HOPE",
    "owner2": "",
    "current_taxes": 20320.26,
    "new_taxes_no_override": 21198.1,
    "override_total_1": 21799.57,
    "override_increase_1": 601.48
  },
  {
    "#": "10 Hancock Rd (208-25-00)",
    "$": 2986800,
    "address": "10 Hancock Rd",
    "parcel_id": "208-25-00",
    "owner1": "ERDMAN, CHRISTOPHER & ELIZABETH",
    "owner2": "",
    "current_taxes": 26949.9,
    "new_taxes_no_override": 28114.14,
    "override_total_1": 28911.85,
    "override_increase_1": 797.72
  },
  {
    "#": "15 Hancock Rd (208-19-00)",
    "$": 2939300,
    "address": "15 Hancock Rd",
    "parcel_id": "208-19-00",
    "owner1": "BLACKBURN, DAVID T & KARA F",
    "owner2": "",
    "current_taxes": 30098.43,
    "new_taxes_no_override": 31398.68,
    "override_total_1": 32289.6,
    "override_increase_1": 890.91
  },
  {
    "#": "16 Hancock Rd (208-23-24)",
    "$": 2724400,
    "address": "16 Hancock Rd",
    "parcel_id": "208-23-24",
    "owner1": "BOURNE ET AL TRS, RICHARD B JR",
    "owner2": "",
    "current_taxes": 27897.86,
    "new_taxes_no_override": 29103.05,
    "override_total_1": 29928.82,
    "override_increase_1": 825.78
  },
  {
    "#": "17 Hancock Rd (208-20-00)",
    "$": 2409900,
    "address": "17 Hancock Rd",
    "parcel_id": "208-20-00",
    "owner1": "STEIN TR, ROSANNE W",
    "owner2": "",
    "current_taxes": 24677.38,
    "new_taxes_no_override": 25743.44,
    "override_total_1": 26473.89,
    "override_increase_1": 730.45
  },
  {
    "#": "21 Hancock Rd (208-21-00)",
    "$": 2561800,
    "address": "21 Hancock Rd",
    "parcel_id": "208-21-00",
    "owner1": "SOKOLOFF TRS, MIRIAM K & JEFFREY B",
    "owner2": "",
    "current_taxes": 22597.9,
    "new_taxes_no_override": 23574.13,
    "override_total_1": 24243.03,
    "override_increase_1": 668.9
  },
  {
    "#": "22 Hancock Rd (208-22-00)",
    "$": 4635300,
    "address": "22 Hancock Rd",
    "parcel_id": "208-22-00",
    "owner1": "LEI, XIAOYU",
    "owner2": "WEI, JIAQI",
    "current_taxes": 43830.54,
    "new_taxes_no_override": 45724.02,
    "override_total_1": 47021.4,
    "override_increase_1": 1297.38
  },
  {
    "#": "11 Harris St (168-02-00)",
    "$": 3080300,
    "address": "11 Harris St",
    "parcel_id": "168-02-00",
    "owner1": "BROOKLINE HOUSING AUTHORITY",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "12 Harris St (169-22-00)",
    "$": 3856900,
    "address": "12 Harris St",
    "parcel_id": "169-22-00",
    "owner1": "NORA LLC",
    "owner2": "",
    "current_taxes": 39494.66,
    "new_taxes_no_override": 41200.83,
    "override_total_1": 42369.87,
    "override_increase_1": 1169.04
  },
  {
    "#": "16 Harris St (169-21-00)",
    "$": 2197600,
    "address": "16 Harris St",
    "parcel_id": "169-21-00",
    "owner1": "KROIN, ROBERT",
    "owner2": "",
    "current_taxes": 18868.49,
    "new_taxes_no_override": 19683.61,
    "override_total_1": 20242.12,
    "override_increase_1": 558.51
  },
  {
    "#": "17 Harris St (168-03-00)",
    "$": 2223700,
    "address": "17 Harris St",
    "parcel_id": "168-03-00",
    "owner1": "PAN, YE",
    "owner2": "SHI, BIN",
    "current_taxes": 19135.75,
    "new_taxes_no_override": 19962.41,
    "override_total_1": 20528.83,
    "override_increase_1": 566.42
  },
  {
    "#": "19 Harris St, Unit 1&P2-3-4 (168-04-01)",
    "$": 3125300,
    "address": "19 Harris St, Unit 1&P2-3-4",
    "parcel_id": "168-04-01",
    "owner1": "SCHARF, RON",
    "owner2": "SCHULTZ, AYLIT T",
    "current_taxes": 28368.14,
    "new_taxes_no_override": 29593.64,
    "override_total_1": 30433.34,
    "override_increase_1": 839.7
  },
  {
    "#": "19 Harris St, Unit 2 & P1 (168-04-02)",
    "$": 1461700,
    "address": "19 Harris St, Unit 2 & P1",
    "parcel_id": "168-04-02",
    "owner1": "PARK, JIHWAN",
    "owner2": "LEE, YOUNGEUN",
    "current_taxes": 11332.87,
    "new_taxes_no_override": 11822.45,
    "override_total_1": 12157.9,
    "override_increase_1": 335.45
  },
  {
    "#": "21 Harris St (168-05-00)",
    "$": 2583500,
    "address": "21 Harris St",
    "parcel_id": "168-05-00",
    "owner1": "HEFFAN, IRA V & DEBORAH S",
    "owner2": "",
    "current_taxes": 22820.11,
    "new_taxes_no_override": 23805.94,
    "override_total_1": 24481.41,
    "override_increase_1": 675.48
  },
  {
    "#": "22 Harris St (169-20-00)",
    "$": 2084800,
    "address": "22 Harris St",
    "parcel_id": "169-20-00",
    "owner1": "JEFFERIES TRS, MICHAEL JOHN & MARY ANN",
    "owner2": "",
    "current_taxes": 21348.35,
    "new_taxes_no_override": 22270.6,
    "override_total_1": 22902.51,
    "override_increase_1": 631.91
  },
  {
    "#": "23 Harris St (168-06-00)",
    "$": 2392900,
    "address": "23 Harris St",
    "parcel_id": "168-06-00",
    "owner1": "GROSSMAN, EVAN O & WENDY S",
    "owner2": "",
    "current_taxes": 20868.36,
    "new_taxes_no_override": 21769.87,
    "override_total_1": 22387.58,
    "override_increase_1": 617.7
  },
  {
    "#": "24 Harris St (169-19-00)",
    "$": 2830000,
    "address": "24 Harris St",
    "parcel_id": "169-19-00",
    "owner1": "CORMAN, JULIE E & DEVORA",
    "owner2": "",
    "current_taxes": 25344.27,
    "new_taxes_no_override": 26439.14,
    "override_total_1": 27189.33,
    "override_increase_1": 750.19
  },
  {
    "#": "28 Harris St (169-18-00)",
    "$": 1841400,
    "address": "28 Harris St",
    "parcel_id": "169-18-00",
    "owner1": "WONG LIFE ESTATE, DIANA",
    "owner2": "",
    "current_taxes": 15221.0,
    "new_taxes_no_override": 15878.55,
    "override_total_1": 16329.09,
    "override_increase_1": 450.54
  },
  {
    "#": "31 Harris St, Unit 102 (168-07-01)",
    "$": 817800,
    "address": "31 Harris St, Unit 102",
    "parcel_id": "168-07-01",
    "owner1": "SCHNEIDERMAN FAMILY LLC",
    "owner2": "",
    "current_taxes": 8374.27,
    "new_taxes_no_override": 8736.04,
    "override_total_1": 8983.92,
    "override_increase_1": 247.88
  },
  {
    "#": "31 Harris St, Unit 201 (168-07-02)",
    "$": 666000,
    "address": "31 Harris St, Unit 201",
    "parcel_id": "168-07-02",
    "owner1": "GREENWALD, CRAIG M",
    "owner2": "",
    "current_taxes": 6819.84,
    "new_taxes_no_override": 7114.46,
    "override_total_1": 7316.32,
    "override_increase_1": 201.87
  },
  {
    "#": "31 Harris St, Unit 202 (168-07-03)",
    "$": 800100,
    "address": "31 Harris St, Unit 202",
    "parcel_id": "168-07-03",
    "owner1": "DYAS, JOHN F & KAZUKO M",
    "owner2": "",
    "current_taxes": 4558.09,
    "new_taxes_no_override": 4755.0,
    "override_total_1": 4889.92,
    "override_increase_1": 134.92
  },
  {
    "#": "31 Harris St, Unit 301 (168-07-04)",
    "$": 686600,
    "address": "31 Harris St, Unit 301",
    "parcel_id": "168-07-04",
    "owner1": "SCHNEIDERMAN FAMILY LLC",
    "owner2": "",
    "current_taxes": 7030.78,
    "new_taxes_no_override": 7334.51,
    "override_total_1": 7542.62,
    "override_increase_1": 208.11
  },
  {
    "#": "31 Harris St, Unit 302 (168-07-05)",
    "$": 814100,
    "address": "31 Harris St, Unit 302",
    "parcel_id": "168-07-05",
    "owner1": "LIANG, DAN",
    "owner2": "WANG, MENGYU",
    "current_taxes": 8336.38,
    "new_taxes_no_override": 8696.51,
    "override_total_1": 8943.27,
    "override_increase_1": 246.76
  },
  {
    "#": "31 Harris St, Unit 401 (168-07-06)",
    "$": 686600,
    "address": "31 Harris St, Unit 401",
    "parcel_id": "168-07-06",
    "owner1": "NELSON, DONALD",
    "owner2": "",
    "current_taxes": 3395.85,
    "new_taxes_no_override": 3542.55,
    "override_total_1": 3643.07,
    "override_increase_1": 100.52
  },
  {
    "#": "31 Harris St, Unit 402 (168-07-07)",
    "$": 814100,
    "address": "31 Harris St, Unit 402",
    "parcel_id": "168-07-07",
    "owner1": "TONKOV, ANDREY V",
    "owner2": "TSESARSKAYA, GALINA",
    "current_taxes": 4701.45,
    "new_taxes_no_override": 4904.55,
    "override_total_1": 5043.72,
    "override_increase_1": 139.16
  },
  {
    "#": "31 Harris St, Unit 501 (168-07-08)",
    "$": 702300,
    "address": "31 Harris St, Unit 501",
    "parcel_id": "168-07-08",
    "owner1": "HAQUE, REZAUL",
    "owner2": "",
    "current_taxes": 3556.62,
    "new_taxes_no_override": 3710.27,
    "override_total_1": 3815.54,
    "override_increase_1": 105.28
  },
  {
    "#": "31 Harris St, Unit 502 (168-07-09)",
    "$": 814100,
    "address": "31 Harris St, Unit 502",
    "parcel_id": "168-07-09",
    "owner1": "STEELE TR, SONDRA J",
    "owner2": "",
    "current_taxes": 4701.45,
    "new_taxes_no_override": 4904.55,
    "override_total_1": 5043.72,
    "override_increase_1": 139.16
  },
  {
    "#": "31 Harris St, Unit 601 (168-07-10)",
    "$": 686600,
    "address": "31 Harris St, Unit 601",
    "parcel_id": "168-07-10",
    "owner1": "GRAY JR, MARK A",
    "owner2": "",
    "current_taxes": 3395.85,
    "new_taxes_no_override": 3542.55,
    "override_total_1": 3643.07,
    "override_increase_1": 100.52
  },
  {
    "#": "31 Harris St, Unit 602 (168-07-11)",
    "$": 849400,
    "address": "31 Harris St, Unit 602",
    "parcel_id": "168-07-11",
    "owner1": "BAKER, RITA SHON",
    "owner2": "",
    "current_taxes": 8697.86,
    "new_taxes_no_override": 9073.61,
    "override_total_1": 9331.06,
    "override_increase_1": 257.46
  },
  {
    "#": "31 Harris St, Unit 701 (168-07-12)",
    "$": 702300,
    "address": "31 Harris St, Unit 701",
    "parcel_id": "168-07-12",
    "owner1": "AJEMIAN, MARIANNE",
    "owner2": "",
    "current_taxes": 7191.55,
    "new_taxes_no_override": 7502.22,
    "override_total_1": 7715.09,
    "override_increase_1": 212.87
  },
  {
    "#": "31 Harris St, Unit 702 (168-07-13)",
    "$": 916000,
    "address": "31 Harris St, Unit 702",
    "parcel_id": "168-07-13",
    "owner1": "VAYSBURD, TRS, LEV B & VICTORIA",
    "owner2": "",
    "current_taxes": 9379.84,
    "new_taxes_no_override": 9785.05,
    "override_total_1": 10062.69,
    "override_increase_1": 277.64
  },
  {
    "#": "37 Harris St, Unit 1 (168-08-02)",
    "$": 1452900,
    "address": "37 Harris St, Unit 1",
    "parcel_id": "168-08-02",
    "owner1": "MCDONOUGH TRS, JOHN E",
    "owner2": "FURLONG, JANICE N",
    "current_taxes": 11242.76,
    "new_taxes_no_override": 11728.45,
    "override_total_1": 12061.23,
    "override_increase_1": 332.79
  },
  {
    "#": "42 Harris St (169-16-00)",
    "$": 2409300,
    "address": "42 Harris St",
    "parcel_id": "169-16-00",
    "owner1": "KIERNAN LIFE ESTATE, WILLIAM E",
    "owner2": "GROSSMAN LIFE ESTATE, GAIL",
    "current_taxes": 21036.3,
    "new_taxes_no_override": 21945.07,
    "override_total_1": 22567.74,
    "override_increase_1": 622.67
  },
  {
    "#": "44 Harris St (169-15-00)",
    "$": 2471900,
    "address": "44 Harris St",
    "parcel_id": "169-15-00",
    "owner1": "WILSON LIFE ESTATE, JULIA",
    "owner2": "",
    "current_taxes": 21677.32,
    "new_taxes_no_override": 22613.78,
    "override_total_1": 23255.43,
    "override_increase_1": 641.65
  },
  {
    "#": "48 Harris St, Unit 1 (169-14-02)",
    "$": 1394800,
    "address": "48 Harris St, Unit 1",
    "parcel_id": "169-14-02",
    "owner1": "WAPINSKI, ILAN",
    "owner2": "VOSKOBOYNIK, BERENIKA",
    "current_taxes": 10647.82,
    "new_taxes_no_override": 11107.81,
    "override_total_1": 11422.98,
    "override_increase_1": 315.18
  },
  {
    "#": "49 Harris St, Unit 2 (168-08-01)",
    "$": 1452500,
    "address": "49 Harris St, Unit 2",
    "parcel_id": "168-08-01",
    "owner1": "SIVAN, EZRA WZ & LISA AW",
    "owner2": "",
    "current_taxes": 11238.67,
    "new_taxes_no_override": 11724.18,
    "override_total_1": 12056.85,
    "override_increase_1": 332.66
  },
  {
    "#": "50 Harris St, Unit 2 (169-14-01)",
    "$": 1325700,
    "address": "50 Harris St, Unit 2",
    "parcel_id": "169-14-01",
    "owner1": "SABLE TRS, ROBERT A & SLOAN",
    "owner2": "",
    "current_taxes": 9940.23,
    "new_taxes_no_override": 10369.65,
    "override_total_1": 10663.88,
    "override_increase_1": 294.23
  },
  {
    "#": "57 Harris St (168-09-00)",
    "$": 2296600,
    "address": "57 Harris St",
    "parcel_id": "168-09-00",
    "owner1": "HEIKIN, STEVEN A",
    "owner2": "",
    "current_taxes": 19882.25,
    "new_taxes_no_override": 20741.16,
    "override_total_1": 21329.68,
    "override_increase_1": 588.51
  },
  {
    "#": "16 Harrison St (130-25-00)",
    "$": 2953400,
    "address": "16 Harrison St",
    "parcel_id": "130-25-00",
    "owner1": "MILLER, ANDREW FREDERICK & KELSEY ANN",
    "owner2": "",
    "current_taxes": 26607.88,
    "new_taxes_no_override": 27757.34,
    "override_total_1": 28544.93,
    "override_increase_1": 787.59
  },
  {
    "#": "20 Harrison St (130-24-00)",
    "$": 3267500,
    "address": "20 Harrison St",
    "parcel_id": "130-24-00",
    "owner1": "ZHANG, JUANJUAN",
    "owner2": "",
    "current_taxes": 29824.27,
    "new_taxes_no_override": 31112.68,
    "override_total_1": 31995.48,
    "override_increase_1": 882.8
  },
  {
    "#": "26 Harrison St (130-23-01)",
    "$": 2004400,
    "address": "26 Harrison St",
    "parcel_id": "130-23-01",
    "owner1": "BERKOVITS TRS, SHIMSHON & LILLIAN LEA",
    "owner2": "",
    "current_taxes": 16890.12,
    "new_taxes_no_override": 17619.77,
    "override_total_1": 18119.72,
    "override_increase_1": 499.95
  },
  {
    "#": "30 Harrison St (130-23-00)",
    "$": 2394800,
    "address": "30 Harrison St",
    "parcel_id": "130-23-00",
    "owner1": "ENGEL, MARLA S",
    "owner2": "LEIFER, DAVID",
    "current_taxes": 20887.82,
    "new_taxes_no_override": 21790.17,
    "override_total_1": 22408.45,
    "override_increase_1": 618.28
  },
  {
    "#": "36 Harrison St (130-22-00)",
    "$": 1807200,
    "address": "36 Harrison St",
    "parcel_id": "130-22-00",
    "owner1": "NOYES, ERIK",
    "owner2": "BAILEY, ELIZABETH",
    "current_taxes": 14870.79,
    "new_taxes_no_override": 15513.21,
    "override_total_1": 15953.38,
    "override_increase_1": 440.18
  },
  {
    "#": "38 Harrison St (130-21-00)",
    "$": 1960500,
    "address": "38 Harrison St",
    "parcel_id": "130-21-00",
    "owner1": "EMMONS, ERIC B",
    "owner2": "KROPA, KATRINA I",
    "current_taxes": 16440.59,
    "new_taxes_no_override": 17150.82,
    "override_total_1": 17637.46,
    "override_increase_1": 486.64
  },
  {
    "#": "40 Harrison St (130-20-00)",
    "$": 4097600,
    "address": "40 Harrison St",
    "parcel_id": "130-20-00",
    "owner1": "WANG, HELEN HAI-LING",
    "owner2": "",
    "current_taxes": 41959.42,
    "new_taxes_no_override": 43772.07,
    "override_total_1": 45014.07,
    "override_increase_1": 1242.0
  },
  {
    "#": "43 Harrison St (128-21-00)",
    "$": 1371300,
    "address": "43 Harrison St",
    "parcel_id": "128-21-00",
    "owner1": "CAVANAUGH LIFE ESTATE, JANICE M",
    "owner2": "",
    "current_taxes": 14042.11,
    "new_taxes_no_override": 14648.73,
    "override_total_1": 15064.38,
    "override_increase_1": 415.65
  },
  {
    "#": "44 Harrison St, Unit 1 (130-19-01)",
    "$": 1507500,
    "address": "44 Harrison St, Unit 1",
    "parcel_id": "130-19-01",
    "owner1": "VARSANIK, JONATHAN & SARAH",
    "owner2": "",
    "current_taxes": 11801.87,
    "new_taxes_no_override": 12311.71,
    "override_total_1": 12661.05,
    "override_increase_1": 349.34
  },
  {
    "#": "44 Harrison St, Unit 2 (130-19-02)",
    "$": 1407700,
    "address": "44 Harrison St, Unit 2",
    "parcel_id": "130-19-02",
    "owner1": "KNIGHTS, ROSS D",
    "owner2": "DORF, ALEXANDRA N",
    "current_taxes": 10779.91,
    "new_taxes_no_override": 11245.6,
    "override_total_1": 11564.69,
    "override_increase_1": 319.09
  },
  {
    "#": "47 Harrison St (128-01-00)",
    "$": 3083000,
    "address": "47 Harrison St",
    "parcel_id": "128-01-00",
    "owner1": "YEUNG TRS, MAN & SHUET MUI",
    "owner2": "",
    "current_taxes": 31569.92,
    "new_taxes_no_override": 32933.74,
    "override_total_1": 33868.21,
    "override_increase_1": 934.47
  },
  {
    "#": "48 Harrison St, Unit 1 (130-18-01)",
    "$": 2022800,
    "address": "48 Harrison St, Unit 1",
    "parcel_id": "130-18-01",
    "owner1": "MALANDRAKIS, MARY LEE",
    "owner2": "",
    "current_taxes": 17078.54,
    "new_taxes_no_override": 17816.33,
    "override_total_1": 18321.86,
    "override_increase_1": 505.52
  },
  {
    "#": "48 Harrison St, Unit 2 (130-18-02)",
    "$": 2214800,
    "address": "48 Harrison St, Unit 2",
    "parcel_id": "130-18-02",
    "owner1": "ABRANTES, ANTHONY J & NICOLE",
    "owner2": "",
    "current_taxes": 19044.62,
    "new_taxes_no_override": 19867.35,
    "override_total_1": 20431.07,
    "override_increase_1": 563.72
  },
  {
    "#": "52 Harrison St (130-17-00)",
    "$": 3049800,
    "address": "52 Harrison St",
    "parcel_id": "130-17-00",
    "owner1": "MACOSKO, EVAN",
    "owner2": "FELDMAN, CANDACE",
    "current_taxes": 27595.02,
    "new_taxes_no_override": 28787.12,
    "override_total_1": 29603.94,
    "override_increase_1": 816.81
  },
  {
    "#": "54 Harrison St (130-16-00)",
    "$": 2973600,
    "address": "54 Harrison St",
    "parcel_id": "130-16-00",
    "owner1": "YAGJIAN, TANYA E",
    "owner2": "",
    "current_taxes": 26814.73,
    "new_taxes_no_override": 27973.13,
    "override_total_1": 28766.84,
    "override_increase_1": 793.72
  },
  {
    "#": "55 Harrison St, Unit 1 (129-07-01)",
    "$": 972200,
    "address": "55 Harrison St, Unit 1",
    "parcel_id": "129-07-01",
    "owner1": "ARSENAULT, MICHAEL P & SUN CHI",
    "owner2": "",
    "current_taxes": 6320.39,
    "new_taxes_no_override": 6593.43,
    "override_total_1": 6780.51,
    "override_increase_1": 187.08
  },
  {
    "#": "55 Harrison St, Unit 2 (129-07-02)",
    "$": 1511500,
    "address": "55 Harrison St, Unit 2",
    "parcel_id": "129-07-02",
    "owner1": "MCKENZIE, ROBIN",
    "owner2": "FINUCANE, TOM",
    "current_taxes": 11842.83,
    "new_taxes_no_override": 12354.44,
    "override_total_1": 12704.99,
    "override_increase_1": 350.55
  },
  {
    "#": "60 Harrison St, Unit 1 (130-15-01)",
    "$": 893100,
    "address": "60 Harrison St, Unit 1",
    "parcel_id": "130-15-01",
    "owner1": "NELSON, SUSAN E",
    "owner2": "",
    "current_taxes": 5510.41,
    "new_taxes_no_override": 5748.46,
    "override_total_1": 5911.57,
    "override_increase_1": 163.11
  },
  {
    "#": "60 Harrison St, Unit 2 (130-15-02)",
    "$": 1478200,
    "address": "60 Harrison St, Unit 2",
    "parcel_id": "130-15-02",
    "owner1": "CARAMAZZA, ALFONSO",
    "owner2": "LINK, KATHRYN",
    "current_taxes": 11501.83,
    "new_taxes_no_override": 11998.71,
    "override_total_1": 12339.16,
    "override_increase_1": 340.45
  },
  {
    "#": "6 Hart St (305-23-00)",
    "$": 813500,
    "address": "6 Hart St",
    "parcel_id": "305-23-00",
    "owner1": "TYNAN, ANNA T & MARY J",
    "owner2": "",
    "current_taxes": 8330.24,
    "new_taxes_no_override": 8690.11,
    "override_total_1": 8936.68,
    "override_increase_1": 246.58
  },
  {
    "#": "7 Hart St (304-08-00)",
    "$": 902900,
    "address": "7 Hart St",
    "parcel_id": "304-08-00",
    "owner1": "YU, YIXIN",
    "owner2": "",
    "current_taxes": 9245.7,
    "new_taxes_no_override": 9645.11,
    "override_total_1": 9918.79,
    "override_increase_1": 273.67
  },
  {
    "#": "8 Hart St (305-22-00)",
    "$": 931700,
    "address": "8 Hart St",
    "parcel_id": "305-22-00",
    "owner1": "GIRARD, ZOE BOURGEOIS-PIN",
    "owner2": "",
    "current_taxes": 5905.67,
    "new_taxes_no_override": 6160.79,
    "override_total_1": 6335.6,
    "override_increase_1": 174.81
  },
  {
    "#": "9 Hart St (304-09-00)",
    "$": 815900,
    "address": "9 Hart St",
    "parcel_id": "304-09-00",
    "owner1": "FARRELL LIFE ESTATE, JEAN E",
    "owner2": "",
    "current_taxes": 4719.88,
    "new_taxes_no_override": 4923.78,
    "override_total_1": 5063.49,
    "override_increase_1": 139.71
  },
  {
    "#": "10 Hart St (305-21-00)",
    "$": 932000,
    "address": "10 Hart St",
    "parcel_id": "305-21-00",
    "owner1": "PRICE, SARAH N & AARON M",
    "owner2": "",
    "current_taxes": 5908.75,
    "new_taxes_no_override": 6164.01,
    "override_total_1": 6338.91,
    "override_increase_1": 174.9
  },
  {
    "#": "11 Hart St (304-10-00)",
    "$": 826900,
    "address": "11 Hart St",
    "parcel_id": "304-10-00",
    "owner1": "CAI, TIANRUN",
    "owner2": "",
    "current_taxes": 8467.46,
    "new_taxes_no_override": 8833.25,
    "override_total_1": 9083.89,
    "override_increase_1": 250.64
  },
  {
    "#": "14 Hart St (305-20-00)",
    "$": 1696600,
    "address": "14 Hart St",
    "parcel_id": "305-20-00",
    "owner1": "WOO WOO REALTY LLC",
    "owner2": "",
    "current_taxes": 17373.18,
    "new_taxes_no_override": 18123.7,
    "override_total_1": 18637.95,
    "override_increase_1": 514.25
  },
  {
    "#": "16 Hart St (305-19-00)",
    "$": 897200,
    "address": "16 Hart St",
    "parcel_id": "305-19-00",
    "owner1": "WOLF, MICHAEL & CLAIRE",
    "owner2": "",
    "current_taxes": 5552.39,
    "new_taxes_no_override": 5792.25,
    "override_total_1": 5956.6,
    "override_increase_1": 164.35
  },
  {
    "#": "17 Hart St (304-11-12)",
    "$": 2590100,
    "address": "17 Hart St",
    "parcel_id": "304-11-12",
    "owner1": "YE, ZI",
    "owner2": "NEARY, ALEXANDER ROSS",
    "current_taxes": 22887.69,
    "new_taxes_no_override": 23876.44,
    "override_total_1": 24553.91,
    "override_increase_1": 677.48
  },
  {
    "#": "18 Hart St (305-18-00)",
    "$": 814000,
    "address": "18 Hart St",
    "parcel_id": "305-18-00",
    "owner1": "LUSK TR, ANNE C",
    "owner2": "",
    "current_taxes": 4700.43,
    "new_taxes_no_override": 4903.49,
    "override_total_1": 5042.62,
    "override_increase_1": 139.13
  },
  {
    "#": "19 Hart St (304-13-00)",
    "$": 799300,
    "address": "19 Hart St",
    "parcel_id": "304-13-00",
    "owner1": "MA, JIANTAO",
    "owner2": "LI, YANPING",
    "current_taxes": 4549.9,
    "new_taxes_no_override": 4746.46,
    "override_total_1": 4881.13,
    "override_increase_1": 134.68
  },
  {
    "#": "20 Hart St (305-17-00)",
    "$": 949400,
    "address": "20 Hart St",
    "parcel_id": "305-17-00",
    "owner1": "MARSH, MARIE",
    "owner2": "GARDINER, ERIK",
    "current_taxes": 6086.92,
    "new_taxes_no_override": 6349.87,
    "override_total_1": 6530.05,
    "override_increase_1": 180.17
  },
  {
    "#": "21 Hart St (304-14-00)",
    "$": 1004800,
    "address": "21 Hart St",
    "parcel_id": "304-14-00",
    "owner1": "CHERENFANT, MARCEL",
    "owner2": "BURNIM, JUDITH",
    "current_taxes": 6654.22,
    "new_taxes_no_override": 6941.68,
    "override_total_1": 7138.65,
    "override_increase_1": 196.96
  },
  {
    "#": "22 Hart St (305-16-00)",
    "$": 90600,
    "address": "22 Hart St",
    "parcel_id": "305-16-00",
    "owner1": "ROBERTS STREET REALTY LLC",
    "owner2": "",
    "current_taxes": 927.74,
    "new_taxes_no_override": 967.82,
    "override_total_1": 995.28,
    "override_increase_1": 27.46
  },
  {
    "#": "3 Harvard Ave, Unit 1 (170-19-04)",
    "$": 1264600,
    "address": "3 Harvard Ave, Unit 1",
    "parcel_id": "170-19-04",
    "owner1": "NJB DEVELOPMENT LLC",
    "owner2": "",
    "current_taxes": 12949.5,
    "new_taxes_no_override": 13508.92,
    "override_total_1": 13892.22,
    "override_increase_1": 383.31
  },
  {
    "#": "3 Harvard Ave, Unit 3 (170-19-02)",
    "$": 1231900,
    "address": "3 Harvard Ave, Unit 3",
    "parcel_id": "170-19-02",
    "owner1": "AKAS LLC",
    "owner2": "",
    "current_taxes": 21139.4,
    "new_taxes_no_override": 22052.62,
    "override_total_1": 22678.35,
    "override_increase_1": 625.73
  },
  {
    "#": "5 Harvard Ave, Unit 2 (170-19-01)",
    "$": 846200,
    "address": "5 Harvard Ave, Unit 2",
    "parcel_id": "170-19-01",
    "owner1": "AKAS LLC",
    "owner2": "",
    "current_taxes": 14520.79,
    "new_taxes_no_override": 15148.09,
    "override_total_1": 15577.9,
    "override_increase_1": 429.82
  },
  {
    "#": "5 Harvard Ave, Unit 4 (170-19-03)",
    "$": 1176100,
    "address": "5 Harvard Ave, Unit 4",
    "parcel_id": "170-19-03",
    "owner1": "AKAS LLC",
    "owner2": "",
    "current_taxes": 20181.88,
    "new_taxes_no_override": 21053.74,
    "override_total_1": 21651.12,
    "override_increase_1": 597.38
  },
  {
    "#": "7 Harvard Ave (170-20-00)",
    "$": 2149500,
    "address": "7 Harvard Ave",
    "parcel_id": "170-20-00",
    "owner1": "TAM, ALAN",
    "owner2": "",
    "current_taxes": 26621.97,
    "new_taxes_no_override": 27772.04,
    "override_total_1": 28560.05,
    "override_increase_1": 788.01
  },
  {
    "#": "19 Harvard Ave (170-21-00)",
    "$": 2293300,
    "address": "19 Harvard Ave",
    "parcel_id": "170-21-00",
    "owner1": "19 HARVARD AVE LLC",
    "owner2": "",
    "current_taxes": 23483.39,
    "new_taxes_no_override": 24497.87,
    "override_total_1": 25192.98,
    "override_increase_1": 695.11
  },
  {
    "#": "21 Harvard Ave (170-22-00)",
    "$": 2868300,
    "address": "21 Harvard Ave",
    "parcel_id": "170-22-00",
    "owner1": "CLANCY TRS, CAITLIN M",
    "owner2": "DESAI, PRASANT D",
    "current_taxes": 29371.39,
    "new_taxes_no_override": 30640.23,
    "override_total_1": 31509.63,
    "override_increase_1": 869.39
  },
  {
    "#": "23 Harvard Ave, Unit 1 (170-24-01)",
    "$": 1450500,
    "address": "23 Harvard Ave, Unit 1",
    "parcel_id": "170-24-01",
    "owner1": "ERAN, ODED & ADI",
    "owner2": "",
    "current_taxes": 14853.12,
    "new_taxes_no_override": 15494.77,
    "override_total_1": 15934.43,
    "override_increase_1": 439.65
  },
  {
    "#": "23 Harvard Ave, Unit 2 (170-24-02)",
    "$": 2182200,
    "address": "23 Harvard Ave, Unit 2",
    "parcel_id": "170-24-02",
    "owner1": "SANTINELLI, MAXIMILIANO",
    "owner2": "LEIBEL, ESTHER",
    "current_taxes": 22345.73,
    "new_taxes_no_override": 23311.07,
    "override_total_1": 23972.5,
    "override_increase_1": 661.43
  },
  {
    "#": "23 Harvard Ave, Unit 3 (170-24-03)",
    "$": 1569600,
    "address": "23 Harvard Ave, Unit 3",
    "parcel_id": "170-24-03",
    "owner1": "RIVES, SHAUNA S",
    "owner2": "",
    "current_taxes": 12437.77,
    "new_taxes_no_override": 12975.08,
    "override_total_1": 13343.24,
    "override_increase_1": 368.16
  },
  {
    "#": "25 Harvard Ave (170-23-00)",
    "$": 2115000,
    "address": "25 Harvard Ave",
    "parcel_id": "170-23-00",
    "owner1": "REIMER TRS, JOSEPH B & GAIL T",
    "owner2": "",
    "current_taxes": 18022.67,
    "new_taxes_no_override": 18801.25,
    "override_total_1": 19334.72,
    "override_increase_1": 533.47
  },
  {
    "#": "27 Harvard Ave, Unit 1 & P3 (170-25-01)",
    "$": 1347300,
    "address": "27 Harvard Ave, Unit 1 & P3",
    "parcel_id": "170-25-01",
    "owner1": "ZUBIZARRETA, JOSE",
    "owner2": "",
    "current_taxes": 13796.35,
    "new_taxes_no_override": 14392.35,
    "override_total_1": 14800.72,
    "override_increase_1": 408.37
  },
  {
    "#": "27 Harvard Ave, Unit 2 & P1 (170-25-02)",
    "$": 1320800,
    "address": "27 Harvard Ave, Unit 2 & P1",
    "parcel_id": "170-25-02",
    "owner1": "ZUBIZARRETA, JOSE R",
    "owner2": "OPAZO, MARIA P",
    "current_taxes": 13524.99,
    "new_taxes_no_override": 14109.27,
    "override_total_1": 14509.61,
    "override_increase_1": 400.34
  },
  {
    "#": "27 Harvard Ave, Unit 3 & P2 (170-25-03)",
    "$": 1234600,
    "address": "27 Harvard Ave, Unit 3 & P2",
    "parcel_id": "170-25-03",
    "owner1": "LEMIEUX ETAL, JACOB E & ROBERT P",
    "owner2": "LI, AMY",
    "current_taxes": 9007.37,
    "new_taxes_no_override": 9396.49,
    "override_total_1": 9663.11,
    "override_increase_1": 266.62
  },
  {
    "#": "29 Harvard Ave, Unit 1 (170-26-01)",
    "$": 920800,
    "address": "29 Harvard Ave, Unit 1",
    "parcel_id": "170-26-01",
    "owner1": "NAVARRETE, JERRY O & PATRICIA J",
    "owner2": "",
    "current_taxes": 9428.99,
    "new_taxes_no_override": 9836.32,
    "override_total_1": 10115.42,
    "override_increase_1": 279.1
  },
  {
    "#": "30 Harvard Ave (171-26-00)",
    "$": 22643900,
    "address": "30 Harvard Ave",
    "parcel_id": "171-26-00",
    "owner1": "NTABOS 30-38 HARVARD AVE LLC",
    "owner2": "C/O DAVOS, PETER",
    "current_taxes": 231873.54,
    "new_taxes_no_override": 241890.48,
    "override_total_1": 248753.93,
    "override_increase_1": 6863.46
  },
  {
    "#": "31 Harvard Ave, Unit 31 (170-26-04)",
    "$": 1470100,
    "address": "31 Harvard Ave, Unit 31",
    "parcel_id": "170-26-04",
    "owner1": "NAVARRETE, JERRY O & PATRICIA J",
    "owner2": "",
    "current_taxes": 11418.89,
    "new_taxes_no_override": 11912.19,
    "override_total_1": 12250.19,
    "override_increase_1": 338.0
  },
  {
    "#": "33 Harvard Ave (170-27-00)",
    "$": 2460500,
    "address": "33 Harvard Ave",
    "parcel_id": "170-27-00",
    "owner1": "CHOW, SUN C & CALIVINA C",
    "owner2": "",
    "current_taxes": 21560.59,
    "new_taxes_no_override": 22492.01,
    "override_total_1": 23130.2,
    "override_increase_1": 638.19
  },
  {
    "#": "37 Harvard Ave (170-28-00)",
    "$": 2230400,
    "address": "37 Harvard Ave",
    "parcel_id": "170-28-00",
    "owner1": "BARRETTO-MORSE, CYRENE",
    "owner2": "C/O PAULO BARRETTO",
    "current_taxes": 22839.3,
    "new_taxes_no_override": 23825.96,
    "override_total_1": 24502.0,
    "override_increase_1": 676.04
  },
  {
    "#": "40 Harvard Ave (171-25-00)",
    "$": 19748600,
    "address": "40 Harvard Ave",
    "parcel_id": "171-25-00",
    "owner1": "HARVARD MANOR LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 202225.66,
    "new_taxes_no_override": 210961.81,
    "override_total_1": 216947.69,
    "override_increase_1": 5985.88
  },
  {
    "#": "45 Harvard Ave, Unit 45-1 (170-33-01)",
    "$": 567700,
    "address": "45 Harvard Ave, Unit 45-1",
    "parcel_id": "170-33-01",
    "owner1": "HANNAGAN, KERI M",
    "owner2": "ALONSO, MARIA-ISABEL",
    "current_taxes": 2178.31,
    "new_taxes_no_override": 2272.41,
    "override_total_1": 2336.89,
    "override_increase_1": 64.48
  },
  {
    "#": "45 Harvard Ave, Unit 45-2 & G31 (170-33-02)",
    "$": 917500,
    "address": "45 Harvard Ave, Unit 45-2 & G31",
    "parcel_id": "170-33-02",
    "owner1": "HART, DENNIS C",
    "owner2": "GULINELLO, JOAN R",
    "current_taxes": 9395.2,
    "new_taxes_no_override": 9801.07,
    "override_total_1": 10079.17,
    "override_increase_1": 278.1
  },
  {
    "#": "45 Harvard Ave, Unit 45-3 & G26 (170-33-03)",
    "$": 883600,
    "address": "45 Harvard Ave, Unit 45-3 & G26",
    "parcel_id": "170-33-03",
    "owner1": "ARCELUS DE DIEGO, MARIA ISABEL",
    "owner2": "",
    "current_taxes": 9048.06,
    "new_taxes_no_override": 9438.94,
    "override_total_1": 9706.76,
    "override_increase_1": 267.82
  },
  {
    "#": "45 Harvard Ave, Unit 45-4 & G3 (170-33-04)",
    "$": 885700,
    "address": "45 Harvard Ave, Unit 45-4 & G3",
    "parcel_id": "170-33-04",
    "owner1": "KARNIK, AMOL M",
    "owner2": "PANDIT, CHANDA",
    "current_taxes": 5434.63,
    "new_taxes_no_override": 5669.41,
    "override_total_1": 5830.27,
    "override_increase_1": 160.87
  },
  {
    "#": "47 Harvard Ave, Unit 47-1 & G17 (170-33-05)",
    "$": 743900,
    "address": "47 Harvard Ave, Unit 47-1 & G17",
    "parcel_id": "170-33-05",
    "owner1": "KLEIN, LINDA D",
    "owner2": "",
    "current_taxes": 3982.6,
    "new_taxes_no_override": 4154.65,
    "override_total_1": 4272.53,
    "override_increase_1": 117.88
  },
  {
    "#": "47 Harvard Ave, Unit 47-2 & G6 (170-33-06)",
    "$": 810800,
    "address": "47 Harvard Ave, Unit 47-2 & G6",
    "parcel_id": "170-33-06",
    "owner1": "GRANIK, ALEXANDER",
    "owner2": "NOSIK, TATYANA",
    "current_taxes": 4667.66,
    "new_taxes_no_override": 4869.3,
    "override_total_1": 5007.47,
    "override_increase_1": 138.16
  },
  {
    "#": "47 Harvard Ave, Unit 47-3 & G2 (170-33-07)",
    "$": 732400,
    "address": "47 Harvard Ave, Unit 47-3 & G2",
    "parcel_id": "170-33-07",
    "owner1": "GONZALEZ TRS, MARILYN & MAXIMILLIAN E",
    "owner2": "GONZALEZ-SERVA, ALDO",
    "current_taxes": 3864.84,
    "new_taxes_no_override": 4031.8,
    "override_total_1": 4146.2,
    "override_increase_1": 114.4
  },
  {
    "#": "47 Harvard Ave, Unit 47-4 & P13 (170-33-08)",
    "$": 934300,
    "address": "47 Harvard Ave, Unit 47-4 & P13",
    "parcel_id": "170-33-08",
    "owner1": "WONG, PAK SHAN SIMON",
    "owner2": "FUNG, WINGSZE",
    "current_taxes": 9567.23,
    "new_taxes_no_override": 9980.53,
    "override_total_1": 10263.72,
    "override_increase_1": 283.19
  },
  {
    "#": "47 Harvard Ave, Unit 47-5 & P2 (170-33-09)",
    "$": 719200,
    "address": "47 Harvard Ave, Unit 47-5 & P2",
    "parcel_id": "170-33-09",
    "owner1": "LIAO, SHU YI",
    "owner2": "",
    "current_taxes": 7364.61,
    "new_taxes_no_override": 7682.76,
    "override_total_1": 7900.75,
    "override_increase_1": 217.99
  },
  {
    "#": "47 Harvard Ave, Unit 47-6 & G7 (170-33-10)",
    "$": 915000,
    "address": "47 Harvard Ave, Unit 47-6 & G7",
    "parcel_id": "170-33-10",
    "owner1": "WU, CHIA -LING",
    "owner2": "",
    "current_taxes": 9369.6,
    "new_taxes_no_override": 9774.37,
    "override_total_1": 10051.71,
    "override_increase_1": 277.34
  },
  {
    "#": "48 Harvard Ave (171-24-00)",
    "$": 10203100,
    "address": "48 Harvard Ave",
    "parcel_id": "171-24-00",
    "owner1": "JUPITER XX LLC",
    "owner2": "",
    "current_taxes": 104479.74,
    "new_taxes_no_override": 108993.26,
    "override_total_1": 112085.87,
    "override_increase_1": 3092.6
  },
  {
    "#": "49 Harvard Ave, Unit 49-1 & G32 (170-33-11)",
    "$": 1004100,
    "address": "49 Harvard Ave, Unit 49-1 & G32",
    "parcel_id": "170-33-11",
    "owner1": "KIRKHAM, JOHN C",
    "owner2": "MROWKA, JENNIFER L",
    "current_taxes": 10281.98,
    "new_taxes_no_override": 10726.16,
    "override_total_1": 11030.51,
    "override_increase_1": 304.35
  },
  {
    "#": "49 Harvard Ave, Unit 49-2 & G15 (170-33-12)",
    "$": 773700,
    "address": "49 Harvard Ave, Unit 49-2 & G15",
    "parcel_id": "170-33-12",
    "owner1": "ALONSO TRS, MARIA ISABEL",
    "owner2": "HANNAGAN, KERI MARIE",
    "current_taxes": 4287.75,
    "new_taxes_no_override": 4472.98,
    "override_total_1": 4599.9,
    "override_increase_1": 126.92
  },
  {
    "#": "49 Harvard Ave, Unit 49-3 & G9 (170-33-13)",
    "$": 905700,
    "address": "49 Harvard Ave, Unit 49-3 & G9",
    "parcel_id": "170-33-13",
    "owner1": "SHEKHEL, HARRY & ELENA",
    "owner2": "",
    "current_taxes": 5639.43,
    "new_taxes_no_override": 5883.05,
    "override_total_1": 6049.98,
    "override_increase_1": 166.93
  },
  {
    "#": "49 Harvard Ave, Unit 49-4 & G5 (170-33-14)",
    "$": 952800,
    "address": "49 Harvard Ave, Unit 49-4 & G5",
    "parcel_id": "170-33-14",
    "owner1": "MARGOLIS, JONATHAN",
    "owner2": "BOOTON, DIANE",
    "current_taxes": 6121.74,
    "new_taxes_no_override": 6386.2,
    "override_total_1": 6567.4,
    "override_increase_1": 181.2
  },
  {
    "#": "49 Harvard Ave, Unit 49-5 & G27 (170-33-15)",
    "$": 916000,
    "address": "49 Harvard Ave, Unit 49-5 & G27",
    "parcel_id": "170-33-15",
    "owner1": "ZHENG, AIWEI",
    "owner2": "",
    "current_taxes": 5744.91,
    "new_taxes_no_override": 5993.09,
    "override_total_1": 6163.14,
    "override_increase_1": 170.05
  },
  {
    "#": "49 Harvard Ave, Unit 49-6 & G14 (170-33-16)",
    "$": 952800,
    "address": "49 Harvard Ave, Unit 49-6 & G14",
    "parcel_id": "170-33-16",
    "owner1": "PIRYATINSKY, MAXIM & IRENE",
    "owner2": "",
    "current_taxes": 9756.67,
    "new_taxes_no_override": 10178.16,
    "override_total_1": 10466.96,
    "override_increase_1": 288.8
  },
  {
    "#": "51 Harvard Ave, Unit 51-1 & 0-3 (170-33-17)",
    "$": 783300,
    "address": "51 Harvard Ave, Unit 51-1 & 0-3",
    "parcel_id": "170-33-17",
    "owner1": "YE, MINGYU",
    "owner2": "WANG, FENGJIAO",
    "current_taxes": 4386.06,
    "new_taxes_no_override": 4575.54,
    "override_total_1": 4705.37,
    "override_increase_1": 129.83
  },
  {
    "#": "51 Harvard Ave, Unit 51-2 & P21 (170-33-18)",
    "$": 806400,
    "address": "51 Harvard Ave, Unit 51-2 & P21",
    "parcel_id": "170-33-18",
    "owner1": "BOGDANOVIC, DEAN & BLANKA",
    "owner2": "",
    "current_taxes": 4622.6,
    "new_taxes_no_override": 4822.3,
    "override_total_1": 4959.13,
    "override_increase_1": 136.83
  },
  {
    "#": "51 Harvard Ave, Unit 51-3 & G4 (170-33-19)",
    "$": 837600,
    "address": "51 Harvard Ave, Unit 51-3 & G4",
    "parcel_id": "170-33-19",
    "owner1": "XU, MIN",
    "owner2": "ZHANG, HUIHONG",
    "current_taxes": 4942.09,
    "new_taxes_no_override": 5155.59,
    "override_total_1": 5301.87,
    "override_increase_1": 146.29
  },
  {
    "#": "51 Harvard Ave, Unit 51-4 & G22 (170-33-20)",
    "$": 863200,
    "address": "51 Harvard Ave, Unit 51-4 & G22",
    "parcel_id": "170-33-20",
    "owner1": "LI, JICHAO",
    "owner2": "ZHANG, YIWEI",
    "current_taxes": 5204.23,
    "new_taxes_no_override": 5429.05,
    "override_total_1": 5583.1,
    "override_increase_1": 154.05
  },
  {
    "#": "51 Harvard Ave, Unit 51-5 & P6 (170-33-21)",
    "$": 832600,
    "address": "51 Harvard Ave, Unit 51-5 & P6",
    "parcel_id": "170-33-21",
    "owner1": "LENBURG, MARC E",
    "owner2": "CHARLES, JULIA F",
    "current_taxes": 4890.89,
    "new_taxes_no_override": 5102.18,
    "override_total_1": 5246.95,
    "override_increase_1": 144.77
  },
  {
    "#": "51 Harvard Ave, Unit 51-6 & G25 (170-33-22)",
    "$": 863100,
    "address": "51 Harvard Ave, Unit 51-6 & G25",
    "parcel_id": "170-33-22",
    "owner1": "DAI, JING",
    "owner2": "",
    "current_taxes": 5203.21,
    "new_taxes_no_override": 5427.99,
    "override_total_1": 5582.0,
    "override_increase_1": 154.02
  },
  {
    "#": "53 Harvard Ave, Unit 53-1 & O-1 (170-33-23)",
    "$": 733200,
    "address": "53 Harvard Ave, Unit 53-1 & O-1",
    "parcel_id": "170-33-23",
    "owner1": "ZHENG, ZHIXIAN",
    "owner2": "FENG, MIAO",
    "current_taxes": 7507.97,
    "new_taxes_no_override": 7832.31,
    "override_total_1": 8054.55,
    "override_increase_1": 222.24
  },
  {
    "#": "53 Harvard Ave, Unit 53-2 & G20 (170-33-24)",
    "$": 924900,
    "address": "53 Harvard Ave, Unit 53-2 & G20",
    "parcel_id": "170-33-24",
    "owner1": "TREMONT STREET ASSOCIATES-MA LLC TRS",
    "owner2": "",
    "current_taxes": 9470.98,
    "new_taxes_no_override": 9880.13,
    "override_total_1": 10160.47,
    "override_increase_1": 280.34
  },
  {
    "#": "53 Harvard Ave, Unit 53-3 & G29 (170-33-25)",
    "$": 987500,
    "address": "53 Harvard Ave, Unit 53-3 & G29",
    "parcel_id": "170-33-25",
    "owner1": "CHEN, DOROTHY Y",
    "owner2": "",
    "current_taxes": 6477.07,
    "new_taxes_no_override": 6756.88,
    "override_total_1": 6948.6,
    "override_increase_1": 191.72
  },
  {
    "#": "53 Harvard Ave, Unit 53-4 & G30 (170-33-26)",
    "$": 881600,
    "address": "53 Harvard Ave, Unit 53-4 & G30",
    "parcel_id": "170-33-26",
    "owner1": "SHU ET AL, YONG",
    "owner2": "C/O WANG, YE",
    "current_taxes": 9027.58,
    "new_taxes_no_override": 9417.57,
    "override_total_1": 9684.79,
    "override_increase_1": 267.22
  },
  {
    "#": "53 Harvard Ave, Unit 53-5 & P11 (170-33-27)",
    "$": 952800,
    "address": "53 Harvard Ave, Unit 53-5 & P11",
    "parcel_id": "170-33-27",
    "owner1": "DARVISH, SHAHAN M & BIJAN",
    "owner2": "",
    "current_taxes": 9756.67,
    "new_taxes_no_override": 10178.16,
    "override_total_1": 10466.96,
    "override_increase_1": 288.8
  },
  {
    "#": "53 Harvard Ave, Unit 53-6 & G12 (170-33-28)",
    "$": 905700,
    "address": "53 Harvard Ave, Unit 53-6 & G12",
    "parcel_id": "170-33-28",
    "owner1": "WALSH, BRIAN",
    "owner2": "MURPHY, ERIN",
    "current_taxes": 5639.43,
    "new_taxes_no_override": 5883.05,
    "override_total_1": 6049.98,
    "override_increase_1": 166.93
  },
  {
    "#": "54 Harvard Ave, Unit 1 (171-23-01)",
    "$": 2885200,
    "address": "54 Harvard Ave, Unit 1",
    "parcel_id": "171-23-01",
    "owner1": "HILL, JUAN MARCOS",
    "owner2": "PALACIOS, NITZEL",
    "current_taxes": 25909.51,
    "new_taxes_no_override": 27028.8,
    "override_total_1": 27795.72,
    "override_increase_1": 766.92
  },
  {
    "#": "54 Harvard Ave, Unit 2 (171-23-02)",
    "$": 3107600,
    "address": "54 Harvard Ave, Unit 2",
    "parcel_id": "171-23-02",
    "owner1": "GINZBURG, ALEXANDER & JULIA",
    "owner2": "",
    "current_taxes": 31821.82,
    "new_taxes_no_override": 33196.52,
    "override_total_1": 34138.45,
    "override_increase_1": 941.93
  },
  {
    "#": "54 Harvard Ave, Unit 3 (171-23-03)",
    "$": 3039200,
    "address": "54 Harvard Ave, Unit 3",
    "parcel_id": "171-23-03",
    "owner1": "GOLLERKERI TRS, ASHWIN",
    "owner2": "GOYAL, SUNITA",
    "current_taxes": 27486.47,
    "new_taxes_no_override": 28673.89,
    "override_total_1": 29487.49,
    "override_increase_1": 813.6
  },
  {
    "#": "55 Harvard Ave, Unit 55-1 & P4 (170-33-29)",
    "$": 797900,
    "address": "55 Harvard Ave, Unit 55-1 & P4",
    "parcel_id": "170-33-29",
    "owner1": "GOULD, NICHOLAS MICHAEL & KENDALL LAUREN",
    "owner2": "",
    "current_taxes": 4535.56,
    "new_taxes_no_override": 4731.5,
    "override_total_1": 4865.75,
    "override_increase_1": 134.25
  },
  {
    "#": "55 Harvard Ave, Unit 55-2 (170-33-30)",
    "$": 586400,
    "address": "55 Harvard Ave, Unit 55-2",
    "parcel_id": "170-33-30",
    "owner1": "WEI, WENYI",
    "owner2": "WANG, YE",
    "current_taxes": 6004.74,
    "new_taxes_no_override": 6264.14,
    "override_total_1": 6441.89,
    "override_increase_1": 177.74
  },
  {
    "#": "55 Harvard Ave, Unit 55-3 & G16 (170-33-31)",
    "$": 926800,
    "address": "55 Harvard Ave, Unit 55-3 & G16",
    "parcel_id": "170-33-31",
    "owner1": "BASSOV, IVAN & TATYANA",
    "owner2": "",
    "current_taxes": 5855.5,
    "new_taxes_no_override": 6108.46,
    "override_total_1": 6281.78,
    "override_increase_1": 173.32
  },
  {
    "#": "55 Harvard Ave, Unit 55-4 & G8 (170-33-32)",
    "$": 747800,
    "address": "55 Harvard Ave, Unit 55-4 & G8",
    "parcel_id": "170-33-32",
    "owner1": "ARONSKY, EUGENE",
    "owner2": "",
    "current_taxes": 4022.54,
    "new_taxes_no_override": 4196.31,
    "override_total_1": 4315.38,
    "override_increase_1": 119.07
  },
  {
    "#": "55 Harvard Ave, Unit 55-5 & G24 (170-33-33)",
    "$": 933000,
    "address": "55 Harvard Ave, Unit 55-5 & G24",
    "parcel_id": "170-33-33",
    "owner1": "HOAR, CHARLES",
    "owner2": "LESCHIN-HOAR, CLARE",
    "current_taxes": 9553.92,
    "new_taxes_no_override": 9966.65,
    "override_total_1": 10249.45,
    "override_increase_1": 282.8
  },
  {
    "#": "55 Harvard Ave, Unit 55-6 & G1 (170-33-34)",
    "$": 739500,
    "address": "55 Harvard Ave, Unit 55-6 & G1",
    "parcel_id": "170-33-34",
    "owner1": "LEE, SABRINA",
    "owner2": "",
    "current_taxes": 7572.48,
    "new_taxes_no_override": 7899.61,
    "override_total_1": 8123.76,
    "override_increase_1": 224.15
  },
  {
    "#": "56 Harvard Ave (171-22-00)",
    "$": 3641000,
    "address": "56 Harvard Ave",
    "parcel_id": "171-22-00",
    "owner1": "SEEFAR LLC",
    "owner2": "",
    "current_taxes": 37283.84,
    "new_taxes_no_override": 38894.5,
    "override_total_1": 39998.1,
    "override_increase_1": 1103.6
  },
  {
    "#": "57 Harvard Ave, Unit 57-1 & G10 (170-33-35)",
    "$": 764700,
    "address": "57 Harvard Ave, Unit 57-1 & G10",
    "parcel_id": "170-33-35",
    "owner1": "YANG, XIAOHUI",
    "owner2": "DENG, DONG",
    "current_taxes": 7830.53,
    "new_taxes_no_override": 8168.81,
    "override_total_1": 8400.59,
    "override_increase_1": 231.78
  },
  {
    "#": "57 Harvard Ave, Unit 57-2 & G23 (170-33-36)",
    "$": 908800,
    "address": "57 Harvard Ave, Unit 57-2 & G23",
    "parcel_id": "170-33-36",
    "owner1": "LU, XIAOLAN",
    "owner2": "",
    "current_taxes": 5671.18,
    "new_taxes_no_override": 5916.17,
    "override_total_1": 6084.04,
    "override_increase_1": 167.87
  },
  {
    "#": "57 Harvard Ave, Unit 57-3 & P5 (170-33-37)",
    "$": 715700,
    "address": "57 Harvard Ave, Unit 57-3 & P5",
    "parcel_id": "170-33-37",
    "owner1": "REYNOLDS, DOUGLAS & KIMBERLY",
    "owner2": "",
    "current_taxes": 3693.83,
    "new_taxes_no_override": 3853.4,
    "override_total_1": 3962.74,
    "override_increase_1": 109.34
  },
  {
    "#": "57 Harvard Ave, Unit 57-4 & G18 (170-33-38)",
    "$": 919000,
    "address": "57 Harvard Ave, Unit 57-4 & G18",
    "parcel_id": "170-33-38",
    "owner1": "MULLAHY, MICHAEL",
    "owner2": "WU, FU-NONG",
    "current_taxes": 9410.56,
    "new_taxes_no_override": 9817.1,
    "override_total_1": 10095.65,
    "override_increase_1": 278.55
  },
  {
    "#": "57 Harvard Ave, Unit 57-5 & P19 (170-33-39)",
    "$": 756600,
    "address": "57 Harvard Ave, Unit 57-5 & P19",
    "parcel_id": "170-33-39",
    "owner1": "YANG, ZHIYONG",
    "owner2": "",
    "current_taxes": 4112.65,
    "new_taxes_no_override": 4290.32,
    "override_total_1": 4412.05,
    "override_increase_1": 121.73
  },
  {
    "#": "57 Harvard Ave, Unit 57-6 & G28 (170-33-40)",
    "$": 953600,
    "address": "57 Harvard Ave, Unit 57-6 & G28",
    "parcel_id": "170-33-40",
    "owner1": "SHAFIR, FRANCES J",
    "owner2": "LAMBROPOULOS, JAMES",
    "current_taxes": 9764.86,
    "new_taxes_no_override": 10186.7,
    "override_total_1": 10475.74,
    "override_increase_1": 289.04
  },
  {
    "#": "59 Harvard Ave, Unit 59-1 & P7 (170-33-41)",
    "$": 739300,
    "address": "59 Harvard Ave, Unit 59-1 & P7",
    "parcel_id": "170-33-41",
    "owner1": "TAYLOR TRS, MARK F & CAROL W",
    "owner2": "",
    "current_taxes": 7570.43,
    "new_taxes_no_override": 7897.47,
    "override_total_1": 8121.56,
    "override_increase_1": 224.08
  },
  {
    "#": "59 Harvard Ave, Unit 59-2 (170-33-42)",
    "$": 500300,
    "address": "59 Harvard Ave, Unit 59-2",
    "parcel_id": "170-33-42",
    "owner1": "FUHR, MARK E & NICHOLAS",
    "owner2": "",
    "current_taxes": 1488.14,
    "new_taxes_no_override": 1552.43,
    "override_total_1": 1596.48,
    "override_increase_1": 44.05
  },
  {
    "#": "60 Harvard Ave, Unit 1 (171-21-02)",
    "$": 1330500,
    "address": "60 Harvard Ave, Unit 1",
    "parcel_id": "171-21-02",
    "owner1": "TUCKER TRS, LEIGH J",
    "owner2": "MEHRTENS, STEPHEN R",
    "current_taxes": 9989.39,
    "new_taxes_no_override": 10420.93,
    "override_total_1": 10716.62,
    "override_increase_1": 295.69
  },
  {
    "#": "60 Harvard Ave, Unit 2 (171-21-01)",
    "$": 1517100,
    "address": "60 Harvard Ave, Unit 2",
    "parcel_id": "171-21-01",
    "owner1": "NICKERSON, CHRISTINE L & BERNSTEIN I",
    "owner2": "",
    "current_taxes": 11900.17,
    "new_taxes_no_override": 12414.26,
    "override_total_1": 12766.5,
    "override_increase_1": 352.25
  },
  {
    "#": "63 Harvard Ave, Unit 63-1 (170-35-02)",
    "$": 3853800,
    "address": "63 Harvard Ave, Unit 63-1",
    "parcel_id": "170-35-02",
    "owner1": "MARCUS, MELANIE",
    "owner2": "LEONARD, CHRISTOPHER",
    "current_taxes": 35827.98,
    "new_taxes_no_override": 37375.75,
    "override_total_1": 38436.26,
    "override_increase_1": 1060.51
  },
  {
    "#": "63 Harvard Ave, Unit 63-2&G3P3 (170-35-03)",
    "$": 2671300,
    "address": "63 Harvard Ave, Unit 63-2&G3P3",
    "parcel_id": "170-35-03",
    "owner1": "YU TR, HONG",
    "owner2": "HONG YU REVOCABLE LIVING TRUST",
    "current_taxes": 23719.18,
    "new_taxes_no_override": 24743.85,
    "override_total_1": 25445.94,
    "override_increase_1": 702.09
  },
  {
    "#": "63 Harvard Ave, Unit 63-3&G4P4 (170-35-04)",
    "$": 2462000,
    "address": "63 Harvard Ave, Unit 63-3&G4P4",
    "parcel_id": "170-35-04",
    "owner1": "XUE-JUN, YUAN",
    "owner2": "",
    "current_taxes": 25210.88,
    "new_taxes_no_override": 26299.99,
    "override_total_1": 27046.23,
    "override_increase_1": 746.24
  },
  {
    "#": "65 Harvard Ave, Unit 65 &G5P7 (170-35-05)",
    "$": 2703500,
    "address": "65 Harvard Ave, Unit 65 &G5P7",
    "parcel_id": "170-35-05",
    "owner1": "HUNT TRS, GEOFFREY H & JENNIFER L",
    "owner2": "",
    "current_taxes": 27683.84,
    "new_taxes_no_override": 28879.78,
    "override_total_1": 29699.22,
    "override_increase_1": 819.44
  },
  {
    "#": "65 Harvard Ave, Unit P 5 6 8 9 (170-35-07)",
    "$": 196000,
    "address": "65 Harvard Ave, Unit P 5 6 8 9",
    "parcel_id": "170-35-07",
    "owner1": "HUNT, GEOFFREY H & JENNIFER L",
    "owner2": "",
    "current_taxes": 2007.04,
    "new_taxes_no_override": 2093.74,
    "override_total_1": 2153.15,
    "override_increase_1": 59.41
  },
  {
    "#": "66 Harvard Ave (171-59-00)",
    "$": 2090500,
    "address": "66 Harvard Ave",
    "parcel_id": "171-59-00",
    "owner1": "CARTER, DUSTIN P & DIANE M",
    "owner2": "",
    "current_taxes": 21406.72,
    "new_taxes_no_override": 22331.49,
    "override_total_1": 22965.13,
    "override_increase_1": 633.64
  },
  {
    "#": "67 Harvard Ave, Unit 67 &P10 11 (170-35-06)",
    "$": 2651100,
    "address": "67 Harvard Ave, Unit 67 &P10 11",
    "parcel_id": "170-35-06",
    "owner1": "ANGERMEIER, MARLA C",
    "owner2": "",
    "current_taxes": 27147.26,
    "new_taxes_no_override": 28320.02,
    "override_total_1": 29123.58,
    "override_increase_1": 803.56
  },
  {
    "#": "70 Harvard Ave (171-19-00)",
    "$": 2610800,
    "address": "70 Harvard Ave",
    "parcel_id": "171-19-00",
    "owner1": "SILEVITCH LIFE ESTATE, MICHAEL B & RENA M",
    "owner2": "",
    "current_taxes": 23099.66,
    "new_taxes_no_override": 24097.57,
    "override_total_1": 24781.32,
    "override_increase_1": 683.75
  },
  {
    "#": "71 Harvard Ave (170-36-01)",
    "$": 2343200,
    "address": "71 Harvard Ave",
    "parcel_id": "170-36-01",
    "owner1": "71 HA BROOKLINE LLC",
    "owner2": "",
    "current_taxes": 23994.37,
    "new_taxes_no_override": 25030.93,
    "override_total_1": 25741.16,
    "override_increase_1": 710.23
  },
  {
    "#": "74 Harvard Ave (171-18-00)",
    "$": 2713700,
    "address": "74 Harvard Ave",
    "parcel_id": "171-18-00",
    "owner1": "SAMUELS, DIANE",
    "owner2": "",
    "current_taxes": 24153.35,
    "new_taxes_no_override": 25196.77,
    "override_total_1": 25911.71,
    "override_increase_1": 714.94
  },
  {
    "#": "76 Harvard Ave (171-17-00)",
    "$": 2397200,
    "address": "76 Harvard Ave",
    "parcel_id": "171-17-00",
    "owner1": "DARBYSHIRE, CAROLINE",
    "owner2": "",
    "current_taxes": 24547.33,
    "new_taxes_no_override": 25607.77,
    "override_total_1": 26334.38,
    "override_increase_1": 726.6
  },
  {
    "#": "77 Harvard Ave, Unit 77-1 & P11 (170-37-01)",
    "$": 1092000,
    "address": "77 Harvard Ave, Unit 77-1 & P11",
    "parcel_id": "170-37-01",
    "owner1": "WILLCOX TRS, OLIVER S & AMELIA G",
    "owner2": "",
    "current_taxes": 7547.15,
    "new_taxes_no_override": 7873.19,
    "override_total_1": 8096.58,
    "override_increase_1": 223.4
  },
  {
    "#": "77 Harvard Ave, Unit 77-2 & P9 (170-37-02)",
    "$": 1275200,
    "address": "77 Harvard Ave, Unit 77-2 & P9",
    "parcel_id": "170-37-02",
    "owner1": "PEREZ-ESPEJO, MIGUEL",
    "owner2": "TSAI, HSIN-LIN",
    "current_taxes": 9423.11,
    "new_taxes_no_override": 9830.19,
    "override_total_1": 10109.11,
    "override_increase_1": 278.92
  },
  {
    "#": "77 Harvard Ave, Unit 77-3 & G-8 (170-37-03)",
    "$": 1263900,
    "address": "77 Harvard Ave, Unit 77-3 & G-8",
    "parcel_id": "170-37-03",
    "owner1": "LEVY TR, EMILY J",
    "owner2": "",
    "current_taxes": 9307.4,
    "new_taxes_no_override": 9709.48,
    "override_total_1": 9984.98,
    "override_increase_1": 275.5
  },
  {
    "#": "78 Harvard Ave (171-16-00)",
    "$": 2691700,
    "address": "78 Harvard Ave",
    "parcel_id": "171-16-00",
    "owner1": "DARBYSHIRE, CAROLINE",
    "owner2": "",
    "current_taxes": 27563.01,
    "new_taxes_no_override": 28753.73,
    "override_total_1": 29569.6,
    "override_increase_1": 815.87
  },
  {
    "#": "79 Harvard Ave, Unit 79-1 P-12 (170-37-04)",
    "$": 1104400,
    "address": "79 Harvard Ave, Unit 79-1 P-12",
    "parcel_id": "170-37-04",
    "owner1": "PINKHAM, ARTHUR W",
    "owner2": "KOSSARI, PARVANEH",
    "current_taxes": 7674.12,
    "new_taxes_no_override": 8005.64,
    "override_total_1": 8232.8,
    "override_increase_1": 227.15
  },
  {
    "#": "79 Harvard Ave, Unit 79-2 & G7 (170-37-05)",
    "$": 1137200,
    "address": "79 Harvard Ave, Unit 79-2 & G7",
    "parcel_id": "170-37-05",
    "owner1": "PAGET TR, KATHERINE FROME",
    "owner2": "",
    "current_taxes": 8009.99,
    "new_taxes_no_override": 8356.02,
    "override_total_1": 8593.12,
    "override_increase_1": 237.1
  },
  {
    "#": "79 Harvard Ave, Unit 79-3 & P10 (170-37-06)",
    "$": 1087800,
    "address": "79 Harvard Ave, Unit 79-3 & P10",
    "parcel_id": "170-37-06",
    "owner1": "DESOUZA TR, ERICA",
    "owner2": "",
    "current_taxes": 11139.07,
    "new_taxes_no_override": 11620.28,
    "override_total_1": 11949.99,
    "override_increase_1": 329.72
  },
  {
    "#": "80 Harvard Ave (171-15-00)",
    "$": 2321000,
    "address": "80 Harvard Ave",
    "parcel_id": "171-15-00",
    "owner1": "STEVENSON, SCOUT",
    "owner2": "EVANS, JOANNE",
    "current_taxes": 20132.11,
    "new_taxes_no_override": 21001.82,
    "override_total_1": 21597.73,
    "override_increase_1": 595.91
  },
  {
    "#": "81 Harvard Ave, Unit 81-1 & G-5 (170-37-07)",
    "$": 1135000,
    "address": "81 Harvard Ave, Unit 81-1 & G-5",
    "parcel_id": "170-37-07",
    "owner1": "SILBERBERG, SUSAN C",
    "owner2": "",
    "current_taxes": 7987.47,
    "new_taxes_no_override": 8332.53,
    "override_total_1": 8568.96,
    "override_increase_1": 236.43
  },
  {
    "#": "81 Harvard Ave, Unit 81-2 G1-G2 (170-37-08)",
    "$": 1185900,
    "address": "81 Harvard Ave, Unit 81-2 G1-G2",
    "parcel_id": "170-37-08",
    "owner1": "ULIS B LLC",
    "owner2": "",
    "current_taxes": 12143.62,
    "new_taxes_no_override": 12668.22,
    "override_total_1": 13027.68,
    "override_increase_1": 359.45
  },
  {
    "#": "81 Harvard Ave, Unit 81-3 & P13 (170-37-09)",
    "$": 1121300,
    "address": "81 Harvard Ave, Unit 81-3 & P13",
    "parcel_id": "170-37-09",
    "owner1": "WANG, YONG",
    "owner2": "YUE, WAH",
    "current_taxes": 11482.11,
    "new_taxes_no_override": 11978.14,
    "override_total_1": 12318.01,
    "override_increase_1": 339.87
  },
  {
    "#": "82 Harvard Ave (171-14-00)",
    "$": 1957300,
    "address": "82 Harvard Ave",
    "parcel_id": "171-14-00",
    "owner1": "TAYER TRS, BARTON H & MARJORIE H",
    "owner2": "",
    "current_taxes": 16407.82,
    "new_taxes_no_override": 17116.64,
    "override_total_1": 17602.31,
    "override_increase_1": 485.67
  },
  {
    "#": "83 Harvard Ave, Unit 83-1 & P16 (170-37-10)",
    "$": 1097200,
    "address": "83 Harvard Ave, Unit 83-1 & P16",
    "parcel_id": "170-37-10",
    "owner1": "GALLAGHER TR, DIANE S",
    "owner2": "",
    "current_taxes": 7600.39,
    "new_taxes_no_override": 7928.73,
    "override_total_1": 8153.7,
    "override_increase_1": 224.97
  },
  {
    "#": "83 Harvard Ave, Unit 83-2 G3-G4 (170-37-11)",
    "$": 1355300,
    "address": "83 Harvard Ave, Unit 83-2 G3-G4",
    "parcel_id": "170-37-11",
    "owner1": "BURTCH, DAVID G",
    "owner2": "BAK, KATARZYNA",
    "current_taxes": 10243.34,
    "new_taxes_no_override": 10685.85,
    "override_total_1": 10989.06,
    "override_increase_1": 303.2
  },
  {
    "#": "83 Harvard Ave, Unit 83-3 & G-6 (170-37-12)",
    "$": 1326300,
    "address": "83 Harvard Ave, Unit 83-3 & G-6",
    "parcel_id": "170-37-12",
    "owner1": "ARUTUNIAN, ANAIT",
    "owner2": "VELINZON, ALEXANDER",
    "current_taxes": 9946.38,
    "new_taxes_no_override": 10376.06,
    "override_total_1": 10670.48,
    "override_increase_1": 294.41
  },
  {
    "#": "84 Harvard Ave, Unit 1 (171-13-01)",
    "$": 885100,
    "address": "84 Harvard Ave, Unit 1",
    "parcel_id": "171-13-01",
    "owner1": "MOYLAN TRS, J DANIEL",
    "owner2": "",
    "current_taxes": 5428.49,
    "new_taxes_no_override": 5663.0,
    "override_total_1": 5823.68,
    "override_increase_1": 160.68
  },
  {
    "#": "84 Harvard Ave, Unit 2 (171-13-02)",
    "$": 923900,
    "address": "84 Harvard Ave, Unit 2",
    "parcel_id": "171-13-02",
    "owner1": "SLOANE, JACK LEIDER",
    "owner2": "MCLOUGHLIN, ELIZABETH",
    "current_taxes": 5825.8,
    "new_taxes_no_override": 6077.47,
    "override_total_1": 6249.92,
    "override_increase_1": 172.44
  },
  {
    "#": "86 Harvard Ave (171-12-00)",
    "$": 2343900,
    "address": "86 Harvard Ave",
    "parcel_id": "171-12-00",
    "owner1": "FINE, GERALD J",
    "owner2": "LEFEVRE, L VICTORIA",
    "current_taxes": 20366.6,
    "new_taxes_no_override": 21246.44,
    "override_total_1": 21849.29,
    "override_increase_1": 602.85
  },
  {
    "#": "88 Harvard Ave (171-11-00)",
    "$": 2280600,
    "address": "88 Harvard Ave",
    "parcel_id": "171-11-00",
    "owner1": "ESTRELLA PROPERTY LLC",
    "owner2": "",
    "current_taxes": 23353.34,
    "new_taxes_no_override": 24362.2,
    "override_total_1": 25053.46,
    "override_increase_1": 691.26
  },
  {
    "#": "90 Harvard Ave (171-10-00)",
    "$": 2596000,
    "address": "90 Harvard Ave",
    "parcel_id": "171-10-00",
    "owner1": "CHUNG TRS, KEE YOUNG",
    "owner2": "KIM, MIKYOUNG",
    "current_taxes": 22948.11,
    "new_taxes_no_override": 23939.47,
    "override_total_1": 24618.73,
    "override_increase_1": 679.26
  },
  {
    "#": "91 Harvard Ave, Unit 91-1 (170-01-13)",
    "$": 421300,
    "address": "91 Harvard Ave, Unit 91-1",
    "parcel_id": "170-01-13",
    "owner1": "MAUND, GREGORY & JANET MARIE",
    "owner2": "",
    "current_taxes": 4314.11,
    "new_taxes_no_override": 4500.48,
    "override_total_1": 4628.18,
    "override_increase_1": 127.7
  },
  {
    "#": "91 Harvard Ave, Unit 91-2 (170-01-14)",
    "$": 625500,
    "address": "91 Harvard Ave, Unit 91-2",
    "parcel_id": "170-01-14",
    "owner1": "KEITH TRS, TERRY C & MARGARET",
    "owner2": "",
    "current_taxes": 2770.19,
    "new_taxes_no_override": 2889.86,
    "override_total_1": 2971.86,
    "override_increase_1": 82.0
  },
  {
    "#": "91 Harvard Ave, Unit 91-3 (170-01-15)",
    "$": 509900,
    "address": "91 Harvard Ave, Unit 91-3",
    "parcel_id": "170-01-15",
    "owner1": "RUSAK, SERGEY",
    "owner2": "",
    "current_taxes": 1586.44,
    "new_taxes_no_override": 1654.97,
    "override_total_1": 1701.93,
    "override_increase_1": 46.96
  },
  {
    "#": "91 Harvard Ave, Unit 91-4 (170-01-16)",
    "$": 625600,
    "address": "91 Harvard Ave, Unit 91-4",
    "parcel_id": "170-01-16",
    "owner1": "CHICKERING, MORGAN W & JANIE V",
    "owner2": "",
    "current_taxes": 2771.21,
    "new_taxes_no_override": 2890.93,
    "override_total_1": 2972.95,
    "override_increase_1": 82.03
  },
  {
    "#": "91 Harvard Ave, Unit 91-5 (170-01-17)",
    "$": 421300,
    "address": "91 Harvard Ave, Unit 91-5",
    "parcel_id": "170-01-17",
    "owner1": "AUGUSTINACK, JEAN C",
    "owner2": "",
    "current_taxes": 679.18,
    "new_taxes_no_override": 708.52,
    "override_total_1": 728.62,
    "override_increase_1": 20.1
  },
  {
    "#": "91 Harvard Ave, Unit 91-6 (170-01-18)",
    "$": 651000,
    "address": "91 Harvard Ave, Unit 91-6",
    "parcel_id": "170-01-18",
    "owner1": "GREEN TRS, BRADLEY",
    "owner2": "MARSHALL, ALLISON",
    "current_taxes": 6666.24,
    "new_taxes_no_override": 6954.22,
    "override_total_1": 7151.54,
    "override_increase_1": 197.32
  },
  {
    "#": "92 Harvard Ave, Unit 1 & P1 (171-09-01)",
    "$": 1335600,
    "address": "92 Harvard Ave, Unit 1 & P1",
    "parcel_id": "171-09-01",
    "owner1": "APPEL TRS, NEAL B & BARBARA R",
    "owner2": "",
    "current_taxes": 10041.61,
    "new_taxes_no_override": 10475.41,
    "override_total_1": 10772.64,
    "override_increase_1": 297.23
  },
  {
    "#": "92 Harvard Ave, Unit 2 & P2 (171-09-02)",
    "$": 1646000,
    "address": "92 Harvard Ave, Unit 2 & P2",
    "parcel_id": "171-09-02",
    "owner1": "COHEN, BARBARA ANN",
    "owner2": "",
    "current_taxes": 13220.11,
    "new_taxes_no_override": 13791.22,
    "override_total_1": 14182.53,
    "override_increase_1": 391.32
  },
  {
    "#": "94 Harvard Ave (171-08-00)",
    "$": 1999600,
    "address": "94 Harvard Ave",
    "parcel_id": "171-08-00",
    "owner1": "TAN, XIAO",
    "owner2": "TSAI, MIAO-CHIH",
    "current_taxes": 16840.97,
    "new_taxes_no_override": 17568.5,
    "override_total_1": 18066.99,
    "override_increase_1": 498.49
  },
  {
    "#": "96 Harvard Ave (171-07-00)",
    "$": 2049500,
    "address": "96 Harvard Ave",
    "parcel_id": "171-07-00",
    "owner1": "GOLDMAN TR, EILEEN S",
    "owner2": "",
    "current_taxes": 17351.95,
    "new_taxes_no_override": 18101.55,
    "override_total_1": 18615.17,
    "override_increase_1": 513.62
  },
  {
    "#": "243 Harvard Ave (071-01-00)",
    "$": 1861000,
    "address": "243 Harvard Ave",
    "parcel_id": "071-01-00",
    "owner1": "KIM, TR, BENJAMIN W",
    "owner2": "",
    "current_taxes": 19056.64,
    "new_taxes_no_override": 19879.89,
    "override_total_1": 20443.96,
    "override_increase_1": 564.08
  },
  {
    "#": "20 Harvard Ct (155-20-01)",
    "$": 1267100,
    "address": "20 Harvard Ct",
    "parcel_id": "155-20-01",
    "owner1": "BOSTON EDISON CO",
    "owner2": "C/O NSTAR PROPERTY TAX DEPT",
    "current_taxes": 21743.44,
    "new_taxes_no_override": 22682.76,
    "override_total_1": 23326.36,
    "override_increase_1": 643.61
  },
  {
    "#": "3 Harvard Pl, Unit 3 & P7-G3 (171-29-03)",
    "$": 861800,
    "address": "3 Harvard Pl, Unit 3 & P7-G3",
    "parcel_id": "171-29-03",
    "owner1": "YEE, CHRISTINA S K",
    "owner2": "",
    "current_taxes": 5189.9,
    "new_taxes_no_override": 5414.1,
    "override_total_1": 5567.72,
    "override_increase_1": 153.62
  },
  {
    "#": "4 Harvard Pl (171-34-00)",
    "$": 1689800,
    "address": "4 Harvard Pl",
    "parcel_id": "171-34-00",
    "owner1": "CHANG, HSIANG SHENG",
    "owner2": "",
    "current_taxes": 17303.55,
    "new_taxes_no_override": 18051.06,
    "override_total_1": 18563.25,
    "override_increase_1": 512.19
  },
  {
    "#": "6 Harvard Pl (171-33-00)",
    "$": 1617100,
    "address": "6 Harvard Pl",
    "parcel_id": "171-33-00",
    "owner1": "CALKINS, MERCEDES M",
    "owner2": "",
    "current_taxes": 12924.17,
    "new_taxes_no_override": 13482.49,
    "override_total_1": 13865.05,
    "override_increase_1": 382.56
  },
  {
    "#": "14 Harvard Pl (171-32-00)",
    "$": 1821400,
    "address": "14 Harvard Pl",
    "parcel_id": "171-32-00",
    "owner1": "LIN, PITIPONG JUN SEN & KAY HYUNKEE",
    "owner2": "",
    "current_taxes": 15016.2,
    "new_taxes_no_override": 15664.9,
    "override_total_1": 16109.38,
    "override_increase_1": 444.48
  },
  {
    "#": "16 Harvard Pl (171-31-00)",
    "$": 1745400,
    "address": "16 Harvard Pl",
    "parcel_id": "171-31-00",
    "owner1": "KERR, GREGORY S & CAROLINE F",
    "owner2": "",
    "current_taxes": 17872.9,
    "new_taxes_no_override": 18645.01,
    "override_total_1": 19174.05,
    "override_increase_1": 529.04
  },
  {
    "#": "20 Harvard Pl (171-30-01)",
    "$": 1736900,
    "address": "20 Harvard Pl",
    "parcel_id": "171-30-01",
    "owner1": "ALVAREZ, TR, PABLO",
    "owner2": "",
    "current_taxes": 14150.92,
    "new_taxes_no_override": 14762.24,
    "override_total_1": 15181.11,
    "override_increase_1": 418.87
  },
  {
    "#": "22 Harvard Pl (171-30-00)",
    "$": 1646500,
    "address": "22 Harvard Pl",
    "parcel_id": "171-30-00",
    "owner1": "ROYCROFT, ALAN & MAUREEN",
    "owner2": "",
    "current_taxes": 16860.16,
    "new_taxes_no_override": 17588.52,
    "override_total_1": 18087.58,
    "override_increase_1": 499.06
  },
  {
    "#": "1 Harvard Sq (140-10-00)",
    "$": 2462300,
    "address": "1 Harvard Sq",
    "parcel_id": "140-10-00",
    "owner1": "BLACKWELL REALTY LLC",
    "owner2": "C/O KAPLAN, ALAN F",
    "current_taxes": 33748.73,
    "new_taxes_no_override": 35206.68,
    "override_total_1": 36205.64,
    "override_increase_1": 998.96
  },
  {
    "#": "5 Harvard Sq (140-10-01)",
    "$": 742100,
    "address": "5 Harvard Sq",
    "parcel_id": "140-10-01",
    "owner1": "SERENADE CHOCOLATIER LLC",
    "owner2": "",
    "current_taxes": 12734.44,
    "new_taxes_no_override": 13284.57,
    "override_total_1": 13661.51,
    "override_increase_1": 376.94
  },
  {
    "#": "6 Harvard Sq (140-10-02)",
    "$": 4792700,
    "address": "6 Harvard Sq",
    "parcel_id": "140-10-02",
    "owner1": "C & S REALTY LLC",
    "owner2": "C/O KAPLAN, ALAN F",
    "current_taxes": 60690.57,
    "new_taxes_no_override": 63312.4,
    "override_total_1": 65108.84,
    "override_increase_1": 1796.44
  },
  {
    "#": "1 Harvard St (140A-04-00)",
    "$": 10591200,
    "address": "1 Harvard St",
    "parcel_id": "140A-04-00",
    "owner1": "ONE HARVARD STREET LLC",
    "owner2": "C/O OCTAGON PROPERTY MGMT CORP",
    "current_taxes": 181744.99,
    "new_taxes_no_override": 189596.37,
    "override_total_1": 194976.03,
    "override_increase_1": 5379.65
  },
  {
    "#": "7 Harvard St (140A-05-00)",
    "$": 5584600,
    "address": "7 Harvard St",
    "parcel_id": "140A-05-00",
    "owner1": "RPT BROOKLINE VILLAGE LLC",
    "owner2": "",
    "current_taxes": 95831.74,
    "new_taxes_no_override": 99971.67,
    "override_total_1": 102808.29,
    "override_increase_1": 2836.62
  },
  {
    "#": "14 Harvard St (174-02-00)",
    "$": 4607700,
    "address": "14 Harvard St",
    "parcel_id": "174-02-00",
    "owner1": "TUCK, TR, JEROME M",
    "owner2": "",
    "current_taxes": 79068.13,
    "new_taxes_no_override": 82483.87,
    "override_total_1": 84824.29,
    "override_increase_1": 2340.42
  },
  {
    "#": "19 Harvard St, Unit A (141-01-00)",
    "$": 3814700,
    "address": "19 Harvard St, Unit A",
    "parcel_id": "141-01-00",
    "owner1": "BEAL ET AL TRS, BRUCE A",
    "owner2": "",
    "current_taxes": 65460.25,
    "new_taxes_no_override": 68288.13,
    "override_total_1": 70225.76,
    "override_increase_1": 1937.62
  },
  {
    "#": "27 Harvard St (141-02-00)",
    "$": 2277500,
    "address": "27 Harvard St",
    "parcel_id": "141-02-00",
    "owner1": "STAVROS LLC",
    "owner2": "",
    "current_taxes": 39081.9,
    "new_taxes_no_override": 40770.24,
    "override_total_1": 41927.06,
    "override_increase_1": 1156.82
  },
  {
    "#": "29 Harvard St (141-03-00)",
    "$": 3705400,
    "address": "29 Harvard St",
    "parcel_id": "141-03-00",
    "owner1": "MEM STATE LLC",
    "owner2": "",
    "current_taxes": 63584.66,
    "new_taxes_no_override": 66331.52,
    "override_total_1": 68213.62,
    "override_increase_1": 1882.11
  },
  {
    "#": "31 Harvard St, Unit A (141-04-00)",
    "$": 1972800,
    "address": "31 Harvard St, Unit A",
    "parcel_id": "141-04-00",
    "owner1": "31 HARVARD STREET LLC",
    "owner2": "",
    "current_taxes": 26618.19,
    "new_taxes_no_override": 27768.1,
    "override_total_1": 28555.99,
    "override_increase_1": 787.9
  },
  {
    "#": "33 Harvard St, Unit A (141-05-00)",
    "$": 3262900,
    "address": "33 Harvard St, Unit A",
    "parcel_id": "141-05-00",
    "owner1": "SLD B LLC",
    "owner2": "",
    "current_taxes": 55991.36,
    "new_taxes_no_override": 58410.19,
    "override_total_1": 60067.53,
    "override_increase_1": 1657.34
  },
  {
    "#": "35 Harvard St, Unit A, Unit 1 (141-06-03)",
    "$": 386900,
    "address": "35 Harvard St, Unit A, Unit 1",
    "parcel_id": "141-06-03",
    "owner1": "REALE, ANDREW D",
    "owner2": "",
    "current_taxes": 3961.86,
    "new_taxes_no_override": 4133.01,
    "override_total_1": 4250.28,
    "override_increase_1": 117.27
  },
  {
    "#": "35 Harvard St, Unit A, Unit 2 (141-06-04)",
    "$": 375000,
    "address": "35 Harvard St, Unit A, Unit 2",
    "parcel_id": "141-06-04",
    "owner1": "REALE, ANDREW D",
    "owner2": "",
    "current_taxes": 3840.0,
    "new_taxes_no_override": 4005.89,
    "override_total_1": 4119.55,
    "override_increase_1": 113.66
  },
  {
    "#": "35 Harvard St, Unit A, Unit 3 (141-06-05)",
    "$": 471000,
    "address": "35 Harvard St, Unit A, Unit 3",
    "parcel_id": "141-06-05",
    "owner1": "LIU, JIAN",
    "owner2": "DONG, JINGHUI",
    "current_taxes": 4823.04,
    "new_taxes_no_override": 5031.4,
    "override_total_1": 5174.16,
    "override_increase_1": 142.76
  },
  {
    "#": "35 Harvard St, Unit A, Unit 4 (141-06-06)",
    "$": 419900,
    "address": "35 Harvard St, Unit A, Unit 4",
    "parcel_id": "141-06-06",
    "owner1": "ZHANG, YING",
    "owner2": "GU, LING",
    "current_taxes": 4299.78,
    "new_taxes_no_override": 4485.53,
    "override_total_1": 4612.8,
    "override_increase_1": 127.27
  },
  {
    "#": "35 Harvard St, Unit A, Unit 5 (141-06-07)",
    "$": 412800,
    "address": "35 Harvard St, Unit A, Unit 5",
    "parcel_id": "141-06-07",
    "owner1": "COMI, RICHARD J",
    "owner2": "COLLINS, DEBORAH A",
    "current_taxes": 4227.07,
    "new_taxes_no_override": 4409.68,
    "override_total_1": 4534.8,
    "override_increase_1": 125.12
  },
  {
    "#": "35 Harvard St, Unit A, Unit 6 (141-06-08)",
    "$": 451600,
    "address": "35 Harvard St, Unit A, Unit 6",
    "parcel_id": "141-06-08",
    "owner1": "VINCENT, JENNIFER",
    "owner2": "",
    "current_taxes": 4624.38,
    "new_taxes_no_override": 4824.15,
    "override_total_1": 4961.03,
    "override_increase_1": 136.88
  },
  {
    "#": "35 Harvard St (141-06-00)",
    "$": 1482000,
    "address": "35 Harvard St",
    "parcel_id": "141-06-00",
    "owner1": "MOORE TR, JAMES VERNER",
    "owner2": "",
    "current_taxes": 16258.91,
    "new_taxes_no_override": 16961.29,
    "override_total_1": 17442.56,
    "override_increase_1": 481.26
  },
  {
    "#": "37 Harvard St (141-06-02)",
    "$": 2290700,
    "address": "37 Harvard St",
    "parcel_id": "141-06-02",
    "owner1": "37 HARVARD LLC",
    "owner2": "C/O THRIVE REALTY PARTNERS",
    "current_taxes": 27578.13,
    "new_taxes_no_override": 28769.51,
    "override_total_1": 29585.82,
    "override_increase_1": 816.31
  },
  {
    "#": "39 Harvard St (141-07-00)",
    "$": 2015700,
    "address": "39 Harvard St",
    "parcel_id": "141-07-00",
    "owner1": "NOVA INVESTMENT MA LLC",
    "owner2": "C/O HUANG, CONNIE",
    "current_taxes": 34589.41,
    "new_taxes_no_override": 36083.67,
    "override_total_1": 37107.52,
    "override_increase_1": 1023.85
  },
  {
    "#": "41 Harvard St (141-07-01)",
    "$": 2338800,
    "address": "41 Harvard St",
    "parcel_id": "141-07-01",
    "owner1": "OBOY TR, KEVIN M",
    "owner2": "",
    "current_taxes": 28296.56,
    "new_taxes_no_override": 29518.97,
    "override_total_1": 30356.55,
    "override_increase_1": 837.58
  },
  {
    "#": "43 Harvard St (141-08-00)",
    "$": 3473900,
    "address": "43 Harvard St",
    "parcel_id": "141-08-00",
    "owner1": "HARVARD LINDEN LLC",
    "owner2": "",
    "current_taxes": 44706.13,
    "new_taxes_no_override": 46637.43,
    "override_total_1": 47960.74,
    "override_increase_1": 1323.3
  },
  {
    "#": "54 Harvard St (172-08-00)",
    "$": 2122000,
    "address": "54 Harvard St",
    "parcel_id": "172-08-00",
    "owner1": "54 HARVARD LLC",
    "owner2": "C/O THRIVE REALTY PARTNERS",
    "current_taxes": 29218.15,
    "new_taxes_no_override": 30480.37,
    "override_total_1": 31345.23,
    "override_increase_1": 864.86
  },
  {
    "#": "56 Harvard St (172-07-00)",
    "$": 2031100,
    "address": "56 Harvard St",
    "parcel_id": "172-07-00",
    "owner1": "SEEFAR LLC",
    "owner2": "",
    "current_taxes": 31760.93,
    "new_taxes_no_override": 33133.0,
    "override_total_1": 34073.13,
    "override_increase_1": 940.12
  },
  {
    "#": "58 Harvard St (172-06-00)",
    "$": 2023600,
    "address": "58 Harvard St",
    "parcel_id": "172-06-00",
    "owner1": "58 HARVARD STREET LLC",
    "owner2": "",
    "current_taxes": 24776.02,
    "new_taxes_no_override": 25846.34,
    "override_total_1": 26579.71,
    "override_increase_1": 733.37
  },
  {
    "#": "60 Harvard St (172-05-10)",
    "$": 9948000,
    "address": "60 Harvard St",
    "parcel_id": "172-05-10",
    "owner1": "STARIKOV TR, FRED",
    "owner2": "",
    "current_taxes": 161255.18,
    "new_taxes_no_override": 168221.4,
    "override_total_1": 172994.56,
    "override_increase_1": 4773.15
  },
  {
    "#": "67 Harvard St (148-01-02)",
    "$": 18413800,
    "address": "67 Harvard St",
    "parcel_id": "148-01-02",
    "owner1": "ROMAN CATHOLIC ARCHBISHOP OF BOSTON",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "68 Harvard St (172-04-00)",
    "$": 4127600,
    "address": "68 Harvard St",
    "parcel_id": "172-04-00",
    "owner1": "GOLDEN, TR, ROBERT E",
    "owner2": "",
    "current_taxes": 70829.62,
    "new_taxes_no_override": 73889.46,
    "override_total_1": 75986.02,
    "override_increase_1": 2096.56
  },
  {
    "#": "75 Harvard St (154-05-00)",
    "$": 12370100,
    "address": "75 Harvard St",
    "parcel_id": "154-05-00",
    "owner1": "75 87 HARVARD STREET LLC",
    "owner2": "",
    "current_taxes": 161790.88,
    "new_taxes_no_override": 168780.25,
    "override_total_1": 173569.26,
    "override_increase_1": 4789.01
  },
  {
    "#": "92 Harvard St (171-35-37)",
    "$": 2484000,
    "address": "92 Harvard St",
    "parcel_id": "171-35-37",
    "owner1": "EVANGELAKOS, WILLIAM & ELENI",
    "owner2": "",
    "current_taxes": 25436.16,
    "new_taxes_no_override": 26535.0,
    "override_total_1": 27287.91,
    "override_increase_1": 752.91
  },
  {
    "#": "99 Harvard St (155-12-18)",
    "$": 9812200,
    "address": "99 Harvard St",
    "parcel_id": "155-12-18",
    "owner1": "LONGWOOD BUICK LLC",
    "owner2": "C/O WALGREENS TAX DEPT",
    "current_taxes": 168377.35,
    "new_taxes_no_override": 175651.25,
    "override_total_1": 180635.22,
    "override_increase_1": 4983.97
  },
  {
    "#": "100 Harvard St, Unit 8 & P8-G8 (171-29-08)",
    "$": 1091000,
    "address": "100 Harvard St, Unit 8 & P8-G8",
    "parcel_id": "171-29-08",
    "owner1": "GOUD, AJAY & NIPA",
    "owner2": "",
    "current_taxes": 11171.84,
    "new_taxes_no_override": 11654.46,
    "override_total_1": 11985.15,
    "override_increase_1": 330.69
  },
  {
    "#": "102 Harvard St, Unit 2 & G2 (171-29-02)",
    "$": 743600,
    "address": "102 Harvard St, Unit 2 & G2",
    "parcel_id": "171-29-02",
    "owner1": "HURWITZ, STACEY",
    "owner2": "",
    "current_taxes": 3979.53,
    "new_taxes_no_override": 4151.45,
    "override_total_1": 4269.24,
    "override_increase_1": 117.79
  },
  {
    "#": "104 Harvard St, Unit 6 & P6-G6 (171-29-06)",
    "$": 1300100,
    "address": "104 Harvard St, Unit 6 & P6-G6",
    "parcel_id": "171-29-06",
    "owner1": "KRAMER, ANNE R",
    "owner2": "",
    "current_taxes": 13313.02,
    "new_taxes_no_override": 13888.14,
    "override_total_1": 14282.21,
    "override_increase_1": 394.07
  },
  {
    "#": "106 Harvard St, Unit 5 & P5-G5 (171-29-05)",
    "$": 1375500,
    "address": "106 Harvard St, Unit 5 & P5-G5",
    "parcel_id": "171-29-05",
    "owner1": "MAHAGITSIRI, AUSANEE",
    "owner2": "",
    "current_taxes": 14085.12,
    "new_taxes_no_override": 14693.6,
    "override_total_1": 15110.52,
    "override_increase_1": 416.92
  },
  {
    "#": "108 Harvard St, Unit 1 & P1-G1 (171-29-01)",
    "$": 985500,
    "address": "108 Harvard St, Unit 1 & P1-G1",
    "parcel_id": "171-29-01",
    "owner1": "ZHAO, BINHAO LINDSEY",
    "owner2": "PERSELS, SHAWN D",
    "current_taxes": 10091.52,
    "new_taxes_no_override": 10527.47,
    "override_total_1": 10826.18,
    "override_increase_1": 298.71
  },
  {
    "#": "108 Harvard St, Unit 4 & P4-G4 (171-29-04)",
    "$": 1524600,
    "address": "108 Harvard St, Unit 4 & P4-G4",
    "parcel_id": "171-29-04",
    "owner1": "ARONSON, SAMUEL J",
    "owner2": "LEE, WAN-CHIUN",
    "current_taxes": 11976.97,
    "new_taxes_no_override": 12494.38,
    "override_total_1": 12848.89,
    "override_increase_1": 354.52
  },
  {
    "#": "108 Harvard St, Unit 7 & P3-G7 (171-29-07)",
    "$": 1383200,
    "address": "108 Harvard St, Unit 7 & P3-G7",
    "parcel_id": "171-29-07",
    "owner1": "GOUD, AJAY & NIPA",
    "owner2": "",
    "current_taxes": 14163.97,
    "new_taxes_no_override": 14775.85,
    "override_total_1": 15195.11,
    "override_increase_1": 419.25
  },
  {
    "#": "111 Harvard St (155-21-22)",
    "$": 3787300,
    "address": "111 Harvard St",
    "parcel_id": "155-21-22",
    "owner1": "HARVARD 111 LP",
    "owner2": "",
    "current_taxes": 64990.07,
    "new_taxes_no_override": 67797.64,
    "override_total_1": 69721.35,
    "override_increase_1": 1923.71
  },
  {
    "#": "114 Harvard St (170-18-01)",
    "$": 2695900,
    "address": "114 Harvard St",
    "parcel_id": "170-18-01",
    "owner1": "PECK TRS, JANE KAPLAN & NATHAN",
    "owner2": "C/O 116 HARVARD STREET LLC",
    "current_taxes": 46261.64,
    "new_taxes_no_override": 48260.14,
    "override_total_1": 49629.49,
    "override_increase_1": 1369.34
  },
  {
    "#": "123 Harvard St (155-23-00)",
    "$": 2363400,
    "address": "123 Harvard St",
    "parcel_id": "155-23-00",
    "owner1": "WILLIAMS, DANIEL E",
    "owner2": "",
    "current_taxes": 35542.33,
    "new_taxes_no_override": 37077.76,
    "override_total_1": 38129.81,
    "override_increase_1": 1052.05
  },
  {
    "#": "124 Harvard St (170-18-00)",
    "$": 2587800,
    "address": "124 Harvard St",
    "parcel_id": "170-18-00",
    "owner1": "SUDALTER, TRS, MELVYN S & SIMONE H",
    "owner2": "",
    "current_taxes": 44406.65,
    "new_taxes_no_override": 46325.02,
    "override_total_1": 47639.45,
    "override_increase_1": 1314.44
  },
  {
    "#": "126 Harvard St (170-17-00)",
    "$": 2588500,
    "address": "126 Harvard St",
    "parcel_id": "170-17-00",
    "owner1": "HARVARD BROOKLINE LLC",
    "owner2": "",
    "current_taxes": 37481.08,
    "new_taxes_no_override": 39100.26,
    "override_total_1": 40209.7,
    "override_increase_1": 1109.44
  },
  {
    "#": "127 Harvard St (155-24-00)",
    "$": 12264210,
    "address": "127 Harvard St",
    "parcel_id": "155-24-00",
    "owner1": "CAUSE DU JOUR FOUNDATION",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "130 Harvard St (170-16-00)",
    "$": 2532200,
    "address": "130 Harvard St",
    "parcel_id": "170-16-00",
    "owner1": "ROWE, TR, MARIA FRANCESCA",
    "owner2": "",
    "current_taxes": 34615.71,
    "new_taxes_no_override": 36111.11,
    "override_total_1": 37135.73,
    "override_increase_1": 1024.63
  },
  {
    "#": "137 Harvard St (155-25-00)",
    "$": 4174300,
    "address": "137 Harvard St",
    "parcel_id": "155-25-00",
    "owner1": "SMITH ET AL TRS, MARC E",
    "owner2": "C/O AHOLD FINANCIAL SERVICES",
    "current_taxes": 71630.99,
    "new_taxes_no_override": 74725.45,
    "override_total_1": 76845.73,
    "override_increase_1": 2120.28
  },
  {
    "#": "138 Harvard St (169-24-00)",
    "$": 7178500,
    "address": "138 Harvard St",
    "parcel_id": "169-24-00",
    "owner1": "MCADAMS, TR, PAUL",
    "owner2": "C/O BRIGHT HORIZONS FAM SOLUT",
    "current_taxes": 73507.84,
    "new_taxes_no_override": 76683.38,
    "override_total_1": 78859.21,
    "override_increase_1": 2175.83
  },
  {
    "#": "142 Harvard St (169-23-00)",
    "$": 2384000,
    "address": "142 Harvard St",
    "parcel_id": "169-23-00",
    "owner1": "MING ON WONG 2001 FAMILY, PARTNERSHIP LLC",
    "owner2": "",
    "current_taxes": 40909.44,
    "new_taxes_no_override": 42676.73,
    "override_total_1": 43887.65,
    "override_increase_1": 1210.92
  },
  {
    "#": "143 Harvard St (155-20-00)",
    "$": 2808500,
    "address": "143 Harvard St",
    "parcel_id": "155-20-00",
    "owner1": "M & E REALTY ASSOCIATES LLC",
    "owner2": "",
    "current_taxes": 48193.86,
    "new_taxes_no_override": 50275.83,
    "override_total_1": 51702.37,
    "override_increase_1": 1426.54
  },
  {
    "#": "149 Harvard St (155-26-00)",
    "$": 3162500,
    "address": "149 Harvard St",
    "parcel_id": "155-26-00",
    "owner1": "COAKLEY ET AL TRS, MARY E",
    "owner2": "C/O AHOLD FINANCIAL SERVICES",
    "current_taxes": 54268.5,
    "new_taxes_no_override": 56612.9,
    "override_total_1": 58219.25,
    "override_increase_1": 1606.35
  },
  {
    "#": "152 Harvard St, Unit 2 (168-01-01)",
    "$": 902400,
    "address": "152 Harvard St, Unit 2",
    "parcel_id": "168-01-01",
    "owner1": "TSELEVICH, ALEKSANDR & MARIA",
    "owner2": "",
    "current_taxes": 9240.58,
    "new_taxes_no_override": 9639.77,
    "override_total_1": 9913.29,
    "override_increase_1": 273.52
  },
  {
    "#": "152 Harvard St, Unit 4 (168-01-02)",
    "$": 939800,
    "address": "152 Harvard St, Unit 4",
    "parcel_id": "168-01-02",
    "owner1": "VAN DER HEIDEN, JEREMY F",
    "owner2": "HANCE, ELIZABETH K",
    "current_taxes": 5988.62,
    "new_taxes_no_override": 6247.33,
    "override_total_1": 6424.59,
    "override_increase_1": 177.26
  },
  {
    "#": "152 Harvard St, Unit 6 (168-01-03)",
    "$": 909000,
    "address": "152 Harvard St, Unit 6",
    "parcel_id": "168-01-03",
    "owner1": "FLAHERTY TRS, JOSEPH P",
    "owner2": "ARDIFF, EMMA C",
    "current_taxes": 9308.16,
    "new_taxes_no_override": 9710.27,
    "override_total_1": 9985.79,
    "override_increase_1": 275.52
  },
  {
    "#": "152 Harvard St, Unit 8 (168-01-04)",
    "$": 932500,
    "address": "152 Harvard St, Unit 8",
    "parcel_id": "168-01-04",
    "owner1": "MCGILLICUDDY, DIANE",
    "owner2": "",
    "current_taxes": 9548.8,
    "new_taxes_no_override": 9961.31,
    "override_total_1": 10243.95,
    "override_increase_1": 282.64
  },
  {
    "#": "154 Harvard St, Unit 1 (168-01-05)",
    "$": 890300,
    "address": "154 Harvard St, Unit 1",
    "parcel_id": "168-01-05",
    "owner1": "BALMAZI TR, LEON",
    "owner2": "",
    "current_taxes": 9116.67,
    "new_taxes_no_override": 9510.51,
    "override_total_1": 9780.36,
    "override_increase_1": 269.85
  },
  {
    "#": "154 Harvard St, Unit 3 (168-01-06)",
    "$": 896600,
    "address": "154 Harvard St, Unit 3",
    "parcel_id": "168-01-06",
    "owner1": "MANNAR, SATEESH KUMAR",
    "owner2": "SATEESH, SHASHIREKHA",
    "current_taxes": 9181.18,
    "new_taxes_no_override": 9577.81,
    "override_total_1": 9849.57,
    "override_increase_1": 271.76
  },
  {
    "#": "154 Harvard St, Unit 5 (168-01-07)",
    "$": 897400,
    "address": "154 Harvard St, Unit 5",
    "parcel_id": "168-01-07",
    "owner1": "REZAVKER, FELIX",
    "owner2": "PITTEL, JULIA",
    "current_taxes": 5554.44,
    "new_taxes_no_override": 5794.39,
    "override_total_1": 5958.8,
    "override_increase_1": 164.41
  },
  {
    "#": "154 Harvard St, Unit 7 (168-01-08)",
    "$": 890300,
    "address": "154 Harvard St, Unit 7",
    "parcel_id": "168-01-08",
    "owner1": "BALMAZI TR, VERA",
    "owner2": "",
    "current_taxes": 9116.67,
    "new_taxes_no_override": 9510.51,
    "override_total_1": 9780.36,
    "override_increase_1": 269.85
  },
  {
    "#": "155 Harvard St (155-27-00)",
    "$": 18344900,
    "address": "155 Harvard St",
    "parcel_id": "155-27-00",
    "owner1": "THE STOP & SHOP SUPERMARKET COMPANY LLC",
    "owner2": "C/O RETAIL BUSINESS SERVICES",
    "current_taxes": 314798.48,
    "new_taxes_no_override": 328397.77,
    "override_total_1": 337715.81,
    "override_increase_1": 9318.04
  },
  {
    "#": "156 Harvard St, Unit 2 (168-01-09)",
    "$": 893700,
    "address": "156 Harvard St, Unit 2",
    "parcel_id": "168-01-09",
    "owner1": "YIP, SAMUEL M",
    "owner2": "YOU, DAICHAO",
    "current_taxes": 9151.49,
    "new_taxes_no_override": 9546.83,
    "override_total_1": 9817.72,
    "override_increase_1": 270.88
  },
  {
    "#": "156 Harvard St, Unit 4 (168-01-10)",
    "$": 925000,
    "address": "156 Harvard St, Unit 4",
    "parcel_id": "168-01-10",
    "owner1": "KURMAKOV TRS, ALEKSEY N & ANDREY N",
    "owner2": "",
    "current_taxes": 9472.0,
    "new_taxes_no_override": 9881.19,
    "override_total_1": 10161.56,
    "override_increase_1": 280.37
  },
  {
    "#": "156 Harvard St, Unit 6 (168-01-11)",
    "$": 893400,
    "address": "156 Harvard St, Unit 6",
    "parcel_id": "168-01-11",
    "owner1": "RYZHIK, WOLF & LEYA",
    "owner2": "",
    "current_taxes": 5513.48,
    "new_taxes_no_override": 5751.66,
    "override_total_1": 5914.86,
    "override_increase_1": 163.2
  },
  {
    "#": "156 Harvard St, Unit 8 (168-01-12)",
    "$": 932000,
    "address": "156 Harvard St, Unit 8",
    "parcel_id": "168-01-12",
    "owner1": "LI TR, WENJUN",
    "owner2": "",
    "current_taxes": 9543.68,
    "new_taxes_no_override": 9955.97,
    "override_total_1": 10238.46,
    "override_increase_1": 282.49
  },
  {
    "#": "158 Harvard St, Unit 1 (168-01-13)",
    "$": 903700,
    "address": "158 Harvard St, Unit 1",
    "parcel_id": "168-01-13",
    "owner1": "DAMODARAN, VINDOKUMAR",
    "owner2": "MUNIKRISHNAN, LAVANYA PENNASWAMY",
    "current_taxes": 9253.89,
    "new_taxes_no_override": 9653.66,
    "override_total_1": 9927.57,
    "override_increase_1": 273.92
  },
  {
    "#": "158 Harvard St, Unit 3 (168-01-14)",
    "$": 887200,
    "address": "158 Harvard St, Unit 3",
    "parcel_id": "168-01-14",
    "owner1": "KIM, BOCKSOON",
    "owner2": "",
    "current_taxes": 9084.93,
    "new_taxes_no_override": 9477.4,
    "override_total_1": 9746.31,
    "override_increase_1": 268.91
  },
  {
    "#": "158 Harvard St, Unit 5 (168-01-15)",
    "$": 898200,
    "address": "158 Harvard St, Unit 5",
    "parcel_id": "168-01-15",
    "owner1": "CHANANA, ISHA",
    "owner2": "MANCHANDA, VINAYAK",
    "current_taxes": 5562.63,
    "new_taxes_no_override": 5802.94,
    "override_total_1": 5967.59,
    "override_increase_1": 164.65
  },
  {
    "#": "158 Harvard St, Unit 7 (168-01-16)",
    "$": 910800,
    "address": "158 Harvard St, Unit 7",
    "parcel_id": "168-01-16",
    "owner1": "PRICE, GEORGE",
    "owner2": "SONG, JIAHUI",
    "current_taxes": 5691.66,
    "new_taxes_no_override": 5937.54,
    "override_total_1": 6106.01,
    "override_increase_1": 168.47
  },
  {
    "#": "171 Harvard St (155-28-00)",
    "$": 4043800,
    "address": "171 Harvard St",
    "parcel_id": "155-28-00",
    "owner1": "MARCOR REALTY LLC",
    "owner2": "C/O NORDBLOM COMPANYY",
    "current_taxes": 46434.54,
    "new_taxes_no_override": 48440.51,
    "override_total_1": 49814.97,
    "override_increase_1": 1374.46
  },
  {
    "#": "175 Harvard St (155-29-00)",
    "$": 2934600,
    "address": "175 Harvard St",
    "parcel_id": "155-29-00",
    "owner1": "TOOBIAN TRS, SAIED & NAHID",
    "owner2": "",
    "current_taxes": 30050.3,
    "new_taxes_no_override": 31348.47,
    "override_total_1": 32237.96,
    "override_increase_1": 889.49
  },
  {
    "#": "179 Harvard St (155-30-00)",
    "$": 3079300,
    "address": "179 Harvard St",
    "parcel_id": "155-30-00",
    "owner1": "CHOW, SHU KOON",
    "owner2": "",
    "current_taxes": 27897.1,
    "new_taxes_no_override": 29102.25,
    "override_total_1": 29928.01,
    "override_increase_1": 825.75
  },
  {
    "#": "181 Harvard St (155-31-00)",
    "$": 3207200,
    "address": "181 Harvard St",
    "parcel_id": "155-31-00",
    "owner1": "DANESH TRS, MORDECAI M & HELEN & DAVID H",
    "owner2": "HILLERY, MATTHEW R",
    "current_taxes": 32841.73,
    "new_taxes_no_override": 34260.49,
    "override_total_1": 35232.61,
    "override_increase_1": 972.12
  },
  {
    "#": "185 Harvard St (156-11-02)",
    "$": 5451400,
    "address": "185 Harvard St",
    "parcel_id": "156-11-02",
    "owner1": "MACROPOULOS, ET AL, DEMETRIOS",
    "owner2": "C/O ALTON REALTY TRUST",
    "current_taxes": 93546.02,
    "new_taxes_no_override": 97587.21,
    "override_total_1": 100356.17,
    "override_increase_1": 2768.96
  },
  {
    "#": "190 Harvard St (167-24-00)",
    "$": 13728000,
    "address": "190 Harvard St",
    "parcel_id": "167-24-00",
    "owner1": "BROOKLINE HOUSING AUTHORITY",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "198 Harvard St (167-23-00)",
    "$": 3860400,
    "address": "198 Harvard St",
    "parcel_id": "167-23-00",
    "owner1": "GLOBAL COMPANIES LLC",
    "owner2": "C/O ALLIANCE ENERGY LLC, ATTN TAX DEPT",
    "current_taxes": 66244.46,
    "new_taxes_no_override": 69106.22,
    "override_total_1": 71067.06,
    "override_increase_1": 1960.84
  },
  {
    "#": "209 Harvard St (156-12-00)",
    "$": 13143700,
    "address": "209 Harvard St",
    "parcel_id": "156-12-00",
    "owner1": "209 HARVARD STREET LLC",
    "owner2": "",
    "current_taxes": 225545.89,
    "new_taxes_no_override": 235289.47,
    "override_total_1": 241965.63,
    "override_increase_1": 6676.16
  },
  {
    "#": "210 Harvard St (164-06-00)",
    "$": 15029800,
    "address": "210 Harvard St",
    "parcel_id": "164-06-00",
    "owner1": "UNITED PARISH IN BROOKLINE",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "217 Harvard St (156-13-00)",
    "$": 14763200,
    "address": "217 Harvard St",
    "parcel_id": "156-13-00",
    "owner1": "217-221 HARVARD STREET LLC",
    "owner2": "",
    "current_taxes": 151175.17,
    "new_taxes_no_override": 157705.94,
    "override_total_1": 162180.72,
    "override_increase_1": 4474.79
  },
  {
    "#": "224 Harvard St (164-05-00)",
    "$": 7870500,
    "address": "224 Harvard St",
    "parcel_id": "164-05-00",
    "owner1": "CHOW TRS, ALAN S & KRIS C",
    "owner2": "",
    "current_taxes": 135057.78,
    "new_taxes_no_override": 140892.28,
    "override_total_1": 144889.99,
    "override_increase_1": 3997.71
  },
  {
    "#": "238 Harvard St (163-02-00)",
    "$": 6256900,
    "address": "238 Harvard St",
    "parcel_id": "163-02-00",
    "owner1": "WEBSTER-COOLIDGE ASSOCIATES LLC",
    "owner2": "C/O SALTER & KAHN INC",
    "current_taxes": 107368.4,
    "new_taxes_no_override": 112006.71,
    "override_total_1": 115184.82,
    "override_increase_1": 3178.1
  },
  {
    "#": "279 Harvard St (045-04-05)",
    "$": 12807500,
    "address": "279 Harvard St",
    "parcel_id": "045-04-05",
    "owner1": "TUCK, ET AL TRS, JEROME",
    "owner2": "",
    "current_taxes": 219776.7,
    "new_taxes_no_override": 229271.05,
    "override_total_1": 235776.44,
    "override_increase_1": 6505.39
  },
  {
    "#": "280 Harvard St (082-09-00)",
    "$": 14486700,
    "address": "280 Harvard St",
    "parcel_id": "082-09-00",
    "owner1": "BROWN TRS, JAMESON & RONALD",
    "owner2": "",
    "current_taxes": 70654.65,
    "new_taxes_no_override": 73706.93,
    "override_total_1": 75798.31,
    "override_increase_1": 2091.38
  },
  {
    "#": "289 Harvard St, Unit A (047A-01-00)",
    "$": 9666200,
    "address": "289 Harvard St, Unit A",
    "parcel_id": "047A-01-00",
    "owner1": "HARVARD GREEN CORNER LLC",
    "owner2": "",
    "current_taxes": 165871.99,
    "new_taxes_no_override": 173037.66,
    "override_total_1": 177947.47,
    "override_increase_1": 4909.81
  },
  {
    "#": "294 Harvard St, Unit A (082-07-08)",
    "$": 25014600,
    "address": "294 Harvard St, Unit A",
    "parcel_id": "082-07-08",
    "owner1": "BROOKLINE INVEST LP",
    "owner2": "",
    "current_taxes": 401564.7,
    "new_taxes_no_override": 418912.3,
    "override_total_1": 430798.61,
    "override_increase_1": 11886.32
  },
  {
    "#": "299 Harvard St, Unit A (047A-02-00)",
    "$": 5822300,
    "address": "299 Harvard St, Unit A",
    "parcel_id": "047A-02-00",
    "owner1": "WHITTEMORE TR, EDWIN P",
    "owner2": "C/O 299 HARVARD ST",
    "current_taxes": 99910.67,
    "new_taxes_no_override": 104226.81,
    "override_total_1": 107184.17,
    "override_increase_1": 2957.36
  },
  {
    "#": "301 Harvard St, Unit A (047A-02-01)",
    "$": 7546000,
    "address": "301 Harvard St, Unit A",
    "parcel_id": "047A-02-01",
    "owner1": "PAGOUNIS TRS, GEORGE & BESSIE",
    "owner2": "",
    "current_taxes": 129489.36,
    "new_taxes_no_override": 135083.3,
    "override_total_1": 138916.19,
    "override_increase_1": 3832.89
  },
  {
    "#": "305 Harvard St, Unit B (047A-03-00)",
    "$": 11324900,
    "address": "305 Harvard St, Unit B",
    "parcel_id": "047A-03-00",
    "owner1": "313 HARVARD STREET LLC",
    "owner2": "C/O DIMARCO, STEPHEN",
    "current_taxes": 194335.28,
    "new_taxes_no_override": 202730.56,
    "override_total_1": 208482.89,
    "override_increase_1": 5752.32
  },
  {
    "#": "308 Harvard St, Unit A (082-06-00)",
    "$": 8837600,
    "address": "308 Harvard St, Unit A",
    "parcel_id": "082-06-00",
    "owner1": "JMT INVESTMENT LLC",
    "owner2": "C/O THE BLAKLEY GROUP",
    "current_taxes": 151653.22,
    "new_taxes_no_override": 158204.64,
    "override_total_1": 162693.57,
    "override_increase_1": 4488.94
  },
  {
    "#": "314 Harvard St, Unit A (082-05-00)",
    "$": 6742100,
    "address": "314 Harvard St, Unit A",
    "parcel_id": "082-05-00",
    "owner1": "LEEDER ET AL TRS, EARLE",
    "owner2": "",
    "current_taxes": 115694.44,
    "new_taxes_no_override": 120692.44,
    "override_total_1": 124117.0,
    "override_increase_1": 3424.56
  },
  {
    "#": "315 Harvard St (048-12-00)",
    "$": 17855400,
    "address": "315 Harvard St",
    "parcel_id": "048-12-00",
    "owner1": "WELD, ET AL TRS, EDWARD W",
    "owner2": "C/O HUNNEMAN MANAGEMENT CO",
    "current_taxes": 306398.66,
    "new_taxes_no_override": 319635.08,
    "override_total_1": 328704.48,
    "override_increase_1": 9069.4
  },
  {
    "#": "322 Harvard St, Unit 1 (082-04-03)",
    "$": 1642200,
    "address": "322 Harvard St, Unit 1",
    "parcel_id": "082-04-03",
    "owner1": "LEEDER, TRS, EARLE & JUDITH",
    "owner2": "",
    "current_taxes": 28180.15,
    "new_taxes_no_override": 29397.53,
    "override_total_1": 30231.66,
    "override_increase_1": 834.13
  },
  {
    "#": "324 Harvard St, Unit 2 (082-04-01)",
    "$": 901600,
    "address": "324 Harvard St, Unit 2",
    "parcel_id": "082-04-01",
    "owner1": "LEEDER, TRS, EARLE & JUDITH",
    "owner2": "",
    "current_taxes": 15471.46,
    "new_taxes_no_override": 16139.83,
    "override_total_1": 16597.78,
    "override_increase_1": 457.96
  },
  {
    "#": "326 Harvard St, Unit 3 (082-04-02)",
    "$": 1522700,
    "address": "326 Harvard St, Unit 3",
    "parcel_id": "082-04-02",
    "owner1": "LEEDER TR, JUDITH",
    "owner2": "C/O LEEDER MANAGEMENT CO",
    "current_taxes": 26129.53,
    "new_taxes_no_override": 27258.33,
    "override_total_1": 28031.76,
    "override_increase_1": 773.43
  },
  {
    "#": "340 Harvard St (082-01-00)",
    "$": 2127800,
    "address": "340 Harvard St",
    "parcel_id": "082-01-00",
    "owner1": "CHENG LIFE ESTATE, JOYCE O",
    "owner2": "",
    "current_taxes": 21788.67,
    "new_taxes_no_override": 22729.94,
    "override_total_1": 23374.89,
    "override_increase_1": 644.94
  },
  {
    "#": "342 Harvard St (082-28-00)",
    "$": 2030300,
    "address": "342 Harvard St",
    "parcel_id": "082-28-00",
    "owner1": "LIM, TR, SHEILA C",
    "owner2": "",
    "current_taxes": 20790.27,
    "new_taxes_no_override": 21688.41,
    "override_total_1": 22303.8,
    "override_increase_1": 615.39
  },
  {
    "#": "344 Harvard St (082-27-00)",
    "$": 2830700,
    "address": "344 Harvard St",
    "parcel_id": "082-27-00",
    "owner1": "BERGER, MICHAEL L",
    "owner2": "",
    "current_taxes": 41718.75,
    "new_taxes_no_override": 43521.0,
    "override_total_1": 44755.88,
    "override_increase_1": 1234.88
  },
  {
    "#": "345 Harvard St (048-13-00)",
    "$": 147773200,
    "address": "345 Harvard St",
    "parcel_id": "048-13-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O FLORIDA RUFFIN RIDLEY SCHOOL",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "356 Harvard St (081-03-00)",
    "$": 2882600,
    "address": "356 Harvard St",
    "parcel_id": "081-03-00",
    "owner1": "ROGARIS, TR, CHRISTOS J",
    "owner2": "C/O C N E REALTY",
    "current_taxes": 49465.42,
    "new_taxes_no_override": 51602.33,
    "override_total_1": 53066.5,
    "override_increase_1": 1464.18
  },
  {
    "#": "360 Harvard St (081-02-00)",
    "$": 2283900,
    "address": "360 Harvard St",
    "parcel_id": "081-02-00",
    "owner1": "JUNIPER ENTERPRISES LP",
    "owner2": "",
    "current_taxes": 39191.72,
    "new_taxes_no_override": 40884.8,
    "override_total_1": 42044.88,
    "override_increase_1": 1160.07
  },
  {
    "#": "364 Harvard St (081-01-00)",
    "$": 1903500,
    "address": "364 Harvard St",
    "parcel_id": "081-01-00",
    "owner1": "CUTTLER, TR, LILYAN",
    "owner2": "",
    "current_taxes": 24922.56,
    "new_taxes_no_override": 25999.21,
    "override_total_1": 26736.92,
    "override_increase_1": 737.71
  },
  {
    "#": "367 Harvard St, Unit 1 & P3 (050-01-07)",
    "$": 1733800,
    "address": "367 Harvard St, Unit 1 & P3",
    "parcel_id": "050-01-07",
    "owner1": "367 PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 29752.01,
    "new_taxes_no_override": 31037.3,
    "override_total_1": 31917.96,
    "override_increase_1": 880.66
  },
  {
    "#": "367 Harvard St, Unit 2 (050-01-08)",
    "$": 1218800,
    "address": "367 Harvard St, Unit 2",
    "parcel_id": "050-01-08",
    "owner1": "REN, GENG",
    "owner2": "MIAO, XIAO CHI",
    "current_taxes": 8845.58,
    "new_taxes_no_override": 9227.71,
    "override_total_1": 9489.54,
    "override_increase_1": 261.83
  },
  {
    "#": "367 Harvard St, Unit 3 (050-01-09)",
    "$": 1023400,
    "address": "367 Harvard St, Unit 3",
    "parcel_id": "050-01-09",
    "owner1": "GAY TRS, GEORGE EDWARD HARPER JR",
    "owner2": "BARNETT, HALIMA SHAKURA",
    "current_taxes": 6844.68,
    "new_taxes_no_override": 7140.37,
    "override_total_1": 7342.97,
    "override_increase_1": 202.6
  },
  {
    "#": "369 Harvard St, Unit 1 (050-01-10)",
    "$": 1168200,
    "address": "369 Harvard St, Unit 1",
    "parcel_id": "050-01-10",
    "owner1": "D A A ENTERPRISES INC",
    "owner2": "",
    "current_taxes": 20046.31,
    "new_taxes_no_override": 20912.31,
    "override_total_1": 21505.68,
    "override_increase_1": 593.37
  },
  {
    "#": "369 Harvard St, Unit 2 (050-01-11)",
    "$": 1072900,
    "address": "369 Harvard St, Unit 2",
    "parcel_id": "050-01-11",
    "owner1": "GUNAWARDENE, SAMANTHA C",
    "owner2": "",
    "current_taxes": 7351.56,
    "new_taxes_no_override": 7669.15,
    "override_total_1": 7886.75,
    "override_increase_1": 217.61
  },
  {
    "#": "369 Harvard St, Unit 3 (050-01-12)",
    "$": 962900,
    "address": "369 Harvard St, Unit 3",
    "parcel_id": "050-01-12",
    "owner1": "HOUGH, JAMES",
    "owner2": "",
    "current_taxes": 9860.1,
    "new_taxes_no_override": 10286.06,
    "override_total_1": 10577.92,
    "override_increase_1": 291.86
  },
  {
    "#": "370 Harvard St (078-08-00)",
    "$": 11600000,
    "address": "370 Harvard St",
    "parcel_id": "078-08-00",
    "owner1": "CONGREGATION KEHILLATH ISRAEL",
    "owner2": "C/O 2LIFE 370 HARVARD LLC",
    "current_taxes": 120389.44,
    "new_taxes_no_override": 125590.26,
    "override_total_1": 129153.79,
    "override_increase_1": 3563.53
  },
  {
    "#": "373 Harvard St, Unit 1 & P10 (050-02-01)",
    "$": 1400200,
    "address": "373 Harvard St, Unit 1 & P10",
    "parcel_id": "050-02-01",
    "owner1": "KAPUR, GAUTAM",
    "owner2": "SHANKAR, SANGEETA",
    "current_taxes": 14338.05,
    "new_taxes_no_override": 14957.45,
    "override_total_1": 15381.86,
    "override_increase_1": 424.41
  },
  {
    "#": "373 Harvard St, Unit 2 (050-02-02)",
    "$": 1101900,
    "address": "373 Harvard St, Unit 2",
    "parcel_id": "050-02-02",
    "owner1": "BHAT, NARENDRANATH",
    "owner2": "AGARWAL, RASHI",
    "current_taxes": 11283.46,
    "new_taxes_no_override": 11770.91,
    "override_total_1": 12104.9,
    "override_increase_1": 333.99
  },
  {
    "#": "373 Harvard St, Unit 3 & P11 (050-02-03)",
    "$": 1542400,
    "address": "373 Harvard St, Unit 3 & P11",
    "parcel_id": "050-02-03",
    "owner1": "RIZIKA, ROBERT & DANIELLE",
    "owner2": "",
    "current_taxes": 15794.18,
    "new_taxes_no_override": 16476.49,
    "override_total_1": 16944.0,
    "override_increase_1": 467.51
  },
  {
    "#": "373 Harvard St, Unit 4 & P9 (050-02-04)",
    "$": 2376000,
    "address": "373 Harvard St, Unit 4 & P9",
    "parcel_id": "050-02-04",
    "owner1": "LEIGH, DAMIEN J & MARY JANE",
    "owner2": "",
    "current_taxes": 20695.31,
    "new_taxes_no_override": 21589.35,
    "override_total_1": 22201.93,
    "override_increase_1": 612.58
  },
  {
    "#": "375 Harvard St (050-03-00)",
    "$": 5086500,
    "address": "375 Harvard St",
    "parcel_id": "050-03-00",
    "owner1": "GLUZ, ARNOLD & ANNETTE",
    "owner2": "ARONOVITCH, AVIVA A & DOV B",
    "current_taxes": 58052.23,
    "new_taxes_no_override": 60560.09,
    "override_total_1": 62278.43,
    "override_increase_1": 1718.35
  },
  {
    "#": "384 Harvard St (078-05-00)",
    "$": 18648100,
    "address": "384 Harvard St",
    "parcel_id": "078-05-00",
    "owner1": "CONGREGATION KEHILLATH ISRAEL",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "385 Harvard St (051-01-02)",
    "$": 5406200,
    "address": "385 Harvard St",
    "parcel_id": "051-01-02",
    "owner1": "1379 COM LLC",
    "owner2": "",
    "current_taxes": 60596.64,
    "new_taxes_no_override": 63214.41,
    "override_total_1": 65008.08,
    "override_increase_1": 1793.66
  },
  {
    "#": "389 Harvard St (051-03-00)",
    "$": 3281400,
    "address": "389 Harvard St",
    "parcel_id": "051-03-00",
    "owner1": "1379 COM LLC",
    "owner2": "",
    "current_taxes": 36326.63,
    "new_taxes_no_override": 37895.94,
    "override_total_1": 38971.21,
    "override_increase_1": 1075.27
  },
  {
    "#": "392 Harvard St (078-04-00)",
    "$": 2562600,
    "address": "392 Harvard St",
    "parcel_id": "078-04-00",
    "owner1": "LMW REALTY LLC",
    "owner2": "C/O ANDREW WIENER",
    "current_taxes": 43974.22,
    "new_taxes_no_override": 45873.91,
    "override_total_1": 47175.54,
    "override_increase_1": 1301.64
  },
  {
    "#": "395 Harvard St (051-04-00)",
    "$": 11257500,
    "address": "395 Harvard St",
    "parcel_id": "051-04-00",
    "owner1": "RAMON REALTY LLC",
    "owner2": "",
    "current_taxes": 126962.57,
    "new_taxes_no_override": 132447.35,
    "override_total_1": 136205.45,
    "override_increase_1": 3758.09
  },
  {
    "#": "398 Harvard St (078-03-00)",
    "$": 2062000,
    "address": "398 Harvard St",
    "parcel_id": "078-03-00",
    "owner1": "DIEPENBROCK TR, WILLIAM R",
    "owner2": "C/O CLASSIC REALTY",
    "current_taxes": 35383.92,
    "new_taxes_no_override": 36912.51,
    "override_total_1": 37959.87,
    "override_increase_1": 1047.36
  },
  {
    "#": "401 Harvard St (064-09-00)",
    "$": 2194500,
    "address": "401 Harvard St",
    "parcel_id": "064-09-00",
    "owner1": "401 HARVARD STREET LLC",
    "owner2": "",
    "current_taxes": 37657.62,
    "new_taxes_no_override": 39284.43,
    "override_total_1": 40399.09,
    "override_increase_1": 1114.67
  },
  {
    "#": "404 Harvard St, Unit A (078-02-00)",
    "$": 2486400,
    "address": "404 Harvard St, Unit A",
    "parcel_id": "078-02-00",
    "owner1": "WERNICK PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 42666.62,
    "new_taxes_no_override": 44509.82,
    "override_total_1": 45772.75,
    "override_increase_1": 1262.93
  },
  {
    "#": "408 Harvard St (078-01-00)",
    "$": 3649300,
    "address": "408 Harvard St",
    "parcel_id": "078-01-00",
    "owner1": "DOVEK, EDITH N",
    "owner2": "",
    "current_taxes": 62621.99,
    "new_taxes_no_override": 65327.26,
    "override_total_1": 67180.87,
    "override_increase_1": 1853.61
  },
  {
    "#": "411 Harvard St (064-10-11)",
    "$": 4588500,
    "address": "411 Harvard St",
    "parcel_id": "064-10-11",
    "owner1": "HARVARD STREET II LLC",
    "owner2": "C/O GELERMAN, WALTER",
    "current_taxes": 78738.66,
    "new_taxes_no_override": 82140.17,
    "override_total_1": 84470.83,
    "override_increase_1": 2330.66
  },
  {
    "#": "420 Harvard St (077-09-12)",
    "$": 21905600,
    "address": "420 Harvard St",
    "parcel_id": "077-09-12",
    "owner1": "420 HARVARD FMS LLC",
    "owner2": "",
    "current_taxes": 239569.94,
    "new_taxes_no_override": 249919.36,
    "override_total_1": 257010.63,
    "override_increase_1": 7091.27
  },
  {
    "#": "421 Harvard St (066-10-00)",
    "$": 2218300,
    "address": "421 Harvard St",
    "parcel_id": "066-10-00",
    "owner1": "BAGELS LLC",
    "owner2": "",
    "current_taxes": 38066.03,
    "new_taxes_no_override": 39710.48,
    "override_total_1": 40837.24,
    "override_increase_1": 1126.75
  },
  {
    "#": "426 Harvard St (077-10-00)",
    "$": 3080400,
    "address": "426 Harvard St",
    "parcel_id": "077-10-00",
    "owner1": "RUBOY, TRS ET AL, JOSHUA & LISA",
    "owner2": "C/O 428 HARVARD STREET REALTY TRUST",
    "current_taxes": 52859.66,
    "new_taxes_no_override": 55143.2,
    "override_total_1": 56707.84,
    "override_increase_1": 1564.65
  },
  {
    "#": "429 Harvard St (066-11-00)",
    "$": 3801900,
    "address": "429 Harvard St",
    "parcel_id": "066-11-00",
    "owner1": "OAK HILL PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 65240.6,
    "new_taxes_no_override": 68058.99,
    "override_total_1": 69990.12,
    "override_increase_1": 1931.12
  },
  {
    "#": "434 Harvard St, Unit A (076-13-00)",
    "$": 1725800,
    "address": "434 Harvard St, Unit A",
    "parcel_id": "076-13-00",
    "owner1": "KATZ, JERALD N",
    "owner2": "",
    "current_taxes": 29614.73,
    "new_taxes_no_override": 30894.09,
    "override_total_1": 31770.68,
    "override_increase_1": 876.6
  },
  {
    "#": "435 Harvard St, Unit A (067-08-00)",
    "$": 2443600,
    "address": "435 Harvard St, Unit A",
    "parcel_id": "067-08-00",
    "owner1": "CHEW, TR, JERRY",
    "owner2": "C/O A COBB",
    "current_taxes": 41932.18,
    "new_taxes_no_override": 43743.65,
    "override_total_1": 44984.84,
    "override_increase_1": 1241.19
  },
  {
    "#": "440 Harvard St (076-12-00)",
    "$": 2550700,
    "address": "440 Harvard St",
    "parcel_id": "076-12-00",
    "owner1": "ROCKET STREET LLC",
    "owner2": "",
    "current_taxes": 43770.01,
    "new_taxes_no_override": 45660.87,
    "override_total_1": 46956.47,
    "override_increase_1": 1295.59
  },
  {
    "#": "445 Harvard St (067-09-00)",
    "$": 2440000,
    "address": "445 Harvard St",
    "parcel_id": "067-09-00",
    "owner1": "445 HARVARD LLC",
    "owner2": "",
    "current_taxes": 41870.4,
    "new_taxes_no_override": 43679.2,
    "override_total_1": 44918.57,
    "override_increase_1": 1239.36
  },
  {
    "#": "454 Harvard St (075-01-02)",
    "$": 3134500,
    "address": "454 Harvard St",
    "parcel_id": "075-01-02",
    "owner1": "454 HARVARD ST LLC ET AL",
    "owner2": "",
    "current_taxes": 53788.02,
    "new_taxes_no_override": 56111.66,
    "override_total_1": 57703.79,
    "override_increase_1": 1592.13
  },
  {
    "#": "455 Harvard St (069-22-00)",
    "$": 8508900,
    "address": "455 Harvard St",
    "parcel_id": "069-22-00",
    "owner1": "HARVARD DANESH 455 LLC",
    "owner2": "C/O ALLIED CAPITAL PROPERTIES",
    "current_taxes": 91253.09,
    "new_taxes_no_override": 95195.22,
    "override_total_1": 97896.31,
    "override_increase_1": 2701.09
  },
  {
    "#": "470 Harvard St (074-01-00)",
    "$": 5309300,
    "address": "470 Harvard St",
    "parcel_id": "074-01-00",
    "owner1": "AFFILIATED FAMILY FUNERAL, SERVICES INC",
    "owner2": "",
    "current_taxes": 91107.59,
    "new_taxes_no_override": 95043.44,
    "override_total_1": 97740.22,
    "override_increase_1": 2696.78
  },
  {
    "#": "473 Harvard St (069-23-24)",
    "$": 7332700,
    "address": "473 Harvard St",
    "parcel_id": "069-23-24",
    "owner1": "H-PAL REALTY LLC",
    "owner2": "",
    "current_taxes": 125829.13,
    "new_taxes_no_override": 131264.95,
    "override_total_1": 134989.49,
    "override_increase_1": 3724.54
  },
  {
    "#": "488 Harvard St (073-02-00)",
    "$": 2006800,
    "address": "488 Harvard St",
    "parcel_id": "073-02-00",
    "owner1": "AFFILIATED FAMILY FUNERAL, SERVICES INC",
    "owner2": "",
    "current_taxes": 34436.69,
    "new_taxes_no_override": 35924.36,
    "override_total_1": 36943.68,
    "override_increase_1": 1019.33
  },
  {
    "#": "496 Harvard St (073-01-00)",
    "$": 3454600,
    "address": "496 Harvard St",
    "parcel_id": "073-01-00",
    "owner1": "CHABAD LUBEVITCH INC",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "500 Harvard St (072-01-00)",
    "$": 2161800,
    "address": "500 Harvard St",
    "parcel_id": "072-01-00",
    "owner1": "500 HARVARD ST LLC",
    "owner2": "",
    "current_taxes": 37096.49,
    "new_taxes_no_override": 38699.06,
    "override_total_1": 39797.11,
    "override_increase_1": 1098.06
  },
  {
    "#": "514 Harvard St, Unit 1A (072-40-16)",
    "$": 483700,
    "address": "514 Harvard St, Unit 1A",
    "parcel_id": "072-40-16",
    "owner1": "HANNIGAN, JOHN A",
    "owner2": "",
    "current_taxes": 1318.15,
    "new_taxes_no_override": 1375.09,
    "override_total_1": 1414.11,
    "override_increase_1": 39.02
  },
  {
    "#": "514 Harvard St, Unit 1B (072-40-01)",
    "$": 560000,
    "address": "514 Harvard St, Unit 1B",
    "parcel_id": "072-40-01",
    "owner1": "ELIGULASHVILI, FLORENSA",
    "owner2": "OFIR, DAVID MARC",
    "current_taxes": 2099.47,
    "new_taxes_no_override": 2190.17,
    "override_total_1": 2252.31,
    "override_increase_1": 62.14
  },
  {
    "#": "514 Harvard St, Unit 1C (072-40-02)",
    "$": 743600,
    "address": "514 Harvard St, Unit 1C",
    "parcel_id": "072-40-02",
    "owner1": "ESCH, JESSE",
    "owner2": "VANDERPLUYM, CHRISTINA",
    "current_taxes": 7614.46,
    "new_taxes_no_override": 7943.4,
    "override_total_1": 8168.79,
    "override_increase_1": 225.39
  },
  {
    "#": "514 Harvard St, Unit 1D (072-40-03)",
    "$": 497100,
    "address": "514 Harvard St, Unit 1D",
    "parcel_id": "072-40-03",
    "owner1": "LIU, BOTAO",
    "owner2": "YUAN, YIFAN",
    "current_taxes": 5090.3,
    "new_taxes_no_override": 5310.2,
    "override_total_1": 5460.87,
    "override_increase_1": 150.67
  },
  {
    "#": "514 Harvard St, Unit 2A (072-40-04)",
    "$": 587200,
    "address": "514 Harvard St, Unit 2A",
    "parcel_id": "072-40-04",
    "owner1": "RAHARDJO, BUDDY & KAY",
    "owner2": "",
    "current_taxes": 6012.93,
    "new_taxes_no_override": 6272.69,
    "override_total_1": 6450.67,
    "override_increase_1": 177.98
  },
  {
    "#": "514 Harvard St, Unit 2B (072-40-05)",
    "$": 592900,
    "address": "514 Harvard St, Unit 2B",
    "parcel_id": "072-40-05",
    "owner1": "SANTER, PETER & ADRIENNE PIERINA",
    "owner2": "",
    "current_taxes": 2436.36,
    "new_taxes_no_override": 2541.61,
    "override_total_1": 2613.73,
    "override_increase_1": 72.12
  },
  {
    "#": "514 Harvard St, Unit 2C (072-40-06)",
    "$": 704300,
    "address": "514 Harvard St, Unit 2C",
    "parcel_id": "072-40-06",
    "owner1": "BAUMOL, DANIEL",
    "owner2": "C/O F & F PROPERTY MANAGEMENT",
    "current_taxes": 7212.03,
    "new_taxes_no_override": 7523.59,
    "override_total_1": 7737.07,
    "override_increase_1": 213.48
  },
  {
    "#": "514 Harvard St, Unit 2D (072-40-07)",
    "$": 480100,
    "address": "514 Harvard St, Unit 2D",
    "parcel_id": "072-40-07",
    "owner1": "SPRINGBROOK INVESTMENT LLC",
    "owner2": "",
    "current_taxes": 4916.22,
    "new_taxes_no_override": 5128.6,
    "override_total_1": 5274.12,
    "override_increase_1": 145.52
  },
  {
    "#": "514 Harvard St, Unit 3A (072-40-08)",
    "$": 552900,
    "address": "514 Harvard St, Unit 3A",
    "parcel_id": "072-40-08",
    "owner1": "YANG, SHIH-YING",
    "owner2": "",
    "current_taxes": 5661.7,
    "new_taxes_no_override": 5906.29,
    "override_total_1": 6073.87,
    "override_increase_1": 167.59
  },
  {
    "#": "514 Harvard St, Unit 3B (072-40-09)",
    "$": 602200,
    "address": "514 Harvard St, Unit 3B",
    "parcel_id": "072-40-09",
    "owner1": "YU, LEI",
    "owner2": "",
    "current_taxes": 6166.53,
    "new_taxes_no_override": 6432.92,
    "override_total_1": 6615.45,
    "override_increase_1": 182.53
  },
  {
    "#": "514 Harvard St, Unit 3C (072-40-10)",
    "$": 760000,
    "address": "514 Harvard St, Unit 3C",
    "parcel_id": "072-40-10",
    "owner1": "WILLOW JANE LLC",
    "owner2": "",
    "current_taxes": 7782.4,
    "new_taxes_no_override": 8118.6,
    "override_total_1": 8348.96,
    "override_increase_1": 230.36
  },
  {
    "#": "514 Harvard St, Unit 3D (072-40-11)",
    "$": 512700,
    "address": "514 Harvard St, Unit 3D",
    "parcel_id": "072-40-11",
    "owner1": "YEO TR, BEE KENG",
    "owner2": "",
    "current_taxes": 5250.05,
    "new_taxes_no_override": 5476.85,
    "override_total_1": 5632.25,
    "override_increase_1": 155.4
  },
  {
    "#": "514 Harvard St, Unit B1 (072-40-12)",
    "$": 327300,
    "address": "514 Harvard St, Unit B1",
    "parcel_id": "072-40-12",
    "owner1": "FITZGERALD, DANIEL J & DEYSI ELIZABETH ZAMORA",
    "owner2": "",
    "current_taxes": 3351.55,
    "new_taxes_no_override": 3496.34,
    "override_total_1": 3595.54,
    "override_increase_1": 99.21
  },
  {
    "#": "514 Harvard St, Unit B2 (072-40-13)",
    "$": 357900,
    "address": "514 Harvard St, Unit B2",
    "parcel_id": "072-40-13",
    "owner1": "CANTY, THOMAS",
    "owner2": "",
    "current_taxes": 3664.9,
    "new_taxes_no_override": 3823.22,
    "override_total_1": 3931.7,
    "override_increase_1": 108.48
  },
  {
    "#": "514 Harvard St, Unit B3 (072-40-14)",
    "$": 253600,
    "address": "514 Harvard St, Unit B3",
    "parcel_id": "072-40-14",
    "owner1": "SHRIVER, EDWIN R",
    "owner2": "",
    "current_taxes": 259.69,
    "new_taxes_no_override": 270.91,
    "override_total_1": 278.6,
    "override_increase_1": 7.69
  },
  {
    "#": "514 Harvard St, Unit B4 (072-40-15)",
    "$": 341300,
    "address": "514 Harvard St, Unit B4",
    "parcel_id": "072-40-15",
    "owner1": "FORTUNATO TRS, ANTHONY J & JENNIFER",
    "owner2": "",
    "current_taxes": 3494.91,
    "new_taxes_no_override": 3645.89,
    "override_total_1": 3749.34,
    "override_increase_1": 103.45
  },
  {
    "#": "523 Harvard St (070-18-22)",
    "$": 20285000,
    "address": "523 Harvard St",
    "parcel_id": "070-18-22",
    "owner1": "VERNHUNT LLC",
    "owner2": "",
    "current_taxes": 348090.6,
    "new_taxes_no_override": 363128.11,
    "override_total_1": 373431.6,
    "override_increase_1": 10303.48
  },
  {
    "#": "524 Harvard St (071-02-01)",
    "$": 2728600,
    "address": "524 Harvard St",
    "parcel_id": "071-02-01",
    "owner1": "524 HARVARD BROOKLINE LLC",
    "owner2": "",
    "current_taxes": 27940.86,
    "new_taxes_no_override": 29147.91,
    "override_total_1": 29974.95,
    "override_increase_1": 827.05
  },
  {
    "#": "526 Harvard St (071-02-00)",
    "$": 3060900,
    "address": "526 Harvard St",
    "parcel_id": "071-02-00",
    "owner1": "KIM, TR, BENJAMIN",
    "owner2": "",
    "current_taxes": 31343.62,
    "new_taxes_no_override": 32697.66,
    "override_total_1": 33625.44,
    "override_increase_1": 927.77
  },
  {
    "#": "10 Hawes Pl (117-05-00)",
    "$": 4953800,
    "address": "10 Hawes Pl",
    "parcel_id": "117-05-00",
    "owner1": "MINKOFF, MICHAEL",
    "owner2": "",
    "current_taxes": 47091.98,
    "new_taxes_no_override": 49126.35,
    "override_total_1": 50520.28,
    "override_increase_1": 1393.92
  },
  {
    "#": "5 Hawes St (115-06-00)",
    "$": 4671300,
    "address": "5 Hawes St",
    "parcel_id": "115-06-00",
    "owner1": "MUNDEL, PETER H",
    "owner2": "GREKA, ANNA",
    "current_taxes": 44199.18,
    "new_taxes_no_override": 46108.58,
    "override_total_1": 47416.88,
    "override_increase_1": 1308.3
  },
  {
    "#": "6 Hawes St (120-01-00)",
    "$": 4394500,
    "address": "6 Hawes St",
    "parcel_id": "120-01-00",
    "owner1": "LEWIS, HARRY R",
    "owner2": "MCGRATH, MARLYN",
    "current_taxes": 41364.75,
    "new_taxes_no_override": 43151.71,
    "override_total_1": 44376.1,
    "override_increase_1": 1224.4
  },
  {
    "#": "7 Hawes St (115-07-00)",
    "$": 3705600,
    "address": "7 Hawes St",
    "parcel_id": "115-07-00",
    "owner1": "SNYDER TRS, RYAN",
    "owner2": "LYONS, EMILY",
    "current_taxes": 37945.34,
    "new_taxes_no_override": 39584.58,
    "override_total_1": 40707.76,
    "override_increase_1": 1123.18
  },
  {
    "#": "9 Hawes St (115-08-00)",
    "$": 3347100,
    "address": "9 Hawes St",
    "parcel_id": "115-08-00",
    "owner1": "KAPLAN TR, LINDA M",
    "owner2": "TOLLMAN TR, PETER A",
    "current_taxes": 34274.3,
    "new_taxes_no_override": 35754.95,
    "override_total_1": 36769.47,
    "override_increase_1": 1014.52
  },
  {
    "#": "11 Hawes St (115-09-00)",
    "$": 4155800,
    "address": "11 Hawes St",
    "parcel_id": "115-09-00",
    "owner1": "JANOVITZ, TYLER",
    "owner2": "CUNNINGHAM-BUSSEL, AMY",
    "current_taxes": 38920.46,
    "new_taxes_no_override": 40601.82,
    "override_total_1": 41753.87,
    "override_increase_1": 1152.05
  },
  {
    "#": "16 Hawes St (120-19-00)",
    "$": 6447400,
    "address": "16 Hawes St",
    "parcel_id": "120-19-00",
    "owner1": "JENSEN TR, DAVID J",
    "owner2": "",
    "current_taxes": 66021.38,
    "new_taxes_no_override": 68873.5,
    "override_total_1": 70827.74,
    "override_increase_1": 1954.23
  },
  {
    "#": "17 Hawes St (115-10-00)",
    "$": 5255500,
    "address": "17 Hawes St",
    "parcel_id": "115-10-00",
    "owner1": "BESHAROV TR, GREGORY",
    "owner2": "C/O ROTHSTEIN KASS",
    "current_taxes": 53816.32,
    "new_taxes_no_override": 56141.19,
    "override_total_1": 57734.15,
    "override_increase_1": 1592.96
  },
  {
    "#": "40 Hawes St (117-01-00)",
    "$": 3865900,
    "address": "40 Hawes St",
    "parcel_id": "117-01-00",
    "owner1": "DAM, HAMASAT GHEDDAF",
    "owner2": "TANEJA, PRIYANK",
    "current_taxes": 39586.82,
    "new_taxes_no_override": 41296.97,
    "override_total_1": 42468.74,
    "override_increase_1": 1171.77
  },
  {
    "#": "43 Hawes St (115-11-00)",
    "$": 16241500,
    "address": "43 Hawes St",
    "parcel_id": "115-11-00",
    "owner1": "TRUSTEES OF BOSTON UNIVERSITY",
    "owner2": "C/O GENERAL ACCOUNTING 4TH FL",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "48 Hawes St (117-11-00)",
    "$": 4470400,
    "address": "48 Hawes St",
    "parcel_id": "117-11-00",
    "owner1": "FLOREA, VICTORIA L",
    "owner2": "",
    "current_taxes": 42141.96,
    "new_taxes_no_override": 43962.49,
    "override_total_1": 45209.89,
    "override_increase_1": 1247.4
  },
  {
    "#": "56 Hawes St (117-10-00)",
    "$": 5976300,
    "address": "56 Hawes St",
    "parcel_id": "117-10-00",
    "owner1": "KOVEL TR, ALEXANDER",
    "owner2": "",
    "current_taxes": 57562.38,
    "new_taxes_no_override": 60049.07,
    "override_total_1": 61752.92,
    "override_increase_1": 1703.85
  },
  {
    "#": "4 Hawthorn Rd (296-01-02)",
    "$": 4032900,
    "address": "4 Hawthorn Rd",
    "parcel_id": "296-01-02",
    "owner1": "ERGEN, ERKUT E & NESLIN M",
    "owner2": "",
    "current_taxes": 37661.96,
    "new_taxes_no_override": 39288.96,
    "override_total_1": 40403.75,
    "override_increase_1": 1114.79
  },
  {
    "#": "14 Hawthorn Rd (296-03-14)",
    "$": 3918800,
    "address": "14 Hawthorn Rd",
    "parcel_id": "296-03-14",
    "owner1": "GLATZER, JOCELYN S",
    "owner2": "SPAGAT, JEFFREY A",
    "current_taxes": 36493.58,
    "new_taxes_no_override": 38070.1,
    "override_total_1": 39150.31,
    "override_increase_1": 1080.21
  },
  {
    "#": "17 Hawthorn Rd (295-06-00)",
    "$": 3506600,
    "address": "17 Hawthorn Rd",
    "parcel_id": "295-06-00",
    "owner1": "MOODY, D BRANCH",
    "owner2": "NUCCI, MARISA R",
    "current_taxes": 32272.65,
    "new_taxes_no_override": 33666.83,
    "override_total_1": 34622.1,
    "override_increase_1": 955.27
  },
  {
    "#": "20 Hawthorn Rd (296-13-00)",
    "$": 2700400,
    "address": "20 Hawthorn Rd",
    "parcel_id": "296-13-00",
    "owner1": "WALLING TR, SUSAN L",
    "owner2": "",
    "current_taxes": 24017.16,
    "new_taxes_no_override": 25054.7,
    "override_total_1": 25765.61,
    "override_increase_1": 710.91
  },
  {
    "#": "21 Hawthorn Rd (295-07-08)",
    "$": 3715100,
    "address": "21 Hawthorn Rd",
    "parcel_id": "295-07-08",
    "owner1": "SCHWARZ, FREDERICK A O III",
    "owner2": "COFFEY, MAUREEN",
    "current_taxes": 34407.69,
    "new_taxes_no_override": 35894.1,
    "override_total_1": 36912.57,
    "override_increase_1": 1018.47
  },
  {
    "#": "28 Hawthorn Rd (296-12-00)",
    "$": 2755000,
    "address": "28 Hawthorn Rd",
    "parcel_id": "296-12-00",
    "owner1": "CARABOOLAD, TR, GEOFFREY S",
    "owner2": "",
    "current_taxes": 28211.2,
    "new_taxes_no_override": 29429.92,
    "override_total_1": 30264.98,
    "override_increase_1": 835.05
  },
  {
    "#": "29 Hawthorn Rd (295-09-00)",
    "$": 2848500,
    "address": "29 Hawthorn Rd",
    "parcel_id": "295-09-00",
    "owner1": "ADKINS, JASON B",
    "owner2": "KRAUT, KAREN L",
    "current_taxes": 25533.71,
    "new_taxes_no_override": 26636.77,
    "override_total_1": 27392.56,
    "override_increase_1": 755.8
  },
  {
    "#": "34 Hawthorn Rd (296-11-00)",
    "$": 2054400,
    "address": "34 Hawthorn Rd",
    "parcel_id": "296-11-00",
    "owner1": "RODRIGUEZ TRS, DAVID EDWARD JR",
    "owner2": "SMITH, ALLA VICKERY LESECURE",
    "current_taxes": 17402.12,
    "new_taxes_no_override": 18153.89,
    "override_total_1": 18668.99,
    "override_increase_1": 515.1
  },
  {
    "#": "35 Hawthorn Rd (295-10-00)",
    "$": 2307600,
    "address": "35 Hawthorn Rd",
    "parcel_id": "295-10-00",
    "owner1": "GLOVER, MICHAEL ANDREW",
    "owner2": "MOLS, JESSICA YOSHIE",
    "current_taxes": 19994.89,
    "new_taxes_no_override": 20858.67,
    "override_total_1": 21450.52,
    "override_increase_1": 591.85
  },
  {
    "#": "40 Hawthorn Rd (296-10-00)",
    "$": 2680100,
    "address": "40 Hawthorn Rd",
    "parcel_id": "296-10-00",
    "owner1": "SCHIRO TRS, SUSAN F",
    "owner2": "MANUS, PETER J",
    "current_taxes": 23809.29,
    "new_taxes_no_override": 24837.85,
    "override_total_1": 25542.61,
    "override_increase_1": 704.75
  },
  {
    "#": "46 Hawthorn Rd (296-09-00)",
    "$": 2381400,
    "address": "46 Hawthorn Rd",
    "parcel_id": "296-09-00",
    "owner1": "WEISS TR, LEONARD A",
    "owner2": "",
    "current_taxes": 20750.6,
    "new_taxes_no_override": 21647.03,
    "override_total_1": 22261.24,
    "override_increase_1": 614.22
  },
  {
    "#": "18 Hayden Rd (250-11-01)",
    "$": 2809200,
    "address": "18 Hayden Rd",
    "parcel_id": "250-11-01",
    "owner1": "ROSENZWEIG , STANLEY",
    "owner2": "UNION, LAURI",
    "current_taxes": 28766.21,
    "new_taxes_no_override": 30008.91,
    "override_total_1": 30860.39,
    "override_increase_1": 851.48
  },
  {
    "#": "30 Hayden Rd (250-12-05)",
    "$": 11969400,
    "address": "30 Hayden Rd",
    "parcel_id": "250-12-05",
    "owner1": "ROSENZWEIG, STANLEY",
    "owner2": "UNION, LAURI",
    "current_taxes": 122566.66,
    "new_taxes_no_override": 127861.54,
    "override_total_1": 131489.51,
    "override_increase_1": 3627.97
  },
  {
    "#": "11 Heath Hill (337-07-00)",
    "$": 3821600,
    "address": "11 Heath Hill",
    "parcel_id": "337-07-00",
    "owner1": "FREEMAN, BRIAN & STEPHANIE",
    "owner2": "",
    "current_taxes": 39133.18,
    "new_taxes_no_override": 40823.73,
    "override_total_1": 41982.08,
    "override_increase_1": 1158.34
  },
  {
    "#": "12 Heath Hill (336-20-21)",
    "$": 2417300,
    "address": "12 Heath Hill",
    "parcel_id": "336-20-21",
    "owner1": "SHAH, ASHESH C & LOUISE",
    "owner2": "",
    "current_taxes": 21118.22,
    "new_taxes_no_override": 22030.53,
    "override_total_1": 22655.63,
    "override_increase_1": 625.1
  },
  {
    "#": "21 Heath Hill (337-05-06)",
    "$": 4814100,
    "address": "21 Heath Hill",
    "parcel_id": "337-05-06",
    "owner1": "SCHWARTZ, HOWARD M",
    "owner2": "SANTANGELO, JACQUELINE",
    "current_taxes": 45661.45,
    "new_taxes_no_override": 47634.02,
    "override_total_1": 48985.6,
    "override_increase_1": 1351.58
  },
  {
    "#": "22 Heath Hill (336-22-00)",
    "$": 2422700,
    "address": "22 Heath Hill",
    "parcel_id": "336-22-00",
    "owner1": "AVRAHAM TRS, SHALOM & HAVA",
    "owner2": "",
    "current_taxes": 21173.51,
    "new_taxes_no_override": 22088.21,
    "override_total_1": 22714.94,
    "override_increase_1": 626.74
  },
  {
    "#": "30 Heath Hill (336-23-00)",
    "$": 3120600,
    "address": "30 Heath Hill",
    "parcel_id": "336-23-00",
    "owner1": "SINGER, TR, REBECCA C",
    "owner2": "",
    "current_taxes": 28320.01,
    "new_taxes_no_override": 29543.43,
    "override_total_1": 30381.71,
    "override_increase_1": 838.27
  },
  {
    "#": "33 Heath Hill (337-04-00)",
    "$": 6678200,
    "address": "33 Heath Hill",
    "parcel_id": "337-04-00",
    "owner1": "LAUFFER, RANDALL B",
    "owner2": "",
    "current_taxes": 64749.83,
    "new_taxes_no_override": 67547.02,
    "override_total_1": 69463.62,
    "override_increase_1": 1916.59
  },
  {
    "#": "40 Heath Hill (336-24-00)",
    "$": 4996100,
    "address": "40 Heath Hill",
    "parcel_id": "336-24-00",
    "owner1": "GYENES, DEBORAH",
    "owner2": "",
    "current_taxes": 47525.13,
    "new_taxes_no_override": 49578.22,
    "override_total_1": 50984.96,
    "override_increase_1": 1406.74
  },
  {
    "#": "43 Heath Hill (337-03-00)",
    "$": 8614200,
    "address": "43 Heath Hill",
    "parcel_id": "337-03-00",
    "owner1": "KALIN TR, RACHEL LYNN",
    "owner2": "",
    "current_taxes": 88209.41,
    "new_taxes_no_override": 92020.06,
    "override_total_1": 94631.06,
    "override_increase_1": 2611.0
  },
  {
    "#": "51 Heath Hill (337-02-00)",
    "$": 8182300,
    "address": "51 Heath Hill",
    "parcel_id": "337-02-00",
    "owner1": "JEPSKY TR, ANDREW S",
    "owner2": "C/O JEPSKY & SACK",
    "current_taxes": 83786.75,
    "new_taxes_no_override": 87406.34,
    "override_total_1": 89886.43,
    "override_increase_1": 2480.09
  },
  {
    "#": "54 Heath Hill (336-25-00)",
    "$": 5271500,
    "address": "54 Heath Hill",
    "parcel_id": "336-25-00",
    "owner1": "ADLER, NANCY",
    "owner2": "",
    "current_taxes": 50345.23,
    "new_taxes_no_override": 52520.14,
    "override_total_1": 54010.36,
    "override_increase_1": 1490.22
  },
  {
    "#": "60 Heath Hill (336-26-00)",
    "$": 5003500,
    "address": "60 Heath Hill",
    "parcel_id": "336-26-00",
    "owner1": "CHRISTOPHER TR, MARK M",
    "owner2": "C/O SCRIVANOS, GEORGE",
    "current_taxes": 51235.84,
    "new_taxes_no_override": 53449.23,
    "override_total_1": 54965.81,
    "override_increase_1": 1516.58
  },
  {
    "#": "61 Heath Hill (337-01-00)",
    "$": 4074000,
    "address": "61 Heath Hill",
    "parcel_id": "337-01-00",
    "owner1": "PARKS TRS, CAROL SAWYER & HANA D",
    "owner2": "",
    "current_taxes": 38082.83,
    "new_taxes_no_override": 39728.01,
    "override_total_1": 40855.26,
    "override_increase_1": 1127.25
  },
  {
    "#": "15 Heath St (276-14-00)",
    "$": 1663400,
    "address": "15 Heath St",
    "parcel_id": "276-14-00",
    "owner1": "SHAHROOZ TR, KAMYAR",
    "owner2": "",
    "current_taxes": 17033.22,
    "new_taxes_no_override": 17769.06,
    "override_total_1": 18273.24,
    "override_increase_1": 504.18
  },
  {
    "#": "23 Heath St (276-15-00)",
    "$": 1620900,
    "address": "23 Heath St",
    "parcel_id": "276-15-00",
    "owner1": "LEUNG TRS, KACEY MAY NGAN & TINA MAY LING",
    "owner2": "",
    "current_taxes": 12963.08,
    "new_taxes_no_override": 13523.09,
    "override_total_1": 13906.79,
    "override_increase_1": 383.71
  },
  {
    "#": "27 Heath St (276-15-01)",
    "$": 1840900,
    "address": "27 Heath St",
    "parcel_id": "276-15-01",
    "owner1": "27 HEATH STREET LLC",
    "owner2": "",
    "current_taxes": 18850.82,
    "new_taxes_no_override": 19665.18,
    "override_total_1": 20223.16,
    "override_increase_1": 557.98
  },
  {
    "#": "30 Heath St (337-09-10)",
    "$": 3918000,
    "address": "30 Heath St",
    "parcel_id": "337-09-10",
    "owner1": "ST CLAIR, DANIEL J & OLGA M",
    "owner2": "",
    "current_taxes": 36485.39,
    "new_taxes_no_override": 38061.56,
    "override_total_1": 39141.53,
    "override_increase_1": 1079.97
  },
  {
    "#": "31 Heath St (276-16-00)",
    "$": 3083000,
    "address": "31 Heath St",
    "parcel_id": "276-16-00",
    "owner1": "31 HEATH STREET LLC",
    "owner2": "",
    "current_taxes": 31569.92,
    "new_taxes_no_override": 32933.74,
    "override_total_1": 33868.21,
    "override_increase_1": 934.47
  },
  {
    "#": "34 Heath St (337-30-00)",
    "$": 3512000,
    "address": "34 Heath St",
    "parcel_id": "337-30-00",
    "owner1": "GROSSMAN TRS, ADAM",
    "owner2": "HANNEMANN , MARIA CANDIDA",
    "current_taxes": 32327.95,
    "new_taxes_no_override": 33724.52,
    "override_total_1": 34681.42,
    "override_increase_1": 956.91
  },
  {
    "#": "35 Heath St (276-16-01)",
    "$": 1627200,
    "address": "35 Heath St",
    "parcel_id": "276-16-01",
    "owner1": "CHIN, DAVID L & LISA S",
    "owner2": "",
    "current_taxes": 13027.59,
    "new_taxes_no_override": 13590.38,
    "override_total_1": 13976.0,
    "override_increase_1": 385.62
  },
  {
    "#": "38 Heath St (337-29-00)",
    "$": 4115500,
    "address": "38 Heath St",
    "parcel_id": "337-29-00",
    "owner1": "N & O MASS HOLDINGS LLC",
    "owner2": "",
    "current_taxes": 42142.72,
    "new_taxes_no_override": 43963.29,
    "override_total_1": 45210.71,
    "override_increase_1": 1247.42
  },
  {
    "#": "39 Heath St, Unit 1 (276-17-01)",
    "$": 1050000,
    "address": "39 Heath St, Unit 1",
    "parcel_id": "276-17-01",
    "owner1": "MONZAVI TR, HOSSEIN",
    "owner2": "SADEGHI TR, NASRIN",
    "current_taxes": 7117.07,
    "new_taxes_no_override": 7424.53,
    "override_total_1": 7635.19,
    "override_increase_1": 210.67
  },
  {
    "#": "39 Heath St, Unit 2 (276-17-02)",
    "$": 1040300,
    "address": "39 Heath St, Unit 2",
    "parcel_id": "276-17-02",
    "owner1": "PARK, JEONG-GUN",
    "owner2": "YOON, EUN-KYOUNG",
    "current_taxes": 7017.74,
    "new_taxes_no_override": 7320.91,
    "override_total_1": 7528.63,
    "override_increase_1": 207.73
  },
  {
    "#": "45 Heath St (276-18-00)",
    "$": 1965300,
    "address": "45 Heath St",
    "parcel_id": "276-18-00",
    "owner1": "MOOSA, MOOSA E",
    "owner2": "",
    "current_taxes": 16489.74,
    "new_taxes_no_override": 17202.1,
    "override_total_1": 17690.19,
    "override_increase_1": 488.1
  },
  {
    "#": "60 Heath St (337-14-00)",
    "$": 4525500,
    "address": "60 Heath St",
    "parcel_id": "337-14-00",
    "owner1": "BERGER TRS, PATRICIA DOWNS",
    "owner2": "CORTI, ANNA M",
    "current_taxes": 46341.12,
    "new_taxes_no_override": 48343.06,
    "override_total_1": 49714.75,
    "override_increase_1": 1371.7
  },
  {
    "#": "61 Heath St (437-76-00)",
    "$": 5134600,
    "address": "61 Heath St",
    "parcel_id": "437-76-00",
    "owner1": "YOON, RICHARD K",
    "owner2": "",
    "current_taxes": 52578.3,
    "new_taxes_no_override": 54849.68,
    "override_total_1": 56406.0,
    "override_increase_1": 1556.32
  },
  {
    "#": "70 Heath St (337-17-00)",
    "$": 9409400,
    "address": "70 Heath St",
    "parcel_id": "337-17-00",
    "owner1": "DAVID, JAMES A W & SAMANTHA P",
    "owner2": "",
    "current_taxes": 92717.32,
    "new_taxes_no_override": 96722.71,
    "override_total_1": 99467.14,
    "override_increase_1": 2744.43
  },
  {
    "#": "77 Heath St (437-77-00)",
    "$": 7003500,
    "address": "77 Heath St",
    "parcel_id": "437-77-00",
    "owner1": "MARCUS, ANNE PUNZAK",
    "owner2": "",
    "current_taxes": 71715.84,
    "new_taxes_no_override": 74813.96,
    "override_total_1": 76936.75,
    "override_increase_1": 2122.79
  },
  {
    "#": "80 Heath St (337-18-00)",
    "$": 3000800,
    "address": "80 Heath St",
    "parcel_id": "337-18-00",
    "owner1": "LORING, IAN & ISABELLE",
    "owner2": "",
    "current_taxes": 30728.19,
    "new_taxes_no_override": 32055.65,
    "override_total_1": 32965.2,
    "override_increase_1": 909.55
  },
  {
    "#": "113 Heath St (437-15-02)",
    "$": 6968200,
    "address": "113 Heath St",
    "parcel_id": "437-15-02",
    "owner1": "CONDRON, CASEY & CHRISTINA",
    "owner2": "",
    "current_taxes": 67719.43,
    "new_taxes_no_override": 70644.91,
    "override_total_1": 72649.4,
    "override_increase_1": 2004.5
  },
  {
    "#": "124 Heath St (439-84-00)",
    "$": 9678800,
    "address": "124 Heath St",
    "parcel_id": "439-84-00",
    "owner1": "MOEHL, JAN D & KATHLEEN W",
    "owner2": "",
    "current_taxes": 99110.91,
    "new_taxes_no_override": 103392.5,
    "override_total_1": 106326.18,
    "override_increase_1": 2933.68
  },
  {
    "#": "140 Heath St (439-85-00)",
    "$": 3253700,
    "address": "140 Heath St",
    "parcel_id": "439-85-00",
    "owner1": "RUFO TR, PAUL ALAN",
    "owner2": "C/O MOUNT VERNON COMPANY",
    "current_taxes": 33317.89,
    "new_taxes_no_override": 34757.22,
    "override_total_1": 35743.43,
    "override_increase_1": 986.21
  },
  {
    "#": "150 Heath St (439-86-00)",
    "$": 9685200,
    "address": "150 Heath St",
    "parcel_id": "439-86-00",
    "owner1": "PERCELAY, BRUCE A & ELISABETH J M SCHADAE",
    "owner2": "",
    "current_taxes": 99176.45,
    "new_taxes_no_override": 103460.87,
    "override_total_1": 106396.5,
    "override_increase_1": 2935.62
  },
  {
    "#": "155 Heath St (437-40-00)",
    "$": 9026300,
    "address": "155 Heath St",
    "parcel_id": "437-40-00",
    "owner1": "RABE TRS, ARTHUR N & PAULA S",
    "owner2": "",
    "current_taxes": 92429.31,
    "new_taxes_no_override": 96422.26,
    "override_total_1": 99158.16,
    "override_increase_1": 2735.91
  },
  {
    "#": "171 Heath St (437-41-00)",
    "$": 8290300,
    "address": "171 Heath St",
    "parcel_id": "437-41-00",
    "owner1": "171 HEATH STREET DEVELOPMENT LLC",
    "owner2": "",
    "current_taxes": 84892.67,
    "new_taxes_no_override": 88560.03,
    "override_total_1": 91072.86,
    "override_increase_1": 2512.82
  },
  {
    "#": "188 Heath St (438-03-05)",
    "$": 7865600,
    "address": "188 Heath St",
    "parcel_id": "438-03-05",
    "owner1": "YUDKOFF TRS, ROYCE G & JODY",
    "owner2": "",
    "current_taxes": 80543.74,
    "new_taxes_no_override": 84023.23,
    "override_total_1": 86407.32,
    "override_increase_1": 2384.09
  },
  {
    "#": "214 Heath St (438-01-07)",
    "$": 4908900,
    "address": "214 Heath St",
    "parcel_id": "438-01-07",
    "owner1": "ALLEN  TRS, ROBERT L",
    "owner2": "CHIU, BERNARD",
    "current_taxes": 50267.14,
    "new_taxes_no_override": 52438.68,
    "override_total_1": 53926.59,
    "override_increase_1": 1487.91
  },
  {
    "#": "230 Heath St (440-01-00)",
    "$": 13201500,
    "address": "230 Heath St",
    "parcel_id": "440-01-00",
    "owner1": "RMD PROPERTIES LLC",
    "owner2": "C/O LEWIS S COHEN",
    "current_taxes": 135183.36,
    "new_taxes_no_override": 141023.28,
    "override_total_1": 145024.71,
    "override_increase_1": 4001.43
  },
  {
    "#": "244 Heath St (440-13-03)",
    "$": 4198700,
    "address": "244 Heath St",
    "parcel_id": "440-13-03",
    "owner1": "DUKER TR, SAMUEL A",
    "owner2": "",
    "current_taxes": 42994.69,
    "new_taxes_no_override": 44852.06,
    "override_total_1": 46124.7,
    "override_increase_1": 1272.64
  },
  {
    "#": "260 Heath St (440-32-35)",
    "$": 18404000,
    "address": "260 Heath St",
    "parcel_id": "440-32-35",
    "owner1": "KRAFT TRS, ROBERT K",
    "owner2": "C/O 260 HEATH ST REALTY",
    "current_taxes": 184822.03,
    "new_taxes_no_override": 192806.34,
    "override_total_1": 198277.07,
    "override_increase_1": 5470.73
  },
  {
    "#": "288 Heath St (440-36-00)",
    "$": 5020700,
    "address": "288 Heath St",
    "parcel_id": "440-36-00",
    "owner1": "KRAFT TR, ROBERT K",
    "owner2": "",
    "current_taxes": 51411.97,
    "new_taxes_no_override": 53632.97,
    "override_total_1": 55154.76,
    "override_increase_1": 1521.79
  },
  {
    "#": "296 Heath St (440-37-38)",
    "$": 5249100,
    "address": "296 Heath St",
    "parcel_id": "440-37-38",
    "owner1": "KRAFT, TRS, ROBERT K",
    "owner2": "",
    "current_taxes": 53750.78,
    "new_taxes_no_override": 56072.81,
    "override_total_1": 57663.84,
    "override_increase_1": 1591.02
  },
  {
    "#": "315 Heath St (437-58-00)",
    "$": 1923500,
    "address": "315 Heath St",
    "parcel_id": "437-58-00",
    "owner1": "COUTURE TR, MICHAEL",
    "owner2": "",
    "current_taxes": 19696.64,
    "new_taxes_no_override": 20547.53,
    "override_total_1": 21130.56,
    "override_increase_1": 583.02
  },
  {
    "#": "319 Heath St (437-60-00)",
    "$": 3122600,
    "address": "319 Heath St",
    "parcel_id": "437-60-00",
    "owner1": "COUTURE TR, MICHAEL",
    "owner2": "",
    "current_taxes": 31975.42,
    "new_taxes_no_override": 33356.76,
    "override_total_1": 34303.23,
    "override_increase_1": 946.47
  },
  {
    "#": "321 Heath St (437-61-00)",
    "$": 11965900,
    "address": "321 Heath St",
    "parcel_id": "437-61-00",
    "owner1": "COUTURE TR, MICHAEL",
    "owner2": "",
    "current_taxes": 122530.82,
    "new_taxes_no_override": 127824.15,
    "override_total_1": 131451.06,
    "override_increase_1": 3626.91
  },
  {
    "#": "324 Heath St (440-44-01)",
    "$": 5944900,
    "address": "324 Heath St",
    "parcel_id": "440-44-01",
    "owner1": "NEAL, JEFFREY T & EMILY D",
    "owner2": "",
    "current_taxes": 57240.84,
    "new_taxes_no_override": 59713.64,
    "override_total_1": 61407.97,
    "override_increase_1": 1694.33
  },
  {
    "#": "325 Heath St (437-62-00)",
    "$": 7585500,
    "address": "325 Heath St",
    "parcel_id": "437-62-00",
    "owner1": "325 HEATH STREET LLC",
    "owner2": "",
    "current_taxes": 77675.52,
    "new_taxes_no_override": 81031.1,
    "override_total_1": 83330.3,
    "override_increase_1": 2299.2
  },
  {
    "#": "327 Heath St (437-63-00)",
    "$": 7379300,
    "address": "327 Heath St",
    "parcel_id": "437-63-00",
    "owner1": "KAY  ET AL TRS, STEPHEN B",
    "owner2": "TARLOW, LISBETH L",
    "current_taxes": 71929.1,
    "new_taxes_no_override": 75036.44,
    "override_total_1": 77165.54,
    "override_increase_1": 2129.1
  },
  {
    "#": "329 Heath St (437-64-00)",
    "$": 8108700,
    "address": "329 Heath St",
    "parcel_id": "437-64-00",
    "owner1": "LEVENSON, SONDRA H",
    "owner2": "",
    "current_taxes": 79398.15,
    "new_taxes_no_override": 82828.15,
    "override_total_1": 85178.34,
    "override_increase_1": 2350.19
  },
  {
    "#": "331 Heath St (437-65-00)",
    "$": 4420500,
    "address": "331 Heath St",
    "parcel_id": "437-65-00",
    "owner1": "MALKIN, DONALD J",
    "owner2": "",
    "current_taxes": 41630.99,
    "new_taxes_no_override": 43429.45,
    "override_total_1": 44661.73,
    "override_increase_1": 1232.28
  },
  {
    "#": "333 Heath St (437-66-00)",
    "$": 6674400,
    "address": "333 Heath St",
    "parcel_id": "437-66-00",
    "owner1": "BASILE TRS, ROBERT W & PAULA K",
    "owner2": "",
    "current_taxes": 64710.92,
    "new_taxes_no_override": 67506.43,
    "override_total_1": 69421.87,
    "override_increase_1": 1915.44
  },
  {
    "#": "335 Heath St (437-67-00)",
    "$": 4845100,
    "address": "335 Heath St",
    "parcel_id": "437-67-00",
    "owner1": "MEATUS LLC",
    "owner2": "",
    "current_taxes": 49613.82,
    "new_taxes_no_override": 51757.14,
    "override_total_1": 53225.71,
    "override_increase_1": 1468.57
  },
  {
    "#": "358 Heath St (440-44-02)",
    "$": 3094600,
    "address": "358 Heath St",
    "parcel_id": "440-44-02",
    "owner1": "TRUSTEES OF BOSTON COLLEGE",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "359 Heath St (437-68-00)",
    "$": 3208800,
    "address": "359 Heath St",
    "parcel_id": "437-68-00",
    "owner1": "OBI, OLUFEMI J",
    "owner2": "",
    "current_taxes": 29223.18,
    "new_taxes_no_override": 30485.62,
    "override_total_1": 31350.63,
    "override_increase_1": 865.01
  },
  {
    "#": "370 Heath St (440-45-00)",
    "$": 3000600,
    "address": "370 Heath St",
    "parcel_id": "440-45-00",
    "owner1": "TRUSTEES OF BOSTON COLLEGE",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "375 Heath St (435-11-00)",
    "$": 3381600,
    "address": "375 Heath St",
    "parcel_id": "435-11-00",
    "owner1": "LEE, DAVID H & STACEY S",
    "owner2": "",
    "current_taxes": 30992.65,
    "new_taxes_no_override": 32331.53,
    "override_total_1": 33248.91,
    "override_increase_1": 917.38
  },
  {
    "#": "385 Heath St (435-12-13)",
    "$": 2983200,
    "address": "385 Heath St",
    "parcel_id": "435-12-13",
    "owner1": "HACKETT, VICTORIA A",
    "owner2": "",
    "current_taxes": 26913.03,
    "new_taxes_no_override": 28075.67,
    "override_total_1": 28872.3,
    "override_increase_1": 796.63
  },
  {
    "#": "386 Heath St (440-46-00)",
    "$": 3004700,
    "address": "386 Heath St",
    "parcel_id": "440-46-00",
    "owner1": "TRUSTEES OF BOSTON COLLEGE",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "393 Heath St (435-14-00)",
    "$": 3297000,
    "address": "393 Heath St",
    "parcel_id": "435-14-00",
    "owner1": "SILBERSWEIG, DAVID",
    "owner2": "STERN, EMILY",
    "current_taxes": 30126.35,
    "new_taxes_no_override": 31427.81,
    "override_total_1": 32319.55,
    "override_increase_1": 891.74
  },
  {
    "#": "400 Heath St (440-39-01)",
    "$": 101086000,
    "address": "400 Heath St",
    "parcel_id": "440-39-01",
    "owner1": "TRUSTEES OF BOSTON COLLEGE",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "401 Heath St (435-15-00)",
    "$": 2830600,
    "address": "401 Heath St",
    "parcel_id": "435-15-00",
    "owner1": "HOOKS, JASON",
    "owner2": "RUSSELL, LILY",
    "current_taxes": 25350.41,
    "new_taxes_no_override": 26445.55,
    "override_total_1": 27195.92,
    "override_increase_1": 750.37
  },
  {
    "#": "402 Heath St (440-47-00)",
    "$": 3008200,
    "address": "402 Heath St",
    "parcel_id": "440-47-00",
    "owner1": "TRUSTEES OF BOSTON COLLEGE",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "409 Heath St (435-16-00)",
    "$": 3407800,
    "address": "409 Heath St",
    "parcel_id": "435-16-00",
    "owner1": "CHEN, SHOUCONG",
    "owner2": "LIN, XIRONG",
    "current_taxes": 31260.94,
    "new_taxes_no_override": 32611.41,
    "override_total_1": 33536.74,
    "override_increase_1": 925.32
  },
  {
    "#": "421 Heath St (435-17-00)",
    "$": 2749500,
    "address": "421 Heath St",
    "parcel_id": "435-17-00",
    "owner1": "BOLKWADZE, NATIA",
    "owner2": "",
    "current_taxes": 28154.88,
    "new_taxes_no_override": 29371.17,
    "override_total_1": 30204.56,
    "override_increase_1": 833.38
  },
  {
    "#": "435 Heath St (435-01-00)",
    "$": 4717600,
    "address": "435 Heath St",
    "parcel_id": "435-01-00",
    "owner1": "DHIR, ATUL & G MAYA",
    "owner2": "",
    "current_taxes": 44673.29,
    "new_taxes_no_override": 46603.18,
    "override_total_1": 47925.51,
    "override_increase_1": 1322.33
  },
  {
    "#": "456 Heath St (432-26-05)",
    "$": 4972200,
    "address": "456 Heath St",
    "parcel_id": "432-26-05",
    "owner1": "FLETCHER, PETER",
    "owner2": "MARTIN, ELISABETH",
    "current_taxes": 50915.33,
    "new_taxes_no_override": 53114.87,
    "override_total_1": 54621.97,
    "override_increase_1": 1507.09
  },
  {
    "#": "458 Heath St (432-26-04)",
    "$": 4656400,
    "address": "458 Heath St",
    "parcel_id": "432-26-04",
    "owner1": "CHEN, QIANHONG",
    "owner2": "LI, XUE",
    "current_taxes": 47681.54,
    "new_taxes_no_override": 49741.38,
    "override_total_1": 51152.76,
    "override_increase_1": 1411.37
  },
  {
    "#": "459 Heath St (434-08-00)",
    "$": 2377700,
    "address": "459 Heath St",
    "parcel_id": "434-08-00",
    "owner1": "MULYANTO, SAMUEL & LILIANA S",
    "owner2": "",
    "current_taxes": 24347.65,
    "new_taxes_no_override": 25399.47,
    "override_total_1": 26120.16,
    "override_increase_1": 720.69
  },
  {
    "#": "460 Heath St (432-26-03)",
    "$": 3298600,
    "address": "460 Heath St",
    "parcel_id": "432-26-03",
    "owner1": "SPIEGEL TRS, JEFFREY H & ONIR LESHEM",
    "owner2": "",
    "current_taxes": 33777.66,
    "new_taxes_no_override": 35236.85,
    "override_total_1": 36236.67,
    "override_increase_1": 999.82
  },
  {
    "#": "462 Heath St (432-26-02)",
    "$": 3382800,
    "address": "462 Heath St",
    "parcel_id": "432-26-02",
    "owner1": "XU, HAOTIAN",
    "owner2": "",
    "current_taxes": 31004.94,
    "new_taxes_no_override": 32344.35,
    "override_total_1": 33262.1,
    "override_increase_1": 917.75
  },
  {
    "#": "471 Heath St (434-09-00)",
    "$": 2990600,
    "address": "471 Heath St",
    "parcel_id": "434-09-00",
    "owner1": "GUSTAFSON, ERIC K",
    "owner2": "SHANNON, LENORE",
    "current_taxes": 30623.74,
    "new_taxes_no_override": 31946.69,
    "override_total_1": 32853.15,
    "override_increase_1": 906.46
  },
  {
    "#": "475 Heath St (434-10-00)",
    "$": 2891200,
    "address": "475 Heath St",
    "parcel_id": "434-10-00",
    "owner1": "LOGAN, DAVID S & HOLLI S",
    "owner2": "",
    "current_taxes": 25970.95,
    "new_taxes_no_override": 27092.9,
    "override_total_1": 27861.64,
    "override_increase_1": 768.74
  },
  {
    "#": "476 Heath St (432-25-00)",
    "$": 2836100,
    "address": "476 Heath St",
    "parcel_id": "432-25-00",
    "owner1": "476 HEATH STREET LLC",
    "owner2": "",
    "current_taxes": 29041.66,
    "new_taxes_no_override": 30296.26,
    "override_total_1": 31155.89,
    "override_increase_1": 859.63
  },
  {
    "#": "484 Heath St (432-20-24)",
    "$": 11017000,
    "address": "484 Heath St",
    "parcel_id": "432-20-24",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O BALDWIN SCHOOL",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "495 Heath St (433-03-00)",
    "$": 1358800,
    "address": "495 Heath St",
    "parcel_id": "433-03-00",
    "owner1": "WRIGHT, ROBERT W & JACALYN M",
    "owner2": "",
    "current_taxes": 13914.11,
    "new_taxes_no_override": 14515.2,
    "override_total_1": 14927.06,
    "override_increase_1": 411.86
  },
  {
    "#": "501 Heath St (433-04-00)",
    "$": 1713300,
    "address": "501 Heath St",
    "parcel_id": "433-04-00",
    "owner1": "LOBERFIELD, TR, ROBERTA I",
    "owner2": "",
    "current_taxes": 29400.23,
    "new_taxes_no_override": 30670.32,
    "override_total_1": 31540.57,
    "override_increase_1": 870.25
  },
  {
    "#": "508 Heath St (432-17-00)",
    "$": 1419900,
    "address": "508 Heath St",
    "parcel_id": "432-17-00",
    "owner1": "ARNAOUT, AMAL K",
    "owner2": "",
    "current_taxes": 14539.78,
    "new_taxes_no_override": 15167.9,
    "override_total_1": 15598.28,
    "override_increase_1": 430.38
  },
  {
    "#": "513 Heath St (433-08-00)",
    "$": 1531400,
    "address": "513 Heath St",
    "parcel_id": "433-08-00",
    "owner1": "TASO, SELIM",
    "owner2": "",
    "current_taxes": 15681.54,
    "new_taxes_no_override": 16358.98,
    "override_total_1": 16823.16,
    "override_increase_1": 464.17
  },
  {
    "#": "517 Heath St (433-09-00)",
    "$": 1212600,
    "address": "517 Heath St",
    "parcel_id": "433-09-00",
    "owner1": "YUH, DAVID J & FAITH H",
    "owner2": "",
    "current_taxes": 8782.09,
    "new_taxes_no_override": 9161.48,
    "override_total_1": 9421.43,
    "override_increase_1": 259.95
  },
  {
    "#": "521 Heath St (433-09-01)",
    "$": 1487900,
    "address": "521 Heath St",
    "parcel_id": "433-09-01",
    "owner1": "LEE, WAN JAE & KWANG JA",
    "owner2": "",
    "current_taxes": 11601.16,
    "new_taxes_no_override": 12102.33,
    "override_total_1": 12445.72,
    "override_increase_1": 343.39
  },
  {
    "#": "545 Heath St (428-10-00)",
    "$": 795200,
    "address": "545 Heath St",
    "parcel_id": "428-10-00",
    "owner1": "CH REALTY VENTURES LLC",
    "owner2": "",
    "current_taxes": 8142.85,
    "new_taxes_no_override": 8494.62,
    "override_total_1": 8735.65,
    "override_increase_1": 241.03
  },
  {
    "#": "555 Heath St, Unit 1 (428-11-01)",
    "$": 900600,
    "address": "555 Heath St, Unit 1",
    "parcel_id": "428-11-01",
    "owner1": "ARGIROS, MICHAEL",
    "owner2": "",
    "current_taxes": 9222.14,
    "new_taxes_no_override": 9620.54,
    "override_total_1": 9893.51,
    "override_increase_1": 272.98
  },
  {
    "#": "555 Heath St, Unit 2 (428-11-02)",
    "$": 842800,
    "address": "555 Heath St, Unit 2",
    "parcel_id": "428-11-02",
    "owner1": "ARGIROS, MICHAEL",
    "owner2": "",
    "current_taxes": 8630.27,
    "new_taxes_no_override": 9003.1,
    "override_total_1": 9258.55,
    "override_increase_1": 255.46
  },
  {
    "#": "555 Heath St, Unit 3 (428-11-03)",
    "$": 1204100,
    "address": "555 Heath St, Unit 3",
    "parcel_id": "428-11-03",
    "owner1": "ARGIROS, MICHAEL",
    "owner2": "",
    "current_taxes": 12329.98,
    "new_taxes_no_override": 12862.64,
    "override_total_1": 13227.6,
    "override_increase_1": 364.97
  },
  {
    "#": "557 Heath St (428-12-00)",
    "$": 1970900,
    "address": "557 Heath St",
    "parcel_id": "428-12-00",
    "owner1": "CROWLEY TR, XIAONING",
    "owner2": "",
    "current_taxes": 20182.02,
    "new_taxes_no_override": 21053.88,
    "override_total_1": 21651.27,
    "override_increase_1": 597.39
  },
  {
    "#": "559 Heath St (428-13-00)",
    "$": 1587400,
    "address": "559 Heath St",
    "parcel_id": "428-13-00",
    "owner1": "LYCOURGOS, DOROTHY S",
    "owner2": "",
    "current_taxes": 12620.04,
    "new_taxes_no_override": 13165.23,
    "override_total_1": 13538.78,
    "override_increase_1": 373.55
  },
  {
    "#": "563 Heath St, Unit 1 (428-14-03)",
    "$": 885600,
    "address": "563 Heath St, Unit 1",
    "parcel_id": "428-14-03",
    "owner1": "WATTS, GERALD F M & LINDA N",
    "owner2": "",
    "current_taxes": 5433.61,
    "new_taxes_no_override": 5668.34,
    "override_total_1": 5829.18,
    "override_increase_1": 160.83
  },
  {
    "#": "563 Heath St, Unit 2 (428-14-01)",
    "$": 897800,
    "address": "563 Heath St, Unit 2",
    "parcel_id": "428-14-01",
    "owner1": "KATS, YEVGENY",
    "owner2": "",
    "current_taxes": 9193.47,
    "new_taxes_no_override": 9590.63,
    "override_total_1": 9862.75,
    "override_increase_1": 272.13
  },
  {
    "#": "563 Heath St, Unit 3 (428-14-02)",
    "$": 1214400,
    "address": "563 Heath St, Unit 3",
    "parcel_id": "428-14-02",
    "owner1": "YOON, JASON",
    "owner2": "HO, KA-WAI GRACE",
    "current_taxes": 8800.52,
    "new_taxes_no_override": 9180.7,
    "override_total_1": 9441.2,
    "override_increase_1": 260.5
  },
  {
    "#": "566 Heath St, Unit 1 (429-01-01)",
    "$": 892400,
    "address": "566 Heath St, Unit 1",
    "parcel_id": "429-01-01",
    "owner1": "ABRISHAMIAN, NIKI",
    "owner2": "",
    "current_taxes": 5503.24,
    "new_taxes_no_override": 5740.98,
    "override_total_1": 5903.88,
    "override_increase_1": 162.9
  },
  {
    "#": "566 Heath St, Unit 2 (429-01-02)",
    "$": 910000,
    "address": "566 Heath St, Unit 2",
    "parcel_id": "429-01-02",
    "owner1": "SOLOMON, MARTIN",
    "owner2": "BERMAN-GNIVECKI, ALANA",
    "current_taxes": 9318.4,
    "new_taxes_no_override": 9720.95,
    "override_total_1": 9996.78,
    "override_increase_1": 275.82
  },
  {
    "#": "566 Heath St, Unit 3 (429-01-03)",
    "$": 745200,
    "address": "566 Heath St, Unit 3",
    "parcel_id": "429-01-03",
    "owner1": "PIETRZAK, VINCENT & JEANNE & ANNA",
    "owner2": "",
    "current_taxes": 7630.85,
    "new_taxes_no_override": 7960.5,
    "override_total_1": 8186.38,
    "override_increase_1": 225.87
  },
  {
    "#": "584 Heath St (429-43-00)",
    "$": 17493400,
    "address": "584 Heath St",
    "parcel_id": "429-43-00",
    "owner1": "ROMAN CATHOLIC ARCHBISHOP",
    "owner2": "HOLYHOOD CEMETARY",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "593 Heath St (426-08-00)",
    "$": 1825900,
    "address": "593 Heath St",
    "parcel_id": "426-08-00",
    "owner1": "MARGOLIS TRS, FREDRIC H",
    "owner2": "MARTIN , JEFFREY R",
    "current_taxes": 18697.22,
    "new_taxes_no_override": 19504.94,
    "override_total_1": 20058.38,
    "override_increase_1": 553.44
  },
  {
    "#": "595 Heath St (426-09-00)",
    "$": 1119000,
    "address": "595 Heath St",
    "parcel_id": "426-09-00",
    "owner1": "SHALHOUB, LUISA S",
    "owner2": "",
    "current_taxes": 7823.63,
    "new_taxes_no_override": 8161.61,
    "override_total_1": 8393.19,
    "override_increase_1": 231.58
  },
  {
    "#": "599 Heath St (426-10-00)",
    "$": 1123600,
    "address": "599 Heath St",
    "parcel_id": "426-10-00",
    "owner1": "CHAMBERLAIN, JAMES & LAURA J",
    "owner2": "",
    "current_taxes": 7870.73,
    "new_taxes_no_override": 8210.75,
    "override_total_1": 8443.72,
    "override_increase_1": 232.97
  },
  {
    "#": "601 Heath St (426-10-01)",
    "$": 1206000,
    "address": "601 Heath St",
    "parcel_id": "426-10-01",
    "owner1": "MARGOLIS TRS, FREDRIC H",
    "owner2": "MARTIN , JEFFREY R",
    "current_taxes": 12349.44,
    "new_taxes_no_override": 12882.94,
    "override_total_1": 13248.48,
    "override_increase_1": 365.54
  },
  {
    "#": "603 Heath St (426-10-02)",
    "$": 914500,
    "address": "603 Heath St",
    "parcel_id": "426-10-02",
    "owner1": "MARGOLIS, TRS, FREDERIC H & CALVIN",
    "owner2": "",
    "current_taxes": 9364.48,
    "new_taxes_no_override": 9769.03,
    "override_total_1": 10046.21,
    "override_increase_1": 277.19
  },
  {
    "#": "605 Heath St (426-10-03)",
    "$": 951000,
    "address": "605 Heath St",
    "parcel_id": "426-10-03",
    "owner1": "CARNEY, BRIAN",
    "owner2": "",
    "current_taxes": 6103.31,
    "new_taxes_no_override": 6366.97,
    "override_total_1": 6547.63,
    "override_increase_1": 180.66
  },
  {
    "#": "615 Heath St (426-11-13)",
    "$": 34227200,
    "address": "615 Heath St",
    "parcel_id": "426-11-13",
    "owner1": "CHESTNUT HILL PROPCO LLC",
    "owner2": "C/O LCB SENIOR LIVING",
    "current_taxes": 350486.53,
    "new_taxes_no_override": 365627.55,
    "override_total_1": 376001.95,
    "override_increase_1": 10374.4
  },
  {
    "#": "629 Heath St (425-07-00)",
    "$": 1258700,
    "address": "629 Heath St",
    "parcel_id": "425-07-00",
    "owner1": "MARGOLIS TRS, CALVIN",
    "owner2": "BERGER, STANLEY I",
    "current_taxes": 21599.29,
    "new_taxes_no_override": 22532.38,
    "override_total_1": 23171.72,
    "override_increase_1": 639.34
  },
  {
    "#": "687 Heath St (425-06-00)",
    "$": 1070300,
    "address": "687 Heath St",
    "parcel_id": "425-06-00",
    "owner1": "OSBORNE TR, KATHLEEN ANDREADIS",
    "owner2": "",
    "current_taxes": 10959.87,
    "new_taxes_no_override": 11433.34,
    "override_total_1": 11757.75,
    "override_increase_1": 324.41
  },
  {
    "#": "691 Heath St (425-04-00)",
    "$": 1570300,
    "address": "691 Heath St",
    "parcel_id": "425-04-00",
    "owner1": "BATTITE, KRISTEN",
    "owner2": "BARNEY, TRACEY",
    "current_taxes": 12444.94,
    "new_taxes_no_override": 12982.56,
    "override_total_1": 13350.93,
    "override_increase_1": 368.37
  },
  {
    "#": "695 Heath St, Unit 1 (425-03-01)",
    "$": 1890500,
    "address": "695 Heath St, Unit 1",
    "parcel_id": "425-03-01",
    "owner1": "PULLANO, THOMAS & MICHELLE M",
    "owner2": "",
    "current_taxes": 15723.79,
    "new_taxes_no_override": 16403.06,
    "override_total_1": 16868.48,
    "override_increase_1": 465.42
  },
  {
    "#": "695 Heath St, Unit 2 (425-03-02)",
    "$": 1881400,
    "address": "695 Heath St, Unit 2",
    "parcel_id": "425-03-02",
    "owner1": "SHRAYER TRS, MAXIM D",
    "owner2": "LASSER, KAREN E",
    "current_taxes": 15630.6,
    "new_taxes_no_override": 16305.84,
    "override_total_1": 16768.51,
    "override_increase_1": 462.67
  },
  {
    "#": "709 Heath St (424-22-00)",
    "$": 1391100,
    "address": "709 Heath St",
    "parcel_id": "424-22-00",
    "owner1": "PANIS TRS, WALTER",
    "owner2": "HARRISON, SHELLY R",
    "current_taxes": 10609.93,
    "new_taxes_no_override": 11068.28,
    "override_total_1": 11382.33,
    "override_increase_1": 314.05
  },
  {
    "#": "711 Heath St (424-21-00)",
    "$": 1008700,
    "address": "711 Heath St",
    "parcel_id": "424-21-00",
    "owner1": "HEAVEY, BERNARD J & PATRICIA A",
    "owner2": "",
    "current_taxes": 6694.15,
    "new_taxes_no_override": 6983.34,
    "override_total_1": 7181.48,
    "override_increase_1": 198.15
  },
  {
    "#": "717 Heath St (424-20-00)",
    "$": 1219500,
    "address": "717 Heath St",
    "parcel_id": "424-20-00",
    "owner1": "BULLARD LIFE ESTATE, JOSEPH W JR & VIRGINIA",
    "owner2": "",
    "current_taxes": 8852.75,
    "new_taxes_no_override": 9235.19,
    "override_total_1": 9497.23,
    "override_increase_1": 262.04
  },
  {
    "#": "721 Heath St (424-19-00)",
    "$": 1125400,
    "address": "721 Heath St",
    "parcel_id": "424-19-00",
    "owner1": "BULLARD LIFE ESTATE, JOSEPH W JR & VIRGINIA",
    "owner2": "",
    "current_taxes": 11524.1,
    "new_taxes_no_override": 12021.94,
    "override_total_1": 12363.05,
    "override_increase_1": 341.11
  },
  {
    "#": "725 Heath St (424-18-00)",
    "$": 1250600,
    "address": "725 Heath St",
    "parcel_id": "424-18-00",
    "owner1": "HOFFMAN, GREGORY R",
    "owner2": "WALKER, STEPHANIE J",
    "current_taxes": 9171.21,
    "new_taxes_no_override": 9567.41,
    "override_total_1": 9838.87,
    "override_increase_1": 271.47
  },
  {
    "#": "727 Heath St (424-17-00)",
    "$": 996200,
    "address": "727 Heath St",
    "parcel_id": "424-17-00",
    "owner1": "DETZ TR, SUSAN",
    "owner2": "",
    "current_taxes": 6566.15,
    "new_taxes_no_override": 6849.81,
    "override_total_1": 7044.17,
    "override_increase_1": 194.36
  },
  {
    "#": "731 Heath St (424-15-16)",
    "$": 1374700,
    "address": "731 Heath St",
    "parcel_id": "424-15-16",
    "owner1": "BAKER, EDWARD J & DIANE H",
    "owner2": "",
    "current_taxes": 10441.99,
    "new_taxes_no_override": 10893.08,
    "override_total_1": 11202.17,
    "override_increase_1": 309.08
  },
  {
    "#": "739 Heath St (424-14-00)",
    "$": 1229900,
    "address": "739 Heath St",
    "parcel_id": "424-14-00",
    "owner1": "KADETS, PHILIP I",
    "owner2": "",
    "current_taxes": 12594.18,
    "new_taxes_no_override": 13138.25,
    "override_total_1": 13511.04,
    "override_increase_1": 372.79
  },
  {
    "#": "741 Heath St, Unit 1 & Pk 1A 1B (424-13-01)",
    "$": 824300,
    "address": "741 Heath St, Unit 1 & Pk 1A 1B",
    "parcel_id": "424-13-01",
    "owner1": "KMIEC, KEVIN JOHN & CHRISTINE GIAMBONE",
    "owner2": "",
    "current_taxes": 8440.83,
    "new_taxes_no_override": 8805.47,
    "override_total_1": 9055.32,
    "override_increase_1": 249.85
  },
  {
    "#": "741 Heath St, Unit 2 & Pk 2A-2B (424-13-02)",
    "$": 818400,
    "address": "741 Heath St, Unit 2 & Pk 2A-2B",
    "parcel_id": "424-13-02",
    "owner1": "BLOOM, LESLIE A",
    "owner2": "",
    "current_taxes": 4745.48,
    "new_taxes_no_override": 4950.48,
    "override_total_1": 5090.95,
    "override_increase_1": 140.47
  },
  {
    "#": "741 Heath St, Unit 3 & Pk 3A-B-C-D (424-13-03)",
    "$": 914600,
    "address": "741 Heath St, Unit 3 & Pk 3A-B-C-D",
    "parcel_id": "424-13-03",
    "owner1": "AV & P RENTAL LLC",
    "owner2": "",
    "current_taxes": 9365.5,
    "new_taxes_no_override": 9770.09,
    "override_total_1": 10047.31,
    "override_increase_1": 277.22
  },
  {
    "#": "745 Heath St (424-12-00)",
    "$": 1141900,
    "address": "745 Heath St",
    "parcel_id": "424-12-00",
    "owner1": "HINES, BLAIR",
    "owner2": "JURCHAK, MARTHA K",
    "current_taxes": 8058.12,
    "new_taxes_no_override": 8406.23,
    "override_total_1": 8644.75,
    "override_increase_1": 238.52
  },
  {
    "#": "749 Heath St, Unit 1 (424-11-02)",
    "$": 1283300,
    "address": "749 Heath St, Unit 1",
    "parcel_id": "424-11-02",
    "owner1": "BUCCI, ALLISON",
    "owner2": "",
    "current_taxes": 9506.06,
    "new_taxes_no_override": 9916.72,
    "override_total_1": 10198.1,
    "override_increase_1": 281.38
  },
  {
    "#": "751 Heath St, Unit 2 (424-11-01)",
    "$": 1686300,
    "address": "751 Heath St, Unit 2",
    "parcel_id": "424-11-01",
    "owner1": "KOVALCIK LIFE ESTATE, RIMMA",
    "owner2": "",
    "current_taxes": 13632.78,
    "new_taxes_no_override": 14221.72,
    "override_total_1": 14625.25,
    "override_increase_1": 403.53
  },
  {
    "#": "755 Heath St (424-10-00)",
    "$": 1100900,
    "address": "755 Heath St",
    "parcel_id": "424-10-00",
    "owner1": "MATORIN TRS, ROBERT M",
    "owner2": "BELTIS, JUDITH A",
    "current_taxes": 7638.28,
    "new_taxes_no_override": 7968.25,
    "override_total_1": 8194.35,
    "override_increase_1": 226.09
  },
  {
    "#": "756 Heath St (421-15-00)",
    "$": 1061300,
    "address": "756 Heath St",
    "parcel_id": "421-15-00",
    "owner1": "HOPKINS TRS, PETER G & SHEILA F",
    "owner2": "",
    "current_taxes": 7232.78,
    "new_taxes_no_override": 7545.24,
    "override_total_1": 7759.33,
    "override_increase_1": 214.09
  },
  {
    "#": "767 Heath St, Unit 767 & 1T-2T-32-34 (424-06-20)",
    "$": 1674500,
    "address": "767 Heath St, Unit 767 & 1T-2T-32-34",
    "parcel_id": "424-06-20",
    "owner1": "FAIGEN, MARTHA S",
    "owner2": "",
    "current_taxes": 13511.95,
    "new_taxes_no_override": 14095.67,
    "override_total_1": 14495.62,
    "override_increase_1": 399.95
  },
  {
    "#": "769 Heath St, Unit 769&3T 4T (424-06-21)",
    "$": 1856000,
    "address": "769 Heath St, Unit 769&3T 4T",
    "parcel_id": "424-06-21",
    "owner1": "KWOK, SHELDON J J",
    "owner2": "ZHANG, JIAHE",
    "current_taxes": 19005.44,
    "new_taxes_no_override": 19826.48,
    "override_total_1": 20389.04,
    "override_increase_1": 562.56
  },
  {
    "#": "771 Heath St, Unit 771 & 5T 6T (424-06-22)",
    "$": 1994300,
    "address": "771 Heath St, Unit 771 & 5T 6T",
    "parcel_id": "424-06-22",
    "owner1": "TADMOR, BRIGITTA",
    "owner2": "",
    "current_taxes": 16786.7,
    "new_taxes_no_override": 17511.89,
    "override_total_1": 18008.77,
    "override_increase_1": 496.89
  },
  {
    "#": "773 Heath St, Unit 773&7T 8T (424-06-23)",
    "$": 1752500,
    "address": "773 Heath St, Unit 773&7T 8T",
    "parcel_id": "424-06-23",
    "owner1": "ANATOLE, ELENA EUGENE",
    "owner2": "",
    "current_taxes": 17945.6,
    "new_taxes_no_override": 18720.85,
    "override_total_1": 19252.04,
    "override_increase_1": 531.19
  },
  {
    "#": "775 Heath St, Unit 775& 9T10T (424-06-24)",
    "$": 1650900,
    "address": "775 Heath St, Unit 775& 9T10T",
    "parcel_id": "424-06-24",
    "owner1": "DU, YULU",
    "owner2": "",
    "current_taxes": 13270.28,
    "new_taxes_no_override": 13843.56,
    "override_total_1": 14236.36,
    "override_increase_1": 392.8
  },
  {
    "#": "779 Heath St (424-01-00)",
    "$": 1120100,
    "address": "779 Heath St",
    "parcel_id": "424-01-00",
    "owner1": "CHEN, TRASONG",
    "owner2": "LIN, MEN JAN",
    "current_taxes": 7834.89,
    "new_taxes_no_override": 8173.36,
    "override_total_1": 8405.27,
    "override_increase_1": 231.91
  },
  {
    "#": "789 Heath St (424A-07-00)",
    "$": 1055700,
    "address": "789 Heath St",
    "parcel_id": "424A-07-00",
    "owner1": "SAVAGE TR, JANET",
    "owner2": "",
    "current_taxes": 10810.37,
    "new_taxes_no_override": 11277.38,
    "override_total_1": 11597.36,
    "override_increase_1": 319.99
  },
  {
    "#": "790 Heath St (423-02-01)",
    "$": 1935500,
    "address": "790 Heath St",
    "parcel_id": "423-02-01",
    "owner1": "FRANKEL TRS, IRWIN H & MARCY",
    "owner2": "",
    "current_taxes": 16184.59,
    "new_taxes_no_override": 16883.76,
    "override_total_1": 17362.83,
    "override_increase_1": 479.06
  },
  {
    "#": "794 Heath St, Unit 794 (423-02-11)",
    "$": 1564700,
    "address": "794 Heath St, Unit 794",
    "parcel_id": "423-02-11",
    "owner1": "MINTZ TRS, DAVID I & BETH F",
    "owner2": "",
    "current_taxes": 16022.53,
    "new_taxes_no_override": 16714.7,
    "override_total_1": 17188.97,
    "override_increase_1": 474.27
  },
  {
    "#": "794 Heath St, Unit 796 (423-02-12)",
    "$": 1570800,
    "address": "794 Heath St, Unit 796",
    "parcel_id": "423-02-12",
    "owner1": "PAREKH, VISHAL",
    "owner2": "BIWALKAR, PRACHI",
    "current_taxes": 12450.06,
    "new_taxes_no_override": 12987.9,
    "override_total_1": 13356.42,
    "override_increase_1": 368.52
  },
  {
    "#": "797 Heath St, Unit 1 (424A-05-01)",
    "$": 1552400,
    "address": "797 Heath St, Unit 1",
    "parcel_id": "424A-05-01",
    "owner1": "AZOULAY TR, JESSICA",
    "owner2": "",
    "current_taxes": 15896.58,
    "new_taxes_no_override": 16583.31,
    "override_total_1": 17053.85,
    "override_increase_1": 470.54
  },
  {
    "#": "797 Heath St, Unit 2 (424A-05-02)",
    "$": 1544700,
    "address": "797 Heath St, Unit 2",
    "parcel_id": "424A-05-02",
    "owner1": "FERNANDEZ, NELSON & TERESA LAUREN",
    "owner2": "",
    "current_taxes": 12182.79,
    "new_taxes_no_override": 12709.09,
    "override_total_1": 13069.7,
    "override_increase_1": 360.61
  },
  {
    "#": "798 Heath St, Unit 798 (423-02-09)",
    "$": 527000,
    "address": "798 Heath St, Unit 798",
    "parcel_id": "423-02-09",
    "owner1": "RODRIGUEZ, BENJAMIN A",
    "owner2": "ZARE, SABA",
    "current_taxes": 5396.48,
    "new_taxes_no_override": 5629.61,
    "override_total_1": 5789.34,
    "override_increase_1": 159.74
  },
  {
    "#": "800 Heath St, Unit 800 (423-02-10)",
    "$": 642800,
    "address": "800 Heath St, Unit 800",
    "parcel_id": "423-02-10",
    "owner1": "ASSUNCAO ETAL, ROSILDA",
    "owner2": "SANTOS, KATHERYN & ABRAHAM",
    "current_taxes": 2947.34,
    "new_taxes_no_override": 3074.67,
    "override_total_1": 3161.91,
    "override_increase_1": 87.24
  },
  {
    "#": "805 Heath St, Unit 1 (424A-04-01)",
    "$": 1927000,
    "address": "805 Heath St, Unit 1",
    "parcel_id": "424A-04-01",
    "owner1": "CLEMONS, KEEFE & JANA",
    "owner2": "",
    "current_taxes": 16097.55,
    "new_taxes_no_override": 16792.96,
    "override_total_1": 17269.45,
    "override_increase_1": 476.49
  },
  {
    "#": "805 Heath St, Unit 2 (424A-04-02)",
    "$": 2334000,
    "address": "805 Heath St, Unit 2",
    "parcel_id": "424A-04-02",
    "owner1": "PONDER TRS, KATHERINE P & JAY W",
    "owner2": "",
    "current_taxes": 20265.23,
    "new_taxes_no_override": 21140.69,
    "override_total_1": 21740.54,
    "override_increase_1": 599.85
  },
  {
    "#": "806 Heath St (423-03-00)",
    "$": 1743500,
    "address": "806 Heath St",
    "parcel_id": "423-03-00",
    "owner1": "GLASER, THOMAS A & GAIL P",
    "owner2": "",
    "current_taxes": 14218.51,
    "new_taxes_no_override": 14832.75,
    "override_total_1": 15253.62,
    "override_increase_1": 420.87
  },
  {
    "#": "809 Heath St, Unit 1 (424A-03-04)",
    "$": 2196500,
    "address": "809 Heath St, Unit 1",
    "parcel_id": "424A-03-04",
    "owner1": "295 PHILLIPS ROAD LLC",
    "owner2": "",
    "current_taxes": 22492.16,
    "new_taxes_no_override": 23463.82,
    "override_total_1": 24129.59,
    "override_increase_1": 665.77
  },
  {
    "#": "809 Heath St, Unit 2 (424A-03-05)",
    "$": 2252700,
    "address": "809 Heath St, Unit 2",
    "parcel_id": "424A-03-05",
    "owner1": "5C CONTRACTING LLC",
    "owner2": "",
    "current_taxes": 23067.65,
    "new_taxes_no_override": 24064.17,
    "override_total_1": 24746.97,
    "override_increase_1": 682.8
  },
  {
    "#": "813 Heath St (424A-02-00)",
    "$": 1309500,
    "address": "813 Heath St",
    "parcel_id": "424A-02-00",
    "owner1": "SAHOO, NACHIKETA & DIPTIMAYEE",
    "owner2": "",
    "current_taxes": 9774.35,
    "new_taxes_no_override": 10196.6,
    "override_total_1": 10485.92,
    "override_increase_1": 289.32
  },
  {
    "#": "816 Heath St, Unit A (423-04-15)",
    "$": 1999000,
    "address": "816 Heath St, Unit A",
    "parcel_id": "423-04-15",
    "owner1": "AZENKOT, TOMER & DAFNA",
    "owner2": "",
    "current_taxes": 16834.83,
    "new_taxes_no_override": 17562.09,
    "override_total_1": 18060.41,
    "override_increase_1": 498.31
  },
  {
    "#": "816 Heath St, Unit B (423-04-16)",
    "$": 2039600,
    "address": "816 Heath St, Unit B",
    "parcel_id": "423-04-16",
    "owner1": "REESE, BENJAMIN",
    "owner2": "",
    "current_taxes": 20885.5,
    "new_taxes_no_override": 21787.75,
    "override_total_1": 22405.96,
    "override_increase_1": 618.21
  },
  {
    "#": "1 Heath Wood Ln, Unit 1 (423-04-03)",
    "$": 1306800,
    "address": "1 Heath Wood Ln, Unit 1",
    "parcel_id": "423-04-03",
    "owner1": "PEVZNER TR, MARIA",
    "owner2": "",
    "current_taxes": 13381.63,
    "new_taxes_no_override": 13959.72,
    "override_total_1": 14355.81,
    "override_increase_1": 396.1
  },
  {
    "#": "2 Heath Wood Ln, Unit 2 (423-04-04)",
    "$": 1164400,
    "address": "2 Heath Wood Ln, Unit 2",
    "parcel_id": "423-04-04",
    "owner1": "J PROPERTIES LIMTD PARTNERSHIP",
    "owner2": "C/O DAVID E JACOBSON",
    "current_taxes": 11923.46,
    "new_taxes_no_override": 12438.55,
    "override_total_1": 12791.49,
    "override_increase_1": 352.93
  },
  {
    "#": "3 Heath Wood Ln, Unit 3 (423-04-05)",
    "$": 1209100,
    "address": "3 Heath Wood Ln, Unit 3",
    "parcel_id": "423-04-05",
    "owner1": "ORDIA, JOE I",
    "owner2": "",
    "current_taxes": 8746.25,
    "new_taxes_no_override": 9124.09,
    "override_total_1": 9382.98,
    "override_increase_1": 258.89
  },
  {
    "#": "4 Heath Wood Ln, Unit 4 (423-04-06)",
    "$": 1104600,
    "address": "4 Heath Wood Ln, Unit 4",
    "parcel_id": "423-04-06",
    "owner1": "SELETZ OLARSCH TRS, SUZANNE",
    "owner2": "",
    "current_taxes": 7676.17,
    "new_taxes_no_override": 8007.78,
    "override_total_1": 8235.0,
    "override_increase_1": 227.21
  },
  {
    "#": "5 Heath Wood Ln, Unit 5 (423-04-07)",
    "$": 1104600,
    "address": "5 Heath Wood Ln, Unit 5",
    "parcel_id": "423-04-07",
    "owner1": "WEIN TR, MARJORIE S",
    "owner2": "",
    "current_taxes": 7676.17,
    "new_taxes_no_override": 8007.78,
    "override_total_1": 8235.0,
    "override_increase_1": 227.21
  },
  {
    "#": "6 Heath Wood Ln, Unit 6 (423-04-08)",
    "$": 1108700,
    "address": "6 Heath Wood Ln, Unit 6",
    "parcel_id": "423-04-08",
    "owner1": "ZHOU, PINGZHU",
    "owner2": "HUANG, YANNU",
    "current_taxes": 11353.09,
    "new_taxes_no_override": 11843.54,
    "override_total_1": 12179.59,
    "override_increase_1": 336.05
  },
  {
    "#": "7 Heath Wood Ln, Unit 7 (423-04-09)",
    "$": 1121800,
    "address": "7 Heath Wood Ln, Unit 7",
    "parcel_id": "423-04-09",
    "owner1": "KAMEL, MOHAMAD AYAD",
    "owner2": "ABDALLA, NOOR S",
    "current_taxes": 7852.3,
    "new_taxes_no_override": 8191.52,
    "override_total_1": 8423.95,
    "override_increase_1": 232.43
  },
  {
    "#": "8 Heath Wood Ln, Unit 8 (423-04-10)",
    "$": 1107300,
    "address": "8 Heath Wood Ln, Unit 8",
    "parcel_id": "423-04-10",
    "owner1": "QUEEN, MICHAEL",
    "owner2": "",
    "current_taxes": 7703.82,
    "new_taxes_no_override": 8036.63,
    "override_total_1": 8264.66,
    "override_increase_1": 228.03
  },
  {
    "#": "10 Heath Wood Ln, Unit 10 (423-04-11)",
    "$": 1274700,
    "address": "10 Heath Wood Ln, Unit 10",
    "parcel_id": "423-04-11",
    "owner1": "RINALDI, CLAUDIA & BRIAN",
    "owner2": "",
    "current_taxes": 9417.99,
    "new_taxes_no_override": 9824.85,
    "override_total_1": 10103.62,
    "override_increase_1": 278.77
  },
  {
    "#": "12 Heath Wood Ln, Unit 12 (423-04-12)",
    "$": 1231700,
    "address": "12 Heath Wood Ln, Unit 12",
    "parcel_id": "423-04-12",
    "owner1": "HSIEH, YICHUAN GRACE",
    "owner2": "GERAMI-NAINI, BEHZAD",
    "current_taxes": 8977.67,
    "new_taxes_no_override": 9365.51,
    "override_total_1": 9631.24,
    "override_increase_1": 265.74
  },
  {
    "#": "14 Heath Wood Ln, Unit 14 (423-04-13)",
    "$": 1125000,
    "address": "14 Heath Wood Ln, Unit 14",
    "parcel_id": "423-04-13",
    "owner1": "SNYDER, AARON Z",
    "owner2": "KATZ, MARJORIE",
    "current_taxes": 7885.07,
    "new_taxes_no_override": 8225.71,
    "override_total_1": 8459.1,
    "override_increase_1": 233.4
  },
  {
    "#": "16 Heath Wood Ln, Unit 16 & P16 (423-04-14)",
    "$": 1386600,
    "address": "16 Heath Wood Ln, Unit 16 & P16",
    "parcel_id": "423-04-14",
    "owner1": "STOKES, JEFFREY",
    "owner2": "BORGMAN, CHRISTA",
    "current_taxes": 10563.85,
    "new_taxes_no_override": 11020.21,
    "override_total_1": 11332.9,
    "override_increase_1": 312.69
  },
  {
    "#": "18 Heath Wood Ln (423-05-00)",
    "$": 1792100,
    "address": "18 Heath Wood Ln",
    "parcel_id": "423-05-00",
    "owner1": "HE, ZIZHAO",
    "owner2": "LIU, XIAOCHEN",
    "current_taxes": 14716.17,
    "new_taxes_no_override": 15351.91,
    "override_total_1": 15787.51,
    "override_increase_1": 435.6
  },
  {
    "#": "37 Hedge Rd (321-05-00)",
    "$": 2149700,
    "address": "37 Hedge Rd",
    "parcel_id": "321-05-00",
    "owner1": "KELLEY, WILLIAM S",
    "owner2": "",
    "current_taxes": 18377.99,
    "new_taxes_no_override": 19171.92,
    "override_total_1": 19715.91,
    "override_increase_1": 543.99
  },
  {
    "#": "38 Hedge Rd (322-17-00)",
    "$": 3945900,
    "address": "38 Hedge Rd",
    "parcel_id": "322-17-00",
    "owner1": "ALLYN TRS, MARK B & ALLISON E",
    "owner2": "",
    "current_taxes": 36771.08,
    "new_taxes_no_override": 38359.59,
    "override_total_1": 39448.01,
    "override_increase_1": 1088.42
  },
  {
    "#": "43 Hedge Rd (321-06-00)",
    "$": 3111200,
    "address": "43 Hedge Rd",
    "parcel_id": "321-06-00",
    "owner1": "LINCOLN, TR, NANCY C",
    "owner2": "",
    "current_taxes": 31858.69,
    "new_taxes_no_override": 33234.99,
    "override_total_1": 34178.0,
    "override_increase_1": 943.02
  },
  {
    "#": "52 Hedge Rd (322-16-01)",
    "$": 4488900,
    "address": "52 Hedge Rd",
    "parcel_id": "322-16-01",
    "owner1": "FAIR, STEPHEN & REBECCA",
    "owner2": "",
    "current_taxes": 42331.4,
    "new_taxes_no_override": 44160.12,
    "override_total_1": 45413.13,
    "override_increase_1": 1253.01
  },
  {
    "#": "57 Hedge Rd (321-07-00)",
    "$": 3015700,
    "address": "57 Hedge Rd",
    "parcel_id": "321-07-00",
    "owner1": "RADELJEVIC, ANA",
    "owner2": "MAYOTTE, TIMOTHY",
    "current_taxes": 27245.83,
    "new_taxes_no_override": 28422.85,
    "override_total_1": 29229.33,
    "override_increase_1": 806.48
  },
  {
    "#": "58 Hedge Rd (322-15-02)",
    "$": 2512700,
    "address": "58 Hedge Rd",
    "parcel_id": "322-15-02",
    "owner1": "GROSSMAN, JEFFREY C",
    "owner2": "MOSCHANDREAS, KATHERINE",
    "current_taxes": 22095.11,
    "new_taxes_no_override": 23049.62,
    "override_total_1": 23703.63,
    "override_increase_1": 654.02
  },
  {
    "#": "61 Hedge Rd (321-08-00)",
    "$": 2344500,
    "address": "61 Hedge Rd",
    "parcel_id": "321-08-00",
    "owner1": "BERMAN, KEN",
    "owner2": "PASCIUCCO, KATIE",
    "current_taxes": 20372.75,
    "new_taxes_no_override": 21252.85,
    "override_total_1": 21855.89,
    "override_increase_1": 603.03
  },
  {
    "#": "62 Hedge Rd (322-15-01)",
    "$": 151000,
    "address": "62 Hedge Rd",
    "parcel_id": "322-15-01",
    "owner1": "BURNS , ANDREA H & MATTHEW G",
    "owner2": "",
    "current_taxes": 1546.24,
    "new_taxes_no_override": 1613.04,
    "override_total_1": 1658.81,
    "override_increase_1": 45.77
  },
  {
    "#": "7 Henry St (302-06-00)",
    "$": 1279800,
    "address": "7 Henry St",
    "parcel_id": "302-06-00",
    "owner1": "HENRY HILL HOLDING LLC",
    "owner2": "",
    "current_taxes": 13105.15,
    "new_taxes_no_override": 13671.29,
    "override_total_1": 14059.2,
    "override_increase_1": 387.91
  },
  {
    "#": "8 Henry St (303-18-00)",
    "$": 1236300,
    "address": "8 Henry St",
    "parcel_id": "303-18-00",
    "owner1": "RAMONDO TRS, CHARLES G JR & MONIKA",
    "owner2": "",
    "current_taxes": 12659.71,
    "new_taxes_no_override": 13206.61,
    "override_total_1": 13581.34,
    "override_increase_1": 374.73
  },
  {
    "#": "11 Henry St (302-07-00)",
    "$": 1637400,
    "address": "11 Henry St",
    "parcel_id": "302-07-00",
    "owner1": "GOLDBERG TRS, MICHAEL S",
    "owner2": "GERWIN, CAROL S",
    "current_taxes": 13132.04,
    "new_taxes_no_override": 13699.34,
    "override_total_1": 14088.05,
    "override_increase_1": 388.71
  },
  {
    "#": "12 Henry St, Unit 1 (303-17-01)",
    "$": 898400,
    "address": "12 Henry St, Unit 1",
    "parcel_id": "303-17-01",
    "owner1": "KRANTZ TRS, BRIAN & JANE",
    "owner2": "",
    "current_taxes": 9199.62,
    "new_taxes_no_override": 9597.04,
    "override_total_1": 9869.35,
    "override_increase_1": 272.31
  },
  {
    "#": "12 Henry St, Unit 2 (303-17-02)",
    "$": 959600,
    "address": "12 Henry St, Unit 2",
    "parcel_id": "303-17-02",
    "owner1": "FUKESENKO, YURIY Y",
    "owner2": "YE, JESSICA",
    "current_taxes": 9826.3,
    "new_taxes_no_override": 10250.8,
    "override_total_1": 10541.65,
    "override_increase_1": 290.86
  },
  {
    "#": "12 Henry St, Unit 3 (303-17-03)",
    "$": 1152800,
    "address": "12 Henry St, Unit 3",
    "parcel_id": "303-17-03",
    "owner1": "AGRAWAL, MRIDUL",
    "owner2": "SCHAEFER, INGA MARIE",
    "current_taxes": 11804.67,
    "new_taxes_no_override": 12314.63,
    "override_total_1": 12664.05,
    "override_increase_1": 349.42
  },
  {
    "#": "16 Henry St, Unit 1 (303-16-01)",
    "$": 662500,
    "address": "16 Henry St, Unit 1",
    "parcel_id": "303-16-01",
    "owner1": "HULIN HOLDINGS LLC",
    "owner2": "",
    "current_taxes": 6784.0,
    "new_taxes_no_override": 7077.07,
    "override_total_1": 7277.88,
    "override_increase_1": 200.81
  },
  {
    "#": "16 Henry St, Unit 2 (303-16-02)",
    "$": 984700,
    "address": "16 Henry St, Unit 2",
    "parcel_id": "303-16-02",
    "owner1": "HULIN HOLDINGS LLC",
    "owner2": "",
    "current_taxes": 10083.33,
    "new_taxes_no_override": 10518.93,
    "override_total_1": 10817.4,
    "override_increase_1": 298.47
  },
  {
    "#": "17 Henry St (302-08-00)",
    "$": 1498800,
    "address": "17 Henry St",
    "parcel_id": "302-08-00",
    "owner1": "MURRAY, JACOB",
    "owner2": "AZZARA, JENNIFER B",
    "current_taxes": 11712.78,
    "new_taxes_no_override": 12218.77,
    "override_total_1": 12565.47,
    "override_increase_1": 346.7
  },
  {
    "#": "19 Henry St (302-09-10)",
    "$": 1046200,
    "address": "19 Henry St",
    "parcel_id": "302-09-10",
    "owner1": "BASAN, MARKUS",
    "owner2": "",
    "current_taxes": 7078.15,
    "new_taxes_no_override": 7383.93,
    "override_total_1": 7593.44,
    "override_increase_1": 209.51
  },
  {
    "#": "20 Henry St (303-14-15)",
    "$": 1486600,
    "address": "20 Henry St",
    "parcel_id": "303-14-15",
    "owner1": "WISHINSKY TRS, NEIL A & SUSAN C",
    "owner2": "",
    "current_taxes": 11587.85,
    "new_taxes_no_override": 12088.45,
    "override_total_1": 12431.45,
    "override_increase_1": 343.0
  },
  {
    "#": "17 High St, Unit 1 (314-12-02)",
    "$": 1002400,
    "address": "17 High St, Unit 1",
    "parcel_id": "314-12-02",
    "owner1": "LUOX REALTY BOSTON LLC",
    "owner2": "",
    "current_taxes": 10264.58,
    "new_taxes_no_override": 10708.01,
    "override_total_1": 11011.84,
    "override_increase_1": 303.83
  },
  {
    "#": "17 High St, Unit 2 (314-12-03)",
    "$": 1039400,
    "address": "17 High St, Unit 2",
    "parcel_id": "314-12-03",
    "owner1": "JIANG, NING",
    "owner2": "",
    "current_taxes": 10643.46,
    "new_taxes_no_override": 11103.26,
    "override_total_1": 11418.3,
    "override_increase_1": 315.05
  },
  {
    "#": "17 High St, Unit 3 (314-12-04)",
    "$": 1088500,
    "address": "17 High St, Unit 3",
    "parcel_id": "314-12-04",
    "owner1": "SUAZO, HECTOR & MARITZA",
    "owner2": "",
    "current_taxes": 7511.31,
    "new_taxes_no_override": 7835.8,
    "override_total_1": 8058.13,
    "override_increase_1": 222.33
  },
  {
    "#": "17 High St, Unit 4 (314-12-05)",
    "$": 1035900,
    "address": "17 High St, Unit 4",
    "parcel_id": "314-12-05",
    "owner1": "MACLAURIN, KENNETH & SEPTIMA",
    "owner2": "",
    "current_taxes": 6972.68,
    "new_taxes_no_override": 7273.9,
    "override_total_1": 7480.29,
    "override_increase_1": 206.39
  },
  {
    "#": "17 High St, Unit 5 (314-12-06)",
    "$": 1088500,
    "address": "17 High St, Unit 5",
    "parcel_id": "314-12-06",
    "owner1": "LEARN, CHRISTOPHER P",
    "owner2": "GOLDBERG, SARAH W",
    "current_taxes": 7511.31,
    "new_taxes_no_override": 7835.8,
    "override_total_1": 8058.13,
    "override_increase_1": 222.33
  },
  {
    "#": "17 High St, Unit Cs-1 (314-12-08)",
    "$": 775300,
    "address": "17 High St, Unit Cs-1",
    "parcel_id": "314-12-08",
    "owner1": "17 HIGH ST LLC",
    "owner2": "",
    "current_taxes": 13304.15,
    "new_taxes_no_override": 13878.89,
    "override_total_1": 14272.69,
    "override_increase_1": 393.8
  },
  {
    "#": "17 High St, Unit Cs-2 (314-12-07)",
    "$": 322300,
    "address": "17 High St, Unit Cs-2",
    "parcel_id": "314-12-07",
    "owner1": "EMILY OLIVEIRA REALTY LLC",
    "owner2": "",
    "current_taxes": 5530.67,
    "new_taxes_no_override": 5769.59,
    "override_total_1": 5933.3,
    "override_increase_1": 163.71
  },
  {
    "#": "21 High St, Unit 1 (314-12-09)",
    "$": 801800,
    "address": "21 High St, Unit 1",
    "parcel_id": "314-12-09",
    "owner1": "LAWSON, IAN ROBERT & SARAH STUPPY",
    "owner2": "",
    "current_taxes": 8210.43,
    "new_taxes_no_override": 8565.12,
    "override_total_1": 8808.15,
    "override_increase_1": 243.03
  },
  {
    "#": "21 High St, Unit 2 (314-12-10)",
    "$": 959000,
    "address": "21 High St, Unit 2",
    "parcel_id": "314-12-10",
    "owner1": "KLEIN, MARK",
    "owner2": "SNEEGAS, JANIECE J",
    "current_taxes": 6185.23,
    "new_taxes_no_override": 6452.43,
    "override_total_1": 6635.51,
    "override_increase_1": 183.08
  },
  {
    "#": "27 High St (314-13-00)",
    "$": 1755000,
    "address": "27 High St",
    "parcel_id": "314-13-00",
    "owner1": "LEE TRS, KAI WING",
    "owner2": "CHOU-LEE, CHAO N",
    "current_taxes": 17971.2,
    "new_taxes_no_override": 18747.56,
    "override_total_1": 19279.5,
    "override_increase_1": 531.95
  },
  {
    "#": "31 High St (314-14-00)",
    "$": 1713300,
    "address": "31 High St",
    "parcel_id": "314-14-00",
    "owner1": "BROOKLINE 31 HIGH STREET LLC",
    "owner2": "",
    "current_taxes": 17544.19,
    "new_taxes_no_override": 18302.1,
    "override_total_1": 18821.41,
    "override_increase_1": 519.31
  },
  {
    "#": "36 High St (292-13-00)",
    "$": 3552800,
    "address": "36 High St",
    "parcel_id": "292-13-00",
    "owner1": "BLOTNER, MARK",
    "owner2": "",
    "current_taxes": 36380.67,
    "new_taxes_no_override": 37952.31,
    "override_total_1": 39029.18,
    "override_increase_1": 1076.87
  },
  {
    "#": "44 High St (292-11-00)",
    "$": 2289000,
    "address": "44 High St",
    "parcel_id": "292-11-00",
    "owner1": "SIMON, ERIC",
    "owner2": "ELIA, CHRISTINE",
    "current_taxes": 23439.36,
    "new_taxes_no_override": 24451.94,
    "override_total_1": 25145.75,
    "override_increase_1": 693.81
  },
  {
    "#": "48 High St (292-10-00)",
    "$": 1439400,
    "address": "48 High St",
    "parcel_id": "292-10-00",
    "owner1": "BOXER, CHANTAL S & EDWARD",
    "owner2": "",
    "current_taxes": 11104.52,
    "new_taxes_no_override": 11584.24,
    "override_total_1": 11912.93,
    "override_increase_1": 328.69
  },
  {
    "#": "52 High St (292-09-01)",
    "$": 2369900,
    "address": "52 High St",
    "parcel_id": "292-09-01",
    "owner1": "NAUMOV, GEORGE",
    "owner2": "PIRALKOVA, YANA",
    "current_taxes": 20632.84,
    "new_taxes_no_override": 21524.18,
    "override_total_1": 22134.91,
    "override_increase_1": 610.73
  },
  {
    "#": "59 High St (315-02-04)",
    "$": 5871200,
    "address": "59 High St",
    "parcel_id": "315-02-04",
    "owner1": "ROSS, NINA",
    "owner2": "BERMINGHAM, NESSAN",
    "current_taxes": 60121.09,
    "new_taxes_no_override": 62718.32,
    "override_total_1": 64497.91,
    "override_increase_1": 1779.58
  },
  {
    "#": "60 High St (292-09-00)",
    "$": 2539100,
    "address": "60 High St",
    "parcel_id": "292-09-00",
    "owner1": "JAKER, CHRISTOPH",
    "owner2": "JAEKER, JILLIAN A BERRY",
    "current_taxes": 22365.45,
    "new_taxes_no_override": 23331.64,
    "override_total_1": 23993.65,
    "override_increase_1": 662.02
  },
  {
    "#": "68 High St (295-01-00)",
    "$": 3127800,
    "address": "68 High St",
    "parcel_id": "295-01-00",
    "owner1": "MICHIE, THOMAS S",
    "owner2": "",
    "current_taxes": 28393.74,
    "new_taxes_no_override": 29620.35,
    "override_total_1": 30460.8,
    "override_increase_1": 840.45
  },
  {
    "#": "76 High St (295-18-00)",
    "$": 3642200,
    "address": "76 High St",
    "parcel_id": "295-18-00",
    "owner1": "POST, TR, DIANA E",
    "owner2": "",
    "current_taxes": 33661.19,
    "new_taxes_no_override": 35115.35,
    "override_total_1": 36111.72,
    "override_increase_1": 996.37
  },
  {
    "#": "82 High St (295-17-00)",
    "$": 3591200,
    "address": "82 High St",
    "parcel_id": "295-17-00",
    "owner1": "CAMERON TR, FRASER",
    "owner2": "",
    "current_taxes": 33138.95,
    "new_taxes_no_override": 34570.55,
    "override_total_1": 35551.47,
    "override_increase_1": 980.91
  },
  {
    "#": "84 High St (295-16-00)",
    "$": 3184000,
    "address": "84 High St",
    "parcel_id": "295-16-00",
    "owner1": "BROWN, ELEANOR",
    "owner2": "",
    "current_taxes": 28969.23,
    "new_taxes_no_override": 30220.7,
    "override_total_1": 31078.19,
    "override_increase_1": 857.49
  },
  {
    "#": "92 High St (295-15-00)",
    "$": 4566400,
    "address": "92 High St",
    "parcel_id": "295-15-00",
    "owner1": "LOCKE, REBECCA J",
    "owner2": "SILLMAN, ERIC H",
    "current_taxes": 43125.0,
    "new_taxes_no_override": 44988.0,
    "override_total_1": 46264.5,
    "override_increase_1": 1276.5
  },
  {
    "#": "99 High St (308-50-00)",
    "$": 5374200,
    "address": "99 High St",
    "parcel_id": "308-50-00",
    "owner1": "REINHART, VINCENT R & CARMEN M",
    "owner2": "",
    "current_taxes": 51396.87,
    "new_taxes_no_override": 53617.21,
    "override_total_1": 55138.56,
    "override_increase_1": 1521.35
  },
  {
    "#": "100 High St (295-14-00)",
    "$": 3251800,
    "address": "100 High St",
    "parcel_id": "295-14-00",
    "owner1": "PETEET, JOHN R & JEAN O",
    "owner2": "",
    "current_taxes": 29663.5,
    "new_taxes_no_override": 30944.96,
    "override_total_1": 31823.0,
    "override_increase_1": 878.04
  },
  {
    "#": "107 High St, Unit 107 (308-51-01)",
    "$": 1713300,
    "address": "107 High St, Unit 107",
    "parcel_id": "308-51-01",
    "owner1": "MACK, JENNIFER",
    "owner2": "",
    "current_taxes": 13909.26,
    "new_taxes_no_override": 14510.14,
    "override_total_1": 14921.85,
    "override_increase_1": 411.71
  },
  {
    "#": "111 High St, Unit 111 (308-51-02)",
    "$": 1766500,
    "address": "111 High St, Unit 111",
    "parcel_id": "308-51-02",
    "owner1": "JOHNSON, PHILIP L",
    "owner2": "NORDONE, THERESA A",
    "current_taxes": 14454.03,
    "new_taxes_no_override": 15078.44,
    "override_total_1": 15506.28,
    "override_increase_1": 427.84
  },
  {
    "#": "112 High St (299-44-00)",
    "$": 6377300,
    "address": "112 High St",
    "parcel_id": "299-44-00",
    "owner1": "CLOETINGH, JEFFREY SCOTT",
    "owner2": "BUNDY, LAUREN TESS",
    "current_taxes": 61668.62,
    "new_taxes_no_override": 64332.7,
    "override_total_1": 66158.1,
    "override_increase_1": 1825.39
  },
  {
    "#": "123 High St (308-52-00)",
    "$": 3764900,
    "address": "123 High St",
    "parcel_id": "308-52-00",
    "owner1": "WILEN, JEFFREY D",
    "owner2": "HERSHEY, SARAH E",
    "current_taxes": 34917.64,
    "new_taxes_no_override": 36426.08,
    "override_total_1": 37459.64,
    "override_increase_1": 1033.56
  },
  {
    "#": "127 High St (308-53-00)",
    "$": 3403900,
    "address": "127 High St",
    "parcel_id": "308-53-00",
    "owner1": "RUTH, JASON",
    "owner2": "KEENAN, TANYA",
    "current_taxes": 31221.0,
    "new_taxes_no_override": 32569.75,
    "override_total_1": 33493.89,
    "override_increase_1": 924.14
  },
  {
    "#": "131 High St (308-54-00)",
    "$": 2626000,
    "address": "131 High St",
    "parcel_id": "308-54-00",
    "owner1": "RICHARD, CANDACE BROOKE & DAVID GERZOF",
    "owner2": "",
    "current_taxes": 23255.31,
    "new_taxes_no_override": 24259.94,
    "override_total_1": 24948.3,
    "override_increase_1": 688.36
  },
  {
    "#": "132 High St (299-30-00)",
    "$": 2839600,
    "address": "132 High St",
    "parcel_id": "299-30-00",
    "owner1": "VAN DE VELDE, THOMAS & BLANDINE",
    "owner2": "",
    "current_taxes": 29077.5,
    "new_taxes_no_override": 30333.65,
    "override_total_1": 31194.34,
    "override_increase_1": 860.69
  },
  {
    "#": "135 High St (308-54-01)",
    "$": 2833500,
    "address": "135 High St",
    "parcel_id": "308-54-01",
    "owner1": "SCHOEN, FREDERICK J",
    "owner2": "WARNER, ANGELINE E",
    "current_taxes": 25380.11,
    "new_taxes_no_override": 26476.53,
    "override_total_1": 27227.78,
    "override_increase_1": 751.25
  },
  {
    "#": "138 High St (299-28-29)",
    "$": 3872900,
    "address": "138 High St",
    "parcel_id": "299-28-29",
    "owner1": "ELS TR, MICHAEL SAMUEL DAVID",
    "owner2": "BRASTIANOS TR, KALIOPI",
    "current_taxes": 36023.56,
    "new_taxes_no_override": 37579.78,
    "override_total_1": 38646.08,
    "override_increase_1": 1066.3
  },
  {
    "#": "146 High St (299-27-00)",
    "$": 2047400,
    "address": "146 High St",
    "parcel_id": "299-27-00",
    "owner1": "HAMMOND, TR, LORRAINE LEE",
    "owner2": "",
    "current_taxes": 17330.44,
    "new_taxes_no_override": 18079.12,
    "override_total_1": 18592.1,
    "override_increase_1": 512.98
  },
  {
    "#": "153 High St (308-56-00)",
    "$": 2017700,
    "address": "153 High St",
    "parcel_id": "308-56-00",
    "owner1": "MAI, LILY QING HUA",
    "owner2": "",
    "current_taxes": 17026.31,
    "new_taxes_no_override": 17761.85,
    "override_total_1": 18265.83,
    "override_increase_1": 503.98
  },
  {
    "#": "157 High St (308-57-00)",
    "$": 1896700,
    "address": "157 High St",
    "parcel_id": "308-57-00",
    "owner1": "HAN TRS, MING",
    "owner2": "ZHANG, YUNYI",
    "current_taxes": 19422.21,
    "new_taxes_no_override": 20261.25,
    "override_total_1": 20836.15,
    "override_increase_1": 574.9
  },
  {
    "#": "161 High St (308-58-00)",
    "$": 1573900,
    "address": "161 High St",
    "parcel_id": "308-58-00",
    "owner1": "GUO, WEN YAN",
    "owner2": "XIAO, TIAN",
    "current_taxes": 12481.8,
    "new_taxes_no_override": 13021.01,
    "override_total_1": 13390.48,
    "override_increase_1": 369.46
  },
  {
    "#": "165 High St, Unit 1 (308-64-01)",
    "$": 1144000,
    "address": "165 High St, Unit 1",
    "parcel_id": "308-64-01",
    "owner1": "KMAA LLC",
    "owner2": "",
    "current_taxes": 11714.56,
    "new_taxes_no_override": 12220.63,
    "override_total_1": 12567.38,
    "override_increase_1": 346.75
  },
  {
    "#": "165 High St, Unit 2 (308-64-02)",
    "$": 1367100,
    "address": "165 High St, Unit 2",
    "parcel_id": "308-64-02",
    "owner1": "LIBERATORE, SAURO",
    "owner2": "PIIZZI, GRAZIA",
    "current_taxes": 10364.17,
    "new_taxes_no_override": 10811.9,
    "override_total_1": 11118.68,
    "override_increase_1": 306.78
  },
  {
    "#": "171 High St (308-65-00)",
    "$": 1348400,
    "address": "171 High St",
    "parcel_id": "308-65-00",
    "owner1": "BENTSON, BRETT",
    "owner2": "CASE, EMILY",
    "current_taxes": 10172.68,
    "new_taxes_no_override": 10612.14,
    "override_total_1": 10913.25,
    "override_increase_1": 301.11
  },
  {
    "#": "173 High St (308-66-00)",
    "$": 1109700,
    "address": "173 High St",
    "parcel_id": "308-66-00",
    "owner1": "GROSSESTREUR, ANNE VICTORIA",
    "owner2": "CLARK, TIMOTHY SCOTT",
    "current_taxes": 11363.33,
    "new_taxes_no_override": 11854.23,
    "override_total_1": 12190.58,
    "override_increase_1": 336.35
  },
  {
    "#": "175 High St (308-67-00)",
    "$": 1608100,
    "address": "175 High St",
    "parcel_id": "308-67-00",
    "owner1": "OLD HIGH STREET LLC",
    "owner2": "",
    "current_taxes": 16466.94,
    "new_taxes_no_override": 17178.31,
    "override_total_1": 17665.73,
    "override_increase_1": 487.42
  },
  {
    "#": "179 High St, Unit 1 (308-73-03)",
    "$": 685300,
    "address": "179 High St, Unit 1",
    "parcel_id": "308-73-03",
    "owner1": "ZHAO, GUOLI",
    "owner2": "WANG, WEIHUA",
    "current_taxes": 3382.54,
    "new_taxes_no_override": 3528.67,
    "override_total_1": 3628.79,
    "override_increase_1": 100.12
  },
  {
    "#": "179 High St, Unit 2 (308-73-01)",
    "$": 691100,
    "address": "179 High St, Unit 2",
    "parcel_id": "308-73-01",
    "owner1": "HALIM, NAFISA",
    "owner2": "",
    "current_taxes": 7076.86,
    "new_taxes_no_override": 7382.58,
    "override_total_1": 7592.06,
    "override_increase_1": 209.48
  },
  {
    "#": "179 High St, Unit 3 (308-73-02)",
    "$": 702900,
    "address": "179 High St, Unit 3",
    "parcel_id": "308-73-02",
    "owner1": "OLOUGHLIN, BRIAN J",
    "owner2": "",
    "current_taxes": 3562.76,
    "new_taxes_no_override": 3716.67,
    "override_total_1": 3822.13,
    "override_increase_1": 105.46
  },
  {
    "#": "181 High St, Unit 1 (308-74-01)",
    "$": 672200,
    "address": "181 High St, Unit 1",
    "parcel_id": "308-74-01",
    "owner1": "OZYURT, DERYA B & PEMBE H OZLINLER",
    "owner2": "",
    "current_taxes": 6883.33,
    "new_taxes_no_override": 7180.69,
    "override_total_1": 7384.44,
    "override_increase_1": 203.75
  },
  {
    "#": "181 High St, Unit 2 (308-74-02)",
    "$": 715100,
    "address": "181 High St, Unit 2",
    "parcel_id": "308-74-02",
    "owner1": "OZYURT, PEMBE H O & DERYA B",
    "owner2": "",
    "current_taxes": 7322.62,
    "new_taxes_no_override": 7638.96,
    "override_total_1": 7855.71,
    "override_increase_1": 216.75
  },
  {
    "#": "183 High St (308-75-00)",
    "$": 1827400,
    "address": "183 High St",
    "parcel_id": "308-75-00",
    "owner1": "TAO, LIANG FENG",
    "owner2": "WANG, MAO MAO",
    "current_taxes": 18712.58,
    "new_taxes_no_override": 19520.96,
    "override_total_1": 20074.86,
    "override_increase_1": 553.89
  },
  {
    "#": "185 High St, Unit 101 G1 G2 P18 (308-76-07)",
    "$": 1081900,
    "address": "185 High St, Unit 101 G1 G2 P18",
    "parcel_id": "308-76-07",
    "owner1": "SAWICKI TRS, JANUSZ I & ELZBIETA S",
    "owner2": "",
    "current_taxes": 11078.66,
    "new_taxes_no_override": 11557.26,
    "override_total_1": 11885.19,
    "override_increase_1": 327.93
  },
  {
    "#": "185 High St, Unit 102 & G8-9 (308-76-08)",
    "$": 1060600,
    "address": "185 High St, Unit 102 & G8-9",
    "parcel_id": "308-76-08",
    "owner1": "QIAN, RUISEN",
    "owner2": "",
    "current_taxes": 10860.54,
    "new_taxes_no_override": 11329.72,
    "override_total_1": 11651.19,
    "override_increase_1": 321.47
  },
  {
    "#": "185 High St, Unit 103 & P21-G6 (308-76-01)",
    "$": 983100,
    "address": "185 High St, Unit 103 & P21-G6",
    "parcel_id": "308-76-01",
    "owner1": "XU, JIAQI",
    "owner2": "YANG, YIXUAN",
    "current_taxes": 10066.94,
    "new_taxes_no_override": 10501.83,
    "override_total_1": 10799.81,
    "override_increase_1": 297.98
  },
  {
    "#": "185 High St, Unit 104 22&G13 (308-76-02)",
    "$": 979200,
    "address": "185 High St, Unit 104 22&G13",
    "parcel_id": "308-76-02",
    "owner1": "SWARTZ, STEPHANIE",
    "owner2": "",
    "current_taxes": 6392.07,
    "new_taxes_no_override": 6668.21,
    "override_total_1": 6857.41,
    "override_increase_1": 189.21
  },
  {
    "#": "185 High St, Unit 201 G7-G14 (308-76-09)",
    "$": 1072200,
    "address": "185 High St, Unit 201 G7-G14",
    "parcel_id": "308-76-09",
    "owner1": "JIANG, BIZHEN",
    "owner2": "",
    "current_taxes": 7344.39,
    "new_taxes_no_override": 7661.67,
    "override_total_1": 7879.06,
    "override_increase_1": 217.39
  },
  {
    "#": "185 High St, Unit 202 & G4 (308-76-10)",
    "$": 928900,
    "address": "185 High St, Unit 202 & G4",
    "parcel_id": "308-76-10",
    "owner1": "WANG, KUN",
    "owner2": "LI, ZHUONING",
    "current_taxes": 5877.0,
    "new_taxes_no_override": 6130.89,
    "override_total_1": 6304.85,
    "override_increase_1": 173.96
  },
  {
    "#": "185 High St, Unit 203 20&G15 (308-76-03)",
    "$": 1002500,
    "address": "185 High St, Unit 203 20&G15",
    "parcel_id": "308-76-03",
    "owner1": "OLSON, KAREN L",
    "owner2": "",
    "current_taxes": 6630.67,
    "new_taxes_no_override": 6917.11,
    "override_total_1": 7113.38,
    "override_increase_1": 196.27
  },
  {
    "#": "185 High St, Unit 204 P19-23 (308-76-04)",
    "$": 921100,
    "address": "185 High St, Unit 204 P19-23",
    "parcel_id": "308-76-04",
    "owner1": "HALFORD, BRITTNE",
    "owner2": "SIMON, KEVIN",
    "current_taxes": 9432.06,
    "new_taxes_no_override": 9839.52,
    "override_total_1": 10118.71,
    "override_increase_1": 279.19
  },
  {
    "#": "185 High St, Unit 301 G3-P24 (308-76-11)",
    "$": 1014100,
    "address": "185 High St, Unit 301 G3-P24",
    "parcel_id": "308-76-11",
    "owner1": "ZUO TR, HAOBO",
    "owner2": "",
    "current_taxes": 10384.38,
    "new_taxes_no_override": 10832.99,
    "override_total_1": 11140.36,
    "override_increase_1": 307.38
  },
  {
    "#": "185 High St, Unit 302 G10-11 (308-76-12)",
    "$": 1060700,
    "address": "185 High St, Unit 302 G10-11",
    "parcel_id": "308-76-12",
    "owner1": "MA, XUEHAO",
    "owner2": "",
    "current_taxes": 7226.63,
    "new_taxes_no_override": 7538.82,
    "override_total_1": 7752.73,
    "override_increase_1": 213.91
  },
  {
    "#": "185 High St, Unit 303 G16-17 (308-76-05)",
    "$": 1060600,
    "address": "185 High St, Unit 303 G16-17",
    "parcel_id": "308-76-05",
    "owner1": "LI, MEI",
    "owner2": "",
    "current_taxes": 7225.61,
    "new_taxes_no_override": 7537.76,
    "override_total_1": 7751.63,
    "override_increase_1": 213.88
  },
  {
    "#": "185 High St, Unit 304 G12-G5 (308-76-06)",
    "$": 1072200,
    "address": "185 High St, Unit 304 G12-G5",
    "parcel_id": "308-76-06",
    "owner1": "CHEN, WEI-YU",
    "owner2": "",
    "current_taxes": 10979.33,
    "new_taxes_no_override": 11453.64,
    "override_total_1": 11778.63,
    "override_increase_1": 324.99
  },
  {
    "#": "201 High St (308-80-00)",
    "$": 2055200,
    "address": "201 High St",
    "parcel_id": "308-80-00",
    "owner1": "LU, FANG",
    "owner2": "HUNG, NICOLE PEIYU",
    "current_taxes": 21045.25,
    "new_taxes_no_override": 21954.4,
    "override_total_1": 22577.34,
    "override_increase_1": 622.94
  },
  {
    "#": "203 High St (308-81-00)",
    "$": 1770500,
    "address": "203 High St",
    "parcel_id": "308-81-00",
    "owner1": "MANNAR, SATEESH KUMAR",
    "owner2": "SATEESH, SHASHIREKHA",
    "current_taxes": 18129.92,
    "new_taxes_no_override": 18913.13,
    "override_total_1": 19449.78,
    "override_increase_1": 536.65
  },
  {
    "#": "209 High St (308-81-01)",
    "$": 1212100,
    "address": "209 High St",
    "parcel_id": "308-81-01",
    "owner1": "BROOKLINE 209 LLC",
    "owner2": "",
    "current_taxes": 12411.9,
    "new_taxes_no_override": 12948.09,
    "override_total_1": 13315.49,
    "override_increase_1": 367.39
  },
  {
    "#": "225 High St (302-15-00)",
    "$": 1579600,
    "address": "225 High St",
    "parcel_id": "302-15-00",
    "owner1": "SCHWARTZ, JOAN",
    "owner2": "",
    "current_taxes": 12540.17,
    "new_taxes_no_override": 13081.91,
    "override_total_1": 13453.09,
    "override_increase_1": 371.19
  },
  {
    "#": "229 High St (302-16-00)",
    "$": 1768100,
    "address": "229 High St",
    "parcel_id": "302-16-00",
    "owner1": "SHEN TRS, JOHN",
    "owner2": "WU, MIN",
    "current_taxes": 18105.34,
    "new_taxes_no_override": 18887.49,
    "override_total_1": 19423.41,
    "override_increase_1": 535.92
  },
  {
    "#": "231 High St (302-01-00)",
    "$": 1831400,
    "address": "231 High St",
    "parcel_id": "302-01-00",
    "owner1": "ADAMIDIS, PAVLOS & EFTHIMIA",
    "owner2": "",
    "current_taxes": 18753.54,
    "new_taxes_no_override": 19563.69,
    "override_total_1": 20118.8,
    "override_increase_1": 555.1
  },
  {
    "#": "3 High St Pl (308-68-00)",
    "$": 1984300,
    "address": "3 High St Pl",
    "parcel_id": "308-68-00",
    "owner1": "HIGH STREET PLACE LLC",
    "owner2": "",
    "current_taxes": 20319.23,
    "new_taxes_no_override": 21197.02,
    "override_total_1": 21798.47,
    "override_increase_1": 601.45
  },
  {
    "#": "5 High St Pl (308-69-00)",
    "$": 1975500,
    "address": "5 High St Pl",
    "parcel_id": "308-69-00",
    "owner1": "HIGH STREET PLACE LLC",
    "owner2": "",
    "current_taxes": 20229.12,
    "new_taxes_no_override": 21103.02,
    "override_total_1": 21701.8,
    "override_increase_1": 598.78
  },
  {
    "#": "7 High St Pl (308-70-00)",
    "$": 1634900,
    "address": "7 High St Pl",
    "parcel_id": "308-70-00",
    "owner1": "LIN TRS, POKUNG",
    "owner2": "SU, LIHE",
    "current_taxes": 16741.38,
    "new_taxes_no_override": 17464.61,
    "override_total_1": 17960.15,
    "override_increase_1": 495.54
  },
  {
    "#": "9 High St Pl, Unit 1 (308-71-01)",
    "$": 616200,
    "address": "9 High St Pl, Unit 1",
    "parcel_id": "308-71-01",
    "owner1": "LIU, MINGXING",
    "owner2": "PENG, JINGYU",
    "current_taxes": 2674.95,
    "new_taxes_no_override": 2790.51,
    "override_total_1": 2869.69,
    "override_increase_1": 79.18
  },
  {
    "#": "9 High St Pl, Unit 2 & P-2 (308-71-02)",
    "$": 583000,
    "address": "9 High St Pl, Unit 2 & P-2",
    "parcel_id": "308-71-02",
    "owner1": "JONES, RYAN S",
    "owner2": "",
    "current_taxes": 5969.92,
    "new_taxes_no_override": 6227.82,
    "override_total_1": 6404.53,
    "override_increase_1": 176.71
  },
  {
    "#": "9 High St Pl, Unit 3 (308-71-03)",
    "$": 595300,
    "address": "9 High St Pl, Unit 3",
    "parcel_id": "308-71-03",
    "owner1": "BIRTWELL, JONATHAN",
    "owner2": "",
    "current_taxes": 6095.87,
    "new_taxes_no_override": 6359.21,
    "override_total_1": 6539.65,
    "override_increase_1": 180.44
  },
  {
    "#": "11 High St Pl (308-72-00)",
    "$": 122800,
    "address": "11 High St Pl",
    "parcel_id": "308-72-00",
    "owner1": "LUSK TR, ANNE C",
    "owner2": "",
    "current_taxes": 1257.47,
    "new_taxes_no_override": 1311.79,
    "override_total_1": 1349.01,
    "override_increase_1": 37.22
  },
  {
    "#": "24 Highland Rd (300-01-00)",
    "$": 9337700,
    "address": "24 Highland Rd",
    "parcel_id": "300-01-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O HARRY DOWNES FIELD",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "29 Highland Rd (299-05-00)",
    "$": 3863800,
    "address": "29 Highland Rd",
    "parcel_id": "299-05-00",
    "owner1": "HIGHLAND STREET DEVELOPMENT LLC",
    "owner2": "",
    "current_taxes": 39565.31,
    "new_taxes_no_override": 41274.53,
    "override_total_1": 42445.66,
    "override_increase_1": 1171.13
  },
  {
    "#": "35 Highland Rd (299-05-01)",
    "$": 1625900,
    "address": "35 Highland Rd",
    "parcel_id": "299-05-01",
    "owner1": "QIAN, RONGFANG",
    "owner2": "WANG, YING",
    "current_taxes": 16649.22,
    "new_taxes_no_override": 17368.47,
    "override_total_1": 17861.28,
    "override_increase_1": 492.82
  },
  {
    "#": "41 Highland Rd (299-06-00)",
    "$": 1642600,
    "address": "41 Highland Rd",
    "parcel_id": "299-06-00",
    "owner1": "PILICHOWSKA, MONIKA",
    "owner2": "NAKAMURA, FUMIHIKO",
    "current_taxes": 16820.22,
    "new_taxes_no_override": 17546.85,
    "override_total_1": 18044.73,
    "override_increase_1": 497.88
  },
  {
    "#": "45 Highland Rd, Unit 45 (299-06-02)",
    "$": 716100,
    "address": "45 Highland Rd, Unit 45",
    "parcel_id": "299-06-02",
    "owner1": "FONTES, EDUARDO BODNARIUC",
    "owner2": "DE PACE, FERNANDA",
    "current_taxes": 7332.86,
    "new_taxes_no_override": 7649.64,
    "override_total_1": 7866.69,
    "override_increase_1": 217.05
  },
  {
    "#": "45 Highland Rd, Unit 47 (299-06-03)",
    "$": 734100,
    "address": "45 Highland Rd, Unit 47",
    "parcel_id": "299-06-03",
    "owner1": "GERRY, JANE",
    "owner2": "",
    "current_taxes": 3882.25,
    "new_taxes_no_override": 4049.96,
    "override_total_1": 4164.88,
    "override_increase_1": 114.91
  },
  {
    "#": "49 Highland Rd, Unit 49 (299-07-02)",
    "$": 840600,
    "address": "49 Highland Rd, Unit 49",
    "parcel_id": "299-07-02",
    "owner1": "KERR, STEPHEN & GWENDOLYN",
    "owner2": "",
    "current_taxes": 4972.81,
    "new_taxes_no_override": 5187.64,
    "override_total_1": 5334.83,
    "override_increase_1": 147.2
  },
  {
    "#": "51 Highland Rd, Unit 51 (299-07-03)",
    "$": 1098300,
    "address": "51 Highland Rd, Unit 51",
    "parcel_id": "299-07-03",
    "owner1": "JESKA, STEVEN & YACHIYO",
    "owner2": "",
    "current_taxes": 7611.66,
    "new_taxes_no_override": 7940.48,
    "override_total_1": 8165.79,
    "override_increase_1": 225.31
  },
  {
    "#": "53 Highland Rd (299-07-01)",
    "$": 1770200,
    "address": "53 Highland Rd",
    "parcel_id": "299-07-01",
    "owner1": "COLEMAN, KEITH A & JANICE H",
    "owner2": "",
    "current_taxes": 14491.91,
    "new_taxes_no_override": 15117.96,
    "override_total_1": 15546.92,
    "override_increase_1": 428.96
  },
  {
    "#": "57 Highland Rd (299-08-00)",
    "$": 2921400,
    "address": "57 Highland Rd",
    "parcel_id": "299-08-00",
    "owner1": "57 HIGHLAND RD LLC",
    "owner2": "C/O RIOS ENTERPRISES X1 LLC",
    "current_taxes": 29915.14,
    "new_taxes_no_override": 31207.47,
    "override_total_1": 32092.96,
    "override_increase_1": 885.49
  },
  {
    "#": "61 Highland Rd, Unit A (299-09-00)",
    "$": 1654400,
    "address": "61 Highland Rd, Unit A",
    "parcel_id": "299-09-00",
    "owner1": "KWAN, TERRY",
    "owner2": "",
    "current_taxes": 13306.12,
    "new_taxes_no_override": 13880.94,
    "override_total_1": 14274.81,
    "override_increase_1": 393.86
  },
  {
    "#": "63 Highland Rd (299-10-00)",
    "$": 1685300,
    "address": "63 Highland Rd",
    "parcel_id": "299-10-00",
    "owner1": "COHEN, ALAN L",
    "owner2": "SHEPLEY, JULIA R",
    "current_taxes": 13622.54,
    "new_taxes_no_override": 14211.03,
    "override_total_1": 14614.26,
    "override_increase_1": 403.23
  },
  {
    "#": "67 Highland Rd (299-11-00)",
    "$": 1604600,
    "address": "67 Highland Rd",
    "parcel_id": "299-11-00",
    "owner1": "WUCHERPFENNIG, KAI & ANNE",
    "owner2": "",
    "current_taxes": 12796.17,
    "new_taxes_no_override": 13348.96,
    "override_total_1": 13727.73,
    "override_increase_1": 378.77
  },
  {
    "#": "69 Highland Rd (299-12-00)",
    "$": 1599600,
    "address": "69 Highland Rd",
    "parcel_id": "299-12-00",
    "owner1": "ONEILL, STEPHEN F & SARAH S",
    "owner2": "",
    "current_taxes": 12744.97,
    "new_taxes_no_override": 13295.55,
    "override_total_1": 13672.8,
    "override_increase_1": 377.25
  },
  {
    "#": "71 Highland Rd (299-13-00)",
    "$": 1143700,
    "address": "71 Highland Rd",
    "parcel_id": "299-13-00",
    "owner1": "SMITH, MARCIA",
    "owner2": "MORRIS, PAMELA",
    "current_taxes": 11711.49,
    "new_taxes_no_override": 12217.43,
    "override_total_1": 12564.09,
    "override_increase_1": 346.66
  },
  {
    "#": "73 Highland Rd (299-14-00)",
    "$": 1136000,
    "address": "73 Highland Rd",
    "parcel_id": "299-14-00",
    "owner1": "MORRIS, PAMELA",
    "owner2": "SMITH, MARCIA",
    "current_taxes": 11632.64,
    "new_taxes_no_override": 12135.17,
    "override_total_1": 12479.5,
    "override_increase_1": 344.33
  },
  {
    "#": "75 Highland Rd (299-15-00)",
    "$": 1334100,
    "address": "75 Highland Rd",
    "parcel_id": "299-15-00",
    "owner1": "KIGER, WILLIAM S III",
    "owner2": "",
    "current_taxes": 10026.25,
    "new_taxes_no_override": 10459.38,
    "override_total_1": 10756.16,
    "override_increase_1": 296.78
  },
  {
    "#": "77 Highland Rd (299-16-00)",
    "$": 1446500,
    "address": "77 Highland Rd",
    "parcel_id": "299-16-00",
    "owner1": "CROSS TRS, EMILY R",
    "owner2": "ALLEN, MATTHEW B",
    "current_taxes": 11177.23,
    "new_taxes_no_override": 11660.09,
    "override_total_1": 11990.93,
    "override_increase_1": 330.85
  },
  {
    "#": "81 Highland Rd (299-17-00)",
    "$": 1937300,
    "address": "81 Highland Rd",
    "parcel_id": "299-17-00",
    "owner1": "ZASLOW, FRANCINE",
    "owner2": "",
    "current_taxes": 16203.02,
    "new_taxes_no_override": 16902.99,
    "override_total_1": 17382.6,
    "override_increase_1": 479.61
  },
  {
    "#": "82 Highland Rd, Unit 1 (301-03-01)",
    "$": 882700,
    "address": "82 Highland Rd, Unit 1",
    "parcel_id": "301-03-01",
    "owner1": "DUBOIS TR, JENNIFER ZOE",
    "owner2": "",
    "current_taxes": 9038.85,
    "new_taxes_no_override": 9429.33,
    "override_total_1": 9696.88,
    "override_increase_1": 267.55
  },
  {
    "#": "82 Highland Rd, Unit 2 (301-03-02)",
    "$": 898900,
    "address": "82 Highland Rd, Unit 2",
    "parcel_id": "301-03-02",
    "owner1": "GUNNER, NATHAN",
    "owner2": "SIMPSON II, ROBERT L",
    "current_taxes": 5569.8,
    "new_taxes_no_override": 5810.42,
    "override_total_1": 5975.28,
    "override_increase_1": 164.87
  },
  {
    "#": "82 Highland Rd, Unit 3 (301-03-03)",
    "$": 950300,
    "address": "82 Highland Rd, Unit 3",
    "parcel_id": "301-03-03",
    "owner1": "RODRIGUEZ, WILLIAM RICHARD",
    "owner2": "LUCKETT, REBECCA LUCY",
    "current_taxes": 9731.07,
    "new_taxes_no_override": 10151.45,
    "override_total_1": 10439.49,
    "override_increase_1": 288.04
  },
  {
    "#": "82 Highland Rd, Unit Garage (301-03-04)",
    "$": 181500,
    "address": "82 Highland Rd, Unit Garage",
    "parcel_id": "301-03-04",
    "owner1": "82 HIGHLAND CONDO TRUST",
    "owner2": "C/O NATHAN GUNNER",
    "current_taxes": 1858.56,
    "new_taxes_no_override": 1938.85,
    "override_total_1": 1993.86,
    "override_increase_1": 55.01
  },
  {
    "#": "83 Highland Rd (299-14-01)",
    "$": 117000,
    "address": "83 Highland Rd",
    "parcel_id": "299-14-01",
    "owner1": "MILLER ET AL, LINDA",
    "owner2": "",
    "current_taxes": 1198.08,
    "new_taxes_no_override": 1249.84,
    "override_total_1": 1285.3,
    "override_increase_1": 35.46
  },
  {
    "#": "85 Highland Rd (299-18-00)",
    "$": 1493900,
    "address": "85 Highland Rd",
    "parcel_id": "299-18-00",
    "owner1": "MESSING, JOANNA R",
    "owner2": "NICHOLAS, DOMINIC S",
    "current_taxes": 11662.6,
    "new_taxes_no_override": 12166.42,
    "override_total_1": 12511.64,
    "override_increase_1": 345.21
  },
  {
    "#": "86 Highland Rd (301-02-00)",
    "$": 1913300,
    "address": "86 Highland Rd",
    "parcel_id": "301-02-00",
    "owner1": "MCLAREN TR, BARBARA",
    "owner2": "",
    "current_taxes": 19592.19,
    "new_taxes_no_override": 20438.57,
    "override_total_1": 21018.5,
    "override_increase_1": 579.93
  },
  {
    "#": "89 Highland Rd (299-20-21)",
    "$": 1612100,
    "address": "89 Highland Rd",
    "parcel_id": "299-20-21",
    "owner1": "MILLER, LINDA E",
    "owner2": "",
    "current_taxes": 12872.97,
    "new_taxes_no_override": 13429.08,
    "override_total_1": 13810.12,
    "override_increase_1": 381.04
  },
  {
    "#": "90 Highland Rd (301-01-00)",
    "$": 1880600,
    "address": "90 Highland Rd",
    "parcel_id": "301-01-00",
    "owner1": "MCLAREN TR, BARBARA",
    "owner2": "",
    "current_taxes": 19257.34,
    "new_taxes_no_override": 20089.26,
    "override_total_1": 20659.27,
    "override_increase_1": 570.02
  },
  {
    "#": "91 Highland Rd (299-22-00)",
    "$": 1138500,
    "address": "91 Highland Rd",
    "parcel_id": "299-22-00",
    "owner1": "RILEY, ROBERT W & MARILYN E",
    "owner2": "",
    "current_taxes": 8023.31,
    "new_taxes_no_override": 8369.92,
    "override_total_1": 8607.41,
    "override_increase_1": 237.49
  },
  {
    "#": "93 Highland Rd (299-23-00)",
    "$": 1164500,
    "address": "93 Highland Rd",
    "parcel_id": "299-23-00",
    "owner1": "CALLANAN TRS, TIMOTHY",
    "owner2": "STOCK, COURTNEY",
    "current_taxes": 8289.55,
    "new_taxes_no_override": 8647.66,
    "override_total_1": 8893.03,
    "override_increase_1": 245.37
  },
  {
    "#": "95 Highland Rd (299-24-00)",
    "$": 1258500,
    "address": "95 Highland Rd",
    "parcel_id": "299-24-00",
    "owner1": "OCCHIALINI, CHRISTOPHER D & ANNA JD",
    "owner2": "",
    "current_taxes": 9252.11,
    "new_taxes_no_override": 9651.8,
    "override_total_1": 9925.66,
    "override_increase_1": 273.86
  },
  {
    "#": "97 Highland Rd (299-25-00)",
    "$": 1079900,
    "address": "97 Highland Rd",
    "parcel_id": "299-25-00",
    "owner1": "ELWERTOWSKI, THOMAS",
    "owner2": "",
    "current_taxes": 7423.24,
    "new_taxes_no_override": 7743.92,
    "override_total_1": 7963.65,
    "override_increase_1": 219.73
  },
  {
    "#": "1 Hillside Rd (336-05-00)",
    "$": 7976400,
    "address": "1 Hillside Rd",
    "parcel_id": "336-05-00",
    "owner1": "ZHANG, XIAOJIE",
    "owner2": "",
    "current_taxes": 78043.4,
    "new_taxes_no_override": 81414.87,
    "override_total_1": 83724.96,
    "override_increase_1": 2310.08
  },
  {
    "#": "15 Hillside Rd (336-04-00)",
    "$": 2692100,
    "address": "15 Hillside Rd",
    "parcel_id": "336-04-00",
    "owner1": "ALSAWALHI, HEIAM",
    "owner2": "",
    "current_taxes": 27567.1,
    "new_taxes_no_override": 28758.0,
    "override_total_1": 29573.98,
    "override_increase_1": 815.99
  },
  {
    "#": "33 Hillside Rd (336-03-00)",
    "$": 8976200,
    "address": "33 Hillside Rd",
    "parcel_id": "336-03-00",
    "owner1": "ALSAWALHI, HEIAM",
    "owner2": "",
    "current_taxes": 91916.29,
    "new_taxes_no_override": 95887.07,
    "override_total_1": 98607.8,
    "override_increase_1": 2720.72
  },
  {
    "#": "37 Hillside Rd (336-02-00)",
    "$": 2326800,
    "address": "37 Hillside Rd",
    "parcel_id": "336-02-00",
    "owner1": "ALSAWALHI, HEIAM",
    "owner2": "",
    "current_taxes": 23826.43,
    "new_taxes_no_override": 24855.73,
    "override_total_1": 25560.99,
    "override_increase_1": 705.26
  },
  {
    "#": "40 Hillside Rd (337-27-00)",
    "$": 473900,
    "address": "40 Hillside Rd",
    "parcel_id": "337-27-00",
    "owner1": "ANDELMAN, TR, DAVID R",
    "owner2": "C/O WELLESLEY CAPITAL MGMT",
    "current_taxes": 4852.74,
    "new_taxes_no_override": 5062.38,
    "override_total_1": 5206.02,
    "override_increase_1": 143.64
  },
  {
    "#": "60 Hillside Rd (337-28-00)",
    "$": 8584600,
    "address": "60 Hillside Rd",
    "parcel_id": "337-28-00",
    "owner1": "VANBUREN ET AL TRS, BRADLEY M",
    "owner2": "C/O KFN HILLSIDE TRUST",
    "current_taxes": 87906.3,
    "new_taxes_no_override": 91703.85,
    "override_total_1": 94305.88,
    "override_increase_1": 2602.03
  },
  {
    "#": "63 Hillside Rd (336-01-00)",
    "$": 10125900,
    "address": "63 Hillside Rd",
    "parcel_id": "336-01-00",
    "owner1": "CARBONNEAU TR, DANIEL P",
    "owner2": "",
    "current_taxes": 103689.22,
    "new_taxes_no_override": 108168.59,
    "override_total_1": 111237.8,
    "override_increase_1": 3069.2
  },
  {
    "#": "3 Hilltop Rd (278-04-00)",
    "$": 2609100,
    "address": "3 Hilltop Rd",
    "parcel_id": "278-04-00",
    "owner1": "LYNCH TRS, NANCY B",
    "owner2": "",
    "current_taxes": 23082.25,
    "new_taxes_no_override": 24079.4,
    "override_total_1": 24762.64,
    "override_increase_1": 683.23
  },
  {
    "#": "11 Hilltop Rd (278-05-00)",
    "$": 2482200,
    "address": "11 Hilltop Rd",
    "parcel_id": "278-05-00",
    "owner1": "WANGER TR, NANCY K",
    "owner2": "",
    "current_taxes": 21782.79,
    "new_taxes_no_override": 22723.81,
    "override_total_1": 23368.58,
    "override_increase_1": 644.77
  },
  {
    "#": "20 Hilltop Rd (278A-01-00)",
    "$": 2443900,
    "address": "20 Hilltop Rd",
    "parcel_id": "278A-01-00",
    "owner1": "HOGANSON, DAVID MONROE & HEATHER G",
    "owner2": "",
    "current_taxes": 21390.6,
    "new_taxes_no_override": 22314.67,
    "override_total_1": 22947.84,
    "override_increase_1": 633.16
  },
  {
    "#": "29 Hilltop Rd (278-06-07)",
    "$": 4130300,
    "address": "29 Hilltop Rd",
    "parcel_id": "278-06-07",
    "owner1": "RIBATT, POLLY ROSS & GREGG S",
    "owner2": "",
    "current_taxes": 38659.34,
    "new_taxes_no_override": 40329.42,
    "override_total_1": 41473.74,
    "override_increase_1": 1144.32
  },
  {
    "#": "30 Hilltop Rd (278A-08-00)",
    "$": 2596200,
    "address": "30 Hilltop Rd",
    "parcel_id": "278A-08-00",
    "owner1": "GARDINER, PETER E & LISA D",
    "owner2": "",
    "current_taxes": 22950.15,
    "new_taxes_no_override": 23941.6,
    "override_total_1": 24620.92,
    "override_increase_1": 679.32
  },
  {
    "#": "37 Hilltop Rd (278-07-01)",
    "$": 4059700,
    "address": "37 Hilltop Rd",
    "parcel_id": "278-07-01",
    "owner1": "MAY, SEAN",
    "owner2": "FLIGHT, ADRIENNE",
    "current_taxes": 37936.39,
    "new_taxes_no_override": 39575.24,
    "override_total_1": 40698.16,
    "override_increase_1": 1122.92
  },
  {
    "#": "42 Hilltop Rd (278A-07-00)",
    "$": 2137300,
    "address": "42 Hilltop Rd",
    "parcel_id": "278A-07-00",
    "owner1": "COCO TRS, FRANK  & MARTHA",
    "owner2": "",
    "current_taxes": 18251.02,
    "new_taxes_no_override": 19039.46,
    "override_total_1": 19579.69,
    "override_increase_1": 540.23
  },
  {
    "#": "47 Hilltop Rd (278-08-00)",
    "$": 2704200,
    "address": "47 Hilltop Rd",
    "parcel_id": "278-08-00",
    "owner1": "LAWSON, CHAPPELL & ELIZABETH",
    "owner2": "",
    "current_taxes": 27691.01,
    "new_taxes_no_override": 28887.26,
    "override_total_1": 29706.92,
    "override_increase_1": 819.65
  },
  {
    "#": "53 Hilltop Rd (278-09-00)",
    "$": 2975400,
    "address": "53 Hilltop Rd",
    "parcel_id": "278-09-00",
    "owner1": "MCLAUGHLIN, JAMES A & ANN M",
    "owner2": "",
    "current_taxes": 26833.16,
    "new_taxes_no_override": 27992.35,
    "override_total_1": 28786.61,
    "override_increase_1": 794.26
  },
  {
    "#": "54 Hilltop Rd (278A-06-00)",
    "$": 3332100,
    "address": "54 Hilltop Rd",
    "parcel_id": "278A-06-00",
    "owner1": "SAWATZKY, MATTHEW R & KATHERINE P L",
    "owner2": "",
    "current_taxes": 30485.77,
    "new_taxes_no_override": 31802.76,
    "override_total_1": 32705.13,
    "override_increase_1": 902.38
  },
  {
    "#": "59 Hilltop Rd (278-33-00)",
    "$": 3216400,
    "address": "59 Hilltop Rd",
    "parcel_id": "278-33-00",
    "owner1": "LLOYD 3RD TRS, FRANCIS V & LIDA T",
    "owner2": "",
    "current_taxes": 29301.0,
    "new_taxes_no_override": 30566.8,
    "override_total_1": 31434.11,
    "override_increase_1": 867.31
  },
  {
    "#": "65 Hilltop Rd (278-11-00)",
    "$": 3286300,
    "address": "65 Hilltop Rd",
    "parcel_id": "278-11-00",
    "owner1": "ELWOOD, MICHAEL W & CORNELIA P",
    "owner2": "",
    "current_taxes": 30016.78,
    "new_taxes_no_override": 31313.5,
    "override_total_1": 32202.0,
    "override_increase_1": 888.5
  },
  {
    "#": "74 Hilltop Rd (278A-05-00)",
    "$": 2639000,
    "address": "74 Hilltop Rd",
    "parcel_id": "278A-05-00",
    "owner1": "PARK, ROBERT",
    "owner2": "OH, HOLLY",
    "current_taxes": 23388.43,
    "new_taxes_no_override": 24398.81,
    "override_total_1": 25091.11,
    "override_increase_1": 692.3
  },
  {
    "#": "75 Hilltop Rd (278-12-00)",
    "$": 3378800,
    "address": "75 Hilltop Rd",
    "parcel_id": "278-12-00",
    "owner1": "BHADELIA, RAFEEQUE A & JABUN R",
    "owner2": "",
    "current_taxes": 30963.98,
    "new_taxes_no_override": 32301.62,
    "override_total_1": 33218.16,
    "override_increase_1": 916.53
  },
  {
    "#": "85 Hilltop Rd (278-13-00)",
    "$": 3777600,
    "address": "85 Hilltop Rd",
    "parcel_id": "278-13-00",
    "owner1": "BRZEZINSKI TRS, ANDREW & ASHLEY T",
    "owner2": "",
    "current_taxes": 35047.69,
    "new_taxes_no_override": 36561.75,
    "override_total_1": 37599.16,
    "override_increase_1": 1037.41
  },
  {
    "#": "5 Holden St, Unit 5A (174-08-04)",
    "$": 596900,
    "address": "5 Holden St, Unit 5A",
    "parcel_id": "174-08-04",
    "owner1": "MERCURIO, ANDREA",
    "owner2": "",
    "current_taxes": 2477.32,
    "new_taxes_no_override": 2584.34,
    "override_total_1": 2657.67,
    "override_increase_1": 73.33
  },
  {
    "#": "5 Holden St, Unit 5B (174-08-02)",
    "$": 934800,
    "address": "5 Holden St, Unit 5B",
    "parcel_id": "174-08-02",
    "owner1": "MELTON, GEOFFREY E",
    "owner2": "MACKRES, JENNIFER S",
    "current_taxes": 5937.42,
    "new_taxes_no_override": 6193.92,
    "override_total_1": 6369.66,
    "override_increase_1": 175.75
  },
  {
    "#": "7 Holden St, Unit 7 (174-08-03)",
    "$": 1312200,
    "address": "7 Holden St, Unit 7",
    "parcel_id": "174-08-03",
    "owner1": "HAWKINS TR, SARA JULIA",
    "owner2": "",
    "current_taxes": 9801.99,
    "new_taxes_no_override": 10225.44,
    "override_total_1": 10515.57,
    "override_increase_1": 290.14
  },
  {
    "#": "11 Holden St, Unit A (174-09-01)",
    "$": 2219000,
    "address": "11 Holden St, Unit A",
    "parcel_id": "174-09-01",
    "owner1": "TU, WENLONG",
    "owner2": "BI, WENWEN",
    "current_taxes": 19087.63,
    "new_taxes_no_override": 19912.22,
    "override_total_1": 20477.21,
    "override_increase_1": 564.99
  },
  {
    "#": "11 Holden St, Unit B (174-09-02)",
    "$": 2126800,
    "address": "11 Holden St, Unit B",
    "parcel_id": "174-09-02",
    "owner1": "GAMETCHU, MAYETI",
    "owner2": "",
    "current_taxes": 18143.5,
    "new_taxes_no_override": 18927.3,
    "override_total_1": 19464.35,
    "override_increase_1": 537.05
  },
  {
    "#": "11 Holden St, Unit C (174-09-03)",
    "$": 1337500,
    "address": "11 Holden St, Unit C",
    "parcel_id": "174-09-03",
    "owner1": "FINKELSTEIN, IRA D",
    "owner2": "",
    "current_taxes": 10061.07,
    "new_taxes_no_override": 10495.71,
    "override_total_1": 10793.52,
    "override_increase_1": 297.81
  },
  {
    "#": "15 Holden St (174-10-00)",
    "$": 1514900,
    "address": "15 Holden St",
    "parcel_id": "174-10-00",
    "owner1": "YEE, SAMUEL & ROGER & DAVID",
    "owner2": "",
    "current_taxes": 11877.64,
    "new_taxes_no_override": 12390.75,
    "override_total_1": 12742.33,
    "override_increase_1": 351.58
  },
  {
    "#": "25 Holden St (174-01-00)",
    "$": 13599100,
    "address": "25 Holden St",
    "parcel_id": "174-01-00",
    "owner1": "KOREAN CHURCH OF BOSTON INC",
    "owner2": "",
    "current_taxes": 22287.61,
    "new_taxes_no_override": 23250.43,
    "override_total_1": 23910.15,
    "override_increase_1": 659.71
  },
  {
    "#": "16 Holland Rd (251-06-01)",
    "$": 2296700,
    "address": "16 Holland Rd",
    "parcel_id": "251-06-01",
    "owner1": "RIDRUEJO, ALISA KAHN & CARLOS",
    "owner2": "",
    "current_taxes": 19883.27,
    "new_taxes_no_override": 20742.23,
    "override_total_1": 21330.77,
    "override_increase_1": 588.54
  },
  {
    "#": "50 Holland Rd (251-05-00)",
    "$": 2572500,
    "address": "50 Holland Rd",
    "parcel_id": "251-05-00",
    "owner1": "GOLDMAN TR, MIRIAM M",
    "owner2": "",
    "current_taxes": 22707.47,
    "new_taxes_no_override": 23688.43,
    "override_total_1": 24360.57,
    "override_increase_1": 672.14
  },
  {
    "#": "51 Holland Rd (248-10-00)",
    "$": 4105900,
    "address": "51 Holland Rd",
    "parcel_id": "248-10-00",
    "owner1": "51 HOLLAND ROAD LLC",
    "owner2": "",
    "current_taxes": 42044.42,
    "new_taxes_no_override": 43860.74,
    "override_total_1": 45105.25,
    "override_increase_1": 1244.51
  },
  {
    "#": "59 Holland Rd (248-11-00)",
    "$": 3121000,
    "address": "59 Holland Rd",
    "parcel_id": "248-11-00",
    "owner1": "WERTHEIMER, AUSTIN J",
    "owner2": "GOODMAN, CARYL I",
    "current_taxes": 28324.11,
    "new_taxes_no_override": 29547.71,
    "override_total_1": 30386.11,
    "override_increase_1": 838.39
  },
  {
    "#": "74 Holland Rd (250-07-00)",
    "$": 3718900,
    "address": "74 Holland Rd",
    "parcel_id": "250-07-00",
    "owner1": "WERNER, JOHN K & ERIKA ALVAREZ",
    "owner2": "",
    "current_taxes": 34446.6,
    "new_taxes_no_override": 35934.69,
    "override_total_1": 36954.31,
    "override_increase_1": 1019.62
  },
  {
    "#": "79 Holland Rd (249-08-00)",
    "$": 4264500,
    "address": "79 Holland Rd",
    "parcel_id": "249-08-00",
    "owner1": "FISHMAN TRS, JUSTIN T & JILLIAN B T",
    "owner2": "",
    "current_taxes": 43668.48,
    "new_taxes_no_override": 45554.96,
    "override_total_1": 46847.55,
    "override_increase_1": 1292.59
  },
  {
    "#": "90 Holland Rd (250-06-00)",
    "$": 6505500,
    "address": "90 Holland Rd",
    "parcel_id": "250-06-00",
    "owner1": "MADISON LOOP LLC",
    "owner2": "",
    "current_taxes": 66616.32,
    "new_taxes_no_override": 69494.15,
    "override_total_1": 71465.99,
    "override_increase_1": 1971.84
  },
  {
    "#": "97 Holland Rd (249-15-00)",
    "$": 5018700,
    "address": "97 Holland Rd",
    "parcel_id": "249-15-00",
    "owner1": "KOYFMAN, ANDREW",
    "owner2": "",
    "current_taxes": 47756.55,
    "new_taxes_no_override": 49819.63,
    "override_total_1": 51233.23,
    "override_increase_1": 1413.59
  },
  {
    "#": "105 Holland Rd (249-11-00)",
    "$": 4302800,
    "address": "105 Holland Rd",
    "parcel_id": "249-11-00",
    "owner1": "YOUNG, DAVID J",
    "owner2": "MAYER, MICHELLE L",
    "current_taxes": 44060.67,
    "new_taxes_no_override": 45964.09,
    "override_total_1": 47268.29,
    "override_increase_1": 1304.2
  },
  {
    "#": "111 Holland Rd (249-12-00)",
    "$": 3136100,
    "address": "111 Holland Rd",
    "parcel_id": "249-12-00",
    "owner1": "GOLDSTEIN, KENNETH M",
    "owner2": "GAMBULOS, DEMEE S",
    "current_taxes": 28478.73,
    "new_taxes_no_override": 29709.01,
    "override_total_1": 30551.98,
    "override_increase_1": 842.97
  },
  {
    "#": "125 Holland Rd (249-13-00)",
    "$": 5795300,
    "address": "125 Holland Rd",
    "parcel_id": "249-13-00",
    "owner1": "WELLTOWER TRS HOLDCO LLC",
    "owner2": "",
    "current_taxes": 59343.87,
    "new_taxes_no_override": 61907.53,
    "override_total_1": 63664.1,
    "override_increase_1": 1756.58
  },
  {
    "#": "25 Holly Ln, Unit 1A & P1 (426-06-12)",
    "$": 766400,
    "address": "25 Holly Ln, Unit 1A & P1",
    "parcel_id": "426-06-12",
    "owner1": "KOZHUSHNYAN, IGOR & LYUDMILA",
    "owner2": "",
    "current_taxes": 4213.0,
    "new_taxes_no_override": 4395.0,
    "override_total_1": 4519.71,
    "override_increase_1": 124.7
  },
  {
    "#": "25 Holly Ln, Unit 1B & P2-7 (426-06-03)",
    "$": 859300,
    "address": "25 Holly Ln, Unit 1B & P2-7",
    "parcel_id": "426-06-03",
    "owner1": "MATLINK LLC",
    "owner2": "",
    "current_taxes": 8799.23,
    "new_taxes_no_override": 9179.36,
    "override_total_1": 9439.81,
    "override_increase_1": 260.46
  },
  {
    "#": "25 Holly Ln, Unit 1C P17-18 (426-06-06)",
    "$": 816800,
    "address": "25 Holly Ln, Unit 1C P17-18",
    "parcel_id": "426-06-06",
    "owner1": "KHANG, ALEXANDER H",
    "owner2": "",
    "current_taxes": 4729.1,
    "new_taxes_no_override": 4933.4,
    "override_total_1": 5073.38,
    "override_increase_1": 139.98
  },
  {
    "#": "25 Holly Ln, Unit 1D & P4 (426-06-09)",
    "$": 747800,
    "address": "25 Holly Ln, Unit 1D & P4",
    "parcel_id": "426-06-09",
    "owner1": "GEHRKE, LEE",
    "owner2": "",
    "current_taxes": 4022.54,
    "new_taxes_no_override": 4196.31,
    "override_total_1": 4315.38,
    "override_increase_1": 119.07
  },
  {
    "#": "25 Holly Ln, Unit 2A & P5 (426-06-01)",
    "$": 820800,
    "address": "25 Holly Ln, Unit 2A & P5",
    "parcel_id": "426-06-01",
    "owner1": "NAGIA TRS, VIKRAM & JYOTI",
    "owner2": "",
    "current_taxes": 8404.99,
    "new_taxes_no_override": 8768.09,
    "override_total_1": 9016.87,
    "override_increase_1": 248.79
  },
  {
    "#": "25 Holly Ln, Unit 2B & P6-3 (426-06-04)",
    "$": 859600,
    "address": "25 Holly Ln, Unit 2B & P6-3",
    "parcel_id": "426-06-04",
    "owner1": "AHMED, ZAHEER",
    "owner2": "HASHIMI, ANEEQA",
    "current_taxes": 8802.3,
    "new_taxes_no_override": 9182.56,
    "override_total_1": 9443.11,
    "override_increase_1": 260.55
  },
  {
    "#": "25 Holly Ln, Unit 2C P15-16 (426-06-07)",
    "$": 814600,
    "address": "25 Holly Ln, Unit 2C P15-16",
    "parcel_id": "426-06-07",
    "owner1": "MEAD, JULIE M",
    "owner2": "",
    "current_taxes": 4706.57,
    "new_taxes_no_override": 4909.89,
    "override_total_1": 5049.21,
    "override_increase_1": 139.31
  },
  {
    "#": "25 Holly Ln, Unit 2D & P8-9 (426-06-10)",
    "$": 859600,
    "address": "25 Holly Ln, Unit 2D & P8-9",
    "parcel_id": "426-06-10",
    "owner1": "WILNER LIFE ESTATE, ARTHUR & BERNICE",
    "owner2": "",
    "current_taxes": 5167.37,
    "new_taxes_no_override": 5390.6,
    "override_total_1": 5543.55,
    "override_increase_1": 152.95
  },
  {
    "#": "25 Holly Ln, Unit 3A P13-14 (426-06-02)",
    "$": 892200,
    "address": "25 Holly Ln, Unit 3A P13-14",
    "parcel_id": "426-06-02",
    "owner1": "GRIMM, GERALDINE A",
    "owner2": "",
    "current_taxes": 5501.19,
    "new_taxes_no_override": 5738.84,
    "override_total_1": 5901.68,
    "override_increase_1": 162.84
  },
  {
    "#": "25 Holly Ln, Unit 3B & P10 (426-06-05)",
    "$": 739600,
    "address": "25 Holly Ln, Unit 3B & P10",
    "parcel_id": "426-06-05",
    "owner1": "MCCANN TRS, MARY E",
    "owner2": "GRAY III, ROLAND",
    "current_taxes": 3938.57,
    "new_taxes_no_override": 4108.72,
    "override_total_1": 4225.3,
    "override_increase_1": 116.58
  },
  {
    "#": "25 Holly Ln, Unit 3C & P11 (426-06-08)",
    "$": 695100,
    "address": "25 Holly Ln, Unit 3C & P11",
    "parcel_id": "426-06-08",
    "owner1": "WEIL TR, ROCHELLE ANNE",
    "owner2": "",
    "current_taxes": 3482.89,
    "new_taxes_no_override": 3633.35,
    "override_total_1": 3736.44,
    "override_increase_1": 103.09
  },
  {
    "#": "25 Holly Ln, Unit 3D & P12 (426-06-11)",
    "$": 740500,
    "address": "25 Holly Ln, Unit 3D & P12",
    "parcel_id": "426-06-11",
    "owner1": "ZANERCIK, GARY D",
    "owner2": "",
    "current_taxes": 3947.79,
    "new_taxes_no_override": 4118.33,
    "override_total_1": 4235.19,
    "override_increase_1": 116.85
  },
  {
    "#": "26 Holly Ln, Unit 1A P6-14 (428-01-18)",
    "$": 781200,
    "address": "26 Holly Ln, Unit 1A P6-14",
    "parcel_id": "428-01-18",
    "owner1": "REDFIELD, ROBYN S",
    "owner2": "",
    "current_taxes": 4364.55,
    "new_taxes_no_override": 4553.1,
    "override_total_1": 4682.29,
    "override_increase_1": 129.19
  },
  {
    "#": "26 Holly Ln, Unit 1B & P11 (428-01-01)",
    "$": 756900,
    "address": "26 Holly Ln, Unit 1B & P11",
    "parcel_id": "428-01-01",
    "owner1": "LI, RICHARD",
    "owner2": "TIMBERLAKE, KRISTEN",
    "current_taxes": 4115.72,
    "new_taxes_no_override": 4293.52,
    "override_total_1": 4415.34,
    "override_increase_1": 121.83
  },
  {
    "#": "26 Holly Ln, Unit 1C & P12 (428-01-02)",
    "$": 713300,
    "address": "26 Holly Ln, Unit 1C & P12",
    "parcel_id": "428-01-02",
    "owner1": "GEFFIN, LAURENCE A & YURIKA H",
    "owner2": "",
    "current_taxes": 3669.26,
    "new_taxes_no_override": 3827.77,
    "override_total_1": 3936.38,
    "override_increase_1": 108.61
  },
  {
    "#": "26 Holly Ln, Unit 1D & P7 (428-01-03)",
    "$": 669900,
    "address": "26 Holly Ln, Unit 1D & P7",
    "parcel_id": "428-01-03",
    "owner1": "KRUSKAL, EMMA",
    "owner2": "",
    "current_taxes": 3224.84,
    "new_taxes_no_override": 3364.15,
    "override_total_1": 3459.61,
    "override_increase_1": 95.46
  },
  {
    "#": "26 Holly Ln, Unit 1E & P18 (428-01-04)",
    "$": 689200,
    "address": "26 Holly Ln, Unit 1E & P18",
    "parcel_id": "428-01-04",
    "owner1": "SILVER, PATTI B & STEVEN A",
    "owner2": "",
    "current_taxes": 7057.41,
    "new_taxes_no_override": 7362.29,
    "override_total_1": 7571.19,
    "override_increase_1": 208.9
  },
  {
    "#": "26 Holly Ln, Unit 1F & P15 (428-01-05)",
    "$": 791700,
    "address": "26 Holly Ln, Unit 1F & P15",
    "parcel_id": "428-01-05",
    "owner1": "YU, KYONG JA",
    "owner2": "",
    "current_taxes": 4472.07,
    "new_taxes_no_override": 4665.26,
    "override_total_1": 4797.64,
    "override_increase_1": 132.37
  },
  {
    "#": "26 Holly Ln, Unit 2A & P13 (428-01-06)",
    "$": 756000,
    "address": "26 Holly Ln, Unit 2A & P13",
    "parcel_id": "428-01-06",
    "owner1": "BROSNAN, TARYN",
    "owner2": "DEANS, SPENCER",
    "current_taxes": 4106.51,
    "new_taxes_no_override": 4283.91,
    "override_total_1": 4405.46,
    "override_increase_1": 121.55
  },
  {
    "#": "26 Holly Ln, Unit 2B & P5 (428-01-07)",
    "$": 757000,
    "address": "26 Holly Ln, Unit 2B & P5",
    "parcel_id": "428-01-07",
    "owner1": "NICKMAN, STEVEN L",
    "owner2": "",
    "current_taxes": 4116.75,
    "new_taxes_no_override": 4294.59,
    "override_total_1": 4416.45,
    "override_increase_1": 121.86
  },
  {
    "#": "26 Holly Ln, Unit 2C P2-23 (428-01-08)",
    "$": 786700,
    "address": "26 Holly Ln, Unit 2C P2-23",
    "parcel_id": "428-01-08",
    "owner1": "GOTKIN TR, KAREN E",
    "owner2": "",
    "current_taxes": 8055.81,
    "new_taxes_no_override": 8403.82,
    "override_total_1": 8642.27,
    "override_increase_1": 238.45
  },
  {
    "#": "26 Holly Ln, Unit 2D & P9 (428-01-09)",
    "$": 633200,
    "address": "26 Holly Ln, Unit 2D & P9",
    "parcel_id": "428-01-09",
    "owner1": "NOONAN, PAUL F",
    "owner2": "",
    "current_taxes": 2849.03,
    "new_taxes_no_override": 2972.11,
    "override_total_1": 3056.44,
    "override_increase_1": 84.33
  },
  {
    "#": "26 Holly Ln, Unit 2E & P8 (428-01-10)",
    "$": 668900,
    "address": "26 Holly Ln, Unit 2E & P8",
    "parcel_id": "428-01-10",
    "owner1": "CENTORINO LIFE ESTATE, KATHLEEN K",
    "owner2": "",
    "current_taxes": 3214.6,
    "new_taxes_no_override": 3353.47,
    "override_total_1": 3448.62,
    "override_increase_1": 95.15
  },
  {
    "#": "26 Holly Ln, Unit 2F & P10 (428-01-11)",
    "$": 805300,
    "address": "26 Holly Ln, Unit 2F & P10",
    "parcel_id": "428-01-11",
    "owner1": "CHAN TR, SHUK CHING",
    "owner2": "",
    "current_taxes": 8246.27,
    "new_taxes_no_override": 8602.51,
    "override_total_1": 8846.6,
    "override_increase_1": 244.09
  },
  {
    "#": "26 Holly Ln, Unit 3A & P4-19 (428-01-12)",
    "$": 787300,
    "address": "26 Holly Ln, Unit 3A & P4-19",
    "parcel_id": "428-01-12",
    "owner1": "MAHONEY, ALICE E",
    "owner2": "",
    "current_taxes": 4427.02,
    "new_taxes_no_override": 4618.27,
    "override_total_1": 4749.31,
    "override_increase_1": 131.04
  },
  {
    "#": "26 Holly Ln, Unit 3B & P1-20 (428-01-13)",
    "$": 811800,
    "address": "26 Holly Ln, Unit 3B & P1-20",
    "parcel_id": "428-01-13",
    "owner1": "COSTELLIC, DOREEN E",
    "owner2": "",
    "current_taxes": 4677.9,
    "new_taxes_no_override": 4879.99,
    "override_total_1": 5018.45,
    "override_increase_1": 138.47
  },
  {
    "#": "26 Holly Ln, Unit 3C & P17 (428-01-14)",
    "$": 758700,
    "address": "26 Holly Ln, Unit 3C & P17",
    "parcel_id": "428-01-14",
    "owner1": "DAVID, MICHELE M A",
    "owner2": "",
    "current_taxes": 4134.15,
    "new_taxes_no_override": 4312.75,
    "override_total_1": 4435.12,
    "override_increase_1": 122.37
  },
  {
    "#": "26 Holly Ln, Unit 3D & P16 (428-01-15)",
    "$": 642700,
    "address": "26 Holly Ln, Unit 3D & P16",
    "parcel_id": "428-01-15",
    "owner1": "KOURY, LINDA",
    "owner2": "",
    "current_taxes": 2946.31,
    "new_taxes_no_override": 3073.59,
    "override_total_1": 3160.8,
    "override_increase_1": 87.21
  },
  {
    "#": "26 Holly Ln, Unit 3E & P22 (428-01-16)",
    "$": 678400,
    "address": "26 Holly Ln, Unit 3E & P22",
    "parcel_id": "428-01-16",
    "owner1": "GERRY, JANE",
    "owner2": "",
    "current_taxes": 6946.82,
    "new_taxes_no_override": 7246.92,
    "override_total_1": 7452.55,
    "override_increase_1": 205.63
  },
  {
    "#": "26 Holly Ln, Unit 3F & P3-21 (428-01-17)",
    "$": 870300,
    "address": "26 Holly Ln, Unit 3F & P3-21",
    "parcel_id": "428-01-17",
    "owner1": "GANT TR, BERNARD",
    "owner2": "",
    "current_taxes": 5276.94,
    "new_taxes_no_override": 5504.9,
    "override_total_1": 5661.1,
    "override_increase_1": 156.2
  },
  {
    "#": "6 Hollywood Rd (378-01-00)",
    "$": 1413800,
    "address": "6 Hollywood Rd",
    "parcel_id": "378-01-00",
    "owner1": "CHABON, DAVID S & KAREN C",
    "owner2": "",
    "current_taxes": 10842.38,
    "new_taxes_no_override": 11310.77,
    "override_total_1": 11631.71,
    "override_increase_1": 320.93
  },
  {
    "#": "12 Hollywood Rd (378-06-00)",
    "$": 14200,
    "address": "12 Hollywood Rd",
    "parcel_id": "378-06-00",
    "owner1": "KANEKO, TSUYOSCHI & AKIKO",
    "owner2": "",
    "current_taxes": 145.41,
    "new_taxes_no_override": 151.69,
    "override_total_1": 156.0,
    "override_increase_1": 4.3
  },
  {
    "#": "16 Hollywood Rd (378-07-00)",
    "$": 5000,
    "address": "16 Hollywood Rd",
    "parcel_id": "378-07-00",
    "owner1": "TSENG, HSUE H CHIN",
    "owner2": "CHENG, MING",
    "current_taxes": 51.2,
    "new_taxes_no_override": 53.41,
    "override_total_1": 54.93,
    "override_increase_1": 1.52
  },
  {
    "#": "8 Homer St, Unit 1 & P6 (154-06-09)",
    "$": 686300,
    "address": "8 Homer St, Unit 1 & P6",
    "parcel_id": "154-06-09",
    "owner1": "GRIMES, KELLY A",
    "owner2": "ODOWD, SCOTT M",
    "current_taxes": 3392.78,
    "new_taxes_no_override": 3539.35,
    "override_total_1": 3639.77,
    "override_increase_1": 100.43
  },
  {
    "#": "8 Homer St, Unit 2 & P7 (154-06-10)",
    "$": 699400,
    "address": "8 Homer St, Unit 2 & P7",
    "parcel_id": "154-06-10",
    "owner1": "EMILFARB, TRS, POLINA",
    "owner2": "",
    "current_taxes": 7161.86,
    "new_taxes_no_override": 7471.25,
    "override_total_1": 7683.24,
    "override_increase_1": 211.99
  },
  {
    "#": "8 Homer St, Unit 3 (154-06-11)",
    "$": 689800,
    "address": "8 Homer St, Unit 3",
    "parcel_id": "154-06-11",
    "owner1": "KUHLMAN, BRYAN & RACHEL",
    "owner2": "",
    "current_taxes": 3428.62,
    "new_taxes_no_override": 3576.74,
    "override_total_1": 3678.22,
    "override_increase_1": 101.49
  },
  {
    "#": "8 Homer St, Unit 4 (154-06-12)",
    "$": 703100,
    "address": "8 Homer St, Unit 4",
    "parcel_id": "154-06-12",
    "owner1": "MURRAY, ANNE T",
    "owner2": "",
    "current_taxes": 7199.74,
    "new_taxes_no_override": 7510.77,
    "override_total_1": 7723.88,
    "override_increase_1": 213.11
  },
  {
    "#": "10 Homer St, Unit 1 (154-06-13)",
    "$": 630200,
    "address": "10 Homer St, Unit 1",
    "parcel_id": "154-06-13",
    "owner1": "WANG, TIFFANY Y",
    "owner2": "",
    "current_taxes": 6453.25,
    "new_taxes_no_override": 6732.03,
    "override_total_1": 6923.05,
    "override_increase_1": 191.02
  },
  {
    "#": "10 Homer St, Unit 2 & P2 (154-06-14)",
    "$": 713000,
    "address": "10 Homer St, Unit 2 & P2",
    "parcel_id": "154-06-14",
    "owner1": "YUNGELSON TRS, ANNA",
    "owner2": "KULIKOVA, MARIA",
    "current_taxes": 7301.12,
    "new_taxes_no_override": 7616.53,
    "override_total_1": 7832.64,
    "override_increase_1": 216.11
  },
  {
    "#": "10 Homer St, Unit 3 (154-06-15)",
    "$": 702900,
    "address": "10 Homer St, Unit 3",
    "parcel_id": "154-06-15",
    "owner1": "MILLER, KATERINA",
    "owner2": "C/O MILLER, TATYANA",
    "current_taxes": 7197.7,
    "new_taxes_no_override": 7508.64,
    "override_total_1": 7721.69,
    "override_increase_1": 213.05
  },
  {
    "#": "10 Homer St, Unit 4 & P4 (154-06-16)",
    "$": 735700,
    "address": "10 Homer St, Unit 4 & P4",
    "parcel_id": "154-06-16",
    "owner1": "10 HOMER 4 REALTY LLC",
    "owner2": "",
    "current_taxes": 7533.57,
    "new_taxes_no_override": 7859.02,
    "override_total_1": 8082.01,
    "override_increase_1": 222.99
  },
  {
    "#": "12 Homer St (154-10-00)",
    "$": 5074200,
    "address": "12 Homer St",
    "parcel_id": "154-10-00",
    "owner1": "HREB LLC",
    "owner2": "",
    "current_taxes": 51959.81,
    "new_taxes_no_override": 54204.47,
    "override_total_1": 55742.48,
    "override_increase_1": 1538.01
  },
  {
    "#": "18 Homer St (154-02-00)",
    "$": 3399200,
    "address": "18 Homer St",
    "parcel_id": "154-02-00",
    "owner1": "NEW HOMER STREET LLC",
    "owner2": "C/O  G MORELLO",
    "current_taxes": 34807.81,
    "new_taxes_no_override": 36311.51,
    "override_total_1": 37341.82,
    "override_increase_1": 1030.31
  },
  {
    "#": "22 Homer St, Unit 1 (154-01-06)",
    "$": 736300,
    "address": "22 Homer St, Unit 1",
    "parcel_id": "154-01-06",
    "owner1": "CHEN, CI-DI",
    "owner2": "CHANG, HUICHU",
    "current_taxes": 3904.78,
    "new_taxes_no_override": 4073.47,
    "override_total_1": 4189.05,
    "override_increase_1": 115.58
  },
  {
    "#": "22 Homer St, Unit 2 & P2 (154-01-01)",
    "$": 753200,
    "address": "22 Homer St, Unit 2 & P2",
    "parcel_id": "154-01-01",
    "owner1": "OLEARY TRS, MICHAEL W",
    "owner2": "DIMITROVA, VESELKA ANCHEVA",
    "current_taxes": 7712.77,
    "new_taxes_no_override": 8045.96,
    "override_total_1": 8274.26,
    "override_increase_1": 228.3
  },
  {
    "#": "22 Homer St, Unit 3 (154-01-02)",
    "$": 743000,
    "address": "22 Homer St, Unit 3",
    "parcel_id": "154-01-02",
    "owner1": "DEPETER, COURTNEY T",
    "owner2": "",
    "current_taxes": 3973.39,
    "new_taxes_no_override": 4145.04,
    "override_total_1": 4262.65,
    "override_increase_1": 117.61
  },
  {
    "#": "22 Homer St, Unit 4 (154-01-03)",
    "$": 816600,
    "address": "22 Homer St, Unit 4",
    "parcel_id": "154-01-03",
    "owner1": "JOHNSTON, IAN & SHADI",
    "owner2": "",
    "current_taxes": 4727.05,
    "new_taxes_no_override": 4931.26,
    "override_total_1": 5071.18,
    "override_increase_1": 139.92
  },
  {
    "#": "22 Homer St, Unit 5 & P1 (154-01-04)",
    "$": 737900,
    "address": "22 Homer St, Unit 5 & P1",
    "parcel_id": "154-01-04",
    "owner1": "LEVINSON TRS, FREDRIC S",
    "owner2": "BISTROWITZ, LESLIE H",
    "current_taxes": 7556.1,
    "new_taxes_no_override": 7882.52,
    "override_total_1": 8106.18,
    "override_increase_1": 223.66
  },
  {
    "#": "22 Homer St, Unit 6 (154-01-05)",
    "$": 796200,
    "address": "22 Homer St, Unit 6",
    "parcel_id": "154-01-05",
    "owner1": "CASE, BRANDON C & JUNNING H",
    "owner2": "",
    "current_taxes": 4518.15,
    "new_taxes_no_override": 4713.33,
    "override_total_1": 4847.07,
    "override_increase_1": 133.74
  },
  {
    "#": "7 Hurd Rd, Unit 1 (149-26-01)",
    "$": 959100,
    "address": "7 Hurd Rd, Unit 1",
    "parcel_id": "149-26-01",
    "owner1": "SULLIVAN, FREDERICK B",
    "owner2": "LIVENGOOD, AMANDA J",
    "current_taxes": 6186.25,
    "new_taxes_no_override": 6453.5,
    "override_total_1": 6636.61,
    "override_increase_1": 183.11
  },
  {
    "#": "7 Hurd Rd, Unit 2 (149-26-02)",
    "$": 1121400,
    "address": "7 Hurd Rd, Unit 2",
    "parcel_id": "149-26-02",
    "owner1": "ELMEKIAS, MOSHE & CYNTHIA MORTON",
    "owner2": "",
    "current_taxes": 7848.2,
    "new_taxes_no_override": 8187.24,
    "override_total_1": 8419.55,
    "override_increase_1": 232.31
  },
  {
    "#": "7 Hurd Rd, Unit 3 (149-26-03)",
    "$": 1574800,
    "address": "7 Hurd Rd, Unit 3",
    "parcel_id": "149-26-03",
    "owner1": "BARRETT TR, SARAH M",
    "owner2": "",
    "current_taxes": 12491.02,
    "new_taxes_no_override": 13030.63,
    "override_total_1": 13400.37,
    "override_increase_1": 369.73
  },
  {
    "#": "9 Hurd Rd (149-27-00)",
    "$": 2590900,
    "address": "9 Hurd Rd",
    "parcel_id": "149-27-00",
    "owner1": "CANO-MIRABILE, TR, GLORIA",
    "owner2": "",
    "current_taxes": 22895.88,
    "new_taxes_no_override": 23884.98,
    "override_total_1": 24562.7,
    "override_increase_1": 677.72
  },
  {
    "#": "11 Hurd Rd, Unit 1 (149-28-01)",
    "$": 740000,
    "address": "11 Hurd Rd, Unit 1",
    "parcel_id": "149-28-01",
    "owner1": "MILLER, COURTNEY PINA & JESSIE WARD",
    "owner2": "",
    "current_taxes": 3942.67,
    "new_taxes_no_override": 4112.99,
    "override_total_1": 4229.7,
    "override_increase_1": 116.7
  },
  {
    "#": "11 Hurd Rd, Unit 2 (149-28-02)",
    "$": 716300,
    "address": "11 Hurd Rd, Unit 2",
    "parcel_id": "149-28-02",
    "owner1": "YEH TR, IRENE M",
    "owner2": "",
    "current_taxes": 7334.91,
    "new_taxes_no_override": 7651.78,
    "override_total_1": 7868.89,
    "override_increase_1": 217.11
  },
  {
    "#": "11 Hurd Rd, Unit 3 (149-28-03)",
    "$": 733900,
    "address": "11 Hurd Rd, Unit 3",
    "parcel_id": "149-28-03",
    "owner1": "ZHANG, HENRY",
    "owner2": "",
    "current_taxes": 7515.14,
    "new_taxes_no_override": 7839.79,
    "override_total_1": 8062.24,
    "override_increase_1": 222.45
  },
  {
    "#": "15 Hurd Rd (149-29-00)",
    "$": 2781000,
    "address": "15 Hurd Rd",
    "parcel_id": "149-29-00",
    "owner1": "OCONNOR, ROBERT E & NANCY WALSH",
    "owner2": "",
    "current_taxes": 24842.51,
    "new_taxes_no_override": 25915.71,
    "override_total_1": 26651.04,
    "override_increase_1": 735.34
  },
  {
    "#": "19 Hurd Rd (149-30-00)",
    "$": 2131400,
    "address": "19 Hurd Rd",
    "parcel_id": "149-30-00",
    "owner1": "MURRAY, ANDREW",
    "owner2": "KRAMER-MURRAY, B J",
    "current_taxes": 18190.6,
    "new_taxes_no_override": 18976.43,
    "override_total_1": 19514.88,
    "override_increase_1": 538.44
  },
  {
    "#": "23 Hurd Rd, Unit 1 (149-31-01)",
    "$": 956200,
    "address": "23 Hurd Rd, Unit 1",
    "parcel_id": "149-31-01",
    "owner1": "DIMISE, ERIC J",
    "owner2": "FIELDING, ELISHA N",
    "current_taxes": 9791.49,
    "new_taxes_no_override": 10214.48,
    "override_total_1": 10504.31,
    "override_increase_1": 289.83
  },
  {
    "#": "23 Hurd Rd, Unit 2 (149-31-02)",
    "$": 956400,
    "address": "23 Hurd Rd, Unit 2",
    "parcel_id": "149-31-02",
    "owner1": "WONG, JESSICA",
    "owner2": "ANANIAN, CLIFFORD SCOTT",
    "current_taxes": 9793.54,
    "new_taxes_no_override": 10216.62,
    "override_total_1": 10506.51,
    "override_increase_1": 289.89
  },
  {
    "#": "23 Hurd Rd, Unit 3 (149-31-03)",
    "$": 956300,
    "address": "23 Hurd Rd, Unit 3",
    "parcel_id": "149-31-03",
    "owner1": "CAMPBELL, DEREK J",
    "owner2": "GRILLO, ELIZABETH",
    "current_taxes": 6157.58,
    "new_taxes_no_override": 6423.59,
    "override_total_1": 6605.85,
    "override_increase_1": 182.26
  },
  {
    "#": "27 Hurd Rd (149-32-07)",
    "$": 3575200,
    "address": "27 Hurd Rd",
    "parcel_id": "149-32-07",
    "owner1": "27 HURD REALTY LLC",
    "owner2": "",
    "current_taxes": 36610.05,
    "new_taxes_no_override": 38191.6,
    "override_total_1": 39275.26,
    "override_increase_1": 1083.66
  },
  {
    "#": "31 Hurd Rd (149-33-00)",
    "$": 2175800,
    "address": "31 Hurd Rd",
    "parcel_id": "149-33-00",
    "owner1": "WHEELER TRS, SUSAN CHAPMAN",
    "owner2": "WESTPHAL, CHRISTINE MARIE",
    "current_taxes": 18645.26,
    "new_taxes_no_override": 19450.74,
    "override_total_1": 20002.63,
    "override_increase_1": 551.9
  },
  {
    "#": "9 Hyslop Rd (248-12-00)",
    "$": 3774400,
    "address": "9 Hyslop Rd",
    "parcel_id": "248-12-00",
    "owner1": "BROWN TRS, CLIFFORD M",
    "owner2": "HALPERT, LISA J",
    "current_taxes": 35014.92,
    "new_taxes_no_override": 36527.56,
    "override_total_1": 37564.01,
    "override_increase_1": 1036.44
  },
  {
    "#": "15 Hyslop Rd (248-13-00)",
    "$": 3953400,
    "address": "15 Hyslop Rd",
    "parcel_id": "248-13-00",
    "owner1": "KASPER TRS, DENNIS L",
    "owner2": "SCURTI, MARIE E",
    "current_taxes": 36847.88,
    "new_taxes_no_override": 38439.71,
    "override_total_1": 39530.41,
    "override_increase_1": 1090.7
  },
  {
    "#": "22 Hyslop Rd (249-07-00)",
    "$": 3281300,
    "address": "22 Hyslop Rd",
    "parcel_id": "249-07-00",
    "owner1": "NATH TR, BARBARA J",
    "owner2": "",
    "current_taxes": 29965.58,
    "new_taxes_no_override": 31260.09,
    "override_total_1": 32147.07,
    "override_increase_1": 886.98
  },
  {
    "#": "29 Hyslop Rd (248-14-00)",
    "$": 3551200,
    "address": "29 Hyslop Rd",
    "parcel_id": "248-14-00",
    "owner1": "ROTH, ROBERT A & SALLY S",
    "owner2": "",
    "current_taxes": 32729.35,
    "new_taxes_no_override": 34143.26,
    "override_total_1": 35112.05,
    "override_increase_1": 968.79
  },
  {
    "#": "34 Hyslop Rd (249-14-00)",
    "$": 2741600,
    "address": "34 Hyslop Rd",
    "parcel_id": "249-14-00",
    "owner1": "CHAVEZ, ALEJANDRO",
    "owner2": "NUNEZ DE CHAVEZ, IRENE",
    "current_taxes": 24439.05,
    "new_taxes_no_override": 25494.82,
    "override_total_1": 26218.21,
    "override_increase_1": 723.4
  },
  {
    "#": "37 Hyslop Rd (248-15-00)",
    "$": 5862400,
    "address": "37 Hyslop Rd",
    "parcel_id": "248-15-00",
    "owner1": "GOLDBERG, DEBORAH",
    "owner2": "",
    "current_taxes": 56396.04,
    "new_taxes_no_override": 58832.35,
    "override_total_1": 60501.67,
    "override_increase_1": 1669.32
  },
  {
    "#": "46 Hyslop Rd (249-05-00)",
    "$": 3478900,
    "address": "46 Hyslop Rd",
    "parcel_id": "249-05-00",
    "owner1": "HUANG, JIEYU",
    "owner2": "HE, KAIMING",
    "current_taxes": 31989.0,
    "new_taxes_no_override": 33370.92,
    "override_total_1": 34317.8,
    "override_increase_1": 946.87
  },
  {
    "#": "52 Hyslop Rd (249-04-00)",
    "$": 4346900,
    "address": "52 Hyslop Rd",
    "parcel_id": "249-04-00",
    "owner1": "KING TR, DAVID L",
    "owner2": "",
    "current_taxes": 44512.26,
    "new_taxes_no_override": 46435.19,
    "override_total_1": 47752.75,
    "override_increase_1": 1317.56
  },
  {
    "#": "60 Hyslop Rd (249-03-00)",
    "$": 4633400,
    "address": "60 Hyslop Rd",
    "parcel_id": "249-03-00",
    "owner1": "MININBERG, JULIEN R & EMESHE JUHASZ",
    "owner2": "",
    "current_taxes": 43811.08,
    "new_taxes_no_override": 45703.72,
    "override_total_1": 47000.53,
    "override_increase_1": 1296.81
  },
  {
    "#": "67 Hyslop Rd (244-06-00)",
    "$": 3861800,
    "address": "67 Hyslop Rd",
    "parcel_id": "244-06-00",
    "owner1": "BARRETT, JAMES T",
    "owner2": "",
    "current_taxes": 35909.9,
    "new_taxes_no_override": 37461.21,
    "override_total_1": 38524.14,
    "override_increase_1": 1062.93
  },
  {
    "#": "70 Hyslop Rd (249-02-00)",
    "$": 4406600,
    "address": "70 Hyslop Rd",
    "parcel_id": "249-02-00",
    "owner1": "MARCUS ET AL TRS, ROBERT L",
    "owner2": "ONEILL, CHARLES T",
    "current_taxes": 41488.65,
    "new_taxes_no_override": 43280.96,
    "override_total_1": 44509.02,
    "override_increase_1": 1228.06
  },
  {
    "#": "89 Hyslop Rd (244-07-00)",
    "$": 7865300,
    "address": "89 Hyslop Rd",
    "parcel_id": "244-07-00",
    "owner1": "FEINBERG, DAVID H",
    "owner2": "",
    "current_taxes": 80540.67,
    "new_taxes_no_override": 84020.03,
    "override_total_1": 86404.03,
    "override_increase_1": 2384.0
  },
  {
    "#": "119 Hyslop Rd (257-02-00)",
    "$": 11516200,
    "address": "119 Hyslop Rd",
    "parcel_id": "257-02-00",
    "owner1": "EDGERLEY, PAUL B & SANDRA M",
    "owner2": "",
    "current_taxes": 114290.95,
    "new_taxes_no_override": 119228.32,
    "override_total_1": 122611.33,
    "override_increase_1": 3383.01
  },
  {
    "#": "133 Hyslop Rd (257-03-00)",
    "$": 5851800,
    "address": "133 Hyslop Rd",
    "parcel_id": "257-03-00",
    "owner1": "SLOSS, BENJAMIN & CHRISTINE",
    "owner2": "",
    "current_taxes": 59922.43,
    "new_taxes_no_override": 62511.08,
    "override_total_1": 64284.78,
    "override_increase_1": 1773.7
  },
  {
    "#": "146 Hyslop Rd (256-20-00)",
    "$": 5625400,
    "address": "146 Hyslop Rd",
    "parcel_id": "256-20-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O TREASURERS OFFICE",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "147 Hyslop Rd (257-04-06)",
    "$": 4537100,
    "address": "147 Hyslop Rd",
    "parcel_id": "257-04-06",
    "owner1": "DIMENTO, FRANCIS J",
    "owner2": "",
    "current_taxes": 42824.97,
    "new_taxes_no_override": 44675.01,
    "override_total_1": 45942.63,
    "override_increase_1": 1267.62
  },
  {
    "#": "154 Hyslop Rd (256-19-00)",
    "$": 5024600,
    "address": "154 Hyslop Rd",
    "parcel_id": "256-19-00",
    "owner1": "SANIEOFF, SYROOS & RONNI M",
    "owner2": "",
    "current_taxes": 47816.97,
    "new_taxes_no_override": 49882.66,
    "override_total_1": 51298.05,
    "override_increase_1": 1415.38
  },
  {
    "#": "161 Hyslop Rd (257-05-00)",
    "$": 5101600,
    "address": "161 Hyslop Rd",
    "parcel_id": "257-05-00",
    "owner1": "LIPSON, PAUL A & NICOLE G",
    "owner2": "",
    "current_taxes": 52240.38,
    "new_taxes_no_override": 54497.16,
    "override_total_1": 56043.48,
    "override_increase_1": 1546.32
  },
  {
    "#": "166 Hyslop Rd (256-18-00)",
    "$": 4760600,
    "address": "166 Hyslop Rd",
    "parcel_id": "256-18-00",
    "owner1": "FREDKIN, EDWARD & JOYCELIN W",
    "owner2": "",
    "current_taxes": 48748.54,
    "new_taxes_no_override": 50854.48,
    "override_total_1": 52297.43,
    "override_increase_1": 1442.96
  },
  {
    "#": "170 Hyslop Rd (256A-02-00)",
    "$": 5679900,
    "address": "170 Hyslop Rd",
    "parcel_id": "256A-02-00",
    "owner1": "SENGUPTA, PUSHAN",
    "owner2": "MOHANTY, ARPAN",
    "current_taxes": 58162.18,
    "new_taxes_no_override": 60674.79,
    "override_total_1": 62396.39,
    "override_increase_1": 1721.6
  },
  {
    "#": "200 Hyslop Rd (256A-01-01)",
    "$": 3020400,
    "address": "200 Hyslop Rd",
    "parcel_id": "256A-01-01",
    "owner1": "MAHADEVAN, LAKSHMINARAYANAN & AMALA",
    "owner2": "",
    "current_taxes": 30928.9,
    "new_taxes_no_override": 32265.03,
    "override_total_1": 33180.52,
    "override_increase_1": 915.5
  },
  {
    "#": "201 Hyslop Rd (257-07-00)",
    "$": 8077100,
    "address": "201 Hyslop Rd",
    "parcel_id": "257-07-00",
    "owner1": "MCLEOD, MICHAEL P",
    "owner2": "",
    "current_taxes": 82709.5,
    "new_taxes_no_override": 86282.55,
    "override_total_1": 88730.75,
    "override_increase_1": 2448.2
  },
  {
    "#": "11 Hyslop Rd Ext (256A-02-01)",
    "$": 2004800,
    "address": "11 Hyslop Rd Ext",
    "parcel_id": "256A-02-01",
    "owner1": "YAGODA, ELISE JOLENE  & DANIEL",
    "owner2": "",
    "current_taxes": 16894.22,
    "new_taxes_no_override": 17624.05,
    "override_total_1": 18124.12,
    "override_increase_1": 500.07
  },
  {
    "#": "31 Hyslop Rd Ext (256A-03-06)",
    "$": 7765100,
    "address": "31 Hyslop Rd Ext",
    "parcel_id": "256A-03-06",
    "owner1": "DAGLIO, KRISTINA G",
    "owner2": "",
    "current_taxes": 75879.69,
    "new_taxes_no_override": 79157.69,
    "override_total_1": 81403.73,
    "override_increase_1": 2246.04
  },
  {
    "#": " Hyslop Rd Ext (256-17-00)",
    "$": 14700,
    "address": " Hyslop Rd Ext",
    "parcel_id": "256-17-00",
    "owner1": "DAGLIO, KRISTINA G",
    "owner2": "",
    "current_taxes": 150.53,
    "new_taxes_no_override": 157.03,
    "override_total_1": 161.49,
    "override_increase_1": 4.46
  },
  {
    "#": "7 Independence Dr (392-01-01)",
    "$": 1166900,
    "address": "7 Independence Dr",
    "parcel_id": "392-01-01",
    "owner1": "KRAWITZ TRS, ROBERT L",
    "owner2": "GANI, MANUELA",
    "current_taxes": 8314.12,
    "new_taxes_no_override": 8673.29,
    "override_total_1": 8919.39,
    "override_increase_1": 246.1
  },
  {
    "#": "9 Independence Dr (388C-01-01)",
    "$": 12913900,
    "address": "9 Independence Dr",
    "parcel_id": "388C-01-01",
    "owner1": "ROSB REALTY LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 132238.34,
    "new_taxes_no_override": 137951.04,
    "override_total_1": 141865.29,
    "override_increase_1": 3914.25
  },
  {
    "#": "14 Independence Dr (389-13-00)",
    "$": 1418900,
    "address": "14 Independence Dr",
    "parcel_id": "389-13-00",
    "owner1": "GALVEZ DELGADO TRS, JULIA  A",
    "owner2": "KLUCINEC, CARMIE A",
    "current_taxes": 10894.6,
    "new_taxes_no_override": 11365.25,
    "override_total_1": 11687.73,
    "override_increase_1": 322.48
  },
  {
    "#": "18 Independence Dr (389-14-00)",
    "$": 1577600,
    "address": "18 Independence Dr",
    "parcel_id": "389-14-00",
    "owner1": "DAVID, EBENEZER",
    "owner2": "",
    "current_taxes": 12519.69,
    "new_taxes_no_override": 13060.54,
    "override_total_1": 13431.12,
    "override_increase_1": 370.58
  },
  {
    "#": "21 Independence Dr (388C-01-00)",
    "$": 51672600,
    "address": "21 Independence Dr",
    "parcel_id": "388C-01-00",
    "owner1": "HV TH LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 529127.42,
    "new_taxes_no_override": 551985.72,
    "override_total_1": 567647.9,
    "override_increase_1": 15662.17
  },
  {
    "#": "22 Independence Dr (389-15-00)",
    "$": 2075500,
    "address": "22 Independence Dr",
    "parcel_id": "389-15-00",
    "owner1": "KHAMIS, FARIDA MOHAMED FARID FOUAD",
    "owner2": "",
    "current_taxes": 17618.19,
    "new_taxes_no_override": 18379.3,
    "override_total_1": 18900.79,
    "override_increase_1": 521.5
  },
  {
    "#": "24 Independence Dr (388A-01-01)",
    "$": 7364100,
    "address": "24 Independence Dr",
    "parcel_id": "388A-01-01",
    "owner1": "ROSB REALTY LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 75408.38,
    "new_taxes_no_override": 78666.02,
    "override_total_1": 80898.11,
    "override_increase_1": 2232.09
  },
  {
    "#": "46 Independence Dr (388A-01-00)",
    "$": 34691200,
    "address": "46 Independence Dr",
    "parcel_id": "388A-01-00",
    "owner1": "HV 676 LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 355237.89,
    "new_taxes_no_override": 370584.17,
    "override_total_1": 381099.21,
    "override_increase_1": 10515.04
  },
  {
    "#": "101 Independence Dr (388B-01-00)",
    "$": 97850800,
    "address": "101 Independence Dr",
    "parcel_id": "388B-01-00",
    "owner1": "HV 676 LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 1001992.19,
    "new_taxes_no_override": 1045278.25,
    "override_total_1": 1074937.22,
    "override_increase_1": 29658.97
  },
  {
    "#": "2 Intervale Rd (375C-11-00)",
    "$": 1355900,
    "address": "2 Intervale Rd",
    "parcel_id": "375C-11-00",
    "owner1": "BOLOKER TRS, DAVID & SHEREE",
    "owner2": "",
    "current_taxes": 10249.48,
    "new_taxes_no_override": 10692.26,
    "override_total_1": 10995.64,
    "override_increase_1": 303.38
  },
  {
    "#": "6 Intervale Rd (375C-10-00)",
    "$": 2515600,
    "address": "6 Intervale Rd",
    "parcel_id": "375C-10-00",
    "owner1": "YI, TINGFANG",
    "owner2": "ZONG, CHEN",
    "current_taxes": 22124.81,
    "new_taxes_no_override": 23080.6,
    "override_total_1": 23735.5,
    "override_increase_1": 654.89
  },
  {
    "#": "11 Intervale Rd (375F-03-00)",
    "$": 1765300,
    "address": "11 Intervale Rd",
    "parcel_id": "375F-03-00",
    "owner1": "JACOBSON TR, FRANCINE L KAVENOFF",
    "owner2": "",
    "current_taxes": 14441.74,
    "new_taxes_no_override": 15065.62,
    "override_total_1": 15493.1,
    "override_increase_1": 427.48
  },
  {
    "#": "12 Intervale Rd (375C-09-00)",
    "$": 1266600,
    "address": "12 Intervale Rd",
    "parcel_id": "375C-09-00",
    "owner1": "TOW, RANDOLPH B & SUSAN P C",
    "owner2": "",
    "current_taxes": 9335.05,
    "new_taxes_no_override": 9738.32,
    "override_total_1": 10014.64,
    "override_increase_1": 276.32
  },
  {
    "#": "20 Intervale Rd (375C-05-00)",
    "$": 1861400,
    "address": "20 Intervale Rd",
    "parcel_id": "375C-05-00",
    "owner1": "SHAH, ADITYA N & KRETA",
    "owner2": "",
    "current_taxes": 15425.8,
    "new_taxes_no_override": 16092.19,
    "override_total_1": 16548.8,
    "override_increase_1": 456.6
  },
  {
    "#": "26 Intervale Rd (375C-08-00)",
    "$": 2435000,
    "address": "26 Intervale Rd",
    "parcel_id": "375C-08-00",
    "owner1": "MAHADEVIA TRS, ANKIT",
    "owner2": "MEHTA, PUJA",
    "current_taxes": 21299.47,
    "new_taxes_no_override": 22219.61,
    "override_total_1": 22850.07,
    "override_increase_1": 630.46
  },
  {
    "#": "27 Intervale Rd (375F-01-02)",
    "$": 3392300,
    "address": "27 Intervale Rd",
    "parcel_id": "375F-01-02",
    "owner1": "KATWA TRS, UMAKANTH & RESHMA",
    "owner2": "",
    "current_taxes": 31102.22,
    "new_taxes_no_override": 32445.84,
    "override_total_1": 33366.46,
    "override_increase_1": 920.63
  },
  {
    "#": "30 Intervale Rd (375C-07-00)",
    "$": 1080900,
    "address": "30 Intervale Rd",
    "parcel_id": "375C-07-00",
    "owner1": "INBAR, DANIELA FLASH",
    "owner2": "",
    "current_taxes": 11068.42,
    "new_taxes_no_override": 11546.58,
    "override_total_1": 11874.2,
    "override_increase_1": 327.63
  },
  {
    "#": "44 Intervale Rd (375C-06-00)",
    "$": 1869800,
    "address": "44 Intervale Rd",
    "parcel_id": "375C-06-00",
    "owner1": "ZAK TR, LEV",
    "owner2": "",
    "current_taxes": 15511.82,
    "new_taxes_no_override": 16181.93,
    "override_total_1": 16641.08,
    "override_increase_1": 459.15
  },
  {
    "#": "56 Intervale Rd (375D-05-00)",
    "$": 1464100,
    "address": "56 Intervale Rd",
    "parcel_id": "375D-05-00",
    "owner1": "POTENZA, ROBERT & NEENA",
    "owner2": "",
    "current_taxes": 11357.45,
    "new_taxes_no_override": 11848.09,
    "override_total_1": 12184.27,
    "override_increase_1": 336.18
  },
  {
    "#": "5 Irving St, Unit 1 (308-34-01)",
    "$": 889900,
    "address": "5 Irving St, Unit 1",
    "parcel_id": "308-34-01",
    "owner1": "ADAMS, DAVID C",
    "owner2": "TIESZEN, LISA A",
    "current_taxes": 5477.64,
    "new_taxes_no_override": 5714.27,
    "override_total_1": 5876.41,
    "override_increase_1": 162.14
  },
  {
    "#": "5 Irving St, Unit 2 (308-34-02)",
    "$": 935700,
    "address": "5 Irving St, Unit 2",
    "parcel_id": "308-34-02",
    "owner1": "STARK, JAMES",
    "owner2": "CLARK, SUNDAY",
    "current_taxes": 5946.63,
    "new_taxes_no_override": 6203.52,
    "override_total_1": 6379.54,
    "override_increase_1": 176.02
  },
  {
    "#": "5 Irving St, Unit 3 (308-34-03)",
    "$": 1249900,
    "address": "5 Irving St, Unit 3",
    "parcel_id": "308-34-03",
    "owner1": "BAYRAM, GIZEM ACARLAR & ILKER",
    "owner2": "",
    "current_taxes": 9164.04,
    "new_taxes_no_override": 9559.93,
    "override_total_1": 9831.18,
    "override_increase_1": 271.26
  },
  {
    "#": "6 Irving St (313-05-00)",
    "$": 1364700,
    "address": "6 Irving St",
    "parcel_id": "313-05-00",
    "owner1": "MARTIN, PAUL & RHONDA",
    "owner2": "",
    "current_taxes": 10339.59,
    "new_taxes_no_override": 10786.26,
    "override_total_1": 11092.31,
    "override_increase_1": 306.05
  },
  {
    "#": "9 Irving St (308-35-00)",
    "$": 2896900,
    "address": "9 Irving St",
    "parcel_id": "308-35-00",
    "owner1": "LISS-RIORDAN TR, KEVIN",
    "owner2": "",
    "current_taxes": 26029.32,
    "new_taxes_no_override": 27153.79,
    "override_total_1": 27924.25,
    "override_increase_1": 770.47
  },
  {
    "#": "14 Irving St (313-04-00)",
    "$": 2779400,
    "address": "14 Irving St",
    "parcel_id": "313-04-00",
    "owner1": "LI, JIALU",
    "owner2": "HE, JINGKAI",
    "current_taxes": 28461.06,
    "new_taxes_no_override": 29690.58,
    "override_total_1": 30533.03,
    "override_increase_1": 842.45
  },
  {
    "#": "22 Irving St (313-03-00)",
    "$": 4913800,
    "address": "22 Irving St",
    "parcel_id": "313-03-00",
    "owner1": "JOHANNSEN, PETER V & JULIA R",
    "owner2": "",
    "current_taxes": 50317.31,
    "new_taxes_no_override": 52491.02,
    "override_total_1": 53980.41,
    "override_increase_1": 1489.39
  },
  {
    "#": "27 Irving St (312-10-00)",
    "$": 3489800,
    "address": "27 Irving St",
    "parcel_id": "312-10-00",
    "owner1": "NIELSEN, AILEEN A",
    "owner2": "DONG, KEXUN",
    "current_taxes": 32100.62,
    "new_taxes_no_override": 33487.37,
    "override_total_1": 34437.55,
    "override_increase_1": 950.18
  },
  {
    "#": "30 Irving St (313-02-00)",
    "$": 2272800,
    "address": "30 Irving St",
    "parcel_id": "313-02-00",
    "owner1": "PISACICH, SARAH & DAVID",
    "owner2": "",
    "current_taxes": 19638.54,
    "new_taxes_no_override": 20486.92,
    "override_total_1": 21068.23,
    "override_increase_1": 581.3
  },
  {
    "#": "39 Irving St (308-48-00)",
    "$": 4514900,
    "address": "39 Irving St",
    "parcel_id": "308-48-00",
    "owner1": "BERK, EDWARD",
    "owner2": "WEINBERG, NAOMI",
    "current_taxes": 42597.64,
    "new_taxes_no_override": 44437.86,
    "override_total_1": 45698.75,
    "override_increase_1": 1260.89
  },
  {
    "#": "48 Irving St (310-01-00)",
    "$": 2599400,
    "address": "48 Irving St",
    "parcel_id": "310-01-00",
    "owner1": "LATVIAN LUTHERAN EXILE CHURCH",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "55 Irving St (308-49-00)",
    "$": 4616400,
    "address": "55 Irving St",
    "parcel_id": "308-49-00",
    "owner1": "MANN, WILLIAM DAVID",
    "owner2": "",
    "current_taxes": 43637.0,
    "new_taxes_no_override": 45522.12,
    "override_total_1": 46813.77,
    "override_increase_1": 1291.66
  },
  {
    "#": "58 Irving St (310-01-01)",
    "$": 2647900,
    "address": "58 Irving St",
    "parcel_id": "310-01-01",
    "owner1": "LATVIAN LUTHERAN EXILE CHURCH",
    "owner2": "",
    "current_taxes": 10159.85,
    "new_taxes_no_override": 10598.76,
    "override_total_1": 10899.49,
    "override_increase_1": 300.73
  },
  {
    "#": "0 Ivy St (012-01-00)",
    "$": 2670100,
    "address": "0 Ivy St",
    "parcel_id": "012-01-00",
    "owner1": "MASS ASSOC FOR THE BLIND",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "80 Ivy St (001-23-00)",
    "$": 13405200,
    "address": "80 Ivy St",
    "parcel_id": "001-23-00",
    "owner1": "BOSTON UNIVERSITY TRS",
    "owner2": "C/O GENERAL ACCOUNTING 4TH FLR",
    "current_taxes": 137269.25,
    "new_taxes_no_override": 143199.28,
    "override_total_1": 147262.45,
    "override_increase_1": 4063.17
  },
  {
    "#": "83 Ivy St, Unit 11 (002-01-01)",
    "$": 832200,
    "address": "83 Ivy St, Unit 11",
    "parcel_id": "002-01-01",
    "owner1": "RAVUNNIARATH, ATHUL",
    "owner2": "BENSSON-RAVUNNIARATH, MARA",
    "current_taxes": 8521.73,
    "new_taxes_no_override": 8889.87,
    "override_total_1": 9142.11,
    "override_increase_1": 252.24
  },
  {
    "#": "83 Ivy St, Unit 12 (002-01-02)",
    "$": 789000,
    "address": "83 Ivy St, Unit 12",
    "parcel_id": "002-01-02",
    "owner1": "LIN, CHIH-JEN & HUEI HSUAN",
    "owner2": "",
    "current_taxes": 4444.43,
    "new_taxes_no_override": 4636.43,
    "override_total_1": 4767.98,
    "override_increase_1": 131.56
  },
  {
    "#": "83 Ivy St, Unit 13 (002-01-03)",
    "$": 862000,
    "address": "83 Ivy St, Unit 13",
    "parcel_id": "002-01-03",
    "owner1": "JALETTE, RAYMOND",
    "owner2": "PAN, SHAOLIN",
    "current_taxes": 5191.95,
    "new_taxes_no_override": 5416.24,
    "override_total_1": 5569.92,
    "override_increase_1": 153.68
  },
  {
    "#": "83 Ivy St, Unit 14 (002-01-04)",
    "$": 701400,
    "address": "83 Ivy St, Unit 14",
    "parcel_id": "002-01-04",
    "owner1": "MUCHA, CARLOS",
    "owner2": "",
    "current_taxes": 7182.34,
    "new_taxes_no_override": 7492.62,
    "override_total_1": 7705.21,
    "override_increase_1": 212.6
  },
  {
    "#": "83 Ivy St, Unit 21 (002-01-05)",
    "$": 853300,
    "address": "83 Ivy St, Unit 21",
    "parcel_id": "002-01-05",
    "owner1": "LOKSHIN, ABIGAIL",
    "owner2": "",
    "current_taxes": 5102.86,
    "new_taxes_no_override": 5323.3,
    "override_total_1": 5474.35,
    "override_increase_1": 151.04
  },
  {
    "#": "83 Ivy St, Unit 22 (002-01-06)",
    "$": 782900,
    "address": "83 Ivy St, Unit 22",
    "parcel_id": "002-01-06",
    "owner1": "URENECK, LOUIS A",
    "owner2": "",
    "current_taxes": 4381.96,
    "new_taxes_no_override": 4571.26,
    "override_total_1": 4700.97,
    "override_increase_1": 129.71
  },
  {
    "#": "83 Ivy St, Unit 23 (002-01-07)",
    "$": 870200,
    "address": "83 Ivy St, Unit 23",
    "parcel_id": "002-01-07",
    "owner1": "MALTES, JAVIER EDUARDO RAMOS",
    "owner2": "ANDRACA, MONICA CRISTINA OLIVER",
    "current_taxes": 5275.91,
    "new_taxes_no_override": 5503.83,
    "override_total_1": 5660.0,
    "override_increase_1": 156.17
  },
  {
    "#": "83 Ivy St, Unit 24 (002-01-08)",
    "$": 712000,
    "address": "83 Ivy St, Unit 24",
    "parcel_id": "002-01-08",
    "owner1": "TRUSTEES OF BOSTON UNIVERSITY",
    "owner2": "C/O GENERAL ACCOUNTING 4TH FLR",
    "current_taxes": 7290.88,
    "new_taxes_no_override": 7605.85,
    "override_total_1": 7821.66,
    "override_increase_1": 215.81
  },
  {
    "#": "83 Ivy St, Unit 31 (002-01-09)",
    "$": 835800,
    "address": "83 Ivy St, Unit 31",
    "parcel_id": "002-01-09",
    "owner1": "FLOYD TR, JULIET H",
    "owner2": "",
    "current_taxes": 8558.59,
    "new_taxes_no_override": 8928.32,
    "override_total_1": 9181.66,
    "override_increase_1": 253.33
  },
  {
    "#": "83 Ivy St, Unit 32 (002-01-10)",
    "$": 782900,
    "address": "83 Ivy St, Unit 32",
    "parcel_id": "002-01-10",
    "owner1": "BOSTON UNIVERSITY TRS",
    "owner2": "C/O GENERAL ACCOUNTING 4TH FLR",
    "current_taxes": 8016.9,
    "new_taxes_no_override": 8363.23,
    "override_total_1": 8600.53,
    "override_increase_1": 237.3
  },
  {
    "#": "83 Ivy St, Unit 33 (002-01-11)",
    "$": 862000,
    "address": "83 Ivy St, Unit 33",
    "parcel_id": "002-01-11",
    "owner1": "CARROLL, JOHN & TARA",
    "owner2": "",
    "current_taxes": 8826.88,
    "new_taxes_no_override": 9208.2,
    "override_total_1": 9469.48,
    "override_increase_1": 261.28
  },
  {
    "#": "83 Ivy St, Unit 34 (002-01-12)",
    "$": 712000,
    "address": "83 Ivy St, Unit 34",
    "parcel_id": "002-01-12",
    "owner1": "TERRELL, CHARLES",
    "owner2": "",
    "current_taxes": 3655.95,
    "new_taxes_no_override": 3813.89,
    "override_total_1": 3922.1,
    "override_increase_1": 108.22
  },
  {
    "#": "83 Ivy St, Unit 41 (002-01-13)",
    "$": 858300,
    "address": "83 Ivy St, Unit 41",
    "parcel_id": "002-01-13",
    "owner1": "WALKER LIFE ESTATE, JOHN G",
    "owner2": "",
    "current_taxes": 8788.99,
    "new_taxes_no_override": 9168.67,
    "override_total_1": 9428.83,
    "override_increase_1": 260.15
  },
  {
    "#": "83 Ivy St, Unit 42 (002-01-14)",
    "$": 770300,
    "address": "83 Ivy St, Unit 42",
    "parcel_id": "002-01-14",
    "owner1": "CHOBANIAN JR, ARAM V",
    "owner2": "",
    "current_taxes": 4252.94,
    "new_taxes_no_override": 4436.67,
    "override_total_1": 4562.55,
    "override_increase_1": 125.89
  },
  {
    "#": "83 Ivy St, Unit 43 (002-01-15)",
    "$": 901300,
    "address": "83 Ivy St, Unit 43",
    "parcel_id": "002-01-15",
    "owner1": "LIN, KEVIN HAO-YU",
    "owner2": "LI, TRUDY",
    "current_taxes": 9229.31,
    "new_taxes_no_override": 9628.02,
    "override_total_1": 9901.2,
    "override_increase_1": 273.19
  },
  {
    "#": "83 Ivy St, Unit 44 (002-01-16)",
    "$": 743500,
    "address": "83 Ivy St, Unit 44",
    "parcel_id": "002-01-16",
    "owner1": "AFTAHI, KIANA & SHAHAB",
    "owner2": "",
    "current_taxes": 7613.44,
    "new_taxes_no_override": 7942.34,
    "override_total_1": 8167.7,
    "override_increase_1": 225.36
  },
  {
    "#": "83 Ivy St, Unit B-1 (002-01-17)",
    "$": 590700,
    "address": "83 Ivy St, Unit B-1",
    "parcel_id": "002-01-17",
    "owner1": "SAN, DEBRA",
    "owner2": "",
    "current_taxes": 6048.77,
    "new_taxes_no_override": 6310.08,
    "override_total_1": 6489.12,
    "override_increase_1": 179.04
  },
  {
    "#": "87 Ivy St (002-02-00)",
    "$": 2943400,
    "address": "87 Ivy St",
    "parcel_id": "002-02-00",
    "owner1": "WEISEL TR, LAURA",
    "owner2": "",
    "current_taxes": 26505.48,
    "new_taxes_no_override": 27650.52,
    "override_total_1": 28435.08,
    "override_increase_1": 784.56
  },
  {
    "#": "90 Ivy St (001-22-00)",
    "$": 3291200,
    "address": "90 Ivy St",
    "parcel_id": "001-22-00",
    "owner1": "IVY BROOKLINE DEVELOPMENT LLC",
    "owner2": "",
    "current_taxes": 33701.89,
    "new_taxes_no_override": 35157.81,
    "override_total_1": 36155.39,
    "override_increase_1": 997.58
  },
  {
    "#": "93 Ivy St (002-03-00)",
    "$": 4420700,
    "address": "93 Ivy St",
    "parcel_id": "002-03-00",
    "owner1": "MOYER, BENTON L III",
    "owner2": "",
    "current_taxes": 45267.97,
    "new_taxes_no_override": 47223.55,
    "override_total_1": 48563.48,
    "override_increase_1": 1339.93
  },
  {
    "#": "96 Ivy St (001-21-00)",
    "$": 4834400,
    "address": "96 Ivy St",
    "parcel_id": "001-21-00",
    "owner1": "HIRSCH TRS, ANDREW J & ALLISON P",
    "owner2": "",
    "current_taxes": 45869.32,
    "new_taxes_no_override": 47850.87,
    "override_total_1": 49208.61,
    "override_increase_1": 1357.73
  },
  {
    "#": "101 Ivy St (002-04-00)",
    "$": 4296000,
    "address": "101 Ivy St",
    "parcel_id": "002-04-00",
    "owner1": "THORN, JEFFREY G",
    "owner2": "QUASHA, DEVON R",
    "current_taxes": 40356.11,
    "new_taxes_no_override": 42099.49,
    "override_total_1": 43294.03,
    "override_increase_1": 1194.54
  },
  {
    "#": "108 Ivy St (001-20-00)",
    "$": 5099800,
    "address": "108 Ivy St",
    "parcel_id": "001-20-00",
    "owner1": "SOLLAMI, ALFRED & ANNA",
    "owner2": "",
    "current_taxes": 52221.95,
    "new_taxes_no_override": 54477.94,
    "override_total_1": 56023.71,
    "override_increase_1": 1545.77
  },
  {
    "#": "111 Ivy St (002-05-00)",
    "$": 4414700,
    "address": "111 Ivy St",
    "parcel_id": "002-05-00",
    "owner1": "MINSKY, MARVIN L & GLORIA R",
    "owner2": "",
    "current_taxes": 41571.59,
    "new_taxes_no_override": 43367.48,
    "override_total_1": 44598.0,
    "override_increase_1": 1230.52
  },
  {
    "#": "135 Ivy St (003-01-00)",
    "$": 9825600,
    "address": "135 Ivy St",
    "parcel_id": "003-01-00",
    "owner1": "BOSTON UNIVERSITY TRS",
    "owner2": "C/O GENERAL ACCOUNTING 4TH FLR",
    "current_taxes": 100614.14,
    "new_taxes_no_override": 104960.67,
    "override_total_1": 107938.85,
    "override_increase_1": 2978.18
  },
  {
    "#": "156 Ivy St (009-02-00)",
    "$": 7745600,
    "address": "156 Ivy St",
    "parcel_id": "009-02-00",
    "owner1": "MCLOUGHLIN, PETER J",
    "owner2": "",
    "current_taxes": 75680.01,
    "new_taxes_no_override": 78949.39,
    "override_total_1": 81189.51,
    "override_increase_1": 2240.13
  },
  {
    "#": "157 Ivy St (008-03-01)",
    "$": 3234500,
    "address": "157 Ivy St",
    "parcel_id": "008-03-01",
    "owner1": "LANG TR, ELVIRA V",
    "owner2": "",
    "current_taxes": 29486.35,
    "new_taxes_no_override": 30760.16,
    "override_total_1": 31632.96,
    "override_increase_1": 872.8
  },
  {
    "#": "165 Ivy St (008-04-00)",
    "$": 3031900,
    "address": "165 Ivy St",
    "parcel_id": "008-04-00",
    "owner1": "DANE, RONNIE",
    "owner2": "",
    "current_taxes": 31046.66,
    "new_taxes_no_override": 32387.88,
    "override_total_1": 33306.86,
    "override_increase_1": 918.98
  },
  {
    "#": "170 Ivy St (009-01-00)",
    "$": 6000500,
    "address": "170 Ivy St",
    "parcel_id": "009-01-00",
    "owner1": "ROH TR, SHIYOUNG",
    "owner2": "",
    "current_taxes": 57810.19,
    "new_taxes_no_override": 60307.59,
    "override_total_1": 62018.77,
    "override_increase_1": 1711.18
  },
  {
    "#": "178 Ivy St (012-04-01)",
    "$": 4200500,
    "address": "178 Ivy St",
    "parcel_id": "012-04-01",
    "owner1": "DODSON, DAVID & WENDY",
    "owner2": "",
    "current_taxes": 43013.12,
    "new_taxes_no_override": 44871.29,
    "override_total_1": 46144.48,
    "override_increase_1": 1273.19
  },
  {
    "#": "180 Ivy St (012-04-00)",
    "$": 5536500,
    "address": "180 Ivy St",
    "parcel_id": "012-04-00",
    "owner1": "GORDON, LLOYD M & DIANE R",
    "owner2": "C/O AMCEL CENTER",
    "current_taxes": 56693.76,
    "new_taxes_no_override": 59142.93,
    "override_total_1": 60821.07,
    "override_increase_1": 1678.14
  },
  {
    "#": "190 Ivy St (012-02-01)",
    "$": 7115500,
    "address": "190 Ivy St",
    "parcel_id": "012-02-01",
    "owner1": "CALHOUN TR, STEVEN C",
    "owner2": "",
    "current_taxes": 72862.72,
    "new_taxes_no_override": 76010.39,
    "override_total_1": 78167.13,
    "override_increase_1": 2156.74
  },
  {
    "#": "200 Ivy St (012-02-00)",
    "$": 9263800,
    "address": "200 Ivy St",
    "parcel_id": "012-02-00",
    "owner1": "MASS ASSOC FOR THE BLIND",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": " Ivy St (001-19-02)",
    "$": 22900,
    "address": " Ivy St",
    "parcel_id": "001-19-02",
    "owner1": "SOLLAMI, ALFRED & ANNA",
    "owner2": "TEMPEL ET AL, JEAN",
    "current_taxes": 234.5,
    "new_taxes_no_override": 244.63,
    "override_total_1": 251.57,
    "override_increase_1": 6.94
  },
  {
    "#": " Ivy St (001-19-04)",
    "$": 146500,
    "address": " Ivy St",
    "parcel_id": "001-19-04",
    "owner1": "TEMPEL, JEAN C",
    "owner2": "WILSON, PETER A",
    "current_taxes": 1500.16,
    "new_taxes_no_override": 1564.97,
    "override_total_1": 1609.37,
    "override_increase_1": 44.4
  },
  {
    "#": " Ivy St (001-31-02)",
    "$": 77100,
    "address": " Ivy St",
    "parcel_id": "001-31-02",
    "owner1": "SOLLAMI, ALFRED & ANNA",
    "owner2": "",
    "current_taxes": 789.5,
    "new_taxes_no_override": 823.61,
    "override_total_1": 846.98,
    "override_increase_1": 23.37
  },
  {
    "#": "8 Jamaica Rd, Unit 1 (301-23-01)",
    "$": 972600,
    "address": "8 Jamaica Rd, Unit 1",
    "parcel_id": "301-23-01",
    "owner1": "XYPTERAS, TRIANTAFYLOS W",
    "owner2": "",
    "current_taxes": 9959.42,
    "new_taxes_no_override": 10389.67,
    "override_total_1": 10684.47,
    "override_increase_1": 294.8
  },
  {
    "#": "8 Jamaica Rd, Unit 2 (301-23-02)",
    "$": 813100,
    "address": "8 Jamaica Rd, Unit 2",
    "parcel_id": "301-23-02",
    "owner1": "XYPTERAS, TRIANTAFYLOS G",
    "owner2": "",
    "current_taxes": 8326.14,
    "new_taxes_no_override": 8685.83,
    "override_total_1": 8932.28,
    "override_increase_1": 246.45
  },
  {
    "#": "8 Jamaica Rd, Unit 3 (301-23-03)",
    "$": 812700,
    "address": "8 Jamaica Rd, Unit 3",
    "parcel_id": "301-23-03",
    "owner1": "XYPTERAS, GEORGE",
    "owner2": "",
    "current_taxes": 8322.05,
    "new_taxes_no_override": 8681.56,
    "override_total_1": 8927.9,
    "override_increase_1": 246.33
  },
  {
    "#": "12 Jamaica Rd (301-22-00)",
    "$": 2087900,
    "address": "12 Jamaica Rd",
    "parcel_id": "301-22-00",
    "owner1": "MORONEY TRS, FRANCIS M",
    "owner2": "BERNARD, MARK",
    "current_taxes": 17745.16,
    "new_taxes_no_override": 18511.75,
    "override_total_1": 19037.01,
    "override_increase_1": 525.26
  },
  {
    "#": "16 Jamaica Rd (301-21-00)",
    "$": 2495200,
    "address": "16 Jamaica Rd",
    "parcel_id": "301-21-00",
    "owner1": "OLEARY LIFE ESTATE, GEORGE J & PHYLLIS R",
    "owner2": "",
    "current_taxes": 21915.91,
    "new_taxes_no_override": 22862.68,
    "override_total_1": 23511.39,
    "override_increase_1": 648.71
  },
  {
    "#": "20 Jamaica Rd, Unit 1 (301-20-01)",
    "$": 952200,
    "address": "20 Jamaica Rd, Unit 1",
    "parcel_id": "301-20-01",
    "owner1": "CHOI, DAVID S",
    "owner2": "KIM, YOUNG MI",
    "current_taxes": 9750.53,
    "new_taxes_no_override": 10171.75,
    "override_total_1": 10460.37,
    "override_increase_1": 288.62
  },
  {
    "#": "20 Jamaica Rd, Unit 2 (301-20-02)",
    "$": 976100,
    "address": "20 Jamaica Rd, Unit 2",
    "parcel_id": "301-20-02",
    "owner1": "RABRENOVIC ET AL, GORDANA",
    "owner2": "PIERCE, GLENN L",
    "current_taxes": 6360.33,
    "new_taxes_no_override": 6635.1,
    "override_total_1": 6823.36,
    "override_increase_1": 188.27
  },
  {
    "#": "20 Jamaica Rd, Unit 3 (301-20-03)",
    "$": 1032700,
    "address": "20 Jamaica Rd, Unit 3",
    "parcel_id": "301-20-03",
    "owner1": "BLESSEN, CHRISTOPHER D & ALLISON K",
    "owner2": "",
    "current_taxes": 6939.91,
    "new_taxes_no_override": 7239.71,
    "override_total_1": 7445.14,
    "override_increase_1": 205.42
  },
  {
    "#": "22 Jamaica Rd (301-19-00)",
    "$": 1645100,
    "address": "22 Jamaica Rd",
    "parcel_id": "301-19-00",
    "owner1": "LU, JIE",
    "owner2": "",
    "current_taxes": 16845.82,
    "new_taxes_no_override": 17573.56,
    "override_total_1": 18072.2,
    "override_increase_1": 498.64
  },
  {
    "#": "26 Jamaica Rd (301-18-00)",
    "$": 2039800,
    "address": "26 Jamaica Rd",
    "parcel_id": "301-18-00",
    "owner1": "DALEY, WILLIAM E & JOYCE K",
    "owner2": "",
    "current_taxes": 20887.55,
    "new_taxes_no_override": 21789.89,
    "override_total_1": 22408.16,
    "override_increase_1": 618.27
  },
  {
    "#": "30 Jamaica Rd (301-17-00)",
    "$": 2097100,
    "address": "30 Jamaica Rd",
    "parcel_id": "301-17-00",
    "owner1": "LIU, JUN",
    "owner2": "ZHANG, QUN",
    "current_taxes": 21474.3,
    "new_taxes_no_override": 22401.99,
    "override_total_1": 23037.63,
    "override_increase_1": 635.64
  },
  {
    "#": "34 Jamaica Rd (301-16-00)",
    "$": 3871100,
    "address": "34 Jamaica Rd",
    "parcel_id": "301-16-00",
    "owner1": "YEO, BEE",
    "owner2": "",
    "current_taxes": 39640.06,
    "new_taxes_no_override": 41352.51,
    "override_total_1": 42525.86,
    "override_increase_1": 1173.35
  },
  {
    "#": "36 Jamaica Rd (301-13-01)",
    "$": 24600,
    "address": "36 Jamaica Rd",
    "parcel_id": "301-13-01",
    "owner1": "BROOKLINE HOUSING AUTHORITY",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "38 Jamaica Rd (301-12-00)",
    "$": 1897300,
    "address": "38 Jamaica Rd",
    "parcel_id": "301-12-00",
    "owner1": "PENDER TRS, PAUL R JR",
    "owner2": "MCCAFFREY, JOYCE A",
    "current_taxes": 19428.35,
    "new_taxes_no_override": 20267.65,
    "override_total_1": 20842.73,
    "override_increase_1": 575.08
  },
  {
    "#": "40 Jamaica Rd (301-13-00)",
    "$": 81900,
    "address": "40 Jamaica Rd",
    "parcel_id": "301-13-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O VACANT PARCEL/REAR 38 JAMAICA",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "42 Jamaica Rd, Unit 1 (301-11-01)",
    "$": 779700,
    "address": "42 Jamaica Rd, Unit 1",
    "parcel_id": "301-11-01",
    "owner1": "RIEDER, VICKI A",
    "owner2": "",
    "current_taxes": 4349.19,
    "new_taxes_no_override": 4537.08,
    "override_total_1": 4665.81,
    "override_increase_1": 128.74
  },
  {
    "#": "42 Jamaica Rd, Unit 2 (301-11-02)",
    "$": 779800,
    "address": "42 Jamaica Rd, Unit 2",
    "parcel_id": "301-11-02",
    "owner1": "GROSSMAN, PERRY",
    "owner2": "JAMES, CARRIE F",
    "current_taxes": 4350.22,
    "new_taxes_no_override": 4538.15,
    "override_total_1": 4666.92,
    "override_increase_1": 128.77
  },
  {
    "#": "42 Jamaica Rd, Unit 3 (301-11-03)",
    "$": 825200,
    "address": "42 Jamaica Rd, Unit 3",
    "parcel_id": "301-11-03",
    "owner1": "SHIH, TING YU",
    "owner2": "",
    "current_taxes": 4815.11,
    "new_taxes_no_override": 5023.12,
    "override_total_1": 5165.65,
    "override_increase_1": 142.53
  },
  {
    "#": "46 Jamaica Rd, Unit 1 (301-10-01)",
    "$": 1309600,
    "address": "46 Jamaica Rd, Unit 1",
    "parcel_id": "301-10-01",
    "owner1": "HEWITT, MICHAEL",
    "owner2": "PERLSTEIN, DEBORAH",
    "current_taxes": 9775.37,
    "new_taxes_no_override": 10197.67,
    "override_total_1": 10487.02,
    "override_increase_1": 289.35
  },
  {
    "#": "46 Jamaica Rd, Unit 2 (301-10-02)",
    "$": 1551100,
    "address": "46 Jamaica Rd, Unit 2",
    "parcel_id": "301-10-02",
    "owner1": "FEN, ALLEN MING",
    "owner2": "BIERLY, KELLY",
    "current_taxes": 12248.33,
    "new_taxes_no_override": 12777.46,
    "override_total_1": 13140.01,
    "override_increase_1": 362.55
  },
  {
    "#": "48 Jamaica Rd, Unit 1 (301-09-01)",
    "$": 1344000,
    "address": "48 Jamaica Rd, Unit 1",
    "parcel_id": "301-09-01",
    "owner1": "TIAN, FU",
    "owner2": "GUO, XIN LI",
    "current_taxes": 10127.63,
    "new_taxes_no_override": 10565.14,
    "override_total_1": 10864.92,
    "override_increase_1": 299.78
  },
  {
    "#": "48 Jamaica Rd, Unit 2 (301-09-02)",
    "$": 1073800,
    "address": "48 Jamaica Rd, Unit 2",
    "parcel_id": "301-09-02",
    "owner1": "NARENKIVICIUS, PAULA",
    "owner2": "",
    "current_taxes": 7360.78,
    "new_taxes_no_override": 7678.77,
    "override_total_1": 7896.64,
    "override_increase_1": 217.88
  },
  {
    "#": "48 Jamaica Rd, Unit 3 (301-09-03)",
    "$": 1295700,
    "address": "48 Jamaica Rd, Unit 3",
    "parcel_id": "301-09-03",
    "owner1": "KAO, AUDREY",
    "owner2": "TAI, TARA",
    "current_taxes": 13267.97,
    "new_taxes_no_override": 13841.15,
    "override_total_1": 14233.88,
    "override_increase_1": 392.73
  },
  {
    "#": "52 Jamaica Rd (301-08-00)",
    "$": 2902200,
    "address": "52 Jamaica Rd",
    "parcel_id": "301-08-00",
    "owner1": "VITORINO, THERESA & JASON",
    "owner2": "",
    "current_taxes": 26083.59,
    "new_taxes_no_override": 27210.4,
    "override_total_1": 27982.48,
    "override_increase_1": 772.07
  },
  {
    "#": "58 Jamaica Rd, Unit 1 (301-07-01)",
    "$": 719600,
    "address": "58 Jamaica Rd, Unit 1",
    "parcel_id": "301-07-01",
    "owner1": "SILLS, JONATHAN",
    "owner2": "MCCLEARY, SANDRA",
    "current_taxes": 7368.7,
    "new_taxes_no_override": 7687.03,
    "override_total_1": 7905.14,
    "override_increase_1": 218.11
  },
  {
    "#": "58 Jamaica Rd, Unit 2 (301-07-02)",
    "$": 719600,
    "address": "58 Jamaica Rd, Unit 2",
    "parcel_id": "301-07-02",
    "owner1": "REGULE, TEVA",
    "owner2": "",
    "current_taxes": 3733.77,
    "new_taxes_no_override": 3895.07,
    "override_total_1": 4005.59,
    "override_increase_1": 110.52
  },
  {
    "#": "58 Jamaica Rd, Unit 3 (301-07-03)",
    "$": 729800,
    "address": "58 Jamaica Rd, Unit 3",
    "parcel_id": "301-07-03",
    "owner1": "LAWRENCE, MARGARET",
    "owner2": "",
    "current_taxes": 3838.22,
    "new_taxes_no_override": 4004.03,
    "override_total_1": 4117.64,
    "override_increase_1": 113.61
  },
  {
    "#": "60 Jamaica Rd (301-06-00)",
    "$": 1651000,
    "address": "60 Jamaica Rd",
    "parcel_id": "301-06-00",
    "owner1": "GUO, WEN YAN",
    "owner2": "",
    "current_taxes": 16906.24,
    "new_taxes_no_override": 17636.59,
    "override_total_1": 18137.01,
    "override_increase_1": 500.42
  },
  {
    "#": "66 Jamaica Rd, Unit 1 (301-05-01)",
    "$": 783100,
    "address": "66 Jamaica Rd, Unit 1",
    "parcel_id": "301-05-01",
    "owner1": "PEKKANEN TR, JENNIE D",
    "owner2": "",
    "current_taxes": 8018.94,
    "new_taxes_no_override": 8365.36,
    "override_total_1": 8602.72,
    "override_increase_1": 237.36
  },
  {
    "#": "66 Jamaica Rd, Unit 2 (301-05-02)",
    "$": 805700,
    "address": "66 Jamaica Rd, Unit 2",
    "parcel_id": "301-05-02",
    "owner1": "PEKKANEN TR, DAVID J",
    "owner2": "",
    "current_taxes": 8250.37,
    "new_taxes_no_override": 8606.79,
    "override_total_1": 8851.0,
    "override_increase_1": 244.21
  },
  {
    "#": "66 Jamaica Rd, Unit 3 (301-05-03)",
    "$": 805700,
    "address": "66 Jamaica Rd, Unit 3",
    "parcel_id": "301-05-03",
    "owner1": "XYPTERAS, TRIANTAFYLOS G",
    "owner2": "",
    "current_taxes": 8250.37,
    "new_taxes_no_override": 8606.79,
    "override_total_1": 8851.0,
    "override_increase_1": 244.21
  },
  {
    "#": "68 Jamaica Rd (301-04-00)",
    "$": 2212900,
    "address": "68 Jamaica Rd",
    "parcel_id": "301-04-00",
    "owner1": "NELSON, CAROL S",
    "owner2": "SCHAFFER TRS, CHERYL & JANET E",
    "current_taxes": 19025.16,
    "new_taxes_no_override": 19847.05,
    "override_total_1": 20410.19,
    "override_increase_1": 563.14
  },
  {
    "#": "5 James St (043-15-00)",
    "$": 1221000,
    "address": "5 James St",
    "parcel_id": "043-15-00",
    "owner1": "WONG TR, ROBERT W",
    "owner2": "C/O MARY Y WONG MGR",
    "current_taxes": 20952.36,
    "new_taxes_no_override": 21857.5,
    "override_total_1": 22477.69,
    "override_increase_1": 620.19
  },
  {
    "#": "9 James St (043-16-00)",
    "$": 4999900,
    "address": "9 James St",
    "parcel_id": "043-16-00",
    "owner1": "SYNH LLC",
    "owner2": "",
    "current_taxes": 51198.98,
    "new_taxes_no_override": 53410.78,
    "override_total_1": 54926.27,
    "override_increase_1": 1515.49
  },
  {
    "#": "12 James St, Unit 12-1 (044-08-02)",
    "$": 725000,
    "address": "12 James St, Unit 12-1",
    "parcel_id": "044-08-02",
    "owner1": "YIP TRS, WAI KI & ELAINE",
    "owner2": "",
    "current_taxes": 3789.07,
    "new_taxes_no_override": 3952.76,
    "override_total_1": 4064.91,
    "override_increase_1": 112.16
  },
  {
    "#": "12 James St, Unit 12-2 (044-08-03)",
    "$": 738200,
    "address": "12 James St, Unit 12-2",
    "parcel_id": "044-08-03",
    "owner1": "ALMOZLINO, ELLIAT",
    "owner2": "",
    "current_taxes": 7559.17,
    "new_taxes_no_override": 7885.73,
    "override_total_1": 8109.48,
    "override_increase_1": 223.75
  },
  {
    "#": "12 James St, Unit 12-3 (044-08-04)",
    "$": 784500,
    "address": "12 James St, Unit 12-3",
    "parcel_id": "044-08-04",
    "owner1": "SHAO, JIAYANG",
    "owner2": "",
    "current_taxes": 8033.28,
    "new_taxes_no_override": 8380.32,
    "override_total_1": 8618.1,
    "override_increase_1": 237.79
  },
  {
    "#": "12 James St, Unit 12-B (044-08-01)",
    "$": 568600,
    "address": "12 James St, Unit 12-B",
    "parcel_id": "044-08-01",
    "owner1": "BAKER, MICHAEL",
    "owner2": "JOHNSON, KELLI RAE",
    "current_taxes": 5822.46,
    "new_taxes_no_override": 6073.99,
    "override_total_1": 6246.34,
    "override_increase_1": 172.34
  },
  {
    "#": "14 James St, Unit 14-1 (044-08-05)",
    "$": 703200,
    "address": "14 James St, Unit 14-1",
    "parcel_id": "044-08-05",
    "owner1": "JHAVERI-SCHNEIDER, SONAL",
    "owner2": "",
    "current_taxes": 7200.77,
    "new_taxes_no_override": 7511.84,
    "override_total_1": 7724.99,
    "override_increase_1": 213.14
  },
  {
    "#": "14 James St, Unit 14-2 (044-08-06)",
    "$": 772900,
    "address": "14 James St, Unit 14-2",
    "parcel_id": "044-08-06",
    "owner1": "SUTTIN, ADAM & HOPE",
    "owner2": "",
    "current_taxes": 7914.5,
    "new_taxes_no_override": 8256.41,
    "override_total_1": 8490.68,
    "override_increase_1": 234.27
  },
  {
    "#": "14 James St, Unit 14-3 (044-08-07)",
    "$": 819800,
    "address": "14 James St, Unit 14-3",
    "parcel_id": "044-08-07",
    "owner1": "DBF FREEMAN PROPERTY MANAGEMENT LLC",
    "owner2": "",
    "current_taxes": 8394.75,
    "new_taxes_no_override": 8757.4,
    "override_total_1": 9005.89,
    "override_increase_1": 248.48
  },
  {
    "#": "14 James St, Unit 14-4 (044-08-08)",
    "$": 772800,
    "address": "14 James St, Unit 14-4",
    "parcel_id": "044-08-08",
    "owner1": "BORODIN, ALEXEI",
    "owner2": "",
    "current_taxes": 7913.47,
    "new_taxes_no_override": 8255.33,
    "override_total_1": 8489.57,
    "override_increase_1": 234.24
  },
  {
    "#": "14 James St, Unit 14-5 (044-08-09)",
    "$": 766600,
    "address": "14 James St, Unit 14-5",
    "parcel_id": "044-08-09",
    "owner1": "QIAN, JINGYI & SHUNBIAO",
    "owner2": "WANG, ZHONGQIN",
    "current_taxes": 4215.05,
    "new_taxes_no_override": 4397.14,
    "override_total_1": 4521.91,
    "override_increase_1": 124.77
  },
  {
    "#": "14 James St, Unit 14-6 (044-08-10)",
    "$": 780400,
    "address": "14 James St, Unit 14-6",
    "parcel_id": "044-08-10",
    "owner1": "LULL, PAIGE",
    "owner2": "",
    "current_taxes": 4356.36,
    "new_taxes_no_override": 4544.55,
    "override_total_1": 4673.5,
    "override_increase_1": 128.95
  },
  {
    "#": "15 James St, Unit 2 (043-17-01)",
    "$": 1515700,
    "address": "15 James St, Unit 2",
    "parcel_id": "043-17-01",
    "owner1": "SCHEIDE, TR, IRIS MAUDINE",
    "owner2": "",
    "current_taxes": 15520.77,
    "new_taxes_no_override": 16191.27,
    "override_total_1": 16650.68,
    "override_increase_1": 459.41
  },
  {
    "#": "15 James St, Unit 4 (043-17-03)",
    "$": 1579800,
    "address": "15 James St, Unit 4",
    "parcel_id": "043-17-03",
    "owner1": "SLAMA, JAROMIR",
    "owner2": "GREEN, JULIE",
    "current_taxes": 12542.22,
    "new_taxes_no_override": 13084.04,
    "override_total_1": 13455.29,
    "override_increase_1": 371.25
  },
  {
    "#": "15 James St, Unit 6 (043-17-05)",
    "$": 1545300,
    "address": "15 James St, Unit 6",
    "parcel_id": "043-17-05",
    "owner1": "DAVIS, ALBERT N",
    "owner2": "FRIEDMAN, R S",
    "current_taxes": 12188.94,
    "new_taxes_no_override": 12715.5,
    "override_total_1": 13076.29,
    "override_increase_1": 360.79
  },
  {
    "#": "15 James St, Unit 7 (043-17-06)",
    "$": 616200,
    "address": "15 James St, Unit 7",
    "parcel_id": "043-17-06",
    "owner1": "SCHILLING, ZACHARY P",
    "owner2": "",
    "current_taxes": 2674.95,
    "new_taxes_no_override": 2790.51,
    "override_total_1": 2869.69,
    "override_increase_1": 79.18
  },
  {
    "#": "17 James St, Unit 1 (043-17-07)",
    "$": 1518900,
    "address": "17 James St, Unit 1",
    "parcel_id": "043-17-07",
    "owner1": "BACOW, LAWRENCE & ADELE FLEET",
    "owner2": "",
    "current_taxes": 15553.54,
    "new_taxes_no_override": 16225.45,
    "override_total_1": 16685.84,
    "override_increase_1": 460.38
  },
  {
    "#": "17 James St, Unit 3 (043-17-02)",
    "$": 1580400,
    "address": "17 James St, Unit 3",
    "parcel_id": "043-17-02",
    "owner1": "BROWN, ELEANOR",
    "owner2": "",
    "current_taxes": 16183.3,
    "new_taxes_no_override": 16882.42,
    "override_total_1": 17361.44,
    "override_increase_1": 479.03
  },
  {
    "#": "17 James St, Unit 5 (043-17-04)",
    "$": 1574700,
    "address": "17 James St, Unit 5",
    "parcel_id": "043-17-04",
    "owner1": "DONNELLY, ROBERT J",
    "owner2": "COLLINS, TARA A",
    "current_taxes": 12489.99,
    "new_taxes_no_override": 13029.56,
    "override_total_1": 13399.26,
    "override_increase_1": 369.7
  },
  {
    "#": "19 James St (043-18-00)",
    "$": 5545600,
    "address": "19 James St",
    "parcel_id": "043-18-00",
    "owner1": "19-21 JAMES STREET LLC",
    "owner2": "C/O CARL CHAN",
    "current_taxes": 56786.94,
    "new_taxes_no_override": 59240.14,
    "override_total_1": 60921.03,
    "override_increase_1": 1680.89
  },
  {
    "#": "22 James St, Unit 1 (044-07-02)",
    "$": 957600,
    "address": "22 James St, Unit 1",
    "parcel_id": "044-07-02",
    "owner1": "BLANEY TRS, PAUL H & NANCY T",
    "owner2": "",
    "current_taxes": 6170.89,
    "new_taxes_no_override": 6437.47,
    "override_total_1": 6620.13,
    "override_increase_1": 182.66
  },
  {
    "#": "22 James St, Unit 2 & P8 (044-07-03)",
    "$": 854900,
    "address": "22 James St, Unit 2 & P8",
    "parcel_id": "044-07-03",
    "owner1": "RABINOVITZ, ZORI & INBAL",
    "owner2": "",
    "current_taxes": 8754.18,
    "new_taxes_no_override": 9132.36,
    "override_total_1": 9391.48,
    "override_increase_1": 259.12
  },
  {
    "#": "22 James St, Unit 22A (044-07-01)",
    "$": 940400,
    "address": "22 James St, Unit 22A",
    "parcel_id": "044-07-01",
    "owner1": "KIM, TAEYOUNG",
    "owner2": "HUH, JINI",
    "current_taxes": 9629.7,
    "new_taxes_no_override": 10045.7,
    "override_total_1": 10330.74,
    "override_increase_1": 285.04
  },
  {
    "#": "22 James St, Unit 3 (044-07-04)",
    "$": 993400,
    "address": "22 James St, Unit 3",
    "parcel_id": "044-07-04",
    "owner1": "CASORIO, CHRISTOPHER",
    "owner2": "",
    "current_taxes": 6537.48,
    "new_taxes_no_override": 6819.9,
    "override_total_1": 7013.41,
    "override_increase_1": 193.51
  },
  {
    "#": "22 James St, Unit 4 (044-07-05)",
    "$": 980500,
    "address": "22 James St, Unit 4",
    "parcel_id": "044-07-05",
    "owner1": "ERSLAND TRS, PAUL & MARY",
    "owner2": "",
    "current_taxes": 10040.32,
    "new_taxes_no_override": 10474.06,
    "override_total_1": 10771.26,
    "override_increase_1": 297.19
  },
  {
    "#": "22 James St, Unit 5 & P4 P5 (044-07-06)",
    "$": 1055600,
    "address": "22 James St, Unit 5 & P4 P5",
    "parcel_id": "044-07-06",
    "owner1": "NI, YIHONG & BIAO",
    "owner2": "",
    "current_taxes": 7174.41,
    "new_taxes_no_override": 7484.34,
    "override_total_1": 7696.71,
    "override_increase_1": 212.36
  },
  {
    "#": "22 James St, Unit 6 (044-07-07)",
    "$": 1012500,
    "address": "22 James St, Unit 6",
    "parcel_id": "044-07-07",
    "owner1": "THOMPSON, LADORA V",
    "owner2": "",
    "current_taxes": 6733.07,
    "new_taxes_no_override": 7023.94,
    "override_total_1": 7223.24,
    "override_increase_1": 199.3
  },
  {
    "#": "27 James St, Unit 27-1 (043-19-02)",
    "$": 1161800,
    "address": "27 James St, Unit 27-1",
    "parcel_id": "043-19-02",
    "owner1": "MCMAHON, CHRISTIAN A",
    "owner2": "FAHMY, SUSAN L",
    "current_taxes": 8261.9,
    "new_taxes_no_override": 8618.81,
    "override_total_1": 8863.37,
    "override_increase_1": 244.55
  },
  {
    "#": "27 James St, Unit 27-2 (043-19-03)",
    "$": 1209400,
    "address": "27 James St, Unit 27-2",
    "parcel_id": "043-19-03",
    "owner1": "SHEN, HOWARD I",
    "owner2": "CHUNG, SARITA A",
    "current_taxes": 8749.32,
    "new_taxes_no_override": 9127.29,
    "override_total_1": 9386.27,
    "override_increase_1": 258.98
  },
  {
    "#": "27 James St, Unit 27-3 (043-19-04)",
    "$": 1209400,
    "address": "27 James St, Unit 27-3",
    "parcel_id": "043-19-04",
    "owner1": "SAXENA, SAPNA",
    "owner2": "",
    "current_taxes": 12384.26,
    "new_taxes_no_override": 12919.26,
    "override_total_1": 13285.83,
    "override_increase_1": 366.57
  },
  {
    "#": "27 James St, Unit 27-4 (043-19-05)",
    "$": 1128700,
    "address": "27 James St, Unit 27-4",
    "parcel_id": "043-19-05",
    "owner1": "WOLFSDORF TR, JACK",
    "owner2": "",
    "current_taxes": 11557.89,
    "new_taxes_no_override": 12057.19,
    "override_total_1": 12399.3,
    "override_increase_1": 342.11
  },
  {
    "#": "27 James St, Unit 27-5 (043-19-06)",
    "$": 1178300,
    "address": "27 James St, Unit 27-5",
    "parcel_id": "043-19-06",
    "owner1": "PARK, KEE B & SUSAN K",
    "owner2": "",
    "current_taxes": 8430.86,
    "new_taxes_no_override": 8795.07,
    "override_total_1": 9044.63,
    "override_increase_1": 249.55
  },
  {
    "#": "27 James St, Unit 27-6 (043-19-07)",
    "$": 1178400,
    "address": "27 James St, Unit 27-6",
    "parcel_id": "043-19-07",
    "owner1": "CHAKRABARTI, MEGHNA",
    "owner2": "",
    "current_taxes": 8431.88,
    "new_taxes_no_override": 8796.14,
    "override_total_1": 9045.72,
    "override_increase_1": 249.58
  },
  {
    "#": "27 James St, Unit 27-B (043-19-01)",
    "$": 952900,
    "address": "27 James St, Unit 27-B",
    "parcel_id": "043-19-01",
    "owner1": "SPECTOR, JOSHUA J",
    "owner2": "",
    "current_taxes": 9757.7,
    "new_taxes_no_override": 10179.23,
    "override_total_1": 10468.06,
    "override_increase_1": 288.83
  },
  {
    "#": "28 James St, Unit 28-1 (044-06-02)",
    "$": 575500,
    "address": "28 James St, Unit 28-1",
    "parcel_id": "044-06-02",
    "owner1": "DONAHUE, ROBERT",
    "owner2": "",
    "current_taxes": 5893.12,
    "new_taxes_no_override": 6147.7,
    "override_total_1": 6322.14,
    "override_increase_1": 174.44
  },
  {
    "#": "28 James St, Unit 28-2 (044-06-03)",
    "$": 700400,
    "address": "28 James St, Unit 28-2",
    "parcel_id": "044-06-03",
    "owner1": "BERNSTEIN, SHARON",
    "owner2": "",
    "current_taxes": 3537.16,
    "new_taxes_no_override": 3689.97,
    "override_total_1": 3794.67,
    "override_increase_1": 104.7
  },
  {
    "#": "28 James St, Unit 28-3 (044-06-04)",
    "$": 711200,
    "address": "28 James St, Unit 28-3",
    "parcel_id": "044-06-04",
    "owner1": "CASTRONUOVO, LYNNE A",
    "owner2": "HELLENDRUNG, JASON",
    "current_taxes": 7282.69,
    "new_taxes_no_override": 7597.3,
    "override_total_1": 7812.87,
    "override_increase_1": 215.57
  },
  {
    "#": "28 James St, Unit 28-B (044-06-01)",
    "$": 597300,
    "address": "28 James St, Unit 28-B",
    "parcel_id": "044-06-01",
    "owner1": "PAUL, RHEA",
    "owner2": "",
    "current_taxes": 2481.42,
    "new_taxes_no_override": 2588.62,
    "override_total_1": 2662.07,
    "override_increase_1": 73.45
  },
  {
    "#": "31 James St, Unit 31-1 (043-19-08)",
    "$": 1090900,
    "address": "31 James St, Unit 31-1",
    "parcel_id": "043-19-08",
    "owner1": "HUMBLIAS, GEORGE J & NICOLE K",
    "owner2": "",
    "current_taxes": 7535.88,
    "new_taxes_no_override": 7861.43,
    "override_total_1": 8084.49,
    "override_increase_1": 223.06
  },
  {
    "#": "31 James St, Unit 31-2 (043-19-09)",
    "$": 1174200,
    "address": "31 James St, Unit 31-2",
    "parcel_id": "043-19-09",
    "owner1": "CAINE, BRENDAN",
    "owner2": "CINO, DIANA",
    "current_taxes": 12023.81,
    "new_taxes_no_override": 12543.24,
    "override_total_1": 12899.14,
    "override_increase_1": 355.9
  },
  {
    "#": "31 James St, Unit 31-3 (043-19-10)",
    "$": 1174200,
    "address": "31 James St, Unit 31-3",
    "parcel_id": "043-19-10",
    "owner1": "HELLENDRUNG, JASON",
    "owner2": "CASTRONUOVO, LYNNE A",
    "current_taxes": 12023.81,
    "new_taxes_no_override": 12543.24,
    "override_total_1": 12899.14,
    "override_increase_1": 355.9
  },
  {
    "#": "32 James St, Unit 32-1 (044-06-05)",
    "$": 808300,
    "address": "32 James St, Unit 32-1",
    "parcel_id": "044-06-05",
    "owner1": "H J R REALTY LLC",
    "owner2": "",
    "current_taxes": 4642.06,
    "new_taxes_no_override": 4842.6,
    "override_total_1": 4980.0,
    "override_increase_1": 137.4
  },
  {
    "#": "32 James St, Unit 32-2 (044-06-06)",
    "$": 792700,
    "address": "32 James St, Unit 32-2",
    "parcel_id": "044-06-06",
    "owner1": "TACKNEY, ERIN",
    "owner2": "PAETSCH, CHRISTOPHER",
    "current_taxes": 4482.31,
    "new_taxes_no_override": 4675.95,
    "override_total_1": 4808.62,
    "override_increase_1": 132.68
  },
  {
    "#": "32 James St, Unit 32-3 (044-06-07)",
    "$": 802100,
    "address": "32 James St, Unit 32-3",
    "parcel_id": "044-06-07",
    "owner1": "ZHU, FENG",
    "owner2": "YANG, ZAIHAN",
    "current_taxes": 4578.57,
    "new_taxes_no_override": 4776.36,
    "override_total_1": 4911.89,
    "override_increase_1": 135.53
  },
  {
    "#": "32 James St, Unit 32-4 (044-06-08)",
    "$": 802000,
    "address": "32 James St, Unit 32-4",
    "parcel_id": "044-06-08",
    "owner1": "YENG, YI XIANG",
    "owner2": "",
    "current_taxes": 8212.48,
    "new_taxes_no_override": 8567.26,
    "override_total_1": 8810.35,
    "override_increase_1": 243.09
  },
  {
    "#": "32 James St, Unit 32-5 (044-06-09)",
    "$": 792700,
    "address": "32 James St, Unit 32-5",
    "parcel_id": "044-06-09",
    "owner1": "CHOWDHURY, ALEXANDER",
    "owner2": "XUE, JING",
    "current_taxes": 4482.31,
    "new_taxes_no_override": 4675.95,
    "override_total_1": 4808.62,
    "override_increase_1": 132.68
  },
  {
    "#": "32 James St, Unit 32-6 (044-06-10)",
    "$": 802000,
    "address": "32 James St, Unit 32-6",
    "parcel_id": "044-06-10",
    "owner1": "LIANG TRS, JASON & YUANHENG",
    "owner2": "",
    "current_taxes": 4577.55,
    "new_taxes_no_override": 4775.3,
    "override_total_1": 4910.8,
    "override_increase_1": 135.5
  },
  {
    "#": "5 Jefferson Rd (436-03-04)",
    "$": 1962100,
    "address": "5 Jefferson Rd",
    "parcel_id": "436-03-04",
    "owner1": "RASTOGI, ANISH",
    "owner2": "VYAS, HARSHA",
    "current_taxes": 16456.97,
    "new_taxes_no_override": 17167.91,
    "override_total_1": 17655.04,
    "override_increase_1": 487.13
  },
  {
    "#": "13 Jefferson Rd (436-05-00)",
    "$": 3223500,
    "address": "13 Jefferson Rd",
    "parcel_id": "436-05-00",
    "owner1": "HARMON TRS, WILLIAM E",
    "owner2": "SCHWEITZER, DIANE J",
    "current_taxes": 29373.71,
    "new_taxes_no_override": 30642.65,
    "override_total_1": 31512.12,
    "override_increase_1": 869.46
  },
  {
    "#": "14 Jefferson Rd (437-01-00)",
    "$": 3292400,
    "address": "14 Jefferson Rd",
    "parcel_id": "437-01-00",
    "owner1": "BAE, DONALD S",
    "owner2": "CHUNG, JEANNIE H",
    "current_taxes": 30079.24,
    "new_taxes_no_override": 31378.66,
    "override_total_1": 32269.01,
    "override_increase_1": 890.35
  },
  {
    "#": "24 Jefferson Rd (437-74-00)",
    "$": 2296500,
    "address": "24 Jefferson Rd",
    "parcel_id": "437-74-00",
    "owner1": "KARCHMER TRS, MAURICIO",
    "owner2": "STEIN, E K",
    "current_taxes": 19881.23,
    "new_taxes_no_override": 20740.1,
    "override_total_1": 21328.58,
    "override_increase_1": 588.48
  },
  {
    "#": "25 Jefferson Rd (436-06-00)",
    "$": 3544200,
    "address": "25 Jefferson Rd",
    "parcel_id": "436-06-00",
    "owner1": "MURPHY, DAVID L",
    "owner2": "EVANS, WENDY A",
    "current_taxes": 36292.61,
    "new_taxes_no_override": 37860.45,
    "override_total_1": 38934.71,
    "override_increase_1": 1074.26
  },
  {
    "#": "35 Jefferson Rd (436-07-00)",
    "$": 2493000,
    "address": "35 Jefferson Rd",
    "parcel_id": "436-07-00",
    "owner1": "ROYAL TEMPLE LLC",
    "owner2": "",
    "current_taxes": 21893.39,
    "new_taxes_no_override": 22839.18,
    "override_total_1": 23487.23,
    "override_increase_1": 648.04
  },
  {
    "#": "36 Jefferson Rd (437-73-00)",
    "$": 3225800,
    "address": "36 Jefferson Rd",
    "parcel_id": "437-73-00",
    "owner1": "REINHARDT TR, SUSAN E",
    "owner2": "",
    "current_taxes": 29397.26,
    "new_taxes_no_override": 30667.22,
    "override_total_1": 31537.38,
    "override_increase_1": 870.16
  },
  {
    "#": "42 Jefferson Rd (437-72-00)",
    "$": 3799500,
    "address": "42 Jefferson Rd",
    "parcel_id": "437-72-00",
    "owner1": "EL-ZEIN TRS, MOHAMAD",
    "owner2": "KASSIS TR, LAILA",
    "current_taxes": 35271.95,
    "new_taxes_no_override": 36795.7,
    "override_total_1": 37839.75,
    "override_increase_1": 1044.05
  },
  {
    "#": "6 Jenness Rd (086A-12-00)",
    "$": 1619000,
    "address": "6 Jenness Rd",
    "parcel_id": "086A-12-00",
    "owner1": "LEBEDOWYCH, JAROSLAW MARK",
    "owner2": "HALL, EMILY OLSEN",
    "current_taxes": 16578.56,
    "new_taxes_no_override": 17294.75,
    "override_total_1": 17785.48,
    "override_increase_1": 490.73
  },
  {
    "#": "8 Jenness Rd (086A-13-00)",
    "$": 1606000,
    "address": "8 Jenness Rd",
    "parcel_id": "086A-13-00",
    "owner1": "KATZ, JAKOW & LUDMILA",
    "owner2": "",
    "current_taxes": 12810.51,
    "new_taxes_no_override": 13363.92,
    "override_total_1": 13743.12,
    "override_increase_1": 379.19
  },
  {
    "#": "9 Jenness Rd (086A-10-00)",
    "$": 2019600,
    "address": "9 Jenness Rd",
    "parcel_id": "086A-10-00",
    "owner1": "CONTENTE, RICHARD G & PATRICIA A",
    "owner2": "",
    "current_taxes": 17045.77,
    "new_taxes_no_override": 17782.15,
    "override_total_1": 18286.7,
    "override_increase_1": 504.55
  },
  {
    "#": "10 Jenness Rd (086A-14-00)",
    "$": 1812700,
    "address": "10 Jenness Rd",
    "parcel_id": "086A-14-00",
    "owner1": "SEPOLEN, LAUREN",
    "owner2": "KAIN, BENJAMIN",
    "current_taxes": 14927.11,
    "new_taxes_no_override": 15571.96,
    "override_total_1": 16013.8,
    "override_increase_1": 441.84
  },
  {
    "#": "15 Jenness Rd (086A-10-01)",
    "$": 1845900,
    "address": "15 Jenness Rd",
    "parcel_id": "086A-10-01",
    "owner1": "MANDELL, MARK & LISA",
    "owner2": "",
    "current_taxes": 15267.08,
    "new_taxes_no_override": 15926.62,
    "override_total_1": 16378.52,
    "override_increase_1": 451.91
  },
  {
    "#": "16 Jenness Rd (086A-15-00)",
    "$": 1818000,
    "address": "16 Jenness Rd",
    "parcel_id": "086A-15-00",
    "owner1": "KOHANE, ISAAC",
    "owner2": "",
    "current_taxes": 18616.32,
    "new_taxes_no_override": 19420.55,
    "override_total_1": 19971.59,
    "override_increase_1": 551.04
  },
  {
    "#": "20 Jenness Rd (086A-16-00)",
    "$": 1786100,
    "address": "20 Jenness Rd",
    "parcel_id": "086A-16-00",
    "owner1": "PARRISH, RUT REYKJALIN & BRANDON CHARLES",
    "owner2": "",
    "current_taxes": 14654.73,
    "new_taxes_no_override": 15287.81,
    "override_total_1": 15721.59,
    "override_increase_1": 433.78
  },
  {
    "#": "9 John St (046-02-04)",
    "$": 6606000,
    "address": "9 John St",
    "parcel_id": "046-02-04",
    "owner1": "BASILE, TR, ROBERT W",
    "owner2": "",
    "current_taxes": 67645.44,
    "new_taxes_no_override": 70567.72,
    "override_total_1": 72570.03,
    "override_increase_1": 2002.31
  },
  {
    "#": "16 John St (045-11-00)",
    "$": 2767600,
    "address": "16 John St",
    "parcel_id": "045-11-00",
    "owner1": "CHR PLEASANT LLC",
    "owner2": "",
    "current_taxes": 47492.02,
    "new_taxes_no_override": 49543.68,
    "override_total_1": 50949.44,
    "override_increase_1": 1405.76
  },
  {
    "#": "20 John St, Unit 1 (045-09-11)",
    "$": 1009900,
    "address": "20 John St, Unit 1",
    "parcel_id": "045-09-11",
    "owner1": "FERRERO-POSCHETTO, FRANCO",
    "owner2": "BERNARD, LAUREN S",
    "current_taxes": 6706.44,
    "new_taxes_no_override": 6996.16,
    "override_total_1": 7194.67,
    "override_increase_1": 198.51
  },
  {
    "#": "20 John St, Unit 2 (045-09-12)",
    "$": 1087900,
    "address": "20 John St, Unit 2",
    "parcel_id": "045-09-12",
    "owner1": "DOBRUSHKIN, ALBERT",
    "owner2": "",
    "current_taxes": 11140.1,
    "new_taxes_no_override": 11621.35,
    "override_total_1": 11951.1,
    "override_increase_1": 329.75
  },
  {
    "#": "20 John St, Unit 3 (045-09-13)",
    "$": 1096400,
    "address": "20 John St, Unit 3",
    "parcel_id": "045-09-13",
    "owner1": "LIPPARD, LESLIE A",
    "owner2": "APPEN, ALLYSON",
    "current_taxes": 7592.2,
    "new_taxes_no_override": 7920.18,
    "override_total_1": 8144.91,
    "override_increase_1": 224.73
  },
  {
    "#": "20 John St, Unit A (045-09-10)",
    "$": 600800,
    "address": "20 John St, Unit A",
    "parcel_id": "045-09-10",
    "owner1": "ZUKER TR, EDWARD E",
    "owner2": "PORAS, PETER F",
    "current_taxes": 6152.19,
    "new_taxes_no_override": 6417.96,
    "override_total_1": 6600.07,
    "override_increase_1": 182.1
  },
  {
    "#": "24 John St, Unit 1 (045-09-15)",
    "$": 992600,
    "address": "24 John St, Unit 1",
    "parcel_id": "045-09-15",
    "owner1": "SANTIAGO, RACHEL M & ALEX G",
    "owner2": "",
    "current_taxes": 6529.29,
    "new_taxes_no_override": 6811.36,
    "override_total_1": 7004.62,
    "override_increase_1": 193.27
  },
  {
    "#": "24 John St, Unit 2 (045-09-16)",
    "$": 1279000,
    "address": "24 John St, Unit 2",
    "parcel_id": "045-09-16",
    "owner1": "SUN, DYANNA",
    "owner2": "",
    "current_taxes": 9462.03,
    "new_taxes_no_override": 9870.79,
    "override_total_1": 10150.87,
    "override_increase_1": 280.08
  },
  {
    "#": "24 John St, Unit 3 (045-09-17)",
    "$": 1071600,
    "address": "24 John St, Unit 3",
    "parcel_id": "045-09-17",
    "owner1": "LEE, YU CHI",
    "owner2": "RIMKUS, MODESTAS",
    "current_taxes": 7338.25,
    "new_taxes_no_override": 7655.26,
    "override_total_1": 7872.47,
    "override_increase_1": 217.21
  },
  {
    "#": "24 John St, Unit A (045-09-14)",
    "$": 555300,
    "address": "24 John St, Unit A",
    "parcel_id": "045-09-14",
    "owner1": "HENRY, LARRY D",
    "owner2": "LARKIN, DALE J",
    "current_taxes": 2051.34,
    "new_taxes_no_override": 2139.96,
    "override_total_1": 2200.68,
    "override_increase_1": 60.72
  },
  {
    "#": "26 John St, Unit 1 (045-09-20)",
    "$": 975000,
    "address": "26 John St, Unit 1",
    "parcel_id": "045-09-20",
    "owner1": "ROSSIN, JACK E",
    "owner2": "",
    "current_taxes": 6349.07,
    "new_taxes_no_override": 6623.35,
    "override_total_1": 6811.28,
    "override_increase_1": 187.93
  },
  {
    "#": "26 John St, Unit 2 (045-09-21)",
    "$": 1003200,
    "address": "26 John St, Unit 2",
    "parcel_id": "045-09-21",
    "owner1": "MIER TR, JAMES W",
    "owner2": "",
    "current_taxes": 6637.83,
    "new_taxes_no_override": 6924.58,
    "override_total_1": 7121.06,
    "override_increase_1": 196.48
  },
  {
    "#": "26 John St, Unit 3 (045-09-22)",
    "$": 1061500,
    "address": "26 John St, Unit 3",
    "parcel_id": "045-09-22",
    "owner1": "ZHANG, CHENG ZHONG",
    "owner2": "",
    "current_taxes": 7234.83,
    "new_taxes_no_override": 7547.37,
    "override_total_1": 7761.53,
    "override_increase_1": 214.15
  },
  {
    "#": "26 John St, Unit A (045-09-18)",
    "$": 519100,
    "address": "26 John St, Unit A",
    "parcel_id": "045-09-18",
    "owner1": "JARMAN, MOLLY PRICE",
    "owner2": "",
    "current_taxes": 1680.65,
    "new_taxes_no_override": 1753.25,
    "override_total_1": 1803.0,
    "override_increase_1": 49.75
  },
  {
    "#": "26 John St, Unit B (045-09-19)",
    "$": 411200,
    "address": "26 John St, Unit B",
    "parcel_id": "045-09-19",
    "owner1": "GUARINO, MICHELLE",
    "owner2": "",
    "current_taxes": 4210.69,
    "new_taxes_no_override": 4392.59,
    "override_total_1": 4517.23,
    "override_increase_1": 124.64
  },
  {
    "#": "37 John St (047-17-00)",
    "$": 1439600,
    "address": "37 John St",
    "parcel_id": "047-17-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O JOHN ST PARKING LOT",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "40 John St (047A-10-00)",
    "$": 364100,
    "address": "40 John St",
    "parcel_id": "047A-10-00",
    "owner1": "KRAMER TR, CARL M",
    "owner2": "c/o METRO REALTY",
    "current_taxes": 3728.38,
    "new_taxes_no_override": 3889.45,
    "override_total_1": 3999.81,
    "override_increase_1": 110.36
  },
  {
    "#": "51 John St, Unit 101 (047-01-18)",
    "$": 707500,
    "address": "51 John St, Unit 101",
    "parcel_id": "047-01-18",
    "owner1": "BERGEL TR, IRENE",
    "owner2": "",
    "current_taxes": 3609.87,
    "new_taxes_no_override": 3765.82,
    "override_total_1": 3872.67,
    "override_increase_1": 106.85
  },
  {
    "#": "51 John St, Unit 102 (047-01-01)",
    "$": 763700,
    "address": "51 John St, Unit 102",
    "parcel_id": "047-01-01",
    "owner1": "BEN-OZER, NOAM",
    "owner2": "FINEGOLD-BEN-OZER, SARAH",
    "current_taxes": 7820.29,
    "new_taxes_no_override": 8158.13,
    "override_total_1": 8389.61,
    "override_increase_1": 231.48
  },
  {
    "#": "51 John St, Unit 103 (047-01-02)",
    "$": 1051400,
    "address": "51 John St, Unit 103",
    "parcel_id": "047-01-02",
    "owner1": "WINTHROP 168 LLC",
    "owner2": "",
    "current_taxes": 7131.4,
    "new_taxes_no_override": 7439.48,
    "override_total_1": 7650.57,
    "override_increase_1": 211.09
  },
  {
    "#": "51 John St, Unit 104 (047-01-03)",
    "$": 869900,
    "address": "51 John St, Unit 104",
    "parcel_id": "047-01-03",
    "owner1": "BEN-OZER, NOAM",
    "owner2": "",
    "current_taxes": 8907.78,
    "new_taxes_no_override": 9292.6,
    "override_total_1": 9556.27,
    "override_increase_1": 263.67
  },
  {
    "#": "51 John St, Unit 201 (047-01-04)",
    "$": 844500,
    "address": "51 John St, Unit 201",
    "parcel_id": "047-01-04",
    "owner1": "GRAY, ALICE E",
    "owner2": "",
    "current_taxes": 5012.75,
    "new_taxes_no_override": 5229.3,
    "override_total_1": 5377.68,
    "override_increase_1": 148.38
  },
  {
    "#": "51 John St, Unit 202 (047-01-05)",
    "$": 942600,
    "address": "51 John St, Unit 202",
    "parcel_id": "047-01-05",
    "owner1": "HURWITZ, SHELLEY",
    "owner2": "",
    "current_taxes": 6017.29,
    "new_taxes_no_override": 6277.24,
    "override_total_1": 6455.35,
    "override_increase_1": 178.11
  },
  {
    "#": "51 John St, Unit 203 (047-01-06)",
    "$": 938300,
    "address": "51 John St, Unit 203",
    "parcel_id": "047-01-06",
    "owner1": "WEISINGER, ROXANNE",
    "owner2": "",
    "current_taxes": 5973.26,
    "new_taxes_no_override": 6231.3,
    "override_total_1": 6408.11,
    "override_increase_1": 176.81
  },
  {
    "#": "51 John St, Unit 204 (047-01-07)",
    "$": 932500,
    "address": "51 John St, Unit 204",
    "parcel_id": "047-01-07",
    "owner1": "YANG, MIN",
    "owner2": "",
    "current_taxes": 5913.87,
    "new_taxes_no_override": 6169.35,
    "override_total_1": 6344.4,
    "override_increase_1": 175.05
  },
  {
    "#": "51 John St, Unit 301 (047-01-08)",
    "$": 836600,
    "address": "51 John St, Unit 301",
    "parcel_id": "047-01-08",
    "owner1": "TAMULSKI, THECLA",
    "owner2": "",
    "current_taxes": 4931.85,
    "new_taxes_no_override": 5144.91,
    "override_total_1": 5290.89,
    "override_increase_1": 145.98
  },
  {
    "#": "51 John St, Unit 302 (047-01-09)",
    "$": 943100,
    "address": "51 John St, Unit 302",
    "parcel_id": "047-01-09",
    "owner1": "SHERWIN, WILLIAM GEOFFREY",
    "owner2": "",
    "current_taxes": 9657.34,
    "new_taxes_no_override": 10074.54,
    "override_total_1": 10360.39,
    "override_increase_1": 285.86
  },
  {
    "#": "51 John St, Unit 303 & P5 (047-01-10)",
    "$": 882100,
    "address": "51 John St, Unit 303 & P5",
    "parcel_id": "047-01-10",
    "owner1": "PEACHTREE PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 9032.7,
    "new_taxes_no_override": 9422.91,
    "override_total_1": 9690.28,
    "override_increase_1": 267.37
  },
  {
    "#": "51 John St, Unit 304 & P4 (047-01-11)",
    "$": 908900,
    "address": "51 John St, Unit 304 & P4",
    "parcel_id": "047-01-11",
    "owner1": "SAVANNAH OAK PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 9307.14,
    "new_taxes_no_override": 9709.21,
    "override_total_1": 9984.7,
    "override_increase_1": 275.49
  },
  {
    "#": "51 John St, Unit 401 (047-01-12)",
    "$": 865800,
    "address": "51 John St, Unit 401",
    "parcel_id": "047-01-12",
    "owner1": "LAYANI, SHAHAR",
    "owner2": "KROSZYNSKI, GABRIELA",
    "current_taxes": 8865.79,
    "new_taxes_no_override": 9248.79,
    "override_total_1": 9511.22,
    "override_increase_1": 262.43
  },
  {
    "#": "51 John St, Unit 402 (047-01-13)",
    "$": 1039300,
    "address": "51 John St, Unit 402",
    "parcel_id": "047-01-13",
    "owner1": "LEE TR, PAUL W",
    "owner2": "",
    "current_taxes": 10642.43,
    "new_taxes_no_override": 11102.18,
    "override_total_1": 11417.2,
    "override_increase_1": 315.02
  },
  {
    "#": "51 John St, Unit 403 (047-01-14)",
    "$": 925900,
    "address": "51 John St, Unit 403",
    "parcel_id": "047-01-14",
    "owner1": "WANG, LIYUAN",
    "owner2": "YOU, SHWUJEN",
    "current_taxes": 5846.28,
    "new_taxes_no_override": 6098.84,
    "override_total_1": 6271.89,
    "override_increase_1": 173.05
  },
  {
    "#": "51 John St, Unit 404 & P-16 (047-01-15)",
    "$": 983100,
    "address": "51 John St, Unit 404 & P-16",
    "parcel_id": "047-01-15",
    "owner1": "STROCK, RICHARD E & JANICE M",
    "owner2": "",
    "current_taxes": 6432.01,
    "new_taxes_no_override": 6709.87,
    "override_total_1": 6900.26,
    "override_increase_1": 190.39
  },
  {
    "#": "51 John St, Unit B-37 (047-01-17)",
    "$": 82500,
    "address": "51 John St, Unit B-37",
    "parcel_id": "047-01-17",
    "owner1": "SKOLER, PETER M & SHEREE P",
    "owner2": "",
    "current_taxes": 844.8,
    "new_taxes_no_override": 881.3,
    "override_total_1": 906.3,
    "override_increase_1": 25.01
  },
  {
    "#": "51 John St, Unit G-B1-36 (047-01-16)",
    "$": 2310000,
    "address": "51 John St, Unit G-B1-36",
    "parcel_id": "047-01-16",
    "owner1": "BEAR HILL DEVELOPMENT LLC",
    "owner2": "",
    "current_taxes": 23654.4,
    "new_taxes_no_override": 24676.27,
    "override_total_1": 25376.44,
    "override_increase_1": 700.17
  },
  {
    "#": "51 John St, Unit G-B17 B20 (047-01-20)",
    "$": 88500,
    "address": "51 John St, Unit G-B17 B20",
    "parcel_id": "047-01-20",
    "owner1": "ONEAT NC",
    "owner2": "",
    "current_taxes": 906.24,
    "new_taxes_no_override": 945.39,
    "override_total_1": 972.21,
    "override_increase_1": 26.82
  },
  {
    "#": "51 John St, Unit G-B18 (047-01-21)",
    "$": 41300,
    "address": "51 John St, Unit G-B18",
    "parcel_id": "047-01-21",
    "owner1": "STROCK, RICHARD E & JANICE M",
    "owner2": "",
    "current_taxes": 422.91,
    "new_taxes_no_override": 441.18,
    "override_total_1": 453.7,
    "override_increase_1": 12.52
  },
  {
    "#": "51 John St, Unit G-B19  B27 (047-01-22)",
    "$": 88400,
    "address": "51 John St, Unit G-B19  B27",
    "parcel_id": "047-01-22",
    "owner1": "KAMINSKI TRS, CHICHUAN Y & JOSEPH M",
    "owner2": "",
    "current_taxes": 905.22,
    "new_taxes_no_override": 944.33,
    "override_total_1": 971.12,
    "override_increase_1": 26.79
  },
  {
    "#": "51 John St, Unit G-B21 (047-01-23)",
    "$": 40700,
    "address": "51 John St, Unit G-B21",
    "parcel_id": "047-01-23",
    "owner1": "YANG, MIN",
    "owner2": "",
    "current_taxes": 416.77,
    "new_taxes_no_override": 434.77,
    "override_total_1": 447.11,
    "override_increase_1": 12.34
  },
  {
    "#": "51 John St, Unit G-B28 (047-01-24)",
    "$": 42000,
    "address": "51 John St, Unit G-B28",
    "parcel_id": "047-01-24",
    "owner1": "HURWITZ, SHELLEY",
    "owner2": "",
    "current_taxes": 430.08,
    "new_taxes_no_override": 448.66,
    "override_total_1": 461.39,
    "override_increase_1": 12.73
  },
  {
    "#": "51 John St, Unit G-B8 (047-01-19)",
    "$": 46400,
    "address": "51 John St, Unit G-B8",
    "parcel_id": "047-01-19",
    "owner1": "WEISINGER, ROXANNE",
    "owner2": "",
    "current_taxes": 475.14,
    "new_taxes_no_override": 495.67,
    "override_total_1": 509.73,
    "override_increase_1": 14.06
  },
  {
    "#": "15 Jordan Rd (086-44-00)",
    "$": 2556000,
    "address": "15 Jordan Rd",
    "parcel_id": "086-44-00",
    "owner1": "SHAROT, TALI",
    "owner2": "MCDERMOTT, JOSHUA",
    "current_taxes": 22538.51,
    "new_taxes_no_override": 23512.17,
    "override_total_1": 24179.31,
    "override_increase_1": 667.14
  },
  {
    "#": "19 Jordan Rd (086-45-00)",
    "$": 2650200,
    "address": "19 Jordan Rd",
    "parcel_id": "086-45-00",
    "owner1": "HELWEGE TRS, ANN",
    "owner2": "MOODY, OLIVIA ANN",
    "current_taxes": 23503.11,
    "new_taxes_no_override": 24518.44,
    "override_total_1": 25214.14,
    "override_increase_1": 695.69
  },
  {
    "#": "20 Jordan Rd (086B-23-00)",
    "$": 1968100,
    "address": "20 Jordan Rd",
    "parcel_id": "086B-23-00",
    "owner1": "SANGHAVI, ELIZABETH S & DARSHAK M",
    "owner2": "",
    "current_taxes": 16518.41,
    "new_taxes_no_override": 17232.01,
    "override_total_1": 17720.95,
    "override_increase_1": 488.94
  },
  {
    "#": "24 Jordan Rd (086B-22-00)",
    "$": 2221000,
    "address": "24 Jordan Rd",
    "parcel_id": "086B-22-00",
    "owner1": "BYHOFF, ELENA",
    "owner2": "COMBS, DAVID",
    "current_taxes": 19108.11,
    "new_taxes_no_override": 19933.58,
    "override_total_1": 20499.18,
    "override_increase_1": 565.6
  },
  {
    "#": "25 Jordan Rd (086-46-00)",
    "$": 3855400,
    "address": "25 Jordan Rd",
    "parcel_id": "086-46-00",
    "owner1": "VAZIRANI TRS, SARAH",
    "owner2": "DISOTTO TR, CHRISTOPHER",
    "current_taxes": 39479.3,
    "new_taxes_no_override": 41184.81,
    "override_total_1": 42353.39,
    "override_increase_1": 1168.59
  },
  {
    "#": "28 Jordan Rd (086B-21-00)",
    "$": 2059700,
    "address": "28 Jordan Rd",
    "parcel_id": "086B-21-00",
    "owner1": "KLEINER, PETER & DEBORAH",
    "owner2": "",
    "current_taxes": 17456.39,
    "new_taxes_no_override": 18210.51,
    "override_total_1": 18727.22,
    "override_increase_1": 516.71
  },
  {
    "#": "31 Jordan Rd (086-47-48)",
    "$": 2813200,
    "address": "31 Jordan Rd",
    "parcel_id": "086-47-48",
    "owner1": "SHANNON, WALTER C III",
    "owner2": "",
    "current_taxes": 25172.23,
    "new_taxes_no_override": 26259.67,
    "override_total_1": 27004.77,
    "override_increase_1": 745.1
  },
  {
    "#": "38 Jordan Rd (086B-20-00)",
    "$": 2420100,
    "address": "38 Jordan Rd",
    "parcel_id": "086B-20-00",
    "owner1": "ROBERTS, JULIE ANN",
    "owner2": "",
    "current_taxes": 21146.89,
    "new_taxes_no_override": 22060.44,
    "override_total_1": 22686.38,
    "override_increase_1": 625.95
  },
  {
    "#": "39 Jordan Rd (086-49-50)",
    "$": 2873100,
    "address": "39 Jordan Rd",
    "parcel_id": "086-49-50",
    "owner1": "MAYO, AARON T",
    "owner2": "MCCLELLAND, ASHLEY NICOLE",
    "current_taxes": 29420.54,
    "new_taxes_no_override": 30691.51,
    "override_total_1": 31562.36,
    "override_increase_1": 870.85
  },
  {
    "#": "42 Jordan Rd (086B-18-19)",
    "$": 2212100,
    "address": "42 Jordan Rd",
    "parcel_id": "086B-18-19",
    "owner1": "VINOGRAD, GLADYS GOLDSTEIN",
    "owner2": "",
    "current_taxes": 22651.9,
    "new_taxes_no_override": 23630.46,
    "override_total_1": 24300.96,
    "override_increase_1": 670.5
  },
  {
    "#": "43 Jordan Rd (086-51-00)",
    "$": 2360000,
    "address": "43 Jordan Rd",
    "parcel_id": "086-51-00",
    "owner1": "WOLFSDORF, TRS, JOSEPH I & GAIL A",
    "owner2": "",
    "current_taxes": 20531.47,
    "new_taxes_no_override": 21418.43,
    "override_total_1": 22026.16,
    "override_increase_1": 607.73
  },
  {
    "#": "49 Jordan Rd (086-52-00)",
    "$": 2126200,
    "address": "49 Jordan Rd",
    "parcel_id": "086-52-00",
    "owner1": "GOLLOBIN TRS, RONALD W & HELEN M",
    "owner2": "",
    "current_taxes": 18137.35,
    "new_taxes_no_override": 18920.88,
    "override_total_1": 19457.75,
    "override_increase_1": 536.87
  },
  {
    "#": "52 Jordan Rd (086B-16-17)",
    "$": 2238000,
    "address": "52 Jordan Rd",
    "parcel_id": "086B-16-17",
    "owner1": "ABRAMS, KATHLEEN OCONNOR",
    "owner2": "STANLEY M",
    "current_taxes": 19282.19,
    "new_taxes_no_override": 20115.18,
    "override_total_1": 20685.93,
    "override_increase_1": 570.75
  },
  {
    "#": "53 Jordan Rd (086-53-00)",
    "$": 2401300,
    "address": "53 Jordan Rd",
    "parcel_id": "086-53-00",
    "owner1": "GORDON, ALBERT S",
    "owner2": "",
    "current_taxes": 20954.38,
    "new_taxes_no_override": 21859.61,
    "override_total_1": 22479.86,
    "override_increase_1": 620.25
  },
  {
    "#": "54 Jordan Rd (086B-15-00)",
    "$": 2117600,
    "address": "54 Jordan Rd",
    "parcel_id": "086B-15-00",
    "owner1": "GUBAR, MARTIN D",
    "owner2": "RHODES, REBECCA",
    "current_taxes": 18049.29,
    "new_taxes_no_override": 18829.02,
    "override_total_1": 19363.28,
    "override_increase_1": 534.26
  },
  {
    "#": "59 Jordan Rd (086-54-00)",
    "$": 2248100,
    "address": "59 Jordan Rd",
    "parcel_id": "086-54-00",
    "owner1": "VIDELEFSKY, GEOFFREY & ZELDA",
    "owner2": "",
    "current_taxes": 19385.61,
    "new_taxes_no_override": 20223.07,
    "override_total_1": 20796.88,
    "override_increase_1": 573.81
  },
  {
    "#": "60 Jordan Rd (086B-14-00)",
    "$": 2568000,
    "address": "60 Jordan Rd",
    "parcel_id": "086B-14-00",
    "owner1": "LIUBLINSKA, MARYNA",
    "owner2": "BADRAK, MAKSYM",
    "current_taxes": 22661.39,
    "new_taxes_no_override": 23640.36,
    "override_total_1": 24311.14,
    "override_increase_1": 670.78
  },
  {
    "#": "61 Jordan Rd (086-55-00)",
    "$": 2456300,
    "address": "61 Jordan Rd",
    "parcel_id": "086-55-00",
    "owner1": "CASEY TRS, DONALD J & SUSAN J",
    "owner2": "",
    "current_taxes": 21517.58,
    "new_taxes_no_override": 22447.14,
    "override_total_1": 23084.06,
    "override_increase_1": 636.92
  },
  {
    "#": "67 Jordan Rd (086-56-00)",
    "$": 2514200,
    "address": "67 Jordan Rd",
    "parcel_id": "086-56-00",
    "owner1": "SHAPIRO, ROGER L",
    "owner2": "LOCKMAN, SHAHIN",
    "current_taxes": 22110.47,
    "new_taxes_no_override": 23065.64,
    "override_total_1": 23720.11,
    "override_increase_1": 654.47
  },
  {
    "#": "71 Jordan Rd (086-57-00)",
    "$": 2256300,
    "address": "71 Jordan Rd",
    "parcel_id": "086-57-00",
    "owner1": "SHOLKOVITZ, DAVID C & LUISA QUENTIN",
    "owner2": "",
    "current_taxes": 19469.58,
    "new_taxes_no_override": 20310.67,
    "override_total_1": 20886.97,
    "override_increase_1": 576.3
  },
  {
    "#": "77 Jordan Rd (086-58-00)",
    "$": 2120800,
    "address": "77 Jordan Rd",
    "parcel_id": "086-58-00",
    "owner1": "WEINSTEIN TRS, REUBEN",
    "owner2": "PIELECH, ROBERT M",
    "current_taxes": 21716.99,
    "new_taxes_no_override": 22655.16,
    "override_total_1": 23297.99,
    "override_increase_1": 642.82
  },
  {
    "#": "81 Jordan Rd (086-59-00)",
    "$": 2821700,
    "address": "81 Jordan Rd",
    "parcel_id": "086-59-00",
    "owner1": "LEVINE TRS, RICHARD E & VALERIE S",
    "owner2": "",
    "current_taxes": 25259.27,
    "new_taxes_no_override": 26350.47,
    "override_total_1": 27098.14,
    "override_increase_1": 747.67
  },
  {
    "#": "89 Jordan Rd (086-60-00)",
    "$": 3112100,
    "address": "89 Jordan Rd",
    "parcel_id": "086-60-00",
    "owner1": "ANQUETIL, PATRICK A",
    "owner2": "MANCHANDA, NITASHA V",
    "current_taxes": 28232.97,
    "new_taxes_no_override": 29452.63,
    "override_total_1": 30288.33,
    "override_increase_1": 835.7
  },
  {
    "#": "94 Jordan Rd (086B-09-00)",
    "$": 2159600,
    "address": "94 Jordan Rd",
    "parcel_id": "086B-09-00",
    "owner1": "TIGAR, MICHAEL J",
    "owner2": "",
    "current_taxes": 22114.3,
    "new_taxes_no_override": 23069.64,
    "override_total_1": 23724.22,
    "override_increase_1": 654.58
  },
  {
    "#": "95 Jordan Rd (086-61-00)",
    "$": 2502700,
    "address": "95 Jordan Rd",
    "parcel_id": "086-61-00",
    "owner1": "ROCKETT, FRANCIS X",
    "owner2": "",
    "current_taxes": 25627.65,
    "new_taxes_no_override": 26734.76,
    "override_total_1": 27493.34,
    "override_increase_1": 758.58
  },
  {
    "#": "99 Jordan Rd (086-62-00)",
    "$": 2386100,
    "address": "99 Jordan Rd",
    "parcel_id": "086-62-00",
    "owner1": "CHENG, AI-CHUN",
    "owner2": "LI, GENE-WEI",
    "current_taxes": 20798.73,
    "new_taxes_no_override": 21697.24,
    "override_total_1": 22312.88,
    "override_increase_1": 615.64
  },
  {
    "#": "100 Jordan Rd (086B-08-00)",
    "$": 3415100,
    "address": "100 Jordan Rd",
    "parcel_id": "086B-08-00",
    "owner1": "GORDON, ANDREW P & JOCELYN R",
    "owner2": "",
    "current_taxes": 31335.69,
    "new_taxes_no_override": 32689.39,
    "override_total_1": 33616.93,
    "override_increase_1": 927.54
  },
  {
    "#": "105 Jordan Rd (086-63-00)",
    "$": 4559600,
    "address": "105 Jordan Rd",
    "parcel_id": "086-63-00",
    "owner1": "ZELFOND TRS, MARINA P & ALEXANDER",
    "owner2": "",
    "current_taxes": 43055.37,
    "new_taxes_no_override": 44915.36,
    "override_total_1": 46189.8,
    "override_increase_1": 1274.44
  },
  {
    "#": "106 Jordan Rd (086B-07-00)",
    "$": 2004900,
    "address": "106 Jordan Rd",
    "parcel_id": "086B-07-00",
    "owner1": "INBAL, ESTHER",
    "owner2": "",
    "current_taxes": 20530.18,
    "new_taxes_no_override": 21417.08,
    "override_total_1": 22024.78,
    "override_increase_1": 607.69
  },
  {
    "#": "111 Jordan Rd (086-64-65)",
    "$": 4754500,
    "address": "111 Jordan Rd",
    "parcel_id": "086-64-65",
    "owner1": "BIRMINGHAM, KEVIN B",
    "owner2": "",
    "current_taxes": 45051.15,
    "new_taxes_no_override": 46997.36,
    "override_total_1": 48330.87,
    "override_increase_1": 1333.51
  },
  {
    "#": "121 Jordan Rd (086-66-00)",
    "$": 2893100,
    "address": "121 Jordan Rd",
    "parcel_id": "086-66-00",
    "owner1": "TATAR TR, DANIEL J",
    "owner2": "",
    "current_taxes": 29625.34,
    "new_taxes_no_override": 30905.15,
    "override_total_1": 31782.06,
    "override_increase_1": 876.91
  },
  {
    "#": "127 Jordan Rd (086-67-00)",
    "$": 2679400,
    "address": "127 Jordan Rd",
    "parcel_id": "086-67-00",
    "owner1": "DAVIES TR, RYAN J",
    "owner2": "",
    "current_taxes": 23802.12,
    "new_taxes_no_override": 24830.37,
    "override_total_1": 25534.91,
    "override_increase_1": 704.54
  },
  {
    "#": "133 Jordan Rd (086-68-00)",
    "$": 2713800,
    "address": "133 Jordan Rd",
    "parcel_id": "086-68-00",
    "owner1": "ESKIN, TRS, BARBARA",
    "owner2": "",
    "current_taxes": 27789.31,
    "new_taxes_no_override": 28989.81,
    "override_total_1": 29812.37,
    "override_increase_1": 822.56
  },
  {
    "#": "137 Jordan Rd (086-69-00)",
    "$": 2318400,
    "address": "137 Jordan Rd",
    "parcel_id": "086-69-00",
    "owner1": "ESKIN, BARBARA",
    "owner2": "",
    "current_taxes": 23740.42,
    "new_taxes_no_override": 24766.01,
    "override_total_1": 25468.72,
    "override_increase_1": 702.72
  },
  {
    "#": "138 Jordan Rd (086A-03-01)",
    "$": 2083600,
    "address": "138 Jordan Rd",
    "parcel_id": "086A-03-01",
    "owner1": "ROBINSON, RICHARD A",
    "owner2": "",
    "current_taxes": 17701.13,
    "new_taxes_no_override": 18465.82,
    "override_total_1": 18989.77,
    "override_increase_1": 523.95
  },
  {
    "#": "141 Jordan Rd (086-69-01)",
    "$": 1941000,
    "address": "141 Jordan Rd",
    "parcel_id": "086-69-01",
    "owner1": "CHEN, WANG",
    "owner2": "QIN, LAN",
    "current_taxes": 19875.84,
    "new_taxes_no_override": 20734.48,
    "override_total_1": 21322.8,
    "override_increase_1": 588.32
  },
  {
    "#": "142 Jordan Rd (086A-03-00)",
    "$": 1836100,
    "address": "142 Jordan Rd",
    "parcel_id": "086A-03-00",
    "owner1": "JACOBSON, PAUL & DEBORAH",
    "owner2": "",
    "current_taxes": 15166.73,
    "new_taxes_no_override": 15821.93,
    "override_total_1": 16270.87,
    "override_increase_1": 448.94
  },
  {
    "#": "144 Jordan Rd (086A-02-01)",
    "$": 1828400,
    "address": "144 Jordan Rd",
    "parcel_id": "086A-02-01",
    "owner1": "SUKACHEV, DENIS",
    "owner2": "BELYAEVA, OLESYA",
    "current_taxes": 15087.88,
    "new_taxes_no_override": 15739.68,
    "override_total_1": 16186.28,
    "override_increase_1": 446.6
  },
  {
    "#": "147 Jordan Rd (086-70-00)",
    "$": 2763700,
    "address": "147 Jordan Rd",
    "parcel_id": "086-70-00",
    "owner1": "KHAN, ATIF",
    "owner2": "LI, JANET",
    "current_taxes": 24665.35,
    "new_taxes_no_override": 25730.89,
    "override_total_1": 26460.99,
    "override_increase_1": 730.09
  },
  {
    "#": "148 Jordan Rd (086A-02-00)",
    "$": 2134400,
    "address": "148 Jordan Rd",
    "parcel_id": "086A-02-00",
    "owner1": "GOLDSMITH, KEN & JENNIFER",
    "owner2": "",
    "current_taxes": 18221.32,
    "new_taxes_no_override": 19008.48,
    "override_total_1": 19547.83,
    "override_increase_1": 539.35
  },
  {
    "#": "150 Jordan Rd (086A-01-02)",
    "$": 1454200,
    "address": "150 Jordan Rd",
    "parcel_id": "086A-01-02",
    "owner1": "249 COREY ACQUISITION LLC",
    "owner2": "",
    "current_taxes": 14891.01,
    "new_taxes_no_override": 15534.3,
    "override_total_1": 15975.08,
    "override_increase_1": 440.77
  },
  {
    "#": "153 Jordan Rd (086-71-00)",
    "$": 2395400,
    "address": "153 Jordan Rd",
    "parcel_id": "086-71-00",
    "owner1": "PENG, LI",
    "owner2": "ZHONG, ZHILUN",
    "current_taxes": 20893.96,
    "new_taxes_no_override": 21796.58,
    "override_total_1": 22415.04,
    "override_increase_1": 618.46
  },
  {
    "#": "157 Jordan Rd (086-72-00)",
    "$": 2189700,
    "address": "157 Jordan Rd",
    "parcel_id": "086-72-00",
    "owner1": "POLYAKOV, EVGENY",
    "owner2": "DMITRIEVA, LENA",
    "current_taxes": 18787.59,
    "new_taxes_no_override": 19599.21,
    "override_total_1": 20155.33,
    "override_increase_1": 556.11
  },
  {
    "#": " Jordan Rd (086A-01-01)",
    "$": 1455500,
    "address": " Jordan Rd",
    "parcel_id": "086A-01-01",
    "owner1": "249 COREY ACQUISITION LLC",
    "owner2": "",
    "current_taxes": 14904.32,
    "new_taxes_no_override": 15548.19,
    "override_total_1": 15989.35,
    "override_increase_1": 441.17
  },
  {
    "#": "6 Juniper St, Unit 1 & P2 (287-02-04)",
    "$": 416900,
    "address": "6 Juniper St, Unit 1 & P2",
    "parcel_id": "287-02-04",
    "owner1": "YOO, SANDRA H & ALBERT J",
    "owner2": "",
    "current_taxes": 4269.06,
    "new_taxes_no_override": 4453.48,
    "override_total_1": 4579.85,
    "override_increase_1": 126.36
  },
  {
    "#": "6 Juniper St, Unit 10 & P5 (287-02-13)",
    "$": 475700,
    "address": "6 Juniper St, Unit 10 & P5",
    "parcel_id": "287-02-13",
    "owner1": "JOSEPH, JEREMY",
    "owner2": "",
    "current_taxes": 1236.23,
    "new_taxes_no_override": 1289.64,
    "override_total_1": 1326.23,
    "override_increase_1": 36.59
  },
  {
    "#": "6 Juniper St, Unit 11 & P10 (287-02-14)",
    "$": 605200,
    "address": "6 Juniper St, Unit 11 & P10",
    "parcel_id": "287-02-14",
    "owner1": "CHOW-GUIDOBONI, JO SUK-YING",
    "owner2": "",
    "current_taxes": 6197.25,
    "new_taxes_no_override": 6464.97,
    "override_total_1": 6648.41,
    "override_increase_1": 183.44
  },
  {
    "#": "6 Juniper St, Unit 12 & P6 (287-02-15)",
    "$": 589900,
    "address": "6 Juniper St, Unit 12 & P6",
    "parcel_id": "287-02-15",
    "owner1": "LO, FU S-KAYSON-STACIE-JANIS",
    "owner2": "",
    "current_taxes": 2405.64,
    "new_taxes_no_override": 2509.56,
    "override_total_1": 2580.77,
    "override_increase_1": 71.21
  },
  {
    "#": "6 Juniper St, Unit 13 & P54 (287-02-16)",
    "$": 207300,
    "address": "6 Juniper St, Unit 13 & P54",
    "parcel_id": "287-02-16",
    "owner1": "ZARAKHOVSKY, NATALIA",
    "owner2": "",
    "current_taxes": 212.28,
    "new_taxes_no_override": 221.45,
    "override_total_1": 227.73,
    "override_increase_1": 6.28
  },
  {
    "#": "6 Juniper St, Unit 14 & P41 (287-02-17)",
    "$": 475700,
    "address": "6 Juniper St, Unit 14 & P41",
    "parcel_id": "287-02-17",
    "owner1": "CHANG, HSUN-HSIEN",
    "owner2": "LIN, SHENG I",
    "current_taxes": 4871.17,
    "new_taxes_no_override": 5081.6,
    "override_total_1": 5225.79,
    "override_increase_1": 144.19
  },
  {
    "#": "6 Juniper St, Unit 15 & P17 (287-02-18)",
    "$": 589900,
    "address": "6 Juniper St, Unit 15 & P17",
    "parcel_id": "287-02-18",
    "owner1": "BARNEY, GEORGE",
    "owner2": "",
    "current_taxes": 2405.64,
    "new_taxes_no_override": 2509.56,
    "override_total_1": 2580.77,
    "override_increase_1": 71.21
  },
  {
    "#": "6 Juniper St, Unit 16 & P11 (287-02-19)",
    "$": 673200,
    "address": "6 Juniper St, Unit 16 & P11",
    "parcel_id": "287-02-19",
    "owner1": "LIU, LING",
    "owner2": "",
    "current_taxes": 6893.57,
    "new_taxes_no_override": 7191.37,
    "override_total_1": 7395.42,
    "override_increase_1": 204.05
  },
  {
    "#": "6 Juniper St, Unit 2 & P56 (287-02-05)",
    "$": 199400,
    "address": "6 Juniper St, Unit 2 & P56",
    "parcel_id": "287-02-05",
    "owner1": "RECORD-STANLEY, SHIELA ESTELLE",
    "owner2": "",
    "current_taxes": 204.19,
    "new_taxes_no_override": 213.01,
    "override_total_1": 219.06,
    "override_increase_1": 6.04
  },
  {
    "#": "6 Juniper St, Unit 3 & P8 (287-02-06)",
    "$": 342400,
    "address": "6 Juniper St, Unit 3 & P8",
    "parcel_id": "287-02-06",
    "owner1": "CHU, LING",
    "owner2": "",
    "current_taxes": 3506.18,
    "new_taxes_no_override": 3657.65,
    "override_total_1": 3761.43,
    "override_increase_1": 103.78
  },
  {
    "#": "6 Juniper St, Unit 4 & P61 (287-02-07)",
    "$": 352500,
    "address": "6 Juniper St, Unit 4 & P61",
    "parcel_id": "287-02-07",
    "owner1": "ZHOU, ZHIQIANG",
    "owner2": "JI, FANG",
    "current_taxes": 3609.6,
    "new_taxes_no_override": 3765.53,
    "override_total_1": 3872.38,
    "override_increase_1": 106.84
  },
  {
    "#": "6 Juniper St, Unit 5 & P60 (287-02-08)",
    "$": 412600,
    "address": "6 Juniper St, Unit 5 & P60",
    "parcel_id": "287-02-08",
    "owner1": "YU, QIANG",
    "owner2": "LI, XIAN CHANG",
    "current_taxes": 4225.02,
    "new_taxes_no_override": 4407.54,
    "override_total_1": 4532.6,
    "override_increase_1": 125.06
  },
  {
    "#": "6 Juniper St, Unit 6 & P1 (287-02-09)",
    "$": 421600,
    "address": "6 Juniper St, Unit 6 & P1",
    "parcel_id": "287-02-09",
    "owner1": "MANNING, THOMAS E JR",
    "owner2": "",
    "current_taxes": 682.25,
    "new_taxes_no_override": 711.72,
    "override_total_1": 731.92,
    "override_increase_1": 20.19
  },
  {
    "#": "6 Juniper St, Unit 7 & P14 (287-02-10)",
    "$": 307300,
    "address": "6 Juniper St, Unit 7 & P14",
    "parcel_id": "287-02-10",
    "owner1": "GOLDBERG, JULIA",
    "owner2": "",
    "current_taxes": 314.68,
    "new_taxes_no_override": 328.27,
    "override_total_1": 337.59,
    "override_increase_1": 9.31
  },
  {
    "#": "6 Juniper St, Unit 8 & P9 (287-02-11)",
    "$": 605200,
    "address": "6 Juniper St, Unit 8 & P9",
    "parcel_id": "287-02-11",
    "owner1": "LI, LONGXIANG",
    "owner2": "SONG, ZHUOQIN",
    "current_taxes": 6197.25,
    "new_taxes_no_override": 6464.97,
    "override_total_1": 6648.41,
    "override_increase_1": 183.44
  },
  {
    "#": "6 Juniper St, Unit 9 & P13 (287-02-12)",
    "$": 470800,
    "address": "6 Juniper St, Unit 9 & P13",
    "parcel_id": "287-02-12",
    "owner1": "KELLEY, SEAN",
    "owner2": "",
    "current_taxes": 4820.99,
    "new_taxes_no_override": 5029.26,
    "override_total_1": 5171.96,
    "override_increase_1": 142.7
  },
  {
    "#": "8 Juniper St, Unit 17 & P30 (287-02-20)",
    "$": 347200,
    "address": "8 Juniper St, Unit 17 & P30",
    "parcel_id": "287-02-20",
    "owner1": "ZHANG, CAROL",
    "owner2": "",
    "current_taxes": 3555.33,
    "new_taxes_no_override": 3708.92,
    "override_total_1": 3814.16,
    "override_increase_1": 105.24
  },
  {
    "#": "8 Juniper St, Unit 18 & P102 (287-02-21)",
    "$": 413200,
    "address": "8 Juniper St, Unit 18 & P102",
    "parcel_id": "287-02-21",
    "owner1": "LIU, YANG",
    "owner2": "",
    "current_taxes": 4231.17,
    "new_taxes_no_override": 4413.96,
    "override_total_1": 4539.2,
    "override_increase_1": 125.24
  },
  {
    "#": "8 Juniper St, Unit 19 & P36 (287-02-22)",
    "$": 259200,
    "address": "8 Juniper St, Unit 19 & P36",
    "parcel_id": "287-02-22",
    "owner1": "CURRAN, MARY S",
    "owner2": "",
    "current_taxes": 2654.21,
    "new_taxes_no_override": 2768.87,
    "override_total_1": 2847.44,
    "override_increase_1": 78.56
  },
  {
    "#": "8 Juniper St, Unit 20 & P22 (287-02-23)",
    "$": 230100,
    "address": "8 Juniper St, Unit 20 & P22",
    "parcel_id": "287-02-23",
    "owner1": "SISAY, ZEGEYE M",
    "owner2": "HADDIS, LUWAM G",
    "current_taxes": 235.62,
    "new_taxes_no_override": 245.8,
    "override_total_1": 252.77,
    "override_increase_1": 6.97
  },
  {
    "#": "8 Juniper St, Unit 21 & P40 (287-02-24)",
    "$": 615400,
    "address": "8 Juniper St, Unit 21 & P40",
    "parcel_id": "287-02-24",
    "owner1": "ZINBOONYAHGOON, NANTTHASORN",
    "owner2": "",
    "current_taxes": 6301.7,
    "new_taxes_no_override": 6573.93,
    "override_total_1": 6760.46,
    "override_increase_1": 186.53
  },
  {
    "#": "8 Juniper St, Unit 22 & P24 (287-02-25)",
    "$": 609900,
    "address": "8 Juniper St, Unit 22 & P24",
    "parcel_id": "287-02-25",
    "owner1": "XU, XUESONG",
    "owner2": "",
    "current_taxes": 6245.38,
    "new_taxes_no_override": 6515.18,
    "override_total_1": 6700.04,
    "override_increase_1": 184.86
  },
  {
    "#": "8 Juniper St, Unit 23 & P4 (287-02-26)",
    "$": 271900,
    "address": "8 Juniper St, Unit 23 & P4",
    "parcel_id": "287-02-26",
    "owner1": "PARTENSKY, STEVE",
    "owner2": "",
    "current_taxes": 278.43,
    "new_taxes_no_override": 290.46,
    "override_total_1": 298.7,
    "override_increase_1": 8.24
  },
  {
    "#": "8 Juniper St, Unit 24 & P59 (287-02-27)",
    "$": 265500,
    "address": "8 Juniper St, Unit 24 & P59",
    "parcel_id": "287-02-27",
    "owner1": "NGUYEN, KIM THU",
    "owner2": "",
    "current_taxes": 271.87,
    "new_taxes_no_override": 283.61,
    "override_total_1": 291.66,
    "override_increase_1": 8.05
  },
  {
    "#": "8 Juniper St, Unit 25 & P37 (287-02-28)",
    "$": 299400,
    "address": "8 Juniper St, Unit 25 & P37",
    "parcel_id": "287-02-28",
    "owner1": "HAGERTY, AGNES C",
    "owner2": "",
    "current_taxes": 3065.86,
    "new_taxes_no_override": 3198.31,
    "override_total_1": 3289.05,
    "override_increase_1": 90.75
  },
  {
    "#": "8 Juniper St, Unit 26 & P21 (287-02-29)",
    "$": 615400,
    "address": "8 Juniper St, Unit 26 & P21",
    "parcel_id": "287-02-29",
    "owner1": "MENG, SHASHA",
    "owner2": "",
    "current_taxes": 6301.7,
    "new_taxes_no_override": 6573.93,
    "override_total_1": 6760.46,
    "override_increase_1": 186.53
  },
  {
    "#": "8 Juniper St, Unit 27 & P18 (287-02-30)",
    "$": 521500,
    "address": "8 Juniper St, Unit 27 & P18",
    "parcel_id": "287-02-30",
    "owner1": "MCGINN TR, ELAINE F",
    "owner2": "",
    "current_taxes": 1705.23,
    "new_taxes_no_override": 1778.9,
    "override_total_1": 1829.37,
    "override_increase_1": 50.47
  },
  {
    "#": "8 Juniper St, Unit 28 & P39 (287-02-31)",
    "$": 521500,
    "address": "8 Juniper St, Unit 28 & P39",
    "parcel_id": "287-02-31",
    "owner1": "MI, WEIDONG",
    "owner2": "ZHANG, RANNING",
    "current_taxes": 1705.23,
    "new_taxes_no_override": 1778.9,
    "override_total_1": 1829.37,
    "override_increase_1": 50.47
  },
  {
    "#": "8 Juniper St, Unit 29 & P35 (287-02-32)",
    "$": 605200,
    "address": "8 Juniper St, Unit 29 & P35",
    "parcel_id": "287-02-32",
    "owner1": "RADFORD, RICHARD  III",
    "owner2": "",
    "current_taxes": 2562.31,
    "new_taxes_no_override": 2673.0,
    "override_total_1": 2748.85,
    "override_increase_1": 75.84
  },
  {
    "#": "8 Juniper St, Unit 30 & P33 (287-02-33)",
    "$": 589900,
    "address": "8 Juniper St, Unit 30 & P33",
    "parcel_id": "287-02-33",
    "owner1": "ZHENG, YAN",
    "owner2": "LI, JUN",
    "current_taxes": 6040.58,
    "new_taxes_no_override": 6301.53,
    "override_total_1": 6480.33,
    "override_increase_1": 178.8
  },
  {
    "#": "8 Juniper St, Unit 31 & P20 (287-02-34)",
    "$": 267100,
    "address": "8 Juniper St, Unit 31 & P20",
    "parcel_id": "287-02-34",
    "owner1": "PRIESTLY, VENA",
    "owner2": "",
    "current_taxes": 273.51,
    "new_taxes_no_override": 285.33,
    "override_total_1": 293.42,
    "override_increase_1": 8.1
  },
  {
    "#": "10 Juniper St, Unit 32 & P28 (287-02-35)",
    "$": 447000,
    "address": "10 Juniper St, Unit 32 & P28",
    "parcel_id": "287-02-35",
    "owner1": "ARSENAULT, JOHN & ELIZABETH",
    "owner2": "",
    "current_taxes": 942.35,
    "new_taxes_no_override": 983.06,
    "override_total_1": 1010.95,
    "override_increase_1": 27.89
  },
  {
    "#": "10 Juniper St, Unit 33 & P3 (287-02-36)",
    "$": 413200,
    "address": "10 Juniper St, Unit 33 & P3",
    "parcel_id": "287-02-36",
    "owner1": "JUNIPER GARDENS CONDOMINIUM TR",
    "owner2": "",
    "current_taxes": 4231.17,
    "new_taxes_no_override": 4413.96,
    "override_total_1": 4539.2,
    "override_increase_1": 125.24
  },
  {
    "#": "10 Juniper St, Unit 34 & P57 (287-02-37)",
    "$": 367900,
    "address": "10 Juniper St, Unit 34 & P57",
    "parcel_id": "287-02-37",
    "owner1": "BERGQUIST TRS, SAM",
    "owner2": "HALS, KRISTINA",
    "current_taxes": 3767.3,
    "new_taxes_no_override": 3930.05,
    "override_total_1": 4041.56,
    "override_increase_1": 111.51
  },
  {
    "#": "10 Juniper St, Unit 35 & P80 (287-02-38)",
    "$": 597000,
    "address": "10 Juniper St, Unit 35 & P80",
    "parcel_id": "287-02-38",
    "owner1": "HE TR, LIXIA",
    "owner2": "",
    "current_taxes": 6113.28,
    "new_taxes_no_override": 6377.37,
    "override_total_1": 6558.33,
    "override_increase_1": 180.95
  },
  {
    "#": "10 Juniper St, Unit 36 & P15 (287-02-39)",
    "$": 547000,
    "address": "10 Juniper St, Unit 36 & P15",
    "parcel_id": "287-02-39",
    "owner1": "DURKIN, JALYN E",
    "owner2": "",
    "current_taxes": 5601.28,
    "new_taxes_no_override": 5843.26,
    "override_total_1": 6009.05,
    "override_increase_1": 165.8
  },
  {
    "#": "10 Juniper St, Unit 37 & P29 (287-02-40)",
    "$": 521500,
    "address": "10 Juniper St, Unit 37 & P29",
    "parcel_id": "287-02-40",
    "owner1": "KELLY  LIFE ESTATE, WILLIAM & SUSAN",
    "owner2": "",
    "current_taxes": 1705.23,
    "new_taxes_no_override": 1778.9,
    "override_total_1": 1829.37,
    "override_increase_1": 50.47
  },
  {
    "#": "10 Juniper St, Unit 38 & P31 (287-02-41)",
    "$": 615400,
    "address": "10 Juniper St, Unit 38 & P31",
    "parcel_id": "287-02-41",
    "owner1": "WU TRS, KERRY",
    "owner2": "LEE, CHEN YI JANE",
    "current_taxes": 6301.7,
    "new_taxes_no_override": 6573.93,
    "override_total_1": 6760.46,
    "override_increase_1": 186.53
  },
  {
    "#": "10 Juniper St, Unit 39 & P12 (287-02-42)",
    "$": 299400,
    "address": "10 Juniper St, Unit 39 & P12",
    "parcel_id": "287-02-42",
    "owner1": "KILGALLON, RONALD & MARILYN",
    "owner2": "",
    "current_taxes": 306.59,
    "new_taxes_no_override": 319.83,
    "override_total_1": 328.91,
    "override_increase_1": 9.08
  },
  {
    "#": "10 Juniper St, Unit 40 & P38 (287-02-43)",
    "$": 259100,
    "address": "10 Juniper St, Unit 40 & P38",
    "parcel_id": "287-02-43",
    "owner1": "YANG, JUN",
    "owner2": "LIANG, GUIJUAN",
    "current_taxes": 265.32,
    "new_taxes_no_override": 276.78,
    "override_total_1": 284.64,
    "override_increase_1": 7.85
  },
  {
    "#": "10 Juniper St, Unit 41 & P19 (287-02-44)",
    "$": 531700,
    "address": "10 Juniper St, Unit 41 & P19",
    "parcel_id": "287-02-44",
    "owner1": "FREDERICKS, JOANNE",
    "owner2": "",
    "current_taxes": 1809.67,
    "new_taxes_no_override": 1887.85,
    "override_total_1": 1941.41,
    "override_increase_1": 53.57
  },
  {
    "#": "10 Juniper St, Unit 42 & P55 (287-02-45)",
    "$": 589900,
    "address": "10 Juniper St, Unit 42 & P55",
    "parcel_id": "287-02-45",
    "owner1": "KELLEY, JEAN",
    "owner2": "",
    "current_taxes": 6040.58,
    "new_taxes_no_override": 6301.53,
    "override_total_1": 6480.33,
    "override_increase_1": 178.8
  },
  {
    "#": "10 Juniper St, Unit 43 & P27 (287-02-46)",
    "$": 600100,
    "address": "10 Juniper St, Unit 43 & P27",
    "parcel_id": "287-02-46",
    "owner1": "WANG, DONGHAI",
    "owner2": "PENG, HANQIN",
    "current_taxes": 2510.09,
    "new_taxes_no_override": 2618.53,
    "override_total_1": 2692.82,
    "override_increase_1": 74.3
  },
  {
    "#": "10 Juniper St, Unit 44 & P16 (287-02-47)",
    "$": 595100,
    "address": "10 Juniper St, Unit 44 & P16",
    "parcel_id": "287-02-47",
    "owner1": "FRANK, DEBORAH B",
    "owner2": "",
    "current_taxes": 2458.89,
    "new_taxes_no_override": 2565.11,
    "override_total_1": 2637.9,
    "override_increase_1": 72.78
  },
  {
    "#": "10 Juniper St, Unit 45 & P32 (287-02-48)",
    "$": 595100,
    "address": "10 Juniper St, Unit 45 & P32",
    "parcel_id": "287-02-48",
    "owner1": "BAI TRS, MING",
    "owner2": "ZENG TRS, LILING",
    "current_taxes": 6093.82,
    "new_taxes_no_override": 6357.07,
    "override_total_1": 6537.45,
    "override_increase_1": 180.38
  },
  {
    "#": "10 Juniper St, Unit 46 & P23 (287-02-49)",
    "$": 589900,
    "address": "10 Juniper St, Unit 46 & P23",
    "parcel_id": "287-02-49",
    "owner1": "SHEN, ALICE",
    "owner2": "",
    "current_taxes": 6040.58,
    "new_taxes_no_override": 6301.53,
    "override_total_1": 6480.33,
    "override_increase_1": 178.8
  },
  {
    "#": "18 Juniper St, Unit 47 & P77 (287-02-50)",
    "$": 558100,
    "address": "18 Juniper St, Unit 47 & P77",
    "parcel_id": "287-02-50",
    "owner1": "18 JUNIPER LLC",
    "owner2": "",
    "current_taxes": 5714.94,
    "new_taxes_no_override": 5961.83,
    "override_total_1": 6130.99,
    "override_increase_1": 169.16
  },
  {
    "#": "18 Juniper St, Unit 48 & P71 (287-02-51)",
    "$": 260700,
    "address": "18 Juniper St, Unit 48 & P71",
    "parcel_id": "287-02-51",
    "owner1": "WONG, SHELLY W",
    "owner2": "",
    "current_taxes": 266.96,
    "new_taxes_no_override": 278.49,
    "override_total_1": 286.39,
    "override_increase_1": 7.9
  },
  {
    "#": "18 Juniper St, Unit 49 & P65 (287-02-52)",
    "$": 546200,
    "address": "18 Juniper St, Unit 49 & P65",
    "parcel_id": "287-02-52",
    "owner1": "FU, XUAN",
    "owner2": "",
    "current_taxes": 5593.09,
    "new_taxes_no_override": 5834.71,
    "override_total_1": 6000.27,
    "override_increase_1": 165.56
  },
  {
    "#": "18 Juniper St, Unit 50 & P45 (287-02-53)",
    "$": 259200,
    "address": "18 Juniper St, Unit 50 & P45",
    "parcel_id": "287-02-53",
    "owner1": "BAUGHMAN, CAROL",
    "owner2": "",
    "current_taxes": 265.42,
    "new_taxes_no_override": 276.89,
    "override_total_1": 284.74,
    "override_increase_1": 7.86
  },
  {
    "#": "18 Juniper St, Unit 51 & P99 (287-02-54)",
    "$": 546200,
    "address": "18 Juniper St, Unit 51 & P99",
    "parcel_id": "287-02-54",
    "owner1": "PAGE, MARYELLEN & ERIC J & SCOTT",
    "owner2": "",
    "current_taxes": 1958.15,
    "new_taxes_no_override": 2042.74,
    "override_total_1": 2100.7,
    "override_increase_1": 57.96
  },
  {
    "#": "18 Juniper St, Unit 52 & P25 (287-02-55)",
    "$": 546200,
    "address": "18 Juniper St, Unit 52 & P25",
    "parcel_id": "287-02-55",
    "owner1": "WANG, XUEYAN",
    "owner2": "",
    "current_taxes": 1958.15,
    "new_taxes_no_override": 2042.74,
    "override_total_1": 2100.7,
    "override_increase_1": 57.96
  },
  {
    "#": "18 Juniper St, Unit 53 & P26 (287-02-56)",
    "$": 546200,
    "address": "18 Juniper St, Unit 53 & P26",
    "parcel_id": "287-02-56",
    "owner1": "MAHON LIFE ESTATE, JANIS M",
    "owner2": "",
    "current_taxes": 1958.15,
    "new_taxes_no_override": 2042.74,
    "override_total_1": 2100.7,
    "override_increase_1": 57.96
  },
  {
    "#": "18 Juniper St, Unit 54 & P49 (287-02-57)",
    "$": 259200,
    "address": "18 Juniper St, Unit 54 & P49",
    "parcel_id": "287-02-57",
    "owner1": "NOLAN, THERESE",
    "owner2": "",
    "current_taxes": 2654.21,
    "new_taxes_no_override": 2768.87,
    "override_total_1": 2847.44,
    "override_increase_1": 78.56
  },
  {
    "#": "18 Juniper St, Unit 55 & P82 (287-02-58)",
    "$": 546200,
    "address": "18 Juniper St, Unit 55 & P82",
    "parcel_id": "287-02-58",
    "owner1": "GEE, LULU",
    "owner2": "GEE MORRISSEY, LAURA",
    "current_taxes": 1958.15,
    "new_taxes_no_override": 2042.74,
    "override_total_1": 2100.7,
    "override_increase_1": 57.96
  },
  {
    "#": "18 Juniper St, Unit 56 & P72 (287-02-59)",
    "$": 268700,
    "address": "18 Juniper St, Unit 56 & P72",
    "parcel_id": "287-02-59",
    "owner1": "ZHANG, SHAOLONG",
    "owner2": "CHEN, BING GUANG",
    "current_taxes": 275.15,
    "new_taxes_no_override": 287.04,
    "override_total_1": 295.18,
    "override_increase_1": 8.14
  },
  {
    "#": "18 Juniper St, Unit 57 & P34 (287-02-60)",
    "$": 546200,
    "address": "18 Juniper St, Unit 57 & P34",
    "parcel_id": "287-02-60",
    "owner1": "KELLEY, SHANNON",
    "owner2": "",
    "current_taxes": 1958.15,
    "new_taxes_no_override": 2042.74,
    "override_total_1": 2100.7,
    "override_increase_1": 57.96
  },
  {
    "#": "18 Juniper St, Unit 58 & P74 (287-02-61)",
    "$": 259200,
    "address": "18 Juniper St, Unit 58 & P74",
    "parcel_id": "287-02-61",
    "owner1": "BROWN, ROY & DOROTHEA",
    "owner2": "",
    "current_taxes": 2654.21,
    "new_taxes_no_override": 2768.87,
    "override_total_1": 2847.44,
    "override_increase_1": 78.56
  },
  {
    "#": "18 Juniper St, Unit 59 & P63 (287-02-62)",
    "$": 636800,
    "address": "18 Juniper St, Unit 59 & P63",
    "parcel_id": "287-02-62",
    "owner1": "LI, DAN",
    "owner2": "XIANG, SHUANGLIN",
    "current_taxes": 2885.9,
    "new_taxes_no_override": 3010.57,
    "override_total_1": 3095.99,
    "override_increase_1": 85.42
  },
  {
    "#": "18 Juniper St, Unit 60 & P75 (287-02-63)",
    "$": 267100,
    "address": "18 Juniper St, Unit 60 & P75",
    "parcel_id": "287-02-63",
    "owner1": "MATTHEWS, CHRISTINE",
    "owner2": "",
    "current_taxes": 273.51,
    "new_taxes_no_override": 285.33,
    "override_total_1": 293.42,
    "override_increase_1": 8.1
  },
  {
    "#": "24 Juniper St, Unit 61 & P93 (287-02-64)",
    "$": 218800,
    "address": "24 Juniper St, Unit 61 & P93",
    "parcel_id": "287-02-64",
    "owner1": "WANG, YUFEI",
    "owner2": "",
    "current_taxes": 224.05,
    "new_taxes_no_override": 233.73,
    "override_total_1": 240.36,
    "override_increase_1": 6.63
  },
  {
    "#": "24 Juniper St, Unit 62 & P94 (287-02-65)",
    "$": 388100,
    "address": "24 Juniper St, Unit 62 & P94",
    "parcel_id": "287-02-65",
    "owner1": "SHANI, DAVID",
    "owner2": "",
    "current_taxes": 397.41,
    "new_taxes_no_override": 414.58,
    "override_total_1": 426.34,
    "override_increase_1": 11.76
  },
  {
    "#": "24 Juniper St, Unit 63 & P43 (287-02-66)",
    "$": 458900,
    "address": "24 Juniper St, Unit 63 & P43",
    "parcel_id": "287-02-66",
    "owner1": "CHEN, CHUN-MEI",
    "owner2": "",
    "current_taxes": 4699.14,
    "new_taxes_no_override": 4902.14,
    "override_total_1": 5041.24,
    "override_increase_1": 139.09
  },
  {
    "#": "24 Juniper St, Unit 64 & P113 (287-02-67)",
    "$": 217200,
    "address": "24 Juniper St, Unit 64 & P113",
    "parcel_id": "287-02-67",
    "owner1": "CHING, ALLISON",
    "owner2": "",
    "current_taxes": 222.41,
    "new_taxes_no_override": 232.02,
    "override_total_1": 238.6,
    "override_increase_1": 6.58
  },
  {
    "#": "24 Juniper St, Unit 65 & P88 (287-02-68)",
    "$": 243000,
    "address": "24 Juniper St, Unit 65 & P88",
    "parcel_id": "287-02-68",
    "owner1": "QUINONEZ, AIDA L",
    "owner2": "",
    "current_taxes": 2488.32,
    "new_taxes_no_override": 2595.82,
    "override_total_1": 2669.47,
    "override_increase_1": 73.65
  },
  {
    "#": "24 Juniper St, Unit 66 & P91 (287-02-69)",
    "$": 447000,
    "address": "24 Juniper St, Unit 66 & P91",
    "parcel_id": "287-02-69",
    "owner1": "WEI, BAOGUO",
    "owner2": "LIU, SHUANG",
    "current_taxes": 4577.28,
    "new_taxes_no_override": 4775.02,
    "override_total_1": 4910.51,
    "override_increase_1": 135.49
  },
  {
    "#": "24 Juniper St, Unit 67 & P47 (287-02-70)",
    "$": 213600,
    "address": "24 Juniper St, Unit 67 & P47",
    "parcel_id": "287-02-70",
    "owner1": "FARRELL, ROBERT A",
    "owner2": "",
    "current_taxes": 218.73,
    "new_taxes_no_override": 228.18,
    "override_total_1": 234.65,
    "override_increase_1": 6.47
  },
  {
    "#": "24 Juniper St, Unit 68 & P46 (287-02-71)",
    "$": 209200,
    "address": "24 Juniper St, Unit 68 & P46",
    "parcel_id": "287-02-71",
    "owner1": "CHUN, KIMBERLY",
    "owner2": "",
    "current_taxes": 214.22,
    "new_taxes_no_override": 223.47,
    "override_total_1": 229.82,
    "override_increase_1": 6.34
  },
  {
    "#": "24 Juniper St, Unit 69 & P86 (287-02-72)",
    "$": 215800,
    "address": "24 Juniper St, Unit 69 & P86",
    "parcel_id": "287-02-72",
    "owner1": "OJALA, KRYSTIN",
    "owner2": "",
    "current_taxes": 220.98,
    "new_taxes_no_override": 230.53,
    "override_total_1": 237.07,
    "override_increase_1": 6.54
  },
  {
    "#": "24 Juniper St, Unit 70 & P110 (287-02-73)",
    "$": 208100,
    "address": "24 Juniper St, Unit 70 & P110",
    "parcel_id": "287-02-73",
    "owner1": "HICKEY, FRANCIS S",
    "owner2": "",
    "current_taxes": 213.09,
    "new_taxes_no_override": 222.3,
    "override_total_1": 228.6,
    "override_increase_1": 6.31
  },
  {
    "#": "24 Juniper St, Unit 71 & P69 (287-02-74)",
    "$": 218800,
    "address": "24 Juniper St, Unit 71 & P69",
    "parcel_id": "287-02-74",
    "owner1": "HU, JIANYI",
    "owner2": "",
    "current_taxes": 224.05,
    "new_taxes_no_override": 233.73,
    "override_total_1": 240.36,
    "override_increase_1": 6.63
  },
  {
    "#": "24 Juniper St, Unit 72 & P98 (287-02-75)",
    "$": 216200,
    "address": "24 Juniper St, Unit 72 & P98",
    "parcel_id": "287-02-75",
    "owner1": "KEAVENEY, JOSEPH",
    "owner2": "",
    "current_taxes": 221.39,
    "new_taxes_no_override": 230.95,
    "override_total_1": 237.51,
    "override_increase_1": 6.55
  },
  {
    "#": "24 Juniper St, Unit 73 & P87 (287-02-76)",
    "$": 472500,
    "address": "24 Juniper St, Unit 73 & P87",
    "parcel_id": "287-02-76",
    "owner1": "FREDERICKS, GWEN",
    "owner2": "",
    "current_taxes": 1203.47,
    "new_taxes_no_override": 1255.46,
    "override_total_1": 1291.08,
    "override_increase_1": 35.62
  },
  {
    "#": "24 Juniper St, Unit 74 & P97 (287-02-77)",
    "$": 472500,
    "address": "24 Juniper St, Unit 74 & P97",
    "parcel_id": "287-02-77",
    "owner1": "PYATIBRAT, SERGEY",
    "owner2": "",
    "current_taxes": 1203.47,
    "new_taxes_no_override": 1255.46,
    "override_total_1": 1291.08,
    "override_increase_1": 35.62
  },
  {
    "#": "28 Juniper St, Unit 75 & P107 (287-02-78)",
    "$": 400000,
    "address": "28 Juniper St, Unit 75 & P107",
    "parcel_id": "287-02-78",
    "owner1": "AGRAWAL, SHRUTIDEVI",
    "owner2": "GUPTA, SAURABH",
    "current_taxes": 4096.0,
    "new_taxes_no_override": 4272.95,
    "override_total_1": 4394.19,
    "override_increase_1": 121.24
  },
  {
    "#": "28 Juniper St, Unit 76 & P79 (287-02-79)",
    "$": 388100,
    "address": "28 Juniper St, Unit 76 & P79",
    "parcel_id": "287-02-79",
    "owner1": "OWENS, KENNETH",
    "owner2": "",
    "current_taxes": 397.41,
    "new_taxes_no_override": 414.58,
    "override_total_1": 426.34,
    "override_increase_1": 11.76
  },
  {
    "#": "28 Juniper St, Unit 77 & P103 (287-02-80)",
    "$": 447000,
    "address": "28 Juniper St, Unit 77 & P103",
    "parcel_id": "287-02-80",
    "owner1": "ELFANT, STEVEN",
    "owner2": "",
    "current_taxes": 4577.28,
    "new_taxes_no_override": 4775.02,
    "override_total_1": 4910.51,
    "override_increase_1": 135.49
  },
  {
    "#": "28 Juniper St, Unit 78 & P42 (287-02-81)",
    "$": 447000,
    "address": "28 Juniper St, Unit 78 & P42",
    "parcel_id": "287-02-81",
    "owner1": "ELKHOURY, NABIL G & CATHY S",
    "owner2": "",
    "current_taxes": 4577.28,
    "new_taxes_no_override": 4775.02,
    "override_total_1": 4910.51,
    "override_increase_1": 135.49
  },
  {
    "#": "28 Juniper St, Unit 79 & P78 (287-02-82)",
    "$": 472500,
    "address": "28 Juniper St, Unit 79 & P78",
    "parcel_id": "287-02-82",
    "owner1": "CHU, CHEN & HUIDONG",
    "owner2": "HE, MIAO",
    "current_taxes": 4838.4,
    "new_taxes_no_override": 5047.42,
    "override_total_1": 5190.64,
    "override_increase_1": 143.22
  },
  {
    "#": "28 Juniper St, Unit 80 & P83 (287-02-83)",
    "$": 447000,
    "address": "28 Juniper St, Unit 80 & P83",
    "parcel_id": "287-02-83",
    "owner1": "LANAVA ROSE LLC",
    "owner2": "",
    "current_taxes": 4577.28,
    "new_taxes_no_override": 4775.02,
    "override_total_1": 4910.51,
    "override_increase_1": 135.49
  },
  {
    "#": "28 Juniper St, Unit 81 & P96 (287-02-84)",
    "$": 447000,
    "address": "28 Juniper St, Unit 81 & P96",
    "parcel_id": "287-02-84",
    "owner1": "LAVIN, THOMAS",
    "owner2": "",
    "current_taxes": 942.35,
    "new_taxes_no_override": 983.06,
    "override_total_1": 1010.95,
    "override_increase_1": 27.89
  },
  {
    "#": "28 Juniper St, Unit 82 & P48 (287-02-85)",
    "$": 207300,
    "address": "28 Juniper St, Unit 82 & P48",
    "parcel_id": "287-02-85",
    "owner1": "ODAY, VIRGINIA",
    "owner2": "",
    "current_taxes": 212.28,
    "new_taxes_no_override": 221.45,
    "override_total_1": 227.73,
    "override_increase_1": 6.28
  },
  {
    "#": "28 Juniper St, Unit 83 & P7 (287-02-86)",
    "$": 459600,
    "address": "28 Juniper St, Unit 83 & P7",
    "parcel_id": "287-02-86",
    "owner1": "NOLAN, THERESE",
    "owner2": "",
    "current_taxes": 4706.3,
    "new_taxes_no_override": 4909.61,
    "override_total_1": 5048.92,
    "override_increase_1": 139.31
  },
  {
    "#": "28 Juniper St, Unit 84 & P44 (287-02-87)",
    "$": 222000,
    "address": "28 Juniper St, Unit 84 & P44",
    "parcel_id": "287-02-87",
    "owner1": "ROMANOVA, VICTORIA",
    "owner2": "",
    "current_taxes": 227.33,
    "new_taxes_no_override": 237.15,
    "override_total_1": 243.88,
    "override_increase_1": 6.73
  },
  {
    "#": "28 Juniper St, Unit 85 & P84 (287-02-88)",
    "$": 241000,
    "address": "28 Juniper St, Unit 85 & P84",
    "parcel_id": "287-02-88",
    "owner1": "GRIZEGONO, VERONICA YOHANNES",
    "owner2": "",
    "current_taxes": 246.78,
    "new_taxes_no_override": 257.44,
    "override_total_1": 264.75,
    "override_increase_1": 7.3
  },
  {
    "#": "28 Juniper St, Unit 86 & P62 (287-02-89)",
    "$": 472500,
    "address": "28 Juniper St, Unit 86 & P62",
    "parcel_id": "287-02-89",
    "owner1": "BOWEN, FRANK",
    "owner2": "",
    "current_taxes": 1203.47,
    "new_taxes_no_override": 1255.46,
    "override_total_1": 1291.08,
    "override_increase_1": 35.62
  },
  {
    "#": "28 Juniper St, Unit 87 & P81 (287-02-90)",
    "$": 472500,
    "address": "28 Juniper St, Unit 87 & P81",
    "parcel_id": "287-02-90",
    "owner1": "DEATTE, WILLIAM",
    "owner2": "",
    "current_taxes": 4838.4,
    "new_taxes_no_override": 5047.42,
    "override_total_1": 5190.64,
    "override_increase_1": 143.22
  },
  {
    "#": "28 Juniper St, Unit 88 & P58 (287-02-91)",
    "$": 472500,
    "address": "28 Juniper St, Unit 88 & P58",
    "parcel_id": "287-02-91",
    "owner1": "ROEHRL, MICHAEL H",
    "owner2": "WANG, JULIA Y",
    "current_taxes": 4838.4,
    "new_taxes_no_override": 5047.42,
    "override_total_1": 5190.64,
    "override_increase_1": 143.22
  },
  {
    "#": "32 Juniper St, Unit 100 & P51 (287-03-04)",
    "$": 546200,
    "address": "32 Juniper St, Unit 100 & P51",
    "parcel_id": "287-03-04",
    "owner1": "LARSON, CLAIRE",
    "owner2": "",
    "current_taxes": 1958.15,
    "new_taxes_no_override": 2042.74,
    "override_total_1": 2100.7,
    "override_increase_1": 57.96
  },
  {
    "#": "32 Juniper St, Unit 101 & P100 (287-03-05)",
    "$": 546200,
    "address": "32 Juniper St, Unit 101 & P100",
    "parcel_id": "287-03-05",
    "owner1": "ZHANG TR, CHONGHUI",
    "owner2": "ZHOU TR, YIPING",
    "current_taxes": 5593.09,
    "new_taxes_no_override": 5834.71,
    "override_total_1": 6000.27,
    "override_increase_1": 165.56
  },
  {
    "#": "32 Juniper St, Unit 102 & P66 (287-03-06)",
    "$": 553300,
    "address": "32 Juniper St, Unit 102 & P66",
    "parcel_id": "287-03-06",
    "owner1": "KELLY, BARBARA & THERESA",
    "owner2": "",
    "current_taxes": 2030.86,
    "new_taxes_no_override": 2118.59,
    "override_total_1": 2178.71,
    "override_increase_1": 60.11
  },
  {
    "#": "32 Juniper St, Unit 89 & P106 (287-02-92)",
    "$": 472400,
    "address": "32 Juniper St, Unit 89 & P106",
    "parcel_id": "287-02-92",
    "owner1": "SHARMA, PARDEEP K& INDIRA&VISHAL",
    "owner2": "",
    "current_taxes": 4837.38,
    "new_taxes_no_override": 5046.35,
    "override_total_1": 5189.54,
    "override_increase_1": 143.19
  },
  {
    "#": "32 Juniper St, Unit 90 & P92 (287-02-93)",
    "$": 260700,
    "address": "32 Juniper St, Unit 90 & P92",
    "parcel_id": "287-02-93",
    "owner1": "TRESKA, FABIOLA",
    "owner2": "",
    "current_taxes": 2669.57,
    "new_taxes_no_override": 2784.9,
    "override_total_1": 2863.91,
    "override_increase_1": 79.02
  },
  {
    "#": "32 Juniper St, Unit 91 & P104 (287-02-94)",
    "$": 558100,
    "address": "32 Juniper St, Unit 91 & P104",
    "parcel_id": "287-02-94",
    "owner1": "SANRAME, CARLOS N",
    "owner2": "ZERDAN, MARIA EUGENIA MORENO",
    "current_taxes": 5714.94,
    "new_taxes_no_override": 5961.83,
    "override_total_1": 6130.99,
    "override_increase_1": 169.16
  },
  {
    "#": "32 Juniper St, Unit 92 & P89 (287-02-95)",
    "$": 296100,
    "address": "32 Juniper St, Unit 92 & P89",
    "parcel_id": "287-02-95",
    "owner1": "TUEN, KIT SIN",
    "owner2": "",
    "current_taxes": 3032.06,
    "new_taxes_no_override": 3163.04,
    "override_total_1": 3252.79,
    "override_increase_1": 89.75
  },
  {
    "#": "32 Juniper St, Unit 93 & P76 (287-02-96)",
    "$": 546200,
    "address": "32 Juniper St, Unit 93 & P76",
    "parcel_id": "287-02-96",
    "owner1": "WISWELL, BYRON CAMPBELL III",
    "owner2": "SNOW, MACKENZIE",
    "current_taxes": 5593.09,
    "new_taxes_no_override": 5834.71,
    "override_total_1": 6000.27,
    "override_increase_1": 165.56
  },
  {
    "#": "32 Juniper St, Unit 94 & P52 (287-02-97)",
    "$": 558100,
    "address": "32 Juniper St, Unit 94 & P52",
    "parcel_id": "287-02-97",
    "owner1": "LIU, YAJUN",
    "owner2": "ZENG, SHIRLEY H",
    "current_taxes": 5714.94,
    "new_taxes_no_override": 5961.83,
    "override_total_1": 6130.99,
    "override_increase_1": 169.16
  },
  {
    "#": "32 Juniper St, Unit 95 & P73 (287-02-98)",
    "$": 546200,
    "address": "32 Juniper St, Unit 95 & P73",
    "parcel_id": "287-02-98",
    "owner1": "DRAPER, RICHARD & LISA",
    "owner2": "",
    "current_taxes": 1958.15,
    "new_taxes_no_override": 2042.74,
    "override_total_1": 2100.7,
    "override_increase_1": 57.96
  },
  {
    "#": "32 Juniper St, Unit 96 & P53 (287-02-99)",
    "$": 558100,
    "address": "32 Juniper St, Unit 96 & P53",
    "parcel_id": "287-02-99",
    "owner1": "LI, YUNZHOU",
    "owner2": "HUO, JUQI",
    "current_taxes": 5714.94,
    "new_taxes_no_override": 5961.83,
    "override_total_1": 6130.99,
    "override_increase_1": 169.16
  },
  {
    "#": "32 Juniper St, Unit 97 & P50 (287-03-01)",
    "$": 623300,
    "address": "32 Juniper St, Unit 97 & P50",
    "parcel_id": "287-03-01",
    "owner1": "DUAN, RUITAO",
    "owner2": "SUN, YUXIN",
    "current_taxes": 2747.66,
    "new_taxes_no_override": 2866.36,
    "override_total_1": 2947.69,
    "override_increase_1": 81.33
  },
  {
    "#": "32 Juniper St, Unit 98 & P105 (287-03-02)",
    "$": 571700,
    "address": "32 Juniper St, Unit 98 & P105",
    "parcel_id": "287-03-02",
    "owner1": "LIN, JOSHUA K",
    "owner2": "",
    "current_taxes": 5854.21,
    "new_taxes_no_override": 6107.11,
    "override_total_1": 6280.4,
    "override_increase_1": 173.28
  },
  {
    "#": "32 Juniper St, Unit 99 & P64 (287-03-03)",
    "$": 566200,
    "address": "32 Juniper St, Unit 99 & P64",
    "parcel_id": "287-03-03",
    "owner1": "TAY, ALAN THAN & WIN WIN",
    "owner2": "",
    "current_taxes": 2162.95,
    "new_taxes_no_override": 2256.39,
    "override_total_1": 2320.41,
    "override_increase_1": 64.02
  },
  {
    "#": "38 Juniper St, Unit 103 & P108 (287-03-07)",
    "$": 546200,
    "address": "38 Juniper St, Unit 103 & P108",
    "parcel_id": "287-03-07",
    "owner1": "HU, YONGWU",
    "owner2": "",
    "current_taxes": 5593.09,
    "new_taxes_no_override": 5834.71,
    "override_total_1": 6000.27,
    "override_increase_1": 165.56
  },
  {
    "#": "38 Juniper St, Unit 104 & P111 (287-03-08)",
    "$": 546200,
    "address": "38 Juniper St, Unit 104 & P111",
    "parcel_id": "287-03-08",
    "owner1": "RODRIGUEZ, ANNABEL",
    "owner2": "",
    "current_taxes": 5593.09,
    "new_taxes_no_override": 5834.71,
    "override_total_1": 6000.27,
    "override_increase_1": 165.56
  },
  {
    "#": "38 Juniper St, Unit 105 & P67 (287-03-09)",
    "$": 259200,
    "address": "38 Juniper St, Unit 105 & P67",
    "parcel_id": "287-03-09",
    "owner1": "HOGAN, JOHN",
    "owner2": "",
    "current_taxes": 265.42,
    "new_taxes_no_override": 276.89,
    "override_total_1": 284.74,
    "override_increase_1": 7.86
  },
  {
    "#": "38 Juniper St, Unit 106 & P114 (287-03-10)",
    "$": 558100,
    "address": "38 Juniper St, Unit 106 & P114",
    "parcel_id": "287-03-10",
    "owner1": "CHOI, YOUNG II",
    "owner2": "HAN, SUNMI",
    "current_taxes": 5714.94,
    "new_taxes_no_override": 5961.83,
    "override_total_1": 6130.99,
    "override_increase_1": 169.16
  },
  {
    "#": "38 Juniper St, Unit 107 & P68 (287-03-11)",
    "$": 571700,
    "address": "38 Juniper St, Unit 107 & P68",
    "parcel_id": "287-03-11",
    "owner1": "TANG, LING",
    "owner2": "",
    "current_taxes": 5854.21,
    "new_taxes_no_override": 6107.11,
    "override_total_1": 6280.4,
    "override_increase_1": 173.28
  },
  {
    "#": "38 Juniper St, Unit 108 & P85 (287-03-12)",
    "$": 546200,
    "address": "38 Juniper St, Unit 108 & P85",
    "parcel_id": "287-03-12",
    "owner1": "CROWLEY, JOSEPH",
    "owner2": "",
    "current_taxes": 1958.15,
    "new_taxes_no_override": 2042.74,
    "override_total_1": 2100.7,
    "override_increase_1": 57.96
  },
  {
    "#": "38 Juniper St, Unit 109 & P70 (287-03-13)",
    "$": 546200,
    "address": "38 Juniper St, Unit 109 & P70",
    "parcel_id": "287-03-13",
    "owner1": "WINTON, CAROL",
    "owner2": "FARQUHAR, EDWIN",
    "current_taxes": 5593.09,
    "new_taxes_no_override": 5834.71,
    "override_total_1": 6000.27,
    "override_increase_1": 165.56
  },
  {
    "#": "38 Juniper St, Unit 110 & P109 (287-03-14)",
    "$": 566200,
    "address": "38 Juniper St, Unit 110 & P109",
    "parcel_id": "287-03-14",
    "owner1": "VU, CHAU H",
    "owner2": "",
    "current_taxes": 2162.95,
    "new_taxes_no_override": 2256.39,
    "override_total_1": 2320.41,
    "override_increase_1": 64.02
  },
  {
    "#": "38 Juniper St, Unit 111 & P90 (287-03-15)",
    "$": 571700,
    "address": "38 Juniper St, Unit 111 & P90",
    "parcel_id": "287-03-15",
    "owner1": "KIM, JOONCHUL",
    "owner2": "LEE, OKYEAN",
    "current_taxes": 2219.27,
    "new_taxes_no_override": 2315.14,
    "override_total_1": 2380.83,
    "override_increase_1": 65.69
  },
  {
    "#": "38 Juniper St, Unit 112 & P95 (287-03-16)",
    "$": 571700,
    "address": "38 Juniper St, Unit 112 & P95",
    "parcel_id": "287-03-16",
    "owner1": "LOPES, ALVARO ARAUJO",
    "owner2": "MENE XAVIER, CLAUDIA REGINA",
    "current_taxes": 5854.21,
    "new_taxes_no_override": 6107.11,
    "override_total_1": 6280.4,
    "override_increase_1": 173.28
  },
  {
    "#": "38 Juniper St, Unit 113 & P115 (287-03-17)",
    "$": 556400,
    "address": "38 Juniper St, Unit 113 & P115",
    "parcel_id": "287-03-17",
    "owner1": "KRAMER TRS, HOWARD & RENEE",
    "owner2": "",
    "current_taxes": 5697.54,
    "new_taxes_no_override": 5943.67,
    "override_total_1": 6112.32,
    "override_increase_1": 168.65
  },
  {
    "#": "38 Juniper St, Unit 114 & P116 (287-03-18)",
    "$": 546200,
    "address": "38 Juniper St, Unit 114 & P116",
    "parcel_id": "287-03-18",
    "owner1": "WINTON TR, CAROL LANGDON",
    "owner2": "",
    "current_taxes": 5593.09,
    "new_taxes_no_override": 5834.71,
    "override_total_1": 6000.27,
    "override_increase_1": 165.56
  },
  {
    "#": "38 Juniper St, Unit 115 & P101 (287-03-19)",
    "$": 546200,
    "address": "38 Juniper St, Unit 115 & P101",
    "parcel_id": "287-03-19",
    "owner1": "HOGAN, ROBERT & PATRICIA",
    "owner2": "",
    "current_taxes": 1958.15,
    "new_taxes_no_override": 2042.74,
    "override_total_1": 2100.7,
    "override_increase_1": 57.96
  },
  {
    "#": "38 Juniper St, Unit 116 & P112 (287-03-20)",
    "$": 571700,
    "address": "38 Juniper St, Unit 116 & P112",
    "parcel_id": "287-03-20",
    "owner1": "MENG, HSIEN-WEI YVONNE",
    "owner2": "",
    "current_taxes": 5854.21,
    "new_taxes_no_override": 6107.11,
    "override_total_1": 6280.4,
    "override_increase_1": 173.28
  },
  {
    "#": "40 Juniper St (287-04-00)",
    "$": 1772500,
    "address": "40 Juniper St",
    "parcel_id": "287-04-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O JUNIPER STREET PLAYGROUND",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "1 Kendall St, Unit A (317-35-00)",
    "$": 2630000,
    "address": "1 Kendall St, Unit A",
    "parcel_id": "317-35-00",
    "owner1": "AROUSH, JACK & GEORGE",
    "owner2": "",
    "current_taxes": 31475.91,
    "new_taxes_no_override": 32835.67,
    "override_total_1": 33767.36,
    "override_increase_1": 931.69
  },
  {
    "#": "7 Kendall St, Unit 1 (317-36-02)",
    "$": 461200,
    "address": "7 Kendall St, Unit 1",
    "parcel_id": "317-36-02",
    "owner1": "HARRIS TR, JOHN T",
    "owner2": "",
    "current_taxes": 7914.19,
    "new_taxes_no_override": 8256.08,
    "override_total_1": 8490.34,
    "override_increase_1": 234.26
  },
  {
    "#": "7 Kendall St, Unit 2 (317-36-03)",
    "$": 628000,
    "address": "7 Kendall St, Unit 2",
    "parcel_id": "317-36-03",
    "owner1": "BRENNAN, GERARD",
    "owner2": "",
    "current_taxes": 6430.72,
    "new_taxes_no_override": 6708.53,
    "override_total_1": 6898.88,
    "override_increase_1": 190.35
  },
  {
    "#": "7 Kendall St, Unit 3 (317-36-04)",
    "$": 628000,
    "address": "7 Kendall St, Unit 3",
    "parcel_id": "317-36-04",
    "owner1": "COELHO, CAMILLE S",
    "owner2": "",
    "current_taxes": 6430.72,
    "new_taxes_no_override": 6708.53,
    "override_total_1": 6898.88,
    "override_increase_1": 190.35
  },
  {
    "#": "11 Kendall St (317-36-01)",
    "$": 1051300,
    "address": "11 Kendall St",
    "parcel_id": "317-36-01",
    "owner1": "PORCARI, CAROL A",
    "owner2": "",
    "current_taxes": 7130.38,
    "new_taxes_no_override": 7438.41,
    "override_total_1": 7649.47,
    "override_increase_1": 211.06
  },
  {
    "#": "15 Kendall St (317-37-00)",
    "$": 2117300,
    "address": "15 Kendall St",
    "parcel_id": "317-37-00",
    "owner1": "ESTRADA, ANGEL & MARILYN",
    "owner2": "",
    "current_taxes": 21681.15,
    "new_taxes_no_override": 22617.78,
    "override_total_1": 23259.54,
    "override_increase_1": 641.76
  },
  {
    "#": "19 Kendall St (317-38-00)",
    "$": 1260100,
    "address": "19 Kendall St",
    "parcel_id": "317-38-00",
    "owner1": "VALLEE, LINDSA R",
    "owner2": "",
    "current_taxes": 9268.49,
    "new_taxes_no_override": 9668.89,
    "override_total_1": 9943.24,
    "override_increase_1": 274.35
  },
  {
    "#": "23 Kendall St (316A-18-00)",
    "$": 1386300,
    "address": "23 Kendall St",
    "parcel_id": "316A-18-00",
    "owner1": "MALLEY TRS, PATRICIA E & ANDREW T",
    "owner2": "",
    "current_taxes": 10560.78,
    "new_taxes_no_override": 11017.01,
    "override_total_1": 11329.6,
    "override_increase_1": 312.6
  },
  {
    "#": "33 Kendall St, Unit 33-1 & P5 (316A-19-01)",
    "$": 598200,
    "address": "33 Kendall St, Unit 33-1 & P5",
    "parcel_id": "316A-19-01",
    "owner1": "DYKSTRA, BRADFORD J & MOLLIE A",
    "owner2": "",
    "current_taxes": 2490.63,
    "new_taxes_no_override": 2598.23,
    "override_total_1": 2671.95,
    "override_increase_1": 73.72
  },
  {
    "#": "33 Kendall St, Unit 33-2 & P1 (316A-19-02)",
    "$": 538600,
    "address": "33 Kendall St, Unit 33-2 & P1",
    "parcel_id": "316A-19-02",
    "owner1": "MEEHAN TR, ANGELA E",
    "owner2": "",
    "current_taxes": 5515.26,
    "new_taxes_no_override": 5753.52,
    "override_total_1": 5916.77,
    "override_increase_1": 163.25
  },
  {
    "#": "33 Kendall St, Unit 33-3 & P4 (316A-19-03)",
    "$": 575600,
    "address": "33 Kendall St, Unit 33-3 & P4",
    "parcel_id": "316A-19-03",
    "owner1": "SUN, HUAHANG",
    "owner2": "",
    "current_taxes": 5894.14,
    "new_taxes_no_override": 6148.77,
    "override_total_1": 6323.23,
    "override_increase_1": 174.47
  },
  {
    "#": "37 Kendall St (316A-20-01)",
    "$": 1293200,
    "address": "37 Kendall St",
    "parcel_id": "316A-20-01",
    "owner1": "CHEN, ZI",
    "owner2": "FAN, JING",
    "current_taxes": 13242.37,
    "new_taxes_no_override": 13814.44,
    "override_total_1": 14206.41,
    "override_increase_1": 391.97
  },
  {
    "#": "39 Kendall St (316A-20-00)",
    "$": 1173400,
    "address": "39 Kendall St",
    "parcel_id": "316A-20-00",
    "owner1": "LACY, KEITH O & JULIE E",
    "owner2": "",
    "current_taxes": 8380.68,
    "new_taxes_no_override": 8742.73,
    "override_total_1": 8990.79,
    "override_increase_1": 248.07
  },
  {
    "#": "45 Kendall St (316A-21-00)",
    "$": 1378600,
    "address": "45 Kendall St",
    "parcel_id": "316A-21-00",
    "owner1": "HORLICK, LAWRENCE A",
    "owner2": "SOLOMON, LISA H",
    "current_taxes": 10481.93,
    "new_taxes_no_override": 10934.75,
    "override_total_1": 11245.01,
    "override_increase_1": 310.27
  },
  {
    "#": "48 Kendall St (316-22-00)",
    "$": 1443300,
    "address": "48 Kendall St",
    "parcel_id": "316-22-00",
    "owner1": "66 CHESTNUT STREET LLC",
    "owner2": "",
    "current_taxes": 14779.39,
    "new_taxes_no_override": 15417.86,
    "override_total_1": 15855.33,
    "override_increase_1": 437.47
  },
  {
    "#": "52 Kendall St (316-21-00)",
    "$": 1342100,
    "address": "52 Kendall St",
    "parcel_id": "316-21-00",
    "owner1": "OSTERWEIL, ET AL, SCOT M",
    "owner2": "",
    "current_taxes": 10108.17,
    "new_taxes_no_override": 10544.84,
    "override_total_1": 10844.04,
    "override_increase_1": 299.2
  },
  {
    "#": "5 Kennard Rd (321-13-00)",
    "$": 3364200,
    "address": "5 Kennard Rd",
    "parcel_id": "321-13-00",
    "owner1": "SHIVDASANI, KESHAV & PRIYANKA",
    "owner2": "",
    "current_taxes": 30814.47,
    "new_taxes_no_override": 32145.66,
    "override_total_1": 33057.76,
    "override_increase_1": 912.11
  },
  {
    "#": "6 Kennard Rd (320A-14-15)",
    "$": 2450600,
    "address": "6 Kennard Rd",
    "parcel_id": "320A-14-15",
    "owner1": "AUSTREW, ERIC D",
    "owner2": "WILSON, KATHRYN & PATRICIA S & GARY A",
    "current_taxes": 21459.21,
    "new_taxes_no_override": 22386.25,
    "override_total_1": 23021.44,
    "override_increase_1": 635.19
  },
  {
    "#": "15 Kennard Rd (321-01-00)",
    "$": 3558300,
    "address": "15 Kennard Rd",
    "parcel_id": "321-01-00",
    "owner1": "LAMONT TR, OWEN A",
    "owner2": "",
    "current_taxes": 32802.06,
    "new_taxes_no_override": 34219.11,
    "override_total_1": 35190.05,
    "override_increase_1": 970.94
  },
  {
    "#": "16 Kennard Rd (320A-13-00)",
    "$": 2896900,
    "address": "16 Kennard Rd",
    "parcel_id": "320A-13-00",
    "owner1": "OBRIEN, THOMAS F & RUTH R",
    "owner2": "",
    "current_taxes": 26029.32,
    "new_taxes_no_override": 27153.79,
    "override_total_1": 27924.25,
    "override_increase_1": 770.47
  },
  {
    "#": "19 Kennard Rd (322-01-00)",
    "$": 52382800,
    "address": "19 Kennard Rd",
    "parcel_id": "322-01-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O LINCOLN  &  BROOKLINE MUSIC",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "22 Kennard Rd (320A-12-00)",
    "$": 2553600,
    "address": "22 Kennard Rd",
    "parcel_id": "320A-12-00",
    "owner1": "HENDERSON, ZACH & NICOLE",
    "owner2": "",
    "current_taxes": 22513.93,
    "new_taxes_no_override": 23486.53,
    "override_total_1": 24152.94,
    "override_increase_1": 666.41
  },
  {
    "#": "32 Kennard Rd (320A-09-11)",
    "$": 3334300,
    "address": "32 Kennard Rd",
    "parcel_id": "320A-09-11",
    "owner1": "KETCHAM TRS, CHRISTOPHER",
    "owner2": "HOVAGUIMIAN, ALEXANDRA",
    "current_taxes": 30508.3,
    "new_taxes_no_override": 31826.26,
    "override_total_1": 32729.3,
    "override_increase_1": 903.05
  },
  {
    "#": "5 Kensington Cir (416-17-00)",
    "$": 2096200,
    "address": "5 Kensington Cir",
    "parcel_id": "416-17-00",
    "owner1": "LEADER, CELESTE M",
    "owner2": "",
    "current_taxes": 21465.09,
    "new_taxes_no_override": 22392.38,
    "override_total_1": 23027.75,
    "override_increase_1": 635.37
  },
  {
    "#": "11 Kensington Cir (416-16-00)",
    "$": 2019100,
    "address": "11 Kensington Cir",
    "parcel_id": "416-16-00",
    "owner1": "VITULLO, JOSHUA",
    "owner2": "YEE, KRISTINA A",
    "current_taxes": 17040.65,
    "new_taxes_no_override": 17776.81,
    "override_total_1": 18281.21,
    "override_increase_1": 504.4
  },
  {
    "#": "17 Kensington Cir (416-14-15)",
    "$": 2508900,
    "address": "17 Kensington Cir",
    "parcel_id": "416-14-15",
    "owner1": "BEAVERBROOK STEP INC",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "20 Kensington Cir (415-07-00)",
    "$": 2133700,
    "address": "20 Kensington Cir",
    "parcel_id": "415-07-00",
    "owner1": "GRAM, HILARY FOSSUM",
    "owner2": "LANCE, KIRSTEN ELIZABETH",
    "current_taxes": 18214.15,
    "new_taxes_no_override": 19001.0,
    "override_total_1": 19540.14,
    "override_increase_1": 539.14
  },
  {
    "#": "25 Kensington Cir (416-13-00)",
    "$": 2725900,
    "address": "25 Kensington Cir",
    "parcel_id": "416-13-00",
    "owner1": "IANNUCCI, LISA & MICHAEL",
    "owner2": "",
    "current_taxes": 24278.28,
    "new_taxes_no_override": 25327.1,
    "override_total_1": 26045.74,
    "override_increase_1": 718.64
  },
  {
    "#": "30 Kensington Cir (415-06-00)",
    "$": 1560200,
    "address": "30 Kensington Cir",
    "parcel_id": "415-06-00",
    "owner1": "NIU TRS, GEORGE G Y & SYLVIA S W",
    "owner2": "",
    "current_taxes": 15976.45,
    "new_taxes_no_override": 16666.63,
    "override_total_1": 17139.54,
    "override_increase_1": 472.9
  },
  {
    "#": "31 Kensington Cir (416-12-00)",
    "$": 2273900,
    "address": "31 Kensington Cir",
    "parcel_id": "416-12-00",
    "owner1": "GLICK TRS, CHARLOTTE E & HYMAN",
    "owner2": "",
    "current_taxes": 19649.8,
    "new_taxes_no_override": 20498.67,
    "override_total_1": 21080.31,
    "override_increase_1": 581.63
  },
  {
    "#": "39 Kensington Cir (416-11-00)",
    "$": 3492200,
    "address": "39 Kensington Cir",
    "parcel_id": "416-11-00",
    "owner1": "ALBANESE, STEVE & LISA DUNN",
    "owner2": "",
    "current_taxes": 32125.19,
    "new_taxes_no_override": 33513.0,
    "override_total_1": 34463.9,
    "override_increase_1": 950.91
  },
  {
    "#": "40 Kensington Cir (415-05-00)",
    "$": 2165300,
    "address": "40 Kensington Cir",
    "parcel_id": "415-05-00",
    "owner1": "DING, ALFRED",
    "owner2": "XU, JING",
    "current_taxes": 22172.67,
    "new_taxes_no_override": 23130.53,
    "override_total_1": 23786.84,
    "override_increase_1": 656.31
  },
  {
    "#": "43 Kensington Cir (416-10-00)",
    "$": 2093900,
    "address": "43 Kensington Cir",
    "parcel_id": "416-10-00",
    "owner1": "GU, YONGFENG",
    "owner2": "ZHOU, YUNSHENG",
    "current_taxes": 17806.6,
    "new_taxes_no_override": 18575.85,
    "override_total_1": 19102.92,
    "override_increase_1": 527.08
  },
  {
    "#": "49 Kensington Cir (416-09-00)",
    "$": 2526800,
    "address": "49 Kensington Cir",
    "parcel_id": "416-09-00",
    "owner1": "OBRIEN TRS, JOHN F  & KRISTEN S",
    "owner2": "",
    "current_taxes": 22239.5,
    "new_taxes_no_override": 23200.25,
    "override_total_1": 23858.54,
    "override_increase_1": 658.29
  },
  {
    "#": "50 Kensington Cir (415-03-04)",
    "$": 2496300,
    "address": "50 Kensington Cir",
    "parcel_id": "415-03-04",
    "owner1": "CHADHA, LAYLA N",
    "owner2": "",
    "current_taxes": 21927.18,
    "new_taxes_no_override": 22874.43,
    "override_total_1": 23523.48,
    "override_increase_1": 649.04
  },
  {
    "#": "55 Kensington Cir (416-08-00)",
    "$": 2473700,
    "address": "55 Kensington Cir",
    "parcel_id": "416-08-00",
    "owner1": "FAIGEL, HARRIS C & FRAYDA",
    "owner2": "",
    "current_taxes": 21695.75,
    "new_taxes_no_override": 22633.01,
    "override_total_1": 23275.2,
    "override_increase_1": 642.19
  },
  {
    "#": "60 Kensington Cir (415-02-00)",
    "$": 2532400,
    "address": "60 Kensington Cir",
    "parcel_id": "415-02-00",
    "owner1": "SCHECHTER, DAVID G & GAIL R",
    "owner2": "",
    "current_taxes": 22296.84,
    "new_taxes_no_override": 23260.06,
    "override_total_1": 23920.05,
    "override_increase_1": 659.99
  },
  {
    "#": "63 Kensington Cir (416-07-00)",
    "$": 2563200,
    "address": "63 Kensington Cir",
    "parcel_id": "416-07-00",
    "owner1": "PEREZ, JOSE CANCELAS",
    "owner2": "GARCIA, MARIA AZUCENA CALVO",
    "current_taxes": 22612.23,
    "new_taxes_no_override": 23589.08,
    "override_total_1": 24258.4,
    "override_increase_1": 669.32
  },
  {
    "#": "80 Kensington Cir (415-01-00)",
    "$": 2974400,
    "address": "80 Kensington Cir",
    "parcel_id": "415-01-00",
    "owner1": "AGHASSI, MICHELE L",
    "owner2": "SPRINGER, KIMBERLEY",
    "current_taxes": 26822.92,
    "new_taxes_no_override": 27981.67,
    "override_total_1": 28775.63,
    "override_increase_1": 793.96
  },
  {
    "#": "3 Kent Sq (129-20-00)",
    "$": 1494100,
    "address": "3 Kent Sq",
    "parcel_id": "129-20-00",
    "owner1": "SUN, JING",
    "owner2": "XU, TIANLEI",
    "current_taxes": 11664.65,
    "new_taxes_no_override": 12168.56,
    "override_total_1": 12513.84,
    "override_increase_1": 345.27
  },
  {
    "#": "7 Kent Sq (129-21-00)",
    "$": 1377100,
    "address": "7 Kent Sq",
    "parcel_id": "129-21-00",
    "owner1": "SMITH, CORY JAMES",
    "owner2": "WEFALD, REBECCA",
    "current_taxes": 14101.5,
    "new_taxes_no_override": 14710.68,
    "override_total_1": 15128.09,
    "override_increase_1": 417.4
  },
  {
    "#": "9 Kent Sq (129-01-00)",
    "$": 1441900,
    "address": "9 Kent Sq",
    "parcel_id": "129-01-00",
    "owner1": "WANG, YAN",
    "owner2": "LI, SHUJIA",
    "current_taxes": 14765.06,
    "new_taxes_no_override": 15402.91,
    "override_total_1": 15839.96,
    "override_increase_1": 437.05
  },
  {
    "#": "11 Kent Sq (129-02-00)",
    "$": 1426700,
    "address": "11 Kent Sq",
    "parcel_id": "129-02-00",
    "owner1": "MOLODOVSKY, ELIZABETH",
    "owner2": "",
    "current_taxes": 10974.47,
    "new_taxes_no_override": 11448.57,
    "override_total_1": 11773.41,
    "override_increase_1": 324.84
  },
  {
    "#": "12 Kent Sq, Unit 1 (128-06-01)",
    "$": 1140600,
    "address": "12 Kent Sq, Unit 1",
    "parcel_id": "128-06-01",
    "owner1": "WEI, LEE JEN-ERIC S-ROBERT S",
    "owner2": "",
    "current_taxes": 8044.81,
    "new_taxes_no_override": 8392.35,
    "override_total_1": 8630.47,
    "override_increase_1": 238.13
  },
  {
    "#": "12 Kent Sq, Unit 2 (128-06-02)",
    "$": 1420800,
    "address": "12 Kent Sq, Unit 2",
    "parcel_id": "128-06-02",
    "owner1": "COWAN, JOLYON",
    "owner2": "TRIEN, VANESSA",
    "current_taxes": 10914.06,
    "new_taxes_no_override": 11385.55,
    "override_total_1": 11708.6,
    "override_increase_1": 323.06
  },
  {
    "#": "13 Kent Sq (129-02-01)",
    "$": 1419300,
    "address": "13 Kent Sq",
    "parcel_id": "129-02-01",
    "owner1": "QUILLEN TR, KAREN",
    "owner2": "",
    "current_taxes": 10898.7,
    "new_taxes_no_override": 11369.52,
    "override_total_1": 11692.13,
    "override_increase_1": 322.6
  },
  {
    "#": "15 Kent Sq (129-02-02)",
    "$": 1505900,
    "address": "15 Kent Sq",
    "parcel_id": "129-02-02",
    "owner1": "KULKARNI, ALISON",
    "owner2": "",
    "current_taxes": 15420.42,
    "new_taxes_no_override": 16086.58,
    "override_total_1": 16543.03,
    "override_increase_1": 456.44
  },
  {
    "#": "16 Kent Sq, Unit 1 & P3 P4 (128-05-01)",
    "$": 1190800,
    "address": "16 Kent Sq, Unit 1 & P3 P4",
    "parcel_id": "128-05-01",
    "owner1": "CHANSKY, BENJAMIN",
    "owner2": "",
    "current_taxes": 8558.86,
    "new_taxes_no_override": 8928.6,
    "override_total_1": 9181.95,
    "override_increase_1": 253.34
  },
  {
    "#": "16 Kent Sq, Unit 2 & P1 P2 (128-05-02)",
    "$": 1244700,
    "address": "16 Kent Sq, Unit 2 & P1 P2",
    "parcel_id": "128-05-02",
    "owner1": "KISELYOV, ELINOR & DMITRY",
    "owner2": "",
    "current_taxes": 9110.79,
    "new_taxes_no_override": 9504.38,
    "override_total_1": 9774.06,
    "override_increase_1": 269.68
  },
  {
    "#": "17 Kent Sq (129-02-03)",
    "$": 1556500,
    "address": "17 Kent Sq",
    "parcel_id": "129-02-03",
    "owner1": "BLAKE, NATHAN D",
    "owner2": "BUTLER, KATHERINE  S",
    "current_taxes": 12303.63,
    "new_taxes_no_override": 12835.15,
    "override_total_1": 13199.33,
    "override_increase_1": 364.19
  },
  {
    "#": "21 Kent Sq (129-03-00)",
    "$": 2523900,
    "address": "21 Kent Sq",
    "parcel_id": "129-03-00",
    "owner1": "RDC- KENT 21 LLC",
    "owner2": "",
    "current_taxes": 25844.74,
    "new_taxes_no_override": 26961.23,
    "override_total_1": 27726.24,
    "override_increase_1": 765.0
  },
  {
    "#": "22 Kent Sq, Unit 1 (128-04-01)",
    "$": 980900,
    "address": "22 Kent Sq, Unit 1",
    "parcel_id": "128-04-01",
    "owner1": "BELLMUNT, JOAQUIM",
    "owner2": "",
    "current_taxes": 6409.48,
    "new_taxes_no_override": 6686.37,
    "override_total_1": 6876.09,
    "override_increase_1": 189.72
  },
  {
    "#": "22 Kent Sq, Unit 2 (128-04-02)",
    "$": 1181400,
    "address": "22 Kent Sq, Unit 2",
    "parcel_id": "128-04-02",
    "owner1": "HORNFELDT, JOHN E & JESSICA G",
    "owner2": "",
    "current_taxes": 8462.6,
    "new_taxes_no_override": 8828.18,
    "override_total_1": 9078.68,
    "override_increase_1": 250.49
  },
  {
    "#": "25 Kent Sq (129-04-00)",
    "$": 2482300,
    "address": "25 Kent Sq",
    "parcel_id": "129-04-00",
    "owner1": "NAGLER, JOSHUA",
    "owner2": "KANOSKY, JAN",
    "current_taxes": 21783.82,
    "new_taxes_no_override": 22724.88,
    "override_total_1": 23369.68,
    "override_increase_1": 644.8
  },
  {
    "#": "26 Kent Sq (128-03-00)",
    "$": 2266200,
    "address": "26 Kent Sq",
    "parcel_id": "128-03-00",
    "owner1": "FEIT TRS, ZEEV & HAVA",
    "owner2": "",
    "current_taxes": 19570.95,
    "new_taxes_no_override": 20416.42,
    "override_total_1": 20995.72,
    "override_increase_1": 579.3
  },
  {
    "#": "31 Kent Sq (129-05-00)",
    "$": 1630600,
    "address": "31 Kent Sq",
    "parcel_id": "129-05-00",
    "owner1": "DEBOURGKNECHT, FAITH N & GREGORY L",
    "owner2": "",
    "current_taxes": 13062.41,
    "new_taxes_no_override": 13626.71,
    "override_total_1": 14013.35,
    "override_increase_1": 386.65
  },
  {
    "#": "32 Kent Sq, Unit 1 (128-02-01)",
    "$": 1877100,
    "address": "32 Kent Sq, Unit 1",
    "parcel_id": "128-02-01",
    "owner1": "AHMED, ARSHAD & MARY PAYSON CHESLEY",
    "owner2": "",
    "current_taxes": 19221.5,
    "new_taxes_no_override": 20051.87,
    "override_total_1": 20620.83,
    "override_increase_1": 568.96
  },
  {
    "#": "32 Kent Sq, Unit 2 (128-02-02)",
    "$": 2294400,
    "address": "32 Kent Sq, Unit 2",
    "parcel_id": "128-02-02",
    "owner1": "BHASHYAM, HEMALI T & ABHIRAM R",
    "owner2": "",
    "current_taxes": 19859.72,
    "new_taxes_no_override": 20717.66,
    "override_total_1": 21305.51,
    "override_increase_1": 587.85
  },
  {
    "#": "33 Kent Sq (129-06-00)",
    "$": 2134200,
    "address": "33 Kent Sq",
    "parcel_id": "129-06-00",
    "owner1": "COGGESHALL TRS, GEORGE B",
    "owner2": "STARR, JULIE ANN",
    "current_taxes": 18219.27,
    "new_taxes_no_override": 19006.34,
    "override_total_1": 19545.63,
    "override_increase_1": 539.29
  },
  {
    "#": "7 Kent St, Unit 1 & P3 (140-11-04)",
    "$": 411800,
    "address": "7 Kent St, Unit 1 & P3",
    "parcel_id": "140-11-04",
    "owner1": "LINDSAY, ANDREA T",
    "owner2": "",
    "current_taxes": 7066.49,
    "new_taxes_no_override": 7371.76,
    "override_total_1": 7580.93,
    "override_increase_1": 209.17
  },
  {
    "#": "7 Kent St, Unit 2 & P2 (140-11-01)",
    "$": 439100,
    "address": "7 Kent St, Unit 2 & P2",
    "parcel_id": "140-11-01",
    "owner1": "VARGHESE, THOMAS & LIGY K",
    "owner2": "",
    "current_taxes": 7534.96,
    "new_taxes_no_override": 7860.47,
    "override_total_1": 8083.51,
    "override_increase_1": 223.03
  },
  {
    "#": "7 Kent St, Unit 3 & P1 (140-11-02)",
    "$": 452800,
    "address": "7 Kent St, Unit 3 & P1",
    "parcel_id": "140-11-02",
    "owner1": "FERRIGNO, MARCIA",
    "owner2": "",
    "current_taxes": 7770.05,
    "new_taxes_no_override": 8105.72,
    "override_total_1": 8335.71,
    "override_increase_1": 229.99
  },
  {
    "#": "7 Kent St, Unit 4 P4 P5 (140-11-03)",
    "$": 685800,
    "address": "7 Kent St, Unit 4 P4 P5",
    "parcel_id": "140-11-03",
    "owner1": "BROOOKEDAVEPOOK LLC",
    "owner2": "C/O DAVID GERZOF RICHARD",
    "current_taxes": 11768.33,
    "new_taxes_no_override": 12276.72,
    "override_total_1": 12625.06,
    "override_increase_1": 348.34
  },
  {
    "#": "9 Kent St (140-12-00)",
    "$": 1770900,
    "address": "9 Kent St",
    "parcel_id": "140-12-00",
    "owner1": "MCWADE, ALICE",
    "owner2": "DRISCOLL, CLARE",
    "current_taxes": 14499.08,
    "new_taxes_no_override": 15125.44,
    "override_total_1": 15554.61,
    "override_increase_1": 429.17
  },
  {
    "#": "11 Kent St (140-13-00)",
    "$": 1969800,
    "address": "11 Kent St",
    "parcel_id": "140-13-00",
    "owner1": "MALICK TRS, AMY & LOIS",
    "owner2": "",
    "current_taxes": 30162.09,
    "new_taxes_no_override": 31465.09,
    "override_total_1": 32357.89,
    "override_increase_1": 892.8
  },
  {
    "#": "16 Kent St (140A-03-00)",
    "$": 3677500,
    "address": "16 Kent St",
    "parcel_id": "140A-03-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O KENT-WEBSTER PL PARKING LOT",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "17 Kent St (140-14-01)",
    "$": 2181700,
    "address": "17 Kent St",
    "parcel_id": "140-14-01",
    "owner1": "KRONENBERGER, JOHN & JULIE",
    "owner2": "",
    "current_taxes": 18705.67,
    "new_taxes_no_override": 19513.75,
    "override_total_1": 20067.44,
    "override_increase_1": 553.69
  },
  {
    "#": "20 Kent St (140A-02-00)",
    "$": 6747300,
    "address": "20 Kent St",
    "parcel_id": "140A-02-00",
    "owner1": "ALPER, TR, FREDERIC M",
    "owner2": "C/O ADVANTAGE PROPERTY MGMT",
    "current_taxes": 115783.67,
    "new_taxes_no_override": 120785.52,
    "override_total_1": 124212.72,
    "override_increase_1": 3427.2
  },
  {
    "#": "21 Kent St, Unit 1 & P6 P7 (140-15-01)",
    "$": 1278100,
    "address": "21 Kent St, Unit 1 & P6 P7",
    "parcel_id": "140-15-01",
    "owner1": "SEARS, LISAMARIE",
    "owner2": "MICHAELSON, SETH B & ROBERT I",
    "current_taxes": 13087.74,
    "new_taxes_no_override": 13653.13,
    "override_total_1": 14040.53,
    "override_increase_1": 387.4
  },
  {
    "#": "21 Kent St, Unit 2 & P1 P3 (140-15-02)",
    "$": 927800,
    "address": "21 Kent St, Unit 2 & P1 P3",
    "parcel_id": "140-15-02",
    "owner1": "STEPHENS, ERIC THOMAS & CATHERINE HALPIN",
    "owner2": "",
    "current_taxes": 9500.67,
    "new_taxes_no_override": 9911.1,
    "override_total_1": 10192.32,
    "override_increase_1": 281.22
  },
  {
    "#": "21 Kent St, Unit 3 & P4 P5 (140-15-03)",
    "$": 946500,
    "address": "21 Kent St, Unit 3 & P4 P5",
    "parcel_id": "140-15-03",
    "owner1": "WANG, CHUANJINGWEI & XUAN",
    "owner2": "",
    "current_taxes": 6057.23,
    "new_taxes_no_override": 6318.9,
    "override_total_1": 6498.2,
    "override_increase_1": 179.29
  },
  {
    "#": "21 Kent St, Unit B & P2 (140-15-04)",
    "$": 877000,
    "address": "21 Kent St, Unit B & P2",
    "parcel_id": "140-15-04",
    "owner1": "MEADOWS, ALICE",
    "owner2": "POLD, PETER",
    "current_taxes": 5345.55,
    "new_taxes_no_override": 5576.48,
    "override_total_1": 5734.71,
    "override_increase_1": 158.23
  },
  {
    "#": "25 Kent St (140-05-00)",
    "$": 2424100,
    "address": "25 Kent St",
    "parcel_id": "140-05-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O KENT-STATION PARKING LOT",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "32 Kent St (140A-01-00)",
    "$": 1673200,
    "address": "32 Kent St",
    "parcel_id": "140A-01-00",
    "owner1": "ALPER, TR, FREDERIC M",
    "owner2": "C/O ADVANTAGE PROPERTY MGMT",
    "current_taxes": 28712.11,
    "new_taxes_no_override": 29952.47,
    "override_total_1": 30802.35,
    "override_increase_1": 849.88
  },
  {
    "#": "33 Kent St, Unit 33-1 (140-17-17)",
    "$": 819100,
    "address": "33 Kent St, Unit 33-1",
    "parcel_id": "140-17-17",
    "owner1": "33-1 KENT STREET LLC",
    "owner2": "",
    "current_taxes": 8387.58,
    "new_taxes_no_override": 8749.92,
    "override_total_1": 8998.2,
    "override_increase_1": 248.27
  },
  {
    "#": "33 Kent St, Unit 33-2 (140-17-01)",
    "$": 1106400,
    "address": "33 Kent St, Unit 33-2",
    "parcel_id": "140-17-01",
    "owner1": "BA, LORITA KIT",
    "owner2": "",
    "current_taxes": 7694.6,
    "new_taxes_no_override": 8027.01,
    "override_total_1": 8254.77,
    "override_increase_1": 227.76
  },
  {
    "#": "33 Kent St, Unit 33-3 (140-17-02)",
    "$": 839500,
    "address": "33 Kent St, Unit 33-3",
    "parcel_id": "140-17-02",
    "owner1": "CHU, QIUMING",
    "owner2": "ZHU, MENGYU",
    "current_taxes": 8596.48,
    "new_taxes_no_override": 8967.85,
    "override_total_1": 9222.3,
    "override_increase_1": 254.46
  },
  {
    "#": "33 Kent St, Unit 33-4 (140-17-03)",
    "$": 817400,
    "address": "33 Kent St, Unit 33-4",
    "parcel_id": "140-17-03",
    "owner1": "SANTANA, HERNAN",
    "owner2": "KOLESSIN, LUDMILA",
    "current_taxes": 4735.24,
    "new_taxes_no_override": 4939.8,
    "override_total_1": 5079.97,
    "override_increase_1": 140.16
  },
  {
    "#": "33 Kent St, Unit 33-5 (140-17-04)",
    "$": 817400,
    "address": "33 Kent St, Unit 33-5",
    "parcel_id": "140-17-04",
    "owner1": "HINKLE, CHAD L",
    "owner2": "",
    "current_taxes": 8370.18,
    "new_taxes_no_override": 8731.77,
    "override_total_1": 8979.53,
    "override_increase_1": 247.76
  },
  {
    "#": "33 Kent St, Unit 33-6 (140-17-05)",
    "$": 817400,
    "address": "33 Kent St, Unit 33-6",
    "parcel_id": "140-17-05",
    "owner1": "MAR, LYNN",
    "owner2": "QUAYLE, STEVEN NORMAN",
    "current_taxes": 4735.24,
    "new_taxes_no_override": 4939.8,
    "override_total_1": 5079.97,
    "override_increase_1": 140.16
  },
  {
    "#": "33 Kent St, Unit 33-7 (140-17-06)",
    "$": 807200,
    "address": "33 Kent St, Unit 33-7",
    "parcel_id": "140-17-06",
    "owner1": "SUTTON, SCOTT E & KAREN H",
    "owner2": "",
    "current_taxes": 4630.79,
    "new_taxes_no_override": 4830.84,
    "override_total_1": 4967.91,
    "override_increase_1": 137.07
  },
  {
    "#": "33 Kent St, Unit 33-8 (140-17-07)",
    "$": 813300,
    "address": "33 Kent St, Unit 33-8",
    "parcel_id": "140-17-07",
    "owner1": "TRAVIS, JOHN P",
    "owner2": "",
    "current_taxes": 4693.26,
    "new_taxes_no_override": 4896.01,
    "override_total_1": 5034.93,
    "override_increase_1": 138.92
  },
  {
    "#": "39 Kent St, Unit 39-1 (140-17-09)",
    "$": 920800,
    "address": "39 Kent St, Unit 39-1",
    "parcel_id": "140-17-09",
    "owner1": "PAREJA-SUNANDA, ROSA & EBENEZER",
    "owner2": "",
    "current_taxes": 5794.06,
    "new_taxes_no_override": 6044.36,
    "override_total_1": 6215.87,
    "override_increase_1": 171.5
  },
  {
    "#": "39 Kent St, Unit 39-2 (140-17-10)",
    "$": 814400,
    "address": "39 Kent St, Unit 39-2",
    "parcel_id": "140-17-10",
    "owner1": "YANG, JUNCHUN",
    "owner2": "",
    "current_taxes": 4704.52,
    "new_taxes_no_override": 4907.76,
    "override_total_1": 5047.01,
    "override_increase_1": 139.25
  },
  {
    "#": "39 Kent St, Unit 39-3 (140-17-11)",
    "$": 826900,
    "address": "39 Kent St, Unit 39-3",
    "parcel_id": "140-17-11",
    "owner1": "SOMERS, JOSEPH S",
    "owner2": "BARFIELD, WANDA D",
    "current_taxes": 8467.46,
    "new_taxes_no_override": 8833.25,
    "override_total_1": 9083.89,
    "override_increase_1": 250.64
  },
  {
    "#": "39 Kent St, Unit 39-4 (140-17-12)",
    "$": 853600,
    "address": "39 Kent St, Unit 39-4",
    "parcel_id": "140-17-12",
    "owner1": "ZIRIN, JONATHAN D",
    "owner2": "EBNER, ELIZABETH",
    "current_taxes": 8740.86,
    "new_taxes_no_override": 9118.47,
    "override_total_1": 9377.19,
    "override_increase_1": 258.73
  },
  {
    "#": "39 Kent St, Unit 39-5 (140-17-13)",
    "$": 819100,
    "address": "39 Kent St, Unit 39-5",
    "parcel_id": "140-17-13",
    "owner1": "MAHMOOD, FAISAL",
    "owner2": "NOOR, ZAHRA",
    "current_taxes": 4752.65,
    "new_taxes_no_override": 4957.96,
    "override_total_1": 5098.64,
    "override_increase_1": 140.68
  },
  {
    "#": "39 Kent St, Unit 39-6 (140-17-14)",
    "$": 814400,
    "address": "39 Kent St, Unit 39-6",
    "parcel_id": "140-17-14",
    "owner1": "FITZPATRICK, ROBERT E",
    "owner2": "DRISCOLL-FITZPATRICK, TRACEY A",
    "current_taxes": 4704.52,
    "new_taxes_no_override": 4907.76,
    "override_total_1": 5047.01,
    "override_increase_1": 139.25
  },
  {
    "#": "39 Kent St, Unit 39-7 (140-17-15)",
    "$": 807200,
    "address": "39 Kent St, Unit 39-7",
    "parcel_id": "140-17-15",
    "owner1": "YOSHIDA, KAZUKI & TOMOKO",
    "owner2": "",
    "current_taxes": 4630.79,
    "new_taxes_no_override": 4830.84,
    "override_total_1": 4967.91,
    "override_increase_1": 137.07
  },
  {
    "#": "39 Kent St, Unit 39-8 (140-17-16)",
    "$": 814400,
    "address": "39 Kent St, Unit 39-8",
    "parcel_id": "140-17-16",
    "owner1": "DOWLING, ROBERT",
    "owner2": "",
    "current_taxes": 8339.46,
    "new_taxes_no_override": 8699.72,
    "override_total_1": 8946.57,
    "override_increase_1": 246.85
  },
  {
    "#": "39 Kent St, Unit 39-B (140-17-08)",
    "$": 688500,
    "address": "39 Kent St, Unit 39-B",
    "parcel_id": "140-17-08",
    "owner1": "LINDSAY, EMMA MULLEN & JAMES R",
    "owner2": "",
    "current_taxes": 3415.31,
    "new_taxes_no_override": 3562.85,
    "override_total_1": 3663.94,
    "override_increase_1": 101.09
  },
  {
    "#": "40 Kent St (141-26-00)",
    "$": 2664000,
    "address": "40 Kent St",
    "parcel_id": "141-26-00",
    "owner1": "40 KENT STREET LLC",
    "owner2": "C/O DND HOMES LLC",
    "current_taxes": 45714.24,
    "new_taxes_no_override": 47689.1,
    "override_total_1": 49042.24,
    "override_increase_1": 1353.14
  },
  {
    "#": "41 Kent St, Unit A (140-18-02)",
    "$": 890900,
    "address": "41 Kent St, Unit A",
    "parcel_id": "140-18-02",
    "owner1": "WU, ZHONGHAO",
    "owner2": "GAO, QI",
    "current_taxes": 9122.82,
    "new_taxes_no_override": 9516.93,
    "override_total_1": 9786.96,
    "override_increase_1": 270.04
  },
  {
    "#": "41 Kent St, Unit B (140-18-03)",
    "$": 1041500,
    "address": "41 Kent St, Unit B",
    "parcel_id": "140-18-03",
    "owner1": "CHOW TR, JENNIFER J",
    "owner2": "BAILLIEUL, JOHN P",
    "current_taxes": 7030.03,
    "new_taxes_no_override": 7333.73,
    "override_total_1": 7541.82,
    "override_increase_1": 208.09
  },
  {
    "#": "43 Kent St (140-18-01)",
    "$": 1676200,
    "address": "43 Kent St",
    "parcel_id": "140-18-01",
    "owner1": "BARRON TR, ROSALYN",
    "owner2": "",
    "current_taxes": 17164.29,
    "new_taxes_no_override": 17905.79,
    "override_total_1": 18413.85,
    "override_increase_1": 508.06
  },
  {
    "#": "48 Kent St, Unit 1 (141-25-08)",
    "$": 1098700,
    "address": "48 Kent St, Unit 1",
    "parcel_id": "141-25-08",
    "owner1": "STAVROPULOS, JOHN & JADE IWASAKA NEDER",
    "owner2": "",
    "current_taxes": 7615.75,
    "new_taxes_no_override": 7944.75,
    "override_total_1": 8170.18,
    "override_increase_1": 225.43
  },
  {
    "#": "48 Kent St, Unit 2 (141-25-01)",
    "$": 996500,
    "address": "48 Kent St, Unit 2",
    "parcel_id": "141-25-01",
    "owner1": "BARRETT TRS, SUSAN",
    "owner2": "DANIEL, NANCY J",
    "current_taxes": 10204.16,
    "new_taxes_no_override": 10644.98,
    "override_total_1": 10947.02,
    "override_increase_1": 302.04
  },
  {
    "#": "48 Kent St, Unit 3 (141-25-02)",
    "$": 977300,
    "address": "48 Kent St, Unit 3",
    "parcel_id": "141-25-02",
    "owner1": "HOULE TRS, DAVID A & JANE H",
    "owner2": "",
    "current_taxes": 10007.55,
    "new_taxes_no_override": 10439.88,
    "override_total_1": 10736.1,
    "override_increase_1": 296.22
  },
  {
    "#": "48 Kent St, Unit 4 (141-25-03)",
    "$": 986600,
    "address": "48 Kent St, Unit 4",
    "parcel_id": "141-25-03",
    "owner1": "RADOVANOV, SVETLANA",
    "owner2": "",
    "current_taxes": 6467.85,
    "new_taxes_no_override": 6747.26,
    "override_total_1": 6938.71,
    "override_increase_1": 191.45
  },
  {
    "#": "48 Kent St, Unit 5 (141-25-04)",
    "$": 1002300,
    "address": "48 Kent St, Unit 5",
    "parcel_id": "141-25-04",
    "owner1": "CHIN TRS, HORACIO & ALICE H Y",
    "owner2": "",
    "current_taxes": 6628.62,
    "new_taxes_no_override": 6914.98,
    "override_total_1": 7111.18,
    "override_increase_1": 196.21
  },
  {
    "#": "48 Kent St, Unit 6 (141-25-05)",
    "$": 1025900,
    "address": "48 Kent St, Unit 6",
    "parcel_id": "141-25-05",
    "owner1": "CHAN, TAI M",
    "owner2": "CHANG, NANCY",
    "current_taxes": 6870.28,
    "new_taxes_no_override": 7167.08,
    "override_total_1": 7370.44,
    "override_increase_1": 203.36
  },
  {
    "#": "48 Kent St, Unit 7 & P7 (141-25-06)",
    "$": 1001300,
    "address": "48 Kent St, Unit 7 & P7",
    "parcel_id": "141-25-06",
    "owner1": "MALABANAN, ALAN O & DIANNE C",
    "owner2": "",
    "current_taxes": 6618.38,
    "new_taxes_no_override": 6904.29,
    "override_total_1": 7100.2,
    "override_increase_1": 195.9
  },
  {
    "#": "48 Kent St, Unit 8 (141-25-07)",
    "$": 944300,
    "address": "48 Kent St, Unit 8",
    "parcel_id": "141-25-07",
    "owner1": "MATTESON, DOREEN F",
    "owner2": "",
    "current_taxes": 6034.7,
    "new_taxes_no_override": 6295.4,
    "override_total_1": 6474.03,
    "override_increase_1": 178.63
  },
  {
    "#": "50 Kent St (141-24-00)",
    "$": 9905300,
    "address": "50 Kent St",
    "parcel_id": "141-24-00",
    "owner1": "KENT STREET SOUTH LLC",
    "owner2": "",
    "current_taxes": 101430.27,
    "new_taxes_no_override": 105812.06,
    "override_total_1": 108814.39,
    "override_increase_1": 3002.34
  },
  {
    "#": "58 Kent St (141-23-00)",
    "$": 6534900,
    "address": "58 Kent St",
    "parcel_id": "141-23-00",
    "owner1": "KENT STREET DEVELOPMENT LLC",
    "owner2": "",
    "current_taxes": 75509.16,
    "new_taxes_no_override": 78771.16,
    "override_total_1": 81006.23,
    "override_increase_1": 2235.07
  },
  {
    "#": "72 Kent St, Unit D-1 & G10-22 (141-22-21)",
    "$": 1197400,
    "address": "72 Kent St, Unit D-1 & G10-22",
    "parcel_id": "141-22-21",
    "owner1": "KOOP REALTY LLC",
    "owner2": "",
    "current_taxes": 12261.38,
    "new_taxes_no_override": 12791.07,
    "override_total_1": 13154.01,
    "override_increase_1": 362.94
  },
  {
    "#": "74 Kent St, Unit C-1 & G9-11 (141-22-07)",
    "$": 1135200,
    "address": "74 Kent St, Unit C-1 & G9-11",
    "parcel_id": "141-22-07",
    "owner1": "LIANG TR, PATRIC",
    "owner2": "",
    "current_taxes": 11624.45,
    "new_taxes_no_override": 12126.63,
    "override_total_1": 12470.71,
    "override_increase_1": 344.08
  },
  {
    "#": "74 Kent St, Unit C-10 & G20-39 (141-22-16)",
    "$": 1838000,
    "address": "74 Kent St, Unit C-10 & G20-39",
    "parcel_id": "141-22-16",
    "owner1": "LIN, BRIAN",
    "owner2": "GROSS, KAYLA MARIE",
    "current_taxes": 15186.19,
    "new_taxes_no_override": 15842.23,
    "override_total_1": 16291.74,
    "override_increase_1": 449.51
  },
  {
    "#": "74 Kent St, Unit C-11 & G40-41 (141-22-17)",
    "$": 1995200,
    "address": "74 Kent St, Unit C-11 & G40-41",
    "parcel_id": "141-22-17",
    "owner1": "PRINTZ, ERIC R",
    "owner2": "",
    "current_taxes": 16795.91,
    "new_taxes_no_override": 17521.49,
    "override_total_1": 18018.65,
    "override_increase_1": 497.16
  },
  {
    "#": "74 Kent St, Unit C-12 & G4-15 (141-22-18)",
    "$": 1152800,
    "address": "74 Kent St, Unit C-12 & G4-15",
    "parcel_id": "141-22-18",
    "owner1": "RAWLINSON, GORDON & VICKI",
    "owner2": "",
    "current_taxes": 11804.67,
    "new_taxes_no_override": 12314.63,
    "override_total_1": 12664.05,
    "override_increase_1": 349.42
  },
  {
    "#": "74 Kent St, Unit C-13 & G26-33 (141-22-19)",
    "$": 1100700,
    "address": "74 Kent St, Unit C-13 & G26-33",
    "parcel_id": "141-22-19",
    "owner1": "YEUNG, MIKE",
    "owner2": "LI, STEPHANIE",
    "current_taxes": 7636.23,
    "new_taxes_no_override": 7966.12,
    "override_total_1": 8192.15,
    "override_increase_1": 226.03
  },
  {
    "#": "74 Kent St, Unit C-14 & G25-32 (141-22-20)",
    "$": 1122600,
    "address": "74 Kent St, Unit C-14 & G25-32",
    "parcel_id": "141-22-20",
    "owner1": "FIALKOFF, LAUREN & JARED",
    "owner2": "",
    "current_taxes": 7860.49,
    "new_taxes_no_override": 8200.06,
    "override_total_1": 8432.73,
    "override_increase_1": 232.67
  },
  {
    "#": "74 Kent St, Unit C-2 & G1-12 (141-22-08)",
    "$": 1159000,
    "address": "74 Kent St, Unit C-2 & G1-12",
    "parcel_id": "141-22-08",
    "owner1": "LIANG, PATRIC & YU MING & SHU CHEN",
    "owner2": "",
    "current_taxes": 11868.16,
    "new_taxes_no_override": 12380.86,
    "override_total_1": 12732.16,
    "override_increase_1": 351.3
  },
  {
    "#": "74 Kent St, Unit C-3 & G2-13 (141-22-09)",
    "$": 1187500,
    "address": "74 Kent St, Unit C-3 & G2-13",
    "parcel_id": "141-22-09",
    "owner1": "TSOU TRS, DUU-CHUNG",
    "owner2": "WEN, SU-FENG",
    "current_taxes": 12160.0,
    "new_taxes_no_override": 12685.31,
    "override_total_1": 13045.25,
    "override_increase_1": 359.94
  },
  {
    "#": "74 Kent St, Unit C-4 & G37 (141-22-10)",
    "$": 293500,
    "address": "74 Kent St, Unit C-4 & G37",
    "parcel_id": "141-22-10",
    "owner1": "BOWDEN TRS, R S",
    "owner2": "C/O RCG LLC",
    "current_taxes": 3005.44,
    "new_taxes_no_override": 3135.28,
    "override_total_1": 3224.24,
    "override_increase_1": 88.96
  },
  {
    "#": "74 Kent St, Unit C-5 & G3-14 (141-22-11)",
    "$": 1152800,
    "address": "74 Kent St, Unit C-5 & G3-14",
    "parcel_id": "141-22-11",
    "owner1": "POTTER TR, SUSAN R",
    "owner2": "",
    "current_taxes": 8169.74,
    "new_taxes_no_override": 8522.67,
    "override_total_1": 8764.5,
    "override_increase_1": 241.82
  },
  {
    "#": "74 Kent St, Unit C-6 & G23-30 (141-22-12)",
    "$": 1225000,
    "address": "74 Kent St, Unit C-6 & G23-30",
    "parcel_id": "141-22-12",
    "owner1": "ZHANG, NINGYAN",
    "owner2": "AN, ZHIQIANG",
    "current_taxes": 12544.0,
    "new_taxes_no_override": 13085.9,
    "override_total_1": 13457.2,
    "override_increase_1": 371.3
  },
  {
    "#": "74 Kent St, Unit C-7 &  G6-17 (141-22-13)",
    "$": 1296800,
    "address": "74 Kent St, Unit C-7 &  G6-17",
    "parcel_id": "141-22-13",
    "owner1": "WEBBER, RICHARD M & STEPHANIE J",
    "owner2": "",
    "current_taxes": 9644.3,
    "new_taxes_no_override": 10060.93,
    "override_total_1": 10346.41,
    "override_increase_1": 285.47
  },
  {
    "#": "74 Kent St, Unit C-8 & G24-31 (141-22-14)",
    "$": 1160300,
    "address": "74 Kent St, Unit C-8 & G24-31",
    "parcel_id": "141-22-14",
    "owner1": "74 KENT ST UNIT C-8 LLC",
    "owner2": "C/O ZOIS BESS",
    "current_taxes": 11881.47,
    "new_taxes_no_override": 12394.75,
    "override_total_1": 12746.44,
    "override_increase_1": 351.69
  },
  {
    "#": "74 Kent St, Unit C-9 &  G5-16 (141-22-15)",
    "$": 1152800,
    "address": "74 Kent St, Unit C-9 &  G5-16",
    "parcel_id": "141-22-15",
    "owner1": "MEHTA, ROHINI",
    "owner2": "PORWAL, YATISH",
    "current_taxes": 8169.74,
    "new_taxes_no_override": 8522.67,
    "override_total_1": 8764.5,
    "override_increase_1": 241.82
  },
  {
    "#": "76 Kent St, Unit B-1 & G29-36 (141-22-04)",
    "$": 1108100,
    "address": "76 Kent St, Unit B-1 & G29-36",
    "parcel_id": "141-22-04",
    "owner1": "HOWELL, JOHN",
    "owner2": "",
    "current_taxes": 7712.01,
    "new_taxes_no_override": 8045.17,
    "override_total_1": 8273.44,
    "override_increase_1": 228.28
  },
  {
    "#": "76 Kent St, Unit B-2 & G28-35 (141-22-05)",
    "$": 1361500,
    "address": "76 Kent St, Unit B-2 & G28-35",
    "parcel_id": "141-22-05",
    "owner1": "AHN, SEONG WAN",
    "owner2": "WON, JEONG",
    "current_taxes": 10306.83,
    "new_taxes_no_override": 10752.09,
    "override_total_1": 11057.17,
    "override_increase_1": 305.08
  },
  {
    "#": "76 Kent St, Unit B-3 & G27-34 (141-22-06)",
    "$": 1353900,
    "address": "76 Kent St, Unit B-3 & G27-34",
    "parcel_id": "141-22-06",
    "owner1": "YANG, VICKY K",
    "owner2": "CURRIE, MATTHEW T",
    "current_taxes": 10229.0,
    "new_taxes_no_override": 10670.89,
    "override_total_1": 10973.67,
    "override_increase_1": 302.78
  },
  {
    "#": "90 Kent St (146-19-00)",
    "$": 2116100,
    "address": "90 Kent St",
    "parcel_id": "146-19-00",
    "owner1": "LI, YIN",
    "owner2": "LEE, HONGMEI",
    "current_taxes": 21668.86,
    "new_taxes_no_override": 22604.95,
    "override_total_1": 23246.35,
    "override_increase_1": 641.4
  },
  {
    "#": "96 Kent St (146-18-00)",
    "$": 1907400,
    "address": "96 Kent St",
    "parcel_id": "146-18-00",
    "owner1": "KUMAR, ARVIND",
    "owner2": "JAGASIA, PALLAVI",
    "current_taxes": 19531.78,
    "new_taxes_no_override": 20375.55,
    "override_total_1": 20953.69,
    "override_increase_1": 578.14
  },
  {
    "#": "99 Kent St (142-01-00)",
    "$": 28841200,
    "address": "99 Kent St",
    "parcel_id": "142-01-00",
    "owner1": "KENT STREET ELDERLY LIMITED PARTNERSHIP",
    "owner2": "C/O WINNCOMPANIES",
    "current_taxes": 295333.89,
    "new_taxes_no_override": 308092.31,
    "override_total_1": 316834.2,
    "override_increase_1": 8741.88
  },
  {
    "#": "110 Kent St (145-01-00)",
    "$": 2963400,
    "address": "110 Kent St",
    "parcel_id": "145-01-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O MURPHY PLAYGROUND",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "117 Kent St, Unit 1 (143-02-03)",
    "$": 1003100,
    "address": "117 Kent St, Unit 1",
    "parcel_id": "143-02-03",
    "owner1": "LIN, HSI CHIANG & SHARON SHIAO-JUNG",
    "owner2": "",
    "current_taxes": 6636.81,
    "new_taxes_no_override": 6923.52,
    "override_total_1": 7119.97,
    "override_increase_1": 196.45
  },
  {
    "#": "117 Kent St, Unit 2 (143-02-01)",
    "$": 1018400,
    "address": "117 Kent St, Unit 2",
    "parcel_id": "143-02-01",
    "owner1": "CHRIST, ALAN",
    "owner2": "LEWINTER, ROBIN",
    "current_taxes": 6793.48,
    "new_taxes_no_override": 7086.96,
    "override_total_1": 7288.05,
    "override_increase_1": 201.09
  },
  {
    "#": "117 Kent St, Unit 3 (143-02-02)",
    "$": 1003800,
    "address": "117 Kent St, Unit 3",
    "parcel_id": "143-02-02",
    "owner1": "BAART, ROBERT C & KAREN S",
    "owner2": "",
    "current_taxes": 6643.98,
    "new_taxes_no_override": 6931.0,
    "override_total_1": 7127.66,
    "override_increase_1": 196.66
  },
  {
    "#": "122 Kent St (144-01-00)",
    "$": 2409800,
    "address": "122 Kent St",
    "parcel_id": "144-01-00",
    "owner1": "STARR, MARK",
    "owner2": "KOSHNER, KAREN",
    "current_taxes": 21041.42,
    "new_taxes_no_override": 21950.41,
    "override_total_1": 22573.24,
    "override_increase_1": 622.83
  },
  {
    "#": "123 Kent St (143-03-00)",
    "$": 2753000,
    "address": "123 Kent St",
    "parcel_id": "143-03-00",
    "owner1": "123 KENT STREET REALTY LLC",
    "owner2": "C/O PINEO",
    "current_taxes": 28190.72,
    "new_taxes_no_override": 29408.56,
    "override_total_1": 30243.0,
    "override_increase_1": 834.45
  },
  {
    "#": "125 Kent St (143-04-00)",
    "$": 2747900,
    "address": "125 Kent St",
    "parcel_id": "143-04-00",
    "owner1": "MUNZER, TRS, HELEN B",
    "owner2": "",
    "current_taxes": 28138.5,
    "new_taxes_no_override": 29354.08,
    "override_total_1": 30186.98,
    "override_increase_1": 832.9
  },
  {
    "#": "128 Kent St (144-26-00)",
    "$": 2141700,
    "address": "128 Kent St",
    "parcel_id": "144-26-00",
    "owner1": "HARMSWORTH, JILLIAN",
    "owner2": "MORRISSEY, STEPHEN",
    "current_taxes": 18296.07,
    "new_taxes_no_override": 19086.46,
    "override_total_1": 19628.02,
    "override_increase_1": 541.56
  },
  {
    "#": "131 Kent St (143-05-00)",
    "$": 2421500,
    "address": "131 Kent St",
    "parcel_id": "143-05-00",
    "owner1": "WELU, JORDAN & MENDIE",
    "owner2": "",
    "current_taxes": 21161.23,
    "new_taxes_no_override": 22075.4,
    "override_total_1": 22701.77,
    "override_increase_1": 626.37
  },
  {
    "#": "143 Kent St, Unit 1 (127-19-01)",
    "$": 1672200,
    "address": "143 Kent St, Unit 1",
    "parcel_id": "127-19-01",
    "owner1": "LANCASTER, MARIANNA",
    "owner2": "MOURA, ARICILO",
    "current_taxes": 17123.33,
    "new_taxes_no_override": 17863.06,
    "override_total_1": 18369.91,
    "override_increase_1": 506.85
  },
  {
    "#": "143 Kent St, Unit 2 (127-19-02)",
    "$": 1976200,
    "address": "143 Kent St, Unit 2",
    "parcel_id": "127-19-02",
    "owner1": "BATES, TOBY ANTHONY",
    "owner2": "LAI, MARGARET JUDY",
    "current_taxes": 16601.35,
    "new_taxes_no_override": 17318.53,
    "override_total_1": 17809.93,
    "override_increase_1": 491.4
  },
  {
    "#": "147 Kent St, Unit 1 (127-18-01)",
    "$": 2546600,
    "address": "147 Kent St, Unit 1",
    "parcel_id": "127-18-01",
    "owner1": "AIGLON-KENT LLC",
    "owner2": "",
    "current_taxes": 26077.18,
    "new_taxes_no_override": 27203.71,
    "override_total_1": 27975.6,
    "override_increase_1": 771.88
  },
  {
    "#": "147 Kent St, Unit 2 (127-18-02)",
    "$": 2544100,
    "address": "147 Kent St, Unit 2",
    "parcel_id": "127-18-02",
    "owner1": "OLIVER TR, ELIZABETH",
    "owner2": "OLIVER KENT LLC",
    "current_taxes": 26051.58,
    "new_taxes_no_override": 27177.01,
    "override_total_1": 27948.14,
    "override_increase_1": 771.13
  },
  {
    "#": "147 Kent St, Unit 3 (127-18-03)",
    "$": 2869500,
    "address": "147 Kent St, Unit 3",
    "parcel_id": "127-18-03",
    "owner1": "SEMIGRAN TRS, GAIL E & MARC J",
    "owner2": "",
    "current_taxes": 29383.68,
    "new_taxes_no_override": 30653.05,
    "override_total_1": 31522.81,
    "override_increase_1": 869.76
  },
  {
    "#": "148 Kent St, Unit 148 (128-11-01)",
    "$": 2156100,
    "address": "148 Kent St, Unit 148",
    "parcel_id": "128-11-01",
    "owner1": "MOONEY, MICHAEL & THERESA",
    "owner2": "",
    "current_taxes": 22078.46,
    "new_taxes_no_override": 23032.25,
    "override_total_1": 23685.77,
    "override_increase_1": 653.52
  },
  {
    "#": "148 Kent St, Unit 150 (128-11-02)",
    "$": 2551700,
    "address": "148 Kent St, Unit 150",
    "parcel_id": "128-11-02",
    "owner1": "TANG, GAOYAN",
    "owner2": "CHEN, ADAM",
    "current_taxes": 22494.47,
    "new_taxes_no_override": 23466.23,
    "override_total_1": 24132.07,
    "override_increase_1": 665.84
  },
  {
    "#": "153 Kent St (127-17-00)",
    "$": 2069000,
    "address": "153 Kent St",
    "parcel_id": "127-17-00",
    "owner1": "BROOKLINE HOUSING AUTHORITY",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "159 Kent St (127-16-00)",
    "$": 1705100,
    "address": "159 Kent St",
    "parcel_id": "127-16-00",
    "owner1": "BARBAS, HELEN",
    "owner2": "COPPOCK, DONALD L",
    "current_taxes": 13825.29,
    "new_taxes_no_override": 14422.54,
    "override_total_1": 14831.77,
    "override_increase_1": 409.23
  },
  {
    "#": "163 Kent St, Unit 1 & G1 G2 (127-15-01)",
    "$": 1764600,
    "address": "163 Kent St, Unit 1 & G1 G2",
    "parcel_id": "127-15-01",
    "owner1": "LANDMAN, BRYAN NATHAN",
    "owner2": "ZULLOW, HAYLEY",
    "current_taxes": 18069.5,
    "new_taxes_no_override": 18850.1,
    "override_total_1": 19384.96,
    "override_increase_1": 534.86
  },
  {
    "#": "163 Kent St, Unit 2 & G5 G6 (127-15-02)",
    "$": 1795300,
    "address": "163 Kent St, Unit 2 & G5 G6",
    "parcel_id": "127-15-02",
    "owner1": "LEOPOLD, JOSEPH R",
    "owner2": "PINO, ELIZABETH C",
    "current_taxes": 14748.94,
    "new_taxes_no_override": 15386.09,
    "override_total_1": 15822.66,
    "override_increase_1": 436.57
  },
  {
    "#": "163 Kent St, Unit 3 & G3 G4 (127-15-03)",
    "$": 1802600,
    "address": "163 Kent St, Unit 3 & G3 G4",
    "parcel_id": "127-15-03",
    "owner1": "FLYNN FAMILY REVOCABLE TRUST",
    "owner2": "C/O FLYNN ROBYN V & SCOTT S TRS",
    "current_taxes": 14823.69,
    "new_taxes_no_override": 15464.07,
    "override_total_1": 15902.85,
    "override_increase_1": 438.78
  },
  {
    "#": "169 Kent St, Unit 1 & P37 (127-12-02)",
    "$": 546100,
    "address": "169 Kent St, Unit 1 & P37",
    "parcel_id": "127-12-02",
    "owner1": "STEVENS TR, JACQUELINE S",
    "owner2": "",
    "current_taxes": 1957.13,
    "new_taxes_no_override": 2041.68,
    "override_total_1": 2099.61,
    "override_increase_1": 57.93
  },
  {
    "#": "169 Kent St, Unit 2 & P22 (127-12-03)",
    "$": 536900,
    "address": "169 Kent St, Unit 2 & P22",
    "parcel_id": "127-12-03",
    "owner1": "KARNIADAKIS, GEORGE",
    "owner2": "CHRISTOU, HELEN",
    "current_taxes": 5497.86,
    "new_taxes_no_override": 5735.37,
    "override_total_1": 5898.1,
    "override_increase_1": 162.74
  },
  {
    "#": "169 Kent St, Unit 3 & P38 (127-12-04)",
    "$": 530800,
    "address": "169 Kent St, Unit 3 & P38",
    "parcel_id": "127-12-04",
    "owner1": "SHARAF, TR, ALAN B",
    "owner2": "",
    "current_taxes": 5435.39,
    "new_taxes_no_override": 5670.2,
    "override_total_1": 5831.09,
    "override_increase_1": 160.89
  },
  {
    "#": "169 Kent St, Unit 4 (127-12-05)",
    "$": 533800,
    "address": "169 Kent St, Unit 4",
    "parcel_id": "127-12-05",
    "owner1": "LI, RI",
    "owner2": "",
    "current_taxes": 1831.18,
    "new_taxes_no_override": 1910.29,
    "override_total_1": 1964.49,
    "override_increase_1": 54.2
  },
  {
    "#": "169 Kent St, Unit 5 & P39 (127-12-06)",
    "$": 547600,
    "address": "169 Kent St, Unit 5 & P39",
    "parcel_id": "127-12-06",
    "owner1": "YURKOVSKY TR, GREGORY",
    "owner2": "",
    "current_taxes": 5607.42,
    "new_taxes_no_override": 5849.66,
    "override_total_1": 6015.64,
    "override_increase_1": 165.98
  },
  {
    "#": "169 Kent St, Unit 6 & P24 (127-12-07)",
    "$": 539900,
    "address": "169 Kent St, Unit 6 & P24",
    "parcel_id": "127-12-07",
    "owner1": "169 KENT STREET APT 6 LLC",
    "owner2": "",
    "current_taxes": 5528.58,
    "new_taxes_no_override": 5767.41,
    "override_total_1": 5931.06,
    "override_increase_1": 163.65
  },
  {
    "#": "169 Kent St, Unit A & P35 (127-12-46)",
    "$": 396500,
    "address": "169 Kent St, Unit A & P35",
    "parcel_id": "127-12-46",
    "owner1": "MCHUGH TR, GEORGE",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 4060.16,
    "new_taxes_no_override": 4235.56,
    "override_total_1": 4355.74,
    "override_increase_1": 120.18
  },
  {
    "#": "169 Kent St, Unit B & P36 (127-12-01)",
    "$": 436300,
    "address": "169 Kent St, Unit B & P36",
    "parcel_id": "127-12-01",
    "owner1": "MCHUGH TR, GEORGE",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 4467.71,
    "new_taxes_no_override": 4660.72,
    "override_total_1": 4792.96,
    "override_increase_1": 132.24
  },
  {
    "#": "175 Kent St, Unit 1 & P43 (127-12-10)",
    "$": 541600,
    "address": "175 Kent St, Unit 1 & P43",
    "parcel_id": "127-12-10",
    "owner1": "SHARAF, TR, ALAN B",
    "owner2": "",
    "current_taxes": 5545.98,
    "new_taxes_no_override": 5785.57,
    "override_total_1": 5949.73,
    "override_increase_1": 164.16
  },
  {
    "#": "175 Kent St, Unit 2 (127-12-11)",
    "$": 912400,
    "address": "175 Kent St, Unit 2",
    "parcel_id": "127-12-11",
    "owner1": "RMZ CONDO LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 9342.98,
    "new_taxes_no_override": 9746.6,
    "override_total_1": 10023.15,
    "override_increase_1": 276.55
  },
  {
    "#": "175 Kent St, Unit 3 & P41 (127-12-12)",
    "$": 528600,
    "address": "175 Kent St, Unit 3 & P41",
    "parcel_id": "127-12-12",
    "owner1": "CARUSO, JOSEPH R",
    "owner2": "",
    "current_taxes": 5412.86,
    "new_taxes_no_override": 5646.7,
    "override_total_1": 5806.92,
    "override_increase_1": 160.22
  },
  {
    "#": "175 Kent St, Unit 4 & P25 (127-12-13)",
    "$": 637400,
    "address": "175 Kent St, Unit 4 & P25",
    "parcel_id": "127-12-13",
    "owner1": "CHAE, JIN BYUNG & SUE KYUNG",
    "owner2": "",
    "current_taxes": 6526.98,
    "new_taxes_no_override": 6808.95,
    "override_total_1": 7002.14,
    "override_increase_1": 193.2
  },
  {
    "#": "175 Kent St, Unit 5&P40 (127-12-14)",
    "$": 530100,
    "address": "175 Kent St, Unit 5&P40",
    "parcel_id": "127-12-14",
    "owner1": "MIKROUDIS, ARGYRO",
    "owner2": "",
    "current_taxes": 1793.29,
    "new_taxes_no_override": 1870.76,
    "override_total_1": 1923.84,
    "override_increase_1": 53.08
  },
  {
    "#": "175 Kent St, Unit 6 & P23 (127-12-15)",
    "$": 533800,
    "address": "175 Kent St, Unit 6 & P23",
    "parcel_id": "127-12-15",
    "owner1": "GOLDEN, CRAIG A",
    "owner2": "",
    "current_taxes": 1831.18,
    "new_taxes_no_override": 1910.29,
    "override_total_1": 1964.49,
    "override_increase_1": 54.2
  },
  {
    "#": "175 Kent St, Unit A & P42 (127-12-08)",
    "$": 399100,
    "address": "175 Kent St, Unit A & P42",
    "parcel_id": "127-12-08",
    "owner1": "MCHUGH TR, GEORGE",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 4086.78,
    "new_taxes_no_override": 4263.33,
    "override_total_1": 4384.3,
    "override_increase_1": 120.97
  },
  {
    "#": "175 Kent St, Unit B & P26 (127-12-09)",
    "$": 442100,
    "address": "175 Kent St, Unit B & P26",
    "parcel_id": "127-12-09",
    "owner1": "MCHUGH TR, GEORGE",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 4527.1,
    "new_taxes_no_override": 4722.67,
    "override_total_1": 4856.67,
    "override_increase_1": 134.0
  },
  {
    "#": "179 Kent St, Unit 1 & P21 (127-12-18)",
    "$": 536700,
    "address": "179 Kent St, Unit 1 & P21",
    "parcel_id": "127-12-18",
    "owner1": "SCHETTINO, IVANY A",
    "owner2": "",
    "current_taxes": 1860.87,
    "new_taxes_no_override": 1941.26,
    "override_total_1": 1996.34,
    "override_increase_1": 55.08
  },
  {
    "#": "179 Kent St, Unit 2&P48 (127-12-19)",
    "$": 533100,
    "address": "179 Kent St, Unit 2&P48",
    "parcel_id": "127-12-19",
    "owner1": "MIKROUDIS, ARGYRO P",
    "owner2": "",
    "current_taxes": 5458.94,
    "new_taxes_no_override": 5694.77,
    "override_total_1": 5856.35,
    "override_increase_1": 161.58
  },
  {
    "#": "179 Kent St, Unit 3& P44 P45 (127-12-20)",
    "$": 549700,
    "address": "179 Kent St, Unit 3& P44 P45",
    "parcel_id": "127-12-20",
    "owner1": "SHARAF, TR, ALAN B",
    "owner2": "",
    "current_taxes": 5628.93,
    "new_taxes_no_override": 5872.1,
    "override_total_1": 6038.72,
    "override_increase_1": 166.62
  },
  {
    "#": "179 Kent St, Unit 4 & P19 (127-12-21)",
    "$": 533800,
    "address": "179 Kent St, Unit 4 & P19",
    "parcel_id": "127-12-21",
    "owner1": "DOUBKO, TATIANA",
    "owner2": "",
    "current_taxes": 5466.11,
    "new_taxes_no_override": 5702.25,
    "override_total_1": 5864.04,
    "override_increase_1": 161.8
  },
  {
    "#": "179 Kent St, Unit 5 & P49 (127-12-22)",
    "$": 529300,
    "address": "179 Kent St, Unit 5 & P49",
    "parcel_id": "127-12-22",
    "owner1": "BARR, STEPHEN J",
    "owner2": "LEGGAT, MARTHA",
    "current_taxes": 5420.03,
    "new_taxes_no_override": 5654.18,
    "override_total_1": 5814.61,
    "override_increase_1": 160.43
  },
  {
    "#": "179 Kent St, Unit 6 & P20 (127-12-23)",
    "$": 531600,
    "address": "179 Kent St, Unit 6 & P20",
    "parcel_id": "127-12-23",
    "owner1": "GOODWIN, GAIL L",
    "owner2": "",
    "current_taxes": 1808.65,
    "new_taxes_no_override": 1886.78,
    "override_total_1": 1940.32,
    "override_increase_1": 53.54
  },
  {
    "#": "179 Kent St, Unit A & P46 (127-12-16)",
    "$": 423100,
    "address": "179 Kent St, Unit A & P46",
    "parcel_id": "127-12-16",
    "owner1": "MCHUGH TR, GEORGE",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 4332.54,
    "new_taxes_no_override": 4519.71,
    "override_total_1": 4647.95,
    "override_increase_1": 128.24
  },
  {
    "#": "179 Kent St, Unit B & P47 (127-12-17)",
    "$": 434000,
    "address": "179 Kent St, Unit B & P47",
    "parcel_id": "127-12-17",
    "owner1": "MCHUGH TR, GEORGE",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 4444.16,
    "new_taxes_no_override": 4636.15,
    "override_total_1": 4767.69,
    "override_increase_1": 131.55
  },
  {
    "#": "183 Kent St, Unit 1 (127-12-25)",
    "$": 509000,
    "address": "183 Kent St, Unit 1",
    "parcel_id": "127-12-25",
    "owner1": "LI, WEI",
    "owner2": "ZONG, ZONG",
    "current_taxes": 5212.16,
    "new_taxes_no_override": 5437.33,
    "override_total_1": 5591.61,
    "override_increase_1": 154.28
  },
  {
    "#": "183 Kent St, Unit 2 & P50 (127-12-26)",
    "$": 549700,
    "address": "183 Kent St, Unit 2 & P50",
    "parcel_id": "127-12-26",
    "owner1": "VELASQUEZ TR, MARGARITA",
    "owner2": "",
    "current_taxes": 5628.93,
    "new_taxes_no_override": 5872.1,
    "override_total_1": 6038.72,
    "override_increase_1": 166.62
  },
  {
    "#": "183 Kent St, Unit 3 & P18 (127-12-27)",
    "$": 557100,
    "address": "183 Kent St, Unit 3 & P18",
    "parcel_id": "127-12-27",
    "owner1": "KENT STREET REALTY LLC",
    "owner2": "",
    "current_taxes": 5704.7,
    "new_taxes_no_override": 5951.14,
    "override_total_1": 6120.0,
    "override_increase_1": 168.86
  },
  {
    "#": "183 Kent St, Unit 4 & P53 (127-12-28)",
    "$": 531600,
    "address": "183 Kent St, Unit 4 & P53",
    "parcel_id": "127-12-28",
    "owner1": "SHARAF, TR, ALAN B",
    "owner2": "",
    "current_taxes": 5443.58,
    "new_taxes_no_override": 5678.74,
    "override_total_1": 5839.87,
    "override_increase_1": 161.13
  },
  {
    "#": "183 Kent St, Unit 5 (127-12-29)",
    "$": 510400,
    "address": "183 Kent St, Unit 5",
    "parcel_id": "127-12-29",
    "owner1": "CHU, ANDY C",
    "owner2": "",
    "current_taxes": 1591.56,
    "new_taxes_no_override": 1660.32,
    "override_total_1": 1707.43,
    "override_increase_1": 47.11
  },
  {
    "#": "183 Kent St, Unit 6 & P15 (127-12-30)",
    "$": 534600,
    "address": "183 Kent St, Unit 6 & P15",
    "parcel_id": "127-12-30",
    "owner1": "ARNAOUT, RIMA",
    "owner2": "",
    "current_taxes": 1839.37,
    "new_taxes_no_override": 1918.83,
    "override_total_1": 1973.28,
    "override_increase_1": 54.45
  },
  {
    "#": "183 Kent St, Unit B & P51 (127-12-24)",
    "$": 429300,
    "address": "183 Kent St, Unit B & P51",
    "parcel_id": "127-12-24",
    "owner1": "MCHUGH TR, GEORGE",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 4396.03,
    "new_taxes_no_override": 4585.94,
    "override_total_1": 4716.06,
    "override_increase_1": 130.12
  },
  {
    "#": "186 Kent St (128-08-10)",
    "$": 36112400,
    "address": "186 Kent St",
    "parcel_id": "128-08-10",
    "owner1": "NORTHEASTERN UNIVERSITY",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "187 Kent St, Unit 1 & P58 (127-12-33)",
    "$": 552500,
    "address": "187 Kent St, Unit 1 & P58",
    "parcel_id": "127-12-33",
    "owner1": "FERRARO, CHRISTOPHER M",
    "owner2": "MCCARTHY-FERRARO, PATRICIA",
    "current_taxes": 5657.6,
    "new_taxes_no_override": 5902.01,
    "override_total_1": 6069.47,
    "override_increase_1": 167.46
  },
  {
    "#": "187 Kent St, Unit 2 & P4 (127-12-34)",
    "$": 629500,
    "address": "187 Kent St, Unit 2 & P4",
    "parcel_id": "127-12-34",
    "owner1": "BENN, SHARON & BERNADETTE",
    "owner2": "",
    "current_taxes": 2811.15,
    "new_taxes_no_override": 2932.59,
    "override_total_1": 3015.8,
    "override_increase_1": 83.21
  },
  {
    "#": "187 Kent St, Unit 3 & P56 (127-12-35)",
    "$": 527000,
    "address": "187 Kent St, Unit 3 & P56",
    "parcel_id": "127-12-35",
    "owner1": "SHARAF, TR, ALAN B",
    "owner2": "",
    "current_taxes": 5396.48,
    "new_taxes_no_override": 5629.61,
    "override_total_1": 5789.34,
    "override_increase_1": 159.74
  },
  {
    "#": "187 Kent St, Unit 4 & P10 (127-12-36)",
    "$": 534600,
    "address": "187 Kent St, Unit 4 & P10",
    "parcel_id": "127-12-36",
    "owner1": "ABUGOV TR, GREGORY",
    "owner2": "",
    "current_taxes": 5474.3,
    "new_taxes_no_override": 5710.79,
    "override_total_1": 5872.83,
    "override_increase_1": 162.04
  },
  {
    "#": "187 Kent St, Unit 5 & P12 (127-12-37)",
    "$": 523300,
    "address": "187 Kent St, Unit 5 & P12",
    "parcel_id": "127-12-37",
    "owner1": "YAGODA, DANIEL",
    "owner2": "",
    "current_taxes": 5358.59,
    "new_taxes_no_override": 5590.08,
    "override_total_1": 5748.7,
    "override_increase_1": 158.61
  },
  {
    "#": "187 Kent St, Unit 6 & P54 (127-12-38)",
    "$": 533800,
    "address": "187 Kent St, Unit 6 & P54",
    "parcel_id": "127-12-38",
    "owner1": "SHARAF, TR, ALAN B",
    "owner2": "",
    "current_taxes": 5466.11,
    "new_taxes_no_override": 5702.25,
    "override_total_1": 5864.04,
    "override_increase_1": 161.8
  },
  {
    "#": "187 Kent St, Unit A & P57 (127-12-31)",
    "$": 417800,
    "address": "187 Kent St, Unit A & P57",
    "parcel_id": "127-12-31",
    "owner1": "MCHUGH TR, GEORGE",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 4278.27,
    "new_taxes_no_override": 4463.09,
    "override_total_1": 4589.73,
    "override_increase_1": 126.64
  },
  {
    "#": "187 Kent St, Unit B & P13 (127-12-32)",
    "$": 419600,
    "address": "187 Kent St, Unit B & P13",
    "parcel_id": "127-12-32",
    "owner1": "HEALY, ELAINE M",
    "owner2": "",
    "current_taxes": 4296.7,
    "new_taxes_no_override": 4482.32,
    "override_total_1": 4609.5,
    "override_increase_1": 127.18
  },
  {
    "#": "191 Kent St, Unit 1 & P59 (127-12-40)",
    "$": 431900,
    "address": "191 Kent St, Unit 1 & P59",
    "parcel_id": "127-12-40",
    "owner1": "SHARAF, TR, ALAN B",
    "owner2": "",
    "current_taxes": 4422.66,
    "new_taxes_no_override": 4613.72,
    "override_total_1": 4744.63,
    "override_increase_1": 130.91
  },
  {
    "#": "191 Kent St, Unit 2 & P62 (127-12-41)",
    "$": 531600,
    "address": "191 Kent St, Unit 2 & P62",
    "parcel_id": "127-12-41",
    "owner1": "ZHOU TRS, YI",
    "owner2": "LI, QIHONG",
    "current_taxes": 5443.58,
    "new_taxes_no_override": 5678.74,
    "override_total_1": 5839.87,
    "override_increase_1": 161.13
  },
  {
    "#": "191 Kent St, Unit 3 & P60 (127-12-42)",
    "$": 438400,
    "address": "191 Kent St, Unit 3 & P60",
    "parcel_id": "127-12-42",
    "owner1": "SHARAF, TR, ALAN B",
    "owner2": "",
    "current_taxes": 4489.22,
    "new_taxes_no_override": 4683.15,
    "override_total_1": 4816.04,
    "override_increase_1": 132.88
  },
  {
    "#": "191 Kent St, Unit 4 & P63 (127-12-43)",
    "$": 535400,
    "address": "191 Kent St, Unit 4 & P63",
    "parcel_id": "127-12-43",
    "owner1": "SHARAF, TR, ALAN B",
    "owner2": "",
    "current_taxes": 5482.5,
    "new_taxes_no_override": 5719.34,
    "override_total_1": 5881.63,
    "override_increase_1": 162.28
  },
  {
    "#": "191 Kent St, Unit 5 & P61 (127-12-44)",
    "$": 440300,
    "address": "191 Kent St, Unit 5 & P61",
    "parcel_id": "127-12-44",
    "owner1": "SHARAF TR, ALAN B",
    "owner2": "CICERO TR, KAMA",
    "current_taxes": 4508.67,
    "new_taxes_no_override": 4703.44,
    "override_total_1": 4836.9,
    "override_increase_1": 133.46
  },
  {
    "#": "191 Kent St, Unit 6 & P8 (127-12-45)",
    "$": 538400,
    "address": "191 Kent St, Unit 6 & P8",
    "parcel_id": "127-12-45",
    "owner1": "ADAM, ROSALYN",
    "owner2": "",
    "current_taxes": 1878.28,
    "new_taxes_no_override": 1959.42,
    "override_total_1": 2015.02,
    "override_increase_1": 55.6
  },
  {
    "#": "191 Kent St, Unit A (127-12-39)",
    "$": 1113200,
    "address": "191 Kent St, Unit A",
    "parcel_id": "127-12-39",
    "owner1": "RMZ CONDO LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 11399.17,
    "new_taxes_no_override": 11891.61,
    "override_total_1": 12229.03,
    "override_increase_1": 337.42
  },
  {
    "#": "197 Kent St, Unit 11 & P1 (127-11-02)",
    "$": 607500,
    "address": "197 Kent St, Unit 11 & P1",
    "parcel_id": "127-11-02",
    "owner1": "LIN TRS, JIAN",
    "owner2": "DENG, BIJIA",
    "current_taxes": 6220.8,
    "new_taxes_no_override": 6489.54,
    "override_total_1": 6673.67,
    "override_increase_1": 184.14
  },
  {
    "#": "197 Kent St, Unit 12 & P21 (127-11-03)",
    "$": 592200,
    "address": "197 Kent St, Unit 12 & P21",
    "parcel_id": "127-11-03",
    "owner1": "AGUILAR, LAURA KARINA & LAURA K",
    "owner2": "AGUILAR-CORDOVA, ESTUARDO",
    "current_taxes": 2429.19,
    "new_taxes_no_override": 2534.13,
    "override_total_1": 2606.04,
    "override_increase_1": 71.9
  },
  {
    "#": "197 Kent St, Unit 12A (127-11-04)",
    "$": 408800,
    "address": "197 Kent St, Unit 12A",
    "parcel_id": "127-11-04",
    "owner1": "SPIEGEL, DANIEL M",
    "owner2": "",
    "current_taxes": 4186.11,
    "new_taxes_no_override": 4366.95,
    "override_total_1": 4490.86,
    "override_increase_1": 123.91
  },
  {
    "#": "197 Kent St, Unit 14 (127-11-05)",
    "$": 429000,
    "address": "197 Kent St, Unit 14",
    "parcel_id": "127-11-05",
    "owner1": "197 205 KENT STREET LLC",
    "owner2": "",
    "current_taxes": 4392.96,
    "new_taxes_no_override": 4582.74,
    "override_total_1": 4712.77,
    "override_increase_1": 130.03
  },
  {
    "#": "197 Kent St, Unit 15 (127-11-06)",
    "$": 515500,
    "address": "197 Kent St, Unit 15",
    "parcel_id": "127-11-06",
    "owner1": "197 205 KENT STREET LLC",
    "owner2": "",
    "current_taxes": 5278.72,
    "new_taxes_no_override": 5506.76,
    "override_total_1": 5663.01,
    "override_increase_1": 156.25
  },
  {
    "#": "197 Kent St, Unit 16 (127-11-07)",
    "$": 429000,
    "address": "197 Kent St, Unit 16",
    "parcel_id": "127-11-07",
    "owner1": "197 205 KENT STREET LLC",
    "owner2": "",
    "current_taxes": 4392.96,
    "new_taxes_no_override": 4582.74,
    "override_total_1": 4712.77,
    "override_increase_1": 130.03
  },
  {
    "#": "197 Kent St, Unit 17 (127-11-08)",
    "$": 582000,
    "address": "197 Kent St, Unit 17",
    "parcel_id": "127-11-08",
    "owner1": "ASTASHKEVICH TR, IRINA",
    "owner2": "",
    "current_taxes": 5959.68,
    "new_taxes_no_override": 6217.14,
    "override_total_1": 6393.54,
    "override_increase_1": 176.41
  },
  {
    "#": "197 Kent St, Unit 18 (127-11-09)",
    "$": 607500,
    "address": "197 Kent St, Unit 18",
    "parcel_id": "127-11-09",
    "owner1": "197 205 KENT STREET LLC",
    "owner2": "",
    "current_taxes": 6220.8,
    "new_taxes_no_override": 6489.54,
    "override_total_1": 6673.67,
    "override_increase_1": 184.14
  },
  {
    "#": "197 Kent St, Unit 21 (127-11-10)",
    "$": 607500,
    "address": "197 Kent St, Unit 21",
    "parcel_id": "127-11-10",
    "owner1": "197 205 KENT STREET LLC",
    "owner2": "",
    "current_taxes": 6220.8,
    "new_taxes_no_override": 6489.54,
    "override_total_1": 6673.67,
    "override_increase_1": 184.14
  },
  {
    "#": "197 Kent St, Unit 22 & P34 (127-11-11)",
    "$": 582000,
    "address": "197 Kent St, Unit 22 & P34",
    "parcel_id": "127-11-11",
    "owner1": "LI, DAYU",
    "owner2": "",
    "current_taxes": 2324.75,
    "new_taxes_no_override": 2425.18,
    "override_total_1": 2493.99,
    "override_increase_1": 68.81
  },
  {
    "#": "197 Kent St, Unit 23 (127-11-12)",
    "$": 433700,
    "address": "197 Kent St, Unit 23",
    "parcel_id": "127-11-12",
    "owner1": "WANG, RUI",
    "owner2": "VINEGONI, CLAUDIO",
    "current_taxes": 4441.09,
    "new_taxes_no_override": 4632.95,
    "override_total_1": 4764.4,
    "override_increase_1": 131.46
  },
  {
    "#": "197 Kent St, Unit 24 (127-11-13)",
    "$": 515500,
    "address": "197 Kent St, Unit 24",
    "parcel_id": "127-11-13",
    "owner1": "WHITTEMORE ET AL TRS, EDWIN P",
    "owner2": "C/O TAW FAMILY TRUST",
    "current_taxes": 5278.72,
    "new_taxes_no_override": 5506.76,
    "override_total_1": 5663.01,
    "override_increase_1": 156.25
  },
  {
    "#": "197 Kent St, Unit 25 (127-11-14)",
    "$": 515500,
    "address": "197 Kent St, Unit 25",
    "parcel_id": "127-11-14",
    "owner1": "LAKE, GERRY",
    "owner2": "",
    "current_taxes": 1643.79,
    "new_taxes_no_override": 1714.8,
    "override_total_1": 1763.46,
    "override_increase_1": 48.66
  },
  {
    "#": "197 Kent St, Unit 26 (127-11-15)",
    "$": 429000,
    "address": "197 Kent St, Unit 26",
    "parcel_id": "127-11-15",
    "owner1": "VOLDINS, DIDZIS M",
    "owner2": "YELLEN, ELIZABETH",
    "current_taxes": 4392.96,
    "new_taxes_no_override": 4582.74,
    "override_total_1": 4712.77,
    "override_increase_1": 130.03
  },
  {
    "#": "197 Kent St, Unit 27 & P10 (127-11-16)",
    "$": 607500,
    "address": "197 Kent St, Unit 27 & P10",
    "parcel_id": "127-11-16",
    "owner1": "KAFLE, BIR B",
    "owner2": "",
    "current_taxes": 6220.8,
    "new_taxes_no_override": 6489.54,
    "override_total_1": 6673.67,
    "override_increase_1": 184.14
  },
  {
    "#": "197 Kent St, Unit 28 & P32 (127-11-17)",
    "$": 582000,
    "address": "197 Kent St, Unit 28 & P32",
    "parcel_id": "127-11-17",
    "owner1": "BU, XIA",
    "owner2": "LI, XIAOYU",
    "current_taxes": 5959.68,
    "new_taxes_no_override": 6217.14,
    "override_total_1": 6393.54,
    "override_increase_1": 176.41
  },
  {
    "#": "197 Kent St, Unit 31 & P2 (127-11-18)",
    "$": 582000,
    "address": "197 Kent St, Unit 31 & P2",
    "parcel_id": "127-11-18",
    "owner1": "WU, ZHANGGUI",
    "owner2": "LIU, XIANG LANG",
    "current_taxes": 5959.68,
    "new_taxes_no_override": 6217.14,
    "override_total_1": 6393.54,
    "override_increase_1": 176.41
  },
  {
    "#": "197 Kent St, Unit 32 (127-11-19)",
    "$": 582000,
    "address": "197 Kent St, Unit 32",
    "parcel_id": "127-11-19",
    "owner1": "BAGDASARYAN, KARINE",
    "owner2": "",
    "current_taxes": 5959.68,
    "new_taxes_no_override": 6217.14,
    "override_total_1": 6393.54,
    "override_increase_1": 176.41
  },
  {
    "#": "197 Kent St, Unit 33 (127-11-20)",
    "$": 421100,
    "address": "197 Kent St, Unit 33",
    "parcel_id": "127-11-20",
    "owner1": "RIBAYA-MERCADO TR, JUDY D",
    "owner2": "",
    "current_taxes": 4312.06,
    "new_taxes_no_override": 4498.34,
    "override_total_1": 4625.98,
    "override_increase_1": 127.64
  },
  {
    "#": "197 Kent St, Unit 34 & P28 (127-11-21)",
    "$": 515500,
    "address": "197 Kent St, Unit 34 & P28",
    "parcel_id": "127-11-21",
    "owner1": "GANCHI, LEYLA S",
    "owner2": "",
    "current_taxes": 5278.72,
    "new_taxes_no_override": 5506.76,
    "override_total_1": 5663.01,
    "override_increase_1": 156.25
  },
  {
    "#": "197 Kent St, Unit 35 (127-11-22)",
    "$": 515500,
    "address": "197 Kent St, Unit 35",
    "parcel_id": "127-11-22",
    "owner1": "SPIVAC/DISSON LLC",
    "owner2": "",
    "current_taxes": 5278.72,
    "new_taxes_no_override": 5506.76,
    "override_total_1": 5663.01,
    "override_increase_1": 156.25
  },
  {
    "#": "197 Kent St, Unit 36 (127-11-23)",
    "$": 429000,
    "address": "197 Kent St, Unit 36",
    "parcel_id": "127-11-23",
    "owner1": "ANVAR, PARITCHEHR",
    "owner2": "BORHANIAN, HAMED S",
    "current_taxes": 758.03,
    "new_taxes_no_override": 790.78,
    "override_total_1": 813.21,
    "override_increase_1": 22.44
  },
  {
    "#": "197 Kent St, Unit 37 & P27 (127-11-24)",
    "$": 607500,
    "address": "197 Kent St, Unit 37 & P27",
    "parcel_id": "127-11-24",
    "owner1": "LIU, YUEYANG",
    "owner2": "SU, HANG",
    "current_taxes": 6220.8,
    "new_taxes_no_override": 6489.54,
    "override_total_1": 6673.67,
    "override_increase_1": 184.14
  },
  {
    "#": "197 Kent St, Unit 38 (127-11-25)",
    "$": 582000,
    "address": "197 Kent St, Unit 38",
    "parcel_id": "127-11-25",
    "owner1": "MURAKAWA, TRS, GEORGE J",
    "owner2": "",
    "current_taxes": 5959.68,
    "new_taxes_no_override": 6217.14,
    "override_total_1": 6393.54,
    "override_increase_1": 176.41
  },
  {
    "#": "197 Kent St, Unit 41 (127-11-26)",
    "$": 582000,
    "address": "197 Kent St, Unit 41",
    "parcel_id": "127-11-26",
    "owner1": "WONG, PUI YEE",
    "owner2": "",
    "current_taxes": 5959.68,
    "new_taxes_no_override": 6217.14,
    "override_total_1": 6393.54,
    "override_increase_1": 176.41
  },
  {
    "#": "197 Kent St, Unit 42 (127-11-27)",
    "$": 582000,
    "address": "197 Kent St, Unit 42",
    "parcel_id": "127-11-27",
    "owner1": "BILLINGS TR, CHARLES E",
    "owner2": "C/O NIXON PEABODY - L COHEN",
    "current_taxes": 5959.68,
    "new_taxes_no_override": 6217.14,
    "override_total_1": 6393.54,
    "override_increase_1": 176.41
  },
  {
    "#": "197 Kent St, Unit 43 (127-11-28)",
    "$": 421100,
    "address": "197 Kent St, Unit 43",
    "parcel_id": "127-11-28",
    "owner1": "LU ET AL TRS, XINGQI",
    "owner2": "",
    "current_taxes": 4312.06,
    "new_taxes_no_override": 4498.34,
    "override_total_1": 4625.98,
    "override_increase_1": 127.64
  },
  {
    "#": "197 Kent St, Unit 44 & P35 (127-11-29)",
    "$": 515500,
    "address": "197 Kent St, Unit 44 & P35",
    "parcel_id": "127-11-29",
    "owner1": "197 KENT STREET LLC",
    "owner2": "",
    "current_taxes": 5278.72,
    "new_taxes_no_override": 5506.76,
    "override_total_1": 5663.01,
    "override_increase_1": 156.25
  },
  {
    "#": "197 Kent St, Unit 45 & P59 (127-11-30)",
    "$": 541000,
    "address": "197 Kent St, Unit 45 & P59",
    "parcel_id": "127-11-30",
    "owner1": "KAJLA, VIJAY",
    "owner2": "FLOCK, PETRA",
    "current_taxes": 5539.84,
    "new_taxes_no_override": 5779.16,
    "override_total_1": 5943.14,
    "override_increase_1": 163.98
  },
  {
    "#": "197 Kent St, Unit 46 (127-11-31)",
    "$": 458100,
    "address": "197 Kent St, Unit 46",
    "parcel_id": "127-11-31",
    "owner1": "CLEOPATRA PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 4690.94,
    "new_taxes_no_override": 4893.59,
    "override_total_1": 5032.44,
    "override_increase_1": 138.85
  },
  {
    "#": "197 Kent St, Unit 47 (127-11-32)",
    "$": 602100,
    "address": "197 Kent St, Unit 47",
    "parcel_id": "127-11-32",
    "owner1": "PARVEEN, NASIM BANU",
    "owner2": "",
    "current_taxes": 6165.5,
    "new_taxes_no_override": 6431.85,
    "override_total_1": 6614.35,
    "override_increase_1": 182.5
  },
  {
    "#": "197 Kent St, Unit 48 & P31 (127-11-33)",
    "$": 582000,
    "address": "197 Kent St, Unit 48 & P31",
    "parcel_id": "127-11-33",
    "owner1": "PU, SHARON XIANGDONG",
    "owner2": "YANG, BO",
    "current_taxes": 5959.68,
    "new_taxes_no_override": 6217.14,
    "override_total_1": 6393.54,
    "override_increase_1": 176.41
  },
  {
    "#": "197 Kent St, Unit B-1 (127-11-68)",
    "$": 488400,
    "address": "197 Kent St, Unit B-1",
    "parcel_id": "127-11-68",
    "owner1": "DYAS, JOHN F & KAZUKO M",
    "owner2": "",
    "current_taxes": 5001.22,
    "new_taxes_no_override": 5217.27,
    "override_total_1": 5365.31,
    "override_increase_1": 148.04
  },
  {
    "#": "197 Kent St, Unit B-2 (127-11-01)",
    "$": 376000,
    "address": "197 Kent St, Unit B-2",
    "parcel_id": "127-11-01",
    "owner1": "ZHOU, JIANHUA",
    "owner2": "SHAO, ZHAOHUI",
    "current_taxes": 3850.24,
    "new_taxes_no_override": 4016.57,
    "override_total_1": 4130.54,
    "override_increase_1": 113.97
  },
  {
    "#": "200 Kent St (128-07-00)",
    "$": 3844300,
    "address": "200 Kent St",
    "parcel_id": "128-07-00",
    "owner1": "PARTAN, TRS, DANIEL G-DORIS-MATTHEW A",
    "owner2": "",
    "current_taxes": 35730.7,
    "new_taxes_no_override": 37274.27,
    "override_total_1": 38331.89,
    "override_increase_1": 1057.63
  },
  {
    "#": "205 Kent St, Unit 11 (127-11-36)",
    "$": 582000,
    "address": "205 Kent St, Unit 11",
    "parcel_id": "127-11-36",
    "owner1": "NG TR, PING P",
    "owner2": "YEUNG TR, KIT M",
    "current_taxes": 2324.75,
    "new_taxes_no_override": 2425.18,
    "override_total_1": 2493.99,
    "override_increase_1": 68.81
  },
  {
    "#": "205 Kent St, Unit 12 (127-11-37)",
    "$": 582000,
    "address": "205 Kent St, Unit 12",
    "parcel_id": "127-11-37",
    "owner1": "197 205 KENT STREET LLC",
    "owner2": "",
    "current_taxes": 5959.68,
    "new_taxes_no_override": 6217.14,
    "override_total_1": 6393.54,
    "override_increase_1": 176.41
  },
  {
    "#": "205 Kent St, Unit 12A (127-11-38)",
    "$": 429000,
    "address": "205 Kent St, Unit 12A",
    "parcel_id": "127-11-38",
    "owner1": "197 205 KENT STREET LLC",
    "owner2": "",
    "current_taxes": 4392.96,
    "new_taxes_no_override": 4582.74,
    "override_total_1": 4712.77,
    "override_increase_1": 130.03
  },
  {
    "#": "205 Kent St, Unit 14 (127-11-39)",
    "$": 397200,
    "address": "205 Kent St, Unit 14",
    "parcel_id": "127-11-39",
    "owner1": "WANG, BETTY C",
    "owner2": "",
    "current_taxes": 4067.33,
    "new_taxes_no_override": 4243.04,
    "override_total_1": 4363.43,
    "override_increase_1": 120.39
  },
  {
    "#": "205 Kent St, Unit 15 (127-11-40)",
    "$": 429000,
    "address": "205 Kent St, Unit 15",
    "parcel_id": "127-11-40",
    "owner1": "HARSIP ALBERTSON, KATHLEEN",
    "owner2": "C/O PHILIP ALBERTO",
    "current_taxes": 4392.96,
    "new_taxes_no_override": 4582.74,
    "override_total_1": 4712.77,
    "override_increase_1": 130.03
  },
  {
    "#": "205 Kent St, Unit 16 & P51 (127-11-41)",
    "$": 515500,
    "address": "205 Kent St, Unit 16 & P51",
    "parcel_id": "127-11-41",
    "owner1": "TALAROSKI, STEPHEN J",
    "owner2": "",
    "current_taxes": 1643.79,
    "new_taxes_no_override": 1714.8,
    "override_total_1": 1763.46,
    "override_increase_1": 48.66
  },
  {
    "#": "205 Kent St, Unit 17 (127-11-42)",
    "$": 582000,
    "address": "205 Kent St, Unit 17",
    "parcel_id": "127-11-42",
    "owner1": "PORKHOVNIK TR, JANNA",
    "owner2": "",
    "current_taxes": 5959.68,
    "new_taxes_no_override": 6217.14,
    "override_total_1": 6393.54,
    "override_increase_1": 176.41
  },
  {
    "#": "205 Kent St, Unit 18 & P43 (127-11-43)",
    "$": 582000,
    "address": "205 Kent St, Unit 18 & P43",
    "parcel_id": "127-11-43",
    "owner1": "ARNAOUT, AMAL K",
    "owner2": "",
    "current_taxes": 5959.68,
    "new_taxes_no_override": 6217.14,
    "override_total_1": 6393.54,
    "override_increase_1": 176.41
  },
  {
    "#": "205 Kent St, Unit 21 (127-11-44)",
    "$": 582000,
    "address": "205 Kent St, Unit 21",
    "parcel_id": "127-11-44",
    "owner1": "WEDEN, THOMAS B",
    "owner2": "",
    "current_taxes": 5959.68,
    "new_taxes_no_override": 6217.14,
    "override_total_1": 6393.54,
    "override_increase_1": 176.41
  },
  {
    "#": "205 Kent St, Unit 22 (127-11-45)",
    "$": 582000,
    "address": "205 Kent St, Unit 22",
    "parcel_id": "127-11-45",
    "owner1": "197 205 KENT STREET LLC",
    "owner2": "",
    "current_taxes": 5959.68,
    "new_taxes_no_override": 6217.14,
    "override_total_1": 6393.54,
    "override_increase_1": 176.41
  },
  {
    "#": "205 Kent St, Unit 23 & P40 (127-11-46)",
    "$": 515500,
    "address": "205 Kent St, Unit 23 & P40",
    "parcel_id": "127-11-46",
    "owner1": "CHAN, RAYMOND",
    "owner2": "CHEUK, JENNY P",
    "current_taxes": 5278.72,
    "new_taxes_no_override": 5506.76,
    "override_total_1": 5663.01,
    "override_increase_1": 156.25
  },
  {
    "#": "205 Kent St, Unit 24 (127-11-47)",
    "$": 421100,
    "address": "205 Kent St, Unit 24",
    "parcel_id": "127-11-47",
    "owner1": "EIGHTY- EIGHT PROPERTIES, COMPANY LLC",
    "owner2": "",
    "current_taxes": 4312.06,
    "new_taxes_no_override": 4498.34,
    "override_total_1": 4625.98,
    "override_increase_1": 127.64
  },
  {
    "#": "205 Kent St, Unit 25 (127-11-48)",
    "$": 429000,
    "address": "205 Kent St, Unit 25",
    "parcel_id": "127-11-48",
    "owner1": "ELLIN, TR, BARBARA J",
    "owner2": "",
    "current_taxes": 4392.96,
    "new_taxes_no_override": 4582.74,
    "override_total_1": 4712.77,
    "override_increase_1": 130.03
  },
  {
    "#": "205 Kent St, Unit 26 (127-11-49)",
    "$": 541000,
    "address": "205 Kent St, Unit 26",
    "parcel_id": "127-11-49",
    "owner1": "197 205 KENT STREET LLC",
    "owner2": "",
    "current_taxes": 5539.84,
    "new_taxes_no_override": 5779.16,
    "override_total_1": 5943.14,
    "override_increase_1": 163.98
  },
  {
    "#": "205 Kent St, Unit 27 & P54 (127-11-50)",
    "$": 582000,
    "address": "205 Kent St, Unit 27 & P54",
    "parcel_id": "127-11-50",
    "owner1": "YU, QIAN",
    "owner2": "KANG, YAXIAO",
    "current_taxes": 2324.75,
    "new_taxes_no_override": 2425.18,
    "override_total_1": 2493.99,
    "override_increase_1": 68.81
  },
  {
    "#": "205 Kent St, Unit 28 & P65 (127-11-51)",
    "$": 592200,
    "address": "205 Kent St, Unit 28 & P65",
    "parcel_id": "127-11-51",
    "owner1": "GARG EXPEDITIONS LLC",
    "owner2": "",
    "current_taxes": 6064.13,
    "new_taxes_no_override": 6326.1,
    "override_total_1": 6505.6,
    "override_increase_1": 179.5
  },
  {
    "#": "205 Kent St, Unit 31 (127-11-52)",
    "$": 582000,
    "address": "205 Kent St, Unit 31",
    "parcel_id": "127-11-52",
    "owner1": "197 205 KENT STREET LLC",
    "owner2": "",
    "current_taxes": 5959.68,
    "new_taxes_no_override": 6217.14,
    "override_total_1": 6393.54,
    "override_increase_1": 176.41
  },
  {
    "#": "205 Kent St, Unit 32 (127-11-53)",
    "$": 582000,
    "address": "205 Kent St, Unit 32",
    "parcel_id": "127-11-53",
    "owner1": "197 205 KENT STREET LLC",
    "owner2": "",
    "current_taxes": 5959.68,
    "new_taxes_no_override": 6217.14,
    "override_total_1": 6393.54,
    "override_increase_1": 176.41
  },
  {
    "#": "205 Kent St, Unit 33 (127-11-54)",
    "$": 515500,
    "address": "205 Kent St, Unit 33",
    "parcel_id": "127-11-54",
    "owner1": "ORZECHOWSKI, IRENE M",
    "owner2": "",
    "current_taxes": 5278.72,
    "new_taxes_no_override": 5506.76,
    "override_total_1": 5663.01,
    "override_increase_1": 156.25
  },
  {
    "#": "205 Kent St, Unit 34 (127-11-55)",
    "$": 421100,
    "address": "205 Kent St, Unit 34",
    "parcel_id": "127-11-55",
    "owner1": "WANG TRS, PEI",
    "owner2": "LUO, CAROLYNE",
    "current_taxes": 4312.06,
    "new_taxes_no_override": 4498.34,
    "override_total_1": 4625.98,
    "override_increase_1": 127.64
  },
  {
    "#": "205 Kent St, Unit 35 & P60 (127-11-56)",
    "$": 434500,
    "address": "205 Kent St, Unit 35 & P60",
    "parcel_id": "127-11-56",
    "owner1": "WIDMAN, BROOKE",
    "owner2": "",
    "current_taxes": 814.35,
    "new_taxes_no_override": 849.53,
    "override_total_1": 873.63,
    "override_increase_1": 24.1
  },
  {
    "#": "205 Kent St, Unit 36 (127-11-57)",
    "$": 601900,
    "address": "205 Kent St, Unit 36",
    "parcel_id": "127-11-57",
    "owner1": "YU, JIA",
    "owner2": "HAN, ASHOU",
    "current_taxes": 6163.46,
    "new_taxes_no_override": 6429.72,
    "override_total_1": 6612.16,
    "override_increase_1": 182.44
  },
  {
    "#": "205 Kent St, Unit 37 (127-11-58)",
    "$": 582000,
    "address": "205 Kent St, Unit 37",
    "parcel_id": "127-11-58",
    "owner1": "LI, SHIJUN",
    "owner2": "SONG, YAN",
    "current_taxes": 5959.68,
    "new_taxes_no_override": 6217.14,
    "override_total_1": 6393.54,
    "override_increase_1": 176.41
  },
  {
    "#": "205 Kent St, Unit 38 (127-11-59)",
    "$": 582000,
    "address": "205 Kent St, Unit 38",
    "parcel_id": "127-11-59",
    "owner1": "PAL TRS, SOUMITRO & RINKU",
    "owner2": "",
    "current_taxes": 5959.68,
    "new_taxes_no_override": 6217.14,
    "override_total_1": 6393.54,
    "override_increase_1": 176.41
  },
  {
    "#": "205 Kent St, Unit 41 (127-11-60)",
    "$": 582000,
    "address": "205 Kent St, Unit 41",
    "parcel_id": "127-11-60",
    "owner1": "197 205 KENT STREET LLC",
    "owner2": "",
    "current_taxes": 5959.68,
    "new_taxes_no_override": 6217.14,
    "override_total_1": 6393.54,
    "override_increase_1": 176.41
  },
  {
    "#": "205 Kent St, Unit 42 (127-11-61)",
    "$": 582000,
    "address": "205 Kent St, Unit 42",
    "parcel_id": "127-11-61",
    "owner1": "TANG TRS, CHAOYU",
    "owner2": "LIU, YE",
    "current_taxes": 5959.68,
    "new_taxes_no_override": 6217.14,
    "override_total_1": 6393.54,
    "override_increase_1": 176.41
  },
  {
    "#": "205 Kent St, Unit 43 & P16 (127-11-62)",
    "$": 530800,
    "address": "205 Kent St, Unit 43 & P16",
    "parcel_id": "127-11-62",
    "owner1": "JAIM LLC",
    "owner2": "",
    "current_taxes": 5435.39,
    "new_taxes_no_override": 5670.2,
    "override_total_1": 5831.09,
    "override_increase_1": 160.89
  },
  {
    "#": "205 Kent St, Unit 44 & P50 (127-11-63)",
    "$": 421100,
    "address": "205 Kent St, Unit 44 & P50",
    "parcel_id": "127-11-63",
    "owner1": "SOKOLOVA, NATALYA",
    "owner2": "",
    "current_taxes": 4312.06,
    "new_taxes_no_override": 4498.34,
    "override_total_1": 4625.98,
    "override_increase_1": 127.64
  },
  {
    "#": "205 Kent St, Unit 45 (127-11-64)",
    "$": 429000,
    "address": "205 Kent St, Unit 45",
    "parcel_id": "127-11-64",
    "owner1": "WARING, YING QI & STEVEN",
    "owner2": "",
    "current_taxes": 4392.96,
    "new_taxes_no_override": 4582.74,
    "override_total_1": 4712.77,
    "override_increase_1": 130.03
  },
  {
    "#": "205 Kent St, Unit 46 & P46 (127-11-65)",
    "$": 515500,
    "address": "205 Kent St, Unit 46 & P46",
    "parcel_id": "127-11-65",
    "owner1": "205 KENT 46 LLC",
    "owner2": "",
    "current_taxes": 5278.72,
    "new_taxes_no_override": 5506.76,
    "override_total_1": 5663.01,
    "override_increase_1": 156.25
  },
  {
    "#": "205 Kent St, Unit 47 (127-11-66)",
    "$": 582000,
    "address": "205 Kent St, Unit 47",
    "parcel_id": "127-11-66",
    "owner1": "NINETY NINE PROPERTIES, COMPANY LLC",
    "owner2": "",
    "current_taxes": 5959.68,
    "new_taxes_no_override": 6217.14,
    "override_total_1": 6393.54,
    "override_increase_1": 176.41
  },
  {
    "#": "205 Kent St, Unit 48 (127-11-67)",
    "$": 607500,
    "address": "205 Kent St, Unit 48",
    "parcel_id": "127-11-67",
    "owner1": "BLUM, TAMAR ROSE",
    "owner2": "",
    "current_taxes": 6220.8,
    "new_taxes_no_override": 6489.54,
    "override_total_1": 6673.67,
    "override_increase_1": 184.14
  },
  {
    "#": "205 Kent St, Unit B-1 & P56 (127-11-34)",
    "$": 476500,
    "address": "205 Kent St, Unit B-1 & P56",
    "parcel_id": "127-11-34",
    "owner1": "TAO TRS, JIAQI",
    "owner2": "LI, JIAN",
    "current_taxes": 4879.36,
    "new_taxes_no_override": 5090.15,
    "override_total_1": 5234.58,
    "override_increase_1": 144.43
  },
  {
    "#": "205 Kent St, Unit B-2&P44 (127-11-35)",
    "$": 380700,
    "address": "205 Kent St, Unit B-2&P44",
    "parcel_id": "127-11-35",
    "owner1": "LE, ANDREW T Q & JENNIFER B L",
    "owner2": "VU, BACH THUOC",
    "current_taxes": 389.84,
    "new_taxes_no_override": 406.68,
    "override_total_1": 418.22,
    "override_increase_1": 11.54
  },
  {
    "#": "212 Kent St (129-19-00)",
    "$": 1514900,
    "address": "212 Kent St",
    "parcel_id": "129-19-00",
    "owner1": "GILLMAN, SETH & YASAMAN",
    "owner2": "",
    "current_taxes": 11877.64,
    "new_taxes_no_override": 12390.75,
    "override_total_1": 12742.33,
    "override_increase_1": 351.58
  },
  {
    "#": "214 Kent St (129-18-00)",
    "$": 1610900,
    "address": "214 Kent St",
    "parcel_id": "129-18-00",
    "owner1": "WHEELER, GREGORY B",
    "owner2": "DREW, CHARLOTTE D",
    "current_taxes": 12860.68,
    "new_taxes_no_override": 13416.26,
    "override_total_1": 13796.94,
    "override_increase_1": 380.68
  },
  {
    "#": "216 Kent St (129-17-00)",
    "$": 1461500,
    "address": "216 Kent St",
    "parcel_id": "129-17-00",
    "owner1": "STEINBERG TRS, RICK & LESLIE",
    "owner2": "",
    "current_taxes": 14965.76,
    "new_taxes_no_override": 15612.28,
    "override_total_1": 16055.27,
    "override_increase_1": 442.99
  },
  {
    "#": "217 Kent St (127-10-00)",
    "$": 11682500,
    "address": "217 Kent St",
    "parcel_id": "127-10-00",
    "owner1": "NEW KENT ST LLC",
    "owner2": "",
    "current_taxes": 119628.8,
    "new_taxes_no_override": 124796.76,
    "override_total_1": 128337.78,
    "override_increase_1": 3541.01
  },
  {
    "#": "218 Kent St (129-16-00)",
    "$": 1432100,
    "address": "218 Kent St",
    "parcel_id": "129-16-00",
    "owner1": "CHURCH TRS, GEORGE M",
    "owner2": "WU, CHAO-TING",
    "current_taxes": 11029.77,
    "new_taxes_no_override": 11506.26,
    "override_total_1": 11832.74,
    "override_increase_1": 326.48
  },
  {
    "#": "220 Kent St (129-15-00)",
    "$": 1571900,
    "address": "220 Kent St",
    "parcel_id": "129-15-00",
    "owner1": "KRISHNAN, JAGANNATH G",
    "owner2": "",
    "current_taxes": 16096.26,
    "new_taxes_no_override": 16791.62,
    "override_total_1": 17268.07,
    "override_increase_1": 476.45
  },
  {
    "#": "229 Kent St (127-09-00)",
    "$": 8585900,
    "address": "229 Kent St",
    "parcel_id": "127-09-00",
    "owner1": "BOSTON RONALD MCDONALD",
    "owner2": "HOUSE INC",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "232 Kent St (126-06-00)",
    "$": 3977000,
    "address": "232 Kent St",
    "parcel_id": "126-06-00",
    "owner1": "REALE, CHRISTOPHER & SHARON",
    "owner2": "",
    "current_taxes": 40724.48,
    "new_taxes_no_override": 42483.78,
    "override_total_1": 43689.22,
    "override_increase_1": 1205.44
  },
  {
    "#": "240 Kent St (126-05-02)",
    "$": 2005800,
    "address": "240 Kent St",
    "parcel_id": "126-05-02",
    "owner1": "KHETARPAL, RAJINDER K & ALKA",
    "owner2": "",
    "current_taxes": 16904.46,
    "new_taxes_no_override": 17634.73,
    "override_total_1": 18135.1,
    "override_increase_1": 500.37
  },
  {
    "#": "241 Kent St (127-08-00)",
    "$": 9301500,
    "address": "241 Kent St",
    "parcel_id": "127-08-00",
    "owner1": "THE CHILDRENS HOSPITAL CORP",
    "owner2": "C/O HEALEY, SHARON",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "247 Kent St (127-07-00)",
    "$": 3631200,
    "address": "247 Kent St",
    "parcel_id": "127-07-00",
    "owner1": "TEAGLACH GRA LLC",
    "owner2": "",
    "current_taxes": 37183.49,
    "new_taxes_no_override": 38789.82,
    "override_total_1": 39890.45,
    "override_increase_1": 1100.63
  },
  {
    "#": "252 Kent St (126-03-01)",
    "$": 2985200,
    "address": "252 Kent St",
    "parcel_id": "126-03-01",
    "owner1": "FOGLEMAN TR, MARK ALLEN",
    "owner2": "KAZMI TR, SADAF KHADIJA",
    "current_taxes": 26933.51,
    "new_taxes_no_override": 28097.04,
    "override_total_1": 28894.27,
    "override_increase_1": 797.23
  },
  {
    "#": "253 Kent St (127-06-00)",
    "$": 3793100,
    "address": "253 Kent St",
    "parcel_id": "127-06-00",
    "owner1": "SOLISH, SAMUEL",
    "owner2": "",
    "current_taxes": 38841.34,
    "new_taxes_no_override": 40519.29,
    "override_total_1": 41668.99,
    "override_increase_1": 1149.7
  },
  {
    "#": "258 Kent St (126-03-00)",
    "$": 2042600,
    "address": "258 Kent St",
    "parcel_id": "126-03-00",
    "owner1": "CHURCHILL TR, GERALDINE M",
    "owner2": "",
    "current_taxes": 17281.29,
    "new_taxes_no_override": 18027.84,
    "override_total_1": 18539.37,
    "override_increase_1": 511.53
  },
  {
    "#": "259 Kent St (127-05-00)",
    "$": 4291300,
    "address": "259 Kent St",
    "parcel_id": "127-05-00",
    "owner1": "SHANG, SHUANG",
    "owner2": "",
    "current_taxes": 40307.98,
    "new_taxes_no_override": 42049.28,
    "override_total_1": 43242.4,
    "override_increase_1": 1193.12
  },
  {
    "#": "262 Kent St (126-02-00)",
    "$": 2994600,
    "address": "262 Kent St",
    "parcel_id": "126-02-00",
    "owner1": "VONNEGUT LIFE ESTATE, PATRICIA O",
    "owner2": "TEEL LIFE ESTATE, MICHAEL B",
    "current_taxes": 27029.77,
    "new_taxes_no_override": 28197.46,
    "override_total_1": 28997.54,
    "override_increase_1": 800.08
  },
  {
    "#": "268 Kent St (126-01-00)",
    "$": 2403100,
    "address": "268 Kent St",
    "parcel_id": "126-01-00",
    "owner1": "DESAI TR, LAXMAN S",
    "owner2": "",
    "current_taxes": 24607.74,
    "new_taxes_no_override": 25670.79,
    "override_total_1": 26399.18,
    "override_increase_1": 728.39
  },
  {
    "#": "269 Kent St (127-21-00)",
    "$": 4274300,
    "address": "269 Kent St",
    "parcel_id": "127-21-00",
    "owner1": "JEWISH HEALTH ORGANIZATION INC",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "282 Kent St (122-03-02)",
    "$": 3620200,
    "address": "282 Kent St",
    "parcel_id": "122-03-02",
    "owner1": "ZIMBLE, DAVID S & DONNA B",
    "owner2": "",
    "current_taxes": 33435.91,
    "new_taxes_no_override": 34880.34,
    "override_total_1": 35870.04,
    "override_increase_1": 989.7
  },
  {
    "#": "287 Kent St, Unit 1 & G3-P9 (121-01-06)",
    "$": 2244200,
    "address": "287 Kent St, Unit 1 & G3-P9",
    "parcel_id": "121-01-06",
    "owner1": "SOLOMON, SCOTT D & CAREN G",
    "owner2": "",
    "current_taxes": 22980.61,
    "new_taxes_no_override": 23973.37,
    "override_total_1": 24653.6,
    "override_increase_1": 680.23
  },
  {
    "#": "287 Kent St, Unit 2 & G4-P8 (121-01-01)",
    "$": 2184800,
    "address": "287 Kent St, Unit 2 & G4-P8",
    "parcel_id": "121-01-01",
    "owner1": "HILLMAN TR, CAROL",
    "owner2": "",
    "current_taxes": 22372.35,
    "new_taxes_no_override": 23338.84,
    "override_total_1": 24001.06,
    "override_increase_1": 662.22
  },
  {
    "#": "287 Kent St, Unit 3 & G7-P11 (121-01-02)",
    "$": 1862400,
    "address": "287 Kent St, Unit 3 & G7-P11",
    "parcel_id": "121-01-02",
    "owner1": "DESROSIERS, PAUL R & ASHLEY A",
    "owner2": "",
    "current_taxes": 15436.04,
    "new_taxes_no_override": 16102.88,
    "override_total_1": 16559.78,
    "override_increase_1": 456.91
  },
  {
    "#": "287 Kent St, Unit 4 & G2-P12 (121-01-03)",
    "$": 2130200,
    "address": "287 Kent St, Unit 4 & G2-P12",
    "parcel_id": "121-01-03",
    "owner1": "ROLLINS, CAITLIN K",
    "owner2": "",
    "current_taxes": 18178.31,
    "new_taxes_no_override": 18963.61,
    "override_total_1": 19501.69,
    "override_increase_1": 538.08
  },
  {
    "#": "287 Kent St, Unit 5 & G1 P10 (121-01-04)",
    "$": 1997500,
    "address": "287 Kent St, Unit 5 & G1 P10",
    "parcel_id": "121-01-04",
    "owner1": "ASHDOWN TRS, CHARLES P",
    "owner2": "KANTROWITZ, LORE E",
    "current_taxes": 16819.47,
    "new_taxes_no_override": 17546.07,
    "override_total_1": 18043.93,
    "override_increase_1": 497.86
  },
  {
    "#": "288 Kent St (122-03-01)",
    "$": 2878800,
    "address": "288 Kent St",
    "parcel_id": "122-03-01",
    "owner1": "STAIR, DANIEL C",
    "owner2": "LI, SHA",
    "current_taxes": 25843.98,
    "new_taxes_no_override": 26960.44,
    "override_total_1": 27725.42,
    "override_increase_1": 764.98
  },
  {
    "#": "289 Kent St, Unit 6 & G5-G6 (121-01-05)",
    "$": 2415500,
    "address": "289 Kent St, Unit 6 & G5-G6",
    "parcel_id": "121-01-05",
    "owner1": "STRASSLER, MATTHEW & KAREN",
    "owner2": "",
    "current_taxes": 24734.72,
    "new_taxes_no_override": 25803.26,
    "override_total_1": 26535.41,
    "override_increase_1": 732.15
  },
  {
    "#": "294 Kent St (122-03-00)",
    "$": 2867600,
    "address": "294 Kent St",
    "parcel_id": "122-03-00",
    "owner1": "CEDER, MOLLIE",
    "owner2": "",
    "current_taxes": 25729.29,
    "new_taxes_no_override": 26840.8,
    "override_total_1": 27602.38,
    "override_increase_1": 761.59
  },
  {
    "#": "295 Kent St (121-02-00)",
    "$": 6131800,
    "address": "295 Kent St",
    "parcel_id": "121-02-00",
    "owner1": "JEWISH HEALTH ORGANIZATION INC",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "300 Kent St, Unit 1 (122-02-05)",
    "$": 2018400,
    "address": "300 Kent St, Unit 1",
    "parcel_id": "122-02-05",
    "owner1": "FIELDS TRS, BRUCE ERIC & SUZANNE",
    "owner2": "",
    "current_taxes": 17033.48,
    "new_taxes_no_override": 17769.33,
    "override_total_1": 18273.52,
    "override_increase_1": 504.19
  },
  {
    "#": "300 Kent St, Unit 2 (122-02-01)",
    "$": 1935300,
    "address": "300 Kent St, Unit 2",
    "parcel_id": "122-02-01",
    "owner1": "LOEWENSTEIN, ANDREW B",
    "owner2": "",
    "current_taxes": 16182.54,
    "new_taxes_no_override": 16881.63,
    "override_total_1": 17360.63,
    "override_increase_1": 479.0
  },
  {
    "#": "300 Kent St, Unit 3 (122-02-02)",
    "$": 1871100,
    "address": "300 Kent St, Unit 3",
    "parcel_id": "122-02-02",
    "owner1": "BROWN, MARSHALL J & JANE K",
    "owner2": "",
    "current_taxes": 15525.13,
    "new_taxes_no_override": 16195.82,
    "override_total_1": 16655.36,
    "override_increase_1": 459.54
  },
  {
    "#": "300 Kent St, Unit 4 (122-02-03)",
    "$": 1824800,
    "address": "300 Kent St, Unit 4",
    "parcel_id": "122-02-03",
    "owner1": "PADWA, BONNIE",
    "owner2": "",
    "current_taxes": 15051.02,
    "new_taxes_no_override": 15701.22,
    "override_total_1": 16146.73,
    "override_increase_1": 445.51
  },
  {
    "#": "300 Kent St, Unit 5 (122-02-04)",
    "$": 2165300,
    "address": "300 Kent St, Unit 5",
    "parcel_id": "122-02-04",
    "owner1": "LI, JEFFREY",
    "owner2": "",
    "current_taxes": 18537.74,
    "new_taxes_no_override": 19338.57,
    "override_total_1": 19887.29,
    "override_increase_1": 548.72
  },
  {
    "#": "310 Kent St (122-01-00)",
    "$": 4536700,
    "address": "310 Kent St",
    "parcel_id": "122-01-00",
    "owner1": "THORS, TRS, ELIZABETH C",
    "owner2": "",
    "current_taxes": 42820.87,
    "new_taxes_no_override": 44670.73,
    "override_total_1": 45938.23,
    "override_increase_1": 1267.5
  },
  {
    "#": "328 Kent St (123-09-00)",
    "$": 3187800,
    "address": "328 Kent St",
    "parcel_id": "123-09-00",
    "owner1": "CHAYAVICHITSILP TR, MALATRI",
    "owner2": "",
    "current_taxes": 29008.14,
    "new_taxes_no_override": 30261.29,
    "override_total_1": 31119.93,
    "override_increase_1": 858.64
  },
  {
    "#": "334 Kent St (123-08-00)",
    "$": 4044500,
    "address": "334 Kent St",
    "parcel_id": "123-08-00",
    "owner1": "EPSTEIN, BRIAN & SARAH",
    "owner2": "",
    "current_taxes": 37780.75,
    "new_taxes_no_override": 39412.88,
    "override_total_1": 40531.19,
    "override_increase_1": 1118.31
  },
  {
    "#": "339 Kent St (119-01-00)",
    "$": 13933100,
    "address": "339 Kent St",
    "parcel_id": "119-01-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O LONGWOOD SQUARE",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "340 Kent St (123-07-00)",
    "$": 2382800,
    "address": "340 Kent St",
    "parcel_id": "123-07-00",
    "owner1": "LESSER, HARRIET S",
    "owner2": "",
    "current_taxes": 20764.94,
    "new_taxes_no_override": 21661.99,
    "override_total_1": 22276.63,
    "override_increase_1": 614.64
  },
  {
    "#": "348 Kent St (123-06-00)",
    "$": 4114900,
    "address": "348 Kent St",
    "parcel_id": "123-06-00",
    "owner1": "OBRIEN, MARK",
    "owner2": "SASTRY, ANJALI",
    "current_taxes": 38501.64,
    "new_taxes_no_override": 40164.91,
    "override_total_1": 41304.56,
    "override_increase_1": 1139.65
  },
  {
    "#": "352 Kent St (123-05-00)",
    "$": 3669100,
    "address": "352 Kent St",
    "parcel_id": "123-05-00",
    "owner1": "THOMPSON, PHILIP L & NICOLA S",
    "owner2": "",
    "current_taxes": 33936.65,
    "new_taxes_no_override": 35402.71,
    "override_total_1": 36407.24,
    "override_increase_1": 1004.52
  },
  {
    "#": "359 Kent St (118-11-00)",
    "$": 2808900,
    "address": "359 Kent St",
    "parcel_id": "118-11-00",
    "owner1": "CHAVALI, RAM V S R",
    "owner2": "KRISHNAMURTHY, KAARKUZHALI B",
    "current_taxes": 25128.2,
    "new_taxes_no_override": 26213.74,
    "override_total_1": 26957.53,
    "override_increase_1": 743.79
  },
  {
    "#": "360 Kent St (123-04-00)",
    "$": 3449700,
    "address": "360 Kent St",
    "parcel_id": "123-04-00",
    "owner1": "DORFMAN, DAVID M & MELODY",
    "owner2": "",
    "current_taxes": 31689.99,
    "new_taxes_no_override": 33059.0,
    "override_total_1": 33997.02,
    "override_increase_1": 938.02
  },
  {
    "#": "365 Kent St (118-12-00)",
    "$": 2783300,
    "address": "365 Kent St",
    "parcel_id": "118-12-00",
    "owner1": "GOODHEART, LISA C & MARC L",
    "owner2": "",
    "current_taxes": 24866.06,
    "new_taxes_no_override": 25940.27,
    "override_total_1": 26676.31,
    "override_increase_1": 736.04
  },
  {
    "#": "366 Kent St (123-03-00)",
    "$": 3313000,
    "address": "366 Kent St",
    "parcel_id": "123-03-00",
    "owner1": "WINIK TRS, HAYES A",
    "owner2": "BAQUERIZO, MARIA",
    "current_taxes": 30290.19,
    "new_taxes_no_override": 31598.73,
    "override_total_1": 32495.32,
    "override_increase_1": 896.59
  },
  {
    "#": "9 Kenwood St (072-02-00)",
    "$": 2326100,
    "address": "9 Kenwood St",
    "parcel_id": "072-02-00",
    "owner1": "9 KENWOOD EXCHANGE LLC",
    "owner2": "",
    "current_taxes": 23819.26,
    "new_taxes_no_override": 24848.25,
    "override_total_1": 25553.3,
    "override_increase_1": 705.05
  },
  {
    "#": "12 Kenwood St, Unit 1 (073-20-01)",
    "$": 1017700,
    "address": "12 Kenwood St, Unit 1",
    "parcel_id": "073-20-01",
    "owner1": "MASO TRS, MICHAEL H",
    "owner2": "COADY, LISA M",
    "current_taxes": 6786.31,
    "new_taxes_no_override": 7079.48,
    "override_total_1": 7280.35,
    "override_increase_1": 200.87
  },
  {
    "#": "12 Kenwood St, Unit 2 (073-20-02)",
    "$": 1229400,
    "address": "12 Kenwood St, Unit 2",
    "parcel_id": "073-20-02",
    "owner1": "GARRETT, WENDY S",
    "owner2": "",
    "current_taxes": 8954.12,
    "new_taxes_no_override": 9340.94,
    "override_total_1": 9605.98,
    "override_increase_1": 265.04
  },
  {
    "#": "15 Kenwood St (072-03-00)",
    "$": 2469400,
    "address": "15 Kenwood St",
    "parcel_id": "072-03-00",
    "owner1": "SHASHOUA, MICHAEL",
    "owner2": "ZOLL, MIRIAM",
    "current_taxes": 25286.66,
    "new_taxes_no_override": 26379.04,
    "override_total_1": 27127.53,
    "override_increase_1": 748.49
  },
  {
    "#": "16 Kenwood St (073-19-00)",
    "$": 2734200,
    "address": "16 Kenwood St",
    "parcel_id": "073-19-00",
    "owner1": "SAMUELS TR, VALERIE C",
    "owner2": "",
    "current_taxes": 24363.27,
    "new_taxes_no_override": 25415.76,
    "override_total_1": 26136.92,
    "override_increase_1": 721.15
  },
  {
    "#": "19 Kenwood St (072-04-00)",
    "$": 3056700,
    "address": "19 Kenwood St",
    "parcel_id": "072-04-00",
    "owner1": "SAIAH TRS, EDDINE",
    "owner2": "BARBIER, ANN",
    "current_taxes": 31300.61,
    "new_taxes_no_override": 32652.8,
    "override_total_1": 33579.29,
    "override_increase_1": 926.5
  },
  {
    "#": "22 Kenwood St (073-18-00)",
    "$": 2762900,
    "address": "22 Kenwood St",
    "parcel_id": "073-18-00",
    "owner1": "LURIE, ADAM W & REBECCA C",
    "owner2": "",
    "current_taxes": 24657.16,
    "new_taxes_no_override": 25722.35,
    "override_total_1": 26452.2,
    "override_increase_1": 729.85
  },
  {
    "#": "23 Kenwood St, Unit 1 (072-05-01)",
    "$": 1101200,
    "address": "23 Kenwood St, Unit 1",
    "parcel_id": "072-05-01",
    "owner1": "WHITE, MARGARETA & MONICA S",
    "owner2": "",
    "current_taxes": 7641.35,
    "new_taxes_no_override": 7971.46,
    "override_total_1": 8197.64,
    "override_increase_1": 226.18
  },
  {
    "#": "23 Kenwood St, Unit 2 (072-05-02)",
    "$": 1214300,
    "address": "23 Kenwood St, Unit 2",
    "parcel_id": "072-05-02",
    "owner1": "VEKSLER, VITALY & ANNA",
    "owner2": "",
    "current_taxes": 8799.5,
    "new_taxes_no_override": 9179.64,
    "override_total_1": 9440.1,
    "override_increase_1": 260.47
  },
  {
    "#": "26 Kenwood St (073-17-00)",
    "$": 2869900,
    "address": "26 Kenwood St",
    "parcel_id": "073-17-00",
    "owner1": "KELLY, SEAN P & DARA B",
    "owner2": "",
    "current_taxes": 25752.84,
    "new_taxes_no_override": 26865.36,
    "override_total_1": 27627.65,
    "override_increase_1": 762.28
  },
  {
    "#": "27 Kenwood St (072-06-00)",
    "$": 2317400,
    "address": "27 Kenwood St",
    "parcel_id": "072-06-00",
    "owner1": "SPEARS, WILLIAM C",
    "owner2": "MACILROY, ROBIN G",
    "current_taxes": 20095.24,
    "new_taxes_no_override": 20963.35,
    "override_total_1": 21558.17,
    "override_increase_1": 594.82
  },
  {
    "#": "30 Kenwood St (073-16-00)",
    "$": 2148000,
    "address": "30 Kenwood St",
    "parcel_id": "073-16-00",
    "owner1": "WOLF, WALTER S & AGNES J",
    "owner2": "C/O WOLF ELYSE K",
    "current_taxes": 21995.52,
    "new_taxes_no_override": 22945.73,
    "override_total_1": 23596.79,
    "override_increase_1": 651.07
  },
  {
    "#": "33 Kenwood St (072-07-00)",
    "$": 2057900,
    "address": "33 Kenwood St",
    "parcel_id": "072-07-00",
    "owner1": "KIM, JOHN J & THERESA MINJUNG",
    "owner2": "",
    "current_taxes": 17437.96,
    "new_taxes_no_override": 18191.28,
    "override_total_1": 18707.44,
    "override_increase_1": 516.16
  },
  {
    "#": "34 Kenwood St, Unit 34 & 2 Pk Sps (073-15-01)",
    "$": 1996000,
    "address": "34 Kenwood St, Unit 34 & 2 Pk Sps",
    "parcel_id": "073-15-01",
    "owner1": "REYZIN, ALISSA N",
    "owner2": "GOLDMAN, MAX",
    "current_taxes": 16804.11,
    "new_taxes_no_override": 17530.05,
    "override_total_1": 18027.45,
    "override_increase_1": 497.4
  },
  {
    "#": "34 Kenwood St, Unit 36 & 2 Pk Sps (073-15-02)",
    "$": 1769000,
    "address": "34 Kenwood St, Unit 36 & 2 Pk Sps",
    "parcel_id": "073-15-02",
    "owner1": "KLINGENSTEIN, ALEXANDRA",
    "owner2": "KEMP, PHILIP",
    "current_taxes": 18114.56,
    "new_taxes_no_override": 18897.11,
    "override_total_1": 19433.3,
    "override_increase_1": 536.19
  },
  {
    "#": "37 Kenwood St (072-08-00)",
    "$": 2403800,
    "address": "37 Kenwood St",
    "parcel_id": "072-08-00",
    "owner1": "BECK ASHLAND FARM LLC",
    "owner2": "",
    "current_taxes": 24614.91,
    "new_taxes_no_override": 25678.27,
    "override_total_1": 26406.88,
    "override_increase_1": 728.6
  },
  {
    "#": "40 Kenwood St, Unit 1 (073-14-01)",
    "$": 1100700,
    "address": "40 Kenwood St, Unit 1",
    "parcel_id": "073-14-01",
    "owner1": "OLIVERA, SANTIAGO",
    "owner2": "TEJADA, ANAMARIA",
    "current_taxes": 11271.17,
    "new_taxes_no_override": 11758.08,
    "override_total_1": 12091.71,
    "override_increase_1": 333.63
  },
  {
    "#": "40 Kenwood St, Unit 2 (073-14-02)",
    "$": 1554800,
    "address": "40 Kenwood St, Unit 2",
    "parcel_id": "073-14-02",
    "owner1": "BEARD, JEFFREY & ELIZABETH",
    "owner2": "",
    "current_taxes": 12286.22,
    "new_taxes_no_override": 12816.98,
    "override_total_1": 13180.66,
    "override_increase_1": 363.67
  },
  {
    "#": "41 Kenwood St (072-09-00)",
    "$": 2568100,
    "address": "41 Kenwood St",
    "parcel_id": "072-09-00",
    "owner1": "BILCHIK, BRIAN",
    "owner2": "SHMUKLER, KAREN",
    "current_taxes": 22662.41,
    "new_taxes_no_override": 23641.43,
    "override_total_1": 24312.23,
    "override_increase_1": 670.81
  },
  {
    "#": "45 Kenwood St, Unit 45 (072-10-01)",
    "$": 2315300,
    "address": "45 Kenwood St, Unit 45",
    "parcel_id": "072-10-01",
    "owner1": "KALOWSKI, LEE",
    "owner2": "JAFFEE, EMILY",
    "current_taxes": 20073.74,
    "new_taxes_no_override": 20940.93,
    "override_total_1": 21535.11,
    "override_increase_1": 594.18
  },
  {
    "#": "46 Kenwood St (073-13-00)",
    "$": 2366500,
    "address": "46 Kenwood St",
    "parcel_id": "073-13-00",
    "owner1": "KIRSNER, SCOTT A",
    "owner2": "TRAVERSO, AMY",
    "current_taxes": 20598.03,
    "new_taxes_no_override": 21487.86,
    "override_total_1": 22097.57,
    "override_increase_1": 609.7
  },
  {
    "#": "47 Kenwood St, Unit 47 (072-10-02)",
    "$": 2024200,
    "address": "47 Kenwood St, Unit 47",
    "parcel_id": "072-10-02",
    "owner1": "CHANDRASEKARAN, CHANDRAMOULI",
    "owner2": "VEMBUSUBRAMANIAN, MEENAKSHI",
    "current_taxes": 17092.87,
    "new_taxes_no_override": 17831.28,
    "override_total_1": 18337.23,
    "override_increase_1": 505.95
  },
  {
    "#": "50 Kenwood St (073-12-00)",
    "$": 3291100,
    "address": "50 Kenwood St",
    "parcel_id": "073-12-00",
    "owner1": "KATES TRS, JAMES G & HELEN E & PETER",
    "owner2": "",
    "current_taxes": 33700.86,
    "new_taxes_no_override": 35156.74,
    "override_total_1": 36154.28,
    "override_increase_1": 997.55
  },
  {
    "#": "51 Kenwood St (072-11-00)",
    "$": 2198600,
    "address": "51 Kenwood St",
    "parcel_id": "072-11-00",
    "owner1": "KITTERMAN, ROGER D & SARAH B",
    "owner2": "",
    "current_taxes": 18878.73,
    "new_taxes_no_override": 19694.29,
    "override_total_1": 20253.1,
    "override_increase_1": 558.81
  },
  {
    "#": "55 Kenwood St (072-12-00)",
    "$": 2009900,
    "address": "55 Kenwood St",
    "parcel_id": "072-12-00",
    "owner1": "BONDARYK TRS, JOSEPH & LESLIE",
    "owner2": "",
    "current_taxes": 16946.44,
    "new_taxes_no_override": 17678.53,
    "override_total_1": 18180.14,
    "override_increase_1": 501.61
  },
  {
    "#": "57 Kenwood St (072-12-01)",
    "$": 1832100,
    "address": "57 Kenwood St",
    "parcel_id": "072-12-01",
    "owner1": "LANZA TRS, RICHARD C & SYLVIA L",
    "owner2": "",
    "current_taxes": 15125.77,
    "new_taxes_no_override": 15779.2,
    "override_total_1": 16226.93,
    "override_increase_1": 447.72
  },
  {
    "#": "61 Kenwood St (072-13-00)",
    "$": 2305700,
    "address": "61 Kenwood St",
    "parcel_id": "072-13-00",
    "owner1": "GHANNAM, HUDA",
    "owner2": "",
    "current_taxes": 19975.43,
    "new_taxes_no_override": 20838.37,
    "override_total_1": 21429.64,
    "override_increase_1": 591.27
  },
  {
    "#": "63 Kenwood St, Unit 1 P1-2-3-4 (072-14-01)",
    "$": 1622200,
    "address": "63 Kenwood St, Unit 1 P1-2-3-4",
    "parcel_id": "072-14-01",
    "owner1": "ZUBOV, IRINA & DMITRIY",
    "owner2": "",
    "current_taxes": 12976.39,
    "new_taxes_no_override": 13536.97,
    "override_total_1": 13921.07,
    "override_increase_1": 384.1
  },
  {
    "#": "63 Kenwood St, Unit 2 & P5 (072-14-02)",
    "$": 751300,
    "address": "63 Kenwood St, Unit 2 & P5",
    "parcel_id": "072-14-02",
    "owner1": "BEN-ARI, DORON & AVITAL PATO",
    "owner2": "",
    "current_taxes": 7693.31,
    "new_taxes_no_override": 8025.66,
    "override_total_1": 8253.38,
    "override_increase_1": 227.72
  },
  {
    "#": "63 Kenwood St, Unit 3 & P6 (072-14-03)",
    "$": 714500,
    "address": "63 Kenwood St, Unit 3 & P6",
    "parcel_id": "072-14-03",
    "owner1": "DARGHOUTH, SARAH",
    "owner2": "",
    "current_taxes": 3681.55,
    "new_taxes_no_override": 3840.59,
    "override_total_1": 3949.57,
    "override_increase_1": 108.97
  },
  {
    "#": "69 Kenwood St (072-15-00)",
    "$": 3815500,
    "address": "69 Kenwood St",
    "parcel_id": "072-15-00",
    "owner1": "YUNG, STEVEN",
    "owner2": "",
    "current_taxes": 35435.79,
    "new_taxes_no_override": 36966.62,
    "override_total_1": 38015.52,
    "override_increase_1": 1048.9
  },
  {
    "#": "73 Kenwood St, Unit 73 (072-16-01)",
    "$": 1775900,
    "address": "73 Kenwood St, Unit 73",
    "parcel_id": "072-16-01",
    "owner1": "KITCHINGS TRS, ANDREW WICKERSHAM & EMILY MOY",
    "owner2": "",
    "current_taxes": 14550.28,
    "new_taxes_no_override": 15178.85,
    "override_total_1": 15609.54,
    "override_increase_1": 430.69
  },
  {
    "#": "75 Kenwood St, Unit 75 (072-16-02)",
    "$": 1549400,
    "address": "75 Kenwood St, Unit 75",
    "parcel_id": "072-16-02",
    "owner1": "KONITA LLC",
    "owner2": "",
    "current_taxes": 15865.86,
    "new_taxes_no_override": 16551.27,
    "override_total_1": 17020.89,
    "override_increase_1": 469.63
  },
  {
    "#": "77 Kenwood St, Unit 77 (072-17-01)",
    "$": 2455800,
    "address": "77 Kenwood St, Unit 77",
    "parcel_id": "072-17-01",
    "owner1": "GU, JIACHEN",
    "owner2": "",
    "current_taxes": 21512.46,
    "new_taxes_no_override": 22441.8,
    "override_total_1": 23078.57,
    "override_increase_1": 636.77
  },
  {
    "#": "77 Kenwood St, Unit 79 (072-17-02)",
    "$": 1996900,
    "address": "77 Kenwood St, Unit 79",
    "parcel_id": "072-17-02",
    "owner1": "KATES, EMILY",
    "owner2": "",
    "current_taxes": 20448.26,
    "new_taxes_no_override": 21331.62,
    "override_total_1": 21936.89,
    "override_increase_1": 605.27
  },
  {
    "#": "83 Kenwood St (072-18-00)",
    "$": 2739300,
    "address": "83 Kenwood St",
    "parcel_id": "072-18-00",
    "owner1": "LABAREE, ROBERT R & FRANCES L",
    "owner2": "",
    "current_taxes": 24415.5,
    "new_taxes_no_override": 25470.25,
    "override_total_1": 26192.95,
    "override_increase_1": 722.7
  },
  {
    "#": "8 Kilsyth Rd (108-12-00)",
    "$": 3922400,
    "address": "8 Kilsyth Rd",
    "parcel_id": "108-12-00",
    "owner1": "THE MEZZ 2 LLC",
    "owner2": "",
    "current_taxes": 40165.38,
    "new_taxes_no_override": 41900.52,
    "override_total_1": 43089.42,
    "override_increase_1": 1188.9
  },
  {
    "#": "10 Kilsyth Rd, Unit 1 (108-11-01)",
    "$": 1055900,
    "address": "10 Kilsyth Rd, Unit 1",
    "parcel_id": "108-11-01",
    "owner1": "SOUVAINE, DIANE L",
    "owner2": "",
    "current_taxes": 7177.48,
    "new_taxes_no_override": 7487.55,
    "override_total_1": 7700.0,
    "override_increase_1": 212.45
  },
  {
    "#": "10 Kilsyth Rd, Unit 2 (108-11-02)",
    "$": 1099500,
    "address": "10 Kilsyth Rd, Unit 2",
    "parcel_id": "108-11-02",
    "owner1": "COHEN, LIMOR",
    "owner2": "LI, CHARLES HAN",
    "current_taxes": 7623.95,
    "new_taxes_no_override": 7953.3,
    "override_total_1": 8178.97,
    "override_increase_1": 225.67
  },
  {
    "#": "10 Kilsyth Rd, Unit 3 (108-11-03)",
    "$": 1079600,
    "address": "10 Kilsyth Rd, Unit 3",
    "parcel_id": "108-11-03",
    "owner1": "RITTER, CHRISTOPHER C & ALINA I",
    "owner2": "",
    "current_taxes": 7420.17,
    "new_taxes_no_override": 7740.72,
    "override_total_1": 7960.36,
    "override_increase_1": 219.64
  },
  {
    "#": "12 Kilsyth Rd, Unit 1  & P1 (108-10-01)",
    "$": 690300,
    "address": "12 Kilsyth Rd, Unit 1  & P1",
    "parcel_id": "108-10-01",
    "owner1": "TWERSKY LIFE ESTATE, DAVID & BRENDA",
    "owner2": "",
    "current_taxes": 3433.74,
    "new_taxes_no_override": 3582.08,
    "override_total_1": 3683.72,
    "override_increase_1": 101.64
  },
  {
    "#": "12 Kilsyth Rd, Unit 2 (108-10-02)",
    "$": 731700,
    "address": "12 Kilsyth Rd, Unit 2",
    "parcel_id": "108-10-02",
    "owner1": "GAVRONSKY, STAS",
    "owner2": "",
    "current_taxes": 7492.61,
    "new_taxes_no_override": 7816.29,
    "override_total_1": 8038.07,
    "override_increase_1": 221.78
  },
  {
    "#": "12 Kilsyth Rd, Unit 3 & P3 (108-10-03)",
    "$": 1241600,
    "address": "12 Kilsyth Rd, Unit 3 & P3",
    "parcel_id": "108-10-03",
    "owner1": "GAVRONSKY, STAS",
    "owner2": "",
    "current_taxes": 12713.98,
    "new_taxes_no_override": 13263.22,
    "override_total_1": 13639.56,
    "override_increase_1": 376.33
  },
  {
    "#": "12 Kilsyth Rd, Unit 4 & P4 (108-10-04)",
    "$": 1220000,
    "address": "12 Kilsyth Rd, Unit 4 & P4",
    "parcel_id": "108-10-04",
    "owner1": "GOLD, HARRY J",
    "owner2": "",
    "current_taxes": 12492.8,
    "new_taxes_no_override": 13032.49,
    "override_total_1": 13402.28,
    "override_increase_1": 369.79
  },
  {
    "#": "15 Kilsyth Rd (107-10-00)",
    "$": 3282700,
    "address": "15 Kilsyth Rd",
    "parcel_id": "107-10-00",
    "owner1": "SCHER TRS, STEVEN L & LISA BUTTERS",
    "owner2": "",
    "current_taxes": 29979.91,
    "new_taxes_no_override": 31275.04,
    "override_total_1": 32162.45,
    "override_increase_1": 887.41
  },
  {
    "#": "17 Kilsyth Rd (107-11-00)",
    "$": 3729700,
    "address": "17 Kilsyth Rd",
    "parcel_id": "107-11-00",
    "owner1": "BORODYANSKY TRS, LAURA",
    "owner2": "",
    "current_taxes": 34557.19,
    "new_taxes_no_override": 36050.06,
    "override_total_1": 37072.95,
    "override_increase_1": 1022.89
  },
  {
    "#": "18 Kilsyth Rd, Unit 1 (108-09-01)",
    "$": 2020700,
    "address": "18 Kilsyth Rd, Unit 1",
    "parcel_id": "108-09-01",
    "owner1": "GATMOR, EFRAIM",
    "owner2": "SABAN, HAVA",
    "current_taxes": 17057.03,
    "new_taxes_no_override": 17793.89,
    "override_total_1": 18298.78,
    "override_increase_1": 504.89
  },
  {
    "#": "18 Kilsyth Rd, Unit 2 (108-09-02)",
    "$": 2029800,
    "address": "18 Kilsyth Rd, Unit 2",
    "parcel_id": "108-09-02",
    "owner1": "ROSENBLATT, HOWARD S",
    "owner2": "FEIN, MIRIAM",
    "current_taxes": 17150.22,
    "new_taxes_no_override": 17891.11,
    "override_total_1": 18398.76,
    "override_increase_1": 507.65
  },
  {
    "#": "18 Kilsyth Rd, Unit 3 (108-09-03)",
    "$": 1930100,
    "address": "18 Kilsyth Rd, Unit 3",
    "parcel_id": "108-09-03",
    "owner1": "VOGEL, STEPHEN & CLAIRE",
    "owner2": "",
    "current_taxes": 16129.29,
    "new_taxes_no_override": 16826.08,
    "override_total_1": 17303.5,
    "override_increase_1": 477.43
  },
  {
    "#": "19 Kilsyth Rd (107-12-00)",
    "$": 3263800,
    "address": "19 Kilsyth Rd",
    "parcel_id": "107-12-00",
    "owner1": "MILLS, GRAEME J",
    "owner2": "HUNTER, DEBORAH",
    "current_taxes": 29786.38,
    "new_taxes_no_override": 31073.15,
    "override_total_1": 31954.83,
    "override_increase_1": 881.68
  },
  {
    "#": "21 Kilsyth Rd (107-13-00)",
    "$": 2551500,
    "address": "21 Kilsyth Rd",
    "parcel_id": "107-13-00",
    "owner1": "FREMONT, VICTORIA",
    "owner2": "",
    "current_taxes": 22492.43,
    "new_taxes_no_override": 23464.1,
    "override_total_1": 24129.88,
    "override_increase_1": 665.78
  },
  {
    "#": "23 Kilsyth Rd (107-14-00)",
    "$": 3354300,
    "address": "23 Kilsyth Rd",
    "parcel_id": "107-14-00",
    "owner1": "DEGTEREV, ALEXEI",
    "owner2": "TORCHILIN, EKATERINA",
    "current_taxes": 30713.1,
    "new_taxes_no_override": 32039.91,
    "override_total_1": 32949.01,
    "override_increase_1": 909.11
  },
  {
    "#": "24 Kilsyth Rd (108-08-00)",
    "$": 2152700,
    "address": "24 Kilsyth Rd",
    "parcel_id": "108-08-00",
    "owner1": "GOLDSTONE, CHARLES",
    "owner2": "",
    "current_taxes": 18408.71,
    "new_taxes_no_override": 19203.97,
    "override_total_1": 19748.86,
    "override_increase_1": 544.9
  },
  {
    "#": "25 Kilsyth Rd (107-15-00)",
    "$": 3252000,
    "address": "25 Kilsyth Rd",
    "parcel_id": "107-15-00",
    "owner1": "REZNIKOW, JESSE",
    "owner2": "NICASTRO, DOREEN",
    "current_taxes": 29665.55,
    "new_taxes_no_override": 30947.1,
    "override_total_1": 31825.2,
    "override_increase_1": 878.1
  },
  {
    "#": "27 Kilsyth Rd (107-16-00)",
    "$": 2650200,
    "address": "27 Kilsyth Rd",
    "parcel_id": "107-16-00",
    "owner1": "LAWSON, ASTOR G",
    "owner2": "HOSANG, YVONNE",
    "current_taxes": 23503.11,
    "new_taxes_no_override": 24518.44,
    "override_total_1": 25214.14,
    "override_increase_1": 695.69
  },
  {
    "#": "30 Kilsyth Rd, Unit 1 (108-03-01)",
    "$": 596800,
    "address": "30 Kilsyth Rd, Unit 1",
    "parcel_id": "108-03-01",
    "owner1": "MCEACHERN, DONNA",
    "owner2": "",
    "current_taxes": 2476.3,
    "new_taxes_no_override": 2583.28,
    "override_total_1": 2656.57,
    "override_increase_1": 73.3
  },
  {
    "#": "30 Kilsyth Rd, Unit 2 & P2 (108-03-02)",
    "$": 562900,
    "address": "30 Kilsyth Rd, Unit 2 & P2",
    "parcel_id": "108-03-02",
    "owner1": "TSAI, MINDY",
    "owner2": "",
    "current_taxes": 5764.1,
    "new_taxes_no_override": 6013.11,
    "override_total_1": 6183.73,
    "override_increase_1": 170.62
  },
  {
    "#": "30 Kilsyth Rd, Unit 21 (108-03-04)",
    "$": 758300,
    "address": "30 Kilsyth Rd, Unit 21",
    "parcel_id": "108-03-04",
    "owner1": "ZHANG, LIHUA",
    "owner2": "SHEN, TAO",
    "current_taxes": 4130.06,
    "new_taxes_no_override": 4308.48,
    "override_total_1": 4430.73,
    "override_increase_1": 122.25
  },
  {
    "#": "30 Kilsyth Rd, Unit 22 (108-03-05)",
    "$": 535400,
    "address": "30 Kilsyth Rd, Unit 22",
    "parcel_id": "108-03-05",
    "owner1": "HASSON, MICHAEL",
    "owner2": "",
    "current_taxes": 5482.5,
    "new_taxes_no_override": 5719.34,
    "override_total_1": 5881.63,
    "override_increase_1": 162.28
  },
  {
    "#": "30 Kilsyth Rd, Unit 23 (108-03-06)",
    "$": 422400,
    "address": "30 Kilsyth Rd, Unit 23",
    "parcel_id": "108-03-06",
    "owner1": "STREMINSKY, SVETLANA",
    "owner2": "",
    "current_taxes": 4325.38,
    "new_taxes_no_override": 4512.24,
    "override_total_1": 4640.27,
    "override_increase_1": 128.03
  },
  {
    "#": "30 Kilsyth Rd, Unit 3 (108-03-03)",
    "$": 437700,
    "address": "30 Kilsyth Rd, Unit 3",
    "parcel_id": "108-03-03",
    "owner1": "GU, YUNJIA",
    "owner2": "SHEN, JUN YAN",
    "current_taxes": 4482.05,
    "new_taxes_no_override": 4675.67,
    "override_total_1": 4808.34,
    "override_increase_1": 132.67
  },
  {
    "#": "30 Kilsyth Rd, Unit 31 & P3 (108-03-07)",
    "$": 789700,
    "address": "30 Kilsyth Rd, Unit 31 & P3",
    "parcel_id": "108-03-07",
    "owner1": "FAJA, ADAM & SUSAN",
    "owner2": "",
    "current_taxes": 4451.59,
    "new_taxes_no_override": 4643.9,
    "override_total_1": 4775.67,
    "override_increase_1": 131.77
  },
  {
    "#": "30 Kilsyth Rd, Unit 32 (108-03-08)",
    "$": 550700,
    "address": "30 Kilsyth Rd, Unit 32",
    "parcel_id": "108-03-08",
    "owner1": "BARRISON, GERI",
    "owner2": "",
    "current_taxes": 2004.23,
    "new_taxes_no_override": 2090.81,
    "override_total_1": 2150.14,
    "override_increase_1": 59.33
  },
  {
    "#": "30 Kilsyth Rd, Unit 33 (108-03-09)",
    "$": 487500,
    "address": "30 Kilsyth Rd, Unit 33",
    "parcel_id": "108-03-09",
    "owner1": "HENRY, STEPHEN K",
    "owner2": "",
    "current_taxes": 1357.07,
    "new_taxes_no_override": 1415.7,
    "override_total_1": 1455.86,
    "override_increase_1": 40.17
  },
  {
    "#": "30 Kilsyth Rd, Unit B-1 (108-03-29)",
    "$": 433600,
    "address": "30 Kilsyth Rd, Unit B-1",
    "parcel_id": "108-03-29",
    "owner1": "DAVIDSON, WILLIAM S & MICHELLE QUIN",
    "owner2": "",
    "current_taxes": 805.13,
    "new_taxes_no_override": 839.91,
    "override_total_1": 863.74,
    "override_increase_1": 23.83
  },
  {
    "#": "30 Kilsyth Rd, Unit P10 (108-03-28)",
    "$": 48300,
    "address": "30 Kilsyth Rd, Unit P10",
    "parcel_id": "108-03-28",
    "owner1": "ROSS COOK, JANE L",
    "owner2": "",
    "current_taxes": 494.59,
    "new_taxes_no_override": 515.96,
    "override_total_1": 530.6,
    "override_increase_1": 14.64
  },
  {
    "#": "32 Kilsyth Rd, Unit 1 & P1 (108-03-10)",
    "$": 1307900,
    "address": "32 Kilsyth Rd, Unit 1 & P1",
    "parcel_id": "108-03-10",
    "owner1": "DICHTER, BRONISLAW K & PATRICIA M",
    "owner2": "",
    "current_taxes": 9757.96,
    "new_taxes_no_override": 10179.5,
    "override_total_1": 10468.34,
    "override_increase_1": 288.84
  },
  {
    "#": "32 Kilsyth Rd, Unit 2 (108-03-11)",
    "$": 1343800,
    "address": "32 Kilsyth Rd, Unit 2",
    "parcel_id": "108-03-11",
    "owner1": "LARSON, URBAN & BARBARA Z",
    "owner2": "",
    "current_taxes": 10125.58,
    "new_taxes_no_override": 10563.01,
    "override_total_1": 10862.72,
    "override_increase_1": 299.72
  },
  {
    "#": "32 Kilsyth Rd, Unit 3 & P7 (108-03-12)",
    "$": 1356900,
    "address": "32 Kilsyth Rd, Unit 3 & P7",
    "parcel_id": "108-03-12",
    "owner1": "SIDLO, JOHN R",
    "owner2": "",
    "current_taxes": 10259.72,
    "new_taxes_no_override": 10702.94,
    "override_total_1": 11006.63,
    "override_increase_1": 303.69
  },
  {
    "#": "34 Kilsyth Rd, Unit 1 & P6 (108-03-13)",
    "$": 1071100,
    "address": "34 Kilsyth Rd, Unit 1 & P6",
    "parcel_id": "108-03-13",
    "owner1": "JENSEN, DAVID J & DIANE MCMANUS",
    "owner2": "",
    "current_taxes": 7333.13,
    "new_taxes_no_override": 7649.92,
    "override_total_1": 7866.98,
    "override_increase_1": 217.06
  },
  {
    "#": "34 Kilsyth Rd, Unit 2 (108-03-14)",
    "$": 948100,
    "address": "34 Kilsyth Rd, Unit 2",
    "parcel_id": "108-03-14",
    "owner1": "RUSSINOV, LEONID S & YELENA S",
    "owner2": "",
    "current_taxes": 6073.61,
    "new_taxes_no_override": 6335.99,
    "override_total_1": 6515.77,
    "override_increase_1": 179.78
  },
  {
    "#": "34 Kilsyth Rd, Unit 3 & P9 (108-03-15)",
    "$": 1134300,
    "address": "34 Kilsyth Rd, Unit 3 & P9",
    "parcel_id": "108-03-15",
    "owner1": "ALIZADEH, BABAK & SASSAN",
    "owner2": "ELIZABETH BERGL",
    "current_taxes": 11615.23,
    "new_taxes_no_override": 12117.01,
    "override_total_1": 12460.82,
    "override_increase_1": 343.81
  },
  {
    "#": "36 Kilsyth Rd, Unit 1 & P4 (108-03-16)",
    "$": 1262100,
    "address": "36 Kilsyth Rd, Unit 1 & P4",
    "parcel_id": "108-03-16",
    "owner1": "JACKOWITZ TRS, SEAN E",
    "owner2": "SIVITZ TR, REBECCA J",
    "current_taxes": 9288.97,
    "new_taxes_no_override": 9690.25,
    "override_total_1": 9965.21,
    "override_increase_1": 274.95
  },
  {
    "#": "36 Kilsyth Rd, Unit 2 & P11 (108-03-17)",
    "$": 1347500,
    "address": "36 Kilsyth Rd, Unit 2 & P11",
    "parcel_id": "108-03-17",
    "owner1": "DELBAUM, CHARLES",
    "owner2": "KORNHAUSER, MARJORIE",
    "current_taxes": 10163.47,
    "new_taxes_no_override": 10602.53,
    "override_total_1": 10903.37,
    "override_increase_1": 300.84
  },
  {
    "#": "36 Kilsyth Rd, Unit 3 & P5 (108-03-18)",
    "$": 1385200,
    "address": "36 Kilsyth Rd, Unit 3 & P5",
    "parcel_id": "108-03-18",
    "owner1": "DIFABBRIZIO, GIUSEPPE",
    "owner2": "PUGLIELLI, DANIELA",
    "current_taxes": 10549.51,
    "new_taxes_no_override": 11005.25,
    "override_total_1": 11317.51,
    "override_increase_1": 312.27
  },
  {
    "#": "37 Kilsyth Rd (105-07-00)",
    "$": 2553000,
    "address": "37 Kilsyth Rd",
    "parcel_id": "105-07-00",
    "owner1": "CECCHIN, ATTILIO M",
    "owner2": "",
    "current_taxes": 22507.79,
    "new_taxes_no_override": 23480.13,
    "override_total_1": 24146.36,
    "override_increase_1": 666.23
  },
  {
    "#": "38 Kilsyth Rd, Unit 1 & Pk Sp (108-03-19)",
    "$": 617200,
    "address": "38 Kilsyth Rd, Unit 1 & Pk Sp",
    "parcel_id": "108-03-19",
    "owner1": "MACNEILL TR, CHARLES",
    "owner2": "",
    "current_taxes": 2685.19,
    "new_taxes_no_override": 2801.19,
    "override_total_1": 2880.67,
    "override_increase_1": 79.48
  },
  {
    "#": "38 Kilsyth Rd, Unit 2 (108-03-20)",
    "$": 542400,
    "address": "38 Kilsyth Rd, Unit 2",
    "parcel_id": "108-03-20",
    "owner1": "TAUSCH, KAREN H",
    "owner2": "",
    "current_taxes": 5554.18,
    "new_taxes_no_override": 5794.12,
    "override_total_1": 5958.52,
    "override_increase_1": 164.4
  },
  {
    "#": "38 Kilsyth Rd, Unit 21 & P48 (108-03-22)",
    "$": 803300,
    "address": "38 Kilsyth Rd, Unit 21 & P48",
    "parcel_id": "108-03-22",
    "owner1": "JANG, HUEIMEY",
    "owner2": "",
    "current_taxes": 8225.79,
    "new_taxes_no_override": 8581.14,
    "override_total_1": 8824.63,
    "override_increase_1": 243.48
  },
  {
    "#": "38 Kilsyth Rd, Unit 22 (108-03-23)",
    "$": 550600,
    "address": "38 Kilsyth Rd, Unit 22",
    "parcel_id": "108-03-23",
    "owner1": "WU TR, PETER",
    "owner2": "",
    "current_taxes": 2003.21,
    "new_taxes_no_override": 2089.75,
    "override_total_1": 2149.04,
    "override_increase_1": 59.3
  },
  {
    "#": "38 Kilsyth Rd, Unit 23 (108-03-24)",
    "$": 495600,
    "address": "38 Kilsyth Rd, Unit 23",
    "parcel_id": "108-03-24",
    "owner1": "SONI, REENA",
    "owner2": "",
    "current_taxes": 5074.94,
    "new_taxes_no_override": 5294.18,
    "override_total_1": 5444.4,
    "override_increase_1": 150.22
  },
  {
    "#": "38 Kilsyth Rd, Unit 3 (108-03-21)",
    "$": 487500,
    "address": "38 Kilsyth Rd, Unit 3",
    "parcel_id": "108-03-21",
    "owner1": "SHAMIR, BEN",
    "owner2": "",
    "current_taxes": 1357.07,
    "new_taxes_no_override": 1415.7,
    "override_total_1": 1455.86,
    "override_increase_1": 40.17
  },
  {
    "#": "38 Kilsyth Rd, Unit 31 & Pk Sp (108-03-25)",
    "$": 781500,
    "address": "38 Kilsyth Rd, Unit 31 & Pk Sp",
    "parcel_id": "108-03-25",
    "owner1": "GRIMA, ANTHONY V",
    "owner2": "MUISE, PETER F",
    "current_taxes": 4367.63,
    "new_taxes_no_override": 4556.31,
    "override_total_1": 4685.59,
    "override_increase_1": 129.28
  },
  {
    "#": "38 Kilsyth Rd, Unit 32 (108-03-26)",
    "$": 561000,
    "address": "38 Kilsyth Rd, Unit 32",
    "parcel_id": "108-03-26",
    "owner1": "WHITE TR, SHEILA ROGOVIN",
    "owner2": "",
    "current_taxes": 5744.64,
    "new_taxes_no_override": 5992.81,
    "override_total_1": 6162.85,
    "override_increase_1": 170.04
  },
  {
    "#": "38 Kilsyth Rd, Unit 33 (108-03-27)",
    "$": 429500,
    "address": "38 Kilsyth Rd, Unit 33",
    "parcel_id": "108-03-27",
    "owner1": "TALBOT, JEFFREY E",
    "owner2": "",
    "current_taxes": 4398.08,
    "new_taxes_no_override": 4588.08,
    "override_total_1": 4718.26,
    "override_increase_1": 130.18
  },
  {
    "#": "41 Kilsyth Rd (105-08-00)",
    "$": 3346300,
    "address": "41 Kilsyth Rd",
    "parcel_id": "105-08-00",
    "owner1": "MILOVIC, NEBOJSA",
    "owner2": "MARLOWE, JENNIFER",
    "current_taxes": 30631.18,
    "new_taxes_no_override": 31954.45,
    "override_total_1": 32861.13,
    "override_increase_1": 906.68
  },
  {
    "#": "44 Kilsyth Rd, Unit 1 & Pb (108-24-01)",
    "$": 1097000,
    "address": "44 Kilsyth Rd, Unit 1 & Pb",
    "parcel_id": "108-24-01",
    "owner1": "ZIC TR, VLASTA",
    "owner2": "",
    "current_taxes": 7598.35,
    "new_taxes_no_override": 7926.6,
    "override_total_1": 8151.51,
    "override_increase_1": 224.91
  },
  {
    "#": "44 Kilsyth Rd, Unit 2 & P29 (108-24-02)",
    "$": 1127800,
    "address": "44 Kilsyth Rd, Unit 2 & P29",
    "parcel_id": "108-24-02",
    "owner1": "LEVENSTEIN, CHARLES & ELLEN A L",
    "owner2": "",
    "current_taxes": 7913.74,
    "new_taxes_no_override": 8255.61,
    "override_total_1": 8489.86,
    "override_increase_1": 234.25
  },
  {
    "#": "44 Kilsyth Rd, Unit 3 & P31 (108-24-03)",
    "$": 1118700,
    "address": "44 Kilsyth Rd, Unit 3 & P31",
    "parcel_id": "108-24-03",
    "owner1": "LEE, SEUNG EUN",
    "owner2": "GYORI, BENJAMIN M",
    "current_taxes": 7820.55,
    "new_taxes_no_override": 8158.4,
    "override_total_1": 8389.89,
    "override_increase_1": 231.49
  },
  {
    "#": "44 Kilsyth Rd, Unit B & P-A (108-24-04)",
    "$": 462100,
    "address": "44 Kilsyth Rd, Unit B & P-A",
    "parcel_id": "108-24-04",
    "owner1": "HERTZ, KENNETH",
    "owner2": "BOPPANA, SUSHMA",
    "current_taxes": 4731.9,
    "new_taxes_no_override": 4936.32,
    "override_total_1": 5076.38,
    "override_increase_1": 140.06
  },
  {
    "#": "45 Kilsyth Rd (105-09-00)",
    "$": 2659700,
    "address": "45 Kilsyth Rd",
    "parcel_id": "105-09-00",
    "owner1": "SCHILLER, PIERCE",
    "owner2": "",
    "current_taxes": 23600.39,
    "new_taxes_no_override": 24619.93,
    "override_total_1": 25318.5,
    "override_increase_1": 698.57
  },
  {
    "#": "47 Kilsyth Rd (105-09-01)",
    "$": 2228000,
    "address": "47 Kilsyth Rd",
    "parcel_id": "105-09-01",
    "owner1": "MESSING, ELLEN J",
    "owner2": "",
    "current_taxes": 19179.79,
    "new_taxes_no_override": 20008.36,
    "override_total_1": 20576.08,
    "override_increase_1": 567.72
  },
  {
    "#": "48 Kilsyth Rd, Unit 1 (108-02-04)",
    "$": 1098100,
    "address": "48 Kilsyth Rd, Unit 1",
    "parcel_id": "108-02-04",
    "owner1": "BUHLER TRS, PHILIPP M & KATHERINE",
    "owner2": "",
    "current_taxes": 7609.61,
    "new_taxes_no_override": 7938.35,
    "override_total_1": 8163.59,
    "override_increase_1": 225.24
  },
  {
    "#": "48 Kilsyth Rd, Unit 2 & P35 (108-02-02)",
    "$": 1118300,
    "address": "48 Kilsyth Rd, Unit 2 & P35",
    "parcel_id": "108-02-02",
    "owner1": "NOBLE, MICHAEL S",
    "owner2": "",
    "current_taxes": 7816.46,
    "new_taxes_no_override": 8154.13,
    "override_total_1": 8385.5,
    "override_increase_1": 231.37
  },
  {
    "#": "48 Kilsyth Rd, Unit 3 & P36 (108-02-03)",
    "$": 1140800,
    "address": "48 Kilsyth Rd, Unit 3 & P36",
    "parcel_id": "108-02-03",
    "owner1": "48 KILSYTH ROAD UNIT 3 LLC",
    "owner2": "",
    "current_taxes": 8046.86,
    "new_taxes_no_override": 8394.48,
    "override_total_1": 8632.67,
    "override_increase_1": 238.19
  },
  {
    "#": "52 Kilsyth Rd, Unit 1 (108-02-05)",
    "$": 1091500,
    "address": "52 Kilsyth Rd, Unit 1",
    "parcel_id": "108-02-05",
    "owner1": "SIMONS, LEIGH EVANS",
    "owner2": "",
    "current_taxes": 7542.03,
    "new_taxes_no_override": 7867.85,
    "override_total_1": 8091.09,
    "override_increase_1": 223.24
  },
  {
    "#": "52 Kilsyth Rd, Unit 2 (108-02-06)",
    "$": 1166200,
    "address": "52 Kilsyth Rd, Unit 2",
    "parcel_id": "108-02-06",
    "owner1": "GILLIGAN, BETH KATHERINE",
    "owner2": "VOEGE, LODEWIJK OTTO",
    "current_taxes": 8306.95,
    "new_taxes_no_override": 8665.81,
    "override_total_1": 8911.7,
    "override_increase_1": 245.89
  },
  {
    "#": "52 Kilsyth Rd, Unit 3 (108-02-07)",
    "$": 1166200,
    "address": "52 Kilsyth Rd, Unit 3",
    "parcel_id": "108-02-07",
    "owner1": "SCHLAEPPI, YVONNE E",
    "owner2": "",
    "current_taxes": 8306.95,
    "new_taxes_no_override": 8665.81,
    "override_total_1": 8911.7,
    "override_increase_1": 245.89
  },
  {
    "#": "60 Kilsyth Rd (108-01-00)",
    "$": 2684500,
    "address": "60 Kilsyth Rd",
    "parcel_id": "108-01-00",
    "owner1": "STEINBERG, TRS, HOWARD N & SHAINDY",
    "owner2": "",
    "current_taxes": 23854.35,
    "new_taxes_no_override": 24884.86,
    "override_total_1": 25590.95,
    "override_increase_1": 706.09
  },
  {
    "#": "12 Lagrange St (402-34-00)",
    "$": 1850200,
    "address": "12 Lagrange St",
    "parcel_id": "402-34-00",
    "owner1": "RODERICK, CHARLES J",
    "owner2": "",
    "current_taxes": 15311.11,
    "new_taxes_no_override": 15972.55,
    "override_total_1": 16425.76,
    "override_increase_1": 453.21
  },
  {
    "#": "20 Lagrange St (402-35-00)",
    "$": 2253100,
    "address": "20 Lagrange St",
    "parcel_id": "402-35-00",
    "owner1": "TCHERNYCHEV, BORIS",
    "owner2": "SCHENONE, MONICA M",
    "current_taxes": 19436.81,
    "new_taxes_no_override": 20276.48,
    "override_total_1": 20851.81,
    "override_increase_1": 575.33
  },
  {
    "#": "24 Lagrange St (402-36-00)",
    "$": 1211600,
    "address": "24 Lagrange St",
    "parcel_id": "402-36-00",
    "owner1": "BLUMENFELD, BRACHA",
    "owner2": "",
    "current_taxes": 8771.85,
    "new_taxes_no_override": 9150.79,
    "override_total_1": 9410.44,
    "override_increase_1": 259.65
  },
  {
    "#": "27 Lagrange St (408-12-00)",
    "$": 1412600,
    "address": "27 Lagrange St",
    "parcel_id": "408-12-00",
    "owner1": "LEE TRS, JULIA GOON",
    "owner2": "",
    "current_taxes": 10830.09,
    "new_taxes_no_override": 11297.95,
    "override_total_1": 11618.52,
    "override_increase_1": 320.57
  },
  {
    "#": "34 Lagrange St (402-38-39)",
    "$": 2810700,
    "address": "34 Lagrange St",
    "parcel_id": "402-38-39",
    "owner1": "BLUMBERG, RICHARD S & LYNN T",
    "owner2": "",
    "current_taxes": 28781.57,
    "new_taxes_no_override": 30024.93,
    "override_total_1": 30876.87,
    "override_increase_1": 851.93
  },
  {
    "#": "39 Lagrange St (408-13-00)",
    "$": 1749000,
    "address": "39 Lagrange St",
    "parcel_id": "408-13-00",
    "owner1": "LOPES, SUMARA & RONI",
    "owner2": "",
    "current_taxes": 14274.83,
    "new_taxes_no_override": 14891.5,
    "override_total_1": 15314.04,
    "override_increase_1": 422.53
  },
  {
    "#": "45 Lagrange St (408-14-00)",
    "$": 1450300,
    "address": "45 Lagrange St",
    "parcel_id": "408-14-00",
    "owner1": "KHARBANDA, VIKRAM",
    "owner2": "GULATI, MANEESHA",
    "current_taxes": 11216.14,
    "new_taxes_no_override": 11700.68,
    "override_total_1": 12032.67,
    "override_increase_1": 332.0
  },
  {
    "#": "48 Lagrange St (403-01-00)",
    "$": 1086400,
    "address": "48 Lagrange St",
    "parcel_id": "403-01-00",
    "owner1": "YAN, XIAOWEI",
    "owner2": "CHE, JIAN MEI",
    "current_taxes": 7489.8,
    "new_taxes_no_override": 7813.36,
    "override_total_1": 8035.06,
    "override_increase_1": 221.7
  },
  {
    "#": "54 Lagrange St (403-03-00)",
    "$": 1084000,
    "address": "54 Lagrange St",
    "parcel_id": "403-03-00",
    "owner1": "ANDREYEV, IGOR & ALLA",
    "owner2": "",
    "current_taxes": 7465.23,
    "new_taxes_no_override": 7787.73,
    "override_total_1": 8008.7,
    "override_increase_1": 220.97
  },
  {
    "#": "55 Lagrange St (408-15-00)",
    "$": 1446500,
    "address": "55 Lagrange St",
    "parcel_id": "408-15-00",
    "owner1": "TOW, DARREN C & KYOUNGMIN",
    "owner2": "",
    "current_taxes": 11177.23,
    "new_taxes_no_override": 11660.09,
    "override_total_1": 11990.93,
    "override_increase_1": 330.85
  },
  {
    "#": "65 Lagrange St (408-16-00)",
    "$": 1447700,
    "address": "65 Lagrange St",
    "parcel_id": "408-16-00",
    "owner1": "LILLY TRS, NORMA & LEONARD S",
    "owner2": "",
    "current_taxes": 11189.51,
    "new_taxes_no_override": 11672.9,
    "override_total_1": 12004.11,
    "override_increase_1": 331.21
  },
  {
    "#": "71 Lagrange St (408-17-00)",
    "$": 1922300,
    "address": "71 Lagrange St",
    "parcel_id": "408-17-00",
    "owner1": "CHAKAR, NADINE S & SELIM R",
    "owner2": "",
    "current_taxes": 16049.42,
    "new_taxes_no_override": 16742.75,
    "override_total_1": 17217.82,
    "override_increase_1": 475.06
  },
  {
    "#": "78 Lagrange St (405-07-00)",
    "$": 1971000,
    "address": "78 Lagrange St",
    "parcel_id": "405-07-00",
    "owner1": "YEE TR, GEORGE S",
    "owner2": "",
    "current_taxes": 16548.11,
    "new_taxes_no_override": 17262.99,
    "override_total_1": 17752.81,
    "override_increase_1": 489.82
  },
  {
    "#": "81 Lagrange St (408-18-00)",
    "$": 2815600,
    "address": "81 Lagrange St",
    "parcel_id": "408-18-00",
    "owner1": "COX, PHILIP J & LIA",
    "owner2": "",
    "current_taxes": 25196.81,
    "new_taxes_no_override": 26285.31,
    "override_total_1": 27031.14,
    "override_increase_1": 745.83
  },
  {
    "#": "91 Lagrange St (408-19-00)",
    "$": 1726600,
    "address": "91 Lagrange St",
    "parcel_id": "408-19-00",
    "owner1": "ABATE, IWNETIM",
    "owner2": "TADESSE, LOZA",
    "current_taxes": 14045.45,
    "new_taxes_no_override": 14652.21,
    "override_total_1": 15067.96,
    "override_increase_1": 415.75
  },
  {
    "#": "98 Lagrange St (405-08-00)",
    "$": 1513500,
    "address": "98 Lagrange St",
    "parcel_id": "405-08-00",
    "owner1": "CHAN, KI",
    "owner2": "LAU, WAN HUENG",
    "current_taxes": 11863.31,
    "new_taxes_no_override": 12375.8,
    "override_total_1": 12726.96,
    "override_increase_1": 351.15
  },
  {
    "#": "101 Lagrange St (408-20-00)",
    "$": 1513800,
    "address": "101 Lagrange St",
    "parcel_id": "408-20-00",
    "owner1": "KLAPES LIFE ESTATE, BILLIE P",
    "owner2": "",
    "current_taxes": 11866.38,
    "new_taxes_no_override": 12379.01,
    "override_total_1": 12730.25,
    "override_increase_1": 351.24
  },
  {
    "#": "104 Lagrange St (405-09-00)",
    "$": 2685900,
    "address": "104 Lagrange St",
    "parcel_id": "405-09-00",
    "owner1": "WALDRON, ALEX C & ALTHEA",
    "owner2": "",
    "current_taxes": 23868.68,
    "new_taxes_no_override": 24899.81,
    "override_total_1": 25606.32,
    "override_increase_1": 706.51
  },
  {
    "#": "116 Lagrange St (405-10-11)",
    "$": 2189700,
    "address": "116 Lagrange St",
    "parcel_id": "405-10-11",
    "owner1": "HONG, SOON CHUN & JUNG HYE",
    "owner2": "",
    "current_taxes": 18787.59,
    "new_taxes_no_override": 19599.21,
    "override_total_1": 20155.33,
    "override_increase_1": 556.11
  },
  {
    "#": "130 Lagrange St (406-01-00)",
    "$": 2482300,
    "address": "130 Lagrange St",
    "parcel_id": "406-01-00",
    "owner1": "STEVENSON, MARY ANN",
    "owner2": "",
    "current_taxes": 21783.82,
    "new_taxes_no_override": 22724.88,
    "override_total_1": 23369.68,
    "override_increase_1": 644.8
  },
  {
    "#": "135 Lagrange St (409-01-02)",
    "$": 2913000,
    "address": "135 Lagrange St",
    "parcel_id": "409-01-02",
    "owner1": "MALEKI, FARZAM SAFARZADEH",
    "owner2": "HEDAYAT, MONA",
    "current_taxes": 26194.19,
    "new_taxes_no_override": 27325.78,
    "override_total_1": 28101.13,
    "override_increase_1": 775.35
  },
  {
    "#": "142 Lagrange St (406-14-00)",
    "$": 1681200,
    "address": "142 Lagrange St",
    "parcel_id": "406-14-00",
    "owner1": "SONN, CHRISTOPHER I & HYEJIN",
    "owner2": "",
    "current_taxes": 13580.55,
    "new_taxes_no_override": 14167.23,
    "override_total_1": 14569.21,
    "override_increase_1": 401.98
  },
  {
    "#": "145 Lagrange St (409-02-00)",
    "$": 1817700,
    "address": "145 Lagrange St",
    "parcel_id": "409-02-00",
    "owner1": "FRANKLIN, ROBERT M",
    "owner2": "WULSIN, ANNE E",
    "current_taxes": 14978.31,
    "new_taxes_no_override": 15625.37,
    "override_total_1": 16068.73,
    "override_increase_1": 443.36
  },
  {
    "#": "150 Lagrange St (406-13-00)",
    "$": 2098300,
    "address": "150 Lagrange St",
    "parcel_id": "406-13-00",
    "owner1": "GOULD, TRS, STUART S & IMI S",
    "owner2": "",
    "current_taxes": 17851.66,
    "new_taxes_no_override": 18622.85,
    "override_total_1": 19151.26,
    "override_increase_1": 528.41
  },
  {
    "#": "164 Lagrange St (407-02-00)",
    "$": 1722600,
    "address": "164 Lagrange St",
    "parcel_id": "407-02-00",
    "owner1": "PARKER TR, STEPHANIE A",
    "owner2": "",
    "current_taxes": 14004.49,
    "new_taxes_no_override": 14609.48,
    "override_total_1": 15024.02,
    "override_increase_1": 414.53
  },
  {
    "#": "176 Lagrange St (407-01-00)",
    "$": 1020500,
    "address": "176 Lagrange St",
    "parcel_id": "407-01-00",
    "owner1": "PARKER TR, STEPHANIE A",
    "owner2": "",
    "current_taxes": 10449.92,
    "new_taxes_no_override": 10901.36,
    "override_total_1": 11210.67,
    "override_increase_1": 309.32
  },
  {
    "#": "1 Lanark Rd, Unit 1-1 & P54 (108-19-53)",
    "$": 597900,
    "address": "1 Lanark Rd, Unit 1-1 & P54",
    "parcel_id": "108-19-53",
    "owner1": "TSIEH, PETER",
    "owner2": "",
    "current_taxes": 2487.56,
    "new_taxes_no_override": 2595.02,
    "override_total_1": 2668.65,
    "override_increase_1": 73.63
  },
  {
    "#": "1 Lanark Rd, Unit 1-2 & P18 (108-19-54)",
    "$": 572400,
    "address": "1 Lanark Rd, Unit 1-2 & P18",
    "parcel_id": "108-19-54",
    "owner1": "GHAFARI, RAMIN",
    "owner2": "",
    "current_taxes": 5861.38,
    "new_taxes_no_override": 6114.59,
    "override_total_1": 6288.09,
    "override_increase_1": 173.5
  },
  {
    "#": "1 Lanark Rd, Unit 1-3 (108-19-55)",
    "$": 572400,
    "address": "1 Lanark Rd, Unit 1-3",
    "parcel_id": "108-19-55",
    "owner1": "ZIMMERMAN, ET AL, MICHAEL",
    "owner2": "",
    "current_taxes": 5861.38,
    "new_taxes_no_override": 6114.59,
    "override_total_1": 6288.09,
    "override_increase_1": 173.5
  },
  {
    "#": "1 Lanark Rd, Unit 1-4 & P81 (108-19-56)",
    "$": 572400,
    "address": "1 Lanark Rd, Unit 1-4 & P81",
    "parcel_id": "108-19-56",
    "owner1": "HEINE, WALTER F & VELVIZHI RANGANATHAN",
    "owner2": "",
    "current_taxes": 5861.38,
    "new_taxes_no_override": 6114.59,
    "override_total_1": 6288.09,
    "override_increase_1": 173.5
  },
  {
    "#": "1 Lanark Rd, Unit 1-5 (108-19-57)",
    "$": 584300,
    "address": "1 Lanark Rd, Unit 1-5",
    "parcel_id": "108-19-57",
    "owner1": "VARNEY, GEORGE W",
    "owner2": "",
    "current_taxes": 2348.3,
    "new_taxes_no_override": 2449.75,
    "override_total_1": 2519.26,
    "override_increase_1": 69.51
  },
  {
    "#": "1 Lanark Rd, Unit 1-6 & P68 (108-19-58)",
    "$": 584400,
    "address": "1 Lanark Rd, Unit 1-6 & P68",
    "parcel_id": "108-19-58",
    "owner1": "YEO TR, BEE KENG",
    "owner2": "",
    "current_taxes": 5984.26,
    "new_taxes_no_override": 6242.78,
    "override_total_1": 6419.91,
    "override_increase_1": 177.13
  },
  {
    "#": "1 Lanark Rd, Unit 1-7 (108-19-59)",
    "$": 475900,
    "address": "1 Lanark Rd, Unit 1-7",
    "parcel_id": "108-19-59",
    "owner1": "DANG, QUYNH NGOC & THU",
    "owner2": "PHAM, TUAN",
    "current_taxes": 4873.22,
    "new_taxes_no_override": 5083.74,
    "override_total_1": 5227.99,
    "override_increase_1": 144.25
  },
  {
    "#": "6 Lanark Rd, Unit 1 & P39 (109-01-16)",
    "$": 1039700,
    "address": "6 Lanark Rd, Unit 1 & P39",
    "parcel_id": "109-01-16",
    "owner1": "KOCHAR, RITESH",
    "owner2": "ASHER, KAAJAL",
    "current_taxes": 10646.53,
    "new_taxes_no_override": 11106.46,
    "override_total_1": 11421.6,
    "override_increase_1": 315.14
  },
  {
    "#": "6 Lanark Rd, Unit 2 (109-01-01)",
    "$": 652800,
    "address": "6 Lanark Rd, Unit 2",
    "parcel_id": "109-01-01",
    "owner1": "YEE TRS, LAI HA & LAI NGOR & OI YUK CHU",
    "owner2": "",
    "current_taxes": 6684.67,
    "new_taxes_no_override": 6973.45,
    "override_total_1": 7171.31,
    "override_increase_1": 197.87
  },
  {
    "#": "6 Lanark Rd, Unit 3 (109-01-02)",
    "$": 1087900,
    "address": "6 Lanark Rd, Unit 3",
    "parcel_id": "109-01-02",
    "owner1": "PEROLA, EMANUELE",
    "owner2": "",
    "current_taxes": 7505.16,
    "new_taxes_no_override": 7829.38,
    "override_total_1": 8051.54,
    "override_increase_1": 222.15
  },
  {
    "#": "6 Lanark Rd, Unit 4 (109-01-03)",
    "$": 695100,
    "address": "6 Lanark Rd, Unit 4",
    "parcel_id": "109-01-03",
    "owner1": "ZHOU, XIAOMEI",
    "owner2": "",
    "current_taxes": 7117.82,
    "new_taxes_no_override": 7425.31,
    "override_total_1": 7636.0,
    "override_increase_1": 210.69
  },
  {
    "#": "6 Lanark Rd, Unit 5 & P49 (109-01-04)",
    "$": 1016600,
    "address": "6 Lanark Rd, Unit 5 & P49",
    "parcel_id": "109-01-04",
    "owner1": "KREIMAN, CLAUDIA",
    "owner2": "LEADER, EBN DAVID",
    "current_taxes": 6775.05,
    "new_taxes_no_override": 7067.73,
    "override_total_1": 7268.27,
    "override_increase_1": 200.54
  },
  {
    "#": "6 Lanark Rd, Unit 6 & P50 (109-01-05)",
    "$": 806100,
    "address": "6 Lanark Rd, Unit 6 & P50",
    "parcel_id": "109-01-05",
    "owner1": "SCHWARTZ, ANNE",
    "owner2": "",
    "current_taxes": 4619.53,
    "new_taxes_no_override": 4819.09,
    "override_total_1": 4955.83,
    "override_increase_1": 136.74
  },
  {
    "#": "7 Lanark Rd, Unit 7-1 (108-19-60)",
    "$": 587800,
    "address": "7 Lanark Rd, Unit 7-1",
    "parcel_id": "108-19-60",
    "owner1": "KERN LIFE ESTATE, ROBIN A",
    "owner2": "",
    "current_taxes": 2384.14,
    "new_taxes_no_override": 2487.13,
    "override_total_1": 2557.71,
    "override_increase_1": 70.57
  },
  {
    "#": "7 Lanark Rd, Unit 7-2 & P63 (108-19-61)",
    "$": 597900,
    "address": "7 Lanark Rd, Unit 7-2 & P63",
    "parcel_id": "108-19-61",
    "owner1": "ANASTAS, TIMOTHY C",
    "owner2": "",
    "current_taxes": 6122.5,
    "new_taxes_no_override": 6386.99,
    "override_total_1": 6568.22,
    "override_increase_1": 181.23
  },
  {
    "#": "7 Lanark Rd, Unit 7-3 & P60 P66 (108-19-62)",
    "$": 657100,
    "address": "7 Lanark Rd, Unit 7-3 & P60 P66",
    "parcel_id": "108-19-62",
    "owner1": "HU, YIZHONG",
    "owner2": "",
    "current_taxes": 3093.77,
    "new_taxes_no_override": 3227.42,
    "override_total_1": 3319.0,
    "override_increase_1": 91.58
  },
  {
    "#": "7 Lanark Rd, Unit 7-4 & P65 (108-19-63)",
    "$": 598000,
    "address": "7 Lanark Rd, Unit 7-4 & P65",
    "parcel_id": "108-19-63",
    "owner1": "SHAUGHNESSY, FRANCEEN A",
    "owner2": "",
    "current_taxes": 2488.59,
    "new_taxes_no_override": 2596.1,
    "override_total_1": 2669.76,
    "override_increase_1": 73.66
  },
  {
    "#": "7 Lanark Rd, Unit 7-5 (108-19-64)",
    "$": 584300,
    "address": "7 Lanark Rd, Unit 7-5",
    "parcel_id": "108-19-64",
    "owner1": "YE, JINGBO",
    "owner2": "HAN, FANG",
    "current_taxes": 5983.23,
    "new_taxes_no_override": 6241.71,
    "override_total_1": 6418.81,
    "override_increase_1": 177.1
  },
  {
    "#": "7 Lanark Rd, Unit 7-6 & P-70 (108-19-65)",
    "$": 666800,
    "address": "7 Lanark Rd, Unit 7-6 & P-70",
    "parcel_id": "108-19-65",
    "owner1": "ESLAMY, HOMAYOUN & MINOO J",
    "owner2": "",
    "current_taxes": 6828.03,
    "new_taxes_no_override": 7123.0,
    "override_total_1": 7325.11,
    "override_increase_1": 202.11
  },
  {
    "#": "10 Lanark Rd, Unit 1 & P52 (109-01-06)",
    "$": 690900,
    "address": "10 Lanark Rd, Unit 1 & P52",
    "parcel_id": "109-01-06",
    "owner1": "LEE, NANCY",
    "owner2": "",
    "current_taxes": 7074.82,
    "new_taxes_no_override": 7380.45,
    "override_total_1": 7589.87,
    "override_increase_1": 209.41
  },
  {
    "#": "10 Lanark Rd, Unit 2 (109-01-07)",
    "$": 633000,
    "address": "10 Lanark Rd, Unit 2",
    "parcel_id": "109-01-07",
    "owner1": "KEKEZI, SPARTAK & EDLIRA",
    "owner2": "",
    "current_taxes": 2846.99,
    "new_taxes_no_override": 2969.98,
    "override_total_1": 3054.25,
    "override_increase_1": 84.27
  },
  {
    "#": "10 Lanark Rd, Unit 3 & P-55 (109-01-08)",
    "$": 710700,
    "address": "10 Lanark Rd, Unit 3 & P-55",
    "parcel_id": "109-01-08",
    "owner1": "ZELDIN, OLGA",
    "owner2": "",
    "current_taxes": 7277.57,
    "new_taxes_no_override": 7591.96,
    "override_total_1": 7807.38,
    "override_increase_1": 215.42
  },
  {
    "#": "10 Lanark Rd, Unit 4 & P57 (109-01-09)",
    "$": 705500,
    "address": "10 Lanark Rd, Unit 4 & P57",
    "parcel_id": "109-01-09",
    "owner1": "PETKOVA, KRASSIMIRA & KRASSIMIR",
    "owner2": "",
    "current_taxes": 7224.32,
    "new_taxes_no_override": 7536.41,
    "override_total_1": 7750.25,
    "override_increase_1": 213.84
  },
  {
    "#": "10 Lanark Rd, Unit 5 & P33 (109-01-10)",
    "$": 796600,
    "address": "10 Lanark Rd, Unit 5 & P33",
    "parcel_id": "109-01-10",
    "owner1": "HAMMELL, WILLIAM M",
    "owner2": "",
    "current_taxes": 4522.25,
    "new_taxes_no_override": 4717.61,
    "override_total_1": 4851.47,
    "override_increase_1": 133.86
  },
  {
    "#": "10 Lanark Rd, Unit 6 & P47 (109-01-11)",
    "$": 736900,
    "address": "10 Lanark Rd, Unit 6 & P47",
    "parcel_id": "109-01-11",
    "owner1": "CHEN, CAROLYN A",
    "owner2": "RODRIGUEZ DIAZ, ELADIO",
    "current_taxes": 3910.92,
    "new_taxes_no_override": 4079.87,
    "override_total_1": 4195.63,
    "override_increase_1": 115.76
  },
  {
    "#": "11 Lanark Rd (108-19-02)",
    "$": 2566600,
    "address": "11 Lanark Rd",
    "parcel_id": "108-19-02",
    "owner1": "BELKIN, RICHARD I",
    "owner2": "LAUFER, MEREDITH",
    "current_taxes": 26281.98,
    "new_taxes_no_override": 27417.36,
    "override_total_1": 28195.31,
    "override_increase_1": 777.95
  },
  {
    "#": "15 Lanark Rd (108-19-01)",
    "$": 2847800,
    "address": "15 Lanark Rd",
    "parcel_id": "108-19-01",
    "owner1": "SOKOL-MARGOLIS, SAMUEL",
    "owner2": "",
    "current_taxes": 29161.47,
    "new_taxes_no_override": 30421.25,
    "override_total_1": 31284.43,
    "override_increase_1": 863.18
  },
  {
    "#": "19 Lanark Rd, Unit Rear (108-20-00)",
    "$": 96800,
    "address": "19 Lanark Rd, Unit Rear",
    "parcel_id": "108-20-00",
    "owner1": "GARBER TR, PHILIP C",
    "owner2": "",
    "current_taxes": 991.23,
    "new_taxes_no_override": 1034.05,
    "override_total_1": 1063.39,
    "override_increase_1": 29.34
  },
  {
    "#": "23 Lanark Rd (108-21-00)",
    "$": 1208500,
    "address": "23 Lanark Rd",
    "parcel_id": "108-21-00",
    "owner1": "LANARK ROAD LLC",
    "owner2": "",
    "current_taxes": 12375.04,
    "new_taxes_no_override": 12909.64,
    "override_total_1": 13275.94,
    "override_increase_1": 366.3
  },
  {
    "#": "29 Lanark Rd, Unit P1 (108-22-01)",
    "$": 53900,
    "address": "29 Lanark Rd, Unit P1",
    "parcel_id": "108-22-01",
    "owner1": "OIKE, TAKU",
    "owner2": "",
    "current_taxes": 551.94,
    "new_taxes_no_override": 575.78,
    "override_total_1": 592.12,
    "override_increase_1": 16.34
  },
  {
    "#": "31 Lanark Rd, Unit P7 (108-23-01)",
    "$": 53900,
    "address": "31 Lanark Rd, Unit P7",
    "parcel_id": "108-23-01",
    "owner1": "MIATTO, ORIETTA",
    "owner2": "",
    "current_taxes": 551.94,
    "new_taxes_no_override": 575.78,
    "override_total_1": 592.12,
    "override_increase_1": 16.34
  },
  {
    "#": "33 Lanark Rd, Unit P6 (108-23-02)",
    "$": 53900,
    "address": "33 Lanark Rd, Unit P6",
    "parcel_id": "108-23-02",
    "owner1": "BERNDT, CAROLYN",
    "owner2": "",
    "current_taxes": 551.94,
    "new_taxes_no_override": 575.78,
    "override_total_1": 592.12,
    "override_increase_1": 16.34
  },
  {
    "#": "19 Lancaster Ter, Unit 1 (089-11-02)",
    "$": 1353700,
    "address": "19 Lancaster Ter, Unit 1",
    "parcel_id": "089-11-02",
    "owner1": "MURESEANU, IRINA",
    "owner2": "LAFLEUR, JOHN",
    "current_taxes": 13861.89,
    "new_taxes_no_override": 14460.72,
    "override_total_1": 14871.04,
    "override_increase_1": 410.31
  },
  {
    "#": "19 Lancaster Ter, Unit 2 (089-11-01)",
    "$": 1175500,
    "address": "19 Lancaster Ter, Unit 2",
    "parcel_id": "089-11-01",
    "owner1": "CARTY, PETER F",
    "owner2": "PIERCE, ERIN B",
    "current_taxes": 8402.19,
    "new_taxes_no_override": 8765.16,
    "override_total_1": 9013.87,
    "override_increase_1": 248.7
  },
  {
    "#": "33 Lancaster Ter (089-12-13)",
    "$": 17444400,
    "address": "33 Lancaster Ter",
    "parcel_id": "089-12-13",
    "owner1": "LANCASTER TERRACE ASSOC LLC",
    "owner2": "C/O FINEBERG MANAGEMENT INC",
    "current_taxes": 182252.33,
    "new_taxes_no_override": 190125.63,
    "override_total_1": 195520.3,
    "override_increase_1": 5394.67
  },
  {
    "#": "48 Lancaster Ter (091-73-00)",
    "$": 2428300,
    "address": "48 Lancaster Ter",
    "parcel_id": "091-73-00",
    "owner1": "WONG TRS, LEP FOO & LISA XIE",
    "owner2": "",
    "current_taxes": 21230.86,
    "new_taxes_no_override": 22148.03,
    "override_total_1": 22776.47,
    "override_increase_1": 628.43
  },
  {
    "#": "50 Lancaster Ter, Unit 1 P-A (091-72-04)",
    "$": 563600,
    "address": "50 Lancaster Ter, Unit 1 P-A",
    "parcel_id": "091-72-04",
    "owner1": "CANTRELL, JERAMY W & CAITLIN R",
    "owner2": "",
    "current_taxes": 2136.33,
    "new_taxes_no_override": 2228.62,
    "override_total_1": 2291.85,
    "override_increase_1": 63.24
  },
  {
    "#": "50 Lancaster Ter, Unit 2 & Pk-B (091-72-01)",
    "$": 990600,
    "address": "50 Lancaster Ter, Unit 2 & Pk-B",
    "parcel_id": "091-72-01",
    "owner1": "KLAUS, JENNIFER L",
    "owner2": "",
    "current_taxes": 6508.81,
    "new_taxes_no_override": 6789.99,
    "override_total_1": 6982.65,
    "override_increase_1": 192.66
  },
  {
    "#": "50 Lancaster Ter, Unit 3 & P-C (091-72-02)",
    "$": 1021100,
    "address": "50 Lancaster Ter, Unit 3 & P-C",
    "parcel_id": "091-72-02",
    "owner1": "SINGH, GURKIRAT",
    "owner2": "LIN, WEN-HUNG",
    "current_taxes": 6821.13,
    "new_taxes_no_override": 7115.8,
    "override_total_1": 7317.71,
    "override_increase_1": 201.91
  },
  {
    "#": "50 Lancaster Ter, Unit 4& Pksp D (091-72-03)",
    "$": 1033200,
    "address": "50 Lancaster Ter, Unit 4& Pksp D",
    "parcel_id": "091-72-03",
    "owner1": "MO, CHENHUI",
    "owner2": "XIAO, LAN",
    "current_taxes": 10579.97,
    "new_taxes_no_override": 11037.02,
    "override_total_1": 11350.19,
    "override_increase_1": 313.17
  },
  {
    "#": "54 Lancaster Ter, Unit 1 & Ps-1 (091-71-03)",
    "$": 658700,
    "address": "54 Lancaster Ter, Unit 1 & Ps-1",
    "parcel_id": "091-71-03",
    "owner1": "VAVRA, LORRAINE J",
    "owner2": "",
    "current_taxes": 6745.09,
    "new_taxes_no_override": 7036.48,
    "override_total_1": 7236.13,
    "override_increase_1": 199.65
  },
  {
    "#": "54 Lancaster Ter, Unit 2 (091-71-01)",
    "$": 595100,
    "address": "54 Lancaster Ter, Unit 2",
    "parcel_id": "091-71-01",
    "owner1": "COONS  ESQ TR, CARTER",
    "owner2": "",
    "current_taxes": 6093.82,
    "new_taxes_no_override": 6357.07,
    "override_total_1": 6537.45,
    "override_increase_1": 180.38
  },
  {
    "#": "54 Lancaster Ter, Unit 3 & Ps-2 (091-71-02)",
    "$": 730600,
    "address": "54 Lancaster Ter, Unit 3 & Ps-2",
    "parcel_id": "091-71-02",
    "owner1": "LLADO, POL",
    "owner2": "",
    "current_taxes": 3846.41,
    "new_taxes_no_override": 4012.57,
    "override_total_1": 4126.43,
    "override_increase_1": 113.85
  },
  {
    "#": "58 Lancaster Ter (091-70-00)",
    "$": 1914600,
    "address": "58 Lancaster Ter",
    "parcel_id": "091-70-00",
    "owner1": "GARREN TR, DEBRALEE",
    "owner2": "",
    "current_taxes": 19605.5,
    "new_taxes_no_override": 20452.46,
    "override_total_1": 21032.78,
    "override_increase_1": 580.32
  },
  {
    "#": "69 Lancaster Ter (088-18-00)",
    "$": 1534600,
    "address": "69 Lancaster Ter",
    "parcel_id": "088-18-00",
    "owner1": "GARDNER, WILLIAM L",
    "owner2": "ROTTER, SARI J",
    "current_taxes": 15714.3,
    "new_taxes_no_override": 16393.16,
    "override_total_1": 16858.3,
    "override_increase_1": 465.14
  },
  {
    "#": "78 Lancaster Ter (091-68-00)",
    "$": 3096700,
    "address": "78 Lancaster Ter",
    "parcel_id": "091-68-00",
    "owner1": "THEUNISSEN TRS, JAN-WILLEM F A S",
    "owner2": "GONG, YING",
    "current_taxes": 28075.27,
    "new_taxes_no_override": 29288.12,
    "override_total_1": 30119.15,
    "override_increase_1": 831.03
  },
  {
    "#": "79 Lancaster Ter (088-19-00)",
    "$": 2554200,
    "address": "79 Lancaster Ter",
    "parcel_id": "088-19-00",
    "owner1": "RUTKOVE, SEWARD B",
    "owner2": "RUEHR, ELENA L",
    "current_taxes": 22520.07,
    "new_taxes_no_override": 23492.94,
    "override_total_1": 24159.53,
    "override_increase_1": 666.59
  },
  {
    "#": "82 Lancaster Ter (091-67-00)",
    "$": 3213600,
    "address": "82 Lancaster Ter",
    "parcel_id": "091-67-00",
    "owner1": "82 LANCASTER TERRACE LLC",
    "owner2": "",
    "current_taxes": 29272.33,
    "new_taxes_no_override": 30536.89,
    "override_total_1": 31403.36,
    "override_increase_1": 866.46
  },
  {
    "#": "85 Lancaster Ter (088-20-00)",
    "$": 2059900,
    "address": "85 Lancaster Ter",
    "parcel_id": "088-20-00",
    "owner1": "FERGUSON, MICHAEL & JULIE",
    "owner2": "",
    "current_taxes": 17458.44,
    "new_taxes_no_override": 18212.64,
    "override_total_1": 18729.41,
    "override_increase_1": 516.77
  },
  {
    "#": "88 Lancaster Ter (091-66-00)",
    "$": 2912900,
    "address": "88 Lancaster Ter",
    "parcel_id": "091-66-00",
    "owner1": "TENENBAUM, SHELLY",
    "owner2": "",
    "current_taxes": 26193.16,
    "new_taxes_no_override": 27324.7,
    "override_total_1": 28100.02,
    "override_increase_1": 775.32
  },
  {
    "#": "92 Lancaster Ter (091-65-00)",
    "$": 2333600,
    "address": "92 Lancaster Ter",
    "parcel_id": "091-65-00",
    "owner1": "TSO, SIEW WONG & SALLY B",
    "owner2": "",
    "current_taxes": 20261.13,
    "new_taxes_no_override": 21136.41,
    "override_total_1": 21736.14,
    "override_increase_1": 599.73
  },
  {
    "#": "93 Lancaster Ter (088-21-22)",
    "$": 1871200,
    "address": "93 Lancaster Ter",
    "parcel_id": "088-21-22",
    "owner1": "SANDONATO TR, GINA C",
    "owner2": "GINA C SANDONATO REVOCABLE TRUST",
    "current_taxes": 15526.15,
    "new_taxes_no_override": 16196.88,
    "override_total_1": 16656.45,
    "override_increase_1": 459.57
  },
  {
    "#": "98 Lancaster Ter (091-64-00)",
    "$": 2331000,
    "address": "98 Lancaster Ter",
    "parcel_id": "091-64-00",
    "owner1": "SANDER ET AL TRS, MARCEL & SARAH E",
    "owner2": "",
    "current_taxes": 20234.51,
    "new_taxes_no_override": 21108.64,
    "override_total_1": 21707.58,
    "override_increase_1": 598.94
  },
  {
    "#": "99 Lancaster Ter (088-23-00)",
    "$": 1862500,
    "address": "99 Lancaster Ter",
    "parcel_id": "088-23-00",
    "owner1": "PHILLIPS LIFE ESTATE, GERALDINE M",
    "owner2": "C/O DEADRA DOKU GARDNER",
    "current_taxes": 19072.0,
    "new_taxes_no_override": 19895.91,
    "override_total_1": 20460.44,
    "override_increase_1": 564.53
  },
  {
    "#": "105 Lancaster Ter (088-24-00)",
    "$": 1697800,
    "address": "105 Lancaster Ter",
    "parcel_id": "088-24-00",
    "owner1": "SCHEINDLIN, BENJAMIN & BETH",
    "owner2": "",
    "current_taxes": 13750.54,
    "new_taxes_no_override": 14344.56,
    "override_total_1": 14751.58,
    "override_increase_1": 407.02
  },
  {
    "#": "112 Lancaster Ter (091-63-00)",
    "$": 3610800,
    "address": "112 Lancaster Ter",
    "parcel_id": "091-63-00",
    "owner1": "BENJAMIN, EMELIA J",
    "owner2": "POLLAK, DAVID M",
    "current_taxes": 33339.66,
    "new_taxes_no_override": 34779.93,
    "override_total_1": 35766.79,
    "override_increase_1": 986.85
  },
  {
    "#": "114 Lancaster Ter, Unit 1 (091-62-01)",
    "$": 1244700,
    "address": "114 Lancaster Ter, Unit 1",
    "parcel_id": "091-62-01",
    "owner1": "VENMAN TRS, THOMAS CHASE",
    "owner2": "HARRIS , KATHRYN RUTH",
    "current_taxes": 9110.79,
    "new_taxes_no_override": 9504.38,
    "override_total_1": 9774.06,
    "override_increase_1": 269.68
  },
  {
    "#": "114 Lancaster Ter, Unit 2 (091-62-02)",
    "$": 1531800,
    "address": "114 Lancaster Ter, Unit 2",
    "parcel_id": "091-62-02",
    "owner1": "DERMAN TRS, LAURA",
    "owner2": "TEITEL TRS, LEE",
    "current_taxes": 15685.63,
    "new_taxes_no_override": 16363.25,
    "override_total_1": 16827.54,
    "override_increase_1": 464.29
  },
  {
    "#": "115 Lancaster Ter (088-25-26)",
    "$": 2550900,
    "address": "115 Lancaster Ter",
    "parcel_id": "088-25-26",
    "owner1": "LIU TRS, RAYMOND W",
    "owner2": "HAN, SUSAN Z",
    "current_taxes": 22486.28,
    "new_taxes_no_override": 23457.69,
    "override_total_1": 24123.28,
    "override_increase_1": 665.59
  },
  {
    "#": "118 Lancaster Ter (091-61-00)",
    "$": 2312300,
    "address": "118 Lancaster Ter",
    "parcel_id": "091-61-00",
    "owner1": "SHAHROOZ, FARHAD & SUSAN A",
    "owner2": "",
    "current_taxes": 20043.02,
    "new_taxes_no_override": 20908.88,
    "override_total_1": 21502.15,
    "override_increase_1": 593.27
  },
  {
    "#": "119 Lancaster Ter (088-27-00)",
    "$": 2095100,
    "address": "119 Lancaster Ter",
    "parcel_id": "088-27-00",
    "owner1": "WHOLEY, LEONARD N",
    "owner2": "NAYLOR, MARIA-AI  L",
    "current_taxes": 17818.89,
    "new_taxes_no_override": 18588.67,
    "override_total_1": 19116.11,
    "override_increase_1": 527.44
  },
  {
    "#": "122 Lancaster Ter (091-60-00)",
    "$": 1852100,
    "address": "122 Lancaster Ter",
    "parcel_id": "091-60-00",
    "owner1": "WILLERS, HENNING",
    "owner2": "MAHALINGAIAH, SHRUTHI",
    "current_taxes": 15330.57,
    "new_taxes_no_override": 15992.85,
    "override_total_1": 16446.64,
    "override_increase_1": 453.78
  },
  {
    "#": "126 Lancaster Ter (091-59-00)",
    "$": 2310300,
    "address": "126 Lancaster Ter",
    "parcel_id": "091-59-00",
    "owner1": "SUN, WENTAO",
    "owner2": "",
    "current_taxes": 23657.47,
    "new_taxes_no_override": 24679.47,
    "override_total_1": 25379.73,
    "override_increase_1": 700.26
  },
  {
    "#": "128 Lancaster Ter (091-58-00)",
    "$": 2126900,
    "address": "128 Lancaster Ter",
    "parcel_id": "091-58-00",
    "owner1": "MAYOTTE, EDWARD",
    "owner2": "",
    "current_taxes": 21779.46,
    "new_taxes_no_override": 22720.33,
    "override_total_1": 23365.0,
    "override_increase_1": 644.67
  },
  {
    "#": "130 Lancaster Ter, Unit 1 (091-57-01)",
    "$": 1999000,
    "address": "130 Lancaster Ter, Unit 1",
    "parcel_id": "091-57-01",
    "owner1": "SHARMA, KAUSTUBH & POOJA",
    "owner2": "",
    "current_taxes": 20469.76,
    "new_taxes_no_override": 21354.05,
    "override_total_1": 21959.96,
    "override_increase_1": 605.9
  },
  {
    "#": "130 Lancaster Ter, Unit 2 (091-57-02)",
    "$": 1670200,
    "address": "130 Lancaster Ter, Unit 2",
    "parcel_id": "091-57-02",
    "owner1": "KRAMER, ZACHARY",
    "owner2": "SOUSTEK-KRAMER, MEGHAN",
    "current_taxes": 13467.91,
    "new_taxes_no_override": 14049.72,
    "override_total_1": 14448.37,
    "override_increase_1": 398.65
  },
  {
    "#": "138 Lancaster Ter (091-56-00)",
    "$": 2786300,
    "address": "138 Lancaster Ter",
    "parcel_id": "091-56-00",
    "owner1": "SOHIER, KATHARINE SAGE",
    "owner2": "",
    "current_taxes": 24896.78,
    "new_taxes_no_override": 25972.32,
    "override_total_1": 26709.27,
    "override_increase_1": 736.94
  },
  {
    "#": "146 Lancaster Ter (091-54-00)",
    "$": 2882100,
    "address": "146 Lancaster Ter",
    "parcel_id": "091-54-00",
    "owner1": "IVERSEN, TORBEN",
    "owner2": "RUDISILL, CHARLA",
    "current_taxes": 25877.77,
    "new_taxes_no_override": 26995.69,
    "override_total_1": 27761.67,
    "override_increase_1": 765.98
  },
  {
    "#": "150 Lancaster Ter (091-53-00)",
    "$": 2011300,
    "address": "150 Lancaster Ter",
    "parcel_id": "091-53-00",
    "owner1": "WYCKOFF TR, LAURA E",
    "owner2": "",
    "current_taxes": 16960.78,
    "new_taxes_no_override": 17693.49,
    "override_total_1": 18195.52,
    "override_increase_1": 502.04
  },
  {
    "#": "151 Lancaster Ter, Unit A-11 (087-14-11)",
    "$": 1257000,
    "address": "151 Lancaster Ter, Unit A-11",
    "parcel_id": "087-14-11",
    "owner1": "SANTORO TRS, ALBERT J",
    "owner2": "LONZANA, MARTHA",
    "current_taxes": 9236.75,
    "new_taxes_no_override": 9635.78,
    "override_total_1": 9909.19,
    "override_increase_1": 273.41
  },
  {
    "#": "156 Lancaster Ter (091-52-00)",
    "$": 2705600,
    "address": "156 Lancaster Ter",
    "parcel_id": "091-52-00",
    "owner1": "KING TRS, DAVID L",
    "owner2": "CARACCIOLO, ELISA",
    "current_taxes": 24070.41,
    "new_taxes_no_override": 25110.25,
    "override_total_1": 25822.74,
    "override_increase_1": 712.48
  },
  {
    "#": "160 Lancaster Ter (091-51-00)",
    "$": 2194300,
    "address": "160 Lancaster Ter",
    "parcel_id": "091-51-00",
    "owner1": "FUNG, VICKI CHIAO ERH",
    "owner2": "BHANDARI, AMAN",
    "current_taxes": 18834.7,
    "new_taxes_no_override": 19648.36,
    "override_total_1": 20205.87,
    "override_increase_1": 557.51
  },
  {
    "#": "166 Lancaster Ter (091-50-00)",
    "$": 3511500,
    "address": "166 Lancaster Ter",
    "parcel_id": "091-50-00",
    "owner1": "RADEBAUGH, CAREY",
    "owner2": "PRIAM, MYLENE",
    "current_taxes": 32322.83,
    "new_taxes_no_override": 33719.18,
    "override_total_1": 34675.93,
    "override_increase_1": 956.76
  },
  {
    "#": "184 Lancaster Ter (086A-07-00)",
    "$": 2775700,
    "address": "184 Lancaster Ter",
    "parcel_id": "086A-07-00",
    "owner1": "BEROUKHIM, REBECCA S",
    "owner2": "KUSMIN, VICTOR N",
    "current_taxes": 24788.23,
    "new_taxes_no_override": 25859.08,
    "override_total_1": 26592.81,
    "override_increase_1": 733.73
  },
  {
    "#": "190 Lancaster Ter (086A-06-00)",
    "$": 2934000,
    "address": "190 Lancaster Ter",
    "parcel_id": "086A-06-00",
    "owner1": "TSUNG, NANCY Y & YEAN KAI",
    "owner2": "",
    "current_taxes": 26409.23,
    "new_taxes_no_override": 27550.11,
    "override_total_1": 28331.82,
    "override_increase_1": 781.71
  },
  {
    "#": "194 Lancaster Ter (086A-05-00)",
    "$": 2007700,
    "address": "194 Lancaster Ter",
    "parcel_id": "086A-05-00",
    "owner1": "ANSARI, AKBAR",
    "owner2": "AMEERNAZ, SYEDA",
    "current_taxes": 20558.85,
    "new_taxes_no_override": 21446.99,
    "override_total_1": 22055.53,
    "override_increase_1": 608.54
  },
  {
    "#": "200 Lancaster Ter (086A-04-01)",
    "$": 1999900,
    "address": "200 Lancaster Ter",
    "parcel_id": "086A-04-01",
    "owner1": "CHAN TRS, CHIN & PUNG",
    "owner2": "",
    "current_taxes": 16844.04,
    "new_taxes_no_override": 17571.7,
    "override_total_1": 18070.29,
    "override_increase_1": 498.58
  },
  {
    "#": "204 Lancaster Ter (086A-04-00)",
    "$": 2223900,
    "address": "204 Lancaster Ter",
    "parcel_id": "086A-04-00",
    "owner1": "ASTLEY, NICHOLAS H",
    "owner2": "CHEN, YIH-CHIEH S",
    "current_taxes": 19137.8,
    "new_taxes_no_override": 19964.55,
    "override_total_1": 20531.03,
    "override_increase_1": 566.48
  },
  {
    "#": " Lancaster Ter (091-35-01)",
    "$": 18200,
    "address": " Lancaster Ter",
    "parcel_id": "091-35-01",
    "owner1": "RADEBAUGH, CAREY",
    "owner2": "PRIAM, MYLENE",
    "current_taxes": 186.37,
    "new_taxes_no_override": 194.42,
    "override_total_1": 199.94,
    "override_increase_1": 5.52
  },
  {
    "#": "35 Lapland St (440-02-12)",
    "$": 23816400,
    "address": "35 Lapland St",
    "parcel_id": "440-02-12",
    "owner1": "BAKALAR TRS, DAVID",
    "owner2": "",
    "current_taxes": 240245.0,
    "new_taxes_no_override": 250623.58,
    "override_total_1": 257734.84,
    "override_increase_1": 7111.25
  },
  {
    "#": "4 Larkin Rd, Unit 4 (342-07-01)",
    "$": 1329100,
    "address": "4 Larkin Rd, Unit 4",
    "parcel_id": "342-07-01",
    "owner1": "FEUER, ELISABETH",
    "owner2": "JOYCE ET AL TRS, EDWARD J",
    "current_taxes": 9975.05,
    "new_taxes_no_override": 10405.97,
    "override_total_1": 10701.23,
    "override_increase_1": 295.26
  },
  {
    "#": "6 Larkin Rd, Unit 6 (342-07-02)",
    "$": 1436400,
    "address": "6 Larkin Rd, Unit 6",
    "parcel_id": "342-07-02",
    "owner1": "SPIVAK, ALEXANDER & ANNA",
    "owner2": "",
    "current_taxes": 11073.8,
    "new_taxes_no_override": 11552.19,
    "override_total_1": 11879.97,
    "override_increase_1": 327.78
  },
  {
    "#": "11 Larkin Rd (343-14-00)",
    "$": 1379500,
    "address": "11 Larkin Rd",
    "parcel_id": "343-14-00",
    "owner1": "LIU, WILSON",
    "owner2": "",
    "current_taxes": 10491.15,
    "new_taxes_no_override": 10944.37,
    "override_total_1": 11254.91,
    "override_increase_1": 310.54
  },
  {
    "#": "12 Larkin Rd, Unit 12 (342-04-03)",
    "$": 1243800,
    "address": "12 Larkin Rd, Unit 12",
    "parcel_id": "342-04-03",
    "owner1": "DUTRA, MARCELO FARIAS & PATRICIA DA COSTA PIMENTEL TRISTAO",
    "owner2": "",
    "current_taxes": 9101.58,
    "new_taxes_no_override": 9494.77,
    "override_total_1": 9764.18,
    "override_increase_1": 269.41
  },
  {
    "#": "15 Larkin Rd (343-13-00)",
    "$": 1387100,
    "address": "15 Larkin Rd",
    "parcel_id": "343-13-00",
    "owner1": "SAWIN, HERBERT H",
    "owner2": "HELLWIG, VERONICA M",
    "current_taxes": 10568.97,
    "new_taxes_no_override": 11025.55,
    "override_total_1": 11338.39,
    "override_increase_1": 312.84
  },
  {
    "#": "17 Larkin Rd (343-03-00)",
    "$": 1116100,
    "address": "17 Larkin Rd",
    "parcel_id": "343-03-00",
    "owner1": "KELLER, ELIZABETH E",
    "owner2": "",
    "current_taxes": 7793.93,
    "new_taxes_no_override": 8130.63,
    "override_total_1": 8361.33,
    "override_increase_1": 230.7
  },
  {
    "#": "21 Larkin Rd (343-04-00)",
    "$": 958100,
    "address": "21 Larkin Rd",
    "parcel_id": "343-04-00",
    "owner1": "CURRAN TRS, THOMAS A & MARGARET R",
    "owner2": "",
    "current_taxes": 6176.01,
    "new_taxes_no_override": 6442.81,
    "override_total_1": 6625.62,
    "override_increase_1": 182.81
  },
  {
    "#": "11 Laurel Rd (421-11-00)",
    "$": 4506300,
    "address": "11 Laurel Rd",
    "parcel_id": "421-11-00",
    "owner1": "SEITZ, ERIC",
    "owner2": "CORCORAN, MARGARET ELIZABETH",
    "current_taxes": 42509.58,
    "new_taxes_no_override": 44345.99,
    "override_total_1": 45604.28,
    "override_increase_1": 1258.28
  },
  {
    "#": "17 Laurel Rd (421-10-00)",
    "$": 3257600,
    "address": "17 Laurel Rd",
    "parcel_id": "421-10-00",
    "owner1": "GRANDFIELD, KATHARINE A & DOROTHY E",
    "owner2": "",
    "current_taxes": 29722.89,
    "new_taxes_no_override": 31006.92,
    "override_total_1": 31886.72,
    "override_increase_1": 879.8
  },
  {
    "#": "27 Laurel Rd (421-08-00)",
    "$": 4370300,
    "address": "27 Laurel Rd",
    "parcel_id": "421-08-00",
    "owner1": "HAYES, PATRICK WILLIAM ROWE & CAROLINE",
    "owner2": "",
    "current_taxes": 41116.94,
    "new_taxes_no_override": 42893.19,
    "override_total_1": 44110.25,
    "override_increase_1": 1217.06
  },
  {
    "#": "28 Laurel Rd (420-14-00)",
    "$": 4558900,
    "address": "28 Laurel Rd",
    "parcel_id": "420-14-00",
    "owner1": "CENTRAL PART OF TOWN HOLDINGS LLC",
    "owner2": "C/O BURKE & CASSERLY PC",
    "current_taxes": 46683.14,
    "new_taxes_no_override": 48699.85,
    "override_total_1": 50081.67,
    "override_increase_1": 1381.82
  },
  {
    "#": "42 Laurel Rd (420-15-00)",
    "$": 5088000,
    "address": "42 Laurel Rd",
    "parcel_id": "420-15-00",
    "owner1": "BURKE TRS, TIMOTHY P & JOY BARWICK",
    "owner2": "",
    "current_taxes": 52101.12,
    "new_taxes_no_override": 54351.89,
    "override_total_1": 55894.08,
    "override_increase_1": 1542.19
  },
  {
    "#": "45 Laurel Rd (421-06-00)",
    "$": 4539000,
    "address": "45 Laurel Rd",
    "parcel_id": "421-06-00",
    "owner1": "TYLER, WAT & BRITTEN HARTNETT",
    "owner2": "",
    "current_taxes": 46479.36,
    "new_taxes_no_override": 48487.27,
    "override_total_1": 49863.06,
    "override_increase_1": 1375.79
  },
  {
    "#": "48 Laurel Rd (420-16-00)",
    "$": 6878000,
    "address": "48 Laurel Rd",
    "parcel_id": "420-16-00",
    "owner1": "LAUREL PROPERTY HOLDINGS LLC",
    "owner2": "",
    "current_taxes": 70430.72,
    "new_taxes_no_override": 73473.33,
    "override_total_1": 75558.08,
    "override_increase_1": 2084.75
  },
  {
    "#": "57 Laurel Rd (421-05-00)",
    "$": 4567000,
    "address": "57 Laurel Rd",
    "parcel_id": "421-05-00",
    "owner1": "CICCONE TRS, JOSEPH M & KERRIANNE",
    "owner2": "",
    "current_taxes": 43131.15,
    "new_taxes_no_override": 44994.42,
    "override_total_1": 46271.1,
    "override_increase_1": 1276.68
  },
  {
    "#": "66 Laurel Rd (420-17-00)",
    "$": 5326100,
    "address": "66 Laurel Rd",
    "parcel_id": "420-17-00",
    "owner1": "SLAVIN TRS, SUMNER A",
    "owner2": "",
    "current_taxes": 54539.26,
    "new_taxes_no_override": 56895.36,
    "override_total_1": 58509.72,
    "override_increase_1": 1614.36
  },
  {
    "#": "73 Laurel Rd (421-04-00)",
    "$": 5177700,
    "address": "73 Laurel Rd",
    "parcel_id": "421-04-00",
    "owner1": "BREWSTER, DAVID C & GLORIA",
    "owner2": "",
    "current_taxes": 49384.71,
    "new_taxes_no_override": 51518.13,
    "override_total_1": 52979.92,
    "override_increase_1": 1461.79
  },
  {
    "#": "76 Laurel Rd (420-18-19)",
    "$": 8116300,
    "address": "76 Laurel Rd",
    "parcel_id": "420-18-19",
    "owner1": "HALL TRS, LAURIE J",
    "owner2": "MCELHINNEY , JOHN E",
    "current_taxes": 83110.91,
    "new_taxes_no_override": 86701.3,
    "override_total_1": 89161.38,
    "override_increase_1": 2460.08
  },
  {
    "#": "88 Laurel Rd (420-20-00)",
    "$": 4039600,
    "address": "88 Laurel Rd",
    "parcel_id": "420-20-00",
    "owner1": "ROME, JAMIE ADAM & LEILA M",
    "owner2": "",
    "current_taxes": 37730.57,
    "new_taxes_no_override": 39360.53,
    "override_total_1": 40477.36,
    "override_increase_1": 1116.82
  },
  {
    "#": "97 Laurel Rd (421-01-00)",
    "$": 4667700,
    "address": "97 Laurel Rd",
    "parcel_id": "421-01-00",
    "owner1": "TAFF, DEREK E & ELIZABETH H",
    "owner2": "",
    "current_taxes": 44162.31,
    "new_taxes_no_override": 46070.12,
    "override_total_1": 47377.33,
    "override_increase_1": 1307.2
  },
  {
    "#": "106 Laurel Rd (419B-08-01)",
    "$": 4449900,
    "address": "106 Laurel Rd",
    "parcel_id": "419B-08-01",
    "owner1": "GOLDIE, JASON",
    "owner2": "",
    "current_taxes": 45566.98,
    "new_taxes_no_override": 47535.47,
    "override_total_1": 48884.26,
    "override_increase_1": 1348.78
  },
  {
    "#": "111 Laurel Rd (419-18-00)",
    "$": 5127700,
    "address": "111 Laurel Rd",
    "parcel_id": "419-18-00",
    "owner1": "PACINI, STEFANO",
    "owner2": "SONNTAG, ALEXANDRA",
    "current_taxes": 48872.71,
    "new_taxes_no_override": 50984.01,
    "override_total_1": 52430.64,
    "override_increase_1": 1446.63
  },
  {
    "#": "116 Laurel Rd (419B-09-01)",
    "$": 6616400,
    "address": "116 Laurel Rd",
    "parcel_id": "419B-09-01",
    "owner1": "BLACK, JOHN R",
    "owner2": "TAYLOR, ANN",
    "current_taxes": 64117.0,
    "new_taxes_no_override": 66886.85,
    "override_total_1": 68784.72,
    "override_increase_1": 1897.86
  },
  {
    "#": "121 Laurel Rd (419-17-00)",
    "$": 5940200,
    "address": "121 Laurel Rd",
    "parcel_id": "419-17-00",
    "owner1": "LITLE V TR, THOMAS J",
    "owner2": "",
    "current_taxes": 60827.65,
    "new_taxes_no_override": 63455.4,
    "override_total_1": 65255.9,
    "override_increase_1": 1800.5
  },
  {
    "#": "128 Laurel Rd (419B-10-00)",
    "$": 3638700,
    "address": "128 Laurel Rd",
    "parcel_id": "419B-10-00",
    "owner1": "GILULA, JONATHAN E & ROBIN",
    "owner2": "",
    "current_taxes": 33625.35,
    "new_taxes_no_override": 35077.97,
    "override_total_1": 36073.28,
    "override_increase_1": 995.31
  },
  {
    "#": "131 Laurel Rd (419-16-00)",
    "$": 4514400,
    "address": "131 Laurel Rd",
    "parcel_id": "419-16-00",
    "owner1": "HOE-RICHARDSON, PETER & LAURA",
    "owner2": "",
    "current_taxes": 42592.52,
    "new_taxes_no_override": 44432.52,
    "override_total_1": 45693.26,
    "override_increase_1": 1260.74
  },
  {
    "#": "136 Laurel Rd (419B-11-00)",
    "$": 3655800,
    "address": "136 Laurel Rd",
    "parcel_id": "419B-11-00",
    "owner1": "LEWIN TR, LEONARD L",
    "owner2": "",
    "current_taxes": 37435.39,
    "new_taxes_no_override": 39052.6,
    "override_total_1": 40160.69,
    "override_increase_1": 1108.09
  },
  {
    "#": "143 Laurel Rd (419-15-00)",
    "$": 4804800,
    "address": "143 Laurel Rd",
    "parcel_id": "419-15-00",
    "owner1": "GANJEI, JOSHUA Y & HANNAH",
    "owner2": "",
    "current_taxes": 45566.22,
    "new_taxes_no_override": 47534.68,
    "override_total_1": 48883.44,
    "override_increase_1": 1348.76
  },
  {
    "#": "151 Laurel Rd (419-14-00)",
    "$": 4106500,
    "address": "151 Laurel Rd",
    "parcel_id": "419-14-00",
    "owner1": "DIBNER TRS, BRENT & RACHEL",
    "owner2": "",
    "current_taxes": 38415.63,
    "new_taxes_no_override": 40075.19,
    "override_total_1": 41212.29,
    "override_increase_1": 1137.1
  },
  {
    "#": "160 Laurel Rd (419A-09-00)",
    "$": 4059100,
    "address": "160 Laurel Rd",
    "parcel_id": "419A-09-00",
    "owner1": "MARCHAND, JACQUELINE & LUKE",
    "owner2": "",
    "current_taxes": 37930.25,
    "new_taxes_no_override": 39568.84,
    "override_total_1": 40691.57,
    "override_increase_1": 1122.74
  },
  {
    "#": "167 Laurel Rd (419-19-00)",
    "$": 3240800,
    "address": "167 Laurel Rd",
    "parcel_id": "419-19-00",
    "owner1": "NADDAFF, MARTHA L",
    "owner2": "",
    "current_taxes": 33185.79,
    "new_taxes_no_override": 34619.42,
    "override_total_1": 35601.72,
    "override_increase_1": 982.3
  },
  {
    "#": "173 Laurel Rd (419-12-02)",
    "$": 4686600,
    "address": "173 Laurel Rd",
    "parcel_id": "419-12-02",
    "owner1": "SHEENA TRS, DAVID & SOLOMON J",
    "owner2": "",
    "current_taxes": 44355.85,
    "new_taxes_no_override": 46272.02,
    "override_total_1": 47584.96,
    "override_increase_1": 1312.93
  },
  {
    "#": "174 Laurel Rd (419A-01-02)",
    "$": 3069400,
    "address": "174 Laurel Rd",
    "parcel_id": "419A-01-02",
    "owner1": "TSATSKIS, FELIX & ANGELA",
    "owner2": "",
    "current_taxes": 27795.72,
    "new_taxes_no_override": 28996.5,
    "override_total_1": 29819.25,
    "override_increase_1": 822.75
  },
  {
    "#": "181 Laurel Rd (419-11-00)",
    "$": 3619600,
    "address": "181 Laurel Rd",
    "parcel_id": "419-11-00",
    "owner1": "PUNWANI, VIKRAM S",
    "owner2": "KOZEK, LAURA",
    "current_taxes": 33429.77,
    "new_taxes_no_override": 34873.94,
    "override_total_1": 35863.46,
    "override_increase_1": 989.52
  },
  {
    "#": "186 Laurel Rd (419A-03-00)",
    "$": 3024000,
    "address": "186 Laurel Rd",
    "parcel_id": "419A-03-00",
    "owner1": "ROHATGI, NALIN & PRIYANKA",
    "owner2": "",
    "current_taxes": 27330.83,
    "new_taxes_no_override": 28511.52,
    "override_total_1": 29320.51,
    "override_increase_1": 808.99
  },
  {
    "#": "3 Lawrence Rd (126-34-00)",
    "$": 2812100,
    "address": "3 Lawrence Rd",
    "parcel_id": "126-34-00",
    "owner1": "SUK, JIN",
    "owner2": "STEIN, BARBARA M",
    "current_taxes": 25160.97,
    "new_taxes_no_override": 26247.92,
    "override_total_1": 26992.69,
    "override_increase_1": 744.76
  },
  {
    "#": "7 Lawrence Rd (126-35-00)",
    "$": 3108300,
    "address": "7 Lawrence Rd",
    "parcel_id": "126-35-00",
    "owner1": "SAMUELS, MICHAEL",
    "owner2": "",
    "current_taxes": 28194.06,
    "new_taxes_no_override": 29412.04,
    "override_total_1": 30246.59,
    "override_increase_1": 834.54
  },
  {
    "#": "11 Lawrence Rd (126-36-00)",
    "$": 2198900,
    "address": "11 Lawrence Rd",
    "parcel_id": "126-36-00",
    "owner1": "FATHIBITARAF, JAMAL",
    "owner2": "",
    "current_taxes": 22516.74,
    "new_taxes_no_override": 23489.46,
    "override_total_1": 24155.96,
    "override_increase_1": 666.5
  },
  {
    "#": "12 Lawrence Rd (126-37-00)",
    "$": 3089200,
    "address": "12 Lawrence Rd",
    "parcel_id": "126-37-00",
    "owner1": "UPHAM, JOSEPH P & JANNA M",
    "owner2": "",
    "current_taxes": 27998.47,
    "new_taxes_no_override": 29208.0,
    "override_total_1": 30036.76,
    "override_increase_1": 828.75
  },
  {
    "#": "21 Lawton St, Unit 1 (069-25-01)",
    "$": 2185700,
    "address": "21 Lawton St, Unit 1",
    "parcel_id": "069-25-01",
    "owner1": "CHAN, STELLA WAI YUE & DARREN Y",
    "owner2": "",
    "current_taxes": 22381.57,
    "new_taxes_no_override": 23348.45,
    "override_total_1": 24010.95,
    "override_increase_1": 662.49
  },
  {
    "#": "21 Lawton St, Unit 2 (069-25-02)",
    "$": 2527600,
    "address": "21 Lawton St, Unit 2",
    "parcel_id": "069-25-02",
    "owner1": "NG TRS, SHEUNG CHEE THOMAS",
    "owner2": "AN, MICHELLE SOON",
    "current_taxes": 22247.69,
    "new_taxes_no_override": 23208.79,
    "override_total_1": 23867.32,
    "override_increase_1": 658.53
  },
  {
    "#": "27 Lawton St (069-26-00)",
    "$": 2139300,
    "address": "27 Lawton St",
    "parcel_id": "069-26-00",
    "owner1": "NG TRS, YEE MAN & YEE CHOR",
    "owner2": "",
    "current_taxes": 18271.5,
    "new_taxes_no_override": 19060.83,
    "override_total_1": 19601.67,
    "override_increase_1": 540.84
  },
  {
    "#": "33 Lawton St (069-27-00)",
    "$": 2191100,
    "address": "33 Lawton St",
    "parcel_id": "069-27-00",
    "owner1": "ORENSTEIN TR, SANDRA J",
    "owner2": "",
    "current_taxes": 18801.93,
    "new_taxes_no_override": 19614.17,
    "override_total_1": 20170.71,
    "override_increase_1": 556.54
  },
  {
    "#": "38 Lawton St (070-17-00)",
    "$": 2542400,
    "address": "38 Lawton St",
    "parcel_id": "070-17-00",
    "owner1": "LAWTON STREET LLC",
    "owner2": "",
    "current_taxes": 26034.18,
    "new_taxes_no_override": 27158.86,
    "override_total_1": 27929.47,
    "override_increase_1": 770.61
  },
  {
    "#": "39 Lawton St (069-28-00)",
    "$": 2626200,
    "address": "39 Lawton St",
    "parcel_id": "069-28-00",
    "owner1": "REES ET AL, HOLLY",
    "owner2": "CROWLEY, BRIAN",
    "current_taxes": 23257.35,
    "new_taxes_no_override": 24262.07,
    "override_total_1": 24950.49,
    "override_increase_1": 688.42
  },
  {
    "#": "45 Lawton St, Unit 1 (069-29-01)",
    "$": 1856300,
    "address": "45 Lawton St, Unit 1",
    "parcel_id": "069-29-01",
    "owner1": "DENG, DONG",
    "owner2": "YANG, XIAOHUI",
    "current_taxes": 19008.51,
    "new_taxes_no_override": 19829.68,
    "override_total_1": 20392.33,
    "override_increase_1": 562.65
  },
  {
    "#": "45 Lawton St, Unit 2 (069-29-02)",
    "$": 1955200,
    "address": "45 Lawton St, Unit 2",
    "parcel_id": "069-29-02",
    "owner1": "JAWISH, JEREMY & ANNE-SOPHIE",
    "owner2": "",
    "current_taxes": 16386.31,
    "new_taxes_no_override": 17094.2,
    "override_total_1": 17579.23,
    "override_increase_1": 485.03
  },
  {
    "#": "48 Lawton St (070-16-00)",
    "$": 2510900,
    "address": "48 Lawton St",
    "parcel_id": "070-16-00",
    "owner1": "MOY-YEE TR, LILLIAN S",
    "owner2": "",
    "current_taxes": 22076.68,
    "new_taxes_no_override": 23030.39,
    "override_total_1": 23683.86,
    "override_increase_1": 653.47
  },
  {
    "#": "53 Lawton St (069-30-00)",
    "$": 2957400,
    "address": "53 Lawton St",
    "parcel_id": "069-30-00",
    "owner1": "MILLER TRS, BENJAMIN O",
    "owner2": "REGAN, SUSAN",
    "current_taxes": 26648.84,
    "new_taxes_no_override": 27800.07,
    "override_total_1": 28588.88,
    "override_increase_1": 788.81
  },
  {
    "#": "54 Lawton St, Unit 1 (070-15-01)",
    "$": 1073500,
    "address": "54 Lawton St, Unit 1",
    "parcel_id": "070-15-01",
    "owner1": "CHIE, JULIA YAU-KUEN&HEE MAN",
    "owner2": "",
    "current_taxes": 7357.71,
    "new_taxes_no_override": 7675.56,
    "override_total_1": 7893.35,
    "override_increase_1": 217.79
  },
  {
    "#": "54 Lawton St, Unit 2 (070-15-02)",
    "$": 1355700,
    "address": "54 Lawton St, Unit 2",
    "parcel_id": "070-15-02",
    "owner1": "CHIE TR, LUCY Y",
    "owner2": "",
    "current_taxes": 10247.43,
    "new_taxes_no_override": 10690.12,
    "override_total_1": 10993.44,
    "override_increase_1": 303.32
  },
  {
    "#": "57 Lawton St, Unit 1 (069-31-01)",
    "$": 1518100,
    "address": "57 Lawton St, Unit 1",
    "parcel_id": "069-31-01",
    "owner1": "BULGRIN, SUSAN M & LAURA N",
    "owner2": "AKULA, SUJEET",
    "current_taxes": 15545.34,
    "new_taxes_no_override": 16216.9,
    "override_total_1": 16677.04,
    "override_increase_1": 460.14
  },
  {
    "#": "57 Lawton St, Unit 2 (069-31-02)",
    "$": 1272100,
    "address": "57 Lawton St, Unit 2",
    "parcel_id": "069-31-02",
    "owner1": "WU, AMY F & ROBERT H",
    "owner2": "",
    "current_taxes": 13026.3,
    "new_taxes_no_override": 13589.04,
    "override_total_1": 13974.61,
    "override_increase_1": 385.58
  },
  {
    "#": "60 Lawton St (070-14-00)",
    "$": 2223400,
    "address": "60 Lawton St",
    "parcel_id": "070-14-00",
    "owner1": "WOO TRS, YIN GO & SHOO HING",
    "owner2": "",
    "current_taxes": 19132.68,
    "new_taxes_no_override": 19959.21,
    "override_total_1": 20525.54,
    "override_increase_1": 566.33
  },
  {
    "#": "63 Lawton St (069-32-00)",
    "$": 2151200,
    "address": "63 Lawton St",
    "parcel_id": "069-32-00",
    "owner1": "FONG, TRS, MOY O&RAYMOND W&ANDY W",
    "owner2": "",
    "current_taxes": 18393.35,
    "new_taxes_no_override": 19187.94,
    "override_total_1": 19732.39,
    "override_increase_1": 544.44
  },
  {
    "#": "66 Lawton St, Unit 1 (070-13-01)",
    "$": 1640900,
    "address": "66 Lawton St, Unit 1",
    "parcel_id": "070-13-01",
    "owner1": "RUBENSTEIN, ARIELLE & JASON",
    "owner2": "",
    "current_taxes": 16802.82,
    "new_taxes_no_override": 17528.7,
    "override_total_1": 18026.07,
    "override_increase_1": 497.36
  },
  {
    "#": "66 Lawton St, Unit 2 (070-13-02)",
    "$": 1638700,
    "address": "66 Lawton St, Unit 2",
    "parcel_id": "070-13-02",
    "owner1": "WEINSTOCK, BRUCE",
    "owner2": "KEMPLER, LISA",
    "current_taxes": 13145.35,
    "new_taxes_no_override": 13713.23,
    "override_total_1": 14102.33,
    "override_increase_1": 389.1
  },
  {
    "#": "71 Lawton St (069-33-00)",
    "$": 2262900,
    "address": "71 Lawton St",
    "parcel_id": "069-33-00",
    "owner1": "HO, HELEN M M & SUMMING",
    "owner2": "KAREN K-KARMEN K-KATIE K",
    "current_taxes": 19537.16,
    "new_taxes_no_override": 20381.17,
    "override_total_1": 20959.47,
    "override_increase_1": 578.3
  },
  {
    "#": "74 Lawton St (070-12-00)",
    "$": 2748400,
    "address": "74 Lawton St",
    "parcel_id": "070-12-00",
    "owner1": "WILLIAMSON TRS, TODD A & HIROKO",
    "owner2": "",
    "current_taxes": 24508.68,
    "new_taxes_no_override": 25567.45,
    "override_total_1": 26292.91,
    "override_increase_1": 725.46
  },
  {
    "#": "78 Lawton St (070-11-00)",
    "$": 1855800,
    "address": "78 Lawton St",
    "parcel_id": "070-11-00",
    "owner1": "HONG, YIN S & MEE L",
    "owner2": "",
    "current_taxes": 15368.46,
    "new_taxes_no_override": 16032.38,
    "override_total_1": 16487.28,
    "override_increase_1": 454.91
  },
  {
    "#": "79 Lawton St (069-34-00)",
    "$": 2058400,
    "address": "79 Lawton St",
    "parcel_id": "069-34-00",
    "owner1": "LEUNG TRS, GEORGE & CARIE",
    "owner2": "",
    "current_taxes": 17443.08,
    "new_taxes_no_override": 18196.62,
    "override_total_1": 18712.94,
    "override_increase_1": 516.32
  },
  {
    "#": "84 Lawton St (070-10-00)",
    "$": 2189600,
    "address": "84 Lawton St",
    "parcel_id": "070-10-00",
    "owner1": "HUNG TRS, SU-CHEN",
    "owner2": "",
    "current_taxes": 22421.5,
    "new_taxes_no_override": 23390.11,
    "override_total_1": 24053.79,
    "override_increase_1": 663.68
  },
  {
    "#": "85 Lawton St (069-35-00)",
    "$": 2066500,
    "address": "85 Lawton St",
    "parcel_id": "069-35-00",
    "owner1": "SOOHOO TRS, PHILLIP G",
    "owner2": "KWAI, SIM",
    "current_taxes": 21160.96,
    "new_taxes_no_override": 22075.11,
    "override_total_1": 22701.48,
    "override_increase_1": 626.36
  },
  {
    "#": "90 Lawton St, Unit 1 & Pa- Gc (070-09-01)",
    "$": 1612500,
    "address": "90 Lawton St, Unit 1 & Pa- Gc",
    "parcel_id": "070-09-01",
    "owner1": "MOLDAVSKY, ASSAF",
    "owner2": "KARAVAEVA, YULIA",
    "current_taxes": 12877.07,
    "new_taxes_no_override": 13433.36,
    "override_total_1": 13814.52,
    "override_increase_1": 381.16
  },
  {
    "#": "90 Lawton St, Unit 2 & Pb Gd (070-09-02)",
    "$": 1678500,
    "address": "90 Lawton St, Unit 2 & Pb Gd",
    "parcel_id": "070-09-02",
    "owner1": "CHANG, EUGENE K",
    "owner2": "LEE, CHI HYUNG",
    "current_taxes": 13552.91,
    "new_taxes_no_override": 14138.4,
    "override_total_1": 14539.56,
    "override_increase_1": 401.17
  },
  {
    "#": "93 Lawton St (069-36-00)",
    "$": 2744800,
    "address": "93 Lawton St",
    "parcel_id": "069-36-00",
    "owner1": "LEW, MICHAEL & HELEN",
    "owner2": "",
    "current_taxes": 24471.82,
    "new_taxes_no_override": 25529.0,
    "override_total_1": 26253.37,
    "override_increase_1": 724.37
  },
  {
    "#": "96 Lawton St (070-08-00)",
    "$": 2266300,
    "address": "96 Lawton St",
    "parcel_id": "070-08-00",
    "owner1": "ZHONG, WEIN LIN & WEI TAN & WEI XIAO",
    "owner2": "",
    "current_taxes": 19571.98,
    "new_taxes_no_override": 20417.49,
    "override_total_1": 20996.82,
    "override_increase_1": 579.33
  },
  {
    "#": "102 Lawton St (070-07-00)",
    "$": 1932700,
    "address": "102 Lawton St",
    "parcel_id": "070-07-00",
    "owner1": "LOU, MAUNG C & LILIAN",
    "owner2": "",
    "current_taxes": 16155.91,
    "new_taxes_no_override": 16853.85,
    "override_total_1": 17332.06,
    "override_increase_1": 478.21
  },
  {
    "#": "103 Lawton St (069-37-00)",
    "$": 2840400,
    "address": "103 Lawton St",
    "parcel_id": "069-37-00",
    "owner1": "SHENG, PAUL HWA-YOUN & MORGAN",
    "owner2": "",
    "current_taxes": 29085.7,
    "new_taxes_no_override": 30342.2,
    "override_total_1": 31203.14,
    "override_increase_1": 860.94
  },
  {
    "#": "105 Lawton St (069-38-00)",
    "$": 2018400,
    "address": "105 Lawton St",
    "parcel_id": "069-38-00",
    "owner1": "CMW REALTY LLC",
    "owner2": "",
    "current_taxes": 20668.42,
    "new_taxes_no_override": 21561.3,
    "override_total_1": 22173.08,
    "override_increase_1": 611.79
  },
  {
    "#": "108 Lawton St (070-06-00)",
    "$": 2088500,
    "address": "108 Lawton St",
    "parcel_id": "070-06-00",
    "owner1": "LAU, KIN L",
    "owner2": "",
    "current_taxes": 21386.24,
    "new_taxes_no_override": 22310.13,
    "override_total_1": 22943.16,
    "override_increase_1": 633.03
  },
  {
    "#": "112 Lawton St (070-05-00)",
    "$": 1772000,
    "address": "112 Lawton St",
    "parcel_id": "070-05-00",
    "owner1": "HUIE, HANNAH W & CHUN KWOK",
    "owner2": "",
    "current_taxes": 14510.35,
    "new_taxes_no_override": 15137.2,
    "override_total_1": 15566.7,
    "override_increase_1": 429.51
  },
  {
    "#": "115 Lawton St (069-39-40)",
    "$": 3003900,
    "address": "115 Lawton St",
    "parcel_id": "069-39-40",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O LAWTON PLAYGROUND SOUTH",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "116 Lawton St (070-03-00)",
    "$": 2945400,
    "address": "116 Lawton St",
    "parcel_id": "070-03-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O LAWTON PLAYGROUND NORTH",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "156 Lawton St (070-02-00)",
    "$": 5935200,
    "address": "156 Lawton St",
    "parcel_id": "070-02-00",
    "owner1": "COMMONWEALTH  APTS LTD PRTSHP",
    "owner2": "",
    "current_taxes": 101848.03,
    "new_taxes_no_override": 106247.86,
    "override_total_1": 109262.57,
    "override_increase_1": 3014.7
  },
  {
    "#": "25 Lee St (336-19-00)",
    "$": 1629600,
    "address": "25 Lee St",
    "parcel_id": "336-19-00",
    "owner1": "MYERS, MITCHELL J& LINDA J",
    "owner2": "",
    "current_taxes": 13052.17,
    "new_taxes_no_override": 13616.02,
    "override_total_1": 14002.37,
    "override_increase_1": 386.34
  },
  {
    "#": "31 Lee St (336-18-00)",
    "$": 1679200,
    "address": "31 Lee St",
    "parcel_id": "336-18-00",
    "owner1": "PETERSON, TRS, GREGORY & JOANNE",
    "owner2": "",
    "current_taxes": 13560.07,
    "new_taxes_no_override": 14145.87,
    "override_total_1": 14547.24,
    "override_increase_1": 401.38
  },
  {
    "#": "37 Lee St (336-17-00)",
    "$": 2509900,
    "address": "37 Lee St",
    "parcel_id": "336-17-00",
    "owner1": "LIU TRS, YU",
    "owner2": "TRAN, TU MAI D",
    "current_taxes": 22066.44,
    "new_taxes_no_override": 23019.71,
    "override_total_1": 23672.88,
    "override_increase_1": 653.17
  },
  {
    "#": "49 Lee St (336-16-00)",
    "$": 3884000,
    "address": "49 Lee St",
    "parcel_id": "336-16-00",
    "owner1": "BANSAL, AMIT & RIMA",
    "owner2": "",
    "current_taxes": 36137.23,
    "new_taxes_no_override": 37698.36,
    "override_total_1": 38768.02,
    "override_increase_1": 1069.66
  },
  {
    "#": "55 Lee St (336-15-00)",
    "$": 3261900,
    "address": "55 Lee St",
    "parcel_id": "336-15-00",
    "owner1": "MADNICK TR, STUART E",
    "owner2": "",
    "current_taxes": 33401.86,
    "new_taxes_no_override": 34844.82,
    "override_total_1": 35833.52,
    "override_increase_1": 988.7
  },
  {
    "#": "75 Lee St (336-13-00)",
    "$": 3019600,
    "address": "75 Lee St",
    "parcel_id": "336-13-00",
    "owner1": "HUANG, XI",
    "owner2": "PU, MEI",
    "current_taxes": 27285.77,
    "new_taxes_no_override": 28464.52,
    "override_total_1": 29272.17,
    "override_increase_1": 807.66
  },
  {
    "#": "83 Lee St (336-12-00)",
    "$": 3819200,
    "address": "83 Lee St",
    "parcel_id": "336-12-00",
    "owner1": "83 LEE STREET BROOKLINE LLC",
    "owner2": "C/O BRIAN DOUGLAS HOST",
    "current_taxes": 39108.61,
    "new_taxes_no_override": 40798.1,
    "override_total_1": 41955.72,
    "override_increase_1": 1157.61
  },
  {
    "#": "97 Lee St (336-11-00)",
    "$": 5064100,
    "address": "97 Lee St",
    "parcel_id": "336-11-00",
    "owner1": "FAISAL, ANWAR",
    "owner2": "",
    "current_taxes": 51856.38,
    "new_taxes_no_override": 54096.58,
    "override_total_1": 55631.52,
    "override_increase_1": 1534.95
  },
  {
    "#": "109 Lee St (336-09-10)",
    "$": 5556900,
    "address": "109 Lee St",
    "parcel_id": "336-09-10",
    "owner1": "HUANG, BO & ALLISON LI",
    "owner2": "",
    "current_taxes": 56902.66,
    "new_taxes_no_override": 59360.85,
    "override_total_1": 61045.17,
    "override_increase_1": 1684.32
  },
  {
    "#": "125 Lee St (336-08-00)",
    "$": 5172400,
    "address": "125 Lee St",
    "parcel_id": "336-08-00",
    "owner1": "MADENCI, ARIN LINDQUIST & KRISTIN ANNE",
    "owner2": "LINDQUIST, DIANE",
    "current_taxes": 52965.38,
    "new_taxes_no_override": 55253.48,
    "override_total_1": 56821.26,
    "override_increase_1": 1567.78
  },
  {
    "#": "145 Lee St (336-07-00)",
    "$": 5179500,
    "address": "145 Lee St",
    "parcel_id": "336-07-00",
    "owner1": "EKLUND TR, CHRISTOPHER S",
    "owner2": "",
    "current_taxes": 49403.15,
    "new_taxes_no_override": 51537.37,
    "override_total_1": 52999.7,
    "override_increase_1": 1462.33
  },
  {
    "#": "182 Lee St (349-11-00)",
    "$": 2866600,
    "address": "182 Lee St",
    "parcel_id": "349-11-00",
    "owner1": "MULLIKEN TR, JOHN B",
    "owner2": "",
    "current_taxes": 25719.05,
    "new_taxes_no_override": 26830.11,
    "override_total_1": 27591.4,
    "override_increase_1": 761.28
  },
  {
    "#": "190 Lee St (349-10-00)",
    "$": 4095800,
    "address": "190 Lee St",
    "parcel_id": "349-10-00",
    "owner1": "DEHNI, WALID & IRAYS SANTAMARIA",
    "owner2": "",
    "current_taxes": 38306.06,
    "new_taxes_no_override": 39960.88,
    "override_total_1": 41094.74,
    "override_increase_1": 1133.86
  },
  {
    "#": "195 Lee St (338-04-05)",
    "$": 6466600,
    "address": "195 Lee St",
    "parcel_id": "338-04-05",
    "owner1": "DOUROS TR, DEBORAH",
    "owner2": "",
    "current_taxes": 66217.98,
    "new_taxes_no_override": 69078.6,
    "override_total_1": 71038.65,
    "override_increase_1": 1960.05
  },
  {
    "#": "210 Lee St (349-09-00)",
    "$": 2496100,
    "address": "210 Lee St",
    "parcel_id": "349-09-00",
    "owner1": "MORSE TRS, RICHARD P & CLAIRE W & JAMES A & STEVEN A",
    "owner2": "HAXHAMOVITCH, JOAN MORSE",
    "current_taxes": 25560.06,
    "new_taxes_no_override": 26664.25,
    "override_total_1": 27420.83,
    "override_increase_1": 756.58
  },
  {
    "#": "220 Lee St (349-08-00)",
    "$": 2587600,
    "address": "220 Lee St",
    "parcel_id": "349-08-00",
    "owner1": "MORSE TRS, RICHARD P & CLAIRE W & JAMES A & STEVEN A",
    "owner2": "HAXHAMOVITCH, JOAN MORSE",
    "current_taxes": 26497.02,
    "new_taxes_no_override": 27641.69,
    "override_total_1": 28426.0,
    "override_increase_1": 784.31
  },
  {
    "#": "225 Lee St (338-08-00)",
    "$": 3088800,
    "address": "225 Lee St",
    "parcel_id": "338-08-00",
    "owner1": "HOLLENBERG, NORMAN K & DEBORAH K",
    "owner2": "",
    "current_taxes": 27994.38,
    "new_taxes_no_override": 29203.74,
    "override_total_1": 30032.37,
    "override_increase_1": 828.63
  },
  {
    "#": "240 Lee St (349-07-00)",
    "$": 4652400,
    "address": "240 Lee St",
    "parcel_id": "349-07-00",
    "owner1": "MORSE TRS, CLAIRE W & RICHARD P & JAMES A & STEVEN A",
    "owner2": "HACHAMOVITCH, JOAN MORSE",
    "current_taxes": 44005.64,
    "new_taxes_no_override": 45906.68,
    "override_total_1": 47209.25,
    "override_increase_1": 1302.57
  },
  {
    "#": "250 Lee St (349-06-00)",
    "$": 4209500,
    "address": "250 Lee St",
    "parcel_id": "349-06-00",
    "owner1": "BRAGG TRS, JANET E & NOAH D & ELEANOR A & CAROLINE B",
    "owner2": "",
    "current_taxes": 39470.35,
    "new_taxes_no_override": 41175.47,
    "override_total_1": 42343.79,
    "override_increase_1": 1168.32
  },
  {
    "#": "260 Lee St (349-05-00)",
    "$": 6890700,
    "address": "260 Lee St",
    "parcel_id": "349-05-00",
    "owner1": "COOK, JEFFREY",
    "owner2": "TUBLIN-COOK, PAMELA",
    "current_taxes": 66925.83,
    "new_taxes_no_override": 69817.03,
    "override_total_1": 71798.03,
    "override_increase_1": 1981.0
  },
  {
    "#": "280 Lee St (349-03-00)",
    "$": 6903300,
    "address": "280 Lee St",
    "parcel_id": "349-03-00",
    "owner1": "JACOBS TR, CERISE LIM",
    "owner2": "",
    "current_taxes": 70689.79,
    "new_taxes_no_override": 73743.59,
    "override_total_1": 75836.01,
    "override_increase_1": 2092.42
  },
  {
    "#": "295 Lee St (338-14-15)",
    "$": 4847100,
    "address": "295 Lee St",
    "parcel_id": "338-14-15",
    "owner1": "SMITH, EARL E T & TATIANA G",
    "owner2": "",
    "current_taxes": 49634.3,
    "new_taxes_no_override": 51778.5,
    "override_total_1": 53247.68,
    "override_increase_1": 1469.18
  },
  {
    "#": "315 Lee St (339-01-02)",
    "$": 8536500,
    "address": "315 Lee St",
    "parcel_id": "339-01-02",
    "owner1": "JOHN RAYMOND REALTY ASSOCIATES LLC",
    "owner2": "",
    "current_taxes": 87413.76,
    "new_taxes_no_override": 91190.03,
    "override_total_1": 93777.48,
    "override_increase_1": 2587.45
  },
  {
    "#": "330 Lee St (347-11-00)",
    "$": 3384700,
    "address": "330 Lee St",
    "parcel_id": "347-11-00",
    "owner1": "SILVERMAN, STUART G & PATRICIA ANN",
    "owner2": "",
    "current_taxes": 31024.39,
    "new_taxes_no_override": 32364.64,
    "override_total_1": 33282.97,
    "override_increase_1": 918.32
  },
  {
    "#": "333 Lee St (339-03-00)",
    "$": 19250600,
    "address": "333 Lee St",
    "parcel_id": "339-03-00",
    "owner1": "GREENWALD TRS, LEWIS J",
    "owner2": "MURRAY, CORNELIUS J III",
    "current_taxes": 197126.14,
    "new_taxes_no_override": 205641.99,
    "override_total_1": 211476.92,
    "override_increase_1": 5834.93
  },
  {
    "#": "346 Lee St (347-10-00)",
    "$": 3891800,
    "address": "346 Lee St",
    "parcel_id": "347-10-00",
    "owner1": "FREEMAN, JOSEPH S",
    "owner2": "",
    "current_taxes": 36217.1,
    "new_taxes_no_override": 37781.68,
    "override_total_1": 38853.7,
    "override_increase_1": 1072.03
  },
  {
    "#": "360 Lee St (347-09-01)",
    "$": 3175800,
    "address": "360 Lee St",
    "parcel_id": "347-09-01",
    "owner1": "ANDERSON, BYRON T",
    "owner2": "CHOW, JOANNA C",
    "current_taxes": 28885.26,
    "new_taxes_no_override": 30133.1,
    "override_total_1": 30988.11,
    "override_increase_1": 855.0
  },
  {
    "#": "370 Lee St (347-09-00)",
    "$": 3052000,
    "address": "370 Lee St",
    "parcel_id": "347-09-00",
    "owner1": "SULLIVAN, TR, BRENDA",
    "owner2": "",
    "current_taxes": 27617.55,
    "new_taxes_no_override": 28810.63,
    "override_total_1": 29628.11,
    "override_increase_1": 817.48
  },
  {
    "#": "375 Lee St (339-05-01)",
    "$": 5145800,
    "address": "375 Lee St",
    "parcel_id": "339-05-01",
    "owner1": "LAUKIEN, RUTA J",
    "owner2": "",
    "current_taxes": 52692.99,
    "new_taxes_no_override": 54969.33,
    "override_total_1": 56529.04,
    "override_increase_1": 1559.71
  },
  {
    "#": "382 Lee St (347-08-00)",
    "$": 5899900,
    "address": "382 Lee St",
    "parcel_id": "347-08-00",
    "owner1": "YEUNG, YU LUNG",
    "owner2": "YANG, MAN LUNG",
    "current_taxes": 60414.98,
    "new_taxes_no_override": 63024.91,
    "override_total_1": 64813.19,
    "override_increase_1": 1788.28
  },
  {
    "#": "385 Lee St (339-06-00)",
    "$": 1835100,
    "address": "385 Lee St",
    "parcel_id": "339-06-00",
    "owner1": "LIU, YANG",
    "owner2": "LI, YANJING",
    "current_taxes": 15156.49,
    "new_taxes_no_override": 15811.25,
    "override_total_1": 16259.88,
    "override_increase_1": 448.63
  },
  {
    "#": "393 Lee St (339-06-01)",
    "$": 1780900,
    "address": "393 Lee St",
    "parcel_id": "339-06-01",
    "owner1": "EVANS TRS, SETH",
    "owner2": "NELSON TRS, KIMBERLY L",
    "current_taxes": 14601.48,
    "new_taxes_no_override": 15232.26,
    "override_total_1": 15664.47,
    "override_increase_1": 432.2
  },
  {
    "#": "396 Lee St (347-17-00)",
    "$": 2784500,
    "address": "396 Lee St",
    "parcel_id": "347-17-00",
    "owner1": "GOLDTHWAIT, WILLIAM A & COURTNEY",
    "owner2": "",
    "current_taxes": 24878.35,
    "new_taxes_no_override": 25953.09,
    "override_total_1": 26689.49,
    "override_increase_1": 736.4
  },
  {
    "#": "403 Lee St (339-06-02)",
    "$": 1578000,
    "address": "403 Lee St",
    "parcel_id": "339-06-02",
    "owner1": "CASEY, TR, SAIDE A",
    "owner2": "",
    "current_taxes": 12523.79,
    "new_taxes_no_override": 13064.82,
    "override_total_1": 13435.52,
    "override_increase_1": 370.7
  },
  {
    "#": "408 Lee St (347-06-00)",
    "$": 2048800,
    "address": "408 Lee St",
    "parcel_id": "347-06-00",
    "owner1": "MENAHEM, ABRAHAM",
    "owner2": "FELSZEGI, GEORGETTE",
    "current_taxes": 17344.78,
    "new_taxes_no_override": 18094.07,
    "override_total_1": 18607.48,
    "override_increase_1": 513.41
  },
  {
    "#": "23 Leicester St (254-10-00)",
    "$": 5626900,
    "address": "23 Leicester St",
    "parcel_id": "254-10-00",
    "owner1": "SILVER TR, TERRI D",
    "owner2": "",
    "current_taxes": 53984.52,
    "new_taxes_no_override": 56316.65,
    "override_total_1": 57914.59,
    "override_increase_1": 1597.94
  },
  {
    "#": "33 Leicester St (254-11-00)",
    "$": 6405100,
    "address": "33 Leicester St",
    "parcel_id": "254-11-00",
    "owner1": "MARSHALL TR, DOUGLAS B",
    "owner2": "",
    "current_taxes": 65588.22,
    "new_taxes_no_override": 68421.63,
    "override_total_1": 70363.04,
    "override_increase_1": 1941.41
  },
  {
    "#": "45 Leicester St (254-12-00)",
    "$": 9247100,
    "address": "45 Leicester St",
    "parcel_id": "254-12-00",
    "owner1": "KALISH, MATTHEW",
    "owner2": "",
    "current_taxes": 94690.3,
    "new_taxes_no_override": 98780.92,
    "override_total_1": 101583.75,
    "override_increase_1": 2802.83
  },
  {
    "#": "55 Leicester St (254-13-00)",
    "$": 10229100,
    "address": "55 Leicester St",
    "parcel_id": "254-13-00",
    "owner1": "SCINTILLA FUND LP",
    "owner2": "",
    "current_taxes": 104745.98,
    "new_taxes_no_override": 109271.01,
    "override_total_1": 112371.49,
    "override_increase_1": 3100.48
  },
  {
    "#": "71 Leicester St (254-14-00)",
    "$": 7063300,
    "address": "71 Leicester St",
    "parcel_id": "254-14-00",
    "owner1": "DOW, TRS, JODY DEROMA",
    "owner2": "",
    "current_taxes": 68693.26,
    "new_taxes_no_override": 71660.81,
    "override_total_1": 73694.13,
    "override_increase_1": 2033.32
  },
  {
    "#": "83 Leicester St (254-15-01)",
    "$": 7876300,
    "address": "83 Leicester St",
    "parcel_id": "254-15-01",
    "owner1": "GIRLS4 LLC",
    "owner2": "",
    "current_taxes": 80653.31,
    "new_taxes_no_override": 84137.53,
    "override_total_1": 86524.87,
    "override_increase_1": 2387.34
  },
  {
    "#": "5 Leland Rd (366-01-00)",
    "$": 1242000,
    "address": "5 Leland Rd",
    "parcel_id": "366-01-00",
    "owner1": "JHE, GRACE",
    "owner2": "BAI, GINMANN",
    "current_taxes": 9083.15,
    "new_taxes_no_override": 9475.54,
    "override_total_1": 9744.4,
    "override_increase_1": 268.86
  },
  {
    "#": "6 Leland Rd (367-14-00)",
    "$": 1117000,
    "address": "6 Leland Rd",
    "parcel_id": "367-14-00",
    "owner1": "BERGEN, ERIC S",
    "owner2": "STOLZMANN, KELLY L",
    "current_taxes": 7803.15,
    "new_taxes_no_override": 8140.25,
    "override_total_1": 8371.22,
    "override_increase_1": 230.97
  },
  {
    "#": "9 Leland Rd (366-03-00)",
    "$": 1269200,
    "address": "9 Leland Rd",
    "parcel_id": "366-03-00",
    "owner1": "KAPOOR, ARCHANA",
    "owner2": "KUMAR, LALIT",
    "current_taxes": 9361.67,
    "new_taxes_no_override": 9766.09,
    "override_total_1": 10043.2,
    "override_increase_1": 277.11
  },
  {
    "#": "10 Leland Rd (367-13-00)",
    "$": 1123600,
    "address": "10 Leland Rd",
    "parcel_id": "367-13-00",
    "owner1": "BISCOE TR, ELOISE PALMER",
    "owner2": "",
    "current_taxes": 7870.73,
    "new_taxes_no_override": 8210.75,
    "override_total_1": 8443.72,
    "override_increase_1": 232.97
  },
  {
    "#": "14 Leland Rd (367-12-00)",
    "$": 1210300,
    "address": "14 Leland Rd",
    "parcel_id": "367-12-00",
    "owner1": "LIU, WENZHUO",
    "owner2": "TENG, ZHAOYANG",
    "current_taxes": 8758.54,
    "new_taxes_no_override": 9136.91,
    "override_total_1": 9396.16,
    "override_increase_1": 259.25
  },
  {
    "#": "15 Leland Rd (366-04-00)",
    "$": 1093700,
    "address": "15 Leland Rd",
    "parcel_id": "366-04-00",
    "owner1": "WHITE TRS, BENJAMIN L",
    "owner2": "SOHN-WHITE, JUDITH B",
    "current_taxes": 7564.55,
    "new_taxes_no_override": 7891.34,
    "override_total_1": 8115.25,
    "override_increase_1": 223.91
  },
  {
    "#": "18 Leland Rd (367-11-00)",
    "$": 1283500,
    "address": "18 Leland Rd",
    "parcel_id": "367-11-00",
    "owner1": "THOMAS, SUZANNE",
    "owner2": "GURURAJ, VINEETH",
    "current_taxes": 9508.11,
    "new_taxes_no_override": 9918.86,
    "override_total_1": 10200.3,
    "override_increase_1": 281.44
  },
  {
    "#": "21 Leland Rd (366-05-00)",
    "$": 1026900,
    "address": "21 Leland Rd",
    "parcel_id": "366-05-00",
    "owner1": "GATELY, PETER",
    "owner2": "",
    "current_taxes": 6880.52,
    "new_taxes_no_override": 7177.76,
    "override_total_1": 7381.42,
    "override_increase_1": 203.66
  },
  {
    "#": "22 Leland Rd (367-10-00)",
    "$": 1590800,
    "address": "22 Leland Rd",
    "parcel_id": "367-10-00",
    "owner1": "PRENTISS, SETH",
    "owner2": "",
    "current_taxes": 12654.86,
    "new_taxes_no_override": 13201.55,
    "override_total_1": 13576.13,
    "override_increase_1": 374.58
  },
  {
    "#": "25 Leland Rd (366-06-00)",
    "$": 840100,
    "address": "25 Leland Rd",
    "parcel_id": "366-06-00",
    "owner1": "EHNES, ELIZABETH D",
    "owner2": "",
    "current_taxes": 4967.69,
    "new_taxes_no_override": 5182.29,
    "override_total_1": 5329.34,
    "override_increase_1": 147.04
  },
  {
    "#": "26 Leland Rd (367-09-00)",
    "$": 1704200,
    "address": "26 Leland Rd",
    "parcel_id": "367-09-00",
    "owner1": "AIHARA, HIROYUKI & IKUYO",
    "owner2": "",
    "current_taxes": 13816.07,
    "new_taxes_no_override": 14412.92,
    "override_total_1": 14821.88,
    "override_increase_1": 408.96
  },
  {
    "#": "33 Leland Rd (366-07-00)",
    "$": 1952100,
    "address": "33 Leland Rd",
    "parcel_id": "366-07-00",
    "owner1": "PATTEN-CLARK TRS, JUDEAN",
    "owner2": "FIDUCIARY TRUST COMPANY",
    "current_taxes": 16354.57,
    "new_taxes_no_override": 17061.09,
    "override_total_1": 17545.18,
    "override_increase_1": 484.1
  },
  {
    "#": "34 Leland Rd (367-07-00)",
    "$": 917600,
    "address": "34 Leland Rd",
    "parcel_id": "367-07-00",
    "owner1": "DALI, MOHAN & HEMALATA M",
    "owner2": "",
    "current_taxes": 5761.29,
    "new_taxes_no_override": 6010.18,
    "override_total_1": 6180.71,
    "override_increase_1": 170.53
  },
  {
    "#": "40 Leland Rd (367-05-00)",
    "$": 1265700,
    "address": "40 Leland Rd",
    "parcel_id": "367-05-00",
    "owner1": "RODLIFF, PAUL A & SUSAN B",
    "owner2": "",
    "current_taxes": 9325.83,
    "new_taxes_no_override": 9728.71,
    "override_total_1": 10004.75,
    "override_increase_1": 276.04
  },
  {
    "#": "41 Leland Rd (366-08-00)",
    "$": 1481800,
    "address": "41 Leland Rd",
    "parcel_id": "366-08-00",
    "owner1": "AMIN, PARAG M",
    "owner2": "MADHAVAN, VANDANA",
    "current_taxes": 11538.7,
    "new_taxes_no_override": 12037.17,
    "override_total_1": 12378.72,
    "override_increase_1": 341.55
  },
  {
    "#": "45 Leland Rd (366-08-01)",
    "$": 1097500,
    "address": "45 Leland Rd",
    "parcel_id": "366-08-01",
    "owner1": "HART, BRUCE T & YVONNE V",
    "owner2": "",
    "current_taxes": 7603.47,
    "new_taxes_no_override": 7931.94,
    "override_total_1": 8157.0,
    "override_increase_1": 225.06
  },
  {
    "#": "46 Leland Rd (367-03-04)",
    "$": 1138000,
    "address": "46 Leland Rd",
    "parcel_id": "367-03-04",
    "owner1": "MAHONEY TR, JASON G",
    "owner2": "",
    "current_taxes": 11653.12,
    "new_taxes_no_override": 12156.53,
    "override_total_1": 12501.47,
    "override_increase_1": 344.93
  },
  {
    "#": "51 Leland Rd (366-09-10)",
    "$": 1287700,
    "address": "51 Leland Rd",
    "parcel_id": "366-09-10",
    "owner1": "RATNATHICAM, INDRAN",
    "owner2": "ROBERTS, JENNIFER",
    "current_taxes": 9551.11,
    "new_taxes_no_override": 9963.72,
    "override_total_1": 10246.43,
    "override_increase_1": 282.71
  },
  {
    "#": "54 Leland Rd (367-01-02)",
    "$": 1303100,
    "address": "54 Leland Rd",
    "parcel_id": "367-01-02",
    "owner1": "SUSKIN, DAVID & HEIDI LYNN",
    "owner2": "",
    "current_taxes": 9708.81,
    "new_taxes_no_override": 10128.23,
    "override_total_1": 10415.61,
    "override_increase_1": 287.38
  },
  {
    "#": "55 Leland Rd (366-11-00)",
    "$": 1178500,
    "address": "55 Leland Rd",
    "parcel_id": "366-11-00",
    "owner1": "GILBO TRS, EUGENE P & TANYA N",
    "owner2": "",
    "current_taxes": 8432.91,
    "new_taxes_no_override": 8797.21,
    "override_total_1": 9046.83,
    "override_increase_1": 249.61
  },
  {
    "#": "59 Leland Rd (366-12-00)",
    "$": 1239200,
    "address": "59 Leland Rd",
    "parcel_id": "366-12-00",
    "owner1": "LUSZCZYNSKA, AIDA A",
    "owner2": "",
    "current_taxes": 9054.47,
    "new_taxes_no_override": 9445.62,
    "override_total_1": 9713.64,
    "override_increase_1": 268.01
  },
  {
    "#": "65 Leland Rd (366-13-00)",
    "$": 196800,
    "address": "65 Leland Rd",
    "parcel_id": "366-13-00",
    "owner1": "OPREA, FLORIAN G & ALINA M",
    "owner2": "",
    "current_taxes": 2015.23,
    "new_taxes_no_override": 2102.29,
    "override_total_1": 2161.94,
    "override_increase_1": 59.65
  },
  {
    "#": "10 Lenox St (004-02-00)",
    "$": 10847000,
    "address": "10 Lenox St",
    "parcel_id": "004-02-00",
    "owner1": "BOSTON UNIVERSITY TRS",
    "owner2": "C/O GENERAL  ACCOUNTING 4TH FL",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "25 Lenox St (006A-03-00)",
    "$": 4799800,
    "address": "25 Lenox St",
    "parcel_id": "006A-03-00",
    "owner1": "BOSTON UNIVERSITY TRS",
    "owner2": "C/O GENERAL ACCOUNTING 4TH FLR",
    "current_taxes": 49149.95,
    "new_taxes_no_override": 51273.23,
    "override_total_1": 52728.07,
    "override_increase_1": 1454.84
  },
  {
    "#": "39 Lenox St (006A-04-00)",
    "$": 2479600,
    "address": "39 Lenox St",
    "parcel_id": "006A-04-00",
    "owner1": "BOSTON UNIVERSITY TRS",
    "owner2": "C/O GENERAL ACCOUNTING 4TH FLR",
    "current_taxes": 25391.1,
    "new_taxes_no_override": 26488.0,
    "override_total_1": 27239.57,
    "override_increase_1": 751.58
  },
  {
    "#": "170 Lenox St (006A-02-00)",
    "$": 1861800,
    "address": "170 Lenox St",
    "parcel_id": "006A-02-00",
    "owner1": "BOSTON UNIVERSITY TRS",
    "owner2": "C/O GENERAL ACCOUNTING 4TH FLR",
    "current_taxes": 19064.83,
    "new_taxes_no_override": 19888.43,
    "override_total_1": 20452.75,
    "override_increase_1": 564.32
  },
  {
    "#": "7 Leverett St, Unit 1 (186-05-02)",
    "$": 630700,
    "address": "7 Leverett St, Unit 1",
    "parcel_id": "186-05-02",
    "owner1": "TARPEY, JIALU & NATHAN",
    "owner2": "",
    "current_taxes": 6458.37,
    "new_taxes_no_override": 6737.37,
    "override_total_1": 6928.54,
    "override_increase_1": 191.17
  },
  {
    "#": "7 Leverett St, Unit 2 (186-05-03)",
    "$": 631100,
    "address": "7 Leverett St, Unit 2",
    "parcel_id": "186-05-03",
    "owner1": "KADDOURA, MAHMOUD",
    "owner2": "KHACHAN, MOUNA",
    "current_taxes": 6462.46,
    "new_taxes_no_override": 6741.64,
    "override_total_1": 6932.93,
    "override_increase_1": 191.29
  },
  {
    "#": "7 Leverett St, Unit 3 (186-05-04)",
    "$": 645000,
    "address": "7 Leverett St, Unit 3",
    "parcel_id": "186-05-04",
    "owner1": "COOPER, STEPHANIE",
    "owner2": "",
    "current_taxes": 2969.87,
    "new_taxes_no_override": 3098.17,
    "override_total_1": 3186.08,
    "override_increase_1": 87.91
  },
  {
    "#": "8 Leverett St, Unit 1 & G5 (187-03-05)",
    "$": 1284100,
    "address": "8 Leverett St, Unit 1 & G5",
    "parcel_id": "187-03-05",
    "owner1": "PHAM, LONG TRAC",
    "owner2": "",
    "current_taxes": 13149.18,
    "new_taxes_no_override": 13717.22,
    "override_total_1": 14106.44,
    "override_increase_1": 389.22
  },
  {
    "#": "8 Leverett St, Unit 2 & G9 -G10 (187-03-06)",
    "$": 1196000,
    "address": "8 Leverett St, Unit 2 & G9 -G10",
    "parcel_id": "187-03-06",
    "owner1": "VENKATAKRISHNAN, KARTHIK",
    "owner2": "",
    "current_taxes": 12247.04,
    "new_taxes_no_override": 12776.11,
    "override_total_1": 13138.62,
    "override_increase_1": 362.51
  },
  {
    "#": "8 Leverett St, Unit 3 & G3 -G4 (187-03-07)",
    "$": 1200000,
    "address": "8 Leverett St, Unit 3 & G3 -G4",
    "parcel_id": "187-03-07",
    "owner1": "KUNIN, MARINA & SERGEY",
    "owner2": "",
    "current_taxes": 8653.07,
    "new_taxes_no_override": 9026.88,
    "override_total_1": 9283.01,
    "override_increase_1": 256.13
  },
  {
    "#": "8 Leverett St, Unit 4 & G7 & G8 (187-03-08)",
    "$": 1196000,
    "address": "8 Leverett St, Unit 4 & G7 & G8",
    "parcel_id": "187-03-08",
    "owner1": "KANG, JOOEUN",
    "owner2": "FOWLER, BENJAMIN",
    "current_taxes": 8612.11,
    "new_taxes_no_override": 8984.15,
    "override_total_1": 9239.07,
    "override_increase_1": 254.92
  },
  {
    "#": "8 Leverett St, Unit 5 & G2 (187-03-09)",
    "$": 1200000,
    "address": "8 Leverett St, Unit 5 & G2",
    "parcel_id": "187-03-09",
    "owner1": "YAN, FENG",
    "owner2": "",
    "current_taxes": 12288.0,
    "new_taxes_no_override": 12818.84,
    "override_total_1": 13182.57,
    "override_increase_1": 363.72
  },
  {
    "#": "9 Leverett St (186-05-01)",
    "$": 1806100,
    "address": "9 Leverett St",
    "parcel_id": "186-05-01",
    "owner1": "WU, HELEN KEYING",
    "owner2": "",
    "current_taxes": 18494.46,
    "new_taxes_no_override": 19293.42,
    "override_total_1": 19840.86,
    "override_increase_1": 547.44
  },
  {
    "#": "10 Leverett St (187-02-00)",
    "$": 1168000,
    "address": "10 Leverett St",
    "parcel_id": "187-02-00",
    "owner1": "KELLY LIFE ESTATE, JOHN R",
    "owner2": "",
    "current_taxes": 8325.39,
    "new_taxes_no_override": 8685.05,
    "override_total_1": 8931.48,
    "override_increase_1": 246.43
  },
  {
    "#": "11 Leverett St (186-06-00)",
    "$": 1783400,
    "address": "11 Leverett St",
    "parcel_id": "186-06-00",
    "owner1": "SCS DEVELOPMENT LLC",
    "owner2": "",
    "current_taxes": 18262.02,
    "new_taxes_no_override": 19050.94,
    "override_total_1": 19591.5,
    "override_increase_1": 540.56
  },
  {
    "#": "14 Leverett St (187-01-00)",
    "$": 3131400,
    "address": "14 Leverett St",
    "parcel_id": "187-01-00",
    "owner1": "LEVERETT REALTY LLC",
    "owner2": "",
    "current_taxes": 32065.54,
    "new_taxes_no_override": 33450.77,
    "override_total_1": 34399.91,
    "override_increase_1": 949.14
  },
  {
    "#": "15 Leverett St (186-06-01)",
    "$": 431300,
    "address": "15 Leverett St",
    "parcel_id": "186-06-01",
    "owner1": "JANE DEVELOPMENT LLC",
    "owner2": "",
    "current_taxes": 4416.51,
    "new_taxes_no_override": 4607.3,
    "override_total_1": 4738.03,
    "override_increase_1": 130.73
  },
  {
    "#": "22 Leverett St (189-01-03)",
    "$": 1637900,
    "address": "22 Leverett St",
    "parcel_id": "189-01-03",
    "owner1": "LEWIS, MARK & DARA LEE",
    "owner2": "",
    "current_taxes": 13137.16,
    "new_taxes_no_override": 13704.69,
    "override_total_1": 14093.55,
    "override_increase_1": 388.86
  },
  {
    "#": "4 Lincoln Rd (198-05-00)",
    "$": 2181700,
    "address": "4 Lincoln Rd",
    "parcel_id": "198-05-00",
    "owner1": "KANE, BRIAN S & JEAN E",
    "owner2": "",
    "current_taxes": 18705.67,
    "new_taxes_no_override": 19513.75,
    "override_total_1": 20067.44,
    "override_increase_1": 553.69
  },
  {
    "#": "5 Lincoln Rd (199-15-00)",
    "$": 2124100,
    "address": "5 Lincoln Rd",
    "parcel_id": "199-15-00",
    "owner1": "WHITFIELD TRS, RUFUS N & CHERYL F",
    "owner2": "",
    "current_taxes": 18115.85,
    "new_taxes_no_override": 18898.45,
    "override_total_1": 19434.68,
    "override_increase_1": 536.23
  },
  {
    "#": "8 Lincoln Rd, Unit 1 (198-04-01)",
    "$": 1535400,
    "address": "8 Lincoln Rd, Unit 1",
    "parcel_id": "198-04-01",
    "owner1": "HOLZMAN, ROBYN",
    "owner2": "LISZANCKIE, SHARON",
    "current_taxes": 12087.56,
    "new_taxes_no_override": 12609.74,
    "override_total_1": 12967.53,
    "override_increase_1": 357.79
  },
  {
    "#": "8 Lincoln Rd, Unit 2 (198-04-02)",
    "$": 1284100,
    "address": "8 Lincoln Rd, Unit 2",
    "parcel_id": "198-04-02",
    "owner1": "OREILLY, PRISCILLA L",
    "owner2": "",
    "current_taxes": 9514.25,
    "new_taxes_no_override": 9925.27,
    "override_total_1": 10206.89,
    "override_increase_1": 281.62
  },
  {
    "#": "9 Lincoln Rd (199-16-00)",
    "$": 2316400,
    "address": "9 Lincoln Rd",
    "parcel_id": "199-16-00",
    "owner1": "MENDELSOHN TRS, THOMAS A",
    "owner2": "GITTLEMAN TR, JULIA S",
    "current_taxes": 20085.0,
    "new_taxes_no_override": 20952.67,
    "override_total_1": 21547.19,
    "override_increase_1": 594.52
  },
  {
    "#": "12 Lincoln Rd (198-03-00)",
    "$": 2197000,
    "address": "12 Lincoln Rd",
    "parcel_id": "198-03-00",
    "owner1": "WIZANSKY, TRS, DAVID H & MARGOT G",
    "owner2": "",
    "current_taxes": 18862.35,
    "new_taxes_no_override": 19677.2,
    "override_total_1": 20235.53,
    "override_increase_1": 558.33
  },
  {
    "#": "15 Lincoln Rd (199-17-00)",
    "$": 2493200,
    "address": "15 Lincoln Rd",
    "parcel_id": "199-17-00",
    "owner1": "WAGER, TRAVIS",
    "owner2": "",
    "current_taxes": 25530.37,
    "new_taxes_no_override": 26633.28,
    "override_total_1": 27388.98,
    "override_increase_1": 755.7
  },
  {
    "#": "16 Lincoln Rd (198-02-00)",
    "$": 1908500,
    "address": "16 Lincoln Rd",
    "parcel_id": "198-02-00",
    "owner1": "BRIGL, MANFRED",
    "owner2": "UHLIG, KATRIN",
    "current_taxes": 15908.11,
    "new_taxes_no_override": 16595.34,
    "override_total_1": 17066.22,
    "override_increase_1": 470.88
  },
  {
    "#": "4 Linden Ct, Unit 1 (147-07-01)",
    "$": 865800,
    "address": "4 Linden Ct, Unit 1",
    "parcel_id": "147-07-01",
    "owner1": "SMITH TR, VIRGINIA A",
    "owner2": "",
    "current_taxes": 8865.79,
    "new_taxes_no_override": 9248.79,
    "override_total_1": 9511.22,
    "override_increase_1": 262.43
  },
  {
    "#": "4 Linden Ct, Unit 2 (147-07-02)",
    "$": 848600,
    "address": "4 Linden Ct, Unit 2",
    "parcel_id": "147-07-02",
    "owner1": "SMITH, VIRGINIA",
    "owner2": "HITCHCOCK, KATHERINE",
    "current_taxes": 8689.66,
    "new_taxes_no_override": 9065.05,
    "override_total_1": 9322.27,
    "override_increase_1": 257.21
  },
  {
    "#": "4 Linden Ct, Unit 3 (147-07-03)",
    "$": 848700,
    "address": "4 Linden Ct, Unit 3",
    "parcel_id": "147-07-03",
    "owner1": "DAUBLAIN, PIERRE",
    "owner2": "LEPONT, CLAIRE",
    "current_taxes": 8690.69,
    "new_taxes_no_override": 9066.13,
    "override_total_1": 9323.37,
    "override_increase_1": 257.24
  },
  {
    "#": "8 Linden Ct, Unit 1 (147-06-02)",
    "$": 971000,
    "address": "8 Linden Ct, Unit 1",
    "parcel_id": "147-06-02",
    "owner1": "FLAHERTY, STEPHEN & JESSICA",
    "owner2": "",
    "current_taxes": 6308.11,
    "new_taxes_no_override": 6580.62,
    "override_total_1": 6767.34,
    "override_increase_1": 186.72
  },
  {
    "#": "8 Linden Ct, Unit 2 (147-06-03)",
    "$": 933900,
    "address": "8 Linden Ct, Unit 2",
    "parcel_id": "147-06-03",
    "owner1": "BRAUDY, ANNE E",
    "owner2": "",
    "current_taxes": 5928.2,
    "new_taxes_no_override": 6184.3,
    "override_total_1": 6359.77,
    "override_increase_1": 175.47
  },
  {
    "#": "8 Linden Ct, Unit 3 (147-06-04)",
    "$": 956600,
    "address": "8 Linden Ct, Unit 3",
    "parcel_id": "147-06-04",
    "owner1": "GHERBI, SOUAD & CHAKIB",
    "owner2": "",
    "current_taxes": 9795.58,
    "new_taxes_no_override": 10218.75,
    "override_total_1": 10508.7,
    "override_increase_1": 289.95
  },
  {
    "#": "5 Linden Pl (148-03-00)",
    "$": 16896700,
    "address": "5 Linden Pl",
    "parcel_id": "148-03-00",
    "owner1": "ROMAN CATHOLIC ARCHBISHOP",
    "owner2": "C/O ST MARY OF THE ASSUMPTION, PARISH",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "11 Linden Pl, Unit 1 (149-25-03)",
    "$": 1234400,
    "address": "11 Linden Pl, Unit 1",
    "parcel_id": "149-25-03",
    "owner1": "LEE, SANGKYU & SEUNGEUN CHOI",
    "owner2": "",
    "current_taxes": 9005.32,
    "new_taxes_no_override": 9394.35,
    "override_total_1": 9660.91,
    "override_increase_1": 266.56
  },
  {
    "#": "11 Linden Pl, Unit 2 (149-25-01)",
    "$": 1204800,
    "address": "11 Linden Pl, Unit 2",
    "parcel_id": "149-25-01",
    "owner1": "HUBSCHMAN, HAROLD",
    "owner2": "",
    "current_taxes": 8702.22,
    "new_taxes_no_override": 9078.16,
    "override_total_1": 9335.74,
    "override_increase_1": 257.59
  },
  {
    "#": "11 Linden Pl, Unit 3 (149-25-02)",
    "$": 1731500,
    "address": "11 Linden Pl, Unit 3",
    "parcel_id": "149-25-02",
    "owner1": "CUNNINGHAM TR, CHARLES",
    "owner2": "",
    "current_taxes": 17730.56,
    "new_taxes_no_override": 18496.52,
    "override_total_1": 19021.34,
    "override_increase_1": 524.82
  },
  {
    "#": "12 Linden Pl (149-24-05)",
    "$": 1735800,
    "address": "12 Linden Pl",
    "parcel_id": "149-24-05",
    "owner1": "MROSE TR, SUSAN ANN",
    "owner2": "",
    "current_taxes": 14139.66,
    "new_taxes_no_override": 14750.49,
    "override_total_1": 15169.03,
    "override_increase_1": 418.53
  },
  {
    "#": "12 Linden Pl (149-24-06)",
    "$": 1989700,
    "address": "12 Linden Pl",
    "parcel_id": "149-24-06",
    "owner1": "CAFFERTY, CLAIRE A & THOMAS D",
    "owner2": "",
    "current_taxes": 16739.59,
    "new_taxes_no_override": 17462.74,
    "override_total_1": 17958.23,
    "override_increase_1": 495.49
  },
  {
    "#": "14 Linden Pl (149-24-03)",
    "$": 1772300,
    "address": "14 Linden Pl",
    "parcel_id": "149-24-03",
    "owner1": "EQUITZ, ANN L & WILLIAM H",
    "owner2": "",
    "current_taxes": 14513.42,
    "new_taxes_no_override": 15140.4,
    "override_total_1": 15570.0,
    "override_increase_1": 429.6
  },
  {
    "#": "14 Linden Pl (149-24-04)",
    "$": 1666600,
    "address": "14 Linden Pl",
    "parcel_id": "149-24-04",
    "owner1": "SANDLER, JONATHAN & JEAN",
    "owner2": "",
    "current_taxes": 13431.05,
    "new_taxes_no_override": 14011.27,
    "override_total_1": 14408.83,
    "override_increase_1": 397.56
  },
  {
    "#": "16 Linden Pl (149-24-01)",
    "$": 1865900,
    "address": "16 Linden Pl",
    "parcel_id": "149-24-01",
    "owner1": "SHAMA TR, JEANNIE LINDHEIM",
    "owner2": "SHAMA, STEVEN K",
    "current_taxes": 19106.82,
    "new_taxes_no_override": 19932.23,
    "override_total_1": 20497.8,
    "override_increase_1": 565.56
  },
  {
    "#": "16 Linden Pl (149-24-02)",
    "$": 1600600,
    "address": "16 Linden Pl",
    "parcel_id": "149-24-02",
    "owner1": "LAWTON, JAMES H JR & BONNIE J",
    "owner2": "",
    "current_taxes": 12755.21,
    "new_taxes_no_override": 13306.24,
    "override_total_1": 13683.79,
    "override_increase_1": 377.55
  },
  {
    "#": "18 Linden Pl (149-24-00)",
    "$": 2182900,
    "address": "18 Linden Pl",
    "parcel_id": "149-24-00",
    "owner1": "HIJERRA-PERALTA TR, ANA MARIA",
    "owner2": "",
    "current_taxes": 18717.96,
    "new_taxes_no_override": 19526.58,
    "override_total_1": 20080.63,
    "override_increase_1": 554.05
  },
  {
    "#": "20 Linden Pl (149-23-01)",
    "$": 1736800,
    "address": "20 Linden Pl",
    "parcel_id": "149-23-01",
    "owner1": "KHOUW, RAYMOND & TERESA",
    "owner2": "",
    "current_taxes": 17784.83,
    "new_taxes_no_override": 18553.13,
    "override_total_1": 19079.57,
    "override_increase_1": 526.43
  },
  {
    "#": "21 Linden Pl (147-08-00)",
    "$": 2006800,
    "address": "21 Linden Pl",
    "parcel_id": "147-08-00",
    "owner1": "THORNTON TRS, DOROTHY E & CHARLES P",
    "owner2": "CADDLE TR, KIMBERLY A",
    "current_taxes": 20549.63,
    "new_taxes_no_override": 21437.37,
    "override_total_1": 22045.64,
    "override_increase_1": 608.27
  },
  {
    "#": "22 Linden Pl (149-22-23)",
    "$": 8900900,
    "address": "22 Linden Pl",
    "parcel_id": "149-22-23",
    "owner1": "TRICONI TRS, RICHARD S & WILMA A",
    "owner2": "",
    "current_taxes": 91145.22,
    "new_taxes_no_override": 95082.69,
    "override_total_1": 97780.59,
    "override_increase_1": 2697.9
  },
  {
    "#": "29 Linden Pl, Unit 1 (147-09-01)",
    "$": 1167900,
    "address": "29 Linden Pl, Unit 1",
    "parcel_id": "147-09-01",
    "owner1": "HARKNESS, NICHOLAS H",
    "owner2": "LEE, DOREEN",
    "current_taxes": 8324.36,
    "new_taxes_no_override": 8683.97,
    "override_total_1": 8930.37,
    "override_increase_1": 246.4
  },
  {
    "#": "29 Linden Pl, Unit 2 (147-09-02)",
    "$": 1532300,
    "address": "29 Linden Pl, Unit 2",
    "parcel_id": "147-09-02",
    "owner1": "HARKNESS, NICHOLAS",
    "owner2": "LEE, DOREEN",
    "current_taxes": 15690.75,
    "new_taxes_no_override": 16368.59,
    "override_total_1": 16833.04,
    "override_increase_1": 464.45
  },
  {
    "#": "31 Linden Pl (147-10-00)",
    "$": 5668300,
    "address": "31 Linden Pl",
    "parcel_id": "147-10-00",
    "owner1": "THE KIM FAMILY LIMITED PARTNERSHIP",
    "owner2": "C/O ALBERT KIM",
    "current_taxes": 58043.39,
    "new_taxes_no_override": 60550.86,
    "override_total_1": 62268.95,
    "override_increase_1": 1718.08
  },
  {
    "#": "37 Linden Pl (147-11-00)",
    "$": 1785400,
    "address": "37 Linden Pl",
    "parcel_id": "147-11-00",
    "owner1": "SMITH TR, SANDRA P",
    "owner2": "",
    "current_taxes": 14647.56,
    "new_taxes_no_override": 15280.33,
    "override_total_1": 15713.9,
    "override_increase_1": 433.57
  },
  {
    "#": "39 Linden Pl (147-12-00)",
    "$": 2608200,
    "address": "39 Linden Pl",
    "parcel_id": "147-12-00",
    "owner1": "PAVLOVICH, JAMES & JILL",
    "owner2": "",
    "current_taxes": 23073.03,
    "new_taxes_no_override": 24069.78,
    "override_total_1": 24752.75,
    "override_increase_1": 682.96
  },
  {
    "#": "45 Linden Pl (147-13-00)",
    "$": 2214100,
    "address": "45 Linden Pl",
    "parcel_id": "147-13-00",
    "owner1": "HEYWOOD TRS, SARAH A",
    "owner2": "GOOD, ANDREW H",
    "current_taxes": 19037.45,
    "new_taxes_no_override": 19859.87,
    "override_total_1": 20423.38,
    "override_increase_1": 563.51
  },
  {
    "#": "46 Linden Pl (146-05-00)",
    "$": 2879000,
    "address": "46 Linden Pl",
    "parcel_id": "146-05-00",
    "owner1": "ANDERSON TR, JULIE",
    "owner2": "",
    "current_taxes": 25846.03,
    "new_taxes_no_override": 26962.58,
    "override_total_1": 27727.62,
    "override_increase_1": 765.04
  },
  {
    "#": "48 Linden Pl (146-04-00)",
    "$": 1703200,
    "address": "48 Linden Pl",
    "parcel_id": "146-04-00",
    "owner1": "SHARMA, JATINDER L & SUBHADRA",
    "owner2": "",
    "current_taxes": 13805.83,
    "new_taxes_no_override": 14402.24,
    "override_total_1": 14810.89,
    "override_increase_1": 408.65
  },
  {
    "#": "50 Linden Pl (146-03-01)",
    "$": 2568700,
    "address": "50 Linden Pl",
    "parcel_id": "146-03-01",
    "owner1": "GEDULDIG TR, MATTHEW",
    "owner2": "",
    "current_taxes": 22668.55,
    "new_taxes_no_override": 23647.83,
    "override_total_1": 24318.82,
    "override_increase_1": 670.99
  },
  {
    "#": "54 Linden Pl, Unit 2 (146-03-03)",
    "$": 1403100,
    "address": "54 Linden Pl, Unit 2",
    "parcel_id": "146-03-03",
    "owner1": "CRAINE, CLIFFORD",
    "owner2": "LINN, SUSAN",
    "current_taxes": 10732.81,
    "new_taxes_no_override": 11196.47,
    "override_total_1": 11514.16,
    "override_increase_1": 317.69
  },
  {
    "#": "56 Linden Pl, Unit 1 (146-03-02)",
    "$": 1216600,
    "address": "56 Linden Pl, Unit 1",
    "parcel_id": "146-03-02",
    "owner1": "GERDTS, NADINE",
    "owner2": "LACKER, STEPHEN J",
    "current_taxes": 8823.05,
    "new_taxes_no_override": 9204.21,
    "override_total_1": 9465.37,
    "override_increase_1": 261.16
  },
  {
    "#": "62 Linden Pl (146-02-00)",
    "$": 1826900,
    "address": "62 Linden Pl",
    "parcel_id": "146-02-00",
    "owner1": "FAGUNDO LIFE ESTATE, ELSA I",
    "owner2": "",
    "current_taxes": 15072.52,
    "new_taxes_no_override": 15723.65,
    "override_total_1": 16169.8,
    "override_increase_1": 446.15
  },
  {
    "#": "64 Linden Pl (146-01-00)",
    "$": 2810500,
    "address": "64 Linden Pl",
    "parcel_id": "146-01-00",
    "owner1": "MOYNIHAN, JOHN",
    "owner2": "",
    "current_taxes": 25144.59,
    "new_taxes_no_override": 26230.84,
    "override_total_1": 26975.12,
    "override_increase_1": 744.28
  },
  {
    "#": "30 Linden Sq (150-01-00)",
    "$": 1274500,
    "address": "30 Linden Sq",
    "parcel_id": "150-01-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O LINDEN SQUARE",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "7 Linden St (141-09-00)",
    "$": 1980100,
    "address": "7 Linden St",
    "parcel_id": "141-09-00",
    "owner1": "MALINN, MARY T",
    "owner2": "STRONG-OBOY, EILEEN F",
    "current_taxes": 16641.29,
    "new_taxes_no_override": 17360.19,
    "override_total_1": 17852.78,
    "override_increase_1": 492.58
  },
  {
    "#": "9 Linden St, Unit 1 & P1 (141-10-02)",
    "$": 799300,
    "address": "9 Linden St, Unit 1 & P1",
    "parcel_id": "141-10-02",
    "owner1": "LOEW, ANDREA H",
    "owner2": "",
    "current_taxes": 4549.9,
    "new_taxes_no_override": 4746.46,
    "override_total_1": 4881.13,
    "override_increase_1": 134.68
  },
  {
    "#": "9 Linden St, Unit 2 & P2 (141-10-03)",
    "$": 795200,
    "address": "9 Linden St, Unit 2 & P2",
    "parcel_id": "141-10-03",
    "owner1": "CALLENDER TR, CHRISTINE P",
    "owner2": "",
    "current_taxes": 4507.91,
    "new_taxes_no_override": 4702.65,
    "override_total_1": 4836.09,
    "override_increase_1": 133.43
  },
  {
    "#": "9 Linden St, Unit 3 & P3 (141-10-04)",
    "$": 770000,
    "address": "9 Linden St, Unit 3 & P3",
    "parcel_id": "141-10-04",
    "owner1": "THAKKAR TRS, AJAY V",
    "owner2": "FOLDY, SHARON M",
    "current_taxes": 4249.87,
    "new_taxes_no_override": 4433.46,
    "override_total_1": 4559.26,
    "override_increase_1": 125.8
  },
  {
    "#": "9 Linden St, Unit 4 Prk 6 7 (141-10-05)",
    "$": 1071200,
    "address": "9 Linden St, Unit 4 Prk 6 7",
    "parcel_id": "141-10-05",
    "owner1": "9 LINDEN ASSOCIATES LLC",
    "owner2": "",
    "current_taxes": 10969.09,
    "new_taxes_no_override": 11442.95,
    "override_total_1": 11767.64,
    "override_increase_1": 324.69
  },
  {
    "#": "9 Linden St, Unit 5 (141-10-06)",
    "$": 1087700,
    "address": "9 Linden St, Unit 5",
    "parcel_id": "141-10-06",
    "owner1": "LASCH, KATHRYN",
    "owner2": "",
    "current_taxes": 7503.11,
    "new_taxes_no_override": 7827.24,
    "override_total_1": 8049.34,
    "override_increase_1": 222.09
  },
  {
    "#": "10 Linden St (141-10-01)",
    "$": 665700,
    "address": "10 Linden St",
    "parcel_id": "141-10-01",
    "owner1": "SLD B LLC",
    "owner2": "",
    "current_taxes": 11423.41,
    "new_taxes_no_override": 11916.9,
    "override_total_1": 12255.03,
    "override_increase_1": 338.13
  },
  {
    "#": "12 Linden St, Unit 1 & P1 (141-11-02)",
    "$": 1403600,
    "address": "12 Linden St, Unit 1 & P1",
    "parcel_id": "141-11-02",
    "owner1": "CONNOR, MARIA HOOK",
    "owner2": "",
    "current_taxes": 14372.86,
    "new_taxes_no_override": 14993.77,
    "override_total_1": 15419.2,
    "override_increase_1": 425.44
  },
  {
    "#": "12 Linden St, Unit 2 & P2 (141-11-01)",
    "$": 1431100,
    "address": "12 Linden St, Unit 2 & P2",
    "parcel_id": "141-11-01",
    "owner1": "HITCHCOCK, KATHERINE A",
    "owner2": "SMITH, VIRGINIA",
    "current_taxes": 11019.53,
    "new_taxes_no_override": 11495.57,
    "override_total_1": 11821.75,
    "override_increase_1": 326.18
  },
  {
    "#": "13 Linden St, Unit 1 (141-12-22)",
    "$": 757100,
    "address": "13 Linden St, Unit 1",
    "parcel_id": "141-12-22",
    "owner1": "MORRIS, KEVIN W",
    "owner2": "RUIZ, LORENA FLORES",
    "current_taxes": 7752.7,
    "new_taxes_no_override": 8087.62,
    "override_total_1": 8317.1,
    "override_increase_1": 229.48
  },
  {
    "#": "13 Linden St, Unit 2 (141-12-01)",
    "$": 743900,
    "address": "13 Linden St, Unit 2",
    "parcel_id": "141-12-01",
    "owner1": "HANSSEN TR, KARLA DIANNE",
    "owner2": "",
    "current_taxes": 7617.54,
    "new_taxes_no_override": 7946.62,
    "override_total_1": 8172.1,
    "override_increase_1": 225.48
  },
  {
    "#": "13 Linden St, Unit 3 (141-12-02)",
    "$": 763700,
    "address": "13 Linden St, Unit 3",
    "parcel_id": "141-12-02",
    "owner1": "GARG, LOVEE",
    "owner2": "",
    "current_taxes": 4185.35,
    "new_taxes_no_override": 4366.16,
    "override_total_1": 4490.04,
    "override_increase_1": 123.89
  },
  {
    "#": "13 Linden St, Unit 4 (141-12-03)",
    "$": 766900,
    "address": "13 Linden St, Unit 4",
    "parcel_id": "141-12-03",
    "owner1": "TOPALOV, PETAR",
    "owner2": "",
    "current_taxes": 4218.12,
    "new_taxes_no_override": 4400.34,
    "override_total_1": 4525.2,
    "override_increase_1": 124.86
  },
  {
    "#": "13 Linden St, Unit 5 (141-12-04)",
    "$": 728000,
    "address": "13 Linden St, Unit 5",
    "parcel_id": "141-12-04",
    "owner1": "STATLENDER, LOIS SUSAN",
    "owner2": "",
    "current_taxes": 3819.79,
    "new_taxes_no_override": 3984.8,
    "override_total_1": 4097.87,
    "override_increase_1": 113.07
  },
  {
    "#": "13 Linden St, Unit 6 (141-12-05)",
    "$": 790100,
    "address": "13 Linden St, Unit 6",
    "parcel_id": "141-12-05",
    "owner1": "CONNELLY, JOSEPH C",
    "owner2": "",
    "current_taxes": 4455.69,
    "new_taxes_no_override": 4648.18,
    "override_total_1": 4780.06,
    "override_increase_1": 131.89
  },
  {
    "#": "13 Linden St, Unit 7 (141-12-06)",
    "$": 728000,
    "address": "13 Linden St, Unit 7",
    "parcel_id": "141-12-06",
    "owner1": "MANN, MELINDA A",
    "owner2": "",
    "current_taxes": 3819.79,
    "new_taxes_no_override": 3984.8,
    "override_total_1": 4097.87,
    "override_increase_1": 113.07
  },
  {
    "#": "13 Linden St, Unit 8 (141-12-07)",
    "$": 766800,
    "address": "13 Linden St, Unit 8",
    "parcel_id": "141-12-07",
    "owner1": "RAO, MAYA",
    "owner2": "",
    "current_taxes": 7852.03,
    "new_taxes_no_override": 8191.24,
    "override_total_1": 8423.66,
    "override_increase_1": 232.42
  },
  {
    "#": "14 Linden St, Unit 1 (141-12-08)",
    "$": 751900,
    "address": "14 Linden St, Unit 1",
    "parcel_id": "141-12-08",
    "owner1": "LIU, EDWARD P",
    "owner2": "",
    "current_taxes": 4064.52,
    "new_taxes_no_override": 4240.11,
    "override_total_1": 4360.42,
    "override_increase_1": 120.31
  },
  {
    "#": "14 Linden St, Unit 2 (141-12-09)",
    "$": 773100,
    "address": "14 Linden St, Unit 2",
    "parcel_id": "141-12-09",
    "owner1": "MENN, ANATOLY NAFTALY",
    "owner2": "",
    "current_taxes": 4281.61,
    "new_taxes_no_override": 4466.58,
    "override_total_1": 4593.31,
    "override_increase_1": 126.74
  },
  {
    "#": "14 Linden St, Unit 3 (141-12-10)",
    "$": 760900,
    "address": "14 Linden St, Unit 3",
    "parcel_id": "141-12-10",
    "owner1": "OCONNELL, DAVID P",
    "owner2": "",
    "current_taxes": 4156.68,
    "new_taxes_no_override": 4336.25,
    "override_total_1": 4459.29,
    "override_increase_1": 123.04
  },
  {
    "#": "14 Linden St, Unit 4 (141-12-11)",
    "$": 767200,
    "address": "14 Linden St, Unit 4",
    "parcel_id": "141-12-11",
    "owner1": "ROBERTS TR, GAIL M",
    "owner2": "",
    "current_taxes": 4221.19,
    "new_taxes_no_override": 4403.55,
    "override_total_1": 4528.49,
    "override_increase_1": 124.95
  },
  {
    "#": "14 Linden St, Unit 5 (141-12-12)",
    "$": 745400,
    "address": "14 Linden St, Unit 5",
    "parcel_id": "141-12-12",
    "owner1": "EMMERICH, RALPH & VALERIE",
    "owner2": "HORWITZ TR, EVE T",
    "current_taxes": 3997.96,
    "new_taxes_no_override": 4170.67,
    "override_total_1": 4289.01,
    "override_increase_1": 118.34
  },
  {
    "#": "14 Linden St, Unit 6 (141-12-13)",
    "$": 757500,
    "address": "14 Linden St, Unit 6",
    "parcel_id": "141-12-13",
    "owner1": "ZHOU, XIN SAM",
    "owner2": "TAO, XUEQIN",
    "current_taxes": 7756.8,
    "new_taxes_no_override": 8091.89,
    "override_total_1": 8321.5,
    "override_increase_1": 229.6
  },
  {
    "#": "14 Linden St, Unit 7 (141-12-14)",
    "$": 754700,
    "address": "14 Linden St, Unit 7",
    "parcel_id": "141-12-14",
    "owner1": "7 LINDEN LLC",
    "owner2": "",
    "current_taxes": 7728.13,
    "new_taxes_no_override": 8061.99,
    "override_total_1": 8290.74,
    "override_increase_1": 228.75
  },
  {
    "#": "14 Linden St, Unit 8 (141-12-15)",
    "$": 766900,
    "address": "14 Linden St, Unit 8",
    "parcel_id": "141-12-15",
    "owner1": "CORELLO TRS, JUDITH",
    "owner2": "VEILLET, MARC",
    "current_taxes": 4218.12,
    "new_taxes_no_override": 4400.34,
    "override_total_1": 4525.2,
    "override_increase_1": 124.86
  },
  {
    "#": "15 Linden St, Unit 1 (141-12-16)",
    "$": 837000,
    "address": "15 Linden St, Unit 1",
    "parcel_id": "141-12-16",
    "owner1": "RAINE TRS, ALDEN S & ERICA S",
    "owner2": "",
    "current_taxes": 4935.95,
    "new_taxes_no_override": 5149.18,
    "override_total_1": 5295.29,
    "override_increase_1": 146.1
  },
  {
    "#": "15 Linden St, Unit 2 (141-12-17)",
    "$": 737500,
    "address": "15 Linden St, Unit 2",
    "parcel_id": "141-12-17",
    "owner1": "CAVANARO TR, SANDRA L",
    "owner2": "",
    "current_taxes": 3917.07,
    "new_taxes_no_override": 4086.29,
    "override_total_1": 4202.23,
    "override_increase_1": 115.95
  },
  {
    "#": "15 Linden St, Unit 3 (141-12-18)",
    "$": 848800,
    "address": "15 Linden St, Unit 3",
    "parcel_id": "141-12-18",
    "owner1": "BURKHART, TIMOTHY M",
    "owner2": "",
    "current_taxes": 5056.78,
    "new_taxes_no_override": 5275.23,
    "override_total_1": 5424.91,
    "override_increase_1": 149.68
  },
  {
    "#": "15 Linden St, Unit 4 (141-12-19)",
    "$": 821800,
    "address": "15 Linden St, Unit 4",
    "parcel_id": "141-12-19",
    "owner1": "HONG, XUECHUAN",
    "owner2": "XIAO, YULING",
    "current_taxes": 8415.23,
    "new_taxes_no_override": 8778.77,
    "override_total_1": 9027.86,
    "override_increase_1": 249.09
  },
  {
    "#": "15 Linden St, Unit 5 (141-12-20)",
    "$": 1069900,
    "address": "15 Linden St, Unit 5",
    "parcel_id": "141-12-20",
    "owner1": "OETTGEN, SUSAN P",
    "owner2": "",
    "current_taxes": 7320.84,
    "new_taxes_no_override": 7637.1,
    "override_total_1": 7853.8,
    "override_increase_1": 216.7
  },
  {
    "#": "15 Linden St, Unit 6 (141-12-21)",
    "$": 1037100,
    "address": "15 Linden St, Unit 6",
    "parcel_id": "141-12-21",
    "owner1": "MCCARTHY, MARY",
    "owner2": "",
    "current_taxes": 6984.97,
    "new_taxes_no_override": 7286.72,
    "override_total_1": 7493.48,
    "override_increase_1": 206.76
  },
  {
    "#": "15 Linden St (147-06-01)",
    "$": 1519000,
    "address": "15 Linden St",
    "parcel_id": "147-06-01",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O LINDEN PARK",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "19 Linden St (141-13-00)",
    "$": 2763500,
    "address": "19 Linden St",
    "parcel_id": "141-13-00",
    "owner1": "TREFONIDES  TRS, PHYLLIS & JESSICA E & ADAM A",
    "owner2": "TREFONIDES-MASE, ALEXA S",
    "current_taxes": 24663.31,
    "new_taxes_no_override": 25728.76,
    "override_total_1": 26458.8,
    "override_increase_1": 730.03
  },
  {
    "#": "22 Linden St (147-05-00)",
    "$": 2087900,
    "address": "22 Linden St",
    "parcel_id": "147-05-00",
    "owner1": "EWALL, ET AL, WILLIAM J",
    "owner2": "",
    "current_taxes": 17745.16,
    "new_taxes_no_override": 18511.75,
    "override_total_1": 19037.01,
    "override_increase_1": 525.26
  },
  {
    "#": "25 Linden St (141-14-00)",
    "$": 3167600,
    "address": "25 Linden St",
    "parcel_id": "141-14-00",
    "owner1": "BITTON, ASAF & ELIZABETH",
    "owner2": "",
    "current_taxes": 28801.29,
    "new_taxes_no_override": 30045.51,
    "override_total_1": 30898.02,
    "override_increase_1": 852.52
  },
  {
    "#": "26 Linden St, Unit 1 (147-04-01)",
    "$": 994500,
    "address": "26 Linden St, Unit 1",
    "parcel_id": "147-04-01",
    "owner1": "SADOVNIKOV, LEONID & KATHERINE",
    "owner2": "",
    "current_taxes": 6548.75,
    "new_taxes_no_override": 6831.66,
    "override_total_1": 7025.5,
    "override_increase_1": 193.84
  },
  {
    "#": "26 Linden St, Unit 2 & P2 (147-04-02)",
    "$": 865900,
    "address": "26 Linden St, Unit 2 & P2",
    "parcel_id": "147-04-02",
    "owner1": "MASTERMAN, CRAIG & ANN",
    "owner2": "",
    "current_taxes": 8866.82,
    "new_taxes_no_override": 9249.87,
    "override_total_1": 9512.32,
    "override_increase_1": 262.46
  },
  {
    "#": "26 Linden St, Unit 3 (147-04-03)",
    "$": 849200,
    "address": "26 Linden St, Unit 3",
    "parcel_id": "147-04-03",
    "owner1": "GNOZZIO, MICHAEL",
    "owner2": "VALLEAU, MATTHEW",
    "current_taxes": 5060.87,
    "new_taxes_no_override": 5279.5,
    "override_total_1": 5429.3,
    "override_increase_1": 149.8
  },
  {
    "#": "29 Linden St (141-15-00)",
    "$": 1927300,
    "address": "29 Linden St",
    "parcel_id": "141-15-00",
    "owner1": "HINGSTON, JOSEPH DONALD",
    "owner2": "",
    "current_taxes": 16100.62,
    "new_taxes_no_override": 16796.17,
    "override_total_1": 17272.75,
    "override_increase_1": 476.58
  },
  {
    "#": "31 Linden St (141-16-00)",
    "$": 1869400,
    "address": "31 Linden St",
    "parcel_id": "141-16-00",
    "owner1": "PFISTER, JANE",
    "owner2": "MOORE TR, JAMES VERNER",
    "current_taxes": 15507.72,
    "new_taxes_no_override": 16177.65,
    "override_total_1": 16636.68,
    "override_increase_1": 459.03
  },
  {
    "#": "32 Linden St (147-03-00)",
    "$": 5917100,
    "address": "32 Linden St",
    "parcel_id": "147-03-00",
    "owner1": "32 LINDEN ST LLC",
    "owner2": "C/O DARROW EVERETT LLP",
    "current_taxes": 60591.1,
    "new_taxes_no_override": 63208.64,
    "override_total_1": 65002.13,
    "override_increase_1": 1793.5
  },
  {
    "#": "33 Linden St (141-17-00)",
    "$": 2470400,
    "address": "33 Linden St",
    "parcel_id": "141-17-00",
    "owner1": "XU, HAO",
    "owner2": "ZHOU, ZHIQI",
    "current_taxes": 21661.96,
    "new_taxes_no_override": 22597.76,
    "override_total_1": 23238.95,
    "override_increase_1": 641.19
  },
  {
    "#": "35 Linden St (141-18-00)",
    "$": 2397100,
    "address": "35 Linden St",
    "parcel_id": "141-18-00",
    "owner1": "MOORE TR, CELESTE M",
    "owner2": "",
    "current_taxes": 20911.37,
    "new_taxes_no_override": 21814.74,
    "override_total_1": 22433.72,
    "override_increase_1": 618.98
  },
  {
    "#": "38 Linden St, Unit 1-2 (147-02-08)",
    "$": 1827200,
    "address": "38 Linden St, Unit 1-2",
    "parcel_id": "147-02-08",
    "owner1": "PALUSZEK, MATTHEW J",
    "owner2": "",
    "current_taxes": 15075.59,
    "new_taxes_no_override": 15726.86,
    "override_total_1": 16173.09,
    "override_increase_1": 446.24
  },
  {
    "#": "38 Linden St, Unit 3 (147-02-02)",
    "$": 1024600,
    "address": "38 Linden St, Unit 3",
    "parcel_id": "147-02-02",
    "owner1": "HARSFIELD, LEAH R & CRAIG H",
    "owner2": "",
    "current_taxes": 6856.97,
    "new_taxes_no_override": 7153.19,
    "override_total_1": 7356.16,
    "override_increase_1": 202.97
  },
  {
    "#": "38 Linden St, Unit 4 (147-02-03)",
    "$": 1063200,
    "address": "38 Linden St, Unit 4",
    "parcel_id": "147-02-03",
    "owner1": "WILLCOX, JILL L & DAVID R",
    "owner2": "",
    "current_taxes": 7252.23,
    "new_taxes_no_override": 7565.53,
    "override_total_1": 7780.19,
    "override_increase_1": 214.67
  },
  {
    "#": "38 Linden St, Unit 5 (147-02-04)",
    "$": 997400,
    "address": "38 Linden St, Unit 5",
    "parcel_id": "147-02-04",
    "owner1": "WANG, FEI",
    "owner2": "ZHAO, YAO",
    "current_taxes": 6578.44,
    "new_taxes_no_override": 6862.63,
    "override_total_1": 7057.35,
    "override_increase_1": 194.72
  },
  {
    "#": "38 Linden St, Unit 6 (147-02-05)",
    "$": 981400,
    "address": "38 Linden St, Unit 6",
    "parcel_id": "147-02-05",
    "owner1": "REED, DAVID E",
    "owner2": "",
    "current_taxes": 6414.6,
    "new_taxes_no_override": 6691.71,
    "override_total_1": 6881.58,
    "override_increase_1": 189.87
  },
  {
    "#": "38 Linden St, Unit 7 (147-02-06)",
    "$": 848500,
    "address": "38 Linden St, Unit 7",
    "parcel_id": "147-02-06",
    "owner1": "FREED, JASON & MARISSA",
    "owner2": "",
    "current_taxes": 5053.71,
    "new_taxes_no_override": 5272.03,
    "override_total_1": 5421.62,
    "override_increase_1": 149.59
  },
  {
    "#": "39 Linden St (141-19-00)",
    "$": 1939100,
    "address": "39 Linden St",
    "parcel_id": "141-19-00",
    "owner1": "HILLIARD, KAREN L",
    "owner2": "",
    "current_taxes": 16221.45,
    "new_taxes_no_override": 16922.22,
    "override_total_1": 17402.37,
    "override_increase_1": 480.15
  },
  {
    "#": "41 Linden St, Unit 1 (141-19-05)",
    "$": 917500,
    "address": "41 Linden St, Unit 1",
    "parcel_id": "141-19-05",
    "owner1": "BALTZELL, LAURA",
    "owner2": "",
    "current_taxes": 5760.27,
    "new_taxes_no_override": 6009.11,
    "override_total_1": 6179.62,
    "override_increase_1": 170.5
  },
  {
    "#": "41 Linden St, Unit 2 & P1&P2 (141-19-06)",
    "$": 1435000,
    "address": "41 Linden St, Unit 2 & P1&P2",
    "parcel_id": "141-19-06",
    "owner1": "BROOKFIELD, FLORA & JONATHAN",
    "owner2": "",
    "current_taxes": 11059.47,
    "new_taxes_no_override": 11537.24,
    "override_total_1": 11864.6,
    "override_increase_1": 327.36
  },
  {
    "#": "43 Linden St, Unit 1 (141-19-07)",
    "$": 1232100,
    "address": "43 Linden St, Unit 1",
    "parcel_id": "141-19-07",
    "owner1": "SMITH TR, JULIE A",
    "owner2": "",
    "current_taxes": 8981.77,
    "new_taxes_no_override": 9369.78,
    "override_total_1": 9635.64,
    "override_increase_1": 265.86
  },
  {
    "#": "43 Linden St, Unit 2 (141-19-08)",
    "$": 1420600,
    "address": "43 Linden St, Unit 2",
    "parcel_id": "141-19-08",
    "owner1": "LUCKMAN TR, MARK",
    "owner2": "MAHONEY TR, MARGARET A",
    "current_taxes": 10912.01,
    "new_taxes_no_override": 11383.41,
    "override_total_1": 11706.4,
    "override_increase_1": 323.0
  },
  {
    "#": "44 Linden St (147-01-00)",
    "$": 2996000,
    "address": "44 Linden St",
    "parcel_id": "147-01-00",
    "owner1": "REVIS, MATTHEW L",
    "owner2": "LITTMAN, MARA E",
    "current_taxes": 27044.11,
    "new_taxes_no_override": 28212.42,
    "override_total_1": 29012.92,
    "override_increase_1": 800.51
  },
  {
    "#": "45 Linden St (141-19-02)",
    "$": 2314000,
    "address": "45 Linden St",
    "parcel_id": "141-19-02",
    "owner1": "MUI, KIT",
    "owner2": "",
    "current_taxes": 20060.43,
    "new_taxes_no_override": 20927.04,
    "override_total_1": 21520.83,
    "override_increase_1": 593.79
  },
  {
    "#": "52 Linden St (146-25-00)",
    "$": 1725800,
    "address": "52 Linden St",
    "parcel_id": "146-25-00",
    "owner1": "LINDHOLM LIFE ESTATE, EDWARD P & NANCY M",
    "owner2": "",
    "current_taxes": 14037.26,
    "new_taxes_no_override": 14643.67,
    "override_total_1": 15059.17,
    "override_increase_1": 415.5
  },
  {
    "#": "53 Linden St (141-19-04)",
    "$": 3128100,
    "address": "53 Linden St",
    "parcel_id": "141-19-04",
    "owner1": "GRACE, JAMES F & LISA GOLDBLATT",
    "owner2": "",
    "current_taxes": 28396.81,
    "new_taxes_no_override": 29623.55,
    "override_total_1": 30464.1,
    "override_increase_1": 840.55
  },
  {
    "#": "55 Linden St (141-20-00)",
    "$": 2015000,
    "address": "55 Linden St",
    "parcel_id": "141-20-00",
    "owner1": "LM LINDEN LLC",
    "owner2": "",
    "current_taxes": 20633.6,
    "new_taxes_no_override": 21524.97,
    "override_total_1": 22135.73,
    "override_increase_1": 610.75
  },
  {
    "#": "56 Linden St, Unit 1 (146-24-01)",
    "$": 1422700,
    "address": "56 Linden St, Unit 1",
    "parcel_id": "146-24-01",
    "owner1": "PRABHAKAR, RACHEL & VINAY",
    "owner2": "",
    "current_taxes": 10933.51,
    "new_taxes_no_override": 11405.84,
    "override_total_1": 11729.47,
    "override_increase_1": 323.63
  },
  {
    "#": "56 Linden St, Unit 2 (146-24-02)",
    "$": 1462300,
    "address": "56 Linden St, Unit 2",
    "parcel_id": "146-24-02",
    "owner1": "SIMCHOWITZ, BRETT",
    "owner2": "",
    "current_taxes": 11339.02,
    "new_taxes_no_override": 11828.87,
    "override_total_1": 12164.5,
    "override_increase_1": 335.63
  },
  {
    "#": "59 Linden St (141-20-01)",
    "$": 2117300,
    "address": "59 Linden St",
    "parcel_id": "141-20-01",
    "owner1": "SIEGEL, MARJORIE",
    "owner2": "",
    "current_taxes": 18046.22,
    "new_taxes_no_override": 18825.82,
    "override_total_1": 19359.98,
    "override_increase_1": 534.17
  },
  {
    "#": "60 Linden St, Unit 1 (146-23-01)",
    "$": 1056600,
    "address": "60 Linden St, Unit 1",
    "parcel_id": "146-23-01",
    "owner1": "TOPPER, JONATHAN M & KELLEY E",
    "owner2": "",
    "current_taxes": 7184.65,
    "new_taxes_no_override": 7495.03,
    "override_total_1": 7707.69,
    "override_increase_1": 212.67
  },
  {
    "#": "60 Linden St, Unit 2 (146-23-02)",
    "$": 1487000,
    "address": "60 Linden St, Unit 2",
    "parcel_id": "146-23-02",
    "owner1": "JACOPILLE, MYRIAM D & DAVID M",
    "owner2": "",
    "current_taxes": 11591.95,
    "new_taxes_no_override": 12092.72,
    "override_total_1": 12435.84,
    "override_increase_1": 343.12
  },
  {
    "#": "61 Linden St, Unit 1 (141-20-03)",
    "$": 949300,
    "address": "61 Linden St, Unit 1",
    "parcel_id": "141-20-03",
    "owner1": "JANDOVA, IVA",
    "owner2": "",
    "current_taxes": 6085.9,
    "new_taxes_no_override": 6348.81,
    "override_total_1": 6528.95,
    "override_increase_1": 180.14
  },
  {
    "#": "61 Linden St, Unit 2 (141-20-04)",
    "$": 968600,
    "address": "61 Linden St, Unit 2",
    "parcel_id": "141-20-04",
    "owner1": "HUMPHREY, DENNIS A",
    "owner2": "",
    "current_taxes": 6283.53,
    "new_taxes_no_override": 6554.98,
    "override_total_1": 6740.97,
    "override_increase_1": 185.99
  },
  {
    "#": "64 Linden St, Unit 1 (146-22-01)",
    "$": 1134700,
    "address": "64 Linden St, Unit 1",
    "parcel_id": "146-22-01",
    "owner1": "VIEIRA, REBECCA L",
    "owner2": "VANKOSKI, BRETT M",
    "current_taxes": 7984.39,
    "new_taxes_no_override": 8329.32,
    "override_total_1": 8565.65,
    "override_increase_1": 236.34
  },
  {
    "#": "64 Linden St, Unit 2 (146-22-02)",
    "$": 1571900,
    "address": "64 Linden St, Unit 2",
    "parcel_id": "146-22-02",
    "owner1": "CIRINCIONE TRS, PETER",
    "owner2": "COLEMAN, JILL",
    "current_taxes": 12461.32,
    "new_taxes_no_override": 12999.65,
    "override_total_1": 13368.5,
    "override_increase_1": 368.86
  },
  {
    "#": "65 Linden St (141-21-00)",
    "$": 1936200,
    "address": "65 Linden St",
    "parcel_id": "141-21-00",
    "owner1": "BRADLEY, PHYLLIS O & JULIE & THOMAS P III",
    "owner2": "",
    "current_taxes": 16191.75,
    "new_taxes_no_override": 16891.23,
    "override_total_1": 17370.51,
    "override_increase_1": 479.28
  },
  {
    "#": "66 Linden St, Unit 66 (146-21-01)",
    "$": 1742600,
    "address": "66 Linden St, Unit 66",
    "parcel_id": "146-21-01",
    "owner1": "BRENMAN, LEOR",
    "owner2": "",
    "current_taxes": 14209.29,
    "new_taxes_no_override": 14823.13,
    "override_total_1": 15243.73,
    "override_increase_1": 420.59
  },
  {
    "#": "66 Linden St, Unit 68 (146-21-02)",
    "$": 1701900,
    "address": "66 Linden St, Unit 68",
    "parcel_id": "146-21-02",
    "owner1": "COMERCHERO, SANDRA",
    "owner2": "",
    "current_taxes": 13792.52,
    "new_taxes_no_override": 14388.36,
    "override_total_1": 14796.62,
    "override_increase_1": 408.26
  },
  {
    "#": "69 Linden St (141-21-01)",
    "$": 2040900,
    "address": "69 Linden St",
    "parcel_id": "141-21-01",
    "owner1": "JACOBY, TR, LAURA W & JEFF",
    "owner2": "",
    "current_taxes": 17263.88,
    "new_taxes_no_override": 18009.68,
    "override_total_1": 18520.69,
    "override_increase_1": 511.01
  },
  {
    "#": "72 Linden St (146-20-00)",
    "$": 2256300,
    "address": "72 Linden St",
    "parcel_id": "146-20-00",
    "owner1": "GARIN, PATRICIA L",
    "owner2": "DOHAN, JOSHUA M",
    "current_taxes": 19469.58,
    "new_taxes_no_override": 20310.67,
    "override_total_1": 20886.97,
    "override_increase_1": 576.3
  },
  {
    "#": "75 Linden St, Unit A-2 & G8-19-21 (141-22-02)",
    "$": 1541700,
    "address": "75 Linden St, Unit A-2 & G8-19-21",
    "parcel_id": "141-22-02",
    "owner1": "CHEZAR TRS, TIMOTHY MICHAEL & JACQUELINE D",
    "owner2": "",
    "current_taxes": 12152.07,
    "new_taxes_no_override": 12677.04,
    "override_total_1": 13036.74,
    "override_increase_1": 359.7
  },
  {
    "#": "75 Linden St, Unit A-3 & G7-18 (141-22-03)",
    "$": 1442600,
    "address": "75 Linden St, Unit A-3 & G7-18",
    "parcel_id": "141-22-03",
    "owner1": "LI, MI",
    "owner2": "CHEN, HUAN",
    "current_taxes": 11137.29,
    "new_taxes_no_override": 11618.42,
    "override_total_1": 11948.08,
    "override_increase_1": 329.66
  },
  {
    "#": "77 Linden St, Unit A-1 & G38 (141-22-01)",
    "$": 270000,
    "address": "77 Linden St, Unit A-1 & G38",
    "parcel_id": "141-22-01",
    "owner1": "BOWDEN TRS, R S",
    "owner2": "C/O RCG LLC",
    "current_taxes": 2764.8,
    "new_taxes_no_override": 2884.24,
    "override_total_1": 2966.08,
    "override_increase_1": 81.84
  },
  {
    "#": "7 Littell Rd (157-04-00)",
    "$": 2650300,
    "address": "7 Littell Rd",
    "parcel_id": "157-04-00",
    "owner1": "EBER TRS, DAVID G & JESSICA M A",
    "owner2": "",
    "current_taxes": 23504.14,
    "new_taxes_no_override": 24519.52,
    "override_total_1": 25215.24,
    "override_increase_1": 695.72
  },
  {
    "#": "8 Littell Rd (156-08-00)",
    "$": 2740600,
    "address": "8 Littell Rd",
    "parcel_id": "156-08-00",
    "owner1": "DICKMAN TRS, AUBREY",
    "owner2": "RAUCH, PAULA K",
    "current_taxes": 24428.81,
    "new_taxes_no_override": 25484.13,
    "override_total_1": 26207.23,
    "override_increase_1": 723.09
  },
  {
    "#": "11 Littell Rd (157-05-00)",
    "$": 2288700,
    "address": "11 Littell Rd",
    "parcel_id": "157-05-00",
    "owner1": "GENOVESE TRS, EMANUELE & CAROL A",
    "owner2": "",
    "current_taxes": 19801.35,
    "new_taxes_no_override": 20656.77,
    "override_total_1": 21242.89,
    "override_increase_1": 586.12
  },
  {
    "#": "12 Littell Rd, Unit 12 (156-07-01)",
    "$": 2674900,
    "address": "12 Littell Rd, Unit 12",
    "parcel_id": "156-07-01",
    "owner1": "COSTINOT, ARNAUD",
    "owner2": "PLESIER, NADEGE",
    "current_taxes": 23756.04,
    "new_taxes_no_override": 24782.3,
    "override_total_1": 25485.48,
    "override_increase_1": 703.18
  },
  {
    "#": "12 Littell Rd, Unit 14 (156-07-02)",
    "$": 2067500,
    "address": "12 Littell Rd, Unit 14",
    "parcel_id": "156-07-02",
    "owner1": "LEUNER, MARK & MARIA",
    "owner2": "",
    "current_taxes": 17536.27,
    "new_taxes_no_override": 18293.84,
    "override_total_1": 18812.91,
    "override_increase_1": 519.07
  },
  {
    "#": "16 Littell Rd, Unit 2 (156-06-02)",
    "$": 1723000,
    "address": "16 Littell Rd, Unit 2",
    "parcel_id": "156-06-02",
    "owner1": "PICKARD TRS, SARAH",
    "owner2": "MANDEL, MATTHEW",
    "current_taxes": 14008.59,
    "new_taxes_no_override": 14613.76,
    "override_total_1": 15028.42,
    "override_increase_1": 414.65
  },
  {
    "#": "17 Littell Rd (157-06-00)",
    "$": 3571300,
    "address": "17 Littell Rd",
    "parcel_id": "157-06-00",
    "owner1": "LACOUNT, SHAWN & JESSICA ULLIAN",
    "owner2": "",
    "current_taxes": 32935.18,
    "new_taxes_no_override": 34357.98,
    "override_total_1": 35332.86,
    "override_increase_1": 974.88
  },
  {
    "#": "18 Littell Rd, Unit 1 (156-06-01)",
    "$": 1472100,
    "address": "18 Littell Rd, Unit 1",
    "parcel_id": "156-06-01",
    "owner1": "HARDEBECK, EDWARD F & KELLY A",
    "owner2": "",
    "current_taxes": 11439.37,
    "new_taxes_no_override": 11933.55,
    "override_total_1": 12272.16,
    "override_increase_1": 338.61
  },
  {
    "#": "20 Littell Rd (156-05-00)",
    "$": 2518700,
    "address": "20 Littell Rd",
    "parcel_id": "156-05-00",
    "owner1": "KAZMI, ANWAR H & NIKHAT",
    "owner2": "",
    "current_taxes": 25791.49,
    "new_taxes_no_override": 26905.68,
    "override_total_1": 27669.11,
    "override_increase_1": 763.43
  },
  {
    "#": "21 Littell Rd (157-07-00)",
    "$": 2200400,
    "address": "21 Littell Rd",
    "parcel_id": "157-07-00",
    "owner1": "COHEN TR, SUSAN F",
    "owner2": "",
    "current_taxes": 18897.16,
    "new_taxes_no_override": 19713.52,
    "override_total_1": 20272.87,
    "override_increase_1": 559.36
  },
  {
    "#": "24 Littell Rd, Unit 1 (156-04-01)",
    "$": 2661200,
    "address": "24 Littell Rd, Unit 1",
    "parcel_id": "156-04-01",
    "owner1": "MURRAY, TATUM L & BRAD C",
    "owner2": "SPAGNOLETTI, NICHOLAS ALBERT",
    "current_taxes": 27250.69,
    "new_taxes_no_override": 28427.92,
    "override_total_1": 29234.54,
    "override_increase_1": 806.62
  },
  {
    "#": "24 Littell Rd, Unit 2 (156-04-02)",
    "$": 2538900,
    "address": "24 Littell Rd, Unit 2",
    "parcel_id": "156-04-02",
    "owner1": "DHUNDIA, HARSH",
    "owner2": "RAGHAVAN, INDHU",
    "current_taxes": 25998.34,
    "new_taxes_no_override": 27121.47,
    "override_total_1": 27891.02,
    "override_increase_1": 769.55
  },
  {
    "#": "25 Littell Rd (157-08-00)",
    "$": 2781100,
    "address": "25 Littell Rd",
    "parcel_id": "157-08-00",
    "owner1": "URBANO, ROSEANNE",
    "owner2": "",
    "current_taxes": 24843.53,
    "new_taxes_no_override": 25916.77,
    "override_total_1": 26652.14,
    "override_increase_1": 735.37
  },
  {
    "#": "28 Littell Rd (156-02-03)",
    "$": 6233000,
    "address": "28 Littell Rd",
    "parcel_id": "156-02-03",
    "owner1": "BEACON PROPERTY REALTY LLC",
    "owner2": "",
    "current_taxes": 63825.92,
    "new_taxes_no_override": 66583.2,
    "override_total_1": 68472.45,
    "override_increase_1": 1889.25
  },
  {
    "#": "29 Littell Rd (157-09-00)",
    "$": 2209400,
    "address": "29 Littell Rd",
    "parcel_id": "157-09-00",
    "owner1": "ST PIERRE, CHRISTINE & PHILIP",
    "owner2": "",
    "current_taxes": 18989.32,
    "new_taxes_no_override": 19809.66,
    "override_total_1": 20371.74,
    "override_increase_1": 562.08
  },
  {
    "#": "5 Longwood Ave (162-03-00)",
    "$": 8111300,
    "address": "5 Longwood Ave",
    "parcel_id": "162-03-00",
    "owner1": "CLEVELAND REALTY CO",
    "owner2": "",
    "current_taxes": 139189.91,
    "new_taxes_no_override": 145202.91,
    "override_total_1": 149322.94,
    "override_increase_1": 4120.02
  },
  {
    "#": "11 Longwood Ave, Unit 201 P15&16 (162-01-01)",
    "$": 1654500,
    "address": "11 Longwood Ave, Unit 201 P15&16",
    "parcel_id": "162-01-01",
    "owner1": "ROSENKRANTZ TR, ROBERT I",
    "owner2": "",
    "current_taxes": 13307.15,
    "new_taxes_no_override": 13882.02,
    "override_total_1": 14275.91,
    "override_increase_1": 393.89
  },
  {
    "#": "11 Longwood Ave, Unit 202 P11&12 (162-01-02)",
    "$": 1592600,
    "address": "11 Longwood Ave, Unit 202 P11&12",
    "parcel_id": "162-01-02",
    "owner1": "MAZZA, JOHN E",
    "owner2": "LIN, LEESA K",
    "current_taxes": 12673.29,
    "new_taxes_no_override": 13220.78,
    "override_total_1": 13595.91,
    "override_increase_1": 375.13
  },
  {
    "#": "11 Longwood Ave, Unit 203 & P13 (162-01-03)",
    "$": 1559000,
    "address": "11 Longwood Ave, Unit 203 & P13",
    "parcel_id": "162-01-03",
    "owner1": "IRWIG, MICHAEL",
    "owner2": "",
    "current_taxes": 12329.23,
    "new_taxes_no_override": 12861.85,
    "override_total_1": 13226.8,
    "override_increase_1": 364.95
  },
  {
    "#": "11 Longwood Ave, Unit 301 P2 P10 (162-01-04)",
    "$": 1825800,
    "address": "11 Longwood Ave, Unit 301 P2 P10",
    "parcel_id": "162-01-04",
    "owner1": "FROST , EVIE",
    "owner2": "",
    "current_taxes": 18696.19,
    "new_taxes_no_override": 19503.87,
    "override_total_1": 20057.27,
    "override_increase_1": 553.41
  },
  {
    "#": "11 Longwood Ave, Unit 302 P4 P14 (162-01-05)",
    "$": 1696600,
    "address": "11 Longwood Ave, Unit 302 P4 P14",
    "parcel_id": "162-01-05",
    "owner1": "DOYLE, RICHARD B & NANCY B",
    "owner2": "",
    "current_taxes": 13738.25,
    "new_taxes_no_override": 14331.74,
    "override_total_1": 14738.39,
    "override_increase_1": 406.65
  },
  {
    "#": "11 Longwood Ave, Unit 303 P17&18 (162-01-06)",
    "$": 1644600,
    "address": "11 Longwood Ave, Unit 303 P17&18",
    "parcel_id": "162-01-06",
    "owner1": "CLARK, ALICE L",
    "owner2": "MARTENS, JOHN A",
    "current_taxes": 13205.77,
    "new_taxes_no_override": 13776.26,
    "override_total_1": 14167.15,
    "override_increase_1": 390.89
  },
  {
    "#": "11 Longwood Ave, Unit Ph1 & P1P8  (162-01-07)",
    "$": 1735900,
    "address": "11 Longwood Ave, Unit Ph1 & P1P8 ",
    "parcel_id": "162-01-07",
    "owner1": "KANTOR, LISA",
    "owner2": "",
    "current_taxes": 14140.68,
    "new_taxes_no_override": 14751.56,
    "override_total_1": 15170.12,
    "override_increase_1": 418.56
  },
  {
    "#": "11 Longwood Ave, Unit Ph2 P5-6-7 (162-01-08)",
    "$": 1743100,
    "address": "11 Longwood Ave, Unit Ph2 P5-6-7",
    "parcel_id": "162-01-08",
    "owner1": "LUU, TR, GEORGE V H",
    "owner2": "",
    "current_taxes": 17849.34,
    "new_taxes_no_override": 18620.43,
    "override_total_1": 19148.77,
    "override_increase_1": 528.34
  },
  {
    "#": "11 Longwood Ave, Unit Ph3 P3 P9 (162-01-09)",
    "$": 1696600,
    "address": "11 Longwood Ave, Unit Ph3 P3 P9",
    "parcel_id": "162-01-09",
    "owner1": "AGARWAL, PRASUN",
    "owner2": "AGGARWAL, NIDHI",
    "current_taxes": 17373.18,
    "new_taxes_no_override": 18123.7,
    "override_total_1": 18637.95,
    "override_increase_1": 514.25
  },
  {
    "#": "21 Longwood Ave (158-11-00)",
    "$": 4399400,
    "address": "21 Longwood Ave",
    "parcel_id": "158-11-00",
    "owner1": "CLAYSTONE LLC",
    "owner2": "",
    "current_taxes": 75493.7,
    "new_taxes_no_override": 78755.03,
    "override_total_1": 80989.64,
    "override_increase_1": 2234.61
  },
  {
    "#": "27 Longwood Ave (158-12-00)",
    "$": 2518000,
    "address": "27 Longwood Ave",
    "parcel_id": "158-12-00",
    "owner1": "MARJORAM LLC",
    "owner2": "C/O MCCARTHY LEGAL SERVICES",
    "current_taxes": 25784.32,
    "new_taxes_no_override": 26898.2,
    "override_total_1": 27661.42,
    "override_increase_1": 763.22
  },
  {
    "#": "29 Longwood Ave (158-13-00)",
    "$": 2198200,
    "address": "29 Longwood Ave",
    "parcel_id": "158-13-00",
    "owner1": "MARJORAM LLC",
    "owner2": "C/O MCCARTHY LEGAL SERVICES",
    "current_taxes": 22509.57,
    "new_taxes_no_override": 23481.98,
    "override_total_1": 24148.27,
    "override_increase_1": 666.28
  },
  {
    "#": "30 Longwood Ave, Unit 101 & P19 (159-01-01)",
    "$": 1259100,
    "address": "30 Longwood Ave, Unit 101 & P19",
    "parcel_id": "159-01-01",
    "owner1": "HALLAL TRS, EZZAT SAMIH & LANA SUBHI",
    "owner2": "",
    "current_taxes": 12893.18,
    "new_taxes_no_override": 13450.17,
    "override_total_1": 13831.8,
    "override_increase_1": 381.64
  },
  {
    "#": "30 Longwood Ave, Unit 102 & P1 (159-01-02)",
    "$": 1521600,
    "address": "30 Longwood Ave, Unit 102 & P1",
    "parcel_id": "159-01-02",
    "owner1": "CHENG, CHIEN YEE CINDY",
    "owner2": "",
    "current_taxes": 15581.18,
    "new_taxes_no_override": 16254.29,
    "override_total_1": 16715.49,
    "override_increase_1": 461.2
  },
  {
    "#": "30 Longwood Ave, Unit 103 G7-P23 (159-01-03)",
    "$": 1526600,
    "address": "30 Longwood Ave, Unit 103 G7-P23",
    "parcel_id": "159-01-03",
    "owner1": "WOLFMAN TR, ILENE S",
    "owner2": "",
    "current_taxes": 11997.45,
    "new_taxes_no_override": 12515.74,
    "override_total_1": 12870.86,
    "override_increase_1": 355.12
  },
  {
    "#": "30 Longwood Ave, Unit 104 & P18 (159-01-04)",
    "$": 1403900,
    "address": "30 Longwood Ave, Unit 104 & P18",
    "parcel_id": "159-01-04",
    "owner1": "BERLOFF TRS, ANDREA & HOWARD A & MYRA K",
    "owner2": "",
    "current_taxes": 10741.0,
    "new_taxes_no_override": 11205.01,
    "override_total_1": 11522.94,
    "override_increase_1": 317.93
  },
  {
    "#": "30 Longwood Ave, Unit 201 & P6 (159-01-05)",
    "$": 1369800,
    "address": "30 Longwood Ave, Unit 201 & P6",
    "parcel_id": "159-01-05",
    "owner1": "LIEBOW TRS, ELIZABETH A",
    "owner2": "ROGOVIN, PETER H",
    "current_taxes": 14026.75,
    "new_taxes_no_override": 14632.71,
    "override_total_1": 15047.9,
    "override_increase_1": 415.19
  },
  {
    "#": "30 Longwood Ave, Unit 202 & P8 (159-01-06)",
    "$": 1485600,
    "address": "30 Longwood Ave, Unit 202 & P8",
    "parcel_id": "159-01-06",
    "owner1": "DESFOSSES, KEITH O",
    "owner2": "EDWARDS, OWEN",
    "current_taxes": 11577.61,
    "new_taxes_no_override": 12077.76,
    "override_total_1": 12420.46,
    "override_increase_1": 342.7
  },
  {
    "#": "30 Longwood Ave, Unit 203 G9-G10 (159-01-07)",
    "$": 1614400,
    "address": "30 Longwood Ave, Unit 203 G9-G10",
    "parcel_id": "159-01-07",
    "owner1": "AGRESTI TRS, ALAN",
    "owner2": "LEVINE, JACALYN",
    "current_taxes": 16531.46,
    "new_taxes_no_override": 17245.62,
    "override_total_1": 17734.95,
    "override_increase_1": 489.33
  },
  {
    "#": "30 Longwood Ave, Unit 204 P20&21 (159-01-08)",
    "$": 1484400,
    "address": "30 Longwood Ave, Unit 204 P20&21",
    "parcel_id": "159-01-08",
    "owner1": "BELLAR TRS, ROSS S",
    "owner2": "WONG, DAVID J",
    "current_taxes": 11565.32,
    "new_taxes_no_override": 12064.94,
    "override_total_1": 12407.28,
    "override_increase_1": 342.33
  },
  {
    "#": "30 Longwood Ave, Unit 301 & P4 (159-01-09)",
    "$": 1396200,
    "address": "30 Longwood Ave, Unit 301 & P4",
    "parcel_id": "159-01-09",
    "owner1": "SPARROW, DAVID W",
    "owner2": "",
    "current_taxes": 10662.15,
    "new_taxes_no_override": 11122.75,
    "override_total_1": 11438.35,
    "override_increase_1": 315.6
  },
  {
    "#": "30 Longwood Ave, Unit 302 & P11 (159-01-10)",
    "$": 1486900,
    "address": "30 Longwood Ave, Unit 302 & P11",
    "parcel_id": "159-01-10",
    "owner1": "ADAMS TR, FRANCES S",
    "owner2": "",
    "current_taxes": 15225.86,
    "new_taxes_no_override": 15883.62,
    "override_total_1": 16334.3,
    "override_increase_1": 450.69
  },
  {
    "#": "30 Longwood Ave, Unit 303 P2 P3 (159-01-11)",
    "$": 1623400,
    "address": "30 Longwood Ave, Unit 303 P2 P3",
    "parcel_id": "159-01-11",
    "owner1": "RABINOVITZ TRS, MICHAEL & HELEN",
    "owner2": "",
    "current_taxes": 12988.68,
    "new_taxes_no_override": 13549.79,
    "override_total_1": 13934.26,
    "override_increase_1": 384.46
  },
  {
    "#": "30 Longwood Ave, Unit 304 P14&15 (159-01-12)",
    "$": 1493400,
    "address": "30 Longwood Ave, Unit 304 P14&15",
    "parcel_id": "159-01-12",
    "owner1": "ALI-HASSAN TRS, AMINE & MARIE-JEANNE",
    "owner2": "",
    "current_taxes": 15292.42,
    "new_taxes_no_override": 15953.05,
    "override_total_1": 16405.71,
    "override_increase_1": 452.66
  },
  {
    "#": "30 Longwood Ave, Unit 401 P16&17 (159-01-13)",
    "$": 1660800,
    "address": "30 Longwood Ave, Unit 401 P16&17",
    "parcel_id": "159-01-13",
    "owner1": "KRAMER, EVELYNNE",
    "owner2": "",
    "current_taxes": 13371.66,
    "new_taxes_no_override": 13949.32,
    "override_total_1": 14345.12,
    "override_increase_1": 395.8
  },
  {
    "#": "30 Longwood Ave, Unit 402 (159-01-14)",
    "$": 1770700,
    "address": "30 Longwood Ave, Unit 402",
    "parcel_id": "159-01-14",
    "owner1": "DARISH FAMILY LP",
    "owner2": "",
    "current_taxes": 18131.97,
    "new_taxes_no_override": 18915.27,
    "override_total_1": 19451.98,
    "override_increase_1": 536.71
  },
  {
    "#": "30 Longwood Ave, Unit 403 P5 P22 (159-01-15)",
    "$": 2142600,
    "address": "30 Longwood Ave, Unit 403 P5 P22",
    "parcel_id": "159-01-15",
    "owner1": "KOBATA, HIROSHI & CHIYUKI",
    "owner2": "",
    "current_taxes": 18305.29,
    "new_taxes_no_override": 19096.08,
    "override_total_1": 19637.92,
    "override_increase_1": 541.84
  },
  {
    "#": "31 Longwood Ave (158-14-00)",
    "$": 2198200,
    "address": "31 Longwood Ave",
    "parcel_id": "158-14-00",
    "owner1": "MARJORAM LLC",
    "owner2": "C/O MCCARTHY LEGAL SERVICES",
    "current_taxes": 22509.57,
    "new_taxes_no_override": 23481.98,
    "override_total_1": 24148.27,
    "override_increase_1": 666.28
  },
  {
    "#": "33 Longwood Ave, Unit 1 (158-15-03)",
    "$": 830400,
    "address": "33 Longwood Ave, Unit 1",
    "parcel_id": "158-15-03",
    "owner1": "CAVALLACCI, GABRIELLE",
    "owner2": "",
    "current_taxes": 4868.36,
    "new_taxes_no_override": 5078.67,
    "override_total_1": 5222.78,
    "override_increase_1": 144.1
  },
  {
    "#": "33 Longwood Ave, Unit 2 (158-15-01)",
    "$": 757100,
    "address": "33 Longwood Ave, Unit 2",
    "parcel_id": "158-15-01",
    "owner1": "KAPLAN, BRIAN S",
    "owner2": "REAGAN, BETH M",
    "current_taxes": 7752.7,
    "new_taxes_no_override": 8087.62,
    "override_total_1": 8317.1,
    "override_increase_1": 229.48
  },
  {
    "#": "33 Longwood Ave, Unit 3 (158-15-02)",
    "$": 764700,
    "address": "33 Longwood Ave, Unit 3",
    "parcel_id": "158-15-02",
    "owner1": "MULGREW LLC",
    "owner2": "",
    "current_taxes": 7830.53,
    "new_taxes_no_override": 8168.81,
    "override_total_1": 8400.59,
    "override_increase_1": 231.78
  },
  {
    "#": "36 Longwood Ave, Unit 1 & G7- G15C (159-12-01)",
    "$": 1376600,
    "address": "36 Longwood Ave, Unit 1 & G7- G15C",
    "parcel_id": "159-12-01",
    "owner1": "ARIES GENERATION LLC",
    "owner2": "",
    "current_taxes": 14096.38,
    "new_taxes_no_override": 14705.34,
    "override_total_1": 15122.6,
    "override_increase_1": 417.25
  },
  {
    "#": "36 Longwood Ave, Unit 2 & G5C-6C (159-12-02)",
    "$": 1376300,
    "address": "36 Longwood Ave, Unit 2 & G5C-6C",
    "parcel_id": "159-12-02",
    "owner1": "AQUARIUS GENERATION LLC",
    "owner2": "",
    "current_taxes": 14093.31,
    "new_taxes_no_override": 14702.14,
    "override_total_1": 15119.3,
    "override_increase_1": 417.16
  },
  {
    "#": "36 Longwood Ave, Unit 3 & G9-10 (159-12-03)",
    "$": 1557700,
    "address": "36 Longwood Ave, Unit 3 & G9-10",
    "parcel_id": "159-12-03",
    "owner1": "HUR, YONG",
    "owner2": "OGATA, YUMI",
    "current_taxes": 12315.91,
    "new_taxes_no_override": 12847.96,
    "override_total_1": 13212.51,
    "override_increase_1": 364.55
  },
  {
    "#": "36 Longwood Ave, Unit 4 & G1C-2C (159-12-04)",
    "$": 1577700,
    "address": "36 Longwood Ave, Unit 4 & G1C-2C",
    "parcel_id": "159-12-04",
    "owner1": "KAMIN, CAROL S",
    "owner2": "",
    "current_taxes": 12520.71,
    "new_taxes_no_override": 13061.6,
    "override_total_1": 13432.22,
    "override_increase_1": 370.61
  },
  {
    "#": "36 Longwood Ave, Unit 5 & G11-12 (159-12-05)",
    "$": 2862100,
    "address": "36 Longwood Ave, Unit 5 & G11-12",
    "parcel_id": "159-12-05",
    "owner1": "COLLIER, JOYCE L",
    "owner2": "POTTER, JENNIFER E",
    "current_taxes": 29307.9,
    "new_taxes_no_override": 30574.0,
    "override_total_1": 31441.52,
    "override_increase_1": 867.51
  },
  {
    "#": "36 Longwood Ave, Unit 6 & G4C-8 (159-12-06)",
    "$": 2862100,
    "address": "36 Longwood Ave, Unit 6 & G4C-8",
    "parcel_id": "159-12-06",
    "owner1": "BECHHOFER TRS, DAVID J",
    "owner2": "NEAVE, KATHERINE F",
    "current_taxes": 25672.97,
    "new_taxes_no_override": 26782.04,
    "override_total_1": 27541.96,
    "override_increase_1": 759.92
  },
  {
    "#": "36 Longwood Ave, Unit 7 & G3C-13-14 (159-12-07)",
    "$": 2954000,
    "address": "36 Longwood Ave, Unit 7 & G3C-13-14",
    "parcel_id": "159-12-07",
    "owner1": "DU, ROSE",
    "owner2": "",
    "current_taxes": 26614.03,
    "new_taxes_no_override": 27763.76,
    "override_total_1": 28551.53,
    "override_increase_1": 787.78
  },
  {
    "#": "40 Longwood Ave (159-11-00)",
    "$": 14426300,
    "address": "40 Longwood Ave",
    "parcel_id": "159-11-00",
    "owner1": "R & M W LIMITED PARTNERSHIP",
    "owner2": "C/O ROSA WOOD REALTY TR MGMT, ATTN PAULA WOOD DYER",
    "current_taxes": 147725.31,
    "new_taxes_no_override": 154107.04,
    "override_total_1": 158479.71,
    "override_increase_1": 4372.67
  },
  {
    "#": "45 Longwood Ave, Unit 101 & P166 (158-16-01)",
    "$": 713800,
    "address": "45 Longwood Ave, Unit 101 & P166",
    "parcel_id": "158-16-01",
    "owner1": "ZHU, CHUNYAN",
    "owner2": "",
    "current_taxes": 3674.38,
    "new_taxes_no_override": 3833.11,
    "override_total_1": 3941.87,
    "override_increase_1": 108.76
  },
  {
    "#": "45 Longwood Ave, Unit 102 & G17 (158-16-02)",
    "$": 861900,
    "address": "45 Longwood Ave, Unit 102 & G17",
    "parcel_id": "158-16-02",
    "owner1": "RUSSOTTO, ALINE",
    "owner2": "",
    "current_taxes": 5190.92,
    "new_taxes_no_override": 5415.17,
    "override_total_1": 5568.82,
    "override_increase_1": 153.65
  },
  {
    "#": "45 Longwood Ave, Unit 103 & P173 (158-16-03)",
    "$": 373500,
    "address": "45 Longwood Ave, Unit 103 & P173",
    "parcel_id": "158-16-03",
    "owner1": "MIRANDA-NAON TR, ALEJANDRA",
    "owner2": "",
    "current_taxes": 3824.64,
    "new_taxes_no_override": 3989.86,
    "override_total_1": 4103.07,
    "override_increase_1": 113.21
  },
  {
    "#": "45 Longwood Ave, Unit 104 & P153 (158-16-04)",
    "$": 763800,
    "address": "45 Longwood Ave, Unit 104 & P153",
    "parcel_id": "158-16-04",
    "owner1": "ALLEN, HARVEY & SARRA & MELISSA",
    "owner2": "",
    "current_taxes": 4186.38,
    "new_taxes_no_override": 4367.23,
    "override_total_1": 4491.15,
    "override_increase_1": 123.92
  },
  {
    "#": "45 Longwood Ave, Unit 105 & P182 (158-16-05)",
    "$": 730000,
    "address": "45 Longwood Ave, Unit 105 & P182",
    "parcel_id": "158-16-05",
    "owner1": "SOLOMON, LOIS",
    "owner2": "",
    "current_taxes": 3840.27,
    "new_taxes_no_override": 4006.17,
    "override_total_1": 4119.84,
    "override_increase_1": 113.67
  },
  {
    "#": "45 Longwood Ave, Unit 107 & P99 (158-16-06)",
    "$": 1130300,
    "address": "45 Longwood Ave, Unit 107 & P99",
    "parcel_id": "158-16-06",
    "owner1": "MATERA, BARBARA",
    "owner2": "",
    "current_taxes": 11574.27,
    "new_taxes_no_override": 12074.28,
    "override_total_1": 12416.88,
    "override_increase_1": 342.6
  },
  {
    "#": "45 Longwood Ave, Unit 108 & P15 (158-16-07)",
    "$": 821000,
    "address": "45 Longwood Ave, Unit 108 & P15",
    "parcel_id": "158-16-07",
    "owner1": "WINIKER, WILLIAM J",
    "owner2": "",
    "current_taxes": 4772.11,
    "new_taxes_no_override": 4978.27,
    "override_total_1": 5119.52,
    "override_increase_1": 141.25
  },
  {
    "#": "45 Longwood Ave, Unit 109 & P170 (158-16-08)",
    "$": 373500,
    "address": "45 Longwood Ave, Unit 109 & P170",
    "parcel_id": "158-16-08",
    "owner1": "KAUFMAN, PETER",
    "owner2": "",
    "current_taxes": 3824.64,
    "new_taxes_no_override": 3989.86,
    "override_total_1": 4103.07,
    "override_increase_1": 113.21
  },
  {
    "#": "45 Longwood Ave, Unit 110 & P143 (158-16-09)",
    "$": 820000,
    "address": "45 Longwood Ave, Unit 110 & P143",
    "parcel_id": "158-16-09",
    "owner1": "ISHIZAWA, YUMIKO",
    "owner2": "",
    "current_taxes": 4761.87,
    "new_taxes_no_override": 4967.58,
    "override_total_1": 5108.53,
    "override_increase_1": 140.95
  },
  {
    "#": "45 Longwood Ave, Unit 111 & G4 (158-16-10)",
    "$": 920000,
    "address": "45 Longwood Ave, Unit 111 & G4",
    "parcel_id": "158-16-10",
    "owner1": "SEN, MAYA & SUSAN",
    "owner2": "",
    "current_taxes": 5785.87,
    "new_taxes_no_override": 6035.82,
    "override_total_1": 6207.08,
    "override_increase_1": 171.26
  },
  {
    "#": "45 Longwood Ave, Unit 112 & P159 (158-16-11)",
    "$": 517200,
    "address": "45 Longwood Ave, Unit 112 & P159",
    "parcel_id": "158-16-11",
    "owner1": "KAPLAN, LAWRENCE E",
    "owner2": "",
    "current_taxes": 5296.13,
    "new_taxes_no_override": 5524.92,
    "override_total_1": 5681.69,
    "override_increase_1": 156.77
  },
  {
    "#": "45 Longwood Ave, Unit 201 & G37 (158-16-12)",
    "$": 732500,
    "address": "45 Longwood Ave, Unit 201 & G37",
    "parcel_id": "158-16-12",
    "owner1": "LIPINER, FRANK",
    "owner2": "ANDRADE, DAVID B",
    "current_taxes": 3865.87,
    "new_taxes_no_override": 4032.88,
    "override_total_1": 4147.31,
    "override_increase_1": 114.43
  },
  {
    "#": "45 Longwood Ave, Unit 202 & P150 (158-16-13)",
    "$": 820400,
    "address": "45 Longwood Ave, Unit 202 & P150",
    "parcel_id": "158-16-13",
    "owner1": "LYNN, PAMELA W",
    "owner2": "BENSON, MARTIN Y",
    "current_taxes": 4765.96,
    "new_taxes_no_override": 4971.85,
    "override_total_1": 5112.92,
    "override_increase_1": 141.07
  },
  {
    "#": "45 Longwood Ave, Unit 203 & P149 (158-16-14)",
    "$": 402600,
    "address": "45 Longwood Ave, Unit 203 & P149",
    "parcel_id": "158-16-14",
    "owner1": "GONZALEZ, AMMY D",
    "owner2": "",
    "current_taxes": 487.69,
    "new_taxes_no_override": 508.76,
    "override_total_1": 523.19,
    "override_increase_1": 14.44
  },
  {
    "#": "45 Longwood Ave, Unit 204 & P176 (158-16-15)",
    "$": 786800,
    "address": "45 Longwood Ave, Unit 204 & P176",
    "parcel_id": "158-16-15",
    "owner1": "MANILOV, YURY & SOPHIA",
    "owner2": "",
    "current_taxes": 4421.9,
    "new_taxes_no_override": 4612.93,
    "override_total_1": 4743.81,
    "override_increase_1": 130.89
  },
  {
    "#": "45 Longwood Ave, Unit 205 & G-2 (158-16-16)",
    "$": 901400,
    "address": "45 Longwood Ave, Unit 205 & G-2",
    "parcel_id": "158-16-16",
    "owner1": "MEHRTASH, MAJID",
    "owner2": "EMAMI, NASTARAN",
    "current_taxes": 5595.4,
    "new_taxes_no_override": 5837.12,
    "override_total_1": 6002.75,
    "override_increase_1": 165.62
  },
  {
    "#": "45 Longwood Ave, Unit 206 & P177 (158-16-17)",
    "$": 680400,
    "address": "45 Longwood Ave, Unit 206 & P177",
    "parcel_id": "158-16-17",
    "owner1": "WAXMAN TRS, SHEILA & DAVID J",
    "owner2": "",
    "current_taxes": 6967.3,
    "new_taxes_no_override": 7268.29,
    "override_total_1": 7474.52,
    "override_increase_1": 206.23
  },
  {
    "#": "45 Longwood Ave, Unit 207 & P103 (158-16-18)",
    "$": 724300,
    "address": "45 Longwood Ave, Unit 207 & P103",
    "parcel_id": "158-16-18",
    "owner1": "MUIR, GERALDINE M",
    "owner2": "",
    "current_taxes": 7416.83,
    "new_taxes_no_override": 7737.24,
    "override_total_1": 7956.78,
    "override_increase_1": 219.54
  },
  {
    "#": "45 Longwood Ave, Unit 208 & P142 (158-16-19)",
    "$": 821800,
    "address": "45 Longwood Ave, Unit 208 & P142",
    "parcel_id": "158-16-19",
    "owner1": "CHENG, YU-TING",
    "owner2": "",
    "current_taxes": 4780.3,
    "new_taxes_no_override": 4986.81,
    "override_total_1": 5128.31,
    "override_increase_1": 141.5
  },
  {
    "#": "45 Longwood Ave, Unit 209 & P184 (158-16-20)",
    "$": 391000,
    "address": "45 Longwood Ave, Unit 209 & P184",
    "parcel_id": "158-16-20",
    "owner1": "WEI, LAN",
    "owner2": "",
    "current_taxes": 4003.84,
    "new_taxes_no_override": 4176.81,
    "override_total_1": 4295.32,
    "override_increase_1": 118.51
  },
  {
    "#": "45 Longwood Ave, Unit 210 & G24 (158-16-21)",
    "$": 826300,
    "address": "45 Longwood Ave, Unit 210 & G24",
    "parcel_id": "158-16-21",
    "owner1": "TAYCHER, LEONID & KATYA & SAMUIL  & LILIYA",
    "owner2": "",
    "current_taxes": 4826.38,
    "new_taxes_no_override": 5034.88,
    "override_total_1": 5177.74,
    "override_increase_1": 142.86
  },
  {
    "#": "45 Longwood Ave, Unit 211 & P156 (158-16-22)",
    "$": 861100,
    "address": "45 Longwood Ave, Unit 211 & P156",
    "parcel_id": "158-16-22",
    "owner1": "KOMINSKY, NEIL",
    "owner2": "FRANK, DEBORAH",
    "current_taxes": 5182.73,
    "new_taxes_no_override": 5406.62,
    "override_total_1": 5560.03,
    "override_increase_1": 153.41
  },
  {
    "#": "45 Longwood Ave, Unit 212 & G8 (158-16-23)",
    "$": 726200,
    "address": "45 Longwood Ave, Unit 212 & G8",
    "parcel_id": "158-16-23",
    "owner1": "ZHANG, ENYA & LIANG",
    "owner2": "CHENG, HSIULAN",
    "current_taxes": 7436.29,
    "new_taxes_no_override": 7757.54,
    "override_total_1": 7977.65,
    "override_increase_1": 220.11
  },
  {
    "#": "45 Longwood Ave, Unit 301 & G16 (158-16-24)",
    "$": 719500,
    "address": "45 Longwood Ave, Unit 301 & G16",
    "parcel_id": "158-16-24",
    "owner1": "WANG, RUI",
    "owner2": "VINEGONI, CLAUDIO",
    "current_taxes": 3732.75,
    "new_taxes_no_override": 3894.0,
    "override_total_1": 4004.49,
    "override_increase_1": 110.49
  },
  {
    "#": "45 Longwood Ave, Unit 302 13&140 (158-16-25)",
    "$": 917200,
    "address": "45 Longwood Ave, Unit 302 13&140",
    "parcel_id": "158-16-25",
    "owner1": "KRAMER TRS, MATTHEW B & GAIL M",
    "owner2": "",
    "current_taxes": 5757.19,
    "new_taxes_no_override": 6005.9,
    "override_total_1": 6176.31,
    "override_increase_1": 170.41
  },
  {
    "#": "45 Longwood Ave, Unit 303 & P180 (158-16-26)",
    "$": 404300,
    "address": "45 Longwood Ave, Unit 303 & P180",
    "parcel_id": "158-16-26",
    "owner1": "ELLIN, TR, BARBARA J",
    "owner2": "",
    "current_taxes": 4140.03,
    "new_taxes_no_override": 4318.88,
    "override_total_1": 4441.42,
    "override_increase_1": 122.54
  },
  {
    "#": "45 Longwood Ave, Unit 304 & G26 (158-16-27)",
    "$": 851800,
    "address": "45 Longwood Ave, Unit 304 & G26",
    "parcel_id": "158-16-27",
    "owner1": "FITZGERALD, GREGORY & AMY",
    "owner2": "",
    "current_taxes": 5087.5,
    "new_taxes_no_override": 5307.28,
    "override_total_1": 5457.87,
    "override_increase_1": 150.59
  },
  {
    "#": "45 Longwood Ave, Unit 305 & P181 (158-16-28)",
    "$": 853700,
    "address": "45 Longwood Ave, Unit 305 & P181",
    "parcel_id": "158-16-28",
    "owner1": "KOZOL TRS, CLARA BARBARA & ERIC JOHN",
    "owner2": "",
    "current_taxes": 5106.95,
    "new_taxes_no_override": 5327.57,
    "override_total_1": 5478.74,
    "override_increase_1": 151.17
  },
  {
    "#": "45 Longwood Ave, Unit 306 (158-16-29)",
    "$": 635600,
    "address": "45 Longwood Ave, Unit 306",
    "parcel_id": "158-16-29",
    "owner1": "KAUFMAN, PETER",
    "owner2": "",
    "current_taxes": 2873.61,
    "new_taxes_no_override": 2997.75,
    "override_total_1": 3082.81,
    "override_increase_1": 85.06
  },
  {
    "#": "45 Longwood Ave, Unit 307 & P193 (158-16-30)",
    "$": 705900,
    "address": "45 Longwood Ave, Unit 307 & P193",
    "parcel_id": "158-16-30",
    "owner1": "GLICK, ARNOLD R",
    "owner2": "",
    "current_taxes": 3593.48,
    "new_taxes_no_override": 3748.72,
    "override_total_1": 3855.09,
    "override_increase_1": 106.37
  },
  {
    "#": "45 Longwood Ave, Unit 308 & G20 (158-16-31)",
    "$": 837100,
    "address": "45 Longwood Ave, Unit 308 & G20",
    "parcel_id": "158-16-31",
    "owner1": "VINOKUR, OLEG",
    "owner2": "",
    "current_taxes": 4936.97,
    "new_taxes_no_override": 5150.25,
    "override_total_1": 5296.38,
    "override_increase_1": 146.13
  },
  {
    "#": "45 Longwood Ave, Unit 309 & P191 (158-16-32)",
    "$": 414800,
    "address": "45 Longwood Ave, Unit 309 & P191",
    "parcel_id": "158-16-32",
    "owner1": "FARRELL, COLLEEN M",
    "owner2": "",
    "current_taxes": 612.62,
    "new_taxes_no_override": 639.09,
    "override_total_1": 657.22,
    "override_increase_1": 18.13
  },
  {
    "#": "45 Longwood Ave, Unit 310 & P190 (158-16-33)",
    "$": 821200,
    "address": "45 Longwood Ave, Unit 310 & P190",
    "parcel_id": "158-16-33",
    "owner1": "KANG, YOON JUN",
    "owner2": "LEE, EUN KYUNG",
    "current_taxes": 4774.15,
    "new_taxes_no_override": 4980.39,
    "override_total_1": 5121.71,
    "override_increase_1": 141.31
  },
  {
    "#": "45 Longwood Ave, Unit 311 & G29 (158-16-34)",
    "$": 984700,
    "address": "45 Longwood Ave, Unit 311 & G29",
    "parcel_id": "158-16-34",
    "owner1": "LACY, ELIZABETHANN M",
    "owner2": "",
    "current_taxes": 6448.39,
    "new_taxes_no_override": 6726.96,
    "override_total_1": 6917.83,
    "override_increase_1": 190.87
  },
  {
    "#": "45 Longwood Ave, Unit 312 & P178 (158-16-35)",
    "$": 690900,
    "address": "45 Longwood Ave, Unit 312 & P178",
    "parcel_id": "158-16-35",
    "owner1": "BLACKMAN, ETHEL",
    "owner2": "",
    "current_taxes": 3439.88,
    "new_taxes_no_override": 3588.48,
    "override_total_1": 3690.3,
    "override_increase_1": 101.82
  },
  {
    "#": "45 Longwood Ave, Unit 401 & P157 (158-16-36)",
    "$": 695400,
    "address": "45 Longwood Ave, Unit 401 & P157",
    "parcel_id": "158-16-36",
    "owner1": "GOGOL, REGINA",
    "owner2": "",
    "current_taxes": 3485.96,
    "new_taxes_no_override": 3636.55,
    "override_total_1": 3739.74,
    "override_increase_1": 103.18
  },
  {
    "#": "45 Longwood Ave, Unit 402 & P188 (158-16-37)",
    "$": 820400,
    "address": "45 Longwood Ave, Unit 402 & P188",
    "parcel_id": "158-16-37",
    "owner1": "PARITSKY, ALEXANDER & YELENA",
    "owner2": "",
    "current_taxes": 4765.96,
    "new_taxes_no_override": 4971.85,
    "override_total_1": 5112.92,
    "override_increase_1": 141.07
  },
  {
    "#": "45 Longwood Ave, Unit 403 & P155 (158-16-38)",
    "$": 404300,
    "address": "45 Longwood Ave, Unit 403 & P155",
    "parcel_id": "158-16-38",
    "owner1": "GOLDSTEIN, DAVID",
    "owner2": "",
    "current_taxes": 4140.03,
    "new_taxes_no_override": 4318.88,
    "override_total_1": 4441.42,
    "override_increase_1": 122.54
  },
  {
    "#": "45 Longwood Ave, Unit 404 & 2 Pk (158-16-39)",
    "$": 922900,
    "address": "45 Longwood Ave, Unit 404 & 2 Pk",
    "parcel_id": "158-16-39",
    "owner1": "MINDESS, MARY",
    "owner2": "C/O KAREN WALDSTEIN",
    "current_taxes": 9450.5,
    "new_taxes_no_override": 9858.76,
    "override_total_1": 10138.5,
    "override_increase_1": 279.73
  },
  {
    "#": "45 Longwood Ave, Unit 405 & 2 Pk (158-16-40)",
    "$": 1024000,
    "address": "45 Longwood Ave, Unit 405 & 2 Pk",
    "parcel_id": "158-16-40",
    "owner1": "ST PAUL TRS, NADEGE",
    "owner2": "SCHLEIPMAN, ARTHUR ROBERT",
    "current_taxes": 6850.83,
    "new_taxes_no_override": 7146.79,
    "override_total_1": 7349.57,
    "override_increase_1": 202.78
  },
  {
    "#": "45 Longwood Ave, Unit 406 & P163 (158-16-41)",
    "$": 692000,
    "address": "45 Longwood Ave, Unit 406 & P163",
    "parcel_id": "158-16-41",
    "owner1": "NG, EVA YEE WAH",
    "owner2": "",
    "current_taxes": 3451.15,
    "new_taxes_no_override": 3600.24,
    "override_total_1": 3702.39,
    "override_increase_1": 102.15
  },
  {
    "#": "45 Longwood Ave, Unit 407 & P100 (158-16-42)",
    "$": 731400,
    "address": "45 Longwood Ave, Unit 407 & P100",
    "parcel_id": "158-16-42",
    "owner1": "GOLDMAN TR, ROBERT P",
    "owner2": "",
    "current_taxes": 7489.54,
    "new_taxes_no_override": 7813.09,
    "override_total_1": 8034.78,
    "override_increase_1": 221.69
  },
  {
    "#": "45 Longwood Ave, Unit 408 & P168 (158-16-43)",
    "$": 797600,
    "address": "45 Longwood Ave, Unit 408 & P168",
    "parcel_id": "158-16-43",
    "owner1": "KLAPHOLTZ, HENRY & MADELYN",
    "owner2": "",
    "current_taxes": 8167.42,
    "new_taxes_no_override": 8520.25,
    "override_total_1": 8762.01,
    "override_increase_1": 241.76
  },
  {
    "#": "45 Longwood Ave, Unit 409 & P101 (158-16-44)",
    "$": 404300,
    "address": "45 Longwood Ave, Unit 409 & P101",
    "parcel_id": "158-16-44",
    "owner1": "SULKIN, ELIZABETH A & ANATOLY M & YELENA Z",
    "owner2": "",
    "current_taxes": 505.1,
    "new_taxes_no_override": 526.92,
    "override_total_1": 541.87,
    "override_increase_1": 14.95
  },
  {
    "#": "45 Longwood Ave, Unit 410 & G40 (158-16-45)",
    "$": 826300,
    "address": "45 Longwood Ave, Unit 410 & G40",
    "parcel_id": "158-16-45",
    "owner1": "MORRIS, DIANE T",
    "owner2": "",
    "current_taxes": 4826.38,
    "new_taxes_no_override": 5034.88,
    "override_total_1": 5177.74,
    "override_increase_1": 142.86
  },
  {
    "#": "45 Longwood Ave, Unit 411 & G11 (158-16-46)",
    "$": 884600,
    "address": "45 Longwood Ave, Unit 411 & G11",
    "parcel_id": "158-16-46",
    "owner1": "CHANG TRS, TEWEN & JANET",
    "owner2": "",
    "current_taxes": 9058.3,
    "new_taxes_no_override": 9449.62,
    "override_total_1": 9717.74,
    "override_increase_1": 268.13
  },
  {
    "#": "45 Longwood Ave, Unit 412 & G10 (158-16-47)",
    "$": 726200,
    "address": "45 Longwood Ave, Unit 412 & G10",
    "parcel_id": "158-16-47",
    "owner1": "BELT, STEPHEN",
    "owner2": "",
    "current_taxes": 3801.35,
    "new_taxes_no_override": 3965.57,
    "override_total_1": 4078.09,
    "override_increase_1": 112.52
  },
  {
    "#": "45 Longwood Ave, Unit 501 & P192 (158-16-48)",
    "$": 695400,
    "address": "45 Longwood Ave, Unit 501 & P192",
    "parcel_id": "158-16-48",
    "owner1": "WANG, SHAONING & RUOING",
    "owner2": "CHENG, JIANXIN",
    "current_taxes": 3485.96,
    "new_taxes_no_override": 3636.55,
    "override_total_1": 3739.74,
    "override_increase_1": 103.18
  },
  {
    "#": "45 Longwood Ave, Unit 502 & P144 (158-16-49)",
    "$": 915200,
    "address": "45 Longwood Ave, Unit 502 & P144",
    "parcel_id": "158-16-49",
    "owner1": "LEBLANC, DONALD & DENISE",
    "owner2": "",
    "current_taxes": 9371.65,
    "new_taxes_no_override": 9776.51,
    "override_total_1": 10053.91,
    "override_increase_1": 277.4
  },
  {
    "#": "45 Longwood Ave, Unit 503 & P98 (158-16-50)",
    "$": 419000,
    "address": "45 Longwood Ave, Unit 503 & P98",
    "parcel_id": "158-16-50",
    "owner1": "LEVY, BENJAMIN",
    "owner2": "",
    "current_taxes": 4290.56,
    "new_taxes_no_override": 4475.91,
    "override_total_1": 4602.91,
    "override_increase_1": 127.0
  },
  {
    "#": "45 Longwood Ave, Unit 504 & G23 (158-16-51)",
    "$": 943000,
    "address": "45 Longwood Ave, Unit 504 & G23",
    "parcel_id": "158-16-51",
    "owner1": "RAMEYEVA TR, LILIYA",
    "owner2": "",
    "current_taxes": 9656.32,
    "new_taxes_no_override": 10073.47,
    "override_total_1": 10359.3,
    "override_increase_1": 285.83
  },
  {
    "#": "45 Longwood Ave, Unit 505& P154-P162 (158-16-52)",
    "$": 1024000,
    "address": "45 Longwood Ave, Unit 505& P154-P162",
    "parcel_id": "158-16-52",
    "owner1": "PELTSMAN, EDWARD & KIMBERLY",
    "owner2": "",
    "current_taxes": 10485.76,
    "new_taxes_no_override": 10938.74,
    "override_total_1": 11249.12,
    "override_increase_1": 310.38
  },
  {
    "#": "45 Longwood Ave, Unit 506 & P158 (158-16-53)",
    "$": 680100,
    "address": "45 Longwood Ave, Unit 506 & P158",
    "parcel_id": "158-16-53",
    "owner1": "506 LLC",
    "owner2": "",
    "current_taxes": 6964.22,
    "new_taxes_no_override": 7265.07,
    "override_total_1": 7471.22,
    "override_increase_1": 206.14
  },
  {
    "#": "45 Longwood Ave, Unit 507 & P160 (158-16-54)",
    "$": 731400,
    "address": "45 Longwood Ave, Unit 507 & P160",
    "parcel_id": "158-16-54",
    "owner1": "CHENG, MARISSA",
    "owner2": "",
    "current_taxes": 3854.6,
    "new_taxes_no_override": 4021.12,
    "override_total_1": 4135.21,
    "override_increase_1": 114.1
  },
  {
    "#": "45 Longwood Ave, Unit 508 & P165 (158-16-55)",
    "$": 813600,
    "address": "45 Longwood Ave, Unit 508 & P165",
    "parcel_id": "158-16-55",
    "owner1": "WINIKER TR, ROBERT A",
    "owner2": "",
    "current_taxes": 4696.33,
    "new_taxes_no_override": 4899.21,
    "override_total_1": 5038.22,
    "override_increase_1": 139.01
  },
  {
    "#": "45 Longwood Ave, Unit 509 & P161 (158-16-56)",
    "$": 404300,
    "address": "45 Longwood Ave, Unit 509 & P161",
    "parcel_id": "158-16-56",
    "owner1": "ZHOU, YIRU",
    "owner2": "",
    "current_taxes": 4140.03,
    "new_taxes_no_override": 4318.88,
    "override_total_1": 4441.42,
    "override_increase_1": 122.54
  },
  {
    "#": "45 Longwood Ave, Unit 510 & P185 (158-16-57)",
    "$": 924300,
    "address": "45 Longwood Ave, Unit 510 & P185",
    "parcel_id": "158-16-57",
    "owner1": "ROSENBAUM, STEPHEN & GRAZIA",
    "owner2": "",
    "current_taxes": 5829.9,
    "new_taxes_no_override": 6081.75,
    "override_total_1": 6254.32,
    "override_increase_1": 172.57
  },
  {
    "#": "45 Longwood Ave, Unit 511 & G3 (158-16-58)",
    "$": 964900,
    "address": "45 Longwood Ave, Unit 511 & G3",
    "parcel_id": "158-16-58",
    "owner1": "SHAFER TR, NANCY L",
    "owner2": "",
    "current_taxes": 6245.64,
    "new_taxes_no_override": 6515.45,
    "override_total_1": 6700.32,
    "override_increase_1": 184.87
  },
  {
    "#": "45 Longwood Ave, Unit 512 & P30 (158-16-59)",
    "$": 729600,
    "address": "45 Longwood Ave, Unit 512 & P30",
    "parcel_id": "158-16-59",
    "owner1": "SEGAL, JEANNE",
    "owner2": "",
    "current_taxes": 7471.1,
    "new_taxes_no_override": 7793.85,
    "override_total_1": 8015.0,
    "override_increase_1": 221.14
  },
  {
    "#": "45 Longwood Ave, Unit 601 & G36 (158-16-60)",
    "$": 820400,
    "address": "45 Longwood Ave, Unit 601 & G36",
    "parcel_id": "158-16-60",
    "owner1": "SURKIS TRS, ANNA",
    "owner2": "LEWINTER, MARGARITA",
    "current_taxes": 4765.96,
    "new_taxes_no_override": 4971.85,
    "override_total_1": 5112.92,
    "override_increase_1": 141.07
  },
  {
    "#": "45 Longwood Ave, Unit 602 G5 G27 (158-16-61)",
    "$": 1000200,
    "address": "45 Longwood Ave, Unit 602 G5 G27",
    "parcel_id": "158-16-61",
    "owner1": "WANG, YUCHEN",
    "owner2": "",
    "current_taxes": 6607.11,
    "new_taxes_no_override": 6892.54,
    "override_total_1": 7088.11,
    "override_increase_1": 195.57
  },
  {
    "#": "45 Longwood Ave, Unit 603 & P194 (158-16-62)",
    "$": 404300,
    "address": "45 Longwood Ave, Unit 603 & P194",
    "parcel_id": "158-16-62",
    "owner1": "KANAREK, JAIME",
    "owner2": "",
    "current_taxes": 4140.03,
    "new_taxes_no_override": 4318.88,
    "override_total_1": 4441.42,
    "override_increase_1": 122.54
  },
  {
    "#": "45 Longwood Ave, Unit 604 & G-39 (158-16-63)",
    "$": 898400,
    "address": "45 Longwood Ave, Unit 604 & G-39",
    "parcel_id": "158-16-63",
    "owner1": "BRILL, JESSICA & ALISSA",
    "owner2": "",
    "current_taxes": 9199.62,
    "new_taxes_no_override": 9597.04,
    "override_total_1": 9869.35,
    "override_increase_1": 272.31
  },
  {
    "#": "45 Longwood Ave, Unit 605 & G18 (158-16-64)",
    "$": 974800,
    "address": "45 Longwood Ave, Unit 605 & G18",
    "parcel_id": "158-16-64",
    "owner1": "TREY, GARY",
    "owner2": "",
    "current_taxes": 9981.95,
    "new_taxes_no_override": 10413.17,
    "override_total_1": 10708.64,
    "override_increase_1": 295.47
  },
  {
    "#": "45 Longwood Ave, Unit 606 & P7 (158-16-65)",
    "$": 684900,
    "address": "45 Longwood Ave, Unit 606 & P7",
    "parcel_id": "158-16-65",
    "owner1": "YANKELEVICH, TATIANA",
    "owner2": "",
    "current_taxes": 7013.38,
    "new_taxes_no_override": 7316.36,
    "override_total_1": 7523.95,
    "override_increase_1": 207.6
  },
  {
    "#": "45 Longwood Ave, Unit 607 & G31 (158-16-66)",
    "$": 845900,
    "address": "45 Longwood Ave, Unit 607 & G31",
    "parcel_id": "158-16-66",
    "owner1": "LISOVSKY, MIKHAIL",
    "owner2": "STAROSELSKAYA, IRINA",
    "current_taxes": 5027.08,
    "new_taxes_no_override": 5244.25,
    "override_total_1": 5393.05,
    "override_increase_1": 148.8
  },
  {
    "#": "45 Longwood Ave, Unit 608 & 2 Pk (158-16-67)",
    "$": 949700,
    "address": "45 Longwood Ave, Unit 608 & 2 Pk",
    "parcel_id": "158-16-67",
    "owner1": "SKALIOTIS, GEORGE & MARILYN",
    "owner2": "",
    "current_taxes": 6089.99,
    "new_taxes_no_override": 6353.08,
    "override_total_1": 6533.34,
    "override_increase_1": 180.26
  },
  {
    "#": "45 Longwood Ave, Unit 609 (158-16-68)",
    "$": 356500,
    "address": "45 Longwood Ave, Unit 609",
    "parcel_id": "158-16-68",
    "owner1": "CUCURULLO, MICHAEL",
    "owner2": "",
    "current_taxes": 365.06,
    "new_taxes_no_override": 380.83,
    "override_total_1": 391.64,
    "override_increase_1": 10.81
  },
  {
    "#": "45 Longwood Ave, Unit 610 & G-6 (158-16-69)",
    "$": 927500,
    "address": "45 Longwood Ave, Unit 610 & G-6",
    "parcel_id": "158-16-69",
    "owner1": "ISLA, DAMIAN",
    "owner2": "FARAGO, JULIA H",
    "current_taxes": 5862.67,
    "new_taxes_no_override": 6115.94,
    "override_total_1": 6289.47,
    "override_increase_1": 173.54
  },
  {
    "#": "45 Longwood Ave, Unit 611 & Pk Sp 9 (158-16-70)",
    "$": 938100,
    "address": "45 Longwood Ave, Unit 611 & Pk Sp 9",
    "parcel_id": "158-16-70",
    "owner1": "KING, KENYON & BATHSHEBA",
    "owner2": "",
    "current_taxes": 9606.14,
    "new_taxes_no_override": 10021.13,
    "override_total_1": 10305.47,
    "override_increase_1": 284.34
  },
  {
    "#": "45 Longwood Ave, Unit 612 & P187 (158-16-71)",
    "$": 702800,
    "address": "45 Longwood Ave, Unit 612 & P187",
    "parcel_id": "158-16-71",
    "owner1": "KALISSKY, LEV & TANYA",
    "owner2": "",
    "current_taxes": 3561.74,
    "new_taxes_no_override": 3715.61,
    "override_total_1": 3821.03,
    "override_increase_1": 105.43
  },
  {
    "#": "45 Longwood Ave, Unit 701 & G-32 (158-16-72)",
    "$": 787400,
    "address": "45 Longwood Ave, Unit 701 & G-32",
    "parcel_id": "158-16-72",
    "owner1": "COLE 3RD, WHITEFOORD R",
    "owner2": "",
    "current_taxes": 8062.98,
    "new_taxes_no_override": 8411.3,
    "override_total_1": 8649.96,
    "override_increase_1": 238.66
  },
  {
    "#": "45 Longwood Ave, Unit 702 & P141 (158-16-73)",
    "$": 896900,
    "address": "45 Longwood Ave, Unit 702 & P141",
    "parcel_id": "158-16-73",
    "owner1": "KAMHOLTZ, SAMUEL & JESSICA",
    "owner2": "",
    "current_taxes": 5549.32,
    "new_taxes_no_override": 5789.05,
    "override_total_1": 5953.31,
    "override_increase_1": 164.26
  },
  {
    "#": "45 Longwood Ave, Unit 703 & P148 (158-16-74)",
    "$": 429900,
    "address": "45 Longwood Ave, Unit 703 & P148",
    "parcel_id": "158-16-74",
    "owner1": "GAUTAM, GAUTAM",
    "owner2": "",
    "current_taxes": 4402.18,
    "new_taxes_no_override": 4592.35,
    "override_total_1": 4722.66,
    "override_increase_1": 130.3
  },
  {
    "#": "45 Longwood Ave, Unit 704 & P164 (158-16-75)",
    "$": 891500,
    "address": "45 Longwood Ave, Unit 704 & P164",
    "parcel_id": "158-16-75",
    "owner1": "WINIKER, WILLIAM",
    "owner2": "",
    "current_taxes": 9128.96,
    "new_taxes_no_override": 9523.33,
    "override_total_1": 9793.55,
    "override_increase_1": 270.22
  },
  {
    "#": "45 Longwood Ave, Unit 705 & P-39 (158-16-76)",
    "$": 974800,
    "address": "45 Longwood Ave, Unit 705 & P-39",
    "parcel_id": "158-16-76",
    "owner1": "KASYANOV, ANDREY",
    "owner2": "",
    "current_taxes": 6347.02,
    "new_taxes_no_override": 6621.21,
    "override_total_1": 6809.08,
    "override_increase_1": 187.87
  },
  {
    "#": "45 Longwood Ave, Unit 706 & P183 (158-16-77)",
    "$": 789700,
    "address": "45 Longwood Ave, Unit 706 & P183",
    "parcel_id": "158-16-77",
    "owner1": "BERMAN TRS, DAVID J & MARY D & DANIEL S",
    "owner2": "",
    "current_taxes": 4451.59,
    "new_taxes_no_override": 4643.9,
    "override_total_1": 4775.67,
    "override_increase_1": 131.77
  },
  {
    "#": "45 Longwood Ave, Unit 707 & P147 (158-16-78)",
    "$": 819200,
    "address": "45 Longwood Ave, Unit 707 & P147",
    "parcel_id": "158-16-78",
    "owner1": "DE CRISTO, PHILLIP J & LISA M",
    "owner2": "",
    "current_taxes": 8388.61,
    "new_taxes_no_override": 8751.0,
    "override_total_1": 8999.3,
    "override_increase_1": 248.3
  },
  {
    "#": "45 Longwood Ave, Unit 708 & G-1 (158-16-79)",
    "$": 954400,
    "address": "45 Longwood Ave, Unit 708 & G-1",
    "parcel_id": "158-16-79",
    "owner1": "GUREVICI, LAZAR & EDITH",
    "owner2": "",
    "current_taxes": 6138.12,
    "new_taxes_no_override": 6403.29,
    "override_total_1": 6584.98,
    "override_increase_1": 181.69
  },
  {
    "#": "45 Longwood Ave, Unit 709 & P102 (158-16-80)",
    "$": 416900,
    "address": "45 Longwood Ave, Unit 709 & P102",
    "parcel_id": "158-16-80",
    "owner1": "FUENMAYOR, PERLA",
    "owner2": "",
    "current_taxes": 634.12,
    "new_taxes_no_override": 661.51,
    "override_total_1": 680.28,
    "override_increase_1": 18.77
  },
  {
    "#": "45 Longwood Ave, Unit 710 & G41 (158-16-81)",
    "$": 963900,
    "address": "45 Longwood Ave, Unit 710 & G41",
    "parcel_id": "158-16-81",
    "owner1": "BEROUKHIM, ASTRID",
    "owner2": "",
    "current_taxes": 6235.4,
    "new_taxes_no_override": 6504.77,
    "override_total_1": 6689.34,
    "override_increase_1": 184.57
  },
  {
    "#": "45 Longwood Ave, Unit 711 & P179 (158-16-82)",
    "$": 1003600,
    "address": "45 Longwood Ave, Unit 711 & P179",
    "parcel_id": "158-16-82",
    "owner1": "GULYANSKY TRS, ALEX",
    "owner2": "GRUMAN, ALLA",
    "current_taxes": 10276.86,
    "new_taxes_no_override": 10720.82,
    "override_total_1": 11025.02,
    "override_increase_1": 304.2
  },
  {
    "#": "45 Longwood Ave, Unit 712 & G22 (158-16-83)",
    "$": 828800,
    "address": "45 Longwood Ave, Unit 712 & G22",
    "parcel_id": "158-16-83",
    "owner1": "BAJAJ, ROHAN",
    "owner2": "",
    "current_taxes": 4851.98,
    "new_taxes_no_override": 5061.59,
    "override_total_1": 5205.2,
    "override_increase_1": 143.62
  },
  {
    "#": "45 Longwood Ave, Unit 801 & P169 (158-16-84)",
    "$": 780000,
    "address": "45 Longwood Ave, Unit 801 & P169",
    "parcel_id": "158-16-84",
    "owner1": "NORMAN, SHARON S",
    "owner2": "WINICKOFF, BETH",
    "current_taxes": 4352.27,
    "new_taxes_no_override": 4540.29,
    "override_total_1": 4669.12,
    "override_increase_1": 128.83
  },
  {
    "#": "45 Longwood Ave, Unit 802 & G19 (158-16-85)",
    "$": 933800,
    "address": "45 Longwood Ave, Unit 802 & G19",
    "parcel_id": "158-16-85",
    "owner1": "COLE, PHILIP",
    "owner2": "ALANI, RHODA M",
    "current_taxes": 9562.11,
    "new_taxes_no_override": 9975.19,
    "override_total_1": 10258.23,
    "override_increase_1": 283.04
  },
  {
    "#": "45 Longwood Ave, Unit 803 & P171 (158-16-86)",
    "$": 435800,
    "address": "45 Longwood Ave, Unit 803 & P171",
    "parcel_id": "158-16-86",
    "owner1": "LISOVSKY, MIKHAIL",
    "owner2": "STAROSELSKAYA, IRINA",
    "current_taxes": 4462.59,
    "new_taxes_no_override": 4655.37,
    "override_total_1": 4787.47,
    "override_increase_1": 132.09
  },
  {
    "#": "45 Longwood Ave, Unit 804 & G14 (158-16-87)",
    "$": 963900,
    "address": "45 Longwood Ave, Unit 804 & G14",
    "parcel_id": "158-16-87",
    "owner1": "KRISHNAMURTHY, MANICKAM & THAIYA",
    "owner2": "",
    "current_taxes": 6235.4,
    "new_taxes_no_override": 6504.77,
    "override_total_1": 6689.34,
    "override_increase_1": 184.57
  },
  {
    "#": "45 Longwood Ave, Unit 805 & P28 (158-16-88)",
    "$": 1028600,
    "address": "45 Longwood Ave, Unit 805 & P28",
    "parcel_id": "158-16-88",
    "owner1": "HASKAL, HAIM & RUTH",
    "owner2": "",
    "current_taxes": 6897.93,
    "new_taxes_no_override": 7195.92,
    "override_total_1": 7400.1,
    "override_increase_1": 204.18
  },
  {
    "#": "45 Longwood Ave, Unit 806 & P189 (158-16-89)",
    "$": 811800,
    "address": "45 Longwood Ave, Unit 806 & P189",
    "parcel_id": "158-16-89",
    "owner1": "KOYA, HIROKO",
    "owner2": "",
    "current_taxes": 4677.9,
    "new_taxes_no_override": 4879.99,
    "override_total_1": 5018.45,
    "override_increase_1": 138.47
  },
  {
    "#": "45 Longwood Ave, Unit 807 & P151 (158-16-90)",
    "$": 819200,
    "address": "45 Longwood Ave, Unit 807 & P151",
    "parcel_id": "158-16-90",
    "owner1": "GOODMAN, ANDREA B",
    "owner2": "",
    "current_taxes": 4753.67,
    "new_taxes_no_override": 4959.03,
    "override_total_1": 5099.74,
    "override_increase_1": 140.71
  },
  {
    "#": "45 Longwood Ave, Unit 808 & G35 (158-16-91)",
    "$": 976200,
    "address": "45 Longwood Ave, Unit 808 & G35",
    "parcel_id": "158-16-91",
    "owner1": "GARTNER TRS, NATHAN H & LEAH",
    "owner2": "",
    "current_taxes": 6361.35,
    "new_taxes_no_override": 6636.16,
    "override_total_1": 6824.46,
    "override_increase_1": 188.3
  },
  {
    "#": "45 Longwood Ave, Unit 809 & P106 (158-16-92)",
    "$": 427000,
    "address": "45 Longwood Ave, Unit 809 & P106",
    "parcel_id": "158-16-92",
    "owner1": "WISHNICK, JOYCE L",
    "owner2": "",
    "current_taxes": 737.55,
    "new_taxes_no_override": 769.41,
    "override_total_1": 791.24,
    "override_increase_1": 21.83
  },
  {
    "#": "45 Longwood Ave, Unit 810 & P21 (158-16-93)",
    "$": 963900,
    "address": "45 Longwood Ave, Unit 810 & P21",
    "parcel_id": "158-16-93",
    "owner1": "LEYBZON, IZRAIL & SOFIA",
    "owner2": "",
    "current_taxes": 6235.4,
    "new_taxes_no_override": 6504.77,
    "override_total_1": 6689.34,
    "override_increase_1": 184.57
  },
  {
    "#": "45 Longwood Ave, Unit 811 & G25 (158-16-94)",
    "$": 1017200,
    "address": "45 Longwood Ave, Unit 811 & G25",
    "parcel_id": "158-16-94",
    "owner1": "FEUER TRS, JERALD C",
    "owner2": "",
    "current_taxes": 6781.19,
    "new_taxes_no_override": 7074.14,
    "override_total_1": 7274.86,
    "override_increase_1": 200.72
  },
  {
    "#": "45 Longwood Ave, Unit 812 & P172 (158-16-95)",
    "$": 788400,
    "address": "45 Longwood Ave, Unit 812 & P172",
    "parcel_id": "158-16-95",
    "owner1": "COHEN TRS, ROBERTA G & MARK S & PETER R",
    "owner2": "",
    "current_taxes": 8073.22,
    "new_taxes_no_override": 8421.98,
    "override_total_1": 8660.95,
    "override_increase_1": 238.97
  },
  {
    "#": "45 Longwood Ave, Unit G-1 & P104 (158-17-01)",
    "$": 619200,
    "address": "45 Longwood Ave, Unit G-1 & P104",
    "parcel_id": "158-17-01",
    "owner1": "MICHELSON, ET AL TRS, GEORGE",
    "owner2": "C/O DANNIN MGMT CORP, LONGWOOD CONDO TR",
    "current_taxes": 6340.61,
    "new_taxes_no_override": 6614.52,
    "override_total_1": 6802.21,
    "override_increase_1": 187.68
  },
  {
    "#": "45 Longwood Ave, Unit Pha 12&179 (158-16-96)",
    "$": 1512100,
    "address": "45 Longwood Ave, Unit Pha 12&179",
    "parcel_id": "158-16-96",
    "owner1": "TREY, GARY",
    "owner2": "",
    "current_taxes": 11848.97,
    "new_taxes_no_override": 12360.85,
    "override_total_1": 12711.58,
    "override_increase_1": 350.73
  },
  {
    "#": "45 Longwood Ave, Unit Phb 1G&1P (158-16-97)",
    "$": 1477500,
    "address": "45 Longwood Ave, Unit Phb 1G&1P",
    "parcel_id": "158-16-97",
    "owner1": "JO, VICKIE YOUNG",
    "owner2": "ROBBINS, JONATHAN A",
    "current_taxes": 15129.6,
    "new_taxes_no_override": 15783.2,
    "override_total_1": 16231.03,
    "override_increase_1": 447.84
  },
  {
    "#": "45 Longwood Ave, Unit Phc & P175 (158-16-98)",
    "$": 1461200,
    "address": "45 Longwood Ave, Unit Phc & P175",
    "parcel_id": "158-16-98",
    "owner1": "ELDER TRS, JOHN J & MARY BETH",
    "owner2": "",
    "current_taxes": 11327.75,
    "new_taxes_no_override": 11817.11,
    "override_total_1": 12152.41,
    "override_increase_1": 335.3
  },
  {
    "#": "45 Longwood Ave, Unit Phd & P38 (158-16-99)",
    "$": 1452700,
    "address": "45 Longwood Ave, Unit Phd & P38",
    "parcel_id": "158-16-99",
    "owner1": "COLE III, WHITEFOORD R",
    "owner2": "BEAN, LILLIAN",
    "current_taxes": 11240.71,
    "new_taxes_no_override": 11726.31,
    "override_total_1": 12059.03,
    "override_increase_1": 332.73
  },
  {
    "#": "50 Longwood Ave, Unit 1011& P160 (159-05-71)",
    "$": 709500,
    "address": "50 Longwood Ave, Unit 1011& P160",
    "parcel_id": "159-05-71",
    "owner1": "TOLKOFF, M JOSH & ANN CONNOLLY",
    "owner2": "",
    "current_taxes": 7265.28,
    "new_taxes_no_override": 7579.14,
    "override_total_1": 7794.19,
    "override_increase_1": 215.05
  },
  {
    "#": "50 Longwood Ave, Unit 1012 & P141 (159-05-72)",
    "$": 770700,
    "address": "50 Longwood Ave, Unit 1012 & P141",
    "parcel_id": "159-05-72",
    "owner1": "TOLKOFF, M JOSH & ANN CONNOLLY",
    "owner2": "",
    "current_taxes": 4257.03,
    "new_taxes_no_override": 4440.93,
    "override_total_1": 4566.94,
    "override_increase_1": 126.01
  },
  {
    "#": "50 Longwood Ave, Unit 1014 (159-05-73)",
    "$": 2230300,
    "address": "50 Longwood Ave, Unit 1014",
    "parcel_id": "159-05-73",
    "owner1": "FRIEDMAN, EDWARD N",
    "owner2": "",
    "current_taxes": 19203.34,
    "new_taxes_no_override": 20032.92,
    "override_total_1": 20601.34,
    "override_increase_1": 568.42
  },
  {
    "#": "50 Longwood Ave, Unit 1016&P67 (159-05-74)",
    "$": 1071200,
    "address": "50 Longwood Ave, Unit 1016&P67",
    "parcel_id": "159-05-74",
    "owner1": "GOLDEN, JONATHAN JOSEPH & KIMBERLY MARN & ROBERT H",
    "owner2": "",
    "current_taxes": 10969.09,
    "new_taxes_no_override": 11442.95,
    "override_total_1": 11767.64,
    "override_increase_1": 324.69
  },
  {
    "#": "50 Longwood Ave, Unit 1017 & P86 (159-05-75)",
    "$": 792900,
    "address": "50 Longwood Ave, Unit 1017 & P86",
    "parcel_id": "159-05-75",
    "owner1": "GOLDEN, JONATHAN JOSEPH & KIMBERLY MARN & ROBERT H",
    "owner2": "",
    "current_taxes": 8119.3,
    "new_taxes_no_override": 8470.05,
    "override_total_1": 8710.39,
    "override_increase_1": 240.33
  },
  {
    "#": "50 Longwood Ave, Unit 1018 &P182 (159-05-76)",
    "$": 798400,
    "address": "50 Longwood Ave, Unit 1018 &P182",
    "parcel_id": "159-05-76",
    "owner1": "SUGIMORI, HIROSHI & HAJIME",
    "owner2": "C/O ABLE BOSTON REAL ESTATE",
    "current_taxes": 8175.62,
    "new_taxes_no_override": 8528.81,
    "override_total_1": 8770.81,
    "override_increase_1": 242.0
  },
  {
    "#": "50 Longwood Ave, Unit 1019 &P158 (159-05-77)",
    "$": 620100,
    "address": "50 Longwood Ave, Unit 1019 &P158",
    "parcel_id": "159-05-77",
    "owner1": "AVNI TR, NITZA",
    "owner2": "",
    "current_taxes": 6349.82,
    "new_taxes_no_override": 6624.13,
    "override_total_1": 6812.09,
    "override_increase_1": 187.95
  },
  {
    "#": "50 Longwood Ave, Unit 1020 G-113 (159-05-78)",
    "$": 591600,
    "address": "50 Longwood Ave, Unit 1020 G-113",
    "parcel_id": "159-05-78",
    "owner1": "LASTER, JUDITH E",
    "owner2": "",
    "current_taxes": 2423.05,
    "new_taxes_no_override": 2527.73,
    "override_total_1": 2599.45,
    "override_increase_1": 71.72
  },
  {
    "#": "50 Longwood Ave, Unit 1112 89&90 (159-05-79)",
    "$": 1671200,
    "address": "50 Longwood Ave, Unit 1112 89&90",
    "parcel_id": "159-05-79",
    "owner1": "SCHOENFELD, JONATHAN D",
    "owner2": "LEVIN, KELLY E",
    "current_taxes": 13478.15,
    "new_taxes_no_override": 14060.41,
    "override_total_1": 14459.36,
    "override_increase_1": 398.95
  },
  {
    "#": "50 Longwood Ave, Unit 1114 P138 (159-05-80)",
    "$": 1585000,
    "address": "50 Longwood Ave, Unit 1114 P138",
    "parcel_id": "159-05-80",
    "owner1": "NADELSON TRS, CAROL C",
    "owner2": "LUDWIG, JUDITH D",
    "current_taxes": 12595.47,
    "new_taxes_no_override": 13139.59,
    "override_total_1": 13512.42,
    "override_increase_1": 372.83
  },
  {
    "#": "50 Longwood Ave, Unit 1117 P137 (159-05-81)",
    "$": 1553800,
    "address": "50 Longwood Ave, Unit 1117 P137",
    "parcel_id": "159-05-81",
    "owner1": "LIPES, MYRA A",
    "owner2": "WOLPERT, HOWARD A",
    "current_taxes": 12275.98,
    "new_taxes_no_override": 12806.3,
    "override_total_1": 13169.67,
    "override_increase_1": 363.37
  },
  {
    "#": "50 Longwood Ave, Unit 1118&P3435 (159-05-82)",
    "$": 1837900,
    "address": "50 Longwood Ave, Unit 1118&P3435",
    "parcel_id": "159-05-82",
    "owner1": "CHANG TR, TEWEN",
    "owner2": "",
    "current_taxes": 15185.16,
    "new_taxes_no_override": 15841.16,
    "override_total_1": 16290.64,
    "override_increase_1": 449.48
  },
  {
    "#": "50 Longwood Ave, Unit 211 (159-05-00)",
    "$": 635900,
    "address": "50 Longwood Ave, Unit 211",
    "parcel_id": "159-05-00",
    "owner1": "SCHMAHMANN, DAVID R",
    "owner2": "",
    "current_taxes": 6511.62,
    "new_taxes_no_override": 6792.92,
    "override_total_1": 6985.67,
    "override_increase_1": 192.74
  },
  {
    "#": "50 Longwood Ave, Unit 212 & P131 (159-05-01)",
    "$": 703900,
    "address": "50 Longwood Ave, Unit 212 & P131",
    "parcel_id": "159-05-01",
    "owner1": "WARSHAW, ROBERTA RUTH",
    "owner2": "MONCHICK, ALAN",
    "current_taxes": 3573.0,
    "new_taxes_no_override": 3727.35,
    "override_total_1": 3833.11,
    "override_increase_1": 105.76
  },
  {
    "#": "50 Longwood Ave, Unit 214 (159-05-02)",
    "$": 692500,
    "address": "50 Longwood Ave, Unit 214",
    "parcel_id": "159-05-02",
    "owner1": "MARULKAR TRS, SACHIN S",
    "owner2": "JOSHI, AMITA A",
    "current_taxes": 7091.2,
    "new_taxes_no_override": 7397.54,
    "override_total_1": 7607.44,
    "override_increase_1": 209.9
  },
  {
    "#": "50 Longwood Ave, Unit 215 & P170 (159-05-03)",
    "$": 1072900,
    "address": "50 Longwood Ave, Unit 215 & P170",
    "parcel_id": "159-05-03",
    "owner1": "TASSONE, BETTINA R",
    "owner2": "",
    "current_taxes": 10986.5,
    "new_taxes_no_override": 11461.12,
    "override_total_1": 11786.32,
    "override_increase_1": 325.2
  },
  {
    "#": "50 Longwood Ave, Unit 216 & P47 (159-05-04)",
    "$": 1062000,
    "address": "50 Longwood Ave, Unit 216 & P47",
    "parcel_id": "159-05-04",
    "owner1": "KILDAY, DEBORAH A",
    "owner2": "",
    "current_taxes": 10874.88,
    "new_taxes_no_override": 11344.67,
    "override_total_1": 11666.57,
    "override_increase_1": 321.9
  },
  {
    "#": "50 Longwood Ave, Unit 217 & P122 (159-05-05)",
    "$": 669100,
    "address": "50 Longwood Ave, Unit 217 & P122",
    "parcel_id": "159-05-05",
    "owner1": "GOODELL, JAMES M",
    "owner2": "",
    "current_taxes": 6851.58,
    "new_taxes_no_override": 7147.57,
    "override_total_1": 7350.38,
    "override_increase_1": 202.81
  },
  {
    "#": "50 Longwood Ave, Unit 218 & G128 (159-05-06)",
    "$": 780800,
    "address": "50 Longwood Ave, Unit 218 & G128",
    "parcel_id": "159-05-06",
    "owner1": "HABERMAN TR, SHELBY JOEL",
    "owner2": "",
    "current_taxes": 4360.46,
    "new_taxes_no_override": 4548.83,
    "override_total_1": 4677.9,
    "override_increase_1": 129.07
  },
  {
    "#": "50 Longwood Ave, Unit 219 & P186 (159-05-07)",
    "$": 589600,
    "address": "50 Longwood Ave, Unit 219 & P186",
    "parcel_id": "159-05-07",
    "owner1": "DENNIS, STANLEY R",
    "owner2": "LAVIE, RENA R",
    "current_taxes": 6037.5,
    "new_taxes_no_override": 6298.32,
    "override_total_1": 6477.03,
    "override_increase_1": 178.71
  },
  {
    "#": "50 Longwood Ave, Unit 220 & P91 (159-05-08)",
    "$": 595600,
    "address": "50 Longwood Ave, Unit 220 & P91",
    "parcel_id": "159-05-08",
    "owner1": "ZHENG, XIAOZHU",
    "owner2": "ZHOU, JIALI",
    "current_taxes": 6098.94,
    "new_taxes_no_override": 6362.41,
    "override_total_1": 6542.94,
    "override_increase_1": 180.53
  },
  {
    "#": "50 Longwood Ave, Unit 311 (159-05-09)",
    "$": 560400,
    "address": "50 Longwood Ave, Unit 311",
    "parcel_id": "159-05-09",
    "owner1": "TOROUS TRS, JANE & WALTER",
    "owner2": "",
    "current_taxes": 5738.5,
    "new_taxes_no_override": 5986.4,
    "override_total_1": 6156.26,
    "override_increase_1": 169.86
  },
  {
    "#": "50 Longwood Ave, Unit 312 & P142 (159-05-10)",
    "$": 763500,
    "address": "50 Longwood Ave, Unit 312 & P142",
    "parcel_id": "159-05-10",
    "owner1": "AALYSON TR, MOLLY",
    "owner2": "LODA, MASSIMO",
    "current_taxes": 7818.24,
    "new_taxes_no_override": 8155.99,
    "override_total_1": 8387.41,
    "override_increase_1": 231.42
  },
  {
    "#": "50 Longwood Ave, Unit 314 & P125 (159-05-11)",
    "$": 664300,
    "address": "50 Longwood Ave, Unit 314 & P125",
    "parcel_id": "159-05-11",
    "owner1": "GLICK, LEONARD J DEBRA M TERRY",
    "owner2": "",
    "current_taxes": 3167.5,
    "new_taxes_no_override": 3304.34,
    "override_total_1": 3398.09,
    "override_increase_1": 93.76
  },
  {
    "#": "50 Longwood Ave, Unit 315&P51 (159-05-12)",
    "$": 1072300,
    "address": "50 Longwood Ave, Unit 315&P51",
    "parcel_id": "159-05-12",
    "owner1": "SHARMA, KAUSTUBH & POOJA",
    "owner2": "",
    "current_taxes": 10980.35,
    "new_taxes_no_override": 11454.7,
    "override_total_1": 11779.72,
    "override_increase_1": 325.02
  },
  {
    "#": "50 Longwood Ave, Unit 316 & P60 (159-05-13)",
    "$": 1091300,
    "address": "50 Longwood Ave, Unit 316 & P60",
    "parcel_id": "159-05-13",
    "owner1": "RISKIN, JOY",
    "owner2": "",
    "current_taxes": 7539.98,
    "new_taxes_no_override": 7865.71,
    "override_total_1": 8088.89,
    "override_increase_1": 223.18
  },
  {
    "#": "50 Longwood Ave, Unit 317 & P80 (159-05-14)",
    "$": 668700,
    "address": "50 Longwood Ave, Unit 317 & P80",
    "parcel_id": "159-05-14",
    "owner1": "ALIGN MBN LLC",
    "owner2": "",
    "current_taxes": 6847.49,
    "new_taxes_no_override": 7143.3,
    "override_total_1": 7345.99,
    "override_increase_1": 202.69
  },
  {
    "#": "50 Longwood Ave, Unit 318 & P85 (159-05-15)",
    "$": 675800,
    "address": "50 Longwood Ave, Unit 318 & P85",
    "parcel_id": "159-05-15",
    "owner1": "FAMILI, LIDA",
    "owner2": "",
    "current_taxes": 6920.19,
    "new_taxes_no_override": 7219.14,
    "override_total_1": 7423.98,
    "override_increase_1": 204.84
  },
  {
    "#": "50 Longwood Ave, Unit 319&P171 (159-05-16)",
    "$": 614100,
    "address": "50 Longwood Ave, Unit 319&P171",
    "parcel_id": "159-05-16",
    "owner1": "ROSENZWEIG, PERRY",
    "owner2": "LEVIN, NETA ROSENZWEIG",
    "current_taxes": 2653.45,
    "new_taxes_no_override": 2768.08,
    "override_total_1": 2846.62,
    "override_increase_1": 78.54
  },
  {
    "#": "50 Longwood Ave, Unit 320 & P175 (159-05-17)",
    "$": 605500,
    "address": "50 Longwood Ave, Unit 320 & P175",
    "parcel_id": "159-05-17",
    "owner1": "BRONSTEIN, MIRIAM",
    "owner2": "",
    "current_taxes": 6200.32,
    "new_taxes_no_override": 6468.17,
    "override_total_1": 6651.7,
    "override_increase_1": 183.53
  },
  {
    "#": "50 Longwood Ave, Unit 411 & P43 (159-05-18)",
    "$": 628900,
    "address": "50 Longwood Ave, Unit 411 & P43",
    "parcel_id": "159-05-18",
    "owner1": "DUBIN, BENJAMIN & SUSAN A",
    "owner2": "",
    "current_taxes": 6439.94,
    "new_taxes_no_override": 6718.15,
    "override_total_1": 6908.77,
    "override_increase_1": 190.62
  },
  {
    "#": "50 Longwood Ave, Unit 412 (159-05-19)",
    "$": 644600,
    "address": "50 Longwood Ave, Unit 412",
    "parcel_id": "159-05-19",
    "owner1": "DUBIN, BENJAMIN & SUSAN A",
    "owner2": "",
    "current_taxes": 6600.7,
    "new_taxes_no_override": 6885.85,
    "override_total_1": 7081.23,
    "override_increase_1": 195.38
  },
  {
    "#": "50 Longwood Ave, Unit 414 & P172 (159-05-20)",
    "$": 661500,
    "address": "50 Longwood Ave, Unit 414 & P172",
    "parcel_id": "159-05-20",
    "owner1": "BRICKMAN, ETHLYNNE",
    "owner2": "",
    "current_taxes": 6773.76,
    "new_taxes_no_override": 7066.39,
    "override_total_1": 7266.89,
    "override_increase_1": 200.5
  },
  {
    "#": "50 Longwood Ave, Unit 415 & P121 (159-05-21)",
    "$": 1071200,
    "address": "50 Longwood Ave, Unit 415 & P121",
    "parcel_id": "159-05-21",
    "owner1": "12N 201E STREET LLC",
    "owner2": "",
    "current_taxes": 10969.09,
    "new_taxes_no_override": 11442.95,
    "override_total_1": 11767.64,
    "override_increase_1": 324.69
  },
  {
    "#": "50 Longwood Ave, Unit 416 & P124 (159-05-22)",
    "$": 1027600,
    "address": "50 Longwood Ave, Unit 416 & P124",
    "parcel_id": "159-05-22",
    "owner1": "BHATIA, OM",
    "owner2": "SHEEHY, NANCY",
    "current_taxes": 10522.62,
    "new_taxes_no_override": 10977.2,
    "override_total_1": 11288.67,
    "override_increase_1": 311.47
  },
  {
    "#": "50 Longwood Ave, Unit 417 & P145 (159-05-23)",
    "$": 684100,
    "address": "50 Longwood Ave, Unit 417 & P145",
    "parcel_id": "159-05-23",
    "owner1": "DUBIN, BENJAMIN",
    "owner2": "",
    "current_taxes": 7005.18,
    "new_taxes_no_override": 7307.8,
    "override_total_1": 7515.16,
    "override_increase_1": 207.35
  },
  {
    "#": "50 Longwood Ave, Unit 418 & P123 (159-05-24)",
    "$": 788100,
    "address": "50 Longwood Ave, Unit 418 & P123",
    "parcel_id": "159-05-24",
    "owner1": "BLUM TRS, BARRY S & HOWARD L",
    "owner2": "",
    "current_taxes": 4435.21,
    "new_taxes_no_override": 4626.81,
    "override_total_1": 4758.09,
    "override_increase_1": 131.28
  },
  {
    "#": "50 Longwood Ave, Unit 419 & P112 (159-05-25)",
    "$": 615300,
    "address": "50 Longwood Ave, Unit 419 & P112",
    "parcel_id": "159-05-25",
    "owner1": "WOLF, JAMES A",
    "owner2": "",
    "current_taxes": 2665.74,
    "new_taxes_no_override": 2780.9,
    "override_total_1": 2859.81,
    "override_increase_1": 78.91
  },
  {
    "#": "50 Longwood Ave, Unit 420 (159-05-26)",
    "$": 546600,
    "address": "50 Longwood Ave, Unit 420",
    "parcel_id": "159-05-26",
    "owner1": "STROUP, MARY E",
    "owner2": "",
    "current_taxes": 1962.25,
    "new_taxes_no_override": 2047.02,
    "override_total_1": 2105.1,
    "override_increase_1": 58.08
  },
  {
    "#": "50 Longwood Ave, Unit 511 & P107 (159-05-27)",
    "$": 653400,
    "address": "50 Longwood Ave, Unit 511 & P107",
    "parcel_id": "159-05-27",
    "owner1": "511 512 LONGWOOD AVENUE LLC",
    "owner2": "",
    "current_taxes": 6690.82,
    "new_taxes_no_override": 6979.86,
    "override_total_1": 7177.91,
    "override_increase_1": 198.05
  },
  {
    "#": "50 Longwood Ave, Unit 512 & P49 (159-05-28)",
    "$": 660700,
    "address": "50 Longwood Ave, Unit 512 & P49",
    "parcel_id": "159-05-28",
    "owner1": "511 512 LONGWOOD AVENUE LLC",
    "owner2": "",
    "current_taxes": 6765.57,
    "new_taxes_no_override": 7057.84,
    "override_total_1": 7258.1,
    "override_increase_1": 200.26
  },
  {
    "#": "50 Longwood Ave, Unit 514 & P25 (159-05-29)",
    "$": 767600,
    "address": "50 Longwood Ave, Unit 514 & P25",
    "parcel_id": "159-05-29",
    "owner1": "514 LONGWOOD AVENUE LLC",
    "owner2": "",
    "current_taxes": 7860.22,
    "new_taxes_no_override": 8199.78,
    "override_total_1": 8432.44,
    "override_increase_1": 232.66
  },
  {
    "#": "50 Longwood Ave, Unit 515 (159-05-30)",
    "$": 920900,
    "address": "50 Longwood Ave, Unit 515",
    "parcel_id": "159-05-30",
    "owner1": "KIRPALANI, SHEILA & RAMESH",
    "owner2": "",
    "current_taxes": 5795.08,
    "new_taxes_no_override": 6045.43,
    "override_total_1": 6216.96,
    "override_increase_1": 171.53
  },
  {
    "#": "50 Longwood Ave, Unit 516 & P77 (159-05-31)",
    "$": 1079900,
    "address": "50 Longwood Ave, Unit 516 & P77",
    "parcel_id": "159-05-31",
    "owner1": "CHMC CARDIOVASCULAR SURGICAL FOUNDATION INC",
    "owner2": "",
    "current_taxes": 11058.18,
    "new_taxes_no_override": 11535.89,
    "override_total_1": 11863.22,
    "override_increase_1": 327.32
  },
  {
    "#": "50 Longwood Ave, Unit 517 (159-05-32)",
    "$": 631100,
    "address": "50 Longwood Ave, Unit 517",
    "parcel_id": "159-05-32",
    "owner1": "TASSONE, DEBORAH & BETTINA",
    "owner2": "",
    "current_taxes": 6462.46,
    "new_taxes_no_override": 6741.64,
    "override_total_1": 6932.93,
    "override_increase_1": 191.29
  },
  {
    "#": "50 Longwood Ave, Unit 518 & P29 (159-05-33)",
    "$": 768100,
    "address": "50 Longwood Ave, Unit 518 & P29",
    "parcel_id": "159-05-33",
    "owner1": "RAO, UMA M P & PAMIDIMAKKALA M V",
    "owner2": "",
    "current_taxes": 7865.34,
    "new_taxes_no_override": 8205.12,
    "override_total_1": 8437.94,
    "override_increase_1": 232.81
  },
  {
    "#": "50 Longwood Ave, Unit 519 & P146 (159-05-34)",
    "$": 613700,
    "address": "50 Longwood Ave, Unit 519 & P146",
    "parcel_id": "159-05-34",
    "owner1": "TREY, GARY",
    "owner2": "",
    "current_taxes": 6284.29,
    "new_taxes_no_override": 6555.77,
    "override_total_1": 6741.79,
    "override_increase_1": 186.01
  },
  {
    "#": "50 Longwood Ave, Unit 520 (159-05-35)",
    "$": 569500,
    "address": "50 Longwood Ave, Unit 520",
    "parcel_id": "159-05-35",
    "owner1": "GOPIN, STEVEN D & PAULA  & NOAH",
    "owner2": "",
    "current_taxes": 5831.68,
    "new_taxes_no_override": 6083.61,
    "override_total_1": 6256.23,
    "override_increase_1": 172.62
  },
  {
    "#": "50 Longwood Ave, Unit 611 & P191 (159-05-36)",
    "$": 624100,
    "address": "50 Longwood Ave, Unit 611 & P191",
    "parcel_id": "159-05-36",
    "owner1": "LEE TRS, AMY & LORRAINE",
    "owner2": "",
    "current_taxes": 6390.78,
    "new_taxes_no_override": 6666.86,
    "override_total_1": 6856.03,
    "override_increase_1": 189.17
  },
  {
    "#": "50 Longwood Ave, Unit 612 & P53 (159-05-37)",
    "$": 759900,
    "address": "50 Longwood Ave, Unit 612 & P53",
    "parcel_id": "159-05-37",
    "owner1": "BURNLEY, LINDA D",
    "owner2": "",
    "current_taxes": 4146.44,
    "new_taxes_no_override": 4325.57,
    "override_total_1": 4448.3,
    "override_increase_1": 122.73
  },
  {
    "#": "50 Longwood Ave, Unit 614 & P132 (159-05-38)",
    "$": 686700,
    "address": "50 Longwood Ave, Unit 614 & P132",
    "parcel_id": "159-05-38",
    "owner1": "LEVY TRS, CECILE PASTEL",
    "owner2": "",
    "current_taxes": 7031.81,
    "new_taxes_no_override": 7335.58,
    "override_total_1": 7543.73,
    "override_increase_1": 208.14
  },
  {
    "#": "50 Longwood Ave, Unit 615 & P139 (159-05-39)",
    "$": 1071800,
    "address": "50 Longwood Ave, Unit 615 & P139",
    "parcel_id": "159-05-39",
    "owner1": "FUKUDA, TOSHIYA & KEIKO",
    "owner2": "",
    "current_taxes": 10975.23,
    "new_taxes_no_override": 11449.36,
    "override_total_1": 11774.23,
    "override_increase_1": 324.87
  },
  {
    "#": "50 Longwood Ave, Unit 616 & P59 (159-05-40)",
    "$": 1031400,
    "address": "50 Longwood Ave, Unit 616 & P59",
    "parcel_id": "159-05-40",
    "owner1": "BARON TRS, CYNTHIA L",
    "owner2": "INBAR, SHAI",
    "current_taxes": 10561.54,
    "new_taxes_no_override": 11017.8,
    "override_total_1": 11330.42,
    "override_increase_1": 312.62
  },
  {
    "#": "50 Longwood Ave, Unit 617 & P181 (159-05-41)",
    "$": 767900,
    "address": "50 Longwood Ave, Unit 617 & P181",
    "parcel_id": "159-05-41",
    "owner1": "COHEN, ROSALIE",
    "owner2": "CAPLAN, MICHAEL S",
    "current_taxes": 4228.36,
    "new_taxes_no_override": 4411.03,
    "override_total_1": 4536.18,
    "override_increase_1": 125.16
  },
  {
    "#": "50 Longwood Ave, Unit 618 (159-05-42)",
    "$": 651000,
    "address": "50 Longwood Ave, Unit 618",
    "parcel_id": "159-05-42",
    "owner1": "SUN, YI",
    "owner2": "",
    "current_taxes": 3031.31,
    "new_taxes_no_override": 3162.26,
    "override_total_1": 3251.99,
    "override_increase_1": 89.73
  },
  {
    "#": "50 Longwood Ave, Unit 619 (159-05-43)",
    "$": 526000,
    "address": "50 Longwood Ave, Unit 619",
    "parcel_id": "159-05-43",
    "owner1": "KARIMI, ALI",
    "owner2": "",
    "current_taxes": 5386.24,
    "new_taxes_no_override": 5618.93,
    "override_total_1": 5778.36,
    "override_increase_1": 159.43
  },
  {
    "#": "50 Longwood Ave, Unit 620 & P153 (159-05-44)",
    "$": 596000,
    "address": "50 Longwood Ave, Unit 620 & P153",
    "parcel_id": "159-05-44",
    "owner1": "ROSOFSKY TRS, GLADYS & MURRAY P",
    "owner2": "",
    "current_taxes": 6103.04,
    "new_taxes_no_override": 6366.69,
    "override_total_1": 6547.34,
    "override_increase_1": 180.65
  },
  {
    "#": "50 Longwood Ave, Unit 711 & P98 (159-05-45)",
    "$": 610200,
    "address": "50 Longwood Ave, Unit 711 & P98",
    "parcel_id": "159-05-45",
    "owner1": "BOSTON MBM PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 6248.45,
    "new_taxes_no_override": 6518.38,
    "override_total_1": 6703.34,
    "override_increase_1": 184.95
  },
  {
    "#": "50 Longwood Ave, Unit 712&P94 (159-05-46)",
    "$": 661100,
    "address": "50 Longwood Ave, Unit 712&P94",
    "parcel_id": "159-05-46",
    "owner1": "RAO, PAMIDIMUKKALA M V & UMA M P",
    "owner2": "",
    "current_taxes": 6769.66,
    "new_taxes_no_override": 7062.11,
    "override_total_1": 7262.49,
    "override_increase_1": 200.38
  },
  {
    "#": "50 Longwood Ave, Unit 714 (159-05-47)",
    "$": 661900,
    "address": "50 Longwood Ave, Unit 714",
    "parcel_id": "159-05-47",
    "owner1": "LIU, YINGYING",
    "owner2": "",
    "current_taxes": 6777.86,
    "new_taxes_no_override": 7070.66,
    "override_total_1": 7271.29,
    "override_increase_1": 200.62
  },
  {
    "#": "50 Longwood Ave, Unit 715 & P65 (159-05-48)",
    "$": 1023200,
    "address": "50 Longwood Ave, Unit 715 & P65",
    "parcel_id": "159-05-48",
    "owner1": "FAIBES, NORA",
    "owner2": "",
    "current_taxes": 6842.63,
    "new_taxes_no_override": 7138.23,
    "override_total_1": 7340.77,
    "override_increase_1": 202.54
  },
  {
    "#": "50 Longwood Ave, Unit 716 & P106 (159-05-49)",
    "$": 1075000,
    "address": "50 Longwood Ave, Unit 716 & P106",
    "parcel_id": "159-05-49",
    "owner1": "DABORA TR, EMIL",
    "owner2": "",
    "current_taxes": 11008.0,
    "new_taxes_no_override": 11483.55,
    "override_total_1": 11809.38,
    "override_increase_1": 325.84
  },
  {
    "#": "50 Longwood Ave, Unit 717 & P117 (159-05-50)",
    "$": 737000,
    "address": "50 Longwood Ave, Unit 717 & P117",
    "parcel_id": "159-05-50",
    "owner1": "LONGWOOD INVESTMENT AND, DEVELOPMENT LLC",
    "owner2": "C/O IANCHULEV STEFAN",
    "current_taxes": 7546.88,
    "new_taxes_no_override": 7872.91,
    "override_total_1": 8096.29,
    "override_increase_1": 223.39
  },
  {
    "#": "50 Longwood Ave, Unit 718 & P118 (159-05-51)",
    "$": 691200,
    "address": "50 Longwood Ave, Unit 718 & P118",
    "parcel_id": "159-05-51",
    "owner1": "DRIVEN REALTY LLC",
    "owner2": "",
    "current_taxes": 3442.95,
    "new_taxes_no_override": 3591.69,
    "override_total_1": 3693.6,
    "override_increase_1": 101.91
  },
  {
    "#": "50 Longwood Ave, Unit 719 & P185 (159-05-52)",
    "$": 686900,
    "address": "50 Longwood Ave, Unit 719 & P185",
    "parcel_id": "159-05-52",
    "owner1": "MA, HSIANG YU R",
    "owner2": "",
    "current_taxes": 7033.86,
    "new_taxes_no_override": 7337.72,
    "override_total_1": 7545.93,
    "override_increase_1": 208.2
  },
  {
    "#": "50 Longwood Ave, Unit 720 & P167 (159-05-53)",
    "$": 621700,
    "address": "50 Longwood Ave, Unit 720 & P167",
    "parcel_id": "159-05-53",
    "owner1": "SHEA TR, KRISTIN M",
    "owner2": "",
    "current_taxes": 6366.21,
    "new_taxes_no_override": 6641.23,
    "override_total_1": 6829.67,
    "override_increase_1": 188.44
  },
  {
    "#": "50 Longwood Ave, Unit 811 (159-05-54)",
    "$": 698500,
    "address": "50 Longwood Ave, Unit 811",
    "parcel_id": "159-05-54",
    "owner1": "ROSENBAUM, SARA M & SUSAN E & DAVID P",
    "owner2": "",
    "current_taxes": 3517.71,
    "new_taxes_no_override": 3669.68,
    "override_total_1": 3773.8,
    "override_increase_1": 104.12
  },
  {
    "#": "50 Longwood Ave, Unit 812 (159-05-55)",
    "$": 674500,
    "address": "50 Longwood Ave, Unit 812",
    "parcel_id": "159-05-55",
    "owner1": "BRENNER, TRS, SOL L & GLORIA F",
    "owner2": "",
    "current_taxes": 6906.88,
    "new_taxes_no_override": 7205.26,
    "override_total_1": 7409.7,
    "override_increase_1": 204.44
  },
  {
    "#": "50 Longwood Ave, Unit 814 & P31 (159-05-56)",
    "$": 773000,
    "address": "50 Longwood Ave, Unit 814 & P31",
    "parcel_id": "159-05-56",
    "owner1": "YALE TR, JEFFREY F",
    "owner2": "",
    "current_taxes": 7915.52,
    "new_taxes_no_override": 8257.47,
    "override_total_1": 8491.77,
    "override_increase_1": 234.3
  },
  {
    "#": "50 Longwood Ave, Unit 815 P22-23 (159-05-57)",
    "$": 1250600,
    "address": "50 Longwood Ave, Unit 815 P22-23",
    "parcel_id": "159-05-57",
    "owner1": "WOLFMAN, LINDA",
    "owner2": "",
    "current_taxes": 12806.14,
    "new_taxes_no_override": 13359.37,
    "override_total_1": 13738.43,
    "override_increase_1": 379.06
  },
  {
    "#": "50 Longwood Ave, Unit 816 & P87 (159-05-58)",
    "$": 1056100,
    "address": "50 Longwood Ave, Unit 816 & P87",
    "parcel_id": "159-05-58",
    "owner1": "HACKBARTH, DIRK",
    "owner2": "",
    "current_taxes": 7179.53,
    "new_taxes_no_override": 7489.69,
    "override_total_1": 7702.2,
    "override_increase_1": 212.51
  },
  {
    "#": "50 Longwood Ave, Unit 817 & P183 (159-05-59)",
    "$": 771600,
    "address": "50 Longwood Ave, Unit 817 & P183",
    "parcel_id": "159-05-59",
    "owner1": "ATINIZIAN, LORI A",
    "owner2": "",
    "current_taxes": 4266.25,
    "new_taxes_no_override": 4450.55,
    "override_total_1": 4576.83,
    "override_increase_1": 126.28
  },
  {
    "#": "50 Longwood Ave, Unit 818 &P73 (159-05-60)",
    "$": 697400,
    "address": "50 Longwood Ave, Unit 818 &P73",
    "parcel_id": "159-05-60",
    "owner1": "GORDAN, RACHEL & MIRIAM L",
    "owner2": "",
    "current_taxes": 7141.38,
    "new_taxes_no_override": 7449.89,
    "override_total_1": 7661.27,
    "override_increase_1": 211.38
  },
  {
    "#": "50 Longwood Ave, Unit 819 & P156 (159-05-61)",
    "$": 594000,
    "address": "50 Longwood Ave, Unit 819 & P156",
    "parcel_id": "159-05-61",
    "owner1": "MILMAN, ISAAK & GENYA",
    "owner2": "",
    "current_taxes": 2447.63,
    "new_taxes_no_override": 2553.37,
    "override_total_1": 2625.82,
    "override_increase_1": 72.45
  },
  {
    "#": "50 Longwood Ave, Unit 820 & P164 (159-05-62)",
    "$": 595200,
    "address": "50 Longwood Ave, Unit 820 & P164",
    "parcel_id": "159-05-62",
    "owner1": "POURATI, JACOB A",
    "owner2": "",
    "current_taxes": 6094.85,
    "new_taxes_no_override": 6358.15,
    "override_total_1": 6538.56,
    "override_increase_1": 180.41
  },
  {
    "#": "50 Longwood Ave, Unit 911 & P69 (159-05-63)",
    "$": 634400,
    "address": "50 Longwood Ave, Unit 911 & P69",
    "parcel_id": "159-05-63",
    "owner1": "BONDERMAN, EUGENE D",
    "owner2": "",
    "current_taxes": 6496.26,
    "new_taxes_no_override": 6776.9,
    "override_total_1": 6969.19,
    "override_increase_1": 192.29
  },
  {
    "#": "50 Longwood Ave, Unit 912 & P166 (159-05-64)",
    "$": 678500,
    "address": "50 Longwood Ave, Unit 912 & P166",
    "parcel_id": "159-05-64",
    "owner1": "SHECTER, ARNOLD E",
    "owner2": "",
    "current_taxes": 6947.84,
    "new_taxes_no_override": 7247.99,
    "override_total_1": 7453.64,
    "override_increase_1": 205.66
  },
  {
    "#": "50 Longwood Ave, Unit 914 P40-41 (159-05-65)",
    "$": 2212800,
    "address": "50 Longwood Ave, Unit 914 P40-41",
    "parcel_id": "159-05-65",
    "owner1": "SHERMAN, MICHAEL & ANN",
    "owner2": "",
    "current_taxes": 22659.07,
    "new_taxes_no_override": 23637.94,
    "override_total_1": 24308.65,
    "override_increase_1": 670.71
  },
  {
    "#": "50 Longwood Ave, Unit 916 & P116 (159-05-66)",
    "$": 1073400,
    "address": "50 Longwood Ave, Unit 916 & P116",
    "parcel_id": "159-05-66",
    "owner1": "LEVY, JOSEPH & VALERY",
    "owner2": "",
    "current_taxes": 10991.62,
    "new_taxes_no_override": 11466.46,
    "override_total_1": 11791.81,
    "override_increase_1": 325.35
  },
  {
    "#": "50 Longwood Ave, Unit 917 & P46 (159-05-67)",
    "$": 790700,
    "address": "50 Longwood Ave, Unit 917 & P46",
    "parcel_id": "159-05-67",
    "owner1": "TSAI, JUSTIN & JESSICA",
    "owner2": "",
    "current_taxes": 4461.83,
    "new_taxes_no_override": 4654.58,
    "override_total_1": 4786.65,
    "override_increase_1": 132.07
  },
  {
    "#": "50 Longwood Ave, Unit 918 & P30 (159-05-68)",
    "$": 792900,
    "address": "50 Longwood Ave, Unit 918 & P30",
    "parcel_id": "159-05-68",
    "owner1": "TSAI, JASON & ALEXIS W",
    "owner2": "",
    "current_taxes": 4484.36,
    "new_taxes_no_override": 4678.08,
    "override_total_1": 4810.82,
    "override_increase_1": 132.74
  },
  {
    "#": "50 Longwood Ave, Unit 919 & P159 (159-05-69)",
    "$": 592800,
    "address": "50 Longwood Ave, Unit 919 & P159",
    "parcel_id": "159-05-69",
    "owner1": "WONG, ET AL, JAMES H",
    "owner2": "",
    "current_taxes": 6070.27,
    "new_taxes_no_override": 6332.51,
    "override_total_1": 6512.19,
    "override_increase_1": 179.68
  },
  {
    "#": "50 Longwood Ave, Unit 920 & P136 (159-05-70)",
    "$": 690900,
    "address": "50 Longwood Ave, Unit 920 & P136",
    "parcel_id": "159-05-70",
    "owner1": "ZHANG, XIANG",
    "owner2": "",
    "current_taxes": 7074.82,
    "new_taxes_no_override": 7380.45,
    "override_total_1": 7589.87,
    "override_increase_1": 209.41
  },
  {
    "#": "50 Longwood Ave, Unit P120 (159-05-85)",
    "$": 82500,
    "address": "50 Longwood Ave, Unit P120",
    "parcel_id": "159-05-85",
    "owner1": "KUNIN, PAUL E",
    "owner2": "AVEDON, NINA A",
    "current_taxes": 844.8,
    "new_taxes_no_override": 881.3,
    "override_total_1": 906.3,
    "override_increase_1": 25.01
  },
  {
    "#": "50 Longwood Ave, Unit P187 (159-05-84)",
    "$": 82500,
    "address": "50 Longwood Ave, Unit P187",
    "parcel_id": "159-05-84",
    "owner1": "TASSONE, DEBORAH & BETTINA",
    "owner2": "",
    "current_taxes": 844.8,
    "new_taxes_no_override": 881.3,
    "override_total_1": 906.3,
    "override_increase_1": 25.01
  },
  {
    "#": "57 Longwood Ave (158-19-00)",
    "$": 5169800,
    "address": "57 Longwood Ave",
    "parcel_id": "158-19-00",
    "owner1": "SANIEOFF TRS, SIEON & SYROOS",
    "owner2": "",
    "current_taxes": 52938.75,
    "new_taxes_no_override": 55225.7,
    "override_total_1": 56792.69,
    "override_increase_1": 1566.99
  },
  {
    "#": "59 Longwood Ave, Unit 1 (158-20-03)",
    "$": 1038900,
    "address": "59 Longwood Ave, Unit 1",
    "parcel_id": "158-20-03",
    "owner1": "COLE TR, ELLEN R",
    "owner2": "SRIVASTAVA, YOGENDRA N",
    "current_taxes": 10638.34,
    "new_taxes_no_override": 11097.92,
    "override_total_1": 11412.81,
    "override_increase_1": 314.89
  },
  {
    "#": "59 Longwood Ave, Unit 2 (158-20-01)",
    "$": 1097600,
    "address": "59 Longwood Ave, Unit 2",
    "parcel_id": "158-20-01",
    "owner1": "SRIVASTAVA, YOGENDRA & GIULIA",
    "owner2": "",
    "current_taxes": 7604.49,
    "new_taxes_no_override": 7933.0,
    "override_total_1": 8158.1,
    "override_increase_1": 225.09
  },
  {
    "#": "59 Longwood Ave, Unit 3 (158-20-02)",
    "$": 1097100,
    "address": "59 Longwood Ave, Unit 3",
    "parcel_id": "158-20-02",
    "owner1": "COLE TR, ELLEN R",
    "owner2": "",
    "current_taxes": 7599.37,
    "new_taxes_no_override": 7927.66,
    "override_total_1": 8152.6,
    "override_increase_1": 224.94
  },
  {
    "#": "60 Longwood Ave, Unit 1001 P165 (159-04-79)",
    "$": 607800,
    "address": "60 Longwood Ave, Unit 1001 P165",
    "parcel_id": "159-04-79",
    "owner1": "LEVINE, ROBERT A",
    "owner2": "",
    "current_taxes": 2588.94,
    "new_taxes_no_override": 2700.78,
    "override_total_1": 2777.41,
    "override_increase_1": 76.63
  },
  {
    "#": "60 Longwood Ave, Unit 1002 & P26 (159-04-80)",
    "$": 756500,
    "address": "60 Longwood Ave, Unit 1002 & P26",
    "parcel_id": "159-04-80",
    "owner1": "CHAVAKULA, VAMSIDHAR",
    "owner2": "",
    "current_taxes": 4111.63,
    "new_taxes_no_override": 4289.25,
    "override_total_1": 4410.96,
    "override_increase_1": 121.7
  },
  {
    "#": "60 Longwood Ave, Unit 1003&P108 (159-04-81)",
    "$": 789800,
    "address": "60 Longwood Ave, Unit 1003&P108",
    "parcel_id": "159-04-81",
    "owner1": "BARANDOV, ALI",
    "owner2": "ARAGHI, RAHELEH REZAEI",
    "current_taxes": 4452.62,
    "new_taxes_no_override": 4644.97,
    "override_total_1": 4776.77,
    "override_increase_1": 131.8
  },
  {
    "#": "60 Longwood Ave, Unit 1004 P102 (159-04-82)",
    "$": 976200,
    "address": "60 Longwood Ave, Unit 1004 P102",
    "parcel_id": "159-04-82",
    "owner1": "BAEK, PAUL W",
    "owner2": "KIM, RISEON",
    "current_taxes": 9996.29,
    "new_taxes_no_override": 10428.13,
    "override_total_1": 10724.02,
    "override_increase_1": 295.89
  },
  {
    "#": "60 Longwood Ave, Unit 1005 & P84 (159-04-83)",
    "$": 1199200,
    "address": "60 Longwood Ave, Unit 1005 & P84",
    "parcel_id": "159-04-83",
    "owner1": "FELDMAN, SOLOMON & PAULINA",
    "owner2": "",
    "current_taxes": 8644.87,
    "new_taxes_no_override": 9018.33,
    "override_total_1": 9274.22,
    "override_increase_1": 255.89
  },
  {
    "#": "60 Longwood Ave, Unit 1007 & P33 (159-04-84)",
    "$": 703100,
    "address": "60 Longwood Ave, Unit 1007 & P33",
    "parcel_id": "159-04-84",
    "owner1": "ERHARTIC TRS, MARK & JOANNE",
    "owner2": "C/O AARON ERHARTIC",
    "current_taxes": 7199.74,
    "new_taxes_no_override": 7510.77,
    "override_total_1": 7723.88,
    "override_increase_1": 213.11
  },
  {
    "#": "60 Longwood Ave, Unit 1008 & G92 (159-04-85)",
    "$": 752000,
    "address": "60 Longwood Ave, Unit 1008 & G92",
    "parcel_id": "159-04-85",
    "owner1": "BANSAL, DISHA",
    "owner2": "GOPINATHAN, KAUSTAV A",
    "current_taxes": 4065.55,
    "new_taxes_no_override": 4241.18,
    "override_total_1": 4361.52,
    "override_increase_1": 120.34
  },
  {
    "#": "60 Longwood Ave, Unit 1009 & P127 (159-04-86)",
    "$": 593200,
    "address": "60 Longwood Ave, Unit 1009 & P127",
    "parcel_id": "159-04-86",
    "owner1": "MONFARED, HASSAN H & SINA",
    "owner2": "",
    "current_taxes": 2439.43,
    "new_taxes_no_override": 2544.81,
    "override_total_1": 2617.02,
    "override_increase_1": 72.21
  },
  {
    "#": "60 Longwood Ave, Unit 1010 (159-04-87)",
    "$": 598000,
    "address": "60 Longwood Ave, Unit 1010",
    "parcel_id": "159-04-87",
    "owner1": "JULES LEVINE FAMILY LP",
    "owner2": "",
    "current_taxes": 6123.52,
    "new_taxes_no_override": 6388.06,
    "override_total_1": 6569.31,
    "override_increase_1": 181.26
  },
  {
    "#": "60 Longwood Ave, Unit 1102 96&97 (159-04-88)",
    "$": 1771000,
    "address": "60 Longwood Ave, Unit 1102 96&97",
    "parcel_id": "159-04-88",
    "owner1": "STEIN TR, GAIL S",
    "owner2": "",
    "current_taxes": 18135.04,
    "new_taxes_no_override": 18918.47,
    "override_total_1": 19455.27,
    "override_increase_1": 536.8
  },
  {
    "#": "60 Longwood Ave, Unit 1103&P50 (159-04-89)",
    "$": 1658700,
    "address": "60 Longwood Ave, Unit 1103&P50",
    "parcel_id": "159-04-89",
    "owner1": "LIVINGSTON, DENNIS A",
    "owner2": "MOSS, KAREN C",
    "current_taxes": 13350.15,
    "new_taxes_no_override": 13926.88,
    "override_total_1": 14322.04,
    "override_increase_1": 395.16
  },
  {
    "#": "60 Longwood Ave, Unit 1107 & P95 (159-04-90)",
    "$": 1627300,
    "address": "60 Longwood Ave, Unit 1107 & P95",
    "parcel_id": "159-04-90",
    "owner1": "EVANS TRS, ROBERT & PAULA M",
    "owner2": "",
    "current_taxes": 13028.62,
    "new_taxes_no_override": 13591.46,
    "override_total_1": 13977.1,
    "override_increase_1": 385.65
  },
  {
    "#": "60 Longwood Ave, Unit 1108 28&71 (159-04-91)",
    "$": 2005700,
    "address": "60 Longwood Ave, Unit 1108 28&71",
    "parcel_id": "159-04-91",
    "owner1": "ZOLTEK-JICK TR, ROSE R",
    "owner2": "",
    "current_taxes": 16903.43,
    "new_taxes_no_override": 17633.66,
    "override_total_1": 18134.0,
    "override_increase_1": 500.34
  },
  {
    "#": "60 Longwood Ave, Unit 201 (159-05-83)",
    "$": 552600,
    "address": "60 Longwood Ave, Unit 201",
    "parcel_id": "159-05-83",
    "owner1": "KOO, JI HYUN",
    "owner2": "JI, YONG",
    "current_taxes": 5658.62,
    "new_taxes_no_override": 5903.07,
    "override_total_1": 6070.57,
    "override_increase_1": 167.5
  },
  {
    "#": "60 Longwood Ave, Unit 202 & P109 (159-04-01)",
    "$": 663500,
    "address": "60 Longwood Ave, Unit 202 & P109",
    "parcel_id": "159-04-01",
    "owner1": "DEMOS TRS, STEPHEN C & LAVINIA C",
    "owner2": "",
    "current_taxes": 3159.31,
    "new_taxes_no_override": 3295.79,
    "override_total_1": 3389.31,
    "override_increase_1": 93.52
  },
  {
    "#": "60 Longwood Ave, Unit 203 & P100 (159-04-02)",
    "$": 663500,
    "address": "60 Longwood Ave, Unit 203 & P100",
    "parcel_id": "159-04-02",
    "owner1": "ABRAMS, ROBIN",
    "owner2": "",
    "current_taxes": 6794.24,
    "new_taxes_no_override": 7087.75,
    "override_total_1": 7288.86,
    "override_increase_1": 201.11
  },
  {
    "#": "60 Longwood Ave, Unit 204 & P144 (159-04-03)",
    "$": 928600,
    "address": "60 Longwood Ave, Unit 204 & P144",
    "parcel_id": "159-04-03",
    "owner1": "CHMC CARDIOVASCULAR SURGICAL FOUNDATION INC",
    "owner2": "",
    "current_taxes": 9508.86,
    "new_taxes_no_override": 9919.64,
    "override_total_1": 10201.11,
    "override_increase_1": 281.46
  },
  {
    "#": "60 Longwood Ave, Unit 205 & P83 (159-04-04)",
    "$": 586000,
    "address": "60 Longwood Ave, Unit 205 & P83",
    "parcel_id": "159-04-04",
    "owner1": "CHIN TR, LINDA HUI MIN",
    "owner2": "WONG TR, JOHN DICK ON",
    "current_taxes": 2365.71,
    "new_taxes_no_override": 2467.91,
    "override_total_1": 2537.93,
    "override_increase_1": 70.03
  },
  {
    "#": "60 Longwood Ave, Unit 206 & P184 (159-04-05)",
    "$": 451400,
    "address": "60 Longwood Ave, Unit 206 & P184",
    "parcel_id": "159-04-05",
    "owner1": "JENTER TR, AMY",
    "owner2": "",
    "current_taxes": 4622.34,
    "new_taxes_no_override": 4822.03,
    "override_total_1": 4958.85,
    "override_increase_1": 136.82
  },
  {
    "#": "60 Longwood Ave, Unit 207 (159-04-06)",
    "$": 616100,
    "address": "60 Longwood Ave, Unit 207",
    "parcel_id": "159-04-06",
    "owner1": "KORBY, ARKADY M",
    "owner2": "FRIDMAN, ELLA",
    "current_taxes": 2673.93,
    "new_taxes_no_override": 2789.44,
    "override_total_1": 2868.59,
    "override_increase_1": 79.15
  },
  {
    "#": "60 Longwood Ave, Unit 208 & P82 (159-04-07)",
    "$": 714100,
    "address": "60 Longwood Ave, Unit 208 & P82",
    "parcel_id": "159-04-07",
    "owner1": "DESLIPPE, MARK",
    "owner2": "PENG, YOUPING",
    "current_taxes": 7312.38,
    "new_taxes_no_override": 7628.27,
    "override_total_1": 7844.72,
    "override_increase_1": 216.45
  },
  {
    "#": "60 Longwood Ave, Unit 209 & P57 (159-04-08)",
    "$": 592400,
    "address": "60 Longwood Ave, Unit 209 & P57",
    "parcel_id": "159-04-08",
    "owner1": "STOPPER, E JAY",
    "owner2": "",
    "current_taxes": 6066.18,
    "new_taxes_no_override": 6328.24,
    "override_total_1": 6507.8,
    "override_increase_1": 179.56
  },
  {
    "#": "60 Longwood Ave, Unit 210 & P76 (159-04-09)",
    "$": 608600,
    "address": "60 Longwood Ave, Unit 210 & P76",
    "parcel_id": "159-04-09",
    "owner1": "HARTZ, BRADLEY & NAAMA",
    "owner2": "",
    "current_taxes": 6232.06,
    "new_taxes_no_override": 6501.28,
    "override_total_1": 6685.75,
    "override_increase_1": 184.47
  },
  {
    "#": "60 Longwood Ave, Unit 301 & P129 (159-04-10)",
    "$": 637900,
    "address": "60 Longwood Ave, Unit 301 & P129",
    "parcel_id": "159-04-10",
    "owner1": "SOLE COSTANZO, MARIA",
    "owner2": "",
    "current_taxes": 2897.16,
    "new_taxes_no_override": 3022.32,
    "override_total_1": 3108.07,
    "override_increase_1": 85.76
  },
  {
    "#": "60 Longwood Ave, Unit 302 (159-04-11)",
    "$": 686300,
    "address": "60 Longwood Ave, Unit 302",
    "parcel_id": "159-04-11",
    "owner1": "EHRLICH, SCOTT",
    "owner2": "",
    "current_taxes": 7027.71,
    "new_taxes_no_override": 7331.31,
    "override_total_1": 7539.33,
    "override_increase_1": 208.02
  },
  {
    "#": "60 Longwood Ave, Unit 303 & P63 (159-04-12)",
    "$": 694800,
    "address": "60 Longwood Ave, Unit 303 & P63",
    "parcel_id": "159-04-12",
    "owner1": "BEREZO  LIFE ESTATE, EVELYN",
    "owner2": "",
    "current_taxes": 3479.82,
    "new_taxes_no_override": 3630.15,
    "override_total_1": 3733.15,
    "override_increase_1": 103.0
  },
  {
    "#": "60 Longwood Ave, Unit 304 & P56 (159-04-13)",
    "$": 924300,
    "address": "60 Longwood Ave, Unit 304 & P56",
    "parcel_id": "159-04-13",
    "owner1": "BUTLER, PAULA & JOEL",
    "owner2": "",
    "current_taxes": 9464.83,
    "new_taxes_no_override": 9873.71,
    "override_total_1": 10153.87,
    "override_increase_1": 280.16
  },
  {
    "#": "60 Longwood Ave, Unit 305 & P38 (159-04-14)",
    "$": 593200,
    "address": "60 Longwood Ave, Unit 305 & P38",
    "parcel_id": "159-04-14",
    "owner1": "LUDOMIRSKY, AVITAL BRENA",
    "owner2": "",
    "current_taxes": 6074.37,
    "new_taxes_no_override": 6336.78,
    "override_total_1": 6516.58,
    "override_increase_1": 179.8
  },
  {
    "#": "60 Longwood Ave, Unit 306-P174 (159-04-15)",
    "$": 504200,
    "address": "60 Longwood Ave, Unit 306-P174",
    "parcel_id": "159-04-15",
    "owner1": "CHANG, QING",
    "owner2": "JIANG, SHAN",
    "current_taxes": 5163.01,
    "new_taxes_no_override": 5386.05,
    "override_total_1": 5538.88,
    "override_increase_1": 152.83
  },
  {
    "#": "60 Longwood Ave, Unit 307 & P152 (159-04-16)",
    "$": 683300,
    "address": "60 Longwood Ave, Unit 307 & P152",
    "parcel_id": "159-04-16",
    "owner1": "RAO, PAMIDIMAKKALA M V & UMA M P",
    "owner2": "",
    "current_taxes": 6996.99,
    "new_taxes_no_override": 7299.26,
    "override_total_1": 7506.37,
    "override_increase_1": 207.11
  },
  {
    "#": "60 Longwood Ave, Unit 308 & P64 (159-04-17)",
    "$": 705900,
    "address": "60 Longwood Ave, Unit 308 & P64",
    "parcel_id": "159-04-17",
    "owner1": "SWEIGENBERG, AMY A",
    "owner2": "",
    "current_taxes": 3593.48,
    "new_taxes_no_override": 3748.72,
    "override_total_1": 3855.09,
    "override_increase_1": 106.37
  },
  {
    "#": "60 Longwood Ave, Unit 309 & P32 (159-04-18)",
    "$": 605900,
    "address": "60 Longwood Ave, Unit 309 & P32",
    "parcel_id": "159-04-18",
    "owner1": "FLIER, TR, JEFFREY S",
    "owner2": "",
    "current_taxes": 6204.42,
    "new_taxes_no_override": 6472.45,
    "override_total_1": 6656.1,
    "override_increase_1": 183.65
  },
  {
    "#": "60 Longwood Ave, Unit 310 & P179 (159-04-19)",
    "$": 632000,
    "address": "60 Longwood Ave, Unit 310 & P179",
    "parcel_id": "159-04-19",
    "owner1": "CHEE-ATKIN, WINNIE",
    "owner2": "",
    "current_taxes": 6471.68,
    "new_taxes_no_override": 6751.26,
    "override_total_1": 6942.82,
    "override_increase_1": 191.56
  },
  {
    "#": "60 Longwood Ave, Unit 401 (159-04-20)",
    "$": 610200,
    "address": "60 Longwood Ave, Unit 401",
    "parcel_id": "159-04-20",
    "owner1": "GREEN, CAROL J",
    "owner2": "",
    "current_taxes": 6248.45,
    "new_taxes_no_override": 6518.38,
    "override_total_1": 6703.34,
    "override_increase_1": 184.95
  },
  {
    "#": "60 Longwood Ave, Unit 402 & P169 (159-04-21)",
    "$": 670300,
    "address": "60 Longwood Ave, Unit 402 & P169",
    "parcel_id": "159-04-21",
    "owner1": "WANG, DANHONG",
    "owner2": "",
    "current_taxes": 6863.87,
    "new_taxes_no_override": 7160.39,
    "override_total_1": 7363.56,
    "override_increase_1": 203.17
  },
  {
    "#": "60 Longwood Ave, Unit 403 & P110 (159-04-22)",
    "$": 638500,
    "address": "60 Longwood Ave, Unit 403 & P110",
    "parcel_id": "159-04-22",
    "owner1": "SMOKLER, SHEILA",
    "owner2": "",
    "current_taxes": 6538.24,
    "new_taxes_no_override": 6820.69,
    "override_total_1": 7014.22,
    "override_increase_1": 193.53
  },
  {
    "#": "60 Longwood Ave, Unit 404 & P37 (159-04-23)",
    "$": 890400,
    "address": "60 Longwood Ave, Unit 404 & P37",
    "parcel_id": "159-04-23",
    "owner1": "FRANCIA, EMANUELE CLEMENTE CARLO",
    "owner2": "CHENG, SHAN",
    "current_taxes": 9117.7,
    "new_taxes_no_override": 9511.58,
    "override_total_1": 9781.47,
    "override_increase_1": 269.88
  },
  {
    "#": "60 Longwood Ave, Unit 405 & P75 (159-04-24)",
    "$": 672000,
    "address": "60 Longwood Ave, Unit 405 & P75",
    "parcel_id": "159-04-24",
    "owner1": "WU TR, JUDY HAOJUN",
    "owner2": "",
    "current_taxes": 6881.28,
    "new_taxes_no_override": 7178.55,
    "override_total_1": 7382.24,
    "override_increase_1": 203.69
  },
  {
    "#": "60 Longwood Ave, Unit 406 (159-04-25)",
    "$": 394400,
    "address": "60 Longwood Ave, Unit 406",
    "parcel_id": "159-04-25",
    "owner1": "HERMAN, MATTHEW",
    "owner2": "",
    "current_taxes": 403.87,
    "new_taxes_no_override": 421.32,
    "override_total_1": 433.27,
    "override_increase_1": 11.95
  },
  {
    "#": "60 Longwood Ave, Unit 407 & P88 (159-04-26)",
    "$": 778400,
    "address": "60 Longwood Ave, Unit 407 & P88",
    "parcel_id": "159-04-26",
    "owner1": "GOLDSTEIN, BRUCE M & AMY M",
    "owner2": "",
    "current_taxes": 7970.82,
    "new_taxes_no_override": 8315.16,
    "override_total_1": 8551.1,
    "override_increase_1": 235.94
  },
  {
    "#": "60 Longwood Ave, Unit 408 & P180 (159-04-27)",
    "$": 673400,
    "address": "60 Longwood Ave, Unit 408 & P180",
    "parcel_id": "159-04-27",
    "owner1": "RAO, PAMIDIMUKKALA MV & UMA M P",
    "owner2": "",
    "current_taxes": 6895.62,
    "new_taxes_no_override": 7193.51,
    "override_total_1": 7397.62,
    "override_increase_1": 204.11
  },
  {
    "#": "60 Longwood Ave, Unit 409 & P99 (159-04-28)",
    "$": 597600,
    "address": "60 Longwood Ave, Unit 409 & P99",
    "parcel_id": "159-04-28",
    "owner1": "ROUSH, JACOB H & WILLIAM R",
    "owner2": "",
    "current_taxes": 6119.42,
    "new_taxes_no_override": 6383.78,
    "override_total_1": 6564.91,
    "override_increase_1": 181.13
  },
  {
    "#": "60 Longwood Ave, Unit 410 (159-04-29)",
    "$": 546200,
    "address": "60 Longwood Ave, Unit 410",
    "parcel_id": "159-04-29",
    "owner1": "SAPHRA, NAOMI",
    "owner2": "CARRELL, ANNABELLE MICHAEL",
    "current_taxes": 5593.09,
    "new_taxes_no_override": 5834.71,
    "override_total_1": 6000.27,
    "override_increase_1": 165.56
  },
  {
    "#": "60 Longwood Ave, Unit 501 & P61 (159-04-30)",
    "$": 635500,
    "address": "60 Longwood Ave, Unit 501 & P61",
    "parcel_id": "159-04-30",
    "owner1": "ZAI, AILEEN & MARVIN",
    "owner2": "",
    "current_taxes": 6507.52,
    "new_taxes_no_override": 6788.64,
    "override_total_1": 6981.27,
    "override_increase_1": 192.62
  },
  {
    "#": "60 Longwood Ave, Unit 502 (159-04-31)",
    "$": 611400,
    "address": "60 Longwood Ave, Unit 502",
    "parcel_id": "159-04-31",
    "owner1": "ZAI, MARVIN HO MING & AILEEN K",
    "owner2": "",
    "current_taxes": 2625.8,
    "new_taxes_no_override": 2739.23,
    "override_total_1": 2816.96,
    "override_increase_1": 77.72
  },
  {
    "#": "60 Longwood Ave, Unit 503 & P55 (159-04-32)",
    "$": 771100,
    "address": "60 Longwood Ave, Unit 503 & P55",
    "parcel_id": "159-04-32",
    "owner1": "SEVER, LEVENT RIFKI",
    "owner2": "",
    "current_taxes": 7896.06,
    "new_taxes_no_override": 8237.17,
    "override_total_1": 8470.89,
    "override_increase_1": 233.72
  },
  {
    "#": "60 Longwood Ave, Unit 504 & P58 (159-04-33)",
    "$": 888400,
    "address": "60 Longwood Ave, Unit 504 & P58",
    "parcel_id": "159-04-33",
    "owner1": "SEVER, LEVENT RIFKI",
    "owner2": "",
    "current_taxes": 5462.28,
    "new_taxes_no_override": 5698.25,
    "override_total_1": 5859.93,
    "override_increase_1": 161.68
  },
  {
    "#": "60 Longwood Ave, Unit 505 & P155 (159-04-34)",
    "$": 595800,
    "address": "60 Longwood Ave, Unit 505 & P155",
    "parcel_id": "159-04-34",
    "owner1": "GLADSTONE, SHIRA L",
    "owner2": "",
    "current_taxes": 6100.99,
    "new_taxes_no_override": 6364.55,
    "override_total_1": 6545.14,
    "override_increase_1": 180.59
  },
  {
    "#": "60 Longwood Ave, Unit 506 (159-04-35)",
    "$": 392900,
    "address": "60 Longwood Ave, Unit 506",
    "parcel_id": "159-04-35",
    "owner1": "WATSON, BARBARA M",
    "owner2": "",
    "current_taxes": 4023.3,
    "new_taxes_no_override": 4197.11,
    "override_total_1": 4316.2,
    "override_increase_1": 119.09
  },
  {
    "#": "60 Longwood Ave, Unit 507 & P42 (159-04-36)",
    "$": 769800,
    "address": "60 Longwood Ave, Unit 507 & P42",
    "parcel_id": "159-04-36",
    "owner1": "MAZER, INA J",
    "owner2": "",
    "current_taxes": 4247.82,
    "new_taxes_no_override": 4431.33,
    "override_total_1": 4557.06,
    "override_increase_1": 125.74
  },
  {
    "#": "60 Longwood Ave, Unit 508 & P190 (159-04-37)",
    "$": 786100,
    "address": "60 Longwood Ave, Unit 508 & P190",
    "parcel_id": "159-04-37",
    "owner1": "ORNSTEIN TR, SHARONE B",
    "owner2": "",
    "current_taxes": 8049.66,
    "new_taxes_no_override": 8397.41,
    "override_total_1": 8635.68,
    "override_increase_1": 238.27
  },
  {
    "#": "60 Longwood Ave, Unit 509 & P42 (159-04-38)",
    "$": 605500,
    "address": "60 Longwood Ave, Unit 509 & P42",
    "parcel_id": "159-04-38",
    "owner1": "ORNSTEIN TR, SHARONE B",
    "owner2": "",
    "current_taxes": 6200.32,
    "new_taxes_no_override": 6468.17,
    "override_total_1": 6651.7,
    "override_increase_1": 183.53
  },
  {
    "#": "60 Longwood Ave, Unit 510 & P178 (159-04-39)",
    "$": 597200,
    "address": "60 Longwood Ave, Unit 510 & P178",
    "parcel_id": "159-04-39",
    "owner1": "DOHERTY TR, JEAN MARIE",
    "owner2": "",
    "current_taxes": 2480.39,
    "new_taxes_no_override": 2587.54,
    "override_total_1": 2660.96,
    "override_increase_1": 73.42
  },
  {
    "#": "60 Longwood Ave, Unit 601 & P36 (159-04-40)",
    "$": 644200,
    "address": "60 Longwood Ave, Unit 601 & P36",
    "parcel_id": "159-04-40",
    "owner1": "TEICH, JONATHAN M & NANCY D & SUSANNAH",
    "owner2": "",
    "current_taxes": 2961.67,
    "new_taxes_no_override": 3089.61,
    "override_total_1": 3177.28,
    "override_increase_1": 87.67
  },
  {
    "#": "60 Longwood Ave, Unit 602 & P151 (159-04-41)",
    "$": 689100,
    "address": "60 Longwood Ave, Unit 602 & P151",
    "parcel_id": "159-04-41",
    "owner1": "MCNULTY TR, FRANCIS J",
    "owner2": "",
    "current_taxes": 7056.38,
    "new_taxes_no_override": 7361.22,
    "override_total_1": 7570.08,
    "override_increase_1": 208.87
  },
  {
    "#": "60 Longwood Ave, Unit 603 & P101 (159-04-42)",
    "$": 792000,
    "address": "60 Longwood Ave, Unit 603 & P101",
    "parcel_id": "159-04-42",
    "owner1": "PONCE TR, SILVIA A",
    "owner2": "",
    "current_taxes": 4475.15,
    "new_taxes_no_override": 4668.48,
    "override_total_1": 4800.94,
    "override_increase_1": 132.46
  },
  {
    "#": "60 Longwood Ave, Unit 604 & P105 (159-04-43)",
    "$": 977800,
    "address": "60 Longwood Ave, Unit 604 & P105",
    "parcel_id": "159-04-43",
    "owner1": "NAGHIEH, TARANEH",
    "owner2": "",
    "current_taxes": 6377.74,
    "new_taxes_no_override": 6653.26,
    "override_total_1": 6842.04,
    "override_increase_1": 188.78
  },
  {
    "#": "60 Longwood Ave, Unit 605 (159-04-44)",
    "$": 563600,
    "address": "60 Longwood Ave, Unit 605",
    "parcel_id": "159-04-44",
    "owner1": "NAIMAN, DANIEL & LILYA",
    "owner2": "",
    "current_taxes": 5771.26,
    "new_taxes_no_override": 6020.58,
    "override_total_1": 6191.41,
    "override_increase_1": 170.83
  },
  {
    "#": "60 Longwood Ave, Unit 606 (159-04-45)",
    "$": 399600,
    "address": "60 Longwood Ave, Unit 606",
    "parcel_id": "159-04-45",
    "owner1": "BURDENKO TRS, MICHAEL N & GALINA B",
    "owner2": "",
    "current_taxes": 4091.9,
    "new_taxes_no_override": 4268.67,
    "override_total_1": 4389.79,
    "override_increase_1": 121.12
  },
  {
    "#": "60 Longwood Ave, Unit 607 (159-04-46)",
    "$": 614900,
    "address": "60 Longwood Ave, Unit 607",
    "parcel_id": "159-04-46",
    "owner1": "KUNIN, PAUL E",
    "owner2": "AVEDON, NINA A",
    "current_taxes": 2661.64,
    "new_taxes_no_override": 2776.62,
    "override_total_1": 2855.41,
    "override_increase_1": 78.78
  },
  {
    "#": "60 Longwood Ave, Unit 608 & P143 (159-04-47)",
    "$": 688000,
    "address": "60 Longwood Ave, Unit 608 & P143",
    "parcel_id": "159-04-47",
    "owner1": "SANDS, ELIZABETH A",
    "owner2": "",
    "current_taxes": 3410.19,
    "new_taxes_no_override": 3557.51,
    "override_total_1": 3658.45,
    "override_increase_1": 100.94
  },
  {
    "#": "60 Longwood Ave, Unit 609 & P143 (159-04-48)",
    "$": 620100,
    "address": "60 Longwood Ave, Unit 609 & P143",
    "parcel_id": "159-04-48",
    "owner1": "SLAVTCHEVA, DESSISLAVA",
    "owner2": "",
    "current_taxes": 6349.82,
    "new_taxes_no_override": 6624.13,
    "override_total_1": 6812.09,
    "override_increase_1": 187.95
  },
  {
    "#": "60 Longwood Ave, Unit 610 (159-04-49)",
    "$": 572700,
    "address": "60 Longwood Ave, Unit 610",
    "parcel_id": "159-04-49",
    "owner1": "FLORMAN TR, JONATHAN",
    "owner2": "",
    "current_taxes": 5864.45,
    "new_taxes_no_override": 6117.79,
    "override_total_1": 6291.38,
    "override_increase_1": 173.59
  },
  {
    "#": "60 Longwood Ave, Unit 701 & P48 (159-04-50)",
    "$": 608600,
    "address": "60 Longwood Ave, Unit 701 & P48",
    "parcel_id": "159-04-50",
    "owner1": "AGRAWAL, PREM K & SUDHA",
    "owner2": "",
    "current_taxes": 6232.06,
    "new_taxes_no_override": 6501.28,
    "override_total_1": 6685.75,
    "override_increase_1": 184.47
  },
  {
    "#": "60 Longwood Ave, Unit 702 & P62 (159-04-51)",
    "$": 680100,
    "address": "60 Longwood Ave, Unit 702 & P62",
    "parcel_id": "159-04-51",
    "owner1": "TRIPPA, LORENZO",
    "owner2": "",
    "current_taxes": 3329.29,
    "new_taxes_no_override": 3473.12,
    "override_total_1": 3571.66,
    "override_increase_1": 98.55
  },
  {
    "#": "60 Longwood Ave, Unit 703 & P147 (159-04-52)",
    "$": 771200,
    "address": "60 Longwood Ave, Unit 703 & P147",
    "parcel_id": "159-04-52",
    "owner1": "NAGHIEH, TARANEH",
    "owner2": "",
    "current_taxes": 7897.09,
    "new_taxes_no_override": 8238.24,
    "override_total_1": 8472.0,
    "override_increase_1": 233.75
  },
  {
    "#": "60 Longwood Ave, Unit 704 & P54 (159-04-53)",
    "$": 880600,
    "address": "60 Longwood Ave, Unit 704 & P54",
    "parcel_id": "159-04-53",
    "owner1": "BLUMENFELD TRS, HARRY & SONIA",
    "owner2": "",
    "current_taxes": 5382.41,
    "new_taxes_no_override": 5614.93,
    "override_total_1": 5774.25,
    "override_increase_1": 159.32
  },
  {
    "#": "60 Longwood Ave, Unit 705 & P93 (159-04-54)",
    "$": 607100,
    "address": "60 Longwood Ave, Unit 705 & P93",
    "parcel_id": "159-04-54",
    "owner1": "CHANG TRS, DIANA & TEWEN",
    "owner2": "",
    "current_taxes": 6216.7,
    "new_taxes_no_override": 6485.26,
    "override_total_1": 6669.28,
    "override_increase_1": 184.01
  },
  {
    "#": "60 Longwood Ave, Unit 706 & P163 (159-04-55)",
    "$": 496700,
    "address": "60 Longwood Ave, Unit 706 & P163",
    "parcel_id": "159-04-55",
    "owner1": "ESKOT, HERBERT J",
    "owner2": "SAFFRAN, CAROL",
    "current_taxes": 5086.21,
    "new_taxes_no_override": 5305.93,
    "override_total_1": 5456.49,
    "override_increase_1": 150.55
  },
  {
    "#": "60 Longwood Ave, Unit 707 & P162 (159-04-56)",
    "$": 685600,
    "address": "60 Longwood Ave, Unit 707 & P162",
    "parcel_id": "159-04-56",
    "owner1": "PAVLON, JULIE",
    "owner2": "LANDY, RONALD",
    "current_taxes": 7020.54,
    "new_taxes_no_override": 7323.83,
    "override_total_1": 7531.64,
    "override_increase_1": 207.81
  },
  {
    "#": "60 Longwood Ave, Unit 708 & P81 (159-04-57)",
    "$": 691600,
    "address": "60 Longwood Ave, Unit 708 & P81",
    "parcel_id": "159-04-57",
    "owner1": "BRETT TRS, LESLIE A & JESSICA",
    "owner2": "BRETT-FLEEGLER, MARISA",
    "current_taxes": 7081.98,
    "new_taxes_no_override": 7387.92,
    "override_total_1": 7597.55,
    "override_increase_1": 209.63
  },
  {
    "#": "60 Longwood Ave, Unit 709 (159-04-58)",
    "$": 569100,
    "address": "60 Longwood Ave, Unit 709",
    "parcel_id": "159-04-58",
    "owner1": "LIM, HIE SOOK & YOUNSOOK",
    "owner2": "",
    "current_taxes": 2192.65,
    "new_taxes_no_override": 2287.37,
    "override_total_1": 2352.27,
    "override_increase_1": 64.9
  },
  {
    "#": "60 Longwood Ave, Unit 710 & P44 (159-04-59)",
    "$": 598400,
    "address": "60 Longwood Ave, Unit 710 & P44",
    "parcel_id": "159-04-59",
    "owner1": "POURATI, YASAMAN",
    "owner2": "",
    "current_taxes": 6127.62,
    "new_taxes_no_override": 6392.33,
    "override_total_1": 6573.71,
    "override_increase_1": 181.38
  },
  {
    "#": "60 Longwood Ave, Unit 801 & P111 (159-04-60)",
    "$": 703900,
    "address": "60 Longwood Ave, Unit 801 & P111",
    "parcel_id": "159-04-60",
    "owner1": "SHAHBAZI, MITRA",
    "owner2": "",
    "current_taxes": 7207.94,
    "new_taxes_no_override": 7519.32,
    "override_total_1": 7732.68,
    "override_increase_1": 213.36
  },
  {
    "#": "60 Longwood Ave, Unit 802 & P177 (159-04-61)",
    "$": 676100,
    "address": "60 Longwood Ave, Unit 802 & P177",
    "parcel_id": "159-04-61",
    "owner1": "RAO, UMA MP & PAMIDIMAKKALA MV",
    "owner2": "",
    "current_taxes": 6923.26,
    "new_taxes_no_override": 7222.34,
    "override_total_1": 7427.27,
    "override_increase_1": 204.93
  },
  {
    "#": "60 Longwood Ave, Unit 803 & P78 (159-04-62)",
    "$": 760500,
    "address": "60 Longwood Ave, Unit 803 & P78",
    "parcel_id": "159-04-62",
    "owner1": "WANG, HONG",
    "owner2": "",
    "current_taxes": 7787.52,
    "new_taxes_no_override": 8123.94,
    "override_total_1": 8354.45,
    "override_increase_1": 230.51
  },
  {
    "#": "60 Longwood Ave, Unit 804 & P126 (159-04-63)",
    "$": 915500,
    "address": "60 Longwood Ave, Unit 804 & P126",
    "parcel_id": "159-04-63",
    "owner1": "AZENSTEIN, MICHAEL G & ZINAIDA",
    "owner2": "",
    "current_taxes": 5739.79,
    "new_taxes_no_override": 5987.75,
    "override_total_1": 6157.65,
    "override_increase_1": 169.9
  },
  {
    "#": "60 Longwood Ave, Unit 805 & P70 (159-04-64)",
    "$": 575600,
    "address": "60 Longwood Ave, Unit 805 & P70",
    "parcel_id": "159-04-64",
    "owner1": "NI, WEN LIN",
    "owner2": "YU, CHUN FENG",
    "current_taxes": 5894.14,
    "new_taxes_no_override": 6148.77,
    "override_total_1": 6323.23,
    "override_increase_1": 174.47
  },
  {
    "#": "60 Longwood Ave, Unit 806 & P157 (159-04-65)",
    "$": 465000,
    "address": "60 Longwood Ave, Unit 806 & P157",
    "parcel_id": "159-04-65",
    "owner1": "SEEBERGER, PETER H",
    "owner2": "",
    "current_taxes": 4761.6,
    "new_taxes_no_override": 4967.3,
    "override_total_1": 5108.24,
    "override_increase_1": 140.94
  },
  {
    "#": "60 Longwood Ave, Unit 807 & P103 (159-04-66)",
    "$": 687200,
    "address": "60 Longwood Ave, Unit 807 & P103",
    "parcel_id": "159-04-66",
    "owner1": "WOLPERT, SHARON G",
    "owner2": "",
    "current_taxes": 7036.93,
    "new_taxes_no_override": 7340.93,
    "override_total_1": 7549.22,
    "override_increase_1": 208.29
  },
  {
    "#": "60 Longwood Ave, Unit 808 & P115 (159-04-67)",
    "$": 785600,
    "address": "60 Longwood Ave, Unit 808 & P115",
    "parcel_id": "159-04-67",
    "owner1": "SU, DONGMEI",
    "owner2": "",
    "current_taxes": 4409.61,
    "new_taxes_no_override": 4600.11,
    "override_total_1": 4730.63,
    "override_increase_1": 130.52
  },
  {
    "#": "60 Longwood Ave, Unit 809 (159-04-68)",
    "$": 610600,
    "address": "60 Longwood Ave, Unit 809",
    "parcel_id": "159-04-68",
    "owner1": "SOKOLOFF, NATALIE",
    "owner2": "",
    "current_taxes": 2617.61,
    "new_taxes_no_override": 2730.69,
    "override_total_1": 2808.17,
    "override_increase_1": 77.48
  },
  {
    "#": "60 Longwood Ave, Unit 810 & P161 (159-04-69)",
    "$": 708800,
    "address": "60 Longwood Ave, Unit 810 & P161",
    "parcel_id": "159-04-69",
    "owner1": "LEE, SEUNGHAE",
    "owner2": "",
    "current_taxes": 3623.18,
    "new_taxes_no_override": 3779.7,
    "override_total_1": 3886.95,
    "override_increase_1": 107.25
  },
  {
    "#": "60 Longwood Ave, Unit 901&P154 (159-04-70)",
    "$": 607800,
    "address": "60 Longwood Ave, Unit 901&P154",
    "parcel_id": "159-04-70",
    "owner1": "ROSHAN, BIJAN",
    "owner2": "",
    "current_taxes": 6223.87,
    "new_taxes_no_override": 6492.74,
    "override_total_1": 6676.97,
    "override_increase_1": 184.23
  },
  {
    "#": "60 Longwood Ave, Unit 902 & P134 (159-04-71)",
    "$": 752800,
    "address": "60 Longwood Ave, Unit 902 & P134",
    "parcel_id": "159-04-71",
    "owner1": "SHAH, HINA",
    "owner2": "KERALIYA, ABHISHEK",
    "current_taxes": 7708.67,
    "new_taxes_no_override": 8041.68,
    "override_total_1": 8269.86,
    "override_increase_1": 228.18
  },
  {
    "#": "60 Longwood Ave, Unit 903 & P189 (159-04-72)",
    "$": 750100,
    "address": "60 Longwood Ave, Unit 903 & P189",
    "parcel_id": "159-04-72",
    "owner1": "KRAMER, GLORIA",
    "owner2": "",
    "current_taxes": 4046.09,
    "new_taxes_no_override": 4220.88,
    "override_total_1": 4340.65,
    "override_increase_1": 119.76
  },
  {
    "#": "60 Longwood Ave, Unit 904 & P188 (159-04-73)",
    "$": 909200,
    "address": "60 Longwood Ave, Unit 904 & P188",
    "parcel_id": "159-04-73",
    "owner1": "SAFFRAN ET AL TRS, CAROL",
    "owner2": "ANCONINA, BETHANY",
    "current_taxes": 5675.27,
    "new_taxes_no_override": 5920.44,
    "override_total_1": 6088.43,
    "override_increase_1": 167.99
  },
  {
    "#": "60 Longwood Ave, Unit 905 & P176 (159-04-74)",
    "$": 1194800,
    "address": "60 Longwood Ave, Unit 905 & P176",
    "parcel_id": "159-04-74",
    "owner1": "TURNER, PATRICK G",
    "owner2": "RADLEY, KEVIN C",
    "current_taxes": 8599.82,
    "new_taxes_no_override": 8971.33,
    "override_total_1": 9225.89,
    "override_increase_1": 254.55
  },
  {
    "#": "60 Longwood Ave, Unit 907&P24 (159-04-75)",
    "$": 781900,
    "address": "60 Longwood Ave, Unit 907&P24",
    "parcel_id": "159-04-75",
    "owner1": "SHEU, YI HAN",
    "owner2": "",
    "current_taxes": 4371.72,
    "new_taxes_no_override": 4560.58,
    "override_total_1": 4689.98,
    "override_increase_1": 129.4
  },
  {
    "#": "60 Longwood Ave, Unit 908 & P104 (159-04-76)",
    "$": 785600,
    "address": "60 Longwood Ave, Unit 908 & P104",
    "parcel_id": "159-04-76",
    "owner1": "DANG, MATTHEW",
    "owner2": "",
    "current_taxes": 8044.54,
    "new_taxes_no_override": 8392.06,
    "override_total_1": 8630.18,
    "override_increase_1": 238.12
  },
  {
    "#": "60 Longwood Ave, Unit 909 (159-04-77)",
    "$": 543400,
    "address": "60 Longwood Ave, Unit 909",
    "parcel_id": "159-04-77",
    "owner1": "FISHMAN, MARINA",
    "owner2": "SHLAYEN, JEFFREY",
    "current_taxes": 5564.42,
    "new_taxes_no_override": 5804.8,
    "override_total_1": 5969.51,
    "override_increase_1": 164.71
  },
  {
    "#": "60 Longwood Ave, Unit 910 & P119 (159-04-78)",
    "$": 685000,
    "address": "60 Longwood Ave, Unit 910 & P119",
    "parcel_id": "159-04-78",
    "owner1": "RODMAN, DANIEL A",
    "owner2": "",
    "current_taxes": 7014.4,
    "new_taxes_no_override": 7317.42,
    "override_total_1": 7525.05,
    "override_increase_1": 207.63
  },
  {
    "#": "61 Longwood Ave, Unit 1 (158-21-03)",
    "$": 1137800,
    "address": "61 Longwood Ave, Unit 1",
    "parcel_id": "158-21-03",
    "owner1": "POLAK, JOSEPH & REIZEL",
    "owner2": "",
    "current_taxes": 8016.14,
    "new_taxes_no_override": 8362.44,
    "override_total_1": 8599.71,
    "override_increase_1": 237.28
  },
  {
    "#": "61 Longwood Ave, Unit 2 (158-21-01)",
    "$": 1173200,
    "address": "61 Longwood Ave, Unit 2",
    "parcel_id": "158-21-01",
    "owner1": "HORNFELDT, JOHN W JR",
    "owner2": "ETSCOVITZ, SUSAN L",
    "current_taxes": 8378.63,
    "new_taxes_no_override": 8740.59,
    "override_total_1": 8988.59,
    "override_increase_1": 248.01
  },
  {
    "#": "61 Longwood Ave, Unit 3 (158-21-02)",
    "$": 1146400,
    "address": "61 Longwood Ave, Unit 3",
    "parcel_id": "158-21-02",
    "owner1": "DREYFUSS, EVELYNE R",
    "owner2": "",
    "current_taxes": 8104.2,
    "new_taxes_no_override": 8454.3,
    "override_total_1": 8694.19,
    "override_increase_1": 239.88
  },
  {
    "#": "63 Longwood Ave, Unit 1 (158-22-06)",
    "$": 613500,
    "address": "63 Longwood Ave, Unit 1",
    "parcel_id": "158-22-06",
    "owner1": "D ALTON, SUSAN E & JOSEPH G",
    "owner2": "",
    "current_taxes": 6282.24,
    "new_taxes_no_override": 6553.63,
    "override_total_1": 6739.59,
    "override_increase_1": 185.95
  },
  {
    "#": "63 Longwood Ave, Unit 2 (158-22-01)",
    "$": 681500,
    "address": "63 Longwood Ave, Unit 2",
    "parcel_id": "158-22-01",
    "owner1": "DAVIDSON, IDA",
    "owner2": "",
    "current_taxes": 6978.56,
    "new_taxes_no_override": 7280.03,
    "override_total_1": 7486.6,
    "override_increase_1": 206.57
  },
  {
    "#": "63 Longwood Ave, Unit 3 (158-22-02)",
    "$": 615800,
    "address": "63 Longwood Ave, Unit 3",
    "parcel_id": "158-22-02",
    "owner1": "ZHENG, JIANPING",
    "owner2": "JIANG, HONGYU",
    "current_taxes": 6305.79,
    "new_taxes_no_override": 6578.2,
    "override_total_1": 6764.85,
    "override_increase_1": 186.65
  },
  {
    "#": "63 Longwood Ave, Unit 4 (158-22-03)",
    "$": 681600,
    "address": "63 Longwood Ave, Unit 4",
    "parcel_id": "158-22-03",
    "owner1": "63 LONGWOOD 4 REALTY LLC",
    "owner2": "",
    "current_taxes": 6979.58,
    "new_taxes_no_override": 7281.1,
    "override_total_1": 7487.69,
    "override_increase_1": 206.6
  },
  {
    "#": "63 Longwood Ave, Unit 5 (158-22-04)",
    "$": 631100,
    "address": "63 Longwood Ave, Unit 5",
    "parcel_id": "158-22-04",
    "owner1": "63 LONGWOOD 5 REALTY LLC",
    "owner2": "",
    "current_taxes": 6462.46,
    "new_taxes_no_override": 6741.64,
    "override_total_1": 6932.93,
    "override_increase_1": 191.29
  },
  {
    "#": "63 Longwood Ave, Unit 6 (158-22-05)",
    "$": 666200,
    "address": "63 Longwood Ave, Unit 6",
    "parcel_id": "158-22-05",
    "owner1": "ZHA, LI",
    "owner2": "",
    "current_taxes": 3186.95,
    "new_taxes_no_override": 3324.63,
    "override_total_1": 3418.96,
    "override_increase_1": 94.33
  },
  {
    "#": "72 Longwood Ave, Unit 72 (125-24-03)",
    "$": 600800,
    "address": "72 Longwood Ave, Unit 72",
    "parcel_id": "125-24-03",
    "owner1": "CHAPARALA, SUJANA & TIRUMALA",
    "owner2": "",
    "current_taxes": 6152.19,
    "new_taxes_no_override": 6417.96,
    "override_total_1": 6600.07,
    "override_increase_1": 182.1
  },
  {
    "#": "74 Longwood Ave, Unit 74 (125-24-04)",
    "$": 448900,
    "address": "74 Longwood Ave, Unit 74",
    "parcel_id": "125-24-04",
    "owner1": "74 LW LLC",
    "owner2": "",
    "current_taxes": 4596.74,
    "new_taxes_no_override": 4795.32,
    "override_total_1": 4931.38,
    "override_increase_1": 136.06
  },
  {
    "#": "83 Longwood Ave (126-50-00)",
    "$": 3407400,
    "address": "83 Longwood Ave",
    "parcel_id": "126-50-00",
    "owner1": "83 LONGWOOD AVE LLC",
    "owner2": "C/O ALLIED CAPITAL PROPERTIES",
    "current_taxes": 34891.78,
    "new_taxes_no_override": 36399.1,
    "override_total_1": 37431.9,
    "override_increase_1": 1032.8
  },
  {
    "#": "86 Longwood Ave (125-22-23)",
    "$": 30265900,
    "address": "86 Longwood Ave",
    "parcel_id": "125-22-23",
    "owner1": "BROOKLINE HOUSING AUTHORITY",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "89 Longwood Ave (126-51-00)",
    "$": 11603500,
    "address": "89 Longwood Ave",
    "parcel_id": "126-51-00",
    "owner1": "89-95 LONGWOOD AVE LLC",
    "owner2": "",
    "current_taxes": 118819.84,
    "new_taxes_no_override": 123952.86,
    "override_total_1": 127469.92,
    "override_increase_1": 3517.07
  },
  {
    "#": "94 Longwood Ave, Unit A (125-21-00)",
    "$": 12145900,
    "address": "94 Longwood Ave, Unit A",
    "parcel_id": "125-21-00",
    "owner1": "BPG LONGWOOD LLC",
    "owner2": "C/O METROPOLITAN PROPERTIES OF AMERICA INC",
    "current_taxes": 124374.02,
    "new_taxes_no_override": 129746.98,
    "override_total_1": 133428.45,
    "override_increase_1": 3681.47
  },
  {
    "#": "101 Longwood Ave (126-52-00)",
    "$": 2359400,
    "address": "101 Longwood Ave",
    "parcel_id": "126-52-00",
    "owner1": "BANKS, TR, JOSEPH I",
    "owner2": "",
    "current_taxes": 24160.26,
    "new_taxes_no_override": 25203.98,
    "override_total_1": 25919.13,
    "override_increase_1": 715.14
  },
  {
    "#": "103 Longwood Ave (126-52-01)",
    "$": 2031500,
    "address": "103 Longwood Ave",
    "parcel_id": "126-52-01",
    "owner1": "LAWRENCE GROUP LLC",
    "owner2": "",
    "current_taxes": 20802.56,
    "new_taxes_no_override": 21701.23,
    "override_total_1": 22316.99,
    "override_increase_1": 615.76
  },
  {
    "#": "105 Longwood Ave (126-52-02)",
    "$": 2308000,
    "address": "105 Longwood Ave",
    "parcel_id": "126-52-02",
    "owner1": "105 REALTY LLC",
    "owner2": "",
    "current_taxes": 23633.92,
    "new_taxes_no_override": 24654.91,
    "override_total_1": 25354.47,
    "override_increase_1": 699.56
  },
  {
    "#": "106 Longwood Ave (125-19-20)",
    "$": 21923400,
    "address": "106 Longwood Ave",
    "parcel_id": "125-19-20",
    "owner1": "106-116 LONGWOOD AVENUE LLC",
    "owner2": "C/O BOSTON UNION REALTY",
    "current_taxes": 224495.62,
    "new_taxes_no_override": 234193.83,
    "override_total_1": 240838.9,
    "override_increase_1": 6645.07
  },
  {
    "#": "111 Longwood Ave (126-53-00)",
    "$": 2307400,
    "address": "111 Longwood Ave",
    "parcel_id": "126-53-00",
    "owner1": "TAYLOR TRS, LINDA",
    "owner2": "POLGAR, PAUL J",
    "current_taxes": 19992.84,
    "new_taxes_no_override": 20856.53,
    "override_total_1": 21448.32,
    "override_increase_1": 591.79
  },
  {
    "#": "115 Longwood Ave (126-54-00)",
    "$": 2649600,
    "address": "115 Longwood Ave",
    "parcel_id": "126-54-00",
    "owner1": "BAGAI, RADHIKA",
    "owner2": "",
    "current_taxes": 27131.9,
    "new_taxes_no_override": 28304.0,
    "override_total_1": 29107.1,
    "override_increase_1": 803.1
  },
  {
    "#": "121 Longwood Ave, Unit 1A & P2 P10 (126-54-02)",
    "$": 979800,
    "address": "121 Longwood Ave, Unit 1A & P2 P10",
    "parcel_id": "126-54-02",
    "owner1": "GAVRONSKY, STAS",
    "owner2": "DZEVENSKAYA, TATIANA",
    "current_taxes": 10033.15,
    "new_taxes_no_override": 10466.58,
    "override_total_1": 10763.56,
    "override_increase_1": 296.98
  },
  {
    "#": "121 Longwood Ave, Unit 2A (126-54-03)",
    "$": 987900,
    "address": "121 Longwood Ave, Unit 2A",
    "parcel_id": "126-54-03",
    "owner1": "DINATALE, PATRICE",
    "owner2": "",
    "current_taxes": 6481.16,
    "new_taxes_no_override": 6761.15,
    "override_total_1": 6952.99,
    "override_increase_1": 191.84
  },
  {
    "#": "121 Longwood Ave, Unit 2B & P1 (126-54-04)",
    "$": 794000,
    "address": "121 Longwood Ave, Unit 2B & P1",
    "parcel_id": "126-54-04",
    "owner1": "YAAR TRS, ISRAEL & MINA",
    "owner2": "",
    "current_taxes": 8130.56,
    "new_taxes_no_override": 8481.8,
    "override_total_1": 8722.46,
    "override_increase_1": 240.66
  },
  {
    "#": "121 Longwood Ave, Unit 3A & P3 P8 (126-54-05)",
    "$": 1046900,
    "address": "121 Longwood Ave, Unit 3A & P3 P8",
    "parcel_id": "126-54-05",
    "owner1": "YAAR TRS, MINA & ISRAEL",
    "owner2": "",
    "current_taxes": 10720.26,
    "new_taxes_no_override": 11183.38,
    "override_total_1": 11500.69,
    "override_increase_1": 317.32
  },
  {
    "#": "121 Longwood Ave, Unit 3B & P5 (126-54-06)",
    "$": 778100,
    "address": "121 Longwood Ave, Unit 3B & P5",
    "parcel_id": "126-54-06",
    "owner1": "YU, KUN-HSING",
    "owner2": "CHIU, YU-HAN",
    "current_taxes": 4332.81,
    "new_taxes_no_override": 4519.99,
    "override_total_1": 4648.24,
    "override_increase_1": 128.25
  },
  {
    "#": "121 Longwood Ave, Unit 4A P7 P11 (126-54-07)",
    "$": 1040500,
    "address": "121 Longwood Ave, Unit 4A P7 P11",
    "parcel_id": "126-54-07",
    "owner1": "PROLMAN TR, MARJORIE",
    "owner2": "",
    "current_taxes": 10654.72,
    "new_taxes_no_override": 11115.0,
    "override_total_1": 11430.38,
    "override_increase_1": 315.38
  },
  {
    "#": "121 Longwood Ave, Unit 4B & P6 (126-54-08)",
    "$": 777600,
    "address": "121 Longwood Ave, Unit 4B & P6",
    "parcel_id": "126-54-08",
    "owner1": "ZIMBLE, JACOB",
    "owner2": "",
    "current_taxes": 7962.62,
    "new_taxes_no_override": 8306.61,
    "override_total_1": 8542.3,
    "override_increase_1": 235.69
  },
  {
    "#": "123 Longwood Ave (126-55-00)",
    "$": 4842300,
    "address": "123 Longwood Ave",
    "parcel_id": "126-55-00",
    "owner1": "CHAI HOSPITALITY FOUNDATION INC",
    "owner2": "",
    "current_taxes": 83093.87,
    "new_taxes_no_override": 86683.53,
    "override_total_1": 89143.1,
    "override_increase_1": 2459.58
  },
  {
    "#": "124 Longwood Ave, Unit 1 & P1-2 (125-18-01)",
    "$": 1979600,
    "address": "124 Longwood Ave, Unit 1 & P1-2",
    "parcel_id": "125-18-01",
    "owner1": "HUTCHISON, CHRISTOPHER R",
    "owner2": "",
    "current_taxes": 16636.17,
    "new_taxes_no_override": 17354.85,
    "override_total_1": 17847.28,
    "override_increase_1": 492.43
  },
  {
    "#": "124 Longwood Ave, Unit 2 & P3P4 (125-18-02)",
    "$": 1784400,
    "address": "124 Longwood Ave, Unit 2 & P3P4",
    "parcel_id": "125-18-02",
    "owner1": "POMERANTZ, MARK",
    "owner2": "OSMAN, NORA",
    "current_taxes": 14637.32,
    "new_taxes_no_override": 15269.65,
    "override_total_1": 15702.92,
    "override_increase_1": 433.26
  },
  {
    "#": "124 Longwood Ave, Unit 3 & P5 (125-18-03)",
    "$": 1743400,
    "address": "124 Longwood Ave, Unit 3 & P5",
    "parcel_id": "125-18-03",
    "owner1": "SHINDLER, PAUL",
    "owner2": "KOFF, SHAWNA",
    "current_taxes": 14217.48,
    "new_taxes_no_override": 14831.68,
    "override_total_1": 15252.51,
    "override_increase_1": 420.84
  },
  {
    "#": "126 Longwood Ave, Unit 1 (125-17-03)",
    "$": 1391800,
    "address": "126 Longwood Ave, Unit 1",
    "parcel_id": "125-17-03",
    "owner1": "VAN ZANT TRS, NANCY & KENT L",
    "owner2": "",
    "current_taxes": 10617.1,
    "new_taxes_no_override": 11075.76,
    "override_total_1": 11390.02,
    "override_increase_1": 314.27
  },
  {
    "#": "126 Longwood Ave, Unit 2 (125-17-04)",
    "$": 1441900,
    "address": "126 Longwood Ave, Unit 2",
    "parcel_id": "125-17-04",
    "owner1": "GALE TR, MARK S",
    "owner2": "",
    "current_taxes": 11130.12,
    "new_taxes_no_override": 11610.94,
    "override_total_1": 11940.39,
    "override_increase_1": 329.45
  },
  {
    "#": "126 Longwood Ave, Unit 3 (125-17-05)",
    "$": 1459300,
    "address": "126 Longwood Ave, Unit 3",
    "parcel_id": "125-17-05",
    "owner1": "EATHER TR, ROBERT HUGH",
    "owner2": "",
    "current_taxes": 11308.3,
    "new_taxes_no_override": 11796.82,
    "override_total_1": 12131.54,
    "override_increase_1": 334.73
  },
  {
    "#": "126 Longwood Ave, Unit A (125-17-01)",
    "$": 916900,
    "address": "126 Longwood Ave, Unit A",
    "parcel_id": "125-17-01",
    "owner1": "SAMOT, ARIEL & STACY GOMES",
    "owner2": "",
    "current_taxes": 5754.12,
    "new_taxes_no_override": 6002.7,
    "override_total_1": 6173.02,
    "override_increase_1": 170.32
  },
  {
    "#": "126 Longwood Ave, Unit B (125-17-02)",
    "$": 345200,
    "address": "126 Longwood Ave, Unit B",
    "parcel_id": "125-17-02",
    "owner1": "SMITH, TIMOTHY W",
    "owner2": "JORGENSEN, MIRIAM",
    "current_taxes": 3534.85,
    "new_taxes_no_override": 3687.56,
    "override_total_1": 3792.19,
    "override_increase_1": 104.63
  },
  {
    "#": "128 Longwood Ave (125-16-00)",
    "$": 3935900,
    "address": "128 Longwood Ave",
    "parcel_id": "125-16-00",
    "owner1": "ROTHMAN TR, STEVEN A",
    "owner2": "",
    "current_taxes": 40303.62,
    "new_taxes_no_override": 42044.74,
    "override_total_1": 43237.72,
    "override_increase_1": 1192.99
  },
  {
    "#": "130 Longwood Ave, Unit 1A (125-15-01)",
    "$": 728200,
    "address": "130 Longwood Ave, Unit 1A",
    "parcel_id": "125-15-01",
    "owner1": "GOLDENBERG, MYRON",
    "owner2": "",
    "current_taxes": 7456.77,
    "new_taxes_no_override": 7778.9,
    "override_total_1": 7999.62,
    "override_increase_1": 220.72
  },
  {
    "#": "130 Longwood Ave, Unit 1B (125-15-02)",
    "$": 854500,
    "address": "130 Longwood Ave, Unit 1B",
    "parcel_id": "125-15-02",
    "owner1": "GOLDENBERG, MYRON",
    "owner2": "",
    "current_taxes": 5115.15,
    "new_taxes_no_override": 5336.12,
    "override_total_1": 5487.53,
    "override_increase_1": 151.41
  },
  {
    "#": "130 Longwood Ave, Unit 2 (125-15-03)",
    "$": 1657500,
    "address": "130 Longwood Ave, Unit 2",
    "parcel_id": "125-15-03",
    "owner1": "CANNIFF, DANIEL & NATALIE",
    "owner2": "",
    "current_taxes": 13337.87,
    "new_taxes_no_override": 13914.07,
    "override_total_1": 14308.87,
    "override_increase_1": 394.8
  },
  {
    "#": "130 Longwood Ave, Unit 3A (125-15-04)",
    "$": 777600,
    "address": "130 Longwood Ave, Unit 3A",
    "parcel_id": "125-15-04",
    "owner1": "FARAGO TR, PETER T",
    "owner2": "FARAGO, ANNA F",
    "current_taxes": 7962.62,
    "new_taxes_no_override": 8306.61,
    "override_total_1": 8542.3,
    "override_increase_1": 235.69
  },
  {
    "#": "130 Longwood Ave, Unit 3B (125-15-05)",
    "$": 923100,
    "address": "130 Longwood Ave, Unit 3B",
    "parcel_id": "125-15-05",
    "owner1": "QUIST TRS, TERRY CHARLES",
    "owner2": "",
    "current_taxes": 5817.61,
    "new_taxes_no_override": 6068.93,
    "override_total_1": 6241.13,
    "override_increase_1": 172.2
  },
  {
    "#": "130 Longwood Ave, Unit B (125-15-06)",
    "$": 442800,
    "address": "130 Longwood Ave, Unit B",
    "parcel_id": "125-15-06",
    "owner1": "DUGGAN, LAUREL E",
    "owner2": "",
    "current_taxes": 4534.27,
    "new_taxes_no_override": 4730.15,
    "override_total_1": 4864.36,
    "override_increase_1": 134.21
  },
  {
    "#": "131 Longwood Ave (126-10-00)",
    "$": 26439800,
    "address": "131 Longwood Ave",
    "parcel_id": "126-10-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O LONGWOOD PLAYGROUND",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "138 Longwood Ave (122-04-03)",
    "$": 2808100,
    "address": "138 Longwood Ave",
    "parcel_id": "122-04-03",
    "owner1": "WELSH TR, CHRISTINE",
    "owner2": "",
    "current_taxes": 25120.01,
    "new_taxes_no_override": 26205.19,
    "override_total_1": 26948.75,
    "override_increase_1": 743.55
  },
  {
    "#": "141 Longwood Ave (126-57-00)",
    "$": 2674800,
    "address": "141 Longwood Ave",
    "parcel_id": "126-57-00",
    "owner1": "SUGARBAKER TRS, DAVID J & LINDA J",
    "owner2": "",
    "current_taxes": 27389.95,
    "new_taxes_no_override": 28573.2,
    "override_total_1": 29383.94,
    "override_increase_1": 810.74
  },
  {
    "#": "143 Longwood Ave, Unit 1 (126-58-05)",
    "$": 349300,
    "address": "143 Longwood Ave, Unit 1",
    "parcel_id": "126-58-05",
    "owner1": "RENTALS ONE LLC",
    "owner2": "",
    "current_taxes": 3576.83,
    "new_taxes_no_override": 3731.35,
    "override_total_1": 3837.22,
    "override_increase_1": 105.87
  },
  {
    "#": "143 Longwood Ave, Unit 2 (126-58-01)",
    "$": 446400,
    "address": "143 Longwood Ave, Unit 2",
    "parcel_id": "126-58-01",
    "owner1": "POGREBNIAK, IRINA",
    "owner2": "",
    "current_taxes": 4571.14,
    "new_taxes_no_override": 4768.61,
    "override_total_1": 4903.92,
    "override_increase_1": 135.31
  },
  {
    "#": "143 Longwood Ave, Unit 3 (126-58-02)",
    "$": 1026200,
    "address": "143 Longwood Ave, Unit 3",
    "parcel_id": "126-58-02",
    "owner1": "RENTHAL, WILLIAM R & NORA E",
    "owner2": "",
    "current_taxes": 10508.29,
    "new_taxes_no_override": 10962.25,
    "override_total_1": 11273.29,
    "override_increase_1": 311.05
  },
  {
    "#": "143 Longwood Ave, Unit 4 (126-58-03)",
    "$": 1036500,
    "address": "143 Longwood Ave, Unit 4",
    "parcel_id": "126-58-03",
    "owner1": "BUENO TRS, CARLOS M & IVEY R",
    "owner2": "",
    "current_taxes": 6978.83,
    "new_taxes_no_override": 7280.32,
    "override_total_1": 7486.89,
    "override_increase_1": 206.57
  },
  {
    "#": "143 Longwood Ave, Unit 5 (126-58-04)",
    "$": 1016000,
    "address": "143 Longwood Ave, Unit 5",
    "parcel_id": "126-58-04",
    "owner1": "GOLDIE LONGWOOD LLC",
    "owner2": "GOLDEN AMBERWOOD LLC",
    "current_taxes": 10403.84,
    "new_taxes_no_override": 10853.29,
    "override_total_1": 11161.24,
    "override_increase_1": 307.95
  },
  {
    "#": "144 Longwood Ave (122-04-02)",
    "$": 2594700,
    "address": "144 Longwood Ave",
    "parcel_id": "122-04-02",
    "owner1": "KRISHNAN, JAGANNATH G",
    "owner2": "BASKARAN, CHARUMATHI",
    "current_taxes": 22934.79,
    "new_taxes_no_override": 23925.57,
    "override_total_1": 24604.44,
    "override_increase_1": 678.87
  },
  {
    "#": "145 Longwood Ave (126-59-00)",
    "$": 3527500,
    "address": "145 Longwood Ave",
    "parcel_id": "126-59-00",
    "owner1": "WOMBOLDT, JOANNE",
    "owner2": "",
    "current_taxes": 36121.6,
    "new_taxes_no_override": 37682.05,
    "override_total_1": 38751.25,
    "override_increase_1": 1069.2
  },
  {
    "#": "147 Longwood Ave, Unit 1 (126-60-03)",
    "$": 1120700,
    "address": "147 Longwood Ave, Unit 1",
    "parcel_id": "126-60-03",
    "owner1": "HWANG, JOYCE K",
    "owner2": "LIN, LI",
    "current_taxes": 11475.97,
    "new_taxes_no_override": 11971.73,
    "override_total_1": 12311.42,
    "override_increase_1": 339.69
  },
  {
    "#": "147 Longwood Ave, Unit 2 (126-60-01)",
    "$": 1235600,
    "address": "147 Longwood Ave, Unit 2",
    "parcel_id": "126-60-01",
    "owner1": "VAN REENEN, JOHN",
    "owner2": "",
    "current_taxes": 9017.61,
    "new_taxes_no_override": 9407.17,
    "override_total_1": 9674.09,
    "override_increase_1": 266.92
  },
  {
    "#": "147 Longwood Ave, Unit 3 (126-60-02)",
    "$": 1148000,
    "address": "147 Longwood Ave, Unit 3",
    "parcel_id": "126-60-02",
    "owner1": "JACOB TRS, PHILIPPE",
    "owner2": "STINGLE, ANNE F",
    "current_taxes": 8120.59,
    "new_taxes_no_override": 8471.4,
    "override_total_1": 8711.77,
    "override_increase_1": 240.37
  },
  {
    "#": "149 Longwood Ave, Unit 1 (126-61-04)",
    "$": 1555800,
    "address": "149 Longwood Ave, Unit 1",
    "parcel_id": "126-61-04",
    "owner1": "KARNOVSKY, PRISCILLA C & DANIEL P",
    "owner2": "",
    "current_taxes": 12296.46,
    "new_taxes_no_override": 12827.67,
    "override_total_1": 13191.64,
    "override_increase_1": 363.98
  },
  {
    "#": "149 Longwood Ave, Unit 2 (126-61-05)",
    "$": 1155000,
    "address": "149 Longwood Ave, Unit 2",
    "parcel_id": "126-61-05",
    "owner1": "KRASNER, TATE",
    "owner2": "SIMON, RACHEL",
    "current_taxes": 8192.27,
    "new_taxes_no_override": 8546.18,
    "override_total_1": 8788.67,
    "override_increase_1": 242.49
  },
  {
    "#": "149 Longwood Ave, Unit 3 (126-61-06)",
    "$": 1165000,
    "address": "149 Longwood Ave, Unit 3",
    "parcel_id": "126-61-06",
    "owner1": "KRAKOFF TR, CHRISTINA L",
    "owner2": "C/O MCLANE  MIDDLETON",
    "current_taxes": 11929.6,
    "new_taxes_no_override": 12444.96,
    "override_total_1": 12798.07,
    "override_increase_1": 353.12
  },
  {
    "#": "150 Longwood Ave (122-04-01)",
    "$": 2021400,
    "address": "150 Longwood Ave",
    "parcel_id": "122-04-01",
    "owner1": "MANDL, KENNETH D & BETH TEITELL",
    "owner2": "",
    "current_taxes": 17064.2,
    "new_taxes_no_override": 17801.37,
    "override_total_1": 18306.47,
    "override_increase_1": 505.1
  },
  {
    "#": "151 Longwood Ave, Unit 1 (126-62-03)",
    "$": 1576000,
    "address": "151 Longwood Ave, Unit 1",
    "parcel_id": "126-62-03",
    "owner1": "KIRSHENBAUM, DANIEL S & LAURA B",
    "owner2": "",
    "current_taxes": 12503.31,
    "new_taxes_no_override": 13043.45,
    "override_total_1": 13413.55,
    "override_increase_1": 370.1
  },
  {
    "#": "151 Longwood Ave, Unit 2 (126-62-01)",
    "$": 1136800,
    "address": "151 Longwood Ave, Unit 2",
    "parcel_id": "126-62-01",
    "owner1": "RAMADI, KHALIL B & BASEL K",
    "owner2": "FERNANDEZ-CABEZUDO, MARIA J",
    "current_taxes": 11640.83,
    "new_taxes_no_override": 12143.71,
    "override_total_1": 12488.28,
    "override_increase_1": 344.57
  },
  {
    "#": "151 Longwood Ave, Unit 3 (126-62-02)",
    "$": 1036500,
    "address": "151 Longwood Ave, Unit 3",
    "parcel_id": "126-62-02",
    "owner1": "SRIVASTAVA, ANSHUL KUMAR",
    "owner2": "RAJINIKANTH, MONISHA M",
    "current_taxes": 6978.83,
    "new_taxes_no_override": 7280.32,
    "override_total_1": 7486.89,
    "override_increase_1": 206.57
  },
  {
    "#": "155 Longwood Ave (126-63-00)",
    "$": 2835300,
    "address": "155 Longwood Ave",
    "parcel_id": "126-63-00",
    "owner1": "WOMBOLDT, JOANNE",
    "owner2": "",
    "current_taxes": 25398.54,
    "new_taxes_no_override": 26495.76,
    "override_total_1": 27247.55,
    "override_increase_1": 751.8
  },
  {
    "#": "156 Longwood Ave (122-04-00)",
    "$": 2165900,
    "address": "156 Longwood Ave",
    "parcel_id": "122-04-00",
    "owner1": "FEUERSTEIN, HENRY & MIRIAM",
    "owner2": "",
    "current_taxes": 18543.88,
    "new_taxes_no_override": 19344.98,
    "override_total_1": 19893.87,
    "override_increase_1": 548.9
  },
  {
    "#": "159 Longwood Ave (126-64-00)",
    "$": 4046600,
    "address": "159 Longwood Ave",
    "parcel_id": "126-64-00",
    "owner1": "POURATI, FLORA G & EBRAHIM",
    "owner2": "",
    "current_taxes": 37802.25,
    "new_taxes_no_override": 39435.31,
    "override_total_1": 40554.25,
    "override_increase_1": 1118.95
  },
  {
    "#": "165 Longwood Ave (126-65-00)",
    "$": 2414500,
    "address": "165 Longwood Ave",
    "parcel_id": "126-65-00",
    "owner1": "POURATI TRS, FLORA",
    "owner2": "ZARZBI, MANSOUR",
    "current_taxes": 24724.48,
    "new_taxes_no_override": 25792.58,
    "override_total_1": 26524.42,
    "override_increase_1": 731.84
  },
  {
    "#": "173 Longwood Ave (126-66-00)",
    "$": 2518600,
    "address": "173 Longwood Ave",
    "parcel_id": "126-66-00",
    "owner1": "PALEFSKI, SANDRA S & PAUL E",
    "owner2": "",
    "current_taxes": 22155.53,
    "new_taxes_no_override": 23112.65,
    "override_total_1": 23768.45,
    "override_increase_1": 655.8
  },
  {
    "#": "191 Longwood Ave (127-22-01)",
    "$": 1997900,
    "address": "191 Longwood Ave",
    "parcel_id": "127-22-01",
    "owner1": "MORRIS, DONALD J",
    "owner2": "PENDER, SUZANNE G",
    "current_taxes": 16823.56,
    "new_taxes_no_override": 17550.34,
    "override_total_1": 18048.32,
    "override_increase_1": 497.98
  },
  {
    "#": "193 Longwood Ave (127-22-02)",
    "$": 2678200,
    "address": "193 Longwood Ave",
    "parcel_id": "127-22-02",
    "owner1": "LAI, YVONNE",
    "owner2": "BRAT, GABRIEL",
    "current_taxes": 23789.83,
    "new_taxes_no_override": 24817.55,
    "override_total_1": 25521.73,
    "override_increase_1": 704.18
  },
  {
    "#": "197 Longwood Ave (127-03-01)",
    "$": 2128700,
    "address": "197 Longwood Ave",
    "parcel_id": "127-03-01",
    "owner1": "GREENBERG, ROBERTA",
    "owner2": "",
    "current_taxes": 18162.95,
    "new_taxes_no_override": 18947.59,
    "override_total_1": 19485.21,
    "override_increase_1": 537.62
  },
  {
    "#": "199 Longwood Ave (127-03-02)",
    "$": 1939800,
    "address": "199 Longwood Ave",
    "parcel_id": "127-03-02",
    "owner1": "RAYKHTSAUM TRS, AZA",
    "owner2": "ESKIN, JULES",
    "current_taxes": 16228.62,
    "new_taxes_no_override": 16929.7,
    "override_total_1": 17410.06,
    "override_increase_1": 480.37
  },
  {
    "#": "201 Longwood Ave, Unit 1&P1 P2 (127-02-01)",
    "$": 1819500,
    "address": "201 Longwood Ave, Unit 1&P1 P2",
    "parcel_id": "127-02-01",
    "owner1": "SILVERMAN TRS, EDWIN K & RACHEL A",
    "owner2": "",
    "current_taxes": 14996.75,
    "new_taxes_no_override": 15644.61,
    "override_total_1": 16088.51,
    "override_increase_1": 443.9
  },
  {
    "#": "201 Longwood Ave, Unit 2&P3 P4 (127-02-02)",
    "$": 1806100,
    "address": "201 Longwood Ave, Unit 2&P3 P4",
    "parcel_id": "127-02-02",
    "owner1": "TRUOG, DAVID",
    "owner2": "HAHN, GINA M",
    "current_taxes": 14859.53,
    "new_taxes_no_override": 15501.46,
    "override_total_1": 15941.3,
    "override_increase_1": 439.84
  },
  {
    "#": "70 Louise Rd (418-22-00)",
    "$": 18700,
    "address": "70 Louise Rd",
    "parcel_id": "418-22-00",
    "owner1": "80-82 LOUISE ROAD LLC",
    "owner2": "",
    "current_taxes": 191.49,
    "new_taxes_no_override": 199.76,
    "override_total_1": 205.43,
    "override_increase_1": 5.67
  },
  {
    "#": "80 Louise Rd (418-23-00)",
    "$": 31500,
    "address": "80 Louise Rd",
    "parcel_id": "418-23-00",
    "owner1": "80-82 LOUISE ROAD LLC",
    "owner2": "",
    "current_taxes": 322.56,
    "new_taxes_no_override": 336.49,
    "override_total_1": 346.04,
    "override_increase_1": 9.55
  },
  {
    "#": "92 Louise Rd (418-24-00)",
    "$": 31800,
    "address": "92 Louise Rd",
    "parcel_id": "418-24-00",
    "owner1": "YEE TRS, ARNOLD G & JENIFER Y",
    "owner2": "",
    "current_taxes": 325.63,
    "new_taxes_no_override": 339.7,
    "override_total_1": 349.34,
    "override_increase_1": 9.64
  },
  {
    "#": "102 Louise Rd (418-25-00)",
    "$": 22600,
    "address": "102 Louise Rd",
    "parcel_id": "418-25-00",
    "owner1": "102 104 LOUISE ROAD LLC",
    "owner2": "",
    "current_taxes": 231.42,
    "new_taxes_no_override": 241.42,
    "override_total_1": 248.27,
    "override_increase_1": 6.85
  },
  {
    "#": "110 Louise Rd (418-26-00)",
    "$": 7300,
    "address": "110 Louise Rd",
    "parcel_id": "418-26-00",
    "owner1": "ENG TR, FEE KAM",
    "owner2": "",
    "current_taxes": 74.75,
    "new_taxes_no_override": 77.98,
    "override_total_1": 80.19,
    "override_increase_1": 2.21
  },
  {
    "#": "10 Loveland Rd (269A-14-00)",
    "$": 1336600,
    "address": "10 Loveland Rd",
    "parcel_id": "269A-14-00",
    "owner1": "BEKKER, PETER L & PHOEBE D",
    "owner2": "",
    "current_taxes": 10051.85,
    "new_taxes_no_override": 10486.09,
    "override_total_1": 10783.62,
    "override_increase_1": 297.53
  },
  {
    "#": "11 Loveland Rd, Unit 11 (269-12-01)",
    "$": 1054100,
    "address": "11 Loveland Rd, Unit 11",
    "parcel_id": "269-12-01",
    "owner1": "JULIAN, PAMELA",
    "owner2": "",
    "current_taxes": 7159.05,
    "new_taxes_no_override": 7468.32,
    "override_total_1": 7680.23,
    "override_increase_1": 211.91
  },
  {
    "#": "12 Loveland Rd (269A-13-00)",
    "$": 1531800,
    "address": "12 Loveland Rd",
    "parcel_id": "269A-13-00",
    "owner1": "ANDREWS, CHRISTOPHER W & DARYL D",
    "owner2": "",
    "current_taxes": 12050.7,
    "new_taxes_no_override": 12571.29,
    "override_total_1": 12927.99,
    "override_increase_1": 356.7
  },
  {
    "#": "15 Loveland Rd, Unit 15 (269-12-02)",
    "$": 970700,
    "address": "15 Loveland Rd, Unit 15",
    "parcel_id": "269-12-02",
    "owner1": "AMETAJ TRS, ARIAN & DHURATA",
    "owner2": "",
    "current_taxes": 9939.97,
    "new_taxes_no_override": 10369.38,
    "override_total_1": 10663.6,
    "override_increase_1": 294.22
  },
  {
    "#": "16 Loveland Rd (269A-12-00)",
    "$": 1156800,
    "address": "16 Loveland Rd",
    "parcel_id": "269A-12-00",
    "owner1": "MCDONALD TR, ELIZABETH A",
    "owner2": "",
    "current_taxes": 11845.63,
    "new_taxes_no_override": 12357.36,
    "override_total_1": 12707.99,
    "override_increase_1": 350.63
  },
  {
    "#": "20 Loveland Rd (269A-11-00)",
    "$": 1813700,
    "address": "20 Loveland Rd",
    "parcel_id": "269A-11-00",
    "owner1": "SHAVIT, AMINADAV",
    "owner2": "EFRAT, ZINNAR",
    "current_taxes": 14937.35,
    "new_taxes_no_override": 15582.64,
    "override_total_1": 16024.79,
    "override_increase_1": 442.15
  },
  {
    "#": "21 Loveland Rd (269-13-00)",
    "$": 2573800,
    "address": "21 Loveland Rd",
    "parcel_id": "269-13-00",
    "owner1": "EHLERS, MICHAEL D & LAURA J",
    "owner2": "",
    "current_taxes": 22720.78,
    "new_taxes_no_override": 23702.32,
    "override_total_1": 24374.85,
    "override_increase_1": 672.54
  },
  {
    "#": "22 Loveland Rd (269A-10-00)",
    "$": 1154700,
    "address": "22 Loveland Rd",
    "parcel_id": "269A-10-00",
    "owner1": "SHAVIT, AMINADAV & EFRAT ZINNAR",
    "owner2": "",
    "current_taxes": 11824.13,
    "new_taxes_no_override": 12334.93,
    "override_total_1": 12684.93,
    "override_increase_1": 349.99
  },
  {
    "#": "23 Loveland Rd, Unit 23 (269-13-06)",
    "$": 2523700,
    "address": "23 Loveland Rd, Unit 23",
    "parcel_id": "269-13-06",
    "owner1": "TISHLER, JORDAN L & LORI WIVIOTT",
    "owner2": "",
    "current_taxes": 22207.75,
    "new_taxes_no_override": 23167.12,
    "override_total_1": 23824.47,
    "override_increase_1": 657.35
  },
  {
    "#": "25 Loveland Rd, Unit 25 (269-13-07)",
    "$": 2535100,
    "address": "25 Loveland Rd, Unit 25",
    "parcel_id": "269-13-07",
    "owner1": "JESSUP TRS, CHAD J",
    "owner2": "YANG , FEI-SHIUANN CLARISSA",
    "current_taxes": 22324.49,
    "new_taxes_no_override": 23288.91,
    "override_total_1": 23949.71,
    "override_increase_1": 660.8
  },
  {
    "#": "26 Loveland Rd (269A-09-00)",
    "$": 1378500,
    "address": "26 Loveland Rd",
    "parcel_id": "269A-09-00",
    "owner1": "BERK, SIMONE",
    "owner2": "SILVERMAN, JARED A",
    "current_taxes": 10480.91,
    "new_taxes_no_override": 10933.69,
    "override_total_1": 11243.92,
    "override_increase_1": 310.23
  },
  {
    "#": "27 Loveland Rd, Unit 27 (269-13-08)",
    "$": 2161900,
    "address": "27 Loveland Rd, Unit 27",
    "parcel_id": "269-13-08",
    "owner1": "BASS, JONATHAN E",
    "owner2": "ZERA, CHLOE A",
    "current_taxes": 18502.92,
    "new_taxes_no_override": 19302.25,
    "override_total_1": 19849.93,
    "override_increase_1": 547.69
  },
  {
    "#": "29 Loveland Rd, Unit 29 (269-13-09)",
    "$": 2129800,
    "address": "29 Loveland Rd, Unit 29",
    "parcel_id": "269-13-09",
    "owner1": "BLEICHMAR, FERNANDO",
    "owner2": "AGUAYO-MAZZUCATO, CRISTINA",
    "current_taxes": 21809.15,
    "new_taxes_no_override": 22751.31,
    "override_total_1": 23396.86,
    "override_increase_1": 645.55
  },
  {
    "#": "30 Loveland Rd (269A-08-00)",
    "$": 1183900,
    "address": "30 Loveland Rd",
    "parcel_id": "269A-08-00",
    "owner1": "ZHANG, XINWEI",
    "owner2": "WANG, NING",
    "current_taxes": 8488.2,
    "new_taxes_no_override": 8854.89,
    "override_total_1": 9106.14,
    "override_increase_1": 251.25
  },
  {
    "#": "31 Loveland Rd (269-14-00)",
    "$": 1287600,
    "address": "31 Loveland Rd",
    "parcel_id": "269-14-00",
    "owner1": "SELVAGGIO, FRANCIS A",
    "owner2": "BURRILL, NICOLE R",
    "current_taxes": 9550.09,
    "new_taxes_no_override": 9962.65,
    "override_total_1": 10245.34,
    "override_increase_1": 282.68
  },
  {
    "#": "32 Loveland Rd (269A-07-00)",
    "$": 2100900,
    "address": "32 Loveland Rd",
    "parcel_id": "269A-07-00",
    "owner1": "ANDERSEN, JANNIK",
    "owner2": "SCHMIDT, LISE LOTTE",
    "current_taxes": 17878.28,
    "new_taxes_no_override": 18650.62,
    "override_total_1": 19179.82,
    "override_increase_1": 529.2
  },
  {
    "#": "35 Loveland Rd (269-15-00)",
    "$": 1187900,
    "address": "35 Loveland Rd",
    "parcel_id": "269-15-00",
    "owner1": "BURKE TRS, STEPHEN H & JANET M",
    "owner2": "",
    "current_taxes": 8529.16,
    "new_taxes_no_override": 8897.62,
    "override_total_1": 9150.08,
    "override_increase_1": 252.46
  },
  {
    "#": "36 Loveland Rd, Unit 36 (269A-06-02)",
    "$": 1429900,
    "address": "36 Loveland Rd, Unit 36",
    "parcel_id": "269A-06-02",
    "owner1": "OSMANI, NOMAN & HAMEDA",
    "owner2": "",
    "current_taxes": 11007.24,
    "new_taxes_no_override": 11482.75,
    "override_total_1": 11808.57,
    "override_increase_1": 325.81
  },
  {
    "#": "38 Loveland Rd, Unit 38 (269A-06-03)",
    "$": 1750400,
    "address": "38 Loveland Rd, Unit 38",
    "parcel_id": "269A-06-03",
    "owner1": "OSMANI, YOUSAF",
    "owner2": "",
    "current_taxes": 14289.16,
    "new_taxes_no_override": 14906.45,
    "override_total_1": 15329.41,
    "override_increase_1": 422.96
  },
  {
    "#": "39 Loveland Rd (269-16-00)",
    "$": 1191200,
    "address": "39 Loveland Rd",
    "parcel_id": "269-16-00",
    "owner1": "EASH, BRANDON & SYLVIA",
    "owner2": "",
    "current_taxes": 8562.95,
    "new_taxes_no_override": 8932.87,
    "override_total_1": 9186.33,
    "override_increase_1": 253.46
  },
  {
    "#": "42 Loveland Rd (269A-05-00)",
    "$": 1985700,
    "address": "42 Loveland Rd",
    "parcel_id": "269A-05-00",
    "owner1": "MILLER LIFE ESTATE, CHARLES J & SUSAN E",
    "owner2": "",
    "current_taxes": 16698.63,
    "new_taxes_no_override": 17420.01,
    "override_total_1": 17914.29,
    "override_increase_1": 494.28
  },
  {
    "#": "43 Loveland Rd (269-16-01)",
    "$": 1208200,
    "address": "43 Loveland Rd",
    "parcel_id": "269-16-01",
    "owner1": "WALSH, DOMINIC M & NUALA B",
    "owner2": "",
    "current_taxes": 8737.03,
    "new_taxes_no_override": 9114.47,
    "override_total_1": 9373.09,
    "override_increase_1": 258.62
  },
  {
    "#": "48 Loveland Rd, Unit 1 (269A-04-01)",
    "$": 818100,
    "address": "48 Loveland Rd, Unit 1",
    "parcel_id": "269A-04-01",
    "owner1": "SPURR TR, MICHAEL",
    "owner2": "",
    "current_taxes": 8377.34,
    "new_taxes_no_override": 8739.24,
    "override_total_1": 8987.21,
    "override_increase_1": 247.97
  },
  {
    "#": "48 Loveland Rd, Unit 2 (269A-04-02)",
    "$": 1135500,
    "address": "48 Loveland Rd, Unit 2",
    "parcel_id": "269A-04-02",
    "owner1": "MCGRATH, MEGHAN",
    "owner2": "SHELDRICK, RADLEY C",
    "current_taxes": 7992.59,
    "new_taxes_no_override": 8337.87,
    "override_total_1": 8574.45,
    "override_increase_1": 236.58
  },
  {
    "#": "52 Loveland Rd (269A-02-00)",
    "$": 1314900,
    "address": "52 Loveland Rd",
    "parcel_id": "269A-02-00",
    "owner1": "LAU, YAT P",
    "owner2": "SAU, W K",
    "current_taxes": 9829.64,
    "new_taxes_no_override": 10254.28,
    "override_total_1": 10545.24,
    "override_increase_1": 290.96
  },
  {
    "#": "20 Lowell Ln (337-15-00)",
    "$": 8451800,
    "address": "20 Lowell Ln",
    "parcel_id": "337-15-00",
    "owner1": "ABRAMS, DAVID C & AMY",
    "owner2": "",
    "current_taxes": 86546.43,
    "new_taxes_no_override": 90285.24,
    "override_total_1": 92847.01,
    "override_increase_1": 2561.77
  },
  {
    "#": "36 Lowell Ln (337-16-00)",
    "$": 9891000,
    "address": "36 Lowell Ln",
    "parcel_id": "337-16-00",
    "owner1": "KATZ, JONATHAN M",
    "owner2": "ITO, BARBARA A",
    "current_taxes": 97648.91,
    "new_taxes_no_override": 101867.34,
    "override_total_1": 104757.75,
    "override_increase_1": 2890.41
  },
  {
    "#": "8 Lowell Rd (201-16-01)",
    "$": 2450300,
    "address": "8 Lowell Rd",
    "parcel_id": "201-16-01",
    "owner1": "AMES, RICHARD M",
    "owner2": "PERKINS, MARGARET",
    "current_taxes": 21456.14,
    "new_taxes_no_override": 22383.05,
    "override_total_1": 23018.15,
    "override_increase_1": 635.1
  },
  {
    "#": "11 Lowell Rd (202-02-00)",
    "$": 2722000,
    "address": "11 Lowell Rd",
    "parcel_id": "202-02-00",
    "owner1": "SACKS TRS, PETER W",
    "owner2": "JACOBS, DEBORAH S",
    "current_taxes": 24238.35,
    "new_taxes_no_override": 25285.45,
    "override_total_1": 26002.9,
    "override_increase_1": 717.46
  },
  {
    "#": "12 Lowell Rd (201-16-00)",
    "$": 2765400,
    "address": "12 Lowell Rd",
    "parcel_id": "201-16-00",
    "owner1": "MCKENZIE, ANDREW L",
    "owner2": "XU, SHUANG",
    "current_taxes": 24682.76,
    "new_taxes_no_override": 25749.06,
    "override_total_1": 26479.66,
    "override_increase_1": 730.61
  },
  {
    "#": "17 Lowell Rd (202-03-00)",
    "$": 2468200,
    "address": "17 Lowell Rd",
    "parcel_id": "202-03-00",
    "owner1": "KENET, TAI",
    "owner2": "KATZ, DANIEL P",
    "current_taxes": 21639.43,
    "new_taxes_no_override": 22574.25,
    "override_total_1": 23214.78,
    "override_increase_1": 640.53
  },
  {
    "#": "18 Lowell Rd (201-15-00)",
    "$": 76000,
    "address": "18 Lowell Rd",
    "parcel_id": "201-15-00",
    "owner1": "O'BRIEN TRS, MARGARET & PATRICK J JR",
    "owner2": "",
    "current_taxes": 778.24,
    "new_taxes_no_override": 811.86,
    "override_total_1": 834.9,
    "override_increase_1": 23.04
  },
  {
    "#": "21 Lowell Rd (202-04-00)",
    "$": 2678100,
    "address": "21 Lowell Rd",
    "parcel_id": "202-04-00",
    "owner1": "LECARME TRS, ALEXANDRE",
    "owner2": "KWOK, SARITA",
    "current_taxes": 23788.81,
    "new_taxes_no_override": 24816.49,
    "override_total_1": 25520.64,
    "override_increase_1": 704.15
  },
  {
    "#": "22 Lowell Rd (201-14-00)",
    "$": 3065200,
    "address": "22 Lowell Rd",
    "parcel_id": "201-14-00",
    "owner1": "OBRIEN TRS, MARGARET & PATRICK J JR",
    "owner2": "",
    "current_taxes": 27752.71,
    "new_taxes_no_override": 28951.63,
    "override_total_1": 29773.11,
    "override_increase_1": 821.48
  },
  {
    "#": "29 Lowell Rd (202-05-00)",
    "$": 3058000,
    "address": "29 Lowell Rd",
    "parcel_id": "202-05-00",
    "owner1": "KONG, YUAN",
    "owner2": "MA, HAOBO",
    "current_taxes": 27678.99,
    "new_taxes_no_override": 28874.72,
    "override_total_1": 29694.02,
    "override_increase_1": 819.3
  },
  {
    "#": "32 Lowell Rd (201-13-00)",
    "$": 2680000,
    "address": "32 Lowell Rd",
    "parcel_id": "201-13-00",
    "owner1": "KAHN, MICHAEL W",
    "owner2": "VARHELYI, ZSUZSANNA",
    "current_taxes": 23808.27,
    "new_taxes_no_override": 24836.79,
    "override_total_1": 25541.51,
    "override_increase_1": 704.72
  },
  {
    "#": "37 Lowell Rd (202-06-00)",
    "$": 2742300,
    "address": "37 Lowell Rd",
    "parcel_id": "202-06-00",
    "owner1": "SAPOZNIK TRS, MAURICE & CAROL",
    "owner2": "",
    "current_taxes": 24446.22,
    "new_taxes_no_override": 25502.3,
    "override_total_1": 26225.9,
    "override_increase_1": 723.61
  },
  {
    "#": "42 Lowell Rd (201-12-00)",
    "$": 2802800,
    "address": "42 Lowell Rd",
    "parcel_id": "201-12-00",
    "owner1": "GUILLEMIN TR, JENYA",
    "owner2": "",
    "current_taxes": 25065.74,
    "new_taxes_no_override": 26148.58,
    "override_total_1": 26890.53,
    "override_increase_1": 741.95
  },
  {
    "#": "10 Lyman Rd (437-39-00)",
    "$": 7939200,
    "address": "10 Lyman Rd",
    "parcel_id": "437-39-00",
    "owner1": "418 RE LYMAN LLC",
    "owner2": "",
    "current_taxes": 81297.41,
    "new_taxes_no_override": 84809.46,
    "override_total_1": 87215.86,
    "override_increase_1": 2406.4
  },
  {
    "#": "30 Lyman Rd (437-38-00)",
    "$": 7735200,
    "address": "30 Lyman Rd",
    "parcel_id": "437-38-00",
    "owner1": "SAMUELS TR, SUZANNE J",
    "owner2": "",
    "current_taxes": 75573.51,
    "new_taxes_no_override": 78838.29,
    "override_total_1": 81075.26,
    "override_increase_1": 2236.98
  },
  {
    "#": "33 Lyman Rd (437-25-00)",
    "$": 8461100,
    "address": "33 Lyman Rd",
    "parcel_id": "437-25-00",
    "owner1": "33 CHESTNUT HILL LLC",
    "owner2": "",
    "current_taxes": 86641.66,
    "new_taxes_no_override": 90384.58,
    "override_total_1": 92949.17,
    "override_increase_1": 2564.59
  },
  {
    "#": "45 Lyman Rd (437-26-00)",
    "$": 6179000,
    "address": "45 Lyman Rd",
    "parcel_id": "437-26-00",
    "owner1": "MISSAGHI, KATAYOUN LALEHPOUR",
    "owner2": "",
    "current_taxes": 59638.03,
    "new_taxes_no_override": 62214.39,
    "override_total_1": 63979.68,
    "override_increase_1": 1765.29
  },
  {
    "#": "50 Lyman Rd (437-37-00)",
    "$": 8464300,
    "address": "50 Lyman Rd",
    "parcel_id": "437-37-00",
    "owner1": "WU, YANLING",
    "owner2": "",
    "current_taxes": 83039.5,
    "new_taxes_no_override": 86626.81,
    "override_total_1": 89084.78,
    "override_increase_1": 2457.97
  },
  {
    "#": "55 Lyman Rd (437-27-01)",
    "$": 8967600,
    "address": "55 Lyman Rd",
    "parcel_id": "437-27-01",
    "owner1": "PANAYIOTOPOULOS, PARIS & MARIE CLAIRE",
    "owner2": "",
    "current_taxes": 91828.22,
    "new_taxes_no_override": 95795.2,
    "override_total_1": 98513.31,
    "override_increase_1": 2718.12
  },
  {
    "#": "60 Lyman Rd (437-36-00)",
    "$": 2714400,
    "address": "60 Lyman Rd",
    "parcel_id": "437-36-00",
    "owner1": "LIVING WATER DEVELOPMENT LLC",
    "owner2": "",
    "current_taxes": 27795.46,
    "new_taxes_no_override": 28996.22,
    "override_total_1": 29818.97,
    "override_increase_1": 822.75
  },
  {
    "#": "80 Lyman Rd (437-34-00)",
    "$": 6710900,
    "address": "80 Lyman Rd",
    "parcel_id": "437-34-00",
    "owner1": "ROSENGARD, BRUCE R & ARIELLA M",
    "owner2": "",
    "current_taxes": 65084.68,
    "new_taxes_no_override": 67896.34,
    "override_total_1": 69822.84,
    "override_increase_1": 1926.51
  },
  {
    "#": "96 Lyman Rd (437-33-00)",
    "$": 5144000,
    "address": "96 Lyman Rd",
    "parcel_id": "437-33-00",
    "owner1": "LURIE, CATHY J",
    "owner2": "",
    "current_taxes": 49039.63,
    "new_taxes_no_override": 51158.14,
    "override_total_1": 52609.72,
    "override_increase_1": 1451.57
  },
  {
    "#": "99 Lyman Rd (437-28-00)",
    "$": 3854800,
    "address": "99 Lyman Rd",
    "parcel_id": "437-28-00",
    "owner1": "FLORENCE TR, CHARLOTTE",
    "owner2": "",
    "current_taxes": 35838.22,
    "new_taxes_no_override": 37386.43,
    "override_total_1": 38447.24,
    "override_increase_1": 1060.81
  },
  {
    "#": "105 Lyman Rd (437-29-00)",
    "$": 4454700,
    "address": "105 Lyman Rd",
    "parcel_id": "437-29-00",
    "owner1": "ZHANG, XIAOHUA",
    "owner2": "ZHOU, QUAN",
    "current_taxes": 45616.13,
    "new_taxes_no_override": 47586.75,
    "override_total_1": 48936.98,
    "override_increase_1": 1350.24
  },
  {
    "#": "110 Lyman Rd (437-32-00)",
    "$": 5923700,
    "address": "110 Lyman Rd",
    "parcel_id": "437-32-00",
    "owner1": "MARKS, TR, NANCY LURIE",
    "owner2": "",
    "current_taxes": 60658.69,
    "new_taxes_no_override": 63279.15,
    "override_total_1": 65074.64,
    "override_increase_1": 1795.5
  },
  {
    "#": "111 Lyman Rd (437-30-00)",
    "$": 2694700,
    "address": "111 Lyman Rd",
    "parcel_id": "437-30-00",
    "owner1": "111 LYMAN ROAD REALTY LLC",
    "owner2": "",
    "current_taxes": 27593.73,
    "new_taxes_no_override": 28785.78,
    "override_total_1": 29602.55,
    "override_increase_1": 816.77
  },
  {
    "#": "117 Lyman Rd (437-31-00)",
    "$": 4746600,
    "address": "117 Lyman Rd",
    "parcel_id": "437-31-00",
    "owner1": "DRORY, NIR & SIVIAN",
    "owner2": "",
    "current_taxes": 44970.25,
    "new_taxes_no_override": 46912.96,
    "override_total_1": 48244.08,
    "override_increase_1": 1331.12
  },
  {
    "#": "8 Lyon Rd (423-01-01)",
    "$": 2225600,
    "address": "8 Lyon Rd",
    "parcel_id": "423-01-01",
    "owner1": "CHANG, JONATHAN",
    "owner2": "JAIN, RUCHI",
    "current_taxes": 19155.21,
    "new_taxes_no_override": 19982.72,
    "override_total_1": 20549.71,
    "override_increase_1": 566.99
  },
  {
    "#": "11 Lyon Rd (423-02-04)",
    "$": 1852300,
    "address": "11 Lyon Rd",
    "parcel_id": "423-02-04",
    "owner1": "CUNNINGHAM TRS, JONATHAN WOO",
    "owner2": "LAU, EMILY",
    "current_taxes": 15332.62,
    "new_taxes_no_override": 15994.99,
    "override_total_1": 16448.83,
    "override_increase_1": 453.85
  },
  {
    "#": "12 Lyon Rd (423-01-02)",
    "$": 1674000,
    "address": "12 Lyon Rd",
    "parcel_id": "423-01-02",
    "owner1": "HANNA, DORIS",
    "owner2": "LYSAGHT, PETER F",
    "current_taxes": 13506.83,
    "new_taxes_no_override": 14090.33,
    "override_total_1": 14490.13,
    "override_increase_1": 399.8
  },
  {
    "#": "19 Lyon Rd (423-02-05)",
    "$": 2774000,
    "address": "19 Lyon Rd",
    "parcel_id": "423-02-05",
    "owner1": "ANAND, AMIT & VIBHA",
    "owner2": "",
    "current_taxes": 24770.83,
    "new_taxes_no_override": 25840.93,
    "override_total_1": 26574.15,
    "override_increase_1": 733.22
  },
  {
    "#": "20 Lyon Rd (423-43-00)",
    "$": 2765400,
    "address": "20 Lyon Rd",
    "parcel_id": "423-43-00",
    "owner1": "TARBOX, MELINDA ANNE & JOHN DAVID",
    "owner2": "",
    "current_taxes": 24682.76,
    "new_taxes_no_override": 25749.06,
    "override_total_1": 26479.66,
    "override_increase_1": 730.61
  },
  {
    "#": "27 Lyon Rd (423-02-06)",
    "$": 1366800,
    "address": "27 Lyon Rd",
    "parcel_id": "423-02-06",
    "owner1": "GERSTEL-FRIEDMAN, FELICE E",
    "owner2": "OLIVERI, MICHAEL A",
    "current_taxes": 10361.1,
    "new_taxes_no_override": 10808.7,
    "override_total_1": 11115.39,
    "override_increase_1": 306.69
  },
  {
    "#": "28 Lyon Rd (423-45-00)",
    "$": 1094800,
    "address": "28 Lyon Rd",
    "parcel_id": "423-45-00",
    "owner1": "COHEN, SHIMON",
    "owner2": "HALPERIN, YONATHAN",
    "current_taxes": 11210.75,
    "new_taxes_no_override": 11695.05,
    "override_total_1": 12026.89,
    "override_increase_1": 331.84
  },
  {
    "#": "30 Lyon Rd (423-44-00)",
    "$": 3217100,
    "address": "30 Lyon Rd",
    "parcel_id": "423-44-00",
    "owner1": "SHROFF TRS, NEMIT & NIKETA",
    "owner2": "",
    "current_taxes": 29308.17,
    "new_taxes_no_override": 30574.28,
    "override_total_1": 31441.8,
    "override_increase_1": 867.52
  },
  {
    "#": "11 Manchester Rd (053-02-00)",
    "$": 2297900,
    "address": "11 Manchester Rd",
    "parcel_id": "053-02-00",
    "owner1": "HU, THOMAS C",
    "owner2": "ZHANG, DOROTHY",
    "current_taxes": 19895.56,
    "new_taxes_no_override": 20755.05,
    "override_total_1": 21343.96,
    "override_increase_1": 588.91
  },
  {
    "#": "12 Manchester Rd (049-02-00)",
    "$": 3015400,
    "address": "12 Manchester Rd",
    "parcel_id": "049-02-00",
    "owner1": "EL FAKHRI, GEORGES",
    "owner2": "LIM, RUTH",
    "current_taxes": 30877.7,
    "new_taxes_no_override": 32211.62,
    "override_total_1": 33125.6,
    "override_increase_1": 913.98
  },
  {
    "#": "16 Manchester Rd (049-01-00)",
    "$": 2996200,
    "address": "16 Manchester Rd",
    "parcel_id": "049-01-00",
    "owner1": "WIENER TRS, WILLIAM &  ITA N & ADAM A",
    "owner2": "",
    "current_taxes": 27046.15,
    "new_taxes_no_override": 28214.54,
    "override_total_1": 29015.11,
    "override_increase_1": 800.57
  },
  {
    "#": "17 Manchester Rd (053-03-00)",
    "$": 3714300,
    "address": "17 Manchester Rd",
    "parcel_id": "053-03-00",
    "owner1": "GUPTA TRS, SRISHTI",
    "owner2": "NARASIMHAN, VASANT K",
    "current_taxes": 38034.43,
    "new_taxes_no_override": 39677.52,
    "override_total_1": 40803.34,
    "override_increase_1": 1125.82
  },
  {
    "#": "23 Manchester Rd, Unit 1 P-1 G-1 (053-04-02)",
    "$": 1445400,
    "address": "23 Manchester Rd, Unit 1 P-1 G-1",
    "parcel_id": "053-04-02",
    "owner1": "INBAR, SHAI",
    "owner2": "BARON, CYNTHIA",
    "current_taxes": 11165.96,
    "new_taxes_no_override": 11648.33,
    "override_total_1": 11978.84,
    "override_increase_1": 330.51
  },
  {
    "#": "23 Manchester Rd, Unit 2 P-2 P-3 (053-04-01)",
    "$": 1638900,
    "address": "23 Manchester Rd, Unit 2 P-2 P-3",
    "parcel_id": "053-04-01",
    "owner1": "INBAR, SHAI",
    "owner2": "BARON, CYNTHIA",
    "current_taxes": 16782.34,
    "new_taxes_no_override": 17507.34,
    "override_total_1": 18004.09,
    "override_increase_1": 496.76
  },
  {
    "#": "28 Manchester Rd, Unit 1 (052-08-01)",
    "$": 1440200,
    "address": "28 Manchester Rd, Unit 1",
    "parcel_id": "052-08-01",
    "owner1": "MCILWRAITH, ANDREW & LETITIA",
    "owner2": "",
    "current_taxes": 11112.71,
    "new_taxes_no_override": 11592.78,
    "override_total_1": 11921.72,
    "override_increase_1": 328.94
  },
  {
    "#": "28 Manchester Rd, Unit 2 (052-08-02)",
    "$": 1532100,
    "address": "28 Manchester Rd, Unit 2",
    "parcel_id": "052-08-02",
    "owner1": "MCILWRAITH, LETITIA & ANDREW J",
    "owner2": "",
    "current_taxes": 15688.7,
    "new_taxes_no_override": 16366.45,
    "override_total_1": 16830.84,
    "override_increase_1": 464.39
  },
  {
    "#": "29 Manchester Rd (053-05-00)",
    "$": 3042300,
    "address": "29 Manchester Rd",
    "parcel_id": "053-05-00",
    "owner1": "BATCHELOR, JAMES P & CLARA C",
    "owner2": "",
    "current_taxes": 27518.22,
    "new_taxes_no_override": 28707.01,
    "override_total_1": 29521.55,
    "override_increase_1": 814.54
  },
  {
    "#": "32 Manchester Rd (052-07-00)",
    "$": 1849800,
    "address": "32 Manchester Rd",
    "parcel_id": "052-07-00",
    "owner1": "32 MANCHESTER ROAD LLC",
    "owner2": "",
    "current_taxes": 18941.95,
    "new_taxes_no_override": 19760.24,
    "override_total_1": 20320.92,
    "override_increase_1": 560.68
  },
  {
    "#": "33 Manchester Rd (053-06-00)",
    "$": 4193800,
    "address": "33 Manchester Rd",
    "parcel_id": "053-06-00",
    "owner1": "NANDA, TOBIAS & ALISHA",
    "owner2": "",
    "current_taxes": 39309.58,
    "new_taxes_no_override": 41007.75,
    "override_total_1": 42171.32,
    "override_increase_1": 1163.56
  },
  {
    "#": "34 Manchester Rd (052-06-00)",
    "$": 2643600,
    "address": "34 Manchester Rd",
    "parcel_id": "052-06-00",
    "owner1": "EGOZY, ERAN B & YUKIKO U",
    "owner2": "",
    "current_taxes": 27070.46,
    "new_taxes_no_override": 28239.9,
    "override_total_1": 29041.19,
    "override_increase_1": 801.29
  },
  {
    "#": "41 Manchester Rd (053-07-00)",
    "$": 1918900,
    "address": "41 Manchester Rd",
    "parcel_id": "053-07-00",
    "owner1": "LEUNG-YUE, CINDY",
    "owner2": "",
    "current_taxes": 16014.6,
    "new_taxes_no_override": 16706.43,
    "override_total_1": 17180.46,
    "override_increase_1": 474.03
  },
  {
    "#": "42 Manchester Rd (052-05-00)",
    "$": 3619600,
    "address": "42 Manchester Rd",
    "parcel_id": "052-05-00",
    "owner1": "HARRIS, PETER",
    "owner2": "",
    "current_taxes": 33429.77,
    "new_taxes_no_override": 34873.94,
    "override_total_1": 35863.46,
    "override_increase_1": 989.52
  },
  {
    "#": "47 Manchester Rd (053-08-00)",
    "$": 1786300,
    "address": "47 Manchester Rd",
    "parcel_id": "053-08-00",
    "owner1": "GOODWIN TR, RHODA S",
    "owner2": "",
    "current_taxes": 14656.78,
    "new_taxes_no_override": 15289.95,
    "override_total_1": 15723.79,
    "override_increase_1": 433.84
  },
  {
    "#": "48 Manchester Rd (052-04-00)",
    "$": 3412400,
    "address": "48 Manchester Rd",
    "parcel_id": "052-04-00",
    "owner1": "HEIMDALL LLC",
    "owner2": "C/O MA-LUNG CHEN",
    "current_taxes": 34942.98,
    "new_taxes_no_override": 36452.52,
    "override_total_1": 37486.83,
    "override_increase_1": 1034.31
  },
  {
    "#": "51 Manchester Rd, Unit 1 (053-09-22)",
    "$": 623700,
    "address": "51 Manchester Rd, Unit 1",
    "parcel_id": "053-09-22",
    "owner1": "KRINSKY REALTY CO INC",
    "owner2": "C/O GOLDMAN",
    "current_taxes": 6386.69,
    "new_taxes_no_override": 6662.6,
    "override_total_1": 6851.64,
    "override_increase_1": 189.05
  },
  {
    "#": "51 Manchester Rd, Unit 3 (053-09-02)",
    "$": 794400,
    "address": "51 Manchester Rd, Unit 3",
    "parcel_id": "053-09-02",
    "owner1": "KRINSKY REALTY CO INC",
    "owner2": "C/O GOLDMAN",
    "current_taxes": 8134.66,
    "new_taxes_no_override": 8486.08,
    "override_total_1": 8726.86,
    "override_increase_1": 240.79
  },
  {
    "#": "51 Manchester Rd, Unit 51-2 (053-09-01)",
    "$": 775000,
    "address": "51 Manchester Rd, Unit 51-2",
    "parcel_id": "053-09-01",
    "owner1": "GOLDMAN, ELLEN L",
    "owner2": "C/O MCCABE ELLEN",
    "current_taxes": 7936.0,
    "new_taxes_no_override": 8278.84,
    "override_total_1": 8513.74,
    "override_increase_1": 234.91
  },
  {
    "#": "53 Manchester Rd, Unit 1 (053-09-03)",
    "$": 559200,
    "address": "53 Manchester Rd, Unit 1",
    "parcel_id": "053-09-03",
    "owner1": "KRINSKY REALTY CO INC",
    "owner2": "C/O GOLDMAN",
    "current_taxes": 5726.21,
    "new_taxes_no_override": 5973.58,
    "override_total_1": 6143.08,
    "override_increase_1": 169.5
  },
  {
    "#": "53 Manchester Rd, Unit 2 (053-09-04)",
    "$": 531500,
    "address": "53 Manchester Rd, Unit 2",
    "parcel_id": "053-09-04",
    "owner1": "KRINSKY REALTY CO INC",
    "owner2": "C/O GOLDMAN",
    "current_taxes": 5442.56,
    "new_taxes_no_override": 5677.68,
    "override_total_1": 5838.78,
    "override_increase_1": 161.1
  },
  {
    "#": "53 Manchester Rd, Unit 3 (053-09-05)",
    "$": 703800,
    "address": "53 Manchester Rd, Unit 3",
    "parcel_id": "053-09-05",
    "owner1": "KRINSKY REALTY CO INC",
    "owner2": "C/O GOLDMAN",
    "current_taxes": 7206.91,
    "new_taxes_no_override": 7518.25,
    "override_total_1": 7731.57,
    "override_increase_1": 213.32
  },
  {
    "#": "53 Manchester Rd, Unit 4 (053-09-06)",
    "$": 531500,
    "address": "53 Manchester Rd, Unit 4",
    "parcel_id": "053-09-06",
    "owner1": "KRINSKY REALTY CO INC",
    "owner2": "C/O GOLDMAN",
    "current_taxes": 5442.56,
    "new_taxes_no_override": 5677.68,
    "override_total_1": 5838.78,
    "override_increase_1": 161.1
  },
  {
    "#": "53 Manchester Rd, Unit 5 (053-09-07)",
    "$": 703800,
    "address": "53 Manchester Rd, Unit 5",
    "parcel_id": "053-09-07",
    "owner1": "KRINSKY REALTY CO INC",
    "owner2": "C/O GOLDMAN",
    "current_taxes": 7206.91,
    "new_taxes_no_override": 7518.25,
    "override_total_1": 7731.57,
    "override_increase_1": 213.32
  },
  {
    "#": "53 Manchester Rd, Unit 6 (053-09-08)",
    "$": 531500,
    "address": "53 Manchester Rd, Unit 6",
    "parcel_id": "053-09-08",
    "owner1": "KRINSKY REALTY CO INC",
    "owner2": "C/O GOLDMAN",
    "current_taxes": 5442.56,
    "new_taxes_no_override": 5677.68,
    "override_total_1": 5838.78,
    "override_increase_1": 161.1
  },
  {
    "#": "57 Manchester Rd, Unit 1 (053-09-09)",
    "$": 491700,
    "address": "57 Manchester Rd, Unit 1",
    "parcel_id": "053-09-09",
    "owner1": "KRINSKY REALTY CO INC",
    "owner2": "C/O GOLDMAN",
    "current_taxes": 5035.01,
    "new_taxes_no_override": 5252.52,
    "override_total_1": 5401.56,
    "override_increase_1": 149.04
  },
  {
    "#": "57 Manchester Rd, Unit 2 (053-09-10)",
    "$": 538100,
    "address": "57 Manchester Rd, Unit 2",
    "parcel_id": "053-09-10",
    "owner1": "KRINSKY REALTY CO INC",
    "owner2": "C/O GOLDMAN",
    "current_taxes": 5510.14,
    "new_taxes_no_override": 5748.18,
    "override_total_1": 5911.28,
    "override_increase_1": 163.1
  },
  {
    "#": "57 Manchester Rd, Unit 3 (053-09-11)",
    "$": 545100,
    "address": "57 Manchester Rd, Unit 3",
    "parcel_id": "053-09-11",
    "owner1": "KRINSKY REALTY CO INC",
    "owner2": "C/O GOLDMAN",
    "current_taxes": 5581.82,
    "new_taxes_no_override": 5822.95,
    "override_total_1": 5988.18,
    "override_increase_1": 165.22
  },
  {
    "#": "57 Manchester Rd, Unit 4 (053-09-12)",
    "$": 557000,
    "address": "57 Manchester Rd, Unit 4",
    "parcel_id": "053-09-12",
    "owner1": "KRINSKY REALTY CO INC",
    "owner2": "C/O GOLDMAN",
    "current_taxes": 5703.68,
    "new_taxes_no_override": 5950.08,
    "override_total_1": 6118.91,
    "override_increase_1": 168.83
  },
  {
    "#": "57 Manchester Rd, Unit 5 (053-09-13)",
    "$": 591400,
    "address": "57 Manchester Rd, Unit 5",
    "parcel_id": "053-09-13",
    "owner1": "KRINSKY REALTY CO INC",
    "owner2": "C/O GOLDMAN",
    "current_taxes": 6055.94,
    "new_taxes_no_override": 6317.56,
    "override_total_1": 6496.81,
    "override_increase_1": 179.26
  },
  {
    "#": "57 Manchester Rd, Unit 6 (053-09-14)",
    "$": 545100,
    "address": "57 Manchester Rd, Unit 6",
    "parcel_id": "053-09-14",
    "owner1": "KRINSKY REALTY CO INC",
    "owner2": "C/O GOLDMAN",
    "current_taxes": 5581.82,
    "new_taxes_no_override": 5822.95,
    "override_total_1": 5988.18,
    "override_increase_1": 165.22
  },
  {
    "#": "58 Manchester Rd (052-02-03)",
    "$": 3254800,
    "address": "58 Manchester Rd",
    "parcel_id": "052-02-03",
    "owner1": "DOVER CLUB OF M I T INC",
    "owner2": "C/O JEROME F. DAUSMAN, TREASURER, MICHAEL",
    "current_taxes": 33329.15,
    "new_taxes_no_override": 34768.97,
    "override_total_1": 35755.51,
    "override_increase_1": 986.54
  },
  {
    "#": "59 Manchester Rd, Unit 1 (053-09-15)",
    "$": 523500,
    "address": "59 Manchester Rd, Unit 1",
    "parcel_id": "053-09-15",
    "owner1": "KRINSKY REALTY CO INC",
    "owner2": "C/O GOLDMAN",
    "current_taxes": 5360.64,
    "new_taxes_no_override": 5592.22,
    "override_total_1": 5750.89,
    "override_increase_1": 158.67
  },
  {
    "#": "59 Manchester Rd, Unit 2 (053-09-16)",
    "$": 615600,
    "address": "59 Manchester Rd, Unit 2",
    "parcel_id": "053-09-16",
    "owner1": "KRINSKY REALTY CO INC",
    "owner2": "C/O GOLDMAN",
    "current_taxes": 6303.74,
    "new_taxes_no_override": 6576.06,
    "override_total_1": 6762.65,
    "override_increase_1": 186.59
  },
  {
    "#": "59 Manchester Rd, Unit 3 (053-09-17)",
    "$": 661900,
    "address": "59 Manchester Rd, Unit 3",
    "parcel_id": "053-09-17",
    "owner1": "KRINSKY REALTY CO INC",
    "owner2": "C/O GOLDMAN",
    "current_taxes": 6777.86,
    "new_taxes_no_override": 7070.66,
    "override_total_1": 7271.29,
    "override_increase_1": 200.62
  },
  {
    "#": "59 Manchester Rd, Unit 4 (053-09-18)",
    "$": 615600,
    "address": "59 Manchester Rd, Unit 4",
    "parcel_id": "053-09-18",
    "owner1": "KRINSKY REALTY CO INC",
    "owner2": "C/O GOLDMAN",
    "current_taxes": 6303.74,
    "new_taxes_no_override": 6576.06,
    "override_total_1": 6762.65,
    "override_increase_1": 186.59
  },
  {
    "#": "59 Manchester Rd, Unit 5 (053-09-19)",
    "$": 661900,
    "address": "59 Manchester Rd, Unit 5",
    "parcel_id": "053-09-19",
    "owner1": "KRINSKY REALTY CO INC",
    "owner2": "C/O GOLDMAN",
    "current_taxes": 6777.86,
    "new_taxes_no_override": 7070.66,
    "override_total_1": 7271.29,
    "override_increase_1": 200.62
  },
  {
    "#": "59 Manchester Rd, Unit 6 (053-09-20)",
    "$": 615600,
    "address": "59 Manchester Rd, Unit 6",
    "parcel_id": "053-09-20",
    "owner1": "KRINSKY REALTY CO INC",
    "owner2": "",
    "current_taxes": 6303.74,
    "new_taxes_no_override": 6576.06,
    "override_total_1": 6762.65,
    "override_increase_1": 186.59
  },
  {
    "#": "59 Manchester Rd, Unit 7 (053-09-21)",
    "$": 595500,
    "address": "59 Manchester Rd, Unit 7",
    "parcel_id": "053-09-21",
    "owner1": "KRINSKY REALTY CO INC",
    "owner2": "C/O GOLDMAN",
    "current_taxes": 6097.92,
    "new_taxes_no_override": 6361.35,
    "override_total_1": 6541.85,
    "override_increase_1": 180.5
  },
  {
    "#": "5 Manton Ter (071-31-00)",
    "$": 8200,
    "address": "5 Manton Ter",
    "parcel_id": "071-31-00",
    "owner1": "WIENER TR, CLAIRE M",
    "owner2": "",
    "current_taxes": 83.97,
    "new_taxes_no_override": 87.6,
    "override_total_1": 90.08,
    "override_increase_1": 2.49
  },
  {
    "#": "7 Manton Ter, Unit 1 & Pk A & C (071-32-01)",
    "$": 977200,
    "address": "7 Manton Ter, Unit 1 & Pk A & C",
    "parcel_id": "071-32-01",
    "owner1": "WILLIAMS, MATTI I & SHERYL",
    "owner2": "",
    "current_taxes": 6371.59,
    "new_taxes_no_override": 6646.84,
    "override_total_1": 6835.44,
    "override_increase_1": 188.6
  },
  {
    "#": "7 Manton Ter, Unit 2 & Pk B-D-E (071-32-02)",
    "$": 1590800,
    "address": "7 Manton Ter, Unit 2 & Pk B-D-E",
    "parcel_id": "071-32-02",
    "owner1": "XIONG, YUHONG",
    "owner2": "HAN, SITING",
    "current_taxes": 12654.86,
    "new_taxes_no_override": 13201.55,
    "override_total_1": 13576.13,
    "override_increase_1": 374.58
  },
  {
    "#": "8 Manton Ter (071-33-00)",
    "$": 2623100,
    "address": "8 Manton Ter",
    "parcel_id": "071-33-00",
    "owner1": "MANI TRS, VIJAYALAKSHMI & MAHALINGAM",
    "owner2": "MITAL, ANSHUL",
    "current_taxes": 26860.54,
    "new_taxes_no_override": 28020.92,
    "override_total_1": 28815.99,
    "override_increase_1": 795.07
  },
  {
    "#": "5 Maple St (308-36-00)",
    "$": 4113100,
    "address": "5 Maple St",
    "parcel_id": "308-36-00",
    "owner1": "BHOJWANI, KUNIKA & NIKHIL",
    "owner2": "",
    "current_taxes": 38483.21,
    "new_taxes_no_override": 40145.68,
    "override_total_1": 41284.79,
    "override_increase_1": 1139.1
  },
  {
    "#": "12 Maple St (312-09-00)",
    "$": 4085600,
    "address": "12 Maple St",
    "parcel_id": "312-09-00",
    "owner1": "DUNN, PATRICK & ELIZABETH",
    "owner2": "",
    "current_taxes": 38201.61,
    "new_taxes_no_override": 39851.92,
    "override_total_1": 40982.69,
    "override_increase_1": 1130.77
  },
  {
    "#": "18 Maple St (312-08-00)",
    "$": 2260700,
    "address": "18 Maple St",
    "parcel_id": "312-08-00",
    "owner1": "CONNELL, MARGARET E",
    "owner2": "",
    "current_taxes": 19514.63,
    "new_taxes_no_override": 20357.66,
    "override_total_1": 20935.3,
    "override_increase_1": 577.63
  },
  {
    "#": "14 Marion St (167-22-00)",
    "$": 6927400,
    "address": "14 Marion St",
    "parcel_id": "167-22-00",
    "owner1": "14 MARION LLC",
    "owner2": "",
    "current_taxes": 70936.58,
    "new_taxes_no_override": 74001.04,
    "override_total_1": 76100.76,
    "override_increase_1": 2099.72
  },
  {
    "#": "20 Marion St, Unit 2 & G1 P8 (167-21-01)",
    "$": 2599400,
    "address": "20 Marion St, Unit 2 & G1 P8",
    "parcel_id": "167-21-01",
    "owner1": "CARNO, ELLEN B",
    "owner2": "",
    "current_taxes": 22982.92,
    "new_taxes_no_override": 23975.78,
    "override_total_1": 24656.08,
    "override_increase_1": 680.29
  },
  {
    "#": "20 Marion St, Unit 3 & G2 P7 (167-21-02)",
    "$": 2618400,
    "address": "20 Marion St, Unit 3 & G2 P7",
    "parcel_id": "167-21-02",
    "owner1": "KAI, MASASHI & YUKIE",
    "owner2": "",
    "current_taxes": 26812.42,
    "new_taxes_no_override": 27970.72,
    "override_total_1": 28764.36,
    "override_increase_1": 793.65
  },
  {
    "#": "20 Marion St, Unit 4 &  G6 & P9 (167-21-03)",
    "$": 2592300,
    "address": "20 Marion St, Unit 4 &  G6 & P9",
    "parcel_id": "167-21-03",
    "owner1": "DERENZO, LINDA",
    "owner2": "SNYDER, CLARISE",
    "current_taxes": 22910.22,
    "new_taxes_no_override": 23899.94,
    "override_total_1": 24578.08,
    "override_increase_1": 678.14
  },
  {
    "#": "20 Marion St, Unit G3 (167-21-05)",
    "$": 88700,
    "address": "20 Marion St, Unit G3",
    "parcel_id": "167-21-05",
    "owner1": "20 MARION STREET LLC",
    "owner2": "",
    "current_taxes": 908.29,
    "new_taxes_no_override": 947.53,
    "override_total_1": 974.41,
    "override_increase_1": 26.89
  },
  {
    "#": "20 Marion St, Unit Ph & G4 G5 (167-21-04)",
    "$": 2575300,
    "address": "20 Marion St, Unit Ph & G4 G5",
    "parcel_id": "167-21-04",
    "owner1": "KHAVINSON TR, IRINA M",
    "owner2": "",
    "current_taxes": 26371.07,
    "new_taxes_no_override": 27510.3,
    "override_total_1": 28290.88,
    "override_increase_1": 780.58
  },
  {
    "#": "24 Marion St (167-20-02)",
    "$": 1321800,
    "address": "24 Marion St",
    "parcel_id": "167-20-02",
    "owner1": "JIANG, SIZUN",
    "owner2": "WONG, HOI MEI",
    "current_taxes": 9900.3,
    "new_taxes_no_override": 10327.99,
    "override_total_1": 10621.04,
    "override_increase_1": 293.05
  },
  {
    "#": "25 Marion St, Unit 12 & P6 (164-07-01)",
    "$": 1004500,
    "address": "25 Marion St, Unit 12 & P6",
    "parcel_id": "164-07-01",
    "owner1": "TITELBAUM, JENNA",
    "owner2": "",
    "current_taxes": 6651.15,
    "new_taxes_no_override": 6938.48,
    "override_total_1": 7135.35,
    "override_increase_1": 196.87
  },
  {
    "#": "25 Marion St, Unit 14 & P15 (164-07-02)",
    "$": 884800,
    "address": "25 Marion St, Unit 14 & P15",
    "parcel_id": "164-07-02",
    "owner1": "SUZUKI, AKIRA",
    "owner2": "",
    "current_taxes": 9060.35,
    "new_taxes_no_override": 9451.76,
    "override_total_1": 9719.94,
    "override_increase_1": 268.19
  },
  {
    "#": "25 Marion St, Unit 15 & P11 (164-07-03)",
    "$": 830700,
    "address": "25 Marion St, Unit 15 & P11",
    "parcel_id": "164-07-03",
    "owner1": "KEYS TRS, MARSHALL T & SANDRA BAILEY",
    "owner2": "",
    "current_taxes": 8506.37,
    "new_taxes_no_override": 8873.85,
    "override_total_1": 9125.63,
    "override_increase_1": 251.79
  },
  {
    "#": "25 Marion St, Unit 16 P31-31A (164-07-04)",
    "$": 1039400,
    "address": "25 Marion St, Unit 16 P31-31A",
    "parcel_id": "164-07-04",
    "owner1": "SHENG, MORGAN",
    "owner2": "WEN, LIDA",
    "current_taxes": 10643.46,
    "new_taxes_no_override": 11103.26,
    "override_total_1": 11418.3,
    "override_increase_1": 315.05
  },
  {
    "#": "25 Marion St, Unit 21 & P42 (164-07-05)",
    "$": 970200,
    "address": "25 Marion St, Unit 21 & P42",
    "parcel_id": "164-07-05",
    "owner1": "DOUBILET, LIBBY",
    "owner2": "",
    "current_taxes": 6299.91,
    "new_taxes_no_override": 6572.07,
    "override_total_1": 6758.54,
    "override_increase_1": 186.48
  },
  {
    "#": "25 Marion St, Unit 22 P29&A (164-07-06)",
    "$": 1062900,
    "address": "25 Marion St, Unit 22 P29&A",
    "parcel_id": "164-07-06",
    "owner1": "SUBBAIAH, SATHISH JAY",
    "owner2": "THAKORE, AVNI H",
    "current_taxes": 10884.1,
    "new_taxes_no_override": 11354.29,
    "override_total_1": 11676.46,
    "override_increase_1": 322.17
  },
  {
    "#": "25 Marion St, Unit 23 & P24 (164-07-07)",
    "$": 924100,
    "address": "25 Marion St, Unit 23 & P24",
    "parcel_id": "164-07-07",
    "owner1": "MEKA, HARI",
    "owner2": "",
    "current_taxes": 5827.85,
    "new_taxes_no_override": 6079.61,
    "override_total_1": 6252.12,
    "override_increase_1": 172.5
  },
  {
    "#": "25 Marion St, Unit 24 & P18 (164-07-08)",
    "$": 991300,
    "address": "25 Marion St, Unit 24 & P18",
    "parcel_id": "164-07-08",
    "owner1": "CHAN, TONY P & SU MEI",
    "owner2": "",
    "current_taxes": 10150.91,
    "new_taxes_no_override": 10589.43,
    "override_total_1": 10889.9,
    "override_increase_1": 300.47
  },
  {
    "#": "25 Marion St, Unit 25 & P43 (164-07-09)",
    "$": 1019000,
    "address": "25 Marion St, Unit 25 & P43",
    "parcel_id": "164-07-09",
    "owner1": "DOSHI, SUCHETA",
    "owner2": "",
    "current_taxes": 6799.63,
    "new_taxes_no_override": 7093.37,
    "override_total_1": 7294.64,
    "override_increase_1": 201.27
  },
  {
    "#": "25 Marion St, Unit 26 & P8 (164-07-10)",
    "$": 1036200,
    "address": "25 Marion St, Unit 26 & P8",
    "parcel_id": "164-07-10",
    "owner1": "BAY, GANN KEOW SUSANNA",
    "owner2": "",
    "current_taxes": 10610.69,
    "new_taxes_no_override": 11069.07,
    "override_total_1": 11383.15,
    "override_increase_1": 314.08
  },
  {
    "#": "25 Marion St, Unit 27 & P3 (164-07-11)",
    "$": 920000,
    "address": "25 Marion St, Unit 27 & P3",
    "parcel_id": "164-07-11",
    "owner1": "KEHOE, MARTIN P &  LAURA JOHANNA",
    "owner2": "KELLY KEHOE, MARY C",
    "current_taxes": 5785.87,
    "new_taxes_no_override": 6035.82,
    "override_total_1": 6207.08,
    "override_increase_1": 171.26
  },
  {
    "#": "25 Marion St, Unit 31 & P10 (164-07-12)",
    "$": 970200,
    "address": "25 Marion St, Unit 31 & P10",
    "parcel_id": "164-07-12",
    "owner1": "REICH TR, GWENDOLYN G",
    "owner2": "",
    "current_taxes": 9934.85,
    "new_taxes_no_override": 10364.04,
    "override_total_1": 10658.11,
    "override_increase_1": 294.07
  },
  {
    "#": "25 Marion St, Unit 32 & P4 (164-07-13)",
    "$": 987200,
    "address": "25 Marion St, Unit 32 & P4",
    "parcel_id": "164-07-13",
    "owner1": "LEE, WAN-HUNG",
    "owner2": "",
    "current_taxes": 10108.93,
    "new_taxes_no_override": 10545.64,
    "override_total_1": 10844.86,
    "override_increase_1": 299.22
  },
  {
    "#": "25 Marion St, Unit 33 & P7 (164-07-14)",
    "$": 914700,
    "address": "25 Marion St, Unit 33 & P7",
    "parcel_id": "164-07-14",
    "owner1": "SAVIKOVSKY, VLADIMIR & LENA",
    "owner2": "",
    "current_taxes": 9366.53,
    "new_taxes_no_override": 9771.16,
    "override_total_1": 10048.41,
    "override_increase_1": 277.25
  },
  {
    "#": "25 Marion St, Unit 34 & P17 (164-07-15)",
    "$": 999200,
    "address": "25 Marion St, Unit 34 & P17",
    "parcel_id": "164-07-15",
    "owner1": "KAIDO, HITOMI & HIROAKI",
    "owner2": "",
    "current_taxes": 6596.87,
    "new_taxes_no_override": 6881.85,
    "override_total_1": 7077.12,
    "override_increase_1": 195.27
  },
  {
    "#": "25 Marion St, Unit 35 & P16 (164-07-16)",
    "$": 994100,
    "address": "25 Marion St, Unit 35 & P16",
    "parcel_id": "164-07-16",
    "owner1": "JIANG, CANWEN",
    "owner2": "",
    "current_taxes": 6544.65,
    "new_taxes_no_override": 6827.38,
    "override_total_1": 7021.1,
    "override_increase_1": 193.72
  },
  {
    "#": "25 Marion St, Unit 36 P13 P14 (164-07-17)",
    "$": 1123500,
    "address": "25 Marion St, Unit 36 P13 P14",
    "parcel_id": "164-07-17",
    "owner1": "SEMAH TR, EPHRAIM",
    "owner2": "",
    "current_taxes": 7869.71,
    "new_taxes_no_override": 8209.68,
    "override_total_1": 8442.62,
    "override_increase_1": 232.94
  },
  {
    "#": "25 Marion St, Unit 37 & P19 (164-07-18)",
    "$": 920000,
    "address": "25 Marion St, Unit 37 & P19",
    "parcel_id": "164-07-18",
    "owner1": "HO, TRS, YUK LIN",
    "owner2": "",
    "current_taxes": 5785.87,
    "new_taxes_no_override": 6035.82,
    "override_total_1": 6207.08,
    "override_increase_1": 171.26
  },
  {
    "#": "25 Marion St, Unit 41 & P41 (164-07-19)",
    "$": 991100,
    "address": "25 Marion St, Unit 41 & P41",
    "parcel_id": "164-07-19",
    "owner1": "CHEN, LIN HUEY & LAN BO",
    "owner2": "",
    "current_taxes": 10148.86,
    "new_taxes_no_override": 10587.29,
    "override_total_1": 10887.7,
    "override_increase_1": 300.41
  },
  {
    "#": "25 Marion St, Unit 42 & P20 (164-07-20)",
    "$": 1020300,
    "address": "25 Marion St, Unit 42 & P20",
    "parcel_id": "164-07-20",
    "owner1": "GRAUER, WALTER",
    "owner2": "",
    "current_taxes": 6812.94,
    "new_taxes_no_override": 7107.26,
    "override_total_1": 7308.92,
    "override_increase_1": 201.66
  },
  {
    "#": "25 Marion St, Unit 43 & P9 (164-07-21)",
    "$": 914800,
    "address": "25 Marion St, Unit 43 & P9",
    "parcel_id": "164-07-21",
    "owner1": "YUE, JIE",
    "owner2": "",
    "current_taxes": 9367.55,
    "new_taxes_no_override": 9772.23,
    "override_total_1": 10049.51,
    "override_increase_1": 277.28
  },
  {
    "#": "25 Marion St, Unit 44 P30 30A (164-07-22)",
    "$": 1097400,
    "address": "25 Marion St, Unit 44 P30 30A",
    "parcel_id": "164-07-22",
    "owner1": "BALASHOV, KONSTANTIN",
    "owner2": "",
    "current_taxes": 11237.38,
    "new_taxes_no_override": 11722.83,
    "override_total_1": 12055.46,
    "override_increase_1": 332.63
  },
  {
    "#": "25 Marion St, Unit 45 & P12 (164-07-23)",
    "$": 1038900,
    "address": "25 Marion St, Unit 45 & P12",
    "parcel_id": "164-07-23",
    "owner1": "DAVIDI, ASNAT NATI",
    "owner2": "",
    "current_taxes": 10638.34,
    "new_taxes_no_override": 11097.92,
    "override_total_1": 11412.81,
    "override_increase_1": 314.89
  },
  {
    "#": "25 Marion St, Unit 46 & P5 (164-07-24)",
    "$": 1067900,
    "address": "25 Marion St, Unit 46 & P5",
    "parcel_id": "164-07-24",
    "owner1": "SOLOMON TR, LOIS",
    "owner2": "",
    "current_taxes": 7300.36,
    "new_taxes_no_override": 7615.74,
    "override_total_1": 7831.83,
    "override_increase_1": 216.09
  },
  {
    "#": "25 Marion St, Unit 47 & P6 (164-07-25)",
    "$": 920000,
    "address": "25 Marion St, Unit 47 & P6",
    "parcel_id": "164-07-25",
    "owner1": "SATO, SHIGERU",
    "owner2": "C/O ABLE REAL ESTATE USA INC",
    "current_taxes": 9420.8,
    "new_taxes_no_override": 9827.78,
    "override_total_1": 10106.63,
    "override_increase_1": 278.86
  },
  {
    "#": "25 Marion St, Unit Ph-3 P32&A (164-07-28)",
    "$": 1257200,
    "address": "25 Marion St, Unit Ph-3 P32&A",
    "parcel_id": "164-07-28",
    "owner1": "JONES TR, MARSHA SALTER",
    "owner2": "",
    "current_taxes": 9238.79,
    "new_taxes_no_override": 9637.91,
    "override_total_1": 9911.37,
    "override_increase_1": 273.47
  },
  {
    "#": "25 Marion St, Unit Ph-4 P23&A (164-07-29)",
    "$": 1467700,
    "address": "25 Marion St, Unit Ph-4 P23&A",
    "parcel_id": "164-07-29",
    "owner1": "CONDOS ETC LLC",
    "owner2": "",
    "current_taxes": 15029.25,
    "new_taxes_no_override": 15678.51,
    "override_total_1": 16123.38,
    "override_increase_1": 444.87
  },
  {
    "#": "25 Marion St, Unit Ph-5 P21&A (164-07-30)",
    "$": 1288000,
    "address": "25 Marion St, Unit Ph-5 P21&A",
    "parcel_id": "164-07-30",
    "owner1": "HICKEY, PATRICIA",
    "owner2": "",
    "current_taxes": 9554.19,
    "new_taxes_no_override": 9966.93,
    "override_total_1": 10249.74,
    "override_increase_1": 282.8
  },
  {
    "#": "25 Marion St, Unit Ph1-2& 4Pk (164-07-31)",
    "$": 2320100,
    "address": "25 Marion St, Unit Ph1-2& 4Pk",
    "parcel_id": "164-07-31",
    "owner1": "HODGMAN, JOHN F",
    "owner2": "PIKE, ADELE W",
    "current_taxes": 20122.89,
    "new_taxes_no_override": 20992.2,
    "override_total_1": 21587.84,
    "override_increase_1": 595.64
  },
  {
    "#": "26 Marion St (167-20-01)",
    "$": 1346600,
    "address": "26 Marion St",
    "parcel_id": "167-20-01",
    "owner1": "BELASKI TR, MAUREEN R",
    "owner2": "",
    "current_taxes": 13789.18,
    "new_taxes_no_override": 14384.87,
    "override_total_1": 14793.03,
    "override_increase_1": 408.16
  },
  {
    "#": "32 Marion St, Unit A (167-19-00)",
    "$": 20454700,
    "address": "32 Marion St, Unit A",
    "parcel_id": "167-19-00",
    "owner1": "BROOKLINE HOUSING AUTHORITY",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "41 Marion St (164-08-00)",
    "$": 8179600,
    "address": "41 Marion St",
    "parcel_id": "164-08-00",
    "owner1": "NEW ENGLAND TELEPHONE",
    "owner2": "C/O VERIZON NEW ENGLAND INC",
    "current_taxes": 140361.94,
    "new_taxes_no_override": 146425.58,
    "override_total_1": 150580.29,
    "override_increase_1": 4154.71
  },
  {
    "#": "44 Marion St (167-18-00)",
    "$": 2599600,
    "address": "44 Marion St",
    "parcel_id": "167-18-00",
    "owner1": "GIAMBRO, JEANNE",
    "owner2": "C/O GIAMBRO RONALD",
    "current_taxes": 26619.9,
    "new_taxes_no_override": 27769.88,
    "override_total_1": 28557.83,
    "override_increase_1": 787.95
  },
  {
    "#": "45 Marion St (164-09-00)",
    "$": 25033200,
    "address": "45 Marion St",
    "parcel_id": "164-09-00",
    "owner1": "M H DANESH LLC",
    "owner2": "C/O ALLIED CAPITAL PROPERTIES",
    "current_taxes": 256339.97,
    "new_taxes_no_override": 267413.86,
    "override_total_1": 275001.52,
    "override_increase_1": 7587.66
  },
  {
    "#": "49 Marion St (164-10-01)",
    "$": 19949900,
    "address": "49 Marion St",
    "parcel_id": "164-10-01",
    "owner1": "MARION 49 LIMITED PARTNERSHIP",
    "owner2": "",
    "current_taxes": 204286.98,
    "new_taxes_no_override": 213112.18,
    "override_total_1": 219159.07,
    "override_increase_1": 6046.89
  },
  {
    "#": "59 Marion St (164-11-00)",
    "$": 5903900,
    "address": "59 Marion St",
    "parcel_id": "164-11-00",
    "owner1": "LONDON, ARNOLD",
    "owner2": "C/O ALLSTATE REALTY",
    "current_taxes": 60455.94,
    "new_taxes_no_override": 63067.64,
    "override_total_1": 64857.13,
    "override_increase_1": 1789.5
  },
  {
    "#": "67 Marion St, Unit 1 (165-01-01)",
    "$": 587300,
    "address": "67 Marion St, Unit 1",
    "parcel_id": "165-01-01",
    "owner1": "SANTOS, SUSAN M",
    "owner2": "",
    "current_taxes": 2379.02,
    "new_taxes_no_override": 2481.79,
    "override_total_1": 2552.21,
    "override_increase_1": 70.42
  },
  {
    "#": "67 Marion St, Unit 2 (165-01-02)",
    "$": 735400,
    "address": "67 Marion St, Unit 2",
    "parcel_id": "165-01-02",
    "owner1": "SHEA, JOHN",
    "owner2": "PAPPER, ROBIN",
    "current_taxes": 7530.5,
    "new_taxes_no_override": 7855.82,
    "override_total_1": 8078.72,
    "override_increase_1": 222.9
  },
  {
    "#": "67 Marion St, Unit 3 (165-01-03)",
    "$": 594500,
    "address": "67 Marion St, Unit 3",
    "parcel_id": "165-01-03",
    "owner1": "ROYAL, VICTORIA MARIE",
    "owner2": "ISILDAKLI, DEAN",
    "current_taxes": 2452.75,
    "new_taxes_no_override": 2558.71,
    "override_total_1": 2631.31,
    "override_increase_1": 72.6
  },
  {
    "#": "67 Marion St, Unit 4 (165-01-04)",
    "$": 839300,
    "address": "67 Marion St, Unit 4",
    "parcel_id": "165-01-04",
    "owner1": "BLOTTNER LARA INVESTMENT LLC",
    "owner2": "",
    "current_taxes": 8594.43,
    "new_taxes_no_override": 8965.71,
    "override_total_1": 9220.1,
    "override_increase_1": 254.4
  },
  {
    "#": "67 Marion St, Unit 5 (165-01-05)",
    "$": 599300,
    "address": "67 Marion St, Unit 5",
    "parcel_id": "165-01-05",
    "owner1": "XIA, HONG",
    "owner2": "",
    "current_taxes": 2501.9,
    "new_taxes_no_override": 2609.98,
    "override_total_1": 2684.04,
    "override_increase_1": 74.06
  },
  {
    "#": "67 Marion St, Unit 6 (165-01-06)",
    "$": 709900,
    "address": "67 Marion St, Unit 6",
    "parcel_id": "165-01-06",
    "owner1": "KARJANE, DAMIAN & NICOLE",
    "owner2": "",
    "current_taxes": 7269.38,
    "new_taxes_no_override": 7583.42,
    "override_total_1": 7798.59,
    "override_increase_1": 215.17
  },
  {
    "#": "67 Marion St, Unit B (165-01-16)",
    "$": 584100,
    "address": "67 Marion St, Unit B",
    "parcel_id": "165-01-16",
    "owner1": "BLAKE, RAN",
    "owner2": "",
    "current_taxes": 2346.25,
    "new_taxes_no_override": 2447.61,
    "override_total_1": 2517.06,
    "override_increase_1": 69.45
  },
  {
    "#": "77 Marion St (165-02-00)",
    "$": 34500000,
    "address": "77 Marion St",
    "parcel_id": "165-02-00",
    "owner1": "MARION SQUARE LLC",
    "owner2": "C/O NORDBLOM MGMT CO INC",
    "current_taxes": 358054.8,
    "new_taxes_no_override": 373522.77,
    "override_total_1": 384121.19,
    "override_increase_1": 10598.42
  },
  {
    "#": "88 Marion St, Unit 1 (214-36-01)",
    "$": 831600,
    "address": "88 Marion St, Unit 1",
    "parcel_id": "214-36-01",
    "owner1": "WONG TRS, JONATHAN J & JESSICA M M",
    "owner2": "",
    "current_taxes": 8515.58,
    "new_taxes_no_override": 8883.45,
    "override_total_1": 9135.51,
    "override_increase_1": 252.06
  },
  {
    "#": "88 Marion St, Unit 2 (214-36-02)",
    "$": 817100,
    "address": "88 Marion St, Unit 2",
    "parcel_id": "214-36-02",
    "owner1": "LEE, NICHOLAS P",
    "owner2": "",
    "current_taxes": 4732.17,
    "new_taxes_no_override": 4936.6,
    "override_total_1": 5076.67,
    "override_increase_1": 140.07
  },
  {
    "#": "88 Marion St, Unit 2 (214-36-07)",
    "$": 484700,
    "address": "88 Marion St, Unit 2",
    "parcel_id": "214-36-07",
    "owner1": "DANESHVARI, NICHOLAS",
    "owner2": "",
    "current_taxes": 4963.33,
    "new_taxes_no_override": 5177.75,
    "override_total_1": 5324.66,
    "override_increase_1": 146.91
  },
  {
    "#": "88 Marion St, Unit 3 (214-36-03)",
    "$": 836800,
    "address": "88 Marion St, Unit 3",
    "parcel_id": "214-36-03",
    "owner1": "VINNIK, ANNA",
    "owner2": "FOLTZ, JONATHAN HIGBIE",
    "current_taxes": 8568.83,
    "new_taxes_no_override": 8939.0,
    "override_total_1": 9192.64,
    "override_increase_1": 253.64
  },
  {
    "#": "88 Marion St, Unit 3 (214-36-08)",
    "$": 498400,
    "address": "88 Marion St, Unit 3",
    "parcel_id": "214-36-08",
    "owner1": "KHEMRAJ, UMA & DHANSHAM & RUPWATEE",
    "owner2": "",
    "current_taxes": 5103.62,
    "new_taxes_no_override": 5324.1,
    "override_total_1": 5475.16,
    "override_increase_1": 151.07
  },
  {
    "#": "88 Marion St, Unit 4 (214-36-04)",
    "$": 882600,
    "address": "88 Marion St, Unit 4",
    "parcel_id": "214-36-04",
    "owner1": "SONNENFELD TR, SARAH",
    "owner2": "",
    "current_taxes": 9037.82,
    "new_taxes_no_override": 9428.25,
    "override_total_1": 9695.77,
    "override_increase_1": 267.52
  },
  {
    "#": "88 Marion St, Unit 5 (214-36-05)",
    "$": 874700,
    "address": "88 Marion St, Unit 5",
    "parcel_id": "214-36-05",
    "owner1": "BELAND TR, ROBERT R",
    "owner2": "",
    "current_taxes": 5321.99,
    "new_taxes_no_override": 5551.9,
    "override_total_1": 5709.43,
    "override_increase_1": 157.53
  },
  {
    "#": "88 Marion St, Unit 6 (214-36-06)",
    "$": 870800,
    "address": "88 Marion St, Unit 6",
    "parcel_id": "214-36-06",
    "owner1": "SHORE, EVAN & LINDA M",
    "owner2": "",
    "current_taxes": 5282.06,
    "new_taxes_no_override": 5510.24,
    "override_total_1": 5666.59,
    "override_increase_1": 156.35
  },
  {
    "#": "89 Marion St (165-05-00)",
    "$": 5154900,
    "address": "89 Marion St",
    "parcel_id": "165-05-00",
    "owner1": "89 MARION ST LLC",
    "owner2": "C/O MAVERICK SUITES",
    "current_taxes": 52786.18,
    "new_taxes_no_override": 55066.54,
    "override_total_1": 56629.01,
    "override_increase_1": 1562.47
  },
  {
    "#": "90 Marion St, Unit 1 (214-36-09)",
    "$": 619800,
    "address": "90 Marion St, Unit 1",
    "parcel_id": "214-36-09",
    "owner1": "ZHENG, NING",
    "owner2": "C/O RICHARD OSENTON PLUMB&HEAT",
    "current_taxes": 6346.75,
    "new_taxes_no_override": 6620.93,
    "override_total_1": 6808.79,
    "override_increase_1": 187.86
  },
  {
    "#": "90 Marion St, Unit 2 (214-36-10)",
    "$": 973400,
    "address": "90 Marion St, Unit 2",
    "parcel_id": "214-36-10",
    "owner1": "SAJI, MICHAEL YASUHIRO & CHARLENE C",
    "owner2": "",
    "current_taxes": 6332.68,
    "new_taxes_no_override": 6606.25,
    "override_total_1": 6793.7,
    "override_increase_1": 187.45
  },
  {
    "#": "90 Marion St, Unit 3 (214-36-11)",
    "$": 732900,
    "address": "90 Marion St, Unit 3",
    "parcel_id": "214-36-11",
    "owner1": "BORNSTEIN, STANLEY A & SUSAN B",
    "owner2": "",
    "current_taxes": 7504.9,
    "new_taxes_no_override": 7829.11,
    "override_total_1": 8051.26,
    "override_increase_1": 222.15
  },
  {
    "#": "90 Marion St, Unit 4 (214-36-12)",
    "$": 972300,
    "address": "90 Marion St, Unit 4",
    "parcel_id": "214-36-12",
    "owner1": "GERBER, TERRI N",
    "owner2": "",
    "current_taxes": 6321.42,
    "new_taxes_no_override": 6594.51,
    "override_total_1": 6781.62,
    "override_increase_1": 187.11
  },
  {
    "#": "90 Marion St, Unit 5 (214-36-13)",
    "$": 662300,
    "address": "90 Marion St, Unit 5",
    "parcel_id": "214-36-13",
    "owner1": "LEVINE, FREDERICK E",
    "owner2": "",
    "current_taxes": 3147.02,
    "new_taxes_no_override": 3282.97,
    "override_total_1": 3376.12,
    "override_increase_1": 93.15
  },
  {
    "#": "90 Marion St, Unit 6 (214-36-14)",
    "$": 994300,
    "address": "90 Marion St, Unit 6",
    "parcel_id": "214-36-14",
    "owner1": "HOWELL TRS, DAVID LUKE & KOKO FUJITA",
    "owner2": "",
    "current_taxes": 6546.7,
    "new_taxes_no_override": 6829.52,
    "override_total_1": 7023.3,
    "override_increase_1": 193.78
  },
  {
    "#": "91 Marion St (165-06-10)",
    "$": 3816500,
    "address": "91 Marion St",
    "parcel_id": "165-06-10",
    "owner1": "91 MARION REALTY LLC",
    "owner2": "C/O INVEST PROP LTD",
    "current_taxes": 39080.96,
    "new_taxes_no_override": 40769.26,
    "override_total_1": 41926.05,
    "override_increase_1": 1156.8
  },
  {
    "#": "92 Marion St, Unit 1 (214-36-15)",
    "$": 633400,
    "address": "92 Marion St, Unit 1",
    "parcel_id": "214-36-15",
    "owner1": "PROKAEVA, TATIANA B",
    "owner2": "",
    "current_taxes": 2851.08,
    "new_taxes_no_override": 2974.25,
    "override_total_1": 3058.64,
    "override_increase_1": 84.39
  },
  {
    "#": "92 Marion St, Unit 2 (214-36-16)",
    "$": 860900,
    "address": "92 Marion St, Unit 2",
    "parcel_id": "214-36-16",
    "owner1": "ROTENBERG, ET AL TRS, MARC",
    "owner2": "C/O ROTENBERG MGT CO INC",
    "current_taxes": 8815.62,
    "new_taxes_no_override": 9196.45,
    "override_total_1": 9457.4,
    "override_increase_1": 260.94
  },
  {
    "#": "92 Marion St, Unit 3 (214-36-17)",
    "$": 738500,
    "address": "92 Marion St, Unit 3",
    "parcel_id": "214-36-17",
    "owner1": "YONGE, NOAH M",
    "owner2": "",
    "current_taxes": 3927.31,
    "new_taxes_no_override": 4096.97,
    "override_total_1": 4213.22,
    "override_increase_1": 116.25
  },
  {
    "#": "92 Marion St, Unit 4 (214-36-18)",
    "$": 982700,
    "address": "92 Marion St, Unit 4",
    "parcel_id": "214-36-18",
    "owner1": "NAH, CHONG IN",
    "owner2": "YUN, YERIM",
    "current_taxes": 10062.85,
    "new_taxes_no_override": 10497.57,
    "override_total_1": 10795.43,
    "override_increase_1": 297.86
  },
  {
    "#": "92 Marion St, Unit 5 (214-36-19)",
    "$": 726800,
    "address": "92 Marion St, Unit 5",
    "parcel_id": "214-36-19",
    "owner1": "DO, MICHAEL TRI H",
    "owner2": "",
    "current_taxes": 3807.5,
    "new_taxes_no_override": 3971.98,
    "override_total_1": 4084.69,
    "override_increase_1": 112.7
  },
  {
    "#": "92 Marion St, Unit 6 (214-36-20)",
    "$": 972400,
    "address": "92 Marion St, Unit 6",
    "parcel_id": "214-36-20",
    "owner1": "SHURE TR, LOREN",
    "owner2": "",
    "current_taxes": 6322.44,
    "new_taxes_no_override": 6595.57,
    "override_total_1": 6782.71,
    "override_increase_1": 187.14
  },
  {
    "#": "93 Marion St, Unit 1 (165-07-09)",
    "$": 602700,
    "address": "93 Marion St, Unit 1",
    "parcel_id": "165-07-09",
    "owner1": "PAINE, LOUISA P & ALEXANDER T",
    "owner2": "",
    "current_taxes": 2536.71,
    "new_taxes_no_override": 2646.3,
    "override_total_1": 2721.38,
    "override_increase_1": 75.09
  },
  {
    "#": "93 Marion St, Unit 2 (165-07-01)",
    "$": 329100,
    "address": "93 Marion St, Unit 2",
    "parcel_id": "165-07-01",
    "owner1": "KLEIN TR, JEFFREY F",
    "owner2": "",
    "current_taxes": 3369.98,
    "new_taxes_no_override": 3515.56,
    "override_total_1": 3615.31,
    "override_increase_1": 99.75
  },
  {
    "#": "93 Marion St, Unit 3 (165-07-02)",
    "$": 505100,
    "address": "93 Marion St, Unit 3",
    "parcel_id": "165-07-02",
    "owner1": "MASS SUNSHINE LLC",
    "owner2": "CHESTNUT HIL REALTY CORP",
    "current_taxes": 5172.22,
    "new_taxes_no_override": 5395.66,
    "override_total_1": 5548.76,
    "override_increase_1": 153.1
  },
  {
    "#": "93 Marion St, Unit 4 (165-07-03)",
    "$": 751400,
    "address": "93 Marion St, Unit 4",
    "parcel_id": "165-07-03",
    "owner1": "LIU, JIAFU",
    "owner2": "ZUO, SAI",
    "current_taxes": 4059.4,
    "new_taxes_no_override": 4234.77,
    "override_total_1": 4354.92,
    "override_increase_1": 120.16
  },
  {
    "#": "93 Marion St, Unit 5 (165-07-04)",
    "$": 313300,
    "address": "93 Marion St, Unit 5",
    "parcel_id": "165-07-04",
    "owner1": "MASS SUNSHINE LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 3208.19,
    "new_taxes_no_override": 3346.78,
    "override_total_1": 3441.75,
    "override_increase_1": 94.96
  },
  {
    "#": "93 Marion St, Unit 6 (165-07-05)",
    "$": 499100,
    "address": "93 Marion St, Unit 6",
    "parcel_id": "165-07-05",
    "owner1": "HATZIELEFTHERIADIS, DEBORAH L",
    "owner2": "",
    "current_taxes": 5110.78,
    "new_taxes_no_override": 5331.57,
    "override_total_1": 5482.84,
    "override_increase_1": 151.28
  },
  {
    "#": "93 Marion St, Unit 7 (165-07-06)",
    "$": 830600,
    "address": "93 Marion St, Unit 7",
    "parcel_id": "165-07-06",
    "owner1": "KIM, CLAIRE HAHNI",
    "owner2": "",
    "current_taxes": 8505.34,
    "new_taxes_no_override": 8872.77,
    "override_total_1": 9124.53,
    "override_increase_1": 251.76
  },
  {
    "#": "93 Marion St, Unit 8 (165-07-07)",
    "$": 313300,
    "address": "93 Marion St, Unit 8",
    "parcel_id": "165-07-07",
    "owner1": "KLEIN TR, JEFFREY F",
    "owner2": "",
    "current_taxes": 3208.19,
    "new_taxes_no_override": 3346.78,
    "override_total_1": 3441.75,
    "override_increase_1": 94.96
  },
  {
    "#": "93 Marion St, Unit 9 (165-07-08)",
    "$": 489500,
    "address": "93 Marion St, Unit 9",
    "parcel_id": "165-07-08",
    "owner1": "LUI TR, ZHILIN",
    "owner2": "",
    "current_taxes": 5012.48,
    "new_taxes_no_override": 5229.02,
    "override_total_1": 5377.39,
    "override_increase_1": 148.37
  },
  {
    "#": "94 Marion St, Unit 1 (214-36-21)",
    "$": 853500,
    "address": "94 Marion St, Unit 1",
    "parcel_id": "214-36-21",
    "owner1": "MELLER, AMIT & ROTEM",
    "owner2": "",
    "current_taxes": 5104.91,
    "new_taxes_no_override": 5325.44,
    "override_total_1": 5476.55,
    "override_increase_1": 151.11
  },
  {
    "#": "94 Marion St, Unit 1 (214-36-27)",
    "$": 385800,
    "address": "94 Marion St, Unit 1",
    "parcel_id": "214-36-27",
    "owner1": "JOSEPH TR, JANICE L",
    "owner2": "",
    "current_taxes": 3950.59,
    "new_taxes_no_override": 4121.26,
    "override_total_1": 4238.19,
    "override_increase_1": 116.94
  },
  {
    "#": "94 Marion St, Unit 2 (214-36-22)",
    "$": 755000,
    "address": "94 Marion St, Unit 2",
    "parcel_id": "214-36-22",
    "owner1": "MASTROIANNI, MICHAEL P",
    "owner2": "",
    "current_taxes": 7731.2,
    "new_taxes_no_override": 8065.19,
    "override_total_1": 8294.03,
    "override_increase_1": 228.84
  },
  {
    "#": "94 Marion St, Unit 2 (214-36-28)",
    "$": 488000,
    "address": "94 Marion St, Unit 2",
    "parcel_id": "214-36-28",
    "owner1": "STEFANIK TR, ANN MARIE",
    "owner2": "",
    "current_taxes": 1362.19,
    "new_taxes_no_override": 1421.04,
    "override_total_1": 1461.36,
    "override_increase_1": 40.32
  },
  {
    "#": "94 Marion St, Unit 3 (214-36-23)",
    "$": 851500,
    "address": "94 Marion St, Unit 3",
    "parcel_id": "214-36-23",
    "owner1": "WILDE, MATTHEW C",
    "owner2": "WANG, SUE X",
    "current_taxes": 5084.43,
    "new_taxes_no_override": 5304.08,
    "override_total_1": 5454.58,
    "override_increase_1": 150.5
  },
  {
    "#": "94 Marion St, Unit 3 (214-36-29)",
    "$": 365000,
    "address": "94 Marion St, Unit 3",
    "parcel_id": "214-36-29",
    "owner1": "94A MARION LLC",
    "owner2": "",
    "current_taxes": 3737.6,
    "new_taxes_no_override": 3899.06,
    "override_total_1": 4009.7,
    "override_increase_1": 110.63
  },
  {
    "#": "94 Marion St, Unit 4 (214-36-24)",
    "$": 882600,
    "address": "94 Marion St, Unit 4",
    "parcel_id": "214-36-24",
    "owner1": "GARFIELD, ALASTAIR",
    "owner2": "",
    "current_taxes": 5402.89,
    "new_taxes_no_override": 5636.29,
    "override_total_1": 5796.22,
    "override_increase_1": 159.93
  },
  {
    "#": "94 Marion St, Unit 4 (214-36-30)",
    "$": 308600,
    "address": "94 Marion St, Unit 4",
    "parcel_id": "214-36-30",
    "owner1": "94A MARION LLC",
    "owner2": "",
    "current_taxes": 3160.06,
    "new_taxes_no_override": 3296.57,
    "override_total_1": 3390.11,
    "override_increase_1": 93.54
  },
  {
    "#": "94 Marion St, Unit 5 (214-36-25)",
    "$": 817000,
    "address": "94 Marion St, Unit 5",
    "parcel_id": "214-36-25",
    "owner1": "WILSON, TR, MARIA",
    "owner2": "",
    "current_taxes": 8366.08,
    "new_taxes_no_override": 8727.49,
    "override_total_1": 8975.13,
    "override_increase_1": 247.64
  },
  {
    "#": "94 Marion St, Unit 6 (214-36-26)",
    "$": 860800,
    "address": "94 Marion St, Unit 6",
    "parcel_id": "214-36-26",
    "owner1": "GHAIE, PAVAN & CAROLYN",
    "owner2": "",
    "current_taxes": 8814.59,
    "new_taxes_no_override": 9195.38,
    "override_total_1": 9456.29,
    "override_increase_1": 260.91
  },
  {
    "#": "97 Marion St, Unit 1 (165-08-05)",
    "$": 560300,
    "address": "97 Marion St, Unit 1",
    "parcel_id": "165-08-05",
    "owner1": "STUKULS TR, ALFRED",
    "owner2": "",
    "current_taxes": 2102.54,
    "new_taxes_no_override": 2193.37,
    "override_total_1": 2255.6,
    "override_increase_1": 62.24
  },
  {
    "#": "97 Marion St, Unit 2 (165-08-01)",
    "$": 297200,
    "address": "97 Marion St, Unit 2",
    "parcel_id": "165-08-01",
    "owner1": "MASS SUNSHINE LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 3043.33,
    "new_taxes_no_override": 3174.8,
    "override_total_1": 3264.88,
    "override_increase_1": 90.08
  },
  {
    "#": "97 Marion St, Unit 3 (165-08-02)",
    "$": 447000,
    "address": "97 Marion St, Unit 3",
    "parcel_id": "165-08-02",
    "owner1": "MASS SUNSHINE LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 4577.28,
    "new_taxes_no_override": 4775.02,
    "override_total_1": 4910.51,
    "override_increase_1": 135.49
  },
  {
    "#": "97 Marion St, Unit 4 (165-08-03)",
    "$": 1205700,
    "address": "97 Marion St, Unit 4",
    "parcel_id": "165-08-03",
    "owner1": "HENDI, ZAHRA",
    "owner2": "C/O MOJTABA MOSTASHARI",
    "current_taxes": 12346.37,
    "new_taxes_no_override": 12879.73,
    "override_total_1": 13245.19,
    "override_increase_1": 365.45
  },
  {
    "#": "97 Marion St, Unit 5 (165-08-04)",
    "$": 1205700,
    "address": "97 Marion St, Unit 5",
    "parcel_id": "165-08-04",
    "owner1": "MASS SUNSHINE LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 12346.37,
    "new_taxes_no_override": 12879.73,
    "override_total_1": 13245.19,
    "override_increase_1": 365.45
  },
  {
    "#": "99 Marion St, Unit 1 (165-09-01)",
    "$": 1416400,
    "address": "99 Marion St, Unit 1",
    "parcel_id": "165-09-01",
    "owner1": "WINKLEMAN, ARLENE R",
    "owner2": "",
    "current_taxes": 10869.0,
    "new_taxes_no_override": 11338.54,
    "override_total_1": 11660.26,
    "override_increase_1": 321.72
  },
  {
    "#": "99 Marion St, Unit 2 (165-09-02)",
    "$": 754300,
    "address": "99 Marion St, Unit 2",
    "parcel_id": "165-09-02",
    "owner1": "DOBRINA, IRINA",
    "owner2": "KHALANDOVSKY, MICHAEL",
    "current_taxes": 7724.03,
    "new_taxes_no_override": 8057.71,
    "override_total_1": 8286.34,
    "override_increase_1": 228.63
  },
  {
    "#": "99 Marion St, Unit 3 (165-09-03)",
    "$": 312300,
    "address": "99 Marion St, Unit 3",
    "parcel_id": "165-09-03",
    "owner1": "LU, JIAN",
    "owner2": "",
    "current_taxes": 3197.95,
    "new_taxes_no_override": 3336.1,
    "override_total_1": 3430.76,
    "override_increase_1": 94.66
  },
  {
    "#": "99 Marion St, Unit 4 (165-09-04)",
    "$": 617700,
    "address": "99 Marion St, Unit 4",
    "parcel_id": "165-09-04",
    "owner1": "PAPPER, ROBIN",
    "owner2": "SHEA, JOHN",
    "current_taxes": 6325.25,
    "new_taxes_no_override": 6598.5,
    "override_total_1": 6785.73,
    "override_increase_1": 187.23
  },
  {
    "#": "99 Marion St, Unit 5 (165-09-05)",
    "$": 806700,
    "address": "99 Marion St, Unit 5",
    "parcel_id": "165-09-05",
    "owner1": "GARCIA, JOSE R & MARGARET A",
    "owner2": "",
    "current_taxes": 8260.61,
    "new_taxes_no_override": 8617.47,
    "override_total_1": 8861.98,
    "override_increase_1": 244.51
  },
  {
    "#": "99 Marion St, Unit 6 (165-09-06)",
    "$": 312400,
    "address": "99 Marion St, Unit 6",
    "parcel_id": "165-09-06",
    "owner1": "GRAPPO, MICHAEL J",
    "owner2": "",
    "current_taxes": 3198.98,
    "new_taxes_no_override": 3337.18,
    "override_total_1": 3431.87,
    "override_increase_1": 94.69
  },
  {
    "#": "99 Marion St, Unit 7 (165-09-07)",
    "$": 757400,
    "address": "99 Marion St, Unit 7",
    "parcel_id": "165-09-07",
    "owner1": "EOM, JOO YOUNG",
    "owner2": "",
    "current_taxes": 4120.84,
    "new_taxes_no_override": 4298.86,
    "override_total_1": 4420.84,
    "override_increase_1": 121.98
  },
  {
    "#": "100 Marion St, Unit 10 & P-M (214-35-03)",
    "$": 514700,
    "address": "100 Marion St, Unit 10 & P-M",
    "parcel_id": "214-35-03",
    "owner1": "CHAN, LAWRENCE K",
    "owner2": "",
    "current_taxes": 1635.59,
    "new_taxes_no_override": 1706.25,
    "override_total_1": 1754.66,
    "override_increase_1": 48.41
  },
  {
    "#": "100 Marion St, Unit 11 (214-35-04)",
    "$": 541900,
    "address": "100 Marion St, Unit 11",
    "parcel_id": "214-35-04",
    "owner1": "CHOI, KAREN Y",
    "owner2": "PAGAN, STEVEN",
    "current_taxes": 5549.06,
    "new_taxes_no_override": 5788.78,
    "override_total_1": 5953.03,
    "override_increase_1": 164.25
  },
  {
    "#": "100 Marion St, Unit 12 & P-C (214-35-05)",
    "$": 585200,
    "address": "100 Marion St, Unit 12 & P-C",
    "parcel_id": "214-35-05",
    "owner1": "LEHMAN, JANET M",
    "owner2": "",
    "current_taxes": 5992.45,
    "new_taxes_no_override": 6251.32,
    "override_total_1": 6428.7,
    "override_increase_1": 177.38
  },
  {
    "#": "100 Marion St, Unit 14 & P-D (214-35-06)",
    "$": 626100,
    "address": "100 Marion St, Unit 14 & P-D",
    "parcel_id": "214-35-06",
    "owner1": "DISSON TRS, MIKHAIL",
    "owner2": "SPIVACK TR, CARLA",
    "current_taxes": 2776.33,
    "new_taxes_no_override": 2896.27,
    "override_total_1": 2978.45,
    "override_increase_1": 82.18
  },
  {
    "#": "100 Marion St, Unit 15 & P-E (214-35-07)",
    "$": 597400,
    "address": "100 Marion St, Unit 15 & P-E",
    "parcel_id": "214-35-07",
    "owner1": "LONGO, MARIA-LOURDES",
    "owner2": "",
    "current_taxes": 6117.38,
    "new_taxes_no_override": 6381.65,
    "override_total_1": 6562.73,
    "override_increase_1": 181.07
  },
  {
    "#": "100 Marion St, Unit 16 & P16 (214-35-08)",
    "$": 665400,
    "address": "100 Marion St, Unit 16 & P16",
    "parcel_id": "214-35-08",
    "owner1": "GROSSMAN, ANDREW B",
    "owner2": "",
    "current_taxes": 3178.76,
    "new_taxes_no_override": 3316.08,
    "override_total_1": 3410.17,
    "override_increase_1": 94.09
  },
  {
    "#": "100 Marion St, Unit 17 & P9 (214-35-09)",
    "$": 694500,
    "address": "100 Marion St, Unit 17 & P9",
    "parcel_id": "214-35-09",
    "owner1": "GREENACRE, JONATHAN ESPIE",
    "owner2": "PARSHINA, IULIIA",
    "current_taxes": 3476.75,
    "new_taxes_no_override": 3626.95,
    "override_total_1": 3729.86,
    "override_increase_1": 102.91
  },
  {
    "#": "100 Marion St, Unit 18 & P18 (214-35-10)",
    "$": 829300,
    "address": "100 Marion St, Unit 18 & P18",
    "parcel_id": "214-35-10",
    "owner1": "SHETH, NAVIN & SUCHETA N",
    "owner2": "",
    "current_taxes": 8492.03,
    "new_taxes_no_override": 8858.89,
    "override_total_1": 9110.25,
    "override_increase_1": 251.36
  },
  {
    "#": "100 Marion St, Unit 21 & P12 (214-35-11)",
    "$": 801600,
    "address": "100 Marion St, Unit 21 & P12",
    "parcel_id": "214-35-11",
    "owner1": "TIONGSON, JON",
    "owner2": "",
    "current_taxes": 8208.38,
    "new_taxes_no_override": 8562.98,
    "override_total_1": 8805.95,
    "override_increase_1": 242.97
  },
  {
    "#": "100 Marion St, Unit 22 & P6 (214-35-12)",
    "$": 817100,
    "address": "100 Marion St, Unit 22 & P6",
    "parcel_id": "214-35-12",
    "owner1": "FINKELSTEIN, JOSEPH",
    "owner2": "ANTISTA-FINKELSTEIN, DELLA",
    "current_taxes": 8367.1,
    "new_taxes_no_override": 8728.56,
    "override_total_1": 8976.22,
    "override_increase_1": 247.67
  },
  {
    "#": "100 Marion St, Unit 23 & P-I (214-35-13)",
    "$": 603300,
    "address": "100 Marion St, Unit 23 & P-I",
    "parcel_id": "214-35-13",
    "owner1": "NORTH GRIGGS LLC",
    "owner2": "",
    "current_taxes": 6177.79,
    "new_taxes_no_override": 6444.67,
    "override_total_1": 6627.53,
    "override_increase_1": 182.86
  },
  {
    "#": "100 Marion St, Unit 24 & P-G (214-35-14)",
    "$": 640200,
    "address": "100 Marion St, Unit 24 & P-G",
    "parcel_id": "214-35-14",
    "owner1": "SPECTOR, MICHELLE L",
    "owner2": "",
    "current_taxes": 2920.71,
    "new_taxes_no_override": 3046.88,
    "override_total_1": 3133.34,
    "override_increase_1": 86.45
  },
  {
    "#": "100 Marion St, Unit 25 & P-H (214-35-15)",
    "$": 598800,
    "address": "100 Marion St, Unit 25 & P-H",
    "parcel_id": "214-35-15",
    "owner1": "RUIZ, CESAR & GLADYS",
    "owner2": "",
    "current_taxes": 6131.71,
    "new_taxes_no_override": 6396.6,
    "override_total_1": 6578.1,
    "override_increase_1": 181.5
  },
  {
    "#": "100 Marion St, Unit 26 &P13-20 (214-35-16)",
    "$": 792500,
    "address": "100 Marion St, Unit 26 &P13-20",
    "parcel_id": "214-35-16",
    "owner1": "HOWARD, HINDS & ERIONA",
    "owner2": "",
    "current_taxes": 8115.2,
    "new_taxes_no_override": 8465.78,
    "override_total_1": 8705.99,
    "override_increase_1": 240.21
  },
  {
    "#": "100 Marion St, Unit 27 & P15 (214-35-17)",
    "$": 783200,
    "address": "100 Marion St, Unit 27 & P15",
    "parcel_id": "214-35-17",
    "owner1": "PROTOPOPOVA TRS, ALEXEI & MARINA",
    "owner2": "",
    "current_taxes": 8019.97,
    "new_taxes_no_override": 8366.43,
    "override_total_1": 8603.82,
    "override_increase_1": 237.39
  },
  {
    "#": "100 Marion St, Unit 28 & P7 (214-35-18)",
    "$": 811000,
    "address": "100 Marion St, Unit 28 & P7",
    "parcel_id": "214-35-18",
    "owner1": "MORI, SERGIO S",
    "owner2": "",
    "current_taxes": 4669.71,
    "new_taxes_no_override": 4871.44,
    "override_total_1": 5009.66,
    "override_increase_1": 138.22
  },
  {
    "#": "100 Marion St, Unit 31 & P3 (214-35-19)",
    "$": 801600,
    "address": "100 Marion St, Unit 31 & P3",
    "parcel_id": "214-35-19",
    "owner1": "OGANESOV TR, ANNA S",
    "owner2": "",
    "current_taxes": 8208.38,
    "new_taxes_no_override": 8562.98,
    "override_total_1": 8805.95,
    "override_increase_1": 242.97
  },
  {
    "#": "100 Marion St, Unit 32 & P2 (214-35-20)",
    "$": 817100,
    "address": "100 Marion St, Unit 32 & P2",
    "parcel_id": "214-35-20",
    "owner1": "AZARBAYJANI DOW, NEGAR",
    "owner2": "",
    "current_taxes": 4732.17,
    "new_taxes_no_override": 4936.6,
    "override_total_1": 5076.67,
    "override_increase_1": 140.07
  },
  {
    "#": "100 Marion St, Unit 33 & P-B (214-35-21)",
    "$": 571800,
    "address": "100 Marion St, Unit 33 & P-B",
    "parcel_id": "214-35-21",
    "owner1": "ARNAOUT, RIMA",
    "owner2": "",
    "current_taxes": 5855.23,
    "new_taxes_no_override": 6108.18,
    "override_total_1": 6281.49,
    "override_increase_1": 173.31
  },
  {
    "#": "100 Marion St, Unit 34 & P-K (214-35-22)",
    "$": 693000,
    "address": "100 Marion St, Unit 34 & P-K",
    "parcel_id": "214-35-22",
    "owner1": "YAMADA, MIAH & KAZUHIRO",
    "owner2": "LIN, QIAN",
    "current_taxes": 7096.32,
    "new_taxes_no_override": 7402.88,
    "override_total_1": 7612.93,
    "override_increase_1": 210.05
  },
  {
    "#": "100 Marion St, Unit 35 & P-J (214-35-23)",
    "$": 648200,
    "address": "100 Marion St, Unit 35 & P-J",
    "parcel_id": "214-35-23",
    "owner1": "LEE, ESTHER C Y",
    "owner2": "",
    "current_taxes": 3002.63,
    "new_taxes_no_override": 3132.34,
    "override_total_1": 3221.22,
    "override_increase_1": 88.88
  },
  {
    "#": "100 Marion St, Unit 36 & P11 (214-35-24)",
    "$": 708600,
    "address": "100 Marion St, Unit 36 & P11",
    "parcel_id": "214-35-24",
    "owner1": "STERN, MEREDITH J",
    "owner2": "",
    "current_taxes": 3621.13,
    "new_taxes_no_override": 3777.56,
    "override_total_1": 3884.75,
    "override_increase_1": 107.19
  },
  {
    "#": "100 Marion St, Unit 37 & P1 (214-35-25)",
    "$": 783200,
    "address": "100 Marion St, Unit 37 & P1",
    "parcel_id": "214-35-25",
    "owner1": "CHEN, TIANZHEN",
    "owner2": "",
    "current_taxes": 8019.97,
    "new_taxes_no_override": 8366.43,
    "override_total_1": 8603.82,
    "override_increase_1": 237.39
  },
  {
    "#": "100 Marion St, Unit 38 & P8 (214-35-26)",
    "$": 794200,
    "address": "100 Marion St, Unit 38 & P8",
    "parcel_id": "214-35-26",
    "owner1": "LAGOS, TRS, CONSTANTINE B & LILLIAN",
    "owner2": "",
    "current_taxes": 8132.61,
    "new_taxes_no_override": 8483.94,
    "override_total_1": 8724.66,
    "override_increase_1": 240.73
  },
  {
    "#": "100 Marion St, Unit 41 & P10 (214-35-27)",
    "$": 801500,
    "address": "100 Marion St, Unit 41 & P10",
    "parcel_id": "214-35-27",
    "owner1": "CHODOS, LEIGH",
    "owner2": "",
    "current_taxes": 8207.36,
    "new_taxes_no_override": 8561.92,
    "override_total_1": 8804.86,
    "override_increase_1": 242.94
  },
  {
    "#": "100 Marion St, Unit 42 & P5 (214-35-28)",
    "$": 817100,
    "address": "100 Marion St, Unit 42 & P5",
    "parcel_id": "214-35-28",
    "owner1": "OVADIA, JOANNE",
    "owner2": "LIPSCHUTZ TR, ESTERINA OVADIA",
    "current_taxes": 4732.17,
    "new_taxes_no_override": 4936.6,
    "override_total_1": 5076.67,
    "override_increase_1": 140.07
  },
  {
    "#": "100 Marion St, Unit 43 & P-F (214-35-29)",
    "$": 603300,
    "address": "100 Marion St, Unit 43 & P-F",
    "parcel_id": "214-35-29",
    "owner1": "VARENNA LLC",
    "owner2": "",
    "current_taxes": 6177.79,
    "new_taxes_no_override": 6444.67,
    "override_total_1": 6627.53,
    "override_increase_1": 182.86
  },
  {
    "#": "100 Marion St, Unit 44 & P19 (214-35-30)",
    "$": 730900,
    "address": "100 Marion St, Unit 44 & P19",
    "parcel_id": "214-35-30",
    "owner1": "GOULD, DAVID",
    "owner2": "",
    "current_taxes": 3849.48,
    "new_taxes_no_override": 4015.78,
    "override_total_1": 4129.72,
    "override_increase_1": 113.94
  },
  {
    "#": "100 Marion St, Unit 45 & P-L (214-35-31)",
    "$": 648300,
    "address": "100 Marion St, Unit 45 & P-L",
    "parcel_id": "214-35-31",
    "owner1": "PEZZULO TRS, GARY & ABIGAIL KANE",
    "owner2": "",
    "current_taxes": 6638.59,
    "new_taxes_no_override": 6925.38,
    "override_total_1": 7121.88,
    "override_increase_1": 196.5
  },
  {
    "#": "100 Marion St, Unit 46 & P17 (214-35-32)",
    "$": 704700,
    "address": "100 Marion St, Unit 46 & P17",
    "parcel_id": "214-35-32",
    "owner1": "HORVITZ, MICHAEL D",
    "owner2": "",
    "current_taxes": 3581.19,
    "new_taxes_no_override": 3735.9,
    "override_total_1": 3841.9,
    "override_increase_1": 106.0
  },
  {
    "#": "100 Marion St, Unit 47 & P14 (214-35-33)",
    "$": 783200,
    "address": "100 Marion St, Unit 47 & P14",
    "parcel_id": "214-35-33",
    "owner1": "KWOK, MICHAEL & GENEVIEVE",
    "owner2": "",
    "current_taxes": 8019.97,
    "new_taxes_no_override": 8366.43,
    "override_total_1": 8603.82,
    "override_increase_1": 237.39
  },
  {
    "#": "100 Marion St, Unit 48 & P4 (214-35-34)",
    "$": 811000,
    "address": "100 Marion St, Unit 48 & P4",
    "parcel_id": "214-35-34",
    "owner1": "MAPELLI, AMEDEO",
    "owner2": "",
    "current_taxes": 4669.71,
    "new_taxes_no_override": 4871.44,
    "override_total_1": 5009.66,
    "override_increase_1": 138.22
  },
  {
    "#": "100 Marion St, Unit Bmt & P-A (214-35-35)",
    "$": 528900,
    "address": "100 Marion St, Unit Bmt & P-A",
    "parcel_id": "214-35-35",
    "owner1": "SCIPIONE, STEPHEN A",
    "owner2": "",
    "current_taxes": 5415.94,
    "new_taxes_no_override": 5649.91,
    "override_total_1": 5810.22,
    "override_increase_1": 160.31
  },
  {
    "#": "102 Marion St (214-35-01)",
    "$": 1600,
    "address": "102 Marion St",
    "parcel_id": "214-35-01",
    "owner1": "1443 BEACON LLC",
    "owner2": "C/O CHESTNUT HILL REALTY",
    "current_taxes": 16.38,
    "new_taxes_no_override": 17.09,
    "override_total_1": 17.57,
    "override_increase_1": 0.48
  },
  {
    "#": "105 Marion St (165-10-00)",
    "$": 2564600,
    "address": "105 Marion St",
    "parcel_id": "165-10-00",
    "owner1": "MARION INN LLC",
    "owner2": "C/O JIANG WENHUA",
    "current_taxes": 26261.5,
    "new_taxes_no_override": 27396.0,
    "override_total_1": 28173.34,
    "override_increase_1": 777.34
  },
  {
    "#": "111 Marion St, Unit 1 (165-11-01)",
    "$": 528200,
    "address": "111 Marion St, Unit 1",
    "parcel_id": "165-11-01",
    "owner1": "GOYAL, VANITA",
    "owner2": "SHARMA, HEERA",
    "current_taxes": 5408.77,
    "new_taxes_no_override": 5642.43,
    "override_total_1": 5802.53,
    "override_increase_1": 160.1
  },
  {
    "#": "111 Marion St, Unit 2 (165-11-02)",
    "$": 1438600,
    "address": "111 Marion St, Unit 2",
    "parcel_id": "165-11-02",
    "owner1": "OFLYNN, LENA",
    "owner2": "RODRIGO, DIMITRI",
    "current_taxes": 11096.33,
    "new_taxes_no_override": 11575.69,
    "override_total_1": 11904.14,
    "override_increase_1": 328.45
  },
  {
    "#": "111 Marion St, Unit 3 (165-11-03)",
    "$": 2197500,
    "address": "111 Marion St, Unit 3",
    "parcel_id": "165-11-03",
    "owner1": "SALIK, JONATHAN",
    "owner2": "HAIMES, HILARY",
    "current_taxes": 22502.4,
    "new_taxes_no_override": 23474.5,
    "override_total_1": 24140.57,
    "override_increase_1": 666.07
  },
  {
    "#": "7 Marion Ter, Unit B-1 (167-15-04)",
    "$": 1335700,
    "address": "7 Marion Ter, Unit B-1",
    "parcel_id": "167-15-04",
    "owner1": "CHU, HIUFUNG VANESSA",
    "owner2": "WONG, WILSON WAI CHUN",
    "current_taxes": 10042.63,
    "new_taxes_no_override": 10476.47,
    "override_total_1": 10773.73,
    "override_increase_1": 297.26
  },
  {
    "#": "8 Marion Ter, Unit A-1 (167-15-07)",
    "$": 1367100,
    "address": "8 Marion Ter, Unit A-1",
    "parcel_id": "167-15-07",
    "owner1": "KING TR, COLETTE M",
    "owner2": "",
    "current_taxes": 10364.17,
    "new_taxes_no_override": 10811.9,
    "override_total_1": 11118.68,
    "override_increase_1": 306.78
  },
  {
    "#": "9 Marion Ter, Unit B-2 (167-15-05)",
    "$": 1351700,
    "address": "9 Marion Ter, Unit B-2",
    "parcel_id": "167-15-05",
    "owner1": "DACHA LLC",
    "owner2": "",
    "current_taxes": 13841.41,
    "new_taxes_no_override": 14439.36,
    "override_total_1": 14849.06,
    "override_increase_1": 409.71
  },
  {
    "#": "10 Marion Ter, Unit A-2 (167-15-01)",
    "$": 1378800,
    "address": "10 Marion Ter, Unit A-2",
    "parcel_id": "167-15-01",
    "owner1": "PROEKT TRS, MARK & VERONICA",
    "owner2": "",
    "current_taxes": 10483.98,
    "new_taxes_no_override": 10936.89,
    "override_total_1": 11247.21,
    "override_increase_1": 310.33
  },
  {
    "#": "11 Marion Ter, Unit B-3 (167-15-06)",
    "$": 1385700,
    "address": "11 Marion Ter, Unit B-3",
    "parcel_id": "167-15-06",
    "owner1": "CHU, JENNY H",
    "owner2": "YOON, CHARLES H",
    "current_taxes": 10554.63,
    "new_taxes_no_override": 11010.59,
    "override_total_1": 11323.01,
    "override_increase_1": 312.42
  },
  {
    "#": "12 Marion Ter, Unit A-3 (167-15-02)",
    "$": 1402800,
    "address": "12 Marion Ter, Unit A-3",
    "parcel_id": "167-15-02",
    "owner1": "DURBIN, PHILIP",
    "owner2": "BROERING, TERESA",
    "current_taxes": 10729.74,
    "new_taxes_no_override": 11193.26,
    "override_total_1": 11510.87,
    "override_increase_1": 317.6
  },
  {
    "#": "14 Marion Ter, Unit A-4 (167-15-03)",
    "$": 1394200,
    "address": "14 Marion Ter, Unit A-4",
    "parcel_id": "167-15-03",
    "owner1": "LEONG TRS, ANDREW L",
    "owner2": "WU, CHI CHI",
    "current_taxes": 10641.67,
    "new_taxes_no_override": 11101.39,
    "override_total_1": 11416.38,
    "override_increase_1": 314.99
  },
  {
    "#": "12 Marshal St, Unit 1 (125-13-01)",
    "$": 1836000,
    "address": "12 Marshal St, Unit 1",
    "parcel_id": "125-13-01",
    "owner1": "WIECEK, MICHAEL",
    "owner2": "GRANCIK, LISA",
    "current_taxes": 15165.71,
    "new_taxes_no_override": 15820.87,
    "override_total_1": 16269.77,
    "override_increase_1": 448.91
  },
  {
    "#": "12 Marshal St, Unit 2 (125-13-02)",
    "$": 1843800,
    "address": "12 Marshal St, Unit 2",
    "parcel_id": "125-13-02",
    "owner1": "KASSIR, NADIM & MIRNA",
    "owner2": "",
    "current_taxes": 15245.58,
    "new_taxes_no_override": 15904.19,
    "override_total_1": 16355.46,
    "override_increase_1": 451.27
  },
  {
    "#": "12 Marshal St, Unit 3 (125-13-03)",
    "$": 1843900,
    "address": "12 Marshal St, Unit 3",
    "parcel_id": "125-13-03",
    "owner1": "WATERS, WILLIAM A",
    "owner2": "MALONE, CHRISTOPHER MICHAEL",
    "current_taxes": 15246.6,
    "new_taxes_no_override": 15905.25,
    "override_total_1": 16356.55,
    "override_increase_1": 451.3
  },
  {
    "#": "14 Marshal St, Unit 1 (125-12-01)",
    "$": 1368800,
    "address": "14 Marshal St, Unit 1",
    "parcel_id": "125-12-01",
    "owner1": "SCHWARTZ, MARGOT & GLEN",
    "owner2": "",
    "current_taxes": 10381.58,
    "new_taxes_no_override": 10830.06,
    "override_total_1": 11137.36,
    "override_increase_1": 307.29
  },
  {
    "#": "14 Marshal St, Unit 2 (125-12-02)",
    "$": 1407100,
    "address": "14 Marshal St, Unit 2",
    "parcel_id": "125-12-02",
    "owner1": "ECHANIZ, HECTOR",
    "owner2": "IZSAK, CAROLINA",
    "current_taxes": 10773.77,
    "new_taxes_no_override": 11239.2,
    "override_total_1": 11558.1,
    "override_increase_1": 318.9
  },
  {
    "#": "14 Marshal St, Unit 3 (125-12-03)",
    "$": 1677000,
    "address": "14 Marshal St, Unit 3",
    "parcel_id": "125-12-03",
    "owner1": "CHECHELNITSKY TR, MICHAEL",
    "owner2": "",
    "current_taxes": 17172.48,
    "new_taxes_no_override": 17914.33,
    "override_total_1": 18422.64,
    "override_increase_1": 508.31
  },
  {
    "#": "19 Marshal St (122-05-00)",
    "$": 3001600,
    "address": "19 Marshal St",
    "parcel_id": "122-05-00",
    "owner1": "FEINS TRS, NEIL R & CHRISTINE",
    "owner2": "",
    "current_taxes": 27101.45,
    "new_taxes_no_override": 28272.23,
    "override_total_1": 29074.44,
    "override_increase_1": 802.2
  },
  {
    "#": "20 Marshal St, Unit 1 (125-08-12)",
    "$": 480800,
    "address": "20 Marshal St, Unit 1",
    "parcel_id": "125-08-12",
    "owner1": "SHUMAN, ALANNA ELIZABETH",
    "owner2": "",
    "current_taxes": 4923.39,
    "new_taxes_no_override": 5136.08,
    "override_total_1": 5281.81,
    "override_increase_1": 145.73
  },
  {
    "#": "20 Marshal St, Unit 2 (125-08-13)",
    "$": 1551900,
    "address": "20 Marshal St, Unit 2",
    "parcel_id": "125-08-13",
    "owner1": "ROSEN, RICHARD A & ELLEN I",
    "owner2": "",
    "current_taxes": 12256.52,
    "new_taxes_no_override": 12786.0,
    "override_total_1": 13148.79,
    "override_increase_1": 362.79
  },
  {
    "#": "20 Marshal St, Unit 3 & P24 (125-08-14)",
    "$": 1642900,
    "address": "20 Marshal St, Unit 3 & P24",
    "parcel_id": "125-08-14",
    "owner1": "CLOUSE, GRAYDON M & KIMBERLY R",
    "owner2": "",
    "current_taxes": 13188.36,
    "new_taxes_no_override": 13758.1,
    "override_total_1": 14148.47,
    "override_increase_1": 390.38
  },
  {
    "#": "20 Marshal St, Unit 4 (125-08-15)",
    "$": 1718900,
    "address": "20 Marshal St, Unit 4",
    "parcel_id": "125-08-15",
    "owner1": "LEVI, JUSTIN",
    "owner2": "",
    "current_taxes": 13966.6,
    "new_taxes_no_override": 14569.96,
    "override_total_1": 14983.37,
    "override_increase_1": 413.41
  },
  {
    "#": "25 Marshal St (122-05-01)",
    "$": 3018300,
    "address": "25 Marshal St",
    "parcel_id": "122-05-01",
    "owner1": "MAYA, JAKOB",
    "owner2": "HALPERIN MAYA, MIRIAM P",
    "current_taxes": 27272.46,
    "new_taxes_no_override": 28450.63,
    "override_total_1": 29257.9,
    "override_increase_1": 807.26
  },
  {
    "#": "28 Marshal St, Unit 1 (125-08-08)",
    "$": 496200,
    "address": "28 Marshal St, Unit 1",
    "parcel_id": "125-08-08",
    "owner1": "HEALY, ADAM J & ADRIANA",
    "owner2": "",
    "current_taxes": 5081.09,
    "new_taxes_no_override": 5300.59,
    "override_total_1": 5450.99,
    "override_increase_1": 150.4
  },
  {
    "#": "28 Marshal St, Unit 2 (125-08-09)",
    "$": 1581300,
    "address": "28 Marshal St, Unit 2",
    "parcel_id": "125-08-09",
    "owner1": "KALISH, SARAH EMILY",
    "owner2": "WEIL, SAMUEL AHMAN",
    "current_taxes": 12557.58,
    "new_taxes_no_override": 13100.07,
    "override_total_1": 13471.77,
    "override_increase_1": 371.7
  },
  {
    "#": "28 Marshal St, Unit 3 (125-08-10)",
    "$": 1806700,
    "address": "28 Marshal St, Unit 3",
    "parcel_id": "125-08-10",
    "owner1": "WANG, XIAOJIE",
    "owner2": "",
    "current_taxes": 14865.67,
    "new_taxes_no_override": 15507.87,
    "override_total_1": 15947.89,
    "override_increase_1": 440.02
  },
  {
    "#": "28 Marshal St, Unit 4 (125-08-11)",
    "$": 1686300,
    "address": "28 Marshal St, Unit 4",
    "parcel_id": "125-08-11",
    "owner1": "CARVAJAL, JUAN & ANGELINA",
    "owner2": "",
    "current_taxes": 13632.78,
    "new_taxes_no_override": 14221.72,
    "override_total_1": 14625.25,
    "override_increase_1": 403.53
  },
  {
    "#": "32 Marshal St, Unit 1 & P24 (125-08-04)",
    "$": 624400,
    "address": "32 Marshal St, Unit 1 & P24",
    "parcel_id": "125-08-04",
    "owner1": "ORLANDO, MICHAEL & LAURA",
    "owner2": "",
    "current_taxes": 6393.86,
    "new_taxes_no_override": 6670.07,
    "override_total_1": 6859.33,
    "override_increase_1": 189.26
  },
  {
    "#": "32 Marshal St, Unit 2 (125-08-05)",
    "$": 1572100,
    "address": "32 Marshal St, Unit 2",
    "parcel_id": "125-08-05",
    "owner1": "MCCULLOUGH, JOHN A &  JUDITH W",
    "owner2": "",
    "current_taxes": 12463.37,
    "new_taxes_no_override": 13001.79,
    "override_total_1": 13370.7,
    "override_increase_1": 368.92
  },
  {
    "#": "32 Marshal St, Unit 3 (125-08-06)",
    "$": 1629100,
    "address": "32 Marshal St, Unit 3",
    "parcel_id": "125-08-06",
    "owner1": "FRIED, JULES M & SYLVIA F",
    "owner2": "",
    "current_taxes": 13047.05,
    "new_taxes_no_override": 13610.68,
    "override_total_1": 13996.88,
    "override_increase_1": 386.19
  },
  {
    "#": "32 Marshal St, Unit 4 (125-08-07)",
    "$": 1616900,
    "address": "32 Marshal St, Unit 4",
    "parcel_id": "125-08-07",
    "owner1": "ONIE, LAURENCE M & DEBORAH B",
    "owner2": "",
    "current_taxes": 12922.12,
    "new_taxes_no_override": 13480.36,
    "override_total_1": 13862.85,
    "override_increase_1": 382.49
  },
  {
    "#": "39 Marshal St (123-12-00)",
    "$": 3676100,
    "address": "39 Marshal St",
    "parcel_id": "123-12-00",
    "owner1": "TRUST, LAURA B",
    "owner2": "LITCHMAN, ALAN",
    "current_taxes": 34008.33,
    "new_taxes_no_override": 35477.49,
    "override_total_1": 36484.14,
    "override_increase_1": 1006.65
  },
  {
    "#": "45 Marshal St (123-13-00)",
    "$": 2945200,
    "address": "45 Marshal St",
    "parcel_id": "123-13-00",
    "owner1": "MANDELBAUM, JUAN P",
    "owner2": "SANDLER, CLARA",
    "current_taxes": 26523.91,
    "new_taxes_no_override": 27669.74,
    "override_total_1": 28454.85,
    "override_increase_1": 785.11
  },
  {
    "#": "48 Marshal St, Unit 48A & P6 (124-21-01)",
    "$": 1374900,
    "address": "48 Marshal St, Unit 48A & P6",
    "parcel_id": "124-21-01",
    "owner1": "BAR, MEIRAV WOLFF & NIR MORDECHAI",
    "owner2": "",
    "current_taxes": 14078.98,
    "new_taxes_no_override": 14687.19,
    "override_total_1": 15103.93,
    "override_increase_1": 416.74
  },
  {
    "#": "48 Marshal St, Unit 48B & P1 (124-21-02)",
    "$": 1600800,
    "address": "48 Marshal St, Unit 48B & P1",
    "parcel_id": "124-21-02",
    "owner1": "YESNER LIFE ESTATE, SEYMOUR & JOAN C",
    "owner2": "",
    "current_taxes": 16392.19,
    "new_taxes_no_override": 17100.33,
    "override_total_1": 17585.54,
    "override_increase_1": 485.21
  },
  {
    "#": "48 Marshal St, Unit 48C & P15 (124-21-03)",
    "$": 1707300,
    "address": "48 Marshal St, Unit 48C & P15",
    "parcel_id": "124-21-03",
    "owner1": "LI, LI",
    "owner2": "",
    "current_taxes": 13847.82,
    "new_taxes_no_override": 14446.05,
    "override_total_1": 14855.94,
    "override_increase_1": 409.9
  },
  {
    "#": "50 Marshal St, Unit 50A (124-20-01)",
    "$": 1315400,
    "address": "50 Marshal St, Unit 50A",
    "parcel_id": "124-20-01",
    "owner1": "TAYLOR TRS, MARK F & CAROL W",
    "owner2": "",
    "current_taxes": 9834.76,
    "new_taxes_no_override": 10259.62,
    "override_total_1": 10550.73,
    "override_increase_1": 291.11
  },
  {
    "#": "50 Marshal St, Unit 50B & P22 (124-20-02)",
    "$": 1408600,
    "address": "50 Marshal St, Unit 50B & P22",
    "parcel_id": "124-20-02",
    "owner1": "FLEISHMAN, DAVID A",
    "owner2": "LIEBERMAN, JOANN",
    "current_taxes": 10789.13,
    "new_taxes_no_override": 11255.22,
    "override_total_1": 11574.58,
    "override_increase_1": 319.36
  },
  {
    "#": "50 Marshal St, Unit 50C & P21 (124-20-03)",
    "$": 1347800,
    "address": "50 Marshal St, Unit 50C & P21",
    "parcel_id": "124-20-03",
    "owner1": "DAVISON, JULIET A",
    "owner2": "",
    "current_taxes": 13801.47,
    "new_taxes_no_override": 14397.69,
    "override_total_1": 14806.22,
    "override_increase_1": 408.52
  },
  {
    "#": "51 Marshal St (123-14-00)",
    "$": 2449300,
    "address": "51 Marshal St",
    "parcel_id": "123-14-00",
    "owner1": "FARRELL TR, LOUISE M",
    "owner2": "",
    "current_taxes": 21445.9,
    "new_taxes_no_override": 22372.36,
    "override_total_1": 23007.16,
    "override_increase_1": 634.8
  },
  {
    "#": "54 Marshal St (124-19-00)",
    "$": 3110700,
    "address": "54 Marshal St",
    "parcel_id": "124-19-00",
    "owner1": "RAVELLO REALTY LLC",
    "owner2": "",
    "current_taxes": 31853.57,
    "new_taxes_no_override": 33229.64,
    "override_total_1": 34172.51,
    "override_increase_1": 942.87
  },
  {
    "#": "56 Marshal St, Unit 1 (124-18-03)",
    "$": 1131900,
    "address": "56 Marshal St, Unit 1",
    "parcel_id": "124-18-03",
    "owner1": "SHEILS TR, MAUREEN",
    "owner2": "",
    "current_taxes": 7955.72,
    "new_taxes_no_override": 8299.41,
    "override_total_1": 8534.9,
    "override_increase_1": 235.49
  },
  {
    "#": "56 Marshal St, Unit 2 (124-18-01)",
    "$": 1139600,
    "address": "56 Marshal St, Unit 2",
    "parcel_id": "124-18-01",
    "owner1": "WUNDERLICH, ZEBA BATOOL",
    "owner2": "JAJOO, RISHI HAR",
    "current_taxes": 8034.57,
    "new_taxes_no_override": 8381.66,
    "override_total_1": 8619.49,
    "override_increase_1": 237.82
  },
  {
    "#": "56 Marshal St, Unit 3 (124-18-02)",
    "$": 1122900,
    "address": "56 Marshal St, Unit 3",
    "parcel_id": "124-18-02",
    "owner1": "SHAW TR, LISA M",
    "owner2": "",
    "current_taxes": 7863.56,
    "new_taxes_no_override": 8203.27,
    "override_total_1": 8436.03,
    "override_increase_1": 232.76
  },
  {
    "#": "58 Marshal St, Unit 1 (124-17-01)",
    "$": 1205000,
    "address": "58 Marshal St, Unit 1",
    "parcel_id": "124-17-01",
    "owner1": "PRITCHARD, MATTHEW A",
    "owner2": "LAN, SI PING",
    "current_taxes": 8704.27,
    "new_taxes_no_override": 9080.29,
    "override_total_1": 9337.94,
    "override_increase_1": 257.65
  },
  {
    "#": "58 Marshal St, Unit 2 (124-17-02)",
    "$": 994600,
    "address": "58 Marshal St, Unit 2",
    "parcel_id": "124-17-02",
    "owner1": "RACE TR, KELLY J",
    "owner2": "",
    "current_taxes": 6549.77,
    "new_taxes_no_override": 6832.72,
    "override_total_1": 7026.59,
    "override_increase_1": 193.87
  },
  {
    "#": "58 Marshal St, Unit 3 (124-17-03)",
    "$": 1079500,
    "address": "58 Marshal St, Unit 3",
    "parcel_id": "124-17-03",
    "owner1": "BI, WENYA",
    "owner2": "",
    "current_taxes": 7419.15,
    "new_taxes_no_override": 7739.66,
    "override_total_1": 7959.26,
    "override_increase_1": 219.61
  },
  {
    "#": "59 Marshal St (123-15-00)",
    "$": 2261900,
    "address": "59 Marshal St",
    "parcel_id": "123-15-00",
    "owner1": "FOSTER TRS, JOAN B & ROBERT E",
    "owner2": "",
    "current_taxes": 23161.86,
    "new_taxes_no_override": 24162.45,
    "override_total_1": 24848.04,
    "override_increase_1": 685.59
  },
  {
    "#": "60 Marshal St, Unit 1 (124-16-01)",
    "$": 933200,
    "address": "60 Marshal St, Unit 1",
    "parcel_id": "124-16-01",
    "owner1": "COHEN, SUSAN MANDELBAUM",
    "owner2": "",
    "current_taxes": 5921.03,
    "new_taxes_no_override": 6176.82,
    "override_total_1": 6352.08,
    "override_increase_1": 175.26
  },
  {
    "#": "60 Marshal St, Unit 2 (124-16-02)",
    "$": 1006400,
    "address": "60 Marshal St, Unit 2",
    "parcel_id": "124-16-02",
    "owner1": "BAUMANN, DENISE M",
    "owner2": "MCALLISTER, PATRICK I",
    "current_taxes": 6670.6,
    "new_taxes_no_override": 6958.77,
    "override_total_1": 7156.22,
    "override_increase_1": 197.45
  },
  {
    "#": "60 Marshal St, Unit 3 (124-16-03)",
    "$": 974200,
    "address": "60 Marshal St, Unit 3",
    "parcel_id": "124-16-03",
    "owner1": "CLARK, BRIAN W & EKATERINA B",
    "owner2": "",
    "current_taxes": 6340.87,
    "new_taxes_no_override": 6614.8,
    "override_total_1": 6802.49,
    "override_increase_1": 187.69
  },
  {
    "#": "60 Marshal St, Unit 4 (124-16-04)",
    "$": 520600,
    "address": "60 Marshal St, Unit 4",
    "parcel_id": "124-16-04",
    "owner1": "BRESLIN, GREGORY P",
    "owner2": "",
    "current_taxes": 5330.94,
    "new_taxes_no_override": 5561.24,
    "override_total_1": 5719.03,
    "override_increase_1": 157.8
  },
  {
    "#": "65 Marshal St (123-16-00)",
    "$": 1853000,
    "address": "65 Marshal St",
    "parcel_id": "123-16-00",
    "owner1": "TEMPLE OHABEI SHALOM",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "66 Marshal St, Unit 1 & P1 (124-15-01)",
    "$": 737500,
    "address": "66 Marshal St, Unit 1 & P1",
    "parcel_id": "124-15-01",
    "owner1": "SHAH, PRITEN HITEN",
    "owner2": "",
    "current_taxes": 7552.0,
    "new_taxes_no_override": 7878.25,
    "override_total_1": 8101.79,
    "override_increase_1": 223.54
  },
  {
    "#": "66 Marshal St, Unit 1B (124-15-10)",
    "$": 704300,
    "address": "66 Marshal St, Unit 1B",
    "parcel_id": "124-15-10",
    "owner1": "MENG, GUANGYU",
    "owner2": "TONG, ZIMING",
    "current_taxes": 7212.03,
    "new_taxes_no_override": 7523.59,
    "override_total_1": 7737.07,
    "override_increase_1": 213.48
  },
  {
    "#": "66 Marshal St, Unit 2 & P4 (124-15-02)",
    "$": 379600,
    "address": "66 Marshal St, Unit 2 & P4",
    "parcel_id": "124-15-02",
    "owner1": "ZETLAN, PETER J & KRISTEN",
    "owner2": "",
    "current_taxes": 3887.1,
    "new_taxes_no_override": 4055.02,
    "override_total_1": 4170.08,
    "override_increase_1": 115.06
  },
  {
    "#": "66 Marshal St, Unit 3 (124-15-03)",
    "$": 762300,
    "address": "66 Marshal St, Unit 3",
    "parcel_id": "124-15-03",
    "owner1": "PU, YI",
    "owner2": "ZHU, XU",
    "current_taxes": 7805.95,
    "new_taxes_no_override": 8143.17,
    "override_total_1": 8374.22,
    "override_increase_1": 231.06
  },
  {
    "#": "66 Marshal St, Unit 4 (124-15-04)",
    "$": 784700,
    "address": "66 Marshal St, Unit 4",
    "parcel_id": "124-15-04",
    "owner1": "JAJOO TRS, HARISH C & SHASHI",
    "owner2": "",
    "current_taxes": 8035.33,
    "new_taxes_no_override": 8382.46,
    "override_total_1": 8620.3,
    "override_increase_1": 237.85
  },
  {
    "#": "66 Marshal St, Unit 5 (124-15-05)",
    "$": 379600,
    "address": "66 Marshal St, Unit 5",
    "parcel_id": "124-15-05",
    "owner1": "DAGAN, HAGAY & LIMOR",
    "owner2": "",
    "current_taxes": 3887.1,
    "new_taxes_no_override": 4055.02,
    "override_total_1": 4170.08,
    "override_increase_1": 115.06
  },
  {
    "#": "66 Marshal St, Unit 6 & P6 (124-15-06)",
    "$": 762100,
    "address": "66 Marshal St, Unit 6 & P6",
    "parcel_id": "124-15-06",
    "owner1": "MALEKI, NASIM",
    "owner2": "",
    "current_taxes": 7803.9,
    "new_taxes_no_override": 8141.03,
    "override_total_1": 8372.02,
    "override_increase_1": 231.0
  },
  {
    "#": "66 Marshal St, Unit 7 & P7 (124-15-07)",
    "$": 788500,
    "address": "66 Marshal St, Unit 7 & P7",
    "parcel_id": "124-15-07",
    "owner1": "RESTREPO TRS, GEORGE",
    "owner2": "DIERCKS, LISA",
    "current_taxes": 4439.31,
    "new_taxes_no_override": 4631.09,
    "override_total_1": 4762.49,
    "override_increase_1": 131.4
  },
  {
    "#": "66 Marshal St, Unit 8 (124-15-08)",
    "$": 393500,
    "address": "66 Marshal St, Unit 8",
    "parcel_id": "124-15-08",
    "owner1": "LARKIN, MARY",
    "owner2": "HARRINGTON, DAVI",
    "current_taxes": 4029.44,
    "new_taxes_no_override": 4203.51,
    "override_total_1": 4322.78,
    "override_increase_1": 119.27
  },
  {
    "#": "66 Marshal St, Unit 9 (124-15-09)",
    "$": 773300,
    "address": "66 Marshal St, Unit 9",
    "parcel_id": "124-15-09",
    "owner1": "CLARK, LISA M WONG",
    "owner2": "",
    "current_taxes": 4283.66,
    "new_taxes_no_override": 4468.71,
    "override_total_1": 4595.51,
    "override_increase_1": 126.8
  },
  {
    "#": "68 Marshal St, Unit 1 & G1 (124-14-03)",
    "$": 1291900,
    "address": "68 Marshal St, Unit 1 & G1",
    "parcel_id": "124-14-03",
    "owner1": "OKEEFFE, BRIAN K & JESSICA",
    "owner2": "",
    "current_taxes": 9594.12,
    "new_taxes_no_override": 10008.59,
    "override_total_1": 10292.57,
    "override_increase_1": 283.99
  },
  {
    "#": "68 Marshal St, Unit 2 & G2 (124-14-01)",
    "$": 1506700,
    "address": "68 Marshal St, Unit 2 & G2",
    "parcel_id": "124-14-01",
    "owner1": "MALONEY TRS, MICHAEL R & HEATHER",
    "owner2": "",
    "current_taxes": 11793.67,
    "new_taxes_no_override": 12303.16,
    "override_total_1": 12652.25,
    "override_increase_1": 349.09
  },
  {
    "#": "68 Marshal St, Unit 3 & G3 (124-14-02)",
    "$": 1486600,
    "address": "68 Marshal St, Unit 3 & G3",
    "parcel_id": "124-14-02",
    "owner1": "MULLINS, ANDREW & STEPHANIE",
    "owner2": "",
    "current_taxes": 11587.85,
    "new_taxes_no_override": 12088.45,
    "override_total_1": 12431.45,
    "override_increase_1": 343.0
  },
  {
    "#": "69 Marshal St (123-17-00)",
    "$": 1992700,
    "address": "69 Marshal St",
    "parcel_id": "123-17-00",
    "owner1": "TEMPLE OHABEI SHALOM",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "70 Marshal St, Unit A-4 (124-13-03)",
    "$": 1550700,
    "address": "70 Marshal St, Unit A-4",
    "parcel_id": "124-13-03",
    "owner1": "PATSOURIS, PETER",
    "owner2": "KOLTAN, HANA",
    "current_taxes": 12244.23,
    "new_taxes_no_override": 12773.18,
    "override_total_1": 13135.61,
    "override_increase_1": 362.43
  },
  {
    "#": "70 Marshal St, Unit A1 (124-13-04)",
    "$": 543100,
    "address": "70 Marshal St, Unit A1",
    "parcel_id": "124-13-04",
    "owner1": "70 MARA1 LLC",
    "owner2": "C/O KELLER ELISABETH",
    "current_taxes": 5561.34,
    "new_taxes_no_override": 5801.59,
    "override_total_1": 5966.21,
    "override_increase_1": 164.62
  },
  {
    "#": "70 Marshal St, Unit A2 (124-13-01)",
    "$": 1588000,
    "address": "70 Marshal St, Unit A2",
    "parcel_id": "124-13-01",
    "owner1": "KELLER, ELISABETH A",
    "owner2": "KALISH, RICHARD L",
    "current_taxes": 12626.19,
    "new_taxes_no_override": 13171.64,
    "override_total_1": 13545.38,
    "override_increase_1": 373.74
  },
  {
    "#": "70 Marshal St, Unit A3 & Pii (124-13-02)",
    "$": 1773700,
    "address": "70 Marshal St, Unit A3 & Pii",
    "parcel_id": "124-13-02",
    "owner1": "YU, QINFENG",
    "owner2": "",
    "current_taxes": 18162.69,
    "new_taxes_no_override": 18947.32,
    "override_total_1": 19484.93,
    "override_increase_1": 537.62
  },
  {
    "#": "76 Marshal St, Unit 1 (124-12-03)",
    "$": 1039300,
    "address": "76 Marshal St, Unit 1",
    "parcel_id": "124-12-03",
    "owner1": "DALE, CHERYL E",
    "owner2": "",
    "current_taxes": 7007.5,
    "new_taxes_no_override": 7310.22,
    "override_total_1": 7517.65,
    "override_increase_1": 207.42
  },
  {
    "#": "76 Marshal St, Unit 2 (124-12-01)",
    "$": 1174400,
    "address": "76 Marshal St, Unit 2",
    "parcel_id": "124-12-01",
    "owner1": "LU, MINYING",
    "owner2": "LI, QING",
    "current_taxes": 12025.86,
    "new_taxes_no_override": 12545.38,
    "override_total_1": 12901.34,
    "override_increase_1": 355.97
  },
  {
    "#": "76 Marshal St, Unit 3 (124-12-02)",
    "$": 1073500,
    "address": "76 Marshal St, Unit 3",
    "parcel_id": "124-12-02",
    "owner1": "BERK, EMANUEL",
    "owner2": "",
    "current_taxes": 7357.71,
    "new_taxes_no_override": 7675.56,
    "override_total_1": 7893.35,
    "override_increase_1": 217.79
  },
  {
    "#": "23 Marthas Ln (417-04-02)",
    "$": 2669700,
    "address": "23 Marthas Ln",
    "parcel_id": "417-04-02",
    "owner1": "ZHANG TR, EFFIE",
    "owner2": "",
    "current_taxes": 23702.79,
    "new_taxes_no_override": 24726.75,
    "override_total_1": 25428.35,
    "override_increase_1": 701.6
  },
  {
    "#": "25 Marthas Ln (417-04-01)",
    "$": 3541600,
    "address": "25 Marthas Ln",
    "parcel_id": "417-04-01",
    "owner1": "HAO, YONG KUAN",
    "owner2": "ZHAO, BAOHONG",
    "current_taxes": 32631.05,
    "new_taxes_no_override": 34040.71,
    "override_total_1": 35006.59,
    "override_increase_1": 965.88
  },
  {
    "#": "26 Marthas Ln (416-25-00)",
    "$": 2323000,
    "address": "26 Marthas Ln",
    "parcel_id": "416-25-00",
    "owner1": "VANMARCKE, PATRICIA C PIERETTI",
    "owner2": "ODRIOZOLA, ANDONI ROCHE",
    "current_taxes": 20152.59,
    "new_taxes_no_override": 21023.18,
    "override_total_1": 21619.7,
    "override_increase_1": 596.52
  },
  {
    "#": "33 Marthas Ln (417-03-00)",
    "$": 2114900,
    "address": "33 Marthas Ln",
    "parcel_id": "417-03-00",
    "owner1": "COHEN, HARVEY J & LOUISE G",
    "owner2": "",
    "current_taxes": 18021.64,
    "new_taxes_no_override": 18800.17,
    "override_total_1": 19333.62,
    "override_increase_1": 533.44
  },
  {
    "#": "34 Marthas Ln (416-26-00)",
    "$": 2105900,
    "address": "34 Marthas Ln",
    "parcel_id": "416-26-00",
    "owner1": "LIU, DINGFANG",
    "owner2": "HU, XIAO",
    "current_taxes": 17929.48,
    "new_taxes_no_override": 18704.03,
    "override_total_1": 19234.75,
    "override_increase_1": 530.71
  },
  {
    "#": "44 Marthas Ln (416-27-00)",
    "$": 2405000,
    "address": "44 Marthas Ln",
    "parcel_id": "416-27-00",
    "owner1": "WALTER, JOHN S",
    "owner2": "LORENZO, MAYRA E",
    "current_taxes": 20992.27,
    "new_taxes_no_override": 21899.14,
    "override_total_1": 22520.51,
    "override_increase_1": 621.37
  },
  {
    "#": "45 Marthas Ln (417-02-00)",
    "$": 2813800,
    "address": "45 Marthas Ln",
    "parcel_id": "417-02-00",
    "owner1": "YANG, QINGJIA",
    "owner2": "ZHOU, NINGLU",
    "current_taxes": 28813.31,
    "new_taxes_no_override": 30058.04,
    "override_total_1": 30910.92,
    "override_increase_1": 852.87
  },
  {
    "#": "53 Marthas Ln (417-01-00)",
    "$": 3397900,
    "address": "53 Marthas Ln",
    "parcel_id": "417-01-00",
    "owner1": "MOKADY, EHUD & ELANA",
    "owner2": "",
    "current_taxes": 31159.56,
    "new_taxes_no_override": 32505.65,
    "override_total_1": 33427.98,
    "override_increase_1": 922.32
  },
  {
    "#": "1 Mason St (014-04-00)",
    "$": 6973800,
    "address": "1 Mason St",
    "parcel_id": "014-04-00",
    "owner1": "GAJDECKI, ANITA M",
    "owner2": "",
    "current_taxes": 67776.78,
    "new_taxes_no_override": 70704.74,
    "override_total_1": 72710.93,
    "override_increase_1": 2006.19
  },
  {
    "#": "8 Mason St (013-01-00)",
    "$": 5157100,
    "address": "8 Mason St",
    "parcel_id": "013-01-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O MASON SQUARE",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "11 Mason St (014-05-00)",
    "$": 5194200,
    "address": "11 Mason St",
    "parcel_id": "014-05-00",
    "owner1": "HAWTHORNE, RANDOLPH G",
    "owner2": "BALDWIN, CARLISS Y",
    "current_taxes": 49553.67,
    "new_taxes_no_override": 51694.39,
    "override_total_1": 53161.18,
    "override_increase_1": 1466.79
  },
  {
    "#": "21 Mason St (014-06-00)",
    "$": 6816700,
    "address": "21 Mason St",
    "parcel_id": "014-06-00",
    "owner1": "SAPERSTONE, PETER S & NANCY B",
    "owner2": "",
    "current_taxes": 69803.01,
    "new_taxes_no_override": 72818.5,
    "override_total_1": 74884.67,
    "override_increase_1": 2066.17
  },
  {
    "#": "2 Mason Ter (088-17-00)",
    "$": 3502800,
    "address": "2 Mason Ter",
    "parcel_id": "088-17-00",
    "owner1": "GARDNER, WILLIAM L",
    "owner2": "ROTTER, SARI J",
    "current_taxes": 32233.74,
    "new_taxes_no_override": 33626.24,
    "override_total_1": 34580.36,
    "override_increase_1": 954.12
  },
  {
    "#": "5 Mason Ter (089-14-00)",
    "$": 3212700,
    "address": "5 Mason Ter",
    "parcel_id": "089-14-00",
    "owner1": "ROSS, SUSAN M & CHARLES  N",
    "owner2": "",
    "current_taxes": 29263.11,
    "new_taxes_no_override": 30527.28,
    "override_total_1": 31393.46,
    "override_increase_1": 866.19
  },
  {
    "#": "12 Mason Ter (088-16-37)",
    "$": 4689500,
    "address": "12 Mason Ter",
    "parcel_id": "088-16-37",
    "owner1": "BARNES TRS, THOMAS M & CAROLINE S",
    "owner2": "",
    "current_taxes": 44385.55,
    "new_taxes_no_override": 46303.01,
    "override_total_1": 47616.82,
    "override_increase_1": 1313.81
  },
  {
    "#": "19 Mason Ter (089-14-01)",
    "$": 1849700,
    "address": "19 Mason Ter",
    "parcel_id": "089-14-01",
    "owner1": "FITZGERALD TR, KEVIN",
    "owner2": "OKAMURA TR, HITOMI HEIDI",
    "current_taxes": 15305.99,
    "new_taxes_no_override": 15967.21,
    "override_total_1": 16420.27,
    "override_increase_1": 453.06
  },
  {
    "#": "22 Mason Ter (088-15-00)",
    "$": 3286200,
    "address": "22 Mason Ter",
    "parcel_id": "088-15-00",
    "owner1": "PINNACLE FOUNDATION LLC",
    "owner2": "",
    "current_taxes": 33650.69,
    "new_taxes_no_override": 35104.4,
    "override_total_1": 36100.46,
    "override_increase_1": 996.06
  },
  {
    "#": "25 Mason Ter (089-15-00)",
    "$": 1371900,
    "address": "25 Mason Ter",
    "parcel_id": "089-15-00",
    "owner1": "BATRA-KAHOUSSI, VANDHNA",
    "owner2": "KAHOUSSI, BEHNAM",
    "current_taxes": 14048.26,
    "new_taxes_no_override": 14655.14,
    "override_total_1": 15070.97,
    "override_increase_1": 415.83
  },
  {
    "#": "28 Mason Ter (088-14-00)",
    "$": 2419700,
    "address": "28 Mason Ter",
    "parcel_id": "088-14-00",
    "owner1": "DZIK, WALTER H",
    "owner2": "KUWABARA, YURIKO",
    "current_taxes": 21142.79,
    "new_taxes_no_override": 22056.16,
    "override_total_1": 22681.99,
    "override_increase_1": 625.83
  },
  {
    "#": "29 Mason Ter (089-15-01)",
    "$": 2452700,
    "address": "29 Mason Ter",
    "parcel_id": "089-15-01",
    "owner1": "WHITE, JONATHAN & MARY",
    "owner2": "",
    "current_taxes": 25115.65,
    "new_taxes_no_override": 26200.65,
    "override_total_1": 26944.07,
    "override_increase_1": 743.42
  },
  {
    "#": "32 Mason Ter (088-13-00)",
    "$": 2381800,
    "address": "32 Mason Ter",
    "parcel_id": "088-13-00",
    "owner1": "SPUNT, NATHAN & EMILY",
    "owner2": "",
    "current_taxes": 24389.63,
    "new_taxes_no_override": 25443.26,
    "override_total_1": 26165.2,
    "override_increase_1": 721.93
  },
  {
    "#": "38 Mason Ter (088-12-00)",
    "$": 1367500,
    "address": "38 Mason Ter",
    "parcel_id": "088-12-00",
    "owner1": "HORWITZ, AUDREY E & MIRIAM R",
    "owner2": "",
    "current_taxes": 10368.27,
    "new_taxes_no_override": 10816.18,
    "override_total_1": 11123.08,
    "override_increase_1": 306.9
  },
  {
    "#": "41 Mason Ter (089-16-00)",
    "$": 3368700,
    "address": "41 Mason Ter",
    "parcel_id": "089-16-00",
    "owner1": "GONG, CHEN CHEN",
    "owner2": "DESIMONE, ROBERT",
    "current_taxes": 30860.55,
    "new_taxes_no_override": 32193.73,
    "override_total_1": 33107.2,
    "override_increase_1": 913.47
  },
  {
    "#": "42 Mason Ter (088-11-00)",
    "$": 1941100,
    "address": "42 Mason Ter",
    "parcel_id": "088-11-00",
    "owner1": "BODENHEIMER TRS, ROSEMARIE & THOMAS",
    "owner2": "",
    "current_taxes": 16241.93,
    "new_taxes_no_override": 16943.58,
    "override_total_1": 17424.34,
    "override_increase_1": 480.76
  },
  {
    "#": "45 Mason Ter, Unit 1 (089-17-01)",
    "$": 746000,
    "address": "45 Mason Ter, Unit 1",
    "parcel_id": "089-17-01",
    "owner1": "HAMAD, ANTHONY Z",
    "owner2": "HEYDARI, NASTARAN",
    "current_taxes": 7639.04,
    "new_taxes_no_override": 7969.05,
    "override_total_1": 8195.16,
    "override_increase_1": 226.12
  },
  {
    "#": "45 Mason Ter, Unit 2 (089-17-02)",
    "$": 641900,
    "address": "45 Mason Ter, Unit 2",
    "parcel_id": "089-17-02",
    "owner1": "SUI, LESHEN",
    "owner2": "",
    "current_taxes": 6573.06,
    "new_taxes_no_override": 6857.02,
    "override_total_1": 7051.58,
    "override_increase_1": 194.56
  },
  {
    "#": "45 Mason Ter, Unit 3 (089-17-03)",
    "$": 849600,
    "address": "45 Mason Ter, Unit 3",
    "parcel_id": "089-17-03",
    "owner1": "ANG TRS, SOON TECK GIBSON",
    "owner2": "PEK , WEI LI",
    "current_taxes": 8699.9,
    "new_taxes_no_override": 9075.74,
    "override_total_1": 9333.25,
    "override_increase_1": 257.52
  },
  {
    "#": "45 Mason Ter, Unit 4 (089-17-04)",
    "$": 625400,
    "address": "45 Mason Ter, Unit 4",
    "parcel_id": "089-17-04",
    "owner1": "SCHONTHAL, EMILIA",
    "owner2": "",
    "current_taxes": 2769.16,
    "new_taxes_no_override": 2888.79,
    "override_total_1": 2970.75,
    "override_increase_1": 81.97
  },
  {
    "#": "45 Mason Ter, Unit 5 (089-17-05)",
    "$": 1434200,
    "address": "45 Mason Ter, Unit 5",
    "parcel_id": "089-17-05",
    "owner1": "LEMESHUK, JAN",
    "owner2": "GUREVICH, MARINA",
    "current_taxes": 11051.27,
    "new_taxes_no_override": 11528.68,
    "override_total_1": 11855.8,
    "override_increase_1": 327.12
  },
  {
    "#": "45 Mason Ter, Unit A (089-17-12)",
    "$": 660600,
    "address": "45 Mason Ter, Unit A",
    "parcel_id": "089-17-12",
    "owner1": "SIMON, EMMA",
    "owner2": "RAVISH, ASHERAH",
    "current_taxes": 6764.54,
    "new_taxes_no_override": 7056.77,
    "override_total_1": 7257.0,
    "override_increase_1": 200.23
  },
  {
    "#": "47 Mason Ter, Unit 1 (089-17-06)",
    "$": 685100,
    "address": "47 Mason Ter, Unit 1",
    "parcel_id": "089-17-06",
    "owner1": "HECKLER, KEVIN",
    "owner2": "BARBER, BEVERLY A",
    "current_taxes": 3380.49,
    "new_taxes_no_override": 3526.53,
    "override_total_1": 3626.59,
    "override_increase_1": 100.06
  },
  {
    "#": "47 Mason Ter, Unit 2 (089-17-07)",
    "$": 560200,
    "address": "47 Mason Ter, Unit 2",
    "parcel_id": "089-17-07",
    "owner1": "LYNCH, MARGARET E",
    "owner2": "",
    "current_taxes": 2101.51,
    "new_taxes_no_override": 2192.3,
    "override_total_1": 2254.5,
    "override_increase_1": 62.2
  },
  {
    "#": "47 Mason Ter, Unit 3 (089-17-08)",
    "$": 711900,
    "address": "47 Mason Ter, Unit 3",
    "parcel_id": "089-17-08",
    "owner1": "INTERNICOLA, JENNIFER A",
    "owner2": "",
    "current_taxes": 3654.92,
    "new_taxes_no_override": 3812.81,
    "override_total_1": 3921.0,
    "override_increase_1": 108.19
  },
  {
    "#": "47 Mason Ter, Unit 4 (089-17-09)",
    "$": 562500,
    "address": "47 Mason Ter, Unit 4",
    "parcel_id": "089-17-09",
    "owner1": "LARIONOVA, EVGENIYA",
    "owner2": "",
    "current_taxes": 2125.07,
    "new_taxes_no_override": 2216.87,
    "override_total_1": 2279.78,
    "override_increase_1": 62.9
  },
  {
    "#": "47 Mason Ter, Unit 5 (089-17-10)",
    "$": 697500,
    "address": "47 Mason Ter, Unit 5",
    "parcel_id": "089-17-10",
    "owner1": "SPANO, GREGORY A",
    "owner2": "",
    "current_taxes": 7142.4,
    "new_taxes_no_override": 7450.95,
    "override_total_1": 7662.37,
    "override_increase_1": 211.42
  },
  {
    "#": "47 Mason Ter, Unit 6 (089-17-11)",
    "$": 570100,
    "address": "47 Mason Ter, Unit 6",
    "parcel_id": "089-17-11",
    "owner1": "XING, JIANGANG",
    "owner2": "ZHONG, ZHAOHUI",
    "current_taxes": 5837.82,
    "new_taxes_no_override": 6090.01,
    "override_total_1": 6262.81,
    "override_increase_1": 172.8
  },
  {
    "#": "48 Mason Ter (088-10-00)",
    "$": 2074900,
    "address": "48 Mason Ter",
    "parcel_id": "088-10-00",
    "owner1": "SANDERS, LINDA K",
    "owner2": "STATES, ALAN R",
    "current_taxes": 17612.04,
    "new_taxes_no_override": 18372.88,
    "override_total_1": 18894.2,
    "override_increase_1": 521.32
  },
  {
    "#": "51 Mason Ter (089-18-00)",
    "$": 2081800,
    "address": "51 Mason Ter",
    "parcel_id": "089-18-00",
    "owner1": "SDOUCAS, LEAH",
    "owner2": "",
    "current_taxes": 21317.63,
    "new_taxes_no_override": 22238.55,
    "override_total_1": 22869.55,
    "override_increase_1": 631.0
  },
  {
    "#": "52 Mason Ter (088-09-00)",
    "$": 2063500,
    "address": "52 Mason Ter",
    "parcel_id": "088-09-00",
    "owner1": "GRUNERT, JOHN A",
    "owner2": "EDELBERG, E",
    "current_taxes": 17495.31,
    "new_taxes_no_override": 18251.11,
    "override_total_1": 18768.97,
    "override_increase_1": 517.86
  },
  {
    "#": "55 Mason Ter, Unit 1 (089-18-02)",
    "$": 1079000,
    "address": "55 Mason Ter, Unit 1",
    "parcel_id": "089-18-02",
    "owner1": "HILLMAN TRS, SCOTT R & ALINE I",
    "owner2": "",
    "current_taxes": 7414.03,
    "new_taxes_no_override": 7734.32,
    "override_total_1": 7953.77,
    "override_increase_1": 219.46
  },
  {
    "#": "56 Mason Ter (088-08-00)",
    "$": 1989500,
    "address": "56 Mason Ter",
    "parcel_id": "088-08-00",
    "owner1": "MAZURKEVICH TRS, YURI & DANA",
    "owner2": "",
    "current_taxes": 16737.55,
    "new_taxes_no_override": 17460.61,
    "override_total_1": 17956.04,
    "override_increase_1": 495.43
  },
  {
    "#": "57 Mason Ter, Unit 2 (089-18-03)",
    "$": 1194300,
    "address": "57 Mason Ter, Unit 2",
    "parcel_id": "089-18-03",
    "owner1": "BRUSS, NEAL H",
    "owner2": "GOLEMAN, JUDITH",
    "current_taxes": 8594.7,
    "new_taxes_no_override": 8965.99,
    "override_total_1": 9220.39,
    "override_increase_1": 254.4
  },
  {
    "#": "59 Mason Ter (089-19-00)",
    "$": 1882100,
    "address": "59 Mason Ter",
    "parcel_id": "089-19-00",
    "owner1": "59-61 MASON TERRACE LLC",
    "owner2": "",
    "current_taxes": 19272.7,
    "new_taxes_no_override": 20105.28,
    "override_total_1": 20675.75,
    "override_increase_1": 570.47
  },
  {
    "#": "60 Mason Ter (088-07-01)",
    "$": 2466300,
    "address": "60 Mason Ter",
    "parcel_id": "088-07-01",
    "owner1": "LOEWINTHAN TR, PETER FREDERIC",
    "owner2": "",
    "current_taxes": 25254.91,
    "new_taxes_no_override": 26345.92,
    "override_total_1": 27093.47,
    "override_increase_1": 747.55
  },
  {
    "#": "63 Mason Ter (089-20-00)",
    "$": 2223800,
    "address": "63 Mason Ter",
    "parcel_id": "089-20-00",
    "owner1": "GUTMANN, SAMUEL",
    "owner2": "COLBURN, NANCY",
    "current_taxes": 19136.78,
    "new_taxes_no_override": 19963.49,
    "override_total_1": 20529.94,
    "override_increase_1": 566.45
  },
  {
    "#": "66 Mason Ter (088-07-02)",
    "$": 4851500,
    "address": "66 Mason Ter",
    "parcel_id": "088-07-02",
    "owner1": "FINNERTY TRS, CECEILIA K & PETER F",
    "owner2": "",
    "current_taxes": 46044.43,
    "new_taxes_no_override": 48033.55,
    "override_total_1": 49396.46,
    "override_increase_1": 1362.92
  },
  {
    "#": "67 Mason Ter, Unit 1 & G1 & P (089-21-02)",
    "$": 1115400,
    "address": "67 Mason Ter, Unit 1 & G1 & P",
    "parcel_id": "089-21-02",
    "owner1": "LEVY, NADAV",
    "owner2": "SHAHAR, EFRAT",
    "current_taxes": 7786.76,
    "new_taxes_no_override": 8123.15,
    "override_total_1": 8353.64,
    "override_increase_1": 230.49
  },
  {
    "#": "69 Mason Ter, Unit 2 G2 Prk (089-21-01)",
    "$": 1616900,
    "address": "69 Mason Ter, Unit 2 G2 Prk",
    "parcel_id": "089-21-01",
    "owner1": "D ALOIA, ALICIA",
    "owner2": "",
    "current_taxes": 12922.12,
    "new_taxes_no_override": 13480.36,
    "override_total_1": 13862.85,
    "override_increase_1": 382.49
  },
  {
    "#": "70 Mason Ter (088-06-01)",
    "$": 3131100,
    "address": "70 Mason Ter",
    "parcel_id": "088-06-01",
    "owner1": "COREY HILL DEVELOPMENT LLC",
    "owner2": "",
    "current_taxes": 32062.46,
    "new_taxes_no_override": 33447.56,
    "override_total_1": 34396.61,
    "override_increase_1": 949.05
  },
  {
    "#": "71 Mason Ter, Unit 1 (089-22-01)",
    "$": 1123300,
    "address": "71 Mason Ter, Unit 1",
    "parcel_id": "089-22-01",
    "owner1": "ZACHMANN, DOROTHY",
    "owner2": "GROSSMAN, KEN",
    "current_taxes": 11502.59,
    "new_taxes_no_override": 11999.5,
    "override_total_1": 12339.98,
    "override_increase_1": 340.48
  },
  {
    "#": "71 Mason Ter, Unit 2 (089-22-02)",
    "$": 1266200,
    "address": "71 Mason Ter, Unit 2",
    "parcel_id": "089-22-02",
    "owner1": "MAMANE, PAUL",
    "owner2": "BARCHECHAT, NATHALYA",
    "current_taxes": 12965.89,
    "new_taxes_no_override": 13526.02,
    "override_total_1": 13909.81,
    "override_increase_1": 383.79
  },
  {
    "#": "77 Mason Ter (089-23-25)",
    "$": 10292000,
    "address": "77 Mason Ter",
    "parcel_id": "089-23-25",
    "owner1": "CHAMPION MONTROSE LLC",
    "owner2": "",
    "current_taxes": 105390.08,
    "new_taxes_no_override": 109942.93,
    "override_total_1": 113062.48,
    "override_increase_1": 3119.55
  },
  {
    "#": "80 Mason Ter, Unit 80 (088-05-02)",
    "$": 2097500,
    "address": "80 Mason Ter, Unit 80",
    "parcel_id": "088-05-02",
    "owner1": "MCKEE, PATRICK & KIMBERLY",
    "owner2": "",
    "current_taxes": 17843.47,
    "new_taxes_no_override": 18614.31,
    "override_total_1": 19142.47,
    "override_increase_1": 528.17
  },
  {
    "#": "82 Mason Ter, Unit 82 (088-05-01)",
    "$": 1542600,
    "address": "82 Mason Ter, Unit 82",
    "parcel_id": "088-05-01",
    "owner1": "LANKFORD, PETER",
    "owner2": "CHIEN, ALYNA",
    "current_taxes": 15796.22,
    "new_taxes_no_override": 16478.62,
    "override_total_1": 16946.18,
    "override_increase_1": 467.57
  },
  {
    "#": "87 Mason Ter, Unit 1 (089-26-01)",
    "$": 656300,
    "address": "87 Mason Ter, Unit 1",
    "parcel_id": "089-26-01",
    "owner1": "ROSENTHAL, LEIGH S",
    "owner2": "HALPER, SHEILA J",
    "current_taxes": 6720.51,
    "new_taxes_no_override": 7010.84,
    "override_total_1": 7209.76,
    "override_increase_1": 198.93
  },
  {
    "#": "87 Mason Ter, Unit 2 (089-26-02)",
    "$": 1063600,
    "address": "87 Mason Ter, Unit 2",
    "parcel_id": "089-26-02",
    "owner1": "ANDRES, ALAN E",
    "owner2": "WEAVER, ANNE",
    "current_taxes": 7256.33,
    "new_taxes_no_override": 7569.8,
    "override_total_1": 7784.59,
    "override_increase_1": 214.79
  },
  {
    "#": "87 Mason Ter, Unit 3 (089-26-03)",
    "$": 878100,
    "address": "87 Mason Ter, Unit 3",
    "parcel_id": "089-26-03",
    "owner1": "COUSIN CHARLIE'S BISCUITS LLC",
    "owner2": "",
    "current_taxes": 8991.74,
    "new_taxes_no_override": 9380.18,
    "override_total_1": 9646.34,
    "override_increase_1": 266.16
  },
  {
    "#": "87 Mason Ter, Unit 4 (089-26-04)",
    "$": 1078100,
    "address": "87 Mason Ter, Unit 4",
    "parcel_id": "089-26-04",
    "owner1": "KING TRS, GEORGE A JR",
    "owner2": "MORIO, SOPHIA M",
    "current_taxes": 7404.81,
    "new_taxes_no_override": 7724.7,
    "override_total_1": 7943.88,
    "override_increase_1": 219.18
  },
  {
    "#": "87 Mason Ter, Unit 5 (089-26-05)",
    "$": 878100,
    "address": "87 Mason Ter, Unit 5",
    "parcel_id": "089-26-05",
    "owner1": "BRUSIC, VLADIMIR & VESNA",
    "owner2": "",
    "current_taxes": 5356.81,
    "new_taxes_no_override": 5588.22,
    "override_total_1": 5746.79,
    "override_increase_1": 158.56
  },
  {
    "#": "87 Mason Ter, Unit 6 (089-26-06)",
    "$": 1078200,
    "address": "87 Mason Ter, Unit 6",
    "parcel_id": "089-26-06",
    "owner1": "CLAUSON, CONNIE M",
    "owner2": "",
    "current_taxes": 7405.83,
    "new_taxes_no_override": 7725.76,
    "override_total_1": 7944.97,
    "override_increase_1": 219.21
  },
  {
    "#": "87 Mason Ter, Unit A (089-26-15)",
    "$": 672800,
    "address": "87 Mason Ter, Unit A",
    "parcel_id": "089-26-15",
    "owner1": "COLETTI, ANTHONY",
    "owner2": "",
    "current_taxes": 6889.47,
    "new_taxes_no_override": 7187.1,
    "override_total_1": 7391.02,
    "override_increase_1": 203.93
  },
  {
    "#": "88 Mason Ter, Unit 88 & G21-22 (088-04-01)",
    "$": 3008600,
    "address": "88 Mason Ter, Unit 88 & G21-22",
    "parcel_id": "088-04-01",
    "owner1": "KINSELLA, JAMES M",
    "owner2": "MAUNSELL, GRAINNE P",
    "current_taxes": 27173.13,
    "new_taxes_no_override": 28347.01,
    "override_total_1": 29151.33,
    "override_increase_1": 804.32
  },
  {
    "#": "89 Mason Ter, Unit 1 (089-26-09)",
    "$": 647600,
    "address": "89 Mason Ter, Unit 1",
    "parcel_id": "089-26-09",
    "owner1": "SREDL, DIANE L",
    "owner2": "",
    "current_taxes": 2996.49,
    "new_taxes_no_override": 3125.94,
    "override_total_1": 3214.63,
    "override_increase_1": 88.7
  },
  {
    "#": "89 Mason Ter, Unit 2 (089-26-10)",
    "$": 1153400,
    "address": "89 Mason Ter, Unit 2",
    "parcel_id": "089-26-10",
    "owner1": "GREEN, TR, JOAN C & WALTER A",
    "owner2": "",
    "current_taxes": 11810.82,
    "new_taxes_no_override": 12321.05,
    "override_total_1": 12670.65,
    "override_increase_1": 349.6
  },
  {
    "#": "89 Mason Ter, Unit 3 (089-26-11)",
    "$": 830700,
    "address": "89 Mason Ter, Unit 3",
    "parcel_id": "089-26-11",
    "owner1": "PELLEGROM, SARA E",
    "owner2": "OFFENBERG, NICHOLAS",
    "current_taxes": 4871.43,
    "new_taxes_no_override": 5081.88,
    "override_total_1": 5226.07,
    "override_increase_1": 144.19
  },
  {
    "#": "89 Mason Ter, Unit 4 (089-26-12)",
    "$": 1137400,
    "address": "89 Mason Ter, Unit 4",
    "parcel_id": "089-26-12",
    "owner1": "GREEN, JOAN C",
    "owner2": "",
    "current_taxes": 11646.98,
    "new_taxes_no_override": 12150.13,
    "override_total_1": 12494.88,
    "override_increase_1": 344.75
  },
  {
    "#": "89 Mason Ter, Unit 5 (089-26-13)",
    "$": 820400,
    "address": "89 Mason Ter, Unit 5",
    "parcel_id": "089-26-13",
    "owner1": "LO, MING",
    "owner2": "CHIU, WEI-TING",
    "current_taxes": 4765.96,
    "new_taxes_no_override": 4971.85,
    "override_total_1": 5112.92,
    "override_increase_1": 141.07
  },
  {
    "#": "89 Mason Ter, Unit 6 (089-26-14)",
    "$": 1167800,
    "address": "89 Mason Ter, Unit 6",
    "parcel_id": "089-26-14",
    "owner1": "WU, GUOYONG",
    "owner2": "",
    "current_taxes": 8323.34,
    "new_taxes_no_override": 8682.91,
    "override_total_1": 8929.28,
    "override_increase_1": 246.37
  },
  {
    "#": "89 Mason Ter, Unit A (089-26-07)",
    "$": 726300,
    "address": "89 Mason Ter, Unit A",
    "parcel_id": "089-26-07",
    "owner1": "DAI, XING",
    "owner2": "MENG, JIHONG & YUZHONG",
    "current_taxes": 3802.38,
    "new_taxes_no_override": 3966.64,
    "override_total_1": 4079.19,
    "override_increase_1": 112.55
  },
  {
    "#": "89 Mason Ter, Unit B (089-26-08)",
    "$": 394000,
    "address": "89 Mason Ter, Unit B",
    "parcel_id": "089-26-08",
    "owner1": "GORDETSKY, ANDREW",
    "owner2": "",
    "current_taxes": 4034.56,
    "new_taxes_no_override": 4208.85,
    "override_total_1": 4328.28,
    "override_increase_1": 119.42
  },
  {
    "#": "90 Mason Ter, Unit 90 (088-04-02)",
    "$": 2645100,
    "address": "90 Mason Ter, Unit 90",
    "parcel_id": "088-04-02",
    "owner1": "PAN TRS, JUNG FENG & CHUN ZHI WANG",
    "owner2": "",
    "current_taxes": 23450.89,
    "new_taxes_no_override": 24463.97,
    "override_total_1": 25158.11,
    "override_increase_1": 694.15
  },
  {
    "#": "94 Mason Ter, Unit 1 & P1-P2 (088-03-01)",
    "$": 902900,
    "address": "94 Mason Ter, Unit 1 & P1-P2",
    "parcel_id": "088-03-01",
    "owner1": "WALSKE, JARED",
    "owner2": "",
    "current_taxes": 9245.7,
    "new_taxes_no_override": 9645.11,
    "override_total_1": 9918.79,
    "override_increase_1": 273.67
  },
  {
    "#": "94 Mason Ter, Unit 2 & P4-P5 (088-03-02)",
    "$": 1574600,
    "address": "94 Mason Ter, Unit 2 & P4-P5",
    "parcel_id": "088-03-02",
    "owner1": "LEIBOWITZ, AKIVA",
    "owner2": "ROMI, HILA",
    "current_taxes": 12488.97,
    "new_taxes_no_override": 13028.49,
    "override_total_1": 13398.17,
    "override_increase_1": 369.67
  },
  {
    "#": "94 Mason Ter, Unit B & P3 (088-03-03)",
    "$": 552600,
    "address": "94 Mason Ter, Unit B & P3",
    "parcel_id": "088-03-03",
    "owner1": "NAIM, NATASHA",
    "owner2": "WALSKE, JARED",
    "current_taxes": 2023.69,
    "new_taxes_no_override": 2111.11,
    "override_total_1": 2171.01,
    "override_increase_1": 59.9
  },
  {
    "#": "95 Mason Ter, Unit 95-1 (089-28-03)",
    "$": 651200,
    "address": "95 Mason Ter, Unit 95-1",
    "parcel_id": "089-28-03",
    "owner1": "NIST, SARAH & JUDITH A",
    "owner2": "",
    "current_taxes": 6668.29,
    "new_taxes_no_override": 6956.36,
    "override_total_1": 7153.74,
    "override_increase_1": 197.38
  },
  {
    "#": "95 Mason Ter, Unit 95-2 (089-28-04)",
    "$": 1175200,
    "address": "95 Mason Ter, Unit 95-2",
    "parcel_id": "089-28-04",
    "owner1": "MARANZANO TRS, JOSEPH F & GWYNEDD H",
    "owner2": "",
    "current_taxes": 8399.11,
    "new_taxes_no_override": 8761.95,
    "override_total_1": 9010.57,
    "override_increase_1": 248.61
  },
  {
    "#": "95 Mason Ter, Unit 95-3 (089-28-05)",
    "$": 887700,
    "address": "95 Mason Ter, Unit 95-3",
    "parcel_id": "089-28-05",
    "owner1": "HOLLAND, MARGARET",
    "owner2": "",
    "current_taxes": 5455.11,
    "new_taxes_no_override": 5690.77,
    "override_total_1": 5852.24,
    "override_increase_1": 161.47
  },
  {
    "#": "95 Mason Ter, Unit 95-4 (089-28-06)",
    "$": 1219500,
    "address": "95 Mason Ter, Unit 95-4",
    "parcel_id": "089-28-06",
    "owner1": "SPRECHER, ELI",
    "owner2": "GELFMAN, ILANA",
    "current_taxes": 8852.75,
    "new_taxes_no_override": 9235.19,
    "override_total_1": 9497.23,
    "override_increase_1": 262.04
  },
  {
    "#": "95 Mason Ter, Unit 95-5 (089-28-07)",
    "$": 923000,
    "address": "95 Mason Ter, Unit 95-5",
    "parcel_id": "089-28-07",
    "owner1": "HIGGINS, KATHLEEN A",
    "owner2": "",
    "current_taxes": 5816.59,
    "new_taxes_no_override": 6067.87,
    "override_total_1": 6240.04,
    "override_increase_1": 172.17
  },
  {
    "#": "95 Mason Ter, Unit 95-6 (089-28-08)",
    "$": 1211800,
    "address": "95 Mason Ter, Unit 95-6",
    "parcel_id": "089-28-08",
    "owner1": "HARTMAN, WILLIAM M & LAURA",
    "owner2": "",
    "current_taxes": 8773.9,
    "new_taxes_no_override": 9152.93,
    "override_total_1": 9412.64,
    "override_increase_1": 259.71
  },
  {
    "#": "95 Mason Ter, Unit 95-A (089-28-01)",
    "$": 603400,
    "address": "95 Mason Ter, Unit 95-A",
    "parcel_id": "089-28-01",
    "owner1": "DENG, LINDA LIU & LINGYI",
    "owner2": "LIU, XIAOYANG",
    "current_taxes": 6178.82,
    "new_taxes_no_override": 6445.75,
    "override_total_1": 6628.64,
    "override_increase_1": 182.89
  },
  {
    "#": "95 Mason Ter, Unit 95-B (089-28-02)",
    "$": 526700,
    "address": "95 Mason Ter, Unit 95-B",
    "parcel_id": "089-28-02",
    "owner1": "KIM, CHRISTINE",
    "owner2": "",
    "current_taxes": 5393.41,
    "new_taxes_no_override": 5626.41,
    "override_total_1": 5786.05,
    "override_increase_1": 159.64
  },
  {
    "#": "97 Mason Ter, Unit 97-1 (089-28-11)",
    "$": 768100,
    "address": "97 Mason Ter, Unit 97-1",
    "parcel_id": "089-28-11",
    "owner1": "THOMSON, STEPHEN BROOKE",
    "owner2": "CRONIN, JESSICA ELIZABETH",
    "current_taxes": 7865.34,
    "new_taxes_no_override": 8205.12,
    "override_total_1": 8437.94,
    "override_increase_1": 232.81
  },
  {
    "#": "97 Mason Ter, Unit 97-2 (089-28-12)",
    "$": 1027700,
    "address": "97 Mason Ter, Unit 97-2",
    "parcel_id": "089-28-12",
    "owner1": "CICERONE, DAVID ANTHONY III",
    "owner2": "",
    "current_taxes": 6888.71,
    "new_taxes_no_override": 7186.3,
    "override_total_1": 7390.21,
    "override_increase_1": 203.91
  },
  {
    "#": "97 Mason Ter, Unit 97-3 (089-28-13)",
    "$": 1010400,
    "address": "97 Mason Ter, Unit 97-3",
    "parcel_id": "089-28-13",
    "owner1": "PENG TR, HONGMING",
    "owner2": "",
    "current_taxes": 6711.56,
    "new_taxes_no_override": 7001.5,
    "override_total_1": 7200.16,
    "override_increase_1": 198.66
  },
  {
    "#": "97 Mason Ter, Unit 97-4 (089-28-14)",
    "$": 1031200,
    "address": "97 Mason Ter, Unit 97-4",
    "parcel_id": "089-28-14",
    "owner1": "BEZRUKAVNIKOV, ROMAN & YULIA",
    "owner2": "",
    "current_taxes": 6924.55,
    "new_taxes_no_override": 7223.69,
    "override_total_1": 7428.66,
    "override_increase_1": 204.97
  },
  {
    "#": "97 Mason Ter, Unit 97-5 (089-28-15)",
    "$": 981600,
    "address": "97 Mason Ter, Unit 97-5",
    "parcel_id": "089-28-15",
    "owner1": "RUMPLER, JOHN A & CAROL",
    "owner2": "",
    "current_taxes": 6416.65,
    "new_taxes_no_override": 6693.85,
    "override_total_1": 6883.78,
    "override_increase_1": 189.93
  },
  {
    "#": "97 Mason Ter, Unit 97-6 (089-28-16)",
    "$": 1013500,
    "address": "97 Mason Ter, Unit 97-6",
    "parcel_id": "089-28-16",
    "owner1": "GARBER, BROOKE",
    "owner2": "NIST, STEPHANIE",
    "current_taxes": 6743.31,
    "new_taxes_no_override": 7034.62,
    "override_total_1": 7234.22,
    "override_increase_1": 199.6
  },
  {
    "#": "97 Mason Ter, Unit 97-A (089-28-09)",
    "$": 524900,
    "address": "97 Mason Ter, Unit 97-A",
    "parcel_id": "089-28-09",
    "owner1": "DENG, SHAOHUA",
    "owner2": "",
    "current_taxes": 5374.98,
    "new_taxes_no_override": 5607.18,
    "override_total_1": 5766.28,
    "override_increase_1": 159.1
  },
  {
    "#": "97 Mason Ter, Unit 97-B (089-28-10)",
    "$": 404000,
    "address": "97 Mason Ter, Unit 97-B",
    "parcel_id": "089-28-10",
    "owner1": "WU, JESSICA WENHUA",
    "owner2": "",
    "current_taxes": 4136.96,
    "new_taxes_no_override": 4315.68,
    "override_total_1": 4438.13,
    "override_increase_1": 122.45
  },
  {
    "#": "99 Mason Ter (089-30-31)",
    "$": 3083200,
    "address": "99 Mason Ter",
    "parcel_id": "089-30-31",
    "owner1": "POMERANZ ET AL, DAVID",
    "owner2": "JUNGREIS, KATHERINE & ABIGAIL",
    "current_taxes": 27937.03,
    "new_taxes_no_override": 29143.91,
    "override_total_1": 29970.85,
    "override_increase_1": 826.94
  },
  {
    "#": "106 Mason Ter (088-02-00)",
    "$": 2862600,
    "address": "106 Mason Ter",
    "parcel_id": "088-02-00",
    "owner1": "STARR, DOUGLAS",
    "owner2": "SIDOR, MONICA",
    "current_taxes": 25678.09,
    "new_taxes_no_override": 26787.38,
    "override_total_1": 27547.45,
    "override_increase_1": 760.07
  },
  {
    "#": "111 Mason Ter, Unit 1 (089-32-02)",
    "$": 884700,
    "address": "111 Mason Ter, Unit 1",
    "parcel_id": "089-32-02",
    "owner1": "YE, LICUN",
    "owner2": "",
    "current_taxes": 9059.33,
    "new_taxes_no_override": 9450.69,
    "override_total_1": 9718.85,
    "override_increase_1": 268.16
  },
  {
    "#": "111 Mason Ter, Unit 2 (089-32-03)",
    "$": 925700,
    "address": "111 Mason Ter, Unit 2",
    "parcel_id": "089-32-03",
    "owner1": "GARMS, RYAN & KATHLEEN",
    "owner2": "CHAMBERLAIN, CORDELIA",
    "current_taxes": 5844.23,
    "new_taxes_no_override": 6096.7,
    "override_total_1": 6269.69,
    "override_increase_1": 172.99
  },
  {
    "#": "117 Mason Ter (089-32-01)",
    "$": 2494000,
    "address": "117 Mason Ter",
    "parcel_id": "089-32-01",
    "owner1": "WU, CATHERINE",
    "owner2": "HACOHEN, NIR",
    "current_taxes": 21903.63,
    "new_taxes_no_override": 22849.87,
    "override_total_1": 23498.21,
    "override_increase_1": 648.35
  },
  {
    "#": "118 Mason Ter (088-01-00)",
    "$": 2769300,
    "address": "118 Mason Ter",
    "parcel_id": "088-01-00",
    "owner1": "ISRAEL, NAFTALI",
    "owner2": "GIBELEY, RACHEL",
    "current_taxes": 24722.7,
    "new_taxes_no_override": 25790.72,
    "override_total_1": 26522.51,
    "override_increase_1": 731.79
  },
  {
    "#": "127 Mason Ter, Unit 1 (085-56-01)",
    "$": 2073600,
    "address": "127 Mason Ter, Unit 1",
    "parcel_id": "085-56-01",
    "owner1": "TSUNG, NANCY Y & YEAN-KAI",
    "owner2": "",
    "current_taxes": 21233.66,
    "new_taxes_no_override": 22150.95,
    "override_total_1": 22779.47,
    "override_increase_1": 628.52
  },
  {
    "#": "127 Mason Ter, Unit 2 (085-56-02)",
    "$": 2733800,
    "address": "127 Mason Ter, Unit 2",
    "parcel_id": "085-56-02",
    "owner1": "SETH, MANMOHAN SINGH",
    "owner2": "SODHI, SUPREET",
    "current_taxes": 24359.18,
    "new_taxes_no_override": 25411.5,
    "override_total_1": 26132.53,
    "override_increase_1": 721.03
  },
  {
    "#": "131 Mason Ter (085-57-00)",
    "$": 1739100,
    "address": "131 Mason Ter",
    "parcel_id": "085-57-00",
    "owner1": "HELLENDRUNG, JASON S",
    "owner2": "CASTRONUOVO, LYNNE A",
    "current_taxes": 17808.38,
    "new_taxes_no_override": 18577.7,
    "override_total_1": 19104.83,
    "override_increase_1": 527.13
  },
  {
    "#": "132 Mason Ter (086-36-00)",
    "$": 2126900,
    "address": "132 Mason Ter",
    "parcel_id": "086-36-00",
    "owner1": "YEE TRS, LAI HA & LAI NGOR & OI YUK CHU",
    "owner2": "",
    "current_taxes": 18144.52,
    "new_taxes_no_override": 18928.36,
    "override_total_1": 19465.44,
    "override_increase_1": 537.08
  },
  {
    "#": "135 Mason Ter, Unit 1& Pk D -E (085-58-01)",
    "$": 1485300,
    "address": "135 Mason Ter, Unit 1& Pk D -E",
    "parcel_id": "085-58-01",
    "owner1": "SHELDON, BRIAN W",
    "owner2": "RANKIN, JANET",
    "current_taxes": 11574.54,
    "new_taxes_no_override": 12074.56,
    "override_total_1": 12417.17,
    "override_increase_1": 342.61
  },
  {
    "#": "135 Mason Ter, Unit 2&3 Pk Sps (085-58-02)",
    "$": 1998800,
    "address": "135 Mason Ter, Unit 2&3 Pk Sps",
    "parcel_id": "085-58-02",
    "owner1": "FORMAN, ROBERT F & EVGENIA",
    "owner2": "",
    "current_taxes": 16832.78,
    "new_taxes_no_override": 17559.96,
    "override_total_1": 18058.21,
    "override_increase_1": 498.25
  },
  {
    "#": "138 Mason Ter, Unit 1 (086-35-01)",
    "$": 1539500,
    "address": "138 Mason Ter, Unit 1",
    "parcel_id": "086-35-01",
    "owner1": "JACKSON, COLIN & AMY",
    "owner2": "",
    "current_taxes": 12129.55,
    "new_taxes_no_override": 12653.55,
    "override_total_1": 13012.58,
    "override_increase_1": 359.03
  },
  {
    "#": "138 Mason Ter, Unit 2 (086-35-02)",
    "$": 1772500,
    "address": "138 Mason Ter, Unit 2",
    "parcel_id": "086-35-02",
    "owner1": "PAN, HARVARD L & CINDY LIU",
    "owner2": "",
    "current_taxes": 14515.47,
    "new_taxes_no_override": 15142.54,
    "override_total_1": 15572.2,
    "override_increase_1": 429.66
  },
  {
    "#": "139 Mason Ter, Unit 1 (085-59-01)",
    "$": 1623300,
    "address": "139 Mason Ter, Unit 1",
    "parcel_id": "085-59-01",
    "owner1": "SOUTHWORTH, BONNIE",
    "owner2": "GANDHI, RAJESH",
    "current_taxes": 12987.66,
    "new_taxes_no_override": 13548.73,
    "override_total_1": 13933.16,
    "override_increase_1": 384.43
  },
  {
    "#": "139 Mason Ter, Unit 2 (085-59-02)",
    "$": 2209400,
    "address": "139 Mason Ter, Unit 2",
    "parcel_id": "085-59-02",
    "owner1": "SCHNEIDER, BEN",
    "owner2": "THELEN, KATHLEEN",
    "current_taxes": 18989.32,
    "new_taxes_no_override": 19809.66,
    "override_total_1": 20371.74,
    "override_increase_1": 562.08
  },
  {
    "#": "144 Mason Ter, Unit 1 (086-34-01)",
    "$": 889700,
    "address": "144 Mason Ter, Unit 1",
    "parcel_id": "086-34-01",
    "owner1": "MONTERISI TRS, JOHN JR",
    "owner2": "HUTT, CHERYL A",
    "current_taxes": 5475.59,
    "new_taxes_no_override": 5712.14,
    "override_total_1": 5874.21,
    "override_increase_1": 162.08
  },
  {
    "#": "144 Mason Ter, Unit 2 (086-34-02)",
    "$": 1161300,
    "address": "144 Mason Ter, Unit 2",
    "parcel_id": "086-34-02",
    "owner1": "FLAMMIA, GIOVANNI",
    "owner2": "JACKSON FLAMMIA, STACEY ELLEN",
    "current_taxes": 8256.78,
    "new_taxes_no_override": 8613.47,
    "override_total_1": 8857.87,
    "override_increase_1": 244.4
  },
  {
    "#": "145 Mason Ter (085-60-03)",
    "$": 2692900,
    "address": "145 Mason Ter",
    "parcel_id": "085-60-03",
    "owner1": "DITKOFF, JOSEPH",
    "owner2": "WOLF, SUSAN",
    "current_taxes": 23940.36,
    "new_taxes_no_override": 24974.58,
    "override_total_1": 25683.22,
    "override_increase_1": 708.63
  },
  {
    "#": "147 Mason Ter, Unit 1 (085-61-01)",
    "$": 648500,
    "address": "147 Mason Ter, Unit 1",
    "parcel_id": "085-61-01",
    "owner1": "ZISKIN TRS, MARVIN L & DOROTHY R",
    "owner2": "",
    "current_taxes": 6640.64,
    "new_taxes_no_override": 6927.52,
    "override_total_1": 7124.08,
    "override_increase_1": 196.56
  },
  {
    "#": "147 Mason Ter, Unit 2 & Pk Sp B (085-61-02)",
    "$": 847200,
    "address": "147 Mason Ter, Unit 2 & Pk Sp B",
    "parcel_id": "085-61-02",
    "owner1": "ZISKIN, MARVIN L & DOROTHY R",
    "owner2": "",
    "current_taxes": 5040.39,
    "new_taxes_no_override": 5258.13,
    "override_total_1": 5407.33,
    "override_increase_1": 149.2
  },
  {
    "#": "147 Mason Ter, Unit 3 & Pk Sp A (085-61-03)",
    "$": 1186400,
    "address": "147 Mason Ter, Unit 3 & Pk Sp A",
    "parcel_id": "085-61-03",
    "owner1": "GLEDHILL TRS, JOHN",
    "owner2": "TEILLON, JEAN",
    "current_taxes": 12148.74,
    "new_taxes_no_override": 12673.57,
    "override_total_1": 13033.17,
    "override_increase_1": 359.6
  },
  {
    "#": "148 Mason Ter, Unit 1 (086-33-01)",
    "$": 1860500,
    "address": "148 Mason Ter, Unit 1",
    "parcel_id": "086-33-01",
    "owner1": "YUCESOY, BURCU",
    "owner2": "SUREN, ARTO",
    "current_taxes": 15416.59,
    "new_taxes_no_override": 16082.59,
    "override_total_1": 16538.92,
    "override_increase_1": 456.33
  },
  {
    "#": "148 Mason Ter, Unit 2 (086-33-02)",
    "$": 2115700,
    "address": "148 Mason Ter, Unit 2",
    "parcel_id": "086-33-02",
    "owner1": "LEIBOWITZ, HILARY & JAYSON",
    "owner2": "",
    "current_taxes": 21664.77,
    "new_taxes_no_override": 22600.69,
    "override_total_1": 23241.97,
    "override_increase_1": 641.28
  },
  {
    "#": "151 Mason Ter, Unit 1  (085-62-01)",
    "$": 2434300,
    "address": "151 Mason Ter, Unit 1 ",
    "parcel_id": "085-62-01",
    "owner1": "COHEN, OHAD R",
    "owner2": "BIJUR, ANSUYA",
    "current_taxes": 24927.23,
    "new_taxes_no_override": 26004.09,
    "override_total_1": 26741.93,
    "override_increase_1": 737.85
  },
  {
    "#": "151 Mason Ter, Unit 2 (085-62-02)",
    "$": 1957600,
    "address": "151 Mason Ter, Unit 2",
    "parcel_id": "085-62-02",
    "owner1": "YANG, LINYA & LI-SHANG C",
    "owner2": "",
    "current_taxes": 20045.82,
    "new_taxes_no_override": 20911.8,
    "override_total_1": 21505.16,
    "override_increase_1": 593.36
  },
  {
    "#": "155 Mason Ter, Unit 155 & Pk Sp B (085-63-03)",
    "$": 2225100,
    "address": "155 Mason Ter, Unit 155 & Pk Sp B",
    "parcel_id": "085-63-03",
    "owner1": "XU, JIAYI & XIQING",
    "owner2": "",
    "current_taxes": 19150.09,
    "new_taxes_no_override": 19977.37,
    "override_total_1": 20544.22,
    "override_increase_1": 566.84
  },
  {
    "#": "155 Mason Ter, Unit 157 & Pk Sp A (085-63-04)",
    "$": 2259300,
    "address": "155 Mason Ter, Unit 157 & Pk Sp A",
    "parcel_id": "085-63-04",
    "owner1": "SONE, PISA",
    "owner2": "SALOOJA, VINAY",
    "current_taxes": 19500.3,
    "new_taxes_no_override": 20342.71,
    "override_total_1": 20919.92,
    "override_increase_1": 577.21
  },
  {
    "#": "156 Mason Ter (086-32-00)",
    "$": 2892900,
    "address": "156 Mason Ter",
    "parcel_id": "086-32-00",
    "owner1": "MIGNANO TRS, JOHN A",
    "owner2": "MILLMAN, DARLENE M",
    "current_taxes": 25988.36,
    "new_taxes_no_override": 27111.06,
    "override_total_1": 27880.31,
    "override_increase_1": 769.26
  },
  {
    "#": "161 Mason Ter (085-64-00)",
    "$": 1984400,
    "address": "161 Mason Ter",
    "parcel_id": "085-64-00",
    "owner1": "BONIAS, IOANNIS",
    "owner2": "SCHINKMANN, KARIN",
    "current_taxes": 16685.32,
    "new_taxes_no_override": 17406.13,
    "override_total_1": 17900.01,
    "override_increase_1": 493.89
  },
  {
    "#": "162 Mason Ter, Unit 162 (086-31-01)",
    "$": 1616600,
    "address": "162 Mason Ter, Unit 162",
    "parcel_id": "086-31-01",
    "owner1": "BIERYLO TRS, MICHAEL",
    "owner2": "MENYUK, DIANE",
    "current_taxes": 16553.98,
    "new_taxes_no_override": 17269.11,
    "override_total_1": 17759.11,
    "override_increase_1": 490.0
  },
  {
    "#": "164 Mason Ter, Unit 164 (086-31-02)",
    "$": 1697500,
    "address": "164 Mason Ter, Unit 164",
    "parcel_id": "086-31-02",
    "owner1": "PERDUE, NATHAN & RACHEL",
    "owner2": "",
    "current_taxes": 13747.47,
    "new_taxes_no_override": 14341.36,
    "override_total_1": 14748.29,
    "override_increase_1": 406.93
  },
  {
    "#": "165 Mason Ter (085-65-00)",
    "$": 1776600,
    "address": "165 Mason Ter",
    "parcel_id": "085-65-00",
    "owner1": "KHAZANOV LIFE ESTATE, MARINA B",
    "owner2": "",
    "current_taxes": 14557.45,
    "new_taxes_no_override": 15186.33,
    "override_total_1": 15617.23,
    "override_increase_1": 430.9
  },
  {
    "#": "169 Mason Ter (085-66-00)",
    "$": 2190600,
    "address": "169 Mason Ter",
    "parcel_id": "085-66-00",
    "owner1": "SMITH, ADAM DAVISON",
    "owner2": "RASKHODNIKOVA, SOFYA",
    "current_taxes": 18796.81,
    "new_taxes_no_override": 19608.83,
    "override_total_1": 20165.22,
    "override_increase_1": 556.39
  },
  {
    "#": "172 Mason Ter (086-30-00)",
    "$": 3206200,
    "address": "172 Mason Ter",
    "parcel_id": "086-30-00",
    "owner1": "CANETTI, RAN",
    "owner2": "RUBINFELD, RONITT",
    "current_taxes": 29196.55,
    "new_taxes_no_override": 30457.84,
    "override_total_1": 31322.06,
    "override_increase_1": 864.22
  },
  {
    "#": "173 Mason Ter (085-67-00)",
    "$": 2001800,
    "address": "173 Mason Ter",
    "parcel_id": "085-67-00",
    "owner1": "TOROUS, JOHN & VANDA FARAHMAND",
    "owner2": "",
    "current_taxes": 16863.5,
    "new_taxes_no_override": 17592.0,
    "override_total_1": 18091.16,
    "override_increase_1": 499.16
  },
  {
    "#": "177 Mason Ter (085-68-00)",
    "$": 2166100,
    "address": "177 Mason Ter",
    "parcel_id": "085-68-00",
    "owner1": "LOWE TR, DAVID J",
    "owner2": "",
    "current_taxes": 18545.93,
    "new_taxes_no_override": 19347.11,
    "override_total_1": 19896.07,
    "override_increase_1": 548.96
  },
  {
    "#": "178 Mason Ter (086-29-00)",
    "$": 3787300,
    "address": "178 Mason Ter",
    "parcel_id": "086-29-00",
    "owner1": "BERGER, ERIC & KATHRYN",
    "owner2": "",
    "current_taxes": 35147.02,
    "new_taxes_no_override": 36665.37,
    "override_total_1": 37705.72,
    "override_increase_1": 1040.35
  },
  {
    "#": "183 Mason Ter (085-69-00)",
    "$": 1930300,
    "address": "183 Mason Ter",
    "parcel_id": "085-69-00",
    "owner1": "LINDQUIST, JAMES S & GWENYTH",
    "owner2": "",
    "current_taxes": 16131.34,
    "new_taxes_no_override": 16828.21,
    "override_total_1": 17305.7,
    "override_increase_1": 477.49
  },
  {
    "#": "186 Mason Ter, Unit 186 (086-27-01)",
    "$": 2140900,
    "address": "186 Mason Ter, Unit 186",
    "parcel_id": "086-27-01",
    "owner1": "VICINELLI, STEPHEN & KAJAL",
    "owner2": "",
    "current_taxes": 21922.82,
    "new_taxes_no_override": 22869.89,
    "override_total_1": 23518.8,
    "override_increase_1": 648.92
  },
  {
    "#": "186 Mason Ter, Unit 188 (086-27-02)",
    "$": 2529100,
    "address": "186 Mason Ter, Unit 188",
    "parcel_id": "086-27-02",
    "owner1": "MANNING, JACQUELINE GREER",
    "owner2": "",
    "current_taxes": 25897.98,
    "new_taxes_no_override": 27016.77,
    "override_total_1": 27783.35,
    "override_increase_1": 766.58
  },
  {
    "#": "187 Mason Ter (085-70-00)",
    "$": 2422400,
    "address": "187 Mason Ter",
    "parcel_id": "085-70-00",
    "owner1": "LENZ-KASHER, DANIELLE",
    "owner2": "KASHER, IDO",
    "current_taxes": 21170.44,
    "new_taxes_no_override": 22085.0,
    "override_total_1": 22711.65,
    "override_increase_1": 626.65
  },
  {
    "#": "192 Mason Ter (086-26-00)",
    "$": 2248600,
    "address": "192 Mason Ter",
    "parcel_id": "086-26-00",
    "owner1": "CHARBONNEAU, DAVID B",
    "owner2": "BOURDEAUX, MARGARET E",
    "current_taxes": 19390.73,
    "new_taxes_no_override": 20228.41,
    "override_total_1": 20802.38,
    "override_increase_1": 573.97
  },
  {
    "#": "193 Mason Ter (085-71-00)",
    "$": 2127400,
    "address": "193 Mason Ter",
    "parcel_id": "085-71-00",
    "owner1": "SHERMAN TRS, KENNETH M",
    "owner2": "AKIBA, BARBARA J",
    "current_taxes": 18149.64,
    "new_taxes_no_override": 18933.7,
    "override_total_1": 19470.93,
    "override_increase_1": 537.23
  },
  {
    "#": "196 Mason Ter (086-25-00)",
    "$": 2073000,
    "address": "196 Mason Ter",
    "parcel_id": "086-25-00",
    "owner1": "KESNER, JAY",
    "owner2": "",
    "current_taxes": 17592.59,
    "new_taxes_no_override": 18352.59,
    "override_total_1": 18873.33,
    "override_increase_1": 520.74
  },
  {
    "#": "197 Mason Ter (085-72-00)",
    "$": 2255800,
    "address": "197 Mason Ter",
    "parcel_id": "085-72-00",
    "owner1": "WELLES TRS, NICHOLAS C & ELIZABETH G",
    "owner2": "",
    "current_taxes": 19464.46,
    "new_taxes_no_override": 20305.32,
    "override_total_1": 20881.47,
    "override_increase_1": 576.15
  },
  {
    "#": "202 Mason Ter (086-24-00)",
    "$": 2811300,
    "address": "202 Mason Ter",
    "parcel_id": "086-24-00",
    "owner1": "GAO, YUAN ZHAO & ANNE E",
    "owner2": "",
    "current_taxes": 28787.71,
    "new_taxes_no_override": 30031.34,
    "override_total_1": 30883.46,
    "override_increase_1": 852.12
  },
  {
    "#": "203 Mason Ter (085-73-00)",
    "$": 2696500,
    "address": "203 Mason Ter",
    "parcel_id": "085-73-00",
    "owner1": "MAJMUDAR TRS, SAMIR S & PRAKRUTI S",
    "owner2": "",
    "current_taxes": 23977.23,
    "new_taxes_no_override": 25013.05,
    "override_total_1": 25722.77,
    "override_increase_1": 709.73
  },
  {
    "#": "207 Mason Ter, Unit 1 (085-74-01)",
    "$": 1255700,
    "address": "207 Mason Ter, Unit 1",
    "parcel_id": "085-74-01",
    "owner1": "HALPERT, ANDREW",
    "owner2": "KANAREK, JANE",
    "current_taxes": 9223.43,
    "new_taxes_no_override": 9621.88,
    "override_total_1": 9894.9,
    "override_increase_1": 273.01
  },
  {
    "#": "207 Mason Ter, Unit 2 (085-74-02)",
    "$": 1361400,
    "address": "207 Mason Ter, Unit 2",
    "parcel_id": "085-74-02",
    "owner1": "HARRIS, ROBERT & EVE",
    "owner2": "",
    "current_taxes": 13940.74,
    "new_taxes_no_override": 14542.98,
    "override_total_1": 14955.63,
    "override_increase_1": 412.65
  },
  {
    "#": "210 Mason Ter (086-23-00)",
    "$": 2511900,
    "address": "210 Mason Ter",
    "parcel_id": "086-23-00",
    "owner1": "BEIT-ARIE TRS, OREN",
    "owner2": "SHLONSKY, NAAMA BEIT-ARIE",
    "current_taxes": 22086.92,
    "new_taxes_no_override": 23041.07,
    "override_total_1": 23694.85,
    "override_increase_1": 653.77
  },
  {
    "#": "211 Mason Ter (085-75-00)",
    "$": 2222600,
    "address": "211 Mason Ter",
    "parcel_id": "085-75-00",
    "owner1": "LAVELLE  TRS, JAMES",
    "owner2": "STOLL TRS, SUSAN",
    "current_taxes": 22759.42,
    "new_taxes_no_override": 23742.63,
    "override_total_1": 24416.31,
    "override_increase_1": 673.68
  },
  {
    "#": "214 Mason Ter, Unit 1 (086-22-01)",
    "$": 1565800,
    "address": "214 Mason Ter, Unit 1",
    "parcel_id": "086-22-01",
    "owner1": "DELUCIA, MICHAEL",
    "owner2": "WALSH, HEATHER",
    "current_taxes": 16033.79,
    "new_taxes_no_override": 16726.45,
    "override_total_1": 17201.05,
    "override_increase_1": 474.6
  },
  {
    "#": "214 Mason Ter, Unit 2 (086-22-02)",
    "$": 1306200,
    "address": "214 Mason Ter, Unit 2",
    "parcel_id": "086-22-02",
    "owner1": "YOON, MARK Y & GRACE E",
    "owner2": "",
    "current_taxes": 13375.49,
    "new_taxes_no_override": 13953.31,
    "override_total_1": 14349.23,
    "override_increase_1": 395.91
  },
  {
    "#": "217 Mason Ter (085-76-00)",
    "$": 2237900,
    "address": "217 Mason Ter",
    "parcel_id": "085-76-00",
    "owner1": "LAMBERT, ET AL, MICHAEL A",
    "owner2": "",
    "current_taxes": 19281.16,
    "new_taxes_no_override": 20114.11,
    "override_total_1": 20684.83,
    "override_increase_1": 570.72
  },
  {
    "#": "219 Mason Ter, Unit 2-219 (085-77-02)",
    "$": 1666400,
    "address": "219 Mason Ter, Unit 2-219",
    "parcel_id": "085-77-02",
    "owner1": "CEPEDA, CAMILO ROMAN",
    "owner2": "AHN, HYOUNGOK",
    "current_taxes": 17063.94,
    "new_taxes_no_override": 17801.1,
    "override_total_1": 18306.19,
    "override_increase_1": 505.09
  },
  {
    "#": "220 Mason Ter (086-21-00)",
    "$": 2124900,
    "address": "220 Mason Ter",
    "parcel_id": "086-21-00",
    "owner1": "LEVITOV, LEONID",
    "owner2": "GALKINA, JULIA",
    "current_taxes": 18124.04,
    "new_taxes_no_override": 18907.0,
    "override_total_1": 19443.47,
    "override_increase_1": 536.47
  },
  {
    "#": "221 Mason Ter, Unit 1-221 (085-77-01)",
    "$": 1101500,
    "address": "221 Mason Ter, Unit 1-221",
    "parcel_id": "085-77-01",
    "owner1": "PAGE, PHILLIP E & JENNIFER K",
    "owner2": "",
    "current_taxes": 7644.43,
    "new_taxes_no_override": 7974.67,
    "override_total_1": 8200.94,
    "override_increase_1": 226.28
  },
  {
    "#": "224 Mason Ter (086-20-00)",
    "$": 2646700,
    "address": "224 Mason Ter",
    "parcel_id": "086-20-00",
    "owner1": "ROH, DANIEL",
    "owner2": "TSENG, IRENE",
    "current_taxes": 23467.27,
    "new_taxes_no_override": 24481.06,
    "override_total_1": 25175.69,
    "override_increase_1": 694.63
  },
  {
    "#": "227 Mason Ter (085-78-00)",
    "$": 2088000,
    "address": "227 Mason Ter",
    "parcel_id": "085-78-00",
    "owner1": "SHIMO, ARITO A",
    "owner2": "",
    "current_taxes": 17746.19,
    "new_taxes_no_override": 18512.83,
    "override_total_1": 19038.11,
    "override_increase_1": 525.29
  },
  {
    "#": "228 Mason Ter (086-19-00)",
    "$": 1888600,
    "address": "228 Mason Ter",
    "parcel_id": "086-19-00",
    "owner1": "JASON, SHARON",
    "owner2": "KYN, PAVEL",
    "current_taxes": 15704.33,
    "new_taxes_no_override": 16382.76,
    "override_total_1": 16847.61,
    "override_increase_1": 464.85
  },
  {
    "#": "230 Mason Ter (086-18-00)",
    "$": 2477400,
    "address": "230 Mason Ter",
    "parcel_id": "086-18-00",
    "owner1": "GORFAJN, JULIAN",
    "owner2": "GIORA-GORFAJN, SHANNA T",
    "current_taxes": 21733.64,
    "new_taxes_no_override": 22672.53,
    "override_total_1": 23315.85,
    "override_increase_1": 643.32
  },
  {
    "#": "233 Mason Ter (085-79-00)",
    "$": 2866300,
    "address": "233 Mason Ter",
    "parcel_id": "085-79-00",
    "owner1": "CHEESEMAN, IAIN",
    "owner2": "YARAR, DEFNE",
    "current_taxes": 25715.98,
    "new_taxes_no_override": 26826.91,
    "override_total_1": 27588.1,
    "override_increase_1": 761.19
  },
  {
    "#": "236 Mason Ter (086-17-00)",
    "$": 2533100,
    "address": "236 Mason Ter",
    "parcel_id": "086-17-00",
    "owner1": "KHANNA TRS, ABHISHEK",
    "owner2": "DHALIWAL, KIRAN DEEP",
    "current_taxes": 22304.01,
    "new_taxes_no_override": 23267.54,
    "override_total_1": 23927.74,
    "override_increase_1": 660.2
  },
  {
    "#": "237 Mason Ter, Unit 1 & G1 (085-80-01)",
    "$": 1346400,
    "address": "237 Mason Ter, Unit 1 & G1",
    "parcel_id": "085-80-01",
    "owner1": "YEHEZKEL TRS, MEIR",
    "owner2": "EZEKIEL, ANNETTE",
    "current_taxes": 10152.2,
    "new_taxes_no_override": 10590.78,
    "override_total_1": 10891.28,
    "override_increase_1": 300.51
  },
  {
    "#": "239 Mason Ter, Unit 2 & P2 P3 (085-80-02)",
    "$": 984700,
    "address": "239 Mason Ter, Unit 2 & P2 P3",
    "parcel_id": "085-80-02",
    "owner1": "KISHONY, ROY",
    "owner2": "TALIA, BERMAN",
    "current_taxes": 6448.39,
    "new_taxes_no_override": 6726.96,
    "override_total_1": 6917.83,
    "override_increase_1": 190.87
  },
  {
    "#": "240 Mason Ter (086-16-00)",
    "$": 2023200,
    "address": "240 Mason Ter",
    "parcel_id": "086-16-00",
    "owner1": "LUSTIG, MOE",
    "owner2": "",
    "current_taxes": 17082.63,
    "new_taxes_no_override": 17820.6,
    "override_total_1": 18326.25,
    "override_increase_1": 505.65
  },
  {
    "#": "243 Mason Ter (085-81-00)",
    "$": 2189100,
    "address": "243 Mason Ter",
    "parcel_id": "085-81-00",
    "owner1": "AYZENBERG, YADID",
    "owner2": "AYZENBERG-SHOSHAN, YIFAAT",
    "current_taxes": 18781.45,
    "new_taxes_no_override": 19592.81,
    "override_total_1": 20148.74,
    "override_increase_1": 555.93
  },
  {
    "#": "246 Mason Ter (086-15-00)",
    "$": 2475000,
    "address": "246 Mason Ter",
    "parcel_id": "086-15-00",
    "owner1": "BALABAN, RICHARD B",
    "owner2": "SHELLENBERGER, KIMBERLEY S",
    "current_taxes": 21709.07,
    "new_taxes_no_override": 22646.9,
    "override_total_1": 23289.49,
    "override_increase_1": 642.59
  },
  {
    "#": "249 Mason Ter (085-82-00)",
    "$": 2192100,
    "address": "249 Mason Ter",
    "parcel_id": "085-82-00",
    "owner1": "NEWMAN TR, JULIE",
    "owner2": "",
    "current_taxes": 18812.17,
    "new_taxes_no_override": 19624.86,
    "override_total_1": 20181.7,
    "override_increase_1": 556.84
  },
  {
    "#": "252 Mason Ter (086-14-00)",
    "$": 2703100,
    "address": "252 Mason Ter",
    "parcel_id": "086-14-00",
    "owner1": "SUNDEL, ROBERT",
    "owner2": "ABERSON, ALLA",
    "current_taxes": 24044.81,
    "new_taxes_no_override": 25083.55,
    "override_total_1": 25795.27,
    "override_increase_1": 711.73
  },
  {
    "#": "253 Mason Ter (085-83-00)",
    "$": 2546600,
    "address": "253 Mason Ter",
    "parcel_id": "085-83-00",
    "owner1": "BUCKLEY, OLIVER E",
    "owner2": "LAYTON, LYNNE B",
    "current_taxes": 22442.25,
    "new_taxes_no_override": 23411.76,
    "override_total_1": 24076.05,
    "override_increase_1": 664.29
  },
  {
    "#": "256 Mason Ter (086-13-00)",
    "$": 1862600,
    "address": "256 Mason Ter",
    "parcel_id": "086-13-00",
    "owner1": "LAWSON, WILLIAM K",
    "owner2": "",
    "current_taxes": 15438.09,
    "new_taxes_no_override": 16105.02,
    "override_total_1": 16561.98,
    "override_increase_1": 456.97
  },
  {
    "#": "259 Mason Ter (085-84-00)",
    "$": 2891200,
    "address": "259 Mason Ter",
    "parcel_id": "085-84-00",
    "owner1": "HU TR, MEIHUEI",
    "owner2": "",
    "current_taxes": 25970.95,
    "new_taxes_no_override": 27092.9,
    "override_total_1": 27861.64,
    "override_increase_1": 768.74
  },
  {
    "#": "260 Mason Ter (086-12-01)",
    "$": 2329300,
    "address": "260 Mason Ter",
    "parcel_id": "086-12-01",
    "owner1": "ROMM, EMILY",
    "owner2": "BRODSKY, MICHAEL",
    "current_taxes": 20217.1,
    "new_taxes_no_override": 21090.48,
    "override_total_1": 21688.9,
    "override_increase_1": 598.43
  },
  {
    "#": "264 Mason Ter (086-12-00)",
    "$": 2233500,
    "address": "264 Mason Ter",
    "parcel_id": "086-12-00",
    "owner1": "KARMA WIND 2019 LLC",
    "owner2": "",
    "current_taxes": 22871.04,
    "new_taxes_no_override": 23859.07,
    "override_total_1": 24536.05,
    "override_increase_1": 676.98
  },
  {
    "#": "265 Mason Ter (085-85-00)",
    "$": 2062300,
    "address": "265 Mason Ter",
    "parcel_id": "085-85-00",
    "owner1": "LUI TRS, RAYMOND & THERESA L",
    "owner2": "",
    "current_taxes": 17483.02,
    "new_taxes_no_override": 18238.29,
    "override_total_1": 18755.78,
    "override_increase_1": 517.5
  },
  {
    "#": "268 Mason Ter (086-11-00)",
    "$": 2789900,
    "address": "268 Mason Ter",
    "parcel_id": "086-11-00",
    "owner1": "SHEFFER, URI & MICHAL",
    "owner2": "",
    "current_taxes": 24933.64,
    "new_taxes_no_override": 26010.77,
    "override_total_1": 26748.81,
    "override_increase_1": 738.04
  },
  {
    "#": "269 Mason Ter (085-86-00)",
    "$": 2002700,
    "address": "269 Mason Ter",
    "parcel_id": "085-86-00",
    "owner1": "MUNROE TRS, STEPHANIE LAUREN",
    "owner2": "ABBETT, LEO GERARD",
    "current_taxes": 16872.71,
    "new_taxes_no_override": 17601.61,
    "override_total_1": 18101.04,
    "override_increase_1": 499.43
  },
  {
    "#": "273 Mason Ter (085-87-00)",
    "$": 2876100,
    "address": "273 Mason Ter",
    "parcel_id": "085-87-00",
    "owner1": "KAC, ELENA & VICTOR",
    "owner2": "",
    "current_taxes": 25816.33,
    "new_taxes_no_override": 26931.6,
    "override_total_1": 27695.76,
    "override_increase_1": 764.16
  },
  {
    "#": "274 Mason Ter (086-10-00)",
    "$": 2220000,
    "address": "274 Mason Ter",
    "parcel_id": "086-10-00",
    "owner1": "BURDENKO, ALEXANDER & MARINA",
    "owner2": "",
    "current_taxes": 19097.87,
    "new_taxes_no_override": 19922.9,
    "override_total_1": 20488.19,
    "override_increase_1": 565.3
  },
  {
    "#": "277 Mason Ter (085-88-00)",
    "$": 2535000,
    "address": "277 Mason Ter",
    "parcel_id": "085-88-00",
    "owner1": "ZELKHA, MOUSSA",
    "owner2": "",
    "current_taxes": 25958.4,
    "new_taxes_no_override": 27079.8,
    "override_total_1": 27848.17,
    "override_increase_1": 768.37
  },
  {
    "#": "280 Mason Ter (086-09-00)",
    "$": 1964900,
    "address": "280 Mason Ter",
    "parcel_id": "086-09-00",
    "owner1": "RIVERA TR, LIGIA R",
    "owner2": "",
    "current_taxes": 16485.64,
    "new_taxes_no_override": 17197.82,
    "override_total_1": 17685.79,
    "override_increase_1": 487.97
  },
  {
    "#": "281 Mason Ter, Unit 1 (085-89-01)",
    "$": 1735100,
    "address": "281 Mason Ter, Unit 1",
    "parcel_id": "085-89-01",
    "owner1": "SIMKOVITZ TR, MARC D",
    "owner2": "LANDESMAN TR, JULIETTE M",
    "current_taxes": 14132.49,
    "new_taxes_no_override": 14743.01,
    "override_total_1": 15161.34,
    "override_increase_1": 418.32
  },
  {
    "#": "281 Mason Ter, Unit 2 (085-89-02)",
    "$": 1615600,
    "address": "281 Mason Ter, Unit 2",
    "parcel_id": "085-89-02",
    "owner1": "VU, MINH HOANG",
    "owner2": "SHU, SUSAN",
    "current_taxes": 12908.81,
    "new_taxes_no_override": 13466.47,
    "override_total_1": 13848.57,
    "override_increase_1": 382.1
  },
  {
    "#": "286 Mason Ter (086-08-00)",
    "$": 2228500,
    "address": "286 Mason Ter",
    "parcel_id": "086-08-00",
    "owner1": "VOLDINS, DIDZIS",
    "owner2": "YELLEN, ELIZABETH SPENCE",
    "current_taxes": 19184.91,
    "new_taxes_no_override": 20013.7,
    "override_total_1": 20581.57,
    "override_increase_1": 567.87
  },
  {
    "#": "287 Mason Ter (085-90-00)",
    "$": 2726600,
    "address": "287 Mason Ter",
    "parcel_id": "085-90-00",
    "owner1": "HADAR, BENJAMIN A",
    "owner2": "ANTEBI-HADAR, RONIT",
    "current_taxes": 24285.45,
    "new_taxes_no_override": 25334.58,
    "override_total_1": 26053.43,
    "override_increase_1": 718.85
  },
  {
    "#": "292 Mason Ter (086-07-00)",
    "$": 2520800,
    "address": "292 Mason Ter",
    "parcel_id": "086-07-00",
    "owner1": "KERMAN, SCOTT & ADRIENNE A",
    "owner2": "",
    "current_taxes": 22178.06,
    "new_taxes_no_override": 23136.15,
    "override_total_1": 23792.62,
    "override_increase_1": 656.47
  },
  {
    "#": "293 Mason Ter (085-91-00)",
    "$": 2083000,
    "address": "293 Mason Ter",
    "parcel_id": "085-91-00",
    "owner1": "ROSENTHAL TRS, RALPH",
    "owner2": "LEILA, JOY",
    "current_taxes": 17694.99,
    "new_taxes_no_override": 18459.41,
    "override_total_1": 18983.19,
    "override_increase_1": 523.77
  },
  {
    "#": "296 Mason Ter (086-06-00)",
    "$": 2884600,
    "address": "296 Mason Ter",
    "parcel_id": "086-06-00",
    "owner1": "SHEEHAN, BRIAN & LISA SERAFIN",
    "owner2": "",
    "current_taxes": 25903.37,
    "new_taxes_no_override": 27022.4,
    "override_total_1": 27789.14,
    "override_increase_1": 766.74
  },
  {
    "#": "297 Mason Ter (085-91-01)",
    "$": 2216700,
    "address": "297 Mason Ter",
    "parcel_id": "085-91-01",
    "owner1": "HERTZ TR, MARCIA B",
    "owner2": "",
    "current_taxes": 19064.07,
    "new_taxes_no_override": 19887.64,
    "override_total_1": 20451.93,
    "override_increase_1": 564.3
  },
  {
    "#": "301 Mason Ter (085-92-00)",
    "$": 2118300,
    "address": "301 Mason Ter",
    "parcel_id": "085-92-00",
    "owner1": "COHN TR, CAROL ELAINE",
    "owner2": "",
    "current_taxes": 21691.39,
    "new_taxes_no_override": 22628.46,
    "override_total_1": 23270.52,
    "override_increase_1": 642.07
  },
  {
    "#": "302 Mason Ter (086-05-00)",
    "$": 3566000,
    "address": "302 Mason Ter",
    "parcel_id": "086-05-00",
    "owner1": "KIM, LEO A",
    "owner2": "LEE, NAHYOUNG G",
    "current_taxes": 32880.91,
    "new_taxes_no_override": 34301.37,
    "override_total_1": 35274.64,
    "override_increase_1": 973.27
  },
  {
    "#": "305 Mason Ter (085-92-01)",
    "$": 1887100,
    "address": "305 Mason Ter",
    "parcel_id": "085-92-01",
    "owner1": "FISCH TR, JUDITH S",
    "owner2": "FRANK TR, MARGARET L",
    "current_taxes": 15688.97,
    "new_taxes_no_override": 16366.73,
    "override_total_1": 16831.13,
    "override_increase_1": 464.39
  },
  {
    "#": "306 Mason Ter (086-04-00)",
    "$": 2472500,
    "address": "306 Mason Ter",
    "parcel_id": "086-04-00",
    "owner1": "SCHONWALD TRS, SETH N & ALISON D",
    "owner2": "",
    "current_taxes": 21683.47,
    "new_taxes_no_override": 22620.2,
    "override_total_1": 23262.03,
    "override_increase_1": 641.83
  },
  {
    "#": "309 Mason Ter (085-93-00)",
    "$": 1948900,
    "address": "309 Mason Ter",
    "parcel_id": "085-93-00",
    "owner1": "APPLEGATE, KRISTEN & DOUGLAS",
    "owner2": "",
    "current_taxes": 16321.8,
    "new_taxes_no_override": 17026.9,
    "override_total_1": 17510.03,
    "override_increase_1": 483.13
  },
  {
    "#": "312 Mason Ter (086-03-00)",
    "$": 2253500,
    "address": "312 Mason Ter",
    "parcel_id": "086-03-00",
    "owner1": "BEIZER TR, JANET L",
    "owner2": "",
    "current_taxes": 19440.91,
    "new_taxes_no_override": 20280.76,
    "override_total_1": 20856.21,
    "override_increase_1": 575.45
  },
  {
    "#": "315 Mason Ter (085-94-00)",
    "$": 2118200,
    "address": "315 Mason Ter",
    "parcel_id": "085-94-00",
    "owner1": "CLASS, JAMIE N",
    "owner2": "",
    "current_taxes": 18055.43,
    "new_taxes_no_override": 18835.42,
    "override_total_1": 19369.87,
    "override_increase_1": 534.44
  },
  {
    "#": "318 Mason Ter (086-02-00)",
    "$": 4645300,
    "address": "318 Mason Ter",
    "parcel_id": "086-02-00",
    "owner1": "BROWN, WINNA",
    "owner2": "",
    "current_taxes": 43932.94,
    "new_taxes_no_override": 45830.84,
    "override_total_1": 47131.26,
    "override_increase_1": 1300.42
  },
  {
    "#": "319 Mason Ter (085-95-00)",
    "$": 1821500,
    "address": "319 Mason Ter",
    "parcel_id": "085-95-00",
    "owner1": "JIA, LINGYUN",
    "owner2": "",
    "current_taxes": 18652.16,
    "new_taxes_no_override": 19457.93,
    "override_total_1": 20010.04,
    "override_increase_1": 552.1
  },
  {
    "#": "322 Mason Ter (086-01-01)",
    "$": 2771000,
    "address": "322 Mason Ter",
    "parcel_id": "086-01-01",
    "owner1": "CASTEL, CAROLYN",
    "owner2": "",
    "current_taxes": 24740.11,
    "new_taxes_no_override": 25808.88,
    "override_total_1": 26541.19,
    "override_increase_1": 732.31
  },
  {
    "#": "325 Mason Ter (085-96-00)",
    "$": 2398600,
    "address": "325 Mason Ter",
    "parcel_id": "085-96-00",
    "owner1": "RAO, VIKRAM",
    "owner2": "NARAYANAN, RANJANI",
    "current_taxes": 24561.66,
    "new_taxes_no_override": 25622.72,
    "override_total_1": 26349.75,
    "override_increase_1": 727.03
  },
  {
    "#": "327 Mason Ter (085-97-00)",
    "$": 2025100,
    "address": "327 Mason Ter",
    "parcel_id": "085-97-00",
    "owner1": "LIU, CHUN",
    "owner2": "ZHANG, SHUMIN",
    "current_taxes": 17102.09,
    "new_taxes_no_override": 17840.9,
    "override_total_1": 18347.12,
    "override_increase_1": 506.22
  },
  {
    "#": "328 Mason Ter (086-01-00)",
    "$": 2003700,
    "address": "328 Mason Ter",
    "parcel_id": "086-01-00",
    "owner1": "GURIAN, TANYA T",
    "owner2": "",
    "current_taxes": 20517.89,
    "new_taxes_no_override": 21404.26,
    "override_total_1": 22011.59,
    "override_increase_1": 607.33
  },
  {
    "#": "1 Meadowbrook Rd (342-01-02)",
    "$": 1515600,
    "address": "1 Meadowbrook Rd",
    "parcel_id": "342-01-02",
    "owner1": "RENFROE, KELLY E",
    "owner2": "",
    "current_taxes": 15519.74,
    "new_taxes_no_override": 16190.19,
    "override_total_1": 16649.58,
    "override_increase_1": 459.38
  },
  {
    "#": "5 Meadowbrook Rd (342-03-01)",
    "$": 1044600,
    "address": "5 Meadowbrook Rd",
    "parcel_id": "342-03-01",
    "owner1": "LEE TR, JOHN T",
    "owner2": "",
    "current_taxes": 10696.7,
    "new_taxes_no_override": 11158.8,
    "override_total_1": 11475.42,
    "override_increase_1": 316.62
  },
  {
    "#": "6 Meadowbrook Rd (341-13-00)",
    "$": 1277600,
    "address": "6 Meadowbrook Rd",
    "parcel_id": "341-13-00",
    "owner1": "GEAGAN, BARBARA L",
    "owner2": "WOOD, JENNIFER L",
    "current_taxes": 13082.62,
    "new_taxes_no_override": 13647.79,
    "override_total_1": 14035.03,
    "override_increase_1": 387.25
  },
  {
    "#": "7 Meadowbrook Rd (342-03-02)",
    "$": 1054600,
    "address": "7 Meadowbrook Rd",
    "parcel_id": "342-03-02",
    "owner1": "BURKLEY, JULIE E",
    "owner2": "WOHLERS, CRAIG",
    "current_taxes": 7164.17,
    "new_taxes_no_override": 7473.66,
    "override_total_1": 7685.72,
    "override_increase_1": 212.06
  },
  {
    "#": "9 Meadowbrook Rd, Unit 9 (342-04-01)",
    "$": 1415800,
    "address": "9 Meadowbrook Rd, Unit 9",
    "parcel_id": "342-04-01",
    "owner1": "QUEEN, SARAH A",
    "owner2": "",
    "current_taxes": 10862.86,
    "new_taxes_no_override": 11332.14,
    "override_total_1": 11653.68,
    "override_increase_1": 321.54
  },
  {
    "#": "11 Meadowbrook Rd, Unit 11 (342-04-02)",
    "$": 1566300,
    "address": "11 Meadowbrook Rd, Unit 11",
    "parcel_id": "342-04-02",
    "owner1": "WOODWORTH, HEATHER",
    "owner2": "",
    "current_taxes": 16038.91,
    "new_taxes_no_override": 16731.79,
    "override_total_1": 17206.54,
    "override_increase_1": 474.75
  },
  {
    "#": "15 Meadowbrook Rd, Unit 15 (342-04-04)",
    "$": 1425200,
    "address": "15 Meadowbrook Rd, Unit 15",
    "parcel_id": "342-04-04",
    "owner1": "AL-MASRI, NADIA MONICA",
    "owner2": "SMITH, JOEL",
    "current_taxes": 10959.11,
    "new_taxes_no_override": 11432.54,
    "override_total_1": 11756.93,
    "override_increase_1": 324.39
  },
  {
    "#": "26 Meadowbrook Rd (345-15-00)",
    "$": 1017300,
    "address": "26 Meadowbrook Rd",
    "parcel_id": "345-15-00",
    "owner1": "SALAH, GEORGE J",
    "owner2": "C/O SALAH, THOMAS",
    "current_taxes": 10417.15,
    "new_taxes_no_override": 10867.17,
    "override_total_1": 11175.52,
    "override_increase_1": 308.35
  },
  {
    "#": "28 Meadowbrook Rd, Unit 28 (345-13-01)",
    "$": 1392900,
    "address": "28 Meadowbrook Rd, Unit 28",
    "parcel_id": "345-13-01",
    "owner1": "LUO, SUQUN",
    "owner2": "YANG, YUN",
    "current_taxes": 10628.36,
    "new_taxes_no_override": 11087.51,
    "override_total_1": 11402.1,
    "override_increase_1": 314.6
  },
  {
    "#": "30 Meadowbrook Rd, Unit 30 (345-13-02)",
    "$": 1378600,
    "address": "30 Meadowbrook Rd, Unit 30",
    "parcel_id": "345-13-02",
    "owner1": "EDDINGER TR, PAMMY YUE",
    "owner2": "",
    "current_taxes": 10481.93,
    "new_taxes_no_override": 10934.75,
    "override_total_1": 11245.01,
    "override_increase_1": 310.27
  },
  {
    "#": "32 Meadowbrook Rd, Unit 32 (345-13-03)",
    "$": 1378600,
    "address": "32 Meadowbrook Rd, Unit 32",
    "parcel_id": "345-13-03",
    "owner1": "MA, JUN",
    "owner2": "",
    "current_taxes": 10481.93,
    "new_taxes_no_override": 10934.75,
    "override_total_1": 11245.01,
    "override_increase_1": 310.27
  },
  {
    "#": "33 Meadowbrook Rd (343-05-00)",
    "$": 999500,
    "address": "33 Meadowbrook Rd",
    "parcel_id": "343-05-00",
    "owner1": "ODESSIT MEADOWBROOK LLC",
    "owner2": "",
    "current_taxes": 6599.95,
    "new_taxes_no_override": 6885.07,
    "override_total_1": 7080.43,
    "override_increase_1": 195.36
  },
  {
    "#": "34 Meadowbrook Rd, Unit 34 (345-13-04)",
    "$": 1392900,
    "address": "34 Meadowbrook Rd, Unit 34",
    "parcel_id": "345-13-04",
    "owner1": "WONG TRS, STEPHEN KENNETH & ALICIA TANG",
    "owner2": "",
    "current_taxes": 10628.36,
    "new_taxes_no_override": 11087.51,
    "override_total_1": 11402.1,
    "override_increase_1": 314.6
  },
  {
    "#": "36 Meadowbrook Rd (345-12-00)",
    "$": 1300500,
    "address": "36 Meadowbrook Rd",
    "parcel_id": "345-12-00",
    "owner1": "HOULIHAN LIFE ESTATE, RICHARD G & JANICE M",
    "owner2": "",
    "current_taxes": 9682.19,
    "new_taxes_no_override": 10100.46,
    "override_total_1": 10387.05,
    "override_increase_1": 286.59
  },
  {
    "#": "40 Meadowbrook Rd (345-11-00)",
    "$": 1196200,
    "address": "40 Meadowbrook Rd",
    "parcel_id": "345-11-00",
    "owner1": "MORAKABATI, REZA",
    "owner2": "",
    "current_taxes": 8614.15,
    "new_taxes_no_override": 8986.28,
    "override_total_1": 9241.26,
    "override_increase_1": 254.98
  },
  {
    "#": "46 Meadowbrook Rd (345-09-10)",
    "$": 1522900,
    "address": "46 Meadowbrook Rd",
    "parcel_id": "345-09-10",
    "owner1": "WANG, EDWARD K",
    "owner2": "MCLEAN, KATHLEEN M",
    "current_taxes": 11959.56,
    "new_taxes_no_override": 12476.21,
    "override_total_1": 12830.22,
    "override_increase_1": 354.0
  },
  {
    "#": "52 Meadowbrook Rd (345-08-00)",
    "$": 1092900,
    "address": "52 Meadowbrook Rd",
    "parcel_id": "345-08-00",
    "owner1": "BERLIN, DEAN & JENNY LARIOS",
    "owner2": "",
    "current_taxes": 7556.36,
    "new_taxes_no_override": 7882.79,
    "override_total_1": 8106.46,
    "override_increase_1": 223.67
  },
  {
    "#": "55 Meadowbrook Rd (344-06-02)",
    "$": 1231000,
    "address": "55 Meadowbrook Rd",
    "parcel_id": "344-06-02",
    "owner1": "LIAO, CAROLINE W",
    "owner2": "",
    "current_taxes": 8970.51,
    "new_taxes_no_override": 9358.04,
    "override_total_1": 9623.56,
    "override_increase_1": 265.53
  },
  {
    "#": "56 Meadowbrook Rd (345-07-00)",
    "$": 1223800,
    "address": "56 Meadowbrook Rd",
    "parcel_id": "345-07-00",
    "owner1": "EDELSTEIN, LAURA",
    "owner2": "",
    "current_taxes": 8896.78,
    "new_taxes_no_override": 9281.12,
    "override_total_1": 9544.47,
    "override_increase_1": 263.34
  },
  {
    "#": "67 Meadowbrook Rd, Unit 4 (344-08-05)",
    "$": 1362900,
    "address": "67 Meadowbrook Rd, Unit 4",
    "parcel_id": "344-08-05",
    "owner1": "DRIBEN, BRUCE & AUDREY WINTER",
    "owner2": "",
    "current_taxes": 10321.16,
    "new_taxes_no_override": 10767.03,
    "override_total_1": 11072.54,
    "override_increase_1": 305.51
  },
  {
    "#": "69 Meadowbrook Rd, Unit 3 (344-08-04)",
    "$": 1504400,
    "address": "69 Meadowbrook Rd, Unit 3",
    "parcel_id": "344-08-04",
    "owner1": "LEHTINEN TRS, MARIA",
    "owner2": "ANDERMANN, MARK",
    "current_taxes": 11770.12,
    "new_taxes_no_override": 12278.59,
    "override_total_1": 12626.98,
    "override_increase_1": 348.4
  },
  {
    "#": "70 Meadowbrook Rd (345-03-00)",
    "$": 1821600,
    "address": "70 Meadowbrook Rd",
    "parcel_id": "345-03-00",
    "owner1": "LEONG, NGAR LAI & FEE LAI",
    "owner2": "",
    "current_taxes": 15018.25,
    "new_taxes_no_override": 15667.04,
    "override_total_1": 16111.58,
    "override_increase_1": 444.54
  },
  {
    "#": "71 Meadowbrook Rd, Unit 1 (344-08-02)",
    "$": 1501800,
    "address": "71 Meadowbrook Rd, Unit 1",
    "parcel_id": "344-08-02",
    "owner1": "CHANG, STEVEN",
    "owner2": "HUANG, KATHIE",
    "current_taxes": 11743.5,
    "new_taxes_no_override": 12250.82,
    "override_total_1": 12598.43,
    "override_increase_1": 347.61
  },
  {
    "#": "73 Meadowbrook Rd, Unit 2 (344-08-03)",
    "$": 1538800,
    "address": "73 Meadowbrook Rd, Unit 2",
    "parcel_id": "344-08-03",
    "owner1": "HOUSMAN TR, DONNA K",
    "owner2": "",
    "current_taxes": 12122.38,
    "new_taxes_no_override": 12646.07,
    "override_total_1": 13004.89,
    "override_increase_1": 358.82
  },
  {
    "#": "78 Meadowbrook Rd (345-01-00)",
    "$": 1354500,
    "address": "78 Meadowbrook Rd",
    "parcel_id": "345-01-00",
    "owner1": "GERMAIN TRS, JEAN CLAUDE & GISSELINE",
    "owner2": "",
    "current_taxes": 10235.15,
    "new_taxes_no_override": 10677.31,
    "override_total_1": 10980.27,
    "override_increase_1": 302.96
  },
  {
    "#": "69 Middlesex Rd (283-07-08)",
    "$": 6020300,
    "address": "69 Middlesex Rd",
    "parcel_id": "283-07-08",
    "owner1": "THE BRIMMER & MAY SCHOOL",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "73 Middlesex Rd (283-01-00)",
    "$": 3556100,
    "address": "73 Middlesex Rd",
    "parcel_id": "283-01-00",
    "owner1": "THE BRIMMER & MAY SCHOOL",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "81 Middlesex Rd (283-02-00)",
    "$": 3498300,
    "address": "81 Middlesex Rd",
    "parcel_id": "283-02-00",
    "owner1": "THE BRIMMER AND MAY SCHOOL",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "91 Middlesex Rd (283-03-00)",
    "$": 5311100,
    "address": "91 Middlesex Rd",
    "parcel_id": "283-03-00",
    "owner1": "RUBINSTEIN, SAMUEL R & JESSICA",
    "owner2": "",
    "current_taxes": 50750.73,
    "new_taxes_no_override": 52943.16,
    "override_total_1": 54445.38,
    "override_increase_1": 1502.22
  },
  {
    "#": "92 Middlesex Rd (282-23-00)",
    "$": 22200,
    "address": "92 Middlesex Rd",
    "parcel_id": "282-23-00",
    "owner1": "THE BRIMMER & MAY SCHOOL",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "96 Middlesex Rd (282-22-00)",
    "$": 30700,
    "address": "96 Middlesex Rd",
    "parcel_id": "282-22-00",
    "owner1": "THE BRIMMER & MAY SCHOOL",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "104 Middlesex Rd (282-21-00)",
    "$": 44300,
    "address": "104 Middlesex Rd",
    "parcel_id": "282-21-00",
    "owner1": "TOLEDANO, TRS, ALLAN",
    "owner2": "",
    "current_taxes": 453.63,
    "new_taxes_no_override": 473.23,
    "override_total_1": 486.65,
    "override_increase_1": 13.43
  },
  {
    "#": "110 Middlesex Rd (282-21-01)",
    "$": 45800,
    "address": "110 Middlesex Rd",
    "parcel_id": "282-21-01",
    "owner1": "PLUTZKY, JORGE",
    "owner2": "BASKIN, NANCY F",
    "current_taxes": 468.99,
    "new_taxes_no_override": 489.25,
    "override_total_1": 503.13,
    "override_increase_1": 13.88
  },
  {
    "#": "120 Middlesex Rd (282-20-00)",
    "$": 29600,
    "address": "120 Middlesex Rd",
    "parcel_id": "282-20-00",
    "owner1": "HALL, LAURIE J",
    "owner2": "REED, WALTER G",
    "current_taxes": 303.1,
    "new_taxes_no_override": 316.19,
    "override_total_1": 325.17,
    "override_increase_1": 8.97
  },
  {
    "#": "128 Middlesex Rd (282-19-00)",
    "$": 25200,
    "address": "128 Middlesex Rd",
    "parcel_id": "282-19-00",
    "owner1": "HAVERBERG, BRUCE A & DONNA R",
    "owner2": "",
    "current_taxes": 258.05,
    "new_taxes_no_override": 269.2,
    "override_total_1": 276.84,
    "override_increase_1": 7.64
  },
  {
    "#": "132 Middlesex Rd, Unit 132-1 &2Pk (282-18-01)",
    "$": 456900,
    "address": "132 Middlesex Rd, Unit 132-1 &2Pk",
    "parcel_id": "282-18-01",
    "owner1": "BAI, HAIQING",
    "owner2": "SONG, WEI",
    "current_taxes": 1043.72,
    "new_taxes_no_override": 1088.81,
    "override_total_1": 1119.7,
    "override_increase_1": 30.89
  },
  {
    "#": "132 Middlesex Rd, Unit 132-2 &2Pk (282-18-02)",
    "$": 438300,
    "address": "132 Middlesex Rd, Unit 132-2 &2Pk",
    "parcel_id": "282-18-02",
    "owner1": "SZENT-GYORGYI, LARA E",
    "owner2": "TRACEY, STEPHEN W",
    "current_taxes": 853.26,
    "new_taxes_no_override": 890.12,
    "override_total_1": 915.38,
    "override_increase_1": 25.26
  },
  {
    "#": "132 Middlesex Rd, Unit 132-3 &3Pk (282-18-03)",
    "$": 527100,
    "address": "132 Middlesex Rd, Unit 132-3 &3Pk",
    "parcel_id": "282-18-03",
    "owner1": "TAYLOR, TERRY",
    "owner2": "",
    "current_taxes": 5397.5,
    "new_taxes_no_override": 5630.67,
    "override_total_1": 5790.44,
    "override_increase_1": 159.77
  },
  {
    "#": "132 Middlesex Rd, Unit 144-1 &2Pk (282-18-17)",
    "$": 455900,
    "address": "132 Middlesex Rd, Unit 144-1 &2Pk",
    "parcel_id": "282-18-17",
    "owner1": "BROWN, KATHARINE W & GREGORY C",
    "owner2": "",
    "current_taxes": 4668.42,
    "new_taxes_no_override": 4870.1,
    "override_total_1": 5008.28,
    "override_increase_1": 138.19
  },
  {
    "#": "132 Middlesex Rd, Unit 144-2 &P21 (282-18-18)",
    "$": 447900,
    "address": "132 Middlesex Rd, Unit 144-2 &P21",
    "parcel_id": "282-18-18",
    "owner1": "MOKADY, EHUD & ELANA",
    "owner2": "",
    "current_taxes": 4586.5,
    "new_taxes_no_override": 4784.64,
    "override_total_1": 4920.4,
    "override_increase_1": 135.76
  },
  {
    "#": "132 Middlesex Rd, Unit 144-3 &2Pk (282-18-19)",
    "$": 442000,
    "address": "132 Middlesex Rd, Unit 144-3 &2Pk",
    "parcel_id": "282-18-19",
    "owner1": "CHONG, ROYSON",
    "owner2": "CHAN, SEA WON ELLA",
    "current_taxes": 891.15,
    "new_taxes_no_override": 929.65,
    "override_total_1": 956.03,
    "override_increase_1": 26.38
  },
  {
    "#": "137 Middlesex Rd (281-07-00)",
    "$": 3062000,
    "address": "137 Middlesex Rd",
    "parcel_id": "281-07-00",
    "owner1": "PLOTZ TRS, JOHN",
    "owner2": "SOLTANI, LISA",
    "current_taxes": 27719.95,
    "new_taxes_no_override": 28917.45,
    "override_total_1": 29737.96,
    "override_increase_1": 820.51
  },
  {
    "#": "145 Middlesex Rd (281-08-00)",
    "$": 3528700,
    "address": "145 Middlesex Rd",
    "parcel_id": "281-08-00",
    "owner1": "WYLIE, JOHN & BLAIR",
    "owner2": "",
    "current_taxes": 32498.95,
    "new_taxes_no_override": 33902.9,
    "override_total_1": 34864.87,
    "override_increase_1": 961.97
  },
  {
    "#": "151 Middlesex Rd (281-09-00)",
    "$": 2410500,
    "address": "151 Middlesex Rd",
    "parcel_id": "281-09-00",
    "owner1": "PARKER, HANNAH J",
    "owner2": "BAUMANN, HEINRICH",
    "current_taxes": 21048.59,
    "new_taxes_no_override": 21957.89,
    "override_total_1": 22580.93,
    "override_increase_1": 623.04
  },
  {
    "#": "157 Middlesex Rd (281-10-00)",
    "$": 2960900,
    "address": "157 Middlesex Rd",
    "parcel_id": "281-10-00",
    "owner1": "BUSCH, ALISA B",
    "owner2": "DANKWERTH, ANDREW J",
    "current_taxes": 26684.68,
    "new_taxes_no_override": 27837.46,
    "override_total_1": 28627.32,
    "override_increase_1": 789.87
  },
  {
    "#": "162 Middlesex Rd (282-13-00)",
    "$": 694100,
    "address": "162 Middlesex Rd",
    "parcel_id": "282-13-00",
    "owner1": "FLINT, ALAN",
    "owner2": "GRECO, CHRISTINE",
    "current_taxes": 3472.65,
    "new_taxes_no_override": 3622.67,
    "override_total_1": 3725.46,
    "override_increase_1": 102.79
  },
  {
    "#": "163 Middlesex Rd (281-11-00)",
    "$": 4579300,
    "address": "163 Middlesex Rd",
    "parcel_id": "281-11-00",
    "owner1": "KOVACS, SHANE & VALERIE",
    "owner2": "",
    "current_taxes": 43257.1,
    "new_taxes_no_override": 45125.81,
    "override_total_1": 46406.22,
    "override_increase_1": 1280.41
  },
  {
    "#": "170 Middlesex Rd (282-12-00)",
    "$": 366000,
    "address": "170 Middlesex Rd",
    "parcel_id": "282-12-00",
    "owner1": "CHI, DORCAS",
    "owner2": "WANG ETAL, HEJING",
    "current_taxes": 3747.84,
    "new_taxes_no_override": 3909.75,
    "override_total_1": 4020.68,
    "override_increase_1": 110.94
  },
  {
    "#": "174 Middlesex Rd (282-11-00)",
    "$": 536200,
    "address": "174 Middlesex Rd",
    "parcel_id": "282-11-00",
    "owner1": "RIVERO, MARITA",
    "owner2": "",
    "current_taxes": 1855.75,
    "new_taxes_no_override": 1935.92,
    "override_total_1": 1990.85,
    "override_increase_1": 54.93
  },
  {
    "#": "175 Middlesex Rd (281-12-00)",
    "$": 3543400,
    "address": "175 Middlesex Rd",
    "parcel_id": "281-12-00",
    "owner1": "PACKARD, ALEXANDER B",
    "owner2": "",
    "current_taxes": 36284.42,
    "new_taxes_no_override": 37851.91,
    "override_total_1": 38925.93,
    "override_increase_1": 1074.02
  },
  {
    "#": "180 Middlesex Rd (282-10-00)",
    "$": 1294800,
    "address": "180 Middlesex Rd",
    "parcel_id": "282-10-00",
    "owner1": "PATEL, PINAKIN J & HEENA P",
    "owner2": "",
    "current_taxes": 9623.82,
    "new_taxes_no_override": 10039.57,
    "override_total_1": 10324.43,
    "override_increase_1": 284.87
  },
  {
    "#": "183 Middlesex Rd (281-12-01)",
    "$": 4342400,
    "address": "183 Middlesex Rd",
    "parcel_id": "281-12-01",
    "owner1": "MARCUS, CRAIG E & JULIE F",
    "owner2": "",
    "current_taxes": 40831.24,
    "new_taxes_no_override": 42595.15,
    "override_total_1": 43803.75,
    "override_increase_1": 1208.6
  },
  {
    "#": "190 Middlesex Rd (282-08-09)",
    "$": 1926000,
    "address": "190 Middlesex Rd",
    "parcel_id": "282-08-09",
    "owner1": "HIERSTEINER, RICHARD & ERICA",
    "owner2": "",
    "current_taxes": 16087.31,
    "new_taxes_no_override": 16782.28,
    "override_total_1": 17258.47,
    "override_increase_1": 476.18
  },
  {
    "#": "195 Middlesex Rd (281-13-14)",
    "$": 4919500,
    "address": "195 Middlesex Rd",
    "parcel_id": "281-13-14",
    "owner1": "KALIN TR, RACHEL LYNN",
    "owner2": "",
    "current_taxes": 50375.68,
    "new_taxes_no_override": 52551.91,
    "override_total_1": 54043.03,
    "override_increase_1": 1491.12
  },
  {
    "#": "206 Middlesex Rd (282-07-00)",
    "$": 2323800,
    "address": "206 Middlesex Rd",
    "parcel_id": "282-07-00",
    "owner1": "KRAHMER, MICHELE",
    "owner2": "",
    "current_taxes": 23795.71,
    "new_taxes_no_override": 24823.68,
    "override_total_1": 25528.04,
    "override_increase_1": 704.35
  },
  {
    "#": "209 Middlesex Rd (281-15-00)",
    "$": 3970200,
    "address": "209 Middlesex Rd",
    "parcel_id": "281-15-00",
    "owner1": "YU, ERIC & LILY L",
    "owner2": "",
    "current_taxes": 37019.91,
    "new_taxes_no_override": 38619.17,
    "override_total_1": 39714.96,
    "override_increase_1": 1095.79
  },
  {
    "#": "210 Middlesex Rd (282-06-00)",
    "$": 2209800,
    "address": "210 Middlesex Rd",
    "parcel_id": "282-06-00",
    "owner1": "DRISCOLL, DAVID & KATRINA GREENMAN",
    "owner2": "",
    "current_taxes": 18993.42,
    "new_taxes_no_override": 19813.94,
    "override_total_1": 20376.14,
    "override_increase_1": 562.21
  },
  {
    "#": "218 Middlesex Rd (282-04-05)",
    "$": 2831900,
    "address": "218 Middlesex Rd",
    "parcel_id": "282-04-05",
    "owner1": "HOLAHAN, TIMOTHY F",
    "owner2": "MALONE, MAURA E",
    "current_taxes": 28998.66,
    "new_taxes_no_override": 30251.4,
    "override_total_1": 31109.76,
    "override_increase_1": 858.36
  },
  {
    "#": "230 Middlesex Rd (282-03-00)",
    "$": 2270600,
    "address": "230 Middlesex Rd",
    "parcel_id": "282-03-00",
    "owner1": "HIRATA ETAL, ALLISON M",
    "owner2": "WANG, FOREA L & RICHARD Y",
    "current_taxes": 19616.01,
    "new_taxes_no_override": 20463.42,
    "override_total_1": 21044.06,
    "override_increase_1": 580.63
  },
  {
    "#": "233 Middlesex Rd (281-19-00)",
    "$": 3089600,
    "address": "233 Middlesex Rd",
    "parcel_id": "281-19-00",
    "owner1": "MEAD, STEPHEN JR & LAETITIA",
    "owner2": "",
    "current_taxes": 28002.57,
    "new_taxes_no_override": 29212.28,
    "override_total_1": 30041.16,
    "override_increase_1": 828.88
  },
  {
    "#": "234 Middlesex Rd (282-02-00)",
    "$": 2325800,
    "address": "234 Middlesex Rd",
    "parcel_id": "282-02-00",
    "owner1": "PRIESOL, ADRIAN",
    "owner2": "TORUN, NURHAN",
    "current_taxes": 20181.26,
    "new_taxes_no_override": 21053.09,
    "override_total_1": 21650.46,
    "override_increase_1": 597.37
  },
  {
    "#": "240 Middlesex Rd (282-01-00)",
    "$": 2563800,
    "address": "240 Middlesex Rd",
    "parcel_id": "282-01-00",
    "owner1": "FEIBEL, BRUCE J & SHARI Z",
    "owner2": "",
    "current_taxes": 22618.38,
    "new_taxes_no_override": 23595.49,
    "override_total_1": 24265.0,
    "override_increase_1": 669.5
  },
  {
    "#": "243 Middlesex Rd (281-20-01)",
    "$": 383100,
    "address": "243 Middlesex Rd",
    "parcel_id": "281-20-01",
    "owner1": "SILBERT TRS, CYNTHIA K",
    "owner2": "KORB, DAVID",
    "current_taxes": 3922.94,
    "new_taxes_no_override": 4092.41,
    "override_total_1": 4208.53,
    "override_increase_1": 116.12
  },
  {
    "#": "10 Milton Rd (320-13-00)",
    "$": 1915400,
    "address": "10 Milton Rd",
    "parcel_id": "320-13-00",
    "owner1": "SETIYA, KIERAN",
    "owner2": "GUBAR, MARAH",
    "current_taxes": 15978.76,
    "new_taxes_no_override": 16669.04,
    "override_total_1": 17142.01,
    "override_increase_1": 472.97
  },
  {
    "#": "11 Milton Rd (319-02-00)",
    "$": 2091100,
    "address": "11 Milton Rd",
    "parcel_id": "319-02-00",
    "owner1": "ROTHSTEIN TRS, JOSEPH C & SUSAN E",
    "owner2": "",
    "current_taxes": 17777.93,
    "new_taxes_no_override": 18545.94,
    "override_total_1": 19072.16,
    "override_increase_1": 526.23
  },
  {
    "#": "14 Milton Rd (320-12-00)",
    "$": 2874300,
    "address": "14 Milton Rd",
    "parcel_id": "320-12-00",
    "owner1": "SUDDUTH, ANNE & MATTHEW",
    "owner2": "",
    "current_taxes": 25797.9,
    "new_taxes_no_override": 26912.37,
    "override_total_1": 27675.99,
    "override_increase_1": 763.62
  },
  {
    "#": "17 Milton Rd (319-03-00)",
    "$": 2318500,
    "address": "17 Milton Rd",
    "parcel_id": "319-03-00",
    "owner1": "JONES, RICHARD L",
    "owner2": "KRAMER, ABIGAIL S",
    "current_taxes": 20106.51,
    "new_taxes_no_override": 20975.11,
    "override_total_1": 21570.26,
    "override_increase_1": 595.15
  },
  {
    "#": "18 Milton Rd (320-11-00)",
    "$": 2082500,
    "address": "18 Milton Rd",
    "parcel_id": "320-11-00",
    "owner1": "FRIEDMAN, EVELYN & RAQUEL RUTH",
    "owner2": "",
    "current_taxes": 17689.87,
    "new_taxes_no_override": 18454.07,
    "override_total_1": 18977.69,
    "override_increase_1": 523.62
  },
  {
    "#": "21 Milton Rd (319-04-05)",
    "$": 2497600,
    "address": "21 Milton Rd",
    "parcel_id": "319-04-05",
    "owner1": "ENGLAND, KEVIN A & SUBHADRA",
    "owner2": "",
    "current_taxes": 21940.49,
    "new_taxes_no_override": 22888.32,
    "override_total_1": 23537.76,
    "override_increase_1": 649.44
  },
  {
    "#": "24 Milton Rd (320-10-00)",
    "$": 2028100,
    "address": "24 Milton Rd",
    "parcel_id": "320-10-00",
    "owner1": "TEAGUE, DANA M & TERRANCE M",
    "owner2": "",
    "current_taxes": 17132.81,
    "new_taxes_no_override": 17872.95,
    "override_total_1": 18380.08,
    "override_increase_1": 507.13
  },
  {
    "#": "32 Milton Rd, Unit 1 (320A-02-01)",
    "$": 1200100,
    "address": "32 Milton Rd, Unit 1",
    "parcel_id": "320A-02-01",
    "owner1": "BRUEN, GARTH O & EILEEN O",
    "owner2": "",
    "current_taxes": 8654.09,
    "new_taxes_no_override": 9027.95,
    "override_total_1": 9284.11,
    "override_increase_1": 256.16
  },
  {
    "#": "32 Milton Rd, Unit 2 (320A-02-02)",
    "$": 1340900,
    "address": "32 Milton Rd, Unit 2",
    "parcel_id": "320A-02-02",
    "owner1": "BROWNING, JEFFREY L",
    "owner2": "",
    "current_taxes": 10095.88,
    "new_taxes_no_override": 10532.02,
    "override_total_1": 10830.86,
    "override_increase_1": 298.84
  },
  {
    "#": "35 Milton Rd (319-06-07)",
    "$": 1717400,
    "address": "35 Milton Rd",
    "parcel_id": "319-06-07",
    "owner1": "MORRIS, PAMELA",
    "owner2": "",
    "current_taxes": 17586.18,
    "new_taxes_no_override": 18345.9,
    "override_total_1": 18866.45,
    "override_increase_1": 520.55
  },
  {
    "#": "36 Milton Rd (320A-01-00)",
    "$": 1883000,
    "address": "36 Milton Rd",
    "parcel_id": "320A-01-00",
    "owner1": "TAXIDIS, PETER",
    "owner2": "BALDI, ANDREA ANNE",
    "current_taxes": 15646.99,
    "new_taxes_no_override": 16322.94,
    "override_total_1": 16786.09,
    "override_increase_1": 463.15
  },
  {
    "#": "10 Monmouth Ct (113-06-00)",
    "$": 3334900,
    "address": "10 Monmouth Ct",
    "parcel_id": "113-06-00",
    "owner1": "WALSH TR, CHARLES A III",
    "owner2": "",
    "current_taxes": 30514.44,
    "new_taxes_no_override": 31832.66,
    "override_total_1": 32735.89,
    "override_increase_1": 903.23
  },
  {
    "#": "11 Monmouth Ct, Unit 1 (114-10-01)",
    "$": 625800,
    "address": "11 Monmouth Ct, Unit 1",
    "parcel_id": "114-10-01",
    "owner1": "LEVITIN, LEV B",
    "owner2": "",
    "current_taxes": 2773.26,
    "new_taxes_no_override": 2893.06,
    "override_total_1": 2975.15,
    "override_increase_1": 82.09
  },
  {
    "#": "11 Monmouth Ct, Unit 2 (114-10-02)",
    "$": 781900,
    "address": "11 Monmouth Ct, Unit 2",
    "parcel_id": "114-10-02",
    "owner1": "PENALVER, LUIS R",
    "owner2": "DAVIS, ELIZABETH A",
    "current_taxes": 8006.66,
    "new_taxes_no_override": 8352.55,
    "override_total_1": 8589.54,
    "override_increase_1": 237.0
  },
  {
    "#": "11 Monmouth Ct, Unit 3 (114-10-03)",
    "$": 697100,
    "address": "11 Monmouth Ct, Unit 3",
    "parcel_id": "114-10-03",
    "owner1": "WANG, PEI",
    "owner2": "",
    "current_taxes": 3503.37,
    "new_taxes_no_override": 3654.72,
    "override_total_1": 3758.42,
    "override_increase_1": 103.7
  },
  {
    "#": "11 Monmouth Ct, Unit 4 (114-10-04)",
    "$": 764800,
    "address": "11 Monmouth Ct, Unit 4",
    "parcel_id": "114-10-04",
    "owner1": "RUDNITSKAYA, ALEKSANDRA",
    "owner2": "LEVITIN, LEV B",
    "current_taxes": 4196.62,
    "new_taxes_no_override": 4377.91,
    "override_total_1": 4502.13,
    "override_increase_1": 124.22
  },
  {
    "#": "11 Monmouth Ct, Unit 5 (114-10-05)",
    "$": 684200,
    "address": "11 Monmouth Ct, Unit 5",
    "parcel_id": "114-10-05",
    "owner1": "PERELMAN, REBECCA & LEV & OLGA",
    "owner2": "",
    "current_taxes": 3371.27,
    "new_taxes_no_override": 3516.91,
    "override_total_1": 3616.7,
    "override_increase_1": 99.79
  },
  {
    "#": "11 Monmouth Ct, Unit 6 & P3 (114-10-06)",
    "$": 925200,
    "address": "11 Monmouth Ct, Unit 6 & P3",
    "parcel_id": "114-10-06",
    "owner1": "KISHORE, PUNYAMURTULA S",
    "owner2": "GURBANI, SHEELA",
    "current_taxes": 9474.05,
    "new_taxes_no_override": 9883.33,
    "override_total_1": 10163.76,
    "override_increase_1": 280.43
  },
  {
    "#": "12 Monmouth Ct (113-05-00)",
    "$": 2999500,
    "address": "12 Monmouth Ct",
    "parcel_id": "113-05-00",
    "owner1": "CHAPMAN, JOHN C & DIANA B",
    "owner2": "",
    "current_taxes": 27079.95,
    "new_taxes_no_override": 28249.8,
    "override_total_1": 29051.37,
    "override_increase_1": 801.57
  },
  {
    "#": "14 Monmouth Ct (113-04-00)",
    "$": 2733300,
    "address": "14 Monmouth Ct",
    "parcel_id": "113-04-00",
    "owner1": "REID TR, WATSON D",
    "owner2": "",
    "current_taxes": 24354.06,
    "new_taxes_no_override": 25406.16,
    "override_total_1": 26127.04,
    "override_increase_1": 720.88
  },
  {
    "#": "15 Monmouth Ct, Unit 1 (114-10-07)",
    "$": 648500,
    "address": "15 Monmouth Ct, Unit 1",
    "parcel_id": "114-10-07",
    "owner1": "ANZIVINO TR, HELENA A",
    "owner2": "",
    "current_taxes": 3005.71,
    "new_taxes_no_override": 3135.56,
    "override_total_1": 3224.53,
    "override_increase_1": 88.97
  },
  {
    "#": "15 Monmouth Ct, Unit 2 (114-10-08)",
    "$": 647900,
    "address": "15 Monmouth Ct, Unit 2",
    "parcel_id": "114-10-08",
    "owner1": "TOWSNER, ROBERT S&RITA&EAN",
    "owner2": "",
    "current_taxes": 2999.56,
    "new_taxes_no_override": 3129.14,
    "override_total_1": 3217.93,
    "override_increase_1": 88.79
  },
  {
    "#": "15 Monmouth Ct, Unit 3 (114-10-09)",
    "$": 632600,
    "address": "15 Monmouth Ct, Unit 3",
    "parcel_id": "114-10-09",
    "owner1": "STEIN TR, ROSANNE W",
    "owner2": "",
    "current_taxes": 6477.82,
    "new_taxes_no_override": 6757.66,
    "override_total_1": 6949.41,
    "override_increase_1": 191.74
  },
  {
    "#": "15 Monmouth Ct, Unit 4 & P1 (114-10-10)",
    "$": 653000,
    "address": "15 Monmouth Ct, Unit 4 & P1",
    "parcel_id": "114-10-10",
    "owner1": "STEIN, ROSEANNE",
    "owner2": "",
    "current_taxes": 6686.72,
    "new_taxes_no_override": 6975.59,
    "override_total_1": 7173.51,
    "override_increase_1": 197.93
  },
  {
    "#": "15 Monmouth Ct, Unit 5 (114-10-11)",
    "$": 658100,
    "address": "15 Monmouth Ct, Unit 5",
    "parcel_id": "114-10-11",
    "owner1": "AMDURSKY TRS, ERIC J & JENNIFER S",
    "owner2": "",
    "current_taxes": 6738.94,
    "new_taxes_no_override": 7030.06,
    "override_total_1": 7229.53,
    "override_increase_1": 199.47
  },
  {
    "#": "15 Monmouth Ct, Unit 6 & P4 (114-10-12)",
    "$": 678500,
    "address": "15 Monmouth Ct, Unit 6 & P4",
    "parcel_id": "114-10-12",
    "owner1": "STEIN TR, ROSANNE W",
    "owner2": "",
    "current_taxes": 6947.84,
    "new_taxes_no_override": 7247.99,
    "override_total_1": 7453.64,
    "override_increase_1": 205.66
  },
  {
    "#": "16 Monmouth Ct (113-03-00)",
    "$": 2657000,
    "address": "16 Monmouth Ct",
    "parcel_id": "113-03-00",
    "owner1": "ABLOW TR, RACHEL E",
    "owner2": "",
    "current_taxes": 27207.68,
    "new_taxes_no_override": 28383.05,
    "override_total_1": 29188.4,
    "override_increase_1": 805.35
  },
  {
    "#": "17 Monmouth Ct, Unit 1 (114-10-14)",
    "$": 768300,
    "address": "17 Monmouth Ct, Unit 1",
    "parcel_id": "114-10-14",
    "owner1": "CLARKE, THOMAS D & LAURA",
    "owner2": "",
    "current_taxes": 7867.39,
    "new_taxes_no_override": 8207.26,
    "override_total_1": 8440.14,
    "override_increase_1": 232.87
  },
  {
    "#": "17 Monmouth Ct, Unit 2 (114-10-15)",
    "$": 642800,
    "address": "17 Monmouth Ct, Unit 2",
    "parcel_id": "114-10-15",
    "owner1": "BRUCE TRS, ANDREA L",
    "owner2": "CORCORAN, JULIE",
    "current_taxes": 6582.27,
    "new_taxes_no_override": 6866.62,
    "override_total_1": 7061.46,
    "override_increase_1": 194.84
  },
  {
    "#": "17 Monmouth Ct, Unit 3 (114-10-16)",
    "$": 764800,
    "address": "17 Monmouth Ct, Unit 3",
    "parcel_id": "114-10-16",
    "owner1": "VATMAN, TALYA E",
    "owner2": "",
    "current_taxes": 4196.62,
    "new_taxes_no_override": 4377.91,
    "override_total_1": 4502.13,
    "override_increase_1": 124.22
  },
  {
    "#": "17 Monmouth Ct, Unit 4 (114-10-17)",
    "$": 677100,
    "address": "17 Monmouth Ct, Unit 4",
    "parcel_id": "114-10-17",
    "owner1": "BOEY, CHOONG-KHEONG PATRICK",
    "owner2": "",
    "current_taxes": 3298.57,
    "new_taxes_no_override": 3441.07,
    "override_total_1": 3538.71,
    "override_increase_1": 97.64
  },
  {
    "#": "17 Monmouth Ct, Unit 5 (114-10-18)",
    "$": 764800,
    "address": "17 Monmouth Ct, Unit 5",
    "parcel_id": "114-10-18",
    "owner1": "KRASINSKI TR, PETER EDWIN",
    "owner2": "",
    "current_taxes": 4196.62,
    "new_taxes_no_override": 4377.91,
    "override_total_1": 4502.13,
    "override_increase_1": 124.22
  },
  {
    "#": "17 Monmouth Ct, Unit 6 & P2 (114-10-19)",
    "$": 825100,
    "address": "17 Monmouth Ct, Unit 6 & P2",
    "parcel_id": "114-10-19",
    "owner1": "CHEN, MING HUI",
    "owner2": "WALSH, MICHELLE LIAN",
    "current_taxes": 8449.02,
    "new_taxes_no_override": 8814.02,
    "override_total_1": 9064.11,
    "override_increase_1": 250.09
  },
  {
    "#": "17 Monmouth Ct, Unit B (114-10-13)",
    "$": 490400,
    "address": "17 Monmouth Ct, Unit B",
    "parcel_id": "114-10-13",
    "owner1": "KAEMMER TR, GRETA R",
    "owner2": "",
    "current_taxes": 1386.76,
    "new_taxes_no_override": 1446.67,
    "override_total_1": 1487.72,
    "override_increase_1": 41.05
  },
  {
    "#": "18 Monmouth Ct (113-02-00)",
    "$": 2564500,
    "address": "18 Monmouth Ct",
    "parcel_id": "113-02-00",
    "owner1": "LINDGREN, KRISTEN",
    "owner2": "VOLINSKY, MATTHEW",
    "current_taxes": 26260.48,
    "new_taxes_no_override": 27394.93,
    "override_total_1": 28172.24,
    "override_increase_1": 777.31
  },
  {
    "#": "19 Monmouth Ct (114-11-00)",
    "$": 2907100,
    "address": "19 Monmouth Ct",
    "parcel_id": "114-11-00",
    "owner1": "MONTEIRO, RICARDO",
    "owner2": "HAFEEZ, NAFEEZA",
    "current_taxes": 26133.77,
    "new_taxes_no_override": 27262.75,
    "override_total_1": 28036.31,
    "override_increase_1": 773.56
  },
  {
    "#": "21 Monmouth Ct (114-12-00)",
    "$": 2537300,
    "address": "21 Monmouth Ct",
    "parcel_id": "114-12-00",
    "owner1": "JACKSON, ANGELA DENISE",
    "owner2": "TERNAN, CHRISTOPHER",
    "current_taxes": 22347.02,
    "new_taxes_no_override": 23312.41,
    "override_total_1": 23973.88,
    "override_increase_1": 661.47
  },
  {
    "#": "23 Monmouth Ct (114-13-00)",
    "$": 2370300,
    "address": "23 Monmouth Ct",
    "parcel_id": "114-13-00",
    "owner1": "GARVER, RICHARD & PENNY",
    "owner2": "",
    "current_taxes": 20636.94,
    "new_taxes_no_override": 21528.46,
    "override_total_1": 22139.31,
    "override_increase_1": 610.85
  },
  {
    "#": "24 Monmouth Ct, Unit 1 & 2 Gar Sps (113-01-05)",
    "$": 2715500,
    "address": "24 Monmouth Ct, Unit 1 & 2 Gar Sps",
    "parcel_id": "113-01-05",
    "owner1": "BOTSFORD, SAMUEL C",
    "owner2": "CHUKWUEKE, UGONMA",
    "current_taxes": 27806.72,
    "new_taxes_no_override": 29007.97,
    "override_total_1": 29831.05,
    "override_increase_1": 823.08
  },
  {
    "#": "24 Monmouth Ct, Unit 2 & 2 Gar Sps (113-01-06)",
    "$": 3043500,
    "address": "24 Monmouth Ct, Unit 2 & 2 Gar Sps",
    "parcel_id": "113-01-06",
    "owner1": "BRETTMAN TRS, LEE R & CYNTHIA H",
    "owner2": "",
    "current_taxes": 31165.44,
    "new_taxes_no_override": 32511.79,
    "override_total_1": 33434.28,
    "override_increase_1": 922.5
  },
  {
    "#": "25 Monmouth Ct (114-14-00)",
    "$": 2919900,
    "address": "25 Monmouth Ct",
    "parcel_id": "114-14-00",
    "owner1": "LIU, STEPHANIE W",
    "owner2": "SCHMIDLIN, ERIC J",
    "current_taxes": 26264.84,
    "new_taxes_no_override": 27399.48,
    "override_total_1": 28176.92,
    "override_increase_1": 777.44
  },
  {
    "#": "26 Monmouth Ct, Unit 1 (113-01-02)",
    "$": 2461100,
    "address": "26 Monmouth Ct, Unit 1",
    "parcel_id": "113-01-02",
    "owner1": "GABRIELSEN, LINDSEY",
    "owner2": "ROSS, PETER",
    "current_taxes": 25201.66,
    "new_taxes_no_override": 26290.37,
    "override_total_1": 27036.34,
    "override_increase_1": 745.97
  },
  {
    "#": "26 Monmouth Ct, Unit 2 (113-01-03)",
    "$": 2721400,
    "address": "26 Monmouth Ct, Unit 2",
    "parcel_id": "113-01-03",
    "owner1": "JAYE TRS, ROBERT & DIANE",
    "owner2": "",
    "current_taxes": 24232.2,
    "new_taxes_no_override": 25279.03,
    "override_total_1": 25996.3,
    "override_increase_1": 717.27
  },
  {
    "#": "27 Monmouth Ct (114-15-00)",
    "$": 2747300,
    "address": "27 Monmouth Ct",
    "parcel_id": "114-15-00",
    "owner1": "CAVELL, CATHLEEN C",
    "owner2": "",
    "current_taxes": 24497.42,
    "new_taxes_no_override": 25555.71,
    "override_total_1": 26280.83,
    "override_increase_1": 725.12
  },
  {
    "#": "4 Monmouth St (116-04-00)",
    "$": 6026100,
    "address": "4 Monmouth St",
    "parcel_id": "116-04-00",
    "owner1": "KIMBALL, RANCH C",
    "owner2": "BOER KIMBALL, ALEXANDRA",
    "current_taxes": 58072.33,
    "new_taxes_no_override": 60581.05,
    "override_total_1": 62300.0,
    "override_increase_1": 1718.94
  },
  {
    "#": "16 Monmouth St (116-03-00)",
    "$": 6320300,
    "address": "16 Monmouth St",
    "parcel_id": "116-03-00",
    "owner1": "FELDMAN, JESSE & GEORGIA A",
    "owner2": "",
    "current_taxes": 61084.94,
    "new_taxes_no_override": 63723.81,
    "override_total_1": 65531.92,
    "override_increase_1": 1808.11
  },
  {
    "#": "23 Monmouth St (115-12-00)",
    "$": 3625900,
    "address": "23 Monmouth St",
    "parcel_id": "115-12-00",
    "owner1": "CHURCH OF OUR SAVIOUR",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "26 Monmouth St (116-02-00)",
    "$": 6064100,
    "address": "26 Monmouth St",
    "parcel_id": "116-02-00",
    "owner1": "GUO, LIFEI",
    "owner2": "PANG, TRUDY D",
    "current_taxes": 58461.45,
    "new_taxes_no_override": 60986.98,
    "override_total_1": 62717.44,
    "override_increase_1": 1730.46
  },
  {
    "#": "29 Monmouth St (115-01-00)",
    "$": 9041800,
    "address": "29 Monmouth St",
    "parcel_id": "115-01-00",
    "owner1": "CHURCH OF OUR SAVIOUR",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "47 Monmouth St (114-04-00)",
    "$": 3171100,
    "address": "47 Monmouth St",
    "parcel_id": "114-04-00",
    "owner1": "SEGAL, ADAM",
    "owner2": "PEREYRA, FLORENCIA",
    "current_taxes": 28837.13,
    "new_taxes_no_override": 30082.89,
    "override_total_1": 30936.47,
    "override_increase_1": 853.58
  },
  {
    "#": "49 Monmouth St (114-04-01)",
    "$": 3129100,
    "address": "49 Monmouth St",
    "parcel_id": "114-04-01",
    "owner1": "ELPERIN TRS, ELTON & ANNE",
    "owner2": "",
    "current_taxes": 28407.05,
    "new_taxes_no_override": 29634.23,
    "override_total_1": 30475.08,
    "override_increase_1": 840.85
  },
  {
    "#": "53 Monmouth St (114-05-00)",
    "$": 2509700,
    "address": "53 Monmouth St",
    "parcel_id": "114-05-00",
    "owner1": "LYNN-JONES, KAREN L & SEAN M",
    "owner2": "",
    "current_taxes": 22064.39,
    "new_taxes_no_override": 23017.57,
    "override_total_1": 23670.68,
    "override_increase_1": 653.11
  },
  {
    "#": "55 Monmouth St (114-06-00)",
    "$": 2615800,
    "address": "55 Monmouth St",
    "parcel_id": "114-06-00",
    "owner1": "BROWNSTEIN, JOHN S & CATHERINE A",
    "owner2": "",
    "current_taxes": 23150.86,
    "new_taxes_no_override": 24150.98,
    "override_total_1": 24836.24,
    "override_increase_1": 685.27
  },
  {
    "#": "57 Monmouth St (114-07-00)",
    "$": 2951000,
    "address": "57 Monmouth St",
    "parcel_id": "114-07-00",
    "owner1": "GONEN, YAEL",
    "owner2": "",
    "current_taxes": 30218.24,
    "new_taxes_no_override": 31523.67,
    "override_total_1": 32418.13,
    "override_increase_1": 894.46
  },
  {
    "#": "58 Monmouth St (112-35-00)",
    "$": 6834500,
    "address": "58 Monmouth St",
    "parcel_id": "112-35-00",
    "owner1": "PESKIN TRS, CRAIG D & BIANCA K",
    "owner2": "",
    "current_taxes": 66350.35,
    "new_taxes_no_override": 69216.69,
    "override_total_1": 71180.66,
    "override_increase_1": 1963.97
  },
  {
    "#": "59 Monmouth St (114-08-00)",
    "$": 2670600,
    "address": "59 Monmouth St",
    "parcel_id": "114-08-00",
    "owner1": "MACKINNON, DAVID & CATHERINE",
    "owner2": "",
    "current_taxes": 23712.01,
    "new_taxes_no_override": 24736.37,
    "override_total_1": 25438.24,
    "override_increase_1": 701.88
  },
  {
    "#": "61 Monmouth St (114-09-00)",
    "$": 3113200,
    "address": "61 Monmouth St",
    "parcel_id": "114-09-00",
    "owner1": "KING TR, LISA R",
    "owner2": "",
    "current_taxes": 28244.23,
    "new_taxes_no_override": 29464.38,
    "override_total_1": 30300.41,
    "override_increase_1": 836.03
  },
  {
    "#": "68 Monmouth St, Unit 1 (112-34-02)",
    "$": 1973500,
    "address": "68 Monmouth St, Unit 1",
    "parcel_id": "112-34-02",
    "owner1": "PERELMAN, LEV & OLGA",
    "owner2": "",
    "current_taxes": 16573.71,
    "new_taxes_no_override": 17289.69,
    "override_total_1": 17780.28,
    "override_increase_1": 490.58
  },
  {
    "#": "68 Monmouth St, Unit 2 (112-34-01)",
    "$": 1537600,
    "address": "68 Monmouth St, Unit 2",
    "parcel_id": "112-34-01",
    "owner1": "LINDSAY, ANDREA T",
    "owner2": "",
    "current_taxes": 12110.09,
    "new_taxes_no_override": 12633.25,
    "override_total_1": 12991.7,
    "override_increase_1": 358.46
  },
  {
    "#": "69 Monmouth St (113-07-00)",
    "$": 3355600,
    "address": "69 Monmouth St",
    "parcel_id": "113-07-00",
    "owner1": "PENZIAS, ALAN",
    "owner2": "KING, LOUISE",
    "current_taxes": 30726.41,
    "new_taxes_no_override": 32053.79,
    "override_total_1": 32963.29,
    "override_increase_1": 909.5
  },
  {
    "#": "71 Monmouth St (113-08-00)",
    "$": 2893000,
    "address": "71 Monmouth St",
    "parcel_id": "113-08-00",
    "owner1": "KOBLAN TR, MARILYN C",
    "owner2": "",
    "current_taxes": 25989.39,
    "new_taxes_no_override": 27112.13,
    "override_total_1": 27881.42,
    "override_increase_1": 769.29
  },
  {
    "#": "73 Monmouth St (113-09-00)",
    "$": 3206400,
    "address": "73 Monmouth St",
    "parcel_id": "113-09-00",
    "owner1": "KELLIS, MANOLIS",
    "owner2": "GUILLAUD, LUCILE M",
    "current_taxes": 29198.6,
    "new_taxes_no_override": 30459.98,
    "override_total_1": 31324.26,
    "override_increase_1": 864.28
  },
  {
    "#": "74 Monmouth St (112-33-00)",
    "$": 3366300,
    "address": "74 Monmouth St",
    "parcel_id": "112-33-00",
    "owner1": "TATE, JEFFREY B &ELIZABETH KANE",
    "owner2": "",
    "current_taxes": 30835.98,
    "new_taxes_no_override": 32168.09,
    "override_total_1": 33080.84,
    "override_increase_1": 912.75
  },
  {
    "#": "75 Monmouth St (113-10-00)",
    "$": 2951300,
    "address": "75 Monmouth St",
    "parcel_id": "113-10-00",
    "owner1": "SKULSTAD, PETTER & HELENE",
    "owner2": "",
    "current_taxes": 26586.38,
    "new_taxes_no_override": 27734.91,
    "override_total_1": 28521.87,
    "override_increase_1": 786.96
  },
  {
    "#": "76 Monmouth St (112-32-00)",
    "$": 3296100,
    "address": "76 Monmouth St",
    "parcel_id": "112-32-00",
    "owner1": "MACLAY, WILLIAM & NICOLE",
    "owner2": "",
    "current_taxes": 30117.13,
    "new_taxes_no_override": 31418.19,
    "override_total_1": 32309.66,
    "override_increase_1": 891.47
  },
  {
    "#": "77 Monmouth St (113-11-00)",
    "$": 3531200,
    "address": "77 Monmouth St",
    "parcel_id": "113-11-00",
    "owner1": "ZIMMAN, MARC",
    "owner2": "DOME ZIMMAN, SARAH MARTHA",
    "current_taxes": 32524.55,
    "new_taxes_no_override": 33929.61,
    "override_total_1": 34892.34,
    "override_increase_1": 962.73
  },
  {
    "#": "78 Monmouth St (112-31-00)",
    "$": 2988200,
    "address": "78 Monmouth St",
    "parcel_id": "112-31-00",
    "owner1": "KEANE TRS, TERENCE M",
    "owner2": "HUGHES, DOUGLAS H",
    "current_taxes": 26964.23,
    "new_taxes_no_override": 28129.08,
    "override_total_1": 28927.23,
    "override_increase_1": 798.14
  },
  {
    "#": "80 Monmouth St (112-30-00)",
    "$": 2652800,
    "address": "80 Monmouth St",
    "parcel_id": "112-30-00",
    "owner1": "NADO, ZACHARY",
    "owner2": "DOIRON, KAILYN",
    "current_taxes": 27164.67,
    "new_taxes_no_override": 28338.18,
    "override_total_1": 29142.26,
    "override_increase_1": 804.07
  },
  {
    "#": "82 Monmouth St (112-29-00)",
    "$": 3505200,
    "address": "82 Monmouth St",
    "parcel_id": "112-29-00",
    "owner1": "PAYNE TRS, JONATHAN",
    "owner2": "CARSON, ANITA",
    "current_taxes": 35893.25,
    "new_taxes_no_override": 37443.84,
    "override_total_1": 38506.28,
    "override_increase_1": 1062.44
  },
  {
    "#": "86 Monmouth St (112-28-00)",
    "$": 2768000,
    "address": "86 Monmouth St",
    "parcel_id": "112-28-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O ARTS CENTER",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "90 Monmouth St (112-27-00)",
    "$": 85900,
    "address": "90 Monmouth St",
    "parcel_id": "112-27-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O MONMOUTH PARK",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "101 Monmouth St (113-12-00)",
    "$": 65328800,
    "address": "101 Monmouth St",
    "parcel_id": "113-12-00",
    "owner1": "101 MONMOUTH STREET LLC",
    "owner2": "",
    "current_taxes": 668966.91,
    "new_taxes_no_override": 697866.28,
    "override_total_1": 717667.7,
    "override_increase_1": 19801.42
  },
  {
    "#": " Monmouth St (113-07-01)",
    "$": 160800,
    "address": " Monmouth St",
    "parcel_id": "113-07-01",
    "owner1": "PENZIAS ET AL, ALAN",
    "owner2": "KING, LOUISE",
    "current_taxes": 1646.59,
    "new_taxes_no_override": 1717.72,
    "override_total_1": 1766.46,
    "override_increase_1": 48.74
  },
  {
    "#": " Monmouth St (113-09-01)",
    "$": 217200,
    "address": " Monmouth St",
    "parcel_id": "113-09-01",
    "owner1": "KELLIS, MANOLIS",
    "owner2": "GUILLAUD, LUCILE M",
    "current_taxes": 2224.13,
    "new_taxes_no_override": 2320.21,
    "override_total_1": 2386.05,
    "override_increase_1": 65.83
  },
  {
    "#": " Monmouth St (113-10-02)",
    "$": 78800,
    "address": " Monmouth St",
    "parcel_id": "113-10-02",
    "owner1": "KOBLAN TR, MARILYN C",
    "owner2": "",
    "current_taxes": 806.91,
    "new_taxes_no_override": 841.77,
    "override_total_1": 865.65,
    "override_increase_1": 23.88
  },
  {
    "#": " Monmouth St (113-10-03)",
    "$": 78800,
    "address": " Monmouth St",
    "parcel_id": "113-10-03",
    "owner1": "JACKSON, ANGELA DENISE",
    "owner2": "TERNAN, CHRISTOPHER",
    "current_taxes": 806.91,
    "new_taxes_no_override": 841.77,
    "override_total_1": 865.65,
    "override_increase_1": 23.88
  },
  {
    "#": " Monmouth St (113-10-04)",
    "$": 78800,
    "address": " Monmouth St",
    "parcel_id": "113-10-04",
    "owner1": "SKULSTAD, PETTER & HELENE",
    "owner2": "",
    "current_taxes": 806.91,
    "new_taxes_no_override": 841.77,
    "override_total_1": 865.65,
    "override_increase_1": 23.88
  },
  {
    "#": " Monmouth St (113-10-05)",
    "$": 78800,
    "address": " Monmouth St",
    "parcel_id": "113-10-05",
    "owner1": "SKULSTAD, PETTER & HELENE",
    "owner2": "",
    "current_taxes": 806.91,
    "new_taxes_no_override": 841.77,
    "override_total_1": 865.65,
    "override_increase_1": 23.88
  },
  {
    "#": " Monmouth St (113-11-01)",
    "$": 147500,
    "address": " Monmouth St",
    "parcel_id": "113-11-01",
    "owner1": "ZIMMAN, MARC",
    "owner2": "DOME ZIMMAN, SARAH MARTHA",
    "current_taxes": 1510.4,
    "new_taxes_no_override": 1575.65,
    "override_total_1": 1620.36,
    "override_increase_1": 44.71
  },
  {
    "#": "138 Mountfort St (005-03-00)",
    "$": 3245100,
    "address": "138 Mountfort St",
    "parcel_id": "005-03-00",
    "owner1": "BOSTON UNIVERSITY TRS",
    "owner2": "C/O GENERAL ACCOUNTING 4TH FLR",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "150 Mountfort St (005-02-00)",
    "$": 2382100,
    "address": "150 Mountfort St",
    "parcel_id": "005-02-00",
    "owner1": "BOSTON UNIVERSITY TRS",
    "owner2": "C/O GENERAL ACCOUNTING 4TH FLR",
    "current_taxes": 24392.7,
    "new_taxes_no_override": 25446.46,
    "override_total_1": 26168.49,
    "override_increase_1": 722.02
  },
  {
    "#": "3 Mulford St, Unit 1 (317-22-01)",
    "$": 730100,
    "address": "3 Mulford St, Unit 1",
    "parcel_id": "317-22-01",
    "owner1": "BAPHNA, JAIDEEP J",
    "owner2": "",
    "current_taxes": 7476.22,
    "new_taxes_no_override": 7799.19,
    "override_total_1": 8020.49,
    "override_increase_1": 221.3
  },
  {
    "#": "3 Mulford St, Unit 2 (317-22-02)",
    "$": 748700,
    "address": "3 Mulford St, Unit 2",
    "parcel_id": "317-22-02",
    "owner1": "WANG, GRACE & YUSHIEN",
    "owner2": "",
    "current_taxes": 4031.75,
    "new_taxes_no_override": 4205.92,
    "override_total_1": 4325.26,
    "override_increase_1": 119.34
  },
  {
    "#": "3 Mulford St, Unit 3 (317-22-03)",
    "$": 1083400,
    "address": "3 Mulford St, Unit 3",
    "parcel_id": "317-22-03",
    "owner1": "WESEMANN, DUANE R & SANDRA C",
    "owner2": "",
    "current_taxes": 7459.08,
    "new_taxes_no_override": 7781.31,
    "override_total_1": 8002.1,
    "override_increase_1": 220.79
  },
  {
    "#": "7 Mulford St (317-23-00)",
    "$": 1722800,
    "address": "7 Mulford St",
    "parcel_id": "317-23-00",
    "owner1": "7 MULFORD LLC",
    "owner2": "",
    "current_taxes": 17641.47,
    "new_taxes_no_override": 18403.58,
    "override_total_1": 18925.77,
    "override_increase_1": 522.19
  },
  {
    "#": "9 Mulford St (317-24-00)",
    "$": 1743500,
    "address": "9 Mulford St",
    "parcel_id": "317-24-00",
    "owner1": "LEE, TRS, FRANCES S KUEN & ESTELLA",
    "owner2": "",
    "current_taxes": 14218.51,
    "new_taxes_no_override": 14832.75,
    "override_total_1": 15253.62,
    "override_increase_1": 420.87
  },
  {
    "#": "8 Naples Rd, Unit 1 (064-08-01)",
    "$": 1409000,
    "address": "8 Naples Rd, Unit 1",
    "parcel_id": "064-08-01",
    "owner1": "OFFNER, OLIVIA",
    "owner2": "MORAIS, ISABEL",
    "current_taxes": 14428.16,
    "new_taxes_no_override": 15051.46,
    "override_total_1": 15478.53,
    "override_increase_1": 427.07
  },
  {
    "#": "8 Naples Rd, Unit 2 (064-08-02)",
    "$": 1919500,
    "address": "8 Naples Rd, Unit 2",
    "parcel_id": "064-08-02",
    "owner1": "PRICE, GEORGE",
    "owner2": "",
    "current_taxes": 16020.75,
    "new_taxes_no_override": 16712.85,
    "override_total_1": 17187.06,
    "override_increase_1": 474.21
  },
  {
    "#": "11 Naples Rd (051-05-00)",
    "$": 1993900,
    "address": "11 Naples Rd",
    "parcel_id": "051-05-00",
    "owner1": "SLOMIAK, CHRISTOPHER",
    "owner2": "SLOMIAK TRS, MING CHOU & JACKSON C",
    "current_taxes": 16782.6,
    "new_taxes_no_override": 17507.61,
    "override_total_1": 18004.37,
    "override_increase_1": 496.76
  },
  {
    "#": "12 Naples Rd (064-07-00)",
    "$": 2173500,
    "address": "12 Naples Rd",
    "parcel_id": "064-07-00",
    "owner1": "635 CHESTNUT HILL AVE REAL ESTATE DEVELOPMENT LLC",
    "owner2": "",
    "current_taxes": 22256.64,
    "new_taxes_no_override": 23218.13,
    "override_total_1": 23876.92,
    "override_increase_1": 658.8
  },
  {
    "#": "15 Naples Rd (051-06-00)",
    "$": 2354500,
    "address": "15 Naples Rd",
    "parcel_id": "051-06-00",
    "owner1": "SAND, DAVID F & JOCELYN H",
    "owner2": "",
    "current_taxes": 20475.15,
    "new_taxes_no_override": 21359.68,
    "override_total_1": 21965.74,
    "override_increase_1": 606.06
  },
  {
    "#": "18 Naples Rd (064-06-00)",
    "$": 2449400,
    "address": "18 Naples Rd",
    "parcel_id": "064-06-00",
    "owner1": "STONE SQUARE BROOKLINE LLC",
    "owner2": "",
    "current_taxes": 25081.86,
    "new_taxes_no_override": 26165.4,
    "override_total_1": 26907.82,
    "override_increase_1": 742.42
  },
  {
    "#": "21 Naples Rd, Unit 1 (051-07-01)",
    "$": 2184600,
    "address": "21 Naples Rd, Unit 1",
    "parcel_id": "051-07-01",
    "owner1": "PARK, HAESEONG",
    "owner2": "",
    "current_taxes": 22370.3,
    "new_taxes_no_override": 23336.7,
    "override_total_1": 23998.86,
    "override_increase_1": 662.16
  },
  {
    "#": "21 Naples Rd, Unit 2 (051-07-02)",
    "$": 2391500,
    "address": "21 Naples Rd, Unit 2",
    "parcel_id": "051-07-02",
    "owner1": "ALKALAY, YAEL",
    "owner2": "BAKMAN, VADIM",
    "current_taxes": 20854.03,
    "new_taxes_no_override": 21754.92,
    "override_total_1": 22372.2,
    "override_increase_1": 617.28
  },
  {
    "#": "23 Naples Rd (051-08-00)",
    "$": 2815700,
    "address": "23 Naples Rd",
    "parcel_id": "051-08-00",
    "owner1": "SHASHOUA, EDWARD V & FRANCES K",
    "owner2": "",
    "current_taxes": 28832.77,
    "new_taxes_no_override": 30078.35,
    "override_total_1": 30931.8,
    "override_increase_1": 853.45
  },
  {
    "#": "24 Naples Rd (064-05-00)",
    "$": 2619600,
    "address": "24 Naples Rd",
    "parcel_id": "064-05-00",
    "owner1": "KAHN TR, MARJORIE S",
    "owner2": "",
    "current_taxes": 23189.77,
    "new_taxes_no_override": 24191.57,
    "override_total_1": 24877.99,
    "override_increase_1": 686.42
  },
  {
    "#": "29 Naples Rd (051-09-00)",
    "$": 2597400,
    "address": "29 Naples Rd",
    "parcel_id": "051-09-00",
    "owner1": "ADAMEK, ADAM",
    "owner2": "MARA, MEGAN S",
    "current_taxes": 22962.44,
    "new_taxes_no_override": 23954.42,
    "override_total_1": 24634.11,
    "override_increase_1": 679.69
  },
  {
    "#": "30 Naples Rd, Unit 1 & P1 (064-04-01)",
    "$": 1900400,
    "address": "30 Naples Rd, Unit 1 & P1",
    "parcel_id": "064-04-01",
    "owner1": "BUTCHER, DAVID",
    "owner2": "STERN, JULIE ELIZABETH",
    "current_taxes": 19460.1,
    "new_taxes_no_override": 20300.78,
    "override_total_1": 20876.8,
    "override_increase_1": 576.02
  },
  {
    "#": "30 Naples Rd, Unit 2 & P2-P3 (064-04-02)",
    "$": 2278700,
    "address": "30 Naples Rd, Unit 2 & P2-P3",
    "parcel_id": "064-04-02",
    "owner1": "TRACHTENBERG, BENJAMIN G & MOLLY E",
    "owner2": "",
    "current_taxes": 19698.95,
    "new_taxes_no_override": 20549.94,
    "override_total_1": 21133.03,
    "override_increase_1": 583.09
  },
  {
    "#": "33 Naples Rd (051-10-00)",
    "$": 3149600,
    "address": "33 Naples Rd",
    "parcel_id": "051-10-00",
    "owner1": "GERTNER, NIR & RONA",
    "owner2": "",
    "current_taxes": 28616.97,
    "new_taxes_no_override": 29853.22,
    "override_total_1": 30700.29,
    "override_increase_1": 847.06
  },
  {
    "#": "36 Naples Rd (064-03-00)",
    "$": 3584400,
    "address": "36 Naples Rd",
    "parcel_id": "064-03-00",
    "owner1": "PANG, CONGCONG",
    "owner2": "",
    "current_taxes": 36704.26,
    "new_taxes_no_override": 38289.88,
    "override_total_1": 39376.33,
    "override_increase_1": 1086.45
  },
  {
    "#": "40 Naples Rd (064-02-00)",
    "$": 4532000,
    "address": "40 Naples Rd",
    "parcel_id": "064-02-00",
    "owner1": "ALIREZAEI, VAHID A",
    "owner2": "",
    "current_taxes": 42772.75,
    "new_taxes_no_override": 44620.53,
    "override_total_1": 45886.61,
    "override_increase_1": 1266.07
  },
  {
    "#": "41 Naples Rd (051-11-01)",
    "$": 2930500,
    "address": "41 Naples Rd",
    "parcel_id": "051-11-01",
    "owner1": "LEVINE TRS, MATTHEW",
    "owner2": "WEBSTER, GILLIAN",
    "current_taxes": 26373.39,
    "new_taxes_no_override": 27512.72,
    "override_total_1": 28293.37,
    "override_increase_1": 780.65
  },
  {
    "#": "43 Naples Rd, Unit 43 (051-11-03)",
    "$": 1700000,
    "address": "43 Naples Rd, Unit 43",
    "parcel_id": "051-11-03",
    "owner1": "YUE, JIE",
    "owner2": "",
    "current_taxes": 17408.0,
    "new_taxes_no_override": 18160.03,
    "override_total_1": 18675.3,
    "override_increase_1": 515.28
  },
  {
    "#": "45 Naples Rd, Unit 45 (051-11-04)",
    "$": 1713300,
    "address": "45 Naples Rd, Unit 45",
    "parcel_id": "051-11-04",
    "owner1": "LISSY TR, NATALIE A",
    "owner2": "",
    "current_taxes": 13909.26,
    "new_taxes_no_override": 14510.14,
    "override_total_1": 14921.85,
    "override_increase_1": 411.71
  },
  {
    "#": "46 Naples Rd (064-01-00)",
    "$": 3116600,
    "address": "46 Naples Rd",
    "parcel_id": "064-01-00",
    "owner1": "GIBSON, SAMUEL H & CATHY L",
    "owner2": "",
    "current_taxes": 28279.05,
    "new_taxes_no_override": 29500.7,
    "override_total_1": 30337.76,
    "override_increase_1": 837.06
  },
  {
    "#": "47 Naples Rd (051-12-00)",
    "$": 2313900,
    "address": "47 Naples Rd",
    "parcel_id": "051-12-00",
    "owner1": "FRIED, ALAN C",
    "owner2": "BRUE, ANDREA L",
    "current_taxes": 20059.4,
    "new_taxes_no_override": 20925.97,
    "override_total_1": 21519.72,
    "override_increase_1": 593.76
  },
  {
    "#": "50 Naples Rd (063-14-00)",
    "$": 4035700,
    "address": "50 Naples Rd",
    "parcel_id": "063-14-00",
    "owner1": "NAPLES ROAD LLC",
    "owner2": "",
    "current_taxes": 41325.57,
    "new_taxes_no_override": 43110.83,
    "override_total_1": 44334.07,
    "override_increase_1": 1223.24
  },
  {
    "#": "51 Naples Rd (051-13-00)",
    "$": 2896800,
    "address": "51 Naples Rd",
    "parcel_id": "051-13-00",
    "owner1": "LEADER, KRISTIN",
    "owner2": "",
    "current_taxes": 29663.23,
    "new_taxes_no_override": 30944.68,
    "override_total_1": 31822.71,
    "override_increase_1": 878.03
  },
  {
    "#": "54 Naples Rd (063-13-00)",
    "$": 3278600,
    "address": "54 Naples Rd",
    "parcel_id": "063-13-00",
    "owner1": "GRINNELL, RICHARD",
    "owner2": "TALJE, ZEINA",
    "current_taxes": 29937.93,
    "new_taxes_no_override": 31231.25,
    "override_total_1": 32117.41,
    "override_increase_1": 886.16
  },
  {
    "#": "55 Naples Rd (051-14-00)",
    "$": 2699000,
    "address": "55 Naples Rd",
    "parcel_id": "051-14-00",
    "owner1": "HUTNER TRS, JEREMY E",
    "owner2": "EDELL, DAWN R",
    "current_taxes": 24002.83,
    "new_taxes_no_override": 25039.75,
    "override_total_1": 25750.24,
    "override_increase_1": 710.48
  },
  {
    "#": "59 Naples Rd (051-15-00)",
    "$": 2304400,
    "address": "59 Naples Rd",
    "parcel_id": "051-15-00",
    "owner1": "KROLL TRS, MARK R & CAROL LIEBERMAN",
    "owner2": "",
    "current_taxes": 19962.12,
    "new_taxes_no_override": 20824.48,
    "override_total_1": 21415.36,
    "override_increase_1": 590.88
  },
  {
    "#": "60 Naples Rd (063-12-00)",
    "$": 2267200,
    "address": "60 Naples Rd",
    "parcel_id": "063-12-00",
    "owner1": "HULBERT, JONATHAN H",
    "owner2": "HOFKOSH, SONIA",
    "current_taxes": 19581.19,
    "new_taxes_no_override": 20427.1,
    "override_total_1": 21006.7,
    "override_increase_1": 579.6
  },
  {
    "#": "64 Naples Rd (063-11-00)",
    "$": 4823300,
    "address": "64 Naples Rd",
    "parcel_id": "063-11-00",
    "owner1": "KUBAT, RONY",
    "owner2": "STEWART, MICHELLE",
    "current_taxes": 45755.66,
    "new_taxes_no_override": 47732.3,
    "override_total_1": 49086.67,
    "override_increase_1": 1354.37
  },
  {
    "#": "65 Naples Rd (051-16-00)",
    "$": 1872700,
    "address": "65 Naples Rd",
    "parcel_id": "051-16-00",
    "owner1": "HNATOWICH TRS, DONALD & MARCIA",
    "owner2": "",
    "current_taxes": 15541.51,
    "new_taxes_no_override": 16212.9,
    "override_total_1": 16672.93,
    "override_increase_1": 460.03
  },
  {
    "#": "68 Naples Rd (063-10-00)",
    "$": 4563100,
    "address": "68 Naples Rd",
    "parcel_id": "063-10-00",
    "owner1": "GOTTFRIED, GUY & MIRI ALLA",
    "owner2": "",
    "current_taxes": 43091.21,
    "new_taxes_no_override": 44952.75,
    "override_total_1": 46228.25,
    "override_increase_1": 1275.5
  },
  {
    "#": "69 Naples Rd (051-17-00)",
    "$": 3086500,
    "address": "69 Naples Rd",
    "parcel_id": "051-17-00",
    "owner1": "CHEUNG, CHAU-YIP KITTY",
    "owner2": "ZILLA, CHRISTOPHER MATTHEW",
    "current_taxes": 27970.83,
    "new_taxes_no_override": 29179.17,
    "override_total_1": 30007.11,
    "override_increase_1": 827.94
  },
  {
    "#": "73 Naples Rd (051-18-00)",
    "$": 2971000,
    "address": "73 Naples Rd",
    "parcel_id": "051-18-00",
    "owner1": "BLEIMES, ASHLEY",
    "owner2": "WILFONG, CHRISTOPHER",
    "current_taxes": 26788.11,
    "new_taxes_no_override": 27945.36,
    "override_total_1": 28738.28,
    "override_increase_1": 792.93
  },
  {
    "#": "74 Naples Rd (063-09-00)",
    "$": 2596500,
    "address": "74 Naples Rd",
    "parcel_id": "063-09-00",
    "owner1": "ZYSOW, SALA",
    "owner2": "",
    "current_taxes": 22953.23,
    "new_taxes_no_override": 23944.81,
    "override_total_1": 24624.23,
    "override_increase_1": 679.42
  },
  {
    "#": "79 Naples Rd (051-19-00)",
    "$": 2327200,
    "address": "79 Naples Rd",
    "parcel_id": "051-19-00",
    "owner1": "HERSCOVICI, STEVEN",
    "owner2": "BARE, TRACY V",
    "current_taxes": 23830.53,
    "new_taxes_no_override": 24860.01,
    "override_total_1": 25565.39,
    "override_increase_1": 705.38
  },
  {
    "#": "82 Naples Rd (063-08-00)",
    "$": 1810200,
    "address": "82 Naples Rd",
    "parcel_id": "063-08-00",
    "owner1": "MILLER, SHEL J & DEBORAH G",
    "owner2": "",
    "current_taxes": 14901.51,
    "new_taxes_no_override": 15545.26,
    "override_total_1": 15986.34,
    "override_increase_1": 441.08
  },
  {
    "#": "85 Naples Rd (051-20-00)",
    "$": 2681800,
    "address": "85 Naples Rd",
    "parcel_id": "051-20-00",
    "owner1": "85 NAPLES ROAD LLC",
    "owner2": "",
    "current_taxes": 27461.63,
    "new_taxes_no_override": 28647.97,
    "override_total_1": 29460.84,
    "override_increase_1": 812.86
  },
  {
    "#": "88 Naples Rd, Unit 1 (063-07-06)",
    "$": 727500,
    "address": "88 Naples Rd, Unit 1",
    "parcel_id": "063-07-06",
    "owner1": "ABRAHAMS, JASON B",
    "owner2": "NORMANDIN, JACQUELINE",
    "current_taxes": 3814.67,
    "new_taxes_no_override": 3979.46,
    "override_total_1": 4092.38,
    "override_increase_1": 112.91
  },
  {
    "#": "88 Naples Rd, Unit 2 (063-07-01)",
    "$": 618300,
    "address": "88 Naples Rd, Unit 2",
    "parcel_id": "063-07-01",
    "owner1": "CHOREIM, HUSSEIN A",
    "owner2": "",
    "current_taxes": 6331.39,
    "new_taxes_no_override": 6604.91,
    "override_total_1": 6792.32,
    "override_increase_1": 187.41
  },
  {
    "#": "88 Naples Rd, Unit 3 (063-07-02)",
    "$": 731500,
    "address": "88 Naples Rd, Unit 3",
    "parcel_id": "063-07-02",
    "owner1": "PECOT, MATTHEW YASUO",
    "owner2": "CHEN, YI",
    "current_taxes": 3855.63,
    "new_taxes_no_override": 4022.19,
    "override_total_1": 4136.32,
    "override_increase_1": 114.13
  },
  {
    "#": "88 Naples Rd, Unit 4 (063-07-03)",
    "$": 640300,
    "address": "88 Naples Rd, Unit 4",
    "parcel_id": "063-07-03",
    "owner1": "KALLMERTEN TRS, DANIEL H & PAMELA S",
    "owner2": "",
    "current_taxes": 6556.67,
    "new_taxes_no_override": 6839.92,
    "override_total_1": 7034.0,
    "override_increase_1": 194.08
  },
  {
    "#": "88 Naples Rd, Unit 5 (063-07-04)",
    "$": 727600,
    "address": "88 Naples Rd, Unit 5",
    "parcel_id": "063-07-04",
    "owner1": "JEWETT, ALEXANDER NELSON",
    "owner2": "",
    "current_taxes": 3815.69,
    "new_taxes_no_override": 3980.53,
    "override_total_1": 4093.47,
    "override_increase_1": 112.94
  },
  {
    "#": "88 Naples Rd, Unit 6 (063-07-05)",
    "$": 631100,
    "address": "88 Naples Rd, Unit 6",
    "parcel_id": "063-07-05",
    "owner1": "QIU, YILING",
    "owner2": "FANG, ZI",
    "current_taxes": 6462.46,
    "new_taxes_no_override": 6741.64,
    "override_total_1": 6932.93,
    "override_increase_1": 191.29
  },
  {
    "#": "89 Naples Rd (051-21-00)",
    "$": 2717700,
    "address": "89 Naples Rd",
    "parcel_id": "051-21-00",
    "owner1": "ARNOLDI, REBECCA-HARRIET G-RICHARD",
    "owner2": "",
    "current_taxes": 24194.31,
    "new_taxes_no_override": 25239.5,
    "override_total_1": 25955.66,
    "override_increase_1": 716.15
  },
  {
    "#": "90 Naples Rd, Unit 1 (063-06-06)",
    "$": 595000,
    "address": "90 Naples Rd, Unit 1",
    "parcel_id": "063-06-06",
    "owner1": "NOSPAL, TINA",
    "owner2": "",
    "current_taxes": 6092.8,
    "new_taxes_no_override": 6356.01,
    "override_total_1": 6536.36,
    "override_increase_1": 180.35
  },
  {
    "#": "90 Naples Rd, Unit 2 (063-06-01)",
    "$": 657100,
    "address": "90 Naples Rd, Unit 2",
    "parcel_id": "063-06-01",
    "owner1": "MALAKOV, ANDREY",
    "owner2": "SOKOLOVA, MARINA",
    "current_taxes": 6728.7,
    "new_taxes_no_override": 7019.38,
    "override_total_1": 7218.55,
    "override_increase_1": 199.17
  },
  {
    "#": "90 Naples Rd, Unit 3 (063-06-02)",
    "$": 643700,
    "address": "90 Naples Rd, Unit 3",
    "parcel_id": "063-06-02",
    "owner1": "CHANG, CHIEH",
    "owner2": "C/O KATHLEEN JOY ALEXANDER",
    "current_taxes": 6591.49,
    "new_taxes_no_override": 6876.24,
    "override_total_1": 7071.35,
    "override_increase_1": 195.11
  },
  {
    "#": "90 Naples Rd, Unit 4 (063-06-03)",
    "$": 650400,
    "address": "90 Naples Rd, Unit 4",
    "parcel_id": "063-06-03",
    "owner1": "SIEH, REGINA E",
    "owner2": "",
    "current_taxes": 3025.16,
    "new_taxes_no_override": 3155.85,
    "override_total_1": 3245.39,
    "override_increase_1": 89.54
  },
  {
    "#": "90 Naples Rd, Unit 5 (063-06-04)",
    "$": 643700,
    "address": "90 Naples Rd, Unit 5",
    "parcel_id": "063-06-04",
    "owner1": "BERMAN, STUART",
    "owner2": "ZAHAROVITS, ILEANA",
    "current_taxes": 6591.49,
    "new_taxes_no_override": 6876.24,
    "override_total_1": 7071.35,
    "override_increase_1": 195.11
  },
  {
    "#": "90 Naples Rd, Unit 6 (063-06-05)",
    "$": 650400,
    "address": "90 Naples Rd, Unit 6",
    "parcel_id": "063-06-05",
    "owner1": "HUTCHINSON TR, SCOTT",
    "owner2": "",
    "current_taxes": 6660.1,
    "new_taxes_no_override": 6947.82,
    "override_total_1": 7144.96,
    "override_increase_1": 197.14
  },
  {
    "#": "94 Naples Rd, Unit 1 (063-05-06)",
    "$": 599400,
    "address": "94 Naples Rd, Unit 1",
    "parcel_id": "063-05-06",
    "owner1": "KOLA TR, SANDYA",
    "owner2": "",
    "current_taxes": 6137.86,
    "new_taxes_no_override": 6403.02,
    "override_total_1": 6584.7,
    "override_increase_1": 181.68
  },
  {
    "#": "94 Naples Rd, Unit 2 (063-05-01)",
    "$": 647800,
    "address": "94 Naples Rd, Unit 2",
    "parcel_id": "063-05-01",
    "owner1": "SHORE, STEPHEN M & LIU YI",
    "owner2": "",
    "current_taxes": 6633.47,
    "new_taxes_no_override": 6920.04,
    "override_total_1": 7116.39,
    "override_increase_1": 196.35
  },
  {
    "#": "94 Naples Rd, Unit 3 (063-05-02)",
    "$": 650000,
    "address": "94 Naples Rd, Unit 3",
    "parcel_id": "063-05-02",
    "owner1": "SPINO, GREGORY A",
    "owner2": "DUGGAN, PATRICIA",
    "current_taxes": 6656.0,
    "new_taxes_no_override": 6943.54,
    "override_total_1": 7140.56,
    "override_increase_1": 197.02
  },
  {
    "#": "94 Naples Rd, Unit 4 (063-05-03)",
    "$": 646000,
    "address": "94 Naples Rd, Unit 4",
    "parcel_id": "063-05-03",
    "owner1": "MARINKOVIC, MARINA & ALEKSANDAR",
    "owner2": "",
    "current_taxes": 2980.11,
    "new_taxes_no_override": 3108.85,
    "override_total_1": 3197.06,
    "override_increase_1": 88.21
  },
  {
    "#": "94 Naples Rd, Unit 5 (063-05-04)",
    "$": 660300,
    "address": "94 Naples Rd, Unit 5",
    "parcel_id": "063-05-04",
    "owner1": "CAI, LIWEN",
    "owner2": "",
    "current_taxes": 3126.54,
    "new_taxes_no_override": 3261.61,
    "override_total_1": 3354.15,
    "override_increase_1": 92.55
  },
  {
    "#": "94 Naples Rd, Unit 6 (063-05-05)",
    "$": 646100,
    "address": "94 Naples Rd, Unit 6",
    "parcel_id": "063-05-05",
    "owner1": "DEISADZE, DAVID",
    "owner2": "",
    "current_taxes": 6616.06,
    "new_taxes_no_override": 6901.87,
    "override_total_1": 7097.71,
    "override_increase_1": 195.84
  },
  {
    "#": "96 Naples Rd, Unit 1 (063-04-06)",
    "$": 595000,
    "address": "96 Naples Rd, Unit 1",
    "parcel_id": "063-04-06",
    "owner1": "CHENG, FANG",
    "owner2": "CAO, SICHENG",
    "current_taxes": 6092.8,
    "new_taxes_no_override": 6356.01,
    "override_total_1": 6536.36,
    "override_increase_1": 180.35
  },
  {
    "#": "96 Naples Rd, Unit 2 (063-04-01)",
    "$": 657000,
    "address": "96 Naples Rd, Unit 2",
    "parcel_id": "063-04-01",
    "owner1": "KANSOUN, RANIA",
    "owner2": "",
    "current_taxes": 3092.75,
    "new_taxes_no_override": 3226.36,
    "override_total_1": 3317.9,
    "override_increase_1": 91.55
  },
  {
    "#": "96 Naples Rd, Unit 3 (063-04-02)",
    "$": 659000,
    "address": "96 Naples Rd, Unit 3",
    "parcel_id": "063-04-02",
    "owner1": "CHENG, FANG",
    "owner2": "",
    "current_taxes": 6748.16,
    "new_taxes_no_override": 7039.68,
    "override_total_1": 7239.43,
    "override_increase_1": 199.75
  },
  {
    "#": "96 Naples Rd, Unit 4 (063-04-03)",
    "$": 650400,
    "address": "96 Naples Rd, Unit 4",
    "parcel_id": "063-04-03",
    "owner1": "EYAL, ELIA",
    "owner2": "",
    "current_taxes": 6660.1,
    "new_taxes_no_override": 6947.82,
    "override_total_1": 7144.96,
    "override_increase_1": 197.14
  },
  {
    "#": "96 Naples Rd, Unit 5 (063-04-04)",
    "$": 643700,
    "address": "96 Naples Rd, Unit 5",
    "parcel_id": "063-04-04",
    "owner1": "96-5 NAPLES ROAD LLC",
    "owner2": "C/O INVEST PROPERTIES",
    "current_taxes": 6591.49,
    "new_taxes_no_override": 6876.24,
    "override_total_1": 7071.35,
    "override_increase_1": 195.11
  },
  {
    "#": "96 Naples Rd, Unit 6 (063-04-05)",
    "$": 650400,
    "address": "96 Naples Rd, Unit 6",
    "parcel_id": "063-04-05",
    "owner1": "NORTON, MAYA",
    "owner2": "",
    "current_taxes": 3025.16,
    "new_taxes_no_override": 3155.85,
    "override_total_1": 3245.39,
    "override_increase_1": 89.54
  },
  {
    "#": "100 Naples Rd (063-03-00)",
    "$": 2979300,
    "address": "100 Naples Rd",
    "parcel_id": "063-03-00",
    "owner1": "GABEL, ETTA S",
    "owner2": "C/O DAVID WOOD R E SERVICES",
    "current_taxes": 30508.03,
    "new_taxes_no_override": 31825.98,
    "override_total_1": 32729.01,
    "override_increase_1": 903.04
  },
  {
    "#": "102 Naples Rd (063-02-00)",
    "$": 4063100,
    "address": "102 Naples Rd",
    "parcel_id": "063-02-00",
    "owner1": "GABEL, ETTA S",
    "owner2": "C/O DAVID WOOD R E SERVICES",
    "current_taxes": 41606.14,
    "new_taxes_no_override": 43403.53,
    "override_total_1": 44635.07,
    "override_increase_1": 1231.54
  },
  {
    "#": "105 Naples Rd (052-01-00)",
    "$": 4034300,
    "address": "105 Naples Rd",
    "parcel_id": "052-01-00",
    "owner1": "ZON, LEONARD I",
    "owner2": "SCHNEIDER, LYNDA C",
    "current_taxes": 37676.3,
    "new_taxes_no_override": 39303.92,
    "override_total_1": 40419.13,
    "override_increase_1": 1115.22
  },
  {
    "#": "106 Naples Rd, Unit 1 (063-01-01)",
    "$": 2001200,
    "address": "106 Naples Rd, Unit 1",
    "parcel_id": "063-01-01",
    "owner1": "SINGH, SWETA",
    "owner2": "POTNIS, KUNAL",
    "current_taxes": 16857.35,
    "new_taxes_no_override": 17585.59,
    "override_total_1": 18084.57,
    "override_increase_1": 498.98
  },
  {
    "#": "106 Naples Rd, Unit 2 (063-01-02)",
    "$": 2290900,
    "address": "106 Naples Rd, Unit 2",
    "parcel_id": "063-01-02",
    "owner1": "KOLODNER, JANET L",
    "owner2": "",
    "current_taxes": 19823.88,
    "new_taxes_no_override": 20680.27,
    "override_total_1": 21267.06,
    "override_increase_1": 586.79
  },
  {
    "#": "108 Naples Rd, Unit P1 (062-04-03)",
    "$": 114000,
    "address": "108 Naples Rd, Unit P1",
    "parcel_id": "062-04-03",
    "owner1": "WEI, XIAODUI",
    "owner2": "CHENG, JIASHENG",
    "current_taxes": 1167.36,
    "new_taxes_no_override": 1217.79,
    "override_total_1": 1252.34,
    "override_increase_1": 34.55
  },
  {
    "#": "108 Naples Rd, Unit P10 (062-04-08)",
    "$": 114000,
    "address": "108 Naples Rd, Unit P10",
    "parcel_id": "062-04-08",
    "owner1": "LIANSKI TRS, MAXIM & ANNA",
    "owner2": "",
    "current_taxes": 1167.36,
    "new_taxes_no_override": 1217.79,
    "override_total_1": 1252.34,
    "override_increase_1": 34.55
  },
  {
    "#": "108 Naples Rd, Unit P11-P12 (062-04-09)",
    "$": 228000,
    "address": "108 Naples Rd, Unit P11-P12",
    "parcel_id": "062-04-09",
    "owner1": "FRIED, ISAAC & NIVA",
    "owner2": "",
    "current_taxes": 2334.72,
    "new_taxes_no_override": 2435.58,
    "override_total_1": 2504.69,
    "override_increase_1": 69.11
  },
  {
    "#": "108 Naples Rd, Unit P13 (062-04-10)",
    "$": 114000,
    "address": "108 Naples Rd, Unit P13",
    "parcel_id": "062-04-10",
    "owner1": "PARKER, TRS, JAMES & CHRISTINA",
    "owner2": "",
    "current_taxes": 1167.36,
    "new_taxes_no_override": 1217.79,
    "override_total_1": 1252.34,
    "override_increase_1": 34.55
  },
  {
    "#": "108 Naples Rd, Unit P14 (062-04-11)",
    "$": 114000,
    "address": "108 Naples Rd, Unit P14",
    "parcel_id": "062-04-11",
    "owner1": "KASS, ELIZABETH",
    "owner2": "",
    "current_taxes": 1167.36,
    "new_taxes_no_override": 1217.79,
    "override_total_1": 1252.34,
    "override_increase_1": 34.55
  },
  {
    "#": "108 Naples Rd, Unit P15 (062-04-12)",
    "$": 114000,
    "address": "108 Naples Rd, Unit P15",
    "parcel_id": "062-04-12",
    "owner1": "LIANSKI TRS, MAXIM & ANNA",
    "owner2": "",
    "current_taxes": 1167.36,
    "new_taxes_no_override": 1217.79,
    "override_total_1": 1252.34,
    "override_increase_1": 34.55
  },
  {
    "#": "108 Naples Rd, Unit P16 (062-04-13)",
    "$": 114000,
    "address": "108 Naples Rd, Unit P16",
    "parcel_id": "062-04-13",
    "owner1": "FRIED, ISAAC & NIVA",
    "owner2": "",
    "current_taxes": 1167.36,
    "new_taxes_no_override": 1217.79,
    "override_total_1": 1252.34,
    "override_increase_1": 34.55
  },
  {
    "#": "108 Naples Rd, Unit P17 (062-04-14)",
    "$": 114000,
    "address": "108 Naples Rd, Unit P17",
    "parcel_id": "062-04-14",
    "owner1": "THOMAS, DOLORES R",
    "owner2": "",
    "current_taxes": 1167.36,
    "new_taxes_no_override": 1217.79,
    "override_total_1": 1252.34,
    "override_increase_1": 34.55
  },
  {
    "#": "108 Naples Rd, Unit P18 (062-04-15)",
    "$": 114000,
    "address": "108 Naples Rd, Unit P18",
    "parcel_id": "062-04-15",
    "owner1": "BARON GROUP LLC",
    "owner2": "",
    "current_taxes": 1167.36,
    "new_taxes_no_override": 1217.79,
    "override_total_1": 1252.34,
    "override_increase_1": 34.55
  },
  {
    "#": "108 Naples Rd, Unit P19 (062-04-16)",
    "$": 114000,
    "address": "108 Naples Rd, Unit P19",
    "parcel_id": "062-04-16",
    "owner1": "BARON GROUP LLC",
    "owner2": "",
    "current_taxes": 1167.36,
    "new_taxes_no_override": 1217.79,
    "override_total_1": 1252.34,
    "override_increase_1": 34.55
  },
  {
    "#": "108 Naples Rd, Unit P2 (062-04-19)",
    "$": 114000,
    "address": "108 Naples Rd, Unit P2",
    "parcel_id": "062-04-19",
    "owner1": "LEE, HSIEN-HSIN SEAN",
    "owner2": "LIU, ESTHER JYUE-CHYI",
    "current_taxes": 1167.36,
    "new_taxes_no_override": 1217.79,
    "override_total_1": 1252.34,
    "override_increase_1": 34.55
  },
  {
    "#": "108 Naples Rd, Unit P3 (062-04-17)",
    "$": 114000,
    "address": "108 Naples Rd, Unit P3",
    "parcel_id": "062-04-17",
    "owner1": "GOLJA, ANNA",
    "owner2": "",
    "current_taxes": 1167.36,
    "new_taxes_no_override": 1217.79,
    "override_total_1": 1252.34,
    "override_increase_1": 34.55
  },
  {
    "#": "108 Naples Rd, Unit P4 (062-04-18)",
    "$": 114000,
    "address": "108 Naples Rd, Unit P4",
    "parcel_id": "062-04-18",
    "owner1": "SHADE STREET-NAPLES ROAD LLC",
    "owner2": "C/O MCLANE MIDDLETON PROFESSIONAL ASSOC",
    "current_taxes": 1167.36,
    "new_taxes_no_override": 1217.79,
    "override_total_1": 1252.34,
    "override_increase_1": 34.55
  },
  {
    "#": "108 Naples Rd, Unit P5-P6-P7 (062-04-05)",
    "$": 342000,
    "address": "108 Naples Rd, Unit P5-P6-P7",
    "parcel_id": "062-04-05",
    "owner1": "FRIED, ISAAC & NIVA",
    "owner2": "",
    "current_taxes": 3502.08,
    "new_taxes_no_override": 3653.37,
    "override_total_1": 3757.03,
    "override_increase_1": 103.66
  },
  {
    "#": "108 Naples Rd, Unit P8 (062-04-06)",
    "$": 114000,
    "address": "108 Naples Rd, Unit P8",
    "parcel_id": "062-04-06",
    "owner1": "SPILIOPOULOS, KONSTANTINOS",
    "owner2": "VOULGARAKI, ANASTASIA",
    "current_taxes": 1167.36,
    "new_taxes_no_override": 1217.79,
    "override_total_1": 1252.34,
    "override_increase_1": 34.55
  },
  {
    "#": "108 Naples Rd, Unit P9 (062-04-07)",
    "$": 114000,
    "address": "108 Naples Rd, Unit P9",
    "parcel_id": "062-04-07",
    "owner1": "CARLSON, NELS",
    "owner2": "",
    "current_taxes": 1167.36,
    "new_taxes_no_override": 1217.79,
    "override_total_1": 1252.34,
    "override_increase_1": 34.55
  },
  {
    "#": "108 Naples Rd, Unit R2 (062-04-02)",
    "$": 1383600,
    "address": "108 Naples Rd, Unit R2",
    "parcel_id": "062-04-02",
    "owner1": "GINGERY, ANDREW X",
    "owner2": "LIU, WEI",
    "current_taxes": 10533.13,
    "new_taxes_no_override": 10988.16,
    "override_total_1": 11299.94,
    "override_increase_1": 311.78
  },
  {
    "#": "114 Naples Rd (062-03-00)",
    "$": 3128400,
    "address": "114 Naples Rd",
    "parcel_id": "062-03-00",
    "owner1": "QIAN, LU",
    "owner2": "",
    "current_taxes": 28399.88,
    "new_taxes_no_override": 29626.75,
    "override_total_1": 30467.39,
    "override_increase_1": 840.64
  },
  {
    "#": "122 Naples Rd (062-02-00)",
    "$": 3202100,
    "address": "122 Naples Rd",
    "parcel_id": "062-02-00",
    "owner1": "FOSTER, MARC C",
    "owner2": "ROBERTS, ANDREA L",
    "current_taxes": 29154.57,
    "new_taxes_no_override": 30414.05,
    "override_total_1": 31277.02,
    "override_increase_1": 862.98
  },
  {
    "#": "127 Naples Rd (053-10-00)",
    "$": 2952400,
    "address": "127 Naples Rd",
    "parcel_id": "053-10-00",
    "owner1": "KAPLAN, SCOTT ADAM",
    "owner2": "CHEN, JIE",
    "current_taxes": 26597.64,
    "new_taxes_no_override": 27746.66,
    "override_total_1": 28533.95,
    "override_increase_1": 787.29
  },
  {
    "#": "132 Naples Rd (062-01-00)",
    "$": 2845600,
    "address": "132 Naples Rd",
    "parcel_id": "062-01-00",
    "owner1": "MEAGHER TR, RACHEL Y",
    "owner2": "",
    "current_taxes": 25504.01,
    "new_taxes_no_override": 26605.78,
    "override_total_1": 27360.7,
    "override_increase_1": 754.92
  },
  {
    "#": "140 Naples Rd (057-13-00)",
    "$": 5429600,
    "address": "140 Naples Rd",
    "parcel_id": "057-13-00",
    "owner1": "HESSNEY, DAVID S & SHARON A C",
    "owner2": "",
    "current_taxes": 51964.17,
    "new_taxes_no_override": 54209.02,
    "override_total_1": 55747.16,
    "override_increase_1": 1538.14
  },
  {
    "#": "145 Naples Rd (055-08-00)",
    "$": 2399700,
    "address": "145 Naples Rd",
    "parcel_id": "055-08-00",
    "owner1": "TA, TAI VAN",
    "owner2": "TRAN, LIEN-NHU & T P THAO",
    "current_taxes": 20937.99,
    "new_taxes_no_override": 21842.51,
    "override_total_1": 22462.28,
    "override_increase_1": 619.76
  },
  {
    "#": "146 Naples Rd (057-12-00)",
    "$": 4078300,
    "address": "146 Naples Rd",
    "parcel_id": "057-12-00",
    "owner1": "GORDON TR, STEPHEN E",
    "owner2": "",
    "current_taxes": 41761.79,
    "new_taxes_no_override": 43565.9,
    "override_total_1": 44802.05,
    "override_increase_1": 1236.15
  },
  {
    "#": "149 Naples Rd (055-09-00)",
    "$": 2059000,
    "address": "149 Naples Rd",
    "parcel_id": "055-09-00",
    "owner1": "LIU, SUSIE S L",
    "owner2": "FONG, WILLIAM-TIMMY-TOMMY",
    "current_taxes": 17449.23,
    "new_taxes_no_override": 18203.04,
    "override_total_1": 18719.53,
    "override_increase_1": 516.5
  },
  {
    "#": "150 Naples Rd, Unit 3 & 2 G-Sp (057-11-02)",
    "$": 1716300,
    "address": "150 Naples Rd, Unit 3 & 2 G-Sp",
    "parcel_id": "057-11-02",
    "owner1": "HERTEL, JAIME",
    "owner2": "DASQUE, ERIK",
    "current_taxes": 13939.98,
    "new_taxes_no_override": 14542.19,
    "override_total_1": 14954.81,
    "override_increase_1": 412.62
  },
  {
    "#": "152 Naples Rd, Unit 1 (057-11-03)",
    "$": 1070900,
    "address": "152 Naples Rd, Unit 1",
    "parcel_id": "057-11-03",
    "owner1": "PLAZONJA, ALISA",
    "owner2": "",
    "current_taxes": 7331.08,
    "new_taxes_no_override": 7647.78,
    "override_total_1": 7864.78,
    "override_increase_1": 217.0
  },
  {
    "#": "153 Naples Rd (055-10-00)",
    "$": 2479300,
    "address": "153 Naples Rd",
    "parcel_id": "055-10-00",
    "owner1": "MAHONEY, CHARLES R",
    "owner2": "GREGG, NANCY L",
    "current_taxes": 21753.1,
    "new_taxes_no_override": 22692.83,
    "override_total_1": 23336.73,
    "override_increase_1": 643.89
  },
  {
    "#": "154 Naples Rd, Unit 2 (057-11-01)",
    "$": 1338700,
    "address": "154 Naples Rd, Unit 2",
    "parcel_id": "057-11-01",
    "owner1": "HIRSCH TRS, ELI & PAMELA LYNN",
    "owner2": "",
    "current_taxes": 10073.35,
    "new_taxes_no_override": 10508.52,
    "override_total_1": 10806.69,
    "override_increase_1": 298.17
  },
  {
    "#": "157 Naples Rd, Unit 1 (055-11-03)",
    "$": 1151800,
    "address": "157 Naples Rd, Unit 1",
    "parcel_id": "055-11-03",
    "owner1": "FINK, AARON S & ANNE M",
    "owner2": "",
    "current_taxes": 8159.5,
    "new_taxes_no_override": 8511.99,
    "override_total_1": 8753.51,
    "override_increase_1": 241.52
  },
  {
    "#": "157 Naples Rd, Unit 2 (055-11-01)",
    "$": 1189200,
    "address": "157 Naples Rd, Unit 2",
    "parcel_id": "055-11-01",
    "owner1": "KELTER, TR, JACQUELINE M",
    "owner2": "",
    "current_taxes": 8542.47,
    "new_taxes_no_override": 8911.5,
    "override_total_1": 9164.36,
    "override_increase_1": 252.86
  },
  {
    "#": "157 Naples Rd, Unit 3 (055-11-02)",
    "$": 1202800,
    "address": "157 Naples Rd, Unit 3",
    "parcel_id": "055-11-02",
    "owner1": "TATLOCK, ALISON & JESSICA",
    "owner2": "",
    "current_taxes": 12316.67,
    "new_taxes_no_override": 12848.75,
    "override_total_1": 13213.32,
    "override_increase_1": 364.57
  },
  {
    "#": "158 Naples Rd (057-10-00)",
    "$": 2466900,
    "address": "158 Naples Rd",
    "parcel_id": "057-10-00",
    "owner1": "AMSTER, RICHARD B",
    "owner2": "",
    "current_taxes": 21626.12,
    "new_taxes_no_override": 22560.37,
    "override_total_1": 23200.5,
    "override_increase_1": 640.13
  },
  {
    "#": "161 Naples Rd, Unit A (055-12-01)",
    "$": 2416000,
    "address": "161 Naples Rd, Unit A",
    "parcel_id": "055-12-01",
    "owner1": "KAGAN, JONATHAN CHAD",
    "owner2": "MAREK-KAGAN, LORRI RENEE",
    "current_taxes": 24739.84,
    "new_taxes_no_override": 25808.6,
    "override_total_1": 26540.9,
    "override_increase_1": 732.3
  },
  {
    "#": "161 Naples Rd, Unit B (055-12-02)",
    "$": 2264100,
    "address": "161 Naples Rd, Unit B",
    "parcel_id": "055-12-02",
    "owner1": "COHEN, JEFFREY",
    "owner2": "",
    "current_taxes": 23184.38,
    "new_taxes_no_override": 24185.95,
    "override_total_1": 24872.2,
    "override_increase_1": 686.26
  },
  {
    "#": "162 Naples Rd (057-09-00)",
    "$": 2048600,
    "address": "162 Naples Rd",
    "parcel_id": "057-09-00",
    "owner1": "SHU, TI-PIN",
    "owner2": "",
    "current_taxes": 17342.73,
    "new_taxes_no_override": 18091.94,
    "override_total_1": 18605.28,
    "override_increase_1": 513.34
  },
  {
    "#": "165 Naples Rd (055-13-00)",
    "$": 2127500,
    "address": "165 Naples Rd",
    "parcel_id": "055-13-00",
    "owner1": "SUN, TSAI-HSUAN LEE & TZI-MING",
    "owner2": "",
    "current_taxes": 18150.67,
    "new_taxes_no_override": 18934.78,
    "override_total_1": 19472.04,
    "override_increase_1": 537.26
  },
  {
    "#": "166 Naples Rd (057-08-00)",
    "$": 2267200,
    "address": "166 Naples Rd",
    "parcel_id": "057-08-00",
    "owner1": "LEE  TRS, JOHN W Y & LINDA M",
    "owner2": "",
    "current_taxes": 19581.19,
    "new_taxes_no_override": 20427.1,
    "override_total_1": 21006.7,
    "override_increase_1": 579.6
  },
  {
    "#": "169 Naples Rd (055-14-00)",
    "$": 3257200,
    "address": "169 Naples Rd",
    "parcel_id": "055-14-00",
    "owner1": "SLOMIAK TRS, JACKSON C  & MING C",
    "owner2": "FUNG, VICTORIA",
    "current_taxes": 29718.79,
    "new_taxes_no_override": 31002.64,
    "override_total_1": 31882.32,
    "override_increase_1": 879.68
  },
  {
    "#": "172 Naples Rd (057-07-00)",
    "$": 3015200,
    "address": "172 Naples Rd",
    "parcel_id": "057-07-00",
    "owner1": "CHEDD TRS, GRAHAM P",
    "owner2": "ANGOFF, NAOMI B",
    "current_taxes": 27240.71,
    "new_taxes_no_override": 28417.51,
    "override_total_1": 29223.83,
    "override_increase_1": 806.33
  },
  {
    "#": "173 Naples Rd (055-15-00)",
    "$": 2352800,
    "address": "173 Naples Rd",
    "parcel_id": "055-15-00",
    "owner1": "HUNTE, ALAN D & ROYLENE",
    "owner2": "JOHNSON, ARLISHA T",
    "current_taxes": 20457.74,
    "new_taxes_no_override": 21341.51,
    "override_total_1": 21947.06,
    "override_increase_1": 605.55
  },
  {
    "#": "175 Naples Rd (055-16-00)",
    "$": 2424200,
    "address": "175 Naples Rd",
    "parcel_id": "055-16-00",
    "owner1": "VERLINDEN, ET AL, JOHN",
    "owner2": "MONDEJAR, OSWALD",
    "current_taxes": 21188.87,
    "new_taxes_no_override": 22104.23,
    "override_total_1": 22731.42,
    "override_increase_1": 627.19
  },
  {
    "#": "176 Naples Rd, Unit 1 (057-06-12)",
    "$": 540000,
    "address": "176 Naples Rd, Unit 1",
    "parcel_id": "057-06-12",
    "owner1": "BASSIL, JANICE",
    "owner2": "C/O CARNEY & BASSIL",
    "current_taxes": 5529.6,
    "new_taxes_no_override": 5768.48,
    "override_total_1": 5932.15,
    "override_increase_1": 163.68
  },
  {
    "#": "176 Naples Rd, Unit 10 (057-06-09)",
    "$": 589000,
    "address": "176 Naples Rd, Unit 10",
    "parcel_id": "057-06-09",
    "owner1": "O`LEARY, WILLIAM JOHN  & JUDY YUEN",
    "owner2": "",
    "current_taxes": 2396.43,
    "new_taxes_no_override": 2499.96,
    "override_total_1": 2570.89,
    "override_increase_1": 70.93
  },
  {
    "#": "176 Naples Rd, Unit 11 (057-06-10)",
    "$": 660500,
    "address": "176 Naples Rd, Unit 11",
    "parcel_id": "057-06-10",
    "owner1": "SONG, YIWEI",
    "owner2": "GU, JIAXUAN",
    "current_taxes": 6763.52,
    "new_taxes_no_override": 7055.7,
    "override_total_1": 7255.9,
    "override_increase_1": 200.2
  },
  {
    "#": "176 Naples Rd, Unit 12 (057-06-11)",
    "$": 657100,
    "address": "176 Naples Rd, Unit 12",
    "parcel_id": "057-06-11",
    "owner1": "MENDOZA, ADRIAN & SENOFER",
    "owner2": "",
    "current_taxes": 3093.77,
    "new_taxes_no_override": 3227.42,
    "override_total_1": 3319.0,
    "override_increase_1": 91.58
  },
  {
    "#": "176 Naples Rd, Unit 2 (057-06-01)",
    "$": 514500,
    "address": "176 Naples Rd, Unit 2",
    "parcel_id": "057-06-01",
    "owner1": "SHAH, AMIL",
    "owner2": "",
    "current_taxes": 5268.48,
    "new_taxes_no_override": 5496.08,
    "override_total_1": 5652.03,
    "override_increase_1": 155.95
  },
  {
    "#": "176 Naples Rd, Unit 3 (057-06-02)",
    "$": 645200,
    "address": "176 Naples Rd, Unit 3",
    "parcel_id": "057-06-02",
    "owner1": "PALADINO TR, VITA",
    "owner2": "",
    "current_taxes": 2971.91,
    "new_taxes_no_override": 3100.3,
    "override_total_1": 3188.27,
    "override_increase_1": 87.97
  },
  {
    "#": "176 Naples Rd, Unit 4 (057-06-03)",
    "$": 645300,
    "address": "176 Naples Rd, Unit 4",
    "parcel_id": "057-06-03",
    "owner1": "LEE TRS, JOHN W Y & LINDA M",
    "owner2": "",
    "current_taxes": 6607.87,
    "new_taxes_no_override": 6893.33,
    "override_total_1": 7088.92,
    "override_increase_1": 195.59
  },
  {
    "#": "176 Naples Rd, Unit 5 (057-06-04)",
    "$": 614500,
    "address": "176 Naples Rd, Unit 5",
    "parcel_id": "057-06-04",
    "owner1": "BASSIL, JANICE",
    "owner2": "",
    "current_taxes": 6292.48,
    "new_taxes_no_override": 6564.32,
    "override_total_1": 6750.57,
    "override_increase_1": 186.26
  },
  {
    "#": "176 Naples Rd, Unit 6 (057-06-05)",
    "$": 614500,
    "address": "176 Naples Rd, Unit 6",
    "parcel_id": "057-06-05",
    "owner1": "OLEARY, WILLIAM J",
    "owner2": "",
    "current_taxes": 2657.55,
    "new_taxes_no_override": 2772.36,
    "override_total_1": 2851.02,
    "override_increase_1": 78.66
  },
  {
    "#": "176 Naples Rd, Unit 7 (057-06-06)",
    "$": 655400,
    "address": "176 Naples Rd, Unit 7",
    "parcel_id": "057-06-06",
    "owner1": "FRANTZIS, LISA",
    "owner2": "DAHL, OPHELIA",
    "current_taxes": 6711.3,
    "new_taxes_no_override": 7001.23,
    "override_total_1": 7199.88,
    "override_increase_1": 198.65
  },
  {
    "#": "176 Naples Rd, Unit 8 (057-06-07)",
    "$": 657200,
    "address": "176 Naples Rd, Unit 8",
    "parcel_id": "057-06-07",
    "owner1": "WU, KUN NANCY",
    "owner2": "",
    "current_taxes": 6729.73,
    "new_taxes_no_override": 7020.45,
    "override_total_1": 7219.65,
    "override_increase_1": 199.2
  },
  {
    "#": "176 Naples Rd, Unit 9 (057-06-08)",
    "$": 589100,
    "address": "176 Naples Rd, Unit 9",
    "parcel_id": "057-06-08",
    "owner1": "KOMINIS, KATHERINE E",
    "owner2": "",
    "current_taxes": 2397.45,
    "new_taxes_no_override": 2501.02,
    "override_total_1": 2571.98,
    "override_increase_1": 70.96
  },
  {
    "#": "178 Naples Rd, Unit 1 & 2 Pk Sps (057-05-01)",
    "$": 1132800,
    "address": "178 Naples Rd, Unit 1 & 2 Pk Sps",
    "parcel_id": "057-05-01",
    "owner1": "MCKENZIE, MINDY",
    "owner2": "",
    "current_taxes": 11599.87,
    "new_taxes_no_override": 12100.98,
    "override_total_1": 12444.34,
    "override_increase_1": 343.36
  },
  {
    "#": "178 Naples Rd, Unit 2 & 2 Pk Sps (057-05-02)",
    "$": 1824000,
    "address": "178 Naples Rd, Unit 2 & 2 Pk Sps",
    "parcel_id": "057-05-02",
    "owner1": "WANG, SHUYI",
    "owner2": "BIN, LIHAN",
    "current_taxes": 15042.83,
    "new_taxes_no_override": 15692.68,
    "override_total_1": 16137.95,
    "override_increase_1": 445.27
  },
  {
    "#": "180 Naples Rd (057-04-00)",
    "$": 2847000,
    "address": "180 Naples Rd",
    "parcel_id": "057-04-00",
    "owner1": "RHA TRS, YOUNG B & MARIA B H",
    "owner2": "",
    "current_taxes": 25518.35,
    "new_taxes_no_override": 26620.74,
    "override_total_1": 27376.09,
    "override_increase_1": 755.34
  },
  {
    "#": "182 Naples Rd, Unit 1 (057-03-01)",
    "$": 903400,
    "address": "182 Naples Rd, Unit 1",
    "parcel_id": "057-03-01",
    "owner1": "COFFMAN, CHRISTOPHER K",
    "owner2": "VANDENBERG, KATHLEEN M",
    "current_taxes": 5615.88,
    "new_taxes_no_override": 5858.49,
    "override_total_1": 6024.72,
    "override_increase_1": 166.23
  },
  {
    "#": "182 Naples Rd, Unit 2 (057-03-02)",
    "$": 835200,
    "address": "182 Naples Rd, Unit 2",
    "parcel_id": "057-03-02",
    "owner1": "FOLMAN, ELIZABETH STARR",
    "owner2": "",
    "current_taxes": 4917.51,
    "new_taxes_no_override": 5129.95,
    "override_total_1": 5275.5,
    "override_increase_1": 145.56
  },
  {
    "#": "182 Naples Rd, Unit 3 (057-03-03)",
    "$": 1156500,
    "address": "182 Naples Rd, Unit 3",
    "parcel_id": "057-03-03",
    "owner1": "CHERKASKY, ALEXANDER V & OLENA A",
    "owner2": "",
    "current_taxes": 8207.63,
    "new_taxes_no_override": 8562.2,
    "override_total_1": 8805.15,
    "override_increase_1": 242.95
  },
  {
    "#": "184 Naples Rd (057-02-00)",
    "$": 3275000,
    "address": "184 Naples Rd",
    "parcel_id": "057-02-00",
    "owner1": "COHEN, TRS, HOWARD S & MARJORIE S",
    "owner2": "",
    "current_taxes": 33536.0,
    "new_taxes_no_override": 34984.76,
    "override_total_1": 35977.42,
    "override_increase_1": 992.67
  },
  {
    "#": "186 Naples Rd (057-01-00)",
    "$": 3271400,
    "address": "186 Naples Rd",
    "parcel_id": "057-01-00",
    "owner1": "DAD CONSTRUCTION CO INC",
    "owner2": "",
    "current_taxes": 33499.14,
    "new_taxes_no_override": 34946.3,
    "override_total_1": 35937.88,
    "override_increase_1": 991.57
  },
  {
    "#": "5 Nelson Dr (418-08-00)",
    "$": 1778200,
    "address": "5 Nelson Dr",
    "parcel_id": "418-08-00",
    "owner1": "LANG TRS, NORMAN J & MATINA D",
    "owner2": "",
    "current_taxes": 14573.83,
    "new_taxes_no_override": 15203.42,
    "override_total_1": 15634.8,
    "override_increase_1": 431.39
  },
  {
    "#": "6 Nelson Dr (418-07-00)",
    "$": 1840200,
    "address": "6 Nelson Dr",
    "parcel_id": "418-07-00",
    "owner1": "ANIK LLC",
    "owner2": "",
    "current_taxes": 18843.65,
    "new_taxes_no_override": 19657.7,
    "override_total_1": 20215.47,
    "override_increase_1": 557.77
  },
  {
    "#": "15 Nelson Dr (418-06-00)",
    "$": 1748500,
    "address": "15 Nelson Dr",
    "parcel_id": "418-06-00",
    "owner1": "TORNETTA III, PAUL",
    "owner2": "",
    "current_taxes": 14269.71,
    "new_taxes_no_override": 14886.16,
    "override_total_1": 15308.54,
    "override_increase_1": 422.38
  },
  {
    "#": "16 Nelson Dr (418-02-03)",
    "$": 1794900,
    "address": "16 Nelson Dr",
    "parcel_id": "418-02-03",
    "owner1": "COHEN, MERRICK & MARLENE",
    "owner2": "",
    "current_taxes": 14744.84,
    "new_taxes_no_override": 15381.82,
    "override_total_1": 15818.26,
    "override_increase_1": 436.45
  },
  {
    "#": "24 Nelson Dr (418-04-00)",
    "$": 2864000,
    "address": "24 Nelson Dr",
    "parcel_id": "418-04-00",
    "owner1": "DOYLE, THOMAS ANTHONY & CARINA BITTAR",
    "owner2": "",
    "current_taxes": 25692.43,
    "new_taxes_no_override": 26802.34,
    "override_total_1": 27562.84,
    "override_increase_1": 760.5
  },
  {
    "#": "25 Nelson Dr (418-05-00)",
    "$": 2337500,
    "address": "25 Nelson Dr",
    "parcel_id": "418-05-00",
    "owner1": "BOYER TRS, SOFIA HAKANSSON & ERIC & LANCE W",
    "owner2": "",
    "current_taxes": 20301.07,
    "new_taxes_no_override": 21178.08,
    "override_total_1": 21778.99,
    "override_increase_1": 600.91
  },
  {
    "#": "2 Netherlands Rd (133-06-00)",
    "$": 1759200,
    "address": "2 Netherlands Rd",
    "parcel_id": "133-06-00",
    "owner1": "SUGRUE TRS, JOHN ANTHONY",
    "owner2": "ENAMORADO-SUGRUE, NOEMI YOLANDA",
    "current_taxes": 14379.27,
    "new_taxes_no_override": 15000.45,
    "override_total_1": 15426.08,
    "override_increase_1": 425.63
  },
  {
    "#": "3 Netherlands Rd, Unit 2 & P25 (134-01-01)",
    "$": 865800,
    "address": "3 Netherlands Rd, Unit 2 & P25",
    "parcel_id": "134-01-01",
    "owner1": "HEKSTRA, DOEKE",
    "owner2": "TULBOVICH-HEKSTRA, ELLINA",
    "current_taxes": 8865.79,
    "new_taxes_no_override": 9248.79,
    "override_total_1": 9511.22,
    "override_increase_1": 262.43
  },
  {
    "#": "3 Netherlands Rd, Unit A &P26-P9 (134-01-03)",
    "$": 874300,
    "address": "3 Netherlands Rd, Unit A &P26-P9",
    "parcel_id": "134-01-03",
    "owner1": "KOOR, HOWARD I",
    "owner2": "MOSNER, ELLEN R",
    "current_taxes": 5317.9,
    "new_taxes_no_override": 5547.63,
    "override_total_1": 5705.04,
    "override_increase_1": 157.41
  },
  {
    "#": "3 Netherlands Rd, Unit C & P24 (134-01-02)",
    "$": 879400,
    "address": "3 Netherlands Rd, Unit C & P24",
    "parcel_id": "134-01-02",
    "owner1": "SCHLOSSER, GARY F & FADIME",
    "owner2": "",
    "current_taxes": 5370.12,
    "new_taxes_no_override": 5602.11,
    "override_total_1": 5761.06,
    "override_increase_1": 158.96
  },
  {
    "#": "6 Netherlands Rd (133-05-00)",
    "$": 1649800,
    "address": "6 Netherlands Rd",
    "parcel_id": "133-05-00",
    "owner1": "GUAN, JIAZHEN",
    "owner2": "LI, XIAOTONG",
    "current_taxes": 13259.02,
    "new_taxes_no_override": 13831.81,
    "override_total_1": 14224.28,
    "override_increase_1": 392.47
  },
  {
    "#": "7 Netherlands Rd, Unit 1 & P23 (134-02-03)",
    "$": 1078600,
    "address": "7 Netherlands Rd, Unit 1 & P23",
    "parcel_id": "134-02-03",
    "owner1": "VILLA TRS, PETER J",
    "owner2": "CHECCHIO, REGAN E",
    "current_taxes": 7409.93,
    "new_taxes_no_override": 7730.04,
    "override_total_1": 7949.37,
    "override_increase_1": 219.33
  },
  {
    "#": "7 Netherlands Rd, Unit 2 (134-02-01)",
    "$": 872200,
    "address": "7 Netherlands Rd, Unit 2",
    "parcel_id": "134-02-01",
    "owner1": "BURNET TR, STEPHANE",
    "owner2": "STEPHANE BURNET REAL ESTATE TRUST",
    "current_taxes": 8931.33,
    "new_taxes_no_override": 9317.16,
    "override_total_1": 9581.53,
    "override_increase_1": 264.37
  },
  {
    "#": "7 Netherlands Rd, Unit 3 & P22 (134-02-02)",
    "$": 880500,
    "address": "7 Netherlands Rd, Unit 3 & P22",
    "parcel_id": "134-02-02",
    "owner1": "CAGGIANO TR, JOSEPH",
    "owner2": "",
    "current_taxes": 9016.32,
    "new_taxes_no_override": 9405.83,
    "override_total_1": 9672.71,
    "override_increase_1": 266.88
  },
  {
    "#": "10 Netherlands Rd, Unit 1 (133-04-01)",
    "$": 1454400,
    "address": "10 Netherlands Rd, Unit 1",
    "parcel_id": "133-04-01",
    "owner1": "SCHECHTER, ETHAN & LEAKHENA A",
    "owner2": "",
    "current_taxes": 11258.12,
    "new_taxes_no_override": 11744.47,
    "override_total_1": 12077.71,
    "override_increase_1": 333.24
  },
  {
    "#": "10 Netherlands Rd, Unit 2 (133-04-02)",
    "$": 1421200,
    "address": "10 Netherlands Rd, Unit 2",
    "parcel_id": "133-04-02",
    "owner1": "OYUELA, PEDRO",
    "owner2": "CORONADO, CAROLINA",
    "current_taxes": 10918.15,
    "new_taxes_no_override": 11389.81,
    "override_total_1": 11712.99,
    "override_increase_1": 323.18
  },
  {
    "#": "11 Netherlands Rd, Unit 1 & P10 (134-03-01)",
    "$": 879200,
    "address": "11 Netherlands Rd, Unit 1 & P10",
    "parcel_id": "134-03-01",
    "owner1": "SHARMA, NEERJA",
    "owner2": "",
    "current_taxes": 5368.07,
    "new_taxes_no_override": 5599.97,
    "override_total_1": 5758.87,
    "override_increase_1": 158.89
  },
  {
    "#": "11 Netherlands Rd, Unit 2 & P7 & 37 (134-03-02)",
    "$": 902600,
    "address": "11 Netherlands Rd, Unit 2 & P7 & 37",
    "parcel_id": "134-03-02",
    "owner1": "YEH, JANE & JONATHAN",
    "owner2": "",
    "current_taxes": 5607.69,
    "new_taxes_no_override": 5849.94,
    "override_total_1": 6015.93,
    "override_increase_1": 165.99
  },
  {
    "#": "11 Netherlands Rd, Unit 3 (134-03-03)",
    "$": 826200,
    "address": "11 Netherlands Rd, Unit 3",
    "parcel_id": "134-03-03",
    "owner1": "KEY TRS, JASON M",
    "owner2": "ROSNER KEY, ERICA BETH",
    "current_taxes": 4825.35,
    "new_taxes_no_override": 5033.81,
    "override_total_1": 5176.64,
    "override_increase_1": 142.83
  },
  {
    "#": "11 Netherlands Rd, Unit B (134-03-04)",
    "$": 536000,
    "address": "11 Netherlands Rd, Unit B",
    "parcel_id": "134-03-04",
    "owner1": "PENG, JAMES & NANCY",
    "owner2": "",
    "current_taxes": 5488.64,
    "new_taxes_no_override": 5725.75,
    "override_total_1": 5888.21,
    "override_increase_1": 162.46
  },
  {
    "#": "14 Netherlands Rd (133-03-00)",
    "$": 1632700,
    "address": "14 Netherlands Rd",
    "parcel_id": "133-03-00",
    "owner1": "HERITAGE HOLDINGS LLC",
    "owner2": "",
    "current_taxes": 16718.85,
    "new_taxes_no_override": 17441.1,
    "override_total_1": 17935.98,
    "override_increase_1": 494.88
  },
  {
    "#": "15 Netherlands Rd (134-04-00)",
    "$": 2316900,
    "address": "15 Netherlands Rd",
    "parcel_id": "134-04-00",
    "owner1": "SHING TRS, CHU KWOK",
    "owner2": "SOON, CHU GIN",
    "current_taxes": 20090.12,
    "new_taxes_no_override": 20958.01,
    "override_total_1": 21552.68,
    "override_increase_1": 594.67
  },
  {
    "#": "19 Netherlands Rd, Unit 1 (134-05-03)",
    "$": 870900,
    "address": "19 Netherlands Rd, Unit 1",
    "parcel_id": "134-05-03",
    "owner1": "BAHL, TAVISH & BHANU",
    "owner2": "",
    "current_taxes": 8918.02,
    "new_taxes_no_override": 9303.28,
    "override_total_1": 9567.25,
    "override_increase_1": 263.97
  },
  {
    "#": "19 Netherlands Rd, Unit 2 (134-05-01)",
    "$": 799900,
    "address": "19 Netherlands Rd, Unit 2",
    "parcel_id": "134-05-01",
    "owner1": "HAN, DONGRAN",
    "owner2": "LIU, YIXING",
    "current_taxes": 8190.98,
    "new_taxes_no_override": 8544.83,
    "override_total_1": 8787.28,
    "override_increase_1": 242.45
  },
  {
    "#": "19 Netherlands Rd, Unit 3 (134-05-02)",
    "$": 791700,
    "address": "19 Netherlands Rd, Unit 3",
    "parcel_id": "134-05-02",
    "owner1": "WOLF LYON TR, VICKY J",
    "owner2": "",
    "current_taxes": 8107.01,
    "new_taxes_no_override": 8457.23,
    "override_total_1": 8697.2,
    "override_increase_1": 239.97
  },
  {
    "#": "20 Netherlands Rd (133-02-00)",
    "$": 2783200,
    "address": "20 Netherlands Rd",
    "parcel_id": "133-02-00",
    "owner1": "DE BANSA, CLAUS",
    "owner2": "",
    "current_taxes": 28499.97,
    "new_taxes_no_override": 29731.17,
    "override_total_1": 30574.77,
    "override_increase_1": 843.6
  },
  {
    "#": "23 Netherlands Rd, Unit 1 (134-06-01)",
    "$": 1144400,
    "address": "23 Netherlands Rd, Unit 1",
    "parcel_id": "134-06-01",
    "owner1": "LONDON TR, TIRZAH LEA",
    "owner2": "C/O TIRZAH LEE LONDON",
    "current_taxes": 11718.66,
    "new_taxes_no_override": 12224.91,
    "override_total_1": 12571.78,
    "override_increase_1": 346.87
  },
  {
    "#": "23 Netherlands Rd, Unit 2 (134-06-02)",
    "$": 771000,
    "address": "23 Netherlands Rd, Unit 2",
    "parcel_id": "134-06-02",
    "owner1": "WANG, XIAOWEN",
    "owner2": "HAN, BINGHONG",
    "current_taxes": 7895.04,
    "new_taxes_no_override": 8236.11,
    "override_total_1": 8469.8,
    "override_increase_1": 233.69
  },
  {
    "#": "23 Netherlands Rd, Unit 3 (134-06-03)",
    "$": 771000,
    "address": "23 Netherlands Rd, Unit 3",
    "parcel_id": "134-06-03",
    "owner1": "LIU, WEI",
    "owner2": "",
    "current_taxes": 4260.11,
    "new_taxes_no_override": 4444.15,
    "override_total_1": 4570.25,
    "override_increase_1": 126.1
  },
  {
    "#": "44 Netherlands Rd (133-01-00)",
    "$": 6037600,
    "address": "44 Netherlands Rd",
    "parcel_id": "133-01-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O WATER & SEWER GARAGE",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "11 Newell Rd (126-03-02)",
    "$": 2236600,
    "address": "11 Newell Rd",
    "parcel_id": "126-03-02",
    "owner1": "GORE  LIFE ESTATE, NEIL S & SUSAN",
    "owner2": "",
    "current_taxes": 19267.85,
    "new_taxes_no_override": 20100.22,
    "override_total_1": 20670.55,
    "override_increase_1": 570.33
  },
  {
    "#": "14 Newell Rd (126-05-01)",
    "$": 2092300,
    "address": "14 Newell Rd",
    "parcel_id": "126-05-01",
    "owner1": "FREINK, DANIEL & MARIANNA",
    "owner2": "",
    "current_taxes": 21425.15,
    "new_taxes_no_override": 22350.72,
    "override_total_1": 22984.9,
    "override_increase_1": 634.18
  },
  {
    "#": "17 Newell Rd (126-03-03)",
    "$": 2398000,
    "address": "17 Newell Rd",
    "parcel_id": "126-03-03",
    "owner1": "ROOT, DAVID E",
    "owner2": "FOO, SHI YIN",
    "current_taxes": 20920.59,
    "new_taxes_no_override": 21824.36,
    "override_total_1": 22443.61,
    "override_increase_1": 619.25
  },
  {
    "#": "20 Newell Rd (126-05-00)",
    "$": 1945500,
    "address": "20 Newell Rd",
    "parcel_id": "126-05-00",
    "owner1": "CHIN, WILLIAM-HELEN-TERESA-SOON",
    "owner2": "",
    "current_taxes": 16286.99,
    "new_taxes_no_override": 16990.59,
    "override_total_1": 17472.68,
    "override_increase_1": 482.09
  },
  {
    "#": "21 Newell Rd (126-03-04)",
    "$": 2874600,
    "address": "21 Newell Rd",
    "parcel_id": "126-03-04",
    "owner1": "LUSTER TRS, THOMAS H & AMY M",
    "owner2": "",
    "current_taxes": 25800.97,
    "new_taxes_no_override": 26915.57,
    "override_total_1": 27679.28,
    "override_increase_1": 763.71
  },
  {
    "#": "27 Newell Rd, Unit 1 (126-04-01)",
    "$": 2174900,
    "address": "27 Newell Rd, Unit 1",
    "parcel_id": "126-04-01",
    "owner1": "SAMPSON, ROBERT J & NANCY A",
    "owner2": "",
    "current_taxes": 18636.04,
    "new_taxes_no_override": 19441.12,
    "override_total_1": 19992.74,
    "override_increase_1": 551.63
  },
  {
    "#": "27 Newell Rd, Unit 2 (126-04-02)",
    "$": 2467200,
    "address": "27 Newell Rd, Unit 2",
    "parcel_id": "126-04-02",
    "owner1": "KIRSHENBAUM, DANIEL S & LAURA B",
    "owner2": "",
    "current_taxes": 25264.13,
    "new_taxes_no_override": 26355.54,
    "override_total_1": 27103.36,
    "override_increase_1": 747.82
  },
  {
    "#": "9 Newton St (356-01-00)",
    "$": 71956100,
    "address": "9 Newton St",
    "parcel_id": "356-01-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O LARZ ANDERSON PARK",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "20 Newton St (357-01-02)",
    "$": 154824200,
    "address": "20 Newton St",
    "parcel_id": "357-01-02",
    "owner1": "DEXTER, SCHOOL",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "40 Newton St (357-36-00)",
    "$": 2266300,
    "address": "40 Newton St",
    "parcel_id": "357-36-00",
    "owner1": "CHEN, SHIH YIN",
    "owner2": "TOH, SENGWEE",
    "current_taxes": 19571.98,
    "new_taxes_no_override": 20417.49,
    "override_total_1": 20996.82,
    "override_increase_1": 579.33
  },
  {
    "#": "50 Newton St (357-35-00)",
    "$": 1922800,
    "address": "50 Newton St",
    "parcel_id": "357-35-00",
    "owner1": "MURRAY, ADIN C &THEODORA E TEXTOR",
    "owner2": "",
    "current_taxes": 16054.54,
    "new_taxes_no_override": 16748.1,
    "override_total_1": 17223.31,
    "override_increase_1": 475.21
  },
  {
    "#": "64 Newton St (357-33-34)",
    "$": 4500700,
    "address": "64 Newton St",
    "parcel_id": "357-33-34",
    "owner1": "CALLAHAN TR, MICHAEL F",
    "owner2": "",
    "current_taxes": 46087.17,
    "new_taxes_no_override": 48078.14,
    "override_total_1": 49442.32,
    "override_increase_1": 1364.18
  },
  {
    "#": "80 Newton St (357-32-00)",
    "$": 2847700,
    "address": "80 Newton St",
    "parcel_id": "357-32-00",
    "owner1": "RAMAN, ANANTH & PADMAJA",
    "owner2": "",
    "current_taxes": 25525.51,
    "new_taxes_no_override": 26628.21,
    "override_total_1": 27383.77,
    "override_increase_1": 755.56
  },
  {
    "#": "92 Newton St (357-31-00)",
    "$": 2312000,
    "address": "92 Newton St",
    "parcel_id": "357-31-00",
    "owner1": "DOW LIFE ESTATE, SARAH",
    "owner2": "GAFFEY, RACHEL DOW",
    "current_taxes": 20039.95,
    "new_taxes_no_override": 20905.68,
    "override_total_1": 21498.86,
    "override_increase_1": 593.18
  },
  {
    "#": "102 Newton St (357-30-00)",
    "$": 2484500,
    "address": "102 Newton St",
    "parcel_id": "357-30-00",
    "owner1": "RICHIE, DIANE E",
    "owner2": "",
    "current_taxes": 21806.35,
    "new_taxes_no_override": 22748.38,
    "override_total_1": 23393.85,
    "override_increase_1": 645.47
  },
  {
    "#": "112 Newton St (357-29-00)",
    "$": 2109900,
    "address": "112 Newton St",
    "parcel_id": "357-29-00",
    "owner1": "ANIK LLC",
    "owner2": "",
    "current_taxes": 21605.38,
    "new_taxes_no_override": 22538.73,
    "override_total_1": 23178.25,
    "override_increase_1": 639.52
  },
  {
    "#": "147 Newton St (344-09-00)",
    "$": 2590800,
    "address": "147 Newton St",
    "parcel_id": "344-09-00",
    "owner1": "OGE, WADNER & DAPHNEE",
    "owner2": "",
    "current_taxes": 22894.86,
    "new_taxes_no_override": 23883.92,
    "override_total_1": 24561.61,
    "override_increase_1": 677.69
  },
  {
    "#": "150 Newton St (357-22-00)",
    "$": 2397300,
    "address": "150 Newton St",
    "parcel_id": "357-22-00",
    "owner1": "SHAY, NORBERT J",
    "owner2": "",
    "current_taxes": 20913.42,
    "new_taxes_no_override": 21816.88,
    "override_total_1": 22435.92,
    "override_increase_1": 619.04
  },
  {
    "#": "155 Newton St, Unit 7 (344-08-08)",
    "$": 1225800,
    "address": "155 Newton St, Unit 7",
    "parcel_id": "344-08-08",
    "owner1": "GELLER TR, LEONARD",
    "owner2": "",
    "current_taxes": 8917.26,
    "new_taxes_no_override": 9302.49,
    "override_total_1": 9566.44,
    "override_increase_1": 263.95
  },
  {
    "#": "164 Newton St (357-21-00)",
    "$": 4205100,
    "address": "164 Newton St",
    "parcel_id": "357-21-00",
    "owner1": "WOOLLEY, HUNTER B & ANN E",
    "owner2": "",
    "current_taxes": 43060.22,
    "new_taxes_no_override": 44920.42,
    "override_total_1": 46195.0,
    "override_increase_1": 1274.58
  },
  {
    "#": "165 Newton St, Unit 8 (344-08-09)",
    "$": 1310900,
    "address": "165 Newton St, Unit 8",
    "parcel_id": "344-08-09",
    "owner1": "LAM, GIANG",
    "owner2": "YEH, GLORIA",
    "current_taxes": 13423.62,
    "new_taxes_no_override": 14003.52,
    "override_total_1": 14400.86,
    "override_increase_1": 397.34
  },
  {
    "#": "186 Newton St (357-14-20)",
    "$": 6736200,
    "address": "186 Newton St",
    "parcel_id": "357-14-20",
    "owner1": "LAWRENCE JR ET AL TRS, JAMES",
    "owner2": "",
    "current_taxes": 69185.6,
    "new_taxes_no_override": 72174.42,
    "override_total_1": 74222.31,
    "override_increase_1": 2047.89
  },
  {
    "#": "191 Newton St (441-52-01)",
    "$": 4295500,
    "address": "191 Newton St",
    "parcel_id": "441-52-01",
    "owner1": "GRIMES TRS, PETER N & KARLYN L",
    "owner2": "",
    "current_taxes": 40350.99,
    "new_taxes_no_override": 42094.15,
    "override_total_1": 43288.54,
    "override_increase_1": 1194.39
  },
  {
    "#": "195 Newton St (441-51-00)",
    "$": 5919900,
    "address": "195 Newton St",
    "parcel_id": "441-51-00",
    "owner1": "LI, ZECHEN",
    "owner2": "DONG, RUI",
    "current_taxes": 56984.84,
    "new_taxes_no_override": 59446.59,
    "override_total_1": 61133.34,
    "override_increase_1": 1686.75
  },
  {
    "#": "209 Newton St (441-50-00)",
    "$": 4846000,
    "address": "209 Newton St",
    "parcel_id": "441-50-00",
    "owner1": "ROSS, CAROLYN THAYER",
    "owner2": "",
    "current_taxes": 45988.11,
    "new_taxes_no_override": 47974.8,
    "override_total_1": 49336.04,
    "override_increase_1": 1361.25
  },
  {
    "#": "225 Newton St (441-49-00)",
    "$": 6686100,
    "address": "225 Newton St",
    "parcel_id": "441-49-00",
    "owner1": "ZHU, FEI",
    "owner2": "",
    "current_taxes": 68465.66,
    "new_taxes_no_override": 71423.38,
    "override_total_1": 73449.96,
    "override_increase_1": 2026.58
  },
  {
    "#": "280 Newton St (357-03-00)",
    "$": 44406000,
    "address": "280 Newton St",
    "parcel_id": "357-03-00",
    "owner1": "BRANDEGEE CHARITABLE, FOUNDATION",
    "owner2": "C/O LORING WOLCOTT & COOLIDGE",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "282 Newton St (357-04-13)",
    "$": 23591900,
    "address": "282 Newton St",
    "parcel_id": "357-04-13",
    "owner1": "LAWRENCE, ET AL TRS, EDWARD P",
    "owner2": "",
    "current_taxes": 241918.2,
    "new_taxes_no_override": 252369.07,
    "override_total_1": 259529.84,
    "override_increase_1": 7160.78
  },
  {
    "#": "293 Newton St (442-02-00)",
    "$": 63500,
    "address": "293 Newton St",
    "parcel_id": "442-02-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O VACANT PARCEL/ABUT 11-33 FRGRN",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "320 Newton St (370-17-00)",
    "$": 2997100,
    "address": "320 Newton St",
    "parcel_id": "370-17-00",
    "owner1": "KYL LLP",
    "owner2": "",
    "current_taxes": 51430.24,
    "new_taxes_no_override": 53652.03,
    "override_total_1": 55174.36,
    "override_increase_1": 1522.34
  },
  {
    "#": "321 Newton St (442-16-00)",
    "$": 2336000,
    "address": "321 Newton St",
    "parcel_id": "442-16-00",
    "owner1": "MWRA",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "331 Newton St (442-17-00)",
    "$": 1218200,
    "address": "331 Newton St",
    "parcel_id": "442-17-00",
    "owner1": "WARD, MAUREEN E & MARY F",
    "owner2": "",
    "current_taxes": 8839.43,
    "new_taxes_no_override": 9221.29,
    "override_total_1": 9482.94,
    "override_increase_1": 261.65
  },
  {
    "#": "346 Newton St (370-14-00)",
    "$": 1643900,
    "address": "346 Newton St",
    "parcel_id": "370-14-00",
    "owner1": "FIGLER, JOSEPH G &TRICIA DESINGCO",
    "owner2": "",
    "current_taxes": 13198.6,
    "new_taxes_no_override": 13768.78,
    "override_total_1": 14159.46,
    "override_increase_1": 390.68
  },
  {
    "#": "361 Newton St (442-31-33)",
    "$": 1717400,
    "address": "361 Newton St",
    "parcel_id": "442-31-33",
    "owner1": "PISANO, KATHLEEN ISABEL & ALAN D",
    "owner2": "",
    "current_taxes": 13951.24,
    "new_taxes_no_override": 14553.93,
    "override_total_1": 14966.89,
    "override_increase_1": 412.96
  },
  {
    "#": "367 Newton St (442-34-00)",
    "$": 1708800,
    "address": "367 Newton St",
    "parcel_id": "442-34-00",
    "owner1": "BOSTON LZ DEVELOPMENT LLC",
    "owner2": "",
    "current_taxes": 17498.11,
    "new_taxes_no_override": 18254.03,
    "override_total_1": 18771.97,
    "override_increase_1": 517.94
  },
  {
    "#": "376 Newton St (370A-09-00)",
    "$": 2707800,
    "address": "376 Newton St",
    "parcel_id": "370A-09-00",
    "owner1": "FUNSTON, GEORGE KEITH III & DAPHNE GRAYSON",
    "owner2": "",
    "current_taxes": 24092.94,
    "new_taxes_no_override": 25133.76,
    "override_total_1": 25846.91,
    "override_increase_1": 713.15
  },
  {
    "#": "379 Newton St (442-37-00)",
    "$": 1950600,
    "address": "379 Newton St",
    "parcel_id": "442-37-00",
    "owner1": "ANJOMSHOA, MOHAMMADFAZAL",
    "owner2": "KERMANI, MARYAM  POURYAZDANPANAH",
    "current_taxes": 16339.21,
    "new_taxes_no_override": 17045.06,
    "override_total_1": 17528.7,
    "override_increase_1": 483.64
  },
  {
    "#": "384 Newton St (370A-08-00)",
    "$": 2376200,
    "address": "384 Newton St",
    "parcel_id": "370A-08-00",
    "owner1": "NAKEEB, ATTILA & ROSE MARIE",
    "owner2": "",
    "current_taxes": 20697.35,
    "new_taxes_no_override": 21591.48,
    "override_total_1": 22204.12,
    "override_increase_1": 612.64
  },
  {
    "#": "387 Newton St (442-38-01)",
    "$": 1313100,
    "address": "387 Newton St",
    "parcel_id": "442-38-01",
    "owner1": "387 NEWTON STREET LLC",
    "owner2": "",
    "current_taxes": 13446.14,
    "new_taxes_no_override": 14027.01,
    "override_total_1": 14425.02,
    "override_increase_1": 398.01
  },
  {
    "#": "389 Newton St (442-39-00)",
    "$": 1596300,
    "address": "389 Newton St",
    "parcel_id": "442-39-00",
    "owner1": "WARNER TRS, GEORGE I",
    "owner2": "CUNNINGHAM , ELISABETH W",
    "current_taxes": 16346.11,
    "new_taxes_no_override": 17052.26,
    "override_total_1": 17536.11,
    "override_increase_1": 483.84
  },
  {
    "#": "397 Newton St (442-40-00)",
    "$": 2048700,
    "address": "397 Newton St",
    "parcel_id": "442-40-00",
    "owner1": "WARNER, GEORGE I",
    "owner2": "CUNNINGHAM, E W",
    "current_taxes": 17343.75,
    "new_taxes_no_override": 18093.0,
    "override_total_1": 18606.38,
    "override_increase_1": 513.38
  },
  {
    "#": "420 Newton St (370-02-00)",
    "$": 2106500,
    "address": "420 Newton St",
    "parcel_id": "370-02-00",
    "owner1": "LITT, TRS, MORTIMER & CHARLOTTE",
    "owner2": "",
    "current_taxes": 17935.63,
    "new_taxes_no_override": 18710.45,
    "override_total_1": 19241.34,
    "override_increase_1": 530.89
  },
  {
    "#": "464 Newton St (372-04-00)",
    "$": 2006700,
    "address": "464 Newton St",
    "parcel_id": "372-04-00",
    "owner1": "THALAPPILLIL, RICHARD & JENNIFER",
    "owner2": "",
    "current_taxes": 16913.67,
    "new_taxes_no_override": 17644.34,
    "override_total_1": 18144.99,
    "override_increase_1": 500.64
  },
  {
    "#": "474 Newton St (372-03-00)",
    "$": 1532000,
    "address": "474 Newton St",
    "parcel_id": "372-03-00",
    "owner1": "GLUGETH TRS, RICHARD J & MADELINE S",
    "owner2": "",
    "current_taxes": 12052.75,
    "new_taxes_no_override": 12573.43,
    "override_total_1": 12930.19,
    "override_increase_1": 356.76
  },
  {
    "#": "510 Newton St (399-39-00)",
    "$": 1719700,
    "address": "510 Newton St",
    "parcel_id": "399-39-00",
    "owner1": "KICKHAM LIFE ESTATE, GEORGE A",
    "owner2": "",
    "current_taxes": 13974.79,
    "new_taxes_no_override": 14578.5,
    "override_total_1": 14992.15,
    "override_increase_1": 413.65
  },
  {
    "#": "518 Newton St (399-38-00)",
    "$": 1965900,
    "address": "518 Newton St",
    "parcel_id": "399-38-00",
    "owner1": "TANG, JIAMAN",
    "owner2": "",
    "current_taxes": 16495.88,
    "new_taxes_no_override": 17208.5,
    "override_total_1": 17696.78,
    "override_increase_1": 488.28
  },
  {
    "#": "528 Newton St (399-37-00)",
    "$": 2065000,
    "address": "528 Newton St",
    "parcel_id": "399-37-00",
    "owner1": "GROYSBERG, BORIS & LILIYA",
    "owner2": "",
    "current_taxes": 21145.6,
    "new_taxes_no_override": 22059.09,
    "override_total_1": 22685.0,
    "override_increase_1": 625.91
  },
  {
    "#": "538 Newton St (399-36-00)",
    "$": 2924800,
    "address": "538 Newton St",
    "parcel_id": "399-36-00",
    "owner1": "MICHALOWSKI, MARK & NANCY",
    "owner2": "",
    "current_taxes": 26315.02,
    "new_taxes_no_override": 27451.83,
    "override_total_1": 28230.75,
    "override_increase_1": 778.92
  },
  {
    "#": "546 Newton St (399-33-35)",
    "$": 1425300,
    "address": "546 Newton St",
    "parcel_id": "399-33-35",
    "owner1": "ZHAO, LIJIE",
    "owner2": "WANG, XI",
    "current_taxes": 14595.07,
    "new_taxes_no_override": 15225.58,
    "override_total_1": 15657.59,
    "override_increase_1": 432.01
  },
  {
    "#": "556 Newton St (399-32-00)",
    "$": 1324500,
    "address": "556 Newton St",
    "parcel_id": "399-32-00",
    "owner1": "KIM, JINHONG & KYUNG TAE",
    "owner2": "",
    "current_taxes": 9927.95,
    "new_taxes_no_override": 10356.84,
    "override_total_1": 10650.7,
    "override_increase_1": 293.87
  },
  {
    "#": "566 Newton St (399-31-00)",
    "$": 1651100,
    "address": "566 Newton St",
    "parcel_id": "399-31-00",
    "owner1": "GORMAN, MARK P & MIRIAM K",
    "owner2": "",
    "current_taxes": 13272.33,
    "new_taxes_no_override": 13845.69,
    "override_total_1": 14238.56,
    "override_increase_1": 392.86
  },
  {
    "#": "576 Newton St (399-30-00)",
    "$": 1281000,
    "address": "576 Newton St",
    "parcel_id": "399-30-00",
    "owner1": "NG TRS, HENRY H & ANNA C",
    "owner2": "FINK TRS, ALICE",
    "current_taxes": 13117.44,
    "new_taxes_no_override": 13684.11,
    "override_total_1": 14072.39,
    "override_increase_1": 388.28
  },
  {
    "#": "584 Newton St (399-29-00)",
    "$": 2846500,
    "address": "584 Newton St",
    "parcel_id": "399-29-00",
    "owner1": "WANG, HSIN HSIAO",
    "owner2": "HU, YUPEI",
    "current_taxes": 29148.16,
    "new_taxes_no_override": 30407.36,
    "override_total_1": 31270.15,
    "override_increase_1": 862.79
  },
  {
    "#": "594 Newton St (399-28-00)",
    "$": 1452300,
    "address": "594 Newton St",
    "parcel_id": "399-28-00",
    "owner1": "KOBAYASHI, IKEI & SUSUMU",
    "owner2": "",
    "current_taxes": 11236.62,
    "new_taxes_no_override": 11722.04,
    "override_total_1": 12054.65,
    "override_increase_1": 332.6
  },
  {
    "#": "604 Newton St (399-27-00)",
    "$": 2857800,
    "address": "604 Newton St",
    "parcel_id": "399-27-00",
    "owner1": "AMIRIFELI, SHIDEH",
    "owner2": "",
    "current_taxes": 29263.87,
    "new_taxes_no_override": 30528.07,
    "override_total_1": 31394.28,
    "override_increase_1": 866.21
  },
  {
    "#": "612 Newton St (399-26-00)",
    "$": 2844500,
    "address": "612 Newton St",
    "parcel_id": "399-26-00",
    "owner1": "DOSHI, PARUL BORDIA & HARIT",
    "owner2": "",
    "current_taxes": 25492.75,
    "new_taxes_no_override": 26594.04,
    "override_total_1": 27348.62,
    "override_increase_1": 754.59
  },
  {
    "#": "618 Newton St (399-25-00)",
    "$": 1242500,
    "address": "618 Newton St",
    "parcel_id": "399-25-00",
    "owner1": "GLASER, DAVID M & HELENE",
    "owner2": "",
    "current_taxes": 9088.27,
    "new_taxes_no_override": 9480.88,
    "override_total_1": 9749.9,
    "override_increase_1": 269.01
  },
  {
    "#": "624 Newton St (399-24-00)",
    "$": 1609000,
    "address": "624 Newton St",
    "parcel_id": "399-24-00",
    "owner1": "KOUDIJS, ALEXANDER & TAYLOR",
    "owner2": "",
    "current_taxes": 16476.16,
    "new_taxes_no_override": 17187.93,
    "override_total_1": 17675.62,
    "override_increase_1": 487.69
  },
  {
    "#": "628 Newton St (399-23-00)",
    "$": 1701200,
    "address": "628 Newton St",
    "parcel_id": "399-23-00",
    "owner1": "NANDIVADA, PRATHIMA",
    "owner2": "COLLINS, JESSE W",
    "current_taxes": 13785.35,
    "new_taxes_no_override": 14380.88,
    "override_total_1": 14788.92,
    "override_increase_1": 408.05
  },
  {
    "#": "634 Newton St (399-22-00)",
    "$": 1488100,
    "address": "634 Newton St",
    "parcel_id": "399-22-00",
    "owner1": "MORRIS, JULES J & LETICIA H",
    "owner2": "",
    "current_taxes": 11603.21,
    "new_taxes_no_override": 12104.47,
    "override_total_1": 12447.92,
    "override_increase_1": 343.46
  },
  {
    "#": "640 Newton St (399-21-00)",
    "$": 1839900,
    "address": "640 Newton St",
    "parcel_id": "399-21-00",
    "owner1": "GUNASEKARAN, DEEPTHI",
    "owner2": "VENKATARAMAN, VINAYAK",
    "current_taxes": 15205.64,
    "new_taxes_no_override": 15862.52,
    "override_total_1": 16312.61,
    "override_increase_1": 450.09
  },
  {
    "#": "646 Newton St, Unit 1 (399-20-01)",
    "$": 1282400,
    "address": "646 Newton St, Unit 1",
    "parcel_id": "399-20-01",
    "owner1": "SINGER, JENNIFER & SAMUEL",
    "owner2": "HARRIS, ANDREW",
    "current_taxes": 9496.84,
    "new_taxes_no_override": 9907.1,
    "override_total_1": 10188.21,
    "override_increase_1": 281.11
  },
  {
    "#": "646 Newton St, Unit 2 (399-20-02)",
    "$": 1523700,
    "address": "646 Newton St, Unit 2",
    "parcel_id": "399-20-02",
    "owner1": "DINSHAW, SOHRAB",
    "owner2": "MEHTA, RASHNA",
    "current_taxes": 15602.69,
    "new_taxes_no_override": 16276.73,
    "override_total_1": 16738.57,
    "override_increase_1": 461.84
  },
  {
    "#": "668 Newton St (402-28-00)",
    "$": 1447000,
    "address": "668 Newton St",
    "parcel_id": "402-28-00",
    "owner1": "IACOB, IOAN A & ROXANA E",
    "owner2": "",
    "current_taxes": 11182.35,
    "new_taxes_no_override": 11665.43,
    "override_total_1": 11996.43,
    "override_increase_1": 331.0
  },
  {
    "#": "674 Newton St (402-29-00)",
    "$": 1222000,
    "address": "674 Newton St",
    "parcel_id": "402-29-00",
    "owner1": "LU, SHIHUA",
    "owner2": "ZHONG, ZHAOXI",
    "current_taxes": 8878.35,
    "new_taxes_no_override": 9261.89,
    "override_total_1": 9524.69,
    "override_increase_1": 262.8
  },
  {
    "#": "680 Newton St (402-30-00)",
    "$": 958700,
    "address": "680 Newton St",
    "parcel_id": "402-30-00",
    "owner1": "FUOCO, LAURA M",
    "owner2": "",
    "current_taxes": 9817.09,
    "new_taxes_no_override": 10241.19,
    "override_total_1": 10531.77,
    "override_increase_1": 290.59
  },
  {
    "#": "684 Newton St (402-31-00)",
    "$": 1239400,
    "address": "684 Newton St",
    "parcel_id": "402-31-00",
    "owner1": "BONIS LIFE ESTATE, EVA M",
    "owner2": "",
    "current_taxes": 9056.52,
    "new_taxes_no_override": 9447.76,
    "override_total_1": 9715.83,
    "override_increase_1": 268.07
  },
  {
    "#": "690 Newton St (402-32-00)",
    "$": 1489900,
    "address": "690 Newton St",
    "parcel_id": "402-32-00",
    "owner1": "REID, ELIZABETH",
    "owner2": "ABOOKIRE, ROBERT",
    "current_taxes": 11621.64,
    "new_taxes_no_override": 12123.69,
    "override_total_1": 12467.7,
    "override_increase_1": 344.0
  },
  {
    "#": "716 Newton St (408-11-00)",
    "$": 2744300,
    "address": "716 Newton St",
    "parcel_id": "408-11-00",
    "owner1": "ALTAN, BETUL S",
    "owner2": "",
    "current_taxes": 28101.63,
    "new_taxes_no_override": 29315.62,
    "override_total_1": 30147.43,
    "override_increase_1": 831.81
  },
  {
    "#": "721 Newton St (418-13-00)",
    "$": 1573900,
    "address": "721 Newton St",
    "parcel_id": "418-13-00",
    "owner1": "SZETO, BENNY & NORA",
    "owner2": "CHU, YUE",
    "current_taxes": 12481.8,
    "new_taxes_no_override": 13021.01,
    "override_total_1": 13390.48,
    "override_increase_1": 369.46
  },
  {
    "#": "728 Newton St (408-10-00)",
    "$": 1764400,
    "address": "728 Newton St",
    "parcel_id": "408-10-00",
    "owner1": "KINZER TR, PATRICIA A",
    "owner2": "RAVELSON TR, SCOTT C",
    "current_taxes": 14432.52,
    "new_taxes_no_override": 15056.0,
    "override_total_1": 15483.21,
    "override_increase_1": 427.2
  },
  {
    "#": "729 Newton St (418-12-02)",
    "$": 1876000,
    "address": "729 Newton St",
    "parcel_id": "418-12-02",
    "owner1": "LEMBO, PAUL B",
    "owner2": "SPENCER, ANNE E",
    "current_taxes": 15575.31,
    "new_taxes_no_override": 16248.16,
    "override_total_1": 16709.19,
    "override_increase_1": 461.03
  },
  {
    "#": "737 Newton St (418-12-01)",
    "$": 4824200,
    "address": "737 Newton St",
    "parcel_id": "418-12-01",
    "owner1": "MALHORTA, DEEPAK K & SHIKHA M",
    "owner2": "",
    "current_taxes": 49399.81,
    "new_taxes_no_override": 51533.88,
    "override_total_1": 52996.12,
    "override_increase_1": 1462.23
  },
  {
    "#": "740 Newton St (408-26-00)",
    "$": 3034000,
    "address": "740 Newton St",
    "parcel_id": "408-26-00",
    "owner1": "CANNATA, FRANK J & DEANNA",
    "owner2": "",
    "current_taxes": 27433.23,
    "new_taxes_no_override": 28618.35,
    "override_total_1": 29430.37,
    "override_increase_1": 812.02
  },
  {
    "#": "744 Newton St (408-25-00)",
    "$": 2958800,
    "address": "744 Newton St",
    "parcel_id": "408-25-00",
    "owner1": "AN, BICHENG",
    "owner2": "HOU, LILI",
    "current_taxes": 26663.18,
    "new_taxes_no_override": 27815.03,
    "override_total_1": 28604.26,
    "override_increase_1": 789.23
  },
  {
    "#": "745 Newton St (418-12-00)",
    "$": 2342400,
    "address": "745 Newton St",
    "parcel_id": "418-12-00",
    "owner1": "BLEICH TR, SARA N",
    "owner2": "",
    "current_taxes": 20351.24,
    "new_taxes_no_override": 21230.41,
    "override_total_1": 21832.81,
    "override_increase_1": 602.4
  },
  {
    "#": "750 Newton St (408-22-00)",
    "$": 2837800,
    "address": "750 Newton St",
    "parcel_id": "408-22-00",
    "owner1": "FRANCONA, JACQUELINE S",
    "owner2": "",
    "current_taxes": 29059.07,
    "new_taxes_no_override": 30314.42,
    "override_total_1": 31174.57,
    "override_increase_1": 860.15
  },
  {
    "#": "753 Newton St (418-11-02)",
    "$": 1600000,
    "address": "753 Newton St",
    "parcel_id": "418-11-02",
    "owner1": "ROSENGARD, ROBERT M",
    "owner2": "RANDHAWA, P K",
    "current_taxes": 12749.07,
    "new_taxes_no_override": 13299.83,
    "override_total_1": 13677.2,
    "override_increase_1": 377.37
  },
  {
    "#": "754 Newton St (408-23-00)",
    "$": 2589000,
    "address": "754 Newton St",
    "parcel_id": "408-23-00",
    "owner1": "KURTZ, NANCY B & MICHAEL P",
    "owner2": "",
    "current_taxes": 22876.43,
    "new_taxes_no_override": 23864.69,
    "override_total_1": 24541.83,
    "override_increase_1": 677.14
  },
  {
    "#": "761 Newton St (418-11-01)",
    "$": 1675200,
    "address": "761 Newton St",
    "parcel_id": "418-11-01",
    "owner1": "YU, ZHANYANG",
    "owner2": "LIU, CHUNRU",
    "current_taxes": 17154.05,
    "new_taxes_no_override": 17895.1,
    "override_total_1": 18402.86,
    "override_increase_1": 507.76
  },
  {
    "#": "767 Newton St (418-11-00)",
    "$": 3203200,
    "address": "767 Newton St",
    "parcel_id": "418-11-00",
    "owner1": "STONE, SCELLIG & ANGELA",
    "owner2": "",
    "current_taxes": 29165.83,
    "new_taxes_no_override": 30425.79,
    "override_total_1": 31289.1,
    "override_increase_1": 863.31
  },
  {
    "#": "775 Newton St (418-10-00)",
    "$": 1817400,
    "address": "775 Newton St",
    "parcel_id": "418-10-00",
    "owner1": "DIAMOND, RICHARD & ARLENE",
    "owner2": "",
    "current_taxes": 14975.24,
    "new_taxes_no_override": 15622.17,
    "override_total_1": 16065.44,
    "override_increase_1": 443.27
  },
  {
    "#": "776 Newton St (410-16-00)",
    "$": 1491500,
    "address": "776 Newton St",
    "parcel_id": "410-16-00",
    "owner1": "EBADI, AIDA SOROORI",
    "owner2": "SOROORI, BAHMAN",
    "current_taxes": 11638.03,
    "new_taxes_no_override": 12140.79,
    "override_total_1": 12485.28,
    "override_increase_1": 344.49
  },
  {
    "#": "783 Newton St (418-09-00)",
    "$": 3610300,
    "address": "783 Newton St",
    "parcel_id": "418-09-00",
    "owner1": "BRANOVER, ALEXANDER",
    "owner2": "LITMANOVICH, DIANA",
    "current_taxes": 33334.54,
    "new_taxes_no_override": 34774.59,
    "override_total_1": 35761.29,
    "override_increase_1": 986.7
  },
  {
    "#": "786 Newton St (410-17-00)",
    "$": 1815100,
    "address": "786 Newton St",
    "parcel_id": "410-17-00",
    "owner1": "KOTZEN, KAREN S",
    "owner2": "",
    "current_taxes": 14951.69,
    "new_taxes_no_override": 15597.6,
    "override_total_1": 16040.17,
    "override_increase_1": 442.57
  },
  {
    "#": "800 Newton St (410-18-19)",
    "$": 2749900,
    "address": "800 Newton St",
    "parcel_id": "410-18-19",
    "owner1": "CUNNINGHAM, JASON C",
    "owner2": "",
    "current_taxes": 24524.04,
    "new_taxes_no_override": 25583.48,
    "override_total_1": 26309.39,
    "override_increase_1": 725.91
  },
  {
    "#": "806 Newton St (410-20-00)",
    "$": 1392800,
    "address": "806 Newton St",
    "parcel_id": "410-20-00",
    "owner1": "ISHKANIAN TRS, RICHARD N & CAROL",
    "owner2": "",
    "current_taxes": 10627.34,
    "new_taxes_no_override": 11086.44,
    "override_total_1": 11401.01,
    "override_increase_1": 314.57
  },
  {
    "#": "807 Newton St (418-01-00)",
    "$": 23057500,
    "address": "807 Newton St",
    "parcel_id": "418-01-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O INCINERATOR LAND, SKYLINE PARK",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "815 Newton St (418-19-00)",
    "$": 37083500,
    "address": "815 Newton St",
    "parcel_id": "418-19-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O INCINERATOR/TRANSFER STATION",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "820 Newton St, Unit 820 (411-06-02)",
    "$": 2499300,
    "address": "820 Newton St, Unit 820",
    "parcel_id": "411-06-02",
    "owner1": "WILLIAMS, FRANK JR",
    "owner2": "SNOW-WILLIAMS, DENISE K",
    "current_taxes": 25592.83,
    "new_taxes_no_override": 26698.44,
    "override_total_1": 27455.99,
    "override_increase_1": 757.55
  },
  {
    "#": "823 Newton St (417-07-03)",
    "$": 2805300,
    "address": "823 Newton St",
    "parcel_id": "417-07-03",
    "owner1": "SOPP, WILLIAM V",
    "owner2": "SADEGHI, SORAYA",
    "current_taxes": 28726.27,
    "new_taxes_no_override": 29967.24,
    "override_total_1": 30817.54,
    "override_increase_1": 850.3
  },
  {
    "#": "830 Newton St (411-09-00)",
    "$": 2591100,
    "address": "830 Newton St",
    "parcel_id": "411-09-00",
    "owner1": "STICH, HARRIET S & ANDREW C",
    "owner2": "",
    "current_taxes": 22897.93,
    "new_taxes_no_override": 23887.12,
    "override_total_1": 24564.9,
    "override_increase_1": 677.78
  },
  {
    "#": "833 Newton St (417-07-02)",
    "$": 1682800,
    "address": "833 Newton St",
    "parcel_id": "417-07-02",
    "owner1": "KASETTY TRS, KUMARASWAMY & ARTHI",
    "owner2": "",
    "current_taxes": 13596.94,
    "new_taxes_no_override": 14184.33,
    "override_total_1": 14586.8,
    "override_increase_1": 402.47
  },
  {
    "#": "835 Newton St (417-06-00)",
    "$": 2210200,
    "address": "835 Newton St",
    "parcel_id": "417-06-00",
    "owner1": "ALBERT, SCOTT E",
    "owner2": "",
    "current_taxes": 18997.51,
    "new_taxes_no_override": 19818.2,
    "override_total_1": 20380.53,
    "override_increase_1": 562.33
  },
  {
    "#": "840 Newton St, Unit 840 (411-06-03)",
    "$": 2611500,
    "address": "840 Newton St, Unit 840",
    "parcel_id": "411-06-03",
    "owner1": "SMITH, DANIEL J",
    "owner2": "JOHNSON, LESLIE N",
    "current_taxes": 23106.83,
    "new_taxes_no_override": 24105.05,
    "override_total_1": 24789.01,
    "override_increase_1": 683.96
  },
  {
    "#": "844 Newton St, Unit 844 (411-06-04)",
    "$": 2602000,
    "address": "844 Newton St, Unit 844",
    "parcel_id": "411-06-04",
    "owner1": "BAKSHI, KAAJAL & MANJIT",
    "owner2": "",
    "current_taxes": 23009.55,
    "new_taxes_no_override": 24003.56,
    "override_total_1": 24684.65,
    "override_increase_1": 681.08
  },
  {
    "#": "850 Newton St (411-04-00)",
    "$": 3532500,
    "address": "850 Newton St",
    "parcel_id": "411-04-00",
    "owner1": "NIEDERMEYER JR, THOMAS F",
    "owner2": "C/O MATRIX FINANCIAL",
    "current_taxes": 36172.8,
    "new_taxes_no_override": 37735.46,
    "override_total_1": 38806.18,
    "override_increase_1": 1070.71
  },
  {
    "#": "854 Newton St (411-03-00)",
    "$": 3427800,
    "address": "854 Newton St",
    "parcel_id": "411-03-00",
    "owner1": "CHESNICK, ANDREW H & LYDIA G",
    "owner2": "",
    "current_taxes": 31465.74,
    "new_taxes_no_override": 32825.06,
    "override_total_1": 33756.45,
    "override_increase_1": 931.39
  },
  {
    "#": "860 Newton St (411-05-00)",
    "$": 4259100,
    "address": "860 Newton St",
    "parcel_id": "411-05-00",
    "owner1": "GREER, JONATHAN R & LYNNE P",
    "owner2": "",
    "current_taxes": 39978.25,
    "new_taxes_no_override": 41705.31,
    "override_total_1": 42888.67,
    "override_increase_1": 1183.36
  },
  {
    "#": "864 Newton St, Unit 864 (411-06-05)",
    "$": 2447100,
    "address": "864 Newton St, Unit 864",
    "parcel_id": "411-06-05",
    "owner1": "FINKIELSZTEIN, EDUARDO & KAREN",
    "owner2": "",
    "current_taxes": 21423.37,
    "new_taxes_no_override": 22348.86,
    "override_total_1": 22982.99,
    "override_increase_1": 634.13
  },
  {
    "#": "868 Newton St, Unit 868 (411-06-06)",
    "$": 2438600,
    "address": "868 Newton St, Unit 868",
    "parcel_id": "411-06-06",
    "owner1": "FARB, DAVID H",
    "owner2": "RUSSEK, SHELLEY J",
    "current_taxes": 21336.33,
    "new_taxes_no_override": 22258.06,
    "override_total_1": 22889.61,
    "override_increase_1": 631.56
  },
  {
    "#": "6 Norfolk Rd (279-10-00)",
    "$": 4668800,
    "address": "6 Norfolk Rd",
    "parcel_id": "279-10-00",
    "owner1": "LEE, FRANK D",
    "owner2": "HALL, CAROL V",
    "current_taxes": 44173.58,
    "new_taxes_no_override": 46081.88,
    "override_total_1": 47389.42,
    "override_increase_1": 1307.54
  },
  {
    "#": "14 Norfolk Rd (279-09-00)",
    "$": 2843000,
    "address": "14 Norfolk Rd",
    "parcel_id": "279-09-00",
    "owner1": "FIRST CHURCH",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "15 Norfolk Rd (283-04-00)",
    "$": 3759400,
    "address": "15 Norfolk Rd",
    "parcel_id": "283-04-00",
    "owner1": "KYRIAZI, THEO MELAS & LISA",
    "owner2": "",
    "current_taxes": 34861.32,
    "new_taxes_no_override": 36367.33,
    "override_total_1": 37399.22,
    "override_increase_1": 1031.9
  },
  {
    "#": "30 Norfolk Rd (279-08-00)",
    "$": 6071700,
    "address": "30 Norfolk Rd",
    "parcel_id": "279-08-00",
    "owner1": "ALBRIGHT, LARS & LAWSON",
    "owner2": "",
    "current_taxes": 62174.21,
    "new_taxes_no_override": 64860.14,
    "override_total_1": 66700.49,
    "override_increase_1": 1840.36
  },
  {
    "#": "40 Norfolk Rd (279-07-00)",
    "$": 7049600,
    "address": "40 Norfolk Rd",
    "parcel_id": "279-07-00",
    "owner1": "LUBY , STEVEN C",
    "owner2": "KACZOR, KRISTINE L",
    "current_taxes": 68552.97,
    "new_taxes_no_override": 71514.46,
    "override_total_1": 73543.63,
    "override_increase_1": 2029.17
  },
  {
    "#": "47 Norfolk Rd (284-08-00)",
    "$": 4576900,
    "address": "47 Norfolk Rd",
    "parcel_id": "284-08-00",
    "owner1": "LEWIS, JONATHON D & DANA F P",
    "owner2": "",
    "current_taxes": 43232.52,
    "new_taxes_no_override": 45100.16,
    "override_total_1": 46379.85,
    "override_increase_1": 1279.68
  },
  {
    "#": "52 Norfolk Rd (279-06-00)",
    "$": 5876600,
    "address": "52 Norfolk Rd",
    "parcel_id": "279-06-00",
    "owner1": "WYNER, JAMES HENRY & GIANG THI H",
    "owner2": "",
    "current_taxes": 56541.45,
    "new_taxes_no_override": 58984.04,
    "override_total_1": 60657.67,
    "override_increase_1": 1673.63
  },
  {
    "#": "63 Norfolk Rd (284-13-00)",
    "$": 4022500,
    "address": "63 Norfolk Rd",
    "parcel_id": "284-13-00",
    "owner1": "DEVAIAH, ANAND",
    "owner2": "SUBRAMANIAN, MANJU",
    "current_taxes": 37555.47,
    "new_taxes_no_override": 39177.87,
    "override_total_1": 40289.51,
    "override_increase_1": 1111.64
  },
  {
    "#": "66 Norfolk Rd (278C-24-00)",
    "$": 3247500,
    "address": "66 Norfolk Rd",
    "parcel_id": "278C-24-00",
    "owner1": "METZGER FILHO, OTTO",
    "owner2": "METZGER, ANA PAULA DE ABREU E SILVA",
    "current_taxes": 29619.47,
    "new_taxes_no_override": 30899.03,
    "override_total_1": 31775.77,
    "override_increase_1": 876.74
  },
  {
    "#": "76 Norfolk Rd (278C-23-00)",
    "$": 2374700,
    "address": "76 Norfolk Rd",
    "parcel_id": "278C-23-00",
    "owner1": "HARPIN TR, MARC R",
    "owner2": "TOOMAJANIAN, GARO R",
    "current_taxes": 20681.99,
    "new_taxes_no_override": 21575.45,
    "override_total_1": 22187.64,
    "override_increase_1": 612.19
  },
  {
    "#": "77 Norfolk Rd (284-14-01)",
    "$": 3349200,
    "address": "77 Norfolk Rd",
    "parcel_id": "284-14-01",
    "owner1": "KOENIG TRS, DAVID & MARIELA",
    "owner2": "",
    "current_taxes": 30660.87,
    "new_taxes_no_override": 31985.42,
    "override_total_1": 32892.98,
    "override_increase_1": 907.56
  },
  {
    "#": "15 Oak St, Unit 15 (432-18-01)",
    "$": 1486300,
    "address": "15 Oak St, Unit 15",
    "parcel_id": "432-18-01",
    "owner1": "ARORA, GAURAV",
    "owner2": "DIECKER, BARBARA",
    "current_taxes": 11584.78,
    "new_taxes_no_override": 12085.24,
    "override_total_1": 12428.15,
    "override_increase_1": 342.91
  },
  {
    "#": "15 Oak St, Unit 17 (432-18-02)",
    "$": 1583400,
    "address": "15 Oak St, Unit 17",
    "parcel_id": "432-18-02",
    "owner1": "PIATETSKY, MATTHEW MEDVEDEV",
    "owner2": "KARPOVA, NADEZHDA",
    "current_taxes": 12579.08,
    "new_taxes_no_override": 13122.5,
    "override_total_1": 13494.84,
    "override_increase_1": 372.34
  },
  {
    "#": "15 Oak St, Unit 19 (432-18-03)",
    "$": 1501300,
    "address": "15 Oak St, Unit 19",
    "parcel_id": "432-18-03",
    "owner1": "YU, YANZHI",
    "owner2": "LIN, YUAN",
    "current_taxes": 11738.38,
    "new_taxes_no_override": 12245.48,
    "override_total_1": 12592.93,
    "override_increase_1": 347.46
  },
  {
    "#": "7 Oakland Rd (307-23-00)",
    "$": 2342200,
    "address": "7 Oakland Rd",
    "parcel_id": "307-23-00",
    "owner1": "CARAMELLO, NICHOLAS I",
    "owner2": "",
    "current_taxes": 20349.19,
    "new_taxes_no_override": 21228.28,
    "override_total_1": 21830.61,
    "override_increase_1": 602.34
  },
  {
    "#": "15 Oakland Rd (307-24-00)",
    "$": 1451900,
    "address": "15 Oakland Rd",
    "parcel_id": "307-24-00",
    "owner1": "LIPSITT, ET AL, PETER R",
    "owner2": "",
    "current_taxes": 11232.52,
    "new_taxes_no_override": 11717.76,
    "override_total_1": 12050.25,
    "override_increase_1": 332.48
  },
  {
    "#": "18 Oakland Rd (308-99-02)",
    "$": 1916600,
    "address": "18 Oakland Rd",
    "parcel_id": "308-99-02",
    "owner1": "RISSE, JOHN & MEIGAN",
    "owner2": "CAZORT, VIRGINIA",
    "current_taxes": 15991.05,
    "new_taxes_no_override": 16681.86,
    "override_total_1": 17155.2,
    "override_increase_1": 473.34
  },
  {
    "#": "19 Oakland Rd (307-25-00)",
    "$": 1959100,
    "address": "19 Oakland Rd",
    "parcel_id": "307-25-00",
    "owner1": "ROBB TRS, LUCY L",
    "owner2": "MCBRINE , JOHN A",
    "current_taxes": 16426.25,
    "new_taxes_no_override": 17135.86,
    "override_total_1": 17622.08,
    "override_increase_1": 486.22
  },
  {
    "#": "22 Oakland Rd (308-99-01)",
    "$": 2755900,
    "address": "22 Oakland Rd",
    "parcel_id": "308-99-01",
    "owner1": "BANERJEE, ANURAG",
    "owner2": "KRISHNAN, SUMANGALI",
    "current_taxes": 28220.42,
    "new_taxes_no_override": 29439.54,
    "override_total_1": 30274.87,
    "override_increase_1": 835.32
  },
  {
    "#": "28 Oakland Rd (308-99-00)",
    "$": 2391700,
    "address": "28 Oakland Rd",
    "parcel_id": "308-99-00",
    "owner1": "WHITE, ANDREW P & KIRIAKI C",
    "owner2": "",
    "current_taxes": 24491.01,
    "new_taxes_no_override": 25549.02,
    "override_total_1": 26273.96,
    "override_increase_1": 724.93
  },
  {
    "#": "32 Oakland Rd (308-98-00)",
    "$": 1362200,
    "address": "32 Oakland Rd",
    "parcel_id": "308-98-00",
    "owner1": "CAMPBELL, JOHN E & CRANFORD S",
    "owner2": "",
    "current_taxes": 13948.93,
    "new_taxes_no_override": 14551.52,
    "override_total_1": 14964.41,
    "override_increase_1": 412.89
  },
  {
    "#": "33 Oakland Rd (307-30-31)",
    "$": 1737700,
    "address": "33 Oakland Rd",
    "parcel_id": "307-30-31",
    "owner1": "CLARK TR, AMY",
    "owner2": "",
    "current_taxes": 14159.11,
    "new_taxes_no_override": 14770.78,
    "override_total_1": 15189.89,
    "override_increase_1": 419.11
  },
  {
    "#": "35 Oakland Rd (307-32-00)",
    "$": 2320200,
    "address": "35 Oakland Rd",
    "parcel_id": "307-32-00",
    "owner1": "MONGEON, BRAD ANTHONY",
    "owner2": "GIOVANNI, MONICA ALICIA",
    "current_taxes": 20123.91,
    "new_taxes_no_override": 20993.26,
    "override_total_1": 21588.93,
    "override_increase_1": 595.67
  },
  {
    "#": "36 Oakland Rd (308-97-01)",
    "$": 2166100,
    "address": "36 Oakland Rd",
    "parcel_id": "308-97-01",
    "owner1": "SPIELVOGEL, ROBERT",
    "owner2": "FLANNERY, KAREN M",
    "current_taxes": 18545.93,
    "new_taxes_no_override": 19347.11,
    "override_total_1": 19896.07,
    "override_increase_1": 548.96
  },
  {
    "#": "39 Oakland Rd (308-88-00)",
    "$": 1564700,
    "address": "39 Oakland Rd",
    "parcel_id": "308-88-00",
    "owner1": "KUO, JUSTIN F & CAROL D",
    "owner2": "",
    "current_taxes": 12387.59,
    "new_taxes_no_override": 12922.73,
    "override_total_1": 13289.41,
    "override_increase_1": 366.67
  },
  {
    "#": "40 Oakland Rd, Unit 1 & P-A&C (308-96-04)",
    "$": 1751100,
    "address": "40 Oakland Rd, Unit 1 & P-A&C",
    "parcel_id": "308-96-04",
    "owner1": "LEE TR, HEUNG HAE",
    "owner2": "",
    "current_taxes": 14296.33,
    "new_taxes_no_override": 14913.93,
    "override_total_1": 15337.1,
    "override_increase_1": 423.17
  },
  {
    "#": "40 Oakland Rd, Unit 2 & P-B&D (308-96-05)",
    "$": 1708900,
    "address": "40 Oakland Rd, Unit 2 & P-B&D",
    "parcel_id": "308-96-05",
    "owner1": "RILEY, THOMAS",
    "owner2": "",
    "current_taxes": 13864.2,
    "new_taxes_no_override": 14463.13,
    "override_total_1": 14873.51,
    "override_increase_1": 410.38
  },
  {
    "#": "43 Oakland Rd (308-89-00)",
    "$": 1898700,
    "address": "43 Oakland Rd",
    "parcel_id": "308-89-00",
    "owner1": "SHEEHY, KATHLEEN",
    "owner2": "",
    "current_taxes": 15807.75,
    "new_taxes_no_override": 16490.64,
    "override_total_1": 16958.55,
    "override_increase_1": 467.91
  },
  {
    "#": "50 Oakland Rd (308-96-02)",
    "$": 1867000,
    "address": "50 Oakland Rd",
    "parcel_id": "308-96-02",
    "owner1": "MCLEAN, PAUL C",
    "owner2": "LEADER, JODY J",
    "current_taxes": 19118.08,
    "new_taxes_no_override": 19943.98,
    "override_total_1": 20509.88,
    "override_increase_1": 565.9
  },
  {
    "#": "51 Oakland Rd (308-90-00)",
    "$": 2167600,
    "address": "51 Oakland Rd",
    "parcel_id": "308-90-00",
    "owner1": "MAGEE TRS, JOHN J",
    "owner2": "MCNEICE, MICHELLE M",
    "current_taxes": 18561.29,
    "new_taxes_no_override": 19363.14,
    "override_total_1": 19912.55,
    "override_increase_1": 549.41
  },
  {
    "#": "55 Oakland Rd, Unit 1 (308-91-01)",
    "$": 1183800,
    "address": "55 Oakland Rd, Unit 1",
    "parcel_id": "308-91-01",
    "owner1": "CORNELLA-TARACIDO, IVAN",
    "owner2": "BOTANA-MARTINEZ, MARIA PILAR",
    "current_taxes": 8487.18,
    "new_taxes_no_override": 8853.83,
    "override_total_1": 9105.05,
    "override_increase_1": 251.22
  },
  {
    "#": "55 Oakland Rd, Unit 2 (308-91-02)",
    "$": 1050800,
    "address": "55 Oakland Rd, Unit 2",
    "parcel_id": "308-91-02",
    "owner1": "VIZZA, ELIZABETH A",
    "owner2": "",
    "current_taxes": 7125.26,
    "new_taxes_no_override": 7433.07,
    "override_total_1": 7643.98,
    "override_increase_1": 210.91
  },
  {
    "#": "56 Oakland Rd (308-96-03)",
    "$": 1560300,
    "address": "56 Oakland Rd",
    "parcel_id": "308-96-03",
    "owner1": "CAI, VIET LUKASZ",
    "owner2": "VO, ANH-THU ELAINE",
    "current_taxes": 12342.54,
    "new_taxes_no_override": 12875.74,
    "override_total_1": 13241.08,
    "override_increase_1": 365.34
  },
  {
    "#": "59 Oakland Rd (308-92-00)",
    "$": 1665000,
    "address": "59 Oakland Rd",
    "parcel_id": "308-92-00",
    "owner1": "MCLEAN, PAUL C",
    "owner2": "LEADER, JODY J",
    "current_taxes": 13414.67,
    "new_taxes_no_override": 13994.18,
    "override_total_1": 14391.26,
    "override_increase_1": 397.07
  },
  {
    "#": " Oakland Rd (308-84-00)",
    "$": 89700,
    "address": " Oakland Rd",
    "parcel_id": "308-84-00",
    "owner1": "MCLEAN, PAUL C",
    "owner2": "LEADER, JODY J",
    "current_taxes": 918.53,
    "new_taxes_no_override": 958.21,
    "override_total_1": 985.4,
    "override_increase_1": 27.19
  },
  {
    "#": " Oakland Rd (308-86-87)",
    "$": 177500,
    "address": " Oakland Rd",
    "parcel_id": "308-86-87",
    "owner1": "CAI, VIET LUKASZ",
    "owner2": "VO, ANH-THU ELAINE",
    "current_taxes": 1817.6,
    "new_taxes_no_override": 1896.12,
    "override_total_1": 1949.92,
    "override_increase_1": 53.8
  },
  {
    "#": "104 Oakland Rd Ext (308-61-00)",
    "$": 2127700,
    "address": "104 Oakland Rd Ext",
    "parcel_id": "308-61-00",
    "owner1": "SILVA TRS, DAVID F",
    "owner2": "KANTZ, MARY ELIZABETH",
    "current_taxes": 18152.71,
    "new_taxes_no_override": 18936.91,
    "override_total_1": 19474.23,
    "override_increase_1": 537.32
  },
  {
    "#": "105 Oakland Rd Ext, Unit 105 (308-62-02)",
    "$": 675500,
    "address": "105 Oakland Rd Ext, Unit 105",
    "parcel_id": "308-62-02",
    "owner1": "MORRIS, ET AL, FRANCIS K",
    "owner2": "",
    "current_taxes": 3282.19,
    "new_taxes_no_override": 3423.98,
    "override_total_1": 3521.13,
    "override_increase_1": 97.15
  },
  {
    "#": "107 Oakland Rd Ext, Unit 107 (308-62-01)",
    "$": 684000,
    "address": "107 Oakland Rd Ext, Unit 107",
    "parcel_id": "308-62-01",
    "owner1": "FLAHERTY, RUTH",
    "owner2": "",
    "current_taxes": 3369.23,
    "new_taxes_no_override": 3514.78,
    "override_total_1": 3614.51,
    "override_increase_1": 99.73
  },
  {
    "#": "108 Oakland Rd Ext (308-60-00)",
    "$": 1810400,
    "address": "108 Oakland Rd Ext",
    "parcel_id": "308-60-00",
    "owner1": "ROACH, SAMUEL D & KATHRYN B",
    "owner2": "",
    "current_taxes": 14903.56,
    "new_taxes_no_override": 15547.39,
    "override_total_1": 15988.54,
    "override_increase_1": 441.15
  },
  {
    "#": "111 Oakland Rd Ext (308-63-00)",
    "$": 1446100,
    "address": "111 Oakland Rd Ext",
    "parcel_id": "308-63-00",
    "owner1": "CHEN, JIAGENG",
    "owner2": "JIEZHI, WANG",
    "current_taxes": 11173.13,
    "new_taxes_no_override": 11655.81,
    "override_total_1": 11986.53,
    "override_increase_1": 330.72
  },
  {
    "#": "112 Oakland Rd Ext, Unit 2 (308-59-02)",
    "$": 1323100,
    "address": "112 Oakland Rd Ext, Unit 2",
    "parcel_id": "308-59-02",
    "owner1": "FURCHTGOTT, LEON & DEBORAH",
    "owner2": "",
    "current_taxes": 9913.61,
    "new_taxes_no_override": 10341.88,
    "override_total_1": 10635.32,
    "override_increase_1": 293.44
  },
  {
    "#": "114 Oakland Rd Ext, Unit 1 (308-59-01)",
    "$": 860700,
    "address": "114 Oakland Rd Ext, Unit 1",
    "parcel_id": "308-59-01",
    "owner1": "ANJIR LLC",
    "owner2": "",
    "current_taxes": 8813.57,
    "new_taxes_no_override": 9194.32,
    "override_total_1": 9455.2,
    "override_increase_1": 260.88
  },
  {
    "#": "11 Ogden Rd (375C-01-00)",
    "$": 1212200,
    "address": "11 Ogden Rd",
    "parcel_id": "375C-01-00",
    "owner1": "KALISH, JOHN D",
    "owner2": "",
    "current_taxes": 8777.99,
    "new_taxes_no_override": 9157.2,
    "override_total_1": 9417.03,
    "override_increase_1": 259.83
  },
  {
    "#": "14 Ogden Rd (375B-15-00)",
    "$": 1680800,
    "address": "14 Ogden Rd",
    "parcel_id": "375B-15-00",
    "owner1": "DEMICCO, JAMES R & DIANE E CHESTER",
    "owner2": "",
    "current_taxes": 13576.46,
    "new_taxes_no_override": 14162.96,
    "override_total_1": 14564.83,
    "override_increase_1": 401.86
  },
  {
    "#": "20 Ogden Rd (375B-14-00)",
    "$": 1480400,
    "address": "20 Ogden Rd",
    "parcel_id": "375B-14-00",
    "owner1": "WARSH TR, ROBIN A",
    "owner2": "",
    "current_taxes": 11524.36,
    "new_taxes_no_override": 12022.21,
    "override_total_1": 12363.33,
    "override_increase_1": 341.12
  },
  {
    "#": "21 Ogden Rd (375D-09-00)",
    "$": 1204000,
    "address": "21 Ogden Rd",
    "parcel_id": "375D-09-00",
    "owner1": "ALBUREZ, RICARDO A",
    "owner2": "",
    "current_taxes": 12328.96,
    "new_taxes_no_override": 12861.57,
    "override_total_1": 13226.51,
    "override_increase_1": 364.94
  },
  {
    "#": "24 Ogden Rd (375B-13-00)",
    "$": 1583100,
    "address": "24 Ogden Rd",
    "parcel_id": "375B-13-00",
    "owner1": "XU, CAIYUE",
    "owner2": "LEI, JIUSI",
    "current_taxes": 12576.01,
    "new_taxes_no_override": 13119.29,
    "override_total_1": 13491.54,
    "override_increase_1": 372.25
  },
  {
    "#": "27 Ogden Rd (375D-10-00)",
    "$": 1595400,
    "address": "27 Ogden Rd",
    "parcel_id": "375D-10-00",
    "owner1": "SONG, XIANG",
    "owner2": "ZHANG, XIAOYU",
    "current_taxes": 16336.9,
    "new_taxes_no_override": 17042.65,
    "override_total_1": 17526.23,
    "override_increase_1": 483.57
  },
  {
    "#": "30 Ogden Rd (375B-12-00)",
    "$": 1425200,
    "address": "30 Ogden Rd",
    "parcel_id": "375B-12-00",
    "owner1": "EVANS, ERIC M",
    "owner2": "ARNOLD, MELISSA S",
    "current_taxes": 10959.11,
    "new_taxes_no_override": 11432.54,
    "override_total_1": 11756.93,
    "override_increase_1": 324.39
  },
  {
    "#": "35 Ogden Rd (375D-01-00)",
    "$": 1236100,
    "address": "35 Ogden Rd",
    "parcel_id": "375D-01-00",
    "owner1": "RIVERBEE, AMY B",
    "owner2": "",
    "current_taxes": 9022.73,
    "new_taxes_no_override": 9412.51,
    "override_total_1": 9679.58,
    "override_increase_1": 267.07
  },
  {
    "#": "36 Ogden Rd (375B-11-00)",
    "$": 1577700,
    "address": "36 Ogden Rd",
    "parcel_id": "375B-11-00",
    "owner1": "SHUMAR, SHEB & LEILA",
    "owner2": "",
    "current_taxes": 12520.71,
    "new_taxes_no_override": 13061.6,
    "override_total_1": 13432.22,
    "override_increase_1": 370.61
  },
  {
    "#": "42 Ogden Rd (375B-10-00)",
    "$": 1634800,
    "address": "42 Ogden Rd",
    "parcel_id": "375B-10-00",
    "owner1": "COSKUN, MUSTAFA & EMILY K",
    "owner2": "",
    "current_taxes": 13105.42,
    "new_taxes_no_override": 13671.57,
    "override_total_1": 14059.49,
    "override_increase_1": 387.92
  },
  {
    "#": "2 Olmsted Rd, Unit 1 & P36 (250-13-12)",
    "$": 428000,
    "address": "2 Olmsted Rd, Unit 1 & P36",
    "parcel_id": "250-13-12",
    "owner1": "BROUSSEAU, JON P & PHILIPPA L",
    "owner2": "",
    "current_taxes": 747.79,
    "new_taxes_no_override": 780.09,
    "override_total_1": 802.23,
    "override_increase_1": 22.13
  },
  {
    "#": "2 Olmsted Rd, Unit 2 & P35 (250-13-13)",
    "$": 246200,
    "address": "2 Olmsted Rd, Unit 2 & P35",
    "parcel_id": "250-13-13",
    "owner1": "HUGGINS, YEANIE",
    "owner2": "",
    "current_taxes": 252.11,
    "new_taxes_no_override": 263.0,
    "override_total_1": 270.46,
    "override_increase_1": 7.46
  },
  {
    "#": "2 Olmsted Rd, Unit 3 & P37 (250-13-14)",
    "$": 233800,
    "address": "2 Olmsted Rd, Unit 3 & P37",
    "parcel_id": "250-13-14",
    "owner1": "CHIN, WESLEY B",
    "owner2": "WILSON, ABIGAIL E",
    "current_taxes": 239.41,
    "new_taxes_no_override": 249.75,
    "override_total_1": 256.84,
    "override_increase_1": 7.09
  },
  {
    "#": "2 Olmsted Rd, Unit 4 & P38 (250-13-15)",
    "$": 394200,
    "address": "2 Olmsted Rd, Unit 4 & P38",
    "parcel_id": "250-13-15",
    "owner1": "ALMEIDA, LUIS OMAR & MERCEDES",
    "owner2": "",
    "current_taxes": 403.66,
    "new_taxes_no_override": 421.1,
    "override_total_1": 433.05,
    "override_increase_1": 11.95
  },
  {
    "#": "3 Olmsted Rd (250-13-05)",
    "$": 3996500,
    "address": "3 Olmsted Rd",
    "parcel_id": "250-13-05",
    "owner1": "DESAI TRS, SANJAY H & SHEETAL S",
    "owner2": "",
    "current_taxes": 37289.23,
    "new_taxes_no_override": 38900.12,
    "override_total_1": 40003.89,
    "override_increase_1": 1103.76
  },
  {
    "#": "5 Olmsted Rd (250-13-06)",
    "$": 4115500,
    "address": "5 Olmsted Rd",
    "parcel_id": "250-13-06",
    "owner1": "DESHPANDE, DEEP & CHARU",
    "owner2": "",
    "current_taxes": 38507.79,
    "new_taxes_no_override": 40171.33,
    "override_total_1": 41311.16,
    "override_increase_1": 1139.83
  },
  {
    "#": "6 Olmsted Rd, Unit 101 & G10 (250-13-16)",
    "$": 428000,
    "address": "6 Olmsted Rd, Unit 101 & G10",
    "parcel_id": "250-13-16",
    "owner1": "NAJJAR, MILAD & GRAZIELLA GERGI",
    "owner2": "",
    "current_taxes": 747.79,
    "new_taxes_no_override": 780.09,
    "override_total_1": 802.23,
    "override_increase_1": 22.13
  },
  {
    "#": "6 Olmsted Rd, Unit 102 & G1 (250-13-17)",
    "$": 246200,
    "address": "6 Olmsted Rd, Unit 102 & G1",
    "parcel_id": "250-13-17",
    "owner1": "EDMONDSON, EILEEN",
    "owner2": "",
    "current_taxes": 252.11,
    "new_taxes_no_override": 263.0,
    "override_total_1": 270.46,
    "override_increase_1": 7.46
  },
  {
    "#": "6 Olmsted Rd, Unit 103 & G2 (250-13-18)",
    "$": 233800,
    "address": "6 Olmsted Rd, Unit 103 & G2",
    "parcel_id": "250-13-18",
    "owner1": "SANABRIA, LUZ M",
    "owner2": "",
    "current_taxes": 239.41,
    "new_taxes_no_override": 249.75,
    "override_total_1": 256.84,
    "override_increase_1": 7.09
  },
  {
    "#": "6 Olmsted Rd, Unit 104 & G3 (250-13-19)",
    "$": 428000,
    "address": "6 Olmsted Rd, Unit 104 & G3",
    "parcel_id": "250-13-19",
    "owner1": "JOHANSSON, INGRID L",
    "owner2": "",
    "current_taxes": 747.79,
    "new_taxes_no_override": 780.09,
    "override_total_1": 802.23,
    "override_increase_1": 22.13
  },
  {
    "#": "6 Olmsted Rd, Unit 105 & G11 (250-13-20)",
    "$": 230100,
    "address": "6 Olmsted Rd, Unit 105 & G11",
    "parcel_id": "250-13-20",
    "owner1": "CHAN, DAVID K",
    "owner2": "CHEN, HUI XIANG",
    "current_taxes": 235.62,
    "new_taxes_no_override": 245.8,
    "override_total_1": 252.77,
    "override_increase_1": 6.97
  },
  {
    "#": "6 Olmsted Rd, Unit 106 & G4 (250-13-21)",
    "$": 230100,
    "address": "6 Olmsted Rd, Unit 106 & G4",
    "parcel_id": "250-13-21",
    "owner1": "TSE, CHI HANG",
    "owner2": "",
    "current_taxes": 235.62,
    "new_taxes_no_override": 245.8,
    "override_total_1": 252.77,
    "override_increase_1": 6.97
  },
  {
    "#": "6 Olmsted Rd, Unit 201 & G5 (250-13-22)",
    "$": 428000,
    "address": "6 Olmsted Rd, Unit 201 & G5",
    "parcel_id": "250-13-22",
    "owner1": "YANG, HONGWEI",
    "owner2": "PIAO, HUIYING",
    "current_taxes": 747.79,
    "new_taxes_no_override": 780.09,
    "override_total_1": 802.23,
    "override_increase_1": 22.13
  },
  {
    "#": "6 Olmsted Rd, Unit 202 & G6 (250-13-23)",
    "$": 250700,
    "address": "6 Olmsted Rd, Unit 202 & G6",
    "parcel_id": "250-13-23",
    "owner1": "LEUNG, KIM TAI",
    "owner2": "TSANG, NGAN LING",
    "current_taxes": 256.72,
    "new_taxes_no_override": 267.81,
    "override_total_1": 275.41,
    "override_increase_1": 7.6
  },
  {
    "#": "6 Olmsted Rd, Unit 203 & G7 (250-13-24)",
    "$": 230100,
    "address": "6 Olmsted Rd, Unit 203 & G7",
    "parcel_id": "250-13-24",
    "owner1": "AHMED, OMAR K",
    "owner2": "",
    "current_taxes": 235.62,
    "new_taxes_no_override": 245.8,
    "override_total_1": 252.77,
    "override_increase_1": 6.97
  },
  {
    "#": "6 Olmsted Rd, Unit 204 & G8 (250-13-25)",
    "$": 250700,
    "address": "6 Olmsted Rd, Unit 204 & G8",
    "parcel_id": "250-13-25",
    "owner1": "RAMOS, CAROLA M",
    "owner2": "",
    "current_taxes": 256.72,
    "new_taxes_no_override": 267.81,
    "override_total_1": 275.41,
    "override_increase_1": 7.6
  },
  {
    "#": "6 Olmsted Rd, Unit 205 & G9 (250-13-26)",
    "$": 394200,
    "address": "6 Olmsted Rd, Unit 205 & G9",
    "parcel_id": "250-13-26",
    "owner1": "KIM, JAEGIL",
    "owner2": "LIM, SEONG HEE",
    "current_taxes": 403.66,
    "new_taxes_no_override": 421.1,
    "override_total_1": 433.05,
    "override_increase_1": 11.95
  },
  {
    "#": "6 Olmsted Rd, Unit 206 & G12 (250-13-27)",
    "$": 394200,
    "address": "6 Olmsted Rd, Unit 206 & G12",
    "parcel_id": "250-13-27",
    "owner1": "HENRY, WENDY BETH",
    "owner2": "",
    "current_taxes": 403.66,
    "new_taxes_no_override": 421.1,
    "override_total_1": 433.05,
    "override_increase_1": 11.95
  },
  {
    "#": "6 Olmsted Rd, Unit 301 & G13 (250-13-28)",
    "$": 394200,
    "address": "6 Olmsted Rd, Unit 301 & G13",
    "parcel_id": "250-13-28",
    "owner1": "LEE, TAE HO & SUNG HEE",
    "owner2": "",
    "current_taxes": 403.66,
    "new_taxes_no_override": 421.1,
    "override_total_1": 433.05,
    "override_increase_1": 11.95
  },
  {
    "#": "6 Olmsted Rd, Unit 302 & G14 (250-13-29)",
    "$": 233800,
    "address": "6 Olmsted Rd, Unit 302 & G14",
    "parcel_id": "250-13-29",
    "owner1": "WANG, GANG",
    "owner2": "HU, NINGYAN",
    "current_taxes": 239.41,
    "new_taxes_no_override": 249.75,
    "override_total_1": 256.84,
    "override_increase_1": 7.09
  },
  {
    "#": "6 Olmsted Rd, Unit 303 & G15 (250-13-30)",
    "$": 394200,
    "address": "6 Olmsted Rd, Unit 303 & G15",
    "parcel_id": "250-13-30",
    "owner1": "MELLO, MICHAEL J",
    "owner2": "POST, LAUREN S",
    "current_taxes": 403.66,
    "new_taxes_no_override": 421.1,
    "override_total_1": 433.05,
    "override_increase_1": 11.95
  },
  {
    "#": "6 Olmsted Rd, Unit 304 & G16 (250-13-31)",
    "$": 394200,
    "address": "6 Olmsted Rd, Unit 304 & G16",
    "parcel_id": "250-13-31",
    "owner1": "PALERMO, JOSEPH & MELISSA BAKER",
    "owner2": "",
    "current_taxes": 403.66,
    "new_taxes_no_override": 421.1,
    "override_total_1": 433.05,
    "override_increase_1": 11.95
  },
  {
    "#": "7 Olmsted Rd (250-13-07)",
    "$": 3951000,
    "address": "7 Olmsted Rd",
    "parcel_id": "250-13-07",
    "owner1": "DEUTSCH, ERIK R",
    "owner2": "HONG, JULIE J",
    "current_taxes": 36823.31,
    "new_taxes_no_override": 38414.08,
    "override_total_1": 39504.05,
    "override_increase_1": 1089.97
  },
  {
    "#": "8 Olmsted Rd, Unit 1 & P39 (250-13-32)",
    "$": 246200,
    "address": "8 Olmsted Rd, Unit 1 & P39",
    "parcel_id": "250-13-32",
    "owner1": "YE, ZHUO QUN",
    "owner2": "",
    "current_taxes": 252.11,
    "new_taxes_no_override": 263.0,
    "override_total_1": 270.46,
    "override_increase_1": 7.46
  },
  {
    "#": "8 Olmsted Rd, Unit 2 & P40 (250-13-33)",
    "$": 250700,
    "address": "8 Olmsted Rd, Unit 2 & P40",
    "parcel_id": "250-13-33",
    "owner1": "HUANG, SHUANG YU",
    "owner2": "CHEN, SHASHA",
    "current_taxes": 256.72,
    "new_taxes_no_override": 267.81,
    "override_total_1": 275.41,
    "override_increase_1": 7.6
  },
  {
    "#": "8 Olmsted Rd, Unit 3 & P41 (250-13-34)",
    "$": 428000,
    "address": "8 Olmsted Rd, Unit 3 & P41",
    "parcel_id": "250-13-34",
    "owner1": "NOVICKA, NATALIA",
    "owner2": "",
    "current_taxes": 747.79,
    "new_taxes_no_override": 780.09,
    "override_total_1": 802.23,
    "override_increase_1": 22.13
  },
  {
    "#": "8 Olmsted Rd, Unit 4 & P42 (250-13-35)",
    "$": 428000,
    "address": "8 Olmsted Rd, Unit 4 & P42",
    "parcel_id": "250-13-35",
    "owner1": "HARTMAN, MOR-LI",
    "owner2": "",
    "current_taxes": 747.79,
    "new_taxes_no_override": 780.09,
    "override_total_1": 802.23,
    "override_increase_1": 22.13
  },
  {
    "#": "9 Olmsted Rd (250-13-08)",
    "$": 4005100,
    "address": "9 Olmsted Rd",
    "parcel_id": "250-13-08",
    "owner1": "SHANNON TR, CHRISTOPHER A",
    "owner2": "",
    "current_taxes": 41012.22,
    "new_taxes_no_override": 42783.95,
    "override_total_1": 43997.91,
    "override_increase_1": 1213.96
  },
  {
    "#": "10 Olmsted Rd (250-13-10)",
    "$": 4815300,
    "address": "10 Olmsted Rd",
    "parcel_id": "250-13-10",
    "owner1": "ALBERTELLI, ALYSSA",
    "owner2": "",
    "current_taxes": 45673.74,
    "new_taxes_no_override": 47646.85,
    "override_total_1": 48998.79,
    "override_increase_1": 1351.94
  },
  {
    "#": "11 Olmsted Rd (250-13-09)",
    "$": 4890200,
    "address": "11 Olmsted Rd",
    "parcel_id": "250-13-09",
    "owner1": "LEE TRS, KAI WING",
    "owner2": "CHOU-LEE, CHAO N",
    "current_taxes": 46440.71,
    "new_taxes_no_override": 48446.95,
    "override_total_1": 49821.59,
    "override_increase_1": 1374.65
  },
  {
    "#": "11 Orchard Rd (095-06-00)",
    "$": 2680500,
    "address": "11 Orchard Rd",
    "parcel_id": "095-06-00",
    "owner1": "POLYAK TR, KORNELIA",
    "owner2": "",
    "current_taxes": 23813.39,
    "new_taxes_no_override": 24842.13,
    "override_total_1": 25547.0,
    "override_increase_1": 704.88
  },
  {
    "#": "14 Orchard Rd (097-05-00)",
    "$": 2851900,
    "address": "14 Orchard Rd",
    "parcel_id": "097-05-00",
    "owner1": "ELIASON, PAULA",
    "owner2": "LI, PHILIP",
    "current_taxes": 25568.52,
    "new_taxes_no_override": 26673.08,
    "override_total_1": 27429.91,
    "override_increase_1": 756.83
  },
  {
    "#": "18 Orchard Rd (097-04-00)",
    "$": 2618400,
    "address": "18 Orchard Rd",
    "parcel_id": "097-04-00",
    "owner1": "PUTKA, GARY S & DORON",
    "owner2": "",
    "current_taxes": 23177.48,
    "new_taxes_no_override": 24178.75,
    "override_total_1": 24864.8,
    "override_increase_1": 686.05
  },
  {
    "#": "21 Orchard Rd (095-07-00)",
    "$": 2982900,
    "address": "21 Orchard Rd",
    "parcel_id": "095-07-00",
    "owner1": "CASSEL, SCOTT A",
    "owner2": "PODZIBA, SUSAN",
    "current_taxes": 26909.96,
    "new_taxes_no_override": 28072.47,
    "override_total_1": 28869.01,
    "override_increase_1": 796.53
  },
  {
    "#": "25 Orchard Rd (095-08-00)",
    "$": 2167900,
    "address": "25 Orchard Rd",
    "parcel_id": "095-08-00",
    "owner1": "BARAS, ROBYN",
    "owner2": "",
    "current_taxes": 18564.36,
    "new_taxes_no_override": 19366.34,
    "override_total_1": 19915.85,
    "override_increase_1": 549.51
  },
  {
    "#": "26 Orchard Rd (097-03-00)",
    "$": 3081900,
    "address": "26 Orchard Rd",
    "parcel_id": "097-03-00",
    "owner1": "HILLMAN, ROBERT K",
    "owner2": "MITCHELL, JAMES W JR",
    "current_taxes": 27923.72,
    "new_taxes_no_override": 29130.02,
    "override_total_1": 29956.57,
    "override_increase_1": 826.54
  },
  {
    "#": "34 Orchard Rd (097-02-00)",
    "$": 2386200,
    "address": "34 Orchard Rd",
    "parcel_id": "097-02-00",
    "owner1": "ALLEN TRS, IRVING M & BETTY N",
    "owner2": "",
    "current_taxes": 20799.75,
    "new_taxes_no_override": 21698.3,
    "override_total_1": 22313.97,
    "override_increase_1": 615.67
  },
  {
    "#": "35 Orchard Rd (095-01-01)",
    "$": 103700,
    "address": "35 Orchard Rd",
    "parcel_id": "095-01-01",
    "owner1": "DRORY, RONEN",
    "owner2": "",
    "current_taxes": 1061.89,
    "new_taxes_no_override": 1107.76,
    "override_total_1": 1139.2,
    "override_increase_1": 31.43
  },
  {
    "#": "36 Orchard Rd (097-01-00)",
    "$": 1252600,
    "address": "36 Orchard Rd",
    "parcel_id": "097-01-00",
    "owner1": "OBRIEN, STEPHEN E",
    "owner2": "OHARE, MEABH",
    "current_taxes": 12826.62,
    "new_taxes_no_override": 13380.73,
    "override_total_1": 13760.4,
    "override_increase_1": 379.67
  },
  {
    "#": "1 Osborne Rd (054-09-00)",
    "$": 1992100,
    "address": "1 Osborne Rd",
    "parcel_id": "054-09-00",
    "owner1": "SPACK, CAROL J",
    "owner2": "",
    "current_taxes": 20399.1,
    "new_taxes_no_override": 21280.34,
    "override_total_1": 21884.15,
    "override_increase_1": 603.81
  },
  {
    "#": "5 Osborne Rd (054-10-00)",
    "$": 2271800,
    "address": "5 Osborne Rd",
    "parcel_id": "054-10-00",
    "owner1": "PARKER-JOHNSON TRS, PAUL E & DEBORAH A",
    "owner2": "",
    "current_taxes": 19628.3,
    "new_taxes_no_override": 20476.24,
    "override_total_1": 21057.24,
    "override_increase_1": 581.0
  },
  {
    "#": "9 Osborne Rd (054-11-00)",
    "$": 2343600,
    "address": "9 Osborne Rd",
    "parcel_id": "054-11-00",
    "owner1": "MONTAGUE, TRS, RUTH",
    "owner2": "",
    "current_taxes": 20363.53,
    "new_taxes_no_override": 21243.23,
    "override_total_1": 21845.99,
    "override_increase_1": 602.76
  },
  {
    "#": "11 Osborne Rd (054-12-00)",
    "$": 2742100,
    "address": "11 Osborne Rd",
    "parcel_id": "054-12-00",
    "owner1": "LYNCH, DENNIS C & NANCY A",
    "owner2": "",
    "current_taxes": 24444.17,
    "new_taxes_no_override": 25500.16,
    "override_total_1": 26223.71,
    "override_increase_1": 723.55
  },
  {
    "#": "12 Osborne Rd, Unit 12 (055-07-01)",
    "$": 1304400,
    "address": "12 Osborne Rd, Unit 12",
    "parcel_id": "055-07-01",
    "owner1": "LECLERC, JOSHUA E",
    "owner2": "PARRISH, AMANDA T",
    "current_taxes": 13357.06,
    "new_taxes_no_override": 13934.08,
    "override_total_1": 14329.45,
    "override_increase_1": 395.37
  },
  {
    "#": "12 Osborne Rd, Unit 14 (055-07-02)",
    "$": 864900,
    "address": "12 Osborne Rd, Unit 14",
    "parcel_id": "055-07-02",
    "owner1": "PARRISH TRS, BYRON N & KATHLEEN M",
    "owner2": "",
    "current_taxes": 5221.64,
    "new_taxes_no_override": 5447.21,
    "override_total_1": 5601.78,
    "override_increase_1": 154.56
  },
  {
    "#": "17 Osborne Rd (054-13-00)",
    "$": 2193900,
    "address": "17 Osborne Rd",
    "parcel_id": "054-13-00",
    "owner1": "STRAUSS TR, SUZANNE HILLMAN",
    "owner2": "",
    "current_taxes": 22465.54,
    "new_taxes_no_override": 23436.05,
    "override_total_1": 24101.03,
    "override_increase_1": 664.98
  },
  {
    "#": "18 Osborne Rd (055-06-00)",
    "$": 2479300,
    "address": "18 Osborne Rd",
    "parcel_id": "055-06-00",
    "owner1": "COX, CHAD W & ABIGAIL SCHOENBAUM",
    "owner2": "",
    "current_taxes": 21753.1,
    "new_taxes_no_override": 22692.83,
    "override_total_1": 23336.73,
    "override_increase_1": 643.89
  },
  {
    "#": "21 Osborne Rd (054-14-00)",
    "$": 2034200,
    "address": "21 Osborne Rd",
    "parcel_id": "054-14-00",
    "owner1": "OSBORNE ROAD LLC",
    "owner2": "C/O POLGAR, PETER",
    "current_taxes": 20830.21,
    "new_taxes_no_override": 21730.08,
    "override_total_1": 22346.65,
    "override_increase_1": 616.57
  },
  {
    "#": "22 Osborne Rd (055-05-00)",
    "$": 1555500,
    "address": "22 Osborne Rd",
    "parcel_id": "055-05-00",
    "owner1": "RODRIGUEZ TR, YOLANDA M",
    "owner2": "",
    "current_taxes": 12293.39,
    "new_taxes_no_override": 12824.46,
    "override_total_1": 13188.35,
    "override_increase_1": 363.88
  },
  {
    "#": "26 Osborne Rd (055-04-00)",
    "$": 2387800,
    "address": "26 Osborne Rd",
    "parcel_id": "055-04-00",
    "owner1": "COHEN, MOSHE & BARBRA D B",
    "owner2": "",
    "current_taxes": 20816.14,
    "new_taxes_no_override": 21715.4,
    "override_total_1": 22331.55,
    "override_increase_1": 616.16
  },
  {
    "#": "27 Osborne Rd (054-15-00)",
    "$": 2451700,
    "address": "27 Osborne Rd",
    "parcel_id": "054-15-00",
    "owner1": "KROOP, DAVID",
    "owner2": "YANOVER, ELISSA N",
    "current_taxes": 21470.47,
    "new_taxes_no_override": 22397.99,
    "override_total_1": 23033.52,
    "override_increase_1": 635.53
  },
  {
    "#": "30 Osborne Rd (055-03-00)",
    "$": 2197100,
    "address": "30 Osborne Rd",
    "parcel_id": "055-03-00",
    "owner1": "YEE, JAMES & SYLVIA",
    "owner2": "",
    "current_taxes": 18863.37,
    "new_taxes_no_override": 19678.27,
    "override_total_1": 20236.62,
    "override_increase_1": 558.36
  },
  {
    "#": "31 Osborne Rd (054-16-00)",
    "$": 2398600,
    "address": "31 Osborne Rd",
    "parcel_id": "054-16-00",
    "owner1": "SWETOW, CAROL J",
    "owner2": "MINICHIELLO, RALPH R",
    "current_taxes": 20926.73,
    "new_taxes_no_override": 21830.76,
    "override_total_1": 22450.2,
    "override_increase_1": 619.43
  },
  {
    "#": "37 Osborne Rd (054-17-00)",
    "$": 2697700,
    "address": "37 Osborne Rd",
    "parcel_id": "054-17-00",
    "owner1": "LIU, LUQIAO",
    "owner2": "XU, YING",
    "current_taxes": 27624.45,
    "new_taxes_no_override": 28817.83,
    "override_total_1": 29635.51,
    "override_increase_1": 817.68
  },
  {
    "#": "41 Osborne Rd (054-18-00)",
    "$": 2274500,
    "address": "41 Osborne Rd",
    "parcel_id": "054-18-00",
    "owner1": "JOHNSON, ANITA L",
    "owner2": "",
    "current_taxes": 19655.95,
    "new_taxes_no_override": 20505.09,
    "override_total_1": 21086.9,
    "override_increase_1": 581.82
  },
  {
    "#": "42 Osborne Rd (055-02-00)",
    "$": 2538300,
    "address": "42 Osborne Rd",
    "parcel_id": "055-02-00",
    "owner1": "COURTNEY, MICHAEL",
    "owner2": "",
    "current_taxes": 25992.19,
    "new_taxes_no_override": 27115.05,
    "override_total_1": 27884.42,
    "override_increase_1": 769.37
  },
  {
    "#": "4 Park St, Unit 1 (214-49-01)",
    "$": 917100,
    "address": "4 Park St, Unit 1",
    "parcel_id": "214-49-01",
    "owner1": "NGUYEN, HUY",
    "owner2": "ENE, ALINA R",
    "current_taxes": 5756.17,
    "new_taxes_no_override": 6004.84,
    "override_total_1": 6175.22,
    "override_increase_1": 170.38
  },
  {
    "#": "4 Park St, Unit 2 (214-49-02)",
    "$": 1010300,
    "address": "4 Park St, Unit 2",
    "parcel_id": "214-49-02",
    "owner1": "BAILLIEUL, CHARLOTTE",
    "owner2": "",
    "current_taxes": 6710.54,
    "new_taxes_no_override": 7000.44,
    "override_total_1": 7199.07,
    "override_increase_1": 198.63
  },
  {
    "#": "4 Park St, Unit 3 (214-49-03)",
    "$": 977700,
    "address": "4 Park St, Unit 3",
    "parcel_id": "214-49-03",
    "owner1": "WOYTASH, ANNASTACIA",
    "owner2": "",
    "current_taxes": 10011.65,
    "new_taxes_no_override": 10444.15,
    "override_total_1": 10740.5,
    "override_increase_1": 296.34
  },
  {
    "#": "5 Park St, Unit 1 (171-58-08)",
    "$": 1047900,
    "address": "5 Park St, Unit 1",
    "parcel_id": "171-58-08",
    "owner1": "JACOBS, J WARREN & JANET P",
    "owner2": "",
    "current_taxes": 7095.56,
    "new_taxes_no_override": 7402.09,
    "override_total_1": 7612.12,
    "override_increase_1": 210.03
  },
  {
    "#": "5 Park St, Unit 2 (171-58-09)",
    "$": 1036100,
    "address": "5 Park St, Unit 2",
    "parcel_id": "171-58-09",
    "owner1": "ROSENFIELD, SARA",
    "owner2": "OLIVERIA, JOEL R",
    "current_taxes": 6974.73,
    "new_taxes_no_override": 7276.04,
    "override_total_1": 7482.49,
    "override_increase_1": 206.45
  },
  {
    "#": "5 Park St, Unit 3 (171-58-10)",
    "$": 1052700,
    "address": "5 Park St, Unit 3",
    "parcel_id": "171-58-10",
    "owner1": "FINNIGAN, JOHN P JR & MARIEL A & KAREN J & JOHN P",
    "owner2": "",
    "current_taxes": 7144.71,
    "new_taxes_no_override": 7453.36,
    "override_total_1": 7664.84,
    "override_increase_1": 211.48
  },
  {
    "#": "5 Park St, Unit 4 (171-58-11)",
    "$": 1030600,
    "address": "5 Park St, Unit 4",
    "parcel_id": "171-58-11",
    "owner1": "FENG, ZHAO",
    "owner2": "YANG, YILI",
    "current_taxes": 6918.41,
    "new_taxes_no_override": 7217.29,
    "override_total_1": 7422.07,
    "override_increase_1": 204.78
  },
  {
    "#": "10 Park St (214-48-00)",
    "$": 4484700,
    "address": "10 Park St",
    "parcel_id": "214-48-00",
    "owner1": "AJS PARK STREET LLC",
    "owner2": "C/O TREMONT ASSET MGMT LLC",
    "current_taxes": 45923.33,
    "new_taxes_no_override": 47907.22,
    "override_total_1": 49266.55,
    "override_increase_1": 1359.33
  },
  {
    "#": "11 Park St (171-05-00)",
    "$": 5001800,
    "address": "11 Park St",
    "parcel_id": "171-05-00",
    "owner1": "ERLICH WILLIAM ET AL TRS",
    "owner2": "C/O SENTRY PROPERTY MANAGEMENT",
    "current_taxes": 51218.43,
    "new_taxes_no_override": 53431.07,
    "override_total_1": 54947.13,
    "override_increase_1": 1516.07
  },
  {
    "#": "14 Park St, Unit 1 P-1 (214-47-04)",
    "$": 874100,
    "address": "14 Park St, Unit 1 P-1",
    "parcel_id": "214-47-04",
    "owner1": "PAGANO, MARISA",
    "owner2": "",
    "current_taxes": 5315.85,
    "new_taxes_no_override": 5545.49,
    "override_total_1": 5702.84,
    "override_increase_1": 157.35
  },
  {
    "#": "14 Park St, Unit 2 & P2 (214-47-02)",
    "$": 1014900,
    "address": "14 Park St, Unit 2 & P2",
    "parcel_id": "214-47-02",
    "owner1": "GUO, JIANI",
    "owner2": "",
    "current_taxes": 6757.64,
    "new_taxes_no_override": 7049.57,
    "override_total_1": 7249.6,
    "override_increase_1": 200.03
  },
  {
    "#": "14 Park St, Unit 3 & P3 (214-47-03)",
    "$": 1024600,
    "address": "14 Park St, Unit 3 & P3",
    "parcel_id": "214-47-03",
    "owner1": "MUSSON, CHARLES T",
    "owner2": "KIRWAN, SYDNEY B",
    "current_taxes": 6856.97,
    "new_taxes_no_override": 7153.19,
    "override_total_1": 7356.16,
    "override_increase_1": 202.97
  },
  {
    "#": "20 Park St (214-47-00)",
    "$": 6858500,
    "address": "20 Park St",
    "parcel_id": "214-47-00",
    "owner1": "PARK APARTMENTS",
    "owner2": "",
    "current_taxes": 70231.04,
    "new_taxes_no_override": 73265.02,
    "override_total_1": 75343.86,
    "override_increase_1": 2078.84
  },
  {
    "#": "25 Park St (171-06-00)",
    "$": 2213800,
    "address": "25 Park St",
    "parcel_id": "171-06-00",
    "owner1": "NYHAN TR, OLIVIA D",
    "owner2": "",
    "current_taxes": 19034.38,
    "new_taxes_no_override": 19856.67,
    "override_total_1": 20420.08,
    "override_increase_1": 563.42
  },
  {
    "#": "28 Park St (214-45-46)",
    "$": 24359400,
    "address": "28 Park St",
    "parcel_id": "214-45-46",
    "owner1": "28 PARK STREET LLC",
    "owner2": "C/O PARK PROPERTY MGMT GRP LLC",
    "current_taxes": 249440.26,
    "new_taxes_no_override": 260216.08,
    "override_total_1": 267599.51,
    "override_increase_1": 7383.43
  },
  {
    "#": "31 Park St, Unit 2 (170-01-02)",
    "$": 582200,
    "address": "31 Park St, Unit 2",
    "parcel_id": "170-01-02",
    "owner1": "SPERLING, DEVORAH S",
    "owner2": "",
    "current_taxes": 2326.79,
    "new_taxes_no_override": 2427.31,
    "override_total_1": 2496.18,
    "override_increase_1": 68.87
  },
  {
    "#": "31 Park St, Unit 3 (170-01-03)",
    "$": 582200,
    "address": "31 Park St, Unit 3",
    "parcel_id": "170-01-03",
    "owner1": "SOMBERG, SMILYANA M",
    "owner2": "",
    "current_taxes": 2326.79,
    "new_taxes_no_override": 2427.31,
    "override_total_1": 2496.18,
    "override_increase_1": 68.87
  },
  {
    "#": "31 Park St, Unit 31-1 (170-01-01)",
    "$": 602300,
    "address": "31 Park St, Unit 31-1",
    "parcel_id": "170-01-01",
    "owner1": "YUNG TRS, VIVIAN & RICKY",
    "owner2": "",
    "current_taxes": 6167.55,
    "new_taxes_no_override": 6433.99,
    "override_total_1": 6616.55,
    "override_increase_1": 182.56
  },
  {
    "#": "31 Park St, Unit 4 (170-01-04)",
    "$": 602300,
    "address": "31 Park St, Unit 4",
    "parcel_id": "170-01-04",
    "owner1": "MILLAR, RONALD G",
    "owner2": "",
    "current_taxes": 2532.62,
    "new_taxes_no_override": 2642.03,
    "override_total_1": 2716.99,
    "override_increase_1": 74.97
  },
  {
    "#": "31 Park St, Unit 5 (170-01-05)",
    "$": 592400,
    "address": "31 Park St, Unit 5",
    "parcel_id": "170-01-05",
    "owner1": "MCCORMACK, KATHLEEN",
    "owner2": "",
    "current_taxes": 2431.24,
    "new_taxes_no_override": 2536.27,
    "override_total_1": 2608.23,
    "override_increase_1": 71.96
  },
  {
    "#": "31 Park St, Unit 6 (170-01-06)",
    "$": 572000,
    "address": "31 Park St, Unit 6",
    "parcel_id": "170-01-06",
    "owner1": "PIEN TRS, ARLENE C & SHUI HSIEN",
    "owner2": "",
    "current_taxes": 5857.28,
    "new_taxes_no_override": 6110.31,
    "override_total_1": 6283.69,
    "override_increase_1": 173.38
  },
  {
    "#": "35 Park St, Unit 1 (170-01-07)",
    "$": 590700,
    "address": "35 Park St, Unit 1",
    "parcel_id": "170-01-07",
    "owner1": "BROOKE, CAROLYN H",
    "owner2": "",
    "current_taxes": 2413.83,
    "new_taxes_no_override": 2518.11,
    "override_total_1": 2589.56,
    "override_increase_1": 71.45
  },
  {
    "#": "35 Park St, Unit 35-2 (170-01-08)",
    "$": 607700,
    "address": "35 Park St, Unit 35-2",
    "parcel_id": "170-01-08",
    "owner1": "EMAS LLC",
    "owner2": "",
    "current_taxes": 6222.85,
    "new_taxes_no_override": 6491.68,
    "override_total_1": 6675.87,
    "override_increase_1": 184.2
  },
  {
    "#": "35 Park St, Unit 35-3 (170-01-09)",
    "$": 607700,
    "address": "35 Park St, Unit 35-3",
    "parcel_id": "170-01-09",
    "owner1": "DUDLEY, PHILIP",
    "owner2": "CANIESO, SARAH",
    "current_taxes": 2587.91,
    "new_taxes_no_override": 2699.71,
    "override_total_1": 2776.31,
    "override_increase_1": 76.6
  },
  {
    "#": "35 Park St, Unit 35-4 (170-01-10)",
    "$": 597500,
    "address": "35 Park St, Unit 35-4",
    "parcel_id": "170-01-10",
    "owner1": "HANLEY TR, NANCY M",
    "owner2": "",
    "current_taxes": 2483.47,
    "new_taxes_no_override": 2590.76,
    "override_total_1": 2664.27,
    "override_increase_1": 73.51
  },
  {
    "#": "35 Park St, Unit 35-5 (170-01-11)",
    "$": 589400,
    "address": "35 Park St, Unit 35-5",
    "parcel_id": "170-01-11",
    "owner1": "KOMMIT, SUSAN S",
    "owner2": "",
    "current_taxes": 2400.52,
    "new_taxes_no_override": 2504.22,
    "override_total_1": 2575.28,
    "override_increase_1": 71.06
  },
  {
    "#": "35 Park St, Unit 35-6 (170-01-12)",
    "$": 607800,
    "address": "35 Park St, Unit 35-6",
    "parcel_id": "170-01-12",
    "owner1": "COTICCHIA, CHRISTINE",
    "owner2": "",
    "current_taxes": 2588.94,
    "new_taxes_no_override": 2700.78,
    "override_total_1": 2777.41,
    "override_increase_1": 76.63
  },
  {
    "#": "41 Park St, Unit 101 (170-02-42)",
    "$": 397800,
    "address": "41 Park St, Unit 101",
    "parcel_id": "170-02-42",
    "owner1": "STACK, CAROL",
    "owner2": "C/O CAROL R FINE",
    "current_taxes": 4073.47,
    "new_taxes_no_override": 4249.44,
    "override_total_1": 4370.02,
    "override_increase_1": 120.57
  },
  {
    "#": "41 Park St, Unit 102 & P5 (170-02-01)",
    "$": 755500,
    "address": "41 Park St, Unit 102 & P5",
    "parcel_id": "170-02-01",
    "owner1": "YE, YONGXIN",
    "owner2": "YANG, HAIYAN",
    "current_taxes": 4101.39,
    "new_taxes_no_override": 4278.57,
    "override_total_1": 4399.97,
    "override_increase_1": 121.4
  },
  {
    "#": "41 Park St, Unit 103 (170-02-02)",
    "$": 357900,
    "address": "41 Park St, Unit 103",
    "parcel_id": "170-02-02",
    "owner1": "RENTALS ONE LLC",
    "owner2": "",
    "current_taxes": 3664.9,
    "new_taxes_no_override": 3823.22,
    "override_total_1": 3931.7,
    "override_increase_1": 108.48
  },
  {
    "#": "41 Park St, Unit 104 & P33 (170-02-03)",
    "$": 768000,
    "address": "41 Park St, Unit 104 & P33",
    "parcel_id": "170-02-03",
    "owner1": "SACHEDINA, ANWAR M",
    "owner2": "",
    "current_taxes": 4229.39,
    "new_taxes_no_override": 4412.1,
    "override_total_1": 4537.29,
    "override_increase_1": 125.19
  },
  {
    "#": "41 Park St, Unit 105 & P11 (170-02-04)",
    "$": 768000,
    "address": "41 Park St, Unit 105 & P11",
    "parcel_id": "170-02-04",
    "owner1": "LEONG, WEI LEE",
    "owner2": "",
    "current_taxes": 4229.39,
    "new_taxes_no_override": 4412.1,
    "override_total_1": 4537.29,
    "override_increase_1": 125.19
  },
  {
    "#": "41 Park St, Unit 106 & P5 (170-02-05)",
    "$": 794700,
    "address": "41 Park St, Unit 106 & P5",
    "parcel_id": "170-02-05",
    "owner1": "CHIN, EMILY",
    "owner2": "",
    "current_taxes": 4502.79,
    "new_taxes_no_override": 4697.31,
    "override_total_1": 4830.59,
    "override_increase_1": 133.28
  },
  {
    "#": "41 Park St, Unit 107 & P40 (170-02-06)",
    "$": 783200,
    "address": "41 Park St, Unit 107 & P40",
    "parcel_id": "170-02-06",
    "owner1": "SUBRAMONIA IYER, SUBRAMONY",
    "owner2": "IYER, SMITHA",
    "current_taxes": 8019.97,
    "new_taxes_no_override": 8366.43,
    "override_total_1": 8603.82,
    "override_increase_1": 237.39
  },
  {
    "#": "41 Park St, Unit 108 & P38 (170-02-07)",
    "$": 638100,
    "address": "41 Park St, Unit 108 & P38",
    "parcel_id": "170-02-07",
    "owner1": "FETONTE, SHIRA",
    "owner2": "KUDATSKY, HELEN",
    "current_taxes": 6534.14,
    "new_taxes_no_override": 6816.41,
    "override_total_1": 7009.83,
    "override_increase_1": 193.41
  },
  {
    "#": "41 Park St, Unit 109 & P42 (170-02-08)",
    "$": 432600,
    "address": "41 Park St, Unit 109 & P42",
    "parcel_id": "170-02-08",
    "owner1": "ANTONELLI, DEBRA",
    "owner2": "",
    "current_taxes": 794.89,
    "new_taxes_no_override": 829.23,
    "override_total_1": 852.76,
    "override_increase_1": 23.53
  },
  {
    "#": "41 Park St, Unit 201 & P36 (170-02-09)",
    "$": 426900,
    "address": "41 Park St, Unit 201 & P36",
    "parcel_id": "170-02-09",
    "owner1": "WILLEMS, SEAN P & ANJANETTE",
    "owner2": "",
    "current_taxes": 4371.46,
    "new_taxes_no_override": 4560.31,
    "override_total_1": 4689.7,
    "override_increase_1": 129.4
  },
  {
    "#": "41 Park St, Unit 202 & P6 (170-02-10)",
    "$": 801100,
    "address": "41 Park St, Unit 202 & P6",
    "parcel_id": "170-02-10",
    "owner1": "LEBOW, WILLIAM & LAURA E",
    "owner2": "",
    "current_taxes": 8203.26,
    "new_taxes_no_override": 8557.64,
    "override_total_1": 8800.46,
    "override_increase_1": 242.82
  },
  {
    "#": "41 Park St, Unit 203 & P14 (170-02-11)",
    "$": 613900,
    "address": "41 Park St, Unit 203 & P14",
    "parcel_id": "170-02-11",
    "owner1": "MANALIS, SCOTT",
    "owner2": "TSAI, ANGEL",
    "current_taxes": 6286.34,
    "new_taxes_no_override": 6557.91,
    "override_total_1": 6743.99,
    "override_increase_1": 186.08
  },
  {
    "#": "41 Park St, Unit 204 & P16 (170-02-12)",
    "$": 798600,
    "address": "41 Park St, Unit 204 & P16",
    "parcel_id": "170-02-12",
    "owner1": "GURENICH, DMITRY I",
    "owner2": "",
    "current_taxes": 4542.73,
    "new_taxes_no_override": 4738.98,
    "override_total_1": 4873.44,
    "override_increase_1": 134.46
  },
  {
    "#": "41 Park St, Unit 205 (170-02-13)",
    "$": 785400,
    "address": "41 Park St, Unit 205",
    "parcel_id": "170-02-13",
    "owner1": "MAGID, ILIA",
    "owner2": "KOGA, YOKO",
    "current_taxes": 4407.56,
    "new_taxes_no_override": 4597.97,
    "override_total_1": 4728.43,
    "override_increase_1": 130.46
  },
  {
    "#": "41 Park St, Unit 206 & P37 (170-02-15)",
    "$": 917600,
    "address": "41 Park St, Unit 206 & P37",
    "parcel_id": "170-02-15",
    "owner1": "MURSTEIN LIFE ESTATE, MARK",
    "owner2": "",
    "current_taxes": 5761.29,
    "new_taxes_no_override": 6010.18,
    "override_total_1": 6180.71,
    "override_increase_1": 170.53
  },
  {
    "#": "41 Park St, Unit 207 &  P21 (170-02-14)",
    "$": 780600,
    "address": "41 Park St, Unit 207 &  P21",
    "parcel_id": "170-02-14",
    "owner1": "WU, YUNHONG",
    "owner2": "",
    "current_taxes": 7993.34,
    "new_taxes_no_override": 8338.65,
    "override_total_1": 8575.26,
    "override_increase_1": 236.6
  },
  {
    "#": "41 Park St, Unit 208 & P3 (170-02-16)",
    "$": 644500,
    "address": "41 Park St, Unit 208 & P3",
    "parcel_id": "170-02-16",
    "owner1": "KOZINETS LIFE ESTATE, ANATOLIY",
    "owner2": "AKSELROD LIFE ESTATE, SOFYA",
    "current_taxes": 2964.75,
    "new_taxes_no_override": 3092.83,
    "override_total_1": 3180.58,
    "override_increase_1": 87.76
  },
  {
    "#": "41 Park St, Unit 209 & P41 (170-02-17)",
    "$": 427700,
    "address": "41 Park St, Unit 209 & P41",
    "parcel_id": "170-02-17",
    "owner1": "CHANG, QING",
    "owner2": "JIANG, SHAN",
    "current_taxes": 4379.65,
    "new_taxes_no_override": 4568.85,
    "override_total_1": 4698.49,
    "override_increase_1": 129.64
  },
  {
    "#": "41 Park St, Unit 210 & P10 (170-02-18)",
    "$": 630400,
    "address": "41 Park St, Unit 210 & P10",
    "parcel_id": "170-02-18",
    "owner1": "KARAGODSKY TR, IGOR",
    "owner2": "C/O VALERY KARAGODSKY",
    "current_taxes": 6455.3,
    "new_taxes_no_override": 6734.17,
    "override_total_1": 6925.25,
    "override_increase_1": 191.08
  },
  {
    "#": "41 Park St, Unit 211 & P7 (170-02-19)",
    "$": 610900,
    "address": "41 Park St, Unit 211 & P7",
    "parcel_id": "170-02-19",
    "owner1": "PEARSON, BEATA",
    "owner2": "",
    "current_taxes": 6255.62,
    "new_taxes_no_override": 6525.86,
    "override_total_1": 6711.03,
    "override_increase_1": 185.17
  },
  {
    "#": "41 Park St, Unit 301 & P15 (170-02-20)",
    "$": 409400,
    "address": "41 Park St, Unit 301 & P15",
    "parcel_id": "170-02-20",
    "owner1": "RENTALS ONE LLC",
    "owner2": "",
    "current_taxes": 4192.26,
    "new_taxes_no_override": 4373.37,
    "override_total_1": 4497.46,
    "override_increase_1": 124.09
  },
  {
    "#": "41 Park St, Unit 302 & P17 (170-02-21)",
    "$": 764100,
    "address": "41 Park St, Unit 302 & P17",
    "parcel_id": "170-02-21",
    "owner1": "TSEKOV TRS, GEORGI I",
    "owner2": "COLTEN, MELISSA G",
    "current_taxes": 7824.38,
    "new_taxes_no_override": 8162.39,
    "override_total_1": 8393.99,
    "override_increase_1": 231.6
  },
  {
    "#": "41 Park St, Unit 303 (170-02-22)",
    "$": 589100,
    "address": "41 Park St, Unit 303",
    "parcel_id": "170-02-22",
    "owner1": "LU, SHANHONG",
    "owner2": "CHEN, HONGLIN",
    "current_taxes": 2397.45,
    "new_taxes_no_override": 2501.02,
    "override_total_1": 2571.98,
    "override_increase_1": 70.96
  },
  {
    "#": "41 Park St, Unit 304 & P8 (170-02-23)",
    "$": 788400,
    "address": "41 Park St, Unit 304 & P8",
    "parcel_id": "170-02-23",
    "owner1": "LI, ZIYAN",
    "owner2": "NI, PIANRAN",
    "current_taxes": 4438.28,
    "new_taxes_no_override": 4630.01,
    "override_total_1": 4761.39,
    "override_increase_1": 131.37
  },
  {
    "#": "41 Park St, Unit 305 & P2 (170-02-24)",
    "$": 770100,
    "address": "41 Park St, Unit 305 & P2",
    "parcel_id": "170-02-24",
    "owner1": "BERKMAN TRS, VITALY & REGINA",
    "owner2": "",
    "current_taxes": 4250.89,
    "new_taxes_no_override": 4434.53,
    "override_total_1": 4560.35,
    "override_increase_1": 125.83
  },
  {
    "#": "41 Park St, Unit 306 & P4 (170-02-25)",
    "$": 769200,
    "address": "41 Park St, Unit 306 & P4",
    "parcel_id": "170-02-25",
    "owner1": "TASSOUDJI, SHOREH",
    "owner2": "",
    "current_taxes": 7876.61,
    "new_taxes_no_override": 8216.88,
    "override_total_1": 8450.03,
    "override_increase_1": 233.15
  },
  {
    "#": "41 Park St, Unit 307 & P29 (170-02-26)",
    "$": 772200,
    "address": "41 Park St, Unit 307 & P29",
    "parcel_id": "170-02-26",
    "owner1": "LAGANA LIFE ESTATE, LETITIA",
    "owner2": "",
    "current_taxes": 4272.39,
    "new_taxes_no_override": 4456.96,
    "override_total_1": 4583.42,
    "override_increase_1": 126.46
  },
  {
    "#": "41 Park St, Unit 308 & P28 (170-02-27)",
    "$": 661500,
    "address": "41 Park St, Unit 308 & P28",
    "parcel_id": "170-02-27",
    "owner1": "KUPERMAN LIFE ESTATE, EMMA",
    "owner2": "",
    "current_taxes": 3138.83,
    "new_taxes_no_override": 3274.43,
    "override_total_1": 3367.34,
    "override_increase_1": 92.91
  },
  {
    "#": "41 Park St, Unit 309 & P1 (170-02-28)",
    "$": 456100,
    "address": "41 Park St, Unit 309 & P1",
    "parcel_id": "170-02-28",
    "owner1": "ARNAOUT, AMAL",
    "owner2": "",
    "current_taxes": 4670.46,
    "new_taxes_no_override": 4872.22,
    "override_total_1": 5010.47,
    "override_increase_1": 138.25
  },
  {
    "#": "41 Park St, Unit 310 & P31 (170-02-29)",
    "$": 617300,
    "address": "41 Park St, Unit 310 & P31",
    "parcel_id": "170-02-29",
    "owner1": "KARGIR, BEVERLY S",
    "owner2": "",
    "current_taxes": 2686.22,
    "new_taxes_no_override": 2802.26,
    "override_total_1": 2881.78,
    "override_increase_1": 79.51
  },
  {
    "#": "41 Park St, Unit 311 & P32 (170-02-30)",
    "$": 622800,
    "address": "41 Park St, Unit 311 & P32",
    "parcel_id": "170-02-30",
    "owner1": "KIM, DAVID & LISA",
    "owner2": "",
    "current_taxes": 2742.54,
    "new_taxes_no_override": 2861.02,
    "override_total_1": 2942.2,
    "override_increase_1": 81.18
  },
  {
    "#": "41 Park St, Unit 401 & P19 (170-02-31)",
    "$": 437700,
    "address": "41 Park St, Unit 401 & P19",
    "parcel_id": "170-02-31",
    "owner1": "KORNFELD TRS, SUSAN E & JOSEPH E",
    "owner2": "",
    "current_taxes": 4482.05,
    "new_taxes_no_override": 4675.67,
    "override_total_1": 4808.34,
    "override_increase_1": 132.67
  },
  {
    "#": "41 Park St, Unit 402 (170-02-32)",
    "$": 745400,
    "address": "41 Park St, Unit 402",
    "parcel_id": "170-02-32",
    "owner1": "FRANK, LIVIA",
    "owner2": "",
    "current_taxes": 3997.96,
    "new_taxes_no_override": 4170.67,
    "override_total_1": 4289.01,
    "override_increase_1": 118.34
  },
  {
    "#": "41 Park St, Unit 403 & P39 (170-02-33)",
    "$": 593900,
    "address": "41 Park St, Unit 403 & P39",
    "parcel_id": "170-02-33",
    "owner1": "BEYGELMAKER, DORA",
    "owner2": "",
    "current_taxes": 6081.54,
    "new_taxes_no_override": 6344.26,
    "override_total_1": 6524.28,
    "override_increase_1": 180.01
  },
  {
    "#": "41 Park St, Unit 404 & P12 (170-02-34)",
    "$": 824100,
    "address": "41 Park St, Unit 404 & P12",
    "parcel_id": "170-02-34",
    "owner1": "KATZ, MARK & KIMBERLEE",
    "owner2": "",
    "current_taxes": 8438.78,
    "new_taxes_no_override": 8803.34,
    "override_total_1": 9053.12,
    "override_increase_1": 249.79
  },
  {
    "#": "41 Park St, Unit 405 P34-35 (170-02-35)",
    "$": 889500,
    "address": "41 Park St, Unit 405 P34-35",
    "parcel_id": "170-02-35",
    "owner1": "KOGAN, GALINA",
    "owner2": "",
    "current_taxes": 5473.55,
    "new_taxes_no_override": 5710.01,
    "override_total_1": 5872.02,
    "override_increase_1": 162.02
  },
  {
    "#": "41 Park St, Unit 406 & P9 (170-02-36)",
    "$": 787800,
    "address": "41 Park St, Unit 406 & P9",
    "parcel_id": "170-02-36",
    "owner1": "OGANESOV ET AL, RUBEN",
    "owner2": "RUDMAN, ARIELLA JANE",
    "current_taxes": 8067.07,
    "new_taxes_no_override": 8415.57,
    "override_total_1": 8654.35,
    "override_increase_1": 238.79
  },
  {
    "#": "41 Park St, Unit 407 & P27 (170-02-37)",
    "$": 790800,
    "address": "41 Park St, Unit 407 & P27",
    "parcel_id": "170-02-37",
    "owner1": "EHRENFRIED, JOSHUA H & DAHLIA",
    "owner2": "",
    "current_taxes": 8097.79,
    "new_taxes_no_override": 8447.61,
    "override_total_1": 8687.31,
    "override_increase_1": 239.69
  },
  {
    "#": "41 Park St, Unit 408 (170-02-38)",
    "$": 599000,
    "address": "41 Park St, Unit 408",
    "parcel_id": "170-02-38",
    "owner1": "FRANCESONE, RONALD & ANGELINA",
    "owner2": "",
    "current_taxes": 6133.76,
    "new_taxes_no_override": 6398.74,
    "override_total_1": 6580.3,
    "override_increase_1": 181.56
  },
  {
    "#": "41 Park St, Unit 409 (170-02-39)",
    "$": 414900,
    "address": "41 Park St, Unit 409",
    "parcel_id": "170-02-39",
    "owner1": "LEBOWITZ TR, DEANNE F",
    "owner2": "",
    "current_taxes": 4248.58,
    "new_taxes_no_override": 4432.12,
    "override_total_1": 4557.88,
    "override_increase_1": 125.76
  },
  {
    "#": "41 Park St, Unit 410 & P18 (170-02-40)",
    "$": 619000,
    "address": "41 Park St, Unit 410 & P18",
    "parcel_id": "170-02-40",
    "owner1": "CHANG, QING",
    "owner2": "JIANG, SHAN",
    "current_taxes": 6338.56,
    "new_taxes_no_override": 6612.39,
    "override_total_1": 6800.01,
    "override_increase_1": 187.62
  },
  {
    "#": "41 Park St, Unit 411 (170-02-41)",
    "$": 607900,
    "address": "41 Park St, Unit 411",
    "parcel_id": "170-02-41",
    "owner1": "GU, JOANN Z",
    "owner2": "",
    "current_taxes": 6224.9,
    "new_taxes_no_override": 6493.82,
    "override_total_1": 6678.07,
    "override_increase_1": 184.26
  },
  {
    "#": "41 Park St, Unit P 20 (170-02-43)",
    "$": 52600,
    "address": "41 Park St, Unit P 20",
    "parcel_id": "170-02-43",
    "owner1": "EHRENFRIED, JOSHUA H",
    "owner2": "",
    "current_taxes": 538.62,
    "new_taxes_no_override": 561.89,
    "override_total_1": 577.83,
    "override_increase_1": 15.94
  },
  {
    "#": "41 Park St, Unit P30 (170-02-44)",
    "$": 52600,
    "address": "41 Park St, Unit P30",
    "parcel_id": "170-02-44",
    "owner1": "MAGID, ILIA",
    "owner2": "KOGA, YOKO",
    "current_taxes": 538.62,
    "new_taxes_no_override": 561.89,
    "override_total_1": 577.83,
    "override_increase_1": 15.94
  },
  {
    "#": "50 Park St, Unit 10 & P-16 (214-43-32)",
    "$": 699400,
    "address": "50 Park St, Unit 10 & P-16",
    "parcel_id": "214-43-32",
    "owner1": "GRIFFIN, VICKI WING KAN & JUSTIN CHEN",
    "owner2": "",
    "current_taxes": 7161.86,
    "new_taxes_no_override": 7471.25,
    "override_total_1": 7683.24,
    "override_increase_1": 211.99
  },
  {
    "#": "50 Park St, Unit 11 (214-43-01)",
    "$": 393500,
    "address": "50 Park St, Unit 11",
    "parcel_id": "214-43-01",
    "owner1": "GARDNER, PAULA R",
    "owner2": "",
    "current_taxes": 402.94,
    "new_taxes_no_override": 420.35,
    "override_total_1": 432.27,
    "override_increase_1": 11.93
  },
  {
    "#": "50 Park St, Unit 12 (214-43-02)",
    "$": 824500,
    "address": "50 Park St, Unit 12",
    "parcel_id": "214-43-02",
    "owner1": "YEO TRS, BEE KENG",
    "owner2": "ONEILL, GARRY",
    "current_taxes": 8442.88,
    "new_taxes_no_override": 8807.61,
    "override_total_1": 9057.52,
    "override_increase_1": 249.91
  },
  {
    "#": "50 Park St, Unit 14 (214-43-03)",
    "$": 453000,
    "address": "50 Park St, Unit 14",
    "parcel_id": "214-43-03",
    "owner1": "MCQUAID, MARISA",
    "owner2": "",
    "current_taxes": 1003.79,
    "new_taxes_no_override": 1047.15,
    "override_total_1": 1076.87,
    "override_increase_1": 29.71
  },
  {
    "#": "50 Park St, Unit 15 (214-43-04)",
    "$": 657200,
    "address": "50 Park St, Unit 15",
    "parcel_id": "214-43-04",
    "owner1": "LAM, ANDY J",
    "owner2": "",
    "current_taxes": 3094.79,
    "new_taxes_no_override": 3228.48,
    "override_total_1": 3320.09,
    "override_increase_1": 91.61
  },
  {
    "#": "50 Park St, Unit 16 (214-43-05)",
    "$": 650400,
    "address": "50 Park St, Unit 16",
    "parcel_id": "214-43-05",
    "owner1": "CK AND CJ LLC",
    "owner2": "",
    "current_taxes": 6660.1,
    "new_taxes_no_override": 6947.82,
    "override_total_1": 7144.96,
    "override_increase_1": 197.14
  },
  {
    "#": "50 Park St, Unit 17 & P4 (214-43-06)",
    "$": 816500,
    "address": "50 Park St, Unit 17 & P4",
    "parcel_id": "214-43-06",
    "owner1": "SAEZ, KETTY",
    "owner2": "",
    "current_taxes": 4726.03,
    "new_taxes_no_override": 4930.19,
    "override_total_1": 5070.08,
    "override_increase_1": 139.89
  },
  {
    "#": "50 Park St, Unit 18 (214-43-07)",
    "$": 685800,
    "address": "50 Park St, Unit 18",
    "parcel_id": "214-43-07",
    "owner1": "BIAN, JENNIFER JIE",
    "owner2": "",
    "current_taxes": 3387.66,
    "new_taxes_no_override": 3534.01,
    "override_total_1": 3634.28,
    "override_increase_1": 100.27
  },
  {
    "#": "50 Park St, Unit 21 (214-43-08)",
    "$": 845600,
    "address": "50 Park St, Unit 21",
    "parcel_id": "214-43-08",
    "owner1": "ZHANG, CHI & YUJUAN",
    "owner2": "",
    "current_taxes": 8658.94,
    "new_taxes_no_override": 9033.01,
    "override_total_1": 9289.31,
    "override_increase_1": 256.3
  },
  {
    "#": "50 Park St, Unit 22 (214-43-09)",
    "$": 814200,
    "address": "50 Park St, Unit 22",
    "parcel_id": "214-43-09",
    "owner1": "BELLE, KATHLEEN",
    "owner2": "",
    "current_taxes": 4702.47,
    "new_taxes_no_override": 4905.62,
    "override_total_1": 5044.81,
    "override_increase_1": 139.19
  },
  {
    "#": "50 Park St, Unit 23 (214-43-10)",
    "$": 643300,
    "address": "50 Park St, Unit 23",
    "parcel_id": "214-43-10",
    "owner1": "WOLF, GAYLE S",
    "owner2": "",
    "current_taxes": 6587.39,
    "new_taxes_no_override": 6871.97,
    "override_total_1": 7066.95,
    "override_increase_1": 194.99
  },
  {
    "#": "50 Park St, Unit 24 (214-43-11)",
    "$": 660200,
    "address": "50 Park St, Unit 24",
    "parcel_id": "214-43-11",
    "owner1": "GUAN, GUOQIANG",
    "owner2": "HUANG, XIU LI",
    "current_taxes": 3125.51,
    "new_taxes_no_override": 3260.53,
    "override_total_1": 3353.05,
    "override_increase_1": 92.52
  },
  {
    "#": "50 Park St, Unit 25 (214-43-12)",
    "$": 662700,
    "address": "50 Park St, Unit 25",
    "parcel_id": "214-43-12",
    "owner1": "FAN, JIH CHUNG",
    "owner2": "",
    "current_taxes": 6786.05,
    "new_taxes_no_override": 7079.21,
    "override_total_1": 7280.07,
    "override_increase_1": 200.87
  },
  {
    "#": "50 Park St, Unit 26 (214-43-13)",
    "$": 675700,
    "address": "50 Park St, Unit 26",
    "parcel_id": "214-43-13",
    "owner1": "CHOW, JONATHAN K",
    "owner2": "",
    "current_taxes": 3284.23,
    "new_taxes_no_override": 3426.11,
    "override_total_1": 3523.32,
    "override_increase_1": 97.21
  },
  {
    "#": "50 Park St, Unit 27 (214-43-14)",
    "$": 806300,
    "address": "50 Park St, Unit 27",
    "parcel_id": "214-43-14",
    "owner1": "NIAZMAND, SEYED S",
    "owner2": "",
    "current_taxes": 8256.51,
    "new_taxes_no_override": 8613.19,
    "override_total_1": 8857.58,
    "override_increase_1": 244.39
  },
  {
    "#": "50 Park St, Unit 28 (214-43-15)",
    "$": 789800,
    "address": "50 Park St, Unit 28",
    "parcel_id": "214-43-15",
    "owner1": "RAKUZ, LEO",
    "owner2": "SHEYFER, LILYA",
    "current_taxes": 4452.62,
    "new_taxes_no_override": 4644.97,
    "override_total_1": 4776.77,
    "override_increase_1": 131.8
  },
  {
    "#": "50 Park St, Unit 31 (214-43-16)",
    "$": 845600,
    "address": "50 Park St, Unit 31",
    "parcel_id": "214-43-16",
    "owner1": "KASO-COLLLETTE, ALMA",
    "owner2": "",
    "current_taxes": 5024.01,
    "new_taxes_no_override": 5241.05,
    "override_total_1": 5389.76,
    "override_increase_1": 148.71
  },
  {
    "#": "50 Park St, Unit 32 (214-43-17)",
    "$": 831600,
    "address": "50 Park St, Unit 32",
    "parcel_id": "214-43-17",
    "owner1": "VIDANOVIC TR, ZORAN",
    "owner2": "",
    "current_taxes": 4880.65,
    "new_taxes_no_override": 5091.49,
    "override_total_1": 5235.96,
    "override_increase_1": 144.47
  },
  {
    "#": "50 Park St, Unit 33 (214-43-18)",
    "$": 691800,
    "address": "50 Park St, Unit 33",
    "parcel_id": "214-43-18",
    "owner1": "LAROCQUE, KATHLEEN COLTON",
    "owner2": "",
    "current_taxes": 3449.1,
    "new_taxes_no_override": 3598.1,
    "override_total_1": 3700.19,
    "override_increase_1": 102.09
  },
  {
    "#": "50 Park St, Unit 34 (214-43-19)",
    "$": 646600,
    "address": "50 Park St, Unit 34",
    "parcel_id": "214-43-19",
    "owner1": "VAYSBURD LIFE ESTATE, ABRAM & DIANA",
    "owner2": "",
    "current_taxes": 2986.25,
    "new_taxes_no_override": 3115.26,
    "override_total_1": 3203.65,
    "override_increase_1": 88.39
  },
  {
    "#": "50 Park St, Unit 35 (214-43-20)",
    "$": 662700,
    "address": "50 Park St, Unit 35",
    "parcel_id": "214-43-20",
    "owner1": "OETTINGER TRS, PHILIP HALE & TRINA LYNN",
    "owner2": "OETTINGER, ANDREA RUTH",
    "current_taxes": 6786.05,
    "new_taxes_no_override": 7079.21,
    "override_total_1": 7280.07,
    "override_increase_1": 200.87
  },
  {
    "#": "50 Park St, Unit 36 (214-43-21)",
    "$": 661800,
    "address": "50 Park St, Unit 36",
    "parcel_id": "214-43-21",
    "owner1": "WILLIAMS, REBECCA G",
    "owner2": "",
    "current_taxes": 6776.83,
    "new_taxes_no_override": 7069.59,
    "override_total_1": 7270.18,
    "override_increase_1": 200.59
  },
  {
    "#": "50 Park St, Unit 37 (214-43-22)",
    "$": 828100,
    "address": "50 Park St, Unit 37",
    "parcel_id": "214-43-22",
    "owner1": "KO, CONNEY",
    "owner2": "",
    "current_taxes": 8479.74,
    "new_taxes_no_override": 8846.06,
    "override_total_1": 9097.07,
    "override_increase_1": 251.0
  },
  {
    "#": "50 Park St, Unit 38 (214-43-23)",
    "$": 789800,
    "address": "50 Park St, Unit 38",
    "parcel_id": "214-43-23",
    "owner1": "RABADJIJA TR, NEVEN",
    "owner2": "",
    "current_taxes": 8087.55,
    "new_taxes_no_override": 8436.93,
    "override_total_1": 8676.32,
    "override_increase_1": 239.39
  },
  {
    "#": "50 Park St, Unit 41 (214-43-24)",
    "$": 845600,
    "address": "50 Park St, Unit 41",
    "parcel_id": "214-43-24",
    "owner1": "REDDY, OLTA TAFAJ",
    "owner2": "YEREDLA, RAKESH R",
    "current_taxes": 8658.94,
    "new_taxes_no_override": 9033.01,
    "override_total_1": 9289.31,
    "override_increase_1": 256.3
  },
  {
    "#": "50 Park St, Unit 42 (214-43-25)",
    "$": 792400,
    "address": "50 Park St, Unit 42",
    "parcel_id": "214-43-25",
    "owner1": "VIDANOVIC, MARIYA SHATSMAN",
    "owner2": "",
    "current_taxes": 4479.24,
    "new_taxes_no_override": 4672.74,
    "override_total_1": 4805.33,
    "override_increase_1": 132.59
  },
  {
    "#": "50 Park St, Unit 43 (214-43-26)",
    "$": 662700,
    "address": "50 Park St, Unit 43",
    "parcel_id": "214-43-26",
    "owner1": "NIAZMAND, SHAHRZAD",
    "owner2": "",
    "current_taxes": 6786.05,
    "new_taxes_no_override": 7079.21,
    "override_total_1": 7280.07,
    "override_increase_1": 200.87
  },
  {
    "#": "50 Park St, Unit 44 (214-43-27)",
    "$": 646600,
    "address": "50 Park St, Unit 44",
    "parcel_id": "214-43-27",
    "owner1": "MAO, WENYANG",
    "owner2": "TIAN, GENG",
    "current_taxes": 6621.18,
    "new_taxes_no_override": 6907.21,
    "override_total_1": 7103.2,
    "override_increase_1": 195.99
  },
  {
    "#": "50 Park St, Unit 45 (214-43-28)",
    "$": 680100,
    "address": "50 Park St, Unit 45",
    "parcel_id": "214-43-28",
    "owner1": "ARNAOUT, M AMIN & AMAL KAWA",
    "owner2": "",
    "current_taxes": 6964.22,
    "new_taxes_no_override": 7265.07,
    "override_total_1": 7471.22,
    "override_increase_1": 206.14
  },
  {
    "#": "50 Park St, Unit 46 (214-43-29)",
    "$": 574800,
    "address": "50 Park St, Unit 46",
    "parcel_id": "214-43-29",
    "owner1": "DASHTI, GOHAR",
    "owner2": "NOORI, HAMED",
    "current_taxes": 5885.95,
    "new_taxes_no_override": 6140.22,
    "override_total_1": 6314.45,
    "override_increase_1": 174.22
  },
  {
    "#": "50 Park St, Unit 47 (214-43-30)",
    "$": 845600,
    "address": "50 Park St, Unit 47",
    "parcel_id": "214-43-30",
    "owner1": "SUN, YANG-HARN",
    "owner2": "HSU, CHE-CHI",
    "current_taxes": 8658.94,
    "new_taxes_no_override": 9033.01,
    "override_total_1": 9289.31,
    "override_increase_1": 256.3
  },
  {
    "#": "50 Park St, Unit 48 (214-43-31)",
    "$": 789800,
    "address": "50 Park St, Unit 48",
    "parcel_id": "214-43-31",
    "owner1": "KNOBEL LIFE ESTATE, VLADIMIR A",
    "owner2": "BERZOW, FLORA",
    "current_taxes": 4452.62,
    "new_taxes_no_override": 4644.97,
    "override_total_1": 4776.77,
    "override_increase_1": 131.8
  },
  {
    "#": "55 Park St, Unit 1A & G16 (169-01-01)",
    "$": 342700,
    "address": "55 Park St, Unit 1A & G16",
    "parcel_id": "169-01-01",
    "owner1": "SEK, POH KUEN",
    "owner2": "LOH, AH KEEN",
    "current_taxes": 350.92,
    "new_taxes_no_override": 366.08,
    "override_total_1": 376.47,
    "override_increase_1": 10.39
  },
  {
    "#": "55 Park St, Unit 1B & G7-8 (169-01-02)",
    "$": 1685000,
    "address": "55 Park St, Unit 1B & G7-8",
    "parcel_id": "169-01-02",
    "owner1": "LIU TRS, NAN-SUEY & HSIU-MIN",
    "owner2": "",
    "current_taxes": 13619.47,
    "new_taxes_no_override": 14207.83,
    "override_total_1": 14610.97,
    "override_increase_1": 403.14
  },
  {
    "#": "55 Park St, Unit 1C & G15 (169-01-03)",
    "$": 286300,
    "address": "55 Park St, Unit 1C & G15",
    "parcel_id": "169-01-03",
    "owner1": "VASIOS, KRISTINE B",
    "owner2": "",
    "current_taxes": 293.17,
    "new_taxes_no_override": 305.83,
    "override_total_1": 314.51,
    "override_increase_1": 8.68
  },
  {
    "#": "55 Park St, Unit 2A & G9-10 (169-01-04)",
    "$": 1839400,
    "address": "55 Park St, Unit 2A & G9-10",
    "parcel_id": "169-01-04",
    "owner1": "GOLDSTEIN, WALTER A",
    "owner2": "WALZER, TONI B",
    "current_taxes": 15200.52,
    "new_taxes_no_override": 15857.18,
    "override_total_1": 16307.12,
    "override_increase_1": 449.94
  },
  {
    "#": "55 Park St, Unit 2B G11-12 (169-01-05)",
    "$": 1773800,
    "address": "55 Park St, Unit 2B G11-12",
    "parcel_id": "169-01-05",
    "owner1": "ADVANI, GEETANJALI ANU",
    "owner2": "",
    "current_taxes": 14528.78,
    "new_taxes_no_override": 15156.42,
    "override_total_1": 15586.48,
    "override_increase_1": 430.05
  },
  {
    "#": "55 Park St, Unit 3A & G5 G6 (169-01-06)",
    "$": 1839400,
    "address": "55 Park St, Unit 3A & G5 G6",
    "parcel_id": "169-01-06",
    "owner1": "EFIMOVA, OLGA",
    "owner2": "",
    "current_taxes": 15200.52,
    "new_taxes_no_override": 15857.18,
    "override_total_1": 16307.12,
    "override_increase_1": 449.94
  },
  {
    "#": "55 Park St, Unit 3B & G3 G4 (169-01-07)",
    "$": 1773800,
    "address": "55 Park St, Unit 3B & G3 G4",
    "parcel_id": "169-01-07",
    "owner1": "HOCH, ROBERT",
    "owner2": "ROTHFELD, BEVERLY",
    "current_taxes": 14528.78,
    "new_taxes_no_override": 15156.42,
    "override_total_1": 15586.48,
    "override_increase_1": 430.05
  },
  {
    "#": "55 Park St, Unit 4A & G1 G2 (169-01-08)",
    "$": 2406200,
    "address": "55 Park St, Unit 4A & G1 G2",
    "parcel_id": "169-01-08",
    "owner1": "FRENCH TRS, JAMES A",
    "owner2": "DE LEON FRENCH, MARIA PRISCILLA",
    "current_taxes": 21004.55,
    "new_taxes_no_override": 21911.95,
    "override_total_1": 22533.68,
    "override_increase_1": 621.73
  },
  {
    "#": "55 Park St, Unit 4B &G17-18 (169-01-09)",
    "$": 2367600,
    "address": "55 Park St, Unit 4B &G17-18",
    "parcel_id": "169-01-09",
    "owner1": "YOU, JAE YOUNG",
    "owner2": "BAN, WOO HYUN",
    "current_taxes": 20609.29,
    "new_taxes_no_override": 21499.61,
    "override_total_1": 22109.65,
    "override_increase_1": 610.03
  },
  {
    "#": "61 Park St (169-02-00)",
    "$": 15776200,
    "address": "61 Park St",
    "parcel_id": "169-02-00",
    "owner1": "BROOKLINE HOUSING AUTHORITY",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "65 Park St, Unit 1 & P15 (169-03-26)",
    "$": 791500,
    "address": "65 Park St, Unit 1 & P15",
    "parcel_id": "169-03-26",
    "owner1": "ROOHI, BEHNAM J",
    "owner2": "MILANI, TARANEH",
    "current_taxes": 8104.96,
    "new_taxes_no_override": 8455.09,
    "override_total_1": 8695.0,
    "override_increase_1": 239.91
  },
  {
    "#": "65 Park St, Unit 2 & P13 (169-03-01)",
    "$": 761800,
    "address": "65 Park St, Unit 2 & P13",
    "parcel_id": "169-03-01",
    "owner1": "VOLOSHIN LIFE ESTATE, GENNADIY",
    "owner2": "VOLOSHINA LIFE ESTATE, ZHANNA",
    "current_taxes": 4165.9,
    "new_taxes_no_override": 4345.87,
    "override_total_1": 4469.18,
    "override_increase_1": 123.31
  },
  {
    "#": "65 Park St, Unit 3 & P10 (169-03-02)",
    "$": 874100,
    "address": "65 Park St, Unit 3 & P10",
    "parcel_id": "169-03-02",
    "owner1": "WHITE, SUSAN",
    "owner2": "RIBNER, JONATHAN",
    "current_taxes": 5315.85,
    "new_taxes_no_override": 5545.49,
    "override_total_1": 5702.84,
    "override_increase_1": 157.35
  },
  {
    "#": "65 Park St, Unit 4 & G17 (169-03-03)",
    "$": 878100,
    "address": "65 Park St, Unit 4 & G17",
    "parcel_id": "169-03-03",
    "owner1": "MEHR, MEHRDAD F",
    "owner2": "",
    "current_taxes": 8991.74,
    "new_taxes_no_override": 9380.18,
    "override_total_1": 9646.34,
    "override_increase_1": 266.16
  },
  {
    "#": "65 Park St, Unit 5 & Pc1 (169-03-04)",
    "$": 845900,
    "address": "65 Park St, Unit 5 & Pc1",
    "parcel_id": "169-03-04",
    "owner1": "TIAN, FENG",
    "owner2": "LUO, TAIYUE",
    "current_taxes": 5027.08,
    "new_taxes_no_override": 5244.25,
    "override_total_1": 5393.05,
    "override_increase_1": 148.8
  },
  {
    "#": "65 Park St, Unit 6 & G18 (169-03-05)",
    "$": 889800,
    "address": "65 Park St, Unit 6 & G18",
    "parcel_id": "169-03-05",
    "owner1": "CHIN, ROGER D",
    "owner2": "",
    "current_taxes": 9111.55,
    "new_taxes_no_override": 9505.17,
    "override_total_1": 9774.87,
    "override_increase_1": 269.7
  },
  {
    "#": "67 Park St, Unit 1 (169-03-06)",
    "$": 587800,
    "address": "67 Park St, Unit 1",
    "parcel_id": "169-03-06",
    "owner1": "DAVILA, LUZ MARIA",
    "owner2": "",
    "current_taxes": 2384.14,
    "new_taxes_no_override": 2487.13,
    "override_total_1": 2557.71,
    "override_increase_1": 70.57
  },
  {
    "#": "67 Park St, Unit 2 & P14 (169-03-07)",
    "$": 629400,
    "address": "67 Park St, Unit 2 & P14",
    "parcel_id": "169-03-07",
    "owner1": "ZHOU, ZHIQIANG",
    "owner2": "JI, FANG",
    "current_taxes": 6445.06,
    "new_taxes_no_override": 6723.49,
    "override_total_1": 6914.26,
    "override_increase_1": 190.77
  },
  {
    "#": "67 Park St, Unit 3 & Pc3 (169-03-08)",
    "$": 628200,
    "address": "67 Park St, Unit 3 & Pc3",
    "parcel_id": "169-03-08",
    "owner1": "LIN, KAI",
    "owner2": "",
    "current_taxes": 6432.77,
    "new_taxes_no_override": 6710.67,
    "override_total_1": 6901.08,
    "override_increase_1": 190.41
  },
  {
    "#": "69 Park St, Unit 1 (169-03-09)",
    "$": 738800,
    "address": "69 Park St, Unit 1",
    "parcel_id": "169-03-09",
    "owner1": "CHODOSOVSKY, OLEG & ELENA",
    "owner2": "",
    "current_taxes": 3930.38,
    "new_taxes_no_override": 4100.17,
    "override_total_1": 4216.51,
    "override_increase_1": 116.34
  },
  {
    "#": "69 Park St, Unit 2 & P7 (169-03-10)",
    "$": 774600,
    "address": "69 Park St, Unit 2 & P7",
    "parcel_id": "169-03-10",
    "owner1": "WEBER, EMILY",
    "owner2": "",
    "current_taxes": 4296.97,
    "new_taxes_no_override": 4482.6,
    "override_total_1": 4609.79,
    "override_increase_1": 127.19
  },
  {
    "#": "69 Park St, Unit 3 & G19 (169-03-11)",
    "$": 849300,
    "address": "69 Park St, Unit 3 & G19",
    "parcel_id": "169-03-11",
    "owner1": "KLEBANOV TR, JOSEPH & ANNA",
    "owner2": "",
    "current_taxes": 5061.9,
    "new_taxes_no_override": 5280.57,
    "override_total_1": 5430.41,
    "override_increase_1": 149.83
  },
  {
    "#": "69 Park St, Unit 4 & P16 (169-03-12)",
    "$": 807600,
    "address": "69 Park St, Unit 4 & P16",
    "parcel_id": "169-03-12",
    "owner1": "DOST, IBRAHIM & MARINA",
    "owner2": "",
    "current_taxes": 4634.89,
    "new_taxes_no_override": 4835.12,
    "override_total_1": 4972.31,
    "override_increase_1": 137.19
  },
  {
    "#": "69 Park St, Unit 5 & P5 (169-03-13)",
    "$": 826700,
    "address": "69 Park St, Unit 5 & P5",
    "parcel_id": "169-03-13",
    "owner1": "LOZOVSKY, IRINA",
    "owner2": "",
    "current_taxes": 8465.41,
    "new_taxes_no_override": 8831.12,
    "override_total_1": 9081.69,
    "override_increase_1": 250.58
  },
  {
    "#": "69 Park St, Unit 6 & P8 (169-03-14)",
    "$": 782200,
    "address": "69 Park St, Unit 6 & P8",
    "parcel_id": "169-03-14",
    "owner1": "GINSBURG, CELINE & JONATHAN",
    "owner2": "",
    "current_taxes": 4374.79,
    "new_taxes_no_override": 4563.78,
    "override_total_1": 4693.27,
    "override_increase_1": 129.49
  },
  {
    "#": "70 Park St, Unit 16 (214-39-04)",
    "$": 343400,
    "address": "70 Park St, Unit 16",
    "parcel_id": "214-39-04",
    "owner1": "BOLAND, JAMES",
    "owner2": "",
    "current_taxes": 351.64,
    "new_taxes_no_override": 366.83,
    "override_total_1": 377.24,
    "override_increase_1": 10.41
  },
  {
    "#": "70 Park St, Unit 17 & P-H (214-39-05)",
    "$": 411800,
    "address": "70 Park St, Unit 17 & P-H",
    "parcel_id": "214-39-05",
    "owner1": "CLAYTON , RICHARD L & ALEXANDRA",
    "owner2": "HAZARD, HOLLY E",
    "current_taxes": 4216.83,
    "new_taxes_no_override": 4399.0,
    "override_total_1": 4523.82,
    "override_increase_1": 124.82
  },
  {
    "#": "70 Park St, Unit 18 & Pk-G (214-39-06)",
    "$": 617800,
    "address": "70 Park St, Unit 18 & Pk-G",
    "parcel_id": "214-39-06",
    "owner1": "YEE, RUI LAN & DONNA",
    "owner2": "",
    "current_taxes": 2691.34,
    "new_taxes_no_override": 2807.61,
    "override_total_1": 2887.27,
    "override_increase_1": 79.66
  },
  {
    "#": "70 Park St, Unit 21 (214-39-07)",
    "$": 1169000,
    "address": "70 Park St, Unit 21",
    "parcel_id": "214-39-07",
    "owner1": "PENNY HOLDINGS LLC",
    "owner2": "C/O RADA RUDYAK",
    "current_taxes": 11970.56,
    "new_taxes_no_override": 12487.69,
    "override_total_1": 12842.02,
    "override_increase_1": 354.33
  },
  {
    "#": "70 Park St, Unit 22 & P60 (214-39-08)",
    "$": 1002400,
    "address": "70 Park St, Unit 22 & P60",
    "parcel_id": "214-39-08",
    "owner1": "PENNY HOLDINGS LLC",
    "owner2": "C/O RADA RUDYAK",
    "current_taxes": 10264.58,
    "new_taxes_no_override": 10708.01,
    "override_total_1": 11011.84,
    "override_increase_1": 303.83
  },
  {
    "#": "70 Park St, Unit 23 & P24 (214-39-09)",
    "$": 806000,
    "address": "70 Park St, Unit 23 & P24",
    "parcel_id": "214-39-09",
    "owner1": "BRENNER TR, JACQUELINE N",
    "owner2": "",
    "current_taxes": 4618.51,
    "new_taxes_no_override": 4818.03,
    "override_total_1": 4954.74,
    "override_increase_1": 136.71
  },
  {
    "#": "70 Park St, Unit 24 & G16 (214-39-10)",
    "$": 820500,
    "address": "70 Park St, Unit 24 & G16",
    "parcel_id": "214-39-10",
    "owner1": "STEINBERG TR, CYNTHIA T",
    "owner2": "",
    "current_taxes": 4766.99,
    "new_taxes_no_override": 4972.92,
    "override_total_1": 5114.03,
    "override_increase_1": 141.1
  },
  {
    "#": "70 Park St, Unit 25 (214-39-11)",
    "$": 795600,
    "address": "70 Park St, Unit 25",
    "parcel_id": "214-39-11",
    "owner1": "KENNEDY, CONOR",
    "owner2": "ZHANG, MAN",
    "current_taxes": 4512.01,
    "new_taxes_no_override": 4706.93,
    "override_total_1": 4840.48,
    "override_increase_1": 133.56
  },
  {
    "#": "70 Park St, Unit 26 (214-39-12)",
    "$": 797100,
    "address": "70 Park St, Unit 26",
    "parcel_id": "214-39-12",
    "owner1": "CAMPBELL TRS, GERALD D & JUDITH P & THERESA M",
    "owner2": "",
    "current_taxes": 4527.37,
    "new_taxes_no_override": 4722.95,
    "override_total_1": 4856.96,
    "override_increase_1": 134.01
  },
  {
    "#": "70 Park St, Unit 31 & P59 (214-39-13)",
    "$": 981600,
    "address": "70 Park St, Unit 31 & P59",
    "parcel_id": "214-39-13",
    "owner1": "FISH TRS, ANATOLY",
    "owner2": "SCHWARTZ, SOPHIA",
    "current_taxes": 6416.65,
    "new_taxes_no_override": 6693.85,
    "override_total_1": 6883.78,
    "override_increase_1": 189.93
  },
  {
    "#": "70 Park St, Unit 32 (214-39-14)",
    "$": 1104600,
    "address": "70 Park St, Unit 32",
    "parcel_id": "214-39-14",
    "owner1": "SHEN, JIAYI",
    "owner2": "",
    "current_taxes": 11311.1,
    "new_taxes_no_override": 11799.74,
    "override_total_1": 12134.55,
    "override_increase_1": 334.81
  },
  {
    "#": "70 Park St, Unit 33 & P63 (214-39-15)",
    "$": 805900,
    "address": "70 Park St, Unit 33 & P63",
    "parcel_id": "214-39-15",
    "owner1": "FRIEDMAN ET AL TRS, JAMES D",
    "owner2": "EINSTEIN TRS, AMY B",
    "current_taxes": 4617.48,
    "new_taxes_no_override": 4816.96,
    "override_total_1": 4953.63,
    "override_increase_1": 136.68
  },
  {
    "#": "70 Park St, Unit 34 (214-39-16)",
    "$": 805200,
    "address": "70 Park St, Unit 34",
    "parcel_id": "214-39-16",
    "owner1": "ESPOSITO TR, GIANLUIGI",
    "owner2": "C/O MARIO DIACONO",
    "current_taxes": 8245.25,
    "new_taxes_no_override": 8601.44,
    "override_total_1": 8845.5,
    "override_increase_1": 244.06
  },
  {
    "#": "70 Park St, Unit 35 & G12 (214-39-17)",
    "$": 812900,
    "address": "70 Park St, Unit 35 & G12",
    "parcel_id": "214-39-17",
    "owner1": "CLARK TR, NANCY L",
    "owner2": "",
    "current_taxes": 8324.1,
    "new_taxes_no_override": 8683.7,
    "override_total_1": 8930.09,
    "override_increase_1": 246.39
  },
  {
    "#": "70 Park St, Unit 36 & P-47 (214-39-18)",
    "$": 781900,
    "address": "70 Park St, Unit 36 & P-47",
    "parcel_id": "214-39-18",
    "owner1": "HSU, YU FEN & YA HUEI",
    "owner2": "",
    "current_taxes": 8006.66,
    "new_taxes_no_override": 8352.55,
    "override_total_1": 8589.54,
    "override_increase_1": 237.0
  },
  {
    "#": "70 Park St, Unit 41 P33-34 (214-39-19)",
    "$": 1134700,
    "address": "70 Park St, Unit 41 P33-34",
    "parcel_id": "214-39-19",
    "owner1": "HUSSEY, SHEILA E",
    "owner2": "",
    "current_taxes": 7984.39,
    "new_taxes_no_override": 8329.32,
    "override_total_1": 8565.65,
    "override_increase_1": 236.34
  },
  {
    "#": "70 Park St, Unit 42 & P10 (214-39-20)",
    "$": 968000,
    "address": "70 Park St, Unit 42 & P10",
    "parcel_id": "214-39-20",
    "owner1": "HERSHENSON, DAVID B & MARIAN V",
    "owner2": "",
    "current_taxes": 6277.39,
    "new_taxes_no_override": 6548.57,
    "override_total_1": 6734.38,
    "override_increase_1": 185.81
  },
  {
    "#": "70 Park St, Unit 43 & P65 (214-39-21)",
    "$": 787600,
    "address": "70 Park St, Unit 43 & P65",
    "parcel_id": "214-39-21",
    "owner1": "LU, TONG",
    "owner2": "DUAN, JIANING",
    "current_taxes": 4430.09,
    "new_taxes_no_override": 4621.47,
    "override_total_1": 4752.6,
    "override_increase_1": 131.13
  },
  {
    "#": "70 Park St, Unit 44 & P7 (214-39-22)",
    "$": 846900,
    "address": "70 Park St, Unit 44 & P7",
    "parcel_id": "214-39-22",
    "owner1": "WU TRS, YU-HSUAN",
    "owner2": "CHANG, KUANGCHOU",
    "current_taxes": 8672.26,
    "new_taxes_no_override": 9046.9,
    "override_total_1": 9303.6,
    "override_increase_1": 256.7
  },
  {
    "#": "70 Park St, Unit 7012 P-E (214-39-02)",
    "$": 409500,
    "address": "70 Park St, Unit 7012 P-E",
    "parcel_id": "214-39-02",
    "owner1": "MOQRI, MOHAMMADMAHDI",
    "owner2": "",
    "current_taxes": 4193.28,
    "new_taxes_no_override": 4374.43,
    "override_total_1": 4498.55,
    "override_increase_1": 124.12
  },
  {
    "#": "70 Park St, Unit 7015 & P-F (214-39-03)",
    "$": 376900,
    "address": "70 Park St, Unit 7015 & P-F",
    "parcel_id": "214-39-03",
    "owner1": "WILLEMS, SEAN & ANJANETTE",
    "owner2": "",
    "current_taxes": 385.95,
    "new_taxes_no_override": 402.62,
    "override_total_1": 414.05,
    "override_increase_1": 11.42
  },
  {
    "#": "70 Park St, Unit 7045 (214-39-23)",
    "$": 842400,
    "address": "70 Park St, Unit 7045",
    "parcel_id": "214-39-23",
    "owner1": "PORKHOVNIK TR, JANNA",
    "owner2": "",
    "current_taxes": 8626.18,
    "new_taxes_no_override": 8998.83,
    "override_total_1": 9254.17,
    "override_increase_1": 255.33
  },
  {
    "#": "70 Park St, Unit 7046 & P57 (214-39-24)",
    "$": 797200,
    "address": "70 Park St, Unit 7046 & P57",
    "parcel_id": "214-39-24",
    "owner1": "CHEN, YUYING",
    "owner2": "ZHANG, GUOQI",
    "current_taxes": 8163.33,
    "new_taxes_no_override": 8515.99,
    "override_total_1": 8757.62,
    "override_increase_1": 241.63
  },
  {
    "#": "70 Park St, Unit 7051 & P18 (214-39-25)",
    "$": 1007700,
    "address": "70 Park St, Unit 7051 & P18",
    "parcel_id": "214-39-25",
    "owner1": "GOLBURGH TR, LINDA G",
    "owner2": "",
    "current_taxes": 6683.91,
    "new_taxes_no_override": 6972.65,
    "override_total_1": 7170.5,
    "override_increase_1": 197.84
  },
  {
    "#": "70 Park St, Unit 7052 & P9 (214-39-26)",
    "$": 1123000,
    "address": "70 Park St, Unit 7052 & P9",
    "parcel_id": "214-39-26",
    "owner1": "SPEKTOR, ALEXANDER",
    "owner2": "VOVNOBOY, IRINA",
    "current_taxes": 7864.59,
    "new_taxes_no_override": 8204.34,
    "override_total_1": 8437.13,
    "override_increase_1": 232.79
  },
  {
    "#": "70 Park St, Unit 7053 (214-39-27)",
    "$": 913400,
    "address": "70 Park St, Unit 7053",
    "parcel_id": "214-39-27",
    "owner1": "OCHERETYANNY, SEMYON & GALINA",
    "owner2": "",
    "current_taxes": 5718.28,
    "new_taxes_no_override": 5965.31,
    "override_total_1": 6134.57,
    "override_increase_1": 169.26
  },
  {
    "#": "70 Park St, Unit 7054 & P54 (214-39-28)",
    "$": 948000,
    "address": "70 Park St, Unit 7054 & P54",
    "parcel_id": "214-39-28",
    "owner1": "GREENBERG, ETHAN M & JASPER N",
    "owner2": "",
    "current_taxes": 6072.59,
    "new_taxes_no_override": 6334.93,
    "override_total_1": 6514.67,
    "override_increase_1": 179.75
  },
  {
    "#": "70 Park St, Unit 7055 & P19 (214-39-29)",
    "$": 832200,
    "address": "70 Park St, Unit 7055 & P19",
    "parcel_id": "214-39-29",
    "owner1": "LIU, EDWARD P",
    "owner2": "",
    "current_taxes": 8521.73,
    "new_taxes_no_override": 8889.87,
    "override_total_1": 9142.11,
    "override_increase_1": 252.24
  },
  {
    "#": "70 Park St, Unit 7056 & G11 (214-39-30)",
    "$": 807500,
    "address": "70 Park St, Unit 7056 & G11",
    "parcel_id": "214-39-30",
    "owner1": "ANDRADE, DAVID",
    "owner2": "BOTELHO, MARIA FERNANDA",
    "current_taxes": 4633.87,
    "new_taxes_no_override": 4834.05,
    "override_total_1": 4971.22,
    "override_increase_1": 137.16
  },
  {
    "#": "70 Park St, Unit 7061 & P43 (214-39-31)",
    "$": 1008400,
    "address": "70 Park St, Unit 7061 & P43",
    "parcel_id": "214-39-31",
    "owner1": "KENNISTON, DONNA VENEGAS & STEVEN NOBLE",
    "owner2": "",
    "current_taxes": 6691.08,
    "new_taxes_no_override": 6980.13,
    "override_total_1": 7178.19,
    "override_increase_1": 198.06
  },
  {
    "#": "70 Park St, Unit 7062 (214-39-32)",
    "$": 1112800,
    "address": "70 Park St, Unit 7062",
    "parcel_id": "214-39-32",
    "owner1": "MALIKIN, ILYA & LYUDMILA",
    "owner2": "",
    "current_taxes": 7760.14,
    "new_taxes_no_override": 8095.38,
    "override_total_1": 8325.08,
    "override_increase_1": 229.7
  },
  {
    "#": "70 Park St, Unit 7063 & P20 (214-39-33)",
    "$": 821300,
    "address": "70 Park St, Unit 7063 & P20",
    "parcel_id": "214-39-33",
    "owner1": "ROTH TRS, PETER & JULIE GILLIAM",
    "owner2": "",
    "current_taxes": 8410.11,
    "new_taxes_no_override": 8773.43,
    "override_total_1": 9022.37,
    "override_increase_1": 248.94
  },
  {
    "#": "70 Park St, Unit 7064 & P23 (214-39-34)",
    "$": 1026100,
    "address": "70 Park St, Unit 7064 & P23",
    "parcel_id": "214-39-34",
    "owner1": "LUKACEVIC, DEJAN & TATJANA",
    "owner2": "",
    "current_taxes": 6872.33,
    "new_taxes_no_override": 7169.21,
    "override_total_1": 7372.64,
    "override_increase_1": 203.42
  },
  {
    "#": "70 Park St, Unit 7065 (214-39-35)",
    "$": 835900,
    "address": "70 Park St, Unit 7065",
    "parcel_id": "214-39-35",
    "owner1": "EDELMAN, DAVID & CAROL",
    "owner2": "",
    "current_taxes": 8559.62,
    "new_taxes_no_override": 8929.4,
    "override_total_1": 9182.76,
    "override_increase_1": 253.36
  },
  {
    "#": "70 Park St, Unit 7066 (214-39-36)",
    "$": 894100,
    "address": "70 Park St, Unit 7066",
    "parcel_id": "214-39-36",
    "owner1": "ESFAHANY, KOUROS",
    "owner2": "NGUYEN, ANHTRAM",
    "current_taxes": 9155.58,
    "new_taxes_no_override": 9551.1,
    "override_total_1": 9822.11,
    "override_increase_1": 271.01
  },
  {
    "#": "70 Park St, Unit 7071&P15 (214-39-37)",
    "$": 1189800,
    "address": "70 Park St, Unit 7071&P15",
    "parcel_id": "214-39-37",
    "owner1": "ANDRADE, DAVID",
    "owner2": "",
    "current_taxes": 8548.62,
    "new_taxes_no_override": 8917.92,
    "override_total_1": 9170.96,
    "override_increase_1": 253.04
  },
  {
    "#": "70 Park St, Unit 7072 & G52 (214-39-38)",
    "$": 1337600,
    "address": "70 Park St, Unit 7072 & G52",
    "parcel_id": "214-39-38",
    "owner1": "WANG, HSIU MEI",
    "owner2": "",
    "current_taxes": 10062.09,
    "new_taxes_no_override": 10496.77,
    "override_total_1": 10794.61,
    "override_increase_1": 297.84
  },
  {
    "#": "70 Park St, Unit 7074 (214-39-39)",
    "$": 1343800,
    "address": "70 Park St, Unit 7074",
    "parcel_id": "214-39-39",
    "owner1": "BRUCE, ELLEN A",
    "owner2": "SEGAN, RICHARD",
    "current_taxes": 13760.51,
    "new_taxes_no_override": 14354.96,
    "override_total_1": 14762.28,
    "override_increase_1": 407.31
  },
  {
    "#": "70 Park St, Unit 7075 & P46 (214-39-40)",
    "$": 960700,
    "address": "70 Park St, Unit 7075 & P46",
    "parcel_id": "214-39-40",
    "owner1": "MAPELLI, PAOLO",
    "owner2": "",
    "current_taxes": 6202.63,
    "new_taxes_no_override": 6470.58,
    "override_total_1": 6654.18,
    "override_increase_1": 183.6
  },
  {
    "#": "70 Park St, Unit 7076 & P17 (214-39-41)",
    "$": 919200,
    "address": "70 Park St, Unit 7076 & P17",
    "parcel_id": "214-39-41",
    "owner1": "DOAN, VINH",
    "owner2": "LUI, ZONG CHENG",
    "current_taxes": 9412.61,
    "new_taxes_no_override": 9819.23,
    "override_total_1": 10097.85,
    "override_increase_1": 278.61
  },
  {
    "#": "70 Park St, Unit 70Ph & P7043 (214-39-42)",
    "$": 1965300,
    "address": "70 Park St, Unit 70Ph & P7043",
    "parcel_id": "214-39-42",
    "owner1": "MELZER TRS, ROBERT M & JUDITH G",
    "owner2": "MELZER TRS, JUDITH G & ROBERT M",
    "current_taxes": 16489.74,
    "new_taxes_no_override": 17202.1,
    "override_total_1": 17690.19,
    "override_increase_1": 488.1
  },
  {
    "#": "71 Park St, Unit 1 (169-03-15)",
    "$": 515600,
    "address": "71 Park St, Unit 1",
    "parcel_id": "169-03-15",
    "owner1": "ZHANG, RUOSHUI",
    "owner2": "",
    "current_taxes": 1644.81,
    "new_taxes_no_override": 1715.87,
    "override_total_1": 1764.55,
    "override_increase_1": 48.69
  },
  {
    "#": "71 Park St, Unit 2 & P4 (169-03-16)",
    "$": 634900,
    "address": "71 Park St, Unit 2 & P4",
    "parcel_id": "169-03-16",
    "owner1": "KNYAZHITSKIY, IGOR",
    "owner2": "",
    "current_taxes": 6501.38,
    "new_taxes_no_override": 6782.24,
    "override_total_1": 6974.68,
    "override_increase_1": 192.44
  },
  {
    "#": "71 Park St, Unit 3 (169-03-17)",
    "$": 583600,
    "address": "71 Park St, Unit 3",
    "parcel_id": "169-03-17",
    "owner1": "DELLOSTRITTO, ALEXANDRA A",
    "owner2": "",
    "current_taxes": 2341.13,
    "new_taxes_no_override": 2442.27,
    "override_total_1": 2511.56,
    "override_increase_1": 69.3
  },
  {
    "#": "73 Park St, Unit 1 & Pc2 (169-03-18)",
    "$": 803500,
    "address": "73 Park St, Unit 1 & Pc2",
    "parcel_id": "169-03-18",
    "owner1": "SHAH, NAMRATA HEMANT",
    "owner2": "MARINI, ANDREA",
    "current_taxes": 8227.84,
    "new_taxes_no_override": 8583.28,
    "override_total_1": 8826.83,
    "override_increase_1": 243.54
  },
  {
    "#": "73 Park St, Unit 2 & P6 (169-03-19)",
    "$": 757000,
    "address": "73 Park St, Unit 2 & P6",
    "parcel_id": "169-03-19",
    "owner1": "73-2 PARK LLC",
    "owner2": "",
    "current_taxes": 7751.68,
    "new_taxes_no_override": 8086.55,
    "override_total_1": 8316.0,
    "override_increase_1": 229.45
  },
  {
    "#": "73 Park St, Unit 3 (169-03-20)",
    "$": 765700,
    "address": "73 Park St, Unit 3",
    "parcel_id": "169-03-20",
    "owner1": "AWASTHI, SUMIT",
    "owner2": "AWASTHY, MANDAKINI",
    "current_taxes": 4205.83,
    "new_taxes_no_override": 4387.52,
    "override_total_1": 4512.01,
    "override_increase_1": 124.49
  },
  {
    "#": "73 Park St, Unit 4 & P8 (169-03-21)",
    "$": 772300,
    "address": "73 Park St, Unit 4 & P8",
    "parcel_id": "169-03-21",
    "owner1": "MINTS LIFE ESTATE, YEFIM & YEVGENIYA",
    "owner2": "",
    "current_taxes": 4273.42,
    "new_taxes_no_override": 4458.03,
    "override_total_1": 4584.52,
    "override_increase_1": 126.49
  },
  {
    "#": "73 Park St, Unit 5 (169-03-22)",
    "$": 750400,
    "address": "73 Park St, Unit 5",
    "parcel_id": "169-03-22",
    "owner1": "CHERNOV TRS, ALEXANDER & MARINA",
    "owner2": "",
    "current_taxes": 4049.16,
    "new_taxes_no_override": 4224.08,
    "override_total_1": 4343.94,
    "override_increase_1": 119.86
  },
  {
    "#": "73 Park St, Unit 6 & P11 (169-03-23)",
    "$": 772300,
    "address": "73 Park St, Unit 6 & P11",
    "parcel_id": "169-03-23",
    "owner1": "YANG, XIAOPING",
    "owner2": "LI, HAO",
    "current_taxes": 4273.42,
    "new_taxes_no_override": 4458.03,
    "override_total_1": 4584.52,
    "override_increase_1": 126.49
  },
  {
    "#": "73 Park St, Unit B & P12 (169-03-24)",
    "$": 599300,
    "address": "73 Park St, Unit B & P12",
    "parcel_id": "169-03-24",
    "owner1": "BEEKMAN, PEGGY & JOSHUA",
    "owner2": "",
    "current_taxes": 2501.9,
    "new_taxes_no_override": 2609.98,
    "override_total_1": 2684.04,
    "override_increase_1": 74.06
  },
  {
    "#": "75 Park St, Unit 1 (169-04-01)",
    "$": 569600,
    "address": "75 Park St, Unit 1",
    "parcel_id": "169-04-01",
    "owner1": "TOLOU, AZIZOLLAH",
    "owner2": "",
    "current_taxes": 5832.7,
    "new_taxes_no_override": 6084.67,
    "override_total_1": 6257.32,
    "override_increase_1": 172.65
  },
  {
    "#": "75 Park St, Unit 2 (169-04-02)",
    "$": 330500,
    "address": "75 Park St, Unit 2",
    "parcel_id": "169-04-02",
    "owner1": "BLAW LLC",
    "owner2": "C/O ARLENE LEHANE",
    "current_taxes": 3384.32,
    "new_taxes_no_override": 3530.52,
    "override_total_1": 3630.7,
    "override_increase_1": 100.18
  },
  {
    "#": "75 Park St, Unit 3 (169-04-03)",
    "$": 483100,
    "address": "75 Park St, Unit 3",
    "parcel_id": "169-04-03",
    "owner1": "MEHAN TR, NANCY",
    "owner2": "",
    "current_taxes": 4946.94,
    "new_taxes_no_override": 5160.65,
    "override_total_1": 5307.08,
    "override_increase_1": 146.43
  },
  {
    "#": "75 Park St, Unit 4 (169-04-04)",
    "$": 644700,
    "address": "75 Park St, Unit 4",
    "parcel_id": "169-04-04",
    "owner1": "BELA CHANDHOK LLC",
    "owner2": "",
    "current_taxes": 6601.73,
    "new_taxes_no_override": 6886.92,
    "override_total_1": 7082.34,
    "override_increase_1": 195.41
  },
  {
    "#": "75 Park St, Unit 5 (169-04-05)",
    "$": 359600,
    "address": "75 Park St, Unit 5",
    "parcel_id": "169-04-05",
    "owner1": "VOLLOCH, VLADIMAR Z & SOFIA R",
    "owner2": "",
    "current_taxes": 3682.3,
    "new_taxes_no_override": 3841.38,
    "override_total_1": 3950.37,
    "override_increase_1": 109.0
  },
  {
    "#": "75 Park St, Unit 6 (169-04-06)",
    "$": 410100,
    "address": "75 Park St, Unit 6",
    "parcel_id": "169-04-06",
    "owner1": "HALL, HERMIA J",
    "owner2": "",
    "current_taxes": 564.49,
    "new_taxes_no_override": 588.88,
    "override_total_1": 605.58,
    "override_increase_1": 16.71
  },
  {
    "#": "75 Park St, Unit 7 (169-04-07)",
    "$": 644600,
    "address": "75 Park St, Unit 7",
    "parcel_id": "169-04-07",
    "owner1": "SHAAR, REVITAL",
    "owner2": "",
    "current_taxes": 2965.77,
    "new_taxes_no_override": 3093.89,
    "override_total_1": 3181.68,
    "override_increase_1": 87.79
  },
  {
    "#": "75 Park St, Unit 8 (169-04-08)",
    "$": 368300,
    "address": "75 Park St, Unit 8",
    "parcel_id": "169-04-08",
    "owner1": "CHANG, QING",
    "owner2": "JIANG, SHAN",
    "current_taxes": 3771.39,
    "new_taxes_no_override": 3934.31,
    "override_total_1": 4045.95,
    "override_increase_1": 111.63
  },
  {
    "#": "75 Park St, Unit 9 (169-04-09)",
    "$": 420300,
    "address": "75 Park St, Unit 9",
    "parcel_id": "169-04-09",
    "owner1": "RUSSELL, REBECCA",
    "owner2": "",
    "current_taxes": 4303.87,
    "new_taxes_no_override": 4489.8,
    "override_total_1": 4617.19,
    "override_increase_1": 127.39
  },
  {
    "#": "75 Park St, Unit B (169-04-10)",
    "$": 431300,
    "address": "75 Park St, Unit B",
    "parcel_id": "169-04-10",
    "owner1": "DOYLE, HUDSON",
    "owner2": "",
    "current_taxes": 4416.51,
    "new_taxes_no_override": 4607.3,
    "override_total_1": 4738.03,
    "override_increase_1": 130.73
  },
  {
    "#": "77 Park St, Unit 1 (169-05-01)",
    "$": 1446000,
    "address": "77 Park St, Unit 1",
    "parcel_id": "169-05-01",
    "owner1": "PAINE TRS, NATHAN DANIEL",
    "owner2": "MAHARA, SHIHO",
    "current_taxes": 11172.11,
    "new_taxes_no_override": 11654.75,
    "override_total_1": 11985.44,
    "override_increase_1": 330.69
  },
  {
    "#": "77 Park St, Unit 2 (169-05-02)",
    "$": 1516700,
    "address": "77 Park St, Unit 2",
    "parcel_id": "169-05-02",
    "owner1": "PARK ST CP LLC",
    "owner2": "",
    "current_taxes": 15531.01,
    "new_taxes_no_override": 16201.95,
    "override_total_1": 16661.67,
    "override_increase_1": 459.72
  },
  {
    "#": "77 Park St, Unit 3 (169-05-03)",
    "$": 1445400,
    "address": "77 Park St, Unit 3",
    "parcel_id": "169-05-03",
    "owner1": "NOTEBAERT, JESSICA",
    "owner2": "",
    "current_taxes": 14800.9,
    "new_taxes_no_override": 15440.3,
    "override_total_1": 15878.41,
    "override_increase_1": 438.11
  },
  {
    "#": "79 Park St (169-06-00)",
    "$": 2905400,
    "address": "79 Park St",
    "parcel_id": "169-06-00",
    "owner1": "79 PARK STREET DEVELOPMENT LLC",
    "owner2": "",
    "current_taxes": 29751.3,
    "new_taxes_no_override": 31036.56,
    "override_total_1": 31917.19,
    "override_increase_1": 880.64
  },
  {
    "#": "80 Park St, Unit 8012 & P44 (214-39-43)",
    "$": 1121300,
    "address": "80 Park St, Unit 8012 & P44",
    "parcel_id": "214-39-43",
    "owner1": "DEW, BROCK S & LAUREL P",
    "owner2": "",
    "current_taxes": 7847.18,
    "new_taxes_no_override": 8186.18,
    "override_total_1": 8418.45,
    "override_increase_1": 232.28
  },
  {
    "#": "80 Park St, Unit 8014 (214-39-44)",
    "$": 1069500,
    "address": "80 Park St, Unit 8014",
    "parcel_id": "214-39-44",
    "owner1": "SACKS TR, SELMA D",
    "owner2": "",
    "current_taxes": 10951.68,
    "new_taxes_no_override": 11424.79,
    "override_total_1": 11748.96,
    "override_increase_1": 324.17
  },
  {
    "#": "80 Park St, Unit 8021 & P66 (214-39-45)",
    "$": 984100,
    "address": "80 Park St, Unit 8021 & P66",
    "parcel_id": "214-39-45",
    "owner1": "FISHER, FRANCES A",
    "owner2": "JANKELOWITZ, ZVI H",
    "current_taxes": 6442.25,
    "new_taxes_no_override": 6720.56,
    "override_total_1": 6911.25,
    "override_increase_1": 190.69
  },
  {
    "#": "80 Park St, Unit 8022 & P14 (214-39-46)",
    "$": 997000,
    "address": "80 Park St, Unit 8022 & P14",
    "parcel_id": "214-39-46",
    "owner1": "LI, HUI",
    "owner2": "",
    "current_taxes": 6574.35,
    "new_taxes_no_override": 6858.36,
    "override_total_1": 7052.96,
    "override_increase_1": 194.6
  },
  {
    "#": "80 Park St, Unit 8023 (214-39-47)",
    "$": 973900,
    "address": "80 Park St, Unit 8023",
    "parcel_id": "214-39-47",
    "owner1": "LAM TR, KITTY HO",
    "owner2": "",
    "current_taxes": 9972.74,
    "new_taxes_no_override": 10403.56,
    "override_total_1": 10698.76,
    "override_increase_1": 295.19
  },
  {
    "#": "80 Park St, Unit 8024 & P32 (214-39-48)",
    "$": 999500,
    "address": "80 Park St, Unit 8024 & P32",
    "parcel_id": "214-39-48",
    "owner1": "SMILOWITZ, KAREN",
    "owner2": "",
    "current_taxes": 6599.95,
    "new_taxes_no_override": 6885.07,
    "override_total_1": 7080.43,
    "override_increase_1": 195.36
  },
  {
    "#": "80 Park St, Unit 8025 & P13 (214-39-49)",
    "$": 986600,
    "address": "80 Park St, Unit 8025 & P13",
    "parcel_id": "214-39-49",
    "owner1": "LUCAL, DAVID C",
    "owner2": "CHASSLER, DEBORAH",
    "current_taxes": 6467.85,
    "new_taxes_no_override": 6747.26,
    "override_total_1": 6938.71,
    "override_increase_1": 191.45
  },
  {
    "#": "80 Park St, Unit 8031 & P28 (214-39-50)",
    "$": 1003200,
    "address": "80 Park St, Unit 8031 & P28",
    "parcel_id": "214-39-50",
    "owner1": "KIM TRS, MYUNG KI & EUN YOUNG",
    "owner2": "",
    "current_taxes": 10272.77,
    "new_taxes_no_override": 10716.55,
    "override_total_1": 11020.63,
    "override_increase_1": 304.07
  },
  {
    "#": "80 Park St, Unit 8032 & P2 (214-39-51)",
    "$": 986800,
    "address": "80 Park St, Unit 8032 & P2",
    "parcel_id": "214-39-51",
    "owner1": "CHITKUSHEV, LUBOMIR T& IRENA VODENSKA",
    "owner2": "",
    "current_taxes": 6469.9,
    "new_taxes_no_override": 6749.4,
    "override_total_1": 6940.91,
    "override_increase_1": 191.51
  },
  {
    "#": "80 Park St, Unit 8033 & P56 (214-39-52)",
    "$": 989200,
    "address": "80 Park St, Unit 8033 & P56",
    "parcel_id": "214-39-52",
    "owner1": "SCHNEIDER, ANDREA ROSE",
    "owner2": "",
    "current_taxes": 6494.47,
    "new_taxes_no_override": 6775.03,
    "override_total_1": 6967.27,
    "override_increase_1": 192.24
  },
  {
    "#": "80 Park St, Unit 8034 (214-39-53)",
    "$": 999500,
    "address": "80 Park St, Unit 8034",
    "parcel_id": "214-39-53",
    "owner1": "SMELYANSKIY TRS, ANATOLY",
    "owner2": "SMELYANSKAYA, TATIANA",
    "current_taxes": 6599.95,
    "new_taxes_no_override": 6885.07,
    "override_total_1": 7080.43,
    "override_increase_1": 195.36
  },
  {
    "#": "80 Park St, Unit 8035 & P69 (214-39-54)",
    "$": 1005800,
    "address": "80 Park St, Unit 8035 & P69",
    "parcel_id": "214-39-54",
    "owner1": "RYAN, BRENT D",
    "owner2": "BELLO-GOMEZ, LORENA",
    "current_taxes": 6664.46,
    "new_taxes_no_override": 6952.36,
    "override_total_1": 7149.63,
    "override_increase_1": 197.27
  },
  {
    "#": "80 Park St, Unit 8041 (214-39-55)",
    "$": 1011000,
    "address": "80 Park St, Unit 8041",
    "parcel_id": "214-39-55",
    "owner1": "BAZHENOVA, SVETLANA",
    "owner2": "PONOMAREV, DANIL",
    "current_taxes": 6717.71,
    "new_taxes_no_override": 7007.92,
    "override_total_1": 7206.76,
    "override_increase_1": 198.84
  },
  {
    "#": "80 Park St, Unit 8042 (214-39-56)",
    "$": 1106600,
    "address": "80 Park St, Unit 8042",
    "parcel_id": "214-39-56",
    "owner1": "KRAPCHEV, VLADIMIR B & TANIA A",
    "owner2": "",
    "current_taxes": 7696.65,
    "new_taxes_no_override": 8029.15,
    "override_total_1": 8256.97,
    "override_increase_1": 227.82
  },
  {
    "#": "80 Park St, Unit 8043  (214-39-57)",
    "$": 973900,
    "address": "80 Park St, Unit 8043 ",
    "parcel_id": "214-39-57",
    "owner1": "KRAPCHEV, TANIA",
    "owner2": "",
    "current_taxes": 9972.74,
    "new_taxes_no_override": 10403.56,
    "override_total_1": 10698.76,
    "override_increase_1": 295.19
  },
  {
    "#": "80 Park St, Unit 8044 G-45 (214-39-58)",
    "$": 1150500,
    "address": "80 Park St, Unit 8044 G-45",
    "parcel_id": "214-39-58",
    "owner1": "EBER, ELIZABETH",
    "owner2": "BEARDSLEY, SCOTT",
    "current_taxes": 8146.19,
    "new_taxes_no_override": 8498.11,
    "override_total_1": 8739.23,
    "override_increase_1": 241.13
  },
  {
    "#": "80 Park St, Unit 8045 & P49 (214-39-59)",
    "$": 980300,
    "address": "80 Park St, Unit 8045 & P49",
    "parcel_id": "214-39-59",
    "owner1": "GORDON TR, HELEN GAIL",
    "owner2": "",
    "current_taxes": 10038.27,
    "new_taxes_no_override": 10471.92,
    "override_total_1": 10769.06,
    "override_increase_1": 297.13
  },
  {
    "#": "80 Park St, Unit 8051 & P37 (214-39-60)",
    "$": 1123900,
    "address": "80 Park St, Unit 8051 & P37",
    "parcel_id": "214-39-60",
    "owner1": "FITCH TR, RUTH ELLEN",
    "owner2": "",
    "current_taxes": 7873.8,
    "new_taxes_no_override": 8213.95,
    "override_total_1": 8447.01,
    "override_increase_1": 233.06
  },
  {
    "#": "80 Park St, Unit 8052 & P5 (214-39-61)",
    "$": 1083900,
    "address": "80 Park St, Unit 8052 & P5",
    "parcel_id": "214-39-61",
    "owner1": "KIKINIS, RON & ZORA",
    "owner2": "",
    "current_taxes": 7464.2,
    "new_taxes_no_override": 7786.65,
    "override_total_1": 8007.59,
    "override_increase_1": 220.94
  },
  {
    "#": "80 Park St, Unit 8053 & P40 (214-39-62)",
    "$": 1015500,
    "address": "80 Park St, Unit 8053 & P40",
    "parcel_id": "214-39-62",
    "owner1": "GORNY, IGOR",
    "owner2": "GORNAYA, IRINA",
    "current_taxes": 6763.79,
    "new_taxes_no_override": 7055.99,
    "override_total_1": 7256.19,
    "override_increase_1": 200.21
  },
  {
    "#": "80 Park St, Unit 8054 & P4 (214-39-63)",
    "$": 1119600,
    "address": "80 Park St, Unit 8054 & P4",
    "parcel_id": "214-39-63",
    "owner1": "TIEN, JAMES M & LEE W",
    "owner2": "",
    "current_taxes": 11464.7,
    "new_taxes_no_override": 11959.98,
    "override_total_1": 12299.33,
    "override_increase_1": 339.36
  },
  {
    "#": "80 Park St, Unit 8055 & G-6 (214-39-64)",
    "$": 1102000,
    "address": "80 Park St, Unit 8055 & G-6",
    "parcel_id": "214-39-64",
    "owner1": "GINZBURG, ALEXANDER & JULIA",
    "owner2": "",
    "current_taxes": 11284.48,
    "new_taxes_no_override": 11771.97,
    "override_total_1": 12105.99,
    "override_increase_1": 334.02
  },
  {
    "#": "80 Park St, Unit 8061 (214-39-65)",
    "$": 1099200,
    "address": "80 Park St, Unit 8061",
    "parcel_id": "214-39-65",
    "owner1": "SULLIVAN TR, MARYANN M",
    "owner2": "",
    "current_taxes": 7620.87,
    "new_taxes_no_override": 7950.09,
    "override_total_1": 8175.67,
    "override_increase_1": 225.58
  },
  {
    "#": "80 Park St, Unit 8062 & P62 (214-39-66)",
    "$": 1115900,
    "address": "80 Park St, Unit 8062 & P62",
    "parcel_id": "214-39-66",
    "owner1": "BOWMAN, JOHN L",
    "owner2": "",
    "current_taxes": 7791.88,
    "new_taxes_no_override": 8128.49,
    "override_total_1": 8359.13,
    "override_increase_1": 230.64
  },
  {
    "#": "80 Park St, Unit 8063 & P30 (214-39-67)",
    "$": 1330100,
    "address": "80 Park St, Unit 8063 & P30",
    "parcel_id": "214-39-67",
    "owner1": "BERK, LEAH R",
    "owner2": "LASRY, SALOMAN",
    "current_taxes": 9985.29,
    "new_taxes_no_override": 10416.65,
    "override_total_1": 10712.22,
    "override_increase_1": 295.56
  },
  {
    "#": "80 Park St, Unit 8064 (214-39-68)",
    "$": 736300,
    "address": "80 Park St, Unit 8064",
    "parcel_id": "214-39-68",
    "owner1": "KNOPF TR, TERRY ANN",
    "owner2": "",
    "current_taxes": 3904.78,
    "new_taxes_no_override": 4073.47,
    "override_total_1": 4189.05,
    "override_increase_1": 115.58
  },
  {
    "#": "80 Park St, Unit 8065 & G55 (214-39-69)",
    "$": 1111400,
    "address": "80 Park St, Unit 8065 & G55",
    "parcel_id": "214-39-69",
    "owner1": "PETUCHOWSKI TRS, SAMUEL J & SILVIA R",
    "owner2": "",
    "current_taxes": 7745.8,
    "new_taxes_no_override": 8080.42,
    "override_total_1": 8309.69,
    "override_increase_1": 229.28
  },
  {
    "#": "80 Park St, Unit 8071 & P68 (214-39-70)",
    "$": 1348700,
    "address": "80 Park St, Unit 8071 & P68",
    "parcel_id": "214-39-70",
    "owner1": "LI, JIANYI",
    "owner2": "XIONG, ZHILING",
    "current_taxes": 10175.75,
    "new_taxes_no_override": 10615.34,
    "override_total_1": 10916.54,
    "override_increase_1": 301.2
  },
  {
    "#": "80 Park St, Unit 8072 & P53 (214-39-71)",
    "$": 1342400,
    "address": "80 Park St, Unit 8072 & P53",
    "parcel_id": "214-39-71",
    "owner1": "MARKS, CAROL S & ROGER E",
    "owner2": "",
    "current_taxes": 13746.18,
    "new_taxes_no_override": 14340.01,
    "override_total_1": 14746.9,
    "override_increase_1": 406.89
  },
  {
    "#": "80 Park St, Unit 8074 & P29 (214-39-72)",
    "$": 1244900,
    "address": "80 Park St, Unit 8074 & P29",
    "parcel_id": "214-39-72",
    "owner1": "SOLOMON-AUGER TRS, MARA",
    "owner2": "SOLOMON, MELI & MAGEN",
    "current_taxes": 12747.78,
    "new_taxes_no_override": 13298.48,
    "override_total_1": 13675.82,
    "override_increase_1": 377.33
  },
  {
    "#": "80 Park St, Unit 8075 & P27 (214-39-73)",
    "$": 1343800,
    "address": "80 Park St, Unit 8075 & P27",
    "parcel_id": "214-39-73",
    "owner1": "FRANK, RICHARD G & ELIZABETH S",
    "owner2": "",
    "current_taxes": 10125.58,
    "new_taxes_no_override": 10563.01,
    "override_total_1": 10862.72,
    "override_increase_1": 299.72
  },
  {
    "#": "80 Park St, Unit 80Ph (214-39-74)",
    "$": 1931800,
    "address": "80 Park St, Unit 80Ph",
    "parcel_id": "214-39-74",
    "owner1": "PREMINGER, MICHAL & DAVID",
    "owner2": "",
    "current_taxes": 16146.7,
    "new_taxes_no_override": 16844.24,
    "override_total_1": 17322.18,
    "override_increase_1": 477.94
  },
  {
    "#": "81 Park St, Unit 1 (169-07-03)",
    "$": 1305800,
    "address": "81 Park St, Unit 1",
    "parcel_id": "169-07-03",
    "owner1": "WIZEL, SHEINE",
    "owner2": "KERSHNER, JOEL",
    "current_taxes": 9736.46,
    "new_taxes_no_override": 10157.08,
    "override_total_1": 10445.27,
    "override_increase_1": 288.2
  },
  {
    "#": "81 Park St, Unit 2 (169-07-01)",
    "$": 1314700,
    "address": "81 Park St, Unit 2",
    "parcel_id": "169-07-01",
    "owner1": "RAHBAR, CAMERON",
    "owner2": "ROBINSON, ALLISON",
    "current_taxes": 9827.59,
    "new_taxes_no_override": 10252.14,
    "override_total_1": 10543.04,
    "override_increase_1": 290.9
  },
  {
    "#": "81 Park St, Unit 3 (169-07-02)",
    "$": 1085400,
    "address": "81 Park St, Unit 3",
    "parcel_id": "169-07-02",
    "owner1": "BITMAN, DOUGLAS B",
    "owner2": "SINCLAIR, SUSAN",
    "current_taxes": 7479.56,
    "new_taxes_no_override": 7802.68,
    "override_total_1": 8024.07,
    "override_increase_1": 221.39
  },
  {
    "#": "83 Park St, Unit 1 (169-08-03)",
    "$": 1073300,
    "address": "83 Park St, Unit 1",
    "parcel_id": "169-08-03",
    "owner1": "ZHANG, CHI & YUJUAN",
    "owner2": "",
    "current_taxes": 7355.66,
    "new_taxes_no_override": 7673.42,
    "override_total_1": 7891.15,
    "override_increase_1": 217.73
  },
  {
    "#": "83 Park St, Unit 2 (169-08-01)",
    "$": 1127400,
    "address": "83 Park St, Unit 2",
    "parcel_id": "169-08-01",
    "owner1": "STERIADE, DONCA",
    "owner2": "",
    "current_taxes": 7909.64,
    "new_taxes_no_override": 8251.34,
    "override_total_1": 8485.46,
    "override_increase_1": 234.13
  },
  {
    "#": "83 Park St, Unit 3 (169-08-02)",
    "$": 1137200,
    "address": "83 Park St, Unit 3",
    "parcel_id": "169-08-02",
    "owner1": "HARTMAN, HOLLY",
    "owner2": "WILKERSON, CYNTHIA",
    "current_taxes": 8009.99,
    "new_taxes_no_override": 8356.02,
    "override_total_1": 8593.12,
    "override_increase_1": 237.1
  },
  {
    "#": "90 Park St, Unit 11 (214-38-20)",
    "$": 1911200,
    "address": "90 Park St, Unit 11",
    "parcel_id": "214-38-20",
    "owner1": "LANDE, NELSON PRENTIS & MAYDEE G",
    "owner2": "",
    "current_taxes": 15935.75,
    "new_taxes_no_override": 16624.17,
    "override_total_1": 17095.87,
    "override_increase_1": 471.7
  },
  {
    "#": "90 Park St, Unit 12 (214-38-01)",
    "$": 1125000,
    "address": "90 Park St, Unit 12",
    "parcel_id": "214-38-01",
    "owner1": "REYNOLDS, HANSON S",
    "owner2": "GRAY, SHARON M",
    "current_taxes": 7885.07,
    "new_taxes_no_override": 8225.71,
    "override_total_1": 8459.1,
    "override_increase_1": 233.4
  },
  {
    "#": "90 Park St, Unit 14 (214-38-02)",
    "$": 1165100,
    "address": "90 Park St, Unit 14",
    "parcel_id": "214-38-02",
    "owner1": "UEDA TRS, REED T & PEGGY LYNN",
    "owner2": "",
    "current_taxes": 8295.69,
    "new_taxes_no_override": 8654.06,
    "override_total_1": 8899.62,
    "override_increase_1": 245.55
  },
  {
    "#": "90 Park St, Unit 21 (214-38-03)",
    "$": 979100,
    "address": "90 Park St, Unit 21",
    "parcel_id": "214-38-03",
    "owner1": "BUTLER, EILEEN M",
    "owner2": "GALLAGHER, DANIEL B",
    "current_taxes": 6391.05,
    "new_taxes_no_override": 6667.14,
    "override_total_1": 6856.32,
    "override_increase_1": 189.18
  },
  {
    "#": "90 Park St, Unit 22 (214-38-04)",
    "$": 1253100,
    "address": "90 Park St, Unit 22",
    "parcel_id": "214-38-04",
    "owner1": "DOWD, DEBORAH A",
    "owner2": "",
    "current_taxes": 12831.74,
    "new_taxes_no_override": 13386.07,
    "override_total_1": 13765.89,
    "override_increase_1": 379.82
  },
  {
    "#": "90 Park St, Unit 23 (214-38-05)",
    "$": 1235000,
    "address": "90 Park St, Unit 23",
    "parcel_id": "214-38-05",
    "owner1": "KRONIK, GEOFFREY B",
    "owner2": "LEE, I- MIN",
    "current_taxes": 9011.47,
    "new_taxes_no_override": 9400.77,
    "override_total_1": 9667.51,
    "override_increase_1": 266.74
  },
  {
    "#": "90 Park St, Unit 24 (214-38-06)",
    "$": 1292900,
    "address": "90 Park St, Unit 24",
    "parcel_id": "214-38-06",
    "owner1": "DOBBINS, CHARLES B",
    "owner2": "DEFRANCOIS, THEODOSIA",
    "current_taxes": 9604.36,
    "new_taxes_no_override": 10019.27,
    "override_total_1": 10303.56,
    "override_increase_1": 284.29
  },
  {
    "#": "90 Park St, Unit 25 & P12 (214-38-07)",
    "$": 1283600,
    "address": "90 Park St, Unit 25 & P12",
    "parcel_id": "214-38-07",
    "owner1": "NBMF LLC",
    "owner2": "",
    "current_taxes": 13144.06,
    "new_taxes_no_override": 13711.88,
    "override_total_1": 14100.95,
    "override_increase_1": 389.06
  },
  {
    "#": "90 Park St, Unit 27 (214-38-08)",
    "$": 961000,
    "address": "90 Park St, Unit 27",
    "parcel_id": "214-38-08",
    "owner1": "MOHR, ROBERT R-ASHLEY E-ROBERT E",
    "owner2": "",
    "current_taxes": 9840.64,
    "new_taxes_no_override": 10265.76,
    "override_total_1": 10557.04,
    "override_increase_1": 291.28
  },
  {
    "#": "90 Park St, Unit 28 (214-38-09)",
    "$": 1223700,
    "address": "90 Park St, Unit 28",
    "parcel_id": "214-38-09",
    "owner1": "LEW, KENNETH K",
    "owner2": "LAWLER, NANCY L",
    "current_taxes": 8895.75,
    "new_taxes_no_override": 9280.05,
    "override_total_1": 9543.36,
    "override_increase_1": 263.31
  },
  {
    "#": "90 Park St, Unit 31 (214-38-10)",
    "$": 1058800,
    "address": "90 Park St, Unit 31",
    "parcel_id": "214-38-10",
    "owner1": "SHULMAN, ANDREA",
    "owner2": "",
    "current_taxes": 10842.11,
    "new_taxes_no_override": 11310.49,
    "override_total_1": 11631.42,
    "override_increase_1": 320.93
  },
  {
    "#": "90 Park St, Unit 32 (214-38-11)",
    "$": 1371800,
    "address": "90 Park St, Unit 32",
    "parcel_id": "214-38-11",
    "owner1": "MCARDLE, HANNAH & COLIN",
    "owner2": "",
    "current_taxes": 10412.3,
    "new_taxes_no_override": 10862.11,
    "override_total_1": 11170.32,
    "override_increase_1": 308.2
  },
  {
    "#": "90 Park St, Unit 33 (214-38-12)",
    "$": 1041600,
    "address": "90 Park St, Unit 33",
    "parcel_id": "214-38-12",
    "owner1": "QUAN, JANICE",
    "owner2": "UPCHURCH, RALPH H",
    "current_taxes": 7031.05,
    "new_taxes_no_override": 7334.79,
    "override_total_1": 7542.91,
    "override_increase_1": 208.12
  },
  {
    "#": "90 Park St, Unit 34 (214-38-13)",
    "$": 1012600,
    "address": "90 Park St, Unit 34",
    "parcel_id": "214-38-13",
    "owner1": "UEDA TRS, REED T & PEGGY LYNN",
    "owner2": "",
    "current_taxes": 10369.02,
    "new_taxes_no_override": 10816.96,
    "override_total_1": 11123.88,
    "override_increase_1": 306.92
  },
  {
    "#": "90 Park St, Unit 35 & P5 (214-38-14)",
    "$": 1031800,
    "address": "90 Park St, Unit 35 & P5",
    "parcel_id": "214-38-14",
    "owner1": "BENJAMIN, EDWARD",
    "owner2": "NOTEBAERT, SHANNON",
    "current_taxes": 6930.7,
    "new_taxes_no_override": 7230.11,
    "override_total_1": 7435.25,
    "override_increase_1": 205.15
  },
  {
    "#": "90 Park St, Unit 36 (214-38-15)",
    "$": 974500,
    "address": "90 Park St, Unit 36",
    "parcel_id": "214-38-15",
    "owner1": "UPCHURCH, RALPH",
    "owner2": "",
    "current_taxes": 6343.95,
    "new_taxes_no_override": 6618.01,
    "override_total_1": 6805.79,
    "override_increase_1": 187.78
  },
  {
    "#": "90 Park St, Unit 37 &  P11 (214-38-16)",
    "$": 1520100,
    "address": "90 Park St, Unit 37 &  P11",
    "parcel_id": "214-38-16",
    "owner1": "LUCKY MOHR INVESTMENTS LP",
    "owner2": "",
    "current_taxes": 15565.82,
    "new_taxes_no_override": 16238.26,
    "override_total_1": 16699.01,
    "override_increase_1": 460.75
  },
  {
    "#": "90 Park St, Unit 38 (214-38-17)",
    "$": 1411800,
    "address": "90 Park St, Unit 38",
    "parcel_id": "214-38-17",
    "owner1": "ALIZADEH, BABAK",
    "owner2": "",
    "current_taxes": 14456.83,
    "new_taxes_no_override": 15081.37,
    "override_total_1": 15509.29,
    "override_increase_1": 427.92
  },
  {
    "#": "90 Park St, Unit 45 (214-38-18)",
    "$": 1333100,
    "address": "90 Park St, Unit 45",
    "parcel_id": "214-38-18",
    "owner1": "BLEICHMAR, ANDREA",
    "owner2": "",
    "current_taxes": 10016.01,
    "new_taxes_no_override": 10448.7,
    "override_total_1": 10745.18,
    "override_increase_1": 296.47
  },
  {
    "#": "90 Park St, Unit 46 P22 (214-38-19)",
    "$": 1429400,
    "address": "90 Park St, Unit 46 P22",
    "parcel_id": "214-38-19",
    "owner1": "DONAHUE, JENNIFER",
    "owner2": "",
    "current_taxes": 11002.12,
    "new_taxes_no_override": 11477.41,
    "override_total_1": 11803.07,
    "override_increase_1": 325.66
  },
  {
    "#": "99 Park St (167-10-00)",
    "$": 7300000,
    "address": "99 Park St",
    "parcel_id": "167-10-00",
    "owner1": "VANDERKLISH TRS, ROBERT W-JULIE E-DAVID",
    "owner2": "C/O CARE ONE LLC - LILIYA VAYSMAN",
    "current_taxes": 125268.0,
    "new_taxes_no_override": 130679.58,
    "override_total_1": 134387.51,
    "override_increase_1": 3707.93
  },
  {
    "#": "100 Park St (166-01-00)",
    "$": 2403300,
    "address": "100 Park St",
    "parcel_id": "166-01-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O ST MARKS SQUARE",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "114 Park St, Unit 1 (165-01-07)",
    "$": 587300,
    "address": "114 Park St, Unit 1",
    "parcel_id": "165-01-07",
    "owner1": "LITTERST, MARY",
    "owner2": "",
    "current_taxes": 2379.02,
    "new_taxes_no_override": 2481.79,
    "override_total_1": 2552.21,
    "override_increase_1": 70.42
  },
  {
    "#": "114 Park St, Unit 2 (165-01-08)",
    "$": 587300,
    "address": "114 Park St, Unit 2",
    "parcel_id": "165-01-08",
    "owner1": "NEEDLEMAN, TRS, DEBBIE",
    "owner2": "",
    "current_taxes": 6013.95,
    "new_taxes_no_override": 6273.75,
    "override_total_1": 6451.77,
    "override_increase_1": 178.01
  },
  {
    "#": "114 Park St, Unit 3 (165-01-09)",
    "$": 587300,
    "address": "114 Park St, Unit 3",
    "parcel_id": "165-01-09",
    "owner1": "JIA, DI",
    "owner2": "",
    "current_taxes": 6013.95,
    "new_taxes_no_override": 6273.75,
    "override_total_1": 6451.77,
    "override_increase_1": 178.01
  },
  {
    "#": "116 Park St, Unit 1 (165-01-10)",
    "$": 629600,
    "address": "116 Park St, Unit 1",
    "parcel_id": "165-01-10",
    "owner1": "KIM, JONGSEONG",
    "owner2": "",
    "current_taxes": 6447.1,
    "new_taxes_no_override": 6725.61,
    "override_total_1": 6916.45,
    "override_increase_1": 190.83
  },
  {
    "#": "116 Park St, Unit 2 (165-01-11)",
    "$": 629600,
    "address": "116 Park St, Unit 2",
    "parcel_id": "165-01-11",
    "owner1": "CHANG, QING",
    "owner2": "JIANG, SHIN",
    "current_taxes": 6447.1,
    "new_taxes_no_override": 6725.61,
    "override_total_1": 6916.45,
    "override_increase_1": 190.83
  },
  {
    "#": "116 Park St, Unit 3 (165-01-12)",
    "$": 666900,
    "address": "116 Park St, Unit 3",
    "parcel_id": "165-01-12",
    "owner1": "RICHMAN, ELAINE",
    "owner2": "",
    "current_taxes": 3194.12,
    "new_taxes_no_override": 3332.11,
    "override_total_1": 3426.65,
    "override_increase_1": 94.55
  },
  {
    "#": "116 Park St, Unit 4 (165-01-13)",
    "$": 641400,
    "address": "116 Park St, Unit 4",
    "parcel_id": "165-01-13",
    "owner1": "WURTELE, JONATHAN S",
    "owner2": "",
    "current_taxes": 6567.94,
    "new_taxes_no_override": 6851.68,
    "override_total_1": 7046.09,
    "override_increase_1": 194.41
  },
  {
    "#": "116 Park St, Unit 5 (165-01-14)",
    "$": 667000,
    "address": "116 Park St, Unit 5",
    "parcel_id": "165-01-14",
    "owner1": "JIN, JIANGHUA",
    "owner2": "",
    "current_taxes": 6830.08,
    "new_taxes_no_override": 7125.14,
    "override_total_1": 7327.31,
    "override_increase_1": 202.17
  },
  {
    "#": "116 Park St, Unit 6 (165-01-15)",
    "$": 656800,
    "address": "116 Park St, Unit 6",
    "parcel_id": "165-01-15",
    "owner1": "SCIABARRASI, MYA",
    "owner2": "",
    "current_taxes": 3090.7,
    "new_taxes_no_override": 3224.22,
    "override_total_1": 3315.7,
    "override_increase_1": 91.48
  },
  {
    "#": "119 Park St, Unit 1 (164-12-11)",
    "$": 480200,
    "address": "119 Park St, Unit 1",
    "parcel_id": "164-12-11",
    "owner1": "SCOTT, MARK ANDREW",
    "owner2": "SHKLYAR, IRINA",
    "current_taxes": 4917.25,
    "new_taxes_no_override": 5129.68,
    "override_total_1": 5275.23,
    "override_increase_1": 145.55
  },
  {
    "#": "119 Park St, Unit 10 & P5 (164-12-09)",
    "$": 982900,
    "address": "119 Park St, Unit 10 & P5",
    "parcel_id": "164-12-09",
    "owner1": "AROLOVICH, ALAN",
    "owner2": "GANTVARG, JELENA A",
    "current_taxes": 6429.96,
    "new_taxes_no_override": 6707.73,
    "override_total_1": 6898.06,
    "override_increase_1": 190.33
  },
  {
    "#": "119 Park St, Unit 2 (164-12-01)",
    "$": 451800,
    "address": "119 Park St, Unit 2",
    "parcel_id": "164-12-01",
    "owner1": "CLEOPATRA PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 4626.43,
    "new_taxes_no_override": 4826.29,
    "override_total_1": 4963.23,
    "override_increase_1": 136.94
  },
  {
    "#": "119 Park St, Unit 3 (164-12-02)",
    "$": 442000,
    "address": "119 Park St, Unit 3",
    "parcel_id": "164-12-02",
    "owner1": "LIN, GEORGE & MENGSHAN",
    "owner2": "",
    "current_taxes": 891.15,
    "new_taxes_no_override": 929.65,
    "override_total_1": 956.03,
    "override_increase_1": 26.38
  },
  {
    "#": "119 Park St, Unit 4 & P-1 (164-12-03)",
    "$": 585900,
    "address": "119 Park St, Unit 4 & P-1",
    "parcel_id": "164-12-03",
    "owner1": "BABCOCK, JANICE L",
    "owner2": "",
    "current_taxes": 2364.68,
    "new_taxes_no_override": 2466.83,
    "override_total_1": 2536.83,
    "override_increase_1": 69.99
  },
  {
    "#": "119 Park St, Unit 5 (164-12-04)",
    "$": 380000,
    "address": "119 Park St, Unit 5",
    "parcel_id": "164-12-04",
    "owner1": "HAMILTON TRS, CHERI DAWSON",
    "owner2": "KALBFUS, ANTHONY G C",
    "current_taxes": 3891.2,
    "new_taxes_no_override": 4059.3,
    "override_total_1": 4174.48,
    "override_increase_1": 115.18
  },
  {
    "#": "119 Park St, Unit 6 & P3 (164-12-05)",
    "$": 506300,
    "address": "119 Park St, Unit 6 & P3",
    "parcel_id": "164-12-05",
    "owner1": "CLEOPATRA PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 5184.51,
    "new_taxes_no_override": 5408.48,
    "override_total_1": 5561.94,
    "override_increase_1": 153.46
  },
  {
    "#": "119 Park St, Unit 7 (164-12-06)",
    "$": 560300,
    "address": "119 Park St, Unit 7",
    "parcel_id": "164-12-06",
    "owner1": "VLISIDIS, ATHANASIOS",
    "owner2": "",
    "current_taxes": 5737.47,
    "new_taxes_no_override": 5985.33,
    "override_total_1": 6155.16,
    "override_increase_1": 169.83
  },
  {
    "#": "119 Park St, Unit 8 & P4 (164-12-07)",
    "$": 445600,
    "address": "119 Park St, Unit 8 & P4",
    "parcel_id": "164-12-07",
    "owner1": "XING, JIANGANG",
    "owner2": "ZHONG, ZHAOHUI",
    "current_taxes": 4562.94,
    "new_taxes_no_override": 4760.06,
    "override_total_1": 4895.12,
    "override_increase_1": 135.06
  },
  {
    "#": "119 Park St, Unit 9 & P2 (164-12-08)",
    "$": 494700,
    "address": "119 Park St, Unit 9 & P2",
    "parcel_id": "164-12-08",
    "owner1": "TOW, DARREN CURTIS",
    "owner2": "",
    "current_taxes": 5065.73,
    "new_taxes_no_override": 5284.57,
    "override_total_1": 5434.52,
    "override_increase_1": 149.95
  },
  {
    "#": "122 Park St (165-24-00)",
    "$": 3762100,
    "address": "122 Park St",
    "parcel_id": "165-24-00",
    "owner1": "SANIEOFF ET AL TRS, SIEON & SYROOS",
    "owner2": "",
    "current_taxes": 38523.9,
    "new_taxes_no_override": 40188.13,
    "override_total_1": 41328.44,
    "override_increase_1": 1140.31
  },
  {
    "#": "124 Park St, Unit 1 (165-23-03)",
    "$": 938500,
    "address": "124 Park St, Unit 1",
    "parcel_id": "165-23-03",
    "owner1": "LEW TR, CHARLES",
    "owner2": "",
    "current_taxes": 5975.31,
    "new_taxes_no_override": 6233.44,
    "override_total_1": 6410.31,
    "override_increase_1": 176.87
  },
  {
    "#": "124 Park St, Unit 2 (165-23-01)",
    "$": 993800,
    "address": "124 Park St, Unit 2",
    "parcel_id": "165-23-01",
    "owner1": "MACVEAGH TRS, CHARLTON III",
    "owner2": "LEITMAN, JULIE F",
    "current_taxes": 6541.58,
    "new_taxes_no_override": 6824.18,
    "override_total_1": 7017.81,
    "override_increase_1": 193.63
  },
  {
    "#": "124 Park St, Unit 3 (165-23-02)",
    "$": 1010200,
    "address": "124 Park St, Unit 3",
    "parcel_id": "165-23-02",
    "owner1": "GRUEBEL, ERIC MATTHEW",
    "owner2": "SIEBER, JENNIFER RACHAEL",
    "current_taxes": 10344.45,
    "new_taxes_no_override": 10791.33,
    "override_total_1": 11097.53,
    "override_increase_1": 306.2
  },
  {
    "#": "125 Park St, Unit 1 (164-13-03)",
    "$": 935600,
    "address": "125 Park St, Unit 1",
    "parcel_id": "164-13-03",
    "owner1": "DAVIS, JONATHAN &  LINDA",
    "owner2": "",
    "current_taxes": 5945.61,
    "new_taxes_no_override": 6202.46,
    "override_total_1": 6378.45,
    "override_increase_1": 175.99
  },
  {
    "#": "125 Park St, Unit 2 # P1 (164-13-04)",
    "$": 959400,
    "address": "125 Park St, Unit 2 # P1",
    "parcel_id": "164-13-04",
    "owner1": "KELLY TR, KRISTINE L",
    "owner2": "",
    "current_taxes": 9824.26,
    "new_taxes_no_override": 10248.67,
    "override_total_1": 10539.47,
    "override_increase_1": 290.8
  },
  {
    "#": "125 Park St, Unit 3 & P-B4 (164-13-05)",
    "$": 1216500,
    "address": "125 Park St, Unit 3 & P-B4",
    "parcel_id": "164-13-05",
    "owner1": "GOLDING, BRAGE WILLIAM & KAREN B",
    "owner2": "",
    "current_taxes": 8822.03,
    "new_taxes_no_override": 9203.14,
    "override_total_1": 9464.27,
    "override_increase_1": 261.13
  },
  {
    "#": "125 Park St, Unit 4 & P3 (164-13-06)",
    "$": 1150500,
    "address": "125 Park St, Unit 4 & P3",
    "parcel_id": "164-13-06",
    "owner1": "HUNG, YU-WEN",
    "owner2": "WU, CHUN-TING",
    "current_taxes": 8146.19,
    "new_taxes_no_override": 8498.11,
    "override_total_1": 8739.23,
    "override_increase_1": 241.13
  },
  {
    "#": "125 Park St, Unit 5 & P5 (164-13-07)",
    "$": 1216500,
    "address": "125 Park St, Unit 5 & P5",
    "parcel_id": "164-13-07",
    "owner1": "KURTEVA, SVETLA K",
    "owner2": "YORDANOV, YORDAN S",
    "current_taxes": 8822.03,
    "new_taxes_no_override": 9203.14,
    "override_total_1": 9464.27,
    "override_increase_1": 261.13
  },
  {
    "#": "125 Park St, Unit 6 & P2 (164-13-08)",
    "$": 1128600,
    "address": "125 Park St, Unit 6 & P2",
    "parcel_id": "164-13-08",
    "owner1": "EKINCI, KAMIL L",
    "owner2": "LUND, THERESA A",
    "current_taxes": 7921.93,
    "new_taxes_no_override": 8264.16,
    "override_total_1": 8498.65,
    "override_increase_1": 234.49
  },
  {
    "#": "125 Park St, Unit G-1 (164-13-09)",
    "$": 367700,
    "address": "125 Park St, Unit G-1",
    "parcel_id": "164-13-09",
    "owner1": "HEYM LLC",
    "owner2": "",
    "current_taxes": 3765.25,
    "new_taxes_no_override": 3927.91,
    "override_total_1": 4039.36,
    "override_increase_1": 111.45
  },
  {
    "#": "125 Park St, Unit G-2 (164-13-01)",
    "$": 290100,
    "address": "125 Park St, Unit G-2",
    "parcel_id": "164-13-01",
    "owner1": "GRANDFIELD, DOROTHY",
    "owner2": "",
    "current_taxes": 297.06,
    "new_taxes_no_override": 309.89,
    "override_total_1": 318.69,
    "override_increase_1": 8.79
  },
  {
    "#": "125 Park St, Unit G-3 (164-13-02)",
    "$": 577200,
    "address": "125 Park St, Unit G-3",
    "parcel_id": "164-13-02",
    "owner1": "SURESH, SHRUTHI",
    "owner2": "",
    "current_taxes": 5910.53,
    "new_taxes_no_override": 6165.86,
    "override_total_1": 6340.82,
    "override_increase_1": 174.95
  },
  {
    "#": "126 Park St, Unit 1 (165-22-02)",
    "$": 566300,
    "address": "126 Park St, Unit 1",
    "parcel_id": "165-22-02",
    "owner1": "MCKINNEY, SARA A",
    "owner2": "",
    "current_taxes": 2163.98,
    "new_taxes_no_override": 2257.46,
    "override_total_1": 2321.52,
    "override_increase_1": 64.05
  },
  {
    "#": "126 Park St, Unit 2 (165-22-03)",
    "$": 457900,
    "address": "126 Park St, Unit 2",
    "parcel_id": "165-22-03",
    "owner1": "SISTLER, ANNE C",
    "owner2": "",
    "current_taxes": 1053.96,
    "new_taxes_no_override": 1099.49,
    "override_total_1": 1130.69,
    "override_increase_1": 31.2
  },
  {
    "#": "126 Park St, Unit 3 (165-22-04)",
    "$": 643600,
    "address": "126 Park St, Unit 3",
    "parcel_id": "165-22-04",
    "owner1": "181 BALDWIN AVENUE LLC",
    "owner2": "",
    "current_taxes": 6590.46,
    "new_taxes_no_override": 6875.17,
    "override_total_1": 7070.25,
    "override_increase_1": 195.08
  },
  {
    "#": "126 Park St, Unit 4 (165-22-05)",
    "$": 459400,
    "address": "126 Park St, Unit 4",
    "parcel_id": "165-22-05",
    "owner1": "URBAS, PAMELA",
    "owner2": "",
    "current_taxes": 4704.26,
    "new_taxes_no_override": 4907.48,
    "override_total_1": 5046.73,
    "override_increase_1": 139.25
  },
  {
    "#": "126 Park St, Unit 5 (165-22-06)",
    "$": 939400,
    "address": "126 Park St, Unit 5",
    "parcel_id": "165-22-06",
    "owner1": "SHYAMJI, VIMAL & ERIN",
    "owner2": "",
    "current_taxes": 9619.46,
    "new_taxes_no_override": 10035.02,
    "override_total_1": 10319.76,
    "override_increase_1": 284.74
  },
  {
    "#": " Park St (165-22-01)",
    "$": 850600,
    "address": " Park St",
    "parcel_id": "165-22-01",
    "owner1": "SANIEOFF ET AL TRS, SIEON & SYROOS",
    "owner2": "",
    "current_taxes": 8710.14,
    "new_taxes_no_override": 9086.42,
    "override_total_1": 9344.24,
    "override_increase_1": 257.82
  },
  {
    "#": "2 Park Vale, Unit B-1 (171-58-12)",
    "$": 475800,
    "address": "2 Park Vale, Unit B-1",
    "parcel_id": "171-58-12",
    "owner1": "CATER, DAWN M",
    "owner2": "",
    "current_taxes": 4872.19,
    "new_taxes_no_override": 5082.67,
    "override_total_1": 5226.89,
    "override_increase_1": 144.22
  },
  {
    "#": "2 Park Vale, Unit B-2 (171-58-13)",
    "$": 454000,
    "address": "2 Park Vale, Unit B-2",
    "parcel_id": "171-58-13",
    "owner1": "MURPHY, CINDY M",
    "owner2": "",
    "current_taxes": 1014.03,
    "new_taxes_no_override": 1057.84,
    "override_total_1": 1087.85,
    "override_increase_1": 30.02
  },
  {
    "#": "5 Park Vale (171-04-00)",
    "$": 5927900,
    "address": "5 Park Vale",
    "parcel_id": "171-04-00",
    "owner1": "ABRAMS, ET AL TRS, ESTELLE D",
    "owner2": "C/O ALLSTATE REALTY",
    "current_taxes": 60701.7,
    "new_taxes_no_override": 63324.01,
    "override_total_1": 65120.78,
    "override_increase_1": 1796.77
  },
  {
    "#": "9 Park Vale, Unit 1 (171-03-01)",
    "$": 877100,
    "address": "9 Park Vale, Unit 1",
    "parcel_id": "171-03-01",
    "owner1": "HE, HUI",
    "owner2": "ZHANG, MIN",
    "current_taxes": 5346.57,
    "new_taxes_no_override": 5577.54,
    "override_total_1": 5735.8,
    "override_increase_1": 158.26
  },
  {
    "#": "9 Park Vale, Unit 2 & P1 (171-03-02)",
    "$": 954500,
    "address": "9 Park Vale, Unit 2 & P1",
    "parcel_id": "171-03-02",
    "owner1": "MALECKY, LAURA",
    "owner2": "FERRERA, MICHAEL",
    "current_taxes": 6139.15,
    "new_taxes_no_override": 6404.36,
    "override_total_1": 6586.08,
    "override_increase_1": 181.72
  },
  {
    "#": "9 Park Vale, Unit 3 & P8 (171-03-03)",
    "$": 901800,
    "address": "9 Park Vale, Unit 3 & P8",
    "parcel_id": "171-03-03",
    "owner1": "GAZIT TRS, RONIE ESTHER & YONATAN AARON",
    "owner2": "",
    "current_taxes": 9234.43,
    "new_taxes_no_override": 9633.36,
    "override_total_1": 9906.7,
    "override_increase_1": 273.34
  },
  {
    "#": "9 Park Vale, Unit 4 (171-03-04)",
    "$": 811700,
    "address": "9 Park Vale, Unit 4",
    "parcel_id": "171-03-04",
    "owner1": "SUGIMOTO, AI & HIROSHI",
    "owner2": "",
    "current_taxes": 8311.81,
    "new_taxes_no_override": 8670.88,
    "override_total_1": 8916.91,
    "override_increase_1": 246.03
  },
  {
    "#": "9 Park Vale, Unit 5 & P9 (171-03-05)",
    "$": 1027100,
    "address": "9 Park Vale, Unit 5 & P9",
    "parcel_id": "171-03-05",
    "owner1": "HECHT, MICHAEL & JENNIFER",
    "owner2": "",
    "current_taxes": 6882.57,
    "new_taxes_no_override": 7179.9,
    "override_total_1": 7383.62,
    "override_increase_1": 203.72
  },
  {
    "#": "9 Park Vale, Unit 6 & P7 (171-03-06)",
    "$": 834400,
    "address": "9 Park Vale, Unit 6 & P7",
    "parcel_id": "171-03-06",
    "owner1": "CUI, JIE",
    "owner2": "",
    "current_taxes": 8544.26,
    "new_taxes_no_override": 8913.37,
    "override_total_1": 9166.28,
    "override_increase_1": 252.91
  },
  {
    "#": "9 Park Vale, Unit 7 & P2 (171-03-07)",
    "$": 896200,
    "address": "9 Park Vale, Unit 7 & P2",
    "parcel_id": "171-03-07",
    "owner1": "PARK VALE LLC",
    "owner2": "",
    "current_taxes": 9177.09,
    "new_taxes_no_override": 9573.54,
    "override_total_1": 9845.18,
    "override_increase_1": 271.64
  },
  {
    "#": "9 Park Vale, Unit 8 (171-03-08)",
    "$": 801100,
    "address": "9 Park Vale, Unit 8",
    "parcel_id": "171-03-08",
    "owner1": "ZHANG, SUSAN XU & YANG XU",
    "owner2": "",
    "current_taxes": 8203.26,
    "new_taxes_no_override": 8557.64,
    "override_total_1": 8800.46,
    "override_increase_1": 242.82
  },
  {
    "#": "9 Park Vale, Unit 9 (171-03-09)",
    "$": 652500,
    "address": "9 Park Vale, Unit 9",
    "parcel_id": "171-03-09",
    "owner1": "WHITFIELD, ADAM W",
    "owner2": "",
    "current_taxes": 3046.67,
    "new_taxes_no_override": 3178.29,
    "override_total_1": 3268.47,
    "override_increase_1": 90.18
  },
  {
    "#": "15 Park Vale, Unit 1 & P1 (171-02-02)",
    "$": 839100,
    "address": "15 Park Vale, Unit 1 & P1",
    "parcel_id": "171-02-02",
    "owner1": "ROSE, SUSAN",
    "owner2": "",
    "current_taxes": 4957.45,
    "new_taxes_no_override": 5171.61,
    "override_total_1": 5318.35,
    "override_increase_1": 146.74
  },
  {
    "#": "15 Park Vale, Unit 2 & P-2 (171-02-03)",
    "$": 1017600,
    "address": "15 Park Vale, Unit 2 & P-2",
    "parcel_id": "171-02-03",
    "owner1": "BAGDONAS, EDWARD P & NATALIE R",
    "owner2": "",
    "current_taxes": 10420.22,
    "new_taxes_no_override": 10870.37,
    "override_total_1": 11178.81,
    "override_increase_1": 308.44
  },
  {
    "#": "15 Park Vale, Unit 3 & P3 (171-02-04)",
    "$": 912600,
    "address": "15 Park Vale, Unit 3 & P3",
    "parcel_id": "171-02-04",
    "owner1": "LIPMAN, EMILY & CHRISTINE",
    "owner2": "",
    "current_taxes": 5710.09,
    "new_taxes_no_override": 5956.77,
    "override_total_1": 6125.78,
    "override_increase_1": 169.02
  },
  {
    "#": "15 Park Vale, Unit 4 & Prk 4 (171-02-05)",
    "$": 906600,
    "address": "15 Park Vale, Unit 4 & Prk 4",
    "parcel_id": "171-02-05",
    "owner1": "GELLER, DANIEL & ELLEN L",
    "owner2": "",
    "current_taxes": 5648.65,
    "new_taxes_no_override": 5892.67,
    "override_total_1": 6059.87,
    "override_increase_1": 167.2
  },
  {
    "#": "15 Park Vale, Unit A & P-A (171-02-01)",
    "$": 670100,
    "address": "15 Park Vale, Unit A & P-A",
    "parcel_id": "171-02-01",
    "owner1": "LEE, CHAO-YING",
    "owner2": "",
    "current_taxes": 6861.82,
    "new_taxes_no_override": 7158.25,
    "override_total_1": 7361.36,
    "override_increase_1": 203.11
  },
  {
    "#": "15 Park Vale, Unit P 5 (171-02-06)",
    "$": 48300,
    "address": "15 Park Vale, Unit P 5",
    "parcel_id": "171-02-06",
    "owner1": "BAGDONAS, EDWARD P & NATALIE R",
    "owner2": "",
    "current_taxes": 494.59,
    "new_taxes_no_override": 515.96,
    "override_total_1": 530.6,
    "override_increase_1": 14.64
  },
  {
    "#": "17 Park Vale, Unit 1 (171-01-01)",
    "$": 929800,
    "address": "17 Park Vale, Unit 1",
    "parcel_id": "171-01-01",
    "owner1": "PATEL, PRIYAL",
    "owner2": "PANIGRAHI, BISHNU",
    "current_taxes": 5886.22,
    "new_taxes_no_override": 6140.5,
    "override_total_1": 6314.74,
    "override_increase_1": 174.23
  },
  {
    "#": "17 Park Vale, Unit 2  & P25 (171-01-02)",
    "$": 801900,
    "address": "17 Park Vale, Unit 2  & P25",
    "parcel_id": "171-01-02",
    "owner1": "RUTLEY, CATHERINE",
    "owner2": "SULKALA, ANDREW",
    "current_taxes": 4576.52,
    "new_taxes_no_override": 4774.23,
    "override_total_1": 4909.69,
    "override_increase_1": 135.46
  },
  {
    "#": "17 Park Vale, Unit 3 (171-01-03)",
    "$": 884900,
    "address": "17 Park Vale, Unit 3",
    "parcel_id": "171-01-03",
    "owner1": "FADEEVA, ELENA",
    "owner2": "",
    "current_taxes": 5426.44,
    "new_taxes_no_override": 5660.86,
    "override_total_1": 5821.48,
    "override_increase_1": 160.62
  },
  {
    "#": "17 Park Vale, Unit 4 (171-01-04)",
    "$": 758700,
    "address": "17 Park Vale, Unit 4",
    "parcel_id": "171-01-04",
    "owner1": "MIZRAHI, NATALYA",
    "owner2": "KORIN, NETANEL",
    "current_taxes": 4134.15,
    "new_taxes_no_override": 4312.75,
    "override_total_1": 4435.12,
    "override_increase_1": 122.37
  },
  {
    "#": "17 Park Vale, Unit 5 (171-01-05)",
    "$": 876600,
    "address": "17 Park Vale, Unit 5",
    "parcel_id": "171-01-05",
    "owner1": "HARJANTO, DEWI",
    "owner2": "MILLS, ANDREW",
    "current_taxes": 5341.45,
    "new_taxes_no_override": 5572.2,
    "override_total_1": 5730.31,
    "override_increase_1": 158.11
  },
  {
    "#": "17 Park Vale, Unit 6 & P24 (171-01-06)",
    "$": 796500,
    "address": "17 Park Vale, Unit 6 & P24",
    "parcel_id": "171-01-06",
    "owner1": "KEUNG, LOK HANG KRISTINA",
    "owner2": "",
    "current_taxes": 8156.16,
    "new_taxes_no_override": 8508.51,
    "override_total_1": 8749.93,
    "override_increase_1": 241.42
  },
  {
    "#": "17 Park Vale, Unit 7 (171-01-07)",
    "$": 591400,
    "address": "17 Park Vale, Unit 7",
    "parcel_id": "171-01-07",
    "owner1": "BROWN, ESTHER Y",
    "owner2": "",
    "current_taxes": 2421.0,
    "new_taxes_no_override": 2525.59,
    "override_total_1": 2597.25,
    "override_increase_1": 71.66
  },
  {
    "#": "17 Park Vale, Unit P-1 (171-01-08)",
    "$": 53900,
    "address": "17 Park Vale, Unit P-1",
    "parcel_id": "171-01-08",
    "owner1": "SCHEER, EDWARD H JR & ANTONIA R",
    "owner2": "",
    "current_taxes": 551.94,
    "new_taxes_no_override": 575.78,
    "override_total_1": 592.12,
    "override_increase_1": 16.34
  },
  {
    "#": "17 Park Vale, Unit P-10 (171-01-17)",
    "$": 48300,
    "address": "17 Park Vale, Unit P-10",
    "parcel_id": "171-01-17",
    "owner1": "PATEL, PRIYAL",
    "owner2": "PANIGRAHI, BISHNU",
    "current_taxes": 494.59,
    "new_taxes_no_override": 515.96,
    "override_total_1": 530.6,
    "override_increase_1": 14.64
  },
  {
    "#": "17 Park Vale, Unit P-11 (171-01-18)",
    "$": 48300,
    "address": "17 Park Vale, Unit P-11",
    "parcel_id": "171-01-18",
    "owner1": "WIZEL, SHEINE",
    "owner2": "KERSHNER, JOEL",
    "current_taxes": 494.59,
    "new_taxes_no_override": 515.96,
    "override_total_1": 530.6,
    "override_increase_1": 14.64
  },
  {
    "#": "17 Park Vale, Unit P-12 (171-01-19)",
    "$": 48300,
    "address": "17 Park Vale, Unit P-12",
    "parcel_id": "171-01-19",
    "owner1": "WOYTASH, ANNASTACIA",
    "owner2": "",
    "current_taxes": 494.59,
    "new_taxes_no_override": 515.96,
    "override_total_1": 530.6,
    "override_increase_1": 14.64
  },
  {
    "#": "17 Park Vale, Unit P-13 (171-01-20)",
    "$": 48300,
    "address": "17 Park Vale, Unit P-13",
    "parcel_id": "171-01-20",
    "owner1": "BAILLIEUL, CHARLOTTE",
    "owner2": "",
    "current_taxes": 494.59,
    "new_taxes_no_override": 515.96,
    "override_total_1": 530.6,
    "override_increase_1": 14.64
  },
  {
    "#": "17 Park Vale, Unit P-14 (171-01-21)",
    "$": 48300,
    "address": "17 Park Vale, Unit P-14",
    "parcel_id": "171-01-21",
    "owner1": "PENTA TR, ANITA",
    "owner2": "",
    "current_taxes": 494.59,
    "new_taxes_no_override": 515.96,
    "override_total_1": 530.6,
    "override_increase_1": 14.64
  },
  {
    "#": "17 Park Vale, Unit P-15 (171-01-22)",
    "$": 48300,
    "address": "17 Park Vale, Unit P-15",
    "parcel_id": "171-01-22",
    "owner1": "NGUYEN, HUY",
    "owner2": "ENE, ALINA R",
    "current_taxes": 494.59,
    "new_taxes_no_override": 515.96,
    "override_total_1": 530.6,
    "override_increase_1": 14.64
  },
  {
    "#": "17 Park Vale, Unit P-16 (171-01-23)",
    "$": 48300,
    "address": "17 Park Vale, Unit P-16",
    "parcel_id": "171-01-23",
    "owner1": "BURSTYN, GILDA",
    "owner2": "",
    "current_taxes": 494.59,
    "new_taxes_no_override": 515.96,
    "override_total_1": 530.6,
    "override_increase_1": 14.64
  },
  {
    "#": "17 Park Vale, Unit P-17 (171-01-24)",
    "$": 48300,
    "address": "17 Park Vale, Unit P-17",
    "parcel_id": "171-01-24",
    "owner1": "SUGIMOTO, AI & HIROSHI",
    "owner2": "",
    "current_taxes": 494.59,
    "new_taxes_no_override": 515.96,
    "override_total_1": 530.6,
    "override_increase_1": 14.64
  },
  {
    "#": "17 Park Vale, Unit P-18 (171-01-25)",
    "$": 48300,
    "address": "17 Park Vale, Unit P-18",
    "parcel_id": "171-01-25",
    "owner1": "MENE XAVIER, CLAUDIA REGINA",
    "owner2": "",
    "current_taxes": 494.59,
    "new_taxes_no_override": 515.96,
    "override_total_1": 530.6,
    "override_increase_1": 14.64
  },
  {
    "#": "17 Park Vale, Unit P-19 (171-01-26)",
    "$": 48300,
    "address": "17 Park Vale, Unit P-19",
    "parcel_id": "171-01-26",
    "owner1": "PASSY, ALEXANDRA R & LAWRENCE S",
    "owner2": "",
    "current_taxes": 494.59,
    "new_taxes_no_override": 515.96,
    "override_total_1": 530.6,
    "override_increase_1": 14.64
  },
  {
    "#": "17 Park Vale, Unit P-2 (171-01-09)",
    "$": 48300,
    "address": "17 Park Vale, Unit P-2",
    "parcel_id": "171-01-09",
    "owner1": "OFFICER TR, ARLENN J",
    "owner2": "",
    "current_taxes": 494.59,
    "new_taxes_no_override": 515.96,
    "override_total_1": 530.6,
    "override_increase_1": 14.64
  },
  {
    "#": "17 Park Vale, Unit P-20 (171-01-27)",
    "$": 48300,
    "address": "17 Park Vale, Unit P-20",
    "parcel_id": "171-01-27",
    "owner1": "HE, HUI",
    "owner2": "ZHANG, MIN",
    "current_taxes": 494.59,
    "new_taxes_no_override": 515.96,
    "override_total_1": 530.6,
    "override_increase_1": 14.64
  },
  {
    "#": "17 Park Vale, Unit P-21 (171-01-28)",
    "$": 48300,
    "address": "17 Park Vale, Unit P-21",
    "parcel_id": "171-01-28",
    "owner1": "FOSTER, JEREMIAH",
    "owner2": "",
    "current_taxes": 494.59,
    "new_taxes_no_override": 515.96,
    "override_total_1": 530.6,
    "override_increase_1": 14.64
  },
  {
    "#": "17 Park Vale, Unit P-22 (171-01-29)",
    "$": 48300,
    "address": "17 Park Vale, Unit P-22",
    "parcel_id": "171-01-29",
    "owner1": "ZHANG, QI",
    "owner2": "FU, YUN",
    "current_taxes": 494.59,
    "new_taxes_no_override": 515.96,
    "override_total_1": 530.6,
    "override_increase_1": 14.64
  },
  {
    "#": "17 Park Vale, Unit P-23 (171-01-30)",
    "$": 48300,
    "address": "17 Park Vale, Unit P-23",
    "parcel_id": "171-01-30",
    "owner1": "ZHANG, SUSAN XU & YANG XU",
    "owner2": "",
    "current_taxes": 494.59,
    "new_taxes_no_override": 515.96,
    "override_total_1": 530.6,
    "override_increase_1": 14.64
  },
  {
    "#": "17 Park Vale, Unit P-3 (171-01-10)",
    "$": 48300,
    "address": "17 Park Vale, Unit P-3",
    "parcel_id": "171-01-10",
    "owner1": "CHODOSOVSKY, OLEG Y & ELENA S",
    "owner2": "",
    "current_taxes": 494.59,
    "new_taxes_no_override": 515.96,
    "override_total_1": 530.6,
    "override_increase_1": 14.64
  },
  {
    "#": "17 Park Vale, Unit P-4 (171-01-11)",
    "$": 48300,
    "address": "17 Park Vale, Unit P-4",
    "parcel_id": "171-01-11",
    "owner1": "NAVARRETE, JERRY O & PATRICIA J",
    "owner2": "",
    "current_taxes": 494.59,
    "new_taxes_no_override": 515.96,
    "override_total_1": 530.6,
    "override_increase_1": 14.64
  },
  {
    "#": "17 Park Vale, Unit P-5 (171-01-12)",
    "$": 48300,
    "address": "17 Park Vale, Unit P-5",
    "parcel_id": "171-01-12",
    "owner1": "NAVARRETTE, JERRY O & PATRICIA J",
    "owner2": "",
    "current_taxes": 494.59,
    "new_taxes_no_override": 515.96,
    "override_total_1": 530.6,
    "override_increase_1": 14.64
  },
  {
    "#": "17 Park Vale, Unit P-6 (171-01-13)",
    "$": 48300,
    "address": "17 Park Vale, Unit P-6",
    "parcel_id": "171-01-13",
    "owner1": "ZUBIZARRETA, JOSE R",
    "owner2": "OPAZO, MARIA P",
    "current_taxes": 494.59,
    "new_taxes_no_override": 515.96,
    "override_total_1": 530.6,
    "override_increase_1": 14.64
  },
  {
    "#": "17 Park Vale, Unit P-7 (171-01-14)",
    "$": 84000,
    "address": "17 Park Vale, Unit P-7",
    "parcel_id": "171-01-14",
    "owner1": "HARJANTO, DEWI",
    "owner2": "MILLS, ANDREW",
    "current_taxes": 860.16,
    "new_taxes_no_override": 897.32,
    "override_total_1": 922.78,
    "override_increase_1": 25.46
  },
  {
    "#": "17 Park Vale, Unit P-8 (171-01-15)",
    "$": 82500,
    "address": "17 Park Vale, Unit P-8",
    "parcel_id": "171-01-15",
    "owner1": "WHITFIELD, ADAM W",
    "owner2": "",
    "current_taxes": 844.8,
    "new_taxes_no_override": 881.3,
    "override_total_1": 906.3,
    "override_increase_1": 25.01
  },
  {
    "#": "17 Park Vale, Unit P-9 (171-01-16)",
    "$": 82500,
    "address": "17 Park Vale, Unit P-9",
    "parcel_id": "171-01-16",
    "owner1": "FADEEVA, ELENA",
    "owner2": "",
    "current_taxes": 844.8,
    "new_taxes_no_override": 881.3,
    "override_total_1": 906.3,
    "override_increase_1": 25.01
  },
  {
    "#": "7 Parkman St, Unit 1 (041-10-01)",
    "$": 1334700,
    "address": "7 Parkman St, Unit 1",
    "parcel_id": "041-10-01",
    "owner1": "SELVAGGI, JOVANNA",
    "owner2": "",
    "current_taxes": 10032.39,
    "new_taxes_no_override": 10465.79,
    "override_total_1": 10762.75,
    "override_increase_1": 296.96
  },
  {
    "#": "7 Parkman St, Unit 2 (041-10-02)",
    "$": 1641000,
    "address": "7 Parkman St, Unit 2",
    "parcel_id": "041-10-02",
    "owner1": "LU, BING",
    "owner2": "YANG, YINGZI",
    "current_taxes": 13168.91,
    "new_taxes_no_override": 13737.81,
    "override_total_1": 14127.61,
    "override_increase_1": 389.8
  },
  {
    "#": "7 Parkman St, Unit 3 (041-10-03)",
    "$": 1690600,
    "address": "7 Parkman St, Unit 3",
    "parcel_id": "041-10-03",
    "owner1": "FRANZA, OLIVIER PAUL YVES",
    "owner2": "PROSMITSKY, JENYA",
    "current_taxes": 13676.81,
    "new_taxes_no_override": 14267.65,
    "override_total_1": 14672.48,
    "override_increase_1": 404.83
  },
  {
    "#": "12 Parkman St (042-08-00)",
    "$": 3336100,
    "address": "12 Parkman St",
    "parcel_id": "042-08-00",
    "owner1": "LOUIE TRS, RAYMOND & EVA",
    "owner2": "",
    "current_taxes": 34161.66,
    "new_taxes_no_override": 35637.44,
    "override_total_1": 36648.63,
    "override_increase_1": 1011.19
  },
  {
    "#": "14 Parkman St, Unit 1 (042-07-03)",
    "$": 1482600,
    "address": "14 Parkman St, Unit 1",
    "parcel_id": "042-07-03",
    "owner1": "SANDROCK, NORMA J",
    "owner2": "",
    "current_taxes": 11546.89,
    "new_taxes_no_override": 12045.72,
    "override_total_1": 12387.5,
    "override_increase_1": 341.79
  },
  {
    "#": "14 Parkman St, Unit 2 (042-07-01)",
    "$": 1534300,
    "address": "14 Parkman St, Unit 2",
    "parcel_id": "042-07-01",
    "owner1": "TRIARHOU, EFTHALIA",
    "owner2": "",
    "current_taxes": 12076.3,
    "new_taxes_no_override": 12598.0,
    "override_total_1": 12955.45,
    "override_increase_1": 357.46
  },
  {
    "#": "14 Parkman St, Unit 3 & P3T (042-07-02)",
    "$": 1523400,
    "address": "14 Parkman St, Unit 3 & P3T",
    "parcel_id": "042-07-02",
    "owner1": "ROSENBERG TRS, IAN M & MIREILLE",
    "owner2": "",
    "current_taxes": 11964.68,
    "new_taxes_no_override": 12481.55,
    "override_total_1": 12835.71,
    "override_increase_1": 354.15
  },
  {
    "#": "15 Parkman St (041-11-00)",
    "$": 4557800,
    "address": "15 Parkman St",
    "parcel_id": "041-11-00",
    "owner1": "CHONG TRS, PETER N S & DONNA C P W",
    "owner2": "",
    "current_taxes": 43036.94,
    "new_taxes_no_override": 44896.14,
    "override_total_1": 46170.03,
    "override_increase_1": 1273.89
  },
  {
    "#": "16 Parkman St, Unit 1 & P1-G1 (042-06-01)",
    "$": 1334500,
    "address": "16 Parkman St, Unit 1 & P1-G1",
    "parcel_id": "042-06-01",
    "owner1": "DESAI, NIRAV K & AVANI J",
    "owner2": "",
    "current_taxes": 10030.35,
    "new_taxes_no_override": 10463.66,
    "override_total_1": 10760.56,
    "override_increase_1": 296.9
  },
  {
    "#": "16 Parkman St, Unit 2 & P2-G2 (042-06-02)",
    "$": 1342900,
    "address": "16 Parkman St, Unit 2 & P2-G2",
    "parcel_id": "042-06-02",
    "owner1": "SHARMA, ROHIT",
    "owner2": "PURI, CHARU",
    "current_taxes": 10116.36,
    "new_taxes_no_override": 10553.39,
    "override_total_1": 10852.83,
    "override_increase_1": 299.44
  },
  {
    "#": "16 Parkman St, Unit 3 & P3-G3 (042-06-03)",
    "$": 1605000,
    "address": "16 Parkman St, Unit 3 & P3-G3",
    "parcel_id": "042-06-03",
    "owner1": "FUH, HANCHING",
    "owner2": "ZHAO, SHERRY Y",
    "current_taxes": 12800.27,
    "new_taxes_no_override": 13353.24,
    "override_total_1": 13732.13,
    "override_increase_1": 378.89
  },
  {
    "#": "16 Parkman St, Unit 4 (042-06-04)",
    "$": 1616000,
    "address": "16 Parkman St, Unit 4",
    "parcel_id": "042-06-04",
    "owner1": "KONIECZKA, JAY H & IVANIA PALACIOS",
    "owner2": "",
    "current_taxes": 12912.91,
    "new_taxes_no_override": 13470.75,
    "override_total_1": 13852.97,
    "override_increase_1": 382.22
  },
  {
    "#": "17 Parkman St (041-12-00)",
    "$": 2553900,
    "address": "17 Parkman St",
    "parcel_id": "041-12-00",
    "owner1": "17 PARKMAN STREET LLC",
    "owner2": "",
    "current_taxes": 26151.94,
    "new_taxes_no_override": 27281.7,
    "override_total_1": 28055.8,
    "override_increase_1": 774.1
  },
  {
    "#": "18 Parkman St (042-05-00)",
    "$": 2906400,
    "address": "18 Parkman St",
    "parcel_id": "042-05-00",
    "owner1": "WONG, JAMES L-GARRY-MARJORIE L",
    "owner2": "",
    "current_taxes": 29761.54,
    "new_taxes_no_override": 31047.24,
    "override_total_1": 31928.18,
    "override_increase_1": 880.94
  },
  {
    "#": "21 Parkman St, Unit 1 (041-13-05)",
    "$": 1532300,
    "address": "21 Parkman St, Unit 1",
    "parcel_id": "041-13-05",
    "owner1": "PARKMAN 21 REALTY TRUST",
    "owner2": "C/O CHESNICK TR LYDIA G",
    "current_taxes": 15690.75,
    "new_taxes_no_override": 16368.59,
    "override_total_1": 16833.04,
    "override_increase_1": 464.45
  },
  {
    "#": "21 Parkman St, Unit 2A & P-A (041-13-01)",
    "$": 850900,
    "address": "21 Parkman St, Unit 2A & P-A",
    "parcel_id": "041-13-01",
    "owner1": "KIM, JANE Y",
    "owner2": "",
    "current_taxes": 8713.22,
    "new_taxes_no_override": 9089.63,
    "override_total_1": 9347.54,
    "override_increase_1": 257.91
  },
  {
    "#": "21 Parkman St, Unit 2B (041-13-02)",
    "$": 739500,
    "address": "21 Parkman St, Unit 2B",
    "parcel_id": "041-13-02",
    "owner1": "GERKEN, STEFANIE R",
    "owner2": "",
    "current_taxes": 3937.55,
    "new_taxes_no_override": 4107.65,
    "override_total_1": 4224.2,
    "override_increase_1": 116.55
  },
  {
    "#": "21 Parkman St, Unit 3A (041-13-03)",
    "$": 905400,
    "address": "21 Parkman St, Unit 3A",
    "parcel_id": "041-13-03",
    "owner1": "WARSAWSKI, CARINE",
    "owner2": "",
    "current_taxes": 9271.3,
    "new_taxes_no_override": 9671.82,
    "override_total_1": 9946.25,
    "override_increase_1": 274.43
  },
  {
    "#": "21 Parkman St, Unit 3B (041-13-04)",
    "$": 821900,
    "address": "21 Parkman St, Unit 3B",
    "parcel_id": "041-13-04",
    "owner1": "ZUCKOFF, ISABEL M",
    "owner2": "",
    "current_taxes": 4781.32,
    "new_taxes_no_override": 4987.87,
    "override_total_1": 5129.4,
    "override_increase_1": 141.53
  },
  {
    "#": "22 Parkman St, Unit 1 & G-3 (042-03-23)",
    "$": 671100,
    "address": "22 Parkman St, Unit 1 & G-3",
    "parcel_id": "042-03-23",
    "owner1": "SANTOS, MARIA TANYA",
    "owner2": "",
    "current_taxes": 3237.13,
    "new_taxes_no_override": 3376.97,
    "override_total_1": 3472.79,
    "override_increase_1": 95.82
  },
  {
    "#": "22 Parkman St, Unit 2 & Prk 1 (042-03-01)",
    "$": 658800,
    "address": "22 Parkman St, Unit 2 & Prk 1",
    "parcel_id": "042-03-01",
    "owner1": "WU, DIXI",
    "owner2": "",
    "current_taxes": 6746.11,
    "new_taxes_no_override": 7037.54,
    "override_total_1": 7237.23,
    "override_increase_1": 199.68
  },
  {
    "#": "22 Parkman St, Unit 3 & P37-38 (042-03-02)",
    "$": 1190600,
    "address": "22 Parkman St, Unit 3 & P37-38",
    "parcel_id": "042-03-02",
    "owner1": "22 PARKMAN LLC",
    "owner2": "",
    "current_taxes": 12191.74,
    "new_taxes_no_override": 12718.42,
    "override_total_1": 13079.3,
    "override_increase_1": 360.88
  },
  {
    "#": "22 Parkman St, Unit 4 P-20 P21 (042-03-03)",
    "$": 1201300,
    "address": "22 Parkman St, Unit 4 P-20 P21",
    "parcel_id": "042-03-03",
    "owner1": "ORLANDO, DANIEL",
    "owner2": "",
    "current_taxes": 8666.38,
    "new_taxes_no_override": 9040.77,
    "override_total_1": 9297.29,
    "override_increase_1": 256.52
  },
  {
    "#": "22 Parkman St, Unit G-15 (042-03-24)",
    "$": 90800,
    "address": "22 Parkman St, Unit G-15",
    "parcel_id": "042-03-24",
    "owner1": "HONG, KEUMHYE",
    "owner2": "LEE, JONGSUK",
    "current_taxes": 929.79,
    "new_taxes_no_override": 969.96,
    "override_total_1": 997.48,
    "override_increase_1": 27.52
  },
  {
    "#": "22 Parkman St, Unit Garage-1 (042-03-22)",
    "$": 2820400,
    "address": "22 Parkman St, Unit Garage-1",
    "parcel_id": "042-03-22",
    "owner1": "90210 BEACON OWNER LLC",
    "owner2": "",
    "current_taxes": 48398.06,
    "new_taxes_no_override": 50488.86,
    "override_total_1": 51921.44,
    "override_increase_1": 1432.58
  },
  {
    "#": "23 Parkman St, Unit 1 (041-14-01)",
    "$": 1563500,
    "address": "23 Parkman St, Unit 1",
    "parcel_id": "041-14-01",
    "owner1": "TARLOW TRS, DANIEL S  & RONNA F",
    "owner2": "",
    "current_taxes": 12375.31,
    "new_taxes_no_override": 12909.92,
    "override_total_1": 13276.23,
    "override_increase_1": 366.31
  },
  {
    "#": "23 Parkman St, Unit 2 (041-14-02)",
    "$": 1663200,
    "address": "23 Parkman St, Unit 2",
    "parcel_id": "041-14-02",
    "owner1": "EPSTEIN TRS, LESLIE & ILENE",
    "owner2": "",
    "current_taxes": 13396.23,
    "new_taxes_no_override": 13974.95,
    "override_total_1": 14371.48,
    "override_increase_1": 396.53
  },
  {
    "#": "23 Parkman St, Unit 3 (041-14-03)",
    "$": 1667400,
    "address": "23 Parkman St, Unit 3",
    "parcel_id": "041-14-03",
    "owner1": "FRONK, MARY ANN",
    "owner2": "SMALLRIDGE, HORACE H",
    "current_taxes": 13439.24,
    "new_taxes_no_override": 14019.82,
    "override_total_1": 14417.62,
    "override_increase_1": 397.8
  },
  {
    "#": "24 Parkman St, Unit 1 & P35 (042-03-04)",
    "$": 650600,
    "address": "24 Parkman St, Unit 1 & P35",
    "parcel_id": "042-03-04",
    "owner1": "FALKENSTEIN TR, EMILY A",
    "owner2": "",
    "current_taxes": 3027.21,
    "new_taxes_no_override": 3157.99,
    "override_total_1": 3247.59,
    "override_increase_1": 89.61
  },
  {
    "#": "24 Parkman St, Unit 2 & G17 (042-03-05)",
    "$": 675900,
    "address": "24 Parkman St, Unit 2 & G17",
    "parcel_id": "042-03-05",
    "owner1": "DALAL, ANUJ",
    "owner2": "",
    "current_taxes": 3286.28,
    "new_taxes_no_override": 3428.25,
    "override_total_1": 3525.52,
    "override_increase_1": 97.27
  },
  {
    "#": "24 Parkman St, Unit 3 P-9 P-10 (042-03-06)",
    "$": 1159700,
    "address": "24 Parkman St, Unit 3 P-9 P-10",
    "parcel_id": "042-03-06",
    "owner1": "GUERTIN TRS, MICHELLE",
    "owner2": "BORGOS TR, MICHAEL",
    "current_taxes": 8240.39,
    "new_taxes_no_override": 8596.37,
    "override_total_1": 8840.29,
    "override_increase_1": 243.92
  },
  {
    "#": "24 Parkman St, Unit 4 & Prk 16 (042-03-07)",
    "$": 1055500,
    "address": "24 Parkman St, Unit 4 & Prk 16",
    "parcel_id": "042-03-07",
    "owner1": "ECLIPSE CORP B V I",
    "owner2": "C/O ZARATE CARLOS JR",
    "current_taxes": 10808.32,
    "new_taxes_no_override": 11275.24,
    "override_total_1": 11595.17,
    "override_increase_1": 319.93
  },
  {
    "#": "25 Parkman St (041-15-00)",
    "$": 3106800,
    "address": "25 Parkman St",
    "parcel_id": "041-15-00",
    "owner1": "BARRON TR, THOMAS A",
    "owner2": "",
    "current_taxes": 28178.7,
    "new_taxes_no_override": 29396.02,
    "override_total_1": 30230.11,
    "override_increase_1": 834.09
  },
  {
    "#": "26 Parkman St, Unit 1 & P30 (042-03-08)",
    "$": 889500,
    "address": "26 Parkman St, Unit 1 & P30",
    "parcel_id": "042-03-08",
    "owner1": "BROWN, DEBORAH",
    "owner2": "",
    "current_taxes": 5473.55,
    "new_taxes_no_override": 5710.01,
    "override_total_1": 5872.02,
    "override_increase_1": 162.02
  },
  {
    "#": "26 Parkman St, Unit 2 & P18 (042-03-09)",
    "$": 871100,
    "address": "26 Parkman St, Unit 2 & P18",
    "parcel_id": "042-03-09",
    "owner1": "MEDARAMETLA, LALITHA & HANUMANTHARAO",
    "owner2": "",
    "current_taxes": 8920.06,
    "new_taxes_no_override": 9305.41,
    "override_total_1": 9569.44,
    "override_increase_1": 264.03
  },
  {
    "#": "26 Parkman St, Unit 3 & Prk 32 (042-03-10)",
    "$": 970000,
    "address": "26 Parkman St, Unit 3 & Prk 32",
    "parcel_id": "042-03-10",
    "owner1": "BURK, ALEXANDER",
    "owner2": "LERNER, ERICA",
    "current_taxes": 9932.8,
    "new_taxes_no_override": 10361.9,
    "override_total_1": 10655.91,
    "override_increase_1": 294.01
  },
  {
    "#": "26 Parkman St, Unit 4 & Prk 4 (042-03-11)",
    "$": 879600,
    "address": "26 Parkman St, Unit 4 & Prk 4",
    "parcel_id": "042-03-11",
    "owner1": "CHENG, JACHIN M & JESSICA H",
    "owner2": "",
    "current_taxes": 9007.1,
    "new_taxes_no_override": 9396.21,
    "override_total_1": 9662.82,
    "override_increase_1": 266.61
  },
  {
    "#": "26 Parkman St, Unit 5 & G5 (042-03-12)",
    "$": 926000,
    "address": "26 Parkman St, Unit 5 & G5",
    "parcel_id": "042-03-12",
    "owner1": "HONG, KEUMHYE",
    "owner2": "LEE, JONGSUK",
    "current_taxes": 9482.24,
    "new_taxes_no_override": 9891.87,
    "override_total_1": 10172.55,
    "override_increase_1": 280.67
  },
  {
    "#": "26 Parkman St, Unit 6 & Prk 29 (042-03-13)",
    "$": 890400,
    "address": "26 Parkman St, Unit 6 & Prk 29",
    "parcel_id": "042-03-13",
    "owner1": "SU, KEVIN KAILUN",
    "owner2": "LIN, SHUYEN",
    "current_taxes": 9117.7,
    "new_taxes_no_override": 9511.58,
    "override_total_1": 9781.47,
    "override_increase_1": 269.88
  },
  {
    "#": "28 Parkman St, Unit 1 & P31 (042-03-14)",
    "$": 626300,
    "address": "28 Parkman St, Unit 1 & P31",
    "parcel_id": "042-03-14",
    "owner1": "FORMAN, SCOTT L & JENNIFER",
    "owner2": "",
    "current_taxes": 2778.38,
    "new_taxes_no_override": 2898.41,
    "override_total_1": 2980.65,
    "override_increase_1": 82.24
  },
  {
    "#": "28 Parkman St, Unit 2 & P13 (042-03-15)",
    "$": 645000,
    "address": "28 Parkman St, Unit 2 & P13",
    "parcel_id": "042-03-15",
    "owner1": "YAMAZAKI, MASASHI & MISAKO",
    "owner2": "",
    "current_taxes": 2969.87,
    "new_taxes_no_override": 3098.17,
    "override_total_1": 3186.08,
    "override_increase_1": 87.91
  },
  {
    "#": "28 Parkman St, Unit 3 & P40-41 (042-03-16)",
    "$": 1224800,
    "address": "28 Parkman St, Unit 3 & P40-41",
    "parcel_id": "042-03-16",
    "owner1": "SCHWADRON, TR, ALAN M",
    "owner2": "",
    "current_taxes": 8907.02,
    "new_taxes_no_override": 9291.8,
    "override_total_1": 9555.45,
    "override_increase_1": 263.65
  },
  {
    "#": "28 Parkman St, Unit 4 & G36 (042-03-17)",
    "$": 1052400,
    "address": "28 Parkman St, Unit 4 & G36",
    "parcel_id": "042-03-17",
    "owner1": "KMA KING BOSTON LLC",
    "owner2": "",
    "current_taxes": 7141.64,
    "new_taxes_no_override": 7450.16,
    "override_total_1": 7661.55,
    "override_increase_1": 211.39
  },
  {
    "#": "30 Parkman St, Unit 1 & P2 (042-03-18)",
    "$": 665700,
    "address": "30 Parkman St, Unit 1 & P2",
    "parcel_id": "042-03-18",
    "owner1": "GRAY, MICHAEL S & TANIA",
    "owner2": "",
    "current_taxes": 6816.77,
    "new_taxes_no_override": 7111.25,
    "override_total_1": 7313.03,
    "override_increase_1": 201.78
  },
  {
    "#": "30 Parkman St, Unit 2 & P11 (042-03-19)",
    "$": 665300,
    "address": "30 Parkman St, Unit 2 & P11",
    "parcel_id": "042-03-19",
    "owner1": "TAMAYO, ENRIQUE",
    "owner2": "",
    "current_taxes": 3177.74,
    "new_taxes_no_override": 3315.02,
    "override_total_1": 3409.08,
    "override_increase_1": 94.06
  },
  {
    "#": "30 Parkman St, Unit 3 & P7-P8 (042-03-20)",
    "$": 1247200,
    "address": "30 Parkman St, Unit 3 & P7-P8",
    "parcel_id": "042-03-20",
    "owner1": "SHI, JING Z",
    "owner2": "",
    "current_taxes": 12771.33,
    "new_taxes_no_override": 13323.05,
    "override_total_1": 13701.08,
    "override_increase_1": 378.03
  },
  {
    "#": "30 Parkman St, Unit 4 & P19 (042-03-21)",
    "$": 1082300,
    "address": "30 Parkman St, Unit 4 & P19",
    "parcel_id": "042-03-21",
    "owner1": "DAUNCH, WILLIAM",
    "owner2": "RABAH, GHADA",
    "current_taxes": 11082.75,
    "new_taxes_no_override": 11561.52,
    "override_total_1": 11889.57,
    "override_increase_1": 328.05
  },
  {
    "#": "34 Parkman St, Unit 1 (042-02-06)",
    "$": 659400,
    "address": "34 Parkman St, Unit 1",
    "parcel_id": "042-02-06",
    "owner1": "LAGOS TRS, LILLIAN & CONSTANTINE B",
    "owner2": "",
    "current_taxes": 6752.26,
    "new_taxes_no_override": 7043.96,
    "override_total_1": 7243.82,
    "override_increase_1": 199.87
  },
  {
    "#": "34 Parkman St, Unit 2 (042-02-01)",
    "$": 603500,
    "address": "34 Parkman St, Unit 2",
    "parcel_id": "042-02-01",
    "owner1": "MAASS, VALERIE C",
    "owner2": "",
    "current_taxes": 2544.91,
    "new_taxes_no_override": 2654.85,
    "override_total_1": 2730.18,
    "override_increase_1": 75.33
  },
  {
    "#": "34 Parkman St, Unit 3 (042-02-02)",
    "$": 735300,
    "address": "34 Parkman St, Unit 3",
    "parcel_id": "042-02-02",
    "owner1": "CHAN, NICOLE L & WINNIE H & PETER",
    "owner2": "",
    "current_taxes": 3894.54,
    "new_taxes_no_override": 4062.78,
    "override_total_1": 4178.06,
    "override_increase_1": 115.28
  },
  {
    "#": "34 Parkman St, Unit 4 (042-02-03)",
    "$": 648100,
    "address": "34 Parkman St, Unit 4",
    "parcel_id": "042-02-03",
    "owner1": "BIONDOLILLO, ANTHONY J",
    "owner2": "",
    "current_taxes": 6636.54,
    "new_taxes_no_override": 6923.24,
    "override_total_1": 7119.68,
    "override_increase_1": 196.44
  },
  {
    "#": "34 Parkman St, Unit 5 (042-02-04)",
    "$": 757900,
    "address": "34 Parkman St, Unit 5",
    "parcel_id": "042-02-04",
    "owner1": "LO, FUK WAH VINCENT",
    "owner2": "CHAN, WAI CHAN",
    "current_taxes": 7760.9,
    "new_taxes_no_override": 8096.17,
    "override_total_1": 8325.89,
    "override_increase_1": 229.72
  },
  {
    "#": "34 Parkman St, Unit 6 (042-02-05)",
    "$": 638300,
    "address": "34 Parkman St, Unit 6",
    "parcel_id": "042-02-05",
    "owner1": "PARKMAN 34-6 LLC",
    "owner2": "",
    "current_taxes": 6536.19,
    "new_taxes_no_override": 6818.55,
    "override_total_1": 7012.02,
    "override_increase_1": 193.47
  },
  {
    "#": "35 Parkman St, Unit 35 (041-16-06)",
    "$": 529400,
    "address": "35 Parkman St, Unit 35",
    "parcel_id": "041-16-06",
    "owner1": "LEE, ELIZABETH",
    "owner2": "",
    "current_taxes": 1786.12,
    "new_taxes_no_override": 1863.28,
    "override_total_1": 1916.15,
    "override_increase_1": 52.87
  },
  {
    "#": "37 Parkman St, Unit 37 & P-2 (041-16-07)",
    "$": 651900,
    "address": "37 Parkman St, Unit 37 & P-2",
    "parcel_id": "041-16-07",
    "owner1": "BLANQUERA TR, LEIANNA",
    "owner2": "",
    "current_taxes": 6675.46,
    "new_taxes_no_override": 6963.84,
    "override_total_1": 7161.43,
    "override_increase_1": 197.59
  },
  {
    "#": "40 Parkman St, Unit 1 (042-01-04)",
    "$": 633300,
    "address": "40 Parkman St, Unit 1",
    "parcel_id": "042-01-04",
    "owner1": "PAGAN TRS, SAMUEL L",
    "owner2": "WALKER TR, KATHRYN M",
    "current_taxes": 2850.06,
    "new_taxes_no_override": 2973.18,
    "override_total_1": 3057.54,
    "override_increase_1": 84.36
  },
  {
    "#": "40 Parkman St, Unit 1A (042-01-03)",
    "$": 589200,
    "address": "40 Parkman St, Unit 1A",
    "parcel_id": "042-01-03",
    "owner1": "MADISON TRUST CO CUSTODIAN",
    "owner2": "C/O KARR MICHAEL",
    "current_taxes": 6033.41,
    "new_taxes_no_override": 6294.05,
    "override_total_1": 6472.64,
    "override_increase_1": 178.59
  },
  {
    "#": "40 Parkman St, Unit 2 (042-01-05)",
    "$": 615400,
    "address": "40 Parkman St, Unit 2",
    "parcel_id": "042-01-05",
    "owner1": "CHAKRABARTI, MEGHNA",
    "owner2": "",
    "current_taxes": 6301.7,
    "new_taxes_no_override": 6573.93,
    "override_total_1": 6760.46,
    "override_increase_1": 186.53
  },
  {
    "#": "40 Parkman St, Unit 3 (042-01-06)",
    "$": 618500,
    "address": "40 Parkman St, Unit 3",
    "parcel_id": "042-01-06",
    "owner1": "BAJIC, SIBINKA",
    "owner2": "",
    "current_taxes": 2698.51,
    "new_taxes_no_override": 2815.09,
    "override_total_1": 2894.96,
    "override_increase_1": 79.88
  },
  {
    "#": "53 Parkman St (040-01-00)",
    "$": 10735300,
    "address": "53 Parkman St",
    "parcel_id": "040-01-00",
    "owner1": "IDRG LLC",
    "owner2": "C/O HAMILTON CO",
    "current_taxes": 109929.47,
    "new_taxes_no_override": 114678.42,
    "override_total_1": 117932.34,
    "override_increase_1": 3253.91
  },
  {
    "#": "60 Parkman St (043-31-00)",
    "$": 4956100,
    "address": "60 Parkman St",
    "parcel_id": "043-31-00",
    "owner1": "HUMAIRA REALTY LLC",
    "owner2": "C/O DANNIN MGMT CORP",
    "current_taxes": 50750.46,
    "new_taxes_no_override": 52942.88,
    "override_total_1": 54445.09,
    "override_increase_1": 1502.21
  },
  {
    "#": "62 Parkman St, Unit 1 P-A (043-30-01)",
    "$": 1533300,
    "address": "62 Parkman St, Unit 1 P-A",
    "parcel_id": "043-30-01",
    "owner1": "ABUR, ALI & AYSEN TANYERI",
    "owner2": "",
    "current_taxes": 12066.06,
    "new_taxes_no_override": 12587.31,
    "override_total_1": 12944.47,
    "override_increase_1": 357.16
  },
  {
    "#": "62 Parkman St, Unit 2 (043-30-02)",
    "$": 1831000,
    "address": "62 Parkman St, Unit 2",
    "parcel_id": "043-30-02",
    "owner1": "HOM TR, PAMELA JADE",
    "owner2": "",
    "current_taxes": 15114.51,
    "new_taxes_no_override": 15767.46,
    "override_total_1": 16214.85,
    "override_increase_1": 447.39
  },
  {
    "#": "62 Parkman St, Unit 3 Prk B D (043-30-03)",
    "$": 1741400,
    "address": "62 Parkman St, Unit 3 Prk B D",
    "parcel_id": "043-30-03",
    "owner1": "CHECHELNITSKY TRS, MICHAEL",
    "owner2": "BASSINA, NATALYA Y",
    "current_taxes": 14197.0,
    "new_taxes_no_override": 14810.31,
    "override_total_1": 15230.54,
    "override_increase_1": 420.23
  },
  {
    "#": "62 Parkman St, Unit A & P-C (043-30-04)",
    "$": 1008500,
    "address": "62 Parkman St, Unit A & P-C",
    "parcel_id": "043-30-04",
    "owner1": "GOLDBERG, NECHAMA D",
    "owner2": "",
    "current_taxes": 6692.11,
    "new_taxes_no_override": 6981.21,
    "override_total_1": 7179.3,
    "override_increase_1": 198.09
  },
  {
    "#": "64 Parkman St, Unit 1 (043-29-01)",
    "$": 1310800,
    "address": "64 Parkman St, Unit 1",
    "parcel_id": "043-29-01",
    "owner1": "SCHIMMEL, EDITH",
    "owner2": "",
    "current_taxes": 9787.66,
    "new_taxes_no_override": 10210.49,
    "override_total_1": 10500.2,
    "override_increase_1": 289.71
  },
  {
    "#": "64 Parkman St, Unit 2 (043-29-02)",
    "$": 1702300,
    "address": "64 Parkman St, Unit 2",
    "parcel_id": "043-29-02",
    "owner1": "LEVY, VANESSA",
    "owner2": "",
    "current_taxes": 13796.62,
    "new_taxes_no_override": 14392.63,
    "override_total_1": 14801.01,
    "override_increase_1": 408.38
  },
  {
    "#": "64 Parkman St, Unit 3 (043-29-03)",
    "$": 1605000,
    "address": "64 Parkman St, Unit 3",
    "parcel_id": "043-29-03",
    "owner1": "ZIK, ORY",
    "owner2": "WILENSKY ZIK, DAPHNA",
    "current_taxes": 12800.27,
    "new_taxes_no_override": 13353.24,
    "override_total_1": 13732.13,
    "override_increase_1": 378.89
  },
  {
    "#": "66 Parkman St, Unit 1 (043-28-01)",
    "$": 1698500,
    "address": "66 Parkman St, Unit 1",
    "parcel_id": "043-28-01",
    "owner1": "MANDELL TRS, BRIAN S",
    "owner2": "DAVID, DEBRA L",
    "current_taxes": 13757.71,
    "new_taxes_no_override": 14352.04,
    "override_total_1": 14759.27,
    "override_increase_1": 407.23
  },
  {
    "#": "66 Parkman St, Unit 2 (043-28-02)",
    "$": 1782800,
    "address": "66 Parkman St, Unit 2",
    "parcel_id": "043-28-02",
    "owner1": "GUGLIELMINO, PAUL",
    "owner2": "MINTCHEVA, RALITSA",
    "current_taxes": 14620.94,
    "new_taxes_no_override": 15252.56,
    "override_total_1": 15685.34,
    "override_increase_1": 432.78
  },
  {
    "#": "66 Parkman St, Unit 3 (043-28-03)",
    "$": 1727200,
    "address": "66 Parkman St, Unit 3",
    "parcel_id": "043-28-03",
    "owner1": "HURIOGLU, TAMARA",
    "owner2": "NOUBIR, GUEVARA",
    "current_taxes": 14051.59,
    "new_taxes_no_override": 14658.62,
    "override_total_1": 15074.55,
    "override_increase_1": 415.93
  },
  {
    "#": "68 Parkman St, Unit 1 -Gar D & Pksps E & F (043-27-03)",
    "$": 1947400,
    "address": "68 Parkman St, Unit 1 -Gar D & Pksps E & F",
    "parcel_id": "043-27-03",
    "owner1": "LEWITT, MICHAEL A & PATRICA M",
    "owner2": "",
    "current_taxes": 16306.44,
    "new_taxes_no_override": 17010.88,
    "override_total_1": 17493.55,
    "override_increase_1": 482.67
  },
  {
    "#": "68 Parkman St, Unit 2  Gar A & B (043-27-01)",
    "$": 1785800,
    "address": "68 Parkman St, Unit 2  Gar A & B",
    "parcel_id": "043-27-01",
    "owner1": "ILAHI, M ABID",
    "owner2": "",
    "current_taxes": 14651.66,
    "new_taxes_no_override": 15284.61,
    "override_total_1": 15718.3,
    "override_increase_1": 433.69
  },
  {
    "#": "68 Parkman St, Unit 3 Gar C (043-27-02)",
    "$": 1715800,
    "address": "68 Parkman St, Unit 3 Gar C",
    "parcel_id": "043-27-02",
    "owner1": "LIN, TONY XIANG DONG & NAN",
    "owner2": "",
    "current_taxes": 13934.86,
    "new_taxes_no_override": 14536.85,
    "override_total_1": 14949.32,
    "override_increase_1": 412.47
  },
  {
    "#": "71 Parkman St, Unit 1 & P2 (040-02-01)",
    "$": 657600,
    "address": "71 Parkman St, Unit 1 & P2",
    "parcel_id": "040-02-01",
    "owner1": "SANDORA, THOMAS J",
    "owner2": "",
    "current_taxes": 3098.89,
    "new_taxes_no_override": 3232.76,
    "override_total_1": 3324.49,
    "override_increase_1": 91.73
  },
  {
    "#": "71 Parkman St, Unit 1A & P-6 (040-02-02)",
    "$": 530800,
    "address": "71 Parkman St, Unit 1A & P-6",
    "parcel_id": "040-02-02",
    "owner1": "REDMOND TRS, KEVIN J & JOSEPHINE L",
    "owner2": "",
    "current_taxes": 5435.39,
    "new_taxes_no_override": 5670.2,
    "override_total_1": 5831.09,
    "override_increase_1": 160.89
  },
  {
    "#": "71 Parkman St, Unit 2 & P12 (040-02-03)",
    "$": 1142900,
    "address": "71 Parkman St, Unit 2 & P12",
    "parcel_id": "040-02-03",
    "owner1": "ROEBUCK, FRANK III",
    "owner2": "TOMPKINS, KYLE",
    "current_taxes": 8068.36,
    "new_taxes_no_override": 8416.91,
    "override_total_1": 8655.74,
    "override_increase_1": 238.82
  },
  {
    "#": "71 Parkman St, Unit 3 & P7 (040-02-04)",
    "$": 805300,
    "address": "71 Parkman St, Unit 3 & P7",
    "parcel_id": "040-02-04",
    "owner1": "WARREN, ROBERT & LAURA E G",
    "owner2": "GRAYSON, JANE",
    "current_taxes": 8246.27,
    "new_taxes_no_override": 8602.51,
    "override_total_1": 8846.6,
    "override_increase_1": 244.09
  },
  {
    "#": "71 Parkman St, Unit 4 & P-3 (040-02-05)",
    "$": 542100,
    "address": "71 Parkman St, Unit 4 & P-3",
    "parcel_id": "040-02-05",
    "owner1": "YONGKITTIKUL, THATCHAPORN",
    "owner2": "",
    "current_taxes": 1916.17,
    "new_taxes_no_override": 1998.95,
    "override_total_1": 2055.67,
    "override_increase_1": 56.72
  },
  {
    "#": "71 Parkman St, Unit B (040-02-28)",
    "$": 406300,
    "address": "71 Parkman St, Unit B",
    "parcel_id": "040-02-28",
    "owner1": "LO, COLIN C",
    "owner2": "C/O ACTIONVEST MGMT CORP",
    "current_taxes": 4160.51,
    "new_taxes_no_override": 4340.24,
    "override_total_1": 4463.4,
    "override_increase_1": 123.15
  },
  {
    "#": "73 Parkman St, Unit 1 (040-02-06)",
    "$": 634300,
    "address": "73 Parkman St, Unit 1",
    "parcel_id": "040-02-06",
    "owner1": "REDMOND, PATRICK H G & JACQUELYN",
    "owner2": "",
    "current_taxes": 6495.23,
    "new_taxes_no_override": 6775.82,
    "override_total_1": 6968.08,
    "override_increase_1": 192.26
  },
  {
    "#": "73 Parkman St, Unit 1A (040-02-07)",
    "$": 457400,
    "address": "73 Parkman St, Unit 1A",
    "parcel_id": "040-02-07",
    "owner1": "CARVAJAL TR, ALEJANDRA VERONICA",
    "owner2": "",
    "current_taxes": 4683.78,
    "new_taxes_no_override": 4886.12,
    "override_total_1": 5024.76,
    "override_increase_1": 138.64
  },
  {
    "#": "73 Parkman St, Unit 3 & P14 (040-02-09)",
    "$": 716800,
    "address": "73 Parkman St, Unit 3 & P14",
    "parcel_id": "040-02-09",
    "owner1": "PMU REALTY LLC",
    "owner2": "",
    "current_taxes": 7340.03,
    "new_taxes_no_override": 7657.12,
    "override_total_1": 7874.38,
    "override_increase_1": 217.26
  },
  {
    "#": "73 Parkman St, Unit 4 & P13 (040-02-10)",
    "$": 530600,
    "address": "73 Parkman St, Unit 4 & P13",
    "parcel_id": "040-02-10",
    "owner1": "PMU REALTY LLC",
    "owner2": "",
    "current_taxes": 5433.34,
    "new_taxes_no_override": 5668.06,
    "override_total_1": 5828.89,
    "override_increase_1": 160.83
  },
  {
    "#": "73 Parkman St, Unit 73-2 & P8 (040-02-08)",
    "$": 1008200,
    "address": "73 Parkman St, Unit 73-2 & P8",
    "parcel_id": "040-02-08",
    "owner1": "ROBERTSON TR, ANNE",
    "owner2": "",
    "current_taxes": 6689.03,
    "new_taxes_no_override": 6978.0,
    "override_total_1": 7175.99,
    "override_increase_1": 198.0
  },
  {
    "#": "74 Parkman St, Unit 1 (043-26-03)",
    "$": 914700,
    "address": "74 Parkman St, Unit 1",
    "parcel_id": "043-26-03",
    "owner1": "LISS LIFE ESTATE, LISA",
    "owner2": "",
    "current_taxes": 5731.59,
    "new_taxes_no_override": 5979.19,
    "override_total_1": 6148.85,
    "override_increase_1": 169.66
  },
  {
    "#": "74 Parkman St, Unit 2 (043-26-01)",
    "$": 986800,
    "address": "74 Parkman St, Unit 2",
    "parcel_id": "043-26-01",
    "owner1": "MCKAY, MICHAEL J",
    "owner2": "MULLANE, CATRIONA",
    "current_taxes": 10104.83,
    "new_taxes_no_override": 10541.36,
    "override_total_1": 10840.46,
    "override_increase_1": 299.1
  },
  {
    "#": "74 Parkman St, Unit 3 (043-26-02)",
    "$": 987700,
    "address": "74 Parkman St, Unit 3",
    "parcel_id": "043-26-02",
    "owner1": "DURBIN, PHILIP A",
    "owner2": "BROERING, TERESA J",
    "current_taxes": 10114.05,
    "new_taxes_no_override": 10550.98,
    "override_total_1": 10850.35,
    "override_increase_1": 299.38
  },
  {
    "#": "76 Parkman St, Unit 1 (043-25-01)",
    "$": 872600,
    "address": "76 Parkman St, Unit 1",
    "parcel_id": "043-25-01",
    "owner1": "WEINBERG, EMILY",
    "owner2": "MARTIN, DANIEL",
    "current_taxes": 5300.49,
    "new_taxes_no_override": 5529.47,
    "override_total_1": 5686.37,
    "override_increase_1": 156.89
  },
  {
    "#": "76 Parkman St, Unit 2 (043-25-02)",
    "$": 905500,
    "address": "76 Parkman St, Unit 2",
    "parcel_id": "043-25-02",
    "owner1": "HUMPHREYS, JENAI MICHELLE & JARED DANIEL",
    "owner2": "",
    "current_taxes": 5637.39,
    "new_taxes_no_override": 5880.93,
    "override_total_1": 6047.79,
    "override_increase_1": 166.87
  },
  {
    "#": "76 Parkman St, Unit 3 (043-25-03)",
    "$": 899400,
    "address": "76 Parkman St, Unit 3",
    "parcel_id": "043-25-03",
    "owner1": "MACKEY TRS, JOHN A & EILEEN A",
    "owner2": "",
    "current_taxes": 5574.92,
    "new_taxes_no_override": 5815.76,
    "override_total_1": 5980.77,
    "override_increase_1": 165.02
  },
  {
    "#": "77 Parkman St, Unit 1 (040-02-13)",
    "$": 1066700,
    "address": "77 Parkman St, Unit 1",
    "parcel_id": "040-02-13",
    "owner1": "ORENSTEIN, SANFORD M & INA",
    "owner2": "",
    "current_taxes": 7288.07,
    "new_taxes_no_override": 7602.91,
    "override_total_1": 7818.64,
    "override_increase_1": 215.73
  },
  {
    "#": "77 Parkman St, Unit 2 & P1 (040-02-14)",
    "$": 1207100,
    "address": "77 Parkman St, Unit 2 & P1",
    "parcel_id": "040-02-14",
    "owner1": "DORFMAN, LARISA",
    "owner2": "VAITSBLIT, EUGENE",
    "current_taxes": 8725.77,
    "new_taxes_no_override": 9102.72,
    "override_total_1": 9361.01,
    "override_increase_1": 258.28
  },
  {
    "#": "77 Parkman St, Unit 3 & P15 (040-02-15)",
    "$": 719000,
    "address": "77 Parkman St, Unit 3 & P15",
    "parcel_id": "040-02-15",
    "owner1": "SABOURY, SAEAD & ABDULREZA",
    "owner2": "",
    "current_taxes": 3727.63,
    "new_taxes_no_override": 3888.66,
    "override_total_1": 3999.0,
    "override_increase_1": 110.34
  },
  {
    "#": "77 Parkman St, Unit 4 (040-02-16)",
    "$": 606900,
    "address": "77 Parkman St, Unit 4",
    "parcel_id": "040-02-16",
    "owner1": "M & R CONDOMINIUMS LLC",
    "owner2": "C/O MERRILL & MCGEARY",
    "current_taxes": 6214.66,
    "new_taxes_no_override": 6483.13,
    "override_total_1": 6667.09,
    "override_increase_1": 183.95
  },
  {
    "#": "77 Parkman St, Unit 77A (040-02-11)",
    "$": 563200,
    "address": "77 Parkman St, Unit 77A",
    "parcel_id": "040-02-11",
    "owner1": "HARR, SUSAN R",
    "owner2": "",
    "current_taxes": 2132.23,
    "new_taxes_no_override": 2224.34,
    "override_total_1": 2287.46,
    "override_increase_1": 63.11
  },
  {
    "#": "77 Parkman St, Unit 77B (040-02-12)",
    "$": 519100,
    "address": "77 Parkman St, Unit 77B",
    "parcel_id": "040-02-12",
    "owner1": "ROUKHADZE, TOM",
    "owner2": "ROUKHADZE-BEKACHVILI, NINO",
    "current_taxes": 5315.58,
    "new_taxes_no_override": 5545.21,
    "override_total_1": 5702.55,
    "override_increase_1": 157.34
  },
  {
    "#": "6 Parkway Rd, Unit 1 (134-13-06)",
    "$": 847300,
    "address": "6 Parkway Rd, Unit 1",
    "parcel_id": "134-13-06",
    "owner1": "PARTRIDGE, ANN",
    "owner2": "MITCHELL, JONATHAN",
    "current_taxes": 8676.35,
    "new_taxes_no_override": 9051.17,
    "override_total_1": 9307.99,
    "override_increase_1": 256.82
  },
  {
    "#": "6 Parkway Rd, Unit 2 (134-13-07)",
    "$": 822800,
    "address": "6 Parkway Rd, Unit 2",
    "parcel_id": "134-13-07",
    "owner1": "TURNER, JOHN PAUL",
    "owner2": "YANG, WEI-YU",
    "current_taxes": 8425.47,
    "new_taxes_no_override": 8789.45,
    "override_total_1": 9038.84,
    "override_increase_1": 249.39
  },
  {
    "#": "6 Parkway Rd, Unit 3 (134-13-08)",
    "$": 788900,
    "address": "6 Parkway Rd, Unit 3",
    "parcel_id": "134-13-08",
    "owner1": "LONDON, MARK",
    "owner2": "",
    "current_taxes": 4443.4,
    "new_taxes_no_override": 4635.35,
    "override_total_1": 4766.88,
    "override_increase_1": 131.52
  },
  {
    "#": "6 Parkway Rd, Unit 4 (134-13-09)",
    "$": 698800,
    "address": "6 Parkway Rd, Unit 4",
    "parcel_id": "134-13-09",
    "owner1": "MIKROUDIS, ARGYRO",
    "owner2": "",
    "current_taxes": 7155.71,
    "new_taxes_no_override": 7464.84,
    "override_total_1": 7676.65,
    "override_increase_1": 211.81
  },
  {
    "#": "6 Parkway Rd, Unit 5 (134-13-10)",
    "$": 708300,
    "address": "6 Parkway Rd, Unit 5",
    "parcel_id": "134-13-10",
    "owner1": "LEE, HSUEH-YEN & YU-HSIANG",
    "owner2": "",
    "current_taxes": 7252.99,
    "new_taxes_no_override": 7566.32,
    "override_total_1": 7781.01,
    "override_increase_1": 214.69
  },
  {
    "#": "6 Parkway Rd, Unit 6 (134-13-11)",
    "$": 686900,
    "address": "6 Parkway Rd, Unit 6",
    "parcel_id": "134-13-11",
    "owner1": "STEADMAN, OPHELIA",
    "owner2": "",
    "current_taxes": 7033.86,
    "new_taxes_no_override": 7337.72,
    "override_total_1": 7545.93,
    "override_increase_1": 208.2
  },
  {
    "#": "8 Parkway Rd (134-10-01)",
    "$": 3623700,
    "address": "8 Parkway Rd",
    "parcel_id": "134-10-01",
    "owner1": "PENG, JAMES LI-WEI & NANCY Y",
    "owner2": "",
    "current_taxes": 37106.69,
    "new_taxes_no_override": 38709.7,
    "override_total_1": 39808.06,
    "override_increase_1": 1098.36
  },
  {
    "#": "12 Parkway Rd (134-10-02)",
    "$": 3623700,
    "address": "12 Parkway Rd",
    "parcel_id": "134-10-02",
    "owner1": "PENG, JAMES LI-WEI & NANCY Y",
    "owner2": "",
    "current_taxes": 37106.69,
    "new_taxes_no_override": 38709.7,
    "override_total_1": 39808.06,
    "override_increase_1": 1098.36
  },
  {
    "#": "16 Parkway Rd (134-10-03)",
    "$": 4418100,
    "address": "16 Parkway Rd",
    "parcel_id": "134-10-03",
    "owner1": "LU-MARQUES, CARSON",
    "owner2": "",
    "current_taxes": 45241.34,
    "new_taxes_no_override": 47195.77,
    "override_total_1": 48534.91,
    "override_increase_1": 1339.14
  },
  {
    "#": "20 Parkway Rd, Unit 1 (134-09-06)",
    "$": 715200,
    "address": "20 Parkway Rd, Unit 1",
    "parcel_id": "134-09-06",
    "owner1": "VON DAUM THOLL, SUSAN E",
    "owner2": "",
    "current_taxes": 3688.71,
    "new_taxes_no_override": 3848.06,
    "override_total_1": 3957.25,
    "override_increase_1": 109.19
  },
  {
    "#": "20 Parkway Rd, Unit 3 (134-09-02)",
    "$": 746800,
    "address": "20 Parkway Rd, Unit 3",
    "parcel_id": "134-09-02",
    "owner1": "WONG TRS, CELENE W",
    "owner2": "CHILD, THOMAS F",
    "current_taxes": 4012.3,
    "new_taxes_no_override": 4185.63,
    "override_total_1": 4304.4,
    "override_increase_1": 118.76
  },
  {
    "#": "20 Parkway Rd, Unit 5 (134-09-04)",
    "$": 739400,
    "address": "20 Parkway Rd, Unit 5",
    "parcel_id": "134-09-04",
    "owner1": "LASEK, MARILYN A",
    "owner2": "",
    "current_taxes": 3936.52,
    "new_taxes_no_override": 4106.58,
    "override_total_1": 4223.1,
    "override_increase_1": 116.52
  },
  {
    "#": "22 Parkway Rd, Unit 2 (134-09-01)",
    "$": 739700,
    "address": "22 Parkway Rd, Unit 2",
    "parcel_id": "134-09-01",
    "owner1": "HUANG, PENGYU",
    "owner2": "CHEN, SEN",
    "current_taxes": 7574.53,
    "new_taxes_no_override": 7901.75,
    "override_total_1": 8125.96,
    "override_increase_1": 224.21
  },
  {
    "#": "22 Parkway Rd, Unit 4 (134-09-03)",
    "$": 745000,
    "address": "22 Parkway Rd, Unit 4",
    "parcel_id": "134-09-03",
    "owner1": "BAIBAKOU, ANDREI",
    "owner2": "",
    "current_taxes": 3993.87,
    "new_taxes_no_override": 4166.41,
    "override_total_1": 4284.62,
    "override_increase_1": 118.22
  },
  {
    "#": "22 Parkway Rd, Unit 6 (134-09-05)",
    "$": 730700,
    "address": "22 Parkway Rd, Unit 6",
    "parcel_id": "134-09-05",
    "owner1": "WANG, JULIA",
    "owner2": "ROEHRL, MICHAEL H",
    "current_taxes": 7482.37,
    "new_taxes_no_override": 7805.61,
    "override_total_1": 8027.09,
    "override_increase_1": 221.48
  },
  {
    "#": "26 Parkway Rd (134-08-00)",
    "$": 2328900,
    "address": "26 Parkway Rd",
    "parcel_id": "134-08-00",
    "owner1": "KORSTVEDT, ROBERTA S",
    "owner2": "",
    "current_taxes": 20213.0,
    "new_taxes_no_override": 21086.2,
    "override_total_1": 21684.51,
    "override_increase_1": 598.3
  },
  {
    "#": "32 Parkway Rd, Unit 1 (134-07-01)",
    "$": 725800,
    "address": "32 Parkway Rd, Unit 1",
    "parcel_id": "134-07-01",
    "owner1": "ARDIFF TRS, EMMA C",
    "owner2": "FLAHERTY, JOSEPH P",
    "current_taxes": 7432.19,
    "new_taxes_no_override": 7753.26,
    "override_total_1": 7973.25,
    "override_increase_1": 219.99
  },
  {
    "#": "32 Parkway Rd, Unit 2 (134-07-02)",
    "$": 716700,
    "address": "32 Parkway Rd, Unit 2",
    "parcel_id": "134-07-02",
    "owner1": "BYWATER, ALEXIS C",
    "owner2": "",
    "current_taxes": 7339.01,
    "new_taxes_no_override": 7656.06,
    "override_total_1": 7873.29,
    "override_increase_1": 217.23
  },
  {
    "#": "32 Parkway Rd, Unit 3 (134-07-03)",
    "$": 720200,
    "address": "32 Parkway Rd, Unit 3",
    "parcel_id": "134-07-03",
    "owner1": "WENG, ZHIGANG",
    "owner2": "LAZAROVA, TSVETELINA",
    "current_taxes": 7374.85,
    "new_taxes_no_override": 7693.44,
    "override_total_1": 7911.74,
    "override_increase_1": 218.3
  },
  {
    "#": "9 Payson Rd (361-06-00)",
    "$": 2806900,
    "address": "9 Payson Rd",
    "parcel_id": "361-06-00",
    "owner1": "STEINBERG TR, CYNTHIA R",
    "owner2": "",
    "current_taxes": 28742.66,
    "new_taxes_no_override": 29984.34,
    "override_total_1": 30835.13,
    "override_increase_1": 850.78
  },
  {
    "#": "16 Payson Rd (362-01-00)",
    "$": 816300,
    "address": "16 Payson Rd",
    "parcel_id": "362-01-00",
    "owner1": "PLANTE, RAYMOND",
    "owner2": "WEBB, CLARA",
    "current_taxes": 4723.98,
    "new_taxes_no_override": 4928.06,
    "override_total_1": 5067.89,
    "override_increase_1": 139.83
  },
  {
    "#": "17 Payson Rd (361-08-00)",
    "$": 1451300,
    "address": "17 Payson Rd",
    "parcel_id": "361-08-00",
    "owner1": "SHERSETH, KYLE NICHOLAS & HANNAH SEDLET",
    "owner2": "",
    "current_taxes": 11226.38,
    "new_taxes_no_override": 11711.36,
    "override_total_1": 12043.66,
    "override_increase_1": 332.3
  },
  {
    "#": "20 Payson Rd (362-03-00)",
    "$": 1230300,
    "address": "20 Payson Rd",
    "parcel_id": "362-03-00",
    "owner1": "CAGNINA, SHAWN J & REBECCA E",
    "owner2": "",
    "current_taxes": 8963.34,
    "new_taxes_no_override": 9350.56,
    "override_total_1": 9615.87,
    "override_increase_1": 265.31
  },
  {
    "#": "21 Payson Rd (361-09-00)",
    "$": 1155600,
    "address": "21 Payson Rd",
    "parcel_id": "361-09-00",
    "owner1": "YAMADA, KEN & KAYOKO",
    "owner2": "",
    "current_taxes": 8198.41,
    "new_taxes_no_override": 8552.58,
    "override_total_1": 8795.25,
    "override_increase_1": 242.67
  },
  {
    "#": "22 Payson Rd (362-04-00)",
    "$": 791500,
    "address": "22 Payson Rd",
    "parcel_id": "362-04-00",
    "owner1": "CANADAY, ANNE C",
    "owner2": "",
    "current_taxes": 4470.03,
    "new_taxes_no_override": 4663.14,
    "override_total_1": 4795.45,
    "override_increase_1": 132.31
  },
  {
    "#": "25 Payson Rd (361-10-00)",
    "$": 1483800,
    "address": "25 Payson Rd",
    "parcel_id": "361-10-00",
    "owner1": "SOHN, REGINA L",
    "owner2": "VANDENDRIES, ERIK R",
    "current_taxes": 11559.18,
    "new_taxes_no_override": 12058.54,
    "override_total_1": 12400.69,
    "override_increase_1": 342.15
  },
  {
    "#": "29 Payson Rd (361-11-00)",
    "$": 1120300,
    "address": "29 Payson Rd",
    "parcel_id": "361-11-00",
    "owner1": "SIDDIQI, FAIZAN JAWED",
    "owner2": "HANSEN, JULIA CHRISTINA & MARY ELIZABETH",
    "current_taxes": 11471.87,
    "new_taxes_no_override": 11967.45,
    "override_total_1": 12307.02,
    "override_increase_1": 339.57
  },
  {
    "#": "30 Payson Rd (362-05-00)",
    "$": 1135500,
    "address": "30 Payson Rd",
    "parcel_id": "362-05-00",
    "owner1": "MULLIGAN, THOMAS F JR & MARY ELIZ",
    "owner2": "",
    "current_taxes": 7992.59,
    "new_taxes_no_override": 8337.87,
    "override_total_1": 8574.45,
    "override_increase_1": 236.58
  },
  {
    "#": "44 Payson Rd (367-22-00)",
    "$": 1351700,
    "address": "44 Payson Rd",
    "parcel_id": "367-22-00",
    "owner1": "SHPRITZ, NATHAN",
    "owner2": "KASEN, NANCY",
    "current_taxes": 10206.47,
    "new_taxes_no_override": 10647.39,
    "override_total_1": 10949.5,
    "override_increase_1": 302.11
  },
  {
    "#": "48 Payson Rd (367-21-00)",
    "$": 1550200,
    "address": "48 Payson Rd",
    "parcel_id": "367-21-00",
    "owner1": "SINGAL TRS, ROBERTA",
    "owner2": "WEINTROUB, JONATHAN",
    "current_taxes": 12239.11,
    "new_taxes_no_override": 12767.84,
    "override_total_1": 13130.12,
    "override_increase_1": 362.28
  },
  {
    "#": "51 Payson Rd (363-13-14)",
    "$": 1489900,
    "address": "51 Payson Rd",
    "parcel_id": "363-13-14",
    "owner1": "FRANCISCO, PATRICIA & ARCADIO",
    "owner2": "",
    "current_taxes": 15256.58,
    "new_taxes_no_override": 15915.66,
    "override_total_1": 16367.26,
    "override_increase_1": 451.59
  },
  {
    "#": "52 Payson Rd (367-19-00)",
    "$": 1459600,
    "address": "52 Payson Rd",
    "parcel_id": "367-19-00",
    "owner1": "CHERTOV, ANDREY",
    "owner2": "VOLKOVA, NATALIYA",
    "current_taxes": 11311.37,
    "new_taxes_no_override": 11800.02,
    "override_total_1": 12134.84,
    "override_increase_1": 334.82
  },
  {
    "#": "58 Payson Rd (367-18-00)",
    "$": 1023600,
    "address": "58 Payson Rd",
    "parcel_id": "367-18-00",
    "owner1": "DAILEY, JILL CANORA & MATTHEW",
    "owner2": "",
    "current_taxes": 6846.73,
    "new_taxes_no_override": 7142.51,
    "override_total_1": 7345.17,
    "override_increase_1": 202.66
  },
  {
    "#": "63 Payson Rd (363-09-02)",
    "$": 1400300,
    "address": "63 Payson Rd",
    "parcel_id": "363-09-02",
    "owner1": "MEREWOOD, ANNE",
    "owner2": "MAKRIGIORGOS, GERASSIMOS",
    "current_taxes": 10704.14,
    "new_taxes_no_override": 11166.56,
    "override_total_1": 11483.4,
    "override_increase_1": 316.84
  },
  {
    "#": "67 Payson Rd (363-09-01)",
    "$": 1992500,
    "address": "67 Payson Rd",
    "parcel_id": "363-09-01",
    "owner1": "MAKRIGIORGOS TRS, GERASSIMOS N & ANNE MEREWOOD",
    "owner2": "",
    "current_taxes": 20403.2,
    "new_taxes_no_override": 21284.62,
    "override_total_1": 21888.55,
    "override_increase_1": 603.93
  },
  {
    "#": "68 Payson Rd (367-17-00)",
    "$": 1101300,
    "address": "68 Payson Rd",
    "parcel_id": "367-17-00",
    "owner1": "FORD, AMELIA LOPES & SETH ROBERT",
    "owner2": "",
    "current_taxes": 7642.38,
    "new_taxes_no_override": 7972.53,
    "override_total_1": 8198.75,
    "override_increase_1": 226.21
  },
  {
    "#": "69 Payson Rd (363-07-08)",
    "$": 1626300,
    "address": "69 Payson Rd",
    "parcel_id": "363-07-08",
    "owner1": "HOSKEN TR, JOHN M",
    "owner2": "FRIEDLANDER-HOSKEN, NANCY",
    "current_taxes": 13018.38,
    "new_taxes_no_override": 13580.77,
    "override_total_1": 13966.12,
    "override_increase_1": 385.34
  },
  {
    "#": "74 Payson Rd (367-16-00)",
    "$": 1049500,
    "address": "74 Payson Rd",
    "parcel_id": "367-16-00",
    "owner1": "SHEIBANI, FARROKH",
    "owner2": "TAVAKOLI, SAHAR",
    "current_taxes": 7111.95,
    "new_taxes_no_override": 7419.19,
    "override_total_1": 7629.7,
    "override_increase_1": 210.51
  },
  {
    "#": "75 Payson Rd (363-06-00)",
    "$": 1392000,
    "address": "75 Payson Rd",
    "parcel_id": "363-06-00",
    "owner1": "PLATCOW TR, KAREN J",
    "owner2": "",
    "current_taxes": 10619.15,
    "new_taxes_no_override": 11077.9,
    "override_total_1": 11392.22,
    "override_increase_1": 314.33
  },
  {
    "#": "77 Payson Rd (363-05-00)",
    "$": 944400,
    "address": "77 Payson Rd",
    "parcel_id": "363-05-00",
    "owner1": "GEIER, JUDITH A",
    "owner2": "",
    "current_taxes": 6035.72,
    "new_taxes_no_override": 6296.46,
    "override_total_1": 6475.12,
    "override_increase_1": 178.66
  },
  {
    "#": "80 Payson Rd (367-15-00)",
    "$": 1167700,
    "address": "80 Payson Rd",
    "parcel_id": "367-15-00",
    "owner1": "MITCHELL, SANDRA L",
    "owner2": "",
    "current_taxes": 8322.31,
    "new_taxes_no_override": 8681.83,
    "override_total_1": 8928.17,
    "override_increase_1": 246.34
  },
  {
    "#": "83 Payson Rd (363-04-00)",
    "$": 1303700,
    "address": "83 Payson Rd",
    "parcel_id": "363-04-00",
    "owner1": "EFREMOV, IVAN V",
    "owner2": "MARININA, JULIA",
    "current_taxes": 9714.95,
    "new_taxes_no_override": 10134.64,
    "override_total_1": 10422.2,
    "override_increase_1": 287.56
  },
  {
    "#": "87 Payson Rd (363-03-00)",
    "$": 1637500,
    "address": "87 Payson Rd",
    "parcel_id": "363-03-00",
    "owner1": "STANTON TRS, BRIAN JOHN & MAUREEN LIBERTY",
    "owner2": "",
    "current_taxes": 13133.07,
    "new_taxes_no_override": 13700.42,
    "override_total_1": 14089.16,
    "override_increase_1": 388.74
  },
  {
    "#": "93 Payson Rd (363-01-02)",
    "$": 1477800,
    "address": "93 Payson Rd",
    "parcel_id": "363-01-02",
    "owner1": "KVITNITSKY, LEONID A",
    "owner2": "JETTE, JULIE A",
    "current_taxes": 11497.74,
    "new_taxes_no_override": 11994.44,
    "override_total_1": 12334.78,
    "override_increase_1": 340.33
  },
  {
    "#": "97 Payson Rd (365-39-00)",
    "$": 3221100,
    "address": "97 Payson Rd",
    "parcel_id": "365-39-00",
    "owner1": "MIEGEL TRS, ROBERT E",
    "owner2": "LYONS, CHRISTINE A",
    "current_taxes": 29349.13,
    "new_taxes_no_override": 30617.01,
    "override_total_1": 31485.75,
    "override_increase_1": 868.73
  },
  {
    "#": "103 Payson Rd (365-38-00)",
    "$": 1605200,
    "address": "103 Payson Rd",
    "parcel_id": "365-38-00",
    "owner1": "BEN-EZRA, AMRAM & LINDA L",
    "owner2": "",
    "current_taxes": 12802.31,
    "new_taxes_no_override": 13355.37,
    "override_total_1": 13734.32,
    "override_increase_1": 378.95
  },
  {
    "#": "107 Payson Rd (365-37-00)",
    "$": 1422500,
    "address": "107 Payson Rd",
    "parcel_id": "365-37-00",
    "owner1": "HYMAN, JULIAN E & FRANCINE J",
    "owner2": "",
    "current_taxes": 10931.47,
    "new_taxes_no_override": 11403.71,
    "override_total_1": 11727.28,
    "override_increase_1": 323.57
  },
  {
    "#": "110 Payson Rd (366-25-26)",
    "$": 1433500,
    "address": "110 Payson Rd",
    "parcel_id": "366-25-26",
    "owner1": "PEREZ, RICHARD J",
    "owner2": "HUNT, DONNA M",
    "current_taxes": 11044.11,
    "new_taxes_no_override": 11521.22,
    "override_total_1": 11848.12,
    "override_increase_1": 326.91
  },
  {
    "#": "113 Payson Rd (365-36-00)",
    "$": 1289100,
    "address": "113 Payson Rd",
    "parcel_id": "365-36-00",
    "owner1": "SHERMAN-STOKES, SARAH",
    "owner2": "",
    "current_taxes": 9565.45,
    "new_taxes_no_override": 9978.68,
    "override_total_1": 10261.81,
    "override_increase_1": 283.14
  },
  {
    "#": "119 Payson Rd (365-35-00)",
    "$": 1551000,
    "address": "119 Payson Rd",
    "parcel_id": "365-35-00",
    "owner1": "ALLEN, JOSEPH G & MARY KENDA",
    "owner2": "",
    "current_taxes": 12247.31,
    "new_taxes_no_override": 12776.39,
    "override_total_1": 13138.91,
    "override_increase_1": 362.52
  },
  {
    "#": "120 Payson Rd (366-24-00)",
    "$": 1255500,
    "address": "120 Payson Rd",
    "parcel_id": "366-24-00",
    "owner1": "BRILL TRS, GREGORY",
    "owner2": "MOGUN, YELENA",
    "current_taxes": 9221.39,
    "new_taxes_no_override": 9619.75,
    "override_total_1": 9892.71,
    "override_increase_1": 272.95
  },
  {
    "#": "125 Payson Rd (365-34-00)",
    "$": 1219500,
    "address": "125 Payson Rd",
    "parcel_id": "365-34-00",
    "owner1": "MATHEWS, COREY M & REBECCA A",
    "owner2": "",
    "current_taxes": 8852.75,
    "new_taxes_no_override": 9235.19,
    "override_total_1": 9497.23,
    "override_increase_1": 262.04
  },
  {
    "#": "126 Payson Rd (366-23-00)",
    "$": 1350500,
    "address": "126 Payson Rd",
    "parcel_id": "366-23-00",
    "owner1": "COCKBURN, G VICTOR",
    "owner2": "RESNICK, ELIZABETH",
    "current_taxes": 10194.19,
    "new_taxes_no_override": 10634.58,
    "override_total_1": 10936.33,
    "override_increase_1": 301.75
  },
  {
    "#": "129 Payson Rd (365-33-00)",
    "$": 1543100,
    "address": "129 Payson Rd",
    "parcel_id": "365-33-00",
    "owner1": "COOK TRS, LEE FARROW & ROBERT E",
    "owner2": "",
    "current_taxes": 12166.41,
    "new_taxes_no_override": 12692.0,
    "override_total_1": 13052.12,
    "override_increase_1": 360.13
  },
  {
    "#": "132 Payson Rd (366-22-00)",
    "$": 1544200,
    "address": "132 Payson Rd",
    "parcel_id": "366-22-00",
    "owner1": "BERGER TRS, STEPHEN A & LISA Z",
    "owner2": "",
    "current_taxes": 12177.67,
    "new_taxes_no_override": 12703.75,
    "override_total_1": 13064.2,
    "override_increase_1": 360.46
  },
  {
    "#": "133 Payson Rd (365-32-00)",
    "$": 1263200,
    "address": "133 Payson Rd",
    "parcel_id": "365-32-00",
    "owner1": "REYNOSO, HUMBERTO",
    "owner2": "ROSEN, MYRA",
    "current_taxes": 9300.23,
    "new_taxes_no_override": 9702.0,
    "override_total_1": 9977.29,
    "override_increase_1": 275.29
  },
  {
    "#": "138 Payson Rd (366-21-00)",
    "$": 1313500,
    "address": "138 Payson Rd",
    "parcel_id": "366-21-00",
    "owner1": "FILINE, EUGUENI & TATIANA",
    "owner2": "",
    "current_taxes": 9815.31,
    "new_taxes_no_override": 10239.33,
    "override_total_1": 10529.86,
    "override_increase_1": 290.53
  },
  {
    "#": "141 Payson Rd (365-31-00)",
    "$": 1140100,
    "address": "141 Payson Rd",
    "parcel_id": "365-31-00",
    "owner1": "DELICHATSIOS TRS, HELEN K",
    "owner2": "",
    "current_taxes": 8039.69,
    "new_taxes_no_override": 8387.0,
    "override_total_1": 8624.98,
    "override_increase_1": 237.97
  },
  {
    "#": "144 Payson Rd (366-20-01)",
    "$": 1557700,
    "address": "144 Payson Rd",
    "parcel_id": "366-20-01",
    "owner1": "DEEGAN, SEAMUS",
    "owner2": "GANNAWAY, AMANDA",
    "current_taxes": 12315.91,
    "new_taxes_no_override": 12847.96,
    "override_total_1": 13212.51,
    "override_increase_1": 364.55
  },
  {
    "#": "147 Payson Rd (365-30-00)",
    "$": 961000,
    "address": "147 Payson Rd",
    "parcel_id": "365-30-00",
    "owner1": "KING, MARTHA",
    "owner2": "",
    "current_taxes": 6205.71,
    "new_taxes_no_override": 6473.8,
    "override_total_1": 6657.49,
    "override_increase_1": 183.69
  },
  {
    "#": "150 Payson Rd (366-20-00)",
    "$": 1213800,
    "address": "150 Payson Rd",
    "parcel_id": "366-20-00",
    "owner1": "CLARK, JONATHAN & KITTY R",
    "owner2": "",
    "current_taxes": 8794.38,
    "new_taxes_no_override": 9174.3,
    "override_total_1": 9434.61,
    "override_increase_1": 260.31
  },
  {
    "#": "151 Payson Rd (365-29-00)",
    "$": 1316500,
    "address": "151 Payson Rd",
    "parcel_id": "365-29-00",
    "owner1": "JONES TRS, JOSEPH FERNAL & KRISTIN",
    "owner2": "",
    "current_taxes": 9846.03,
    "new_taxes_no_override": 10271.38,
    "override_total_1": 10562.82,
    "override_increase_1": 291.44
  },
  {
    "#": "158 Payson Rd (366-19-00)",
    "$": 1163500,
    "address": "158 Payson Rd",
    "parcel_id": "366-19-00",
    "owner1": "WEINREICH, MICHAEL",
    "owner2": "LINDVALL, CHARLOTTA",
    "current_taxes": 8279.31,
    "new_taxes_no_override": 8636.98,
    "override_total_1": 8882.04,
    "override_increase_1": 245.07
  },
  {
    "#": "159 Payson Rd (365-28-00)",
    "$": 1076600,
    "address": "159 Payson Rd",
    "parcel_id": "365-28-00",
    "owner1": "CHANG, JONATHAN WEI JI",
    "owner2": "",
    "current_taxes": 7389.45,
    "new_taxes_no_override": 7708.67,
    "override_total_1": 7927.4,
    "override_increase_1": 218.73
  },
  {
    "#": "161 Payson Rd (365-27-01)",
    "$": 21800,
    "address": "161 Payson Rd",
    "parcel_id": "365-27-01",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O VACANT PARCEL/ABUT 811 W RXBRY",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "162 Payson Rd (366-18-00)",
    "$": 1054200,
    "address": "162 Payson Rd",
    "parcel_id": "366-18-00",
    "owner1": "MARTIN, JOY M",
    "owner2": "",
    "current_taxes": 7160.07,
    "new_taxes_no_override": 7469.39,
    "override_total_1": 7681.32,
    "override_increase_1": 211.94
  },
  {
    "#": "166 Payson Rd (366-17-00)",
    "$": 140700,
    "address": "166 Payson Rd",
    "parcel_id": "366-17-00",
    "owner1": "SOLINGA TRS, ROBERT MARCEL & ELIZABETH MARKLE",
    "owner2": "",
    "current_taxes": 1440.77,
    "new_taxes_no_override": 1503.01,
    "override_total_1": 1545.66,
    "override_increase_1": 42.65
  },
  {
    "#": "168 Payson Rd (366-17-01)",
    "$": 800,
    "address": "168 Payson Rd",
    "parcel_id": "366-17-01",
    "owner1": "KOSEBUTZKI, WALTER & ROBIN",
    "owner2": "",
    "current_taxes": 8.19,
    "new_taxes_no_override": 8.54,
    "override_total_1": 8.79,
    "override_increase_1": 0.24
  },
  {
    "#": "72 Penniman Pl (267-15-16)",
    "$": 3366900,
    "address": "72 Penniman Pl",
    "parcel_id": "267-15-16",
    "owner1": "COLLINS, GREGORY",
    "owner2": "DOLPHIN, SUSAN",
    "current_taxes": 30842.12,
    "new_taxes_no_override": 32174.5,
    "override_total_1": 33087.43,
    "override_increase_1": 912.93
  },
  {
    "#": "83 Penniman Pl (267-14-00)",
    "$": 4855700,
    "address": "83 Penniman Pl",
    "parcel_id": "267-14-00",
    "owner1": "TRINGAS, JAMES M & DAWN S",
    "owner2": "",
    "current_taxes": 49722.37,
    "new_taxes_no_override": 51870.38,
    "override_total_1": 53342.16,
    "override_increase_1": 1471.78
  },
  {
    "#": "8 Penniman Rd (263-03-00)",
    "$": 3081600,
    "address": "8 Penniman Rd",
    "parcel_id": "263-03-00",
    "owner1": "DOGGETT, JOHN",
    "owner2": "",
    "current_taxes": 27920.65,
    "new_taxes_no_override": 29126.82,
    "override_total_1": 29953.27,
    "override_increase_1": 826.45
  },
  {
    "#": "9 Penniman Rd (262-05-00)",
    "$": 3559200,
    "address": "9 Penniman Rd",
    "parcel_id": "262-05-00",
    "owner1": "KRAEMER, TIM & CAMERON",
    "owner2": "",
    "current_taxes": 32811.27,
    "new_taxes_no_override": 34228.72,
    "override_total_1": 35199.93,
    "override_increase_1": 971.21
  },
  {
    "#": "15 Penniman Rd (262-06-00)",
    "$": 3604600,
    "address": "15 Penniman Rd",
    "parcel_id": "262-06-00",
    "owner1": "SHER TRS, PHILIP J",
    "owner2": "BASS, MICHAEL A",
    "current_taxes": 33276.17,
    "new_taxes_no_override": 34713.7,
    "override_total_1": 35698.68,
    "override_increase_1": 984.97
  },
  {
    "#": "18 Penniman Rd (263-01-02)",
    "$": 3542400,
    "address": "18 Penniman Rd",
    "parcel_id": "263-01-02",
    "owner1": "FRANK TR, JILLIAN B",
    "owner2": "",
    "current_taxes": 32639.24,
    "new_taxes_no_override": 34049.26,
    "override_total_1": 35015.38,
    "override_increase_1": 966.12
  },
  {
    "#": "21 Penniman Rd (262-07-00)",
    "$": 3642800,
    "address": "21 Penniman Rd",
    "parcel_id": "262-07-00",
    "owner1": "COHEN, KIMBERLY E",
    "owner2": "BENN, SUSANNA C",
    "current_taxes": 33667.34,
    "new_taxes_no_override": 35121.77,
    "override_total_1": 36118.32,
    "override_increase_1": 996.55
  },
  {
    "#": "44 Penniman Rd (259-04-00)",
    "$": 3994200,
    "address": "44 Penniman Rd",
    "parcel_id": "259-04-00",
    "owner1": "FRIEDMAN TRS, DAVID J",
    "owner2": "WEXLER TR, DEBORAH J",
    "current_taxes": 37265.67,
    "new_taxes_no_override": 38875.55,
    "override_total_1": 39978.61,
    "override_increase_1": 1103.06
  },
  {
    "#": "47 Penniman Rd (260-02-00)",
    "$": 2551300,
    "address": "47 Penniman Rd",
    "parcel_id": "260-02-00",
    "owner1": "LASSEY TRS, BRADFORD STEPHEN & SARAH CONNOR",
    "owner2": "",
    "current_taxes": 22490.38,
    "new_taxes_no_override": 23461.96,
    "override_total_1": 24127.68,
    "override_increase_1": 665.72
  },
  {
    "#": "55 Penniman Rd (260-03-00)",
    "$": 3613000,
    "address": "55 Penniman Rd",
    "parcel_id": "260-03-00",
    "owner1": "MARTLAND, DAVID & TERESA A",
    "owner2": "",
    "current_taxes": 33362.19,
    "new_taxes_no_override": 34803.44,
    "override_total_1": 35790.96,
    "override_increase_1": 987.52
  },
  {
    "#": "1 Perrin Rd (329-09-00)",
    "$": 2720000,
    "address": "1 Perrin Rd",
    "parcel_id": "329-09-00",
    "owner1": "GRAVEREAUX TRS, EDWIN C",
    "owner2": "KIM, JEAN J",
    "current_taxes": 24217.87,
    "new_taxes_no_override": 25264.08,
    "override_total_1": 25980.93,
    "override_increase_1": 716.85
  },
  {
    "#": "2 Perrin Rd (329-06-00)",
    "$": 2911600,
    "address": "2 Perrin Rd",
    "parcel_id": "329-06-00",
    "owner1": "BERZ, JONATHAN P B & JENNIFER",
    "owner2": "",
    "current_taxes": 26179.85,
    "new_taxes_no_override": 27310.82,
    "override_total_1": 28085.74,
    "override_increase_1": 774.92
  },
  {
    "#": "3 Perrin Rd (329-08-00)",
    "$": 2877300,
    "address": "3 Perrin Rd",
    "parcel_id": "329-08-00",
    "owner1": "KAUFMAN, DAVID ROSS",
    "owner2": "KAHN, NICOLE AUDREY",
    "current_taxes": 25828.62,
    "new_taxes_no_override": 26944.42,
    "override_total_1": 27708.94,
    "override_increase_1": 764.53
  },
  {
    "#": "5 Perrin Rd (329-07-00)",
    "$": 4171000,
    "address": "5 Perrin Rd",
    "parcel_id": "329-07-00",
    "owner1": "MARK, COLEMAN",
    "owner2": "",
    "current_taxes": 39076.11,
    "new_taxes_no_override": 40764.2,
    "override_total_1": 41920.85,
    "override_increase_1": 1156.65
  },
  {
    "#": "4 Perry St, Unit 1 (149-21-01)",
    "$": 2170200,
    "address": "4 Perry St, Unit 1",
    "parcel_id": "149-21-01",
    "owner1": "FREY, TOMER B",
    "owner2": "PERETZMAN, MAYA H",
    "current_taxes": 18587.91,
    "new_taxes_no_override": 19390.91,
    "override_total_1": 19941.11,
    "override_increase_1": 550.2
  },
  {
    "#": "4 Perry St, Unit 2 (149-21-02)",
    "$": 1093300,
    "address": "4 Perry St, Unit 2",
    "parcel_id": "149-21-02",
    "owner1": "TSANG, JENNIFER",
    "owner2": "SATINSKY, BRANDON",
    "current_taxes": 7560.46,
    "new_taxes_no_override": 7887.07,
    "override_total_1": 8110.86,
    "override_increase_1": 223.79
  },
  {
    "#": "6 Perry St, Unit 1 (149-20-08)",
    "$": 561100,
    "address": "6 Perry St, Unit 1",
    "parcel_id": "149-20-08",
    "owner1": "COHEN, DEBORAH",
    "owner2": "",
    "current_taxes": 2110.73,
    "new_taxes_no_override": 2201.91,
    "override_total_1": 2264.39,
    "override_increase_1": 62.48
  },
  {
    "#": "6 Perry St, Unit 2 (149-20-01)",
    "$": 562100,
    "address": "6 Perry St, Unit 2",
    "parcel_id": "149-20-01",
    "owner1": "SINGH, PRATAP",
    "owner2": "NGUYEN, TAM",
    "current_taxes": 5755.9,
    "new_taxes_no_override": 6004.55,
    "override_total_1": 6174.93,
    "override_increase_1": 170.37
  },
  {
    "#": "6 Perry St, Unit 3 (149-20-02)",
    "$": 645800,
    "address": "6 Perry St, Unit 3",
    "parcel_id": "149-20-02",
    "owner1": "SINGH, PRATAP",
    "owner2": "NGUYEN, TAM H",
    "current_taxes": 6612.99,
    "new_taxes_no_override": 6898.67,
    "override_total_1": 7094.42,
    "override_increase_1": 195.74
  },
  {
    "#": "6 Perry St, Unit 4 (149-20-03)",
    "$": 641300,
    "address": "6 Perry St, Unit 4",
    "parcel_id": "149-20-03",
    "owner1": "NG, ET AL, KAREN S",
    "owner2": "",
    "current_taxes": 2931.98,
    "new_taxes_no_override": 3058.64,
    "override_total_1": 3145.43,
    "override_increase_1": 86.79
  },
  {
    "#": "6 Perry St, Unit 5 (149-20-04)",
    "$": 652900,
    "address": "6 Perry St, Unit 5",
    "parcel_id": "149-20-04",
    "owner1": "XU, DAOSONG",
    "owner2": "KONG, TIANQING",
    "current_taxes": 6685.7,
    "new_taxes_no_override": 6974.52,
    "override_total_1": 7172.42,
    "override_increase_1": 197.9
  },
  {
    "#": "6 Perry St, Unit 6 (149-20-05)",
    "$": 641400,
    "address": "6 Perry St, Unit 6",
    "parcel_id": "149-20-05",
    "owner1": "MELTZER, MIRIT MOR BROKMAN & ISHAI",
    "owner2": "",
    "current_taxes": 6567.94,
    "new_taxes_no_override": 6851.68,
    "override_total_1": 7046.09,
    "override_increase_1": 194.41
  },
  {
    "#": "6 Perry St, Unit 7 (149-20-06)",
    "$": 671300,
    "address": "6 Perry St, Unit 7",
    "parcel_id": "149-20-06",
    "owner1": "GOLDMAN, KATHERINE OPDYKE",
    "owner2": "",
    "current_taxes": 3239.18,
    "new_taxes_no_override": 3379.11,
    "override_total_1": 3474.99,
    "override_increase_1": 95.88
  },
  {
    "#": "6 Perry St, Unit 8 (149-20-07)",
    "$": 641300,
    "address": "6 Perry St, Unit 8",
    "parcel_id": "149-20-07",
    "owner1": "ASCHERIO, ALBERTO",
    "owner2": "",
    "current_taxes": 6566.91,
    "new_taxes_no_override": 6850.6,
    "override_total_1": 7044.98,
    "override_increase_1": 194.38
  },
  {
    "#": "7 Perry St (151-05-00)",
    "$": 2749200,
    "address": "7 Perry St",
    "parcel_id": "151-05-00",
    "owner1": "SPUNT, NATHAN & EMILY",
    "owner2": "",
    "current_taxes": 28151.81,
    "new_taxes_no_override": 29367.97,
    "override_total_1": 30201.26,
    "override_increase_1": 833.29
  },
  {
    "#": "8 Perry St, Unit 1 & P3 (149-19-03)",
    "$": 785000,
    "address": "8 Perry St, Unit 1 & P3",
    "parcel_id": "149-19-03",
    "owner1": "PAVLOVICH, JAMES C & JILL G",
    "owner2": "",
    "current_taxes": 8038.4,
    "new_taxes_no_override": 8385.66,
    "override_total_1": 8623.6,
    "override_increase_1": 237.94
  },
  {
    "#": "8 Perry St, Unit 2 & P2 (149-19-01)",
    "$": 854400,
    "address": "8 Perry St, Unit 2 & P2",
    "parcel_id": "149-19-01",
    "owner1": "PAVLOVICH, JILL G & JAMES C",
    "owner2": "",
    "current_taxes": 8749.06,
    "new_taxes_no_override": 9127.02,
    "override_total_1": 9385.99,
    "override_increase_1": 258.97
  },
  {
    "#": "8 Perry St, Unit 3 & P4 (149-19-02)",
    "$": 957600,
    "address": "8 Perry St, Unit 3 & P4",
    "parcel_id": "149-19-02",
    "owner1": "BUCCI, JOHN P",
    "owner2": "",
    "current_taxes": 6170.89,
    "new_taxes_no_override": 6437.47,
    "override_total_1": 6620.13,
    "override_increase_1": 182.66
  },
  {
    "#": "8 Perry St, Unit P1 (149-19-04)",
    "$": 52600,
    "address": "8 Perry St, Unit P1",
    "parcel_id": "149-19-04",
    "owner1": "SINGH, PRATAP",
    "owner2": "NGUYEN, TAM",
    "current_taxes": 538.62,
    "new_taxes_no_override": 561.89,
    "override_total_1": 577.83,
    "override_increase_1": 15.94
  },
  {
    "#": "8 Perry St, Unit P5 (149-19-05)",
    "$": 52600,
    "address": "8 Perry St, Unit P5",
    "parcel_id": "149-19-05",
    "owner1": "HORAN, ELIZABETH I",
    "owner2": "",
    "current_taxes": 538.62,
    "new_taxes_no_override": 561.89,
    "override_total_1": 577.83,
    "override_increase_1": 15.94
  },
  {
    "#": "9 Perry St (151-05-01)",
    "$": 1930600,
    "address": "9 Perry St",
    "parcel_id": "151-05-01",
    "owner1": "FOLLAND, ROBINA E",
    "owner2": "",
    "current_taxes": 16134.41,
    "new_taxes_no_override": 16831.42,
    "override_total_1": 17309.0,
    "override_increase_1": 477.58
  },
  {
    "#": "12 Perry St (149-18-00)",
    "$": 2168400,
    "address": "12 Perry St",
    "parcel_id": "149-18-00",
    "owner1": "HORAN, MARY L & WILLIAM P",
    "owner2": "DRISCOLL, ELIZABETH G",
    "current_taxes": 22204.42,
    "new_taxes_no_override": 23163.65,
    "override_total_1": 23820.9,
    "override_increase_1": 657.25
  },
  {
    "#": "13 Perry St (151-06-00)",
    "$": 1901600,
    "address": "13 Perry St",
    "parcel_id": "151-06-00",
    "owner1": "WONG TRS, KA LAI",
    "owner2": "YUEN, ANGELA S C",
    "current_taxes": 19472.38,
    "new_taxes_no_override": 20313.59,
    "override_total_1": 20889.97,
    "override_increase_1": 576.38
  },
  {
    "#": "14 Perry St (149-18-01)",
    "$": 1775200,
    "address": "14 Perry St",
    "parcel_id": "149-18-01",
    "owner1": "BOIME TR, DOROTHY ANN",
    "owner2": "",
    "current_taxes": 14543.11,
    "new_taxes_no_override": 15171.37,
    "override_total_1": 15601.85,
    "override_increase_1": 430.48
  },
  {
    "#": "15 Perry St (151-07-00)",
    "$": 1968800,
    "address": "15 Perry St",
    "parcel_id": "151-07-00",
    "owner1": "JOSHI TRS, RAVINDAR K & SUDESH R & JITENDER",
    "owner2": "",
    "current_taxes": 16525.58,
    "new_taxes_no_override": 17239.49,
    "override_total_1": 17728.64,
    "override_increase_1": 489.16
  },
  {
    "#": "17 Perry St, Unit 1 (151-08-10)",
    "$": 640300,
    "address": "17 Perry St, Unit 1",
    "parcel_id": "151-08-10",
    "owner1": "WHITE, KATHARINE E-DAN S-NANCY P",
    "owner2": "",
    "current_taxes": 2921.74,
    "new_taxes_no_override": 3047.96,
    "override_total_1": 3134.44,
    "override_increase_1": 86.48
  },
  {
    "#": "17 Perry St, Unit 2 (151-08-11)",
    "$": 697700,
    "address": "17 Perry St, Unit 2",
    "parcel_id": "151-08-11",
    "owner1": "DAMATO, LISA",
    "owner2": "",
    "current_taxes": 7144.45,
    "new_taxes_no_override": 7453.09,
    "override_total_1": 7664.57,
    "override_increase_1": 211.48
  },
  {
    "#": "17 Perry St, Unit 3 (151-08-12)",
    "$": 764100,
    "address": "17 Perry St, Unit 3",
    "parcel_id": "151-08-12",
    "owner1": "KARKARE, KIRIT",
    "owner2": "RAMSEY, ELISABETH",
    "current_taxes": 7824.38,
    "new_taxes_no_override": 8162.39,
    "override_total_1": 8393.99,
    "override_increase_1": 231.6
  },
  {
    "#": "19 Perry St, Unit 1 & Sp 1 (151-08-04)",
    "$": 1038600,
    "address": "19 Perry St, Unit 1 & Sp 1",
    "parcel_id": "151-08-04",
    "owner1": "DUBREUIL, CATHERINE I",
    "owner2": "REYNOLDS, TYLER R",
    "current_taxes": 7000.33,
    "new_taxes_no_override": 7302.74,
    "override_total_1": 7509.95,
    "override_increase_1": 207.21
  },
  {
    "#": "19 Perry St, Unit 2 & P2 (151-08-05)",
    "$": 830100,
    "address": "19 Perry St, Unit 2 & P2",
    "parcel_id": "151-08-05",
    "owner1": "NG, KARBERT",
    "owner2": "LYNCH, REBECCA",
    "current_taxes": 4865.29,
    "new_taxes_no_override": 5075.47,
    "override_total_1": 5219.48,
    "override_increase_1": 144.01
  },
  {
    "#": "19 Perry St, Unit 3 Pk 3A-3B (151-08-06)",
    "$": 1063700,
    "address": "19 Perry St, Unit 3 Pk 3A-3B",
    "parcel_id": "151-08-06",
    "owner1": "MALTZ, RACHEL B",
    "owner2": "",
    "current_taxes": 7257.35,
    "new_taxes_no_override": 7570.87,
    "override_total_1": 7785.69,
    "override_increase_1": 214.82
  },
  {
    "#": "20 Perry St, Unit 1 (149-03-01)",
    "$": 540500,
    "address": "20 Perry St, Unit 1",
    "parcel_id": "149-03-01",
    "owner1": "LI, XIAO",
    "owner2": "",
    "current_taxes": 5534.72,
    "new_taxes_no_override": 5773.82,
    "override_total_1": 5937.65,
    "override_increase_1": 163.83
  },
  {
    "#": "20 Perry St, Unit 2 (149-03-02)",
    "$": 602700,
    "address": "20 Perry St, Unit 2",
    "parcel_id": "149-03-02",
    "owner1": "TIEMEIER, HENNING",
    "owner2": "",
    "current_taxes": 2536.71,
    "new_taxes_no_override": 2646.3,
    "override_total_1": 2721.38,
    "override_increase_1": 75.09
  },
  {
    "#": "20 Perry St, Unit 3 (149-03-03)",
    "$": 676800,
    "address": "20 Perry St, Unit 3",
    "parcel_id": "149-03-03",
    "owner1": "HORNG, TIFFANY",
    "owner2": "",
    "current_taxes": 6930.43,
    "new_taxes_no_override": 7229.82,
    "override_total_1": 7434.97,
    "override_increase_1": 205.14
  },
  {
    "#": "22 Perry St, Unit 1 (149-02-01)",
    "$": 602000,
    "address": "22 Perry St, Unit 1",
    "parcel_id": "149-02-01",
    "owner1": "XIA, JIN J",
    "owner2": "",
    "current_taxes": 6164.48,
    "new_taxes_no_override": 6430.79,
    "override_total_1": 6613.25,
    "override_increase_1": 182.47
  },
  {
    "#": "22 Perry St, Unit 2 (149-02-02)",
    "$": 609200,
    "address": "22 Perry St, Unit 2",
    "parcel_id": "149-02-02",
    "owner1": "SENDEROVICH, IGOR",
    "owner2": "NEDER, KINGA",
    "current_taxes": 2603.27,
    "new_taxes_no_override": 2715.73,
    "override_total_1": 2792.79,
    "override_increase_1": 77.06
  },
  {
    "#": "22 Perry St, Unit 3 (149-02-03)",
    "$": 695200,
    "address": "22 Perry St, Unit 3",
    "parcel_id": "149-02-03",
    "owner1": "CHEN, SHENGYING",
    "owner2": "WANG, DONGYU",
    "current_taxes": 7118.85,
    "new_taxes_no_override": 7426.38,
    "override_total_1": 7637.1,
    "override_increase_1": 210.72
  },
  {
    "#": "30 Perry St (153-01-00)",
    "$": 2280200,
    "address": "30 Perry St",
    "parcel_id": "153-01-00",
    "owner1": "SNEIDER, RUTHANN",
    "owner2": "",
    "current_taxes": 19714.31,
    "new_taxes_no_override": 20565.97,
    "override_total_1": 21149.51,
    "override_increase_1": 583.54
  },
  {
    "#": "31 Perry St (152-07-00)",
    "$": 2176900,
    "address": "31 Perry St",
    "parcel_id": "152-07-00",
    "owner1": "OLSON, BENJAMIN H",
    "owner2": "",
    "current_taxes": 18656.52,
    "new_taxes_no_override": 19462.48,
    "override_total_1": 20014.71,
    "override_increase_1": 552.23
  },
  {
    "#": "34 Perry St (153-20-00)",
    "$": 2668400,
    "address": "34 Perry St",
    "parcel_id": "153-20-00",
    "owner1": "MUCHA TR, WALTER R",
    "owner2": "",
    "current_taxes": 23689.48,
    "new_taxes_no_override": 24712.87,
    "override_total_1": 25414.07,
    "override_increase_1": 701.21
  },
  {
    "#": "37 Perry St, Unit 1 & P1 (152-08-01)",
    "$": 940900,
    "address": "37 Perry St, Unit 1 & P1",
    "parcel_id": "152-08-01",
    "owner1": "DE LOS SANTOS, ANNA ORSOLA",
    "owner2": "",
    "current_taxes": 5999.88,
    "new_taxes_no_override": 6259.07,
    "override_total_1": 6436.67,
    "override_increase_1": 177.6
  },
  {
    "#": "37 Perry St, Unit 2 & P2 (152-08-02)",
    "$": 1179300,
    "address": "37 Perry St, Unit 2 & P2",
    "parcel_id": "152-08-02",
    "owner1": "LEURENT, CLAIRE",
    "owner2": "",
    "current_taxes": 8441.1,
    "new_taxes_no_override": 8805.76,
    "override_total_1": 9055.61,
    "override_increase_1": 249.86
  },
  {
    "#": "37 Perry St, Unit 3 (152-08-03)",
    "$": 1138700,
    "address": "37 Perry St, Unit 3",
    "parcel_id": "152-08-03",
    "owner1": "GRANDFIELD, MICHAEL P",
    "owner2": "",
    "current_taxes": 8025.35,
    "new_taxes_no_override": 8372.05,
    "override_total_1": 8609.6,
    "override_increase_1": 237.55
  },
  {
    "#": "39 Perry St (152-09-00)",
    "$": 2286200,
    "address": "39 Perry St",
    "parcel_id": "152-09-00",
    "owner1": "PROSPEROUS PERRY LLC",
    "owner2": "",
    "current_taxes": 23410.69,
    "new_taxes_no_override": 24422.03,
    "override_total_1": 25114.99,
    "override_increase_1": 692.96
  },
  {
    "#": "40 Perry St (153-19-00)",
    "$": 2859700,
    "address": "40 Perry St",
    "parcel_id": "153-19-00",
    "owner1": "HOLZWORTH, DARLENE K",
    "owner2": "",
    "current_taxes": 25648.39,
    "new_taxes_no_override": 26756.4,
    "override_total_1": 27515.59,
    "override_increase_1": 759.19
  },
  {
    "#": "56 Perry St, Unit 1 (132-25-01)",
    "$": 1728400,
    "address": "56 Perry St, Unit 1",
    "parcel_id": "132-25-01",
    "owner1": "YAJNIK, AMOL R",
    "owner2": "KARIV, KAREN D",
    "current_taxes": 14063.88,
    "new_taxes_no_override": 14671.44,
    "override_total_1": 15087.73,
    "override_increase_1": 416.29
  },
  {
    "#": "56 Perry St, Unit 2 (132-25-02)",
    "$": 1733800,
    "address": "56 Perry St, Unit 2",
    "parcel_id": "132-25-02",
    "owner1": "STEINBERG, PETER LANG",
    "owner2": "JUILLARD, HELENE",
    "current_taxes": 14119.18,
    "new_taxes_no_override": 14729.13,
    "override_total_1": 15147.06,
    "override_increase_1": 417.93
  },
  {
    "#": "56 Perry St, Unit 3 (132-25-03)",
    "$": 1902600,
    "address": "56 Perry St, Unit 3",
    "parcel_id": "132-25-03",
    "owner1": "SNYDER SAMUELS, EMILY G",
    "owner2": "",
    "current_taxes": 19482.62,
    "new_taxes_no_override": 20324.27,
    "override_total_1": 20900.95,
    "override_increase_1": 576.69
  },
  {
    "#": "56 Perry St, Unit 4 (132-25-04)",
    "$": 1899800,
    "address": "56 Perry St, Unit 4",
    "parcel_id": "132-25-04",
    "owner1": "LUKITSH, NANCY",
    "owner2": "METCALFE, CLAIRE",
    "current_taxes": 15819.02,
    "new_taxes_no_override": 16502.4,
    "override_total_1": 16970.64,
    "override_increase_1": 468.24
  },
  {
    "#": "57 Perry St (131-06-00)",
    "$": 2134800,
    "address": "57 Perry St",
    "parcel_id": "131-06-00",
    "owner1": "DOUGHTY, DENNIS",
    "owner2": "ROSENSTOCK, CAROL J",
    "current_taxes": 18225.42,
    "new_taxes_no_override": 19012.76,
    "override_total_1": 19552.23,
    "override_increase_1": 539.47
  },
  {
    "#": "63 Perry St (131-07-00)",
    "$": 2913000,
    "address": "63 Perry St",
    "parcel_id": "131-07-00",
    "owner1": "KERNER TRS, JONATHAN H & JENNIFER KAPLAN",
    "owner2": "",
    "current_taxes": 26194.19,
    "new_taxes_no_override": 27325.78,
    "override_total_1": 28101.13,
    "override_increase_1": 775.35
  },
  {
    "#": "64 Perry St (132-20-00)",
    "$": 1790600,
    "address": "64 Perry St",
    "parcel_id": "132-20-00",
    "owner1": "MCINTOSH TRS, NATHALIE",
    "owner2": "HILTEBRANDT, GODFREY",
    "current_taxes": 14700.81,
    "new_taxes_no_override": 15335.88,
    "override_total_1": 15771.03,
    "override_increase_1": 435.14
  },
  {
    "#": "66 Perry St, Unit 1 (132-24-01)",
    "$": 2751100,
    "address": "66 Perry St, Unit 1",
    "parcel_id": "132-24-01",
    "owner1": "CECALA, SAMUEL C & KATHARINE A",
    "owner2": "",
    "current_taxes": 24536.33,
    "new_taxes_no_override": 25596.3,
    "override_total_1": 26322.57,
    "override_increase_1": 726.28
  },
  {
    "#": "66 Perry St, Unit 2 (132-24-02)",
    "$": 2972200,
    "address": "66 Perry St, Unit 2",
    "parcel_id": "132-24-02",
    "owner1": "ZHAO TR, YULI",
    "owner2": "",
    "current_taxes": 26800.39,
    "new_taxes_no_override": 27958.17,
    "override_total_1": 28751.46,
    "override_increase_1": 793.29
  },
  {
    "#": "67 Perry St (131-08-00)",
    "$": 3190200,
    "address": "67 Perry St",
    "parcel_id": "131-08-00",
    "owner1": "TVETERAAS, ANDERS & ANASTASYA PARTAN",
    "owner2": "",
    "current_taxes": 29032.71,
    "new_taxes_no_override": 30286.92,
    "override_total_1": 31146.29,
    "override_increase_1": 859.37
  },
  {
    "#": "70 Perry St (132-23-00)",
    "$": 2593500,
    "address": "70 Perry St",
    "parcel_id": "132-23-00",
    "owner1": "BONFILIO TRS, EDWARD & CLAIRE",
    "owner2": "",
    "current_taxes": 22922.51,
    "new_taxes_no_override": 23912.76,
    "override_total_1": 24591.27,
    "override_increase_1": 678.51
  },
  {
    "#": "71 Perry St, Unit A (131-09-01)",
    "$": 1558200,
    "address": "71 Perry St, Unit A",
    "parcel_id": "131-09-01",
    "owner1": "WOLOSENKO, JEREMA E & DANUTE E",
    "owner2": "",
    "current_taxes": 12321.03,
    "new_taxes_no_override": 12853.3,
    "override_total_1": 13218.0,
    "override_increase_1": 364.7
  },
  {
    "#": "73 Perry St, Unit 73 (131-09-02)",
    "$": 1565900,
    "address": "73 Perry St, Unit 73",
    "parcel_id": "131-09-02",
    "owner1": "HUDSON, ROBERT E & JANET R",
    "owner2": "",
    "current_taxes": 12399.88,
    "new_taxes_no_override": 12935.55,
    "override_total_1": 13302.59,
    "override_increase_1": 367.04
  },
  {
    "#": "74 Perry St, Unit 1 (132-21-01)",
    "$": 2242900,
    "address": "74 Perry St, Unit 1",
    "parcel_id": "132-21-01",
    "owner1": "HEYMAN, LEIGH D",
    "owner2": "HOROWITZ HEYMAN, ILISA C",
    "current_taxes": 19332.36,
    "new_taxes_no_override": 20167.52,
    "override_total_1": 20739.76,
    "override_increase_1": 572.24
  },
  {
    "#": "74 Perry St, Unit 2 (132-21-02)",
    "$": 2242900,
    "address": "74 Perry St, Unit 2",
    "parcel_id": "132-21-02",
    "owner1": "MAHMOOD, SYED KASHIF & SADIA",
    "owner2": "",
    "current_taxes": 19332.36,
    "new_taxes_no_override": 20167.52,
    "override_total_1": 20739.76,
    "override_increase_1": 572.24
  },
  {
    "#": "76 Perry St (132-17-00)",
    "$": 1376300,
    "address": "76 Perry St",
    "parcel_id": "132-17-00",
    "owner1": "BERMAN, ANN",
    "owner2": "",
    "current_taxes": 10458.38,
    "new_taxes_no_override": 10910.18,
    "override_total_1": 11219.75,
    "override_increase_1": 309.57
  },
  {
    "#": "77 Perry St (131-10-00)",
    "$": 2146100,
    "address": "77 Perry St",
    "parcel_id": "131-10-00",
    "owner1": "ROTHMAN, MICHAEL",
    "owner2": "CHOI, ELISABETH",
    "current_taxes": 18341.13,
    "new_taxes_no_override": 19133.47,
    "override_total_1": 19676.36,
    "override_increase_1": 542.9
  },
  {
    "#": "78 Perry St (132-22-00)",
    "$": 91700,
    "address": "78 Perry St",
    "parcel_id": "132-22-00",
    "owner1": "BONFILIO TRS, EDWARD & CLAIRE",
    "owner2": "",
    "current_taxes": 939.01,
    "new_taxes_no_override": 979.58,
    "override_total_1": 1007.37,
    "override_increase_1": 27.79
  },
  {
    "#": "80 Perry St (132-15-00)",
    "$": 2688500,
    "address": "80 Perry St",
    "parcel_id": "132-15-00",
    "owner1": "XU, JIN",
    "owner2": "HAN, JINYU",
    "current_taxes": 23895.31,
    "new_taxes_no_override": 24927.59,
    "override_total_1": 25634.89,
    "override_increase_1": 707.3
  },
  {
    "#": "81 Perry St (131-11-00)",
    "$": 1934800,
    "address": "81 Perry St",
    "parcel_id": "131-11-00",
    "owner1": "ZANER, KEN SCOTT",
    "owner2": "MARTIN-ZANER, BERNICE M",
    "current_taxes": 16177.42,
    "new_taxes_no_override": 16876.28,
    "override_total_1": 17355.14,
    "override_increase_1": 478.85
  },
  {
    "#": "82 Perry St, Unit 1 (132-14-02)",
    "$": 1000100,
    "address": "82 Perry St, Unit 1",
    "parcel_id": "132-14-02",
    "owner1": "GELWAN, ELIOT",
    "owner2": "HAMM, BARBARA C",
    "current_taxes": 6606.09,
    "new_taxes_no_override": 6891.47,
    "override_total_1": 7087.01,
    "override_increase_1": 195.54
  },
  {
    "#": "82 Perry St, Unit 2 (132-14-01)",
    "$": 1008300,
    "address": "82 Perry St, Unit 2",
    "parcel_id": "132-14-01",
    "owner1": "WAGNER, ET AL, MILES",
    "owner2": "",
    "current_taxes": 6690.06,
    "new_taxes_no_override": 6979.07,
    "override_total_1": 7177.1,
    "override_increase_1": 198.03
  },
  {
    "#": "85 Perry St (131-12-00)",
    "$": 2348900,
    "address": "85 Perry St",
    "parcel_id": "131-12-00",
    "owner1": "DUKAKIS TRS, JOHN C",
    "owner2": "CAPE COD FIVE CENTS SAVINGS BANK",
    "current_taxes": 24052.74,
    "new_taxes_no_override": 25091.82,
    "override_total_1": 25803.78,
    "override_increase_1": 711.96
  },
  {
    "#": "87 Perry St (131-12-01)",
    "$": 2635200,
    "address": "87 Perry St",
    "parcel_id": "131-12-01",
    "owner1": "NGUYEN, PAUL",
    "owner2": "KOO, SOPHIA",
    "current_taxes": 23349.51,
    "new_taxes_no_override": 24358.21,
    "override_total_1": 25049.35,
    "override_increase_1": 691.15
  },
  {
    "#": "93 Perry St, Unit 1 (131-13-01)",
    "$": 1254200,
    "address": "93 Perry St, Unit 1",
    "parcel_id": "131-13-01",
    "owner1": "ELLSWORTH, GEORGE A & MARA N",
    "owner2": "",
    "current_taxes": 9208.07,
    "new_taxes_no_override": 9605.86,
    "override_total_1": 9878.42,
    "override_increase_1": 272.56
  },
  {
    "#": "93 Perry St, Unit 2 (131-13-02)",
    "$": 1264800,
    "address": "93 Perry St, Unit 2",
    "parcel_id": "131-13-02",
    "owner1": "HUYGHUE TRS, ARMER J  & CYNTHIA",
    "owner2": "",
    "current_taxes": 9316.62,
    "new_taxes_no_override": 9719.1,
    "override_total_1": 9994.87,
    "override_increase_1": 275.77
  },
  {
    "#": "93 Perry St, Unit 3 (131-13-03)",
    "$": 1304500,
    "address": "93 Perry St, Unit 3",
    "parcel_id": "131-13-03",
    "owner1": "CARBONE TR, FRANK J",
    "owner2": "",
    "current_taxes": 9723.15,
    "new_taxes_no_override": 10143.19,
    "override_total_1": 10431.0,
    "override_increase_1": 287.81
  },
  {
    "#": "93 Perry St, Unit 4 (131-13-04)",
    "$": 1304500,
    "address": "93 Perry St, Unit 4",
    "parcel_id": "131-13-04",
    "owner1": "VIDENOVIC, ALEKSANDAR",
    "owner2": "GRACIN, NANCY",
    "current_taxes": 9723.15,
    "new_taxes_no_override": 10143.19,
    "override_total_1": 10431.0,
    "override_increase_1": 287.81
  },
  {
    "#": "93 Perry St, Unit 5 (131-13-05)",
    "$": 1238200,
    "address": "93 Perry St, Unit 5",
    "parcel_id": "131-13-05",
    "owner1": "SCHNEIDER, ERIC C",
    "owner2": "MELTZER, ELLEN",
    "current_taxes": 9044.23,
    "new_taxes_no_override": 9434.94,
    "override_total_1": 9702.65,
    "override_increase_1": 267.71
  },
  {
    "#": "93 Perry St, Unit 6 (131-13-06)",
    "$": 1307400,
    "address": "93 Perry St, Unit 6",
    "parcel_id": "131-13-06",
    "owner1": "VERDELHAN, ADRIEN F",
    "owner2": "ARKIN, KIMBERLY A",
    "current_taxes": 9752.84,
    "new_taxes_no_override": 10174.16,
    "override_total_1": 10462.85,
    "override_increase_1": 288.68
  },
  {
    "#": "94 Perry St, Unit 1 (132-12-04)",
    "$": 839600,
    "address": "94 Perry St, Unit 1",
    "parcel_id": "132-12-04",
    "owner1": "RESNICK, LAWRENCE A",
    "owner2": "",
    "current_taxes": 4962.57,
    "new_taxes_no_override": 5176.95,
    "override_total_1": 5323.85,
    "override_increase_1": 146.89
  },
  {
    "#": "94 Perry St, Unit 2 & P2 (132-12-02)",
    "$": 927200,
    "address": "94 Perry St, Unit 2 & P2",
    "parcel_id": "132-12-02",
    "owner1": "HASS, DOROTHEA",
    "owner2": "CAREY, JOSEPH",
    "current_taxes": 5859.59,
    "new_taxes_no_override": 6112.72,
    "override_total_1": 6286.17,
    "override_increase_1": 173.44
  },
  {
    "#": "94 Perry St, Unit 3 (132-12-03)",
    "$": 1174800,
    "address": "94 Perry St, Unit 3",
    "parcel_id": "132-12-03",
    "owner1": "BARRADAH, HISHAM",
    "owner2": "TAHER, NEVEEN R",
    "current_taxes": 8395.02,
    "new_taxes_no_override": 8757.68,
    "override_total_1": 9006.18,
    "override_increase_1": 248.49
  },
  {
    "#": "99 Perry St, Unit 1 (131-14-07)",
    "$": 714500,
    "address": "99 Perry St, Unit 1",
    "parcel_id": "131-14-07",
    "owner1": "MCHUGH, GEORGE M",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 7316.48,
    "new_taxes_no_override": 7632.55,
    "override_total_1": 7849.12,
    "override_increase_1": 216.57
  },
  {
    "#": "99 Perry St, Unit 2 (131-14-08)",
    "$": 730700,
    "address": "99 Perry St, Unit 2",
    "parcel_id": "131-14-08",
    "owner1": "OSHER, FAWN",
    "owner2": "",
    "current_taxes": 3847.43,
    "new_taxes_no_override": 4013.64,
    "override_total_1": 4127.52,
    "override_increase_1": 113.88
  },
  {
    "#": "99 Perry St, Unit 3 (131-14-09)",
    "$": 722600,
    "address": "99 Perry St, Unit 3",
    "parcel_id": "131-14-09",
    "owner1": "BARRADAH, HISHAM",
    "owner2": "TAHER, NAVEEN",
    "current_taxes": 7399.42,
    "new_taxes_no_override": 7719.07,
    "override_total_1": 7938.1,
    "override_increase_1": 219.02
  },
  {
    "#": "99 Perry St, Unit 4 (131-14-10)",
    "$": 795600,
    "address": "99 Perry St, Unit 4",
    "parcel_id": "131-14-10",
    "owner1": "SLAVKOV, KIRIL",
    "owner2": "DAHA-SLAVKOVA, ELENA",
    "current_taxes": 4512.01,
    "new_taxes_no_override": 4706.93,
    "override_total_1": 4840.48,
    "override_increase_1": 133.56
  },
  {
    "#": "99 Perry St, Unit 5 (131-14-11)",
    "$": 731900,
    "address": "99 Perry St, Unit 5",
    "parcel_id": "131-14-11",
    "owner1": "CHENG TR, SU-CHUN",
    "owner2": "",
    "current_taxes": 3859.72,
    "new_taxes_no_override": 4026.46,
    "override_total_1": 4140.71,
    "override_increase_1": 114.25
  },
  {
    "#": "99 Perry St, Unit 6 (131-14-12)",
    "$": 789300,
    "address": "99 Perry St, Unit 6",
    "parcel_id": "131-14-12",
    "owner1": "KRISHNAN, GOPAL V & JAYA S",
    "owner2": "",
    "current_taxes": 8082.43,
    "new_taxes_no_override": 8431.59,
    "override_total_1": 8670.83,
    "override_increase_1": 239.24
  },
  {
    "#": "3 Philbrick Rd (192-10-00)",
    "$": 2111500,
    "address": "3 Philbrick Rd",
    "parcel_id": "192-10-00",
    "owner1": "KARR LIFE ESTATE, MICHAEL E",
    "owner2": "",
    "current_taxes": 21621.76,
    "new_taxes_no_override": 22555.82,
    "override_total_1": 23195.82,
    "override_increase_1": 640.0
  },
  {
    "#": "19 Philbrick Rd (192-08-00)",
    "$": 2396400,
    "address": "19 Philbrick Rd",
    "parcel_id": "192-08-00",
    "owner1": "DAVIS TR, ELIZABETH A",
    "owner2": "",
    "current_taxes": 20904.2,
    "new_taxes_no_override": 21807.26,
    "override_total_1": 22426.03,
    "override_increase_1": 618.76
  },
  {
    "#": "21 Philbrick Rd (192-12-01)",
    "$": 1859200,
    "address": "21 Philbrick Rd",
    "parcel_id": "192-12-01",
    "owner1": "RESNICK, TR, SUZANNE S",
    "owner2": "",
    "current_taxes": 19038.21,
    "new_taxes_no_override": 19860.66,
    "override_total_1": 20424.19,
    "override_increase_1": 563.53
  },
  {
    "#": "23 Philbrick Rd (192-12-00)",
    "$": 3750600,
    "address": "23 Philbrick Rd",
    "parcel_id": "192-12-00",
    "owner1": "MALLIK, GUARAV",
    "owner2": "ZAVERI, DARSHANA",
    "current_taxes": 34771.21,
    "new_taxes_no_override": 36273.33,
    "override_total_1": 37302.55,
    "override_increase_1": 1029.23
  },
  {
    "#": "36 Philbrick Rd (193-01-00)",
    "$": 27085900,
    "address": "36 Philbrick Rd",
    "parcel_id": "193-01-00",
    "owner1": "MAIMONIDES SCHOOL",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "37 Philbrick Rd (192-13-00)",
    "$": 4219900,
    "address": "37 Philbrick Rd",
    "parcel_id": "192-13-00",
    "owner1": "BAILEY, ALLISON S",
    "owner2": "",
    "current_taxes": 39576.84,
    "new_taxes_no_override": 41286.56,
    "override_total_1": 42458.03,
    "override_increase_1": 1171.47
  },
  {
    "#": "51 Philbrick Rd (192-15-00)",
    "$": 2845300,
    "address": "51 Philbrick Rd",
    "parcel_id": "192-15-00",
    "owner1": "PECK, NATHAN E & JANE M KAPLAN",
    "owner2": "",
    "current_taxes": 25500.94,
    "new_taxes_no_override": 26602.58,
    "override_total_1": 27357.41,
    "override_increase_1": 754.83
  },
  {
    "#": "55 Philbrick Rd (192-16-00)",
    "$": 2886400,
    "address": "55 Philbrick Rd",
    "parcel_id": "192-16-00",
    "owner1": "PLOTKIN, SCOTT R & CANDACE L",
    "owner2": "",
    "current_taxes": 25921.8,
    "new_taxes_no_override": 27041.62,
    "override_total_1": 27808.91,
    "override_increase_1": 767.29
  },
  {
    "#": "11 Pierce St (172-09-00)",
    "$": 10023700,
    "address": "11 Pierce St",
    "parcel_id": "172-09-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O PUBLIC HEALTH CENTER",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "7 Pine Rd (431-07-00)",
    "$": 4302800,
    "address": "7 Pine Rd",
    "parcel_id": "431-07-00",
    "owner1": "RASOOL, SYED FAHEEM",
    "owner2": "HOSSEINI, NEDA S",
    "current_taxes": 44060.67,
    "new_taxes_no_override": 45964.09,
    "override_total_1": 47268.29,
    "override_increase_1": 1304.2
  },
  {
    "#": "18 Pine Rd (432-05-00)",
    "$": 8546900,
    "address": "18 Pine Rd",
    "parcel_id": "432-05-00",
    "owner1": "LEVENTHAL TRS, ALAN M & SHERRY M",
    "owner2": "",
    "current_taxes": 83885.32,
    "new_taxes_no_override": 87509.17,
    "override_total_1": 89992.17,
    "override_increase_1": 2483.01
  },
  {
    "#": "19 Pine Rd (431-07-01)",
    "$": 4884100,
    "address": "19 Pine Rd",
    "parcel_id": "431-07-01",
    "owner1": "KUMAR, MONICA S",
    "owner2": "",
    "current_taxes": 46378.25,
    "new_taxes_no_override": 48381.79,
    "override_total_1": 49754.59,
    "override_increase_1": 1372.8
  },
  {
    "#": "40 Pine Rd (432-04-00)",
    "$": 4701600,
    "address": "40 Pine Rd",
    "parcel_id": "432-04-00",
    "owner1": "LEVENTHAL TRS, ALAN M & SHERRY M",
    "owner2": "",
    "current_taxes": 48144.38,
    "new_taxes_no_override": 50224.22,
    "override_total_1": 51649.29,
    "override_increase_1": 1425.07
  },
  {
    "#": "45 Pine Rd (431-08-00)",
    "$": 4734000,
    "address": "45 Pine Rd",
    "parcel_id": "431-08-00",
    "owner1": "HUGHES TR, WILLIAM S",
    "owner2": "",
    "current_taxes": 44841.23,
    "new_taxes_no_override": 46778.37,
    "override_total_1": 48105.67,
    "override_increase_1": 1327.3
  },
  {
    "#": "62 Pine Rd (432-03-00)",
    "$": 1846900,
    "address": "62 Pine Rd",
    "parcel_id": "432-03-00",
    "owner1": "KRAFT, JONATHAN A & PATRICIA L",
    "owner2": "C/O THE KRAFT GROUP",
    "current_taxes": 18912.26,
    "new_taxes_no_override": 19729.27,
    "override_total_1": 20289.07,
    "override_increase_1": 559.8
  },
  {
    "#": "67 Pine Rd (431-09-00)",
    "$": 3973800,
    "address": "67 Pine Rd",
    "parcel_id": "431-09-00",
    "owner1": "MERTON, ROBERT C",
    "owner2": "",
    "current_taxes": 40691.71,
    "new_taxes_no_override": 42449.59,
    "override_total_1": 43654.07,
    "override_increase_1": 1204.47
  },
  {
    "#": "72 Pine Rd (432-02-00)",
    "$": 3606100,
    "address": "72 Pine Rd",
    "parcel_id": "432-02-00",
    "owner1": "KRAFT TR, JONATHAN & PATRICIA",
    "owner2": "",
    "current_taxes": 36926.46,
    "new_taxes_no_override": 38521.68,
    "override_total_1": 39614.71,
    "override_increase_1": 1093.02
  },
  {
    "#": "10 Pleasant St (045-01-00)",
    "$": 9500000,
    "address": "10 Pleasant St",
    "parcel_id": "045-01-00",
    "owner1": "CHR PLEASANT LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 163020.0,
    "new_taxes_no_override": 170062.46,
    "override_total_1": 174887.86,
    "override_increase_1": 4825.39
  },
  {
    "#": "26 Pleasant St (046-20-00)",
    "$": 2899200,
    "address": "26 Pleasant St",
    "parcel_id": "046-20-00",
    "owner1": "NORDBLOM, ET AL TRS, ROBERT C",
    "owner2": "",
    "current_taxes": 29687.81,
    "new_taxes_no_override": 30970.32,
    "override_total_1": 31849.08,
    "override_increase_1": 878.76
  },
  {
    "#": "31 Pleasant St (044-05-00)",
    "$": 10905300,
    "address": "31 Pleasant St",
    "parcel_id": "044-05-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O LIBRARY/COOLIDGE CRNR BRANCH",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "50 Pleasant St (046-17-00)",
    "$": 20249800,
    "address": "50 Pleasant St",
    "parcel_id": "046-17-00",
    "owner1": "BROOKLINE HOUSING AUTHORITY",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "57 Pleasant St, Unit 1 & P1-G8 (043-20-01)",
    "$": 1124000,
    "address": "57 Pleasant St, Unit 1 & P1-G8",
    "parcel_id": "043-20-01",
    "owner1": "TAPPER  TR, ELIZABETH A",
    "owner2": "",
    "current_taxes": 7874.83,
    "new_taxes_no_override": 8215.02,
    "override_total_1": 8448.12,
    "override_increase_1": 233.09
  },
  {
    "#": "57 Pleasant St, Unit 2 (043-20-02)",
    "$": 1086200,
    "address": "57 Pleasant St, Unit 2",
    "parcel_id": "043-20-02",
    "owner1": "SCIPPA, MARCELLO",
    "owner2": "",
    "current_taxes": 7487.75,
    "new_taxes_no_override": 7811.22,
    "override_total_1": 8032.86,
    "override_increase_1": 221.64
  },
  {
    "#": "57 Pleasant St, Unit 3 (043-20-03)",
    "$": 1086300,
    "address": "57 Pleasant St, Unit 3",
    "parcel_id": "043-20-03",
    "owner1": "HWANG, ANN",
    "owner2": "CABODI, MARIO",
    "current_taxes": 7488.78,
    "new_taxes_no_override": 7812.3,
    "override_total_1": 8033.96,
    "override_increase_1": 221.67
  },
  {
    "#": "58 Pleasant St, Unit 1 (046-16-01)",
    "$": 693000,
    "address": "58 Pleasant St, Unit 1",
    "parcel_id": "046-16-01",
    "owner1": "AOUT SOLEIL LLC",
    "owner2": "",
    "current_taxes": 7096.32,
    "new_taxes_no_override": 7402.88,
    "override_total_1": 7612.93,
    "override_increase_1": 210.05
  },
  {
    "#": "58 Pleasant St, Unit 2 (046-16-08)",
    "$": 664700,
    "address": "58 Pleasant St, Unit 2",
    "parcel_id": "046-16-08",
    "owner1": "HUANG, ROBERT D",
    "owner2": "",
    "current_taxes": 6806.53,
    "new_taxes_no_override": 7100.57,
    "override_total_1": 7302.05,
    "override_increase_1": 201.47
  },
  {
    "#": "58 Pleasant St, Unit 3 (046-16-03)",
    "$": 731700,
    "address": "58 Pleasant St, Unit 3",
    "parcel_id": "046-16-03",
    "owner1": "HENDRICK, MARY & ARTHUR NATHAN",
    "owner2": "",
    "current_taxes": 7492.61,
    "new_taxes_no_override": 7816.29,
    "override_total_1": 8038.07,
    "override_increase_1": 221.78
  },
  {
    "#": "58 Pleasant St, Unit 4 (046-16-04)",
    "$": 609300,
    "address": "58 Pleasant St, Unit 4",
    "parcel_id": "046-16-04",
    "owner1": "MAVUK, TURGUT",
    "owner2": "",
    "current_taxes": 6239.23,
    "new_taxes_no_override": 6508.76,
    "override_total_1": 6693.45,
    "override_increase_1": 184.68
  },
  {
    "#": "58 Pleasant St, Unit 5 (046-16-05)",
    "$": 738400,
    "address": "58 Pleasant St, Unit 5",
    "parcel_id": "046-16-05",
    "owner1": "FANG, XIAO",
    "owner2": "",
    "current_taxes": 3926.28,
    "new_taxes_no_override": 4095.9,
    "override_total_1": 4212.11,
    "override_increase_1": 116.22
  },
  {
    "#": "58 Pleasant St, Unit 6 (046-16-06)",
    "$": 531500,
    "address": "58 Pleasant St, Unit 6",
    "parcel_id": "046-16-06",
    "owner1": "BARASH, FREDERICK PHILIP",
    "owner2": "FRITZ, ERIKA L",
    "current_taxes": 5442.56,
    "new_taxes_no_override": 5677.68,
    "override_total_1": 5838.78,
    "override_increase_1": 161.1
  },
  {
    "#": "59 Pleasant St, Unit 1 & P1  P2 (043-21-01)",
    "$": 1182900,
    "address": "59 Pleasant St, Unit 1 & P1  P2",
    "parcel_id": "043-21-01",
    "owner1": "YEE TRS, EDMOND SHICK F & SYLVIA",
    "owner2": "",
    "current_taxes": 8477.96,
    "new_taxes_no_override": 8844.21,
    "override_total_1": 9095.16,
    "override_increase_1": 250.95
  },
  {
    "#": "59 Pleasant St, Unit 2 & P3 P4 (043-21-02)",
    "$": 990100,
    "address": "59 Pleasant St, Unit 2 & P3 P4",
    "parcel_id": "043-21-02",
    "owner1": "LIN, MICHAEL C & CINDY K YEE",
    "owner2": "",
    "current_taxes": 6503.69,
    "new_taxes_no_override": 6784.65,
    "override_total_1": 6977.16,
    "override_increase_1": 192.51
  },
  {
    "#": "59 Pleasant St, Unit 3 & P5 (043-21-03)",
    "$": 967700,
    "address": "59 Pleasant St, Unit 3 & P5",
    "parcel_id": "043-21-03",
    "owner1": "YEE TRS, EDMOND SHICK F & SYLVIA",
    "owner2": "",
    "current_taxes": 9909.25,
    "new_taxes_no_override": 10337.33,
    "override_total_1": 10630.64,
    "override_increase_1": 293.31
  },
  {
    "#": "61 Pleasant St, Unit 1 (043-22-03)",
    "$": 924700,
    "address": "61 Pleasant St, Unit 1",
    "parcel_id": "043-22-03",
    "owner1": "BRESLAW TRS, ANITA S",
    "owner2": "",
    "current_taxes": 5833.99,
    "new_taxes_no_override": 6086.02,
    "override_total_1": 6258.7,
    "override_increase_1": 172.69
  },
  {
    "#": "61 Pleasant St, Unit 2 (043-22-01)",
    "$": 1011600,
    "address": "61 Pleasant St, Unit 2",
    "parcel_id": "043-22-01",
    "owner1": "KIM, EUGENE",
    "owner2": "JOEN, JIN-KYUNG",
    "current_taxes": 6723.85,
    "new_taxes_no_override": 7014.32,
    "override_total_1": 7213.35,
    "override_increase_1": 199.03
  },
  {
    "#": "61 Pleasant St, Unit 3 (043-22-02)",
    "$": 1046400,
    "address": "61 Pleasant St, Unit 3",
    "parcel_id": "043-22-02",
    "owner1": "ERVIN, MIRIAM R",
    "owner2": "",
    "current_taxes": 7080.2,
    "new_taxes_no_override": 7386.06,
    "override_total_1": 7595.64,
    "override_increase_1": 209.57
  },
  {
    "#": "62 Pleasant St, Unit 1 (046-15-01)",
    "$": 1187800,
    "address": "62 Pleasant St, Unit 1",
    "parcel_id": "046-15-01",
    "owner1": "HATTON  TRS, CHARLES S & ALLYSON R",
    "owner2": "",
    "current_taxes": 8528.14,
    "new_taxes_no_override": 8896.56,
    "override_total_1": 9148.99,
    "override_increase_1": 252.43
  },
  {
    "#": "62 Pleasant St, Unit 2 (046-15-02)",
    "$": 1267800,
    "address": "62 Pleasant St, Unit 2",
    "parcel_id": "046-15-02",
    "owner1": "ROJANSKI, RACHEL",
    "owner2": "TELLER, ADAM",
    "current_taxes": 9347.34,
    "new_taxes_no_override": 9751.15,
    "override_total_1": 10027.83,
    "override_increase_1": 276.68
  },
  {
    "#": "62 Pleasant St, Unit 3 (046-15-03)",
    "$": 1424300,
    "address": "62 Pleasant St, Unit 3",
    "parcel_id": "046-15-03",
    "owner1": "PUNZO, CLAUDIO",
    "owner2": "ESSHAKI, DIANA JANE",
    "current_taxes": 10949.9,
    "new_taxes_no_override": 11422.94,
    "override_total_1": 11747.05,
    "override_increase_1": 324.12
  },
  {
    "#": "63 Pleasant St, Unit 1  & P1 (043-23-01)",
    "$": 860300,
    "address": "63 Pleasant St, Unit 1  & P1",
    "parcel_id": "043-23-01",
    "owner1": "BLUMENTHAL, ROBERTA F",
    "owner2": "",
    "current_taxes": 5174.54,
    "new_taxes_no_override": 5398.08,
    "override_total_1": 5551.25,
    "override_increase_1": 153.17
  },
  {
    "#": "63 Pleasant St, Unit 2 (043-23-02)",
    "$": 964200,
    "address": "63 Pleasant St, Unit 2",
    "parcel_id": "043-23-02",
    "owner1": "JACK, DAVID C",
    "owner2": "MAYER, AMY",
    "current_taxes": 6238.47,
    "new_taxes_no_override": 6507.97,
    "override_total_1": 6692.63,
    "override_increase_1": 184.66
  },
  {
    "#": "63 Pleasant St, Unit 3 (043-23-03)",
    "$": 908500,
    "address": "63 Pleasant St, Unit 3",
    "parcel_id": "043-23-03",
    "owner1": "YELISEYEV, VLADIMIR",
    "owner2": "BELAVUSAVA, VERA",
    "current_taxes": 5668.11,
    "new_taxes_no_override": 5912.97,
    "override_total_1": 6080.75,
    "override_increase_1": 167.78
  },
  {
    "#": "65 Pleasant St, Unit 1 (043-24-01)",
    "$": 1807800,
    "address": "65 Pleasant St, Unit 1",
    "parcel_id": "043-24-01",
    "owner1": "SINGH DEV HOLDINGS LLC",
    "owner2": "",
    "current_taxes": 18511.87,
    "new_taxes_no_override": 19311.58,
    "override_total_1": 19859.53,
    "override_increase_1": 547.95
  },
  {
    "#": "65 Pleasant St, Unit 2 (043-24-02)",
    "$": 1142400,
    "address": "65 Pleasant St, Unit 2",
    "parcel_id": "043-24-02",
    "owner1": "WASTA, MATTEW J & SANDRAM",
    "owner2": "",
    "current_taxes": 11698.18,
    "new_taxes_no_override": 12203.54,
    "override_total_1": 12549.81,
    "override_increase_1": 346.27
  },
  {
    "#": "65 Pleasant St, Unit 3 (043-24-03)",
    "$": 1325200,
    "address": "65 Pleasant St, Unit 3",
    "parcel_id": "043-24-03",
    "owner1": "EHRLICH, JAMIE ALEXANDRA",
    "owner2": "",
    "current_taxes": 13570.05,
    "new_taxes_no_override": 14156.28,
    "override_total_1": 14557.95,
    "override_increase_1": 401.67
  },
  {
    "#": "79 Pleasant St, Unit 1 (040-02-19)",
    "$": 1045200,
    "address": "79 Pleasant St, Unit 1",
    "parcel_id": "040-02-19",
    "owner1": "THURSTON TR, SUMMER IRVIN",
    "owner2": "",
    "current_taxes": 10702.85,
    "new_taxes_no_override": 11165.21,
    "override_total_1": 11482.02,
    "override_increase_1": 316.8
  },
  {
    "#": "79 Pleasant St, Unit 2 & P4 (040-02-20)",
    "$": 1250700,
    "address": "79 Pleasant St, Unit 2 & P4",
    "parcel_id": "040-02-20",
    "owner1": "ARONSSON, MARK & AZURE",
    "owner2": "",
    "current_taxes": 9172.23,
    "new_taxes_no_override": 9568.47,
    "override_total_1": 9839.97,
    "override_increase_1": 271.5
  },
  {
    "#": "79 Pleasant St, Unit 3 (040-02-21)",
    "$": 904200,
    "address": "79 Pleasant St, Unit 3",
    "parcel_id": "040-02-21",
    "owner1": "SHTEYNBERG, MAYA",
    "owner2": "",
    "current_taxes": 9259.01,
    "new_taxes_no_override": 9659.0,
    "override_total_1": 9933.07,
    "override_increase_1": 274.07
  },
  {
    "#": "79 Pleasant St, Unit 4 (040-02-22)",
    "$": 468600,
    "address": "79 Pleasant St, Unit 4",
    "parcel_id": "040-02-22",
    "owner1": "WONG, LEE HAN",
    "owner2": "LAI, WEN-HSING",
    "current_taxes": 4798.46,
    "new_taxes_no_override": 5005.75,
    "override_total_1": 5147.79,
    "override_increase_1": 142.03
  },
  {
    "#": "79 Pleasant St, Unit A (040-02-17)",
    "$": 490900,
    "address": "79 Pleasant St, Unit A",
    "parcel_id": "040-02-17",
    "owner1": "MCMANUS, KATHRYN L",
    "owner2": "",
    "current_taxes": 1391.88,
    "new_taxes_no_override": 1452.01,
    "override_total_1": 1493.21,
    "override_increase_1": 41.2
  },
  {
    "#": "79 Pleasant St, Unit B (040-02-18)",
    "$": 426800,
    "address": "79 Pleasant St, Unit B",
    "parcel_id": "040-02-18",
    "owner1": "BIRDY REAL ESTATE LLC TR",
    "owner2": "",
    "current_taxes": 4370.43,
    "new_taxes_no_override": 4559.23,
    "override_total_1": 4688.6,
    "override_increase_1": 129.36
  },
  {
    "#": "80 Pleasant St (035-41-43)",
    "$": 20089700,
    "address": "80 Pleasant St",
    "parcel_id": "035-41-43",
    "owner1": "CENTREBROOK LTD PARTNERSHIP",
    "owner2": "",
    "current_taxes": 205718.53,
    "new_taxes_no_override": 214605.57,
    "override_total_1": 220694.84,
    "override_increase_1": 6089.27
  },
  {
    "#": "83 Pleasant St, Unit 1 & P-10 (040-02-25)",
    "$": 1016500,
    "address": "83 Pleasant St, Unit 1 & P-10",
    "parcel_id": "040-02-25",
    "owner1": "SUNG, JASMIN",
    "owner2": "",
    "current_taxes": 10408.96,
    "new_taxes_no_override": 10858.63,
    "override_total_1": 11166.73,
    "override_increase_1": 308.11
  },
  {
    "#": "83 Pleasant St, Unit 2 & P5 (040-02-26)",
    "$": 1203800,
    "address": "83 Pleasant St, Unit 2 & P5",
    "parcel_id": "040-02-26",
    "owner1": "COHEN, NATHAN A & RACHEL SARAH",
    "owner2": "",
    "current_taxes": 8691.98,
    "new_taxes_no_override": 9067.47,
    "override_total_1": 9324.76,
    "override_increase_1": 257.28
  },
  {
    "#": "83 Pleasant St, Unit 83-3 & P11 (040-02-27)",
    "$": 1200600,
    "address": "83 Pleasant St, Unit 83-3 & P11",
    "parcel_id": "040-02-27",
    "owner1": "SZELENYI, KATALIN & BALAZS ANDRAS",
    "owner2": "",
    "current_taxes": 8659.21,
    "new_taxes_no_override": 9033.29,
    "override_total_1": 9289.6,
    "override_increase_1": 256.31
  },
  {
    "#": "83 Pleasant St, Unit A (040-02-23)",
    "$": 515800,
    "address": "83 Pleasant St, Unit A",
    "parcel_id": "040-02-23",
    "owner1": "MANNION TRS, LEA",
    "owner2": "BARR, KEITH",
    "current_taxes": 1646.86,
    "new_taxes_no_override": 1718.0,
    "override_total_1": 1766.75,
    "override_increase_1": 48.75
  },
  {
    "#": "83 Pleasant St, Unit B (040-02-24)",
    "$": 490100,
    "address": "83 Pleasant St, Unit B",
    "parcel_id": "040-02-24",
    "owner1": "EINHORN, ROBERT",
    "owner2": "",
    "current_taxes": 5018.62,
    "new_taxes_no_override": 5235.42,
    "override_total_1": 5383.98,
    "override_increase_1": 148.55
  },
  {
    "#": "84 Pleasant St, Unit 1 (035-40-01)",
    "$": 1156300,
    "address": "84 Pleasant St, Unit 1",
    "parcel_id": "035-40-01",
    "owner1": "VEZIKOV, JAN",
    "owner2": "",
    "current_taxes": 8205.58,
    "new_taxes_no_override": 8560.06,
    "override_total_1": 8802.95,
    "override_increase_1": 242.89
  },
  {
    "#": "84 Pleasant St, Unit 2 (035-40-02)",
    "$": 1029900,
    "address": "84 Pleasant St, Unit 2",
    "parcel_id": "035-40-02",
    "owner1": "MCLEOD TRS, SARAH",
    "owner2": "CHUANG, CONRAD",
    "current_taxes": 6911.24,
    "new_taxes_no_override": 7209.81,
    "override_total_1": 7414.38,
    "override_increase_1": 204.57
  },
  {
    "#": "84 Pleasant St, Unit 3 (035-40-03)",
    "$": 1036400,
    "address": "84 Pleasant St, Unit 3",
    "parcel_id": "035-40-03",
    "owner1": "HORVATH, PETER MICHAEL & SABRINA ELISE",
    "owner2": "DAVIDSON, DIANE MERRILL",
    "current_taxes": 10612.74,
    "new_taxes_no_override": 11071.21,
    "override_total_1": 11385.35,
    "override_increase_1": 314.14
  },
  {
    "#": "88 Pleasant St, Unit 1 (035-39-03)",
    "$": 1010700,
    "address": "88 Pleasant St, Unit 1",
    "parcel_id": "035-39-03",
    "owner1": "KILPATRICK TR, KATHRYN J",
    "owner2": "",
    "current_taxes": 6714.63,
    "new_taxes_no_override": 7004.7,
    "override_total_1": 7203.46,
    "override_increase_1": 198.75
  },
  {
    "#": "88 Pleasant St, Unit 2 (035-39-01)",
    "$": 1089400,
    "address": "88 Pleasant St, Unit 2",
    "parcel_id": "035-39-01",
    "owner1": "ZHOU, JIANHUA",
    "owner2": "SHAO, ZHAOHUI",
    "current_taxes": 11155.46,
    "new_taxes_no_override": 11637.38,
    "override_total_1": 11967.58,
    "override_increase_1": 330.2
  },
  {
    "#": "88 Pleasant St, Unit 3 (035-39-02)",
    "$": 1166500,
    "address": "88 Pleasant St, Unit 3",
    "parcel_id": "035-39-02",
    "owner1": "MARTINEZ, LINA ITZEL",
    "owner2": "BARANAC, SINISA",
    "current_taxes": 8310.03,
    "new_taxes_no_override": 8669.02,
    "override_total_1": 8915.0,
    "override_increase_1": 245.98
  },
  {
    "#": "89 Pleasant St, Unit 1 (040-05-06)",
    "$": 1179900,
    "address": "89 Pleasant St, Unit 1",
    "parcel_id": "040-05-06",
    "owner1": "BEVILAQUA TR, RALPH A",
    "owner2": "",
    "current_taxes": 8447.24,
    "new_taxes_no_override": 8812.16,
    "override_total_1": 9062.2,
    "override_increase_1": 250.04
  },
  {
    "#": "89 Pleasant St, Unit 2 (040-05-01)",
    "$": 1347100,
    "address": "89 Pleasant St, Unit 2",
    "parcel_id": "040-05-01",
    "owner1": "BELLO TRS, MARTIN G & JUDITH F",
    "owner2": "",
    "current_taxes": 10159.37,
    "new_taxes_no_override": 10598.25,
    "override_total_1": 10898.97,
    "override_increase_1": 300.72
  },
  {
    "#": "89 Pleasant St, Unit 3 (040-05-02)",
    "$": 1268700,
    "address": "89 Pleasant St, Unit 3",
    "parcel_id": "040-05-02",
    "owner1": "MEHIO TR, CHIRINE DANNAOUI",
    "owner2": "",
    "current_taxes": 12991.49,
    "new_taxes_no_override": 13552.72,
    "override_total_1": 13937.27,
    "override_increase_1": 384.55
  },
  {
    "#": "89 Pleasant St, Unit 4 (040-05-03)",
    "$": 1383500,
    "address": "89 Pleasant St, Unit 4",
    "parcel_id": "040-05-03",
    "owner1": "NATH TRS, PRAN & SHASHI",
    "owner2": "",
    "current_taxes": 10532.11,
    "new_taxes_no_override": 10987.1,
    "override_total_1": 11298.85,
    "override_increase_1": 311.75
  },
  {
    "#": "89 Pleasant St, Unit 5 (040-05-04)",
    "$": 1243600,
    "address": "89 Pleasant St, Unit 5",
    "parcel_id": "040-05-04",
    "owner1": "LUDWIG ET AL, MARK",
    "owner2": "GASCOIGNE, KATE",
    "current_taxes": 9099.53,
    "new_taxes_no_override": 9492.63,
    "override_total_1": 9761.98,
    "override_increase_1": 269.35
  },
  {
    "#": "89 Pleasant St, Unit 6 (040-05-05)",
    "$": 1648500,
    "address": "89 Pleasant St, Unit 6",
    "parcel_id": "040-05-05",
    "owner1": "MORESCO, STEPHANIE & MICHELE",
    "owner2": "",
    "current_taxes": 13245.71,
    "new_taxes_no_override": 13817.92,
    "override_total_1": 14210.0,
    "override_increase_1": 392.07
  },
  {
    "#": "90 Pleasant St (035-38-00)",
    "$": 2694800,
    "address": "90 Pleasant St",
    "parcel_id": "035-38-00",
    "owner1": "MA, JUDY",
    "owner2": "",
    "current_taxes": 23959.82,
    "new_taxes_no_override": 24994.88,
    "override_total_1": 25704.09,
    "override_increase_1": 709.21
  },
  {
    "#": "92 Pleasant St, Unit 1 (035-37-01)",
    "$": 1833800,
    "address": "92 Pleasant St, Unit 1",
    "parcel_id": "035-37-01",
    "owner1": "ZHOU, MIN",
    "owner2": "",
    "current_taxes": 18778.11,
    "new_taxes_no_override": 19589.32,
    "override_total_1": 20145.16,
    "override_increase_1": 555.83
  },
  {
    "#": "92 Pleasant St, Unit 2 (035-37-02)",
    "$": 1599600,
    "address": "92 Pleasant St, Unit 2",
    "parcel_id": "035-37-02",
    "owner1": "MENG, LIN",
    "owner2": "TERRONES, JAMES",
    "current_taxes": 16379.9,
    "new_taxes_no_override": 17087.51,
    "override_total_1": 17572.36,
    "override_increase_1": 484.85
  },
  {
    "#": "92 Pleasant St, Unit 3 (035-37-03)",
    "$": 1796900,
    "address": "92 Pleasant St, Unit 3",
    "parcel_id": "035-37-03",
    "owner1": "KWAUK, SABRINA",
    "owner2": "",
    "current_taxes": 18400.26,
    "new_taxes_no_override": 19195.15,
    "override_total_1": 19739.8,
    "override_increase_1": 544.65
  },
  {
    "#": "94 Pleasant St (035-36-00)",
    "$": 2593400,
    "address": "94 Pleasant St",
    "parcel_id": "035-36-00",
    "owner1": "74 BROWNE STREET LLC",
    "owner2": "",
    "current_taxes": 26556.42,
    "new_taxes_no_override": 27703.66,
    "override_total_1": 28489.73,
    "override_increase_1": 786.07
  },
  {
    "#": "104 Pleasant St, Unit 1 & P1 (036-17-01)",
    "$": 1665000,
    "address": "104 Pleasant St, Unit 1 & P1",
    "parcel_id": "036-17-01",
    "owner1": "NUSBAUM, BARRY",
    "owner2": "MAY, MELANIE",
    "current_taxes": 13414.67,
    "new_taxes_no_override": 13994.18,
    "override_total_1": 14391.26,
    "override_increase_1": 397.07
  },
  {
    "#": "104 Pleasant St, Unit 2 (036-17-02)",
    "$": 1734200,
    "address": "104 Pleasant St, Unit 2",
    "parcel_id": "036-17-02",
    "owner1": "GHOSHAL, ARNAB",
    "owner2": "",
    "current_taxes": 14123.27,
    "new_taxes_no_override": 14733.4,
    "override_total_1": 15151.44,
    "override_increase_1": 418.05
  },
  {
    "#": "104 Pleasant St, Unit 3 & G3 (036-17-03)",
    "$": 1725800,
    "address": "104 Pleasant St, Unit 3 & G3",
    "parcel_id": "036-17-03",
    "owner1": "ANSELL TRS, AMY",
    "owner2": "STATMAN, JAMES M",
    "current_taxes": 17672.19,
    "new_taxes_no_override": 18435.63,
    "override_total_1": 18958.73,
    "override_increase_1": 523.1
  },
  {
    "#": "106 Pleasant St (036-16-00)",
    "$": 3786800,
    "address": "106 Pleasant St",
    "parcel_id": "036-16-00",
    "owner1": "LOO, TRS, ROBERT N & TERESA H",
    "owner2": "",
    "current_taxes": 35141.9,
    "new_taxes_no_override": 36660.03,
    "override_total_1": 37700.23,
    "override_increase_1": 1040.2
  },
  {
    "#": "112 Pleasant St (036-15-00)",
    "$": 2899700,
    "address": "112 Pleasant St",
    "parcel_id": "036-15-00",
    "owner1": "LUNG ET AL, PAULINE Y & GRACE S & VICTOR S",
    "owner2": "YEE, PAULINE S L",
    "current_taxes": 29692.93,
    "new_taxes_no_override": 30975.66,
    "override_total_1": 31854.58,
    "override_increase_1": 878.91
  },
  {
    "#": "114 Pleasant St (036-14-00)",
    "$": 2872300,
    "address": "114 Pleasant St",
    "parcel_id": "036-14-00",
    "owner1": "LUNG, PAULINE Y & VICTOR S",
    "owner2": "",
    "current_taxes": 29412.35,
    "new_taxes_no_override": 30682.96,
    "override_total_1": 31553.57,
    "override_increase_1": 870.61
  },
  {
    "#": "116 Pleasant St, Unit 1 & G4 (036-13-01)",
    "$": 1314800,
    "address": "116 Pleasant St, Unit 1 & G4",
    "parcel_id": "036-13-01",
    "owner1": "PELL, STEVEN & MARCY",
    "owner2": "",
    "current_taxes": 9828.62,
    "new_taxes_no_override": 10253.22,
    "override_total_1": 10544.14,
    "override_increase_1": 290.93
  },
  {
    "#": "116 Pleasant St, Unit 2 &P3 G6 (036-13-02)",
    "$": 1382700,
    "address": "116 Pleasant St, Unit 2 &P3 G6",
    "parcel_id": "036-13-02",
    "owner1": "SONTAG, DAVID A",
    "owner2": "ESTRADA, VIOLETA RAYON",
    "current_taxes": 10523.91,
    "new_taxes_no_override": 10978.54,
    "override_total_1": 11290.05,
    "override_increase_1": 311.51
  },
  {
    "#": "116 Pleasant St, Unit 3 & P2 G5 (036-13-03)",
    "$": 1382600,
    "address": "116 Pleasant St, Unit 3 & P2 G5",
    "parcel_id": "036-13-03",
    "owner1": "ENGLUND, DIRK R",
    "owner2": "",
    "current_taxes": 10522.89,
    "new_taxes_no_override": 10977.48,
    "override_total_1": 11288.96,
    "override_increase_1": 311.48
  },
  {
    "#": "116 Pleasant St, Unit B & P1 (036-13-04)",
    "$": 835800,
    "address": "116 Pleasant St, Unit B & P1",
    "parcel_id": "036-13-04",
    "owner1": "BERGMAN TRS, BARRY S & SUSAN BIENER",
    "owner2": "",
    "current_taxes": 8558.59,
    "new_taxes_no_override": 8928.32,
    "override_total_1": 9181.66,
    "override_increase_1": 253.33
  },
  {
    "#": "118 Pleasant St, Unit 1 & G1 (036-12-01)",
    "$": 1508100,
    "address": "118 Pleasant St, Unit 1 & G1",
    "parcel_id": "036-12-01",
    "owner1": "BESLIC, MILENKO & MILIJANA",
    "owner2": "",
    "current_taxes": 15442.94,
    "new_taxes_no_override": 16110.08,
    "override_total_1": 16567.19,
    "override_increase_1": 457.11
  },
  {
    "#": "118 Pleasant St, Unit 2 & G2 (036-12-02)",
    "$": 1389100,
    "address": "118 Pleasant St, Unit 2 & G2",
    "parcel_id": "036-12-02",
    "owner1": "BESLIC, MILENKO & MILIJANA",
    "owner2": "",
    "current_taxes": 10589.45,
    "new_taxes_no_override": 11046.91,
    "override_total_1": 11360.36,
    "override_increase_1": 313.45
  },
  {
    "#": "118 Pleasant St, Unit 3 & 2 Pk Sps (036-12-03)",
    "$": 1412400,
    "address": "118 Pleasant St, Unit 3 & 2 Pk Sps",
    "parcel_id": "036-12-03",
    "owner1": "SILVER, ALEXANDER",
    "owner2": "MA, HUI",
    "current_taxes": 10828.04,
    "new_taxes_no_override": 11295.81,
    "override_total_1": 11616.32,
    "override_increase_1": 320.51
  },
  {
    "#": "118 Pleasant St, Unit B (036-12-04)",
    "$": 859600,
    "address": "118 Pleasant St, Unit B",
    "parcel_id": "036-12-04",
    "owner1": "BESLIC, MILIJANA",
    "owner2": "",
    "current_taxes": 8802.3,
    "new_taxes_no_override": 9182.56,
    "override_total_1": 9443.11,
    "override_increase_1": 260.55
  },
  {
    "#": "120 Pleasant St (036-11-00)",
    "$": 2869700,
    "address": "120 Pleasant St",
    "parcel_id": "036-11-00",
    "owner1": "LOO, TRS, ROBERT N & TERESA H",
    "owner2": "",
    "current_taxes": 29385.73,
    "new_taxes_no_override": 30655.19,
    "override_total_1": 31525.01,
    "override_increase_1": 869.82
  },
  {
    "#": "122 Pleasant St (036-10-00)",
    "$": 3072500,
    "address": "122 Pleasant St",
    "parcel_id": "036-10-00",
    "owner1": "WONG TR, DONALD M",
    "owner2": "",
    "current_taxes": 27827.47,
    "new_taxes_no_override": 29029.62,
    "override_total_1": 29853.31,
    "override_increase_1": 823.69
  },
  {
    "#": "125 Pleasant St, Unit 101 & P102 (037-03-73)",
    "$": 534400,
    "address": "125 Pleasant St, Unit 101 & P102",
    "parcel_id": "037-03-73",
    "owner1": "DOGLIOLI, CARLOS R P",
    "owner2": "ORTIGOSA, ANDREA A",
    "current_taxes": 5472.26,
    "new_taxes_no_override": 5708.66,
    "override_total_1": 5870.64,
    "override_increase_1": 161.98
  },
  {
    "#": "125 Pleasant St, Unit 102 (037-02-01)",
    "$": 528100,
    "address": "125 Pleasant St, Unit 102",
    "parcel_id": "037-02-01",
    "owner1": "COLE, JAMES V",
    "owner2": "",
    "current_taxes": 5407.74,
    "new_taxes_no_override": 5641.35,
    "override_total_1": 5801.42,
    "override_increase_1": 160.07
  },
  {
    "#": "125 Pleasant St, Unit 104 & P105 (037-02-02)",
    "$": 838800,
    "address": "125 Pleasant St, Unit 104 & P105",
    "parcel_id": "037-02-02",
    "owner1": "SUTELMAN TRS, ALEX & ELLA",
    "owner2": "",
    "current_taxes": 4954.38,
    "new_taxes_no_override": 5168.41,
    "override_total_1": 5315.06,
    "override_increase_1": 146.65
  },
  {
    "#": "125 Pleasant St, Unit 105 & P118 (037-02-03)",
    "$": 666600,
    "address": "125 Pleasant St, Unit 105 & P118",
    "parcel_id": "037-02-03",
    "owner1": "NOAM LLC",
    "owner2": "",
    "current_taxes": 6825.98,
    "new_taxes_no_override": 7120.86,
    "override_total_1": 7322.91,
    "override_increase_1": 202.05
  },
  {
    "#": "125 Pleasant St, Unit 106 & P104 (037-02-04)",
    "$": 739700,
    "address": "125 Pleasant St, Unit 106 & P104",
    "parcel_id": "037-02-04",
    "owner1": "NOAM LLC",
    "owner2": "",
    "current_taxes": 7574.53,
    "new_taxes_no_override": 7901.75,
    "override_total_1": 8125.96,
    "override_increase_1": 224.21
  },
  {
    "#": "125 Pleasant St, Unit 107 & P113 (037-02-05)",
    "$": 688000,
    "address": "125 Pleasant St, Unit 107 & P113",
    "parcel_id": "037-02-05",
    "owner1": "VELASQUEZ, MIGUEL C",
    "owner2": "KENNEDY, MARTINA",
    "current_taxes": 7045.12,
    "new_taxes_no_override": 7349.47,
    "override_total_1": 7558.0,
    "override_increase_1": 208.54
  },
  {
    "#": "125 Pleasant St, Unit 108 & P3 (037-02-06)",
    "$": 829800,
    "address": "125 Pleasant St, Unit 108 & P3",
    "parcel_id": "037-02-06",
    "owner1": "MARKUS, OFRI & LIRON",
    "owner2": "",
    "current_taxes": 8497.15,
    "new_taxes_no_override": 8864.23,
    "override_total_1": 9115.74,
    "override_increase_1": 251.52
  },
  {
    "#": "125 Pleasant St, Unit 109 & P9 (037-02-07)",
    "$": 793700,
    "address": "125 Pleasant St, Unit 109 & P9",
    "parcel_id": "037-02-07",
    "owner1": "KRUSS LIFE ESTATE, GAIL MARIE",
    "owner2": "",
    "current_taxes": 4492.55,
    "new_taxes_no_override": 4686.63,
    "override_total_1": 4819.61,
    "override_increase_1": 132.98
  },
  {
    "#": "125 Pleasant St, Unit 110 & P41 (037-02-08)",
    "$": 685500,
    "address": "125 Pleasant St, Unit 110 & P41",
    "parcel_id": "037-02-08",
    "owner1": "NOAM LLC",
    "owner2": "",
    "current_taxes": 7019.52,
    "new_taxes_no_override": 7322.76,
    "override_total_1": 7530.54,
    "override_increase_1": 207.78
  },
  {
    "#": "125 Pleasant St, Unit 111 & P44 (037-02-09)",
    "$": 724900,
    "address": "125 Pleasant St, Unit 111 & P44",
    "parcel_id": "037-02-09",
    "owner1": "ROSENBERG, DARRYL",
    "owner2": "",
    "current_taxes": 3788.04,
    "new_taxes_no_override": 3951.68,
    "override_total_1": 4063.81,
    "override_increase_1": 112.13
  },
  {
    "#": "125 Pleasant St, Unit 201 & P114 (037-02-10)",
    "$": 654000,
    "address": "125 Pleasant St, Unit 201 & P114",
    "parcel_id": "037-02-10",
    "owner1": "SCHASTNY, PETER L",
    "owner2": "",
    "current_taxes": 3062.03,
    "new_taxes_no_override": 3194.31,
    "override_total_1": 3284.95,
    "override_increase_1": 90.64
  },
  {
    "#": "125 Pleasant St, Unit 202 & P115 (037-02-11)",
    "$": 654600,
    "address": "125 Pleasant St, Unit 202 & P115",
    "parcel_id": "037-02-11",
    "owner1": "ISAACS TRS, JAMES A",
    "owner2": "ZELLMAN, ANDREA J",
    "current_taxes": 6703.1,
    "new_taxes_no_override": 6992.67,
    "override_total_1": 7191.09,
    "override_increase_1": 198.41
  },
  {
    "#": "125 Pleasant St, Unit 203 & P33L (037-02-12)",
    "$": 809900,
    "address": "125 Pleasant St, Unit 203 & P33L",
    "parcel_id": "037-02-12",
    "owner1": "ZHAO, ZICHEN",
    "owner2": "",
    "current_taxes": 8293.38,
    "new_taxes_no_override": 8651.65,
    "override_total_1": 8897.14,
    "override_increase_1": 245.48
  },
  {
    "#": "125 Pleasant St, Unit 204 45&106 (037-02-13)",
    "$": 881200,
    "address": "125 Pleasant St, Unit 204 45&106",
    "parcel_id": "037-02-13",
    "owner1": "ISAACS TRS, JAMES A",
    "owner2": "ZELLMAN, ANDREA J",
    "current_taxes": 5388.55,
    "new_taxes_no_override": 5621.34,
    "override_total_1": 5780.84,
    "override_increase_1": 159.5
  },
  {
    "#": "125 Pleasant St, Unit 205 & P42 (037-02-14)",
    "$": 718900,
    "address": "125 Pleasant St, Unit 205 & P42",
    "parcel_id": "037-02-14",
    "owner1": "WEIL TR, JESSE L",
    "owner2": "",
    "current_taxes": 7361.54,
    "new_taxes_no_override": 7679.56,
    "override_total_1": 7897.46,
    "override_increase_1": 217.9
  },
  {
    "#": "125 Pleasant St, Unit 206 & P49 (037-02-15)",
    "$": 754800,
    "address": "125 Pleasant St, Unit 206 & P49",
    "parcel_id": "037-02-15",
    "owner1": "LIN, PEI JUNG",
    "owner2": "",
    "current_taxes": 4094.22,
    "new_taxes_no_override": 4271.09,
    "override_total_1": 4392.28,
    "override_increase_1": 121.19
  },
  {
    "#": "125 Pleasant St, Unit 207 & P43 (037-02-16)",
    "$": 718900,
    "address": "125 Pleasant St, Unit 207 & P43",
    "parcel_id": "037-02-16",
    "owner1": "WATERS TR, MARLA G",
    "owner2": "",
    "current_taxes": 3726.6,
    "new_taxes_no_override": 3887.59,
    "override_total_1": 3997.9,
    "override_increase_1": 110.31
  },
  {
    "#": "125 Pleasant St, Unit 208 & P12 (037-02-17)",
    "$": 829800,
    "address": "125 Pleasant St, Unit 208 & P12",
    "parcel_id": "037-02-17",
    "owner1": "LAI TR, YANG CHING",
    "owner2": "C/O LAI, LILY",
    "current_taxes": 8497.15,
    "new_taxes_no_override": 8864.23,
    "override_total_1": 9115.74,
    "override_increase_1": 251.52
  },
  {
    "#": "125 Pleasant St, Unit 209 & P48 (037-02-18)",
    "$": 793700,
    "address": "125 Pleasant St, Unit 209 & P48",
    "parcel_id": "037-02-18",
    "owner1": "SURKIS TRS, ANNA",
    "owner2": "LEWINTER, MARGARITA",
    "current_taxes": 4492.55,
    "new_taxes_no_override": 4686.63,
    "override_total_1": 4819.61,
    "override_increase_1": 132.98
  },
  {
    "#": "125 Pleasant St, Unit 210 & P121 (037-02-19)",
    "$": 654700,
    "address": "125 Pleasant St, Unit 210 & P121",
    "parcel_id": "037-02-19",
    "owner1": "PERROTTI, TIMOTHY",
    "owner2": "",
    "current_taxes": 3069.19,
    "new_taxes_no_override": 3201.78,
    "override_total_1": 3292.63,
    "override_increase_1": 90.85
  },
  {
    "#": "125 Pleasant St, Unit 211 & P100 (037-02-20)",
    "$": 829200,
    "address": "125 Pleasant St, Unit 211 & P100",
    "parcel_id": "037-02-20",
    "owner1": "WEN, YUSANG",
    "owner2": "",
    "current_taxes": 8491.01,
    "new_taxes_no_override": 8857.82,
    "override_total_1": 9109.16,
    "override_increase_1": 251.33
  },
  {
    "#": "125 Pleasant St, Unit 301 & P116 (037-02-21)",
    "$": 768900,
    "address": "125 Pleasant St, Unit 301 & P116",
    "parcel_id": "037-02-21",
    "owner1": "HUANG, CHIEN-CHIH",
    "owner2": "LI, SZU-HUA",
    "current_taxes": 7873.54,
    "new_taxes_no_override": 8213.68,
    "override_total_1": 8446.73,
    "override_increase_1": 233.06
  },
  {
    "#": "125 Pleasant St, Unit 302 & P27L (037-02-22)",
    "$": 685500,
    "address": "125 Pleasant St, Unit 302 & P27L",
    "parcel_id": "037-02-22",
    "owner1": "KWAN, LERMIN",
    "owner2": "LO, KA YI",
    "current_taxes": 7019.52,
    "new_taxes_no_override": 7322.76,
    "override_total_1": 7530.54,
    "override_increase_1": 207.78
  },
  {
    "#": "125 Pleasant St, Unit 303 & P53 (037-02-23)",
    "$": 793700,
    "address": "125 Pleasant St, Unit 303 & P53",
    "parcel_id": "037-02-23",
    "owner1": "FELDMAN, MATAN",
    "owner2": "",
    "current_taxes": 8127.49,
    "new_taxes_no_override": 8478.6,
    "override_total_1": 8719.17,
    "override_increase_1": 240.57
  },
  {
    "#": "125 Pleasant St, Unit 304 & P40 (037-02-24)",
    "$": 829800,
    "address": "125 Pleasant St, Unit 304 & P40",
    "parcel_id": "037-02-24",
    "owner1": "PLISKIN, JOSEPH",
    "owner2": "C/O MARY HURWITZ",
    "current_taxes": 8497.15,
    "new_taxes_no_override": 8864.23,
    "override_total_1": 9115.74,
    "override_increase_1": 251.52
  },
  {
    "#": "125 Pleasant St, Unit 305 & P25 (037-02-25)",
    "$": 718800,
    "address": "125 Pleasant St, Unit 305 & P25",
    "parcel_id": "037-02-25",
    "owner1": "CHENG, CHI MEI",
    "owner2": "",
    "current_taxes": 3725.58,
    "new_taxes_no_override": 3886.53,
    "override_total_1": 3996.8,
    "override_increase_1": 110.28
  },
  {
    "#": "125 Pleasant St, Unit 306 & P4 (037-02-26)",
    "$": 739800,
    "address": "125 Pleasant St, Unit 306 & P4",
    "parcel_id": "037-02-26",
    "owner1": "MAKEDON, FILLIA",
    "owner2": "",
    "current_taxes": 7575.55,
    "new_taxes_no_override": 7902.81,
    "override_total_1": 8127.05,
    "override_increase_1": 224.24
  },
  {
    "#": "125 Pleasant St, Unit 307 & P64 (037-02-27)",
    "$": 734400,
    "address": "125 Pleasant St, Unit 307 & P64",
    "parcel_id": "037-02-27",
    "owner1": "CHENG  TR, LAUREN",
    "owner2": "",
    "current_taxes": 3885.32,
    "new_taxes_no_override": 4053.17,
    "override_total_1": 4168.17,
    "override_increase_1": 115.01
  },
  {
    "#": "125 Pleasant St, Unit 308 & P54 (037-02-28)",
    "$": 838800,
    "address": "125 Pleasant St, Unit 308 & P54",
    "parcel_id": "037-02-28",
    "owner1": "HOLTZMAN, OSNAT & ELIEZER",
    "owner2": "",
    "current_taxes": 8589.31,
    "new_taxes_no_override": 8960.37,
    "override_total_1": 9214.61,
    "override_increase_1": 254.24
  },
  {
    "#": "125 Pleasant St, Unit 309 & P11 (037-02-29)",
    "$": 828400,
    "address": "125 Pleasant St, Unit 309 & P11",
    "parcel_id": "037-02-29",
    "owner1": "CHEN, SHU-MEI & CHIEN-YU",
    "owner2": "",
    "current_taxes": 4847.88,
    "new_taxes_no_override": 5057.31,
    "override_total_1": 5200.81,
    "override_increase_1": 143.5
  },
  {
    "#": "125 Pleasant St, Unit 310 P100L (037-02-30)",
    "$": 685500,
    "address": "125 Pleasant St, Unit 310 P100L",
    "parcel_id": "037-02-30",
    "owner1": "CORREA, CELIA MARIA",
    "owner2": "",
    "current_taxes": 7019.52,
    "new_taxes_no_override": 7322.76,
    "override_total_1": 7530.54,
    "override_increase_1": 207.78
  },
  {
    "#": "125 Pleasant St, Unit 311 & P6 (037-02-31)",
    "$": 843800,
    "address": "125 Pleasant St, Unit 311 & P6",
    "parcel_id": "037-02-31",
    "owner1": "BRODY TR, LEONORE D",
    "owner2": "",
    "current_taxes": 5005.58,
    "new_taxes_no_override": 5221.82,
    "override_total_1": 5369.99,
    "override_increase_1": 148.17
  },
  {
    "#": "125 Pleasant St, Unit 401 & P86R (037-02-32)",
    "$": 834500,
    "address": "125 Pleasant St, Unit 401 & P86R",
    "parcel_id": "037-02-32",
    "owner1": "CASTELLI TRS, GABRIELE & ANDREA",
    "owner2": "",
    "current_taxes": 8545.28,
    "new_taxes_no_override": 8914.44,
    "override_total_1": 9167.38,
    "override_increase_1": 252.94
  },
  {
    "#": "125 Pleasant St, Unit 402 & P47 (037-02-33)",
    "$": 685500,
    "address": "125 Pleasant St, Unit 402 & P47",
    "parcel_id": "037-02-33",
    "owner1": "SACKS, S HENRY & SUSAN R",
    "owner2": "",
    "current_taxes": 3384.59,
    "new_taxes_no_override": 3530.8,
    "override_total_1": 3630.99,
    "override_increase_1": 100.18
  },
  {
    "#": "125 Pleasant St, Unit 403 P100R (037-02-34)",
    "$": 793700,
    "address": "125 Pleasant St, Unit 403 P100R",
    "parcel_id": "037-02-34",
    "owner1": "CHANG, OTTO Y",
    "owner2": "TEE, KUN",
    "current_taxes": 8127.49,
    "new_taxes_no_override": 8478.6,
    "override_total_1": 8719.17,
    "override_increase_1": 240.57
  },
  {
    "#": "125 Pleasant St, Unit 404 & P46 (037-02-35)",
    "$": 885500,
    "address": "125 Pleasant St, Unit 404 & P46",
    "parcel_id": "037-02-35",
    "owner1": "LEVINS TR, ALISON",
    "owner2": "",
    "current_taxes": 5432.59,
    "new_taxes_no_override": 5667.28,
    "override_total_1": 5828.08,
    "override_increase_1": 160.8
  },
  {
    "#": "125 Pleasant St, Unit 405 & P31 (037-02-36)",
    "$": 733900,
    "address": "125 Pleasant St, Unit 405 & P31",
    "parcel_id": "037-02-36",
    "owner1": "KIMEL, KLAUS",
    "owner2": "TRIPOLSKI-KIMEL, MARIA",
    "current_taxes": 7515.14,
    "new_taxes_no_override": 7839.79,
    "override_total_1": 8062.24,
    "override_increase_1": 222.45
  },
  {
    "#": "125 Pleasant St, Unit 406 & P37 (037-02-37)",
    "$": 746900,
    "address": "125 Pleasant St, Unit 406 & P37",
    "parcel_id": "037-02-37",
    "owner1": "QIAN, QINFANG",
    "owner2": "CHEN, TONGSHENG",
    "current_taxes": 7648.26,
    "new_taxes_no_override": 7978.66,
    "override_total_1": 8205.05,
    "override_increase_1": 226.39
  },
  {
    "#": "125 Pleasant St, Unit 407 P106L (037-02-38)",
    "$": 718900,
    "address": "125 Pleasant St, Unit 407 P106L",
    "parcel_id": "037-02-38",
    "owner1": "CASTELLI TRS, GABRIELE & ANDREA",
    "owner2": "",
    "current_taxes": 7361.54,
    "new_taxes_no_override": 7679.56,
    "override_total_1": 7897.46,
    "override_increase_1": 217.9
  },
  {
    "#": "125 Pleasant St, Unit 408 & P52 (037-02-39)",
    "$": 829800,
    "address": "125 Pleasant St, Unit 408 & P52",
    "parcel_id": "037-02-39",
    "owner1": "JIANG, HONGYU",
    "owner2": "",
    "current_taxes": 8497.15,
    "new_taxes_no_override": 8864.23,
    "override_total_1": 9115.74,
    "override_increase_1": 251.52
  },
  {
    "#": "125 Pleasant St, Unit 409 & P30 (037-02-40)",
    "$": 793800,
    "address": "125 Pleasant St, Unit 409 & P30",
    "parcel_id": "037-02-40",
    "owner1": "CALDAS DECASTRO, MARCIA",
    "owner2": "",
    "current_taxes": 4493.58,
    "new_taxes_no_override": 4687.7,
    "override_total_1": 4820.71,
    "override_increase_1": 133.01
  },
  {
    "#": "125 Pleasant St, Unit 410 & P34 (037-02-41)",
    "$": 685600,
    "address": "125 Pleasant St, Unit 410 & P34",
    "parcel_id": "037-02-41",
    "owner1": "RESTEGHINI TR, CHRISTINA",
    "owner2": "",
    "current_taxes": 3385.61,
    "new_taxes_no_override": 3531.87,
    "override_total_1": 3632.08,
    "override_increase_1": 100.21
  },
  {
    "#": "125 Pleasant St, Unit 411 & P59 (037-02-42)",
    "$": 878500,
    "address": "125 Pleasant St, Unit 411 & P59",
    "parcel_id": "037-02-42",
    "owner1": "BLANKSCHTEIN, EDMUNDO DANIEL & ANNA",
    "owner2": "",
    "current_taxes": 5360.91,
    "new_taxes_no_override": 5592.5,
    "override_total_1": 5751.18,
    "override_increase_1": 158.68
  },
  {
    "#": "125 Pleasant St, Unit 501 & P38 (037-02-43)",
    "$": 799700,
    "address": "125 Pleasant St, Unit 501 & P38",
    "parcel_id": "037-02-43",
    "owner1": "ZALIZETSKY, BORIS",
    "owner2": "",
    "current_taxes": 4553.99,
    "new_taxes_no_override": 4750.72,
    "override_total_1": 4885.52,
    "override_increase_1": 134.8
  },
  {
    "#": "125 Pleasant St, Unit 502 & P94 (037-02-44)",
    "$": 700900,
    "address": "125 Pleasant St, Unit 502 & P94",
    "parcel_id": "037-02-44",
    "owner1": "LEVIN TRS, YURY & ZINAIDA",
    "owner2": "",
    "current_taxes": 7177.22,
    "new_taxes_no_override": 7487.28,
    "override_total_1": 7699.72,
    "override_increase_1": 212.45
  },
  {
    "#": "125 Pleasant St, Unit 503 & P112 (037-02-45)",
    "$": 762800,
    "address": "125 Pleasant St, Unit 503 & P112",
    "parcel_id": "037-02-45",
    "owner1": "CHARNAS TR, FRANCES ELKA",
    "owner2": "",
    "current_taxes": 4176.14,
    "new_taxes_no_override": 4356.55,
    "override_total_1": 4480.16,
    "override_increase_1": 123.61
  },
  {
    "#": "125 Pleasant St, Unit 504 & P50 (037-02-46)",
    "$": 829800,
    "address": "125 Pleasant St, Unit 504 & P50",
    "parcel_id": "037-02-46",
    "owner1": "EDELMAN, DAVID & CAROL",
    "owner2": "",
    "current_taxes": 8497.15,
    "new_taxes_no_override": 8864.23,
    "override_total_1": 9115.74,
    "override_increase_1": 251.52
  },
  {
    "#": "125 Pleasant St, Unit 505 (037-02-47)",
    "$": 667500,
    "address": "125 Pleasant St, Unit 505",
    "parcel_id": "037-02-47",
    "owner1": "AZUERO, GLORIA M & DORA",
    "owner2": "",
    "current_taxes": 3200.27,
    "new_taxes_no_override": 3338.52,
    "override_total_1": 3433.25,
    "override_increase_1": 94.73
  },
  {
    "#": "125 Pleasant St, Unit 506 & P123 (037-02-48)",
    "$": 708900,
    "address": "125 Pleasant St, Unit 506 & P123",
    "parcel_id": "037-02-48",
    "owner1": "LEEN, WILLIAM J",
    "owner2": "",
    "current_taxes": 7259.14,
    "new_taxes_no_override": 7572.73,
    "override_total_1": 7787.61,
    "override_increase_1": 214.87
  },
  {
    "#": "125 Pleasant St, Unit 507 & P117 (037-02-49)",
    "$": 703000,
    "address": "125 Pleasant St, Unit 507 & P117",
    "parcel_id": "037-02-49",
    "owner1": "ARAKCHEEVA, KSENIA",
    "owner2": "",
    "current_taxes": 3563.79,
    "new_taxes_no_override": 3717.75,
    "override_total_1": 3823.23,
    "override_increase_1": 105.49
  },
  {
    "#": "125 Pleasant St, Unit 508 & P57 (037-02-50)",
    "$": 829900,
    "address": "125 Pleasant St, Unit 508 & P57",
    "parcel_id": "037-02-50",
    "owner1": "VERQUIST, MIN",
    "owner2": "",
    "current_taxes": 4863.24,
    "new_taxes_no_override": 5073.33,
    "override_total_1": 5217.28,
    "override_increase_1": 143.95
  },
  {
    "#": "125 Pleasant St, Unit 509 & P55 (037-02-51)",
    "$": 793700,
    "address": "125 Pleasant St, Unit 509 & P55",
    "parcel_id": "037-02-51",
    "owner1": "MCCARRON, MARY JANE",
    "owner2": "",
    "current_taxes": 4492.55,
    "new_taxes_no_override": 4686.63,
    "override_total_1": 4819.61,
    "override_increase_1": 132.98
  },
  {
    "#": "125 Pleasant St, Unit 510 & P67 (037-02-52)",
    "$": 685500,
    "address": "125 Pleasant St, Unit 510 & P67",
    "parcel_id": "037-02-52",
    "owner1": "MCCARRON, MARY JANE",
    "owner2": "",
    "current_taxes": 7019.52,
    "new_taxes_no_override": 7322.76,
    "override_total_1": 7530.54,
    "override_increase_1": 207.78
  },
  {
    "#": "125 Pleasant St, Unit 511 & P56 (037-02-53)",
    "$": 859200,
    "address": "125 Pleasant St, Unit 511 & P56",
    "parcel_id": "037-02-53",
    "owner1": "ALIZADEH TR, ELIZABETH",
    "owner2": "",
    "current_taxes": 8798.21,
    "new_taxes_no_override": 9178.29,
    "override_total_1": 9438.72,
    "override_increase_1": 260.43
  },
  {
    "#": "125 Pleasant St, Unit 601 & P60 (037-02-54)",
    "$": 903600,
    "address": "125 Pleasant St, Unit 601 & P60",
    "parcel_id": "037-02-54",
    "owner1": "ZHAN, YONG",
    "owner2": "YUAN, LEI",
    "current_taxes": 5617.93,
    "new_taxes_no_override": 5860.62,
    "override_total_1": 6026.92,
    "override_increase_1": 166.29
  },
  {
    "#": "125 Pleasant St, Unit 602 & P35 (037-02-55)",
    "$": 685500,
    "address": "125 Pleasant St, Unit 602 & P35",
    "parcel_id": "037-02-55",
    "owner1": "LEEF TRS, PHILLIP HARRIS & SARA MICHELE",
    "owner2": "",
    "current_taxes": 7019.52,
    "new_taxes_no_override": 7322.76,
    "override_total_1": 7530.54,
    "override_increase_1": 207.78
  },
  {
    "#": "125 Pleasant St, Unit 603 & P1 (037-02-56)",
    "$": 1720100,
    "address": "125 Pleasant St, Unit 603 & P1",
    "parcel_id": "037-02-56",
    "owner1": "CHANG, YING-CHIN",
    "owner2": "CHIANG, SHIHKUN",
    "current_taxes": 13978.89,
    "new_taxes_no_override": 14582.78,
    "override_total_1": 14996.55,
    "override_increase_1": 413.78
  },
  {
    "#": "125 Pleasant St, Unit 605 & P29 (037-02-57)",
    "$": 751000,
    "address": "125 Pleasant St, Unit 605 & P29",
    "parcel_id": "037-02-57",
    "owner1": "BLUNDON, JEAN",
    "owner2": "",
    "current_taxes": 4055.31,
    "new_taxes_no_override": 4230.5,
    "override_total_1": 4350.54,
    "override_increase_1": 120.04
  },
  {
    "#": "125 Pleasant St, Unit 606 & P86L (037-02-58)",
    "$": 739800,
    "address": "125 Pleasant St, Unit 606 & P86L",
    "parcel_id": "037-02-58",
    "owner1": "VEERAKAMOLMAL ET AL, PITIPONG",
    "owner2": "C/O LIN ET AL, PITIPONG JUN SEN",
    "current_taxes": 7575.55,
    "new_taxes_no_override": 7902.81,
    "override_total_1": 8127.05,
    "override_increase_1": 224.24
  },
  {
    "#": "125 Pleasant St, Unit 607 & P39 (037-02-59)",
    "$": 726700,
    "address": "125 Pleasant St, Unit 607 & P39",
    "parcel_id": "037-02-59",
    "owner1": "NOAM LLC",
    "owner2": "",
    "current_taxes": 7441.41,
    "new_taxes_no_override": 7762.88,
    "override_total_1": 7983.14,
    "override_increase_1": 220.27
  },
  {
    "#": "125 Pleasant St, Unit 608 & P36 (037-02-60)",
    "$": 829800,
    "address": "125 Pleasant St, Unit 608 & P36",
    "parcel_id": "037-02-60",
    "owner1": "SHIH, HONG DAO",
    "owner2": "",
    "current_taxes": 8497.15,
    "new_taxes_no_override": 8864.23,
    "override_total_1": 9115.74,
    "override_increase_1": 251.52
  },
  {
    "#": "125 Pleasant St, Unit 609 & P8 (037-02-61)",
    "$": 809100,
    "address": "125 Pleasant St, Unit 609 & P8",
    "parcel_id": "037-02-61",
    "owner1": "EDELSTEIN, RIVCKA",
    "owner2": "",
    "current_taxes": 8285.18,
    "new_taxes_no_override": 8643.1,
    "override_total_1": 8888.34,
    "override_increase_1": 245.24
  },
  {
    "#": "125 Pleasant St, Unit 610 & P70 (037-02-62)",
    "$": 685500,
    "address": "125 Pleasant St, Unit 610 & P70",
    "parcel_id": "037-02-62",
    "owner1": "STEINHORN, ROBERTA",
    "owner2": "",
    "current_taxes": 3384.59,
    "new_taxes_no_override": 3530.8,
    "override_total_1": 3630.99,
    "override_increase_1": 100.18
  },
  {
    "#": "125 Pleasant St, Unit 611 & P99 (037-02-63)",
    "$": 843800,
    "address": "125 Pleasant St, Unit 611 & P99",
    "parcel_id": "037-02-63",
    "owner1": "ALIZADEH TR, ELIZABETH",
    "owner2": "",
    "current_taxes": 8640.51,
    "new_taxes_no_override": 9013.78,
    "override_total_1": 9269.54,
    "override_increase_1": 255.76
  },
  {
    "#": "125 Pleasant St, Unit 701 & P51 (037-02-64)",
    "$": 1246900,
    "address": "125 Pleasant St, Unit 701 & P51",
    "parcel_id": "037-02-64",
    "owner1": "HULL ET AL TRS, JOHN D",
    "owner2": "",
    "current_taxes": 9133.32,
    "new_taxes_no_override": 9527.88,
    "override_total_1": 9798.23,
    "override_increase_1": 270.35
  },
  {
    "#": "125 Pleasant St, Unit P111 (037-03-69)",
    "$": 48300,
    "address": "125 Pleasant St, Unit P111",
    "parcel_id": "037-03-69",
    "owner1": "LEIPMAN, SARAH G & SUSAN N",
    "owner2": "ROBERGE, JOHN H",
    "current_taxes": 494.59,
    "new_taxes_no_override": 515.96,
    "override_total_1": 530.6,
    "override_increase_1": 14.64
  },
  {
    "#": "125 Pleasant St, Unit P124 (037-03-70)",
    "$": 48300,
    "address": "125 Pleasant St, Unit P124",
    "parcel_id": "037-03-70",
    "owner1": "LEIPMAN, SARAH G & SUSAN N",
    "owner2": "ROBERGE, JOHN H",
    "current_taxes": 494.59,
    "new_taxes_no_override": 515.96,
    "override_total_1": 530.6,
    "override_increase_1": 14.64
  },
  {
    "#": "125 Pleasant St, Unit P125 (037-03-71)",
    "$": 48300,
    "address": "125 Pleasant St, Unit P125",
    "parcel_id": "037-03-71",
    "owner1": "LEIPMAN, SARAH G & SUSAN N",
    "owner2": "ROBERGE, JOHN H",
    "current_taxes": 494.59,
    "new_taxes_no_override": 515.96,
    "override_total_1": 530.6,
    "override_increase_1": 14.64
  },
  {
    "#": "125 Pleasant St, Unit P2 (037-03-64)",
    "$": 82500,
    "address": "125 Pleasant St, Unit P2",
    "parcel_id": "037-03-64",
    "owner1": "LEIPMAN, SARAH G & SUSAN N",
    "owner2": "ROBERGE, JOHN H",
    "current_taxes": 844.8,
    "new_taxes_no_override": 881.3,
    "override_total_1": 906.3,
    "override_increase_1": 25.01
  },
  {
    "#": "125 Pleasant St, Unit P5 (037-03-75)",
    "$": 90800,
    "address": "125 Pleasant St, Unit P5",
    "parcel_id": "037-03-75",
    "owner1": "STEIN TR, CYNTHIA J",
    "owner2": "",
    "current_taxes": 929.79,
    "new_taxes_no_override": 969.96,
    "override_total_1": 997.48,
    "override_increase_1": 27.52
  },
  {
    "#": "125 Pleasant St, Unit P65 (037-03-74)",
    "$": 82500,
    "address": "125 Pleasant St, Unit P65",
    "parcel_id": "037-03-74",
    "owner1": "CHANG, OTTO Y & KUN TEE",
    "owner2": "",
    "current_taxes": 844.8,
    "new_taxes_no_override": 881.3,
    "override_total_1": 906.3,
    "override_increase_1": 25.01
  },
  {
    "#": "125 Pleasant St, Unit P81 (037-03-67)",
    "$": 82500,
    "address": "125 Pleasant St, Unit P81",
    "parcel_id": "037-03-67",
    "owner1": "BOHN, ET AL, TRS, ELLEN",
    "owner2": "C/O CROWNINSHIELD MANAGEMENT CO",
    "current_taxes": 844.8,
    "new_taxes_no_override": 881.3,
    "override_total_1": 906.3,
    "override_increase_1": 25.01
  },
  {
    "#": "128 Pleasant St, Unit 1 (036-09-05)",
    "$": 738300,
    "address": "128 Pleasant St, Unit 1",
    "parcel_id": "036-09-05",
    "owner1": "BEDDALL, THOMAS G",
    "owner2": "DUMLER, FRANCOISE",
    "current_taxes": 3925.26,
    "new_taxes_no_override": 4094.83,
    "override_total_1": 4211.02,
    "override_increase_1": 116.19
  },
  {
    "#": "128 Pleasant St, Unit 2 (036-09-01)",
    "$": 773100,
    "address": "128 Pleasant St, Unit 2",
    "parcel_id": "036-09-01",
    "owner1": "DUMLER, FRANCOISE",
    "owner2": "BEDDAL, THOMAS G",
    "current_taxes": 7916.54,
    "new_taxes_no_override": 8258.53,
    "override_total_1": 8492.86,
    "override_increase_1": 234.33
  },
  {
    "#": "128 Pleasant St, Unit 3 & P1 (036-09-02)",
    "$": 1326600,
    "address": "128 Pleasant St, Unit 3 & P1",
    "parcel_id": "036-09-02",
    "owner1": "GREENE, BENJAMIN M & RACHEL G",
    "owner2": "",
    "current_taxes": 13584.38,
    "new_taxes_no_override": 14171.23,
    "override_total_1": 14573.32,
    "override_increase_1": 402.1
  },
  {
    "#": "128 Pleasant St, Unit 4 & P5 (036-09-03)",
    "$": 798100,
    "address": "128 Pleasant St, Unit 4 & P5",
    "parcel_id": "036-09-03",
    "owner1": "SORDO SANCHEZ, MARIA MARGARITA D",
    "owner2": "",
    "current_taxes": 4537.61,
    "new_taxes_no_override": 4733.63,
    "override_total_1": 4867.95,
    "override_increase_1": 134.31
  },
  {
    "#": "128 Pleasant St, Unit 5 & P-4 (036-09-04)",
    "$": 796800,
    "address": "128 Pleasant St, Unit 5 & P-4",
    "parcel_id": "036-09-04",
    "owner1": "GHITELMAN, GAYLE S",
    "owner2": "",
    "current_taxes": 4524.3,
    "new_taxes_no_override": 4719.75,
    "override_total_1": 4853.67,
    "override_increase_1": 133.92
  },
  {
    "#": "130 Pleasant St (036-08-00)",
    "$": 2908000,
    "address": "130 Pleasant St",
    "parcel_id": "036-08-00",
    "owner1": "ROBINS TRS, BONNIE & STEVEN D",
    "owner2": "",
    "current_taxes": 29777.92,
    "new_taxes_no_override": 31064.33,
    "override_total_1": 31945.75,
    "override_increase_1": 881.43
  },
  {
    "#": "132 Pleasant St, Unit 1 (036-07-01)",
    "$": 1343300,
    "address": "132 Pleasant St, Unit 1",
    "parcel_id": "036-07-01",
    "owner1": "YEE TRS, JAMES P & LILLI T",
    "owner2": "",
    "current_taxes": 10120.46,
    "new_taxes_no_override": 10557.66,
    "override_total_1": 10857.23,
    "override_increase_1": 299.57
  },
  {
    "#": "132 Pleasant St, Unit 2 (036-07-02)",
    "$": 1413300,
    "address": "132 Pleasant St, Unit 2",
    "parcel_id": "036-07-02",
    "owner1": "YEE, STEPHEN P & TRICIA MARCY",
    "owner2": "",
    "current_taxes": 10837.26,
    "new_taxes_no_override": 11305.43,
    "override_total_1": 11626.21,
    "override_increase_1": 320.78
  },
  {
    "#": "132 Pleasant St, Unit 3 (036-07-03)",
    "$": 1413600,
    "address": "132 Pleasant St, Unit 3",
    "parcel_id": "036-07-03",
    "owner1": "YEE TRS, ANDREW & REBECCA",
    "owner2": "",
    "current_taxes": 10840.33,
    "new_taxes_no_override": 11308.63,
    "override_total_1": 11629.51,
    "override_increase_1": 320.87
  },
  {
    "#": "134 Pleasant St, Unit A & P-A (036-06-03)",
    "$": 1280900,
    "address": "134 Pleasant St, Unit A & P-A",
    "parcel_id": "036-06-03",
    "owner1": "LEUNG, WILLIAM H",
    "owner2": "LI, LIU Q",
    "current_taxes": 9481.48,
    "new_taxes_no_override": 9891.08,
    "override_total_1": 10171.73,
    "override_increase_1": 280.65
  },
  {
    "#": "134 Pleasant St, Unit B  & P-B (036-06-01)",
    "$": 1373600,
    "address": "134 Pleasant St, Unit B  & P-B",
    "parcel_id": "036-06-01",
    "owner1": "EDELMAN, LEE",
    "owner2": "LITVAK, JOSEPH",
    "current_taxes": 10430.73,
    "new_taxes_no_override": 10881.34,
    "override_total_1": 11190.09,
    "override_increase_1": 308.75
  },
  {
    "#": "134 Pleasant St, Unit C (036-06-02)",
    "$": 1370200,
    "address": "134 Pleasant St, Unit C",
    "parcel_id": "036-06-02",
    "owner1": "134 PLEASANT STREET LLC",
    "owner2": "",
    "current_taxes": 14030.85,
    "new_taxes_no_override": 14636.98,
    "override_total_1": 15052.3,
    "override_increase_1": 415.31
  },
  {
    "#": "135 Pleasant St, Unit 101 & P16R (037-03-00)",
    "$": 839100,
    "address": "135 Pleasant St, Unit 101 & P16R",
    "parcel_id": "037-03-00",
    "owner1": "LOUKOVA, PETIA",
    "owner2": "",
    "current_taxes": 4957.45,
    "new_taxes_no_override": 5171.61,
    "override_total_1": 5318.35,
    "override_increase_1": 146.74
  },
  {
    "#": "135 Pleasant St, Unit 102 & P91 (037-03-01)",
    "$": 685500,
    "address": "135 Pleasant St, Unit 102 & P91",
    "parcel_id": "037-03-01",
    "owner1": "CHEN, JIE",
    "owner2": "LIU, YUNHE",
    "current_taxes": 7019.52,
    "new_taxes_no_override": 7322.76,
    "override_total_1": 7530.54,
    "override_increase_1": 207.78
  },
  {
    "#": "135 Pleasant St, Unit 103 & P10R (037-03-02)",
    "$": 800900,
    "address": "135 Pleasant St, Unit 103 & P10R",
    "parcel_id": "037-03-02",
    "owner1": "FORD, SUSAN",
    "owner2": "",
    "current_taxes": 4566.28,
    "new_taxes_no_override": 4763.54,
    "override_total_1": 4898.71,
    "override_increase_1": 135.16
  },
  {
    "#": "135 Pleasant St, Unit 104 & P24 (037-03-03)",
    "$": 849100,
    "address": "135 Pleasant St, Unit 104 & P24",
    "parcel_id": "037-03-03",
    "owner1": "ORR, ERAN",
    "owner2": "",
    "current_taxes": 8694.78,
    "new_taxes_no_override": 9070.39,
    "override_total_1": 9327.76,
    "override_increase_1": 257.37
  },
  {
    "#": "135 Pleasant St, Unit 105 & P23 (037-03-04)",
    "$": 718800,
    "address": "135 Pleasant St, Unit 105 & P23",
    "parcel_id": "037-03-04",
    "owner1": "MINSKY, ADAM A",
    "owner2": "",
    "current_taxes": 3725.58,
    "new_taxes_no_override": 3886.53,
    "override_total_1": 3996.8,
    "override_increase_1": 110.28
  },
  {
    "#": "135 Pleasant St, Unit 106 & P28 (037-03-05)",
    "$": 754700,
    "address": "135 Pleasant St, Unit 106 & P28",
    "parcel_id": "037-03-05",
    "owner1": "KIM TRS, JOHN & MICHELINE A",
    "owner2": "",
    "current_taxes": 7728.13,
    "new_taxes_no_override": 8061.99,
    "override_total_1": 8290.74,
    "override_increase_1": 228.75
  },
  {
    "#": "135 Pleasant St, Unit 107 & P90 (037-03-06)",
    "$": 718800,
    "address": "135 Pleasant St, Unit 107 & P90",
    "parcel_id": "037-03-06",
    "owner1": "LIEF, GERALD A",
    "owner2": "",
    "current_taxes": 7360.51,
    "new_taxes_no_override": 7678.48,
    "override_total_1": 7896.36,
    "override_increase_1": 217.87
  },
  {
    "#": "135 Pleasant St, Unit 108 & P126 (037-03-07)",
    "$": 799000,
    "address": "135 Pleasant St, Unit 108 & P126",
    "parcel_id": "037-03-07",
    "owner1": "WHITE, SHELLEY",
    "owner2": "",
    "current_taxes": 8181.76,
    "new_taxes_no_override": 8535.21,
    "override_total_1": 8777.39,
    "override_increase_1": 242.18
  },
  {
    "#": "135 Pleasant St, Unit 109 & P128 (037-03-08)",
    "$": 762800,
    "address": "135 Pleasant St, Unit 109 & P128",
    "parcel_id": "037-03-08",
    "owner1": "CHEN TR, XIAOQI",
    "owner2": "",
    "current_taxes": 7811.07,
    "new_taxes_no_override": 8148.51,
    "override_total_1": 8379.72,
    "override_increase_1": 231.21
  },
  {
    "#": "135 Pleasant St, Unit 110 (037-03-09)",
    "$": 685500,
    "address": "135 Pleasant St, Unit 110",
    "parcel_id": "037-03-09",
    "owner1": "YEE TRS, ANDREW & REBECCA",
    "owner2": "",
    "current_taxes": 7019.52,
    "new_taxes_no_override": 7322.76,
    "override_total_1": 7530.54,
    "override_increase_1": 207.78
  },
  {
    "#": "135 Pleasant St, Unit 111 & P129 (037-03-10)",
    "$": 496200,
    "address": "135 Pleasant St, Unit 111 & P129",
    "parcel_id": "037-03-10",
    "owner1": "EL FAKHRI, RAMZI & GEORGES",
    "owner2": "",
    "current_taxes": 5081.09,
    "new_taxes_no_override": 5300.59,
    "override_total_1": 5450.99,
    "override_increase_1": 150.4
  },
  {
    "#": "135 Pleasant St, Unit 201 & P7 (037-03-11)",
    "$": 852700,
    "address": "135 Pleasant St, Unit 201 & P7",
    "parcel_id": "037-03-11",
    "owner1": "LESSING, JOSHUA & TATYANA SVINKINA",
    "owner2": "",
    "current_taxes": 5096.71,
    "new_taxes_no_override": 5316.89,
    "override_total_1": 5467.75,
    "override_increase_1": 150.86
  },
  {
    "#": "135 Pleasant St, Unit 202 & P101 (037-03-12)",
    "$": 685500,
    "address": "135 Pleasant St, Unit 202 & P101",
    "parcel_id": "037-03-12",
    "owner1": "NATHANSON, SINAIA & DAN",
    "owner2": "",
    "current_taxes": 7019.52,
    "new_taxes_no_override": 7322.76,
    "override_total_1": 7530.54,
    "override_increase_1": 207.78
  },
  {
    "#": "135 Pleasant St, Unit 203 & P122 (037-03-13)",
    "$": 779100,
    "address": "135 Pleasant St, Unit 203 & P122",
    "parcel_id": "037-03-13",
    "owner1": "SINGH TRS, SUMA & SANDEEP",
    "owner2": "",
    "current_taxes": 7977.98,
    "new_taxes_no_override": 8322.63,
    "override_total_1": 8558.78,
    "override_increase_1": 236.15
  },
  {
    "#": "135 Pleasant St, Unit 204 & P15 (037-03-14)",
    "$": 829800,
    "address": "135 Pleasant St, Unit 204 & P15",
    "parcel_id": "037-03-14",
    "owner1": "CHAPLA, JERAM P & KEVIN J",
    "owner2": "",
    "current_taxes": 8497.15,
    "new_taxes_no_override": 8864.23,
    "override_total_1": 9115.74,
    "override_increase_1": 251.52
  },
  {
    "#": "135 Pleasant St, Unit 205 & P82 (037-03-15)",
    "$": 718900,
    "address": "135 Pleasant St, Unit 205 & P82",
    "parcel_id": "037-03-15",
    "owner1": "SOBOL, TAMAR",
    "owner2": "INGERMAN, AVNER",
    "current_taxes": 7361.54,
    "new_taxes_no_override": 7679.56,
    "override_total_1": 7897.46,
    "override_increase_1": 217.9
  },
  {
    "#": "135 Pleasant St, Unit 206 & P80 (037-03-16)",
    "$": 739700,
    "address": "135 Pleasant St, Unit 206 & P80",
    "parcel_id": "037-03-16",
    "owner1": "GREGORY, MICHAEL & KAREN",
    "owner2": "",
    "current_taxes": 7574.53,
    "new_taxes_no_override": 7901.75,
    "override_total_1": 8125.96,
    "override_increase_1": 224.21
  },
  {
    "#": "135 Pleasant St, Unit 207 & P88 (037-03-17)",
    "$": 726600,
    "address": "135 Pleasant St, Unit 207 & P88",
    "parcel_id": "037-03-17",
    "owner1": "SALIB, WAGIH & AIDA",
    "owner2": "",
    "current_taxes": 7440.38,
    "new_taxes_no_override": 7761.8,
    "override_total_1": 7982.04,
    "override_increase_1": 220.24
  },
  {
    "#": "135 Pleasant St, Unit 208 & P22 (037-03-18)",
    "$": 829800,
    "address": "135 Pleasant St, Unit 208 & P22",
    "parcel_id": "037-03-18",
    "owner1": "HSU, YI-HSIANG",
    "owner2": "LIEN, JU-PING",
    "current_taxes": 8497.15,
    "new_taxes_no_override": 8864.23,
    "override_total_1": 9115.74,
    "override_increase_1": 251.52
  },
  {
    "#": "135 Pleasant St, Unit 209 & P84 (037-03-19)",
    "$": 835500,
    "address": "135 Pleasant St, Unit 209 & P84",
    "parcel_id": "037-03-19",
    "owner1": "HERSKOVITS, ARIE",
    "owner2": "",
    "current_taxes": 8555.52,
    "new_taxes_no_override": 8925.12,
    "override_total_1": 9178.36,
    "override_increase_1": 253.24
  },
  {
    "#": "135 Pleasant St, Unit 210 & P98 (037-03-20)",
    "$": 685500,
    "address": "135 Pleasant St, Unit 210 & P98",
    "parcel_id": "037-03-20",
    "owner1": "WYMAN TR, CARY E",
    "owner2": "",
    "current_taxes": 3384.59,
    "new_taxes_no_override": 3530.8,
    "override_total_1": 3630.99,
    "override_increase_1": 100.18
  },
  {
    "#": "135 Pleasant St, Unit 211 & P95R (037-03-21)",
    "$": 684800,
    "address": "135 Pleasant St, Unit 211 & P95R",
    "parcel_id": "037-03-21",
    "owner1": "PESAKOVICH TR, BORIS I",
    "owner2": "BELOSTOTSKY TR, LARISA",
    "current_taxes": 3377.42,
    "new_taxes_no_override": 3523.32,
    "override_total_1": 3623.3,
    "override_increase_1": 99.97
  },
  {
    "#": "135 Pleasant St, Unit 301 & P96 (037-03-22)",
    "$": 859300,
    "address": "135 Pleasant St, Unit 301 & P96",
    "parcel_id": "037-03-22",
    "owner1": "BEVILAQUA TR, RALPH A",
    "owner2": "",
    "current_taxes": 8799.23,
    "new_taxes_no_override": 9179.36,
    "override_total_1": 9439.81,
    "override_increase_1": 260.46
  },
  {
    "#": "135 Pleasant St, Unit 302 & P32 (037-03-23)",
    "$": 685500,
    "address": "135 Pleasant St, Unit 302 & P32",
    "parcel_id": "037-03-23",
    "owner1": "GONZALEZ-FLECHA, BEATRIZ",
    "owner2": "",
    "current_taxes": 3384.59,
    "new_taxes_no_override": 3530.8,
    "override_total_1": 3630.99,
    "override_increase_1": 100.18
  },
  {
    "#": "135 Pleasant St, Unit 303 & P14 (037-03-24)",
    "$": 828400,
    "address": "135 Pleasant St, Unit 303 & P14",
    "parcel_id": "037-03-24",
    "owner1": "MANDELBAUM TR, ROSE B",
    "owner2": "",
    "current_taxes": 4847.88,
    "new_taxes_no_override": 5057.31,
    "override_total_1": 5200.81,
    "override_increase_1": 143.5
  },
  {
    "#": "135 Pleasant St, Unit 304 (037-03-25)",
    "$": 845300,
    "address": "135 Pleasant St, Unit 304",
    "parcel_id": "037-03-25",
    "owner1": "LEIPMAN, SARAH G & SUSAN N",
    "owner2": "ROBERGE, JOHN H",
    "current_taxes": 8655.87,
    "new_taxes_no_override": 9029.8,
    "override_total_1": 9286.02,
    "override_increase_1": 256.21
  },
  {
    "#": "135 Pleasant St, Unit 305 & P13 (037-03-26)",
    "$": 718800,
    "address": "135 Pleasant St, Unit 305 & P13",
    "parcel_id": "037-03-26",
    "owner1": "NATHANSON, DAN & SINAIA",
    "owner2": "",
    "current_taxes": 7360.51,
    "new_taxes_no_override": 7678.48,
    "override_total_1": 7896.36,
    "override_increase_1": 217.87
  },
  {
    "#": "135 Pleasant St, Unit 306 & P76 (037-03-27)",
    "$": 771800,
    "address": "135 Pleasant St, Unit 306 & P76",
    "parcel_id": "037-03-27",
    "owner1": "CHEN TRS, GUO",
    "owner2": "TUAN, HAN FANG",
    "current_taxes": 4268.3,
    "new_taxes_no_override": 4452.69,
    "override_total_1": 4579.03,
    "override_increase_1": 126.34
  },
  {
    "#": "135 Pleasant St, Unit 307 & P27R (037-03-28)",
    "$": 718900,
    "address": "135 Pleasant St, Unit 307 & P27R",
    "parcel_id": "037-03-28",
    "owner1": "MAKEDON, FILLIA",
    "owner2": "",
    "current_taxes": 7361.54,
    "new_taxes_no_override": 7679.56,
    "override_total_1": 7897.46,
    "override_increase_1": 217.9
  },
  {
    "#": "135 Pleasant St, Unit 308 & P87 (037-03-29)",
    "$": 829800,
    "address": "135 Pleasant St, Unit 308 & P87",
    "parcel_id": "037-03-29",
    "owner1": "MAKEDON, FILLIA S",
    "owner2": "",
    "current_taxes": 8497.15,
    "new_taxes_no_override": 8864.23,
    "override_total_1": 9115.74,
    "override_increase_1": 251.52
  },
  {
    "#": "135 Pleasant St, Unit 309 & P72 (037-03-30)",
    "$": 820200,
    "address": "135 Pleasant St, Unit 309 & P72",
    "parcel_id": "037-03-30",
    "owner1": "HWANG, KIUCHUL & EDWARD",
    "owner2": "",
    "current_taxes": 4763.91,
    "new_taxes_no_override": 4969.71,
    "override_total_1": 5110.72,
    "override_increase_1": 141.01
  },
  {
    "#": "135 Pleasant St, Unit 310 & P10L (037-03-31)",
    "$": 688700,
    "address": "135 Pleasant St, Unit 310 & P10L",
    "parcel_id": "037-03-31",
    "owner1": "CHEN, LILLIAN Y & DOROTHY Y",
    "owner2": "",
    "current_taxes": 7052.29,
    "new_taxes_no_override": 7356.95,
    "override_total_1": 7565.7,
    "override_increase_1": 208.75
  },
  {
    "#": "135 Pleasant St, Unit 311 & P92 (037-03-32)",
    "$": 815100,
    "address": "135 Pleasant St, Unit 311 & P92",
    "parcel_id": "037-03-32",
    "owner1": "SNYDER, RICHARD D & SUSAN R",
    "owner2": "",
    "current_taxes": 4711.69,
    "new_taxes_no_override": 4915.24,
    "override_total_1": 5054.7,
    "override_increase_1": 139.47
  },
  {
    "#": "135 Pleasant St, Unit 401 & P93 (037-03-33)",
    "$": 867200,
    "address": "135 Pleasant St, Unit 401 & P93",
    "parcel_id": "037-03-33",
    "owner1": "DUGAL, NEHA & ARJUN S",
    "owner2": "",
    "current_taxes": 8880.13,
    "new_taxes_no_override": 9263.75,
    "override_total_1": 9526.6,
    "override_increase_1": 262.85
  },
  {
    "#": "135 Pleasant St, Unit 402 & P107 (037-03-34)",
    "$": 685500,
    "address": "135 Pleasant St, Unit 402 & P107",
    "parcel_id": "037-03-34",
    "owner1": "NOAM LLC",
    "owner2": "",
    "current_taxes": 7019.52,
    "new_taxes_no_override": 7322.76,
    "override_total_1": 7530.54,
    "override_increase_1": 207.78
  },
  {
    "#": "135 Pleasant St, Unit 403 & P73 (037-03-35)",
    "$": 802800,
    "address": "135 Pleasant St, Unit 403 & P73",
    "parcel_id": "037-03-35",
    "owner1": "CHU ETAL, FRED TZE-YU & CLAUDIA LICHIEH & LESLIE LIYING",
    "owner2": "PAN, JAU-AN",
    "current_taxes": 8220.67,
    "new_taxes_no_override": 8575.8,
    "override_total_1": 8819.13,
    "override_increase_1": 243.33
  },
  {
    "#": "135 Pleasant St, Unit 404 & P109 (037-03-36)",
    "$": 864500,
    "address": "135 Pleasant St, Unit 404 & P109",
    "parcel_id": "037-03-36",
    "owner1": "MEDEIROS, GRETCHEN",
    "owner2": "",
    "current_taxes": 8852.48,
    "new_taxes_no_override": 9234.91,
    "override_total_1": 9496.94,
    "override_increase_1": 262.03
  },
  {
    "#": "135 Pleasant St, Unit 405 & P127 (037-03-37)",
    "$": 688000,
    "address": "135 Pleasant St, Unit 405 & P127",
    "parcel_id": "037-03-37",
    "owner1": "CHANG TRS, DAVID & ROBERT & MICHAEL",
    "owner2": "CHANG, ALICE S",
    "current_taxes": 7045.12,
    "new_taxes_no_override": 7349.47,
    "override_total_1": 7558.0,
    "override_increase_1": 208.54
  },
  {
    "#": "135 Pleasant St, Unit 406 & P79 (037-03-38)",
    "$": 739700,
    "address": "135 Pleasant St, Unit 406 & P79",
    "parcel_id": "037-03-38",
    "owner1": "FELDMAN, MATAN",
    "owner2": "",
    "current_taxes": 7574.53,
    "new_taxes_no_override": 7901.75,
    "override_total_1": 8125.96,
    "override_increase_1": 224.21
  },
  {
    "#": "135 Pleasant St, Unit 407 & P33R (037-03-39)",
    "$": 751000,
    "address": "135 Pleasant St, Unit 407 & P33R",
    "parcel_id": "037-03-39",
    "owner1": "KIANI, SALMA",
    "owner2": "",
    "current_taxes": 7690.24,
    "new_taxes_no_override": 8022.46,
    "override_total_1": 8250.09,
    "override_increase_1": 227.63
  },
  {
    "#": "135 Pleasant St, Unit 408 & P71 (037-03-40)",
    "$": 829800,
    "address": "135 Pleasant St, Unit 408 & P71",
    "parcel_id": "037-03-40",
    "owner1": "TURNER, LANE G",
    "owner2": "",
    "current_taxes": 4862.22,
    "new_taxes_no_override": 5072.27,
    "override_total_1": 5216.19,
    "override_increase_1": 143.92
  },
  {
    "#": "135 Pleasant St, Unit 409 & P119 (037-03-41)",
    "$": 762800,
    "address": "135 Pleasant St, Unit 409 & P119",
    "parcel_id": "037-03-41",
    "owner1": "REICHENTHAL TR, CAROL",
    "owner2": "",
    "current_taxes": 4176.14,
    "new_taxes_no_override": 4356.55,
    "override_total_1": 4480.16,
    "override_increase_1": 123.61
  },
  {
    "#": "135 Pleasant St, Unit 410 & P58 (037-03-42)",
    "$": 701000,
    "address": "135 Pleasant St, Unit 410 & P58",
    "parcel_id": "037-03-42",
    "owner1": "WILSON, SARAH",
    "owner2": "",
    "current_taxes": 3543.31,
    "new_taxes_no_override": 3696.38,
    "override_total_1": 3801.26,
    "override_increase_1": 104.88
  },
  {
    "#": "135 Pleasant St, Unit 411 & P63 (037-03-43)",
    "$": 799800,
    "address": "135 Pleasant St, Unit 411 & P63",
    "parcel_id": "037-03-43",
    "owner1": "DENG, NANHUA & NANNI",
    "owner2": "",
    "current_taxes": 4555.02,
    "new_taxes_no_override": 4751.8,
    "override_total_1": 4886.63,
    "override_increase_1": 134.83
  },
  {
    "#": "135 Pleasant St, Unit 501 & P85 (037-03-44)",
    "$": 878400,
    "address": "135 Pleasant St, Unit 501 & P85",
    "parcel_id": "037-03-44",
    "owner1": "DINER, STEVEN-HASIA-SHIRA",
    "owner2": "",
    "current_taxes": 5359.88,
    "new_taxes_no_override": 5591.43,
    "override_total_1": 5750.08,
    "override_increase_1": 158.65
  },
  {
    "#": "135 Pleasant St, Unit 502 & P95L (037-03-45)",
    "$": 685500,
    "address": "135 Pleasant St, Unit 502 & P95L",
    "parcel_id": "037-03-45",
    "owner1": "DRAGOS, JUDITH M",
    "owner2": "C/O JOHNSON JUDITH",
    "current_taxes": 7019.52,
    "new_taxes_no_override": 7322.76,
    "override_total_1": 7530.54,
    "override_increase_1": 207.78
  },
  {
    "#": "135 Pleasant St, Unit 503&P20-21 (037-03-46)",
    "$": 961600,
    "address": "135 Pleasant St, Unit 503&P20-21",
    "parcel_id": "037-03-46",
    "owner1": "DUCHNOWSKI, PAUL",
    "owner2": "NELSON, KAREN L",
    "current_taxes": 6211.85,
    "new_taxes_no_override": 6480.2,
    "override_total_1": 6664.07,
    "override_increase_1": 183.87
  },
  {
    "#": "135 Pleasant St, Unit 504 & P18 (037-03-47)",
    "$": 864600,
    "address": "135 Pleasant St, Unit 504 & P18",
    "parcel_id": "037-03-47",
    "owner1": "HUANG, CHIEN CHIH",
    "owner2": "LI, SZU HUA",
    "current_taxes": 8853.5,
    "new_taxes_no_override": 9235.97,
    "override_total_1": 9498.03,
    "override_increase_1": 262.06
  },
  {
    "#": "135 Pleasant St, Unit 505 & P83 (037-03-48)",
    "$": 718800,
    "address": "135 Pleasant St, Unit 505 & P83",
    "parcel_id": "037-03-48",
    "owner1": "HANONO TRS, SAUL & EUGENIA SARA",
    "owner2": "",
    "current_taxes": 7360.51,
    "new_taxes_no_override": 7678.48,
    "override_total_1": 7896.36,
    "override_increase_1": 217.87
  },
  {
    "#": "135 Pleasant St, Unit 506 & P16L (037-03-49)",
    "$": 739700,
    "address": "135 Pleasant St, Unit 506 & P16L",
    "parcel_id": "037-03-49",
    "owner1": "NOAM LLC",
    "owner2": "",
    "current_taxes": 7574.53,
    "new_taxes_no_override": 7901.75,
    "override_total_1": 8125.96,
    "override_increase_1": 224.21
  },
  {
    "#": "135 Pleasant St, Unit 507 & P97 (037-03-50)",
    "$": 718800,
    "address": "135 Pleasant St, Unit 507 & P97",
    "parcel_id": "037-03-50",
    "owner1": "LEE TR, BEVERLY P",
    "owner2": "",
    "current_taxes": 7360.51,
    "new_taxes_no_override": 7678.48,
    "override_total_1": 7896.36,
    "override_increase_1": 217.87
  },
  {
    "#": "135 Pleasant St, Unit 508 & P69 (037-03-51)",
    "$": 829900,
    "address": "135 Pleasant St, Unit 508 & P69",
    "parcel_id": "037-03-51",
    "owner1": "ZHONG, QIANG",
    "owner2": "ZHANG, YING",
    "current_taxes": 8498.18,
    "new_taxes_no_override": 8865.3,
    "override_total_1": 9116.85,
    "override_increase_1": 251.55
  },
  {
    "#": "135 Pleasant St, Unit 509 & P61 (037-03-52)",
    "$": 802700,
    "address": "135 Pleasant St, Unit 509 & P61",
    "parcel_id": "037-03-52",
    "owner1": "HERSKOVITS, ARIE",
    "owner2": "",
    "current_taxes": 4584.71,
    "new_taxes_no_override": 4782.77,
    "override_total_1": 4918.48,
    "override_increase_1": 135.71
  },
  {
    "#": "135 Pleasant St, Unit 510 & P108 (037-03-53)",
    "$": 685500,
    "address": "135 Pleasant St, Unit 510 & P108",
    "parcel_id": "037-03-53",
    "owner1": "YUGAWA, LINELL E",
    "owner2": "",
    "current_taxes": 3384.59,
    "new_taxes_no_override": 3530.8,
    "override_total_1": 3630.99,
    "override_increase_1": 100.18
  },
  {
    "#": "135 Pleasant St, Unit 511 & P66 (037-03-54)",
    "$": 815900,
    "address": "135 Pleasant St, Unit 511 & P66",
    "parcel_id": "037-03-54",
    "owner1": "YAAR TRS, ISRAEL & MINA",
    "owner2": "",
    "current_taxes": 8354.82,
    "new_taxes_no_override": 8715.75,
    "override_total_1": 8963.05,
    "override_increase_1": 247.3
  },
  {
    "#": "135 Pleasant St, Unit 601 & P68 (037-03-55)",
    "$": 843800,
    "address": "135 Pleasant St, Unit 601 & P68",
    "parcel_id": "037-03-55",
    "owner1": "HOLTZMAN, ELEIZER",
    "owner2": "GEIFMAN, OSNAT",
    "current_taxes": 8640.51,
    "new_taxes_no_override": 9013.78,
    "override_total_1": 9269.54,
    "override_increase_1": 255.76
  },
  {
    "#": "135 Pleasant St, Unit 602 & P17 (037-03-56)",
    "$": 717600,
    "address": "135 Pleasant St, Unit 602 & P17",
    "parcel_id": "037-03-56",
    "owner1": "BLACKER, MARCI S",
    "owner2": "WEBBER TRS, PHILIP R & VICKI C",
    "current_taxes": 3713.29,
    "new_taxes_no_override": 3873.7,
    "override_total_1": 3983.62,
    "override_increase_1": 109.91
  },
  {
    "#": "135 Pleasant St, Unit 603 & P89 (037-03-57)",
    "$": 815700,
    "address": "135 Pleasant St, Unit 603 & P89",
    "parcel_id": "037-03-57",
    "owner1": "CHAKRAVORTY TRS, RUDRA",
    "owner2": "",
    "current_taxes": 8352.77,
    "new_taxes_no_override": 8713.61,
    "override_total_1": 8960.85,
    "override_increase_1": 247.24
  },
  {
    "#": "135 Pleasant St, Unit 604 & P19 (037-03-58)",
    "$": 944300,
    "address": "135 Pleasant St, Unit 604 & P19",
    "parcel_id": "037-03-58",
    "owner1": "LEE TR, BEVERLY P",
    "owner2": "",
    "current_taxes": 6034.7,
    "new_taxes_no_override": 6295.4,
    "override_total_1": 6474.03,
    "override_increase_1": 178.63
  },
  {
    "#": "135 Pleasant St, Unit 605 & P77 (037-03-59)",
    "$": 718900,
    "address": "135 Pleasant St, Unit 605 & P77",
    "parcel_id": "037-03-59",
    "owner1": "TAN TRS, RAYMOND & WEILEEN",
    "owner2": "",
    "current_taxes": 7361.54,
    "new_taxes_no_override": 7679.56,
    "override_total_1": 7897.46,
    "override_increase_1": 217.9
  },
  {
    "#": "135 Pleasant St, Unit 606 & P78 (037-03-60)",
    "$": 760000,
    "address": "135 Pleasant St, Unit 606 & P78",
    "parcel_id": "037-03-60",
    "owner1": "KARIMLI, FARID GUNDUZ OGLU",
    "owner2": "",
    "current_taxes": 4147.47,
    "new_taxes_no_override": 4326.64,
    "override_total_1": 4449.41,
    "override_increase_1": 122.77
  },
  {
    "#": "135 Pleasant St, Unit 608 & P74 (037-03-61)",
    "$": 1719700,
    "address": "135 Pleasant St, Unit 608 & P74",
    "parcel_id": "037-03-61",
    "owner1": "STEIN TR, CYNTHIA J",
    "owner2": "",
    "current_taxes": 13974.79,
    "new_taxes_no_override": 14578.5,
    "override_total_1": 14992.15,
    "override_increase_1": 413.65
  },
  {
    "#": "135 Pleasant St, Unit 610 & P26 (037-03-62)",
    "$": 685500,
    "address": "135 Pleasant St, Unit 610 & P26",
    "parcel_id": "037-03-62",
    "owner1": "LIPPNER, GABOR",
    "owner2": "ERDOS, DORA",
    "current_taxes": 7019.52,
    "new_taxes_no_override": 7322.76,
    "override_total_1": 7530.54,
    "override_increase_1": 207.78
  },
  {
    "#": "135 Pleasant St, Unit 611 & P75 (037-03-63)",
    "$": 834500,
    "address": "135 Pleasant St, Unit 611 & P75",
    "parcel_id": "037-03-63",
    "owner1": "ERDOS, DORA & PETERNE",
    "owner2": "LIPPNER, GABOR P",
    "current_taxes": 4910.35,
    "new_taxes_no_override": 5122.48,
    "override_total_1": 5267.82,
    "override_increase_1": 145.35
  },
  {
    "#": "136 Pleasant St (036-05-00)",
    "$": 3941900,
    "address": "136 Pleasant St",
    "parcel_id": "036-05-00",
    "owner1": "PART PLEASANT LP",
    "owner2": "MELIKIAN, TR, JOS",
    "current_taxes": 40365.06,
    "new_taxes_no_override": 42108.83,
    "override_total_1": 43303.64,
    "override_increase_1": 1194.81
  },
  {
    "#": "140 Pleasant St (036-04-00)",
    "$": 2435600,
    "address": "140 Pleasant St",
    "parcel_id": "036-04-00",
    "owner1": "MAKHORTOVA, NINA R",
    "owner2": "GREGORY, RICHARD I",
    "current_taxes": 21305.61,
    "new_taxes_no_override": 22226.01,
    "override_total_1": 22856.66,
    "override_increase_1": 630.65
  },
  {
    "#": "142 Pleasant St, Unit 1 (036-03-01)",
    "$": 1706300,
    "address": "142 Pleasant St, Unit 1",
    "parcel_id": "036-03-01",
    "owner1": "KALISSERY, BIJU",
    "owner2": "GOVINDAN, SAPNA",
    "current_taxes": 13837.58,
    "new_taxes_no_override": 14435.36,
    "override_total_1": 14844.96,
    "override_increase_1": 409.59
  },
  {
    "#": "142 Pleasant St, Unit 2 (036-03-02)",
    "$": 1706300,
    "address": "142 Pleasant St, Unit 2",
    "parcel_id": "036-03-02",
    "owner1": "DE LOS PINOS, ELISABET",
    "owner2": "",
    "current_taxes": 17472.51,
    "new_taxes_no_override": 18227.32,
    "override_total_1": 18744.51,
    "override_increase_1": 517.19
  },
  {
    "#": "150 Pleasant St, Unit 101 & G6 (027-01-01)",
    "$": 392600,
    "address": "150 Pleasant St, Unit 101 & G6",
    "parcel_id": "027-01-01",
    "owner1": "LAWLOR, JOSEPH P JR & JUNE M",
    "owner2": "",
    "current_taxes": 402.02,
    "new_taxes_no_override": 419.39,
    "override_total_1": 431.29,
    "override_increase_1": 11.9
  },
  {
    "#": "150 Pleasant St, Unit 102 & G7 (027-01-02)",
    "$": 315400,
    "address": "150 Pleasant St, Unit 102 & G7",
    "parcel_id": "027-01-02",
    "owner1": "SACHDEV, KIRIT D & DEVYANI K",
    "owner2": "",
    "current_taxes": 322.97,
    "new_taxes_no_override": 336.92,
    "override_total_1": 346.48,
    "override_increase_1": 9.56
  },
  {
    "#": "150 Pleasant St, Unit 201 (027-01-03)",
    "$": 370000,
    "address": "150 Pleasant St, Unit 201",
    "parcel_id": "027-01-03",
    "owner1": "ST AIDANS LLC",
    "owner2": "C/O PEABODY PROPERTIES",
    "current_taxes": 3788.8,
    "new_taxes_no_override": 3952.48,
    "override_total_1": 4064.62,
    "override_increase_1": 112.15
  },
  {
    "#": "150 Pleasant St, Unit 202 (027-01-04)",
    "$": 310600,
    "address": "150 Pleasant St, Unit 202",
    "parcel_id": "027-01-04",
    "owner1": "ST AIDANS LLC",
    "owner2": "C/O PEABODY PROPERTIES",
    "current_taxes": 3180.54,
    "new_taxes_no_override": 3317.94,
    "override_total_1": 3412.08,
    "override_increase_1": 94.14
  },
  {
    "#": "150 Pleasant St, Unit 203 (027-01-05)",
    "$": 259100,
    "address": "150 Pleasant St, Unit 203",
    "parcel_id": "027-01-05",
    "owner1": "ST AIDANS LLC",
    "owner2": "C/O PEABODY PROPERTIES",
    "current_taxes": 2653.18,
    "new_taxes_no_override": 2767.8,
    "override_total_1": 2846.33,
    "override_increase_1": 78.53
  },
  {
    "#": "150 Pleasant St, Unit 204 (027-01-06)",
    "$": 310500,
    "address": "150 Pleasant St, Unit 204",
    "parcel_id": "027-01-06",
    "owner1": "ST AIDANS  LLC",
    "owner2": "C/O PEABODY PROPERTIES",
    "current_taxes": 3179.52,
    "new_taxes_no_override": 3316.88,
    "override_total_1": 3410.99,
    "override_increase_1": 94.11
  },
  {
    "#": "150 Pleasant St, Unit 205 (027-01-07)",
    "$": 310500,
    "address": "150 Pleasant St, Unit 205",
    "parcel_id": "027-01-07",
    "owner1": "ST AIDANS LLC",
    "owner2": "C/O PEABODY PROPERTIES",
    "current_taxes": 3179.52,
    "new_taxes_no_override": 3316.88,
    "override_total_1": 3410.99,
    "override_increase_1": 94.11
  },
  {
    "#": "150 Pleasant St, Unit 206 (027-01-08)",
    "$": 310500,
    "address": "150 Pleasant St, Unit 206",
    "parcel_id": "027-01-08",
    "owner1": "ST AIDANS LLC",
    "owner2": "C/O PEABODY PROPERTIES",
    "current_taxes": 3179.52,
    "new_taxes_no_override": 3316.88,
    "override_total_1": 3410.99,
    "override_increase_1": 94.11
  },
  {
    "#": "150 Pleasant St, Unit 207 & G40 (027-01-09)",
    "$": 310600,
    "address": "150 Pleasant St, Unit 207 & G40",
    "parcel_id": "027-01-09",
    "owner1": "DUBOVSKIY, NIKOLAY YAKOVLEVICH&YAKOV",
    "owner2": "",
    "current_taxes": 318.05,
    "new_taxes_no_override": 331.79,
    "override_total_1": 341.2,
    "override_increase_1": 9.41
  },
  {
    "#": "150 Pleasant St, Unit 208 (027-01-10)",
    "$": 259000,
    "address": "150 Pleasant St, Unit 208",
    "parcel_id": "027-01-10",
    "owner1": "ST AIDANS LLC",
    "owner2": "C/O PEABODY PROPERTIES",
    "current_taxes": 2652.16,
    "new_taxes_no_override": 2766.73,
    "override_total_1": 2845.24,
    "override_increase_1": 78.5
  },
  {
    "#": "150 Pleasant St, Unit 209 & G41 (027-01-11)",
    "$": 310500,
    "address": "150 Pleasant St, Unit 209 & G41",
    "parcel_id": "027-01-11",
    "owner1": "ZHOU, WEI M",
    "owner2": "ZHANG, JIE QUN",
    "current_taxes": 317.95,
    "new_taxes_no_override": 331.69,
    "override_total_1": 341.1,
    "override_increase_1": 9.41
  },
  {
    "#": "150 Pleasant St, Unit 301 (027-01-12)",
    "$": 370000,
    "address": "150 Pleasant St, Unit 301",
    "parcel_id": "027-01-12",
    "owner1": "ST AIDANS  LLC",
    "owner2": "C/O PEABODY PROPERTIES",
    "current_taxes": 3788.8,
    "new_taxes_no_override": 3952.48,
    "override_total_1": 4064.62,
    "override_increase_1": 112.15
  },
  {
    "#": "150 Pleasant St, Unit 302 & G8 (027-01-13)",
    "$": 310500,
    "address": "150 Pleasant St, Unit 302 & G8",
    "parcel_id": "027-01-13",
    "owner1": "KELLY, SHAR J",
    "owner2": "",
    "current_taxes": 317.95,
    "new_taxes_no_override": 331.69,
    "override_total_1": 341.1,
    "override_increase_1": 9.41
  },
  {
    "#": "150 Pleasant St, Unit 303 (027-01-14)",
    "$": 259000,
    "address": "150 Pleasant St, Unit 303",
    "parcel_id": "027-01-14",
    "owner1": "ST AIDANS LLC",
    "owner2": "C/O PEABODY PROPERTIES",
    "current_taxes": 2652.16,
    "new_taxes_no_override": 2766.73,
    "override_total_1": 2845.24,
    "override_increase_1": 78.5
  },
  {
    "#": "150 Pleasant St, Unit 304 (027-01-15)",
    "$": 310500,
    "address": "150 Pleasant St, Unit 304",
    "parcel_id": "027-01-15",
    "owner1": "ST AIDANS  LLC",
    "owner2": "C/O PEABODY PROPERTIES",
    "current_taxes": 3179.52,
    "new_taxes_no_override": 3316.88,
    "override_total_1": 3410.99,
    "override_increase_1": 94.11
  },
  {
    "#": "150 Pleasant St, Unit 305 (027-01-16)",
    "$": 310500,
    "address": "150 Pleasant St, Unit 305",
    "parcel_id": "027-01-16",
    "owner1": "ST AIDANS LLC",
    "owner2": "C/O PEABODY PROPERTIES",
    "current_taxes": 3179.52,
    "new_taxes_no_override": 3316.88,
    "override_total_1": 3410.99,
    "override_increase_1": 94.11
  },
  {
    "#": "150 Pleasant St, Unit 306 (027-01-17)",
    "$": 310500,
    "address": "150 Pleasant St, Unit 306",
    "parcel_id": "027-01-17",
    "owner1": "ST AIDANS  LLC",
    "owner2": "C/O PEABODY PROPERTIES",
    "current_taxes": 3179.52,
    "new_taxes_no_override": 3316.88,
    "override_total_1": 3410.99,
    "override_increase_1": 94.11
  },
  {
    "#": "150 Pleasant St, Unit 307 & G42 (027-01-18)",
    "$": 310500,
    "address": "150 Pleasant St, Unit 307 & G42",
    "parcel_id": "027-01-18",
    "owner1": "NORMAN-SALAKO, TITILOLA E",
    "owner2": "",
    "current_taxes": 3179.52,
    "new_taxes_no_override": 3316.88,
    "override_total_1": 3410.99,
    "override_increase_1": 94.11
  },
  {
    "#": "150 Pleasant St, Unit 308 & G1 (027-01-19)",
    "$": 260700,
    "address": "150 Pleasant St, Unit 308 & G1",
    "parcel_id": "027-01-19",
    "owner1": "PANIKOV, FEDOR",
    "owner2": "",
    "current_taxes": 266.96,
    "new_taxes_no_override": 278.49,
    "override_total_1": 286.39,
    "override_increase_1": 7.9
  },
  {
    "#": "150 Pleasant St, Unit 309 & G43 (027-01-20)",
    "$": 310500,
    "address": "150 Pleasant St, Unit 309 & G43",
    "parcel_id": "027-01-20",
    "owner1": "SHIN, HAE SOOK",
    "owner2": "",
    "current_taxes": 317.95,
    "new_taxes_no_override": 331.69,
    "override_total_1": 341.1,
    "override_increase_1": 9.41
  },
  {
    "#": "150 Pleasant St, Unit 401 & G44 (027-01-21)",
    "$": 310500,
    "address": "150 Pleasant St, Unit 401 & G44",
    "parcel_id": "027-01-21",
    "owner1": "CHEN, MINGHUA",
    "owner2": "",
    "current_taxes": 317.95,
    "new_taxes_no_override": 331.69,
    "override_total_1": 341.1,
    "override_increase_1": 9.41
  },
  {
    "#": "150 Pleasant St, Unit 402 & G65 (027-01-22)",
    "$": 260700,
    "address": "150 Pleasant St, Unit 402 & G65",
    "parcel_id": "027-01-22",
    "owner1": "HARTMAN, DANIEL",
    "owner2": "",
    "current_taxes": 266.96,
    "new_taxes_no_override": 278.49,
    "override_total_1": 286.39,
    "override_increase_1": 7.9
  },
  {
    "#": "150 Pleasant St, Unit 403 (027-01-23)",
    "$": 310500,
    "address": "150 Pleasant St, Unit 403",
    "parcel_id": "027-01-23",
    "owner1": "ST AIDANS LLC",
    "owner2": "C/O PEABODY PROPERTIES",
    "current_taxes": 3179.52,
    "new_taxes_no_override": 3316.88,
    "override_total_1": 3410.99,
    "override_increase_1": 94.11
  },
  {
    "#": "150 Pleasant St, Unit 404 (027-01-24)",
    "$": 310500,
    "address": "150 Pleasant St, Unit 404",
    "parcel_id": "027-01-24",
    "owner1": "ST AIDANS LLC",
    "owner2": "C/O PEABODY PROPERTIES",
    "current_taxes": 3179.52,
    "new_taxes_no_override": 3316.88,
    "override_total_1": 3410.99,
    "override_increase_1": 94.11
  },
  {
    "#": "150 Pleasant St, Unit 405 (027-01-25)",
    "$": 310500,
    "address": "150 Pleasant St, Unit 405",
    "parcel_id": "027-01-25",
    "owner1": "ST AIDANS  LLC",
    "owner2": "C/O PEABODY PROPERTIES",
    "current_taxes": 3179.52,
    "new_taxes_no_override": 3316.88,
    "override_total_1": 3410.99,
    "override_increase_1": 94.11
  },
  {
    "#": "150 Pleasant St, Unit 406 (027-01-26)",
    "$": 310500,
    "address": "150 Pleasant St, Unit 406",
    "parcel_id": "027-01-26",
    "owner1": "ST AIDANS  LLC",
    "owner2": "C/O PEABODY PROPERTIES",
    "current_taxes": 3179.52,
    "new_taxes_no_override": 3316.88,
    "override_total_1": 3410.99,
    "override_increase_1": 94.11
  },
  {
    "#": "150 Pleasant St, Unit 407 & G45 (027-01-27)",
    "$": 310500,
    "address": "150 Pleasant St, Unit 407 & G45",
    "parcel_id": "027-01-27",
    "owner1": "HUANG, JING YI",
    "owner2": "SITU, SHAO FENG",
    "current_taxes": 317.95,
    "new_taxes_no_override": 331.69,
    "override_total_1": 341.1,
    "override_increase_1": 9.41
  },
  {
    "#": "150 Pleasant St, Unit 408 & G3 (027-01-28)",
    "$": 259000,
    "address": "150 Pleasant St, Unit 408 & G3",
    "parcel_id": "027-01-28",
    "owner1": "SIU, CECILIA C F",
    "owner2": "",
    "current_taxes": 265.22,
    "new_taxes_no_override": 276.68,
    "override_total_1": 284.53,
    "override_increase_1": 7.85
  },
  {
    "#": "150 Pleasant St, Unit 409 & G46 (027-01-29)",
    "$": 310500,
    "address": "150 Pleasant St, Unit 409 & G46",
    "parcel_id": "027-01-29",
    "owner1": "PAN, JUNDA",
    "owner2": "",
    "current_taxes": 317.95,
    "new_taxes_no_override": 331.69,
    "override_total_1": 341.1,
    "override_increase_1": 9.41
  },
  {
    "#": "150 Pleasant St, Unit 501 (027-01-30)",
    "$": 370000,
    "address": "150 Pleasant St, Unit 501",
    "parcel_id": "027-01-30",
    "owner1": "ST AIDANS LLC",
    "owner2": "C/O PEABODY PROPERTIES",
    "current_taxes": 3788.8,
    "new_taxes_no_override": 3952.48,
    "override_total_1": 4064.62,
    "override_increase_1": 112.15
  },
  {
    "#": "150 Pleasant St, Unit 502 (027-01-31)",
    "$": 310500,
    "address": "150 Pleasant St, Unit 502",
    "parcel_id": "027-01-31",
    "owner1": "ST AIDANS LLC",
    "owner2": "C/O PEABODY PROPERTIES",
    "current_taxes": 3179.52,
    "new_taxes_no_override": 3316.88,
    "override_total_1": 3410.99,
    "override_increase_1": 94.11
  },
  {
    "#": "150 Pleasant St, Unit 503 (027-01-32)",
    "$": 310500,
    "address": "150 Pleasant St, Unit 503",
    "parcel_id": "027-01-32",
    "owner1": "ST AIDANS LLC",
    "owner2": "C/O PEABODY PROPERTIES",
    "current_taxes": 3179.52,
    "new_taxes_no_override": 3316.88,
    "override_total_1": 3410.99,
    "override_increase_1": 94.11
  },
  {
    "#": "150 Pleasant St, Unit 504 (027-01-33)",
    "$": 310500,
    "address": "150 Pleasant St, Unit 504",
    "parcel_id": "027-01-33",
    "owner1": "ST AIDANS LLC",
    "owner2": "C/O PEABODY PROPERTIES",
    "current_taxes": 3179.52,
    "new_taxes_no_override": 3316.88,
    "override_total_1": 3410.99,
    "override_increase_1": 94.11
  },
  {
    "#": "150 Pleasant St, Unit 505 & G47 (027-01-34)",
    "$": 310500,
    "address": "150 Pleasant St, Unit 505 & G47",
    "parcel_id": "027-01-34",
    "owner1": "POBEDNOV, VICTOR A",
    "owner2": "POBEDNOVA, TATIANA V",
    "current_taxes": 317.95,
    "new_taxes_no_override": 331.69,
    "override_total_1": 341.1,
    "override_increase_1": 9.41
  },
  {
    "#": "150 Pleasant St, Unit 506 & G4 (027-01-35)",
    "$": 259000,
    "address": "150 Pleasant St, Unit 506 & G4",
    "parcel_id": "027-01-35",
    "owner1": "FAIR, STEPHEN G",
    "owner2": "",
    "current_taxes": 265.22,
    "new_taxes_no_override": 276.68,
    "override_total_1": 284.53,
    "override_increase_1": 7.85
  },
  {
    "#": "150 Pleasant St, Unit 507 & G64 (027-01-36)",
    "$": 310500,
    "address": "150 Pleasant St, Unit 507 & G64",
    "parcel_id": "027-01-36",
    "owner1": "PFARRER, DAVID M",
    "owner2": "BARTOO, GILLIAN E",
    "current_taxes": 3179.52,
    "new_taxes_no_override": 3316.88,
    "override_total_1": 3410.99,
    "override_increase_1": 94.11
  },
  {
    "#": "182 Pleasant St (031-03-00)",
    "$": 2226600,
    "address": "182 Pleasant St",
    "parcel_id": "031-03-00",
    "owner1": "CORMAN, CATHERINE A",
    "owner2": "PENZEL, MARKUS",
    "current_taxes": 19165.45,
    "new_taxes_no_override": 19993.4,
    "override_total_1": 20560.69,
    "override_increase_1": 567.3
  },
  {
    "#": "185 Pleasant St, Unit 1-1 & G10 (023-14-04)",
    "$": 1034000,
    "address": "185 Pleasant St, Unit 1-1 & G10",
    "parcel_id": "023-14-04",
    "owner1": "NEMETZ, JAMES & DOROTHY J",
    "owner2": "",
    "current_taxes": 10588.16,
    "new_taxes_no_override": 11045.57,
    "override_total_1": 11358.98,
    "override_increase_1": 313.41
  },
  {
    "#": "185 Pleasant St, Unit 1-2 & G12 (023-14-05)",
    "$": 944200,
    "address": "185 Pleasant St, Unit 1-2 & G12",
    "parcel_id": "023-14-05",
    "owner1": "KEEFE, MAUREEN C",
    "owner2": "",
    "current_taxes": 6033.67,
    "new_taxes_no_override": 6294.32,
    "override_total_1": 6472.92,
    "override_increase_1": 178.6
  },
  {
    "#": "185 Pleasant St, Unit 2-1 & G9 (023-14-06)",
    "$": 976200,
    "address": "185 Pleasant St, Unit 2-1 & G9",
    "parcel_id": "023-14-06",
    "owner1": "IMBER, SHARON",
    "owner2": "MCDONALD, ROBERT A",
    "current_taxes": 6361.35,
    "new_taxes_no_override": 6636.16,
    "override_total_1": 6824.46,
    "override_increase_1": 188.3
  },
  {
    "#": "185 Pleasant St, Unit 2-2 & G11 (023-14-07)",
    "$": 974600,
    "address": "185 Pleasant St, Unit 2-2 & G11",
    "parcel_id": "023-14-07",
    "owner1": "OLIVEIRA TRS, JUDITH M",
    "owner2": "",
    "current_taxes": 6344.97,
    "new_taxes_no_override": 6619.07,
    "override_total_1": 6806.88,
    "override_increase_1": 187.81
  },
  {
    "#": "185 Pleasant St, Unit 3-1 & G16 (023-14-08)",
    "$": 1015300,
    "address": "185 Pleasant St, Unit 3-1 & G16",
    "parcel_id": "023-14-08",
    "owner1": "KETKAR, KANCHAN",
    "owner2": "",
    "current_taxes": 10396.67,
    "new_taxes_no_override": 10845.81,
    "override_total_1": 11153.55,
    "override_increase_1": 307.74
  },
  {
    "#": "185 Pleasant St, Unit 3-2 & P19 (023-14-09)",
    "$": 991800,
    "address": "185 Pleasant St, Unit 3-2 & P19",
    "parcel_id": "023-14-09",
    "owner1": "HUANG, JINJUN",
    "owner2": "QIU, LING",
    "current_taxes": 6521.1,
    "new_taxes_no_override": 6802.81,
    "override_total_1": 6995.84,
    "override_increase_1": 193.02
  },
  {
    "#": "185 Pleasant St, Unit B-1 (023-14-03)",
    "$": 449700,
    "address": "185 Pleasant St, Unit B-1",
    "parcel_id": "023-14-03",
    "owner1": "RIORDAN, TIMOTHY",
    "owner2": "MESSINGER, GAYLE",
    "current_taxes": 4604.93,
    "new_taxes_no_override": 4803.86,
    "override_total_1": 4940.17,
    "override_increase_1": 136.31
  },
  {
    "#": "186 Pleasant St (031-02-00)",
    "$": 2136100,
    "address": "186 Pleasant St",
    "parcel_id": "031-02-00",
    "owner1": "EPSTEIN TRS, FRANK B & MARY A",
    "owner2": "",
    "current_taxes": 21873.66,
    "new_taxes_no_override": 22818.6,
    "override_total_1": 23466.06,
    "override_increase_1": 647.46
  },
  {
    "#": "193 Pleasant St, Unit 1-1 & G7 (023-14-10)",
    "$": 1034100,
    "address": "193 Pleasant St, Unit 1-1 & G7",
    "parcel_id": "023-14-10",
    "owner1": "TAYLOR, GERARD",
    "owner2": "ZION, HEATHER",
    "current_taxes": 6954.25,
    "new_taxes_no_override": 7254.67,
    "override_total_1": 7460.52,
    "override_increase_1": 205.85
  },
  {
    "#": "193 Pleasant St, Unit 1-2 & G6 (023-14-11)",
    "$": 980600,
    "address": "193 Pleasant St, Unit 1-2 & G6",
    "parcel_id": "023-14-11",
    "owner1": "GLICK, DAVID M",
    "owner2": "",
    "current_taxes": 6406.41,
    "new_taxes_no_override": 6683.17,
    "override_total_1": 6872.8,
    "override_increase_1": 189.63
  },
  {
    "#": "193 Pleasant St, Unit 2-1 & G13 (023-14-12)",
    "$": 997600,
    "address": "193 Pleasant St, Unit 2-1 & G13",
    "parcel_id": "023-14-12",
    "owner1": "SERIY TRS, VICTORIA",
    "owner2": "",
    "current_taxes": 10215.42,
    "new_taxes_no_override": 10656.73,
    "override_total_1": 10959.1,
    "override_increase_1": 302.38
  },
  {
    "#": "193 Pleasant St, Unit 2-2 & G8 (023-14-13)",
    "$": 944200,
    "address": "193 Pleasant St, Unit 2-2 & G8",
    "parcel_id": "023-14-13",
    "owner1": "GOLABCHI, FATEMEH NOUSHIN & SEYED A",
    "owner2": "",
    "current_taxes": 6033.67,
    "new_taxes_no_override": 6294.32,
    "override_total_1": 6472.92,
    "override_increase_1": 178.6
  },
  {
    "#": "193 Pleasant St, Unit 3-1 & G2 (023-14-14)",
    "$": 997600,
    "address": "193 Pleasant St, Unit 3-1 & G2",
    "parcel_id": "023-14-14",
    "owner1": "MIRNY, LEONID & ANNA",
    "owner2": "",
    "current_taxes": 6580.49,
    "new_taxes_no_override": 6864.77,
    "override_total_1": 7059.55,
    "override_increase_1": 194.78
  },
  {
    "#": "193 Pleasant St, Unit 3-2 & G1 (023-14-15)",
    "$": 961800,
    "address": "193 Pleasant St, Unit 3-2 & G1",
    "parcel_id": "023-14-15",
    "owner1": "KOVACH, ALEXANDRA ELIZABETH",
    "owner2": "",
    "current_taxes": 6213.9,
    "new_taxes_no_override": 6482.34,
    "override_total_1": 6666.27,
    "override_increase_1": 183.93
  },
  {
    "#": "199 Pleasant St, Unit 1-1 (023-14-16)",
    "$": 813100,
    "address": "199 Pleasant St, Unit 1-1",
    "parcel_id": "023-14-16",
    "owner1": "DUROCHER TR, BRIAN G",
    "owner2": "",
    "current_taxes": 4691.21,
    "new_taxes_no_override": 4893.87,
    "override_total_1": 5032.73,
    "override_increase_1": 138.86
  },
  {
    "#": "199 Pleasant St, Unit 1-2 & G3 (023-14-17)",
    "$": 997600,
    "address": "199 Pleasant St, Unit 1-2 & G3",
    "parcel_id": "023-14-17",
    "owner1": "GLANTS LIFE ESTATE, ALEX & MUSYA",
    "owner2": "",
    "current_taxes": 6580.49,
    "new_taxes_no_override": 6864.77,
    "override_total_1": 7059.55,
    "override_increase_1": 194.78
  },
  {
    "#": "199 Pleasant St, Unit 2-1 (023-14-18)",
    "$": 786300,
    "address": "199 Pleasant St, Unit 2-1",
    "parcel_id": "023-14-18",
    "owner1": "VIGNA TR, PAUL A",
    "owner2": "",
    "current_taxes": 8051.71,
    "new_taxes_no_override": 8399.54,
    "override_total_1": 8637.87,
    "override_increase_1": 238.33
  },
  {
    "#": "199 Pleasant St, Unit 2-2 & G4 (023-14-19)",
    "$": 1020100,
    "address": "199 Pleasant St, Unit 2-2 & G4",
    "parcel_id": "023-14-19",
    "owner1": "CIEMPA, JEFFREY S & SHANNON R",
    "owner2": "",
    "current_taxes": 6810.89,
    "new_taxes_no_override": 7105.12,
    "override_total_1": 7306.72,
    "override_increase_1": 201.6
  },
  {
    "#": "199 Pleasant St, Unit 3-1 & P17 (023-14-20)",
    "$": 836500,
    "address": "199 Pleasant St, Unit 3-1 & P17",
    "parcel_id": "023-14-20",
    "owner1": "DEPIS, FABIEN",
    "owner2": "TACCON, CLAIRE",
    "current_taxes": 4930.83,
    "new_taxes_no_override": 5143.84,
    "override_total_1": 5289.79,
    "override_increase_1": 145.95
  },
  {
    "#": "199 Pleasant St, Unit 3-2 & G5 (023-14-21)",
    "$": 1016700,
    "address": "199 Pleasant St, Unit 3-2 & G5",
    "parcel_id": "023-14-21",
    "owner1": "BASTARACHE, CLARENCE & DANA",
    "owner2": "",
    "current_taxes": 10411.01,
    "new_taxes_no_override": 10860.77,
    "override_total_1": 11168.93,
    "override_increase_1": 308.17
  },
  {
    "#": "204 Pleasant St (030-02-00)",
    "$": 2903100,
    "address": "204 Pleasant St",
    "parcel_id": "030-02-00",
    "owner1": "DISERIO, MICHELE",
    "owner2": "",
    "current_taxes": 26092.81,
    "new_taxes_no_override": 27220.02,
    "override_total_1": 27992.37,
    "override_increase_1": 772.35
  },
  {
    "#": "222 Pleasant St (029-02-00)",
    "$": 2527900,
    "address": "222 Pleasant St",
    "parcel_id": "029-02-00",
    "owner1": "MEARS TRS, CHRISTOPHER J",
    "owner2": "KATZ, KAREN L",
    "current_taxes": 22250.76,
    "new_taxes_no_override": 23211.99,
    "override_total_1": 23870.62,
    "override_increase_1": 658.62
  },
  {
    "#": "228 Pleasant St (029-01-00)",
    "$": 2845200,
    "address": "228 Pleasant St",
    "parcel_id": "029-01-00",
    "owner1": "KAWKABANI, NADINE",
    "owner2": "",
    "current_taxes": 25499.91,
    "new_taxes_no_override": 26601.51,
    "override_total_1": 27356.3,
    "override_increase_1": 754.8
  },
  {
    "#": "9 Plowgate Rd (375B-02-00)",
    "$": 1486500,
    "address": "9 Plowgate Rd",
    "parcel_id": "375B-02-00",
    "owner1": "KESSEL TRS, SHIRLEY & STEVEN P",
    "owner2": "",
    "current_taxes": 11586.83,
    "new_taxes_no_override": 12087.38,
    "override_total_1": 12430.35,
    "override_increase_1": 342.97
  },
  {
    "#": "10 Plowgate Rd (375A-12-00)",
    "$": 1195300,
    "address": "10 Plowgate Rd",
    "parcel_id": "375A-12-00",
    "owner1": "PODJARSKI, ISAAC & OLGA",
    "owner2": "",
    "current_taxes": 8604.94,
    "new_taxes_no_override": 8976.67,
    "override_total_1": 9231.38,
    "override_increase_1": 254.71
  },
  {
    "#": "14 Plowgate Rd (375A-11-00)",
    "$": 1608400,
    "address": "14 Plowgate Rd",
    "parcel_id": "375A-11-00",
    "owner1": "PIZER, STEVEN D & HILLARY F",
    "owner2": "",
    "current_taxes": 12835.08,
    "new_taxes_no_override": 13389.56,
    "override_total_1": 13769.47,
    "override_increase_1": 379.92
  },
  {
    "#": "17 Plowgate Rd (375B-04-00)",
    "$": 3379600,
    "address": "17 Plowgate Rd",
    "parcel_id": "375B-04-00",
    "owner1": "CHALETSKY, SANDRA R",
    "owner2": "",
    "current_taxes": 34607.1,
    "new_taxes_no_override": 36102.13,
    "override_total_1": 37126.5,
    "override_increase_1": 1024.37
  },
  {
    "#": "20 Plowgate Rd (375A-10-00)",
    "$": 1185700,
    "address": "20 Plowgate Rd",
    "parcel_id": "375A-10-00",
    "owner1": "KATZ, JEFFREY N",
    "owner2": "ZEIGER, SUSAN",
    "current_taxes": 8506.63,
    "new_taxes_no_override": 8874.12,
    "override_total_1": 9125.91,
    "override_increase_1": 251.8
  },
  {
    "#": "25 Plowgate Rd (375B-05-00)",
    "$": 2042800,
    "address": "25 Plowgate Rd",
    "parcel_id": "375B-05-00",
    "owner1": "SMITH, NICOLE A",
    "owner2": "LAWSON, GARETH L",
    "current_taxes": 17283.34,
    "new_taxes_no_override": 18029.98,
    "override_total_1": 18541.57,
    "override_increase_1": 511.59
  },
  {
    "#": "26 Plowgate Rd (375A-09-00)",
    "$": 1434500,
    "address": "26 Plowgate Rd",
    "parcel_id": "375A-09-00",
    "owner1": "MCGRATH, NEAL F",
    "owner2": "LEVIN, NANCY",
    "current_taxes": 11054.35,
    "new_taxes_no_override": 11531.9,
    "override_total_1": 11859.11,
    "override_increase_1": 327.21
  },
  {
    "#": "31 Plowgate Rd (375B-06-00)",
    "$": 1581700,
    "address": "31 Plowgate Rd",
    "parcel_id": "375B-06-00",
    "owner1": "BRAHMBHATT TRS, BENITA",
    "owner2": "KHOR, DENISE",
    "current_taxes": 12561.67,
    "new_taxes_no_override": 13104.33,
    "override_total_1": 13476.16,
    "override_increase_1": 371.83
  },
  {
    "#": "32 Plowgate Rd (375A-08-00)",
    "$": 1348200,
    "address": "32 Plowgate Rd",
    "parcel_id": "375A-08-00",
    "owner1": "BELTON, DAVID J & SUSAN J",
    "owner2": "",
    "current_taxes": 10170.63,
    "new_taxes_no_override": 10610.0,
    "override_total_1": 10911.05,
    "override_increase_1": 301.05
  },
  {
    "#": "35 Plowgate Rd (375B-07-00)",
    "$": 1439400,
    "address": "35 Plowgate Rd",
    "parcel_id": "375B-07-00",
    "owner1": "GOTTLIEB, DANIEL J",
    "owner2": "BAK, SHARON M",
    "current_taxes": 11104.52,
    "new_taxes_no_override": 11584.24,
    "override_total_1": 11912.93,
    "override_increase_1": 328.69
  },
  {
    "#": "33 Pond Ave, Unit 1001 (287-13-95)",
    "$": 423300,
    "address": "33 Pond Ave, Unit 1001",
    "parcel_id": "287-13-95",
    "owner1": "KARIMI, ALI M",
    "owner2": "",
    "current_taxes": 4334.59,
    "new_taxes_no_override": 4521.84,
    "override_total_1": 4650.15,
    "override_increase_1": 128.3
  },
  {
    "#": "33 Pond Ave, Unit 1002 P267 (287-13-96)",
    "$": 461200,
    "address": "33 Pond Ave, Unit 1002 P267",
    "parcel_id": "287-13-96",
    "owner1": "WU, SHWU RU & JUNG  & EILEEN",
    "owner2": "",
    "current_taxes": 4722.69,
    "new_taxes_no_override": 4926.71,
    "override_total_1": 5066.5,
    "override_increase_1": 139.79
  },
  {
    "#": "33 Pond Ave, Unit 1003 349&A (287-13-97)",
    "$": 740800,
    "address": "33 Pond Ave, Unit 1003 349&A",
    "parcel_id": "287-13-97",
    "owner1": "WALKER, JEFFREY D & DAVID C & ELIZABETH ANN",
    "owner2": "",
    "current_taxes": 3950.86,
    "new_taxes_no_override": 4121.54,
    "override_total_1": 4238.48,
    "override_increase_1": 116.95
  },
  {
    "#": "33 Pond Ave, Unit 1004 (287-13-98)",
    "$": 458400,
    "address": "33 Pond Ave, Unit 1004",
    "parcel_id": "287-13-98",
    "owner1": "DINERMAN, HARRY",
    "owner2": "",
    "current_taxes": 1059.08,
    "new_taxes_no_override": 1104.83,
    "override_total_1": 1136.18,
    "override_increase_1": 31.35
  },
  {
    "#": "33 Pond Ave, Unit 1005 P377 (287-13-99)",
    "$": 733400,
    "address": "33 Pond Ave, Unit 1005 P377",
    "parcel_id": "287-13-99",
    "owner1": "BROWN, ELEANOR C",
    "owner2": "",
    "current_taxes": 7510.02,
    "new_taxes_no_override": 7834.45,
    "override_total_1": 8056.75,
    "override_increase_1": 222.3
  },
  {
    "#": "33 Pond Ave, Unit 1006 603&A (287-14-00)",
    "$": 618200,
    "address": "33 Pond Ave, Unit 1006 603&A",
    "parcel_id": "287-14-00",
    "owner1": "LEW TRS, LEO",
    "owner2": "LI, LAI M",
    "current_taxes": 6330.37,
    "new_taxes_no_override": 6603.84,
    "override_total_1": 6791.22,
    "override_increase_1": 187.38
  },
  {
    "#": "33 Pond Ave, Unit 1007 P110 (287-14-01)",
    "$": 594900,
    "address": "33 Pond Ave, Unit 1007 P110",
    "parcel_id": "287-14-01",
    "owner1": "HARLAP PROPERTY LLC",
    "owner2": "",
    "current_taxes": 6091.78,
    "new_taxes_no_override": 6354.94,
    "override_total_1": 6535.26,
    "override_increase_1": 180.32
  },
  {
    "#": "33 Pond Ave, Unit 1008 P390 (287-14-02)",
    "$": 509400,
    "address": "33 Pond Ave, Unit 1008 P390",
    "parcel_id": "287-14-02",
    "owner1": "OBARA, KAYOKO",
    "owner2": "",
    "current_taxes": 5216.26,
    "new_taxes_no_override": 5441.6,
    "override_total_1": 5596.0,
    "override_increase_1": 154.4
  },
  {
    "#": "33 Pond Ave, Unit 1009 (287-14-03)",
    "$": 524100,
    "address": "33 Pond Ave, Unit 1009",
    "parcel_id": "287-14-03",
    "owner1": "TRAN, THU",
    "owner2": "",
    "current_taxes": 5366.78,
    "new_taxes_no_override": 5598.62,
    "override_total_1": 5757.48,
    "override_increase_1": 158.86
  },
  {
    "#": "33 Pond Ave, Unit 1010 361&A (287-14-04)",
    "$": 497300,
    "address": "33 Pond Ave, Unit 1010 361&A",
    "parcel_id": "287-14-04",
    "owner1": "SHAYEGAN TR, BIJAN",
    "owner2": "",
    "current_taxes": 5092.35,
    "new_taxes_no_override": 5312.34,
    "override_total_1": 5463.07,
    "override_increase_1": 150.73
  },
  {
    "#": "33 Pond Ave, Unit 1011 P408 (287-14-05)",
    "$": 557600,
    "address": "33 Pond Ave, Unit 1011 P408",
    "parcel_id": "287-14-05",
    "owner1": "CHEN, CHUNG YANG",
    "owner2": "",
    "current_taxes": 5709.82,
    "new_taxes_no_override": 5956.48,
    "override_total_1": 6125.49,
    "override_increase_1": 169.01
  },
  {
    "#": "33 Pond Ave, Unit 1012 P151 (287-14-06)",
    "$": 456500,
    "address": "33 Pond Ave, Unit 1012 P151",
    "parcel_id": "287-14-06",
    "owner1": "CHO, STEVEN & MYUNG JIN",
    "owner2": "",
    "current_taxes": 1039.63,
    "new_taxes_no_override": 1084.54,
    "override_total_1": 1115.32,
    "override_increase_1": 30.77
  },
  {
    "#": "33 Pond Ave, Unit 1013 P248 (287-14-07)",
    "$": 471800,
    "address": "33 Pond Ave, Unit 1013 P248",
    "parcel_id": "287-14-07",
    "owner1": "TANZER TR, KEVIN",
    "owner2": "",
    "current_taxes": 4831.23,
    "new_taxes_no_override": 5039.94,
    "override_total_1": 5182.94,
    "override_increase_1": 143.0
  },
  {
    "#": "33 Pond Ave, Unit 1014 P200 (287-14-08)",
    "$": 481300,
    "address": "33 Pond Ave, Unit 1014 P200",
    "parcel_id": "287-14-08",
    "owner1": "PARANGI TR, MAHSA & SAREH",
    "owner2": "",
    "current_taxes": 4928.51,
    "new_taxes_no_override": 5141.42,
    "override_total_1": 5287.31,
    "override_increase_1": 145.88
  },
  {
    "#": "33 Pond Ave, Unit 1015 P173 (287-14-09)",
    "$": 581300,
    "address": "33 Pond Ave, Unit 1015 P173",
    "parcel_id": "287-14-09",
    "owner1": "ZODIAC ASSOCIATES LP",
    "owner2": "",
    "current_taxes": 5952.51,
    "new_taxes_no_override": 6209.66,
    "override_total_1": 6385.85,
    "override_increase_1": 176.19
  },
  {
    "#": "33 Pond Ave, Unit 1016 P625 (287-14-10)",
    "$": 509400,
    "address": "33 Pond Ave, Unit 1016 P625",
    "parcel_id": "287-14-10",
    "owner1": "GANGAPUTRA, SACHIN",
    "owner2": "BHATA, NEHA S",
    "current_taxes": 5216.26,
    "new_taxes_no_override": 5441.6,
    "override_total_1": 5596.0,
    "override_increase_1": 154.4
  },
  {
    "#": "33 Pond Ave, Unit 1017 P399 (287-14-11)",
    "$": 581300,
    "address": "33 Pond Ave, Unit 1017 P399",
    "parcel_id": "287-14-11",
    "owner1": "RHEINGOLD TR, LINDA COURTISS",
    "owner2": "",
    "current_taxes": 5952.51,
    "new_taxes_no_override": 6209.66,
    "override_total_1": 6385.85,
    "override_increase_1": 176.19
  },
  {
    "#": "33 Pond Ave, Unit 1018 P283 (287-14-12)",
    "$": 581300,
    "address": "33 Pond Ave, Unit 1018 P283",
    "parcel_id": "287-14-12",
    "owner1": "ELOUAZZANI, MOUNAIM",
    "owner2": "",
    "current_taxes": 5952.51,
    "new_taxes_no_override": 6209.66,
    "override_total_1": 6385.85,
    "override_increase_1": 176.19
  },
  {
    "#": "33 Pond Ave, Unit 1019 P72&A (287-14-13)",
    "$": 799500,
    "address": "33 Pond Ave, Unit 1019 P72&A",
    "parcel_id": "287-14-13",
    "owner1": "DESAI, SUKUMAR P & MANISHA S",
    "owner2": "",
    "current_taxes": 8186.88,
    "new_taxes_no_override": 8540.55,
    "override_total_1": 8782.88,
    "override_increase_1": 242.33
  },
  {
    "#": "33 Pond Ave, Unit 1020 P202 (287-14-14)",
    "$": 573600,
    "address": "33 Pond Ave, Unit 1020 P202",
    "parcel_id": "287-14-14",
    "owner1": "SU, WEI-SHING & STACEY",
    "owner2": "",
    "current_taxes": 5873.66,
    "new_taxes_no_override": 6127.4,
    "override_total_1": 6301.26,
    "override_increase_1": 173.86
  },
  {
    "#": "33 Pond Ave, Unit 1021 P223 (287-14-15)",
    "$": 769400,
    "address": "33 Pond Ave, Unit 1021 P223",
    "parcel_id": "287-14-15",
    "owner1": "TUFTS TRS, HENRY H",
    "owner2": "GARZA, RENE",
    "current_taxes": 4243.72,
    "new_taxes_no_override": 4427.05,
    "override_total_1": 4552.66,
    "override_increase_1": 125.61
  },
  {
    "#": "33 Pond Ave, Unit 1022 P201 (287-14-16)",
    "$": 503200,
    "address": "33 Pond Ave, Unit 1022 P201",
    "parcel_id": "287-14-16",
    "owner1": "LIN TR, FRANK T",
    "owner2": "",
    "current_taxes": 5152.77,
    "new_taxes_no_override": 5375.37,
    "override_total_1": 5527.89,
    "override_increase_1": 152.52
  },
  {
    "#": "33 Pond Ave, Unit 1023 P89&A (287-14-17)",
    "$": 738300,
    "address": "33 Pond Ave, Unit 1023 P89&A",
    "parcel_id": "287-14-17",
    "owner1": "FANG, KUO-KANG & PAU-CHO",
    "owner2": "",
    "current_taxes": 7560.19,
    "new_taxes_no_override": 7886.79,
    "override_total_1": 8110.57,
    "override_increase_1": 223.78
  },
  {
    "#": "33 Pond Ave, Unit 1024 P587 (287-14-18)",
    "$": 794600,
    "address": "33 Pond Ave, Unit 1024 P587",
    "parcel_id": "287-14-18",
    "owner1": "WANG, FELICIA",
    "owner2": "",
    "current_taxes": 4501.77,
    "new_taxes_no_override": 4696.25,
    "override_total_1": 4829.5,
    "override_increase_1": 133.25
  },
  {
    "#": "33 Pond Ave, Unit 1101 551&A (287-14-19)",
    "$": 494700,
    "address": "33 Pond Ave, Unit 1101 551&A",
    "parcel_id": "287-14-19",
    "owner1": "GRKOVICH TR, LJILJANA",
    "owner2": "",
    "current_taxes": 5065.73,
    "new_taxes_no_override": 5284.57,
    "override_total_1": 5434.52,
    "override_increase_1": 149.95
  },
  {
    "#": "33 Pond Ave, Unit 1102 (287-14-20)",
    "$": 431000,
    "address": "33 Pond Ave, Unit 1102",
    "parcel_id": "287-14-20",
    "owner1": "CHEN, ALBERT",
    "owner2": "",
    "current_taxes": 4413.44,
    "new_taxes_no_override": 4604.1,
    "override_total_1": 4734.74,
    "override_increase_1": 130.64
  },
  {
    "#": "33 Pond Ave, Unit 1103 P362 (287-14-21)",
    "$": 642800,
    "address": "33 Pond Ave, Unit 1103 P362",
    "parcel_id": "287-14-21",
    "owner1": "XIE, WENFEI",
    "owner2": "",
    "current_taxes": 6582.27,
    "new_taxes_no_override": 6866.62,
    "override_total_1": 7061.46,
    "override_increase_1": 194.84
  },
  {
    "#": "33 Pond Ave, Unit 1104 (287-14-22)",
    "$": 536600,
    "address": "33 Pond Ave, Unit 1104",
    "parcel_id": "287-14-22",
    "owner1": "SONG, WENJUN",
    "owner2": "",
    "current_taxes": 1859.85,
    "new_taxes_no_override": 1940.2,
    "override_total_1": 1995.25,
    "override_increase_1": 55.05
  },
  {
    "#": "33 Pond Ave, Unit 1105 P73&A (287-14-23)",
    "$": 756600,
    "address": "33 Pond Ave, Unit 1105 P73&A",
    "parcel_id": "287-14-23",
    "owner1": "LIPMAN LIFE ESTATE, ANN RUTH",
    "owner2": "",
    "current_taxes": 4112.65,
    "new_taxes_no_override": 4290.32,
    "override_total_1": 4412.05,
    "override_increase_1": 121.73
  },
  {
    "#": "33 Pond Ave, Unit 1106 (287-14-24)",
    "$": 531300,
    "address": "33 Pond Ave, Unit 1106",
    "parcel_id": "287-14-24",
    "owner1": "REISS, ROBIN",
    "owner2": "",
    "current_taxes": 1805.58,
    "new_taxes_no_override": 1883.58,
    "override_total_1": 1937.03,
    "override_increase_1": 53.45
  },
  {
    "#": "33 Pond Ave, Unit 1107 P156 (287-14-25)",
    "$": 594900,
    "address": "33 Pond Ave, Unit 1107 P156",
    "parcel_id": "287-14-25",
    "owner1": "NAHRA SAAD, DANIEL J",
    "owner2": "CABALLERO, CECILIA G",
    "current_taxes": 2456.84,
    "new_taxes_no_override": 2562.98,
    "override_total_1": 2635.7,
    "override_increase_1": 72.72
  },
  {
    "#": "33 Pond Ave, Unit 1108 & P68 (287-14-26)",
    "$": 516600,
    "address": "33 Pond Ave, Unit 1108 & P68",
    "parcel_id": "287-14-26",
    "owner1": "GROSS, REBECCA",
    "owner2": "",
    "current_taxes": 1655.05,
    "new_taxes_no_override": 1726.55,
    "override_total_1": 1775.54,
    "override_increase_1": 48.99
  },
  {
    "#": "33 Pond Ave, Unit 1109 P256 (287-14-27)",
    "$": 591000,
    "address": "33 Pond Ave, Unit 1109 P256",
    "parcel_id": "287-14-27",
    "owner1": "DEPINTO TR, JOHN",
    "owner2": "",
    "current_taxes": 6051.84,
    "new_taxes_no_override": 6313.28,
    "override_total_1": 6492.41,
    "override_increase_1": 179.13
  },
  {
    "#": "33 Pond Ave, Unit 1110 P371 (287-14-28)",
    "$": 487200,
    "address": "33 Pond Ave, Unit 1110 P371",
    "parcel_id": "287-14-28",
    "owner1": "YANAGAWA, KYOSUKE",
    "owner2": "",
    "current_taxes": 4988.93,
    "new_taxes_no_override": 5204.45,
    "override_total_1": 5352.12,
    "override_increase_1": 147.67
  },
  {
    "#": "33 Pond Ave, Unit 1111 P184 (287-14-29)",
    "$": 565400,
    "address": "33 Pond Ave, Unit 1111 P184",
    "parcel_id": "287-14-29",
    "owner1": "BOURTMAN, ILYA",
    "owner2": "",
    "current_taxes": 5789.7,
    "new_taxes_no_override": 6039.82,
    "override_total_1": 6211.19,
    "override_increase_1": 171.38
  },
  {
    "#": "33 Pond Ave, Unit 1112 P405 (287-14-30)",
    "$": 471800,
    "address": "33 Pond Ave, Unit 1112 P405",
    "parcel_id": "287-14-30",
    "owner1": "33 POND AVE UNIT 1112 LLC",
    "owner2": "",
    "current_taxes": 4831.23,
    "new_taxes_no_override": 5039.94,
    "override_total_1": 5182.94,
    "override_increase_1": 143.0
  },
  {
    "#": "33 Pond Ave, Unit 1113 P182 (287-14-31)",
    "$": 476500,
    "address": "33 Pond Ave, Unit 1113 P182",
    "parcel_id": "287-14-31",
    "owner1": "MANGOUBI TR, URSULA",
    "owner2": "",
    "current_taxes": 4879.36,
    "new_taxes_no_override": 5090.15,
    "override_total_1": 5234.58,
    "override_increase_1": 144.43
  },
  {
    "#": "33 Pond Ave, Unit 1114 P389 (287-14-32)",
    "$": 549300,
    "address": "33 Pond Ave, Unit 1114 P389",
    "parcel_id": "287-14-32",
    "owner1": "SU, YING",
    "owner2": "",
    "current_taxes": 5624.83,
    "new_taxes_no_override": 5867.82,
    "override_total_1": 6034.32,
    "override_increase_1": 166.49
  },
  {
    "#": "33 Pond Ave, Unit 1115 P533 (287-14-33)",
    "$": 573600,
    "address": "33 Pond Ave, Unit 1115 P533",
    "parcel_id": "287-14-33",
    "owner1": "DASTJERDI, DIBA",
    "owner2": "GOLKARI, HAMID",
    "current_taxes": 2238.73,
    "new_taxes_no_override": 2335.44,
    "override_total_1": 2401.71,
    "override_increase_1": 66.27
  },
  {
    "#": "33 Pond Ave, Unit 1116 P245 (287-14-34)",
    "$": 509400,
    "address": "33 Pond Ave, Unit 1116 P245",
    "parcel_id": "287-14-34",
    "owner1": "WU TRS, ELAINE K",
    "owner2": "NIEPEL TR, MICHELE",
    "current_taxes": 5216.26,
    "new_taxes_no_override": 5441.6,
    "override_total_1": 5596.0,
    "override_increase_1": 154.4
  },
  {
    "#": "33 Pond Ave, Unit 1117 P87&A (287-14-35)",
    "$": 618200,
    "address": "33 Pond Ave, Unit 1117 P87&A",
    "parcel_id": "287-14-35",
    "owner1": "MILLER TRS, DEANNA L",
    "owner2": "CULVER, EMILE W JR",
    "current_taxes": 6330.37,
    "new_taxes_no_override": 6603.84,
    "override_total_1": 6791.22,
    "override_increase_1": 187.38
  },
  {
    "#": "33 Pond Ave, Unit 1118 & P637 (287-14-36)",
    "$": 581300,
    "address": "33 Pond Ave, Unit 1118 & P637",
    "parcel_id": "287-14-36",
    "owner1": "SHAHBAZI, MITRA",
    "owner2": "",
    "current_taxes": 5952.51,
    "new_taxes_no_override": 6209.66,
    "override_total_1": 6385.85,
    "override_increase_1": 176.19
  },
  {
    "#": "33 Pond Ave, Unit 1119 P78&A (287-14-37)",
    "$": 777600,
    "address": "33 Pond Ave, Unit 1119 P78&A",
    "parcel_id": "287-14-37",
    "owner1": "LERNER, DEBRA I",
    "owner2": "",
    "current_taxes": 4327.69,
    "new_taxes_no_override": 4514.65,
    "override_total_1": 4642.75,
    "override_increase_1": 128.1
  },
  {
    "#": "33 Pond Ave, Unit 1120 P547 (287-14-38)",
    "$": 581300,
    "address": "33 Pond Ave, Unit 1120 P547",
    "parcel_id": "287-14-38",
    "owner1": "NAMBUDIRI, EASWARAN & DRAUPATHI",
    "owner2": "",
    "current_taxes": 5952.51,
    "new_taxes_no_override": 6209.66,
    "override_total_1": 6385.85,
    "override_increase_1": 176.19
  },
  {
    "#": "33 Pond Ave, Unit 1121 186&A (287-14-39)",
    "$": 770800,
    "address": "33 Pond Ave, Unit 1121 186&A",
    "parcel_id": "287-14-39",
    "owner1": "LASOSKI, ANNE MARIE",
    "owner2": "",
    "current_taxes": 4258.06,
    "new_taxes_no_override": 4442.01,
    "override_total_1": 4568.05,
    "override_increase_1": 126.04
  },
  {
    "#": "33 Pond Ave, Unit 1122 P453 (287-14-40)",
    "$": 503200,
    "address": "33 Pond Ave, Unit 1122 P453",
    "parcel_id": "287-14-40",
    "owner1": "WOODCLIFF REALTY LLC",
    "owner2": "",
    "current_taxes": 5152.77,
    "new_taxes_no_override": 5375.37,
    "override_total_1": 5527.89,
    "override_increase_1": 152.52
  },
  {
    "#": "33 Pond Ave, Unit 1123P552&A (287-14-41)",
    "$": 682100,
    "address": "33 Pond Ave, Unit 1123P552&A",
    "parcel_id": "287-14-41",
    "owner1": "CHEN, SHIN JONG & JESSIE L",
    "owner2": "",
    "current_taxes": 6984.7,
    "new_taxes_no_override": 7286.44,
    "override_total_1": 7493.19,
    "override_increase_1": 206.75
  },
  {
    "#": "33 Pond Ave, Unit 1124 548&A (287-14-42)",
    "$": 740900,
    "address": "33 Pond Ave, Unit 1124 548&A",
    "parcel_id": "287-14-42",
    "owner1": "INFORMATION DEVELOPMENT, AMERICA INC",
    "owner2": "C/O ABLE REAL ESTATE USA INC",
    "current_taxes": 7586.82,
    "new_taxes_no_override": 7914.57,
    "override_total_1": 8139.14,
    "override_increase_1": 224.57
  },
  {
    "#": "33 Pond Ave, Unit 1201 P303 (287-14-43)",
    "$": 523800,
    "address": "33 Pond Ave, Unit 1201 P303",
    "parcel_id": "287-14-43",
    "owner1": "PARK, SUN YOUNG",
    "owner2": "",
    "current_taxes": 1728.78,
    "new_taxes_no_override": 1803.46,
    "override_total_1": 1854.64,
    "override_increase_1": 51.17
  },
  {
    "#": "33 Pond Ave, Unit 1202 P189 (287-14-44)",
    "$": 520900,
    "address": "33 Pond Ave, Unit 1202 P189",
    "parcel_id": "287-14-44",
    "owner1": "PENG, RICHARD",
    "owner2": "",
    "current_taxes": 5334.02,
    "new_taxes_no_override": 5564.45,
    "override_total_1": 5722.34,
    "override_increase_1": 157.89
  },
  {
    "#": "33 Pond Ave, Unit 1203 P79&A (287-14-45)",
    "$": 721000,
    "address": "33 Pond Ave, Unit 1203 P79&A",
    "parcel_id": "287-14-45",
    "owner1": "SUMAN HOLDINGS LLC",
    "owner2": "",
    "current_taxes": 7383.04,
    "new_taxes_no_override": 7701.99,
    "override_total_1": 7920.53,
    "override_increase_1": 218.54
  },
  {
    "#": "33 Pond Ave, Unit 1204 188&A (287-14-46)",
    "$": 1110700,
    "address": "33 Pond Ave, Unit 1204 188&A",
    "parcel_id": "287-14-46",
    "owner1": "USATIN TR, MASHA",
    "owner2": "",
    "current_taxes": 11373.57,
    "new_taxes_no_override": 11864.91,
    "override_total_1": 12201.57,
    "override_increase_1": 336.66
  },
  {
    "#": "33 Pond Ave, Unit 1205 & P106 P287 (287-14-47)",
    "$": 1302700,
    "address": "33 Pond Ave, Unit 1205 & P106 P287",
    "parcel_id": "287-14-47",
    "owner1": "ROUHANI TR, SHIVA",
    "owner2": "",
    "current_taxes": 13339.65,
    "new_taxes_no_override": 13915.92,
    "override_total_1": 14310.78,
    "override_increase_1": 394.85
  },
  {
    "#": "33 Pond Ave, Unit 1206 P467 (287-14-48)",
    "$": 509400,
    "address": "33 Pond Ave, Unit 1206 P467",
    "parcel_id": "287-14-48",
    "owner1": "YEE, WINNIE",
    "owner2": "",
    "current_taxes": 1581.32,
    "new_taxes_no_override": 1649.63,
    "override_total_1": 1696.44,
    "override_increase_1": 46.81
  },
  {
    "#": "33 Pond Ave, Unit 1207 P75&A (287-14-49)",
    "$": 989100,
    "address": "33 Pond Ave, Unit 1207 P75&A",
    "parcel_id": "287-14-49",
    "owner1": "LICHTENSTEIN, EMILY",
    "owner2": "MINAHAN, JOHN",
    "current_taxes": 10128.38,
    "new_taxes_no_override": 10565.93,
    "override_total_1": 10865.73,
    "override_increase_1": 299.8
  },
  {
    "#": "33 Pond Ave, Unit 1208 334&A (287-14-50)",
    "$": 1018800,
    "address": "33 Pond Ave, Unit 1208 334&A",
    "parcel_id": "287-14-50",
    "owner1": "EKINCI, THERESA & KAMIL",
    "owner2": "",
    "current_taxes": 10432.51,
    "new_taxes_no_override": 10883.19,
    "override_total_1": 11192.0,
    "override_increase_1": 308.8
  },
  {
    "#": "33 Pond Ave, Unit 1209 &P158 (287-14-51)",
    "$": 483700,
    "address": "33 Pond Ave, Unit 1209 &P158",
    "parcel_id": "287-14-51",
    "owner1": "BROOK HOUSE REALTY LLC",
    "owner2": "",
    "current_taxes": 4953.09,
    "new_taxes_no_override": 5167.06,
    "override_total_1": 5313.67,
    "override_increase_1": 146.61
  },
  {
    "#": "33 Pond Ave, Unit 1210 & P99 (287-14-52)",
    "$": 481700,
    "address": "33 Pond Ave, Unit 1210 & P99",
    "parcel_id": "287-14-52",
    "owner1": "WEINER, JAY M",
    "owner2": "",
    "current_taxes": 4932.61,
    "new_taxes_no_override": 5145.7,
    "override_total_1": 5291.7,
    "override_increase_1": 146.01
  },
  {
    "#": "33 Pond Ave, Unit 1211 P71&A (287-14-53)",
    "$": 997500,
    "address": "33 Pond Ave, Unit 1211 P71&A",
    "parcel_id": "287-14-53",
    "owner1": "GREENLEAF VISTA LLC",
    "owner2": "",
    "current_taxes": 10214.4,
    "new_taxes_no_override": 10655.66,
    "override_total_1": 10958.01,
    "override_increase_1": 302.35
  },
  {
    "#": "33 Pond Ave, Unit 1212 353&A (287-14-54)",
    "$": 476900,
    "address": "33 Pond Ave, Unit 1212 353&A",
    "parcel_id": "287-14-54",
    "owner1": "KATZ, JOANNE",
    "owner2": "",
    "current_taxes": 1248.52,
    "new_taxes_no_override": 1302.46,
    "override_total_1": 1339.41,
    "override_increase_1": 36.96
  },
  {
    "#": "33 Pond Ave, Unit 1213 P319 (287-14-55)",
    "$": 461200,
    "address": "33 Pond Ave, Unit 1213 P319",
    "parcel_id": "287-14-55",
    "owner1": "COME, CAROLYN E",
    "owner2": "",
    "current_taxes": 1087.75,
    "new_taxes_no_override": 1134.74,
    "override_total_1": 1166.94,
    "override_increase_1": 32.2
  },
  {
    "#": "33 Pond Ave, Unit 1214 P280 (287-14-56)",
    "$": 481400,
    "address": "33 Pond Ave, Unit 1214 P280",
    "parcel_id": "287-14-56",
    "owner1": "LIN TR, DEBBIE WEI LONG",
    "owner2": "",
    "current_taxes": 4929.54,
    "new_taxes_no_override": 5142.5,
    "override_total_1": 5288.41,
    "override_increase_1": 145.91
  },
  {
    "#": "33 Pond Ave, Unit 1215 P69&A (287-14-57)",
    "$": 1190300,
    "address": "33 Pond Ave, Unit 1215 P69&A",
    "parcel_id": "287-14-57",
    "owner1": "GLASER, CHARLES L",
    "owner2": "CARTER, CAROL LEE",
    "current_taxes": 8553.74,
    "new_taxes_no_override": 8923.26,
    "override_total_1": 9176.45,
    "override_increase_1": 253.19
  },
  {
    "#": "33 Pond Ave, Unit 1216 P185 (287-14-58)",
    "$": 995200,
    "address": "33 Pond Ave, Unit 1216 P185",
    "parcel_id": "287-14-58",
    "owner1": "SACKSTEIN, ROBERT & BETH L",
    "owner2": "",
    "current_taxes": 10190.85,
    "new_taxes_no_override": 10631.09,
    "override_total_1": 10932.74,
    "override_increase_1": 301.65
  },
  {
    "#": "33 Pond Ave, Unit 1217 P118 (287-14-59)",
    "$": 509400,
    "address": "33 Pond Ave, Unit 1217 P118",
    "parcel_id": "287-14-59",
    "owner1": "SHTIFTER, ZVI",
    "owner2": "",
    "current_taxes": 5216.26,
    "new_taxes_no_override": 5441.6,
    "override_total_1": 5596.0,
    "override_increase_1": 154.4
  },
  {
    "#": "33 Pond Ave, Unit 1218 P395 (287-14-60)",
    "$": 509400,
    "address": "33 Pond Ave, Unit 1218 P395",
    "parcel_id": "287-14-60",
    "owner1": "CHHABRA, NARENDER K & VYJAYANTI",
    "owner2": "",
    "current_taxes": 5216.26,
    "new_taxes_no_override": 5441.6,
    "override_total_1": 5596.0,
    "override_increase_1": 154.4
  },
  {
    "#": "33 Pond Ave, Unit 1219 P70&A (287-14-61)",
    "$": 1248800,
    "address": "33 Pond Ave, Unit 1219 P70&A",
    "parcel_id": "287-14-61",
    "owner1": "SHINAGARE, ATUL B & SHWETA A",
    "owner2": "",
    "current_taxes": 9152.78,
    "new_taxes_no_override": 9548.18,
    "override_total_1": 9819.1,
    "override_increase_1": 270.92
  },
  {
    "#": "33 Pond Ave, Unit 1220 P127-P152 (287-14-62)",
    "$": 1097900,
    "address": "33 Pond Ave, Unit 1220 P127-P152",
    "parcel_id": "287-14-62",
    "owner1": "SHECHTER, SAGI & SHARON",
    "owner2": "",
    "current_taxes": 11242.5,
    "new_taxes_no_override": 11728.18,
    "override_total_1": 12060.95,
    "override_increase_1": 332.78
  },
  {
    "#": "33 Pond Ave, Unit 1221 P341 (287-14-63)",
    "$": 747600,
    "address": "33 Pond Ave, Unit 1221 P341",
    "parcel_id": "287-14-63",
    "owner1": "SMITH, STACEY I",
    "owner2": "",
    "current_taxes": 4020.49,
    "new_taxes_no_override": 4194.18,
    "override_total_1": 4313.18,
    "override_increase_1": 119.01
  },
  {
    "#": "33 Pond Ave, Unit 1222 (287-14-64)",
    "$": 529600,
    "address": "33 Pond Ave, Unit 1222",
    "parcel_id": "287-14-64",
    "owner1": "KUGLER, ALEJANDRO & ANN K",
    "owner2": "",
    "current_taxes": 5423.1,
    "new_taxes_no_override": 5657.38,
    "override_total_1": 5817.9,
    "override_increase_1": 160.52
  },
  {
    "#": "33 Pond Ave, Unit 1223 P490 (287-14-65)",
    "$": 658800,
    "address": "33 Pond Ave, Unit 1223 P490",
    "parcel_id": "287-14-65",
    "owner1": "CEJAS, PALOMA",
    "owner2": "",
    "current_taxes": 6746.11,
    "new_taxes_no_override": 7037.54,
    "override_total_1": 7237.23,
    "override_increase_1": 199.68
  },
  {
    "#": "33 Pond Ave, Unit 1224 P92&A (287-14-66)",
    "$": 721000,
    "address": "33 Pond Ave, Unit 1224 P92&A",
    "parcel_id": "287-14-66",
    "owner1": "MORCOS, EHAB F",
    "owner2": "ABEER, HANNA",
    "current_taxes": 7383.04,
    "new_taxes_no_override": 7701.99,
    "override_total_1": 7920.53,
    "override_increase_1": 218.54
  },
  {
    "#": "33 Pond Ave, Unit 1225 (287-17-73)",
    "$": 2171700,
    "address": "33 Pond Ave, Unit 1225",
    "parcel_id": "287-17-73",
    "owner1": "KAPLAN, SUSAN B",
    "owner2": "",
    "current_taxes": 18603.27,
    "new_taxes_no_override": 19406.93,
    "override_total_1": 19957.59,
    "override_increase_1": 550.66
  },
  {
    "#": "33 Pond Ave, Unit 201 & P195 (287-12-03)",
    "$": 516100,
    "address": "33 Pond Ave, Unit 201 & P195",
    "parcel_id": "287-12-03",
    "owner1": "MEI, MU YAN",
    "owner2": "",
    "current_taxes": 5284.86,
    "new_taxes_no_override": 5513.17,
    "override_total_1": 5669.6,
    "override_increase_1": 156.43
  },
  {
    "#": "33 Pond Ave, Unit 202 & P143 (287-12-04)",
    "$": 449700,
    "address": "33 Pond Ave, Unit 202 & P143",
    "parcel_id": "287-12-04",
    "owner1": "ZHANG, FAN",
    "owner2": "",
    "current_taxes": 969.99,
    "new_taxes_no_override": 1011.89,
    "override_total_1": 1040.61,
    "override_increase_1": 28.71
  },
  {
    "#": "33 Pond Ave, Unit 203 & P147 (287-12-05)",
    "$": 675800,
    "address": "33 Pond Ave, Unit 203 & P147",
    "parcel_id": "287-12-05",
    "owner1": "AZUKI CO LTD",
    "owner2": "",
    "current_taxes": 6920.19,
    "new_taxes_no_override": 7219.14,
    "override_total_1": 7423.98,
    "override_increase_1": 204.84
  },
  {
    "#": "33 Pond Ave, Unit 204 & P82 (287-12-06)",
    "$": 516600,
    "address": "33 Pond Ave, Unit 204 & P82",
    "parcel_id": "287-12-06",
    "owner1": "ANASTASIO, JOHN G",
    "owner2": "",
    "current_taxes": 5289.98,
    "new_taxes_no_override": 5518.51,
    "override_total_1": 5675.09,
    "override_increase_1": 156.58
  },
  {
    "#": "33 Pond Ave, Unit 205 & P132 (287-12-07)",
    "$": 791600,
    "address": "33 Pond Ave, Unit 205 & P132",
    "parcel_id": "287-12-07",
    "owner1": "SELIM, ALFREDO J C & MARIA A",
    "owner2": "",
    "current_taxes": 4471.05,
    "new_taxes_no_override": 4664.2,
    "override_total_1": 4796.54,
    "override_increase_1": 132.34
  },
  {
    "#": "33 Pond Ave, Unit 206 & P149 (287-12-08)",
    "$": 509400,
    "address": "33 Pond Ave, Unit 206 & P149",
    "parcel_id": "287-12-08",
    "owner1": "CROWLEY, JAMES J",
    "owner2": "C/O COLES AND BODOIN LLP",
    "current_taxes": 5216.26,
    "new_taxes_no_override": 5441.6,
    "override_total_1": 5596.0,
    "override_increase_1": 154.4
  },
  {
    "#": "33 Pond Ave, Unit 207 (287-12-09)",
    "$": 483900,
    "address": "33 Pond Ave, Unit 207",
    "parcel_id": "287-12-09",
    "owner1": "ARONSON, JAMES M",
    "owner2": "BREEN, MARY P",
    "current_taxes": 4955.14,
    "new_taxes_no_override": 5169.2,
    "override_total_1": 5315.87,
    "override_increase_1": 146.67
  },
  {
    "#": "33 Pond Ave, Unit 208 Pc494 (287-12-10)",
    "$": 519600,
    "address": "33 Pond Ave, Unit 208 Pc494",
    "parcel_id": "287-12-10",
    "owner1": "ARCHBALD, MICHELE A & ANTHONY J",
    "owner2": "",
    "current_taxes": 5320.7,
    "new_taxes_no_override": 5550.55,
    "override_total_1": 5708.05,
    "override_increase_1": 157.49
  },
  {
    "#": "33 Pond Ave, Unit 209 (287-12-11)",
    "$": 464400,
    "address": "33 Pond Ave, Unit 209",
    "parcel_id": "287-12-11",
    "owner1": "80 WASHINGTON STREET LLC",
    "owner2": "",
    "current_taxes": 4755.46,
    "new_taxes_no_override": 4960.9,
    "override_total_1": 5101.66,
    "override_increase_1": 140.76
  },
  {
    "#": "33 Pond Ave, Unit 210 (287-12-12)",
    "$": 415300,
    "address": "33 Pond Ave, Unit 210",
    "parcel_id": "287-12-12",
    "owner1": "MCBREARTY, KYLE",
    "owner2": "MESISCA, KELLY",
    "current_taxes": 4252.67,
    "new_taxes_no_override": 4436.39,
    "override_total_1": 4562.26,
    "override_increase_1": 125.88
  },
  {
    "#": "33 Pond Ave, Unit 211&P385 (287-12-13)",
    "$": 500200,
    "address": "33 Pond Ave, Unit 211&P385",
    "parcel_id": "287-12-13",
    "owner1": "BARNETT TR, BARBARA",
    "owner2": "",
    "current_taxes": 1487.11,
    "new_taxes_no_override": 1551.35,
    "override_total_1": 1595.37,
    "override_increase_1": 44.02
  },
  {
    "#": "33 Pond Ave, Unit 212 & P289 (287-12-14)",
    "$": 449700,
    "address": "33 Pond Ave, Unit 212 & P289",
    "parcel_id": "287-12-14",
    "owner1": "OLUMI TRS ET AL, ARIA",
    "owner2": "OLOUMI, ARUSHA",
    "current_taxes": 4604.93,
    "new_taxes_no_override": 4803.86,
    "override_total_1": 4940.17,
    "override_increase_1": 136.31
  },
  {
    "#": "33 Pond Ave, Unit 213 &P412 (287-12-15)",
    "$": 449700,
    "address": "33 Pond Ave, Unit 213 &P412",
    "parcel_id": "287-12-15",
    "owner1": "LEE, KUO-KANG TOM",
    "owner2": "",
    "current_taxes": 4604.93,
    "new_taxes_no_override": 4803.86,
    "override_total_1": 4940.17,
    "override_increase_1": 136.31
  },
  {
    "#": "33 Pond Ave, Unit 214 & P183 (287-12-16)",
    "$": 488500,
    "address": "33 Pond Ave, Unit 214 & P183",
    "parcel_id": "287-12-16",
    "owner1": "WENNERS TRS, MARYANNE",
    "owner2": "",
    "current_taxes": 1367.31,
    "new_taxes_no_override": 1426.38,
    "override_total_1": 1466.85,
    "override_increase_1": 40.47
  },
  {
    "#": "33 Pond Ave, Unit 215 (287-12-17)",
    "$": 483800,
    "address": "33 Pond Ave, Unit 215",
    "parcel_id": "287-12-17",
    "owner1": "CASTRO, KELLY",
    "owner2": "",
    "current_taxes": 1319.18,
    "new_taxes_no_override": 1376.17,
    "override_total_1": 1415.22,
    "override_increase_1": 39.05
  },
  {
    "#": "33 Pond Ave, Unit 216 & P105 (287-12-18)",
    "$": 509400,
    "address": "33 Pond Ave, Unit 216 & P105",
    "parcel_id": "287-12-18",
    "owner1": "ANDREYCHENKO LIFE ESTATE, ALEKSANDR & NATALIA",
    "owner2": "",
    "current_taxes": 1581.32,
    "new_taxes_no_override": 1649.63,
    "override_total_1": 1696.44,
    "override_increase_1": 46.81
  },
  {
    "#": "33 Pond Ave, Unit 217 (287-12-19)",
    "$": 483900,
    "address": "33 Pond Ave, Unit 217",
    "parcel_id": "287-12-19",
    "owner1": "HODGINS TR, CATHERINE A",
    "owner2": "",
    "current_taxes": 1320.2,
    "new_taxes_no_override": 1377.23,
    "override_total_1": 1416.31,
    "override_increase_1": 39.08
  },
  {
    "#": "33 Pond Ave, Unit 218 & P504 (287-12-20)",
    "$": 509400,
    "address": "33 Pond Ave, Unit 218 & P504",
    "parcel_id": "287-12-20",
    "owner1": "KRAM HOLDING LLC",
    "owner2": "",
    "current_taxes": 5216.26,
    "new_taxes_no_override": 5441.6,
    "override_total_1": 5596.0,
    "override_increase_1": 154.4
  },
  {
    "#": "33 Pond Ave, Unit 219 (287-12-21)",
    "$": 718000,
    "address": "33 Pond Ave, Unit 219",
    "parcel_id": "287-12-21",
    "owner1": "PASTERNACK, SUSAN",
    "owner2": "WEISSMAN, FRED",
    "current_taxes": 3717.39,
    "new_taxes_no_override": 3877.98,
    "override_total_1": 3988.02,
    "override_increase_1": 110.03
  },
  {
    "#": "33 Pond Ave, Unit 220 & P129 (287-12-22)",
    "$": 509400,
    "address": "33 Pond Ave, Unit 220 & P129",
    "parcel_id": "287-12-22",
    "owner1": "UPSTATE MED ANESTHESIOLOGY GRP",
    "owner2": "",
    "current_taxes": 5216.26,
    "new_taxes_no_override": 5441.6,
    "override_total_1": 5596.0,
    "override_increase_1": 154.4
  },
  {
    "#": "33 Pond Ave, Unit 221 (287-12-23)",
    "$": 689400,
    "address": "33 Pond Ave, Unit 221",
    "parcel_id": "287-12-23",
    "owner1": "NEMIROVSKAYA, LYUDMILA N",
    "owner2": "DUBOVSKIY, NIKOLAY",
    "current_taxes": 3424.52,
    "new_taxes_no_override": 3572.46,
    "override_total_1": 3673.83,
    "override_increase_1": 101.37
  },
  {
    "#": "33 Pond Ave, Unit 222 (287-12-24)",
    "$": 467500,
    "address": "33 Pond Ave, Unit 222",
    "parcel_id": "287-12-24",
    "owner1": "OLEARY, MARYELLEN & MICHAEL",
    "owner2": "",
    "current_taxes": 4787.2,
    "new_taxes_no_override": 4994.01,
    "override_total_1": 5135.71,
    "override_increase_1": 141.7
  },
  {
    "#": "33 Pond Ave, Unit 223 & P97 (287-12-25)",
    "$": 658800,
    "address": "33 Pond Ave, Unit 223 & P97",
    "parcel_id": "287-12-25",
    "owner1": "REID TRS, SCOTT K",
    "owner2": "CHOU, MARY TAO PEI",
    "current_taxes": 6746.11,
    "new_taxes_no_override": 7037.54,
    "override_total_1": 7237.23,
    "override_increase_1": 199.68
  },
  {
    "#": "33 Pond Ave, Unit 224 P539&A (287-12-26)",
    "$": 666100,
    "address": "33 Pond Ave, Unit 224 P539&A",
    "parcel_id": "287-12-26",
    "owner1": "PANZETTI ET AL TRS, CARMEN C",
    "owner2": "FERRAGAMO TR, KAREN",
    "current_taxes": 6820.86,
    "new_taxes_no_override": 7115.52,
    "override_total_1": 7317.42,
    "override_increase_1": 201.9
  },
  {
    "#": "33 Pond Ave, Unit 301 & P624 (287-12-27)",
    "$": 459000,
    "address": "33 Pond Ave, Unit 301 & P624",
    "parcel_id": "287-12-27",
    "owner1": "GABRE-MADHIN, SEBLE Z & ZAUDE",
    "owner2": "",
    "current_taxes": 4700.16,
    "new_taxes_no_override": 4903.21,
    "override_total_1": 5042.33,
    "override_increase_1": 139.12
  },
  {
    "#": "33 Pond Ave, Unit 302 & P227 (287-12-28)",
    "$": 456500,
    "address": "33 Pond Ave, Unit 302 & P227",
    "parcel_id": "287-12-28",
    "owner1": "KELLER, RENA M",
    "owner2": "",
    "current_taxes": 1039.63,
    "new_taxes_no_override": 1084.54,
    "override_total_1": 1115.32,
    "override_increase_1": 30.77
  },
  {
    "#": "33 Pond Ave, Unit 303 & P340 (287-12-29)",
    "$": 642800,
    "address": "33 Pond Ave, Unit 303 & P340",
    "parcel_id": "287-12-29",
    "owner1": "WORCESTER, CURTIS W",
    "owner2": "",
    "current_taxes": 2947.34,
    "new_taxes_no_override": 3074.67,
    "override_total_1": 3161.91,
    "override_increase_1": 87.24
  },
  {
    "#": "33 Pond Ave, Unit 304 (287-12-30)",
    "$": 515400,
    "address": "33 Pond Ave, Unit 304",
    "parcel_id": "287-12-30",
    "owner1": "SCJJ LLC",
    "owner2": "",
    "current_taxes": 5277.7,
    "new_taxes_no_override": 5505.7,
    "override_total_1": 5661.92,
    "override_increase_1": 156.22
  },
  {
    "#": "33 Pond Ave, Unit 305 & P294 (287-12-31)",
    "$": 772600,
    "address": "33 Pond Ave, Unit 305 & P294",
    "parcel_id": "287-12-31",
    "owner1": "DRABKIN TR, ALAN",
    "owner2": "GOLDMAN, ROSE H",
    "current_taxes": 4276.49,
    "new_taxes_no_override": 4461.23,
    "override_total_1": 4587.82,
    "override_increase_1": 126.58
  },
  {
    "#": "33 Pond Ave, Unit 306 (287-12-32)",
    "$": 458400,
    "address": "33 Pond Ave, Unit 306",
    "parcel_id": "287-12-32",
    "owner1": "BLAW LLC",
    "owner2": "C/O ARLENE LEHANE",
    "current_taxes": 4694.02,
    "new_taxes_no_override": 4896.8,
    "override_total_1": 5035.74,
    "override_increase_1": 138.94
  },
  {
    "#": "33 Pond Ave, Unit 307 & P430 (287-12-33)",
    "$": 509400,
    "address": "33 Pond Ave, Unit 307 & P430",
    "parcel_id": "287-12-33",
    "owner1": "ANTILES, MICHELLE",
    "owner2": "",
    "current_taxes": 1581.32,
    "new_taxes_no_override": 1649.63,
    "override_total_1": 1696.44,
    "override_increase_1": 46.81
  },
  {
    "#": "33 Pond Ave, Unit 308 & P292 (287-12-34)",
    "$": 526800,
    "address": "33 Pond Ave, Unit 308 & P292",
    "parcel_id": "287-12-34",
    "owner1": "JIN, LIANPING",
    "owner2": "",
    "current_taxes": 5394.43,
    "new_taxes_no_override": 5627.47,
    "override_total_1": 5787.14,
    "override_increase_1": 159.68
  },
  {
    "#": "33 Pond Ave, Unit 309 P550&A (287-12-35)",
    "$": 537000,
    "address": "33 Pond Ave, Unit 309 P550&A",
    "parcel_id": "287-12-35",
    "owner1": "WANG, DUO",
    "owner2": "DREW, MICHAEL & WILLIAM",
    "current_taxes": 5498.88,
    "new_taxes_no_override": 5736.43,
    "override_total_1": 5899.2,
    "override_increase_1": 162.77
  },
  {
    "#": "33 Pond Ave, Unit 310 & P648 (287-12-36)",
    "$": 461600,
    "address": "33 Pond Ave, Unit 310 & P648",
    "parcel_id": "287-12-36",
    "owner1": "DU, BO",
    "owner2": "WANG, KE",
    "current_taxes": 4726.78,
    "new_taxes_no_override": 4930.98,
    "override_total_1": 5070.89,
    "override_increase_1": 139.91
  },
  {
    "#": "33 Pond Ave, Unit 311 (287-12-37)",
    "$": 444400,
    "address": "33 Pond Ave, Unit 311",
    "parcel_id": "287-12-37",
    "owner1": "MCARTHUR, PATRICIA E",
    "owner2": "",
    "current_taxes": 915.72,
    "new_taxes_no_override": 955.28,
    "override_total_1": 982.38,
    "override_increase_1": 27.11
  },
  {
    "#": "33 Pond Ave, Unit 312 & P509 (287-12-38)",
    "$": 471800,
    "address": "33 Pond Ave, Unit 312 & P509",
    "parcel_id": "287-12-38",
    "owner1": "BEACON POND COMPANY LLC",
    "owner2": "",
    "current_taxes": 4831.23,
    "new_taxes_no_override": 5039.94,
    "override_total_1": 5182.94,
    "override_increase_1": 143.0
  },
  {
    "#": "33 Pond Ave, Unit 313 & P220 (287-12-39)",
    "$": 456500,
    "address": "33 Pond Ave, Unit 313 & P220",
    "parcel_id": "287-12-39",
    "owner1": "SAPOL, LINDA C",
    "owner2": "",
    "current_taxes": 1039.63,
    "new_taxes_no_override": 1084.54,
    "override_total_1": 1115.32,
    "override_increase_1": 30.77
  },
  {
    "#": "33 Pond Ave, Unit 314 & P672 (287-12-40)",
    "$": 498700,
    "address": "33 Pond Ave, Unit 314 & P672",
    "parcel_id": "287-12-40",
    "owner1": "QUACH, PAT",
    "owner2": "",
    "current_taxes": 1471.75,
    "new_taxes_no_override": 1535.33,
    "override_total_1": 1578.89,
    "override_increase_1": 43.56
  },
  {
    "#": "33 Pond Ave, Unit 315 (287-12-41)",
    "$": 458400,
    "address": "33 Pond Ave, Unit 315",
    "parcel_id": "287-12-41",
    "owner1": "REVZIN TR, MARC W",
    "owner2": "",
    "current_taxes": 1059.08,
    "new_taxes_no_override": 1104.83,
    "override_total_1": 1136.18,
    "override_increase_1": 31.35
  },
  {
    "#": "33 Pond Ave, Unit 316 & P321 (287-12-42)",
    "$": 509400,
    "address": "33 Pond Ave, Unit 316 & P321",
    "parcel_id": "287-12-42",
    "owner1": "SHAHBAZI, KIA",
    "owner2": "",
    "current_taxes": 1581.32,
    "new_taxes_no_override": 1649.63,
    "override_total_1": 1696.44,
    "override_increase_1": 46.81
  },
  {
    "#": "33 Pond Ave, Unit 317 & P102 (287-12-43)",
    "$": 581300,
    "address": "33 Pond Ave, Unit 317 & P102",
    "parcel_id": "287-12-43",
    "owner1": "FONG, BENNY & TERRENCE",
    "owner2": "",
    "current_taxes": 5952.51,
    "new_taxes_no_override": 6209.66,
    "override_total_1": 6385.85,
    "override_increase_1": 176.19
  },
  {
    "#": "33 Pond Ave, Unit 318 & P363 (287-12-44)",
    "$": 516600,
    "address": "33 Pond Ave, Unit 318 & P363",
    "parcel_id": "287-12-44",
    "owner1": "MANIMARAN, SOLAIAPPAN",
    "owner2": "",
    "current_taxes": 5289.98,
    "new_taxes_no_override": 5518.51,
    "override_total_1": 5675.09,
    "override_increase_1": 156.58
  },
  {
    "#": "33 Pond Ave, Unit 319 & P107 (287-12-45)",
    "$": 764600,
    "address": "33 Pond Ave, Unit 319 & P107",
    "parcel_id": "287-12-45",
    "owner1": "DOCKSER TR, ELLEN J",
    "owner2": "",
    "current_taxes": 4194.57,
    "new_taxes_no_override": 4375.78,
    "override_total_1": 4499.93,
    "override_increase_1": 124.16
  },
  {
    "#": "33 Pond Ave, Unit 320 (287-12-46)",
    "$": 473700,
    "address": "33 Pond Ave, Unit 320",
    "parcel_id": "287-12-46",
    "owner1": "PACSON TR, MARIO P",
    "owner2": "",
    "current_taxes": 4850.69,
    "new_taxes_no_override": 5060.24,
    "override_total_1": 5203.82,
    "override_increase_1": 143.58
  },
  {
    "#": "33 Pond Ave, Unit 321 P329&A (287-12-47)",
    "$": 816500,
    "address": "33 Pond Ave, Unit 321 P329&A",
    "parcel_id": "287-12-47",
    "owner1": "GEORGE ALAN HUGGINS FAMILY UNLIMITED PARTNERSHIP",
    "owner2": "C/O IAN HUGGINS",
    "current_taxes": 8360.96,
    "new_taxes_no_override": 8722.15,
    "override_total_1": 8969.64,
    "override_increase_1": 247.48
  },
  {
    "#": "33 Pond Ave, Unit 322 & P652 (287-12-48)",
    "$": 518500,
    "address": "33 Pond Ave, Unit 322 & P652",
    "parcel_id": "287-12-48",
    "owner1": "LITTLE TRS, JAMES DEREK",
    "owner2": "DOMOTO-REILLY, KIMIKO",
    "current_taxes": 5309.44,
    "new_taxes_no_override": 5538.81,
    "override_total_1": 5695.97,
    "override_increase_1": 157.16
  },
  {
    "#": "33 Pond Ave, Unit 323 (287-12-49)",
    "$": 658800,
    "address": "33 Pond Ave, Unit 323",
    "parcel_id": "287-12-49",
    "owner1": "JAC ACQUISITIONS-POND LLC",
    "owner2": "",
    "current_taxes": 6746.11,
    "new_taxes_no_override": 7037.54,
    "override_total_1": 7237.23,
    "override_increase_1": 199.68
  },
  {
    "#": "33 Pond Ave, Unit 324 & P93 (287-12-50)",
    "$": 642800,
    "address": "33 Pond Ave, Unit 324 & P93",
    "parcel_id": "287-12-50",
    "owner1": "MEROWITZ, MYRNA J",
    "owner2": "",
    "current_taxes": 6582.27,
    "new_taxes_no_override": 6866.62,
    "override_total_1": 7061.46,
    "override_increase_1": 194.84
  },
  {
    "#": "33 Pond Ave, Unit 401 & P136 (287-12-51)",
    "$": 466200,
    "address": "33 Pond Ave, Unit 401 & P136",
    "parcel_id": "287-12-51",
    "owner1": "PATNAIK, AKASH & VIKAS",
    "owner2": "",
    "current_taxes": 4773.89,
    "new_taxes_no_override": 4980.12,
    "override_total_1": 5121.43,
    "override_increase_1": 141.31
  },
  {
    "#": "33 Pond Ave, Unit 402 & P516 (287-12-52)",
    "$": 482000,
    "address": "33 Pond Ave, Unit 402 & P516",
    "parcel_id": "287-12-52",
    "owner1": "NISHIKAWA CO LTD",
    "owner2": "C/O RELO REDAC INC-MGMT 2201",
    "current_taxes": 4935.68,
    "new_taxes_no_override": 5148.9,
    "override_total_1": 5295.0,
    "override_increase_1": 146.1
  },
  {
    "#": "33 Pond Ave, Unit 403 P544&A (287-12-53)",
    "$": 666100,
    "address": "33 Pond Ave, Unit 403 P544&A",
    "parcel_id": "287-12-53",
    "owner1": "QUINN, JAMES J",
    "owner2": "",
    "current_taxes": 3185.93,
    "new_taxes_no_override": 3323.56,
    "override_total_1": 3417.87,
    "override_increase_1": 94.3
  },
  {
    "#": "33 Pond Ave, Unit 404 & P175 (287-12-54)",
    "$": 509400,
    "address": "33 Pond Ave, Unit 404 & P175",
    "parcel_id": "287-12-54",
    "owner1": "LEON TR, SONIA",
    "owner2": "C/O JOBLIN C YOUNGER",
    "current_taxes": 5216.26,
    "new_taxes_no_override": 5441.6,
    "override_total_1": 5596.0,
    "override_increase_1": 154.4
  },
  {
    "#": "33 Pond Ave, Unit 405 & P611 (287-12-55)",
    "$": 718800,
    "address": "33 Pond Ave, Unit 405 & P611",
    "parcel_id": "287-12-55",
    "owner1": "HODOSI, MARTIN",
    "owner2": "TANG, YANHUAN",
    "current_taxes": 3725.58,
    "new_taxes_no_override": 3886.53,
    "override_total_1": 3996.8,
    "override_increase_1": 110.28
  },
  {
    "#": "33 Pond Ave, Unit 406 P351&A (287-12-56)",
    "$": 555300,
    "address": "33 Pond Ave, Unit 406 P351&A",
    "parcel_id": "287-12-56",
    "owner1": "ZHANG, YUEBIN R",
    "owner2": "FINN, ELIOT L",
    "current_taxes": 2051.34,
    "new_taxes_no_override": 2139.96,
    "override_total_1": 2200.68,
    "override_increase_1": 60.72
  },
  {
    "#": "33 Pond Ave, Unit 407 & P119 (287-12-57)",
    "$": 509400,
    "address": "33 Pond Ave, Unit 407 & P119",
    "parcel_id": "287-12-57",
    "owner1": "MORTON, BRETT",
    "owner2": "",
    "current_taxes": 1581.32,
    "new_taxes_no_override": 1649.63,
    "override_total_1": 1696.44,
    "override_increase_1": 46.81
  },
  {
    "#": "33 Pond Ave, Unit 408 & P461 (287-12-58)",
    "$": 509400,
    "address": "33 Pond Ave, Unit 408 & P461",
    "parcel_id": "287-12-58",
    "owner1": "SENN TR, JOHN A",
    "owner2": "",
    "current_taxes": 1581.32,
    "new_taxes_no_override": 1649.63,
    "override_total_1": 1696.44,
    "override_increase_1": 46.81
  },
  {
    "#": "33 Pond Ave, Unit 409 & P153 (287-12-59)",
    "$": 500100,
    "address": "33 Pond Ave, Unit 409 & P153",
    "parcel_id": "287-12-59",
    "owner1": "LEON TR, SONIA",
    "owner2": "C/O JOBLIN C YOUNGER",
    "current_taxes": 5121.02,
    "new_taxes_no_override": 5342.25,
    "override_total_1": 5493.83,
    "override_increase_1": 151.58
  },
  {
    "#": "33 Pond Ave, Unit 410 & P666 (287-12-60)",
    "$": 461600,
    "address": "33 Pond Ave, Unit 410 & P666",
    "parcel_id": "287-12-60",
    "owner1": "MEHRA, SUNIL & NISHA",
    "owner2": "",
    "current_taxes": 4726.78,
    "new_taxes_no_override": 4930.98,
    "override_total_1": 5070.89,
    "override_increase_1": 139.91
  },
  {
    "#": "33 Pond Ave, Unit 411  (287-12-61)",
    "$": 459700,
    "address": "33 Pond Ave, Unit 411 ",
    "parcel_id": "287-12-61",
    "owner1": "LOUIE, SHIRLEY & SHULIAN XU",
    "owner2": "",
    "current_taxes": 1072.39,
    "new_taxes_no_override": 1118.72,
    "override_total_1": 1150.46,
    "override_increase_1": 31.74
  },
  {
    "#": "33 Pond Ave, Unit 412 & P534 (287-12-62)",
    "$": 482000,
    "address": "33 Pond Ave, Unit 412 & P534",
    "parcel_id": "287-12-62",
    "owner1": "CORKIN, LINDSAY",
    "owner2": "",
    "current_taxes": 1300.75,
    "new_taxes_no_override": 1356.94,
    "override_total_1": 1395.44,
    "override_increase_1": 38.5
  },
  {
    "#": "33 Pond Ave, Unit 413 & P626 (287-12-63)",
    "$": 456500,
    "address": "33 Pond Ave, Unit 413 & P626",
    "parcel_id": "287-12-63",
    "owner1": "JIA, YANKAI",
    "owner2": "",
    "current_taxes": 4674.56,
    "new_taxes_no_override": 4876.5,
    "override_total_1": 5014.87,
    "override_increase_1": 138.37
  },
  {
    "#": "33 Pond Ave, Unit 414 & P638 (287-12-64)",
    "$": 481300,
    "address": "33 Pond Ave, Unit 414 & P638",
    "parcel_id": "287-12-64",
    "owner1": "DUBOVSKIY LIFE ESTATE, YAKOV",
    "owner2": "NEMIROSKAYA, LYUDMILA",
    "current_taxes": 4928.51,
    "new_taxes_no_override": 5141.42,
    "override_total_1": 5287.31,
    "override_increase_1": 145.88
  },
  {
    "#": "33 Pond Ave, Unit 415 & P160 (287-12-65)",
    "$": 524700,
    "address": "33 Pond Ave, Unit 415 & P160",
    "parcel_id": "287-12-65",
    "owner1": "KANTOR TRS, FRANCINE E",
    "owner2": "MROZOWSKI, EUGENE T",
    "current_taxes": 1737.99,
    "new_taxes_no_override": 1813.07,
    "override_total_1": 1864.52,
    "override_increase_1": 51.44
  },
  {
    "#": "33 Pond Ave, Unit 416 P499&A (287-12-66)",
    "$": 545100,
    "address": "33 Pond Ave, Unit 416 P499&A",
    "parcel_id": "287-12-66",
    "owner1": "KIM, HWAN",
    "owner2": "LEE, ASHLEY",
    "current_taxes": 5581.82,
    "new_taxes_no_override": 5822.95,
    "override_total_1": 5988.18,
    "override_increase_1": 165.22
  },
  {
    "#": "33 Pond Ave, Unit 417 & P265 (287-12-67)",
    "$": 573600,
    "address": "33 Pond Ave, Unit 417 & P265",
    "parcel_id": "287-12-67",
    "owner1": "T & R RE LLC",
    "owner2": "",
    "current_taxes": 5873.66,
    "new_taxes_no_override": 6127.4,
    "override_total_1": 6301.26,
    "override_increase_1": 173.86
  },
  {
    "#": "33 Pond Ave, Unit 418 (287-12-68)",
    "$": 475800,
    "address": "33 Pond Ave, Unit 418",
    "parcel_id": "287-12-68",
    "owner1": "ZHU, TONY",
    "owner2": "",
    "current_taxes": 1237.26,
    "new_taxes_no_override": 1290.71,
    "override_total_1": 1327.33,
    "override_increase_1": 36.62
  },
  {
    "#": "33 Pond Ave, Unit 419 & P193 (287-12-69)",
    "$": 776200,
    "address": "33 Pond Ave, Unit 419 & P193",
    "parcel_id": "287-12-69",
    "owner1": "GUAN, CHUNZI",
    "owner2": "MENG, ERJIA",
    "current_taxes": 4313.35,
    "new_taxes_no_override": 4499.69,
    "override_total_1": 4627.36,
    "override_increase_1": 127.68
  },
  {
    "#": "33 Pond Ave, Unit 420 & P402 (287-12-70)",
    "$": 587900,
    "address": "33 Pond Ave, Unit 420 & P402",
    "parcel_id": "287-12-70",
    "owner1": "CLIFFORD, ZACHARY MAXWELL",
    "owner2": "",
    "current_taxes": 2385.16,
    "new_taxes_no_override": 2488.2,
    "override_total_1": 2558.8,
    "override_increase_1": 70.6
  },
  {
    "#": "33 Pond Ave, Unit 421 P137&A (287-12-71)",
    "$": 788300,
    "address": "33 Pond Ave, Unit 421 P137&A",
    "parcel_id": "287-12-71",
    "owner1": "SCHUETTE TRS, WILLIAM H & DEIRDRE A",
    "owner2": "",
    "current_taxes": 8072.19,
    "new_taxes_no_override": 8420.91,
    "override_total_1": 8659.85,
    "override_increase_1": 238.94
  },
  {
    "#": "33 Pond Ave, Unit 422 & P680 (287-12-72)",
    "$": 503200,
    "address": "33 Pond Ave, Unit 422 & P680",
    "parcel_id": "287-12-72",
    "owner1": "HULTSCH, ERWIN M D",
    "owner2": "",
    "current_taxes": 5152.77,
    "new_taxes_no_override": 5375.37,
    "override_total_1": 5527.89,
    "override_increase_1": 152.52
  },
  {
    "#": "33 Pond Ave, Unit 423 & P112 (287-12-73)",
    "$": 658800,
    "address": "33 Pond Ave, Unit 423 & P112",
    "parcel_id": "287-12-73",
    "owner1": "SHIEH, ANNIE",
    "owner2": "",
    "current_taxes": 6746.11,
    "new_taxes_no_override": 7037.54,
    "override_total_1": 7237.23,
    "override_increase_1": 199.68
  },
  {
    "#": "33 Pond Ave, Unit 424 & P344 (287-12-74)",
    "$": 682100,
    "address": "33 Pond Ave, Unit 424 & P344",
    "parcel_id": "287-12-74",
    "owner1": "FANG, XIJIA",
    "owner2": "CHANG, CHENG",
    "current_taxes": 6984.7,
    "new_taxes_no_override": 7286.44,
    "override_total_1": 7493.19,
    "override_increase_1": 206.75
  },
  {
    "#": "33 Pond Ave, Unit 501 & P676 (287-12-75)",
    "$": 484600,
    "address": "33 Pond Ave, Unit 501 & P676",
    "parcel_id": "287-12-75",
    "owner1": "KAKKALA, ET AL TR, GOPALAKRISHNAN",
    "owner2": "",
    "current_taxes": 4962.3,
    "new_taxes_no_override": 5176.67,
    "override_total_1": 5323.56,
    "override_increase_1": 146.88
  },
  {
    "#": "33 Pond Ave, Unit 502  (287-12-76)",
    "$": 420900,
    "address": "33 Pond Ave, Unit 502 ",
    "parcel_id": "287-12-76",
    "owner1": "KARIMI, ALI",
    "owner2": "",
    "current_taxes": 4310.02,
    "new_taxes_no_override": 4496.21,
    "override_total_1": 4623.79,
    "override_increase_1": 127.58
  },
  {
    "#": "33 Pond Ave, Unit 503 & P270 (287-12-77)",
    "$": 642800,
    "address": "33 Pond Ave, Unit 503 & P270",
    "parcel_id": "287-12-77",
    "owner1": "FELSEN, MICHAEL D & JUDITH EDNA",
    "owner2": "",
    "current_taxes": 6582.27,
    "new_taxes_no_override": 6866.62,
    "override_total_1": 7061.46,
    "override_increase_1": 194.84
  },
  {
    "#": "33 Pond Ave, Unit 504 (287-12-78)",
    "$": 458400,
    "address": "33 Pond Ave, Unit 504",
    "parcel_id": "287-12-78",
    "owner1": "FAN, ANGELA P-VICTOR-JACK C P",
    "owner2": "",
    "current_taxes": 4694.02,
    "new_taxes_no_override": 4896.8,
    "override_total_1": 5035.74,
    "override_increase_1": 138.94
  },
  {
    "#": "33 Pond Ave, Unit 505 & P100 (287-12-79)",
    "$": 750800,
    "address": "33 Pond Ave, Unit 505 & P100",
    "parcel_id": "287-12-79",
    "owner1": "LI, HAO",
    "owner2": "FU, FANG",
    "current_taxes": 4053.26,
    "new_taxes_no_override": 4228.36,
    "override_total_1": 4348.34,
    "override_increase_1": 119.98
  },
  {
    "#": "33 Pond Ave, Unit 506 (287-12-80)",
    "$": 458400,
    "address": "33 Pond Ave, Unit 506",
    "parcel_id": "287-12-80",
    "owner1": "CHINCHILLA, MANUEL",
    "owner2": "FREILICH, ANDREW",
    "current_taxes": 4694.02,
    "new_taxes_no_override": 4896.8,
    "override_total_1": 5035.74,
    "override_increase_1": 138.94
  },
  {
    "#": "33 Pond Ave, Unit 507 (287-12-81)",
    "$": 458400,
    "address": "33 Pond Ave, Unit 507",
    "parcel_id": "287-12-81",
    "owner1": "HOMAEE, TR, MAHDOKHT BANOO",
    "owner2": "",
    "current_taxes": 4694.02,
    "new_taxes_no_override": 4896.8,
    "override_total_1": 5035.74,
    "override_increase_1": 138.94
  },
  {
    "#": "33 Pond Ave, Unit 508 & P457 (287-12-82)",
    "$": 509400,
    "address": "33 Pond Ave, Unit 508 & P457",
    "parcel_id": "287-12-82",
    "owner1": "WEI, HELEN HANNYI",
    "owner2": "",
    "current_taxes": 1581.32,
    "new_taxes_no_override": 1649.63,
    "override_total_1": 1696.44,
    "override_increase_1": 46.81
  },
  {
    "#": "33 Pond Ave, Unit 509 & P190 (287-12-83)",
    "$": 509400,
    "address": "33 Pond Ave, Unit 509 & P190",
    "parcel_id": "287-12-83",
    "owner1": "KAO, TZU C-PHENG-F T -ROBERT M",
    "owner2": "",
    "current_taxes": 5216.26,
    "new_taxes_no_override": 5441.6,
    "override_total_1": 5596.0,
    "override_increase_1": 154.4
  },
  {
    "#": "33 Pond Ave, Unit 510 & P575 (287-12-84)",
    "$": 461600,
    "address": "33 Pond Ave, Unit 510 & P575",
    "parcel_id": "287-12-84",
    "owner1": "CASA LH LLC",
    "owner2": "",
    "current_taxes": 4726.78,
    "new_taxes_no_override": 4930.98,
    "override_total_1": 5070.89,
    "override_increase_1": 139.91
  },
  {
    "#": "33 Pond Ave, Unit 511 & P674 (287-12-85)",
    "$": 565400,
    "address": "33 Pond Ave, Unit 511 & P674",
    "parcel_id": "287-12-85",
    "owner1": "HURWITZ TRS, MICHAEL & MARY LOCHNER",
    "owner2": "",
    "current_taxes": 5789.7,
    "new_taxes_no_override": 6039.82,
    "override_total_1": 6211.19,
    "override_increase_1": 171.38
  },
  {
    "#": "33 Pond Ave, Unit 512 (287-12-86)",
    "$": 405500,
    "address": "33 Pond Ave, Unit 512",
    "parcel_id": "287-12-86",
    "owner1": "COLAO, FRANK G",
    "owner2": "",
    "current_taxes": 517.39,
    "new_taxes_no_override": 539.74,
    "override_total_1": 555.06,
    "override_increase_1": 15.31
  },
  {
    "#": "33 Pond Ave, Unit 513 & P272 (287-12-87)",
    "$": 456500,
    "address": "33 Pond Ave, Unit 513 & P272",
    "parcel_id": "287-12-87",
    "owner1": "MALMQUIST, SUSAN",
    "owner2": "",
    "current_taxes": 4674.56,
    "new_taxes_no_override": 4876.5,
    "override_total_1": 5014.87,
    "override_increase_1": 138.37
  },
  {
    "#": "33 Pond Ave, Unit 514 (287-12-88)",
    "$": 430300,
    "address": "33 Pond Ave, Unit 514",
    "parcel_id": "287-12-88",
    "owner1": "WIN INTERNATIONAL LLC",
    "owner2": "",
    "current_taxes": 4406.27,
    "new_taxes_no_override": 4596.62,
    "override_total_1": 4727.05,
    "override_increase_1": 130.43
  },
  {
    "#": "33 Pond Ave, Unit 515 & P215 (287-12-89)",
    "$": 581300,
    "address": "33 Pond Ave, Unit 515 & P215",
    "parcel_id": "287-12-89",
    "owner1": "GOCHBERG TR, ROBERT",
    "owner2": "",
    "current_taxes": 5952.51,
    "new_taxes_no_override": 6209.66,
    "override_total_1": 6385.85,
    "override_increase_1": 176.19
  },
  {
    "#": "33 Pond Ave, Unit 516 & P286 (287-12-90)",
    "$": 509400,
    "address": "33 Pond Ave, Unit 516 & P286",
    "parcel_id": "287-12-90",
    "owner1": "RATHORE TRS, RITESH & BHARTI",
    "owner2": "",
    "current_taxes": 5216.26,
    "new_taxes_no_override": 5441.6,
    "override_total_1": 5596.0,
    "override_increase_1": 154.4
  },
  {
    "#": "33 Pond Ave, Unit 517 & P122 (287-12-91)",
    "$": 509400,
    "address": "33 Pond Ave, Unit 517 & P122",
    "parcel_id": "287-12-91",
    "owner1": "MASNIK TR, MARILYN",
    "owner2": "",
    "current_taxes": 1581.32,
    "new_taxes_no_override": 1649.63,
    "override_total_1": 1696.44,
    "override_increase_1": 46.81
  },
  {
    "#": "33 Pond Ave, Unit 518 & P445 (287-12-92)",
    "$": 524700,
    "address": "33 Pond Ave, Unit 518 & P445",
    "parcel_id": "287-12-92",
    "owner1": "NGUYEN, HIEP T & CHAU",
    "owner2": "",
    "current_taxes": 5372.93,
    "new_taxes_no_override": 5605.04,
    "override_total_1": 5764.08,
    "override_increase_1": 159.04
  },
  {
    "#": "33 Pond Ave, Unit 519 P527&A (287-12-93)",
    "$": 787800,
    "address": "33 Pond Ave, Unit 519 P527&A",
    "parcel_id": "287-12-93",
    "owner1": "CHEN, SHENGSHENG",
    "owner2": "",
    "current_taxes": 8067.07,
    "new_taxes_no_override": 8415.57,
    "override_total_1": 8654.35,
    "override_increase_1": 238.79
  },
  {
    "#": "33 Pond Ave, Unit 520 & P123 (287-12-94)",
    "$": 589500,
    "address": "33 Pond Ave, Unit 520 & P123",
    "parcel_id": "287-12-94",
    "owner1": "JANG SOLUTION LLC",
    "owner2": "",
    "current_taxes": 6036.48,
    "new_taxes_no_override": 6297.26,
    "override_total_1": 6475.94,
    "override_increase_1": 178.68
  },
  {
    "#": "33 Pond Ave, Unit 521 & P154 (287-12-95)",
    "$": 755700,
    "address": "33 Pond Ave, Unit 521 & P154",
    "parcel_id": "287-12-95",
    "owner1": "PURI, AJIT",
    "owner2": "",
    "current_taxes": 7738.37,
    "new_taxes_no_override": 8072.67,
    "override_total_1": 8301.72,
    "override_increase_1": 229.06
  },
  {
    "#": "33 Pond Ave, Unit 522 & P431 (287-12-96)",
    "$": 503200,
    "address": "33 Pond Ave, Unit 522 & P431",
    "parcel_id": "287-12-96",
    "owner1": "KOHL, RALPH A & MARCIA G",
    "owner2": "",
    "current_taxes": 5152.77,
    "new_taxes_no_override": 5375.37,
    "override_total_1": 5527.89,
    "override_increase_1": 152.52
  },
  {
    "#": "33 Pond Ave, Unit 523 P523&A (287-12-97)",
    "$": 738300,
    "address": "33 Pond Ave, Unit 523 P523&A",
    "parcel_id": "287-12-97",
    "owner1": "ALPARSLAN, YAVUZ",
    "owner2": "ISIK, NURAN",
    "current_taxes": 7560.19,
    "new_taxes_no_override": 7886.79,
    "override_total_1": 8110.57,
    "override_increase_1": 223.78
  },
  {
    "#": "33 Pond Ave, Unit 524 & P458 (287-12-98)",
    "$": 682100,
    "address": "33 Pond Ave, Unit 524 & P458",
    "parcel_id": "287-12-98",
    "owner1": "MARTIN, EMMA RUTH & CLARENE MARY & ROBERT EARL JR",
    "owner2": "NIEDZOLKOWSKI, JAMIE SUSAN",
    "current_taxes": 6984.7,
    "new_taxes_no_override": 7286.44,
    "override_total_1": 7493.19,
    "override_increase_1": 206.75
  },
  {
    "#": "33 Pond Ave, Unit 601 & P213 (287-12-99)",
    "$": 459000,
    "address": "33 Pond Ave, Unit 601 & P213",
    "parcel_id": "287-12-99",
    "owner1": "KERAMOPOULOS TR, HERO",
    "owner2": "C/O SOMMER, RUTH",
    "current_taxes": 4700.16,
    "new_taxes_no_override": 4903.21,
    "override_total_1": 5042.33,
    "override_increase_1": 139.12
  },
  {
    "#": "33 Pond Ave, Unit 602 (287-13-00)",
    "$": 420800,
    "address": "33 Pond Ave, Unit 602",
    "parcel_id": "287-13-00",
    "owner1": "SZETO, ROSEMARY L",
    "owner2": "",
    "current_taxes": 674.06,
    "new_taxes_no_override": 703.18,
    "override_total_1": 723.13,
    "override_increase_1": 19.95
  },
  {
    "#": "33 Pond Ave, Unit 603 P530-A (287-13-01)",
    "$": 740800,
    "address": "33 Pond Ave, Unit 603 P530-A",
    "parcel_id": "287-13-01",
    "owner1": "KUGLER, ANN & ALEJANDRO FELIX",
    "owner2": "",
    "current_taxes": 7585.79,
    "new_taxes_no_override": 7913.5,
    "override_total_1": 8138.04,
    "override_increase_1": 224.54
  },
  {
    "#": "33 Pond Ave, Unit 604 & P241 (287-13-02)",
    "$": 581200,
    "address": "33 Pond Ave, Unit 604 & P241",
    "parcel_id": "287-13-02",
    "owner1": "BATTA, ARATI & RAVI",
    "owner2": "",
    "current_taxes": 5951.49,
    "new_taxes_no_override": 6208.59,
    "override_total_1": 6384.76,
    "override_increase_1": 176.16
  },
  {
    "#": "33 Pond Ave, Unit 605 & P166 (287-13-03)",
    "$": 718800,
    "address": "33 Pond Ave, Unit 605 & P166",
    "parcel_id": "287-13-03",
    "owner1": "THARAYIL, MARY JOY",
    "owner2": "",
    "current_taxes": 3725.58,
    "new_taxes_no_override": 3886.53,
    "override_total_1": 3996.8,
    "override_increase_1": 110.28
  },
  {
    "#": "33 Pond Ave, Unit 606 & P654 (287-13-04)",
    "$": 534900,
    "address": "33 Pond Ave, Unit 606 & P654",
    "parcel_id": "287-13-04",
    "owner1": "WEINSTEIN, CHERYL S",
    "owner2": "",
    "current_taxes": 1842.44,
    "new_taxes_no_override": 1922.03,
    "override_total_1": 1976.57,
    "override_increase_1": 54.54
  },
  {
    "#": "33 Pond Ave, Unit 607 (287-13-05)",
    "$": 458400,
    "address": "33 Pond Ave, Unit 607",
    "parcel_id": "287-13-05",
    "owner1": "ZHOU, CHENGJIE",
    "owner2": "DONG, YANHUA",
    "current_taxes": 4694.02,
    "new_taxes_no_override": 4896.8,
    "override_total_1": 5035.74,
    "override_increase_1": 138.94
  },
  {
    "#": "33 Pond Ave, Unit 608 (287-13-06)",
    "$": 458400,
    "address": "33 Pond Ave, Unit 608",
    "parcel_id": "287-13-06",
    "owner1": "SHTIFTER, ZVI",
    "owner2": "",
    "current_taxes": 4694.02,
    "new_taxes_no_override": 4896.8,
    "override_total_1": 5035.74,
    "override_increase_1": 138.94
  },
  {
    "#": "33 Pond Ave, Unit 609 & P162 (287-13-07)",
    "$": 507200,
    "address": "33 Pond Ave, Unit 609 & P162",
    "parcel_id": "287-13-07",
    "owner1": "CHANG TRS, TEWEN & JANET",
    "owner2": "",
    "current_taxes": 5193.73,
    "new_taxes_no_override": 5418.1,
    "override_total_1": 5571.83,
    "override_increase_1": 153.73
  },
  {
    "#": "33 Pond Ave, Unit 610 & P216 (287-13-08)",
    "$": 461600,
    "address": "33 Pond Ave, Unit 610 & P216",
    "parcel_id": "287-13-08",
    "owner1": "CHO, SUNG HEE",
    "owner2": "C/O MIKI HONDA",
    "current_taxes": 4726.78,
    "new_taxes_no_override": 4930.98,
    "override_total_1": 5070.89,
    "override_increase_1": 139.91
  },
  {
    "#": "33 Pond Ave, Unit 611 & P251 (287-13-09)",
    "$": 495400,
    "address": "33 Pond Ave, Unit 611 & P251",
    "parcel_id": "287-13-09",
    "owner1": "YANG, CHIH CHIEH",
    "owner2": "CHEN, JIN FAN",
    "current_taxes": 1437.96,
    "new_taxes_no_override": 1500.08,
    "override_total_1": 1542.64,
    "override_increase_1": 42.56
  },
  {
    "#": "33 Pond Ave, Unit 612 & P580 (287-13-10)",
    "$": 456500,
    "address": "33 Pond Ave, Unit 612 & P580",
    "parcel_id": "287-13-10",
    "owner1": "ALAGHEBAND, BABAK",
    "owner2": "",
    "current_taxes": 4674.56,
    "new_taxes_no_override": 4876.5,
    "override_total_1": 5014.87,
    "override_increase_1": 138.37
  },
  {
    "#": "33 Pond Ave, Unit 613 (287-13-11)",
    "$": 398700,
    "address": "33 Pond Ave, Unit 613",
    "parcel_id": "287-13-11",
    "owner1": "MINTZ, ELIZABETH M",
    "owner2": "WALPERT, ALLEN S",
    "current_taxes": 4082.69,
    "new_taxes_no_override": 4259.06,
    "override_total_1": 4379.91,
    "override_increase_1": 120.85
  },
  {
    "#": "33 Pond Ave, Unit 614 & P101 (287-13-12)",
    "$": 481300,
    "address": "33 Pond Ave, Unit 614 & P101",
    "parcel_id": "287-13-12",
    "owner1": "AUGUST, JUDITH",
    "owner2": "",
    "current_taxes": 1293.58,
    "new_taxes_no_override": 1349.46,
    "override_total_1": 1387.75,
    "override_increase_1": 38.29
  },
  {
    "#": "33 Pond Ave, Unit 615 & P113 (287-13-13)",
    "$": 509400,
    "address": "33 Pond Ave, Unit 615 & P113",
    "parcel_id": "287-13-13",
    "owner1": "GOLDSTEIN, DAVID",
    "owner2": "",
    "current_taxes": 5216.26,
    "new_taxes_no_override": 5441.6,
    "override_total_1": 5596.0,
    "override_increase_1": 154.4
  },
  {
    "#": "33 Pond Ave, Unit 616 & P620 (287-13-14)",
    "$": 524700,
    "address": "33 Pond Ave, Unit 616 & P620",
    "parcel_id": "287-13-14",
    "owner1": "ZHENG, WEIHONG",
    "owner2": "WANG, TAO",
    "current_taxes": 5372.93,
    "new_taxes_no_override": 5605.04,
    "override_total_1": 5764.08,
    "override_increase_1": 159.04
  },
  {
    "#": "33 Pond Ave, Unit 617 & P120 (287-13-15)",
    "$": 524700,
    "address": "33 Pond Ave, Unit 617 & P120",
    "parcel_id": "287-13-15",
    "owner1": "CHANG, CHAOKAI & JULIA",
    "owner2": "",
    "current_taxes": 5372.93,
    "new_taxes_no_override": 5605.04,
    "override_total_1": 5764.08,
    "override_increase_1": 159.04
  },
  {
    "#": "33 Pond Ave, Unit 618 & P443 (287-13-16)",
    "$": 521300,
    "address": "33 Pond Ave, Unit 618 & P443",
    "parcel_id": "287-13-16",
    "owner1": "DAVIS, LINDSEY S",
    "owner2": "",
    "current_taxes": 5338.11,
    "new_taxes_no_override": 5568.72,
    "override_total_1": 5726.72,
    "override_increase_1": 158.01
  },
  {
    "#": "33 Pond Ave, Unit 619 & P81 (287-13-17)",
    "$": 736900,
    "address": "33 Pond Ave, Unit 619 & P81",
    "parcel_id": "287-13-17",
    "owner1": "KIM, YOUNG JO",
    "owner2": "LEE, LOIS K",
    "current_taxes": 7545.86,
    "new_taxes_no_override": 7871.84,
    "override_total_1": 8095.2,
    "override_increase_1": 223.36
  },
  {
    "#": "33 Pond Ave, Unit 620 & P374 (287-13-18)",
    "$": 524700,
    "address": "33 Pond Ave, Unit 620 & P374",
    "parcel_id": "287-13-18",
    "owner1": "SAPOZHNIKOV TR, FRIDA",
    "owner2": "",
    "current_taxes": 5372.93,
    "new_taxes_no_override": 5605.04,
    "override_total_1": 5764.08,
    "override_increase_1": 159.04
  },
  {
    "#": "33 Pond Ave, Unit 621 & P95 (287-13-19)",
    "$": 747600,
    "address": "33 Pond Ave, Unit 621 & P95",
    "parcel_id": "287-13-19",
    "owner1": "LEVIN, DEBRA R",
    "owner2": "",
    "current_taxes": 4020.49,
    "new_taxes_no_override": 4194.18,
    "override_total_1": 4313.18,
    "override_increase_1": 119.01
  },
  {
    "#": "33 Pond Ave, Unit 622 & P661 (287-13-20)",
    "$": 574200,
    "address": "33 Pond Ave, Unit 622 & P661",
    "parcel_id": "287-13-20",
    "owner1": "MIKALIAN, BENJAMIN",
    "owner2": "",
    "current_taxes": 5879.81,
    "new_taxes_no_override": 6133.82,
    "override_total_1": 6307.86,
    "override_increase_1": 174.04
  },
  {
    "#": "33 Pond Ave, Unit 623 & P338 (287-13-21)",
    "$": 677100,
    "address": "33 Pond Ave, Unit 623 & P338",
    "parcel_id": "287-13-21",
    "owner1": "VAYSBURD, LEV B & VICTORIA",
    "owner2": "",
    "current_taxes": 6933.5,
    "new_taxes_no_override": 7233.03,
    "override_total_1": 7438.26,
    "override_increase_1": 205.23
  },
  {
    "#": "33 Pond Ave, Unit 624 & P191 (287-13-22)",
    "$": 682100,
    "address": "33 Pond Ave, Unit 624 & P191",
    "parcel_id": "287-13-22",
    "owner1": "SHELLMAN, TR, WILLIE",
    "owner2": "",
    "current_taxes": 6984.7,
    "new_taxes_no_override": 7286.44,
    "override_total_1": 7493.19,
    "override_increase_1": 206.75
  },
  {
    "#": "33 Pond Ave, Unit 701 P354&A (287-13-23)",
    "$": 499500,
    "address": "33 Pond Ave, Unit 701 P354&A",
    "parcel_id": "287-13-23",
    "owner1": "TSANG, TRACY L & YEE",
    "owner2": "",
    "current_taxes": 5114.88,
    "new_taxes_no_override": 5335.84,
    "override_total_1": 5487.24,
    "override_increase_1": 151.4
  },
  {
    "#": "33 Pond Ave, Unit 702 & P679 (287-13-24)",
    "$": 471800,
    "address": "33 Pond Ave, Unit 702 & P679",
    "parcel_id": "287-13-24",
    "owner1": "SHELLMAN, TR, WILLIE",
    "owner2": "",
    "current_taxes": 4831.23,
    "new_taxes_no_override": 5039.94,
    "override_total_1": 5182.94,
    "override_increase_1": 143.0
  },
  {
    "#": "33 Pond Ave, Unit 703 P80&A (287-13-25)",
    "$": 740900,
    "address": "33 Pond Ave, Unit 703 P80&A",
    "parcel_id": "287-13-25",
    "owner1": "JIANG, YINGCHUN",
    "owner2": "C/O HONGYU JIANG",
    "current_taxes": 7586.82,
    "new_taxes_no_override": 7914.57,
    "override_total_1": 8139.14,
    "override_increase_1": 224.57
  },
  {
    "#": "33 Pond Ave, Unit 704 & P131 (287-13-26)",
    "$": 524700,
    "address": "33 Pond Ave, Unit 704 & P131",
    "parcel_id": "287-13-26",
    "owner1": "LIANG, WU",
    "owner2": "",
    "current_taxes": 5372.93,
    "new_taxes_no_override": 5605.04,
    "override_total_1": 5764.08,
    "override_increase_1": 159.04
  },
  {
    "#": "33 Pond Ave, Unit 705 P514&A (287-13-27)",
    "$": 795900,
    "address": "33 Pond Ave, Unit 705 P514&A",
    "parcel_id": "287-13-27",
    "owner1": "EMANI, SITARAM M & SIRISHA",
    "owner2": "",
    "current_taxes": 8150.02,
    "new_taxes_no_override": 8502.1,
    "override_total_1": 8743.34,
    "override_increase_1": 241.24
  },
  {
    "#": "33 Pond Ave, Unit 706 & P109 (287-13-28)",
    "$": 581300,
    "address": "33 Pond Ave, Unit 706 & P109",
    "parcel_id": "287-13-28",
    "owner1": "BENNETT, DANIELLE R",
    "owner2": "C/O BOBER DANIELLE RENEE",
    "current_taxes": 5952.51,
    "new_taxes_no_override": 6209.66,
    "override_total_1": 6385.85,
    "override_increase_1": 176.19
  },
  {
    "#": "33 Pond Ave, Unit 707 & P128 (287-13-29)",
    "$": 581300,
    "address": "33 Pond Ave, Unit 707 & P128",
    "parcel_id": "287-13-29",
    "owner1": "OUAHED, JODIE",
    "owner2": "",
    "current_taxes": 5952.51,
    "new_taxes_no_override": 6209.66,
    "override_total_1": 6385.85,
    "override_increase_1": 176.19
  },
  {
    "#": "33 Pond Ave, Unit 708 (287-13-30)",
    "$": 523100,
    "address": "33 Pond Ave, Unit 708",
    "parcel_id": "287-13-30",
    "owner1": "TAN, YAN",
    "owner2": "",
    "current_taxes": 5356.54,
    "new_taxes_no_override": 5587.94,
    "override_total_1": 5746.5,
    "override_increase_1": 158.55
  },
  {
    "#": "33 Pond Ave, Unit 709 P76&A (287-13-31)",
    "$": 529800,
    "address": "33 Pond Ave, Unit 709 P76&A",
    "parcel_id": "287-13-31",
    "owner1": "TURKANIS, TR, ROY",
    "owner2": "",
    "current_taxes": 5425.15,
    "new_taxes_no_override": 5659.52,
    "override_total_1": 5820.1,
    "override_increase_1": 160.58
  },
  {
    "#": "33 Pond Ave, Unit 710 & P243 (287-13-32)",
    "$": 487100,
    "address": "33 Pond Ave, Unit 710 & P243",
    "parcel_id": "287-13-32",
    "owner1": "ANDRIC, MARKO & JELENA",
    "owner2": "",
    "current_taxes": 1352.97,
    "new_taxes_no_override": 1411.42,
    "override_total_1": 1451.47,
    "override_increase_1": 40.05
  },
  {
    "#": "33 Pond Ave, Unit 711 & P337 (287-13-33)",
    "$": 515500,
    "address": "33 Pond Ave, Unit 711 & P337",
    "parcel_id": "287-13-33",
    "owner1": "INNOCENTI, SIMONA",
    "owner2": "",
    "current_taxes": 1643.79,
    "new_taxes_no_override": 1714.8,
    "override_total_1": 1763.46,
    "override_increase_1": 48.66
  },
  {
    "#": "33 Pond Ave, Unit 712 (287-13-34)",
    "$": 398700,
    "address": "33 Pond Ave, Unit 712",
    "parcel_id": "287-13-34",
    "owner1": "TARABOCCHIA, VIRGINIA",
    "owner2": "",
    "current_taxes": 447.75,
    "new_taxes_no_override": 467.09,
    "override_total_1": 480.35,
    "override_increase_1": 13.25
  },
  {
    "#": "33 Pond Ave, Unit 713 & P207 (287-13-35)",
    "$": 468400,
    "address": "33 Pond Ave, Unit 713 & P207",
    "parcel_id": "287-13-35",
    "owner1": "LI, HANK",
    "owner2": "",
    "current_taxes": 4796.42,
    "new_taxes_no_override": 5003.63,
    "override_total_1": 5145.6,
    "override_increase_1": 141.97
  },
  {
    "#": "33 Pond Ave, Unit 714 & P229 (287-13-36)",
    "$": 481300,
    "address": "33 Pond Ave, Unit 714 & P229",
    "parcel_id": "287-13-36",
    "owner1": "FENG, JUAN & PEIQIANG",
    "owner2": "",
    "current_taxes": 1293.58,
    "new_taxes_no_override": 1349.46,
    "override_total_1": 1387.75,
    "override_increase_1": 38.29
  },
  {
    "#": "33 Pond Ave, Unit 715 & P108 (287-13-37)",
    "$": 509400,
    "address": "33 Pond Ave, Unit 715 & P108",
    "parcel_id": "287-13-37",
    "owner1": "IUANOW, ELAINE & CHRIS",
    "owner2": "",
    "current_taxes": 5216.26,
    "new_taxes_no_override": 5441.6,
    "override_total_1": 5596.0,
    "override_increase_1": 154.4
  },
  {
    "#": "33 Pond Ave, Unit 716 & P209 (287-13-38)",
    "$": 521300,
    "address": "33 Pond Ave, Unit 716 & P209",
    "parcel_id": "287-13-38",
    "owner1": "WU, ZHONG",
    "owner2": "ZHOU, JIN",
    "current_taxes": 5338.11,
    "new_taxes_no_override": 5568.72,
    "override_total_1": 5726.72,
    "override_increase_1": 158.01
  },
  {
    "#": "33 Pond Ave, Unit 717 & P163 (287-13-39)",
    "$": 509400,
    "address": "33 Pond Ave, Unit 717 & P163",
    "parcel_id": "287-13-39",
    "owner1": "YU, ZIYANG",
    "owner2": "MIN, CHENGYIN",
    "current_taxes": 5216.26,
    "new_taxes_no_override": 5441.6,
    "override_total_1": 5596.0,
    "override_increase_1": 154.4
  },
  {
    "#": "33 Pond Ave, Unit 718 & P178 (287-13-40)",
    "$": 521300,
    "address": "33 Pond Ave, Unit 718 & P178",
    "parcel_id": "287-13-40",
    "owner1": "SWEAT, YAN & MASON",
    "owner2": "",
    "current_taxes": 1703.18,
    "new_taxes_no_override": 1776.76,
    "override_total_1": 1827.17,
    "override_increase_1": 50.41
  },
  {
    "#": "33 Pond Ave, Unit 719 P503&A (287-13-41)",
    "$": 776600,
    "address": "33 Pond Ave, Unit 719 P503&A",
    "parcel_id": "287-13-41",
    "owner1": "PEI, YEE YA & EDWIN HY",
    "owner2": "",
    "current_taxes": 7952.38,
    "new_taxes_no_override": 8295.92,
    "override_total_1": 8531.31,
    "override_increase_1": 235.39
  },
  {
    "#": "33 Pond Ave, Unit 720 & P214 (287-13-42)",
    "$": 581300,
    "address": "33 Pond Ave, Unit 720 & P214",
    "parcel_id": "287-13-42",
    "owner1": "WEINER, JAY M",
    "owner2": "",
    "current_taxes": 5952.51,
    "new_taxes_no_override": 6209.66,
    "override_total_1": 6385.85,
    "override_increase_1": 176.19
  },
  {
    "#": "33 Pond Ave, Unit 721 & P94 (287-13-43)",
    "$": 747600,
    "address": "33 Pond Ave, Unit 721 & P94",
    "parcel_id": "287-13-43",
    "owner1": "SHAYEGAN TR, BIJAN",
    "owner2": "",
    "current_taxes": 7655.42,
    "new_taxes_no_override": 7986.13,
    "override_total_1": 8212.73,
    "override_increase_1": 226.6
  },
  {
    "#": "33 Pond Ave, Unit 722 (287-13-44)",
    "$": 467500,
    "address": "33 Pond Ave, Unit 722",
    "parcel_id": "287-13-44",
    "owner1": "LASOSKI, ANNE M",
    "owner2": "",
    "current_taxes": 4787.2,
    "new_taxes_no_override": 4994.01,
    "override_total_1": 5135.71,
    "override_increase_1": 141.7
  },
  {
    "#": "33 Pond Ave, Unit 723 P522&A (287-13-45)",
    "$": 722600,
    "address": "33 Pond Ave, Unit 723 P522&A",
    "parcel_id": "287-13-45",
    "owner1": "YANG, NATALIE SHAOLING",
    "owner2": "",
    "current_taxes": 7399.42,
    "new_taxes_no_override": 7719.07,
    "override_total_1": 7938.1,
    "override_increase_1": 219.02
  },
  {
    "#": "33 Pond Ave, Unit 724 & P439 (287-13-46)",
    "$": 670500,
    "address": "33 Pond Ave, Unit 724 & P439",
    "parcel_id": "287-13-46",
    "owner1": "AGRAWAL, NIKHIL",
    "owner2": "HANDA, SHRUTI",
    "current_taxes": 3230.99,
    "new_taxes_no_override": 3370.57,
    "override_total_1": 3466.21,
    "override_increase_1": 95.64
  },
  {
    "#": "33 Pond Ave, Unit 801 (287-13-47)",
    "$": 423300,
    "address": "33 Pond Ave, Unit 801",
    "parcel_id": "287-13-47",
    "owner1": "KIM, HYUN KYU",
    "owner2": "BAEK, SONG I",
    "current_taxes": 699.66,
    "new_taxes_no_override": 729.89,
    "override_total_1": 750.6,
    "override_increase_1": 20.71
  },
  {
    "#": "33 Pond Ave, Unit 802 & P225 (287-13-48)",
    "$": 482000,
    "address": "33 Pond Ave, Unit 802 & P225",
    "parcel_id": "287-13-48",
    "owner1": "NISHIKAWA CO LTD",
    "owner2": "C/O RELO REDAC INC-MGMT 2202",
    "current_taxes": 4935.68,
    "new_taxes_no_override": 5148.9,
    "override_total_1": 5295.0,
    "override_increase_1": 146.1
  },
  {
    "#": "33 Pond Ave, Unit 803 & P159 (287-13-49)",
    "$": 642800,
    "address": "33 Pond Ave, Unit 803 & P159",
    "parcel_id": "287-13-49",
    "owner1": "YU, DOUGLAS SZETO",
    "owner2": "",
    "current_taxes": 2947.34,
    "new_taxes_no_override": 3074.67,
    "override_total_1": 3161.91,
    "override_increase_1": 87.24
  },
  {
    "#": "33 Pond Ave, Unit 804 (287-13-50)",
    "$": 470300,
    "address": "33 Pond Ave, Unit 804",
    "parcel_id": "287-13-50",
    "owner1": "REARDON TR, ANDREW J",
    "owner2": "",
    "current_taxes": 4815.87,
    "new_taxes_no_override": 5023.92,
    "override_total_1": 5166.47,
    "override_increase_1": 142.55
  },
  {
    "#": "33 Pond Ave, Unit 805 & P297 (287-13-51)",
    "$": 733400,
    "address": "33 Pond Ave, Unit 805 & P297",
    "parcel_id": "287-13-51",
    "owner1": "CHAU, KEUNG T",
    "owner2": "MOY, MYRA M",
    "current_taxes": 7510.02,
    "new_taxes_no_override": 7834.45,
    "override_total_1": 8056.75,
    "override_increase_1": 222.3
  },
  {
    "#": "33 Pond Ave, Unit 806 (287-13-52)",
    "$": 523100,
    "address": "33 Pond Ave, Unit 806",
    "parcel_id": "287-13-52",
    "owner1": "CHEN, CHUNG-YANG",
    "owner2": "",
    "current_taxes": 1721.61,
    "new_taxes_no_override": 1795.98,
    "override_total_1": 1846.94,
    "override_increase_1": 50.96
  },
  {
    "#": "33 Pond Ave, Unit 807 & P281 (287-13-53)",
    "$": 581300,
    "address": "33 Pond Ave, Unit 807 & P281",
    "parcel_id": "287-13-53",
    "owner1": "CUNNINGHAM TR, MEREDITH L",
    "owner2": "",
    "current_taxes": 2317.58,
    "new_taxes_no_override": 2417.7,
    "override_total_1": 2486.3,
    "override_increase_1": 68.6
  },
  {
    "#": "33 Pond Ave, Unit 808 & P148 (287-13-54)",
    "$": 581300,
    "address": "33 Pond Ave, Unit 808 & P148",
    "parcel_id": "287-13-54",
    "owner1": "SHEN, DELIA",
    "owner2": "",
    "current_taxes": 5952.51,
    "new_taxes_no_override": 6209.66,
    "override_total_1": 6385.85,
    "override_increase_1": 176.19
  },
  {
    "#": "33 Pond Ave, Unit 809 & P566-B (287-13-55)",
    "$": 500100,
    "address": "33 Pond Ave, Unit 809 & P566-B",
    "parcel_id": "287-13-55",
    "owner1": "LOW TR, JOHNNY",
    "owner2": "",
    "current_taxes": 1486.09,
    "new_taxes_no_override": 1550.29,
    "override_total_1": 1594.28,
    "override_increase_1": 43.99
  },
  {
    "#": "33 Pond Ave, Unit 810 P583&A (287-13-56)",
    "$": 489100,
    "address": "33 Pond Ave, Unit 810 P583&A",
    "parcel_id": "287-13-56",
    "owner1": "KUMAR, RUCHIRA",
    "owner2": "",
    "current_taxes": 5008.38,
    "new_taxes_no_override": 5224.74,
    "override_total_1": 5372.99,
    "override_increase_1": 148.25
  },
  {
    "#": "33 Pond Ave, Unit 811 & P116 (287-13-57)",
    "$": 495400,
    "address": "33 Pond Ave, Unit 811 & P116",
    "parcel_id": "287-13-57",
    "owner1": "MURPHY, MARYANN",
    "owner2": "",
    "current_taxes": 1437.96,
    "new_taxes_no_override": 1500.08,
    "override_total_1": 1542.64,
    "override_increase_1": 42.56
  },
  {
    "#": "33 Pond Ave, Unit 812 & P291 (287-13-58)",
    "$": 456500,
    "address": "33 Pond Ave, Unit 812 & P291",
    "parcel_id": "287-13-58",
    "owner1": "COPPELMAN, DANIEL",
    "owner2": "",
    "current_taxes": 4674.56,
    "new_taxes_no_override": 4876.5,
    "override_total_1": 5014.87,
    "override_increase_1": 138.37
  },
  {
    "#": "33 Pond Ave, Unit 813  (287-13-59)",
    "$": 425500,
    "address": "33 Pond Ave, Unit 813 ",
    "parcel_id": "287-13-59",
    "owner1": "KRAM HOLDING LLC",
    "owner2": "",
    "current_taxes": 4357.12,
    "new_taxes_no_override": 4545.35,
    "override_total_1": 4674.32,
    "override_increase_1": 128.97
  },
  {
    "#": "33 Pond Ave, Unit 814 & P446 (287-13-60)",
    "$": 481300,
    "address": "33 Pond Ave, Unit 814 & P446",
    "parcel_id": "287-13-60",
    "owner1": "BLOOM TR, RICHARD A",
    "owner2": "",
    "current_taxes": 1293.58,
    "new_taxes_no_override": 1349.46,
    "override_total_1": 1387.75,
    "override_increase_1": 38.29
  },
  {
    "#": "33 Pond Ave, Unit 815 & P126 (287-13-61)",
    "$": 524700,
    "address": "33 Pond Ave, Unit 815 & P126",
    "parcel_id": "287-13-61",
    "owner1": "CHU, KEVIN C",
    "owner2": "CHAO, CHRISTINA",
    "current_taxes": 1737.99,
    "new_taxes_no_override": 1813.07,
    "override_total_1": 1864.52,
    "override_increase_1": 51.44
  },
  {
    "#": "33 Pond Ave, Unit 816 (287-13-62)",
    "$": 458400,
    "address": "33 Pond Ave, Unit 816",
    "parcel_id": "287-13-62",
    "owner1": "LITTS, ET AL, DANIEL J",
    "owner2": "",
    "current_taxes": 4694.02,
    "new_taxes_no_override": 4896.8,
    "override_total_1": 5035.74,
    "override_increase_1": 138.94
  },
  {
    "#": "33 Pond Ave, Unit 817 (287-13-63)",
    "$": 523100,
    "address": "33 Pond Ave, Unit 817",
    "parcel_id": "287-13-63",
    "owner1": "XU TRS, GUANG LI",
    "owner2": "ZHOU, YING",
    "current_taxes": 5356.54,
    "new_taxes_no_override": 5587.94,
    "override_total_1": 5746.5,
    "override_increase_1": 158.55
  },
  {
    "#": "33 Pond Ave, Unit 818 & P441 (287-13-64)",
    "$": 581300,
    "address": "33 Pond Ave, Unit 818 & P441",
    "parcel_id": "287-13-64",
    "owner1": "ROBBINS BROOKLINE CONDOS LLC",
    "owner2": "C/O ROBBINS PROPERTY ASSOCIATES",
    "current_taxes": 5952.51,
    "new_taxes_no_override": 6209.66,
    "override_total_1": 6385.85,
    "override_increase_1": 176.19
  },
  {
    "#": "33 Pond Ave, Unit 819 & P307 P665 (287-13-65)",
    "$": 803300,
    "address": "33 Pond Ave, Unit 819 & P307 P665",
    "parcel_id": "287-13-65",
    "owner1": "BROWN, TRS, DAVID J",
    "owner2": "MULLER, CORINNE",
    "current_taxes": 8225.79,
    "new_taxes_no_override": 8581.14,
    "override_total_1": 8824.63,
    "override_increase_1": 243.48
  },
  {
    "#": "33 Pond Ave, Unit 820 & P424 (287-13-66)",
    "$": 509400,
    "address": "33 Pond Ave, Unit 820 & P424",
    "parcel_id": "287-13-66",
    "owner1": "CHO, HARRY B & MYUNG JIN",
    "owner2": "",
    "current_taxes": 5216.26,
    "new_taxes_no_override": 5441.6,
    "override_total_1": 5596.0,
    "override_increase_1": 154.4
  },
  {
    "#": "33 Pond Ave, Unit 821 & P104 (287-13-67)",
    "$": 765900,
    "address": "33 Pond Ave, Unit 821 & P104",
    "parcel_id": "287-13-67",
    "owner1": "LANE TR, CATHERINE S",
    "owner2": "",
    "current_taxes": 4207.88,
    "new_taxes_no_override": 4389.66,
    "override_total_1": 4514.21,
    "override_increase_1": 124.55
  },
  {
    "#": "33 Pond Ave, Unit 822 & P409 (287-13-68)",
    "$": 506300,
    "address": "33 Pond Ave, Unit 822 & P409",
    "parcel_id": "287-13-68",
    "owner1": "MACLEOD, CLAUDIA",
    "owner2": "STOUT, JOSEPHINE I",
    "current_taxes": 1549.58,
    "new_taxes_no_override": 1616.52,
    "override_total_1": 1662.39,
    "override_increase_1": 45.87
  },
  {
    "#": "33 Pond Ave, Unit 823 P347&A (287-13-69)",
    "$": 738300,
    "address": "33 Pond Ave, Unit 823 P347&A",
    "parcel_id": "287-13-69",
    "owner1": "BLUMENREICH , BILL JR",
    "owner2": "",
    "current_taxes": 7560.19,
    "new_taxes_no_override": 7886.79,
    "override_total_1": 8110.57,
    "override_increase_1": 223.78
  },
  {
    "#": "33 Pond Ave, Unit 824 & P339 (287-13-70)",
    "$": 642800,
    "address": "33 Pond Ave, Unit 824 & P339",
    "parcel_id": "287-13-70",
    "owner1": "KIRSHEN, MARC D",
    "owner2": "",
    "current_taxes": 6582.27,
    "new_taxes_no_override": 6866.62,
    "override_total_1": 7061.46,
    "override_increase_1": 194.84
  },
  {
    "#": "33 Pond Ave, Unit 901 (287-13-71)",
    "$": 433500,
    "address": "33 Pond Ave, Unit 901",
    "parcel_id": "287-13-71",
    "owner1": "LYNCH, ANN MARIE",
    "owner2": "",
    "current_taxes": 4439.04,
    "new_taxes_no_override": 4630.81,
    "override_total_1": 4762.2,
    "override_increase_1": 131.4
  },
  {
    "#": "33 Pond Ave, Unit 902 & P226 (287-13-72)",
    "$": 456500,
    "address": "33 Pond Ave, Unit 902 & P226",
    "parcel_id": "287-13-72",
    "owner1": "ZANDINEJAD, KEIVAN",
    "owner2": "",
    "current_taxes": 4674.56,
    "new_taxes_no_override": 4876.5,
    "override_total_1": 5014.87,
    "override_increase_1": 138.37
  },
  {
    "#": "33 Pond Ave, Unit 903 & P218 (287-13-73)",
    "$": 651000,
    "address": "33 Pond Ave, Unit 903 & P218",
    "parcel_id": "287-13-73",
    "owner1": "BOUSSIOTIS, VASSILIKI A",
    "owner2": "",
    "current_taxes": 3031.31,
    "new_taxes_no_override": 3162.26,
    "override_total_1": 3251.99,
    "override_increase_1": 89.73
  },
  {
    "#": "33 Pond Ave, Unit 904 (287-13-74)",
    "$": 470300,
    "address": "33 Pond Ave, Unit 904",
    "parcel_id": "287-13-74",
    "owner1": "MA, XIAOZHOU",
    "owner2": "SHI, YAN",
    "current_taxes": 4815.87,
    "new_taxes_no_override": 5023.92,
    "override_total_1": 5166.47,
    "override_increase_1": 142.55
  },
  {
    "#": "33 Pond Ave, Unit 905 P85&A (287-13-75)",
    "$": 764800,
    "address": "33 Pond Ave, Unit 905 P85&A",
    "parcel_id": "287-13-75",
    "owner1": "FIELD, BRIGITTE",
    "owner2": "C/O APPLETON PARTNERS INC, KELLY MCKERNAN",
    "current_taxes": 4196.62,
    "new_taxes_no_override": 4377.91,
    "override_total_1": 4502.13,
    "override_increase_1": 124.22
  },
  {
    "#": "33 Pond Ave, Unit 906 & P627 (287-13-76)",
    "$": 581300,
    "address": "33 Pond Ave, Unit 906 & P627",
    "parcel_id": "287-13-76",
    "owner1": "TAUBIN, STEPHANIE P",
    "owner2": "",
    "current_taxes": 2317.58,
    "new_taxes_no_override": 2417.7,
    "override_total_1": 2486.3,
    "override_increase_1": 68.6
  },
  {
    "#": "33 Pond Ave, Unit 907 (287-13-77)",
    "$": 458400,
    "address": "33 Pond Ave, Unit 907",
    "parcel_id": "287-13-77",
    "owner1": "LIN, JASON YE",
    "owner2": "LI, PENG",
    "current_taxes": 4694.02,
    "new_taxes_no_override": 4896.8,
    "override_total_1": 5035.74,
    "override_increase_1": 138.94
  },
  {
    "#": "33 Pond Ave, Unit 908 & P146 (287-13-78)",
    "$": 509400,
    "address": "33 Pond Ave, Unit 908 & P146",
    "parcel_id": "287-13-78",
    "owner1": "LI, XIA",
    "owner2": "",
    "current_taxes": 5216.26,
    "new_taxes_no_override": 5441.6,
    "override_total_1": 5596.0,
    "override_increase_1": 154.4
  },
  {
    "#": "33 Pond Ave, Unit 909 & P179 (287-13-79)",
    "$": 581300,
    "address": "33 Pond Ave, Unit 909 & P179",
    "parcel_id": "287-13-79",
    "owner1": "ZHANG, QIN",
    "owner2": "LI, QIANG",
    "current_taxes": 5952.51,
    "new_taxes_no_override": 6209.66,
    "override_total_1": 6385.85,
    "override_increase_1": 176.19
  },
  {
    "#": "33 Pond Ave, Unit 910 & P396 (287-13-80)",
    "$": 476900,
    "address": "33 Pond Ave, Unit 910 & P396",
    "parcel_id": "287-13-80",
    "owner1": "WANG, JUNFENG",
    "owner2": "LI, LIJIA",
    "current_taxes": 4883.46,
    "new_taxes_no_override": 5094.43,
    "override_total_1": 5238.98,
    "override_increase_1": 144.55
  },
  {
    "#": "33 Pond Ave, Unit 911 & P114 (287-13-81)",
    "$": 500200,
    "address": "33 Pond Ave, Unit 911 & P114",
    "parcel_id": "287-13-81",
    "owner1": "LAM, CARRIE",
    "owner2": "",
    "current_taxes": 5122.05,
    "new_taxes_no_override": 5343.32,
    "override_total_1": 5494.94,
    "override_increase_1": 151.61
  },
  {
    "#": "33 Pond Ave, Unit 912 & P425 (287-13-82)",
    "$": 456500,
    "address": "33 Pond Ave, Unit 912 & P425",
    "parcel_id": "287-13-82",
    "owner1": "MAYDMAN TR, RITA",
    "owner2": "",
    "current_taxes": 4674.56,
    "new_taxes_no_override": 4876.5,
    "override_total_1": 5014.87,
    "override_increase_1": 138.37
  },
  {
    "#": "33 Pond Ave, Unit 913 & P659 (287-13-83)",
    "$": 456500,
    "address": "33 Pond Ave, Unit 913 & P659",
    "parcel_id": "287-13-83",
    "owner1": "LOUIE TR, PEGGIE SIU HING",
    "owner2": "",
    "current_taxes": 4674.56,
    "new_taxes_no_override": 4876.5,
    "override_total_1": 5014.87,
    "override_increase_1": 138.37
  },
  {
    "#": "33 Pond Ave, Unit 914 (287-13-84)",
    "$": 455800,
    "address": "33 Pond Ave, Unit 914",
    "parcel_id": "287-13-84",
    "owner1": "TONG, ANDREW CHEE ON",
    "owner2": "WONG, CHEUK SANG",
    "current_taxes": 4667.39,
    "new_taxes_no_override": 4869.02,
    "override_total_1": 5007.18,
    "override_increase_1": 138.15
  },
  {
    "#": "33 Pond Ave, Unit 915 & P252 (287-13-85)",
    "$": 594900,
    "address": "33 Pond Ave, Unit 915 & P252",
    "parcel_id": "287-13-85",
    "owner1": "REN, JUN",
    "owner2": "",
    "current_taxes": 6091.78,
    "new_taxes_no_override": 6354.94,
    "override_total_1": 6535.26,
    "override_increase_1": 180.32
  },
  {
    "#": "33 Pond Ave, Unit 916 & P237 (287-13-86)",
    "$": 509400,
    "address": "33 Pond Ave, Unit 916 & P237",
    "parcel_id": "287-13-86",
    "owner1": "WANG, LIONEL C",
    "owner2": "LAI, L C",
    "current_taxes": 1581.32,
    "new_taxes_no_override": 1649.63,
    "override_total_1": 1696.44,
    "override_increase_1": 46.81
  },
  {
    "#": "33 Pond Ave, Unit 917  (287-13-87)",
    "$": 523100,
    "address": "33 Pond Ave, Unit 917 ",
    "parcel_id": "287-13-87",
    "owner1": "ADAMOWICZ, DAVID",
    "owner2": "",
    "current_taxes": 5356.54,
    "new_taxes_no_override": 5587.94,
    "override_total_1": 5746.5,
    "override_increase_1": 158.55
  },
  {
    "#": "33 Pond Ave, Unit 918 (287-13-88)",
    "$": 473700,
    "address": "33 Pond Ave, Unit 918",
    "parcel_id": "287-13-88",
    "owner1": "DADALT TRS, SANDRA M & ANTHONY",
    "owner2": "",
    "current_taxes": 4850.69,
    "new_taxes_no_override": 5060.24,
    "override_total_1": 5203.82,
    "override_increase_1": 143.58
  },
  {
    "#": "33 Pond Ave, Unit 919 & P171 (287-13-89)",
    "$": 764600,
    "address": "33 Pond Ave, Unit 919 & P171",
    "parcel_id": "287-13-89",
    "owner1": "HAO, ZHONGMING",
    "owner2": "",
    "current_taxes": 7829.5,
    "new_taxes_no_override": 8167.73,
    "override_total_1": 8399.49,
    "override_increase_1": 231.75
  },
  {
    "#": "33 Pond Ave, Unit 920 & P138 (287-13-90)",
    "$": 516600,
    "address": "33 Pond Ave, Unit 920 & P138",
    "parcel_id": "287-13-90",
    "owner1": "LEON TR, SONIA",
    "owner2": "C/O JOBLIN C YOUNGER",
    "current_taxes": 5289.98,
    "new_taxes_no_override": 5518.51,
    "override_total_1": 5675.09,
    "override_increase_1": 156.58
  },
  {
    "#": "33 Pond Ave, Unit 921 P90&A (287-13-91)",
    "$": 788300,
    "address": "33 Pond Ave, Unit 921 P90&A",
    "parcel_id": "287-13-91",
    "owner1": "GROSSMAN, MARK M",
    "owner2": "",
    "current_taxes": 8072.19,
    "new_taxes_no_override": 8420.91,
    "override_total_1": 8659.85,
    "override_increase_1": 238.94
  },
  {
    "#": "33 Pond Ave, Unit 922 & P115 (287-13-92)",
    "$": 566500,
    "address": "33 Pond Ave, Unit 922 & P115",
    "parcel_id": "287-13-92",
    "owner1": "GUJRAL, TARANJIT S",
    "owner2": "CHAN, MARINA",
    "current_taxes": 5800.96,
    "new_taxes_no_override": 6051.56,
    "override_total_1": 6223.27,
    "override_increase_1": 171.71
  },
  {
    "#": "33 Pond Ave, Unit 923 & P121 (287-13-93)",
    "$": 577300,
    "address": "33 Pond Ave, Unit 923 & P121",
    "parcel_id": "287-13-93",
    "owner1": "AL-NAIB, MAY N",
    "owner2": "",
    "current_taxes": 5911.55,
    "new_taxes_no_override": 6166.93,
    "override_total_1": 6341.91,
    "override_increase_1": 174.98
  },
  {
    "#": "33 Pond Ave, Unit 924 & P264 (287-13-94)",
    "$": 695800,
    "address": "33 Pond Ave, Unit 924 & P264",
    "parcel_id": "287-13-94",
    "owner1": "KIM, SUN & JESSE",
    "owner2": "",
    "current_taxes": 7124.99,
    "new_taxes_no_override": 7432.79,
    "override_total_1": 7643.69,
    "override_increase_1": 210.9
  },
  {
    "#": "33 Pond Ave, Unit Nr-1 (287-12-00)",
    "$": 935400,
    "address": "33 Pond Ave, Unit Nr-1",
    "parcel_id": "287-12-00",
    "owner1": "ATTIC BROOK HOUSE LLC",
    "owner2": "",
    "current_taxes": 16051.46,
    "new_taxes_no_override": 16744.88,
    "override_total_1": 17220.01,
    "override_increase_1": 475.12
  },
  {
    "#": "33 Pond Ave, Unit Nr-102B (287-18-17)",
    "$": 1101500,
    "address": "33 Pond Ave, Unit Nr-102B",
    "parcel_id": "287-18-17",
    "owner1": "ATLANTIC BROOKHOUSE REALTY LLC",
    "owner2": "",
    "current_taxes": 18901.74,
    "new_taxes_no_override": 19718.3,
    "override_total_1": 20277.79,
    "override_increase_1": 559.49
  },
  {
    "#": "33 Pond Ave, Unit Nr-104B (287-18-19)",
    "$": 509100,
    "address": "33 Pond Ave, Unit Nr-104B",
    "parcel_id": "287-18-19",
    "owner1": "BERGEL TR, ERNEST W",
    "owner2": "",
    "current_taxes": 8736.16,
    "new_taxes_no_override": 9113.56,
    "override_total_1": 9372.15,
    "override_increase_1": 258.59
  },
  {
    "#": "33 Pond Ave, Unit Nr-3 (287-12-02)",
    "$": 1205000,
    "address": "33 Pond Ave, Unit Nr-3",
    "parcel_id": "287-12-02",
    "owner1": "GHOSTLAW PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 20677.8,
    "new_taxes_no_override": 21571.08,
    "override_total_1": 22183.14,
    "override_increase_1": 612.06
  },
  {
    "#": "33 Pond Ave, Unit Nr-4 (287-17-74)",
    "$": 1689600,
    "address": "33 Pond Ave, Unit Nr-4",
    "parcel_id": "287-17-74",
    "owner1": "SAHANI PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 28993.54,
    "new_taxes_no_override": 30246.06,
    "override_total_1": 31104.27,
    "override_increase_1": 858.21
  },
  {
    "#": "33 Pond Ave, Unit Nr103B 705 (287-18-18)",
    "$": 571600,
    "address": "33 Pond Ave, Unit Nr103B 705",
    "parcel_id": "287-18-18",
    "owner1": "JURIANSZ, PETER A",
    "owner2": "",
    "current_taxes": 9808.66,
    "new_taxes_no_override": 10232.39,
    "override_total_1": 10522.73,
    "override_increase_1": 290.34
  },
  {
    "#": "33 Pond Ave, Unit Nr106B 692 (287-18-20)",
    "$": 526000,
    "address": "33 Pond Ave, Unit Nr106B 692",
    "parcel_id": "287-18-20",
    "owner1": "ATLANTIC-BROOK HOUSE, REALTY II LLC",
    "owner2": "C/O ATLANTIC MGMT CORP",
    "current_taxes": 9026.16,
    "new_taxes_no_override": 9416.09,
    "override_total_1": 9683.26,
    "override_increase_1": 267.17
  },
  {
    "#": "33 Pond Ave, Unit Nr109B & P (287-18-21)",
    "$": 752500,
    "address": "33 Pond Ave, Unit Nr109B & P",
    "parcel_id": "287-18-21",
    "owner1": "ATLANTIC-BROOK HOUSE, REALTY II LLC",
    "owner2": "C/O ATLANTIC MGMT CORP",
    "current_taxes": 12912.9,
    "new_taxes_no_override": 13470.74,
    "override_total_1": 13852.96,
    "override_increase_1": 382.22
  },
  {
    "#": "33 Pond Ave, Unit P 89-89A (287-17-83)",
    "$": 84000,
    "address": "33 Pond Ave, Unit P 89-89A",
    "parcel_id": "287-17-83",
    "owner1": "TURKANIS, TR, ROY",
    "owner2": "",
    "current_taxes": 860.16,
    "new_taxes_no_override": 897.32,
    "override_total_1": 922.78,
    "override_increase_1": 25.46
  },
  {
    "#": "33 Pond Ave, Unit P 91-91A (287-17-85)",
    "$": 84000,
    "address": "33 Pond Ave, Unit P 91-91A",
    "parcel_id": "287-17-85",
    "owner1": "PASTERNACK, SUSAN",
    "owner2": "WEISSMAN, FRED",
    "current_taxes": 860.16,
    "new_taxes_no_override": 897.32,
    "override_total_1": 922.78,
    "override_increase_1": 25.46
  },
  {
    "#": "33 Pond Ave, Unit P-103 (287-18-16)",
    "$": 60000,
    "address": "33 Pond Ave, Unit P-103",
    "parcel_id": "287-18-16",
    "owner1": "SHAYEGAN TRS, BIJAN",
    "owner2": "",
    "current_taxes": 614.4,
    "new_taxes_no_override": 640.94,
    "override_total_1": 659.13,
    "override_increase_1": 18.19
  },
  {
    "#": "33 Pond Ave, Unit P-187-187A (287-18-14)",
    "$": 90000,
    "address": "33 Pond Ave, Unit P-187-187A",
    "parcel_id": "287-18-14",
    "owner1": "KAPLAN, SUSAN B",
    "owner2": "",
    "current_taxes": 921.6,
    "new_taxes_no_override": 961.41,
    "override_total_1": 988.69,
    "override_increase_1": 27.28
  },
  {
    "#": "33 Pond Ave, Unit P-296 (287-18-00)",
    "$": 60000,
    "address": "33 Pond Ave, Unit P-296",
    "parcel_id": "287-18-00",
    "owner1": "LIN, JASON YE",
    "owner2": "LI, PENG",
    "current_taxes": 614.4,
    "new_taxes_no_override": 640.94,
    "override_total_1": 659.13,
    "override_increase_1": 18.19
  },
  {
    "#": "33 Pond Ave, Unit P-335C (287-17-80)",
    "$": 63500,
    "address": "33 Pond Ave, Unit P-335C",
    "parcel_id": "287-17-80",
    "owner1": "DINERMAN, HARRY",
    "owner2": "",
    "current_taxes": 650.24,
    "new_taxes_no_override": 678.33,
    "override_total_1": 697.58,
    "override_increase_1": 19.25
  },
  {
    "#": "33 Pond Ave, Unit P117 (287-18-71)",
    "$": 61800,
    "address": "33 Pond Ave, Unit P117",
    "parcel_id": "287-18-71",
    "owner1": "KUGLER, ALEJANDRO & ANN K",
    "owner2": "",
    "current_taxes": 632.83,
    "new_taxes_no_override": 660.17,
    "override_total_1": 678.9,
    "override_increase_1": 18.73
  },
  {
    "#": "33 Pond Ave, Unit P150 (287-18-80)",
    "$": 61900,
    "address": "33 Pond Ave, Unit P150",
    "parcel_id": "287-18-80",
    "owner1": "SZETO, ROSEMARY & HERBERT",
    "owner2": "",
    "current_taxes": 633.86,
    "new_taxes_no_override": 661.24,
    "override_total_1": 680.01,
    "override_increase_1": 18.76
  },
  {
    "#": "33 Pond Ave, Unit P176 (287-18-75)",
    "$": 63500,
    "address": "33 Pond Ave, Unit P176",
    "parcel_id": "287-18-75",
    "owner1": "ETKIN, ISABEL",
    "owner2": "",
    "current_taxes": 650.24,
    "new_taxes_no_override": 678.33,
    "override_total_1": 697.58,
    "override_increase_1": 19.25
  },
  {
    "#": "33 Pond Ave, Unit P279 (287-18-54)",
    "$": 60000,
    "address": "33 Pond Ave, Unit P279",
    "parcel_id": "287-18-54",
    "owner1": "SHTIFTER, ZVI",
    "owner2": "",
    "current_taxes": 614.4,
    "new_taxes_no_override": 640.94,
    "override_total_1": 659.13,
    "override_increase_1": 18.19
  },
  {
    "#": "33 Pond Ave, Unit P88-88A (287-18-55)",
    "$": 90000,
    "address": "33 Pond Ave, Unit P88-88A",
    "parcel_id": "287-18-55",
    "owner1": "ZHOU, CHENGJIE",
    "owner2": "DONG, YANHUA",
    "current_taxes": 921.6,
    "new_taxes_no_override": 961.41,
    "override_total_1": 988.69,
    "override_increase_1": 27.28
  },
  {
    "#": "33 Pond Ave, Unit P98 (287-17-77)",
    "$": 57800,
    "address": "33 Pond Ave, Unit P98",
    "parcel_id": "287-17-77",
    "owner1": "SONG, WENJUN",
    "owner2": "",
    "current_taxes": 591.87,
    "new_taxes_no_override": 617.44,
    "override_total_1": 634.96,
    "override_increase_1": 17.52
  },
  {
    "#": "77 Pond Ave, Unit 1001 355&A (287-15-61)",
    "$": 978800,
    "address": "77 Pond Ave, Unit 1001 355&A",
    "parcel_id": "287-15-61",
    "owner1": "ERGEN, ERIK E & ERKUT E & NESLIN",
    "owner2": "",
    "current_taxes": 10022.91,
    "new_taxes_no_override": 10455.9,
    "override_total_1": 10752.58,
    "override_increase_1": 296.68
  },
  {
    "#": "77 Pond Ave, Unit 1002 558&A (287-15-62)",
    "$": 980700,
    "address": "77 Pond Ave, Unit 1002 558&A",
    "parcel_id": "287-15-62",
    "owner1": "CHIN TRS, MICHAEL T",
    "owner2": "SHIMAMURA, AKIKO",
    "current_taxes": 6407.43,
    "new_taxes_no_override": 6684.23,
    "override_total_1": 6873.89,
    "override_increase_1": 189.66
  },
  {
    "#": "77 Pond Ave, Unit 1003 P372 (287-15-63)",
    "$": 526400,
    "address": "77 Pond Ave, Unit 1003 P372",
    "parcel_id": "287-15-63",
    "owner1": "LI, HANK",
    "owner2": "",
    "current_taxes": 5390.34,
    "new_taxes_no_override": 5623.2,
    "override_total_1": 5782.76,
    "override_increase_1": 159.55
  },
  {
    "#": "77 Pond Ave, Unit 1004 P491 (287-15-64)",
    "$": 516500,
    "address": "77 Pond Ave, Unit 1004 P491",
    "parcel_id": "287-15-64",
    "owner1": "LI, GORDON KUO",
    "owner2": "SZETO, RAYMOND",
    "current_taxes": 1654.03,
    "new_taxes_no_override": 1725.48,
    "override_total_1": 1774.44,
    "override_increase_1": 48.96
  },
  {
    "#": "77 Pond Ave, Unit 1005 308&A (287-15-65)",
    "$": 775900,
    "address": "77 Pond Ave, Unit 1005 308&A",
    "parcel_id": "287-15-65",
    "owner1": "BROWN, TRS, DAVID J",
    "owner2": "MULLER, CORINNE",
    "current_taxes": 7945.22,
    "new_taxes_no_override": 8288.45,
    "override_total_1": 8523.63,
    "override_increase_1": 235.18
  },
  {
    "#": "77 Pond Ave, Unit 1006 542&A (287-15-66)",
    "$": 795900,
    "address": "77 Pond Ave, Unit 1006 542&A",
    "parcel_id": "287-15-66",
    "owner1": "HENSON, ROBERT",
    "owner2": "HOSHI, YOSHI",
    "current_taxes": 4515.08,
    "new_taxes_no_override": 4710.13,
    "override_total_1": 4843.78,
    "override_increase_1": 133.65
  },
  {
    "#": "77 Pond Ave, Unit 1007 P567B (287-15-67)",
    "$": 506300,
    "address": "77 Pond Ave, Unit 1007 P567B",
    "parcel_id": "287-15-67",
    "owner1": "JIWA, FARAH",
    "owner2": "",
    "current_taxes": 5184.51,
    "new_taxes_no_override": 5408.48,
    "override_total_1": 5561.94,
    "override_increase_1": 153.46
  },
  {
    "#": "77 Pond Ave, Unit 1008 P614 (287-15-68)",
    "$": 479400,
    "address": "77 Pond Ave, Unit 1008 P614",
    "parcel_id": "287-15-68",
    "owner1": "IBSB DECORATION LLC",
    "owner2": "",
    "current_taxes": 4909.06,
    "new_taxes_no_override": 5121.13,
    "override_total_1": 5266.44,
    "override_increase_1": 145.31
  },
  {
    "#": "77 Pond Ave, Unit 1009 P619 (287-15-69)",
    "$": 577800,
    "address": "77 Pond Ave, Unit 1009 P619",
    "parcel_id": "287-15-69",
    "owner1": "XIAO, FENG",
    "owner2": "ZHANG, HUAN",
    "current_taxes": 2281.74,
    "new_taxes_no_override": 2380.31,
    "override_total_1": 2447.85,
    "override_increase_1": 67.54
  },
  {
    "#": "77 Pond Ave, Unit 1010 P422 (287-15-70)",
    "$": 568900,
    "address": "77 Pond Ave, Unit 1010 P422",
    "parcel_id": "287-15-70",
    "owner1": "77 POND AVE UNIT 1010 LLC",
    "owner2": "",
    "current_taxes": 5825.54,
    "new_taxes_no_override": 6077.2,
    "override_total_1": 6249.64,
    "override_increase_1": 172.44
  },
  {
    "#": "77 Pond Ave, Unit 1011 P208 (287-15-71)",
    "$": 565400,
    "address": "77 Pond Ave, Unit 1011 P208",
    "parcel_id": "287-15-71",
    "owner1": "SHARMA, SAMATA",
    "owner2": "",
    "current_taxes": 5789.7,
    "new_taxes_no_override": 6039.82,
    "override_total_1": 6211.19,
    "override_increase_1": 171.38
  },
  {
    "#": "77 Pond Ave, Unit 1012 P306 (287-15-72)",
    "$": 464100,
    "address": "77 Pond Ave, Unit 1012 P306",
    "parcel_id": "287-15-72",
    "owner1": "KAYA, EMINE E",
    "owner2": "",
    "current_taxes": 1117.45,
    "new_taxes_no_override": 1165.72,
    "override_total_1": 1198.8,
    "override_increase_1": 33.08
  },
  {
    "#": "77 Pond Ave, Unit 1101 330&A (287-15-73)",
    "$": 978800,
    "address": "77 Pond Ave, Unit 1101 330&A",
    "parcel_id": "287-15-73",
    "owner1": "DORSEY TR, ELIZABETH L",
    "owner2": "",
    "current_taxes": 6387.98,
    "new_taxes_no_override": 6663.94,
    "override_total_1": 6853.02,
    "override_increase_1": 189.08
  },
  {
    "#": "77 Pond Ave, Unit 1102 557&A (287-15-74)",
    "$": 980700,
    "address": "77 Pond Ave, Unit 1102 557&A",
    "parcel_id": "287-15-74",
    "owner1": "NOVIKOV TR, ALEXANDER",
    "owner2": "",
    "current_taxes": 6407.43,
    "new_taxes_no_override": 6684.23,
    "override_total_1": 6873.89,
    "override_increase_1": 189.66
  },
  {
    "#": "77 Pond Ave, Unit 1103 P641 (287-15-75)",
    "$": 506300,
    "address": "77 Pond Ave, Unit 1103 P641",
    "parcel_id": "287-15-75",
    "owner1": "SANTANDER BANK N.A",
    "owner2": "",
    "current_taxes": 1549.58,
    "new_taxes_no_override": 1616.52,
    "override_total_1": 1662.39,
    "override_increase_1": 45.87
  },
  {
    "#": "77 Pond Ave, Unit 1104 P508 (287-15-76)",
    "$": 506300,
    "address": "77 Pond Ave, Unit 1104 P508",
    "parcel_id": "287-15-76",
    "owner1": "YEGHIAZARIANS TRS, VARTAN & YEREM",
    "owner2": "",
    "current_taxes": 5184.51,
    "new_taxes_no_override": 5408.48,
    "override_total_1": 5561.94,
    "override_increase_1": 153.46
  },
  {
    "#": "77 Pond Ave, Unit 1105 526&A (287-15-77)",
    "$": 775900,
    "address": "77 Pond Ave, Unit 1105 526&A",
    "parcel_id": "287-15-77",
    "owner1": "YEGHIAZARIANS TRS, VARTAN & YEREM",
    "owner2": "",
    "current_taxes": 7945.22,
    "new_taxes_no_override": 8288.45,
    "override_total_1": 8523.63,
    "override_increase_1": 235.18
  },
  {
    "#": "77 Pond Ave, Unit 1106 & P217 P224 (287-15-78)",
    "$": 809000,
    "address": "77 Pond Ave, Unit 1106 & P217 P224",
    "parcel_id": "287-15-78",
    "owner1": "CHU, CHEN",
    "owner2": "HE, MIAO",
    "current_taxes": 8284.16,
    "new_taxes_no_override": 8642.04,
    "override_total_1": 8887.25,
    "override_increase_1": 245.21
  },
  {
    "#": "77 Pond Ave, Unit 1107 P335 (287-15-79)",
    "$": 570000,
    "address": "77 Pond Ave, Unit 1107 P335",
    "parcel_id": "287-15-79",
    "owner1": "RENNIE, HELEN & KARALYN",
    "owner2": "",
    "current_taxes": 5836.8,
    "new_taxes_no_override": 6088.95,
    "override_total_1": 6261.72,
    "override_increase_1": 172.77
  },
  {
    "#": "77 Pond Ave, Unit 1108 P447 (287-15-80)",
    "$": 479400,
    "address": "77 Pond Ave, Unit 1108 P447",
    "parcel_id": "287-15-80",
    "owner1": "HUANG, CHING-SHUAN",
    "owner2": "",
    "current_taxes": 1274.12,
    "new_taxes_no_override": 1329.16,
    "override_total_1": 1366.88,
    "override_increase_1": 37.71
  },
  {
    "#": "77 Pond Ave, Unit 1109 & 501-501A (287-15-81)",
    "$": 546800,
    "address": "77 Pond Ave, Unit 1109 & 501-501A",
    "parcel_id": "287-15-81",
    "owner1": "77-1109 BROOK HOUSE LLC",
    "owner2": "",
    "current_taxes": 5599.23,
    "new_taxes_no_override": 5841.12,
    "override_total_1": 6006.85,
    "override_increase_1": 165.74
  },
  {
    "#": "77 Pond Ave, Unit 1110 P367 (287-15-82)",
    "$": 510400,
    "address": "77 Pond Ave, Unit 1110 P367",
    "parcel_id": "287-15-82",
    "owner1": "CHA, WOONJA",
    "owner2": "",
    "current_taxes": 5226.5,
    "new_taxes_no_override": 5452.28,
    "override_total_1": 5606.99,
    "override_increase_1": 154.7
  },
  {
    "#": "77 Pond Ave, Unit 1111 P438 (287-15-83)",
    "$": 510700,
    "address": "77 Pond Ave, Unit 1111 P438",
    "parcel_id": "287-15-83",
    "owner1": "KATZ, SANDRA M",
    "owner2": "",
    "current_taxes": 1594.63,
    "new_taxes_no_override": 1663.52,
    "override_total_1": 1710.72,
    "override_increase_1": 47.2
  },
  {
    "#": "77 Pond Ave, Unit 1112 P591 (287-15-84)",
    "$": 464100,
    "address": "77 Pond Ave, Unit 1112 P591",
    "parcel_id": "287-15-84",
    "owner1": "ERGEN, ERIK E",
    "owner2": "",
    "current_taxes": 4752.38,
    "new_taxes_no_override": 4957.68,
    "override_total_1": 5098.35,
    "override_increase_1": 140.67
  },
  {
    "#": "77 Pond Ave, Unit 1201 521&A (287-15-85)",
    "$": 883200,
    "address": "77 Pond Ave, Unit 1201 521&A",
    "parcel_id": "287-15-85",
    "owner1": "HERMAN TR, JUDITH B",
    "owner2": "",
    "current_taxes": 5409.03,
    "new_taxes_no_override": 5642.7,
    "override_total_1": 5802.81,
    "override_increase_1": 160.11
  },
  {
    "#": "77 Pond Ave, Unit 1202 567&A (287-15-86)",
    "$": 938200,
    "address": "77 Pond Ave, Unit 1202 567&A",
    "parcel_id": "287-15-86",
    "owner1": "PARMENTER, RICHARD W & ROBINLEE A",
    "owner2": "",
    "current_taxes": 9607.17,
    "new_taxes_no_override": 10022.2,
    "override_total_1": 10306.57,
    "override_increase_1": 284.37
  },
  {
    "#": "77 Pond Ave, Unit 1203 528&A (287-15-87)",
    "$": 614600,
    "address": "77 Pond Ave, Unit 1203 528&A",
    "parcel_id": "287-15-87",
    "owner1": "HAYES TR, GERARD J",
    "owner2": "",
    "current_taxes": 6293.5,
    "new_taxes_no_override": 6565.38,
    "override_total_1": 6751.67,
    "override_increase_1": 186.29
  },
  {
    "#": "77 Pond Ave, Unit 1204 P578 (287-15-88)",
    "$": 506300,
    "address": "77 Pond Ave, Unit 1204 P578",
    "parcel_id": "287-15-88",
    "owner1": "LEON TR, SONIA",
    "owner2": "C/O JOBLIN C YOUNGER",
    "current_taxes": 5184.51,
    "new_taxes_no_override": 5408.48,
    "override_total_1": 5561.94,
    "override_increase_1": 153.46
  },
  {
    "#": "77 Pond Ave, Unit 1205 P275 (287-15-89)",
    "$": 752600,
    "address": "77 Pond Ave, Unit 1205 P275",
    "parcel_id": "287-15-89",
    "owner1": "SMIRNOVA, TRS, MARIA",
    "owner2": "",
    "current_taxes": 7706.62,
    "new_taxes_no_override": 8039.55,
    "override_total_1": 8267.66,
    "override_increase_1": 228.12
  },
  {
    "#": "77 Pond Ave, Unit 1206 P507 (287-15-90)",
    "$": 733400,
    "address": "77 Pond Ave, Unit 1206 P507",
    "parcel_id": "287-15-90",
    "owner1": "BARRY, DAVID M",
    "owner2": "",
    "current_taxes": 3875.08,
    "new_taxes_no_override": 4042.48,
    "override_total_1": 4157.19,
    "override_increase_1": 114.7
  },
  {
    "#": "77 Pond Ave, Unit 1207 P646 (287-15-91)",
    "$": 526100,
    "address": "77 Pond Ave, Unit 1207 P646",
    "parcel_id": "287-15-91",
    "owner1": "ZHOU TRS, YING",
    "owner2": "XU, GUANG LI",
    "current_taxes": 1752.33,
    "new_taxes_no_override": 1828.03,
    "override_total_1": 1879.9,
    "override_increase_1": 51.87
  },
  {
    "#": "77 Pond Ave, Unit 1208 (287-15-92)",
    "$": 402900,
    "address": "77 Pond Ave, Unit 1208",
    "parcel_id": "287-15-92",
    "owner1": "KARIMI, ALI",
    "owner2": "",
    "current_taxes": 4125.7,
    "new_taxes_no_override": 4303.93,
    "override_total_1": 4426.05,
    "override_increase_1": 122.12
  },
  {
    "#": "77 Pond Ave, Unit 1209 P655 (287-15-93)",
    "$": 577800,
    "address": "77 Pond Ave, Unit 1209 P655",
    "parcel_id": "287-15-93",
    "owner1": "MIKALIAN, BENJAMIN",
    "owner2": "",
    "current_taxes": 2281.74,
    "new_taxes_no_override": 2380.31,
    "override_total_1": 2447.85,
    "override_increase_1": 67.54
  },
  {
    "#": "77 Pond Ave, Unit 1210 P324 (287-15-94)",
    "$": 498500,
    "address": "77 Pond Ave, Unit 1210 P324",
    "parcel_id": "287-15-94",
    "owner1": "SEIDEN, RICHARD L",
    "owner2": "",
    "current_taxes": 1469.71,
    "new_taxes_no_override": 1533.2,
    "override_total_1": 1576.7,
    "override_increase_1": 43.5
  },
  {
    "#": "77 Pond Ave, Unit 1211 P401 (287-15-95)",
    "$": 495400,
    "address": "77 Pond Ave, Unit 1211 P401",
    "parcel_id": "287-15-95",
    "owner1": "HERNANDEZ, OLMANDA",
    "owner2": "",
    "current_taxes": 1437.96,
    "new_taxes_no_override": 1500.08,
    "override_total_1": 1542.64,
    "override_increase_1": 42.56
  },
  {
    "#": "77 Pond Ave, Unit 1212 P336 (287-15-96)",
    "$": 448800,
    "address": "77 Pond Ave, Unit 1212 P336",
    "parcel_id": "287-15-96",
    "owner1": "J & A REALTY LLC",
    "owner2": "C/O LEHANE, ARLENE",
    "current_taxes": 4595.71,
    "new_taxes_no_override": 4794.24,
    "override_total_1": 4930.28,
    "override_increase_1": 136.03
  },
  {
    "#": "77 Pond Ave, Unit 1401 P597A (287-15-97)",
    "$": 929900,
    "address": "77 Pond Ave, Unit 1401 P597A",
    "parcel_id": "287-15-97",
    "owner1": "WANG, DAVID Y",
    "owner2": "",
    "current_taxes": 9522.18,
    "new_taxes_no_override": 9933.54,
    "override_total_1": 10215.39,
    "override_increase_1": 281.86
  },
  {
    "#": "77 Pond Ave, Unit 1402 519&A (287-15-98)",
    "$": 922400,
    "address": "77 Pond Ave, Unit 1402 519&A",
    "parcel_id": "287-15-98",
    "owner1": "KDLD 77 POND AVE 1402 LLC",
    "owner2": "",
    "current_taxes": 9445.38,
    "new_taxes_no_override": 9853.42,
    "override_total_1": 10133.0,
    "override_increase_1": 279.58
  },
  {
    "#": "77 Pond Ave, Unit 1403 P261 (287-15-99)",
    "$": 591400,
    "address": "77 Pond Ave, Unit 1403 P261",
    "parcel_id": "287-15-99",
    "owner1": "KOZAK, ALEXA T",
    "owner2": "",
    "current_taxes": 6055.94,
    "new_taxes_no_override": 6317.56,
    "override_total_1": 6496.81,
    "override_increase_1": 179.26
  },
  {
    "#": "77 Pond Ave, Unit 1404 P511 (287-16-00)",
    "$": 570000,
    "address": "77 Pond Ave, Unit 1404 P511",
    "parcel_id": "287-16-00",
    "owner1": "ROSS, DANIEL",
    "owner2": "",
    "current_taxes": 5836.8,
    "new_taxes_no_override": 6088.95,
    "override_total_1": 6261.72,
    "override_increase_1": 172.77
  },
  {
    "#": "77 Pond Ave, Unit 1405 564&A (287-16-01)",
    "$": 821000,
    "address": "77 Pond Ave, Unit 1405 564&A",
    "parcel_id": "287-16-01",
    "owner1": "GHAEMI, MEHDI & NAZILA RESHAD",
    "owner2": "",
    "current_taxes": 8407.04,
    "new_taxes_no_override": 8770.22,
    "override_total_1": 9019.07,
    "override_increase_1": 248.85
  },
  {
    "#": "77 Pond Ave, Unit 1406 517&A (287-16-02)",
    "$": 756600,
    "address": "77 Pond Ave, Unit 1406 517&A",
    "parcel_id": "287-16-02",
    "owner1": "NICKLES, DAVID E",
    "owner2": "",
    "current_taxes": 7747.58,
    "new_taxes_no_override": 8082.28,
    "override_total_1": 8311.6,
    "override_increase_1": 229.33
  },
  {
    "#": "77 Pond Ave, Unit 1407 P335A (287-16-03)",
    "$": 506300,
    "address": "77 Pond Ave, Unit 1407 P335A",
    "parcel_id": "287-16-03",
    "owner1": "GOMES, ANTONIO S",
    "owner2": "",
    "current_taxes": 5184.51,
    "new_taxes_no_override": 5408.48,
    "override_total_1": 5561.94,
    "override_increase_1": 153.46
  },
  {
    "#": "77 Pond Ave, Unit 1408 (287-16-04)",
    "$": 418200,
    "address": "77 Pond Ave, Unit 1408",
    "parcel_id": "287-16-04",
    "owner1": "WONG TRS, NANCY YIM JANG & CHARLIE WING HING",
    "owner2": "",
    "current_taxes": 4282.37,
    "new_taxes_no_override": 4467.37,
    "override_total_1": 4594.13,
    "override_increase_1": 126.76
  },
  {
    "#": "77 Pond Ave, Unit 1409 P633 (287-16-05)",
    "$": 606900,
    "address": "77 Pond Ave, Unit 1409 P633",
    "parcel_id": "287-16-05",
    "owner1": "WANG, MICHAEL P",
    "owner2": "YAOHUIZHAO, ANNA",
    "current_taxes": 6214.66,
    "new_taxes_no_override": 6483.13,
    "override_total_1": 6667.09,
    "override_increase_1": 183.95
  },
  {
    "#": "77 Pond Ave, Unit 1410 P236 (287-16-06)",
    "$": 582500,
    "address": "77 Pond Ave, Unit 1410 P236",
    "parcel_id": "287-16-06",
    "owner1": "ZHANG, YU",
    "owner2": "",
    "current_taxes": 5964.8,
    "new_taxes_no_override": 6222.48,
    "override_total_1": 6399.04,
    "override_increase_1": 176.56
  },
  {
    "#": "77 Pond Ave, Unit 1411 P326 (287-16-07)",
    "$": 578900,
    "address": "77 Pond Ave, Unit 1411 P326",
    "parcel_id": "287-16-07",
    "owner1": "CUSICK, MARY E",
    "owner2": "",
    "current_taxes": 5927.94,
    "new_taxes_no_override": 6184.03,
    "override_total_1": 6359.49,
    "override_increase_1": 175.47
  },
  {
    "#": "77 Pond Ave, Unit 1412 P244 (287-16-08)",
    "$": 448800,
    "address": "77 Pond Ave, Unit 1412 P244",
    "parcel_id": "287-16-08",
    "owner1": "BOUSSIOTIS, VASSILIKI A",
    "owner2": "",
    "current_taxes": 4595.71,
    "new_taxes_no_override": 4794.24,
    "override_total_1": 4930.28,
    "override_increase_1": 136.03
  },
  {
    "#": "77 Pond Ave, Unit 1501 555&A (287-16-09)",
    "$": 1361400,
    "address": "77 Pond Ave, Unit 1501 555&A",
    "parcel_id": "287-16-09",
    "owner1": "LITT TRS, ROBERT S & DEBORAH G",
    "owner2": "",
    "current_taxes": 10305.8,
    "new_taxes_no_override": 10751.01,
    "override_total_1": 11056.06,
    "override_increase_1": 305.05
  },
  {
    "#": "77 Pond Ave, Unit 1502 524&A (287-16-10)",
    "$": 991300,
    "address": "77 Pond Ave, Unit 1502 524&A",
    "parcel_id": "287-16-10",
    "owner1": "CHARLES, JUDITH A",
    "owner2": "SULLIVAN, JOHN P",
    "current_taxes": 10150.91,
    "new_taxes_no_override": 10589.43,
    "override_total_1": 10889.9,
    "override_increase_1": 300.47
  },
  {
    "#": "77 Pond Ave, Unit 1503 P234 (287-16-11)",
    "$": 518100,
    "address": "77 Pond Ave, Unit 1503 P234",
    "parcel_id": "287-16-11",
    "owner1": "ALBERTO, RODNEY & PRISCILLA",
    "owner2": "RENATO",
    "current_taxes": 5305.34,
    "new_taxes_no_override": 5534.53,
    "override_total_1": 5691.57,
    "override_increase_1": 157.04
  },
  {
    "#": "77 Pond Ave, Unit 1504 P607 (287-16-12)",
    "$": 577800,
    "address": "77 Pond Ave, Unit 1504 P607",
    "parcel_id": "287-16-12",
    "owner1": "ROY, HEATHER",
    "owner2": "",
    "current_taxes": 2281.74,
    "new_taxes_no_override": 2380.31,
    "override_total_1": 2447.85,
    "override_increase_1": 67.54
  },
  {
    "#": "77 Pond Ave, Unit 1505 571&A (287-16-13)",
    "$": 776700,
    "address": "77 Pond Ave, Unit 1505 571&A",
    "parcel_id": "287-16-13",
    "owner1": "BROOK HOUSE CONDO C1505 LLC",
    "owner2": "",
    "current_taxes": 7953.41,
    "new_taxes_no_override": 8297.0,
    "override_total_1": 8532.42,
    "override_increase_1": 235.42
  },
  {
    "#": "77 Pond Ave, Unit 1506 502&A (287-16-14)",
    "$": 774900,
    "address": "77 Pond Ave, Unit 1506 502&A",
    "parcel_id": "287-16-14",
    "owner1": "KRAJOVIC TR, RICHARD PAUL",
    "owner2": "",
    "current_taxes": 4300.04,
    "new_taxes_no_override": 4485.8,
    "override_total_1": 4613.08,
    "override_increase_1": 127.28
  },
  {
    "#": "77 Pond Ave, Unit 1507 P376 (287-16-15)",
    "$": 506300,
    "address": "77 Pond Ave, Unit 1507 P376",
    "parcel_id": "287-16-15",
    "owner1": "BOTTARY, PATRICIA E & JENNIFER",
    "owner2": "",
    "current_taxes": 1549.58,
    "new_taxes_no_override": 1616.52,
    "override_total_1": 1662.39,
    "override_increase_1": 45.87
  },
  {
    "#": "77 Pond Ave, Unit 1508 520&A (287-16-16)",
    "$": 791800,
    "address": "77 Pond Ave, Unit 1508 520&A",
    "parcel_id": "287-16-16",
    "owner1": "BERKE TR, ERIC D",
    "owner2": "",
    "current_taxes": 4473.1,
    "new_taxes_no_override": 4666.34,
    "override_total_1": 4798.74,
    "override_increase_1": 132.4
  },
  {
    "#": "77 Pond Ave, Unit 1509 P623 (287-16-17)",
    "$": 506300,
    "address": "77 Pond Ave, Unit 1509 P623",
    "parcel_id": "287-16-17",
    "owner1": "LEON TR, SONIA",
    "owner2": "C/O JOBLIN C. YOUNGER",
    "current_taxes": 5184.51,
    "new_taxes_no_override": 5408.48,
    "override_total_1": 5561.94,
    "override_increase_1": 153.46
  },
  {
    "#": "77 Pond Ave, Unit 201 P563&A (287-14-73)",
    "$": 864900,
    "address": "77 Pond Ave, Unit 201 P563&A",
    "parcel_id": "287-14-73",
    "owner1": "GHOREISHI, S JAVAD",
    "owner2": "",
    "current_taxes": 5221.64,
    "new_taxes_no_override": 5447.21,
    "override_total_1": 5601.78,
    "override_increase_1": 154.56
  },
  {
    "#": "77 Pond Ave, Unit 202 P587B (287-14-74)",
    "$": 871000,
    "address": "77 Pond Ave, Unit 202 P587B",
    "parcel_id": "287-14-74",
    "owner1": "KANTOR TRS, WILLIAM M & PHYLLIS W",
    "owner2": "",
    "current_taxes": 5284.11,
    "new_taxes_no_override": 5512.38,
    "override_total_1": 5668.79,
    "override_increase_1": 156.41
  },
  {
    "#": "77 Pond Ave, Unit 203 & P466 (287-14-75)",
    "$": 521600,
    "address": "77 Pond Ave, Unit 203 & P466",
    "parcel_id": "287-14-75",
    "owner1": "TANG, FUCHUAN",
    "owner2": "",
    "current_taxes": 5341.18,
    "new_taxes_no_override": 5571.92,
    "override_total_1": 5730.02,
    "override_increase_1": 158.1
  },
  {
    "#": "77 Pond Ave, Unit 204 & P301 (287-14-76)",
    "$": 526400,
    "address": "77 Pond Ave, Unit 204 & P301",
    "parcel_id": "287-14-76",
    "owner1": "GAO, LI-GUO",
    "owner2": "LIANG, WEI-LI",
    "current_taxes": 5390.34,
    "new_taxes_no_override": 5623.2,
    "override_total_1": 5782.76,
    "override_increase_1": 159.55
  },
  {
    "#": "77 Pond Ave, Unit 301 P495&A (287-14-77)",
    "$": 904200,
    "address": "77 Pond Ave, Unit 301 P495&A",
    "parcel_id": "287-14-77",
    "owner1": "KIEFF TRS, LAUREN R & DAVID A",
    "owner2": "",
    "current_taxes": 9259.01,
    "new_taxes_no_override": 9659.0,
    "override_total_1": 9933.07,
    "override_increase_1": 274.07
  },
  {
    "#": "77 Pond Ave, Unit 302 & P640 (287-14-78)",
    "$": 843400,
    "address": "77 Pond Ave, Unit 302 & P640",
    "parcel_id": "287-14-78",
    "owner1": "WEINGART, DANIEL E & SARAH L",
    "owner2": "",
    "current_taxes": 5001.48,
    "new_taxes_no_override": 5217.54,
    "override_total_1": 5365.59,
    "override_increase_1": 148.04
  },
  {
    "#": "77 Pond Ave, Unit 303 (287-14-79)",
    "$": 462500,
    "address": "77 Pond Ave, Unit 303",
    "parcel_id": "287-14-79",
    "owner1": "BISCHOFF, ROXANNE N",
    "owner2": "",
    "current_taxes": 1101.07,
    "new_taxes_no_override": 1148.64,
    "override_total_1": 1181.23,
    "override_increase_1": 32.59
  },
  {
    "#": "77 Pond Ave, Unit 304 & P622 (287-14-80)",
    "$": 521600,
    "address": "77 Pond Ave, Unit 304 & P622",
    "parcel_id": "287-14-80",
    "owner1": "GHAEMI, MEHDI & NAZILIA RESHAD",
    "owner2": "",
    "current_taxes": 5341.18,
    "new_taxes_no_override": 5571.92,
    "override_total_1": 5730.02,
    "override_increase_1": 158.1
  },
  {
    "#": "77 Pond Ave, Unit 305 & P465 (287-14-81)",
    "$": 774400,
    "address": "77 Pond Ave, Unit 305 & P465",
    "parcel_id": "287-14-81",
    "owner1": "BRINKERHOFF, JEREMY C & CRISTINA A",
    "owner2": "",
    "current_taxes": 4294.92,
    "new_taxes_no_override": 4480.46,
    "override_total_1": 4607.59,
    "override_increase_1": 127.13
  },
  {
    "#": "77 Pond Ave, Unit 306 & P463 (287-14-82)",
    "$": 750800,
    "address": "77 Pond Ave, Unit 306 & P463",
    "parcel_id": "287-14-82",
    "owner1": "KIM, JESSE & SUN",
    "owner2": "",
    "current_taxes": 7688.19,
    "new_taxes_no_override": 8020.32,
    "override_total_1": 8247.89,
    "override_increase_1": 227.57
  },
  {
    "#": "77 Pond Ave, Unit 307 & P678 (287-14-83)",
    "$": 506300,
    "address": "77 Pond Ave, Unit 307 & P678",
    "parcel_id": "287-14-83",
    "owner1": "FIORELLINI LIFE EST, VALENTINO & ADRIANA",
    "owner2": "",
    "current_taxes": 5184.51,
    "new_taxes_no_override": 5408.48,
    "override_total_1": 5561.94,
    "override_increase_1": 153.46
  },
  {
    "#": "77 Pond Ave, Unit 308 & P455 (287-14-84)",
    "$": 453900,
    "address": "77 Pond Ave, Unit 308 & P455",
    "parcel_id": "287-14-84",
    "owner1": "PALESTER, ELISABETH",
    "owner2": "",
    "current_taxes": 4647.94,
    "new_taxes_no_override": 4848.73,
    "override_total_1": 4986.31,
    "override_increase_1": 137.58
  },
  {
    "#": "77 Pond Ave, Unit 309 (287-14-85)",
    "$": 480800,
    "address": "77 Pond Ave, Unit 309",
    "parcel_id": "287-14-85",
    "owner1": "YUAN, YUJIE",
    "owner2": "",
    "current_taxes": 1288.46,
    "new_taxes_no_override": 1344.12,
    "override_total_1": 1382.26,
    "override_increase_1": 38.14
  },
  {
    "#": "77 Pond Ave, Unit 310 (287-14-86)",
    "$": 462800,
    "address": "77 Pond Ave, Unit 310",
    "parcel_id": "287-14-86",
    "owner1": "FELDMAN, GARRY & EILEEN R",
    "owner2": "",
    "current_taxes": 4739.07,
    "new_taxes_no_override": 4943.8,
    "override_total_1": 5084.07,
    "override_increase_1": 140.28
  },
  {
    "#": "77 Pond Ave, Unit 311 & P411 (287-14-87)",
    "$": 515500,
    "address": "77 Pond Ave, Unit 311 & P411",
    "parcel_id": "287-14-87",
    "owner1": "NORIGIAN, GREGORY B",
    "owner2": "",
    "current_taxes": 5278.72,
    "new_taxes_no_override": 5506.76,
    "override_total_1": 5663.01,
    "override_increase_1": 156.25
  },
  {
    "#": "77 Pond Ave, Unit 312 & P635 (287-14-88)",
    "$": 448800,
    "address": "77 Pond Ave, Unit 312 & P635",
    "parcel_id": "287-14-88",
    "owner1": "CHUN, YOON S",
    "owner2": "",
    "current_taxes": 4595.71,
    "new_taxes_no_override": 4794.24,
    "override_total_1": 4930.28,
    "override_increase_1": 136.03
  },
  {
    "#": "77 Pond Ave, Unit 401 & P582 (287-14-89)",
    "$": 841600,
    "address": "77 Pond Ave, Unit 401 & P582",
    "parcel_id": "287-14-89",
    "owner1": "TON, TRANG NU DIEU",
    "owner2": "VU, HUAN VAN",
    "current_taxes": 4983.05,
    "new_taxes_no_override": 5198.32,
    "override_total_1": 5345.82,
    "override_increase_1": 147.5
  },
  {
    "#": "77 Pond Ave, Unit 402 P477&A (287-14-90)",
    "$": 958000,
    "address": "77 Pond Ave, Unit 402 P477&A",
    "parcel_id": "287-14-90",
    "owner1": "IVANOV, EMANUIL",
    "owner2": "MATEVA, BILIANA",
    "current_taxes": 6174.99,
    "new_taxes_no_override": 6441.75,
    "override_total_1": 6624.53,
    "override_increase_1": 182.78
  },
  {
    "#": "77 Pond Ave, Unit 403 (287-14-91)",
    "$": 455300,
    "address": "77 Pond Ave, Unit 403",
    "parcel_id": "287-14-91",
    "owner1": "EDES, HOLLY R",
    "owner2": "",
    "current_taxes": 4662.27,
    "new_taxes_no_override": 4863.68,
    "override_total_1": 5001.68,
    "override_increase_1": 138.0
  },
  {
    "#": "77 Pond Ave, Unit 404 & P640 (287-14-92)",
    "$": 522400,
    "address": "77 Pond Ave, Unit 404 & P640",
    "parcel_id": "287-14-92",
    "owner1": "RYAN, DANIEL PHILIP",
    "owner2": "SCHEER, ALEXIS NICOLE",
    "current_taxes": 1714.44,
    "new_taxes_no_override": 1788.5,
    "override_total_1": 1839.25,
    "override_increase_1": 50.75
  },
  {
    "#": "77 Pond Ave, Unit 405 P565&A (287-14-93)",
    "$": 797700,
    "address": "77 Pond Ave, Unit 405 P565&A",
    "parcel_id": "287-14-93",
    "owner1": "PALRIWALA, RAMA D & SHIPRA",
    "owner2": "",
    "current_taxes": 4533.51,
    "new_taxes_no_override": 4729.36,
    "override_total_1": 4863.55,
    "override_increase_1": 134.19
  },
  {
    "#": "77 Pond Ave, Unit 406 & P318 (287-14-94)",
    "$": 772600,
    "address": "77 Pond Ave, Unit 406 & P318",
    "parcel_id": "287-14-94",
    "owner1": "REIMER , NANCY M",
    "owner2": "",
    "current_taxes": 4276.49,
    "new_taxes_no_override": 4461.23,
    "override_total_1": 4587.82,
    "override_increase_1": 126.58
  },
  {
    "#": "77 Pond Ave, Unit 407 & P304 (287-14-95)",
    "$": 506300,
    "address": "77 Pond Ave, Unit 407 & P304",
    "parcel_id": "287-14-95",
    "owner1": "SZETO, ROSEMARY",
    "owner2": "",
    "current_taxes": 5184.51,
    "new_taxes_no_override": 5408.48,
    "override_total_1": 5561.94,
    "override_increase_1": 153.46
  },
  {
    "#": "77 Pond Ave, Unit 408 & P263 (287-14-96)",
    "$": 453900,
    "address": "77 Pond Ave, Unit 408 & P263",
    "parcel_id": "287-14-96",
    "owner1": "CHENG, SHIO-IN",
    "owner2": "",
    "current_taxes": 4647.94,
    "new_taxes_no_override": 4848.73,
    "override_total_1": 4986.31,
    "override_increase_1": 137.58
  },
  {
    "#": "77 Pond Ave, Unit 409 & P423 (287-14-97)",
    "$": 506300,
    "address": "77 Pond Ave, Unit 409 & P423",
    "parcel_id": "287-14-97",
    "owner1": "MUKHERJEE, SUNIT-SUBHASH-BHAROTI",
    "owner2": "",
    "current_taxes": 5184.51,
    "new_taxes_no_override": 5408.48,
    "override_total_1": 5561.94,
    "override_increase_1": 153.46
  },
  {
    "#": "77 Pond Ave, Unit 410 (287-14-98)",
    "$": 454700,
    "address": "77 Pond Ave, Unit 410",
    "parcel_id": "287-14-98",
    "owner1": "DANIELS, CHARLES",
    "owner2": "ONG, CARMELIA",
    "current_taxes": 1021.19,
    "new_taxes_no_override": 1065.31,
    "override_total_1": 1095.53,
    "override_increase_1": 30.23
  },
  {
    "#": "77 Pond Ave, Unit 411 & P196 (287-14-99)",
    "$": 510700,
    "address": "77 Pond Ave, Unit 411 & P196",
    "parcel_id": "287-14-99",
    "owner1": "KOTONI, POLINA",
    "owner2": "MAYDMAN, RITA",
    "current_taxes": 5229.57,
    "new_taxes_no_override": 5455.49,
    "override_total_1": 5610.28,
    "override_increase_1": 154.8
  },
  {
    "#": "77 Pond Ave, Unit 412 & P605 (287-15-00)",
    "$": 474300,
    "address": "77 Pond Ave, Unit 412 & P605",
    "parcel_id": "287-15-00",
    "owner1": "BROWN, JEFFERY R",
    "owner2": "TRUJILLO, CELIA",
    "current_taxes": 4856.83,
    "new_taxes_no_override": 5066.65,
    "override_total_1": 5210.41,
    "override_increase_1": 143.76
  },
  {
    "#": "77 Pond Ave, Unit 501 & P569 (287-15-01)",
    "$": 851800,
    "address": "77 Pond Ave, Unit 501 & P569",
    "parcel_id": "287-15-01",
    "owner1": "VESPA, ANTHONY & RHOWENA",
    "owner2": "",
    "current_taxes": 5087.5,
    "new_taxes_no_override": 5307.28,
    "override_total_1": 5457.87,
    "override_increase_1": 150.59
  },
  {
    "#": "77 Pond Ave, Unit 502 & P561-561A (287-15-02)",
    "$": 1092700,
    "address": "77 Pond Ave, Unit 502 & P561-561A",
    "parcel_id": "287-15-02",
    "owner1": "MCCABE TR, JOANNE M",
    "owner2": "",
    "current_taxes": 7554.31,
    "new_taxes_no_override": 7880.66,
    "override_total_1": 8104.26,
    "override_increase_1": 223.61
  },
  {
    "#": "77 Pond Ave, Unit 503 & P197 (287-15-03)",
    "$": 518200,
    "address": "77 Pond Ave, Unit 503 & P197",
    "parcel_id": "287-15-03",
    "owner1": "LONGWOOD INVESTMENT & DEVELOPMENT LLC",
    "owner2": "",
    "current_taxes": 5306.37,
    "new_taxes_no_override": 5535.61,
    "override_total_1": 5692.67,
    "override_increase_1": 157.07
  },
  {
    "#": "77 Pond Ave, Unit 504 & P537 (287-15-04)",
    "$": 531800,
    "address": "77 Pond Ave, Unit 504 & P537",
    "parcel_id": "287-15-04",
    "owner1": "PRASANNA LLC",
    "owner2": "",
    "current_taxes": 5445.63,
    "new_taxes_no_override": 5680.88,
    "override_total_1": 5842.07,
    "override_increase_1": 161.19
  },
  {
    "#": "77 Pond Ave, Unit 505 P546&A (287-15-05)",
    "$": 775900,
    "address": "77 Pond Ave, Unit 505 P546&A",
    "parcel_id": "287-15-05",
    "owner1": "BERKOWITZ, ELIOT & MARIA TERESA",
    "owner2": "",
    "current_taxes": 4310.28,
    "new_taxes_no_override": 4496.48,
    "override_total_1": 4624.07,
    "override_increase_1": 127.58
  },
  {
    "#": "77 Pond Ave, Unit 506 (287-15-06)",
    "$": 660600,
    "address": "77 Pond Ave, Unit 506",
    "parcel_id": "287-15-06",
    "owner1": "SNYDER, STEPHEN",
    "owner2": "ENSOR, DIANA",
    "current_taxes": 6764.54,
    "new_taxes_no_override": 7056.77,
    "override_total_1": 7257.0,
    "override_increase_1": 200.23
  },
  {
    "#": "77 Pond Ave, Unit 507 P331&A (287-15-07)",
    "$": 536900,
    "address": "77 Pond Ave, Unit 507 P331&A",
    "parcel_id": "287-15-07",
    "owner1": "GURIN, ALEXANDER",
    "owner2": "",
    "current_taxes": 5497.86,
    "new_taxes_no_override": 5735.37,
    "override_total_1": 5898.1,
    "override_increase_1": 162.74
  },
  {
    "#": "77 Pond Ave, Unit 508 & P613 (287-15-08)",
    "$": 461000,
    "address": "77 Pond Ave, Unit 508 & P613",
    "parcel_id": "287-15-08",
    "owner1": "LAWRY, LYNN",
    "owner2": "BEARD, ANDREW",
    "current_taxes": 4720.64,
    "new_taxes_no_override": 4924.57,
    "override_total_1": 5064.3,
    "override_increase_1": 139.73
  },
  {
    "#": "77 Pond Ave, Unit 509 & P464 (287-15-09)",
    "$": 584300,
    "address": "77 Pond Ave, Unit 509 & P464",
    "parcel_id": "287-15-09",
    "owner1": "SULLIVAN, JOHN S",
    "owner2": "C/O ISNOR, JANE",
    "current_taxes": 5983.23,
    "new_taxes_no_override": 6241.71,
    "override_total_1": 6418.81,
    "override_increase_1": 177.1
  },
  {
    "#": "77 Pond Ave, Unit 510 (287-15-10)",
    "$": 447500,
    "address": "77 Pond Ave, Unit 510",
    "parcel_id": "287-15-10",
    "owner1": "SALOMON, WILLIAM L",
    "owner2": "",
    "current_taxes": 4582.4,
    "new_taxes_no_override": 4780.36,
    "override_total_1": 4916.0,
    "override_increase_1": 135.64
  },
  {
    "#": "77 Pond Ave, Unit 511 & P572 (287-15-11)",
    "$": 466300,
    "address": "77 Pond Ave, Unit 511 & P572",
    "parcel_id": "287-15-11",
    "owner1": "LENARD, MELANIE L",
    "owner2": "",
    "current_taxes": 1139.98,
    "new_taxes_no_override": 1189.23,
    "override_total_1": 1222.97,
    "override_increase_1": 33.74
  },
  {
    "#": "77 Pond Ave, Unit 512 & P277 (287-15-12)",
    "$": 460700,
    "address": "77 Pond Ave, Unit 512 & P277",
    "parcel_id": "287-15-12",
    "owner1": "ZHAO, LLJIE",
    "owner2": "WANG, XI",
    "current_taxes": 4717.57,
    "new_taxes_no_override": 4921.37,
    "override_total_1": 5061.01,
    "override_increase_1": 139.64
  },
  {
    "#": "77 Pond Ave, Unit 601 P471Ab (287-15-13)",
    "$": 989200,
    "address": "77 Pond Ave, Unit 601 P471Ab",
    "parcel_id": "287-15-13",
    "owner1": "SIBAHATAU, RYNAT",
    "owner2": "TALSTASHOVA, KATSIARYNA",
    "current_taxes": 6494.47,
    "new_taxes_no_override": 6775.03,
    "override_total_1": 6967.27,
    "override_increase_1": 192.24
  },
  {
    "#": "77 Pond Ave, Unit 602 & P343 (287-15-14)",
    "$": 871000,
    "address": "77 Pond Ave, Unit 602 & P343",
    "parcel_id": "287-15-14",
    "owner1": "KOVACHEVA, VESELA P",
    "owner2": "",
    "current_taxes": 8919.04,
    "new_taxes_no_override": 9304.34,
    "override_total_1": 9568.35,
    "override_increase_1": 264.0
  },
  {
    "#": "77 Pond Ave, Unit 603 (287-15-15)",
    "$": 467200,
    "address": "77 Pond Ave, Unit 603",
    "parcel_id": "287-15-15",
    "owner1": "RONG, SHISONG",
    "owner2": "YU, XINTING",
    "current_taxes": 1149.19,
    "new_taxes_no_override": 1198.84,
    "override_total_1": 1232.85,
    "override_increase_1": 34.02
  },
  {
    "#": "77 Pond Ave, Unit 604 & P568 (287-15-16)",
    "$": 523700,
    "address": "77 Pond Ave, Unit 604 & P568",
    "parcel_id": "287-15-16",
    "owner1": "AOUDE, ELIE J",
    "owner2": "",
    "current_taxes": 1727.75,
    "new_taxes_no_override": 1802.39,
    "override_total_1": 1853.53,
    "override_increase_1": 51.14
  },
  {
    "#": "77 Pond Ave, Unit 605 & P460 P675 (287-15-17)",
    "$": 821000,
    "address": "77 Pond Ave, Unit 605 & P460 P675",
    "parcel_id": "287-15-17",
    "owner1": "WU, FENGLIANG",
    "owner2": "GAI, XIAOYAN",
    "current_taxes": 8407.04,
    "new_taxes_no_override": 8770.22,
    "override_total_1": 9019.07,
    "override_increase_1": 248.85
  },
  {
    "#": "77 Pond Ave, Unit 606 P579&A (287-15-18)",
    "$": 800700,
    "address": "77 Pond Ave, Unit 606 P579&A",
    "parcel_id": "287-15-18",
    "owner1": "TARCAN, TUFAN & ESIN",
    "owner2": "",
    "current_taxes": 8199.17,
    "new_taxes_no_override": 8553.37,
    "override_total_1": 8796.07,
    "override_increase_1": 242.7
  },
  {
    "#": "77 Pond Ave, Unit 607 & P210 (287-15-19)",
    "$": 506300,
    "address": "77 Pond Ave, Unit 607 & P210",
    "parcel_id": "287-15-19",
    "owner1": "MORIN, DANIEL O",
    "owner2": "CETINA-GIRALDO, SANDRA",
    "current_taxes": 5184.51,
    "new_taxes_no_override": 5408.48,
    "override_total_1": 5561.94,
    "override_increase_1": 153.46
  },
  {
    "#": "77 Pond Ave, Unit 608 & P260 (287-15-20)",
    "$": 453900,
    "address": "77 Pond Ave, Unit 608 & P260",
    "parcel_id": "287-15-20",
    "owner1": "CHOU, MICHELLE Y",
    "owner2": "",
    "current_taxes": 4647.94,
    "new_taxes_no_override": 4848.73,
    "override_total_1": 4986.31,
    "override_increase_1": 137.58
  },
  {
    "#": "77 Pond Ave, Unit 609 & P282 (287-15-21)",
    "$": 521600,
    "address": "77 Pond Ave, Unit 609 & P282",
    "parcel_id": "287-15-21",
    "owner1": "LANTSMAN, STAN",
    "owner2": "VAKHER, KATHERINE",
    "current_taxes": 5341.18,
    "new_taxes_no_override": 5571.92,
    "override_total_1": 5730.02,
    "override_increase_1": 158.1
  },
  {
    "#": "77 Pond Ave, Unit 610 Pc488 (287-15-22)",
    "$": 505700,
    "address": "77 Pond Ave, Unit 610 Pc488",
    "parcel_id": "287-15-22",
    "owner1": "SANDBERG TR, SUSAN E",
    "owner2": "",
    "current_taxes": 5178.37,
    "new_taxes_no_override": 5402.08,
    "override_total_1": 5555.36,
    "override_increase_1": 153.28
  },
  {
    "#": "77 Pond Ave, Unit 611 P559&A (287-15-23)",
    "$": 594100,
    "address": "77 Pond Ave, Unit 611 P559&A",
    "parcel_id": "287-15-23",
    "owner1": "77 POND AVE UNIT 611 LLC",
    "owner2": "",
    "current_taxes": 6083.58,
    "new_taxes_no_override": 6346.39,
    "override_total_1": 6526.46,
    "override_increase_1": 180.07
  },
  {
    "#": "77 Pond Ave, Unit 612 (287-15-24)",
    "$": 397800,
    "address": "77 Pond Ave, Unit 612",
    "parcel_id": "287-15-24",
    "owner1": "IZIKSON, LEONID & MIKHAIL & IRINA",
    "owner2": "C/O IRINA IZIKSON",
    "current_taxes": 4073.47,
    "new_taxes_no_override": 4249.44,
    "override_total_1": 4370.02,
    "override_increase_1": 120.57
  },
  {
    "#": "77 Pond Ave, Unit 701 545A&B (287-15-25)",
    "$": 936200,
    "address": "77 Pond Ave, Unit 701 545A&B",
    "parcel_id": "287-15-25",
    "owner1": "BRAWLEY, RICHARD W & MARGARET M W",
    "owner2": "",
    "current_taxes": 5951.75,
    "new_taxes_no_override": 6208.87,
    "override_total_1": 6385.04,
    "override_increase_1": 176.17
  },
  {
    "#": "77 Pond Ave, Unit 702 & P513 (287-15-26)",
    "$": 861700,
    "address": "77 Pond Ave, Unit 702 & P513",
    "parcel_id": "287-15-26",
    "owner1": "RANA, MANDEEP",
    "owner2": "LAMBA, GURPRIT",
    "current_taxes": 8823.81,
    "new_taxes_no_override": 9205.0,
    "override_total_1": 9466.18,
    "override_increase_1": 261.18
  },
  {
    "#": "77 Pond Ave, Unit 703 & P639 (287-15-27)",
    "$": 506300,
    "address": "77 Pond Ave, Unit 703 & P639",
    "parcel_id": "287-15-27",
    "owner1": "HONG, HWI SHIN",
    "owner2": "YOUN-YOUNG, KATE",
    "current_taxes": 1549.58,
    "new_taxes_no_override": 1616.52,
    "override_total_1": 1662.39,
    "override_increase_1": 45.87
  },
  {
    "#": "77 Pond Ave, Unit 704 & P219 (287-15-28)",
    "$": 518200,
    "address": "77 Pond Ave, Unit 704 & P219",
    "parcel_id": "287-15-28",
    "owner1": "GAO, ZIYUE",
    "owner2": "",
    "current_taxes": 5306.37,
    "new_taxes_no_override": 5535.61,
    "override_total_1": 5692.67,
    "override_increase_1": 157.07
  },
  {
    "#": "77 Pond Ave, Unit 705&P483&A (287-15-29)",
    "$": 775900,
    "address": "77 Pond Ave, Unit 705&P483&A",
    "parcel_id": "287-15-29",
    "owner1": "PENG, HAIYING",
    "owner2": "ZHAO, JEAN J",
    "current_taxes": 7945.22,
    "new_taxes_no_override": 8288.45,
    "override_total_1": 8523.63,
    "override_increase_1": 235.18
  },
  {
    "#": "77 Pond Ave, Unit 706 & P631 (287-15-30)",
    "$": 761000,
    "address": "77 Pond Ave, Unit 706 & P631",
    "parcel_id": "287-15-30",
    "owner1": "HASHIMOTO, KUNIMATSU",
    "owner2": "",
    "current_taxes": 4157.71,
    "new_taxes_no_override": 4337.32,
    "override_total_1": 4460.39,
    "override_increase_1": 123.07
  },
  {
    "#": "77 Pond Ave, Unit 707 & P199 (287-15-31)",
    "$": 506300,
    "address": "77 Pond Ave, Unit 707 & P199",
    "parcel_id": "287-15-31",
    "owner1": "SINCLAIR TR, JODIE C",
    "owner2": "",
    "current_taxes": 1549.58,
    "new_taxes_no_override": 1616.52,
    "override_total_1": 1662.39,
    "override_increase_1": 45.87
  },
  {
    "#": "77 Pond Ave, Unit 708 & P656 (287-15-32)",
    "$": 479400,
    "address": "77 Pond Ave, Unit 708 & P656",
    "parcel_id": "287-15-32",
    "owner1": "LOO TR, BEE CHOO",
    "owner2": "",
    "current_taxes": 4909.06,
    "new_taxes_no_override": 5121.13,
    "override_total_1": 5266.44,
    "override_increase_1": 145.31
  },
  {
    "#": "77 Pond Ave, Unit 709 & P206 (287-15-33)",
    "$": 585900,
    "address": "77 Pond Ave, Unit 709 & P206",
    "parcel_id": "287-15-33",
    "owner1": "STILLER TR, JANE MARGERY",
    "owner2": "",
    "current_taxes": 2364.68,
    "new_taxes_no_override": 2466.83,
    "override_total_1": 2536.83,
    "override_increase_1": 69.99
  },
  {
    "#": "77 Pond Ave, Unit 710 & P468 (287-15-34)",
    "$": 505700,
    "address": "77 Pond Ave, Unit 710 & P468",
    "parcel_id": "287-15-34",
    "owner1": "DEYCHMAN, ALISA",
    "owner2": "",
    "current_taxes": 5178.37,
    "new_taxes_no_override": 5402.08,
    "override_total_1": 5555.36,
    "override_increase_1": 153.28
  },
  {
    "#": "77 Pond Ave, Unit 711 & P359 (287-15-35)",
    "$": 495400,
    "address": "77 Pond Ave, Unit 711 & P359",
    "parcel_id": "287-15-35",
    "owner1": "CHIKHANI, CATHERINE & TANIA",
    "owner2": "",
    "current_taxes": 5072.9,
    "new_taxes_no_override": 5292.05,
    "override_total_1": 5442.21,
    "override_increase_1": 150.16
  },
  {
    "#": "77 Pond Ave, Unit 712 (287-15-36)",
    "$": 413100,
    "address": "77 Pond Ave, Unit 712",
    "parcel_id": "287-15-36",
    "owner1": "MOSES TR, ZENA P",
    "owner2": "",
    "current_taxes": 595.21,
    "new_taxes_no_override": 620.92,
    "override_total_1": 638.54,
    "override_increase_1": 17.62
  },
  {
    "#": "77 Pond Ave, Unit 801 P348&A (287-15-37)",
    "$": 944100,
    "address": "77 Pond Ave, Unit 801 P348&A",
    "parcel_id": "287-15-37",
    "owner1": "SCHARBACK LIFE ESTATE, JAMES E",
    "owner2": "WEINER, GAIL",
    "current_taxes": 6032.65,
    "new_taxes_no_override": 6293.26,
    "override_total_1": 6471.83,
    "override_increase_1": 178.57
  },
  {
    "#": "77 Pond Ave, Unit 802 P479&A (287-15-38)",
    "$": 922400,
    "address": "77 Pond Ave, Unit 802 P479&A",
    "parcel_id": "287-15-38",
    "owner1": "SIRACUSA, ANA & MICHAEL",
    "owner2": "",
    "current_taxes": 9445.38,
    "new_taxes_no_override": 9853.42,
    "override_total_1": 10133.0,
    "override_increase_1": 279.58
  },
  {
    "#": "77 Pond Ave, Unit 803 (287-15-39)",
    "$": 519600,
    "address": "77 Pond Ave, Unit 803",
    "parcel_id": "287-15-39",
    "owner1": "GREENE, BERNARD",
    "owner2": "",
    "current_taxes": 1685.77,
    "new_taxes_no_override": 1758.6,
    "override_total_1": 1808.49,
    "override_increase_1": 49.9
  },
  {
    "#": "77 Pond Ave, Unit 804 & P512 (287-15-40)",
    "$": 521600,
    "address": "77 Pond Ave, Unit 804 & P512",
    "parcel_id": "287-15-40",
    "owner1": "HOU TRS, XINGCHUN",
    "owner2": "JIA, GANGYI",
    "current_taxes": 5341.18,
    "new_taxes_no_override": 5571.92,
    "override_total_1": 5730.02,
    "override_increase_1": 158.1
  },
  {
    "#": "77 Pond Ave, Unit 805 & P418 (287-15-41)",
    "$": 774300,
    "address": "77 Pond Ave, Unit 805 & P418",
    "parcel_id": "287-15-41",
    "owner1": "LI, SHITAO",
    "owner2": "WANG, LINGYAN",
    "current_taxes": 7928.83,
    "new_taxes_no_override": 8271.36,
    "override_total_1": 8506.05,
    "override_increase_1": 234.69
  },
  {
    "#": "77 Pond Ave, Unit 806 P538&A (287-15-42)",
    "$": 795900,
    "address": "77 Pond Ave, Unit 806 P538&A",
    "parcel_id": "287-15-42",
    "owner1": "IBSB DECORATION LLC",
    "owner2": "",
    "current_taxes": 8150.02,
    "new_taxes_no_override": 8502.1,
    "override_total_1": 8743.34,
    "override_increase_1": 241.24
  },
  {
    "#": "77 Pond Ave, Unit 807 & P673 (287-15-43)",
    "$": 506300,
    "address": "77 Pond Ave, Unit 807 & P673",
    "parcel_id": "287-15-43",
    "owner1": "PACSON TR, MARIO P",
    "owner2": "",
    "current_taxes": 5184.51,
    "new_taxes_no_override": 5408.48,
    "override_total_1": 5561.94,
    "override_increase_1": 153.46
  },
  {
    "#": "77 Pond Ave, Unit 808 & P642 (287-15-44)",
    "$": 469200,
    "address": "77 Pond Ave, Unit 808 & P642",
    "parcel_id": "287-15-44",
    "owner1": "ARCIPRETE TRS, JOHN M & JEANETTE",
    "owner2": "",
    "current_taxes": 4804.61,
    "new_taxes_no_override": 5012.17,
    "override_total_1": 5154.39,
    "override_increase_1": 142.22
  },
  {
    "#": "77 Pond Ave, Unit 809 & P510 (287-15-45)",
    "$": 506300,
    "address": "77 Pond Ave, Unit 809 & P510",
    "parcel_id": "287-15-45",
    "owner1": "GOLDEN, SHIRLEY H",
    "owner2": "",
    "current_taxes": 1549.58,
    "new_taxes_no_override": 1616.52,
    "override_total_1": 1662.39,
    "override_increase_1": 45.87
  },
  {
    "#": "77 Pond Ave, Unit 810 & P274 (287-15-46)",
    "$": 534200,
    "address": "77 Pond Ave, Unit 810 & P274",
    "parcel_id": "287-15-46",
    "owner1": "GERRATT, EMILY S",
    "owner2": "",
    "current_taxes": 1835.27,
    "new_taxes_no_override": 1914.55,
    "override_total_1": 1968.88,
    "override_increase_1": 54.32
  },
  {
    "#": "77 Pond Ave, Unit 811 & P462 (287-15-47)",
    "$": 495400,
    "address": "77 Pond Ave, Unit 811 & P462",
    "parcel_id": "287-15-47",
    "owner1": "CHANG TRS, TEWEN & JANET",
    "owner2": "",
    "current_taxes": 5072.9,
    "new_taxes_no_override": 5292.05,
    "override_total_1": 5442.21,
    "override_increase_1": 150.16
  },
  {
    "#": "77 Pond Ave, Unit 812 & P506 (287-15-48)",
    "$": 504500,
    "address": "77 Pond Ave, Unit 812 & P506",
    "parcel_id": "287-15-48",
    "owner1": "LUO, ZHIHAO",
    "owner2": "",
    "current_taxes": 5166.08,
    "new_taxes_no_override": 5389.25,
    "override_total_1": 5542.17,
    "override_increase_1": 152.92
  },
  {
    "#": "77 Pond Ave, Unit 901 P543&A (287-15-49)",
    "$": 864900,
    "address": "77 Pond Ave, Unit 901 P543&A",
    "parcel_id": "287-15-49",
    "owner1": "ETKIN TR, ISABEL",
    "owner2": "",
    "current_taxes": 8856.58,
    "new_taxes_no_override": 9239.18,
    "override_total_1": 9501.34,
    "override_increase_1": 262.15
  },
  {
    "#": "77 Pond Ave, Unit 902 P554&A (287-15-50)",
    "$": 958000,
    "address": "77 Pond Ave, Unit 902 P554&A",
    "parcel_id": "287-15-50",
    "owner1": "YU, SHENG HSIUNG & CHANG O",
    "owner2": "",
    "current_taxes": 9809.92,
    "new_taxes_no_override": 10233.71,
    "override_total_1": 10524.08,
    "override_increase_1": 290.37
  },
  {
    "#": "77 Pond Ave, Unit 903 & P505 (287-15-51)",
    "$": 591400,
    "address": "77 Pond Ave, Unit 903 & P505",
    "parcel_id": "287-15-51",
    "owner1": "SAKOULAS, GEORGE",
    "owner2": "",
    "current_taxes": 6055.94,
    "new_taxes_no_override": 6317.56,
    "override_total_1": 6496.81,
    "override_increase_1": 179.26
  },
  {
    "#": "77 Pond Ave, Unit 904 & P249 (287-15-52)",
    "$": 577800,
    "address": "77 Pond Ave, Unit 904 & P249",
    "parcel_id": "287-15-52",
    "owner1": "ROWLES TRS, KYLE J & XIAOYAN T",
    "owner2": "",
    "current_taxes": 5916.67,
    "new_taxes_no_override": 6172.27,
    "override_total_1": 6347.4,
    "override_increase_1": 175.13
  },
  {
    "#": "77 Pond Ave, Unit 905 & P549 (287-15-53)",
    "$": 774400,
    "address": "77 Pond Ave, Unit 905 & P549",
    "parcel_id": "287-15-53",
    "owner1": "OHYAMA TR, HIROE  BABA",
    "owner2": "",
    "current_taxes": 4294.92,
    "new_taxes_no_override": 4480.46,
    "override_total_1": 4607.59,
    "override_increase_1": 127.13
  },
  {
    "#": "77 Pond Ave, Unit 906 P531&A (287-15-54)",
    "$": 697500,
    "address": "77 Pond Ave, Unit 906 P531&A",
    "parcel_id": "287-15-54",
    "owner1": "KAO, VERONICA T",
    "owner2": "CHEN, YAHUA J",
    "current_taxes": 7142.4,
    "new_taxes_no_override": 7450.95,
    "override_total_1": 7662.37,
    "override_increase_1": 211.42
  },
  {
    "#": "77 Pond Ave, Unit 907 & P414 (287-15-55)",
    "$": 591400,
    "address": "77 Pond Ave, Unit 907 & P414",
    "parcel_id": "287-15-55",
    "owner1": "FINE TRS, LEONARD B",
    "owner2": "",
    "current_taxes": 2421.0,
    "new_taxes_no_override": 2525.59,
    "override_total_1": 2597.25,
    "override_increase_1": 71.66
  },
  {
    "#": "77 Pond Ave, Unit 908 & P238 (287-15-56)",
    "$": 479400,
    "address": "77 Pond Ave, Unit 908 & P238",
    "parcel_id": "287-15-56",
    "owner1": "CHUN, HYONHO",
    "owner2": "",
    "current_taxes": 4909.06,
    "new_taxes_no_override": 5121.13,
    "override_total_1": 5266.44,
    "override_increase_1": 145.31
  },
  {
    "#": "77 Pond Ave, Unit 909 & P608 (287-15-57)",
    "$": 506300,
    "address": "77 Pond Ave, Unit 909 & P608",
    "parcel_id": "287-15-57",
    "owner1": "KRAM HOLDING LLC",
    "owner2": "",
    "current_taxes": 5184.51,
    "new_taxes_no_override": 5408.48,
    "override_total_1": 5561.94,
    "override_increase_1": 153.46
  },
  {
    "#": "77 Pond Ave, Unit 910 & P493 (287-15-58)",
    "$": 503300,
    "address": "77 Pond Ave, Unit 910 & P493",
    "parcel_id": "287-15-58",
    "owner1": "LIU, LENA ZAIQING",
    "owner2": "",
    "current_taxes": 1518.86,
    "new_taxes_no_override": 1584.47,
    "override_total_1": 1629.43,
    "override_increase_1": 44.96
  },
  {
    "#": "77 Pond Ave, Unit 911 & P570 (287-15-59)",
    "$": 507300,
    "address": "77 Pond Ave, Unit 911 & P570",
    "parcel_id": "287-15-59",
    "owner1": "HU, AIHUA",
    "owner2": "HAO, YINGSONG",
    "current_taxes": 1559.82,
    "new_taxes_no_override": 1627.2,
    "override_total_1": 1673.37,
    "override_increase_1": 46.17
  },
  {
    "#": "77 Pond Ave, Unit 912 & P428 (287-15-60)",
    "$": 448800,
    "address": "77 Pond Ave, Unit 912 & P428",
    "parcel_id": "287-15-60",
    "owner1": "CHANDRA, ROHIT",
    "owner2": "",
    "current_taxes": 960.78,
    "new_taxes_no_override": 1002.29,
    "override_total_1": 1030.72,
    "override_increase_1": 28.44
  },
  {
    "#": "77 Pond Ave, Unit Nr-1 478&A (287-14-69)",
    "$": 1103500,
    "address": "77 Pond Ave, Unit Nr-1 478&A",
    "parcel_id": "287-14-69",
    "owner1": "GHOREISHI, JAVAD S",
    "owner2": "",
    "current_taxes": 18936.06,
    "new_taxes_no_override": 19754.1,
    "override_total_1": 20314.61,
    "override_increase_1": 560.51
  },
  {
    "#": "77 Pond Ave, Unit Nr-2 P668 (287-14-70)",
    "$": 526200,
    "address": "77 Pond Ave, Unit Nr-2 P668",
    "parcel_id": "287-14-70",
    "owner1": "GAO, HONG",
    "owner2": "ZHU, ZHENGLUN",
    "current_taxes": 9029.59,
    "new_taxes_no_override": 9419.67,
    "override_total_1": 9686.94,
    "override_increase_1": 267.28
  },
  {
    "#": "77 Pond Ave, Unit Nr-3 (287-14-71)",
    "$": 1605900,
    "address": "77 Pond Ave, Unit Nr-3",
    "parcel_id": "287-14-71",
    "owner1": "RABDB LLC",
    "owner2": "C/O BARTLETT DOROTHY",
    "current_taxes": 27557.24,
    "new_taxes_no_override": 28747.71,
    "override_total_1": 29563.41,
    "override_increase_1": 815.69
  },
  {
    "#": "77 Pond Ave, Unit Nr-4 (287-14-72)",
    "$": 762500,
    "address": "77 Pond Ave, Unit Nr-4",
    "parcel_id": "287-14-72",
    "owner1": "ATLANTIC BROOKHOUSE REALTY LLC",
    "owner2": "",
    "current_taxes": 13084.5,
    "new_taxes_no_override": 13649.75,
    "override_total_1": 14037.05,
    "override_increase_1": 387.3
  },
  {
    "#": "77 Pond Ave, Unit Nr-5 (287-17-75)",
    "$": 785000,
    "address": "77 Pond Ave, Unit Nr-5",
    "parcel_id": "287-17-75",
    "owner1": "ATLANTIC BROOKHOUSE REALTY LLC",
    "owner2": "",
    "current_taxes": 13470.6,
    "new_taxes_no_override": 14052.53,
    "override_total_1": 14451.26,
    "override_increase_1": 398.73
  },
  {
    "#": "77 Pond Ave, Unit P 529-529A (287-17-91)",
    "$": 90000,
    "address": "77 Pond Ave, Unit P 529-529A",
    "parcel_id": "287-17-91",
    "owner1": "BROOK HOUSE CONDOMINIUM TRUST",
    "owner2": "C/O  DEPT 696 - THAYER & ASSOC.",
    "current_taxes": 921.6,
    "new_taxes_no_override": 961.41,
    "override_total_1": 988.69,
    "override_increase_1": 27.28
  },
  {
    "#": "77 Pond Ave, Unit P475 (287-18-52)",
    "$": 60000,
    "address": "77 Pond Ave, Unit P475",
    "parcel_id": "287-18-52",
    "owner1": "MOSES TR, ZENA P",
    "owner2": "",
    "current_taxes": 614.4,
    "new_taxes_no_override": 640.94,
    "override_total_1": 659.13,
    "override_increase_1": 18.19
  },
  {
    "#": "77 Pond Ave, Unit P518-518A (287-18-72)",
    "$": 90000,
    "address": "77 Pond Ave, Unit P518-518A",
    "parcel_id": "287-18-72",
    "owner1": "JAC ACQUISITIONS POND LLC",
    "owner2": "",
    "current_taxes": 921.6,
    "new_taxes_no_override": 961.41,
    "override_total_1": 988.69,
    "override_increase_1": 27.28
  },
  {
    "#": "99 Pond Ave, Unit 117 P488X (287-16-18)",
    "$": 889800,
    "address": "99 Pond Ave, Unit 117 P488X",
    "parcel_id": "287-16-18",
    "owner1": "MANDEL, WENDY A",
    "owner2": "",
    "current_taxes": 5476.62,
    "new_taxes_no_override": 5713.21,
    "override_total_1": 5875.32,
    "override_increase_1": 162.11
  },
  {
    "#": "99 Pond Ave, Unit 119 & P599 (287-16-19)",
    "$": 783300,
    "address": "99 Pond Ave, Unit 119 & P599",
    "parcel_id": "287-16-19",
    "owner1": "JIANG TR, HUAN HUAN",
    "owner2": "",
    "current_taxes": 8020.99,
    "new_taxes_no_override": 8367.5,
    "override_total_1": 8604.92,
    "override_increase_1": 237.42
  },
  {
    "#": "99 Pond Ave, Unit 121 & P432 (287-16-20)",
    "$": 786800,
    "address": "99 Pond Ave, Unit 121 & P432",
    "parcel_id": "287-16-20",
    "owner1": "CHALYKOFF, JOHN B & GERALDINE M",
    "owner2": "",
    "current_taxes": 4421.9,
    "new_taxes_no_override": 4612.93,
    "override_total_1": 4743.81,
    "override_increase_1": 130.89
  },
  {
    "#": "99 Pond Ave, Unit 123 & P535 (287-16-21)",
    "$": 433300,
    "address": "99 Pond Ave, Unit 123 & P535",
    "parcel_id": "287-16-21",
    "owner1": "WELLS TRS, JOHN H & SHARON MORIAH",
    "owner2": "",
    "current_taxes": 4436.99,
    "new_taxes_no_override": 4628.67,
    "override_total_1": 4760.0,
    "override_increase_1": 131.33
  },
  {
    "#": "99 Pond Ave, Unit 200 & P645 (287-16-22)",
    "$": 516600,
    "address": "99 Pond Ave, Unit 200 & P645",
    "parcel_id": "287-16-22",
    "owner1": "QI, JANET",
    "owner2": "",
    "current_taxes": 1655.05,
    "new_taxes_no_override": 1726.55,
    "override_total_1": 1775.54,
    "override_increase_1": 48.99
  },
  {
    "#": "99 Pond Ave, Unit 201 & P677 (287-16-23)",
    "$": 601600,
    "address": "99 Pond Ave, Unit 201 & P677",
    "parcel_id": "287-16-23",
    "owner1": "RANA, MANDEEP",
    "owner2": "LAMBS, GURPRIT SINGH",
    "current_taxes": 6160.38,
    "new_taxes_no_override": 6426.51,
    "override_total_1": 6608.86,
    "override_increase_1": 182.35
  },
  {
    "#": "99 Pond Ave, Unit 202 & P259 (287-16-24)",
    "$": 524700,
    "address": "99 Pond Ave, Unit 202 & P259",
    "parcel_id": "287-16-24",
    "owner1": "KENIA, CHHAYA & DHIREN & ROSHAN",
    "owner2": "",
    "current_taxes": 1737.99,
    "new_taxes_no_override": 1813.07,
    "override_total_1": 1864.52,
    "override_increase_1": 51.44
  },
  {
    "#": "99 Pond Ave, Unit 203 (287-16-25)",
    "$": 458400,
    "address": "99 Pond Ave, Unit 203",
    "parcel_id": "287-16-25",
    "owner1": "AGRESAR, ANMIR",
    "owner2": "",
    "current_taxes": 1059.08,
    "new_taxes_no_override": 1104.83,
    "override_total_1": 1136.18,
    "override_increase_1": 31.35
  },
  {
    "#": "99 Pond Ave, Unit 204 & P415 (287-16-26)",
    "$": 524700,
    "address": "99 Pond Ave, Unit 204 & P415",
    "parcel_id": "287-16-26",
    "owner1": "BROOK HOUSE REALTY LLC",
    "owner2": "",
    "current_taxes": 5372.93,
    "new_taxes_no_override": 5605.04,
    "override_total_1": 5764.08,
    "override_increase_1": 159.04
  },
  {
    "#": "99 Pond Ave, Unit 205 & P585 (287-16-27)",
    "$": 775200,
    "address": "99 Pond Ave, Unit 205 & P585",
    "parcel_id": "287-16-27",
    "owner1": "CHOPRA TR, OM",
    "owner2": "",
    "current_taxes": 7938.05,
    "new_taxes_no_override": 8280.97,
    "override_total_1": 8515.94,
    "override_increase_1": 234.97
  },
  {
    "#": "99 Pond Ave, Unit 208 & P305 (287-16-28)",
    "$": 509300,
    "address": "99 Pond Ave, Unit 208 & P305",
    "parcel_id": "287-16-28",
    "owner1": "BORGES, AMANDA",
    "owner2": "GEARY, MICHAEL",
    "current_taxes": 5215.23,
    "new_taxes_no_override": 5440.53,
    "override_total_1": 5594.9,
    "override_increase_1": 154.37
  },
  {
    "#": "99 Pond Ave, Unit 211 & P489 (287-16-29)",
    "$": 541400,
    "address": "99 Pond Ave, Unit 211 & P489",
    "parcel_id": "287-16-29",
    "owner1": "BAENS, CRISTINA",
    "owner2": "",
    "current_taxes": 1909.0,
    "new_taxes_no_override": 1991.47,
    "override_total_1": 2047.98,
    "override_increase_1": 56.51
  },
  {
    "#": "99 Pond Ave, Unit 212 & P322 (287-16-30)",
    "$": 654800,
    "address": "99 Pond Ave, Unit 212 & P322",
    "parcel_id": "287-16-30",
    "owner1": "MANNING, CATHERINE T",
    "owner2": "",
    "current_taxes": 3070.22,
    "new_taxes_no_override": 3202.85,
    "override_total_1": 3293.73,
    "override_increase_1": 90.88
  },
  {
    "#": "99 Pond Ave, Unit 213 (287-16-31)",
    "$": 458400,
    "address": "99 Pond Ave, Unit 213",
    "parcel_id": "287-16-31",
    "owner1": "RAMOS, EVELYN",
    "owner2": "RIVERA, THERESSE R",
    "current_taxes": 4694.02,
    "new_taxes_no_override": 4896.8,
    "override_total_1": 5035.74,
    "override_increase_1": 138.94
  },
  {
    "#": "99 Pond Ave, Unit 214 & P577 (287-16-32)",
    "$": 534900,
    "address": "99 Pond Ave, Unit 214 & P577",
    "parcel_id": "287-16-32",
    "owner1": "TEAM LT LLC",
    "owner2": "",
    "current_taxes": 5477.38,
    "new_taxes_no_override": 5714.0,
    "override_total_1": 5876.13,
    "override_increase_1": 162.13
  },
  {
    "#": "99 Pond Ave, Unit 215& P588B (287-16-33)",
    "$": 529500,
    "address": "99 Pond Ave, Unit 215& P588B",
    "parcel_id": "287-16-33",
    "owner1": "LEARY, LINDA L",
    "owner2": "",
    "current_taxes": 5422.08,
    "new_taxes_no_override": 5656.31,
    "override_total_1": 5816.81,
    "override_increase_1": 160.49
  },
  {
    "#": "99 Pond Ave, Unit 216 P314&A (287-16-34)",
    "$": 936800,
    "address": "99 Pond Ave, Unit 216 P314&A",
    "parcel_id": "287-16-34",
    "owner1": "AL-NAIB, MAY",
    "owner2": "",
    "current_taxes": 5957.9,
    "new_taxes_no_override": 6215.28,
    "override_total_1": 6391.64,
    "override_increase_1": 176.35
  },
  {
    "#": "99 Pond Ave, Unit 217 P485&A (287-16-35)",
    "$": 873800,
    "address": "99 Pond Ave, Unit 217 P485&A",
    "parcel_id": "287-16-35",
    "owner1": "WANG TR, Y",
    "owner2": "",
    "current_taxes": 5312.78,
    "new_taxes_no_override": 5542.29,
    "override_total_1": 5699.55,
    "override_increase_1": 157.26
  },
  {
    "#": "99 Pond Ave, Unit 218 & P364 (287-16-36)",
    "$": 733000,
    "address": "99 Pond Ave, Unit 218 & P364",
    "parcel_id": "287-16-36",
    "owner1": "JAROSZ, WILLIAM R",
    "owner2": "KARLIN, DENISE J",
    "current_taxes": 3870.99,
    "new_taxes_no_override": 4038.22,
    "override_total_1": 4152.8,
    "override_increase_1": 114.58
  },
  {
    "#": "99 Pond Ave, Unit 219 P496&A (287-16-37)",
    "$": 752700,
    "address": "99 Pond Ave, Unit 219 P496&A",
    "parcel_id": "287-16-37",
    "owner1": "DAVID, EBENEZER",
    "owner2": "STEPHEN, MEKHALA",
    "current_taxes": 7707.65,
    "new_taxes_no_override": 8040.62,
    "override_total_1": 8268.77,
    "override_increase_1": 228.15
  },
  {
    "#": "99 Pond Ave, Unit 220 & P198 (287-16-38)",
    "$": 765900,
    "address": "99 Pond Ave, Unit 220 & P198",
    "parcel_id": "287-16-38",
    "owner1": "NKIAYA, DOUDOU DHALLIA LITANGA",
    "owner2": "KOLONGELE, CAELIA EBERANDE",
    "current_taxes": 7842.82,
    "new_taxes_no_override": 8181.63,
    "override_total_1": 8413.78,
    "override_increase_1": 232.15
  },
  {
    "#": "99 Pond Ave, Unit 221 & P369 (287-16-39)",
    "$": 733000,
    "address": "99 Pond Ave, Unit 221 & P369",
    "parcel_id": "287-16-39",
    "owner1": "MOMTAZ TR, PARVANEH",
    "owner2": "",
    "current_taxes": 7505.92,
    "new_taxes_no_override": 7830.18,
    "override_total_1": 8052.35,
    "override_increase_1": 222.18
  },
  {
    "#": "99 Pond Ave, Unit 222 P316&A (287-16-40)",
    "$": 756300,
    "address": "99 Pond Ave, Unit 222 P316&A",
    "parcel_id": "287-16-40",
    "owner1": "GARDNER BROOK CONDOS LLC",
    "owner2": "",
    "current_taxes": 7744.51,
    "new_taxes_no_override": 8079.07,
    "override_total_1": 8308.31,
    "override_increase_1": 229.24
  },
  {
    "#": "99 Pond Ave, Unit 223 & P429 (287-16-41)",
    "$": 916700,
    "address": "99 Pond Ave, Unit 223 & P429",
    "parcel_id": "287-16-41",
    "owner1": "GANDRE TRS, ROBERT W & DEBORAH F",
    "owner2": "",
    "current_taxes": 5752.07,
    "new_taxes_no_override": 6000.56,
    "override_total_1": 6170.82,
    "override_increase_1": 170.26
  },
  {
    "#": "99 Pond Ave, Unit 224 & P404 (287-16-42)",
    "$": 584900,
    "address": "99 Pond Ave, Unit 224 & P404",
    "parcel_id": "287-16-42",
    "owner1": "ZHOU, YOU",
    "owner2": "",
    "current_taxes": 5989.38,
    "new_taxes_no_override": 6248.12,
    "override_total_1": 6425.41,
    "override_increase_1": 177.29
  },
  {
    "#": "99 Pond Ave, Unit 300 & P643 (287-16-43)",
    "$": 509400,
    "address": "99 Pond Ave, Unit 300 & P643",
    "parcel_id": "287-16-43",
    "owner1": "SOCHRIN, LARRY R",
    "owner2": "",
    "current_taxes": 1581.32,
    "new_taxes_no_override": 1649.63,
    "override_total_1": 1696.44,
    "override_increase_1": 46.81
  },
  {
    "#": "99 Pond Ave, Unit 301 P480&A (287-16-44)",
    "$": 658700,
    "address": "99 Pond Ave, Unit 301 P480&A",
    "parcel_id": "287-16-44",
    "owner1": "LAPPIN, ANDREW & MAKIKO",
    "owner2": "",
    "current_taxes": 6745.09,
    "new_taxes_no_override": 7036.48,
    "override_total_1": 7236.13,
    "override_increase_1": 199.65
  },
  {
    "#": "99 Pond Ave, Unit 302 & P644 (287-16-45)",
    "$": 516600,
    "address": "99 Pond Ave, Unit 302 & P644",
    "parcel_id": "287-16-45",
    "owner1": "FLOSS, PATRICIA G",
    "owner2": "",
    "current_taxes": 1655.05,
    "new_taxes_no_override": 1726.55,
    "override_total_1": 1775.54,
    "override_increase_1": 48.99
  },
  {
    "#": "99 Pond Ave, Unit 303 & P621 (287-16-46)",
    "$": 514200,
    "address": "99 Pond Ave, Unit 303 & P621",
    "parcel_id": "287-16-46",
    "owner1": "KAPTSAN, YANIV",
    "owner2": "",
    "current_taxes": 5265.41,
    "new_taxes_no_override": 5492.88,
    "override_total_1": 5648.73,
    "override_increase_1": 155.86
  },
  {
    "#": "99 Pond Ave, Unit 304 & P470 (287-16-47)",
    "$": 509400,
    "address": "99 Pond Ave, Unit 304 & P470",
    "parcel_id": "287-16-47",
    "owner1": "LIU, JIAYUN",
    "owner2": "ZHANG, XIAOLING",
    "current_taxes": 1581.32,
    "new_taxes_no_override": 1649.63,
    "override_total_1": 1696.44,
    "override_increase_1": 46.81
  },
  {
    "#": "99 Pond Ave, Unit 305 & P268 (287-16-48)",
    "$": 733000,
    "address": "99 Pond Ave, Unit 305 & P268",
    "parcel_id": "287-16-48",
    "owner1": "PICARDO, NICHOLAS",
    "owner2": "HUANG, JULIE",
    "current_taxes": 3870.99,
    "new_taxes_no_override": 4038.22,
    "override_total_1": 4152.8,
    "override_increase_1": 114.58
  },
  {
    "#": "99 Pond Ave, Unit 306 & P435 (287-16-49)",
    "$": 542000,
    "address": "99 Pond Ave, Unit 306 & P435",
    "parcel_id": "287-16-49",
    "owner1": "KIM, SUNGHAE GRACE",
    "owner2": "",
    "current_taxes": 5550.08,
    "new_taxes_no_override": 5789.84,
    "override_total_1": 5954.13,
    "override_increase_1": 164.28
  },
  {
    "#": "99 Pond Ave, Unit 307 & P407 (287-16-50)",
    "$": 509400,
    "address": "99 Pond Ave, Unit 307 & P407",
    "parcel_id": "287-16-50",
    "owner1": "STEFANOV WAGNER, THADDEUS J",
    "owner2": "XIANG, MICHAEL H",
    "current_taxes": 5216.26,
    "new_taxes_no_override": 5441.6,
    "override_total_1": 5596.0,
    "override_increase_1": 154.4
  },
  {
    "#": "99 Pond Ave, Unit 308 & P437 (287-16-51)",
    "$": 483800,
    "address": "99 Pond Ave, Unit 308 & P437",
    "parcel_id": "287-16-51",
    "owner1": "LAM TRS, SIU KAI RAYMOND",
    "owner2": "WU, LILY HUILING",
    "current_taxes": 4954.11,
    "new_taxes_no_override": 5168.13,
    "override_total_1": 5314.77,
    "override_increase_1": 146.64
  },
  {
    "#": "99 Pond Ave, Unit 309 (287-16-52)",
    "$": 531300,
    "address": "99 Pond Ave, Unit 309",
    "parcel_id": "287-16-52",
    "owner1": "HATTORI, MIKIYO",
    "owner2": "",
    "current_taxes": 1805.58,
    "new_taxes_no_override": 1883.58,
    "override_total_1": 1937.03,
    "override_increase_1": 53.45
  },
  {
    "#": "99 Pond Ave, Unit 310 P574&A (287-16-53)",
    "$": 545100,
    "address": "99 Pond Ave, Unit 310 P574&A",
    "parcel_id": "287-16-53",
    "owner1": "PACSON TR, MICHAEL ALBERT",
    "owner2": "",
    "current_taxes": 5581.82,
    "new_taxes_no_override": 5822.95,
    "override_total_1": 5988.18,
    "override_increase_1": 165.22
  },
  {
    "#": "99 Pond Ave, Unit 311 & P230 (287-16-54)",
    "$": 521300,
    "address": "99 Pond Ave, Unit 311 & P230",
    "parcel_id": "287-16-54",
    "owner1": "LEUNG, CHEUK LUN",
    "owner2": "",
    "current_taxes": 1703.18,
    "new_taxes_no_override": 1776.76,
    "override_total_1": 1827.17,
    "override_increase_1": 50.41
  },
  {
    "#": "99 Pond Ave, Unit 312 (287-16-55)",
    "$": 458400,
    "address": "99 Pond Ave, Unit 312",
    "parcel_id": "287-16-55",
    "owner1": "SALKOVITZ, MARNIE",
    "owner2": "",
    "current_taxes": 1059.08,
    "new_taxes_no_override": 1104.83,
    "override_total_1": 1136.18,
    "override_increase_1": 31.35
  },
  {
    "#": "99 Pond Ave, Unit 313 & P590 (287-16-56)",
    "$": 581300,
    "address": "99 Pond Ave, Unit 313 & P590",
    "parcel_id": "287-16-56",
    "owner1": "PORTNOF TR, PAUL",
    "owner2": "KRINSKY, MARK",
    "current_taxes": 5952.51,
    "new_taxes_no_override": 6209.66,
    "override_total_1": 6385.85,
    "override_increase_1": 176.19
  },
  {
    "#": "99 Pond Ave, Unit 314 & P615 (287-16-57)",
    "$": 581300,
    "address": "99 Pond Ave, Unit 314 & P615",
    "parcel_id": "287-16-57",
    "owner1": "PARKOFF, CARA",
    "owner2": "",
    "current_taxes": 2317.58,
    "new_taxes_no_override": 2417.7,
    "override_total_1": 2486.3,
    "override_increase_1": 68.6
  },
  {
    "#": "99 Pond Ave, Unit 315 (287-16-58)",
    "$": 536700,
    "address": "99 Pond Ave, Unit 315",
    "parcel_id": "287-16-58",
    "owner1": "WEINER, JAY M",
    "owner2": "",
    "current_taxes": 5495.81,
    "new_taxes_no_override": 5733.23,
    "override_total_1": 5895.9,
    "override_increase_1": 162.68
  },
  {
    "#": "99 Pond Ave, Unit 316 P383&A (287-16-59)",
    "$": 904800,
    "address": "99 Pond Ave, Unit 316 P383&A",
    "parcel_id": "287-16-59",
    "owner1": "BAYNE, JODI A",
    "owner2": "",
    "current_taxes": 5630.22,
    "new_taxes_no_override": 5873.45,
    "override_total_1": 6040.1,
    "override_increase_1": 166.65
  },
  {
    "#": "99 Pond Ave, Unit 317 P346&A (287-16-60)",
    "$": 881900,
    "address": "99 Pond Ave, Unit 317 P346&A",
    "parcel_id": "287-16-60",
    "owner1": "YI, XIAXIA & SHASHA",
    "owner2": "",
    "current_taxes": 9030.66,
    "new_taxes_no_override": 9420.78,
    "override_total_1": 9688.09,
    "override_increase_1": 267.31
  },
  {
    "#": "99 Pond Ave, Unit 318 (287-16-61)",
    "$": 728600,
    "address": "99 Pond Ave, Unit 318",
    "parcel_id": "287-16-61",
    "owner1": "WERMER TR, MARGARET",
    "owner2": "",
    "current_taxes": 7460.86,
    "new_taxes_no_override": 7783.17,
    "override_total_1": 8004.01,
    "override_increase_1": 220.84
  },
  {
    "#": "99 Pond Ave, Unit 319 (287-16-62)",
    "$": 725100,
    "address": "99 Pond Ave, Unit 319",
    "parcel_id": "287-16-62",
    "owner1": "ZHANG, FENGSHAN",
    "owner2": "SONG, QINGHUA & AILIN",
    "current_taxes": 7425.02,
    "new_taxes_no_override": 7745.78,
    "override_total_1": 7965.56,
    "override_increase_1": 219.78
  },
  {
    "#": "99 Pond Ave, Unit 320 P484&A (287-16-63)",
    "$": 810100,
    "address": "99 Pond Ave, Unit 320 P484&A",
    "parcel_id": "287-16-63",
    "owner1": "JHAVERI SCHNEIDER, SONAL",
    "owner2": "",
    "current_taxes": 8295.42,
    "new_taxes_no_override": 8653.78,
    "override_total_1": 8899.33,
    "override_increase_1": 245.54
  },
  {
    "#": "99 Pond Ave, Unit 321 P560&A (287-16-64)",
    "$": 788300,
    "address": "99 Pond Ave, Unit 321 P560&A",
    "parcel_id": "287-16-64",
    "owner1": "WEINSTOCK, JEFFREY",
    "owner2": "",
    "current_taxes": 4437.26,
    "new_taxes_no_override": 4628.95,
    "override_total_1": 4760.29,
    "override_increase_1": 131.34
  },
  {
    "#": "99 Pond Ave, Unit 322 & P400 (287-16-65)",
    "$": 765000,
    "address": "99 Pond Ave, Unit 322 & P400",
    "parcel_id": "287-16-65",
    "owner1": "ALINSKY TRS, JOANNE GAIL LINOWES & LEE DAVID",
    "owner2": "",
    "current_taxes": 7833.6,
    "new_taxes_no_override": 8172.01,
    "override_total_1": 8403.89,
    "override_increase_1": 231.87
  },
  {
    "#": "99 Pond Ave, Unit 323 P500&A (287-16-66)",
    "$": 993900,
    "address": "99 Pond Ave, Unit 323 P500&A",
    "parcel_id": "287-16-66",
    "owner1": "ROSEN TRS, DIANE L",
    "owner2": "WEINTRAUB, MICHAEL S",
    "current_taxes": 6542.6,
    "new_taxes_no_override": 6825.24,
    "override_total_1": 7018.9,
    "override_increase_1": 193.66
  },
  {
    "#": "99 Pond Ave, Unit 324 (287-16-67)",
    "$": 461500,
    "address": "99 Pond Ave, Unit 324",
    "parcel_id": "287-16-67",
    "owner1": "HOU, GUAN REN",
    "owner2": "ZHENG, CHEN JUAN",
    "current_taxes": 4725.76,
    "new_taxes_no_override": 4929.91,
    "override_total_1": 5069.8,
    "override_increase_1": 139.88
  },
  {
    "#": "99 Pond Ave, Unit 325 P541&A (287-16-68)",
    "$": 780300,
    "address": "99 Pond Ave, Unit 325 P541&A",
    "parcel_id": "287-16-68",
    "owner1": "ZHANG, GUOQI",
    "owner2": "CHEN, YUYING",
    "current_taxes": 7990.27,
    "new_taxes_no_override": 8335.45,
    "override_total_1": 8571.96,
    "override_increase_1": 236.51
  },
  {
    "#": "99 Pond Ave, Unit 326&Pc476 (287-16-69)",
    "$": 509400,
    "address": "99 Pond Ave, Unit 326&Pc476",
    "parcel_id": "287-16-69",
    "owner1": "ZAKIN TRS, MICHAEL E",
    "owner2": "GOLDBERG, DORI",
    "current_taxes": 5216.26,
    "new_taxes_no_override": 5441.6,
    "override_total_1": 5596.0,
    "override_increase_1": 154.4
  },
  {
    "#": "99 Pond Ave, Unit 400 & P240 (287-16-70)",
    "$": 509400,
    "address": "99 Pond Ave, Unit 400 & P240",
    "parcel_id": "287-16-70",
    "owner1": "LI, XIANG",
    "owner2": "ZHANG, JING",
    "current_taxes": 5216.26,
    "new_taxes_no_override": 5441.6,
    "override_total_1": 5596.0,
    "override_increase_1": 154.4
  },
  {
    "#": "99 Pond Ave, Unit 401 P311&A (287-16-71)",
    "$": 554700,
    "address": "99 Pond Ave, Unit 401 P311&A",
    "parcel_id": "287-16-71",
    "owner1": "BERGEL TR, ERNEST W",
    "owner2": "",
    "current_taxes": 2045.19,
    "new_taxes_no_override": 2133.54,
    "override_total_1": 2194.08,
    "override_increase_1": 60.54
  },
  {
    "#": "99 Pond Ave, Unit 402 (287-16-72)",
    "$": 470300,
    "address": "99 Pond Ave, Unit 402",
    "parcel_id": "287-16-72",
    "owner1": "ALFORD, MELISSA A",
    "owner2": "",
    "current_taxes": 1180.94,
    "new_taxes_no_override": 1231.96,
    "override_total_1": 1266.91,
    "override_increase_1": 34.96
  },
  {
    "#": "99 Pond Ave, Unit 403 &Pc487 (287-16-73)",
    "$": 509400,
    "address": "99 Pond Ave, Unit 403 &Pc487",
    "parcel_id": "287-16-73",
    "owner1": "MA, WEN HUI",
    "owner2": "",
    "current_taxes": 5216.26,
    "new_taxes_no_override": 5441.6,
    "override_total_1": 5596.0,
    "override_increase_1": 154.4
  },
  {
    "#": "99 Pond Ave, Unit 404 (287-16-74)",
    "$": 536700,
    "address": "99 Pond Ave, Unit 404",
    "parcel_id": "287-16-74",
    "owner1": "KIM, OLIVIA",
    "owner2": "",
    "current_taxes": 5495.81,
    "new_taxes_no_override": 5733.23,
    "override_total_1": 5895.9,
    "override_increase_1": 162.68
  },
  {
    "#": "99 Pond Ave, Unit 405 & P266 (287-16-75)",
    "$": 733000,
    "address": "99 Pond Ave, Unit 405 & P266",
    "parcel_id": "287-16-75",
    "owner1": "PHILLIPS, COLLETTE A M",
    "owner2": "",
    "current_taxes": 3870.99,
    "new_taxes_no_override": 4038.22,
    "override_total_1": 4152.8,
    "override_increase_1": 114.58
  },
  {
    "#": "99 Pond Ave, Unit 406 & P427 (287-16-76)",
    "$": 664600,
    "address": "99 Pond Ave, Unit 406 & P427",
    "parcel_id": "287-16-76",
    "owner1": "OBARA, KAYOKO",
    "owner2": "",
    "current_taxes": 3170.57,
    "new_taxes_no_override": 3307.54,
    "override_total_1": 3401.39,
    "override_increase_1": 93.85
  },
  {
    "#": "99 Pond Ave, Unit 407 & P682 (287-16-77)",
    "$": 509400,
    "address": "99 Pond Ave, Unit 407 & P682",
    "parcel_id": "287-16-77",
    "owner1": "NGUYEN, MY ANH",
    "owner2": "",
    "current_taxes": 5216.26,
    "new_taxes_no_override": 5441.6,
    "override_total_1": 5596.0,
    "override_increase_1": 154.4
  },
  {
    "#": "99 Pond Ave, Unit 408 & P391 (287-16-78)",
    "$": 476700,
    "address": "99 Pond Ave, Unit 408 & P391",
    "parcel_id": "287-16-78",
    "owner1": "CYNN, TR, HYOUN SHIN",
    "owner2": "",
    "current_taxes": 4881.41,
    "new_taxes_no_override": 5092.29,
    "override_total_1": 5236.78,
    "override_increase_1": 144.49
  },
  {
    "#": "99 Pond Ave, Unit 409 & P365 (287-16-79)",
    "$": 509400,
    "address": "99 Pond Ave, Unit 409 & P365",
    "parcel_id": "287-16-79",
    "owner1": "HU, LINDA SHUANG",
    "owner2": "",
    "current_taxes": 1581.32,
    "new_taxes_no_override": 1649.63,
    "override_total_1": 1696.44,
    "override_increase_1": 46.81
  },
  {
    "#": "99 Pond Ave, Unit 410 & P436 (287-16-80)",
    "$": 526800,
    "address": "99 Pond Ave, Unit 410 & P436",
    "parcel_id": "287-16-80",
    "owner1": "RANIERI TRS, SUNHEE C",
    "owner2": "",
    "current_taxes": 1759.5,
    "new_taxes_no_override": 1835.51,
    "override_total_1": 1887.59,
    "override_increase_1": 52.08
  },
  {
    "#": "99 Pond Ave, Unit 411 & P327 (287-16-81)",
    "$": 509400,
    "address": "99 Pond Ave, Unit 411 & P327",
    "parcel_id": "287-16-81",
    "owner1": "HU, ZIYAO",
    "owner2": "",
    "current_taxes": 5216.26,
    "new_taxes_no_override": 5441.6,
    "override_total_1": 5596.0,
    "override_increase_1": 154.4
  },
  {
    "#": "99 Pond Ave, Unit 412 & P300 (287-16-82)",
    "$": 509400,
    "address": "99 Pond Ave, Unit 412 & P300",
    "parcel_id": "287-16-82",
    "owner1": "LURIE, CLAIRE J",
    "owner2": "",
    "current_taxes": 1581.32,
    "new_taxes_no_override": 1649.63,
    "override_total_1": 1696.44,
    "override_increase_1": 46.81
  },
  {
    "#": "99 Pond Ave, Unit 413 & P600 (287-16-83)",
    "$": 581300,
    "address": "99 Pond Ave, Unit 413 & P600",
    "parcel_id": "287-16-83",
    "owner1": "GHAEMI, MEHDI & NAZILA RESHAD",
    "owner2": "",
    "current_taxes": 5952.51,
    "new_taxes_no_override": 6209.66,
    "override_total_1": 6385.85,
    "override_increase_1": 176.19
  },
  {
    "#": "99 Pond Ave, Unit 414 & P285 (287-16-84)",
    "$": 509400,
    "address": "99 Pond Ave, Unit 414 & P285",
    "parcel_id": "287-16-84",
    "owner1": "SEGAL, SHIMON",
    "owner2": "",
    "current_taxes": 1581.32,
    "new_taxes_no_override": 1649.63,
    "override_total_1": 1696.44,
    "override_increase_1": 46.81
  },
  {
    "#": "99 Pond Ave, Unit 415 & P360 (287-16-85)",
    "$": 509400,
    "address": "99 Pond Ave, Unit 415 & P360",
    "parcel_id": "287-16-85",
    "owner1": "GOTTLIEB, DANIEL C",
    "owner2": "",
    "current_taxes": 1581.32,
    "new_taxes_no_override": 1649.63,
    "override_total_1": 1696.44,
    "override_increase_1": 46.81
  },
  {
    "#": "99 Pond Ave, Unit 416  (287-16-86)",
    "$": 855400,
    "address": "99 Pond Ave, Unit 416 ",
    "parcel_id": "287-16-86",
    "owner1": "LOWN, BARBARA & FREDRIC",
    "owner2": "",
    "current_taxes": 5124.36,
    "new_taxes_no_override": 5345.73,
    "override_total_1": 5497.41,
    "override_increase_1": 151.68
  },
  {
    "#": "99 Pond Ave, Unit 417 P332&A (287-16-87)",
    "$": 873800,
    "address": "99 Pond Ave, Unit 417 P332&A",
    "parcel_id": "287-16-87",
    "owner1": "GARDNER BROOK CONDOS LLC",
    "owner2": "",
    "current_taxes": 8947.71,
    "new_taxes_no_override": 9334.25,
    "override_total_1": 9599.1,
    "override_increase_1": 264.85
  },
  {
    "#": "99 Pond Ave, Unit 418 & P434 (287-16-88)",
    "$": 733000,
    "address": "99 Pond Ave, Unit 418 & P434",
    "parcel_id": "287-16-88",
    "owner1": "FOSTER TR, APRIL M",
    "owner2": "",
    "current_taxes": 7505.92,
    "new_taxes_no_override": 7830.18,
    "override_total_1": 8052.35,
    "override_increase_1": 222.18
  },
  {
    "#": "99 Pond Ave, Unit 419 P498&A (287-16-89)",
    "$": 752700,
    "address": "99 Pond Ave, Unit 419 P498&A",
    "parcel_id": "287-16-89",
    "owner1": "MORGAN TRS, DANE DAVID JR & ALICE B",
    "owner2": "",
    "current_taxes": 7707.65,
    "new_taxes_no_override": 8040.62,
    "override_total_1": 8268.77,
    "override_increase_1": 228.15
  },
  {
    "#": "99 Pond Ave, Unit 420 & P492 (287-16-90)",
    "$": 733000,
    "address": "99 Pond Ave, Unit 420 & P492",
    "parcel_id": "287-16-90",
    "owner1": "BOUDOVSKAIA, ELENA E",
    "owner2": "",
    "current_taxes": 7505.92,
    "new_taxes_no_override": 7830.18,
    "override_total_1": 8052.35,
    "override_increase_1": 222.18
  },
  {
    "#": "99 Pond Ave, Unit 421 & P602 (287-16-91)",
    "$": 747600,
    "address": "99 Pond Ave, Unit 421 & P602",
    "parcel_id": "287-16-91",
    "owner1": "BURTMAN, KAY",
    "owner2": "",
    "current_taxes": 7655.42,
    "new_taxes_no_override": 7986.13,
    "override_total_1": 8212.73,
    "override_increase_1": 226.6
  },
  {
    "#": "99 Pond Ave, Unit 422 & P628 (287-16-92)",
    "$": 765900,
    "address": "99 Pond Ave, Unit 422 & P628",
    "parcel_id": "287-16-92",
    "owner1": "KANTEKURE, KANCHAN",
    "owner2": "KERUR, BASAVARAJ",
    "current_taxes": 7842.82,
    "new_taxes_no_override": 8181.63,
    "override_total_1": 8413.78,
    "override_increase_1": 232.15
  },
  {
    "#": "99 Pond Ave, Unit 423 P315&A (287-16-93)",
    "$": 1056400,
    "address": "99 Pond Ave, Unit 423 P315&A",
    "parcel_id": "287-16-93",
    "owner1": "DORFMAN TRS, ROBERT S & MIRIAM M",
    "owner2": "",
    "current_taxes": 7182.6,
    "new_taxes_no_override": 7492.89,
    "override_total_1": 7705.49,
    "override_increase_1": 212.6
  },
  {
    "#": "99 Pond Ave, Unit 424 & P618 (287-16-94)",
    "$": 512500,
    "address": "99 Pond Ave, Unit 424 & P618",
    "parcel_id": "287-16-94",
    "owner1": "CARO, ET AL, ROGER L",
    "owner2": "C/O CARO PROPERTIES",
    "current_taxes": 5248.0,
    "new_taxes_no_override": 5474.71,
    "override_total_1": 5630.05,
    "override_increase_1": 155.34
  },
  {
    "#": "99 Pond Ave, Unit 425 P313&A (287-16-95)",
    "$": 801200,
    "address": "99 Pond Ave, Unit 425 P313&A",
    "parcel_id": "287-16-95",
    "owner1": "HANNA TRS, PHILIP F",
    "owner2": "TAWADROS, FEIBY L NASSAN",
    "current_taxes": 4569.35,
    "new_taxes_no_override": 4766.75,
    "override_total_1": 4902.0,
    "override_increase_1": 135.25
  },
  {
    "#": "99 Pond Ave, Unit 426 & P473 (287-16-96)",
    "$": 586200,
    "address": "99 Pond Ave, Unit 426 & P473",
    "parcel_id": "287-16-96",
    "owner1": "CASTRO RAMIREZ, KAREN L",
    "owner2": "",
    "current_taxes": 6002.69,
    "new_taxes_no_override": 6262.01,
    "override_total_1": 6439.69,
    "override_increase_1": 177.68
  },
  {
    "#": "99 Pond Ave, Unit 501 (287-16-97)",
    "$": 647300,
    "address": "99 Pond Ave, Unit 501",
    "parcel_id": "287-16-97",
    "owner1": "BROOK HOUSE CONDOMINIUM TRUST",
    "owner2": "C/O  DEPT 696 - THAYER & ASSOC.",
    "current_taxes": 6628.35,
    "new_taxes_no_override": 6914.69,
    "override_total_1": 7110.89,
    "override_increase_1": 196.2
  },
  {
    "#": "99 Pond Ave, Unit 502 & P398 (287-16-98)",
    "$": 509400,
    "address": "99 Pond Ave, Unit 502 & P398",
    "parcel_id": "287-16-98",
    "owner1": "LAMMERS, ERIC D & CAROL E",
    "owner2": "",
    "current_taxes": 1581.32,
    "new_taxes_no_override": 1649.63,
    "override_total_1": 1696.44,
    "override_increase_1": 46.81
  },
  {
    "#": "99 Pond Ave, Unit 503 & P392 (287-16-99)",
    "$": 526800,
    "address": "99 Pond Ave, Unit 503 & P392",
    "parcel_id": "287-16-99",
    "owner1": "FAN, HORNG YEUAN",
    "owner2": "TSAI, YI CHEN",
    "current_taxes": 5394.43,
    "new_taxes_no_override": 5627.47,
    "override_total_1": 5787.14,
    "override_increase_1": 159.68
  },
  {
    "#": "99 Pond Ave, Unit 504 & P406 (287-17-00)",
    "$": 513700,
    "address": "99 Pond Ave, Unit 504 & P406",
    "parcel_id": "287-17-00",
    "owner1": "CHEN, YONG & YING",
    "owner2": "",
    "current_taxes": 5260.29,
    "new_taxes_no_override": 5487.53,
    "override_total_1": 5643.24,
    "override_increase_1": 155.7
  },
  {
    "#": "99 Pond Ave, Unit 505 P486&A (287-17-01)",
    "$": 770800,
    "address": "99 Pond Ave, Unit 505 P486&A",
    "parcel_id": "287-17-01",
    "owner1": "LI, ZITAO",
    "owner2": "",
    "current_taxes": 4258.06,
    "new_taxes_no_override": 4442.01,
    "override_total_1": 4568.05,
    "override_increase_1": 126.04
  },
  {
    "#": "99 Pond Ave, Unit 506 & P616 (287-17-02)",
    "$": 615600,
    "address": "99 Pond Ave, Unit 506 & P616",
    "parcel_id": "287-17-02",
    "owner1": "COHEN, ALISON F",
    "owner2": "",
    "current_taxes": 2668.81,
    "new_taxes_no_override": 2784.1,
    "override_total_1": 2863.1,
    "override_increase_1": 79.0
  },
  {
    "#": "99 Pond Ave, Unit 507 (287-17-03)",
    "$": 523100,
    "address": "99 Pond Ave, Unit 507",
    "parcel_id": "287-17-03",
    "owner1": "BLAW LLC",
    "owner2": "C/O ARLENE LEHANE",
    "current_taxes": 5356.54,
    "new_taxes_no_override": 5587.94,
    "override_total_1": 5746.5,
    "override_increase_1": 158.55
  },
  {
    "#": "99 Pond Ave, Unit 508 & P657 (287-17-04)",
    "$": 476700,
    "address": "99 Pond Ave, Unit 508 & P657",
    "parcel_id": "287-17-04",
    "owner1": "ZHENG, CHEN JUAN",
    "owner2": "HOU, GUAN REN",
    "current_taxes": 4881.41,
    "new_taxes_no_override": 5092.29,
    "override_total_1": 5236.78,
    "override_increase_1": 144.49
  },
  {
    "#": "99 Pond Ave, Unit 509 & P469 (287-17-05)",
    "$": 509400,
    "address": "99 Pond Ave, Unit 509 & P469",
    "parcel_id": "287-17-05",
    "owner1": "99 POND AVENUE UNIT 509 LLC",
    "owner2": "",
    "current_taxes": 5216.26,
    "new_taxes_no_override": 5441.6,
    "override_total_1": 5596.0,
    "override_increase_1": 154.4
  },
  {
    "#": "99 Pond Ave, Unit 510 (287-17-06)",
    "$": 473700,
    "address": "99 Pond Ave, Unit 510",
    "parcel_id": "287-17-06",
    "owner1": "YEE, JASON",
    "owner2": "",
    "current_taxes": 1215.75,
    "new_taxes_no_override": 1268.27,
    "override_total_1": 1304.26,
    "override_increase_1": 35.99
  },
  {
    "#": "99 Pond Ave, Unit 511 & P386 (287-17-07)",
    "$": 509400,
    "address": "99 Pond Ave, Unit 511 & P386",
    "parcel_id": "287-17-07",
    "owner1": "NEZAM MAFI TRS, MOHAMMAD",
    "owner2": "MASTERS, JOELLEN",
    "current_taxes": 5216.26,
    "new_taxes_no_override": 5441.6,
    "override_total_1": 5596.0,
    "override_increase_1": 154.4
  },
  {
    "#": "99 Pond Ave, Unit 512 & P192 (287-17-08)",
    "$": 589500,
    "address": "99 Pond Ave, Unit 512 & P192",
    "parcel_id": "287-17-08",
    "owner1": "FAHEY, TR, BRIAN",
    "owner2": "",
    "current_taxes": 6036.48,
    "new_taxes_no_override": 6297.26,
    "override_total_1": 6475.94,
    "override_increase_1": 178.68
  },
  {
    "#": "99 Pond Ave, Unit 513 & P589 (287-17-09)",
    "$": 589500,
    "address": "99 Pond Ave, Unit 513 & P589",
    "parcel_id": "287-17-09",
    "owner1": "WANG, DUO",
    "owner2": "DREW, MICHAEL & WILLIAM",
    "current_taxes": 6036.48,
    "new_taxes_no_override": 6297.26,
    "override_total_1": 6475.94,
    "override_increase_1": 178.68
  },
  {
    "#": "99 Pond Ave, Unit 514 & P594 (287-17-10)",
    "$": 509400,
    "address": "99 Pond Ave, Unit 514 & P594",
    "parcel_id": "287-17-10",
    "owner1": "KAPTSAN TRS, ANGELA & IGOR",
    "owner2": "",
    "current_taxes": 5216.26,
    "new_taxes_no_override": 5441.6,
    "override_total_1": 5596.0,
    "override_increase_1": 154.4
  },
  {
    "#": "99 Pond Ave, Unit 515 & P378 (287-17-11)",
    "$": 581300,
    "address": "99 Pond Ave, Unit 515 & P378",
    "parcel_id": "287-17-11",
    "owner1": "SIEGAL TR, EDWARD D",
    "owner2": "",
    "current_taxes": 2317.58,
    "new_taxes_no_override": 2417.7,
    "override_total_1": 2486.3,
    "override_increase_1": 68.6
  },
  {
    "#": "99 Pond Ave, Unit 516 P380&A (287-17-12)",
    "$": 887400,
    "address": "99 Pond Ave, Unit 516 P380&A",
    "parcel_id": "287-17-12",
    "owner1": "SOMMER, TRS, NANCY MANNOS & LINDSAY",
    "owner2": "",
    "current_taxes": 5452.04,
    "new_taxes_no_override": 5687.57,
    "override_total_1": 5848.95,
    "override_increase_1": 161.38
  },
  {
    "#": "99 Pond Ave, Unit 517 P312&A (287-17-13)",
    "$": 965700,
    "address": "99 Pond Ave, Unit 517 P312&A",
    "parcel_id": "287-17-13",
    "owner1": "KHURANA TR, BHARTI",
    "owner2": "",
    "current_taxes": 9888.77,
    "new_taxes_no_override": 10315.96,
    "override_total_1": 10608.67,
    "override_increase_1": 292.71
  },
  {
    "#": "99 Pond Ave, Unit 518 & P232 (287-17-14)",
    "$": 786800,
    "address": "99 Pond Ave, Unit 518 & P232",
    "parcel_id": "287-17-14",
    "owner1": "MEDALIE, DAVID C",
    "owner2": "",
    "current_taxes": 4421.9,
    "new_taxes_no_override": 4612.93,
    "override_total_1": 4743.81,
    "override_increase_1": 130.89
  },
  {
    "#": "99 Pond Ave, Unit 519 & P601 (287-17-15)",
    "$": 754200,
    "address": "99 Pond Ave, Unit 519 & P601",
    "parcel_id": "287-17-15",
    "owner1": "FLANAGAN, TR, CATHERINE E",
    "owner2": "",
    "current_taxes": 4088.07,
    "new_taxes_no_override": 4264.67,
    "override_total_1": 4385.68,
    "override_increase_1": 121.01
  },
  {
    "#": "99 Pond Ave, Unit 520 & P320 (287-17-16)",
    "$": 786800,
    "address": "99 Pond Ave, Unit 520 & P320",
    "parcel_id": "287-17-16",
    "owner1": "JAGASIA, MAMTA & DILIP",
    "owner2": "",
    "current_taxes": 8056.83,
    "new_taxes_no_override": 8404.89,
    "override_total_1": 8643.37,
    "override_increase_1": 238.48
  },
  {
    "#": "99 Pond Ave, Unit 521 & P387 P660 (287-17-17)",
    "$": 791200,
    "address": "99 Pond Ave, Unit 521 & P387 P660",
    "parcel_id": "287-17-17",
    "owner1": "YE, SEN",
    "owner2": "",
    "current_taxes": 8101.89,
    "new_taxes_no_override": 8451.89,
    "override_total_1": 8691.71,
    "override_increase_1": 239.82
  },
  {
    "#": "99 Pond Ave, Unit 522 P381&A (287-17-18)",
    "$": 810100,
    "address": "99 Pond Ave, Unit 522 P381&A",
    "parcel_id": "287-17-18",
    "owner1": "WANG, GUICHUN",
    "owner2": "",
    "current_taxes": 8295.42,
    "new_taxes_no_override": 8653.78,
    "override_total_1": 8899.33,
    "override_increase_1": 245.54
  },
  {
    "#": "99 Pond Ave, Unit 523 P328&A (287-17-19)",
    "$": 1017500,
    "address": "99 Pond Ave, Unit 523 P328&A",
    "parcel_id": "287-17-19",
    "owner1": "GRAVEREAUX TRS, EDWIN C",
    "owner2": "KIM, JEAN J",
    "current_taxes": 10419.2,
    "new_taxes_no_override": 10869.31,
    "override_total_1": 11177.72,
    "override_increase_1": 308.41
  },
  {
    "#": "99 Pond Ave, Unit 601 & P630 (287-17-20)",
    "$": 675200,
    "address": "99 Pond Ave, Unit 601 & P630",
    "parcel_id": "287-17-20",
    "owner1": "LEHANE TR, ARLENE S",
    "owner2": "",
    "current_taxes": 3279.11,
    "new_taxes_no_override": 3420.77,
    "override_total_1": 3517.83,
    "override_increase_1": 97.06
  },
  {
    "#": "99 Pond Ave, Unit 602 & P397 (287-17-21)",
    "$": 509400,
    "address": "99 Pond Ave, Unit 602 & P397",
    "parcel_id": "287-17-21",
    "owner1": "HARDY TRS, JACK L & FRANKLIN V",
    "owner2": "C/O HARDY FRANKLIN, TYCA CORP",
    "current_taxes": 5216.26,
    "new_taxes_no_override": 5441.6,
    "override_total_1": 5596.0,
    "override_increase_1": 154.4
  },
  {
    "#": "99 Pond Ave, Unit 603 & P393 (287-17-22)",
    "$": 514200,
    "address": "99 Pond Ave, Unit 603 & P393",
    "parcel_id": "287-17-22",
    "owner1": "POND 99-603 LLC",
    "owner2": "",
    "current_taxes": 5265.41,
    "new_taxes_no_override": 5492.88,
    "override_total_1": 5648.73,
    "override_increase_1": 155.86
  },
  {
    "#": "99 Pond Ave, Unit 604 & P205 (287-17-23)",
    "$": 516600,
    "address": "99 Pond Ave, Unit 604 & P205",
    "parcel_id": "287-17-23",
    "owner1": "LI TR, MEIYIN SU",
    "owner2": "",
    "current_taxes": 5289.98,
    "new_taxes_no_override": 5518.51,
    "override_total_1": 5675.09,
    "override_increase_1": 156.58
  },
  {
    "#": "99 Pond Ave, Unit 605 & P595 P664 (287-17-24)",
    "$": 805800,
    "address": "99 Pond Ave, Unit 605 & P595 P664",
    "parcel_id": "287-17-24",
    "owner1": "RANIERI TRS, SUNHEE C",
    "owner2": "",
    "current_taxes": 8251.39,
    "new_taxes_no_override": 8607.85,
    "override_total_1": 8852.09,
    "override_increase_1": 244.24
  },
  {
    "#": "99 Pond Ave, Unit 606 P584B (287-17-25)",
    "$": 642400,
    "address": "99 Pond Ave, Unit 606 P584B",
    "parcel_id": "287-17-25",
    "owner1": "BRITTO, CARL",
    "owner2": "",
    "current_taxes": 6578.18,
    "new_taxes_no_override": 6862.36,
    "override_total_1": 7057.07,
    "override_increase_1": 194.71
  },
  {
    "#": "99 Pond Ave, Unit 607 P356&A (287-17-26)",
    "$": 529800,
    "address": "99 Pond Ave, Unit 607 P356&A",
    "parcel_id": "287-17-26",
    "owner1": "MA, TIESONG",
    "owner2": "",
    "current_taxes": 5425.15,
    "new_taxes_no_override": 5659.52,
    "override_total_1": 5820.1,
    "override_increase_1": 160.58
  },
  {
    "#": "99 Pond Ave, Unit 608 & P271 (287-17-27)",
    "$": 506100,
    "address": "99 Pond Ave, Unit 608 & P271",
    "parcel_id": "287-17-27",
    "owner1": "SUN, SENMIAO",
    "owner2": "",
    "current_taxes": 1547.53,
    "new_taxes_no_override": 1614.38,
    "override_total_1": 1660.19,
    "override_increase_1": 45.81
  },
  {
    "#": "99 Pond Ave, Unit 609 & P448 (287-17-28)",
    "$": 509400,
    "address": "99 Pond Ave, Unit 609 & P448",
    "parcel_id": "287-17-28",
    "owner1": "HASKAL TR, HAIM M",
    "owner2": "",
    "current_taxes": 5216.26,
    "new_taxes_no_override": 5441.6,
    "override_total_1": 5596.0,
    "override_increase_1": 154.4
  },
  {
    "#": "99 Pond Ave, Unit 610 & P584 (287-17-29)",
    "$": 509400,
    "address": "99 Pond Ave, Unit 610 & P584",
    "parcel_id": "287-17-29",
    "owner1": "CYNKOWSKI, TADEUSZ & GRAZYNA",
    "owner2": "",
    "current_taxes": 1581.32,
    "new_taxes_no_override": 1649.63,
    "override_total_1": 1696.44,
    "override_increase_1": 46.81
  },
  {
    "#": "99 Pond Ave, Unit 611& P385A (287-17-30)",
    "$": 519600,
    "address": "99 Pond Ave, Unit 611& P385A",
    "parcel_id": "287-17-30",
    "owner1": "COLCHER TR, SUSAN D",
    "owner2": "",
    "current_taxes": 1685.77,
    "new_taxes_no_override": 1758.6,
    "override_total_1": 1808.49,
    "override_increase_1": 49.9
  },
  {
    "#": "99 Pond Ave, Unit 612 & P604 (287-17-31)",
    "$": 509400,
    "address": "99 Pond Ave, Unit 612 & P604",
    "parcel_id": "287-17-31",
    "owner1": "LIU, NATALIE & ZAO",
    "owner2": "",
    "current_taxes": 5216.26,
    "new_taxes_no_override": 5441.6,
    "override_total_1": 5596.0,
    "override_increase_1": 154.4
  },
  {
    "#": "99 Pond Ave, Unit 613 & P597 (287-17-32)",
    "$": 519600,
    "address": "99 Pond Ave, Unit 613 & P597",
    "parcel_id": "287-17-32",
    "owner1": "GARZA TR, RENE",
    "owner2": "",
    "current_taxes": 5320.7,
    "new_taxes_no_override": 5550.55,
    "override_total_1": 5708.05,
    "override_increase_1": 157.49
  },
  {
    "#": "99 Pond Ave, Unit 614 & P375 (287-17-33)",
    "$": 509400,
    "address": "99 Pond Ave, Unit 614 & P375",
    "parcel_id": "287-17-33",
    "owner1": "REDDY, SHILPA",
    "owner2": "",
    "current_taxes": 5216.26,
    "new_taxes_no_override": 5441.6,
    "override_total_1": 5596.0,
    "override_increase_1": 154.4
  },
  {
    "#": "99 Pond Ave, Unit 615 & P278 (287-17-34)",
    "$": 509400,
    "address": "99 Pond Ave, Unit 615 & P278",
    "parcel_id": "287-17-34",
    "owner1": "LEBNER, PATRICIA",
    "owner2": "SILVER, GLORIA",
    "current_taxes": 5216.26,
    "new_taxes_no_override": 5441.6,
    "override_total_1": 5596.0,
    "override_increase_1": 154.4
  },
  {
    "#": "99 Pond Ave, Unit 616 P310&A (287-17-35)",
    "$": 887400,
    "address": "99 Pond Ave, Unit 616 P310&A",
    "parcel_id": "287-17-35",
    "owner1": "PEJIC-STOJANOV, TRS, SNEZANA",
    "owner2": "",
    "current_taxes": 5452.04,
    "new_taxes_no_override": 5687.57,
    "override_total_1": 5848.95,
    "override_increase_1": 161.38
  },
  {
    "#": "99 Pond Ave, Unit 617 P366&A (287-17-36)",
    "$": 884000,
    "address": "99 Pond Ave, Unit 617 P366&A",
    "parcel_id": "287-17-36",
    "owner1": "PLATT, ROGER D & JUDY R",
    "owner2": "",
    "current_taxes": 9052.16,
    "new_taxes_no_override": 9443.21,
    "override_total_1": 9711.16,
    "override_increase_1": 267.94
  },
  {
    "#": "99 Pond Ave, Unit 618 P482&A (287-17-37)",
    "$": 810100,
    "address": "99 Pond Ave, Unit 618 P482&A",
    "parcel_id": "287-17-37",
    "owner1": "NANAGOULIAN, GARNIK & KARINE",
    "owner2": "",
    "current_taxes": 4660.49,
    "new_taxes_no_override": 4861.82,
    "override_total_1": 4999.77,
    "override_increase_1": 137.95
  },
  {
    "#": "99 Pond Ave, Unit 619 & P596 (287-17-38)",
    "$": 761500,
    "address": "99 Pond Ave, Unit 619 & P596",
    "parcel_id": "287-17-38",
    "owner1": "WEINSTEIN TRS, AMY H",
    "owner2": "BAR-SHANY, ALON",
    "current_taxes": 7797.76,
    "new_taxes_no_override": 8134.62,
    "override_total_1": 8365.44,
    "override_increase_1": 230.81
  },
  {
    "#": "99 Pond Ave, Unit 620 & P586 (287-17-39)",
    "$": 989800,
    "address": "99 Pond Ave, Unit 620 & P586",
    "parcel_id": "287-17-39",
    "owner1": "BROWN, TRS, DAVID J",
    "owner2": "MULLER, CORINNE",
    "current_taxes": 10135.55,
    "new_taxes_no_override": 10573.41,
    "override_total_1": 10873.42,
    "override_increase_1": 300.01
  },
  {
    "#": "99 Pond Ave, Unit 621 & P562-562A (287-17-40)",
    "$": 810100,
    "address": "99 Pond Ave, Unit 621 & P562-562A",
    "parcel_id": "287-17-40",
    "owner1": "WANG, BRANDEN",
    "owner2": "",
    "current_taxes": 4660.49,
    "new_taxes_no_override": 4861.82,
    "override_total_1": 4999.77,
    "override_increase_1": 137.95
  },
  {
    "#": "99 Pond Ave, Unit 622 P384&A (287-17-41)",
    "$": 1169900,
    "address": "99 Pond Ave, Unit 622 P384&A",
    "parcel_id": "287-17-41",
    "owner1": "KIEFF TRS, LAUREN R & DAVID A",
    "owner2": "",
    "current_taxes": 11979.78,
    "new_taxes_no_override": 12497.31,
    "override_total_1": 12851.91,
    "override_increase_1": 354.6
  },
  {
    "#": "99 Pond Ave, Unit 623 P573&A (287-17-42)",
    "$": 1180200,
    "address": "99 Pond Ave, Unit 623 P573&A",
    "parcel_id": "287-17-42",
    "owner1": "CHASE, DEAN F",
    "owner2": "",
    "current_taxes": 8450.31,
    "new_taxes_no_override": 8815.36,
    "override_total_1": 9065.49,
    "override_increase_1": 250.13
  },
  {
    "#": "99 Pond Ave, Unit 701 & P669 (287-17-43)",
    "$": 631100,
    "address": "99 Pond Ave, Unit 701 & P669",
    "parcel_id": "287-17-43",
    "owner1": "GRUBISSICH, LUCIANO",
    "owner2": "KILARSKI, RYSZARD",
    "current_taxes": 2827.53,
    "new_taxes_no_override": 2949.68,
    "override_total_1": 3033.37,
    "override_increase_1": 83.69
  },
  {
    "#": "99 Pond Ave, Unit 702 & P610 (287-17-44)",
    "$": 581300,
    "address": "99 Pond Ave, Unit 702 & P610",
    "parcel_id": "287-17-44",
    "owner1": "DING, ZHIYING",
    "owner2": "",
    "current_taxes": 5952.51,
    "new_taxes_no_override": 6209.66,
    "override_total_1": 6385.85,
    "override_increase_1": 176.19
  },
  {
    "#": "99 Pond Ave, Unit 703 & P421 (287-17-45)",
    "$": 509400,
    "address": "99 Pond Ave, Unit 703 & P421",
    "parcel_id": "287-17-45",
    "owner1": "MAH, TR, KUM-YAN ELIZA",
    "owner2": "",
    "current_taxes": 5216.26,
    "new_taxes_no_override": 5441.6,
    "override_total_1": 5596.0,
    "override_increase_1": 154.4
  },
  {
    "#": "99 Pond Ave, Unit 704 & P612 (287-17-46)",
    "$": 509400,
    "address": "99 Pond Ave, Unit 704 & P612",
    "parcel_id": "287-17-46",
    "owner1": "MORIMOTO, CHIKAO & HARUKO",
    "owner2": "",
    "current_taxes": 5216.26,
    "new_taxes_no_override": 5441.6,
    "override_total_1": 5596.0,
    "override_increase_1": 154.4
  },
  {
    "#": "99 Pond Ave, Unit 705 & P617 (287-17-47)",
    "$": 757700,
    "address": "99 Pond Ave, Unit 705 & P617",
    "parcel_id": "287-17-47",
    "owner1": "SUN, HAIYING",
    "owner2": "",
    "current_taxes": 7758.85,
    "new_taxes_no_override": 8094.03,
    "override_total_1": 8323.69,
    "override_increase_1": 229.66
  },
  {
    "#": "99 Pond Ave, Unit 706 & P417 (287-17-48)",
    "$": 615600,
    "address": "99 Pond Ave, Unit 706 & P417",
    "parcel_id": "287-17-48",
    "owner1": "LI, NAI WO",
    "owner2": "",
    "current_taxes": 6303.74,
    "new_taxes_no_override": 6576.06,
    "override_total_1": 6762.65,
    "override_increase_1": 186.59
  },
  {
    "#": "99 Pond Ave, Unit 707 & P368 (287-17-49)",
    "$": 509400,
    "address": "99 Pond Ave, Unit 707 & P368",
    "parcel_id": "287-17-49",
    "owner1": "WEINTRAUB, STEPHANIE E",
    "owner2": "",
    "current_taxes": 1581.32,
    "new_taxes_no_override": 1649.63,
    "override_total_1": 1696.44,
    "override_increase_1": 46.81
  },
  {
    "#": "99 Pond Ave, Unit 708 P583B (287-17-50)",
    "$": 476700,
    "address": "99 Pond Ave, Unit 708 P583B",
    "parcel_id": "287-17-50",
    "owner1": "YANG, YANG",
    "owner2": "STOLAROV, JAVOR P",
    "current_taxes": 4881.41,
    "new_taxes_no_override": 5092.29,
    "override_total_1": 5236.78,
    "override_increase_1": 144.49
  },
  {
    "#": "99 Pond Ave, Unit 709 & P451 (287-17-51)",
    "$": 594900,
    "address": "99 Pond Ave, Unit 709 & P451",
    "parcel_id": "287-17-51",
    "owner1": "CHIOU, YUH-FEN",
    "owner2": "LIOU, ALISON",
    "current_taxes": 6091.78,
    "new_taxes_no_override": 6354.94,
    "override_total_1": 6535.26,
    "override_increase_1": 180.32
  },
  {
    "#": "99 Pond Ave, Unit 710 & P357 (287-17-52)",
    "$": 509400,
    "address": "99 Pond Ave, Unit 710 & P357",
    "parcel_id": "287-17-52",
    "owner1": "KERAMOPOULOS TR, HERO",
    "owner2": "C/O SOMMER TR, RUTH",
    "current_taxes": 5216.26,
    "new_taxes_no_override": 5441.6,
    "override_total_1": 5596.0,
    "override_increase_1": 154.4
  },
  {
    "#": "99 Pond Ave, Unit 711 & P532 (287-17-53)",
    "$": 509400,
    "address": "99 Pond Ave, Unit 711 & P532",
    "parcel_id": "287-17-53",
    "owner1": "FUNK, ALLEN",
    "owner2": "",
    "current_taxes": 1581.32,
    "new_taxes_no_override": 1649.63,
    "override_total_1": 1696.44,
    "override_increase_1": 46.81
  },
  {
    "#": "99 Pond Ave, Unit 712 & P426 (287-17-54)",
    "$": 509400,
    "address": "99 Pond Ave, Unit 712 & P426",
    "parcel_id": "287-17-54",
    "owner1": "PACSON TR, MARIO P",
    "owner2": "",
    "current_taxes": 5216.26,
    "new_taxes_no_override": 5441.6,
    "override_total_1": 5596.0,
    "override_increase_1": 154.4
  },
  {
    "#": "99 Pond Ave, Unit 713 & P203 (287-17-55)",
    "$": 529500,
    "address": "99 Pond Ave, Unit 713 & P203",
    "parcel_id": "287-17-55",
    "owner1": "BHOJWANI, ISHAAN",
    "owner2": "",
    "current_taxes": 5422.08,
    "new_taxes_no_override": 5656.31,
    "override_total_1": 5816.81,
    "override_increase_1": 160.49
  },
  {
    "#": "99 Pond Ave, Unit 714 & P293 (287-17-56)",
    "$": 509400,
    "address": "99 Pond Ave, Unit 714 & P293",
    "parcel_id": "287-17-56",
    "owner1": "TUROK TR, MILENA",
    "owner2": "",
    "current_taxes": 5216.26,
    "new_taxes_no_override": 5441.6,
    "override_total_1": 5596.0,
    "override_increase_1": 154.4
  },
  {
    "#": "99 Pond Ave, Unit 715 P585B (287-17-57)",
    "$": 509400,
    "address": "99 Pond Ave, Unit 715 P585B",
    "parcel_id": "287-17-57",
    "owner1": "PIMENTEL, DAVID R",
    "owner2": "",
    "current_taxes": 5216.26,
    "new_taxes_no_override": 5441.6,
    "override_total_1": 5596.0,
    "override_increase_1": 154.4
  },
  {
    "#": "99 Pond Ave, Unit 716 P382&A (287-17-58)",
    "$": 754500,
    "address": "99 Pond Ave, Unit 716 P382&A",
    "parcel_id": "287-17-58",
    "owner1": "SALTER TRS, SUSAN",
    "owner2": "HERRON, DINNY J",
    "current_taxes": 4091.15,
    "new_taxes_no_override": 4267.89,
    "override_total_1": 4388.99,
    "override_increase_1": 121.1
  },
  {
    "#": "99 Pond Ave, Unit 717 (287-17-59)",
    "$": 452200,
    "address": "99 Pond Ave, Unit 717",
    "parcel_id": "287-17-59",
    "owner1": "WEKSTEIN TR, ANN R",
    "owner2": "",
    "current_taxes": 995.59,
    "new_taxes_no_override": 1038.6,
    "override_total_1": 1068.07,
    "override_increase_1": 29.47
  },
  {
    "#": "99 Pond Ave, Unit 718 & P581 (287-17-60)",
    "$": 975500,
    "address": "99 Pond Ave, Unit 718 & P581",
    "parcel_id": "287-17-60",
    "owner1": "WALT TR, MICHAEL J",
    "owner2": "",
    "current_taxes": 6354.19,
    "new_taxes_no_override": 6628.69,
    "override_total_1": 6816.78,
    "override_increase_1": 188.08
  },
  {
    "#": "99 Pond Ave, Unit 801 & P592 (287-17-61)",
    "$": 682000,
    "address": "99 Pond Ave, Unit 801 & P592",
    "parcel_id": "287-17-61",
    "owner1": "URMAN, SERGEY",
    "owner2": "",
    "current_taxes": 6983.68,
    "new_taxes_no_override": 7285.37,
    "override_total_1": 7492.09,
    "override_increase_1": 206.72
  },
  {
    "#": "99 Pond Ave, Unit 802 P481&A (287-17-62)",
    "$": 1013700,
    "address": "99 Pond Ave, Unit 802 P481&A",
    "parcel_id": "287-17-62",
    "owner1": "GREENBERG, JASON & TERESA",
    "owner2": "",
    "current_taxes": 10380.29,
    "new_taxes_no_override": 10828.72,
    "override_total_1": 11135.98,
    "override_increase_1": 307.26
  },
  {
    "#": "99 Pond Ave, Unit 803 P309&A (287-17-63)",
    "$": 1013700,
    "address": "99 Pond Ave, Unit 803 P309&A",
    "parcel_id": "287-17-63",
    "owner1": "SMITH, DARRELL N & LORRAINE B",
    "owner2": "",
    "current_taxes": 6745.35,
    "new_taxes_no_override": 7036.75,
    "override_total_1": 7236.41,
    "override_increase_1": 199.66
  },
  {
    "#": "99 Pond Ave, Unit 804 & P276 (287-17-64)",
    "$": 951200,
    "address": "99 Pond Ave, Unit 804 & P276",
    "parcel_id": "287-17-64",
    "owner1": "THADANI, DEEPAK",
    "owner2": "",
    "current_taxes": 9740.29,
    "new_taxes_no_override": 10161.07,
    "override_total_1": 10449.38,
    "override_increase_1": 288.31
  },
  {
    "#": "99 Pond Ave, Unit 805 P497&A (287-17-65)",
    "$": 982500,
    "address": "99 Pond Ave, Unit 805 P497&A",
    "parcel_id": "287-17-65",
    "owner1": "ANTILES TRS, ARLENE & SAMUEL",
    "owner2": "KIEFF, LAUREN & DAVID",
    "current_taxes": 6425.87,
    "new_taxes_no_override": 6703.47,
    "override_total_1": 6893.67,
    "override_increase_1": 190.21
  },
  {
    "#": "99 Pond Ave, Unit 806 P317&A (287-17-66)",
    "$": 638900,
    "address": "99 Pond Ave, Unit 806 P317&A",
    "parcel_id": "287-17-66",
    "owner1": "99 POND AVE LLC",
    "owner2": "",
    "current_taxes": 6542.34,
    "new_taxes_no_override": 6824.97,
    "override_total_1": 7018.62,
    "override_increase_1": 193.65
  },
  {
    "#": "99 Pond Ave, Unit 807 & P515 (287-17-67)",
    "$": 555500,
    "address": "99 Pond Ave, Unit 807 & P515",
    "parcel_id": "287-17-67",
    "owner1": "LIPMAN, AMY",
    "owner2": "",
    "current_taxes": 5688.32,
    "new_taxes_no_override": 5934.06,
    "override_total_1": 6102.43,
    "override_increase_1": 168.37
  },
  {
    "#": "99 Pond Ave, Unit 808 (287-17-68)",
    "$": 441000,
    "address": "99 Pond Ave, Unit 808",
    "parcel_id": "287-17-68",
    "owner1": "CLARIDAD, KATRINA & LETICIA",
    "owner2": "",
    "current_taxes": 4515.84,
    "new_taxes_no_override": 4710.92,
    "override_total_1": 4844.59,
    "override_increase_1": 133.67
  },
  {
    "#": "99 Pond Ave, Unit 810 & P233 (287-17-69)",
    "$": 581200,
    "address": "99 Pond Ave, Unit 810 & P233",
    "parcel_id": "287-17-69",
    "owner1": "SHEN, LI MING",
    "owner2": "WONG, LILY",
    "current_taxes": 5951.49,
    "new_taxes_no_override": 6208.59,
    "override_total_1": 6384.76,
    "override_increase_1": 176.16
  },
  {
    "#": "99 Pond Ave, Unit 812 & P323 (287-17-70)",
    "$": 581300,
    "address": "99 Pond Ave, Unit 812 & P323",
    "parcel_id": "287-17-70",
    "owner1": "ZUO TR, HAOBO",
    "owner2": "",
    "current_taxes": 5952.51,
    "new_taxes_no_override": 6209.66,
    "override_total_1": 6385.85,
    "override_increase_1": 176.19
  },
  {
    "#": "99 Pond Ave, Unit 814 & P231 (287-17-71)",
    "$": 509400,
    "address": "99 Pond Ave, Unit 814 & P231",
    "parcel_id": "287-17-71",
    "owner1": "HUANG, JAMES",
    "owner2": "",
    "current_taxes": 5216.26,
    "new_taxes_no_override": 5441.6,
    "override_total_1": 5596.0,
    "override_increase_1": 154.4
  },
  {
    "#": "99 Pond Ave, Unit 901 & P373 (287-17-72)",
    "$": 682100,
    "address": "99 Pond Ave, Unit 901 & P373",
    "parcel_id": "287-17-72",
    "owner1": "INFORMATION DEVELOPMENT, AMERICA INC",
    "owner2": "C/O ABLE REAL ESTATE USA INC",
    "current_taxes": 6984.7,
    "new_taxes_no_override": 7286.44,
    "override_total_1": 7493.19,
    "override_increase_1": 206.75
  },
  {
    "#": "99 Pond Ave, Unit P174 (287-18-30)",
    "$": 60000,
    "address": "99 Pond Ave, Unit P174",
    "parcel_id": "287-18-30",
    "owner1": "DE VARGAS, ET AL TRS, BLANCA C B",
    "owner2": "C/O HURWITZ MARY",
    "current_taxes": 614.4,
    "new_taxes_no_override": 640.94,
    "override_total_1": 659.13,
    "override_increase_1": 18.19
  },
  {
    "#": "99 Pond Ave, Unit P302 (287-18-74)",
    "$": 63500,
    "address": "99 Pond Ave, Unit P302",
    "parcel_id": "287-18-74",
    "owner1": "AGRESAR, ANMIR",
    "owner2": "",
    "current_taxes": 650.24,
    "new_taxes_no_override": 678.33,
    "override_total_1": 697.58,
    "override_increase_1": 19.25
  },
  {
    "#": "99 Pond Ave, Unit P333-333A (287-18-53)",
    "$": 90000,
    "address": "99 Pond Ave, Unit P333-333A",
    "parcel_id": "287-18-53",
    "owner1": "ZHANG, FENGSHAN",
    "owner2": "SONG, QINGHUA & AILIN",
    "current_taxes": 921.6,
    "new_taxes_no_override": 961.41,
    "override_total_1": 988.69,
    "override_increase_1": 27.28
  },
  {
    "#": "99 Pond Ave, Unit P449 (287-18-85)",
    "$": 61900,
    "address": "99 Pond Ave, Unit P449",
    "parcel_id": "287-18-85",
    "owner1": "SALKOVITZ, MARNIE B",
    "owner2": "",
    "current_taxes": 633.86,
    "new_taxes_no_override": 661.24,
    "override_total_1": 680.01,
    "override_increase_1": 18.76
  },
  {
    "#": "99 Pond Ave, Unit P582A-582B (287-18-66)",
    "$": 90000,
    "address": "99 Pond Ave, Unit P582A-582B",
    "parcel_id": "287-18-66",
    "owner1": "SCJJ LLC",
    "owner2": "",
    "current_taxes": 921.6,
    "new_taxes_no_override": 961.41,
    "override_total_1": 988.69,
    "override_increase_1": 27.28
  },
  {
    "#": "99 Pond Ave, Unit P632 (287-18-36)",
    "$": 60000,
    "address": "99 Pond Ave, Unit P632",
    "parcel_id": "287-18-36",
    "owner1": "SHTIFTER, ZVI",
    "owner2": "",
    "current_taxes": 614.4,
    "new_taxes_no_override": 640.94,
    "override_total_1": 659.13,
    "override_increase_1": 18.19
  },
  {
    "#": "99 Pond Ave, Unit P636 (287-18-37)",
    "$": 60000,
    "address": "99 Pond Ave, Unit P636",
    "parcel_id": "287-18-37",
    "owner1": "SEIDEN, RICHARD L",
    "owner2": "",
    "current_taxes": 614.4,
    "new_taxes_no_override": 640.94,
    "override_total_1": 659.13,
    "override_increase_1": 18.19
  },
  {
    "#": "99 Pond Ave, Unit P670 (287-18-60)",
    "$": 60000,
    "address": "99 Pond Ave, Unit P670",
    "parcel_id": "287-18-60",
    "owner1": "CLARIDAD, KATRINA",
    "owner2": "",
    "current_taxes": 614.4,
    "new_taxes_no_override": 640.94,
    "override_total_1": 659.13,
    "override_increase_1": 18.19
  },
  {
    "#": "99 Pond Ave (287-18-49)",
    "$": 2500000,
    "address": "99 Pond Ave",
    "parcel_id": "287-18-49",
    "owner1": "ATLANTIC BROOKHOUSE REALTY LLC",
    "owner2": "",
    "current_taxes": 42900.0,
    "new_taxes_no_override": 44753.28,
    "override_total_1": 46023.12,
    "override_increase_1": 1269.84
  },
  {
    "#": "203 Pond Ave (297-04-00)",
    "$": 2679300,
    "address": "203 Pond Ave",
    "parcel_id": "297-04-00",
    "owner1": "GESCHICKTER JR, EDMUND",
    "owner2": "SOMMER, MICHELE",
    "current_taxes": 23801.1,
    "new_taxes_no_override": 24829.31,
    "override_total_1": 25533.82,
    "override_increase_1": 704.51
  },
  {
    "#": "209 Pond Ave (297-05-00)",
    "$": 2154000,
    "address": "209 Pond Ave",
    "parcel_id": "297-05-00",
    "owner1": "MATTISON TRS, HUGH & ARLENE B",
    "owner2": "",
    "current_taxes": 18422.03,
    "new_taxes_no_override": 19217.86,
    "override_total_1": 19763.15,
    "override_increase_1": 545.29
  },
  {
    "#": "215 Pond Ave (297-06-00)",
    "$": 2238600,
    "address": "215 Pond Ave",
    "parcel_id": "297-06-00",
    "owner1": "BOOK, JONATHAN E",
    "owner2": "CLIFFORD, COREY J",
    "current_taxes": 19288.33,
    "new_taxes_no_override": 20121.59,
    "override_total_1": 20692.52,
    "override_increase_1": 570.93
  },
  {
    "#": "219 Pond Ave (297-07-00)",
    "$": 2158100,
    "address": "219 Pond Ave",
    "parcel_id": "297-07-00",
    "owner1": "DEANGELO TRS, EDWARD JAMES",
    "owner2": "CONRAD, MIRIAM",
    "current_taxes": 18464.01,
    "new_taxes_no_override": 19261.66,
    "override_total_1": 19808.19,
    "override_increase_1": 546.53
  },
  {
    "#": "225 Pond Ave (297-07-01)",
    "$": 2495000,
    "address": "225 Pond Ave",
    "parcel_id": "297-07-01",
    "owner1": "WANG, RUOBING",
    "owner2": "KIM, SANGBAE",
    "current_taxes": 21913.87,
    "new_taxes_no_override": 22860.55,
    "override_total_1": 23509.2,
    "override_increase_1": 648.65
  },
  {
    "#": "231 Pond Ave (297-08-00)",
    "$": 2473800,
    "address": "231 Pond Ave",
    "parcel_id": "297-08-00",
    "owner1": "ALBASSAM TR, TALAL TARIQ",
    "owner2": "",
    "current_taxes": 25331.71,
    "new_taxes_no_override": 26426.04,
    "override_total_1": 27175.86,
    "override_increase_1": 749.82
  },
  {
    "#": "375 Pond Ave, Unit 1 (301-24-03)",
    "$": 875100,
    "address": "375 Pond Ave, Unit 1",
    "parcel_id": "301-24-03",
    "owner1": "WU, LEI",
    "owner2": "GU, YAN HONG",
    "current_taxes": 5326.09,
    "new_taxes_no_override": 5556.18,
    "override_total_1": 5713.83,
    "override_increase_1": 157.65
  },
  {
    "#": "375 Pond Ave, Unit 2 (301-24-01)",
    "$": 728500,
    "address": "375 Pond Ave, Unit 2",
    "parcel_id": "301-24-01",
    "owner1": "HARGLEROAD, ANN M",
    "owner2": "",
    "current_taxes": 3824.91,
    "new_taxes_no_override": 3990.15,
    "override_total_1": 4103.36,
    "override_increase_1": 113.22
  },
  {
    "#": "375 Pond Ave, Unit 3 (301-24-02)",
    "$": 759100,
    "address": "375 Pond Ave, Unit 3",
    "parcel_id": "301-24-02",
    "owner1": "XIA, XIAOBO",
    "owner2": "",
    "current_taxes": 7773.18,
    "new_taxes_no_override": 8108.98,
    "override_total_1": 8339.07,
    "override_increase_1": 230.09
  },
  {
    "#": "379 Pond Ave, Unit A (301-25-01)",
    "$": 782200,
    "address": "379 Pond Ave, Unit A",
    "parcel_id": "301-25-01",
    "owner1": "PERRINEZ, VALERIE",
    "owner2": "",
    "current_taxes": 4374.79,
    "new_taxes_no_override": 4563.78,
    "override_total_1": 4693.27,
    "override_increase_1": 129.49
  },
  {
    "#": "379 Pond Ave, Unit B (301-25-02)",
    "$": 803100,
    "address": "379 Pond Ave, Unit B",
    "parcel_id": "301-25-02",
    "owner1": "ALMANZA, YEZMIN NAME",
    "owner2": "",
    "current_taxes": 4588.81,
    "new_taxes_no_override": 4787.05,
    "override_total_1": 4922.88,
    "override_increase_1": 135.83
  },
  {
    "#": "381 Pond Ave, Unit 1 (301-26-01)",
    "$": 765900,
    "address": "381 Pond Ave, Unit 1",
    "parcel_id": "301-26-01",
    "owner1": "CHAMBERLIN TR, NANCY L",
    "owner2": "",
    "current_taxes": 4207.88,
    "new_taxes_no_override": 4389.66,
    "override_total_1": 4514.21,
    "override_increase_1": 124.55
  },
  {
    "#": "381 Pond Ave, Unit 2 (301-26-02)",
    "$": 746200,
    "address": "381 Pond Ave, Unit 2",
    "parcel_id": "301-26-02",
    "owner1": "HUNTINGTON, IAN",
    "owner2": "JAY, SARAH",
    "current_taxes": 4006.15,
    "new_taxes_no_override": 4179.22,
    "override_total_1": 4297.8,
    "override_increase_1": 118.58
  },
  {
    "#": "381 Pond Ave, Unit 3 (301-26-03)",
    "$": 752700,
    "address": "381 Pond Ave, Unit 3",
    "parcel_id": "301-26-03",
    "owner1": "BEGGS, BRIAN",
    "owner2": "SCOTT, SARA E",
    "current_taxes": 4072.71,
    "new_taxes_no_override": 4248.65,
    "override_total_1": 4369.2,
    "override_increase_1": 120.55
  },
  {
    "#": "385 Pond Ave (301-27-00)",
    "$": 1786000,
    "address": "385 Pond Ave",
    "parcel_id": "301-27-00",
    "owner1": "POND STREET 385 REALTY LLC",
    "owner2": "",
    "current_taxes": 18288.64,
    "new_taxes_no_override": 19078.71,
    "override_total_1": 19620.05,
    "override_increase_1": 541.34
  },
  {
    "#": "11 Powell St (011-05-00)",
    "$": 3209400,
    "address": "11 Powell St",
    "parcel_id": "011-05-00",
    "owner1": "LIVINGSTON, DAVID M",
    "owner2": "RABB, EMILY",
    "current_taxes": 29229.32,
    "new_taxes_no_override": 30492.03,
    "override_total_1": 31357.21,
    "override_increase_1": 865.19
  },
  {
    "#": "19 Powell St (011-06-00)",
    "$": 4483300,
    "address": "19 Powell St",
    "parcel_id": "011-06-00",
    "owner1": "WOLRAICH, DAVID A",
    "owner2": "WEINRIB, LAURA MAE",
    "current_taxes": 42274.06,
    "new_taxes_no_override": 44100.3,
    "override_total_1": 45351.61,
    "override_increase_1": 1251.31
  },
  {
    "#": "29 Powell St (011-07-00)",
    "$": 4199600,
    "address": "29 Powell St",
    "parcel_id": "011-07-00",
    "owner1": "D ARBELOFF, MATTHEW",
    "owner2": "LAVIN, CLAUDIA",
    "current_taxes": 43003.9,
    "new_taxes_no_override": 44861.67,
    "override_total_1": 46134.58,
    "override_increase_1": 1272.92
  },
  {
    "#": "30 Powell St, Unit 1 (041-09-03)",
    "$": 1800600,
    "address": "30 Powell St, Unit 1",
    "parcel_id": "041-09-03",
    "owner1": "LIPTON, JONATHAN & GALINA",
    "owner2": "",
    "current_taxes": 14803.21,
    "new_taxes_no_override": 15442.71,
    "override_total_1": 15880.88,
    "override_increase_1": 438.18
  },
  {
    "#": "30 Powell St, Unit 2 (041-09-01)",
    "$": 1892300,
    "address": "30 Powell St, Unit 2",
    "parcel_id": "041-09-01",
    "owner1": "KAZEROUNIAN, SOHROB",
    "owner2": "LEAVER, NICOLE",
    "current_taxes": 15742.22,
    "new_taxes_no_override": 16422.28,
    "override_total_1": 16888.25,
    "override_increase_1": 465.97
  },
  {
    "#": "30 Powell St, Unit 3 (041-09-02)",
    "$": 1864300,
    "address": "30 Powell St, Unit 3",
    "parcel_id": "041-09-02",
    "owner1": "KOSTER TRS, KARL F",
    "owner2": "HUEY, LINDLEY C",
    "current_taxes": 15455.5,
    "new_taxes_no_override": 16123.18,
    "override_total_1": 16580.66,
    "override_increase_1": 457.48
  },
  {
    "#": "32 Powell St (041-08-00)",
    "$": 2440500,
    "address": "32 Powell St",
    "parcel_id": "041-08-00",
    "owner1": "YEE TRS, YICK SUN & GEORGE S",
    "owner2": "",
    "current_taxes": 24990.72,
    "new_taxes_no_override": 26070.32,
    "override_total_1": 26810.04,
    "override_increase_1": 739.73
  },
  {
    "#": "33 Powell St (011-08-00)",
    "$": 3463400,
    "address": "33 Powell St",
    "parcel_id": "011-08-00",
    "owner1": "KANAREK TRS, DAVID J & ANNA C",
    "owner2": "",
    "current_taxes": 31830.28,
    "new_taxes_no_override": 33205.35,
    "override_total_1": 34147.52,
    "override_increase_1": 942.18
  },
  {
    "#": "41 Powell St (011-09-00)",
    "$": 3337000,
    "address": "41 Powell St",
    "parcel_id": "011-09-00",
    "owner1": "NOYES, FREDERICK",
    "owner2": "",
    "current_taxes": 30535.95,
    "new_taxes_no_override": 31855.1,
    "override_total_1": 32758.97,
    "override_increase_1": 903.86
  },
  {
    "#": "45 Powell St (011-10-00)",
    "$": 5189200,
    "address": "45 Powell St",
    "parcel_id": "011-10-00",
    "owner1": "GALVIN TR, SUSAN J",
    "owner2": "",
    "current_taxes": 49502.47,
    "new_taxes_no_override": 51640.98,
    "override_total_1": 53106.25,
    "override_increase_1": 1465.27
  },
  {
    "#": "46 Powell St (039-07-00)",
    "$": 4548800,
    "address": "46 Powell St",
    "parcel_id": "039-07-00",
    "owner1": "FITZHUGH, MICHAEL A",
    "owner2": "",
    "current_taxes": 42944.78,
    "new_taxes_no_override": 44799.99,
    "override_total_1": 46071.16,
    "override_increase_1": 1271.17
  },
  {
    "#": "53 Powell St (011-11-00)",
    "$": 4435200,
    "address": "53 Powell St",
    "parcel_id": "011-11-00",
    "owner1": "PARAFESTAS TR, ANASTASIOS",
    "owner2": "",
    "current_taxes": 45416.45,
    "new_taxes_no_override": 47378.44,
    "override_total_1": 48722.77,
    "override_increase_1": 1344.33
  },
  {
    "#": "54 Powell St (039-06-00)",
    "$": 3847800,
    "address": "54 Powell St",
    "parcel_id": "039-06-00",
    "owner1": "MEYER, NATHANIEL S & ERIN S",
    "owner2": "",
    "current_taxes": 39401.47,
    "new_taxes_no_override": 41103.61,
    "override_total_1": 42269.9,
    "override_increase_1": 1166.28
  },
  {
    "#": "60 Powell St, Unit 1 P-1A-1B (039-05-01)",
    "$": 1928600,
    "address": "60 Powell St, Unit 1 P-1A-1B",
    "parcel_id": "039-05-01",
    "owner1": "FALCK, ARTURO D",
    "owner2": "FREEDSON, JULIA",
    "current_taxes": 16113.93,
    "new_taxes_no_override": 16810.05,
    "override_total_1": 17287.02,
    "override_increase_1": 476.97
  },
  {
    "#": "60 Powell St, Unit 2 & P2A-2B (039-05-02)",
    "$": 2115800,
    "address": "60 Powell St, Unit 2 & P2A-2B",
    "parcel_id": "039-05-02",
    "owner1": "BLINDER TRS, ELLEN & RUSSELL",
    "owner2": "",
    "current_taxes": 18030.86,
    "new_taxes_no_override": 18809.79,
    "override_total_1": 19343.51,
    "override_increase_1": 533.71
  },
  {
    "#": "60 Powell St, Unit 3 & P3A-3B (039-05-03)",
    "$": 2465500,
    "address": "60 Powell St, Unit 3 & P3A-3B",
    "parcel_id": "039-05-03",
    "owner1": "TZAMELI, IPHIGENIA",
    "owner2": "PISSIOS, PAVLOS",
    "current_taxes": 21611.79,
    "new_taxes_no_override": 22545.42,
    "override_total_1": 23185.13,
    "override_increase_1": 639.71
  },
  {
    "#": "63 Powell St (011-12-00)",
    "$": 3713700,
    "address": "63 Powell St",
    "parcel_id": "011-12-00",
    "owner1": "FEINSTEIN, STEVEN",
    "owner2": "",
    "current_taxes": 34393.35,
    "new_taxes_no_override": 35879.14,
    "override_total_1": 36897.19,
    "override_increase_1": 1018.04
  },
  {
    "#": "65 Powell St (011-13-00)",
    "$": 1709000,
    "address": "65 Powell St",
    "parcel_id": "011-13-00",
    "owner1": "DHANDA TRS, RAJ K & NEENA G",
    "owner2": "",
    "current_taxes": 17500.16,
    "new_taxes_no_override": 18256.17,
    "override_total_1": 18774.17,
    "override_increase_1": 518.0
  },
  {
    "#": "66 Powell St (039-04-00)",
    "$": 2102900,
    "address": "66 Powell St",
    "parcel_id": "039-04-00",
    "owner1": "ALCALAY, LEOR",
    "owner2": "ZHANG, YU",
    "current_taxes": 21533.7,
    "new_taxes_no_override": 22463.96,
    "override_total_1": 23101.35,
    "override_increase_1": 637.4
  },
  {
    "#": "67 Powell St (011-14-00)",
    "$": 3145800,
    "address": "67 Powell St",
    "parcel_id": "011-14-00",
    "owner1": "DHANDA TRS, RAJ K & NEENA G",
    "owner2": "",
    "current_taxes": 32212.99,
    "new_taxes_no_override": 33604.59,
    "override_total_1": 34558.1,
    "override_increase_1": 953.5
  },
  {
    "#": "72 Powell St (039-03-00)",
    "$": 2615400,
    "address": "72 Powell St",
    "parcel_id": "039-03-00",
    "owner1": "ROBERTSHAW, BARBARA B",
    "owner2": "",
    "current_taxes": 23146.76,
    "new_taxes_no_override": 24146.7,
    "override_total_1": 24831.84,
    "override_increase_1": 685.14
  },
  {
    "#": "78 Powell St (039-02-00)",
    "$": 4314400,
    "address": "78 Powell St",
    "parcel_id": "039-02-00",
    "owner1": "BRITTON TR, DANIEL E",
    "owner2": "",
    "current_taxes": 40544.52,
    "new_taxes_no_override": 42296.04,
    "override_total_1": 43496.16,
    "override_increase_1": 1200.12
  },
  {
    "#": "81 Powell St (011-15-00)",
    "$": 1584100,
    "address": "81 Powell St",
    "parcel_id": "011-15-00",
    "owner1": "DHANDA TRS, RAJ K & NEENA G",
    "owner2": "",
    "current_taxes": 16221.18,
    "new_taxes_no_override": 16921.93,
    "override_total_1": 17402.08,
    "override_increase_1": 480.15
  },
  {
    "#": "86 Powell St (039-01-00)",
    "$": 3474800,
    "address": "86 Powell St",
    "parcel_id": "039-01-00",
    "owner1": "LIBERMAN TR, DAVID",
    "owner2": "",
    "current_taxes": 31947.02,
    "new_taxes_no_override": 33327.13,
    "override_total_1": 34272.76,
    "override_increase_1": 945.63
  },
  {
    "#": "9 Prescott St (008-01-00)",
    "$": 8965000,
    "address": "9 Prescott St",
    "parcel_id": "008-01-00",
    "owner1": "NEW ENGLAND HEBREW ACADEMY",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "16 Prescott St (004-01-00)",
    "$": 8846600,
    "address": "16 Prescott St",
    "parcel_id": "004-01-00",
    "owner1": "DE ICAZA TRS, MIGUEL & MARIA LAURA",
    "owner2": "",
    "current_taxes": 90589.18,
    "new_taxes_no_override": 94502.63,
    "override_total_1": 97184.07,
    "override_increase_1": 2681.44
  },
  {
    "#": "23 Prescott St (008-02-05)",
    "$": 12315900,
    "address": "23 Prescott St",
    "parcel_id": "008-02-05",
    "owner1": "COLASACCO, TR, DOMENIC",
    "owner2": "",
    "current_taxes": 126114.82,
    "new_taxes_no_override": 131562.98,
    "override_total_1": 135295.98,
    "override_increase_1": 3733.0
  },
  {
    "#": "30 Prescott St (003-03-00)",
    "$": 5698600,
    "address": "30 Prescott St",
    "parcel_id": "003-03-00",
    "owner1": "GLASHOW TRS, SHELDON L & JOAN A",
    "owner2": "",
    "current_taxes": 54718.73,
    "new_taxes_no_override": 57082.58,
    "override_total_1": 58702.25,
    "override_increase_1": 1619.67
  },
  {
    "#": "35 Prescott St (008-03-00)",
    "$": 3675500,
    "address": "35 Prescott St",
    "parcel_id": "008-03-00",
    "owner1": "WILLIAMS, STEPHEN A & SUSAN H",
    "owner2": "",
    "current_taxes": 34002.19,
    "new_taxes_no_override": 35471.08,
    "override_total_1": 36477.55,
    "override_increase_1": 1006.46
  },
  {
    "#": "40 Prescott St (003-02-00)",
    "$": 5944000,
    "address": "40 Prescott St",
    "parcel_id": "003-02-00",
    "owner1": "BURNS, JAMES",
    "owner2": "",
    "current_taxes": 57231.63,
    "new_taxes_no_override": 59704.04,
    "override_total_1": 61398.09,
    "override_increase_1": 1694.06
  },
  {
    "#": "8 Prince St (317-45-00)",
    "$": 2194700,
    "address": "8 Prince St",
    "parcel_id": "317-45-00",
    "owner1": "WHITE, ANTHONY G & MARTHA J L",
    "owner2": "",
    "current_taxes": 18838.79,
    "new_taxes_no_override": 19652.63,
    "override_total_1": 20210.25,
    "override_increase_1": 557.63
  },
  {
    "#": "11 Prince St (316A-10-00)",
    "$": 1487700,
    "address": "11 Prince St",
    "parcel_id": "316A-10-00",
    "owner1": "ALLEN, ET AL, JONATHAN C",
    "owner2": "QUIGLEY, MELANIE A",
    "current_taxes": 11599.11,
    "new_taxes_no_override": 12100.19,
    "override_total_1": 12443.53,
    "override_increase_1": 343.33
  },
  {
    "#": "12 Prince St, Unit 1 (317-44-01)",
    "$": 1208500,
    "address": "12 Prince St, Unit 1",
    "parcel_id": "317-44-01",
    "owner1": "JOHNSON, JEFFREY & ABBY",
    "owner2": "",
    "current_taxes": 8740.11,
    "new_taxes_no_override": 9117.68,
    "override_total_1": 9376.39,
    "override_increase_1": 258.71
  },
  {
    "#": "12 Prince St, Unit 2 (317-44-02)",
    "$": 978800,
    "address": "12 Prince St, Unit 2",
    "parcel_id": "317-44-02",
    "owner1": "BEASLEY, ERIC & KARA",
    "owner2": "",
    "current_taxes": 6387.98,
    "new_taxes_no_override": 6663.94,
    "override_total_1": 6853.02,
    "override_increase_1": 189.08
  },
  {
    "#": "15 Prince St (316A-11-00)",
    "$": 1504100,
    "address": "15 Prince St",
    "parcel_id": "316A-11-00",
    "owner1": "FLOOD LIFE ESTATE, JOHN F & MARGARET",
    "owner2": "",
    "current_taxes": 11767.05,
    "new_taxes_no_override": 12275.39,
    "override_total_1": 12623.69,
    "override_increase_1": 348.3
  },
  {
    "#": "16 Prince St, Unit 1 (317-43-01)",
    "$": 981700,
    "address": "16 Prince St, Unit 1",
    "parcel_id": "317-43-01",
    "owner1": "XYPTERAS, GEORGE P",
    "owner2": "",
    "current_taxes": 10052.61,
    "new_taxes_no_override": 10486.88,
    "override_total_1": 10784.44,
    "override_increase_1": 297.56
  },
  {
    "#": "16 Prince St, Unit 2 (317-43-02)",
    "$": 998400,
    "address": "16 Prince St, Unit 2",
    "parcel_id": "317-43-02",
    "owner1": "MOUTSOURIS, DESPINA",
    "owner2": "",
    "current_taxes": 10223.62,
    "new_taxes_no_override": 10665.28,
    "override_total_1": 10967.9,
    "override_increase_1": 302.62
  },
  {
    "#": "19 Prince St, Unit 1 (316A-12-03)",
    "$": 696900,
    "address": "19 Prince St, Unit 1",
    "parcel_id": "316A-12-03",
    "owner1": "HARSCH, MICHAEL FRIEDRICH",
    "owner2": "BRULE, RACHEL ESTHER",
    "current_taxes": 7136.26,
    "new_taxes_no_override": 7444.55,
    "override_total_1": 7655.78,
    "override_increase_1": 211.23
  },
  {
    "#": "19 Prince St, Unit 2 (316A-12-04)",
    "$": 991200,
    "address": "19 Prince St, Unit 2",
    "parcel_id": "316A-12-04",
    "owner1": "PERLOVSKY, BORIS",
    "owner2": "",
    "current_taxes": 6514.95,
    "new_taxes_no_override": 6796.4,
    "override_total_1": 6989.24,
    "override_increase_1": 192.84
  },
  {
    "#": "25 Prince St (316A-12-02)",
    "$": 600,
    "address": "25 Prince St",
    "parcel_id": "316A-12-02",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O VACANT PARCEL/ABUT 39 PRINCE",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "32 Prince St (317-42-00)",
    "$": 1978700,
    "address": "32 Prince St",
    "parcel_id": "317-42-00",
    "owner1": "KCEKOB LLC",
    "owner2": "",
    "current_taxes": 20261.89,
    "new_taxes_no_override": 21137.2,
    "override_total_1": 21736.96,
    "override_increase_1": 599.75
  },
  {
    "#": "39 Prince St, Unit 1 & Pk A (316A-13-01)",
    "$": 655600,
    "address": "39 Prince St, Unit 1 & Pk A",
    "parcel_id": "316A-13-01",
    "owner1": "HEFFRON, JAMES & ELIZABETH",
    "owner2": "",
    "current_taxes": 3078.41,
    "new_taxes_no_override": 3211.4,
    "override_total_1": 3302.52,
    "override_increase_1": 91.12
  },
  {
    "#": "39 Prince St, Unit 2 & P-C (316A-13-02)",
    "$": 654400,
    "address": "39 Prince St, Unit 2 & P-C",
    "parcel_id": "316A-13-02",
    "owner1": "RAO, NARAVANA N & SHYAMALA N",
    "owner2": "",
    "current_taxes": 6701.06,
    "new_taxes_no_override": 6990.55,
    "override_total_1": 7188.9,
    "override_increase_1": 198.35
  },
  {
    "#": "39 Prince St, Unit 3 & P-B (316A-13-03)",
    "$": 654400,
    "address": "39 Prince St, Unit 3 & P-B",
    "parcel_id": "316A-13-03",
    "owner1": "TORRES, ALMA D",
    "owner2": "BALANZAR, JESUS",
    "current_taxes": 3066.12,
    "new_taxes_no_override": 3198.58,
    "override_total_1": 3289.33,
    "override_increase_1": 90.76
  },
  {
    "#": "42 Prince St (317-41-00)",
    "$": 1252700,
    "address": "42 Prince St",
    "parcel_id": "317-41-00",
    "owner1": "LONDERGAN, ROBERT F",
    "owner2": "",
    "current_taxes": 9192.71,
    "new_taxes_no_override": 9589.84,
    "override_total_1": 9861.94,
    "override_increase_1": 272.1
  },
  {
    "#": "43 Prince St, Unit 1 (316A-14-01)",
    "$": 793300,
    "address": "43 Prince St, Unit 1",
    "parcel_id": "316A-14-01",
    "owner1": "EMERICK TRS, JASON NEAL",
    "owner2": "EVIA, KRISTINE ENRIQUEZ",
    "current_taxes": 8123.39,
    "new_taxes_no_override": 8474.32,
    "override_total_1": 8714.77,
    "override_increase_1": 240.45
  },
  {
    "#": "43 Prince St, Unit 2 (316A-14-02)",
    "$": 777400,
    "address": "43 Prince St, Unit 2",
    "parcel_id": "316A-14-02",
    "owner1": "DAL CIN, PAOLA",
    "owner2": "",
    "current_taxes": 7960.58,
    "new_taxes_no_override": 8304.48,
    "override_total_1": 8540.11,
    "override_increase_1": 235.63
  },
  {
    "#": "43 Prince St, Unit 3 (316A-14-03)",
    "$": 1062900,
    "address": "43 Prince St, Unit 3",
    "parcel_id": "316A-14-03",
    "owner1": "MINNELLA, GIANLUCA",
    "owner2": "",
    "current_taxes": 7249.16,
    "new_taxes_no_override": 7562.32,
    "override_total_1": 7776.9,
    "override_increase_1": 214.58
  },
  {
    "#": "49 Prince St, Unit 1 (316A-15-01)",
    "$": 627200,
    "address": "49 Prince St, Unit 1",
    "parcel_id": "316A-15-01",
    "owner1": "HOPKE, JOERN N",
    "owner2": "PARK, SUNG HAE",
    "current_taxes": 6422.53,
    "new_taxes_no_override": 6699.98,
    "override_total_1": 6890.09,
    "override_increase_1": 190.11
  },
  {
    "#": "49 Prince St, Unit 2 (316A-15-02)",
    "$": 654500,
    "address": "49 Prince St, Unit 2",
    "parcel_id": "316A-15-02",
    "owner1": "LAVERTY, MELISSA & LUKE",
    "owner2": "",
    "current_taxes": 6702.08,
    "new_taxes_no_override": 6991.61,
    "override_total_1": 7189.99,
    "override_increase_1": 198.38
  },
  {
    "#": "49 Prince St, Unit 3 (316A-15-03)",
    "$": 694200,
    "address": "49 Prince St, Unit 3",
    "parcel_id": "316A-15-03",
    "owner1": "LOBOVITS TR, ALAN M",
    "owner2": "ROSENFELD TR, LISA",
    "current_taxes": 7108.61,
    "new_taxes_no_override": 7415.7,
    "override_total_1": 7626.12,
    "override_increase_1": 210.41
  },
  {
    "#": "52 Prince St, Unit 1 (317-40-01)",
    "$": 671700,
    "address": "52 Prince St, Unit 1",
    "parcel_id": "317-40-01",
    "owner1": "DEAN, PAUL J",
    "owner2": "MILLER, DOROTA A",
    "current_taxes": 3243.27,
    "new_taxes_no_override": 3383.38,
    "override_total_1": 3479.38,
    "override_increase_1": 96.0
  },
  {
    "#": "52 Prince St, Unit 2 (317-40-02)",
    "$": 940800,
    "address": "52 Prince St, Unit 2",
    "parcel_id": "317-40-02",
    "owner1": "TAYLOR, JASON C",
    "owner2": "",
    "current_taxes": 9633.79,
    "new_taxes_no_override": 10049.97,
    "override_total_1": 10335.13,
    "override_increase_1": 285.16
  },
  {
    "#": "53 Prince St (316A-16-00)",
    "$": 1739600,
    "address": "53 Prince St",
    "parcel_id": "316A-16-00",
    "owner1": "SPUNT, NATHAN & EMILY F",
    "owner2": "",
    "current_taxes": 17813.5,
    "new_taxes_no_override": 18583.04,
    "override_total_1": 19110.32,
    "override_increase_1": 527.28
  },
  {
    "#": "58 Prince St, Unit 1 (317-39-01)",
    "$": 713400,
    "address": "58 Prince St, Unit 1",
    "parcel_id": "317-39-01",
    "owner1": "SHAO, YUE",
    "owner2": "WANG, YUE",
    "current_taxes": 7305.22,
    "new_taxes_no_override": 7620.81,
    "override_total_1": 7837.04,
    "override_increase_1": 216.23
  },
  {
    "#": "58 Prince St, Unit 2 (317-39-02)",
    "$": 752000,
    "address": "58 Prince St, Unit 2",
    "parcel_id": "317-39-02",
    "owner1": "LIU, HSIOU- YUAN",
    "owner2": "",
    "current_taxes": 4065.55,
    "new_taxes_no_override": 4241.18,
    "override_total_1": 4361.52,
    "override_increase_1": 120.34
  },
  {
    "#": "58 Prince St, Unit 3 (317-39-03)",
    "$": 863500,
    "address": "58 Prince St, Unit 3",
    "parcel_id": "317-39-03",
    "owner1": "CATLIN, ANN",
    "owner2": "",
    "current_taxes": 5207.31,
    "new_taxes_no_override": 5432.27,
    "override_total_1": 5586.4,
    "override_increase_1": 154.14
  },
  {
    "#": "59 Prince St (316A-17-00)",
    "$": 1718300,
    "address": "59 Prince St",
    "parcel_id": "316A-17-00",
    "owner1": "LEE, HANMIN",
    "owner2": "",
    "current_taxes": 17595.39,
    "new_taxes_no_override": 18355.51,
    "override_total_1": 18876.33,
    "override_increase_1": 520.82
  },
  {
    "#": "61 Prince St, Unit 61-1 & P2 (316A-19-04)",
    "$": 581200,
    "address": "61 Prince St, Unit 61-1 & P2",
    "parcel_id": "316A-19-04",
    "owner1": "BOYER, ARLENE",
    "owner2": "",
    "current_taxes": 2316.55,
    "new_taxes_no_override": 2416.62,
    "override_total_1": 2485.19,
    "override_increase_1": 68.57
  },
  {
    "#": "61 Prince St, Unit 61-2 & P3 (316A-19-05)",
    "$": 649200,
    "address": "61 Prince St, Unit 61-2 & P3",
    "parcel_id": "316A-19-05",
    "owner1": "HONG, WONHO M & TATIANA",
    "owner2": "",
    "current_taxes": 3012.87,
    "new_taxes_no_override": 3143.03,
    "override_total_1": 3232.21,
    "override_increase_1": 89.18
  },
  {
    "#": "61 Prince St, Unit 61-3 Pk Sp (316A-19-06)",
    "$": 1071300,
    "address": "61 Prince St, Unit 61-3 Pk Sp",
    "parcel_id": "316A-19-06",
    "owner1": "GORDON, MICHAEL W & SOPHIE E",
    "owner2": "",
    "current_taxes": 7335.18,
    "new_taxes_no_override": 7652.06,
    "override_total_1": 7869.18,
    "override_increase_1": 217.12
  },
  {
    "#": "11 Princeton Rd (410-15-00)",
    "$": 2944700,
    "address": "11 Princeton Rd",
    "parcel_id": "410-15-00",
    "owner1": "NEVINS, MARC L & STACEY F",
    "owner2": "",
    "current_taxes": 26518.79,
    "new_taxes_no_override": 27664.4,
    "override_total_1": 28449.36,
    "override_increase_1": 784.96
  },
  {
    "#": "14 Princeton Rd (408-06-00)",
    "$": 2526400,
    "address": "14 Princeton Rd",
    "parcel_id": "408-06-00",
    "owner1": "SHYN TR, PAUL B",
    "owner2": "",
    "current_taxes": 25870.34,
    "new_taxes_no_override": 26987.94,
    "override_total_1": 27753.7,
    "override_increase_1": 765.76
  },
  {
    "#": "21 Princeton Rd (410-14-00)",
    "$": 4610700,
    "address": "21 Princeton Rd",
    "parcel_id": "410-14-00",
    "owner1": "SHAHANI TRS, SHALINI JEETENDRA & JEETENDRA OMPRAKASH",
    "owner2": "",
    "current_taxes": 43578.63,
    "new_taxes_no_override": 45461.23,
    "override_total_1": 46751.15,
    "override_increase_1": 1289.93
  },
  {
    "#": "22 Princeton Rd (408-05-00)",
    "$": 2105100,
    "address": "22 Princeton Rd",
    "parcel_id": "408-05-00",
    "owner1": "SCHWARTZ TRS, FRANCES & DAVID A & JEFFERY G & HOWARD E & MARC R",
    "owner2": "",
    "current_taxes": 17921.29,
    "new_taxes_no_override": 18695.49,
    "override_total_1": 19225.96,
    "override_increase_1": 530.47
  },
  {
    "#": "29 Princeton Rd (410-13-00)",
    "$": 2708400,
    "address": "29 Princeton Rd",
    "parcel_id": "410-13-00",
    "owner1": "JACOBS, FREDERIC H & SUSAN J",
    "owner2": "",
    "current_taxes": 24099.08,
    "new_taxes_no_override": 25140.16,
    "override_total_1": 25853.49,
    "override_increase_1": 713.33
  },
  {
    "#": "30 Princeton Rd (408-04-00)",
    "$": 3053200,
    "address": "30 Princeton Rd",
    "parcel_id": "408-04-00",
    "owner1": "LEE, BERNARD & BRITT",
    "owner2": "",
    "current_taxes": 27629.83,
    "new_taxes_no_override": 28823.44,
    "override_total_1": 29641.28,
    "override_increase_1": 817.84
  },
  {
    "#": "40 Princeton Rd (408-03-00)",
    "$": 2187400,
    "address": "40 Princeton Rd",
    "parcel_id": "408-03-00",
    "owner1": "LAU TR, TECK CHYE",
    "owner2": "WONG TR, JOYCE YUN-WEI",
    "current_taxes": 18764.04,
    "new_taxes_no_override": 19574.65,
    "override_total_1": 20130.06,
    "override_increase_1": 555.42
  },
  {
    "#": "49 Princeton Rd (409-10-00)",
    "$": 2951600,
    "address": "49 Princeton Rd",
    "parcel_id": "409-10-00",
    "owner1": "SKLAR, JEFFREY L",
    "owner2": "NASH, VIVIAN C",
    "current_taxes": 26589.45,
    "new_taxes_no_override": 27738.11,
    "override_total_1": 28525.16,
    "override_increase_1": 787.05
  },
  {
    "#": "50 Princeton Rd (408-02-00)",
    "$": 1754800,
    "address": "50 Princeton Rd",
    "parcel_id": "408-02-00",
    "owner1": "WEINSTEIN TRS, MILTON C & RHONDA K",
    "owner2": "",
    "current_taxes": 14334.22,
    "new_taxes_no_override": 14953.46,
    "override_total_1": 15377.75,
    "override_increase_1": 424.29
  },
  {
    "#": "59 Princeton Rd (409-13-00)",
    "$": 2647800,
    "address": "59 Princeton Rd",
    "parcel_id": "409-13-00",
    "owner1": "ANEJA, ARUN & UDITA",
    "owner2": "",
    "current_taxes": 23478.54,
    "new_taxes_no_override": 24492.81,
    "override_total_1": 25187.78,
    "override_increase_1": 694.96
  },
  {
    "#": "60 Princeton Rd (408-01-00)",
    "$": 3581600,
    "address": "60 Princeton Rd",
    "parcel_id": "408-01-00",
    "owner1": "SHI TR, PARKER L",
    "owner2": "",
    "current_taxes": 33040.65,
    "new_taxes_no_override": 34468.01,
    "override_total_1": 35446.01,
    "override_increase_1": 978.0
  },
  {
    "#": "69 Princeton Rd (409-14-00)",
    "$": 4041700,
    "address": "69 Princeton Rd",
    "parcel_id": "409-14-00",
    "owner1": "KUDSI, OMAR YUSEF",
    "owner2": "",
    "current_taxes": 37752.07,
    "new_taxes_no_override": 39382.96,
    "override_total_1": 40500.42,
    "override_increase_1": 1117.46
  },
  {
    "#": "70 Princeton Rd (408-21-00)",
    "$": 3209000,
    "address": "70 Princeton Rd",
    "parcel_id": "408-21-00",
    "owner1": "DIALANI, VANDANA & MUKESH",
    "owner2": "",
    "current_taxes": 29225.23,
    "new_taxes_no_override": 30487.76,
    "override_total_1": 31352.83,
    "override_increase_1": 865.07
  },
  {
    "#": "79 Princeton Rd (409-01-01)",
    "$": 3009500,
    "address": "79 Princeton Rd",
    "parcel_id": "409-01-01",
    "owner1": "FISCH, STEVEN H & RACHEL N",
    "owner2": "",
    "current_taxes": 27182.35,
    "new_taxes_no_override": 28356.63,
    "override_total_1": 29161.23,
    "override_increase_1": 804.6
  },
  {
    "#": "101 Princeton Rd (406-02-00)",
    "$": 2829100,
    "address": "101 Princeton Rd",
    "parcel_id": "406-02-00",
    "owner1": "KAPLAN, LAWRENCE E",
    "owner2": "",
    "current_taxes": 25335.05,
    "new_taxes_no_override": 26429.52,
    "override_total_1": 27179.44,
    "override_increase_1": 749.92
  },
  {
    "#": "102 Princeton Rd (405-12-00)",
    "$": 2868900,
    "address": "102 Princeton Rd",
    "parcel_id": "405-12-00",
    "owner1": "GIACCHETTI, ROBERT",
    "owner2": "JOHNSON, LAURA",
    "current_taxes": 25742.6,
    "new_taxes_no_override": 26854.68,
    "override_total_1": 27616.66,
    "override_increase_1": 761.98
  },
  {
    "#": "110 Princeton Rd (405-13-00)",
    "$": 2270700,
    "address": "110 Princeton Rd",
    "parcel_id": "405-13-00",
    "owner1": "TRAYNOR TRS, RONNEY M & STEPHEN G",
    "owner2": "",
    "current_taxes": 19617.03,
    "new_taxes_no_override": 20464.49,
    "override_total_1": 21045.15,
    "override_increase_1": 580.66
  },
  {
    "#": "111 Princeton Rd (406-03-00)",
    "$": 2234600,
    "address": "111 Princeton Rd",
    "parcel_id": "406-03-00",
    "owner1": "WAGNER TRS, GERHARD & ELISABETH",
    "owner2": "ELISABETH WAGNER REVOCABLE TRUST",
    "current_taxes": 19247.37,
    "new_taxes_no_override": 20078.86,
    "override_total_1": 20648.58,
    "override_increase_1": 569.72
  },
  {
    "#": "118 Princeton Rd (405-14-00)",
    "$": 2452100,
    "address": "118 Princeton Rd",
    "parcel_id": "405-14-00",
    "owner1": "SHAW, GREGORY R",
    "owner2": "",
    "current_taxes": 21474.57,
    "new_taxes_no_override": 22402.27,
    "override_total_1": 23037.92,
    "override_increase_1": 635.65
  },
  {
    "#": "121 Princeton Rd (406-04-00)",
    "$": 2339000,
    "address": "121 Princeton Rd",
    "parcel_id": "406-04-00",
    "owner1": "NALVEN TRS, DAVID S",
    "owner2": "GOLDMAN , JILL",
    "current_taxes": 23951.36,
    "new_taxes_no_override": 24986.06,
    "override_total_1": 25695.02,
    "override_increase_1": 708.96
  },
  {
    "#": "128 Princeton Rd (405-15-00)",
    "$": 2145100,
    "address": "128 Princeton Rd",
    "parcel_id": "405-15-00",
    "owner1": "WILLIAMS, ZIV & SHIRLEY",
    "owner2": "",
    "current_taxes": 18330.89,
    "new_taxes_no_override": 19122.78,
    "override_total_1": 19665.38,
    "override_increase_1": 542.59
  },
  {
    "#": "140 Princeton Rd (404-05-01)",
    "$": 1653600,
    "address": "140 Princeton Rd",
    "parcel_id": "404-05-01",
    "owner1": "SHEINKOPF, LINDA J",
    "owner2": "",
    "current_taxes": 13297.93,
    "new_taxes_no_override": 13872.4,
    "override_total_1": 14266.02,
    "override_increase_1": 393.62
  },
  {
    "#": "145 Princeton Rd (407-12-00)",
    "$": 3033100,
    "address": "145 Princeton Rd",
    "parcel_id": "407-12-00",
    "owner1": "GRIFFIN TRS, MARILYN P",
    "owner2": "JOHNSON, RICHARD J",
    "current_taxes": 27424.01,
    "new_taxes_no_override": 28608.73,
    "override_total_1": 29420.48,
    "override_increase_1": 811.75
  },
  {
    "#": "150 Princeton Rd (404-06-00)",
    "$": 5739700,
    "address": "150 Princeton Rd",
    "parcel_id": "404-06-00",
    "owner1": "PLUMP, ANDREW S & SUZANNE D",
    "owner2": "",
    "current_taxes": 55139.59,
    "new_taxes_no_override": 57521.62,
    "override_total_1": 59153.75,
    "override_increase_1": 1632.13
  },
  {
    "#": "159 Princeton Rd (407-13-00)",
    "$": 88200,
    "address": "159 Princeton Rd",
    "parcel_id": "407-13-00",
    "owner1": "GRIFFIN TRS, MARILYN P",
    "owner2": "JOHNSON, RICHARD J",
    "current_taxes": 903.17,
    "new_taxes_no_override": 942.19,
    "override_total_1": 968.92,
    "override_increase_1": 26.73
  },
  {
    "#": "160 Princeton Rd (404-07-00)",
    "$": 5413300,
    "address": "160 Princeton Rd",
    "parcel_id": "404-07-00",
    "owner1": "SHEINKOPF, TODD A & CLAUDINE I",
    "owner2": "",
    "current_taxes": 55432.19,
    "new_taxes_no_override": 57826.86,
    "override_total_1": 59467.65,
    "override_increase_1": 1640.79
  },
  {
    "#": "167 Princeton Rd (407-14-00)",
    "$": 169600,
    "address": "167 Princeton Rd",
    "parcel_id": "407-14-00",
    "owner1": "GALLAGHER TRS, JOHN & EILEEN",
    "owner2": "",
    "current_taxes": 1736.7,
    "new_taxes_no_override": 1811.73,
    "override_total_1": 1863.13,
    "override_increase_1": 51.41
  },
  {
    "#": " Princeton Rd (405-14-01)",
    "$": 149600,
    "address": " Princeton Rd",
    "parcel_id": "405-14-01",
    "owner1": "GIACCHETTI, ROBERT",
    "owner2": "JOHNSON, LAURA",
    "current_taxes": 1531.9,
    "new_taxes_no_override": 1598.08,
    "override_total_1": 1643.42,
    "override_increase_1": 45.34
  },
  {
    "#": "9 Puddingstone Rd (375A-02-00)",
    "$": 1420500,
    "address": "9 Puddingstone Rd",
    "parcel_id": "375A-02-00",
    "owner1": "BAMBERG, JOSEPH",
    "owner2": "LEE, JENNIFER",
    "current_taxes": 10910.99,
    "new_taxes_no_override": 11382.34,
    "override_total_1": 11705.31,
    "override_increase_1": 322.97
  },
  {
    "#": "15 Puddingstone Rd (375A-03-00)",
    "$": 1178200,
    "address": "15 Puddingstone Rd",
    "parcel_id": "375A-03-00",
    "owner1": "LEE, GAIL G",
    "owner2": "",
    "current_taxes": 8429.83,
    "new_taxes_no_override": 8794.0,
    "override_total_1": 9043.52,
    "override_increase_1": 249.52
  },
  {
    "#": "19 Puddingstone Rd (375A-04-00)",
    "$": 1597200,
    "address": "19 Puddingstone Rd",
    "parcel_id": "375A-04-00",
    "owner1": "MICKELSON, KURT W & DONNA C",
    "owner2": "",
    "current_taxes": 12720.39,
    "new_taxes_no_override": 13269.91,
    "override_total_1": 13646.43,
    "override_increase_1": 376.52
  },
  {
    "#": "25 Puddingstone Rd (375A-05-00)",
    "$": 1868800,
    "address": "25 Puddingstone Rd",
    "parcel_id": "375A-05-00",
    "owner1": "RODRIGUEZ, JUAN P & ELIZABETH",
    "owner2": "",
    "current_taxes": 15501.58,
    "new_taxes_no_override": 16171.25,
    "override_total_1": 16630.1,
    "override_increase_1": 458.85
  },
  {
    "#": "7 Randolph Rd (434-03-00)",
    "$": 1324400,
    "address": "7 Randolph Rd",
    "parcel_id": "434-03-00",
    "owner1": "DEOCAREZA, EDMUNDO D",
    "owner2": "LIM, LANIE R",
    "current_taxes": 9926.92,
    "new_taxes_no_override": 10355.76,
    "override_total_1": 10649.6,
    "override_increase_1": 293.84
  },
  {
    "#": "15 Randolph Rd (434-04-00)",
    "$": 1576200,
    "address": "15 Randolph Rd",
    "parcel_id": "434-04-00",
    "owner1": "BIGIO, IRVING J & RUTH",
    "owner2": "",
    "current_taxes": 12505.35,
    "new_taxes_no_override": 13045.58,
    "override_total_1": 13415.74,
    "override_increase_1": 370.16
  },
  {
    "#": "20 Randolph Rd (436-01-02)",
    "$": 4254900,
    "address": "20 Randolph Rd",
    "parcel_id": "436-01-02",
    "owner1": "CHALETZKY, STEPHEN E",
    "owner2": "PETERS, ELEANOR P",
    "current_taxes": 39935.24,
    "new_taxes_no_override": 41660.44,
    "override_total_1": 42842.53,
    "override_increase_1": 1182.08
  },
  {
    "#": "29 Randolph Rd (435-03-00)",
    "$": 3207800,
    "address": "29 Randolph Rd",
    "parcel_id": "435-03-00",
    "owner1": "POGORELEC, JASON P & ALEXANDRA S",
    "owner2": "",
    "current_taxes": 29212.94,
    "new_taxes_no_override": 30474.94,
    "override_total_1": 31339.64,
    "override_increase_1": 864.7
  },
  {
    "#": "37 Randolph Rd (435-04-00)",
    "$": 2635300,
    "address": "37 Randolph Rd",
    "parcel_id": "435-04-00",
    "owner1": "CHEN, YIAN",
    "owner2": "ZHANG, LU",
    "current_taxes": 26985.47,
    "new_taxes_no_override": 28151.24,
    "override_total_1": 28950.01,
    "override_increase_1": 798.77
  },
  {
    "#": "38 Randolph Rd (436-09-10)",
    "$": 4239900,
    "address": "38 Randolph Rd",
    "parcel_id": "436-09-10",
    "owner1": "APPLETON, THOMAS R & MONIQUE M",
    "owner2": "",
    "current_taxes": 39781.64,
    "new_taxes_no_override": 41500.21,
    "override_total_1": 42677.74,
    "override_increase_1": 1177.54
  },
  {
    "#": "45 Randolph Rd (435-05-00)",
    "$": 2723700,
    "address": "45 Randolph Rd",
    "parcel_id": "435-05-00",
    "owner1": "SADLER TRS, MONICA S",
    "owner2": "SILVIAN, DAVID L",
    "current_taxes": 24255.75,
    "new_taxes_no_override": 25303.6,
    "override_total_1": 26021.57,
    "override_increase_1": 717.97
  },
  {
    "#": "51 Randolph Rd (435-07-00)",
    "$": 2303500,
    "address": "51 Randolph Rd",
    "parcel_id": "435-07-00",
    "owner1": "DEAK, HOLLY LYNN",
    "owner2": "LA, DANIEL SEUNGDUK",
    "current_taxes": 19952.91,
    "new_taxes_no_override": 20814.88,
    "override_total_1": 21405.48,
    "override_increase_1": 590.61
  },
  {
    "#": "58 Randolph Rd (436-08-00)",
    "$": 3194300,
    "address": "58 Randolph Rd",
    "parcel_id": "436-08-00",
    "owner1": "KATZ, BENJAMIN L",
    "owner2": "DWYER, LAUREN",
    "current_taxes": 29074.7,
    "new_taxes_no_override": 30330.73,
    "override_total_1": 31191.34,
    "override_increase_1": 860.61
  },
  {
    "#": "59 Randolph Rd (435-08-00)",
    "$": 2632300,
    "address": "59 Randolph Rd",
    "parcel_id": "435-08-00",
    "owner1": "LEVIN TRS, ERIC",
    "owner2": "FINEBERG TR, MICHELLE R",
    "current_taxes": 23319.82,
    "new_taxes_no_override": 24327.24,
    "override_total_1": 25017.5,
    "override_increase_1": 690.27
  },
  {
    "#": "69 Randolph Rd (435-09-00)",
    "$": 4609500,
    "address": "69 Randolph Rd",
    "parcel_id": "435-09-00",
    "owner1": "MORRISON, JAMES STEPHEN",
    "owner2": "BOWMAN, ARTHUR J III",
    "current_taxes": 47201.28,
    "new_taxes_no_override": 49240.38,
    "override_total_1": 50637.53,
    "override_increase_1": 1397.16
  },
  {
    "#": "70 Randolph Rd (437-71-00)",
    "$": 4031100,
    "address": "70 Randolph Rd",
    "parcel_id": "437-71-00",
    "owner1": "MALLOY, JOHN P & ELIZABETH B",
    "owner2": "",
    "current_taxes": 41278.46,
    "new_taxes_no_override": 43061.69,
    "override_total_1": 44283.53,
    "override_increase_1": 1221.84
  },
  {
    "#": "78 Randolph Rd (437-70-00)",
    "$": 4855800,
    "address": "78 Randolph Rd",
    "parcel_id": "437-70-00",
    "owner1": "VON ANDRIAN, ULRICH H & LAILA",
    "owner2": "",
    "current_taxes": 46088.46,
    "new_taxes_no_override": 48079.48,
    "override_total_1": 49443.7,
    "override_increase_1": 1364.22
  },
  {
    "#": "79 Randolph Rd (435-10-00)",
    "$": 2349900,
    "address": "79 Randolph Rd",
    "parcel_id": "435-10-00",
    "owner1": "TRIVELLA, MATTHEW A & HAILEY Y",
    "owner2": "",
    "current_taxes": 24062.98,
    "new_taxes_no_override": 25102.5,
    "override_total_1": 25814.76,
    "override_increase_1": 712.26
  },
  {
    "#": "86 Randolph Rd (437-69-00)",
    "$": 4271700,
    "address": "86 Randolph Rd",
    "parcel_id": "437-69-00",
    "owner1": "CANTWELL, RICHARD J",
    "owner2": "CHU, NATALIE",
    "current_taxes": 40107.27,
    "new_taxes_no_override": 41839.9,
    "override_total_1": 43027.08,
    "override_increase_1": 1187.18
  },
  {
    "#": "5 Rangeley Rd (410-12-00)",
    "$": 2906400,
    "address": "5 Rangeley Rd",
    "parcel_id": "410-12-00",
    "owner1": "GRODSTEIN, FRANCINE",
    "owner2": "",
    "current_taxes": 26126.6,
    "new_taxes_no_override": 27255.27,
    "override_total_1": 28028.62,
    "override_increase_1": 773.35
  },
  {
    "#": "14 Rangeley Rd (409-09-00)",
    "$": 2369300,
    "address": "14 Rangeley Rd",
    "parcel_id": "409-09-00",
    "owner1": "GARBAN, AUREL & GWEN",
    "owner2": "",
    "current_taxes": 20626.7,
    "new_taxes_no_override": 21517.77,
    "override_total_1": 22128.32,
    "override_increase_1": 610.55
  },
  {
    "#": "15 Rangeley Rd (410-11-00)",
    "$": 2779900,
    "address": "15 Rangeley Rd",
    "parcel_id": "410-11-00",
    "owner1": "BREHM, WILLIAM J & GERALDINE P",
    "owner2": "",
    "current_taxes": 24831.24,
    "new_taxes_no_override": 25903.95,
    "override_total_1": 26638.95,
    "override_increase_1": 735.0
  },
  {
    "#": "21 Rangeley Rd (410-10-00)",
    "$": 2319700,
    "address": "21 Rangeley Rd",
    "parcel_id": "410-10-00",
    "owner1": "PUTHUSSERY, SHAJU & SUJATA",
    "owner2": "",
    "current_taxes": 20118.79,
    "new_taxes_no_override": 20987.92,
    "override_total_1": 21583.44,
    "override_increase_1": 595.52
  },
  {
    "#": "29 Rangeley Rd (410-09-00)",
    "$": 2047500,
    "address": "29 Rangeley Rd",
    "parcel_id": "410-09-00",
    "owner1": "STONE TRS, PHILLIP J",
    "owner2": "KEMPNER-STONE, SARA",
    "current_taxes": 17331.47,
    "new_taxes_no_override": 18080.19,
    "override_total_1": 18593.2,
    "override_increase_1": 513.01
  },
  {
    "#": "30 Rangeley Rd (409-08-00)",
    "$": 1741400,
    "address": "30 Rangeley Rd",
    "parcel_id": "409-08-00",
    "owner1": "VOKONAS, PANTEL S",
    "owner2": "",
    "current_taxes": 14197.0,
    "new_taxes_no_override": 14810.31,
    "override_total_1": 15230.54,
    "override_increase_1": 420.23
  },
  {
    "#": "33 Rangeley Rd (410-08-00)",
    "$": 2948400,
    "address": "33 Rangeley Rd",
    "parcel_id": "410-08-00",
    "owner1": "SEEGER, JOHN D",
    "owner2": "LIN, SHU YUN",
    "current_taxes": 26556.68,
    "new_taxes_no_override": 27703.93,
    "override_total_1": 28490.01,
    "override_increase_1": 786.08
  },
  {
    "#": "39 Rangeley Rd (410-07-00)",
    "$": 4271600,
    "address": "39 Rangeley Rd",
    "parcel_id": "410-07-00",
    "owner1": "LIVSTONE TRS, LISA R & MITCHELL M",
    "owner2": "",
    "current_taxes": 40106.25,
    "new_taxes_no_override": 41838.84,
    "override_total_1": 43025.99,
    "override_increase_1": 1187.15
  },
  {
    "#": "44 Rangeley Rd (409-07-00)",
    "$": 2305800,
    "address": "44 Rangeley Rd",
    "parcel_id": "409-07-00",
    "owner1": "MILLER, DAVID L & BONNIE B",
    "owner2": "",
    "current_taxes": 19976.46,
    "new_taxes_no_override": 20839.44,
    "override_total_1": 21430.75,
    "override_increase_1": 591.3
  },
  {
    "#": "47 Rangeley Rd (410-06-00)",
    "$": 1676800,
    "address": "47 Rangeley Rd",
    "parcel_id": "410-06-00",
    "owner1": "WOLMAN, TR, MARILYN N",
    "owner2": "",
    "current_taxes": 13535.5,
    "new_taxes_no_override": 14120.23,
    "override_total_1": 14520.88,
    "override_increase_1": 400.65
  },
  {
    "#": "52 Rangeley Rd (409-06-00)",
    "$": 3021600,
    "address": "52 Rangeley Rd",
    "parcel_id": "409-06-00",
    "owner1": "FOURNIER, HUGO",
    "owner2": "YEE, MICHELE",
    "current_taxes": 27306.25,
    "new_taxes_no_override": 28485.88,
    "override_total_1": 29294.15,
    "override_increase_1": 808.27
  },
  {
    "#": "57 Rangeley Rd (410-05-00)",
    "$": 4585600,
    "address": "57 Rangeley Rd",
    "parcel_id": "410-05-00",
    "owner1": "CHEN, FREDERICK Y",
    "owner2": "",
    "current_taxes": 43321.61,
    "new_taxes_no_override": 45193.1,
    "override_total_1": 46475.42,
    "override_increase_1": 1282.32
  },
  {
    "#": "62 Rangeley Rd (409-05-00)",
    "$": 2413200,
    "address": "62 Rangeley Rd",
    "parcel_id": "409-05-00",
    "owner1": "SINGH, HARSIMRANJIT",
    "owner2": "MONGA, HARNEET KAUR",
    "current_taxes": 24711.17,
    "new_taxes_no_override": 25778.69,
    "override_total_1": 26510.14,
    "override_increase_1": 731.45
  },
  {
    "#": "63 Rangeley Rd (410-04-00)",
    "$": 3536300,
    "address": "63 Rangeley Rd",
    "parcel_id": "410-04-00",
    "owner1": "CATALINO, PETER & NATACHA",
    "owner2": "",
    "current_taxes": 32576.78,
    "new_taxes_no_override": 33984.1,
    "override_total_1": 34948.37,
    "override_increase_1": 964.27
  },
  {
    "#": "71 Rangeley Rd (410-03-00)",
    "$": 1874000,
    "address": "71 Rangeley Rd",
    "parcel_id": "410-03-00",
    "owner1": "FREEDMAN, ANN T & STEVEN D",
    "owner2": "",
    "current_taxes": 15554.83,
    "new_taxes_no_override": 16226.8,
    "override_total_1": 16687.22,
    "override_increase_1": 460.42
  },
  {
    "#": "72 Rangeley Rd (409-04-00)",
    "$": 1607100,
    "address": "72 Rangeley Rd",
    "parcel_id": "409-04-00",
    "owner1": "GLEASON, JOANNA",
    "owner2": "",
    "current_taxes": 12821.77,
    "new_taxes_no_override": 13375.67,
    "override_total_1": 13755.19,
    "override_increase_1": 379.52
  },
  {
    "#": "80 Rangeley Rd (409-03-00)",
    "$": 1331600,
    "address": "80 Rangeley Rd",
    "parcel_id": "409-03-00",
    "owner1": "ROMAIN, PAUL L & NAVA D",
    "owner2": "",
    "current_taxes": 10000.65,
    "new_taxes_no_override": 10432.68,
    "override_total_1": 10728.7,
    "override_increase_1": 296.02
  },
  {
    "#": "81 Rangeley Rd (410-02-00)",
    "$": 2190100,
    "address": "81 Rangeley Rd",
    "parcel_id": "410-02-00",
    "owner1": "BRESMAN TR, ALICE A",
    "owner2": "",
    "current_taxes": 18791.69,
    "new_taxes_no_override": 19603.49,
    "override_total_1": 20159.73,
    "override_increase_1": 556.23
  },
  {
    "#": "89 Rangeley Rd (410-01-00)",
    "$": 1664000,
    "address": "89 Rangeley Rd",
    "parcel_id": "410-01-00",
    "owner1": "MALLIOS, ANASTASIOS & CHRISTINE",
    "owner2": "",
    "current_taxes": 17039.36,
    "new_taxes_no_override": 17775.46,
    "override_total_1": 18279.83,
    "override_increase_1": 504.37
  },
  {
    "#": "116 Rangeley Rd (406-12-00)",
    "$": 2294300,
    "address": "116 Rangeley Rd",
    "parcel_id": "406-12-00",
    "owner1": "PUTNAM, TR, DAVID W C",
    "owner2": "",
    "current_taxes": 23493.63,
    "new_taxes_no_override": 24508.55,
    "override_total_1": 25203.97,
    "override_increase_1": 695.41
  },
  {
    "#": "121 Rangeley Rd (407-02-01)",
    "$": 1900400,
    "address": "121 Rangeley Rd",
    "parcel_id": "407-02-01",
    "owner1": "STRATTON-MAMBER, TR, JOAN K",
    "owner2": "",
    "current_taxes": 15825.16,
    "new_taxes_no_override": 16508.81,
    "override_total_1": 16977.23,
    "override_increase_1": 468.42
  },
  {
    "#": "124 Rangeley Rd (406-11-00)",
    "$": 2223800,
    "address": "124 Rangeley Rd",
    "parcel_id": "406-11-00",
    "owner1": "124 RANGELEY ROAD LLC",
    "owner2": "",
    "current_taxes": 22771.71,
    "new_taxes_no_override": 23755.45,
    "override_total_1": 24429.49,
    "override_increase_1": 674.04
  },
  {
    "#": "129 Rangeley Rd (407-04-00)",
    "$": 4111700,
    "address": "129 Rangeley Rd",
    "parcel_id": "407-04-00",
    "owner1": "VIEIL, FREDERIC JACQUES JEAN & LOREDANA REBECCA SANDU",
    "owner2": "",
    "current_taxes": 42103.81,
    "new_taxes_no_override": 43922.69,
    "override_total_1": 45168.97,
    "override_increase_1": 1246.27
  },
  {
    "#": "134 Rangeley Rd (406-10-00)",
    "$": 2061300,
    "address": "134 Rangeley Rd",
    "parcel_id": "406-10-00",
    "owner1": "ERLICH TRS, JASON M & DEBORAH",
    "owner2": "",
    "current_taxes": 21107.71,
    "new_taxes_no_override": 22019.56,
    "override_total_1": 22644.35,
    "override_increase_1": 624.79
  },
  {
    "#": "135 Rangeley Rd (407-05-00)",
    "$": 2205000,
    "address": "135 Rangeley Rd",
    "parcel_id": "407-05-00",
    "owner1": "BROWN TRS, NANCY NEIMAN",
    "owner2": "",
    "current_taxes": 18944.27,
    "new_taxes_no_override": 19762.66,
    "override_total_1": 20323.41,
    "override_increase_1": 560.75
  },
  {
    "#": "140 Rangeley Rd (406-09-00)",
    "$": 1861300,
    "address": "140 Rangeley Rd",
    "parcel_id": "406-09-00",
    "owner1": "WANG, YAOYU",
    "owner2": "HSIEH, MO-YING",
    "current_taxes": 15424.78,
    "new_taxes_no_override": 16091.13,
    "override_total_1": 16547.7,
    "override_increase_1": 456.57
  },
  {
    "#": "143 Rangeley Rd (407-06-00)",
    "$": 1749300,
    "address": "143 Rangeley Rd",
    "parcel_id": "407-06-00",
    "owner1": "ROTHSTEIN TRS, KENNETH & CAROLE A",
    "owner2": "",
    "current_taxes": 14277.9,
    "new_taxes_no_override": 14894.71,
    "override_total_1": 15317.33,
    "override_increase_1": 422.63
  },
  {
    "#": "149 Rangeley Rd (407-07-00)",
    "$": 2322700,
    "address": "149 Rangeley Rd",
    "parcel_id": "407-07-00",
    "owner1": "LIVINGSTONE, MARGARET S",
    "owner2": "SULLIVAN, K T",
    "current_taxes": 20149.51,
    "new_taxes_no_override": 21019.97,
    "override_total_1": 21616.39,
    "override_increase_1": 596.43
  },
  {
    "#": "150 Rangeley Rd (406-08-00)",
    "$": 3544800,
    "address": "150 Rangeley Rd",
    "parcel_id": "406-08-00",
    "owner1": "WANG TRS, DAVID",
    "owner2": "KUOHUNG, WENDY",
    "current_taxes": 32663.82,
    "new_taxes_no_override": 34074.9,
    "override_total_1": 35041.75,
    "override_increase_1": 966.85
  },
  {
    "#": "153 Rangeley Rd (407-08-02)",
    "$": 3687100,
    "address": "153 Rangeley Rd",
    "parcel_id": "407-08-02",
    "owner1": "YU, TIMOTHY WEI-WEN",
    "owner2": "LIEN, CINDY",
    "current_taxes": 34120.97,
    "new_taxes_no_override": 35595.0,
    "override_total_1": 36604.98,
    "override_increase_1": 1009.98
  },
  {
    "#": "155 Rangeley Rd (407-08-03)",
    "$": 3511100,
    "address": "155 Rangeley Rd",
    "parcel_id": "407-08-03",
    "owner1": "VAFA, CUMRUN",
    "owner2": "SADROLHOFFAZI, N",
    "current_taxes": 32318.73,
    "new_taxes_no_override": 33714.9,
    "override_total_1": 34671.53,
    "override_increase_1": 956.63
  },
  {
    "#": "159 Rangeley Rd (407-09-00)",
    "$": 4315400,
    "address": "159 Rangeley Rd",
    "parcel_id": "407-09-00",
    "owner1": "ROITER, ERIC D & TEDDY J",
    "owner2": "",
    "current_taxes": 40554.76,
    "new_taxes_no_override": 42306.73,
    "override_total_1": 43507.15,
    "override_increase_1": 1200.42
  },
  {
    "#": "163 Rangeley Rd (407-10-00)",
    "$": 4440900,
    "address": "163 Rangeley Rd",
    "parcel_id": "407-10-00",
    "owner1": "NAUGHTON TR, AMY B",
    "owner2": "C/O LOURIE & CUTLER PC",
    "current_taxes": 45474.82,
    "new_taxes_no_override": 47439.33,
    "override_total_1": 48785.39,
    "override_increase_1": 1346.05
  },
  {
    "#": "166 Rangeley Rd (406-05-02)",
    "$": 3523000,
    "address": "166 Rangeley Rd",
    "parcel_id": "406-05-02",
    "owner1": "MIN, KENT",
    "owner2": "YUM, MIMI",
    "current_taxes": 32440.59,
    "new_taxes_no_override": 33842.02,
    "override_total_1": 34802.26,
    "override_increase_1": 960.24
  },
  {
    "#": "167 Rangeley Rd (407-11-00)",
    "$": 1652400,
    "address": "167 Rangeley Rd",
    "parcel_id": "407-11-00",
    "owner1": "GALLAGHER TRS, JOHN & EILEEN",
    "owner2": "",
    "current_taxes": 13285.64,
    "new_taxes_no_override": 13859.58,
    "override_total_1": 14252.83,
    "override_increase_1": 393.25
  },
  {
    "#": "176 Rangeley Rd (406-05-01)",
    "$": 3352200,
    "address": "176 Rangeley Rd",
    "parcel_id": "406-05-01",
    "owner1": "SMITH, STEVEN P",
    "owner2": "",
    "current_taxes": 34326.53,
    "new_taxes_no_override": 35809.44,
    "override_total_1": 36825.5,
    "override_increase_1": 1016.07
  },
  {
    "#": "195 Rangeley Rd (404-05-00)",
    "$": 1740900,
    "address": "195 Rangeley Rd",
    "parcel_id": "404-05-00",
    "owner1": "ROSNER, MICHELLE M",
    "owner2": "",
    "current_taxes": 14191.88,
    "new_taxes_no_override": 14804.97,
    "override_total_1": 15225.05,
    "override_increase_1": 420.08
  },
  {
    "#": "203 Rangeley Rd (404-04-01)",
    "$": 1422400,
    "address": "203 Rangeley Rd",
    "parcel_id": "404-04-01",
    "owner1": "GAO, ZHANJUN",
    "owner2": "LIU, FEI",
    "current_taxes": 10930.44,
    "new_taxes_no_override": 11402.64,
    "override_total_1": 11726.18,
    "override_increase_1": 323.54
  },
  {
    "#": "204 Rangeley Rd (405-16-00)",
    "$": 1773500,
    "address": "204 Rangeley Rd",
    "parcel_id": "405-16-00",
    "owner1": "BRAUNSTEIN, EDWIN P & SOPHIA CT",
    "owner2": "",
    "current_taxes": 14525.71,
    "new_taxes_no_override": 15153.22,
    "override_total_1": 15583.18,
    "override_increase_1": 429.96
  },
  {
    "#": "210 Rangeley Rd (405-17-00)",
    "$": 1647100,
    "address": "210 Rangeley Rd",
    "parcel_id": "405-17-00",
    "owner1": "CORRIGAN JR, JOHN J & KATHLEEN M",
    "owner2": "",
    "current_taxes": 13231.37,
    "new_taxes_no_override": 13802.97,
    "override_total_1": 14194.61,
    "override_increase_1": 391.65
  },
  {
    "#": "6 Rawson Rd (209A-14-00)",
    "$": 3071400,
    "address": "6 Rawson Rd",
    "parcel_id": "209A-14-00",
    "owner1": "DANBERG, DAVID A",
    "owner2": "",
    "current_taxes": 31451.14,
    "new_taxes_no_override": 32809.83,
    "override_total_1": 33740.78,
    "override_increase_1": 930.95
  },
  {
    "#": "7 Rawson Rd, Unit 2 (218-06-02)",
    "$": 1879100,
    "address": "7 Rawson Rd, Unit 2",
    "parcel_id": "218-06-02",
    "owner1": "AWASTHI, SAURABH",
    "owner2": "SHRIVASTAV, NIDHI",
    "current_taxes": 15607.05,
    "new_taxes_no_override": 16281.27,
    "override_total_1": 16743.24,
    "override_increase_1": 461.97
  },
  {
    "#": "9 Rawson Rd, Unit 1 (218-06-01)",
    "$": 1779100,
    "address": "9 Rawson Rd, Unit 1",
    "parcel_id": "218-06-01",
    "owner1": "MARCHANT LIFE ESTATE, EDWARD H & CATHERINE",
    "owner2": "",
    "current_taxes": 14583.05,
    "new_taxes_no_override": 15213.04,
    "override_total_1": 15644.7,
    "override_increase_1": 431.66
  },
  {
    "#": "14 Rawson Rd, Unit 1 (209A-13-01)",
    "$": 1571700,
    "address": "14 Rawson Rd, Unit 1",
    "parcel_id": "209A-13-01",
    "owner1": "FARRAR, NOREEN M",
    "owner2": "",
    "current_taxes": 12459.27,
    "new_taxes_no_override": 12997.51,
    "override_total_1": 13366.3,
    "override_increase_1": 368.79
  },
  {
    "#": "14 Rawson Rd, Unit 2 (209A-13-02)",
    "$": 1712900,
    "address": "14 Rawson Rd, Unit 2",
    "parcel_id": "209A-13-02",
    "owner1": "HAN, LONG ZHEN",
    "owner2": "GRECO, JONATHAN PAUL AUGUSTUS",
    "current_taxes": 13905.16,
    "new_taxes_no_override": 14505.86,
    "override_total_1": 14917.46,
    "override_increase_1": 411.59
  },
  {
    "#": "20 Rawson Rd (209A-12-00)",
    "$": 4160900,
    "address": "20 Rawson Rd",
    "parcel_id": "209A-12-00",
    "owner1": "JOLESZ, ANNA",
    "owner2": "",
    "current_taxes": 38972.68,
    "new_taxes_no_override": 40656.3,
    "override_total_1": 41809.89,
    "override_increase_1": 1153.59
  },
  {
    "#": "28 Rawson Rd, Unit 1 (209A-11-01)",
    "$": 1330700,
    "address": "28 Rawson Rd, Unit 1",
    "parcel_id": "209A-11-01",
    "owner1": "SHWARTZ TRS, MICHAEL",
    "owner2": "GOODMAN TR, H PAMELA",
    "current_taxes": 9991.43,
    "new_taxes_no_override": 10423.06,
    "override_total_1": 10718.81,
    "override_increase_1": 295.75
  },
  {
    "#": "28 Rawson Rd, Unit 2 (209A-11-02)",
    "$": 1426000,
    "address": "28 Rawson Rd, Unit 2",
    "parcel_id": "209A-11-02",
    "owner1": "ZARETSKY TRS, MICHAEL & ELENA",
    "owner2": "",
    "current_taxes": 10967.31,
    "new_taxes_no_override": 11441.1,
    "override_total_1": 11765.73,
    "override_increase_1": 324.63
  },
  {
    "#": "29 Rawson Rd (218-08-07)",
    "$": 148800,
    "address": "29 Rawson Rd",
    "parcel_id": "218-08-07",
    "owner1": "ROSEMONT HOMES ASSOCIATION INC",
    "owner2": "C/O JOAN LAUTENSCHLEGER",
    "current_taxes": 1523.71,
    "new_taxes_no_override": 1589.53,
    "override_total_1": 1634.64,
    "override_increase_1": 45.1
  },
  {
    "#": "34 Rawson Rd, Unit 1 (209A-10-01)",
    "$": 2436200,
    "address": "34 Rawson Rd, Unit 1",
    "parcel_id": "209A-10-01",
    "owner1": "BAKER, MARC A & JILL E",
    "owner2": "",
    "current_taxes": 24946.69,
    "new_taxes_no_override": 26024.39,
    "override_total_1": 26762.81,
    "override_increase_1": 738.42
  },
  {
    "#": "34 Rawson Rd, Unit 2 (209A-10-02)",
    "$": 2721800,
    "address": "34 Rawson Rd, Unit 2",
    "parcel_id": "209A-10-02",
    "owner1": "RAFTERY, MICHELLE",
    "owner2": "FARNHAM, JESSICA",
    "current_taxes": 24236.3,
    "new_taxes_no_override": 25283.31,
    "override_total_1": 26000.7,
    "override_increase_1": 717.39
  },
  {
    "#": "44 Rawson Rd, Unit 1 (209A-09-01)",
    "$": 2178300,
    "address": "44 Rawson Rd, Unit 1",
    "parcel_id": "209A-09-01",
    "owner1": "VALDES, MANUEL E B",
    "owner2": "SANCHEZ-CANETE, SONIA MORENO",
    "current_taxes": 22305.79,
    "new_taxes_no_override": 23269.4,
    "override_total_1": 23929.65,
    "override_increase_1": 660.25
  },
  {
    "#": "44 Rawson Rd, Unit 2 (209A-09-02)",
    "$": 2128700,
    "address": "44 Rawson Rd, Unit 2",
    "parcel_id": "209A-09-02",
    "owner1": "LYANDRES, EVGENY",
    "owner2": "BALONOVA, POLINA",
    "current_taxes": 21797.89,
    "new_taxes_no_override": 22739.56,
    "override_total_1": 23384.78,
    "override_increase_1": 645.22
  },
  {
    "#": "45 Rawson Rd (218-07-00)",
    "$": 2782300,
    "address": "45 Rawson Rd",
    "parcel_id": "218-07-00",
    "owner1": "ALFARO, LAURA",
    "owner2": "",
    "current_taxes": 24855.82,
    "new_taxes_no_override": 25929.59,
    "override_total_1": 26665.32,
    "override_increase_1": 735.73
  },
  {
    "#": "47 Rawson Rd (218-07-01)",
    "$": 3234100,
    "address": "47 Rawson Rd",
    "parcel_id": "218-07-01",
    "owner1": "SELVAGGIO, ANTHONY J & ADRIANNA S",
    "owner2": "",
    "current_taxes": 33117.18,
    "new_taxes_no_override": 34547.84,
    "override_total_1": 35528.11,
    "override_increase_1": 980.27
  },
  {
    "#": "49 Rawson Rd (218-09-01)",
    "$": 2622900,
    "address": "49 Rawson Rd",
    "parcel_id": "218-09-01",
    "owner1": "NORMAND, SHARON-LISE TERESA",
    "owner2": "GATSONIS, CONSTANTINE ACHILLES",
    "current_taxes": 23223.56,
    "new_taxes_no_override": 24226.82,
    "override_total_1": 24914.24,
    "override_increase_1": 687.42
  },
  {
    "#": "51 Rawson Rd (218-09-02)",
    "$": 2493400,
    "address": "51 Rawson Rd",
    "parcel_id": "218-09-02",
    "owner1": "LU, JOE & CHERYL",
    "owner2": "",
    "current_taxes": 21897.48,
    "new_taxes_no_override": 22843.45,
    "override_total_1": 23491.62,
    "override_increase_1": 648.17
  },
  {
    "#": "52 Rawson Rd (222-14-02)",
    "$": 2432700,
    "address": "52 Rawson Rd",
    "parcel_id": "222-14-02",
    "owner1": "TURETSKY, EUGENE & SOPHIA",
    "owner2": "",
    "current_taxes": 24910.85,
    "new_taxes_no_override": 25987.0,
    "override_total_1": 26724.36,
    "override_increase_1": 737.36
  },
  {
    "#": "53 Rawson Rd (218-09-03)",
    "$": 2154900,
    "address": "53 Rawson Rd",
    "parcel_id": "218-09-03",
    "owner1": "MADRY, ALEKSANDER & KAMILA",
    "owner2": "",
    "current_taxes": 22066.18,
    "new_taxes_no_override": 23019.44,
    "override_total_1": 23672.6,
    "override_increase_1": 653.16
  },
  {
    "#": "55 Rawson Rd (218-10-00)",
    "$": 7143900,
    "address": "55 Rawson Rd",
    "parcel_id": "218-10-00",
    "owner1": "WERTHEIMER, JOYCE & JEREMY",
    "owner2": "",
    "current_taxes": 73153.54,
    "new_taxes_no_override": 76313.77,
    "override_total_1": 78479.12,
    "override_increase_1": 2165.34
  },
  {
    "#": "58 Rawson Rd (222-14-01)",
    "$": 2925600,
    "address": "58 Rawson Rd",
    "parcel_id": "222-14-01",
    "owner1": "SMITH, DANA & ERIC L",
    "owner2": "",
    "current_taxes": 26323.21,
    "new_taxes_no_override": 27460.37,
    "override_total_1": 28239.54,
    "override_increase_1": 779.17
  },
  {
    "#": "62 Rawson Rd (222-14-00)",
    "$": 2066500,
    "address": "62 Rawson Rd",
    "parcel_id": "222-14-00",
    "owner1": "LAWRENCE, AMOS & CHANTAL",
    "owner2": "",
    "current_taxes": 17526.03,
    "new_taxes_no_override": 18283.15,
    "override_total_1": 18801.92,
    "override_increase_1": 518.77
  },
  {
    "#": "63 Rawson Rd (218-29-00)",
    "$": 2589300,
    "address": "63 Rawson Rd",
    "parcel_id": "218-29-00",
    "owner1": "LEIMAN, SHERI",
    "owner2": "GARBER, JEFFERY",
    "current_taxes": 26514.43,
    "new_taxes_no_override": 27659.85,
    "override_total_1": 28444.68,
    "override_increase_1": 784.83
  },
  {
    "#": "66 Rawson Rd (222-13-02)",
    "$": 43000,
    "address": "66 Rawson Rd",
    "parcel_id": "222-13-02",
    "owner1": "KATZ, NATHAN A & AMY",
    "owner2": "",
    "current_taxes": 440.32,
    "new_taxes_no_override": 459.34,
    "override_total_1": 472.38,
    "override_increase_1": 13.03
  },
  {
    "#": "67 Rawson Rd (218-31-00)",
    "$": 2719800,
    "address": "67 Rawson Rd",
    "parcel_id": "218-31-00",
    "owner1": "GARBER, JEFFREY R",
    "owner2": "LEIMAN, SHERI",
    "current_taxes": 27850.75,
    "new_taxes_no_override": 29053.9,
    "override_total_1": 29878.28,
    "override_increase_1": 824.38
  },
  {
    "#": "72 Rawson Rd (222-13-01)",
    "$": 2191600,
    "address": "72 Rawson Rd",
    "parcel_id": "222-13-01",
    "owner1": "OBRIEN TR, SANDA",
    "owner2": "",
    "current_taxes": 18807.05,
    "new_taxes_no_override": 19619.51,
    "override_total_1": 20176.2,
    "override_increase_1": 556.69
  },
  {
    "#": "77 Rawson Rd (218-27-00)",
    "$": 2821500,
    "address": "77 Rawson Rd",
    "parcel_id": "218-27-00",
    "owner1": "PROPP, MICHAEL & TAMAR",
    "owner2": "",
    "current_taxes": 25257.23,
    "new_taxes_no_override": 26348.34,
    "override_total_1": 27095.96,
    "override_increase_1": 747.61
  },
  {
    "#": "78 Rawson Rd (222-13-00)",
    "$": 2260700,
    "address": "78 Rawson Rd",
    "parcel_id": "222-13-00",
    "owner1": "MEISEL, TRS, FREDERICK L & LILI ANN",
    "owner2": "",
    "current_taxes": 19514.63,
    "new_taxes_no_override": 20357.66,
    "override_total_1": 20935.3,
    "override_increase_1": 577.63
  },
  {
    "#": "84 Rawson Rd (222-12-00)",
    "$": 3148800,
    "address": "84 Rawson Rd",
    "parcel_id": "222-12-00",
    "owner1": "MALIK, RAZA",
    "owner2": "SADIQ, AMAMA",
    "current_taxes": 28608.78,
    "new_taxes_no_override": 29844.68,
    "override_total_1": 30691.5,
    "override_increase_1": 846.82
  },
  {
    "#": "89 Rawson Rd (218-14-00)",
    "$": 4988100,
    "address": "89 Rawson Rd",
    "parcel_id": "218-14-00",
    "owner1": "POTAPOV, IGOR & SOFIA OSTRER",
    "owner2": "",
    "current_taxes": 47443.21,
    "new_taxes_no_override": 49492.76,
    "override_total_1": 50897.08,
    "override_increase_1": 1404.32
  },
  {
    "#": "90 Rawson Rd (222-11-01)",
    "$": 2419600,
    "address": "90 Rawson Rd",
    "parcel_id": "222-11-01",
    "owner1": "GHITZA TRS, DVORA & ODED",
    "owner2": "",
    "current_taxes": 21141.77,
    "new_taxes_no_override": 22055.09,
    "override_total_1": 22680.89,
    "override_increase_1": 625.8
  },
  {
    "#": "98 Rawson Rd (222-11-00)",
    "$": 1989400,
    "address": "98 Rawson Rd",
    "parcel_id": "222-11-00",
    "owner1": "HARNETT, DAVID S",
    "owner2": "HALFIN, VIVIAN",
    "current_taxes": 16736.52,
    "new_taxes_no_override": 17459.54,
    "override_total_1": 17954.94,
    "override_increase_1": 495.4
  },
  {
    "#": "99 Rawson Rd (218-33-00)",
    "$": 3165200,
    "address": "99 Rawson Rd",
    "parcel_id": "218-33-00",
    "owner1": "PLOTNICK TRS, SCOT",
    "owner2": "HACKEL TRS, MELISSA",
    "current_taxes": 28776.71,
    "new_taxes_no_override": 30019.86,
    "override_total_1": 30871.65,
    "override_increase_1": 851.79
  },
  {
    "#": "104 Rawson Rd (222-10-00)",
    "$": 3164700,
    "address": "104 Rawson Rd",
    "parcel_id": "222-10-00",
    "owner1": "KASIDA, TIMOTHY C & SHALINI",
    "owner2": "",
    "current_taxes": 28771.59,
    "new_taxes_no_override": 30014.52,
    "override_total_1": 30866.16,
    "override_increase_1": 851.64
  },
  {
    "#": "109 Rawson Rd (218-15-00)",
    "$": 2769100,
    "address": "109 Rawson Rd",
    "parcel_id": "218-15-00",
    "owner1": "KAY, TRS, REED",
    "owner2": "",
    "current_taxes": 24720.65,
    "new_taxes_no_override": 25788.58,
    "override_total_1": 26520.31,
    "override_increase_1": 731.73
  },
  {
    "#": "114 Rawson Rd (222-09-00)",
    "$": 4854700,
    "address": "114 Rawson Rd",
    "parcel_id": "222-09-00",
    "owner1": "114 RAWSON ROAD LLC",
    "owner2": "",
    "current_taxes": 49712.13,
    "new_taxes_no_override": 51859.69,
    "override_total_1": 53331.17,
    "override_increase_1": 1471.48
  },
  {
    "#": "119 Rawson Rd (218-16-00)",
    "$": 1984100,
    "address": "119 Rawson Rd",
    "parcel_id": "218-16-00",
    "owner1": "BLUMSTEIN, EDWARD D",
    "owner2": "",
    "current_taxes": 16682.25,
    "new_taxes_no_override": 17402.92,
    "override_total_1": 17896.72,
    "override_increase_1": 493.79
  },
  {
    "#": "120 Rawson Rd (222-08-01)",
    "$": 3995600,
    "address": "120 Rawson Rd",
    "parcel_id": "222-08-01",
    "owner1": "JACOBSON TR, LISA RIANA",
    "owner2": "",
    "current_taxes": 40914.94,
    "new_taxes_no_override": 42682.47,
    "override_total_1": 43893.55,
    "override_increase_1": 1211.08
  },
  {
    "#": "124 Rawson Rd (222-07-08)",
    "$": 2423600,
    "address": "124 Rawson Rd",
    "parcel_id": "222-07-08",
    "owner1": "HALVORSON, KAREN N",
    "owner2": "",
    "current_taxes": 21182.73,
    "new_taxes_no_override": 22097.82,
    "override_total_1": 22724.83,
    "override_increase_1": 627.01
  },
  {
    "#": "128 Rawson Rd (222-06-01)",
    "$": 4324300,
    "address": "128 Rawson Rd",
    "parcel_id": "222-06-01",
    "owner1": "BYER, STEVEN T",
    "owner2": "EYSIE, PAUL W",
    "current_taxes": 40645.9,
    "new_taxes_no_override": 42401.8,
    "override_total_1": 43604.92,
    "override_increase_1": 1203.12
  },
  {
    "#": "133 Rawson Rd (218-17-01)",
    "$": 3002600,
    "address": "133 Rawson Rd",
    "parcel_id": "218-17-01",
    "owner1": "SWAIM TR, PATRICIA FAHEY",
    "owner2": "",
    "current_taxes": 27111.69,
    "new_taxes_no_override": 28282.92,
    "override_total_1": 29085.42,
    "override_increase_1": 802.51
  },
  {
    "#": "136 Rawson Rd (222-04-06)",
    "$": 5016000,
    "address": "136 Rawson Rd",
    "parcel_id": "222-04-06",
    "owner1": "CHILDS TRS, MAURICE F",
    "owner2": "COOKE-CHILDS, LEE",
    "current_taxes": 47728.91,
    "new_taxes_no_override": 49790.8,
    "override_total_1": 51203.57,
    "override_increase_1": 1412.78
  },
  {
    "#": "139 Rawson Rd (218-17-02)",
    "$": 2427800,
    "address": "139 Rawson Rd",
    "parcel_id": "218-17-02",
    "owner1": "SILBERT, ARIEL",
    "owner2": "",
    "current_taxes": 21225.74,
    "new_taxes_no_override": 22142.69,
    "override_total_1": 22770.97,
    "override_increase_1": 628.28
  },
  {
    "#": "154 Rawson Rd (222-42-00)",
    "$": 3033400,
    "address": "154 Rawson Rd",
    "parcel_id": "222-42-00",
    "owner1": "WEIL, ARIEL & DANIELLE",
    "owner2": "",
    "current_taxes": 27427.08,
    "new_taxes_no_override": 28611.93,
    "override_total_1": 29423.77,
    "override_increase_1": 811.84
  },
  {
    "#": "161 Rawson Rd (220-46-00)",
    "$": 2243600,
    "address": "161 Rawson Rd",
    "parcel_id": "220-46-00",
    "owner1": "CAVANAUGH, KEVIN & NANCY",
    "owner2": "",
    "current_taxes": 19339.53,
    "new_taxes_no_override": 20175.0,
    "override_total_1": 20747.45,
    "override_increase_1": 572.45
  },
  {
    "#": "164 Rawson Rd (222-41-00)",
    "$": 4452200,
    "address": "164 Rawson Rd",
    "parcel_id": "222-41-00",
    "owner1": "BREITBART, ROGER E",
    "owner2": "HILL, LINDA A",
    "current_taxes": 41955.59,
    "new_taxes_no_override": 43768.07,
    "override_total_1": 45009.96,
    "override_increase_1": 1241.89
  },
  {
    "#": "165 Rawson Rd (220-47-00)",
    "$": 2379900,
    "address": "165 Rawson Rd",
    "parcel_id": "220-47-00",
    "owner1": "BRAUN, SCOTT D",
    "owner2": "HAMZE, MONIQUE R",
    "current_taxes": 20735.24,
    "new_taxes_no_override": 21631.0,
    "override_total_1": 22244.77,
    "override_increase_1": 613.76
  },
  {
    "#": "169 Rawson Rd (220-48-00)",
    "$": 2074400,
    "address": "169 Rawson Rd",
    "parcel_id": "220-48-00",
    "owner1": "KILDUFF, RICHARD J & MARY JANE",
    "owner2": "",
    "current_taxes": 17606.92,
    "new_taxes_no_override": 18367.54,
    "override_total_1": 18888.7,
    "override_increase_1": 521.16
  },
  {
    "#": "170 Rawson Rd (222-39-00)",
    "$": 2327100,
    "address": "170 Rawson Rd",
    "parcel_id": "222-39-00",
    "owner1": "LEVI, JONATHAN & KAY A",
    "owner2": "",
    "current_taxes": 20194.57,
    "new_taxes_no_override": 21066.98,
    "override_total_1": 21664.73,
    "override_increase_1": 597.76
  },
  {
    "#": "175 Rawson Rd (220-49-00)",
    "$": 3172900,
    "address": "175 Rawson Rd",
    "parcel_id": "220-49-00",
    "owner1": "MYERSON, ANN",
    "owner2": "",
    "current_taxes": 28855.56,
    "new_taxes_no_override": 30102.12,
    "override_total_1": 30956.24,
    "override_increase_1": 854.12
  },
  {
    "#": "176 Rawson Rd (222-38-00)",
    "$": 1600400,
    "address": "176 Rawson Rd",
    "parcel_id": "222-38-00",
    "owner1": "MILLER TRS, MARVIN M & ELSA K",
    "owner2": "C/O REBECCA STERN",
    "current_taxes": 12753.16,
    "new_taxes_no_override": 13304.1,
    "override_total_1": 13681.59,
    "override_increase_1": 377.49
  },
  {
    "#": "178 Rawson Rd (222-37-00)",
    "$": 1600000,
    "address": "178 Rawson Rd",
    "parcel_id": "222-37-00",
    "owner1": "JUROW, JONATHAN S & KELSEY J",
    "owner2": "",
    "current_taxes": 12749.07,
    "new_taxes_no_override": 13299.83,
    "override_total_1": 13677.2,
    "override_increase_1": 377.37
  },
  {
    "#": "179 Rawson Rd, Unit 1 (220-50-01)",
    "$": 1015500,
    "address": "179 Rawson Rd, Unit 1",
    "parcel_id": "220-50-01",
    "owner1": "BLASZAK, LYNNE & GREGG",
    "owner2": "",
    "current_taxes": 6763.79,
    "new_taxes_no_override": 7055.99,
    "override_total_1": 7256.19,
    "override_increase_1": 200.21
  },
  {
    "#": "179 Rawson Rd, Unit 2 (220-50-02)",
    "$": 1647700,
    "address": "179 Rawson Rd, Unit 2",
    "parcel_id": "220-50-02",
    "owner1": "HICKEY, KEVIN",
    "owner2": "REIDERMAN-HICKEY, ANNA",
    "current_taxes": 13237.51,
    "new_taxes_no_override": 13809.37,
    "override_total_1": 14201.2,
    "override_increase_1": 391.83
  },
  {
    "#": "180 Rawson Rd (222-36-00)",
    "$": 1688400,
    "address": "180 Rawson Rd",
    "parcel_id": "222-36-00",
    "owner1": "LEE TRS, HYUNJOO JEAN",
    "owner2": "KIM, JEAN WOONG YONG",
    "current_taxes": 13654.28,
    "new_taxes_no_override": 14244.14,
    "override_total_1": 14648.31,
    "override_increase_1": 404.17
  },
  {
    "#": "182 Rawson Rd (222-35-00)",
    "$": 1662800,
    "address": "182 Rawson Rd",
    "parcel_id": "222-35-00",
    "owner1": "JARET TRS, MAZAL & ALEC",
    "owner2": "",
    "current_taxes": 13392.14,
    "new_taxes_no_override": 13970.68,
    "override_total_1": 14367.09,
    "override_increase_1": 396.41
  },
  {
    "#": "184 Rawson Rd (222-34-00)",
    "$": 1653900,
    "address": "184 Rawson Rd",
    "parcel_id": "222-34-00",
    "owner1": "MATHIOWITZ, EDITH",
    "owner2": "",
    "current_taxes": 13301.0,
    "new_taxes_no_override": 13875.6,
    "override_total_1": 14269.31,
    "override_increase_1": 393.71
  },
  {
    "#": "185 Rawson Rd, Unit 1 (220-51-01)",
    "$": 1113400,
    "address": "185 Rawson Rd, Unit 1",
    "parcel_id": "220-51-01",
    "owner1": "DWYER TRS, NICOLE K",
    "owner2": "BARNES, JEFFREY A",
    "current_taxes": 7766.28,
    "new_taxes_no_override": 8101.78,
    "override_total_1": 8331.67,
    "override_increase_1": 229.88
  },
  {
    "#": "185 Rawson Rd, Unit 2 (220-51-02)",
    "$": 1113400,
    "address": "185 Rawson Rd, Unit 2",
    "parcel_id": "220-51-02",
    "owner1": "KELLEY, BENJAMIN",
    "owner2": "BRUCE, STEPHANIE A",
    "current_taxes": 11401.22,
    "new_taxes_no_override": 11893.75,
    "override_total_1": 12231.23,
    "override_increase_1": 337.48
  },
  {
    "#": "185 Rawson Rd, Unit 3 (220-51-03)",
    "$": 1113400,
    "address": "185 Rawson Rd, Unit 3",
    "parcel_id": "220-51-03",
    "owner1": "BRUCE, STEPHANIE A",
    "owner2": "KELLEY, BENJAMIN B",
    "current_taxes": 7766.28,
    "new_taxes_no_override": 8101.78,
    "override_total_1": 8331.67,
    "override_increase_1": 229.88
  },
  {
    "#": "185 Rawson Rd, Unit G-1 (220-51-04)",
    "$": 90800,
    "address": "185 Rawson Rd, Unit G-1",
    "parcel_id": "220-51-04",
    "owner1": "POST, ELIZABETH B",
    "owner2": "",
    "current_taxes": 929.79,
    "new_taxes_no_override": 969.96,
    "override_total_1": 997.48,
    "override_increase_1": 27.52
  },
  {
    "#": "185 Rawson Rd, Unit G-2 (220-51-05)",
    "$": 90800,
    "address": "185 Rawson Rd, Unit G-2",
    "parcel_id": "220-51-05",
    "owner1": "WEINSTEIN, KEITH & MARSHA",
    "owner2": "",
    "current_taxes": 929.79,
    "new_taxes_no_override": 969.96,
    "override_total_1": 997.48,
    "override_increase_1": 27.52
  },
  {
    "#": "188 Rawson Rd, Unit A (223-27-01)",
    "$": 1617200,
    "address": "188 Rawson Rd, Unit A",
    "parcel_id": "223-27-01",
    "owner1": "SIGEL, BENJAMIN R & GABRIELLE EO",
    "owner2": "",
    "current_taxes": 12925.19,
    "new_taxes_no_override": 13483.56,
    "override_total_1": 13866.14,
    "override_increase_1": 382.59
  },
  {
    "#": "188 Rawson Rd, Unit B (223-27-02)",
    "$": 1408500,
    "address": "188 Rawson Rd, Unit B",
    "parcel_id": "223-27-02",
    "owner1": "RUSSELL, CHRISTOPHER W",
    "owner2": "CHICCO, JESSICA E",
    "current_taxes": 10788.11,
    "new_taxes_no_override": 11254.16,
    "override_total_1": 11573.48,
    "override_increase_1": 319.33
  },
  {
    "#": "189 Rawson Rd, Unit 1 (220-56-03)",
    "$": 1022400,
    "address": "189 Rawson Rd, Unit 1",
    "parcel_id": "220-56-03",
    "owner1": "RAJU, PRIYAMVADA",
    "owner2": "ANAND, VIKAS",
    "current_taxes": 10469.38,
    "new_taxes_no_override": 10921.66,
    "override_total_1": 11231.55,
    "override_increase_1": 309.89
  },
  {
    "#": "189 Rawson Rd, Unit 2 (220-56-01)",
    "$": 936600,
    "address": "189 Rawson Rd, Unit 2",
    "parcel_id": "220-56-01",
    "owner1": "ROSENBLOOM TR, HARVEY L",
    "owner2": "",
    "current_taxes": 5955.85,
    "new_taxes_no_override": 6213.14,
    "override_total_1": 6389.44,
    "override_increase_1": 176.29
  },
  {
    "#": "189 Rawson Rd, Unit 3 (220-56-02)",
    "$": 981300,
    "address": "189 Rawson Rd, Unit 3",
    "parcel_id": "220-56-02",
    "owner1": "GUIDRY, SCOTT",
    "owner2": "",
    "current_taxes": 10048.51,
    "new_taxes_no_override": 10482.61,
    "override_total_1": 10780.04,
    "override_increase_1": 297.44
  },
  {
    "#": "193 Rawson Rd (220-57-00)",
    "$": 2446000,
    "address": "193 Rawson Rd",
    "parcel_id": "220-57-00",
    "owner1": "GIANGREGORIO, DAVID & MAEVE",
    "owner2": "",
    "current_taxes": 25047.04,
    "new_taxes_no_override": 26129.07,
    "override_total_1": 26870.46,
    "override_increase_1": 741.39
  },
  {
    "#": "194 Rawson Rd, Unit 1 & P-A-B (223-26-01)",
    "$": 1321500,
    "address": "194 Rawson Rd, Unit 1 & P-A-B",
    "parcel_id": "223-26-01",
    "owner1": "SAFER, MORRY & RACHEL",
    "owner2": "",
    "current_taxes": 9897.23,
    "new_taxes_no_override": 10324.79,
    "override_total_1": 10617.75,
    "override_increase_1": 292.96
  },
  {
    "#": "194 Rawson Rd, Unit 2 (223-26-02)",
    "$": 1882600,
    "address": "194 Rawson Rd, Unit 2",
    "parcel_id": "223-26-02",
    "owner1": "GOLD  TR, SUSAN L",
    "owner2": "",
    "current_taxes": 15642.89,
    "new_taxes_no_override": 16318.66,
    "override_total_1": 16781.69,
    "override_increase_1": 463.03
  },
  {
    "#": "195 Rawson Rd (220-52-54)",
    "$": 960300,
    "address": "195 Rawson Rd",
    "parcel_id": "220-52-54",
    "owner1": "COBBLESTONE HOLDINGS LLC",
    "owner2": "",
    "current_taxes": 16478.75,
    "new_taxes_no_override": 17190.63,
    "override_total_1": 17678.4,
    "override_increase_1": 487.77
  },
  {
    "#": "197 Rawson Rd, Unit 1 (220-58-01)",
    "$": 1816100,
    "address": "197 Rawson Rd, Unit 1",
    "parcel_id": "220-58-01",
    "owner1": "CHERRY, ELYSE D",
    "owner2": "DE MARCO, THAIS",
    "current_taxes": 14961.93,
    "new_taxes_no_override": 15608.29,
    "override_total_1": 16051.16,
    "override_increase_1": 442.87
  },
  {
    "#": "197 Rawson Rd, Unit 2 (220-58-02)",
    "$": 1457600,
    "address": "197 Rawson Rd, Unit 2",
    "parcel_id": "220-58-02",
    "owner1": "SAMUR, MEHMET KEMAL & ANIL AKTAS",
    "owner2": "",
    "current_taxes": 11290.89,
    "new_taxes_no_override": 11778.66,
    "override_total_1": 12112.87,
    "override_increase_1": 334.21
  },
  {
    "#": "197 Rawson Rd, Unit 3 (220-58-03)",
    "$": 1540500,
    "address": "197 Rawson Rd, Unit 3",
    "parcel_id": "220-58-03",
    "owner1": "LOWENSTEIN, MARK",
    "owner2": "MEADER, JENNIFER",
    "current_taxes": 12139.79,
    "new_taxes_no_override": 12664.23,
    "override_total_1": 13023.57,
    "override_increase_1": 359.34
  },
  {
    "#": "198 Rawson Rd, Unit 1 (223-25-01)",
    "$": 2198100,
    "address": "198 Rawson Rd, Unit 1",
    "parcel_id": "223-25-01",
    "owner1": "KIM TRS, WOON CHO",
    "owner2": "SANTHANAM, GOPAL",
    "current_taxes": 18873.61,
    "new_taxes_no_override": 19688.95,
    "override_total_1": 20247.61,
    "override_increase_1": 558.66
  },
  {
    "#": "198 Rawson Rd, Unit 2 (223-25-02)",
    "$": 2456700,
    "address": "198 Rawson Rd, Unit 2",
    "parcel_id": "223-25-02",
    "owner1": "JOSTYN TRS, JAY W & SUSAN W",
    "owner2": "",
    "current_taxes": 25156.61,
    "new_taxes_no_override": 26243.38,
    "override_total_1": 26988.01,
    "override_increase_1": 744.64
  },
  {
    "#": "201 Rawson Rd (220-59-00)",
    "$": 2254000,
    "address": "201 Rawson Rd",
    "parcel_id": "220-59-00",
    "owner1": "STEINBERG TRS, JESSICA",
    "owner2": "SALZBERG, JEREMY",
    "current_taxes": 23080.96,
    "new_taxes_no_override": 24078.06,
    "override_total_1": 24761.25,
    "override_increase_1": 683.2
  },
  {
    "#": "202 Rawson Rd, Unit 1 & P5-P6 (223-24-01)",
    "$": 1992700,
    "address": "202 Rawson Rd, Unit 1 & P5-P6",
    "parcel_id": "223-24-01",
    "owner1": "BOCK, HARVEY N",
    "owner2": "BALZAC, ELENA A",
    "current_taxes": 16770.31,
    "new_taxes_no_override": 17494.79,
    "override_total_1": 17991.19,
    "override_increase_1": 496.4
  },
  {
    "#": "202 Rawson Rd, Unit 2 & P3-P4 (223-24-02)",
    "$": 1711600,
    "address": "202 Rawson Rd, Unit 2 & P3-P4",
    "parcel_id": "223-24-02",
    "owner1": "LANIADO, LISA & DOV",
    "owner2": "",
    "current_taxes": 13891.85,
    "new_taxes_no_override": 14491.98,
    "override_total_1": 14903.18,
    "override_increase_1": 411.2
  },
  {
    "#": "202 Rawson Rd, Unit 3 & P1-P2 (223-24-03)",
    "$": 1936600,
    "address": "202 Rawson Rd, Unit 3 & P1-P2",
    "parcel_id": "223-24-03",
    "owner1": "KLEBANER, STAN",
    "owner2": "GOLDSTEIN, ELENA",
    "current_taxes": 19830.78,
    "new_taxes_no_override": 20687.47,
    "override_total_1": 21274.46,
    "override_increase_1": 586.99
  },
  {
    "#": "205 Rawson Rd (220-60-00)",
    "$": 2296000,
    "address": "205 Rawson Rd",
    "parcel_id": "220-60-00",
    "owner1": "LEE, CHIOUMIN H & LADY H",
    "owner2": "",
    "current_taxes": 19876.11,
    "new_taxes_no_override": 20734.76,
    "override_total_1": 21323.09,
    "override_increase_1": 588.33
  },
  {
    "#": "208 Rawson Rd (223-23-00)",
    "$": 2771500,
    "address": "208 Rawson Rd",
    "parcel_id": "223-23-00",
    "owner1": "FUKS, YEFIM & ANNA B",
    "owner2": "KHASHKES, PETER & ELIANA",
    "current_taxes": 24745.23,
    "new_taxes_no_override": 25814.22,
    "override_total_1": 26546.68,
    "override_increase_1": 732.46
  },
  {
    "#": "222 Rawson Rd, Unit 1 (223-09-50)",
    "$": 902200,
    "address": "222 Rawson Rd, Unit 1",
    "parcel_id": "223-09-50",
    "owner1": "WU, HSIN-JUNG",
    "owner2": "LIU, PO-TING",
    "current_taxes": 5603.59,
    "new_taxes_no_override": 5845.67,
    "override_total_1": 6011.53,
    "override_increase_1": 165.87
  },
  {
    "#": "222 Rawson Rd, Unit 2 (223-09-51)",
    "$": 919300,
    "address": "222 Rawson Rd, Unit 2",
    "parcel_id": "223-09-51",
    "owner1": "DAUBER TRS, EDWARD J & CHERYL S",
    "owner2": "",
    "current_taxes": 9413.63,
    "new_taxes_no_override": 9820.3,
    "override_total_1": 10098.94,
    "override_increase_1": 278.64
  },
  {
    "#": "222 Rawson Rd, Unit 3 & P46 (223-09-52)",
    "$": 919400,
    "address": "222 Rawson Rd, Unit 3 & P46",
    "parcel_id": "223-09-52",
    "owner1": "WEINER, JOSHUA MATTHEW",
    "owner2": "HILL, SHELBY MAE",
    "current_taxes": 5779.72,
    "new_taxes_no_override": 6029.4,
    "override_total_1": 6200.48,
    "override_increase_1": 171.08
  },
  {
    "#": "224 Rawson Rd, Unit 1 (223-09-53)",
    "$": 783500,
    "address": "224 Rawson Rd, Unit 1",
    "parcel_id": "223-09-53",
    "owner1": "HIPSH LIFE ESTATE, ISAAC & EDNA",
    "owner2": "",
    "current_taxes": 4388.11,
    "new_taxes_no_override": 4577.68,
    "override_total_1": 4707.56,
    "override_increase_1": 129.89
  },
  {
    "#": "224 Rawson Rd, Unit 2 (223-09-54)",
    "$": 919300,
    "address": "224 Rawson Rd, Unit 2",
    "parcel_id": "223-09-54",
    "owner1": "SCARAMOZZA, RICHARD",
    "owner2": "MCGOWAN, MARIANNE",
    "current_taxes": 5778.7,
    "new_taxes_no_override": 6028.34,
    "override_total_1": 6199.39,
    "override_increase_1": 171.05
  },
  {
    "#": "224 Rawson Rd, Unit 3 (223-09-55)",
    "$": 958700,
    "address": "224 Rawson Rd, Unit 3",
    "parcel_id": "223-09-55",
    "owner1": "HARRIS TR, ADLYNE SARAH",
    "owner2": "",
    "current_taxes": 9817.09,
    "new_taxes_no_override": 10241.19,
    "override_total_1": 10531.77,
    "override_increase_1": 290.59
  },
  {
    "#": "227 Rawson Rd (221-10-00)",
    "$": 3984600,
    "address": "227 Rawson Rd",
    "parcel_id": "221-10-00",
    "owner1": "RUSSELL, ET AL TRS, WILLIAM W",
    "owner2": "C/O FIELD CORP",
    "current_taxes": 40802.3,
    "new_taxes_no_override": 42564.96,
    "override_total_1": 43772.71,
    "override_increase_1": 1207.75
  },
  {
    "#": "231 Rawson Rd, Unit 1 (221-11-06)",
    "$": 687600,
    "address": "231 Rawson Rd, Unit 1",
    "parcel_id": "221-11-06",
    "owner1": "DENHAM, KEITH ERIC",
    "owner2": "",
    "current_taxes": 7041.02,
    "new_taxes_no_override": 7345.19,
    "override_total_1": 7553.61,
    "override_increase_1": 208.41
  },
  {
    "#": "231 Rawson Rd, Unit 2 (221-11-01)",
    "$": 886700,
    "address": "231 Rawson Rd, Unit 2",
    "parcel_id": "221-11-01",
    "owner1": "FERKO TR, MARTHA M",
    "owner2": "",
    "current_taxes": 5444.87,
    "new_taxes_no_override": 5680.09,
    "override_total_1": 5841.26,
    "override_increase_1": 161.17
  },
  {
    "#": "231 Rawson Rd, Unit 3 (221-11-02)",
    "$": 748500,
    "address": "231 Rawson Rd, Unit 3",
    "parcel_id": "221-11-02",
    "owner1": "SAMPATHU, DARSHAN M",
    "owner2": "",
    "current_taxes": 4029.71,
    "new_taxes_no_override": 4203.79,
    "override_total_1": 4323.07,
    "override_increase_1": 119.28
  },
  {
    "#": "231 Rawson Rd, Unit 4 (221-11-03)",
    "$": 704200,
    "address": "231 Rawson Rd, Unit 4",
    "parcel_id": "221-11-03",
    "owner1": "SMITH, KARA ROSEMARY",
    "owner2": "",
    "current_taxes": 3576.07,
    "new_taxes_no_override": 3730.56,
    "override_total_1": 3836.41,
    "override_increase_1": 105.85
  },
  {
    "#": "231 Rawson Rd, Unit 5 (221-11-04)",
    "$": 739200,
    "address": "231 Rawson Rd, Unit 5",
    "parcel_id": "221-11-04",
    "owner1": "BEINFELD, MOLLY T",
    "owner2": "",
    "current_taxes": 7569.41,
    "new_taxes_no_override": 7896.41,
    "override_total_1": 8120.46,
    "override_increase_1": 224.05
  },
  {
    "#": "231 Rawson Rd, Unit 6 (221-11-05)",
    "$": 741000,
    "address": "231 Rawson Rd, Unit 6",
    "parcel_id": "221-11-05",
    "owner1": "DESHPANDE, ANIKET ARUN",
    "owner2": "CHITGOPEKAR, NEHA RAJEEV",
    "current_taxes": 7587.84,
    "new_taxes_no_override": 7915.63,
    "override_total_1": 8140.23,
    "override_increase_1": 224.6
  },
  {
    "#": "235 Rawson Rd (221-12-00)",
    "$": 3529800,
    "address": "235 Rawson Rd",
    "parcel_id": "221-12-00",
    "owner1": "ZENNER, TRS, ALFRED & MICHELINE",
    "owner2": "",
    "current_taxes": 36145.15,
    "new_taxes_no_override": 37706.62,
    "override_total_1": 38776.52,
    "override_increase_1": 1069.9
  },
  {
    "#": "236 Rawson Rd, Unit 1 (223-18-05)",
    "$": 820000,
    "address": "236 Rawson Rd, Unit 1",
    "parcel_id": "223-18-05",
    "owner1": "FRANK, SUSAN E",
    "owner2": "",
    "current_taxes": 4761.87,
    "new_taxes_no_override": 4967.58,
    "override_total_1": 5108.53,
    "override_increase_1": 140.95
  },
  {
    "#": "236 Rawson Rd, Unit 2 (223-18-01)",
    "$": 674100,
    "address": "236 Rawson Rd, Unit 2",
    "parcel_id": "223-18-01",
    "owner1": "KUPCHIK, ANNA M & KENNETH M",
    "owner2": "",
    "current_taxes": 3267.85,
    "new_taxes_no_override": 3409.02,
    "override_total_1": 3505.75,
    "override_increase_1": 96.73
  },
  {
    "#": "236 Rawson Rd, Unit 3 (223-18-02)",
    "$": 617300,
    "address": "236 Rawson Rd, Unit 3",
    "parcel_id": "223-18-02",
    "owner1": "KUCHINSKY LIFE ESTATE, MARY",
    "owner2": "MILLS LIFE ESTATE, GEORGE ALLEN",
    "current_taxes": 2686.22,
    "new_taxes_no_override": 2802.26,
    "override_total_1": 2881.78,
    "override_increase_1": 79.51
  },
  {
    "#": "236 Rawson Rd, Unit 4 (223-18-03)",
    "$": 705700,
    "address": "236 Rawson Rd, Unit 4",
    "parcel_id": "223-18-03",
    "owner1": "KONARSKI, SUSAN M",
    "owner2": "",
    "current_taxes": 3591.43,
    "new_taxes_no_override": 3746.58,
    "override_total_1": 3852.89,
    "override_increase_1": 106.31
  },
  {
    "#": "236 Rawson Rd, Unit 5 (223-18-04)",
    "$": 1494700,
    "address": "236 Rawson Rd, Unit 5",
    "parcel_id": "223-18-04",
    "owner1": "MCCORMICK, GINNY & ARTHUR",
    "owner2": "",
    "current_taxes": 11670.79,
    "new_taxes_no_override": 12174.97,
    "override_total_1": 12520.42,
    "override_increase_1": 345.46
  },
  {
    "#": "239 Rawson Rd, Unit 1 & P2 (221-13-06)",
    "$": 995300,
    "address": "239 Rawson Rd, Unit 1 & P2",
    "parcel_id": "221-13-06",
    "owner1": "MINCHENKO, YANINO",
    "owner2": "FRADKINE, DMITRI",
    "current_taxes": 10191.87,
    "new_taxes_no_override": 10632.16,
    "override_total_1": 10933.84,
    "override_increase_1": 301.68
  },
  {
    "#": "239 Rawson Rd, Unit 2 & P-1 (221-13-01)",
    "$": 769100,
    "address": "239 Rawson Rd, Unit 2 & P-1",
    "parcel_id": "221-13-01",
    "owner1": "WU, ZHIJUN",
    "owner2": "",
    "current_taxes": 7875.58,
    "new_taxes_no_override": 8215.81,
    "override_total_1": 8448.92,
    "override_increase_1": 233.12
  },
  {
    "#": "239 Rawson Rd, Unit 3 (221-13-02)",
    "$": 864800,
    "address": "239 Rawson Rd, Unit 3",
    "parcel_id": "221-13-02",
    "owner1": "OCONNOR, MARY C",
    "owner2": "",
    "current_taxes": 5220.62,
    "new_taxes_no_override": 5446.15,
    "override_total_1": 5600.68,
    "override_increase_1": 154.53
  },
  {
    "#": "239 Rawson Rd, Unit 4 (221-13-03)",
    "$": 790600,
    "address": "239 Rawson Rd, Unit 4",
    "parcel_id": "221-13-03",
    "owner1": "PIVETEAU, RAPHAEL",
    "owner2": "OH, SUN AH",
    "current_taxes": 8095.74,
    "new_taxes_no_override": 8445.48,
    "override_total_1": 8685.11,
    "override_increase_1": 239.63
  },
  {
    "#": "239 Rawson Rd, Unit 5 (221-13-04)",
    "$": 876600,
    "address": "239 Rawson Rd, Unit 5",
    "parcel_id": "221-13-04",
    "owner1": "KIM, PETER SUNGWHAN",
    "owner2": "JUNG, YOOJIN",
    "current_taxes": 8976.38,
    "new_taxes_no_override": 9364.16,
    "override_total_1": 9629.86,
    "override_increase_1": 265.7
  },
  {
    "#": "239 Rawson Rd, Unit 6 (221-13-05)",
    "$": 799900,
    "address": "239 Rawson Rd, Unit 6",
    "parcel_id": "221-13-05",
    "owner1": "ARAKELOV, KONSTANTIN",
    "owner2": "ARUSTAMYAN, N",
    "current_taxes": 4556.04,
    "new_taxes_no_override": 4752.86,
    "override_total_1": 4887.72,
    "override_increase_1": 134.86
  },
  {
    "#": "1 Regent Cir, Unit 1 P4-P7-P9 (225-52-03)",
    "$": 1250900,
    "address": "1 Regent Cir, Unit 1 P4-P7-P9",
    "parcel_id": "225-52-03",
    "owner1": "SCHONHOFT TRS, JOSEPH D & ELIZABETH",
    "owner2": "",
    "current_taxes": 9174.28,
    "new_taxes_no_override": 9570.61,
    "override_total_1": 9842.17,
    "override_increase_1": 271.56
  },
  {
    "#": "1 Regent Cir, Unit 2 P5-P8 (225-52-01)",
    "$": 1109400,
    "address": "1 Regent Cir, Unit 2 P5-P8",
    "parcel_id": "225-52-01",
    "owner1": "HRISTOV, RUMEN HRISTOV",
    "owner2": "ZHAO, JIE",
    "current_taxes": 7725.32,
    "new_taxes_no_override": 8059.05,
    "override_total_1": 8287.72,
    "override_increase_1": 228.67
  },
  {
    "#": "1 Regent Cir, Unit 3 P1-P2-P3 (225-52-02)",
    "$": 1335300,
    "address": "1 Regent Cir, Unit 3 P1-P2-P3",
    "parcel_id": "225-52-02",
    "owner1": "GREENE, JOSHUA E",
    "owner2": "",
    "current_taxes": 10038.54,
    "new_taxes_no_override": 10472.2,
    "override_total_1": 10769.35,
    "override_increase_1": 297.14
  },
  {
    "#": "1 Regent Cir, Unit P6 (225-52-04)",
    "$": 52500,
    "address": "1 Regent Cir, Unit P6",
    "parcel_id": "225-52-04",
    "owner1": "MARIN TRS, CRAIG & CAROLE",
    "owner2": "",
    "current_taxes": 537.6,
    "new_taxes_no_override": 560.82,
    "override_total_1": 576.74,
    "override_increase_1": 15.91
  },
  {
    "#": "3 Regent Cir (225-51-00)",
    "$": 2561500,
    "address": "3 Regent Cir",
    "parcel_id": "225-51-00",
    "owner1": "MELEGER, ALEC L & KARINA",
    "owner2": "",
    "current_taxes": 22594.83,
    "new_taxes_no_override": 23570.93,
    "override_total_1": 24239.73,
    "override_increase_1": 668.81
  },
  {
    "#": "5 Regent Cir (225-50-00)",
    "$": 2805100,
    "address": "5 Regent Cir",
    "parcel_id": "225-50-00",
    "owner1": "ZHAO TR, YANRU",
    "owner2": "",
    "current_taxes": 25089.29,
    "new_taxes_no_override": 26173.15,
    "override_total_1": 26915.79,
    "override_increase_1": 742.64
  },
  {
    "#": "7 Regent Cir, Unit 1 & P-2 (225-49-01)",
    "$": 571500,
    "address": "7 Regent Cir, Unit 1 & P-2",
    "parcel_id": "225-49-01",
    "owner1": "KAUFMAN, ANDREW S",
    "owner2": "",
    "current_taxes": 5852.16,
    "new_taxes_no_override": 6104.97,
    "override_total_1": 6278.2,
    "override_increase_1": 173.22
  },
  {
    "#": "7 Regent Cir, Unit 2 & Prk 1 (225-49-02)",
    "$": 751300,
    "address": "7 Regent Cir, Unit 2 & Prk 1",
    "parcel_id": "225-49-02",
    "owner1": "SIMAN, DARREN",
    "owner2": "",
    "current_taxes": 7693.31,
    "new_taxes_no_override": 8025.66,
    "override_total_1": 8253.38,
    "override_increase_1": 227.72
  },
  {
    "#": "7 Regent Cir, Unit 3 & P6 (225-49-03)",
    "$": 815500,
    "address": "7 Regent Cir, Unit 3 & P6",
    "parcel_id": "225-49-03",
    "owner1": "DONNELLY, KATHLEEN M",
    "owner2": "",
    "current_taxes": 8350.72,
    "new_taxes_no_override": 8711.47,
    "override_total_1": 8958.65,
    "override_increase_1": 247.18
  },
  {
    "#": "7 Regent Cir, Unit 4 & P-5 (225-49-04)",
    "$": 815500,
    "address": "7 Regent Cir, Unit 4 & P-5",
    "parcel_id": "225-49-04",
    "owner1": "LEVIN TR, CHARLES",
    "owner2": "C/O LEVIN LAW OFFICES",
    "current_taxes": 8350.72,
    "new_taxes_no_override": 8711.47,
    "override_total_1": 8958.65,
    "override_increase_1": 247.18
  },
  {
    "#": "7 Regent Cir, Unit 5 & P-4 (225-49-05)",
    "$": 757100,
    "address": "7 Regent Cir, Unit 5 & P-4",
    "parcel_id": "225-49-05",
    "owner1": "SUISSA, ELISA L",
    "owner2": "MOUNTAIN, ANDREW",
    "current_taxes": 7752.7,
    "new_taxes_no_override": 8087.62,
    "override_total_1": 8317.1,
    "override_increase_1": 229.48
  },
  {
    "#": "9 Regent Cir (225-48-00)",
    "$": 3159400,
    "address": "9 Regent Cir",
    "parcel_id": "225-48-00",
    "owner1": "DORMIE LLC",
    "owner2": "C/O CENTURY 21 CITYSIDE",
    "current_taxes": 32352.26,
    "new_taxes_no_override": 33749.88,
    "override_total_1": 34707.5,
    "override_increase_1": 957.63
  },
  {
    "#": "11 Regent Cir, Unit 1 (225-47-01)",
    "$": 981300,
    "address": "11 Regent Cir, Unit 1",
    "parcel_id": "225-47-01",
    "owner1": "LUSTIG, KEVIN B",
    "owner2": "",
    "current_taxes": 6413.58,
    "new_taxes_no_override": 6690.65,
    "override_total_1": 6880.49,
    "override_increase_1": 189.84
  },
  {
    "#": "11 Regent Cir, Unit 2 (225-47-02)",
    "$": 858800,
    "address": "11 Regent Cir, Unit 2",
    "parcel_id": "225-47-02",
    "owner1": "SIMEONOVA, SILVIYA",
    "owner2": "TOMOV, TOMA",
    "current_taxes": 5159.18,
    "new_taxes_no_override": 5382.06,
    "override_total_1": 5534.77,
    "override_increase_1": 152.71
  },
  {
    "#": "11 Regent Cir, Unit 3 (225-47-03)",
    "$": 863700,
    "address": "11 Regent Cir, Unit 3",
    "parcel_id": "225-47-03",
    "owner1": "POWERS, ALLA",
    "owner2": "",
    "current_taxes": 5209.35,
    "new_taxes_no_override": 5434.39,
    "override_total_1": 5588.59,
    "override_increase_1": 154.2
  },
  {
    "#": "11 Regent Cir, Unit 4 (225-47-04)",
    "$": 871200,
    "address": "11 Regent Cir, Unit 4",
    "parcel_id": "225-47-04",
    "owner1": "UNUR, MICHELLE ANGELA MORENCY & MURAT",
    "owner2": "",
    "current_taxes": 5286.15,
    "new_taxes_no_override": 5514.51,
    "override_total_1": 5670.98,
    "override_increase_1": 156.47
  },
  {
    "#": "11 Regent Cir, Unit 5 (225-47-05)",
    "$": 880300,
    "address": "11 Regent Cir, Unit 5",
    "parcel_id": "225-47-05",
    "owner1": "SOGG, STEPHANIE",
    "owner2": "",
    "current_taxes": 5379.34,
    "new_taxes_no_override": 5611.73,
    "override_total_1": 5770.96,
    "override_increase_1": 159.23
  },
  {
    "#": "13 Regent Cir, Unit 1 (225-46-01)",
    "$": 472000,
    "address": "13 Regent Cir, Unit 1",
    "parcel_id": "225-46-01",
    "owner1": "DEBIASSE, MICHELE A",
    "owner2": "",
    "current_taxes": 1198.35,
    "new_taxes_no_override": 1250.12,
    "override_total_1": 1285.59,
    "override_increase_1": 35.47
  },
  {
    "#": "13 Regent Cir, Unit 2 (225-46-02)",
    "$": 2279800,
    "address": "13 Regent Cir, Unit 2",
    "parcel_id": "225-46-02",
    "owner1": "TRUONG, MINH TAM",
    "owner2": "",
    "current_taxes": 19710.22,
    "new_taxes_no_override": 20561.7,
    "override_total_1": 21145.12,
    "override_increase_1": 583.42
  },
  {
    "#": "15 Regent Cir (225-45-00)",
    "$": 2782400,
    "address": "15 Regent Cir",
    "parcel_id": "225-45-00",
    "owner1": "SCHWARTZ, PHILIPPE & MICHELLE",
    "owner2": "",
    "current_taxes": 28491.78,
    "new_taxes_no_override": 29722.62,
    "override_total_1": 30565.98,
    "override_increase_1": 843.36
  },
  {
    "#": "17 Regent Cir, Unit 1 (225-44-01)",
    "$": 827000,
    "address": "17 Regent Cir, Unit 1",
    "parcel_id": "225-44-01",
    "owner1": "ZHANG, TERESA",
    "owner2": "DONNELLY, GORMAN",
    "current_taxes": 4833.55,
    "new_taxes_no_override": 5042.36,
    "override_total_1": 5185.43,
    "override_increase_1": 143.07
  },
  {
    "#": "17 Regent Cir, Unit 2 (225-44-02)",
    "$": 928700,
    "address": "17 Regent Cir, Unit 2",
    "parcel_id": "225-44-02",
    "owner1": "SOFTIC, SAMIR & NORAH ALARAIFI",
    "owner2": "",
    "current_taxes": 9509.89,
    "new_taxes_no_override": 9920.72,
    "override_total_1": 10202.21,
    "override_increase_1": 281.49
  },
  {
    "#": "17 Regent Cir, Unit 3 (225-44-03)",
    "$": 976100,
    "address": "17 Regent Cir, Unit 3",
    "parcel_id": "225-44-03",
    "owner1": "EPSTEIN, LEONID & JANE",
    "owner2": "",
    "current_taxes": 9995.26,
    "new_taxes_no_override": 10427.06,
    "override_total_1": 10722.91,
    "override_increase_1": 295.86
  },
  {
    "#": "17 Regent Cir, Unit 4 (225-44-04)",
    "$": 910500,
    "address": "17 Regent Cir, Unit 4",
    "parcel_id": "225-44-04",
    "owner1": "ILIC, MARIJA",
    "owner2": "RADAKOVIC, DUSAN",
    "current_taxes": 5688.59,
    "new_taxes_no_override": 5934.34,
    "override_total_1": 6102.72,
    "override_increase_1": 168.38
  },
  {
    "#": "17 Regent Cir, Unit 5 (225-44-05)",
    "$": 1337500,
    "address": "17 Regent Cir, Unit 5",
    "parcel_id": "225-44-05",
    "owner1": "LEE, SUJIN",
    "owner2": "NOH, SUNGHO",
    "current_taxes": 10061.07,
    "new_taxes_no_override": 10495.71,
    "override_total_1": 10793.52,
    "override_increase_1": 297.81
  },
  {
    "#": "19 Regent Cir, Unit 1 & Pk C & D (225-43-01)",
    "$": 1170900,
    "address": "19 Regent Cir, Unit 1 & Pk C & D",
    "parcel_id": "225-43-01",
    "owner1": "LEE, JIA NA",
    "owner2": "",
    "current_taxes": 8355.08,
    "new_taxes_no_override": 8716.02,
    "override_total_1": 8963.33,
    "override_increase_1": 247.31
  },
  {
    "#": "19 Regent Cir, Unit 2 Pk E & F (225-43-02)",
    "$": 1205200,
    "address": "19 Regent Cir, Unit 2 Pk E & F",
    "parcel_id": "225-43-02",
    "owner1": "BRILLIANT TRS, LYNNE B",
    "owner2": "SHELTON, WANDA J",
    "current_taxes": 8706.31,
    "new_taxes_no_override": 9082.42,
    "override_total_1": 9340.13,
    "override_increase_1": 257.71
  },
  {
    "#": "19 Regent Cir, Unit 3 (225-43-03)",
    "$": 1199500,
    "address": "19 Regent Cir, Unit 3",
    "parcel_id": "225-43-03",
    "owner1": "CONAHAN, STEVEN G",
    "owner2": "",
    "current_taxes": 8647.95,
    "new_taxes_no_override": 9021.54,
    "override_total_1": 9277.52,
    "override_increase_1": 255.98
  },
  {
    "#": "21 Regent Cir (225-42-00)",
    "$": 2997400,
    "address": "21 Regent Cir",
    "parcel_id": "225-42-00",
    "owner1": "21 RRDI LLC",
    "owner2": "",
    "current_taxes": 30693.38,
    "new_taxes_no_override": 32019.33,
    "override_total_1": 32927.86,
    "override_increase_1": 908.52
  },
  {
    "#": "23 Regent Cir (225-41-00)",
    "$": 3054400,
    "address": "23 Regent Cir",
    "parcel_id": "225-41-00",
    "owner1": "DREYFUS TRS, ANDREW",
    "owner2": "ROSENTHAL, MEREDITH",
    "current_taxes": 27642.12,
    "new_taxes_no_override": 28836.26,
    "override_total_1": 29654.47,
    "override_increase_1": 818.21
  },
  {
    "#": "25 Regent Cir (225-40-03)",
    "$": 3749400,
    "address": "25 Regent Cir",
    "parcel_id": "225-40-03",
    "owner1": "GLASS, AMY HART",
    "owner2": "",
    "current_taxes": 38393.86,
    "new_taxes_no_override": 40052.47,
    "override_total_1": 41188.93,
    "override_increase_1": 1136.46
  },
  {
    "#": "30 Regent Cir, Unit 30 (225-32-23)",
    "$": 1178600,
    "address": "30 Regent Cir, Unit 30",
    "parcel_id": "225-32-23",
    "owner1": "D L M REGENT LLC",
    "owner2": "",
    "current_taxes": 12068.86,
    "new_taxes_no_override": 12590.23,
    "override_total_1": 12947.47,
    "override_increase_1": 357.24
  },
  {
    "#": "32 Regent Cir, Unit 32 (225-32-22)",
    "$": 1183600,
    "address": "32 Regent Cir, Unit 32",
    "parcel_id": "225-32-22",
    "owner1": "ORNELAS, PABLO CASTRO",
    "owner2": "WISNIEWSKI, MICHELLE  AGUILAR",
    "current_taxes": 8485.13,
    "new_taxes_no_override": 8851.69,
    "override_total_1": 9102.85,
    "override_increase_1": 251.16
  },
  {
    "#": "34 Regent Cir, Unit 34 (225-32-21)",
    "$": 1165400,
    "address": "34 Regent Cir, Unit 34",
    "parcel_id": "225-32-21",
    "owner1": "MORA, RENE & ESMARAGDA",
    "owner2": "",
    "current_taxes": 8298.76,
    "new_taxes_no_override": 8657.27,
    "override_total_1": 8902.91,
    "override_increase_1": 245.64
  },
  {
    "#": "36 Regent Cir, Unit 36 (225-32-20)",
    "$": 1169500,
    "address": "36 Regent Cir, Unit 36",
    "parcel_id": "225-32-20",
    "owner1": "BUCK-LEW TR, MAYLUN",
    "owner2": "",
    "current_taxes": 8340.75,
    "new_taxes_no_override": 8701.07,
    "override_total_1": 8947.96,
    "override_increase_1": 246.89
  },
  {
    "#": "38 Regent Cir, Unit 38 (225-32-19)",
    "$": 1176900,
    "address": "38 Regent Cir, Unit 38",
    "parcel_id": "225-32-19",
    "owner1": "KIM, SIMON S",
    "owner2": "PARK, SANG EUN",
    "current_taxes": 12051.46,
    "new_taxes_no_override": 12572.08,
    "override_total_1": 12928.81,
    "override_increase_1": 356.72
  },
  {
    "#": "40 Regent Cir, Unit 40 (225-32-18)",
    "$": 1185100,
    "address": "40 Regent Cir, Unit 40",
    "parcel_id": "225-32-18",
    "owner1": "CELTRUDA TRS, MICHAEL ORAZIO",
    "owner2": "SIMOSA, CAROLINA DESIREE",
    "current_taxes": 8500.49,
    "new_taxes_no_override": 8867.71,
    "override_total_1": 9119.33,
    "override_increase_1": 251.61
  },
  {
    "#": "42 Regent Cir, Unit 42 (225-32-17)",
    "$": 1181400,
    "address": "42 Regent Cir, Unit 42",
    "parcel_id": "225-32-17",
    "owner1": "ELLIS, JEFFREY HENDERSON",
    "owner2": "QUAN, XIAOHANG",
    "current_taxes": 8462.6,
    "new_taxes_no_override": 8828.18,
    "override_total_1": 9078.68,
    "override_increase_1": 250.49
  },
  {
    "#": "44 Regent Cir, Unit 44 (225-32-16)",
    "$": 1214500,
    "address": "44 Regent Cir, Unit 44",
    "parcel_id": "225-32-16",
    "owner1": "JOHNSON, BRYAN & ELIN WYTRWAL",
    "owner2": "",
    "current_taxes": 8801.55,
    "new_taxes_no_override": 9181.78,
    "override_total_1": 9442.3,
    "override_increase_1": 260.53
  },
  {
    "#": "46 Regent Cir, Unit 46 (225-32-15)",
    "$": 1212000,
    "address": "46 Regent Cir, Unit 46",
    "parcel_id": "225-32-15",
    "owner1": "KRIZ TR, ELIZABETH MERA",
    "owner2": "",
    "current_taxes": 8775.95,
    "new_taxes_no_override": 9155.07,
    "override_total_1": 9414.84,
    "override_increase_1": 259.77
  },
  {
    "#": "48 Regent Cir, Unit 48 (225-32-14)",
    "$": 1178200,
    "address": "48 Regent Cir, Unit 48",
    "parcel_id": "225-32-14",
    "owner1": "SHARP, JOSHUA",
    "owner2": "BLANKSTEIN, SARAH",
    "current_taxes": 8429.83,
    "new_taxes_no_override": 8794.0,
    "override_total_1": 9043.52,
    "override_increase_1": 249.52
  },
  {
    "#": "50 Regent Cir, Unit 50 (225-32-13)",
    "$": 1173200,
    "address": "50 Regent Cir, Unit 50",
    "parcel_id": "225-32-13",
    "owner1": "PIKI LLC",
    "owner2": "",
    "current_taxes": 12013.57,
    "new_taxes_no_override": 12532.56,
    "override_total_1": 12888.16,
    "override_increase_1": 355.6
  },
  {
    "#": "52 Regent Cir, Unit 52 (225-32-12)",
    "$": 1190900,
    "address": "52 Regent Cir, Unit 52",
    "parcel_id": "225-32-12",
    "owner1": "SHIEKH, SHAHID",
    "owner2": "NAZ, AFSHAN",
    "current_taxes": 8559.88,
    "new_taxes_no_override": 8929.67,
    "override_total_1": 9183.04,
    "override_increase_1": 253.37
  },
  {
    "#": "54 Regent Cir, Unit 54 (225-32-11)",
    "$": 1177800,
    "address": "54 Regent Cir, Unit 54",
    "parcel_id": "225-32-11",
    "owner1": "SCHULZE, ELIZABETH M",
    "owner2": "",
    "current_taxes": 12060.67,
    "new_taxes_no_override": 12581.69,
    "override_total_1": 12938.69,
    "override_increase_1": 357.0
  },
  {
    "#": "56 Regent Cir, Unit 56 (225-32-10)",
    "$": 1172000,
    "address": "56 Regent Cir, Unit 56",
    "parcel_id": "225-32-10",
    "owner1": "VALENTINE, BENJAMIN & OLGA B",
    "owner2": "",
    "current_taxes": 8366.35,
    "new_taxes_no_override": 8727.78,
    "override_total_1": 8975.42,
    "override_increase_1": 247.64
  },
  {
    "#": "58 Regent Cir, Unit 58 (225-32-09)",
    "$": 1186400,
    "address": "58 Regent Cir, Unit 58",
    "parcel_id": "225-32-09",
    "owner1": "SAIF, WASIF M",
    "owner2": "",
    "current_taxes": 12148.74,
    "new_taxes_no_override": 12673.57,
    "override_total_1": 13033.17,
    "override_increase_1": 359.6
  },
  {
    "#": "60 Regent Cir, Unit 60 (225-32-08)",
    "$": 1178200,
    "address": "60 Regent Cir, Unit 60",
    "parcel_id": "225-32-08",
    "owner1": "BEEBE, SUSAN",
    "owner2": "",
    "current_taxes": 8429.83,
    "new_taxes_no_override": 8794.0,
    "override_total_1": 9043.52,
    "override_increase_1": 249.52
  },
  {
    "#": "62 Regent Cir, Unit 62 (225-32-07)",
    "$": 1176000,
    "address": "62 Regent Cir, Unit 62",
    "parcel_id": "225-32-07",
    "owner1": "NISENZON, NATALIA & FEY",
    "owner2": "ALIEVSKY, SERGEI",
    "current_taxes": 8407.31,
    "new_taxes_no_override": 8770.51,
    "override_total_1": 9019.36,
    "override_increase_1": 248.86
  },
  {
    "#": "64 Regent Cir, Unit 64 (225-32-06)",
    "$": 1192100,
    "address": "64 Regent Cir, Unit 64",
    "parcel_id": "225-32-06",
    "owner1": "RICHARDSON, FREDERICK S",
    "owner2": "GREEN, ANN E",
    "current_taxes": 8572.17,
    "new_taxes_no_override": 8942.49,
    "override_total_1": 9196.22,
    "override_increase_1": 253.74
  },
  {
    "#": "66 Regent Cir, Unit 66 (225-32-05)",
    "$": 1184700,
    "address": "66 Regent Cir, Unit 66",
    "parcel_id": "225-32-05",
    "owner1": "CAI, CUIMAN",
    "owner2": "",
    "current_taxes": 8496.39,
    "new_taxes_no_override": 8863.43,
    "override_total_1": 9114.93,
    "override_increase_1": 251.49
  },
  {
    "#": "68 Regent Cir, Unit 68 (225-32-04)",
    "$": 1197900,
    "address": "68 Regent Cir, Unit 68",
    "parcel_id": "225-32-04",
    "owner1": "LUDERGNANI TRS, REMO & NORMA",
    "owner2": "",
    "current_taxes": 12266.5,
    "new_taxes_no_override": 12796.41,
    "override_total_1": 13159.5,
    "override_increase_1": 363.09
  },
  {
    "#": "70 Regent Cir, Unit 70 (225-32-03)",
    "$": 1172000,
    "address": "70 Regent Cir, Unit 70",
    "parcel_id": "225-32-03",
    "owner1": "CHIDAMBARAN, PUTHUGRAMANT K & PREETA",
    "owner2": "",
    "current_taxes": 12001.28,
    "new_taxes_no_override": 12519.74,
    "override_total_1": 12874.97,
    "override_increase_1": 355.24
  },
  {
    "#": "72 Regent Cir, Unit 72 (225-32-02)",
    "$": 1193700,
    "address": "72 Regent Cir, Unit 72",
    "parcel_id": "225-32-02",
    "owner1": "GREENWOOD, ALISSA",
    "owner2": "STEARNS, BEN",
    "current_taxes": 8588.55,
    "new_taxes_no_override": 8959.58,
    "override_total_1": 9213.8,
    "override_increase_1": 254.22
  },
  {
    "#": "74 Regent Cir, Unit 74 (225-32-01)",
    "$": 1196600,
    "address": "74 Regent Cir, Unit 74",
    "parcel_id": "225-32-01",
    "owner1": "BELL TRS, SCOTT A",
    "owner2": "SUGIMORI, MARIKO C V",
    "current_taxes": 12253.18,
    "new_taxes_no_override": 12782.52,
    "override_total_1": 13145.21,
    "override_increase_1": 362.69
  },
  {
    "#": "76 Regent Cir, Unit 76 (225-32-24)",
    "$": 1183200,
    "address": "76 Regent Cir, Unit 76",
    "parcel_id": "225-32-24",
    "owner1": "ROTHENBERG, NANCEE JOY",
    "owner2": "",
    "current_taxes": 8481.03,
    "new_taxes_no_override": 8847.41,
    "override_total_1": 9098.45,
    "override_increase_1": 251.04
  },
  {
    "#": " Regent Cir, Unit P1 (225-30-00)",
    "$": 77500,
    "address": " Regent Cir, Unit P1",
    "parcel_id": "225-30-00",
    "owner1": "VOLLOCH, VLADIMIR & SOPHIA",
    "owner2": "",
    "current_taxes": 793.6,
    "new_taxes_no_override": 827.88,
    "override_total_1": 851.37,
    "override_increase_1": 23.49
  },
  {
    "#": " Regent Cir, Unit P10 (225-30-09)",
    "$": 77500,
    "address": " Regent Cir, Unit P10",
    "parcel_id": "225-30-09",
    "owner1": "BERKLEIN, FLORA",
    "owner2": "STADLER, CHRISTOPHER",
    "current_taxes": 793.6,
    "new_taxes_no_override": 827.88,
    "override_total_1": 851.37,
    "override_increase_1": 23.49
  },
  {
    "#": " Regent Cir, Unit P12 (225-30-10)",
    "$": 77500,
    "address": " Regent Cir, Unit P12",
    "parcel_id": "225-30-10",
    "owner1": "TSELEVICH, ALEKSANDR & MARIA",
    "owner2": "",
    "current_taxes": 793.6,
    "new_taxes_no_override": 827.88,
    "override_total_1": 851.37,
    "override_increase_1": 23.49
  },
  {
    "#": " Regent Cir, Unit P2 (225-30-01)",
    "$": 77500,
    "address": " Regent Cir, Unit P2",
    "parcel_id": "225-30-01",
    "owner1": "TRUONG, MINH TAM",
    "owner2": "",
    "current_taxes": 793.6,
    "new_taxes_no_override": 827.88,
    "override_total_1": 851.37,
    "override_increase_1": 23.49
  },
  {
    "#": " Regent Cir, Unit P3 (225-30-02)",
    "$": 77500,
    "address": " Regent Cir, Unit P3",
    "parcel_id": "225-30-02",
    "owner1": "QI, HUIWEN",
    "owner2": "",
    "current_taxes": 793.6,
    "new_taxes_no_override": 827.88,
    "override_total_1": 851.37,
    "override_increase_1": 23.49
  },
  {
    "#": " Regent Cir, Unit P4 (225-30-03)",
    "$": 77500,
    "address": " Regent Cir, Unit P4",
    "parcel_id": "225-30-03",
    "owner1": "MCINTYRE, KEVIN",
    "owner2": "YAZDI, SARA",
    "current_taxes": 793.6,
    "new_taxes_no_override": 827.88,
    "override_total_1": 851.37,
    "override_increase_1": 23.49
  },
  {
    "#": " Regent Cir, Unit P5 (225-30-04)",
    "$": 77500,
    "address": " Regent Cir, Unit P5",
    "parcel_id": "225-30-04",
    "owner1": "LEWIS, JOHN H",
    "owner2": "",
    "current_taxes": 793.6,
    "new_taxes_no_override": 827.88,
    "override_total_1": 851.37,
    "override_increase_1": 23.49
  },
  {
    "#": " Regent Cir, Unit P6 (225-30-05)",
    "$": 77500,
    "address": " Regent Cir, Unit P6",
    "parcel_id": "225-30-05",
    "owner1": "SCHWARTZ, PHILIPPE & MICHELLE",
    "owner2": "",
    "current_taxes": 793.6,
    "new_taxes_no_override": 827.88,
    "override_total_1": 851.37,
    "override_increase_1": 23.49
  },
  {
    "#": " Regent Cir, Unit P7 (225-30-06)",
    "$": 77500,
    "address": " Regent Cir, Unit P7",
    "parcel_id": "225-30-06",
    "owner1": "SCHWARTZ, PHILIPPE & MICHELLE",
    "owner2": "",
    "current_taxes": 793.6,
    "new_taxes_no_override": 827.88,
    "override_total_1": 851.37,
    "override_increase_1": 23.49
  },
  {
    "#": " Regent Cir, Unit P8 (225-30-07)",
    "$": 77500,
    "address": " Regent Cir, Unit P8",
    "parcel_id": "225-30-07",
    "owner1": "SAEIDIAN TR, GITI GANJEI",
    "owner2": "",
    "current_taxes": 793.6,
    "new_taxes_no_override": 827.88,
    "override_total_1": 851.37,
    "override_increase_1": 23.49
  },
  {
    "#": " Regent Cir, Unit P9 (225-30-08)",
    "$": 77500,
    "address": " Regent Cir, Unit P9",
    "parcel_id": "225-30-08",
    "owner1": "SAEIDIAN TR, GITI GANJEI",
    "owner2": "",
    "current_taxes": 793.6,
    "new_taxes_no_override": 827.88,
    "override_total_1": 851.37,
    "override_increase_1": 23.49
  },
  {
    "#": "54 Reservoir Ln (266-02-03)",
    "$": 4160600,
    "address": "54 Reservoir Ln",
    "parcel_id": "266-02-03",
    "owner1": "HILT TR, STEPHEN A",
    "owner2": "",
    "current_taxes": 38969.61,
    "new_taxes_no_override": 40653.1,
    "override_total_1": 41806.6,
    "override_increase_1": 1153.5
  },
  {
    "#": "57 Reservoir Ln (265-36-00)",
    "$": 4314700,
    "address": "57 Reservoir Ln",
    "parcel_id": "265-36-00",
    "owner1": "COLE, GEORGE N & KARIN P",
    "owner2": "",
    "current_taxes": 40547.59,
    "new_taxes_no_override": 42299.25,
    "override_total_1": 43499.45,
    "override_increase_1": 1200.21
  },
  {
    "#": "63 Reservoir Ln (265-37-00)",
    "$": 6355100,
    "address": "63 Reservoir Ln",
    "parcel_id": "265-37-00",
    "owner1": "HOPE, SEAN D & TIFFANY MITCHELL",
    "owner2": "",
    "current_taxes": 65076.22,
    "new_taxes_no_override": 67887.51,
    "override_total_1": 69813.77,
    "override_increase_1": 1926.26
  },
  {
    "#": "249 Reservoir Ln (266-04-00)",
    "$": 2274400,
    "address": "249 Reservoir Ln",
    "parcel_id": "266-04-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O VACANT PARCEL/ABUT 285 RSRVR",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "9 Reservoir Rd (276-19-00)",
    "$": 1728700,
    "address": "9 Reservoir Rd",
    "parcel_id": "276-19-00",
    "owner1": "MOOSA, E MOOSA",
    "owner2": "",
    "current_taxes": 17701.89,
    "new_taxes_no_override": 18466.61,
    "override_total_1": 18990.59,
    "override_increase_1": 523.98
  },
  {
    "#": "15 Reservoir Rd (276-19-01)",
    "$": 1963900,
    "address": "15 Reservoir Rd",
    "parcel_id": "276-19-01",
    "owner1": "WONG, STANLEY & EVELYN L",
    "owner2": "",
    "current_taxes": 20110.34,
    "new_taxes_no_override": 20979.11,
    "override_total_1": 21574.37,
    "override_increase_1": 595.27
  },
  {
    "#": "19 Reservoir Rd (276-20-00)",
    "$": 1332500,
    "address": "19 Reservoir Rd",
    "parcel_id": "276-20-00",
    "owner1": "MAK, ET AL, KAM B",
    "owner2": "",
    "current_taxes": 10009.87,
    "new_taxes_no_override": 10442.3,
    "override_total_1": 10738.59,
    "override_increase_1": 296.29
  },
  {
    "#": "20 Reservoir Rd (437-75-00)",
    "$": 3394100,
    "address": "20 Reservoir Rd",
    "parcel_id": "437-75-00",
    "owner1": "HESS, MARIKA & PHILIP",
    "owner2": "",
    "current_taxes": 31120.65,
    "new_taxes_no_override": 32465.06,
    "override_total_1": 33386.23,
    "override_increase_1": 921.17
  },
  {
    "#": "46 Reservoir Rd (437-12-00)",
    "$": 1482700,
    "address": "46 Reservoir Rd",
    "parcel_id": "437-12-00",
    "owner1": "BOSTON EDISON CO",
    "owner2": "C/O NSTAR PROPERTY TAX DEPT",
    "current_taxes": 25443.13,
    "new_taxes_no_override": 26542.27,
    "override_total_1": 27295.39,
    "override_increase_1": 753.12
  },
  {
    "#": "51 Reservoir Rd (276-21-04)",
    "$": 3547400,
    "address": "51 Reservoir Rd",
    "parcel_id": "276-21-04",
    "owner1": "ROMAN CATHOLIC ARCHBISHOP OF BOSTON",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "55 Reservoir Rd, Unit 1 (276-05-01)",
    "$": 954100,
    "address": "55 Reservoir Rd, Unit 1",
    "parcel_id": "276-05-01",
    "owner1": "HSIAO, HUI CHING",
    "owner2": "CHIOU, GEORGE",
    "current_taxes": 6135.05,
    "new_taxes_no_override": 6400.08,
    "override_total_1": 6581.68,
    "override_increase_1": 181.6
  },
  {
    "#": "55 Reservoir Rd, Unit 2 (276-05-02)",
    "$": 714400,
    "address": "55 Reservoir Rd, Unit 2",
    "parcel_id": "276-05-02",
    "owner1": "WEI, SHUAI",
    "owner2": "ZHOU, WEI",
    "current_taxes": 3680.52,
    "new_taxes_no_override": 3839.52,
    "override_total_1": 3948.46,
    "override_increase_1": 108.94
  },
  {
    "#": "55 Reservoir Rd, Unit 3 (276-05-03)",
    "$": 850600,
    "address": "55 Reservoir Rd, Unit 3",
    "parcel_id": "276-05-03",
    "owner1": "SHU, LI",
    "owner2": "",
    "current_taxes": 8710.14,
    "new_taxes_no_override": 9086.42,
    "override_total_1": 9344.24,
    "override_increase_1": 257.82
  },
  {
    "#": "70 Reservoir Rd (437-11-00)",
    "$": 9817900,
    "address": "70 Reservoir Rd",
    "parcel_id": "437-11-00",
    "owner1": "CHESTNUT EQUITY PARTNERS I LLC",
    "owner2": "C/O AEGEAN CAPITAL LLC",
    "current_taxes": 168475.16,
    "new_taxes_no_override": 175753.29,
    "override_total_1": 180740.15,
    "override_increase_1": 4986.86
  },
  {
    "#": "109 Reservoir Rd (277-01-02)",
    "$": 1358800,
    "address": "109 Reservoir Rd",
    "parcel_id": "277-01-02",
    "owner1": "COMMONWEALTH OF MASSACHUSETTS",
    "owner2": "C/O MASS WATER RESOURCES AUTHORITY",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "144 Reservoir Rd (278-31-00)",
    "$": 2312800,
    "address": "144 Reservoir Rd",
    "parcel_id": "278-31-00",
    "owner1": "KHOURY, NHAIM & SARAH ELIZABETH MAYA",
    "owner2": "",
    "current_taxes": 20048.14,
    "new_taxes_no_override": 20914.22,
    "override_total_1": 21507.64,
    "override_increase_1": 593.42
  },
  {
    "#": "154 Reservoir Rd (278-30-00)",
    "$": 2905500,
    "address": "154 Reservoir Rd",
    "parcel_id": "278-30-00",
    "owner1": "BEDARD, JONATHAN A & JULIE C",
    "owner2": "",
    "current_taxes": 26117.39,
    "new_taxes_no_override": 27245.66,
    "override_total_1": 28018.74,
    "override_increase_1": 773.07
  },
  {
    "#": "155 Reservoir Rd (277-02-00)",
    "$": 2530300,
    "address": "155 Reservoir Rd",
    "parcel_id": "277-02-00",
    "owner1": "HAWKINS, THOMAS H & JENNIFER C",
    "owner2": "",
    "current_taxes": 22275.34,
    "new_taxes_no_override": 23237.63,
    "override_total_1": 23896.98,
    "override_increase_1": 659.35
  },
  {
    "#": "160 Reservoir Rd (278-29-00)",
    "$": 2231700,
    "address": "160 Reservoir Rd",
    "parcel_id": "278-29-00",
    "owner1": "HAO, ZHONGMING",
    "owner2": "",
    "current_taxes": 22852.61,
    "new_taxes_no_override": 23839.84,
    "override_total_1": 24516.28,
    "override_increase_1": 676.44
  },
  {
    "#": "161 Reservoir Rd (277-03-00)",
    "$": 2335000,
    "address": "161 Reservoir Rd",
    "parcel_id": "277-03-00",
    "owner1": "JONES, FRANCIS ARTHUR II",
    "owner2": "THAKURIA, MANISHA",
    "current_taxes": 23910.4,
    "new_taxes_no_override": 24943.33,
    "override_total_1": 25651.08,
    "override_increase_1": 707.75
  },
  {
    "#": "167 Reservoir Rd (277-03-01)",
    "$": 1978600,
    "address": "167 Reservoir Rd",
    "parcel_id": "277-03-01",
    "owner1": "BHATTACHARYA, SAGNIK & ANJANA",
    "owner2": "",
    "current_taxes": 16625.93,
    "new_taxes_no_override": 17344.17,
    "override_total_1": 17836.3,
    "override_increase_1": 492.13
  },
  {
    "#": "170 Reservoir Rd (278-28-00)",
    "$": 2437000,
    "address": "170 Reservoir Rd",
    "parcel_id": "278-28-00",
    "owner1": "MCDERMOTT, GREGORY",
    "owner2": "MADVA, ELIZABETH",
    "current_taxes": 21319.95,
    "new_taxes_no_override": 22240.97,
    "override_total_1": 22872.04,
    "override_increase_1": 631.07
  },
  {
    "#": "171 Reservoir Rd (277-04-00)",
    "$": 2303400,
    "address": "171 Reservoir Rd",
    "parcel_id": "277-04-00",
    "owner1": "DONG TRS, YONG",
    "owner2": "PIAO TR, XIANHUA",
    "current_taxes": 19951.88,
    "new_taxes_no_override": 20813.8,
    "override_total_1": 21404.38,
    "override_increase_1": 590.58
  },
  {
    "#": "176 Reservoir Rd (278-27-00)",
    "$": 1970800,
    "address": "176 Reservoir Rd",
    "parcel_id": "278-27-00",
    "owner1": "HUNNEWELL  TRS, JAMES F JR & SUSAN W",
    "owner2": "",
    "current_taxes": 16546.06,
    "new_taxes_no_override": 17260.85,
    "override_total_1": 17750.61,
    "override_increase_1": 489.76
  },
  {
    "#": "177 Reservoir Rd (277-05-00)",
    "$": 2578000,
    "address": "177 Reservoir Rd",
    "parcel_id": "277-05-00",
    "owner1": "MINAHAN, MICHAEL J & ALYSSA J",
    "owner2": "",
    "current_taxes": 26398.72,
    "new_taxes_no_override": 27539.14,
    "override_total_1": 28320.55,
    "override_increase_1": 781.4
  },
  {
    "#": "183 Reservoir Rd (277-06-00)",
    "$": 2127300,
    "address": "183 Reservoir Rd",
    "parcel_id": "277-06-00",
    "owner1": "MERANUS, JORDAN S & EVONNE H",
    "owner2": "",
    "current_taxes": 18148.62,
    "new_taxes_no_override": 18932.64,
    "override_total_1": 19469.84,
    "override_increase_1": 537.2
  },
  {
    "#": "186 Reservoir Rd (278-26-00)",
    "$": 2095500,
    "address": "186 Reservoir Rd",
    "parcel_id": "278-26-00",
    "owner1": "WHELAN, KIM U",
    "owner2": "",
    "current_taxes": 17822.99,
    "new_taxes_no_override": 18592.94,
    "override_total_1": 19120.5,
    "override_increase_1": 527.56
  },
  {
    "#": "187 Reservoir Rd (277-06-01)",
    "$": 1762900,
    "address": "187 Reservoir Rd",
    "parcel_id": "277-06-01",
    "owner1": "HUANG, JOHN & OUBO",
    "owner2": "",
    "current_taxes": 14417.16,
    "new_taxes_no_override": 15039.98,
    "override_total_1": 15466.73,
    "override_increase_1": 426.75
  },
  {
    "#": "191 Reservoir Rd (277-06-02)",
    "$": 1983000,
    "address": "191 Reservoir Rd",
    "parcel_id": "277-06-02",
    "owner1": "COOPER, ELLEN",
    "owner2": "",
    "current_taxes": 16670.99,
    "new_taxes_no_override": 17391.18,
    "override_total_1": 17884.64,
    "override_increase_1": 493.46
  },
  {
    "#": "192 Reservoir Rd (278-25-00)",
    "$": 2386200,
    "address": "192 Reservoir Rd",
    "parcel_id": "278-25-00",
    "owner1": "SHEA, JAMES R JR & NANCY ANN P",
    "owner2": "",
    "current_taxes": 20799.75,
    "new_taxes_no_override": 21698.3,
    "override_total_1": 22313.97,
    "override_increase_1": 615.67
  },
  {
    "#": "197 Reservoir Rd (277-06-03)",
    "$": 1710200,
    "address": "197 Reservoir Rd",
    "parcel_id": "277-06-03",
    "owner1": "HUG, CHRISTOPHER",
    "owner2": "PODURI, ANNAPURNA",
    "current_taxes": 13877.51,
    "new_taxes_no_override": 14477.02,
    "override_total_1": 14887.79,
    "override_increase_1": 410.77
  },
  {
    "#": "200 Reservoir Rd (278-24-00)",
    "$": 2410600,
    "address": "200 Reservoir Rd",
    "parcel_id": "278-24-00",
    "owner1": "MURPHY TRS, ELIZABETH & TERRENCE A",
    "owner2": "",
    "current_taxes": 21049.61,
    "new_taxes_no_override": 21958.95,
    "override_total_1": 22582.02,
    "override_increase_1": 623.07
  },
  {
    "#": "201 Reservoir Rd (277-07-00)",
    "$": 1881100,
    "address": "201 Reservoir Rd",
    "parcel_id": "277-07-00",
    "owner1": "TOKSOZ-EXLEY, DENIZ",
    "owner2": "",
    "current_taxes": 15627.53,
    "new_taxes_no_override": 16302.64,
    "override_total_1": 16765.21,
    "override_increase_1": 462.57
  },
  {
    "#": "209 Reservoir Rd (277-08-00)",
    "$": 1737800,
    "address": "209 Reservoir Rd",
    "parcel_id": "277-08-00",
    "owner1": "HONG, TRACI JING",
    "owner2": "BEAUDOIN, CHRISTOPHER EVAN",
    "current_taxes": 14160.14,
    "new_taxes_no_override": 14771.86,
    "override_total_1": 15191.0,
    "override_increase_1": 419.14
  },
  {
    "#": "210 Reservoir Rd (278-23-00)",
    "$": 1896300,
    "address": "210 Reservoir Rd",
    "parcel_id": "278-23-00",
    "owner1": "NASON, FRANCES E",
    "owner2": "SCHREIBER, JAN",
    "current_taxes": 15783.18,
    "new_taxes_no_override": 16465.01,
    "override_total_1": 16932.2,
    "override_increase_1": 467.18
  },
  {
    "#": "213 Reservoir Rd, Unit 1 (277-09-01)",
    "$": 775900,
    "address": "213 Reservoir Rd, Unit 1",
    "parcel_id": "277-09-01",
    "owner1": "YEUNG, MELISSA",
    "owner2": "",
    "current_taxes": 7945.22,
    "new_taxes_no_override": 8288.45,
    "override_total_1": 8523.63,
    "override_increase_1": 235.18
  },
  {
    "#": "213 Reservoir Rd, Unit 2 (277-09-02)",
    "$": 768200,
    "address": "213 Reservoir Rd, Unit 2",
    "parcel_id": "277-09-02",
    "owner1": "GUO, WEI & JIANPING",
    "owner2": "",
    "current_taxes": 7866.37,
    "new_taxes_no_override": 8206.2,
    "override_total_1": 8439.04,
    "override_increase_1": 232.84
  },
  {
    "#": "213 Reservoir Rd, Unit 3 (277-09-03)",
    "$": 746400,
    "address": "213 Reservoir Rd, Unit 3",
    "parcel_id": "277-09-03",
    "owner1": "YEUNG, MELISSA",
    "owner2": "",
    "current_taxes": 4008.2,
    "new_taxes_no_override": 4181.35,
    "override_total_1": 4300.0,
    "override_increase_1": 118.64
  },
  {
    "#": "215 Reservoir Rd (277-10-00)",
    "$": 2108400,
    "address": "215 Reservoir Rd",
    "parcel_id": "277-10-00",
    "owner1": "TSELEVICH  TRS, VLADIMIR & NATALYA",
    "owner2": "",
    "current_taxes": 17955.08,
    "new_taxes_no_override": 18730.74,
    "override_total_1": 19262.21,
    "override_increase_1": 531.47
  },
  {
    "#": "218 Reservoir Rd (278-22-00)",
    "$": 2064900,
    "address": "218 Reservoir Rd",
    "parcel_id": "278-22-00",
    "owner1": "YUH, DAVID & FAITH",
    "owner2": "",
    "current_taxes": 21144.58,
    "new_taxes_no_override": 22058.03,
    "override_total_1": 22683.91,
    "override_increase_1": 625.88
  },
  {
    "#": "221 Reservoir Rd (277-11-00)",
    "$": 2738100,
    "address": "221 Reservoir Rd",
    "parcel_id": "277-11-00",
    "owner1": "BAFFY, GYORGY",
    "owner2": "HALASZ, ILDIKO",
    "current_taxes": 24403.21,
    "new_taxes_no_override": 25457.43,
    "override_total_1": 26179.76,
    "override_increase_1": 722.34
  },
  {
    "#": "225 Reservoir Rd (277-12-00)",
    "$": 2336100,
    "address": "225 Reservoir Rd",
    "parcel_id": "277-12-00",
    "owner1": "BURKE, JASON M & JAIME",
    "owner2": "",
    "current_taxes": 20286.73,
    "new_taxes_no_override": 21163.12,
    "override_total_1": 21763.6,
    "override_increase_1": 600.49
  },
  {
    "#": "226 Reservoir Rd (278-21-00)",
    "$": 1924300,
    "address": "226 Reservoir Rd",
    "parcel_id": "278-21-00",
    "owner1": "PIATETSKY-SHAPIRO, GREGORY",
    "owner2": "MEDVEDEV-KHAZANOV, MARIANNA",
    "current_taxes": 16069.9,
    "new_taxes_no_override": 16764.12,
    "override_total_1": 17239.79,
    "override_increase_1": 475.67
  },
  {
    "#": "233 Reservoir Rd (277-12-01)",
    "$": 10200,
    "address": "233 Reservoir Rd",
    "parcel_id": "277-12-01",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O VACANT PARCEL/ABUT 225 RSRVR",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "234 Reservoir Rd (278-20-00)",
    "$": 2179600,
    "address": "234 Reservoir Rd",
    "parcel_id": "278-20-00",
    "owner1": "SINGER, MARTHA C",
    "owner2": "FRANKEL, RICHARD M",
    "current_taxes": 22319.1,
    "new_taxes_no_override": 23283.29,
    "override_total_1": 23943.93,
    "override_increase_1": 660.65
  },
  {
    "#": "280 Reservoir Rd (280-12-00)",
    "$": 2694100,
    "address": "280 Reservoir Rd",
    "parcel_id": "280-12-00",
    "owner1": "HILBURN, C DAVID",
    "owner2": "FLEISHER, KATE E",
    "current_taxes": 23952.65,
    "new_taxes_no_override": 24987.4,
    "override_total_1": 25696.4,
    "override_increase_1": 709.0
  },
  {
    "#": "285 Reservoir Rd (266-03-00)",
    "$": 5212100,
    "address": "285 Reservoir Rd",
    "parcel_id": "266-03-00",
    "owner1": "SELWYN, LEE L & JUDITH E",
    "owner2": "",
    "current_taxes": 49736.97,
    "new_taxes_no_override": 51885.61,
    "override_total_1": 53357.82,
    "override_increase_1": 1472.21
  },
  {
    "#": "295 Reservoir Rd (266-02-04)",
    "$": 2318200,
    "address": "295 Reservoir Rd",
    "parcel_id": "266-02-04",
    "owner1": "HOY, FRANCIS C",
    "owner2": "",
    "current_taxes": 20103.43,
    "new_taxes_no_override": 20971.9,
    "override_total_1": 21566.96,
    "override_increase_1": 595.06
  },
  {
    "#": "307 Reservoir Rd (266-02-00)",
    "$": 2367200,
    "address": "307 Reservoir Rd",
    "parcel_id": "266-02-00",
    "owner1": "VAN SCOYOC, JOHN R & BARBARA T",
    "owner2": "",
    "current_taxes": 20605.19,
    "new_taxes_no_override": 21495.33,
    "override_total_1": 22105.25,
    "override_increase_1": 609.91
  },
  {
    "#": "315 Reservoir Rd (266-01-00)",
    "$": 1601900,
    "address": "315 Reservoir Rd",
    "parcel_id": "266-01-00",
    "owner1": "CALABRESE TRS, MICHAEL & JENNIFER",
    "owner2": "",
    "current_taxes": 12768.52,
    "new_taxes_no_override": 13320.12,
    "override_total_1": 13698.07,
    "override_increase_1": 377.95
  },
  {
    "#": "320 Reservoir Rd (282-01-01)",
    "$": 49500,
    "address": "320 Reservoir Rd",
    "parcel_id": "282-01-01",
    "owner1": "COMMONWEALTH OF MASSACHUSETTS",
    "owner2": "C/O MASS BAY TRANSIT AUTHORITY",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "321 Reservoir Rd (266-01-01)",
    "$": 16500,
    "address": "321 Reservoir Rd",
    "parcel_id": "266-01-01",
    "owner1": "COMMONWEALTH OF MASSACHUSETTS",
    "owner2": "C/O MASS BAY TRANSIT AUTHORITY",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "6 Rice St (307-41-00)",
    "$": 1549600,
    "address": "6 Rice St",
    "parcel_id": "307-41-00",
    "owner1": "VLAD, SERGIU",
    "owner2": "",
    "current_taxes": 15867.9,
    "new_taxes_no_override": 16553.39,
    "override_total_1": 17023.08,
    "override_increase_1": 469.69
  },
  {
    "#": "8 Rice St, Unit 1 (307-40-01)",
    "$": 767000,
    "address": "8 Rice St, Unit 1",
    "parcel_id": "307-40-01",
    "owner1": "LORENTSOV, ERNEST",
    "owner2": "",
    "current_taxes": 4219.15,
    "new_taxes_no_override": 4401.42,
    "override_total_1": 4526.3,
    "override_increase_1": 124.89
  },
  {
    "#": "8 Rice St, Unit 2 (307-40-02)",
    "$": 637000,
    "address": "8 Rice St, Unit 2",
    "parcel_id": "307-40-02",
    "owner1": "GIEDRIMAS, ARNOLDAS & EVALDAS",
    "owner2": "",
    "current_taxes": 6522.88,
    "new_taxes_no_override": 6804.67,
    "override_total_1": 6997.75,
    "override_increase_1": 193.08
  },
  {
    "#": "8 Rice St, Unit 3 (307-40-03)",
    "$": 645400,
    "address": "8 Rice St, Unit 3",
    "parcel_id": "307-40-03",
    "owner1": "WANG, JING",
    "owner2": "",
    "current_taxes": 6608.9,
    "new_taxes_no_override": 6894.4,
    "override_total_1": 7090.03,
    "override_increase_1": 195.62
  },
  {
    "#": "9 Rice St (306-07-00)",
    "$": 4087400,
    "address": "9 Rice St",
    "parcel_id": "306-07-00",
    "owner1": "ZAZULA, GREGORY",
    "owner2": "",
    "current_taxes": 41854.98,
    "new_taxes_no_override": 43663.12,
    "override_total_1": 44902.02,
    "override_increase_1": 1238.91
  },
  {
    "#": "10 Rice St (307-39-00)",
    "$": 1189500,
    "address": "10 Rice St",
    "parcel_id": "307-39-00",
    "owner1": "MABROUK, OMAR",
    "owner2": "DI BERNARDO, JULIE",
    "current_taxes": 8545.55,
    "new_taxes_no_override": 8914.72,
    "override_total_1": 9167.67,
    "override_increase_1": 252.95
  },
  {
    "#": "14 Rice St, Unit 1 (307-37-03)",
    "$": 852800,
    "address": "14 Rice St, Unit 1",
    "parcel_id": "307-37-03",
    "owner1": "LEROY, CHRISTOPHE",
    "owner2": "BONDILA, CLAUDIA",
    "current_taxes": 5097.74,
    "new_taxes_no_override": 5317.96,
    "override_total_1": 5468.86,
    "override_increase_1": 150.89
  },
  {
    "#": "14 Rice St, Unit 2 (307-37-01)",
    "$": 923000,
    "address": "14 Rice St, Unit 2",
    "parcel_id": "307-37-01",
    "owner1": "WANG, XIN",
    "owner2": "",
    "current_taxes": 9451.52,
    "new_taxes_no_override": 9859.83,
    "override_total_1": 10139.59,
    "override_increase_1": 279.76
  },
  {
    "#": "14 Rice St, Unit 3 (307-37-02)",
    "$": 943900,
    "address": "14 Rice St, Unit 3",
    "parcel_id": "307-37-02",
    "owner1": "LEROY, CHRISTOPHE",
    "owner2": "BONDILA, CLAUDIA",
    "current_taxes": 9665.54,
    "new_taxes_no_override": 10083.09,
    "override_total_1": 10369.19,
    "override_increase_1": 286.1
  },
  {
    "#": "15 Rice St (306-09-00)",
    "$": 1304000,
    "address": "15 Rice St",
    "parcel_id": "306-09-00",
    "owner1": "BUCKLEY TR, JAMES J",
    "owner2": "",
    "current_taxes": 9718.03,
    "new_taxes_no_override": 10137.85,
    "override_total_1": 10425.5,
    "override_increase_1": 287.65
  },
  {
    "#": "16 Rice St, Unit 1 (307-36-01)",
    "$": 645700,
    "address": "16 Rice St, Unit 1",
    "parcel_id": "307-36-01",
    "owner1": "STASHESKI, STEPHEN C",
    "owner2": "MARGOLIN, LAUREN P",
    "current_taxes": 6611.97,
    "new_taxes_no_override": 6897.61,
    "override_total_1": 7093.32,
    "override_increase_1": 195.71
  },
  {
    "#": "16 Rice St, Unit 2 (307-36-02)",
    "$": 629600,
    "address": "16 Rice St, Unit 2",
    "parcel_id": "307-36-02",
    "owner1": "WHITMAN, SARAH J",
    "owner2": "",
    "current_taxes": 2812.17,
    "new_taxes_no_override": 2933.66,
    "override_total_1": 3016.9,
    "override_increase_1": 83.24
  },
  {
    "#": "16 Rice St, Unit 3 (307-36-03)",
    "$": 649400,
    "address": "16 Rice St, Unit 3",
    "parcel_id": "307-36-03",
    "owner1": "GENEST, BRUCE P",
    "owner2": "",
    "current_taxes": 3014.92,
    "new_taxes_no_override": 3145.16,
    "override_total_1": 3234.41,
    "override_increase_1": 89.24
  },
  {
    "#": "17 Rice St, Unit 1 (306-10-01)",
    "$": 668900,
    "address": "17 Rice St, Unit 1",
    "parcel_id": "306-10-01",
    "owner1": "FITZGERALD, SARAH A",
    "owner2": "",
    "current_taxes": 3214.6,
    "new_taxes_no_override": 3353.47,
    "override_total_1": 3448.62,
    "override_increase_1": 95.15
  },
  {
    "#": "17 Rice St, Unit 2 (306-10-02)",
    "$": 670600,
    "address": "17 Rice St, Unit 2",
    "parcel_id": "306-10-02",
    "owner1": "MA TR, YUE",
    "owner2": "",
    "current_taxes": 3232.01,
    "new_taxes_no_override": 3371.63,
    "override_total_1": 3467.3,
    "override_increase_1": 95.67
  },
  {
    "#": "17 Rice St, Unit 3 (306-10-03)",
    "$": 676300,
    "address": "17 Rice St, Unit 3",
    "parcel_id": "306-10-03",
    "owner1": "PELED, SHARON",
    "owner2": "",
    "current_taxes": 6925.31,
    "new_taxes_no_override": 7224.48,
    "override_total_1": 7429.47,
    "override_increase_1": 204.99
  },
  {
    "#": "20 Rice St, Unit 1 (307-35-01)",
    "$": 669200,
    "address": "20 Rice St, Unit 1",
    "parcel_id": "307-35-01",
    "owner1": "SANABRIA, CRUZ",
    "owner2": "",
    "current_taxes": 3217.67,
    "new_taxes_no_override": 3356.67,
    "override_total_1": 3451.92,
    "override_increase_1": 95.24
  },
  {
    "#": "20 Rice St, Unit 2 (307-35-02)",
    "$": 700700,
    "address": "20 Rice St, Unit 2",
    "parcel_id": "307-35-02",
    "owner1": "SPECK, TYLER & ASHLAN",
    "owner2": "",
    "current_taxes": 7175.17,
    "new_taxes_no_override": 7485.14,
    "override_total_1": 7697.52,
    "override_increase_1": 212.39
  },
  {
    "#": "20 Rice St, Unit 3 (307-35-03)",
    "$": 716500,
    "address": "20 Rice St, Unit 3",
    "parcel_id": "307-35-03",
    "owner1": "JOYCE, MICHAEL",
    "owner2": "KANEGIS, JULIANA",
    "current_taxes": 3702.03,
    "new_taxes_no_override": 3861.96,
    "override_total_1": 3971.54,
    "override_increase_1": 109.58
  },
  {
    "#": "21 Rice St, Unit 1 (306-11-01)",
    "$": 677000,
    "address": "21 Rice St, Unit 1",
    "parcel_id": "306-11-01",
    "owner1": "MARTIN, LYNDA D & CRAIG B SR",
    "owner2": "",
    "current_taxes": 3297.55,
    "new_taxes_no_override": 3440.0,
    "override_total_1": 3537.61,
    "override_increase_1": 97.61
  },
  {
    "#": "21 Rice St, Unit 2 (306-11-02)",
    "$": 1062100,
    "address": "21 Rice St, Unit 2",
    "parcel_id": "306-11-02",
    "owner1": "VAUGHN, PAMELA & ROBERT",
    "owner2": "",
    "current_taxes": 7240.97,
    "new_taxes_no_override": 7553.78,
    "override_total_1": 7768.11,
    "override_increase_1": 214.33
  },
  {
    "#": "11 Risley Rd (363-29-00)",
    "$": 1123600,
    "address": "11 Risley Rd",
    "parcel_id": "363-29-00",
    "owner1": "ROUNSEVILLE TRS, ANNE E",
    "owner2": "COTE, PAUL J",
    "current_taxes": 7870.73,
    "new_taxes_no_override": 8210.75,
    "override_total_1": 8443.72,
    "override_increase_1": 232.97
  },
  {
    "#": "14 Risley Rd (359-09-10)",
    "$": 2116100,
    "address": "14 Risley Rd",
    "parcel_id": "359-09-10",
    "owner1": "DUKA, ARVI & ADELINA",
    "owner2": "",
    "current_taxes": 21668.86,
    "new_taxes_no_override": 22604.95,
    "override_total_1": 23246.35,
    "override_increase_1": 641.4
  },
  {
    "#": "17 Risley Rd (363-28-00)",
    "$": 1716800,
    "address": "17 Risley Rd",
    "parcel_id": "363-28-00",
    "owner1": "LANHAM, MEGAN K & JULIA W",
    "owner2": "",
    "current_taxes": 13945.1,
    "new_taxes_no_override": 14547.53,
    "override_total_1": 14960.3,
    "override_increase_1": 412.77
  },
  {
    "#": "20 Risley Rd (359-08-00)",
    "$": 54400,
    "address": "20 Risley Rd",
    "parcel_id": "359-08-00",
    "owner1": "GENSLER, ROBERT & MARYSIA",
    "owner2": "",
    "current_taxes": 557.06,
    "new_taxes_no_override": 581.12,
    "override_total_1": 597.61,
    "override_increase_1": 16.49
  },
  {
    "#": "25 Risley Rd (363-26-00)",
    "$": 1684100,
    "address": "25 Risley Rd",
    "parcel_id": "363-26-00",
    "owner1": "SARALAYA, SHRUTHI",
    "owner2": "RAILLARD, VALENTIN",
    "current_taxes": 13610.25,
    "new_taxes_no_override": 14198.21,
    "override_total_1": 14601.08,
    "override_increase_1": 402.86
  },
  {
    "#": "31 Risley Rd (363-25-00)",
    "$": 1219000,
    "address": "31 Risley Rd",
    "parcel_id": "363-25-00",
    "owner1": "MASELLI, NICHOLAS J",
    "owner2": "SAGOR, RACHEL S",
    "current_taxes": 8847.63,
    "new_taxes_no_override": 9229.85,
    "override_total_1": 9491.74,
    "override_increase_1": 261.89
  },
  {
    "#": "36 Risley Rd (360-11-00)",
    "$": 1295000,
    "address": "36 Risley Rd",
    "parcel_id": "360-11-00",
    "owner1": "MACLELLAN TR, ALLISON A",
    "owner2": "",
    "current_taxes": 9625.87,
    "new_taxes_no_override": 10041.71,
    "override_total_1": 10326.63,
    "override_increase_1": 284.93
  },
  {
    "#": "37 Risley Rd (363-23-24)",
    "$": 1064200,
    "address": "37 Risley Rd",
    "parcel_id": "363-23-24",
    "owner1": "BRIDGES, BRIAN",
    "owner2": "MCCARRON, BREDA",
    "current_taxes": 7262.47,
    "new_taxes_no_override": 7576.21,
    "override_total_1": 7791.18,
    "override_increase_1": 214.97
  },
  {
    "#": "41 Risley Rd (363-22-00)",
    "$": 1114400,
    "address": "41 Risley Rd",
    "parcel_id": "363-22-00",
    "owner1": "LAHO TR, ERMELINDA",
    "owner2": "",
    "current_taxes": 7776.52,
    "new_taxes_no_override": 8112.47,
    "override_total_1": 8342.65,
    "override_increase_1": 230.18
  },
  {
    "#": "49 Risley Rd (363-20-00)",
    "$": 1447500,
    "address": "49 Risley Rd",
    "parcel_id": "363-20-00",
    "owner1": "COHEN, LLOYD S & DOROTHY S",
    "owner2": "",
    "current_taxes": 11187.47,
    "new_taxes_no_override": 11670.77,
    "override_total_1": 12001.92,
    "override_increase_1": 331.15
  },
  {
    "#": "53 Risley Rd (363-19-00)",
    "$": 1877000,
    "address": "53 Risley Rd",
    "parcel_id": "363-19-00",
    "owner1": "MASKI TRS, MANISH R & KIRAN P",
    "owner2": "",
    "current_taxes": 15585.55,
    "new_taxes_no_override": 16258.85,
    "override_total_1": 16720.18,
    "override_increase_1": 461.33
  },
  {
    "#": "57 Risley Rd (363-18-00)",
    "$": 1135200,
    "address": "57 Risley Rd",
    "parcel_id": "363-18-00",
    "owner1": "ARISTARKHOV, ALEXANDER & ELENA",
    "owner2": "",
    "current_taxes": 7989.51,
    "new_taxes_no_override": 8334.66,
    "override_total_1": 8571.15,
    "override_increase_1": 236.49
  },
  {
    "#": "58 Risley Rd (361-14-15)",
    "$": 1640500,
    "address": "58 Risley Rd",
    "parcel_id": "361-14-15",
    "owner1": "ROUMELIOTIS, ETHEL R",
    "owner2": "",
    "current_taxes": 13163.79,
    "new_taxes_no_override": 13732.47,
    "override_total_1": 14122.11,
    "override_increase_1": 389.65
  },
  {
    "#": "62 Risley Rd (361-13-00)",
    "$": 1221300,
    "address": "62 Risley Rd",
    "parcel_id": "361-13-00",
    "owner1": "ZHANG, HONGWEI",
    "owner2": "CHEN, YING",
    "current_taxes": 8871.18,
    "new_taxes_no_override": 9254.41,
    "override_total_1": 9517.0,
    "override_increase_1": 262.59
  },
  {
    "#": "63 Risley Rd (363-16-00)",
    "$": 1016400,
    "address": "63 Risley Rd",
    "parcel_id": "363-16-00",
    "owner1": "BHAD, PRAFULLA & SHUBHADA",
    "owner2": "",
    "current_taxes": 6773.0,
    "new_taxes_no_override": 7065.59,
    "override_total_1": 7266.07,
    "override_increase_1": 200.48
  },
  {
    "#": "66 Risley Rd (361-12-00)",
    "$": 1371900,
    "address": "66 Risley Rd",
    "parcel_id": "361-12-00",
    "owner1": "KESSLER, JAMES E & HARRIET D",
    "owner2": "",
    "current_taxes": 10413.32,
    "new_taxes_no_override": 10863.18,
    "override_total_1": 11171.41,
    "override_increase_1": 308.23
  },
  {
    "#": "67 Risley Rd (363-15-00)",
    "$": 1298800,
    "address": "67 Risley Rd",
    "parcel_id": "363-15-00",
    "owner1": "DETORE, NICOLE R",
    "owner2": "CAHILL, JOSEPH",
    "current_taxes": 9664.78,
    "new_taxes_no_override": 10082.3,
    "override_total_1": 10368.38,
    "override_increase_1": 286.08
  },
  {
    "#": "77 Risley Rd (367-23-00)",
    "$": 999000,
    "address": "77 Risley Rd",
    "parcel_id": "367-23-00",
    "owner1": "CUI, XIAOJIE",
    "owner2": "",
    "current_taxes": 10229.76,
    "new_taxes_no_override": 10671.69,
    "override_total_1": 10974.49,
    "override_increase_1": 302.8
  },
  {
    "#": "82 Risley Rd (362-06-00)",
    "$": 1154500,
    "address": "82 Risley Rd",
    "parcel_id": "362-06-00",
    "owner1": "GLASS, JANE",
    "owner2": "",
    "current_taxes": 8187.15,
    "new_taxes_no_override": 8540.83,
    "override_total_1": 8783.17,
    "override_increase_1": 242.34
  },
  {
    "#": "83 Risley Rd (367-24-00)",
    "$": 1538300,
    "address": "83 Risley Rd",
    "parcel_id": "367-24-00",
    "owner1": "FEHRNSTROM TRS, ERIC P & KATHERINE",
    "owner2": "",
    "current_taxes": 12117.26,
    "new_taxes_no_override": 12640.73,
    "override_total_1": 12999.4,
    "override_increase_1": 358.67
  },
  {
    "#": "86 Risley Rd (362-07-00)",
    "$": 994300,
    "address": "86 Risley Rd",
    "parcel_id": "362-07-00",
    "owner1": "JO, SUNG-HO",
    "owner2": "NO, YOON KYONG",
    "current_taxes": 6546.7,
    "new_taxes_no_override": 6829.52,
    "override_total_1": 7023.3,
    "override_increase_1": 193.78
  },
  {
    "#": "87 Risley Rd (367-25-00)",
    "$": 1437800,
    "address": "87 Risley Rd",
    "parcel_id": "367-25-00",
    "owner1": "BEBINGER, MARTHA S",
    "owner2": "",
    "current_taxes": 11088.14,
    "new_taxes_no_override": 11567.15,
    "override_total_1": 11895.36,
    "override_increase_1": 328.21
  },
  {
    "#": "90 Risley Rd (362-08-00)",
    "$": 1292300,
    "address": "90 Risley Rd",
    "parcel_id": "362-08-00",
    "owner1": "WANG, WENDY YIWEN",
    "owner2": "",
    "current_taxes": 9598.22,
    "new_taxes_no_override": 10012.86,
    "override_total_1": 10296.97,
    "override_increase_1": 284.11
  },
  {
    "#": "93 Risley Rd (367-26-00)",
    "$": 1059100,
    "address": "93 Risley Rd",
    "parcel_id": "367-26-00",
    "owner1": "LAMPERT TR, AMY S",
    "owner2": "",
    "current_taxes": 10845.18,
    "new_taxes_no_override": 11313.69,
    "override_total_1": 11634.71,
    "override_increase_1": 321.02
  },
  {
    "#": "98 Risley Rd (362-09-10)",
    "$": 1217000,
    "address": "98 Risley Rd",
    "parcel_id": "362-09-10",
    "owner1": "XU, XIAOYIN",
    "owner2": "LIANG, LEI",
    "current_taxes": 8827.15,
    "new_taxes_no_override": 9208.48,
    "override_total_1": 9469.77,
    "override_increase_1": 261.28
  },
  {
    "#": "99 Risley Rd (367-29-00)",
    "$": 11700,
    "address": "99 Risley Rd",
    "parcel_id": "367-29-00",
    "owner1": "ALATRAKCHI, NADIA",
    "owner2": "",
    "current_taxes": 119.81,
    "new_taxes_no_override": 124.99,
    "override_total_1": 128.53,
    "override_increase_1": 3.55
  },
  {
    "#": "101 Risley Rd (367-27-28)",
    "$": 1089800,
    "address": "101 Risley Rd",
    "parcel_id": "367-27-28",
    "owner1": "KEHAYIAS, ET AL, JOSEPH J",
    "owner2": "",
    "current_taxes": 7524.62,
    "new_taxes_no_override": 7849.68,
    "override_total_1": 8072.41,
    "override_increase_1": 222.73
  },
  {
    "#": "5 Roberts St (305-24-00)",
    "$": 1385400,
    "address": "5 Roberts St",
    "parcel_id": "305-24-00",
    "owner1": "TOY, NANCY",
    "owner2": "",
    "current_taxes": 10551.56,
    "new_taxes_no_override": 11007.39,
    "override_total_1": 11319.71,
    "override_increase_1": 312.33
  },
  {
    "#": "6 Roberts St (306-01-01)",
    "$": 1654400,
    "address": "6 Roberts St",
    "parcel_id": "306-01-01",
    "owner1": "WARNER TRS, CHERYL K & DONALD A",
    "owner2": "ATWOOD, KIMBALL C IV & DEBORAH",
    "current_taxes": 16941.06,
    "new_taxes_no_override": 17672.91,
    "override_total_1": 18174.37,
    "override_increase_1": 501.46
  },
  {
    "#": "7 Roberts St (305-25-00)",
    "$": 1356300,
    "address": "7 Roberts St",
    "parcel_id": "305-25-00",
    "owner1": "ROBERTS STREET REALTY LLC",
    "owner2": "C/O ALLEN RICHARD",
    "current_taxes": 13888.51,
    "new_taxes_no_override": 14488.49,
    "override_total_1": 14899.59,
    "override_increase_1": 411.1
  },
  {
    "#": "8 Roberts St (306-17-00)",
    "$": 2314000,
    "address": "8 Roberts St",
    "parcel_id": "306-17-00",
    "owner1": "8 ROBERTS LLC",
    "owner2": "",
    "current_taxes": 23695.36,
    "new_taxes_no_override": 24719.0,
    "override_total_1": 25420.38,
    "override_increase_1": 701.38
  },
  {
    "#": "9 Roberts St (305-08-00)",
    "$": 1720800,
    "address": "9 Roberts St",
    "parcel_id": "305-08-00",
    "owner1": "APPAVOO, ANN & JONATHAN",
    "owner2": "",
    "current_taxes": 13986.06,
    "new_taxes_no_override": 14590.26,
    "override_total_1": 15004.25,
    "override_increase_1": 413.99
  },
  {
    "#": "10 Roberts St (306-16-00)",
    "$": 1237300,
    "address": "10 Roberts St",
    "parcel_id": "306-16-00",
    "owner1": "BRINK TRS, ROBERT J & ELISABETH P",
    "owner2": "",
    "current_taxes": 12669.95,
    "new_taxes_no_override": 13217.29,
    "override_total_1": 13592.32,
    "override_increase_1": 375.03
  },
  {
    "#": "13 Roberts St (305-09-00)",
    "$": 1640700,
    "address": "13 Roberts St",
    "parcel_id": "305-09-00",
    "owner1": "OMALLEY, EVA M",
    "owner2": "",
    "current_taxes": 13165.83,
    "new_taxes_no_override": 13734.59,
    "override_total_1": 14124.3,
    "override_increase_1": 389.71
  },
  {
    "#": "14 Roberts St, Unit 1 (306-15-05)",
    "$": 873100,
    "address": "14 Roberts St, Unit 1",
    "parcel_id": "306-15-05",
    "owner1": "GERMAN, JACQUELINE SAVETSKY",
    "owner2": "",
    "current_taxes": 5305.61,
    "new_taxes_no_override": 5534.81,
    "override_total_1": 5691.86,
    "override_increase_1": 157.05
  },
  {
    "#": "14 Roberts St, Unit 2 (306-15-06)",
    "$": 873100,
    "address": "14 Roberts St, Unit 2",
    "parcel_id": "306-15-06",
    "owner1": "DAILEY TR, DRUCILA L",
    "owner2": "",
    "current_taxes": 5305.61,
    "new_taxes_no_override": 5534.81,
    "override_total_1": 5691.86,
    "override_increase_1": 157.05
  },
  {
    "#": "14 Roberts St, Unit 3 (306-15-07)",
    "$": 912100,
    "address": "14 Roberts St, Unit 3",
    "parcel_id": "306-15-07",
    "owner1": "DAILEY, TIMOTHY G",
    "owner2": "",
    "current_taxes": 5704.97,
    "new_taxes_no_override": 5951.42,
    "override_total_1": 6120.29,
    "override_increase_1": 168.87
  },
  {
    "#": "16 Roberts St, Unit 1 (306-15-02)",
    "$": 735200,
    "address": "16 Roberts St, Unit 1",
    "parcel_id": "306-15-02",
    "owner1": "ZABLOWSKI, PAUL",
    "owner2": "NGUYEN, HANG",
    "current_taxes": 3893.51,
    "new_taxes_no_override": 4061.71,
    "override_total_1": 4176.96,
    "override_increase_1": 115.25
  },
  {
    "#": "16 Roberts St, Unit 2 (306-15-03)",
    "$": 742300,
    "address": "16 Roberts St, Unit 2",
    "parcel_id": "306-15-03",
    "owner1": "FLORACK, JESSICA",
    "owner2": "BLACKLER, ROBERT G",
    "current_taxes": 3966.22,
    "new_taxes_no_override": 4137.56,
    "override_total_1": 4254.96,
    "override_increase_1": 117.4
  },
  {
    "#": "16 Roberts St, Unit 3 (306-15-04)",
    "$": 810300,
    "address": "16 Roberts St, Unit 3",
    "parcel_id": "306-15-04",
    "owner1": "GUMMERE, SHAUN M",
    "owner2": "BOLLE, SUSANNA",
    "current_taxes": 4662.54,
    "new_taxes_no_override": 4863.96,
    "override_total_1": 5001.97,
    "override_increase_1": 138.01
  },
  {
    "#": "17 Roberts St, Unit 1 P-3 (305-10-01)",
    "$": 709900,
    "address": "17 Roberts St, Unit 1 P-3",
    "parcel_id": "305-10-01",
    "owner1": "DAY, BENJAMIN",
    "owner2": "CASTELINO, FLAVIA",
    "current_taxes": 7269.38,
    "new_taxes_no_override": 7583.42,
    "override_total_1": 7798.59,
    "override_increase_1": 215.17
  },
  {
    "#": "17 Roberts St, Unit 2 & P1-2 (305-10-02)",
    "$": 700000,
    "address": "17 Roberts St, Unit 2 & P1-2",
    "parcel_id": "305-10-02",
    "owner1": "DAY, BENJAMIN",
    "owner2": "CASTELINO, FLAVIA V",
    "current_taxes": 3533.07,
    "new_taxes_no_override": 3685.7,
    "override_total_1": 3790.28,
    "override_increase_1": 104.58
  },
  {
    "#": "17 Roberts St, Unit 3 & P5 (305-10-03)",
    "$": 935500,
    "address": "17 Roberts St, Unit 3 & P5",
    "parcel_id": "305-10-03",
    "owner1": "ZHOU TRS, HONGYU",
    "owner2": "YUAN TR, LIN",
    "current_taxes": 9579.52,
    "new_taxes_no_override": 9993.36,
    "override_total_1": 10276.91,
    "override_increase_1": 283.55
  },
  {
    "#": "18 Roberts St (306-14-00)",
    "$": 5235300,
    "address": "18 Roberts St",
    "parcel_id": "306-14-00",
    "owner1": "ROBINIA LLC",
    "owner2": "",
    "current_taxes": 53609.47,
    "new_taxes_no_override": 55925.4,
    "override_total_1": 57512.24,
    "override_increase_1": 1586.84
  },
  {
    "#": "19 Roberts St (305-11-00)",
    "$": 2652600,
    "address": "19 Roberts St",
    "parcel_id": "305-11-00",
    "owner1": "SUN SHARK PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 27162.62,
    "new_taxes_no_override": 28336.05,
    "override_total_1": 29140.06,
    "override_increase_1": 804.01
  },
  {
    "#": "23 Roberts St (305-12-00)",
    "$": 1349400,
    "address": "23 Roberts St",
    "parcel_id": "305-12-00",
    "owner1": "ROBERTS STREET REALTY LLC",
    "owner2": "",
    "current_taxes": 13817.86,
    "new_taxes_no_override": 14414.79,
    "override_total_1": 14823.8,
    "override_increase_1": 409.01
  },
  {
    "#": "9 Rockledge Rd (375C-02-00)",
    "$": 2052900,
    "address": "9 Rockledge Rd",
    "parcel_id": "375C-02-00",
    "owner1": "GELLER, JEFFREY W",
    "owner2": "KODSI, LILI",
    "current_taxes": 17386.76,
    "new_taxes_no_override": 18137.87,
    "override_total_1": 18652.52,
    "override_increase_1": 514.65
  },
  {
    "#": "15 Rockledge Rd (375C-03-04)",
    "$": 1037900,
    "address": "15 Rockledge Rd",
    "parcel_id": "375C-03-04",
    "owner1": "EPSTEIN TR, DANIEL",
    "owner2": "",
    "current_taxes": 10628.1,
    "new_taxes_no_override": 11087.23,
    "override_total_1": 11401.83,
    "override_increase_1": 314.59
  },
  {
    "#": "20 Rockledge Rd (375D-08-00)",
    "$": 1196100,
    "address": "20 Rockledge Rd",
    "parcel_id": "375D-08-00",
    "owner1": "SMITH TR, ELEANORE E",
    "owner2": "",
    "current_taxes": 12248.06,
    "new_taxes_no_override": 12777.18,
    "override_total_1": 13139.72,
    "override_increase_1": 362.54
  },
  {
    "#": "24 Rockledge Rd (375D-06-00)",
    "$": 746700,
    "address": "24 Rockledge Rd",
    "parcel_id": "375D-06-00",
    "owner1": "SMITH TR, ELEANORE E",
    "owner2": "",
    "current_taxes": 7646.21,
    "new_taxes_no_override": 7976.53,
    "override_total_1": 8202.85,
    "override_increase_1": 226.33
  },
  {
    "#": "105 Rockwood St (353-13-00)",
    "$": 5027900,
    "address": "105 Rockwood St",
    "parcel_id": "353-13-00",
    "owner1": "CASEY TR, J ROBERT",
    "owner2": "",
    "current_taxes": 51485.7,
    "new_taxes_no_override": 53709.88,
    "override_total_1": 55233.86,
    "override_increase_1": 1523.98
  },
  {
    "#": "120 Rockwood St (354-01-01)",
    "$": 4432100,
    "address": "120 Rockwood St",
    "parcel_id": "354-01-01",
    "owner1": "HEFFRON, NEAL R & SUSAN S",
    "owner2": "",
    "current_taxes": 41749.77,
    "new_taxes_no_override": 43553.36,
    "override_total_1": 44789.15,
    "override_increase_1": 1235.79
  },
  {
    "#": "125 Rockwood St (353-11-12)",
    "$": 7641200,
    "address": "125 Rockwood St",
    "parcel_id": "353-11-12",
    "owner1": "GOLDFARB, RACHAEL",
    "owner2": "SLOVENKAI, MARK",
    "current_taxes": 74610.95,
    "new_taxes_no_override": 77834.14,
    "override_total_1": 80042.63,
    "override_increase_1": 2208.48
  },
  {
    "#": "11 Royal Rd (209-04-00)",
    "$": 2797800,
    "address": "11 Royal Rd",
    "parcel_id": "209-04-00",
    "owner1": "RIVLIN TRS, DEBORAH A",
    "owner2": "KIDRIN, THOMAS L",
    "current_taxes": 25014.54,
    "new_taxes_no_override": 26095.17,
    "override_total_1": 26835.6,
    "override_increase_1": 740.43
  },
  {
    "#": "12 Royal Rd (209A-04-00)",
    "$": 2815000,
    "address": "12 Royal Rd",
    "parcel_id": "209A-04-00",
    "owner1": "LOH, MARVIN",
    "owner2": "ACHOR, JAMI",
    "current_taxes": 25190.67,
    "new_taxes_no_override": 26278.91,
    "override_total_1": 27024.55,
    "override_increase_1": 745.64
  },
  {
    "#": "16 Royal Rd (209A-03-00)",
    "$": 2795600,
    "address": "16 Royal Rd",
    "parcel_id": "209A-03-00",
    "owner1": "SHONER TRS, JOEL & ELLEN",
    "owner2": "",
    "current_taxes": 24992.01,
    "new_taxes_no_override": 26071.66,
    "override_total_1": 26811.43,
    "override_increase_1": 739.76
  },
  {
    "#": "19 Royal Rd (209-05-00)",
    "$": 2660900,
    "address": "19 Royal Rd",
    "parcel_id": "209-05-00",
    "owner1": "GUTTMANN, CHARLES R G",
    "owner2": "",
    "current_taxes": 23612.68,
    "new_taxes_no_override": 24632.75,
    "override_total_1": 25331.68,
    "override_increase_1": 698.94
  },
  {
    "#": "20 Royal Rd (209A-02-00)",
    "$": 2791000,
    "address": "20 Royal Rd",
    "parcel_id": "209A-02-00",
    "owner1": "JAMIESON TR, ANITA",
    "owner2": "",
    "current_taxes": 24944.91,
    "new_taxes_no_override": 26022.53,
    "override_total_1": 26760.9,
    "override_increase_1": 738.37
  },
  {
    "#": "25 Royal Rd (209-06-00)",
    "$": 2892700,
    "address": "25 Royal Rd",
    "parcel_id": "209-06-00",
    "owner1": "CHERELLA, CHRISTINE",
    "owner2": "GLICKSMAN, ZACHARY S",
    "current_taxes": 25986.31,
    "new_taxes_no_override": 27108.92,
    "override_total_1": 27878.11,
    "override_increase_1": 769.19
  },
  {
    "#": "26 Royal Rd (209A-01-00)",
    "$": 2548000,
    "address": "26 Royal Rd",
    "parcel_id": "209A-01-00",
    "owner1": "FRIEDMAN, RONNE & IRENE N",
    "owner2": "",
    "current_taxes": 22456.59,
    "new_taxes_no_override": 23426.71,
    "override_total_1": 24091.43,
    "override_increase_1": 664.72
  },
  {
    "#": "11 Russell St (073-03-00)",
    "$": 1555000,
    "address": "11 Russell St",
    "parcel_id": "073-03-00",
    "owner1": "GALLIMORE, TRS, JUDITH C & JOANNA L",
    "owner2": "",
    "current_taxes": 15923.2,
    "new_taxes_no_override": 16611.08,
    "override_total_1": 17082.41,
    "override_increase_1": 471.33
  },
  {
    "#": "12 Russell St (074-22-00)",
    "$": 1867200,
    "address": "12 Russell St",
    "parcel_id": "074-22-00",
    "owner1": "NEWMAN, TRS, DENICE A & SANDRA M",
    "owner2": "",
    "current_taxes": 15485.19,
    "new_taxes_no_override": 16154.15,
    "override_total_1": 16612.51,
    "override_increase_1": 458.36
  },
  {
    "#": "15 Russell St (073-04-00)",
    "$": 2037400,
    "address": "15 Russell St",
    "parcel_id": "073-04-00",
    "owner1": "OBOY, KEVIN & EILEEN STRONG",
    "owner2": "",
    "current_taxes": 17228.04,
    "new_taxes_no_override": 17972.29,
    "override_total_1": 18482.24,
    "override_increase_1": 509.95
  },
  {
    "#": "18 Russell St (074-21-00)",
    "$": 2211000,
    "address": "18 Russell St",
    "parcel_id": "074-21-00",
    "owner1": "SHRIRA TRS, LIUBA",
    "owner2": "HERLIHY, MAURICE",
    "current_taxes": 19005.71,
    "new_taxes_no_override": 19826.76,
    "override_total_1": 20389.33,
    "override_increase_1": 562.57
  },
  {
    "#": "21 Russell St (073-05-00)",
    "$": 2497200,
    "address": "21 Russell St",
    "parcel_id": "073-05-00",
    "owner1": "FRANCESCONE, RONALD & ANGELA",
    "owner2": "",
    "current_taxes": 21936.39,
    "new_taxes_no_override": 22884.04,
    "override_total_1": 23533.36,
    "override_increase_1": 649.32
  },
  {
    "#": "22 Russell St (074-20-00)",
    "$": 3111600,
    "address": "22 Russell St",
    "parcel_id": "074-20-00",
    "owner1": "NUSSENBAUM, KATE",
    "owner2": "LIU, DILLON",
    "current_taxes": 28227.85,
    "new_taxes_no_override": 29447.29,
    "override_total_1": 30282.84,
    "override_increase_1": 835.54
  },
  {
    "#": "25 Russell St (073-06-00)",
    "$": 3033300,
    "address": "25 Russell St",
    "parcel_id": "073-06-00",
    "owner1": "SOUKAS, ALEXANDER A & JULIE",
    "owner2": "",
    "current_taxes": 27426.06,
    "new_taxes_no_override": 28610.87,
    "override_total_1": 29422.68,
    "override_increase_1": 811.81
  },
  {
    "#": "28 Russell St (074-19-00)",
    "$": 2508500,
    "address": "28 Russell St",
    "parcel_id": "074-19-00",
    "owner1": "28 RUSSELL BULLDOG LLC",
    "owner2": "",
    "current_taxes": 25687.04,
    "new_taxes_no_override": 26796.72,
    "override_total_1": 27557.06,
    "override_increase_1": 760.34
  },
  {
    "#": "31 Russell St, Unit 1  & P C&D (073-07-01)",
    "$": 855000,
    "address": "31 Russell St, Unit 1  & P C&D",
    "parcel_id": "073-07-01",
    "owner1": "FITTS, BARBARA HAYDEN",
    "owner2": "",
    "current_taxes": 5120.27,
    "new_taxes_no_override": 5341.47,
    "override_total_1": 5493.03,
    "override_increase_1": 151.56
  },
  {
    "#": "31 Russell St, Unit 2 & P-A-B (073-07-02)",
    "$": 1281500,
    "address": "31 Russell St, Unit 2 & P-A-B",
    "parcel_id": "073-07-02",
    "owner1": "COHEN TRS, SUSAN C",
    "owner2": "TAUB, FRED ALAN",
    "current_taxes": 9487.63,
    "new_taxes_no_override": 9897.5,
    "override_total_1": 10178.33,
    "override_increase_1": 280.83
  },
  {
    "#": "32 Russell St (074-18-00)",
    "$": 2663900,
    "address": "32 Russell St",
    "parcel_id": "074-18-00",
    "owner1": "MARTON, THOMAS R",
    "owner2": "BEN-ARI, DANIT",
    "current_taxes": 23643.4,
    "new_taxes_no_override": 24664.79,
    "override_total_1": 25364.64,
    "override_increase_1": 699.84
  },
  {
    "#": "33 Russell St, Unit 1 (073-08-01)",
    "$": 1008300,
    "address": "33 Russell St, Unit 1",
    "parcel_id": "073-08-01",
    "owner1": "BODTORF, CALEB",
    "owner2": "MURPHY, CHELSEA",
    "current_taxes": 10324.99,
    "new_taxes_no_override": 10771.03,
    "override_total_1": 11076.65,
    "override_increase_1": 305.62
  },
  {
    "#": "33 Russell St, Unit 2 (073-08-02)",
    "$": 1371000,
    "address": "33 Russell St, Unit 2",
    "parcel_id": "073-08-02",
    "owner1": "BAND, ROBERT L",
    "owner2": "",
    "current_taxes": 10404.11,
    "new_taxes_no_override": 10853.57,
    "override_total_1": 11161.53,
    "override_increase_1": 307.96
  },
  {
    "#": "34 Russell St, Unit 1 (074-17-01)",
    "$": 1100600,
    "address": "34 Russell St, Unit 1",
    "parcel_id": "074-17-01",
    "owner1": "BROOKS, LIZA",
    "owner2": "",
    "current_taxes": 7635.21,
    "new_taxes_no_override": 7965.05,
    "override_total_1": 8191.05,
    "override_increase_1": 226.0
  },
  {
    "#": "34 Russell St, Unit 2 (074-17-02)",
    "$": 1527300,
    "address": "34 Russell St, Unit 2",
    "parcel_id": "074-17-02",
    "owner1": "SKVIRSKY, MARC",
    "owner2": "KEBER, MARY",
    "current_taxes": 12004.62,
    "new_taxes_no_override": 12523.22,
    "override_total_1": 12878.56,
    "override_increase_1": 355.34
  },
  {
    "#": "39 Russell St, Unit 1 G-A & P1 (073-09-02)",
    "$": 1305600,
    "address": "39 Russell St, Unit 1 G-A & P1",
    "parcel_id": "073-09-02",
    "owner1": "YEHOSHUA TR, TAMAR",
    "owner2": "",
    "current_taxes": 13369.34,
    "new_taxes_no_override": 13946.9,
    "override_total_1": 14342.63,
    "override_increase_1": 395.73
  },
  {
    "#": "41 Russell St, Unit 2 G-B P3&4 (073-09-01)",
    "$": 1401000,
    "address": "41 Russell St, Unit 2 G-B P3&4",
    "parcel_id": "073-09-01",
    "owner1": "YEHOSHUA, TAMAR",
    "owner2": "",
    "current_taxes": 10711.31,
    "new_taxes_no_override": 11174.04,
    "override_total_1": 11491.09,
    "override_increase_1": 317.05
  },
  {
    "#": "42 Russell St (074-16-00)",
    "$": 2400400,
    "address": "42 Russell St",
    "parcel_id": "074-16-00",
    "owner1": "SRINIVASA, CHETHAN K & EKTA",
    "owner2": "",
    "current_taxes": 20945.16,
    "new_taxes_no_override": 21849.99,
    "override_total_1": 22469.97,
    "override_increase_1": 619.98
  },
  {
    "#": "43 Russell St, Unit 1 (073-10-01)",
    "$": 1045500,
    "address": "43 Russell St, Unit 1",
    "parcel_id": "073-10-01",
    "owner1": "DEAN, GABRIELLE",
    "owner2": "MITRA, HIMAL",
    "current_taxes": 10705.92,
    "new_taxes_no_override": 11168.42,
    "override_total_1": 11485.31,
    "override_increase_1": 316.9
  },
  {
    "#": "43 Russell St, Unit 2 (073-10-02)",
    "$": 1160200,
    "address": "43 Russell St, Unit 2",
    "parcel_id": "073-10-02",
    "owner1": "DEAN, GABRIELLE S",
    "owner2": "MITRA, HIMAL",
    "current_taxes": 11880.45,
    "new_taxes_no_override": 12393.69,
    "override_total_1": 12745.35,
    "override_increase_1": 351.66
  },
  {
    "#": "46 Russell St (074-15-00)",
    "$": 2329400,
    "address": "46 Russell St",
    "parcel_id": "074-15-00",
    "owner1": "JAN, MOHAMMAD ASHRAF & DURESAMIN A",
    "owner2": "",
    "current_taxes": 23853.06,
    "new_taxes_no_override": 24883.51,
    "override_total_1": 25589.56,
    "override_increase_1": 706.05
  },
  {
    "#": "50 Russell St, Unit 1 (074-14-01)",
    "$": 1957800,
    "address": "50 Russell St, Unit 1",
    "parcel_id": "074-14-01",
    "owner1": "FLETCHER TRS, KELBY D",
    "owner2": "BOGUCH, JANET R",
    "current_taxes": 20047.87,
    "new_taxes_no_override": 20913.94,
    "override_total_1": 21507.35,
    "override_increase_1": 593.42
  },
  {
    "#": "50 Russell St, Unit 2 (074-14-02)",
    "$": 1875900,
    "address": "50 Russell St, Unit 2",
    "parcel_id": "074-14-02",
    "owner1": "MARTINSON, CHRISTOPHER",
    "owner2": "TRIEDMAN, NELLIE",
    "current_taxes": 15574.28,
    "new_taxes_no_override": 16247.09,
    "override_total_1": 16708.09,
    "override_increase_1": 461.0
  },
  {
    "#": "56 Russell St (074-13-00)",
    "$": 3417000,
    "address": "56 Russell St",
    "parcel_id": "074-13-00",
    "owner1": "SHISHKO, ADRIENNE M",
    "owner2": "SKLAR, JOEL",
    "current_taxes": 31355.15,
    "new_taxes_no_override": 32709.69,
    "override_total_1": 33637.8,
    "override_increase_1": 928.11
  },
  {
    "#": "62 Russell St (074-12-00)",
    "$": 2837400,
    "address": "62 Russell St",
    "parcel_id": "074-12-00",
    "owner1": "HALAK, OMRI",
    "owner2": "BOGLER, ORLY",
    "current_taxes": 25420.04,
    "new_taxes_no_override": 26518.19,
    "override_total_1": 27270.62,
    "override_increase_1": 752.43
  },
  {
    "#": "197 Russett Rd (380-11-00)",
    "$": 1937400,
    "address": "197 Russett Rd",
    "parcel_id": "380-11-00",
    "owner1": "ROBILLARD, CHRISTOPHER L & CAITLIN",
    "owner2": "",
    "current_taxes": 16204.04,
    "new_taxes_no_override": 16904.05,
    "override_total_1": 17383.69,
    "override_increase_1": 479.64
  },
  {
    "#": "200 Russett Rd (381-01-00)",
    "$": 935900,
    "address": "200 Russett Rd",
    "parcel_id": "381-01-00",
    "owner1": "EDMUNDO JR, JAMES",
    "owner2": "OCONNOR, HEIDI",
    "current_taxes": 5948.68,
    "new_taxes_no_override": 6205.66,
    "override_total_1": 6381.74,
    "override_increase_1": 176.08
  },
  {
    "#": "201 Russett Rd (380-10-00)",
    "$": 1607200,
    "address": "201 Russett Rd",
    "parcel_id": "380-10-00",
    "owner1": "LIPMAN, SCOTT EZRA",
    "owner2": "DAFFLITTI, JOANNA LYNN",
    "current_taxes": 12822.79,
    "new_taxes_no_override": 13376.73,
    "override_total_1": 13756.29,
    "override_increase_1": 379.55
  },
  {
    "#": "202 Russett Rd (381-02-00)",
    "$": 1142400,
    "address": "202 Russett Rd",
    "parcel_id": "381-02-00",
    "owner1": "TAYL0R, J ANDREW & LAURA C",
    "owner2": "",
    "current_taxes": 8063.24,
    "new_taxes_no_override": 8411.57,
    "override_total_1": 8650.24,
    "override_increase_1": 238.67
  },
  {
    "#": "207 Russett Rd (380-09-00)",
    "$": 2838400,
    "address": "207 Russett Rd",
    "parcel_id": "380-09-00",
    "owner1": "THOMPSON, JULIANA SALES",
    "owner2": "",
    "current_taxes": 29065.22,
    "new_taxes_no_override": 30320.84,
    "override_total_1": 31181.17,
    "override_increase_1": 860.33
  },
  {
    "#": "208 Russett Rd (381-03-00)",
    "$": 2219800,
    "address": "208 Russett Rd",
    "parcel_id": "381-03-00",
    "owner1": "MOHINDRA, KARUNA D & SUNITI K",
    "owner2": "",
    "current_taxes": 19095.82,
    "new_taxes_no_override": 19920.76,
    "override_total_1": 20486.0,
    "override_increase_1": 565.24
  },
  {
    "#": "213 Russett Rd (380-08-00)",
    "$": 1282800,
    "address": "213 Russett Rd",
    "parcel_id": "380-08-00",
    "owner1": "KOO, BANG BON & SEO HEE",
    "owner2": "",
    "current_taxes": 9500.94,
    "new_taxes_no_override": 9911.38,
    "override_total_1": 10192.61,
    "override_increase_1": 281.23
  },
  {
    "#": "214 Russett Rd (381-04-00)",
    "$": 1120400,
    "address": "214 Russett Rd",
    "parcel_id": "381-04-00",
    "owner1": "LIANG, OLIN",
    "owner2": "LOSSNER-LIANG, JUTTA",
    "current_taxes": 7837.96,
    "new_taxes_no_override": 8176.56,
    "override_total_1": 8408.56,
    "override_increase_1": 232.0
  },
  {
    "#": "237 Russett Rd (383-02-00)",
    "$": 1147300,
    "address": "237 Russett Rd",
    "parcel_id": "383-02-00",
    "owner1": "KRUG, STEPHEN G",
    "owner2": "SOKOL, MELANIE J",
    "current_taxes": 8113.42,
    "new_taxes_no_override": 8463.92,
    "override_total_1": 8704.08,
    "override_increase_1": 240.16
  },
  {
    "#": "238 Russett Rd (384-02-00)",
    "$": 1064800,
    "address": "238 Russett Rd",
    "parcel_id": "384-02-00",
    "owner1": "FOLSOM, JAMIE MCCLINTOCK",
    "owner2": "BOUCHER, BETH ELLEN",
    "current_taxes": 7268.62,
    "new_taxes_no_override": 7582.62,
    "override_total_1": 7797.78,
    "override_increase_1": 215.15
  },
  {
    "#": "241 Russett Rd (383-03-00)",
    "$": 1154600,
    "address": "241 Russett Rd",
    "parcel_id": "383-03-00",
    "owner1": "MCGLYNN TRS, GERALDINE C & COURTNEY R",
    "owner2": "",
    "current_taxes": 8188.17,
    "new_taxes_no_override": 8541.9,
    "override_total_1": 8784.27,
    "override_increase_1": 242.37
  },
  {
    "#": "242 Russett Rd (384-03-00)",
    "$": 1328500,
    "address": "242 Russett Rd",
    "parcel_id": "384-03-00",
    "owner1": "HAMAMI, TOMER",
    "owner2": "GAL, NAAMA",
    "current_taxes": 9968.91,
    "new_taxes_no_override": 10399.57,
    "override_total_1": 10694.65,
    "override_increase_1": 295.08
  },
  {
    "#": "245 Russett Rd (383-04-00)",
    "$": 1439700,
    "address": "245 Russett Rd",
    "parcel_id": "383-04-00",
    "owner1": "JOHNSON TRS, KEVIN M & MAURA K",
    "owner2": "",
    "current_taxes": 11107.59,
    "new_taxes_no_override": 11587.44,
    "override_total_1": 11916.22,
    "override_increase_1": 328.78
  },
  {
    "#": "246 Russett Rd (384-04-00)",
    "$": 1397700,
    "address": "246 Russett Rd",
    "parcel_id": "384-04-00",
    "owner1": "XIU, ZIYI",
    "owner2": "",
    "current_taxes": 10677.51,
    "new_taxes_no_override": 11138.78,
    "override_total_1": 11454.83,
    "override_increase_1": 316.05
  },
  {
    "#": "249 Russett Rd (383-05-00)",
    "$": 1158100,
    "address": "249 Russett Rd",
    "parcel_id": "383-05-00",
    "owner1": "MCNEELY, OLIVER",
    "owner2": "ADAMS, ASHLEY",
    "current_taxes": 11858.94,
    "new_taxes_no_override": 12371.25,
    "override_total_1": 12722.27,
    "override_increase_1": 351.02
  },
  {
    "#": "250 Russett Rd (384-05-00)",
    "$": 1165400,
    "address": "250 Russett Rd",
    "parcel_id": "384-05-00",
    "owner1": "SCHARF-LAZEROW, JAMES & IRENE",
    "owner2": "",
    "current_taxes": 8298.76,
    "new_taxes_no_override": 8657.27,
    "override_total_1": 8902.91,
    "override_increase_1": 245.64
  },
  {
    "#": "254 Russett Rd (384-06-00)",
    "$": 1232000,
    "address": "254 Russett Rd",
    "parcel_id": "384-06-00",
    "owner1": "WHITMAN, TIMOTHY M",
    "owner2": "ARNOLD, LAUREN",
    "current_taxes": 8980.75,
    "new_taxes_no_override": 9368.72,
    "override_total_1": 9634.55,
    "override_increase_1": 265.83
  },
  {
    "#": "255 Russett Rd (383-06-00)",
    "$": 1903500,
    "address": "255 Russett Rd",
    "parcel_id": "383-06-00",
    "owner1": "MCNEAL, WILLIAM D JR & TRACY J",
    "owner2": "",
    "current_taxes": 15856.91,
    "new_taxes_no_override": 16541.93,
    "override_total_1": 17011.29,
    "override_increase_1": 469.36
  },
  {
    "#": "257 Russett Rd (383-07-00)",
    "$": 1044000,
    "address": "257 Russett Rd",
    "parcel_id": "383-07-00",
    "owner1": "DUNLAP TRS, JOHN WILSON JR & HELENE SUE",
    "owner2": "",
    "current_taxes": 7055.63,
    "new_taxes_no_override": 7360.43,
    "override_total_1": 7569.28,
    "override_increase_1": 208.85
  },
  {
    "#": "258 Russett Rd (384-07-00)",
    "$": 1382800,
    "address": "258 Russett Rd",
    "parcel_id": "384-07-00",
    "owner1": "BHUTANI, SRISHTI",
    "owner2": "DWIVEDI, GAURAV",
    "current_taxes": 10524.94,
    "new_taxes_no_override": 10979.62,
    "override_total_1": 11291.16,
    "override_increase_1": 311.54
  },
  {
    "#": "261 Russett Rd (383-08-00)",
    "$": 1318000,
    "address": "261 Russett Rd",
    "parcel_id": "383-08-00",
    "owner1": "ZHANG, JIMIN",
    "owner2": "XIE, YUHONG",
    "current_taxes": 9861.39,
    "new_taxes_no_override": 10287.4,
    "override_total_1": 10579.3,
    "override_increase_1": 291.9
  },
  {
    "#": "262 Russett Rd (384-08-00)",
    "$": 1104900,
    "address": "262 Russett Rd",
    "parcel_id": "384-08-00",
    "owner1": "CHIUMENTI, ET AL, STEPHEN",
    "owner2": "",
    "current_taxes": 7679.24,
    "new_taxes_no_override": 8010.98,
    "override_total_1": 8238.29,
    "override_increase_1": 227.31
  },
  {
    "#": "265 Russett Rd (383-09-00)",
    "$": 1612800,
    "address": "265 Russett Rd",
    "parcel_id": "383-09-00",
    "owner1": "ABNER, ANTHONY & DEBORAH",
    "owner2": "",
    "current_taxes": 12880.14,
    "new_taxes_no_override": 13436.56,
    "override_total_1": 13817.81,
    "override_increase_1": 381.25
  },
  {
    "#": "266 Russett Rd (384-09-00)",
    "$": 1389000,
    "address": "266 Russett Rd",
    "parcel_id": "384-09-00",
    "owner1": "SHARMA, ONKAR & MAYURI",
    "owner2": "",
    "current_taxes": 10588.43,
    "new_taxes_no_override": 11045.85,
    "override_total_1": 11359.27,
    "override_increase_1": 313.42
  },
  {
    "#": "269 Russett Rd (383-10-00)",
    "$": 1661000,
    "address": "269 Russett Rd",
    "parcel_id": "383-10-00",
    "owner1": "GEARIN TRS, SEAN L & STACEY L",
    "owner2": "",
    "current_taxes": 13373.71,
    "new_taxes_no_override": 13951.45,
    "override_total_1": 14347.32,
    "override_increase_1": 395.86
  },
  {
    "#": "270 Russett Rd (384-10-00)",
    "$": 1352500,
    "address": "270 Russett Rd",
    "parcel_id": "384-10-00",
    "owner1": "CHEHRAZI, FARNAZ",
    "owner2": "RADFAR, ALI",
    "current_taxes": 10214.67,
    "new_taxes_no_override": 10655.94,
    "override_total_1": 10958.3,
    "override_increase_1": 302.35
  },
  {
    "#": "273 Russett Rd (383-11-00)",
    "$": 1457800,
    "address": "273 Russett Rd",
    "parcel_id": "383-11-00",
    "owner1": "LETENDRE, GREGORY & KIMBERLY",
    "owner2": "",
    "current_taxes": 11292.94,
    "new_taxes_no_override": 11780.8,
    "override_total_1": 12115.07,
    "override_increase_1": 334.27
  },
  {
    "#": "274 Russett Rd (384-11-00)",
    "$": 1110700,
    "address": "274 Russett Rd",
    "parcel_id": "384-11-00",
    "owner1": "FREEDMAN, EUNICE R",
    "owner2": "C/O MOLHO CAREN",
    "current_taxes": 11373.57,
    "new_taxes_no_override": 11864.91,
    "override_total_1": 12201.57,
    "override_increase_1": 336.66
  },
  {
    "#": "277 Russett Rd (383-12-00)",
    "$": 1083100,
    "address": "277 Russett Rd",
    "parcel_id": "383-12-00",
    "owner1": "TERRY, SEAN",
    "owner2": "WARD, MOLLY",
    "current_taxes": 11090.94,
    "new_taxes_no_override": 11570.07,
    "override_total_1": 11898.36,
    "override_increase_1": 328.29
  },
  {
    "#": "291 Russett Rd (386-02-00)",
    "$": 1098500,
    "address": "291 Russett Rd",
    "parcel_id": "386-02-00",
    "owner1": "FOX, ROGER & SUSAN",
    "owner2": "",
    "current_taxes": 7613.71,
    "new_taxes_no_override": 7942.62,
    "override_total_1": 8167.99,
    "override_increase_1": 225.37
  },
  {
    "#": "292 Russett Rd (387-02-00)",
    "$": 1097000,
    "address": "292 Russett Rd",
    "parcel_id": "387-02-00",
    "owner1": "PARIAL, ZENAIDA H-KAREN-LYNDA L",
    "owner2": "",
    "current_taxes": 7598.35,
    "new_taxes_no_override": 7926.6,
    "override_total_1": 8151.51,
    "override_increase_1": 224.91
  },
  {
    "#": "295 Russett Rd (386-03-00)",
    "$": 1302000,
    "address": "295 Russett Rd",
    "parcel_id": "386-03-00",
    "owner1": "DELAHANTY, DANIELLE A & BENJAMIN",
    "owner2": "",
    "current_taxes": 9697.55,
    "new_taxes_no_override": 10116.48,
    "override_total_1": 10403.53,
    "override_increase_1": 287.05
  },
  {
    "#": "296 Russett Rd (387-03-00)",
    "$": 1463900,
    "address": "296 Russett Rd",
    "parcel_id": "387-03-00",
    "owner1": "TSAI, THOMAS & SUSAN",
    "owner2": "",
    "current_taxes": 11355.4,
    "new_taxes_no_override": 11845.95,
    "override_total_1": 12182.07,
    "override_increase_1": 336.12
  },
  {
    "#": "299 Russett Rd (386-04-00)",
    "$": 1149400,
    "address": "299 Russett Rd",
    "parcel_id": "386-04-00",
    "owner1": "DRIBINSKY, VADIM",
    "owner2": "KLEYNER, YELENA",
    "current_taxes": 8134.92,
    "new_taxes_no_override": 8486.35,
    "override_total_1": 8727.14,
    "override_increase_1": 240.79
  },
  {
    "#": "300 Russett Rd (387-04-00)",
    "$": 1256600,
    "address": "300 Russett Rd",
    "parcel_id": "387-04-00",
    "owner1": "STERN, PETER L & LORRAINE",
    "owner2": "",
    "current_taxes": 9232.65,
    "new_taxes_no_override": 9631.5,
    "override_total_1": 9904.79,
    "override_increase_1": 273.29
  },
  {
    "#": "303 Russett Rd (386-05-00)",
    "$": 1554000,
    "address": "303 Russett Rd",
    "parcel_id": "386-05-00",
    "owner1": "ZANG, MIAO",
    "owner2": "LIU, MENGYA",
    "current_taxes": 15912.96,
    "new_taxes_no_override": 16600.4,
    "override_total_1": 17071.42,
    "override_increase_1": 471.02
  },
  {
    "#": "304 Russett Rd (387-05-00)",
    "$": 1364500,
    "address": "304 Russett Rd",
    "parcel_id": "387-05-00",
    "owner1": "LIAW, SHIH NING & YEN H",
    "owner2": "",
    "current_taxes": 10337.55,
    "new_taxes_no_override": 10784.13,
    "override_total_1": 11090.12,
    "override_increase_1": 305.99
  },
  {
    "#": "307 Russett Rd (386-06-00)",
    "$": 1329600,
    "address": "307 Russett Rd",
    "parcel_id": "386-06-00",
    "owner1": "GU, YONGFENG",
    "owner2": "ZHOU, YUNSHENG",
    "current_taxes": 13615.1,
    "new_taxes_no_override": 14203.27,
    "override_total_1": 14606.28,
    "override_increase_1": 403.01
  },
  {
    "#": "308 Russett Rd (387-06-00)",
    "$": 1273900,
    "address": "308 Russett Rd",
    "parcel_id": "387-06-00",
    "owner1": "CARROLL, JAMES K & MARY E",
    "owner2": "",
    "current_taxes": 9409.8,
    "new_taxes_no_override": 9816.3,
    "override_total_1": 10094.83,
    "override_increase_1": 278.53
  },
  {
    "#": "311 Russett Rd (386-07-00)",
    "$": 1543800,
    "address": "311 Russett Rd",
    "parcel_id": "386-07-00",
    "owner1": "WILSON, JAMES T",
    "owner2": "POKORNY-WILSON, DIANE",
    "current_taxes": 12173.58,
    "new_taxes_no_override": 12699.48,
    "override_total_1": 13059.82,
    "override_increase_1": 360.34
  },
  {
    "#": "312 Russett Rd (387-07-00)",
    "$": 1532200,
    "address": "312 Russett Rd",
    "parcel_id": "387-07-00",
    "owner1": "SOLEM, DAVID ERIC",
    "owner2": "",
    "current_taxes": 12054.79,
    "new_taxes_no_override": 12575.56,
    "override_total_1": 12932.38,
    "override_increase_1": 356.82
  },
  {
    "#": "315 Russett Rd (386-08-00)",
    "$": 1146300,
    "address": "315 Russett Rd",
    "parcel_id": "386-08-00",
    "owner1": "LEVY, TR, SARA",
    "owner2": "",
    "current_taxes": 8103.18,
    "new_taxes_no_override": 8453.24,
    "override_total_1": 8693.09,
    "override_increase_1": 239.85
  },
  {
    "#": "316 Russett Rd (387-08-00)",
    "$": 1567100,
    "address": "316 Russett Rd",
    "parcel_id": "387-08-00",
    "owner1": "104-106 PAYSON RD LLC",
    "owner2": "",
    "current_taxes": 12412.17,
    "new_taxes_no_override": 12948.38,
    "override_total_1": 13315.78,
    "override_increase_1": 367.4
  },
  {
    "#": "319 Russett Rd (386-09-00)",
    "$": 1718700,
    "address": "319 Russett Rd",
    "parcel_id": "386-09-00",
    "owner1": "JOHNSON TRS, DANIEL A & SARAH L",
    "owner2": "",
    "current_taxes": 13964.55,
    "new_taxes_no_override": 14567.82,
    "override_total_1": 14981.17,
    "override_increase_1": 413.35
  },
  {
    "#": "320 Russett Rd (387-09-00)",
    "$": 1478700,
    "address": "320 Russett Rd",
    "parcel_id": "387-09-00",
    "owner1": "PRAGER TRS, ROBERT M & MARCY A",
    "owner2": "",
    "current_taxes": 11506.95,
    "new_taxes_no_override": 12004.05,
    "override_total_1": 12344.66,
    "override_increase_1": 340.61
  },
  {
    "#": "333 Russett Rd (390-15-00)",
    "$": 1114200,
    "address": "333 Russett Rd",
    "parcel_id": "390-15-00",
    "owner1": "JONAS, ALISA G",
    "owner2": "DAY, DAVID S",
    "current_taxes": 7774.47,
    "new_taxes_no_override": 8110.33,
    "override_total_1": 8340.45,
    "override_increase_1": 230.12
  },
  {
    "#": "336 Russett Rd (389-02-00)",
    "$": 1491200,
    "address": "336 Russett Rd",
    "parcel_id": "389-02-00",
    "owner1": "SILVERSTON, CHARLES M",
    "owner2": "SMALL, LAUREN",
    "current_taxes": 11634.95,
    "new_taxes_no_override": 12137.58,
    "override_total_1": 12481.97,
    "override_increase_1": 344.39
  },
  {
    "#": "339 Russett Rd (390-16-00)",
    "$": 1392300,
    "address": "339 Russett Rd",
    "parcel_id": "390-16-00",
    "owner1": "ILORI, TITILAYO & OLAWALE",
    "owner2": "",
    "current_taxes": 10622.22,
    "new_taxes_no_override": 11081.1,
    "override_total_1": 11395.52,
    "override_increase_1": 314.42
  },
  {
    "#": "340 Russett Rd (389-03-00)",
    "$": 1384000,
    "address": "340 Russett Rd",
    "parcel_id": "389-03-00",
    "owner1": "NIR, MICHAEL & CHEN",
    "owner2": "",
    "current_taxes": 10537.23,
    "new_taxes_no_override": 10992.44,
    "override_total_1": 11304.34,
    "override_increase_1": 311.9
  },
  {
    "#": "343 Russett Rd (390-17-00)",
    "$": 1438900,
    "address": "343 Russett Rd",
    "parcel_id": "390-17-00",
    "owner1": "BERLINE TRS, LEONID",
    "owner2": "POCHERSTNIK, INNA",
    "current_taxes": 11099.4,
    "new_taxes_no_override": 11578.89,
    "override_total_1": 11907.44,
    "override_increase_1": 328.54
  },
  {
    "#": "344 Russett Rd (389-04-00)",
    "$": 1864400,
    "address": "344 Russett Rd",
    "parcel_id": "389-04-00",
    "owner1": "VIOLA, RACHEL S",
    "owner2": "KULKE, MATTHEW",
    "current_taxes": 15456.52,
    "new_taxes_no_override": 16124.24,
    "override_total_1": 16581.75,
    "override_increase_1": 457.51
  },
  {
    "#": "347 Russett Rd (390-18-00)",
    "$": 1408900,
    "address": "347 Russett Rd",
    "parcel_id": "390-18-00",
    "owner1": "ZHOU, JING",
    "owner2": "GAO, WENHUA",
    "current_taxes": 10792.2,
    "new_taxes_no_override": 11258.42,
    "override_total_1": 11577.87,
    "override_increase_1": 319.45
  },
  {
    "#": "348 Russett Rd (389-05-00)",
    "$": 1219100,
    "address": "348 Russett Rd",
    "parcel_id": "389-05-00",
    "owner1": "NAPOLITAN, MICHAEL & JASMIN",
    "owner2": "",
    "current_taxes": 8848.65,
    "new_taxes_no_override": 9230.91,
    "override_total_1": 9492.83,
    "override_increase_1": 261.92
  },
  {
    "#": "352 Russett Rd (389-06-00)",
    "$": 1516000,
    "address": "352 Russett Rd",
    "parcel_id": "389-06-00",
    "owner1": "WANG TRS, FREDERICK CHI SHING & RHODINNE K",
    "owner2": "",
    "current_taxes": 11888.91,
    "new_taxes_no_override": 12402.51,
    "override_total_1": 12754.42,
    "override_increase_1": 351.91
  },
  {
    "#": "353 Russett Rd (390-19-00)",
    "$": 1253300,
    "address": "353 Russett Rd",
    "parcel_id": "390-19-00",
    "owner1": "BERMAN TR, EVELYN G",
    "owner2": "",
    "current_taxes": 9198.86,
    "new_taxes_no_override": 9596.25,
    "override_total_1": 9868.54,
    "override_increase_1": 272.29
  },
  {
    "#": "358 Russett Rd (389-07-00)",
    "$": 1550500,
    "address": "358 Russett Rd",
    "parcel_id": "389-07-00",
    "owner1": "PARSONS, MICHELLE D",
    "owner2": "BLOOM, ALEXANDER B",
    "current_taxes": 12242.19,
    "new_taxes_no_override": 12771.05,
    "override_total_1": 13133.42,
    "override_increase_1": 362.37
  },
  {
    "#": "359 Russett Rd (390-20-00)",
    "$": 1298400,
    "address": "359 Russett Rd",
    "parcel_id": "390-20-00",
    "owner1": "FULTON TRS, DAVID R & NANCY S",
    "owner2": "",
    "current_taxes": 13295.62,
    "new_taxes_no_override": 13869.99,
    "override_total_1": 14263.54,
    "override_increase_1": 393.55
  },
  {
    "#": "362 Russett Rd (389-08-00)",
    "$": 1474400,
    "address": "362 Russett Rd",
    "parcel_id": "389-08-00",
    "owner1": "COHEN, JESSICA L",
    "owner2": "KOVALKO, PETER",
    "current_taxes": 11462.92,
    "new_taxes_no_override": 11958.12,
    "override_total_1": 12297.42,
    "override_increase_1": 339.3
  },
  {
    "#": "365 Russett Rd (390-21-00)",
    "$": 1601900,
    "address": "365 Russett Rd",
    "parcel_id": "390-21-00",
    "owner1": "FRIEDLER TRS, WILLIAM N & MICHELE",
    "owner2": "",
    "current_taxes": 12768.52,
    "new_taxes_no_override": 13320.12,
    "override_total_1": 13698.07,
    "override_increase_1": 377.95
  },
  {
    "#": "366 Russett Rd (389-09-00)",
    "$": 970000,
    "address": "366 Russett Rd",
    "parcel_id": "389-09-00",
    "owner1": "FRAWLEY, REGINA  M",
    "owner2": "",
    "current_taxes": 6297.87,
    "new_taxes_no_override": 6569.94,
    "override_total_1": 6756.35,
    "override_increase_1": 186.42
  },
  {
    "#": "371 Russett Rd (390-22-00)",
    "$": 1420500,
    "address": "371 Russett Rd",
    "parcel_id": "390-22-00",
    "owner1": "MANNING TRS, DIONNE GRAHAM & MICHAEL",
    "owner2": "",
    "current_taxes": 10910.99,
    "new_taxes_no_override": 11382.34,
    "override_total_1": 11705.31,
    "override_increase_1": 322.97
  },
  {
    "#": "372 Russett Rd (389-10-00)",
    "$": 1361200,
    "address": "372 Russett Rd",
    "parcel_id": "389-10-00",
    "owner1": "POWERS TR, LINDA RAYMOND",
    "owner2": "",
    "current_taxes": 10303.75,
    "new_taxes_no_override": 10748.87,
    "override_total_1": 11053.86,
    "override_increase_1": 304.99
  },
  {
    "#": "377 Russett Rd (390-23-00)",
    "$": 1280200,
    "address": "377 Russett Rd",
    "parcel_id": "390-23-00",
    "owner1": "MAYER, ROBERT E",
    "owner2": "",
    "current_taxes": 9474.31,
    "new_taxes_no_override": 9883.6,
    "override_total_1": 10164.04,
    "override_increase_1": 280.44
  },
  {
    "#": "378 Russett Rd (389-11-00)",
    "$": 1519800,
    "address": "378 Russett Rd",
    "parcel_id": "389-11-00",
    "owner1": "SHEIKH, LUBNA",
    "owner2": "",
    "current_taxes": 11927.82,
    "new_taxes_no_override": 12443.1,
    "override_total_1": 12796.17,
    "override_increase_1": 353.06
  },
  {
    "#": "383 Russett Rd (390-24-00)",
    "$": 1236400,
    "address": "383 Russett Rd",
    "parcel_id": "390-24-00",
    "owner1": "GLADSTONE, TRACY & SCOTT",
    "owner2": "",
    "current_taxes": 9025.8,
    "new_taxes_no_override": 9415.71,
    "override_total_1": 9682.88,
    "override_increase_1": 267.16
  },
  {
    "#": "9 Salisbury Rd (100-02-00)",
    "$": 3103000,
    "address": "9 Salisbury Rd",
    "parcel_id": "100-02-00",
    "owner1": "SEGARRA, STEVEN D",
    "owner2": "YAO, JINZHEN",
    "current_taxes": 28139.79,
    "new_taxes_no_override": 29355.43,
    "override_total_1": 30188.37,
    "override_increase_1": 832.94
  },
  {
    "#": "12 Salisbury Rd (101-24-00)",
    "$": 3375000,
    "address": "12 Salisbury Rd",
    "parcel_id": "101-24-00",
    "owner1": "BODIE, TRS, ZVI & JUDITH",
    "owner2": "",
    "current_taxes": 30925.07,
    "new_taxes_no_override": 32261.03,
    "override_total_1": 33176.42,
    "override_increase_1": 915.38
  },
  {
    "#": "15 Salisbury Rd (100-03-00)",
    "$": 2892700,
    "address": "15 Salisbury Rd",
    "parcel_id": "100-03-00",
    "owner1": "BATISTA, STACEY & DAVID",
    "owner2": "",
    "current_taxes": 25986.31,
    "new_taxes_no_override": 27108.92,
    "override_total_1": 27878.11,
    "override_increase_1": 769.19
  },
  {
    "#": "18 Salisbury Rd (101-23-00)",
    "$": 2690500,
    "address": "18 Salisbury Rd",
    "parcel_id": "101-23-00",
    "owner1": "REEVE, CHRISTOPHER L",
    "owner2": "MIMS, NANCYE J",
    "current_taxes": 23915.79,
    "new_taxes_no_override": 24948.95,
    "override_total_1": 25656.86,
    "override_increase_1": 707.91
  },
  {
    "#": "21 Salisbury Rd (100-04-00)",
    "$": 3170900,
    "address": "21 Salisbury Rd",
    "parcel_id": "100-04-00",
    "owner1": "DENCKER, JOHN C",
    "owner2": "AGUILERA, RUTH",
    "current_taxes": 28835.08,
    "new_taxes_no_override": 30080.76,
    "override_total_1": 30934.27,
    "override_increase_1": 853.52
  },
  {
    "#": "22 Salisbury Rd (101-22-00)",
    "$": 3110400,
    "address": "22 Salisbury Rd",
    "parcel_id": "101-22-00",
    "owner1": "FRIEDMAN, DEENA E & MICHAEL E",
    "owner2": "",
    "current_taxes": 28215.56,
    "new_taxes_no_override": 29434.47,
    "override_total_1": 30269.65,
    "override_increase_1": 835.18
  },
  {
    "#": "25 Salisbury Rd (100-05-00)",
    "$": 2531500,
    "address": "25 Salisbury Rd",
    "parcel_id": "100-05-00",
    "owner1": "LOHE, WERNER A JR & CAROL T",
    "owner2": "",
    "current_taxes": 22287.63,
    "new_taxes_no_override": 23250.46,
    "override_total_1": 23910.17,
    "override_increase_1": 659.71
  },
  {
    "#": "26 Salisbury Rd (101-21-00)",
    "$": 2806100,
    "address": "26 Salisbury Rd",
    "parcel_id": "101-21-00",
    "owner1": "PARADIS TRS, JAMES G & JUDITH E",
    "owner2": "",
    "current_taxes": 25099.53,
    "new_taxes_no_override": 26183.83,
    "override_total_1": 26926.78,
    "override_increase_1": 742.95
  },
  {
    "#": "29 Salisbury Rd (100-06-00)",
    "$": 2604800,
    "address": "29 Salisbury Rd",
    "parcel_id": "100-06-00",
    "owner1": "LOCKWOOD TRS, LEWIS H",
    "owner2": "PENMAN, AVA B",
    "current_taxes": 23038.22,
    "new_taxes_no_override": 24033.47,
    "override_total_1": 24715.4,
    "override_increase_1": 681.93
  },
  {
    "#": "32 Salisbury Rd (101-20-00)",
    "$": 2555700,
    "address": "32 Salisbury Rd",
    "parcel_id": "101-20-00",
    "owner1": "BOTTIGLIERI, JASON & MARINA",
    "owner2": "",
    "current_taxes": 22535.43,
    "new_taxes_no_override": 23508.96,
    "override_total_1": 24176.01,
    "override_increase_1": 667.05
  },
  {
    "#": "36 Salisbury Rd (101-19-00)",
    "$": 2334400,
    "address": "36 Salisbury Rd",
    "parcel_id": "101-19-00",
    "owner1": "ELLIS, ALFRED D & SHARON H",
    "owner2": "",
    "current_taxes": 20269.32,
    "new_taxes_no_override": 21144.95,
    "override_total_1": 21744.93,
    "override_increase_1": 599.97
  },
  {
    "#": "37 Salisbury Rd (100-07-00)",
    "$": 3424700,
    "address": "37 Salisbury Rd",
    "parcel_id": "100-07-00",
    "owner1": "BOLMAN TRS, LEE G",
    "owner2": "GALLOS, JOAN V",
    "current_taxes": 31433.99,
    "new_taxes_no_override": 32791.94,
    "override_total_1": 33722.38,
    "override_increase_1": 930.45
  },
  {
    "#": "40 Salisbury Rd (101-18-00)",
    "$": 2508500,
    "address": "40 Salisbury Rd",
    "parcel_id": "101-18-00",
    "owner1": "CIPULLO, EDWARD P JR & HILARY M",
    "owner2": "",
    "current_taxes": 22052.11,
    "new_taxes_no_override": 23004.76,
    "override_total_1": 23657.5,
    "override_increase_1": 652.74
  },
  {
    "#": "43 Salisbury Rd (100-08-00)",
    "$": 2686000,
    "address": "43 Salisbury Rd",
    "parcel_id": "100-08-00",
    "owner1": "HARDT TRS, ERIC J & SUSAN W",
    "owner2": "",
    "current_taxes": 23869.71,
    "new_taxes_no_override": 24900.88,
    "override_total_1": 25607.42,
    "override_increase_1": 706.54
  },
  {
    "#": "47 Salisbury Rd (100-09-00)",
    "$": 2677900,
    "address": "47 Salisbury Rd",
    "parcel_id": "100-09-00",
    "owner1": "HOCHBERG TRS, LEIGH R  & DAISY",
    "owner2": "",
    "current_taxes": 23786.76,
    "new_taxes_no_override": 24814.35,
    "override_total_1": 25518.44,
    "override_increase_1": 704.09
  },
  {
    "#": "48 Salisbury Rd (101-17-00)",
    "$": 2927300,
    "address": "48 Salisbury Rd",
    "parcel_id": "101-17-00",
    "owner1": "NARKAJ, ALEXANDER",
    "owner2": "GUROWSKY, ANNA PASHMAN",
    "current_taxes": 26340.62,
    "new_taxes_no_override": 27478.53,
    "override_total_1": 28258.22,
    "override_increase_1": 779.68
  },
  {
    "#": "51 Salisbury Rd (100-10-00)",
    "$": 3999900,
    "address": "51 Salisbury Rd",
    "parcel_id": "100-10-00",
    "owner1": "CONSIDINE, JEFFREY M",
    "owner2": "CHUNG, JINYOON",
    "current_taxes": 37324.04,
    "new_taxes_no_override": 38936.44,
    "override_total_1": 40041.23,
    "override_increase_1": 1104.79
  },
  {
    "#": "52 Salisbury Rd (101-16-00)",
    "$": 2367300,
    "address": "52 Salisbury Rd",
    "parcel_id": "101-16-00",
    "owner1": "BORODIN, ALEXEI",
    "owner2": "",
    "current_taxes": 20606.22,
    "new_taxes_no_override": 21496.41,
    "override_total_1": 22106.35,
    "override_increase_1": 609.94
  },
  {
    "#": "71 Salisbury Rd (099-02-00)",
    "$": 2536500,
    "address": "71 Salisbury Rd",
    "parcel_id": "099-02-00",
    "owner1": "HAUSER, BARBARA B",
    "owner2": "",
    "current_taxes": 22338.83,
    "new_taxes_no_override": 23303.87,
    "override_total_1": 23965.1,
    "override_increase_1": 661.23
  },
  {
    "#": "72 Salisbury Rd (102-36-01)",
    "$": 2562600,
    "address": "72 Salisbury Rd",
    "parcel_id": "102-36-01",
    "owner1": "HSIEH, SAMUEL",
    "owner2": "HSU, CHRISTINA",
    "current_taxes": 26241.02,
    "new_taxes_no_override": 27374.63,
    "override_total_1": 28151.37,
    "override_increase_1": 776.73
  },
  {
    "#": "74 Salisbury Rd (102-36-00)",
    "$": 2379600,
    "address": "74 Salisbury Rd",
    "parcel_id": "102-36-00",
    "owner1": "HERMAN, JONATHAN R  & KATHARINE M",
    "owner2": "",
    "current_taxes": 20732.17,
    "new_taxes_no_override": 21627.8,
    "override_total_1": 22241.47,
    "override_increase_1": 613.67
  },
  {
    "#": "77 Salisbury Rd (099-03-00)",
    "$": 4490700,
    "address": "77 Salisbury Rd",
    "parcel_id": "099-03-00",
    "owner1": "RIFKIN, ILYA & LANA",
    "owner2": "",
    "current_taxes": 45984.77,
    "new_taxes_no_override": 47971.31,
    "override_total_1": 49332.46,
    "override_increase_1": 1361.15
  },
  {
    "#": "78 Salisbury Rd (102-35-00)",
    "$": 3167400,
    "address": "78 Salisbury Rd",
    "parcel_id": "102-35-00",
    "owner1": "DICARLO, JAMES J & JULIE A",
    "owner2": "",
    "current_taxes": 28799.24,
    "new_taxes_no_override": 30043.37,
    "override_total_1": 30895.82,
    "override_increase_1": 852.46
  },
  {
    "#": "84 Salisbury Rd (102-34-00)",
    "$": 2855400,
    "address": "84 Salisbury Rd",
    "parcel_id": "102-34-00",
    "owner1": "FARHI, EDWARD",
    "owner2": "HARTOG, SOPHIA",
    "current_taxes": 25604.36,
    "new_taxes_no_override": 26710.47,
    "override_total_1": 27468.36,
    "override_increase_1": 757.89
  },
  {
    "#": "85 Salisbury Rd (099-04-00)",
    "$": 2733000,
    "address": "85 Salisbury Rd",
    "parcel_id": "099-04-00",
    "owner1": "STEINMAN, TRS, CAROL Z & THEODORE I",
    "owner2": "",
    "current_taxes": 24350.99,
    "new_taxes_no_override": 25402.95,
    "override_total_1": 26123.74,
    "override_increase_1": 720.79
  },
  {
    "#": "90 Salisbury Rd (102-33-00)",
    "$": 2868100,
    "address": "90 Salisbury Rd",
    "parcel_id": "102-33-00",
    "owner1": "HAVEN, MIRIAM SALOME",
    "owner2": "",
    "current_taxes": 25734.41,
    "new_taxes_no_override": 26846.14,
    "override_total_1": 27607.88,
    "override_increase_1": 761.74
  },
  {
    "#": "93 Salisbury Rd (099-05-00)",
    "$": 3401100,
    "address": "93 Salisbury Rd",
    "parcel_id": "099-05-00",
    "owner1": "DEUTSCH, EUGENE J & EVA M",
    "owner2": "",
    "current_taxes": 31192.33,
    "new_taxes_no_override": 32539.84,
    "override_total_1": 33463.13,
    "override_increase_1": 923.29
  },
  {
    "#": "100 Salisbury Rd (102-32-00)",
    "$": 2678400,
    "address": "100 Salisbury Rd",
    "parcel_id": "102-32-00",
    "owner1": "BACA, KATHERINE",
    "owner2": "",
    "current_taxes": 23791.88,
    "new_taxes_no_override": 24819.69,
    "override_total_1": 25523.93,
    "override_increase_1": 704.24
  },
  {
    "#": "102 Salisbury Rd (102-31-00)",
    "$": 2676200,
    "address": "102 Salisbury Rd",
    "parcel_id": "102-31-00",
    "owner1": "CONGREGATION CHESED VEMES INC",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "105 Salisbury Rd (103-01-00)",
    "$": 2919100,
    "address": "105 Salisbury Rd",
    "parcel_id": "103-01-00",
    "owner1": "DONALDSON, DAVID",
    "owner2": "ERMGASSEN, CHRISTINE ZU",
    "current_taxes": 26256.65,
    "new_taxes_no_override": 27390.94,
    "override_total_1": 28168.13,
    "override_increase_1": 777.2
  },
  {
    "#": "106 Salisbury Rd (102-30-00)",
    "$": 3109300,
    "address": "106 Salisbury Rd",
    "parcel_id": "102-30-00",
    "owner1": "WAISBURD TRS, ANDREW C & BETH S",
    "owner2": "",
    "current_taxes": 31839.23,
    "new_taxes_no_override": 33214.68,
    "override_total_1": 34157.13,
    "override_increase_1": 942.44
  },
  {
    "#": "111 Salisbury Rd (103-02-00)",
    "$": 3070500,
    "address": "111 Salisbury Rd",
    "parcel_id": "103-02-00",
    "owner1": "CARROLL, DOROTHY VICTORIA SAAD & CRAIG JR",
    "owner2": "",
    "current_taxes": 27806.99,
    "new_taxes_no_override": 29008.25,
    "override_total_1": 29831.34,
    "override_increase_1": 823.09
  },
  {
    "#": "112 Salisbury Rd (102-29-00)",
    "$": 3463700,
    "address": "112 Salisbury Rd",
    "parcel_id": "102-29-00",
    "owner1": "LEVY, CAROLYNN",
    "owner2": "",
    "current_taxes": 31833.35,
    "new_taxes_no_override": 33208.55,
    "override_total_1": 34150.82,
    "override_increase_1": 942.27
  },
  {
    "#": "118 Salisbury Rd (102-28-00)",
    "$": 2997300,
    "address": "118 Salisbury Rd",
    "parcel_id": "102-28-00",
    "owner1": "DEMETRI, GEORGE D",
    "owner2": "FRANKL, SUSAN E",
    "current_taxes": 27057.42,
    "new_taxes_no_override": 28226.3,
    "override_total_1": 29027.2,
    "override_increase_1": 800.9
  },
  {
    "#": "121 Salisbury Rd (103-03-00)",
    "$": 2729800,
    "address": "121 Salisbury Rd",
    "parcel_id": "103-03-00",
    "owner1": "REED, CHRISTOPHER & PAIGE SCOTT",
    "owner2": "",
    "current_taxes": 24318.22,
    "new_taxes_no_override": 25368.77,
    "override_total_1": 26088.59,
    "override_increase_1": 719.82
  },
  {
    "#": "133 Salisbury Rd (105-01-00)",
    "$": 4452500,
    "address": "133 Salisbury Rd",
    "parcel_id": "105-01-00",
    "owner1": "RHEI-GORER TRS, NANCY",
    "owner2": "GORER, JASON",
    "current_taxes": 41958.67,
    "new_taxes_no_override": 43771.28,
    "override_total_1": 45013.26,
    "override_increase_1": 1241.98
  },
  {
    "#": "134 Salisbury Rd, Unit 1 & P1-2 (106-13-01)",
    "$": 2603500,
    "address": "134 Salisbury Rd, Unit 1 & P1-2",
    "parcel_id": "106-13-01",
    "owner1": "SHAPIRO, JENNIFER M & JEREMY N",
    "owner2": "",
    "current_taxes": 23024.91,
    "new_taxes_no_override": 24019.59,
    "override_total_1": 24701.12,
    "override_increase_1": 681.54
  },
  {
    "#": "134 Salisbury Rd, Unit 2 & P3-4 (106-13-02)",
    "$": 2460700,
    "address": "134 Salisbury Rd, Unit 2 & P3-4",
    "parcel_id": "106-13-02",
    "owner1": "KESELMAN, EUGENE",
    "owner2": "FISHER, MAIA",
    "current_taxes": 25197.57,
    "new_taxes_no_override": 26286.11,
    "override_total_1": 27031.95,
    "override_increase_1": 745.85
  },
  {
    "#": "140 Salisbury Rd (106-12-00)",
    "$": 2058100,
    "address": "140 Salisbury Rd",
    "parcel_id": "106-12-00",
    "owner1": "WONG, PERRY V Z & JOAN H Y",
    "owner2": "C/O WONG ESTATE",
    "current_taxes": 21074.94,
    "new_taxes_no_override": 21985.38,
    "override_total_1": 22609.2,
    "override_increase_1": 623.82
  },
  {
    "#": "141 Salisbury Rd (105-02-00)",
    "$": 3683100,
    "address": "141 Salisbury Rd",
    "parcel_id": "105-02-00",
    "owner1": "DEININGER, DAVID H",
    "owner2": "GOLDWITZ, SUSAN J",
    "current_taxes": 34080.01,
    "new_taxes_no_override": 35552.27,
    "override_total_1": 36561.03,
    "override_increase_1": 1008.77
  },
  {
    "#": "145 Salisbury Rd, Unit 145 P 3-4 (105-03-02)",
    "$": 1660900,
    "address": "145 Salisbury Rd, Unit 145 P 3-4",
    "parcel_id": "105-03-02",
    "owner1": "KELLY, ADAM S",
    "owner2": "KWON, HAEGI",
    "current_taxes": 13372.68,
    "new_taxes_no_override": 13950.38,
    "override_total_1": 14346.21,
    "override_increase_1": 395.83
  },
  {
    "#": "147 Salisbury Rd, Unit 147 P 1 2 (105-03-01)",
    "$": 1276500,
    "address": "147 Salisbury Rd, Unit 147 P 1 2",
    "parcel_id": "105-03-01",
    "owner1": "KIM, LORA H",
    "owner2": "KAIN, JACOB E",
    "current_taxes": 9436.43,
    "new_taxes_no_override": 9844.08,
    "override_total_1": 10123.4,
    "override_increase_1": 279.32
  },
  {
    "#": "151 Salisbury Rd (105-04-00)",
    "$": 2774200,
    "address": "151 Salisbury Rd",
    "parcel_id": "105-04-00",
    "owner1": "PFEFFER, ELERY & GILI",
    "owner2": "",
    "current_taxes": 28407.81,
    "new_taxes_no_override": 29635.03,
    "override_total_1": 30475.9,
    "override_increase_1": 840.87
  },
  {
    "#": "154 Salisbury Rd (107-20-00)",
    "$": 2372500,
    "address": "154 Salisbury Rd",
    "parcel_id": "107-20-00",
    "owner1": "ISTCHENKO, MARINA",
    "owner2": "",
    "current_taxes": 20659.47,
    "new_taxes_no_override": 21551.96,
    "override_total_1": 22163.48,
    "override_increase_1": 611.52
  },
  {
    "#": "156 Salisbury Rd (107-19-00)",
    "$": 2354900,
    "address": "156 Salisbury Rd",
    "parcel_id": "107-19-00",
    "owner1": "PASTERNAK TR, STELLA",
    "owner2": "",
    "current_taxes": 20479.24,
    "new_taxes_no_override": 21363.94,
    "override_total_1": 21970.13,
    "override_increase_1": 606.19
  },
  {
    "#": "157 Salisbury Rd (105-05-00)",
    "$": 4155600,
    "address": "157 Salisbury Rd",
    "parcel_id": "105-05-00",
    "owner1": "PETROV, VAL",
    "owner2": "KUZNETSOVA, NATALYA",
    "current_taxes": 38918.41,
    "new_taxes_no_override": 40599.69,
    "override_total_1": 41751.67,
    "override_increase_1": 1151.98
  },
  {
    "#": "158 Salisbury Rd (107-18-00)",
    "$": 2078900,
    "address": "158 Salisbury Rd",
    "parcel_id": "107-18-00",
    "owner1": "COLTON, THEODORE & CAROLYN M",
    "owner2": "",
    "current_taxes": 17653.0,
    "new_taxes_no_override": 18415.61,
    "override_total_1": 18938.14,
    "override_increase_1": 522.53
  },
  {
    "#": "160 Salisbury Rd (107-17-00)",
    "$": 2250300,
    "address": "160 Salisbury Rd",
    "parcel_id": "107-17-00",
    "owner1": "WALLACE, OWEN B & ERIN E",
    "owner2": "",
    "current_taxes": 19408.14,
    "new_taxes_no_override": 20246.57,
    "override_total_1": 20821.05,
    "override_increase_1": 574.48
  },
  {
    "#": "167 Salisbury Rd, Unit 1 (105-06-01)",
    "$": 1584300,
    "address": "167 Salisbury Rd, Unit 1",
    "parcel_id": "105-06-01",
    "owner1": "WONG, ALAN & TUNG LEE",
    "owner2": "",
    "current_taxes": 12588.3,
    "new_taxes_no_override": 13132.11,
    "override_total_1": 13504.73,
    "override_increase_1": 372.61
  },
  {
    "#": "167 Salisbury Rd, Unit 2 & Pk B & C (105-06-02)",
    "$": 2023800,
    "address": "167 Salisbury Rd, Unit 2 & Pk B & C",
    "parcel_id": "105-06-02",
    "owner1": "SHEPSIS, MICHAEL & ALLISON",
    "owner2": "",
    "current_taxes": 17088.78,
    "new_taxes_no_override": 17827.02,
    "override_total_1": 18332.84,
    "override_increase_1": 505.83
  },
  {
    "#": "29 Sargent Beechwd (330-19-00)",
    "$": 6098600,
    "address": "29 Sargent Beechwd",
    "parcel_id": "330-19-00",
    "owner1": "ZOHAR, YISHAI & DAPHNE",
    "owner2": "",
    "current_taxes": 62449.66,
    "new_taxes_no_override": 65147.49,
    "override_total_1": 66996.0,
    "override_increase_1": 1848.51
  },
  {
    "#": "30 Sargent Beechwd (330-15-05)",
    "$": 2749300,
    "address": "30 Sargent Beechwd",
    "parcel_id": "330-15-05",
    "owner1": "RIMM TRS, ERIC B & ALLISON C",
    "owner2": "",
    "current_taxes": 24517.9,
    "new_taxes_no_override": 25577.07,
    "override_total_1": 26302.8,
    "override_increase_1": 725.73
  },
  {
    "#": "33 Sargent Beechwd (330-17-18)",
    "$": 7560500,
    "address": "33 Sargent Beechwd",
    "parcel_id": "330-17-18",
    "owner1": "GUZMAN TR, SERGIO",
    "owner2": "",
    "current_taxes": 73784.59,
    "new_taxes_no_override": 76972.08,
    "override_total_1": 79156.11,
    "override_increase_1": 2184.02
  },
  {
    "#": "40 Sargent Beechwd (330-15-04)",
    "$": 2782300,
    "address": "40 Sargent Beechwd",
    "parcel_id": "330-15-04",
    "owner1": "PIRYATINSKY, MAXIM & IRENE",
    "owner2": "",
    "current_taxes": 24855.82,
    "new_taxes_no_override": 25929.59,
    "override_total_1": 26665.32,
    "override_increase_1": 735.73
  },
  {
    "#": "50 Sargent Beechwd (330-15-03)",
    "$": 1728000,
    "address": "50 Sargent Beechwd",
    "parcel_id": "330-15-03",
    "owner1": "BERG TR, JEAN D",
    "owner2": "",
    "current_taxes": 14059.79,
    "new_taxes_no_override": 14667.17,
    "override_total_1": 15083.34,
    "override_increase_1": 416.17
  },
  {
    "#": "60 Sargent Beechwd (330-32-00)",
    "$": 5034700,
    "address": "60 Sargent Beechwd",
    "parcel_id": "330-32-00",
    "owner1": "PETTITI TR, GIANLUCA",
    "owner2": "WANKENNE-PETTITI TR, MIREILLE",
    "current_taxes": 51555.33,
    "new_taxes_no_override": 53782.52,
    "override_total_1": 55308.56,
    "override_increase_1": 1526.04
  },
  {
    "#": "75 Sargent Beechwd (330-16-00)",
    "$": 6414300,
    "address": "75 Sargent Beechwd",
    "parcel_id": "330-16-00",
    "owner1": "KOZOL TR, MATTHEW S",
    "owner2": "",
    "current_taxes": 62047.5,
    "new_taxes_no_override": 64727.95,
    "override_total_1": 66564.56,
    "override_increase_1": 1836.61
  },
  {
    "#": "82 Sargent Beechwd (330-31-00)",
    "$": 5149300,
    "address": "82 Sargent Beechwd",
    "parcel_id": "330-31-00",
    "owner1": "SAKSONOV, EUGENE & LANA",
    "owner2": "",
    "current_taxes": 49093.9,
    "new_taxes_no_override": 51214.76,
    "override_total_1": 52667.94,
    "override_increase_1": 1453.18
  },
  {
    "#": "21 Sargent Cswy (331-03-01)",
    "$": 7528100,
    "address": "21 Sargent Cswy",
    "parcel_id": "331-03-01",
    "owner1": "ADLER, MICAH & REBECCA",
    "owner2": "",
    "current_taxes": 77087.74,
    "new_taxes_no_override": 80417.93,
    "override_total_1": 82699.73,
    "override_increase_1": 2281.8
  },
  {
    "#": "40 Sargent Cswy (330-25-00)",
    "$": 9814500,
    "address": "40 Sargent Cswy",
    "parcel_id": "330-25-00",
    "owner1": "ROIFF, KRISTIN M",
    "owner2": "",
    "current_taxes": 100500.48,
    "new_taxes_no_override": 104842.1,
    "override_total_1": 107816.91,
    "override_increase_1": 2974.81
  },
  {
    "#": "46 Sargent Cswy (330-28-00)",
    "$": 5544100,
    "address": "46 Sargent Cswy",
    "parcel_id": "330-28-00",
    "owner1": "AVERY TRS, ELIZABETH",
    "owner2": "CHRISTIE, WALKER",
    "current_taxes": 53136.65,
    "new_taxes_no_override": 55432.15,
    "override_total_1": 57005.0,
    "override_increase_1": 1572.84
  },
  {
    "#": "50 Sargent Cswy (330-27-00)",
    "$": 5334800,
    "address": "50 Sargent Cswy",
    "parcel_id": "330-27-00",
    "owner1": "GALLER ET AL TRS, JANINA R",
    "owner2": "RABINOWITZ, LOREN GALLER",
    "current_taxes": 50993.42,
    "new_taxes_no_override": 53196.34,
    "override_total_1": 54705.74,
    "override_increase_1": 1509.41
  },
  {
    "#": "53 Sargent Cswy (331-01-07)",
    "$": 23300400,
    "address": "53 Sargent Cswy",
    "parcel_id": "331-01-07",
    "owner1": "ROSENBERG TR, PETER",
    "owner2": "",
    "current_taxes": 238596.1,
    "new_taxes_no_override": 248903.45,
    "override_total_1": 255965.9,
    "override_increase_1": 7062.44
  },
  {
    "#": "56 Sargent Cswy (330-29-00)",
    "$": 6719400,
    "address": "56 Sargent Cswy",
    "parcel_id": "330-29-00",
    "owner1": "56 SARGENT CROSSWAY LLC",
    "owner2": "C/O RABINOWITZ, BURTON D",
    "current_taxes": 68806.66,
    "new_taxes_no_override": 71779.11,
    "override_total_1": 73815.78,
    "override_increase_1": 2036.68
  },
  {
    "#": " Sargent Cswy (331-08-00)",
    "$": 205900,
    "address": " Sargent Cswy",
    "parcel_id": "331-08-00",
    "owner1": "BASS TRS, MICHAEL A",
    "owner2": "SAUNDERS , GARY L",
    "current_taxes": 2108.42,
    "new_taxes_no_override": 2199.5,
    "override_total_1": 2261.91,
    "override_increase_1": 62.41
  },
  {
    "#": "42 Sargent Rd (330-20-02)",
    "$": 751000,
    "address": "42 Sargent Rd",
    "parcel_id": "330-20-02",
    "owner1": "BROOKLINE CONSERVATION LAND TR",
    "owner2": "EDWARD LAWRENCE TRS",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "47 Sargent Rd (329-17-00)",
    "$": 9525400,
    "address": "47 Sargent Rd",
    "parcel_id": "329-17-00",
    "owner1": "MASDEA TRS, MICHAEL & JODI",
    "owner2": "",
    "current_taxes": 93905.16,
    "new_taxes_no_override": 97961.86,
    "override_total_1": 100741.46,
    "override_increase_1": 2779.59
  },
  {
    "#": "54 Sargent Rd (330-20-01)",
    "$": 7574800,
    "address": "54 Sargent Rd",
    "parcel_id": "330-20-01",
    "owner1": "JENNINGS TRS, DAVID L III",
    "owner2": "KREBS, JENNIFER J",
    "current_taxes": 73931.02,
    "new_taxes_no_override": 77124.84,
    "override_total_1": 79313.2,
    "override_increase_1": 2188.36
  },
  {
    "#": "75 Sargent Rd (333-04-00)",
    "$": 7081300,
    "address": "75 Sargent Rd",
    "parcel_id": "333-04-00",
    "owner1": "SAVAGE TRS, JASON B & MELANIE A",
    "owner2": "",
    "current_taxes": 68877.58,
    "new_taxes_no_override": 71853.09,
    "override_total_1": 73891.87,
    "override_increase_1": 2038.78
  },
  {
    "#": "82 Sargent Rd (330-26-00)",
    "$": 7152600,
    "address": "82 Sargent Rd",
    "parcel_id": "330-26-00",
    "owner1": "MONOVOUKAS, MICHAEL & GENNA L",
    "owner2": "",
    "current_taxes": 69607.69,
    "new_taxes_no_override": 72614.74,
    "override_total_1": 74675.13,
    "override_increase_1": 2060.39
  },
  {
    "#": "90 Sargent Rd (330-30-00)",
    "$": 7242900,
    "address": "90 Sargent Rd",
    "parcel_id": "330-30-00",
    "owner1": "LEERINK, JEFFREY A & KRISTI M",
    "owner2": "",
    "current_taxes": 70532.36,
    "new_taxes_no_override": 73579.36,
    "override_total_1": 75667.12,
    "override_increase_1": 2087.76
  },
  {
    "#": "99 Sargent Rd (333-05-00)",
    "$": 10066400,
    "address": "99 Sargent Rd",
    "parcel_id": "333-05-00",
    "owner1": "PLUHAR, JAMS ANDREW",
    "owner2": "",
    "current_taxes": 103079.94,
    "new_taxes_no_override": 107532.99,
    "override_total_1": 110584.16,
    "override_increase_1": 3051.17
  },
  {
    "#": "106 Sargent Rd (330-23-00)",
    "$": 8540600,
    "address": "106 Sargent Rd",
    "parcel_id": "330-23-00",
    "owner1": "CLEARY, TANIA & DENIS J III",
    "owner2": "",
    "current_taxes": 83820.81,
    "new_taxes_no_override": 87441.87,
    "override_total_1": 89922.96,
    "override_increase_1": 2481.1
  },
  {
    "#": "115 Sargent Rd (333-06-00)",
    "$": 6791200,
    "address": "115 Sargent Rd",
    "parcel_id": "333-06-00",
    "owner1": "MASON, CHARLOTTE SANFORD",
    "owner2": "",
    "current_taxes": 69541.89,
    "new_taxes_no_override": 72546.1,
    "override_total_1": 74604.54,
    "override_increase_1": 2058.44
  },
  {
    "#": "120 Sargent Rd (330-24-00)",
    "$": 5696400,
    "address": "120 Sargent Rd",
    "parcel_id": "330-24-00",
    "owner1": "KOENIG, PAMELA E",
    "owner2": "",
    "current_taxes": 54696.2,
    "new_taxes_no_override": 57059.08,
    "override_total_1": 58678.08,
    "override_increase_1": 1619.01
  },
  {
    "#": "136 Sargent Rd (331-04-05)",
    "$": 642500,
    "address": "136 Sargent Rd",
    "parcel_id": "331-04-05",
    "owner1": "SARGENT ROAD TRUST",
    "owner2": "C/O AMERICAN PROPERTIES TEAM",
    "current_taxes": 6579.2,
    "new_taxes_no_override": 6863.42,
    "override_total_1": 7058.17,
    "override_increase_1": 194.74
  },
  {
    "#": "145 Sargent Rd (333-07-00)",
    "$": 9151000,
    "address": "145 Sargent Rd",
    "parcel_id": "333-07-00",
    "owner1": "WOODS TR, GREGORY M",
    "owner2": "",
    "current_taxes": 90071.31,
    "new_taxes_no_override": 93962.39,
    "override_total_1": 96628.5,
    "override_increase_1": 2666.11
  },
  {
    "#": "165 Sargent Rd (333-08-01)",
    "$": 5169400,
    "address": "165 Sargent Rd",
    "parcel_id": "333-08-01",
    "owner1": "SHAW, BRUCE P & NANCY",
    "owner2": "",
    "current_taxes": 49299.72,
    "new_taxes_no_override": 51429.47,
    "override_total_1": 52888.74,
    "override_increase_1": 1459.27
  },
  {
    "#": "170 Sargent Rd (332-10-00)",
    "$": 1338800,
    "address": "170 Sargent Rd",
    "parcel_id": "332-10-00",
    "owner1": "SUMMERA LLC",
    "owner2": "",
    "current_taxes": 13709.31,
    "new_taxes_no_override": 14301.55,
    "override_total_1": 14707.35,
    "override_increase_1": 405.8
  },
  {
    "#": "185 Sargent Rd (333-08-02)",
    "$": 4109200,
    "address": "185 Sargent Rd",
    "parcel_id": "333-08-02",
    "owner1": "SPECTOR TR, NANCY A",
    "owner2": "",
    "current_taxes": 42078.21,
    "new_taxes_no_override": 43895.99,
    "override_total_1": 45141.5,
    "override_increase_1": 1245.52
  },
  {
    "#": "209 Sargent Rd (333-08-00)",
    "$": 19299700,
    "address": "209 Sargent Rd",
    "parcel_id": "333-08-00",
    "owner1": "SPECTOR TR, NANCY A",
    "owner2": "",
    "current_taxes": 197628.93,
    "new_taxes_no_override": 206166.5,
    "override_total_1": 212016.32,
    "override_increase_1": 5849.82
  },
  {
    "#": "211 Sargent Rd (333-09-00)",
    "$": 3830800,
    "address": "211 Sargent Rd",
    "parcel_id": "333-09-00",
    "owner1": "SPECTOR TR, NANCY A",
    "owner2": "",
    "current_taxes": 35592.46,
    "new_taxes_no_override": 37130.05,
    "override_total_1": 38183.59,
    "override_increase_1": 1053.54
  },
  {
    "#": "224 Sargent Rd (332-06-08)",
    "$": 14202800,
    "address": "224 Sargent Rd",
    "parcel_id": "332-06-08",
    "owner1": "AMENT, DAVID & CHRISTINE",
    "owner2": "",
    "current_taxes": 145436.67,
    "new_taxes_no_override": 151719.53,
    "override_total_1": 156024.46,
    "override_increase_1": 4304.93
  },
  {
    "#": "225 Sargent Rd (333-10-00)",
    "$": 5354600,
    "address": "225 Sargent Rd",
    "parcel_id": "333-10-00",
    "owner1": "COX, JULIA D",
    "owner2": "",
    "current_taxes": 51196.17,
    "new_taxes_no_override": 53407.84,
    "override_total_1": 54923.25,
    "override_increase_1": 1515.41
  },
  {
    "#": "235 Sargent Rd (333-11-00)",
    "$": 4841700,
    "address": "235 Sargent Rd",
    "parcel_id": "333-11-00",
    "owner1": "GORDON, PHILIP & JULIE H",
    "owner2": "",
    "current_taxes": 49579.01,
    "new_taxes_no_override": 51720.82,
    "override_total_1": 53188.36,
    "override_increase_1": 1467.54
  },
  {
    "#": "19 School St (171-38-00)",
    "$": 1433500,
    "address": "19 School St",
    "parcel_id": "171-38-00",
    "owner1": "ST AMAND, KENNETH L II & MARIKA CONTOS",
    "owner2": "",
    "current_taxes": 11044.11,
    "new_taxes_no_override": 11521.22,
    "override_total_1": 11848.12,
    "override_increase_1": 326.91
  },
  {
    "#": "21 School St (171-39-00)",
    "$": 1239400,
    "address": "21 School St",
    "parcel_id": "171-39-00",
    "owner1": "FREDERICKS, LORETTA R",
    "owner2": "C/O SWANSON LORETTA",
    "current_taxes": 9056.52,
    "new_taxes_no_override": 9447.76,
    "override_total_1": 9715.83,
    "override_increase_1": 268.07
  },
  {
    "#": "27 School St (171-40-00)",
    "$": 1243400,
    "address": "27 School St",
    "parcel_id": "171-40-00",
    "owner1": "SWANSON, LORETTA R",
    "owner2": "",
    "current_taxes": 12732.42,
    "new_taxes_no_override": 13282.46,
    "override_total_1": 13659.34,
    "override_increase_1": 376.88
  },
  {
    "#": "29 School St (171-41-00)",
    "$": 1373800,
    "address": "29 School St",
    "parcel_id": "171-41-00",
    "owner1": "WILLIAMS, AARON C & JENNY N",
    "owner2": "",
    "current_taxes": 10432.78,
    "new_taxes_no_override": 10883.48,
    "override_total_1": 11192.29,
    "override_increase_1": 308.81
  },
  {
    "#": "31 School St (171-42-00)",
    "$": 1179100,
    "address": "31 School St",
    "parcel_id": "171-42-00",
    "owner1": "ST AMAND, KENNETH LARRY II & MARIKA CONTOS",
    "owner2": "",
    "current_taxes": 12073.98,
    "new_taxes_no_override": 12595.58,
    "override_total_1": 12952.97,
    "override_increase_1": 357.39
  },
  {
    "#": "33 School St (171-43-00)",
    "$": 1373200,
    "address": "33 School St",
    "parcel_id": "171-43-00",
    "owner1": "PUA, MENG H",
    "owner2": "",
    "current_taxes": 10426.63,
    "new_taxes_no_override": 10877.06,
    "override_total_1": 11185.69,
    "override_increase_1": 308.63
  },
  {
    "#": "39 School St (171-44-00)",
    "$": 1134000,
    "address": "39 School St",
    "parcel_id": "171-44-00",
    "owner1": "BURDETTE, DAVID NEWLIN",
    "owner2": "STACK, KATHRYN ELIZABETH",
    "current_taxes": 7977.23,
    "new_taxes_no_override": 8321.85,
    "override_total_1": 8557.97,
    "override_increase_1": 236.13
  },
  {
    "#": "41 School St (171-44-01)",
    "$": 1136500,
    "address": "41 School St",
    "parcel_id": "171-44-01",
    "owner1": "HOLEN TRS, KYLE D",
    "owner2": "BEDRIN, DAVID J",
    "current_taxes": 11637.76,
    "new_taxes_no_override": 12140.51,
    "override_total_1": 12484.99,
    "override_increase_1": 344.48
  },
  {
    "#": "43 School St (171-44-02)",
    "$": 1304500,
    "address": "43 School St",
    "parcel_id": "171-44-02",
    "owner1": "LAWSON, BENJAMIN LATHAM",
    "owner2": "ARON, REBECCA MOTTOR",
    "current_taxes": 13358.08,
    "new_taxes_no_override": 13935.15,
    "override_total_1": 14330.55,
    "override_increase_1": 395.4
  },
  {
    "#": "45 School St (171-44-03)",
    "$": 1409700,
    "address": "45 School St",
    "parcel_id": "171-44-03",
    "owner1": "LAM, CHI",
    "owner2": "",
    "current_taxes": 14435.33,
    "new_taxes_no_override": 15058.94,
    "override_total_1": 15486.22,
    "override_increase_1": 427.29
  },
  {
    "#": "47 School St (171-45-00)",
    "$": 1690300,
    "address": "47 School St",
    "parcel_id": "171-45-00",
    "owner1": "SANIEOFF TRS, ESHAGH",
    "owner2": "NAVIAN, SHAHNAZ",
    "current_taxes": 17308.67,
    "new_taxes_no_override": 18056.4,
    "override_total_1": 18568.74,
    "override_increase_1": 512.34
  },
  {
    "#": "50 School St (172-03-00)",
    "$": 26323800,
    "address": "50 School St",
    "parcel_id": "172-03-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O PIERCE SCHOOL",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "53 School St (171-27-00)",
    "$": 13331300,
    "address": "53 School St",
    "parcel_id": "171-27-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O PIERCE SCHOOL PLAYGROUND",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "69 School St (171-48-02)",
    "$": 3534100,
    "address": "69 School St",
    "parcel_id": "171-48-02",
    "owner1": "VILLA SCUOLA LLC",
    "owner2": "",
    "current_taxes": 60645.16,
    "new_taxes_no_override": 63265.03,
    "override_total_1": 65060.13,
    "override_increase_1": 1795.1
  },
  {
    "#": "81 School St (171-49-00)",
    "$": 1416600,
    "address": "81 School St",
    "parcel_id": "171-49-00",
    "owner1": "KIM TRS, PAUL J",
    "owner2": "",
    "current_taxes": 18517.12,
    "new_taxes_no_override": 19317.06,
    "override_total_1": 19865.17,
    "override_increase_1": 548.11
  },
  {
    "#": "89 School St (171-50-00)",
    "$": 1600500,
    "address": "89 School St",
    "parcel_id": "171-50-00",
    "owner1": "RITS TR, EHIEL",
    "owner2": "",
    "current_taxes": 16389.12,
    "new_taxes_no_override": 17097.13,
    "override_total_1": 17582.25,
    "override_increase_1": 485.12
  },
  {
    "#": "105 School St (171-51-00)",
    "$": 1299100,
    "address": "105 School St",
    "parcel_id": "171-51-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O SCHOOL ST PARKING LOT",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "115 School St, Unit 1 (171-52-01)",
    "$": 842800,
    "address": "115 School St, Unit 1",
    "parcel_id": "171-52-01",
    "owner1": "CASSERLY, PATRICK H",
    "owner2": "",
    "current_taxes": 4995.34,
    "new_taxes_no_override": 5211.14,
    "override_total_1": 5359.0,
    "override_increase_1": 147.86
  },
  {
    "#": "115 School St, Unit 2 &G2 P3 (171-52-02)",
    "$": 983800,
    "address": "115 School St, Unit 2 &G2 P3",
    "parcel_id": "171-52-02",
    "owner1": "KONISKY TRS, RAYMOND A III & KAREN A",
    "owner2": "",
    "current_taxes": 6439.18,
    "new_taxes_no_override": 6717.35,
    "override_total_1": 6907.95,
    "override_increase_1": 190.6
  },
  {
    "#": "115 School St, Unit 3 (171-52-03)",
    "$": 1078700,
    "address": "115 School St, Unit 3",
    "parcel_id": "171-52-03",
    "owner1": "SCHAFFER, ADAM",
    "owner2": "VAUGHN, CAITLIN",
    "current_taxes": 7410.95,
    "new_taxes_no_override": 7731.1,
    "override_total_1": 7950.47,
    "override_increase_1": 219.36
  },
  {
    "#": "3 Searle Ave, Unit 2 (177-25-06)",
    "$": 1499800,
    "address": "3 Searle Ave, Unit 2",
    "parcel_id": "177-25-06",
    "owner1": "OSTER, JOEL M",
    "owner2": "DEL RE, ELISABETTA C",
    "current_taxes": 11723.02,
    "new_taxes_no_override": 12229.45,
    "override_total_1": 12576.46,
    "override_increase_1": 347.0
  },
  {
    "#": "8 Searle Ave, Unit 8 (177-34-01)",
    "$": 1124400,
    "address": "8 Searle Ave, Unit 8",
    "parcel_id": "177-34-01",
    "owner1": "GONG, YAN",
    "owner2": "HE, QING",
    "current_taxes": 7878.92,
    "new_taxes_no_override": 8219.29,
    "override_total_1": 8452.51,
    "override_increase_1": 233.22
  },
  {
    "#": "9 Searle Ave (177-25-02)",
    "$": 1823700,
    "address": "9 Searle Ave",
    "parcel_id": "177-25-02",
    "owner1": "MORIN, MASSIMO",
    "owner2": "GEAMBASU, OANA",
    "current_taxes": 15039.75,
    "new_taxes_no_override": 15689.47,
    "override_total_1": 16134.64,
    "override_increase_1": 445.18
  },
  {
    "#": "10 Searle Ave, Unit 10 (177-34-02)",
    "$": 1163900,
    "address": "10 Searle Ave, Unit 10",
    "parcel_id": "177-34-02",
    "owner1": "JEWHURST, JASON",
    "owner2": "ZUKER, NURIT",
    "current_taxes": 8283.4,
    "new_taxes_no_override": 8641.24,
    "override_total_1": 8886.43,
    "override_increase_1": 245.19
  },
  {
    "#": "14 Searle Ave (177-33-00)",
    "$": 2278700,
    "address": "14 Searle Ave",
    "parcel_id": "177-33-00",
    "owner1": "LARRABEE TRS, J WHITFIELD & SUSAN F",
    "owner2": "",
    "current_taxes": 23333.89,
    "new_taxes_no_override": 24341.91,
    "override_total_1": 25032.6,
    "override_increase_1": 690.68
  },
  {
    "#": "15 Searle Ave (177-26-00)",
    "$": 2634800,
    "address": "15 Searle Ave",
    "parcel_id": "177-26-00",
    "owner1": "HUSSON TRS, ROBERT N & CHRISTINE A DESAN",
    "owner2": "",
    "current_taxes": 23345.42,
    "new_taxes_no_override": 24353.94,
    "override_total_1": 25044.97,
    "override_increase_1": 691.02
  },
  {
    "#": "19 Searle Ave (177-27-00)",
    "$": 2549700,
    "address": "19 Searle Ave",
    "parcel_id": "177-27-00",
    "owner1": "ELKINS, JACOB S",
    "owner2": "",
    "current_taxes": 22473.99,
    "new_taxes_no_override": 23444.87,
    "override_total_1": 24110.1,
    "override_increase_1": 665.23
  },
  {
    "#": "20 Searle Ave (177-32-00)",
    "$": 2278900,
    "address": "20 Searle Ave",
    "parcel_id": "177-32-00",
    "owner1": "ROFFMAN, IAN & JENNIFER",
    "owner2": "",
    "current_taxes": 19701.0,
    "new_taxes_no_override": 20552.08,
    "override_total_1": 21135.23,
    "override_increase_1": 583.15
  },
  {
    "#": "21 Searle Ave, Unit 1 (177-28-01)",
    "$": 1214500,
    "address": "21 Searle Ave, Unit 1",
    "parcel_id": "177-28-01",
    "owner1": "WINKELMAN, WILLIAM",
    "owner2": "LOWELL, BENJAMIN",
    "current_taxes": 8801.55,
    "new_taxes_no_override": 9181.78,
    "override_total_1": 9442.3,
    "override_increase_1": 260.53
  },
  {
    "#": "21 Searle Ave, Unit 2 (177-28-02)",
    "$": 1114400,
    "address": "21 Searle Ave, Unit 2",
    "parcel_id": "177-28-02",
    "owner1": "FLACK, MARK J",
    "owner2": "DERAMO-FLACK, PATRICE MARIE",
    "current_taxes": 11411.46,
    "new_taxes_no_override": 11904.44,
    "override_total_1": 12242.21,
    "override_increase_1": 337.78
  },
  {
    "#": "21 Searle Ave, Unit 3 (177-28-03)",
    "$": 1128700,
    "address": "21 Searle Ave, Unit 3",
    "parcel_id": "177-28-03",
    "owner1": "KAHN, JOEL",
    "owner2": "",
    "current_taxes": 7922.95,
    "new_taxes_no_override": 8265.22,
    "override_total_1": 8499.74,
    "override_increase_1": 234.52
  },
  {
    "#": "22 Searle Ave (177-31-00)",
    "$": 1866400,
    "address": "22 Searle Ave",
    "parcel_id": "177-31-00",
    "owner1": "PARKER, AMY W & DONALD W",
    "owner2": "",
    "current_taxes": 15477.0,
    "new_taxes_no_override": 16145.61,
    "override_total_1": 16603.73,
    "override_increase_1": 458.12
  },
  {
    "#": "23 Searle Ave (177-29-00)",
    "$": 2414500,
    "address": "23 Searle Ave",
    "parcel_id": "177-29-00",
    "owner1": "SUH TRS, CHRISTOPHER H",
    "owner2": "BURHOE, ANNA MCINTOSH",
    "current_taxes": 21089.55,
    "new_taxes_no_override": 22000.62,
    "override_total_1": 22624.87,
    "override_increase_1": 624.25
  },
  {
    "#": "26 Searle Ave (177-30-00)",
    "$": 2190900,
    "address": "26 Searle Ave",
    "parcel_id": "177-30-00",
    "owner1": "WOLFE TRS, CHRISTINA",
    "owner2": "BASSETT TRS, JOHN",
    "current_taxes": 18799.88,
    "new_taxes_no_override": 19612.03,
    "override_total_1": 20168.51,
    "override_increase_1": 556.48
  },
  {
    "#": "8 Sears Rd (349-01-02)",
    "$": 4631500,
    "address": "8 Sears Rd",
    "parcel_id": "349-01-02",
    "owner1": "XU, RUOTONG",
    "owner2": "",
    "current_taxes": 47426.56,
    "new_taxes_no_override": 49475.39,
    "override_total_1": 50879.21,
    "override_increase_1": 1403.83
  },
  {
    "#": "9 Sears Rd (347-12-00)",
    "$": 5506900,
    "address": "9 Sears Rd",
    "parcel_id": "347-12-00",
    "owner1": "BLACK, SCOTT M",
    "owner2": "",
    "current_taxes": 52755.72,
    "new_taxes_no_override": 55034.77,
    "override_total_1": 56596.34,
    "override_increase_1": 1561.57
  },
  {
    "#": "20 Sears Rd (349-18-00)",
    "$": 7546200,
    "address": "20 Sears Rd",
    "parcel_id": "349-18-00",
    "owner1": "HARRINGTON TR, SUSAN MONIZ",
    "owner2": "C/O LYNCH FINK HARRINGTON GRAY LLP",
    "current_taxes": 77273.09,
    "new_taxes_no_override": 80611.29,
    "override_total_1": 82898.57,
    "override_increase_1": 2287.28
  },
  {
    "#": "21 Sears Rd (347-13-02)",
    "$": 9681500,
    "address": "21 Sears Rd",
    "parcel_id": "347-13-02",
    "owner1": "CHANG, RAYMOND NOBU & TIFFANY",
    "owner2": "",
    "current_taxes": 95503.63,
    "new_taxes_no_override": 99629.39,
    "override_total_1": 102456.29,
    "override_increase_1": 2826.91
  },
  {
    "#": "25 Sears Rd (347-13-03)",
    "$": 11467300,
    "address": "25 Sears Rd",
    "parcel_id": "347-13-03",
    "owner1": "25 SEARS ROAD LLC",
    "owner2": "",
    "current_taxes": 117425.15,
    "new_taxes_no_override": 122497.92,
    "override_total_1": 125973.7,
    "override_increase_1": 3475.78
  },
  {
    "#": "29 Sears Rd (347-14-04)",
    "$": 5797700,
    "address": "29 Sears Rd",
    "parcel_id": "347-14-04",
    "owner1": "SULLIVAN TR, JOHANNA WISE",
    "owner2": "",
    "current_taxes": 59368.45,
    "new_taxes_no_override": 61933.17,
    "override_total_1": 63690.47,
    "override_increase_1": 1757.31
  },
  {
    "#": "33 Sears Rd (347-14-01)",
    "$": 13127500,
    "address": "33 Sears Rd",
    "parcel_id": "347-14-01",
    "owner1": "WYRICK TR, JULIE M",
    "owner2": "",
    "current_taxes": 134425.6,
    "new_taxes_no_override": 140232.79,
    "override_total_1": 144211.78,
    "override_increase_1": 3979.0
  },
  {
    "#": "37 Sears Rd (347-14-02)",
    "$": 11213400,
    "address": "37 Sears Rd",
    "parcel_id": "347-14-02",
    "owner1": "NYLEN TR, RICHARD A JR",
    "owner2": "",
    "current_taxes": 114825.22,
    "new_taxes_no_override": 119785.67,
    "override_total_1": 123184.5,
    "override_increase_1": 3398.83
  },
  {
    "#": "41 Sears Rd (347-14-03)",
    "$": 20977800,
    "address": "41 Sears Rd",
    "parcel_id": "347-14-03",
    "owner1": "BASS TR, MICHAEL A",
    "owner2": "",
    "current_taxes": 214812.67,
    "new_taxes_no_override": 224092.58,
    "override_total_1": 230451.03,
    "override_increase_1": 6358.46
  },
  {
    "#": "52 Sears Rd (350-16-00)",
    "$": 3145600,
    "address": "52 Sears Rd",
    "parcel_id": "350-16-00",
    "owner1": "FUBINI TRS, DAVID G",
    "owner2": "RIVERA, BERTHA P",
    "current_taxes": 32210.94,
    "new_taxes_no_override": 33602.45,
    "override_total_1": 34555.9,
    "override_increase_1": 953.44
  },
  {
    "#": "71 Sears Rd (347-15-00)",
    "$": 9563800,
    "address": "71 Sears Rd",
    "parcel_id": "347-15-00",
    "owner1": "CONNORS, EILEEN M",
    "owner2": "",
    "current_taxes": 94298.38,
    "new_taxes_no_override": 98372.07,
    "override_total_1": 101163.3,
    "override_increase_1": 2791.23
  },
  {
    "#": "80 Sears Rd (350-21-00)",
    "$": 13714000,
    "address": "80 Sears Rd",
    "parcel_id": "350-21-00",
    "owner1": "FUBINI TRS, DAVID G",
    "owner2": "RIVERA, BERTHA P",
    "current_taxes": 136796.43,
    "new_taxes_no_override": 142706.04,
    "override_total_1": 146755.21,
    "override_increase_1": 4049.17
  },
  {
    "#": "85 Sears Rd (347-16-00)",
    "$": 8677000,
    "address": "85 Sears Rd",
    "parcel_id": "347-16-00",
    "owner1": "HAYES, KEVIN & JULIE",
    "owner2": "",
    "current_taxes": 88852.48,
    "new_taxes_no_override": 92690.91,
    "override_total_1": 95320.94,
    "override_increase_1": 2630.03
  },
  {
    "#": "88 Sears Rd (350-22-00)",
    "$": 3286600,
    "address": "88 Sears Rd",
    "parcel_id": "350-22-00",
    "owner1": "FUBINI TRS, DAVID G",
    "owner2": "RIVERA, BERTHA P",
    "current_taxes": 33654.78,
    "new_taxes_no_override": 35108.67,
    "override_total_1": 36104.85,
    "override_increase_1": 996.18
  },
  {
    "#": "96 Sears Rd (350-14-00)",
    "$": 5802100,
    "address": "96 Sears Rd",
    "parcel_id": "350-14-00",
    "owner1": "HALLOWELL, BENEDICTE JONES",
    "owner2": "",
    "current_taxes": 55778.57,
    "new_taxes_no_override": 58188.2,
    "override_total_1": 59839.25,
    "override_increase_1": 1651.05
  },
  {
    "#": "5 Seaver St (251-08-00)",
    "$": 2775400,
    "address": "5 Seaver St",
    "parcel_id": "251-08-00",
    "owner1": "PROBSTEIN, TR, RONALD F",
    "owner2": "",
    "current_taxes": 28420.1,
    "new_taxes_no_override": 29647.85,
    "override_total_1": 30489.08,
    "override_increase_1": 841.23
  },
  {
    "#": "10 Seaver St (251-02-01)",
    "$": 55200,
    "address": "10 Seaver St",
    "parcel_id": "251-02-01",
    "owner1": "BRESLOW, JAN L & MARILYN G",
    "owner2": "C/O SPECTOR MYRON",
    "current_taxes": 565.25,
    "new_taxes_no_override": 589.67,
    "override_total_1": 606.4,
    "override_increase_1": 16.73
  },
  {
    "#": "46 Seaver St, Unit 46 (252-02-35)",
    "$": 2704100,
    "address": "46 Seaver St, Unit 46",
    "parcel_id": "252-02-35",
    "owner1": "92501 REALTY LLC",
    "owner2": "",
    "current_taxes": 27689.98,
    "new_taxes_no_override": 28886.19,
    "override_total_1": 29705.81,
    "override_increase_1": 819.62
  },
  {
    "#": "53 Seaver St (251-13-00)",
    "$": 4204400,
    "address": "53 Seaver St",
    "parcel_id": "251-13-00",
    "owner1": "SIMS, THEODORE",
    "owner2": "BUI, LINDA T",
    "current_taxes": 39418.12,
    "new_taxes_no_override": 41120.98,
    "override_total_1": 42287.76,
    "override_increase_1": 1166.78
  },
  {
    "#": "56 Seaver St, Unit 56 (252-02-36)",
    "$": 2678500,
    "address": "56 Seaver St, Unit 56",
    "parcel_id": "252-02-36",
    "owner1": "BARNES TRS, RICHARD A & LINDA J",
    "owner2": "",
    "current_taxes": 23792.91,
    "new_taxes_no_override": 24820.76,
    "override_total_1": 25525.03,
    "override_increase_1": 704.27
  },
  {
    "#": "66 Seaver St, Unit 66 (252-02-37)",
    "$": 2114500,
    "address": "66 Seaver St, Unit 66",
    "parcel_id": "252-02-37",
    "owner1": "KAROL, JOAN L",
    "owner2": "",
    "current_taxes": 21652.48,
    "new_taxes_no_override": 22587.87,
    "override_total_1": 23228.78,
    "override_increase_1": 640.91
  },
  {
    "#": "73 Seaver St (251-01-00)",
    "$": 7372500,
    "address": "73 Seaver St",
    "parcel_id": "251-01-00",
    "owner1": "HAMILTON TRS, RYLAN M & KRISTIN N",
    "owner2": "",
    "current_taxes": 75494.4,
    "new_taxes_no_override": 78755.76,
    "override_total_1": 80990.39,
    "override_increase_1": 2234.63
  },
  {
    "#": "80 Seaver St (252-01-00)",
    "$": 8725500,
    "address": "80 Seaver St",
    "parcel_id": "252-01-00",
    "owner1": "SIMNEGAR TRS, REYNA B & SAMMY",
    "owner2": "",
    "current_taxes": 85714.19,
    "new_taxes_no_override": 89417.04,
    "override_total_1": 91954.18,
    "override_increase_1": 2537.14
  },
  {
    "#": "87 Seaver St (251-02-00)",
    "$": 4710100,
    "address": "87 Seaver St",
    "parcel_id": "251-02-00",
    "owner1": "SMITH ET AL, JOSEPH",
    "owner2": "C/O MIRACLE TRUST",
    "current_taxes": 44596.49,
    "new_taxes_no_override": 46523.06,
    "override_total_1": 47843.11,
    "override_increase_1": 1320.06
  },
  {
    "#": "91 Seaver St (251-10-00)",
    "$": 5123700,
    "address": "91 Seaver St",
    "parcel_id": "251-10-00",
    "owner1": "SPECTOR, MYRON & JOANNE",
    "owner2": "",
    "current_taxes": 52466.69,
    "new_taxes_no_override": 54733.25,
    "override_total_1": 56286.27,
    "override_increase_1": 1553.01
  },
  {
    "#": "93 Seaver St (251-09-00)",
    "$": 3033600,
    "address": "93 Seaver St",
    "parcel_id": "251-09-00",
    "owner1": "93 SEAVER STREET LLC",
    "owner2": "",
    "current_taxes": 31064.06,
    "new_taxes_no_override": 32406.03,
    "override_total_1": 33325.52,
    "override_increase_1": 919.5
  },
  {
    "#": "99 Seaver St (251-02-02)",
    "$": 3918800,
    "address": "99 Seaver St",
    "parcel_id": "251-02-02",
    "owner1": "CHU, SANG MIHN",
    "owner2": "LEE, MI KYOUNG",
    "current_taxes": 36493.58,
    "new_taxes_no_override": 38070.1,
    "override_total_1": 39150.31,
    "override_increase_1": 1080.21
  },
  {
    "#": "105 Seaver St (251-02-03)",
    "$": 3916700,
    "address": "105 Seaver St",
    "parcel_id": "251-02-03",
    "owner1": "AUDOLY, LAURENT",
    "owner2": "GRANATUROVA, OLGA",
    "current_taxes": 36472.07,
    "new_taxes_no_override": 38047.66,
    "override_total_1": 39127.24,
    "override_increase_1": 1079.57
  },
  {
    "#": "111 Seaver St (251-03-00)",
    "$": 3331300,
    "address": "111 Seaver St",
    "parcel_id": "251-03-00",
    "owner1": "JAENISCH, RUDOLF",
    "owner2": "FLECKENSTEIN, ALEXA",
    "current_taxes": 30477.58,
    "new_taxes_no_override": 31794.21,
    "override_total_1": 32696.35,
    "override_increase_1": 902.14
  },
  {
    "#": "120 Seaver St, Unit A101 (250-10-01)",
    "$": 4674800,
    "address": "120 Seaver St, Unit A101",
    "parcel_id": "250-10-01",
    "owner1": "GELB TR, LAWRENCE M",
    "owner2": "",
    "current_taxes": 47869.95,
    "new_taxes_no_override": 49937.93,
    "override_total_1": 51354.88,
    "override_increase_1": 1416.95
  },
  {
    "#": "120 Seaver St, Unit A102 (250-10-02)",
    "$": 4743100,
    "address": "120 Seaver St, Unit A102",
    "parcel_id": "250-10-02",
    "owner1": "NORTH YORK UNITED CORP",
    "owner2": "",
    "current_taxes": 48569.34,
    "new_taxes_no_override": 50667.54,
    "override_total_1": 52105.19,
    "override_increase_1": 1437.65
  },
  {
    "#": "120 Seaver St, Unit A103 (250-10-03)",
    "$": 4573700,
    "address": "120 Seaver St, Unit A103",
    "parcel_id": "250-10-03",
    "owner1": "GILSON TR, CONSTANCE C",
    "owner2": "SAMET, THEODORE",
    "current_taxes": 46834.69,
    "new_taxes_no_override": 48857.95,
    "override_total_1": 50244.26,
    "override_increase_1": 1386.31
  },
  {
    "#": "120 Seaver St, Unit B101 P1 P2 (250-10-04)",
    "$": 3588300,
    "address": "120 Seaver St, Unit B101 P1 P2",
    "parcel_id": "250-10-04",
    "owner1": "GORIN, MARJORIE L",
    "owner2": "",
    "current_taxes": 33109.26,
    "new_taxes_no_override": 34539.58,
    "override_total_1": 35519.61,
    "override_increase_1": 980.03
  },
  {
    "#": "120 Seaver St, Unit B102 P3 P4 (250-10-05)",
    "$": 2444300,
    "address": "120 Seaver St, Unit B102 P3 P4",
    "parcel_id": "250-10-05",
    "owner1": "LEABMAN, SARAH DANA POST",
    "owner2": "",
    "current_taxes": 21394.7,
    "new_taxes_no_override": 22318.95,
    "override_total_1": 22952.23,
    "override_increase_1": 633.28
  },
  {
    "#": "120 Seaver St, Unit B103 P5 P6 (250-10-06)",
    "$": 2312800,
    "address": "120 Seaver St, Unit B103 P5 P6",
    "parcel_id": "250-10-06",
    "owner1": "ALTMAN TR, NANCY",
    "owner2": "",
    "current_taxes": 23683.07,
    "new_taxes_no_override": 24706.18,
    "override_total_1": 25407.2,
    "override_increase_1": 701.02
  },
  {
    "#": "120 Seaver St, Unit B104 & P7-8 (250-10-07)",
    "$": 3265300,
    "address": "120 Seaver St, Unit B104 & P7-8",
    "parcel_id": "250-10-07",
    "owner1": "BENNETT, CAMILLA",
    "owner2": "",
    "current_taxes": 33436.67,
    "new_taxes_no_override": 34881.13,
    "override_total_1": 35870.86,
    "override_increase_1": 989.73
  },
  {
    "#": "120 Seaver St, Unit B201 P23 & 24 (250-10-08)",
    "$": 3603200,
    "address": "120 Seaver St, Unit B201 P23 & 24",
    "parcel_id": "250-10-08",
    "owner1": "THALL, ROBERTA",
    "owner2": "",
    "current_taxes": 36896.77,
    "new_taxes_no_override": 38490.71,
    "override_total_1": 39582.85,
    "override_increase_1": 1092.14
  },
  {
    "#": "120 Seaver St, Unit B202 & G19-20 (250-10-09)",
    "$": 2834600,
    "address": "120 Seaver St, Unit B202 & G19-20",
    "parcel_id": "250-10-09",
    "owner1": "SAUNDERS-HARTSTEIN, LISA M",
    "owner2": "HARTSTEIN, DAVID",
    "current_taxes": 29026.3,
    "new_taxes_no_override": 30280.24,
    "override_total_1": 31139.41,
    "override_increase_1": 859.18
  },
  {
    "#": "120 Seaver St, Unit B203 P13 & 14 (250-10-10)",
    "$": 2890900,
    "address": "120 Seaver St, Unit B203 P13 & 14",
    "parcel_id": "250-10-10",
    "owner1": "STEINBRECHER, DONALD",
    "owner2": "ROBBINS, ROCHELLE",
    "current_taxes": 25967.88,
    "new_taxes_no_override": 27089.69,
    "override_total_1": 27858.34,
    "override_increase_1": 768.65
  },
  {
    "#": "120 Seaver St, Unit B204 P9 P10 (250-10-11)",
    "$": 2959900,
    "address": "120 Seaver St, Unit B204 P9 P10",
    "parcel_id": "250-10-11",
    "owner1": "FINKIELSZTEIN, SAMUEL & GALA",
    "owner2": "",
    "current_taxes": 26674.44,
    "new_taxes_no_override": 27826.78,
    "override_total_1": 28616.34,
    "override_increase_1": 789.56
  },
  {
    "#": "120 Seaver St, Unit B301 P21 & 22 (250-10-12)",
    "$": 6099300,
    "address": "120 Seaver St, Unit B301 P21 & 22",
    "parcel_id": "250-10-12",
    "owner1": "HABER, ROBERT & MARCY",
    "owner2": "",
    "current_taxes": 58821.9,
    "new_taxes_no_override": 61363.01,
    "override_total_1": 63104.13,
    "override_increase_1": 1741.13
  },
  {
    "#": "120 Seaver St, Unit B302 P11 & 12 (250-10-13)",
    "$": 2954100,
    "address": "120 Seaver St, Unit B302 P11 & 12",
    "parcel_id": "250-10-13",
    "owner1": "FORMAN, JANE P",
    "owner2": "",
    "current_taxes": 30249.98,
    "new_taxes_no_override": 31556.78,
    "override_total_1": 32452.18,
    "override_increase_1": 895.4
  },
  {
    "#": "120 Seaver St, Unit B303 P15 & 25 (250-10-14)",
    "$": 2887300,
    "address": "120 Seaver St, Unit B303 P15 & 25",
    "parcel_id": "250-10-14",
    "owner1": "DINE, HARRY K & SANDRA A",
    "owner2": "",
    "current_taxes": 25931.02,
    "new_taxes_no_override": 27051.24,
    "override_total_1": 27818.8,
    "override_increase_1": 767.56
  },
  {
    "#": "120 Seaver St, Unit B401Ph & 3G (250-10-15)",
    "$": 6267800,
    "address": "120 Seaver St, Unit B401Ph & 3G",
    "parcel_id": "250-10-15",
    "owner1": "CHAFETZ, ROBERTA A",
    "owner2": "",
    "current_taxes": 60547.34,
    "new_taxes_no_override": 63162.99,
    "override_total_1": 64955.19,
    "override_increase_1": 1792.2
  },
  {
    "#": "120 Seaver St, Unit C101 (250-10-16)",
    "$": 2645300,
    "address": "120 Seaver St, Unit C101",
    "parcel_id": "250-10-16",
    "owner1": "OFFIT TRS, SUZANNE A & ANDREW S",
    "owner2": "",
    "current_taxes": 27087.87,
    "new_taxes_no_override": 28258.07,
    "override_total_1": 29059.87,
    "override_increase_1": 801.8
  },
  {
    "#": "120 Seaver St, Unit C102 & G16 (250-10-17)",
    "$": 3466900,
    "address": "120 Seaver St, Unit C102 & G16",
    "parcel_id": "250-10-17",
    "owner1": "LURIE, SYRUL",
    "owner2": "",
    "current_taxes": 35501.06,
    "new_taxes_no_override": 37034.71,
    "override_total_1": 38085.54,
    "override_increase_1": 1050.83
  },
  {
    "#": "120 Seaver St, Unit C103 (250-10-18)",
    "$": 2506400,
    "address": "120 Seaver St, Unit C103",
    "parcel_id": "250-10-18",
    "owner1": "GOLDBERG, RICHARD D",
    "owner2": "",
    "current_taxes": 25665.54,
    "new_taxes_no_override": 26774.29,
    "override_total_1": 27533.99,
    "override_increase_1": 759.7
  },
  {
    "#": "120 Seaver St, Unit C104 & G3 (250-10-19)",
    "$": 2693000,
    "address": "120 Seaver St, Unit C104 & G3",
    "parcel_id": "250-10-19",
    "owner1": "CVR LLC",
    "owner2": "",
    "current_taxes": 27576.32,
    "new_taxes_no_override": 28767.62,
    "override_total_1": 29583.88,
    "override_increase_1": 816.26
  },
  {
    "#": "120 Seaver St, Unit C201 & P18 (250-10-20)",
    "$": 2979300,
    "address": "120 Seaver St, Unit C201 & P18",
    "parcel_id": "250-10-20",
    "owner1": "LEVENTHAL TR, DONNA R",
    "owner2": "",
    "current_taxes": 30508.03,
    "new_taxes_no_override": 31825.98,
    "override_total_1": 32729.01,
    "override_increase_1": 903.04
  },
  {
    "#": "120 Seaver St, Unit C202 & G13 (250-10-21)",
    "$": 3459800,
    "address": "120 Seaver St, Unit C202 & G13",
    "parcel_id": "250-10-21",
    "owner1": "LODISH TRS, PAMELA C & HARVEY F",
    "owner2": "",
    "current_taxes": 31793.42,
    "new_taxes_no_override": 33166.9,
    "override_total_1": 34107.98,
    "override_increase_1": 941.09
  },
  {
    "#": "120 Seaver St, Unit C203 & G6 (250-10-22)",
    "$": 2786300,
    "address": "120 Seaver St, Unit C203 & G6",
    "parcel_id": "250-10-22",
    "owner1": "BARRON TRS, ARNOLD S & BARBARA S",
    "owner2": "",
    "current_taxes": 28531.71,
    "new_taxes_no_override": 29764.28,
    "override_total_1": 30608.82,
    "override_increase_1": 844.54
  },
  {
    "#": "120 Seaver St, Unit C204 & G7 (250-10-23)",
    "$": 3272700,
    "address": "120 Seaver St, Unit C204 & G7",
    "parcel_id": "250-10-23",
    "owner1": "WOLKON TRS, JANET",
    "owner2": "",
    "current_taxes": 29877.51,
    "new_taxes_no_override": 31168.22,
    "override_total_1": 32052.59,
    "override_increase_1": 884.37
  },
  {
    "#": "120 Seaver St, Unit C301 (250-10-24)",
    "$": 2990700,
    "address": "120 Seaver St, Unit C301",
    "parcel_id": "250-10-24",
    "owner1": "ZANE, PETER L & ELLEN M",
    "owner2": "",
    "current_taxes": 30624.77,
    "new_taxes_no_override": 31947.76,
    "override_total_1": 32854.25,
    "override_increase_1": 906.49
  },
  {
    "#": "120 Seaver St, Unit C302 & G14 (250-10-25)",
    "$": 3451900,
    "address": "120 Seaver St, Unit C302 & G14",
    "parcel_id": "250-10-25",
    "owner1": "RUBIN, NINA TOLKOFF",
    "owner2": "",
    "current_taxes": 31712.52,
    "new_taxes_no_override": 33082.5,
    "override_total_1": 34021.19,
    "override_increase_1": 938.69
  },
  {
    "#": "120 Seaver St, Unit C303 & G10 (250-10-26)",
    "$": 2787100,
    "address": "120 Seaver St, Unit C303 & G10",
    "parcel_id": "250-10-26",
    "owner1": "DANIELS TR, GILBERT H & JON A",
    "owner2": "",
    "current_taxes": 24904.97,
    "new_taxes_no_override": 25980.86,
    "override_total_1": 26718.05,
    "override_increase_1": 737.19
  },
  {
    "#": "120 Seaver St, Unit C304 & G19 (250-10-27)",
    "$": 3280400,
    "address": "120 Seaver St, Unit C304 & G19",
    "parcel_id": "250-10-27",
    "owner1": "MALKIN TRS, DONALD J",
    "owner2": "602-622 WASHINGTON STREET LLC",
    "current_taxes": 33591.3,
    "new_taxes_no_override": 35042.44,
    "override_total_1": 36036.75,
    "override_increase_1": 994.3
  },
  {
    "#": "120 Seaver St, Unit C401 & G2  (250-10-28)",
    "$": 2961400,
    "address": "120 Seaver St, Unit C401 & G2 ",
    "parcel_id": "250-10-28",
    "owner1": "ZUSSMAN ET AL TRS, RANDI",
    "owner2": "C/O BOSTON DEVELOPMENT GROUP",
    "current_taxes": 30324.74,
    "new_taxes_no_override": 31634.77,
    "override_total_1": 32532.38,
    "override_increase_1": 897.61
  },
  {
    "#": "120 Seaver St, Unit C402 (250-10-29)",
    "$": 3466300,
    "address": "120 Seaver St, Unit C402",
    "parcel_id": "250-10-29",
    "owner1": "BLOOMBERG, CAROLINA",
    "owner2": "",
    "current_taxes": 35494.91,
    "new_taxes_no_override": 37028.29,
    "override_total_1": 38078.94,
    "override_increase_1": 1050.65
  },
  {
    "#": "120 Seaver St, Unit C403 & G8 (250-10-30)",
    "$": 2782900,
    "address": "120 Seaver St, Unit C403 & G8",
    "parcel_id": "250-10-30",
    "owner1": "TAFT TRS, EDWARD A & PAMELA J",
    "owner2": "C/O FAMILY CAPITAL TRUST CO",
    "current_taxes": 28496.9,
    "new_taxes_no_override": 29727.97,
    "override_total_1": 30571.47,
    "override_increase_1": 843.51
  },
  {
    "#": "120 Seaver St, Unit C404 & G5 & G9S & 9N (250-10-31)",
    "$": 3565400,
    "address": "120 Seaver St, Unit C404 & G5 & G9S & 9N",
    "parcel_id": "250-10-31",
    "owner1": "CLICKSTEIN TR, GREGG S",
    "owner2": "C/O SAWYER REALTY HOLDINGS M. ZINNANTI",
    "current_taxes": 36509.7,
    "new_taxes_no_override": 38086.92,
    "override_total_1": 39167.61,
    "override_increase_1": 1080.69
  },
  {
    "#": "120 Seaver St, Unit C501 & G12 (250-10-32)",
    "$": 6526100,
    "address": "120 Seaver St, Unit C501 & G12",
    "parcel_id": "250-10-32",
    "owner1": "ROTTENBERG  ET AL TRS, DANIEL E",
    "owner2": "C/O GOULSTON & STORRS PC",
    "current_taxes": 66827.26,
    "new_taxes_no_override": 69714.2,
    "override_total_1": 71692.28,
    "override_increase_1": 1978.09
  },
  {
    "#": "120 Seaver St, Unit C502 & G11 (250-10-33)",
    "$": 6587600,
    "address": "120 Seaver St, Unit C502 & G11",
    "parcel_id": "250-10-33",
    "owner1": "SWARTZ, SIDNEY W & JUDITH H",
    "owner2": "",
    "current_taxes": 67457.02,
    "new_taxes_no_override": 70371.16,
    "override_total_1": 72367.89,
    "override_increase_1": 1996.73
  },
  {
    "#": "120 Seaver St, Unit D101 (250-10-34)",
    "$": 2544300,
    "address": "120 Seaver St, Unit D101",
    "parcel_id": "250-10-34",
    "owner1": "BROOKLONG LLC",
    "owner2": "",
    "current_taxes": 26053.63,
    "new_taxes_no_override": 27179.15,
    "override_total_1": 27950.33,
    "override_increase_1": 771.19
  },
  {
    "#": "120 Seaver St, Unit D102 (250-10-35)",
    "$": 3435800,
    "address": "120 Seaver St, Unit D102",
    "parcel_id": "250-10-35",
    "owner1": "SMITH TR, BRUCE F",
    "owner2": "",
    "current_taxes": 35182.59,
    "new_taxes_no_override": 36702.48,
    "override_total_1": 37743.88,
    "override_increase_1": 1041.4
  },
  {
    "#": "120 Seaver St, Unit D201 G10 & 11 (250-10-36)",
    "$": 2817100,
    "address": "120 Seaver St, Unit D201 G10 & 11",
    "parcel_id": "250-10-36",
    "owner1": "SOMMADOSSI, KYOUNG",
    "owner2": "",
    "current_taxes": 25212.17,
    "new_taxes_no_override": 26301.34,
    "override_total_1": 27047.62,
    "override_increase_1": 746.28
  },
  {
    "#": "120 Seaver St, Unit D202 & 3Gar (250-10-37)",
    "$": 3455800,
    "address": "120 Seaver St, Unit D202 & 3Gar",
    "parcel_id": "250-10-37",
    "owner1": "YAO TR, BEN LIOU",
    "owner2": "CHEN TR, AMY FONG CHU",
    "current_taxes": 31752.46,
    "new_taxes_no_override": 33124.17,
    "override_total_1": 34064.04,
    "override_increase_1": 939.87
  },
  {
    "#": "120 Seaver St, Unit D301 (250-10-38)",
    "$": 6289800,
    "address": "120 Seaver St, Unit D301",
    "parcel_id": "250-10-38",
    "owner1": "DOBKIN, PENELOPE A",
    "owner2": "",
    "current_taxes": 64407.55,
    "new_taxes_no_override": 67189.96,
    "override_total_1": 69096.42,
    "override_increase_1": 1906.46
  },
  {
    "#": "120 Seaver St, Unit E100 & 3Pksp (250-10-39)",
    "$": 7475200,
    "address": "120 Seaver St, Unit E100 & 3Pksp",
    "parcel_id": "250-10-39",
    "owner1": "CONCORD THREE LLC",
    "owner2": "",
    "current_taxes": 76546.05,
    "new_taxes_no_override": 79852.84,
    "override_total_1": 82118.6,
    "override_increase_1": 2265.76
  },
  {
    "#": "120 Seaver St, Unit E101 & 2Pksp (250-10-40)",
    "$": 4476500,
    "address": "120 Seaver St, Unit E101 & 2Pksp",
    "parcel_id": "250-10-40",
    "owner1": "GORDON, JUDITH",
    "owner2": "",
    "current_taxes": 45839.36,
    "new_taxes_no_override": 47819.62,
    "override_total_1": 49176.47,
    "override_increase_1": 1356.85
  },
  {
    "#": "120 Seaver St, Unit E200 & 3Pksp (250-10-41)",
    "$": 6701500,
    "address": "120 Seaver St, Unit E200 & 3Pksp",
    "parcel_id": "250-10-41",
    "owner1": "CUTLER, ALICE",
    "owner2": "",
    "current_taxes": 68623.36,
    "new_taxes_no_override": 71587.89,
    "override_total_1": 73619.14,
    "override_increase_1": 2031.25
  },
  {
    "#": "120 Seaver St, Unit E201 & 2Pksp (250-10-42)",
    "$": 3164700,
    "address": "120 Seaver St, Unit E201 & 2Pksp",
    "parcel_id": "250-10-42",
    "owner1": "CHEN TR, XINBEI",
    "owner2": "",
    "current_taxes": 32406.53,
    "new_taxes_no_override": 33806.49,
    "override_total_1": 34765.73,
    "override_increase_1": 959.23
  },
  {
    "#": "120 Seaver St, Unit E300 & 4 Gar (250-10-43)",
    "$": 7020900,
    "address": "120 Seaver St, Unit E300 & 4 Gar",
    "parcel_id": "250-10-43",
    "owner1": "LAG SUDBURY CROSSING LLC",
    "owner2": "",
    "current_taxes": 71894.02,
    "new_taxes_no_override": 74999.84,
    "override_total_1": 77127.9,
    "override_increase_1": 2128.06
  },
  {
    "#": "121 Seaver St (251-03-01)",
    "$": 4359600,
    "address": "121 Seaver St",
    "parcel_id": "251-03-01",
    "owner1": "TSOMIDES, TRS, DIANA G",
    "owner2": "",
    "current_taxes": 41007.37,
    "new_taxes_no_override": 42778.89,
    "override_total_1": 43992.71,
    "override_increase_1": 1213.82
  },
  {
    "#": "125 Seaver St (251-03-03)",
    "$": 2444500,
    "address": "125 Seaver St",
    "parcel_id": "251-03-03",
    "owner1": "CHENG, HUNG & JILL T",
    "owner2": "",
    "current_taxes": 25031.68,
    "new_taxes_no_override": 26113.05,
    "override_total_1": 26853.99,
    "override_increase_1": 740.94
  },
  {
    "#": "141 Seaver St (251-04-00)",
    "$": 4911500,
    "address": "141 Seaver St",
    "parcel_id": "251-04-00",
    "owner1": "CHENG, HUNG & JILL T",
    "owner2": "",
    "current_taxes": 46658.83,
    "new_taxes_no_override": 48674.49,
    "override_total_1": 50055.59,
    "override_increase_1": 1381.1
  },
  {
    "#": "155 Seaver St (251-04-01)",
    "$": 3202900,
    "address": "155 Seaver St",
    "parcel_id": "251-04-01",
    "owner1": "ALTER, AMITAY",
    "owner2": "KEINAN, ANAT",
    "current_taxes": 29162.76,
    "new_taxes_no_override": 30422.59,
    "override_total_1": 31285.81,
    "override_increase_1": 863.22
  },
  {
    "#": "9 Sewall Ave (158-10-00)",
    "$": 21567800,
    "address": "9 Sewall Ave",
    "parcel_id": "158-10-00",
    "owner1": "MARJORAM LLC",
    "owner2": "C/O MCCARTHY LEGAL SERVICES",
    "current_taxes": 220854.27,
    "new_taxes_no_override": 230395.17,
    "override_total_1": 236932.46,
    "override_increase_1": 6537.29
  },
  {
    "#": "10 Sewall Ave (162-02-00)",
    "$": 11800600,
    "address": "10 Sewall Ave",
    "parcel_id": "162-02-00",
    "owner1": "PACKET BROOKLINE LLC",
    "owner2": "",
    "current_taxes": 202498.3,
    "new_taxes_no_override": 211246.23,
    "override_total_1": 217240.18,
    "override_increase_1": 5993.95
  },
  {
    "#": "51 Sewall Ave, Unit 51A (159-02-01)",
    "$": 1609600,
    "address": "51 Sewall Ave, Unit 51A",
    "parcel_id": "159-02-01",
    "owner1": "SHOTKIN TRS, JANICE G & ALAN M",
    "owner2": "",
    "current_taxes": 12847.37,
    "new_taxes_no_override": 13402.38,
    "override_total_1": 13782.66,
    "override_increase_1": 380.28
  },
  {
    "#": "51 Sewall Ave, Unit 51B (159-02-02)",
    "$": 2008800,
    "address": "51 Sewall Ave, Unit 51B",
    "parcel_id": "159-02-02",
    "owner1": "SHIVDASANI, RAMESH",
    "owner2": "KIELE, LISA CARYN",
    "current_taxes": 16935.18,
    "new_taxes_no_override": 17666.78,
    "override_total_1": 18168.06,
    "override_increase_1": 501.28
  },
  {
    "#": "53 Sewall Ave (159-03-00)",
    "$": 1330100,
    "address": "53 Sewall Ave",
    "parcel_id": "159-03-00",
    "owner1": "GIAMBRO, RHONDA J & NINA J",
    "owner2": "",
    "current_taxes": 9985.29,
    "new_taxes_no_override": 10416.65,
    "override_total_1": 10712.22,
    "override_increase_1": 295.56
  },
  {
    "#": "55 Sewall Ave, Unit 101 (159-03-26)",
    "$": 1053200,
    "address": "55 Sewall Ave, Unit 101",
    "parcel_id": "159-03-26",
    "owner1": "KATZ, YETTA E",
    "owner2": "",
    "current_taxes": 7149.83,
    "new_taxes_no_override": 7458.7,
    "override_total_1": 7670.34,
    "override_increase_1": 211.63
  },
  {
    "#": "55 Sewall Ave, Unit 1A (159-03-02)",
    "$": 759000,
    "address": "55 Sewall Ave, Unit 1A",
    "parcel_id": "159-03-02",
    "owner1": "GOPAL, MALAVALLI A",
    "owner2": "",
    "current_taxes": 4137.23,
    "new_taxes_no_override": 4315.96,
    "override_total_1": 4438.42,
    "override_increase_1": 122.46
  },
  {
    "#": "55 Sewall Ave, Unit 1B (159-03-03)",
    "$": 756700,
    "address": "55 Sewall Ave, Unit 1B",
    "parcel_id": "159-03-03",
    "owner1": "CHEUNG LIFE ESTATE, LINDA",
    "owner2": "C/O PATRICK CHEUNG",
    "current_taxes": 7748.61,
    "new_taxes_no_override": 8083.35,
    "override_total_1": 8312.71,
    "override_increase_1": 229.36
  },
  {
    "#": "55 Sewall Ave, Unit 1C (159-03-04)",
    "$": 681900,
    "address": "55 Sewall Ave, Unit 1C",
    "parcel_id": "159-03-04",
    "owner1": "WANG, FENGZHONG",
    "owner2": "QI, WEIWEI",
    "current_taxes": 6982.66,
    "new_taxes_no_override": 7284.31,
    "override_total_1": 7491.0,
    "override_increase_1": 206.69
  },
  {
    "#": "55 Sewall Ave, Unit 1D & P-Q (159-03-05)",
    "$": 751400,
    "address": "55 Sewall Ave, Unit 1D & P-Q",
    "parcel_id": "159-03-05",
    "owner1": "SUDIT TRS, DAVID M & GAYLE",
    "owner2": "",
    "current_taxes": 7694.34,
    "new_taxes_no_override": 8026.74,
    "override_total_1": 8254.49,
    "override_increase_1": 227.75
  },
  {
    "#": "55 Sewall Ave, Unit 2A & G-G (159-03-06)",
    "$": 789300,
    "address": "55 Sewall Ave, Unit 2A & G-G",
    "parcel_id": "159-03-06",
    "owner1": "SHAUGHNESSY, SAMUEL W & DANIEL E & MARILOU",
    "owner2": "",
    "current_taxes": 4447.5,
    "new_taxes_no_override": 4639.63,
    "override_total_1": 4771.28,
    "override_increase_1": 131.65
  },
  {
    "#": "55 Sewall Ave, Unit 2B (159-03-07)",
    "$": 759500,
    "address": "55 Sewall Ave, Unit 2B",
    "parcel_id": "159-03-07",
    "owner1": "WALKER, ROSEMARY E",
    "owner2": "",
    "current_taxes": 4142.35,
    "new_taxes_no_override": 4321.3,
    "override_total_1": 4443.91,
    "override_increase_1": 122.61
  },
  {
    "#": "55 Sewall Ave, Unit 2C (159-03-08)",
    "$": 726000,
    "address": "55 Sewall Ave, Unit 2C",
    "parcel_id": "159-03-08",
    "owner1": "KERAMATY TRS, HAMID",
    "owner2": "COLLINS, CATHERINE M",
    "current_taxes": 7434.24,
    "new_taxes_no_override": 7755.4,
    "override_total_1": 7975.45,
    "override_increase_1": 220.05
  },
  {
    "#": "55 Sewall Ave, Unit 2D (159-03-09)",
    "$": 739000,
    "address": "55 Sewall Ave, Unit 2D",
    "parcel_id": "159-03-09",
    "owner1": "LEE, CHIOUMIN H & LADY H",
    "owner2": "",
    "current_taxes": 7567.36,
    "new_taxes_no_override": 7894.27,
    "override_total_1": 8118.26,
    "override_increase_1": 223.99
  },
  {
    "#": "55 Sewall Ave, Unit 3A & G-E (159-03-10)",
    "$": 779400,
    "address": "55 Sewall Ave, Unit 3A & G-E",
    "parcel_id": "159-03-10",
    "owner1": "LOI, DAVID",
    "owner2": "",
    "current_taxes": 4346.12,
    "new_taxes_no_override": 4533.87,
    "override_total_1": 4662.52,
    "override_increase_1": 128.65
  },
  {
    "#": "55 Sewall Ave, Unit 3B (159-03-11)",
    "$": 753800,
    "address": "55 Sewall Ave, Unit 3B",
    "parcel_id": "159-03-11",
    "owner1": "WONG, CHECK T & SONIA",
    "owner2": "MAK, S H",
    "current_taxes": 4083.98,
    "new_taxes_no_override": 4260.41,
    "override_total_1": 4381.29,
    "override_increase_1": 120.89
  },
  {
    "#": "55 Sewall Ave, Unit 3C & P-L (159-03-12)",
    "$": 774400,
    "address": "55 Sewall Ave, Unit 3C & P-L",
    "parcel_id": "159-03-12",
    "owner1": "BAFS LLC",
    "owner2": "",
    "current_taxes": 7929.86,
    "new_taxes_no_override": 8272.43,
    "override_total_1": 8507.15,
    "override_increase_1": 234.72
  },
  {
    "#": "55 Sewall Ave, Unit 3D & Gar M (159-03-13)",
    "$": 738100,
    "address": "55 Sewall Ave, Unit 3D & Gar M",
    "parcel_id": "159-03-13",
    "owner1": "EZHUTHACHAN, JAYACHANDRAN & KAVITA",
    "owner2": "",
    "current_taxes": 7558.14,
    "new_taxes_no_override": 7884.65,
    "override_total_1": 8108.37,
    "override_increase_1": 223.72
  },
  {
    "#": "55 Sewall Ave, Unit 4A & G8 (159-03-14)",
    "$": 763000,
    "address": "55 Sewall Ave, Unit 4A & G8",
    "parcel_id": "159-03-14",
    "owner1": "GUFFEY, DAVID & JEANINE",
    "owner2": "",
    "current_taxes": 7813.12,
    "new_taxes_no_override": 8150.65,
    "override_total_1": 8381.92,
    "override_increase_1": 231.27
  },
  {
    "#": "55 Sewall Ave, Unit 4B (159-03-15)",
    "$": 750000,
    "address": "55 Sewall Ave, Unit 4B",
    "parcel_id": "159-03-15",
    "owner1": "HAIMES, JOANNE R",
    "owner2": "",
    "current_taxes": 4045.07,
    "new_taxes_no_override": 4219.82,
    "override_total_1": 4339.55,
    "override_increase_1": 119.73
  },
  {
    "#": "55 Sewall Ave, Unit 4C & P-A (159-03-16)",
    "$": 729500,
    "address": "55 Sewall Ave, Unit 4C & P-A",
    "parcel_id": "159-03-16",
    "owner1": "BULKINA, LARISA",
    "owner2": "FOYGEL, IGOR & ALEKSANDR",
    "current_taxes": 3835.15,
    "new_taxes_no_override": 4000.83,
    "override_total_1": 4114.35,
    "override_increase_1": 113.52
  },
  {
    "#": "55 Sewall Ave, Unit 4D (159-03-17)",
    "$": 741400,
    "address": "55 Sewall Ave, Unit 4D",
    "parcel_id": "159-03-17",
    "owner1": "FAMILY, FEREYDOON & SOHEILA",
    "owner2": "",
    "current_taxes": 7591.94,
    "new_taxes_no_override": 7919.91,
    "override_total_1": 8144.63,
    "override_increase_1": 224.72
  },
  {
    "#": "55 Sewall Ave, Unit 5A (159-03-18)",
    "$": 764800,
    "address": "55 Sewall Ave, Unit 5A",
    "parcel_id": "159-03-18",
    "owner1": "SUBRAMANIAN, ARUL KUMAR",
    "owner2": "",
    "current_taxes": 4196.62,
    "new_taxes_no_override": 4377.91,
    "override_total_1": 4502.13,
    "override_increase_1": 124.22
  },
  {
    "#": "55 Sewall Ave, Unit 5B & Gar-C (159-03-19)",
    "$": 870800,
    "address": "55 Sewall Ave, Unit 5B & Gar-C",
    "parcel_id": "159-03-19",
    "owner1": "ZHANG, XUECHENG & XINYAN",
    "owner2": "",
    "current_taxes": 8916.99,
    "new_taxes_no_override": 9302.2,
    "override_total_1": 9566.15,
    "override_increase_1": 263.94
  },
  {
    "#": "55 Sewall Ave, Unit 5C (159-03-20)",
    "$": 746400,
    "address": "55 Sewall Ave, Unit 5C",
    "parcel_id": "159-03-20",
    "owner1": "ZHANG, YI NING",
    "owner2": "",
    "current_taxes": 7643.14,
    "new_taxes_no_override": 7973.32,
    "override_total_1": 8199.56,
    "override_increase_1": 226.24
  },
  {
    "#": "55 Sewall Ave, Unit 5D (159-03-21)",
    "$": 739000,
    "address": "55 Sewall Ave, Unit 5D",
    "parcel_id": "159-03-21",
    "owner1": "TANG TR, FLORINE C",
    "owner2": "",
    "current_taxes": 3932.43,
    "new_taxes_no_override": 4102.31,
    "override_total_1": 4218.71,
    "override_increase_1": 116.4
  },
  {
    "#": "55 Sewall Ave, Unit Ph A (159-03-22)",
    "$": 662400,
    "address": "55 Sewall Ave, Unit Ph A",
    "parcel_id": "159-03-22",
    "owner1": "NIMBKAR, SUSHRUT",
    "owner2": "",
    "current_taxes": 3148.04,
    "new_taxes_no_override": 3284.04,
    "override_total_1": 3377.22,
    "override_increase_1": 93.18
  },
  {
    "#": "55 Sewall Ave, Unit Ph B (159-03-23)",
    "$": 748000,
    "address": "55 Sewall Ave, Unit Ph B",
    "parcel_id": "159-03-23",
    "owner1": "SHEK, YUANFU",
    "owner2": "LI, JIA",
    "current_taxes": 7659.52,
    "new_taxes_no_override": 7990.41,
    "override_total_1": 8217.13,
    "override_increase_1": 226.72
  },
  {
    "#": "55 Sewall Ave, Unit Ph C (159-03-24)",
    "$": 698600,
    "address": "55 Sewall Ave, Unit Ph C",
    "parcel_id": "159-03-24",
    "owner1": "YANG, EUROPA",
    "owner2": "",
    "current_taxes": 3518.73,
    "new_taxes_no_override": 3670.74,
    "override_total_1": 3774.89,
    "override_increase_1": 104.15
  },
  {
    "#": "55 Sewall Ave, Unit Ph D & Pi (159-03-25)",
    "$": 720200,
    "address": "55 Sewall Ave, Unit Ph D & Pi",
    "parcel_id": "159-03-25",
    "owner1": "HWANG, AARON",
    "owner2": "",
    "current_taxes": 3739.91,
    "new_taxes_no_override": 3901.47,
    "override_total_1": 4012.18,
    "override_increase_1": 110.7
  },
  {
    "#": "64 Sewall Ave, Unit 101 G27-30 (160-01-02)",
    "$": 2057000,
    "address": "64 Sewall Ave, Unit 101 G27-30",
    "parcel_id": "160-01-02",
    "owner1": "ELIAS, LAUREN R",
    "owner2": "",
    "current_taxes": 17428.75,
    "new_taxes_no_override": 18181.67,
    "override_total_1": 18697.56,
    "override_increase_1": 515.89
  },
  {
    "#": "64 Sewall Ave, Unit 102 G21G31 (160-01-03)",
    "$": 2146100,
    "address": "64 Sewall Ave, Unit 102 G21G31",
    "parcel_id": "160-01-03",
    "owner1": "YANUSHPOLSKY TRS, JOSEPH & ELENA",
    "owner2": "",
    "current_taxes": 21976.06,
    "new_taxes_no_override": 22925.43,
    "override_total_1": 23575.92,
    "override_increase_1": 650.49
  },
  {
    "#": "64 Sewall Ave, Unit 201 G22-23 (160-01-04)",
    "$": 2110700,
    "address": "64 Sewall Ave, Unit 201 G22-23",
    "parcel_id": "160-01-04",
    "owner1": "GRUBIN TRS, MICHAEL L & JAMIE D",
    "owner2": "",
    "current_taxes": 17978.63,
    "new_taxes_no_override": 18755.31,
    "override_total_1": 19287.47,
    "override_increase_1": 532.17
  },
  {
    "#": "64 Sewall Ave, Unit 202 G28-29 (160-01-05)",
    "$": 2147400,
    "address": "64 Sewall Ave, Unit 202 G28-29",
    "parcel_id": "160-01-05",
    "owner1": "EMMANOUILIDIS, EFTHIMIOS & SUSAN",
    "owner2": "",
    "current_taxes": 18354.44,
    "new_taxes_no_override": 19147.35,
    "override_total_1": 19690.64,
    "override_increase_1": 543.29
  },
  {
    "#": "64 Sewall Ave, Unit 301 G24-25 (160-01-06)",
    "$": 2105400,
    "address": "64 Sewall Ave, Unit 301 G24-25",
    "parcel_id": "160-01-06",
    "owner1": "GITMAN  TR, GREGORY M",
    "owner2": "",
    "current_taxes": 21559.3,
    "new_taxes_no_override": 22490.66,
    "override_total_1": 23128.82,
    "override_increase_1": 638.16
  },
  {
    "#": "64 Sewall Ave, Unit 302&G26G32 (160-01-07)",
    "$": 2146800,
    "address": "64 Sewall Ave, Unit 302&G26G32",
    "parcel_id": "160-01-07",
    "owner1": "SPIVAK TRS, HOWARD R",
    "owner2": "SCHWARTZ, JANET B",
    "current_taxes": 18348.3,
    "new_taxes_no_override": 19140.95,
    "override_total_1": 19684.06,
    "override_increase_1": 543.11
  },
  {
    "#": "64 Sewall Ave, Unit Pha G17-20 (160-01-08)",
    "$": 1951200,
    "address": "64 Sewall Ave, Unit Pha G17-20",
    "parcel_id": "160-01-08",
    "owner1": "DVORKIN, MICHAEL E",
    "owner2": "JACOBSON, STEPHANIE G",
    "current_taxes": 16345.35,
    "new_taxes_no_override": 17051.47,
    "override_total_1": 17535.29,
    "override_increase_1": 483.82
  },
  {
    "#": "64 Sewall Ave, Unit Phb G18-19 (160-01-09)",
    "$": 1979600,
    "address": "64 Sewall Ave, Unit Phb G18-19",
    "parcel_id": "160-01-09",
    "owner1": "FRIDLAND TRS, IDA L & ANATOLY V",
    "owner2": "",
    "current_taxes": 16636.17,
    "new_taxes_no_override": 17354.85,
    "override_total_1": 17847.28,
    "override_increase_1": 492.43
  },
  {
    "#": "70 Sewall Ave, Unit 1 & G9 (160-11-01)",
    "$": 2181800,
    "address": "70 Sewall Ave, Unit 1 & G9",
    "parcel_id": "160-11-01",
    "owner1": "PROBOLUS, JOHN X & SUSAN G",
    "owner2": "",
    "current_taxes": 22341.63,
    "new_taxes_no_override": 23306.79,
    "override_total_1": 23968.1,
    "override_increase_1": 661.31
  },
  {
    "#": "70 Sewall Ave, Unit 2 & G6 (160-11-02)",
    "$": 1582600,
    "address": "70 Sewall Ave, Unit 2 & G6",
    "parcel_id": "160-11-02",
    "owner1": "SHIH TRS, CHEN-CHEN",
    "owner2": "",
    "current_taxes": 12570.89,
    "new_taxes_no_override": 13113.95,
    "override_total_1": 13486.05,
    "override_increase_1": 372.1
  },
  {
    "#": "70 Sewall Ave, Unit 3 & G3 (160-11-03)",
    "$": 1685500,
    "address": "70 Sewall Ave, Unit 3 & G3",
    "parcel_id": "160-11-03",
    "owner1": "MORRISON TRS, PEGGY ANN R",
    "owner2": "KOSTO, SETH",
    "current_taxes": 13624.59,
    "new_taxes_no_override": 14213.17,
    "override_total_1": 14616.46,
    "override_increase_1": 403.29
  },
  {
    "#": "70 Sewall Ave, Unit 4 & G5 (160-11-04)",
    "$": 2090900,
    "address": "70 Sewall Ave, Unit 4 & G5",
    "parcel_id": "160-11-04",
    "owner1": "GOLDSTEIN, ROGER & CINDY",
    "owner2": "",
    "current_taxes": 17775.88,
    "new_taxes_no_override": 18543.8,
    "override_total_1": 19069.96,
    "override_increase_1": 526.17
  },
  {
    "#": "70 Sewall Ave, Unit 5 & G1 G2 (160-11-05)",
    "$": 2550100,
    "address": "70 Sewall Ave, Unit 5 & G1 G2",
    "parcel_id": "160-11-05",
    "owner1": "WEXLER TR, BARBARA GRAY",
    "owner2": "",
    "current_taxes": 26113.02,
    "new_taxes_no_override": 27241.1,
    "override_total_1": 28014.05,
    "override_increase_1": 772.95
  },
  {
    "#": "70 Sewall Ave, Unit 6 & G7 (160-11-06)",
    "$": 2049900,
    "address": "70 Sewall Ave, Unit 6 & G7",
    "parcel_id": "160-11-06",
    "owner1": "ELTON TR, PETER NICHOLAS",
    "owner2": "",
    "current_taxes": 17356.04,
    "new_taxes_no_override": 18105.82,
    "override_total_1": 18619.56,
    "override_increase_1": 513.74
  },
  {
    "#": "70 Sewall Ave, Unit 7 & G4 G10 (160-11-07)",
    "$": 2439800,
    "address": "70 Sewall Ave, Unit 7 & G4 G10",
    "parcel_id": "160-11-07",
    "owner1": "SUDEROW, ELLEN BETH L",
    "owner2": "",
    "current_taxes": 21348.62,
    "new_taxes_no_override": 22270.88,
    "override_total_1": 22902.8,
    "override_increase_1": 631.92
  },
  {
    "#": "76 Sewall Ave, Unit A&G36-37 (160-07-47)",
    "$": 1444000,
    "address": "76 Sewall Ave, Unit A&G36-37",
    "parcel_id": "160-07-47",
    "owner1": "ALMALIAH, JOAN",
    "owner2": "",
    "current_taxes": 11151.63,
    "new_taxes_no_override": 11633.38,
    "override_total_1": 11963.47,
    "override_increase_1": 330.09
  },
  {
    "#": "76 Sewall Ave, Unit B&G38-39 (160-07-48)",
    "$": 1387900,
    "address": "76 Sewall Ave, Unit B&G38-39",
    "parcel_id": "160-07-48",
    "owner1": "CHOW, SELINA J",
    "owner2": "",
    "current_taxes": 14212.1,
    "new_taxes_no_override": 14826.06,
    "override_total_1": 15246.74,
    "override_increase_1": 420.68
  },
  {
    "#": "76 Sewall Ave, Unit C & G40-41-22-28 (160-07-49)",
    "$": 1694200,
    "address": "76 Sewall Ave, Unit C & G40-41-22-28",
    "parcel_id": "160-07-49",
    "owner1": "ZHANDOSSOVA, LYUBOV",
    "owner2": "",
    "current_taxes": 17348.61,
    "new_taxes_no_override": 18098.07,
    "override_total_1": 18611.59,
    "override_increase_1": 513.52
  },
  {
    "#": "97 Sewall Ave, Unit 1 & P9&10 (125-02-01)",
    "$": 1675800,
    "address": "97 Sewall Ave, Unit 1 & P9&10",
    "parcel_id": "125-02-01",
    "owner1": "BROWN, DAVID J",
    "owner2": "",
    "current_taxes": 13525.26,
    "new_taxes_no_override": 14109.55,
    "override_total_1": 14509.9,
    "override_increase_1": 400.35
  },
  {
    "#": "97 Sewall Ave, Unit 2 & P-6 (125-02-02)",
    "$": 1304800,
    "address": "97 Sewall Ave, Unit 2 & P-6",
    "parcel_id": "125-02-02",
    "owner1": "TONKIN TR, ELISSA",
    "owner2": "",
    "current_taxes": 13361.15,
    "new_taxes_no_override": 13938.35,
    "override_total_1": 14333.84,
    "override_increase_1": 395.49
  },
  {
    "#": "97 Sewall Ave, Unit 3 & P5 (125-02-03)",
    "$": 1044700,
    "address": "97 Sewall Ave, Unit 3 & P5",
    "parcel_id": "125-02-03",
    "owner1": "MARKOWSKI, STEPHEN & MELANIE & ALEC C & STEPHEN P",
    "owner2": "",
    "current_taxes": 7062.79,
    "new_taxes_no_override": 7367.9,
    "override_total_1": 7576.96,
    "override_increase_1": 209.06
  },
  {
    "#": "97 Sewall Ave, Unit 4 (125-02-04)",
    "$": 595700,
    "address": "97 Sewall Ave, Unit 4",
    "parcel_id": "125-02-04",
    "owner1": "MCMAHON, RUTH E",
    "owner2": "",
    "current_taxes": 6099.97,
    "new_taxes_no_override": 6363.49,
    "override_total_1": 6544.05,
    "override_increase_1": 180.56
  },
  {
    "#": "97 Sewall Ave, Unit 5 & P8 (125-02-05)",
    "$": 546900,
    "address": "97 Sewall Ave, Unit 5 & P8",
    "parcel_id": "125-02-05",
    "owner1": "BRITO, ALEXANDRA C",
    "owner2": "",
    "current_taxes": 1965.32,
    "new_taxes_no_override": 2050.22,
    "override_total_1": 2108.4,
    "override_increase_1": 58.17
  },
  {
    "#": "97 Sewall Ave, Unit 6 & P3-4 (125-02-06)",
    "$": 1563300,
    "address": "97 Sewall Ave, Unit 6 & P3-4",
    "parcel_id": "125-02-06",
    "owner1": "BORNS-WEIL, ALEXANDRA & STEPHANIE",
    "owner2": "",
    "current_taxes": 12373.26,
    "new_taxes_no_override": 12907.78,
    "override_total_1": 13274.03,
    "override_increase_1": 366.25
  },
  {
    "#": "98 Sewall Ave, Unit 1 (124-30-01)",
    "$": 671800,
    "address": "98 Sewall Ave, Unit 1",
    "parcel_id": "124-30-01",
    "owner1": "LG GST LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 6879.23,
    "new_taxes_no_override": 7176.41,
    "override_total_1": 7380.04,
    "override_increase_1": 203.63
  },
  {
    "#": "98 Sewall Ave, Unit 2 & P19 (124-30-02)",
    "$": 624900,
    "address": "98 Sewall Ave, Unit 2 & P19",
    "parcel_id": "124-30-02",
    "owner1": "UNG TR, SHIAW PO LEE LUCIA",
    "owner2": "",
    "current_taxes": 6398.98,
    "new_taxes_no_override": 6675.42,
    "override_total_1": 6864.83,
    "override_increase_1": 189.41
  },
  {
    "#": "98 Sewall Ave, Unit 3 (124-30-03)",
    "$": 637400,
    "address": "98 Sewall Ave, Unit 3",
    "parcel_id": "124-30-03",
    "owner1": "INBAR, NOAH & GALIT",
    "owner2": "",
    "current_taxes": 6526.98,
    "new_taxes_no_override": 6808.95,
    "override_total_1": 7002.14,
    "override_increase_1": 193.2
  },
  {
    "#": "98 Sewall Ave, Unit 4 (124-30-04)",
    "$": 652200,
    "address": "98 Sewall Ave, Unit 4",
    "parcel_id": "124-30-04",
    "owner1": "JENNINGS, MARY-ELAINE",
    "owner2": "",
    "current_taxes": 3043.59,
    "new_taxes_no_override": 3175.07,
    "override_total_1": 3265.16,
    "override_increase_1": 90.09
  },
  {
    "#": "98 Sewall Ave, Unit 5 & P13 (124-30-05)",
    "$": 671400,
    "address": "98 Sewall Ave, Unit 5 & P13",
    "parcel_id": "124-30-05",
    "owner1": "VINOGRADOVA, SVETLANA",
    "owner2": "",
    "current_taxes": 3240.2,
    "new_taxes_no_override": 3380.18,
    "override_total_1": 3476.09,
    "override_increase_1": 95.91
  },
  {
    "#": "98 Sewall Ave, Unit 6 (124-30-06)",
    "$": 653000,
    "address": "98 Sewall Ave, Unit 6",
    "parcel_id": "124-30-06",
    "owner1": "HA, CHENG",
    "owner2": "YE, HUI",
    "current_taxes": 6686.72,
    "new_taxes_no_override": 6975.59,
    "override_total_1": 7173.51,
    "override_increase_1": 197.93
  },
  {
    "#": "98 Sewall Ave, Unit A (124-30-63)",
    "$": 477200,
    "address": "98 Sewall Ave, Unit A",
    "parcel_id": "124-30-63",
    "owner1": "MAHMOOD, SYED KASHIF & SADIA",
    "owner2": "",
    "current_taxes": 4886.53,
    "new_taxes_no_override": 5097.63,
    "override_total_1": 5242.27,
    "override_increase_1": 144.64
  },
  {
    "#": "100 Sewall Ave, Unit 1 (124-30-08)",
    "$": 775000,
    "address": "100 Sewall Ave, Unit 1",
    "parcel_id": "124-30-08",
    "owner1": "LG GST LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 7936.0,
    "new_taxes_no_override": 8278.84,
    "override_total_1": 8513.74,
    "override_increase_1": 234.91
  },
  {
    "#": "100 Sewall Ave, Unit 2 (124-30-09)",
    "$": 780100,
    "address": "100 Sewall Ave, Unit 2",
    "parcel_id": "124-30-09",
    "owner1": "LG GST LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 7988.22,
    "new_taxes_no_override": 8333.31,
    "override_total_1": 8569.76,
    "override_increase_1": 236.45
  },
  {
    "#": "100 Sewall Ave, Unit 3 (124-30-10)",
    "$": 790300,
    "address": "100 Sewall Ave, Unit 3",
    "parcel_id": "124-30-10",
    "owner1": "LYETTEFI, DEAN O & EMILY J",
    "owner2": "",
    "current_taxes": 8092.67,
    "new_taxes_no_override": 8442.27,
    "override_total_1": 8681.82,
    "override_increase_1": 239.54
  },
  {
    "#": "100 Sewall Ave, Unit 4 (124-30-11)",
    "$": 780100,
    "address": "100 Sewall Ave, Unit 4",
    "parcel_id": "124-30-11",
    "owner1": "LG GST LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 7988.22,
    "new_taxes_no_override": 8333.31,
    "override_total_1": 8569.76,
    "override_increase_1": 236.45
  },
  {
    "#": "100 Sewall Ave, Unit 5 (124-30-12)",
    "$": 775000,
    "address": "100 Sewall Ave, Unit 5",
    "parcel_id": "124-30-12",
    "owner1": "ARBER, GARY M",
    "owner2": "",
    "current_taxes": 7936.0,
    "new_taxes_no_override": 8278.84,
    "override_total_1": 8513.74,
    "override_increase_1": 234.91
  },
  {
    "#": "100 Sewall Ave, Unit 6 (124-30-13)",
    "$": 754600,
    "address": "100 Sewall Ave, Unit 6",
    "parcel_id": "124-30-13",
    "owner1": "COHEN-KOPOLOVIC, LILACH",
    "owner2": "COHEN, ESTHER",
    "current_taxes": 7727.1,
    "new_taxes_no_override": 8060.91,
    "override_total_1": 8289.63,
    "override_increase_1": 228.72
  },
  {
    "#": "100 Sewall Ave, Unit A (124-30-07)",
    "$": 634900,
    "address": "100 Sewall Ave, Unit A",
    "parcel_id": "124-30-07",
    "owner1": "LG GST LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 6501.38,
    "new_taxes_no_override": 6782.24,
    "override_total_1": 6974.68,
    "override_increase_1": 192.44
  },
  {
    "#": "102 Sewall Ave, Unit 1 P29 (124-30-14)",
    "$": 762700,
    "address": "102 Sewall Ave, Unit 1 P29",
    "parcel_id": "124-30-14",
    "owner1": "MYERS, SUSAN M",
    "owner2": "",
    "current_taxes": 4175.11,
    "new_taxes_no_override": 4355.47,
    "override_total_1": 4479.06,
    "override_increase_1": 123.58
  },
  {
    "#": "102 Sewall Ave, Unit 2 & P42 (124-30-15)",
    "$": 696300,
    "address": "102 Sewall Ave, Unit 2 & P42",
    "parcel_id": "124-30-15",
    "owner1": "ZHOU, PENG",
    "owner2": "JIN, QI",
    "current_taxes": 7130.11,
    "new_taxes_no_override": 7438.13,
    "override_total_1": 7649.18,
    "override_increase_1": 211.05
  },
  {
    "#": "102 Sewall Ave, Unit 3 (124-30-16)",
    "$": 762600,
    "address": "102 Sewall Ave, Unit 3",
    "parcel_id": "124-30-16",
    "owner1": "KHODADOUST, MARJAN Z",
    "owner2": "",
    "current_taxes": 7809.02,
    "new_taxes_no_override": 8146.37,
    "override_total_1": 8377.52,
    "override_increase_1": 231.15
  },
  {
    "#": "102 Sewall Ave, Unit 4 & P22 (124-30-17)",
    "$": 684400,
    "address": "102 Sewall Ave, Unit 4 & P22",
    "parcel_id": "124-30-17",
    "owner1": "INBAR, NOAH & GALIT",
    "owner2": "",
    "current_taxes": 7008.26,
    "new_taxes_no_override": 7311.02,
    "override_total_1": 7518.46,
    "override_increase_1": 207.44
  },
  {
    "#": "102 Sewall Ave, Unit 5 & P23 (124-30-18)",
    "$": 762600,
    "address": "102 Sewall Ave, Unit 5 & P23",
    "parcel_id": "124-30-18",
    "owner1": "LOPEZ-PINTADO, SARA",
    "owner2": "",
    "current_taxes": 7809.02,
    "new_taxes_no_override": 8146.37,
    "override_total_1": 8377.52,
    "override_increase_1": 231.15
  },
  {
    "#": "102 Sewall Ave, Unit 6 (124-30-19)",
    "$": 699700,
    "address": "102 Sewall Ave, Unit 6",
    "parcel_id": "124-30-19",
    "owner1": "SINGH, SAURABH R",
    "owner2": "MOURIER, ALIX JEANNE",
    "current_taxes": 7164.93,
    "new_taxes_no_override": 7474.45,
    "override_total_1": 7686.54,
    "override_increase_1": 212.08
  },
  {
    "#": "103 Sewall Ave, Unit 1 Pk 1 1A (125-03-07)",
    "$": 923800,
    "address": "103 Sewall Ave, Unit 1 Pk 1 1A",
    "parcel_id": "125-03-07",
    "owner1": "BOJANOWSKI TR, JULIA A",
    "owner2": "",
    "current_taxes": 5824.78,
    "new_taxes_no_override": 6076.41,
    "override_total_1": 6248.82,
    "override_increase_1": 172.41
  },
  {
    "#": "103 Sewall Ave, Unit 2 & P2 (125-03-01)",
    "$": 699600,
    "address": "103 Sewall Ave, Unit 2 & P2",
    "parcel_id": "125-03-01",
    "owner1": "SACCO, MICHAEL A",
    "owner2": "",
    "current_taxes": 3528.97,
    "new_taxes_no_override": 3681.42,
    "override_total_1": 3785.88,
    "override_increase_1": 104.46
  },
  {
    "#": "103 Sewall Ave, Unit 3 & P3 (125-03-02)",
    "$": 971800,
    "address": "103 Sewall Ave, Unit 3 & P3",
    "parcel_id": "125-03-02",
    "owner1": "WELTY, FRANCINE",
    "owner2": "",
    "current_taxes": 6316.3,
    "new_taxes_no_override": 6589.16,
    "override_total_1": 6776.13,
    "override_increase_1": 186.96
  },
  {
    "#": "103 Sewall Ave, Unit 4 & P4 (125-03-03)",
    "$": 909500,
    "address": "103 Sewall Ave, Unit 4 & P4",
    "parcel_id": "125-03-03",
    "owner1": "MUELLER TRS, CRAIG T & CHAILAIWAN C",
    "owner2": "",
    "current_taxes": 9313.28,
    "new_taxes_no_override": 9715.61,
    "override_total_1": 9991.29,
    "override_increase_1": 275.67
  },
  {
    "#": "103 Sewall Ave, Unit 5 & P5 (125-03-04)",
    "$": 760600,
    "address": "103 Sewall Ave, Unit 5 & P5",
    "parcel_id": "125-03-04",
    "owner1": "103.5 SEWALL LLC",
    "owner2": "",
    "current_taxes": 7788.54,
    "new_taxes_no_override": 8125.0,
    "override_total_1": 8355.55,
    "override_increase_1": 230.54
  },
  {
    "#": "103 Sewall Ave, Unit 6 & P6 (125-03-05)",
    "$": 1007900,
    "address": "103 Sewall Ave, Unit 6 & P6",
    "parcel_id": "125-03-05",
    "owner1": "ELFAKHRI, GEORGES",
    "owner2": "",
    "current_taxes": 10320.9,
    "new_taxes_no_override": 10766.76,
    "override_total_1": 11072.26,
    "override_increase_1": 305.5
  },
  {
    "#": "103 Sewall Ave, Unit 7 & P7 (125-03-06)",
    "$": 942300,
    "address": "103 Sewall Ave, Unit 7 & P7",
    "parcel_id": "125-03-06",
    "owner1": "PATTEE, AMY S",
    "owner2": "FLORIN, BENJAMIN",
    "current_taxes": 9649.15,
    "new_taxes_no_override": 10065.99,
    "override_total_1": 10351.61,
    "override_increase_1": 285.61
  },
  {
    "#": "104 Sewall Ave, Unit 1 & P32 (124-30-20)",
    "$": 788100,
    "address": "104 Sewall Ave, Unit 1 & P32",
    "parcel_id": "124-30-20",
    "owner1": "DAI, HUI",
    "owner2": "",
    "current_taxes": 8070.14,
    "new_taxes_no_override": 8418.77,
    "override_total_1": 8657.65,
    "override_increase_1": 238.88
  },
  {
    "#": "104 Sewall Ave, Unit 2 (124-30-21)",
    "$": 647000,
    "address": "104 Sewall Ave, Unit 2",
    "parcel_id": "124-30-21",
    "owner1": "TAW, FREDERICK",
    "owner2": "",
    "current_taxes": 6625.28,
    "new_taxes_no_override": 6911.49,
    "override_total_1": 7107.6,
    "override_increase_1": 196.11
  },
  {
    "#": "104 Sewall Ave, Unit 3 & P7 (124-30-22)",
    "$": 777900,
    "address": "104 Sewall Ave, Unit 3 & P7",
    "parcel_id": "124-30-22",
    "owner1": "SIMONYAN, KAREN",
    "owner2": "",
    "current_taxes": 4330.76,
    "new_taxes_no_override": 4517.85,
    "override_total_1": 4646.04,
    "override_increase_1": 128.19
  },
  {
    "#": "104 Sewall Ave, Unit 4 (124-30-23)",
    "$": 684400,
    "address": "104 Sewall Ave, Unit 4",
    "parcel_id": "124-30-23",
    "owner1": "HUANG, HUIYU",
    "owner2": "",
    "current_taxes": 3373.32,
    "new_taxes_no_override": 3519.05,
    "override_total_1": 3618.9,
    "override_increase_1": 99.85
  },
  {
    "#": "104 Sewall Ave, Unit 5 & P21 (124-30-24)",
    "$": 762600,
    "address": "104 Sewall Ave, Unit 5 & P21",
    "parcel_id": "124-30-24",
    "owner1": "HEIDEBRECHT, RICHARD JR",
    "owner2": "PANCOST-HEIDEBRECHT, MARGARET",
    "current_taxes": 7809.02,
    "new_taxes_no_override": 8146.37,
    "override_total_1": 8377.52,
    "override_increase_1": 231.15
  },
  {
    "#": "104 Sewall Ave, Unit 6 (124-30-25)",
    "$": 699700,
    "address": "104 Sewall Ave, Unit 6",
    "parcel_id": "124-30-25",
    "owner1": "ZWEIG TRS, MATTHEW",
    "owner2": "ELLIOTT, SHANNON",
    "current_taxes": 7164.93,
    "new_taxes_no_override": 7474.45,
    "override_total_1": 7686.54,
    "override_increase_1": 212.08
  },
  {
    "#": "106 Sewall Ave, Unit 1 (124-30-26)",
    "$": 808600,
    "address": "106 Sewall Ave, Unit 1",
    "parcel_id": "124-30-26",
    "owner1": "KHODADOUST, MEHRAN",
    "owner2": "",
    "current_taxes": 8280.06,
    "new_taxes_no_override": 8637.76,
    "override_total_1": 8882.85,
    "override_increase_1": 245.09
  },
  {
    "#": "106 Sewall Ave, Unit 2 (124-30-27)",
    "$": 735600,
    "address": "106 Sewall Ave, Unit 2",
    "parcel_id": "124-30-27",
    "owner1": "ZHANG, FENG",
    "owner2": "",
    "current_taxes": 3897.61,
    "new_taxes_no_override": 4065.99,
    "override_total_1": 4181.36,
    "override_increase_1": 115.37
  },
  {
    "#": "106 Sewall Ave, Unit 3 (124-30-28)",
    "$": 815700,
    "address": "106 Sewall Ave, Unit 3",
    "parcel_id": "124-30-28",
    "owner1": "LU, XING QI",
    "owner2": "CHING, CHI-CHENG",
    "current_taxes": 4717.83,
    "new_taxes_no_override": 4921.64,
    "override_total_1": 5061.29,
    "override_increase_1": 139.65
  },
  {
    "#": "106 Sewall Ave, Unit 4 (124-30-29)",
    "$": 747500,
    "address": "106 Sewall Ave, Unit 4",
    "parcel_id": "124-30-29",
    "owner1": "CHACKAL, ROY & MARCELA",
    "owner2": "",
    "current_taxes": 7654.4,
    "new_taxes_no_override": 7985.07,
    "override_total_1": 8211.64,
    "override_increase_1": 226.57
  },
  {
    "#": "106 Sewall Ave, Unit 5 (124-30-30)",
    "$": 939900,
    "address": "106 Sewall Ave, Unit 5",
    "parcel_id": "124-30-30",
    "owner1": "YAN, JENNY",
    "owner2": "",
    "current_taxes": 5989.64,
    "new_taxes_no_override": 6248.39,
    "override_total_1": 6425.69,
    "override_increase_1": 177.29
  },
  {
    "#": "106 Sewall Ave, Unit 6 (124-30-31)",
    "$": 715200,
    "address": "106 Sewall Ave, Unit 6",
    "parcel_id": "124-30-31",
    "owner1": "KHODADOUST, MEHRAN M",
    "owner2": "",
    "current_taxes": 7323.65,
    "new_taxes_no_override": 7640.03,
    "override_total_1": 7856.81,
    "override_increase_1": 216.78
  },
  {
    "#": "108 Sewall Ave, Unit 1 (124-30-32)",
    "$": 761100,
    "address": "108 Sewall Ave, Unit 1",
    "parcel_id": "124-30-32",
    "owner1": "LG GST LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 7793.66,
    "new_taxes_no_override": 8130.35,
    "override_total_1": 8361.04,
    "override_increase_1": 230.69
  },
  {
    "#": "108 Sewall Ave, Unit 2 (124-30-33)",
    "$": 834100,
    "address": "108 Sewall Ave, Unit 2",
    "parcel_id": "124-30-33",
    "owner1": "LG GST LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 8541.18,
    "new_taxes_no_override": 8910.16,
    "override_total_1": 9162.98,
    "override_increase_1": 252.82
  },
  {
    "#": "108 Sewall Ave, Unit 3 (124-30-34)",
    "$": 761100,
    "address": "108 Sewall Ave, Unit 3",
    "parcel_id": "124-30-34",
    "owner1": "LG GST LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 7793.66,
    "new_taxes_no_override": 8130.35,
    "override_total_1": 8361.04,
    "override_increase_1": 230.69
  },
  {
    "#": "108 Sewall Ave, Unit 4 (124-30-35)",
    "$": 917300,
    "address": "108 Sewall Ave, Unit 4",
    "parcel_id": "124-30-35",
    "owner1": "STEIN, DAVID S & ILENNA J",
    "owner2": "",
    "current_taxes": 9393.15,
    "new_taxes_no_override": 9798.93,
    "override_total_1": 10076.97,
    "override_increase_1": 278.04
  },
  {
    "#": "108 Sewall Ave, Unit 5 (124-30-36)",
    "$": 745800,
    "address": "108 Sewall Ave, Unit 5",
    "parcel_id": "124-30-36",
    "owner1": "WYNN, JANET",
    "owner2": "",
    "current_taxes": 4002.06,
    "new_taxes_no_override": 4174.95,
    "override_total_1": 4293.41,
    "override_increase_1": 118.46
  },
  {
    "#": "108 Sewall Ave, Unit 6 (124-30-37)",
    "$": 915000,
    "address": "108 Sewall Ave, Unit 6",
    "parcel_id": "124-30-37",
    "owner1": "GRAURE, VENNESA J",
    "owner2": "",
    "current_taxes": 5734.67,
    "new_taxes_no_override": 5982.41,
    "override_total_1": 6152.15,
    "override_increase_1": 169.75
  },
  {
    "#": "109 Sewall Ave, Unit 101 & P10 (125-05-09)",
    "$": 255800,
    "address": "109 Sewall Ave, Unit 101 & P10",
    "parcel_id": "125-05-09",
    "owner1": "SZETO, PIK KI",
    "owner2": "WONG, KIN SANG",
    "current_taxes": 261.94,
    "new_taxes_no_override": 273.26,
    "override_total_1": 281.01,
    "override_increase_1": 7.75
  },
  {
    "#": "109 Sewall Ave, Unit 102 & G12 (125-05-10)",
    "$": 288000,
    "address": "109 Sewall Ave, Unit 102 & G12",
    "parcel_id": "125-05-10",
    "owner1": "MENDEZ, BELMA M",
    "owner2": "",
    "current_taxes": 294.91,
    "new_taxes_no_override": 307.65,
    "override_total_1": 316.38,
    "override_increase_1": 8.73
  },
  {
    "#": "109 Sewall Ave, Unit 103&Pg-8-9 (125-05-11)",
    "$": 2406000,
    "address": "109 Sewall Ave, Unit 103&Pg-8-9",
    "parcel_id": "125-05-11",
    "owner1": "LEVY TRS, BRENDA G",
    "owner2": "",
    "current_taxes": 24637.44,
    "new_taxes_no_override": 25701.78,
    "override_total_1": 26431.05,
    "override_increase_1": 729.27
  },
  {
    "#": "109 Sewall Ave, Unit 201 G5 G6 (125-05-12)",
    "$": 2279800,
    "address": "109 Sewall Ave, Unit 201 G5 G6",
    "parcel_id": "125-05-12",
    "owner1": "NEW CHARLESTON LLC",
    "owner2": "",
    "current_taxes": 23345.15,
    "new_taxes_no_override": 24353.66,
    "override_total_1": 25044.68,
    "override_increase_1": 691.02
  },
  {
    "#": "109 Sewall Ave, Unit 202 G10G11 (125-05-13)",
    "$": 2331200,
    "address": "109 Sewall Ave, Unit 202 G10G11",
    "parcel_id": "125-05-13",
    "owner1": "RITTLING, WILLIAM J & SUSAN R",
    "owner2": "",
    "current_taxes": 20236.55,
    "new_taxes_no_override": 21110.77,
    "override_total_1": 21709.77,
    "override_increase_1": 599.0
  },
  {
    "#": "109 Sewall Ave, Unit 301 G8 G9 (125-05-14)",
    "$": 2289700,
    "address": "109 Sewall Ave, Unit 301 G8 G9",
    "parcel_id": "125-05-14",
    "owner1": "HONG ET AL, SUSAN SHU CHUAN",
    "owner2": "C/O HELEN DANESH",
    "current_taxes": 23446.53,
    "new_taxes_no_override": 24459.42,
    "override_total_1": 25153.44,
    "override_increase_1": 694.02
  },
  {
    "#": "109 Sewall Ave, Unit 302 G1 2 3 (125-05-15)",
    "$": 2400400,
    "address": "109 Sewall Ave, Unit 302 G1 2 3",
    "parcel_id": "125-05-15",
    "owner1": "ARONSON, MARJORY S",
    "owner2": "PREBLUDA, JEFFREY L",
    "current_taxes": 20945.16,
    "new_taxes_no_override": 21849.99,
    "override_total_1": 22469.97,
    "override_increase_1": 619.98
  },
  {
    "#": "109 Sewall Ave, Unit 401 G14 G15 (125-05-16)",
    "$": 3539500,
    "address": "109 Sewall Ave, Unit 401 G14 G15",
    "parcel_id": "125-05-16",
    "owner1": "DANESH, ANDRE & MARILYN",
    "owner2": "",
    "current_taxes": 32609.55,
    "new_taxes_no_override": 34018.28,
    "override_total_1": 34983.53,
    "override_increase_1": 965.24
  },
  {
    "#": "109 Sewall Ave, Unit G7 (125-05-17)",
    "$": 85400,
    "address": "109 Sewall Ave, Unit G7",
    "parcel_id": "125-05-17",
    "owner1": "ERICKSON, BRIAN & ALISON",
    "owner2": "",
    "current_taxes": 874.5,
    "new_taxes_no_override": 912.28,
    "override_total_1": 938.16,
    "override_increase_1": 25.89
  },
  {
    "#": "110 Sewall Ave, Unit 1 (124-30-38)",
    "$": 647000,
    "address": "110 Sewall Ave, Unit 1",
    "parcel_id": "124-30-38",
    "owner1": "ZHAO TRS, SHAWN X",
    "owner2": "CHENG, JIE",
    "current_taxes": 6625.28,
    "new_taxes_no_override": 6911.49,
    "override_total_1": 7107.6,
    "override_increase_1": 196.11
  },
  {
    "#": "110 Sewall Ave, Unit 2 (124-30-39)",
    "$": 788100,
    "address": "110 Sewall Ave, Unit 2",
    "parcel_id": "124-30-39",
    "owner1": "LG GST LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 8070.14,
    "new_taxes_no_override": 8418.77,
    "override_total_1": 8657.65,
    "override_increase_1": 238.88
  },
  {
    "#": "110 Sewall Ave, Unit 3 (124-30-40)",
    "$": 709900,
    "address": "110 Sewall Ave, Unit 3",
    "parcel_id": "124-30-40",
    "owner1": "LG GST LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 7269.38,
    "new_taxes_no_override": 7583.42,
    "override_total_1": 7798.59,
    "override_increase_1": 215.17
  },
  {
    "#": "110 Sewall Ave, Unit 4 & P45 (124-30-41)",
    "$": 768400,
    "address": "110 Sewall Ave, Unit 4 & P45",
    "parcel_id": "124-30-41",
    "owner1": "FANG, HUAYU",
    "owner2": "",
    "current_taxes": 7868.42,
    "new_taxes_no_override": 8208.34,
    "override_total_1": 8441.24,
    "override_increase_1": 232.91
  },
  {
    "#": "110 Sewall Ave, Unit 5  & Pk Sp (124-30-42)",
    "$": 684400,
    "address": "110 Sewall Ave, Unit 5  & Pk Sp",
    "parcel_id": "124-30-42",
    "owner1": "SEWALL AVE LLC",
    "owner2": "",
    "current_taxes": 7008.26,
    "new_taxes_no_override": 7311.02,
    "override_total_1": 7518.46,
    "override_increase_1": 207.44
  },
  {
    "#": "110 Sewall Ave, Unit 6 (124-30-43)",
    "$": 777900,
    "address": "110 Sewall Ave, Unit 6",
    "parcel_id": "124-30-43",
    "owner1": "RAVELSON, LARRY C",
    "owner2": "",
    "current_taxes": 4330.76,
    "new_taxes_no_override": 4517.85,
    "override_total_1": 4646.04,
    "override_increase_1": 128.19
  },
  {
    "#": "112 Sewall Ave, Unit 1 & P36 (124-30-44)",
    "$": 684400,
    "address": "112 Sewall Ave, Unit 1 & P36",
    "parcel_id": "124-30-44",
    "owner1": "BUDENKO TRS, MICHAEL N & GALINA B",
    "owner2": "",
    "current_taxes": 7008.26,
    "new_taxes_no_override": 7311.02,
    "override_total_1": 7518.46,
    "override_increase_1": 207.44
  },
  {
    "#": "112 Sewall Ave, Unit 2 (124-30-45)",
    "$": 762600,
    "address": "112 Sewall Ave, Unit 2",
    "parcel_id": "124-30-45",
    "owner1": "LG GST LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 7809.02,
    "new_taxes_no_override": 8146.37,
    "override_total_1": 8377.52,
    "override_increase_1": 231.15
  },
  {
    "#": "112 Sewall Ave, Unit 3 (124-30-46)",
    "$": 704400,
    "address": "112 Sewall Ave, Unit 3",
    "parcel_id": "124-30-46",
    "owner1": "INBAR, NOAH & GALIT",
    "owner2": "",
    "current_taxes": 7213.06,
    "new_taxes_no_override": 7524.66,
    "override_total_1": 7738.17,
    "override_increase_1": 213.51
  },
  {
    "#": "112 Sewall Ave, Unit 4 & P8 (124-30-47)",
    "$": 769700,
    "address": "112 Sewall Ave, Unit 4 & P8",
    "parcel_id": "124-30-47",
    "owner1": "JAKUBOWSKI, ANIELA",
    "owner2": "",
    "current_taxes": 4246.79,
    "new_taxes_no_override": 4430.25,
    "override_total_1": 4555.96,
    "override_increase_1": 125.7
  },
  {
    "#": "112 Sewall Ave, Unit 5 & P16A (124-30-48)",
    "$": 689100,
    "address": "112 Sewall Ave, Unit 5 & P16A",
    "parcel_id": "124-30-48",
    "owner1": "STELLING, TRS, ALLISON W & VALERIE C",
    "owner2": "",
    "current_taxes": 3421.45,
    "new_taxes_no_override": 3569.26,
    "override_total_1": 3670.53,
    "override_increase_1": 101.27
  },
  {
    "#": "112 Sewall Ave, Unit 6 & P39 (124-30-49)",
    "$": 769800,
    "address": "112 Sewall Ave, Unit 6 & P39",
    "parcel_id": "124-30-49",
    "owner1": "HARGADON, KATHERINE",
    "owner2": "",
    "current_taxes": 4247.82,
    "new_taxes_no_override": 4431.33,
    "override_total_1": 4557.06,
    "override_increase_1": 125.74
  },
  {
    "#": "114 Sewall Ave, Unit 1 &P15A&B (124-30-51)",
    "$": 866700,
    "address": "114 Sewall Ave, Unit 1 &P15A&B",
    "parcel_id": "124-30-51",
    "owner1": "MADRY, ALEKSANDER",
    "owner2": "",
    "current_taxes": 5240.07,
    "new_taxes_no_override": 5466.44,
    "override_total_1": 5621.55,
    "override_increase_1": 155.11
  },
  {
    "#": "114 Sewall Ave, Unit 2 & P37 (124-30-52)",
    "$": 775000,
    "address": "114 Sewall Ave, Unit 2 & P37",
    "parcel_id": "124-30-52",
    "owner1": "ANDERSON, CHARLES",
    "owner2": "",
    "current_taxes": 4301.07,
    "new_taxes_no_override": 4486.88,
    "override_total_1": 4614.19,
    "override_increase_1": 127.31
  },
  {
    "#": "114 Sewall Ave, Unit 3 (124-30-53)",
    "$": 754600,
    "address": "114 Sewall Ave, Unit 3",
    "parcel_id": "124-30-53",
    "owner1": "LG GST LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 7727.1,
    "new_taxes_no_override": 8060.91,
    "override_total_1": 8289.63,
    "override_increase_1": 228.72
  },
  {
    "#": "114 Sewall Ave, Unit 4 (124-30-54)",
    "$": 766500,
    "address": "114 Sewall Ave, Unit 4",
    "parcel_id": "124-30-54",
    "owner1": "LI, QING",
    "owner2": "WANG, ZHENG",
    "current_taxes": 4214.03,
    "new_taxes_no_override": 4396.08,
    "override_total_1": 4520.81,
    "override_increase_1": 124.74
  },
  {
    "#": "114 Sewall Ave, Unit 5 & P1A 1B (124-30-55)",
    "$": 853400,
    "address": "114 Sewall Ave, Unit 5 & P1A 1B",
    "parcel_id": "124-30-55",
    "owner1": "NICHOLSON, SHARON & CARL",
    "owner2": "",
    "current_taxes": 5103.88,
    "new_taxes_no_override": 5324.37,
    "override_total_1": 5475.44,
    "override_increase_1": 151.07
  },
  {
    "#": "114 Sewall Ave, Unit 6 (124-30-56)",
    "$": 876600,
    "address": "114 Sewall Ave, Unit 6",
    "parcel_id": "124-30-56",
    "owner1": "ZHENG, DA",
    "owner2": "YANG, MIN",
    "current_taxes": 5341.45,
    "new_taxes_no_override": 5572.2,
    "override_total_1": 5730.31,
    "override_increase_1": 158.11
  },
  {
    "#": "114 Sewall Ave, Unit A (124-30-50)",
    "$": 617900,
    "address": "114 Sewall Ave, Unit A",
    "parcel_id": "124-30-50",
    "owner1": "PINEIRO, CAROL H",
    "owner2": "",
    "current_taxes": 6327.3,
    "new_taxes_no_override": 6600.64,
    "override_total_1": 6787.93,
    "override_increase_1": 187.29
  },
  {
    "#": "115 Sewall Ave, Unit 1& P13-14 (125-05-01)",
    "$": 1660000,
    "address": "115 Sewall Ave, Unit 1& P13-14",
    "parcel_id": "125-05-01",
    "owner1": "MELARAGNO TRS, ANTHONY JOSEPH",
    "owner2": "IMMERMAN, KATHERINE LAURA",
    "current_taxes": 13363.47,
    "new_taxes_no_override": 13940.77,
    "override_total_1": 14336.33,
    "override_increase_1": 395.56
  },
  {
    "#": "115 Sewall Ave, Unit 2 &P11-12 (125-05-02)",
    "$": 1672700,
    "address": "115 Sewall Ave, Unit 2 &P11-12",
    "parcel_id": "125-05-02",
    "owner1": "CHIN TR, LAURA J",
    "owner2": "",
    "current_taxes": 13493.51,
    "new_taxes_no_override": 14076.43,
    "override_total_1": 14475.84,
    "override_increase_1": 399.41
  },
  {
    "#": "115 Sewall Ave, Unit 3&Pg-3G16 (125-05-03)",
    "$": 2261600,
    "address": "115 Sewall Ave, Unit 3&Pg-3G16",
    "parcel_id": "125-05-03",
    "owner1": "HACHIGIAN TR, LEA J",
    "owner2": "",
    "current_taxes": 19523.85,
    "new_taxes_no_override": 20367.28,
    "override_total_1": 20945.19,
    "override_increase_1": 577.91
  },
  {
    "#": "115 Sewall Ave, Unit 4&Pg-1 P15 (125-05-04)",
    "$": 2218000,
    "address": "115 Sewall Ave, Unit 4&Pg-1 P15",
    "parcel_id": "125-05-04",
    "owner1": "SAFFITZ, JEFFREY E & SHARON",
    "owner2": "",
    "current_taxes": 19077.39,
    "new_taxes_no_override": 19901.53,
    "override_total_1": 20466.22,
    "override_increase_1": 564.69
  },
  {
    "#": "115 Sewall Ave, Unit 5& Pg-4-5 (125-05-05)",
    "$": 2307500,
    "address": "115 Sewall Ave, Unit 5& Pg-4-5",
    "parcel_id": "125-05-05",
    "owner1": "DHARAN, BALA & VIDYA",
    "owner2": "",
    "current_taxes": 19993.87,
    "new_taxes_no_override": 20857.61,
    "override_total_1": 21449.42,
    "override_increase_1": 591.82
  },
  {
    "#": "115 Sewall Ave, Unit 6&Pg-2 G4 (125-05-06)",
    "$": 2306800,
    "address": "115 Sewall Ave, Unit 6&Pg-2 G4",
    "parcel_id": "125-05-06",
    "owner1": "HUNDERT TRS, EDWARD M & MARY C",
    "owner2": "",
    "current_taxes": 19986.7,
    "new_taxes_no_override": 20850.13,
    "override_total_1": 21441.73,
    "override_increase_1": 591.61
  },
  {
    "#": "115 Sewall Ave, Unit 7&Pg-7 P16 (125-05-07)",
    "$": 2266500,
    "address": "115 Sewall Ave, Unit 7&Pg-7 P16",
    "parcel_id": "125-05-07",
    "owner1": "ZHANG, JUN",
    "owner2": "WANG, HONGMEI",
    "current_taxes": 19574.03,
    "new_taxes_no_override": 20419.63,
    "override_total_1": 20999.02,
    "override_increase_1": 579.39
  },
  {
    "#": "115 Sewall Ave, Unit 8&Pg-6 G13 (125-05-08)",
    "$": 2306200,
    "address": "115 Sewall Ave, Unit 8&Pg-6 G13",
    "parcel_id": "125-05-08",
    "owner1": "ERICKSON, BRIAN & ALISON",
    "owner2": "",
    "current_taxes": 19980.55,
    "new_taxes_no_override": 20843.71,
    "override_total_1": 21435.13,
    "override_increase_1": 591.42
  },
  {
    "#": "116 Sewall Ave, Unit 1 (124-30-57)",
    "$": 604500,
    "address": "116 Sewall Ave, Unit 1",
    "parcel_id": "124-30-57",
    "owner1": "MERCURIO, ANDREA E",
    "owner2": "",
    "current_taxes": 2555.15,
    "new_taxes_no_override": 2665.53,
    "override_total_1": 2741.16,
    "override_increase_1": 75.63
  },
  {
    "#": "116 Sewall Ave, Unit 2 (124-30-58)",
    "$": 628900,
    "address": "116 Sewall Ave, Unit 2",
    "parcel_id": "124-30-58",
    "owner1": "TRAUB, STACY H",
    "owner2": "",
    "current_taxes": 6439.94,
    "new_taxes_no_override": 6718.15,
    "override_total_1": 6908.77,
    "override_increase_1": 190.62
  },
  {
    "#": "116 Sewall Ave, Unit 3 (124-30-59)",
    "$": 604500,
    "address": "116 Sewall Ave, Unit 3",
    "parcel_id": "124-30-59",
    "owner1": "LI, XIAN CHANG",
    "owner2": "YU, QIANG",
    "current_taxes": 6190.08,
    "new_taxes_no_override": 6457.49,
    "override_total_1": 6640.72,
    "override_increase_1": 183.23
  },
  {
    "#": "116 Sewall Ave, Unit 4 (124-30-60)",
    "$": 646300,
    "address": "116 Sewall Ave, Unit 4",
    "parcel_id": "124-30-60",
    "owner1": "SISK TR, JEFFREY",
    "owner2": "",
    "current_taxes": 6618.11,
    "new_taxes_no_override": 6904.01,
    "override_total_1": 7099.91,
    "override_increase_1": 195.9
  },
  {
    "#": "116 Sewall Ave, Unit 5 (124-30-61)",
    "$": 604500,
    "address": "116 Sewall Ave, Unit 5",
    "parcel_id": "124-30-61",
    "owner1": "JAGODNIK, BRITT L",
    "owner2": "",
    "current_taxes": 6190.08,
    "new_taxes_no_override": 6457.49,
    "override_total_1": 6640.72,
    "override_increase_1": 183.23
  },
  {
    "#": "116 Sewall Ave, Unit 6 (124-30-62)",
    "$": 608500,
    "address": "116 Sewall Ave, Unit 6",
    "parcel_id": "124-30-62",
    "owner1": "DIAZ-PEREZ TR, ARTURO",
    "owner2": "",
    "current_taxes": 2596.11,
    "new_taxes_no_override": 2708.26,
    "override_total_1": 2785.11,
    "override_increase_1": 76.84
  },
  {
    "#": "120 Sewall Ave, Unit 120A & P16 (124-29-01)",
    "$": 1367200,
    "address": "120 Sewall Ave, Unit 120A & P16",
    "parcel_id": "124-29-01",
    "owner1": "EHRLICH, ILYA & YULIYA",
    "owner2": "",
    "current_taxes": 14000.13,
    "new_taxes_no_override": 14604.94,
    "override_total_1": 15019.34,
    "override_increase_1": 414.4
  },
  {
    "#": "120 Sewall Ave, Unit 120B & P24 (124-29-02)",
    "$": 1305000,
    "address": "120 Sewall Ave, Unit 120B & P24",
    "parcel_id": "124-29-02",
    "owner1": "YODER TR, ISABEL C",
    "owner2": "SALDANA, ANDRES",
    "current_taxes": 9728.27,
    "new_taxes_no_override": 10148.53,
    "override_total_1": 10436.49,
    "override_increase_1": 287.96
  },
  {
    "#": "120 Sewall Ave, Unit 120C & P12 (124-29-03)",
    "$": 1466100,
    "address": "120 Sewall Ave, Unit 120C & P12",
    "parcel_id": "124-29-03",
    "owner1": "LAPLUME, CHIARA & JOSEPH W",
    "owner2": "",
    "current_taxes": 11377.93,
    "new_taxes_no_override": 11869.46,
    "override_total_1": 12206.24,
    "override_increase_1": 336.79
  },
  {
    "#": "122 Sewall Ave, Unit 122A & P29 (124-28-01)",
    "$": 1367200,
    "address": "122 Sewall Ave, Unit 122A & P29",
    "parcel_id": "124-28-01",
    "owner1": "CARSON, KEITH L & HOLLY A",
    "owner2": "",
    "current_taxes": 10365.19,
    "new_taxes_no_override": 10812.97,
    "override_total_1": 11119.78,
    "override_increase_1": 306.81
  },
  {
    "#": "122 Sewall Ave, Unit 122B P11 (124-28-02)",
    "$": 1422800,
    "address": "122 Sewall Ave, Unit 122B P11",
    "parcel_id": "124-28-02",
    "owner1": "MONDESIR, JOHANNA",
    "owner2": "KODURI, VIDYASAGAR",
    "current_taxes": 14569.47,
    "new_taxes_no_override": 15198.87,
    "override_total_1": 15630.13,
    "override_increase_1": 431.26
  },
  {
    "#": "122 Sewall Ave, Unit 122C & P8 (124-28-03)",
    "$": 1442000,
    "address": "122 Sewall Ave, Unit 122C & P8",
    "parcel_id": "124-28-03",
    "owner1": "OLFE, MICHAEL & FRANCES",
    "owner2": "",
    "current_taxes": 11131.15,
    "new_taxes_no_override": 11612.02,
    "override_total_1": 11941.5,
    "override_increase_1": 329.48
  },
  {
    "#": "123 Sewall Ave, Unit 1-A & P21 (125-06-39)",
    "$": 613600,
    "address": "123 Sewall Ave, Unit 1-A & P21",
    "parcel_id": "125-06-39",
    "owner1": "NOVIK, OLGA B",
    "owner2": "",
    "current_taxes": 6283.26,
    "new_taxes_no_override": 6554.7,
    "override_total_1": 6740.68,
    "override_increase_1": 185.98
  },
  {
    "#": "123 Sewall Ave, Unit 1-B & P10 (125-06-03)",
    "$": 621100,
    "address": "123 Sewall Ave, Unit 1-B & P10",
    "parcel_id": "125-06-03",
    "owner1": "LINDEN, TRS, KURT J & SUSAN M",
    "owner2": "",
    "current_taxes": 6360.06,
    "new_taxes_no_override": 6634.81,
    "override_total_1": 6823.07,
    "override_increase_1": 188.26
  },
  {
    "#": "123 Sewall Ave, Unit 1-C (125-06-06)",
    "$": 370200,
    "address": "123 Sewall Ave, Unit 1-C",
    "parcel_id": "125-06-06",
    "owner1": "MA, SISI",
    "owner2": "ZHU, YING",
    "current_taxes": 3790.85,
    "new_taxes_no_override": 3954.61,
    "override_total_1": 4066.82,
    "override_increase_1": 112.21
  },
  {
    "#": "123 Sewall Ave, Unit 1-D (125-06-09)",
    "$": 553200,
    "address": "123 Sewall Ave, Unit 1-D",
    "parcel_id": "125-06-09",
    "owner1": "SALEM, RONALD R",
    "owner2": "",
    "current_taxes": 5664.77,
    "new_taxes_no_override": 5909.49,
    "override_total_1": 6077.17,
    "override_increase_1": 167.68
  },
  {
    "#": "123 Sewall Ave, Unit 1-E (125-06-12)",
    "$": 580600,
    "address": "123 Sewall Ave, Unit 1-E",
    "parcel_id": "125-06-12",
    "owner1": "SMILEY, ROBERT",
    "owner2": "YUKIE, ABE",
    "current_taxes": 5945.34,
    "new_taxes_no_override": 6202.18,
    "override_total_1": 6378.16,
    "override_increase_1": 175.98
  },
  {
    "#": "123 Sewall Ave, Unit 1-F (125-06-15)",
    "$": 568300,
    "address": "123 Sewall Ave, Unit 1-F",
    "parcel_id": "125-06-15",
    "owner1": "KODSI TR, GINETTE",
    "owner2": "",
    "current_taxes": 5819.39,
    "new_taxes_no_override": 6070.79,
    "override_total_1": 6243.04,
    "override_increase_1": 172.25
  },
  {
    "#": "123 Sewall Ave, Unit 1-G & G35 (125-06-18)",
    "$": 612700,
    "address": "123 Sewall Ave, Unit 1-G & G35",
    "parcel_id": "125-06-18",
    "owner1": "LUBKER, SCOTT O & ELIZABETH S",
    "owner2": "",
    "current_taxes": 6274.05,
    "new_taxes_no_override": 6545.09,
    "override_total_1": 6730.8,
    "override_increase_1": 185.71
  },
  {
    "#": "123 Sewall Ave, Unit 1-H & P-6 (125-06-21)",
    "$": 599700,
    "address": "123 Sewall Ave, Unit 1-H & P-6",
    "parcel_id": "125-06-21",
    "owner1": "HAN, CHIEH TING",
    "owner2": "",
    "current_taxes": 6140.93,
    "new_taxes_no_override": 6406.22,
    "override_total_1": 6587.99,
    "override_increase_1": 181.77
  },
  {
    "#": "123 Sewall Ave, Unit 1-I & P25 (125-06-24)",
    "$": 582500,
    "address": "123 Sewall Ave, Unit 1-I & P25",
    "parcel_id": "125-06-24",
    "owner1": "JOHNSTON TRS, EDWARD & MARY",
    "owner2": "",
    "current_taxes": 5964.8,
    "new_taxes_no_override": 6222.48,
    "override_total_1": 6399.04,
    "override_increase_1": 176.56
  },
  {
    "#": "123 Sewall Ave, Unit 1-J (125-06-27)",
    "$": 703600,
    "address": "123 Sewall Ave, Unit 1-J",
    "parcel_id": "125-06-27",
    "owner1": "HUA, LEE XIN",
    "owner2": "GONG, DAHAI",
    "current_taxes": 7204.86,
    "new_taxes_no_override": 7516.11,
    "override_total_1": 7729.37,
    "override_increase_1": 213.26
  },
  {
    "#": "123 Sewall Ave, Unit 1-K & P16 (125-06-30)",
    "$": 703800,
    "address": "123 Sewall Ave, Unit 1-K & P16",
    "parcel_id": "125-06-30",
    "owner1": "JBS CAM LLC",
    "owner2": "",
    "current_taxes": 3571.98,
    "new_taxes_no_override": 3726.29,
    "override_total_1": 3832.02,
    "override_increase_1": 105.73
  },
  {
    "#": "123 Sewall Ave, Unit 1-L (125-06-33)",
    "$": 542000,
    "address": "123 Sewall Ave, Unit 1-L",
    "parcel_id": "125-06-33",
    "owner1": "SHLAPIK, SAUL",
    "owner2": "",
    "current_taxes": 1915.15,
    "new_taxes_no_override": 1997.88,
    "override_total_1": 2054.57,
    "override_increase_1": 56.69
  },
  {
    "#": "123 Sewall Ave, Unit 2-A & P29 (125-06-01)",
    "$": 628900,
    "address": "123 Sewall Ave, Unit 2-A & P29",
    "parcel_id": "125-06-01",
    "owner1": "KAUFMAN, JEFFREY H & SYLVIA M",
    "owner2": "",
    "current_taxes": 6439.94,
    "new_taxes_no_override": 6718.15,
    "override_total_1": 6908.77,
    "override_increase_1": 190.62
  },
  {
    "#": "123 Sewall Ave, Unit 2-B (125-06-04)",
    "$": 621100,
    "address": "123 Sewall Ave, Unit 2-B",
    "parcel_id": "125-06-04",
    "owner1": "COLLINS JR, JOHN C",
    "owner2": "",
    "current_taxes": 6360.06,
    "new_taxes_no_override": 6634.81,
    "override_total_1": 6823.07,
    "override_increase_1": 188.26
  },
  {
    "#": "123 Sewall Ave, Unit 2-C (125-06-07)",
    "$": 454900,
    "address": "123 Sewall Ave, Unit 2-C",
    "parcel_id": "125-06-07",
    "owner1": "LEWIS, STEPHEN P & CARMEN",
    "owner2": "",
    "current_taxes": 4658.18,
    "new_taxes_no_override": 4859.41,
    "override_total_1": 4997.3,
    "override_increase_1": 137.88
  },
  {
    "#": "123 Sewall Ave, Unit 2-D (125-06-10)",
    "$": 553200,
    "address": "123 Sewall Ave, Unit 2-D",
    "parcel_id": "125-06-10",
    "owner1": "STARK TR, JOHN T",
    "owner2": "",
    "current_taxes": 5664.77,
    "new_taxes_no_override": 5909.49,
    "override_total_1": 6077.17,
    "override_increase_1": 167.68
  },
  {
    "#": "123 Sewall Ave, Unit 2-E (125-06-13)",
    "$": 575900,
    "address": "123 Sewall Ave, Unit 2-E",
    "parcel_id": "125-06-13",
    "owner1": "LIU, TIFFANY",
    "owner2": "",
    "current_taxes": 5897.22,
    "new_taxes_no_override": 6151.98,
    "override_total_1": 6326.54,
    "override_increase_1": 174.56
  },
  {
    "#": "123 Sewall Ave, Unit 2-F (125-06-16)",
    "$": 510500,
    "address": "123 Sewall Ave, Unit 2-F",
    "parcel_id": "125-06-16",
    "owner1": "HANEY, THERESA",
    "owner2": "",
    "current_taxes": 5227.52,
    "new_taxes_no_override": 5453.35,
    "override_total_1": 5608.08,
    "override_increase_1": 154.73
  },
  {
    "#": "123 Sewall Ave, Unit 2-G (125-06-19)",
    "$": 607300,
    "address": "123 Sewall Ave, Unit 2-G",
    "parcel_id": "125-06-19",
    "owner1": "MA, JUN",
    "owner2": "ZHAO, LEI",
    "current_taxes": 6218.75,
    "new_taxes_no_override": 6487.4,
    "override_total_1": 6671.47,
    "override_increase_1": 184.07
  },
  {
    "#": "123 Sewall Ave, Unit 2-H (125-06-22)",
    "$": 579600,
    "address": "123 Sewall Ave, Unit 2-H",
    "parcel_id": "125-06-22",
    "owner1": "LERNER, MIKHAIL",
    "owner2": "",
    "current_taxes": 5935.1,
    "new_taxes_no_override": 6191.5,
    "override_total_1": 6367.18,
    "override_increase_1": 175.68
  },
  {
    "#": "123 Sewall Ave, Unit 2-I (125-06-25)",
    "$": 557000,
    "address": "123 Sewall Ave, Unit 2-I",
    "parcel_id": "125-06-25",
    "owner1": "EVELSON TRS, ANATOLY & TATIANA",
    "owner2": "",
    "current_taxes": 5703.68,
    "new_taxes_no_override": 5950.08,
    "override_total_1": 6118.91,
    "override_increase_1": 168.83
  },
  {
    "#": "123 Sewall Ave, Unit 2-J & P8 (125-06-28)",
    "$": 754300,
    "address": "123 Sewall Ave, Unit 2-J & P8",
    "parcel_id": "125-06-28",
    "owner1": "HOFFENBERG, WENDI",
    "owner2": "KWITKIN, MICHELLE",
    "current_taxes": 4089.1,
    "new_taxes_no_override": 4265.75,
    "override_total_1": 4386.79,
    "override_increase_1": 121.04
  },
  {
    "#": "123 Sewall Ave, Unit 2-K & G26 (125-06-31)",
    "$": 726800,
    "address": "123 Sewall Ave, Unit 2-K & G26",
    "parcel_id": "125-06-31",
    "owner1": "SMITH TR, HELEN L",
    "owner2": "",
    "current_taxes": 7442.43,
    "new_taxes_no_override": 7763.94,
    "override_total_1": 7984.24,
    "override_increase_1": 220.3
  },
  {
    "#": "123 Sewall Ave, Unit 2-L & P31 (125-06-34)",
    "$": 557000,
    "address": "123 Sewall Ave, Unit 2-L & P31",
    "parcel_id": "125-06-34",
    "owner1": "KHAN, TAIMUR H",
    "owner2": "",
    "current_taxes": 5703.68,
    "new_taxes_no_override": 5950.08,
    "override_total_1": 6118.91,
    "override_increase_1": 168.83
  },
  {
    "#": "123 Sewall Ave, Unit 3-A (125-06-02)",
    "$": 628900,
    "address": "123 Sewall Ave, Unit 3-A",
    "parcel_id": "125-06-02",
    "owner1": "MOFFITT TR, FRANCES A",
    "owner2": "",
    "current_taxes": 2805.0,
    "new_taxes_no_override": 2926.18,
    "override_total_1": 3009.2,
    "override_increase_1": 83.03
  },
  {
    "#": "123 Sewall Ave, Unit 3-B & P15 (125-06-05)",
    "$": 631400,
    "address": "123 Sewall Ave, Unit 3-B & P15",
    "parcel_id": "125-06-05",
    "owner1": "MA, JIAN HUA",
    "owner2": "WANG, HUI LING",
    "current_taxes": 2830.6,
    "new_taxes_no_override": 2952.88,
    "override_total_1": 3036.67,
    "override_increase_1": 83.79
  },
  {
    "#": "123 Sewall Ave, Unit 3-C & P-34 (125-06-08)",
    "$": 454900,
    "address": "123 Sewall Ave, Unit 3-C & P-34",
    "parcel_id": "125-06-08",
    "owner1": "DAHROUJ, MOHAMMAD",
    "owner2": "OUCHERIF, KAOUTAR ABBOU",
    "current_taxes": 4658.18,
    "new_taxes_no_override": 4859.41,
    "override_total_1": 4997.3,
    "override_increase_1": 137.88
  },
  {
    "#": "123 Sewall Ave, Unit 3-D & P14 (125-06-11)",
    "$": 565100,
    "address": "123 Sewall Ave, Unit 3-D & P14",
    "parcel_id": "125-06-11",
    "owner1": "WANG, XIN",
    "owner2": "",
    "current_taxes": 5786.62,
    "new_taxes_no_override": 6036.6,
    "override_total_1": 6207.89,
    "override_increase_1": 171.28
  },
  {
    "#": "123 Sewall Ave, Unit 3-E (125-06-14)",
    "$": 575900,
    "address": "123 Sewall Ave, Unit 3-E",
    "parcel_id": "125-06-14",
    "owner1": "SEMO, BARRY J",
    "owner2": "",
    "current_taxes": 5897.22,
    "new_taxes_no_override": 6151.98,
    "override_total_1": 6326.54,
    "override_increase_1": 174.56
  },
  {
    "#": "123 Sewall Ave, Unit 3-F (125-06-17)",
    "$": 500300,
    "address": "123 Sewall Ave, Unit 3-F",
    "parcel_id": "125-06-17",
    "owner1": "LINFOOT, CINDY & ANDY J",
    "owner2": "",
    "current_taxes": 5123.07,
    "new_taxes_no_override": 5344.39,
    "override_total_1": 5496.03,
    "override_increase_1": 151.64
  },
  {
    "#": "123 Sewall Ave, Unit 3-G (125-06-20)",
    "$": 594300,
    "address": "123 Sewall Ave, Unit 3-G",
    "parcel_id": "125-06-20",
    "owner1": "ROLFS, ANDREAS",
    "owner2": "ZUO, DONGMEI",
    "current_taxes": 6085.63,
    "new_taxes_no_override": 6348.53,
    "override_total_1": 6528.66,
    "override_increase_1": 180.13
  },
  {
    "#": "123 Sewall Ave, Unit 3-H (125-06-23)",
    "$": 605100,
    "address": "123 Sewall Ave, Unit 3-H",
    "parcel_id": "125-06-23",
    "owner1": "CHUNG, JAE WON",
    "owner2": "",
    "current_taxes": 6196.22,
    "new_taxes_no_override": 6463.9,
    "override_total_1": 6647.3,
    "override_increase_1": 183.41
  },
  {
    "#": "123 Sewall Ave, Unit 3-I (125-06-26)",
    "$": 568900,
    "address": "123 Sewall Ave, Unit 3-I",
    "parcel_id": "125-06-26",
    "owner1": "CHENG, CAN",
    "owner2": "",
    "current_taxes": 5825.54,
    "new_taxes_no_override": 6077.2,
    "override_total_1": 6249.64,
    "override_increase_1": 172.44
  },
  {
    "#": "123 Sewall Ave, Unit 3-J & P11 (125-06-29)",
    "$": 728800,
    "address": "123 Sewall Ave, Unit 3-J & P11",
    "parcel_id": "125-06-29",
    "owner1": "LIN, YU-SHENG",
    "owner2": "",
    "current_taxes": 7462.91,
    "new_taxes_no_override": 7785.31,
    "override_total_1": 8006.21,
    "override_increase_1": 220.9
  },
  {
    "#": "123 Sewall Ave, Unit 3-K (125-06-32)",
    "$": 724600,
    "address": "123 Sewall Ave, Unit 3-K",
    "parcel_id": "125-06-32",
    "owner1": "XU, BING",
    "owner2": "",
    "current_taxes": 3784.97,
    "new_taxes_no_override": 3948.48,
    "override_total_1": 4060.52,
    "override_increase_1": 112.04
  },
  {
    "#": "123 Sewall Ave, Unit 3-L (125-06-35)",
    "$": 567400,
    "address": "123 Sewall Ave, Unit 3-L",
    "parcel_id": "125-06-35",
    "owner1": "TAN, WEN-HANN",
    "owner2": "",
    "current_taxes": 5810.18,
    "new_taxes_no_override": 6061.18,
    "override_total_1": 6233.16,
    "override_increase_1": 171.98
  },
  {
    "#": "123 Sewall Ave, Unit L-A (125-06-36)",
    "$": 428200,
    "address": "123 Sewall Ave, Unit L-A",
    "parcel_id": "125-06-36",
    "owner1": "MCGRATH, STACY A",
    "owner2": "",
    "current_taxes": 749.83,
    "new_taxes_no_override": 782.22,
    "override_total_1": 804.42,
    "override_increase_1": 22.19
  },
  {
    "#": "123 Sewall Ave, Unit L-B & P1 (125-06-37)",
    "$": 499800,
    "address": "123 Sewall Ave, Unit L-B & P1",
    "parcel_id": "125-06-37",
    "owner1": "HERMAN, MATTHEW A",
    "owner2": "",
    "current_taxes": 5117.95,
    "new_taxes_no_override": 5339.05,
    "override_total_1": 5490.54,
    "override_increase_1": 151.49
  },
  {
    "#": "123 Sewall Ave, Unit L-C & P22 (125-06-38)",
    "$": 494400,
    "address": "123 Sewall Ave, Unit L-C & P22",
    "parcel_id": "125-06-38",
    "owner1": "XIA, MINGCAN",
    "owner2": "YU, SANHONG",
    "current_taxes": 5062.66,
    "new_taxes_no_override": 5281.37,
    "override_total_1": 5431.22,
    "override_increase_1": 149.85
  },
  {
    "#": "126 Sewall Ave, Unit 126A & Pksp (124-27-01)",
    "$": 1238400,
    "address": "126 Sewall Ave, Unit 126A & Pksp",
    "parcel_id": "124-27-01",
    "owner1": "HOLLANDER TRS, RONALD M & TOBY S",
    "owner2": "",
    "current_taxes": 9046.28,
    "new_taxes_no_override": 9437.08,
    "override_total_1": 9704.85,
    "override_increase_1": 267.77
  },
  {
    "#": "126 Sewall Ave, Unit 126B & P18 (124-27-02)",
    "$": 1330500,
    "address": "126 Sewall Ave, Unit 126B & P18",
    "parcel_id": "124-27-02",
    "owner1": "RUAN, YIXIONG & XIAO HUA",
    "owner2": "",
    "current_taxes": 9989.39,
    "new_taxes_no_override": 10420.93,
    "override_total_1": 10716.62,
    "override_increase_1": 295.69
  },
  {
    "#": "126 Sewall Ave, Unit 126C & P14 (124-27-03)",
    "$": 1387800,
    "address": "126 Sewall Ave, Unit 126C & P14",
    "parcel_id": "124-27-03",
    "owner1": "ERLIJ, ANTONIETA T",
    "owner2": "",
    "current_taxes": 10576.14,
    "new_taxes_no_override": 11033.03,
    "override_total_1": 11346.08,
    "override_increase_1": 313.05
  },
  {
    "#": "128 Sewall Ave, Unit 128A & P24 (124-26-01)",
    "$": 1368700,
    "address": "128 Sewall Ave, Unit 128A & P24",
    "parcel_id": "124-26-01",
    "owner1": "MARTENS, ANDREW",
    "owner2": "FLYNN, CATHERINE",
    "current_taxes": 10380.55,
    "new_taxes_no_override": 10828.99,
    "override_total_1": 11136.25,
    "override_increase_1": 307.26
  },
  {
    "#": "128 Sewall Ave, Unit 128B & P27 (124-26-02)",
    "$": 1408600,
    "address": "128 Sewall Ave, Unit 128B & P27",
    "parcel_id": "124-26-02",
    "owner1": "SEGAL, PHOEBE C",
    "owner2": "BOCKMAN, ALEXANDER C",
    "current_taxes": 10789.13,
    "new_taxes_no_override": 11255.22,
    "override_total_1": 11574.58,
    "override_increase_1": 319.36
  },
  {
    "#": "128 Sewall Ave, Unit 128C & Pa (124-26-03)",
    "$": 1322700,
    "address": "128 Sewall Ave, Unit 128C & Pa",
    "parcel_id": "124-26-03",
    "owner1": "SINGH, ASHISH J & RENUKA B",
    "owner2": "",
    "current_taxes": 13544.45,
    "new_taxes_no_override": 14129.57,
    "override_total_1": 14530.49,
    "override_increase_1": 400.92
  },
  {
    "#": "131 Sewall Ave, Unit 1 (125-07-51)",
    "$": 939700,
    "address": "131 Sewall Ave, Unit 1",
    "parcel_id": "125-07-51",
    "owner1": "STRYER, DAVID & ELIZABETH",
    "owner2": "",
    "current_taxes": 5987.59,
    "new_taxes_no_override": 6246.25,
    "override_total_1": 6423.49,
    "override_increase_1": 177.23
  },
  {
    "#": "131 Sewall Ave, Unit 2 (125-07-01)",
    "$": 711200,
    "address": "131 Sewall Ave, Unit 2",
    "parcel_id": "125-07-01",
    "owner1": "PENG TR, YUNJIE",
    "owner2": "",
    "current_taxes": 7282.69,
    "new_taxes_no_override": 7597.3,
    "override_total_1": 7812.87,
    "override_increase_1": 215.57
  },
  {
    "#": "131 Sewall Ave, Unit 21 (125-07-08)",
    "$": 1018500,
    "address": "131 Sewall Ave, Unit 21",
    "parcel_id": "125-07-08",
    "owner1": "SHINKAZH, ALEXANDER & TSETSILIYA",
    "owner2": "",
    "current_taxes": 6794.51,
    "new_taxes_no_override": 7088.03,
    "override_total_1": 7289.15,
    "override_increase_1": 201.12
  },
  {
    "#": "131 Sewall Ave, Unit 22 (125-07-09)",
    "$": 704000,
    "address": "131 Sewall Ave, Unit 22",
    "parcel_id": "125-07-09",
    "owner1": "IGNATOFF, ANDREA",
    "owner2": "",
    "current_taxes": 3574.03,
    "new_taxes_no_override": 3728.43,
    "override_total_1": 3834.22,
    "override_increase_1": 105.79
  },
  {
    "#": "131 Sewall Ave, Unit 23 (125-07-10)",
    "$": 734100,
    "address": "131 Sewall Ave, Unit 23",
    "parcel_id": "125-07-10",
    "owner1": "WANG, KE",
    "owner2": "DU, BO",
    "current_taxes": 7517.18,
    "new_taxes_no_override": 7841.92,
    "override_total_1": 8064.43,
    "override_increase_1": 222.51
  },
  {
    "#": "131 Sewall Ave, Unit 24 (125-07-11)",
    "$": 522300,
    "address": "131 Sewall Ave, Unit 24",
    "parcel_id": "125-07-11",
    "owner1": "BUNNIN, NANCY",
    "owner2": "",
    "current_taxes": 1713.42,
    "new_taxes_no_override": 1787.44,
    "override_total_1": 1838.16,
    "override_increase_1": 50.72
  },
  {
    "#": "131 Sewall Ave, Unit 25 (125-07-50)",
    "$": 894200,
    "address": "131 Sewall Ave, Unit 25",
    "parcel_id": "125-07-50",
    "owner1": "KOPELMAN LIFE ESTATE, SELMA",
    "owner2": "",
    "current_taxes": 5521.67,
    "new_taxes_no_override": 5760.21,
    "override_total_1": 5923.65,
    "override_increase_1": 163.44
  },
  {
    "#": "131 Sewall Ave, Unit 26 (125-07-12)",
    "$": 595800,
    "address": "131 Sewall Ave, Unit 26",
    "parcel_id": "125-07-12",
    "owner1": "JUNG, YOUNGSUN",
    "owner2": "",
    "current_taxes": 2466.06,
    "new_taxes_no_override": 2572.59,
    "override_total_1": 2645.59,
    "override_increase_1": 73.0
  },
  {
    "#": "131 Sewall Ave, Unit 27 (125-07-13)",
    "$": 575400,
    "address": "131 Sewall Ave, Unit 27",
    "parcel_id": "125-07-13",
    "owner1": "HOWARD TRS, PETER JOHN & NOREEN MARY",
    "owner2": "",
    "current_taxes": 5892.1,
    "new_taxes_no_override": 6146.64,
    "override_total_1": 6321.04,
    "override_increase_1": 174.41
  },
  {
    "#": "131 Sewall Ave, Unit 28 (125-07-14)",
    "$": 729900,
    "address": "131 Sewall Ave, Unit 28",
    "parcel_id": "125-07-14",
    "owner1": "HENKEN TR, JULIA A",
    "owner2": "",
    "current_taxes": 3839.24,
    "new_taxes_no_override": 4005.1,
    "override_total_1": 4118.74,
    "override_increase_1": 113.64
  },
  {
    "#": "131 Sewall Ave, Unit 29 (125-07-15)",
    "$": 1013200,
    "address": "131 Sewall Ave, Unit 29",
    "parcel_id": "125-07-15",
    "owner1": "ROZENBLUM TRS, MICHAEL & SVETLANA",
    "owner2": "",
    "current_taxes": 6740.23,
    "new_taxes_no_override": 7031.41,
    "override_total_1": 7230.92,
    "override_increase_1": 199.51
  },
  {
    "#": "131 Sewall Ave, Unit 3 (125-07-02)",
    "$": 726900,
    "address": "131 Sewall Ave, Unit 3",
    "parcel_id": "125-07-02",
    "owner1": "GUTIERREZ, MYRIAM",
    "owner2": "",
    "current_taxes": 3808.52,
    "new_taxes_no_override": 3973.05,
    "override_total_1": 4085.78,
    "override_increase_1": 112.73
  },
  {
    "#": "131 Sewall Ave, Unit 31 (125-07-16)",
    "$": 1072300,
    "address": "131 Sewall Ave, Unit 31",
    "parcel_id": "125-07-16",
    "owner1": "VOLPERT, OLGA",
    "owner2": "",
    "current_taxes": 10980.35,
    "new_taxes_no_override": 11454.7,
    "override_total_1": 11779.72,
    "override_increase_1": 325.02
  },
  {
    "#": "131 Sewall Ave, Unit 32 (125-07-17)",
    "$": 795700,
    "address": "131 Sewall Ave, Unit 32",
    "parcel_id": "125-07-17",
    "owner1": "ROJAS TR, ADRIANA GARZON",
    "owner2": "",
    "current_taxes": 8147.97,
    "new_taxes_no_override": 8499.96,
    "override_total_1": 8741.14,
    "override_increase_1": 241.18
  },
  {
    "#": "131 Sewall Ave, Unit 33 (125-07-18)",
    "$": 706500,
    "address": "131 Sewall Ave, Unit 33",
    "parcel_id": "125-07-18",
    "owner1": "HUGHES, APRIL D",
    "owner2": "",
    "current_taxes": 3599.63,
    "new_taxes_no_override": 3755.13,
    "override_total_1": 3861.68,
    "override_increase_1": 106.55
  },
  {
    "#": "131 Sewall Ave, Unit 34 (125-07-19)",
    "$": 559200,
    "address": "131 Sewall Ave, Unit 34",
    "parcel_id": "125-07-19",
    "owner1": "SCUDDER, DANIEL MOSES & SABRINA C",
    "owner2": "",
    "current_taxes": 5726.21,
    "new_taxes_no_override": 5973.58,
    "override_total_1": 6143.08,
    "override_increase_1": 169.5
  },
  {
    "#": "131 Sewall Ave, Unit 35 (125-07-20)",
    "$": 1055500,
    "address": "131 Sewall Ave, Unit 35",
    "parcel_id": "125-07-20",
    "owner1": "LEVY, HARRISON A",
    "owner2": "KAPLAN-LEVY, SARA A",
    "current_taxes": 7173.39,
    "new_taxes_no_override": 7483.28,
    "override_total_1": 7695.61,
    "override_increase_1": 212.33
  },
  {
    "#": "131 Sewall Ave, Unit 36 (125-07-21)",
    "$": 587400,
    "address": "131 Sewall Ave, Unit 36",
    "parcel_id": "125-07-21",
    "owner1": "WANG, HAN",
    "owner2": "",
    "current_taxes": 2380.04,
    "new_taxes_no_override": 2482.86,
    "override_total_1": 2553.31,
    "override_increase_1": 70.45
  },
  {
    "#": "131 Sewall Ave, Unit 37 (125-07-22)",
    "$": 607700,
    "address": "131 Sewall Ave, Unit 37",
    "parcel_id": "125-07-22",
    "owner1": "GAO, XINING & BO",
    "owner2": "",
    "current_taxes": 2587.91,
    "new_taxes_no_override": 2699.71,
    "override_total_1": 2776.31,
    "override_increase_1": 76.6
  },
  {
    "#": "131 Sewall Ave, Unit 38 (125-07-23)",
    "$": 713900,
    "address": "131 Sewall Ave, Unit 38",
    "parcel_id": "125-07-23",
    "owner1": "CHENG TRS, HENRY",
    "owner2": "MCSWEENEY, MAIREADE E",
    "current_taxes": 7310.34,
    "new_taxes_no_override": 7626.15,
    "override_total_1": 7842.53,
    "override_increase_1": 216.39
  },
  {
    "#": "131 Sewall Ave, Unit 39 (125-07-24)",
    "$": 886600,
    "address": "131 Sewall Ave, Unit 39",
    "parcel_id": "125-07-24",
    "owner1": "GAFFIN-CAHN, ELON",
    "owner2": "ALMOZLINO, ELLIAT",
    "current_taxes": 5443.85,
    "new_taxes_no_override": 5679.02,
    "override_total_1": 5840.16,
    "override_increase_1": 161.14
  },
  {
    "#": "131 Sewall Ave, Unit 41 (125-07-25)",
    "$": 1006900,
    "address": "131 Sewall Ave, Unit 41",
    "parcel_id": "125-07-25",
    "owner1": "ROSENFELD TR, GARY",
    "owner2": "",
    "current_taxes": 10310.66,
    "new_taxes_no_override": 10756.08,
    "override_total_1": 11061.28,
    "override_increase_1": 305.2
  },
  {
    "#": "131 Sewall Ave, Unit 42 (125-07-26)",
    "$": 818900,
    "address": "131 Sewall Ave, Unit 42",
    "parcel_id": "125-07-26",
    "owner1": "POSS LLC",
    "owner2": "",
    "current_taxes": 8385.54,
    "new_taxes_no_override": 8747.8,
    "override_total_1": 8996.01,
    "override_increase_1": 248.21
  },
  {
    "#": "131 Sewall Ave, Unit 43 (125-07-27)",
    "$": 726900,
    "address": "131 Sewall Ave, Unit 43",
    "parcel_id": "125-07-27",
    "owner1": "ELSTEIN, ALLEN R",
    "owner2": "",
    "current_taxes": 3808.52,
    "new_taxes_no_override": 3973.05,
    "override_total_1": 4085.78,
    "override_increase_1": 112.73
  },
  {
    "#": "131 Sewall Ave, Unit 44 (125-07-28)",
    "$": 567000,
    "address": "131 Sewall Ave, Unit 44",
    "parcel_id": "125-07-28",
    "owner1": "SILVERSTEIN TR, BERNICE",
    "owner2": "",
    "current_taxes": 2171.15,
    "new_taxes_no_override": 2264.94,
    "override_total_1": 2329.21,
    "override_increase_1": 64.27
  },
  {
    "#": "131 Sewall Ave, Unit 45 (125-07-29)",
    "$": 994400,
    "address": "131 Sewall Ave, Unit 45",
    "parcel_id": "125-07-29",
    "owner1": "MICALI, SILVIO & DANIELA CARUSO",
    "owner2": "",
    "current_taxes": 10182.66,
    "new_taxes_no_override": 10622.55,
    "override_total_1": 10923.96,
    "override_increase_1": 301.41
  },
  {
    "#": "131 Sewall Ave, Unit 46 (125-07-30)",
    "$": 600900,
    "address": "131 Sewall Ave, Unit 46",
    "parcel_id": "125-07-30",
    "owner1": "AMASANTI, ALFRED A",
    "owner2": "",
    "current_taxes": 2518.28,
    "new_taxes_no_override": 2627.07,
    "override_total_1": 2701.61,
    "override_increase_1": 74.54
  },
  {
    "#": "131 Sewall Ave, Unit 47 (125-07-31)",
    "$": 600500,
    "address": "131 Sewall Ave, Unit 47",
    "parcel_id": "125-07-31",
    "owner1": "AHMED, ARSHAD & MARY PAYSON",
    "owner2": "",
    "current_taxes": 6149.12,
    "new_taxes_no_override": 6414.76,
    "override_total_1": 6596.78,
    "override_increase_1": 182.01
  },
  {
    "#": "131 Sewall Ave, Unit 48 (125-07-32)",
    "$": 722400,
    "address": "131 Sewall Ave, Unit 48",
    "parcel_id": "125-07-32",
    "owner1": "KHANDELWAL, JAI K-ARUNA-MANOJ",
    "owner2": "",
    "current_taxes": 7397.38,
    "new_taxes_no_override": 7716.95,
    "override_total_1": 7935.91,
    "override_increase_1": 218.96
  },
  {
    "#": "131 Sewall Ave, Unit 49 (125-07-33)",
    "$": 1015000,
    "address": "131 Sewall Ave, Unit 49",
    "parcel_id": "125-07-33",
    "owner1": "BROWN, TAYLOR E",
    "owner2": "BROWN TRS, ALAN A & MARION D",
    "current_taxes": 6758.67,
    "new_taxes_no_override": 7050.64,
    "override_total_1": 7250.7,
    "override_increase_1": 200.06
  },
  {
    "#": "131 Sewall Ave, Unit 5 (125-07-03)",
    "$": 920600,
    "address": "131 Sewall Ave, Unit 5",
    "parcel_id": "125-07-03",
    "owner1": "LEE, JENNIFER JOOYEON",
    "owner2": "SHEEN, JOONG HYUK",
    "current_taxes": 5792.01,
    "new_taxes_no_override": 6042.22,
    "override_total_1": 6213.67,
    "override_increase_1": 171.44
  },
  {
    "#": "131 Sewall Ave, Unit 51 (125-07-34)",
    "$": 991000,
    "address": "131 Sewall Ave, Unit 51",
    "parcel_id": "125-07-34",
    "owner1": "LEVITAN TR, ANNA",
    "owner2": "",
    "current_taxes": 10147.84,
    "new_taxes_no_override": 10586.23,
    "override_total_1": 10886.6,
    "override_increase_1": 300.38
  },
  {
    "#": "131 Sewall Ave, Unit 52 (125-07-35)",
    "$": 518700,
    "address": "131 Sewall Ave, Unit 52",
    "parcel_id": "125-07-35",
    "owner1": "SHOHAM, MARK E",
    "owner2": "",
    "current_taxes": 5311.49,
    "new_taxes_no_override": 5540.95,
    "override_total_1": 5698.17,
    "override_increase_1": 157.22
  },
  {
    "#": "131 Sewall Ave, Unit 53 (125-07-36)",
    "$": 998600,
    "address": "131 Sewall Ave, Unit 53",
    "parcel_id": "125-07-36",
    "owner1": "YAM, CHUN-SHAN",
    "owner2": "HU, LIN-WEN",
    "current_taxes": 10225.66,
    "new_taxes_no_override": 10667.41,
    "override_total_1": 10970.09,
    "override_increase_1": 302.68
  },
  {
    "#": "131 Sewall Ave, Unit 54 (125-07-37)",
    "$": 677200,
    "address": "131 Sewall Ave, Unit 54",
    "parcel_id": "125-07-37",
    "owner1": "SMITH, WILLIAM F III",
    "owner2": "AMICK, MELISSA M",
    "current_taxes": 3299.59,
    "new_taxes_no_override": 3442.13,
    "override_total_1": 3539.8,
    "override_increase_1": 97.67
  },
  {
    "#": "131 Sewall Ave, Unit 55 (125-07-38)",
    "$": 580200,
    "address": "131 Sewall Ave, Unit 55",
    "parcel_id": "125-07-38",
    "owner1": "SHANG, JOHN",
    "owner2": "WU, JANE",
    "current_taxes": 5941.25,
    "new_taxes_no_override": 6197.91,
    "override_total_1": 6373.77,
    "override_increase_1": 175.86
  },
  {
    "#": "131 Sewall Ave, Unit 56 (125-07-39)",
    "$": 704900,
    "address": "131 Sewall Ave, Unit 56",
    "parcel_id": "125-07-39",
    "owner1": "BOTVINNIK TRS, GALINA",
    "owner2": "",
    "current_taxes": 3583.24,
    "new_taxes_no_override": 3738.04,
    "override_total_1": 3844.1,
    "override_increase_1": 106.06
  },
  {
    "#": "131 Sewall Ave, Unit 57 (125-07-40)",
    "$": 1047700,
    "address": "131 Sewall Ave, Unit 57",
    "parcel_id": "125-07-40",
    "owner1": "STIFLER LEGACY PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 10728.45,
    "new_taxes_no_override": 11191.92,
    "override_total_1": 11509.48,
    "override_increase_1": 317.56
  },
  {
    "#": "131 Sewall Ave, Unit 6 (125-07-04)",
    "$": 595800,
    "address": "131 Sewall Ave, Unit 6",
    "parcel_id": "125-07-04",
    "owner1": "TAO, YING",
    "owner2": "LACKNER, FRANK J",
    "current_taxes": 6100.99,
    "new_taxes_no_override": 6364.55,
    "override_total_1": 6545.14,
    "override_increase_1": 180.59
  },
  {
    "#": "131 Sewall Ave, Unit 61 (125-07-41)",
    "$": 1166900,
    "address": "131 Sewall Ave, Unit 61",
    "parcel_id": "125-07-41",
    "owner1": "SHULKIN TR, SVETLANA",
    "owner2": "",
    "current_taxes": 11949.06,
    "new_taxes_no_override": 12465.26,
    "override_total_1": 12818.95,
    "override_increase_1": 353.69
  },
  {
    "#": "131 Sewall Ave, Unit 62 (125-07-42)",
    "$": 547800,
    "address": "131 Sewall Ave, Unit 62",
    "parcel_id": "125-07-42",
    "owner1": "LITWAK, TOVA G & MARY E",
    "owner2": "C/O LITWAK, MARY",
    "current_taxes": 1974.54,
    "new_taxes_no_override": 2059.84,
    "override_total_1": 2118.29,
    "override_increase_1": 58.45
  },
  {
    "#": "131 Sewall Ave, Unit 63 (125-07-43)",
    "$": 1124900,
    "address": "131 Sewall Ave, Unit 63",
    "parcel_id": "125-07-43",
    "owner1": "REINHARZ TRS, JEHUDA & SHULAMIT",
    "owner2": "",
    "current_taxes": 11518.98,
    "new_taxes_no_override": 12016.6,
    "override_total_1": 12357.56,
    "override_increase_1": 340.96
  },
  {
    "#": "131 Sewall Ave, Unit 64 (125-07-44)",
    "$": 748000,
    "address": "131 Sewall Ave, Unit 64",
    "parcel_id": "125-07-44",
    "owner1": "KRUMHOLZ, SANDRA",
    "owner2": "",
    "current_taxes": 4024.59,
    "new_taxes_no_override": 4198.45,
    "override_total_1": 4317.58,
    "override_increase_1": 119.13
  },
  {
    "#": "131 Sewall Ave, Unit 65 (125-07-45)",
    "$": 625100,
    "address": "131 Sewall Ave, Unit 65",
    "parcel_id": "125-07-45",
    "owner1": "TSA MANAGEMENT LLC",
    "owner2": "",
    "current_taxes": 6401.02,
    "new_taxes_no_override": 6677.54,
    "override_total_1": 6867.01,
    "override_increase_1": 189.47
  },
  {
    "#": "131 Sewall Ave, Unit 66 (125-07-46)",
    "$": 833200,
    "address": "131 Sewall Ave, Unit 66",
    "parcel_id": "125-07-46",
    "owner1": "GOODSTEIN TR, HINDA DIANE",
    "owner2": "",
    "current_taxes": 4897.03,
    "new_taxes_no_override": 5108.58,
    "override_total_1": 5253.53,
    "override_increase_1": 144.95
  },
  {
    "#": "131 Sewall Ave, Unit 67 (125-07-47)",
    "$": 1320200,
    "address": "131 Sewall Ave, Unit 67",
    "parcel_id": "125-07-47",
    "owner1": "MCKENNA, LAWRENCE W",
    "owner2": "GRADMAN, SANDRA",
    "current_taxes": 9883.91,
    "new_taxes_no_override": 10310.89,
    "override_total_1": 10603.46,
    "override_increase_1": 292.56
  },
  {
    "#": "131 Sewall Ave, Unit 7 (125-07-05)",
    "$": 621300,
    "address": "131 Sewall Ave, Unit 7",
    "parcel_id": "125-07-05",
    "owner1": "WAN, LING",
    "owner2": "",
    "current_taxes": 6362.11,
    "new_taxes_no_override": 6636.95,
    "override_total_1": 6825.27,
    "override_increase_1": 188.32
  },
  {
    "#": "131 Sewall Ave, Unit 71 (125-07-48)",
    "$": 1795900,
    "address": "131 Sewall Ave, Unit 71",
    "parcel_id": "125-07-48",
    "owner1": "REINHARZ TRS, JEHUDA & SHULAMIT",
    "owner2": "",
    "current_taxes": 18390.02,
    "new_taxes_no_override": 19184.47,
    "override_total_1": 19728.81,
    "override_increase_1": 544.34
  },
  {
    "#": "131 Sewall Ave, Unit 72 (125-07-49)",
    "$": 2016300,
    "address": "131 Sewall Ave, Unit 72",
    "parcel_id": "125-07-49",
    "owner1": "MEANEY TR, PATRICIA L",
    "owner2": "",
    "current_taxes": 17011.98,
    "new_taxes_no_override": 17746.9,
    "override_total_1": 18250.45,
    "override_increase_1": 503.55
  },
  {
    "#": "131 Sewall Ave, Unit 8 (125-07-06)",
    "$": 722400,
    "address": "131 Sewall Ave, Unit 8",
    "parcel_id": "125-07-06",
    "owner1": "VENNA, NAGAGOPAL & USHARANI",
    "owner2": "",
    "current_taxes": 7397.38,
    "new_taxes_no_override": 7716.95,
    "override_total_1": 7935.91,
    "override_increase_1": 218.96
  },
  {
    "#": "131 Sewall Ave, Unit 9 (125-07-07)",
    "$": 897600,
    "address": "131 Sewall Ave, Unit 9",
    "parcel_id": "125-07-07",
    "owner1": "VENNA, NAGAGOPAL & USHARANI V",
    "owner2": "",
    "current_taxes": 5556.49,
    "new_taxes_no_override": 5796.53,
    "override_total_1": 5961.0,
    "override_increase_1": 164.47
  },
  {
    "#": "132 Sewall Ave, Unit 132A & P26 (124-25-01)",
    "$": 1215200,
    "address": "132 Sewall Ave, Unit 132A & P26",
    "parcel_id": "124-25-01",
    "owner1": "EPSTEIN, CHARLES B",
    "owner2": "BENSUSSEN, MELIA",
    "current_taxes": 8808.71,
    "new_taxes_no_override": 9189.25,
    "override_total_1": 9449.98,
    "override_increase_1": 260.74
  },
  {
    "#": "132 Sewall Ave, Unit 132B & P10 (124-25-02)",
    "$": 1389000,
    "address": "132 Sewall Ave, Unit 132B & P10",
    "parcel_id": "124-25-02",
    "owner1": "GALLI LLC",
    "owner2": "",
    "current_taxes": 14223.36,
    "new_taxes_no_override": 14837.81,
    "override_total_1": 15258.82,
    "override_increase_1": 421.01
  },
  {
    "#": "132 Sewall Ave, Unit 132C & P25 (124-25-03)",
    "$": 1408600,
    "address": "132 Sewall Ave, Unit 132C & P25",
    "parcel_id": "124-25-03",
    "owner1": "OAKBROOK SIDE LLC",
    "owner2": "",
    "current_taxes": 14424.06,
    "new_taxes_no_override": 15047.18,
    "override_total_1": 15474.13,
    "override_increase_1": 426.95
  },
  {
    "#": "134 Sewall Ave, Unit 134A & P13 (124-24-01)",
    "$": 1344900,
    "address": "134 Sewall Ave, Unit 134A & P13",
    "parcel_id": "124-24-01",
    "owner1": "TREITLER TR, ELIZABETH WIJKMAN",
    "owner2": "",
    "current_taxes": 13771.78,
    "new_taxes_no_override": 14366.72,
    "override_total_1": 14774.37,
    "override_increase_1": 407.64
  },
  {
    "#": "134 Sewall Ave, Unit 134B & P15 (124-24-02)",
    "$": 1428800,
    "address": "134 Sewall Ave, Unit 134B & P15",
    "parcel_id": "124-24-02",
    "owner1": "LUCACCINI, STEVEN M",
    "owner2": "RASHID, FAUZIA",
    "current_taxes": 10995.98,
    "new_taxes_no_override": 11471.01,
    "override_total_1": 11796.49,
    "override_increase_1": 325.48
  },
  {
    "#": "134 Sewall Ave, Unit 134C & P26 (124-24-03)",
    "$": 1408600,
    "address": "134 Sewall Ave, Unit 134C & P26",
    "parcel_id": "124-24-03",
    "owner1": "GHOSH, SHOMIR",
    "owner2": "MCCARTY, CATHERINE MAR",
    "current_taxes": 10789.13,
    "new_taxes_no_override": 11255.22,
    "override_total_1": 11574.58,
    "override_increase_1": 319.36
  },
  {
    "#": "137 Sewall Ave, Unit 1 (125-08-16)",
    "$": 641400,
    "address": "137 Sewall Ave, Unit 1",
    "parcel_id": "125-08-16",
    "owner1": "CHIN, KIMBERLY M",
    "owner2": "",
    "current_taxes": 6567.94,
    "new_taxes_no_override": 6851.68,
    "override_total_1": 7046.09,
    "override_increase_1": 194.41
  },
  {
    "#": "137 Sewall Ave, Unit 2 (125-08-01)",
    "$": 2015500,
    "address": "137 Sewall Ave, Unit 2",
    "parcel_id": "125-08-01",
    "owner1": "CONNOR, JOHN J & MARY K",
    "owner2": "",
    "current_taxes": 20638.72,
    "new_taxes_no_override": 21530.31,
    "override_total_1": 22141.22,
    "override_increase_1": 610.91
  },
  {
    "#": "137 Sewall Ave, Unit 3 (125-08-02)",
    "$": 1515300,
    "address": "137 Sewall Ave, Unit 3",
    "parcel_id": "125-08-02",
    "owner1": "SIEGEL, WENDY SCHNEIER & YAKIR",
    "owner2": "",
    "current_taxes": 11881.74,
    "new_taxes_no_override": 12395.03,
    "override_total_1": 12746.73,
    "override_increase_1": 351.7
  },
  {
    "#": "137 Sewall Ave, Unit 4 & P23 (125-08-03)",
    "$": 1551700,
    "address": "137 Sewall Ave, Unit 4 & P23",
    "parcel_id": "125-08-03",
    "owner1": "DOLINSKY, SERGEY & OLGA",
    "owner2": "",
    "current_taxes": 12254.47,
    "new_taxes_no_override": 12783.86,
    "override_total_1": 13146.6,
    "override_increase_1": 362.73
  },
  {
    "#": "138 Sewall Ave, Unit 138A & P19 (124-23-01)",
    "$": 1315900,
    "address": "138 Sewall Ave, Unit 138A & P19",
    "parcel_id": "124-23-01",
    "owner1": "OSSAR, JACOB N & MARY F L",
    "owner2": "",
    "current_taxes": 9839.88,
    "new_taxes_no_override": 10264.96,
    "override_total_1": 10556.22,
    "override_increase_1": 291.26
  },
  {
    "#": "138 Sewall Ave, Unit 138B & P4 (124-23-02)",
    "$": 1416100,
    "address": "138 Sewall Ave, Unit 138B & P4",
    "parcel_id": "124-23-02",
    "owner1": "WOY, J RICHARD & JEAN L",
    "owner2": "",
    "current_taxes": 10865.93,
    "new_taxes_no_override": 11335.34,
    "override_total_1": 11656.97,
    "override_increase_1": 321.63
  },
  {
    "#": "138 Sewall Ave, Unit 138C & P17 (124-23-03)",
    "$": 1460400,
    "address": "138 Sewall Ave, Unit 138C & P17",
    "parcel_id": "124-23-03",
    "owner1": "WHYTE, DENNIS G & SANDRA L",
    "owner2": "",
    "current_taxes": 11319.56,
    "new_taxes_no_override": 11808.56,
    "override_total_1": 12143.62,
    "override_increase_1": 335.06
  },
  {
    "#": "140 Sewall Ave, Unit 140A & P7 (124-22-01)",
    "$": 1440700,
    "address": "140 Sewall Ave, Unit 140A & P7",
    "parcel_id": "124-22-01",
    "owner1": "GILMAN TR, JANE CHENEY",
    "owner2": "",
    "current_taxes": 11117.83,
    "new_taxes_no_override": 11598.12,
    "override_total_1": 11927.21,
    "override_increase_1": 329.09
  },
  {
    "#": "140 Sewall Ave, Unit 140B & P20 (124-22-02)",
    "$": 1672400,
    "address": "140 Sewall Ave, Unit 140B & P20",
    "parcel_id": "124-22-02",
    "owner1": "BLACKMAN, RONALD K",
    "owner2": "HOPE, KATHERINE A",
    "current_taxes": 13490.44,
    "new_taxes_no_override": 14073.23,
    "override_total_1": 14472.54,
    "override_increase_1": 399.32
  },
  {
    "#": "140 Sewall Ave, Unit 140C & P5 (124-22-03)",
    "$": 1680300,
    "address": "140 Sewall Ave, Unit 140C & P5",
    "parcel_id": "124-22-03",
    "owner1": "HAVERTY TRS, CHARLES F III",
    "owner2": "GLUCKSMANN, ALEXANDRA",
    "current_taxes": 13571.34,
    "new_taxes_no_override": 14157.62,
    "override_total_1": 14559.33,
    "override_increase_1": 401.71
  },
  {
    "#": "154 Sewall Ave (123-11-00)",
    "$": 2796600,
    "address": "154 Sewall Ave",
    "parcel_id": "123-11-00",
    "owner1": "WEINER, TRS, J H",
    "owner2": "",
    "current_taxes": 28637.18,
    "new_taxes_no_override": 29874.31,
    "override_total_1": 30721.97,
    "override_increase_1": 847.66
  },
  {
    "#": "155 Sewall Ave (122-05-02)",
    "$": 2873100,
    "address": "155 Sewall Ave",
    "parcel_id": "122-05-02",
    "owner1": "BERGER TR, PAMELA",
    "owner2": "",
    "current_taxes": 29420.54,
    "new_taxes_no_override": 30691.51,
    "override_total_1": 31562.36,
    "override_increase_1": 870.85
  },
  {
    "#": "160 Sewall Ave (123-10-00)",
    "$": 3245300,
    "address": "160 Sewall Ave",
    "parcel_id": "123-10-00",
    "owner1": "MACLEAN TRS, THEODORE E",
    "owner2": "LIAUTAUD TRS, JOANNE M",
    "current_taxes": 29596.94,
    "new_taxes_no_override": 30875.53,
    "override_total_1": 31751.6,
    "override_increase_1": 876.07
  },
  {
    "#": "161 Sewall Ave (122-06-00)",
    "$": 3020800,
    "address": "161 Sewall Ave",
    "parcel_id": "122-06-00",
    "owner1": "ALPER TRS, JON",
    "owner2": "",
    "current_taxes": 27298.06,
    "new_taxes_no_override": 28477.34,
    "override_total_1": 29285.36,
    "override_increase_1": 808.02
  },
  {
    "#": "6 Shailer St, Unit 1 (082-26-01)",
    "$": 1228700,
    "address": "6 Shailer St, Unit 1",
    "parcel_id": "082-26-01",
    "owner1": "GUO, YAZHI",
    "owner2": "HE, TAO",
    "current_taxes": 8946.95,
    "new_taxes_no_override": 9333.46,
    "override_total_1": 9598.29,
    "override_increase_1": 264.83
  },
  {
    "#": "6 Shailer St, Unit 2 (082-26-02)",
    "$": 1190500,
    "address": "6 Shailer St, Unit 2",
    "parcel_id": "082-26-02",
    "owner1": "6 SHAILER STREET LLC",
    "owner2": "",
    "current_taxes": 12190.72,
    "new_taxes_no_override": 12717.36,
    "override_total_1": 13078.2,
    "override_increase_1": 360.85
  },
  {
    "#": "6 Shailer St, Unit 3 (082-26-03)",
    "$": 1318400,
    "address": "6 Shailer St, Unit 3",
    "parcel_id": "082-26-03",
    "owner1": "JONEMANN, LORRAINE LOUISE MARIE",
    "owner2": "SILK, TARIK CHRISTOPHER",
    "current_taxes": 9865.48,
    "new_taxes_no_override": 10291.67,
    "override_total_1": 10583.69,
    "override_increase_1": 292.02
  },
  {
    "#": "9 Shailer St (081-04-00)",
    "$": 2325900,
    "address": "9 Shailer St",
    "parcel_id": "081-04-00",
    "owner1": "LEW, STEPHEN & ELIZABETH L",
    "owner2": "",
    "current_taxes": 20182.28,
    "new_taxes_no_override": 21054.15,
    "override_total_1": 21651.55,
    "override_increase_1": 597.4
  },
  {
    "#": "10 Shailer St, Unit 10 (082-25-01)",
    "$": 2326400,
    "address": "10 Shailer St, Unit 10",
    "parcel_id": "082-25-01",
    "owner1": "STAVIS TR, ELIZABETH",
    "owner2": "",
    "current_taxes": 23822.34,
    "new_taxes_no_override": 24851.47,
    "override_total_1": 25556.61,
    "override_increase_1": 705.14
  },
  {
    "#": "10 Shailer St, Unit 12 (082-25-02)",
    "$": 2009300,
    "address": "10 Shailer St, Unit 12",
    "parcel_id": "082-25-02",
    "owner1": "NAVARRO, VANESA ALMENDRO",
    "owner2": "",
    "current_taxes": 20575.23,
    "new_taxes_no_override": 21464.08,
    "override_total_1": 22073.11,
    "override_increase_1": 609.03
  },
  {
    "#": "10 Shailer St, Unit 14 (082-25-03)",
    "$": 1863900,
    "address": "10 Shailer St, Unit 14",
    "parcel_id": "082-25-03",
    "owner1": "SACHER, MATTHEW J & KELLI W",
    "owner2": "",
    "current_taxes": 15451.4,
    "new_taxes_no_override": 16118.9,
    "override_total_1": 16576.26,
    "override_increase_1": 457.36
  },
  {
    "#": "15 Shailer St (081-05-00)",
    "$": 2957800,
    "address": "15 Shailer St",
    "parcel_id": "081-05-00",
    "owner1": "WONG, BRIAN & SUSAN S",
    "owner2": "",
    "current_taxes": 26652.94,
    "new_taxes_no_override": 27804.35,
    "override_total_1": 28593.27,
    "override_increase_1": 788.93
  },
  {
    "#": "19 Shailer St, Unit 2 Pk 1 2 (081-06-01)",
    "$": 1624400,
    "address": "19 Shailer St, Unit 2 Pk 1 2",
    "parcel_id": "081-06-01",
    "owner1": "AULT TRS, STEPHEN K",
    "owner2": "RESNICK, MARGERY",
    "current_taxes": 12998.92,
    "new_taxes_no_override": 13560.47,
    "override_total_1": 13945.24,
    "override_increase_1": 384.77
  },
  {
    "#": "2 Shaw Rd (396-01-00)",
    "$": 1885500,
    "address": "2 Shaw Rd",
    "parcel_id": "396-01-00",
    "owner1": "MENG, XIAO LI",
    "owner2": "ZHONG, WEIMING",
    "current_taxes": 15672.59,
    "new_taxes_no_override": 16349.65,
    "override_total_1": 16813.55,
    "override_increase_1": 463.91
  },
  {
    "#": "5 Shaw Rd (395-01-00)",
    "$": 1476600,
    "address": "5 Shaw Rd",
    "parcel_id": "395-01-00",
    "owner1": "KEYNAN, ERIS H & SHALOM",
    "owner2": "",
    "current_taxes": 11485.45,
    "new_taxes_no_override": 11981.62,
    "override_total_1": 12321.59,
    "override_increase_1": 339.97
  },
  {
    "#": "11 Shaw Rd (395-02-00)",
    "$": 1910500,
    "address": "11 Shaw Rd",
    "parcel_id": "395-02-00",
    "owner1": "NOE TRS, CHRISTOPHER & SHARI",
    "owner2": "",
    "current_taxes": 15928.59,
    "new_taxes_no_override": 16616.71,
    "override_total_1": 17088.19,
    "override_increase_1": 471.49
  },
  {
    "#": "16 Shaw Rd (396-27-00)",
    "$": 1755700,
    "address": "16 Shaw Rd",
    "parcel_id": "396-27-00",
    "owner1": "ROBINOT, BENJAMIN",
    "owner2": "CAVALIE, FANNY C",
    "current_taxes": 14343.43,
    "new_taxes_no_override": 14963.07,
    "override_total_1": 15387.63,
    "override_increase_1": 424.57
  },
  {
    "#": "17 Shaw Rd (395-03-00)",
    "$": 1652000,
    "address": "17 Shaw Rd",
    "parcel_id": "395-03-00",
    "owner1": "17 SHAW ROAD LLC",
    "owner2": "",
    "current_taxes": 16916.48,
    "new_taxes_no_override": 17647.27,
    "override_total_1": 18148.0,
    "override_increase_1": 500.73
  },
  {
    "#": "21 Shaw Rd (395-04-00)",
    "$": 1275100,
    "address": "21 Shaw Rd",
    "parcel_id": "395-04-00",
    "owner1": "REAGAN, JOHN D",
    "owner2": "",
    "current_taxes": 9422.09,
    "new_taxes_no_override": 9829.12,
    "override_total_1": 10108.02,
    "override_increase_1": 278.89
  },
  {
    "#": "24 Shaw Rd (396-26-00)",
    "$": 1775700,
    "address": "24 Shaw Rd",
    "parcel_id": "396-26-00",
    "owner1": "TSITKOVA, ZHANNA",
    "owner2": "TSITKOU, YURY",
    "current_taxes": 14548.23,
    "new_taxes_no_override": 15176.71,
    "override_total_1": 15607.34,
    "override_increase_1": 430.63
  },
  {
    "#": "29 Shaw Rd (395-05-00)",
    "$": 2060500,
    "address": "29 Shaw Rd",
    "parcel_id": "395-05-00",
    "owner1": "FEHNEL, COREY & KATIE",
    "owner2": "",
    "current_taxes": 17464.59,
    "new_taxes_no_override": 18219.06,
    "override_total_1": 18736.01,
    "override_increase_1": 516.95
  },
  {
    "#": "34 Shaw Rd (396-25-00)",
    "$": 3303300,
    "address": "34 Shaw Rd",
    "parcel_id": "396-25-00",
    "owner1": "SEDDIGHZADEH, ALI",
    "owner2": "MIRZAEI, FARIBA",
    "current_taxes": 33825.79,
    "new_taxes_no_override": 35287.06,
    "override_total_1": 36288.31,
    "override_increase_1": 1001.24
  },
  {
    "#": "35 Shaw Rd (395-06-00)",
    "$": 2046300,
    "address": "35 Shaw Rd",
    "parcel_id": "395-06-00",
    "owner1": "YOUN , ROY & JENNY",
    "owner2": "",
    "current_taxes": 17319.18,
    "new_taxes_no_override": 18067.37,
    "override_total_1": 18580.02,
    "override_increase_1": 512.65
  },
  {
    "#": "38 Shaw Rd (396-24-00)",
    "$": 1600500,
    "address": "38 Shaw Rd",
    "parcel_id": "396-24-00",
    "owner1": "VAPPI, CAMILLE",
    "owner2": "SANDERS, EREC",
    "current_taxes": 16389.12,
    "new_taxes_no_override": 17097.13,
    "override_total_1": 17582.25,
    "override_increase_1": 485.12
  },
  {
    "#": "43 Shaw Rd (395-07-00)",
    "$": 1517700,
    "address": "43 Shaw Rd",
    "parcel_id": "395-07-00",
    "owner1": "MAGUIRE TRS, MARGARET",
    "owner2": "SOLVERSON , JAMES",
    "current_taxes": 11906.31,
    "new_taxes_no_override": 12420.66,
    "override_total_1": 12773.09,
    "override_increase_1": 352.43
  },
  {
    "#": "46 Shaw Rd (396-23-00)",
    "$": 1990500,
    "address": "46 Shaw Rd",
    "parcel_id": "396-23-00",
    "owner1": "HASSENSTEIN, CASEY & CARL HERMANN",
    "owner2": "",
    "current_taxes": 16747.79,
    "new_taxes_no_override": 17471.29,
    "override_total_1": 17967.03,
    "override_increase_1": 495.73
  },
  {
    "#": "47 Shaw Rd (395-08-00)",
    "$": 2745300,
    "address": "47 Shaw Rd",
    "parcel_id": "395-08-00",
    "owner1": "GESZPENC, LEON",
    "owner2": "",
    "current_taxes": 24476.94,
    "new_taxes_no_override": 25534.34,
    "override_total_1": 26258.86,
    "override_increase_1": 724.52
  },
  {
    "#": "54 Shaw Rd (396-22-00)",
    "$": 2012200,
    "address": "54 Shaw Rd",
    "parcel_id": "396-22-00",
    "owner1": "BERG, DAVID DOUGLAS",
    "owner2": "CROMBIE, JENNIFER LEIGH",
    "current_taxes": 16969.99,
    "new_taxes_no_override": 17703.09,
    "override_total_1": 18205.41,
    "override_increase_1": 502.31
  },
  {
    "#": "55 Shaw Rd (395-09-00)",
    "$": 2376900,
    "address": "55 Shaw Rd",
    "parcel_id": "395-09-00",
    "owner1": "RANGEL, SHAWN J & ERIKA",
    "owner2": "",
    "current_taxes": 20704.52,
    "new_taxes_no_override": 21598.96,
    "override_total_1": 22211.81,
    "override_increase_1": 612.85
  },
  {
    "#": "60 Shaw Rd (396-21-00)",
    "$": 1768100,
    "address": "60 Shaw Rd",
    "parcel_id": "396-21-00",
    "owner1": "MANKE, MATTHEW L",
    "owner2": "RANKIN, CHRISTINE",
    "current_taxes": 14470.41,
    "new_taxes_no_override": 15095.53,
    "override_total_1": 15523.86,
    "override_increase_1": 428.32
  },
  {
    "#": "61 Shaw Rd (395-10-00)",
    "$": 2159000,
    "address": "61 Shaw Rd",
    "parcel_id": "395-10-00",
    "owner1": "MAKALUSKY, JOSEPH M",
    "owner2": "LEE, GRACE H",
    "current_taxes": 18473.23,
    "new_taxes_no_override": 19271.27,
    "override_total_1": 19818.08,
    "override_increase_1": 546.81
  },
  {
    "#": "67 Shaw Rd (395-11-00)",
    "$": 2591600,
    "address": "67 Shaw Rd",
    "parcel_id": "395-11-00",
    "owner1": "MAMBRINO TRS, LAWRENCE J & DEBRA A SIMIONE",
    "owner2": "",
    "current_taxes": 22903.05,
    "new_taxes_no_override": 23892.46,
    "override_total_1": 24570.39,
    "override_increase_1": 677.93
  },
  {
    "#": "70 Shaw Rd (396-20-00)",
    "$": 2398400,
    "address": "70 Shaw Rd",
    "parcel_id": "396-20-00",
    "owner1": "PHILIP, JAMES H & BEVERLY K",
    "owner2": "",
    "current_taxes": 20924.68,
    "new_taxes_no_override": 21828.63,
    "override_total_1": 22448.0,
    "override_increase_1": 619.37
  },
  {
    "#": "75 Shaw Rd (395-12-00)",
    "$": 2086500,
    "address": "75 Shaw Rd",
    "parcel_id": "395-12-00",
    "owner1": "OKEN, EMILY",
    "owner2": "UKOMADU, CHINWEIKE",
    "current_taxes": 17730.83,
    "new_taxes_no_override": 18496.8,
    "override_total_1": 19021.63,
    "override_increase_1": 524.83
  },
  {
    "#": "78 Shaw Rd (396-19-00)",
    "$": 2823400,
    "address": "78 Shaw Rd",
    "parcel_id": "396-19-00",
    "owner1": "TWORETZKY, WAYNE",
    "owner2": "LIGHTDALE, JENIFER R",
    "current_taxes": 28911.62,
    "new_taxes_no_override": 30160.6,
    "override_total_1": 31016.39,
    "override_increase_1": 855.78
  },
  {
    "#": "83 Shaw Rd (395-13-00)",
    "$": 1920700,
    "address": "83 Shaw Rd",
    "parcel_id": "395-13-00",
    "owner1": "GOTTLIEB TRS, ROBERT M",
    "owner2": "ROSENBACH, MARGO L",
    "current_taxes": 16033.03,
    "new_taxes_no_override": 16725.66,
    "override_total_1": 17200.23,
    "override_increase_1": 474.58
  },
  {
    "#": "86 Shaw Rd (396-18-00)",
    "$": 3800000,
    "address": "86 Shaw Rd",
    "parcel_id": "396-18-00",
    "owner1": "FREED, NANCY A",
    "owner2": "",
    "current_taxes": 35277.07,
    "new_taxes_no_override": 36801.04,
    "override_total_1": 37845.24,
    "override_increase_1": 1044.2
  },
  {
    "#": "90 Shaw Rd (396-15-00)",
    "$": 107200,
    "address": "90 Shaw Rd",
    "parcel_id": "396-15-00",
    "owner1": "KRYZANSKI, JAMES T",
    "owner2": "KATHERINE, P C",
    "current_taxes": 1097.73,
    "new_taxes_no_override": 1145.15,
    "override_total_1": 1177.64,
    "override_increase_1": 32.49
  },
  {
    "#": "91 Shaw Rd (395-14-00)",
    "$": 2320100,
    "address": "91 Shaw Rd",
    "parcel_id": "395-14-00",
    "owner1": "BENAVIDEZ, OSCAR J",
    "owner2": "TAVERAS, ELSIE M",
    "current_taxes": 20122.89,
    "new_taxes_no_override": 20992.2,
    "override_total_1": 21587.84,
    "override_increase_1": 595.64
  },
  {
    "#": "94 Shaw Rd (396-17-00)",
    "$": 2566500,
    "address": "94 Shaw Rd",
    "parcel_id": "396-17-00",
    "owner1": "ZENDEJAS-MUMMERT, BENJAMIN",
    "owner2": "ITURRINO MOREDA, JOHANNA C",
    "current_taxes": 22646.03,
    "new_taxes_no_override": 23624.34,
    "override_total_1": 24294.66,
    "override_increase_1": 670.32
  },
  {
    "#": "99 Shaw Rd (395-15-00)",
    "$": 1740300,
    "address": "99 Shaw Rd",
    "parcel_id": "395-15-00",
    "owner1": "ARNAOUT, M AMIN & AMAL K",
    "owner2": "",
    "current_taxes": 14185.74,
    "new_taxes_no_override": 14798.56,
    "override_total_1": 15218.46,
    "override_increase_1": 419.9
  },
  {
    "#": "100 Shaw Rd (396-16-00)",
    "$": 1626300,
    "address": "100 Shaw Rd",
    "parcel_id": "396-16-00",
    "owner1": "HOE-RICHARDSON, JANE P",
    "owner2": "",
    "current_taxes": 16653.31,
    "new_taxes_no_override": 17372.73,
    "override_total_1": 17865.67,
    "override_increase_1": 492.94
  },
  {
    "#": "107 Shaw Rd (395-16-00)",
    "$": 2325300,
    "address": "107 Shaw Rd",
    "parcel_id": "395-16-00",
    "owner1": "BAHADORI, ALI",
    "owner2": "NOURI, MAHNAZ",
    "current_taxes": 20176.14,
    "new_taxes_no_override": 21047.75,
    "override_total_1": 21644.96,
    "override_increase_1": 597.21
  },
  {
    "#": "117 Shaw Rd (395-17-00)",
    "$": 1514700,
    "address": "117 Shaw Rd",
    "parcel_id": "395-17-00",
    "owner1": "GENIS, DANIEL N & CAROL T",
    "owner2": "",
    "current_taxes": 11875.59,
    "new_taxes_no_override": 12388.62,
    "override_total_1": 12740.13,
    "override_increase_1": 351.52
  },
  {
    "#": "123 Shaw Rd (395-18-20)",
    "$": 2874400,
    "address": "123 Shaw Rd",
    "parcel_id": "395-18-20",
    "owner1": "DEVINE, MICHAEL & JESSICA",
    "owner2": "",
    "current_taxes": 25798.92,
    "new_taxes_no_override": 26913.43,
    "override_total_1": 27677.08,
    "override_increase_1": 763.65
  },
  {
    "#": "133 Shaw Rd (395-19-00)",
    "$": 2420200,
    "address": "133 Shaw Rd",
    "parcel_id": "395-19-00",
    "owner1": "COLEMAN, KENNETH L",
    "owner2": "MORELLI, SUSAN A",
    "current_taxes": 21147.91,
    "new_taxes_no_override": 22061.5,
    "override_total_1": 22687.48,
    "override_increase_1": 625.98
  },
  {
    "#": "140 Shaw Rd (397-13-14)",
    "$": 2336400,
    "address": "140 Shaw Rd",
    "parcel_id": "397-13-14",
    "owner1": "CORCORAN, THOMAS J & MAUREEN P",
    "owner2": "",
    "current_taxes": 20289.8,
    "new_taxes_no_override": 21166.32,
    "override_total_1": 21766.9,
    "override_increase_1": 600.58
  },
  {
    "#": "150 Shaw Rd (400-03-00)",
    "$": 1792900,
    "address": "150 Shaw Rd",
    "parcel_id": "400-03-00",
    "owner1": "LOEB, NANCY H",
    "owner2": "DIDONATO, EUGENE J",
    "current_taxes": 14724.36,
    "new_taxes_no_override": 15360.45,
    "override_total_1": 15796.29,
    "override_increase_1": 435.84
  },
  {
    "#": "151 Shaw Rd (399-62-00)",
    "$": 1783900,
    "address": "151 Shaw Rd",
    "parcel_id": "399-62-00",
    "owner1": "CRAMER, DANIEL W & CHRISTINE R",
    "owner2": "",
    "current_taxes": 14632.2,
    "new_taxes_no_override": 15264.31,
    "override_total_1": 15697.42,
    "override_increase_1": 433.11
  },
  {
    "#": "155 Shaw Rd (399-63-00)",
    "$": 1970300,
    "address": "155 Shaw Rd",
    "parcel_id": "399-63-00",
    "owner1": "SLOTNICK, AMY K & DANIEL J",
    "owner2": "",
    "current_taxes": 16540.94,
    "new_taxes_no_override": 17255.51,
    "override_total_1": 17745.12,
    "override_increase_1": 489.61
  },
  {
    "#": "158 Shaw Rd (400-02-00)",
    "$": 1817300,
    "address": "158 Shaw Rd",
    "parcel_id": "400-02-00",
    "owner1": "GUARDIAN KEY PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 18609.15,
    "new_taxes_no_override": 19413.07,
    "override_total_1": 19963.9,
    "override_increase_1": 550.83
  },
  {
    "#": "161 Shaw Rd (399-64-00)",
    "$": 1673800,
    "address": "161 Shaw Rd",
    "parcel_id": "399-64-00",
    "owner1": "CHIN, CRAIG S",
    "owner2": "YUNG, LILY Y",
    "current_taxes": 13504.78,
    "new_taxes_no_override": 14088.19,
    "override_total_1": 14487.93,
    "override_increase_1": 399.74
  },
  {
    "#": "168 Shaw Rd (400-01-00)",
    "$": 1466100,
    "address": "168 Shaw Rd",
    "parcel_id": "400-01-00",
    "owner1": "LEWIS, PHILIP G & SANDRA G",
    "owner2": "",
    "current_taxes": 11377.93,
    "new_taxes_no_override": 11869.46,
    "override_total_1": 12206.24,
    "override_increase_1": 336.79
  },
  {
    "#": "171 Shaw Rd (399-65-00)",
    "$": 2106900,
    "address": "171 Shaw Rd",
    "parcel_id": "399-65-00",
    "owner1": "JOYNER SHAW LLC",
    "owner2": "",
    "current_taxes": 21574.66,
    "new_taxes_no_override": 22506.69,
    "override_total_1": 23145.3,
    "override_increase_1": 638.61
  },
  {
    "#": "175 Shaw Rd (399-66-00)",
    "$": 1801000,
    "address": "175 Shaw Rd",
    "parcel_id": "399-66-00",
    "owner1": "DEAN, JOHN & JORDAN",
    "owner2": "",
    "current_taxes": 14807.31,
    "new_taxes_no_override": 15446.99,
    "override_total_1": 15885.28,
    "override_increase_1": 438.3
  },
  {
    "#": "8 Sheafe St (428-06-00)",
    "$": 1795000,
    "address": "8 Sheafe St",
    "parcel_id": "428-06-00",
    "owner1": "CH REALTY VENTURES LLC",
    "owner2": "",
    "current_taxes": 18380.8,
    "new_taxes_no_override": 19174.85,
    "override_total_1": 19718.92,
    "override_increase_1": 544.07
  },
  {
    "#": "14 Sheafe St (428-05-00)",
    "$": 2184800,
    "address": "14 Sheafe St",
    "parcel_id": "428-05-00",
    "owner1": "CH REALTY VENTURES LLC",
    "owner2": "",
    "current_taxes": 37491.17,
    "new_taxes_no_override": 39110.79,
    "override_total_1": 40220.53,
    "override_increase_1": 1109.74
  },
  {
    "#": "18 Sheafe St (428-04-00)",
    "$": 1284900,
    "address": "18 Sheafe St",
    "parcel_id": "428-04-00",
    "owner1": "SHEAFE REALTY VENTURES LLC",
    "owner2": "",
    "current_taxes": 13157.38,
    "new_taxes_no_override": 13725.78,
    "override_total_1": 14115.24,
    "override_increase_1": 389.46
  },
  {
    "#": "21 Sheafe St (427-12-00)",
    "$": 1663300,
    "address": "21 Sheafe St",
    "parcel_id": "427-12-00",
    "owner1": "1198-1210 BOYLSTON ST ASSC LLC",
    "owner2": "",
    "current_taxes": 17032.19,
    "new_taxes_no_override": 17767.98,
    "override_total_1": 18272.13,
    "override_increase_1": 504.15
  },
  {
    "#": "22 Sheafe St (428-03-01)",
    "$": 1439600,
    "address": "22 Sheafe St",
    "parcel_id": "428-03-01",
    "owner1": "CURTIN, ELLEN & KATHLEEN A",
    "owner2": "",
    "current_taxes": 11106.57,
    "new_taxes_no_override": 11586.37,
    "override_total_1": 11915.13,
    "override_increase_1": 328.75
  },
  {
    "#": "25 Sheafe St (427-13-00)",
    "$": 1152900,
    "address": "25 Sheafe St",
    "parcel_id": "427-13-00",
    "owner1": "1198-1210 BOYLSTON ST ASSC LLC",
    "owner2": "",
    "current_taxes": 11805.7,
    "new_taxes_no_override": 12315.71,
    "override_total_1": 12665.15,
    "override_increase_1": 349.45
  },
  {
    "#": "26 Sheafe St (428-03-00)",
    "$": 1705200,
    "address": "26 Sheafe St",
    "parcel_id": "428-03-00",
    "owner1": "PAK, TOHYONG",
    "owner2": "CHUNG, CHUNHEE",
    "current_taxes": 17461.25,
    "new_taxes_no_override": 18215.58,
    "override_total_1": 18732.43,
    "override_increase_1": 516.85
  },
  {
    "#": "30 Sheafe St (428-02-02)",
    "$": 1912200,
    "address": "30 Sheafe St",
    "parcel_id": "428-02-02",
    "owner1": "KIM, YOUNSOO",
    "owner2": "KWAK, SUNG JONG",
    "current_taxes": 19580.93,
    "new_taxes_no_override": 20426.83,
    "override_total_1": 21006.42,
    "override_increase_1": 579.6
  },
  {
    "#": "34 Sheafe St, Unit 1 (428-02-03)",
    "$": 863200,
    "address": "34 Sheafe St, Unit 1",
    "parcel_id": "428-02-03",
    "owner1": "YOUR LIVING HERE LLC",
    "owner2": "",
    "current_taxes": 8839.17,
    "new_taxes_no_override": 9221.02,
    "override_total_1": 9482.66,
    "override_increase_1": 261.64
  },
  {
    "#": "34 Sheafe St, Unit 2 (428-02-04)",
    "$": 1084400,
    "address": "34 Sheafe St, Unit 2",
    "parcel_id": "428-02-04",
    "owner1": "WEINTRAUB, ELEANOR",
    "owner2": "",
    "current_taxes": 7469.32,
    "new_taxes_no_override": 7791.99,
    "override_total_1": 8013.09,
    "override_increase_1": 221.09
  },
  {
    "#": "35 Sheafe St (427-15-00)",
    "$": 1353800,
    "address": "35 Sheafe St",
    "parcel_id": "427-15-00",
    "owner1": "MACLEAN , HOWARD & LINDA",
    "owner2": "PIESCO-PUTNAM, JILLIAN",
    "current_taxes": 13862.91,
    "new_taxes_no_override": 14461.79,
    "override_total_1": 14872.13,
    "override_increase_1": 410.34
  },
  {
    "#": "39 Sheafe St (427-16-00)",
    "$": 1717400,
    "address": "39 Sheafe St",
    "parcel_id": "427-16-00",
    "owner1": "HOLLY SHEAFE LLC",
    "owner2": "",
    "current_taxes": 17586.18,
    "new_taxes_no_override": 18345.9,
    "override_total_1": 18866.45,
    "override_increase_1": 520.55
  },
  {
    "#": "41 Sheafe St (427-17-00)",
    "$": 9500,
    "address": "41 Sheafe St",
    "parcel_id": "427-17-00",
    "owner1": "HOLLY SHEAFE LLC",
    "owner2": "",
    "current_taxes": 97.28,
    "new_taxes_no_override": 101.48,
    "override_total_1": 104.36,
    "override_increase_1": 2.88
  },
  {
    "#": "201 Sherman Rd (388B-01-01)",
    "$": 119651580,
    "address": "201 Sherman Rd",
    "parcel_id": "388B-01-01",
    "owner1": "PUDDINGSTONE REALTY LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 1225232.18,
    "new_taxes_no_override": 1278162.21,
    "override_total_1": 1314429.08,
    "override_increase_1": 36266.87
  },
  {
    "#": "6 Sherrin Rd (360-09-00)",
    "$": 1181900,
    "address": "6 Sherrin Rd",
    "parcel_id": "360-09-00",
    "owner1": "HELFEN TRS, SYLVIA",
    "owner2": "WALLACH, CAROL",
    "current_taxes": 8467.72,
    "new_taxes_no_override": 8833.53,
    "override_total_1": 9084.17,
    "override_increase_1": 250.64
  },
  {
    "#": "9 Sherrin Rd (361-16-00)",
    "$": 1550100,
    "address": "9 Sherrin Rd",
    "parcel_id": "361-16-00",
    "owner1": "ZHAI, HELEN HUANWU",
    "owner2": "",
    "current_taxes": 15873.02,
    "new_taxes_no_override": 16558.73,
    "override_total_1": 17028.58,
    "override_increase_1": 469.84
  },
  {
    "#": "10 Sherrin Rd (360-08-00)",
    "$": 1086600,
    "address": "10 Sherrin Rd",
    "parcel_id": "360-08-00",
    "owner1": "GILSON, NANCY",
    "owner2": "",
    "current_taxes": 7491.85,
    "new_taxes_no_override": 7815.5,
    "override_total_1": 8037.26,
    "override_increase_1": 221.76
  },
  {
    "#": "11 Sherrin Rd (361-17-00)",
    "$": 1114900,
    "address": "11 Sherrin Rd",
    "parcel_id": "361-17-00",
    "owner1": "AVRIN TRS, FRANCES M",
    "owner2": "ZAFRAN, MARTIN H",
    "current_taxes": 7781.64,
    "new_taxes_no_override": 8117.81,
    "override_total_1": 8348.14,
    "override_increase_1": 230.34
  },
  {
    "#": "14 Sherrin Rd (360-07-00)",
    "$": 1090100,
    "address": "14 Sherrin Rd",
    "parcel_id": "360-07-00",
    "owner1": "BENITICH, GREGORY& BRIGITTE L BOWEN",
    "owner2": "",
    "current_taxes": 7527.69,
    "new_taxes_no_override": 7852.89,
    "override_total_1": 8075.71,
    "override_increase_1": 222.82
  },
  {
    "#": "15 Sherrin Rd (361-18-00)",
    "$": 1220100,
    "address": "15 Sherrin Rd",
    "parcel_id": "361-18-00",
    "owner1": "WALSH TRS, PATRICIA F  & JOANNE M",
    "owner2": "",
    "current_taxes": 8858.89,
    "new_taxes_no_override": 9241.59,
    "override_total_1": 9503.82,
    "override_increase_1": 262.22
  },
  {
    "#": "19 Sherrin Rd (361-19-00)",
    "$": 1299900,
    "address": "19 Sherrin Rd",
    "parcel_id": "361-19-00",
    "owner1": "HILLMAN TR, KATHERINE S",
    "owner2": "",
    "current_taxes": 9676.04,
    "new_taxes_no_override": 10094.04,
    "override_total_1": 10380.46,
    "override_increase_1": 286.41
  },
  {
    "#": "20 Sherrin Rd (360-06-00)",
    "$": 1084900,
    "address": "20 Sherrin Rd",
    "parcel_id": "360-06-00",
    "owner1": "SPRITZ TRS, CAROL G & SHERMAN M",
    "owner2": "",
    "current_taxes": 7474.44,
    "new_taxes_no_override": 7797.34,
    "override_total_1": 8018.58,
    "override_increase_1": 221.24
  },
  {
    "#": "24 Sherrin Rd (360-05-00)",
    "$": 1741600,
    "address": "24 Sherrin Rd",
    "parcel_id": "360-05-00",
    "owner1": "CHODES, TRS, JOANNA W",
    "owner2": "",
    "current_taxes": 14199.05,
    "new_taxes_no_override": 14812.45,
    "override_total_1": 15232.74,
    "override_increase_1": 420.29
  },
  {
    "#": "25 Sherrin Rd (361-20-00)",
    "$": 1330900,
    "address": "25 Sherrin Rd",
    "parcel_id": "361-20-00",
    "owner1": "BRODSKY, GREGORY J",
    "owner2": "",
    "current_taxes": 9993.48,
    "new_taxes_no_override": 10425.2,
    "override_total_1": 10721.01,
    "override_increase_1": 295.81
  },
  {
    "#": "32 Sherrin Rd (360-03-00)",
    "$": 1408500,
    "address": "32 Sherrin Rd",
    "parcel_id": "360-03-00",
    "owner1": "ARNOLD TRS, GEOFFREY MICHAEL & MEREDITH ANNE",
    "owner2": "",
    "current_taxes": 10788.11,
    "new_taxes_no_override": 11254.16,
    "override_total_1": 11573.48,
    "override_increase_1": 319.33
  },
  {
    "#": "10 Short St (089-34-35)",
    "$": 13163900,
    "address": "10 Short St",
    "parcel_id": "089-34-35",
    "owner1": "BPG SHORT STREET LLC",
    "owner2": "C/O METROPOLITAN PROPERTIES OF AMERICA",
    "current_taxes": 134798.34,
    "new_taxes_no_override": 140621.63,
    "override_total_1": 144611.66,
    "override_increase_1": 3990.03
  },
  {
    "#": "15 Short St, Unit 1 (090-07-19)",
    "$": 581900,
    "address": "15 Short St, Unit 1",
    "parcel_id": "090-07-19",
    "owner1": "MITCHELL, SHANNON R",
    "owner2": "",
    "current_taxes": 2323.72,
    "new_taxes_no_override": 2424.1,
    "override_total_1": 2492.89,
    "override_increase_1": 68.78
  },
  {
    "#": "15 Short St, Unit 2 (090-07-01)",
    "$": 507100,
    "address": "15 Short St, Unit 2",
    "parcel_id": "090-07-01",
    "owner1": "GOTLIB TRS, SANFORD S & LORRAINE B",
    "owner2": "",
    "current_taxes": 5192.7,
    "new_taxes_no_override": 5417.02,
    "override_total_1": 5570.73,
    "override_increase_1": 153.7
  },
  {
    "#": "15 Short St, Unit 3 (090-07-02)",
    "$": 670300,
    "address": "15 Short St, Unit 3",
    "parcel_id": "090-07-02",
    "owner1": "WYKEHAM ROAD LLC",
    "owner2": "",
    "current_taxes": 6863.87,
    "new_taxes_no_override": 7160.39,
    "override_total_1": 7363.56,
    "override_increase_1": 203.17
  },
  {
    "#": "15 Short St, Unit 4 (090-07-03)",
    "$": 599600,
    "address": "15 Short St, Unit 4",
    "parcel_id": "090-07-03",
    "owner1": "GORDON, REBECCA JUDITH",
    "owner2": "",
    "current_taxes": 2504.97,
    "new_taxes_no_override": 2613.18,
    "override_total_1": 2687.33,
    "override_increase_1": 74.15
  },
  {
    "#": "15 Short St, Unit 5 (090-07-04)",
    "$": 572100,
    "address": "15 Short St, Unit 5",
    "parcel_id": "090-07-04",
    "owner1": "CARROLL, JACQUELINE L",
    "owner2": "",
    "current_taxes": 2223.37,
    "new_taxes_no_override": 2319.42,
    "override_total_1": 2385.23,
    "override_increase_1": 65.81
  },
  {
    "#": "15 Short St, Unit 6 (090-07-05)",
    "$": 511900,
    "address": "15 Short St, Unit 6",
    "parcel_id": "090-07-05",
    "owner1": "GUAN, YI",
    "owner2": "",
    "current_taxes": 1606.92,
    "new_taxes_no_override": 1676.34,
    "override_total_1": 1723.9,
    "override_increase_1": 47.56
  },
  {
    "#": "17 Short St, Unit 1 (090-07-06)",
    "$": 814600,
    "address": "17 Short St, Unit 1",
    "parcel_id": "090-07-06",
    "owner1": "GONZALEZ, EDUARDO",
    "owner2": "GAUSS, SUSAN",
    "current_taxes": 4706.57,
    "new_taxes_no_override": 4909.89,
    "override_total_1": 5049.21,
    "override_increase_1": 139.31
  },
  {
    "#": "17 Short St, Unit 2 (090-07-07)",
    "$": 547300,
    "address": "17 Short St, Unit 2",
    "parcel_id": "090-07-07",
    "owner1": "SKLAR, KATHERINE LEMPERT",
    "owner2": "",
    "current_taxes": 5604.35,
    "new_taxes_no_override": 5846.46,
    "override_total_1": 6012.35,
    "override_increase_1": 165.89
  },
  {
    "#": "17 Short St, Unit 3 (090-07-08)",
    "$": 785400,
    "address": "17 Short St, Unit 3",
    "parcel_id": "090-07-08",
    "owner1": "CHOU, WEN-CHI",
    "owner2": "",
    "current_taxes": 4407.56,
    "new_taxes_no_override": 4597.97,
    "override_total_1": 4728.43,
    "override_increase_1": 130.46
  },
  {
    "#": "17 Short St, Unit 4 (090-07-09)",
    "$": 547300,
    "address": "17 Short St, Unit 4",
    "parcel_id": "090-07-09",
    "owner1": "WONG, MEI YUK & JON",
    "owner2": "",
    "current_taxes": 5604.35,
    "new_taxes_no_override": 5846.46,
    "override_total_1": 6012.35,
    "override_increase_1": 165.89
  },
  {
    "#": "17 Short St, Unit 5 (090-07-10)",
    "$": 785400,
    "address": "17 Short St, Unit 5",
    "parcel_id": "090-07-10",
    "owner1": "KASSELL TR, NANCY",
    "owner2": "",
    "current_taxes": 4407.56,
    "new_taxes_no_override": 4597.97,
    "override_total_1": 4728.43,
    "override_increase_1": 130.46
  },
  {
    "#": "17 Short St, Unit 6 (090-07-11)",
    "$": 547300,
    "address": "17 Short St, Unit 6",
    "parcel_id": "090-07-11",
    "owner1": "BARBER, SHELLEY B",
    "owner2": "",
    "current_taxes": 1969.42,
    "new_taxes_no_override": 2054.5,
    "override_total_1": 2112.79,
    "override_increase_1": 58.29
  },
  {
    "#": "19 Short St, Unit 1 (090-07-13)",
    "$": 498300,
    "address": "19 Short St, Unit 1",
    "parcel_id": "090-07-13",
    "owner1": "COLE TR, JOHN W",
    "owner2": "",
    "current_taxes": 5102.59,
    "new_taxes_no_override": 5323.02,
    "override_total_1": 5474.06,
    "override_increase_1": 151.04
  },
  {
    "#": "19 Short St, Unit 2 (090-07-14)",
    "$": 613200,
    "address": "19 Short St, Unit 2",
    "parcel_id": "090-07-14",
    "owner1": "WONG, WAI SIN & MEI Y",
    "owner2": "",
    "current_taxes": 6279.17,
    "new_taxes_no_override": 6550.43,
    "override_total_1": 6736.29,
    "override_increase_1": 185.86
  },
  {
    "#": "19 Short St, Unit 3 (090-07-15)",
    "$": 474600,
    "address": "19 Short St, Unit 3",
    "parcel_id": "090-07-15",
    "owner1": "LANTSMAN, DAVID",
    "owner2": "",
    "current_taxes": 1224.97,
    "new_taxes_no_override": 1277.89,
    "override_total_1": 1314.15,
    "override_increase_1": 36.26
  },
  {
    "#": "19 Short St, Unit 4 (090-07-16)",
    "$": 621400,
    "address": "19 Short St, Unit 4",
    "parcel_id": "090-07-16",
    "owner1": "RAHMAN, SYED",
    "owner2": "",
    "current_taxes": 6363.14,
    "new_taxes_no_override": 6638.03,
    "override_total_1": 6826.38,
    "override_increase_1": 188.35
  },
  {
    "#": "19 Short St, Unit 5 (090-07-17)",
    "$": 507900,
    "address": "19 Short St, Unit 5",
    "parcel_id": "090-07-17",
    "owner1": "BOLDEWSKUL, VICTOR & SVETLANA",
    "owner2": "",
    "current_taxes": 5200.9,
    "new_taxes_no_override": 5425.58,
    "override_total_1": 5579.53,
    "override_increase_1": 153.95
  },
  {
    "#": "19 Short St, Unit 6 (090-07-18)",
    "$": 631600,
    "address": "19 Short St, Unit 6",
    "parcel_id": "090-07-18",
    "owner1": "XIAO, RUIQING",
    "owner2": "OUYANG, QIHUI",
    "current_taxes": 6467.58,
    "new_taxes_no_override": 6746.98,
    "override_total_1": 6938.42,
    "override_increase_1": 191.44
  },
  {
    "#": "19 Short St, Unit B (090-07-12)",
    "$": 512000,
    "address": "19 Short St, Unit B",
    "parcel_id": "090-07-12",
    "owner1": "LIU, CAISHENG",
    "owner2": "",
    "current_taxes": 5242.88,
    "new_taxes_no_override": 5469.37,
    "override_total_1": 5624.56,
    "override_increase_1": 155.19
  },
  {
    "#": "8 Singletree Rd (437-56-00)",
    "$": 8152000,
    "address": "8 Singletree Rd",
    "parcel_id": "437-56-00",
    "owner1": "MANKODI, HIREN V",
    "owner2": "KAPOOR, DEVIKA",
    "current_taxes": 79841.55,
    "new_taxes_no_override": 83290.7,
    "override_total_1": 85654.01,
    "override_increase_1": 2363.31
  },
  {
    "#": "9 Singletree Rd (437-45-00)",
    "$": 5279400,
    "address": "9 Singletree Rd",
    "parcel_id": "437-45-00",
    "owner1": "KATZ, YORAM & SHARON",
    "owner2": "",
    "current_taxes": 50426.12,
    "new_taxes_no_override": 52604.53,
    "override_total_1": 54097.14,
    "override_increase_1": 1492.61
  },
  {
    "#": "35 Singletree Rd (437-46-00)",
    "$": 7227200,
    "address": "35 Singletree Rd",
    "parcel_id": "437-46-00",
    "owner1": "SMART TR, GILDA M",
    "owner2": "",
    "current_taxes": 70371.59,
    "new_taxes_no_override": 73411.64,
    "override_total_1": 75494.64,
    "override_increase_1": 2083.0
  },
  {
    "#": "40 Singletree Rd (437-52-00)",
    "$": 9982100,
    "address": "40 Singletree Rd",
    "parcel_id": "437-52-00",
    "owner1": "BINDER, BRANT C",
    "owner2": "",
    "current_taxes": 98581.77,
    "new_taxes_no_override": 102840.5,
    "override_total_1": 105758.52,
    "override_increase_1": 2918.02
  },
  {
    "#": "45 Singletree Rd (437-47-01)",
    "$": 4478500,
    "address": "45 Singletree Rd",
    "parcel_id": "437-47-01",
    "owner1": "45 SINGLETREE LLC",
    "owner2": "",
    "current_taxes": 45859.84,
    "new_taxes_no_override": 47840.99,
    "override_total_1": 49198.44,
    "override_increase_1": 1357.45
  },
  {
    "#": "55 Singletree Rd (437-50-51)",
    "$": 19275300,
    "address": "55 Singletree Rd",
    "parcel_id": "437-50-51",
    "owner1": "R FAMILY HOUSE LLC",
    "owner2": "C/O STEPTOE & JOHNSON - BETH TRACTENBERG",
    "current_taxes": 197379.07,
    "new_taxes_no_override": 205905.85,
    "override_total_1": 211748.27,
    "override_increase_1": 5842.42
  },
  {
    "#": "5 Smythe St (187-06-01)",
    "$": 2097700,
    "address": "5 Smythe St",
    "parcel_id": "187-06-01",
    "owner1": "BRYANT LLC",
    "owner2": "",
    "current_taxes": 21480.45,
    "new_taxes_no_override": 22408.41,
    "override_total_1": 23044.23,
    "override_increase_1": 635.82
  },
  {
    "#": "6 Smythe St (188-03-00)",
    "$": 1771300,
    "address": "6 Smythe St",
    "parcel_id": "188-03-00",
    "owner1": "DSG PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 18138.11,
    "new_taxes_no_override": 18921.68,
    "override_total_1": 19458.56,
    "override_increase_1": 536.89
  },
  {
    "#": "7 Smythe St, Unit A (187-07-00)",
    "$": 2653000,
    "address": "7 Smythe St, Unit A",
    "parcel_id": "187-07-00",
    "owner1": "7 SMYTHE ST LLC",
    "owner2": "",
    "current_taxes": 27166.72,
    "new_taxes_no_override": 28340.32,
    "override_total_1": 29144.46,
    "override_increase_1": 804.13
  },
  {
    "#": "10 Smythe St (188-02-00)",
    "$": 1230000,
    "address": "10 Smythe St",
    "parcel_id": "188-02-00",
    "owner1": "JOSHI TR, SHUBH R",
    "owner2": "C/O BAIJ JOSHI",
    "current_taxes": 12595.2,
    "new_taxes_no_override": 13139.31,
    "override_total_1": 13512.13,
    "override_increase_1": 372.82
  },
  {
    "#": "14 Smythe St (188-01-00)",
    "$": 1560300,
    "address": "14 Smythe St",
    "parcel_id": "188-01-00",
    "owner1": "FERNANDO TR, GAIL PARUNGAO",
    "owner2": "",
    "current_taxes": 15977.47,
    "new_taxes_no_override": 16667.7,
    "override_total_1": 17140.63,
    "override_increase_1": 472.93
  },
  {
    "#": "1 Somerset Rd (207-01-00)",
    "$": 2550100,
    "address": "1 Somerset Rd",
    "parcel_id": "207-01-00",
    "owner1": "LEAVENWORTH, NICOLE ELIZABETH",
    "owner2": "",
    "current_taxes": 22478.09,
    "new_taxes_no_override": 23449.14,
    "override_total_1": 24114.49,
    "override_increase_1": 665.35
  },
  {
    "#": "9 Somerset Rd (207-02-00)",
    "$": 3632400,
    "address": "9 Somerset Rd",
    "parcel_id": "207-02-00",
    "owner1": "ROSS, MATHILDE & ROBERT WATERS",
    "owner2": "",
    "current_taxes": 33560.84,
    "new_taxes_no_override": 35010.67,
    "override_total_1": 36004.07,
    "override_increase_1": 993.4
  },
  {
    "#": "14 Somerset Rd (206-15-00)",
    "$": 2246200,
    "address": "14 Somerset Rd",
    "parcel_id": "206-15-00",
    "owner1": "HERCE, MIGUEL A",
    "owner2": "HAGIWARA, MIWAKO",
    "current_taxes": 19366.15,
    "new_taxes_no_override": 20202.77,
    "override_total_1": 20776.01,
    "override_increase_1": 573.24
  },
  {
    "#": "18 Somerset Rd (206-14-00)",
    "$": 3080600,
    "address": "18 Somerset Rd",
    "parcel_id": "206-14-00",
    "owner1": "LANG TRS, HANA & DAN H",
    "owner2": "",
    "current_taxes": 27910.41,
    "new_taxes_no_override": 29116.14,
    "override_total_1": 29942.29,
    "override_increase_1": 826.15
  },
  {
    "#": "21 Somerset Rd (208-11-00)",
    "$": 2391700,
    "address": "21 Somerset Rd",
    "parcel_id": "208-11-00",
    "owner1": "JACARD, SONIA M",
    "owner2": "",
    "current_taxes": 20856.07,
    "new_taxes_no_override": 21757.05,
    "override_total_1": 22374.39,
    "override_increase_1": 617.34
  },
  {
    "#": "24 Somerset Rd (206-13-00)",
    "$": 2640200,
    "address": "24 Somerset Rd",
    "parcel_id": "206-13-00",
    "owner1": "BOTT, ANDREW",
    "owner2": "VACCHER, MANJU",
    "current_taxes": 23400.71,
    "new_taxes_no_override": 24411.62,
    "override_total_1": 25104.28,
    "override_increase_1": 692.66
  },
  {
    "#": "27 Somerset Rd (208-12-00)",
    "$": 2696700,
    "address": "27 Somerset Rd",
    "parcel_id": "208-12-00",
    "owner1": "GARIMELLA, PADMA",
    "owner2": "RAGHAVAN, VIJAYA",
    "current_taxes": 27614.21,
    "new_taxes_no_override": 28807.14,
    "override_total_1": 29624.52,
    "override_increase_1": 817.38
  },
  {
    "#": "28 Somerset Rd (206-12-00)",
    "$": 2490400,
    "address": "28 Somerset Rd",
    "parcel_id": "206-12-00",
    "owner1": "METLAY, JOSHUA P & LINDA C",
    "owner2": "",
    "current_taxes": 21866.76,
    "new_taxes_no_override": 22811.4,
    "override_total_1": 23458.66,
    "override_increase_1": 647.26
  },
  {
    "#": "33 Somerset Rd (208-13-00)",
    "$": 2885300,
    "address": "33 Somerset Rd",
    "parcel_id": "208-13-00",
    "owner1": "TRINQUE, ANNE K & BRIAN C",
    "owner2": "",
    "current_taxes": 25910.54,
    "new_taxes_no_override": 27029.88,
    "override_total_1": 27796.83,
    "override_increase_1": 766.95
  },
  {
    "#": "34 Somerset Rd (206-11-00)",
    "$": 2417500,
    "address": "34 Somerset Rd",
    "parcel_id": "206-11-00",
    "owner1": "SILK TRS, ADAM J & ERICA KIRSNERS",
    "owner2": "",
    "current_taxes": 21120.27,
    "new_taxes_no_override": 22032.67,
    "override_total_1": 22657.83,
    "override_increase_1": 625.16
  },
  {
    "#": "39 Somerset Rd (208-14-00)",
    "$": 2862500,
    "address": "39 Somerset Rd",
    "parcel_id": "208-14-00",
    "owner1": "VAN DER BRUGGE TRS, LAURENS BAS",
    "owner2": "BUZZELL, KENDRA LYNN",
    "current_taxes": 25677.07,
    "new_taxes_no_override": 26786.32,
    "override_total_1": 27546.36,
    "override_increase_1": 760.04
  },
  {
    "#": "40 Somerset Rd (206-10-00)",
    "$": 2796000,
    "address": "40 Somerset Rd",
    "parcel_id": "206-10-00",
    "owner1": "MCCULLOCH, MICHAEL & WHITNEY",
    "owner2": "",
    "current_taxes": 24996.11,
    "new_taxes_no_override": 26075.94,
    "override_total_1": 26815.83,
    "override_increase_1": 739.88
  },
  {
    "#": "43 Somerset Rd (208-15-00)",
    "$": 2645100,
    "address": "43 Somerset Rd",
    "parcel_id": "208-15-00",
    "owner1": "BENEVILLE TRS, MARGARET",
    "owner2": "KROGH, CALVIN",
    "current_taxes": 23450.89,
    "new_taxes_no_override": 24463.97,
    "override_total_1": 25158.11,
    "override_increase_1": 694.15
  },
  {
    "#": "59 Somerset Rd (205A-01-00)",
    "$": 2748600,
    "address": "59 Somerset Rd",
    "parcel_id": "205A-01-00",
    "owner1": "SPRANG, HEIDI NOEL",
    "owner2": "",
    "current_taxes": 24510.73,
    "new_taxes_no_override": 25569.59,
    "override_total_1": 26295.11,
    "override_increase_1": 725.52
  },
  {
    "#": "64 Somerset Rd (205-14-00)",
    "$": 2967800,
    "address": "64 Somerset Rd",
    "parcel_id": "205-14-00",
    "owner1": "BERREBY, PATRICK & SHARON HERMAN",
    "owner2": "",
    "current_taxes": 26755.34,
    "new_taxes_no_override": 27911.17,
    "override_total_1": 28703.13,
    "override_increase_1": 791.96
  },
  {
    "#": "65 Somerset Rd (205A-02-00)",
    "$": 2732600,
    "address": "65 Somerset Rd",
    "parcel_id": "205A-02-00",
    "owner1": "KRAMER, MORDECAI & SHARON",
    "owner2": "",
    "current_taxes": 24346.89,
    "new_taxes_no_override": 25398.68,
    "override_total_1": 26119.34,
    "override_increase_1": 720.67
  },
  {
    "#": "69 Somerset Rd (205A-03-00)",
    "$": 2445900,
    "address": "69 Somerset Rd",
    "parcel_id": "205A-03-00",
    "owner1": "BURKE, MATTHEW M & CATHERINE F",
    "owner2": "",
    "current_taxes": 21411.08,
    "new_taxes_no_override": 22336.04,
    "override_total_1": 22969.81,
    "override_increase_1": 633.77
  },
  {
    "#": "74 Somerset Rd (205-13-00)",
    "$": 2630100,
    "address": "74 Somerset Rd",
    "parcel_id": "205-13-00",
    "owner1": "ELLINOR II, PATRICK T",
    "owner2": "BIRNBAUM, S L",
    "current_taxes": 23297.29,
    "new_taxes_no_override": 24303.73,
    "override_total_1": 24993.33,
    "override_increase_1": 689.6
  },
  {
    "#": "75 Somerset Rd (205A-04-00)",
    "$": 2575100,
    "address": "75 Somerset Rd",
    "parcel_id": "205A-04-00",
    "owner1": "CHATEAUS LLC",
    "owner2": "",
    "current_taxes": 26369.02,
    "new_taxes_no_override": 27508.16,
    "override_total_1": 28288.68,
    "override_increase_1": 780.52
  },
  {
    "#": "79 Somerset Rd (205A-05-00)",
    "$": 2530700,
    "address": "79 Somerset Rd",
    "parcel_id": "205A-05-00",
    "owner1": "KULATILAKA TRS, NALIN & MANJERI",
    "owner2": "",
    "current_taxes": 22279.43,
    "new_taxes_no_override": 23241.9,
    "override_total_1": 23901.37,
    "override_increase_1": 659.47
  },
  {
    "#": "80 Somerset Rd (205-12-00)",
    "$": 2625500,
    "address": "80 Somerset Rd",
    "parcel_id": "205-12-00",
    "owner1": "SMITH TRS, W GARTH",
    "owner2": "KIRWAN, SUSAN E",
    "current_taxes": 23250.19,
    "new_taxes_no_override": 24254.6,
    "override_total_1": 24942.8,
    "override_increase_1": 688.21
  },
  {
    "#": "85 Somerset Rd (205A-06-00)",
    "$": 2477900,
    "address": "85 Somerset Rd",
    "parcel_id": "205A-06-00",
    "owner1": "ALIZADEH, SASSAN & BABAK",
    "owner2": "",
    "current_taxes": 25373.7,
    "new_taxes_no_override": 26469.84,
    "override_total_1": 27220.91,
    "override_increase_1": 751.06
  },
  {
    "#": "86 Somerset Rd (205-11-01)",
    "$": 2375300,
    "address": "86 Somerset Rd",
    "parcel_id": "205-11-01",
    "owner1": "CHAN, TONY P & SU M",
    "owner2": "",
    "current_taxes": 20688.14,
    "new_taxes_no_override": 21581.87,
    "override_total_1": 22194.24,
    "override_increase_1": 612.37
  },
  {
    "#": "91 Somerset Rd (205A-07-00)",
    "$": 2601600,
    "address": "91 Somerset Rd",
    "parcel_id": "205A-07-00",
    "owner1": "ROSE TRS, JOSEF & TALMA",
    "owner2": "",
    "current_taxes": 23005.45,
    "new_taxes_no_override": 23999.29,
    "override_total_1": 24680.25,
    "override_increase_1": 680.96
  },
  {
    "#": "92 Somerset Rd (205-11-00)",
    "$": 2474400,
    "address": "92 Somerset Rd",
    "parcel_id": "205-11-00",
    "owner1": "LEVIN, MICHAEL S & THERESA B",
    "owner2": "",
    "current_taxes": 21702.92,
    "new_taxes_no_override": 22640.49,
    "override_total_1": 23282.89,
    "override_increase_1": 642.41
  },
  {
    "#": "97 Somerset Rd (205A-07-01)",
    "$": 2395800,
    "address": "97 Somerset Rd",
    "parcel_id": "205A-07-01",
    "owner1": "BLECHNER, ZEV C & IRENE E",
    "owner2": "",
    "current_taxes": 20898.06,
    "new_taxes_no_override": 21800.86,
    "override_total_1": 22419.44,
    "override_increase_1": 618.58
  },
  {
    "#": "98 Somerset Rd (205-10-01)",
    "$": 2252300,
    "address": "98 Somerset Rd",
    "parcel_id": "205-10-01",
    "owner1": "STUCHINS, FLORENCE",
    "owner2": "",
    "current_taxes": 19428.62,
    "new_taxes_no_override": 20267.94,
    "override_total_1": 20843.02,
    "override_increase_1": 575.09
  },
  {
    "#": "104 Somerset Rd (205-10-00)",
    "$": 2449300,
    "address": "104 Somerset Rd",
    "parcel_id": "205-10-00",
    "owner1": "TAW TR, FRANCIS W D",
    "owner2": "",
    "current_taxes": 25080.83,
    "new_taxes_no_override": 26164.32,
    "override_total_1": 26906.71,
    "override_increase_1": 742.39
  },
  {
    "#": "108 Somerset Rd (205-09-00)",
    "$": 2454400,
    "address": "108 Somerset Rd",
    "parcel_id": "205-09-00",
    "owner1": "CHIERCHIA, GENNARO",
    "owner2": "",
    "current_taxes": 21498.12,
    "new_taxes_no_override": 22426.84,
    "override_total_1": 23063.18,
    "override_increase_1": 636.34
  },
  {
    "#": "114 Somerset Rd (205-08-00)",
    "$": 2578900,
    "address": "114 Somerset Rd",
    "parcel_id": "205-08-00",
    "owner1": "NG, MAN WAI",
    "owner2": "CHIN, DOUGLAS",
    "current_taxes": 22773.0,
    "new_taxes_no_override": 23756.79,
    "override_total_1": 24430.87,
    "override_increase_1": 674.08
  },
  {
    "#": "2 South St (370-01-00)",
    "$": 4402800,
    "address": "2 South St",
    "parcel_id": "370-01-00",
    "owner1": "HOMSY, FARHAT & KHATOUM F",
    "owner2": "",
    "current_taxes": 41449.74,
    "new_taxes_no_override": 43240.37,
    "override_total_1": 44467.28,
    "override_increase_1": 1226.91
  },
  {
    "#": "5 South St (372-05-00)",
    "$": 2191500,
    "address": "5 South St",
    "parcel_id": "372-05-00",
    "owner1": "KURITNIK, BORIS & ESTHER & ALEXANDER",
    "owner2": "",
    "current_taxes": 18806.03,
    "new_taxes_no_override": 19618.45,
    "override_total_1": 20175.11,
    "override_increase_1": 556.66
  },
  {
    "#": "9 South St (372-06-00)",
    "$": 1532900,
    "address": "9 South St",
    "parcel_id": "372-06-00",
    "owner1": "WOZNIAK, ELIZABETH M",
    "owner2": "",
    "current_taxes": 12061.96,
    "new_taxes_no_override": 12583.04,
    "override_total_1": 12940.07,
    "override_increase_1": 357.03
  },
  {
    "#": "16 South St (369-14-00)",
    "$": 2394400,
    "address": "16 South St",
    "parcel_id": "369-14-00",
    "owner1": "HANNIGAN, DANIELLE N",
    "owner2": "",
    "current_taxes": 20883.72,
    "new_taxes_no_override": 21785.9,
    "override_total_1": 22404.05,
    "override_increase_1": 618.16
  },
  {
    "#": "21 South St (372-07-00)",
    "$": 2749600,
    "address": "21 South St",
    "parcel_id": "372-07-00",
    "owner1": "ASSADI, TR, LEILA",
    "owner2": "",
    "current_taxes": 24520.97,
    "new_taxes_no_override": 25580.28,
    "override_total_1": 26306.1,
    "override_increase_1": 725.82
  },
  {
    "#": "28 South St (371-19-00)",
    "$": 1306600,
    "address": "28 South St",
    "parcel_id": "371-19-00",
    "owner1": "KASSIS, AMIN I",
    "owner2": "",
    "current_taxes": 9744.65,
    "new_taxes_no_override": 10165.62,
    "override_total_1": 10454.06,
    "override_increase_1": 288.44
  },
  {
    "#": "33 South St (372-01-00)",
    "$": 1865700,
    "address": "33 South St",
    "parcel_id": "372-01-00",
    "owner1": "LIRIANO, ERIC E",
    "owner2": "BANNA, TAMY H",
    "current_taxes": 19104.77,
    "new_taxes_no_override": 19930.1,
    "override_total_1": 20495.6,
    "override_increase_1": 565.5
  },
  {
    "#": "57 South St (399-47-00)",
    "$": 1664400,
    "address": "57 South St",
    "parcel_id": "399-47-00",
    "owner1": "YACOUT, AHMED",
    "owner2": "",
    "current_taxes": 13408.52,
    "new_taxes_no_override": 13987.77,
    "override_total_1": 14384.66,
    "override_increase_1": 396.89
  },
  {
    "#": "62 South St (373-01-00)",
    "$": 1113400,
    "address": "62 South St",
    "parcel_id": "373-01-00",
    "owner1": "DANA TR, ESTELLE",
    "owner2": "",
    "current_taxes": 7766.28,
    "new_taxes_no_override": 8101.78,
    "override_total_1": 8331.67,
    "override_increase_1": 229.88
  },
  {
    "#": "75 South St (374-19-00)",
    "$": 2065600,
    "address": "75 South St",
    "parcel_id": "374-19-00",
    "owner1": "BARAN, LUCAS S & ALESSANDRA",
    "owner2": "",
    "current_taxes": 17516.81,
    "new_taxes_no_override": 18273.54,
    "override_total_1": 18792.03,
    "override_increase_1": 518.5
  },
  {
    "#": "76 South St (373-02-00)",
    "$": 1059700,
    "address": "76 South St",
    "parcel_id": "373-02-00",
    "owner1": "SHURE, GEORGE B & CAROLYN",
    "owner2": "",
    "current_taxes": 7216.39,
    "new_taxes_no_override": 7528.14,
    "override_total_1": 7741.74,
    "override_increase_1": 213.61
  },
  {
    "#": "81 South St (374-20-00)",
    "$": 1454200,
    "address": "81 South St",
    "parcel_id": "374-20-00",
    "owner1": "KIM, JUNKOO",
    "owner2": "",
    "current_taxes": 11256.07,
    "new_taxes_no_override": 11742.33,
    "override_total_1": 12075.51,
    "override_increase_1": 333.18
  },
  {
    "#": "87 South St (374-21-00)",
    "$": 1519500,
    "address": "87 South St",
    "parcel_id": "374-21-00",
    "owner1": "SHANNON, MICHAEL P & ANNE",
    "owner2": "",
    "current_taxes": 11924.75,
    "new_taxes_no_override": 12439.9,
    "override_total_1": 12792.87,
    "override_increase_1": 352.97
  },
  {
    "#": "95 South St (374-22-00)",
    "$": 1688500,
    "address": "95 South St",
    "parcel_id": "374-22-00",
    "owner1": "REITMAN, RANDA",
    "owner2": "WILNER JR, NOEL JEAN",
    "current_taxes": 13655.31,
    "new_taxes_no_override": 14245.22,
    "override_total_1": 14649.42,
    "override_increase_1": 404.2
  },
  {
    "#": "99 South St (374-23-00)",
    "$": 1773300,
    "address": "99 South St",
    "parcel_id": "374-23-00",
    "owner1": "MCGINNIS, KELLY A",
    "owner2": "POORTINGA, RYAN R",
    "current_taxes": 14523.66,
    "new_taxes_no_override": 15151.08,
    "override_total_1": 15580.98,
    "override_increase_1": 429.9
  },
  {
    "#": "105 South St (374-24-00)",
    "$": 1420900,
    "address": "105 South St",
    "parcel_id": "374-24-00",
    "owner1": "HURWITZ TRS, MARY LOCHNER & MICHAEL",
    "owner2": "",
    "current_taxes": 10915.08,
    "new_taxes_no_override": 11386.61,
    "override_total_1": 11709.7,
    "override_increase_1": 323.09
  },
  {
    "#": "111 South St (374-25-00)",
    "$": 1065200,
    "address": "111 South St",
    "parcel_id": "374-25-00",
    "owner1": "FRIEDMAN TRS, NEAL E & GALINA A",
    "owner2": "",
    "current_taxes": 7272.71,
    "new_taxes_no_override": 7586.89,
    "override_total_1": 7802.16,
    "override_increase_1": 215.27
  },
  {
    "#": "117 South St (374-26-00)",
    "$": 1167400,
    "address": "117 South St",
    "parcel_id": "374-26-00",
    "owner1": "THORNTON TRS, DOROTHY E & CHARLES P",
    "owner2": "CADDLE TR, KIMBERLY A",
    "current_taxes": 8319.24,
    "new_taxes_no_override": 8678.63,
    "override_total_1": 8924.88,
    "override_increase_1": 246.25
  },
  {
    "#": "123 South St (374-27-00)",
    "$": 1170900,
    "address": "123 South St",
    "parcel_id": "374-27-00",
    "owner1": "GREEN, CAROL E",
    "owner2": "",
    "current_taxes": 8355.08,
    "new_taxes_no_override": 8716.02,
    "override_total_1": 8963.33,
    "override_increase_1": 247.31
  },
  {
    "#": "127 South St (374-28-00)",
    "$": 1451900,
    "address": "127 South St",
    "parcel_id": "374-28-00",
    "owner1": "KESNER, LAURE",
    "owner2": "",
    "current_taxes": 11232.52,
    "new_taxes_no_override": 11717.76,
    "override_total_1": 12050.25,
    "override_increase_1": 332.48
  },
  {
    "#": "131 South St (374-29-00)",
    "$": 943700,
    "address": "131 South St",
    "parcel_id": "374-29-00",
    "owner1": "URWIN, JOHN",
    "owner2": "PRESTI, ALISON",
    "current_taxes": 6028.55,
    "new_taxes_no_override": 6288.98,
    "override_total_1": 6467.43,
    "override_increase_1": 178.45
  },
  {
    "#": "139 South St (374-30-00)",
    "$": 1481300,
    "address": "139 South St",
    "parcel_id": "374-30-00",
    "owner1": "VILLARROEL, JUAN CARLOS & VALERIA JOSEFINA",
    "owner2": "",
    "current_taxes": 11533.58,
    "new_taxes_no_override": 12031.83,
    "override_total_1": 12373.22,
    "override_increase_1": 341.39
  },
  {
    "#": "143 South St (374-31-00)",
    "$": 1246500,
    "address": "143 South St",
    "parcel_id": "374-31-00",
    "owner1": "DEFREESE, COURTNEY STRADER",
    "owner2": "",
    "current_taxes": 9129.23,
    "new_taxes_no_override": 9523.61,
    "override_total_1": 9793.84,
    "override_increase_1": 270.23
  },
  {
    "#": "151 South St (374-32-00)",
    "$": 1483700,
    "address": "151 South St",
    "parcel_id": "374-32-00",
    "owner1": "STEVENS, MATTHEW",
    "owner2": "",
    "current_taxes": 15193.09,
    "new_taxes_no_override": 15849.43,
    "override_total_1": 16299.15,
    "override_increase_1": 449.72
  },
  {
    "#": "157 South St (374-01-00)",
    "$": 1314600,
    "address": "157 South St",
    "parcel_id": "374-01-00",
    "owner1": "WIENER TRS, MARTIN D & MONA",
    "owner2": "",
    "current_taxes": 9826.57,
    "new_taxes_no_override": 10251.08,
    "override_total_1": 10541.94,
    "override_increase_1": 290.87
  },
  {
    "#": "173 South St (391-01-00)",
    "$": 2241500,
    "address": "173 South St",
    "parcel_id": "391-01-00",
    "owner1": "DARROW SEA LLC",
    "owner2": "",
    "current_taxes": 22952.96,
    "new_taxes_no_override": 23944.53,
    "override_total_1": 24623.94,
    "override_increase_1": 679.41
  },
  {
    "#": "179 South St (391-02-00)",
    "$": 1428300,
    "address": "179 South St",
    "parcel_id": "391-02-00",
    "owner1": "MARCUS, YUVAL",
    "owner2": "BAREL, MORAN",
    "current_taxes": 10990.86,
    "new_taxes_no_override": 11465.67,
    "override_total_1": 11790.99,
    "override_increase_1": 325.33
  },
  {
    "#": "180 South St (375A-01-00)",
    "$": 1651200,
    "address": "180 South St",
    "parcel_id": "375A-01-00",
    "owner1": "CHOPRA, MOHIT",
    "owner2": "JATI, ANUPMA",
    "current_taxes": 13273.35,
    "new_taxes_no_override": 13846.76,
    "override_total_1": 14239.65,
    "override_increase_1": 392.89
  },
  {
    "#": "186 South St (375A-13-00)",
    "$": 1603400,
    "address": "186 South St",
    "parcel_id": "375A-13-00",
    "owner1": "MACALLISTER, JEFFREY G",
    "owner2": "LETT, SUSAN M",
    "current_taxes": 12783.88,
    "new_taxes_no_override": 13336.14,
    "override_total_1": 13714.55,
    "override_increase_1": 378.4
  },
  {
    "#": "187 South St (391-03-00)",
    "$": 1167300,
    "address": "187 South St",
    "parcel_id": "391-03-00",
    "owner1": "PRERAU, DAVID S & GAIL J",
    "owner2": "",
    "current_taxes": 8318.22,
    "new_taxes_no_override": 8677.57,
    "override_total_1": 8923.79,
    "override_increase_1": 246.22
  },
  {
    "#": "193 South St (391-04-00)",
    "$": 1376400,
    "address": "193 South St",
    "parcel_id": "391-04-00",
    "owner1": "ISKHAKOV, YURI & MARINA",
    "owner2": "",
    "current_taxes": 10459.4,
    "new_taxes_no_override": 10911.25,
    "override_total_1": 11220.84,
    "override_increase_1": 309.6
  },
  {
    "#": "199 South St (391-05-00)",
    "$": 1427000,
    "address": "199 South St",
    "parcel_id": "391-05-00",
    "owner1": "BURSTEIN TRS, JONI FINK & RAMI",
    "owner2": "",
    "current_taxes": 10977.55,
    "new_taxes_no_override": 11451.78,
    "override_total_1": 11776.72,
    "override_increase_1": 324.94
  },
  {
    "#": "200 South St (375B-01-00)",
    "$": 1075600,
    "address": "200 South St",
    "parcel_id": "375B-01-00",
    "owner1": "ROGAL, ANNE P",
    "owner2": "",
    "current_taxes": 7379.21,
    "new_taxes_no_override": 7697.99,
    "override_total_1": 7916.42,
    "override_increase_1": 218.42
  },
  {
    "#": "205 South St (391-06-00)",
    "$": 1626900,
    "address": "205 South St",
    "parcel_id": "391-06-00",
    "owner1": "CHEN, YUNING",
    "owner2": "TAN, YU",
    "current_taxes": 13024.52,
    "new_taxes_no_override": 13587.18,
    "override_total_1": 13972.71,
    "override_increase_1": 385.53
  },
  {
    "#": "207 South St (391-07-01)",
    "$": 0,
    "address": "207 South St",
    "parcel_id": "391-07-01",
    "owner1": "INGE, E J",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "208 South St (375B-16-00)",
    "$": 2309500,
    "address": "208 South St",
    "parcel_id": "375B-16-00",
    "owner1": "SWAROOP, PREM",
    "owner2": "KRISHNA, PRASHANTHI S",
    "current_taxes": 20014.35,
    "new_taxes_no_override": 20878.97,
    "override_total_1": 21471.39,
    "override_increase_1": 592.42
  },
  {
    "#": "211 South St (391-07-00)",
    "$": 1377100,
    "address": "211 South St",
    "parcel_id": "391-07-00",
    "owner1": "CUMMINGS TRS, VIRGINIA R & STEPHEN J",
    "owner2": "",
    "current_taxes": 10466.57,
    "new_taxes_no_override": 10918.73,
    "override_total_1": 11228.54,
    "override_increase_1": 309.81
  },
  {
    "#": "217 South St (391-08-00)",
    "$": 1517300,
    "address": "217 South St",
    "parcel_id": "391-08-00",
    "owner1": "MITTLEMAN, PATSY & MURRAY",
    "owner2": "",
    "current_taxes": 11902.22,
    "new_taxes_no_override": 12416.4,
    "override_total_1": 12768.7,
    "override_increase_1": 352.31
  },
  {
    "#": "220 South St (375C-15-00)",
    "$": 1468000,
    "address": "220 South St",
    "parcel_id": "375C-15-00",
    "owner1": "BRODIE, RICHARD A",
    "owner2": "DANZIG-BRODIE, DEBORAH S",
    "current_taxes": 11397.39,
    "new_taxes_no_override": 11889.76,
    "override_total_1": 12227.12,
    "override_increase_1": 337.36
  },
  {
    "#": "223 South St (391-09-00)",
    "$": 1481900,
    "address": "223 South St",
    "parcel_id": "391-09-00",
    "owner1": "HUNTSMAN, CHRISTOPHER W",
    "owner2": "MARKS, ALISSA L",
    "current_taxes": 11539.72,
    "new_taxes_no_override": 12038.24,
    "override_total_1": 12379.81,
    "override_increase_1": 341.58
  },
  {
    "#": "227 South St (391-10-00)",
    "$": 1415600,
    "address": "227 South St",
    "parcel_id": "391-10-00",
    "owner1": "KANE, KEVIN B & INGRID",
    "owner2": "",
    "current_taxes": 10860.81,
    "new_taxes_no_override": 11330.0,
    "override_total_1": 11651.48,
    "override_increase_1": 321.48
  },
  {
    "#": "228 South St (375C-14-00)",
    "$": 1275100,
    "address": "228 South St",
    "parcel_id": "375C-14-00",
    "owner1": "LARSON, JAMES",
    "owner2": "GUGGINA, LAUREN",
    "current_taxes": 9422.09,
    "new_taxes_no_override": 9829.12,
    "override_total_1": 10108.02,
    "override_increase_1": 278.89
  },
  {
    "#": "231 South St (391-11-00)",
    "$": 1575300,
    "address": "231 South St",
    "parcel_id": "391-11-00",
    "owner1": "ROZENBLUM, ZIV",
    "owner2": "BEITLER-ROZENBLUM, ORIT",
    "current_taxes": 12496.14,
    "new_taxes_no_override": 13035.97,
    "override_total_1": 13405.86,
    "override_increase_1": 369.89
  },
  {
    "#": "234 South St (375C-13-00)",
    "$": 1349000,
    "address": "234 South St",
    "parcel_id": "375C-13-00",
    "owner1": "AACH TRS, JOHN D",
    "owner2": "LAMBERT, GERI M",
    "current_taxes": 10178.83,
    "new_taxes_no_override": 10618.56,
    "override_total_1": 10919.85,
    "override_increase_1": 301.29
  },
  {
    "#": "239 South St (391-12-00)",
    "$": 1358900,
    "address": "239 South St",
    "parcel_id": "391-12-00",
    "owner1": "RECKLING TRS, CHRISTOPHER J",
    "owner2": "GABERMAN TR, EMILY D",
    "current_taxes": 10280.2,
    "new_taxes_no_override": 10724.3,
    "override_total_1": 11028.6,
    "override_increase_1": 304.29
  },
  {
    "#": "240 South St (375C-12-00)",
    "$": 1142800,
    "address": "240 South St",
    "parcel_id": "375C-12-00",
    "owner1": "PINES TR, LINDA B",
    "owner2": "",
    "current_taxes": 8067.34,
    "new_taxes_no_override": 8415.85,
    "override_total_1": 8654.64,
    "override_increase_1": 238.79
  },
  {
    "#": "255 South St (385-10-00)",
    "$": 1178100,
    "address": "255 South St",
    "parcel_id": "385-10-00",
    "owner1": "MORALES, OSCAR & EDITH",
    "owner2": "",
    "current_taxes": 8428.81,
    "new_taxes_no_override": 8792.93,
    "override_total_1": 9042.43,
    "override_increase_1": 249.49
  },
  {
    "#": "257 South St (385-11-00)",
    "$": 1548400,
    "address": "257 South St",
    "parcel_id": "385-11-00",
    "owner1": "KHAIT, ALEXANDER & MARIA",
    "owner2": "",
    "current_taxes": 12220.68,
    "new_taxes_no_override": 12748.61,
    "override_total_1": 13110.35,
    "override_increase_1": 361.73
  },
  {
    "#": "261 South St (385-12-00)",
    "$": 1307900,
    "address": "261 South St",
    "parcel_id": "385-12-00",
    "owner1": "LEFKOWITH, TRS, ROBERT A & ROSALYN",
    "owner2": "",
    "current_taxes": 9757.96,
    "new_taxes_no_override": 10179.5,
    "override_total_1": 10468.34,
    "override_increase_1": 288.84
  },
  {
    "#": "265 South St (385-13-00)",
    "$": 1310100,
    "address": "265 South St",
    "parcel_id": "385-13-00",
    "owner1": "LIBBY, DAVID & KARA",
    "owner2": "",
    "current_taxes": 9780.49,
    "new_taxes_no_override": 10203.01,
    "override_total_1": 10492.51,
    "override_increase_1": 289.5
  },
  {
    "#": "269 South St (385-14-00)",
    "$": 1186400,
    "address": "269 South St",
    "parcel_id": "385-14-00",
    "owner1": "HALEVI, SHMUEL & GONY",
    "owner2": "",
    "current_taxes": 8513.8,
    "new_taxes_no_override": 8881.6,
    "override_total_1": 9133.6,
    "override_increase_1": 252.01
  },
  {
    "#": "270 South St (375F-04-00)",
    "$": 1545700,
    "address": "270 South St",
    "parcel_id": "375F-04-00",
    "owner1": "YAN, YIDING",
    "owner2": "",
    "current_taxes": 12193.03,
    "new_taxes_no_override": 12719.77,
    "override_total_1": 13080.68,
    "override_increase_1": 360.91
  },
  {
    "#": "275 South St (385-15-16)",
    "$": 2145900,
    "address": "275 South St",
    "parcel_id": "385-15-16",
    "owner1": "VANDERPLUYM, CHRISTINA",
    "owner2": "ESCH, JESSE",
    "current_taxes": 18339.08,
    "new_taxes_no_override": 19131.33,
    "override_total_1": 19674.17,
    "override_increase_1": 542.84
  },
  {
    "#": "278 South St (376A-01-02)",
    "$": 1465300,
    "address": "278 South St",
    "parcel_id": "376A-01-02",
    "owner1": "JEW TRS, CONANT GRANT & CHARLENE MOOK",
    "owner2": "",
    "current_taxes": 11369.74,
    "new_taxes_no_override": 11860.91,
    "override_total_1": 12197.46,
    "override_increase_1": 336.54
  },
  {
    "#": "289 South St (385-17-00)",
    "$": 2349100,
    "address": "289 South St",
    "parcel_id": "385-17-00",
    "owner1": "HUANG, JIANYU",
    "owner2": "C/O WEIDONG LI",
    "current_taxes": 24054.78,
    "new_taxes_no_override": 25093.95,
    "override_total_1": 25805.97,
    "override_increase_1": 712.02
  },
  {
    "#": "300 South St (376A-01-00)",
    "$": 26209700,
    "address": "300 South St",
    "parcel_id": "376A-01-00",
    "owner1": "STORE MASTER FUNDING XVIII LLC",
    "owner2": "C/O CFO MICHAEL GALE",
    "current_taxes": 449758.45,
    "new_taxes_no_override": 469188.02,
    "override_total_1": 482500.87,
    "override_increase_1": 13312.85
  },
  {
    "#": "307 South St (382-15-00)",
    "$": 1363300,
    "address": "307 South St",
    "parcel_id": "382-15-00",
    "owner1": "LIPPKE TRS, JUDITH",
    "owner2": "GREENSPAN , CATHY A",
    "current_taxes": 10325.26,
    "new_taxes_no_override": 10771.31,
    "override_total_1": 11076.94,
    "override_increase_1": 305.63
  },
  {
    "#": "311 South St (382-16-00)",
    "$": 1406900,
    "address": "311 South St",
    "parcel_id": "382-16-00",
    "owner1": "BEAU, ANTOINE & LESLEY",
    "owner2": "",
    "current_taxes": 10771.72,
    "new_taxes_no_override": 11237.06,
    "override_total_1": 11555.9,
    "override_increase_1": 318.84
  },
  {
    "#": "317 South St (382-17-00)",
    "$": 1180500,
    "address": "317 South St",
    "parcel_id": "382-17-00",
    "owner1": "TSENG, WENDY C & TINA C",
    "owner2": "",
    "current_taxes": 12088.32,
    "new_taxes_no_override": 12610.54,
    "override_total_1": 12968.35,
    "override_increase_1": 357.81
  },
  {
    "#": "321 South St (382-18-00)",
    "$": 2084800,
    "address": "321 South St",
    "parcel_id": "382-18-00",
    "owner1": "YAMAYKIN, BORIS & ANNA",
    "owner2": "",
    "current_taxes": 17713.42,
    "new_taxes_no_override": 18478.64,
    "override_total_1": 19002.96,
    "override_increase_1": 524.32
  },
  {
    "#": "327 South St (382-19-00)",
    "$": 1111600,
    "address": "327 South St",
    "parcel_id": "382-19-00",
    "owner1": "FREILICH TRS, JEFFREY",
    "owner2": "GRAD-FREILICH, SILVINA",
    "current_taxes": 7747.85,
    "new_taxes_no_override": 8082.56,
    "override_total_1": 8311.89,
    "override_increase_1": 229.34
  },
  {
    "#": "328 South St (376A-32-00)",
    "$": 948400,
    "address": "328 South St",
    "parcel_id": "376A-32-00",
    "owner1": "DAVIS, SUSAN P",
    "owner2": "PERRY, BRUCE",
    "current_taxes": 6076.68,
    "new_taxes_no_override": 6339.19,
    "override_total_1": 6519.06,
    "override_increase_1": 179.87
  },
  {
    "#": "331 South St (382-20-00)",
    "$": 1471900,
    "address": "331 South St",
    "parcel_id": "382-20-00",
    "owner1": "CUMMINGS, CHRISTY & JASON C",
    "owner2": "",
    "current_taxes": 11437.32,
    "new_taxes_no_override": 11931.41,
    "override_total_1": 12269.96,
    "override_increase_1": 338.54
  },
  {
    "#": "335 South St (382-21-00)",
    "$": 1099800,
    "address": "335 South St",
    "parcel_id": "382-21-00",
    "owner1": "MCPHERSON, RYAN J",
    "owner2": "TOW MCPHERSON, CYNTHIA",
    "current_taxes": 7627.02,
    "new_taxes_no_override": 7956.51,
    "override_total_1": 8182.27,
    "override_increase_1": 225.76
  },
  {
    "#": "336 South St (377-14-00)",
    "$": 1706600,
    "address": "336 South St",
    "parcel_id": "377-14-00",
    "owner1": "RUIZ, CESAR & GLADYS",
    "owner2": "",
    "current_taxes": 13840.65,
    "new_taxes_no_override": 14438.57,
    "override_total_1": 14848.25,
    "override_increase_1": 409.68
  },
  {
    "#": "339 South St (382-22-00)",
    "$": 1050800,
    "address": "339 South St",
    "parcel_id": "382-22-00",
    "owner1": "SILBERT TR, MIRIAM L",
    "owner2": "C/O DELANEY STREET FOUNDATION",
    "current_taxes": 10760.19,
    "new_taxes_no_override": 11225.03,
    "override_total_1": 11543.53,
    "override_increase_1": 318.5
  },
  {
    "#": "363 South St (379-03-00)",
    "$": 1215600,
    "address": "363 South St",
    "parcel_id": "379-03-00",
    "owner1": "DHEKNE, NIKHEEL R",
    "owner2": "MORRISSEY, MICHELLE M",
    "current_taxes": 8812.81,
    "new_taxes_no_override": 9193.52,
    "override_total_1": 9454.38,
    "override_increase_1": 260.86
  },
  {
    "#": "367 South St (379-02-00)",
    "$": 1354900,
    "address": "367 South St",
    "parcel_id": "379-02-00",
    "owner1": "LANDER, YELENA",
    "owner2": "",
    "current_taxes": 10239.24,
    "new_taxes_no_override": 10681.58,
    "override_total_1": 10984.66,
    "override_increase_1": 303.08
  },
  {
    "#": "3 Spooner Rd (280-03-00)",
    "$": 3131000,
    "address": "3 Spooner Rd",
    "parcel_id": "280-03-00",
    "owner1": "GOESSLING, WOLFRAM",
    "owner2": "SACHSE, HELLE",
    "current_taxes": 28426.51,
    "new_taxes_no_override": 29654.54,
    "override_total_1": 30495.96,
    "override_increase_1": 841.42
  },
  {
    "#": "10 Spooner Rd (281-32-00)",
    "$": 5792700,
    "address": "10 Spooner Rd",
    "parcel_id": "281-32-00",
    "owner1": "SHMOLAK TRS, BLUMIT",
    "owner2": "RABINOVICH, AKIVA E",
    "current_taxes": 59317.25,
    "new_taxes_no_override": 61879.76,
    "override_total_1": 63635.55,
    "override_increase_1": 1755.79
  },
  {
    "#": "18 Spooner Rd (281-31-00)",
    "$": 3647100,
    "address": "18 Spooner Rd",
    "parcel_id": "281-31-00",
    "owner1": "GACIOCH, DAVID QUINN",
    "owner2": "SCHIEFELBEIN, MARY CURRAN",
    "current_taxes": 33711.37,
    "new_taxes_no_override": 35167.7,
    "override_total_1": 36165.56,
    "override_increase_1": 997.86
  },
  {
    "#": "19 Spooner Rd (280-04-00)",
    "$": 1854800,
    "address": "19 Spooner Rd",
    "parcel_id": "280-04-00",
    "owner1": "FINLEY TR, MARGOT G",
    "owner2": "35 SPOONER ROAD REALTY NOMINEE TRUST",
    "current_taxes": 18993.15,
    "new_taxes_no_override": 19813.65,
    "override_total_1": 20375.85,
    "override_increase_1": 562.2
  },
  {
    "#": "24 Spooner Rd (281-30-00)",
    "$": 3376600,
    "address": "24 Spooner Rd",
    "parcel_id": "281-30-00",
    "owner1": "KUSMER TRS, TOBY H",
    "owner2": "KAPLAN, RUTH L",
    "current_taxes": 30941.45,
    "new_taxes_no_override": 32278.12,
    "override_total_1": 33193.99,
    "override_increase_1": 915.87
  },
  {
    "#": "34 Spooner Rd (281-29-00)",
    "$": 5297000,
    "address": "34 Spooner Rd",
    "parcel_id": "281-29-00",
    "owner1": "WOOD, ROBERT Y III & ELIZABETH",
    "owner2": "",
    "current_taxes": 50606.35,
    "new_taxes_no_override": 52792.54,
    "override_total_1": 54290.49,
    "override_increase_1": 1497.95
  },
  {
    "#": "35 Spooner Rd (280-05-00)",
    "$": 3021700,
    "address": "35 Spooner Rd",
    "parcel_id": "280-05-00",
    "owner1": "FINLEY TR, MARGOT G",
    "owner2": "",
    "current_taxes": 27307.27,
    "new_taxes_no_override": 28486.94,
    "override_total_1": 29295.24,
    "override_increase_1": 808.3
  },
  {
    "#": "41 Spooner Rd (280-06-00)",
    "$": 3320000,
    "address": "41 Spooner Rd",
    "parcel_id": "280-06-00",
    "owner1": "DIADAMO, CAROL E & ROBERT A",
    "owner2": "",
    "current_taxes": 30361.87,
    "new_taxes_no_override": 31673.5,
    "override_total_1": 32572.21,
    "override_increase_1": 898.71
  },
  {
    "#": "50 Spooner Rd (281-28-00)",
    "$": 3577400,
    "address": "50 Spooner Rd",
    "parcel_id": "281-28-00",
    "owner1": "WEXLER, MICHAEL & RACHEL LEVY",
    "owner2": "",
    "current_taxes": 32997.64,
    "new_taxes_no_override": 34423.14,
    "override_total_1": 35399.87,
    "override_increase_1": 976.73
  },
  {
    "#": "51 Spooner Rd (280-07-00)",
    "$": 3323400,
    "address": "51 Spooner Rd",
    "parcel_id": "280-07-00",
    "owner1": "NAHATA, NITISH & MNEESHA",
    "owner2": "",
    "current_taxes": 30396.68,
    "new_taxes_no_override": 31709.82,
    "override_total_1": 32609.56,
    "override_increase_1": 899.74
  },
  {
    "#": "56 Spooner Rd (281-27-00)",
    "$": 2816900,
    "address": "56 Spooner Rd",
    "parcel_id": "281-27-00",
    "owner1": "TOOCHIN, JESS & JESSALYN",
    "owner2": "",
    "current_taxes": 25210.12,
    "new_taxes_no_override": 26299.2,
    "override_total_1": 27045.42,
    "override_increase_1": 746.22
  },
  {
    "#": "61 Spooner Rd (280-08-00)",
    "$": 4533500,
    "address": "61 Spooner Rd",
    "parcel_id": "280-08-00",
    "owner1": "SCHLEIFER TR, DANIEL A",
    "owner2": "",
    "current_taxes": 46423.04,
    "new_taxes_no_override": 48428.52,
    "override_total_1": 49802.64,
    "override_increase_1": 1374.12
  },
  {
    "#": "64 Spooner Rd (281-26-00)",
    "$": 2956100,
    "address": "64 Spooner Rd",
    "parcel_id": "281-26-00",
    "owner1": "GUO, LANJIANG",
    "owner2": "ZHENG, LU",
    "current_taxes": 26635.53,
    "new_taxes_no_override": 27786.18,
    "override_total_1": 28574.6,
    "override_increase_1": 788.41
  },
  {
    "#": "71 Spooner Rd (280-09-01)",
    "$": 617500,
    "address": "71 Spooner Rd",
    "parcel_id": "280-09-01",
    "owner1": "81 SPOONER RD LLC",
    "owner2": "C/O KAPLAN, ALAN F",
    "current_taxes": 6323.2,
    "new_taxes_no_override": 6596.36,
    "override_total_1": 6783.53,
    "override_increase_1": 187.17
  },
  {
    "#": "72 Spooner Rd (281-25-00)",
    "$": 3743100,
    "address": "72 Spooner Rd",
    "parcel_id": "281-25-00",
    "owner1": "URBAS, AVI",
    "owner2": "KO, NAOMI",
    "current_taxes": 34694.41,
    "new_taxes_no_override": 36193.21,
    "override_total_1": 37220.16,
    "override_increase_1": 1026.95
  },
  {
    "#": "81 Spooner Rd (280-09-02)",
    "$": 3257200,
    "address": "81 Spooner Rd",
    "parcel_id": "280-09-02",
    "owner1": "VELANDER, FREDRIK F K & REBECCA L Y",
    "owner2": "",
    "current_taxes": 29718.79,
    "new_taxes_no_override": 31002.64,
    "override_total_1": 31882.32,
    "override_increase_1": 879.68
  },
  {
    "#": "84 Spooner Rd (281-24-17)",
    "$": 2963700,
    "address": "84 Spooner Rd",
    "parcel_id": "281-24-17",
    "owner1": "FRITZE, ANITA W",
    "owner2": "",
    "current_taxes": 26713.35,
    "new_taxes_no_override": 27867.37,
    "override_total_1": 28658.08,
    "override_increase_1": 790.72
  },
  {
    "#": "91 Spooner Rd (280-10-00)",
    "$": 3797300,
    "address": "91 Spooner Rd",
    "parcel_id": "280-10-00",
    "owner1": "FOGG 3RD, GEORGE P",
    "owner2": "FOGG, JANE T N",
    "current_taxes": 35249.42,
    "new_taxes_no_override": 36772.19,
    "override_total_1": 37815.58,
    "override_increase_1": 1043.38
  },
  {
    "#": "92 Spooner Rd (281-23-18)",
    "$": 3706800,
    "address": "92 Spooner Rd",
    "parcel_id": "281-23-18",
    "owner1": "RIZIKA, ROBERT & DANIELLE",
    "owner2": "",
    "current_taxes": 34322.7,
    "new_taxes_no_override": 35805.44,
    "override_total_1": 36821.39,
    "override_increase_1": 1015.95
  },
  {
    "#": "98 Spooner Rd (281-22-00)",
    "$": 3038400,
    "address": "98 Spooner Rd",
    "parcel_id": "281-22-00",
    "owner1": "AGUIRE, PASCAL & IRINA",
    "owner2": "",
    "current_taxes": 31113.22,
    "new_taxes_no_override": 32457.31,
    "override_total_1": 33378.26,
    "override_increase_1": 920.95
  },
  {
    "#": "106 Spooner Rd (281-21-01)",
    "$": 2926500,
    "address": "106 Spooner Rd",
    "parcel_id": "281-21-01",
    "owner1": "SILBERT TRS, CYNTHIA K",
    "owner2": "KORB, DAVID",
    "current_taxes": 26332.43,
    "new_taxes_no_override": 27469.99,
    "override_total_1": 28249.43,
    "override_increase_1": 779.44
  },
  {
    "#": "15 St Marys Ct (001-26-00)",
    "$": 3194700,
    "address": "15 St Marys Ct",
    "parcel_id": "001-26-00",
    "owner1": "15 ST MARY`S CT LLC",
    "owner2": "C/O GLANZ PROPERTIES INC",
    "current_taxes": 32713.73,
    "new_taxes_no_override": 34126.96,
    "override_total_1": 35095.29,
    "override_increase_1": 968.33
  },
  {
    "#": "19 St Marys Ct (001-27-00)",
    "$": 2461000,
    "address": "19 St Marys Ct",
    "parcel_id": "001-27-00",
    "owner1": "ARENDT, CHRISTOPHER",
    "owner2": "",
    "current_taxes": 21565.71,
    "new_taxes_no_override": 22497.35,
    "override_total_1": 23135.69,
    "override_increase_1": 638.35
  },
  {
    "#": "23 St Marys Ct (001-28-00)",
    "$": 1956200,
    "address": "23 St Marys Ct",
    "parcel_id": "001-28-00",
    "owner1": "POLITMAN, TRS, ALEXANDER M & ANGELA V",
    "owner2": "",
    "current_taxes": 16396.55,
    "new_taxes_no_override": 17104.88,
    "override_total_1": 17590.22,
    "override_increase_1": 485.34
  },
  {
    "#": "25 St Marys Ct (001-29-00)",
    "$": 1867200,
    "address": "25 St Marys Ct",
    "parcel_id": "001-29-00",
    "owner1": "25 ST MARYS COURT LLC",
    "owner2": "",
    "current_taxes": 19120.13,
    "new_taxes_no_override": 19946.12,
    "override_total_1": 20512.08,
    "override_increase_1": 565.96
  },
  {
    "#": "27 St Marys Ct (001-30-00)",
    "$": 2309600,
    "address": "27 St Marys Ct",
    "parcel_id": "001-30-00",
    "owner1": "TRACY, JOANNE",
    "owner2": "",
    "current_taxes": 23650.3,
    "new_taxes_no_override": 24671.99,
    "override_total_1": 25372.04,
    "override_increase_1": 700.05
  },
  {
    "#": "29 St Marys Ct (001-31-00)",
    "$": 1869000,
    "address": "29 St Marys Ct",
    "parcel_id": "001-31-00",
    "owner1": "ADIREKSARN, GUNN",
    "owner2": "",
    "current_taxes": 19138.56,
    "new_taxes_no_override": 19965.35,
    "override_total_1": 20531.85,
    "override_increase_1": 566.5
  },
  {
    "#": "29 St Marys St, Unit A (001-31-01)",
    "$": 50000,
    "address": "29 St Marys St, Unit A",
    "parcel_id": "001-31-01",
    "owner1": "ADIREKSARN, GUNN",
    "owner2": "",
    "current_taxes": 512.0,
    "new_taxes_no_override": 534.12,
    "override_total_1": 549.27,
    "override_increase_1": 15.16
  },
  {
    "#": "37 St Marys St (005-04-00)",
    "$": 13122100,
    "address": "37 St Marys St",
    "parcel_id": "005-04-00",
    "owner1": "BOSTON UNIVERSITY TRS",
    "owner2": "C/O GENERAL ACCOUNTING 4TH FLR",
    "current_taxes": 134370.3,
    "new_taxes_no_override": 140175.1,
    "override_total_1": 144152.46,
    "override_increase_1": 3977.36
  },
  {
    "#": "49 St Marys St (005-05-00)",
    "$": 3391400,
    "address": "49 St Marys St",
    "parcel_id": "005-05-00",
    "owner1": "CHIN TRS, TOAYAN & PHILLIP",
    "owner2": "",
    "current_taxes": 34727.94,
    "new_taxes_no_override": 36228.19,
    "override_total_1": 37256.13,
    "override_increase_1": 1027.95
  },
  {
    "#": "65 St Marys St (002-17-00)",
    "$": 4078800,
    "address": "65 St Marys St",
    "parcel_id": "002-17-00",
    "owner1": "YEE TRS, NINOTCHKA Y P",
    "owner2": "",
    "current_taxes": 41766.91,
    "new_taxes_no_override": 43571.24,
    "override_total_1": 44807.54,
    "override_increase_1": 1236.3
  },
  {
    "#": "71 St Marys St, Unit 1 & P1 (002-18-03)",
    "$": 1346900,
    "address": "71 St Marys St, Unit 1 & P1",
    "parcel_id": "002-18-03",
    "owner1": "GREGORY, MICHAEL & KAREN",
    "owner2": "",
    "current_taxes": 10157.32,
    "new_taxes_no_override": 10596.12,
    "override_total_1": 10896.77,
    "override_increase_1": 300.66
  },
  {
    "#": "71 St Marys St, Unit 2 & P2 (002-18-01)",
    "$": 1424400,
    "address": "71 St Marys St, Unit 2 & P2",
    "parcel_id": "002-18-01",
    "owner1": "ZUCKER TR, ELLEN J",
    "owner2": "",
    "current_taxes": 10950.92,
    "new_taxes_no_override": 11424.0,
    "override_total_1": 11748.15,
    "override_increase_1": 324.15
  },
  {
    "#": "71 St Marys St, Unit 3 & P-3 (002-18-02)",
    "$": 1424500,
    "address": "71 St Marys St, Unit 3 & P-3",
    "parcel_id": "002-18-02",
    "owner1": "GONCZAROWSKI, YANNAI AHARON",
    "owner2": "",
    "current_taxes": 10951.95,
    "new_taxes_no_override": 11425.07,
    "override_total_1": 11749.25,
    "override_increase_1": 324.18
  },
  {
    "#": "121 St Marys St (112-26-01)",
    "$": 874700,
    "address": "121 St Marys St",
    "parcel_id": "112-26-01",
    "owner1": "GEE, WALTER",
    "owner2": "C/O SALON PIGALLE",
    "current_taxes": 15009.85,
    "new_taxes_no_override": 15658.28,
    "override_total_1": 16102.57,
    "override_increase_1": 444.29
  },
  {
    "#": "2 St Paul St, Unit 10 P62 P63 (155-06-49)",
    "$": 1330000,
    "address": "2 St Paul St, Unit 10 P62 P63",
    "parcel_id": "155-06-49",
    "owner1": "KIM, EUGENE",
    "owner2": "",
    "current_taxes": 13619.2,
    "new_taxes_no_override": 14207.55,
    "override_total_1": 14610.68,
    "override_increase_1": 403.13
  },
  {
    "#": "2 St Paul St, Unit 101 & P11 (155-06-03)",
    "$": 807100,
    "address": "2 St Paul St, Unit 101 & P11",
    "parcel_id": "155-06-03",
    "owner1": "ORDOOBADI, DAVID & LUCY JAMES",
    "owner2": "",
    "current_taxes": 8264.7,
    "new_taxes_no_override": 8621.74,
    "override_total_1": 8866.37,
    "override_increase_1": 244.64
  },
  {
    "#": "2 St Paul St, Unit 102 & P61 (155-06-04)",
    "$": 326700,
    "address": "2 St Paul St, Unit 102 & P61",
    "parcel_id": "155-06-04",
    "owner1": "CRONIN, PATRICIA L",
    "owner2": "",
    "current_taxes": 334.54,
    "new_taxes_no_override": 348.99,
    "override_total_1": 358.89,
    "override_increase_1": 9.9
  },
  {
    "#": "2 St Paul St, Unit 103 & P25 (155-06-05)",
    "$": 988200,
    "address": "2 St Paul St, Unit 103 & P25",
    "parcel_id": "155-06-05",
    "owner1": "BECKER FAMILY TRUST LTD",
    "owner2": "",
    "current_taxes": 10119.17,
    "new_taxes_no_override": 10556.32,
    "override_total_1": 10855.85,
    "override_increase_1": 299.53
  },
  {
    "#": "2 St Paul St, Unit 104 & P59 (155-06-06)",
    "$": 924800,
    "address": "2 St Paul St, Unit 104 & P59",
    "parcel_id": "155-06-06",
    "owner1": "BROOK POND LLC",
    "owner2": "SAINI TR, VEENA C",
    "current_taxes": 9469.95,
    "new_taxes_no_override": 9879.05,
    "override_total_1": 10159.36,
    "override_increase_1": 280.31
  },
  {
    "#": "2 St Paul St, Unit 105 P44&51 (155-06-07)",
    "$": 1000400,
    "address": "2 St Paul St, Unit 105 P44&51",
    "parcel_id": "155-06-07",
    "owner1": "WARDEN-ROTHMAN, CRAIG & ROBERT",
    "owner2": "",
    "current_taxes": 10244.1,
    "new_taxes_no_override": 10686.65,
    "override_total_1": 10989.87,
    "override_increase_1": 303.23
  },
  {
    "#": "2 St Paul St, Unit 106 P40&47 (155-06-08)",
    "$": 950400,
    "address": "2 St Paul St, Unit 106 P40&47",
    "parcel_id": "155-06-08",
    "owner1": "YANOWITZ TRS, IRWIN M",
    "owner2": "ROLE, ELLEN B",
    "current_taxes": 6097.16,
    "new_taxes_no_override": 6360.56,
    "override_total_1": 6541.03,
    "override_increase_1": 180.48
  },
  {
    "#": "2 St Paul St, Unit 107 P27-16 (155-06-09)",
    "$": 1082400,
    "address": "2 St Paul St, Unit 107 P27-16",
    "parcel_id": "155-06-09",
    "owner1": "WARDEN-ROTHMAN, CRAIG J & ROBERT L",
    "owner2": "",
    "current_taxes": 7448.84,
    "new_taxes_no_override": 7770.63,
    "override_total_1": 7991.12,
    "override_increase_1": 220.49
  },
  {
    "#": "2 St Paul St, Unit 108 & P58 (155-06-10)",
    "$": 305800,
    "address": "2 St Paul St, Unit 108 & P58",
    "parcel_id": "155-06-10",
    "owner1": "ANESHANSLEY, KAREN G",
    "owner2": "",
    "current_taxes": 313.14,
    "new_taxes_no_override": 326.67,
    "override_total_1": 335.94,
    "override_increase_1": 9.27
  },
  {
    "#": "2 St Paul St, Unit 12 P9&G85 (155-06-50)",
    "$": 1413100,
    "address": "2 St Paul St, Unit 12 P9&G85",
    "parcel_id": "155-06-50",
    "owner1": "AYLMER, JOHN F JR & KAREN M",
    "owner2": "",
    "current_taxes": 10835.21,
    "new_taxes_no_override": 11303.29,
    "override_total_1": 11624.01,
    "override_increase_1": 320.72
  },
  {
    "#": "2 St Paul St, Unit 14 P3-G80 (155-06-51)",
    "$": 1471600,
    "address": "2 St Paul St, Unit 14 P3-G80",
    "parcel_id": "155-06-51",
    "owner1": "SOLTZ, J ARNOLD",
    "owner2": "OBERAI-SOLTZ, RACHEL",
    "current_taxes": 11434.25,
    "new_taxes_no_override": 11928.21,
    "override_total_1": 12266.66,
    "override_increase_1": 338.45
  },
  {
    "#": "2 St Paul St, Unit 201 P22&23 (155-06-11)",
    "$": 1133800,
    "address": "2 St Paul St, Unit 201 P22&23",
    "parcel_id": "155-06-11",
    "owner1": "TERK TR, ERICA BLAINE",
    "owner2": "",
    "current_taxes": 11610.11,
    "new_taxes_no_override": 12111.67,
    "override_total_1": 12455.33,
    "override_increase_1": 343.66
  },
  {
    "#": "2 St Paul St, Unit 202 & P60 (155-06-12)",
    "$": 325300,
    "address": "2 St Paul St, Unit 202 & P60",
    "parcel_id": "155-06-12",
    "owner1": "YUNG, RACHEL Z",
    "owner2": "",
    "current_taxes": 333.11,
    "new_taxes_no_override": 347.5,
    "override_total_1": 357.36,
    "override_increase_1": 9.86
  },
  {
    "#": "2 St Paul St, Unit 203 P19&29 (155-06-13)",
    "$": 1068000,
    "address": "2 St Paul St, Unit 203 P19&29",
    "parcel_id": "155-06-13",
    "owner1": "LE, HOA TAI",
    "owner2": "HOANG, MAI PHUONG",
    "current_taxes": 7301.39,
    "new_taxes_no_override": 7616.81,
    "override_total_1": 7832.93,
    "override_increase_1": 216.12
  },
  {
    "#": "2 St Paul St, Unit 204 & P53 (155-06-14)",
    "$": 305800,
    "address": "2 St Paul St, Unit 204 & P53",
    "parcel_id": "155-06-14",
    "owner1": "PIKEN, DELIA B & DAVID J",
    "owner2": "",
    "current_taxes": 313.14,
    "new_taxes_no_override": 326.67,
    "override_total_1": 335.94,
    "override_increase_1": 9.27
  },
  {
    "#": "2 St Paul St, Unit 205 P43&50 (155-06-15)",
    "$": 1262400,
    "address": "2 St Paul St, Unit 205 P43&50",
    "parcel_id": "155-06-15",
    "owner1": "YU, KUN-HSING",
    "owner2": "CHIU, YU-HAN",
    "current_taxes": 12926.98,
    "new_taxes_no_override": 13485.43,
    "override_total_1": 13868.06,
    "override_increase_1": 382.64
  },
  {
    "#": "2 St Paul St, Unit 206 & P32 (155-06-16)",
    "$": 986200,
    "address": "2 St Paul St, Unit 206 & P32",
    "parcel_id": "155-06-16",
    "owner1": "ZHU, WEIJUN",
    "owner2": "LIU, JING",
    "current_taxes": 10098.69,
    "new_taxes_no_override": 10534.95,
    "override_total_1": 10833.87,
    "override_increase_1": 298.92
  },
  {
    "#": "2 St Paul St, Unit 207 P54-18 (155-06-17)",
    "$": 305800,
    "address": "2 St Paul St, Unit 207 P54-18",
    "parcel_id": "155-06-17",
    "owner1": "BENSHABBAT, HANNA & JACOB",
    "owner2": "",
    "current_taxes": 313.14,
    "new_taxes_no_override": 326.67,
    "override_total_1": 335.94,
    "override_increase_1": 9.27
  },
  {
    "#": "2 St Paul St, Unit 208 & P55 (155-06-18)",
    "$": 385700,
    "address": "2 St Paul St, Unit 208 & P55",
    "parcel_id": "155-06-18",
    "owner1": "CANDELA, ANTOINETTE M",
    "owner2": "",
    "current_taxes": 394.96,
    "new_taxes_no_override": 412.02,
    "override_total_1": 423.71,
    "override_increase_1": 11.69
  },
  {
    "#": "2 St Paul St, Unit 301 & P86 (155-06-19)",
    "$": 1372400,
    "address": "2 St Paul St, Unit 301 & P86",
    "parcel_id": "155-06-19",
    "owner1": "POHLMAN, LAWRENCE F",
    "owner2": "",
    "current_taxes": 10418.44,
    "new_taxes_no_override": 10868.52,
    "override_total_1": 11176.9,
    "override_increase_1": 308.39
  },
  {
    "#": "2 St Paul St, Unit 302 P78&79 (155-06-20)",
    "$": 1645200,
    "address": "2 St Paul St, Unit 302 P78&79",
    "parcel_id": "155-06-20",
    "owner1": "COHN, ARTHUR S & SUSAN",
    "owner2": "",
    "current_taxes": 13211.91,
    "new_taxes_no_override": 13782.66,
    "override_total_1": 14173.74,
    "override_increase_1": 391.07
  },
  {
    "#": "2 St Paul St, Unit 303 & P67 (155-06-21)",
    "$": 1267900,
    "address": "2 St Paul St, Unit 303 & P67",
    "parcel_id": "155-06-21",
    "owner1": "JDE VENTURES LLC",
    "owner2": "",
    "current_taxes": 12983.3,
    "new_taxes_no_override": 13544.18,
    "override_total_1": 13928.48,
    "override_increase_1": 384.31
  },
  {
    "#": "2 St Paul St, Unit 304&P42-49 (155-06-22)",
    "$": 1244300,
    "address": "2 St Paul St, Unit 304&P42-49",
    "parcel_id": "155-06-22",
    "owner1": "ST PAUL PARTNERS LLC",
    "owner2": "",
    "current_taxes": 12741.63,
    "new_taxes_no_override": 13292.07,
    "override_total_1": 13669.22,
    "override_increase_1": 377.15
  },
  {
    "#": "2 St Paul St, Unit 305 P41&48 (155-06-23)",
    "$": 1256500,
    "address": "2 St Paul St, Unit 305 P41&48",
    "parcel_id": "155-06-23",
    "owner1": "GANDA, KIRAN",
    "owner2": "EURICH, RICHARD",
    "current_taxes": 9231.63,
    "new_taxes_no_override": 9630.44,
    "override_total_1": 9903.69,
    "override_increase_1": 273.26
  },
  {
    "#": "2 St Paul St, Unit 306 P13 14 (155-06-24)",
    "$": 1231700,
    "address": "2 St Paul St, Unit 306 P13 14",
    "parcel_id": "155-06-24",
    "owner1": "GRINMAN, ALEX",
    "owner2": "",
    "current_taxes": 8977.67,
    "new_taxes_no_override": 9365.51,
    "override_total_1": 9631.24,
    "override_increase_1": 265.74
  },
  {
    "#": "2 St Paul St, Unit 307 & P12 (155-06-25)",
    "$": 790600,
    "address": "2 St Paul St, Unit 307 & P12",
    "parcel_id": "155-06-25",
    "owner1": "RASHID, ZAHID",
    "owner2": "",
    "current_taxes": 8095.74,
    "new_taxes_no_override": 8445.48,
    "override_total_1": 8685.11,
    "override_increase_1": 239.63
  },
  {
    "#": "2 St Paul St, Unit 308 & P31 (155-06-26)",
    "$": 785600,
    "address": "2 St Paul St, Unit 308 & P31",
    "parcel_id": "155-06-26",
    "owner1": "KIM, KIRYUNG",
    "owner2": "",
    "current_taxes": 8044.54,
    "new_taxes_no_override": 8392.06,
    "override_total_1": 8630.18,
    "override_increase_1": 238.12
  },
  {
    "#": "2 St Paul St, Unit 309 & G76 (155-06-27)",
    "$": 1089700,
    "address": "2 St Paul St, Unit 309 & G76",
    "parcel_id": "155-06-27",
    "owner1": "TEXEIRA, SANDRA RENATA",
    "owner2": "TSAO, JEFFREY",
    "current_taxes": 11158.53,
    "new_taxes_no_override": 11640.58,
    "override_total_1": 11970.87,
    "override_increase_1": 330.29
  },
  {
    "#": "2 St Paul St, Unit 310 & P33 (155-06-28)",
    "$": 841000,
    "address": "2 St Paul St, Unit 310 & P33",
    "parcel_id": "155-06-28",
    "owner1": "HENSHALL, LISA",
    "owner2": "",
    "current_taxes": 4976.91,
    "new_taxes_no_override": 5191.91,
    "override_total_1": 5339.23,
    "override_increase_1": 147.32
  },
  {
    "#": "2 St Paul St, Unit 311 26&G71 (155-06-29)",
    "$": 1139900,
    "address": "2 St Paul St, Unit 311 26&G71",
    "parcel_id": "155-06-29",
    "owner1": "TANG, XIAOJIN",
    "owner2": "",
    "current_taxes": 8037.64,
    "new_taxes_no_override": 8384.87,
    "override_total_1": 8622.78,
    "override_increase_1": 237.91
  },
  {
    "#": "2 St Paul St, Unit 312 & P10 (155-06-30)",
    "$": 1030200,
    "address": "2 St Paul St, Unit 312 & P10",
    "parcel_id": "155-06-30",
    "owner1": "WANG, ZHE",
    "owner2": "",
    "current_taxes": 10549.25,
    "new_taxes_no_override": 11004.98,
    "override_total_1": 11317.24,
    "override_increase_1": 312.26
  },
  {
    "#": "2 St Paul St, Unit 313 & P30 (155-06-31)",
    "$": 1083000,
    "address": "2 St Paul St, Unit 313 & P30",
    "parcel_id": "155-06-31",
    "owner1": "ALPEROVICH TRS, LUBA & MIKHAIL",
    "owner2": "",
    "current_taxes": 7454.99,
    "new_taxes_no_override": 7777.05,
    "override_total_1": 7997.71,
    "override_increase_1": 220.67
  },
  {
    "#": "2 St Paul St, Unit 314 P56-15 (155-06-32)",
    "$": 305800,
    "address": "2 St Paul St, Unit 314 P56-15",
    "parcel_id": "155-06-32",
    "owner1": "TUNIK, BORIS Z & IRINA",
    "owner2": "",
    "current_taxes": 313.14,
    "new_taxes_no_override": 326.67,
    "override_total_1": 335.94,
    "override_increase_1": 9.27
  },
  {
    "#": "2 St Paul St, Unit 4 & P6-G72 (155-06-46)",
    "$": 1404400,
    "address": "2 St Paul St, Unit 4 & P6-G72",
    "parcel_id": "155-06-46",
    "owner1": "CRAFTS TRS, ROGER C JR",
    "owner2": "GEAN, MARGARET P",
    "current_taxes": 10746.12,
    "new_taxes_no_override": 11210.35,
    "override_total_1": 11528.44,
    "override_increase_1": 318.09
  },
  {
    "#": "2 St Paul St, Unit 401 & P65 (155-06-33)",
    "$": 1090500,
    "address": "2 St Paul St, Unit 401 & P65",
    "parcel_id": "155-06-33",
    "owner1": "CHIKARMANE TRS, AJIT M & KALPANA A",
    "owner2": "",
    "current_taxes": 11166.72,
    "new_taxes_no_override": 11649.12,
    "override_total_1": 11979.66,
    "override_increase_1": 330.53
  },
  {
    "#": "2 St Paul St, Unit 402 G69&70 (155-06-34)",
    "$": 1556300,
    "address": "2 St Paul St, Unit 402 G69&70",
    "parcel_id": "155-06-34",
    "owner1": "MANOVE, MICHAEL & ELVIRA",
    "owner2": "",
    "current_taxes": 12301.58,
    "new_taxes_no_override": 12833.01,
    "override_total_1": 13197.14,
    "override_increase_1": 364.13
  },
  {
    "#": "2 St Paul St, Unit 403 & P64 (155-06-35)",
    "$": 1006300,
    "address": "2 St Paul St, Unit 403 & P64",
    "parcel_id": "155-06-35",
    "owner1": "DAVIS TR, PHILIP J",
    "owner2": "C/O KAUFFMAN & DAVIS PC",
    "current_taxes": 10304.51,
    "new_taxes_no_override": 10749.66,
    "override_total_1": 11054.68,
    "override_increase_1": 305.01
  },
  {
    "#": "2 St Paul St, Unit 404 & P28 (155-06-36)",
    "$": 1049000,
    "address": "2 St Paul St, Unit 404 & P28",
    "parcel_id": "155-06-36",
    "owner1": "SHAPIRO, LEON",
    "owner2": "ROSENBLATT, LAURIE A",
    "current_taxes": 7106.83,
    "new_taxes_no_override": 7413.85,
    "override_total_1": 7624.21,
    "override_increase_1": 210.36
  },
  {
    "#": "2 St Paul St, Unit 405 P45&52 (155-06-37)",
    "$": 1074800,
    "address": "2 St Paul St, Unit 405 P45&52",
    "parcel_id": "155-06-37",
    "owner1": "HAMILL TR, AMY ELIZABETH",
    "owner2": "",
    "current_taxes": 11005.95,
    "new_taxes_no_override": 11481.41,
    "override_total_1": 11807.18,
    "override_increase_1": 325.78
  },
  {
    "#": "2 St Paul St, Unit 406 & P57 (155-06-38)",
    "$": 305800,
    "address": "2 St Paul St, Unit 406 & P57",
    "parcel_id": "155-06-38",
    "owner1": "LAURO-PRIESTLY, PAUL S",
    "owner2": "",
    "current_taxes": 313.14,
    "new_taxes_no_override": 326.67,
    "override_total_1": 335.94,
    "override_increase_1": 9.27
  },
  {
    "#": "2 St Paul St, Unit 407 21&G84 (155-06-39)",
    "$": 1217300,
    "address": "2 St Paul St, Unit 407 21&G84",
    "parcel_id": "155-06-39",
    "owner1": "NISSIM, ITZHAK & ILANA",
    "owner2": "",
    "current_taxes": 12465.15,
    "new_taxes_no_override": 13003.64,
    "override_total_1": 13372.61,
    "override_increase_1": 368.97
  },
  {
    "#": "2 St Paul St, Unit 501 20&G81 (155-06-40)",
    "$": 1140800,
    "address": "2 St Paul St, Unit 501 20&G81",
    "parcel_id": "155-06-40",
    "owner1": "YEE, PAUL & HELEN",
    "owner2": "",
    "current_taxes": 8046.86,
    "new_taxes_no_override": 8394.48,
    "override_total_1": 8632.67,
    "override_increase_1": 238.19
  },
  {
    "#": "2 St Paul St, Unit 502 G82&83 (155-06-41)",
    "$": 1556300,
    "address": "2 St Paul St, Unit 502 G82&83",
    "parcel_id": "155-06-41",
    "owner1": "BOOKBINDER, STEPHEN M & SUSAN",
    "owner2": "",
    "current_taxes": 12301.58,
    "new_taxes_no_override": 12833.01,
    "override_total_1": 13197.14,
    "override_increase_1": 364.13
  },
  {
    "#": "2 St Paul St, Unit 503 P39&46 (155-06-42)",
    "$": 1055600,
    "address": "2 St Paul St, Unit 503 P39&46",
    "parcel_id": "155-06-42",
    "owner1": "ZARETSKAYA, SVETLANA",
    "owner2": "",
    "current_taxes": 7174.41,
    "new_taxes_no_override": 7484.34,
    "override_total_1": 7696.71,
    "override_increase_1": 212.36
  },
  {
    "#": "2 St Paul St, Unit 504 & G68 & P17 (155-06-43)",
    "$": 1157400,
    "address": "2 St Paul St, Unit 504 & G68 & P17",
    "parcel_id": "155-06-43",
    "owner1": "ALTMAN, LISA & MARK",
    "owner2": "",
    "current_taxes": 11851.78,
    "new_taxes_no_override": 12363.78,
    "override_total_1": 12714.59,
    "override_increase_1": 350.81
  },
  {
    "#": "2 St Paul St, Unit 505 & P24 (155-06-44)",
    "$": 1049100,
    "address": "2 St Paul St, Unit 505 & P24",
    "parcel_id": "155-06-44",
    "owner1": "JDE VENTURES LLC",
    "owner2": "",
    "current_taxes": 10742.78,
    "new_taxes_no_override": 11206.87,
    "override_total_1": 11524.85,
    "override_increase_1": 317.99
  },
  {
    "#": "2 St Paul St, Unit 506 & G73 (155-06-45)",
    "$": 1015600,
    "address": "2 St Paul St, Unit 506 & G73",
    "parcel_id": "155-06-45",
    "owner1": "IQBAL, JAMEEL Z",
    "owner2": "TUNG, STEPHANIE C",
    "current_taxes": 10399.74,
    "new_taxes_no_override": 10849.01,
    "override_total_1": 11156.84,
    "override_increase_1": 307.83
  },
  {
    "#": "2 St Paul St, Unit 6  P75 P5 (155-06-47)",
    "$": 1370700,
    "address": "2 St Paul St, Unit 6  P75 P5",
    "parcel_id": "155-06-47",
    "owner1": "CHEN, FANGFANG",
    "owner2": "LIU, GUANGMING",
    "current_taxes": 14035.97,
    "new_taxes_no_override": 14642.32,
    "override_total_1": 15057.79,
    "override_increase_1": 415.46
  },
  {
    "#": "2 St Paul St, Unit 8 & P4 G74 (155-06-48)",
    "$": 1358600,
    "address": "2 St Paul St, Unit 8 & P4 G74",
    "parcel_id": "155-06-48",
    "owner1": "RCS BROOKLINE LLC",
    "owner2": "",
    "current_taxes": 13912.06,
    "new_taxes_no_override": 14513.06,
    "override_total_1": 14924.86,
    "override_increase_1": 411.8
  },
  {
    "#": "2 St Paul St, Unit G66 (155-06-52)",
    "$": 90800,
    "address": "2 St Paul St, Unit G66",
    "parcel_id": "155-06-52",
    "owner1": "ST PAUL PARTNERS LLC",
    "owner2": "",
    "current_taxes": 929.79,
    "new_taxes_no_override": 969.96,
    "override_total_1": 997.48,
    "override_increase_1": 27.52
  },
  {
    "#": "2 St Paul St, Unit Garage #77 (155-06-53)",
    "$": 90800,
    "address": "2 St Paul St, Unit Garage #77",
    "parcel_id": "155-06-53",
    "owner1": "YANOWITZ, IRWIN M",
    "owner2": "ROLE, ELLEN B",
    "current_taxes": 929.79,
    "new_taxes_no_override": 969.96,
    "override_total_1": 997.48,
    "override_increase_1": 27.52
  },
  {
    "#": "18 St Paul St (155-05-00)",
    "$": 2002500,
    "address": "18 St Paul St",
    "parcel_id": "155-05-00",
    "owner1": "COLLINS, ET AL TRS, JOHN C",
    "owner2": "C/O ST PAUL MANOR CONDO -  L HORLICK TREAS",
    "current_taxes": 20505.6,
    "new_taxes_no_override": 21391.44,
    "override_total_1": 21998.41,
    "override_increase_1": 606.97
  },
  {
    "#": "20 St Paul St, Unit 1 (155-04-01)",
    "$": 507200,
    "address": "20 St Paul St, Unit 1",
    "parcel_id": "155-04-01",
    "owner1": "SUH, JUNGHYUP",
    "owner2": "PARK, YOUNG",
    "current_taxes": 1558.79,
    "new_taxes_no_override": 1626.13,
    "override_total_1": 1672.27,
    "override_increase_1": 46.14
  },
  {
    "#": "20 St Paul St, Unit 2 (155-04-02)",
    "$": 493700,
    "address": "20 St Paul St, Unit 2",
    "parcel_id": "155-04-02",
    "owner1": "MILLER TRS, JODY M",
    "owner2": "BOERMEESTER, ROBERT P",
    "current_taxes": 1420.55,
    "new_taxes_no_override": 1481.92,
    "override_total_1": 1523.97,
    "override_increase_1": 42.05
  },
  {
    "#": "20 St Paul St, Unit 3 & P-73 (155-04-03)",
    "$": 565800,
    "address": "20 St Paul St, Unit 3 & P-73",
    "parcel_id": "155-04-03",
    "owner1": "XU, QIONGLI",
    "owner2": "",
    "current_taxes": 5793.79,
    "new_taxes_no_override": 6044.08,
    "override_total_1": 6215.58,
    "override_increase_1": 171.5
  },
  {
    "#": "20 St Paul St, Unit 4 (155-04-04)",
    "$": 558600,
    "address": "20 St Paul St, Unit 4",
    "parcel_id": "155-04-04",
    "owner1": "KOVNER, MICHAEL",
    "owner2": "",
    "current_taxes": 2085.13,
    "new_taxes_no_override": 2175.21,
    "override_total_1": 2236.93,
    "override_increase_1": 61.72
  },
  {
    "#": "20 St Paul St, Unit 5 (155-04-05)",
    "$": 584100,
    "address": "20 St Paul St, Unit 5",
    "parcel_id": "155-04-05",
    "owner1": "MILLER, JODY",
    "owner2": "",
    "current_taxes": 2346.25,
    "new_taxes_no_override": 2447.61,
    "override_total_1": 2517.06,
    "override_increase_1": 69.45
  },
  {
    "#": "20 St Paul St, Unit 6 (155-04-06)",
    "$": 558600,
    "address": "20 St Paul St, Unit 6",
    "parcel_id": "155-04-06",
    "owner1": "SELIG TR, JEFFREY H",
    "owner2": "",
    "current_taxes": 5720.06,
    "new_taxes_no_override": 5967.17,
    "override_total_1": 6136.48,
    "override_increase_1": 169.31
  },
  {
    "#": "20 St Paul St, Unit 7 (155-04-07)",
    "$": 584100,
    "address": "20 St Paul St, Unit 7",
    "parcel_id": "155-04-07",
    "owner1": "BELOVICH, JOSEPH & MELISSA COLBRARO",
    "owner2": "",
    "current_taxes": 2346.25,
    "new_taxes_no_override": 2447.61,
    "override_total_1": 2517.06,
    "override_increase_1": 69.45
  },
  {
    "#": "20 St Paul St, Unit 8 (155-04-08)",
    "$": 573900,
    "address": "20 St Paul St, Unit 8",
    "parcel_id": "155-04-08",
    "owner1": "OUELLETTE, JASON",
    "owner2": "",
    "current_taxes": 5876.74,
    "new_taxes_no_override": 6130.62,
    "override_total_1": 6304.57,
    "override_increase_1": 173.95
  },
  {
    "#": "22 St Paul St, Unit 1 & P77 (155-04-09)",
    "$": 556500,
    "address": "22 St Paul St, Unit 1 & P77",
    "parcel_id": "155-04-09",
    "owner1": "PERRON, MONIQUE M",
    "owner2": "PERRON TRS, ROBERT A & JUDITH M",
    "current_taxes": 2063.63,
    "new_taxes_no_override": 2152.78,
    "override_total_1": 2213.86,
    "override_increase_1": 61.08
  },
  {
    "#": "22 St Paul St, Unit 2 (155-04-10)",
    "$": 591300,
    "address": "22 St Paul St, Unit 2",
    "parcel_id": "155-04-10",
    "owner1": "HORLICK, LAWRENCE A",
    "owner2": "SOLOMON, LISA H",
    "current_taxes": 6054.91,
    "new_taxes_no_override": 6316.48,
    "override_total_1": 6495.71,
    "override_increase_1": 179.23
  },
  {
    "#": "22 St Paul St, Unit 3 (155-04-11)",
    "$": 556500,
    "address": "22 St Paul St, Unit 3",
    "parcel_id": "155-04-11",
    "owner1": "MELIN, JUDITH A",
    "owner2": "",
    "current_taxes": 5698.56,
    "new_taxes_no_override": 5944.74,
    "override_total_1": 6113.42,
    "override_increase_1": 168.68
  },
  {
    "#": "22 St Paul St, Unit 4 & Pksp (155-04-12)",
    "$": 591300,
    "address": "22 St Paul St, Unit 4 & Pksp",
    "parcel_id": "155-04-12",
    "owner1": "RAY PROPERTY LLC",
    "owner2": "",
    "current_taxes": 6054.91,
    "new_taxes_no_override": 6316.48,
    "override_total_1": 6495.71,
    "override_increase_1": 179.23
  },
  {
    "#": "22 St Paul St, Unit 5 (155-04-13)",
    "$": 576600,
    "address": "22 St Paul St, Unit 5",
    "parcel_id": "155-04-13",
    "owner1": "BRS PROPERTY LLC",
    "owner2": "",
    "current_taxes": 5904.38,
    "new_taxes_no_override": 6159.45,
    "override_total_1": 6334.22,
    "override_increase_1": 174.77
  },
  {
    "#": "22 St Paul St, Unit 6 (155-04-14)",
    "$": 565800,
    "address": "22 St Paul St, Unit 6",
    "parcel_id": "155-04-14",
    "owner1": "CORSETTI, TRS, RALPH & MIMI",
    "owner2": "",
    "current_taxes": 5793.79,
    "new_taxes_no_override": 6044.08,
    "override_total_1": 6215.58,
    "override_increase_1": 171.5
  },
  {
    "#": "24 St Paul St, Unit 1 (155-04-15)",
    "$": 565800,
    "address": "24 St Paul St, Unit 1",
    "parcel_id": "155-04-15",
    "owner1": "CHUI, BARRY W",
    "owner2": "LI, WOON YI",
    "current_taxes": 5793.79,
    "new_taxes_no_override": 6044.08,
    "override_total_1": 6215.58,
    "override_increase_1": 171.5
  },
  {
    "#": "24 St Paul St, Unit 2 (155-04-16)",
    "$": 565800,
    "address": "24 St Paul St, Unit 2",
    "parcel_id": "155-04-16",
    "owner1": "GILMORE, ELLEN P",
    "owner2": "",
    "current_taxes": 2158.86,
    "new_taxes_no_override": 2252.12,
    "override_total_1": 2316.03,
    "override_increase_1": 63.9
  },
  {
    "#": "24 St Paul St, Unit 3 (155-04-17)",
    "$": 583200,
    "address": "24 St Paul St, Unit 3",
    "parcel_id": "155-04-17",
    "owner1": "TALBOT TR, DEBORAH",
    "owner2": "",
    "current_taxes": 2337.03,
    "new_taxes_no_override": 2437.99,
    "override_total_1": 2507.17,
    "override_increase_1": 69.18
  },
  {
    "#": "24 St Paul St, Unit 4 (155-04-18)",
    "$": 565800,
    "address": "24 St Paul St, Unit 4",
    "parcel_id": "155-04-18",
    "owner1": "COLLINS JR, JOHN C",
    "owner2": "",
    "current_taxes": 5793.79,
    "new_taxes_no_override": 6044.08,
    "override_total_1": 6215.58,
    "override_increase_1": 171.5
  },
  {
    "#": "24 St Paul St, Unit 5 (155-04-19)",
    "$": 565800,
    "address": "24 St Paul St, Unit 5",
    "parcel_id": "155-04-19",
    "owner1": "ZHANG, JIE",
    "owner2": "LI, XIANG",
    "current_taxes": 2158.86,
    "new_taxes_no_override": 2252.12,
    "override_total_1": 2316.03,
    "override_increase_1": 63.9
  },
  {
    "#": "24 St Paul St, Unit 6 (155-04-20)",
    "$": 576000,
    "address": "24 St Paul St, Unit 6",
    "parcel_id": "155-04-20",
    "owner1": "GUTMANN, A",
    "owner2": "",
    "current_taxes": 2263.31,
    "new_taxes_no_override": 2361.08,
    "override_total_1": 2428.08,
    "override_increase_1": 66.99
  },
  {
    "#": "26 St Paul St, Unit 1 (155-04-21)",
    "$": 499800,
    "address": "26 St Paul St, Unit 1",
    "parcel_id": "155-04-21",
    "owner1": "PIKE, JEFFREY J",
    "owner2": "",
    "current_taxes": 5117.95,
    "new_taxes_no_override": 5339.05,
    "override_total_1": 5490.54,
    "override_increase_1": 151.49
  },
  {
    "#": "26 St Paul St, Unit 3 (155-04-22)",
    "$": 565800,
    "address": "26 St Paul St, Unit 3",
    "parcel_id": "155-04-22",
    "owner1": "MANOUSAKIS, CONSTANTINE",
    "owner2": "",
    "current_taxes": 5793.79,
    "new_taxes_no_override": 6044.08,
    "override_total_1": 6215.58,
    "override_increase_1": 171.5
  },
  {
    "#": "26 St Paul St, Unit 4 (155-04-23)",
    "$": 591300,
    "address": "26 St Paul St, Unit 4",
    "parcel_id": "155-04-23",
    "owner1": "LIU TRS, RUOFENG",
    "owner2": "WU, JIAYI",
    "current_taxes": 2419.98,
    "new_taxes_no_override": 2524.52,
    "override_total_1": 2596.15,
    "override_increase_1": 71.63
  },
  {
    "#": "26 St Paul St, Unit 5 (155-04-24)",
    "$": 565800,
    "address": "26 St Paul St, Unit 5",
    "parcel_id": "155-04-24",
    "owner1": "PROLMAN, CHARLES E",
    "owner2": "",
    "current_taxes": 2158.86,
    "new_taxes_no_override": 2252.12,
    "override_total_1": 2316.03,
    "override_increase_1": 63.9
  },
  {
    "#": "26 St Paul St, Unit 6 (155-04-25)",
    "$": 565800,
    "address": "26 St Paul St, Unit 6",
    "parcel_id": "155-04-25",
    "owner1": "MAO, CHANGCHUIN",
    "owner2": "JIN, FENGHUA",
    "current_taxes": 5793.79,
    "new_taxes_no_override": 6044.08,
    "override_total_1": 6215.58,
    "override_increase_1": 171.5
  },
  {
    "#": "26 St Paul St, Unit 7 (155-04-26)",
    "$": 585900,
    "address": "26 St Paul St, Unit 7",
    "parcel_id": "155-04-26",
    "owner1": "DONG TR, JUNHUA",
    "owner2": "",
    "current_taxes": 5999.62,
    "new_taxes_no_override": 6258.8,
    "override_total_1": 6436.39,
    "override_increase_1": 177.59
  },
  {
    "#": "26 St Paul St, Unit 8 & P-52 (155-04-27)",
    "$": 585900,
    "address": "26 St Paul St, Unit 8 & P-52",
    "parcel_id": "155-04-27",
    "owner1": "YU, VERONICA",
    "owner2": "",
    "current_taxes": 5999.62,
    "new_taxes_no_override": 6258.8,
    "override_total_1": 6436.39,
    "override_increase_1": 177.59
  },
  {
    "#": "28 St Paul St, Unit 1 (155-04-28)",
    "$": 582600,
    "address": "28 St Paul St, Unit 1",
    "parcel_id": "155-04-28",
    "owner1": "CHUI, BARRY WAI HONG",
    "owner2": "LI, WOON YI",
    "current_taxes": 2330.89,
    "new_taxes_no_override": 2431.58,
    "override_total_1": 2500.58,
    "override_increase_1": 68.99
  },
  {
    "#": "28 St Paul St, Unit 2 (155-04-29)",
    "$": 579200,
    "address": "28 St Paul St, Unit 2",
    "parcel_id": "155-04-29",
    "owner1": "ZHU, XIAOWEN & YINMING",
    "owner2": "",
    "current_taxes": 5931.01,
    "new_taxes_no_override": 6187.23,
    "override_total_1": 6362.79,
    "override_increase_1": 175.56
  },
  {
    "#": "28 St Paul St, Unit 28-6 (155-04-33)",
    "$": 587300,
    "address": "28 St Paul St, Unit 28-6",
    "parcel_id": "155-04-33",
    "owner1": "TIAN, ZE",
    "owner2": "",
    "current_taxes": 6013.95,
    "new_taxes_no_override": 6273.75,
    "override_total_1": 6451.77,
    "override_increase_1": 178.01
  },
  {
    "#": "28 St Paul St, Unit 3 (155-04-30)",
    "$": 567300,
    "address": "28 St Paul St, Unit 3",
    "parcel_id": "155-04-30",
    "owner1": "CURTIS, MARTHA J",
    "owner2": "",
    "current_taxes": 2174.22,
    "new_taxes_no_override": 2268.15,
    "override_total_1": 2332.5,
    "override_increase_1": 64.36
  },
  {
    "#": "28 St Paul St, Unit 4 (155-04-31)",
    "$": 567300,
    "address": "28 St Paul St, Unit 4",
    "parcel_id": "155-04-31",
    "owner1": "LEW, MICHAEL & HELEN E & MATTHEW E",
    "owner2": "",
    "current_taxes": 2174.22,
    "new_taxes_no_override": 2268.15,
    "override_total_1": 2332.5,
    "override_increase_1": 64.36
  },
  {
    "#": "28 St Paul St, Unit 5 (155-04-32)",
    "$": 592800,
    "address": "28 St Paul St, Unit 5",
    "parcel_id": "155-04-32",
    "owner1": "XU, MIN",
    "owner2": "",
    "current_taxes": 6070.27,
    "new_taxes_no_override": 6332.51,
    "override_total_1": 6512.19,
    "override_increase_1": 179.68
  },
  {
    "#": "30 St Paul St, Unit 1 (155-04-34)",
    "$": 513400,
    "address": "30 St Paul St, Unit 1",
    "parcel_id": "155-04-34",
    "owner1": "MSK REALTY PARTNERS LLC",
    "owner2": "",
    "current_taxes": 5257.22,
    "new_taxes_no_override": 5484.33,
    "override_total_1": 5639.95,
    "override_increase_1": 155.61
  },
  {
    "#": "30 St Paul St, Unit 2 (155-04-35)",
    "$": 528900,
    "address": "30 St Paul St, Unit 2",
    "parcel_id": "155-04-35",
    "owner1": "BANKS TRS, STACY B & EVAN M",
    "owner2": "",
    "current_taxes": 5415.94,
    "new_taxes_no_override": 5649.91,
    "override_total_1": 5810.22,
    "override_increase_1": 160.31
  },
  {
    "#": "30 St Paul St, Unit 3 (155-04-36)",
    "$": 570600,
    "address": "30 St Paul St, Unit 3",
    "parcel_id": "155-04-36",
    "owner1": "SHEVCHENKO, FAINA & KATHERIN",
    "owner2": "",
    "current_taxes": 5842.94,
    "new_taxes_no_override": 6095.36,
    "override_total_1": 6268.31,
    "override_increase_1": 172.95
  },
  {
    "#": "30 St Paul St, Unit 4 (155-04-37)",
    "$": 581100,
    "address": "30 St Paul St, Unit 4",
    "parcel_id": "155-04-37",
    "owner1": "TUOHY, PHYLLIS A",
    "owner2": "",
    "current_taxes": 5950.46,
    "new_taxes_no_override": 6207.52,
    "override_total_1": 6383.65,
    "override_increase_1": 176.13
  },
  {
    "#": "30 St Paul St, Unit 5 (155-04-38)",
    "$": 565800,
    "address": "30 St Paul St, Unit 5",
    "parcel_id": "155-04-38",
    "owner1": "KUJAWSKI, KRISTOPHER",
    "owner2": "WONG, FRIEDA",
    "current_taxes": 2158.86,
    "new_taxes_no_override": 2252.12,
    "override_total_1": 2316.03,
    "override_increase_1": 63.9
  },
  {
    "#": "30 St Paul St, Unit 6 (155-04-39)",
    "$": 583200,
    "address": "30 St Paul St, Unit 6",
    "parcel_id": "155-04-39",
    "owner1": "ARNAOUT, AMAL",
    "owner2": "",
    "current_taxes": 5971.97,
    "new_taxes_no_override": 6229.96,
    "override_total_1": 6406.73,
    "override_increase_1": 176.77
  },
  {
    "#": "30 St Paul St, Unit 7 (155-04-40)",
    "$": 565800,
    "address": "30 St Paul St, Unit 7",
    "parcel_id": "155-04-40",
    "owner1": "HARRIS-BAKER, DANIELLE C",
    "owner2": "C/O DANIELLE C KONZELMANN",
    "current_taxes": 5793.79,
    "new_taxes_no_override": 6044.08,
    "override_total_1": 6215.58,
    "override_increase_1": 171.5
  },
  {
    "#": "30 St Paul St, Unit 8 (155-04-41)",
    "$": 565800,
    "address": "30 St Paul St, Unit 8",
    "parcel_id": "155-04-41",
    "owner1": "PIGNATA, CLAUDIO",
    "owner2": "C/O FRANKLIN SQ MGMT",
    "current_taxes": 5793.79,
    "new_taxes_no_override": 6044.08,
    "override_total_1": 6215.58,
    "override_increase_1": 171.5
  },
  {
    "#": "32 St Paul St, Unit 1 (155-04-42)",
    "$": 499800,
    "address": "32 St Paul St, Unit 1",
    "parcel_id": "155-04-42",
    "owner1": "GUO, JUN",
    "owner2": "DUAN, XIACHU",
    "current_taxes": 5117.95,
    "new_taxes_no_override": 5339.05,
    "override_total_1": 5490.54,
    "override_increase_1": 151.49
  },
  {
    "#": "32 St Paul St, Unit 2 & P88 (155-04-43)",
    "$": 507900,
    "address": "32 St Paul St, Unit 2 & P88",
    "parcel_id": "155-04-43",
    "owner1": "SOIFFER, ARIEL J",
    "owner2": "GARCIA-SOIFFER, GEORGINA E",
    "current_taxes": 5200.9,
    "new_taxes_no_override": 5425.58,
    "override_total_1": 5579.53,
    "override_increase_1": 153.95
  },
  {
    "#": "32 St Paul St, Unit 3 (155-04-44)",
    "$": 565800,
    "address": "32 St Paul St, Unit 3",
    "parcel_id": "155-04-44",
    "owner1": "GEE, YEW TOON",
    "owner2": "SHU, YUN LIU",
    "current_taxes": 2158.86,
    "new_taxes_no_override": 2252.12,
    "override_total_1": 2316.03,
    "override_increase_1": 63.9
  },
  {
    "#": "32 St Paul St, Unit 4 (155-04-45)",
    "$": 585900,
    "address": "32 St Paul St, Unit 4",
    "parcel_id": "155-04-45",
    "owner1": "ARNAOUT, AMAL",
    "owner2": "",
    "current_taxes": 5999.62,
    "new_taxes_no_override": 6258.8,
    "override_total_1": 6436.39,
    "override_increase_1": 177.59
  },
  {
    "#": "32 St Paul St, Unit 5 (155-04-46)",
    "$": 565800,
    "address": "32 St Paul St, Unit 5",
    "parcel_id": "155-04-46",
    "owner1": "HARRIS, PAUL MARSHALL",
    "owner2": "",
    "current_taxes": 5793.79,
    "new_taxes_no_override": 6044.08,
    "override_total_1": 6215.58,
    "override_increase_1": 171.5
  },
  {
    "#": "32 St Paul St, Unit 6 (155-04-47)",
    "$": 565800,
    "address": "32 St Paul St, Unit 6",
    "parcel_id": "155-04-47",
    "owner1": "MENG, SIHAN & XIANGFENG",
    "owner2": "",
    "current_taxes": 2158.86,
    "new_taxes_no_override": 2252.12,
    "override_total_1": 2316.03,
    "override_increase_1": 63.9
  },
  {
    "#": "32 St Paul St, Unit 7 (155-04-48)",
    "$": 585900,
    "address": "32 St Paul St, Unit 7",
    "parcel_id": "155-04-48",
    "owner1": "YIU, GLENN C",
    "owner2": "HOU, MELODY",
    "current_taxes": 5999.62,
    "new_taxes_no_override": 6258.8,
    "override_total_1": 6436.39,
    "override_increase_1": 177.59
  },
  {
    "#": "32 St Paul St, Unit 8 & P61 (155-04-49)",
    "$": 591300,
    "address": "32 St Paul St, Unit 8 & P61",
    "parcel_id": "155-04-49",
    "owner1": "DORSTE, ANNA",
    "owner2": "",
    "current_taxes": 2419.98,
    "new_taxes_no_override": 2524.52,
    "override_total_1": 2596.15,
    "override_increase_1": 71.63
  },
  {
    "#": "33 St Paul St, Unit 33-1 (132-03-01)",
    "$": 656600,
    "address": "33 St Paul St, Unit 33-1",
    "parcel_id": "132-03-01",
    "owner1": "LUEBKE TR, JENNIFER I",
    "owner2": "",
    "current_taxes": 6723.58,
    "new_taxes_no_override": 7014.04,
    "override_total_1": 7213.06,
    "override_increase_1": 199.02
  },
  {
    "#": "33 St Paul St, Unit 33-2 (132-03-02)",
    "$": 636500,
    "address": "33 St Paul St, Unit 33-2",
    "parcel_id": "132-03-02",
    "owner1": "SCOTT, TAMMY M",
    "owner2": "",
    "current_taxes": 2882.83,
    "new_taxes_no_override": 3007.37,
    "override_total_1": 3092.7,
    "override_increase_1": 85.33
  },
  {
    "#": "33 St Paul St, Unit 33-3  (132-03-03)",
    "$": 650700,
    "address": "33 St Paul St, Unit 33-3 ",
    "parcel_id": "132-03-03",
    "owner1": "ROSENTHAL, PAUL ELLIOT",
    "owner2": "HANTMAN, ELAINE SUSAN",
    "current_taxes": 6663.17,
    "new_taxes_no_override": 6951.02,
    "override_total_1": 7148.25,
    "override_increase_1": 197.23
  },
  {
    "#": "33 St Paul St, Unit 33-4 (132-03-04)",
    "$": 610000,
    "address": "33 St Paul St, Unit 33-4",
    "parcel_id": "132-03-04",
    "owner1": "BUSINGER, JOHN A",
    "owner2": "",
    "current_taxes": 2611.47,
    "new_taxes_no_override": 2724.29,
    "override_total_1": 2801.59,
    "override_increase_1": 77.3
  },
  {
    "#": "33 St Paul St, Unit 33-5 (132-03-05)",
    "$": 712400,
    "address": "33 St Paul St, Unit 33-5",
    "parcel_id": "132-03-05",
    "owner1": "LAM, KHIEM",
    "owner2": "DAVIS, JULIE",
    "current_taxes": 7294.98,
    "new_taxes_no_override": 7610.12,
    "override_total_1": 7826.05,
    "override_increase_1": 215.93
  },
  {
    "#": "33 St Paul St, Unit 33-6 & P22 (132-03-06)",
    "$": 611700,
    "address": "33 St Paul St, Unit 33-6 & P22",
    "parcel_id": "132-03-06",
    "owner1": "SNITKOVSKY TR, MICHAEL",
    "owner2": "",
    "current_taxes": 6263.81,
    "new_taxes_no_override": 6534.41,
    "override_total_1": 6719.82,
    "override_increase_1": 185.41
  },
  {
    "#": "33 St Paul St, Unit 33G1 (132-03-27)",
    "$": 615100,
    "address": "33 St Paul St, Unit 33G1",
    "parcel_id": "132-03-27",
    "owner1": "WU, WEI",
    "owner2": "CUI, GENG",
    "current_taxes": 6298.62,
    "new_taxes_no_override": 6570.72,
    "override_total_1": 6757.16,
    "override_increase_1": 186.44
  },
  {
    "#": "35 St Paul St, Unit 35-1 (132-03-08)",
    "$": 489900,
    "address": "35 St Paul St, Unit 35-1",
    "parcel_id": "132-03-08",
    "owner1": "FOGT, EMMA",
    "owner2": "",
    "current_taxes": 5016.58,
    "new_taxes_no_override": 5233.3,
    "override_total_1": 5381.79,
    "override_increase_1": 148.49
  },
  {
    "#": "35 St Paul St, Unit 35-2 & P15 (132-03-09)",
    "$": 658600,
    "address": "35 St Paul St, Unit 35-2 & P15",
    "parcel_id": "132-03-09",
    "owner1": "QIU, CHENXI",
    "owner2": "LIU, YU",
    "current_taxes": 3109.13,
    "new_taxes_no_override": 3243.44,
    "override_total_1": 3335.47,
    "override_increase_1": 92.03
  },
  {
    "#": "35 St Paul St, Unit 35-3 (132-03-10)",
    "$": 536900,
    "address": "35 St Paul St, Unit 35-3",
    "parcel_id": "132-03-10",
    "owner1": "ELKIND TR, NORMA",
    "owner2": "",
    "current_taxes": 1862.92,
    "new_taxes_no_override": 1943.4,
    "override_total_1": 1998.54,
    "override_increase_1": 55.14
  },
  {
    "#": "35 St Paul St, Unit 35-4&P18 (132-03-11)",
    "$": 705200,
    "address": "35 St Paul St, Unit 35-4&P18",
    "parcel_id": "132-03-11",
    "owner1": "JIN, QING",
    "owner2": "",
    "current_taxes": 7221.25,
    "new_taxes_no_override": 7533.21,
    "override_total_1": 7746.96,
    "override_increase_1": 213.75
  },
  {
    "#": "35 St Paul St, Unit 35-5&P27 (132-03-12)",
    "$": 609100,
    "address": "35 St Paul St, Unit 35-5&P27",
    "parcel_id": "132-03-12",
    "owner1": "CENTENO, CARLOS R",
    "owner2": "",
    "current_taxes": 6237.18,
    "new_taxes_no_override": 6506.63,
    "override_total_1": 6691.25,
    "override_increase_1": 184.62
  },
  {
    "#": "35 St Paul St, Unit 35-6 (132-03-13)",
    "$": 599000,
    "address": "35 St Paul St, Unit 35-6",
    "parcel_id": "132-03-13",
    "owner1": "MIKALIAN, BENJAMIN",
    "owner2": "",
    "current_taxes": 6133.76,
    "new_taxes_no_override": 6398.74,
    "override_total_1": 6580.3,
    "override_increase_1": 181.56
  },
  {
    "#": "35 St Paul St, Unit 35G1 (132-03-07)",
    "$": 587000,
    "address": "35 St Paul St, Unit 35G1",
    "parcel_id": "132-03-07",
    "owner1": "PLISKIN, JOSEPH",
    "owner2": "C/O MARY HURWITZ",
    "current_taxes": 6010.88,
    "new_taxes_no_override": 6270.55,
    "override_total_1": 6448.47,
    "override_increase_1": 177.92
  },
  {
    "#": "36 St Paul St, Unit 1 (155-03-01)",
    "$": 718500,
    "address": "36 St Paul St, Unit 1",
    "parcel_id": "155-03-01",
    "owner1": "GREEN, LAWRENCE G",
    "owner2": "",
    "current_taxes": 7357.44,
    "new_taxes_no_override": 7675.28,
    "override_total_1": 7893.06,
    "override_increase_1": 217.78
  },
  {
    "#": "36 St Paul St, Unit 1 (155-03-04)",
    "$": 723600,
    "address": "36 St Paul St, Unit 1",
    "parcel_id": "155-03-04",
    "owner1": "WONG, ANITA L",
    "owner2": "",
    "current_taxes": 7409.66,
    "new_taxes_no_override": 7729.76,
    "override_total_1": 7949.08,
    "override_increase_1": 219.33
  },
  {
    "#": "36 St Paul St, Unit 2 (155-03-02)",
    "$": 722800,
    "address": "36 St Paul St, Unit 2",
    "parcel_id": "155-03-02",
    "owner1": "SHULMAN, TR, STANLEY",
    "owner2": "",
    "current_taxes": 7401.47,
    "new_taxes_no_override": 7721.21,
    "override_total_1": 7940.3,
    "override_increase_1": 219.08
  },
  {
    "#": "36 St Paul St, Unit 2 (155-03-05)",
    "$": 764700,
    "address": "36 St Paul St, Unit 2",
    "parcel_id": "155-03-05",
    "owner1": "DASHTI, MOHAMMAD HOSSEIN",
    "owner2": "HASHEMIAN, ROXANA",
    "current_taxes": 7830.53,
    "new_taxes_no_override": 8168.81,
    "override_total_1": 8400.59,
    "override_increase_1": 231.78
  },
  {
    "#": "36 St Paul St, Unit 3 (155-03-03)",
    "$": 733000,
    "address": "36 St Paul St, Unit 3",
    "parcel_id": "155-03-03",
    "owner1": "BRAZEAU, PAMELA M",
    "owner2": "",
    "current_taxes": 3870.99,
    "new_taxes_no_override": 4038.22,
    "override_total_1": 4152.8,
    "override_increase_1": 114.58
  },
  {
    "#": "36 St Paul St, Unit 3 (155-03-06)",
    "$": 759800,
    "address": "36 St Paul St, Unit 3",
    "parcel_id": "155-03-06",
    "owner1": "SHULMAN, TR, STANLEY",
    "owner2": "",
    "current_taxes": 7780.35,
    "new_taxes_no_override": 8116.46,
    "override_total_1": 8346.76,
    "override_increase_1": 230.3
  },
  {
    "#": "36 St Paul St, Unit B (155-03-32)",
    "$": 472000,
    "address": "36 St Paul St, Unit B",
    "parcel_id": "155-03-32",
    "owner1": "SHULMAN, TR, STANLEY",
    "owner2": "",
    "current_taxes": 4833.28,
    "new_taxes_no_override": 5042.08,
    "override_total_1": 5185.14,
    "override_increase_1": 143.07
  },
  {
    "#": "37 St Paul St, Unit 37-1 (132-03-16)",
    "$": 513800,
    "address": "37 St Paul St, Unit 37-1",
    "parcel_id": "132-03-16",
    "owner1": "LENNON, KATHRYN",
    "owner2": "MCCARTHY, FRANCES L",
    "current_taxes": 5261.31,
    "new_taxes_no_override": 5488.6,
    "override_total_1": 5644.33,
    "override_increase_1": 155.73
  },
  {
    "#": "37 St Paul St, Unit 37-2 (132-03-17)",
    "$": 650600,
    "address": "37 St Paul St, Unit 37-2",
    "parcel_id": "132-03-17",
    "owner1": "SOLOMON, ADAM T",
    "owner2": "GAUGHAN, MARY E",
    "current_taxes": 3027.21,
    "new_taxes_no_override": 3157.99,
    "override_total_1": 3247.59,
    "override_increase_1": 89.61
  },
  {
    "#": "37 St Paul St, Unit 37-3 & P13 (132-03-18)",
    "$": 536400,
    "address": "37 St Paul St, Unit 37-3 & P13",
    "parcel_id": "132-03-18",
    "owner1": "PERETZMAN, MAYA",
    "owner2": "",
    "current_taxes": 5492.74,
    "new_taxes_no_override": 5730.03,
    "override_total_1": 5892.61,
    "override_increase_1": 162.59
  },
  {
    "#": "37 St Paul St, Unit 37-4 (132-03-19)",
    "$": 646200,
    "address": "37 St Paul St, Unit 37-4",
    "parcel_id": "132-03-19",
    "owner1": "ROSENTHAL, PAUL E",
    "owner2": "",
    "current_taxes": 6617.09,
    "new_taxes_no_override": 6902.95,
    "override_total_1": 7098.81,
    "override_increase_1": 195.87
  },
  {
    "#": "37 St Paul St, Unit 37-5 (132-03-20)",
    "$": 532600,
    "address": "37 St Paul St, Unit 37-5",
    "parcel_id": "132-03-20",
    "owner1": "PETTIPAW TR, DIANNE O",
    "owner2": "",
    "current_taxes": 1818.89,
    "new_taxes_no_override": 1897.47,
    "override_total_1": 1951.31,
    "override_increase_1": 53.84
  },
  {
    "#": "37 St Paul St, Unit 37-6 (132-03-21)",
    "$": 647100,
    "address": "37 St Paul St, Unit 37-6",
    "parcel_id": "132-03-21",
    "owner1": "KANDEL TR, LESLIE J",
    "owner2": "",
    "current_taxes": 6626.3,
    "new_taxes_no_override": 6912.56,
    "override_total_1": 7108.69,
    "override_increase_1": 196.14
  },
  {
    "#": "37 St Paul St, Unit 37-G1 (132-03-14)",
    "$": 552700,
    "address": "37 St Paul St, Unit 37-G1",
    "parcel_id": "132-03-14",
    "owner1": "WATSON, JANE E",
    "owner2": "",
    "current_taxes": 5659.65,
    "new_taxes_no_override": 5904.15,
    "override_total_1": 6071.67,
    "override_increase_1": 167.53
  },
  {
    "#": "37 St Paul St, Unit 37-G2 (132-03-15)",
    "$": 428000,
    "address": "37 St Paul St, Unit 37-G2",
    "parcel_id": "132-03-15",
    "owner1": "KOPELMAN, MICHAEL J & JEFFREY D",
    "owner2": "",
    "current_taxes": 4382.72,
    "new_taxes_no_override": 4572.05,
    "override_total_1": 4701.78,
    "override_increase_1": 129.73
  },
  {
    "#": "38 St Paul St, Unit 1 (155-03-07)",
    "$": 720700,
    "address": "38 St Paul St, Unit 1",
    "parcel_id": "155-03-07",
    "owner1": "MEYMAND TRS, PHILIP",
    "owner2": "CANNAN, ALICE",
    "current_taxes": 7379.97,
    "new_taxes_no_override": 7698.78,
    "override_total_1": 7917.23,
    "override_increase_1": 218.45
  },
  {
    "#": "38 St Paul St, Unit 1 (155-03-10)",
    "$": 722400,
    "address": "38 St Paul St, Unit 1",
    "parcel_id": "155-03-10",
    "owner1": "SHULMAN, TR, STANLEY",
    "owner2": "",
    "current_taxes": 7397.38,
    "new_taxes_no_override": 7716.95,
    "override_total_1": 7935.91,
    "override_increase_1": 218.96
  },
  {
    "#": "38 St Paul St, Unit 2 (155-03-08)",
    "$": 759900,
    "address": "38 St Paul St, Unit 2",
    "parcel_id": "155-03-08",
    "owner1": "DAMATO, LAURA",
    "owner2": "",
    "current_taxes": 4146.44,
    "new_taxes_no_override": 4325.57,
    "override_total_1": 4448.3,
    "override_increase_1": 122.73
  },
  {
    "#": "38 St Paul St, Unit 2 (155-03-11)",
    "$": 751200,
    "address": "38 St Paul St, Unit 2",
    "parcel_id": "155-03-11",
    "owner1": "AGHA, YUSUF M & LUBNA",
    "owner2": "",
    "current_taxes": 4057.35,
    "new_taxes_no_override": 4232.63,
    "override_total_1": 4352.73,
    "override_increase_1": 120.1
  },
  {
    "#": "38 St Paul St, Unit 3 (155-03-09)",
    "$": 759800,
    "address": "38 St Paul St, Unit 3",
    "parcel_id": "155-03-09",
    "owner1": "SILLS, LESLIE E",
    "owner2": "",
    "current_taxes": 4145.42,
    "new_taxes_no_override": 4324.5,
    "override_total_1": 4447.21,
    "override_increase_1": 122.7
  },
  {
    "#": "38 St Paul St, Unit 3 (155-03-12)",
    "$": 878300,
    "address": "38 St Paul St, Unit 3",
    "parcel_id": "155-03-12",
    "owner1": "MAO, XINDI",
    "owner2": "",
    "current_taxes": 5358.86,
    "new_taxes_no_override": 5590.36,
    "override_total_1": 5748.99,
    "override_increase_1": 158.62
  },
  {
    "#": "39 St Paul St, Unit 39-1 (132-03-24)",
    "$": 1106800,
    "address": "39 St Paul St, Unit 39-1",
    "parcel_id": "132-03-24",
    "owner1": "PERETZ, MOSHE",
    "owner2": "SAMUELS-PERETZ, DEBORAH",
    "current_taxes": 7698.7,
    "new_taxes_no_override": 8031.28,
    "override_total_1": 8259.17,
    "override_increase_1": 227.88
  },
  {
    "#": "39 St Paul St, Unit 39-2 (132-03-26)",
    "$": 1041000,
    "address": "39 St Paul St, Unit 39-2",
    "parcel_id": "132-03-26",
    "owner1": "LUKATSKY, MICHAEL",
    "owner2": "",
    "current_taxes": 10659.84,
    "new_taxes_no_override": 11120.35,
    "override_total_1": 11435.88,
    "override_increase_1": 315.53
  },
  {
    "#": "39 St Paul St, Unit 39-3 (132-03-25)",
    "$": 1079100,
    "address": "39 St Paul St, Unit 39-3",
    "parcel_id": "132-03-25",
    "owner1": "ASURI REALTY LLC",
    "owner2": "",
    "current_taxes": 11049.98,
    "new_taxes_no_override": 11527.34,
    "override_total_1": 11854.42,
    "override_increase_1": 327.08
  },
  {
    "#": "39 St Paul St, Unit 39-G1 (132-03-22)",
    "$": 434400,
    "address": "39 St Paul St, Unit 39-G1",
    "parcel_id": "132-03-22",
    "owner1": "YEE PHD TR, AMY S",
    "owner2": "",
    "current_taxes": 4448.26,
    "new_taxes_no_override": 4640.42,
    "override_total_1": 4772.09,
    "override_increase_1": 131.67
  },
  {
    "#": "39 St Paul St, Unit 39-G2 (132-03-23)",
    "$": 562500,
    "address": "39 St Paul St, Unit 39-G2",
    "parcel_id": "132-03-23",
    "owner1": "OSHEA TR, MAUREEN",
    "owner2": "",
    "current_taxes": 2125.07,
    "new_taxes_no_override": 2216.87,
    "override_total_1": 2279.78,
    "override_increase_1": 62.9
  },
  {
    "#": "40 St Paul St, Unit 1 (155-03-13)",
    "$": 612600,
    "address": "40 St Paul St, Unit 1",
    "parcel_id": "155-03-13",
    "owner1": "SINGLETON TRS, R PATRICK",
    "owner2": "KAHN, DOSSIE F",
    "current_taxes": 6273.02,
    "new_taxes_no_override": 6544.01,
    "override_total_1": 6729.7,
    "override_increase_1": 185.68
  },
  {
    "#": "40 St Paul St, Unit 1 (155-03-16)",
    "$": 612500,
    "address": "40 St Paul St, Unit 1",
    "parcel_id": "155-03-16",
    "owner1": "ROSE, DEBRA SUE",
    "owner2": "",
    "current_taxes": 2637.07,
    "new_taxes_no_override": 2750.99,
    "override_total_1": 2829.05,
    "override_increase_1": 78.06
  },
  {
    "#": "40 St Paul St, Unit 2 (155-03-14)",
    "$": 612500,
    "address": "40 St Paul St, Unit 2",
    "parcel_id": "155-03-14",
    "owner1": "KAUFMAN, KATHRYN A",
    "owner2": "",
    "current_taxes": 2637.07,
    "new_taxes_no_override": 2750.99,
    "override_total_1": 2829.05,
    "override_increase_1": 78.06
  },
  {
    "#": "40 St Paul St, Unit 2 (155-03-17)",
    "$": 612500,
    "address": "40 St Paul St, Unit 2",
    "parcel_id": "155-03-17",
    "owner1": "GERONIMUS, SUSAN R",
    "owner2": "",
    "current_taxes": 2637.07,
    "new_taxes_no_override": 2750.99,
    "override_total_1": 2829.05,
    "override_increase_1": 78.06
  },
  {
    "#": "40 St Paul St, Unit 3 (155-03-15)",
    "$": 618600,
    "address": "40 St Paul St, Unit 3",
    "parcel_id": "155-03-15",
    "owner1": "BAVERSTAM, KRISTIAN",
    "owner2": "MENERI, ENIDA",
    "current_taxes": 6334.46,
    "new_taxes_no_override": 6608.11,
    "override_total_1": 6795.61,
    "override_increase_1": 187.5
  },
  {
    "#": "40 St Paul St, Unit 3 (155-03-18)",
    "$": 638000,
    "address": "40 St Paul St, Unit 3",
    "parcel_id": "155-03-18",
    "owner1": "SHULMAN, TR, STANLEY",
    "owner2": "",
    "current_taxes": 6533.12,
    "new_taxes_no_override": 6815.35,
    "override_total_1": 7008.73,
    "override_increase_1": 193.38
  },
  {
    "#": "42 St Paul St, Unit 1 (155-03-19)",
    "$": 722400,
    "address": "42 St Paul St, Unit 1",
    "parcel_id": "155-03-19",
    "owner1": "SHULMAN, TR, STANLEY",
    "owner2": "",
    "current_taxes": 7397.38,
    "new_taxes_no_override": 7716.95,
    "override_total_1": 7935.91,
    "override_increase_1": 218.96
  },
  {
    "#": "42 St Paul St, Unit 1 (155-03-22)",
    "$": 736000,
    "address": "42 St Paul St, Unit 1",
    "parcel_id": "155-03-22",
    "owner1": "MAO, DAQIN",
    "owner2": "",
    "current_taxes": 3901.71,
    "new_taxes_no_override": 4070.26,
    "override_total_1": 4185.75,
    "override_increase_1": 115.49
  },
  {
    "#": "42 St Paul St, Unit 2 (155-03-20)",
    "$": 744100,
    "address": "42 St Paul St, Unit 2",
    "parcel_id": "155-03-20",
    "owner1": "SHULMAN, STANLEY & JOSHUA L",
    "owner2": "",
    "current_taxes": 7619.58,
    "new_taxes_no_override": 7948.75,
    "override_total_1": 8174.29,
    "override_increase_1": 225.54
  },
  {
    "#": "42 St Paul St, Unit 2 (155-03-23)",
    "$": 756600,
    "address": "42 St Paul St, Unit 2",
    "parcel_id": "155-03-23",
    "owner1": "SAVIKOVSKY, VLADIMIR & LENA",
    "owner2": "",
    "current_taxes": 7747.58,
    "new_taxes_no_override": 8082.28,
    "override_total_1": 8311.6,
    "override_increase_1": 229.33
  },
  {
    "#": "42 St Paul St, Unit 3 (155-03-21)",
    "$": 744100,
    "address": "42 St Paul St, Unit 3",
    "parcel_id": "155-03-21",
    "owner1": "OATES, CHRISTOPHER M",
    "owner2": "HAMER, PATRICIA",
    "current_taxes": 3984.65,
    "new_taxes_no_override": 4156.79,
    "override_total_1": 4274.73,
    "override_increase_1": 117.95
  },
  {
    "#": "42 St Paul St, Unit 3 (155-03-24)",
    "$": 744700,
    "address": "42 St Paul St, Unit 3",
    "parcel_id": "155-03-24",
    "owner1": "SHI, YANG",
    "owner2": "",
    "current_taxes": 7625.73,
    "new_taxes_no_override": 7955.16,
    "override_total_1": 8180.88,
    "override_increase_1": 225.72
  },
  {
    "#": "43 St Paul St (132-06-18)",
    "$": 4476800,
    "address": "43 St Paul St",
    "parcel_id": "132-06-18",
    "owner1": "UNITED S REALTY LLC",
    "owner2": "",
    "current_taxes": 45842.43,
    "new_taxes_no_override": 47822.82,
    "override_total_1": 49179.76,
    "override_increase_1": 1356.94
  },
  {
    "#": "44 St Paul St, Unit 1 (155-03-25)",
    "$": 741000,
    "address": "44 St Paul St, Unit 1",
    "parcel_id": "155-03-25",
    "owner1": "PAPADAKIS, ANDREAS B",
    "owner2": "",
    "current_taxes": 3952.91,
    "new_taxes_no_override": 4123.68,
    "override_total_1": 4240.68,
    "override_increase_1": 117.01
  },
  {
    "#": "44 St Paul St, Unit 1 (155-03-29)",
    "$": 703200,
    "address": "44 St Paul St, Unit 1",
    "parcel_id": "155-03-29",
    "owner1": "SHULMAN, TR, STANLEY",
    "owner2": "",
    "current_taxes": 7200.77,
    "new_taxes_no_override": 7511.84,
    "override_total_1": 7724.99,
    "override_increase_1": 213.14
  },
  {
    "#": "44 St Paul St, Unit 2 (155-03-26)",
    "$": 759800,
    "address": "44 St Paul St, Unit 2",
    "parcel_id": "155-03-26",
    "owner1": "GOPALAKRISHNAN, DINESH",
    "owner2": "SUNDARARAJAN, SOWMYA",
    "current_taxes": 4145.42,
    "new_taxes_no_override": 4324.5,
    "override_total_1": 4447.21,
    "override_increase_1": 122.7
  },
  {
    "#": "44 St Paul St, Unit 2 (155-03-30)",
    "$": 722800,
    "address": "44 St Paul St, Unit 2",
    "parcel_id": "155-03-30",
    "owner1": "SHULMAN, TR, STANLEY",
    "owner2": "",
    "current_taxes": 7401.47,
    "new_taxes_no_override": 7721.21,
    "override_total_1": 7940.3,
    "override_increase_1": 219.08
  },
  {
    "#": "44 St Paul St, Unit 3 (155-03-27)",
    "$": 770000,
    "address": "44 St Paul St, Unit 3",
    "parcel_id": "155-03-27",
    "owner1": "MA, YIDAN",
    "owner2": "WEI, ZIMING",
    "current_taxes": 7884.8,
    "new_taxes_no_override": 8225.42,
    "override_total_1": 8458.81,
    "override_increase_1": 233.39
  },
  {
    "#": "44 St Paul St, Unit 3 (155-03-31)",
    "$": 738100,
    "address": "44 St Paul St, Unit 3",
    "parcel_id": "155-03-31",
    "owner1": "SHULMAN, TR, STANLEY",
    "owner2": "",
    "current_taxes": 7558.14,
    "new_taxes_no_override": 7884.65,
    "override_total_1": 8108.37,
    "override_increase_1": 223.72
  },
  {
    "#": "44 St Paul St, Unit B (155-03-28)",
    "$": 540700,
    "address": "44 St Paul St, Unit B",
    "parcel_id": "155-03-28",
    "owner1": "PRESS, GIL",
    "owner2": "GREENFELD, LIAH",
    "current_taxes": 5536.77,
    "new_taxes_no_override": 5775.96,
    "override_total_1": 5939.85,
    "override_increase_1": 163.89
  },
  {
    "#": "50 St Paul St, Unit 1 (155-01-28)",
    "$": 627500,
    "address": "50 St Paul St, Unit 1",
    "parcel_id": "155-01-28",
    "owner1": "SHOPPER, MOLLY",
    "owner2": "",
    "current_taxes": 2790.67,
    "new_taxes_no_override": 2911.23,
    "override_total_1": 2993.83,
    "override_increase_1": 82.6
  },
  {
    "#": "50 St Paul St, Unit 2 (155-01-01)",
    "$": 738200,
    "address": "50 St Paul St, Unit 2",
    "parcel_id": "155-01-01",
    "owner1": "ALEXANDROV TR, JARRED J",
    "owner2": "",
    "current_taxes": 3924.23,
    "new_taxes_no_override": 4093.76,
    "override_total_1": 4209.91,
    "override_increase_1": 116.16
  },
  {
    "#": "50 St Paul St, Unit 3 (155-01-02)",
    "$": 689300,
    "address": "50 St Paul St, Unit 3",
    "parcel_id": "155-01-02",
    "owner1": "HOUSMAN, LOUISE M & DAVID E",
    "owner2": "",
    "current_taxes": 7058.43,
    "new_taxes_no_override": 7363.35,
    "override_total_1": 7572.28,
    "override_increase_1": 208.93
  },
  {
    "#": "50 St Paul St, Unit 4 (155-01-03)",
    "$": 705400,
    "address": "50 St Paul St, Unit 4",
    "parcel_id": "155-01-03",
    "owner1": "HUANG TRS, YAN-YU",
    "owner2": "CHEN, YAN-JIUN",
    "current_taxes": 7223.3,
    "new_taxes_no_override": 7535.35,
    "override_total_1": 7749.16,
    "override_increase_1": 213.81
  },
  {
    "#": "50 St Paul St, Unit 5 (155-01-04)",
    "$": 837400,
    "address": "50 St Paul St, Unit 5",
    "parcel_id": "155-01-04",
    "owner1": "ZHANG, LEI",
    "owner2": "",
    "current_taxes": 8574.98,
    "new_taxes_no_override": 8945.42,
    "override_total_1": 9199.24,
    "override_increase_1": 253.82
  },
  {
    "#": "50 St Paul St, Unit 6 (155-01-05)",
    "$": 883500,
    "address": "50 St Paul St, Unit 6",
    "parcel_id": "155-01-05",
    "owner1": "HOLMES TRS, CAROLYN ROCK",
    "owner2": "ROCK, ROBERT",
    "current_taxes": 9047.04,
    "new_taxes_no_override": 9437.87,
    "override_total_1": 9705.66,
    "override_increase_1": 267.79
  },
  {
    "#": "51 St Paul St, Unit 201& G5-6 (132-07-01)",
    "$": 1933300,
    "address": "51 St Paul St, Unit 201& G5-6",
    "parcel_id": "132-07-01",
    "owner1": "DOWLATSHAHI, ARRIYAN S",
    "owner2": "",
    "current_taxes": 16162.06,
    "new_taxes_no_override": 16860.26,
    "override_total_1": 17338.66,
    "override_increase_1": 478.4
  },
  {
    "#": "51 St Paul St, Unit 202 &G7-8 (132-07-02)",
    "$": 2029500,
    "address": "51 St Paul St, Unit 202 &G7-8",
    "parcel_id": "132-07-02",
    "owner1": "PRASANNA, NIHAR",
    "owner2": "KANJI, TASNEEM",
    "current_taxes": 17147.15,
    "new_taxes_no_override": 17887.91,
    "override_total_1": 18395.46,
    "override_increase_1": 507.56
  },
  {
    "#": "51 St Paul St, Unit 301 &G3-4 (132-07-03)",
    "$": 2061200,
    "address": "51 St Paul St, Unit 301 &G3-4",
    "parcel_id": "132-07-03",
    "owner1": "LANDAY, JONATHAN I",
    "owner2": "",
    "current_taxes": 21106.69,
    "new_taxes_no_override": 22018.5,
    "override_total_1": 22643.26,
    "override_increase_1": 624.76
  },
  {
    "#": "51 St Paul St, Unit 302 &G1-2 (132-07-04)",
    "$": 2045300,
    "address": "51 St Paul St, Unit 302 &G1-2",
    "parcel_id": "132-07-04",
    "owner1": "PONCE, SILVIA A & FERNANDO F",
    "owner2": "",
    "current_taxes": 17308.94,
    "new_taxes_no_override": 18056.69,
    "override_total_1": 18569.03,
    "override_increase_1": 512.34
  },
  {
    "#": "52 St Paul St, Unit B (155-01-06)",
    "$": 403900,
    "address": "52 St Paul St, Unit B",
    "parcel_id": "155-01-06",
    "owner1": "FENG, MARGIE",
    "owner2": "SASSAMAN, ERIK",
    "current_taxes": 4135.94,
    "new_taxes_no_override": 4314.61,
    "override_total_1": 4437.04,
    "override_increase_1": 122.42
  },
  {
    "#": "53 St Paul St, Unit 1 & P53-3 (132-08-01)",
    "$": 490900,
    "address": "53 St Paul St, Unit 1 & P53-3",
    "parcel_id": "132-08-01",
    "owner1": "SUTTNER, ROSS & ADELE",
    "owner2": "",
    "current_taxes": 5026.82,
    "new_taxes_no_override": 5243.98,
    "override_total_1": 5392.77,
    "override_increase_1": 148.79
  },
  {
    "#": "53 St Paul St, Unit 2 & P53-2 (132-08-02)",
    "$": 826400,
    "address": "53 St Paul St, Unit 2 & P53-2",
    "parcel_id": "132-08-02",
    "owner1": "LAZARUS, HARRIET J",
    "owner2": "",
    "current_taxes": 4827.4,
    "new_taxes_no_override": 5035.94,
    "override_total_1": 5178.83,
    "override_increase_1": 142.89
  },
  {
    "#": "53 St Paul St, Unit 3 & P53-1 (132-08-03)",
    "$": 777200,
    "address": "53 St Paul St, Unit 3 & P53-1",
    "parcel_id": "132-08-03",
    "owner1": "CHEN, WENDY",
    "owner2": "",
    "current_taxes": 4323.59,
    "new_taxes_no_override": 4510.37,
    "override_total_1": 4638.35,
    "override_increase_1": 127.98
  },
  {
    "#": "53 St Paul St, Unit 4 (132-08-04)",
    "$": 512200,
    "address": "53 St Paul St, Unit 4",
    "parcel_id": "132-08-04",
    "owner1": "MOSTAFAVIAN TR, SARA",
    "owner2": "",
    "current_taxes": 5244.93,
    "new_taxes_no_override": 5471.51,
    "override_total_1": 5626.76,
    "override_increase_1": 155.25
  },
  {
    "#": "53 St Paul St, Unit 5 & P53A-3 (132-08-05)",
    "$": 478300,
    "address": "53 St Paul St, Unit 5 & P53A-3",
    "parcel_id": "132-08-05",
    "owner1": "MEDINA ABARCA, HECTOR FRANCISCO",
    "owner2": "",
    "current_taxes": 4897.79,
    "new_taxes_no_override": 5109.37,
    "override_total_1": 5254.35,
    "override_increase_1": 144.97
  },
  {
    "#": "53 St Paul St, Unit 6 & P53A-2 (132-08-06)",
    "$": 777200,
    "address": "53 St Paul St, Unit 6 & P53A-2",
    "parcel_id": "132-08-06",
    "owner1": "ZLATIN, MICHAEL & SVETLANA",
    "owner2": "",
    "current_taxes": 4323.59,
    "new_taxes_no_override": 4510.37,
    "override_total_1": 4638.35,
    "override_increase_1": 127.98
  },
  {
    "#": "53 St Paul St, Unit 7 & P53A-1 (132-08-07)",
    "$": 777300,
    "address": "53 St Paul St, Unit 7 & P53A-1",
    "parcel_id": "132-08-07",
    "owner1": "53A ST PAUL STREET LLC",
    "owner2": "",
    "current_taxes": 7959.55,
    "new_taxes_no_override": 8303.4,
    "override_total_1": 8539.01,
    "override_increase_1": 235.6
  },
  {
    "#": "55 St Paul St, Unit 10 & P10 (132-08-10)",
    "$": 803600,
    "address": "55 St Paul St, Unit 10 & P10",
    "parcel_id": "132-08-10",
    "owner1": "STEIN, CYNTHIA",
    "owner2": "",
    "current_taxes": 8228.86,
    "new_taxes_no_override": 8584.35,
    "override_total_1": 8827.92,
    "override_increase_1": 243.57
  },
  {
    "#": "55 St Paul St, Unit 11 & P11 (132-08-11)",
    "$": 777200,
    "address": "55 St Paul St, Unit 11 & P11",
    "parcel_id": "132-08-11",
    "owner1": "GORNAYA ET AL, IRINA",
    "owner2": "GORNYY , SEMEN I",
    "current_taxes": 7958.53,
    "new_taxes_no_override": 8302.34,
    "override_total_1": 8537.91,
    "override_increase_1": 235.57
  },
  {
    "#": "55 St Paul St, Unit 12 (132-08-12)",
    "$": 481800,
    "address": "55 St Paul St, Unit 12",
    "parcel_id": "132-08-12",
    "owner1": "EAK PROPERTY LLC",
    "owner2": "",
    "current_taxes": 4933.63,
    "new_taxes_no_override": 5146.76,
    "override_total_1": 5292.8,
    "override_increase_1": 146.04
  },
  {
    "#": "55 St Paul St, Unit 13 P55A-3 (132-08-13)",
    "$": 491200,
    "address": "55 St Paul St, Unit 13 P55A-3",
    "parcel_id": "132-08-13",
    "owner1": "BELL, ERIC G",
    "owner2": "",
    "current_taxes": 1394.95,
    "new_taxes_no_override": 1455.21,
    "override_total_1": 1496.5,
    "override_increase_1": 41.29
  },
  {
    "#": "55 St Paul St, Unit 14 P55A-2 (132-08-14)",
    "$": 777200,
    "address": "55 St Paul St, Unit 14 P55A-2",
    "parcel_id": "132-08-14",
    "owner1": "BERNSTEIN TRS, EUGENE & FLYURA",
    "owner2": "",
    "current_taxes": 4323.59,
    "new_taxes_no_override": 4510.37,
    "override_total_1": 4638.35,
    "override_increase_1": 127.98
  },
  {
    "#": "55 St Paul St, Unit 15 (132-08-15)",
    "$": 777200,
    "address": "55 St Paul St, Unit 15",
    "parcel_id": "132-08-15",
    "owner1": "BEZRI LIFE ESTATE, FELICE",
    "owner2": "",
    "current_taxes": 7958.53,
    "new_taxes_no_override": 8302.34,
    "override_total_1": 8537.91,
    "override_increase_1": 235.57
  },
  {
    "#": "55 St Paul St, Unit 8 & P55-4 (132-08-08)",
    "$": 431900,
    "address": "55 St Paul St, Unit 8 & P55-4",
    "parcel_id": "132-08-08",
    "owner1": "ALVAREZ, MELISSA L & DANIEL J",
    "owner2": "",
    "current_taxes": 787.72,
    "new_taxes_no_override": 821.75,
    "override_total_1": 845.07,
    "override_increase_1": 23.32
  },
  {
    "#": "55 St Paul St, Unit 9 (132-08-09)",
    "$": 489600,
    "address": "55 St Paul St, Unit 9",
    "parcel_id": "132-08-09",
    "owner1": "STERNFIELD TR, VIVIAN",
    "owner2": "",
    "current_taxes": 1378.57,
    "new_taxes_no_override": 1438.12,
    "override_total_1": 1478.93,
    "override_increase_1": 40.81
  },
  {
    "#": "57 St Paul St, Unit 16 & P57-4 (132-08-16)",
    "$": 491500,
    "address": "57 St Paul St, Unit 16 & P57-4",
    "parcel_id": "132-08-16",
    "owner1": "AVILA-FIGUEROA, RAFAEL C & ANA MARIA",
    "owner2": "",
    "current_taxes": 5032.96,
    "new_taxes_no_override": 5250.38,
    "override_total_1": 5399.36,
    "override_increase_1": 148.98
  },
  {
    "#": "57 St Paul St, Unit 17 & P57-3 (132-08-17)",
    "$": 426800,
    "address": "57 St Paul St, Unit 17 & P57-3",
    "parcel_id": "132-08-17",
    "owner1": "TREMBLAY, NANCY",
    "owner2": "GOLD, LARRY S",
    "current_taxes": 735.5,
    "new_taxes_no_override": 767.27,
    "override_total_1": 789.04,
    "override_increase_1": 21.77
  },
  {
    "#": "57 St Paul St, Unit 18 & P57-2 (132-08-18)",
    "$": 721000,
    "address": "57 St Paul St, Unit 18 & P57-2",
    "parcel_id": "132-08-18",
    "owner1": "CHOI TRS, YOON JEAN",
    "owner2": "LEE, MYOUNG HEE",
    "current_taxes": 3748.11,
    "new_taxes_no_override": 3910.03,
    "override_total_1": 4020.97,
    "override_increase_1": 110.94
  },
  {
    "#": "57 St Paul St, Unit 19 (132-08-19)",
    "$": 783300,
    "address": "57 St Paul St, Unit 19",
    "parcel_id": "132-08-19",
    "owner1": "R E A REAL ESTATE LLC",
    "owner2": "",
    "current_taxes": 8020.99,
    "new_taxes_no_override": 8367.5,
    "override_total_1": 8604.92,
    "override_increase_1": 237.42
  },
  {
    "#": "57 St Paul St, Unit 20 P57A-4 (132-08-20)",
    "$": 486300,
    "address": "57 St Paul St, Unit 20 P57A-4",
    "parcel_id": "132-08-20",
    "owner1": "FAWAZ-ISTFAN, RANDA",
    "owner2": "ISTFAN, NAWAL W",
    "current_taxes": 4979.71,
    "new_taxes_no_override": 5194.83,
    "override_total_1": 5342.23,
    "override_increase_1": 147.4
  },
  {
    "#": "57 St Paul St, Unit 21 P57A-3 (132-08-21)",
    "$": 486600,
    "address": "57 St Paul St, Unit 21 P57A-3",
    "parcel_id": "132-08-21",
    "owner1": "MEYERS TR, MICHAEL C",
    "owner2": "FEINGOLD-MEYERS TR, AMY",
    "current_taxes": 4982.78,
    "new_taxes_no_override": 5198.04,
    "override_total_1": 5345.53,
    "override_increase_1": 147.49
  },
  {
    "#": "57 St Paul St, Unit 22-P57A-2 (132-08-22)",
    "$": 798900,
    "address": "57 St Paul St, Unit 22-P57A-2",
    "parcel_id": "132-08-22",
    "owner1": "HG PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 8180.74,
    "new_taxes_no_override": 8534.15,
    "override_total_1": 8776.3,
    "override_increase_1": 242.15
  },
  {
    "#": "57 St Paul St, Unit 23 P57A-1 (132-08-23)",
    "$": 783300,
    "address": "57 St Paul St, Unit 23 P57A-1",
    "parcel_id": "132-08-23",
    "owner1": "GUO, JUN",
    "owner2": "DUAN, ZIAOCHU",
    "current_taxes": 4386.06,
    "new_taxes_no_override": 4575.54,
    "override_total_1": 4705.37,
    "override_increase_1": 129.83
  },
  {
    "#": "59 St Paul St, Unit 24 & P59-4 (132-08-24)",
    "$": 471300,
    "address": "59 St Paul St, Unit 24 & P59-4",
    "parcel_id": "132-08-24",
    "owner1": "ONG, MEI SING",
    "owner2": "NATTER, MARC",
    "current_taxes": 4826.11,
    "new_taxes_no_override": 5034.6,
    "override_total_1": 5177.45,
    "override_increase_1": 142.85
  },
  {
    "#": "59 St Paul St, Unit 25 & P59-3 (132-08-25)",
    "$": 490800,
    "address": "59 St Paul St, Unit 25 & P59-3",
    "parcel_id": "132-08-25",
    "owner1": "WHILOCK, ASHLYN E",
    "owner2": "",
    "current_taxes": 5025.79,
    "new_taxes_no_override": 5242.9,
    "override_total_1": 5391.67,
    "override_increase_1": 148.76
  },
  {
    "#": "59 St Paul St, Unit 26 & P59-2 (132-08-26)",
    "$": 783500,
    "address": "59 St Paul St, Unit 26 & P59-2",
    "parcel_id": "132-08-26",
    "owner1": "GUTMAN, JUDITH & RICHARD",
    "owner2": "",
    "current_taxes": 8023.04,
    "new_taxes_no_override": 8369.64,
    "override_total_1": 8607.12,
    "override_increase_1": 237.48
  },
  {
    "#": "59 St Paul St, Unit 27 & P59-1 (132-08-27)",
    "$": 783500,
    "address": "59 St Paul St, Unit 27 & P59-1",
    "parcel_id": "132-08-27",
    "owner1": "CARRILLO, JAMIE & AMANDA",
    "owner2": "",
    "current_taxes": 8023.04,
    "new_taxes_no_override": 8369.64,
    "override_total_1": 8607.12,
    "override_increase_1": 237.48
  },
  {
    "#": "59 St Paul St, Unit 28 (132-08-28)",
    "$": 496000,
    "address": "59 St Paul St, Unit 28",
    "parcel_id": "132-08-28",
    "owner1": "DESIMONE TR, VIVIANA",
    "owner2": "",
    "current_taxes": 5079.04,
    "new_taxes_no_override": 5298.45,
    "override_total_1": 5448.79,
    "override_increase_1": 150.34
  },
  {
    "#": "59 St Paul St, Unit 29 P59A-2 (132-08-29)",
    "$": 826300,
    "address": "59 St Paul St, Unit 29 P59A-2",
    "parcel_id": "132-08-29",
    "owner1": "JIANG, HONG & GINGER YU FEI",
    "owner2": "KE, JUNE JIONG",
    "current_taxes": 4826.38,
    "new_taxes_no_override": 5034.88,
    "override_total_1": 5177.74,
    "override_increase_1": 142.86
  },
  {
    "#": "59 St Paul St, Unit 30 P59A-1 (132-08-30)",
    "$": 811400,
    "address": "59 St Paul St, Unit 30 P59A-1",
    "parcel_id": "132-08-30",
    "owner1": "LI, XIAOYU",
    "owner2": "BU, XIA",
    "current_taxes": 4673.8,
    "new_taxes_no_override": 4875.71,
    "override_total_1": 5014.05,
    "override_increase_1": 138.34
  },
  {
    "#": "65 St Paul St, Unit 1 (132-09-02)",
    "$": 1201400,
    "address": "65 St Paul St, Unit 1",
    "parcel_id": "132-09-02",
    "owner1": "LOGIN TRS, GARY L & MINDA A",
    "owner2": "",
    "current_taxes": 8667.4,
    "new_taxes_no_override": 9041.83,
    "override_total_1": 9298.39,
    "override_increase_1": 256.56
  },
  {
    "#": "67 St Paul St, Unit 2 (132-09-01)",
    "$": 1626400,
    "address": "67 St Paul St, Unit 2",
    "parcel_id": "132-09-01",
    "owner1": "WAIKAR, SUSHRUT S",
    "owner2": "BHAREL, MONICA",
    "current_taxes": 13019.4,
    "new_taxes_no_override": 13581.84,
    "override_total_1": 13967.21,
    "override_increase_1": 385.37
  },
  {
    "#": "75 St Paul St (126-22-02)",
    "$": 1072900,
    "address": "75 St Paul St",
    "parcel_id": "126-22-02",
    "owner1": "ZHONG, BIAO",
    "owner2": "",
    "current_taxes": 7351.56,
    "new_taxes_no_override": 7669.15,
    "override_total_1": 7886.75,
    "override_increase_1": 217.61
  },
  {
    "#": "79 St Paul St, Unit 1 (126-23-01)",
    "$": 1691800,
    "address": "79 St Paul St, Unit 1",
    "parcel_id": "126-23-01",
    "owner1": "PENALOZA, PABLO",
    "owner2": "MIHALCIK, STEPHEN",
    "current_taxes": 13689.1,
    "new_taxes_no_override": 14280.47,
    "override_total_1": 14685.67,
    "override_increase_1": 405.2
  },
  {
    "#": "79 St Paul St, Unit 2 (126-23-02)",
    "$": 1595400,
    "address": "79 St Paul St, Unit 2",
    "parcel_id": "126-23-02",
    "owner1": "ISAKOV, YONATHAN & NOA LIBERMAN",
    "owner2": "",
    "current_taxes": 12701.96,
    "new_taxes_no_override": 13250.68,
    "override_total_1": 13626.66,
    "override_increase_1": 375.98
  },
  {
    "#": "83 St Paul St, Unit 1 & Gar 1 (126-24-01)",
    "$": 1552700,
    "address": "83 St Paul St, Unit 1 & Gar 1",
    "parcel_id": "126-24-01",
    "owner1": "KONEVSKY TRS, SERGE M",
    "owner2": "VOLKOV, REGINA S",
    "current_taxes": 12264.71,
    "new_taxes_no_override": 12794.55,
    "override_total_1": 13157.58,
    "override_increase_1": 363.04
  },
  {
    "#": "83 St Paul St, Unit 2 & Gar 2 (126-24-02)",
    "$": 1580500,
    "address": "83 St Paul St, Unit 2 & Gar 2",
    "parcel_id": "126-24-02",
    "owner1": "ZIMON, ALISON E",
    "owner2": "",
    "current_taxes": 16184.32,
    "new_taxes_no_override": 16883.48,
    "override_total_1": 17362.54,
    "override_increase_1": 479.06
  },
  {
    "#": "89 St Paul St, Unit 1&P1 P2 (126-25-01)",
    "$": 959800,
    "address": "89 St Paul St, Unit 1&P1 P2",
    "parcel_id": "126-25-01",
    "owner1": "MALLERY, ROBERT",
    "owner2": "HUCKFELDT, RACHEL",
    "current_taxes": 6193.42,
    "new_taxes_no_override": 6460.98,
    "override_total_1": 6644.3,
    "override_increase_1": 183.33
  },
  {
    "#": "89 St Paul St, Unit 2&P5 P6 (126-25-02)",
    "$": 1116900,
    "address": "89 St Paul St, Unit 2&P5 P6",
    "parcel_id": "126-25-02",
    "owner1": "FLEISHMAN, PAUL",
    "owner2": "ARONOV, LARISA",
    "current_taxes": 7802.12,
    "new_taxes_no_override": 8139.17,
    "override_total_1": 8370.11,
    "override_increase_1": 230.94
  },
  {
    "#": "89 St Paul St, Unit 3&P3 P4 (126-25-03)",
    "$": 869200,
    "address": "89 St Paul St, Unit 3&P3 P4",
    "parcel_id": "126-25-03",
    "owner1": "ICENOGLE, BENJAMIN D",
    "owner2": "",
    "current_taxes": 5265.67,
    "new_taxes_no_override": 5493.15,
    "override_total_1": 5649.01,
    "override_increase_1": 155.86
  },
  {
    "#": "93 St Paul St, Unit 1 (126-42-01)",
    "$": 1245800,
    "address": "93 St Paul St, Unit 1",
    "parcel_id": "126-42-01",
    "owner1": "JONES, RICHARD O & BETH L",
    "owner2": "",
    "current_taxes": 9122.06,
    "new_taxes_no_override": 9516.13,
    "override_total_1": 9786.15,
    "override_increase_1": 270.01
  },
  {
    "#": "93 St Paul St, Unit 2 (126-42-02)",
    "$": 1527100,
    "address": "93 St Paul St, Unit 2",
    "parcel_id": "126-42-02",
    "owner1": "MUELBERT, PHILIPP & BRIDGET M",
    "owner2": "",
    "current_taxes": 12002.57,
    "new_taxes_no_override": 12521.08,
    "override_total_1": 12876.36,
    "override_increase_1": 355.28
  },
  {
    "#": "96 St Paul St, Unit 1 (158-01-02)",
    "$": 531100,
    "address": "96 St Paul St, Unit 1",
    "parcel_id": "158-01-02",
    "owner1": "JOSEPHENE ST PAUL LLC",
    "owner2": "",
    "current_taxes": 5438.46,
    "new_taxes_no_override": 5673.4,
    "override_total_1": 5834.38,
    "override_increase_1": 160.98
  },
  {
    "#": "96 St Paul St, Unit 2 (158-01-03)",
    "$": 910300,
    "address": "96 St Paul St, Unit 2",
    "parcel_id": "158-01-03",
    "owner1": "FEIT TRS, ZEEV & HAVA",
    "owner2": "",
    "current_taxes": 9321.47,
    "new_taxes_no_override": 9724.16,
    "override_total_1": 10000.07,
    "override_increase_1": 275.92
  },
  {
    "#": "96 St Paul St, Unit 3 (158-01-04)",
    "$": 748300,
    "address": "96 St Paul St, Unit 3",
    "parcel_id": "158-01-04",
    "owner1": "WANG, PEIJIANG",
    "owner2": "",
    "current_taxes": 7662.59,
    "new_taxes_no_override": 7993.61,
    "override_total_1": 8220.43,
    "override_increase_1": 226.81
  },
  {
    "#": "96 St Paul St, Unit 4 (158-01-05)",
    "$": 777500,
    "address": "96 St Paul St, Unit 4",
    "parcel_id": "158-01-05",
    "owner1": "LEW TRS, ALLAN S",
    "owner2": "",
    "current_taxes": 7961.6,
    "new_taxes_no_override": 8305.54,
    "override_total_1": 8541.2,
    "override_increase_1": 235.66
  },
  {
    "#": "96 St Paul St, Unit 5 (158-01-06)",
    "$": 683800,
    "address": "96 St Paul St, Unit 5",
    "parcel_id": "158-01-06",
    "owner1": "ZHOU, DANJIE",
    "owner2": "WU, JIA",
    "current_taxes": 7002.11,
    "new_taxes_no_override": 7304.6,
    "override_total_1": 7511.86,
    "override_increase_1": 207.26
  },
  {
    "#": "96 St Paul St, Unit 6 (158-01-07)",
    "$": 903100,
    "address": "96 St Paul St, Unit 6",
    "parcel_id": "158-01-07",
    "owner1": "LIVANIS, MARIA C & GRIGORIOS",
    "owner2": "",
    "current_taxes": 9247.74,
    "new_taxes_no_override": 9647.24,
    "override_total_1": 9920.98,
    "override_increase_1": 273.73
  },
  {
    "#": "96 St Paul St, Unit A-1 (158-01-15)",
    "$": 469300,
    "address": "96 St Paul St, Unit A-1",
    "parcel_id": "158-01-15",
    "owner1": "AHMADI, GHULAM YAHYA & SHOKRIA",
    "owner2": "",
    "current_taxes": 1170.7,
    "new_taxes_no_override": 1221.27,
    "override_total_1": 1255.93,
    "override_increase_1": 34.65
  },
  {
    "#": "96 St Paul St, Unit A-2 (158-01-01)",
    "$": 422200,
    "address": "96 St Paul St, Unit A-2",
    "parcel_id": "158-01-01",
    "owner1": "FIELD, MICHAEL L",
    "owner2": "",
    "current_taxes": 688.39,
    "new_taxes_no_override": 718.13,
    "override_total_1": 738.5,
    "override_increase_1": 20.38
  },
  {
    "#": "97 St Paul St, Unit 1 (126-43-01)",
    "$": 1111800,
    "address": "97 St Paul St, Unit 1",
    "parcel_id": "126-43-01",
    "owner1": "LANCKTON, BENJAMIN E",
    "owner2": "LINCOLN, ALISA K",
    "current_taxes": 7749.9,
    "new_taxes_no_override": 8084.7,
    "override_total_1": 8314.09,
    "override_increase_1": 229.4
  },
  {
    "#": "97 St Paul St, Unit 2 (126-43-02)",
    "$": 1606700,
    "address": "97 St Paul St, Unit 2",
    "parcel_id": "126-43-02",
    "owner1": "FINUCANE, MARIEL",
    "owner2": "",
    "current_taxes": 12817.67,
    "new_taxes_no_override": 13371.39,
    "override_total_1": 13750.8,
    "override_increase_1": 379.4
  },
  {
    "#": "98 St Paul St, Unit 1 (158-01-09)",
    "$": 580200,
    "address": "98 St Paul St, Unit 1",
    "parcel_id": "158-01-09",
    "owner1": "ZINORI, ETAN",
    "owner2": "",
    "current_taxes": 2306.31,
    "new_taxes_no_override": 2405.94,
    "override_total_1": 2474.21,
    "override_increase_1": 68.27
  },
  {
    "#": "98 St Paul St, Unit 2 (158-01-10)",
    "$": 551300,
    "address": "98 St Paul St, Unit 2",
    "parcel_id": "158-01-10",
    "owner1": "LIU ET AL, KAI",
    "owner2": "CAI, QING",
    "current_taxes": 5645.31,
    "new_taxes_no_override": 5889.19,
    "override_total_1": 6056.29,
    "override_increase_1": 167.1
  },
  {
    "#": "98 St Paul St, Unit 3 (158-01-11)",
    "$": 662200,
    "address": "98 St Paul St, Unit 3",
    "parcel_id": "158-01-11",
    "owner1": "FAN, ANNE",
    "owner2": "",
    "current_taxes": 6780.93,
    "new_taxes_no_override": 7073.87,
    "override_total_1": 7274.58,
    "override_increase_1": 200.72
  },
  {
    "#": "98 St Paul St, Unit 4 (158-01-12)",
    "$": 628200,
    "address": "98 St Paul St, Unit 4",
    "parcel_id": "158-01-12",
    "owner1": "SHEN ET AL, QI",
    "owner2": "XIA , BING",
    "current_taxes": 6432.77,
    "new_taxes_no_override": 6710.67,
    "override_total_1": 6901.08,
    "override_increase_1": 190.41
  },
  {
    "#": "98 St Paul St, Unit 5 (158-01-13)",
    "$": 712700,
    "address": "98 St Paul St, Unit 5",
    "parcel_id": "158-01-13",
    "owner1": "PRICE-DIERKSEN, BRONWEN LEIGH",
    "owner2": "",
    "current_taxes": 7298.05,
    "new_taxes_no_override": 7613.33,
    "override_total_1": 7829.35,
    "override_increase_1": 216.02
  },
  {
    "#": "98 St Paul St, Unit 6 (158-01-14)",
    "$": 603900,
    "address": "98 St Paul St, Unit 6",
    "parcel_id": "158-01-14",
    "owner1": "ZHANG, VERONICA & YANJIA J",
    "owner2": "",
    "current_taxes": 6183.94,
    "new_taxes_no_override": 6451.09,
    "override_total_1": 6634.13,
    "override_increase_1": 183.04
  },
  {
    "#": "98 St Paul St, Unit A-1 (158-01-08)",
    "$": 583200,
    "address": "98 St Paul St, Unit A-1",
    "parcel_id": "158-01-08",
    "owner1": "KUPCHA, ANNA",
    "owner2": "",
    "current_taxes": 2337.03,
    "new_taxes_no_override": 2437.99,
    "override_total_1": 2507.17,
    "override_increase_1": 69.18
  },
  {
    "#": "100 St Paul St, Unit 101 & P10-11 (158-24-01)",
    "$": 1647400,
    "address": "100 St Paul St, Unit 101 & P10-11",
    "parcel_id": "158-24-01",
    "owner1": "FLETCHER, JONATHAN & THESPINA",
    "owner2": "",
    "current_taxes": 13234.44,
    "new_taxes_no_override": 13806.17,
    "override_total_1": 14197.91,
    "override_increase_1": 391.74
  },
  {
    "#": "100 St Paul St, Unit 102&G8G9 (158-24-02)",
    "$": 1803300,
    "address": "100 St Paul St, Unit 102&G8G9",
    "parcel_id": "158-24-02",
    "owner1": "WILLIS, CLAIRE B",
    "owner2": "",
    "current_taxes": 14830.86,
    "new_taxes_no_override": 15471.55,
    "override_total_1": 15910.55,
    "override_increase_1": 438.99
  },
  {
    "#": "100 St Paul St, Unit 201&G1G2 (158-24-03)",
    "$": 1891300,
    "address": "100 St Paul St, Unit 201&G1G2",
    "parcel_id": "158-24-03",
    "owner1": "BURKE, TIMOTHY J",
    "owner2": "",
    "current_taxes": 15731.98,
    "new_taxes_no_override": 16411.6,
    "override_total_1": 16877.27,
    "override_increase_1": 465.67
  },
  {
    "#": "100 St Paul St, Unit 202&G3G4 (158-24-04)",
    "$": 1857500,
    "address": "100 St Paul St, Unit 202&G3G4",
    "parcel_id": "158-24-04",
    "owner1": "KRUSKAL, KAREN L",
    "owner2": "STRICK, SHEERA L",
    "current_taxes": 15385.87,
    "new_taxes_no_override": 16050.54,
    "override_total_1": 16505.96,
    "override_increase_1": 455.42
  },
  {
    "#": "100 St Paul St, Unit 301 & 3 Pksps (158-24-05)",
    "$": 2366500,
    "address": "100 St Paul St, Unit 301 & 3 Pksps",
    "parcel_id": "158-24-05",
    "owner1": "ROSSE, JONATHAN",
    "owner2": "",
    "current_taxes": 20598.03,
    "new_taxes_no_override": 21487.86,
    "override_total_1": 22097.57,
    "override_increase_1": 609.7
  },
  {
    "#": "100 St Paul St, Unit G5 (158-24-06)",
    "$": 88500,
    "address": "100 St Paul St, Unit G5",
    "parcel_id": "158-24-06",
    "owner1": "KRUSKAL, KAREN L",
    "owner2": "STRICK, SHEERA L",
    "current_taxes": 906.24,
    "new_taxes_no_override": 945.39,
    "override_total_1": 972.21,
    "override_increase_1": 26.82
  },
  {
    "#": "101 St Paul St (126-44-00)",
    "$": 2109600,
    "address": "101 St Paul St",
    "parcel_id": "126-44-00",
    "owner1": "MEEHAN, SHARI & JOSEPH",
    "owner2": "",
    "current_taxes": 21602.3,
    "new_taxes_no_override": 22535.52,
    "override_total_1": 23174.95,
    "override_increase_1": 639.43
  },
  {
    "#": "105 St Paul St (126-45-00)",
    "$": 2609600,
    "address": "105 St Paul St",
    "parcel_id": "126-45-00",
    "owner1": "CHABAD OF BROOKLINE INC",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "108 St Paul St, Unit 1 (158-23-01)",
    "$": 863100,
    "address": "108 St Paul St, Unit 1",
    "parcel_id": "158-23-01",
    "owner1": "LEE, CHANGHEE",
    "owner2": "YUN, JEONG H",
    "current_taxes": 5203.21,
    "new_taxes_no_override": 5427.99,
    "override_total_1": 5582.0,
    "override_increase_1": 154.02
  },
  {
    "#": "108 St Paul St, Unit 2 (158-23-02)",
    "$": 852200,
    "address": "108 St Paul St, Unit 2",
    "parcel_id": "158-23-02",
    "owner1": "5 MONMOUTH STREET LLC",
    "owner2": "",
    "current_taxes": 5091.59,
    "new_taxes_no_override": 5311.55,
    "override_total_1": 5462.26,
    "override_increase_1": 150.71
  },
  {
    "#": "108 St Paul St, Unit 3 (158-23-03)",
    "$": 842300,
    "address": "108 St Paul St, Unit 3",
    "parcel_id": "158-23-03",
    "owner1": "HODAS, ADRIA",
    "owner2": "",
    "current_taxes": 4990.22,
    "new_taxes_no_override": 5205.8,
    "override_total_1": 5353.51,
    "override_increase_1": 147.71
  },
  {
    "#": "108 St Paul St, Unit 4 (158-23-04)",
    "$": 867600,
    "address": "108 St Paul St, Unit 4",
    "parcel_id": "158-23-04",
    "owner1": "EPSTEIN, JANE & LEONID",
    "owner2": "",
    "current_taxes": 8884.22,
    "new_taxes_no_override": 9268.02,
    "override_total_1": 9530.99,
    "override_increase_1": 262.97
  },
  {
    "#": "108 St Paul St, Unit 5 (158-23-05)",
    "$": 842200,
    "address": "108 St Paul St, Unit 5",
    "parcel_id": "158-23-05",
    "owner1": "CONNER, JENNIFER",
    "owner2": "",
    "current_taxes": 8624.13,
    "new_taxes_no_override": 8996.69,
    "override_total_1": 9251.97,
    "override_increase_1": 255.27
  },
  {
    "#": "108 St Paul St, Unit 6 (158-23-06)",
    "$": 877800,
    "address": "108 St Paul St, Unit 6",
    "parcel_id": "158-23-06",
    "owner1": "MADARA, JOSEPH DELA CRUZ",
    "owner2": "RAMOS, REGGIE",
    "current_taxes": 5353.74,
    "new_taxes_no_override": 5585.02,
    "override_total_1": 5743.49,
    "override_increase_1": 158.47
  },
  {
    "#": "108 St Paul St, Unit A (158-23-20)",
    "$": 680900,
    "address": "108 St Paul St, Unit A",
    "parcel_id": "158-23-20",
    "owner1": "GABAI TR, SANDRA LEE",
    "owner2": "",
    "current_taxes": 3337.48,
    "new_taxes_no_override": 3481.66,
    "override_total_1": 3580.45,
    "override_increase_1": 98.79
  },
  {
    "#": "109 St Paul St (126-46-49)",
    "$": 12171300,
    "address": "109 St Paul St",
    "parcel_id": "126-46-49",
    "owner1": "SYNH LLC",
    "owner2": "",
    "current_taxes": 126094.49,
    "new_taxes_no_override": 131541.77,
    "override_total_1": 135274.17,
    "override_increase_1": 3732.4
  },
  {
    "#": "114 St Paul St, Unit 1 (158-23-08)",
    "$": 881200,
    "address": "114 St Paul St, Unit 1",
    "parcel_id": "158-23-08",
    "owner1": "BERNSTEIN, AMY",
    "owner2": "",
    "current_taxes": 5388.55,
    "new_taxes_no_override": 5621.34,
    "override_total_1": 5780.84,
    "override_increase_1": 159.5
  },
  {
    "#": "114 St Paul St, Unit 2 (158-23-09)",
    "$": 865900,
    "address": "114 St Paul St, Unit 2",
    "parcel_id": "158-23-09",
    "owner1": "CHIN, HARVEY L",
    "owner2": "",
    "current_taxes": 5231.88,
    "new_taxes_no_override": 5457.9,
    "override_total_1": 5612.76,
    "override_increase_1": 154.86
  },
  {
    "#": "114 St Paul St, Unit 3 (158-23-10)",
    "$": 876100,
    "address": "114 St Paul St, Unit 3",
    "parcel_id": "158-23-10",
    "owner1": "LEE, HENRY HUNG-YI",
    "owner2": "",
    "current_taxes": 5336.33,
    "new_taxes_no_override": 5566.86,
    "override_total_1": 5724.81,
    "override_increase_1": 157.96
  },
  {
    "#": "114 St Paul St, Unit 4 (158-23-11)",
    "$": 1220700,
    "address": "114 St Paul St, Unit 4",
    "parcel_id": "158-23-11",
    "owner1": "KNOPOV TRS, LEV & NATALIA",
    "owner2": "",
    "current_taxes": 8865.03,
    "new_taxes_no_override": 9248.0,
    "override_total_1": 9510.4,
    "override_increase_1": 262.4
  },
  {
    "#": "114 St Paul St, Unit 5 (158-23-12)",
    "$": 848900,
    "address": "114 St Paul St, Unit 5",
    "parcel_id": "158-23-12",
    "owner1": "INTILLE TRS, AMY M & STEPHEN S",
    "owner2": "",
    "current_taxes": 8692.74,
    "new_taxes_no_override": 9068.27,
    "override_total_1": 9325.57,
    "override_increase_1": 257.31
  },
  {
    "#": "114 St Paul St, Unit 6 (158-23-13)",
    "$": 998000,
    "address": "114 St Paul St, Unit 6",
    "parcel_id": "158-23-13",
    "owner1": "ZITOMERSKY, NAAMAH L",
    "owner2": "",
    "current_taxes": 6584.59,
    "new_taxes_no_override": 6869.04,
    "override_total_1": 7063.95,
    "override_increase_1": 194.9
  },
  {
    "#": "114 St Paul St, Unit A (158-23-07)",
    "$": 751900,
    "address": "114 St Paul St, Unit A",
    "parcel_id": "158-23-07",
    "owner1": "PARAGAS, VIOLETTE B",
    "owner2": "PONTIUS, BRIAN W",
    "current_taxes": 4064.52,
    "new_taxes_no_override": 4240.11,
    "override_total_1": 4360.42,
    "override_increase_1": 120.31
  },
  {
    "#": "118 St Paul St, Unit 1 & P14 (158-23-14)",
    "$": 882600,
    "address": "118 St Paul St, Unit 1 & P14",
    "parcel_id": "158-23-14",
    "owner1": "INTILLE, STEPHEN & AMY M",
    "owner2": "",
    "current_taxes": 5402.89,
    "new_taxes_no_override": 5636.29,
    "override_total_1": 5796.22,
    "override_increase_1": 159.93
  },
  {
    "#": "118 St Paul St, Unit 2 (158-23-15)",
    "$": 910700,
    "address": "118 St Paul St, Unit 2",
    "parcel_id": "158-23-15",
    "owner1": "LEI TRS, YANG",
    "owner2": "ZHU, BINBIN",
    "current_taxes": 9325.57,
    "new_taxes_no_override": 9728.43,
    "override_total_1": 10004.47,
    "override_increase_1": 276.04
  },
  {
    "#": "118 St Paul St, Unit 3 (158-23-16)",
    "$": 968600,
    "address": "118 St Paul St, Unit 3",
    "parcel_id": "158-23-16",
    "owner1": "CHARMOY TR, STANLEY",
    "owner2": "C/O CARABOOLAD GEOFFREY S",
    "current_taxes": 9918.46,
    "new_taxes_no_override": 10346.94,
    "override_total_1": 10640.52,
    "override_increase_1": 293.59
  },
  {
    "#": "118 St Paul St, Unit 4 & P13 (158-23-17)",
    "$": 910600,
    "address": "118 St Paul St, Unit 4 & P13",
    "parcel_id": "158-23-17",
    "owner1": "ARTZI, SHAY & LIOR",
    "owner2": "",
    "current_taxes": 5689.61,
    "new_taxes_no_override": 5935.4,
    "override_total_1": 6103.81,
    "override_increase_1": 168.41
  },
  {
    "#": "118 St Paul St, Unit 5 & P-18 (158-23-18)",
    "$": 968600,
    "address": "118 St Paul St, Unit 5 & P-18",
    "parcel_id": "158-23-18",
    "owner1": "GONZALES, PETER H",
    "owner2": "",
    "current_taxes": 6283.53,
    "new_taxes_no_override": 6554.98,
    "override_total_1": 6740.97,
    "override_increase_1": 185.99
  },
  {
    "#": "118 St Paul St, Unit 6 (158-23-19)",
    "$": 916000,
    "address": "118 St Paul St, Unit 6",
    "parcel_id": "158-23-19",
    "owner1": "SCHLOSSBERG, BRETT & GALE",
    "owner2": "",
    "current_taxes": 5744.91,
    "new_taxes_no_override": 5993.09,
    "override_total_1": 6163.14,
    "override_increase_1": 170.05
  },
  {
    "#": "123 St Paul St, Unit 123-1 (125-24-05)",
    "$": 1384400,
    "address": "123 St Paul St, Unit 123-1",
    "parcel_id": "125-24-05",
    "owner1": "MAURER, ALEXANDRIA K",
    "owner2": "OKIN, DANIEL A",
    "current_taxes": 10541.32,
    "new_taxes_no_override": 10996.71,
    "override_total_1": 11308.73,
    "override_increase_1": 312.02
  },
  {
    "#": "123 St Paul St, Unit 123-2 (125-24-06)",
    "$": 1421800,
    "address": "123 St Paul St, Unit 123-2",
    "parcel_id": "125-24-06",
    "owner1": "MLADINOV, DOMAGOJ",
    "owner2": "YEO, NAN CHER",
    "current_taxes": 14559.23,
    "new_taxes_no_override": 15188.19,
    "override_total_1": 15619.14,
    "override_increase_1": 430.95
  },
  {
    "#": "123 St Paul St, Unit 123-3 (125-24-07)",
    "$": 1413900,
    "address": "123 St Paul St, Unit 123-3",
    "parcel_id": "125-24-07",
    "owner1": "SCHLENKER, WOLFRAM & SOPHIE",
    "owner2": "",
    "current_taxes": 10843.4,
    "new_taxes_no_override": 11311.83,
    "override_total_1": 11632.8,
    "override_increase_1": 320.96
  },
  {
    "#": "125 St Paul St (125-24-01)",
    "$": 4223300,
    "address": "125 St Paul St",
    "parcel_id": "125-24-01",
    "owner1": "POURATI TR, FLORA",
    "owner2": "C/O ORCHID REALTY TRUST, ATTN PROPERTY MGR",
    "current_taxes": 43246.59,
    "new_taxes_no_override": 45114.84,
    "override_total_1": 46394.94,
    "override_increase_1": 1280.1
  },
  {
    "#": "129 St Paul St (125-24-02)",
    "$": 3435800,
    "address": "129 St Paul St",
    "parcel_id": "125-24-02",
    "owner1": "CHRISTIAN TRS, LESLEY E",
    "owner2": "",
    "current_taxes": 31547.66,
    "new_taxes_no_override": 32910.52,
    "override_total_1": 33844.33,
    "override_increase_1": 933.81
  },
  {
    "#": "135 St Paul St (125-25-03)",
    "$": 2294800,
    "address": "135 St Paul St",
    "parcel_id": "125-25-03",
    "owner1": "135 SAINT PAUL LLC",
    "owner2": "",
    "current_taxes": 23498.75,
    "new_taxes_no_override": 24513.9,
    "override_total_1": 25209.46,
    "override_increase_1": 695.56
  },
  {
    "#": "143 St Paul St (125-01-00)",
    "$": 4876900,
    "address": "143 St Paul St",
    "parcel_id": "125-01-00",
    "owner1": "OOA INC",
    "owner2": "",
    "current_taxes": 49939.46,
    "new_taxes_no_override": 52096.84,
    "override_total_1": 53575.05,
    "override_increase_1": 1478.21
  },
  {
    "#": "150 St Paul St, Unit 101&G44-71 (160-07-10)",
    "$": 1297100,
    "address": "150 St Paul St, Unit 101&G44-71",
    "parcel_id": "160-07-10",
    "owner1": "XU, PEILUO",
    "owner2": "XU, JUN",
    "current_taxes": 13282.3,
    "new_taxes_no_override": 13856.1,
    "override_total_1": 14249.25,
    "override_increase_1": 393.16
  },
  {
    "#": "150 St Paul St, Unit 102 & G45-20-21 (160-07-11)",
    "$": 1572300,
    "address": "150 St Paul St, Unit 102 & G45-20-21",
    "parcel_id": "160-07-11",
    "owner1": "WOLKE TRS, JOSEPH H & BARBARA L",
    "owner2": "",
    "current_taxes": 16100.35,
    "new_taxes_no_override": 16795.89,
    "override_total_1": 17272.46,
    "override_increase_1": 476.57
  },
  {
    "#": "150 St Paul St, Unit 103&G3 (160-07-12)",
    "$": 1557900,
    "address": "150 St Paul St, Unit 103&G3",
    "parcel_id": "160-07-12",
    "owner1": "YUNGHER, FERNANDA WAJNSZTAJN & BENJAMIN",
    "owner2": "",
    "current_taxes": 15952.9,
    "new_taxes_no_override": 16642.07,
    "override_total_1": 17114.27,
    "override_increase_1": 472.21
  },
  {
    "#": "150 St Paul St, Unit 104 & G55 (160-07-13)",
    "$": 891400,
    "address": "150 St Paul St, Unit 104 & G55",
    "parcel_id": "160-07-13",
    "owner1": "LUPACCHINO, STEVEN",
    "owner2": "",
    "current_taxes": 5493.0,
    "new_taxes_no_override": 5730.3,
    "override_total_1": 5892.89,
    "override_increase_1": 162.59
  },
  {
    "#": "150 St Paul St, Unit 105 & G59&69 (160-07-14)",
    "$": 1544800,
    "address": "150 St Paul St, Unit 105 & G59&69",
    "parcel_id": "160-07-14",
    "owner1": "KIM, KYUNG & YONGJUN BAE",
    "owner2": "",
    "current_taxes": 12183.82,
    "new_taxes_no_override": 12710.16,
    "override_total_1": 13070.8,
    "override_increase_1": 360.64
  },
  {
    "#": "150 St Paul St, Unit 106 & G58 (160-07-15)",
    "$": 1115100,
    "address": "150 St Paul St, Unit 106 & G58",
    "parcel_id": "160-07-15",
    "owner1": "ZHANG, WEN",
    "owner2": "",
    "current_taxes": 11418.62,
    "new_taxes_no_override": 11911.9,
    "override_total_1": 12249.9,
    "override_increase_1": 337.99
  },
  {
    "#": "150 St Paul St, Unit 107 & G61-31-66 (160-07-16)",
    "$": 1712200,
    "address": "150 St Paul St, Unit 107 & G61-31-66",
    "parcel_id": "160-07-16",
    "owner1": "SNOW, CATHERINE",
    "owner2": "BAUM, MICHAEL",
    "current_taxes": 13897.99,
    "new_taxes_no_override": 14498.38,
    "override_total_1": 14909.76,
    "override_increase_1": 411.38
  },
  {
    "#": "150 St Paul St, Unit 108 & G50 (160-07-17)",
    "$": 920100,
    "address": "150 St Paul St, Unit 108 & G50",
    "parcel_id": "160-07-17",
    "owner1": "BAUM, MICHAEL",
    "owner2": "SNOW, CATHERINE",
    "current_taxes": 9421.82,
    "new_taxes_no_override": 9828.84,
    "override_total_1": 10107.73,
    "override_increase_1": 278.89
  },
  {
    "#": "150 St Paul St, Unit 109 & G54 (160-07-18)",
    "$": 296100,
    "address": "150 St Paul St, Unit 109 & G54",
    "parcel_id": "160-07-18",
    "owner1": "NEVEROV, ALEKSANDR & MARIA",
    "owner2": "",
    "current_taxes": 303.21,
    "new_taxes_no_override": 316.31,
    "override_total_1": 325.28,
    "override_increase_1": 8.98
  },
  {
    "#": "150 St Paul St, Unit 110& G62 (160-07-19)",
    "$": 1334600,
    "address": "150 St Paul St, Unit 110& G62",
    "parcel_id": "160-07-19",
    "owner1": "FEINGOLD, ELLEN",
    "owner2": "",
    "current_taxes": 10031.37,
    "new_taxes_no_override": 10464.73,
    "override_total_1": 10761.65,
    "override_increase_1": 296.93
  },
  {
    "#": "150 St Paul St, Unit 201&G47-23 (160-07-20)",
    "$": 1627400,
    "address": "150 St Paul St, Unit 201&G47-23",
    "parcel_id": "160-07-20",
    "owner1": "MENASHI TR, DARA",
    "owner2": "",
    "current_taxes": 13029.64,
    "new_taxes_no_override": 13592.52,
    "override_total_1": 13978.2,
    "override_increase_1": 385.68
  },
  {
    "#": "150 St Paul St, Unit 202 & G49 (160-07-21)",
    "$": 1419100,
    "address": "150 St Paul St, Unit 202 & G49",
    "parcel_id": "160-07-21",
    "owner1": "AGUS, FELITA",
    "owner2": "",
    "current_taxes": 14531.58,
    "new_taxes_no_override": 15159.34,
    "override_total_1": 15589.48,
    "override_increase_1": 430.13
  },
  {
    "#": "150 St Paul St, Unit 203&G18-73-74 (160-07-22)",
    "$": 1809600,
    "address": "150 St Paul St, Unit 203&G18-73-74",
    "parcel_id": "160-07-22",
    "owner1": "VINCIARELLI TR, PATRIZIO",
    "owner2": "LAPOSTA TR, DANIELE",
    "current_taxes": 18530.3,
    "new_taxes_no_override": 19330.81,
    "override_total_1": 19879.31,
    "override_increase_1": 548.5
  },
  {
    "#": "150 St Paul St, Unit 204 & G8-9 (160-07-23)",
    "$": 1126100,
    "address": "150 St Paul St, Unit 204 & G8-9",
    "parcel_id": "160-07-23",
    "owner1": "LEE TR, YVONNE CLAIRE",
    "owner2": "",
    "current_taxes": 11531.26,
    "new_taxes_no_override": 12029.41,
    "override_total_1": 12370.74,
    "override_increase_1": 341.33
  },
  {
    "#": "150 St Paul St, Unit 205 G60 75 (160-07-24)",
    "$": 1493800,
    "address": "150 St Paul St, Unit 205 G60 75",
    "parcel_id": "160-07-24",
    "owner1": "SILBERSTEIN TRS, ERIC M",
    "owner2": "LIU, FANG",
    "current_taxes": 15296.51,
    "new_taxes_no_override": 15957.32,
    "override_total_1": 16410.1,
    "override_increase_1": 452.78
  },
  {
    "#": "150 St Paul St, Unit 206&G48-76 (160-07-25)",
    "$": 1239500,
    "address": "150 St Paul St, Unit 206&G48-76",
    "parcel_id": "160-07-25",
    "owner1": "BOHN, RHONDA",
    "owner2": "LEVY, DANIEL",
    "current_taxes": 12692.48,
    "new_taxes_no_override": 13240.8,
    "override_total_1": 13616.49,
    "override_increase_1": 375.7
  },
  {
    "#": "150 St Paul St, Unit 207 & G4 (160-07-26)",
    "$": 1560200,
    "address": "150 St Paul St, Unit 207 & G4",
    "parcel_id": "160-07-26",
    "owner1": "SHAH, SEJAL",
    "owner2": "",
    "current_taxes": 12341.51,
    "new_taxes_no_override": 12874.66,
    "override_total_1": 13239.97,
    "override_increase_1": 365.31
  },
  {
    "#": "150 St Paul St, Unit 208&G63-64 (160-07-27)",
    "$": 1277400,
    "address": "150 St Paul St, Unit 208&G63-64",
    "parcel_id": "160-07-27",
    "owner1": "YANG, HAN-CHIEH",
    "owner2": "HSIAO, KAI-CHUNG",
    "current_taxes": 13080.58,
    "new_taxes_no_override": 13645.66,
    "override_total_1": 14032.85,
    "override_increase_1": 387.19
  },
  {
    "#": "150 St Paul St, Unit 209 & G53 (160-07-28)",
    "$": 312600,
    "address": "150 St Paul St, Unit 209 & G53",
    "parcel_id": "160-07-28",
    "owner1": "BIDIANOS, ELAINE",
    "owner2": "",
    "current_taxes": 320.1,
    "new_taxes_no_override": 333.93,
    "override_total_1": 343.4,
    "override_increase_1": 9.47
  },
  {
    "#": "150 St Paul St, Unit 210&G57-65 (160-07-29)",
    "$": 1430700,
    "address": "150 St Paul St, Unit 210&G57-65",
    "parcel_id": "160-07-29",
    "owner1": "JAMIESON, TARA PATRICIA",
    "owner2": "",
    "current_taxes": 11015.43,
    "new_taxes_no_override": 11491.3,
    "override_total_1": 11817.35,
    "override_increase_1": 326.06
  },
  {
    "#": "150 St Paul St, Unit 301 & G46 (160-07-30)",
    "$": 1538700,
    "address": "150 St Paul St, Unit 301 & G46",
    "parcel_id": "160-07-30",
    "owner1": "RICHMAN, SANDRA R",
    "owner2": "",
    "current_taxes": 12121.35,
    "new_taxes_no_override": 12644.99,
    "override_total_1": 13003.78,
    "override_increase_1": 358.79
  },
  {
    "#": "150 St Paul St, Unit 302 G56 72 (160-07-31)",
    "$": 1524300,
    "address": "150 St Paul St, Unit 302 G56 72",
    "parcel_id": "160-07-31",
    "owner1": "LIN, MICHAEL M",
    "owner2": "DING, MANNING",
    "current_taxes": 15608.83,
    "new_taxes_no_override": 16283.13,
    "override_total_1": 16745.15,
    "override_increase_1": 462.02
  },
  {
    "#": "150 St Paul St, Unit 303&G14-15 (160-07-32)",
    "$": 1720900,
    "address": "150 St Paul St, Unit 303&G14-15",
    "parcel_id": "160-07-32",
    "owner1": "THE PHILLIPIAN LLC",
    "owner2": "",
    "current_taxes": 17622.02,
    "new_taxes_no_override": 18383.29,
    "override_total_1": 18904.9,
    "override_increase_1": 521.61
  },
  {
    "#": "150 St Paul St, Unit 304 & G52 (160-07-33)",
    "$": 1040400,
    "address": "150 St Paul St, Unit 304 & G52",
    "parcel_id": "160-07-33",
    "owner1": "PEKOZ, EROL",
    "owner2": "",
    "current_taxes": 10653.7,
    "new_taxes_no_override": 11113.94,
    "override_total_1": 11429.29,
    "override_increase_1": 315.35
  },
  {
    "#": "150 St Paul St, Unit 306&G6-35 (160-07-34)",
    "$": 1249000,
    "address": "150 St Paul St, Unit 306&G6-35",
    "parcel_id": "160-07-34",
    "owner1": "RADIN, MARJORIE",
    "owner2": "WOLSTAT, HENRY",
    "current_taxes": 9154.83,
    "new_taxes_no_override": 9550.32,
    "override_total_1": 9821.3,
    "override_increase_1": 270.98
  },
  {
    "#": "150 St Paul St, Unit 307&G7-79 (160-07-35)",
    "$": 1645100,
    "address": "150 St Paul St, Unit 307&G7-79",
    "parcel_id": "160-07-35",
    "owner1": "KIRSCHNER TR, DANIEL A",
    "owner2": "KAHN TR, SUSAN R",
    "current_taxes": 13210.89,
    "new_taxes_no_override": 13781.6,
    "override_total_1": 14172.64,
    "override_increase_1": 391.04
  },
  {
    "#": "150 St Paul St, Unit 308 & G42 (160-07-36)",
    "$": 1192400,
    "address": "150 St Paul St, Unit 308 & G42",
    "parcel_id": "160-07-36",
    "owner1": "SALTZ, ADRIANNE B",
    "owner2": "",
    "current_taxes": 12210.18,
    "new_taxes_no_override": 12737.66,
    "override_total_1": 13099.08,
    "override_increase_1": 361.42
  },
  {
    "#": "150 St Paul St, Unit 309 & G19 (160-07-37)",
    "$": 395700,
    "address": "150 St Paul St, Unit 309 & G19",
    "parcel_id": "160-07-37",
    "owner1": "BLASCHEVICI, MALVINA & IOSIF",
    "owner2": "",
    "current_taxes": 417.03,
    "new_taxes_no_override": 435.05,
    "override_total_1": 447.39,
    "override_increase_1": 12.34
  },
  {
    "#": "150 St Paul St, Unit 310 & G43 (160-07-38)",
    "$": 1334600,
    "address": "150 St Paul St, Unit 310 & G43",
    "parcel_id": "160-07-38",
    "owner1": "SHAY, LISA BRENNER",
    "owner2": "",
    "current_taxes": 10031.37,
    "new_taxes_no_override": 10464.73,
    "override_total_1": 10761.65,
    "override_increase_1": 296.93
  },
  {
    "#": "150 St Paul St, Unit 401&G16-27 (160-07-39)",
    "$": 1627400,
    "address": "150 St Paul St, Unit 401&G16-27",
    "parcel_id": "160-07-39",
    "owner1": "SUMMER, ALAN E",
    "owner2": "HABERMAN, CHERYL L",
    "current_taxes": 13029.64,
    "new_taxes_no_override": 13592.52,
    "override_total_1": 13978.2,
    "override_increase_1": 385.68
  },
  {
    "#": "150 St Paul St, Unit 402 & G17-24-25 (160-07-40)",
    "$": 1613000,
    "address": "150 St Paul St, Unit 402 & G17-24-25",
    "parcel_id": "160-07-40",
    "owner1": "FEDORENKO TRS, ALEKSANDR I",
    "owner2": "MINSTER, ANNA",
    "current_taxes": 12882.19,
    "new_taxes_no_override": 13438.7,
    "override_total_1": 13820.01,
    "override_increase_1": 381.31
  },
  {
    "#": "150 St Paul St, Unit 403&G32-33-34 (160-07-41)",
    "$": 1754400,
    "address": "150 St Paul St, Unit 403&G32-33-34",
    "parcel_id": "160-07-41",
    "owner1": "RECHT, MARTHA & ABRAM",
    "owner2": "",
    "current_taxes": 14330.12,
    "new_taxes_no_override": 14949.18,
    "override_total_1": 15373.35,
    "override_increase_1": 424.17
  },
  {
    "#": "150 St Paul St, Unit 404 & G51 (160-07-42)",
    "$": 1040400,
    "address": "150 St Paul St, Unit 404 & G51",
    "parcel_id": "160-07-42",
    "owner1": "LEVINE, ELLEN R",
    "owner2": "",
    "current_taxes": 7018.76,
    "new_taxes_no_override": 7321.97,
    "override_total_1": 7529.73,
    "override_increase_1": 207.76
  },
  {
    "#": "150 St Paul St, Unit 405&G5-13-77 (160-07-43)",
    "$": 2770600,
    "address": "150 St Paul St, Unit 405&G5-13-77",
    "parcel_id": "160-07-43",
    "owner1": "CHAKRAVORTY, MEENAKSHY",
    "owner2": "RAYCHAUDHURI, SOUMYA",
    "current_taxes": 24736.01,
    "new_taxes_no_override": 25804.61,
    "override_total_1": 26536.79,
    "override_increase_1": 732.19
  },
  {
    "#": "150 St Paul St, Unit 406&G12-78 (160-07-44)",
    "$": 1851300,
    "address": "150 St Paul St, Unit 406&G12-78",
    "parcel_id": "160-07-44",
    "owner1": "SCHOTTENFELS, AMY",
    "owner2": "KLEIN, JONATHAN",
    "current_taxes": 15322.38,
    "new_taxes_no_override": 15984.31,
    "override_total_1": 16437.85,
    "override_increase_1": 453.54
  },
  {
    "#": "150 St Paul St, Unit 501&G10-81 (160-07-45)",
    "$": 2002400,
    "address": "150 St Paul St, Unit 501&G10-81",
    "parcel_id": "160-07-45",
    "owner1": "KOPLAN, BRUCE & JAMIE UDLER",
    "owner2": "",
    "current_taxes": 20504.58,
    "new_taxes_no_override": 21390.38,
    "override_total_1": 21997.31,
    "override_increase_1": 606.94
  },
  {
    "#": "150 St Paul St, Unit 502&G11-80 (160-07-46)",
    "$": 1989200,
    "address": "150 St Paul St, Unit 502&G11-80",
    "parcel_id": "160-07-46",
    "owner1": "KOPLAN, BRUCE A & JAMIE",
    "owner2": "",
    "current_taxes": 16734.47,
    "new_taxes_no_override": 17457.4,
    "override_total_1": 17952.74,
    "override_increase_1": 495.34
  },
  {
    "#": "150 St Paul St, Unit G26 (160-07-53)",
    "$": 86500,
    "address": "150 St Paul St, Unit G26",
    "parcel_id": "160-07-53",
    "owner1": "BIDIANOS, ELAINE",
    "owner2": "",
    "current_taxes": 885.76,
    "new_taxes_no_override": 924.02,
    "override_total_1": 950.24,
    "override_increase_1": 26.22
  },
  {
    "#": "150 St Paul St, Unit G29-G30 (160-07-52)",
    "$": 169100,
    "address": "150 St Paul St, Unit G29-G30",
    "parcel_id": "160-07-52",
    "owner1": "RICHMAN, SANDRA R",
    "owner2": "",
    "current_taxes": 1731.58,
    "new_taxes_no_override": 1806.38,
    "override_total_1": 1857.64,
    "override_increase_1": 51.25
  },
  {
    "#": "150 St Paul St, Unit G70 (160-07-51)",
    "$": 84500,
    "address": "150 St Paul St, Unit G70",
    "parcel_id": "160-07-51",
    "owner1": "SHAY, LISA BRENNER",
    "owner2": "",
    "current_taxes": 865.28,
    "new_taxes_no_override": 902.66,
    "override_total_1": 928.27,
    "override_increase_1": 25.61
  },
  {
    "#": "153 St Paul St (124-01-02)",
    "$": 4237000,
    "address": "153 St Paul St",
    "parcel_id": "124-01-02",
    "owner1": "SEWALL HOLDING LLC",
    "owner2": "",
    "current_taxes": 43386.88,
    "new_taxes_no_override": 45261.19,
    "override_total_1": 46545.44,
    "override_increase_1": 1284.25
  },
  {
    "#": "159 St Paul St, Unit 1 (124-03-09)",
    "$": 851200,
    "address": "159 St Paul St, Unit 1",
    "parcel_id": "124-03-09",
    "owner1": "GROSS, PETER PINCHAS & JAFFA",
    "owner2": "",
    "current_taxes": 8716.29,
    "new_taxes_no_override": 9092.83,
    "override_total_1": 9350.84,
    "override_increase_1": 258.0
  },
  {
    "#": "159 St Paul St, Unit 1A (124-03-01)",
    "$": 510100,
    "address": "159 St Paul St, Unit 1A",
    "parcel_id": "124-03-01",
    "owner1": "ELBH LLC",
    "owner2": "C/O SCHOEN, CATHLEEN",
    "current_taxes": 5223.42,
    "new_taxes_no_override": 5449.07,
    "override_total_1": 5603.68,
    "override_increase_1": 154.61
  },
  {
    "#": "159 St Paul St, Unit 2 (124-03-02)",
    "$": 875600,
    "address": "159 St Paul St, Unit 2",
    "parcel_id": "124-03-02",
    "owner1": "SHIFRIN, ALEXANDER &ELISABETH&MARK",
    "owner2": "",
    "current_taxes": 5331.21,
    "new_taxes_no_override": 5561.52,
    "override_total_1": 5719.32,
    "override_increase_1": 157.8
  },
  {
    "#": "159 St Paul St, Unit 3 (124-03-03)",
    "$": 865400,
    "address": "159 St Paul St, Unit 3",
    "parcel_id": "124-03-03",
    "owner1": "LESCOHIER, DANIEL",
    "owner2": "",
    "current_taxes": 8861.7,
    "new_taxes_no_override": 9244.53,
    "override_total_1": 9506.83,
    "override_increase_1": 262.31
  },
  {
    "#": "159 St Paul St, Unit 4 (124-03-04)",
    "$": 891100,
    "address": "159 St Paul St, Unit 4",
    "parcel_id": "124-03-04",
    "owner1": "HUSEN, SRIWATY",
    "owner2": "",
    "current_taxes": 9124.86,
    "new_taxes_no_override": 9519.05,
    "override_total_1": 9789.15,
    "override_increase_1": 270.1
  },
  {
    "#": "159 St Paul St, Unit 5 (124-03-05)",
    "$": 891200,
    "address": "159 St Paul St, Unit 5",
    "parcel_id": "124-03-05",
    "owner1": "TERAJEWICZ TRS, JAN C & RU-HONG",
    "owner2": "",
    "current_taxes": 9125.89,
    "new_taxes_no_override": 9520.13,
    "override_total_1": 9790.25,
    "override_increase_1": 270.13
  },
  {
    "#": "159 St Paul St, Unit 6 (124-03-06)",
    "$": 891200,
    "address": "159 St Paul St, Unit 6",
    "parcel_id": "124-03-06",
    "owner1": "FEI, YANG",
    "owner2": "",
    "current_taxes": 5490.95,
    "new_taxes_no_override": 5728.16,
    "override_total_1": 5890.69,
    "override_increase_1": 162.53
  },
  {
    "#": "159 St Paul St, Unit 7 (124-03-07)",
    "$": 891100,
    "address": "159 St Paul St, Unit 7",
    "parcel_id": "124-03-07",
    "owner1": "TANG TR, ZHIQI JESSICA YU",
    "owner2": "",
    "current_taxes": 9124.86,
    "new_taxes_no_override": 9519.05,
    "override_total_1": 9789.15,
    "override_increase_1": 270.1
  },
  {
    "#": "159 St Paul St, Unit P8 (124-03-08)",
    "$": 48300,
    "address": "159 St Paul St, Unit P8",
    "parcel_id": "124-03-08",
    "owner1": "LESCOHIER, DANIEL",
    "owner2": "",
    "current_taxes": 494.59,
    "new_taxes_no_override": 515.96,
    "override_total_1": 530.6,
    "override_increase_1": 14.64
  },
  {
    "#": "180 St Paul St (043-08-00)",
    "$": 3226300,
    "address": "180 St Paul St",
    "parcel_id": "043-08-00",
    "owner1": "SANIEOFF, TR, SYROOS",
    "owner2": "",
    "current_taxes": 33037.31,
    "new_taxes_no_override": 34464.52,
    "override_total_1": 35442.43,
    "override_increase_1": 977.9
  },
  {
    "#": "182 St Paul St (043-07-00)",
    "$": 2946100,
    "address": "182 St Paul St",
    "parcel_id": "043-07-00",
    "owner1": "BARTH, TR, RITA",
    "owner2": "",
    "current_taxes": 30168.06,
    "new_taxes_no_override": 31471.32,
    "override_total_1": 32364.29,
    "override_increase_1": 892.97
  },
  {
    "#": "184 St Paul St (043-06-00)",
    "$": 2950400,
    "address": "184 St Paul St",
    "parcel_id": "043-06-00",
    "owner1": "AU TR, PAMELA",
    "owner2": "",
    "current_taxes": 30212.1,
    "new_taxes_no_override": 31517.26,
    "override_total_1": 32411.54,
    "override_increase_1": 894.28
  },
  {
    "#": "194 St Paul St, Unit 1 & P1 (043-05-06)",
    "$": 1272900,
    "address": "194 St Paul St, Unit 1 & P1",
    "parcel_id": "043-05-06",
    "owner1": "EIGEN, STANLEY J",
    "owner2": "BAUM, JACQUELINE L",
    "current_taxes": 9399.56,
    "new_taxes_no_override": 9805.62,
    "override_total_1": 10083.85,
    "override_increase_1": 278.23
  },
  {
    "#": "194 St Paul St, Unit 2 (043-05-01)",
    "$": 538800,
    "address": "194 St Paul St, Unit 2",
    "parcel_id": "043-05-01",
    "owner1": "ZHANG, WEIJIA",
    "owner2": "",
    "current_taxes": 5517.31,
    "new_taxes_no_override": 5755.66,
    "override_total_1": 5918.97,
    "override_increase_1": 163.31
  },
  {
    "#": "194 St Paul St, Unit 3 (043-05-02)",
    "$": 788600,
    "address": "194 St Paul St, Unit 3",
    "parcel_id": "043-05-02",
    "owner1": "ZERVAS, CHRISTOPHER",
    "owner2": "",
    "current_taxes": 4440.33,
    "new_taxes_no_override": 4632.15,
    "override_total_1": 4763.59,
    "override_increase_1": 131.43
  },
  {
    "#": "194 St Paul St, Unit 4 (043-05-03)",
    "$": 730300,
    "address": "194 St Paul St, Unit 4",
    "parcel_id": "043-05-03",
    "owner1": "BANERJEE TRS, AMIT & PAULINE KOH",
    "owner2": "",
    "current_taxes": 7478.27,
    "new_taxes_no_override": 7801.33,
    "override_total_1": 8022.69,
    "override_increase_1": 221.36
  },
  {
    "#": "194 St Paul St, Unit 5 (043-05-04)",
    "$": 790400,
    "address": "194 St Paul St, Unit 5",
    "parcel_id": "043-05-04",
    "owner1": "THOMPSON ET AL, JOHN RASMUS",
    "owner2": "TALARSKI, TAM KAHNH",
    "current_taxes": 8093.7,
    "new_taxes_no_override": 8443.35,
    "override_total_1": 8682.92,
    "override_increase_1": 239.57
  },
  {
    "#": "194 St Paul St, Unit 6 (043-05-05)",
    "$": 735500,
    "address": "194 St Paul St, Unit 6",
    "parcel_id": "043-05-05",
    "owner1": "AZZI, JAMIL",
    "owner2": "EL AKIKI, GHANIA",
    "current_taxes": 7531.52,
    "new_taxes_no_override": 7856.88,
    "override_total_1": 8079.81,
    "override_increase_1": 222.93
  },
  {
    "#": "195 St Paul St, Unit 1 & P1-1A (042-12-01)",
    "$": 1962700,
    "address": "195 St Paul St, Unit 1 & P1-1A",
    "parcel_id": "042-12-01",
    "owner1": "KORMAN, NANCY F",
    "owner2": "",
    "current_taxes": 16463.11,
    "new_taxes_no_override": 17174.32,
    "override_total_1": 17661.62,
    "override_increase_1": 487.31
  },
  {
    "#": "195 St Paul St, Unit 1G (042-12-09)",
    "$": 692500,
    "address": "195 St Paul St, Unit 1G",
    "parcel_id": "042-12-09",
    "owner1": "DB LIBERTY LLC",
    "owner2": "",
    "current_taxes": 7091.2,
    "new_taxes_no_override": 7397.54,
    "override_total_1": 7607.44,
    "override_increase_1": 209.9
  },
  {
    "#": "195 St Paul St, Unit 2  & P4 (042-12-02)",
    "$": 1974200,
    "address": "195 St Paul St, Unit 2  & P4",
    "parcel_id": "042-12-02",
    "owner1": "KANTER, BONNIE",
    "owner2": "",
    "current_taxes": 16580.87,
    "new_taxes_no_override": 17297.16,
    "override_total_1": 17787.96,
    "override_increase_1": 490.79
  },
  {
    "#": "195 St Paul St, Unit 2G (042-12-10)",
    "$": 676800,
    "address": "195 St Paul St, Unit 2G",
    "parcel_id": "042-12-10",
    "owner1": "MANON, DAVIDA",
    "owner2": "",
    "current_taxes": 3295.5,
    "new_taxes_no_override": 3437.87,
    "override_total_1": 3535.41,
    "override_increase_1": 97.55
  },
  {
    "#": "195 St Paul St, Unit 3 & P9-G3 (042-12-03)",
    "$": 2234500,
    "address": "195 St Paul St, Unit 3 & P9-G3",
    "parcel_id": "042-12-03",
    "owner1": "FANG, YI",
    "owner2": "YANG, MIN",
    "current_taxes": 22881.28,
    "new_taxes_no_override": 23869.75,
    "override_total_1": 24547.04,
    "override_increase_1": 677.29
  },
  {
    "#": "195 St Paul St, Unit 3G (042-12-11)",
    "$": 827100,
    "address": "195 St Paul St, Unit 3G",
    "parcel_id": "042-12-11",
    "owner1": "MURPHY, MARY CULLENE",
    "owner2": "",
    "current_taxes": 4834.57,
    "new_taxes_no_override": 5043.42,
    "override_total_1": 5186.53,
    "override_increase_1": 143.1
  },
  {
    "#": "195 St Paul St, Unit 4 & P3-3A (042-12-04)",
    "$": 2184900,
    "address": "195 St Paul St, Unit 4 & P3-3A",
    "parcel_id": "042-12-04",
    "owner1": "DAVIS, TRS, FRANKLIN B & NANCY B",
    "owner2": "",
    "current_taxes": 18738.44,
    "new_taxes_no_override": 19547.94,
    "override_total_1": 20102.6,
    "override_increase_1": 554.66
  },
  {
    "#": "195 St Paul St, Unit 5 (042-12-05)",
    "$": 2173000,
    "address": "195 St Paul St, Unit 5",
    "parcel_id": "042-12-05",
    "owner1": "MIZRUCHI, SUSAN L",
    "owner2": "",
    "current_taxes": 18616.59,
    "new_taxes_no_override": 19420.83,
    "override_total_1": 19971.88,
    "override_increase_1": 551.05
  },
  {
    "#": "195 St Paul St, Unit 6 & 2 Pksp (042-12-06)",
    "$": 2173700,
    "address": "195 St Paul St, Unit 6 & 2 Pksp",
    "parcel_id": "042-12-06",
    "owner1": "WATTENBERG, MARTIN & LAURA",
    "owner2": "",
    "current_taxes": 22258.69,
    "new_taxes_no_override": 23220.27,
    "override_total_1": 23879.12,
    "override_increase_1": 658.86
  },
  {
    "#": "195 St Paul St, Unit 7 & P6-G7 (042-12-07)",
    "$": 2234500,
    "address": "195 St Paul St, Unit 7 & P6-G7",
    "parcel_id": "042-12-07",
    "owner1": "PERSICO, LOUIS & MARGARITA",
    "owner2": "",
    "current_taxes": 19246.35,
    "new_taxes_no_override": 20077.79,
    "override_total_1": 20647.48,
    "override_increase_1": 569.69
  },
  {
    "#": "195 St Paul St, Unit 8 & P8-G8 (042-12-08)",
    "$": 2224200,
    "address": "195 St Paul St, Unit 8 & P8-G8",
    "parcel_id": "042-12-08",
    "owner1": "ROSE TRS, DAVID L",
    "owner2": "BRODER, SHARON C",
    "current_taxes": 19140.87,
    "new_taxes_no_override": 19967.76,
    "override_total_1": 20534.33,
    "override_increase_1": 566.57
  },
  {
    "#": "196 St Paul St (043-04-00)",
    "$": 3006300,
    "address": "196 St Paul St",
    "parcel_id": "043-04-00",
    "owner1": "CHIN, DONALD Y P",
    "owner2": "",
    "current_taxes": 30784.51,
    "new_taxes_no_override": 32114.4,
    "override_total_1": 33025.62,
    "override_increase_1": 911.22
  },
  {
    "#": "198 St Paul St (043-03-00)",
    "$": 4285500,
    "address": "198 St Paul St",
    "parcel_id": "043-03-00",
    "owner1": "ARANGIO ST PAUL STREET LLC",
    "owner2": "",
    "current_taxes": 43883.52,
    "new_taxes_no_override": 45779.29,
    "override_total_1": 47078.24,
    "override_increase_1": 1298.95
  },
  {
    "#": "199 St Paul St (042-13-00)",
    "$": 2915300,
    "address": "199 St Paul St",
    "parcel_id": "042-13-00",
    "owner1": "LOUIE, JOHN & DAVID",
    "owner2": "",
    "current_taxes": 26217.74,
    "new_taxes_no_override": 27350.35,
    "override_total_1": 28126.39,
    "override_increase_1": 776.05
  },
  {
    "#": "200 St Paul St, Unit 1 & P4 (043-02-01)",
    "$": 1317700,
    "address": "200 St Paul St, Unit 1 & P4",
    "parcel_id": "043-02-01",
    "owner1": "DAVIDSON, KYLA",
    "owner2": "",
    "current_taxes": 13493.25,
    "new_taxes_no_override": 14076.16,
    "override_total_1": 14475.56,
    "override_increase_1": 399.4
  },
  {
    "#": "200 St Paul St, Unit 2 & P3 (043-02-02)",
    "$": 1351100,
    "address": "200 St Paul St, Unit 2 & P3",
    "parcel_id": "043-02-02",
    "owner1": "KAHL, CHRISTOPHER",
    "owner2": "SCHACTER, LIVIA",
    "current_taxes": 10200.33,
    "new_taxes_no_override": 10640.98,
    "override_total_1": 10942.91,
    "override_increase_1": 301.93
  },
  {
    "#": "200 St Paul St, Unit 3 & P1 P2 (043-02-03)",
    "$": 1353000,
    "address": "200 St Paul St, Unit 3 & P1 P2",
    "parcel_id": "043-02-03",
    "owner1": "CHIN, BARBARA LIANIDES",
    "owner2": "",
    "current_taxes": 10219.79,
    "new_taxes_no_override": 10661.28,
    "override_total_1": 10963.79,
    "override_increase_1": 302.51
  },
  {
    "#": "201 St Paul St, Unit 1 (042-01-07)",
    "$": 1104600,
    "address": "201 St Paul St, Unit 1",
    "parcel_id": "042-01-07",
    "owner1": "BAJIC, DUSICA",
    "owner2": "",
    "current_taxes": 7676.17,
    "new_taxes_no_override": 8007.78,
    "override_total_1": 8235.0,
    "override_increase_1": 227.21
  },
  {
    "#": "201 St Paul St, Unit 2 (042-01-01)",
    "$": 1243100,
    "address": "201 St Paul St, Unit 2",
    "parcel_id": "042-01-01",
    "owner1": "COHEN, MOISES",
    "owner2": "NATHANSON, DINA E",
    "current_taxes": 9094.41,
    "new_taxes_no_override": 9487.29,
    "override_total_1": 9756.48,
    "override_increase_1": 269.19
  },
  {
    "#": "201 St Paul St, Unit 3 (042-01-02)",
    "$": 1333000,
    "address": "201 St Paul St, Unit 3",
    "parcel_id": "042-01-02",
    "owner1": "YOSHIDA, GILBERTO",
    "owner2": "YU, KAI JAN",
    "current_taxes": 10014.99,
    "new_taxes_no_override": 10447.64,
    "override_total_1": 10744.08,
    "override_increase_1": 296.44
  },
  {
    "#": "202 St Paul St (043-01-00)",
    "$": 5093400,
    "address": "202 St Paul St",
    "parcel_id": "043-01-00",
    "owner1": "THE JOHN P DOYLE FAMILY, LIMITED PARTNERSHIP",
    "owner2": "",
    "current_taxes": 52156.42,
    "new_taxes_no_override": 54409.58,
    "override_total_1": 55953.41,
    "override_increase_1": 1543.83
  },
  {
    "#": "209 St Paul St, Unit 1 & P8 (041-16-08)",
    "$": 629400,
    "address": "209 St Paul St, Unit 1 & P8",
    "parcel_id": "041-16-08",
    "owner1": "BARAKAT TRS, KHALIL I & NADIA K",
    "owner2": "",
    "current_taxes": 6445.06,
    "new_taxes_no_override": 6723.49,
    "override_total_1": 6914.26,
    "override_increase_1": 190.77
  },
  {
    "#": "209 St Paul St, Unit 2 (041-16-01)",
    "$": 742100,
    "address": "209 St Paul St, Unit 2",
    "parcel_id": "041-16-01",
    "owner1": "BARTEK, SUSAN",
    "owner2": "",
    "current_taxes": 3964.17,
    "new_taxes_no_override": 4135.42,
    "override_total_1": 4252.76,
    "override_increase_1": 117.34
  },
  {
    "#": "209 St Paul St, Unit 3 & P7 (041-16-02)",
    "$": 765100,
    "address": "209 St Paul St, Unit 3 & P7",
    "parcel_id": "041-16-02",
    "owner1": "BALMAT, HEATHER E",
    "owner2": "BALMAT III, ROBERT E",
    "current_taxes": 7834.62,
    "new_taxes_no_override": 8173.08,
    "override_total_1": 8404.98,
    "override_increase_1": 231.9
  },
  {
    "#": "209 St Paul St, Unit 4 & P1 (041-16-03)",
    "$": 736200,
    "address": "209 St Paul St, Unit 4 & P1",
    "parcel_id": "041-16-03",
    "owner1": "TWOMEY, ET AL, TRS, JOSEPH F",
    "owner2": "",
    "current_taxes": 3903.75,
    "new_taxes_no_override": 4072.39,
    "override_total_1": 4187.94,
    "override_increase_1": 115.55
  },
  {
    "#": "209 St Paul St, Unit 5 & P5 (041-16-04)",
    "$": 756900,
    "address": "209 St Paul St, Unit 5 & P5",
    "parcel_id": "041-16-04",
    "owner1": "RAZI-WOLF, ZIBA",
    "owner2": "",
    "current_taxes": 7750.66,
    "new_taxes_no_override": 8085.49,
    "override_total_1": 8314.91,
    "override_increase_1": 229.42
  },
  {
    "#": "209 St Paul St, Unit 6 & P6 (041-16-05)",
    "$": 761700,
    "address": "209 St Paul St, Unit 6 & P6",
    "parcel_id": "041-16-05",
    "owner1": "LU, MIN",
    "owner2": "ZHU, YING YUE",
    "current_taxes": 4164.87,
    "new_taxes_no_override": 4344.79,
    "override_total_1": 4468.07,
    "override_increase_1": 123.28
  },
  {
    "#": "211 St Paul St (041-17-00)",
    "$": 3933100,
    "address": "211 St Paul St",
    "parcel_id": "041-17-00",
    "owner1": "ARANGIO, TRS, JOSEPH & MARY",
    "owner2": "",
    "current_taxes": 40274.94,
    "new_taxes_no_override": 42014.82,
    "override_total_1": 43206.96,
    "override_increase_1": 1192.14
  },
  {
    "#": "215 St Paul St (041-18-00)",
    "$": 3678000,
    "address": "215 St Paul St",
    "parcel_id": "041-18-00",
    "owner1": "CHIU, DICK R & HELEN SHU",
    "owner2": "",
    "current_taxes": 37662.72,
    "new_taxes_no_override": 39289.75,
    "override_total_1": 40404.57,
    "override_increase_1": 1114.82
  },
  {
    "#": "216 St Paul St, Unit 201 (040-01-25)",
    "$": 917900,
    "address": "216 St Paul St, Unit 201",
    "parcel_id": "040-01-25",
    "owner1": "HUNG, YU-WEN",
    "owner2": "",
    "current_taxes": 9399.3,
    "new_taxes_no_override": 9805.35,
    "override_total_1": 10083.57,
    "override_increase_1": 278.22
  },
  {
    "#": "216 St Paul St, Unit 202 (040-01-02)",
    "$": 733800,
    "address": "216 St Paul St, Unit 202",
    "parcel_id": "040-01-02",
    "owner1": "JOEN, JIN KYUNG",
    "owner2": "KIM, EUGENE",
    "current_taxes": 7514.11,
    "new_taxes_no_override": 7838.72,
    "override_total_1": 8061.14,
    "override_increase_1": 222.42
  },
  {
    "#": "216 St Paul St, Unit 203 & G5 (040-01-03)",
    "$": 926000,
    "address": "216 St Paul St, Unit 203 & G5",
    "parcel_id": "040-01-03",
    "owner1": "CHEN, SHIH YIN",
    "owner2": "TOH, SENGWEE",
    "current_taxes": 9482.24,
    "new_taxes_no_override": 9891.87,
    "override_total_1": 10172.55,
    "override_increase_1": 280.67
  },
  {
    "#": "216 St Paul St, Unit 204 (040-01-04)",
    "$": 718500,
    "address": "216 St Paul St, Unit 204",
    "parcel_id": "040-01-04",
    "owner1": "BERK, LEAH RAE",
    "owner2": "LASRY, SALOMON DANIEL",
    "current_taxes": 7357.44,
    "new_taxes_no_override": 7675.28,
    "override_total_1": 7893.06,
    "override_increase_1": 217.78
  },
  {
    "#": "216 St Paul St, Unit 301 (040-01-05)",
    "$": 929800,
    "address": "216 St Paul St, Unit 301",
    "parcel_id": "040-01-05",
    "owner1": "WANG , SENSEN X",
    "owner2": "ZHANG, JIAN",
    "current_taxes": 9521.15,
    "new_taxes_no_override": 9932.46,
    "override_total_1": 10214.29,
    "override_increase_1": 281.83
  },
  {
    "#": "216 St Paul St, Unit 302 (040-01-06)",
    "$": 730500,
    "address": "216 St Paul St, Unit 302",
    "parcel_id": "040-01-06",
    "owner1": "HUANG, SHU-HAN",
    "owner2": "",
    "current_taxes": 7480.32,
    "new_taxes_no_override": 7803.47,
    "override_total_1": 8024.89,
    "override_increase_1": 221.42
  },
  {
    "#": "216 St Paul St, Unit 303 (040-01-07)",
    "$": 945100,
    "address": "216 St Paul St, Unit 303",
    "parcel_id": "040-01-07",
    "owner1": "BOTCHKAREV, VLADIMIR",
    "owner2": "BOTCHKAREVA, NATALIA",
    "current_taxes": 6042.89,
    "new_taxes_no_override": 6303.94,
    "override_total_1": 6482.81,
    "override_increase_1": 178.87
  },
  {
    "#": "216 St Paul St, Unit 304 (040-01-08)",
    "$": 718500,
    "address": "216 St Paul St, Unit 304",
    "parcel_id": "040-01-08",
    "owner1": "HAFIZOVIC, SELMA",
    "owner2": "",
    "current_taxes": 3722.51,
    "new_taxes_no_override": 3883.32,
    "override_total_1": 3993.51,
    "override_increase_1": 110.19
  },
  {
    "#": "216 St Paul St, Unit 401 (040-01-09)",
    "$": 1066900,
    "address": "216 St Paul St, Unit 401",
    "parcel_id": "040-01-09",
    "owner1": "KAO TR, HUI S",
    "owner2": "",
    "current_taxes": 10925.06,
    "new_taxes_no_override": 11397.02,
    "override_total_1": 11720.4,
    "override_increase_1": 323.38
  },
  {
    "#": "216 St Paul St, Unit 402 (040-01-10)",
    "$": 733800,
    "address": "216 St Paul St, Unit 402",
    "parcel_id": "040-01-10",
    "owner1": "PASSOVA, YELENA",
    "owner2": "",
    "current_taxes": 3879.18,
    "new_taxes_no_override": 4046.76,
    "override_total_1": 4161.58,
    "override_increase_1": 114.82
  },
  {
    "#": "216 St Paul St, Unit 403 (040-01-11)",
    "$": 910700,
    "address": "216 St Paul St, Unit 403",
    "parcel_id": "040-01-11",
    "owner1": "216 SAINT PAUL 403 LLC",
    "owner2": "C/O PHOENIX REALTY",
    "current_taxes": 9325.57,
    "new_taxes_no_override": 9728.43,
    "override_total_1": 10004.47,
    "override_increase_1": 276.04
  },
  {
    "#": "216 St Paul St, Unit 404 (040-01-12)",
    "$": 718500,
    "address": "216 St Paul St, Unit 404",
    "parcel_id": "040-01-12",
    "owner1": "MULLARKEY, MARY M",
    "owner2": "",
    "current_taxes": 3722.51,
    "new_taxes_no_override": 3883.32,
    "override_total_1": 3993.51,
    "override_increase_1": 110.19
  },
  {
    "#": "216 St Paul St, Unit 501 (040-01-13)",
    "$": 1067000,
    "address": "216 St Paul St, Unit 501",
    "parcel_id": "040-01-13",
    "owner1": "NOURZAD, MARIANNE & DELPHINE S",
    "owner2": "",
    "current_taxes": 10926.08,
    "new_taxes_no_override": 11398.09,
    "override_total_1": 11721.5,
    "override_increase_1": 323.41
  },
  {
    "#": "216 St Paul St, Unit 502 (040-01-14)",
    "$": 735900,
    "address": "216 St Paul St, Unit 502",
    "parcel_id": "040-01-14",
    "owner1": "CHEN TRS, XIANGLI",
    "owner2": "GAO, HUI",
    "current_taxes": 7535.62,
    "new_taxes_no_override": 7861.16,
    "override_total_1": 8084.21,
    "override_increase_1": 223.05
  },
  {
    "#": "216 St Paul St, Unit 503 (040-01-15)",
    "$": 910700,
    "address": "216 St Paul St, Unit 503",
    "parcel_id": "040-01-15",
    "owner1": "BOGUSLAVSKAYA, INNA",
    "owner2": "",
    "current_taxes": 9325.57,
    "new_taxes_no_override": 9728.43,
    "override_total_1": 10004.47,
    "override_increase_1": 276.04
  },
  {
    "#": "216 St Paul St, Unit 504 (040-01-16)",
    "$": 733800,
    "address": "216 St Paul St, Unit 504",
    "parcel_id": "040-01-16",
    "owner1": "SIMANOVSKY, SERGEY",
    "owner2": "",
    "current_taxes": 3879.18,
    "new_taxes_no_override": 4046.76,
    "override_total_1": 4161.58,
    "override_increase_1": 114.82
  },
  {
    "#": "216 St Paul St, Unit 601 (040-01-17)",
    "$": 1078600,
    "address": "216 St Paul St, Unit 601",
    "parcel_id": "040-01-17",
    "owner1": "GELBART TR, JANET",
    "owner2": "",
    "current_taxes": 7409.93,
    "new_taxes_no_override": 7730.04,
    "override_total_1": 7949.37,
    "override_increase_1": 219.33
  },
  {
    "#": "216 St Paul St, Unit 602 & G15 (040-01-18)",
    "$": 733800,
    "address": "216 St Paul St, Unit 602 & G15",
    "parcel_id": "040-01-18",
    "owner1": "JOSHI, ASHOK & ANITA & AVINA",
    "owner2": "",
    "current_taxes": 3879.18,
    "new_taxes_no_override": 4046.76,
    "override_total_1": 4161.58,
    "override_increase_1": 114.82
  },
  {
    "#": "216 St Paul St, Unit 603 (040-01-19)",
    "$": 1039300,
    "address": "216 St Paul St, Unit 603",
    "parcel_id": "040-01-19",
    "owner1": "KARL, CHRISTIAN",
    "owner2": "NOURZAD KARL, MARIANNE",
    "current_taxes": 10642.43,
    "new_taxes_no_override": 11102.18,
    "override_total_1": 11417.2,
    "override_increase_1": 315.02
  },
  {
    "#": "216 St Paul St, Unit 604 (040-01-20)",
    "$": 733800,
    "address": "216 St Paul St, Unit 604",
    "parcel_id": "040-01-20",
    "owner1": "SHAKHNOVICH, ALEX",
    "owner2": "LEONOVA, ELENA",
    "current_taxes": 7514.11,
    "new_taxes_no_override": 7838.72,
    "override_total_1": 8061.14,
    "override_increase_1": 222.42
  },
  {
    "#": "216 St Paul St, Unit 701 (040-01-21)",
    "$": 1078600,
    "address": "216 St Paul St, Unit 701",
    "parcel_id": "040-01-21",
    "owner1": "ELABBOUD, ALI & ELHAM",
    "owner2": "",
    "current_taxes": 7409.93,
    "new_taxes_no_override": 7730.04,
    "override_total_1": 7949.37,
    "override_increase_1": 219.33
  },
  {
    "#": "216 St Paul St, Unit 702 (040-01-22)",
    "$": 730400,
    "address": "216 St Paul St, Unit 702",
    "parcel_id": "040-01-22",
    "owner1": "PAULSEN, RICHARD",
    "owner2": "QUINN, THERESA",
    "current_taxes": 3844.36,
    "new_taxes_no_override": 4010.44,
    "override_total_1": 4124.23,
    "override_increase_1": 113.79
  },
  {
    "#": "216 St Paul St, Unit 703 (040-01-23)",
    "$": 1039300,
    "address": "216 St Paul St, Unit 703",
    "parcel_id": "040-01-23",
    "owner1": "ELABBOUD, ALI & ELHAM",
    "owner2": "",
    "current_taxes": 10642.43,
    "new_taxes_no_override": 11102.18,
    "override_total_1": 11417.2,
    "override_increase_1": 315.02
  },
  {
    "#": "216 St Paul St, Unit 704 (040-01-24)",
    "$": 718500,
    "address": "216 St Paul St, Unit 704",
    "parcel_id": "040-01-24",
    "owner1": "SHI TRS, WEIGENG",
    "owner2": "WU, RONGRONG",
    "current_taxes": 7357.44,
    "new_taxes_no_override": 7675.28,
    "override_total_1": 7893.06,
    "override_increase_1": 217.78
  },
  {
    "#": "217 St Paul St (041-19-00)",
    "$": 3007800,
    "address": "217 St Paul St",
    "parcel_id": "041-19-00",
    "owner1": "KWAN, BRANDON & PETER & ANTHONY",
    "owner2": "",
    "current_taxes": 27164.94,
    "new_taxes_no_override": 28338.47,
    "override_total_1": 29142.55,
    "override_increase_1": 804.08
  },
  {
    "#": "221 St Paul St (041-20-00)",
    "$": 2964300,
    "address": "221 St Paul St",
    "parcel_id": "041-20-00",
    "owner1": "CHIN, FRANK K",
    "owner2": "EDWARD K & MILDRED M",
    "current_taxes": 30354.43,
    "new_taxes_no_override": 31665.74,
    "override_total_1": 32564.23,
    "override_increase_1": 898.49
  },
  {
    "#": "223 St Paul St (041-21-00)",
    "$": 3037900,
    "address": "223 St Paul St",
    "parcel_id": "041-21-00",
    "owner1": "RAMON REALTY LLC",
    "owner2": "",
    "current_taxes": 31108.1,
    "new_taxes_no_override": 32451.97,
    "override_total_1": 33372.77,
    "override_increase_1": 920.8
  },
  {
    "#": "228 St Paul St, Unit B228 (040-08-49)",
    "$": 849400,
    "address": "228 St Paul St, Unit B228",
    "parcel_id": "040-08-49",
    "owner1": "HUDSON, ELIZABETH ANNE",
    "owner2": "",
    "current_taxes": 8697.86,
    "new_taxes_no_override": 9073.61,
    "override_total_1": 9331.06,
    "override_increase_1": 257.46
  },
  {
    "#": "229 St Paul St (041-01-00)",
    "$": 9451900,
    "address": "229 St Paul St",
    "parcel_id": "041-01-00",
    "owner1": "RAMON REALTY LLC",
    "owner2": "",
    "current_taxes": 96787.46,
    "new_taxes_no_override": 100968.68,
    "override_total_1": 103833.59,
    "override_increase_1": 2864.91
  },
  {
    "#": "230 St Paul St, Unit B230 (040-08-50)",
    "$": 539700,
    "address": "230 St Paul St, Unit B230",
    "parcel_id": "040-08-50",
    "owner1": "BROOKLINE HOUSING AUTHORITY",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "237 St Paul St (039-10-00)",
    "$": 2795100,
    "address": "237 St Paul St",
    "parcel_id": "039-10-00",
    "owner1": "JARDUS, WILLIAM M",
    "owner2": "",
    "current_taxes": 28621.82,
    "new_taxes_no_override": 29858.28,
    "override_total_1": 30705.49,
    "override_increase_1": 847.21
  },
  {
    "#": "245 St Paul St (039-11-00)",
    "$": 175300,
    "address": "245 St Paul St",
    "parcel_id": "039-11-00",
    "owner1": "JARDUS, WILLIAM M",
    "owner2": "",
    "current_taxes": 1795.07,
    "new_taxes_no_override": 1872.62,
    "override_total_1": 1925.75,
    "override_increase_1": 53.13
  },
  {
    "#": "250 St Paul St (038-01-00)",
    "$": 10721300,
    "address": "250 St Paul St",
    "parcel_id": "038-01-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O WINTHROP SQUARE",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "251 St Paul St, Unit 1 (039-12-01)",
    "$": 1673000,
    "address": "251 St Paul St, Unit 1",
    "parcel_id": "039-12-01",
    "owner1": "NEER, ROBERT M JR",
    "owner2": "PHAN, MAIXUAN V",
    "current_taxes": 13496.59,
    "new_taxes_no_override": 14079.64,
    "override_total_1": 14479.14,
    "override_increase_1": 399.5
  },
  {
    "#": "251 St Paul St, Unit 2 (039-12-02)",
    "$": 1707100,
    "address": "251 St Paul St, Unit 2",
    "parcel_id": "039-12-02",
    "owner1": "FELDMAN, PAUL L & LAUREN K DEGLEY",
    "owner2": "",
    "current_taxes": 17480.7,
    "new_taxes_no_override": 18235.87,
    "override_total_1": 18753.29,
    "override_increase_1": 517.43
  },
  {
    "#": "255 St Paul St, Unit 1 (039-13-01)",
    "$": 172700,
    "address": "255 St Paul St, Unit 1",
    "parcel_id": "039-13-01",
    "owner1": "CRAWFORD TR, SLOANE P",
    "owner2": "",
    "current_taxes": 1768.45,
    "new_taxes_no_override": 1844.85,
    "override_total_1": 1897.19,
    "override_increase_1": 52.35
  },
  {
    "#": "255 St Paul St, Unit 10 (039-13-10)",
    "$": 233700,
    "address": "255 St Paul St, Unit 10",
    "parcel_id": "039-13-10",
    "owner1": "LOVETT, TRS, DOROTHY D & VIRGINIA Q",
    "owner2": "",
    "current_taxes": 2393.09,
    "new_taxes_no_override": 2496.47,
    "override_total_1": 2567.31,
    "override_increase_1": 70.84
  },
  {
    "#": "255 St Paul St, Unit 2 (039-13-02)",
    "$": 184200,
    "address": "255 St Paul St, Unit 2",
    "parcel_id": "039-13-02",
    "owner1": "MARLOW, TR, CORINNE",
    "owner2": "",
    "current_taxes": 1886.21,
    "new_taxes_no_override": 1967.69,
    "override_total_1": 2023.53,
    "override_increase_1": 55.83
  },
  {
    "#": "255 St Paul St, Unit 3 (039-13-03)",
    "$": 175700,
    "address": "255 St Paul St, Unit 3",
    "parcel_id": "039-13-03",
    "owner1": "LENTZ TR, LAWRENCE H",
    "owner2": "",
    "current_taxes": 1799.17,
    "new_taxes_no_override": 1876.89,
    "override_total_1": 1930.15,
    "override_increase_1": 53.26
  },
  {
    "#": "255 St Paul St, Unit 4 (039-13-04)",
    "$": 190400,
    "address": "255 St Paul St, Unit 4",
    "parcel_id": "039-13-04",
    "owner1": "LAMPERT, AVIS B & SUMNER",
    "owner2": "C/O NANCY SWARTZ",
    "current_taxes": 1949.7,
    "new_taxes_no_override": 2033.93,
    "override_total_1": 2091.64,
    "override_increase_1": 57.71
  },
  {
    "#": "255 St Paul St, Unit 5 (039-13-05)",
    "$": 168900,
    "address": "255 St Paul St, Unit 5",
    "parcel_id": "039-13-05",
    "owner1": "CHECKMATE 255 LLC",
    "owner2": "",
    "current_taxes": 1729.54,
    "new_taxes_no_override": 1804.26,
    "override_total_1": 1855.45,
    "override_increase_1": 51.19
  },
  {
    "#": "255 St Paul St, Unit 6 (039-13-06)",
    "$": 190400,
    "address": "255 St Paul St, Unit 6",
    "parcel_id": "039-13-06",
    "owner1": "STEIN TRS, JAY A",
    "owner2": "FOX STEIN , GRETCHEN",
    "current_taxes": 1949.7,
    "new_taxes_no_override": 2033.93,
    "override_total_1": 2091.64,
    "override_increase_1": 57.71
  },
  {
    "#": "255 St Paul St, Unit 7 (039-13-07)",
    "$": 173500,
    "address": "255 St Paul St, Unit 7",
    "parcel_id": "039-13-07",
    "owner1": "MOEDER, TRS, CHARLES & SUSAN",
    "owner2": "",
    "current_taxes": 1776.64,
    "new_taxes_no_override": 1853.39,
    "override_total_1": 1905.98,
    "override_increase_1": 52.59
  },
  {
    "#": "255 St Paul St, Unit 8 (039-13-08)",
    "$": 164300,
    "address": "255 St Paul St, Unit 8",
    "parcel_id": "039-13-08",
    "owner1": "CONDON TR, WILLIAM J",
    "owner2": "",
    "current_taxes": 1682.43,
    "new_taxes_no_override": 1755.11,
    "override_total_1": 1804.91,
    "override_increase_1": 49.8
  },
  {
    "#": "255 St Paul St, Unit 9 (039-13-09)",
    "$": 212000,
    "address": "255 St Paul St, Unit 9",
    "parcel_id": "039-13-09",
    "owner1": "MURRAY, TR, RICHARD E",
    "owner2": "C/O MURRAY NICOLE",
    "current_taxes": 2170.88,
    "new_taxes_no_override": 2264.66,
    "override_total_1": 2328.92,
    "override_increase_1": 64.26
  },
  {
    "#": "259 St Paul St (039-14-00)",
    "$": 2778800,
    "address": "259 St Paul St",
    "parcel_id": "039-14-00",
    "owner1": "EPSILON THETA OF SIGMA NU INC",
    "owner2": "C/O TREASURER",
    "current_taxes": 28454.91,
    "new_taxes_no_override": 29684.16,
    "override_total_1": 30526.43,
    "override_increase_1": 842.27
  },
  {
    "#": "265 St Paul St (039-15-00)",
    "$": 2927600,
    "address": "265 St Paul St",
    "parcel_id": "039-15-00",
    "owner1": "TRUPPO, MATTHEW & BRITAIN ASHLEY",
    "owner2": "",
    "current_taxes": 26343.69,
    "new_taxes_no_override": 27481.74,
    "override_total_1": 28261.51,
    "override_increase_1": 779.77
  },
  {
    "#": "271 St Paul St (039-16-00)",
    "$": 1766700,
    "address": "271 St Paul St",
    "parcel_id": "039-16-00",
    "owner1": "SMITH, JOEL H & DVORAH",
    "owner2": "",
    "current_taxes": 14456.07,
    "new_taxes_no_override": 15080.57,
    "override_total_1": 15508.47,
    "override_increase_1": 427.9
  },
  {
    "#": "277 St Paul St (039-17-00)",
    "$": 2954200,
    "address": "277 St Paul St",
    "parcel_id": "039-17-00",
    "owner1": "AVRUCH TRS, JOSEPH",
    "owner2": "BASSIL, BARBARA",
    "current_taxes": 26616.07,
    "new_taxes_no_override": 27765.88,
    "override_total_1": 28553.72,
    "override_increase_1": 787.84
  },
  {
    "#": "281 St Paul St (026-10-11)",
    "$": 9599000,
    "address": "281 St Paul St",
    "parcel_id": "026-10-11",
    "owner1": "FREEMAN APTS LP",
    "owner2": "",
    "current_taxes": 98293.76,
    "new_taxes_no_override": 102540.05,
    "override_total_1": 105449.55,
    "override_increase_1": 2909.5
  },
  {
    "#": "303 St Paul St (025-01-00)",
    "$": 11647000,
    "address": "303 St Paul St",
    "parcel_id": "025-01-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O KNYVET SQUARE",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "315 St Paul St, Unit Sp1 & P-3 (022-19-01)",
    "$": 1357900,
    "address": "315 St Paul St, Unit Sp1 & P-3",
    "parcel_id": "022-19-01",
    "owner1": "PURI, SHYANG",
    "owner2": "",
    "current_taxes": 13904.9,
    "new_taxes_no_override": 14505.59,
    "override_total_1": 14917.18,
    "override_increase_1": 411.59
  },
  {
    "#": "315 St Paul St, Unit Sp2&P2-6 (022-19-02)",
    "$": 1347300,
    "address": "315 St Paul St, Unit Sp2&P2-6",
    "parcel_id": "022-19-02",
    "owner1": "HALLAL TRS, EZZAT SAMIH & LANA SUBHI",
    "owner2": "",
    "current_taxes": 13796.35,
    "new_taxes_no_override": 14392.35,
    "override_total_1": 14800.72,
    "override_increase_1": 408.37
  },
  {
    "#": "315 St Paul St, Unit Sp3 & P-5 (022-19-03)",
    "$": 1137900,
    "address": "315 St Paul St, Unit Sp3 & P-5",
    "parcel_id": "022-19-03",
    "owner1": "DEMBO TR, MICAH",
    "owner2": "",
    "current_taxes": 8017.16,
    "new_taxes_no_override": 8363.5,
    "override_total_1": 8600.81,
    "override_increase_1": 237.31
  },
  {
    "#": "315 St Paul St, Unit T1 & Prk 1 (022-19-04)",
    "$": 481600,
    "address": "315 St Paul St, Unit T1 & Prk 1",
    "parcel_id": "022-19-04",
    "owner1": "PATEL, SANJAY",
    "owner2": "",
    "current_taxes": 4931.58,
    "new_taxes_no_override": 5144.62,
    "override_total_1": 5290.6,
    "override_increase_1": 145.97
  },
  {
    "#": "315 St Paul St, Unit T2 & P4 (022-19-05)",
    "$": 405900,
    "address": "315 St Paul St, Unit T2 & P4",
    "parcel_id": "022-19-05",
    "owner1": "FLORIDIA, PEDRO NESTOR & SAU KING-TANG",
    "owner2": "C/O FOLEY MICHAEL, FENWAY PROPERTIES",
    "current_taxes": 4156.42,
    "new_taxes_no_override": 4335.98,
    "override_total_1": 4459.01,
    "override_increase_1": 123.03
  },
  {
    "#": "316 St Paul St, Unit 1 (023-01-56)",
    "$": 689200,
    "address": "316 St Paul St, Unit 1",
    "parcel_id": "023-01-56",
    "owner1": "MOKHTARI-DIZAJI, REZA",
    "owner2": "",
    "current_taxes": 7057.41,
    "new_taxes_no_override": 7362.29,
    "override_total_1": 7571.19,
    "override_increase_1": 208.9
  },
  {
    "#": "316 St Paul St, Unit 2 (023-01-57)",
    "$": 618900,
    "address": "316 St Paul St, Unit 2",
    "parcel_id": "023-01-57",
    "owner1": "EGMONT PARK 38 CONDOS LLC",
    "owner2": "C/O MAIN STREET REALTY",
    "current_taxes": 6337.54,
    "new_taxes_no_override": 6611.32,
    "override_total_1": 6798.91,
    "override_increase_1": 187.59
  },
  {
    "#": "316 St Paul St, Unit 3 (023-01-58)",
    "$": 694900,
    "address": "316 St Paul St, Unit 3",
    "parcel_id": "023-01-58",
    "owner1": "EGMONT PARK 38 CONDOS LLC",
    "owner2": "C/O MAIN STREET REALTY",
    "current_taxes": 7115.78,
    "new_taxes_no_override": 7423.18,
    "override_total_1": 7633.81,
    "override_increase_1": 210.63
  },
  {
    "#": "316 St Paul St, Unit 4 (023-01-59)",
    "$": 647800,
    "address": "316 St Paul St, Unit 4",
    "parcel_id": "023-01-59",
    "owner1": "EGMONT PARK 38 CONDOS LLC",
    "owner2": "C/O MAIN STREET REALTY",
    "current_taxes": 6633.47,
    "new_taxes_no_override": 6920.04,
    "override_total_1": 7116.39,
    "override_increase_1": 196.35
  },
  {
    "#": "316 St Paul St, Unit 5 & P45 (023-01-60)",
    "$": 721500,
    "address": "316 St Paul St, Unit 5 & P45",
    "parcel_id": "023-01-60",
    "owner1": "RAPP, FRANK",
    "owner2": "NICHTER, SUSAN D",
    "current_taxes": 7388.16,
    "new_taxes_no_override": 7707.33,
    "override_total_1": 7926.02,
    "override_increase_1": 218.69
  },
  {
    "#": "316 St Paul St, Unit 6 (023-01-61)",
    "$": 661400,
    "address": "316 St Paul St, Unit 6",
    "parcel_id": "023-01-61",
    "owner1": "EGMONT PARK 38 CONDOS LLC",
    "owner2": "C/O MAIN STREET REALTY",
    "current_taxes": 6772.74,
    "new_taxes_no_override": 7065.32,
    "override_total_1": 7265.8,
    "override_increase_1": 200.47
  },
  {
    "#": "316 St Paul St, Unit B & P47 (023-01-55)",
    "$": 595400,
    "address": "316 St Paul St, Unit B & P47",
    "parcel_id": "023-01-55",
    "owner1": "MAYFIELD TR, SABRA",
    "owner2": "",
    "current_taxes": 2461.96,
    "new_taxes_no_override": 2568.32,
    "override_total_1": 2641.19,
    "override_increase_1": 72.87
  },
  {
    "#": "317 St Paul St (022-20-00)",
    "$": 3298300,
    "address": "317 St Paul St",
    "parcel_id": "022-20-00",
    "owner1": "CROMWELL REALTY LLC",
    "owner2": "",
    "current_taxes": 33774.59,
    "new_taxes_no_override": 35233.65,
    "override_total_1": 36233.38,
    "override_increase_1": 999.73
  },
  {
    "#": "318 St Paul St, Unit 1 (023-01-62)",
    "$": 684900,
    "address": "318 St Paul St, Unit 1",
    "parcel_id": "023-01-62",
    "owner1": "KAI FEUNG 88 LLC",
    "owner2": "",
    "current_taxes": 7013.38,
    "new_taxes_no_override": 7316.36,
    "override_total_1": 7523.95,
    "override_increase_1": 207.6
  },
  {
    "#": "318 St Paul St, Unit 2 (023-01-63)",
    "$": 661500,
    "address": "318 St Paul St, Unit 2",
    "parcel_id": "023-01-63",
    "owner1": "KAI FEUNG 88 LLC",
    "owner2": "",
    "current_taxes": 6773.76,
    "new_taxes_no_override": 7066.39,
    "override_total_1": 7266.89,
    "override_increase_1": 200.5
  },
  {
    "#": "318 St Paul St, Unit 3 (023-01-64)",
    "$": 700200,
    "address": "318 St Paul St, Unit 3",
    "parcel_id": "023-01-64",
    "owner1": "HOURANI TR, AFAF J",
    "owner2": "",
    "current_taxes": 3535.11,
    "new_taxes_no_override": 3687.83,
    "override_total_1": 3792.47,
    "override_increase_1": 104.64
  },
  {
    "#": "318 St Paul St, Unit 4 (023-01-65)",
    "$": 651200,
    "address": "318 St Paul St, Unit 4",
    "parcel_id": "023-01-65",
    "owner1": "EGMONT PARK 38 CONDOS LLC",
    "owner2": "C/O MAIN STREET REALTY",
    "current_taxes": 6668.29,
    "new_taxes_no_override": 6956.36,
    "override_total_1": 7153.74,
    "override_increase_1": 197.38
  },
  {
    "#": "318 St Paul St, Unit 5 (023-01-66)",
    "$": 692000,
    "address": "318 St Paul St, Unit 5",
    "parcel_id": "023-01-66",
    "owner1": "EGMONT PARK 38 CONDOS LLC",
    "owner2": "C/O MAIN STREET REALTY",
    "current_taxes": 7086.08,
    "new_taxes_no_override": 7392.2,
    "override_total_1": 7601.95,
    "override_increase_1": 209.75
  },
  {
    "#": "318 St Paul St, Unit 6 (023-01-67)",
    "$": 635900,
    "address": "318 St Paul St, Unit 6",
    "parcel_id": "023-01-67",
    "owner1": "EGMONT PARK 38 CONDOS LLC",
    "owner2": "C/O MAIN STREET REALTY",
    "current_taxes": 6511.62,
    "new_taxes_no_override": 6792.92,
    "override_total_1": 6985.67,
    "override_increase_1": 192.74
  },
  {
    "#": "319 St Paul St, Unit 1 & P7-8 (022-21-01)",
    "$": 1006100,
    "address": "319 St Paul St, Unit 1 & P7-8",
    "parcel_id": "022-21-01",
    "owner1": "KONG TR, THOMAS L",
    "owner2": "",
    "current_taxes": 10302.46,
    "new_taxes_no_override": 10747.53,
    "override_total_1": 11052.48,
    "override_increase_1": 304.95
  },
  {
    "#": "319 St Paul St, Unit 2 & P1-6 (022-21-02)",
    "$": 1151100,
    "address": "319 St Paul St, Unit 2 & P1-6",
    "parcel_id": "022-21-02",
    "owner1": "BEAULIEU, NICOLAS",
    "owner2": "FOURNIER, ANDREE-ANNE",
    "current_taxes": 8152.33,
    "new_taxes_no_override": 8504.51,
    "override_total_1": 8745.82,
    "override_increase_1": 241.31
  },
  {
    "#": "319 St Paul St, Unit 3 & P2-5 (022-21-03)",
    "$": 1157100,
    "address": "319 St Paul St, Unit 3 & P2-5",
    "parcel_id": "022-21-03",
    "owner1": "RUSSINOVA, ZLATSKA",
    "owner2": "",
    "current_taxes": 8213.77,
    "new_taxes_no_override": 8568.6,
    "override_total_1": 8811.73,
    "override_increase_1": 243.13
  },
  {
    "#": "319 St Paul St, Unit P3-4 (022-21-04)",
    "$": 102300,
    "address": "319 St Paul St, Unit P3-4",
    "parcel_id": "022-21-04",
    "owner1": "HASHKES, GENE & DIANA",
    "owner2": "",
    "current_taxes": 1047.55,
    "new_taxes_no_override": 1092.8,
    "override_total_1": 1123.81,
    "override_increase_1": 31.01
  },
  {
    "#": "322 St Paul St, Unit 1 (023-01-68)",
    "$": 683800,
    "address": "322 St Paul St, Unit 1",
    "parcel_id": "023-01-68",
    "owner1": "EGMONT PARK 38 CONDOS LLC",
    "owner2": "C/O MAIN STREET REALTY",
    "current_taxes": 7002.11,
    "new_taxes_no_override": 7304.6,
    "override_total_1": 7511.86,
    "override_increase_1": 207.26
  },
  {
    "#": "322 St Paul St, Unit 2 (023-01-69)",
    "$": 618900,
    "address": "322 St Paul St, Unit 2",
    "parcel_id": "023-01-69",
    "owner1": "EGMONT PARK 38 CONDOS LLC",
    "owner2": "C/O MAIN STREET REALTY",
    "current_taxes": 6337.54,
    "new_taxes_no_override": 6611.32,
    "override_total_1": 6798.91,
    "override_increase_1": 187.59
  },
  {
    "#": "322 St Paul St, Unit 3 (023-01-70)",
    "$": 1123600,
    "address": "322 St Paul St, Unit 3",
    "parcel_id": "023-01-70",
    "owner1": "EGMONT PARK 38 CONDOS LLC",
    "owner2": "C/O MAIN STREET REALTY",
    "current_taxes": 11505.66,
    "new_taxes_no_override": 12002.7,
    "override_total_1": 12343.27,
    "override_increase_1": 340.57
  },
  {
    "#": "322 St Paul St, Unit 5 (023-01-71)",
    "$": 702500,
    "address": "322 St Paul St, Unit 5",
    "parcel_id": "023-01-71",
    "owner1": "EGMONT PARK 38 CONDOS LLC",
    "owner2": "C/O MAIN STREET REALTY",
    "current_taxes": 7193.6,
    "new_taxes_no_override": 7504.36,
    "override_total_1": 7717.29,
    "override_increase_1": 212.93
  },
  {
    "#": "322 St Paul St, Unit 6 (023-01-72)",
    "$": 635900,
    "address": "322 St Paul St, Unit 6",
    "parcel_id": "023-01-72",
    "owner1": "DODD, JAMES",
    "owner2": "LEAO, MARIA",
    "current_taxes": 6511.62,
    "new_taxes_no_override": 6792.92,
    "override_total_1": 6985.67,
    "override_increase_1": 192.74
  },
  {
    "#": "323 St Paul St, Unit 1 & P4-P8 (022-22-01)",
    "$": 1021900,
    "address": "323 St Paul St, Unit 1 & P4-P8",
    "parcel_id": "022-22-01",
    "owner1": "PLUMB, STEVEN & SHELLY",
    "owner2": "",
    "current_taxes": 6829.32,
    "new_taxes_no_override": 7124.35,
    "override_total_1": 7326.49,
    "override_increase_1": 202.15
  },
  {
    "#": "323 St Paul St, Unit 2 & P3-P7 (022-22-02)",
    "$": 1174700,
    "address": "323 St Paul St, Unit 2 & P3-P7",
    "parcel_id": "022-22-02",
    "owner1": "GREENSTEIN, DANIEL JAY",
    "owner2": "",
    "current_taxes": 8393.99,
    "new_taxes_no_override": 8756.61,
    "override_total_1": 9005.07,
    "override_increase_1": 248.46
  },
  {
    "#": "323 St Paul St, Unit 3 & P2-P6 (022-22-03)",
    "$": 1370100,
    "address": "323 St Paul St, Unit 3 & P2-P6",
    "parcel_id": "022-22-03",
    "owner1": "CHEN, XIZHAO",
    "owner2": "WANG, JIAYUAN",
    "current_taxes": 10394.89,
    "new_taxes_no_override": 10843.95,
    "override_total_1": 11151.64,
    "override_increase_1": 307.69
  },
  {
    "#": "323 St Paul St, Unit 4 & P1 P5 (022-22-04)",
    "$": 1448500,
    "address": "323 St Paul St, Unit 4 & P1 P5",
    "parcel_id": "022-22-04",
    "owner1": "WRIGHT, JAMES G",
    "owner2": "LYNN, JENNIFER",
    "current_taxes": 11197.71,
    "new_taxes_no_override": 11681.45,
    "override_total_1": 12012.9,
    "override_increase_1": 331.45
  },
  {
    "#": "324 St Paul St, Unit 1 (023-01-73)",
    "$": 705100,
    "address": "324 St Paul St, Unit 1",
    "parcel_id": "023-01-73",
    "owner1": "YOU, HAIDONG",
    "owner2": "TIAN, WANGNI",
    "current_taxes": 7220.22,
    "new_taxes_no_override": 7532.13,
    "override_total_1": 7745.85,
    "override_increase_1": 213.72
  },
  {
    "#": "324 St Paul St, Unit 2 (023-01-74)",
    "$": 643100,
    "address": "324 St Paul St, Unit 2",
    "parcel_id": "023-01-74",
    "owner1": "EGMONT PARK 38 CONDOS LLC",
    "owner2": "C/O MAIN STREET REALTY",
    "current_taxes": 6585.34,
    "new_taxes_no_override": 6869.83,
    "override_total_1": 7064.75,
    "override_increase_1": 194.93
  },
  {
    "#": "324 St Paul St, Unit 3 & P38 (023-01-75)",
    "$": 717200,
    "address": "324 St Paul St, Unit 3 & P38",
    "parcel_id": "023-01-75",
    "owner1": "YOU, DALE",
    "owner2": "",
    "current_taxes": 7344.13,
    "new_taxes_no_override": 7661.4,
    "override_total_1": 7878.78,
    "override_increase_1": 217.39
  },
  {
    "#": "324 St Paul St, Unit 4 (023-01-76)",
    "$": 643100,
    "address": "324 St Paul St, Unit 4",
    "parcel_id": "023-01-76",
    "owner1": "EGMONT PARK 38 CONDOS LLC",
    "owner2": "C/O MAIN STREET REALTY",
    "current_taxes": 6585.34,
    "new_taxes_no_override": 6869.83,
    "override_total_1": 7064.75,
    "override_increase_1": 194.93
  },
  {
    "#": "324 St Paul St, Unit 5 (023-01-77)",
    "$": 717200,
    "address": "324 St Paul St, Unit 5",
    "parcel_id": "023-01-77",
    "owner1": "POKROVSKY, NATALIA & ANDREI",
    "owner2": "",
    "current_taxes": 3709.19,
    "new_taxes_no_override": 3869.43,
    "override_total_1": 3979.22,
    "override_increase_1": 109.79
  },
  {
    "#": "324 St Paul St, Unit 6 (023-01-78)",
    "$": 647800,
    "address": "324 St Paul St, Unit 6",
    "parcel_id": "023-01-78",
    "owner1": "EGMONT PARK 38 CONDOS LLC",
    "owner2": "C/O MAIN STREET REALTY",
    "current_taxes": 6633.47,
    "new_taxes_no_override": 6920.04,
    "override_total_1": 7116.39,
    "override_increase_1": 196.35
  },
  {
    "#": "325 St Paul St (022-23-00)",
    "$": 2726700,
    "address": "325 St Paul St",
    "parcel_id": "022-23-00",
    "owner1": "WONG TR, SUSAN S L",
    "owner2": "WONG, BARRY-EVELYN-GORDON & YIU Y",
    "current_taxes": 24286.47,
    "new_taxes_no_override": 25335.65,
    "override_total_1": 26054.53,
    "override_increase_1": 718.88
  },
  {
    "#": "327 St Paul St, Unit 1 P-1 & 2 (022-24-03)",
    "$": 1317300,
    "address": "327 St Paul St, Unit 1 P-1 & 2",
    "parcel_id": "022-24-03",
    "owner1": "YAO TR, HUAI CHUN",
    "owner2": "",
    "current_taxes": 13489.15,
    "new_taxes_no_override": 14071.88,
    "override_total_1": 14471.16,
    "override_increase_1": 399.28
  },
  {
    "#": "327 St Paul St, Unit 2 & P3-4 (022-24-01)",
    "$": 1295700,
    "address": "327 St Paul St, Unit 2 & P3-4",
    "parcel_id": "022-24-01",
    "owner1": "MARSHALL TRS, JAMES & ESTHER",
    "owner2": "",
    "current_taxes": 9633.03,
    "new_taxes_no_override": 10049.18,
    "override_total_1": 10334.31,
    "override_increase_1": 285.14
  },
  {
    "#": "327 St Paul St, Unit 3 Pk 5 6 (022-24-02)",
    "$": 1353800,
    "address": "327 St Paul St, Unit 3 Pk 5 6",
    "parcel_id": "022-24-02",
    "owner1": "LU, RITA DOREEN",
    "owner2": "",
    "current_taxes": 10227.98,
    "new_taxes_no_override": 10669.83,
    "override_total_1": 10972.58,
    "override_increase_1": 302.75
  },
  {
    "#": "328 St Paul St, Unit 1 (023-01-79)",
    "$": 728800,
    "address": "328 St Paul St, Unit 1",
    "parcel_id": "023-01-79",
    "owner1": "KAI FEUNG 88 LLC",
    "owner2": "",
    "current_taxes": 7462.91,
    "new_taxes_no_override": 7785.31,
    "override_total_1": 8006.21,
    "override_increase_1": 220.9
  },
  {
    "#": "328 St Paul St, Unit 2 (023-01-80)",
    "$": 661400,
    "address": "328 St Paul St, Unit 2",
    "parcel_id": "023-01-80",
    "owner1": "KAI FEUNG 88 LLC",
    "owner2": "",
    "current_taxes": 6772.74,
    "new_taxes_no_override": 7065.32,
    "override_total_1": 7265.8,
    "override_increase_1": 200.47
  },
  {
    "#": "328 St Paul St, Unit 3 (023-01-81)",
    "$": 731200,
    "address": "328 St Paul St, Unit 3",
    "parcel_id": "023-01-81",
    "owner1": "KA FAI 88 LLC",
    "owner2": "",
    "current_taxes": 7487.49,
    "new_taxes_no_override": 7810.95,
    "override_total_1": 8032.58,
    "override_increase_1": 221.63
  },
  {
    "#": "328 St Paul St, Unit 4 (023-01-82)",
    "$": 661400,
    "address": "328 St Paul St, Unit 4",
    "parcel_id": "023-01-82",
    "owner1": "KA FAI 88 LLC",
    "owner2": "",
    "current_taxes": 6772.74,
    "new_taxes_no_override": 7065.32,
    "override_total_1": 7265.8,
    "override_increase_1": 200.47
  },
  {
    "#": "328 St Paul St, Unit 5 (023-01-83)",
    "$": 736900,
    "address": "328 St Paul St, Unit 5",
    "parcel_id": "023-01-83",
    "owner1": "KAI FEUNG 88 LLC",
    "owner2": "",
    "current_taxes": 7545.86,
    "new_taxes_no_override": 7871.84,
    "override_total_1": 8095.2,
    "override_increase_1": 223.36
  },
  {
    "#": "328 St Paul St, Unit 6 (023-01-84)",
    "$": 661400,
    "address": "328 St Paul St, Unit 6",
    "parcel_id": "023-01-84",
    "owner1": "KAI FEUNG 88 LLC",
    "owner2": "",
    "current_taxes": 6772.74,
    "new_taxes_no_override": 7065.32,
    "override_total_1": 7265.8,
    "override_increase_1": 200.47
  },
  {
    "#": "330 St Paul St, Unit 1 & P-44 (023-01-85)",
    "$": 718100,
    "address": "330 St Paul St, Unit 1 & P-44",
    "parcel_id": "023-01-85",
    "owner1": "330 SAINT PAUL ST LLC",
    "owner2": "",
    "current_taxes": 7353.34,
    "new_taxes_no_override": 7671.0,
    "override_total_1": 7888.66,
    "override_increase_1": 217.66
  },
  {
    "#": "330 St Paul St, Unit 2 (023-01-86)",
    "$": 629100,
    "address": "330 St Paul St, Unit 2",
    "parcel_id": "023-01-86",
    "owner1": "BERMAN-ROSSI, LUCIA",
    "owner2": "",
    "current_taxes": 6441.98,
    "new_taxes_no_override": 6720.27,
    "override_total_1": 6910.96,
    "override_increase_1": 190.68
  },
  {
    "#": "330 St Paul St, Unit 3 (023-01-87)",
    "$": 689200,
    "address": "330 St Paul St, Unit 3",
    "parcel_id": "023-01-87",
    "owner1": "KA FAI 88 LLC",
    "owner2": "",
    "current_taxes": 7057.41,
    "new_taxes_no_override": 7362.29,
    "override_total_1": 7571.19,
    "override_increase_1": 208.9
  },
  {
    "#": "330 St Paul St, Unit 4 (023-01-88)",
    "$": 635900,
    "address": "330 St Paul St, Unit 4",
    "parcel_id": "023-01-88",
    "owner1": "KA FAI LLC",
    "owner2": "",
    "current_taxes": 6511.62,
    "new_taxes_no_override": 6792.92,
    "override_total_1": 6985.67,
    "override_increase_1": 192.74
  },
  {
    "#": "330 St Paul St, Unit 5 & P26 (023-01-89)",
    "$": 829800,
    "address": "330 St Paul St, Unit 5 & P26",
    "parcel_id": "023-01-89",
    "owner1": "330 SAINT PAUL ST LLC",
    "owner2": "",
    "current_taxes": 8497.15,
    "new_taxes_no_override": 8864.23,
    "override_total_1": 9115.74,
    "override_increase_1": 251.52
  },
  {
    "#": "330 St Paul St, Unit 6 (023-01-90)",
    "$": 635900,
    "address": "330 St Paul St, Unit 6",
    "parcel_id": "023-01-90",
    "owner1": "KAI FEUNG 88 LLC",
    "owner2": "",
    "current_taxes": 6511.62,
    "new_taxes_no_override": 6792.92,
    "override_total_1": 6985.67,
    "override_increase_1": 192.74
  },
  {
    "#": "338 St Paul St (020-01-00)",
    "$": 26769800,
    "address": "338 St Paul St",
    "parcel_id": "020-01-00",
    "owner1": "BROOKLINE HOUSING AUTHORITY",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "11 Stanton Rd (200-02-00)",
    "$": 2331600,
    "address": "11 Stanton Rd",
    "parcel_id": "200-02-00",
    "owner1": "IMURA LIFE ESTATE, SABURO & JITSUE",
    "owner2": "",
    "current_taxes": 20240.65,
    "new_taxes_no_override": 21115.05,
    "override_total_1": 21714.17,
    "override_increase_1": 599.12
  },
  {
    "#": "12 Stanton Rd (198-06-00)",
    "$": 2345200,
    "address": "12 Stanton Rd",
    "parcel_id": "198-06-00",
    "owner1": "VARTANIAN, TIMOTHY K & JOANNA VOLPE",
    "owner2": "",
    "current_taxes": 20379.91,
    "new_taxes_no_override": 21260.32,
    "override_total_1": 21863.57,
    "override_increase_1": 603.25
  },
  {
    "#": "19 Stanton Rd (200-03-00)",
    "$": 1641800,
    "address": "19 Stanton Rd",
    "parcel_id": "200-03-00",
    "owner1": "DWYER, EDWARD J & JEAN S",
    "owner2": "",
    "current_taxes": 13177.1,
    "new_taxes_no_override": 13746.35,
    "override_total_1": 14136.39,
    "override_increase_1": 390.04
  },
  {
    "#": "25 Stanton Rd (200-04-00)",
    "$": 3301000,
    "address": "25 Stanton Rd",
    "parcel_id": "200-04-00",
    "owner1": "MCARDLE, THOMAS & COLIN",
    "owner2": "",
    "current_taxes": 30167.31,
    "new_taxes_no_override": 31470.54,
    "override_total_1": 32363.49,
    "override_increase_1": 892.95
  },
  {
    "#": "27 Stanton Rd, Unit 1 & Pk C (200-05-02)",
    "$": 1134000,
    "address": "27 Stanton Rd, Unit 1 & Pk C",
    "parcel_id": "200-05-02",
    "owner1": "PANYCH, LAWRENCE P",
    "owner2": "DICKEY, CHANDLEE C",
    "current_taxes": 11612.16,
    "new_taxes_no_override": 12113.81,
    "override_total_1": 12457.53,
    "override_increase_1": 343.72
  },
  {
    "#": "27 Stanton Rd, Unit 2 & Pk A (200-05-03)",
    "$": 1189600,
    "address": "27 Stanton Rd, Unit 2 & Pk A",
    "parcel_id": "200-05-03",
    "owner1": "MARTIN, DAVID",
    "owner2": "",
    "current_taxes": 8546.57,
    "new_taxes_no_override": 8915.78,
    "override_total_1": 9168.76,
    "override_increase_1": 252.98
  },
  {
    "#": "27 Stanton Rd, Unit 3 & Pk B (200-05-04)",
    "$": 1154400,
    "address": "27 Stanton Rd, Unit 3 & Pk B",
    "parcel_id": "200-05-04",
    "owner1": "PICHARD, GEORGES",
    "owner2": "",
    "current_taxes": 8186.12,
    "new_taxes_no_override": 8539.76,
    "override_total_1": 8782.07,
    "override_increase_1": 242.31
  },
  {
    "#": "28 Stanton Rd, Unit 1 (199-13-30)",
    "$": 940200,
    "address": "28 Stanton Rd, Unit 1",
    "parcel_id": "199-13-30",
    "owner1": "WELLS TRS, JAMES AERTSEN JR & JENNIFER BALGLEY",
    "owner2": "",
    "current_taxes": 5992.71,
    "new_taxes_no_override": 6251.6,
    "override_total_1": 6428.98,
    "override_increase_1": 177.38
  },
  {
    "#": "28 Stanton Rd, Unit 2 (199-13-01)",
    "$": 1055400,
    "address": "28 Stanton Rd, Unit 2",
    "parcel_id": "199-13-01",
    "owner1": "RIFE, JEAN M",
    "owner2": "BERGER, MARC L",
    "current_taxes": 7172.36,
    "new_taxes_no_override": 7482.21,
    "override_total_1": 7694.51,
    "override_increase_1": 212.3
  },
  {
    "#": "28 Stanton Rd, Unit 3 (199-13-02)",
    "$": 732900,
    "address": "28 Stanton Rd, Unit 3",
    "parcel_id": "199-13-02",
    "owner1": "SUWINSKI, ROBERT",
    "owner2": "DELHANTY, SHEILA",
    "current_taxes": 3869.96,
    "new_taxes_no_override": 4037.14,
    "override_total_1": 4151.69,
    "override_increase_1": 114.55
  },
  {
    "#": "28 Stanton Rd, Unit 4 (199-13-03)",
    "$": 823300,
    "address": "28 Stanton Rd, Unit 4",
    "parcel_id": "199-13-03",
    "owner1": "HASENBUSH, TRS, ABBE",
    "owner2": "",
    "current_taxes": 4795.66,
    "new_taxes_no_override": 5002.83,
    "override_total_1": 5144.78,
    "override_increase_1": 141.95
  },
  {
    "#": "28 Stanton Rd, Unit 5 (199-13-04)",
    "$": 859600,
    "address": "28 Stanton Rd, Unit 5",
    "parcel_id": "199-13-04",
    "owner1": "PANITCH, REBECCA BINA & ORLEE & IRWIN",
    "owner2": "",
    "current_taxes": 5167.37,
    "new_taxes_no_override": 5390.6,
    "override_total_1": 5543.55,
    "override_increase_1": 152.95
  },
  {
    "#": "28 Stanton Rd, Unit 6 (199-13-05)",
    "$": 852000,
    "address": "28 Stanton Rd, Unit 6",
    "parcel_id": "199-13-05",
    "owner1": "MACHKASOVA, POLINA",
    "owner2": "",
    "current_taxes": 5089.55,
    "new_taxes_no_override": 5309.42,
    "override_total_1": 5460.07,
    "override_increase_1": 150.65
  },
  {
    "#": "30 Stanton Rd, Unit 1 (199-13-06)",
    "$": 1041200,
    "address": "30 Stanton Rd, Unit 1",
    "parcel_id": "199-13-06",
    "owner1": "SWEENEY, WILLIAM RICARDO",
    "owner2": "MAYA, SUSAN EVA",
    "current_taxes": 7026.95,
    "new_taxes_no_override": 7330.51,
    "override_total_1": 7538.51,
    "override_increase_1": 208.0
  },
  {
    "#": "30 Stanton Rd, Unit 2 (199-13-07)",
    "$": 1023600,
    "address": "30 Stanton Rd, Unit 2",
    "parcel_id": "199-13-07",
    "owner1": "MADJAR, RONEN & GILA H",
    "owner2": "",
    "current_taxes": 6846.73,
    "new_taxes_no_override": 7142.51,
    "override_total_1": 7345.17,
    "override_increase_1": 202.66
  },
  {
    "#": "30 Stanton Rd, Unit 3 (199-13-08)",
    "$": 809600,
    "address": "30 Stanton Rd, Unit 3",
    "parcel_id": "199-13-08",
    "owner1": "SHUSTER, SCOTT A",
    "owner2": "JOHNSON-YU, SONJA Q",
    "current_taxes": 4655.37,
    "new_taxes_no_override": 4856.48,
    "override_total_1": 4994.28,
    "override_increase_1": 137.8
  },
  {
    "#": "30 Stanton Rd, Unit 4 (199-13-09)",
    "$": 842500,
    "address": "30 Stanton Rd, Unit 4",
    "parcel_id": "199-13-09",
    "owner1": "MANKEL, ROBIN MARIE",
    "owner2": "ROBINAUGH, DONALD JOHN",
    "current_taxes": 4992.27,
    "new_taxes_no_override": 5207.94,
    "override_total_1": 5355.71,
    "override_increase_1": 147.77
  },
  {
    "#": "30 Stanton Rd, Unit 5 (199-13-10)",
    "$": 821200,
    "address": "30 Stanton Rd, Unit 5",
    "parcel_id": "199-13-10",
    "owner1": "MOORE, ANDREW L",
    "owner2": "",
    "current_taxes": 4774.15,
    "new_taxes_no_override": 4980.39,
    "override_total_1": 5121.71,
    "override_increase_1": 141.31
  },
  {
    "#": "30 Stanton Rd, Unit 6 (199-13-11)",
    "$": 821500,
    "address": "30 Stanton Rd, Unit 6",
    "parcel_id": "199-13-11",
    "owner1": "KO, NAOMI",
    "owner2": "URBAS, AVI",
    "current_taxes": 8412.16,
    "new_taxes_no_override": 8775.57,
    "override_total_1": 9024.57,
    "override_increase_1": 249.0
  },
  {
    "#": "32 Stanton Rd, Unit 1 (199-13-12)",
    "$": 876100,
    "address": "32 Stanton Rd, Unit 1",
    "parcel_id": "199-13-12",
    "owner1": "NARDONE, DAVID",
    "owner2": "PLUMMER, JENNIFER",
    "current_taxes": 5336.33,
    "new_taxes_no_override": 5566.86,
    "override_total_1": 5724.81,
    "override_increase_1": 157.96
  },
  {
    "#": "32 Stanton Rd, Unit 2 (199-13-13)",
    "$": 897300,
    "address": "32 Stanton Rd, Unit 2",
    "parcel_id": "199-13-13",
    "owner1": "BOYDEN, FEN ZHANG",
    "owner2": "",
    "current_taxes": 9188.35,
    "new_taxes_no_override": 9585.29,
    "override_total_1": 9857.26,
    "override_increase_1": 271.98
  },
  {
    "#": "32 Stanton Rd, Unit 3 (199-13-14)",
    "$": 912700,
    "address": "32 Stanton Rd, Unit 3",
    "parcel_id": "199-13-14",
    "owner1": "DOHERTY, TERESA M",
    "owner2": "SCHMIDT, AARON M",
    "current_taxes": 5711.11,
    "new_taxes_no_override": 5957.83,
    "override_total_1": 6126.88,
    "override_increase_1": 169.05
  },
  {
    "#": "33 Stanton Rd, Unit 1 (200-05-05)",
    "$": 1071100,
    "address": "33 Stanton Rd, Unit 1",
    "parcel_id": "200-05-05",
    "owner1": "CHAN, BRIAN TAN & BERNARDINE ILETO",
    "owner2": "",
    "current_taxes": 7333.13,
    "new_taxes_no_override": 7649.92,
    "override_total_1": 7866.98,
    "override_increase_1": 217.06
  },
  {
    "#": "33 Stanton Rd, Unit 2 (200-05-06)",
    "$": 1090100,
    "address": "33 Stanton Rd, Unit 2",
    "parcel_id": "200-05-06",
    "owner1": "WU, XIN",
    "owner2": "ZHANG, XUEMEI",
    "current_taxes": 7527.69,
    "new_taxes_no_override": 7852.89,
    "override_total_1": 8075.71,
    "override_increase_1": 222.82
  },
  {
    "#": "33 Stanton Rd, Unit 3 (200-05-07)",
    "$": 1190800,
    "address": "33 Stanton Rd, Unit 3",
    "parcel_id": "200-05-07",
    "owner1": "JOHNSON, STEVEN M",
    "owner2": "BUCHBINDER, JANE",
    "current_taxes": 8558.86,
    "new_taxes_no_override": 8928.6,
    "override_total_1": 9181.95,
    "override_increase_1": 253.34
  },
  {
    "#": "34 Stanton Rd, Unit 1 (199-13-15)",
    "$": 742100,
    "address": "34 Stanton Rd, Unit 1",
    "parcel_id": "199-13-15",
    "owner1": "ZHANG, TONGYUE",
    "owner2": "",
    "current_taxes": 3964.17,
    "new_taxes_no_override": 4135.42,
    "override_total_1": 4252.76,
    "override_increase_1": 117.34
  },
  {
    "#": "34 Stanton Rd, Unit 2 (199-13-16)",
    "$": 856900,
    "address": "34 Stanton Rd, Unit 2",
    "parcel_id": "199-13-16",
    "owner1": "SAADAT, AHMAD & CYNTHIA",
    "owner2": "",
    "current_taxes": 5139.72,
    "new_taxes_no_override": 5361.76,
    "override_total_1": 5513.89,
    "override_increase_1": 152.14
  },
  {
    "#": "34 Stanton Rd, Unit 3 (199-13-17)",
    "$": 821400,
    "address": "34 Stanton Rd, Unit 3",
    "parcel_id": "199-13-17",
    "owner1": "DRANE, PASCAL D",
    "owner2": "",
    "current_taxes": 4776.2,
    "new_taxes_no_override": 4982.53,
    "override_total_1": 5123.91,
    "override_increase_1": 141.38
  },
  {
    "#": "36 Stanton Rd, Unit 1 (199-13-18)",
    "$": 878500,
    "address": "36 Stanton Rd, Unit 1",
    "parcel_id": "199-13-18",
    "owner1": "MCINTOSH, MICHAEL",
    "owner2": "TURNER, LAURA",
    "current_taxes": 5360.91,
    "new_taxes_no_override": 5592.5,
    "override_total_1": 5751.18,
    "override_increase_1": 158.68
  },
  {
    "#": "36 Stanton Rd, Unit 2 (199-13-19)",
    "$": 803900,
    "address": "36 Stanton Rd, Unit 2",
    "parcel_id": "199-13-19",
    "owner1": "HU, WANZHENG",
    "owner2": "RUDEK, BENEDIKT",
    "current_taxes": 4597.0,
    "new_taxes_no_override": 4795.59,
    "override_total_1": 4931.66,
    "override_increase_1": 136.07
  },
  {
    "#": "36 Stanton Rd, Unit 3 (199-13-20)",
    "$": 817600,
    "address": "36 Stanton Rd, Unit 3",
    "parcel_id": "199-13-20",
    "owner1": "SUN, WEI",
    "owner2": "",
    "current_taxes": 8372.22,
    "new_taxes_no_override": 8733.9,
    "override_total_1": 8981.72,
    "override_increase_1": 247.82
  },
  {
    "#": "37 Stanton Rd (200-06-00)",
    "$": 2452100,
    "address": "37 Stanton Rd",
    "parcel_id": "200-06-00",
    "owner1": "KESSLER, BETSY",
    "owner2": "",
    "current_taxes": 21474.57,
    "new_taxes_no_override": 22402.27,
    "override_total_1": 23037.92,
    "override_increase_1": 635.65
  },
  {
    "#": "38 Stanton Rd, Unit 1 (199-13-21)",
    "$": 1085800,
    "address": "38 Stanton Rd, Unit 1",
    "parcel_id": "199-13-21",
    "owner1": "HOFFMAN, AARON",
    "owner2": "DHAR, SHUSMITA",
    "current_taxes": 7483.66,
    "new_taxes_no_override": 7806.95,
    "override_total_1": 8028.47,
    "override_increase_1": 221.52
  },
  {
    "#": "38 Stanton Rd, Unit 2 (199-13-22)",
    "$": 804000,
    "address": "38 Stanton Rd, Unit 2",
    "parcel_id": "199-13-22",
    "owner1": "SHAPIRO, TRS, MARSHALL D & AMY",
    "owner2": "",
    "current_taxes": 8232.96,
    "new_taxes_no_override": 8588.62,
    "override_total_1": 8832.32,
    "override_increase_1": 243.7
  },
  {
    "#": "38 Stanton Rd, Unit 3 (199-13-23)",
    "$": 857000,
    "address": "38 Stanton Rd, Unit 3",
    "parcel_id": "199-13-23",
    "owner1": "DE SANTIAGO, PABLO RODRIGUEZ",
    "owner2": "MOYA, ANA MARINO",
    "current_taxes": 8775.68,
    "new_taxes_no_override": 9154.79,
    "override_total_1": 9414.55,
    "override_increase_1": 259.76
  },
  {
    "#": "40 Stanton Rd, Unit 1 (199-13-24)",
    "$": 862500,
    "address": "40 Stanton Rd, Unit 1",
    "parcel_id": "199-13-24",
    "owner1": "CARTON TRS, BONNIE SUE & JAMES JOSEPH JR",
    "owner2": "",
    "current_taxes": 8832.0,
    "new_taxes_no_override": 9213.54,
    "override_total_1": 9474.97,
    "override_increase_1": 261.43
  },
  {
    "#": "40 Stanton Rd, Unit 2 (199-13-25)",
    "$": 774300,
    "address": "40 Stanton Rd, Unit 2",
    "parcel_id": "199-13-25",
    "owner1": "SHULMAN, JANET",
    "owner2": "",
    "current_taxes": 4293.9,
    "new_taxes_no_override": 4479.4,
    "override_total_1": 4606.5,
    "override_increase_1": 127.1
  },
  {
    "#": "40 Stanton Rd, Unit 3 (199-13-26)",
    "$": 889000,
    "address": "40 Stanton Rd, Unit 3",
    "parcel_id": "199-13-26",
    "owner1": "PETERSON, K M",
    "owner2": "",
    "current_taxes": 5468.43,
    "new_taxes_no_override": 5704.67,
    "override_total_1": 5866.53,
    "override_increase_1": 161.87
  },
  {
    "#": "41 Stanton Rd (200-07-00)",
    "$": 2332400,
    "address": "41 Stanton Rd",
    "parcel_id": "200-07-00",
    "owner1": "POLLOCK TR, ELIZABETH S",
    "owner2": "",
    "current_taxes": 20248.84,
    "new_taxes_no_override": 21123.59,
    "override_total_1": 21722.96,
    "override_increase_1": 599.37
  },
  {
    "#": "42 Stanton Rd, Unit 1 (199-13-27)",
    "$": 943800,
    "address": "42 Stanton Rd, Unit 1",
    "parcel_id": "199-13-27",
    "owner1": "GLASS, MICHAEL & CAITLIN",
    "owner2": "",
    "current_taxes": 6029.58,
    "new_taxes_no_override": 6290.06,
    "override_total_1": 6468.53,
    "override_increase_1": 178.48
  },
  {
    "#": "42 Stanton Rd, Unit 2 (199-13-28)",
    "$": 880200,
    "address": "42 Stanton Rd, Unit 2",
    "parcel_id": "199-13-28",
    "owner1": "NIXON, VICTORIA",
    "owner2": "",
    "current_taxes": 5378.31,
    "new_taxes_no_override": 5610.65,
    "override_total_1": 5769.85,
    "override_increase_1": 159.2
  },
  {
    "#": "42 Stanton Rd, Unit 3 (199-13-29)",
    "$": 812200,
    "address": "42 Stanton Rd, Unit 3",
    "parcel_id": "199-13-29",
    "owner1": "SEIGER, KENNETH",
    "owner2": "",
    "current_taxes": 4681.99,
    "new_taxes_no_override": 4884.25,
    "override_total_1": 5022.84,
    "override_increase_1": 138.59
  },
  {
    "#": "44 Stanton Rd, Unit 1 (199-12-01)",
    "$": 1057300,
    "address": "44 Stanton Rd, Unit 1",
    "parcel_id": "199-12-01",
    "owner1": "OSBORN, MATTHEW",
    "owner2": "SWAIM, CAITLIN",
    "current_taxes": 7191.82,
    "new_taxes_no_override": 7502.51,
    "override_total_1": 7715.38,
    "override_increase_1": 212.88
  },
  {
    "#": "44 Stanton Rd, Unit 2 (199-12-02)",
    "$": 1541700,
    "address": "44 Stanton Rd, Unit 2",
    "parcel_id": "199-12-02",
    "owner1": "VISWANATHAN, ANAND",
    "owner2": "DUTTA, ELLEN J",
    "current_taxes": 12152.07,
    "new_taxes_no_override": 12677.04,
    "override_total_1": 13036.74,
    "override_increase_1": 359.7
  },
  {
    "#": "46 Stanton Rd (199-11-01)",
    "$": 1960200,
    "address": "46 Stanton Rd",
    "parcel_id": "199-11-01",
    "owner1": "HERSHMAN TR, MARCIE F",
    "owner2": "",
    "current_taxes": 16437.51,
    "new_taxes_no_override": 17147.61,
    "override_total_1": 17634.16,
    "override_increase_1": 486.55
  },
  {
    "#": "50 Stanton Rd, Unit 1 (199-11-02)",
    "$": 1149800,
    "address": "50 Stanton Rd, Unit 1",
    "parcel_id": "199-11-02",
    "owner1": "SALZMAN, RACHEL",
    "owner2": "",
    "current_taxes": 8139.02,
    "new_taxes_no_override": 8490.63,
    "override_total_1": 8731.54,
    "override_increase_1": 240.91
  },
  {
    "#": "50 Stanton Rd, Unit 2 (199-11-03)",
    "$": 1537300,
    "address": "50 Stanton Rd, Unit 2",
    "parcel_id": "199-11-03",
    "owner1": "DICKERMAN, SAMUEL & KHA",
    "owner2": "",
    "current_taxes": 12107.02,
    "new_taxes_no_override": 12630.04,
    "override_total_1": 12988.41,
    "override_increase_1": 358.37
  },
  {
    "#": "59 Stanton Rd (206-02-00)",
    "$": 2194300,
    "address": "59 Stanton Rd",
    "parcel_id": "206-02-00",
    "owner1": "SCOTT, JONATHAN MARK",
    "owner2": "WARDWELL-SCOTT, LESLIE HANSEN",
    "current_taxes": 18834.7,
    "new_taxes_no_override": 19648.36,
    "override_total_1": 20205.87,
    "override_increase_1": 557.51
  },
  {
    "#": "65 Stanton Rd (206-03-00)",
    "$": 2562100,
    "address": "65 Stanton Rd",
    "parcel_id": "206-03-00",
    "owner1": "MARGOLIS, JOSHUA D",
    "owner2": "SCHUTZMAN, SARA A",
    "current_taxes": 22600.97,
    "new_taxes_no_override": 23577.33,
    "override_total_1": 24246.32,
    "override_increase_1": 668.99
  },
  {
    "#": "66 Stanton Rd (201-18-00)",
    "$": 2354700,
    "address": "66 Stanton Rd",
    "parcel_id": "201-18-00",
    "owner1": "RABINOVITZ TRS, DANIEL S",
    "owner2": "CHAN TR, EFFIE J",
    "current_taxes": 20477.19,
    "new_taxes_no_override": 21361.8,
    "override_total_1": 21967.93,
    "override_increase_1": 606.12
  },
  {
    "#": "69 Stanton Rd (206-04-00)",
    "$": 2373700,
    "address": "69 Stanton Rd",
    "parcel_id": "206-04-00",
    "owner1": "TRODERMAN, JOSHUA E & DEBRA K",
    "owner2": "",
    "current_taxes": 20671.75,
    "new_taxes_no_override": 21564.77,
    "override_total_1": 22176.65,
    "override_increase_1": 611.88
  },
  {
    "#": "70 Stanton Rd (201-17-00)",
    "$": 2465800,
    "address": "70 Stanton Rd",
    "parcel_id": "201-17-00",
    "owner1": "SEGE TRS, ROBERT D",
    "owner2": "VICTOR, KAREN E",
    "current_taxes": 21614.86,
    "new_taxes_no_override": 22548.62,
    "override_total_1": 23188.42,
    "override_increase_1": 639.8
  },
  {
    "#": "75 Stanton Rd (206-05-00)",
    "$": 2727600,
    "address": "75 Stanton Rd",
    "parcel_id": "206-05-00",
    "owner1": "BARNES, JONATHAN A & JENNIFER H",
    "owner2": "",
    "current_taxes": 24295.69,
    "new_taxes_no_override": 25345.26,
    "override_total_1": 26064.42,
    "override_increase_1": 719.15
  },
  {
    "#": "78 Stanton Rd (202-01-00)",
    "$": 2426700,
    "address": "78 Stanton Rd",
    "parcel_id": "202-01-00",
    "owner1": "MOOLMAN, DANIEL C",
    "owner2": "VARGAS, SARA O",
    "current_taxes": 21214.47,
    "new_taxes_no_override": 22130.94,
    "override_total_1": 22758.88,
    "override_increase_1": 627.95
  },
  {
    "#": "81 Stanton Rd (206-06-00)",
    "$": 2081500,
    "address": "81 Stanton Rd",
    "parcel_id": "206-06-00",
    "owner1": "KANTROWITZ TR, WILLIAM",
    "owner2": "",
    "current_taxes": 17679.63,
    "new_taxes_no_override": 18443.39,
    "override_total_1": 18966.71,
    "override_increase_1": 523.32
  },
  {
    "#": "85 Stanton Rd (206-07-00)",
    "$": 2486400,
    "address": "85 Stanton Rd",
    "parcel_id": "206-07-00",
    "owner1": "ARGOS, MARIA",
    "owner2": "MADER, NICHOLAS S",
    "current_taxes": 25460.74,
    "new_taxes_no_override": 26560.64,
    "override_total_1": 27314.28,
    "override_increase_1": 753.64
  },
  {
    "#": "90 Stanton Rd (202-20-00)",
    "$": 2371700,
    "address": "90 Stanton Rd",
    "parcel_id": "202-20-00",
    "owner1": "DOERNBERG, JOHN A",
    "owner2": "EHRLICH, CAROL M",
    "current_taxes": 20651.27,
    "new_taxes_no_override": 21543.4,
    "override_total_1": 22154.68,
    "override_increase_1": 611.28
  },
  {
    "#": "4 Station St (139-45-00)",
    "$": 1587500,
    "address": "4 Station St",
    "parcel_id": "139-45-00",
    "owner1": "STROSCIO REALTY LLC",
    "owner2": "",
    "current_taxes": 27241.5,
    "new_taxes_no_override": 28418.33,
    "override_total_1": 29224.68,
    "override_increase_1": 806.35
  },
  {
    "#": "5 Station St (140-07-00)",
    "$": 10234800,
    "address": "5 Station St",
    "parcel_id": "140-07-00",
    "owner1": "ESS-SDG BROOKLINE SELF STORAGE LLC",
    "owner2": "C/O EXTRA SPACE PROPERTIES 179 LLC",
    "current_taxes": 175629.17,
    "new_taxes_no_override": 183216.35,
    "override_total_1": 188414.97,
    "override_increase_1": 5198.62
  },
  {
    "#": "9 Station St (140-06-00)",
    "$": 15844200,
    "address": "9 Station St",
    "parcel_id": "140-06-00",
    "owner1": "RPI STATION STREET LLC",
    "owner2": "",
    "current_taxes": 271886.47,
    "new_taxes_no_override": 283631.97,
    "override_total_1": 291679.81,
    "override_increase_1": 8047.84
  },
  {
    "#": "30 Station St, Unit C-30 (140-04-17)",
    "$": 872900,
    "address": "30 Station St, Unit C-30",
    "parcel_id": "140-04-17",
    "owner1": "DENNIS WEST LLC",
    "owner2": "",
    "current_taxes": 14978.96,
    "new_taxes_no_override": 15626.05,
    "override_total_1": 16069.43,
    "override_increase_1": 443.38
  },
  {
    "#": "31 Station St, Unit R31-1 (140-04-01)",
    "$": 889800,
    "address": "31 Station St, Unit R31-1",
    "parcel_id": "140-04-01",
    "owner1": "CHURCHILL, TR, WILLIAM",
    "owner2": "",
    "current_taxes": 9111.55,
    "new_taxes_no_override": 9505.17,
    "override_total_1": 9774.87,
    "override_increase_1": 269.7
  },
  {
    "#": "31 Station St, Unit R31-2 (140-04-02)",
    "$": 850100,
    "address": "31 Station St, Unit R31-2",
    "parcel_id": "140-04-02",
    "owner1": "ELITSUR, NOEET",
    "owner2": "",
    "current_taxes": 8705.02,
    "new_taxes_no_override": 9081.08,
    "override_total_1": 9338.75,
    "override_increase_1": 257.67
  },
  {
    "#": "31 Station St, Unit R31-3 (140-04-03)",
    "$": 858700,
    "address": "31 Station St, Unit R31-3",
    "parcel_id": "140-04-03",
    "owner1": "FENNEL, JOYCE A",
    "owner2": "",
    "current_taxes": 8793.09,
    "new_taxes_no_override": 9172.95,
    "override_total_1": 9433.23,
    "override_increase_1": 260.28
  },
  {
    "#": "31 Station St, Unit R31-4 (140-04-04)",
    "$": 846500,
    "address": "31 Station St, Unit R31-4",
    "parcel_id": "140-04-04",
    "owner1": "WRIGHT, MARIA D",
    "owner2": "",
    "current_taxes": 5033.23,
    "new_taxes_no_override": 5250.67,
    "override_total_1": 5399.65,
    "override_increase_1": 148.98
  },
  {
    "#": "31 Station St, Unit R31-5 (140-04-05)",
    "$": 905200,
    "address": "31 Station St, Unit R31-5",
    "parcel_id": "140-04-05",
    "owner1": "LINDER, ELIZABETH P",
    "owner2": "",
    "current_taxes": 5634.31,
    "new_taxes_no_override": 5877.71,
    "override_total_1": 6044.49,
    "override_increase_1": 166.78
  },
  {
    "#": "31 Station St, Unit R31-6 (140-04-06)",
    "$": 868200,
    "address": "31 Station St, Unit R31-6",
    "parcel_id": "140-04-06",
    "owner1": "LEDER-LUIS, JETSON",
    "owner2": "HOWARD, CAROLINE M",
    "current_taxes": 5255.43,
    "new_taxes_no_override": 5482.46,
    "override_total_1": 5638.03,
    "override_increase_1": 155.56
  },
  {
    "#": "32 Station St, Unit C-32 (140-04-07)",
    "$": 817000,
    "address": "32 Station St, Unit C-32",
    "parcel_id": "140-04-07",
    "owner1": "CHURCHILL, TR, WILLIAM",
    "owner2": "",
    "current_taxes": 14019.72,
    "new_taxes_no_override": 14625.37,
    "override_total_1": 15040.36,
    "override_increase_1": 414.98
  },
  {
    "#": "33 Station St, Unit C-33 (140-04-08)",
    "$": 803200,
    "address": "33 Station St, Unit C-33",
    "parcel_id": "140-04-08",
    "owner1": "CHURCHILL, TR, WILLIAM",
    "owner2": "",
    "current_taxes": 13782.91,
    "new_taxes_no_override": 14378.33,
    "override_total_1": 14786.31,
    "override_increase_1": 407.97
  },
  {
    "#": "34 Station St, Unit C-34 (140-04-09)",
    "$": 195800,
    "address": "34 Station St, Unit C-34",
    "parcel_id": "140-04-09",
    "owner1": "MINIAS, AMGAD",
    "owner2": "",
    "current_taxes": 3359.93,
    "new_taxes_no_override": 3505.08,
    "override_total_1": 3604.53,
    "override_increase_1": 99.45
  },
  {
    "#": "34 Station St, Unit R-34 (140-04-10)",
    "$": 614400,
    "address": "34 Station St, Unit R-34",
    "parcel_id": "140-04-10",
    "owner1": "MINIAS, AMGAD",
    "owner2": "",
    "current_taxes": 10543.1,
    "new_taxes_no_override": 10998.56,
    "override_total_1": 11310.64,
    "override_increase_1": 312.08
  },
  {
    "#": "34 Station St, Unit R34-1 (140-04-11)",
    "$": 843800,
    "address": "34 Station St, Unit R34-1",
    "parcel_id": "140-04-11",
    "owner1": "SPEICHER, MICHAEL  & EMILY",
    "owner2": "",
    "current_taxes": 8640.51,
    "new_taxes_no_override": 9013.78,
    "override_total_1": 9269.54,
    "override_increase_1": 255.76
  },
  {
    "#": "34 Station St, Unit R34-2 (140-04-12)",
    "$": 746400,
    "address": "34 Station St, Unit R34-2",
    "parcel_id": "140-04-12",
    "owner1": "WINTER, FRANCES J",
    "owner2": "",
    "current_taxes": 7643.14,
    "new_taxes_no_override": 7973.32,
    "override_total_1": 8199.56,
    "override_increase_1": 226.24
  },
  {
    "#": "34 Station St, Unit R34-3 (140-04-13)",
    "$": 885700,
    "address": "34 Station St, Unit R34-3",
    "parcel_id": "140-04-13",
    "owner1": "STILES, JOSHUA",
    "owner2": "HEIDEN, CLARA",
    "current_taxes": 5434.63,
    "new_taxes_no_override": 5669.41,
    "override_total_1": 5830.27,
    "override_increase_1": 160.87
  },
  {
    "#": "34 Station St, Unit R34-4 (140-04-14)",
    "$": 746400,
    "address": "34 Station St, Unit R34-4",
    "parcel_id": "140-04-14",
    "owner1": "WEBSTER, MARIA & ANNA G",
    "owner2": "",
    "current_taxes": 7643.14,
    "new_taxes_no_override": 7973.32,
    "override_total_1": 8199.56,
    "override_increase_1": 226.24
  },
  {
    "#": "34 Station St, Unit R34-5 (140-04-15)",
    "$": 839200,
    "address": "34 Station St, Unit R34-5",
    "parcel_id": "140-04-15",
    "owner1": "PAYNE, THOMAS",
    "owner2": "GRAUBARD, AMY",
    "current_taxes": 8593.41,
    "new_taxes_no_override": 8964.65,
    "override_total_1": 9219.01,
    "override_increase_1": 254.36
  },
  {
    "#": "34 Station St, Unit R34-6 (140-04-16)",
    "$": 746400,
    "address": "34 Station St, Unit R34-6",
    "parcel_id": "140-04-16",
    "owner1": "PAYNE, THOMAS M",
    "owner2": "GRAUBARD, AMY",
    "current_taxes": 4008.2,
    "new_taxes_no_override": 4181.35,
    "override_total_1": 4300.0,
    "override_increase_1": 118.64
  },
  {
    "#": "39 Station St (140-03-01)",
    "$": 1484900,
    "address": "39 Station St",
    "parcel_id": "140-03-01",
    "owner1": "MONTERO, SEBASTIANA",
    "owner2": "AVANT, LYA",
    "current_taxes": 11570.44,
    "new_taxes_no_override": 12070.28,
    "override_total_1": 12412.77,
    "override_increase_1": 342.49
  },
  {
    "#": "42 Station St, Unit 1 (140-03-02)",
    "$": 744500,
    "address": "42 Station St, Unit 1",
    "parcel_id": "140-03-02",
    "owner1": "MONTERO, SEBASTIANA",
    "owner2": "",
    "current_taxes": 3988.75,
    "new_taxes_no_override": 4161.06,
    "override_total_1": 4279.13,
    "override_increase_1": 118.07
  },
  {
    "#": "42 Station St, Unit 2 (140-03-03)",
    "$": 732300,
    "address": "42 Station St, Unit 2",
    "parcel_id": "140-03-03",
    "owner1": "MONTERO, FLAVIO",
    "owner2": "",
    "current_taxes": 7498.75,
    "new_taxes_no_override": 7822.7,
    "override_total_1": 8044.66,
    "override_increase_1": 221.96
  },
  {
    "#": "46 Station St (140-02-19)",
    "$": 4482000,
    "address": "46 Station St",
    "parcel_id": "140-02-19",
    "owner1": "MHYNTS REAL ESTATE VENTURES 1 LLC",
    "owner2": "",
    "current_taxes": 45895.68,
    "new_taxes_no_override": 47878.37,
    "override_total_1": 49236.89,
    "override_increase_1": 1358.51
  },
  {
    "#": "55 Station St, Unit 1A & G8-11 (140-01-01)",
    "$": 1308300,
    "address": "55 Station St, Unit 1A & G8-11",
    "parcel_id": "140-01-01",
    "owner1": "FLYNN, RYAN ALEXANDER",
    "owner2": "",
    "current_taxes": 9762.06,
    "new_taxes_no_override": 10183.78,
    "override_total_1": 10472.74,
    "override_increase_1": 288.96
  },
  {
    "#": "55 Station St, Unit 1B & G5-6 (140-01-02)",
    "$": 1279000,
    "address": "55 Station St, Unit 1B & G5-6",
    "parcel_id": "140-01-02",
    "owner1": "55 STATION STREET LLC",
    "owner2": "",
    "current_taxes": 13096.96,
    "new_taxes_no_override": 13662.75,
    "override_total_1": 14050.42,
    "override_increase_1": 387.67
  },
  {
    "#": "55 Station St, Unit 2A & G1-2 (140-01-03)",
    "$": 1797900,
    "address": "55 Station St, Unit 2A & G1-2",
    "parcel_id": "140-01-03",
    "owner1": "BARDFIELD TR, DAVID A",
    "owner2": "C/O M BARDFIELD",
    "current_taxes": 18410.5,
    "new_taxes_no_override": 19205.83,
    "override_total_1": 19750.78,
    "override_increase_1": 544.95
  },
  {
    "#": "55 Station St, Unit 2B & G9-12 (140-01-04)",
    "$": 1805400,
    "address": "55 Station St, Unit 2B & G9-12",
    "parcel_id": "140-01-04",
    "owner1": "WEINSTEIN TRS, KENNETH A & ELLEN LEE",
    "owner2": "",
    "current_taxes": 14852.36,
    "new_taxes_no_override": 15493.98,
    "override_total_1": 15933.61,
    "override_increase_1": 439.63
  },
  {
    "#": "55 Station St, Unit 3A & G3-4 (140-01-05)",
    "$": 1327700,
    "address": "55 Station St, Unit 3A & G3-4",
    "parcel_id": "140-01-05",
    "owner1": "NAHATIS, HARRY M",
    "owner2": "",
    "current_taxes": 9960.71,
    "new_taxes_no_override": 10391.01,
    "override_total_1": 10685.85,
    "override_increase_1": 294.84
  },
  {
    "#": "55 Station St, Unit 3B & G7-10 (140-01-06)",
    "$": 1307800,
    "address": "55 Station St, Unit 3B & G7-10",
    "parcel_id": "140-01-06",
    "owner1": "BARDFIELD TRS, CLAIRE M",
    "owner2": "",
    "current_taxes": 13391.87,
    "new_taxes_no_override": 13970.4,
    "override_total_1": 14366.8,
    "override_increase_1": 396.4
  },
  {
    "#": "11 Stearns Rd (156-14-00)",
    "$": 5375700,
    "address": "11 Stearns Rd",
    "parcel_id": "156-14-00",
    "owner1": "11 STEARNS ROAD LLC",
    "owner2": "",
    "current_taxes": 55047.17,
    "new_taxes_no_override": 57425.21,
    "override_total_1": 59054.6,
    "override_increase_1": 1629.4
  },
  {
    "#": "12 Stearns Rd (158-09-00)",
    "$": 4638900,
    "address": "12 Stearns Rd",
    "parcel_id": "158-09-00",
    "owner1": "MARJORAM LLC",
    "owner2": "C/O MCCARTHY LEGAL SERVICES",
    "current_taxes": 47502.34,
    "new_taxes_no_override": 49554.44,
    "override_total_1": 50960.51,
    "override_increase_1": 1406.07
  },
  {
    "#": "15 Stearns Rd (156-15-00)",
    "$": 5260500,
    "address": "15 Stearns Rd",
    "parcel_id": "156-15-00",
    "owner1": "15 STEARNS ROAD  LLC",
    "owner2": "",
    "current_taxes": 53867.52,
    "new_taxes_no_override": 56194.6,
    "override_total_1": 57789.08,
    "override_increase_1": 1594.48
  },
  {
    "#": "17 Stearns Rd, Unit 1 (156-16-07)",
    "$": 595200,
    "address": "17 Stearns Rd, Unit 1",
    "parcel_id": "156-16-07",
    "owner1": "MOLTA, LAURA J",
    "owner2": "",
    "current_taxes": 6094.85,
    "new_taxes_no_override": 6358.15,
    "override_total_1": 6538.56,
    "override_increase_1": 180.41
  },
  {
    "#": "17 Stearns Rd, Unit 2 (156-16-01)",
    "$": 629300,
    "address": "17 Stearns Rd, Unit 2",
    "parcel_id": "156-16-01",
    "owner1": "YU, QIANG",
    "owner2": "LI, XIAN CHANG",
    "current_taxes": 6444.03,
    "new_taxes_no_override": 6722.41,
    "override_total_1": 6913.16,
    "override_increase_1": 190.74
  },
  {
    "#": "17 Stearns Rd, Unit 3 (156-16-02)",
    "$": 936600,
    "address": "17 Stearns Rd, Unit 3",
    "parcel_id": "156-16-02",
    "owner1": "BENNETT, ERIN  E",
    "owner2": "",
    "current_taxes": 5955.85,
    "new_taxes_no_override": 6213.14,
    "override_total_1": 6389.44,
    "override_increase_1": 176.29
  },
  {
    "#": "17 Stearns Rd, Unit 4 & G4 (156-16-03)",
    "$": 898800,
    "address": "17 Stearns Rd, Unit 4 & G4",
    "parcel_id": "156-16-03",
    "owner1": "YANG TR, JULIA",
    "owner2": "",
    "current_taxes": 9203.71,
    "new_taxes_no_override": 9601.31,
    "override_total_1": 9873.74,
    "override_increase_1": 272.43
  },
  {
    "#": "17 Stearns Rd, Unit 5 (156-16-04)",
    "$": 960600,
    "address": "17 Stearns Rd, Unit 5",
    "parcel_id": "156-16-04",
    "owner1": "DELCAMINO, DONATO",
    "owner2": "YANG, FU-CHIA",
    "current_taxes": 6201.61,
    "new_taxes_no_override": 6469.52,
    "override_total_1": 6653.09,
    "override_increase_1": 183.57
  },
  {
    "#": "17 Stearns Rd, Unit 6 & G3 (156-16-05)",
    "$": 898700,
    "address": "17 Stearns Rd, Unit 6 & G3",
    "parcel_id": "156-16-05",
    "owner1": "ATHANASSIOU, ALEXANDER A JR",
    "owner2": "",
    "current_taxes": 9202.69,
    "new_taxes_no_override": 9600.25,
    "override_total_1": 9872.65,
    "override_increase_1": 272.4
  },
  {
    "#": "17 Stearns Rd, Unit 7 & P2 (156-16-06)",
    "$": 914100,
    "address": "17 Stearns Rd, Unit 7 & P2",
    "parcel_id": "156-16-06",
    "owner1": "HUANG, ZHAOYUN",
    "owner2": "SHI, QINGMIN",
    "current_taxes": 5725.45,
    "new_taxes_no_override": 5972.79,
    "override_total_1": 6142.26,
    "override_increase_1": 169.47
  },
  {
    "#": "20 Stearns Rd, Unit 1 & P39 (158-07-35)",
    "$": 753500,
    "address": "20 Stearns Rd, Unit 1 & P39",
    "parcel_id": "158-07-35",
    "owner1": "MIKHEYEV, ALEKSANDER",
    "owner2": "GLEYZER, GERTRUDA",
    "current_taxes": 4080.91,
    "new_taxes_no_override": 4257.21,
    "override_total_1": 4378.0,
    "override_increase_1": 120.79
  },
  {
    "#": "20 Stearns Rd, Unit 2 (158-07-01)",
    "$": 463600,
    "address": "20 Stearns Rd, Unit 2",
    "parcel_id": "158-07-01",
    "owner1": "WANG, HONGWU",
    "owner2": "YANG, XIN",
    "current_taxes": 1112.33,
    "new_taxes_no_override": 1160.38,
    "override_total_1": 1193.31,
    "override_increase_1": 32.92
  },
  {
    "#": "20 Stearns Rd, Unit 20 & P23 (158-07-05)",
    "$": 786100,
    "address": "20 Stearns Rd, Unit 20 & P23",
    "parcel_id": "158-07-05",
    "owner1": "ROSENGARD, BEVERLY TR & DONNA",
    "owner2": "C/O ROBERT ROSENGARD",
    "current_taxes": 4414.73,
    "new_taxes_no_override": 4605.45,
    "override_total_1": 4736.12,
    "override_increase_1": 130.68
  },
  {
    "#": "20 Stearns Rd, Unit 21 & P35 (158-07-06)",
    "$": 781200,
    "address": "20 Stearns Rd, Unit 21 & P35",
    "parcel_id": "158-07-06",
    "owner1": "PAN, HUASHAN",
    "owner2": "SU, YONGHONG",
    "current_taxes": 7999.49,
    "new_taxes_no_override": 8345.07,
    "override_total_1": 8581.85,
    "override_increase_1": 236.78
  },
  {
    "#": "20 Stearns Rd, Unit 22 P10-P37 (158-07-07)",
    "$": 598300,
    "address": "20 Stearns Rd, Unit 22 P10-P37",
    "parcel_id": "158-07-07",
    "owner1": "MCHUGH TR, GEORGE",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 6126.59,
    "new_taxes_no_override": 6391.26,
    "override_total_1": 6572.61,
    "override_increase_1": 181.35
  },
  {
    "#": "20 Stearns Rd, Unit 23 & P34 (158-07-08)",
    "$": 519800,
    "address": "20 Stearns Rd, Unit 23 & P34",
    "parcel_id": "158-07-08",
    "owner1": "BLASEK TRS, WILLIAM E",
    "owner2": "DOMOSH, JILL L",
    "current_taxes": 5322.75,
    "new_taxes_no_override": 5552.69,
    "override_total_1": 5710.25,
    "override_increase_1": 157.55
  },
  {
    "#": "20 Stearns Rd, Unit 24 & G13 (158-07-09)",
    "$": 758000,
    "address": "20 Stearns Rd, Unit 24 & G13",
    "parcel_id": "158-07-09",
    "owner1": "LIN, LENNOX",
    "owner2": "",
    "current_taxes": 4126.99,
    "new_taxes_no_override": 4305.28,
    "override_total_1": 4427.43,
    "override_increase_1": 122.16
  },
  {
    "#": "20 Stearns Rd, Unit 25 & G25 (158-07-10)",
    "$": 779700,
    "address": "20 Stearns Rd, Unit 25 & G25",
    "parcel_id": "158-07-10",
    "owner1": "YUE, MIN",
    "owner2": "",
    "current_taxes": 4349.19,
    "new_taxes_no_override": 4537.08,
    "override_total_1": 4665.81,
    "override_increase_1": 128.74
  },
  {
    "#": "20 Stearns Rd, Unit 3 & P4 (158-07-02)",
    "$": 558400,
    "address": "20 Stearns Rd, Unit 3 & P4",
    "parcel_id": "158-07-02",
    "owner1": "XU, CHEN & ALBERT TIGER",
    "owner2": "LI, YAQIAO",
    "current_taxes": 5718.02,
    "new_taxes_no_override": 5965.04,
    "override_total_1": 6134.29,
    "override_increase_1": 169.25
  },
  {
    "#": "20 Stearns Rd, Unit 30 & P14 (158-07-11)",
    "$": 778800,
    "address": "20 Stearns Rd, Unit 30 & P14",
    "parcel_id": "158-07-11",
    "owner1": "CHIU, PATRICIA",
    "owner2": "",
    "current_taxes": 7974.91,
    "new_taxes_no_override": 8319.43,
    "override_total_1": 8555.48,
    "override_increase_1": 236.06
  },
  {
    "#": "20 Stearns Rd, Unit 31&G7 (158-07-12)",
    "$": 801100,
    "address": "20 Stearns Rd, Unit 31&G7",
    "parcel_id": "158-07-12",
    "owner1": "ZHANG, YUZHI",
    "owner2": "",
    "current_taxes": 4568.33,
    "new_taxes_no_override": 4765.68,
    "override_total_1": 4900.9,
    "override_increase_1": 135.22
  },
  {
    "#": "20 Stearns Rd, Unit 32 & P31 (158-07-13)",
    "$": 468700,
    "address": "20 Stearns Rd, Unit 32 & P31",
    "parcel_id": "158-07-13",
    "owner1": "18-20 STEARNS ROAD #32 LLC",
    "owner2": "",
    "current_taxes": 4799.49,
    "new_taxes_no_override": 5006.83,
    "override_total_1": 5148.89,
    "override_increase_1": 142.06
  },
  {
    "#": "20 Stearns Rd, Unit 33 (158-07-14)",
    "$": 552100,
    "address": "20 Stearns Rd, Unit 33",
    "parcel_id": "158-07-14",
    "owner1": "XU, CHEN & AMANDA BARBARA",
    "owner2": "LI, YAQIAO",
    "current_taxes": 2018.57,
    "new_taxes_no_override": 2105.77,
    "override_total_1": 2165.52,
    "override_increase_1": 59.75
  },
  {
    "#": "20 Stearns Rd, Unit 34 & P27 (158-07-15)",
    "$": 775000,
    "address": "20 Stearns Rd, Unit 34 & P27",
    "parcel_id": "158-07-15",
    "owner1": "BOIARSKI, EVGUENI",
    "owner2": "",
    "current_taxes": 7936.0,
    "new_taxes_no_override": 8278.84,
    "override_total_1": 8513.74,
    "override_increase_1": 234.91
  },
  {
    "#": "20 Stearns Rd, Unit 35 & G19 (158-07-16)",
    "$": 818500,
    "address": "20 Stearns Rd, Unit 35 & G19",
    "parcel_id": "158-07-16",
    "owner1": "VOLFSON, DORA",
    "owner2": "",
    "current_taxes": 4746.51,
    "new_taxes_no_override": 4951.56,
    "override_total_1": 5092.06,
    "override_increase_1": 140.5
  },
  {
    "#": "20 Stearns Rd, Unit 4 (158-07-03)",
    "$": 798600,
    "address": "20 Stearns Rd, Unit 4",
    "parcel_id": "158-07-03",
    "owner1": "HALPERN, RONALD & SUSAN",
    "owner2": "",
    "current_taxes": 8177.66,
    "new_taxes_no_override": 8530.93,
    "override_total_1": 8772.99,
    "override_increase_1": 242.06
  },
  {
    "#": "20 Stearns Rd, Unit 40 (158-07-17)",
    "$": 818000,
    "address": "20 Stearns Rd, Unit 40",
    "parcel_id": "158-07-17",
    "owner1": "WU, HUANG FEN-FEN",
    "owner2": "C/O WU, ANLI",
    "current_taxes": 8376.32,
    "new_taxes_no_override": 8738.18,
    "override_total_1": 8986.12,
    "override_increase_1": 247.94
  },
  {
    "#": "20 Stearns Rd, Unit 41 & G21 (158-07-18)",
    "$": 819400,
    "address": "20 Stearns Rd, Unit 41 & G21",
    "parcel_id": "158-07-18",
    "owner1": "PALAKURTHI TRS, SANGEETHA",
    "owner2": "THADURI, RAVI",
    "current_taxes": 8390.66,
    "new_taxes_no_override": 8753.14,
    "override_total_1": 9001.5,
    "override_increase_1": 248.36
  },
  {
    "#": "20 Stearns Rd, Unit 42 & P33 (158-07-19)",
    "$": 474500,
    "address": "20 Stearns Rd, Unit 42 & P33",
    "parcel_id": "158-07-19",
    "owner1": "LEVIN, MICHAEL S",
    "owner2": "",
    "current_taxes": 4858.88,
    "new_taxes_no_override": 5068.78,
    "override_total_1": 5212.61,
    "override_increase_1": 143.82
  },
  {
    "#": "20 Stearns Rd, Unit 43 & P24 (158-07-20)",
    "$": 555900,
    "address": "20 Stearns Rd, Unit 43 & P24",
    "parcel_id": "158-07-20",
    "owner1": "CHAO, MICHAEL J",
    "owner2": "",
    "current_taxes": 5692.42,
    "new_taxes_no_override": 5938.33,
    "override_total_1": 6106.83,
    "override_increase_1": 168.5
  },
  {
    "#": "20 Stearns Rd, Unit 44 (158-07-21)",
    "$": 813700,
    "address": "20 Stearns Rd, Unit 44",
    "parcel_id": "158-07-21",
    "owner1": "VERBUK TRS, VLADIMIR M",
    "owner2": "SHAKHRAY, VERA D",
    "current_taxes": 4697.35,
    "new_taxes_no_override": 4900.28,
    "override_total_1": 5039.32,
    "override_increase_1": 139.04
  },
  {
    "#": "20 Stearns Rd, Unit 45 & P32 (158-07-22)",
    "$": 786500,
    "address": "20 Stearns Rd, Unit 45 & P32",
    "parcel_id": "158-07-22",
    "owner1": "GAO, WILLIAM J",
    "owner2": "",
    "current_taxes": 4418.83,
    "new_taxes_no_override": 4609.72,
    "override_total_1": 4740.52,
    "override_increase_1": 130.8
  },
  {
    "#": "20 Stearns Rd, Unit 5 (158-07-04)",
    "$": 786100,
    "address": "20 Stearns Rd, Unit 5",
    "parcel_id": "158-07-04",
    "owner1": "OKUN, LINDA ELLEN & HENRY",
    "owner2": "",
    "current_taxes": 4414.73,
    "new_taxes_no_override": 4605.45,
    "override_total_1": 4736.12,
    "override_increase_1": 130.68
  },
  {
    "#": "20 Stearns Rd, Unit 50 & G17 (158-07-23)",
    "$": 799700,
    "address": "20 Stearns Rd, Unit 50 & G17",
    "parcel_id": "158-07-23",
    "owner1": "KHAZANOV, IGOR",
    "owner2": "",
    "current_taxes": 8188.93,
    "new_taxes_no_override": 8542.69,
    "override_total_1": 8785.08,
    "override_increase_1": 242.39
  },
  {
    "#": "20 Stearns Rd, Unit 51 & G3 (158-07-24)",
    "$": 783100,
    "address": "20 Stearns Rd, Unit 51 & G3",
    "parcel_id": "158-07-24",
    "owner1": "ALPERIN, MARK & ELEONORA",
    "owner2": "",
    "current_taxes": 4384.01,
    "new_taxes_no_override": 4573.4,
    "override_total_1": 4703.17,
    "override_increase_1": 129.77
  },
  {
    "#": "20 Stearns Rd, Unit 52 & P38 (158-07-25)",
    "$": 478500,
    "address": "20 Stearns Rd, Unit 52 & P38",
    "parcel_id": "158-07-25",
    "owner1": "MOCHIZUKI, HIROSHI",
    "owner2": "C/O TANAKA KATSUNORI - ABLE R E USA INC",
    "current_taxes": 4899.84,
    "new_taxes_no_override": 5111.51,
    "override_total_1": 5256.55,
    "override_increase_1": 145.04
  },
  {
    "#": "20 Stearns Rd, Unit 53 & P29 (158-07-26)",
    "$": 536400,
    "address": "20 Stearns Rd, Unit 53 & P29",
    "parcel_id": "158-07-26",
    "owner1": "KAZAKIN TRS, JULIA & VLADIMIR V",
    "owner2": "",
    "current_taxes": 5492.74,
    "new_taxes_no_override": 5730.03,
    "override_total_1": 5892.61,
    "override_increase_1": 162.59
  },
  {
    "#": "20 Stearns Rd, Unit 54 (158-07-27)",
    "$": 776000,
    "address": "20 Stearns Rd, Unit 54",
    "parcel_id": "158-07-27",
    "owner1": "GREEN, RICHARD A",
    "owner2": "",
    "current_taxes": 7946.24,
    "new_taxes_no_override": 8289.52,
    "override_total_1": 8524.73,
    "override_increase_1": 235.21
  },
  {
    "#": "20 Stearns Rd, Unit 55 & G2 (158-07-28)",
    "$": 786900,
    "address": "20 Stearns Rd, Unit 55 & G2",
    "parcel_id": "158-07-28",
    "owner1": "LU, XIAOMING",
    "owner2": "ZHANG, XIPING",
    "current_taxes": 8057.86,
    "new_taxes_no_override": 8405.96,
    "override_total_1": 8644.47,
    "override_increase_1": 238.51
  },
  {
    "#": "20 Stearns Rd, Unit 60 (158-07-29)",
    "$": 815600,
    "address": "20 Stearns Rd, Unit 60",
    "parcel_id": "158-07-29",
    "owner1": "BIR, YULIYA",
    "owner2": "VYDRIN, MIKHAIL",
    "current_taxes": 4716.81,
    "new_taxes_no_override": 4920.58,
    "override_total_1": 5060.19,
    "override_increase_1": 139.62
  },
  {
    "#": "20 Stearns Rd, Unit 61 & G26 (158-07-30)",
    "$": 815600,
    "address": "20 Stearns Rd, Unit 61 & G26",
    "parcel_id": "158-07-30",
    "owner1": "HIGGINS, JOSLIN T",
    "owner2": "",
    "current_taxes": 4716.81,
    "new_taxes_no_override": 4920.58,
    "override_total_1": 5060.19,
    "override_increase_1": 139.62
  },
  {
    "#": "20 Stearns Rd, Unit 62 & P16 (158-07-31)",
    "$": 561600,
    "address": "20 Stearns Rd, Unit 62 & P16",
    "parcel_id": "158-07-31",
    "owner1": "LEE, ALISA E",
    "owner2": "",
    "current_taxes": 2115.85,
    "new_taxes_no_override": 2207.25,
    "override_total_1": 2269.88,
    "override_increase_1": 62.63
  },
  {
    "#": "20 Stearns Rd, Unit 63 & P30 (158-07-32)",
    "$": 530700,
    "address": "20 Stearns Rd, Unit 63 & P30",
    "parcel_id": "158-07-32",
    "owner1": "TYAGI, GIRISH & BHAVNA",
    "owner2": "",
    "current_taxes": 5434.37,
    "new_taxes_no_override": 5669.13,
    "override_total_1": 5829.99,
    "override_increase_1": 160.86
  },
  {
    "#": "20 Stearns Rd, Unit 64 & G11 (158-07-33)",
    "$": 776500,
    "address": "20 Stearns Rd, Unit 64 & G11",
    "parcel_id": "158-07-33",
    "owner1": "SONG, YANLING",
    "owner2": "",
    "current_taxes": 7951.36,
    "new_taxes_no_override": 8294.86,
    "override_total_1": 8530.22,
    "override_increase_1": 235.36
  },
  {
    "#": "20 Stearns Rd, Unit 65 (158-07-34)",
    "$": 818500,
    "address": "20 Stearns Rd, Unit 65",
    "parcel_id": "158-07-34",
    "owner1": "DING, LI",
    "owner2": "",
    "current_taxes": 8381.44,
    "new_taxes_no_override": 8743.52,
    "override_total_1": 8991.61,
    "override_increase_1": 248.09
  },
  {
    "#": "20 Stearns Rd, Unit P36 (158-07-37)",
    "$": 49000,
    "address": "20 Stearns Rd, Unit P36",
    "parcel_id": "158-07-37",
    "owner1": "ALPERIN, MARK & ELEONORA",
    "owner2": "",
    "current_taxes": 501.76,
    "new_taxes_no_override": 523.44,
    "override_total_1": 538.29,
    "override_increase_1": 14.85
  },
  {
    "#": "20 Stearns Rd, Unit P8 & 9 (158-07-36)",
    "$": 98000,
    "address": "20 Stearns Rd, Unit P8 & 9",
    "parcel_id": "158-07-36",
    "owner1": "MIKHEYEV, ALEKSANDER",
    "owner2": "GLEYZER, GERTRUDA",
    "current_taxes": 1003.52,
    "new_taxes_no_override": 1046.87,
    "override_total_1": 1076.58,
    "override_increase_1": 29.7
  },
  {
    "#": "25 Stearns Rd, Unit 1 & G2 (156-17-04)",
    "$": 1398000,
    "address": "25 Stearns Rd, Unit 1 & G2",
    "parcel_id": "156-17-04",
    "owner1": "EHRENBERG, STEVEN",
    "owner2": "WEINSTEIN, LAURA S",
    "current_taxes": 10680.59,
    "new_taxes_no_override": 11141.99,
    "override_total_1": 11458.14,
    "override_increase_1": 316.15
  },
  {
    "#": "25 Stearns Rd, Unit 2 P2 G1 (156-17-01)",
    "$": 1492300,
    "address": "25 Stearns Rd, Unit 2 P2 G1",
    "parcel_id": "156-17-01",
    "owner1": "GHAFOUR, ZIAD",
    "owner2": "LISI, LISA",
    "current_taxes": 11646.22,
    "new_taxes_no_override": 12149.34,
    "override_total_1": 12494.06,
    "override_increase_1": 344.73
  },
  {
    "#": "25 Stearns Rd, Unit 3 & P5 (156-17-02)",
    "$": 840100,
    "address": "25 Stearns Rd, Unit 3 & P5",
    "parcel_id": "156-17-02",
    "owner1": "COHEN, MICHAEL A",
    "owner2": "CHERNILO-COHEN, SUSAN K",
    "current_taxes": 4967.69,
    "new_taxes_no_override": 5182.29,
    "override_total_1": 5329.34,
    "override_increase_1": 147.04
  },
  {
    "#": "25 Stearns Rd, Unit 4 & P1 (156-17-03)",
    "$": 860700,
    "address": "25 Stearns Rd, Unit 4 & P1",
    "parcel_id": "156-17-03",
    "owner1": "CHAVEZ, ANNA M",
    "owner2": "",
    "current_taxes": 8813.57,
    "new_taxes_no_override": 9194.32,
    "override_total_1": 9455.2,
    "override_increase_1": 260.88
  },
  {
    "#": "27 Stearns Rd (156-18-00)",
    "$": 4329100,
    "address": "27 Stearns Rd",
    "parcel_id": "156-18-00",
    "owner1": "NITKIN FAMILY LLC",
    "owner2": "",
    "current_taxes": 44329.98,
    "new_taxes_no_override": 46245.04,
    "override_total_1": 47557.2,
    "override_increase_1": 1312.17
  },
  {
    "#": "30 Stearns Rd, Unit 101 & Pz (158-05-01)",
    "$": 879100,
    "address": "30 Stearns Rd, Unit 101 & Pz",
    "parcel_id": "158-05-01",
    "owner1": "VEKSLER TRS, MARK",
    "owner2": "ZAIKA-VEKSLER, RIMMA",
    "current_taxes": 9001.98,
    "new_taxes_no_override": 9390.87,
    "override_total_1": 9657.32,
    "override_increase_1": 266.46
  },
  {
    "#": "30 Stearns Rd, Unit 102  P-Bb (158-05-02)",
    "$": 1094900,
    "address": "30 Stearns Rd, Unit 102  P-Bb",
    "parcel_id": "158-05-02",
    "owner1": "JIN, XIAOWEI",
    "owner2": "",
    "current_taxes": 7576.84,
    "new_taxes_no_override": 7904.16,
    "override_total_1": 8128.43,
    "override_increase_1": 224.27
  },
  {
    "#": "30 Stearns Rd, Unit 103 & G-X (158-05-03)",
    "$": 723900,
    "address": "30 Stearns Rd, Unit 103 & G-X",
    "parcel_id": "158-05-03",
    "owner1": "ZAIKA-VEKSLER TRS, RIMMA",
    "owner2": "VEKSLER, MARK",
    "current_taxes": 7412.74,
    "new_taxes_no_override": 7732.97,
    "override_total_1": 7952.39,
    "override_increase_1": 219.42
  },
  {
    "#": "30 Stearns Rd, Unit 104 (158-05-04)",
    "$": 1036000,
    "address": "30 Stearns Rd, Unit 104",
    "parcel_id": "158-05-04",
    "owner1": "ZHANG, WEN",
    "owner2": "CHEN, RONG",
    "current_taxes": 6973.71,
    "new_taxes_no_override": 7274.97,
    "override_total_1": 7481.4,
    "override_increase_1": 206.42
  },
  {
    "#": "30 Stearns Rd, Unit 201 (158-05-05)",
    "$": 879300,
    "address": "30 Stearns Rd, Unit 201",
    "parcel_id": "158-05-05",
    "owner1": "YANG, WONJAE",
    "owner2": "CHOI, ASHLEY",
    "current_taxes": 5369.1,
    "new_taxes_no_override": 5601.05,
    "override_total_1": 5759.97,
    "override_increase_1": 158.93
  },
  {
    "#": "30 Stearns Rd, Unit 202 (158-05-06)",
    "$": 1020300,
    "address": "30 Stearns Rd, Unit 202",
    "parcel_id": "158-05-06",
    "owner1": "BROTHERS, MARIKO T",
    "owner2": "",
    "current_taxes": 6812.94,
    "new_taxes_no_override": 7107.26,
    "override_total_1": 7308.92,
    "override_increase_1": 201.66
  },
  {
    "#": "30 Stearns Rd, Unit 203 (158-05-07)",
    "$": 1001300,
    "address": "30 Stearns Rd, Unit 203",
    "parcel_id": "158-05-07",
    "owner1": "MOTIWALA, MEHMOOD Z",
    "owner2": "MEHMOOD, ALMAS & HUMA",
    "current_taxes": 6618.38,
    "new_taxes_no_override": 6904.29,
    "override_total_1": 7100.2,
    "override_increase_1": 195.9
  },
  {
    "#": "30 Stearns Rd, Unit 204 (158-05-08)",
    "$": 1036800,
    "address": "30 Stearns Rd, Unit 204",
    "parcel_id": "158-05-08",
    "owner1": "TABARI, SHAIMA",
    "owner2": "",
    "current_taxes": 6981.9,
    "new_taxes_no_override": 7283.52,
    "override_total_1": 7490.18,
    "override_increase_1": 206.66
  },
  {
    "#": "30 Stearns Rd, Unit 205 (158-05-09)",
    "$": 839200,
    "address": "30 Stearns Rd, Unit 205",
    "parcel_id": "158-05-09",
    "owner1": "BOTELHO, FERNANDA",
    "owner2": "",
    "current_taxes": 8593.41,
    "new_taxes_no_override": 8964.65,
    "override_total_1": 9219.01,
    "override_increase_1": 254.36
  },
  {
    "#": "30 Stearns Rd, Unit 301 (158-05-10)",
    "$": 839200,
    "address": "30 Stearns Rd, Unit 301",
    "parcel_id": "158-05-10",
    "owner1": "DIAMOND, JUDITH E",
    "owner2": "",
    "current_taxes": 4958.47,
    "new_taxes_no_override": 5172.68,
    "override_total_1": 5319.45,
    "override_increase_1": 146.77
  },
  {
    "#": "30 Stearns Rd, Unit 302 (158-05-11)",
    "$": 1055600,
    "address": "30 Stearns Rd, Unit 302",
    "parcel_id": "158-05-11",
    "owner1": "TANG, ZHIRONG",
    "owner2": "",
    "current_taxes": 7174.41,
    "new_taxes_no_override": 7484.34,
    "override_total_1": 7696.71,
    "override_increase_1": 212.36
  },
  {
    "#": "30 Stearns Rd, Unit 303& G-S (158-05-12)",
    "$": 972900,
    "address": "30 Stearns Rd, Unit 303& G-S",
    "parcel_id": "158-05-12",
    "owner1": "SHAKHMUNDES TRS, LEONID",
    "owner2": "SHAKHOVA, GALINA",
    "current_taxes": 6327.56,
    "new_taxes_no_override": 6600.91,
    "override_total_1": 6788.21,
    "override_increase_1": 187.3
  },
  {
    "#": "30 Stearns Rd, Unit 304 (158-05-13)",
    "$": 1055600,
    "address": "30 Stearns Rd, Unit 304",
    "parcel_id": "158-05-13",
    "owner1": "POLIANSKY TRS, ALEXANDER",
    "owner2": "PORTNOY, IRINA",
    "current_taxes": 7174.41,
    "new_taxes_no_override": 7484.34,
    "override_total_1": 7696.71,
    "override_increase_1": 212.36
  },
  {
    "#": "30 Stearns Rd, Unit 305 (158-05-14)",
    "$": 846600,
    "address": "30 Stearns Rd, Unit 305",
    "parcel_id": "158-05-14",
    "owner1": "REZNIKOVA, INNA",
    "owner2": "",
    "current_taxes": 5034.25,
    "new_taxes_no_override": 5251.73,
    "override_total_1": 5400.74,
    "override_increase_1": 149.01
  },
  {
    "#": "30 Stearns Rd, Unit 401 (158-05-15)",
    "$": 819600,
    "address": "30 Stearns Rd, Unit 401",
    "parcel_id": "158-05-15",
    "owner1": "WANG, STANLEY YINGHSIN",
    "owner2": "LEE, ANGELA TSUIPING",
    "current_taxes": 8392.7,
    "new_taxes_no_override": 8755.26,
    "override_total_1": 9003.69,
    "override_increase_1": 248.42
  },
  {
    "#": "30 Stearns Rd, Unit 402 & Prk-J (158-05-16)",
    "$": 1055700,
    "address": "30 Stearns Rd, Unit 402 & Prk-J",
    "parcel_id": "158-05-16",
    "owner1": "WANG, STANLEY YINGHSIN",
    "owner2": "LEE, ANGELA TSUIPING",
    "current_taxes": 7175.43,
    "new_taxes_no_override": 7485.41,
    "override_total_1": 7697.8,
    "override_increase_1": 212.39
  },
  {
    "#": "30 Stearns Rd, Unit 403 (158-05-17)",
    "$": 1099400,
    "address": "30 Stearns Rd, Unit 403",
    "parcel_id": "158-05-17",
    "owner1": "EZHUTHACHAN, JAYACHANDRAN",
    "owner2": "JAYACHANDRAN, KAVITA",
    "current_taxes": 7622.92,
    "new_taxes_no_override": 7952.23,
    "override_total_1": 8177.87,
    "override_increase_1": 225.64
  },
  {
    "#": "30 Stearns Rd, Unit 404 (158-05-18)",
    "$": 1842000,
    "address": "30 Stearns Rd, Unit 404",
    "parcel_id": "158-05-18",
    "owner1": "GOIHMAN TR, SUSANA",
    "owner2": "",
    "current_taxes": 15227.15,
    "new_taxes_no_override": 15884.96,
    "override_total_1": 16335.69,
    "override_increase_1": 450.72
  },
  {
    "#": "30 Stearns Rd, Unit 501 & Pk-Dd (158-05-19)",
    "$": 854100,
    "address": "30 Stearns Rd, Unit 501 & Pk-Dd",
    "parcel_id": "158-05-19",
    "owner1": "CARRUTHERS, JEFFREY B & PATRICIA D",
    "owner2": "",
    "current_taxes": 5111.05,
    "new_taxes_no_override": 5331.85,
    "override_total_1": 5483.13,
    "override_increase_1": 151.29
  },
  {
    "#": "30 Stearns Rd, Unit 502 & Pksp Aa (158-05-20)",
    "$": 937400,
    "address": "30 Stearns Rd, Unit 502 & Pksp Aa",
    "parcel_id": "158-05-20",
    "owner1": "ZHAO TR, JING",
    "owner2": "",
    "current_taxes": 9598.98,
    "new_taxes_no_override": 10013.66,
    "override_total_1": 10297.79,
    "override_increase_1": 284.13
  },
  {
    "#": "30 Stearns Rd, Unit 503 & Pk-G (158-05-21)",
    "$": 989400,
    "address": "30 Stearns Rd, Unit 503 & Pk-G",
    "parcel_id": "158-05-21",
    "owner1": "WANG, STANLEY Y",
    "owner2": "LEE, ANGELA T",
    "current_taxes": 10131.46,
    "new_taxes_no_override": 10569.14,
    "override_total_1": 10869.03,
    "override_increase_1": 299.89
  },
  {
    "#": "30 Stearns Rd, Unit 504 (158-05-22)",
    "$": 1240000,
    "address": "30 Stearns Rd, Unit 504",
    "parcel_id": "158-05-22",
    "owner1": "ARONSON, HELENE SARI",
    "owner2": "",
    "current_taxes": 9062.67,
    "new_taxes_no_override": 9454.18,
    "override_total_1": 9722.43,
    "override_increase_1": 268.26
  },
  {
    "#": "30 Stearns Rd, Unit 505 & G- H (158-05-23)",
    "$": 862900,
    "address": "30 Stearns Rd, Unit 505 & G- H",
    "parcel_id": "158-05-23",
    "owner1": "ZHU, YINENG",
    "owner2": "",
    "current_taxes": 8836.1,
    "new_taxes_no_override": 9217.82,
    "override_total_1": 9479.37,
    "override_increase_1": 261.55
  },
  {
    "#": "30 Stearns Rd, Unit 601 (158-05-24)",
    "$": 966100,
    "address": "30 Stearns Rd, Unit 601",
    "parcel_id": "158-05-24",
    "owner1": "ROSANSKY TR, JULIE",
    "owner2": "",
    "current_taxes": 6257.93,
    "new_taxes_no_override": 6528.27,
    "override_total_1": 6713.51,
    "override_increase_1": 185.23
  },
  {
    "#": "30 Stearns Rd, Unit 602 &G-L (158-05-25)",
    "$": 1153000,
    "address": "30 Stearns Rd, Unit 602 &G-L",
    "parcel_id": "158-05-25",
    "owner1": "ALSHINE LIFE ESTATE, POLINA",
    "owner2": "",
    "current_taxes": 8171.79,
    "new_taxes_no_override": 8524.81,
    "override_total_1": 8766.7,
    "override_increase_1": 241.88
  },
  {
    "#": "30 Stearns Rd, Unit 603 (158-05-26)",
    "$": 1158600,
    "address": "30 Stearns Rd, Unit 603",
    "parcel_id": "158-05-26",
    "owner1": "SHEPSIS, SIMON & INNA",
    "owner2": "",
    "current_taxes": 8229.13,
    "new_taxes_no_override": 8584.63,
    "override_total_1": 8828.21,
    "override_increase_1": 243.58
  },
  {
    "#": "30 Stearns Rd, Unit 604 (158-05-27)",
    "$": 1192900,
    "address": "30 Stearns Rd, Unit 604",
    "parcel_id": "158-05-27",
    "owner1": "GUO, LI",
    "owner2": "YANG, WEI",
    "current_taxes": 8580.36,
    "new_taxes_no_override": 8951.03,
    "override_total_1": 9205.01,
    "override_increase_1": 253.98
  },
  {
    "#": "30 Stearns Rd, Unit 605 (158-05-28)",
    "$": 844100,
    "address": "30 Stearns Rd, Unit 605",
    "parcel_id": "158-05-28",
    "owner1": "VERBITSKY, TR, VLADIMIR",
    "owner2": "",
    "current_taxes": 8643.58,
    "new_taxes_no_override": 9016.98,
    "override_total_1": 9272.83,
    "override_increase_1": 255.85
  },
  {
    "#": "30 Stearns Rd, Unit Pha Pk A-B (158-05-29)",
    "$": 1450300,
    "address": "30 Stearns Rd, Unit Pha Pk A-B",
    "parcel_id": "158-05-29",
    "owner1": "PRESS, DANIEL Z",
    "owner2": "SHAPIRO, STEPHANIE L",
    "current_taxes": 11216.14,
    "new_taxes_no_override": 11700.68,
    "override_total_1": 12032.67,
    "override_increase_1": 332.0
  },
  {
    "#": "30 Stearns Rd, Unit Phb (158-05-30)",
    "$": 1273900,
    "address": "30 Stearns Rd, Unit Phb",
    "parcel_id": "158-05-30",
    "owner1": "HACKEL, NANCY L",
    "owner2": "",
    "current_taxes": 9409.8,
    "new_taxes_no_override": 9816.3,
    "override_total_1": 10094.83,
    "override_increase_1": 278.53
  },
  {
    "#": "31 Stearns Rd (156-19-00)",
    "$": 2521900,
    "address": "31 Stearns Rd",
    "parcel_id": "156-19-00",
    "owner1": "YARCHUN, ROSA",
    "owner2": "",
    "current_taxes": 22189.32,
    "new_taxes_no_override": 23147.9,
    "override_total_1": 23804.7,
    "override_increase_1": 656.8
  },
  {
    "#": "33 Stearns Rd (156-01-00)",
    "$": 3493200,
    "address": "33 Stearns Rd",
    "parcel_id": "156-01-00",
    "owner1": "STEARNS ROAD 33 LLC",
    "owner2": "",
    "current_taxes": 35770.37,
    "new_taxes_no_override": 37315.65,
    "override_total_1": 38374.45,
    "override_increase_1": 1058.8
  },
  {
    "#": "41 Stearns Rd, Unit 41 (157-10-12)",
    "$": 3132300,
    "address": "41 Stearns Rd, Unit 41",
    "parcel_id": "157-10-12",
    "owner1": "PHILLIPS TRS, KEVIN M & MARY R",
    "owner2": "",
    "current_taxes": 32074.75,
    "new_taxes_no_override": 33460.38,
    "override_total_1": 34409.79,
    "override_increase_1": 949.41
  },
  {
    "#": "41 Stearns Rd, Unit 43 (157-10-13)",
    "$": 2746700,
    "address": "41 Stearns Rd, Unit 43",
    "parcel_id": "157-10-13",
    "owner1": "HOFFMAN TR, ELI",
    "owner2": "",
    "current_taxes": 28126.21,
    "new_taxes_no_override": 29341.26,
    "override_total_1": 30173.8,
    "override_increase_1": 832.54
  },
  {
    "#": "45 Stearns Rd, Unit 45A (157-10-14)",
    "$": 1852600,
    "address": "45 Stearns Rd, Unit 45A",
    "parcel_id": "157-10-14",
    "owner1": "STRUPP, KAREN",
    "owner2": "",
    "current_taxes": 18970.62,
    "new_taxes_no_override": 19790.15,
    "override_total_1": 20351.68,
    "override_increase_1": 561.53
  },
  {
    "#": "45 Stearns Rd, Unit 45B (157-10-15)",
    "$": 3982000,
    "address": "45 Stearns Rd, Unit 45B",
    "parcel_id": "157-10-15",
    "owner1": "FINEBERG, GARY",
    "owner2": "COHEN FINEBERG, IRIS",
    "current_taxes": 40775.68,
    "new_taxes_no_override": 42537.19,
    "override_total_1": 43744.15,
    "override_increase_1": 1206.96
  },
  {
    "#": "50 Stearns Rd, Unit 1 & Ps 4C-5 (158-03-01)",
    "$": 2408700,
    "address": "50 Stearns Rd, Unit 1 & Ps 4C-5",
    "parcel_id": "158-03-01",
    "owner1": "OASIS, KENNETH & LAUREN",
    "owner2": "",
    "current_taxes": 24665.09,
    "new_taxes_no_override": 25730.62,
    "override_total_1": 26460.71,
    "override_increase_1": 730.09
  },
  {
    "#": "50 Stearns Rd, Unit 2 & Ps 2 & 3 (158-03-02)",
    "$": 2768900,
    "address": "50 Stearns Rd, Unit 2 & Ps 2 & 3",
    "parcel_id": "158-03-02",
    "owner1": "KAMIOKA, KEIKO",
    "owner2": "KOCBERBER, SAIT",
    "current_taxes": 28353.54,
    "new_taxes_no_override": 29578.41,
    "override_total_1": 30417.68,
    "override_increase_1": 839.26
  },
  {
    "#": "50 Stearns Rd, Unit 3 & Ps 1 & G8 (158-03-03)",
    "$": 2805600,
    "address": "50 Stearns Rd, Unit 3 & Ps 1 & G8",
    "parcel_id": "158-03-03",
    "owner1": "MORNINGSTAR, BETTY",
    "owner2": "KLUGER, JEANETTE",
    "current_taxes": 28729.34,
    "new_taxes_no_override": 29970.45,
    "override_total_1": 30820.84,
    "override_increase_1": 850.39
  },
  {
    "#": "50 Stearns Rd, Unit 4 & G6-7C (158-03-04)",
    "$": 2798400,
    "address": "50 Stearns Rd, Unit 4 & G6-7C",
    "parcel_id": "158-03-04",
    "owner1": "BROWN, EMERY N",
    "owner2": "ANDRADAS, VIRGINIA",
    "current_taxes": 25020.68,
    "new_taxes_no_override": 26101.57,
    "override_total_1": 26842.19,
    "override_increase_1": 740.61
  },
  {
    "#": "54 Stearns Rd, Unit 1 (158-02-03)",
    "$": 1390100,
    "address": "54 Stearns Rd, Unit 1",
    "parcel_id": "158-02-03",
    "owner1": "GIERAHN, TODD M & ANNE-DANIELLE C",
    "owner2": "",
    "current_taxes": 10599.69,
    "new_taxes_no_override": 11057.6,
    "override_total_1": 11371.35,
    "override_increase_1": 313.75
  },
  {
    "#": "54 Stearns Rd, Unit 2 (158-02-01)",
    "$": 1108300,
    "address": "54 Stearns Rd, Unit 2",
    "parcel_id": "158-02-01",
    "owner1": "BRODSKY TRS, ALEXANDER",
    "owner2": "GESIN, NATALIE",
    "current_taxes": 7714.06,
    "new_taxes_no_override": 8047.31,
    "override_total_1": 8275.64,
    "override_increase_1": 228.34
  },
  {
    "#": "54 Stearns Rd, Unit 3 (158-02-02)",
    "$": 1108400,
    "address": "54 Stearns Rd, Unit 3",
    "parcel_id": "158-02-02",
    "owner1": "LAPAN, SYLVAIN & ELLIOT",
    "owner2": "",
    "current_taxes": 7715.08,
    "new_taxes_no_override": 8048.37,
    "override_total_1": 8276.74,
    "override_increase_1": 228.37
  },
  {
    "#": "71 Stearns Rd, Unit 1 (126-26-01)",
    "$": 1937600,
    "address": "71 Stearns Rd, Unit 1",
    "parcel_id": "126-26-01",
    "owner1": "GRADY TRS, CHRISTINA M",
    "owner2": "SCHERPF, JOSEPH C",
    "current_taxes": 16206.09,
    "new_taxes_no_override": 16906.19,
    "override_total_1": 17385.89,
    "override_increase_1": 479.7
  },
  {
    "#": "71 Stearns Rd, Unit 2 (126-26-02)",
    "$": 2212700,
    "address": "71 Stearns Rd, Unit 2",
    "parcel_id": "126-26-02",
    "owner1": "BATES, STEPHEN & LIZA",
    "owner2": "",
    "current_taxes": 19023.11,
    "new_taxes_no_override": 19844.91,
    "override_total_1": 20407.99,
    "override_increase_1": 563.08
  },
  {
    "#": "74 Stearns Rd (126-41-00)",
    "$": 2402600,
    "address": "74 Stearns Rd",
    "parcel_id": "126-41-00",
    "owner1": "YEE, AMY S",
    "owner2": "PAULSON, KURTZ ERIC",
    "current_taxes": 20967.69,
    "new_taxes_no_override": 21873.49,
    "override_total_1": 22494.14,
    "override_increase_1": 620.64
  },
  {
    "#": "75 Stearns Rd, Unit 75 (126-27-02)",
    "$": 984000,
    "address": "75 Stearns Rd, Unit 75",
    "parcel_id": "126-27-02",
    "owner1": "RETTIG, LUKE DONOVAN & ELENI MARIE",
    "owner2": "",
    "current_taxes": 10076.16,
    "new_taxes_no_override": 10511.45,
    "override_total_1": 10809.7,
    "override_increase_1": 298.25
  },
  {
    "#": "77 Stearns Rd, Unit 77 (126-27-01)",
    "$": 1017100,
    "address": "77 Stearns Rd, Unit 77",
    "parcel_id": "126-27-01",
    "owner1": "NOBEL TR, JEREMY J",
    "owner2": "",
    "current_taxes": 6780.17,
    "new_taxes_no_override": 7073.07,
    "override_total_1": 7273.77,
    "override_increase_1": 200.69
  },
  {
    "#": "78 Stearns Rd (126-40-00)",
    "$": 1930100,
    "address": "78 Stearns Rd",
    "parcel_id": "126-40-00",
    "owner1": "LAPSON TRS, LAWRENCE B & MARCIA",
    "owner2": "",
    "current_taxes": 16129.29,
    "new_taxes_no_override": 16826.08,
    "override_total_1": 17303.5,
    "override_increase_1": 477.43
  },
  {
    "#": "79 Stearns Rd (126-28-00)",
    "$": 2006100,
    "address": "79 Stearns Rd",
    "parcel_id": "126-28-00",
    "owner1": "VIOLA, JAMES A & DONNA S",
    "owner2": "",
    "current_taxes": 16907.53,
    "new_taxes_no_override": 17637.94,
    "override_total_1": 18138.4,
    "override_increase_1": 500.46
  },
  {
    "#": "82 Stearns Rd (126-39-03)",
    "$": 2176900,
    "address": "82 Stearns Rd",
    "parcel_id": "126-39-03",
    "owner1": "HEALEY TR, DONNA E",
    "owner2": "",
    "current_taxes": 18656.52,
    "new_taxes_no_override": 19462.48,
    "override_total_1": 20014.71,
    "override_increase_1": 552.23
  },
  {
    "#": "83 Stearns Rd, Unit 1 P1A-1B (126-29-01)",
    "$": 1137500,
    "address": "83 Stearns Rd, Unit 1 P1A-1B",
    "parcel_id": "126-29-01",
    "owner1": "POLK, SAMUEL",
    "owner2": "BECKER, KATHRYN",
    "current_taxes": 8013.07,
    "new_taxes_no_override": 8359.23,
    "override_total_1": 8596.42,
    "override_increase_1": 237.19
  },
  {
    "#": "83 Stearns Rd, Unit 2  P 2A-2B (126-29-02)",
    "$": 938300,
    "address": "83 Stearns Rd, Unit 2  P 2A-2B",
    "parcel_id": "126-29-02",
    "owner1": "SHEEHAN, MICHAEL & JULIA",
    "owner2": "",
    "current_taxes": 9608.19,
    "new_taxes_no_override": 10023.26,
    "override_total_1": 10307.67,
    "override_increase_1": 284.4
  },
  {
    "#": "88 Stearns Rd (126-38-00)",
    "$": 2080300,
    "address": "88 Stearns Rd",
    "parcel_id": "126-38-00",
    "owner1": "LEAHY, LYNDA C",
    "owner2": "",
    "current_taxes": 17667.34,
    "new_taxes_no_override": 18430.57,
    "override_total_1": 18953.52,
    "override_increase_1": 522.95
  },
  {
    "#": "89 Stearns Rd, Unit 1 & G1 (126-30-02)",
    "$": 1109300,
    "address": "89 Stearns Rd, Unit 1 & G1",
    "parcel_id": "126-30-02",
    "owner1": "MENERI, ENIDA",
    "owner2": "BAVERSTAM, KRISTIAN S",
    "current_taxes": 7724.3,
    "new_taxes_no_override": 8057.99,
    "override_total_1": 8286.63,
    "override_increase_1": 228.64
  },
  {
    "#": "89 Stearns Rd, Unit 2 (126-30-01)",
    "$": 1124700,
    "address": "89 Stearns Rd, Unit 2",
    "parcel_id": "126-30-01",
    "owner1": "WALTERS TRS, JACOB & LAURA R",
    "owner2": "",
    "current_taxes": 7881.99,
    "new_taxes_no_override": 8222.49,
    "override_total_1": 8455.8,
    "override_increase_1": 233.31
  },
  {
    "#": "93 Stearns Rd (126-31-00)",
    "$": 1901100,
    "address": "93 Stearns Rd",
    "parcel_id": "126-31-00",
    "owner1": "FISCHER, KAREN G",
    "owner2": "",
    "current_taxes": 15832.33,
    "new_taxes_no_override": 16516.29,
    "override_total_1": 16984.92,
    "override_increase_1": 468.64
  },
  {
    "#": "97 Stearns Rd (126-32-00)",
    "$": 2941700,
    "address": "97 Stearns Rd",
    "parcel_id": "126-32-00",
    "owner1": "FINUCANE ETAL, HILARY K",
    "owner2": "RESHEF, YAKIR A",
    "current_taxes": 26488.07,
    "new_taxes_no_override": 27632.35,
    "override_total_1": 28416.4,
    "override_increase_1": 784.05
  },
  {
    "#": "101 Stearns Rd, Unit 1 (126-33-01)",
    "$": 1464100,
    "address": "101 Stearns Rd, Unit 1",
    "parcel_id": "126-33-01",
    "owner1": "BENSON, JEFFREY",
    "owner2": "KOFKE, ANNE",
    "current_taxes": 11357.45,
    "new_taxes_no_override": 11848.09,
    "override_total_1": 12184.27,
    "override_increase_1": 336.18
  },
  {
    "#": "101 Stearns Rd, Unit 2 (126-33-02)",
    "$": 1527900,
    "address": "101 Stearns Rd, Unit 2",
    "parcel_id": "126-33-02",
    "owner1": "AHMED, ZOHRA",
    "owner2": "BLACK, SAMUEL P",
    "current_taxes": 15645.7,
    "new_taxes_no_override": 16321.59,
    "override_total_1": 16784.71,
    "override_increase_1": 463.11
  },
  {
    "#": "4 Stedman St, Unit 1 (050-01-01)",
    "$": 805100,
    "address": "4 Stedman St, Unit 1",
    "parcel_id": "050-01-01",
    "owner1": "WOO, TSUNG UNG WILSON",
    "owner2": "TIEN, ELISABETE",
    "current_taxes": 8244.22,
    "new_taxes_no_override": 8600.37,
    "override_total_1": 8844.4,
    "override_increase_1": 244.03
  },
  {
    "#": "4 Stedman St, Unit 2 & P4 (050-01-02)",
    "$": 822400,
    "address": "4 Stedman St, Unit 2 & P4",
    "parcel_id": "050-01-02",
    "owner1": "MATTISON TR, CAROLYN A",
    "owner2": "",
    "current_taxes": 4786.44,
    "new_taxes_no_override": 4993.21,
    "override_total_1": 5134.89,
    "override_increase_1": 141.68
  },
  {
    "#": "4 Stedman St, Unit 3 (050-01-03)",
    "$": 799900,
    "address": "4 Stedman St, Unit 3",
    "parcel_id": "050-01-03",
    "owner1": "LOUGHMAN, ET AL, KERRY",
    "owner2": "",
    "current_taxes": 4556.04,
    "new_taxes_no_override": 4752.86,
    "override_total_1": 4887.72,
    "override_increase_1": 134.86
  },
  {
    "#": "6 Stedman St, Unit 1 (050-01-04)",
    "$": 909800,
    "address": "6 Stedman St, Unit 1",
    "parcel_id": "050-01-04",
    "owner1": "CHIN, JIMMY K & REGINA S P",
    "owner2": "",
    "current_taxes": 5681.42,
    "new_taxes_no_override": 5926.86,
    "override_total_1": 6095.03,
    "override_increase_1": 168.17
  },
  {
    "#": "6 Stedman St, Unit 2 (050-01-05)",
    "$": 926900,
    "address": "6 Stedman St, Unit 2",
    "parcel_id": "050-01-05",
    "owner1": "SINTOV, ELAD & MICHAL ZUCKERMAN",
    "owner2": "",
    "current_taxes": 9491.46,
    "new_taxes_no_override": 9901.49,
    "override_total_1": 10182.44,
    "override_increase_1": 280.95
  },
  {
    "#": "6 Stedman St, Unit 3 & P-P1 (050-01-06)",
    "$": 1096100,
    "address": "6 Stedman St, Unit 3 & P-P1",
    "parcel_id": "050-01-06",
    "owner1": "GARCIA, ROMMEL & JACQUELINE SUEN",
    "owner2": "",
    "current_taxes": 7589.13,
    "new_taxes_no_override": 7916.98,
    "override_total_1": 8141.62,
    "override_increase_1": 224.64
  },
  {
    "#": "12 Stedman St, Unit 1 (050-39-01)",
    "$": 1163800,
    "address": "12 Stedman St, Unit 1",
    "parcel_id": "050-39-01",
    "owner1": "GLASSMAN TRS, JAN A",
    "owner2": "SOWALSKY, JOEL M",
    "current_taxes": 8282.38,
    "new_taxes_no_override": 8640.18,
    "override_total_1": 8885.34,
    "override_increase_1": 245.16
  },
  {
    "#": "12 Stedman St, Unit 2 & P5-6 (050-39-02)",
    "$": 1598000,
    "address": "12 Stedman St, Unit 2 & P5-6",
    "parcel_id": "050-39-02",
    "owner1": "BERMAN TRS, ERIC S & ROXANNE L",
    "owner2": "",
    "current_taxes": 12728.59,
    "new_taxes_no_override": 13278.47,
    "override_total_1": 13655.23,
    "override_increase_1": 376.77
  },
  {
    "#": "12 Stedman St, Unit 3 & P3 P4 (050-39-03)",
    "$": 1690500,
    "address": "12 Stedman St, Unit 3 & P3 P4",
    "parcel_id": "050-39-03",
    "owner1": "ADHAMI, KATAYUN S",
    "owner2": "",
    "current_taxes": 13675.79,
    "new_taxes_no_override": 14266.58,
    "override_total_1": 14671.39,
    "override_increase_1": 404.8
  },
  {
    "#": "12 Stedman St, Unit 4 Prk 1 2 (050-39-04)",
    "$": 1690300,
    "address": "12 Stedman St, Unit 4 Prk 1 2",
    "parcel_id": "050-39-04",
    "owner1": "SHAPIRA, OZ M & ESTHER",
    "owner2": "",
    "current_taxes": 13673.74,
    "new_taxes_no_override": 14264.45,
    "override_total_1": 14669.19,
    "override_increase_1": 404.74
  },
  {
    "#": "16 Stedman St (050-38-00)",
    "$": 2070400,
    "address": "16 Stedman St",
    "parcel_id": "050-38-00",
    "owner1": "SAVAGE TRS, AVIS E",
    "owner2": "",
    "current_taxes": 17565.96,
    "new_taxes_no_override": 18324.81,
    "override_total_1": 18844.76,
    "override_increase_1": 519.95
  },
  {
    "#": "20 Stedman St (050-37-00)",
    "$": 2344100,
    "address": "20 Stedman St",
    "parcel_id": "050-37-00",
    "owner1": "COHEN LIFE ESTATE, ELDAD & RINA",
    "owner2": "",
    "current_taxes": 20368.65,
    "new_taxes_no_override": 21248.58,
    "override_total_1": 21851.49,
    "override_increase_1": 602.91
  },
  {
    "#": "24 Stedman St (050-36-00)",
    "$": 2053200,
    "address": "24 Stedman St",
    "parcel_id": "050-36-00",
    "owner1": "GOLDSTEIN, MICHAEL",
    "owner2": "",
    "current_taxes": 17389.83,
    "new_taxes_no_override": 18141.07,
    "override_total_1": 18655.81,
    "override_increase_1": 514.74
  },
  {
    "#": "32 Stedman St (050-35-00)",
    "$": 2940400,
    "address": "32 Stedman St",
    "parcel_id": "050-35-00",
    "owner1": "SHLOSMAN, NATALIE",
    "owner2": "",
    "current_taxes": 26474.76,
    "new_taxes_no_override": 27618.47,
    "override_total_1": 28402.12,
    "override_increase_1": 783.65
  },
  {
    "#": "38 Stedman St (050-34-00)",
    "$": 2389600,
    "address": "38 Stedman St",
    "parcel_id": "050-34-00",
    "owner1": "38 STEDMAN STREET DEVELOPMENT  LLC",
    "owner2": "",
    "current_taxes": 24469.5,
    "new_taxes_no_override": 25526.58,
    "override_total_1": 26250.88,
    "override_increase_1": 724.3
  },
  {
    "#": "44 Stedman St, Unit 1 (050-33-01)",
    "$": 1487400,
    "address": "44 Stedman St, Unit 1",
    "parcel_id": "050-33-01",
    "owner1": "TSAI, ALEXANDER CHUNG-YU",
    "owner2": "HUNG, SERENE",
    "current_taxes": 11596.04,
    "new_taxes_no_override": 12096.99,
    "override_total_1": 12440.23,
    "override_increase_1": 343.24
  },
  {
    "#": "44 Stedman St, Unit 2 (050-33-02)",
    "$": 1830400,
    "address": "44 Stedman St, Unit 2",
    "parcel_id": "050-33-02",
    "owner1": "44 STEDMAN REALTY LLC",
    "owner2": "",
    "current_taxes": 18743.3,
    "new_taxes_no_override": 19553.01,
    "override_total_1": 20107.81,
    "override_increase_1": 554.8
  },
  {
    "#": "48 Stedman St (050-32-00)",
    "$": 2002600,
    "address": "48 Stedman St",
    "parcel_id": "050-32-00",
    "owner1": "RHO, LINDA L",
    "owner2": "",
    "current_taxes": 20506.62,
    "new_taxes_no_override": 21392.51,
    "override_total_1": 21999.5,
    "override_increase_1": 607.0
  },
  {
    "#": "50 Stedman St (050-31-00)",
    "$": 2270400,
    "address": "50 Stedman St",
    "parcel_id": "050-31-00",
    "owner1": "SOJA, NANCY N & THOMAS A",
    "owner2": "",
    "current_taxes": 19613.96,
    "new_taxes_no_override": 20461.28,
    "override_total_1": 21041.86,
    "override_increase_1": 580.57
  },
  {
    "#": "56 Stedman St, Unit 1 (050-30-01)",
    "$": 1153500,
    "address": "56 Stedman St, Unit 1",
    "parcel_id": "050-30-01",
    "owner1": "PRICE TR, STACY ANN",
    "owner2": "",
    "current_taxes": 8176.91,
    "new_taxes_no_override": 8530.15,
    "override_total_1": 8772.19,
    "override_increase_1": 242.04
  },
  {
    "#": "56 Stedman St, Unit 2 (050-30-02)",
    "$": 1105000,
    "address": "56 Stedman St, Unit 2",
    "parcel_id": "050-30-02",
    "owner1": "NAHAS, MICHAEL W",
    "owner2": "HOLCOMB, HELEN",
    "current_taxes": 7680.27,
    "new_taxes_no_override": 8012.06,
    "override_total_1": 8239.39,
    "override_increase_1": 227.34
  },
  {
    "#": "60 Stedman St, Unit 1 (050-29-01)",
    "$": 1118300,
    "address": "60 Stedman St, Unit 1",
    "parcel_id": "050-29-01",
    "owner1": "RAISZ, JONATHAN & MALKA",
    "owner2": "",
    "current_taxes": 11451.39,
    "new_taxes_no_override": 11946.09,
    "override_total_1": 12285.05,
    "override_increase_1": 338.96
  },
  {
    "#": "60 Stedman St, Unit 2 (050-29-02)",
    "$": 1440900,
    "address": "60 Stedman St, Unit 2",
    "parcel_id": "050-29-02",
    "owner1": "FREY, BRIDGET A",
    "owner2": "",
    "current_taxes": 11119.88,
    "new_taxes_no_override": 11600.26,
    "override_total_1": 11929.41,
    "override_increase_1": 329.15
  },
  {
    "#": "66 Stedman St (050-28-00)",
    "$": 2241500,
    "address": "66 Stedman St",
    "parcel_id": "050-28-00",
    "owner1": "WONG, KENNETH S & JANE",
    "owner2": "",
    "current_taxes": 19318.03,
    "new_taxes_no_override": 20152.57,
    "override_total_1": 20724.38,
    "override_increase_1": 571.81
  },
  {
    "#": "72 Stedman St (050-27-00)",
    "$": 3257400,
    "address": "72 Stedman St",
    "parcel_id": "050-27-00",
    "owner1": "REAMER, ARDEN M",
    "owner2": "TABACK, KEVIN M",
    "current_taxes": 29720.84,
    "new_taxes_no_override": 31004.78,
    "override_total_1": 31884.52,
    "override_increase_1": 879.74
  },
  {
    "#": "75 Stedman St (049-18-00)",
    "$": 3425100,
    "address": "75 Stedman St",
    "parcel_id": "049-18-00",
    "owner1": "ROSENTHAL TR, ALISON J",
    "owner2": "",
    "current_taxes": 31438.09,
    "new_taxes_no_override": 32796.22,
    "override_total_1": 33726.78,
    "override_increase_1": 930.57
  },
  {
    "#": "78 Stedman St, Unit 1 (050-26-01)",
    "$": 1002600,
    "address": "78 Stedman St, Unit 1",
    "parcel_id": "050-26-01",
    "owner1": "UEDA, RALFO J & ROSELI",
    "owner2": "",
    "current_taxes": 6631.69,
    "new_taxes_no_override": 6918.18,
    "override_total_1": 7114.48,
    "override_increase_1": 196.3
  },
  {
    "#": "78 Stedman St, Unit 2 (050-26-02)",
    "$": 1225100,
    "address": "78 Stedman St, Unit 2",
    "parcel_id": "050-26-02",
    "owner1": "GARINKOL, OZ & SABINA",
    "owner2": "",
    "current_taxes": 8910.09,
    "new_taxes_no_override": 9295.01,
    "override_total_1": 9558.74,
    "override_increase_1": 263.74
  },
  {
    "#": "79 Stedman St, Unit 1 (049-19-01)",
    "$": 861400,
    "address": "79 Stedman St, Unit 1",
    "parcel_id": "049-19-01",
    "owner1": "REINDORF, WANDA",
    "owner2": "",
    "current_taxes": 5185.8,
    "new_taxes_no_override": 5409.83,
    "override_total_1": 5563.33,
    "override_increase_1": 153.5
  },
  {
    "#": "79 Stedman St, Unit 2 (049-19-02)",
    "$": 1369900,
    "address": "79 Stedman St, Unit 2",
    "parcel_id": "049-19-02",
    "owner1": "ORCHOWSKI, MARKUS P",
    "owner2": "GREYZDORF, NOEMI",
    "current_taxes": 10392.84,
    "new_taxes_no_override": 10841.81,
    "override_total_1": 11149.44,
    "override_increase_1": 307.63
  },
  {
    "#": "82 Stedman St (050-25-00)",
    "$": 2705700,
    "address": "82 Stedman St",
    "parcel_id": "050-25-00",
    "owner1": "BUTERA, GIANFRANCO",
    "owner2": "ANDREU ARASA, VANESA C",
    "current_taxes": 27706.37,
    "new_taxes_no_override": 28903.29,
    "override_total_1": 29723.39,
    "override_increase_1": 820.11
  },
  {
    "#": "83 Stedman St (049-20-00)",
    "$": 2352000,
    "address": "83 Stedman St",
    "parcel_id": "049-20-00",
    "owner1": "EL FAKHRI, GEORGES",
    "owner2": "LIM, RUTH",
    "current_taxes": 24084.48,
    "new_taxes_no_override": 25124.93,
    "override_total_1": 25837.83,
    "override_increase_1": 712.9
  },
  {
    "#": "86 Stedman St (050-24-00)",
    "$": 2079300,
    "address": "86 Stedman St",
    "parcel_id": "050-24-00",
    "owner1": "HUFF, SHAYNE",
    "owner2": "",
    "current_taxes": 17657.1,
    "new_taxes_no_override": 18419.89,
    "override_total_1": 18942.54,
    "override_increase_1": 522.65
  },
  {
    "#": "89 Stedman St (049-21-00)",
    "$": 3408000,
    "address": "89 Stedman St",
    "parcel_id": "049-21-00",
    "owner1": "VIN, YAEL",
    "owner2": "SHESINSKI, EYTAN & RUTH",
    "current_taxes": 31262.99,
    "new_taxes_no_override": 32613.55,
    "override_total_1": 33538.94,
    "override_increase_1": 925.38
  },
  {
    "#": "91 Stedman St (049-22-00)",
    "$": 2161600,
    "address": "91 Stedman St",
    "parcel_id": "049-22-00",
    "owner1": "91 STEDMAN LLC",
    "owner2": "C/O PHOENIX REALTY",
    "current_taxes": 22134.78,
    "new_taxes_no_override": 23091.0,
    "override_total_1": 23746.19,
    "override_increase_1": 655.19
  },
  {
    "#": "95 Stedman St, Unit 1 & Pk Sp (049-23-01)",
    "$": 1881000,
    "address": "95 Stedman St, Unit 1 & Pk Sp",
    "parcel_id": "049-23-01",
    "owner1": "95-1 STEDMAN STREET CBC LLC",
    "owner2": "",
    "current_taxes": 15626.51,
    "new_taxes_no_override": 16301.58,
    "override_total_1": 16764.12,
    "override_increase_1": 462.54
  },
  {
    "#": "95 Stedman St, Unit 2 & 2 Pk Sps (049-23-02)",
    "$": 2175000,
    "address": "95 Stedman St, Unit 2 & 2 Pk Sps",
    "parcel_id": "049-23-02",
    "owner1": "MEHTA, GAURAV & KAVITA",
    "owner2": "",
    "current_taxes": 18637.07,
    "new_taxes_no_override": 19442.19,
    "override_total_1": 19993.85,
    "override_increase_1": 551.66
  },
  {
    "#": "99 Stedman St (049-24-00)",
    "$": 2203300,
    "address": "99 Stedman St",
    "parcel_id": "049-24-00",
    "owner1": "KHOURY, JENNIFER & ALEXANDER",
    "owner2": "",
    "current_taxes": 18926.86,
    "new_taxes_no_override": 19744.5,
    "override_total_1": 20304.74,
    "override_increase_1": 560.24
  },
  {
    "#": "101 Stedman St, Unit 1 (049-25-01)",
    "$": 2010900,
    "address": "101 Stedman St, Unit 1",
    "parcel_id": "049-25-01",
    "owner1": "GAJOS, KRZYSZTOF Z",
    "owner2": "HUANG, JEAN J",
    "current_taxes": 16956.68,
    "new_taxes_no_override": 17689.21,
    "override_total_1": 18191.13,
    "override_increase_1": 501.92
  },
  {
    "#": "101 Stedman St, Unit 2 (049-25-02)",
    "$": 2002700,
    "address": "101 Stedman St, Unit 2",
    "parcel_id": "049-25-02",
    "owner1": "HONG TRS, DAVID I & KAREN G",
    "owner2": "",
    "current_taxes": 16872.71,
    "new_taxes_no_override": 17601.61,
    "override_total_1": 18101.04,
    "override_increase_1": 499.43
  },
  {
    "#": "105 Stedman St (049-26-00)",
    "$": 3793500,
    "address": "105 Stedman St",
    "parcel_id": "049-26-00",
    "owner1": "NISSIM, SAHAR",
    "owner2": "FOURMAN, LINDSAY",
    "current_taxes": 35210.51,
    "new_taxes_no_override": 36731.6,
    "override_total_1": 37773.84,
    "override_increase_1": 1042.23
  },
  {
    "#": "111 Stedman St (049-27-00)",
    "$": 2552700,
    "address": "111 Stedman St",
    "parcel_id": "049-27-00",
    "owner1": "KATZ, SCOTT",
    "owner2": "BERNSTEIN, MEGAN",
    "current_taxes": 26139.65,
    "new_taxes_no_override": 27268.88,
    "override_total_1": 28042.62,
    "override_increase_1": 773.73
  },
  {
    "#": "113 Stedman St (049-28-00)",
    "$": 1559300,
    "address": "113 Stedman St",
    "parcel_id": "049-28-00",
    "owner1": "STEADY TR, FILOMINA C",
    "owner2": "",
    "current_taxes": 15967.23,
    "new_taxes_no_override": 16657.01,
    "override_total_1": 17129.64,
    "override_increase_1": 472.63
  },
  {
    "#": "115 Stedman St (049-29-00)",
    "$": 1604600,
    "address": "115 Stedman St",
    "parcel_id": "049-29-00",
    "owner1": "ROGEL, LAWRENCE & AINAT",
    "owner2": "",
    "current_taxes": 12796.17,
    "new_taxes_no_override": 13348.96,
    "override_total_1": 13727.73,
    "override_increase_1": 378.77
  },
  {
    "#": "117 Stedman St, Unit 2 (049-30-02)",
    "$": 1418100,
    "address": "117 Stedman St, Unit 2",
    "parcel_id": "049-30-02",
    "owner1": "CRANDELL TR, GINA M",
    "owner2": "",
    "current_taxes": 10886.41,
    "new_taxes_no_override": 11356.7,
    "override_total_1": 11678.94,
    "override_increase_1": 322.24
  },
  {
    "#": "119 Stedman St, Unit 1 (049-30-01)",
    "$": 1313700,
    "address": "119 Stedman St, Unit 1",
    "parcel_id": "049-30-01",
    "owner1": "ANDERSON TRS, JOHN R",
    "owner2": "MANASEVIT, JODIE ANN",
    "current_taxes": 9817.35,
    "new_taxes_no_override": 10241.46,
    "override_total_1": 10532.05,
    "override_increase_1": 290.59
  },
  {
    "#": "120 Stedman St (052-09-00)",
    "$": 2505500,
    "address": "120 Stedman St",
    "parcel_id": "052-09-00",
    "owner1": "WONG TR, MARY C",
    "owner2": "",
    "current_taxes": 22021.39,
    "new_taxes_no_override": 22972.71,
    "override_total_1": 23624.55,
    "override_increase_1": 651.83
  },
  {
    "#": "121 Stedman St, Unit 1 (049-31-01)",
    "$": 1121500,
    "address": "121 Stedman St, Unit 1",
    "parcel_id": "049-31-01",
    "owner1": "GOLDMAN TRS, BRIAN ANTHONY & CHRISTINE MARGANIAN",
    "owner2": "",
    "current_taxes": 7849.23,
    "new_taxes_no_override": 8188.32,
    "override_total_1": 8420.65,
    "override_increase_1": 232.34
  },
  {
    "#": "121 Stedman St, Unit 2 (049-31-02)",
    "$": 1152500,
    "address": "121 Stedman St, Unit 2",
    "parcel_id": "049-31-02",
    "owner1": "STAFF TRS, GUY & CAROLINE L",
    "owner2": "",
    "current_taxes": 8166.67,
    "new_taxes_no_override": 8519.47,
    "override_total_1": 8761.2,
    "override_increase_1": 241.73
  },
  {
    "#": "7 Stetson St (035-01-00)",
    "$": 2054200,
    "address": "7 Stetson St",
    "parcel_id": "035-01-00",
    "owner1": "SIMONS, EMMANUEL J & CAROLINE K",
    "owner2": "",
    "current_taxes": 17400.07,
    "new_taxes_no_override": 18151.75,
    "override_total_1": 18666.8,
    "override_increase_1": 515.04
  },
  {
    "#": "8 Stetson St (033-01-00)",
    "$": 3258600,
    "address": "8 Stetson St",
    "parcel_id": "033-01-00",
    "owner1": "EHRLICH, BRUCE & LORI",
    "owner2": "",
    "current_taxes": 29733.13,
    "new_taxes_no_override": 31017.6,
    "override_total_1": 31897.7,
    "override_increase_1": 880.1
  },
  {
    "#": "9 Stetson St (035-02-00)",
    "$": 2296900,
    "address": "9 Stetson St",
    "parcel_id": "035-02-00",
    "owner1": "HULL, CARYL H",
    "owner2": "",
    "current_taxes": 19885.32,
    "new_taxes_no_override": 20744.37,
    "override_total_1": 21332.97,
    "override_increase_1": 588.61
  },
  {
    "#": "12 Stetson St (033-17-00)",
    "$": 2706400,
    "address": "12 Stetson St",
    "parcel_id": "033-17-00",
    "owner1": "HSU TR, LIANGGE",
    "owner2": "",
    "current_taxes": 27713.54,
    "new_taxes_no_override": 28910.76,
    "override_total_1": 29731.09,
    "override_increase_1": 820.32
  },
  {
    "#": "15 Stetson St (035-03-00)",
    "$": 3059800,
    "address": "15 Stetson St",
    "parcel_id": "035-03-00",
    "owner1": "TUNGATE, CINDY V",
    "owner2": "",
    "current_taxes": 27697.42,
    "new_taxes_no_override": 28893.95,
    "override_total_1": 29713.79,
    "override_increase_1": 819.84
  },
  {
    "#": "16 Stetson St (033-16-00)",
    "$": 3146200,
    "address": "16 Stetson St",
    "parcel_id": "033-16-00",
    "owner1": "WINICKOFF, JONATHAN & BETH A",
    "owner2": "",
    "current_taxes": 28582.15,
    "new_taxes_no_override": 29816.9,
    "override_total_1": 30662.93,
    "override_increase_1": 846.03
  },
  {
    "#": "19 Stetson St (035-04-00)",
    "$": 2884000,
    "address": "19 Stetson St",
    "parcel_id": "035-04-00",
    "owner1": "NOVICH TR, MARILYN",
    "owner2": "",
    "current_taxes": 25897.23,
    "new_taxes_no_override": 27015.99,
    "override_total_1": 27782.55,
    "override_increase_1": 766.56
  },
  {
    "#": "23 Stetson St, Unit 1 & P1 (035-05-01)",
    "$": 1298500,
    "address": "23 Stetson St, Unit 1 & P1",
    "parcel_id": "035-05-01",
    "owner1": "HOLLINGSWORTH, JULIET HAMILTON",
    "owner2": "GRISDELA, PHILLIP THOMAS JR",
    "current_taxes": 13296.64,
    "new_taxes_no_override": 13871.05,
    "override_total_1": 14264.64,
    "override_increase_1": 393.58
  },
  {
    "#": "23 Stetson St, Unit 2 (035-05-02)",
    "$": 1421300,
    "address": "23 Stetson St, Unit 2",
    "parcel_id": "035-05-02",
    "owner1": "LIPMAN TRS, BARTON L & MARIE",
    "owner2": "",
    "current_taxes": 10919.18,
    "new_taxes_no_override": 11390.89,
    "override_total_1": 11714.1,
    "override_increase_1": 323.21
  },
  {
    "#": "24 Stetson St (033-15-00)",
    "$": 2204400,
    "address": "24 Stetson St",
    "parcel_id": "033-15-00",
    "owner1": "PEPPER, MARJORIE",
    "owner2": "",
    "current_taxes": 18938.12,
    "new_taxes_no_override": 19756.25,
    "override_total_1": 20316.82,
    "override_increase_1": 560.57
  },
  {
    "#": "26 Stetson St (033-14-00)",
    "$": 2477400,
    "address": "26 Stetson St",
    "parcel_id": "033-14-00",
    "owner1": "UROVITCH, NYNA",
    "owner2": "WILLIAMS, DAVID",
    "current_taxes": 21733.64,
    "new_taxes_no_override": 22672.53,
    "override_total_1": 23315.85,
    "override_increase_1": 643.32
  },
  {
    "#": "27 Stetson St (035-06-00)",
    "$": 2535200,
    "address": "27 Stetson St",
    "parcel_id": "035-06-00",
    "owner1": "ZILBERSHOT, VICTOR O & DORIT",
    "owner2": "",
    "current_taxes": 22325.51,
    "new_taxes_no_override": 23289.97,
    "override_total_1": 23950.81,
    "override_increase_1": 660.84
  },
  {
    "#": "30 Stetson St (033-13-00)",
    "$": 1939000,
    "address": "30 Stetson St",
    "parcel_id": "033-13-00",
    "owner1": "SANKARAN, BARATH W",
    "owner2": "SONNI, SHRUTI",
    "current_taxes": 19855.36,
    "new_taxes_no_override": 20713.11,
    "override_total_1": 21300.83,
    "override_increase_1": 587.72
  },
  {
    "#": "31 Stetson St, Unit 1 & P1-3 (035-07-01)",
    "$": 1972600,
    "address": "31 Stetson St, Unit 1 & P1-3",
    "parcel_id": "035-07-01",
    "owner1": "ZILBERBERG, GIL M & YAFIT",
    "owner2": "",
    "current_taxes": 16564.49,
    "new_taxes_no_override": 17280.08,
    "override_total_1": 17770.38,
    "override_increase_1": 490.31
  },
  {
    "#": "31 Stetson St, Unit 2 & P2-4 (035-07-02)",
    "$": 2209600,
    "address": "31 Stetson St, Unit 2 & P2-4",
    "parcel_id": "035-07-02",
    "owner1": "SANKARAN, BARATH",
    "owner2": "SONNI, SHRUTI",
    "current_taxes": 22626.3,
    "new_taxes_no_override": 23603.76,
    "override_total_1": 24273.49,
    "override_increase_1": 669.74
  },
  {
    "#": "34 Stetson St (033-12-00)",
    "$": 1681900,
    "address": "34 Stetson St",
    "parcel_id": "033-12-00",
    "owner1": "HUFFMAN, MATTHEW D",
    "owner2": "KING, ROBYN S",
    "current_taxes": 17222.66,
    "new_taxes_no_override": 17966.68,
    "override_total_1": 18476.47,
    "override_increase_1": 509.79
  },
  {
    "#": "35 Stetson St (035-08-00)",
    "$": 2188600,
    "address": "35 Stetson St",
    "parcel_id": "035-08-00",
    "owner1": "HSU, MD, LIANGGE & HINGGE",
    "owner2": "",
    "current_taxes": 18776.33,
    "new_taxes_no_override": 19587.47,
    "override_total_1": 20143.25,
    "override_increase_1": 555.78
  },
  {
    "#": "39 Stetson St (035-09-00)",
    "$": 1759300,
    "address": "39 Stetson St",
    "parcel_id": "035-09-00",
    "owner1": "SPIEGEL, STANLEY L & DIANA L",
    "owner2": "",
    "current_taxes": 14380.3,
    "new_taxes_no_override": 15001.53,
    "override_total_1": 15427.19,
    "override_increase_1": 425.66
  },
  {
    "#": "40 Stetson St, Unit 1 P-B (033-10-14)",
    "$": 653800,
    "address": "40 Stetson St, Unit 1 P-B",
    "parcel_id": "033-10-14",
    "owner1": "40-1 STETSON STREET LLC",
    "owner2": "",
    "current_taxes": 6694.91,
    "new_taxes_no_override": 6984.13,
    "override_total_1": 7182.3,
    "override_increase_1": 198.17
  },
  {
    "#": "40 Stetson St, Unit 2 (033-10-01)",
    "$": 638700,
    "address": "40 Stetson St, Unit 2",
    "parcel_id": "033-10-01",
    "owner1": "BAR-LEV, TR, ASSA",
    "owner2": "",
    "current_taxes": 6540.29,
    "new_taxes_no_override": 6822.83,
    "override_total_1": 7016.42,
    "override_increase_1": 193.59
  },
  {
    "#": "40 Stetson St, Unit 3 (033-10-02)",
    "$": 653800,
    "address": "40 Stetson St, Unit 3",
    "parcel_id": "033-10-02",
    "owner1": "BAR LEV TRS, ASSA & EDITH",
    "owner2": "",
    "current_taxes": 6694.91,
    "new_taxes_no_override": 6984.13,
    "override_total_1": 7182.3,
    "override_increase_1": 198.17
  },
  {
    "#": "40 Stetson St, Unit 4 & P-H (033-10-03)",
    "$": 655700,
    "address": "40 Stetson St, Unit 4 & P-H",
    "parcel_id": "033-10-03",
    "owner1": "BARLEV-EHRENBERG, YEHOSHUA & ADI",
    "owner2": "",
    "current_taxes": 6714.37,
    "new_taxes_no_override": 7004.43,
    "override_total_1": 7203.18,
    "override_increase_1": 198.75
  },
  {
    "#": "40 Stetson St, Unit 5 & P-F (033-10-04)",
    "$": 653800,
    "address": "40 Stetson St, Unit 5 & P-F",
    "parcel_id": "033-10-04",
    "owner1": "GOODMAN, RACHEL L",
    "owner2": "",
    "current_taxes": 3059.98,
    "new_taxes_no_override": 3192.17,
    "override_total_1": 3282.75,
    "override_increase_1": 90.58
  },
  {
    "#": "40 Stetson St, Unit 6 & P-J (033-10-05)",
    "$": 655700,
    "address": "40 Stetson St, Unit 6 & P-J",
    "parcel_id": "033-10-05",
    "owner1": "ZIEMANN, CHRISTINE M",
    "owner2": "MAGNONI, SCOTT D",
    "current_taxes": 6714.37,
    "new_taxes_no_override": 7004.43,
    "override_total_1": 7203.18,
    "override_increase_1": 198.75
  },
  {
    "#": "40 Stetson St, Unit 7 (033-10-06)",
    "$": 643500,
    "address": "40 Stetson St, Unit 7",
    "parcel_id": "033-10-06",
    "owner1": "MIR, JULITA",
    "owner2": "MUNARRIZ, RICARDO",
    "current_taxes": 6589.44,
    "new_taxes_no_override": 6874.1,
    "override_total_1": 7069.15,
    "override_increase_1": 195.05
  },
  {
    "#": "43 Stetson St (035-10-00)",
    "$": 1828300,
    "address": "43 Stetson St",
    "parcel_id": "035-10-00",
    "owner1": "HOUGH, HERBERT E JR & ANNE E",
    "owner2": "",
    "current_taxes": 15086.86,
    "new_taxes_no_override": 15738.61,
    "override_total_1": 16185.18,
    "override_increase_1": 446.57
  },
  {
    "#": "46 Stetson St, Unit 1 P-R (033-10-07)",
    "$": 681200,
    "address": "46 Stetson St, Unit 1 P-R",
    "parcel_id": "033-10-07",
    "owner1": "SCHNEIDERMAN FAMILY LLC",
    "owner2": "",
    "current_taxes": 6975.49,
    "new_taxes_no_override": 7276.83,
    "override_total_1": 7483.31,
    "override_increase_1": 206.47
  },
  {
    "#": "46 Stetson St, Unit 2 (033-10-08)",
    "$": 638200,
    "address": "46 Stetson St, Unit 2",
    "parcel_id": "033-10-08",
    "owner1": "MOLLET TR, DANIELLE",
    "owner2": "",
    "current_taxes": 6535.17,
    "new_taxes_no_override": 6817.49,
    "override_total_1": 7010.93,
    "override_increase_1": 193.44
  },
  {
    "#": "46 Stetson St, Unit 3 & P-N (033-10-09)",
    "$": 655700,
    "address": "46 Stetson St, Unit 3 & P-N",
    "parcel_id": "033-10-09",
    "owner1": "REALE, STEPHEN E",
    "owner2": "",
    "current_taxes": 6714.37,
    "new_taxes_no_override": 7004.43,
    "override_total_1": 7203.18,
    "override_increase_1": 198.75
  },
  {
    "#": "46 Stetson St, Unit 4 (033-10-10)",
    "$": 655200,
    "address": "46 Stetson St, Unit 4",
    "parcel_id": "033-10-10",
    "owner1": "SOMERS, PHYLLIS L",
    "owner2": "",
    "current_taxes": 3074.31,
    "new_taxes_no_override": 3207.12,
    "override_total_1": 3298.12,
    "override_increase_1": 91.0
  },
  {
    "#": "46 Stetson St, Unit 5 & P-K (033-10-11)",
    "$": 655700,
    "address": "46 Stetson St, Unit 5 & P-K",
    "parcel_id": "033-10-11",
    "owner1": "KARPMAN, MAURICE S",
    "owner2": "HOROWITZ, SHIRA",
    "current_taxes": 3079.43,
    "new_taxes_no_override": 3212.46,
    "override_total_1": 3303.61,
    "override_increase_1": 91.15
  },
  {
    "#": "46 Stetson St, Unit 6 (033-10-12)",
    "$": 655200,
    "address": "46 Stetson St, Unit 6",
    "parcel_id": "033-10-12",
    "owner1": "HARVEY, PAMELA D",
    "owner2": "",
    "current_taxes": 3074.31,
    "new_taxes_no_override": 3207.12,
    "override_total_1": 3298.12,
    "override_increase_1": 91.0
  },
  {
    "#": "46 Stetson St, Unit 7 (033-10-13)",
    "$": 565100,
    "address": "46 Stetson St, Unit 7",
    "parcel_id": "033-10-13",
    "owner1": "WONG, THOMAS G & PAULA SIU MUI",
    "owner2": "",
    "current_taxes": 2151.69,
    "new_taxes_no_override": 2244.64,
    "override_total_1": 2308.33,
    "override_increase_1": 63.69
  },
  {
    "#": "47 Stetson St (035-11-00)",
    "$": 2344700,
    "address": "47 Stetson St",
    "parcel_id": "035-11-00",
    "owner1": "TRAVERSO TR, CARLO GIOVANNI",
    "owner2": "",
    "current_taxes": 24009.73,
    "new_taxes_no_override": 25046.95,
    "override_total_1": 25757.64,
    "override_increase_1": 710.69
  },
  {
    "#": "51 Stetson St, Unit 1 (035-12-01)",
    "$": 1046400,
    "address": "51 Stetson St, Unit 1",
    "parcel_id": "035-12-01",
    "owner1": "HOMANN, NATASHA GOLDMAN & JOACHIM",
    "owner2": "",
    "current_taxes": 7080.2,
    "new_taxes_no_override": 7386.06,
    "override_total_1": 7595.64,
    "override_increase_1": 209.57
  },
  {
    "#": "2 Still St, Unit 4 & P-5 (037-01-02)",
    "$": 1077100,
    "address": "2 Still St, Unit 4 & P-5",
    "parcel_id": "037-01-02",
    "owner1": "WATKINS, MIWA ANTONIA",
    "owner2": "GUIDA, LEONARD JOHN",
    "current_taxes": 7394.57,
    "new_taxes_no_override": 7714.02,
    "override_total_1": 7932.89,
    "override_increase_1": 218.88
  },
  {
    "#": "2 Still St, Unit 5 (037-01-01)",
    "$": 1337700,
    "address": "2 Still St, Unit 5",
    "parcel_id": "037-01-01",
    "owner1": "ULLMAN, LISA G",
    "owner2": "",
    "current_taxes": 10063.11,
    "new_taxes_no_override": 10497.84,
    "override_total_1": 10795.7,
    "override_increase_1": 297.87
  },
  {
    "#": "4 Still St, Unit 2 (037-01-04)",
    "$": 1206800,
    "address": "4 Still St, Unit 2",
    "parcel_id": "037-01-04",
    "owner1": "PESANELLI, KELLY",
    "owner2": "",
    "current_taxes": 8722.7,
    "new_taxes_no_override": 9099.52,
    "override_total_1": 9357.71,
    "override_increase_1": 258.19
  },
  {
    "#": "4 Still St, Unit 3 & P17 (037-01-03)",
    "$": 1230700,
    "address": "4 Still St, Unit 3 & P17",
    "parcel_id": "037-01-03",
    "owner1": "JOSEPH, IAN & MEGHAN",
    "owner2": "",
    "current_taxes": 12602.37,
    "new_taxes_no_override": 13146.79,
    "override_total_1": 13519.82,
    "override_increase_1": 373.03
  },
  {
    "#": "6 Still St, Unit 1 (037-01-05)",
    "$": 1355600,
    "address": "6 Still St, Unit 1",
    "parcel_id": "037-01-05",
    "owner1": "XU, LING",
    "owner2": "CHEN, TONG",
    "current_taxes": 10246.41,
    "new_taxes_no_override": 10689.05,
    "override_total_1": 10992.35,
    "override_increase_1": 303.29
  },
  {
    "#": "6 Still St, Unit 6 (037-01-06)",
    "$": 1466600,
    "address": "6 Still St, Unit 6",
    "parcel_id": "037-01-06",
    "owner1": "ROBERTS, ELIZABETH P",
    "owner2": "",
    "current_taxes": 15017.98,
    "new_taxes_no_override": 15666.76,
    "override_total_1": 16111.29,
    "override_increase_1": 444.53
  },
  {
    "#": "8 Still St, Unit 10 (037-01-10)",
    "$": 1320400,
    "address": "8 Still St, Unit 10",
    "parcel_id": "037-01-10",
    "owner1": "KRINSKY, KIRSTIN G & ROSS M",
    "owner2": "",
    "current_taxes": 9885.96,
    "new_taxes_no_override": 10313.03,
    "override_total_1": 10605.66,
    "override_increase_1": 292.62
  },
  {
    "#": "8 Still St, Unit 7 & P4 (037-01-07)",
    "$": 1305800,
    "address": "8 Still St, Unit 7 & P4",
    "parcel_id": "037-01-07",
    "owner1": "KEENAN, EDWARD",
    "owner2": "PIERCY, JANE",
    "current_taxes": 9736.46,
    "new_taxes_no_override": 10157.08,
    "override_total_1": 10445.27,
    "override_increase_1": 288.2
  },
  {
    "#": "8 Still St, Unit 8 (037-01-08)",
    "$": 1278900,
    "address": "8 Still St, Unit 8",
    "parcel_id": "037-01-08",
    "owner1": "OJEDA, PEDRO ELIAS & SAMUEL",
    "owner2": "",
    "current_taxes": 9461.0,
    "new_taxes_no_override": 9869.72,
    "override_total_1": 10149.76,
    "override_increase_1": 280.05
  },
  {
    "#": "8 Still St, Unit 9 (037-01-09)",
    "$": 1337100,
    "address": "8 Still St, Unit 9",
    "parcel_id": "037-01-09",
    "owner1": "DESAI, ANUPAM",
    "owner2": "MAKHIJA, MONICA",
    "current_taxes": 13691.9,
    "new_taxes_no_override": 14283.39,
    "override_total_1": 14688.67,
    "override_increase_1": 405.28
  },
  {
    "#": "10 Still St, Unit 11 (037-01-11)",
    "$": 1100000,
    "address": "10 Still St, Unit 11",
    "parcel_id": "037-01-11",
    "owner1": "BOWMAN JR, JOHN E",
    "owner2": "",
    "current_taxes": 7629.07,
    "new_taxes_no_override": 7958.65,
    "override_total_1": 8184.47,
    "override_increase_1": 225.82
  },
  {
    "#": "10 Still St, Unit 12 (037-01-12)",
    "$": 1045600,
    "address": "10 Still St, Unit 12",
    "parcel_id": "037-01-12",
    "owner1": "NASSIF TR, PETER T",
    "owner2": "",
    "current_taxes": 10706.94,
    "new_taxes_no_override": 11169.48,
    "override_total_1": 11486.41,
    "override_increase_1": 316.93
  },
  {
    "#": "10 Still St, Unit 13 (037-01-13)",
    "$": 1010000,
    "address": "10 Still St, Unit 13",
    "parcel_id": "037-01-13",
    "owner1": "LOVIT, CAROLYN E",
    "owner2": "",
    "current_taxes": 6707.47,
    "new_taxes_no_override": 6997.23,
    "override_total_1": 7195.77,
    "override_increase_1": 198.54
  },
  {
    "#": "12 Still St, Unit 14 (037-01-14)",
    "$": 1281800,
    "address": "12 Still St, Unit 14",
    "parcel_id": "037-01-14",
    "owner1": "EAST POINTE HOLDINGS INC",
    "owner2": "",
    "current_taxes": 13125.63,
    "new_taxes_no_override": 13692.66,
    "override_total_1": 14081.18,
    "override_increase_1": 388.52
  },
  {
    "#": "12 Still St, Unit 15 & P1 (037-01-15)",
    "$": 1339500,
    "address": "12 Still St, Unit 15 & P1",
    "parcel_id": "037-01-15",
    "owner1": "BASS TRS, SUSAN D & ARTHUR",
    "owner2": "",
    "current_taxes": 10081.55,
    "new_taxes_no_override": 10517.07,
    "override_total_1": 10815.49,
    "override_increase_1": 298.41
  },
  {
    "#": "12 Still St, Unit 16 (037-01-16)",
    "$": 1210900,
    "address": "12 Still St, Unit 16",
    "parcel_id": "037-01-16",
    "owner1": "NATHANSON TR, LINDA S",
    "owner2": "",
    "current_taxes": 8764.68,
    "new_taxes_no_override": 9143.31,
    "override_total_1": 9402.75,
    "override_increase_1": 259.43
  },
  {
    "#": "12 Still St, Unit 17 (037-01-17)",
    "$": 1176500,
    "address": "12 Still St, Unit 17",
    "parcel_id": "037-01-17",
    "owner1": "LERMAN, IRENE",
    "owner2": "",
    "current_taxes": 12047.36,
    "new_taxes_no_override": 12567.81,
    "override_total_1": 12924.41,
    "override_increase_1": 356.6
  },
  {
    "#": "14 Still St, Unit 18 & P20 (037-01-18)",
    "$": 1145000,
    "address": "14 Still St, Unit 18 & P20",
    "parcel_id": "037-01-18",
    "owner1": "LIAN TR, ALEXANDER HAN SUNG",
    "owner2": "",
    "current_taxes": 11724.8,
    "new_taxes_no_override": 12231.31,
    "override_total_1": 12578.37,
    "override_increase_1": 347.05
  },
  {
    "#": "14 Still St, Unit 19 & Pk Sp (037-01-19)",
    "$": 1183500,
    "address": "14 Still St, Unit 19 & Pk Sp",
    "parcel_id": "037-01-19",
    "owner1": "KNOCKE TRS, JAMES E & ANN M",
    "owner2": "",
    "current_taxes": 8484.11,
    "new_taxes_no_override": 8850.62,
    "override_total_1": 9101.75,
    "override_increase_1": 251.13
  },
  {
    "#": "14 Still St, Unit 20 (037-01-20)",
    "$": 1192600,
    "address": "14 Still St, Unit 20",
    "parcel_id": "037-01-20",
    "owner1": "LIU, PANG-HSIANG & CHIUNG-HUI",
    "owner2": "",
    "current_taxes": 8577.29,
    "new_taxes_no_override": 8947.83,
    "override_total_1": 9201.72,
    "override_increase_1": 253.89
  },
  {
    "#": "16 Still St, Unit 21 & P 25 (037-01-21)",
    "$": 1354900,
    "address": "16 Still St, Unit 21 & P 25",
    "parcel_id": "037-01-21",
    "owner1": "LIN, JEN-WEI",
    "owner2": "SCHWEITZER, A NICOLA",
    "current_taxes": 10239.24,
    "new_taxes_no_override": 10681.58,
    "override_total_1": 10984.66,
    "override_increase_1": 303.08
  },
  {
    "#": "16 Still St, Unit 22 (037-01-22)",
    "$": 1292200,
    "address": "16 Still St, Unit 22",
    "parcel_id": "037-01-22",
    "owner1": "PATTERSON, MARY BURKE & ROBERT E",
    "owner2": "",
    "current_taxes": 13232.13,
    "new_taxes_no_override": 13803.76,
    "override_total_1": 14195.43,
    "override_increase_1": 391.67
  },
  {
    "#": "16 Still St, Unit 23 & P 23 (037-01-23)",
    "$": 1298700,
    "address": "16 Still St, Unit 23 & P 23",
    "parcel_id": "037-01-23",
    "owner1": "HAYES TRS, BARRY D & ELLEN N",
    "owner2": "",
    "current_taxes": 9663.75,
    "new_taxes_no_override": 10081.22,
    "override_total_1": 10367.27,
    "override_increase_1": 286.05
  },
  {
    "#": "16 Still St, Unit 24 (037-01-24)",
    "$": 1322600,
    "address": "16 Still St, Unit 24",
    "parcel_id": "037-01-24",
    "owner1": "LITVIN TR, DANIELA",
    "owner2": "",
    "current_taxes": 9908.49,
    "new_taxes_no_override": 10336.54,
    "override_total_1": 10629.83,
    "override_increase_1": 293.29
  },
  {
    "#": "18 Still St, Unit 25 (037-01-25)",
    "$": 1282800,
    "address": "18 Still St, Unit 25",
    "parcel_id": "037-01-25",
    "owner1": "ELINSON TR, MICHAEL LOU",
    "owner2": "",
    "current_taxes": 9500.94,
    "new_taxes_no_override": 9911.38,
    "override_total_1": 10192.61,
    "override_increase_1": 281.23
  },
  {
    "#": "18 Still St, Unit 26 (037-01-26)",
    "$": 1404500,
    "address": "18 Still St, Unit 26",
    "parcel_id": "037-01-26",
    "owner1": "KIKUCHI, LENA",
    "owner2": "",
    "current_taxes": 10747.15,
    "new_taxes_no_override": 11211.43,
    "override_total_1": 11529.54,
    "override_increase_1": 318.12
  },
  {
    "#": "18 Still St, Unit 31 (037-01-27)",
    "$": 1190900,
    "address": "18 Still St, Unit 31",
    "parcel_id": "037-01-27",
    "owner1": "CONTE, SUE ANN",
    "owner2": "",
    "current_taxes": 8559.88,
    "new_taxes_no_override": 8929.67,
    "override_total_1": 9183.04,
    "override_increase_1": 253.37
  },
  {
    "#": "20 Still St, Unit 29 (037-01-29)",
    "$": 1132600,
    "address": "20 Still St, Unit 29",
    "parcel_id": "037-01-29",
    "owner1": "SLOTNIK, WILLIAM J",
    "owner2": "",
    "current_taxes": 7962.89,
    "new_taxes_no_override": 8306.89,
    "override_total_1": 8542.59,
    "override_increase_1": 235.7
  },
  {
    "#": "20 Still St, Unit 30 (037-01-28)",
    "$": 1071500,
    "address": "20 Still St, Unit 30",
    "parcel_id": "037-01-28",
    "owner1": "JOHNSON, SARAH",
    "owner2": "",
    "current_taxes": 7337.23,
    "new_taxes_no_override": 7654.2,
    "override_total_1": 7871.38,
    "override_increase_1": 217.18
  },
  {
    "#": "22 Still St, Unit 27 & P28 (037-01-31)",
    "$": 1379500,
    "address": "22 Still St, Unit 27 & P28",
    "parcel_id": "037-01-31",
    "owner1": "ZOU, YINGDAN",
    "owner2": "",
    "current_taxes": 10491.15,
    "new_taxes_no_override": 10944.37,
    "override_total_1": 11254.91,
    "override_increase_1": 310.54
  },
  {
    "#": "22 Still St, Unit 28 & P32 (037-01-30)",
    "$": 1176400,
    "address": "22 Still St, Unit 28 & P32",
    "parcel_id": "037-01-30",
    "owner1": "LIOUTAS, VASILEIOS ARSENIOS",
    "owner2": "VAMVINI, MARIA",
    "current_taxes": 8411.4,
    "new_taxes_no_override": 8774.77,
    "override_total_1": 9023.75,
    "override_increase_1": 248.98
  },
  {
    "#": "1 Strathmore Rd, Unit 1 & P4 (235-02-02)",
    "$": 1269800,
    "address": "1 Strathmore Rd, Unit 1 & P4",
    "parcel_id": "235-02-02",
    "owner1": "SOUMERAI, HEIDI",
    "owner2": "HOROVITZ, MARTIN",
    "current_taxes": 9367.82,
    "new_taxes_no_override": 9772.51,
    "override_total_1": 10049.8,
    "override_increase_1": 277.29
  },
  {
    "#": "1 Strathmore Rd, Unit 2 & P3 (235-02-03)",
    "$": 1292800,
    "address": "1 Strathmore Rd, Unit 2 & P3",
    "parcel_id": "235-02-03",
    "owner1": "SCHULZ, KATHRYN",
    "owner2": "SCHULZ TRS, WILLIAM C III & TAMELA J",
    "current_taxes": 9603.34,
    "new_taxes_no_override": 10018.2,
    "override_total_1": 10302.46,
    "override_increase_1": 284.26
  },
  {
    "#": "1 Strathmore Rd, Unit 3 & P2 (235-02-04)",
    "$": 1421300,
    "address": "1 Strathmore Rd, Unit 3 & P2",
    "parcel_id": "235-02-04",
    "owner1": "HALPERIN, YONATHAN & IRIT",
    "owner2": "",
    "current_taxes": 14554.11,
    "new_taxes_no_override": 15182.85,
    "override_total_1": 15613.65,
    "override_increase_1": 430.8
  },
  {
    "#": "1 Strathmore Rd, Unit G & P1 (235-02-01)",
    "$": 1121300,
    "address": "1 Strathmore Rd, Unit G & P1",
    "parcel_id": "235-02-01",
    "owner1": "COHEN, SHIMON",
    "owner2": "",
    "current_taxes": 11482.11,
    "new_taxes_no_override": 11978.14,
    "override_total_1": 12318.01,
    "override_increase_1": 339.87
  },
  {
    "#": "2 Strathmore Rd (236-01-00)",
    "$": 3899600,
    "address": "2 Strathmore Rd",
    "parcel_id": "236-01-00",
    "owner1": "PENG, JAMES L & NANCY Y",
    "owner2": "",
    "current_taxes": 39931.9,
    "new_taxes_no_override": 41656.96,
    "override_total_1": 42838.94,
    "override_increase_1": 1181.98
  },
  {
    "#": "3 Strathmore Rd (235-03-00)",
    "$": 2509000,
    "address": "3 Strathmore Rd",
    "parcel_id": "235-03-00",
    "owner1": "3 STRATHMORE RD LLC",
    "owner2": "",
    "current_taxes": 25692.16,
    "new_taxes_no_override": 26802.06,
    "override_total_1": 27562.55,
    "override_increase_1": 760.49
  },
  {
    "#": "4 Strathmore Rd (236-02-00)",
    "$": 3402800,
    "address": "4 Strathmore Rd",
    "parcel_id": "236-02-00",
    "owner1": "CHOI, MINSIK",
    "owner2": "KIM, JIYEAN",
    "current_taxes": 31209.74,
    "new_taxes_no_override": 32558.0,
    "override_total_1": 33481.81,
    "override_increase_1": 923.81
  },
  {
    "#": "5 Strathmore Rd (235-04-00)",
    "$": 2527600,
    "address": "5 Strathmore Rd",
    "parcel_id": "235-04-00",
    "owner1": "OUELLETTE, BRIAN",
    "owner2": "STEEVES, SHERYL R",
    "current_taxes": 22247.69,
    "new_taxes_no_override": 23208.79,
    "override_total_1": 23867.32,
    "override_increase_1": 658.53
  },
  {
    "#": "6 Strathmore Rd, Unit A (236-03-03)",
    "$": 1047700,
    "address": "6 Strathmore Rd, Unit A",
    "parcel_id": "236-03-03",
    "owner1": "FRIEDMAN, BORIS & MARSHA",
    "owner2": "",
    "current_taxes": 7093.51,
    "new_taxes_no_override": 7399.95,
    "override_total_1": 7609.92,
    "override_increase_1": 209.97
  },
  {
    "#": "6 Strathmore Rd, Unit B (236-03-01)",
    "$": 1141800,
    "address": "6 Strathmore Rd, Unit B",
    "parcel_id": "236-03-01",
    "owner1": "6 STRATHMORE ROAD LLC",
    "owner2": "",
    "current_taxes": 11692.03,
    "new_taxes_no_override": 12197.13,
    "override_total_1": 12543.21,
    "override_increase_1": 346.08
  },
  {
    "#": "6 Strathmore Rd, Unit C (236-03-02)",
    "$": 1125600,
    "address": "6 Strathmore Rd, Unit C",
    "parcel_id": "236-03-02",
    "owner1": "ADANDE, ARMAND & YOLENE",
    "owner2": "",
    "current_taxes": 7891.21,
    "new_taxes_no_override": 8232.11,
    "override_total_1": 8465.69,
    "override_increase_1": 233.58
  },
  {
    "#": "7 Strathmore Rd (235-05-00)",
    "$": 4211300,
    "address": "7 Strathmore Rd",
    "parcel_id": "235-05-00",
    "owner1": "90-92 ENDICOTT STREET LLC",
    "owner2": "C/O BAY REALTY GROUP",
    "current_taxes": 43123.71,
    "new_taxes_no_override": 44986.65,
    "override_total_1": 46263.12,
    "override_increase_1": 1276.46
  },
  {
    "#": "8 Strathmore Rd, Unit 1 & P2 (236-04-02)",
    "$": 1151700,
    "address": "8 Strathmore Rd, Unit 1 & P2",
    "parcel_id": "236-04-02",
    "owner1": "MARTIN, JAKE J",
    "owner2": "GSELL, NICOLE",
    "current_taxes": 8158.47,
    "new_taxes_no_override": 8510.92,
    "override_total_1": 8752.41,
    "override_increase_1": 241.49
  },
  {
    "#": "8 Strathmore Rd, Unit 2 & P3-5 (236-04-03)",
    "$": 1319700,
    "address": "8 Strathmore Rd, Unit 2 & P3-5",
    "parcel_id": "236-04-03",
    "owner1": "SIMPSON, JONATHAN E",
    "owner2": "COHEN, MARYA J",
    "current_taxes": 9878.79,
    "new_taxes_no_override": 10305.55,
    "override_total_1": 10597.97,
    "override_increase_1": 292.41
  },
  {
    "#": "8 Strathmore Rd, Unit 3 & P4-P6 (236-04-04)",
    "$": 1198700,
    "address": "8 Strathmore Rd, Unit 3 & P4-P6",
    "parcel_id": "236-04-04",
    "owner1": "L`ITALIEN, PAUL",
    "owner2": "",
    "current_taxes": 8639.75,
    "new_taxes_no_override": 9012.99,
    "override_total_1": 9268.72,
    "override_increase_1": 255.74
  },
  {
    "#": "8 Strathmore Rd, Unit G & P1 (236-04-01)",
    "$": 680100,
    "address": "8 Strathmore Rd, Unit G & P1",
    "parcel_id": "236-04-01",
    "owner1": "TADMOR, ADA",
    "owner2": "SCANLON, MOIRA O",
    "current_taxes": 3329.29,
    "new_taxes_no_override": 3473.12,
    "override_total_1": 3571.66,
    "override_increase_1": 98.55
  },
  {
    "#": "9 Strathmore Rd (235-06-00)",
    "$": 3825300,
    "address": "9 Strathmore Rd",
    "parcel_id": "235-06-00",
    "owner1": "KENNEY TR, SHANE",
    "owner2": "",
    "current_taxes": 39171.07,
    "new_taxes_no_override": 40863.26,
    "override_total_1": 42022.72,
    "override_increase_1": 1159.46
  },
  {
    "#": "10 Strathmore Rd (236-05-00)",
    "$": 3275200,
    "address": "10 Strathmore Rd",
    "parcel_id": "236-05-00",
    "owner1": "KAI FAI INVESTMENT REALTY LLC",
    "owner2": "",
    "current_taxes": 33538.05,
    "new_taxes_no_override": 34986.89,
    "override_total_1": 35979.62,
    "override_increase_1": 992.73
  },
  {
    "#": "11 Strathmore Rd (235-07-00)",
    "$": 3208600,
    "address": "11 Strathmore Rd",
    "parcel_id": "235-07-00",
    "owner1": "ULCHAK, NELA",
    "owner2": "GESZPENC, LEON",
    "current_taxes": 32856.06,
    "new_taxes_no_override": 34275.44,
    "override_total_1": 35247.98,
    "override_increase_1": 972.54
  },
  {
    "#": "12 Strathmore Rd (236-06-00)",
    "$": 2597700,
    "address": "12 Strathmore Rd",
    "parcel_id": "236-06-00",
    "owner1": "RUSSELL, ET AL TRS, WILLIAM W",
    "owner2": "C/O FIELD CORP",
    "current_taxes": 26600.45,
    "new_taxes_no_override": 27749.59,
    "override_total_1": 28536.96,
    "override_increase_1": 787.37
  },
  {
    "#": "14 Strathmore Rd (236-07-00)",
    "$": 2954800,
    "address": "14 Strathmore Rd",
    "parcel_id": "236-07-00",
    "owner1": "SANIEOFF, SHAHRYAR",
    "owner2": "",
    "current_taxes": 30257.15,
    "new_taxes_no_override": 31564.26,
    "override_total_1": 32459.87,
    "override_increase_1": 895.61
  },
  {
    "#": "15 Strathmore Rd, Unit 1 & P3 (235-08-03)",
    "$": 1046800,
    "address": "15 Strathmore Rd, Unit 1 & P3",
    "parcel_id": "235-08-03",
    "owner1": "LIU, JUN",
    "owner2": "LU, MIN",
    "current_taxes": 10719.23,
    "new_taxes_no_override": 11182.3,
    "override_total_1": 11499.59,
    "override_increase_1": 317.29
  },
  {
    "#": "15 Strathmore Rd, Unit 2 & P2 (235-08-01)",
    "$": 1057500,
    "address": "15 Strathmore Rd, Unit 2 & P2",
    "parcel_id": "235-08-01",
    "owner1": "MCQUADE, ANNE C & DAVID",
    "owner2": "",
    "current_taxes": 7193.87,
    "new_taxes_no_override": 7504.65,
    "override_total_1": 7717.58,
    "override_increase_1": 212.94
  },
  {
    "#": "15 Strathmore Rd, Unit 3 & P4 (235-08-02)",
    "$": 1051000,
    "address": "15 Strathmore Rd, Unit 3 & P4",
    "parcel_id": "235-08-02",
    "owner1": "ZOMPATORI, MARINA",
    "owner2": "WALEGA, JASON G",
    "current_taxes": 7127.31,
    "new_taxes_no_override": 7435.21,
    "override_total_1": 7646.18,
    "override_increase_1": 210.97
  },
  {
    "#": "15 Strathmore Rd, Unit A & P1 (235-08-04)",
    "$": 775800,
    "address": "15 Strathmore Rd, Unit A & P1",
    "parcel_id": "235-08-04",
    "owner1": "NAWROCKI, MAIRI C & PAUL R",
    "owner2": "",
    "current_taxes": 7944.19,
    "new_taxes_no_override": 8287.38,
    "override_total_1": 8522.53,
    "override_increase_1": 235.15
  },
  {
    "#": "16 Strathmore Rd (236-08-00)",
    "$": 3223400,
    "address": "16 Strathmore Rd",
    "parcel_id": "236-08-00",
    "owner1": "LEE TRS, YUN-JUN HUANG & KIT HUNG",
    "owner2": "",
    "current_taxes": 33007.62,
    "new_taxes_no_override": 34433.55,
    "override_total_1": 35410.57,
    "override_increase_1": 977.03
  },
  {
    "#": "17 Strathmore Rd, Unit 1 & P1 (235-09-02)",
    "$": 1018100,
    "address": "17 Strathmore Rd, Unit 1 & P1",
    "parcel_id": "235-09-02",
    "owner1": "TSIKIS, SAVAS",
    "owner2": "HU, LINGBO",
    "current_taxes": 6790.41,
    "new_taxes_no_override": 7083.76,
    "override_total_1": 7284.75,
    "override_increase_1": 201.0
  },
  {
    "#": "17 Strathmore Rd, Unit 2 & P2 (235-09-03)",
    "$": 1078300,
    "address": "17 Strathmore Rd, Unit 2 & P2",
    "parcel_id": "235-09-03",
    "owner1": "HSIEH, SAMUEL",
    "owner2": "HSU, CHRISTINA",
    "current_taxes": 11041.79,
    "new_taxes_no_override": 11518.8,
    "override_total_1": 11845.63,
    "override_increase_1": 326.84
  },
  {
    "#": "17 Strathmore Rd, Unit 3 & P3 (235-09-04)",
    "$": 1106700,
    "address": "17 Strathmore Rd, Unit 3 & P3",
    "parcel_id": "235-09-04",
    "owner1": "DAYNARD TRS, RICHARD A & CAROL I",
    "owner2": "",
    "current_taxes": 11332.61,
    "new_taxes_no_override": 11822.18,
    "override_total_1": 12157.62,
    "override_increase_1": 335.45
  },
  {
    "#": "17 Strathmore Rd, Unit B & P4 (235-09-01)",
    "$": 739100,
    "address": "17 Strathmore Rd, Unit B & P4",
    "parcel_id": "235-09-01",
    "owner1": "SHUKLA, ANIL & SARA",
    "owner2": "",
    "current_taxes": 7568.38,
    "new_taxes_no_override": 7895.33,
    "override_total_1": 8119.36,
    "override_increase_1": 224.02
  },
  {
    "#": "18 Strathmore Rd, Unit 1  Gar 1 & P-C (236-09-01)",
    "$": 1481600,
    "address": "18 Strathmore Rd, Unit 1  Gar 1 & P-C",
    "parcel_id": "236-09-01",
    "owner1": "DAVIDSON, PHILIP R & SANDRA K",
    "owner2": "",
    "current_taxes": 11536.65,
    "new_taxes_no_override": 12035.03,
    "override_total_1": 12376.52,
    "override_increase_1": 341.48
  },
  {
    "#": "18 Strathmore Rd, Unit 2 & P-A & Gar B (236-09-02)",
    "$": 1123700,
    "address": "18 Strathmore Rd, Unit 2 & P-A & Gar B",
    "parcel_id": "236-09-02",
    "owner1": "BELETSKY TR, ELLINA",
    "owner2": "",
    "current_taxes": 7871.75,
    "new_taxes_no_override": 8211.81,
    "override_total_1": 8444.81,
    "override_increase_1": 233.0
  },
  {
    "#": "18 Strathmore Rd, Unit 3 & P-B (236-09-03)",
    "$": 1057500,
    "address": "18 Strathmore Rd, Unit 3 & P-B",
    "parcel_id": "236-09-03",
    "owner1": "MADDEN, ROBERT W",
    "owner2": "",
    "current_taxes": 7193.87,
    "new_taxes_no_override": 7504.65,
    "override_total_1": 7717.58,
    "override_increase_1": 212.94
  },
  {
    "#": "19 Strathmore Rd (235-10-00)",
    "$": 2518300,
    "address": "19 Strathmore Rd",
    "parcel_id": "235-10-00",
    "owner1": "JASAN REALTY LLC",
    "owner2": "",
    "current_taxes": 25787.39,
    "new_taxes_no_override": 26901.41,
    "override_total_1": 27664.71,
    "override_increase_1": 763.31
  },
  {
    "#": "20 Strathmore Rd, Unit 1 (236-10-03)",
    "$": 880700,
    "address": "20 Strathmore Rd, Unit 1",
    "parcel_id": "236-10-03",
    "owner1": "TSIRELSON TRS, BORIS & VERA",
    "owner2": "",
    "current_taxes": 5383.43,
    "new_taxes_no_override": 5615.99,
    "override_total_1": 5775.34,
    "override_increase_1": 159.35
  },
  {
    "#": "20 Strathmore Rd, Unit 2 (236-10-01)",
    "$": 1107300,
    "address": "20 Strathmore Rd, Unit 2",
    "parcel_id": "236-10-01",
    "owner1": "YUE, MIN",
    "owner2": "",
    "current_taxes": 7703.82,
    "new_taxes_no_override": 8036.63,
    "override_total_1": 8264.66,
    "override_increase_1": 228.03
  },
  {
    "#": "20 Strathmore Rd, Unit 3 (236-10-02)",
    "$": 1139800,
    "address": "20 Strathmore Rd, Unit 3",
    "parcel_id": "236-10-02",
    "owner1": "SHIBBERU, HEBRET",
    "owner2": "",
    "current_taxes": 11671.55,
    "new_taxes_no_override": 12175.76,
    "override_total_1": 12521.24,
    "override_increase_1": 345.48
  },
  {
    "#": "21 Strathmore Rd, Unit 1 (235-11-03)",
    "$": 1045900,
    "address": "21 Strathmore Rd, Unit 1",
    "parcel_id": "235-11-03",
    "owner1": "ROSENBAUM, ROBERT G & NORA C",
    "owner2": "",
    "current_taxes": 7075.08,
    "new_taxes_no_override": 7380.72,
    "override_total_1": 7590.15,
    "override_increase_1": 209.42
  },
  {
    "#": "21 Strathmore Rd, Unit 2 (235-11-01)",
    "$": 1080700,
    "address": "21 Strathmore Rd, Unit 2",
    "parcel_id": "235-11-01",
    "owner1": "FINEBERG, SAMUEL A & SUSAN L",
    "owner2": "",
    "current_taxes": 7431.43,
    "new_taxes_no_override": 7752.47,
    "override_total_1": 7972.44,
    "override_increase_1": 219.97
  },
  {
    "#": "21 Strathmore Rd, Unit 3 (235-11-02)",
    "$": 1064900,
    "address": "21 Strathmore Rd, Unit 3",
    "parcel_id": "235-11-02",
    "owner1": "MCNALLY, ZACHARY THOMAS & JOSIE NICOLE",
    "owner2": "",
    "current_taxes": 7269.64,
    "new_taxes_no_override": 7583.69,
    "override_total_1": 7798.87,
    "override_increase_1": 215.18
  },
  {
    "#": "22 Strathmore Rd (236-11-00)",
    "$": 2575500,
    "address": "22 Strathmore Rd",
    "parcel_id": "236-11-00",
    "owner1": "SANIEOFF, SIEON",
    "owner2": "",
    "current_taxes": 26373.12,
    "new_taxes_no_override": 27512.44,
    "override_total_1": 28293.08,
    "override_increase_1": 780.64
  },
  {
    "#": "23 Strathmore Rd, Unit 1A (235-12-02)",
    "$": 889500,
    "address": "23 Strathmore Rd, Unit 1A",
    "parcel_id": "235-12-02",
    "owner1": "KAYE, ADAM",
    "owner2": "CONWAY, SARAH",
    "current_taxes": 5473.55,
    "new_taxes_no_override": 5710.01,
    "override_total_1": 5872.02,
    "override_increase_1": 162.02
  },
  {
    "#": "23 Strathmore Rd, Unit 1B (235-12-01)",
    "$": 815700,
    "address": "23 Strathmore Rd, Unit 1B",
    "parcel_id": "235-12-01",
    "owner1": "FINSTHWAIT, WILLIAM P",
    "owner2": "C/O DICKSON, JEFFREY",
    "current_taxes": 8352.77,
    "new_taxes_no_override": 8713.61,
    "override_total_1": 8960.85,
    "override_increase_1": 247.24
  },
  {
    "#": "23 Strathmore Rd, Unit 2 (235-12-03)",
    "$": 962800,
    "address": "23 Strathmore Rd, Unit 2",
    "parcel_id": "235-12-03",
    "owner1": "BER, BENYAMIN",
    "owner2": "EDWARDS, JENNIFER F",
    "current_taxes": 6224.14,
    "new_taxes_no_override": 6493.02,
    "override_total_1": 6677.26,
    "override_increase_1": 184.23
  },
  {
    "#": "23 Strathmore Rd, Unit 3 (235-12-04)",
    "$": 1071000,
    "address": "23 Strathmore Rd, Unit 3",
    "parcel_id": "235-12-04",
    "owner1": "DUFFY, MARTHA",
    "owner2": "SMITH, CATHARINE",
    "current_taxes": 7332.11,
    "new_taxes_no_override": 7648.86,
    "override_total_1": 7865.89,
    "override_increase_1": 217.03
  },
  {
    "#": "24 Strathmore Rd (236-12-00)",
    "$": 2590900,
    "address": "24 Strathmore Rd",
    "parcel_id": "236-12-00",
    "owner1": "SANIEOFF, SIEON",
    "owner2": "",
    "current_taxes": 26530.82,
    "new_taxes_no_override": 27676.95,
    "override_total_1": 28462.26,
    "override_increase_1": 785.31
  },
  {
    "#": "26 Strathmore Rd (236-13-14)",
    "$": 1118500,
    "address": "26 Strathmore Rd",
    "parcel_id": "236-13-14",
    "owner1": "COMMONWEALTH OF MASSACHUSETTS",
    "owner2": "C/O MASS BAY TRANSIT AUTHORITY",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "28 Strathmore Rd (237-01-00)",
    "$": 5805500,
    "address": "28 Strathmore Rd",
    "parcel_id": "237-01-00",
    "owner1": "COMMONWEALTH OF MASSACHUSETTS",
    "owner2": "C/O MASS BAY TRANSIT AUTHORITY",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "40 Strathmore Rd (237-03-00)",
    "$": 2660300,
    "address": "40 Strathmore Rd",
    "parcel_id": "237-03-00",
    "owner1": "FREEDMAN TRS, ELLIOTT J",
    "owner2": "AIKEN-FREEDMAN TR, MAXINE H",
    "current_taxes": 23606.54,
    "new_taxes_no_override": 24626.34,
    "override_total_1": 25325.1,
    "override_increase_1": 698.75
  },
  {
    "#": "2 Summit Ave (084-09-00)",
    "$": 1046100,
    "address": "2 Summit Ave",
    "parcel_id": "084-09-00",
    "owner1": "SEGAL, TR, DAVID J",
    "owner2": "",
    "current_taxes": 16961.21,
    "new_taxes_no_override": 17693.93,
    "override_total_1": 18195.99,
    "override_increase_1": 502.05
  },
  {
    "#": "3 Summit Ave, Unit 1 & Pk B-C (084-10-01)",
    "$": 1391600,
    "address": "3 Summit Ave, Unit 1 & Pk B-C",
    "parcel_id": "084-10-01",
    "owner1": "IGLEHART TRS, J DIRK",
    "owner2": "ARMSTRONG TR, ELIZABETH J",
    "current_taxes": 10615.05,
    "new_taxes_no_override": 11073.62,
    "override_total_1": 11387.83,
    "override_increase_1": 314.21
  },
  {
    "#": "3 Summit Ave, Unit 2 & Pk-A (084-10-02)",
    "$": 1520300,
    "address": "3 Summit Ave, Unit 2 & Pk-A",
    "parcel_id": "084-10-02",
    "owner1": "PAREKH TRS, KALPENDU J",
    "owner2": "DISCEPOLO, KERI E",
    "current_taxes": 11932.94,
    "new_taxes_no_override": 12448.44,
    "override_total_1": 12801.66,
    "override_increase_1": 353.22
  },
  {
    "#": "4 Summit Ave (084-11-00)",
    "$": 1837800,
    "address": "4 Summit Ave",
    "parcel_id": "084-11-00",
    "owner1": "ZIEFERT, JENNIFER & JAMES",
    "owner2": "",
    "current_taxes": 15184.14,
    "new_taxes_no_override": 15840.09,
    "override_total_1": 16289.55,
    "override_increase_1": 449.45
  },
  {
    "#": "9 Summit Ave, Unit A (084-12-00)",
    "$": 8446900,
    "address": "9 Summit Ave, Unit A",
    "parcel_id": "084-12-00",
    "owner1": "J & W SUMMIT AVE LLC",
    "owner2": "C/O JOHN MORIARTY III",
    "current_taxes": 86496.26,
    "new_taxes_no_override": 90232.9,
    "override_total_1": 92793.19,
    "override_increase_1": 2560.29
  },
  {
    "#": "17 Summit Ave, Unit 1 & Pk A (085-49-01)",
    "$": 1909700,
    "address": "17 Summit Ave, Unit 1 & Pk A",
    "parcel_id": "085-49-01",
    "owner1": "LIM, ALAN & JUDY Y",
    "owner2": "",
    "current_taxes": 15920.39,
    "new_taxes_no_override": 16608.15,
    "override_total_1": 17079.39,
    "override_increase_1": 471.24
  },
  {
    "#": "17 Summit Ave, Unit 2 (085-49-02)",
    "$": 2094400,
    "address": "17 Summit Ave, Unit 2",
    "parcel_id": "085-49-02",
    "owner1": "PARESKY, DAVID E & MEGHAN L",
    "owner2": "",
    "current_taxes": 21446.66,
    "new_taxes_no_override": 22373.16,
    "override_total_1": 23007.98,
    "override_increase_1": 634.82
  },
  {
    "#": "21 Summit Ave, Unit 21 & Pk C (085-50-01)",
    "$": 2006900,
    "address": "21 Summit Ave, Unit 21 & Pk C",
    "parcel_id": "085-50-01",
    "owner1": "MARTZ, IAN",
    "owner2": "TAKEVA, ALEXANDRA",
    "current_taxes": 16915.72,
    "new_taxes_no_override": 17646.48,
    "override_total_1": 18147.18,
    "override_increase_1": 500.71
  },
  {
    "#": "21 Summit Ave, Unit 23 & Pk D (085-50-02)",
    "$": 1768100,
    "address": "21 Summit Ave, Unit 23 & Pk D",
    "parcel_id": "085-50-02",
    "owner1": "CASEY, MATTHEW R",
    "owner2": "KALKHORAN, SARA",
    "current_taxes": 14470.41,
    "new_taxes_no_override": 15095.53,
    "override_total_1": 15523.86,
    "override_increase_1": 428.32
  },
  {
    "#": "24 Summit Ave, Unit 1 (090-08-19)",
    "$": 659300,
    "address": "24 Summit Ave, Unit 1",
    "parcel_id": "090-08-19",
    "owner1": "DUAN, MUCHANG",
    "owner2": "",
    "current_taxes": 3116.3,
    "new_taxes_no_override": 3250.92,
    "override_total_1": 3343.17,
    "override_increase_1": 92.24
  },
  {
    "#": "24 Summit Ave, Unit 2 (090-08-01)",
    "$": 659300,
    "address": "24 Summit Ave, Unit 2",
    "parcel_id": "090-08-01",
    "owner1": "HATJE, CAROLYN",
    "owner2": "",
    "current_taxes": 3116.3,
    "new_taxes_no_override": 3250.92,
    "override_total_1": 3343.17,
    "override_increase_1": 92.24
  },
  {
    "#": "24 Summit Ave, Unit 3 (090-08-02)",
    "$": 632400,
    "address": "24 Summit Ave, Unit 3",
    "parcel_id": "090-08-02",
    "owner1": "MANDEL, MARC",
    "owner2": "BUTLER, ANTHONY N",
    "current_taxes": 2840.84,
    "new_taxes_no_override": 2963.56,
    "override_total_1": 3047.65,
    "override_increase_1": 84.09
  },
  {
    "#": "24 Summit Ave, Unit A (090-08-18)",
    "$": 410300,
    "address": "24 Summit Ave, Unit A",
    "parcel_id": "090-08-18",
    "owner1": "SUMCORP INC",
    "owner2": "C/O ROBERT MARCUS RE CO INC",
    "current_taxes": 4201.47,
    "new_taxes_no_override": 4382.97,
    "override_total_1": 4507.34,
    "override_increase_1": 124.36
  },
  {
    "#": "26 Summit Ave, Unit 4 (090-08-03)",
    "$": 784500,
    "address": "26 Summit Ave, Unit 4",
    "parcel_id": "090-08-03",
    "owner1": "SARWAR, TURHAN FIAZ",
    "owner2": "LEE-SARWAR, KATHLEEN ANNE",
    "current_taxes": 4398.35,
    "new_taxes_no_override": 4588.36,
    "override_total_1": 4718.55,
    "override_increase_1": 130.19
  },
  {
    "#": "26 Summit Ave, Unit 5 (090-08-04)",
    "$": 763700,
    "address": "26 Summit Ave, Unit 5",
    "parcel_id": "090-08-04",
    "owner1": "WANG TRS, YI",
    "owner2": "WU, QUN",
    "current_taxes": 7820.29,
    "new_taxes_no_override": 8158.13,
    "override_total_1": 8389.61,
    "override_increase_1": 231.48
  },
  {
    "#": "26 Summit Ave, Unit 6 (090-08-05)",
    "$": 745400,
    "address": "26 Summit Ave, Unit 6",
    "parcel_id": "090-08-05",
    "owner1": "JIN, HONGYI",
    "owner2": "",
    "current_taxes": 3997.96,
    "new_taxes_no_override": 4170.67,
    "override_total_1": 4289.01,
    "override_increase_1": 118.34
  },
  {
    "#": "27 Summit Ave (085-51-01)",
    "$": 2212800,
    "address": "27 Summit Ave",
    "parcel_id": "085-51-01",
    "owner1": "SINGER TR, DAVA",
    "owner2": "",
    "current_taxes": 19024.14,
    "new_taxes_no_override": 19845.98,
    "override_total_1": 20409.1,
    "override_increase_1": 563.11
  },
  {
    "#": "29 Summit Ave (085-51-02)",
    "$": 1876000,
    "address": "29 Summit Ave",
    "parcel_id": "085-51-02",
    "owner1": "FOX, JENNIFER M",
    "owner2": "TIERNEY, DANIEL E",
    "current_taxes": 15575.31,
    "new_taxes_no_override": 16248.16,
    "override_total_1": 16709.19,
    "override_increase_1": 461.03
  },
  {
    "#": "30 Summit Ave, Unit 1 (090-08-06)",
    "$": 747500,
    "address": "30 Summit Ave, Unit 1",
    "parcel_id": "090-08-06",
    "owner1": "CHEN, YANAN",
    "owner2": "",
    "current_taxes": 7654.4,
    "new_taxes_no_override": 7985.07,
    "override_total_1": 8211.64,
    "override_increase_1": 226.57
  },
  {
    "#": "30 Summit Ave, Unit 2 (090-08-07)",
    "$": 747500,
    "address": "30 Summit Ave, Unit 2",
    "parcel_id": "090-08-07",
    "owner1": "WEI, YU & EVELYNE",
    "owner2": "",
    "current_taxes": 4019.47,
    "new_taxes_no_override": 4193.11,
    "override_total_1": 4312.09,
    "override_increase_1": 118.98
  },
  {
    "#": "30 Summit Ave, Unit 3 (090-08-08)",
    "$": 742700,
    "address": "30 Summit Ave, Unit 3",
    "parcel_id": "090-08-08",
    "owner1": "DELANEY, JACE ANGUS",
    "owner2": "",
    "current_taxes": 7605.25,
    "new_taxes_no_override": 7933.8,
    "override_total_1": 8158.91,
    "override_increase_1": 225.12
  },
  {
    "#": "31 Summit Ave, Unit 31 (085-52-01)",
    "$": 1864300,
    "address": "31 Summit Ave, Unit 31",
    "parcel_id": "085-52-01",
    "owner1": "SASSAMAN, ERIK KARL",
    "owner2": "FENG, MARGIE YINGCHUN",
    "current_taxes": 15455.5,
    "new_taxes_no_override": 16123.18,
    "override_total_1": 16580.66,
    "override_increase_1": 457.48
  },
  {
    "#": "32 Summit Ave, Unit 4 (090-08-09)",
    "$": 782000,
    "address": "32 Summit Ave, Unit 4",
    "parcel_id": "090-08-09",
    "owner1": "YANG, JIE",
    "owner2": "",
    "current_taxes": 8007.68,
    "new_taxes_no_override": 8353.61,
    "override_total_1": 8590.64,
    "override_increase_1": 237.03
  },
  {
    "#": "32 Summit Ave, Unit 5 (090-08-10)",
    "$": 742800,
    "address": "32 Summit Ave, Unit 5",
    "parcel_id": "090-08-10",
    "owner1": "CAFARO TRS, NICHOLAS & CARL",
    "owner2": "",
    "current_taxes": 7606.27,
    "new_taxes_no_override": 7934.86,
    "override_total_1": 8160.01,
    "override_increase_1": 225.15
  },
  {
    "#": "32 Summit Ave, Unit 6 (090-08-11)",
    "$": 761000,
    "address": "32 Summit Ave, Unit 6",
    "parcel_id": "090-08-11",
    "owner1": "HOMEWELL NORFOLK LLC",
    "owner2": "",
    "current_taxes": 7792.64,
    "new_taxes_no_override": 8129.28,
    "override_total_1": 8359.94,
    "override_increase_1": 230.66
  },
  {
    "#": "33 Summit Ave, Unit 33 (085-52-02)",
    "$": 2293500,
    "address": "33 Summit Ave, Unit 33",
    "parcel_id": "085-52-02",
    "owner1": "BARCIN, BORA & ZEYNEP",
    "owner2": "",
    "current_taxes": 19850.51,
    "new_taxes_no_override": 20708.05,
    "override_total_1": 21295.63,
    "override_increase_1": 587.58
  },
  {
    "#": "36 Summit Ave, Unit 1 (090-08-12)",
    "$": 724600,
    "address": "36 Summit Ave, Unit 1",
    "parcel_id": "090-08-12",
    "owner1": "DAVIDI, ASNAT NATI",
    "owner2": "",
    "current_taxes": 3784.97,
    "new_taxes_no_override": 3948.48,
    "override_total_1": 4060.52,
    "override_increase_1": 112.04
  },
  {
    "#": "36 Summit Ave, Unit 2 (090-08-13)",
    "$": 767200,
    "address": "36 Summit Ave, Unit 2",
    "parcel_id": "090-08-13",
    "owner1": "ZHANG, HENG",
    "owner2": "WANG, WEI",
    "current_taxes": 4221.19,
    "new_taxes_no_override": 4403.55,
    "override_total_1": 4528.49,
    "override_increase_1": 124.95
  },
  {
    "#": "36 Summit Ave, Unit 3 (090-08-14)",
    "$": 777800,
    "address": "36 Summit Ave, Unit 3",
    "parcel_id": "090-08-14",
    "owner1": "BLASER, ERIK A",
    "owner2": "KALDY, ZSUZSANNA",
    "current_taxes": 4329.74,
    "new_taxes_no_override": 4516.78,
    "override_total_1": 4644.95,
    "override_increase_1": 128.16
  },
  {
    "#": "37 Summit Ave (085-53-00)",
    "$": 2246700,
    "address": "37 Summit Ave",
    "parcel_id": "085-53-00",
    "owner1": "KIM, ET AL, PETER",
    "owner2": "",
    "current_taxes": 19371.27,
    "new_taxes_no_override": 20208.11,
    "override_total_1": 20781.5,
    "override_increase_1": 573.39
  },
  {
    "#": "38 Summit Ave, Unit 4 (090-08-15)",
    "$": 720400,
    "address": "38 Summit Ave, Unit 4",
    "parcel_id": "090-08-15",
    "owner1": "KOFMAN LIFE ESTATE, RIMMA",
    "owner2": "",
    "current_taxes": 3741.96,
    "new_taxes_no_override": 3903.61,
    "override_total_1": 4014.37,
    "override_increase_1": 110.76
  },
  {
    "#": "38 Summit Ave, Unit 5 (090-08-16)",
    "$": 737700,
    "address": "38 Summit Ave, Unit 5",
    "parcel_id": "090-08-16",
    "owner1": "DALEY, MARK S",
    "owner2": "CHANG, JULIE Y",
    "current_taxes": 3919.11,
    "new_taxes_no_override": 4088.42,
    "override_total_1": 4204.42,
    "override_increase_1": 116.01
  },
  {
    "#": "38 Summit Ave, Unit 6 (090-08-17)",
    "$": 730600,
    "address": "38 Summit Ave, Unit 6",
    "parcel_id": "090-08-17",
    "owner1": "FELDMAN, LEIGH A",
    "owner2": "",
    "current_taxes": 3846.41,
    "new_taxes_no_override": 4012.57,
    "override_total_1": 4126.43,
    "override_increase_1": 113.85
  },
  {
    "#": "41 Summit Ave, Unit 41 (085-54-01)",
    "$": 2179200,
    "address": "41 Summit Ave, Unit 41",
    "parcel_id": "085-54-01",
    "owner1": "CYPEN, SCOTT & LINDSEY",
    "owner2": "",
    "current_taxes": 22315.01,
    "new_taxes_no_override": 23279.02,
    "override_total_1": 23939.54,
    "override_increase_1": 660.52
  },
  {
    "#": "41 Summit Ave, Unit 43 (085-54-02)",
    "$": 2646500,
    "address": "41 Summit Ave, Unit 43",
    "parcel_id": "085-54-02",
    "owner1": "CHASE, ANDREA",
    "owner2": "",
    "current_taxes": 23465.23,
    "new_taxes_no_override": 24478.93,
    "override_total_1": 25173.5,
    "override_increase_1": 694.57
  },
  {
    "#": "48 Summit Ave, Unit 1 & P9-P18 (089-33-01)",
    "$": 1173000,
    "address": "48 Summit Ave, Unit 1 & P9-P18",
    "parcel_id": "089-33-01",
    "owner1": "FINISON TR, CELESTE A",
    "owner2": "RILEY TR, JOANNE",
    "current_taxes": 8376.59,
    "new_taxes_no_override": 8738.46,
    "override_total_1": 8986.41,
    "override_increase_1": 247.95
  },
  {
    "#": "48 Summit Ave, Unit 2 & P8-P12 (089-33-02)",
    "$": 1182000,
    "address": "48 Summit Ave, Unit 2 & P8-P12",
    "parcel_id": "089-33-02",
    "owner1": "MAHNAD, FARAMARZ",
    "owner2": "TEHRANI, MARJAN A",
    "current_taxes": 12103.68,
    "new_taxes_no_override": 12626.56,
    "override_total_1": 12984.83,
    "override_increase_1": 358.27
  },
  {
    "#": "48 Summit Ave, Unit 3 (089-33-03)",
    "$": 1224600,
    "address": "48 Summit Ave, Unit 3",
    "parcel_id": "089-33-03",
    "owner1": "LANE, STEPHEN M & JACQUELINE NG",
    "owner2": "",
    "current_taxes": 8904.97,
    "new_taxes_no_override": 9289.66,
    "override_total_1": 9553.25,
    "override_increase_1": 263.59
  },
  {
    "#": "48 Summit Ave, Unit 48B (089-33-11)",
    "$": 563800,
    "address": "48 Summit Ave, Unit 48B",
    "parcel_id": "089-33-11",
    "owner1": "CHIN, MARY C",
    "owner2": "",
    "current_taxes": 5773.31,
    "new_taxes_no_override": 6022.72,
    "override_total_1": 6193.61,
    "override_increase_1": 170.89
  },
  {
    "#": "49 Summit Ave, Unit 1 & Pk-B (085-55-01)",
    "$": 1983700,
    "address": "49 Summit Ave, Unit 1 & Pk-B",
    "parcel_id": "085-55-01",
    "owner1": "TSAI, KELLEE SING",
    "owner2": "BOOKHART, DAVIS BOYD",
    "current_taxes": 20313.09,
    "new_taxes_no_override": 21190.62,
    "override_total_1": 21791.88,
    "override_increase_1": 601.27
  },
  {
    "#": "49 Summit Ave, Unit 2 & Pk-A (085-55-02)",
    "$": 2247900,
    "address": "49 Summit Ave, Unit 2 & Pk-A",
    "parcel_id": "085-55-02",
    "owner1": "GERTLER, NICHOLAS B",
    "owner2": "",
    "current_taxes": 19383.56,
    "new_taxes_no_override": 20220.93,
    "override_total_1": 20794.68,
    "override_increase_1": 573.75
  },
  {
    "#": "50 Summit Ave, Unit 1 & P1 P5 (089-33-05)",
    "$": 1259600,
    "address": "50 Summit Ave, Unit 1 & P1 P5",
    "parcel_id": "089-33-05",
    "owner1": "CHEN, WENWU",
    "owner2": "LI, JIHONG",
    "current_taxes": 12898.3,
    "new_taxes_no_override": 13455.51,
    "override_total_1": 13837.3,
    "override_increase_1": 381.79
  },
  {
    "#": "50 Summit Ave, Unit 2 P2 P19 (089-33-06)",
    "$": 1337600,
    "address": "50 Summit Ave, Unit 2 P2 P19",
    "parcel_id": "089-33-06",
    "owner1": "PHILLIPS, DAVID F",
    "owner2": "LEVY, CARLA M",
    "current_taxes": 10062.09,
    "new_taxes_no_override": 10496.77,
    "override_total_1": 10794.61,
    "override_increase_1": 297.84
  },
  {
    "#": "50 Summit Ave, Unit 3 P3 20 (089-33-07)",
    "$": 1337600,
    "address": "50 Summit Ave, Unit 3 P3 20",
    "parcel_id": "089-33-07",
    "owner1": "TIAN TR, WENDY WENTONG",
    "owner2": "",
    "current_taxes": 10062.09,
    "new_taxes_no_override": 10496.77,
    "override_total_1": 10794.61,
    "override_increase_1": 297.84
  },
  {
    "#": "50 Summit Ave, Unit 50B & P17 (089-33-04)",
    "$": 474700,
    "address": "50 Summit Ave, Unit 50B & P17",
    "parcel_id": "089-33-04",
    "owner1": "PHLR LLC",
    "owner2": "",
    "current_taxes": 4860.93,
    "new_taxes_no_override": 5070.92,
    "override_total_1": 5214.81,
    "override_increase_1": 143.88
  },
  {
    "#": "52 Summit Ave, Unit 1 (089-33-08)",
    "$": 1153000,
    "address": "52 Summit Ave, Unit 1",
    "parcel_id": "089-33-08",
    "owner1": "SAWYER TR, JOAN HATHAWAY",
    "owner2": "",
    "current_taxes": 8171.79,
    "new_taxes_no_override": 8524.81,
    "override_total_1": 8766.7,
    "override_increase_1": 241.88
  },
  {
    "#": "52 Summit Ave, Unit 2&P7-P14 (089-33-09)",
    "$": 1243000,
    "address": "52 Summit Ave, Unit 2&P7-P14",
    "parcel_id": "089-33-09",
    "owner1": "HOLTZ, TIMOTHY G",
    "owner2": "GELMANOVA, IRINA E",
    "current_taxes": 12728.32,
    "new_taxes_no_override": 13278.18,
    "override_total_1": 13654.94,
    "override_increase_1": 376.76
  },
  {
    "#": "52 Summit Ave, Unit 3 P13 P15 (089-33-10)",
    "$": 1243000,
    "address": "52 Summit Ave, Unit 3 P13 P15",
    "parcel_id": "089-33-10",
    "owner1": "ALFANDARY-JOSEPH, SARENA",
    "owner2": "",
    "current_taxes": 12728.32,
    "new_taxes_no_override": 13278.18,
    "override_total_1": 13654.94,
    "override_increase_1": 376.76
  },
  {
    "#": "63 Summit Ave, Unit 1 (086-37-01)",
    "$": 1056300,
    "address": "63 Summit Ave, Unit 1",
    "parcel_id": "086-37-01",
    "owner1": "BLOUWOLFF, JOSHUA D & REBECCA",
    "owner2": "",
    "current_taxes": 7181.58,
    "new_taxes_no_override": 7491.82,
    "override_total_1": 7704.4,
    "override_increase_1": 212.57
  },
  {
    "#": "63 Summit Ave, Unit 2 (086-37-02)",
    "$": 1370900,
    "address": "63 Summit Ave, Unit 2",
    "parcel_id": "086-37-02",
    "owner1": "DERBER, CHARLES K",
    "owner2": "KOLESNIKOVA-DERBER, ELENA E",
    "current_taxes": 10403.08,
    "new_taxes_no_override": 10852.49,
    "override_total_1": 11160.42,
    "override_increase_1": 307.93
  },
  {
    "#": "66 Summit Ave (088-56-00)",
    "$": 3707000,
    "address": "66 Summit Ave",
    "parcel_id": "088-56-00",
    "owner1": "YANCOVITZ TR, MOLLY",
    "owner2": "",
    "current_taxes": 37959.68,
    "new_taxes_no_override": 39599.54,
    "override_total_1": 40723.14,
    "override_increase_1": 1123.61
  },
  {
    "#": "69 Summit Ave (086-38-00)",
    "$": 3921300,
    "address": "69 Summit Ave",
    "parcel_id": "086-38-00",
    "owner1": "GRON, PAUL & FARAH GANJEI",
    "owner2": "",
    "current_taxes": 36519.18,
    "new_taxes_no_override": 38096.81,
    "override_total_1": 39177.78,
    "override_increase_1": 1080.97
  },
  {
    "#": "70 Summit Ave (088-55-00)",
    "$": 1582900,
    "address": "70 Summit Ave",
    "parcel_id": "088-55-00",
    "owner1": "AMIRIAN, THOMAS T JR  & ADRIANNE",
    "owner2": "",
    "current_taxes": 12573.96,
    "new_taxes_no_override": 13117.16,
    "override_total_1": 13489.34,
    "override_increase_1": 372.19
  },
  {
    "#": "72 Summit Ave (088-54-01)",
    "$": 1923000,
    "address": "72 Summit Ave",
    "parcel_id": "088-54-01",
    "owner1": "GALATIS, TRS, FRANCES J",
    "owner2": "",
    "current_taxes": 19691.52,
    "new_taxes_no_override": 20542.19,
    "override_total_1": 21125.06,
    "override_increase_1": 582.87
  },
  {
    "#": "75 Summit Ave (086-39-00)",
    "$": 2381600,
    "address": "75 Summit Ave",
    "parcel_id": "086-39-00",
    "owner1": "OLSON, DAVID C & SYDNEY R",
    "owner2": "",
    "current_taxes": 20752.65,
    "new_taxes_no_override": 21649.16,
    "override_total_1": 22263.44,
    "override_increase_1": 614.28
  },
  {
    "#": "76 Summit Ave (088-54-00)",
    "$": 2353100,
    "address": "76 Summit Ave",
    "parcel_id": "088-54-00",
    "owner1": "MARSHALL TRS, GAD ASHER",
    "owner2": "FISCHER, SHIRA HANNAH",
    "current_taxes": 20460.81,
    "new_taxes_no_override": 21344.72,
    "override_total_1": 21950.36,
    "override_increase_1": 605.64
  },
  {
    "#": "80 Summit Ave, Unit 80& P4 5 6 (088-53-01)",
    "$": 1906100,
    "address": "80 Summit Ave, Unit 80& P4 5 6",
    "parcel_id": "088-53-01",
    "owner1": "PARRY, MICHELLE",
    "owner2": "",
    "current_taxes": 15883.53,
    "new_taxes_no_override": 16569.7,
    "override_total_1": 17039.85,
    "override_increase_1": 470.15
  },
  {
    "#": "80 Summit Ave, Unit 82&G1-2 P3 (088-53-02)",
    "$": 1934300,
    "address": "80 Summit Ave, Unit 82&G1-2 P3",
    "parcel_id": "088-53-02",
    "owner1": "KALOGEROPOULOS, GEORGE",
    "owner2": "PRYNKO, NATALIE",
    "current_taxes": 19807.23,
    "new_taxes_no_override": 20662.9,
    "override_total_1": 21249.2,
    "override_increase_1": 586.29
  },
  {
    "#": "81 Summit Ave (086-40-00)",
    "$": 4463300,
    "address": "81 Summit Ave",
    "parcel_id": "086-40-00",
    "owner1": "LISKER, EDUARDO SVERDLIN",
    "owner2": "SNIDER, ANNE KANE",
    "current_taxes": 45704.19,
    "new_taxes_no_override": 47678.61,
    "override_total_1": 49031.46,
    "override_increase_1": 1352.84
  },
  {
    "#": "84 Summit Ave (088-52-00)",
    "$": 2725500,
    "address": "84 Summit Ave",
    "parcel_id": "088-52-00",
    "owner1": "DOYLE TR, PAMELA S & JAMES P",
    "owner2": "",
    "current_taxes": 24274.19,
    "new_taxes_no_override": 25322.84,
    "override_total_1": 26041.35,
    "override_increase_1": 718.52
  },
  {
    "#": "87 Summit Ave (086-41-00)",
    "$": 4471700,
    "address": "87 Summit Ave",
    "parcel_id": "086-41-00",
    "owner1": "MEHRA, SAAHIL",
    "owner2": "VENKATESH, HUMSA SRINIDI",
    "current_taxes": 45790.21,
    "new_taxes_no_override": 47768.35,
    "override_total_1": 49123.74,
    "override_increase_1": 1355.39
  },
  {
    "#": "90 Summit Ave (088-51-00)",
    "$": 2049800,
    "address": "90 Summit Ave",
    "parcel_id": "088-51-00",
    "owner1": "LIBERMAN TR, DAVID",
    "owner2": "",
    "current_taxes": 20989.95,
    "new_taxes_no_override": 21896.72,
    "override_total_1": 22518.02,
    "override_increase_1": 621.3
  },
  {
    "#": "93 Summit Ave (086-42-00)",
    "$": 2027500,
    "address": "93 Summit Ave",
    "parcel_id": "086-42-00",
    "owner1": "SAINES, CATHERINE W PHILIP W",
    "owner2": "",
    "current_taxes": 17126.67,
    "new_taxes_no_override": 17866.54,
    "override_total_1": 18373.49,
    "override_increase_1": 506.95
  },
  {
    "#": "100 Summit Ave (088-50-00)",
    "$": 2354000,
    "address": "100 Summit Ave",
    "parcel_id": "088-50-00",
    "owner1": "BURSTEIN, ALON & SHOSHANA KRAKOWSKI",
    "owner2": "",
    "current_taxes": 24104.96,
    "new_taxes_no_override": 25146.29,
    "override_total_1": 25859.8,
    "override_increase_1": 713.51
  },
  {
    "#": "101 Summit Ave, Unit A & P-4 (086-43-05)",
    "$": 1081200,
    "address": "101 Summit Ave, Unit A & P-4",
    "parcel_id": "086-43-05",
    "owner1": "WEITZMAN, LOUIS M",
    "owner2": "SWACK, TERRY L",
    "current_taxes": 7436.55,
    "new_taxes_no_override": 7757.81,
    "override_total_1": 7977.93,
    "override_increase_1": 220.12
  },
  {
    "#": "101 Summit Ave, Unit B & P-1 (086-43-01)",
    "$": 1142300,
    "address": "101 Summit Ave, Unit B & P-1",
    "parcel_id": "086-43-01",
    "owner1": "FIALKOVSKAYA, EKATERINA",
    "owner2": "",
    "current_taxes": 8062.22,
    "new_taxes_no_override": 8410.51,
    "override_total_1": 8649.15,
    "override_increase_1": 238.64
  },
  {
    "#": "101 Summit Ave, Unit C (086-43-02)",
    "$": 1177200,
    "address": "101 Summit Ave, Unit C",
    "parcel_id": "086-43-02",
    "owner1": "REQUADT, ELISE",
    "owner2": "",
    "current_taxes": 8419.59,
    "new_taxes_no_override": 8783.32,
    "override_total_1": 9032.54,
    "override_increase_1": 249.22
  },
  {
    "#": "101 Summit Ave, Unit D & P3 (086-43-03)",
    "$": 1131400,
    "address": "101 Summit Ave, Unit D & P3",
    "parcel_id": "086-43-03",
    "owner1": "MCGINITY TR, KEREN R",
    "owner2": "",
    "current_taxes": 7950.6,
    "new_taxes_no_override": 8294.07,
    "override_total_1": 8529.4,
    "override_increase_1": 235.34
  },
  {
    "#": "101 Summit Ave, Unit E & Pk Sp (086-43-04)",
    "$": 811700,
    "address": "101 Summit Ave, Unit E & Pk Sp",
    "parcel_id": "086-43-04",
    "owner1": "HEMPHILL TRS, GARY A",
    "owner2": "BUI, HIEP XUAN",
    "current_taxes": 4676.87,
    "new_taxes_no_override": 4878.91,
    "override_total_1": 5017.35,
    "override_increase_1": 138.44
  },
  {
    "#": "104 Summit Ave (088-49-00)",
    "$": 1923900,
    "address": "104 Summit Ave",
    "parcel_id": "088-49-00",
    "owner1": "GILBERT, RODERIC K & CYNTHIA K",
    "owner2": "",
    "current_taxes": 16065.8,
    "new_taxes_no_override": 16759.84,
    "override_total_1": 17235.39,
    "override_increase_1": 475.55
  },
  {
    "#": "112 Summit Ave, Unit 1 (087-01-01)",
    "$": 1183300,
    "address": "112 Summit Ave, Unit 1",
    "parcel_id": "087-01-01",
    "owner1": "JOSLYN, MATTHEW",
    "owner2": "MASUDA, KAZUYO",
    "current_taxes": 8482.06,
    "new_taxes_no_override": 8848.48,
    "override_total_1": 9099.55,
    "override_increase_1": 251.07
  },
  {
    "#": "113 Summit Ave (086B-24-25)",
    "$": 1892500,
    "address": "113 Summit Ave",
    "parcel_id": "086B-24-25",
    "owner1": "MANDELL, RICHARD",
    "owner2": "GRAY, MARTHA",
    "current_taxes": 15744.27,
    "new_taxes_no_override": 16424.42,
    "override_total_1": 16890.45,
    "override_increase_1": 466.03
  },
  {
    "#": "119 Summit Ave (086B-26-00)",
    "$": 2583300,
    "address": "119 Summit Ave",
    "parcel_id": "086B-26-00",
    "owner1": "ZHU, SHANGWEI",
    "owner2": "",
    "current_taxes": 26452.99,
    "new_taxes_no_override": 27595.76,
    "override_total_1": 28378.77,
    "override_increase_1": 783.01
  },
  {
    "#": "121 Summit Ave (086B-27-00)",
    "$": 1858600,
    "address": "121 Summit Ave",
    "parcel_id": "086B-27-00",
    "owner1": "LECCESE, MARK A",
    "owner2": "REGAN, MEREDITH M",
    "current_taxes": 15397.13,
    "new_taxes_no_override": 16062.29,
    "override_total_1": 16518.04,
    "override_increase_1": 455.76
  },
  {
    "#": "122 Summit Ave (087-25-00)",
    "$": 2136000,
    "address": "122 Summit Ave",
    "parcel_id": "087-25-00",
    "owner1": "ADLER TR, AARON M",
    "owner2": "",
    "current_taxes": 21872.64,
    "new_taxes_no_override": 22817.54,
    "override_total_1": 23464.97,
    "override_increase_1": 647.43
  },
  {
    "#": "126 Summit Ave (087-24-00)",
    "$": 2251100,
    "address": "126 Summit Ave",
    "parcel_id": "087-24-00",
    "owner1": "126-128 SUMMIT AVENUE LLC",
    "owner2": "",
    "current_taxes": 23051.26,
    "new_taxes_no_override": 24047.07,
    "override_total_1": 24729.39,
    "override_increase_1": 682.32
  },
  {
    "#": "127 Summit Ave (086B-28-00)",
    "$": 1712900,
    "address": "127 Summit Ave",
    "parcel_id": "086B-28-00",
    "owner1": "FAIR, TIMOTHY J",
    "owner2": "TANG, WAN SONYA",
    "current_taxes": 17540.1,
    "new_taxes_no_override": 18297.83,
    "override_total_1": 18817.02,
    "override_increase_1": 519.19
  },
  {
    "#": "132 Summit Ave (087-23-00)",
    "$": 1813700,
    "address": "132 Summit Ave",
    "parcel_id": "087-23-00",
    "owner1": "MINAMI, AKEMI",
    "owner2": "",
    "current_taxes": 14937.35,
    "new_taxes_no_override": 15582.64,
    "override_total_1": 16024.79,
    "override_increase_1": 442.15
  },
  {
    "#": "133 Summit Ave (086B-29-00)",
    "$": 1873500,
    "address": "133 Summit Ave",
    "parcel_id": "086B-29-00",
    "owner1": "RUSSELL, KIRSTEN SANDBERG",
    "owner2": "",
    "current_taxes": 15549.71,
    "new_taxes_no_override": 16221.46,
    "override_total_1": 16681.73,
    "override_increase_1": 460.27
  },
  {
    "#": "139 Summit Ave (086B-30-00)",
    "$": 3058800,
    "address": "139 Summit Ave",
    "parcel_id": "086B-30-00",
    "owner1": "BOER, LAURENT J & MARIA",
    "owner2": "",
    "current_taxes": 27687.18,
    "new_taxes_no_override": 28883.27,
    "override_total_1": 29702.81,
    "override_increase_1": 819.54
  },
  {
    "#": "141 Summit Ave (086B-31-32)",
    "$": 4170400,
    "address": "141 Summit Ave",
    "parcel_id": "086B-31-32",
    "owner1": "DONG, DONG",
    "owner2": "",
    "current_taxes": 42704.9,
    "new_taxes_no_override": 44549.75,
    "override_total_1": 45813.82,
    "override_increase_1": 1264.07
  },
  {
    "#": "142 Summit Ave (087-22-00)",
    "$": 3505500,
    "address": "142 Summit Ave",
    "parcel_id": "087-22-00",
    "owner1": "MEGASON, SEAN G & BERNADINE TSUNG",
    "owner2": "",
    "current_taxes": 32261.39,
    "new_taxes_no_override": 33655.08,
    "override_total_1": 34610.02,
    "override_increase_1": 954.94
  },
  {
    "#": "146 Summit Ave (087-22-01)",
    "$": 1996400,
    "address": "146 Summit Ave",
    "parcel_id": "087-22-01",
    "owner1": "NORDQUIST TR, MARIA",
    "owner2": "",
    "current_taxes": 16808.2,
    "new_taxes_no_override": 17534.31,
    "override_total_1": 18031.84,
    "override_increase_1": 497.52
  },
  {
    "#": "149 Summit Ave (086B-33-00)",
    "$": 2238100,
    "address": "149 Summit Ave",
    "parcel_id": "086B-33-00",
    "owner1": "L`ESPERANCE, RUTHE",
    "owner2": "",
    "current_taxes": 22918.14,
    "new_taxes_no_override": 23908.2,
    "override_total_1": 24586.58,
    "override_increase_1": 678.38
  },
  {
    "#": "150 Summit Ave (087-21-01)",
    "$": 2620700,
    "address": "150 Summit Ave",
    "parcel_id": "087-21-01",
    "owner1": "CHIN, ROBERT DOUGLAS",
    "owner2": "",
    "current_taxes": 23201.03,
    "new_taxes_no_override": 24203.31,
    "override_total_1": 24890.06,
    "override_increase_1": 686.75
  },
  {
    "#": "153 Summit Ave (086B-34-00)",
    "$": 1834500,
    "address": "153 Summit Ave",
    "parcel_id": "086B-34-00",
    "owner1": "BROWN, SADHNA GUPTA",
    "owner2": "",
    "current_taxes": 18785.28,
    "new_taxes_no_override": 19596.8,
    "override_total_1": 20152.85,
    "override_increase_1": 556.04
  },
  {
    "#": "155 Summit Ave (086B-35-36)",
    "$": 2321700,
    "address": "155 Summit Ave",
    "parcel_id": "086B-35-36",
    "owner1": "VADHAN TRS, SALIL P",
    "owner2": "SUN, JENNIFER T",
    "current_taxes": 20139.27,
    "new_taxes_no_override": 21009.29,
    "override_total_1": 21605.41,
    "override_increase_1": 596.12
  },
  {
    "#": "156 Summit Ave (087-21-00)",
    "$": 2197900,
    "address": "156 Summit Ave",
    "parcel_id": "087-21-00",
    "owner1": "CHIN, EUNJI JOY",
    "owner2": "",
    "current_taxes": 22506.5,
    "new_taxes_no_override": 23478.78,
    "override_total_1": 24144.97,
    "override_increase_1": 666.19
  },
  {
    "#": "159 Summit Ave (086B-37-00)",
    "$": 2287300,
    "address": "159 Summit Ave",
    "parcel_id": "086B-37-00",
    "owner1": "GIBBONS TR, CHRISTOPHER H",
    "owner2": "TEMIN, ELIZABETH S",
    "current_taxes": 19787.02,
    "new_taxes_no_override": 20641.82,
    "override_total_1": 21227.52,
    "override_increase_1": 585.7
  },
  {
    "#": "161 Summit Ave (090-09-00)",
    "$": 1655800,
    "address": "161 Summit Ave",
    "parcel_id": "090-09-00",
    "owner1": "J & W SUMMIT AVE LLC",
    "owner2": "C/O JOHN MORIARTY III",
    "current_taxes": 16955.39,
    "new_taxes_no_override": 17687.86,
    "override_total_1": 18189.74,
    "override_increase_1": 501.88
  },
  {
    "#": "162 Summit Ave (087-09-00)",
    "$": 13807800,
    "address": "162 Summit Ave",
    "parcel_id": "087-09-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O COREY HILL PARK SOUTH",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "163 Summit Ave (086B-38-00)",
    "$": 13781900,
    "address": "163 Summit Ave",
    "parcel_id": "086B-38-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O COREY HILL PARK NORTH",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "186 Summit Ave (087-20-00)",
    "$": 1531900,
    "address": "186 Summit Ave",
    "parcel_id": "087-20-00",
    "owner1": "SPEARS, RALPH",
    "owner2": "",
    "current_taxes": 12051.72,
    "new_taxes_no_override": 12572.35,
    "override_total_1": 12929.09,
    "override_increase_1": 356.73
  },
  {
    "#": "188 Summit Ave (087-19-00)",
    "$": 2052400,
    "address": "188 Summit Ave",
    "parcel_id": "087-19-00",
    "owner1": "ROTHMAN TRS, LAURENCE SIDNEY & MARINA ZIVKOVIC",
    "owner2": "",
    "current_taxes": 17381.64,
    "new_taxes_no_override": 18132.53,
    "override_total_1": 18647.02,
    "override_increase_1": 514.5
  },
  {
    "#": "189 Summit Ave (086B-39-00)",
    "$": 2071200,
    "address": "189 Summit Ave",
    "parcel_id": "086B-39-00",
    "owner1": "LANZKRON TR, CAROLYN KAHN",
    "owner2": "",
    "current_taxes": 21209.09,
    "new_taxes_no_override": 22125.32,
    "override_total_1": 22753.11,
    "override_increase_1": 627.79
  },
  {
    "#": "194 Summit Ave (087-17-18)",
    "$": 3634200,
    "address": "194 Summit Ave",
    "parcel_id": "087-17-18",
    "owner1": "NAGGAR, MORRIS M & JOYCE",
    "owner2": "",
    "current_taxes": 37214.21,
    "new_taxes_no_override": 38821.86,
    "override_total_1": 39923.4,
    "override_increase_1": 1101.54
  },
  {
    "#": "195 Summit Ave (086B-40-00)",
    "$": 2028400,
    "address": "195 Summit Ave",
    "parcel_id": "086B-40-00",
    "owner1": "PAPPAS, KATHERINE& PAMELA & KAREN",
    "owner2": "",
    "current_taxes": 20770.82,
    "new_taxes_no_override": 21668.12,
    "override_total_1": 22282.94,
    "override_increase_1": 614.82
  },
  {
    "#": "201 Summit Ave (086B-41-00)",
    "$": 2354900,
    "address": "201 Summit Ave",
    "parcel_id": "086B-41-00",
    "owner1": "BADEN, LINDSAY R",
    "owner2": "",
    "current_taxes": 20479.24,
    "new_taxes_no_override": 21363.94,
    "override_total_1": 21970.13,
    "override_increase_1": 606.19
  },
  {
    "#": "204 Summit Ave, Unit 1 (087-16-01)",
    "$": 1051200,
    "address": "204 Summit Ave, Unit 1",
    "parcel_id": "087-16-01",
    "owner1": "MEYER, STANLEY L",
    "owner2": "KORN MEYER, SHOSHANNA",
    "current_taxes": 7129.35,
    "new_taxes_no_override": 7437.34,
    "override_total_1": 7648.37,
    "override_increase_1": 211.03
  },
  {
    "#": "206 Summit Ave, Unit 2 (087-16-02)",
    "$": 1247900,
    "address": "206 Summit Ave, Unit 2",
    "parcel_id": "087-16-02",
    "owner1": "PAGE, JANICE",
    "owner2": "TSENG, JAMES",
    "current_taxes": 9143.56,
    "new_taxes_no_override": 9538.56,
    "override_total_1": 9809.21,
    "override_increase_1": 270.65
  },
  {
    "#": "208 Summit Ave, Unit 1 (087-15-01)",
    "$": 1106800,
    "address": "208 Summit Ave, Unit 1",
    "parcel_id": "087-15-01",
    "owner1": "SAEIDI, NIMA",
    "owner2": "KARIMI, PEGAH",
    "current_taxes": 7698.7,
    "new_taxes_no_override": 8031.28,
    "override_total_1": 8259.17,
    "override_increase_1": 227.88
  },
  {
    "#": "210 Summit Ave, Unit 2 (087-15-02)",
    "$": 1015000,
    "address": "210 Summit Ave, Unit 2",
    "parcel_id": "087-15-02",
    "owner1": "PERRY TR, AMI H",
    "owner2": "",
    "current_taxes": 6758.67,
    "new_taxes_no_override": 7050.64,
    "override_total_1": 7250.7,
    "override_increase_1": 200.06
  },
  {
    "#": "216 Summit Ave, Unit B-1 (087-14-12)",
    "$": 1513700,
    "address": "216 Summit Ave, Unit B-1",
    "parcel_id": "087-14-12",
    "owner1": "HULNICK TR, EILEEN R",
    "owner2": "",
    "current_taxes": 11865.35,
    "new_taxes_no_override": 12377.93,
    "override_total_1": 12729.15,
    "override_increase_1": 351.21
  },
  {
    "#": "216 Summit Ave, Unit B-2 (087-14-13)",
    "$": 1344400,
    "address": "216 Summit Ave, Unit B-2",
    "parcel_id": "087-14-13",
    "owner1": "LEE, HELEN",
    "owner2": "",
    "current_taxes": 10131.72,
    "new_taxes_no_override": 10569.41,
    "override_total_1": 10869.31,
    "override_increase_1": 299.9
  },
  {
    "#": "216 Summit Ave, Unit B-3 (087-14-14)",
    "$": 1468000,
    "address": "216 Summit Ave, Unit B-3",
    "parcel_id": "087-14-14",
    "owner1": "CONNORS TR, SHARON A",
    "owner2": "",
    "current_taxes": 15032.32,
    "new_taxes_no_override": 15681.72,
    "override_total_1": 16126.67,
    "override_increase_1": 444.96
  },
  {
    "#": "216 Summit Ave, Unit B-4 (087-14-15)",
    "$": 1378300,
    "address": "216 Summit Ave, Unit B-4",
    "parcel_id": "087-14-15",
    "owner1": "MAYSTROVSKY TRS, GENNADY DAVID & LINA M",
    "owner2": "",
    "current_taxes": 10478.86,
    "new_taxes_no_override": 10931.55,
    "override_total_1": 11241.72,
    "override_increase_1": 310.17
  },
  {
    "#": "216 Summit Ave, Unit B-5 (087-14-16)",
    "$": 1316600,
    "address": "216 Summit Ave, Unit B-5",
    "parcel_id": "087-14-16",
    "owner1": "HE, YUE",
    "owner2": "",
    "current_taxes": 9847.05,
    "new_taxes_no_override": 10272.44,
    "override_total_1": 10563.92,
    "override_increase_1": 291.47
  },
  {
    "#": "216 Summit Ave, Unit B-6 (087-14-17)",
    "$": 1161900,
    "address": "216 Summit Ave, Unit B-6",
    "parcel_id": "087-14-17",
    "owner1": "SOTO, ELIZABETH & RITA",
    "owner2": "",
    "current_taxes": 8262.92,
    "new_taxes_no_override": 8619.88,
    "override_total_1": 8864.46,
    "override_increase_1": 244.58
  },
  {
    "#": "216 Summit Ave, Unit C-1 (087-14-18)",
    "$": 1340500,
    "address": "216 Summit Ave, Unit C-1",
    "parcel_id": "087-14-18",
    "owner1": "STEIN, WILLIAM E",
    "owner2": "SOLOMON, HELENE A",
    "current_taxes": 10091.79,
    "new_taxes_no_override": 10527.76,
    "override_total_1": 10826.47,
    "override_increase_1": 298.72
  },
  {
    "#": "216 Summit Ave, Unit C-2 (087-14-19)",
    "$": 1366800,
    "address": "216 Summit Ave, Unit C-2",
    "parcel_id": "087-14-19",
    "owner1": "BRAGANZA, SHERMAN",
    "owner2": "",
    "current_taxes": 10361.1,
    "new_taxes_no_override": 10808.7,
    "override_total_1": 11115.39,
    "override_increase_1": 306.69
  },
  {
    "#": "216 Summit Ave, Unit C-3 (087-14-20)",
    "$": 1241200,
    "address": "216 Summit Ave, Unit C-3",
    "parcel_id": "087-14-20",
    "owner1": "AHN, INHYE",
    "owner2": "NOH, KYOOHYUN",
    "current_taxes": 9074.95,
    "new_taxes_no_override": 9466.99,
    "override_total_1": 9735.61,
    "override_increase_1": 268.62
  },
  {
    "#": "227 Summit Ave, Unit E101 43&20 (086B-01-23)",
    "$": 1331400,
    "address": "227 Summit Ave, Unit E101 43&20",
    "parcel_id": "086B-01-23",
    "owner1": "REDNER TRS, SIDNEY",
    "owner2": "",
    "current_taxes": 13633.54,
    "new_taxes_no_override": 14222.51,
    "override_total_1": 14626.06,
    "override_increase_1": 403.55
  },
  {
    "#": "227 Summit Ave, Unit E102 & P42 (086B-01-24)",
    "$": 773900,
    "address": "227 Summit Ave, Unit E102 & P42",
    "parcel_id": "086B-01-24",
    "owner1": "REZNIKOV, DMITRIY & ROMAN",
    "owner2": "REZNIKOVA, INNA",
    "current_taxes": 7924.74,
    "new_taxes_no_override": 8267.09,
    "override_total_1": 8501.66,
    "override_increase_1": 234.57
  },
  {
    "#": "227 Summit Ave, Unit E103 & P38 (086B-01-25)",
    "$": 1044500,
    "address": "227 Summit Ave, Unit E103 & P38",
    "parcel_id": "086B-01-25",
    "owner1": "OTCASEK TR, SUZANNE G",
    "owner2": "",
    "current_taxes": 7060.75,
    "new_taxes_no_override": 7365.77,
    "override_total_1": 7574.77,
    "override_increase_1": 209.0
  },
  {
    "#": "227 Summit Ave, Unit E104 & P27-28 (086B-01-26)",
    "$": 1073100,
    "address": "227 Summit Ave, Unit E104 & P27-28",
    "parcel_id": "086B-01-26",
    "owner1": "ARANDA, JORGE",
    "owner2": "MARTIN, CECILIA",
    "current_taxes": 7353.61,
    "new_taxes_no_override": 7671.29,
    "override_total_1": 7888.95,
    "override_increase_1": 217.67
  },
  {
    "#": "227 Summit Ave, Unit E105 33&34 (086B-01-27)",
    "$": 1331400,
    "address": "227 Summit Ave, Unit E105 33&34",
    "parcel_id": "086B-01-27",
    "owner1": "MAYO, TR, ELLEN W",
    "owner2": "",
    "current_taxes": 9998.6,
    "new_taxes_no_override": 10430.54,
    "override_total_1": 10726.5,
    "override_increase_1": 295.96
  },
  {
    "#": "227 Summit Ave, Unit E201 23&24 (086B-01-28)",
    "$": 1281100,
    "address": "227 Summit Ave, Unit E201 23&24",
    "parcel_id": "086B-01-28",
    "owner1": "GELLER, DAVID J",
    "owner2": "",
    "current_taxes": 9483.53,
    "new_taxes_no_override": 9893.22,
    "override_total_1": 10173.93,
    "override_increase_1": 280.71
  },
  {
    "#": "227 Summit Ave, Unit E202 & P41 (086B-01-29)",
    "$": 807600,
    "address": "227 Summit Ave, Unit E202 & P41",
    "parcel_id": "086B-01-29",
    "owner1": "BALASHOV, KONSTANTIN",
    "owner2": "",
    "current_taxes": 8269.82,
    "new_taxes_no_override": 8627.08,
    "override_total_1": 8871.86,
    "override_increase_1": 244.79
  },
  {
    "#": "227 Summit Ave, Unit E203 & P24 (086B-01-30)",
    "$": 1212400,
    "address": "227 Summit Ave, Unit E203 & P24",
    "parcel_id": "086B-01-30",
    "owner1": "LI, XIN",
    "owner2": "CUI, KUIYUAN",
    "current_taxes": 12414.98,
    "new_taxes_no_override": 12951.31,
    "override_total_1": 13318.79,
    "override_increase_1": 367.48
  },
  {
    "#": "227 Summit Ave, Unit E204 25&44 (086B-01-31)",
    "$": 1158400,
    "address": "227 Summit Ave, Unit E204 25&44",
    "parcel_id": "086B-01-31",
    "owner1": "GUNZBURGER, YVONNE",
    "owner2": "",
    "current_taxes": 11862.02,
    "new_taxes_no_override": 12374.46,
    "override_total_1": 12725.58,
    "override_increase_1": 351.12
  },
  {
    "#": "227 Summit Ave, Unit E205 31&32 (086B-01-32)",
    "$": 1323100,
    "address": "227 Summit Ave, Unit E205 31&32",
    "parcel_id": "086B-01-32",
    "owner1": "LAVIGNE TR, JENNY",
    "owner2": "",
    "current_taxes": 13548.54,
    "new_taxes_no_override": 14133.84,
    "override_total_1": 14534.87,
    "override_increase_1": 401.04
  },
  {
    "#": "227 Summit Ave, Unit E301 G&T10 (086B-01-33)",
    "$": 1462500,
    "address": "227 Summit Ave, Unit E301 G&T10",
    "parcel_id": "086B-01-33",
    "owner1": "GRABLER, DEBORAH",
    "owner2": "",
    "current_taxes": 11341.07,
    "new_taxes_no_override": 11831.0,
    "override_total_1": 12166.7,
    "override_increase_1": 335.7
  },
  {
    "#": "227 Summit Ave, Unit E302 & P40 (086B-01-34)",
    "$": 807600,
    "address": "227 Summit Ave, Unit E302 & P40",
    "parcel_id": "086B-01-34",
    "owner1": "ZHANG, SHUYUN",
    "owner2": "LIU, PING",
    "current_taxes": 8269.82,
    "new_taxes_no_override": 8627.08,
    "override_total_1": 8871.86,
    "override_increase_1": 244.79
  },
  {
    "#": "227 Summit Ave, Unit E303 P4&37 (086B-01-35)",
    "$": 1233600,
    "address": "227 Summit Ave, Unit E303 P4&37",
    "parcel_id": "086B-01-35",
    "owner1": "COVO, KRISTEN",
    "owner2": "C/O CHOATE HALL & STEWART, ATTN M CARRIER",
    "current_taxes": 12632.06,
    "new_taxes_no_override": 13177.76,
    "override_total_1": 13551.67,
    "override_increase_1": 373.91
  },
  {
    "#": "227 Summit Ave, Unit E304P38 46 (086B-01-36)",
    "$": 1145300,
    "address": "227 Summit Ave, Unit E304P38 46",
    "parcel_id": "086B-01-36",
    "owner1": "WEINGER TR, RONALD S",
    "owner2": "",
    "current_taxes": 11727.87,
    "new_taxes_no_override": 12234.51,
    "override_total_1": 12581.66,
    "override_increase_1": 347.14
  },
  {
    "#": "227 Summit Ave, Unit E305 G2-T2 (086B-01-37)",
    "$": 1376000,
    "address": "227 Summit Ave, Unit E305 G2-T2",
    "parcel_id": "086B-01-37",
    "owner1": "LESLIE ROAD REALTY LLC",
    "owner2": "",
    "current_taxes": 14090.24,
    "new_taxes_no_override": 14698.94,
    "override_total_1": 15116.01,
    "override_increase_1": 417.07
  },
  {
    "#": "227 Summit Ave, Unit E401 G1-T1 (086B-01-38)",
    "$": 1968400,
    "address": "227 Summit Ave, Unit E401 G1-T1",
    "parcel_id": "086B-01-38",
    "owner1": "ERHARTIC TRS, MARK V & JOANNE F",
    "owner2": "",
    "current_taxes": 16521.48,
    "new_taxes_no_override": 17235.21,
    "override_total_1": 17724.24,
    "override_increase_1": 489.04
  },
  {
    "#": "227 Summit Ave, Unit E402 & P39 (086B-01-39)",
    "$": 773800,
    "address": "227 Summit Ave, Unit E402 & P39",
    "parcel_id": "086B-01-39",
    "owner1": "SIMONIAN TR, BARTON P",
    "owner2": "",
    "current_taxes": 7923.71,
    "new_taxes_no_override": 8266.01,
    "override_total_1": 8500.56,
    "override_increase_1": 234.54
  },
  {
    "#": "227 Summit Ave, Unit E404 2Pksp (086B-01-40)",
    "$": 1185200,
    "address": "227 Summit Ave, Unit E404 2Pksp",
    "parcel_id": "086B-01-40",
    "owner1": "NIMGADE, ASHOK",
    "owner2": "",
    "current_taxes": 8501.51,
    "new_taxes_no_override": 8868.78,
    "override_total_1": 9120.42,
    "override_increase_1": 251.64
  },
  {
    "#": "227 Summit Ave, Unit E405 G7-T7 (086B-01-41)",
    "$": 1720800,
    "address": "227 Summit Ave, Unit E405 G7-T7",
    "parcel_id": "086B-01-41",
    "owner1": "SMITH TR, JUDITH ALPER",
    "owner2": "",
    "current_taxes": 13986.06,
    "new_taxes_no_override": 14590.26,
    "override_total_1": 15004.25,
    "override_increase_1": 413.99
  },
  {
    "#": "227 Summit Ave, Unit W101&P3 (086B-01-42)",
    "$": 1014300,
    "address": "227 Summit Ave, Unit W101&P3",
    "parcel_id": "086B-01-42",
    "owner1": "AGOUN, LINYAN DAI",
    "owner2": "",
    "current_taxes": 6751.5,
    "new_taxes_no_override": 7043.16,
    "override_total_1": 7243.01,
    "override_increase_1": 199.84
  },
  {
    "#": "227 Summit Ave, Unit W102 & P2 (086B-01-01)",
    "$": 1007600,
    "address": "227 Summit Ave, Unit W102 & P2",
    "parcel_id": "086B-01-01",
    "owner1": "WEISS TRS, MATTHEW & ELLEN",
    "owner2": "",
    "current_taxes": 6682.89,
    "new_taxes_no_override": 6971.59,
    "override_total_1": 7169.4,
    "override_increase_1": 197.81
  },
  {
    "#": "227 Summit Ave, Unit W103 & P5 (086B-01-02)",
    "$": 795800,
    "address": "227 Summit Ave, Unit W103 & P5",
    "parcel_id": "086B-01-02",
    "owner1": "PAVLOVA, ELENA",
    "owner2": "ZEMLYANOY, DMITRY & NIKITA",
    "current_taxes": 8148.99,
    "new_taxes_no_override": 8501.03,
    "override_total_1": 8742.24,
    "override_increase_1": 241.21
  },
  {
    "#": "227 Summit Ave, Unit W104 & P10 (086B-01-03)",
    "$": 967600,
    "address": "227 Summit Ave, Unit W104 & P10",
    "parcel_id": "086B-01-03",
    "owner1": "BADEN, LINDSEY R",
    "owner2": "FAZIO, SARA",
    "current_taxes": 9908.22,
    "new_taxes_no_override": 10336.26,
    "override_total_1": 10629.54,
    "override_increase_1": 293.28
  },
  {
    "#": "227 Summit Ave, Unit W201 (086B-01-04)",
    "$": 808700,
    "address": "227 Summit Ave, Unit W201",
    "parcel_id": "086B-01-04",
    "owner1": "ALPER, MARIAN B",
    "owner2": "",
    "current_taxes": 8281.09,
    "new_taxes_no_override": 8638.83,
    "override_total_1": 8883.95,
    "override_increase_1": 245.12
  },
  {
    "#": "227 Summit Ave, Unit W202 P6-P7 (086B-01-05)",
    "$": 1269400,
    "address": "227 Summit Ave, Unit W202 P6-P7",
    "parcel_id": "086B-01-05",
    "owner1": "BESS, JUDITH E",
    "owner2": "",
    "current_taxes": 9363.72,
    "new_taxes_no_override": 9768.23,
    "override_total_1": 10045.4,
    "override_increase_1": 277.17
  },
  {
    "#": "227 Summit Ave, Unit W203 16&17 (086B-01-06)",
    "$": 1244400,
    "address": "227 Summit Ave, Unit W203 16&17",
    "parcel_id": "086B-01-06",
    "owner1": "RZEPELA-MAGNUS, CATHERINE V",
    "owner2": "",
    "current_taxes": 9107.72,
    "new_taxes_no_override": 9501.17,
    "override_total_1": 9770.76,
    "override_increase_1": 269.59
  },
  {
    "#": "227 Summit Ave, Unit W204 & P21 (086B-01-07)",
    "$": 1004100,
    "address": "227 Summit Ave, Unit W204 & P21",
    "parcel_id": "086B-01-07",
    "owner1": "LATIMER, ERIC J",
    "owner2": "LEE, LUCIA",
    "current_taxes": 6647.05,
    "new_taxes_no_override": 6934.2,
    "override_total_1": 7130.96,
    "override_increase_1": 196.75
  },
  {
    "#": "227 Summit Ave, Unit W205 & P17 (086B-01-08)",
    "$": 1172500,
    "address": "227 Summit Ave, Unit W205 & P17",
    "parcel_id": "086B-01-08",
    "owner1": "CASA MANAGEMENT PRIVATE LLC",
    "owner2": "",
    "current_taxes": 12006.4,
    "new_taxes_no_override": 12525.08,
    "override_total_1": 12880.47,
    "override_increase_1": 355.39
  },
  {
    "#": "227 Summit Ave, Unit W206 14&15 (086B-01-09)",
    "$": 1260100,
    "address": "227 Summit Ave, Unit W206 14&15",
    "parcel_id": "086B-01-09",
    "owner1": "LIPMAN TRS, MARTIN S & JENNIFER K",
    "owner2": "",
    "current_taxes": 9268.49,
    "new_taxes_no_override": 9668.89,
    "override_total_1": 9943.24,
    "override_increase_1": 274.35
  },
  {
    "#": "227 Summit Ave, Unit W207 (086B-01-10)",
    "$": 1633100,
    "address": "227 Summit Ave, Unit W207",
    "parcel_id": "086B-01-10",
    "owner1": "NETTUNO1 LLC",
    "owner2": "",
    "current_taxes": 16722.94,
    "new_taxes_no_override": 17445.37,
    "override_total_1": 17940.37,
    "override_increase_1": 495.0
  },
  {
    "#": "227 Summit Ave, Unit W208 & P3 (086B-01-11)",
    "$": 959400,
    "address": "227 Summit Ave, Unit W208 & P3",
    "parcel_id": "086B-01-11",
    "owner1": "ADLEMAN TR, MARTHA L",
    "owner2": "",
    "current_taxes": 9824.26,
    "new_taxes_no_override": 10248.67,
    "override_total_1": 10539.47,
    "override_increase_1": 290.8
  },
  {
    "#": "227 Summit Ave, Unit W301 G&T11 (086B-01-12)",
    "$": 1506500,
    "address": "227 Summit Ave, Unit W301 G&T11",
    "parcel_id": "086B-01-12",
    "owner1": "DIMARCO, STEVEN",
    "owner2": "",
    "current_taxes": 11791.63,
    "new_taxes_no_override": 12301.03,
    "override_total_1": 12650.06,
    "override_increase_1": 349.03
  },
  {
    "#": "227 Summit Ave, Unit W302 G4-T4 (086B-01-13)",
    "$": 1612200,
    "address": "227 Summit Ave, Unit W302 G4-T4",
    "parcel_id": "086B-01-13",
    "owner1": "STOLLER, TRS, ROBERT S & GREGORY L",
    "owner2": "",
    "current_taxes": 16508.93,
    "new_taxes_no_override": 17222.12,
    "override_total_1": 17710.78,
    "override_increase_1": 488.66
  },
  {
    "#": "227 Summit Ave, Unit W303 G6-T6 (086B-01-14)",
    "$": 1960700,
    "address": "227 Summit Ave, Unit W303 G6-T6",
    "parcel_id": "086B-01-14",
    "owner1": "CZARNECKI, PETER",
    "owner2": "BIANCHI, GIADA",
    "current_taxes": 16442.63,
    "new_taxes_no_override": 17152.95,
    "override_total_1": 17639.65,
    "override_increase_1": 486.7
  },
  {
    "#": "227 Summit Ave, Unit W304&P20 (086B-01-15)",
    "$": 973700,
    "address": "227 Summit Ave, Unit W304&P20",
    "parcel_id": "086B-01-15",
    "owner1": "TOFFLING, DANIEL A",
    "owner2": "LEBOREIRO, MERCEDES",
    "current_taxes": 9970.69,
    "new_taxes_no_override": 10401.42,
    "override_total_1": 10696.56,
    "override_increase_1": 295.13
  },
  {
    "#": "227 Summit Ave, Unit W305 G5-T5 (086B-01-16)",
    "$": 1532900,
    "address": "227 Summit Ave, Unit W305 G5-T5",
    "parcel_id": "086B-01-16",
    "owner1": "ALI HASSAN LIFE ESTATE, MADIHA",
    "owner2": "",
    "current_taxes": 12061.96,
    "new_taxes_no_override": 12583.04,
    "override_total_1": 12940.07,
    "override_increase_1": 357.03
  },
  {
    "#": "227 Summit Ave, Unit W306 G8-T8 (086B-01-17)",
    "$": 1501600,
    "address": "227 Summit Ave, Unit W306 G8-T8",
    "parcel_id": "086B-01-17",
    "owner1": "KLEINMAN TR, DANIEL LEE",
    "owner2": "BERNSTEIN, SUSAN DAVID",
    "current_taxes": 15376.38,
    "new_taxes_no_override": 16040.64,
    "override_total_1": 16495.78,
    "override_increase_1": 455.14
  },
  {
    "#": "227 Summit Ave, Unit W307 11&45 (086B-01-18)",
    "$": 1099900,
    "address": "227 Summit Ave, Unit W307 11&45",
    "parcel_id": "086B-01-18",
    "owner1": "QURESHI, MOHAMMAD ASIF IQBAL",
    "owner2": "",
    "current_taxes": 11262.98,
    "new_taxes_no_override": 11749.54,
    "override_total_1": 12082.92,
    "override_increase_1": 333.38
  },
  {
    "#": "227 Summit Ave, Unit W308 G&T12 (086B-01-19)",
    "$": 1551300,
    "address": "227 Summit Ave, Unit W308 G&T12",
    "parcel_id": "086B-01-19",
    "owner1": "MANSFIELD TR, MARIA LUISA F",
    "owner2": "",
    "current_taxes": 12250.38,
    "new_taxes_no_override": 12779.6,
    "override_total_1": 13142.21,
    "override_increase_1": 362.61
  },
  {
    "#": "227 Summit Ave, Unit W309 Pk Sp (086B-01-20)",
    "$": 936500,
    "address": "227 Summit Ave, Unit W309 Pk Sp",
    "parcel_id": "086B-01-20",
    "owner1": "RUMAX PROPERTY MANAGEMENT LLC",
    "owner2": "",
    "current_taxes": 9589.76,
    "new_taxes_no_override": 10004.04,
    "override_total_1": 10287.89,
    "override_increase_1": 283.86
  },
  {
    "#": "227 Summit Ave, Unit W310 G13P9 (086B-01-21)",
    "$": 1628600,
    "address": "227 Summit Ave, Unit W310 G13P9",
    "parcel_id": "086B-01-21",
    "owner1": "MITTELMAN, MARC W & JAYSHREE S",
    "owner2": "",
    "current_taxes": 13041.93,
    "new_taxes_no_override": 13605.34,
    "override_total_1": 13991.38,
    "override_increase_1": 386.04
  },
  {
    "#": "227 Summit Ave, Unit W400 G3-T3 (086B-01-22)",
    "$": 2031100,
    "address": "227 Summit Ave, Unit W400 G3-T3",
    "parcel_id": "086B-01-22",
    "owner1": "LOEWENSTEIN TRS, JOHN I & LOUISE N",
    "owner2": "",
    "current_taxes": 17163.53,
    "new_taxes_no_override": 17904.99,
    "override_total_1": 18413.03,
    "override_increase_1": 508.04
  },
  {
    "#": "232 Summit Ave, Unit A-1 (087-14-01)",
    "$": 874100,
    "address": "232 Summit Ave, Unit A-1",
    "parcel_id": "087-14-01",
    "owner1": "LIAO, CARRIE",
    "owner2": "LIU, JET",
    "current_taxes": 5315.85,
    "new_taxes_no_override": 5545.49,
    "override_total_1": 5702.84,
    "override_increase_1": 157.35
  },
  {
    "#": "232 Summit Ave, Unit A-10 (087-14-10)",
    "$": 2000800,
    "address": "232 Summit Ave, Unit A-10",
    "parcel_id": "087-14-10",
    "owner1": "CEDERBAUM TRS, FELLA",
    "owner2": "",
    "current_taxes": 16853.26,
    "new_taxes_no_override": 17581.32,
    "override_total_1": 18080.18,
    "override_increase_1": 498.86
  },
  {
    "#": "232 Summit Ave, Unit A-2 (087-14-02)",
    "$": 1548100,
    "address": "232 Summit Ave, Unit A-2",
    "parcel_id": "087-14-02",
    "owner1": "LEWIS, KENNETH",
    "owner2": "ALLEN, LAURA",
    "current_taxes": 12217.61,
    "new_taxes_no_override": 12745.41,
    "override_total_1": 13107.05,
    "override_increase_1": 361.64
  },
  {
    "#": "232 Summit Ave, Unit A-3 (087-14-03)",
    "$": 1481800,
    "address": "232 Summit Ave, Unit A-3",
    "parcel_id": "087-14-03",
    "owner1": "ANDERSON TRS, CHARLES R & PAMELA R",
    "owner2": "",
    "current_taxes": 11538.7,
    "new_taxes_no_override": 12037.17,
    "override_total_1": 12378.72,
    "override_increase_1": 341.55
  },
  {
    "#": "232 Summit Ave, Unit A-4 (087-14-04)",
    "$": 1783700,
    "address": "232 Summit Ave, Unit A-4",
    "parcel_id": "087-14-04",
    "owner1": "CHANG, PETER",
    "owner2": "GISINGER, ANN K",
    "current_taxes": 14630.15,
    "new_taxes_no_override": 15262.17,
    "override_total_1": 15695.22,
    "override_increase_1": 433.05
  },
  {
    "#": "232 Summit Ave, Unit A-5 (087-14-05)",
    "$": 2074100,
    "address": "232 Summit Ave, Unit A-5",
    "parcel_id": "087-14-05",
    "owner1": "BENOVITZ, DONALD",
    "owner2": "FAGAN, MARTHA E",
    "current_taxes": 17603.85,
    "new_taxes_no_override": 18364.34,
    "override_total_1": 18885.41,
    "override_increase_1": 521.07
  },
  {
    "#": "232 Summit Ave, Unit A-6 (087-14-06)",
    "$": 1130800,
    "address": "232 Summit Ave, Unit A-6",
    "parcel_id": "087-14-06",
    "owner1": "HOFFMAN TRS, THOMAS G",
    "owner2": "PENA-TRUJILLO, MARTHA ROCIO",
    "current_taxes": 11579.39,
    "new_taxes_no_override": 12079.62,
    "override_total_1": 12422.37,
    "override_increase_1": 342.75
  },
  {
    "#": "232 Summit Ave, Unit A-7 (087-14-07)",
    "$": 2073800,
    "address": "232 Summit Ave, Unit A-7",
    "parcel_id": "087-14-07",
    "owner1": "TATALOVIC TR, JASMINA",
    "owner2": "",
    "current_taxes": 21235.71,
    "new_taxes_no_override": 22153.09,
    "override_total_1": 22781.67,
    "override_increase_1": 628.58
  },
  {
    "#": "232 Summit Ave, Unit A-8 (087-14-08)",
    "$": 1967000,
    "address": "232 Summit Ave, Unit A-8",
    "parcel_id": "087-14-08",
    "owner1": "CEDERBAUM TRS, FELLA",
    "owner2": "",
    "current_taxes": 20142.08,
    "new_taxes_no_override": 21012.22,
    "override_total_1": 21608.42,
    "override_increase_1": 596.21
  },
  {
    "#": "232 Summit Ave, Unit A-9 (087-14-09)",
    "$": 1015200,
    "address": "232 Summit Ave, Unit A-9",
    "parcel_id": "087-14-09",
    "owner1": "CEDERBAUM TRS, FELLA",
    "owner2": "",
    "current_taxes": 10395.65,
    "new_taxes_no_override": 10844.74,
    "override_total_1": 11152.45,
    "override_increase_1": 307.71
  },
  {
    "#": "244 Summit Ave (091-49-00)",
    "$": 2438300,
    "address": "244 Summit Ave",
    "parcel_id": "091-49-00",
    "owner1": "ZIERK, MARSHA K",
    "owner2": "",
    "current_taxes": 21333.26,
    "new_taxes_no_override": 22254.86,
    "override_total_1": 22886.32,
    "override_increase_1": 631.46
  },
  {
    "#": "248 Summit Ave (091-48-00)",
    "$": 2257300,
    "address": "248 Summit Ave",
    "parcel_id": "091-48-00",
    "owner1": "MACDONALD, BRADLEY S & BARBARA",
    "owner2": "",
    "current_taxes": 19479.82,
    "new_taxes_no_override": 20321.35,
    "override_total_1": 20897.95,
    "override_increase_1": 576.6
  },
  {
    "#": "249 Summit Ave (086A-08-00)",
    "$": 2113500,
    "address": "249 Summit Ave",
    "parcel_id": "086A-08-00",
    "owner1": "SMAGULA, JEFFREY A & ANGELA B",
    "owner2": "",
    "current_taxes": 18007.31,
    "new_taxes_no_override": 18785.23,
    "override_total_1": 19318.24,
    "override_increase_1": 533.02
  },
  {
    "#": "252 Summit Ave (091-47-00)",
    "$": 2282700,
    "address": "252 Summit Ave",
    "parcel_id": "091-47-00",
    "owner1": "SHATZ, MICHAEL P & LISA",
    "owner2": "",
    "current_taxes": 19739.91,
    "new_taxes_no_override": 20592.67,
    "override_total_1": 21176.98,
    "override_increase_1": 584.3
  },
  {
    "#": "255 Summit Ave (086A-09-00)",
    "$": 2087800,
    "address": "255 Summit Ave",
    "parcel_id": "086A-09-00",
    "owner1": "STRECKER TRS, ROBERT E",
    "owner2": "LARSEN, ULLA",
    "current_taxes": 17744.14,
    "new_taxes_no_override": 18510.69,
    "override_total_1": 19035.91,
    "override_increase_1": 525.23
  },
  {
    "#": "256 Summit Ave (091-46-00)",
    "$": 2316500,
    "address": "256 Summit Ave",
    "parcel_id": "091-46-00",
    "owner1": "FREEMAN TRS, ROY L & SUSAN W",
    "owner2": "",
    "current_taxes": 20086.03,
    "new_taxes_no_override": 20953.75,
    "override_total_1": 21548.29,
    "override_increase_1": 594.55
  },
  {
    "#": "260 Summit Ave (091-45-00)",
    "$": 2428600,
    "address": "260 Summit Ave",
    "parcel_id": "091-45-00",
    "owner1": "PAGE TRS, EDWARD HAMILTON JR",
    "owner2": "TRESSEL, MARILYN",
    "current_taxes": 21233.93,
    "new_taxes_no_override": 22151.24,
    "override_total_1": 22779.76,
    "override_increase_1": 628.52
  },
  {
    "#": "265 Summit Ave (086A-11-00)",
    "$": 1603400,
    "address": "265 Summit Ave",
    "parcel_id": "086A-11-00",
    "owner1": "BUCKWOLD, JONATHAN & LIA",
    "owner2": "",
    "current_taxes": 12783.88,
    "new_taxes_no_override": 13336.14,
    "override_total_1": 13714.55,
    "override_increase_1": 378.4
  },
  {
    "#": "14 Sumner Rd (252-10-02)",
    "$": 1974600,
    "address": "14 Sumner Rd",
    "parcel_id": "252-10-02",
    "owner1": "ANDRA, VENKAJI & VIJAYALAKSHMI",
    "owner2": "",
    "current_taxes": 16584.97,
    "new_taxes_no_override": 17301.44,
    "override_total_1": 17792.36,
    "override_increase_1": 490.92
  },
  {
    "#": "20 Sumner Rd (252-10-01)",
    "$": 2100800,
    "address": "20 Sumner Rd",
    "parcel_id": "252-10-01",
    "owner1": "GERMANOS TR, RAMZI NAJIB",
    "owner2": "",
    "current_taxes": 21512.19,
    "new_taxes_no_override": 22441.52,
    "override_total_1": 23078.28,
    "override_increase_1": 636.76
  },
  {
    "#": "23 Sumner Rd, Unit 1 (253-01-04)",
    "$": 1405900,
    "address": "23 Sumner Rd, Unit 1",
    "parcel_id": "253-01-04",
    "owner1": "RUDMAN, RICHARD D & KAREN G",
    "owner2": "",
    "current_taxes": 10761.48,
    "new_taxes_no_override": 11226.38,
    "override_total_1": 11544.92,
    "override_increase_1": 318.54
  },
  {
    "#": "23 Sumner Rd, Unit 2 & P1 & 2 (253-01-01)",
    "$": 1531500,
    "address": "23 Sumner Rd, Unit 2 & P1 & 2",
    "parcel_id": "253-01-01",
    "owner1": "HABERKERN, PHILLIP",
    "owner2": "DONG, DANIELLE",
    "current_taxes": 12047.63,
    "new_taxes_no_override": 12568.09,
    "override_total_1": 12924.7,
    "override_increase_1": 356.61
  },
  {
    "#": "23 Sumner Rd, Unit 3 & P3 (253-01-02)",
    "$": 1315200,
    "address": "23 Sumner Rd, Unit 3 & P3",
    "parcel_id": "253-01-02",
    "owner1": "MATSON, ERIC & CECILIA",
    "owner2": "",
    "current_taxes": 9832.71,
    "new_taxes_no_override": 10257.48,
    "override_total_1": 10548.53,
    "override_increase_1": 291.05
  },
  {
    "#": "23 Sumner Rd, Unit 4 & P5 (253-01-03)",
    "$": 1520000,
    "address": "23 Sumner Rd, Unit 4 & P5",
    "parcel_id": "253-01-03",
    "owner1": "WEISS, BARRY",
    "owner2": "ALPERT, LAURIE",
    "current_taxes": 11929.87,
    "new_taxes_no_override": 12445.24,
    "override_total_1": 12798.36,
    "override_increase_1": 353.12
  },
  {
    "#": "31 Sumner Rd (253-02-00)",
    "$": 2160700,
    "address": "31 Sumner Rd",
    "parcel_id": "253-02-00",
    "owner1": "RABINA, DANIELLE",
    "owner2": "FISCHER, JEREMY S",
    "current_taxes": 18490.63,
    "new_taxes_no_override": 19289.43,
    "override_total_1": 19836.75,
    "override_increase_1": 547.32
  },
  {
    "#": "43 Sumner Rd (192-18-01)",
    "$": 4088600,
    "address": "43 Sumner Rd",
    "parcel_id": "192-18-01",
    "owner1": "PORTER, SUSAN L",
    "owner2": "",
    "current_taxes": 38232.33,
    "new_taxes_no_override": 39883.97,
    "override_total_1": 41015.64,
    "override_increase_1": 1131.68
  },
  {
    "#": "44 Sumner Rd (231-38-01)",
    "$": 3685400,
    "address": "44 Sumner Rd",
    "parcel_id": "231-38-01",
    "owner1": "TSOKOS TRS, GEORGE C & MARIA",
    "owner2": "",
    "current_taxes": 34103.56,
    "new_taxes_no_override": 35576.83,
    "override_total_1": 36586.3,
    "override_increase_1": 1009.47
  },
  {
    "#": "50 Sumner Rd (231-37-00)",
    "$": 4156600,
    "address": "50 Sumner Rd",
    "parcel_id": "231-37-00",
    "owner1": "COOK, DAVID N & ABBEY R",
    "owner2": "",
    "current_taxes": 38928.65,
    "new_taxes_no_override": 40610.37,
    "override_total_1": 41762.66,
    "override_increase_1": 1152.29
  },
  {
    "#": "55 Sumner Rd (192-18-02)",
    "$": 2374700,
    "address": "55 Sumner Rd",
    "parcel_id": "192-18-02",
    "owner1": "SPEICHER TRS, MICHAEL D & EMILY J",
    "owner2": "",
    "current_taxes": 20681.99,
    "new_taxes_no_override": 21575.45,
    "override_total_1": 22187.64,
    "override_increase_1": 612.19
  },
  {
    "#": "59 Sumner Rd (192-19-00)",
    "$": 1441800,
    "address": "59 Sumner Rd",
    "parcel_id": "192-19-00",
    "owner1": "MENDELSOHN TR, MICHAEL A",
    "owner2": "FERRY TR, ELIZABETH M",
    "current_taxes": 11129.1,
    "new_taxes_no_override": 11609.88,
    "override_total_1": 11939.3,
    "override_increase_1": 329.42
  },
  {
    "#": "61 Sumner Rd (192-20-01)",
    "$": 2996800,
    "address": "61 Sumner Rd",
    "parcel_id": "192-20-01",
    "owner1": "PAUL TR, DAVID L",
    "owner2": "THOMPSON TR, MARGARET A",
    "current_taxes": 27052.3,
    "new_taxes_no_override": 28220.96,
    "override_total_1": 29021.71,
    "override_increase_1": 800.75
  },
  {
    "#": "64 Sumner Rd (231-36-00)",
    "$": 3860400,
    "address": "64 Sumner Rd",
    "parcel_id": "231-36-00",
    "owner1": "HYMAN TRS, ALBERT A",
    "owner2": "WALLER, SHARON J",
    "current_taxes": 35895.56,
    "new_taxes_no_override": 37446.25,
    "override_total_1": 38508.76,
    "override_increase_1": 1062.51
  },
  {
    "#": "65 Sumner Rd (192-20-00)",
    "$": 2155600,
    "address": "65 Sumner Rd",
    "parcel_id": "192-20-00",
    "owner1": "SCHMIDER, ERIC & ANGELA BAIR",
    "owner2": "",
    "current_taxes": 18438.41,
    "new_taxes_no_override": 19234.95,
    "override_total_1": 19780.73,
    "override_increase_1": 545.78
  },
  {
    "#": "71 Sumner Rd (192-21-21)",
    "$": 2297600,
    "address": "71 Sumner Rd",
    "parcel_id": "192-21-21",
    "owner1": "RUTTMAN TRS, LAWRENCE A & LOIS R",
    "owner2": "",
    "current_taxes": 19892.49,
    "new_taxes_no_override": 20751.85,
    "override_total_1": 21340.66,
    "override_increase_1": 588.82
  },
  {
    "#": "72 Sumner Rd (231-36-03)",
    "$": 2055800,
    "address": "72 Sumner Rd",
    "parcel_id": "231-36-03",
    "owner1": "PRAKASH, ASHWIN",
    "owner2": "YADAV, JYOTI",
    "current_taxes": 17416.46,
    "new_taxes_no_override": 18168.85,
    "override_total_1": 18684.38,
    "override_increase_1": 515.53
  },
  {
    "#": "75 Sumner Rd (192-01-00)",
    "$": 1960900,
    "address": "75 Sumner Rd",
    "parcel_id": "192-01-00",
    "owner1": "CAULFIELD, JOANN A & PATRICK",
    "owner2": "",
    "current_taxes": 16444.68,
    "new_taxes_no_override": 17155.09,
    "override_total_1": 17641.85,
    "override_increase_1": 486.76
  },
  {
    "#": "86 Sumner Rd (229-01-01)",
    "$": 7900,
    "address": "86 Sumner Rd",
    "parcel_id": "229-01-01",
    "owner1": "COMMONWEALTH OF MASSACHUSETTS",
    "owner2": "C/O MASS BAY TRANSIT AUTHORITY",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "101 Sumner Rd (194-01-00)",
    "$": 3302200,
    "address": "101 Sumner Rd",
    "parcel_id": "194-01-00",
    "owner1": "101 SUMNER ROAD LLC",
    "owner2": "C/O ADLER, AARON M",
    "current_taxes": 33814.53,
    "new_taxes_no_override": 35275.32,
    "override_total_1": 36276.23,
    "override_increase_1": 1000.91
  },
  {
    "#": "105 Sumner Rd (194-02-00)",
    "$": 1665100,
    "address": "105 Sumner Rd",
    "parcel_id": "194-02-00",
    "owner1": "HARAMIS ET AL, GEORGIA",
    "owner2": "C/O MAVRIKO THEODORE",
    "current_taxes": 13415.69,
    "new_taxes_no_override": 13995.25,
    "override_total_1": 14392.35,
    "override_increase_1": 397.1
  },
  {
    "#": "106 Sumner Rd (203-06-07)",
    "$": 2685300,
    "address": "106 Sumner Rd",
    "parcel_id": "203-06-07",
    "owner1": "GOLAN, TRS, DAVID E & JEFFREY W",
    "owner2": "",
    "current_taxes": 23862.54,
    "new_taxes_no_override": 24893.4,
    "override_total_1": 25599.73,
    "override_increase_1": 706.33
  },
  {
    "#": "111 Sumner Rd (194-03-00)",
    "$": 1930800,
    "address": "111 Sumner Rd",
    "parcel_id": "194-03-00",
    "owner1": "SPUNT, EMILY F & NATHAN",
    "owner2": "",
    "current_taxes": 19771.39,
    "new_taxes_no_override": 20625.51,
    "override_total_1": 21210.75,
    "override_increase_1": 585.23
  },
  {
    "#": "112 Sumner Rd (203-05-00)",
    "$": 2445700,
    "address": "112 Sumner Rd",
    "parcel_id": "203-05-00",
    "owner1": "WANG, YE",
    "owner2": "SHI, XUEQIN",
    "current_taxes": 25043.97,
    "new_taxes_no_override": 26125.87,
    "override_total_1": 26867.17,
    "override_increase_1": 741.3
  },
  {
    "#": "115 Sumner Rd (194-04-00)",
    "$": 1705400,
    "address": "115 Sumner Rd",
    "parcel_id": "194-04-00",
    "owner1": "XIE, EMILY & SHIRLEY WONG",
    "owner2": "",
    "current_taxes": 13828.36,
    "new_taxes_no_override": 14425.75,
    "override_total_1": 14835.06,
    "override_increase_1": 409.32
  },
  {
    "#": "118 Sumner Rd (203-04-00)",
    "$": 2788600,
    "address": "118 Sumner Rd",
    "parcel_id": "203-04-00",
    "owner1": "NEWMAN, MARILYN",
    "owner2": "GANONG III, WILLIAM",
    "current_taxes": 24920.33,
    "new_taxes_no_override": 25996.89,
    "override_total_1": 26734.53,
    "override_increase_1": 737.64
  },
  {
    "#": "119 Sumner Rd (194-05-00)",
    "$": 2177400,
    "address": "119 Sumner Rd",
    "parcel_id": "194-05-00",
    "owner1": "YUNG, ANTHONY M & KAREN Z GARCIA",
    "owner2": "",
    "current_taxes": 18661.64,
    "new_taxes_no_override": 19467.82,
    "override_total_1": 20020.21,
    "override_increase_1": 552.38
  },
  {
    "#": "122 Sumner Rd (203-03-00)",
    "$": 2162600,
    "address": "122 Sumner Rd",
    "parcel_id": "203-03-00",
    "owner1": "ZHANG TRS, CHONGHUI",
    "owner2": "ZHOU TRS, YIPING",
    "current_taxes": 18510.09,
    "new_taxes_no_override": 19309.73,
    "override_total_1": 19857.62,
    "override_increase_1": 547.9
  },
  {
    "#": "125 Sumner Rd, Unit 1 (194-06-01)",
    "$": 759700,
    "address": "125 Sumner Rd, Unit 1",
    "parcel_id": "194-06-01",
    "owner1": "GILARDE, KATIE L & STEVEN T",
    "owner2": "",
    "current_taxes": 7779.33,
    "new_taxes_no_override": 8115.4,
    "override_total_1": 8345.67,
    "override_increase_1": 230.27
  },
  {
    "#": "125 Sumner Rd, Unit 2 (194-06-02)",
    "$": 1196700,
    "address": "125 Sumner Rd, Unit 2",
    "parcel_id": "194-06-02",
    "owner1": "ISSNER, ROBBYN",
    "owner2": "",
    "current_taxes": 8619.27,
    "new_taxes_no_override": 8991.62,
    "override_total_1": 9246.75,
    "override_increase_1": 255.13
  },
  {
    "#": "127 Sumner Rd, Unit 1 (194-07-02)",
    "$": 912900,
    "address": "127 Sumner Rd, Unit 1",
    "parcel_id": "194-07-02",
    "owner1": "SHARMA, BANDANA & CHANDAN",
    "owner2": "",
    "current_taxes": 5713.16,
    "new_taxes_no_override": 5959.97,
    "override_total_1": 6129.08,
    "override_increase_1": 169.11
  },
  {
    "#": "127 Sumner Rd, Unit 2 (194-07-01)",
    "$": 932200,
    "address": "127 Sumner Rd, Unit 2",
    "parcel_id": "194-07-01",
    "owner1": "WOODWORTH, CAROL P",
    "owner2": "WULP, JONATHAN C",
    "current_taxes": 5910.79,
    "new_taxes_no_override": 6166.14,
    "override_total_1": 6341.1,
    "override_increase_1": 174.96
  },
  {
    "#": "130 Sumner Rd, Unit 1 (203-02-02)",
    "$": 1054400,
    "address": "130 Sumner Rd, Unit 1",
    "parcel_id": "203-02-02",
    "owner1": "MORGON, DAVID",
    "owner2": "RAO, SOWMYA",
    "current_taxes": 7162.12,
    "new_taxes_no_override": 7471.52,
    "override_total_1": 7683.52,
    "override_increase_1": 212.0
  },
  {
    "#": "130 Sumner Rd, Unit 2 (203-02-01)",
    "$": 1287500,
    "address": "130 Sumner Rd, Unit 2",
    "parcel_id": "203-02-01",
    "owner1": "SILVERMAN, J G",
    "owner2": "WOODHOUSE, G P",
    "current_taxes": 9549.07,
    "new_taxes_no_override": 9961.59,
    "override_total_1": 10244.24,
    "override_increase_1": 282.65
  },
  {
    "#": "131 Sumner Rd (194-08-00)",
    "$": 1800500,
    "address": "131 Sumner Rd",
    "parcel_id": "194-08-00",
    "owner1": "VERGETIS TR, GEORGE",
    "owner2": "",
    "current_taxes": 18437.12,
    "new_taxes_no_override": 19233.6,
    "override_total_1": 19779.34,
    "override_increase_1": 545.74
  },
  {
    "#": "135 Sumner Rd (194-09-00)",
    "$": 2162900,
    "address": "135 Sumner Rd",
    "parcel_id": "194-09-00",
    "owner1": "JENNESS, KEVIN M & REBECCA A",
    "owner2": "",
    "current_taxes": 22148.1,
    "new_taxes_no_override": 23104.9,
    "override_total_1": 23760.48,
    "override_increase_1": 655.58
  },
  {
    "#": "140 Sumner Rd, Unit 1 (203-01-01)",
    "$": 1759100,
    "address": "140 Sumner Rd, Unit 1",
    "parcel_id": "203-01-01",
    "owner1": "140 SUMNER ROAD UNIT 1 LLC",
    "owner2": "C/O WILCHINS COSENTINO & NOVINS LLP",
    "current_taxes": 18013.18,
    "new_taxes_no_override": 18791.35,
    "override_total_1": 19324.54,
    "override_increase_1": 533.19
  },
  {
    "#": "140 Sumner Rd, Unit 2 (203-01-02)",
    "$": 1823300,
    "address": "140 Sumner Rd, Unit 2",
    "parcel_id": "203-01-02",
    "owner1": "CHANG, ALEXANDER",
    "owner2": "KUO, TZU-YUN",
    "current_taxes": 15035.66,
    "new_taxes_no_override": 15685.2,
    "override_total_1": 16130.26,
    "override_increase_1": 445.06
  },
  {
    "#": "2 Tabor Pl (149-17-00)",
    "$": 1600900,
    "address": "2 Tabor Pl",
    "parcel_id": "149-17-00",
    "owner1": "NIR, REUTH",
    "owner2": "MINCHENBERG, SCOTT B",
    "current_taxes": 12758.28,
    "new_taxes_no_override": 13309.44,
    "override_total_1": 13687.08,
    "override_increase_1": 377.65
  },
  {
    "#": "4 Tabor Pl (149-16-00)",
    "$": 1339700,
    "address": "4 Tabor Pl",
    "parcel_id": "149-16-00",
    "owner1": "KHEYFETS, ALEKSANDR & IRINA",
    "owner2": "",
    "current_taxes": 10083.59,
    "new_taxes_no_override": 10519.2,
    "override_total_1": 10817.68,
    "override_increase_1": 298.47
  },
  {
    "#": "6 Tabor Pl (149-15-00)",
    "$": 1347700,
    "address": "6 Tabor Pl",
    "parcel_id": "149-15-00",
    "owner1": "DIAMOND, KAROLA & KATHLEEN",
    "owner2": "",
    "current_taxes": 10165.51,
    "new_taxes_no_override": 10604.66,
    "override_total_1": 10905.56,
    "override_increase_1": 300.9
  },
  {
    "#": "8 Tabor Pl (149-14-00)",
    "$": 1369500,
    "address": "8 Tabor Pl",
    "parcel_id": "149-14-00",
    "owner1": "KALB, PETER R",
    "owner2": "ROLAND, JESSICA K",
    "current_taxes": 10388.75,
    "new_taxes_no_override": 10837.54,
    "override_total_1": 11145.05,
    "override_increase_1": 307.51
  },
  {
    "#": "10 Tabor Pl (149-13-00)",
    "$": 1247300,
    "address": "10 Tabor Pl",
    "parcel_id": "149-13-00",
    "owner1": "HETRICK, KENTON J & AMANDA I",
    "owner2": "",
    "current_taxes": 9137.42,
    "new_taxes_no_override": 9532.16,
    "override_total_1": 9802.62,
    "override_increase_1": 270.47
  },
  {
    "#": "11 Tabor Pl (149-04-00)",
    "$": 1688600,
    "address": "11 Tabor Pl",
    "parcel_id": "149-04-00",
    "owner1": "CHEUNG, JENNY LUO & KWOK W",
    "owner2": "",
    "current_taxes": 13656.33,
    "new_taxes_no_override": 14246.28,
    "override_total_1": 14650.51,
    "override_increase_1": 404.23
  },
  {
    "#": "12 Tabor Pl (149-12-00)",
    "$": 1486300,
    "address": "12 Tabor Pl",
    "parcel_id": "149-12-00",
    "owner1": "VOGT, MARISSA",
    "owner2": "MCGRAW-HERDEG, MICHAEL",
    "current_taxes": 11584.78,
    "new_taxes_no_override": 12085.24,
    "override_total_1": 12428.15,
    "override_increase_1": 342.91
  },
  {
    "#": "13 Tabor Pl (149-05-00)",
    "$": 1667200,
    "address": "13 Tabor Pl",
    "parcel_id": "149-05-00",
    "owner1": "TAN, TR, FIONA",
    "owner2": "",
    "current_taxes": 17072.13,
    "new_taxes_no_override": 17809.65,
    "override_total_1": 18314.98,
    "override_increase_1": 505.34
  },
  {
    "#": "14 Tabor Pl (149-11-00)",
    "$": 1449500,
    "address": "14 Tabor Pl",
    "parcel_id": "149-11-00",
    "owner1": "POURQUIE, OLIVIER",
    "owner2": "",
    "current_taxes": 11207.95,
    "new_taxes_no_override": 11692.13,
    "override_total_1": 12023.89,
    "override_increase_1": 331.76
  },
  {
    "#": "15 Tabor Pl (149-06-00)",
    "$": 1852300,
    "address": "15 Tabor Pl",
    "parcel_id": "149-06-00",
    "owner1": "FUNG, MICHAEL K",
    "owner2": "YAN, SUSAN",
    "current_taxes": 18967.55,
    "new_taxes_no_override": 19786.95,
    "override_total_1": 20348.39,
    "override_increase_1": 561.44
  },
  {
    "#": "16 Tabor Pl (149-10-00)",
    "$": 1382600,
    "address": "16 Tabor Pl",
    "parcel_id": "149-10-00",
    "owner1": "MOLLOY TRS, JAMES F & ALEXANDRA G",
    "owner2": "",
    "current_taxes": 10522.89,
    "new_taxes_no_override": 10977.48,
    "override_total_1": 11288.96,
    "override_increase_1": 311.48
  },
  {
    "#": "17 Tabor Pl (149-07-00)",
    "$": 1892900,
    "address": "17 Tabor Pl",
    "parcel_id": "149-07-00",
    "owner1": "WHEELER, SUSAN C",
    "owner2": "",
    "current_taxes": 19383.3,
    "new_taxes_no_override": 20220.66,
    "override_total_1": 20794.4,
    "override_increase_1": 573.75
  },
  {
    "#": "18 Tabor Pl (149-09-00)",
    "$": 1603100,
    "address": "18 Tabor Pl",
    "parcel_id": "149-09-00",
    "owner1": "ROTH, EMILY",
    "owner2": "",
    "current_taxes": 12780.81,
    "new_taxes_no_override": 13332.94,
    "override_total_1": 13711.25,
    "override_increase_1": 378.31
  },
  {
    "#": "19 Tabor Pl (149-08-00)",
    "$": 1678700,
    "address": "19 Tabor Pl",
    "parcel_id": "149-08-00",
    "owner1": "XIA, JIN",
    "owner2": "",
    "current_taxes": 17189.89,
    "new_taxes_no_override": 17932.49,
    "override_total_1": 18441.31,
    "override_increase_1": 508.82
  },
  {
    "#": "4 Tappan St (194-13-00)",
    "$": 9500,
    "address": "4 Tappan St",
    "parcel_id": "194-13-00",
    "owner1": "COMMONWEALTH OF MASSACHUSETTS",
    "owner2": "C/O MASS BAY TRANSIT AUTHORITY",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "22 Tappan St (191-01-01)",
    "$": 67276300,
    "address": "22 Tappan St",
    "parcel_id": "191-01-01",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O HIGH SCHOOL EXTENSION",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "24 Tappan St (194-12-00)",
    "$": 14100,
    "address": "24 Tappan St",
    "parcel_id": "194-12-00",
    "owner1": "COMMONWEALTH OF MASSACHUSETTS",
    "owner2": "C/O MASS BAY TRANSIT AUTHORITY",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "46 Tappan St (194-10-11)",
    "$": 38488500,
    "address": "46 Tappan St",
    "parcel_id": "194-10-11",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O UNIFIED ARTS BLDG/GYM/POOL",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "88 Tappan St (203-14-00)",
    "$": 2154500,
    "address": "88 Tappan St",
    "parcel_id": "203-14-00",
    "owner1": "VISHNER, IRA & SUSAN G",
    "owner2": "",
    "current_taxes": 18427.15,
    "new_taxes_no_override": 19223.2,
    "override_total_1": 19768.65,
    "override_increase_1": 545.44
  },
  {
    "#": "94 Tappan St (203-13-00)",
    "$": 2824400,
    "address": "94 Tappan St",
    "parcel_id": "203-13-00",
    "owner1": "WALPERT, ELLEN",
    "owner2": "KOBRAN, CHRISTOPHER",
    "current_taxes": 25286.92,
    "new_taxes_no_override": 26379.31,
    "override_total_1": 27127.81,
    "override_increase_1": 748.49
  },
  {
    "#": "98 Tappan St (203-12-01)",
    "$": 1826000,
    "address": "98 Tappan St",
    "parcel_id": "203-12-01",
    "owner1": "LEE TRS, FRANCES SAU KUEN & SAU YING",
    "owner2": "",
    "current_taxes": 15063.31,
    "new_taxes_no_override": 15714.04,
    "override_total_1": 16159.92,
    "override_increase_1": 445.87
  },
  {
    "#": "100 Tappan St (203-12-00)",
    "$": 2696100,
    "address": "100 Tappan St",
    "parcel_id": "203-12-00",
    "owner1": "WEINSTEIN, MARK",
    "owner2": "BLUMBERG, NANCY",
    "current_taxes": 23973.13,
    "new_taxes_no_override": 25008.77,
    "override_total_1": 25718.37,
    "override_increase_1": 709.6
  },
  {
    "#": "108 Tappan St, Unit 108 (203-11-01)",
    "$": 1055800,
    "address": "108 Tappan St, Unit 108",
    "parcel_id": "203-11-01",
    "owner1": "ADINI, AVNER & IRIT",
    "owner2": "",
    "current_taxes": 10811.39,
    "new_taxes_no_override": 11278.44,
    "override_total_1": 11598.46,
    "override_increase_1": 320.02
  },
  {
    "#": "108 Tappan St, Unit 110 (203-11-02)",
    "$": 1257400,
    "address": "108 Tappan St, Unit 110",
    "parcel_id": "203-11-02",
    "owner1": "ADINI, AVNER & IRIT",
    "owner2": "",
    "current_taxes": 9240.84,
    "new_taxes_no_override": 9640.04,
    "override_total_1": 9913.57,
    "override_increase_1": 273.53
  },
  {
    "#": "109 Tappan St (205-29-00)",
    "$": 1872200,
    "address": "109 Tappan St",
    "parcel_id": "205-29-00",
    "owner1": "SADOW TRS, JEROME & CATHERINE",
    "owner2": "",
    "current_taxes": 15536.39,
    "new_taxes_no_override": 16207.56,
    "override_total_1": 16667.44,
    "override_increase_1": 459.88
  },
  {
    "#": "115 Tappan St (205-01-00)",
    "$": 2088100,
    "address": "115 Tappan St",
    "parcel_id": "205-01-00",
    "owner1": "CONQUEST TRS, ARTHUR W III & VIRGINIA B",
    "owner2": "",
    "current_taxes": 17747.21,
    "new_taxes_no_override": 18513.89,
    "override_total_1": 19039.21,
    "override_increase_1": 525.32
  },
  {
    "#": "116 Tappan St (203-10-00)",
    "$": 2146800,
    "address": "116 Tappan St",
    "parcel_id": "203-10-00",
    "owner1": "MURREN TR, LAWRENCE P JR",
    "owner2": "",
    "current_taxes": 18348.3,
    "new_taxes_no_override": 19140.95,
    "override_total_1": 19684.06,
    "override_increase_1": 543.11
  },
  {
    "#": "125 Tappan St (204-01-00)",
    "$": 2892900,
    "address": "125 Tappan St",
    "parcel_id": "204-01-00",
    "owner1": "SALWASSER, ZACHERY T & REBEKAH K",
    "owner2": "",
    "current_taxes": 29623.3,
    "new_taxes_no_override": 30903.03,
    "override_total_1": 31779.88,
    "override_increase_1": 876.85
  },
  {
    "#": "138 Tappan St (228-30-00)",
    "$": 2260600,
    "address": "138 Tappan St",
    "parcel_id": "228-30-00",
    "owner1": "PLATZ, ELKE",
    "owner2": "",
    "current_taxes": 19513.61,
    "new_taxes_no_override": 20356.6,
    "override_total_1": 20934.2,
    "override_increase_1": 577.6
  },
  {
    "#": "143 Tappan St (204-02-01)",
    "$": 5113400,
    "address": "143 Tappan St",
    "parcel_id": "204-02-01",
    "owner1": "ABOUHAMAD, JEAN N & RANIA",
    "owner2": "",
    "current_taxes": 48726.28,
    "new_taxes_no_override": 50831.26,
    "override_total_1": 52273.55,
    "override_increase_1": 1442.3
  },
  {
    "#": "145 Tappan St (204-02-02)",
    "$": 2569200,
    "address": "145 Tappan St",
    "parcel_id": "204-02-02",
    "owner1": "ABOUHAMAD, JEAN N & RANIA",
    "owner2": "",
    "current_taxes": 26308.61,
    "new_taxes_no_override": 27445.14,
    "override_total_1": 28223.88,
    "override_increase_1": 778.73
  },
  {
    "#": "146 Tappan St (228-29-00)",
    "$": 3100400,
    "address": "146 Tappan St",
    "parcel_id": "228-29-00",
    "owner1": "BIGNAMI, ADRIAN A & PETRA",
    "owner2": "",
    "current_taxes": 28113.16,
    "new_taxes_no_override": 29327.65,
    "override_total_1": 30159.8,
    "override_increase_1": 832.15
  },
  {
    "#": "150 Tappan St (228-29-01)",
    "$": 3001200,
    "address": "150 Tappan St",
    "parcel_id": "228-29-01",
    "owner1": "SERRANO, MIGUEL & MARISA",
    "owner2": "",
    "current_taxes": 27097.35,
    "new_taxes_no_override": 28267.96,
    "override_total_1": 29070.04,
    "override_increase_1": 802.08
  },
  {
    "#": "151 Tappan St (204-04-00)",
    "$": 2995900,
    "address": "151 Tappan St",
    "parcel_id": "204-04-00",
    "owner1": "HYEP, IVAN & KIMBERLY",
    "owner2": "",
    "current_taxes": 27043.08,
    "new_taxes_no_override": 28211.34,
    "override_total_1": 29011.82,
    "override_increase_1": 800.48
  },
  {
    "#": "154 Tappan St (228-25-01)",
    "$": 66200,
    "address": "154 Tappan St",
    "parcel_id": "228-25-01",
    "owner1": "COMMONWEALTH OF MASSACHUSETTS",
    "owner2": "C/O MASS BAY TRANSIT AUTHORITY",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "156 Tappan St (228-28-00)",
    "$": 4926800,
    "address": "156 Tappan St",
    "parcel_id": "228-28-00",
    "owner1": "BESSLER, BARRY & MICHELLE",
    "owner2": "",
    "current_taxes": 46815.5,
    "new_taxes_no_override": 48837.93,
    "override_total_1": 50223.67,
    "override_increase_1": 1385.74
  },
  {
    "#": "162 Tappan St (228-27-00)",
    "$": 2504300,
    "address": "162 Tappan St",
    "parcel_id": "228-27-00",
    "owner1": "RUBY, JONATHAN S & JILLIAN E",
    "owner2": "",
    "current_taxes": 22009.1,
    "new_taxes_no_override": 22959.89,
    "override_total_1": 23611.36,
    "override_increase_1": 651.47
  },
  {
    "#": "163 Tappan St (204-05-00)",
    "$": 2179500,
    "address": "163 Tappan St",
    "parcel_id": "204-05-00",
    "owner1": "SHIMAN, LEON G & LAURA K",
    "owner2": "",
    "current_taxes": 18683.15,
    "new_taxes_no_override": 19490.26,
    "override_total_1": 20043.28,
    "override_increase_1": 553.02
  },
  {
    "#": "164 Tappan St (228-26-00)",
    "$": 2474500,
    "address": "164 Tappan St",
    "parcel_id": "228-26-00",
    "owner1": "ZHOU, LI",
    "owner2": "",
    "current_taxes": 21703.95,
    "new_taxes_no_override": 22641.56,
    "override_total_1": 23284.0,
    "override_increase_1": 642.44
  },
  {
    "#": "166 Tappan St (228-24-25)",
    "$": 2821600,
    "address": "166 Tappan St",
    "parcel_id": "228-24-25",
    "owner1": "REGISTER, VICTORIA C & DAVID C",
    "owner2": "",
    "current_taxes": 25258.25,
    "new_taxes_no_override": 26349.41,
    "override_total_1": 27097.05,
    "override_increase_1": 747.64
  },
  {
    "#": "168 Tappan St (228-23-00)",
    "$": 1969300,
    "address": "168 Tappan St",
    "parcel_id": "228-23-00",
    "owner1": "TRUNK, JOSEPH E",
    "owner2": "",
    "current_taxes": 16530.7,
    "new_taxes_no_override": 17244.83,
    "override_total_1": 17734.13,
    "override_increase_1": 489.31
  },
  {
    "#": "170 Tappan St (228-22-00)",
    "$": 2304700,
    "address": "170 Tappan St",
    "parcel_id": "228-22-00",
    "owner1": "MOSS TR, PHILIP I",
    "owner2": "BRADBURY, KATHARINE L",
    "current_taxes": 19965.19,
    "new_taxes_no_override": 20827.69,
    "override_total_1": 21418.66,
    "override_increase_1": 590.97
  },
  {
    "#": "176 Tappan St (228-21-01)",
    "$": 2541400,
    "address": "176 Tappan St",
    "parcel_id": "228-21-01",
    "owner1": "JACOBS, CARRIE LIN & SIEDLE RUBESH",
    "owner2": "",
    "current_taxes": 22389.0,
    "new_taxes_no_override": 23356.2,
    "override_total_1": 24018.92,
    "override_increase_1": 662.71
  },
  {
    "#": "178 Tappan St (228-21-00)",
    "$": 4289800,
    "address": "178 Tappan St",
    "parcel_id": "228-21-00",
    "owner1": "MISRA, JATIN",
    "owner2": "CORTES-GARCIA, GUADALUPE",
    "current_taxes": 40292.62,
    "new_taxes_no_override": 42033.26,
    "override_total_1": 43225.92,
    "override_increase_1": 1192.66
  },
  {
    "#": "185 Tappan St (222-20-03)",
    "$": 3841800,
    "address": "185 Tappan St",
    "parcel_id": "222-20-03",
    "owner1": "RAI, BHARTI",
    "owner2": "",
    "current_taxes": 39340.03,
    "new_taxes_no_override": 41039.52,
    "override_total_1": 42203.98,
    "override_increase_1": 1164.46
  },
  {
    "#": "186 Tappan St (228-20-00)",
    "$": 5627800,
    "address": "186 Tappan St",
    "parcel_id": "228-20-00",
    "owner1": "WEISMAN, BARRY L",
    "owner2": "FISHEL, MICHELE J",
    "current_taxes": 53993.74,
    "new_taxes_no_override": 56326.27,
    "override_total_1": 57924.48,
    "override_increase_1": 1598.21
  },
  {
    "#": "189 Tappan St (222-20-02)",
    "$": 2762200,
    "address": "189 Tappan St",
    "parcel_id": "222-20-02",
    "owner1": "GRINSTAFF, MARK W",
    "owner2": "MEYERS, FABIENNE M",
    "current_taxes": 28284.93,
    "new_taxes_no_override": 29506.84,
    "override_total_1": 30344.07,
    "override_increase_1": 837.23
  },
  {
    "#": "194 Tappan St (228-19-00)",
    "$": 4206500,
    "address": "194 Tappan St",
    "parcel_id": "228-19-00",
    "owner1": "JAJOO, KUNAL",
    "owner2": "BRACKLEY, MARGUERITE",
    "current_taxes": 39439.63,
    "new_taxes_no_override": 41143.42,
    "override_total_1": 42310.84,
    "override_increase_1": 1167.41
  },
  {
    "#": "195 Tappan St (222-21-00)",
    "$": 3590200,
    "address": "195 Tappan St",
    "parcel_id": "222-21-00",
    "owner1": "SPEAR TRS, STEVEN J & MIRIAM TROPP",
    "owner2": "",
    "current_taxes": 33128.71,
    "new_taxes_no_override": 34559.87,
    "override_total_1": 35540.48,
    "override_increase_1": 980.61
  },
  {
    "#": "200 Tappan St (228-18-00)",
    "$": 2514200,
    "address": "200 Tappan St",
    "parcel_id": "228-18-00",
    "owner1": "BERMAN, JONATHAN C & ERICA M",
    "owner2": "",
    "current_taxes": 22110.47,
    "new_taxes_no_override": 23065.64,
    "override_total_1": 23720.11,
    "override_increase_1": 654.47
  },
  {
    "#": "205 Tappan St (222-22-00)",
    "$": 2374000,
    "address": "205 Tappan St",
    "parcel_id": "222-22-00",
    "owner1": "KETCHUM TR, ADELAIDE L",
    "owner2": "",
    "current_taxes": 20674.83,
    "new_taxes_no_override": 21567.98,
    "override_total_1": 22179.96,
    "override_increase_1": 611.97
  },
  {
    "#": "210 Tappan St (228-17-00)",
    "$": 5660900,
    "address": "210 Tappan St",
    "parcel_id": "228-17-00",
    "owner1": "GUPTA TRS, ROHIT & KOMAL RAMCHANDANI",
    "owner2": "",
    "current_taxes": 54332.68,
    "new_taxes_no_override": 56679.85,
    "override_total_1": 58288.1,
    "override_increase_1": 1608.25
  },
  {
    "#": "215 Tappan St (222-23-00)",
    "$": 2777000,
    "address": "215 Tappan St",
    "parcel_id": "222-23-00",
    "owner1": "HOLLANDER, DAVE & RICKI",
    "owner2": "",
    "current_taxes": 24801.55,
    "new_taxes_no_override": 25872.98,
    "override_total_1": 26607.1,
    "override_increase_1": 734.13
  },
  {
    "#": "216 Tappan St (228-16-00)",
    "$": 5473600,
    "address": "216 Tappan St",
    "parcel_id": "228-16-00",
    "owner1": "BOBBILI TR, RAJA H R",
    "owner2": "",
    "current_taxes": 52414.73,
    "new_taxes_no_override": 54679.05,
    "override_total_1": 56230.52,
    "override_increase_1": 1551.48
  },
  {
    "#": "223 Tappan St (222-24-00)",
    "$": 2307300,
    "address": "223 Tappan St",
    "parcel_id": "222-24-00",
    "owner1": "KIM, SUNGWOO & JOAN J",
    "owner2": "",
    "current_taxes": 19991.82,
    "new_taxes_no_override": 20855.47,
    "override_total_1": 21447.22,
    "override_increase_1": 591.76
  },
  {
    "#": "224 Tappan St (228-15-00)",
    "$": 2052700,
    "address": "224 Tappan St",
    "parcel_id": "228-15-00",
    "owner1": "ADAMS, HAROLD T",
    "owner2": "DELONG, THOMAS F",
    "current_taxes": 17384.71,
    "new_taxes_no_override": 18135.73,
    "override_total_1": 18650.32,
    "override_increase_1": 514.59
  },
  {
    "#": "225 Tappan St, Unit 225 (222-25-01)",
    "$": 2150600,
    "address": "225 Tappan St, Unit 225",
    "parcel_id": "222-25-01",
    "owner1": "MEIR TR, ISRAEL",
    "owner2": "",
    "current_taxes": 18387.21,
    "new_taxes_no_override": 19181.54,
    "override_total_1": 19725.8,
    "override_increase_1": 544.26
  },
  {
    "#": "227 Tappan St, Unit 227 (222-25-02)",
    "$": 2396400,
    "address": "227 Tappan St, Unit 227",
    "parcel_id": "222-25-02",
    "owner1": "REICHL, JOHN H",
    "owner2": "MERLO, KRISTEN",
    "current_taxes": 20904.2,
    "new_taxes_no_override": 21807.26,
    "override_total_1": 22426.03,
    "override_increase_1": 618.76
  },
  {
    "#": "233 Tappan St (222-26-00)",
    "$": 2332500,
    "address": "233 Tappan St",
    "parcel_id": "222-26-00",
    "owner1": "KOPP, HARRIET & JOSHUA K",
    "owner2": "",
    "current_taxes": 23884.8,
    "new_taxes_no_override": 24916.62,
    "override_total_1": 25623.61,
    "override_increase_1": 706.99
  },
  {
    "#": "234 Tappan St (227-14-00)",
    "$": 2605300,
    "address": "234 Tappan St",
    "parcel_id": "227-14-00",
    "owner1": "SOO HOO, NELSON & KAREN",
    "owner2": "",
    "current_taxes": 23043.34,
    "new_taxes_no_override": 24038.81,
    "override_total_1": 24720.9,
    "override_increase_1": 682.08
  },
  {
    "#": "238 Tappan St, Unit 1 (227-13-01)",
    "$": 2150200,
    "address": "238 Tappan St, Unit 1",
    "parcel_id": "227-13-01",
    "owner1": "COX, DONALD & TERRELL",
    "owner2": "",
    "current_taxes": 18383.11,
    "new_taxes_no_override": 19177.26,
    "override_total_1": 19721.4,
    "override_increase_1": 544.14
  },
  {
    "#": "238 Tappan St, Unit 2 (227-13-02)",
    "$": 2195600,
    "address": "238 Tappan St, Unit 2",
    "parcel_id": "227-13-02",
    "owner1": "REIL, JON R & HOLLY C",
    "owner2": "",
    "current_taxes": 22482.94,
    "new_taxes_no_override": 23454.2,
    "override_total_1": 24119.7,
    "override_increase_1": 665.5
  },
  {
    "#": "239 Tappan St (222-27-00)",
    "$": 2449100,
    "address": "239 Tappan St",
    "parcel_id": "222-27-00",
    "owner1": "BRESLER TRS, GABRIEL E & ADRIAN",
    "owner2": "",
    "current_taxes": 21443.85,
    "new_taxes_no_override": 22370.22,
    "override_total_1": 23004.96,
    "override_increase_1": 634.74
  },
  {
    "#": "244 Tappan St (227-12-00)",
    "$": 1505200,
    "address": "244 Tappan St",
    "parcel_id": "227-12-00",
    "owner1": "COLEMAN, ALEX",
    "owner2": "",
    "current_taxes": 11778.31,
    "new_taxes_no_override": 12287.13,
    "override_total_1": 12635.77,
    "override_increase_1": 348.64
  },
  {
    "#": "245 Tappan St (222-28-00)",
    "$": 2317400,
    "address": "245 Tappan St",
    "parcel_id": "222-28-00",
    "owner1": "ZHELNOVA, MARINA",
    "owner2": "GARNITSKIY, VALERIY",
    "current_taxes": 20095.24,
    "new_taxes_no_override": 20963.35,
    "override_total_1": 21558.17,
    "override_increase_1": 594.82
  },
  {
    "#": "247 Tappan St (222-29-00)",
    "$": 2281800,
    "address": "247 Tappan St",
    "parcel_id": "222-29-00",
    "owner1": "GOLD, RICHARD L & JULIE M",
    "owner2": "",
    "current_taxes": 19730.7,
    "new_taxes_no_override": 20583.07,
    "override_total_1": 21167.09,
    "override_increase_1": 584.03
  },
  {
    "#": "250 Tappan St, Unit 250 & G-B (227-11-01)",
    "$": 1518000,
    "address": "250 Tappan St, Unit 250 & G-B",
    "parcel_id": "227-11-01",
    "owner1": "MACE, KENNETH A II",
    "owner2": "GADALETA-MACE, MONICA A",
    "current_taxes": 11909.39,
    "new_taxes_no_override": 12423.88,
    "override_total_1": 12776.39,
    "override_increase_1": 352.52
  },
  {
    "#": "252 Tappan St, Unit 252 & G-A (227-11-02)",
    "$": 1552000,
    "address": "252 Tappan St, Unit 252 & G-A",
    "parcel_id": "227-11-02",
    "owner1": "DARSA TRS, AARON A & JANICE L",
    "owner2": "",
    "current_taxes": 12257.55,
    "new_taxes_no_override": 12787.08,
    "override_total_1": 13149.9,
    "override_increase_1": 362.82
  },
  {
    "#": "254 Tappan St (227-10-00)",
    "$": 2248000,
    "address": "254 Tappan St",
    "parcel_id": "227-10-00",
    "owner1": "SNYDER LIFE ESTATE, NASON & JUDITH A",
    "owner2": "",
    "current_taxes": 19384.59,
    "new_taxes_no_override": 20222.0,
    "override_total_1": 20795.79,
    "override_increase_1": 573.78
  },
  {
    "#": "255 Tappan St (222-30-00)",
    "$": 3131600,
    "address": "255 Tappan St",
    "parcel_id": "222-30-00",
    "owner1": "COHEN, IRA D & DANIEL M",
    "owner2": "",
    "current_taxes": 28432.65,
    "new_taxes_no_override": 29660.94,
    "override_total_1": 30502.55,
    "override_increase_1": 841.61
  },
  {
    "#": "260 Tappan St, Unit 1 (227-09-03)",
    "$": 962500,
    "address": "260 Tappan St, Unit 1",
    "parcel_id": "227-09-03",
    "owner1": "BOZZUTO, BRIAN & LAUREN",
    "owner2": "",
    "current_taxes": 6221.07,
    "new_taxes_no_override": 6489.82,
    "override_total_1": 6673.96,
    "override_increase_1": 184.14
  },
  {
    "#": "260 Tappan St, Unit 2 (227-09-01)",
    "$": 1183400,
    "address": "260 Tappan St, Unit 2",
    "parcel_id": "227-09-01",
    "owner1": "LANDESMAN TRS, YOSEF & ESTHER",
    "owner2": "",
    "current_taxes": 8483.08,
    "new_taxes_no_override": 8849.55,
    "override_total_1": 9100.65,
    "override_increase_1": 251.1
  },
  {
    "#": "261 Tappan St, Unit 1 (222-31-01)",
    "$": 2583100,
    "address": "261 Tappan St, Unit 1",
    "parcel_id": "222-31-01",
    "owner1": "BERGER TR, SILVIA",
    "owner2": "",
    "current_taxes": 26450.94,
    "new_taxes_no_override": 27593.62,
    "override_total_1": 28376.57,
    "override_increase_1": 782.95
  },
  {
    "#": "261 Tappan St, Unit 2 (222-31-02)",
    "$": 2596200,
    "address": "261 Tappan St, Unit 2",
    "parcel_id": "222-31-02",
    "owner1": "YANG, JIMMY CHEN",
    "owner2": "WU, REBECCA LIN",
    "current_taxes": 26585.09,
    "new_taxes_no_override": 27733.57,
    "override_total_1": 28520.48,
    "override_increase_1": 786.92
  },
  {
    "#": "262 Tappan St, Unit 3 (227-09-02)",
    "$": 1156900,
    "address": "262 Tappan St, Unit 3",
    "parcel_id": "227-09-02",
    "owner1": "VETSIGIAN, KALIN",
    "owner2": "NIKOLOVA, BORIANA",
    "current_taxes": 8211.72,
    "new_taxes_no_override": 8566.47,
    "override_total_1": 8809.53,
    "override_increase_1": 243.07
  },
  {
    "#": "264 Tappan St (227-08-00)",
    "$": 2510200,
    "address": "264 Tappan St",
    "parcel_id": "227-08-00",
    "owner1": "LAUERMAN, JOHN & JUDITH",
    "owner2": "",
    "current_taxes": 22069.51,
    "new_taxes_no_override": 23022.91,
    "override_total_1": 23676.17,
    "override_increase_1": 653.26
  },
  {
    "#": "267 Tappan St (222-32-00)",
    "$": 4733600,
    "address": "267 Tappan St",
    "parcel_id": "222-32-00",
    "owner1": "TAPPAN STREET DEVELOPMENT LLC",
    "owner2": "",
    "current_taxes": 48472.06,
    "new_taxes_no_override": 50566.05,
    "override_total_1": 52000.83,
    "override_increase_1": 1434.77
  },
  {
    "#": "270 Tappan St (227-07-00)",
    "$": 1780900,
    "address": "270 Tappan St",
    "parcel_id": "227-07-00",
    "owner1": "KREDI, JACOBO",
    "owner2": "",
    "current_taxes": 14601.48,
    "new_taxes_no_override": 15232.26,
    "override_total_1": 15664.47,
    "override_increase_1": 432.2
  },
  {
    "#": "274 Tappan St, Unit 274 & P3-4-G1-G2-G3 (227-06-01)",
    "$": 1854800,
    "address": "274 Tappan St, Unit 274 & P3-4-G1-G2-G3",
    "parcel_id": "227-06-01",
    "owner1": "LIU, LIXIN",
    "owner2": "WU, JUNE QUN",
    "current_taxes": 15358.22,
    "new_taxes_no_override": 16021.7,
    "override_total_1": 16476.3,
    "override_increase_1": 454.6
  },
  {
    "#": "275 Tappan St (222-33-00)",
    "$": 2510300,
    "address": "275 Tappan St",
    "parcel_id": "222-33-00",
    "owner1": "LIU, LIXIN",
    "owner2": "WU, QUN",
    "current_taxes": 25705.47,
    "new_taxes_no_override": 26815.95,
    "override_total_1": 27576.83,
    "override_increase_1": 760.88
  },
  {
    "#": "276 Tappan St, Unit 276 & P1-P2-G4-G5 (227-06-02)",
    "$": 1626000,
    "address": "276 Tappan St, Unit 276 & P1-P2-G4-G5",
    "parcel_id": "227-06-02",
    "owner1": "CHEN, HUIYING",
    "owner2": "LI, TAO",
    "current_taxes": 16650.24,
    "new_taxes_no_override": 17369.53,
    "override_total_1": 17862.38,
    "override_increase_1": 492.85
  },
  {
    "#": "280 Tappan St, Unit 280 &G3P4 (227-05-01)",
    "$": 2057700,
    "address": "280 Tappan St, Unit 280 &G3P4",
    "parcel_id": "227-05-01",
    "owner1": "DAVISON, KIRSTEN",
    "owner2": "KRAHNSTOEVER, NILS",
    "current_taxes": 21070.85,
    "new_taxes_no_override": 21981.11,
    "override_total_1": 22604.81,
    "override_increase_1": 623.7
  },
  {
    "#": "281 Tappan St, Unit 1 (223-01-01)",
    "$": 1405100,
    "address": "281 Tappan St, Unit 1",
    "parcel_id": "223-01-01",
    "owner1": "RITWIK, KUMAR",
    "owner2": "GOENKA, RASNA",
    "current_taxes": 10753.29,
    "new_taxes_no_override": 11217.83,
    "override_total_1": 11536.13,
    "override_increase_1": 318.3
  },
  {
    "#": "281 Tappan St, Unit 2 (223-01-02)",
    "$": 1485500,
    "address": "281 Tappan St, Unit 2",
    "parcel_id": "223-01-02",
    "owner1": "FOLTZ, JONATHAN H",
    "owner2": "VINNIK, ANNA M",
    "current_taxes": 11576.59,
    "new_taxes_no_override": 12076.7,
    "override_total_1": 12419.37,
    "override_increase_1": 342.67
  },
  {
    "#": "281 Tappan St, Unit 3 (223-01-03)",
    "$": 1484100,
    "address": "281 Tappan St, Unit 3",
    "parcel_id": "223-01-03",
    "owner1": "PRIBIS, JOHN PAUL",
    "owner2": "KIM, SO DAM",
    "current_taxes": 11562.25,
    "new_taxes_no_override": 12061.74,
    "override_total_1": 12403.98,
    "override_increase_1": 342.24
  },
  {
    "#": "281 Tappan St, Unit T-1 (223-01-04)",
    "$": 620000,
    "address": "281 Tappan St, Unit T-1",
    "parcel_id": "223-01-04",
    "owner1": "DO, THUYHONG THUY",
    "owner2": "",
    "current_taxes": 6348.8,
    "new_taxes_no_override": 6623.07,
    "override_total_1": 6810.99,
    "override_increase_1": 187.92
  },
  {
    "#": "282 Tappan St, Unit 282 &G1G2 (227-05-02)",
    "$": 2161100,
    "address": "282 Tappan St, Unit 282 &G1G2",
    "parcel_id": "227-05-02",
    "owner1": "SPANJAARD, ELENA S & REMCO A",
    "owner2": "",
    "current_taxes": 18494.73,
    "new_taxes_no_override": 19293.7,
    "override_total_1": 19841.15,
    "override_increase_1": 547.44
  },
  {
    "#": "283 Tappan St, Unit 1 (223-02-03)",
    "$": 1263900,
    "address": "283 Tappan St, Unit 1",
    "parcel_id": "223-02-03",
    "owner1": "MORSE, JAMES D & LINDA K",
    "owner2": "",
    "current_taxes": 9307.4,
    "new_taxes_no_override": 9709.48,
    "override_total_1": 9984.98,
    "override_increase_1": 275.5
  },
  {
    "#": "283 Tappan St, Unit 3 (223-02-02)",
    "$": 1456200,
    "address": "283 Tappan St, Unit 3",
    "parcel_id": "223-02-02",
    "owner1": "LOWY TRS, PETER M & LINDA E",
    "owner2": "",
    "current_taxes": 11276.55,
    "new_taxes_no_override": 11763.7,
    "override_total_1": 12097.48,
    "override_increase_1": 333.79
  },
  {
    "#": "284 Tappan St, Unit 284 (227-04-01)",
    "$": 1530900,
    "address": "284 Tappan St, Unit 284",
    "parcel_id": "227-04-01",
    "owner1": "BENEDON, CARRIE MEGAN",
    "owner2": "SIENKIEWICZ, MATTHEW SCOTT",
    "current_taxes": 12041.48,
    "new_taxes_no_override": 12561.67,
    "override_total_1": 12918.1,
    "override_increase_1": 356.43
  },
  {
    "#": "285 Tappan St, Unit 2 (223-02-01)",
    "$": 1441900,
    "address": "285 Tappan St, Unit 2",
    "parcel_id": "223-02-01",
    "owner1": "SPELLBERG, MICHAEL",
    "owner2": "MINTS, YULIYA",
    "current_taxes": 11130.12,
    "new_taxes_no_override": 11610.94,
    "override_total_1": 11940.39,
    "override_increase_1": 329.45
  },
  {
    "#": "286 Tappan St, Unit 286 (227-04-02)",
    "$": 1648100,
    "address": "286 Tappan St, Unit 286",
    "parcel_id": "227-04-02",
    "owner1": "FREEMAN, MITCHELL & LAUREN",
    "owner2": "",
    "current_taxes": 13241.61,
    "new_taxes_no_override": 13813.65,
    "override_total_1": 14205.6,
    "override_increase_1": 391.95
  },
  {
    "#": "287 Tappan St, Unit 287 (223-03-01)",
    "$": 3468600,
    "address": "287 Tappan St, Unit 287",
    "parcel_id": "223-03-01",
    "owner1": "KUTIKOV, BORIS",
    "owner2": "",
    "current_taxes": 35518.46,
    "new_taxes_no_override": 37052.86,
    "override_total_1": 38104.2,
    "override_increase_1": 1051.35
  },
  {
    "#": "287 Tappan St, Unit 289 (223-03-02)",
    "$": 3328500,
    "address": "287 Tappan St, Unit 289",
    "parcel_id": "223-03-02",
    "owner1": "AYYAGARI, RAJASEKHARA",
    "owner2": "DESHMUKH, UMA",
    "current_taxes": 30448.91,
    "new_taxes_no_override": 31764.3,
    "override_total_1": 32665.59,
    "override_increase_1": 901.29
  },
  {
    "#": "287 Tappan St, Unit 291 (223-03-03)",
    "$": 3450700,
    "address": "287 Tappan St, Unit 291",
    "parcel_id": "223-03-03",
    "owner1": "MERLIS TRS, ALEXANDER",
    "owner2": "KLAPPERICH, CATHERINE M",
    "current_taxes": 35335.17,
    "new_taxes_no_override": 36861.65,
    "override_total_1": 37907.57,
    "override_increase_1": 1045.92
  },
  {
    "#": "290 Tappan St, Unit 290 (227-03-01)",
    "$": 3540900,
    "address": "290 Tappan St, Unit 290",
    "parcel_id": "227-03-01",
    "owner1": "ROGERS TRS, ERIC",
    "owner2": "GOMEZ, LISA",
    "current_taxes": 32623.88,
    "new_taxes_no_override": 34033.23,
    "override_total_1": 34998.9,
    "override_increase_1": 965.67
  },
  {
    "#": "290 Tappan St, Unit 292 (227-03-02)",
    "$": 2830900,
    "address": "290 Tappan St, Unit 292",
    "parcel_id": "227-03-02",
    "owner1": "KLICKSTEIN, ALAN & JUDITH",
    "owner2": "",
    "current_taxes": 28988.42,
    "new_taxes_no_override": 30240.72,
    "override_total_1": 31098.78,
    "override_increase_1": 858.06
  },
  {
    "#": "294 Tappan St, Unit 1 & P1-G1 (227-02-01)",
    "$": 1549500,
    "address": "294 Tappan St, Unit 1 & P1-G1",
    "parcel_id": "227-02-01",
    "owner1": "SARAF, AMITABH & SHRUTI",
    "owner2": "",
    "current_taxes": 12231.95,
    "new_taxes_no_override": 12760.37,
    "override_total_1": 13122.44,
    "override_increase_1": 362.07
  },
  {
    "#": "294 Tappan St, Unit 2 & P2-G2 (227-02-02)",
    "$": 1273200,
    "address": "294 Tappan St, Unit 2 & P2-G2",
    "parcel_id": "227-02-02",
    "owner1": "SHI, XUEQIN",
    "owner2": "",
    "current_taxes": 13037.57,
    "new_taxes_no_override": 13600.79,
    "override_total_1": 13986.71,
    "override_increase_1": 385.91
  },
  {
    "#": "295 Tappan St, Unit 1 (223-04-01)",
    "$": 1219400,
    "address": "295 Tappan St, Unit 1",
    "parcel_id": "223-04-01",
    "owner1": "SAMAROV TR, VICTOR",
    "owner2": "ZHITNIKOV TR, ELENA",
    "current_taxes": 8851.72,
    "new_taxes_no_override": 9234.11,
    "override_total_1": 9496.13,
    "override_increase_1": 262.01
  },
  {
    "#": "295 Tappan St, Unit 2 (223-04-02)",
    "$": 1166100,
    "address": "295 Tappan St, Unit 2",
    "parcel_id": "223-04-02",
    "owner1": "FELDMAN, RENEE B",
    "owner2": "FLETCHER, DAVID H",
    "current_taxes": 8305.93,
    "new_taxes_no_override": 8664.75,
    "override_total_1": 8910.6,
    "override_increase_1": 245.86
  },
  {
    "#": "295 Tappan St, Unit 3 (223-04-03)",
    "$": 1232300,
    "address": "295 Tappan St, Unit 3",
    "parcel_id": "223-04-03",
    "owner1": "OFFNER, THEODORE & TRACY",
    "owner2": "",
    "current_taxes": 8983.82,
    "new_taxes_no_override": 9371.92,
    "override_total_1": 9637.84,
    "override_increase_1": 265.92
  },
  {
    "#": "299 Tappan St, Unit 1 (223-05-09)",
    "$": 365200,
    "address": "299 Tappan St, Unit 1",
    "parcel_id": "223-05-09",
    "owner1": "LEUNG, HELEN",
    "owner2": "",
    "current_taxes": 3739.65,
    "new_taxes_no_override": 3901.2,
    "override_total_1": 4011.9,
    "override_increase_1": 110.69
  },
  {
    "#": "299 Tappan St, Unit 2 (223-05-01)",
    "$": 581500,
    "address": "299 Tappan St, Unit 2",
    "parcel_id": "223-05-01",
    "owner1": "ZOU, LIHUA",
    "owner2": "YU, YU-CHEN",
    "current_taxes": 5954.56,
    "new_taxes_no_override": 6211.8,
    "override_total_1": 6388.05,
    "override_increase_1": 176.25
  },
  {
    "#": "299 Tappan St, Unit 3 (223-05-02)",
    "$": 695100,
    "address": "299 Tappan St, Unit 3",
    "parcel_id": "223-05-02",
    "owner1": "CHAN, LUNG",
    "owner2": "CHANG, CHRISTINE",
    "current_taxes": 7117.82,
    "new_taxes_no_override": 7425.31,
    "override_total_1": 7636.0,
    "override_increase_1": 210.69
  },
  {
    "#": "299 Tappan St, Unit 4 (223-05-03)",
    "$": 699600,
    "address": "299 Tappan St, Unit 4",
    "parcel_id": "223-05-03",
    "owner1": "FANG TR, MING",
    "owner2": "",
    "current_taxes": 7163.9,
    "new_taxes_no_override": 7473.38,
    "override_total_1": 7685.43,
    "override_increase_1": 212.05
  },
  {
    "#": "299 Tappan St, Unit 5 (223-05-04)",
    "$": 677200,
    "address": "299 Tappan St, Unit 5",
    "parcel_id": "223-05-04",
    "owner1": "ELLIOT TR, ARCHIE W",
    "owner2": "",
    "current_taxes": 3299.59,
    "new_taxes_no_override": 3442.13,
    "override_total_1": 3539.8,
    "override_increase_1": 97.67
  },
  {
    "#": "299 Tappan St, Unit 6 (223-05-05)",
    "$": 369500,
    "address": "299 Tappan St, Unit 6",
    "parcel_id": "223-05-05",
    "owner1": "INBAR, NOAH & GALIT",
    "owner2": "",
    "current_taxes": 3783.68,
    "new_taxes_no_override": 3947.13,
    "override_total_1": 4059.13,
    "override_increase_1": 112.0
  },
  {
    "#": "299 Tappan St, Unit 7 (223-05-06)",
    "$": 400800,
    "address": "299 Tappan St, Unit 7",
    "parcel_id": "223-05-06",
    "owner1": "LENZI, DANIELLE",
    "owner2": "",
    "current_taxes": 4104.19,
    "new_taxes_no_override": 4281.49,
    "override_total_1": 4402.98,
    "override_increase_1": 121.48
  },
  {
    "#": "299 Tappan St, Unit 8 (223-05-07)",
    "$": 793000,
    "address": "299 Tappan St, Unit 8",
    "parcel_id": "223-05-07",
    "owner1": "STARITA, NICHOLAS & MARISA",
    "owner2": "",
    "current_taxes": 4485.39,
    "new_taxes_no_override": 4679.16,
    "override_total_1": 4811.93,
    "override_increase_1": 132.77
  },
  {
    "#": "299 Tappan St, Unit 9 (223-05-08)",
    "$": 691300,
    "address": "299 Tappan St, Unit 9",
    "parcel_id": "223-05-08",
    "owner1": "LUCAS, JENNIFER D",
    "owner2": "",
    "current_taxes": 3443.98,
    "new_taxes_no_override": 3592.76,
    "override_total_1": 3694.7,
    "override_increase_1": 101.94
  },
  {
    "#": "300 Tappan St (227-01-00)",
    "$": 2198500,
    "address": "300 Tappan St",
    "parcel_id": "227-01-00",
    "owner1": "ALPERT, MARC S",
    "owner2": "",
    "current_taxes": 18877.71,
    "new_taxes_no_override": 19693.23,
    "override_total_1": 20252.01,
    "override_increase_1": 558.78
  },
  {
    "#": "303 Tappan St (223-06-00)",
    "$": 2278000,
    "address": "303 Tappan St",
    "parcel_id": "223-06-00",
    "owner1": "CASSEL, SCOTT",
    "owner2": "PODZIBA, SUSAN",
    "current_taxes": 23326.72,
    "new_taxes_no_override": 24334.43,
    "override_total_1": 25024.91,
    "override_increase_1": 690.47
  },
  {
    "#": "306 Tappan St, Unit A (225-01-02)",
    "$": 1029100,
    "address": "306 Tappan St, Unit A",
    "parcel_id": "225-01-02",
    "owner1": "TSERKOVNY, ALEKSANDR",
    "owner2": "LEBEDEVA, YELENA",
    "current_taxes": 6903.05,
    "new_taxes_no_override": 7201.26,
    "override_total_1": 7405.59,
    "override_increase_1": 204.33
  },
  {
    "#": "306 Tappan St, Unit B & P5 (225-01-03)",
    "$": 974500,
    "address": "306 Tappan St, Unit B & P5",
    "parcel_id": "225-01-03",
    "owner1": "WONG, MIMI",
    "owner2": "BUSHONG, KYLE",
    "current_taxes": 9978.88,
    "new_taxes_no_override": 10409.97,
    "override_total_1": 10705.34,
    "override_increase_1": 295.37
  },
  {
    "#": "306 Tappan St, Unit C & P2 (225-01-04)",
    "$": 687100,
    "address": "306 Tappan St, Unit C & P2",
    "parcel_id": "225-01-04",
    "owner1": "SOKOLL TR, ELLEN R",
    "owner2": "",
    "current_taxes": 3400.97,
    "new_taxes_no_override": 3547.89,
    "override_total_1": 3648.56,
    "override_increase_1": 100.67
  },
  {
    "#": "306 Tappan St, Unit D & P3 (225-01-05)",
    "$": 696700,
    "address": "306 Tappan St, Unit D & P3",
    "parcel_id": "225-01-05",
    "owner1": "STANGER LIFE ESTATE, BEN Z",
    "owner2": "MOSES, CELIA E",
    "current_taxes": 3499.27,
    "new_taxes_no_override": 3650.44,
    "override_total_1": 3754.02,
    "override_increase_1": 103.58
  },
  {
    "#": "306 Tappan St, Unit E (225-01-06)",
    "$": 725000,
    "address": "306 Tappan St, Unit E",
    "parcel_id": "225-01-06",
    "owner1": "FAN, KEVIN PAN",
    "owner2": "",
    "current_taxes": 3789.07,
    "new_taxes_no_override": 3952.76,
    "override_total_1": 4064.91,
    "override_increase_1": 112.16
  },
  {
    "#": "306 Tappan St, Unit F & P6 P7 (225-01-07)",
    "$": 760700,
    "address": "306 Tappan St, Unit F & P6 P7",
    "parcel_id": "225-01-07",
    "owner1": "WANG, WEIQING",
    "owner2": "XU, BINYAN",
    "current_taxes": 7789.57,
    "new_taxes_no_override": 8126.08,
    "override_total_1": 8356.65,
    "override_increase_1": 230.57
  },
  {
    "#": "307 Tappan St, Unit 1 (223-07-03)",
    "$": 895100,
    "address": "307 Tappan St, Unit 1",
    "parcel_id": "223-07-03",
    "owner1": "GUTNICK, AMOS",
    "owner2": "GILAD-GUTNICK, SHARON",
    "current_taxes": 9165.82,
    "new_taxes_no_override": 9561.78,
    "override_total_1": 9833.09,
    "override_increase_1": 271.31
  },
  {
    "#": "307 Tappan St, Unit 2 (223-07-01)",
    "$": 888300,
    "address": "307 Tappan St, Unit 2",
    "parcel_id": "223-07-01",
    "owner1": "GUTNICK, AMOS",
    "owner2": "GILAD-GUTNICK, SHARON",
    "current_taxes": 9096.19,
    "new_taxes_no_override": 9489.15,
    "override_total_1": 9758.39,
    "override_increase_1": 269.25
  },
  {
    "#": "307 Tappan St, Unit 3 (223-07-02)",
    "$": 860600,
    "address": "307 Tappan St, Unit 3",
    "parcel_id": "223-07-02",
    "owner1": "HAMMERMAN TRS, JAMES K L",
    "owner2": "LEARY, MARJORIE M H",
    "current_taxes": 8812.54,
    "new_taxes_no_override": 9193.24,
    "override_total_1": 9454.09,
    "override_increase_1": 260.85
  },
  {
    "#": "309 Tappan St (223-08-00)",
    "$": 1712900,
    "address": "309 Tappan St",
    "parcel_id": "223-08-00",
    "owner1": "SLOAN, JACOB",
    "owner2": "HAYNE, CYNTHIA",
    "current_taxes": 13905.16,
    "new_taxes_no_override": 14505.86,
    "override_total_1": 14917.46,
    "override_increase_1": 411.59
  },
  {
    "#": "310 Tappan St (225-02-00)",
    "$": 6581400,
    "address": "310 Tappan St",
    "parcel_id": "225-02-00",
    "owner1": "TREMONT PROPERTY LP",
    "owner2": "",
    "current_taxes": 67393.54,
    "new_taxes_no_override": 70304.94,
    "override_total_1": 72299.79,
    "override_increase_1": 1994.85
  },
  {
    "#": "311 Tappan St, Unit 1 (223-09-56)",
    "$": 874800,
    "address": "311 Tappan St, Unit 1",
    "parcel_id": "223-09-56",
    "owner1": "DHRUV, VISHAL",
    "owner2": "MAHESHWARI, ALPA",
    "current_taxes": 8957.95,
    "new_taxes_no_override": 9344.93,
    "override_total_1": 9610.09,
    "override_increase_1": 265.16
  },
  {
    "#": "311 Tappan St, Unit 2 (223-09-01)",
    "$": 1048500,
    "address": "311 Tappan St, Unit 2",
    "parcel_id": "223-09-01",
    "owner1": "SHKLARSKY, ILAN",
    "owner2": "TSVIRKUN, DARYA",
    "current_taxes": 10736.64,
    "new_taxes_no_override": 11200.46,
    "override_total_1": 11518.27,
    "override_increase_1": 317.8
  },
  {
    "#": "311 Tappan St, Unit 3 (223-09-02)",
    "$": 989100,
    "address": "311 Tappan St, Unit 3",
    "parcel_id": "223-09-02",
    "owner1": "SHPEKTOR, MAINA",
    "owner2": "",
    "current_taxes": 10128.38,
    "new_taxes_no_override": 10565.93,
    "override_total_1": 10865.73,
    "override_increase_1": 299.8
  },
  {
    "#": "311 Tappan St, Unit 4 (223-09-03)",
    "$": 1117000,
    "address": "311 Tappan St, Unit 4",
    "parcel_id": "223-09-03",
    "owner1": "BRODSKY, GALA",
    "owner2": "",
    "current_taxes": 7803.15,
    "new_taxes_no_override": 8140.25,
    "override_total_1": 8371.22,
    "override_increase_1": 230.97
  },
  {
    "#": "311 Tappan St, Unit 5 & P39 (223-09-04)",
    "$": 1020300,
    "address": "311 Tappan St, Unit 5 & P39",
    "parcel_id": "223-09-04",
    "owner1": "THEAKER, SARAH",
    "owner2": "",
    "current_taxes": 10447.87,
    "new_taxes_no_override": 10899.22,
    "override_total_1": 11208.47,
    "override_increase_1": 309.26
  },
  {
    "#": "311 Tappan St, Unit 6 (223-09-05)",
    "$": 1117100,
    "address": "311 Tappan St, Unit 6",
    "parcel_id": "223-09-05",
    "owner1": "WEINER, ADAM",
    "owner2": "RESTIVO, JENETTE",
    "current_taxes": 7804.17,
    "new_taxes_no_override": 8141.31,
    "override_total_1": 8372.31,
    "override_increase_1": 231.0
  },
  {
    "#": "313 Tappan St, Unit 1 (223-09-06)",
    "$": 888900,
    "address": "313 Tappan St, Unit 1",
    "parcel_id": "223-09-06",
    "owner1": "VARGA, JOSEPH F JR",
    "owner2": "GRILLO, DIANE E",
    "current_taxes": 5467.4,
    "new_taxes_no_override": 5703.59,
    "override_total_1": 5865.43,
    "override_increase_1": 161.84
  },
  {
    "#": "313 Tappan St, Unit 2 (223-09-07)",
    "$": 947900,
    "address": "313 Tappan St, Unit 2",
    "parcel_id": "223-09-07",
    "owner1": "LIU, HONG",
    "owner2": "YANG, JIAN",
    "current_taxes": 9706.5,
    "new_taxes_no_override": 10125.82,
    "override_total_1": 10413.13,
    "override_increase_1": 287.31
  },
  {
    "#": "313 Tappan St, Unit 3 (223-09-08)",
    "$": 946000,
    "address": "313 Tappan St, Unit 3",
    "parcel_id": "223-09-08",
    "owner1": "PARK, SOO JUNG",
    "owner2": "CHOI, KYU YOUNG",
    "current_taxes": 9687.04,
    "new_taxes_no_override": 10105.52,
    "override_total_1": 10392.26,
    "override_increase_1": 286.74
  },
  {
    "#": "313 Tappan St, Unit 4 (223-09-09)",
    "$": 944500,
    "address": "313 Tappan St, Unit 4",
    "parcel_id": "223-09-09",
    "owner1": "LEE, GREGORY S & MING M & PENNY C",
    "owner2": "YOUNG, ALYSSA",
    "current_taxes": 6036.75,
    "new_taxes_no_override": 6297.54,
    "override_total_1": 6476.23,
    "override_increase_1": 178.69
  },
  {
    "#": "313 Tappan St, Unit 5 (223-09-10)",
    "$": 927600,
    "address": "313 Tappan St, Unit 5",
    "parcel_id": "223-09-10",
    "owner1": "GOMEZ, SHARI GOLD",
    "owner2": "JUAN, FRAN",
    "current_taxes": 5863.69,
    "new_taxes_no_override": 6117.0,
    "override_total_1": 6290.57,
    "override_increase_1": 173.57
  },
  {
    "#": "313 Tappan St, Unit 6 (223-09-11)",
    "$": 926200,
    "address": "313 Tappan St, Unit 6",
    "parcel_id": "223-09-11",
    "owner1": "JELICIC, MIRO",
    "owner2": "KULOVIC, MIRELA",
    "current_taxes": 5849.35,
    "new_taxes_no_override": 6102.04,
    "override_total_1": 6275.18,
    "override_increase_1": 173.14
  },
  {
    "#": "315 Tappan St, Unit 1 (223-09-12)",
    "$": 811400,
    "address": "315 Tappan St, Unit 1",
    "parcel_id": "223-09-12",
    "owner1": "MEHDIZADEH NADERI TRS, TOM SOROOSH & FOROOZ",
    "owner2": "",
    "current_taxes": 8308.74,
    "new_taxes_no_override": 8667.68,
    "override_total_1": 8913.62,
    "override_increase_1": 245.94
  },
  {
    "#": "315 Tappan St, Unit 2 & P-42 (223-09-13)",
    "$": 857900,
    "address": "315 Tappan St, Unit 2 & P-42",
    "parcel_id": "223-09-13",
    "owner1": "JAEGGIN, LISA N",
    "owner2": "",
    "current_taxes": 5149.96,
    "new_taxes_no_override": 5372.44,
    "override_total_1": 5524.88,
    "override_increase_1": 152.44
  },
  {
    "#": "315 Tappan St, Unit 3 & P49 (223-09-14)",
    "$": 944500,
    "address": "315 Tappan St, Unit 3 & P49",
    "parcel_id": "223-09-14",
    "owner1": "KEOGH, ABIGAIL ROGERS",
    "owner2": "LAMB, DELBERT JENE",
    "current_taxes": 9671.68,
    "new_taxes_no_override": 10089.5,
    "override_total_1": 10375.78,
    "override_increase_1": 286.28
  },
  {
    "#": "315 Tappan St, Unit 4 (223-09-15)",
    "$": 914900,
    "address": "315 Tappan St, Unit 4",
    "parcel_id": "223-09-15",
    "owner1": "WALLIS, WENDIE R",
    "owner2": "",
    "current_taxes": 5733.64,
    "new_taxes_no_override": 5981.33,
    "override_total_1": 6151.05,
    "override_increase_1": 169.72
  },
  {
    "#": "315 Tappan St, Unit 5 (223-09-16)",
    "$": 943600,
    "address": "315 Tappan St, Unit 5",
    "parcel_id": "223-09-16",
    "owner1": "COHEN, MAYDAD",
    "owner2": "",
    "current_taxes": 9662.46,
    "new_taxes_no_override": 10079.88,
    "override_total_1": 10365.89,
    "override_increase_1": 286.01
  },
  {
    "#": "315 Tappan St, Unit 6 (223-09-17)",
    "$": 925200,
    "address": "315 Tappan St, Unit 6",
    "parcel_id": "223-09-17",
    "owner1": "IDHAW, STEVEN R",
    "owner2": "GREENLEE, ELIZABETH",
    "current_taxes": 5839.11,
    "new_taxes_no_override": 6091.36,
    "override_total_1": 6264.2,
    "override_increase_1": 172.84
  },
  {
    "#": "316 Tappan St, Unit 1&Pk A-B (225-03-03)",
    "$": 1838800,
    "address": "316 Tappan St, Unit 1&Pk A-B",
    "parcel_id": "225-03-03",
    "owner1": "COHEN TR, DONALYN SLADE",
    "owner2": "",
    "current_taxes": 15194.38,
    "new_taxes_no_override": 15850.78,
    "override_total_1": 16300.53,
    "override_increase_1": 449.75
  },
  {
    "#": "316 Tappan St, Unit 2 (225-03-01)",
    "$": 927000,
    "address": "316 Tappan St, Unit 2",
    "parcel_id": "225-03-01",
    "owner1": "BERKLEIN, FLORA",
    "owner2": "STADLER, CHRISTOPHER",
    "current_taxes": 5857.55,
    "new_taxes_no_override": 6110.6,
    "override_total_1": 6283.98,
    "override_increase_1": 173.38
  },
  {
    "#": "316 Tappan St, Unit 3 (225-03-02)",
    "$": 1423400,
    "address": "316 Tappan St, Unit 3",
    "parcel_id": "225-03-02",
    "owner1": "TSELEVICH, ALEKSANDR & MARIA",
    "owner2": "",
    "current_taxes": 10940.68,
    "new_taxes_no_override": 11413.32,
    "override_total_1": 11737.16,
    "override_increase_1": 323.84
  },
  {
    "#": "317 Tappan St, Unit 1 (223-09-19)",
    "$": 996400,
    "address": "317 Tappan St, Unit 1",
    "parcel_id": "223-09-19",
    "owner1": "AVIV LIFE ESTATE, ORIT",
    "owner2": "",
    "current_taxes": 6568.2,
    "new_taxes_no_override": 6851.95,
    "override_total_1": 7046.36,
    "override_increase_1": 194.42
  },
  {
    "#": "317 Tappan St, Unit 2 & P36 (223-09-20)",
    "$": 760800,
    "address": "317 Tappan St, Unit 2 & P36",
    "parcel_id": "223-09-20",
    "owner1": "BERMAN, ERIK & VIRGINIJA",
    "owner2": "",
    "current_taxes": 4155.66,
    "new_taxes_no_override": 4335.18,
    "override_total_1": 4458.19,
    "override_increase_1": 123.01
  },
  {
    "#": "317 Tappan St, Unit 3 (223-09-21)",
    "$": 957200,
    "address": "317 Tappan St, Unit 3",
    "parcel_id": "223-09-21",
    "owner1": "LITCHFIELD, KAREN",
    "owner2": "",
    "current_taxes": 6166.79,
    "new_taxes_no_override": 6433.2,
    "override_total_1": 6615.73,
    "override_increase_1": 182.54
  },
  {
    "#": "317 Tappan St, Unit 4 & P57 (223-09-22)",
    "$": 921700,
    "address": "317 Tappan St, Unit 4 & P57",
    "parcel_id": "223-09-22",
    "owner1": "FALKENSTEIN TR, ERENA M",
    "owner2": "",
    "current_taxes": 5803.27,
    "new_taxes_no_override": 6053.97,
    "override_total_1": 6225.75,
    "override_increase_1": 171.78
  },
  {
    "#": "317 Tappan St, Unit 5 & P-48 (223-09-23)",
    "$": 957300,
    "address": "317 Tappan St, Unit 5 & P-48",
    "parcel_id": "223-09-23",
    "owner1": "SIGNORETTI, SABINA",
    "owner2": "",
    "current_taxes": 6167.82,
    "new_taxes_no_override": 6434.27,
    "override_total_1": 6616.84,
    "override_increase_1": 182.57
  },
  {
    "#": "317 Tappan St, Unit 6 (223-09-24)",
    "$": 943600,
    "address": "317 Tappan St, Unit 6",
    "parcel_id": "223-09-24",
    "owner1": "PEISNER, SUSAN",
    "owner2": "",
    "current_taxes": 6027.53,
    "new_taxes_no_override": 6287.92,
    "override_total_1": 6466.33,
    "override_increase_1": 178.41
  },
  {
    "#": "317 Tappan St, Unit B (223-09-18)",
    "$": 631100,
    "address": "317 Tappan St, Unit B",
    "parcel_id": "223-09-18",
    "owner1": "LATSON LIFE ESTATE, ANN M",
    "owner2": "",
    "current_taxes": 2827.53,
    "new_taxes_no_override": 2949.68,
    "override_total_1": 3033.37,
    "override_increase_1": 83.69
  },
  {
    "#": "318 Tappan St (225-04-00)",
    "$": 3715800,
    "address": "318 Tappan St",
    "parcel_id": "225-04-00",
    "owner1": "SAEIDIAN TR, GITI GANJEI",
    "owner2": "",
    "current_taxes": 34414.86,
    "new_taxes_no_override": 35901.58,
    "override_total_1": 36920.26,
    "override_increase_1": 1018.68
  },
  {
    "#": "319 Tappan St, Unit 1 (223-09-26)",
    "$": 774800,
    "address": "319 Tappan St, Unit 1",
    "parcel_id": "223-09-26",
    "owner1": "SAKR, MAHMOUD",
    "owner2": "",
    "current_taxes": 4299.02,
    "new_taxes_no_override": 4484.74,
    "override_total_1": 4611.99,
    "override_increase_1": 127.25
  },
  {
    "#": "319 Tappan St, Unit 2 (223-09-27)",
    "$": 975700,
    "address": "319 Tappan St, Unit 2",
    "parcel_id": "223-09-27",
    "owner1": "FLESHLER, STEVEN",
    "owner2": "MORIMOTO, MAYUMI",
    "current_taxes": 6356.23,
    "new_taxes_no_override": 6630.82,
    "override_total_1": 6818.96,
    "override_increase_1": 188.14
  },
  {
    "#": "319 Tappan St, Unit 3 (223-09-28)",
    "$": 921800,
    "address": "319 Tappan St, Unit 3",
    "parcel_id": "223-09-28",
    "owner1": "MURPHY, GRANT & CHRISTINE FECENKO",
    "owner2": "",
    "current_taxes": 9439.23,
    "new_taxes_no_override": 9847.0,
    "override_total_1": 10126.41,
    "override_increase_1": 279.4
  },
  {
    "#": "319 Tappan St, Unit 4 (223-09-29)",
    "$": 994100,
    "address": "319 Tappan St, Unit 4",
    "parcel_id": "223-09-29",
    "owner1": "AMBROSE, KELLEY",
    "owner2": "",
    "current_taxes": 6544.65,
    "new_taxes_no_override": 6827.38,
    "override_total_1": 7021.1,
    "override_increase_1": 193.72
  },
  {
    "#": "319 Tappan St, Unit 5 (223-09-30)",
    "$": 921700,
    "address": "319 Tappan St, Unit 5",
    "parcel_id": "223-09-30",
    "owner1": "TRUSCOTT, BRYAN",
    "owner2": "YEH, LINSHAN",
    "current_taxes": 5803.27,
    "new_taxes_no_override": 6053.97,
    "override_total_1": 6225.75,
    "override_increase_1": 171.78
  },
  {
    "#": "319 Tappan St, Unit 6 (223-09-31)",
    "$": 1003300,
    "address": "319 Tappan St, Unit 6",
    "parcel_id": "223-09-31",
    "owner1": "CHUN, SEJONG",
    "owner2": "LEE, HYESUN",
    "current_taxes": 6638.86,
    "new_taxes_no_override": 6925.66,
    "override_total_1": 7122.17,
    "override_increase_1": 196.51
  },
  {
    "#": "320 Tappan St (225-05-00)",
    "$": 3699300,
    "address": "320 Tappan St",
    "parcel_id": "225-05-00",
    "owner1": "SCHWARTZ, PHILIPPE & MICHELLE",
    "owner2": "",
    "current_taxes": 37880.83,
    "new_taxes_no_override": 39517.28,
    "override_total_1": 40638.55,
    "override_increase_1": 1121.27
  },
  {
    "#": "321 Tappan St, Unit 1 (223-09-32)",
    "$": 926000,
    "address": "321 Tappan St, Unit 1",
    "parcel_id": "223-09-32",
    "owner1": "GEFFEN, NATASHA",
    "owner2": "",
    "current_taxes": 5847.31,
    "new_taxes_no_override": 6099.91,
    "override_total_1": 6272.99,
    "override_increase_1": 173.08
  },
  {
    "#": "321 Tappan St, Unit 2 (223-09-33)",
    "$": 895100,
    "address": "321 Tappan St, Unit 2",
    "parcel_id": "223-09-33",
    "owner1": "RASIN TR, MARSHA",
    "owner2": "",
    "current_taxes": 5530.89,
    "new_taxes_no_override": 5769.82,
    "override_total_1": 5933.54,
    "override_increase_1": 163.71
  },
  {
    "#": "321 Tappan St, Unit 3 (223-09-34)",
    "$": 926100,
    "address": "321 Tappan St, Unit 3",
    "parcel_id": "223-09-34",
    "owner1": "SOKOL, CLAUDIA",
    "owner2": "",
    "current_taxes": 5848.33,
    "new_taxes_no_override": 6100.98,
    "override_total_1": 6274.09,
    "override_increase_1": 173.11
  },
  {
    "#": "321 Tappan St, Unit 4 & P-31 (223-09-35)",
    "$": 936800,
    "address": "321 Tappan St, Unit 4 & P-31",
    "parcel_id": "223-09-35",
    "owner1": "KLEIN TR, LENORE E",
    "owner2": "",
    "current_taxes": 5957.9,
    "new_taxes_no_override": 6215.28,
    "override_total_1": 6391.64,
    "override_increase_1": 176.35
  },
  {
    "#": "321 Tappan St, Unit 5  (223-09-36)",
    "$": 926100,
    "address": "321 Tappan St, Unit 5 ",
    "parcel_id": "223-09-36",
    "owner1": "MEURLING, JULIA E",
    "owner2": "KNOWLES, SCOTT G",
    "current_taxes": 9483.26,
    "new_taxes_no_override": 9892.94,
    "override_total_1": 10173.64,
    "override_increase_1": 280.7
  },
  {
    "#": "321 Tappan St, Unit 6 (223-09-37)",
    "$": 976200,
    "address": "321 Tappan St, Unit 6",
    "parcel_id": "223-09-37",
    "owner1": "KOMARNITSKY, SVETLANA I & PHILIP B",
    "owner2": "",
    "current_taxes": 9996.29,
    "new_taxes_no_override": 10428.13,
    "override_total_1": 10724.02,
    "override_increase_1": 295.89
  },
  {
    "#": "322 Tappan St, Unit 1 & G1 (225-06-01)",
    "$": 2044300,
    "address": "322 Tappan St, Unit 1 & G1",
    "parcel_id": "225-06-01",
    "owner1": "MCINTYRE, KEVIN",
    "owner2": "YAZDI, SARA",
    "current_taxes": 20933.63,
    "new_taxes_no_override": 21837.96,
    "override_total_1": 22457.6,
    "override_increase_1": 619.64
  },
  {
    "#": "322 Tappan St, Unit 2 & G2 (225-06-02)",
    "$": 2837100,
    "address": "322 Tappan St, Unit 2 & G2",
    "parcel_id": "225-06-02",
    "owner1": "QI, HUIWEN",
    "owner2": "LI, SIYU",
    "current_taxes": 25416.97,
    "new_taxes_no_override": 26514.98,
    "override_total_1": 27267.33,
    "override_increase_1": 752.34
  },
  {
    "#": "323 Tappan St, Unit 1 (223-09-38)",
    "$": 811400,
    "address": "323 Tappan St, Unit 1",
    "parcel_id": "223-09-38",
    "owner1": "FRECHETTE, CYNTHIA L",
    "owner2": "",
    "current_taxes": 4673.8,
    "new_taxes_no_override": 4875.71,
    "override_total_1": 5014.05,
    "override_increase_1": 138.34
  },
  {
    "#": "323 Tappan St, Unit 2 (223-09-39)",
    "$": 811800,
    "address": "323 Tappan St, Unit 2",
    "parcel_id": "223-09-39",
    "owner1": "WIXTED, SANDRA",
    "owner2": "",
    "current_taxes": 4677.9,
    "new_taxes_no_override": 4879.99,
    "override_total_1": 5018.45,
    "override_increase_1": 138.47
  },
  {
    "#": "323 Tappan St, Unit 3 (223-09-40)",
    "$": 926100,
    "address": "323 Tappan St, Unit 3",
    "parcel_id": "223-09-40",
    "owner1": "WILLIAMS TR, JOANNE DEAHL",
    "owner2": "",
    "current_taxes": 5848.33,
    "new_taxes_no_override": 6100.98,
    "override_total_1": 6274.09,
    "override_increase_1": 173.11
  },
  {
    "#": "323 Tappan St, Unit 4 (223-09-41)",
    "$": 936800,
    "address": "323 Tappan St, Unit 4",
    "parcel_id": "223-09-41",
    "owner1": "KURKI TR, IRVING A",
    "owner2": "",
    "current_taxes": 5957.9,
    "new_taxes_no_override": 6215.28,
    "override_total_1": 6391.64,
    "override_increase_1": 176.35
  },
  {
    "#": "323 Tappan St, Unit 5 (223-09-42)",
    "$": 926200,
    "address": "323 Tappan St, Unit 5",
    "parcel_id": "223-09-42",
    "owner1": "GUO, WEIHUI",
    "owner2": "",
    "current_taxes": 9484.29,
    "new_taxes_no_override": 9894.01,
    "override_total_1": 10174.75,
    "override_increase_1": 280.73
  },
  {
    "#": "323 Tappan St, Unit 6 (223-09-43)",
    "$": 978100,
    "address": "323 Tappan St, Unit 6",
    "parcel_id": "223-09-43",
    "owner1": "WONG TRS, DARYL S",
    "owner2": "FOONG, SERENA H",
    "current_taxes": 10015.74,
    "new_taxes_no_override": 10448.42,
    "override_total_1": 10744.89,
    "override_increase_1": 296.47
  },
  {
    "#": "324 Tappan St (225-07-00)",
    "$": 4234400,
    "address": "324 Tappan St",
    "parcel_id": "225-07-00",
    "owner1": "GREENE-BARTON TR, ALISON",
    "owner2": "",
    "current_taxes": 43360.26,
    "new_taxes_no_override": 45233.42,
    "override_total_1": 46516.89,
    "override_increase_1": 1283.46
  },
  {
    "#": "325 Tappan St, Unit 1 (223-09-44)",
    "$": 918700,
    "address": "325 Tappan St, Unit 1",
    "parcel_id": "223-09-44",
    "owner1": "GRAY, ODESSA",
    "owner2": "",
    "current_taxes": 5772.55,
    "new_taxes_no_override": 6021.92,
    "override_total_1": 6192.79,
    "override_increase_1": 170.87
  },
  {
    "#": "325 Tappan St, Unit 2 (223-09-45)",
    "$": 959100,
    "address": "325 Tappan St, Unit 2",
    "parcel_id": "223-09-45",
    "owner1": "325 TAPPAN LLC",
    "owner2": "",
    "current_taxes": 9821.18,
    "new_taxes_no_override": 10245.45,
    "override_total_1": 10536.16,
    "override_increase_1": 290.71
  },
  {
    "#": "325 Tappan St, Unit 3 (223-09-46)",
    "$": 1077700,
    "address": "325 Tappan St, Unit 3",
    "parcel_id": "223-09-46",
    "owner1": "FINE, ERIKA S",
    "owner2": "",
    "current_taxes": 7400.71,
    "new_taxes_no_override": 7720.42,
    "override_total_1": 7939.48,
    "override_increase_1": 219.06
  },
  {
    "#": "325 Tappan St, Unit 4 (223-09-47)",
    "$": 1020400,
    "address": "325 Tappan St, Unit 4",
    "parcel_id": "223-09-47",
    "owner1": "COHEN, OHAD",
    "owner2": "",
    "current_taxes": 10448.9,
    "new_taxes_no_override": 10900.29,
    "override_total_1": 11209.58,
    "override_increase_1": 309.29
  },
  {
    "#": "325 Tappan St, Unit 5 & P-33 (223-09-48)",
    "$": 1117100,
    "address": "325 Tappan St, Unit 5 & P-33",
    "parcel_id": "223-09-48",
    "owner1": "JIA, JIA",
    "owner2": "",
    "current_taxes": 11439.1,
    "new_taxes_no_override": 11933.27,
    "override_total_1": 12271.87,
    "override_increase_1": 338.6
  },
  {
    "#": "325 Tappan St, Unit 6 & P-22 (223-09-49)",
    "$": 1020300,
    "address": "325 Tappan St, Unit 6 & P-22",
    "parcel_id": "223-09-49",
    "owner1": "GULLER LIFE ESTATE, VITALY M & VERA V",
    "owner2": "",
    "current_taxes": 6812.94,
    "new_taxes_no_override": 7107.26,
    "override_total_1": 7308.92,
    "override_increase_1": 201.66
  },
  {
    "#": "326 Tappan St, Unit 1 (225-08-04)",
    "$": 606700,
    "address": "326 Tappan St, Unit 1",
    "parcel_id": "225-08-04",
    "owner1": "STRUNK TR, MICHAEL R",
    "owner2": "",
    "current_taxes": 6212.61,
    "new_taxes_no_override": 6480.99,
    "override_total_1": 6664.89,
    "override_increase_1": 183.89
  },
  {
    "#": "326 Tappan St, Unit 2 & P2 (225-08-01)",
    "$": 1306700,
    "address": "326 Tappan St, Unit 2 & P2",
    "parcel_id": "225-08-01",
    "owner1": "SINGH TR, FIZA",
    "owner2": "",
    "current_taxes": 9745.67,
    "new_taxes_no_override": 10166.68,
    "override_total_1": 10455.15,
    "override_increase_1": 288.47
  },
  {
    "#": "326 Tappan St, Unit 3 (225-08-02)",
    "$": 1000100,
    "address": "326 Tappan St, Unit 3",
    "parcel_id": "225-08-02",
    "owner1": "SINGH TR, FIZA",
    "owner2": "",
    "current_taxes": 10241.02,
    "new_taxes_no_override": 10683.43,
    "override_total_1": 10986.57,
    "override_increase_1": 303.13
  },
  {
    "#": "326 Tappan St, Unit 4 & P4 (225-08-03)",
    "$": 1441700,
    "address": "326 Tappan St, Unit 4 & P4",
    "parcel_id": "225-08-03",
    "owner1": "SCHONBERG, JAY",
    "owner2": "",
    "current_taxes": 11128.07,
    "new_taxes_no_override": 11608.8,
    "override_total_1": 11938.19,
    "override_increase_1": 329.39
  },
  {
    "#": "329 Tappan St (223-11-00)",
    "$": 2406400,
    "address": "329 Tappan St",
    "parcel_id": "223-11-00",
    "owner1": "NUZZO, WILLIAM W & CYNTHIA F",
    "owner2": "",
    "current_taxes": 21006.6,
    "new_taxes_no_override": 21914.09,
    "override_total_1": 22535.88,
    "override_increase_1": 621.8
  },
  {
    "#": "332 Tappan St (225-09-03)",
    "$": 2109100,
    "address": "332 Tappan St",
    "parcel_id": "225-09-03",
    "owner1": "VOLLOCH, VLADIMIR",
    "owner2": "VOLLOCH, SOPHIA R",
    "current_taxes": 21597.18,
    "new_taxes_no_override": 22530.18,
    "override_total_1": 23169.45,
    "override_increase_1": 639.28
  },
  {
    "#": "334 Tappan St, Unit 1 P-B (225-10-01)",
    "$": 415900,
    "address": "334 Tappan St, Unit 1 P-B",
    "parcel_id": "225-10-01",
    "owner1": "PETREE, JEAN R",
    "owner2": "",
    "current_taxes": 623.88,
    "new_taxes_no_override": 650.83,
    "override_total_1": 669.3,
    "override_increase_1": 18.47
  },
  {
    "#": "334 Tappan St, Unit 2 (225-10-02)",
    "$": 595500,
    "address": "334 Tappan St, Unit 2",
    "parcel_id": "225-10-02",
    "owner1": "YAZDI, MARYAM",
    "owner2": "",
    "current_taxes": 2462.99,
    "new_taxes_no_override": 2569.39,
    "override_total_1": 2642.3,
    "override_increase_1": 72.9
  },
  {
    "#": "334 Tappan St, Unit 3 (225-10-03)",
    "$": 598100,
    "address": "334 Tappan St, Unit 3",
    "parcel_id": "225-10-03",
    "owner1": "SPEIGHTS, KATHARINE LEKAS",
    "owner2": "",
    "current_taxes": 6124.54,
    "new_taxes_no_override": 6389.12,
    "override_total_1": 6570.41,
    "override_increase_1": 181.29
  },
  {
    "#": "334 Tappan St, Unit 4 (225-10-04)",
    "$": 605100,
    "address": "334 Tappan St, Unit 4",
    "parcel_id": "225-10-04",
    "owner1": "WU, DIXI",
    "owner2": "",
    "current_taxes": 2561.29,
    "new_taxes_no_override": 2671.94,
    "override_total_1": 2747.75,
    "override_increase_1": 75.81
  },
  {
    "#": "334 Tappan St, Unit 5 & P-A (225-10-05)",
    "$": 617600,
    "address": "334 Tappan St, Unit 5 & P-A",
    "parcel_id": "225-10-05",
    "owner1": "POPE, SAMUEL J",
    "owner2": "",
    "current_taxes": 2689.29,
    "new_taxes_no_override": 2805.47,
    "override_total_1": 2885.07,
    "override_increase_1": 79.6
  },
  {
    "#": "336 Tappan St, Unit 1 & P1 (225-11-03)",
    "$": 889400,
    "address": "336 Tappan St, Unit 1 & P1",
    "parcel_id": "225-11-03",
    "owner1": "LIND, MARC M & KATHLEEN M",
    "owner2": "",
    "current_taxes": 9107.46,
    "new_taxes_no_override": 9500.9,
    "override_total_1": 9770.48,
    "override_increase_1": 269.58
  },
  {
    "#": "336 Tappan St, Unit 2 (225-11-01)",
    "$": 652900,
    "address": "336 Tappan St, Unit 2",
    "parcel_id": "225-11-01",
    "owner1": "RZC LLC",
    "owner2": "",
    "current_taxes": 6685.7,
    "new_taxes_no_override": 6974.52,
    "override_total_1": 7172.42,
    "override_increase_1": 197.9
  },
  {
    "#": "336 Tappan St, Unit 3 (225-11-02)",
    "$": 1194000,
    "address": "336 Tappan St, Unit 3",
    "parcel_id": "225-11-02",
    "owner1": "LIND, MARC M",
    "owner2": "EASLEY, KATHLEEN M",
    "current_taxes": 8591.63,
    "new_taxes_no_override": 8962.79,
    "override_total_1": 9217.1,
    "override_increase_1": 254.31
  },
  {
    "#": "337 Tappan St, Unit 1 P-13 (223-12-27)",
    "$": 634100,
    "address": "337 Tappan St, Unit 1 P-13",
    "parcel_id": "223-12-27",
    "owner1": "PESELMAN, ROBERT A",
    "owner2": "",
    "current_taxes": 6493.18,
    "new_taxes_no_override": 6773.69,
    "override_total_1": 6965.88,
    "override_increase_1": 192.2
  },
  {
    "#": "337 Tappan St, Unit 2 (223-12-01)",
    "$": 688200,
    "address": "337 Tappan St, Unit 2",
    "parcel_id": "223-12-01",
    "owner1": "LAGOS TRS, CONSTANTINE B & LILLIAN",
    "owner2": "",
    "current_taxes": 7047.17,
    "new_taxes_no_override": 7351.61,
    "override_total_1": 7560.2,
    "override_increase_1": 208.6
  },
  {
    "#": "337 Tappan St, Unit 3 (223-12-02)",
    "$": 634000,
    "address": "337 Tappan St, Unit 3",
    "parcel_id": "223-12-02",
    "owner1": "SESTAR LLC",
    "owner2": "",
    "current_taxes": 6492.16,
    "new_taxes_no_override": 6772.62,
    "override_total_1": 6964.79,
    "override_increase_1": 192.17
  },
  {
    "#": "337 Tappan St, Unit 4 & P8 (223-12-03)",
    "$": 872700,
    "address": "337 Tappan St, Unit 4 & P8",
    "parcel_id": "223-12-03",
    "owner1": "LEBOWITZ, REBECCA BLAZAR",
    "owner2": "HISRSCH, ALEXANDER WILLIAM",
    "current_taxes": 5301.51,
    "new_taxes_no_override": 5530.54,
    "override_total_1": 5687.46,
    "override_increase_1": 156.92
  },
  {
    "#": "337 Tappan St, Unit 5 (223-12-04)",
    "$": 613600,
    "address": "337 Tappan St, Unit 5",
    "parcel_id": "223-12-04",
    "owner1": "CRISMAN, DAVID A",
    "owner2": "",
    "current_taxes": 2648.33,
    "new_taxes_no_override": 2762.74,
    "override_total_1": 2841.13,
    "override_increase_1": 78.39
  },
  {
    "#": "337 Tappan St, Unit 6 (223-12-05)",
    "$": 744300,
    "address": "337 Tappan St, Unit 6",
    "parcel_id": "223-12-05",
    "owner1": "XU, HUI",
    "owner2": "KANG, XINYU",
    "current_taxes": 3986.7,
    "new_taxes_no_override": 4158.93,
    "override_total_1": 4276.93,
    "override_increase_1": 118.01
  },
  {
    "#": "338 Tappan St (225-12-00)",
    "$": 3026400,
    "address": "338 Tappan St",
    "parcel_id": "225-12-00",
    "owner1": "JAFRY3RE LLC",
    "owner2": "",
    "current_taxes": 30990.34,
    "new_taxes_no_override": 32329.12,
    "override_total_1": 33246.44,
    "override_increase_1": 917.31
  },
  {
    "#": "339 Tappan St, Unit 1 (223-12-06)",
    "$": 572800,
    "address": "339 Tappan St, Unit 1",
    "parcel_id": "223-12-06",
    "owner1": "LESNICK TR, JOANIE M",
    "owner2": "",
    "current_taxes": 2230.54,
    "new_taxes_no_override": 2326.9,
    "override_total_1": 2392.92,
    "override_increase_1": 66.02
  },
  {
    "#": "339 Tappan St, Unit 2 (223-12-07)",
    "$": 710400,
    "address": "339 Tappan St, Unit 2",
    "parcel_id": "223-12-07",
    "owner1": "GOLDSTEIN TRS, MARCIA & LEONARD S",
    "owner2": "",
    "current_taxes": 3639.56,
    "new_taxes_no_override": 3796.79,
    "override_total_1": 3904.52,
    "override_increase_1": 107.73
  },
  {
    "#": "339 Tappan St, Unit 3 (223-12-08)",
    "$": 537100,
    "address": "339 Tappan St, Unit 3",
    "parcel_id": "223-12-08",
    "owner1": "KOCAL, MARGARET",
    "owner2": "",
    "current_taxes": 1864.97,
    "new_taxes_no_override": 1945.54,
    "override_total_1": 2000.74,
    "override_increase_1": 55.2
  },
  {
    "#": "339 Tappan St, Unit 4 & P14 (223-12-09)",
    "$": 710400,
    "address": "339 Tappan St, Unit 4 & P14",
    "parcel_id": "223-12-09",
    "owner1": "JACOBS, REBECCA L",
    "owner2": "",
    "current_taxes": 3639.56,
    "new_taxes_no_override": 3796.79,
    "override_total_1": 3904.52,
    "override_increase_1": 107.73
  },
  {
    "#": "339 Tappan St, Unit 5 (223-12-10)",
    "$": 537100,
    "address": "339 Tappan St, Unit 5",
    "parcel_id": "223-12-10",
    "owner1": "TAGARIS, AMALIA",
    "owner2": "",
    "current_taxes": 5499.9,
    "new_taxes_no_override": 5737.5,
    "override_total_1": 5900.29,
    "override_increase_1": 162.8
  },
  {
    "#": "339 Tappan St, Unit 6 (223-12-11)",
    "$": 715500,
    "address": "339 Tappan St, Unit 6",
    "parcel_id": "223-12-11",
    "owner1": "STOLYAR, RAISA",
    "owner2": "POLINA, RACHELL",
    "current_taxes": 3691.79,
    "new_taxes_no_override": 3851.28,
    "override_total_1": 3960.55,
    "override_increase_1": 109.28
  },
  {
    "#": "340 Tappan St, Unit 1 (225-13-01)",
    "$": 648600,
    "address": "340 Tappan St, Unit 1",
    "parcel_id": "225-13-01",
    "owner1": "ROUHANI TR, SHIVA",
    "owner2": "",
    "current_taxes": 6641.66,
    "new_taxes_no_override": 6928.58,
    "override_total_1": 7125.17,
    "override_increase_1": 196.59
  },
  {
    "#": "340 Tappan St, Unit 2 (225-13-02)",
    "$": 637200,
    "address": "340 Tappan St, Unit 2",
    "parcel_id": "225-13-02",
    "owner1": "SANTORA, STEVEN",
    "owner2": "",
    "current_taxes": 2889.99,
    "new_taxes_no_override": 3014.84,
    "override_total_1": 3100.38,
    "override_increase_1": 85.54
  },
  {
    "#": "340 Tappan St, Unit 3 (225-13-03)",
    "$": 723100,
    "address": "340 Tappan St, Unit 3",
    "parcel_id": "225-13-03",
    "owner1": "ROCHE, STEPHANIE",
    "owner2": "",
    "current_taxes": 3769.61,
    "new_taxes_no_override": 3932.46,
    "override_total_1": 4044.04,
    "override_increase_1": 111.58
  },
  {
    "#": "340 Tappan St, Unit 4 (225-13-04)",
    "$": 581100,
    "address": "340 Tappan St, Unit 4",
    "parcel_id": "225-13-04",
    "owner1": "LIU, LI KAI",
    "owner2": "",
    "current_taxes": 2315.53,
    "new_taxes_no_override": 2415.56,
    "override_total_1": 2484.1,
    "override_increase_1": 68.54
  },
  {
    "#": "340 Tappan St, Unit B (225-13-05)",
    "$": 479500,
    "address": "340 Tappan St, Unit B",
    "parcel_id": "225-13-05",
    "owner1": "LIND, MARC & KATHY",
    "owner2": "",
    "current_taxes": 4910.08,
    "new_taxes_no_override": 5122.2,
    "override_total_1": 5267.53,
    "override_increase_1": 145.34
  },
  {
    "#": "341 Tappan St, Unit 1 (223-12-12)",
    "$": 877400,
    "address": "341 Tappan St, Unit 1",
    "parcel_id": "223-12-12",
    "owner1": "SHOLKIN TRS, HOWARD S SHOLKIN & SHARON R",
    "owner2": "",
    "current_taxes": 8984.58,
    "new_taxes_no_override": 9372.71,
    "override_total_1": 9638.66,
    "override_increase_1": 265.94
  },
  {
    "#": "341 Tappan St, Unit 2 (223-12-13)",
    "$": 581500,
    "address": "341 Tappan St, Unit 2",
    "parcel_id": "223-12-13",
    "owner1": "HOLMAN, DEBORAH",
    "owner2": "",
    "current_taxes": 2319.63,
    "new_taxes_no_override": 2419.84,
    "override_total_1": 2488.5,
    "override_increase_1": 68.66
  },
  {
    "#": "341 Tappan St, Unit 3 (223-12-14)",
    "$": 761800,
    "address": "341 Tappan St, Unit 3",
    "parcel_id": "223-12-14",
    "owner1": "SLOSSBERG, ALEX D",
    "owner2": "",
    "current_taxes": 4165.9,
    "new_taxes_no_override": 4345.87,
    "override_total_1": 4469.18,
    "override_increase_1": 123.31
  },
  {
    "#": "341 Tappan St, Unit 341-6 (223-12-17)",
    "$": 588800,
    "address": "341 Tappan St, Unit 341-6",
    "parcel_id": "223-12-17",
    "owner1": "BI SCIENTIFIC LLC",
    "owner2": "",
    "current_taxes": 6029.31,
    "new_taxes_no_override": 6289.78,
    "override_total_1": 6468.24,
    "override_increase_1": 178.47
  },
  {
    "#": "341 Tappan St, Unit 4 (223-12-15)",
    "$": 571300,
    "address": "341 Tappan St, Unit 4",
    "parcel_id": "223-12-15",
    "owner1": "HOLDOWSKY, JONATHAN M",
    "owner2": "",
    "current_taxes": 2215.18,
    "new_taxes_no_override": 2310.88,
    "override_total_1": 2376.45,
    "override_increase_1": 65.57
  },
  {
    "#": "341 Tappan St, Unit 5 (223-12-16)",
    "$": 857700,
    "address": "341 Tappan St, Unit 5",
    "parcel_id": "223-12-16",
    "owner1": "YU, LIJEN",
    "owner2": "",
    "current_taxes": 5147.91,
    "new_taxes_no_override": 5370.3,
    "override_total_1": 5522.68,
    "override_increase_1": 152.38
  },
  {
    "#": "342 Tappan St (225-14-00)",
    "$": 2831200,
    "address": "342 Tappan St",
    "parcel_id": "225-14-00",
    "owner1": "CHANG, PEN-HAU BENJAMIN",
    "owner2": "CHAN, AMBER",
    "current_taxes": 25356.55,
    "new_taxes_no_override": 26451.95,
    "override_total_1": 27202.51,
    "override_increase_1": 750.55
  },
  {
    "#": "343 Tappan St, Unit 1 (223-12-18)",
    "$": 622900,
    "address": "343 Tappan St, Unit 1",
    "parcel_id": "223-12-18",
    "owner1": "SILBERBERG TR, REGINA ZIELONKA",
    "owner2": "",
    "current_taxes": 2743.56,
    "new_taxes_no_override": 2862.08,
    "override_total_1": 2943.29,
    "override_increase_1": 81.21
  },
  {
    "#": "343 Tappan St, Unit 2 (223-12-19)",
    "$": 638400,
    "address": "343 Tappan St, Unit 2",
    "parcel_id": "223-12-19",
    "owner1": "COLEMAN, TRS, CATHERINE A",
    "owner2": "",
    "current_taxes": 6537.22,
    "new_taxes_no_override": 6819.63,
    "override_total_1": 7013.13,
    "override_increase_1": 193.5
  },
  {
    "#": "343 Tappan St, Unit 3 (223-12-20)",
    "$": 602500,
    "address": "343 Tappan St, Unit 3",
    "parcel_id": "223-12-20",
    "owner1": "CHEN TR, JEAN YI",
    "owner2": "",
    "current_taxes": 6169.6,
    "new_taxes_no_override": 6436.13,
    "override_total_1": 6618.75,
    "override_increase_1": 182.62
  },
  {
    "#": "343 Tappan St, Unit 4 (223-12-21)",
    "$": 638000,
    "address": "343 Tappan St, Unit 4",
    "parcel_id": "223-12-21",
    "owner1": "YANG, XIAN",
    "owner2": "ZHANG, ZHOUWEI",
    "current_taxes": 6533.12,
    "new_taxes_no_override": 6815.35,
    "override_total_1": 7008.73,
    "override_increase_1": 193.38
  },
  {
    "#": "343 Tappan St, Unit 5 & P15 (223-12-22)",
    "$": 710900,
    "address": "343 Tappan St, Unit 5 & P15",
    "parcel_id": "223-12-22",
    "owner1": "SPENCE, SARAH J",
    "owner2": "",
    "current_taxes": 3644.68,
    "new_taxes_no_override": 3802.13,
    "override_total_1": 3910.01,
    "override_increase_1": 107.88
  },
  {
    "#": "343 Tappan St, Unit 6 (223-12-23)",
    "$": 638400,
    "address": "343 Tappan St, Unit 6",
    "parcel_id": "223-12-23",
    "owner1": "COLTOF, GIDEON",
    "owner2": "",
    "current_taxes": 6537.22,
    "new_taxes_no_override": 6819.63,
    "override_total_1": 7013.13,
    "override_increase_1": 193.5
  },
  {
    "#": "344 Tappan St, Unit 1 (225-15-03)",
    "$": 1405600,
    "address": "344 Tappan St, Unit 1",
    "parcel_id": "225-15-03",
    "owner1": "VLAD, SERGIU",
    "owner2": "PERRELLY, KAITLIN",
    "current_taxes": 10758.41,
    "new_taxes_no_override": 11223.17,
    "override_total_1": 11541.62,
    "override_increase_1": 318.45
  },
  {
    "#": "344 Tappan St, Unit 2 (225-15-01)",
    "$": 823300,
    "address": "344 Tappan St, Unit 2",
    "parcel_id": "225-15-01",
    "owner1": "ORLECK TRS, SCOTT D & JACQUELYN L",
    "owner2": "",
    "current_taxes": 8430.59,
    "new_taxes_no_override": 8794.79,
    "override_total_1": 9044.34,
    "override_increase_1": 249.55
  },
  {
    "#": "344 Tappan St, Unit 3 (225-15-02)",
    "$": 1915600,
    "address": "344 Tappan St, Unit 3",
    "parcel_id": "225-15-02",
    "owner1": "GONEN, YAEL",
    "owner2": "",
    "current_taxes": 19615.74,
    "new_taxes_no_override": 20463.14,
    "override_total_1": 21043.77,
    "override_increase_1": 580.63
  },
  {
    "#": "350 Tappan St, Unit 1 (225-16-03)",
    "$": 1220700,
    "address": "350 Tappan St, Unit 1",
    "parcel_id": "225-16-03",
    "owner1": "MITCHELL, JACQUELINE S",
    "owner2": "",
    "current_taxes": 12499.97,
    "new_taxes_no_override": 13039.97,
    "override_total_1": 13409.97,
    "override_increase_1": 370.0
  },
  {
    "#": "350 Tappan St, Unit 2 (225-16-01)",
    "$": 784900,
    "address": "350 Tappan St, Unit 2",
    "parcel_id": "225-16-01",
    "owner1": "WALKER, SHELAGH & CLIFFORD",
    "owner2": "",
    "current_taxes": 8037.38,
    "new_taxes_no_override": 8384.59,
    "override_total_1": 8622.5,
    "override_increase_1": 237.91
  },
  {
    "#": "350 Tappan St, Unit 3 (225-16-02)",
    "$": 752000,
    "address": "350 Tappan St, Unit 3",
    "parcel_id": "225-16-02",
    "owner1": "SILVESTRI ETAL, ELIZABETH K",
    "owner2": "SOKOL, KIRSTIN",
    "current_taxes": 4065.55,
    "new_taxes_no_override": 4241.18,
    "override_total_1": 4361.52,
    "override_increase_1": 120.34
  },
  {
    "#": "352 Tappan St, Unit 1 (225-17-01)",
    "$": 396000,
    "address": "352 Tappan St, Unit 1",
    "parcel_id": "225-17-01",
    "owner1": "ISUFAJ, ARBER",
    "owner2": "",
    "current_taxes": 4055.04,
    "new_taxes_no_override": 4230.22,
    "override_total_1": 4350.25,
    "override_increase_1": 120.03
  },
  {
    "#": "352 Tappan St, Unit 2 & P1-G1 (225-17-02)",
    "$": 1748300,
    "address": "352 Tappan St, Unit 2 & P1-G1",
    "parcel_id": "225-17-02",
    "owner1": "HENRICH, NATALIE",
    "owner2": "",
    "current_taxes": 14267.66,
    "new_taxes_no_override": 14884.02,
    "override_total_1": 15306.35,
    "override_increase_1": 422.32
  },
  {
    "#": "352 Tappan St, Unit 3 (225-17-03)",
    "$": 1606100,
    "address": "352 Tappan St, Unit 3",
    "parcel_id": "225-17-03",
    "owner1": "KOO, SUN HEE",
    "owner2": "",
    "current_taxes": 16446.46,
    "new_taxes_no_override": 17156.95,
    "override_total_1": 17643.76,
    "override_increase_1": 486.82
  },
  {
    "#": "354 Tappan St (225-18-00)",
    "$": 2978900,
    "address": "354 Tappan St",
    "parcel_id": "225-18-00",
    "owner1": "3456 TAPPAN REALTY LLC",
    "owner2": "",
    "current_taxes": 30503.94,
    "new_taxes_no_override": 31821.71,
    "override_total_1": 32724.63,
    "override_increase_1": 902.92
  },
  {
    "#": "356 Tappan St (225-19-00)",
    "$": 2884200,
    "address": "356 Tappan St",
    "parcel_id": "225-19-00",
    "owner1": "356 TAPPAN LLC",
    "owner2": "",
    "current_taxes": 29534.21,
    "new_taxes_no_override": 30810.09,
    "override_total_1": 31684.3,
    "override_increase_1": 874.21
  },
  {
    "#": "358 Tappan St (225-20-00)",
    "$": 2967100,
    "address": "358 Tappan St",
    "parcel_id": "225-20-00",
    "owner1": "SHINE, THOMAS",
    "owner2": "CHOI, JIN",
    "current_taxes": 26748.17,
    "new_taxes_no_override": 27903.69,
    "override_total_1": 28695.44,
    "override_increase_1": 791.75
  },
  {
    "#": "359 Tappan St, Unit 1 (224-21-01)",
    "$": 1161300,
    "address": "359 Tappan St, Unit 1",
    "parcel_id": "224-21-01",
    "owner1": "SEIDMAN, RUTH",
    "owner2": "",
    "current_taxes": 8256.78,
    "new_taxes_no_override": 8613.47,
    "override_total_1": 8857.87,
    "override_increase_1": 244.4
  },
  {
    "#": "359 Tappan St, Unit 2 (224-21-02)",
    "$": 1220500,
    "address": "359 Tappan St, Unit 2",
    "parcel_id": "224-21-02",
    "owner1": "ESTESO, PAUL",
    "owner2": "CAMPAGNONI, LISA M",
    "current_taxes": 8862.99,
    "new_taxes_no_override": 9245.87,
    "override_total_1": 9508.22,
    "override_increase_1": 262.34
  },
  {
    "#": "359 Tappan St, Unit 3 (224-21-03)",
    "$": 1196700,
    "address": "359 Tappan St, Unit 3",
    "parcel_id": "224-21-03",
    "owner1": "SILLMAN, JONATHON",
    "owner2": "",
    "current_taxes": 8619.27,
    "new_taxes_no_override": 8991.62,
    "override_total_1": 9246.75,
    "override_increase_1": 255.13
  },
  {
    "#": "359 Tappan St, Unit 4 (224-21-04)",
    "$": 1191400,
    "address": "359 Tappan St, Unit 4",
    "parcel_id": "224-21-04",
    "owner1": "BACHMANN, WILLIAM T & EMILY P",
    "owner2": "",
    "current_taxes": 8565.0,
    "new_taxes_no_override": 8935.01,
    "override_total_1": 9188.53,
    "override_increase_1": 253.52
  },
  {
    "#": "360 Tappan St (225-21-00)",
    "$": 2709900,
    "address": "360 Tappan St",
    "parcel_id": "225-21-00",
    "owner1": "3456 TAPPAN REALTY LLC",
    "owner2": "",
    "current_taxes": 27749.38,
    "new_taxes_no_override": 28948.15,
    "override_total_1": 29769.53,
    "override_increase_1": 821.38
  },
  {
    "#": "362 Tappan St (225-22-00)",
    "$": 3537700,
    "address": "362 Tappan St",
    "parcel_id": "225-22-00",
    "owner1": "PARK, JOHN",
    "owner2": "DESJARDINS, MARIE",
    "current_taxes": 36226.05,
    "new_taxes_no_override": 37791.02,
    "override_total_1": 38863.31,
    "override_increase_1": 1072.29
  },
  {
    "#": "366 Tappan St, Unit 1 & 2 Pk Sps (225-23-01)",
    "$": 1098700,
    "address": "366 Tappan St, Unit 1 & 2 Pk Sps",
    "parcel_id": "225-23-01",
    "owner1": "RAFFI, JASON C",
    "owner2": "GAO, YAN C",
    "current_taxes": 7615.75,
    "new_taxes_no_override": 7944.75,
    "override_total_1": 8170.18,
    "override_increase_1": 225.43
  },
  {
    "#": "366 Tappan St, Unit 2 & P2 (225-23-02)",
    "$": 1217700,
    "address": "366 Tappan St, Unit 2 & P2",
    "parcel_id": "225-23-02",
    "owner1": "WONG-RUSSELL TR, CHRISTINA K",
    "owner2": "",
    "current_taxes": 8834.31,
    "new_taxes_no_override": 9215.95,
    "override_total_1": 9477.45,
    "override_increase_1": 261.5
  },
  {
    "#": "366 Tappan St, Unit 3 & P3 (225-23-03)",
    "$": 1240400,
    "address": "366 Tappan St, Unit 3 & P3",
    "parcel_id": "225-23-03",
    "owner1": "NASH, JAKE ADAM",
    "owner2": "",
    "current_taxes": 9066.76,
    "new_taxes_no_override": 9458.44,
    "override_total_1": 9726.82,
    "override_increase_1": 268.38
  },
  {
    "#": "366 Tappan St, Unit 4 & 2 Pk Sps (225-23-04)",
    "$": 1863400,
    "address": "366 Tappan St, Unit 4 & 2 Pk Sps",
    "parcel_id": "225-23-04",
    "owner1": "STEVENSON TR, LAUREN M",
    "owner2": "",
    "current_taxes": 15446.28,
    "new_taxes_no_override": 16113.56,
    "override_total_1": 16570.77,
    "override_increase_1": 457.21
  },
  {
    "#": "369 Tappan St, Unit 1 (224-23-20)",
    "$": 416400,
    "address": "369 Tappan St, Unit 1",
    "parcel_id": "224-23-20",
    "owner1": "PANICH, MICHAEL",
    "owner2": "",
    "current_taxes": 629.0,
    "new_taxes_no_override": 656.17,
    "override_total_1": 674.79,
    "override_increase_1": 18.62
  },
  {
    "#": "369 Tappan St, Unit 10 (224-23-09)",
    "$": 700200,
    "address": "369 Tappan St, Unit 10",
    "parcel_id": "224-23-09",
    "owner1": "LITVAK TRS, EUGENE & ELLA",
    "owner2": "",
    "current_taxes": 7170.05,
    "new_taxes_no_override": 7479.8,
    "override_total_1": 7692.03,
    "override_increase_1": 212.23
  },
  {
    "#": "369 Tappan St, Unit 11 (224-23-10)",
    "$": 766400,
    "address": "369 Tappan St, Unit 11",
    "parcel_id": "224-23-10",
    "owner1": "SALES, STEPHANIE L",
    "owner2": "",
    "current_taxes": 7847.94,
    "new_taxes_no_override": 8186.97,
    "override_total_1": 8419.27,
    "override_increase_1": 232.3
  },
  {
    "#": "369 Tappan St, Unit 12 (224-23-11)",
    "$": 477400,
    "address": "369 Tappan St, Unit 12",
    "parcel_id": "224-23-11",
    "owner1": "MAHMOOD, SYED KASHIF & SADIA",
    "owner2": "",
    "current_taxes": 4888.58,
    "new_taxes_no_override": 5099.77,
    "override_total_1": 5244.47,
    "override_increase_1": 144.7
  },
  {
    "#": "369 Tappan St, Unit 13 (224-23-12)",
    "$": 516000,
    "address": "369 Tappan St, Unit 13",
    "parcel_id": "224-23-12",
    "owner1": "SICCHIO, MOLLY",
    "owner2": "",
    "current_taxes": 1648.91,
    "new_taxes_no_override": 1720.14,
    "override_total_1": 1768.95,
    "override_increase_1": 48.81
  },
  {
    "#": "369 Tappan St, Unit 14 (224-23-13)",
    "$": 727400,
    "address": "369 Tappan St, Unit 14",
    "parcel_id": "224-23-13",
    "owner1": "NAYVELT, LUDMILA",
    "owner2": "",
    "current_taxes": 3813.64,
    "new_taxes_no_override": 3978.39,
    "override_total_1": 4091.27,
    "override_increase_1": 112.88
  },
  {
    "#": "369 Tappan St, Unit 15 (224-23-14)",
    "$": 792300,
    "address": "369 Tappan St, Unit 15",
    "parcel_id": "224-23-14",
    "owner1": "NG, RANICK",
    "owner2": "",
    "current_taxes": 8113.15,
    "new_taxes_no_override": 8463.64,
    "override_total_1": 8703.79,
    "override_increase_1": 240.15
  },
  {
    "#": "369 Tappan St, Unit 16 (224-23-15)",
    "$": 436400,
    "address": "369 Tappan St, Unit 16",
    "parcel_id": "224-23-15",
    "owner1": "SLATER TR, DAVID",
    "owner2": "",
    "current_taxes": 4468.74,
    "new_taxes_no_override": 4661.79,
    "override_total_1": 4794.06,
    "override_increase_1": 132.27
  },
  {
    "#": "369 Tappan St, Unit 17 (224-23-16)",
    "$": 463600,
    "address": "369 Tappan St, Unit 17",
    "parcel_id": "224-23-16",
    "owner1": "COHEN, JUDY B",
    "owner2": "",
    "current_taxes": 1112.33,
    "new_taxes_no_override": 1160.38,
    "override_total_1": 1193.31,
    "override_increase_1": 32.92
  },
  {
    "#": "369 Tappan St, Unit 18 (224-23-17)",
    "$": 725300,
    "address": "369 Tappan St, Unit 18",
    "parcel_id": "224-23-17",
    "owner1": "CHAMANDY, SUSAN J",
    "owner2": "",
    "current_taxes": 3792.14,
    "new_taxes_no_override": 3955.96,
    "override_total_1": 4068.21,
    "override_increase_1": 112.25
  },
  {
    "#": "369 Tappan St, Unit 19 (224-23-18)",
    "$": 345400,
    "address": "369 Tappan St, Unit 19",
    "parcel_id": "224-23-18",
    "owner1": "ELLIN, TR, BARBARA J",
    "owner2": "",
    "current_taxes": 3536.9,
    "new_taxes_no_override": 3689.69,
    "override_total_1": 3794.39,
    "override_increase_1": 104.69
  },
  {
    "#": "369 Tappan St, Unit 2 (224-23-01)",
    "$": 410500,
    "address": "369 Tappan St, Unit 2",
    "parcel_id": "224-23-01",
    "owner1": "LAI, WEIYU",
    "owner2": "HSIEH, PEISHAN",
    "current_taxes": 4203.52,
    "new_taxes_no_override": 4385.11,
    "override_total_1": 4509.54,
    "override_increase_1": 124.42
  },
  {
    "#": "369 Tappan St, Unit 20 (224-23-19)",
    "$": 372600,
    "address": "369 Tappan St, Unit 20",
    "parcel_id": "224-23-19",
    "owner1": "SALAMAT, BANAFSHEH",
    "owner2": "",
    "current_taxes": 3815.42,
    "new_taxes_no_override": 3980.25,
    "override_total_1": 4093.18,
    "override_increase_1": 112.94
  },
  {
    "#": "369 Tappan St, Unit 3 (224-23-02)",
    "$": 803300,
    "address": "369 Tappan St, Unit 3",
    "parcel_id": "224-23-02",
    "owner1": "REESE, BENJAMIN",
    "owner2": "",
    "current_taxes": 8225.79,
    "new_taxes_no_override": 8581.14,
    "override_total_1": 8824.63,
    "override_increase_1": 243.48
  },
  {
    "#": "369 Tappan St, Unit 4 (224-23-03)",
    "$": 411600,
    "address": "369 Tappan St, Unit 4",
    "parcel_id": "224-23-03",
    "owner1": "TAKSIR TR, IGOR",
    "owner2": "",
    "current_taxes": 4214.78,
    "new_taxes_no_override": 4396.86,
    "override_total_1": 4521.62,
    "override_increase_1": 124.76
  },
  {
    "#": "369 Tappan St, Unit 5 (224-23-04)",
    "$": 440000,
    "address": "369 Tappan St, Unit 5",
    "parcel_id": "224-23-04",
    "owner1": "RYAN, JAMES MICHAEL",
    "owner2": "GROSETT, DAPHNE",
    "current_taxes": 870.67,
    "new_taxes_no_override": 908.28,
    "override_total_1": 934.05,
    "override_increase_1": 25.77
  },
  {
    "#": "369 Tappan St, Unit 6 (224-23-05)",
    "$": 598200,
    "address": "369 Tappan St, Unit 6",
    "parcel_id": "224-23-05",
    "owner1": "BOULDER LLC",
    "owner2": "",
    "current_taxes": 6125.57,
    "new_taxes_no_override": 6390.19,
    "override_total_1": 6571.51,
    "override_increase_1": 181.32
  },
  {
    "#": "369 Tappan St, Unit 7 (224-23-06)",
    "$": 791700,
    "address": "369 Tappan St, Unit 7",
    "parcel_id": "224-23-06",
    "owner1": "KING, MARISSA",
    "owner2": "",
    "current_taxes": 8107.01,
    "new_taxes_no_override": 8457.23,
    "override_total_1": 8697.2,
    "override_increase_1": 239.97
  },
  {
    "#": "369 Tappan St, Unit 8 (224-23-07)",
    "$": 443600,
    "address": "369 Tappan St, Unit 8",
    "parcel_id": "224-23-07",
    "owner1": "MAHMOOD, SYED KASHIF & SADIA",
    "owner2": "",
    "current_taxes": 4542.46,
    "new_taxes_no_override": 4738.69,
    "override_total_1": 4873.15,
    "override_increase_1": 134.46
  },
  {
    "#": "369 Tappan St, Unit 9 (224-23-08)",
    "$": 486400,
    "address": "369 Tappan St, Unit 9",
    "parcel_id": "224-23-08",
    "owner1": "WINTEMUTE, DEVIN",
    "owner2": "MARKOWSKI, ANGELIQUE",
    "current_taxes": 1345.8,
    "new_taxes_no_override": 1403.94,
    "override_total_1": 1443.77,
    "override_increase_1": 39.84
  },
  {
    "#": "32 Taylor Cswy (262-02-00)",
    "$": 3524200,
    "address": "32 Taylor Cswy",
    "parcel_id": "262-02-00",
    "owner1": "COLES, PHILIP & KARLI",
    "owner2": "",
    "current_taxes": 36087.81,
    "new_taxes_no_override": 37646.8,
    "override_total_1": 38715.0,
    "override_increase_1": 1068.2
  },
  {
    "#": "33 Taylor Cswy (264B-01-00)",
    "$": 4195800,
    "address": "33 Taylor Cswy",
    "parcel_id": "264B-01-00",
    "owner1": "BERMAN, SCOTT L & SELENA K",
    "owner2": "",
    "current_taxes": 42964.99,
    "new_taxes_no_override": 44821.08,
    "override_total_1": 46092.84,
    "override_increase_1": 1271.76
  },
  {
    "#": "40 Taylor Cswy (262-01-01)",
    "$": 2932400,
    "address": "40 Taylor Cswy",
    "parcel_id": "262-01-01",
    "owner1": "CHANG TRS, KUEI ET AL",
    "owner2": "YOUNG, ANDREA C",
    "current_taxes": 26392.84,
    "new_taxes_no_override": 27533.01,
    "override_total_1": 28314.24,
    "override_increase_1": 781.23
  },
  {
    "#": "41 Taylor Cswy (264B-02-00)",
    "$": 2866800,
    "address": "41 Taylor Cswy",
    "parcel_id": "264B-02-00",
    "owner1": "NOWILL, DONALD T",
    "owner2": "",
    "current_taxes": 25721.1,
    "new_taxes_no_override": 26832.25,
    "override_total_1": 27593.6,
    "override_increase_1": 761.34
  },
  {
    "#": "47 Taylor Cswy (264B-03-00)",
    "$": 2937400,
    "address": "47 Taylor Cswy",
    "parcel_id": "264B-03-00",
    "owner1": "HELMAN, ROBERT C & ELLEN D",
    "owner2": "",
    "current_taxes": 26444.04,
    "new_taxes_no_override": 27586.42,
    "override_total_1": 28369.17,
    "override_increase_1": 782.74
  },
  {
    "#": "68 Taylor Cswy (260-05-00)",
    "$": 3345100,
    "address": "68 Taylor Cswy",
    "parcel_id": "260-05-00",
    "owner1": "LIGON, KEITH L & AZRA H",
    "owner2": "",
    "current_taxes": 30618.89,
    "new_taxes_no_override": 31941.63,
    "override_total_1": 32847.95,
    "override_increase_1": 906.32
  },
  {
    "#": "15 Thatcher St, Unit F1-1 (022-13-01)",
    "$": 1515900,
    "address": "15 Thatcher St, Unit F1-1",
    "parcel_id": "022-13-01",
    "owner1": "KELLY TR, RYAN P B",
    "owner2": "",
    "current_taxes": 15522.82,
    "new_taxes_no_override": 16193.41,
    "override_total_1": 16652.88,
    "override_increase_1": 459.48
  },
  {
    "#": "15 Thatcher St, Unit F1-2 (022-13-02)",
    "$": 1582000,
    "address": "15 Thatcher St, Unit F1-2",
    "parcel_id": "022-13-02",
    "owner1": "LIN, MICHAEL",
    "owner2": "NAGENDRA, DIVYAH",
    "current_taxes": 12564.75,
    "new_taxes_no_override": 13107.55,
    "override_total_1": 13479.46,
    "override_increase_1": 371.92
  },
  {
    "#": "15 Thatcher St, Unit F1-3 (022-13-03)",
    "$": 1687700,
    "address": "15 Thatcher St, Unit F1-3",
    "parcel_id": "022-13-03",
    "owner1": "LIN TRS, SHIUEYAO & PI YU HSIN",
    "owner2": "",
    "current_taxes": 13647.11,
    "new_taxes_no_override": 14236.67,
    "override_total_1": 14640.62,
    "override_increase_1": 403.95
  },
  {
    "#": "15 Thatcher St, Unit F2-1 (022-13-04)",
    "$": 1316500,
    "address": "15 Thatcher St, Unit F2-1",
    "parcel_id": "022-13-04",
    "owner1": "EVANS TR, JANET ANN",
    "owner2": "",
    "current_taxes": 9846.03,
    "new_taxes_no_override": 10271.38,
    "override_total_1": 10562.82,
    "override_increase_1": 291.44
  },
  {
    "#": "15 Thatcher St, Unit F2-2 (022-13-05)",
    "$": 1398000,
    "address": "15 Thatcher St, Unit F2-2",
    "parcel_id": "022-13-05",
    "owner1": "RAJAB-BUDLENDER, NASREEN",
    "owner2": "BUDLENDER, STEVEN",
    "current_taxes": 10680.59,
    "new_taxes_no_override": 11141.99,
    "override_total_1": 11458.14,
    "override_increase_1": 316.15
  },
  {
    "#": "15 Thatcher St, Unit F2-3 (022-13-06)",
    "$": 1397800,
    "address": "15 Thatcher St, Unit F2-3",
    "parcel_id": "022-13-06",
    "owner1": "PHELPS, FAWN",
    "owner2": "MITTLELMAN, MICHAEL J",
    "current_taxes": 10678.54,
    "new_taxes_no_override": 11139.85,
    "override_total_1": 11455.94,
    "override_increase_1": 316.08
  },
  {
    "#": "19 Thatcher St, Unit E1-1 (022-15-01)",
    "$": 1327800,
    "address": "19 Thatcher St, Unit E1-1",
    "parcel_id": "022-15-01",
    "owner1": "WHEELER-CARREIRO TRS, SHELLEY C",
    "owner2": "CARREIRO, ERIN P",
    "current_taxes": 9961.74,
    "new_taxes_no_override": 10392.09,
    "override_total_1": 10686.95,
    "override_increase_1": 294.87
  },
  {
    "#": "19 Thatcher St, Unit E1-2 (022-15-02)",
    "$": 1325800,
    "address": "19 Thatcher St, Unit E1-2",
    "parcel_id": "022-15-02",
    "owner1": "FORCHHEIMER, JODY E",
    "owner2": "KAPLOW, LOUIS",
    "current_taxes": 9941.26,
    "new_taxes_no_override": 10370.72,
    "override_total_1": 10664.98,
    "override_increase_1": 294.26
  },
  {
    "#": "19 Thatcher St, Unit E1-3 (022-15-03)",
    "$": 1397900,
    "address": "19 Thatcher St, Unit E1-3",
    "parcel_id": "022-15-03",
    "owner1": "HOLLIDAY, ALEXANDER & KATHERINE M",
    "owner2": "",
    "current_taxes": 14314.5,
    "new_taxes_no_override": 14932.89,
    "override_total_1": 15356.6,
    "override_increase_1": 423.71
  },
  {
    "#": "19 Thatcher St, Unit E2-1 (022-15-04)",
    "$": 1378500,
    "address": "19 Thatcher St, Unit E2-1",
    "parcel_id": "022-15-04",
    "owner1": "YE, HAI",
    "owner2": "WANG, HONGYI",
    "current_taxes": 14115.84,
    "new_taxes_no_override": 14725.64,
    "override_total_1": 15143.47,
    "override_increase_1": 417.83
  },
  {
    "#": "19 Thatcher St, Unit E2-2 & P37 (022-15-05)",
    "$": 1363500,
    "address": "19 Thatcher St, Unit E2-2 & P37",
    "parcel_id": "022-15-05",
    "owner1": "LEAF-HERRMANN, WILLIAM A & SARAH",
    "owner2": "",
    "current_taxes": 10327.31,
    "new_taxes_no_override": 10773.45,
    "override_total_1": 11079.14,
    "override_increase_1": 305.69
  },
  {
    "#": "19 Thatcher St, Unit E2-3 (022-15-06)",
    "$": 1397900,
    "address": "19 Thatcher St, Unit E2-3",
    "parcel_id": "022-15-06",
    "owner1": "RUBINOW, STUART P",
    "owner2": "ROOSEVELT, LUCY M",
    "current_taxes": 10679.56,
    "new_taxes_no_override": 11140.92,
    "override_total_1": 11457.03,
    "override_increase_1": 316.11
  },
  {
    "#": "25 Thatcher St, Unit D1-1 (022-17-01)",
    "$": 1307500,
    "address": "25 Thatcher St, Unit D1-1",
    "parcel_id": "022-17-01",
    "owner1": "GOLDSMITH, GARY N",
    "owner2": "",
    "current_taxes": 9753.87,
    "new_taxes_no_override": 10175.24,
    "override_total_1": 10463.95,
    "override_increase_1": 288.71
  },
  {
    "#": "25 Thatcher St, Unit D1-2 & Pk (022-17-02)",
    "$": 1397800,
    "address": "25 Thatcher St, Unit D1-2 & Pk",
    "parcel_id": "022-17-02",
    "owner1": "LEEDS TR, ELIZABETH R",
    "owner2": "",
    "current_taxes": 10678.54,
    "new_taxes_no_override": 11139.85,
    "override_total_1": 11455.94,
    "override_increase_1": 316.08
  },
  {
    "#": "25 Thatcher St, Unit D1-3 (022-17-03)",
    "$": 1385000,
    "address": "25 Thatcher St, Unit D1-3",
    "parcel_id": "022-17-03",
    "owner1": "LIN, DIAN",
    "owner2": "FEATHERSTON, JOSEPH",
    "current_taxes": 10547.47,
    "new_taxes_no_override": 11003.12,
    "override_total_1": 11315.33,
    "override_increase_1": 312.21
  },
  {
    "#": "25 Thatcher St, Unit D2-1 (022-17-04)",
    "$": 681800,
    "address": "25 Thatcher St, Unit D2-1",
    "parcel_id": "022-17-04",
    "owner1": "CHAN, DIANE - PAK KIN - MEE YOI",
    "owner2": "",
    "current_taxes": 6981.63,
    "new_taxes_no_override": 7283.24,
    "override_total_1": 7489.89,
    "override_increase_1": 206.66
  },
  {
    "#": "25 Thatcher St, Unit D2-1A (022-17-05)",
    "$": 911100,
    "address": "25 Thatcher St, Unit D2-1A",
    "parcel_id": "022-17-05",
    "owner1": "SASSOON, EDMUND",
    "owner2": "C/O SHEBAIRO",
    "current_taxes": 9329.66,
    "new_taxes_no_override": 9732.7,
    "override_total_1": 10008.86,
    "override_increase_1": 276.16
  },
  {
    "#": "25 Thatcher St, Unit D2-2 (022-17-06)",
    "$": 1582100,
    "address": "25 Thatcher St, Unit D2-2",
    "parcel_id": "022-17-06",
    "owner1": "DIXON, JOHN M",
    "owner2": "SATER, RACHEL M",
    "current_taxes": 12565.77,
    "new_taxes_no_override": 13108.61,
    "override_total_1": 13480.56,
    "override_increase_1": 371.95
  },
  {
    "#": "25 Thatcher St, Unit D2-3 & P30 (022-17-07)",
    "$": 1687700,
    "address": "25 Thatcher St, Unit D2-3 & P30",
    "parcel_id": "022-17-07",
    "owner1": "ABDEL-DAYEM, ESSMAEEL H",
    "owner2": "MOWAFI, MONA",
    "current_taxes": 13647.11,
    "new_taxes_no_override": 14236.67,
    "override_total_1": 14640.62,
    "override_increase_1": 403.95
  },
  {
    "#": "55 Thatcher St, Unit 1 (023-07-01)",
    "$": 454700,
    "address": "55 Thatcher St, Unit 1",
    "parcel_id": "023-07-01",
    "owner1": "DBF PROPERTY MANAGEMENT LLC",
    "owner2": "",
    "current_taxes": 4656.13,
    "new_taxes_no_override": 4857.27,
    "override_total_1": 4995.1,
    "override_increase_1": 137.82
  },
  {
    "#": "55 Thatcher St, Unit 1A (023-07-02)",
    "$": 376200,
    "address": "55 Thatcher St, Unit 1A",
    "parcel_id": "023-07-02",
    "owner1": "KOFMAN, GENE",
    "owner2": "",
    "current_taxes": 3852.29,
    "new_taxes_no_override": 4018.71,
    "override_total_1": 4132.74,
    "override_increase_1": 114.03
  },
  {
    "#": "55 Thatcher St, Unit 2 (023-07-03)",
    "$": 719100,
    "address": "55 Thatcher St, Unit 2",
    "parcel_id": "023-07-03",
    "owner1": "GELLIS , CATHERINE R & VICTORIA R",
    "owner2": "",
    "current_taxes": 7363.58,
    "new_taxes_no_override": 7681.69,
    "override_total_1": 7899.65,
    "override_increase_1": 217.96
  },
  {
    "#": "55 Thatcher St, Unit 3 (023-07-04)",
    "$": 483300,
    "address": "55 Thatcher St, Unit 3",
    "parcel_id": "023-07-04",
    "owner1": "ZHENG, JUE",
    "owner2": "YANG, LI DONG",
    "current_taxes": 4948.99,
    "new_taxes_no_override": 5162.79,
    "override_total_1": 5309.28,
    "override_increase_1": 146.49
  },
  {
    "#": "55 Thatcher St, Unit 3A (023-07-05)",
    "$": 376200,
    "address": "55 Thatcher St, Unit 3A",
    "parcel_id": "023-07-05",
    "owner1": "KOFMAN, GENE",
    "owner2": "",
    "current_taxes": 3852.29,
    "new_taxes_no_override": 4018.71,
    "override_total_1": 4132.74,
    "override_increase_1": 114.03
  },
  {
    "#": "55 Thatcher St, Unit 4 & P-9 (023-07-06)",
    "$": 812500,
    "address": "55 Thatcher St, Unit 4 & P-9",
    "parcel_id": "023-07-06",
    "owner1": "LIU, SONGLAN",
    "owner2": "",
    "current_taxes": 4685.07,
    "new_taxes_no_override": 4887.47,
    "override_total_1": 5026.14,
    "override_increase_1": 138.68
  },
  {
    "#": "55 Thatcher St, Unit 5 & G10-P3 (023-07-07)",
    "$": 646600,
    "address": "55 Thatcher St, Unit 5 & G10-P3",
    "parcel_id": "023-07-07",
    "owner1": "SUI, LEI",
    "owner2": "LIU, LI",
    "current_taxes": 6621.18,
    "new_taxes_no_override": 6907.21,
    "override_total_1": 7103.2,
    "override_increase_1": 195.99
  },
  {
    "#": "55 Thatcher St, Unit 5A (023-07-08)",
    "$": 338400,
    "address": "55 Thatcher St, Unit 5A",
    "parcel_id": "023-07-08",
    "owner1": "GELLIS , CATHERINE R & VICTORIA R",
    "owner2": "",
    "current_taxes": 3465.22,
    "new_taxes_no_override": 3614.92,
    "override_total_1": 3717.49,
    "override_increase_1": 102.57
  },
  {
    "#": "55 Thatcher St, Unit 6 & P6 (023-07-09)",
    "$": 812500,
    "address": "55 Thatcher St, Unit 6 & P6",
    "parcel_id": "023-07-09",
    "owner1": "WANG, XI",
    "owner2": "",
    "current_taxes": 8320.0,
    "new_taxes_no_override": 8679.42,
    "override_total_1": 8925.7,
    "override_increase_1": 246.27
  },
  {
    "#": "55 Thatcher St, Unit A & P-8 (023-07-31)",
    "$": 651500,
    "address": "55 Thatcher St, Unit A & P-8",
    "parcel_id": "023-07-31",
    "owner1": "BAGBY, KARA",
    "owner2": "",
    "current_taxes": 6671.36,
    "new_taxes_no_override": 6959.56,
    "override_total_1": 7157.04,
    "override_increase_1": 197.47
  },
  {
    "#": "55 Thatcher St, Unit G-1 (023-07-19)",
    "$": 88800,
    "address": "55 Thatcher St, Unit G-1",
    "parcel_id": "023-07-19",
    "owner1": "LYNN-JONES, SEAN & KAREN L",
    "owner2": "",
    "current_taxes": 909.31,
    "new_taxes_no_override": 948.59,
    "override_total_1": 975.51,
    "override_increase_1": 26.92
  },
  {
    "#": "55 Thatcher St, Unit G-11 (023-07-29)",
    "$": 82500,
    "address": "55 Thatcher St, Unit G-11",
    "parcel_id": "023-07-29",
    "owner1": "BELLO, MARTIN & JUDITH",
    "owner2": "",
    "current_taxes": 844.8,
    "new_taxes_no_override": 881.3,
    "override_total_1": 906.3,
    "override_increase_1": 25.01
  },
  {
    "#": "55 Thatcher St, Unit G-12 (023-07-30)",
    "$": 82500,
    "address": "55 Thatcher St, Unit G-12",
    "parcel_id": "023-07-30",
    "owner1": "LEVITAN REALTY INC",
    "owner2": "",
    "current_taxes": 844.8,
    "new_taxes_no_override": 881.3,
    "override_total_1": 906.3,
    "override_increase_1": 25.01
  },
  {
    "#": "55 Thatcher St, Unit G-2 (023-07-20)",
    "$": 88800,
    "address": "55 Thatcher St, Unit G-2",
    "parcel_id": "023-07-20",
    "owner1": "BREIBURG, TRS, BELLA",
    "owner2": "C/O MILMAN, ATTY BORIS",
    "current_taxes": 909.31,
    "new_taxes_no_override": 948.59,
    "override_total_1": 975.51,
    "override_increase_1": 26.92
  },
  {
    "#": "55 Thatcher St, Unit G-3 (023-07-21)",
    "$": 88800,
    "address": "55 Thatcher St, Unit G-3",
    "parcel_id": "023-07-21",
    "owner1": "TESIK, PATRICIA",
    "owner2": "",
    "current_taxes": 909.31,
    "new_taxes_no_override": 948.59,
    "override_total_1": 975.51,
    "override_increase_1": 26.92
  },
  {
    "#": "55 Thatcher St, Unit G-4 (023-07-22)",
    "$": 88800,
    "address": "55 Thatcher St, Unit G-4",
    "parcel_id": "023-07-22",
    "owner1": "ZHENG, JUE",
    "owner2": "YANG, LI DONG",
    "current_taxes": 909.31,
    "new_taxes_no_override": 948.59,
    "override_total_1": 975.51,
    "override_increase_1": 26.92
  },
  {
    "#": "55 Thatcher St, Unit G-5 (023-07-23)",
    "$": 90800,
    "address": "55 Thatcher St, Unit G-5",
    "parcel_id": "023-07-23",
    "owner1": "YUM, KENNY & LINDA",
    "owner2": "C/O DAVID YUM",
    "current_taxes": 929.79,
    "new_taxes_no_override": 969.96,
    "override_total_1": 997.48,
    "override_increase_1": 27.52
  },
  {
    "#": "55 Thatcher St, Unit G-7 (023-07-25)",
    "$": 90800,
    "address": "55 Thatcher St, Unit G-7",
    "parcel_id": "023-07-25",
    "owner1": "GELLIS , CATHERINE R & VICTORIA R",
    "owner2": "",
    "current_taxes": 929.79,
    "new_taxes_no_override": 969.96,
    "override_total_1": 997.48,
    "override_increase_1": 27.52
  },
  {
    "#": "55 Thatcher St, Unit G-8 (023-07-26)",
    "$": 82500,
    "address": "55 Thatcher St, Unit G-8",
    "parcel_id": "023-07-26",
    "owner1": "DBF PROPERTY MANAGEMENT LLC",
    "owner2": "",
    "current_taxes": 844.8,
    "new_taxes_no_override": 881.3,
    "override_total_1": 906.3,
    "override_increase_1": 25.01
  },
  {
    "#": "55 Thatcher St, Unit G-9 (023-07-27)",
    "$": 82500,
    "address": "55 Thatcher St, Unit G-9",
    "parcel_id": "023-07-27",
    "owner1": "PURI, SHYANG",
    "owner2": "",
    "current_taxes": 844.8,
    "new_taxes_no_override": 881.3,
    "override_total_1": 906.3,
    "override_increase_1": 25.01
  },
  {
    "#": "61 Thatcher St, Unit 1 (023-07-10)",
    "$": 593400,
    "address": "61 Thatcher St, Unit 1",
    "parcel_id": "023-07-10",
    "owner1": "LEVITAN, TRS, ANNA",
    "owner2": "",
    "current_taxes": 6076.42,
    "new_taxes_no_override": 6338.92,
    "override_total_1": 6518.78,
    "override_increase_1": 179.86
  },
  {
    "#": "61 Thatcher St, Unit 1A & G-6 (023-07-11)",
    "$": 479000,
    "address": "61 Thatcher St, Unit 1A & G-6",
    "parcel_id": "023-07-11",
    "owner1": "SCHWARTZ, TRS, MARC R & HOWARD",
    "owner2": "",
    "current_taxes": 4904.96,
    "new_taxes_no_override": 5116.85,
    "override_total_1": 5262.04,
    "override_increase_1": 145.19
  },
  {
    "#": "61 Thatcher St, Unit 2 & P11 (023-07-12)",
    "$": 607800,
    "address": "61 Thatcher St, Unit 2 & P11",
    "parcel_id": "023-07-12",
    "owner1": "ZOU, YINGDAN",
    "owner2": "",
    "current_taxes": 6223.87,
    "new_taxes_no_override": 6492.74,
    "override_total_1": 6676.97,
    "override_increase_1": 184.23
  },
  {
    "#": "61 Thatcher St, Unit 2A (023-07-13)",
    "$": 404900,
    "address": "61 Thatcher St, Unit 2A",
    "parcel_id": "023-07-13",
    "owner1": "LIU, SONGLAN",
    "owner2": "",
    "current_taxes": 4146.18,
    "new_taxes_no_override": 4325.29,
    "override_total_1": 4448.02,
    "override_increase_1": 122.73
  },
  {
    "#": "61 Thatcher St, Unit 3 & P5 (023-07-14)",
    "$": 943600,
    "address": "61 Thatcher St, Unit 3 & P5",
    "parcel_id": "023-07-14",
    "owner1": "ZHANG, FENG",
    "owner2": "CAI, HAO",
    "current_taxes": 6027.53,
    "new_taxes_no_override": 6287.92,
    "override_total_1": 6466.33,
    "override_increase_1": 178.41
  },
  {
    "#": "61 Thatcher St, Unit 4 & P4 (023-07-15)",
    "$": 928500,
    "address": "61 Thatcher St, Unit 4 & P4",
    "parcel_id": "023-07-15",
    "owner1": "CHANG, EUGENE K",
    "owner2": "LEE, CHI-HYUNG",
    "current_taxes": 9507.84,
    "new_taxes_no_override": 9918.58,
    "override_total_1": 10200.01,
    "override_increase_1": 281.43
  },
  {
    "#": "61 Thatcher St, Unit 5 (023-07-16)",
    "$": 589200,
    "address": "61 Thatcher St, Unit 5",
    "parcel_id": "023-07-16",
    "owner1": "YUM, KENNY & LINDA",
    "owner2": "C/O DAVID YUM",
    "current_taxes": 6033.41,
    "new_taxes_no_override": 6294.05,
    "override_total_1": 6472.64,
    "override_increase_1": 178.59
  },
  {
    "#": "61 Thatcher St, Unit 5A & P7 (023-07-17)",
    "$": 464000,
    "address": "61 Thatcher St, Unit 5A & P7",
    "parcel_id": "023-07-17",
    "owner1": "TIEN, JOE Y",
    "owner2": "",
    "current_taxes": 1116.43,
    "new_taxes_no_override": 1164.66,
    "override_total_1": 1197.71,
    "override_increase_1": 33.05
  },
  {
    "#": "61 Thatcher St, Unit 6 (023-07-18)",
    "$": 951700,
    "address": "61 Thatcher St, Unit 6",
    "parcel_id": "023-07-18",
    "owner1": "TESIK, PATRICIA",
    "owner2": "",
    "current_taxes": 6110.47,
    "new_taxes_no_override": 6374.44,
    "override_total_1": 6555.31,
    "override_increase_1": 180.87
  },
  {
    "#": "67 Thatcher St (023-11-00)",
    "$": 4278800,
    "address": "67 Thatcher St",
    "parcel_id": "023-11-00",
    "owner1": "67 THATCHER STREET REALTY LLC",
    "owner2": "",
    "current_taxes": 40179.98,
    "new_taxes_no_override": 41915.76,
    "override_total_1": 43105.08,
    "override_increase_1": 1189.33
  },
  {
    "#": "73 Thatcher St (023-13-00)",
    "$": 4469000,
    "address": "73 Thatcher St",
    "parcel_id": "023-13-00",
    "owner1": "73 THATCHER ST LLC",
    "owner2": "",
    "current_taxes": 45762.56,
    "new_taxes_no_override": 47739.5,
    "override_total_1": 49094.07,
    "override_increase_1": 1354.57
  },
  {
    "#": "79 Thatcher St, Unit 1 & G14 (023-14-22)",
    "$": 753900,
    "address": "79 Thatcher St, Unit 1 & G14",
    "parcel_id": "023-14-22",
    "owner1": "MORRISSEY, ROBERT",
    "owner2": "BERKELEY, REGINA C",
    "current_taxes": 4085.0,
    "new_taxes_no_override": 4261.47,
    "override_total_1": 4382.39,
    "override_increase_1": 120.92
  },
  {
    "#": "79 Thatcher St, Unit 2 & P18 (023-14-01)",
    "$": 806900,
    "address": "79 Thatcher St, Unit 2 & P18",
    "parcel_id": "023-14-01",
    "owner1": "SILVER, MITCHELL D & RACHEL E",
    "owner2": "",
    "current_taxes": 4627.72,
    "new_taxes_no_override": 4827.64,
    "override_total_1": 4964.62,
    "override_increase_1": 136.98
  },
  {
    "#": "79 Thatcher St, Unit 3 & G15 (023-14-02)",
    "$": 802400,
    "address": "79 Thatcher St, Unit 3 & G15",
    "parcel_id": "023-14-02",
    "owner1": "LEWIS TR, JAYE ELLEN",
    "owner2": "",
    "current_taxes": 4581.64,
    "new_taxes_no_override": 4779.57,
    "override_total_1": 4915.18,
    "override_increase_1": 135.62
  },
  {
    "#": "8 Thayer Pl (177-12-00)",
    "$": 2101100,
    "address": "8 Thayer Pl",
    "parcel_id": "177-12-00",
    "owner1": "GARDINER, BRIAN",
    "owner2": "PARKHURST GARDINER, CATHERINE",
    "current_taxes": 17880.33,
    "new_taxes_no_override": 18652.76,
    "override_total_1": 19182.02,
    "override_increase_1": 529.26
  },
  {
    "#": "12 Thayer Pl (177-11-00)",
    "$": 1692700,
    "address": "12 Thayer Pl",
    "parcel_id": "177-11-00",
    "owner1": "OFT, TOBY & ANDREA",
    "owner2": "",
    "current_taxes": 13698.31,
    "new_taxes_no_override": 14290.08,
    "override_total_1": 14695.55,
    "override_increase_1": 405.47
  },
  {
    "#": "16 Thayer Pl (177-10-00)",
    "$": 1626300,
    "address": "16 Thayer Pl",
    "parcel_id": "177-10-00",
    "owner1": "AHMAD, KAMRAN",
    "owner2": "",
    "current_taxes": 13018.38,
    "new_taxes_no_override": 13580.77,
    "override_total_1": 13966.12,
    "override_increase_1": 385.34
  },
  {
    "#": "18 Thayer Pl, Unit 1 (177-09-01)",
    "$": 835500,
    "address": "18 Thayer Pl, Unit 1",
    "parcel_id": "177-09-01",
    "owner1": "MACDONALD, ALAN",
    "owner2": "OKAZAKI, YOSHIKO",
    "current_taxes": 4920.59,
    "new_taxes_no_override": 5133.16,
    "override_total_1": 5278.81,
    "override_increase_1": 145.65
  },
  {
    "#": "18 Thayer Pl, Unit 2 (177-09-02)",
    "$": 835500,
    "address": "18 Thayer Pl, Unit 2",
    "parcel_id": "177-09-02",
    "owner1": "ROOCHNIK TR, DAVID L",
    "owner2": "",
    "current_taxes": 8555.52,
    "new_taxes_no_override": 8925.12,
    "override_total_1": 9178.36,
    "override_increase_1": 253.24
  },
  {
    "#": "6 Thayer St, Unit 1 (176-21-21)",
    "$": 1376900,
    "address": "6 Thayer St, Unit 1",
    "parcel_id": "176-21-21",
    "owner1": "ROSENBLEET, BENJAMIN S & SHAINA A",
    "owner2": "",
    "current_taxes": 10464.52,
    "new_taxes_no_override": 10916.59,
    "override_total_1": 11226.34,
    "override_increase_1": 309.75
  },
  {
    "#": "6 Thayer St, Unit 2 (176-21-22)",
    "$": 958000,
    "address": "6 Thayer St, Unit 2",
    "parcel_id": "176-21-22",
    "owner1": "CHEN TRS, QING & FANGFANG",
    "owner2": "",
    "current_taxes": 9809.92,
    "new_taxes_no_override": 10233.71,
    "override_total_1": 10524.08,
    "override_increase_1": 290.37
  },
  {
    "#": "6 Thayer St, Unit 3 (176-21-23)",
    "$": 952100,
    "address": "6 Thayer St, Unit 3",
    "parcel_id": "176-21-23",
    "owner1": "MCPHAIL TRS, GARY A & AYANNA O",
    "owner2": "",
    "current_taxes": 6114.57,
    "new_taxes_no_override": 6378.72,
    "override_total_1": 6559.71,
    "override_increase_1": 180.99
  },
  {
    "#": "12 Thayer St (176-20-01)",
    "$": 150000,
    "address": "12 Thayer St",
    "parcel_id": "176-20-01",
    "owner1": "BROWN TRS, JOHN P & DEBRA LEE",
    "owner2": "",
    "current_taxes": 1536.0,
    "new_taxes_no_override": 1602.36,
    "override_total_1": 1647.82,
    "override_increase_1": 45.47
  },
  {
    "#": "14 Thayer St (176-20-00)",
    "$": 1931000,
    "address": "14 Thayer St",
    "parcel_id": "176-20-00",
    "owner1": "HU, ZHAOYING",
    "owner2": "ZHANG, YUANFAN",
    "current_taxes": 16138.51,
    "new_taxes_no_override": 16835.69,
    "override_total_1": 17313.39,
    "override_increase_1": 477.7
  },
  {
    "#": "16 Thayer St (176-19-00)",
    "$": 2664200,
    "address": "16 Thayer St",
    "parcel_id": "176-19-00",
    "owner1": "DIPIRO, PAMELA J",
    "owner2": "",
    "current_taxes": 23646.47,
    "new_taxes_no_override": 24668.0,
    "override_total_1": 25367.93,
    "override_increase_1": 699.94
  },
  {
    "#": "18 Thayer St (176-18-00)",
    "$": 2648300,
    "address": "18 Thayer St",
    "parcel_id": "176-18-00",
    "owner1": "GANGADHARAN, SIDHU & JENNIFER",
    "owner2": "",
    "current_taxes": 23483.66,
    "new_taxes_no_override": 24498.15,
    "override_total_1": 25193.27,
    "override_increase_1": 695.12
  },
  {
    "#": "21 Thayer St, Unit 21 (177-13-01)",
    "$": 1361200,
    "address": "21 Thayer St, Unit 21",
    "parcel_id": "177-13-01",
    "owner1": "KLEIN, KATHERINE",
    "owner2": "TURNBULL, ASHLI",
    "current_taxes": 13938.69,
    "new_taxes_no_override": 14540.84,
    "override_total_1": 14953.43,
    "override_increase_1": 412.59
  },
  {
    "#": "22 Thayer St (176-17-00)",
    "$": 2293000,
    "address": "22 Thayer St",
    "parcel_id": "176-17-00",
    "owner1": "WALDESBUHL, JEROME & JODIE",
    "owner2": "",
    "current_taxes": 19845.39,
    "new_taxes_no_override": 20702.71,
    "override_total_1": 21290.13,
    "override_increase_1": 587.42
  },
  {
    "#": "23 Thayer St, Unit 23 (177-13-02)",
    "$": 1323000,
    "address": "23 Thayer St, Unit 23",
    "parcel_id": "177-13-02",
    "owner1": "GRAY, MICHAEL F",
    "owner2": "BUCKLEY, C DEIRDRE",
    "current_taxes": 9912.59,
    "new_taxes_no_override": 10340.81,
    "override_total_1": 10634.23,
    "override_increase_1": 293.41
  },
  {
    "#": "29 Thayer St (177-14-00)",
    "$": 1766300,
    "address": "29 Thayer St",
    "parcel_id": "177-14-00",
    "owner1": "LEFKOWITZ, TR, MICHAEL",
    "owner2": "",
    "current_taxes": 14451.98,
    "new_taxes_no_override": 15076.31,
    "override_total_1": 15504.08,
    "override_increase_1": 427.78
  },
  {
    "#": "2 Thorndike St, Unit 1 (075-14-01)",
    "$": 2317800,
    "address": "2 Thorndike St, Unit 1",
    "parcel_id": "075-14-01",
    "owner1": "BLONDER, GREG E & CAROLYN W",
    "owner2": "",
    "current_taxes": 20099.34,
    "new_taxes_no_override": 20967.63,
    "override_total_1": 21562.57,
    "override_increase_1": 594.94
  },
  {
    "#": "2 Thorndike St, Unit 2 (075-14-02)",
    "$": 2643400,
    "address": "2 Thorndike St, Unit 2",
    "parcel_id": "075-14-02",
    "owner1": "BERNSTEIN, SHAI BENJAMIN & DAPHNA",
    "owner2": "",
    "current_taxes": 27068.42,
    "new_taxes_no_override": 28237.78,
    "override_total_1": 29039.0,
    "override_increase_1": 801.23
  },
  {
    "#": "12 Thorndike St (075-13-00)",
    "$": 2695200,
    "address": "12 Thorndike St",
    "parcel_id": "075-13-00",
    "owner1": "DAY, RICHARD D & LORI S",
    "owner2": "",
    "current_taxes": 23963.91,
    "new_taxes_no_override": 24999.15,
    "override_total_1": 25708.48,
    "override_increase_1": 709.33
  },
  {
    "#": "17 Thorndike St (076-02-00)",
    "$": 2345800,
    "address": "17 Thorndike St",
    "parcel_id": "076-02-00",
    "owner1": "MAYO, ET AL, RICHARD M",
    "owner2": "",
    "current_taxes": 20386.06,
    "new_taxes_no_override": 21266.74,
    "override_total_1": 21870.17,
    "override_increase_1": 603.43
  },
  {
    "#": "18 Thorndike St (075-12-00)",
    "$": 3068600,
    "address": "18 Thorndike St",
    "parcel_id": "075-12-00",
    "owner1": "DESMARAIS TR, ELLEN M",
    "owner2": "BUDWAY, JOSHUA S",
    "current_taxes": 27787.53,
    "new_taxes_no_override": 28987.95,
    "override_total_1": 29810.46,
    "override_increase_1": 822.51
  },
  {
    "#": "21 Thorndike St (076-03-00)",
    "$": 2204100,
    "address": "21 Thorndike St",
    "parcel_id": "076-03-00",
    "owner1": "PIER, GERALD B",
    "owner2": "BENNETT, SUSAN E",
    "current_taxes": 18935.05,
    "new_taxes_no_override": 19753.04,
    "override_total_1": 20313.52,
    "override_increase_1": 560.48
  },
  {
    "#": "22 Thorndike St (075-11-00)",
    "$": 2189100,
    "address": "22 Thorndike St",
    "parcel_id": "075-11-00",
    "owner1": "HECHINGER, JOHN E",
    "owner2": "MORELL, RICKI A",
    "current_taxes": 18781.45,
    "new_taxes_no_override": 19592.81,
    "override_total_1": 20148.74,
    "override_increase_1": 555.93
  },
  {
    "#": "25 Thorndike St (076-04-00)",
    "$": 1952600,
    "address": "25 Thorndike St",
    "parcel_id": "076-04-00",
    "owner1": "FINKLE, JAMES M",
    "owner2": "GILZOW, SUSAN J",
    "current_taxes": 16359.69,
    "new_taxes_no_override": 17066.43,
    "override_total_1": 17550.68,
    "override_increase_1": 484.25
  },
  {
    "#": "26 Thorndike St (075-10-00)",
    "$": 2515000,
    "address": "26 Thorndike St",
    "parcel_id": "075-10-00",
    "owner1": "GOVERMAN, JEREMY & EINAV",
    "owner2": "",
    "current_taxes": 22118.67,
    "new_taxes_no_override": 23074.2,
    "override_total_1": 23728.91,
    "override_increase_1": 654.71
  },
  {
    "#": "29 Thorndike St (076-05-00)",
    "$": 3718500,
    "address": "29 Thorndike St",
    "parcel_id": "076-05-00",
    "owner1": "GANGULY TR, SOUMEN",
    "owner2": "LAHIRI TR, SUTANUKA",
    "current_taxes": 38077.44,
    "new_taxes_no_override": 39722.39,
    "override_total_1": 40849.48,
    "override_increase_1": 1127.09
  },
  {
    "#": "32 Thorndike St (075-09-00)",
    "$": 2585000,
    "address": "32 Thorndike St",
    "parcel_id": "075-09-00",
    "owner1": "PEPPER, CHARLES L",
    "owner2": "BELLAVIA, REGINA M",
    "current_taxes": 22835.47,
    "new_taxes_no_override": 23821.96,
    "override_total_1": 24497.89,
    "override_increase_1": 675.93
  },
  {
    "#": "33 Thorndike St (076-06-00)",
    "$": 2349200,
    "address": "33 Thorndike St",
    "parcel_id": "076-06-00",
    "owner1": "GORDON, GREGORY AARON & ROSEMARIE ROQUE",
    "owner2": "",
    "current_taxes": 20420.87,
    "new_taxes_no_override": 21303.05,
    "override_total_1": 21907.51,
    "override_increase_1": 604.46
  },
  {
    "#": "36 Thorndike St (075-08-00)",
    "$": 2536000,
    "address": "36 Thorndike St",
    "parcel_id": "075-08-00",
    "owner1": "LEPSON, ROBERT D",
    "owner2": "KLEIN, JOHANNA H",
    "current_taxes": 22333.71,
    "new_taxes_no_override": 23298.53,
    "override_total_1": 23959.6,
    "override_increase_1": 661.08
  },
  {
    "#": "39 Thorndike St (076-07-00)",
    "$": 2150700,
    "address": "39 Thorndike St",
    "parcel_id": "076-07-00",
    "owner1": "SERDY, SHANTI",
    "owner2": "WOLPOWITZ, DEON",
    "current_taxes": 22023.17,
    "new_taxes_no_override": 22974.57,
    "override_total_1": 23626.46,
    "override_increase_1": 651.89
  },
  {
    "#": "40 Thorndike St, Unit 1 (075-07-01)",
    "$": 2073200,
    "address": "40 Thorndike St, Unit 1",
    "parcel_id": "075-07-01",
    "owner1": "RUDIE, ANTONY R",
    "owner2": "FREEMAN, JUDI H",
    "current_taxes": 17594.63,
    "new_taxes_no_override": 18354.72,
    "override_total_1": 18875.52,
    "override_increase_1": 520.8
  },
  {
    "#": "40 Thorndike St, Unit 2 (075-07-02)",
    "$": 2313500,
    "address": "40 Thorndike St, Unit 2",
    "parcel_id": "075-07-02",
    "owner1": "LEVITT, JONATHAN & MARNI",
    "owner2": "",
    "current_taxes": 23690.24,
    "new_taxes_no_override": 24713.66,
    "override_total_1": 25414.89,
    "override_increase_1": 701.23
  },
  {
    "#": "43 Thorndike St (076-08-00)",
    "$": 2152700,
    "address": "43 Thorndike St",
    "parcel_id": "076-08-00",
    "owner1": "CHARPAK, MICHAEL",
    "owner2": "",
    "current_taxes": 22043.65,
    "new_taxes_no_override": 22995.94,
    "override_total_1": 23648.43,
    "override_increase_1": 652.49
  },
  {
    "#": "46 Thorndike St, Unit 1 (075-06-01)",
    "$": 2204700,
    "address": "46 Thorndike St, Unit 1",
    "parcel_id": "075-06-01",
    "owner1": "KARLIN, BENJAMIN",
    "owner2": "INSCO, MEGAN",
    "current_taxes": 18941.19,
    "new_taxes_no_override": 19759.45,
    "override_total_1": 20320.11,
    "override_increase_1": 560.66
  },
  {
    "#": "46 Thorndike St, Unit 2 (075-06-02)",
    "$": 2281300,
    "address": "46 Thorndike St, Unit 2",
    "parcel_id": "075-06-02",
    "owner1": "SAMMY T BONE LLC",
    "owner2": "",
    "current_taxes": 23360.51,
    "new_taxes_no_override": 24369.68,
    "override_total_1": 25061.16,
    "override_increase_1": 691.47
  },
  {
    "#": "49 Thorndike St (076-09-00)",
    "$": 2544000,
    "address": "49 Thorndike St",
    "parcel_id": "076-09-00",
    "owner1": "YOON, MICHAEL K",
    "owner2": "YAMAGUCHI, STACEY",
    "current_taxes": 22415.63,
    "new_taxes_no_override": 23383.99,
    "override_total_1": 24047.49,
    "override_increase_1": 663.5
  },
  {
    "#": "50 Thorndike St (075-05-00)",
    "$": 2584200,
    "address": "50 Thorndike St",
    "parcel_id": "075-05-00",
    "owner1": "BONEBRAKE TRS, PATRICK D",
    "owner2": "BURNS, COLLEEN A",
    "current_taxes": 22827.27,
    "new_taxes_no_override": 23813.41,
    "override_total_1": 24489.1,
    "override_increase_1": 675.69
  },
  {
    "#": "53 Thorndike St (076-10-00)",
    "$": 2595700,
    "address": "53 Thorndike St",
    "parcel_id": "076-10-00",
    "owner1": "BOGDANOV, BRANKA",
    "owner2": "",
    "current_taxes": 22945.03,
    "new_taxes_no_override": 23936.26,
    "override_total_1": 24615.43,
    "override_increase_1": 679.17
  },
  {
    "#": "54 Thorndike St, Unit 54 (075-04-01)",
    "$": 3030900,
    "address": "54 Thorndike St, Unit 54",
    "parcel_id": "075-04-01",
    "owner1": "MISRA, SIDHANT",
    "owner2": "JAIN, TARA",
    "current_taxes": 27401.48,
    "new_taxes_no_override": 28585.22,
    "override_total_1": 29396.31,
    "override_increase_1": 811.08
  },
  {
    "#": "54 Thorndike St, Unit 56 (075-04-02)",
    "$": 2962400,
    "address": "54 Thorndike St, Unit 56",
    "parcel_id": "075-04-02",
    "owner1": "GUPTA, MUNISH",
    "owner2": "",
    "current_taxes": 26700.04,
    "new_taxes_no_override": 27853.48,
    "override_total_1": 28643.8,
    "override_increase_1": 790.32
  },
  {
    "#": "57 Thorndike St (076-11-00)",
    "$": 1907200,
    "address": "57 Thorndike St",
    "parcel_id": "076-11-00",
    "owner1": "SHLAIN, VLADIMIR & LYUBOV",
    "owner2": "",
    "current_taxes": 15894.79,
    "new_taxes_no_override": 16581.44,
    "override_total_1": 17051.93,
    "override_increase_1": 470.49
  },
  {
    "#": "60 Thorndike St (075-03-00)",
    "$": 1689300,
    "address": "60 Thorndike St",
    "parcel_id": "075-03-00",
    "owner1": "SIEH TRS, PING",
    "owner2": "LEUNG, STEPHANIE",
    "current_taxes": 13663.5,
    "new_taxes_no_override": 14253.76,
    "override_total_1": 14658.2,
    "override_increase_1": 404.44
  },
  {
    "#": "77 Thorndike St (067-10-00)",
    "$": 2198500,
    "address": "77 Thorndike St",
    "parcel_id": "067-10-00",
    "owner1": "ROTHMAN, STEVEN A",
    "owner2": "",
    "current_taxes": 22512.64,
    "new_taxes_no_override": 23485.19,
    "override_total_1": 24151.56,
    "override_increase_1": 666.37
  },
  {
    "#": "78 Thorndike St (069-21-00)",
    "$": 1851600,
    "address": "78 Thorndike St",
    "parcel_id": "069-21-00",
    "owner1": "CAMPBELL, CATHERINE",
    "owner2": "",
    "current_taxes": 15325.45,
    "new_taxes_no_override": 15987.51,
    "override_total_1": 16441.14,
    "override_increase_1": 453.63
  },
  {
    "#": "81 Thorndike St, Unit 2 & P2P4 (067-11-02)",
    "$": 1598600,
    "address": "81 Thorndike St, Unit 2 & P2P4",
    "parcel_id": "067-11-02",
    "owner1": "BHANDARI, HARISH B",
    "owner2": "CORDOBA AMOROCHO, MARTHA R",
    "current_taxes": 12734.73,
    "new_taxes_no_override": 13284.87,
    "override_total_1": 13661.82,
    "override_increase_1": 376.95
  },
  {
    "#": "81 Thorndike St, Unit 81& P1P3 (067-11-01)",
    "$": 1358600,
    "address": "81 Thorndike St, Unit 81& P1P3",
    "parcel_id": "067-11-01",
    "owner1": "FISHER, MATTHEW",
    "owner2": "MCKEE, ZOE",
    "current_taxes": 10277.13,
    "new_taxes_no_override": 10721.1,
    "override_total_1": 11025.31,
    "override_increase_1": 304.2
  },
  {
    "#": "82 Thorndike St (069-20-00)",
    "$": 2937400,
    "address": "82 Thorndike St",
    "parcel_id": "069-20-00",
    "owner1": "MULLEN, ALAN C",
    "owner2": "HARRIS, MARIAN H",
    "current_taxes": 26444.04,
    "new_taxes_no_override": 27586.42,
    "override_total_1": 28369.17,
    "override_increase_1": 782.74
  },
  {
    "#": "87 Thorndike St (067-12-00)",
    "$": 2434200,
    "address": "87 Thorndike St",
    "parcel_id": "067-12-00",
    "owner1": "HERSCOVICI, STEVEN",
    "owner2": "BARE, TRACY",
    "current_taxes": 21291.27,
    "new_taxes_no_override": 22211.05,
    "override_total_1": 22841.27,
    "override_increase_1": 630.22
  },
  {
    "#": "88 Thorndike St (069-19-00)",
    "$": 2071400,
    "address": "88 Thorndike St",
    "parcel_id": "069-19-00",
    "owner1": "SHAW, CATHY SLOAT",
    "owner2": "",
    "current_taxes": 17576.2,
    "new_taxes_no_override": 18335.49,
    "override_total_1": 18855.75,
    "override_increase_1": 520.26
  },
  {
    "#": "91 Thorndike St (067-13-00)",
    "$": 2770600,
    "address": "91 Thorndike St",
    "parcel_id": "067-13-00",
    "owner1": "KNOPP TRS, KEVIN J & CHRISTINA A",
    "owner2": "",
    "current_taxes": 24736.01,
    "new_taxes_no_override": 25804.61,
    "override_total_1": 26536.79,
    "override_increase_1": 732.19
  },
  {
    "#": "92 Thorndike St (069-18-00)",
    "$": 2964400,
    "address": "92 Thorndike St",
    "parcel_id": "069-18-00",
    "owner1": "AHMAD, KAMAL & SHARMI",
    "owner2": "",
    "current_taxes": 26720.52,
    "new_taxes_no_override": 27874.85,
    "override_total_1": 28665.77,
    "override_increase_1": 790.93
  },
  {
    "#": "93 Thorndike St (067-14-00)",
    "$": 2365200,
    "address": "93 Thorndike St",
    "parcel_id": "067-14-00",
    "owner1": "SPARROW, JOSHUA D & SYLVAINE E",
    "owner2": "C/O GOULSTON & STORRS",
    "current_taxes": 24219.65,
    "new_taxes_no_override": 25265.94,
    "override_total_1": 25982.84,
    "override_increase_1": 716.9
  },
  {
    "#": "98 Thorndike St (069-17-00)",
    "$": 2248900,
    "address": "98 Thorndike St",
    "parcel_id": "069-17-00",
    "owner1": "TUCKMAN, GERALD M & JANICE P",
    "owner2": "",
    "current_taxes": 19393.8,
    "new_taxes_no_override": 20231.61,
    "override_total_1": 20805.67,
    "override_increase_1": 574.06
  },
  {
    "#": "102 Thorndike St (069-16-00)",
    "$": 2610900,
    "address": "102 Thorndike St",
    "parcel_id": "069-16-00",
    "owner1": "ARNOLD, VICTORIA J",
    "owner2": "",
    "current_taxes": 23100.68,
    "new_taxes_no_override": 24098.63,
    "override_total_1": 24782.41,
    "override_increase_1": 683.78
  },
  {
    "#": "106 Thorndike St, Unit 1 (069-15-01)",
    "$": 2040800,
    "address": "106 Thorndike St, Unit 1",
    "parcel_id": "069-15-01",
    "owner1": "WALTON, KEVIN",
    "owner2": "GRBIC, MARA",
    "current_taxes": 17262.86,
    "new_taxes_no_override": 18008.62,
    "override_total_1": 18519.6,
    "override_increase_1": 510.98
  },
  {
    "#": "106 Thorndike St, Unit 2 (069-15-02)",
    "$": 2397000,
    "address": "106 Thorndike St, Unit 2",
    "parcel_id": "069-15-02",
    "owner1": "MCCANN, MICHAEL E & MARIA DEL PILAR",
    "owner2": "",
    "current_taxes": 20910.35,
    "new_taxes_no_override": 21813.68,
    "override_total_1": 22432.62,
    "override_increase_1": 618.95
  },
  {
    "#": "107 Thorndike St (068-14-00)",
    "$": 2183800,
    "address": "107 Thorndike St",
    "parcel_id": "068-14-00",
    "owner1": "LEUNG, GARY & LILY",
    "owner2": "",
    "current_taxes": 18727.18,
    "new_taxes_no_override": 19536.19,
    "override_total_1": 20090.52,
    "override_increase_1": 554.32
  },
  {
    "#": "111 Thorndike St (068-15-00)",
    "$": 2286500,
    "address": "111 Thorndike St",
    "parcel_id": "068-15-00",
    "owner1": "DUMAS, EDWARD B",
    "owner2": "",
    "current_taxes": 19778.83,
    "new_taxes_no_override": 20633.28,
    "override_total_1": 21218.73,
    "override_increase_1": 585.45
  },
  {
    "#": "112 Thorndike St (069-14-00)",
    "$": 3453300,
    "address": "112 Thorndike St",
    "parcel_id": "069-14-00",
    "owner1": "HERNAN, MIGUEL A",
    "owner2": "HERNANDEZ DIAZ, SONIA",
    "current_taxes": 31726.86,
    "new_taxes_no_override": 33097.46,
    "override_total_1": 34036.58,
    "override_increase_1": 939.12
  },
  {
    "#": "116 Thorndike St (069-13-00)",
    "$": 2987800,
    "address": "116 Thorndike St",
    "parcel_id": "069-13-00",
    "owner1": "116 THORNDIKE STREET LLC",
    "owner2": "",
    "current_taxes": 30595.07,
    "new_taxes_no_override": 31916.78,
    "override_total_1": 32822.39,
    "override_increase_1": 905.61
  },
  {
    "#": "117 Thorndike St (068-16-00)",
    "$": 2145900,
    "address": "117 Thorndike St",
    "parcel_id": "068-16-00",
    "owner1": "RABINOVITZ LIFE ESTATE, MARLENE",
    "owner2": "",
    "current_taxes": 21974.02,
    "new_taxes_no_override": 22923.3,
    "override_total_1": 23573.73,
    "override_increase_1": 650.43
  },
  {
    "#": "121 Thorndike St (068-17-00)",
    "$": 2061000,
    "address": "121 Thorndike St",
    "parcel_id": "068-17-00",
    "owner1": "SCHLATTER, THOMAS & TANIA",
    "owner2": "",
    "current_taxes": 17469.71,
    "new_taxes_no_override": 18224.4,
    "override_total_1": 18741.5,
    "override_increase_1": 517.1
  },
  {
    "#": "122 Thorndike St (069-12-00)",
    "$": 2336500,
    "address": "122 Thorndike St",
    "parcel_id": "069-12-00",
    "owner1": "GROSSMAN, RICHARD A & HILDRETH D",
    "owner2": "",
    "current_taxes": 20290.83,
    "new_taxes_no_override": 21167.39,
    "override_total_1": 21768.0,
    "override_increase_1": 600.61
  },
  {
    "#": "126 Thorndike St, Unit 1 (069-11-01)",
    "$": 1909000,
    "address": "126 Thorndike St, Unit 1",
    "parcel_id": "069-11-01",
    "owner1": "MOSSEL, JOSEPH & NOA RON",
    "owner2": "",
    "current_taxes": 15913.23,
    "new_taxes_no_override": 16600.68,
    "override_total_1": 17071.71,
    "override_increase_1": 471.03
  },
  {
    "#": "126 Thorndike St, Unit 2 (069-11-02)",
    "$": 2007100,
    "address": "126 Thorndike St, Unit 2",
    "parcel_id": "069-11-02",
    "owner1": "KESSLER, BRUCE & HRISTIYANIYA",
    "owner2": "",
    "current_taxes": 16917.77,
    "new_taxes_no_override": 17648.62,
    "override_total_1": 18149.38,
    "override_increase_1": 500.77
  },
  {
    "#": "127 Thorndike St (068-18-00)",
    "$": 2690200,
    "address": "127 Thorndike St",
    "parcel_id": "068-18-00",
    "owner1": "JACOBS TRS, MARTIN A & DEBORAH E BLACKMAN",
    "owner2": "",
    "current_taxes": 27547.65,
    "new_taxes_no_override": 28737.71,
    "override_total_1": 29553.12,
    "override_increase_1": 815.41
  },
  {
    "#": "130 Thorndike St (069-10-00)",
    "$": 2179100,
    "address": "130 Thorndike St",
    "parcel_id": "069-10-00",
    "owner1": "WING TRS, JANE M & NICHOLAS L",
    "owner2": "",
    "current_taxes": 22313.98,
    "new_taxes_no_override": 23277.94,
    "override_total_1": 23938.44,
    "override_increase_1": 660.49
  },
  {
    "#": "131 Thorndike St (068-19-00)",
    "$": 2345900,
    "address": "131 Thorndike St",
    "parcel_id": "068-19-00",
    "owner1": "GARBER , EDWARD M",
    "owner2": "",
    "current_taxes": 24022.02,
    "new_taxes_no_override": 25059.77,
    "override_total_1": 25770.82,
    "override_increase_1": 711.05
  },
  {
    "#": "135 Thorndike St, Unit 1 (068-20-01)",
    "$": 2058600,
    "address": "135 Thorndike St, Unit 1",
    "parcel_id": "068-20-01",
    "owner1": "THOMASSON, RODOLPHE T & AGATHE VERNET",
    "owner2": "",
    "current_taxes": 17445.13,
    "new_taxes_no_override": 18198.76,
    "override_total_1": 18715.14,
    "override_increase_1": 516.38
  },
  {
    "#": "135 Thorndike St, Unit 2 (068-20-02)",
    "$": 2230800,
    "address": "135 Thorndike St, Unit 2",
    "parcel_id": "068-20-02",
    "owner1": "LYONS, MICHAEL J & MARY C",
    "owner2": "",
    "current_taxes": 19208.46,
    "new_taxes_no_override": 20038.27,
    "override_total_1": 20606.84,
    "override_increase_1": 568.57
  },
  {
    "#": "136 Thorndike St, Unit 1 (069-09-01)",
    "$": 2164900,
    "address": "136 Thorndike St, Unit 1",
    "parcel_id": "069-09-01",
    "owner1": "GOLD TRS, ALEXANDRA J",
    "owner2": "KEMPE, JOSEPH C",
    "current_taxes": 18533.64,
    "new_taxes_no_override": 19334.29,
    "override_total_1": 19882.89,
    "override_increase_1": 548.6
  },
  {
    "#": "136 Thorndike St, Unit 2 (069-09-02)",
    "$": 2246500,
    "address": "136 Thorndike St, Unit 2",
    "parcel_id": "069-09-02",
    "owner1": "ZHANG, JIAN",
    "owner2": "WANG, SENSEN X",
    "current_taxes": 19369.23,
    "new_taxes_no_override": 20205.98,
    "override_total_1": 20779.31,
    "override_increase_1": 573.33
  },
  {
    "#": "140 Thorndike St, Unit 1 (069-08-01)",
    "$": 2014900,
    "address": "140 Thorndike St, Unit 1",
    "parcel_id": "069-08-01",
    "owner1": "ROLPH, TIMOTHY & ELAINE",
    "owner2": "",
    "current_taxes": 20632.58,
    "new_taxes_no_override": 21523.91,
    "override_total_1": 22134.63,
    "override_increase_1": 610.72
  },
  {
    "#": "140 Thorndike St, Unit 2 (069-08-02)",
    "$": 2353400,
    "address": "140 Thorndike St, Unit 2",
    "parcel_id": "069-08-02",
    "owner1": "THORNDIKE STREET LLC",
    "owner2": "",
    "current_taxes": 24098.82,
    "new_taxes_no_override": 25139.89,
    "override_total_1": 25853.21,
    "override_increase_1": 713.33
  },
  {
    "#": "141 Thorndike St (068-21-00)",
    "$": 2948100,
    "address": "141 Thorndike St",
    "parcel_id": "068-21-00",
    "owner1": "OLKEN, BENJAMIN A",
    "owner2": "FINKELSTEIN, AMY N",
    "current_taxes": 26553.61,
    "new_taxes_no_override": 27700.73,
    "override_total_1": 28486.71,
    "override_increase_1": 785.99
  },
  {
    "#": "144 Thorndike St, Unit A (069-07-01)",
    "$": 1473300,
    "address": "144 Thorndike St, Unit A",
    "parcel_id": "069-07-01",
    "owner1": "GOLI, JAYANTHY",
    "owner2": "",
    "current_taxes": 15086.59,
    "new_taxes_no_override": 15738.33,
    "override_total_1": 16184.89,
    "override_increase_1": 446.56
  },
  {
    "#": "147 Thorndike St (068-22-00)",
    "$": 2887000,
    "address": "147 Thorndike St",
    "parcel_id": "068-22-00",
    "owner1": "REINDORF, NICOLE R",
    "owner2": "",
    "current_taxes": 25927.95,
    "new_taxes_no_override": 27048.04,
    "override_total_1": 27815.5,
    "override_increase_1": 767.47
  },
  {
    "#": "148 Thorndike St, Unit B (069-07-02)",
    "$": 1495100,
    "address": "148 Thorndike St, Unit B",
    "parcel_id": "069-07-02",
    "owner1": "KONG, SAU WAN",
    "owner2": "LAU, YAT PI NG",
    "current_taxes": 15309.82,
    "new_taxes_no_override": 15971.2,
    "override_total_1": 16424.37,
    "override_increase_1": 453.17
  },
  {
    "#": "154 Thorndike St (069-06-00)",
    "$": 2763100,
    "address": "154 Thorndike St",
    "parcel_id": "069-06-00",
    "owner1": "YEE TR, NINOTCHKA Y P",
    "owner2": "",
    "current_taxes": 28294.14,
    "new_taxes_no_override": 29516.45,
    "override_total_1": 30353.95,
    "override_increase_1": 837.51
  },
  {
    "#": "157 Thorndike St (060-05-00)",
    "$": 3174400,
    "address": "157 Thorndike St",
    "parcel_id": "060-05-00",
    "owner1": "LAU, YAT PING",
    "owner2": "KONG, SAU WAU",
    "current_taxes": 32505.86,
    "new_taxes_no_override": 33910.11,
    "override_total_1": 34872.29,
    "override_increase_1": 962.17
  },
  {
    "#": "158 Thorndike St (069-05-00)",
    "$": 2626400,
    "address": "158 Thorndike St",
    "parcel_id": "069-05-00",
    "owner1": "SHAFER TR, PAUL M",
    "owner2": "CHIN TR, DENNIS R",
    "current_taxes": 26894.34,
    "new_taxes_no_override": 28056.18,
    "override_total_1": 28852.25,
    "override_increase_1": 796.07
  },
  {
    "#": "160 Thorndike St, Unit 1 (069-04-01)",
    "$": 885700,
    "address": "160 Thorndike St, Unit 1",
    "parcel_id": "069-04-01",
    "owner1": "O'REILLY TR, J ARCHER III",
    "owner2": "",
    "current_taxes": 5434.63,
    "new_taxes_no_override": 5669.41,
    "override_total_1": 5830.27,
    "override_increase_1": 160.87
  },
  {
    "#": "160 Thorndike St, Unit 2 (069-04-02)",
    "$": 876000,
    "address": "160 Thorndike St, Unit 2",
    "parcel_id": "069-04-02",
    "owner1": "JARRETT, VINCA L",
    "owner2": "",
    "current_taxes": 5335.31,
    "new_taxes_no_override": 5565.8,
    "override_total_1": 5723.72,
    "override_increase_1": 157.93
  },
  {
    "#": "160 Thorndike St, Unit 3 (069-04-03)",
    "$": 1041000,
    "address": "160 Thorndike St, Unit 3",
    "parcel_id": "069-04-03",
    "owner1": "YOUNG, JANA",
    "owner2": "",
    "current_taxes": 7024.91,
    "new_taxes_no_override": 7328.39,
    "override_total_1": 7536.32,
    "override_increase_1": 207.94
  },
  {
    "#": "161 Thorndike St, Unit 161 (060-04-01)",
    "$": 2201200,
    "address": "161 Thorndike St, Unit 161",
    "parcel_id": "060-04-01",
    "owner1": "CROUCH, ZACHARY",
    "owner2": "",
    "current_taxes": 18905.35,
    "new_taxes_no_override": 19722.06,
    "override_total_1": 20281.66,
    "override_increase_1": 559.6
  },
  {
    "#": "161 Thorndike St, Unit 163 (060-04-02)",
    "$": 2353500,
    "address": "161 Thorndike St, Unit 163",
    "parcel_id": "060-04-02",
    "owner1": "KEMBLE, COLIN",
    "owner2": "BERLINER, JOANNA RAE",
    "current_taxes": 20464.91,
    "new_taxes_no_override": 21348.99,
    "override_total_1": 21954.76,
    "override_increase_1": 605.76
  },
  {
    "#": "164 Thorndike St (069-03-00)",
    "$": 2609800,
    "address": "164 Thorndike St",
    "parcel_id": "069-03-00",
    "owner1": "164 THORNDIKE LLC",
    "owner2": "",
    "current_taxes": 26724.35,
    "new_taxes_no_override": 27878.84,
    "override_total_1": 28669.88,
    "override_increase_1": 791.04
  },
  {
    "#": "165 Thorndike St, Unit 2 (060-03-02)",
    "$": 1570900,
    "address": "165 Thorndike St, Unit 2",
    "parcel_id": "060-03-02",
    "owner1": "CUTLIP, DONALD E & CINDY ANN",
    "owner2": "",
    "current_taxes": 12451.08,
    "new_taxes_no_override": 12988.97,
    "override_total_1": 13357.52,
    "override_increase_1": 368.55
  },
  {
    "#": "166 Thorndike St, Unit 1 (069-02-01)",
    "$": 940900,
    "address": "166 Thorndike St, Unit 1",
    "parcel_id": "069-02-01",
    "owner1": "DI MICELI, ANDREA",
    "owner2": "MARECKI, MIKHAILA",
    "current_taxes": 9634.82,
    "new_taxes_no_override": 10051.04,
    "override_total_1": 10336.23,
    "override_increase_1": 285.19
  },
  {
    "#": "166 Thorndike St, Unit 2 & P2 (069-02-02)",
    "$": 1014700,
    "address": "166 Thorndike St, Unit 2 & P2",
    "parcel_id": "069-02-02",
    "owner1": "HODGKINS, DAVID W",
    "owner2": "KIBBE, SHIELA",
    "current_taxes": 6755.59,
    "new_taxes_no_override": 7047.43,
    "override_total_1": 7247.4,
    "override_increase_1": 199.97
  },
  {
    "#": "166 Thorndike St, Unit 3 (069-02-03)",
    "$": 1007500,
    "address": "166 Thorndike St, Unit 3",
    "parcel_id": "069-02-03",
    "owner1": "BERGER, JEROME M & FRANCINE E",
    "owner2": "",
    "current_taxes": 6681.87,
    "new_taxes_no_override": 6970.53,
    "override_total_1": 7168.31,
    "override_increase_1": 197.78
  },
  {
    "#": "167 Thorndike St, Unit 1 (060-03-01)",
    "$": 1492400,
    "address": "167 Thorndike St, Unit 1",
    "parcel_id": "060-03-01",
    "owner1": "LAKOV, GERMAN & ALLA",
    "owner2": "",
    "current_taxes": 11647.24,
    "new_taxes_no_override": 12150.4,
    "override_total_1": 12495.16,
    "override_increase_1": 344.76
  },
  {
    "#": "170 Thorndike St, Unit 1 (069-01-01)",
    "$": 794500,
    "address": "170 Thorndike St, Unit 1",
    "parcel_id": "069-01-01",
    "owner1": "LUKATSKY, MIKHAIL & ILONA",
    "owner2": "",
    "current_taxes": 8135.68,
    "new_taxes_no_override": 8487.14,
    "override_total_1": 8727.96,
    "override_increase_1": 240.82
  },
  {
    "#": "170 Thorndike St, Unit 2 (069-01-02)",
    "$": 791000,
    "address": "170 Thorndike St, Unit 2",
    "parcel_id": "069-01-02",
    "owner1": "RAKUZ, SHELLYA",
    "owner2": "",
    "current_taxes": 4464.91,
    "new_taxes_no_override": 4657.79,
    "override_total_1": 4789.96,
    "override_increase_1": 132.16
  },
  {
    "#": "170 Thorndike St, Unit 3 (069-01-03)",
    "$": 945200,
    "address": "170 Thorndike St, Unit 3",
    "parcel_id": "069-01-03",
    "owner1": "ALON, ELINOR & ASSAF",
    "owner2": "",
    "current_taxes": 9678.85,
    "new_taxes_no_override": 10096.98,
    "override_total_1": 10383.47,
    "override_increase_1": 286.49
  },
  {
    "#": "171 Thorndike St, Unit 2 P-A B (060-02-01)",
    "$": 1821800,
    "address": "171 Thorndike St, Unit 2 P-A B",
    "parcel_id": "060-02-01",
    "owner1": "DEAN, SUZANNE",
    "owner2": "",
    "current_taxes": 15020.3,
    "new_taxes_no_override": 15669.18,
    "override_total_1": 16113.78,
    "override_increase_1": 444.6
  },
  {
    "#": "173 Thorndike St, Unit 1 & Prk C-D (060-02-02)",
    "$": 1642700,
    "address": "173 Thorndike St, Unit 1 & Prk C-D",
    "parcel_id": "060-02-02",
    "owner1": "KING, CHIH",
    "owner2": "WU, I HAN",
    "current_taxes": 13186.31,
    "new_taxes_no_override": 13755.96,
    "override_total_1": 14146.27,
    "override_increase_1": 390.31
  },
  {
    "#": "177 Thorndike St, Unit 1 (060-01-01)",
    "$": 2471400,
    "address": "177 Thorndike St, Unit 1",
    "parcel_id": "060-01-01",
    "owner1": "TSAI, VICKI H & ELIZABETH HON YU",
    "owner2": "",
    "current_taxes": 25307.14,
    "new_taxes_no_override": 26400.41,
    "override_total_1": 27149.5,
    "override_increase_1": 749.09
  },
  {
    "#": "177 Thorndike St, Unit 2 (060-01-02)",
    "$": 2368300,
    "address": "177 Thorndike St, Unit 2",
    "parcel_id": "060-01-02",
    "owner1": "GIDWANEY, VINAY & SANJLI",
    "owner2": "",
    "current_taxes": 20616.46,
    "new_taxes_no_override": 21507.09,
    "override_total_1": 22117.34,
    "override_increase_1": 610.25
  },
  {
    "#": "178 Thorndike St (070-01-00)",
    "$": 2607000,
    "address": "178 Thorndike St",
    "parcel_id": "070-01-00",
    "owner1": "HRT #1 PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 44736.12,
    "new_taxes_no_override": 46668.72,
    "override_total_1": 47992.91,
    "override_increase_1": 1324.19
  },
  {
    "#": "3 Thornton Rd (389-01-00)",
    "$": 997600,
    "address": "3 Thornton Rd",
    "parcel_id": "389-01-00",
    "owner1": "TETELBOYM, ELLA",
    "owner2": "",
    "current_taxes": 6580.49,
    "new_taxes_no_override": 6864.77,
    "override_total_1": 7059.55,
    "override_increase_1": 194.78
  },
  {
    "#": "4 Thornton Rd (387-10-00)",
    "$": 1074300,
    "address": "4 Thornton Rd",
    "parcel_id": "387-10-00",
    "owner1": "CHENG, PETER K & ANNIE O",
    "owner2": "",
    "current_taxes": 7365.9,
    "new_taxes_no_override": 7684.11,
    "override_total_1": 7902.14,
    "override_increase_1": 218.03
  },
  {
    "#": "10 Thornton Rd (388-01-01)",
    "$": 58513400,
    "address": "10 Thornton Rd",
    "parcel_id": "388-01-01",
    "owner1": "ROSB REALTY LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 599177.22,
    "new_taxes_no_override": 625061.68,
    "override_total_1": 642797.32,
    "override_increase_1": 17735.65
  },
  {
    "#": "7 Timon Ave (272-12-00)",
    "$": 2203200,
    "address": "7 Timon Ave",
    "parcel_id": "272-12-00",
    "owner1": "RAVASIZADEH TR, MASOUMEH",
    "owner2": "",
    "current_taxes": 22560.77,
    "new_taxes_no_override": 23535.4,
    "override_total_1": 24203.19,
    "override_increase_1": 667.8
  },
  {
    "#": "1 Toxteth St (146-06-00)",
    "$": 2345500,
    "address": "1 Toxteth St",
    "parcel_id": "146-06-00",
    "owner1": "MAHON TR, ANNE CHANDLER",
    "owner2": "",
    "current_taxes": 20382.99,
    "new_taxes_no_override": 21263.54,
    "override_total_1": 21866.87,
    "override_increase_1": 603.34
  },
  {
    "#": "9 Toxteth St (146-07-00)",
    "$": 2319200,
    "address": "9 Toxteth St",
    "parcel_id": "146-07-00",
    "owner1": "COHEN, STEVEN",
    "owner2": "LEVIN, SUSAN",
    "current_taxes": 20113.67,
    "new_taxes_no_override": 20982.58,
    "override_total_1": 21577.95,
    "override_increase_1": 595.36
  },
  {
    "#": "12 Toxteth St (151-04-00)",
    "$": 2845300,
    "address": "12 Toxteth St",
    "parcel_id": "151-04-00",
    "owner1": "ROSEN, ERIC S",
    "owner2": "BERNSTEIN, SARAH N",
    "current_taxes": 25500.94,
    "new_taxes_no_override": 26602.58,
    "override_total_1": 27357.41,
    "override_increase_1": 754.83
  },
  {
    "#": "15 Toxteth St, Unit 15 (146-08-02)",
    "$": 1496800,
    "address": "15 Toxteth St, Unit 15",
    "parcel_id": "146-08-02",
    "owner1": "MORENO-GARCIA, ANTONIO",
    "owner2": "MOLA-PEREZ, MARIA J",
    "current_taxes": 11692.3,
    "new_taxes_no_override": 12197.41,
    "override_total_1": 12543.5,
    "override_increase_1": 346.09
  },
  {
    "#": "15 Toxteth St, Unit 17 (146-08-03)",
    "$": 895600,
    "address": "15 Toxteth St, Unit 17",
    "parcel_id": "146-08-03",
    "owner1": "RUSH TR, KATHLEEN",
    "owner2": "",
    "current_taxes": 5536.01,
    "new_taxes_no_override": 5775.17,
    "override_total_1": 5939.03,
    "override_increase_1": 163.87
  },
  {
    "#": "18 Toxteth St (151-03-00)",
    "$": 1992600,
    "address": "18 Toxteth St",
    "parcel_id": "151-03-00",
    "owner1": "WILLIAMSON TR, KATE H",
    "owner2": "",
    "current_taxes": 16769.29,
    "new_taxes_no_override": 17493.72,
    "override_total_1": 17990.09,
    "override_increase_1": 496.37
  },
  {
    "#": "22 Toxteth St (151-02-00)",
    "$": 2701700,
    "address": "22 Toxteth St",
    "parcel_id": "151-02-00",
    "owner1": "NABAR, NEIL",
    "owner2": "COOPER, MEGHAN",
    "current_taxes": 24030.47,
    "new_taxes_no_override": 25068.59,
    "override_total_1": 25779.89,
    "override_increase_1": 711.3
  },
  {
    "#": "23 Toxteth St (145-11-01)",
    "$": 1863400,
    "address": "23 Toxteth St",
    "parcel_id": "145-11-01",
    "owner1": "TRAVERS, EAMONN",
    "owner2": "DANFORTH, MELISSA C",
    "current_taxes": 15446.28,
    "new_taxes_no_override": 16113.56,
    "override_total_1": 16570.77,
    "override_increase_1": 457.21
  },
  {
    "#": "26 Toxteth St, Unit 3 (151-01-03)",
    "$": 1678000,
    "address": "26 Toxteth St, Unit 3",
    "parcel_id": "151-01-03",
    "owner1": "EPSTEIN TR, ADRIENNE H",
    "owner2": "",
    "current_taxes": 13547.79,
    "new_taxes_no_override": 14133.05,
    "override_total_1": 14534.07,
    "override_increase_1": 401.01
  },
  {
    "#": "29 Toxteth St (145-12-00)",
    "$": 3210200,
    "address": "29 Toxteth St",
    "parcel_id": "145-12-00",
    "owner1": "GELLER, ROGER",
    "owner2": "SUISMAN, MARJORIE",
    "current_taxes": 29237.51,
    "new_taxes_no_override": 30500.57,
    "override_total_1": 31366.0,
    "override_increase_1": 865.43
  },
  {
    "#": "56 Toxteth St (131-24-00)",
    "$": 1910900,
    "address": "56 Toxteth St",
    "parcel_id": "131-24-00",
    "owner1": "PRELACK, DAVID & KATHRINA",
    "owner2": "",
    "current_taxes": 15932.68,
    "new_taxes_no_override": 16620.97,
    "override_total_1": 17092.58,
    "override_increase_1": 471.61
  },
  {
    "#": "57 Toxteth St (130-03-00)",
    "$": 3290000,
    "address": "57 Toxteth St",
    "parcel_id": "130-03-00",
    "owner1": "CHOUMERT, FREDERIC P",
    "owner2": "ABRON-CHOUMERT, SABRINA",
    "current_taxes": 30054.67,
    "new_taxes_no_override": 31353.03,
    "override_total_1": 32242.65,
    "override_increase_1": 889.62
  },
  {
    "#": "61 Toxteth St (130-04-00)",
    "$": 1890300,
    "address": "61 Toxteth St",
    "parcel_id": "130-04-00",
    "owner1": "ZAND TRS, LOUIS J",
    "owner2": "HOLDEN, LYNN",
    "current_taxes": 15721.74,
    "new_taxes_no_override": 16400.92,
    "override_total_1": 16866.28,
    "override_increase_1": 465.36
  },
  {
    "#": "62 Toxteth St, Unit 62 (131-23-01)",
    "$": 3363800,
    "address": "62 Toxteth St, Unit 62",
    "parcel_id": "131-23-01",
    "owner1": "BECK, DANIEL T",
    "owner2": "FISHER, DEBORAH",
    "current_taxes": 30810.38,
    "new_taxes_no_override": 32141.39,
    "override_total_1": 33053.38,
    "override_increase_1": 911.99
  },
  {
    "#": "62 Toxteth St, Unit 64 (131-23-02)",
    "$": 3339900,
    "address": "62 Toxteth St, Unit 64",
    "parcel_id": "131-23-02",
    "owner1": "WOLPIN, BRIAN M",
    "owner2": "MCKAY, ELIZABETH ANNE",
    "current_taxes": 30565.64,
    "new_taxes_no_override": 31886.08,
    "override_total_1": 32790.82,
    "override_increase_1": 904.74
  },
  {
    "#": "65 Toxteth St (130-05-00)",
    "$": 2664800,
    "address": "65 Toxteth St",
    "parcel_id": "130-05-00",
    "owner1": "BROWN, CHARLES A III & KATHRYN L",
    "owner2": "",
    "current_taxes": 23652.62,
    "new_taxes_no_override": 24674.41,
    "override_total_1": 25374.53,
    "override_increase_1": 700.12
  },
  {
    "#": "66 Toxteth St (131-22-00)",
    "$": 2646800,
    "address": "66 Toxteth St",
    "parcel_id": "131-22-00",
    "owner1": "ENGEL, SAMUEL & ANNE FREEH",
    "owner2": "",
    "current_taxes": 23468.3,
    "new_taxes_no_override": 24482.13,
    "override_total_1": 25176.79,
    "override_increase_1": 694.66
  },
  {
    "#": "67 Toxteth St (130-05-01)",
    "$": 2857400,
    "address": "67 Toxteth St",
    "parcel_id": "130-05-01",
    "owner1": "CARVER, JARED J & CAROLINE C",
    "owner2": "",
    "current_taxes": 29259.78,
    "new_taxes_no_override": 30523.8,
    "override_total_1": 31389.89,
    "override_increase_1": 866.09
  },
  {
    "#": "71 Toxteth St (130-06-00)",
    "$": 2726500,
    "address": "71 Toxteth St",
    "parcel_id": "130-06-00",
    "owner1": "WALT, STEPHEN M",
    "owner2": "STONE, REBECCA E",
    "current_taxes": 24284.43,
    "new_taxes_no_override": 25333.52,
    "override_total_1": 26052.34,
    "override_increase_1": 718.82
  },
  {
    "#": "72 Toxteth St (131-21-00)",
    "$": 3548300,
    "address": "72 Toxteth St",
    "parcel_id": "131-21-00",
    "owner1": "MASON TR, GEOFFREY M",
    "owner2": "",
    "current_taxes": 36334.59,
    "new_taxes_no_override": 37904.24,
    "override_total_1": 38979.75,
    "override_increase_1": 1075.5
  },
  {
    "#": "77 Toxteth St (130-07-00)",
    "$": 2076800,
    "address": "77 Toxteth St",
    "parcel_id": "130-07-00",
    "owner1": "RAEMER TRS, WALLIS W & DANIEL B",
    "owner2": "",
    "current_taxes": 17631.5,
    "new_taxes_no_override": 18393.18,
    "override_total_1": 18915.07,
    "override_increase_1": 521.89
  },
  {
    "#": "80 Toxteth St, Unit 80 (131-20-01)",
    "$": 2821600,
    "address": "80 Toxteth St, Unit 80",
    "parcel_id": "131-20-01",
    "owner1": "PFAFF TRS, ANNE T",
    "owner2": "KELSEY, KARL T",
    "current_taxes": 28893.18,
    "new_taxes_no_override": 30141.37,
    "override_total_1": 30996.6,
    "override_increase_1": 855.24
  },
  {
    "#": "80 Toxteth St, Unit 82 (131-20-02)",
    "$": 2832400,
    "address": "80 Toxteth St, Unit 82",
    "parcel_id": "131-20-02",
    "owner1": "ANOLIC, ASHER BARAK-TOUBIN",
    "owner2": "WEISSBOURD, CORA",
    "current_taxes": 29003.78,
    "new_taxes_no_override": 30256.74,
    "override_total_1": 31115.26,
    "override_increase_1": 858.51
  },
  {
    "#": "81 Toxteth St (130-08-00)",
    "$": 3038600,
    "address": "81 Toxteth St",
    "parcel_id": "130-08-00",
    "owner1": "YODER, NICHOLAS C",
    "owner2": "TAM, JENNY M",
    "current_taxes": 27480.33,
    "new_taxes_no_override": 28667.48,
    "override_total_1": 29480.9,
    "override_increase_1": 813.42
  },
  {
    "#": "85 Toxteth St (130-26-00)",
    "$": 2185600,
    "address": "85 Toxteth St",
    "parcel_id": "130-26-00",
    "owner1": "BACHMAN, ELIZABETH & WILLIAM",
    "owner2": "",
    "current_taxes": 18745.61,
    "new_taxes_no_override": 19555.42,
    "override_total_1": 20110.29,
    "override_increase_1": 554.87
  },
  {
    "#": "86 Toxteth St (131-19-00)",
    "$": 2295000,
    "address": "86 Toxteth St",
    "parcel_id": "131-19-00",
    "owner1": "HERMOS, JOHN A & ROSALIE J",
    "owner2": "",
    "current_taxes": 19865.87,
    "new_taxes_no_override": 20724.08,
    "override_total_1": 21312.11,
    "override_increase_1": 588.03
  },
  {
    "#": "87 Toxteth St (130-27-00)",
    "$": 2202300,
    "address": "87 Toxteth St",
    "parcel_id": "130-27-00",
    "owner1": "MAIRSON TRS, HARRY G",
    "owner2": "TYSON, ANNE C",
    "current_taxes": 18916.62,
    "new_taxes_no_override": 19733.82,
    "override_total_1": 20293.75,
    "override_increase_1": 559.93
  },
  {
    "#": "90 Toxteth St (131-18-00)",
    "$": 2820500,
    "address": "90 Toxteth St",
    "parcel_id": "131-18-00",
    "owner1": "DEWART, MURRAY JR & MARY D",
    "owner2": "",
    "current_taxes": 25246.99,
    "new_taxes_no_override": 26337.66,
    "override_total_1": 27084.97,
    "override_increase_1": 747.31
  },
  {
    "#": "93 Toxteth St (130-10-00)",
    "$": 2487100,
    "address": "93 Toxteth St",
    "parcel_id": "130-10-00",
    "owner1": "ALHADEFF, PETER & BEATE",
    "owner2": "",
    "current_taxes": 21832.97,
    "new_taxes_no_override": 22776.15,
    "override_total_1": 23422.41,
    "override_increase_1": 646.26
  },
  {
    "#": "97 Toxteth St (130-11-00)",
    "$": 2479100,
    "address": "97 Toxteth St",
    "parcel_id": "130-11-00",
    "owner1": "BOHRS, HARRY",
    "owner2": "TURNER, ANNE",
    "current_taxes": 21751.05,
    "new_taxes_no_override": 22690.7,
    "override_total_1": 23334.53,
    "override_increase_1": 643.83
  },
  {
    "#": "98 Toxteth St (131-17-01)",
    "$": 3452600,
    "address": "98 Toxteth St",
    "parcel_id": "131-17-01",
    "owner1": "YUNG, TRS, THINK T & YUK C",
    "owner2": "",
    "current_taxes": 35354.62,
    "new_taxes_no_override": 36881.94,
    "override_total_1": 37928.44,
    "override_increase_1": 1046.5
  },
  {
    "#": "104 Toxteth St (131-17-00)",
    "$": 3992100,
    "address": "104 Toxteth St",
    "parcel_id": "131-17-00",
    "owner1": "LEE REALTY INVESTMENTS LLC",
    "owner2": "",
    "current_taxes": 40879.1,
    "new_taxes_no_override": 42645.08,
    "override_total_1": 43855.1,
    "override_increase_1": 1210.02
  },
  {
    "#": "19 Tully St (425-07-01)",
    "$": 1041100,
    "address": "19 Tully St",
    "parcel_id": "425-07-01",
    "owner1": "BERGER, TR, STANLEY G",
    "owner2": "HDC INC",
    "current_taxes": 17865.28,
    "new_taxes_no_override": 18637.06,
    "override_total_1": 19165.87,
    "override_increase_1": 528.81
  },
  {
    "#": "7 University Rd (217-20-00)",
    "$": 2705000,
    "address": "7 University Rd",
    "parcel_id": "217-20-00",
    "owner1": "7-9 UNIVERSITY RD LLC",
    "owner2": "",
    "current_taxes": 27699.2,
    "new_taxes_no_override": 28895.81,
    "override_total_1": 29715.7,
    "override_increase_1": 819.9
  },
  {
    "#": "10 University Rd (216-19-00)",
    "$": 6314500,
    "address": "10 University Rd",
    "parcel_id": "216-19-00",
    "owner1": "10 12 UNIVERSITY ROAD LLC",
    "owner2": "",
    "current_taxes": 64660.48,
    "new_taxes_no_override": 67453.81,
    "override_total_1": 69367.76,
    "override_increase_1": 1913.95
  },
  {
    "#": "11 University Rd, Unit 1 (217-19-02)",
    "$": 997000,
    "address": "11 University Rd, Unit 1",
    "parcel_id": "217-19-02",
    "owner1": "LEE LIFE ESTATE, IN SANG",
    "owner2": "",
    "current_taxes": 6574.35,
    "new_taxes_no_override": 6858.36,
    "override_total_1": 7052.96,
    "override_increase_1": 194.6
  },
  {
    "#": "11 University Rd, Unit 2 (217-19-03)",
    "$": 1024500,
    "address": "11 University Rd, Unit 2",
    "parcel_id": "217-19-03",
    "owner1": "LOVELL, MICHAEL & BETH S",
    "owner2": "",
    "current_taxes": 6855.95,
    "new_taxes_no_override": 7152.13,
    "override_total_1": 7355.06,
    "override_increase_1": 202.94
  },
  {
    "#": "11 University Rd, Unit 3 (217-19-04)",
    "$": 1049800,
    "address": "11 University Rd, Unit 3",
    "parcel_id": "217-19-04",
    "owner1": "STEFFLBAUER, NAKEEMA & THOMAS",
    "owner2": "",
    "current_taxes": 10749.95,
    "new_taxes_no_override": 11214.35,
    "override_total_1": 11532.55,
    "override_increase_1": 318.2
  },
  {
    "#": "11 University Rd, Unit B (217-19-01)",
    "$": 572900,
    "address": "11 University Rd, Unit B",
    "parcel_id": "217-19-01",
    "owner1": "CHA TR, LORISSA",
    "owner2": "",
    "current_taxes": 5866.5,
    "new_taxes_no_override": 6119.93,
    "override_total_1": 6293.58,
    "override_increase_1": 173.65
  },
  {
    "#": "15 University Rd, Unit 21 (217-18-06)",
    "$": 429000,
    "address": "15 University Rd, Unit 21",
    "parcel_id": "217-18-06",
    "owner1": "RENTALS ONE LLC",
    "owner2": "",
    "current_taxes": 4392.96,
    "new_taxes_no_override": 4582.74,
    "override_total_1": 4712.77,
    "override_increase_1": 130.03
  },
  {
    "#": "15 University Rd, Unit 22 (217-18-07)",
    "$": 470000,
    "address": "15 University Rd, Unit 22",
    "parcel_id": "217-18-07",
    "owner1": "BOUZAGLO, OREN",
    "owner2": "",
    "current_taxes": 4812.8,
    "new_taxes_no_override": 5020.71,
    "override_total_1": 5163.17,
    "override_increase_1": 142.46
  },
  {
    "#": "15 University Rd, Unit 23 (217-18-08)",
    "$": 336100,
    "address": "15 University Rd, Unit 23",
    "parcel_id": "217-18-08",
    "owner1": "LEWIS, CARMEN B",
    "owner2": "",
    "current_taxes": 3441.66,
    "new_taxes_no_override": 3590.34,
    "override_total_1": 3692.21,
    "override_increase_1": 101.87
  },
  {
    "#": "15 University Rd, Unit 24 (217-18-09)",
    "$": 454900,
    "address": "15 University Rd, Unit 24",
    "parcel_id": "217-18-09",
    "owner1": "XU, YAQING",
    "owner2": "",
    "current_taxes": 1023.24,
    "new_taxes_no_override": 1067.44,
    "override_total_1": 1097.73,
    "override_increase_1": 30.29
  },
  {
    "#": "15 University Rd, Unit 25 (217-18-10)",
    "$": 443200,
    "address": "15 University Rd, Unit 25",
    "parcel_id": "217-18-10",
    "owner1": "VU, MINH-HOANG",
    "owner2": "SHU, SUSAN",
    "current_taxes": 4538.37,
    "new_taxes_no_override": 4734.43,
    "override_total_1": 4868.76,
    "override_increase_1": 134.34
  },
  {
    "#": "15 University Rd, Unit 26 (217-18-11)",
    "$": 436500,
    "address": "15 University Rd, Unit 26",
    "parcel_id": "217-18-11",
    "owner1": "LKCY UNO LLC",
    "owner2": "",
    "current_taxes": 4469.76,
    "new_taxes_no_override": 4662.85,
    "override_total_1": 4795.16,
    "override_increase_1": 132.3
  },
  {
    "#": "15 University Rd, Unit 31 (217-18-12)",
    "$": 429000,
    "address": "15 University Rd, Unit 31",
    "parcel_id": "217-18-12",
    "owner1": "FONG TRS, FRANCIS",
    "owner2": "WOO, PAULINE",
    "current_taxes": 4392.96,
    "new_taxes_no_override": 4582.74,
    "override_total_1": 4712.77,
    "override_increase_1": 130.03
  },
  {
    "#": "15 University Rd, Unit 32 (217-18-13)",
    "$": 470000,
    "address": "15 University Rd, Unit 32",
    "parcel_id": "217-18-13",
    "owner1": "LECLAIRE, SHANNON",
    "owner2": "",
    "current_taxes": 1177.87,
    "new_taxes_no_override": 1228.75,
    "override_total_1": 1263.62,
    "override_increase_1": 34.86
  },
  {
    "#": "15 University Rd, Unit 33 (217-18-14)",
    "$": 378600,
    "address": "15 University Rd, Unit 33",
    "parcel_id": "217-18-14",
    "owner1": "SANIEOFF TRS, SYROOS",
    "owner2": "",
    "current_taxes": 3876.86,
    "new_taxes_no_override": 4044.34,
    "override_total_1": 4159.1,
    "override_increase_1": 114.76
  },
  {
    "#": "15 University Rd, Unit 34 (217-18-15)",
    "$": 454900,
    "address": "15 University Rd, Unit 34",
    "parcel_id": "217-18-15",
    "owner1": "HOMEWELL NORFOLK LLC",
    "owner2": "",
    "current_taxes": 4658.18,
    "new_taxes_no_override": 4859.41,
    "override_total_1": 4997.3,
    "override_increase_1": 137.88
  },
  {
    "#": "15 University Rd, Unit 35 (217-18-16)",
    "$": 443200,
    "address": "15 University Rd, Unit 35",
    "parcel_id": "217-18-16",
    "owner1": "CHEN, SIYU",
    "owner2": "",
    "current_taxes": 4538.37,
    "new_taxes_no_override": 4734.43,
    "override_total_1": 4868.76,
    "override_increase_1": 134.34
  },
  {
    "#": "15 University Rd, Unit 36 (217-18-17)",
    "$": 436500,
    "address": "15 University Rd, Unit 36",
    "parcel_id": "217-18-17",
    "owner1": "ERRICO, DAVID P",
    "owner2": "",
    "current_taxes": 4469.76,
    "new_taxes_no_override": 4662.85,
    "override_total_1": 4795.16,
    "override_increase_1": 132.3
  },
  {
    "#": "15 University Rd, Unit 41 (217-18-18)",
    "$": 429000,
    "address": "15 University Rd, Unit 41",
    "parcel_id": "217-18-18",
    "owner1": "WANG, YIFEI",
    "owner2": "ZHU, YANYAN",
    "current_taxes": 4392.96,
    "new_taxes_no_override": 4582.74,
    "override_total_1": 4712.77,
    "override_increase_1": 130.03
  },
  {
    "#": "15 University Rd, Unit 42 (217-18-19)",
    "$": 470000,
    "address": "15 University Rd, Unit 42",
    "parcel_id": "217-18-19",
    "owner1": "RENTALS ONE LLC",
    "owner2": "",
    "current_taxes": 4812.8,
    "new_taxes_no_override": 5020.71,
    "override_total_1": 5163.17,
    "override_increase_1": 142.46
  },
  {
    "#": "15 University Rd, Unit 43 (217-18-20)",
    "$": 352900,
    "address": "15 University Rd, Unit 43",
    "parcel_id": "217-18-20",
    "owner1": "CUNNINGHAM TR, SUSAN",
    "owner2": "",
    "current_taxes": 361.37,
    "new_taxes_no_override": 376.98,
    "override_total_1": 387.68,
    "override_increase_1": 10.7
  },
  {
    "#": "15 University Rd, Unit 44 (217-18-21)",
    "$": 454900,
    "address": "15 University Rd, Unit 44",
    "parcel_id": "217-18-21",
    "owner1": "RIF, MARIO A",
    "owner2": "",
    "current_taxes": 1023.24,
    "new_taxes_no_override": 1067.44,
    "override_total_1": 1097.73,
    "override_increase_1": 30.29
  },
  {
    "#": "15 University Rd, Unit 45 (217-18-22)",
    "$": 443200,
    "address": "15 University Rd, Unit 45",
    "parcel_id": "217-18-22",
    "owner1": "SLATER TR, DAVID M",
    "owner2": "",
    "current_taxes": 4538.37,
    "new_taxes_no_override": 4734.43,
    "override_total_1": 4868.76,
    "override_increase_1": 134.34
  },
  {
    "#": "15 University Rd, Unit 46 (217-18-23)",
    "$": 436500,
    "address": "15 University Rd, Unit 46",
    "parcel_id": "217-18-23",
    "owner1": "SEDAR TR, ALICE L",
    "owner2": "",
    "current_taxes": 834.83,
    "new_taxes_no_override": 870.89,
    "override_total_1": 895.61,
    "override_increase_1": 24.71
  },
  {
    "#": "15 University Rd, Unit A (217-18-01)",
    "$": 335800,
    "address": "15 University Rd, Unit A",
    "parcel_id": "217-18-01",
    "owner1": "15 UNIVERSITY ROAD UNIT A LLC",
    "owner2": "",
    "current_taxes": 3438.59,
    "new_taxes_no_override": 3587.14,
    "override_total_1": 3688.92,
    "override_increase_1": 101.78
  },
  {
    "#": "15 University Rd, Unit B (217-18-02)",
    "$": 362100,
    "address": "15 University Rd, Unit B",
    "parcel_id": "217-18-02",
    "owner1": "SOO TRS, KUI TING",
    "owner2": "LOO, SWEENEY CHEE EE",
    "current_taxes": 3707.9,
    "new_taxes_no_override": 3868.08,
    "override_total_1": 3977.84,
    "override_increase_1": 109.75
  },
  {
    "#": "15 University Rd, Unit C (217-18-03)",
    "$": 311900,
    "address": "15 University Rd, Unit C",
    "parcel_id": "217-18-03",
    "owner1": "MADDEN, DARCY E",
    "owner2": "",
    "current_taxes": 3193.86,
    "new_taxes_no_override": 3331.83,
    "override_total_1": 3426.37,
    "override_increase_1": 94.54
  },
  {
    "#": "15 University Rd, Unit D (217-18-04)",
    "$": 392800,
    "address": "15 University Rd, Unit D",
    "parcel_id": "217-18-04",
    "owner1": "WANG TRS, YANG",
    "owner2": "YANG , WENZHAN",
    "current_taxes": 4022.27,
    "new_taxes_no_override": 4196.03,
    "override_total_1": 4315.09,
    "override_increase_1": 119.06
  },
  {
    "#": "15 University Rd, Unit E (217-18-05)",
    "$": 428700,
    "address": "15 University Rd, Unit E",
    "parcel_id": "217-18-05",
    "owner1": "RASAMAT TRS, EMIL & LENA",
    "owner2": "",
    "current_taxes": 4389.89,
    "new_taxes_no_override": 4579.53,
    "override_total_1": 4709.47,
    "override_increase_1": 129.94
  },
  {
    "#": "16 University Rd, Unit B (216-20-00)",
    "$": 5832600,
    "address": "16 University Rd, Unit B",
    "parcel_id": "216-20-00",
    "owner1": "16 18 UNIVERSITY ROAD LLC",
    "owner2": "",
    "current_taxes": 59725.82,
    "new_taxes_no_override": 62305.98,
    "override_total_1": 64073.86,
    "override_increase_1": 1767.88
  },
  {
    "#": "19 University Rd (217-16-00)",
    "$": 2585500,
    "address": "19 University Rd",
    "parcel_id": "217-16-00",
    "owner1": "GEE ET AL TRS, RICHARD",
    "owner2": "YEE LIFE ESTATE, WAI J",
    "current_taxes": 22840.59,
    "new_taxes_no_override": 23827.3,
    "override_total_1": 24503.38,
    "override_increase_1": 676.08
  },
  {
    "#": "22 University Rd (216-21-00)",
    "$": 5527900,
    "address": "22 University Rd",
    "parcel_id": "216-21-00",
    "owner1": "22 24 UNIVERSITY ROAD LLC",
    "owner2": "",
    "current_taxes": 56605.7,
    "new_taxes_no_override": 59051.07,
    "override_total_1": 60726.59,
    "override_increase_1": 1675.53
  },
  {
    "#": "25 University Rd (217-15-00)",
    "$": 1878500,
    "address": "25 University Rd",
    "parcel_id": "217-15-00",
    "owner1": "GLEASON, LORRAINE",
    "owner2": "",
    "current_taxes": 15600.91,
    "new_taxes_no_override": 16274.87,
    "override_total_1": 16736.66,
    "override_increase_1": 461.79
  },
  {
    "#": "29 University Rd (217-14-00)",
    "$": 2778400,
    "address": "29 University Rd",
    "parcel_id": "217-14-00",
    "owner1": "HULTS TRS, DAVID E & JOANNE L",
    "owner2": "",
    "current_taxes": 24815.88,
    "new_taxes_no_override": 25887.93,
    "override_total_1": 26622.48,
    "override_increase_1": 734.55
  },
  {
    "#": "30 University Rd (216-22-00)",
    "$": 2178200,
    "address": "30 University Rd",
    "parcel_id": "216-22-00",
    "owner1": "HONIG TR, MARGOT DENNES",
    "owner2": "",
    "current_taxes": 18669.83,
    "new_taxes_no_override": 19476.37,
    "override_total_1": 20028.99,
    "override_increase_1": 552.63
  },
  {
    "#": "34 University Rd (216-23-00)",
    "$": 2776000,
    "address": "34 University Rd",
    "parcel_id": "216-23-00",
    "owner1": "NICHOLS, WILLIAM G & ELIZABETH G",
    "owner2": "RZEPNIEWSKI, CATHERINE L N & ADAM K",
    "current_taxes": 24791.31,
    "new_taxes_no_override": 25862.29,
    "override_total_1": 26596.12,
    "override_increase_1": 733.82
  },
  {
    "#": "35 University Rd, Unit 1 (217-13-01)",
    "$": 892300,
    "address": "35 University Rd, Unit 1",
    "parcel_id": "217-13-01",
    "owner1": "GONIK, ARKADY & IRENA& MICHAEL",
    "owner2": "",
    "current_taxes": 5502.22,
    "new_taxes_no_override": 5739.92,
    "override_total_1": 5902.78,
    "override_increase_1": 162.87
  },
  {
    "#": "35 University Rd, Unit 2 (217-13-02)",
    "$": 1270400,
    "address": "35 University Rd, Unit 2",
    "parcel_id": "217-13-02",
    "owner1": "CHEN, CHENG HENG",
    "owner2": "",
    "current_taxes": 9373.96,
    "new_taxes_no_override": 9778.92,
    "override_total_1": 10056.38,
    "override_increase_1": 277.47
  },
  {
    "#": "35 University Rd, Unit 3 (217-13-03)",
    "$": 1099200,
    "address": "35 University Rd, Unit 3",
    "parcel_id": "217-13-03",
    "owner1": "OKEEFE, KEVIN M",
    "owner2": "CAO, XIAOXUE",
    "current_taxes": 7620.87,
    "new_taxes_no_override": 7950.09,
    "override_total_1": 8175.67,
    "override_increase_1": 225.58
  },
  {
    "#": "35 University Rd, Unit A (217-13-04)",
    "$": 504100,
    "address": "35 University Rd, Unit A",
    "parcel_id": "217-13-04",
    "owner1": "RAGO, KATHLEEN M",
    "owner2": "",
    "current_taxes": 1527.05,
    "new_taxes_no_override": 1593.02,
    "override_total_1": 1638.22,
    "override_increase_1": 45.2
  },
  {
    "#": "37 University Rd (217-12-00)",
    "$": 3319400,
    "address": "37 University Rd",
    "parcel_id": "217-12-00",
    "owner1": "THE EDD KAMP FAMILY LP",
    "owner2": "",
    "current_taxes": 33990.66,
    "new_taxes_no_override": 35459.06,
    "override_total_1": 36465.18,
    "override_increase_1": 1006.12
  },
  {
    "#": "40 University Rd, Unit 1 (216-24-01)",
    "$": 1968300,
    "address": "40 University Rd, Unit 1",
    "parcel_id": "216-24-01",
    "owner1": "THOMAS, LAWRENCE A  & DEBORAH W",
    "owner2": "",
    "current_taxes": 16520.46,
    "new_taxes_no_override": 17234.14,
    "override_total_1": 17723.15,
    "override_increase_1": 489.01
  },
  {
    "#": "40 University Rd, Unit 2 & P2 P3 (216-24-02)",
    "$": 2197900,
    "address": "40 University Rd, Unit 2 & P2 P3",
    "parcel_id": "216-24-02",
    "owner1": "GRUBER, JILLIAN",
    "owner2": "MORRISSEY, ERIC",
    "current_taxes": 18871.56,
    "new_taxes_no_override": 19686.81,
    "override_total_1": 20245.41,
    "override_increase_1": 558.6
  },
  {
    "#": "41 University Rd, Unit 1 & G1-G2 (217-11-01)",
    "$": 2863800,
    "address": "41 University Rd, Unit 1 & G1-G2",
    "parcel_id": "217-11-01",
    "owner1": "LEE TR, ANDREW SEUNGHWAN",
    "owner2": "",
    "current_taxes": 29325.31,
    "new_taxes_no_override": 30592.16,
    "override_total_1": 31460.19,
    "override_increase_1": 868.03
  },
  {
    "#": "41 University Rd, Unit 2 & G5-G6 (217-11-02)",
    "$": 2851800,
    "address": "41 University Rd, Unit 2 & G5-G6",
    "parcel_id": "217-11-02",
    "owner1": "GOLDBERG TR, NANCY",
    "owner2": "",
    "current_taxes": 29202.43,
    "new_taxes_no_override": 30463.97,
    "override_total_1": 31328.37,
    "override_increase_1": 864.39
  },
  {
    "#": "41 University Rd, Unit 3 & G3-G4 (217-11-03)",
    "$": 3022600,
    "address": "41 University Rd, Unit 3 & G3-G4",
    "parcel_id": "217-11-03",
    "owner1": "CHUNG, IVY",
    "owner2": "LEE, YUNG",
    "current_taxes": 30951.42,
    "new_taxes_no_override": 32288.52,
    "override_total_1": 33204.68,
    "override_increase_1": 916.16
  },
  {
    "#": "46 University Rd (216-25-00)",
    "$": 3048700,
    "address": "46 University Rd",
    "parcel_id": "216-25-00",
    "owner1": "STONE TRS, MICHAEL J & BETH D",
    "owner2": "",
    "current_taxes": 27583.75,
    "new_taxes_no_override": 28775.37,
    "override_total_1": 29591.85,
    "override_increase_1": 816.48
  },
  {
    "#": "47 University Rd (217-10-00)",
    "$": 2189200,
    "address": "47 University Rd",
    "parcel_id": "217-10-00",
    "owner1": "47 UNIVERSITY REALTY LLC",
    "owner2": "C/O SS INVESTMENTS INC",
    "current_taxes": 22417.41,
    "new_taxes_no_override": 23385.84,
    "override_total_1": 24049.4,
    "override_increase_1": 663.56
  },
  {
    "#": "53 University Rd, Unit 1 (217-09-01)",
    "$": 1182300,
    "address": "53 University Rd, Unit 1",
    "parcel_id": "217-09-01",
    "owner1": "KALEN TR, JILLIAN C",
    "owner2": "",
    "current_taxes": 12106.75,
    "new_taxes_no_override": 12629.76,
    "override_total_1": 12988.12,
    "override_increase_1": 358.36
  },
  {
    "#": "53 University Rd, Unit 2 (217-09-02)",
    "$": 1791700,
    "address": "53 University Rd, Unit 2",
    "parcel_id": "217-09-02",
    "owner1": "BEAUVALOT, BENJAMIN P & SARA M",
    "owner2": "",
    "current_taxes": 14712.07,
    "new_taxes_no_override": 15347.63,
    "override_total_1": 15783.11,
    "override_increase_1": 435.48
  },
  {
    "#": "54 University Rd (216-26-00)",
    "$": 2800800,
    "address": "54 University Rd",
    "parcel_id": "216-26-00",
    "owner1": "WILSON, GEOFFREY L & KEREN T",
    "owner2": "",
    "current_taxes": 25045.26,
    "new_taxes_no_override": 26127.22,
    "override_total_1": 26868.55,
    "override_increase_1": 741.34
  },
  {
    "#": "57 University Rd (217-08-00)",
    "$": 5378600,
    "address": "57 University Rd",
    "parcel_id": "217-08-00",
    "owner1": "57 UNIVERSITY ROAD LLC",
    "owner2": "",
    "current_taxes": 55076.86,
    "new_taxes_no_override": 57456.18,
    "override_total_1": 59086.46,
    "override_increase_1": 1630.28
  },
  {
    "#": "58 University Rd, Unit 58 (216-27-01)",
    "$": 2625000,
    "address": "58 University Rd, Unit 58",
    "parcel_id": "216-27-01",
    "owner1": "KUBIAK, RAYMOND",
    "owner2": "BAKER, MARIE DAMOUR",
    "current_taxes": 26880.0,
    "new_taxes_no_override": 28041.22,
    "override_total_1": 28836.86,
    "override_increase_1": 795.65
  },
  {
    "#": "60 University Rd, Unit 60 (216-27-02)",
    "$": 2648000,
    "address": "60 University Rd, Unit 60",
    "parcel_id": "216-27-02",
    "owner1": "SCHILLER, ILYA & ELLEN",
    "owner2": "",
    "current_taxes": 23480.59,
    "new_taxes_no_override": 24494.95,
    "override_total_1": 25189.98,
    "override_increase_1": 695.03
  },
  {
    "#": "63 University Rd, Unit A (217-07-01)",
    "$": 1132100,
    "address": "63 University Rd, Unit A",
    "parcel_id": "217-07-01",
    "owner1": "SCHILLER TRS, MIKHAIL & SOPHIE",
    "owner2": "",
    "current_taxes": 11592.7,
    "new_taxes_no_override": 12093.5,
    "override_total_1": 12436.65,
    "override_increase_1": 343.14
  },
  {
    "#": "63 University Rd, Unit B (217-07-02)",
    "$": 1810700,
    "address": "63 University Rd, Unit B",
    "parcel_id": "217-07-02",
    "owner1": "PORCO, JOHN A JR",
    "owner2": "LUZZI, KIMBERLY S",
    "current_taxes": 14906.63,
    "new_taxes_no_override": 15550.6,
    "override_total_1": 15991.83,
    "override_increase_1": 441.24
  },
  {
    "#": "64 University Rd, Unit 1 (216-28-01)",
    "$": 1148900,
    "address": "64 University Rd, Unit 1",
    "parcel_id": "216-28-01",
    "owner1": "GRANT, BENJAMIN & JACINTA",
    "owner2": "",
    "current_taxes": 11764.74,
    "new_taxes_no_override": 12272.98,
    "override_total_1": 12621.21,
    "override_increase_1": 348.24
  },
  {
    "#": "64 University Rd, Unit 2 (216-28-02)",
    "$": 1318600,
    "address": "64 University Rd, Unit 2",
    "parcel_id": "216-28-02",
    "owner1": "DEUTSCH TRS, DANIEL S & AMY L",
    "owner2": "",
    "current_taxes": 9867.53,
    "new_taxes_no_override": 10293.81,
    "override_total_1": 10585.89,
    "override_increase_1": 292.08
  },
  {
    "#": "64 University Rd, Unit 3 (216-28-03)",
    "$": 1907000,
    "address": "64 University Rd, Unit 3",
    "parcel_id": "216-28-03",
    "owner1": "OLSZEWSKI, ROSE",
    "owner2": "",
    "current_taxes": 15892.75,
    "new_taxes_no_override": 16579.32,
    "override_total_1": 17049.74,
    "override_increase_1": 470.43
  },
  {
    "#": "66 University Rd (216-29-00)",
    "$": 2451700,
    "address": "66 University Rd",
    "parcel_id": "216-29-00",
    "owner1": "YIP TRS, LINDA S & KENNETH",
    "owner2": "",
    "current_taxes": 25105.41,
    "new_taxes_no_override": 26189.96,
    "override_total_1": 26933.08,
    "override_increase_1": 743.12
  },
  {
    "#": "67 University Rd (217-06-00)",
    "$": 2810900,
    "address": "67 University Rd",
    "parcel_id": "217-06-00",
    "owner1": "CHAN, DAVID C K",
    "owner2": "",
    "current_taxes": 25148.68,
    "new_taxes_no_override": 26235.1,
    "override_total_1": 26979.5,
    "override_increase_1": 744.4
  },
  {
    "#": "69 University Rd, Unit 1 (217-05-01)",
    "$": 1852800,
    "address": "69 University Rd, Unit 1",
    "parcel_id": "217-05-01",
    "owner1": "BRAY, DOUGLAS C & NANCY L",
    "owner2": "",
    "current_taxes": 18972.67,
    "new_taxes_no_override": 19792.29,
    "override_total_1": 20353.88,
    "override_increase_1": 561.59
  },
  {
    "#": "69 University Rd, Unit 2 (217-05-02)",
    "$": 2235200,
    "address": "69 University Rd, Unit 2",
    "parcel_id": "217-05-02",
    "owner1": "RAJPAR, RAHIM A",
    "owner2": "CASAS, JENNIFER",
    "current_taxes": 19253.51,
    "new_taxes_no_override": 20085.26,
    "override_total_1": 20655.17,
    "override_increase_1": 569.9
  },
  {
    "#": "74 University Rd (216-30-00)",
    "$": 3041900,
    "address": "74 University Rd",
    "parcel_id": "216-30-00",
    "owner1": "LIPTON, TAMIR G & AMY M",
    "owner2": "",
    "current_taxes": 27514.12,
    "new_taxes_no_override": 28702.73,
    "override_total_1": 29517.15,
    "override_increase_1": 814.42
  },
  {
    "#": "79 University Rd, Unit 1 & P1 (217-04-03)",
    "$": 1371600,
    "address": "79 University Rd, Unit 1 & P1",
    "parcel_id": "217-04-03",
    "owner1": "PARODA, PRASHANT",
    "owner2": "SINGH, SHIPRA",
    "current_taxes": 10410.25,
    "new_taxes_no_override": 10859.97,
    "override_total_1": 11168.12,
    "override_increase_1": 308.14
  },
  {
    "#": "79 University Rd, Unit 2 (217-04-04)",
    "$": 1693100,
    "address": "79 University Rd, Unit 2",
    "parcel_id": "217-04-04",
    "owner1": "HOWARD, BENJAMIN",
    "owner2": "OELTJEN, NATASHA",
    "current_taxes": 13702.41,
    "new_taxes_no_override": 14294.35,
    "override_total_1": 14699.95,
    "override_increase_1": 405.59
  },
  {
    "#": "80 University Rd (216-31-00)",
    "$": 2775100,
    "address": "80 University Rd",
    "parcel_id": "216-31-00",
    "owner1": "LEVI, ALEXANDER M & OLGA E",
    "owner2": "",
    "current_taxes": 28417.02,
    "new_taxes_no_override": 29644.64,
    "override_total_1": 30485.78,
    "override_increase_1": 841.14
  },
  {
    "#": "81 University Rd (217-04-01)",
    "$": 2319700,
    "address": "81 University Rd",
    "parcel_id": "217-04-01",
    "owner1": "ADLER, WILLIAM R & SHERYL F",
    "owner2": "",
    "current_taxes": 20118.79,
    "new_taxes_no_override": 20987.92,
    "override_total_1": 21583.44,
    "override_increase_1": 595.52
  },
  {
    "#": "84 University Rd (216-32-00)",
    "$": 2730000,
    "address": "84 University Rd",
    "parcel_id": "216-32-00",
    "owner1": "HATCHETT, DEREK & CASEY",
    "owner2": "",
    "current_taxes": 24320.27,
    "new_taxes_no_override": 25370.91,
    "override_total_1": 26090.79,
    "override_increase_1": 719.88
  },
  {
    "#": "88 University Rd (216-33-00)",
    "$": 2715500,
    "address": "88 University Rd",
    "parcel_id": "216-33-00",
    "owner1": "GARLICK TRS, JONATHAN ASHER & LAUREN SCHWARTZ",
    "owner2": "",
    "current_taxes": 24171.79,
    "new_taxes_no_override": 25216.01,
    "override_total_1": 25931.5,
    "override_increase_1": 715.48
  },
  {
    "#": "89 University Rd (217-03-02)",
    "$": 3305900,
    "address": "89 University Rd",
    "parcel_id": "217-03-02",
    "owner1": "ELENTUKH, ALEXANDER",
    "owner2": "FIGO, IRINA",
    "current_taxes": 33852.42,
    "new_taxes_no_override": 35314.84,
    "override_total_1": 36316.88,
    "override_increase_1": 1002.03
  },
  {
    "#": "91 University Rd, Unit 1 (217-03-03)",
    "$": 1972800,
    "address": "91 University Rd, Unit 1",
    "parcel_id": "217-03-03",
    "owner1": "BRAMBILLA, NICOLO M",
    "owner2": "ITO, NOZOMI",
    "current_taxes": 16566.54,
    "new_taxes_no_override": 17282.21,
    "override_total_1": 17772.58,
    "override_increase_1": 490.37
  },
  {
    "#": "91 University Rd, Unit 2 (217-03-04)",
    "$": 2290600,
    "address": "91 University Rd, Unit 2",
    "parcel_id": "217-03-04",
    "owner1": "TANDON, MANISH",
    "owner2": "RAMCHANDANI, SHIRLY",
    "current_taxes": 23455.74,
    "new_taxes_no_override": 24469.03,
    "override_total_1": 25163.32,
    "override_increase_1": 694.29
  },
  {
    "#": "92 University Rd (216-34-00)",
    "$": 2393500,
    "address": "92 University Rd",
    "parcel_id": "216-34-00",
    "owner1": "SANIEOFF TRS, SYROOS & SIEON",
    "owner2": "",
    "current_taxes": 24509.44,
    "new_taxes_no_override": 25568.25,
    "override_total_1": 26293.73,
    "override_increase_1": 725.48
  },
  {
    "#": "94 University Rd, Unit 1 (216-35-01)",
    "$": 772200,
    "address": "94 University Rd, Unit 1",
    "parcel_id": "216-35-01",
    "owner1": "HOLAHAN, TIMOTHY F",
    "owner2": "MALONE, MAURA E",
    "current_taxes": 7907.33,
    "new_taxes_no_override": 8248.93,
    "override_total_1": 8482.98,
    "override_increase_1": 234.06
  },
  {
    "#": "94 University Rd, Unit 2 (216-35-02)",
    "$": 843000,
    "address": "94 University Rd, Unit 2",
    "parcel_id": "216-35-02",
    "owner1": "ROTHSTEIN, S DOUGLAS",
    "owner2": "",
    "current_taxes": 8632.32,
    "new_taxes_no_override": 9005.24,
    "override_total_1": 9260.75,
    "override_increase_1": 255.52
  },
  {
    "#": "94 University Rd, Unit 3 (216-35-03)",
    "$": 897400,
    "address": "94 University Rd, Unit 3",
    "parcel_id": "216-35-03",
    "owner1": "SCHIMMEL, GRACIELA",
    "owner2": "COVER, JAMES",
    "current_taxes": 5554.44,
    "new_taxes_no_override": 5794.39,
    "override_total_1": 5958.8,
    "override_increase_1": 164.41
  },
  {
    "#": "94 University Rd, Unit 4 (216-35-04)",
    "$": 905000,
    "address": "94 University Rd, Unit 4",
    "parcel_id": "216-35-04",
    "owner1": "LAIRD TRS, THOMAS E & CAROL A",
    "owner2": "",
    "current_taxes": 9267.2,
    "new_taxes_no_override": 9667.54,
    "override_total_1": 9941.85,
    "override_increase_1": 274.31
  },
  {
    "#": "97 University Rd (217-02-00)",
    "$": 2384900,
    "address": "97 University Rd",
    "parcel_id": "217-02-00",
    "owner1": "UNIVERSITY ROAD I LLC",
    "owner2": "",
    "current_taxes": 24421.38,
    "new_taxes_no_override": 25476.38,
    "override_total_1": 26199.26,
    "override_increase_1": 722.87
  },
  {
    "#": "98 University Rd (216-36-00)",
    "$": 2485900,
    "address": "98 University Rd",
    "parcel_id": "216-36-00",
    "owner1": "EDD KAMP FAMILY LP",
    "owner2": "",
    "current_taxes": 25455.62,
    "new_taxes_no_override": 26555.3,
    "override_total_1": 27308.79,
    "override_increase_1": 753.49
  },
  {
    "#": "103 University Rd (217-01-00)",
    "$": 2331500,
    "address": "103 University Rd",
    "parcel_id": "217-01-00",
    "owner1": "UNIVERSITY ROAD I LLC",
    "owner2": "",
    "current_taxes": 23874.56,
    "new_taxes_no_override": 24905.94,
    "override_total_1": 25612.63,
    "override_increase_1": 706.69
  },
  {
    "#": "104 University Rd (211-01-00)",
    "$": 2411000,
    "address": "104 University Rd",
    "parcel_id": "211-01-00",
    "owner1": "ASH, AVNER",
    "owner2": "REISS, ROSEMARY E",
    "current_taxes": 21053.71,
    "new_taxes_no_override": 21963.23,
    "override_total_1": 22586.42,
    "override_increase_1": 623.19
  },
  {
    "#": "107 University Rd, Unit 1 (210-28-01)",
    "$": 1341300,
    "address": "107 University Rd, Unit 1",
    "parcel_id": "210-28-01",
    "owner1": "KOKORAS, CHRISTOPHER",
    "owner2": "KOKOROS, LOUIS",
    "current_taxes": 10099.98,
    "new_taxes_no_override": 10536.3,
    "override_total_1": 10835.26,
    "override_increase_1": 298.96
  },
  {
    "#": "107 University Rd, Unit 2 (210-28-02)",
    "$": 1244400,
    "address": "107 University Rd, Unit 2",
    "parcel_id": "210-28-02",
    "owner1": "107 UNIVERSITY ROAD LLC",
    "owner2": "",
    "current_taxes": 12742.66,
    "new_taxes_no_override": 13293.14,
    "override_total_1": 13670.33,
    "override_increase_1": 377.18
  },
  {
    "#": "107 University Rd, Unit 3 (210-28-03)",
    "$": 1263300,
    "address": "107 University Rd, Unit 3",
    "parcel_id": "210-28-03",
    "owner1": "107 UNIVERSITY ROAD LLC",
    "owner2": "",
    "current_taxes": 12936.19,
    "new_taxes_no_override": 13495.03,
    "override_total_1": 13877.94,
    "override_increase_1": 382.91
  },
  {
    "#": "108 University Rd (211-02-00)",
    "$": 2125400,
    "address": "108 University Rd",
    "parcel_id": "211-02-00",
    "owner1": "POLLACK-LAGUSHENKO TR, OLGA",
    "owner2": "",
    "current_taxes": 18129.16,
    "new_taxes_no_override": 18912.34,
    "override_total_1": 19448.96,
    "override_increase_1": 536.62
  },
  {
    "#": "111 University Rd (210-27-00)",
    "$": 2647500,
    "address": "111 University Rd",
    "parcel_id": "210-27-00",
    "owner1": "111 UNIVERSITY RD LLC",
    "owner2": "",
    "current_taxes": 27110.4,
    "new_taxes_no_override": 28281.57,
    "override_total_1": 29084.04,
    "override_increase_1": 802.47
  },
  {
    "#": "114 University Rd (211-03-00)",
    "$": 3005000,
    "address": "114 University Rd",
    "parcel_id": "211-03-00",
    "owner1": "THE EDD KAMP FAMILY LP",
    "owner2": "",
    "current_taxes": 30771.2,
    "new_taxes_no_override": 32100.52,
    "override_total_1": 33011.34,
    "override_increase_1": 910.83
  },
  {
    "#": "115 University Rd, Unit 1 & G1-P4 (210-26-01)",
    "$": 1191600,
    "address": "115 University Rd, Unit 1 & G1-P4",
    "parcel_id": "210-26-01",
    "owner1": "FISZBEIN, MARTIN",
    "owner2": "SANCHEZ, LUCIA MERCEDES",
    "current_taxes": 8567.05,
    "new_taxes_no_override": 8937.15,
    "override_total_1": 9190.73,
    "override_increase_1": 253.58
  },
  {
    "#": "115 University Rd, Unit 2 & G2- G3- P5- P6 (210-26-02)",
    "$": 1904400,
    "address": "115 University Rd, Unit 2 & G2- G3- P5- P6",
    "parcel_id": "210-26-02",
    "owner1": "MARTINELLI, ROBERTA",
    "owner2": "CARMAN, CHRISTOPHER",
    "current_taxes": 15866.12,
    "new_taxes_no_override": 16551.54,
    "override_total_1": 17021.17,
    "override_increase_1": 469.64
  },
  {
    "#": "116 University Rd, Unit 1 (211-04-01)",
    "$": 1136500,
    "address": "116 University Rd, Unit 1",
    "parcel_id": "211-04-01",
    "owner1": "ROSE TRS, JONATHAN",
    "owner2": "MCCANN, KRISTEN",
    "current_taxes": 11637.76,
    "new_taxes_no_override": 12140.51,
    "override_total_1": 12484.99,
    "override_increase_1": 344.48
  },
  {
    "#": "116 University Rd, Unit 2 (211-04-02)",
    "$": 910400,
    "address": "116 University Rd, Unit 2",
    "parcel_id": "211-04-02",
    "owner1": "SAVCHENKO, EKATERINA",
    "owner2": "DALLESSANDRO TR, JON B",
    "current_taxes": 9322.5,
    "new_taxes_no_override": 9725.23,
    "override_total_1": 10001.18,
    "override_increase_1": 275.95
  },
  {
    "#": "116 University Rd, Unit 3 (211-04-03)",
    "$": 899200,
    "address": "116 University Rd, Unit 3",
    "parcel_id": "211-04-03",
    "owner1": "FOSTER, KEVIN M & MARIA FINISON",
    "owner2": "",
    "current_taxes": 5572.87,
    "new_taxes_no_override": 5813.62,
    "override_total_1": 5978.57,
    "override_increase_1": 164.96
  },
  {
    "#": "118 University Rd (211-05-00)",
    "$": 3222600,
    "address": "118 University Rd",
    "parcel_id": "211-05-00",
    "owner1": "118 UNIVERSITY ROAD LLC",
    "owner2": "C/O R A HALL & CO",
    "current_taxes": 32999.42,
    "new_taxes_no_override": 34424.99,
    "override_total_1": 35401.78,
    "override_increase_1": 976.78
  },
  {
    "#": "120 University Rd (211-06-00)",
    "$": 2540400,
    "address": "120 University Rd",
    "parcel_id": "211-06-00",
    "owner1": "120 UNIVERSITY ROAD LLC",
    "owner2": "",
    "current_taxes": 26013.7,
    "new_taxes_no_override": 27137.49,
    "override_total_1": 27907.5,
    "override_increase_1": 770.01
  },
  {
    "#": "121 University Rd, Unit 1 (210-25-02)",
    "$": 1747100,
    "address": "121 University Rd, Unit 1",
    "parcel_id": "210-25-02",
    "owner1": "KENNEDY, DANIEL P",
    "owner2": "STIVER, KAREN L",
    "current_taxes": 14255.37,
    "new_taxes_no_override": 14871.2,
    "override_total_1": 15293.16,
    "override_increase_1": 421.96
  },
  {
    "#": "121 University Rd, Unit 2 (210-25-03)",
    "$": 2222900,
    "address": "121 University Rd, Unit 2",
    "parcel_id": "210-25-03",
    "owner1": "MOLLOY, JAMES M",
    "owner2": "OROURKE, MAUREEN A",
    "current_taxes": 19127.56,
    "new_taxes_no_override": 19953.87,
    "override_total_1": 20520.05,
    "override_increase_1": 566.18
  },
  {
    "#": "125 University Rd (210-24-00)",
    "$": 2626400,
    "address": "125 University Rd",
    "parcel_id": "210-24-00",
    "owner1": "JENNESS, ET AL, KEVIN M",
    "owner2": "",
    "current_taxes": 23259.4,
    "new_taxes_no_override": 24264.21,
    "override_total_1": 24952.68,
    "override_increase_1": 688.48
  },
  {
    "#": "126 University Rd, Unit 1 (211-07-01)",
    "$": 1863300,
    "address": "126 University Rd, Unit 1",
    "parcel_id": "211-07-01",
    "owner1": "TAN, KIAN L",
    "owner2": "LUCHANSKY, SARAH",
    "current_taxes": 19080.19,
    "new_taxes_no_override": 19904.45,
    "override_total_1": 20469.23,
    "override_increase_1": 564.77
  },
  {
    "#": "126 University Rd, Unit 2 (211-07-02)",
    "$": 2128300,
    "address": "126 University Rd, Unit 2",
    "parcel_id": "211-07-02",
    "owner1": "PATTS, TIMOTHY & MARESSA",
    "owner2": "",
    "current_taxes": 18158.86,
    "new_taxes_no_override": 18943.32,
    "override_total_1": 19480.83,
    "override_increase_1": 537.5
  },
  {
    "#": "128 University Rd, Unit 1 & P1A-1B (211-08-01)",
    "$": 1324300,
    "address": "128 University Rd, Unit 1 & P1A-1B",
    "parcel_id": "211-08-01",
    "owner1": "PATEL, HETAL & KETAN",
    "owner2": "",
    "current_taxes": 13560.83,
    "new_taxes_no_override": 14146.66,
    "override_total_1": 14548.06,
    "override_increase_1": 401.4
  },
  {
    "#": "129 University Rd, Unit 1 (210-23-01)",
    "$": 1674400,
    "address": "129 University Rd, Unit 1",
    "parcel_id": "210-23-01",
    "owner1": "SUTTER, STEPHEN J & CAMILLA A",
    "owner2": "",
    "current_taxes": 17145.86,
    "new_taxes_no_override": 17886.56,
    "override_total_1": 18394.08,
    "override_increase_1": 507.52
  },
  {
    "#": "129 University Rd, Unit 2 (210-23-02)",
    "$": 1473200,
    "address": "129 University Rd, Unit 2",
    "parcel_id": "210-23-02",
    "owner1": "SUTTER, CAMILLA A & STEPHEN J",
    "owner2": "",
    "current_taxes": 11450.63,
    "new_taxes_no_override": 11945.3,
    "override_total_1": 12284.24,
    "override_increase_1": 338.94
  },
  {
    "#": "130 University Rd, Unit 2 & P2A-2B (211-08-02)",
    "$": 1248400,
    "address": "130 University Rd, Unit 2 & P2A-2B",
    "parcel_id": "211-08-02",
    "owner1": "LEVINSON, YURIY & RADMILA",
    "owner2": "",
    "current_taxes": 9148.68,
    "new_taxes_no_override": 9543.9,
    "override_total_1": 9814.7,
    "override_increase_1": 270.8
  },
  {
    "#": "134 University Rd, Unit 1 (211-09-01)",
    "$": 1123900,
    "address": "134 University Rd, Unit 1",
    "parcel_id": "211-09-01",
    "owner1": "KLEBES, JOAN K",
    "owner2": "",
    "current_taxes": 7873.8,
    "new_taxes_no_override": 8213.95,
    "override_total_1": 8447.01,
    "override_increase_1": 233.06
  },
  {
    "#": "134 University Rd, Unit 2 (211-09-02)",
    "$": 1177900,
    "address": "134 University Rd, Unit 2",
    "parcel_id": "211-09-02",
    "owner1": "BALLARD, JAMES P",
    "owner2": "VIVES, TRINIDAD",
    "current_taxes": 8426.76,
    "new_taxes_no_override": 8790.8,
    "override_total_1": 9040.23,
    "override_increase_1": 249.43
  },
  {
    "#": "135 University Rd, Unit 1 & G1 (210-22-01)",
    "$": 2135500,
    "address": "135 University Rd, Unit 1 & G1",
    "parcel_id": "210-22-01",
    "owner1": "CAR, BRUCE",
    "owner2": "ENG, VICKI",
    "current_taxes": 18232.59,
    "new_taxes_no_override": 19020.24,
    "override_total_1": 19559.92,
    "override_increase_1": 539.68
  },
  {
    "#": "135 University Rd, Unit 2 & G2 (210-22-02)",
    "$": 2233300,
    "address": "135 University Rd, Unit 2 & G2",
    "parcel_id": "210-22-02",
    "owner1": "SULLIVAN TRS, SCOTT P",
    "owner2": "GRAHAM, MICHELLE K",
    "current_taxes": 19234.06,
    "new_taxes_no_override": 20064.97,
    "override_total_1": 20634.3,
    "override_increase_1": 569.33
  },
  {
    "#": "138 University Rd (211-10-00)",
    "$": 2322500,
    "address": "138 University Rd",
    "parcel_id": "211-10-00",
    "owner1": "RYNNE, CHRISTOPHER W & SUZANNE",
    "owner2": "",
    "current_taxes": 23782.4,
    "new_taxes_no_override": 24809.8,
    "override_total_1": 25513.76,
    "override_increase_1": 703.96
  },
  {
    "#": "139 University Rd, Unit 1 (210-21-01)",
    "$": 1452300,
    "address": "139 University Rd, Unit 1",
    "parcel_id": "210-21-01",
    "owner1": "SIEMON TRS, JAMES R & ALEXANDRA C",
    "owner2": "",
    "current_taxes": 11236.62,
    "new_taxes_no_override": 11722.04,
    "override_total_1": 12054.65,
    "override_increase_1": 332.6
  },
  {
    "#": "139 University Rd, Unit 2 (210-21-02)",
    "$": 1409300,
    "address": "139 University Rd, Unit 2",
    "parcel_id": "210-21-02",
    "owner1": "SCHEDLBAUER, IRIS",
    "owner2": "SMOOLCA, MATTHEW",
    "current_taxes": 10796.3,
    "new_taxes_no_override": 11262.7,
    "override_total_1": 11582.27,
    "override_increase_1": 319.57
  },
  {
    "#": "142 University Rd (211-11-00)",
    "$": 2124400,
    "address": "142 University Rd",
    "parcel_id": "211-11-00",
    "owner1": "LEONG, ET AL, KAM KWAI",
    "owner2": "",
    "current_taxes": 18118.92,
    "new_taxes_no_override": 18901.66,
    "override_total_1": 19437.98,
    "override_increase_1": 536.32
  },
  {
    "#": "145 University Rd, Unit 1 (210-20-01)",
    "$": 1634000,
    "address": "145 University Rd, Unit 1",
    "parcel_id": "210-20-01",
    "owner1": "RAMSEYER, VALERIE",
    "owner2": "",
    "current_taxes": 13097.23,
    "new_taxes_no_override": 13663.03,
    "override_total_1": 14050.71,
    "override_increase_1": 387.68
  },
  {
    "#": "145 University Rd, Unit 2 (210-20-02)",
    "$": 1525900,
    "address": "145 University Rd, Unit 2",
    "parcel_id": "210-20-02",
    "owner1": "GURRY TRS, ADAM C & LAURA ABINERI",
    "owner2": "",
    "current_taxes": 11990.28,
    "new_taxes_no_override": 12508.26,
    "override_total_1": 12863.17,
    "override_increase_1": 354.91
  },
  {
    "#": "146 University Rd, Unit 2 (211-12-01)",
    "$": 1602700,
    "address": "146 University Rd, Unit 2",
    "parcel_id": "211-12-01",
    "owner1": "LEVENSON TR, DEBORAH",
    "owner2": "",
    "current_taxes": 16411.65,
    "new_taxes_no_override": 17120.63,
    "override_total_1": 17606.42,
    "override_increase_1": 485.78
  },
  {
    "#": "147 University Rd (210-19-00)",
    "$": 2599700,
    "address": "147 University Rd",
    "parcel_id": "210-19-00",
    "owner1": "ZABEL TRS, MOIRA R",
    "owner2": "SPOFFORD, ANDREW F",
    "current_taxes": 22985.99,
    "new_taxes_no_override": 23978.98,
    "override_total_1": 24659.37,
    "override_increase_1": 680.39
  },
  {
    "#": "148 University Rd, Unit 1 (211-12-02)",
    "$": 1178900,
    "address": "148 University Rd, Unit 1",
    "parcel_id": "211-12-02",
    "owner1": "KHAN, AMIR R",
    "owner2": "TAGLAUER, ELIZABETH S",
    "current_taxes": 12071.94,
    "new_taxes_no_override": 12593.45,
    "override_total_1": 12950.78,
    "override_increase_1": 357.33
  },
  {
    "#": "153 University Rd (210-18-00)",
    "$": 2334600,
    "address": "153 University Rd",
    "parcel_id": "210-18-00",
    "owner1": "VITOLO, THOMAS",
    "owner2": "TARANTO, JENNIFER",
    "current_taxes": 20271.37,
    "new_taxes_no_override": 21147.09,
    "override_total_1": 21747.13,
    "override_increase_1": 600.03
  },
  {
    "#": "154 University Rd (211-13-00)",
    "$": 2083500,
    "address": "154 University Rd",
    "parcel_id": "211-13-00",
    "owner1": "ALLEN, MARK H",
    "owner2": "GREENFIELD, STEPHANIE",
    "current_taxes": 17700.11,
    "new_taxes_no_override": 18464.75,
    "override_total_1": 18988.68,
    "override_increase_1": 523.92
  },
  {
    "#": "160 University Rd (211-14-00)",
    "$": 2440400,
    "address": "160 University Rd",
    "parcel_id": "211-14-00",
    "owner1": "WEST, TARA I & KEVIN M",
    "owner2": "",
    "current_taxes": 21354.76,
    "new_taxes_no_override": 22277.29,
    "override_total_1": 22909.39,
    "override_increase_1": 632.1
  },
  {
    "#": "3 Upland Rd, Unit 1 (313-08-03)",
    "$": 1011600,
    "address": "3 Upland Rd, Unit 1",
    "parcel_id": "313-08-03",
    "owner1": "ENNIS LIFE ESTATE, REITA",
    "owner2": "",
    "current_taxes": 6723.85,
    "new_taxes_no_override": 7014.32,
    "override_total_1": 7213.35,
    "override_increase_1": 199.03
  },
  {
    "#": "3 Upland Rd, Unit 2 (313-08-01)",
    "$": 1044400,
    "address": "3 Upland Rd, Unit 2",
    "parcel_id": "313-08-01",
    "owner1": "LIMON, FRANCISCO JAVIER LOPEZ",
    "owner2": "ALCANTARA, EVA MARIA DEL POZO",
    "current_taxes": 7059.72,
    "new_taxes_no_override": 7364.7,
    "override_total_1": 7573.67,
    "override_increase_1": 208.97
  },
  {
    "#": "3 Upland Rd, Unit 3 (313-08-02)",
    "$": 1089500,
    "address": "3 Upland Rd, Unit 3",
    "parcel_id": "313-08-02",
    "owner1": "CAI, TIANXI",
    "owner2": "",
    "current_taxes": 11156.48,
    "new_taxes_no_override": 11638.44,
    "override_total_1": 11968.67,
    "override_increase_1": 330.23
  },
  {
    "#": "4 Upland Rd, Unit 1 (314-05-01)",
    "$": 713600,
    "address": "4 Upland Rd, Unit 1",
    "parcel_id": "314-05-01",
    "owner1": "HILL, JASON",
    "owner2": "HATHON, ALLISON",
    "current_taxes": 7307.26,
    "new_taxes_no_override": 7622.93,
    "override_total_1": 7839.23,
    "override_increase_1": 216.29
  },
  {
    "#": "4 Upland Rd, Unit 2 (314-05-02)",
    "$": 803500,
    "address": "4 Upland Rd, Unit 2",
    "parcel_id": "314-05-02",
    "owner1": "ADAMS TR, KATHERINE BRADLEY",
    "owner2": "",
    "current_taxes": 4592.91,
    "new_taxes_no_override": 4791.32,
    "override_total_1": 4927.27,
    "override_increase_1": 135.95
  },
  {
    "#": "8 Upland Rd, Unit 1 (314-04-01)",
    "$": 1199600,
    "address": "8 Upland Rd, Unit 1",
    "parcel_id": "314-04-01",
    "owner1": "LI, YUMING",
    "owner2": "GU, WEI",
    "current_taxes": 8648.97,
    "new_taxes_no_override": 9022.61,
    "override_total_1": 9278.62,
    "override_increase_1": 256.01
  },
  {
    "#": "8 Upland Rd, Unit 2 (314-04-02)",
    "$": 1300500,
    "address": "8 Upland Rd, Unit 2",
    "parcel_id": "314-04-02",
    "owner1": "OZAKI TR, KIMBERLY A",
    "owner2": "",
    "current_taxes": 9682.19,
    "new_taxes_no_override": 10100.46,
    "override_total_1": 10387.05,
    "override_increase_1": 286.59
  },
  {
    "#": "9 Upland Rd (313-09-00)",
    "$": 2651400,
    "address": "9 Upland Rd",
    "parcel_id": "313-09-00",
    "owner1": "DAVES, ROBERT S",
    "owner2": "JACKSON, JENNIFER A",
    "current_taxes": 23515.4,
    "new_taxes_no_override": 24531.27,
    "override_total_1": 25227.32,
    "override_increase_1": 696.06
  },
  {
    "#": "10 Upland Rd (314-03-00)",
    "$": 1665800,
    "address": "10 Upland Rd",
    "parcel_id": "314-03-00",
    "owner1": "MERCER, TRS, MARY A",
    "owner2": "",
    "current_taxes": 17057.79,
    "new_taxes_no_override": 17794.69,
    "override_total_1": 18299.6,
    "override_increase_1": 504.91
  },
  {
    "#": "14 Upland Rd (314-02-00)",
    "$": 1615500,
    "address": "14 Upland Rd",
    "parcel_id": "314-02-00",
    "owner1": "HARRINGTON TR, ANNE",
    "owner2": "",
    "current_taxes": 16542.72,
    "new_taxes_no_override": 17257.37,
    "override_total_1": 17747.03,
    "override_increase_1": 489.66
  },
  {
    "#": "18 Upland Rd (314-01-00)",
    "$": 1825400,
    "address": "18 Upland Rd",
    "parcel_id": "314-01-00",
    "owner1": "GINSBERG, EDWARD S",
    "owner2": "",
    "current_taxes": 18692.1,
    "new_taxes_no_override": 19499.6,
    "override_total_1": 20052.88,
    "override_increase_1": 553.29
  },
  {
    "#": "24 Upland Rd (315-08-00)",
    "$": 1577900,
    "address": "24 Upland Rd",
    "parcel_id": "315-08-00",
    "owner1": "WANG, XIN",
    "owner2": "ZHOU, SHUANHU",
    "current_taxes": 12522.76,
    "new_taxes_no_override": 13063.74,
    "override_total_1": 13434.42,
    "override_increase_1": 370.67
  },
  {
    "#": "27 Upland Rd (313-01-00)",
    "$": 1584700,
    "address": "27 Upland Rd",
    "parcel_id": "313-01-00",
    "owner1": "CHEN, TAOTAO",
    "owner2": "KE, YUAN",
    "current_taxes": 16227.33,
    "new_taxes_no_override": 16928.35,
    "override_total_1": 17408.68,
    "override_increase_1": 480.33
  },
  {
    "#": "28 Upland Rd (315-07-00)",
    "$": 1598900,
    "address": "28 Upland Rd",
    "parcel_id": "315-07-00",
    "owner1": "SWAIM, JAMES F",
    "owner2": "MORGENSTERN, MICHELLE L",
    "current_taxes": 12737.8,
    "new_taxes_no_override": 13288.07,
    "override_total_1": 13665.11,
    "override_increase_1": 377.04
  },
  {
    "#": "30 Upland Rd (315-06-00)",
    "$": 2186800,
    "address": "30 Upland Rd",
    "parcel_id": "315-06-00",
    "owner1": "MATHEW TR, PAUL",
    "owner2": "",
    "current_taxes": 18757.9,
    "new_taxes_no_override": 19568.24,
    "override_total_1": 20123.48,
    "override_increase_1": 555.23
  },
  {
    "#": "36 Upland Rd (315-05-00)",
    "$": 1719700,
    "address": "36 Upland Rd",
    "parcel_id": "315-05-00",
    "owner1": "FISCHER, OLIVIA",
    "owner2": "FOX, CHRISTOPHER P",
    "current_taxes": 13974.79,
    "new_taxes_no_override": 14578.5,
    "override_total_1": 14992.15,
    "override_increase_1": 413.65
  },
  {
    "#": "43 Upland Rd (312-01-00)",
    "$": 3327300,
    "address": "43 Upland Rd",
    "parcel_id": "312-01-00",
    "owner1": "PEKOWSKY, MICHAEL",
    "owner2": "GLAZER, LISA",
    "current_taxes": 30436.62,
    "new_taxes_no_override": 31751.48,
    "override_total_1": 32652.41,
    "override_increase_1": 900.92
  },
  {
    "#": "51 Upland Rd (312-02-00)",
    "$": 3028500,
    "address": "51 Upland Rd",
    "parcel_id": "312-02-00",
    "owner1": "MADDOX, HILARY",
    "owner2": "",
    "current_taxes": 27376.91,
    "new_taxes_no_override": 28559.59,
    "override_total_1": 29369.95,
    "override_increase_1": 810.36
  },
  {
    "#": "52 Upland Rd (308-47-00)",
    "$": 3096400,
    "address": "52 Upland Rd",
    "parcel_id": "308-47-00",
    "owner1": "COUGHLIN, TRS, WILLIAM G & SALLY J",
    "owner2": "",
    "current_taxes": 31707.14,
    "new_taxes_no_override": 33076.89,
    "override_total_1": 34015.42,
    "override_increase_1": 938.53
  },
  {
    "#": "56 Upland Rd (308-46-00)",
    "$": 3358600,
    "address": "56 Upland Rd",
    "parcel_id": "308-46-00",
    "owner1": "GOOD, NICHOLAS M W",
    "owner2": "",
    "current_taxes": 30757.13,
    "new_taxes_no_override": 32085.84,
    "override_total_1": 32996.25,
    "override_increase_1": 910.41
  },
  {
    "#": "57 Upland Rd (312-03-00)",
    "$": 5328500,
    "address": "57 Upland Rd",
    "parcel_id": "312-03-00",
    "owner1": "WINTERSTEEN, LAURENCE & ALEXIS",
    "owner2": "",
    "current_taxes": 54563.84,
    "new_taxes_no_override": 56921.0,
    "override_total_1": 58536.09,
    "override_increase_1": 1615.09
  },
  {
    "#": "62 Upland Rd (308-45-00)",
    "$": 3380100,
    "address": "62 Upland Rd",
    "parcel_id": "308-45-00",
    "owner1": "ROTHMAN, DOV",
    "owner2": "LEBRUN, ANNE",
    "current_taxes": 30977.29,
    "new_taxes_no_override": 32315.51,
    "override_total_1": 33232.44,
    "override_increase_1": 916.93
  },
  {
    "#": "65 Upland Rd (312-04-07)",
    "$": 3156900,
    "address": "65 Upland Rd",
    "parcel_id": "312-04-07",
    "owner1": "WILSON, JAMES M & M JANE",
    "owner2": "",
    "current_taxes": 28691.72,
    "new_taxes_no_override": 29931.2,
    "override_total_1": 30780.48,
    "override_increase_1": 849.27
  },
  {
    "#": "70 Upland Rd (308-44-00)",
    "$": 3563100,
    "address": "70 Upland Rd",
    "parcel_id": "308-44-00",
    "owner1": "TAUBE, ISABEL L",
    "owner2": "DONOVAN, GREGORY MATTHEW",
    "current_taxes": 36486.14,
    "new_taxes_no_override": 38062.34,
    "override_total_1": 39142.33,
    "override_increase_1": 1079.99
  },
  {
    "#": "71 Upland Rd (312-05-00)",
    "$": 1944300,
    "address": "71 Upland Rd",
    "parcel_id": "312-05-00",
    "owner1": "MAGUIRE, JAMES H",
    "owner2": "LI, XIAOFANG",
    "current_taxes": 16274.7,
    "new_taxes_no_override": 16977.77,
    "override_total_1": 17459.5,
    "override_increase_1": 481.73
  },
  {
    "#": "72 Upland Rd (311-01-00)",
    "$": 163200,
    "address": "72 Upland Rd",
    "parcel_id": "311-01-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O PHILBRICK SQUARE",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "78 Upland Rd (308-43-00)",
    "$": 5917800,
    "address": "78 Upland Rd",
    "parcel_id": "308-43-00",
    "owner1": "CLAY TRS, LAVINIA D & THOMAS M & RICHARD T & LANDON H & CASSIUS M",
    "owner2": "",
    "current_taxes": 60598.27,
    "new_taxes_no_override": 63216.12,
    "override_total_1": 65009.82,
    "override_increase_1": 1793.71
  },
  {
    "#": "84 Upland Rd (308-42-00)",
    "$": 3507700,
    "address": "84 Upland Rd",
    "parcel_id": "308-42-00",
    "owner1": "MOGEL, JASON",
    "owner2": "RIKELMAN, JULIE",
    "current_taxes": 32283.91,
    "new_taxes_no_override": 33678.57,
    "override_total_1": 34634.18,
    "override_increase_1": 955.6
  },
  {
    "#": "94 Upland Rd (308-41-00)",
    "$": 2960600,
    "address": "94 Upland Rd",
    "parcel_id": "308-41-00",
    "owner1": "DEWITT TRS, ELIZABETH ROOSA & DENNIS JAMES",
    "owner2": "",
    "current_taxes": 26681.61,
    "new_taxes_no_override": 27834.26,
    "override_total_1": 28624.03,
    "override_increase_1": 789.78
  },
  {
    "#": "100 Upland Rd (308-40-00)",
    "$": 4889900,
    "address": "100 Upland Rd",
    "parcel_id": "308-40-00",
    "owner1": "SHEA TRS, MICHAEL H M & JENNIFER L B",
    "owner2": "",
    "current_taxes": 46437.64,
    "new_taxes_no_override": 48443.75,
    "override_total_1": 49818.3,
    "override_increase_1": 1374.55
  },
  {
    "#": "107 Upland Rd (312-06-00)",
    "$": 3463900,
    "address": "107 Upland Rd",
    "parcel_id": "312-06-00",
    "owner1": "CHAPMAN, RICHARD P & CYNTHIA M",
    "owner2": "",
    "current_taxes": 31835.4,
    "new_taxes_no_override": 33210.69,
    "override_total_1": 34153.02,
    "override_increase_1": 942.33
  },
  {
    "#": "108 Upland Rd (308-39-00)",
    "$": 4265200,
    "address": "108 Upland Rd",
    "parcel_id": "308-39-00",
    "owner1": "MICHAELS, FAITH INDIA",
    "owner2": "",
    "current_taxes": 40040.71,
    "new_taxes_no_override": 41770.47,
    "override_total_1": 42955.67,
    "override_increase_1": 1185.21
  },
  {
    "#": "14 Valley Rd (278-32-00)",
    "$": 2846400,
    "address": "14 Valley Rd",
    "parcel_id": "278-32-00",
    "owner1": "MACHT, MIRIAM R & JOHN J",
    "owner2": "",
    "current_taxes": 25512.2,
    "new_taxes_no_override": 26614.33,
    "override_total_1": 27369.49,
    "override_increase_1": 755.16
  },
  {
    "#": "22 Valley Rd (278-17-00)",
    "$": 2593400,
    "address": "22 Valley Rd",
    "parcel_id": "278-17-00",
    "owner1": "SCHEFF, DAVID & THERESA R",
    "owner2": "",
    "current_taxes": 22921.48,
    "new_taxes_no_override": 23911.69,
    "override_total_1": 24590.16,
    "override_increase_1": 678.48
  },
  {
    "#": "25 Valley Rd (278D-10-00)",
    "$": 2436900,
    "address": "25 Valley Rd",
    "parcel_id": "278D-10-00",
    "owner1": "DASGUPTA, TATHAGATA",
    "owner2": "MUKHOPADHYAY, SATABJISA",
    "current_taxes": 21318.92,
    "new_taxes_no_override": 22239.9,
    "override_total_1": 22870.94,
    "override_increase_1": 631.04
  },
  {
    "#": "34 Valley Rd (278-16-00)",
    "$": 2198200,
    "address": "34 Valley Rd",
    "parcel_id": "278-16-00",
    "owner1": "ORR, KEVIN R",
    "owner2": "BOEN, ELIZABETH H",
    "current_taxes": 18874.63,
    "new_taxes_no_override": 19690.01,
    "override_total_1": 20248.7,
    "override_increase_1": 558.69
  },
  {
    "#": "43 Valley Rd (278B-11-00)",
    "$": 3609600,
    "address": "43 Valley Rd",
    "parcel_id": "278B-11-00",
    "owner1": "GARDNER, AUGUSTUS P & ELIZABETH",
    "owner2": "",
    "current_taxes": 33327.37,
    "new_taxes_no_override": 34767.11,
    "override_total_1": 35753.6,
    "override_increase_1": 986.49
  },
  {
    "#": "44 Valley Rd (278-15-00)",
    "$": 2465300,
    "address": "44 Valley Rd",
    "parcel_id": "278-15-00",
    "owner1": "CEDAR LIFE ESTATE, ROBERT BRUCE",
    "owner2": "",
    "current_taxes": 21609.74,
    "new_taxes_no_override": 22543.28,
    "override_total_1": 23182.93,
    "override_increase_1": 639.65
  },
  {
    "#": "53 Valley Rd (278B-12-00)",
    "$": 4458100,
    "address": "53 Valley Rd",
    "parcel_id": "278B-12-00",
    "owner1": "SOKOLOFF, JODI",
    "owner2": "",
    "current_taxes": 42016.01,
    "new_taxes_no_override": 43831.1,
    "override_total_1": 45074.78,
    "override_increase_1": 1243.67
  },
  {
    "#": "60 Valley Rd (278-14-00)",
    "$": 3488700,
    "address": "60 Valley Rd",
    "parcel_id": "278-14-00",
    "owner1": "FINKELSTEIN TRS, MELISSA & SETH",
    "owner2": "",
    "current_taxes": 32089.35,
    "new_taxes_no_override": 33475.61,
    "override_total_1": 34425.45,
    "override_increase_1": 949.84
  },
  {
    "#": "5 Verndale St, Unit 1 (071-02-20)",
    "$": 1057000,
    "address": "5 Verndale St, Unit 1",
    "parcel_id": "071-02-20",
    "owner1": "HIJAZ, OMAR FAOUZI & SARAH HATOUM",
    "owner2": "",
    "current_taxes": 7188.75,
    "new_taxes_no_override": 7499.3,
    "override_total_1": 7712.09,
    "override_increase_1": 212.79
  },
  {
    "#": "5 Verndale St, Unit 2 & P5 (071-02-21)",
    "$": 1060600,
    "address": "5 Verndale St, Unit 2 & P5",
    "parcel_id": "071-02-21",
    "owner1": "KLOCK, MATTIE E",
    "owner2": "ROMANOWSKY, MARK B",
    "current_taxes": 7225.61,
    "new_taxes_no_override": 7537.76,
    "override_total_1": 7751.63,
    "override_increase_1": 213.88
  },
  {
    "#": "5 Verndale St, Unit 3 & P3 (071-02-22)",
    "$": 1075900,
    "address": "5 Verndale St, Unit 3 & P3",
    "parcel_id": "071-02-22",
    "owner1": "5 VERNDALE LLC",
    "owner2": "",
    "current_taxes": 11017.22,
    "new_taxes_no_override": 11493.16,
    "override_total_1": 11819.27,
    "override_increase_1": 326.11
  },
  {
    "#": "7 Verndale St, Unit Rear (071-02-14)",
    "$": 80900,
    "address": "7 Verndale St, Unit Rear",
    "parcel_id": "071-02-14",
    "owner1": "BECK ET AL, BRUCE A & JEROME N",
    "owner2": "C/O KALOTKIN, ARTHUR",
    "current_taxes": 828.42,
    "new_taxes_no_override": 864.21,
    "override_total_1": 888.73,
    "override_increase_1": 24.52
  },
  {
    "#": "7 Verndale St, Unit 1 (071-02-23)",
    "$": 1065800,
    "address": "7 Verndale St, Unit 1",
    "parcel_id": "071-02-23",
    "owner1": "MADELEY, JOSHUA N",
    "owner2": "HUIE, DENISE G",
    "current_taxes": 10913.79,
    "new_taxes_no_override": 11385.27,
    "override_total_1": 11708.31,
    "override_increase_1": 323.05
  },
  {
    "#": "7 Verndale St, Unit 2 (071-02-24)",
    "$": 1088300,
    "address": "7 Verndale St, Unit 2",
    "parcel_id": "071-02-24",
    "owner1": "BIERNBAUM, LEE",
    "owner2": "ARONZON, DIANA",
    "current_taxes": 7509.26,
    "new_taxes_no_override": 7833.66,
    "override_total_1": 8055.93,
    "override_increase_1": 222.27
  },
  {
    "#": "7 Verndale St, Unit 3 & P2 (071-02-25)",
    "$": 1066400,
    "address": "7 Verndale St, Unit 3 & P2",
    "parcel_id": "071-02-25",
    "owner1": "CHAPARALA, TIRUMALA V & SUJANA",
    "owner2": "",
    "current_taxes": 10919.94,
    "new_taxes_no_override": 11391.68,
    "override_total_1": 11714.91,
    "override_increase_1": 323.23
  },
  {
    "#": "8 Verndale St (072-39-00)",
    "$": 2838400,
    "address": "8 Verndale St",
    "parcel_id": "072-39-00",
    "owner1": "THE EDD KAMP FAMILY LP",
    "owner2": "",
    "current_taxes": 29065.22,
    "new_taxes_no_override": 30320.84,
    "override_total_1": 31181.17,
    "override_increase_1": 860.33
  },
  {
    "#": "9 Verndale St, Unit 1 & P-3 (071-02-08)",
    "$": 1091900,
    "address": "9 Verndale St, Unit 1 & P-3",
    "parcel_id": "071-02-08",
    "owner1": "PRIDE, VITALY & VALENTINA",
    "owner2": "",
    "current_taxes": 7546.12,
    "new_taxes_no_override": 7872.11,
    "override_total_1": 8095.48,
    "override_increase_1": 223.37
  },
  {
    "#": "9 Verndale St, Unit 2 & P2 (071-02-09)",
    "$": 966300,
    "address": "9 Verndale St, Unit 2 & P2",
    "parcel_id": "071-02-09",
    "owner1": "OZJEN PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 9894.91,
    "new_taxes_no_override": 10322.37,
    "override_total_1": 10615.26,
    "override_increase_1": 292.89
  },
  {
    "#": "9 Verndale St, Unit 3 & P-1 (071-02-10)",
    "$": 1015500,
    "address": "9 Verndale St, Unit 3 & P-1",
    "parcel_id": "071-02-10",
    "owner1": "PERCHEV, STANISLAV R",
    "owner2": "VASKOVA, ELENA",
    "current_taxes": 6763.79,
    "new_taxes_no_override": 7055.99,
    "override_total_1": 7256.19,
    "override_increase_1": 200.21
  },
  {
    "#": "11 Verndale St, Unit 1 & P1 (071-02-11)",
    "$": 1113900,
    "address": "11 Verndale St, Unit 1 & P1",
    "parcel_id": "071-02-11",
    "owner1": "KAYNAR, ATA MURAT & ZELIHA DILSUN",
    "owner2": "",
    "current_taxes": 11406.34,
    "new_taxes_no_override": 11899.09,
    "override_total_1": 12236.72,
    "override_increase_1": 337.63
  },
  {
    "#": "11 Verndale St, Unit 2 & P3 (071-02-12)",
    "$": 1181200,
    "address": "11 Verndale St, Unit 2 & P3",
    "parcel_id": "071-02-12",
    "owner1": "SARFATY, SUZANNE C",
    "owner2": "",
    "current_taxes": 12095.49,
    "new_taxes_no_override": 12618.02,
    "override_total_1": 12976.04,
    "override_increase_1": 358.03
  },
  {
    "#": "11 Verndale St, Unit 3 & P-2 (071-02-13)",
    "$": 1181200,
    "address": "11 Verndale St, Unit 3 & P-2",
    "parcel_id": "071-02-13",
    "owner1": "MILLER, MICHAEL B & CHRISTINE",
    "owner2": "",
    "current_taxes": 8460.55,
    "new_taxes_no_override": 8826.05,
    "override_total_1": 9076.48,
    "override_increase_1": 250.43
  },
  {
    "#": "12 Verndale St (072-38-00)",
    "$": 2077700,
    "address": "12 Verndale St",
    "parcel_id": "072-38-00",
    "owner1": "CHONG DE PROPERTIES LLC",
    "owner2": "LIAO, NAN NING",
    "current_taxes": 21275.65,
    "new_taxes_no_override": 22194.76,
    "override_total_1": 22824.52,
    "override_increase_1": 629.76
  },
  {
    "#": "16 Verndale St (072-37-00)",
    "$": 2079200,
    "address": "16 Verndale St",
    "parcel_id": "072-37-00",
    "owner1": "LONGINO TR, VICTORIA",
    "owner2": "",
    "current_taxes": 17656.07,
    "new_taxes_no_override": 18418.81,
    "override_total_1": 18941.43,
    "override_increase_1": 522.62
  },
  {
    "#": "19 Verndale St, Unit 1 & G1-P1 (071-03-01)",
    "$": 1661100,
    "address": "19 Verndale St, Unit 1 & G1-P1",
    "parcel_id": "071-03-01",
    "owner1": "RAEDE, JASON A & FRANCES A",
    "owner2": "",
    "current_taxes": 13374.73,
    "new_taxes_no_override": 13952.52,
    "override_total_1": 14348.41,
    "override_increase_1": 395.89
  },
  {
    "#": "19 Verndale St, Unit 2 & 2 Gar Sps (071-03-02)",
    "$": 1823300,
    "address": "19 Verndale St, Unit 2 & 2 Gar Sps",
    "parcel_id": "071-03-02",
    "owner1": "WANG, YAN",
    "owner2": "",
    "current_taxes": 18670.59,
    "new_taxes_no_override": 19477.16,
    "override_total_1": 20029.81,
    "override_increase_1": 552.65
  },
  {
    "#": "20 Verndale St (072-36-00)",
    "$": 2297500,
    "address": "20 Verndale St",
    "parcel_id": "072-36-00",
    "owner1": "BURLIN, JACQUELINE",
    "owner2": "",
    "current_taxes": 23526.4,
    "new_taxes_no_override": 24542.74,
    "override_total_1": 25239.12,
    "override_increase_1": 696.38
  },
  {
    "#": "21 Verndale St (071-04-00)",
    "$": 1967100,
    "address": "21 Verndale St",
    "parcel_id": "071-04-00",
    "owner1": "WONG LIFE ESTATE, WING FONG & LAI NGAO",
    "owner2": "",
    "current_taxes": 16508.17,
    "new_taxes_no_override": 17221.32,
    "override_total_1": 17709.96,
    "override_increase_1": 488.64
  },
  {
    "#": "24 Verndale St (072-35-00)",
    "$": 2096100,
    "address": "24 Verndale St",
    "parcel_id": "072-35-00",
    "owner1": "SMITH TR, SYLVIA A",
    "owner2": "",
    "current_taxes": 17829.13,
    "new_taxes_no_override": 18599.35,
    "override_total_1": 19127.09,
    "override_increase_1": 527.74
  },
  {
    "#": "27 Verndale St, Unit 1 (071-05-01)",
    "$": 1029600,
    "address": "27 Verndale St, Unit 1",
    "parcel_id": "071-05-01",
    "owner1": "BARDEN, LAURENCE M",
    "owner2": "DWYER, MELISSA",
    "current_taxes": 6908.17,
    "new_taxes_no_override": 7206.6,
    "override_total_1": 7411.08,
    "override_increase_1": 204.48
  },
  {
    "#": "27 Verndale St, Unit 2 (071-05-02)",
    "$": 982600,
    "address": "27 Verndale St, Unit 2",
    "parcel_id": "071-05-02",
    "owner1": "PERUCCHI, MARCO F",
    "owner2": "CRISTIANO, MARIA",
    "current_taxes": 6426.89,
    "new_taxes_no_override": 6704.53,
    "override_total_1": 6894.77,
    "override_increase_1": 190.24
  },
  {
    "#": "27 Verndale St, Unit 3 (071-05-03)",
    "$": 872600,
    "address": "27 Verndale St, Unit 3",
    "parcel_id": "071-05-03",
    "owner1": "IAVARONE, CARLO",
    "owner2": "PICCIONI, FEDERICA",
    "current_taxes": 5300.49,
    "new_taxes_no_override": 5529.47,
    "override_total_1": 5686.37,
    "override_increase_1": 156.89
  },
  {
    "#": "28 Verndale St (072-34-00)",
    "$": 2342100,
    "address": "28 Verndale St",
    "parcel_id": "072-34-00",
    "owner1": "KUNG, HING PING & CHRISTINA C",
    "owner2": "",
    "current_taxes": 20348.17,
    "new_taxes_no_override": 21227.21,
    "override_total_1": 21829.52,
    "override_increase_1": 602.31
  },
  {
    "#": "31 Verndale St, Unit 1 (071-06-01)",
    "$": 1430800,
    "address": "31 Verndale St, Unit 1",
    "parcel_id": "071-06-01",
    "owner1": "LICHTMAN TR, JENNIFER A",
    "owner2": "",
    "current_taxes": 11016.46,
    "new_taxes_no_override": 11492.37,
    "override_total_1": 11818.46,
    "override_increase_1": 326.09
  },
  {
    "#": "31 Verndale St, Unit 2 (071-06-02)",
    "$": 1456700,
    "address": "31 Verndale St, Unit 2",
    "parcel_id": "071-06-02",
    "owner1": "NYGREN, DIANA CHEREN & ANTHONY E",
    "owner2": "",
    "current_taxes": 11281.67,
    "new_taxes_no_override": 11769.04,
    "override_total_1": 12102.98,
    "override_increase_1": 333.94
  },
  {
    "#": "32 Verndale St (072-33-00)",
    "$": 2319600,
    "address": "32 Verndale St",
    "parcel_id": "072-33-00",
    "owner1": "PIERCE, PATRICIA",
    "owner2": "",
    "current_taxes": 20117.77,
    "new_taxes_no_override": 20986.86,
    "override_total_1": 21582.34,
    "override_increase_1": 595.49
  },
  {
    "#": "33 Verndale St (071-07-00)",
    "$": 2276800,
    "address": "33 Verndale St",
    "parcel_id": "071-07-00",
    "owner1": "CHOSTNER, BENJAMIN R & SARAH S",
    "owner2": "",
    "current_taxes": 23314.43,
    "new_taxes_no_override": 24321.61,
    "override_total_1": 25011.72,
    "override_increase_1": 690.11
  },
  {
    "#": "36 Verndale St (072-32-00)",
    "$": 3168800,
    "address": "36 Verndale St",
    "parcel_id": "072-32-00",
    "owner1": "PAN, DONG",
    "owner2": "LIU, JUNHUA",
    "current_taxes": 28813.58,
    "new_taxes_no_override": 30058.33,
    "override_total_1": 30911.21,
    "override_increase_1": 852.88
  },
  {
    "#": "39 Verndale St, Unit 39 (071-08-01)",
    "$": 2329200,
    "address": "39 Verndale St, Unit 39",
    "parcel_id": "071-08-01",
    "owner1": "DEANGELO, BRIAN BRUNO",
    "owner2": "CARPENTER, KENDALL LEIGH",
    "current_taxes": 20216.07,
    "new_taxes_no_override": 21089.4,
    "override_total_1": 21687.8,
    "override_increase_1": 598.4
  },
  {
    "#": "39 Verndale St, Unit 41 (071-08-02)",
    "$": 2145000,
    "address": "39 Verndale St, Unit 41",
    "parcel_id": "071-08-02",
    "owner1": "RAHMANDAD, HAZHIR",
    "owner2": "SARKHILI, SARA",
    "current_taxes": 21964.8,
    "new_taxes_no_override": 22913.68,
    "override_total_1": 23563.84,
    "override_increase_1": 650.16
  },
  {
    "#": "42 Verndale St, Unit 1 (072-31-01)",
    "$": 1130500,
    "address": "42 Verndale St, Unit 1",
    "parcel_id": "072-31-01",
    "owner1": "CONTU, ALESSIA",
    "owner2": "JAMES, ADAM",
    "current_taxes": 11576.32,
    "new_taxes_no_override": 12076.42,
    "override_total_1": 12419.08,
    "override_increase_1": 342.66
  },
  {
    "#": "42 Verndale St, Unit 2 (072-31-02)",
    "$": 1470700,
    "address": "42 Verndale St, Unit 2",
    "parcel_id": "072-31-02",
    "owner1": "CHERRY, RHONDA",
    "owner2": "LANDY, KAREN",
    "current_taxes": 11425.03,
    "new_taxes_no_override": 11918.59,
    "override_total_1": 12256.77,
    "override_increase_1": 338.18
  },
  {
    "#": "43 Verndale St (071-09-00)",
    "$": 2649000,
    "address": "43 Verndale St",
    "parcel_id": "071-09-00",
    "owner1": "GROSS TRS ET AL, DORIS",
    "owner2": "C/O DEENA GROSS",
    "current_taxes": 27125.76,
    "new_taxes_no_override": 28297.59,
    "override_total_1": 29100.52,
    "override_increase_1": 802.92
  },
  {
    "#": "46 Verndale St (072-30-00)",
    "$": 2279900,
    "address": "46 Verndale St",
    "parcel_id": "072-30-00",
    "owner1": "CHEN, KUANG-TING",
    "owner2": "CHIU, YU-JU",
    "current_taxes": 19711.24,
    "new_taxes_no_override": 20562.77,
    "override_total_1": 21146.22,
    "override_increase_1": 583.45
  },
  {
    "#": "49 Verndale St, Unit 49 (071-10-01)",
    "$": 2209300,
    "address": "49 Verndale St, Unit 49",
    "parcel_id": "071-10-01",
    "owner1": "AKERMAN TRS, ROY & REUT",
    "owner2": "",
    "current_taxes": 22623.23,
    "new_taxes_no_override": 23600.55,
    "override_total_1": 24270.2,
    "override_increase_1": 669.65
  },
  {
    "#": "49 Verndale St, Unit 51 (071-10-02)",
    "$": 2246900,
    "address": "49 Verndale St, Unit 51",
    "parcel_id": "071-10-02",
    "owner1": "NAYAR, NANDINI",
    "owner2": "THEKKEPAT, SIDHARTH",
    "current_taxes": 23008.26,
    "new_taxes_no_override": 24002.22,
    "override_total_1": 24683.26,
    "override_increase_1": 681.04
  },
  {
    "#": "50 Verndale St (072-29-00)",
    "$": 2172900,
    "address": "50 Verndale St",
    "parcel_id": "072-29-00",
    "owner1": "DUPRE, TRS, ROSALYN & JACQUES",
    "owner2": "",
    "current_taxes": 18615.56,
    "new_taxes_no_override": 19419.75,
    "override_total_1": 19970.77,
    "override_increase_1": 551.02
  },
  {
    "#": "55 Verndale St (071-11-00)",
    "$": 2328000,
    "address": "55 Verndale St",
    "parcel_id": "071-11-00",
    "owner1": "PALDI VENTURES LLC",
    "owner2": "",
    "current_taxes": 23838.72,
    "new_taxes_no_override": 24868.55,
    "override_total_1": 25574.18,
    "override_increase_1": 705.63
  },
  {
    "#": "56 Verndale St, Unit 56 (072-28-01)",
    "$": 1398800,
    "address": "56 Verndale St, Unit 56",
    "parcel_id": "072-28-01",
    "owner1": "CARBALLO, DAVID M & JENNIFER L",
    "owner2": "",
    "current_taxes": 10688.78,
    "new_taxes_no_override": 11150.54,
    "override_total_1": 11466.92,
    "override_increase_1": 316.39
  },
  {
    "#": "57 Verndale St (071-12-00)",
    "$": 2460100,
    "address": "57 Verndale St",
    "parcel_id": "071-12-00",
    "owner1": "REMNANT MINISTRY USA",
    "owner2": "",
    "current_taxes": 20153.55,
    "new_taxes_no_override": 21024.18,
    "override_total_1": 21620.73,
    "override_increase_1": 596.55
  },
  {
    "#": "58 Verndale St, Unit 58 (072-28-02)",
    "$": 1045700,
    "address": "58 Verndale St, Unit 58",
    "parcel_id": "072-28-02",
    "owner1": "DULLA, CHRISTOPHER G & MELISSA",
    "owner2": "",
    "current_taxes": 7073.03,
    "new_taxes_no_override": 7378.58,
    "override_total_1": 7587.95,
    "override_increase_1": 209.36
  },
  {
    "#": "60 Verndale St (072-27-00)",
    "$": 2254000,
    "address": "60 Verndale St",
    "parcel_id": "072-27-00",
    "owner1": "KIM, YOUNG E",
    "owner2": "CHAN, SANDRA W",
    "current_taxes": 19446.03,
    "new_taxes_no_override": 20286.1,
    "override_total_1": 20861.7,
    "override_increase_1": 575.6
  },
  {
    "#": "63 Verndale St, Unit 1 (071-13-01)",
    "$": 1330500,
    "address": "63 Verndale St, Unit 1",
    "parcel_id": "071-13-01",
    "owner1": "OFIR, MICHAEL & VICTORIA",
    "owner2": "",
    "current_taxes": 9989.39,
    "new_taxes_no_override": 10420.93,
    "override_total_1": 10716.62,
    "override_increase_1": 295.69
  },
  {
    "#": "63 Verndale St, Unit 2 (071-13-02)",
    "$": 1338900,
    "address": "63 Verndale St, Unit 2",
    "parcel_id": "071-13-02",
    "owner1": "SERBULA, RADOVAN & MELITA",
    "owner2": "",
    "current_taxes": 10075.4,
    "new_taxes_no_override": 10510.66,
    "override_total_1": 10808.89,
    "override_increase_1": 298.23
  },
  {
    "#": "64 Verndale St, Unit 1 (072-26-01)",
    "$": 1552600,
    "address": "64 Verndale St, Unit 1",
    "parcel_id": "072-26-01",
    "owner1": "CHU, SANG MIHN",
    "owner2": "LEE, MI KYOUNG",
    "current_taxes": 15898.62,
    "new_taxes_no_override": 16585.44,
    "override_total_1": 17056.04,
    "override_increase_1": 470.6
  },
  {
    "#": "66 Verndale St, Unit 2 (072-26-02)",
    "$": 1601700,
    "address": "66 Verndale St, Unit 2",
    "parcel_id": "072-26-02",
    "owner1": "CHU, SANG MIHN",
    "owner2": "LEE, MI KYOUNG",
    "current_taxes": 16401.41,
    "new_taxes_no_override": 17109.95,
    "override_total_1": 17595.43,
    "override_increase_1": 485.48
  },
  {
    "#": "67 Verndale St (071-14-00)",
    "$": 2445900,
    "address": "67 Verndale St",
    "parcel_id": "071-14-00",
    "owner1": "HELF TR, HEIDI",
    "owner2": "",
    "current_taxes": 21411.08,
    "new_taxes_no_override": 22336.04,
    "override_total_1": 22969.81,
    "override_increase_1": 633.77
  },
  {
    "#": "70 Verndale St, Unit 1 (072-25-01)",
    "$": 2501100,
    "address": "70 Verndale St, Unit 1",
    "parcel_id": "072-25-01",
    "owner1": "SHIMONY, SIVAN & SHAI",
    "owner2": "",
    "current_taxes": 25611.26,
    "new_taxes_no_override": 26717.67,
    "override_total_1": 27475.76,
    "override_increase_1": 758.09
  },
  {
    "#": "70 Verndale St, Unit 2 (072-25-02)",
    "$": 3020100,
    "address": "70 Verndale St, Unit 2",
    "parcel_id": "072-25-02",
    "owner1": "GHAEL, SANDEEP",
    "owner2": "VULLAGANTI, MITHILA",
    "current_taxes": 30925.82,
    "new_taxes_no_override": 32261.82,
    "override_total_1": 33177.22,
    "override_increase_1": 915.4
  },
  {
    "#": "73 Verndale St, Unit 1 (071-15-01)",
    "$": 2208300,
    "address": "73 Verndale St, Unit 1",
    "parcel_id": "071-15-01",
    "owner1": "BINCZYK, JEFFREY L & KELLIE B",
    "owner2": "",
    "current_taxes": 22612.99,
    "new_taxes_no_override": 23589.87,
    "override_total_1": 24259.22,
    "override_increase_1": 669.34
  },
  {
    "#": "73 Verndale St, Unit 2 (071-15-02)",
    "$": 2710000,
    "address": "73 Verndale St, Unit 2",
    "parcel_id": "071-15-02",
    "owner1": "INBAR, ORI & ADI",
    "owner2": "",
    "current_taxes": 24115.47,
    "new_taxes_no_override": 25157.26,
    "override_total_1": 25871.08,
    "override_increase_1": 713.82
  },
  {
    "#": "76 Verndale St, Unit 1 (072-24-01)",
    "$": 2099800,
    "address": "76 Verndale St, Unit 1",
    "parcel_id": "072-24-01",
    "owner1": "DIVAKARAN, SANJAY & PAYAL",
    "owner2": "",
    "current_taxes": 17867.02,
    "new_taxes_no_override": 18638.88,
    "override_total_1": 19167.74,
    "override_increase_1": 528.86
  },
  {
    "#": "76 Verndale St, Unit 2 (072-24-02)",
    "$": 2390800,
    "address": "76 Verndale St, Unit 2",
    "parcel_id": "072-24-02",
    "owner1": "FARRONATO, CHIARA",
    "owner2": "SHEN, DANIEL",
    "current_taxes": 20846.86,
    "new_taxes_no_override": 21747.44,
    "override_total_1": 22364.51,
    "override_increase_1": 617.07
  },
  {
    "#": "77 Verndale St, Unit 1 (071-16-01)",
    "$": 2053500,
    "address": "77 Verndale St, Unit 1",
    "parcel_id": "071-16-01",
    "owner1": "CONDON, RICHARD",
    "owner2": "BLESS, ELIZABETH",
    "current_taxes": 17392.91,
    "new_taxes_no_override": 18144.28,
    "override_total_1": 18659.11,
    "override_increase_1": 514.83
  },
  {
    "#": "77 Verndale St, Unit 2 (071-16-02)",
    "$": 2308700,
    "address": "77 Verndale St, Unit 2",
    "parcel_id": "071-16-02",
    "owner1": "SAMUELS, RANA",
    "owner2": "OFRAN, YANAY",
    "current_taxes": 23641.09,
    "new_taxes_no_override": 24662.39,
    "override_total_1": 25362.16,
    "override_increase_1": 699.78
  },
  {
    "#": "78 Verndale St, Unit 1 (072-23-01)",
    "$": 2553100,
    "address": "78 Verndale St, Unit 1",
    "parcel_id": "072-23-01",
    "owner1": "SHETTY TRS, CHANDRASHEKAR & NAMRATHA",
    "owner2": "",
    "current_taxes": 26143.74,
    "new_taxes_no_override": 27273.15,
    "override_total_1": 28047.0,
    "override_increase_1": 773.85
  },
  {
    "#": "78 Verndale St, Unit 2 (072-23-02)",
    "$": 3136900,
    "address": "78 Verndale St, Unit 2",
    "parcel_id": "072-23-02",
    "owner1": "REOTT, REBECCA MARY",
    "owner2": "SHERRIN, STEVEN LEWIS",
    "current_taxes": 28486.92,
    "new_taxes_no_override": 29717.55,
    "override_total_1": 30560.77,
    "override_increase_1": 843.21
  },
  {
    "#": "79 Verndale St (071-25-26)",
    "$": 2830100,
    "address": "79 Verndale St",
    "parcel_id": "071-25-26",
    "owner1": "EDGE BRAINERD LLC",
    "owner2": "",
    "current_taxes": 28980.22,
    "new_taxes_no_override": 30232.17,
    "override_total_1": 31089.98,
    "override_increase_1": 857.81
  },
  {
    "#": "81 Verndale St (071-17-00)",
    "$": 1906500,
    "address": "81 Verndale St",
    "parcel_id": "071-17-00",
    "owner1": "YEE, KARL & MARIAN",
    "owner2": "",
    "current_taxes": 19522.56,
    "new_taxes_no_override": 20365.93,
    "override_total_1": 20943.8,
    "override_increase_1": 577.87
  },
  {
    "#": "85 Verndale St (071-18-00)",
    "$": 1839700,
    "address": "85 Verndale St",
    "parcel_id": "071-18-00",
    "owner1": "SENFUMA, SAMUEL",
    "owner2": "",
    "current_taxes": 15203.59,
    "new_taxes_no_override": 15860.39,
    "override_total_1": 16310.41,
    "override_increase_1": 450.03
  },
  {
    "#": "86 Verndale St (072-22-00)",
    "$": 2755100,
    "address": "86 Verndale St",
    "parcel_id": "072-22-00",
    "owner1": "GURNEY, BETH",
    "owner2": "",
    "current_taxes": 24577.29,
    "new_taxes_no_override": 25639.03,
    "override_total_1": 26366.52,
    "override_increase_1": 727.49
  },
  {
    "#": "90 Verndale St, Unit 1 & P1-3 (072-21-01)",
    "$": 1614200,
    "address": "90 Verndale St, Unit 1 & P1-3",
    "parcel_id": "072-21-01",
    "owner1": "BENNETT, RICHARD",
    "owner2": "GAFFIN, DEBORAH L",
    "current_taxes": 12894.47,
    "new_taxes_no_override": 13451.51,
    "override_total_1": 13833.19,
    "override_increase_1": 381.68
  },
  {
    "#": "90 Verndale St, Unit 2 (072-21-02)",
    "$": 1688800,
    "address": "90 Verndale St, Unit 2",
    "parcel_id": "072-21-02",
    "owner1": "JACOBS, MICHAEL G",
    "owner2": "COHEN, JUDITH R",
    "current_taxes": 13658.38,
    "new_taxes_no_override": 14248.42,
    "override_total_1": 14652.71,
    "override_increase_1": 404.29
  },
  {
    "#": "91 Verndale St (071-19-00)",
    "$": 2667500,
    "address": "91 Verndale St",
    "parcel_id": "071-19-00",
    "owner1": "KIM TR, JOHN K",
    "owner2": "",
    "current_taxes": 27315.2,
    "new_taxes_no_override": 28495.22,
    "override_total_1": 29303.75,
    "override_increase_1": 808.53
  },
  {
    "#": "95 Verndale St (071-20-00)",
    "$": 3305900,
    "address": "95 Verndale St",
    "parcel_id": "071-20-00",
    "owner1": "SHNEYDERMAN TRS, BORIS & POLINA L",
    "owner2": "",
    "current_taxes": 30217.48,
    "new_taxes_no_override": 31522.88,
    "override_total_1": 32417.31,
    "override_increase_1": 894.44
  },
  {
    "#": "96 Verndale St, Unit 1 (072-20-01)",
    "$": 2336400,
    "address": "96 Verndale St, Unit 1",
    "parcel_id": "072-20-01",
    "owner1": "SHTALRID, RON & YAANIT NATAN",
    "owner2": "",
    "current_taxes": 23924.74,
    "new_taxes_no_override": 24958.29,
    "override_total_1": 25666.46,
    "override_increase_1": 708.17
  },
  {
    "#": "96 Verndale St, Unit 2 (072-20-02)",
    "$": 2812900,
    "address": "96 Verndale St, Unit 2",
    "parcel_id": "072-20-02",
    "owner1": "LI, XIAOSHU",
    "owner2": "",
    "current_taxes": 28804.1,
    "new_taxes_no_override": 30048.44,
    "override_total_1": 30901.04,
    "override_increase_1": 852.6
  },
  {
    "#": "101 Verndale St (071-21-00)",
    "$": 2456700,
    "address": "101 Verndale St",
    "parcel_id": "071-21-00",
    "owner1": "LIU, MICHAEL",
    "owner2": "LOUIE, MAY JOAN",
    "current_taxes": 25156.61,
    "new_taxes_no_override": 26243.38,
    "override_total_1": 26988.01,
    "override_increase_1": 744.64
  },
  {
    "#": "7 Vernon St (167-01-00)",
    "$": 18680500,
    "address": "7 Vernon St",
    "parcel_id": "167-01-00",
    "owner1": "10 ADDRESSES LLC",
    "owner2": "",
    "current_taxes": 191288.32,
    "new_taxes_no_override": 199551.98,
    "override_total_1": 205214.11,
    "override_increase_1": 5662.13
  },
  {
    "#": "10 Vernon St, Unit 201 G49-51 (168-16-01)",
    "$": 1262500,
    "address": "10 Vernon St, Unit 201 G49-51",
    "parcel_id": "168-16-01",
    "owner1": "KNOX, DOUGLAS & VAISHALI",
    "owner2": "",
    "current_taxes": 12928.0,
    "new_taxes_no_override": 13486.49,
    "override_total_1": 13869.16,
    "override_increase_1": 382.67
  },
  {
    "#": "10 Vernon St, Unit 202 G40-42 (168-16-02)",
    "$": 1305000,
    "address": "10 Vernon St, Unit 202 G40-42",
    "parcel_id": "168-16-02",
    "owner1": "STEVENSON, LISA M",
    "owner2": "",
    "current_taxes": 9728.27,
    "new_taxes_no_override": 10148.53,
    "override_total_1": 10436.49,
    "override_increase_1": 287.96
  },
  {
    "#": "10 Vernon St, Unit 203 G61 (168-16-03)",
    "$": 973100,
    "address": "10 Vernon St, Unit 203 G61",
    "parcel_id": "168-16-03",
    "owner1": "TSANG, STEPHEN S & PAMELA M",
    "owner2": "",
    "current_taxes": 9964.54,
    "new_taxes_no_override": 10395.01,
    "override_total_1": 10689.96,
    "override_increase_1": 294.95
  },
  {
    "#": "10 Vernon St, Unit 204 G36-39 (168-16-04)",
    "$": 1398500,
    "address": "10 Vernon St, Unit 204 G36-39",
    "parcel_id": "168-16-04",
    "owner1": "CHIGIRINSKIY TRS, MIKHAIL",
    "owner2": "CHIGIRINSKAYA, IRINA",
    "current_taxes": 10685.71,
    "new_taxes_no_override": 11147.33,
    "override_total_1": 11463.63,
    "override_increase_1": 316.3
  },
  {
    "#": "10 Vernon St, Unit 205 G35-38 (168-16-05)",
    "$": 1491000,
    "address": "10 Vernon St, Unit 205 G35-38",
    "parcel_id": "168-16-05",
    "owner1": "WIRTH TR, DAVID A",
    "owner2": "",
    "current_taxes": 11632.91,
    "new_taxes_no_override": 12135.45,
    "override_total_1": 12479.79,
    "override_increase_1": 344.33
  },
  {
    "#": "10 Vernon St, Unit 206 G34-37 (168-16-06)",
    "$": 1373400,
    "address": "10 Vernon St, Unit 206 G34-37",
    "parcel_id": "168-16-06",
    "owner1": "OLIVER-LI TR, PARKER L",
    "owner2": "",
    "current_taxes": 10428.68,
    "new_taxes_no_override": 10879.2,
    "override_total_1": 11187.89,
    "override_increase_1": 308.69
  },
  {
    "#": "10 Vernon St, Unit 301 G41-43 (168-16-07)",
    "$": 1320000,
    "address": "10 Vernon St, Unit 301 G41-43",
    "parcel_id": "168-16-07",
    "owner1": "PATEL, PRATIKSHA KIRAN",
    "owner2": "",
    "current_taxes": 9881.87,
    "new_taxes_no_override": 10308.77,
    "override_total_1": 10601.27,
    "override_increase_1": 292.5
  },
  {
    "#": "10 Vernon St, Unit 302 G45-47 (168-16-08)",
    "$": 1275500,
    "address": "10 Vernon St, Unit 302 G45-47",
    "parcel_id": "168-16-08",
    "owner1": "HUNG, KRISTIN JOYCE & FANI & CALEB",
    "owner2": "",
    "current_taxes": 9426.19,
    "new_taxes_no_override": 9833.4,
    "override_total_1": 10112.42,
    "override_increase_1": 279.02
  },
  {
    "#": "10 Vernon St, Unit 303  G60 (168-16-09)",
    "$": 1171600,
    "address": "10 Vernon St, Unit 303  G60",
    "parcel_id": "168-16-09",
    "owner1": "CHEN, SHIH HSI",
    "owner2": "",
    "current_taxes": 11997.18,
    "new_taxes_no_override": 12515.46,
    "override_total_1": 12870.57,
    "override_increase_1": 355.12
  },
  {
    "#": "10 Vernon St, Unit 304 G57 (168-16-10)",
    "$": 1053600,
    "address": "10 Vernon St, Unit 304 G57",
    "parcel_id": "168-16-10",
    "owner1": "OSULLIVAN, DAVID H",
    "owner2": "MCGOVERN, CATHERINE",
    "current_taxes": 10788.86,
    "new_taxes_no_override": 11254.94,
    "override_total_1": 11574.29,
    "override_increase_1": 319.35
  },
  {
    "#": "10 Vernon St, Unit 305  G56 (168-16-11)",
    "$": 1393500,
    "address": "10 Vernon St, Unit 305  G56",
    "parcel_id": "168-16-11",
    "owner1": "BALAKRISHNA, RACHNA & RAJEEV",
    "owner2": "",
    "current_taxes": 14269.44,
    "new_taxes_no_override": 14885.88,
    "override_total_1": 15308.26,
    "override_increase_1": 422.38
  },
  {
    "#": "10 Vernon St, Unit 306 G48-50 (168-16-12)",
    "$": 1387000,
    "address": "10 Vernon St, Unit 306 G48-50",
    "parcel_id": "168-16-12",
    "owner1": "GARBER, MIRIAM",
    "owner2": "",
    "current_taxes": 14202.88,
    "new_taxes_no_override": 14816.44,
    "override_total_1": 15236.85,
    "override_increase_1": 420.41
  },
  {
    "#": "10 Vernon St, Unit Com-1 (168-16-16)",
    "$": 3236600,
    "address": "10 Vernon St, Unit Com-1",
    "parcel_id": "168-16-16",
    "owner1": "HARVARD-VERNON LLC",
    "owner2": "",
    "current_taxes": 55540.06,
    "new_taxes_no_override": 57939.39,
    "override_total_1": 59583.38,
    "override_increase_1": 1643.99
  },
  {
    "#": "10 Vernon St, Unit Com-2 (168-16-17)",
    "$": 2712400,
    "address": "10 Vernon St, Unit Com-2",
    "parcel_id": "168-16-17",
    "owner1": "HARVARD-VERNON PLACE LLC",
    "owner2": "",
    "current_taxes": 27774.98,
    "new_taxes_no_override": 28974.86,
    "override_total_1": 29797.0,
    "override_increase_1": 822.14
  },
  {
    "#": "10 Vernon St, Unit Ph1 & P62 (168-16-13)",
    "$": 1505000,
    "address": "10 Vernon St, Unit Ph1 & P62",
    "parcel_id": "168-16-13",
    "owner1": "ODONOGHUE TR, GEOFFREY P",
    "owner2": "",
    "current_taxes": 11776.27,
    "new_taxes_no_override": 12285.0,
    "override_total_1": 12633.58,
    "override_increase_1": 348.58
  },
  {
    "#": "10 Vernon St, Unit Ph2 & 3 Pksps (168-16-14)",
    "$": 1479400,
    "address": "10 Vernon St, Unit Ph2 & 3 Pksps",
    "parcel_id": "168-16-14",
    "owner1": "DOLINGER TR, MARNA B",
    "owner2": "",
    "current_taxes": 11514.12,
    "new_taxes_no_override": 12011.53,
    "override_total_1": 12352.35,
    "override_increase_1": 340.82
  },
  {
    "#": "10 Vernon St, Unit Ph3  G25-30 (168-16-15)",
    "$": 1605200,
    "address": "10 Vernon St, Unit Ph3  G25-30",
    "parcel_id": "168-16-15",
    "owner1": "GUO LIFE ESTATE, JIM",
    "owner2": "FLEMING LIFE ESTATE, ELAINE M",
    "current_taxes": 12802.31,
    "new_taxes_no_override": 13355.37,
    "override_total_1": 13734.32,
    "override_increase_1": 378.95
  },
  {
    "#": "10 Vernon St, Unit V-1 G44-46 (168-16-18)",
    "$": 1795300,
    "address": "10 Vernon St, Unit V-1 G44-46",
    "parcel_id": "168-16-18",
    "owner1": "BALAKRISHNA, RAJEEV & RACHNA D",
    "owner2": "",
    "current_taxes": 14748.94,
    "new_taxes_no_override": 15386.09,
    "override_total_1": 15822.66,
    "override_increase_1": 436.57
  },
  {
    "#": "10 Vernon St, Unit V-2 & G52 (168-16-19)",
    "$": 829900,
    "address": "10 Vernon St, Unit V-2 & G52",
    "parcel_id": "168-16-19",
    "owner1": "BALAKRISHNA, RAJEEV & RACHRA",
    "owner2": "",
    "current_taxes": 8498.18,
    "new_taxes_no_override": 8865.3,
    "override_total_1": 9116.85,
    "override_increase_1": 251.55
  },
  {
    "#": "18 Vernon St (168-14-00)",
    "$": 3190100,
    "address": "18 Vernon St",
    "parcel_id": "168-14-00",
    "owner1": "BRADVERN LLC",
    "owner2": "",
    "current_taxes": 32666.62,
    "new_taxes_no_override": 34077.82,
    "override_total_1": 35044.75,
    "override_increase_1": 966.93
  },
  {
    "#": "19 Vernon St (167-05-00)",
    "$": 3569300,
    "address": "19 Vernon St",
    "parcel_id": "167-05-00",
    "owner1": "BASILE, ROBERT W & BEVERLY ANN",
    "owner2": "C/O VERNON TOWERS ASSOCIATES",
    "current_taxes": 36549.63,
    "new_taxes_no_override": 38128.57,
    "override_total_1": 39210.44,
    "override_increase_1": 1081.87
  },
  {
    "#": "22 Vernon St (168-13-00)",
    "$": 2282800,
    "address": "22 Vernon St",
    "parcel_id": "168-13-00",
    "owner1": "LERNER, NEAL D",
    "owner2": "BAKER, TANIA A & JEAN C",
    "current_taxes": 19740.94,
    "new_taxes_no_override": 20593.75,
    "override_total_1": 21178.08,
    "override_increase_1": 584.33
  },
  {
    "#": "28 Vernon St (168-12-00)",
    "$": 2515200,
    "address": "28 Vernon St",
    "parcel_id": "168-12-00",
    "owner1": "LEVITAN LIFE ESTATE, ANNA",
    "owner2": "",
    "current_taxes": 22120.71,
    "new_taxes_no_override": 23076.32,
    "override_total_1": 23731.1,
    "override_increase_1": 654.77
  },
  {
    "#": "32 Vernon St (168-11-00)",
    "$": 2492300,
    "address": "32 Vernon St",
    "parcel_id": "168-11-00",
    "owner1": "BOURQUE, RONALD & DIANE",
    "owner2": "",
    "current_taxes": 21886.22,
    "new_taxes_no_override": 22831.7,
    "override_total_1": 23479.54,
    "override_increase_1": 647.83
  },
  {
    "#": "35 Vernon St (167-06-09)",
    "$": 21515000,
    "address": "35 Vernon St",
    "parcel_id": "167-06-09",
    "owner1": "BASILE, ROBERT W & BEVERLY ANN",
    "owner2": "C/O VERNON TOWERS ASSOCIATES",
    "current_taxes": 220313.6,
    "new_taxes_no_override": 229831.15,
    "override_total_1": 236352.43,
    "override_increase_1": 6521.28
  },
  {
    "#": "36 Vernon St, Unit 1 (168-10-01)",
    "$": 1863800,
    "address": "36 Vernon St, Unit 1",
    "parcel_id": "168-10-01",
    "owner1": "ANDREWS TRS, MARGARET COLLINS",
    "owner2": "HALEY, CHRISTOPHER S",
    "current_taxes": 15450.38,
    "new_taxes_no_override": 16117.84,
    "override_total_1": 16575.17,
    "override_increase_1": 457.33
  },
  {
    "#": "36 Vernon St, Unit 2 (168-10-02)",
    "$": 2052500,
    "address": "36 Vernon St, Unit 2",
    "parcel_id": "168-10-02",
    "owner1": "BHANG, HYO-EUN",
    "owner2": "CHUNG, JON",
    "current_taxes": 17382.67,
    "new_taxes_no_override": 18133.6,
    "override_total_1": 18648.13,
    "override_increase_1": 514.53
  },
  {
    "#": "42 Vernon St (169-13-00)",
    "$": 1977400,
    "address": "42 Vernon St",
    "parcel_id": "169-13-00",
    "owner1": "BERK, FREDRICK M",
    "owner2": "BROWN, DIANE",
    "current_taxes": 16613.64,
    "new_taxes_no_override": 17331.35,
    "override_total_1": 17823.11,
    "override_increase_1": 491.76
  },
  {
    "#": "44 Vernon St, Unit 44 (169-12-01)",
    "$": 2369400,
    "address": "44 Vernon St, Unit 44",
    "parcel_id": "169-12-01",
    "owner1": "ALFAKHURI, KHALED",
    "owner2": "BAOUENDI, RYM",
    "current_taxes": 24262.66,
    "new_taxes_no_override": 25310.81,
    "override_total_1": 26028.98,
    "override_increase_1": 718.17
  },
  {
    "#": "44 Vernon St, Unit 46 (169-12-02)",
    "$": 2200700,
    "address": "44 Vernon St, Unit 46",
    "parcel_id": "169-12-02",
    "owner1": "VEYTSMAN, JOHN IGOR",
    "owner2": "KOVAL, ERICA",
    "current_taxes": 18900.23,
    "new_taxes_no_override": 19716.72,
    "override_total_1": 20276.17,
    "override_increase_1": 559.45
  },
  {
    "#": "50 Vernon St (169-11-00)",
    "$": 1343700,
    "address": "50 Vernon St",
    "parcel_id": "169-11-00",
    "owner1": "50 VERNON STREET DEVELOPMENT LLC",
    "owner2": "",
    "current_taxes": 13759.49,
    "new_taxes_no_override": 14353.9,
    "override_total_1": 14761.18,
    "override_increase_1": 407.28
  },
  {
    "#": "52 Vernon St, Unit 1 (169-10-01)",
    "$": 1156300,
    "address": "52 Vernon St, Unit 1",
    "parcel_id": "169-10-01",
    "owner1": "GRANOFF, SUSAN",
    "owner2": "",
    "current_taxes": 8205.58,
    "new_taxes_no_override": 8560.06,
    "override_total_1": 8802.95,
    "override_increase_1": 242.89
  },
  {
    "#": "52 Vernon St, Unit 2 (169-10-02)",
    "$": 1466600,
    "address": "52 Vernon St, Unit 2",
    "parcel_id": "169-10-02",
    "owner1": "DESAI, MISHAL",
    "owner2": "POPESCU, LOREDANA",
    "current_taxes": 11383.05,
    "new_taxes_no_override": 11874.8,
    "override_total_1": 12211.74,
    "override_increase_1": 336.94
  },
  {
    "#": "52 Vernon St, Unit 3 (169-10-03)",
    "$": 1409700,
    "address": "52 Vernon St, Unit 3",
    "parcel_id": "169-10-03",
    "owner1": "JADE CENTURY PROPERTIES INC",
    "owner2": "",
    "current_taxes": 14435.33,
    "new_taxes_no_override": 15058.94,
    "override_total_1": 15486.22,
    "override_increase_1": 427.29
  },
  {
    "#": "54 Vernon St (169-09-00)",
    "$": 2841900,
    "address": "54 Vernon St",
    "parcel_id": "169-09-00",
    "owner1": "LEW TR, STEPHEN",
    "owner2": "",
    "current_taxes": 29101.06,
    "new_taxes_no_override": 30358.23,
    "override_total_1": 31219.62,
    "override_increase_1": 861.39
  },
  {
    "#": "80 Vernon St (214-37-00)",
    "$": 1325000,
    "address": "80 Vernon St",
    "parcel_id": "214-37-00",
    "owner1": "80 VERNON STREET LLC",
    "owner2": "",
    "current_taxes": 13568.0,
    "new_taxes_no_override": 14154.14,
    "override_total_1": 14555.75,
    "override_increase_1": 401.61
  },
  {
    "#": "329 Vfw Pky (376A-14-00)",
    "$": 4600,
    "address": "329 Vfw Pky",
    "parcel_id": "376A-14-00",
    "owner1": "BENNETT, MARJORIE E",
    "owner2": "",
    "current_taxes": 47.1,
    "new_taxes_no_override": 49.13,
    "override_total_1": 50.53,
    "override_increase_1": 1.39
  },
  {
    "#": "333 Vfw Pky (376A-15-00)",
    "$": 18700,
    "address": "333 Vfw Pky",
    "parcel_id": "376A-15-00",
    "owner1": "NEMCHENOK TRS, IRINA & VICTOR V",
    "owner2": "",
    "current_taxes": 191.49,
    "new_taxes_no_override": 199.76,
    "override_total_1": 205.43,
    "override_increase_1": 5.67
  },
  {
    "#": "343 Vfw Pky (376A-17-00)",
    "$": 679700,
    "address": "343 Vfw Pky",
    "parcel_id": "376A-17-00",
    "owner1": "MENON, GOPAN",
    "owner2": "RAMESH, UMA",
    "current_taxes": 3325.19,
    "new_taxes_no_override": 3468.84,
    "override_total_1": 3567.26,
    "override_increase_1": 98.43
  },
  {
    "#": "349 Vfw Pky (376A-16-00)",
    "$": 543800,
    "address": "349 Vfw Pky",
    "parcel_id": "376A-16-00",
    "owner1": "EBERHARDT, ROBERT MAXWELL & ALEXANDRA JOICE BERGER",
    "owner2": "",
    "current_taxes": 5568.51,
    "new_taxes_no_override": 5809.07,
    "override_total_1": 5973.9,
    "override_increase_1": 164.83
  },
  {
    "#": "355 Vfw Pky (377-01-00)",
    "$": 1585100,
    "address": "355 Vfw Pky",
    "parcel_id": "377-01-00",
    "owner1": "LOKA, IRENE NOVIA",
    "owner2": "SUNARDI, HENNY",
    "current_taxes": 16231.42,
    "new_taxes_no_override": 16932.62,
    "override_total_1": 17413.07,
    "override_increase_1": 480.45
  },
  {
    "#": "361 Vfw Pky (377-02-00)",
    "$": 1048400,
    "address": "361 Vfw Pky",
    "parcel_id": "377-02-00",
    "owner1": "PAPAZIAN, MICHELLE A",
    "owner2": "",
    "current_taxes": 7100.68,
    "new_taxes_no_override": 7407.43,
    "override_total_1": 7617.61,
    "override_increase_1": 210.18
  },
  {
    "#": "367 Vfw Pky (377-03-00)",
    "$": 1018200,
    "address": "367 Vfw Pky",
    "parcel_id": "377-03-00",
    "owner1": "SAMARAWEERA, SAM & VISAKHA",
    "owner2": "",
    "current_taxes": 6791.43,
    "new_taxes_no_override": 7084.82,
    "override_total_1": 7285.85,
    "override_increase_1": 201.03
  },
  {
    "#": "373 Vfw Pky (377-04-05)",
    "$": 971900,
    "address": "373 Vfw Pky",
    "parcel_id": "377-04-05",
    "owner1": "TSENG LIFE ESTATE, CHENG CHUAN & YU CHUN",
    "owner2": "",
    "current_taxes": 6317.32,
    "new_taxes_no_override": 6590.23,
    "override_total_1": 6777.22,
    "override_increase_1": 186.99
  },
  {
    "#": "377 Vfw Pky (377-06-00)",
    "$": 949200,
    "address": "377 Vfw Pky",
    "parcel_id": "377-06-00",
    "owner1": "WARD, ABIGAIL S",
    "owner2": "",
    "current_taxes": 6084.87,
    "new_taxes_no_override": 6347.74,
    "override_total_1": 6527.85,
    "override_increase_1": 180.11
  },
  {
    "#": "381 Vfw Pky (377-07-00)",
    "$": 1155500,
    "address": "381 Vfw Pky",
    "parcel_id": "377-07-00",
    "owner1": "FALET, HERVE",
    "owner2": "HOFFMEISTER, KARIN M",
    "current_taxes": 11832.32,
    "new_taxes_no_override": 12343.48,
    "override_total_1": 12693.71,
    "override_increase_1": 350.24
  },
  {
    "#": "385 Vfw Pky (377-08-00)",
    "$": 921100,
    "address": "385 Vfw Pky",
    "parcel_id": "377-08-00",
    "owner1": "GABBE LIFE ESTATE, DAVID R & MARIE L",
    "owner2": "",
    "current_taxes": 5797.13,
    "new_taxes_no_override": 6047.57,
    "override_total_1": 6219.16,
    "override_increase_1": 171.6
  },
  {
    "#": "389 Vfw Pky (377-09-00)",
    "$": 966300,
    "address": "389 Vfw Pky",
    "parcel_id": "377-09-00",
    "owner1": "BURMAN TRS, MORTON H & DIANE K",
    "owner2": "",
    "current_taxes": 6259.98,
    "new_taxes_no_override": 6530.41,
    "override_total_1": 6715.71,
    "override_increase_1": 185.3
  },
  {
    "#": "393 Vfw Pky (377-10-00)",
    "$": 945300,
    "address": "393 Vfw Pky",
    "parcel_id": "377-10-00",
    "owner1": "XIAO, YANPING",
    "owner2": "JIANG, CHENGLIANG",
    "current_taxes": 6044.94,
    "new_taxes_no_override": 6306.08,
    "override_total_1": 6485.01,
    "override_increase_1": 178.93
  },
  {
    "#": "394 Vfw Pky (378-03-05)",
    "$": 1301500,
    "address": "394 Vfw Pky",
    "parcel_id": "378-03-05",
    "owner1": "SWEI ET AL, ANNISSA",
    "owner2": "BARRON, KATHLEEN",
    "current_taxes": 9692.43,
    "new_taxes_no_override": 10111.14,
    "override_total_1": 10398.04,
    "override_increase_1": 286.9
  },
  {
    "#": "397 Vfw Pky (377-11-00)",
    "$": 858500,
    "address": "397 Vfw Pky",
    "parcel_id": "377-11-00",
    "owner1": "RAYNOR TR, CECILE S",
    "owner2": "",
    "current_taxes": 5156.11,
    "new_taxes_no_override": 5378.85,
    "override_total_1": 5531.47,
    "override_increase_1": 152.62
  },
  {
    "#": "401 Vfw Pky (377-12-00)",
    "$": 922600,
    "address": "401 Vfw Pky",
    "parcel_id": "377-12-00",
    "owner1": "MONACH, PAUL & LINDA",
    "owner2": "",
    "current_taxes": 9447.42,
    "new_taxes_no_override": 9855.55,
    "override_total_1": 10135.19,
    "override_increase_1": 279.64
  },
  {
    "#": "402 Vfw Pky (378-02-00)",
    "$": 1003100,
    "address": "402 Vfw Pky",
    "parcel_id": "378-02-00",
    "owner1": "TYSZKA, DANIEL A & GLORIA L S",
    "owner2": "",
    "current_taxes": 6636.81,
    "new_taxes_no_override": 6923.52,
    "override_total_1": 7119.97,
    "override_increase_1": 196.45
  },
  {
    "#": "405 Vfw Pky (377-13-00)",
    "$": 1107700,
    "address": "405 Vfw Pky",
    "parcel_id": "377-13-00",
    "owner1": "DANTOWITZ, RONALD & FAITH",
    "owner2": "",
    "current_taxes": 7707.91,
    "new_taxes_no_override": 8040.89,
    "override_total_1": 8269.05,
    "override_increase_1": 228.15
  },
  {
    "#": "416 Vfw Pky (379-04-00)",
    "$": 932700,
    "address": "416 Vfw Pky",
    "parcel_id": "379-04-00",
    "owner1": "BOWMAN, JON-MYCHAL & ADRIENNE",
    "owner2": "",
    "current_taxes": 5915.91,
    "new_taxes_no_override": 6171.48,
    "override_total_1": 6346.59,
    "override_increase_1": 175.11
  },
  {
    "#": "417 Vfw Pky (382-23-00)",
    "$": 1014900,
    "address": "417 Vfw Pky",
    "parcel_id": "382-23-00",
    "owner1": "DAPSHI, ELVIS",
    "owner2": "GJORGA, FRANCESKA",
    "current_taxes": 6757.64,
    "new_taxes_no_override": 7049.57,
    "override_total_1": 7249.6,
    "override_increase_1": 200.03
  },
  {
    "#": "424 Vfw Pky (379-05-00)",
    "$": 1314800,
    "address": "424 Vfw Pky",
    "parcel_id": "379-05-00",
    "owner1": "MILLER, JEDIDIAH  BRODIE",
    "owner2": "CABRAL, KELLEY JEAN",
    "current_taxes": 9828.62,
    "new_taxes_no_override": 10253.22,
    "override_total_1": 10544.14,
    "override_increase_1": 290.93
  },
  {
    "#": "425 Vfw Pky (382-01-00)",
    "$": 1108800,
    "address": "425 Vfw Pky",
    "parcel_id": "382-01-00",
    "owner1": "JUNG, JOONIL",
    "owner2": "LEE, EUNKYONG",
    "current_taxes": 7719.18,
    "new_taxes_no_override": 8052.65,
    "override_total_1": 8281.14,
    "override_increase_1": 228.49
  },
  {
    "#": "434 Vfw Pky (380-06-01)",
    "$": 17200,
    "address": "434 Vfw Pky",
    "parcel_id": "380-06-01",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O VACANT PARCEL/ABUT 436 VFW",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "436 Vfw Pky (380-06-00)",
    "$": 978700,
    "address": "436 Vfw Pky",
    "parcel_id": "380-06-00",
    "owner1": "HORN, MARY H",
    "owner2": "",
    "current_taxes": 6386.95,
    "new_taxes_no_override": 6662.87,
    "override_total_1": 6851.92,
    "override_increase_1": 189.05
  },
  {
    "#": "443 Vfw Pky (383-01-00)",
    "$": 1028300,
    "address": "443 Vfw Pky",
    "parcel_id": "383-01-00",
    "owner1": "GOON, BERNARD",
    "owner2": "WONG, YIM C",
    "current_taxes": 6894.86,
    "new_taxes_no_override": 7192.72,
    "override_total_1": 7396.81,
    "override_increase_1": 204.09
  },
  {
    "#": "444 Vfw Pky (380-07-00)",
    "$": 943100,
    "address": "444 Vfw Pky",
    "parcel_id": "380-07-00",
    "owner1": "BOXENHORN, BURTON MARIANNE",
    "owner2": "",
    "current_taxes": 6022.41,
    "new_taxes_no_override": 6282.58,
    "override_total_1": 6460.84,
    "override_increase_1": 178.26
  },
  {
    "#": "454 Vfw Pky (381-05-00)",
    "$": 886800,
    "address": "454 Vfw Pky",
    "parcel_id": "381-05-00",
    "owner1": "COHEN TRS, PHILLIP P & ANNA",
    "owner2": "",
    "current_taxes": 9080.83,
    "new_taxes_no_override": 9473.12,
    "override_total_1": 9741.91,
    "override_increase_1": 268.79
  },
  {
    "#": "455 Vfw Pky (384-01-00)",
    "$": 894000,
    "address": "455 Vfw Pky",
    "parcel_id": "384-01-00",
    "owner1": "NEITZEL TR, DAVID",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 9154.56,
    "new_taxes_no_override": 9550.04,
    "override_total_1": 9821.01,
    "override_increase_1": 270.97
  },
  {
    "#": "460 Vfw Pky (381-06-00)",
    "$": 954100,
    "address": "460 Vfw Pky",
    "parcel_id": "381-06-00",
    "owner1": "LUONGO, JOSEPH A",
    "owner2": "",
    "current_taxes": 6135.05,
    "new_taxes_no_override": 6400.08,
    "override_total_1": 6581.68,
    "override_increase_1": 181.6
  },
  {
    "#": "466 Vfw Pky (381-07-00)",
    "$": 1030300,
    "address": "466 Vfw Pky",
    "parcel_id": "381-07-00",
    "owner1": "SEMYANNIKOV, SERGEY",
    "owner2": "SEMYANNIKOVA, NATALYA",
    "current_taxes": 6915.34,
    "new_taxes_no_override": 7214.08,
    "override_total_1": 7418.78,
    "override_increase_1": 204.69
  },
  {
    "#": "471 Vfw Pky (388-01-00)",
    "$": 39667700,
    "address": "471 Vfw Pky",
    "parcel_id": "388-01-00",
    "owner1": "HV 91 LLC",
    "owner2": "C/O CHESTNUT HILL REALTY CORP",
    "current_taxes": 406197.25,
    "new_taxes_no_override": 423744.97,
    "override_total_1": 435768.41,
    "override_increase_1": 12023.44
  },
  {
    "#": "55 Village Way (137-03-00)",
    "$": 49379500,
    "address": "55 Village Way",
    "parcel_id": "137-03-00",
    "owner1": "THE VILLAGE AT BROOKLINE LP",
    "owner2": "C/O WINNCOMPANIES",
    "current_taxes": 505646.08,
    "new_taxes_no_override": 527489.99,
    "override_total_1": 542457.11,
    "override_increase_1": 14967.12
  },
  {
    "#": "1 Vogel Ter (307-29-00)",
    "$": 1425300,
    "address": "1 Vogel Ter",
    "parcel_id": "307-29-00",
    "owner1": "SLATTERY, MARY P",
    "owner2": "",
    "current_taxes": 10960.14,
    "new_taxes_no_override": 11433.62,
    "override_total_1": 11758.04,
    "override_increase_1": 324.42
  },
  {
    "#": "2 Vogel Ter (307-28-00)",
    "$": 1597400,
    "address": "2 Vogel Ter",
    "parcel_id": "307-28-00",
    "owner1": "JEPSEN, JAMES J",
    "owner2": "MCKIM, JENIFER B",
    "current_taxes": 12722.44,
    "new_taxes_no_override": 13272.05,
    "override_total_1": 13648.63,
    "override_increase_1": 376.58
  },
  {
    "#": "3 Vogel Ter (307-27-00)",
    "$": 1923200,
    "address": "3 Vogel Ter",
    "parcel_id": "307-27-00",
    "owner1": "TRAUB, OMRI & FLORA E",
    "owner2": "",
    "current_taxes": 16058.63,
    "new_taxes_no_override": 16752.36,
    "override_total_1": 17227.7,
    "override_increase_1": 475.34
  },
  {
    "#": "4 Vogel Ter (307-26-00)",
    "$": 1993100,
    "address": "4 Vogel Ter",
    "parcel_id": "307-26-00",
    "owner1": "ADLER, ELIZA",
    "owner2": "",
    "current_taxes": 16774.41,
    "new_taxes_no_override": 17499.06,
    "override_total_1": 17995.59,
    "override_increase_1": 496.52
  },
  {
    "#": "10 Waldo St (045-02-01)",
    "$": 8300000,
    "address": "10 Waldo St",
    "parcel_id": "045-02-01",
    "owner1": "CHR PLEASANT LLC",
    "owner2": "",
    "current_taxes": 142428.0,
    "new_taxes_no_override": 148580.89,
    "override_total_1": 152796.76,
    "override_increase_1": 4215.87
  },
  {
    "#": "11 Wallis Rd (394-12-00)",
    "$": 1284300,
    "address": "11 Wallis Rd",
    "parcel_id": "394-12-00",
    "owner1": "RICHARDSON, ROBERT E & MILDA B",
    "owner2": "",
    "current_taxes": 9516.3,
    "new_taxes_no_override": 9927.4,
    "override_total_1": 10209.09,
    "override_increase_1": 281.68
  },
  {
    "#": "14 Wallis Rd (393-16-00)",
    "$": 1904700,
    "address": "14 Wallis Rd",
    "parcel_id": "393-16-00",
    "owner1": "FALLON, DEREK & LINDSAY",
    "owner2": "",
    "current_taxes": 15869.19,
    "new_taxes_no_override": 16554.74,
    "override_total_1": 17024.47,
    "override_increase_1": 469.73
  },
  {
    "#": "17 Wallis Rd (394-11-00)",
    "$": 1518700,
    "address": "17 Wallis Rd",
    "parcel_id": "394-11-00",
    "owner1": "VARDHANABHUTI, SARAN",
    "owner2": "ZHANG, HUALEI",
    "current_taxes": 11916.55,
    "new_taxes_no_override": 12431.34,
    "override_total_1": 12784.07,
    "override_increase_1": 352.73
  },
  {
    "#": "20 Wallis Rd (393-17-00)",
    "$": 1605500,
    "address": "20 Wallis Rd",
    "parcel_id": "393-17-00",
    "owner1": "DIMINO, RICHARD & STEPHANIE A",
    "owner2": "",
    "current_taxes": 12805.39,
    "new_taxes_no_override": 13358.58,
    "override_total_1": 13737.62,
    "override_increase_1": 379.04
  },
  {
    "#": "21 Wallis Rd (394-10-00)",
    "$": 1253500,
    "address": "21 Wallis Rd",
    "parcel_id": "394-10-00",
    "owner1": "SAGER TR, CAROL",
    "owner2": "",
    "current_taxes": 9200.91,
    "new_taxes_no_override": 9598.39,
    "override_total_1": 9870.74,
    "override_increase_1": 272.35
  },
  {
    "#": "26 Wallis Rd (393-18-00)",
    "$": 1390400,
    "address": "26 Wallis Rd",
    "parcel_id": "393-18-00",
    "owner1": "BALIAMOUNE, MOSTAFA Z",
    "owner2": "IKEN, KHADIJA",
    "current_taxes": 10602.76,
    "new_taxes_no_override": 11060.8,
    "override_total_1": 11374.64,
    "override_increase_1": 313.84
  },
  {
    "#": "29 Wallis Rd (394-09-00)",
    "$": 1861300,
    "address": "29 Wallis Rd",
    "parcel_id": "394-09-00",
    "owner1": "LILIENFELD, ARMIN L & CHRISTINE W",
    "owner2": "",
    "current_taxes": 15424.78,
    "new_taxes_no_override": 16091.13,
    "override_total_1": 16547.7,
    "override_increase_1": 456.57
  },
  {
    "#": "32 Wallis Rd (393-19-00)",
    "$": 1545700,
    "address": "32 Wallis Rd",
    "parcel_id": "393-19-00",
    "owner1": "ALBERT, HARVEY & BEVERLY",
    "owner2": "",
    "current_taxes": 12193.03,
    "new_taxes_no_override": 12719.77,
    "override_total_1": 13080.68,
    "override_increase_1": 360.91
  },
  {
    "#": "35 Wallis Rd (394-08-00)",
    "$": 1833700,
    "address": "35 Wallis Rd",
    "parcel_id": "394-08-00",
    "owner1": "HANDELMAN, LAUREN M",
    "owner2": "ARONSON, EDGAR D",
    "current_taxes": 15142.15,
    "new_taxes_no_override": 15796.29,
    "override_total_1": 16244.5,
    "override_increase_1": 448.21
  },
  {
    "#": "40 Wallis Rd (393-20-00)",
    "$": 1477600,
    "address": "40 Wallis Rd",
    "parcel_id": "393-20-00",
    "owner1": "WEITZ, AARON RICHARD & DEBORAH QUYNH NHU GARCIA",
    "owner2": "",
    "current_taxes": 11495.69,
    "new_taxes_no_override": 11992.3,
    "override_total_1": 12332.58,
    "override_increase_1": 340.27
  },
  {
    "#": "41 Wallis Rd (394-07-00)",
    "$": 1500700,
    "address": "41 Wallis Rd",
    "parcel_id": "394-07-00",
    "owner1": "CLARKE TRS, CRISTIN",
    "owner2": "PRIEBE, GREGORY PAUL",
    "current_taxes": 11732.23,
    "new_taxes_no_override": 12239.06,
    "override_total_1": 12586.34,
    "override_increase_1": 347.27
  },
  {
    "#": "46 Wallis Rd (393-21-00)",
    "$": 675800,
    "address": "46 Wallis Rd",
    "parcel_id": "393-21-00",
    "owner1": "SCHNEIDER, SAMUEL M",
    "owner2": "",
    "current_taxes": 6920.19,
    "new_taxes_no_override": 7219.14,
    "override_total_1": 7423.98,
    "override_increase_1": 204.84
  },
  {
    "#": "47 Wallis Rd (394-06-00)",
    "$": 1299900,
    "address": "47 Wallis Rd",
    "parcel_id": "394-06-00",
    "owner1": "DONAHUE, KEVIN J",
    "owner2": "COSTELLO, KERRY A",
    "current_taxes": 13310.98,
    "new_taxes_no_override": 13886.01,
    "override_total_1": 14280.02,
    "override_increase_1": 394.01
  },
  {
    "#": "52 Wallis Rd (393-22-00)",
    "$": 718200,
    "address": "52 Wallis Rd",
    "parcel_id": "393-22-00",
    "owner1": "DORF, MARTIN E & JUDY",
    "owner2": "",
    "current_taxes": 7354.37,
    "new_taxes_no_override": 7672.08,
    "override_total_1": 7889.77,
    "override_increase_1": 217.69
  },
  {
    "#": "53 Wallis Rd (394-05-00)",
    "$": 1385400,
    "address": "53 Wallis Rd",
    "parcel_id": "394-05-00",
    "owner1": "CHERTOV, ANDREY",
    "owner2": "VOLKOVA, NATALIYA",
    "current_taxes": 14186.5,
    "new_taxes_no_override": 14799.36,
    "override_total_1": 15219.28,
    "override_increase_1": 419.92
  },
  {
    "#": "59 Wallis Rd (394-04-00)",
    "$": 1717200,
    "address": "59 Wallis Rd",
    "parcel_id": "394-04-00",
    "owner1": "SCHNEIDER, JACOB & CLAIRE SUPERFINE",
    "owner2": "",
    "current_taxes": 13949.19,
    "new_taxes_no_override": 14551.8,
    "override_total_1": 14964.69,
    "override_increase_1": 412.9
  },
  {
    "#": "60 Wallis Rd (393-23-24)",
    "$": 1339900,
    "address": "60 Wallis Rd",
    "parcel_id": "393-23-24",
    "owner1": "FAN, DERZEN",
    "owner2": "POELWIJK, FRANCISCUS",
    "current_taxes": 13720.58,
    "new_taxes_no_override": 14313.31,
    "override_total_1": 14719.44,
    "override_increase_1": 406.13
  },
  {
    "#": "65 Wallis Rd (394-03-00)",
    "$": 1208500,
    "address": "65 Wallis Rd",
    "parcel_id": "394-03-00",
    "owner1": "APPLEBAUM, AMIRAM",
    "owner2": "",
    "current_taxes": 12375.04,
    "new_taxes_no_override": 12909.64,
    "override_total_1": 13275.94,
    "override_increase_1": 366.3
  },
  {
    "#": "70 Wallis Rd (393-25-00)",
    "$": 1666400,
    "address": "70 Wallis Rd",
    "parcel_id": "393-25-00",
    "owner1": "CHEN, YING",
    "owner2": "SONG, MINGYANG",
    "current_taxes": 13429.0,
    "new_taxes_no_override": 14009.13,
    "override_total_1": 14406.63,
    "override_increase_1": 397.5
  },
  {
    "#": "72 Wallis Rd (393-26-00)",
    "$": 1040100,
    "address": "72 Wallis Rd",
    "parcel_id": "393-26-00",
    "owner1": "MOGILEVSKY, ROMAN",
    "owner2": "GLEYZER, ELIZABETH",
    "current_taxes": 10650.62,
    "new_taxes_no_override": 11110.73,
    "override_total_1": 11425.99,
    "override_increase_1": 315.26
  },
  {
    "#": "73 Wallis Rd (394-02-00)",
    "$": 1476300,
    "address": "73 Wallis Rd",
    "parcel_id": "394-02-00",
    "owner1": "LEVY, DAVID L & GAIL",
    "owner2": "",
    "current_taxes": 11482.38,
    "new_taxes_no_override": 11978.42,
    "override_total_1": 12318.3,
    "override_increase_1": 339.88
  },
  {
    "#": "79 Wallis Rd (394-01-00)",
    "$": 1496400,
    "address": "79 Wallis Rd",
    "parcel_id": "394-01-00",
    "owner1": "RABKIN, ELENA",
    "owner2": "",
    "current_taxes": 11688.2,
    "new_taxes_no_override": 12193.13,
    "override_total_1": 12539.1,
    "override_increase_1": 345.97
  },
  {
    "#": "80 Wallis Rd (393-27-00)",
    "$": 1876000,
    "address": "80 Wallis Rd",
    "parcel_id": "393-27-00",
    "owner1": "SHLAYEN, JEFFREY",
    "owner2": "FISHMAN, MARINA",
    "current_taxes": 15575.31,
    "new_taxes_no_override": 16248.16,
    "override_total_1": 16709.19,
    "override_increase_1": 461.03
  },
  {
    "#": "84 Wallis Rd (398-01-00)",
    "$": 1718600,
    "address": "84 Wallis Rd",
    "parcel_id": "398-01-00",
    "owner1": "CUTTER, CHRISTINA M",
    "owner2": "BERLIN, NICHOLAS LEE",
    "current_taxes": 13963.53,
    "new_taxes_no_override": 14566.75,
    "override_total_1": 14980.07,
    "override_increase_1": 413.32
  },
  {
    "#": "85 Wallis Rd (397-28-00)",
    "$": 1166400,
    "address": "85 Wallis Rd",
    "parcel_id": "397-28-00",
    "owner1": "XING, JIANGANG",
    "owner2": "ZHONG, ZHAOHUI",
    "current_taxes": 8309.0,
    "new_taxes_no_override": 8667.95,
    "override_total_1": 8913.9,
    "override_increase_1": 245.95
  },
  {
    "#": "90 Wallis Rd (398-02-00)",
    "$": 2055500,
    "address": "90 Wallis Rd",
    "parcel_id": "398-02-00",
    "owner1": "JOGIKALMATH, GANGADHAR",
    "owner2": "GANDHI, LEENA",
    "current_taxes": 21048.32,
    "new_taxes_no_override": 21957.61,
    "override_total_1": 22580.64,
    "override_increase_1": 623.03
  },
  {
    "#": "91 Wallis Rd (397-27-00)",
    "$": 1348100,
    "address": "91 Wallis Rd",
    "parcel_id": "397-27-00",
    "owner1": "SIDERS, THOMAS & AMILY",
    "owner2": "",
    "current_taxes": 10169.61,
    "new_taxes_no_override": 10608.94,
    "override_total_1": 10909.96,
    "override_increase_1": 301.02
  },
  {
    "#": "98 Wallis Rd (398-02-01)",
    "$": 1650300,
    "address": "98 Wallis Rd",
    "parcel_id": "398-02-01",
    "owner1": "KAVIAR, JULIE A",
    "owner2": "STEFANI, RICHARD J",
    "current_taxes": 13264.14,
    "new_taxes_no_override": 13837.15,
    "override_total_1": 14229.77,
    "override_increase_1": 392.62
  },
  {
    "#": "99 Wallis Rd (397-26-00)",
    "$": 1072600,
    "address": "99 Wallis Rd",
    "parcel_id": "397-26-00",
    "owner1": "FAVERMAN, MARK L & BARBARA L",
    "owner2": "",
    "current_taxes": 7348.49,
    "new_taxes_no_override": 7665.94,
    "override_total_1": 7883.46,
    "override_increase_1": 217.52
  },
  {
    "#": "102 Wallis Rd (398-03-01)",
    "$": 1935200,
    "address": "102 Wallis Rd",
    "parcel_id": "398-03-01",
    "owner1": "SACKS, MARCY G",
    "owner2": "",
    "current_taxes": 16181.51,
    "new_taxes_no_override": 16880.55,
    "override_total_1": 17359.52,
    "override_increase_1": 478.97
  },
  {
    "#": "103 Wallis Rd (397-25-00)",
    "$": 1461100,
    "address": "103 Wallis Rd",
    "parcel_id": "397-25-00",
    "owner1": "LINKOV, ETTY & DMITRY",
    "owner2": "",
    "current_taxes": 11326.73,
    "new_taxes_no_override": 11816.04,
    "override_total_1": 12151.32,
    "override_increase_1": 335.27
  },
  {
    "#": "109 Wallis Rd (397-24-00)",
    "$": 1121400,
    "address": "109 Wallis Rd",
    "parcel_id": "397-24-00",
    "owner1": "109 WALLIS LLC",
    "owner2": "",
    "current_taxes": 11483.14,
    "new_taxes_no_override": 11979.21,
    "override_total_1": 12319.11,
    "override_increase_1": 339.9
  },
  {
    "#": "110 Wallis Rd (398-04-00)",
    "$": 1943500,
    "address": "110 Wallis Rd",
    "parcel_id": "398-04-00",
    "owner1": "LEON TR, SONIA A",
    "owner2": "",
    "current_taxes": 16266.51,
    "new_taxes_no_override": 16969.22,
    "override_total_1": 17450.71,
    "override_increase_1": 481.49
  },
  {
    "#": "118 Wallis Rd (398-05-00)",
    "$": 1909100,
    "address": "118 Wallis Rd",
    "parcel_id": "398-05-00",
    "owner1": "HWANG TRS, DAVID HONGYUAN",
    "owner2": "WANG, NANCY",
    "current_taxes": 15914.25,
    "new_taxes_no_override": 16601.75,
    "override_total_1": 17072.81,
    "override_increase_1": 471.06
  },
  {
    "#": "119 Wallis Rd (397-23-00)",
    "$": 1388700,
    "address": "119 Wallis Rd",
    "parcel_id": "397-23-00",
    "owner1": "TOBASKY, JEFFREY P",
    "owner2": "LEVIN, PAMELA J",
    "current_taxes": 10585.35,
    "new_taxes_no_override": 11042.64,
    "override_total_1": 11355.96,
    "override_increase_1": 313.33
  },
  {
    "#": "126 Wallis Rd (398-06-00)",
    "$": 2034000,
    "address": "126 Wallis Rd",
    "parcel_id": "398-06-00",
    "owner1": "CAHILL TRS, PATRICK D & ANN HETHERWICK",
    "owner2": "",
    "current_taxes": 17193.23,
    "new_taxes_no_override": 17935.98,
    "override_total_1": 18444.9,
    "override_increase_1": 508.92
  },
  {
    "#": "127 Wallis Rd (397-22-00)",
    "$": 1164200,
    "address": "127 Wallis Rd",
    "parcel_id": "397-22-00",
    "owner1": "CLIFFORD, JOHN",
    "owner2": "HACKETT, SANDRA",
    "current_taxes": 8286.47,
    "new_taxes_no_override": 8644.45,
    "override_total_1": 8889.73,
    "override_increase_1": 245.28
  },
  {
    "#": "134 Wallis Rd (398-07-00)",
    "$": 1743900,
    "address": "134 Wallis Rd",
    "parcel_id": "398-07-00",
    "owner1": "KOPLOW TRS, EDWARD M & JAMES H",
    "owner2": "",
    "current_taxes": 17857.54,
    "new_taxes_no_override": 18628.99,
    "override_total_1": 19157.57,
    "override_increase_1": 528.58
  },
  {
    "#": "135 Wallis Rd (397-21-00)",
    "$": 1582500,
    "address": "135 Wallis Rd",
    "parcel_id": "397-21-00",
    "owner1": "ZHENG TRS, XIN JIA & GANG",
    "owner2": "",
    "current_taxes": 12569.87,
    "new_taxes_no_override": 13112.89,
    "override_total_1": 13484.96,
    "override_increase_1": 372.07
  },
  {
    "#": "146 Wallis Rd (398A-08-00)",
    "$": 1892400,
    "address": "146 Wallis Rd",
    "parcel_id": "398A-08-00",
    "owner1": "BERNSTEIN, STEPHEN B & JUDITH A",
    "owner2": "",
    "current_taxes": 15743.24,
    "new_taxes_no_override": 16423.35,
    "override_total_1": 16889.35,
    "override_increase_1": 466.0
  },
  {
    "#": "147 Wallis Rd (397-20-00)",
    "$": 1483900,
    "address": "147 Wallis Rd",
    "parcel_id": "397-20-00",
    "owner1": "RIDLEY, REBECCA",
    "owner2": "",
    "current_taxes": 11560.2,
    "new_taxes_no_override": 12059.6,
    "override_total_1": 12401.78,
    "override_increase_1": 342.18
  },
  {
    "#": "151 Wallis Rd (397-19-00)",
    "$": 1767300,
    "address": "151 Wallis Rd",
    "parcel_id": "397-19-00",
    "owner1": "LI TR, JONATHAN ZHENG",
    "owner2": "YU TR, ELAINE WEI-YIN",
    "current_taxes": 14462.22,
    "new_taxes_no_override": 15086.99,
    "override_total_1": 15515.07,
    "override_increase_1": 428.08
  },
  {
    "#": "154 Wallis Rd (398A-09-00)",
    "$": 2713400,
    "address": "154 Wallis Rd",
    "parcel_id": "398A-09-00",
    "owner1": "GOMOLIN TR, DAVID",
    "owner2": "",
    "current_taxes": 24150.28,
    "new_taxes_no_override": 25193.57,
    "override_total_1": 25908.42,
    "override_increase_1": 714.85
  },
  {
    "#": "161 Wallis Rd (397-18-00)",
    "$": 1968700,
    "address": "161 Wallis Rd",
    "parcel_id": "397-18-00",
    "owner1": "MILSTONE TRS, DAVID S",
    "owner2": "PETERSEN, KATHY D",
    "current_taxes": 16524.55,
    "new_taxes_no_override": 17238.41,
    "override_total_1": 17727.54,
    "override_increase_1": 489.13
  },
  {
    "#": "162 Wallis Rd (398A-10-00)",
    "$": 3459400,
    "address": "162 Wallis Rd",
    "parcel_id": "398A-10-00",
    "owner1": "JACOBSON, TR, EDMON Y",
    "owner2": "",
    "current_taxes": 35424.26,
    "new_taxes_no_override": 36954.59,
    "override_total_1": 38003.15,
    "override_increase_1": 1048.56
  },
  {
    "#": "171 Wallis Rd (397-16-00)",
    "$": 1414200,
    "address": "171 Wallis Rd",
    "parcel_id": "397-16-00",
    "owner1": "GERMAN, MICHAEL & TANYA",
    "owner2": "",
    "current_taxes": 10846.47,
    "new_taxes_no_override": 11315.04,
    "override_total_1": 11636.09,
    "override_increase_1": 321.06
  },
  {
    "#": "183 Wallis Rd (397-15-00)",
    "$": 2319400,
    "address": "183 Wallis Rd",
    "parcel_id": "397-15-00",
    "owner1": "CHENG, JUDY",
    "owner2": "KWONG, RAYMOND YAN-KIT",
    "current_taxes": 20115.72,
    "new_taxes_no_override": 20984.72,
    "override_total_1": 21580.14,
    "override_increase_1": 595.43
  },
  {
    "#": "186 Wallis Rd (400-05-00)",
    "$": 1609200,
    "address": "186 Wallis Rd",
    "parcel_id": "400-05-00",
    "owner1": "STEIN TRS, LEONARD E & MARILYN L",
    "owner2": "",
    "current_taxes": 12843.27,
    "new_taxes_no_override": 13398.1,
    "override_total_1": 13778.26,
    "override_increase_1": 380.16
  },
  {
    "#": "192 Wallis Rd (400-04-00)",
    "$": 951000,
    "address": "192 Wallis Rd",
    "parcel_id": "400-04-00",
    "owner1": "PERRY, HEDY M",
    "owner2": "",
    "current_taxes": 6103.31,
    "new_taxes_no_override": 6366.97,
    "override_total_1": 6547.63,
    "override_increase_1": 180.66
  },
  {
    "#": "11 Walnut Hill Rd (374-02-00)",
    "$": 2121700,
    "address": "11 Walnut Hill Rd",
    "parcel_id": "374-02-00",
    "owner1": "BURK, ARIADNE J",
    "owner2": "",
    "current_taxes": 18091.27,
    "new_taxes_no_override": 18872.81,
    "override_total_1": 19408.31,
    "override_increase_1": 535.5
  },
  {
    "#": "14 Walnut Hill Rd (394-15-00)",
    "$": 1585800,
    "address": "14 Walnut Hill Rd",
    "parcel_id": "394-15-00",
    "owner1": "BULANOV, BORIS",
    "owner2": "",
    "current_taxes": 12603.66,
    "new_taxes_no_override": 13148.14,
    "override_total_1": 13521.21,
    "override_increase_1": 373.07
  },
  {
    "#": "17 Walnut Hill Rd (374-03-00)",
    "$": 1791500,
    "address": "17 Walnut Hill Rd",
    "parcel_id": "374-03-00",
    "owner1": "GREENBERGER, GAIL",
    "owner2": "",
    "current_taxes": 14710.03,
    "new_taxes_no_override": 15345.5,
    "override_total_1": 15780.92,
    "override_increase_1": 435.42
  },
  {
    "#": "20 Walnut Hill Rd (394-16-00)",
    "$": 1355200,
    "address": "20 Walnut Hill Rd",
    "parcel_id": "394-16-00",
    "owner1": "BEGELFER TRS, DAVID I",
    "owner2": "LIBBY, BETTE ANN",
    "current_taxes": 10242.31,
    "new_taxes_no_override": 10684.78,
    "override_total_1": 10987.95,
    "override_increase_1": 303.17
  },
  {
    "#": "26 Walnut Hill Rd (394-17-00)",
    "$": 1530900,
    "address": "26 Walnut Hill Rd",
    "parcel_id": "394-17-00",
    "owner1": "MCKENDRY, JOSEPH & SUSAN",
    "owner2": "",
    "current_taxes": 12041.48,
    "new_taxes_no_override": 12561.67,
    "override_total_1": 12918.1,
    "override_increase_1": 356.43
  },
  {
    "#": "32 Walnut Hill Rd (394-18-00)",
    "$": 1319700,
    "address": "32 Walnut Hill Rd",
    "parcel_id": "394-18-00",
    "owner1": "RUIGOMEZ, CHRISTOPHER",
    "owner2": "BRUELL, EMILY",
    "current_taxes": 9878.79,
    "new_taxes_no_override": 10305.55,
    "override_total_1": 10597.97,
    "override_increase_1": 292.41
  },
  {
    "#": "38 Walnut Hill Rd (394-19-00)",
    "$": 1431300,
    "address": "38 Walnut Hill Rd",
    "parcel_id": "394-19-00",
    "owner1": "JOHNAS, ANNA MARIE",
    "owner2": "FARHANGSAHLEVANI, HESHMATOLLAH",
    "current_taxes": 11021.58,
    "new_taxes_no_override": 11497.71,
    "override_total_1": 11823.95,
    "override_increase_1": 326.24
  },
  {
    "#": "39 Walnut Hill Rd (395-41-00)",
    "$": 1241700,
    "address": "39 Walnut Hill Rd",
    "parcel_id": "395-41-00",
    "owner1": "MIKELIS, MAGDALINE",
    "owner2": "",
    "current_taxes": 9080.07,
    "new_taxes_no_override": 9472.33,
    "override_total_1": 9741.1,
    "override_increase_1": 268.77
  },
  {
    "#": "42 Walnut Hill Rd (394-20-00)",
    "$": 2600300,
    "address": "42 Walnut Hill Rd",
    "parcel_id": "394-20-00",
    "owner1": "MCCANT TR, KIM R",
    "owner2": "",
    "current_taxes": 22992.14,
    "new_taxes_no_override": 23985.4,
    "override_total_1": 24665.97,
    "override_increase_1": 680.57
  },
  {
    "#": "45 Walnut Hill Rd (395-42-00)",
    "$": 1373800,
    "address": "45 Walnut Hill Rd",
    "parcel_id": "395-42-00",
    "owner1": "SAGOV, STANLEY E & ELIVIA SAVADIER",
    "owner2": "",
    "current_taxes": 10432.78,
    "new_taxes_no_override": 10883.48,
    "override_total_1": 11192.29,
    "override_increase_1": 308.81
  },
  {
    "#": "50 Walnut Hill Rd (394-21-00)",
    "$": 1138900,
    "address": "50 Walnut Hill Rd",
    "parcel_id": "394-21-00",
    "owner1": "FOLCO, EDUARDO J",
    "owner2": "BUSCONI, LILIANA",
    "current_taxes": 8027.4,
    "new_taxes_no_override": 8374.18,
    "override_total_1": 8611.79,
    "override_increase_1": 237.61
  },
  {
    "#": "60 Walnut Hill Rd (394-22-00)",
    "$": 1459700,
    "address": "60 Walnut Hill Rd",
    "parcel_id": "394-22-00",
    "owner1": "BUSHOY, ALEX & LUDMILA",
    "owner2": "",
    "current_taxes": 11312.39,
    "new_taxes_no_override": 11801.09,
    "override_total_1": 12135.93,
    "override_increase_1": 334.85
  },
  {
    "#": "62 Walnut Hill Rd (394-23-24)",
    "$": 1679100,
    "address": "62 Walnut Hill Rd",
    "parcel_id": "394-23-24",
    "owner1": "EISENBERG, MURRAY A & JANE E",
    "owner2": "",
    "current_taxes": 13559.05,
    "new_taxes_no_override": 14144.8,
    "override_total_1": 14546.15,
    "override_increase_1": 401.35
  },
  {
    "#": "73 Walnut Hill Rd (396-02-00)",
    "$": 2340600,
    "address": "73 Walnut Hill Rd",
    "parcel_id": "396-02-00",
    "owner1": "AUGUR, TRIMBLE S",
    "owner2": "BLUMAN, ERIC M",
    "current_taxes": 20332.81,
    "new_taxes_no_override": 21211.19,
    "override_total_1": 21813.04,
    "override_increase_1": 601.85
  },
  {
    "#": "74 Walnut Hill Rd (394-25-00)",
    "$": 1469400,
    "address": "74 Walnut Hill Rd",
    "parcel_id": "394-25-00",
    "owner1": "ROWE LIFE ESTATE, MARIA F",
    "owner2": "",
    "current_taxes": 11411.72,
    "new_taxes_no_override": 11904.71,
    "override_total_1": 12242.49,
    "override_increase_1": 337.79
  },
  {
    "#": "77 Walnut Hill Rd (396-03-00)",
    "$": 2334000,
    "address": "77 Walnut Hill Rd",
    "parcel_id": "396-03-00",
    "owner1": "JANKOWSKI TRS, THADDEUS",
    "owner2": "WILDER, CLAUDYNE",
    "current_taxes": 20265.23,
    "new_taxes_no_override": 21140.69,
    "override_total_1": 21740.54,
    "override_increase_1": 599.85
  },
  {
    "#": "80 Walnut Hill Rd (394-26-00)",
    "$": 1044200,
    "address": "80 Walnut Hill Rd",
    "parcel_id": "394-26-00",
    "owner1": "GEDDIS, PAMELA R",
    "owner2": "",
    "current_taxes": 7057.67,
    "new_taxes_no_override": 7362.56,
    "override_total_1": 7571.47,
    "override_increase_1": 208.91
  },
  {
    "#": "85 Walnut Hill Rd (396-04-00)",
    "$": 1796700,
    "address": "85 Walnut Hill Rd",
    "parcel_id": "396-04-00",
    "owner1": "GILYAN, GITTA",
    "owner2": "DAVIS, ERIC",
    "current_taxes": 14763.27,
    "new_taxes_no_override": 15401.04,
    "override_total_1": 15838.04,
    "override_increase_1": 436.99
  },
  {
    "#": "86 Walnut Hill Rd (397-01-00)",
    "$": 78900,
    "address": "86 Walnut Hill Rd",
    "parcel_id": "397-01-00",
    "owner1": "GEDDIS, PAMELA R",
    "owner2": "",
    "current_taxes": 807.94,
    "new_taxes_no_override": 842.84,
    "override_total_1": 866.76,
    "override_increase_1": 23.92
  },
  {
    "#": "91 Walnut Hill Rd (396-05-00)",
    "$": 1528400,
    "address": "91 Walnut Hill Rd",
    "parcel_id": "396-05-00",
    "owner1": "SCHILLER, SUSAN",
    "owner2": "",
    "current_taxes": 12015.88,
    "new_taxes_no_override": 12534.97,
    "override_total_1": 12890.64,
    "override_increase_1": 355.67
  },
  {
    "#": "94 Walnut Hill Rd (397-02-00)",
    "$": 1111800,
    "address": "94 Walnut Hill Rd",
    "parcel_id": "397-02-00",
    "owner1": "WEINSTEIN, DAVID",
    "owner2": "",
    "current_taxes": 7749.9,
    "new_taxes_no_override": 8084.7,
    "override_total_1": 8314.09,
    "override_increase_1": 229.4
  },
  {
    "#": "97 Walnut Hill Rd (396-06-00)",
    "$": 1451200,
    "address": "97 Walnut Hill Rd",
    "parcel_id": "396-06-00",
    "owner1": "HOLLENBERG TR, DONNA CAROLE KROLIK",
    "owner2": "",
    "current_taxes": 11225.35,
    "new_taxes_no_override": 11710.29,
    "override_total_1": 12042.56,
    "override_increase_1": 332.27
  },
  {
    "#": "98 Walnut Hill Rd (397-03-00)",
    "$": 86000,
    "address": "98 Walnut Hill Rd",
    "parcel_id": "397-03-00",
    "owner1": "WEINSTEIN, DAVID",
    "owner2": "",
    "current_taxes": 880.64,
    "new_taxes_no_override": 918.68,
    "override_total_1": 944.75,
    "override_increase_1": 26.07
  },
  {
    "#": "105 Walnut Hill Rd (396-07-00)",
    "$": 1570600,
    "address": "105 Walnut Hill Rd",
    "parcel_id": "396-07-00",
    "owner1": "KLEIN, ANDREW R & LEAR S",
    "owner2": "",
    "current_taxes": 12448.01,
    "new_taxes_no_override": 12985.76,
    "override_total_1": 13354.23,
    "override_increase_1": 368.46
  },
  {
    "#": "110 Walnut Hill Rd (397-03-01)",
    "$": 4353500,
    "address": "110 Walnut Hill Rd",
    "parcel_id": "397-03-01",
    "owner1": "WANG, JINGYU",
    "owner2": "",
    "current_taxes": 44579.84,
    "new_taxes_no_override": 46505.69,
    "override_total_1": 47825.25,
    "override_increase_1": 1319.56
  },
  {
    "#": "111 Walnut Hill Rd (396-08-00)",
    "$": 1639300,
    "address": "111 Walnut Hill Rd",
    "parcel_id": "396-08-00",
    "owner1": "MCGARR, KEVIN G & LORRAINE E",
    "owner2": "",
    "current_taxes": 13151.5,
    "new_taxes_no_override": 13719.64,
    "override_total_1": 14108.93,
    "override_increase_1": 389.28
  },
  {
    "#": "118 Walnut Hill Rd (397-05-00)",
    "$": 1709000,
    "address": "118 Walnut Hill Rd",
    "parcel_id": "397-05-00",
    "owner1": "GALLOP, FLORENCE W",
    "owner2": "",
    "current_taxes": 13865.23,
    "new_taxes_no_override": 14464.21,
    "override_total_1": 14874.62,
    "override_increase_1": 410.41
  },
  {
    "#": "119 Walnut Hill Rd (396-09-00)",
    "$": 2935000,
    "address": "119 Walnut Hill Rd",
    "parcel_id": "396-09-00",
    "owner1": "COOPER, REBECCA R",
    "owner2": "",
    "current_taxes": 26419.47,
    "new_taxes_no_override": 27560.79,
    "override_total_1": 28342.81,
    "override_increase_1": 782.02
  },
  {
    "#": "126 Walnut Hill Rd (397-06-00)",
    "$": 1482300,
    "address": "126 Walnut Hill Rd",
    "parcel_id": "397-06-00",
    "owner1": "BARNA, KENNETH M & JANE D",
    "owner2": "",
    "current_taxes": 11543.82,
    "new_taxes_no_override": 12042.51,
    "override_total_1": 12384.21,
    "override_increase_1": 341.7
  },
  {
    "#": "129 Walnut Hill Rd (396-10-00)",
    "$": 2039600,
    "address": "129 Walnut Hill Rd",
    "parcel_id": "396-10-00",
    "owner1": "WEINSTEIN, DAVID M & AMY H",
    "owner2": "",
    "current_taxes": 17250.57,
    "new_taxes_no_override": 17995.79,
    "override_total_1": 18506.41,
    "override_increase_1": 510.62
  },
  {
    "#": "135 Walnut Hill Rd (396-11-00)",
    "$": 1995000,
    "address": "135 Walnut Hill Rd",
    "parcel_id": "396-11-00",
    "owner1": "FICKEN TRS, FREDERICK A & PATRICE BORST",
    "owner2": "",
    "current_taxes": 16793.87,
    "new_taxes_no_override": 17519.37,
    "override_total_1": 18016.46,
    "override_increase_1": 497.1
  },
  {
    "#": "136 Walnut Hill Rd (397-07-00)",
    "$": 3200400,
    "address": "136 Walnut Hill Rd",
    "parcel_id": "397-07-00",
    "owner1": "HE, CHUNXING",
    "owner2": "",
    "current_taxes": 29137.16,
    "new_taxes_no_override": 30395.89,
    "override_total_1": 31258.35,
    "override_increase_1": 862.46
  },
  {
    "#": "144 Walnut Hill Rd (397-08-00)",
    "$": 2509800,
    "address": "144 Walnut Hill Rd",
    "parcel_id": "397-08-00",
    "owner1": "PREIS TR, ELISABETH D",
    "owner2": "",
    "current_taxes": 22065.42,
    "new_taxes_no_override": 23018.65,
    "override_total_1": 23671.78,
    "override_increase_1": 653.14
  },
  {
    "#": "145 Walnut Hill Rd (396-12-00)",
    "$": 1500400,
    "address": "145 Walnut Hill Rd",
    "parcel_id": "396-12-00",
    "owner1": "GLAUBERMAN-ROCK TRS, CAROL",
    "owner2": "ROCK, KENNETH L",
    "current_taxes": 11729.16,
    "new_taxes_no_override": 12235.86,
    "override_total_1": 12583.04,
    "override_increase_1": 347.18
  },
  {
    "#": "150 Walnut Hill Rd (397-09-00)",
    "$": 1128000,
    "address": "150 Walnut Hill Rd",
    "parcel_id": "397-09-00",
    "owner1": "SCHINDEL, MARGARET R",
    "owner2": "LALLY, JOHN R",
    "current_taxes": 7915.79,
    "new_taxes_no_override": 8257.75,
    "override_total_1": 8492.06,
    "override_increase_1": 234.31
  },
  {
    "#": "153 Walnut Hill Rd (396-13-00)",
    "$": 1624200,
    "address": "153 Walnut Hill Rd",
    "parcel_id": "396-13-00",
    "owner1": "FOY, ROSEMARY BATTLES",
    "owner2": "",
    "current_taxes": 12996.87,
    "new_taxes_no_override": 13558.33,
    "override_total_1": 13943.04,
    "override_increase_1": 384.71
  },
  {
    "#": "158 Walnut Hill Rd (397-10-00)",
    "$": 2293700,
    "address": "158 Walnut Hill Rd",
    "parcel_id": "397-10-00",
    "owner1": "COCUZZO, ROBERT",
    "owner2": "JOHNSON, JENNIFER",
    "current_taxes": 19852.55,
    "new_taxes_no_override": 20710.18,
    "override_total_1": 21297.82,
    "override_increase_1": 587.64
  },
  {
    "#": "166 Walnut Hill Rd (397-11-00)",
    "$": 2575500,
    "address": "166 Walnut Hill Rd",
    "parcel_id": "397-11-00",
    "owner1": "SCHMULTS, ROBERT C & CHRYSALYNE",
    "owner2": "",
    "current_taxes": 22738.19,
    "new_taxes_no_override": 23720.48,
    "override_total_1": 24393.53,
    "override_increase_1": 673.05
  },
  {
    "#": "171 Walnut Hill Rd (396-14-00)",
    "$": 2148600,
    "address": "171 Walnut Hill Rd",
    "parcel_id": "396-14-00",
    "owner1": "KRYZANSKI, JAMES T",
    "owner2": "KATHERINE, P C",
    "current_taxes": 18366.73,
    "new_taxes_no_override": 19160.17,
    "override_total_1": 19703.83,
    "override_increase_1": 543.66
  },
  {
    "#": "172 Walnut Hill Rd (397-12-00)",
    "$": 1958500,
    "address": "172 Walnut Hill Rd",
    "parcel_id": "397-12-00",
    "owner1": "FERGUSON, DANIEL H",
    "owner2": "",
    "current_taxes": 16420.11,
    "new_taxes_no_override": 17129.46,
    "override_total_1": 17615.49,
    "override_increase_1": 486.04
  },
  {
    "#": "9 Walnut Pl (308-11-00)",
    "$": 4621100,
    "address": "9 Walnut Pl",
    "parcel_id": "308-11-00",
    "owner1": "BERC, BRENT ANDREW & LENA CAPPIELLO",
    "owner2": "",
    "current_taxes": 43685.13,
    "new_taxes_no_override": 45572.33,
    "override_total_1": 46865.41,
    "override_increase_1": 1293.08
  },
  {
    "#": "10 Walnut Pl (308-26-00)",
    "$": 4466600,
    "address": "10 Walnut Pl",
    "parcel_id": "308-26-00",
    "owner1": "THORNDIKE ET AL TRS, JOAN I & WILLIAM N JR & ALEXANDER L",
    "owner2": "GOODOF TR , PAUL S",
    "current_taxes": 45737.98,
    "new_taxes_no_override": 47713.86,
    "override_total_1": 49067.7,
    "override_increase_1": 1353.84
  },
  {
    "#": "24 Walnut Pl (308-25-00)",
    "$": 4238700,
    "address": "24 Walnut Pl",
    "parcel_id": "308-25-00",
    "owner1": "CADY TRS, BLAKE",
    "owner2": "ROSS TRS, DOROTHY M",
    "current_taxes": 39769.35,
    "new_taxes_no_override": 41487.39,
    "override_total_1": 42664.56,
    "override_increase_1": 1177.17
  },
  {
    "#": "27 Walnut Pl (308-12-00)",
    "$": 4180900,
    "address": "27 Walnut Pl",
    "parcel_id": "308-12-00",
    "owner1": "TOBERT, DANIEL",
    "owner2": "GORDON, SARAH",
    "current_taxes": 39177.48,
    "new_taxes_no_override": 40869.95,
    "override_total_1": 42029.6,
    "override_increase_1": 1159.65
  },
  {
    "#": "35 Walnut Pl (308-13-14)",
    "$": 6626800,
    "address": "35 Walnut Pl",
    "parcel_id": "308-13-14",
    "owner1": "HOBBY TR, ROGER W",
    "owner2": "",
    "current_taxes": 67858.43,
    "new_taxes_no_override": 70789.91,
    "override_total_1": 72798.52,
    "override_increase_1": 2008.61
  },
  {
    "#": "56 Walnut Pl (308-24-00)",
    "$": 3705600,
    "address": "56 Walnut Pl",
    "parcel_id": "308-24-00",
    "owner1": "THORNE, DAVID H & ROSE G",
    "owner2": "",
    "current_taxes": 34310.41,
    "new_taxes_no_override": 35792.62,
    "override_total_1": 36808.21,
    "override_increase_1": 1015.59
  },
  {
    "#": "61 Walnut Pl (308-15-00)",
    "$": 4852300,
    "address": "61 Walnut Pl",
    "parcel_id": "308-15-00",
    "owner1": "TAYLOR, KATHERINE S",
    "owner2": "",
    "current_taxes": 46052.62,
    "new_taxes_no_override": 48042.09,
    "override_total_1": 49405.25,
    "override_increase_1": 1363.16
  },
  {
    "#": "67 Walnut Pl (308-16-00)",
    "$": 5902400,
    "address": "67 Walnut Pl",
    "parcel_id": "308-16-00",
    "owner1": "SPIEGELMAN, KATHY A",
    "owner2": "",
    "current_taxes": 56805.64,
    "new_taxes_no_override": 59259.64,
    "override_total_1": 60941.09,
    "override_increase_1": 1681.45
  },
  {
    "#": "75 Walnut Pl (308-17-01)",
    "$": 503000,
    "address": "75 Walnut Pl",
    "parcel_id": "308-17-01",
    "owner1": "WOLF, THOMAS C",
    "owner2": "SMOLKA, ELLEN",
    "current_taxes": 5150.72,
    "new_taxes_no_override": 5373.23,
    "override_total_1": 5525.69,
    "override_increase_1": 152.46
  },
  {
    "#": "76 Walnut Pl (308-20-23)",
    "$": 8220500,
    "address": "76 Walnut Pl",
    "parcel_id": "308-20-23",
    "owner1": "FLEISS TRS, PETER & SARA",
    "owner2": "",
    "current_taxes": 80542.99,
    "new_taxes_no_override": 84022.45,
    "override_total_1": 86406.52,
    "override_increase_1": 2384.07
  },
  {
    "#": "79 Walnut Pl (308-17-00)",
    "$": 4123000,
    "address": "79 Walnut Pl",
    "parcel_id": "308-17-00",
    "owner1": "WOLF, THOMAS C",
    "owner2": "SMOLKA, ELLEN",
    "current_taxes": 38584.59,
    "new_taxes_no_override": 40251.44,
    "override_total_1": 41393.55,
    "override_increase_1": 1142.1
  },
  {
    "#": "93 Walnut Pl (308-18-01)",
    "$": 503000,
    "address": "93 Walnut Pl",
    "parcel_id": "308-18-01",
    "owner1": "AGARWAL TR, ADITYA",
    "owner2": "",
    "current_taxes": 5150.72,
    "new_taxes_no_override": 5373.23,
    "override_total_1": 5525.69,
    "override_increase_1": 152.46
  },
  {
    "#": "94 Walnut Pl (308-19-00)",
    "$": 3646900,
    "address": "94 Walnut Pl",
    "parcel_id": "308-19-00",
    "owner1": "JAQUES, ALEXANDER PREBLE",
    "owner2": "SHATTUCK, JESSICA COLT",
    "current_taxes": 33709.32,
    "new_taxes_no_override": 35165.56,
    "override_total_1": 36163.36,
    "override_increase_1": 997.8
  },
  {
    "#": "100 Walnut Pl (308-18-00)",
    "$": 5011500,
    "address": "100 Walnut Pl",
    "parcel_id": "308-18-00",
    "owner1": "AGARWAL TR, ADITYA",
    "owner2": "",
    "current_taxes": 47682.83,
    "new_taxes_no_override": 49742.73,
    "override_total_1": 51154.14,
    "override_increase_1": 1411.41
  },
  {
    "#": "4 Walnut St (294-01-00)",
    "$": 24851500,
    "address": "4 Walnut St",
    "parcel_id": "294-01-00",
    "owner1": "BROOKLINE HOUSING AUTHORITY",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "72 Walnut St, Unit 1 (314-11-01)",
    "$": 1099900,
    "address": "72 Walnut St, Unit 1",
    "parcel_id": "314-11-01",
    "owner1": "LI, JIAMING & CINDY",
    "owner2": "",
    "current_taxes": 7628.04,
    "new_taxes_no_override": 7957.57,
    "override_total_1": 8183.36,
    "override_increase_1": 225.79
  },
  {
    "#": "72 Walnut St, Unit 2 (314-11-02)",
    "$": 964600,
    "address": "72 Walnut St, Unit 2",
    "parcel_id": "314-11-02",
    "owner1": "SMITH TRS, CHARLES C & GEORGIA P",
    "owner2": "",
    "current_taxes": 6242.57,
    "new_taxes_no_override": 6512.25,
    "override_total_1": 6697.03,
    "override_increase_1": 184.78
  },
  {
    "#": "72 Walnut St, Unit 3 (314-11-03)",
    "$": 1105000,
    "address": "72 Walnut St, Unit 3",
    "parcel_id": "314-11-03",
    "owner1": "SCAGLIOLA TRS, BRIAN",
    "owner2": "ACTION HOMEBUYERS INTERNATIONAL INC TR",
    "current_taxes": 7680.27,
    "new_taxes_no_override": 8012.06,
    "override_total_1": 8239.39,
    "override_increase_1": 227.34
  },
  {
    "#": "72 Walnut St, Unit 4 (314-11-04)",
    "$": 1058800,
    "address": "72 Walnut St, Unit 4",
    "parcel_id": "314-11-04",
    "owner1": "JONES III, JIMMIE R",
    "owner2": "JONES, EVE S",
    "current_taxes": 7207.18,
    "new_taxes_no_override": 7518.53,
    "override_total_1": 7731.86,
    "override_increase_1": 213.33
  },
  {
    "#": "77 Walnut St (318-46-00)",
    "$": 1277000,
    "address": "77 Walnut St",
    "parcel_id": "318-46-00",
    "owner1": "WALNUT STREET 77 REALTY LLC",
    "owner2": "",
    "current_taxes": 13076.48,
    "new_taxes_no_override": 13641.38,
    "override_total_1": 14028.45,
    "override_increase_1": 387.06
  },
  {
    "#": "81 Walnut St (318-46-01)",
    "$": 1302400,
    "address": "81 Walnut St",
    "parcel_id": "318-46-01",
    "owner1": "LOPARO, JOSEPH & ERIN",
    "owner2": "",
    "current_taxes": 9701.64,
    "new_taxes_no_override": 10120.75,
    "override_total_1": 10407.92,
    "override_increase_1": 287.17
  },
  {
    "#": "82 Walnut St, Unit 1 (314-10-03)",
    "$": 651600,
    "address": "82 Walnut St, Unit 1",
    "parcel_id": "314-10-03",
    "owner1": "ZHERNEVSKIY, KONSTANTIN",
    "owner2": "",
    "current_taxes": 3037.45,
    "new_taxes_no_override": 3168.67,
    "override_total_1": 3258.58,
    "override_increase_1": 89.91
  },
  {
    "#": "82 Walnut St, Unit 2 (314-10-01)",
    "$": 779300,
    "address": "82 Walnut St, Unit 2",
    "parcel_id": "314-10-01",
    "owner1": "WANG, XIN",
    "owner2": "ZHOU, SHUANHU",
    "current_taxes": 7980.03,
    "new_taxes_no_override": 8324.77,
    "override_total_1": 8560.98,
    "override_increase_1": 236.21
  },
  {
    "#": "82 Walnut St, Unit 3 (314-10-02)",
    "$": 779300,
    "address": "82 Walnut St, Unit 3",
    "parcel_id": "314-10-02",
    "owner1": "LIU, YUTING",
    "owner2": "HU, WENQIN",
    "current_taxes": 7980.03,
    "new_taxes_no_override": 8324.77,
    "override_total_1": 8560.98,
    "override_increase_1": 236.21
  },
  {
    "#": "87 Walnut St (318-39-00)",
    "$": 1261800,
    "address": "87 Walnut St",
    "parcel_id": "318-39-00",
    "owner1": "HYATT TR, MATTHEW D",
    "owner2": "",
    "current_taxes": 12920.83,
    "new_taxes_no_override": 13479.01,
    "override_total_1": 13861.47,
    "override_increase_1": 382.46
  },
  {
    "#": "88 Walnut St, Unit 1 (314-09-01)",
    "$": 960800,
    "address": "88 Walnut St, Unit 1",
    "parcel_id": "314-09-01",
    "owner1": "LANGER, MONICA",
    "owner2": "",
    "current_taxes": 9838.59,
    "new_taxes_no_override": 10263.62,
    "override_total_1": 10554.84,
    "override_increase_1": 291.22
  },
  {
    "#": "88 Walnut St, Unit 2 (314-09-02)",
    "$": 750600,
    "address": "88 Walnut St, Unit 2",
    "parcel_id": "314-09-02",
    "owner1": "LONGHITANO, GASTON",
    "owner2": "HERNANDEZ, RAYLE",
    "current_taxes": 7686.14,
    "new_taxes_no_override": 8018.18,
    "override_total_1": 8245.69,
    "override_increase_1": 227.51
  },
  {
    "#": "88 Walnut St, Unit 3 (314-09-03)",
    "$": 757800,
    "address": "88 Walnut St, Unit 3",
    "parcel_id": "314-09-03",
    "owner1": "ROBERTS, BRANDON & LISA",
    "owner2": "",
    "current_taxes": 4124.94,
    "new_taxes_no_override": 4303.14,
    "override_total_1": 4425.24,
    "override_increase_1": 122.1
  },
  {
    "#": "91 Walnut St, Unit 1 (318-48-01)",
    "$": 643500,
    "address": "91 Walnut St, Unit 1",
    "parcel_id": "318-48-01",
    "owner1": "ZHOU TRS, ZILU",
    "owner2": "YU, XIAOTONG",
    "current_taxes": 6589.44,
    "new_taxes_no_override": 6874.1,
    "override_total_1": 7069.15,
    "override_increase_1": 195.05
  },
  {
    "#": "91 Walnut St, Unit 2 (318-48-02)",
    "$": 621300,
    "address": "91 Walnut St, Unit 2",
    "parcel_id": "318-48-02",
    "owner1": "AMBROSE, MARIETTA SAMANTHA & SHEKIRA",
    "owner2": "",
    "current_taxes": 2727.18,
    "new_taxes_no_override": 2844.99,
    "override_total_1": 2925.72,
    "override_increase_1": 80.72
  },
  {
    "#": "91 Walnut St, Unit 3 (318-48-03)",
    "$": 624900,
    "address": "91 Walnut St, Unit 3",
    "parcel_id": "318-48-03",
    "owner1": "LIAO, JING",
    "owner2": "QIN, YUANBO",
    "current_taxes": 6398.98,
    "new_taxes_no_override": 6675.42,
    "override_total_1": 6864.83,
    "override_increase_1": 189.41
  },
  {
    "#": "95 Walnut St, Unit 1 (318-49-01)",
    "$": 624600,
    "address": "95 Walnut St, Unit 1",
    "parcel_id": "318-49-01",
    "owner1": "DING, JIAN",
    "owner2": "LI, LEI",
    "current_taxes": 2760.97,
    "new_taxes_no_override": 2880.24,
    "override_total_1": 2961.97,
    "override_increase_1": 81.72
  },
  {
    "#": "95 Walnut St, Unit 2 (318-49-02)",
    "$": 565900,
    "address": "95 Walnut St, Unit 2",
    "parcel_id": "318-49-02",
    "owner1": "FENG, YUXIONG",
    "owner2": "YOU, JIA",
    "current_taxes": 5794.82,
    "new_taxes_no_override": 6045.16,
    "override_total_1": 6216.68,
    "override_increase_1": 171.53
  },
  {
    "#": "95 Walnut St, Unit 3 (318-49-03)",
    "$": 615400,
    "address": "95 Walnut St, Unit 3",
    "parcel_id": "318-49-03",
    "owner1": "LI, QIAN",
    "owner2": "TONG, XIAJING",
    "current_taxes": 6301.7,
    "new_taxes_no_override": 6573.93,
    "override_total_1": 6760.46,
    "override_increase_1": 186.53
  },
  {
    "#": "96 Walnut St (314-08-00)",
    "$": 1623300,
    "address": "96 Walnut St",
    "parcel_id": "314-08-00",
    "owner1": "WANG, JIPING",
    "owner2": "DANG, PING",
    "current_taxes": 16622.59,
    "new_taxes_no_override": 17340.69,
    "override_total_1": 17832.71,
    "override_increase_1": 492.03
  },
  {
    "#": "103 Walnut St (318-50-36)",
    "$": 1909800,
    "address": "103 Walnut St",
    "parcel_id": "318-50-36",
    "owner1": "PLANTE, ALISON & DOUGLAS K",
    "owner2": "",
    "current_taxes": 15921.42,
    "new_taxes_no_override": 16609.23,
    "override_total_1": 17080.5,
    "override_increase_1": 471.27
  },
  {
    "#": "104 Walnut St (314-07-00)",
    "$": 2524800,
    "address": "104 Walnut St",
    "parcel_id": "314-07-00",
    "owner1": "AKPAKI, EMILE K",
    "owner2": "",
    "current_taxes": 22219.02,
    "new_taxes_no_override": 23178.88,
    "override_total_1": 23836.56,
    "override_increase_1": 657.68
  },
  {
    "#": "110 Walnut St (314-06-00)",
    "$": 1526700,
    "address": "110 Walnut St",
    "parcel_id": "314-06-00",
    "owner1": "GANJU, RAMESH K & NEERU",
    "owner2": "",
    "current_taxes": 15633.41,
    "new_taxes_no_override": 16308.77,
    "override_total_1": 16771.52,
    "override_increase_1": 462.75
  },
  {
    "#": "115 Walnut St, Unit 1 & P2 (318-51-01)",
    "$": 1173400,
    "address": "115 Walnut St, Unit 1 & P2",
    "parcel_id": "318-51-01",
    "owner1": "CONNAUGHTON, DAVID & KIRA",
    "owner2": "",
    "current_taxes": 8380.68,
    "new_taxes_no_override": 8742.73,
    "override_total_1": 8990.79,
    "override_increase_1": 248.07
  },
  {
    "#": "115 Walnut St, Unit 2 & P1 (318-51-02)",
    "$": 1072600,
    "address": "115 Walnut St, Unit 2 & P1",
    "parcel_id": "318-51-02",
    "owner1": "WANG, CHAO",
    "owner2": "",
    "current_taxes": 10983.42,
    "new_taxes_no_override": 11457.9,
    "override_total_1": 11783.01,
    "override_increase_1": 325.11
  },
  {
    "#": "115 Walnut St, Unit 3 (318-51-03)",
    "$": 1588800,
    "address": "115 Walnut St, Unit 3",
    "parcel_id": "318-51-03",
    "owner1": "CHEN, LINDA YIRU",
    "owner2": "HOLSTEIN, STEPHEN",
    "current_taxes": 16269.31,
    "new_taxes_no_override": 16972.14,
    "override_total_1": 17453.72,
    "override_increase_1": 481.57
  },
  {
    "#": "123 Walnut St, Unit 1 & P1 (318-52-01)",
    "$": 1494500,
    "address": "123 Walnut St, Unit 1 & P1",
    "parcel_id": "318-52-01",
    "owner1": "ROGOZIN, VADIM & OLGA",
    "owner2": "",
    "current_taxes": 11668.75,
    "new_taxes_no_override": 12172.84,
    "override_total_1": 12518.24,
    "override_increase_1": 345.4
  },
  {
    "#": "123 Walnut St, Unit 2 & P2 (318-52-02)",
    "$": 1460200,
    "address": "123 Walnut St, Unit 2 & P2",
    "parcel_id": "318-52-02",
    "owner1": "BRAILEY, KEVIN",
    "owner2": "VASTERLING, JENNIFER J",
    "current_taxes": 11317.51,
    "new_taxes_no_override": 11806.43,
    "override_total_1": 12141.42,
    "override_increase_1": 335.0
  },
  {
    "#": "129 Walnut St (318-53-00)",
    "$": 892500,
    "address": "129 Walnut St",
    "parcel_id": "318-53-00",
    "owner1": "129 WALNUT STREET LLC",
    "owner2": "",
    "current_taxes": 9139.2,
    "new_taxes_no_override": 9534.01,
    "override_total_1": 9804.53,
    "override_increase_1": 270.52
  },
  {
    "#": "133 Walnut St (318-54-00)",
    "$": 1551300,
    "address": "133 Walnut St",
    "parcel_id": "318-54-00",
    "owner1": "CITY ON A HILL CHURCH",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "137 Walnut St, Unit 1 (318-55-01)",
    "$": 761900,
    "address": "137 Walnut St, Unit 1",
    "parcel_id": "318-55-01",
    "owner1": "KING, LISA ELLIOTT",
    "owner2": "",
    "current_taxes": 4166.92,
    "new_taxes_no_override": 4346.93,
    "override_total_1": 4470.27,
    "override_increase_1": 123.34
  },
  {
    "#": "137 Walnut St, Unit 2 (318-55-02)",
    "$": 567500,
    "address": "137 Walnut St, Unit 2",
    "parcel_id": "318-55-02",
    "owner1": "XING, DONGXIA",
    "owner2": "WAN, WAI CHOU",
    "current_taxes": 2176.27,
    "new_taxes_no_override": 2270.28,
    "override_total_1": 2334.7,
    "override_increase_1": 64.42
  },
  {
    "#": "137 Walnut St, Unit 3 (318-55-03)",
    "$": 645100,
    "address": "137 Walnut St, Unit 3",
    "parcel_id": "318-55-03",
    "owner1": "KVOLS, DAVID",
    "owner2": "LIU, HONG",
    "current_taxes": 6605.82,
    "new_taxes_no_override": 6891.19,
    "override_total_1": 7086.72,
    "override_increase_1": 195.53
  },
  {
    "#": "141 Walnut St (318-56-00)",
    "$": 1708900,
    "address": "141 Walnut St",
    "parcel_id": "318-56-00",
    "owner1": "HAMAD TRS, RITA",
    "owner2": "WHITE, JUSTIN S",
    "current_taxes": 13864.2,
    "new_taxes_no_override": 14463.13,
    "override_total_1": 14873.51,
    "override_increase_1": 410.38
  },
  {
    "#": "148 Walnut St (313-07-00)",
    "$": 2256300,
    "address": "148 Walnut St",
    "parcel_id": "313-07-00",
    "owner1": "DOW ET AL TRS, LINDA S",
    "owner2": "QUAN , CATHERINE S & SUSAN S",
    "current_taxes": 19469.58,
    "new_taxes_no_override": 20310.67,
    "override_total_1": 20886.97,
    "override_increase_1": 576.3
  },
  {
    "#": "149 Walnut St (318-57-00)",
    "$": 1762700,
    "address": "149 Walnut St",
    "parcel_id": "318-57-00",
    "owner1": "FISHER TR, FRANCES SHEDD",
    "owner2": "",
    "current_taxes": 18050.05,
    "new_taxes_no_override": 18829.81,
    "override_total_1": 19364.09,
    "override_increase_1": 534.28
  },
  {
    "#": "150 Walnut St, Unit 1 (313-06-03)",
    "$": 1310300,
    "address": "150 Walnut St, Unit 1",
    "parcel_id": "313-06-03",
    "owner1": "LIN, TONIOU",
    "owner2": "WU, HSIUCHEN",
    "current_taxes": 9782.54,
    "new_taxes_no_override": 10205.15,
    "override_total_1": 10494.71,
    "override_increase_1": 289.56
  },
  {
    "#": "150 Walnut St, Unit 2 (313-06-01)",
    "$": 1193300,
    "address": "150 Walnut St, Unit 2",
    "parcel_id": "313-06-01",
    "owner1": "KIM, JAMES",
    "owner2": "YANG, MARIANNA",
    "current_taxes": 8584.46,
    "new_taxes_no_override": 8955.31,
    "override_total_1": 9209.41,
    "override_increase_1": 254.1
  },
  {
    "#": "150 Walnut St, Unit 3 (313-06-02)",
    "$": 1139300,
    "address": "150 Walnut St, Unit 3",
    "parcel_id": "313-06-02",
    "owner1": "MORELLI, GINO",
    "owner2": "",
    "current_taxes": 8031.5,
    "new_taxes_no_override": 8378.46,
    "override_total_1": 8616.19,
    "override_increase_1": 237.73
  },
  {
    "#": "157 Walnut St (318-58-00)",
    "$": 1883300,
    "address": "157 Walnut St",
    "parcel_id": "318-58-00",
    "owner1": "CHILDS, ELIZABETH",
    "owner2": "GRIECO, RALPH G",
    "current_taxes": 15650.06,
    "new_taxes_no_override": 16326.14,
    "override_total_1": 16789.38,
    "override_increase_1": 463.24
  },
  {
    "#": "162 Walnut St, Unit 1 (308-33-03)",
    "$": 911100,
    "address": "162 Walnut St, Unit 1",
    "parcel_id": "308-33-03",
    "owner1": "PEABODY, NANCY J",
    "owner2": "",
    "current_taxes": 5694.73,
    "new_taxes_no_override": 5940.74,
    "override_total_1": 6109.31,
    "override_increase_1": 168.56
  },
  {
    "#": "162 Walnut St, Unit 2 (308-33-01)",
    "$": 910900,
    "address": "162 Walnut St, Unit 2",
    "parcel_id": "308-33-01",
    "owner1": "STUBBS, CARTER & SARAH",
    "owner2": "",
    "current_taxes": 5692.68,
    "new_taxes_no_override": 5938.6,
    "override_total_1": 6107.11,
    "override_increase_1": 168.5
  },
  {
    "#": "162 Walnut St, Unit 3 (308-33-02)",
    "$": 911100,
    "address": "162 Walnut St, Unit 3",
    "parcel_id": "308-33-02",
    "owner1": "JOHNSON, NICHOLAS B & SUSAN B",
    "owner2": "",
    "current_taxes": 5694.73,
    "new_taxes_no_override": 5940.74,
    "override_total_1": 6109.31,
    "override_increase_1": 168.56
  },
  {
    "#": "163 Walnut St (318-59-00)",
    "$": 2238000,
    "address": "163 Walnut St",
    "parcel_id": "318-59-00",
    "owner1": "CAMPION TRS, EDWARD W & MARGARET M",
    "owner2": "",
    "current_taxes": 19282.19,
    "new_taxes_no_override": 20115.18,
    "override_total_1": 20685.93,
    "override_increase_1": 570.75
  },
  {
    "#": "166 Walnut St, Unit 1 (308-32-01)",
    "$": 720600,
    "address": "166 Walnut St, Unit 1",
    "parcel_id": "308-32-01",
    "owner1": "MCELHENY, KENNETH R",
    "owner2": "",
    "current_taxes": 3744.01,
    "new_taxes_no_override": 3905.75,
    "override_total_1": 4016.57,
    "override_increase_1": 110.82
  },
  {
    "#": "166 Walnut St, Unit 2 (308-32-02)",
    "$": 806400,
    "address": "166 Walnut St, Unit 2",
    "parcel_id": "308-32-02",
    "owner1": "VOGEL, STEPHEN N",
    "owner2": "STRONGIN, ROBERTA A",
    "current_taxes": 4622.6,
    "new_taxes_no_override": 4822.3,
    "override_total_1": 4959.13,
    "override_increase_1": 136.83
  },
  {
    "#": "166 Walnut St, Unit 3 (308-32-03)",
    "$": 771000,
    "address": "166 Walnut St, Unit 3",
    "parcel_id": "308-32-03",
    "owner1": "JACOBSEN, EMILY J",
    "owner2": "MAKKEH, HASSAN",
    "current_taxes": 4260.11,
    "new_taxes_no_override": 4444.15,
    "override_total_1": 4570.25,
    "override_increase_1": 126.1
  },
  {
    "#": "167 Walnut St, Unit 2 (318-60-02)",
    "$": 1957500,
    "address": "167 Walnut St, Unit 2",
    "parcel_id": "318-60-02",
    "owner1": "HOLMAN, BLAKE K & ERIN E",
    "owner2": "",
    "current_taxes": 16409.87,
    "new_taxes_no_override": 17118.78,
    "override_total_1": 17604.51,
    "override_increase_1": 485.73
  },
  {
    "#": "169 Walnut St, Unit 1 (318-60-01)",
    "$": 2006400,
    "address": "169 Walnut St, Unit 1",
    "parcel_id": "318-60-01",
    "owner1": "MACK, MANHEIM & JENNIFER",
    "owner2": "",
    "current_taxes": 20545.54,
    "new_taxes_no_override": 21433.11,
    "override_total_1": 22041.26,
    "override_increase_1": 608.15
  },
  {
    "#": "170 Walnut St (308-31-00)",
    "$": 302900,
    "address": "170 Walnut St",
    "parcel_id": "308-31-00",
    "owner1": "LITCHEN TR, HAROLD L",
    "owner2": "",
    "current_taxes": 3101.7,
    "new_taxes_no_override": 3235.69,
    "override_total_1": 3327.5,
    "override_increase_1": 91.81
  },
  {
    "#": "173 Walnut St, Unit 173 (318-61-01)",
    "$": 1060900,
    "address": "173 Walnut St, Unit 173",
    "parcel_id": "318-61-01",
    "owner1": "JILEK TR, KRISTEN H",
    "owner2": "",
    "current_taxes": 7228.68,
    "new_taxes_no_override": 7540.96,
    "override_total_1": 7754.93,
    "override_increase_1": 213.97
  },
  {
    "#": "175 Walnut St, Unit 175 (318-61-02)",
    "$": 1023200,
    "address": "175 Walnut St, Unit 175",
    "parcel_id": "318-61-02",
    "owner1": "WONG, JEREMY P",
    "owner2": "MURPHY, CIARA",
    "current_taxes": 10477.57,
    "new_taxes_no_override": 10930.2,
    "override_total_1": 11240.34,
    "override_increase_1": 310.14
  },
  {
    "#": "181 Walnut St (318-62-00)",
    "$": 2083500,
    "address": "181 Walnut St",
    "parcel_id": "318-62-00",
    "owner1": "PROPINQUITY LLC",
    "owner2": "",
    "current_taxes": 21335.04,
    "new_taxes_no_override": 22256.71,
    "override_total_1": 22888.23,
    "override_increase_1": 631.52
  },
  {
    "#": "182 Walnut St (308-28-00)",
    "$": 6478400,
    "address": "182 Walnut St",
    "parcel_id": "308-28-00",
    "owner1": "LITCHEN TR, HAROLD L",
    "owner2": "",
    "current_taxes": 66338.82,
    "new_taxes_no_override": 69204.66,
    "override_total_1": 71168.29,
    "override_increase_1": 1963.63
  },
  {
    "#": "187 Walnut St, Unit 187 (318-63-01)",
    "$": 2933100,
    "address": "187 Walnut St, Unit 187",
    "parcel_id": "318-63-01",
    "owner1": "HAKIM, AARON",
    "owner2": "",
    "current_taxes": 26400.01,
    "new_taxes_no_override": 27540.49,
    "override_total_1": 28321.93,
    "override_increase_1": 781.44
  },
  {
    "#": "187 Walnut St, Unit 189 (318-63-02)",
    "$": 2930800,
    "address": "187 Walnut St, Unit 189",
    "parcel_id": "318-63-02",
    "owner1": "RIVIELLO, ROBERT & ELISABETH D",
    "owner2": "",
    "current_taxes": 26376.46,
    "new_taxes_no_override": 27515.92,
    "override_total_1": 28296.67,
    "override_increase_1": 780.74
  },
  {
    "#": "195 Walnut St (318-64-00)",
    "$": 3415900,
    "address": "195 Walnut St",
    "parcel_id": "318-64-00",
    "owner1": "WEISNER, DAVID",
    "owner2": "HSU, BELINDA",
    "current_taxes": 31343.88,
    "new_taxes_no_override": 32697.94,
    "override_total_1": 33625.71,
    "override_increase_1": 927.78
  },
  {
    "#": "205 Walnut St (318-65-00)",
    "$": 2409500,
    "address": "205 Walnut St",
    "parcel_id": "318-65-00",
    "owner1": "KUHNS, ROBERT J & MARY H",
    "owner2": "",
    "current_taxes": 21038.35,
    "new_taxes_no_override": 21947.21,
    "override_total_1": 22569.94,
    "override_increase_1": 622.74
  },
  {
    "#": "210 Walnut St (308-10-00)",
    "$": 2550900,
    "address": "210 Walnut St",
    "parcel_id": "308-10-00",
    "owner1": "PAGE , CREIGHTON K & CAROLINE CHURCHILL",
    "owner2": "",
    "current_taxes": 22486.28,
    "new_taxes_no_override": 23457.69,
    "override_total_1": 24123.28,
    "override_increase_1": 665.59
  },
  {
    "#": "217 Walnut St (318-66-00)",
    "$": 3531300,
    "address": "217 Walnut St",
    "parcel_id": "318-66-00",
    "owner1": "PREHEIM TR, JANETTE A",
    "owner2": "",
    "current_taxes": 32525.58,
    "new_taxes_no_override": 33930.69,
    "override_total_1": 34893.44,
    "override_increase_1": 962.76
  },
  {
    "#": "220 Walnut St (308-09-00)",
    "$": 1683000,
    "address": "220 Walnut St",
    "parcel_id": "308-09-00",
    "owner1": "RAMLER, PHOEBE A",
    "owner2": "",
    "current_taxes": 13598.99,
    "new_taxes_no_override": 14186.47,
    "override_total_1": 14589.0,
    "override_increase_1": 402.53
  },
  {
    "#": "222 Walnut St (308-08-02)",
    "$": 2561000,
    "address": "222 Walnut St",
    "parcel_id": "308-08-02",
    "owner1": "KNOX, PETER L",
    "owner2": "",
    "current_taxes": 22589.71,
    "new_taxes_no_override": 23565.59,
    "override_total_1": 24234.24,
    "override_increase_1": 668.66
  },
  {
    "#": "224 Walnut St (308-08-01)",
    "$": 3263600,
    "address": "224 Walnut St",
    "parcel_id": "308-08-01",
    "owner1": "SIEGEL, MICHAEL D",
    "owner2": "DARROW, JUDITH R",
    "current_taxes": 29784.33,
    "new_taxes_no_override": 31071.01,
    "override_total_1": 31952.63,
    "override_increase_1": 881.62
  },
  {
    "#": "230 Walnut St (308-08-00)",
    "$": 2117900,
    "address": "230 Walnut St",
    "parcel_id": "308-08-00",
    "owner1": "SHANNON, ELAINE B",
    "owner2": "",
    "current_taxes": 18052.36,
    "new_taxes_no_override": 18832.22,
    "override_total_1": 19366.57,
    "override_increase_1": 534.35
  },
  {
    "#": "233 Walnut St (318-67-00)",
    "$": 2491100,
    "address": "233 Walnut St",
    "parcel_id": "318-67-00",
    "owner1": "WOO, TSUNG-UNG WILSON",
    "owner2": "TIEN, ELISABETE PAO-CHIN",
    "current_taxes": 21873.93,
    "new_taxes_no_override": 22818.88,
    "override_total_1": 23466.35,
    "override_increase_1": 647.47
  },
  {
    "#": "234 Walnut St (308-07-00)",
    "$": 2030800,
    "address": "234 Walnut St",
    "parcel_id": "308-07-00",
    "owner1": "MILLER II, LAWRENCE K",
    "owner2": "MILLER, JENNIFER H",
    "current_taxes": 17160.46,
    "new_taxes_no_override": 17901.79,
    "override_total_1": 18409.74,
    "override_increase_1": 507.95
  },
  {
    "#": "235 Walnut St, Unit 235 (318-68-01)",
    "$": 2470600,
    "address": "235 Walnut St, Unit 235",
    "parcel_id": "318-68-01",
    "owner1": "CUI, LONGQUAN",
    "owner2": "ZHAO, QIAN",
    "current_taxes": 25298.94,
    "new_taxes_no_override": 26391.85,
    "override_total_1": 27140.7,
    "override_increase_1": 748.85
  },
  {
    "#": "236 Walnut St (308-06-00)",
    "$": 2264300,
    "address": "236 Walnut St",
    "parcel_id": "308-06-00",
    "owner1": "SELTZER TRS, STEVEN E & ROCHELLE B",
    "owner2": "",
    "current_taxes": 19551.5,
    "new_taxes_no_override": 20396.12,
    "override_total_1": 20974.85,
    "override_increase_1": 578.72
  },
  {
    "#": "237 Walnut St, Unit 237 (318-68-02)",
    "$": 2409000,
    "address": "237 Walnut St, Unit 237",
    "parcel_id": "318-68-02",
    "owner1": "LIU, GUANGDA",
    "owner2": "ZHANG C/O LONGQUAN CUI, YING",
    "current_taxes": 24668.16,
    "new_taxes_no_override": 25733.82,
    "override_total_1": 26464.0,
    "override_increase_1": 730.18
  },
  {
    "#": "238 Walnut St (308-05-00)",
    "$": 2118300,
    "address": "238 Walnut St",
    "parcel_id": "308-05-00",
    "owner1": "SABOT, ERIK J",
    "owner2": "LOBOVITS, ESTY R",
    "current_taxes": 18056.46,
    "new_taxes_no_override": 18836.5,
    "override_total_1": 19370.97,
    "override_increase_1": 534.47
  },
  {
    "#": "239 Walnut St (318-69-00)",
    "$": 4323300,
    "address": "239 Walnut St",
    "parcel_id": "318-69-00",
    "owner1": "SIXTH RUN LLC",
    "owner2": "",
    "current_taxes": 44270.59,
    "new_taxes_no_override": 46183.08,
    "override_total_1": 47493.49,
    "override_increase_1": 1310.41
  },
  {
    "#": "240 Walnut St (308-04-00)",
    "$": 2427200,
    "address": "240 Walnut St",
    "parcel_id": "308-04-00",
    "owner1": "GREER, PAUL L",
    "owner2": "MACDONALD, HELEN Z",
    "current_taxes": 21219.59,
    "new_taxes_no_override": 22136.28,
    "override_total_1": 22764.38,
    "override_increase_1": 628.1
  },
  {
    "#": "242 Walnut St (308-03-00)",
    "$": 2776900,
    "address": "242 Walnut St",
    "parcel_id": "308-03-00",
    "owner1": "BAJAL PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 28435.46,
    "new_taxes_no_override": 29663.87,
    "override_total_1": 30505.56,
    "override_increase_1": 841.69
  },
  {
    "#": "247 Walnut St (318-70-00)",
    "$": 2108300,
    "address": "247 Walnut St",
    "parcel_id": "318-70-00",
    "owner1": "MULHOLLAND, ANNA",
    "owner2": "",
    "current_taxes": 17954.06,
    "new_taxes_no_override": 18729.68,
    "override_total_1": 19261.12,
    "override_increase_1": 531.44
  },
  {
    "#": "249 Walnut St (318-71-00)",
    "$": 2277800,
    "address": "249 Walnut St",
    "parcel_id": "318-71-00",
    "owner1": "249 WALNUT STREET LLC",
    "owner2": "",
    "current_taxes": 23324.67,
    "new_taxes_no_override": 24332.3,
    "override_total_1": 25022.71,
    "override_increase_1": 690.41
  },
  {
    "#": "254 Walnut St (307-22-00)",
    "$": 2293500,
    "address": "254 Walnut St",
    "parcel_id": "307-22-00",
    "owner1": "FLINT, ANTHONY E",
    "owner2": "CASSIDY, TINA A",
    "current_taxes": 19850.51,
    "new_taxes_no_override": 20708.05,
    "override_total_1": 21295.63,
    "override_increase_1": 587.58
  },
  {
    "#": "255 Walnut St, Unit A (318-72-03)",
    "$": 854800,
    "address": "255 Walnut St, Unit A",
    "parcel_id": "318-72-03",
    "owner1": "CAMPION TR, NARCISSA REEDER",
    "owner2": "",
    "current_taxes": 5118.22,
    "new_taxes_no_override": 5339.33,
    "override_total_1": 5490.83,
    "override_increase_1": 151.5
  },
  {
    "#": "255 Walnut St, Unit B (318-72-01)",
    "$": 1068100,
    "address": "255 Walnut St, Unit B",
    "parcel_id": "318-72-01",
    "owner1": "QUIGLEY, MARCUS M & JENNIFER",
    "owner2": "",
    "current_taxes": 7302.41,
    "new_taxes_no_override": 7617.87,
    "override_total_1": 7834.03,
    "override_increase_1": 216.15
  },
  {
    "#": "255 Walnut St, Unit C (318-72-02)",
    "$": 1350800,
    "address": "255 Walnut St, Unit C",
    "parcel_id": "318-72-02",
    "owner1": "BOEHM, SAMANTHA & CHRISTOPHER",
    "owner2": "",
    "current_taxes": 10197.26,
    "new_taxes_no_override": 10637.78,
    "override_total_1": 10939.62,
    "override_increase_1": 301.84
  },
  {
    "#": "256 Walnut St (307-21-00)",
    "$": 2651400,
    "address": "256 Walnut St",
    "parcel_id": "307-21-00",
    "owner1": "WEBER, WILLIAM M & SUZANNE L",
    "owner2": "",
    "current_taxes": 23515.4,
    "new_taxes_no_override": 24531.27,
    "override_total_1": 25227.32,
    "override_increase_1": 696.06
  },
  {
    "#": "257 Walnut St, Unit 1 (318-73-01)",
    "$": 664200,
    "address": "257 Walnut St, Unit 1",
    "parcel_id": "318-73-01",
    "owner1": "DEMPSEY, CHRISTOPHER S",
    "owner2": "CILLUFFO, ANNA",
    "current_taxes": 3166.47,
    "new_taxes_no_override": 3303.26,
    "override_total_1": 3396.99,
    "override_increase_1": 93.73
  },
  {
    "#": "257 Walnut St, Unit 2 (318-73-02)",
    "$": 709600,
    "address": "257 Walnut St, Unit 2",
    "parcel_id": "318-73-02",
    "owner1": "MARVIN TRS, JAMES A & JOANNA SPICER",
    "owner2": "",
    "current_taxes": 7266.3,
    "new_taxes_no_override": 7580.2,
    "override_total_1": 7795.29,
    "override_increase_1": 215.08
  },
  {
    "#": "257 Walnut St, Unit 3 (318-73-03)",
    "$": 689400,
    "address": "257 Walnut St, Unit 3",
    "parcel_id": "318-73-03",
    "owner1": "SHAO, HUACHUAN",
    "owner2": "",
    "current_taxes": 7059.46,
    "new_taxes_no_override": 7364.43,
    "override_total_1": 7573.39,
    "override_increase_1": 208.96
  },
  {
    "#": "258 Walnut St (307-20-00)",
    "$": 2019700,
    "address": "258 Walnut St",
    "parcel_id": "307-20-00",
    "owner1": "MUNSON TRS, GALE",
    "owner2": "LEWIS, JOHN B",
    "current_taxes": 17046.79,
    "new_taxes_no_override": 17783.21,
    "override_total_1": 18287.8,
    "override_increase_1": 504.58
  },
  {
    "#": "261 Walnut St (318-74-00)",
    "$": 2572000,
    "address": "261 Walnut St",
    "parcel_id": "318-74-00",
    "owner1": "A & Y INVESTMENT LLC",
    "owner2": "",
    "current_taxes": 26337.28,
    "new_taxes_no_override": 27475.05,
    "override_total_1": 28254.63,
    "override_increase_1": 779.58
  },
  {
    "#": "262 Walnut St (307-19-00)",
    "$": 2092500,
    "address": "262 Walnut St",
    "parcel_id": "307-19-00",
    "owner1": "SCHWARTZ, THOMAS",
    "owner2": "MUELLER, BRITTA",
    "current_taxes": 17792.27,
    "new_taxes_no_override": 18560.9,
    "override_total_1": 19087.55,
    "override_increase_1": 526.65
  },
  {
    "#": "263 Walnut St (318-75-00)",
    "$": 1883700,
    "address": "263 Walnut St",
    "parcel_id": "318-75-00",
    "owner1": "LEWIS, ALMA C",
    "owner2": "",
    "current_taxes": 19289.09,
    "new_taxes_no_override": 20122.38,
    "override_total_1": 20693.34,
    "override_increase_1": 570.96
  },
  {
    "#": "267 Walnut St (318-76-00)",
    "$": 1938200,
    "address": "267 Walnut St",
    "parcel_id": "318-76-00",
    "owner1": "MOYER TR, GRICEL",
    "owner2": "",
    "current_taxes": 16212.23,
    "new_taxes_no_override": 16912.6,
    "override_total_1": 17392.48,
    "override_increase_1": 479.88
  },
  {
    "#": "268 Walnut St (307-18-00)",
    "$": 2247800,
    "address": "268 Walnut St",
    "parcel_id": "307-18-00",
    "owner1": "ASPI, FERSHID & HIROKO",
    "owner2": "",
    "current_taxes": 19382.54,
    "new_taxes_no_override": 20219.87,
    "override_total_1": 20793.59,
    "override_increase_1": 573.72
  },
  {
    "#": "272 Walnut St (307-17-00)",
    "$": 2247300,
    "address": "272 Walnut St",
    "parcel_id": "307-17-00",
    "owner1": "COADY TR, MICAELA HAMPTON",
    "owner2": "",
    "current_taxes": 19377.42,
    "new_taxes_no_override": 20214.52,
    "override_total_1": 20788.1,
    "override_increase_1": 573.57
  },
  {
    "#": "273 Walnut St (318-77-00)",
    "$": 2786700,
    "address": "273 Walnut St",
    "parcel_id": "318-77-00",
    "owner1": "GOLDWASSER, MEREDITH A",
    "owner2": "",
    "current_taxes": 24900.87,
    "new_taxes_no_override": 25976.59,
    "override_total_1": 26713.65,
    "override_increase_1": 737.07
  },
  {
    "#": "276 Walnut St (307-16-00)",
    "$": 2005300,
    "address": "276 Walnut St",
    "parcel_id": "307-16-00",
    "owner1": "REID TRS, CLIFFORD O",
    "owner2": "LEONARD, MATTHEW J",
    "current_taxes": 16899.34,
    "new_taxes_no_override": 17629.39,
    "override_total_1": 18129.61,
    "override_increase_1": 500.22
  },
  {
    "#": "277 Walnut St (318-78-00)",
    "$": 1790400,
    "address": "277 Walnut St",
    "parcel_id": "318-78-00",
    "owner1": "EGAN TR, JOHN P JR",
    "owner2": "",
    "current_taxes": 18333.7,
    "new_taxes_no_override": 19125.72,
    "override_total_1": 19668.39,
    "override_increase_1": 542.68
  },
  {
    "#": "279 Walnut St (318-79-00)",
    "$": 2879600,
    "address": "279 Walnut St",
    "parcel_id": "318-79-00",
    "owner1": "279-281 WALNUT STREET LLC",
    "owner2": "C/O AARON ADLER",
    "current_taxes": 29487.1,
    "new_taxes_no_override": 30760.94,
    "override_total_1": 31633.76,
    "override_increase_1": 872.82
  },
  {
    "#": "284 Walnut St (307-15-00)",
    "$": 2538100,
    "address": "284 Walnut St",
    "parcel_id": "307-15-00",
    "owner1": "FLEMING, MARK C",
    "owner2": "",
    "current_taxes": 22355.21,
    "new_taxes_no_override": 23320.96,
    "override_total_1": 23982.67,
    "override_increase_1": 661.71
  },
  {
    "#": "287 Walnut St, Unit 287 (318-01-01)",
    "$": 2530500,
    "address": "287 Walnut St, Unit 287",
    "parcel_id": "318-01-01",
    "owner1": "CASAGRANDE, JODIE C & JOSEPH",
    "owner2": "",
    "current_taxes": 22277.39,
    "new_taxes_no_override": 23239.77,
    "override_total_1": 23899.18,
    "override_increase_1": 659.41
  },
  {
    "#": "294 Walnut St, Unit 1 (317-18-01)",
    "$": 746600,
    "address": "294 Walnut St, Unit 1",
    "parcel_id": "317-18-01",
    "owner1": "EL FAKHRI, RAMZI",
    "owner2": "",
    "current_taxes": 4010.25,
    "new_taxes_no_override": 4183.49,
    "override_total_1": 4302.2,
    "override_increase_1": 118.7
  },
  {
    "#": "294 Walnut St, Unit 2 (317-18-02)",
    "$": 697500,
    "address": "294 Walnut St, Unit 2",
    "parcel_id": "317-18-02",
    "owner1": "HUTH, THOMAS R",
    "owner2": "",
    "current_taxes": 3507.47,
    "new_taxes_no_override": 3658.99,
    "override_total_1": 3762.81,
    "override_increase_1": 103.82
  },
  {
    "#": "294 Walnut St, Unit 3 (317-18-03)",
    "$": 702500,
    "address": "294 Walnut St, Unit 3",
    "parcel_id": "317-18-03",
    "owner1": "MURRAY, AFAMIA",
    "owner2": "",
    "current_taxes": 3558.67,
    "new_taxes_no_override": 3712.4,
    "override_total_1": 3817.74,
    "override_increase_1": 105.34
  },
  {
    "#": "294 Walnut St, Unit 4 (317-18-04)",
    "$": 664600,
    "address": "294 Walnut St, Unit 4",
    "parcel_id": "317-18-04",
    "owner1": "LAPLUME, GREGORY J",
    "owner2": "BARREIRO, ESMERALDA M",
    "current_taxes": 3170.57,
    "new_taxes_no_override": 3307.54,
    "override_total_1": 3401.39,
    "override_increase_1": 93.85
  },
  {
    "#": "294 Walnut St, Unit 5 (317-18-05)",
    "$": 924500,
    "address": "294 Walnut St, Unit 5",
    "parcel_id": "317-18-05",
    "owner1": "NORMAN, ERIC J",
    "owner2": "",
    "current_taxes": 5831.95,
    "new_taxes_no_override": 6083.89,
    "override_total_1": 6256.52,
    "override_increase_1": 172.63
  },
  {
    "#": "295 Walnut St (320-05-00)",
    "$": 1681700,
    "address": "295 Walnut St",
    "parcel_id": "320-05-00",
    "owner1": "265 JACKSON LLC",
    "owner2": "",
    "current_taxes": 17220.61,
    "new_taxes_no_override": 17964.54,
    "override_total_1": 18474.27,
    "override_increase_1": 509.73
  },
  {
    "#": "299 Walnut St, Unit 1 (320-05-02)",
    "$": 2143900,
    "address": "299 Walnut St, Unit 1",
    "parcel_id": "320-05-02",
    "owner1": "KLEY TRS, NIKOLAI A & MARGARET LEE",
    "owner2": "CROSIER, LOUIS",
    "current_taxes": 18318.6,
    "new_taxes_no_override": 19109.96,
    "override_total_1": 19652.19,
    "override_increase_1": 542.23
  },
  {
    "#": "299 Walnut St, Unit 2 (320-05-03)",
    "$": 1938100,
    "address": "299 Walnut St, Unit 2",
    "parcel_id": "320-05-03",
    "owner1": "KING, MARTIN",
    "owner2": "CHUANG, CHIA-YING",
    "current_taxes": 16211.21,
    "new_taxes_no_override": 16911.53,
    "override_total_1": 17391.39,
    "override_increase_1": 479.85
  },
  {
    "#": "302 Walnut St (317-17-00)",
    "$": 2265800,
    "address": "302 Walnut St",
    "parcel_id": "317-17-00",
    "owner1": "VON KRUSENSTIERN, FRIEDRICH & LENORE",
    "owner2": "",
    "current_taxes": 19566.86,
    "new_taxes_no_override": 20412.15,
    "override_total_1": 20991.33,
    "override_increase_1": 579.18
  },
  {
    "#": "305 Walnut St (320-06-00)",
    "$": 2534900,
    "address": "305 Walnut St",
    "parcel_id": "320-06-00",
    "owner1": "FREEMAN, ET AL, GORDON",
    "owner2": "",
    "current_taxes": 22322.44,
    "new_taxes_no_override": 23286.77,
    "override_total_1": 23947.51,
    "override_increase_1": 660.74
  },
  {
    "#": "306 Walnut St (317-16-00)",
    "$": 1800800,
    "address": "306 Walnut St",
    "parcel_id": "317-16-00",
    "owner1": "SOMMERS TRS, BENJAMIN D",
    "owner2": "WACHTERMAN, MELISSA W",
    "current_taxes": 18440.19,
    "new_taxes_no_override": 19236.81,
    "override_total_1": 19782.64,
    "override_increase_1": 545.83
  },
  {
    "#": "312 Walnut St (317-15-00)",
    "$": 1757500,
    "address": "312 Walnut St",
    "parcel_id": "317-15-00",
    "owner1": "LASTER, SUSAN BETH",
    "owner2": "",
    "current_taxes": 14361.87,
    "new_taxes_no_override": 14982.3,
    "override_total_1": 15407.41,
    "override_increase_1": 425.11
  },
  {
    "#": "315 Walnut St (320A-07-00)",
    "$": 2069400,
    "address": "315 Walnut St",
    "parcel_id": "320A-07-00",
    "owner1": "GITTELMAN, SUSAN L",
    "owner2": "EGAN, DANIEL F",
    "current_taxes": 17555.72,
    "new_taxes_no_override": 18314.13,
    "override_total_1": 18833.78,
    "override_increase_1": 519.65
  },
  {
    "#": "318 Walnut St (317-09-00)",
    "$": 1911600,
    "address": "318 Walnut St",
    "parcel_id": "317-09-00",
    "owner1": "PARZEN TRS, MICHAEL I & ANDREA D",
    "owner2": "",
    "current_taxes": 15939.85,
    "new_taxes_no_override": 16628.45,
    "override_total_1": 17100.27,
    "override_increase_1": 471.82
  },
  {
    "#": "322 Walnut St (317-08-00)",
    "$": 2034000,
    "address": "322 Walnut St",
    "parcel_id": "317-08-00",
    "owner1": "MARQUIS, STUART",
    "owner2": "FRIEDMAN, WENDY",
    "current_taxes": 17193.23,
    "new_taxes_no_override": 17935.98,
    "override_total_1": 18444.9,
    "override_increase_1": 508.92
  },
  {
    "#": "323 Walnut St (320A-08-00)",
    "$": 1848600,
    "address": "323 Walnut St",
    "parcel_id": "320A-08-00",
    "owner1": "SANDLER, RONALD L",
    "owner2": "MANN, EMILY A",
    "current_taxes": 15294.73,
    "new_taxes_no_override": 15955.46,
    "override_total_1": 16408.19,
    "override_increase_1": 452.72
  },
  {
    "#": "330 Walnut St (329-11-02)",
    "$": 2693600,
    "address": "330 Walnut St",
    "parcel_id": "329-11-02",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O THE OLD BURYING GROUND",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "348 Walnut St (329-10-00)",
    "$": 3178600,
    "address": "348 Walnut St",
    "parcel_id": "329-10-00",
    "owner1": "LOONEY, CHRISTOPHER A",
    "owner2": "GANSKE, INGRID M",
    "current_taxes": 28913.93,
    "new_taxes_no_override": 30163.01,
    "override_total_1": 31018.86,
    "override_increase_1": 855.85
  },
  {
    "#": "353 Walnut St (322-05-00)",
    "$": 4187400,
    "address": "353 Walnut St",
    "parcel_id": "322-05-00",
    "owner1": "CROSSLEY, LISA J",
    "owner2": "HEGEN, MARTIN",
    "current_taxes": 39244.04,
    "new_taxes_no_override": 40939.38,
    "override_total_1": 42101.01,
    "override_increase_1": 1161.62
  },
  {
    "#": "356 Walnut St (329-05-00)",
    "$": 2932000,
    "address": "356 Walnut St",
    "parcel_id": "329-05-00",
    "owner1": "AMES, ANDREW & WENDY",
    "owner2": "",
    "current_taxes": 26388.75,
    "new_taxes_no_override": 27528.74,
    "override_total_1": 28309.85,
    "override_increase_1": 781.11
  },
  {
    "#": "371 Walnut St (322-06-07)",
    "$": 5261600,
    "address": "371 Walnut St",
    "parcel_id": "322-06-07",
    "owner1": "BELL TRS, GEORGE DEB JR & CAROLINE M",
    "owner2": "",
    "current_taxes": 53878.78,
    "new_taxes_no_override": 56206.34,
    "override_total_1": 57801.16,
    "override_increase_1": 1594.81
  },
  {
    "#": "393 Walnut St (322-08-09)",
    "$": 4908100,
    "address": "393 Walnut St",
    "parcel_id": "322-08-09",
    "owner1": "OSTRANDER TR, PATRICIA ANN",
    "owner2": "",
    "current_taxes": 46624.01,
    "new_taxes_no_override": 48638.17,
    "override_total_1": 50018.24,
    "override_increase_1": 1380.07
  },
  {
    "#": "397 Walnut St (322-10-00)",
    "$": 1719900,
    "address": "397 Walnut St",
    "parcel_id": "322-10-00",
    "owner1": "OSTRANDER TR, PATRICIA ANN",
    "owner2": "",
    "current_taxes": 17611.78,
    "new_taxes_no_override": 18372.61,
    "override_total_1": 18893.92,
    "override_increase_1": 521.31
  },
  {
    "#": "400 Walnut St (328-08-00)",
    "$": 9707800,
    "address": "400 Walnut St",
    "parcel_id": "328-08-00",
    "owner1": "FIRST PARISH",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "405 Walnut St (322-11-13)",
    "$": 634000,
    "address": "405 Walnut St",
    "parcel_id": "322-11-13",
    "owner1": "BROOKLINE CONSERVATION LAND TR",
    "owner2": "EDWARD LAWRENCE, TRS",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "413 Walnut St (323-01-00)",
    "$": 89000,
    "address": "413 Walnut St",
    "parcel_id": "323-01-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O TOWN GREEN",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "423 Walnut St (324-06-00)",
    "$": 3417600,
    "address": "423 Walnut St",
    "parcel_id": "324-06-00",
    "owner1": "BRINCH, ADAM & CATHERINE",
    "owner2": "",
    "current_taxes": 31361.29,
    "new_taxes_no_override": 32716.1,
    "override_total_1": 33644.39,
    "override_increase_1": 928.29
  },
  {
    "#": "424 Walnut St (325-06-00)",
    "$": 3216700,
    "address": "424 Walnut St",
    "parcel_id": "325-06-00",
    "owner1": "SCHARFSTEIN TRS, DAVID",
    "owner2": "FELDMAN, SARAH",
    "current_taxes": 29304.07,
    "new_taxes_no_override": 30570.01,
    "override_total_1": 31437.41,
    "override_increase_1": 867.4
  },
  {
    "#": "433 Walnut St (324-07-00)",
    "$": 2672100,
    "address": "433 Walnut St",
    "parcel_id": "324-07-00",
    "owner1": "ARGOV, BENJAMIN & HANNAH",
    "owner2": "",
    "current_taxes": 27362.3,
    "new_taxes_no_override": 28544.35,
    "override_total_1": 29354.28,
    "override_increase_1": 809.92
  },
  {
    "#": "434 Walnut St (325-05-00)",
    "$": 4359100,
    "address": "434 Walnut St",
    "parcel_id": "325-05-00",
    "owner1": "PROKOP, CHRISTOPHER J",
    "owner2": "BATTISTA, MARK A",
    "current_taxes": 41002.25,
    "new_taxes_no_override": 42773.55,
    "override_total_1": 43987.21,
    "override_increase_1": 1213.67
  },
  {
    "#": "439 Walnut St (324-08-00)",
    "$": 1699300,
    "address": "439 Walnut St",
    "parcel_id": "324-08-00",
    "owner1": "H ANNUUS LLC",
    "owner2": "",
    "current_taxes": 17400.83,
    "new_taxes_no_override": 18152.55,
    "override_total_1": 18667.61,
    "override_increase_1": 515.06
  },
  {
    "#": "446 Walnut St (325-04-00)",
    "$": 3224900,
    "address": "446 Walnut St",
    "parcel_id": "325-04-00",
    "owner1": "SARKIS, CATHERINE F & RAMZI",
    "owner2": "",
    "current_taxes": 29388.04,
    "new_taxes_no_override": 30657.6,
    "override_total_1": 31527.49,
    "override_increase_1": 869.89
  },
  {
    "#": "460 Walnut St (325-03-00)",
    "$": 4949000,
    "address": "460 Walnut St",
    "parcel_id": "325-03-00",
    "owner1": "GAFFNEY TR, MATTHEW F",
    "owner2": "",
    "current_taxes": 50677.76,
    "new_taxes_no_override": 52867.04,
    "override_total_1": 54367.1,
    "override_increase_1": 1500.06
  },
  {
    "#": "468 Walnut St (325-02-00)",
    "$": 3739100,
    "address": "468 Walnut St",
    "parcel_id": "325-02-00",
    "owner1": "KATSEFF, ADAM C & AMY L ESSIGMANN",
    "owner2": "ESSIGMANN, JOHN M & ELLEN M",
    "current_taxes": 34653.45,
    "new_taxes_no_override": 36150.48,
    "override_total_1": 37176.22,
    "override_increase_1": 1025.74
  },
  {
    "#": "469 Walnut St (324-09-00)",
    "$": 4808200,
    "address": "469 Walnut St",
    "parcel_id": "324-09-00",
    "owner1": "LOUISON, DOUGLAS I",
    "owner2": "CALLAHAN, MAURA E",
    "current_taxes": 45601.03,
    "new_taxes_no_override": 47570.99,
    "override_total_1": 48920.78,
    "override_increase_1": 1349.79
  },
  {
    "#": "0 Warren St (351-04-00)",
    "$": 4576400,
    "address": "0 Warren St",
    "parcel_id": "351-04-00",
    "owner1": "SOCIETY OF THE  HOLY, TRANSFIGURATION MONESTARY",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "14 Warren St (334-35-00)",
    "$": 556900,
    "address": "14 Warren St",
    "parcel_id": "334-35-00",
    "owner1": "UNITED STATES OF AMERICA",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "16 Warren St (322-15-00)",
    "$": 2069500,
    "address": "16 Warren St",
    "parcel_id": "322-15-00",
    "owner1": "BURNS , ANDREA H & MATTHEW G",
    "owner2": "",
    "current_taxes": 17556.75,
    "new_taxes_no_override": 18315.2,
    "override_total_1": 18834.88,
    "override_increase_1": 519.68
  },
  {
    "#": "30 Warren St (322-14-00)",
    "$": 5143000,
    "address": "30 Warren St",
    "parcel_id": "322-14-00",
    "owner1": "SHENG, MORGAN H",
    "owner2": "WEN, LIDA",
    "current_taxes": 49029.39,
    "new_taxes_no_override": 51147.46,
    "override_total_1": 52598.73,
    "override_increase_1": 1451.27
  },
  {
    "#": "37 Warren St (324-01-00)",
    "$": 8307700,
    "address": "37 Warren St",
    "parcel_id": "324-01-00",
    "owner1": "VELASTEGUI, NICHOLAS A & SOPHIA",
    "owner2": "",
    "current_taxes": 85070.85,
    "new_taxes_no_override": 88745.91,
    "override_total_1": 91264.01,
    "override_increase_1": 2518.1
  },
  {
    "#": "45 Warren St (324-03-00)",
    "$": 3180100,
    "address": "45 Warren St",
    "parcel_id": "324-03-00",
    "owner1": "H ANNUUS LLC",
    "owner2": "",
    "current_taxes": 32564.22,
    "new_taxes_no_override": 33970.99,
    "override_total_1": 34934.9,
    "override_increase_1": 963.9
  },
  {
    "#": "49 Warren St (324-04-05)",
    "$": 7270800,
    "address": "49 Warren St",
    "parcel_id": "324-04-05",
    "owner1": "KOTLER, HAROLD G & JAMIE",
    "owner2": "",
    "current_taxes": 70818.06,
    "new_taxes_no_override": 73877.4,
    "override_total_1": 75973.61,
    "override_increase_1": 2096.21
  },
  {
    "#": "77 Warren St (325-07-00)",
    "$": 6144500,
    "address": "77 Warren St",
    "parcel_id": "325-07-00",
    "owner1": "BENENSON, JAMES III & FIONA ANNE",
    "owner2": "",
    "current_taxes": 59284.75,
    "new_taxes_no_override": 61845.85,
    "override_total_1": 63600.68,
    "override_increase_1": 1754.83
  },
  {
    "#": "99 Warren St (327-02-00)",
    "$": 7689000,
    "address": "99 Warren St",
    "parcel_id": "327-02-00",
    "owner1": "UNITED STATES OF AMERICA",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "103 Warren St (334-01-00)",
    "$": 3100700,
    "address": "103 Warren St",
    "parcel_id": "334-01-00",
    "owner1": "UNITED STATES OF AMERICA",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "107 Warren St (334-02-00)",
    "$": 3058800,
    "address": "107 Warren St",
    "parcel_id": "334-02-00",
    "owner1": "UNITED STATES OF AMERICA",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "111 Warren St (334-10-00)",
    "$": 17093500,
    "address": "111 Warren St",
    "parcel_id": "334-10-00",
    "owner1": "DORAN, TRS, ROBERT W & EVELYN H",
    "owner2": "C/O NANCY E DEMPZE, ESQ",
    "current_taxes": 175037.44,
    "new_taxes_no_override": 182599.06,
    "override_total_1": 187780.17,
    "override_increase_1": 5181.11
  },
  {
    "#": "116 Warren St (328-07-00)",
    "$": 7078100,
    "address": "116 Warren St",
    "parcel_id": "328-07-00",
    "owner1": "BOIARDI TRS, CHANTAL A",
    "owner2": "HUNTINGTON NATIONAL BANK",
    "current_taxes": 68844.81,
    "new_taxes_no_override": 71818.91,
    "override_total_1": 73856.71,
    "override_increase_1": 2037.81
  },
  {
    "#": "126 Warren St (333-13-00)",
    "$": 3030000,
    "address": "126 Warren St",
    "parcel_id": "333-13-00",
    "owner1": "MCDONOUGH, TR, KATHLEEN M",
    "owner2": "C/O PAUL MCCOY FAMILY OFFICE SEVICES LLP",
    "current_taxes": 31027.2,
    "new_taxes_no_override": 32367.58,
    "override_total_1": 33285.98,
    "override_increase_1": 918.41
  },
  {
    "#": "130 Warren St (333-12-00)",
    "$": 15827200,
    "address": "130 Warren St",
    "parcel_id": "333-12-00",
    "owner1": "MCDONOUGH TR, KATHLEEN M",
    "owner2": "C/O PAUL MCCOY FAMILY OFFICE SERVICES LLP",
    "current_taxes": 162070.53,
    "new_taxes_no_override": 169071.98,
    "override_total_1": 173869.26,
    "override_increase_1": 4797.29
  },
  {
    "#": "135 Warren St (334-02-02)",
    "$": 15659200,
    "address": "135 Warren St",
    "parcel_id": "334-02-02",
    "owner1": "MANUS TR, DEBORAH",
    "owner2": "C/O NUTTER MCCLENNEN& FISH LLP",
    "current_taxes": 160350.21,
    "new_taxes_no_override": 167277.34,
    "override_total_1": 172023.71,
    "override_increase_1": 4746.37
  },
  {
    "#": "140 Warren St (333-10-02)",
    "$": 3321500,
    "address": "140 Warren St",
    "parcel_id": "333-10-02",
    "owner1": "COX, JULIA D",
    "owner2": "",
    "current_taxes": 34012.16,
    "new_taxes_no_override": 35481.49,
    "override_total_1": 36488.25,
    "override_increase_1": 1006.76
  },
  {
    "#": "143 Warren St (334-03-00)",
    "$": 3021500,
    "address": "143 Warren St",
    "parcel_id": "334-03-00",
    "owner1": "UNITED STATES OF AMERICA",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "161 Warren St (334-04-00)",
    "$": 3008900,
    "address": "161 Warren St",
    "parcel_id": "334-04-00",
    "owner1": "UNITED STATES OF AMERICA",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "173 Warren St (334-05-00)",
    "$": 3020400,
    "address": "173 Warren St",
    "parcel_id": "334-05-00",
    "owner1": "UNITED STATES OF AMERICA",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "185 Warren St (334-06-00)",
    "$": 3760300,
    "address": "185 Warren St",
    "parcel_id": "334-06-00",
    "owner1": "NYHART TR, VIRGINIA G",
    "owner2": "",
    "current_taxes": 34870.54,
    "new_taxes_no_override": 36376.95,
    "override_total_1": 37409.12,
    "override_increase_1": 1032.17
  },
  {
    "#": "204 Warren St (332-05-00)",
    "$": 13188600,
    "address": "204 Warren St",
    "parcel_id": "332-05-00",
    "owner1": "BOTEIN, MATTHEW & SUSAN H",
    "owner2": "",
    "current_taxes": 131416.33,
    "new_taxes_no_override": 137093.52,
    "override_total_1": 140983.44,
    "override_increase_1": 3889.92
  },
  {
    "#": "215 Warren St (334-07-00)",
    "$": 6479600,
    "address": "215 Warren St",
    "parcel_id": "334-07-00",
    "owner1": "THORNDIKE, ALEXANDER L & ANNE N",
    "owner2": "",
    "current_taxes": 66351.1,
    "new_taxes_no_override": 69217.47,
    "override_total_1": 71181.46,
    "override_increase_1": 1963.99
  },
  {
    "#": "222 Warren St (351-12-01)",
    "$": 5364300,
    "address": "222 Warren St",
    "parcel_id": "351-12-01",
    "owner1": "WARREN COTTAGE VENTURES LLC",
    "owner2": "",
    "current_taxes": 54930.43,
    "new_taxes_no_override": 57303.42,
    "override_total_1": 58929.37,
    "override_increase_1": 1625.94
  },
  {
    "#": "230 Warren St (351-11-00)",
    "$": 11930700,
    "address": "230 Warren St",
    "parcel_id": "351-11-00",
    "owner1": "HERZOG, JAMES M & ELEANOR W",
    "owner2": "",
    "current_taxes": 118535.43,
    "new_taxes_no_override": 123656.16,
    "override_total_1": 127164.81,
    "override_increase_1": 3508.65
  },
  {
    "#": "235 Warren St (334-08-00)",
    "$": 6428000,
    "address": "235 Warren St",
    "parcel_id": "334-08-00",
    "owner1": "BHALLA, PANKAJ",
    "owner2": "NANGLA, TEJAL",
    "current_taxes": 62187.79,
    "new_taxes_no_override": 64874.3,
    "override_total_1": 66715.06,
    "override_increase_1": 1840.76
  },
  {
    "#": "255 Warren St (334-09-01)",
    "$": 15710400,
    "address": "255 Warren St",
    "parcel_id": "334-09-01",
    "owner1": "YANG TR, GUANG",
    "owner2": "",
    "current_taxes": 160874.5,
    "new_taxes_no_override": 167824.28,
    "override_total_1": 172586.16,
    "override_increase_1": 4761.89
  },
  {
    "#": "257 Warren St (334-09-00)",
    "$": 4594800,
    "address": "257 Warren St",
    "parcel_id": "334-09-00",
    "owner1": "YANG TR, GUANG",
    "owner2": "",
    "current_taxes": 47050.75,
    "new_taxes_no_override": 49083.34,
    "override_total_1": 50476.04,
    "override_increase_1": 1392.7
  },
  {
    "#": "260 Warren St (352-08-09)",
    "$": 11026400,
    "address": "260 Warren St",
    "parcel_id": "352-08-09",
    "owner1": "SOCIETY OF THE  HOLY, TRANSFIGURATION MONESTARY",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "270 Warren St (351-03-00)",
    "$": 5491700,
    "address": "270 Warren St",
    "parcel_id": "351-03-00",
    "owner1": "WILDE TRS, PETER O JR",
    "owner2": "FENWICK, JESSICA",
    "current_taxes": 56235.01,
    "new_taxes_no_override": 58664.36,
    "override_total_1": 60328.92,
    "override_increase_1": 1664.56
  },
  {
    "#": "278 Warren St (351-07-10)",
    "$": 33253000,
    "address": "278 Warren St",
    "parcel_id": "351-07-10",
    "owner1": "SOCIETY OF THE  HOLY, TRANSFIGURATION MONESTARY",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "280 Warren St (352-14-03)",
    "$": 15290400,
    "address": "280 Warren St",
    "parcel_id": "352-14-03",
    "owner1": "WILDE JR TRS, PETER O",
    "owner2": "EVANGELISTA, RENEE A R",
    "current_taxes": 152938.76,
    "new_taxes_no_override": 159545.71,
    "override_total_1": 164072.7,
    "override_increase_1": 4526.99
  },
  {
    "#": "282 Warren St (350-13-00)",
    "$": 10736800,
    "address": "282 Warren St",
    "parcel_id": "350-13-00",
    "owner1": "HUNT, JOHN",
    "owner2": "",
    "current_taxes": 109944.83,
    "new_taxes_no_override": 114694.45,
    "override_total_1": 117948.81,
    "override_increase_1": 3254.37
  },
  {
    "#": "284 Warren St (351-14-00)",
    "$": 10802900,
    "address": "284 Warren St",
    "parcel_id": "351-14-00",
    "owner1": "HUSID TRS, DOUGLAS M",
    "owner2": "CIPOLLA, AMI A",
    "current_taxes": 106986.76,
    "new_taxes_no_override": 111608.59,
    "override_total_1": 114775.4,
    "override_increase_1": 3166.81
  },
  {
    "#": "285 Warren St (334-11-13)",
    "$": 4452200,
    "address": "285 Warren St",
    "parcel_id": "334-11-13",
    "owner1": "WETMORE, MARK & JULIA HAYES",
    "owner2": "",
    "current_taxes": 41955.59,
    "new_taxes_no_override": 43768.07,
    "override_total_1": 45009.96,
    "override_increase_1": 1241.89
  },
  {
    "#": "286 Warren St (351-13-00)",
    "$": 8871600,
    "address": "286 Warren St",
    "parcel_id": "351-13-00",
    "owner1": "HIRSCH, ADAM M & RACHEL",
    "owner2": "",
    "current_taxes": 90845.18,
    "new_taxes_no_override": 94769.69,
    "override_total_1": 97458.71,
    "override_increase_1": 2689.02
  },
  {
    "#": "288 Warren St (352-14-02)",
    "$": 7924900,
    "address": "288 Warren St",
    "parcel_id": "352-14-02",
    "owner1": "HUSID TRS, DOUGLAS M",
    "owner2": "CIPOLLA, AMI A",
    "current_taxes": 81150.98,
    "new_taxes_no_override": 84656.7,
    "override_total_1": 87058.77,
    "override_increase_1": 2402.07
  },
  {
    "#": "290 Warren St (351-05-06)",
    "$": 6929900,
    "address": "290 Warren St",
    "parcel_id": "351-05-06",
    "owner1": "CATTINI, ELAINE & MARK PHILIP",
    "owner2": "",
    "current_taxes": 67327.24,
    "new_taxes_no_override": 70235.78,
    "override_total_1": 72228.66,
    "override_increase_1": 1992.89
  },
  {
    "#": "292 Warren St (350-05-00)",
    "$": 12104500,
    "address": "292 Warren St",
    "parcel_id": "350-05-00",
    "owner1": "BARTLETT TR, EDWARD J JR",
    "owner2": "",
    "current_taxes": 123950.08,
    "new_taxes_no_override": 129304.72,
    "override_total_1": 132973.65,
    "override_increase_1": 3668.92
  },
  {
    "#": "294 Warren St (350-12-00)",
    "$": 391100,
    "address": "294 Warren St",
    "parcel_id": "350-12-00",
    "owner1": "MBK MAIN ST STONEHAM LLC",
    "owner2": "C/O KARGMAN",
    "current_taxes": 4004.86,
    "new_taxes_no_override": 4177.87,
    "override_total_1": 4296.41,
    "override_increase_1": 118.54
  },
  {
    "#": "300 Warren St (350-09-00)",
    "$": 6578800,
    "address": "300 Warren St",
    "parcel_id": "350-09-00",
    "owner1": "RACHLIN, JACOB R",
    "owner2": "FUGELSO, DANA K",
    "current_taxes": 63731.98,
    "new_taxes_no_override": 66485.2,
    "override_total_1": 68371.67,
    "override_increase_1": 1886.47
  },
  {
    "#": "305 Warren St (334-14-00)",
    "$": 5302700,
    "address": "305 Warren St",
    "parcel_id": "334-14-00",
    "owner1": "LITTLE, JOHN B & FREDERIC F",
    "owner2": "",
    "current_taxes": 50664.71,
    "new_taxes_no_override": 52853.43,
    "override_total_1": 54353.1,
    "override_increase_1": 1499.68
  },
  {
    "#": "321 Warren St (334-21-00)",
    "$": 4776900,
    "address": "321 Warren St",
    "parcel_id": "334-21-00",
    "owner1": "321 WARREN STREET LLC",
    "owner2": "",
    "current_taxes": 48915.46,
    "new_taxes_no_override": 51028.61,
    "override_total_1": 52476.51,
    "override_increase_1": 1447.9
  },
  {
    "#": "324 Warren St (350-08-00)",
    "$": 5347300,
    "address": "324 Warren St",
    "parcel_id": "350-08-00",
    "owner1": "BIDABADI, NAZILA",
    "owner2": "HAKIMI, ALIREZA",
    "current_taxes": 51121.42,
    "new_taxes_no_override": 53329.87,
    "override_total_1": 54843.06,
    "override_increase_1": 1513.19
  },
  {
    "#": "342 Warren St (349-12-01)",
    "$": 8651700,
    "address": "342 Warren St",
    "parcel_id": "349-12-01",
    "owner1": "LASSER M INVESTMENTS LLC",
    "owner2": "",
    "current_taxes": 88593.41,
    "new_taxes_no_override": 92420.65,
    "override_total_1": 95043.01,
    "override_increase_1": 2622.36
  },
  {
    "#": "372 Warren St (338-01-03)",
    "$": 6428000,
    "address": "372 Warren St",
    "parcel_id": "338-01-03",
    "owner1": "HIGGINS  TRS, LAURENCE  D",
    "owner2": "KOWALIK, ANIA I",
    "current_taxes": 62187.79,
    "new_taxes_no_override": 64874.3,
    "override_total_1": 66715.06,
    "override_increase_1": 1840.76
  },
  {
    "#": "381 Warren St (337-26-00)",
    "$": 12401500,
    "address": "381 Warren St",
    "parcel_id": "337-26-00",
    "owner1": "ANDELMAN, TR, DAVID R",
    "owner2": "C/O WELLESLEY CAPITAL MGMT",
    "current_taxes": 126991.36,
    "new_taxes_no_override": 132477.39,
    "override_total_1": 136236.33,
    "override_increase_1": 3758.94
  },
  {
    "#": "388 Warren St (338-27-28)",
    "$": 5561900,
    "address": "388 Warren St",
    "parcel_id": "338-27-28",
    "owner1": "SIROTENKO TR, EKATERINA",
    "owner2": "",
    "current_taxes": 56953.86,
    "new_taxes_no_override": 59414.27,
    "override_total_1": 61100.1,
    "override_increase_1": 1685.83
  },
  {
    "#": "395 Warren St (337-25-00)",
    "$": 11750100,
    "address": "395 Warren St",
    "parcel_id": "337-25-00",
    "owner1": "BARROCAS, MARK A & YRINA G",
    "owner2": "",
    "current_taxes": 120321.02,
    "new_taxes_no_override": 125518.89,
    "override_total_1": 129080.39,
    "override_increase_1": 3561.5
  },
  {
    "#": "405 Warren St (337-24-01)",
    "$": 4279000,
    "address": "405 Warren St",
    "parcel_id": "337-24-01",
    "owner1": "LESTER, RICHARD K",
    "owner2": "COLUMBIA, ANNE E",
    "current_taxes": 40182.03,
    "new_taxes_no_override": 41917.89,
    "override_total_1": 43107.28,
    "override_increase_1": 1189.39
  },
  {
    "#": "407 Warren St (337-24-03)",
    "$": 8928300,
    "address": "407 Warren St",
    "parcel_id": "337-24-03",
    "owner1": "WU TR, QIONG",
    "owner2": "",
    "current_taxes": 87790.86,
    "new_taxes_no_override": 91583.43,
    "override_total_1": 94182.03,
    "override_increase_1": 2598.61
  },
  {
    "#": "415 Warren St (337-24-00)",
    "$": 7884600,
    "address": "415 Warren St",
    "parcel_id": "337-24-00",
    "owner1": "WINSTON, DAVID & JO-ANN",
    "owner2": "",
    "current_taxes": 80738.3,
    "new_taxes_no_override": 84226.19,
    "override_total_1": 86616.05,
    "override_increase_1": 2389.85
  },
  {
    "#": "420 Warren St (338-26-00)",
    "$": 6238100,
    "address": "420 Warren St",
    "parcel_id": "338-26-00",
    "owner1": "KLEPIKOV, MICHAEL",
    "owner2": "GERTSBERG, SOFIA",
    "current_taxes": 60243.21,
    "new_taxes_no_override": 62845.72,
    "override_total_1": 64628.92,
    "override_increase_1": 1783.2
  },
  {
    "#": "428 Warren St (338-24-25)",
    "$": 7047600,
    "address": "428 Warren St",
    "parcel_id": "338-24-25",
    "owner1": "FOLEY TRS, ELIZABETH A",
    "owner2": "BAYER, STEVEN R",
    "current_taxes": 68532.49,
    "new_taxes_no_override": 71493.09,
    "override_total_1": 73521.66,
    "override_increase_1": 2028.56
  },
  {
    "#": "431 Warren St (337-23-00)",
    "$": 8141000,
    "address": "431 Warren St",
    "parcel_id": "337-23-00",
    "owner1": "TRUJILLO, CAROLINA",
    "owner2": "DIAZGRANADOS, LUIS",
    "current_taxes": 83363.84,
    "new_taxes_no_override": 86965.16,
    "override_total_1": 89432.73,
    "override_increase_1": 2467.57
  },
  {
    "#": "450 Warren St (439-08-19)",
    "$": 56719500,
    "address": "450 Warren St",
    "parcel_id": "439-08-19",
    "owner1": "SUCOFF TR, ANDREW C",
    "owner2": "C/O GOODWIN PROCTER LLP",
    "current_taxes": 580807.68,
    "new_taxes_no_override": 605898.57,
    "override_total_1": 623090.48,
    "override_increase_1": 17191.91
  },
  {
    "#": "465 Warren St (337-22-00)",
    "$": 6769300,
    "address": "465 Warren St",
    "parcel_id": "337-22-00",
    "owner1": "MITCHELL TRS, JOHN D",
    "owner2": "SOLON , JOHN S",
    "current_taxes": 69317.63,
    "new_taxes_no_override": 72312.15,
    "override_total_1": 74363.95,
    "override_increase_1": 2051.8
  },
  {
    "#": "485 Warren St (337-21-00)",
    "$": 12597500,
    "address": "485 Warren St",
    "parcel_id": "337-21-00",
    "owner1": "KRITCHEVER, IRINA",
    "owner2": "",
    "current_taxes": 125363.47,
    "new_taxes_no_override": 130779.17,
    "override_total_1": 134489.93,
    "override_increase_1": 3710.76
  },
  {
    "#": "487 Warren St (337-21-01)",
    "$": 3036200,
    "address": "487 Warren St",
    "parcel_id": "337-21-01",
    "owner1": "KRITCHEVER, IRINA",
    "owner2": "",
    "current_taxes": 31090.69,
    "new_taxes_no_override": 32433.81,
    "override_total_1": 33354.09,
    "override_increase_1": 920.28
  },
  {
    "#": "489 Warren St (337-20-00)",
    "$": 3020900,
    "address": "489 Warren St",
    "parcel_id": "337-20-00",
    "owner1": "LORING, IAN & ISABELLE",
    "owner2": "",
    "current_taxes": 30934.02,
    "new_taxes_no_override": 32270.37,
    "override_total_1": 33186.02,
    "override_increase_1": 915.65
  },
  {
    "#": "514 Warren St (439-83-00)",
    "$": 13803000,
    "address": "514 Warren St",
    "parcel_id": "439-83-00",
    "owner1": "SUCOFF TR, ANDREW C",
    "owner2": "C/O GOODWIN PROCTER LLP",
    "current_taxes": 141342.72,
    "new_taxes_no_override": 147448.73,
    "override_total_1": 151632.47,
    "override_increase_1": 4183.74
  },
  {
    "#": "525 Warren St (337-19-00)",
    "$": 8401700,
    "address": "525 Warren St",
    "parcel_id": "337-19-00",
    "owner1": "LORING, IAN & ISABELLE",
    "owner2": "",
    "current_taxes": 86033.41,
    "new_taxes_no_override": 89750.05,
    "override_total_1": 92296.64,
    "override_increase_1": 2546.59
  },
  {
    "#": "11 Warwick Rd, Unit 1 & G1 (106-08-01)",
    "$": 1119800,
    "address": "11 Warwick Rd, Unit 1 & G1",
    "parcel_id": "106-08-01",
    "owner1": "RICH, DAVID EDWARD",
    "owner2": "LEUNG, KA MAN",
    "current_taxes": 7831.82,
    "new_taxes_no_override": 8170.15,
    "override_total_1": 8401.98,
    "override_increase_1": 231.82
  },
  {
    "#": "11 Warwick Rd, Unit 2 & G2 (106-08-02)",
    "$": 1158000,
    "address": "11 Warwick Rd, Unit 2 & G2",
    "parcel_id": "106-08-02",
    "owner1": "RAKOV, SIMON A & SUZANNE A",
    "owner2": "",
    "current_taxes": 8222.99,
    "new_taxes_no_override": 8578.22,
    "override_total_1": 8821.62,
    "override_increase_1": 243.4
  },
  {
    "#": "11 Warwick Rd, Unit 3 & G3 (106-08-03)",
    "$": 1170000,
    "address": "11 Warwick Rd, Unit 3 & G3",
    "parcel_id": "106-08-03",
    "owner1": "GUSS, DANIEL & YANA DOBKIN",
    "owner2": "",
    "current_taxes": 8345.87,
    "new_taxes_no_override": 8706.41,
    "override_total_1": 8953.45,
    "override_increase_1": 247.04
  },
  {
    "#": "12 Warwick Rd, Unit 12-1 (107-24-01)",
    "$": 1279400,
    "address": "12 Warwick Rd, Unit 12-1",
    "parcel_id": "107-24-01",
    "owner1": "RAPHEL TRS, GERALD & MIRIAM",
    "owner2": "",
    "current_taxes": 9466.12,
    "new_taxes_no_override": 9875.06,
    "override_total_1": 10155.25,
    "override_increase_1": 280.2
  },
  {
    "#": "12 Warwick Rd, Unit 12-2 (107-24-02)",
    "$": 1292900,
    "address": "12 Warwick Rd, Unit 12-2",
    "parcel_id": "107-24-02",
    "owner1": "GLUZMAN, EDWARD & RITA",
    "owner2": "",
    "current_taxes": 9604.36,
    "new_taxes_no_override": 10019.27,
    "override_total_1": 10303.56,
    "override_increase_1": 284.29
  },
  {
    "#": "12 Warwick Rd, Unit 12-3 (107-24-03)",
    "$": 1363300,
    "address": "12 Warwick Rd, Unit 12-3",
    "parcel_id": "107-24-03",
    "owner1": "LOSEVA, TR, NATALIA",
    "owner2": "",
    "current_taxes": 13960.19,
    "new_taxes_no_override": 14563.27,
    "override_total_1": 14976.49,
    "override_increase_1": 413.22
  },
  {
    "#": "14 Warwick Rd, Unit 14-1 (107-23-01)",
    "$": 1246700,
    "address": "14 Warwick Rd, Unit 14-1",
    "parcel_id": "107-23-01",
    "owner1": "STIEFEL, MICHAEL D & SUSANNA T",
    "owner2": "",
    "current_taxes": 12766.21,
    "new_taxes_no_override": 13317.71,
    "override_total_1": 13695.59,
    "override_increase_1": 377.88
  },
  {
    "#": "14 Warwick Rd, Unit 14-2 Pk Sp (107-23-02)",
    "$": 1313500,
    "address": "14 Warwick Rd, Unit 14-2 Pk Sp",
    "parcel_id": "107-23-02",
    "owner1": "CHURCH TR, ALANNA J",
    "owner2": "",
    "current_taxes": 9815.31,
    "new_taxes_no_override": 10239.33,
    "override_total_1": 10529.86,
    "override_increase_1": 290.53
  },
  {
    "#": "14 Warwick Rd, Unit 14-3 (107-23-03)",
    "$": 1302200,
    "address": "14 Warwick Rd, Unit 14-3",
    "parcel_id": "107-23-03",
    "owner1": "WISE, RAYMOND F JR",
    "owner2": "O`TOOLE, KERIN P",
    "current_taxes": 9699.59,
    "new_taxes_no_override": 10118.61,
    "override_total_1": 10405.72,
    "override_increase_1": 287.11
  },
  {
    "#": "15 Warwick Rd (106-09-00)",
    "$": 4225200,
    "address": "15 Warwick Rd",
    "parcel_id": "106-09-00",
    "owner1": "CHANG FOR CHANGE LLC",
    "owner2": "",
    "current_taxes": 43266.05,
    "new_taxes_no_override": 45135.14,
    "override_total_1": 46415.82,
    "override_increase_1": 1280.68
  },
  {
    "#": "16 Warwick Rd, Unit 16-1 (107-22-01)",
    "$": 1271500,
    "address": "16 Warwick Rd, Unit 16-1",
    "parcel_id": "107-22-01",
    "owner1": "PAISNER, DANIEL E",
    "owner2": "MEDOFF, NANCY",
    "current_taxes": 13020.16,
    "new_taxes_no_override": 13582.63,
    "override_total_1": 13968.03,
    "override_increase_1": 385.4
  },
  {
    "#": "16 Warwick Rd, Unit 16-2 (107-22-02)",
    "$": 1347900,
    "address": "16 Warwick Rd, Unit 16-2",
    "parcel_id": "107-22-02",
    "owner1": "BERKOWITZ TRS, JUDITH",
    "owner2": "MARTIN, ROBERT JR",
    "current_taxes": 10167.56,
    "new_taxes_no_override": 10606.8,
    "override_total_1": 10907.76,
    "override_increase_1": 300.96
  },
  {
    "#": "16 Warwick Rd, Unit 16-3 (107-22-03)",
    "$": 1313500,
    "address": "16 Warwick Rd, Unit 16-3",
    "parcel_id": "107-22-03",
    "owner1": "OLDER TRS, MICHAEL J",
    "owner2": "BLACKBURN, PAULA A",
    "current_taxes": 9815.31,
    "new_taxes_no_override": 10239.33,
    "override_total_1": 10529.86,
    "override_increase_1": 290.53
  },
  {
    "#": "16 Warwick Rd, Unit 16B (107-22-04)",
    "$": 381200,
    "address": "16 Warwick Rd, Unit 16B",
    "parcel_id": "107-22-04",
    "owner1": "DORNAN, RICHARD J",
    "owner2": "",
    "current_taxes": 390.35,
    "new_taxes_no_override": 407.21,
    "override_total_1": 418.77,
    "override_increase_1": 11.55
  },
  {
    "#": "17 Warwick Rd (106-10-00)",
    "$": 3119200,
    "address": "17 Warwick Rd",
    "parcel_id": "106-10-00",
    "owner1": "FONG, TR, GERARD",
    "owner2": "",
    "current_taxes": 31940.61,
    "new_taxes_no_override": 33320.44,
    "override_total_1": 34265.89,
    "override_increase_1": 945.44
  },
  {
    "#": "21 Warwick Rd, Unit 21-1 (106-11-03)",
    "$": 565500,
    "address": "21 Warwick Rd, Unit 21-1",
    "parcel_id": "106-11-03",
    "owner1": "FOERSTERLING, PETER O",
    "owner2": "",
    "current_taxes": 2155.79,
    "new_taxes_no_override": 2248.92,
    "override_total_1": 2312.73,
    "override_increase_1": 63.81
  },
  {
    "#": "21 Warwick Rd, Unit 21-2 (106-11-04)",
    "$": 575400,
    "address": "21 Warwick Rd, Unit 21-2",
    "parcel_id": "106-11-04",
    "owner1": "MARON, RUTH",
    "owner2": "",
    "current_taxes": 5892.1,
    "new_taxes_no_override": 6146.64,
    "override_total_1": 6321.04,
    "override_increase_1": 174.41
  },
  {
    "#": "21 Warwick Rd, Unit 21-3 (106-11-05)",
    "$": 629500,
    "address": "21 Warwick Rd, Unit 21-3",
    "parcel_id": "106-11-05",
    "owner1": "MENE XAVIER, CLAUDIA REGINA",
    "owner2": "",
    "current_taxes": 6446.08,
    "new_taxes_no_override": 6724.55,
    "override_total_1": 6915.35,
    "override_increase_1": 190.8
  },
  {
    "#": "21 Warwick Rd, Unit 21-4 (106-11-06)",
    "$": 572300,
    "address": "21 Warwick Rd, Unit 21-4",
    "parcel_id": "106-11-06",
    "owner1": "LAZZARA, JONATHAN",
    "owner2": "KNAPP, STEPHANIE LEE",
    "current_taxes": 2225.42,
    "new_taxes_no_override": 2321.56,
    "override_total_1": 2387.43,
    "override_increase_1": 65.87
  },
  {
    "#": "21 Warwick Rd, Unit 21-5 (106-11-07)",
    "$": 628200,
    "address": "21 Warwick Rd, Unit 21-5",
    "parcel_id": "106-11-07",
    "owner1": "CHRISTOPHER, MATTHEW & KELLY",
    "owner2": "",
    "current_taxes": 2797.83,
    "new_taxes_no_override": 2918.7,
    "override_total_1": 3001.51,
    "override_increase_1": 82.82
  },
  {
    "#": "21 Warwick Rd, Unit 21-6 (106-11-08)",
    "$": 584600,
    "address": "21 Warwick Rd, Unit 21-6",
    "parcel_id": "106-11-08",
    "owner1": "HUESTIS, MARC E & PAMELA S",
    "owner2": "",
    "current_taxes": 5986.3,
    "new_taxes_no_override": 6244.91,
    "override_total_1": 6422.1,
    "override_increase_1": 177.19
  },
  {
    "#": "21 Warwick Rd, Unit 21Bf (106-11-01)",
    "$": 449300,
    "address": "21 Warwick Rd, Unit 21Bf",
    "parcel_id": "106-11-01",
    "owner1": "MACDONALD, CANDACE K",
    "owner2": "",
    "current_taxes": 965.9,
    "new_taxes_no_override": 1007.63,
    "override_total_1": 1036.22,
    "override_increase_1": 28.59
  },
  {
    "#": "21 Warwick Rd, Unit 21Br (106-11-02)",
    "$": 454700,
    "address": "21 Warwick Rd, Unit 21Br",
    "parcel_id": "106-11-02",
    "owner1": "OCONNELL, MARGARET E",
    "owner2": "",
    "current_taxes": 1021.19,
    "new_taxes_no_override": 1065.31,
    "override_total_1": 1095.53,
    "override_increase_1": 30.23
  },
  {
    "#": "23 Warwick Rd, Unit 23-1 (106-11-11)",
    "$": 594300,
    "address": "23 Warwick Rd, Unit 23-1",
    "parcel_id": "106-11-11",
    "owner1": "KATZ, JAKOW & LUDMILA & ELLEN M",
    "owner2": "",
    "current_taxes": 2450.7,
    "new_taxes_no_override": 2556.57,
    "override_total_1": 2629.11,
    "override_increase_1": 72.54
  },
  {
    "#": "23 Warwick Rd, Unit 23-2 (106-11-12)",
    "$": 768500,
    "address": "23 Warwick Rd, Unit 23-2",
    "parcel_id": "106-11-12",
    "owner1": "MARZA, ROSANNA & LIVIU A",
    "owner2": "",
    "current_taxes": 4234.51,
    "new_taxes_no_override": 4417.44,
    "override_total_1": 4542.78,
    "override_increase_1": 125.34
  },
  {
    "#": "23 Warwick Rd, Unit 23-3 (106-11-13)",
    "$": 616600,
    "address": "23 Warwick Rd, Unit 23-3",
    "parcel_id": "106-11-13",
    "owner1": "FISHSTEIN, PAUL D",
    "owner2": "",
    "current_taxes": 2679.05,
    "new_taxes_no_override": 2794.78,
    "override_total_1": 2874.08,
    "override_increase_1": 79.3
  },
  {
    "#": "23 Warwick Rd, Unit 23-4 (106-11-14)",
    "$": 908600,
    "address": "23 Warwick Rd, Unit 23-4",
    "parcel_id": "106-11-14",
    "owner1": "CANZONERI, JULIAN N & KERRY M",
    "owner2": "",
    "current_taxes": 5669.13,
    "new_taxes_no_override": 5914.04,
    "override_total_1": 6081.84,
    "override_increase_1": 167.81
  },
  {
    "#": "23 Warwick Rd, Unit 23-5 (106-11-15)",
    "$": 629800,
    "address": "23 Warwick Rd, Unit 23-5",
    "parcel_id": "106-11-15",
    "owner1": "YIGIT, ALP ERIM",
    "owner2": "",
    "current_taxes": 6449.15,
    "new_taxes_no_override": 6727.75,
    "override_total_1": 6918.65,
    "override_increase_1": 190.89
  },
  {
    "#": "23 Warwick Rd, Unit 23-6 (106-11-16)",
    "$": 780200,
    "address": "23 Warwick Rd, Unit 23-6",
    "parcel_id": "106-11-16",
    "owner1": "DOLLINGER, JULIE",
    "owner2": "",
    "current_taxes": 7989.25,
    "new_taxes_no_override": 8334.39,
    "override_total_1": 8570.87,
    "override_increase_1": 236.48
  },
  {
    "#": "23 Warwick Rd, Unit 23Bf (106-11-09)",
    "$": 483100,
    "address": "23 Warwick Rd, Unit 23Bf",
    "parcel_id": "106-11-09",
    "owner1": "BELL, GRAHAM",
    "owner2": "",
    "current_taxes": 4946.94,
    "new_taxes_no_override": 5160.65,
    "override_total_1": 5307.08,
    "override_increase_1": 146.43
  },
  {
    "#": "23 Warwick Rd, Unit 23Br (106-11-10)",
    "$": 443300,
    "address": "23 Warwick Rd, Unit 23Br",
    "parcel_id": "106-11-10",
    "owner1": "MATTSON, LESLEY",
    "owner2": "",
    "current_taxes": 4539.39,
    "new_taxes_no_override": 4735.49,
    "override_total_1": 4869.86,
    "override_increase_1": 134.37
  },
  {
    "#": "24 Warwick Rd (107-21-00)",
    "$": 2612500,
    "address": "24 Warwick Rd",
    "parcel_id": "107-21-00",
    "owner1": "SWAMY TR, GITANJALI M",
    "owner2": "SARMA, EMANI SANJAY",
    "current_taxes": 23117.07,
    "new_taxes_no_override": 24115.73,
    "override_total_1": 24799.99,
    "override_increase_1": 684.27
  },
  {
    "#": "1 Washburn Pl, Unit 1 (170-12-02)",
    "$": 1246100,
    "address": "1 Washburn Pl, Unit 1",
    "parcel_id": "170-12-02",
    "owner1": "PROVOST, WILLIAM W",
    "owner2": "ZELBOW, STACEY L",
    "current_taxes": 9125.13,
    "new_taxes_no_override": 9519.34,
    "override_total_1": 9789.44,
    "override_increase_1": 270.1
  },
  {
    "#": "1 Washburn Pl, Unit 2 & Pk A-B (170-12-01)",
    "$": 1044500,
    "address": "1 Washburn Pl, Unit 2 & Pk A-B",
    "parcel_id": "170-12-01",
    "owner1": "LUFF, DONNA",
    "owner2": "PARRY, GARETH",
    "current_taxes": 7060.75,
    "new_taxes_no_override": 7365.77,
    "override_total_1": 7574.77,
    "override_increase_1": 209.0
  },
  {
    "#": "2 Washburn Pl, Unit 1 (170-10-07)",
    "$": 1107900,
    "address": "2 Washburn Pl, Unit 1",
    "parcel_id": "170-10-07",
    "owner1": "HARWIN, ALEX & AMY",
    "owner2": "",
    "current_taxes": 11344.9,
    "new_taxes_no_override": 11835.0,
    "override_total_1": 12170.81,
    "override_increase_1": 335.81
  },
  {
    "#": "2 Washburn Pl, Unit 2 (170-10-08)",
    "$": 1131400,
    "address": "2 Washburn Pl, Unit 2",
    "parcel_id": "170-10-08",
    "owner1": "MURTHY, SHARMILA L",
    "owner2": "CHOPRA, SAMEER",
    "current_taxes": 11585.54,
    "new_taxes_no_override": 12086.04,
    "override_total_1": 12428.97,
    "override_increase_1": 342.93
  },
  {
    "#": "3 Washburn Pl (170-11-00)",
    "$": 2017700,
    "address": "3 Washburn Pl",
    "parcel_id": "170-11-00",
    "owner1": "MACBAIN TR, CAROL J",
    "owner2": "",
    "current_taxes": 17026.31,
    "new_taxes_no_override": 17761.85,
    "override_total_1": 18265.83,
    "override_increase_1": 503.98
  },
  {
    "#": "4 Washburn Pl (170-10-02)",
    "$": 2407900,
    "address": "4 Washburn Pl",
    "parcel_id": "170-10-02",
    "owner1": "POSELL, ANNETT L",
    "owner2": "",
    "current_taxes": 21021.96,
    "new_taxes_no_override": 21930.11,
    "override_total_1": 22552.36,
    "override_increase_1": 622.25
  },
  {
    "#": "3 Washburn Ter (170-29-00)",
    "$": 2117300,
    "address": "3 Washburn Ter",
    "parcel_id": "170-29-00",
    "owner1": "LEE TRS, KAI WING",
    "owner2": "CHOU-LEE, CHAO N",
    "current_taxes": 21681.15,
    "new_taxes_no_override": 22617.78,
    "override_total_1": 23259.54,
    "override_increase_1": 641.76
  },
  {
    "#": "5 Washburn Ter, Unit 1 (170-30-03)",
    "$": 1026600,
    "address": "5 Washburn Ter, Unit 1",
    "parcel_id": "170-30-03",
    "owner1": "ITANI, MONA",
    "owner2": "SUKKARIEH, MODAR",
    "current_taxes": 6877.45,
    "new_taxes_no_override": 7174.56,
    "override_total_1": 7378.13,
    "override_increase_1": 203.57
  },
  {
    "#": "5 Washburn Ter, Unit 2 (170-30-01)",
    "$": 846500,
    "address": "5 Washburn Ter, Unit 2",
    "parcel_id": "170-30-01",
    "owner1": "BERKOWER TR, RHONDA",
    "owner2": "",
    "current_taxes": 5033.23,
    "new_taxes_no_override": 5250.67,
    "override_total_1": 5399.65,
    "override_increase_1": 148.98
  },
  {
    "#": "5 Washburn Ter, Unit 3 (170-30-02)",
    "$": 1110800,
    "address": "5 Washburn Ter, Unit 3",
    "parcel_id": "170-30-02",
    "owner1": "FOX, KAYLA JOY & MARC A",
    "owner2": "",
    "current_taxes": 7739.66,
    "new_taxes_no_override": 8074.01,
    "override_total_1": 8303.11,
    "override_increase_1": 229.09
  },
  {
    "#": "7 Washburn Ter (170-31-00)",
    "$": 2564400,
    "address": "7 Washburn Ter",
    "parcel_id": "170-31-00",
    "owner1": "SPUNT, EMILY & NATHAN",
    "owner2": "",
    "current_taxes": 26259.46,
    "new_taxes_no_override": 27393.87,
    "override_total_1": 28171.15,
    "override_increase_1": 777.28
  },
  {
    "#": "9 Washburn Ter, Unit 1 (170-32-01)",
    "$": 837700,
    "address": "9 Washburn Ter, Unit 1",
    "parcel_id": "170-32-01",
    "owner1": "LI, SHAUNG",
    "owner2": "",
    "current_taxes": 4943.11,
    "new_taxes_no_override": 5156.65,
    "override_total_1": 5302.97,
    "override_increase_1": 146.32
  },
  {
    "#": "9 Washburn Ter, Unit 2 (170-32-02)",
    "$": 849100,
    "address": "9 Washburn Ter, Unit 2",
    "parcel_id": "170-32-02",
    "owner1": "JHS LLC",
    "owner2": "C/O SAXENA, SAURABH",
    "current_taxes": 8694.78,
    "new_taxes_no_override": 9070.39,
    "override_total_1": 9327.76,
    "override_increase_1": 257.37
  },
  {
    "#": "9 Washburn Ter, Unit 3 (170-32-03)",
    "$": 924500,
    "address": "9 Washburn Ter, Unit 3",
    "parcel_id": "170-32-03",
    "owner1": "BERRY, LIAT",
    "owner2": "",
    "current_taxes": 9466.88,
    "new_taxes_no_override": 9875.85,
    "override_total_1": 10156.07,
    "override_increase_1": 280.22
  },
  {
    "#": "44 Washington St, Unit 1001 P298 (287-11-46)",
    "$": 715700,
    "address": "44 Washington St, Unit 1001 P298",
    "parcel_id": "287-11-46",
    "owner1": "T&R RE LLC",
    "owner2": "",
    "current_taxes": 7328.77,
    "new_taxes_no_override": 7645.37,
    "override_total_1": 7862.3,
    "override_increase_1": 216.93
  },
  {
    "#": "44 Washington St, Unit 1002 (287-11-47)",
    "$": 658100,
    "address": "44 Washington St, Unit 1002",
    "parcel_id": "287-11-47",
    "owner1": "YEO, PENG CHYE &TAN POH MOI",
    "owner2": "C/O SMITH",
    "current_taxes": 6738.94,
    "new_taxes_no_override": 7030.06,
    "override_total_1": 7229.53,
    "override_increase_1": 199.47
  },
  {
    "#": "44 Washington St, Unit 1003 P168 (287-11-48)",
    "$": 435900,
    "address": "44 Washington St, Unit 1003 P168",
    "parcel_id": "287-11-48",
    "owner1": "BERGEL, MARGUERITE",
    "owner2": "",
    "current_taxes": 4463.62,
    "new_taxes_no_override": 4656.45,
    "override_total_1": 4788.57,
    "override_increase_1": 132.12
  },
  {
    "#": "44 Washington St, Unit 1004 P255 (287-11-49)",
    "$": 474300,
    "address": "44 Washington St, Unit 1004 P255",
    "parcel_id": "287-11-49",
    "owner1": "CHUN, SANG HYUN & EUN S",
    "owner2": "",
    "current_taxes": 4856.83,
    "new_taxes_no_override": 5066.65,
    "override_total_1": 5210.41,
    "override_increase_1": 143.76
  },
  {
    "#": "44 Washington St, Unit 1005 (287-11-50)",
    "$": 406100,
    "address": "44 Washington St, Unit 1005",
    "parcel_id": "287-11-50",
    "owner1": "MICHAEL, RACHEL YONAH",
    "owner2": "",
    "current_taxes": 4158.46,
    "new_taxes_no_override": 4338.11,
    "override_total_1": 4461.2,
    "override_increase_1": 123.09
  },
  {
    "#": "44 Washington St, Unit 1006 (287-11-51)",
    "$": 358400,
    "address": "44 Washington St, Unit 1006",
    "parcel_id": "287-11-51",
    "owner1": "DOLE, VIVIAN PRESTON & WILLIAM",
    "owner2": "",
    "current_taxes": 3670.02,
    "new_taxes_no_override": 3828.56,
    "override_total_1": 3937.2,
    "override_increase_1": 108.63
  },
  {
    "#": "44 Washington St, Unit 1007 P250 (287-11-52)",
    "$": 469400,
    "address": "44 Washington St, Unit 1007 P250",
    "parcel_id": "287-11-52",
    "owner1": "HATTON, DIANE R",
    "owner2": "WHITE, MICHAEL G",
    "current_taxes": 4806.66,
    "new_taxes_no_override": 5014.31,
    "override_total_1": 5156.58,
    "override_increase_1": 142.28
  },
  {
    "#": "44 Washington St, Unit 1008 (287-11-53)",
    "$": 358400,
    "address": "44 Washington St, Unit 1008",
    "parcel_id": "287-11-53",
    "owner1": "FAN, ANGELA P-VICTOR-JACK C P",
    "owner2": "",
    "current_taxes": 3670.02,
    "new_taxes_no_override": 3828.56,
    "override_total_1": 3937.2,
    "override_increase_1": 108.63
  },
  {
    "#": "44 Washington St, Unit 1009 P403 (287-11-54)",
    "$": 444500,
    "address": "44 Washington St, Unit 1009 P403",
    "parcel_id": "287-11-54",
    "owner1": "COPPELMAN, DANIEL",
    "owner2": "",
    "current_taxes": 4551.68,
    "new_taxes_no_override": 4748.31,
    "override_total_1": 4883.04,
    "override_increase_1": 134.73
  },
  {
    "#": "44 Washington St, Unit 1010 (287-11-55)",
    "$": 358400,
    "address": "44 Washington St, Unit 1010",
    "parcel_id": "287-11-55",
    "owner1": "COPPELMAN, DANIEL & JEAN",
    "owner2": "",
    "current_taxes": 3670.02,
    "new_taxes_no_override": 3828.56,
    "override_total_1": 3937.2,
    "override_increase_1": 108.63
  },
  {
    "#": "44 Washington St, Unit 1011 (287-11-56)",
    "$": 358400,
    "address": "44 Washington St, Unit 1011",
    "parcel_id": "287-11-56",
    "owner1": "LORDAN, ANNA O",
    "owner2": "",
    "current_taxes": 3670.02,
    "new_taxes_no_override": 3828.56,
    "override_total_1": 3937.2,
    "override_increase_1": 108.63
  },
  {
    "#": "44 Washington St, Unit 1012 (287-11-57)",
    "$": 358400,
    "address": "44 Washington St, Unit 1012",
    "parcel_id": "287-11-57",
    "owner1": "FAN, ANGELA P-VICTOR S-GRACE",
    "owner2": "",
    "current_taxes": 3670.02,
    "new_taxes_no_override": 3828.56,
    "override_total_1": 3937.2,
    "override_increase_1": 108.63
  },
  {
    "#": "44 Washington St, Unit 1013 (287-11-58)",
    "$": 358400,
    "address": "44 Washington St, Unit 1013",
    "parcel_id": "287-11-58",
    "owner1": "WISWALL REALTY LLC",
    "owner2": "",
    "current_taxes": 3670.02,
    "new_taxes_no_override": 3828.56,
    "override_total_1": 3937.2,
    "override_increase_1": 108.63
  },
  {
    "#": "44 Washington St, Unit 1014 (287-11-59)",
    "$": 358400,
    "address": "44 Washington St, Unit 1014",
    "parcel_id": "287-11-59",
    "owner1": "CHANG, BAO LIN",
    "owner2": "WANG, YOUPING",
    "current_taxes": 3670.02,
    "new_taxes_no_override": 3828.56,
    "override_total_1": 3937.2,
    "override_increase_1": 108.63
  },
  {
    "#": "44 Washington St, Unit 1015 (287-11-60)",
    "$": 406100,
    "address": "44 Washington St, Unit 1015",
    "parcel_id": "287-11-60",
    "owner1": "ROY, HEATHER DALE",
    "owner2": "",
    "current_taxes": 4158.46,
    "new_taxes_no_override": 4338.11,
    "override_total_1": 4461.2,
    "override_increase_1": 123.09
  },
  {
    "#": "44 Washington St, Unit 1016 (287-11-61)",
    "$": 358400,
    "address": "44 Washington St, Unit 1016",
    "parcel_id": "287-11-61",
    "owner1": "LINGERTAT, HELMUT",
    "owner2": "",
    "current_taxes": 3670.02,
    "new_taxes_no_override": 3828.56,
    "override_total_1": 3937.2,
    "override_increase_1": 108.63
  },
  {
    "#": "44 Washington St, Unit 1017 P86&A (287-11-62)",
    "$": 466600,
    "address": "44 Washington St, Unit 1017 P86&A",
    "parcel_id": "287-11-62",
    "owner1": "MAKSAD, MAZEN",
    "owner2": "",
    "current_taxes": 1143.05,
    "new_taxes_no_override": 1192.43,
    "override_total_1": 1226.26,
    "override_increase_1": 33.83
  },
  {
    "#": "44 Washington St, Unit 1018 (287-11-63)",
    "$": 432000,
    "address": "44 Washington St, Unit 1018",
    "parcel_id": "287-11-63",
    "owner1": "WARAT, LAURA M",
    "owner2": "",
    "current_taxes": 4423.68,
    "new_taxes_no_override": 4614.78,
    "override_total_1": 4745.72,
    "override_increase_1": 130.94
  },
  {
    "#": "44 Washington St, Unit 1101 P77&A (287-11-64)",
    "$": 693800,
    "address": "44 Washington St, Unit 1101 P77&A",
    "parcel_id": "287-11-64",
    "owner1": "JIM, TERESITA T",
    "owner2": "",
    "current_taxes": 3469.58,
    "new_taxes_no_override": 3619.47,
    "override_total_1": 3722.17,
    "override_increase_1": 102.7
  },
  {
    "#": "44 Washington St, Unit 1102 P180 (287-11-65)",
    "$": 649900,
    "address": "44 Washington St, Unit 1102 P180",
    "parcel_id": "287-11-65",
    "owner1": "FAN, GRACE",
    "owner2": "CHEN, ANGELA PEI",
    "current_taxes": 6654.98,
    "new_taxes_no_override": 6942.48,
    "override_total_1": 7139.46,
    "override_increase_1": 196.99
  },
  {
    "#": "44 Washington St, Unit 1103 P288 (287-11-66)",
    "$": 420600,
    "address": "44 Washington St, Unit 1103 P288",
    "parcel_id": "287-11-66",
    "owner1": "HUANG, QIUXI",
    "owner2": "",
    "current_taxes": 4306.94,
    "new_taxes_no_override": 4493.0,
    "override_total_1": 4620.49,
    "override_increase_1": 127.49
  },
  {
    "#": "44 Washington St, Unit 1104 P444 (287-11-67)",
    "$": 520300,
    "address": "44 Washington St, Unit 1104 P444",
    "parcel_id": "287-11-67",
    "owner1": "LEE TR, DAZE S",
    "owner2": "",
    "current_taxes": 5327.87,
    "new_taxes_no_override": 5558.03,
    "override_total_1": 5715.74,
    "override_increase_1": 157.7
  },
  {
    "#": "44 Washington St, Unit 1105 (287-11-68)",
    "$": 419700,
    "address": "44 Washington St, Unit 1105",
    "parcel_id": "287-11-68",
    "owner1": "CRANDALL JR, JOEL",
    "owner2": "MEYER, FRANK",
    "current_taxes": 662.79,
    "new_taxes_no_override": 691.42,
    "override_total_1": 711.04,
    "override_increase_1": 19.62
  },
  {
    "#": "44 Washington St, Unit 1106 (287-11-69)",
    "$": 358400,
    "address": "44 Washington St, Unit 1106",
    "parcel_id": "287-11-69",
    "owner1": "WEINER, JAY M",
    "owner2": "",
    "current_taxes": 3670.02,
    "new_taxes_no_override": 3828.56,
    "override_total_1": 3937.2,
    "override_increase_1": 108.63
  },
  {
    "#": "44 Washington St, Unit 1107 (287-11-70)",
    "$": 358400,
    "address": "44 Washington St, Unit 1107",
    "parcel_id": "287-11-70",
    "owner1": "HO TRS, JOYCE SUKYI",
    "owner2": "KO TR, BING HO",
    "current_taxes": 3670.02,
    "new_taxes_no_override": 3828.56,
    "override_total_1": 3937.2,
    "override_increase_1": 108.63
  },
  {
    "#": "44 Washington St, Unit 1108 (287-11-71)",
    "$": 358400,
    "address": "44 Washington St, Unit 1108",
    "parcel_id": "287-11-71",
    "owner1": "JABOUR, JEANNE TRAVERS",
    "owner2": "",
    "current_taxes": 3670.02,
    "new_taxes_no_override": 3828.56,
    "override_total_1": 3937.2,
    "override_increase_1": 108.63
  },
  {
    "#": "44 Washington St, Unit 1109 (287-11-72)",
    "$": 419700,
    "address": "44 Washington St, Unit 1109",
    "parcel_id": "287-11-72",
    "owner1": "PACSON TR, MARIO P",
    "owner2": "",
    "current_taxes": 4297.73,
    "new_taxes_no_override": 4483.39,
    "override_total_1": 4610.6,
    "override_increase_1": 127.21
  },
  {
    "#": "44 Washington St, Unit 1110 (287-11-73)",
    "$": 358400,
    "address": "44 Washington St, Unit 1110",
    "parcel_id": "287-11-73",
    "owner1": "SHTIFTER, ROSITA",
    "owner2": "",
    "current_taxes": 3670.02,
    "new_taxes_no_override": 3828.56,
    "override_total_1": 3937.2,
    "override_increase_1": 108.63
  },
  {
    "#": "44 Washington St, Unit 1111 P416 (287-11-74)",
    "$": 444500,
    "address": "44 Washington St, Unit 1111 P416",
    "parcel_id": "287-11-74",
    "owner1": "STERN, ALEC R",
    "owner2": "",
    "current_taxes": 4551.68,
    "new_taxes_no_override": 4748.31,
    "override_total_1": 4883.04,
    "override_increase_1": 134.73
  },
  {
    "#": "44 Washington St, Unit 1112 (287-11-75)",
    "$": 358400,
    "address": "44 Washington St, Unit 1112",
    "parcel_id": "287-11-75",
    "owner1": "SHTIFTER, ZVI",
    "owner2": "",
    "current_taxes": 3670.02,
    "new_taxes_no_override": 3828.56,
    "override_total_1": 3937.2,
    "override_increase_1": 108.63
  },
  {
    "#": "44 Washington St, Unit 1113 (287-11-76)",
    "$": 401600,
    "address": "44 Washington St, Unit 1113",
    "parcel_id": "287-11-76",
    "owner1": "SANLIKOL, MEHMET ALI & SERAP KANTARCI",
    "owner2": "",
    "current_taxes": 4112.38,
    "new_taxes_no_override": 4290.03,
    "override_total_1": 4411.76,
    "override_increase_1": 121.73
  },
  {
    "#": "44 Washington St, Unit 1114 P134 (287-11-77)",
    "$": 504700,
    "address": "44 Washington St, Unit 1114 P134",
    "parcel_id": "287-11-77",
    "owner1": "PARK, BOK SOON",
    "owner2": "GONG, TAE DONG",
    "current_taxes": 5168.13,
    "new_taxes_no_override": 5391.39,
    "override_total_1": 5544.37,
    "override_increase_1": 152.98
  },
  {
    "#": "44 Washington St, Unit 1115 (287-11-78)",
    "$": 399400,
    "address": "44 Washington St, Unit 1115",
    "parcel_id": "287-11-78",
    "owner1": "BROOK HOUSE REALTY LLC",
    "owner2": "",
    "current_taxes": 4089.86,
    "new_taxes_no_override": 4266.54,
    "override_total_1": 4387.6,
    "override_increase_1": 121.06
  },
  {
    "#": "44 Washington St, Unit 1116 (287-11-79)",
    "$": 419700,
    "address": "44 Washington St, Unit 1116",
    "parcel_id": "287-11-79",
    "owner1": "WARSHAW, KAREN B",
    "owner2": "",
    "current_taxes": 662.79,
    "new_taxes_no_override": 691.42,
    "override_total_1": 711.04,
    "override_increase_1": 19.62
  },
  {
    "#": "44 Washington St, Unit 1117 P658 (287-11-80)",
    "$": 446200,
    "address": "44 Washington St, Unit 1117 P658",
    "parcel_id": "287-11-80",
    "owner1": "LAM, TRS, CATHERINA",
    "owner2": "",
    "current_taxes": 4569.09,
    "new_taxes_no_override": 4766.47,
    "override_total_1": 4901.72,
    "override_increase_1": 135.25
  },
  {
    "#": "44 Washington St, Unit 1118 P609 (287-11-81)",
    "$": 498300,
    "address": "44 Washington St, Unit 1118 P609",
    "parcel_id": "287-11-81",
    "owner1": "HO, SHUK-MEI",
    "owner2": "CHUNG, LUN-NAP",
    "current_taxes": 5102.59,
    "new_taxes_no_override": 5323.02,
    "override_total_1": 5474.06,
    "override_increase_1": 151.04
  },
  {
    "#": "44 Washington St, Unit 1201 P74&A (287-11-82)",
    "$": 666100,
    "address": "44 Washington St, Unit 1201 P74&A",
    "parcel_id": "287-11-82",
    "owner1": "YEAGER, KATHY",
    "owner2": "",
    "current_taxes": 3185.93,
    "new_taxes_no_override": 3323.56,
    "override_total_1": 3417.87,
    "override_increase_1": 94.3
  },
  {
    "#": "44 Washington St, Unit 1202 P269 (287-11-83)",
    "$": 723400,
    "address": "44 Washington St, Unit 1202 P269",
    "parcel_id": "287-11-83",
    "owner1": "FORBES TRS, CHARLES R",
    "owner2": "LASCANO, MIRNA M",
    "current_taxes": 7407.62,
    "new_taxes_no_override": 7727.63,
    "override_total_1": 7946.89,
    "override_increase_1": 219.27
  },
  {
    "#": "44 Washington St, Unit 1203 P167 (287-11-84)",
    "$": 420600,
    "address": "44 Washington St, Unit 1203 P167",
    "parcel_id": "287-11-84",
    "owner1": "RITS, SIMONA A",
    "owner2": "",
    "current_taxes": 4306.94,
    "new_taxes_no_override": 4493.0,
    "override_total_1": 4620.49,
    "override_increase_1": 127.49
  },
  {
    "#": "44 Washington St, Unit 1204 (287-11-85)",
    "$": 446200,
    "address": "44 Washington St, Unit 1204",
    "parcel_id": "287-11-85",
    "owner1": "EROGLU WASHINGTON LLC",
    "owner2": "",
    "current_taxes": 4569.09,
    "new_taxes_no_override": 4766.47,
    "override_total_1": 4901.72,
    "override_increase_1": 135.25
  },
  {
    "#": "44 Washington St, Unit 1205 P239 (287-11-86)",
    "$": 444500,
    "address": "44 Washington St, Unit 1205 P239",
    "parcel_id": "287-11-86",
    "owner1": "HYDE TR, BRENDA M",
    "owner2": "",
    "current_taxes": 916.75,
    "new_taxes_no_override": 956.35,
    "override_total_1": 983.49,
    "override_increase_1": 27.14
  },
  {
    "#": "44 Washington St, Unit 1206 P155 (287-11-87)",
    "$": 444500,
    "address": "44 Washington St, Unit 1206 P155",
    "parcel_id": "287-11-87",
    "owner1": "GOLDSTEIN, DAVID E",
    "owner2": "",
    "current_taxes": 4551.68,
    "new_taxes_no_override": 4748.31,
    "override_total_1": 4883.04,
    "override_increase_1": 134.73
  },
  {
    "#": "44 Washington St, Unit 1207 (287-11-88)",
    "$": 377300,
    "address": "44 Washington St, Unit 1207",
    "parcel_id": "287-11-88",
    "owner1": "PHOENIX SERIES BOSTON LLC",
    "owner2": "",
    "current_taxes": 3863.55,
    "new_taxes_no_override": 4030.46,
    "override_total_1": 4144.82,
    "override_increase_1": 114.36
  },
  {
    "#": "44 Washington St, Unit 1208 (287-11-89)",
    "$": 395300,
    "address": "44 Washington St, Unit 1208",
    "parcel_id": "287-11-89",
    "owner1": "SANI, SHAHRAM",
    "owner2": "",
    "current_taxes": 4047.87,
    "new_taxes_no_override": 4222.74,
    "override_total_1": 4342.55,
    "override_increase_1": 119.82
  },
  {
    "#": "44 Washington St, Unit 1209 (287-11-90)",
    "$": 373100,
    "address": "44 Washington St, Unit 1209",
    "parcel_id": "287-11-90",
    "owner1": "SOLOMON, ROY & ARIELA",
    "owner2": "",
    "current_taxes": 3820.54,
    "new_taxes_no_override": 3985.59,
    "override_total_1": 4098.68,
    "override_increase_1": 113.09
  },
  {
    "#": "44 Washington St, Unit 1210 (287-11-91)",
    "$": 373100,
    "address": "44 Washington St, Unit 1210",
    "parcel_id": "287-11-91",
    "owner1": "ALIEV, TR, SERGUEI",
    "owner2": "C/O MARANT INC",
    "current_taxes": 3820.54,
    "new_taxes_no_override": 3985.59,
    "override_total_1": 4098.68,
    "override_increase_1": 113.09
  },
  {
    "#": "44 Washington St, Unit 1211 (287-11-92)",
    "$": 385800,
    "address": "44 Washington St, Unit 1211",
    "parcel_id": "287-11-92",
    "owner1": "MIKALIAN, BENJAMIN",
    "owner2": "",
    "current_taxes": 3950.59,
    "new_taxes_no_override": 4121.26,
    "override_total_1": 4238.19,
    "override_increase_1": 116.94
  },
  {
    "#": "44 Washington St, Unit 1212 (287-11-93)",
    "$": 373100,
    "address": "44 Washington St, Unit 1212",
    "parcel_id": "287-11-93",
    "owner1": "ZLATNIK, ELENA & VLADIMIR",
    "owner2": "",
    "current_taxes": 3820.54,
    "new_taxes_no_override": 3985.59,
    "override_total_1": 4098.68,
    "override_increase_1": 113.09
  },
  {
    "#": "44 Washington St, Unit 1213 & P96 (287-11-94)",
    "$": 463100,
    "address": "44 Washington St, Unit 1213 & P96",
    "parcel_id": "287-11-94",
    "owner1": "RLLCC INVESTMENTS LLC",
    "owner2": "C/O ABLE REAL ESTATE USA INC, ATTN YUKI KOSUGE",
    "current_taxes": 4742.14,
    "new_taxes_no_override": 4947.0,
    "override_total_1": 5087.37,
    "override_increase_1": 140.37
  },
  {
    "#": "44 Washington St, Unit 1214 (287-11-95)",
    "$": 373100,
    "address": "44 Washington St, Unit 1214",
    "parcel_id": "287-11-95",
    "owner1": "RABINOVICH TRS, DANIEL E & DAPHNA",
    "owner2": "",
    "current_taxes": 3820.54,
    "new_taxes_no_override": 3985.59,
    "override_total_1": 4098.68,
    "override_increase_1": 113.09
  },
  {
    "#": "44 Washington St, Unit 1215 P211 (287-11-96)",
    "$": 497200,
    "address": "44 Washington St, Unit 1215 P211",
    "parcel_id": "287-11-96",
    "owner1": "LEON, SONIA A",
    "owner2": "",
    "current_taxes": 5091.33,
    "new_taxes_no_override": 5311.28,
    "override_total_1": 5461.98,
    "override_increase_1": 150.7
  },
  {
    "#": "44 Washington St, Unit 1216 (287-11-97)",
    "$": 373100,
    "address": "44 Washington St, Unit 1216",
    "parcel_id": "287-11-97",
    "owner1": "PARK, TRS, EDWARD K-RICHARD-KENNETH",
    "owner2": "",
    "current_taxes": 3820.54,
    "new_taxes_no_override": 3985.59,
    "override_total_1": 4098.68,
    "override_increase_1": 113.09
  },
  {
    "#": "44 Washington St, Unit 1217 (287-11-98)",
    "$": 395200,
    "address": "44 Washington St, Unit 1217",
    "parcel_id": "287-11-98",
    "owner1": "KOCHAK, MOHAMMAD",
    "owner2": "",
    "current_taxes": 4046.85,
    "new_taxes_no_override": 4221.67,
    "override_total_1": 4341.46,
    "override_increase_1": 119.79
  },
  {
    "#": "44 Washington St, Unit 1218 P169 (287-11-99)",
    "$": 483000,
    "address": "44 Washington St, Unit 1218 P169",
    "parcel_id": "287-11-99",
    "owner1": "CRUZ, DANIEL E",
    "owner2": "",
    "current_taxes": 1310.99,
    "new_taxes_no_override": 1367.62,
    "override_total_1": 1406.43,
    "override_increase_1": 38.81
  },
  {
    "#": "44 Washington St, Unit 201 P335B (287-10-02)",
    "$": 682100,
    "address": "44 Washington St, Unit 201 P335B",
    "parcel_id": "287-10-02",
    "owner1": "CHANG, HSUN-HSIEN",
    "owner2": "LIN, SHENG-IANG",
    "current_taxes": 3349.77,
    "new_taxes_no_override": 3494.48,
    "override_total_1": 3593.63,
    "override_increase_1": 99.15
  },
  {
    "#": "44 Washington St, Unit 202 P553&A (287-10-03)",
    "$": 691600,
    "address": "44 Washington St, Unit 202 P553&A",
    "parcel_id": "287-10-03",
    "owner1": "SABHARWAL, SUMEET",
    "owner2": "",
    "current_taxes": 7081.98,
    "new_taxes_no_override": 7387.92,
    "override_total_1": 7597.55,
    "override_increase_1": 209.63
  },
  {
    "#": "44 Washington St, Unit 203 & P161 (287-10-04)",
    "$": 420600,
    "address": "44 Washington St, Unit 203 & P161",
    "parcel_id": "287-10-04",
    "owner1": "BONAKDARPOUR, MAJID",
    "owner2": "",
    "current_taxes": 4306.94,
    "new_taxes_no_override": 4493.0,
    "override_total_1": 4620.49,
    "override_increase_1": 127.49
  },
  {
    "#": "44 Washington St, Unit 204 P-133 (287-10-05)",
    "$": 442000,
    "address": "44 Washington St, Unit 204 P-133",
    "parcel_id": "287-10-05",
    "owner1": "LI, NAI WO",
    "owner2": "",
    "current_taxes": 4526.08,
    "new_taxes_no_override": 4721.61,
    "override_total_1": 4855.58,
    "override_increase_1": 133.97
  },
  {
    "#": "44 Washington St, Unit 205 & P681 (287-10-06)",
    "$": 453600,
    "address": "44 Washington St, Unit 205 & P681",
    "parcel_id": "287-10-06",
    "owner1": "GOHIL, AKSHAR",
    "owner2": "",
    "current_taxes": 1009.93,
    "new_taxes_no_override": 1053.56,
    "override_total_1": 1083.45,
    "override_increase_1": 29.89
  },
  {
    "#": "44 Washington St, Unit 206 (287-10-07)",
    "$": 358400,
    "address": "44 Washington St, Unit 206",
    "parcel_id": "287-10-07",
    "owner1": "JACOB, CLAUS",
    "owner2": "",
    "current_taxes": 3670.02,
    "new_taxes_no_override": 3828.56,
    "override_total_1": 3937.2,
    "override_increase_1": 108.63
  },
  {
    "#": "44 Washington St, Unit 207 (287-10-08)",
    "$": 406100,
    "address": "44 Washington St, Unit 207",
    "parcel_id": "287-10-08",
    "owner1": "PACSON TR, MARIO P",
    "owner2": "",
    "current_taxes": 4158.46,
    "new_taxes_no_override": 4338.11,
    "override_total_1": 4461.2,
    "override_increase_1": 123.09
  },
  {
    "#": "44 Washington St, Unit 208 (287-10-09)",
    "$": 367300,
    "address": "44 Washington St, Unit 208",
    "parcel_id": "287-10-09",
    "owner1": "KUGLER, ALEJANDRO & ANN K",
    "owner2": "",
    "current_taxes": 3761.15,
    "new_taxes_no_override": 3923.63,
    "override_total_1": 4034.96,
    "override_increase_1": 111.33
  },
  {
    "#": "44 Washington St, Unit 209 & P342 (287-10-10)",
    "$": 421400,
    "address": "44 Washington St, Unit 209 & P342",
    "parcel_id": "287-10-10",
    "owner1": "GLUGETH TRS, MADELINE S & RICHARD J",
    "owner2": "",
    "current_taxes": 4315.14,
    "new_taxes_no_override": 4501.55,
    "override_total_1": 4629.28,
    "override_increase_1": 127.73
  },
  {
    "#": "44 Washington St, Unit 210 (287-10-11)",
    "$": 358400,
    "address": "44 Washington St, Unit 210",
    "parcel_id": "287-10-11",
    "owner1": "MCCAULEY, THOMAS & DILARA",
    "owner2": "",
    "current_taxes": 3670.02,
    "new_taxes_no_override": 3828.56,
    "override_total_1": 3937.2,
    "override_increase_1": 108.63
  },
  {
    "#": "44 Washington St, Unit 211 & P459 (287-10-12)",
    "$": 421400,
    "address": "44 Washington St, Unit 211 & P459",
    "parcel_id": "287-10-12",
    "owner1": "CHUNG, LAWRENCE P W",
    "owner2": "",
    "current_taxes": 4315.14,
    "new_taxes_no_override": 4501.55,
    "override_total_1": 4629.28,
    "override_increase_1": 127.73
  },
  {
    "#": "44 Washington St, Unit 212 (287-10-13)",
    "$": 406100,
    "address": "44 Washington St, Unit 212",
    "parcel_id": "287-10-13",
    "owner1": "YUE, SIMON C",
    "owner2": "",
    "current_taxes": 523.53,
    "new_taxes_no_override": 546.15,
    "override_total_1": 561.64,
    "override_increase_1": 15.5
  },
  {
    "#": "44 Washington St, Unit 213 (287-10-14)",
    "$": 358400,
    "address": "44 Washington St, Unit 213",
    "parcel_id": "287-10-14",
    "owner1": "LI, NAI WO",
    "owner2": "",
    "current_taxes": 3670.02,
    "new_taxes_no_override": 3828.56,
    "override_total_1": 3937.2,
    "override_increase_1": 108.63
  },
  {
    "#": "44 Washington St, Unit 214 (287-10-15)",
    "$": 350000,
    "address": "44 Washington St, Unit 214",
    "parcel_id": "287-10-15",
    "owner1": "GOLDSTEIN, DAVID E",
    "owner2": "",
    "current_taxes": 3584.0,
    "new_taxes_no_override": 3738.83,
    "override_total_1": 3844.92,
    "override_increase_1": 106.09
  },
  {
    "#": "44 Washington St, Unit 215 (287-10-16)",
    "$": 358400,
    "address": "44 Washington St, Unit 215",
    "parcel_id": "287-10-16",
    "owner1": "FAN, VICTOR & ANGELA",
    "owner2": "",
    "current_taxes": 3670.02,
    "new_taxes_no_override": 3828.56,
    "override_total_1": 3937.2,
    "override_increase_1": 108.63
  },
  {
    "#": "44 Washington St, Unit 216 (287-10-17)",
    "$": 406100,
    "address": "44 Washington St, Unit 216",
    "parcel_id": "287-10-17",
    "owner1": "GIFFORD, JONATHAN H",
    "owner2": "",
    "current_taxes": 523.53,
    "new_taxes_no_override": 546.15,
    "override_total_1": 561.64,
    "override_increase_1": 15.5
  },
  {
    "#": "44 Washington St, Unit 217 (287-10-18)",
    "$": 388400,
    "address": "44 Washington St, Unit 217",
    "parcel_id": "287-10-18",
    "owner1": "GOLDSTEIN, DAVID",
    "owner2": "",
    "current_taxes": 3977.22,
    "new_taxes_no_override": 4149.04,
    "override_total_1": 4266.76,
    "override_increase_1": 117.73
  },
  {
    "#": "44 Washington St, Unit 218 & P254 (287-10-19)",
    "$": 498300,
    "address": "44 Washington St, Unit 218 & P254",
    "parcel_id": "287-10-19",
    "owner1": "NISHIKAWA CO LTD",
    "owner2": "C/O RELO REDAC INC- MGMT 2203",
    "current_taxes": 5102.59,
    "new_taxes_no_override": 5323.02,
    "override_total_1": 5474.06,
    "override_increase_1": 151.04
  },
  {
    "#": "44 Washington St, Unit 301 & P130 (287-10-20)",
    "$": 642800,
    "address": "44 Washington St, Unit 301 & P130",
    "parcel_id": "287-10-20",
    "owner1": "CHUNG, LAWRENCE & JEREMY",
    "owner2": "",
    "current_taxes": 2947.34,
    "new_taxes_no_override": 3074.67,
    "override_total_1": 3161.91,
    "override_increase_1": 87.24
  },
  {
    "#": "44 Washington St, Unit 302 P540&A (287-10-21)",
    "$": 690700,
    "address": "44 Washington St, Unit 302 P540&A",
    "parcel_id": "287-10-21",
    "owner1": "WEINGART, SARAH L & DANIEL E",
    "owner2": "",
    "current_taxes": 7072.77,
    "new_taxes_no_override": 7378.31,
    "override_total_1": 7587.67,
    "override_increase_1": 209.35
  },
  {
    "#": "44 Washington St, Unit 303 (287-10-22)",
    "$": 362800,
    "address": "44 Washington St, Unit 303",
    "parcel_id": "287-10-22",
    "owner1": "LAM, CARRIE",
    "owner2": "",
    "current_taxes": 3715.07,
    "new_taxes_no_override": 3875.56,
    "override_total_1": 3985.53,
    "override_increase_1": 109.97
  },
  {
    "#": "44 Washington St, Unit 304 (287-10-23)",
    "$": 391000,
    "address": "44 Washington St, Unit 304",
    "parcel_id": "287-10-23",
    "owner1": "YI, JI",
    "owner2": "ZHANG, SUI",
    "current_taxes": 4003.84,
    "new_taxes_no_override": 4176.81,
    "override_total_1": 4295.32,
    "override_increase_1": 118.51
  },
  {
    "#": "44 Washington St, Unit 305 (287-10-24)",
    "$": 406100,
    "address": "44 Washington St, Unit 305",
    "parcel_id": "287-10-24",
    "owner1": "KERAMOPOULOS TR, HERO",
    "owner2": "C/O SOMMER TR, RUTH",
    "current_taxes": 4158.46,
    "new_taxes_no_override": 4338.11,
    "override_total_1": 4461.2,
    "override_increase_1": 123.09
  },
  {
    "#": "44 Washington St, Unit 306 (287-10-25)",
    "$": 358400,
    "address": "44 Washington St, Unit 306",
    "parcel_id": "287-10-25",
    "owner1": "HORIMATSU, MASAYOSHI",
    "owner2": "C/O ABLE REAL ESTATE USA INC",
    "current_taxes": 3670.02,
    "new_taxes_no_override": 3828.56,
    "override_total_1": 3937.2,
    "override_increase_1": 108.63
  },
  {
    "#": "44 Washington St, Unit 307 (287-10-26)",
    "$": 406100,
    "address": "44 Washington St, Unit 307",
    "parcel_id": "287-10-26",
    "owner1": "BROOK HOUSE REALTY LLC",
    "owner2": "",
    "current_taxes": 4158.46,
    "new_taxes_no_override": 4338.11,
    "override_total_1": 4461.2,
    "override_increase_1": 123.09
  },
  {
    "#": "44 Washington St, Unit 308 & P671 (287-10-27)",
    "$": 421400,
    "address": "44 Washington St, Unit 308 & P671",
    "parcel_id": "287-10-27",
    "owner1": "CHANG, BAOLIN",
    "owner2": "WANG, YOUPING",
    "current_taxes": 4315.14,
    "new_taxes_no_override": 4501.55,
    "override_total_1": 4629.28,
    "override_increase_1": 127.73
  },
  {
    "#": "44 Washington St, Unit 309 & P358 (287-10-28)",
    "$": 469400,
    "address": "44 Washington St, Unit 309 & P358",
    "parcel_id": "287-10-28",
    "owner1": "GRUTMAN, MORDECHAI & GALIT",
    "owner2": "",
    "current_taxes": 4806.66,
    "new_taxes_no_override": 5014.31,
    "override_total_1": 5156.58,
    "override_increase_1": 142.28
  },
  {
    "#": "44 Washington St, Unit 310 & P394 (287-10-29)",
    "$": 421500,
    "address": "44 Washington St, Unit 310 & P394",
    "parcel_id": "287-10-29",
    "owner1": "FORBES, LINDA S",
    "owner2": "",
    "current_taxes": 681.23,
    "new_taxes_no_override": 710.66,
    "override_total_1": 730.82,
    "override_increase_1": 20.16
  },
  {
    "#": "44 Washington St, Unit 311 & P345 (287-10-30)",
    "$": 421400,
    "address": "44 Washington St, Unit 311 & P345",
    "parcel_id": "287-10-30",
    "owner1": "SUZUKI, KAZUO",
    "owner2": "C/O ABLE REAL ESTATE USA INC",
    "current_taxes": 4315.14,
    "new_taxes_no_override": 4501.55,
    "override_total_1": 4629.28,
    "override_increase_1": 127.73
  },
  {
    "#": "44 Washington St, Unit 312 (287-10-31)",
    "$": 358400,
    "address": "44 Washington St, Unit 312",
    "parcel_id": "287-10-31",
    "owner1": "KRAM HOLDING LLC",
    "owner2": "",
    "current_taxes": 3670.02,
    "new_taxes_no_override": 3828.56,
    "override_total_1": 3937.2,
    "override_increase_1": 108.63
  },
  {
    "#": "44 Washington St, Unit 313 & P222 (287-10-32)",
    "$": 421400,
    "address": "44 Washington St, Unit 313 & P222",
    "parcel_id": "287-10-32",
    "owner1": "MIKALIAN, BEN",
    "owner2": "",
    "current_taxes": 4315.14,
    "new_taxes_no_override": 4501.55,
    "override_total_1": 4629.28,
    "override_increase_1": 127.73
  },
  {
    "#": "44 Washington St, Unit 314 & P433 (287-10-33)",
    "$": 421400,
    "address": "44 Washington St, Unit 314 & P433",
    "parcel_id": "287-10-33",
    "owner1": "GORDON, ET AL TRS, SIDNEY",
    "owner2": "",
    "current_taxes": 680.2,
    "new_taxes_no_override": 709.58,
    "override_total_1": 729.72,
    "override_increase_1": 20.13
  },
  {
    "#": "44 Washington St, Unit 315 (287-10-34)",
    "$": 419700,
    "address": "44 Washington St, Unit 315",
    "parcel_id": "287-10-34",
    "owner1": "ORFALI, MERCEDES",
    "owner2": "",
    "current_taxes": 4297.73,
    "new_taxes_no_override": 4483.39,
    "override_total_1": 4610.6,
    "override_increase_1": 127.21
  },
  {
    "#": "44 Washington St, Unit 316 (287-10-35)",
    "$": 377300,
    "address": "44 Washington St, Unit 316",
    "parcel_id": "287-10-35",
    "owner1": "HU TR, MEIHUEI",
    "owner2": "",
    "current_taxes": 3863.55,
    "new_taxes_no_override": 4030.46,
    "override_total_1": 4144.82,
    "override_increase_1": 114.36
  },
  {
    "#": "44 Washington St, Unit 317 & P141 (287-10-36)",
    "$": 446200,
    "address": "44 Washington St, Unit 317 & P141",
    "parcel_id": "287-10-36",
    "owner1": "GOLDSTEIN, DAVID E",
    "owner2": "",
    "current_taxes": 4569.09,
    "new_taxes_no_override": 4766.47,
    "override_total_1": 4901.72,
    "override_increase_1": 135.25
  },
  {
    "#": "44 Washington St, Unit 318 & P142 (287-10-37)",
    "$": 483000,
    "address": "44 Washington St, Unit 318 & P142",
    "parcel_id": "287-10-37",
    "owner1": "KRAM HOLDING LLC",
    "owner2": "",
    "current_taxes": 4945.92,
    "new_taxes_no_override": 5159.58,
    "override_total_1": 5305.98,
    "override_increase_1": 146.4
  },
  {
    "#": "44 Washington St, Unit 401 & P204 (287-10-38)",
    "$": 660300,
    "address": "44 Washington St, Unit 401 & P204",
    "parcel_id": "287-10-38",
    "owner1": "TAN, POH MOI",
    "owner2": "C/O SMITH",
    "current_taxes": 6761.47,
    "new_taxes_no_override": 7053.57,
    "override_total_1": 7253.71,
    "override_increase_1": 200.14
  },
  {
    "#": "44 Washington St, Unit 402 P556&A (287-10-39)",
    "$": 673200,
    "address": "44 Washington St, Unit 402 P556&A",
    "parcel_id": "287-10-39",
    "owner1": "MANSON LIFE ESTATE, CAROLYN L & DONALD B",
    "owner2": "",
    "current_taxes": 3258.63,
    "new_taxes_no_override": 3399.4,
    "override_total_1": 3495.86,
    "override_increase_1": 96.46
  },
  {
    "#": "44 Washington St, Unit 403 & P634 (287-10-40)",
    "$": 446100,
    "address": "44 Washington St, Unit 403 & P634",
    "parcel_id": "287-10-40",
    "owner1": "SALWEN, KRISTINA",
    "owner2": "",
    "current_taxes": 933.13,
    "new_taxes_no_override": 973.44,
    "override_total_1": 1001.06,
    "override_increase_1": 27.62
  },
  {
    "#": "44 Washington St, Unit 404 & P177 (287-10-41)",
    "$": 474300,
    "address": "44 Washington St, Unit 404 & P177",
    "parcel_id": "287-10-41",
    "owner1": "NISHIKAWA CO LTD",
    "owner2": "C/O RELO REDAC INC-MGMT 2204",
    "current_taxes": 4856.83,
    "new_taxes_no_override": 5066.65,
    "override_total_1": 5210.41,
    "override_increase_1": 143.76
  },
  {
    "#": "44 Washington St, Unit 405 (287-10-42)",
    "$": 358400,
    "address": "44 Washington St, Unit 405",
    "parcel_id": "287-10-42",
    "owner1": "HWANG, MARGARET SIAO",
    "owner2": "",
    "current_taxes": 3670.02,
    "new_taxes_no_override": 3828.56,
    "override_total_1": 3937.2,
    "override_increase_1": 108.63
  },
  {
    "#": "44 Washington St, Unit 406 (287-10-43)",
    "$": 406100,
    "address": "44 Washington St, Unit 406",
    "parcel_id": "287-10-43",
    "owner1": "LI, HANK",
    "owner2": "",
    "current_taxes": 4158.46,
    "new_taxes_no_override": 4338.11,
    "override_total_1": 4461.2,
    "override_increase_1": 123.09
  },
  {
    "#": "44 Washington St, Unit 407 & P165 (287-10-44)",
    "$": 421400,
    "address": "44 Washington St, Unit 407 & P165",
    "parcel_id": "287-10-44",
    "owner1": "BALANCINI DE VARGAS TR, BLANCA CLARA",
    "owner2": "VARGAS, FLORENTINO JOSE",
    "current_taxes": 4315.14,
    "new_taxes_no_override": 4501.55,
    "override_total_1": 4629.28,
    "override_increase_1": 127.73
  },
  {
    "#": "44 Washington St, Unit 408 (287-10-45)",
    "$": 358400,
    "address": "44 Washington St, Unit 408",
    "parcel_id": "287-10-45",
    "owner1": "CUI, CHEN",
    "owner2": "",
    "current_taxes": 3670.02,
    "new_taxes_no_override": 3828.56,
    "override_total_1": 3937.2,
    "override_increase_1": 108.63
  },
  {
    "#": "44 Washington St, Unit 409 (287-10-46)",
    "$": 419700,
    "address": "44 Washington St, Unit 409",
    "parcel_id": "287-10-46",
    "owner1": "DESMOND, RALPH",
    "owner2": "",
    "current_taxes": 4297.73,
    "new_taxes_no_override": 4483.39,
    "override_total_1": 4610.6,
    "override_increase_1": 127.21
  },
  {
    "#": "44 Washington St, Unit 410 (287-10-47)",
    "$": 358400,
    "address": "44 Washington St, Unit 410",
    "parcel_id": "287-10-47",
    "owner1": "VICTORIA HARBOUR LTD",
    "owner2": "C/O ABLE REAL ESTATE USA INC",
    "current_taxes": 3670.02,
    "new_taxes_no_override": 3828.56,
    "override_total_1": 3937.2,
    "override_increase_1": 108.63
  },
  {
    "#": "44 Washington St, Unit 411 & P576 (287-10-48)",
    "$": 469400,
    "address": "44 Washington St, Unit 411 & P576",
    "parcel_id": "287-10-48",
    "owner1": "KRAM HOLDING LLC",
    "owner2": "",
    "current_taxes": 4806.66,
    "new_taxes_no_override": 5014.31,
    "override_total_1": 5156.58,
    "override_increase_1": 142.28
  },
  {
    "#": "44 Washington St, Unit 412 (287-10-49)",
    "$": 383200,
    "address": "44 Washington St, Unit 412",
    "parcel_id": "287-10-49",
    "owner1": "CHOO, MIN KYUNG",
    "owner2": "",
    "current_taxes": 3923.97,
    "new_taxes_no_override": 4093.49,
    "override_total_1": 4209.64,
    "override_increase_1": 116.15
  },
  {
    "#": "44 Washington St, Unit 413 (287-10-50)",
    "$": 406100,
    "address": "44 Washington St, Unit 413",
    "parcel_id": "287-10-50",
    "owner1": "GLANTS, RICHARD-GREGORY-RACHEL",
    "owner2": "",
    "current_taxes": 4158.46,
    "new_taxes_no_override": 4338.11,
    "override_total_1": 4461.2,
    "override_increase_1": 123.09
  },
  {
    "#": "44 Washington St, Unit 414 (287-10-51)",
    "$": 358400,
    "address": "44 Washington St, Unit 414",
    "parcel_id": "287-10-51",
    "owner1": "KRAM HOLDING LLC",
    "owner2": "",
    "current_taxes": 3670.02,
    "new_taxes_no_override": 3828.56,
    "override_total_1": 3937.2,
    "override_increase_1": 108.63
  },
  {
    "#": "44 Washington St, Unit 415 & P257 (287-10-52)",
    "$": 487500,
    "address": "44 Washington St, Unit 415 & P257",
    "parcel_id": "287-10-52",
    "owner1": "SHTIFTER, ROSITA",
    "owner2": "",
    "current_taxes": 4992.0,
    "new_taxes_no_override": 5207.65,
    "override_total_1": 5355.42,
    "override_increase_1": 147.76
  },
  {
    "#": "44 Washington St, Unit 416 (287-10-53)",
    "$": 419700,
    "address": "44 Washington St, Unit 416",
    "parcel_id": "287-10-53",
    "owner1": "LI TR, MEIYIN SU",
    "owner2": "",
    "current_taxes": 4297.73,
    "new_taxes_no_override": 4483.39,
    "override_total_1": 4610.6,
    "override_increase_1": 127.21
  },
  {
    "#": "44 Washington St, Unit 417 & P440 (287-10-54)",
    "$": 466300,
    "address": "44 Washington St, Unit 417 & P440",
    "parcel_id": "287-10-54",
    "owner1": "RATHORE TRS, RITESH & BHARTI",
    "owner2": "",
    "current_taxes": 4774.91,
    "new_taxes_no_override": 4981.19,
    "override_total_1": 5122.52,
    "override_increase_1": 141.34
  },
  {
    "#": "44 Washington St, Unit 418 (287-10-55)",
    "$": 442200,
    "address": "44 Washington St, Unit 418",
    "parcel_id": "287-10-55",
    "owner1": "NEILL, JEANNETTE",
    "owner2": "",
    "current_taxes": 893.19,
    "new_taxes_no_override": 931.78,
    "override_total_1": 958.21,
    "override_increase_1": 26.44
  },
  {
    "#": "44 Washington St, Unit 501 & P125 (287-10-56)",
    "$": 682100,
    "address": "44 Washington St, Unit 501 & P125",
    "parcel_id": "287-10-56",
    "owner1": "HUANG, LI HSIA",
    "owner2": "",
    "current_taxes": 6984.7,
    "new_taxes_no_override": 7286.44,
    "override_total_1": 7493.19,
    "override_increase_1": 206.75
  },
  {
    "#": "44 Washington St, Unit 502 P352&A (287-10-57)",
    "$": 673200,
    "address": "44 Washington St, Unit 502 P352&A",
    "parcel_id": "287-10-57",
    "owner1": "MAKLAKOV, ALEXANDER",
    "owner2": "ROZENBLIT, ALLA",
    "current_taxes": 3258.63,
    "new_taxes_no_override": 3399.4,
    "override_total_1": 3495.86,
    "override_increase_1": 96.46
  },
  {
    "#": "44 Washington St, Unit 503 & P410 (287-10-58)",
    "$": 420600,
    "address": "44 Washington St, Unit 503 & P410",
    "parcel_id": "287-10-58",
    "owner1": "BATTINELLI TR, C ANDREW",
    "owner2": "",
    "current_taxes": 4306.94,
    "new_taxes_no_override": 4493.0,
    "override_total_1": 4620.49,
    "override_increase_1": 127.49
  },
  {
    "#": "44 Washington St, Unit 504 & P536 (287-10-59)",
    "$": 453500,
    "address": "44 Washington St, Unit 504 & P536",
    "parcel_id": "287-10-59",
    "owner1": "WANG, NING",
    "owner2": "",
    "current_taxes": 1008.91,
    "new_taxes_no_override": 1052.49,
    "override_total_1": 1082.36,
    "override_increase_1": 29.86
  },
  {
    "#": "44 Washington St, Unit 505 (287-10-60)",
    "$": 358400,
    "address": "44 Washington St, Unit 505",
    "parcel_id": "287-10-60",
    "owner1": "PACSON, CHRISTOPHER JOHN",
    "owner2": "",
    "current_taxes": 3670.02,
    "new_taxes_no_override": 3828.56,
    "override_total_1": 3937.2,
    "override_increase_1": 108.63
  },
  {
    "#": "44 Washington St, Unit 506 (287-10-61)",
    "$": 383200,
    "address": "44 Washington St, Unit 506",
    "parcel_id": "287-10-61",
    "owner1": "FOUR BONES REALTY LLC",
    "owner2": "",
    "current_taxes": 3923.97,
    "new_taxes_no_override": 4093.49,
    "override_total_1": 4209.64,
    "override_increase_1": 116.15
  },
  {
    "#": "44 Washington St, Unit 507 (287-10-62)",
    "$": 419700,
    "address": "44 Washington St, Unit 507",
    "parcel_id": "287-10-62",
    "owner1": "SUKENNIK, LEONID & TATYANA",
    "owner2": "",
    "current_taxes": 4297.73,
    "new_taxes_no_override": 4483.39,
    "override_total_1": 4610.6,
    "override_increase_1": 127.21
  },
  {
    "#": "44 Washington St, Unit 508 (287-10-63)",
    "$": 358400,
    "address": "44 Washington St, Unit 508",
    "parcel_id": "287-10-63",
    "owner1": "GOLDSTEIN, DAVID E",
    "owner2": "",
    "current_taxes": 3670.02,
    "new_taxes_no_override": 3828.56,
    "override_total_1": 3937.2,
    "override_increase_1": 108.63
  },
  {
    "#": "44 Washington St, Unit 509 (287-10-64)",
    "$": 406100,
    "address": "44 Washington St, Unit 509",
    "parcel_id": "287-10-64",
    "owner1": "ZLATNIK, VLADIMIR & ELENA",
    "owner2": "",
    "current_taxes": 4158.46,
    "new_taxes_no_override": 4338.11,
    "override_total_1": 4461.2,
    "override_increase_1": 123.09
  },
  {
    "#": "44 Washington St, Unit 510 (287-10-65)",
    "$": 389900,
    "address": "44 Washington St, Unit 510",
    "parcel_id": "287-10-65",
    "owner1": "SHUE, LAWRENCE",
    "owner2": "",
    "current_taxes": 399.26,
    "new_taxes_no_override": 416.51,
    "override_total_1": 428.33,
    "override_increase_1": 11.82
  },
  {
    "#": "44 Washington St, Unit 511 (287-10-66)",
    "$": 358400,
    "address": "44 Washington St, Unit 511",
    "parcel_id": "287-10-66",
    "owner1": "HOLLAND, ET AL, JOSEPH",
    "owner2": "",
    "current_taxes": 3670.02,
    "new_taxes_no_override": 3828.56,
    "override_total_1": 3937.2,
    "override_increase_1": 108.63
  },
  {
    "#": "44 Washington St, Unit 512 & P653 (287-10-67)",
    "$": 421400,
    "address": "44 Washington St, Unit 512 & P653",
    "parcel_id": "287-10-67",
    "owner1": "ROBBINS BROOKLINE CONDOS LLC",
    "owner2": "C/O ROBBINS PROPERTY ASSOCIATES",
    "current_taxes": 4315.14,
    "new_taxes_no_override": 4501.55,
    "override_total_1": 4629.28,
    "override_increase_1": 127.73
  },
  {
    "#": "44 Washington St, Unit 513 & P454 (287-10-68)",
    "$": 421400,
    "address": "44 Washington St, Unit 513 & P454",
    "parcel_id": "287-10-68",
    "owner1": "HWANG, MARGARET S",
    "owner2": "",
    "current_taxes": 4315.14,
    "new_taxes_no_override": 4501.55,
    "override_total_1": 4629.28,
    "override_increase_1": 127.73
  },
  {
    "#": "44 Washington St, Unit 514 (287-10-69)",
    "$": 358400,
    "address": "44 Washington St, Unit 514",
    "parcel_id": "287-10-69",
    "owner1": "LARIBESK LLC",
    "owner2": "",
    "current_taxes": 3670.02,
    "new_taxes_no_override": 3828.56,
    "override_total_1": 3937.2,
    "override_increase_1": 108.63
  },
  {
    "#": "44 Washington St, Unit 515 & P629 (287-10-70)",
    "$": 424600,
    "address": "44 Washington St, Unit 515 & P629",
    "parcel_id": "287-10-70",
    "owner1": "GANESAN ETAL, GAYATHRI",
    "owner2": "RAJAGOPALAN ET AL, GANESAN",
    "current_taxes": 4347.9,
    "new_taxes_no_override": 4535.73,
    "override_total_1": 4664.43,
    "override_increase_1": 128.7
  },
  {
    "#": "44 Washington St, Unit 516 & P258 (287-10-71)",
    "$": 421400,
    "address": "44 Washington St, Unit 516 & P258",
    "parcel_id": "287-10-71",
    "owner1": "ZLATNIK, VLADIMIR & ELENA",
    "owner2": "",
    "current_taxes": 4315.14,
    "new_taxes_no_override": 4501.55,
    "override_total_1": 4629.28,
    "override_increase_1": 127.73
  },
  {
    "#": "44 Washington St, Unit 517 (287-10-72)",
    "$": 395200,
    "address": "44 Washington St, Unit 517",
    "parcel_id": "287-10-72",
    "owner1": "KARIMI, ALI M",
    "owner2": "",
    "current_taxes": 4046.85,
    "new_taxes_no_override": 4221.67,
    "override_total_1": 4341.46,
    "override_increase_1": 119.79
  },
  {
    "#": "44 Washington St, Unit 518 (287-10-73)",
    "$": 447300,
    "address": "44 Washington St, Unit 518",
    "parcel_id": "287-10-73",
    "owner1": "POLITCH TR, JOSEPH",
    "owner2": "JOSEPH POLITCH LIVING TRUST",
    "current_taxes": 4580.35,
    "new_taxes_no_override": 4778.22,
    "override_total_1": 4913.8,
    "override_increase_1": 135.58
  },
  {
    "#": "44 Washington St, Unit 601& P586B (287-10-74)",
    "$": 682100,
    "address": "44 Washington St, Unit 601& P586B",
    "parcel_id": "287-10-74",
    "owner1": "WANG, STANLEY Y",
    "owner2": "LEE, ANGELA T",
    "current_taxes": 6984.7,
    "new_taxes_no_override": 7286.44,
    "override_total_1": 7493.19,
    "override_increase_1": 206.75
  },
  {
    "#": "44 Washington St, Unit 602 & P135 (287-10-75)",
    "$": 658100,
    "address": "44 Washington St, Unit 602 & P135",
    "parcel_id": "287-10-75",
    "owner1": "LI, WENZHU",
    "owner2": "",
    "current_taxes": 6738.94,
    "new_taxes_no_override": 7030.06,
    "override_total_1": 7229.53,
    "override_increase_1": 199.47
  },
  {
    "#": "44 Washington St, Unit 603 (287-10-76)",
    "$": 369600,
    "address": "44 Washington St, Unit 603",
    "parcel_id": "287-10-76",
    "owner1": "FAN, ANGELA P & VICTOR S",
    "owner2": "",
    "current_taxes": 3784.7,
    "new_taxes_no_override": 3948.2,
    "override_total_1": 4060.23,
    "override_increase_1": 112.03
  },
  {
    "#": "44 Washington St, Unit 604 & P235 (287-10-77)",
    "$": 464100,
    "address": "44 Washington St, Unit 604 & P235",
    "parcel_id": "287-10-77",
    "owner1": "BLAW LLC",
    "owner2": "",
    "current_taxes": 4752.38,
    "new_taxes_no_override": 4957.68,
    "override_total_1": 5098.35,
    "override_increase_1": 140.67
  },
  {
    "#": "44 Washington St, Unit 605 & P295 (287-10-78)",
    "$": 444600,
    "address": "44 Washington St, Unit 605 & P295",
    "parcel_id": "287-10-78",
    "owner1": "URNER CO LLC",
    "owner2": "",
    "current_taxes": 4552.7,
    "new_taxes_no_override": 4749.38,
    "override_total_1": 4884.14,
    "override_increase_1": 134.76
  },
  {
    "#": "44 Washington St, Unit 606 (287-10-79)",
    "$": 412400,
    "address": "44 Washington St, Unit 606",
    "parcel_id": "287-10-79",
    "owner1": "CHANG, BAOLIN",
    "owner2": "WANG, YOUPING",
    "current_taxes": 4222.98,
    "new_taxes_no_override": 4405.41,
    "override_total_1": 4530.41,
    "override_increase_1": 125.0
  },
  {
    "#": "44 Washington St, Unit 607 (287-10-80)",
    "$": 373100,
    "address": "44 Washington St, Unit 607",
    "parcel_id": "287-10-80",
    "owner1": "JANG, WONJO",
    "owner2": "",
    "current_taxes": 382.05,
    "new_taxes_no_override": 398.55,
    "override_total_1": 409.86,
    "override_increase_1": 11.31
  },
  {
    "#": "44 Washington St, Unit 608 (287-10-81)",
    "$": 406100,
    "address": "44 Washington St, Unit 608",
    "parcel_id": "287-10-81",
    "owner1": "ROZENBLIT, ALLA & YEVGENYA",
    "owner2": "",
    "current_taxes": 523.53,
    "new_taxes_no_override": 546.15,
    "override_total_1": 561.64,
    "override_increase_1": 15.5
  },
  {
    "#": "44 Washington St, Unit 609 (287-10-82)",
    "$": 358400,
    "address": "44 Washington St, Unit 609",
    "parcel_id": "287-10-82",
    "owner1": "WEINER, JAY M",
    "owner2": "",
    "current_taxes": 3670.02,
    "new_taxes_no_override": 3828.56,
    "override_total_1": 3937.2,
    "override_increase_1": 108.63
  },
  {
    "#": "44 Washington St, Unit 610 (287-10-83)",
    "$": 358400,
    "address": "44 Washington St, Unit 610",
    "parcel_id": "287-10-83",
    "owner1": "ALIEV, TRS, SERGUE",
    "owner2": "C/O MARANT INC",
    "current_taxes": 3670.02,
    "new_taxes_no_override": 3828.56,
    "override_total_1": 3937.2,
    "override_increase_1": 108.63
  },
  {
    "#": "44 Washington St, Unit 611 (287-10-84)",
    "$": 358400,
    "address": "44 Washington St, Unit 611",
    "parcel_id": "287-10-84",
    "owner1": "HULTSCH, ERWIN M D",
    "owner2": "",
    "current_taxes": 3670.02,
    "new_taxes_no_override": 3828.56,
    "override_total_1": 3937.2,
    "override_increase_1": 108.63
  },
  {
    "#": "44 Washington St, Unit 612 (287-10-85)",
    "$": 406100,
    "address": "44 Washington St, Unit 612",
    "parcel_id": "287-10-85",
    "owner1": "KRAM HOLDING LLC",
    "owner2": "",
    "current_taxes": 4158.46,
    "new_taxes_no_override": 4338.11,
    "override_total_1": 4461.2,
    "override_increase_1": 123.09
  },
  {
    "#": "44 Washington St, Unit 613 & P419 (287-10-86)",
    "$": 421400,
    "address": "44 Washington St, Unit 613 & P419",
    "parcel_id": "287-10-86",
    "owner1": "KIM, SARAH J",
    "owner2": "",
    "current_taxes": 680.2,
    "new_taxes_no_override": 709.58,
    "override_total_1": 729.72,
    "override_increase_1": 20.13
  },
  {
    "#": "44 Washington St, Unit 614 (287-10-87)",
    "$": 358400,
    "address": "44 Washington St, Unit 614",
    "parcel_id": "287-10-87",
    "owner1": "HONGO, RACHEL & TERESA D",
    "owner2": "",
    "current_taxes": 367.0,
    "new_taxes_no_override": 382.85,
    "override_total_1": 393.72,
    "override_increase_1": 10.86
  },
  {
    "#": "44 Washington St, Unit 615 & P242 (287-10-88)",
    "$": 421400,
    "address": "44 Washington St, Unit 615 & P242",
    "parcel_id": "287-10-88",
    "owner1": "GILL TRS, LORRI S",
    "owner2": "WEINBERG TRS, DONNA B",
    "current_taxes": 4315.14,
    "new_taxes_no_override": 4501.55,
    "override_total_1": 4629.28,
    "override_increase_1": 127.73
  },
  {
    "#": "44 Washington St, Unit 616 & P684 (287-10-89)",
    "$": 463100,
    "address": "44 Washington St, Unit 616 & P684",
    "parcel_id": "287-10-89",
    "owner1": "LI, HANK",
    "owner2": "",
    "current_taxes": 4742.14,
    "new_taxes_no_override": 4947.0,
    "override_total_1": 5087.37,
    "override_increase_1": 140.37
  },
  {
    "#": "44 Washington St, Unit 617 (287-10-90)",
    "$": 395200,
    "address": "44 Washington St, Unit 617",
    "parcel_id": "287-10-90",
    "owner1": "FARRELL, CHRISTOPHER J",
    "owner2": "",
    "current_taxes": 411.91,
    "new_taxes_no_override": 429.7,
    "override_total_1": 441.9,
    "override_increase_1": 12.19
  },
  {
    "#": "44 Washington St, Unit 618 (287-10-91)",
    "$": 447300,
    "address": "44 Washington St, Unit 618",
    "parcel_id": "287-10-91",
    "owner1": "MCDONOUGH, BARBARA A",
    "owner2": "",
    "current_taxes": 945.42,
    "new_taxes_no_override": 986.26,
    "override_total_1": 1014.25,
    "override_increase_1": 27.98
  },
  {
    "#": "44 Washington St, Unit 701 P139&A (287-10-92)",
    "$": 666100,
    "address": "44 Washington St, Unit 701 P139&A",
    "parcel_id": "287-10-92",
    "owner1": "CENTRE STREET PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 6820.86,
    "new_taxes_no_override": 7115.52,
    "override_total_1": 7317.42,
    "override_increase_1": 201.9
  },
  {
    "#": "44 Washington St, Unit 702 & P299 (287-10-93)",
    "$": 649800,
    "address": "44 Washington St, Unit 702 & P299",
    "parcel_id": "287-10-93",
    "owner1": "MORIMOTO, CHIKAO & HARUKO",
    "owner2": "",
    "current_taxes": 6653.95,
    "new_taxes_no_override": 6941.4,
    "override_total_1": 7138.36,
    "override_increase_1": 196.96
  },
  {
    "#": "44 Washington St, Unit 703 P157 (287-10-94)",
    "$": 420600,
    "address": "44 Washington St, Unit 703 P157",
    "parcel_id": "287-10-94",
    "owner1": "KUMAR, PRIYA",
    "owner2": "",
    "current_taxes": 4306.94,
    "new_taxes_no_override": 4493.0,
    "override_total_1": 4620.49,
    "override_increase_1": 127.49
  },
  {
    "#": "44 Washington St, Unit 704 & P124 (287-10-95)",
    "$": 464100,
    "address": "44 Washington St, Unit 704 & P124",
    "parcel_id": "287-10-95",
    "owner1": "SILBERSTEIN, PETER & GAIL",
    "owner2": "",
    "current_taxes": 4752.38,
    "new_taxes_no_override": 4957.68,
    "override_total_1": 5098.35,
    "override_increase_1": 140.67
  },
  {
    "#": "44 Washington St, Unit 705 (287-10-96)",
    "$": 358400,
    "address": "44 Washington St, Unit 705",
    "parcel_id": "287-10-96",
    "owner1": "SATVAT, TARANEH",
    "owner2": "",
    "current_taxes": 3670.02,
    "new_taxes_no_override": 3828.56,
    "override_total_1": 3937.2,
    "override_increase_1": 108.63
  },
  {
    "#": "44 Washington St, Unit 706 (287-10-97)",
    "$": 358400,
    "address": "44 Washington St, Unit 706",
    "parcel_id": "287-10-97",
    "owner1": "KRAM HOLDING LLC",
    "owner2": "",
    "current_taxes": 3670.02,
    "new_taxes_no_override": 3828.56,
    "override_total_1": 3937.2,
    "override_increase_1": 108.63
  },
  {
    "#": "44 Washington St, Unit 707-P194 (287-10-98)",
    "$": 421400,
    "address": "44 Washington St, Unit 707-P194",
    "parcel_id": "287-10-98",
    "owner1": "VERLY TR, JACQUES G",
    "owner2": "",
    "current_taxes": 4315.14,
    "new_taxes_no_override": 4501.55,
    "override_total_1": 4629.28,
    "override_increase_1": 127.73
  },
  {
    "#": "44 Washington St, Unit 708 (287-10-99)",
    "$": 419700,
    "address": "44 Washington St, Unit 708",
    "parcel_id": "287-10-99",
    "owner1": "LOUIE TR, PEGGIE SIU HING",
    "owner2": "",
    "current_taxes": 4297.73,
    "new_taxes_no_override": 4483.39,
    "override_total_1": 4610.6,
    "override_increase_1": 127.21
  },
  {
    "#": "44 Washington St, Unit 709 (287-11-00)",
    "$": 401600,
    "address": "44 Washington St, Unit 709",
    "parcel_id": "287-11-00",
    "owner1": "RUDITSKY PROPERTY MANAGEMENT LLC",
    "owner2": "",
    "current_taxes": 4112.38,
    "new_taxes_no_override": 4290.03,
    "override_total_1": 4411.76,
    "override_increase_1": 121.73
  },
  {
    "#": "44 Washington St, Unit 710 (287-11-01)",
    "$": 406100,
    "address": "44 Washington St, Unit 710",
    "parcel_id": "287-11-01",
    "owner1": "SAVINO, CAROL  ANN",
    "owner2": "",
    "current_taxes": 523.53,
    "new_taxes_no_override": 546.15,
    "override_total_1": 561.64,
    "override_increase_1": 15.5
  },
  {
    "#": "44 Washington St, Unit 711 (287-11-02)",
    "$": 358400,
    "address": "44 Washington St, Unit 711",
    "parcel_id": "287-11-02",
    "owner1": "SIMONELLI, RICHARD A & CYNTHIA A",
    "owner2": "",
    "current_taxes": 3670.02,
    "new_taxes_no_override": 3828.56,
    "override_total_1": 3937.2,
    "override_increase_1": 108.63
  },
  {
    "#": "44 Washington St, Unit 712 (287-11-03)",
    "$": 358400,
    "address": "44 Washington St, Unit 712",
    "parcel_id": "287-11-03",
    "owner1": "HULTSCH, ERWIN",
    "owner2": "",
    "current_taxes": 3670.02,
    "new_taxes_no_override": 3828.56,
    "override_total_1": 3937.2,
    "override_increase_1": 108.63
  },
  {
    "#": "44 Washington St, Unit 713 (287-11-04)",
    "$": 358400,
    "address": "44 Washington St, Unit 713",
    "parcel_id": "287-11-04",
    "owner1": "GOLDSTEIN, DAVID E",
    "owner2": "",
    "current_taxes": 3670.02,
    "new_taxes_no_override": 3828.56,
    "override_total_1": 3937.2,
    "override_increase_1": 108.63
  },
  {
    "#": "44 Washington St, Unit 714 (287-11-05)",
    "$": 358400,
    "address": "44 Washington St, Unit 714",
    "parcel_id": "287-11-05",
    "owner1": "INGRAM, SUSAN M",
    "owner2": "",
    "current_taxes": 367.0,
    "new_taxes_no_override": 382.85,
    "override_total_1": 393.72,
    "override_increase_1": 10.86
  },
  {
    "#": "44 Washington St, Unit 715 (287-11-06)",
    "$": 419700,
    "address": "44 Washington St, Unit 715",
    "parcel_id": "287-11-06",
    "owner1": "715 BROOK LLC",
    "owner2": "",
    "current_taxes": 4297.73,
    "new_taxes_no_override": 4483.39,
    "override_total_1": 4610.6,
    "override_increase_1": 127.21
  },
  {
    "#": "44 Washington St, Unit 716 (287-11-07)",
    "$": 358400,
    "address": "44 Washington St, Unit 716",
    "parcel_id": "287-11-07",
    "owner1": "DU, HUANGHAI & JINHAO",
    "owner2": "",
    "current_taxes": 3670.02,
    "new_taxes_no_override": 3828.56,
    "override_total_1": 3937.2,
    "override_increase_1": 108.63
  },
  {
    "#": "44 Washington St, Unit 717 (287-11-08)",
    "$": 443200,
    "address": "44 Washington St, Unit 717",
    "parcel_id": "287-11-08",
    "owner1": "HOUBEN, STEVEN",
    "owner2": "KORNIENKO, SOFIYA ALEXANDROVNA",
    "current_taxes": 4538.37,
    "new_taxes_no_override": 4734.43,
    "override_total_1": 4868.76,
    "override_increase_1": 134.34
  },
  {
    "#": "44 Washington St, Unit 718 & P181 (287-11-09)",
    "$": 508500,
    "address": "44 Washington St, Unit 718 & P181",
    "parcel_id": "287-11-09",
    "owner1": "TOMICH, JENNIFER",
    "owner2": "",
    "current_taxes": 5207.04,
    "new_taxes_no_override": 5431.98,
    "override_total_1": 5586.11,
    "override_increase_1": 154.13
  },
  {
    "#": "44 Washington St, Unit 801 & P111 (287-11-10)",
    "$": 661200,
    "address": "44 Washington St, Unit 801 & P111",
    "parcel_id": "287-11-10",
    "owner1": "MAJUMDER TRS, PRADIP K & ANAMIKA",
    "owner2": "",
    "current_taxes": 6770.69,
    "new_taxes_no_override": 7063.18,
    "override_total_1": 7263.6,
    "override_increase_1": 200.41
  },
  {
    "#": "44 Washington St, Unit 802 P350&A (287-11-11)",
    "$": 673200,
    "address": "44 Washington St, Unit 802 P350&A",
    "parcel_id": "287-11-11",
    "owner1": "SHAPIRO, GEOFFREY",
    "owner2": "",
    "current_taxes": 3258.63,
    "new_taxes_no_override": 3399.4,
    "override_total_1": 3495.86,
    "override_increase_1": 96.46
  },
  {
    "#": "44 Washington St, Unit 803 & P140 (287-11-12)",
    "$": 472200,
    "address": "44 Washington St, Unit 803 & P140",
    "parcel_id": "287-11-12",
    "owner1": "WEI, SHAO-YUN",
    "owner2": "",
    "current_taxes": 4835.33,
    "new_taxes_no_override": 5044.22,
    "override_total_1": 5187.34,
    "override_increase_1": 143.13
  },
  {
    "#": "44 Washington St, Unit 804 & P650 (287-11-13)",
    "$": 468800,
    "address": "44 Washington St, Unit 804 & P650",
    "parcel_id": "287-11-13",
    "owner1": "HERMAN, MICHELLE C",
    "owner2": "",
    "current_taxes": 1165.58,
    "new_taxes_no_override": 1215.93,
    "override_total_1": 1250.43,
    "override_increase_1": 34.5
  },
  {
    "#": "44 Washington St, Unit 805 & P456 (287-11-14)",
    "$": 504700,
    "address": "44 Washington St, Unit 805 & P456",
    "parcel_id": "287-11-14",
    "owner1": "LAZAROU, STEPHEN A",
    "owner2": "",
    "current_taxes": 5168.13,
    "new_taxes_no_override": 5391.39,
    "override_total_1": 5544.37,
    "override_increase_1": 152.98
  },
  {
    "#": "44 Washington St, Unit 806 (287-11-15)",
    "$": 358400,
    "address": "44 Washington St, Unit 806",
    "parcel_id": "287-11-15",
    "owner1": "MCKAY TRS, JAMES COLEY & JOANNE LARVADAIN",
    "owner2": "MCKAY, JEREMY",
    "current_taxes": 3670.02,
    "new_taxes_no_override": 3828.56,
    "override_total_1": 3937.2,
    "override_increase_1": 108.63
  },
  {
    "#": "44 Washington St, Unit 807 (287-11-16)",
    "$": 358400,
    "address": "44 Washington St, Unit 807",
    "parcel_id": "287-11-16",
    "owner1": "PACSON, MARIO P TR & MICHAEL A",
    "owner2": "",
    "current_taxes": 3670.02,
    "new_taxes_no_override": 3828.56,
    "override_total_1": 3937.2,
    "override_increase_1": 108.63
  },
  {
    "#": "44 Washington St, Unit 808 & P246 (287-11-17)",
    "$": 463100,
    "address": "44 Washington St, Unit 808 & P246",
    "parcel_id": "287-11-17",
    "owner1": "MOMTAZ TRS, PARVANEH & PARISA",
    "owner2": "",
    "current_taxes": 4742.14,
    "new_taxes_no_override": 4947.0,
    "override_total_1": 5087.37,
    "override_increase_1": 140.37
  },
  {
    "#": "44 Washington St, Unit 809 (287-11-18)",
    "$": 358400,
    "address": "44 Washington St, Unit 809",
    "parcel_id": "287-11-18",
    "owner1": "KARAGIANNIS, PANAGIOTIS",
    "owner2": "",
    "current_taxes": 367.0,
    "new_taxes_no_override": 382.85,
    "override_total_1": 393.72,
    "override_increase_1": 10.86
  },
  {
    "#": "44 Washington St, Unit 810 (287-11-19)",
    "$": 358400,
    "address": "44 Washington St, Unit 810",
    "parcel_id": "287-11-19",
    "owner1": "HO , SHUK-MEI",
    "owner2": "CHUNG, LUN-NAP",
    "current_taxes": 3670.02,
    "new_taxes_no_override": 3828.56,
    "override_total_1": 3937.2,
    "override_increase_1": 108.63
  },
  {
    "#": "44 Washington St, Unit 811 (287-11-20)",
    "$": 406100,
    "address": "44 Washington St, Unit 811",
    "parcel_id": "287-11-20",
    "owner1": "MCCAULEY, THOMAS & DILARA",
    "owner2": "",
    "current_taxes": 4158.46,
    "new_taxes_no_override": 4338.11,
    "override_total_1": 4461.2,
    "override_increase_1": 123.09
  },
  {
    "#": "44 Washington St, Unit 812 (287-11-21)",
    "$": 392100,
    "address": "44 Washington St, Unit 812",
    "parcel_id": "287-11-21",
    "owner1": "WONG, MICHELLE YUNG",
    "owner2": "",
    "current_taxes": 4015.1,
    "new_taxes_no_override": 4188.55,
    "override_total_1": 4307.4,
    "override_increase_1": 118.85
  },
  {
    "#": "44 Washington St, Unit 813 (287-11-22)",
    "$": 358400,
    "address": "44 Washington St, Unit 813",
    "parcel_id": "287-11-22",
    "owner1": "SHAHBAZI, MITRA",
    "owner2": "NOSRATIAN, YOUNES",
    "current_taxes": 3670.02,
    "new_taxes_no_override": 3828.56,
    "override_total_1": 3937.2,
    "override_increase_1": 108.63
  },
  {
    "#": "44 Washington St, Unit 814 (287-11-23)",
    "$": 406100,
    "address": "44 Washington St, Unit 814",
    "parcel_id": "287-11-23",
    "owner1": "HO TRS, JOYCE SUKYI",
    "owner2": "",
    "current_taxes": 4158.46,
    "new_taxes_no_override": 4338.11,
    "override_total_1": 4461.2,
    "override_increase_1": 123.09
  },
  {
    "#": "44 Washington St, Unit 815 (287-11-24)",
    "$": 406100,
    "address": "44 Washington St, Unit 815",
    "parcel_id": "287-11-24",
    "owner1": "KRAM HOLDING LLC",
    "owner2": "",
    "current_taxes": 4158.46,
    "new_taxes_no_override": 4338.11,
    "override_total_1": 4461.2,
    "override_increase_1": 123.09
  },
  {
    "#": "44 Washington St, Unit 816 (287-11-25)",
    "$": 419700,
    "address": "44 Washington St, Unit 816",
    "parcel_id": "287-11-25",
    "owner1": "PACSON TR, MARIO P",
    "owner2": "",
    "current_taxes": 4297.73,
    "new_taxes_no_override": 4483.39,
    "override_total_1": 4610.6,
    "override_increase_1": 127.21
  },
  {
    "#": "44 Washington St, Unit 817 & P474 (287-11-26)",
    "$": 451000,
    "address": "44 Washington St, Unit 817 & P474",
    "parcel_id": "287-11-26",
    "owner1": "BALANCINI DE VARGAS TR, BLANCA CLARA",
    "owner2": "VARGAS, FLORENTINO JOSE",
    "current_taxes": 4618.24,
    "new_taxes_no_override": 4817.75,
    "override_total_1": 4954.45,
    "override_increase_1": 136.7
  },
  {
    "#": "44 Washington St, Unit 818 & P172 (287-11-27)",
    "$": 494900,
    "address": "44 Washington St, Unit 818 & P172",
    "parcel_id": "287-11-27",
    "owner1": "LIPNESH, YURI",
    "owner2": "MINTS, VICTORIA",
    "current_taxes": 5067.78,
    "new_taxes_no_override": 5286.71,
    "override_total_1": 5436.71,
    "override_increase_1": 150.01
  },
  {
    "#": "44 Washington St, Unit 901 & P413 (287-11-28)",
    "$": 642800,
    "address": "44 Washington St, Unit 901 & P413",
    "parcel_id": "287-11-28",
    "owner1": "NG, MAVIS M & DAVID TATCHEE",
    "owner2": "",
    "current_taxes": 6582.27,
    "new_taxes_no_override": 6866.62,
    "override_total_1": 7061.46,
    "override_increase_1": 194.84
  },
  {
    "#": "44 Washington St, Unit 902 & P273 (287-11-29)",
    "$": 703500,
    "address": "44 Washington St, Unit 902 & P273",
    "parcel_id": "287-11-29",
    "owner1": "WANG, RICHARD YUN",
    "owner2": "CHEN, YAPING",
    "current_taxes": 3568.91,
    "new_taxes_no_override": 3723.09,
    "override_total_1": 3828.73,
    "override_increase_1": 105.64
  },
  {
    "#": "44 Washington St, Unit 903 & P651 (287-11-30)",
    "$": 420600,
    "address": "44 Washington St, Unit 903 & P651",
    "parcel_id": "287-11-30",
    "owner1": "NEALE, ADA I & BERNARD J",
    "owner2": "",
    "current_taxes": 4306.94,
    "new_taxes_no_override": 4493.0,
    "override_total_1": 4620.49,
    "override_increase_1": 127.49
  },
  {
    "#": "44 Washington St, Unit 904 (287-11-31)",
    "$": 397800,
    "address": "44 Washington St, Unit 904",
    "parcel_id": "287-11-31",
    "owner1": "OKEEFE TR, KAREN",
    "owner2": "",
    "current_taxes": 438.54,
    "new_taxes_no_override": 457.48,
    "override_total_1": 470.47,
    "override_increase_1": 12.98
  },
  {
    "#": "44 Washington St, Unit 905 & P164 (287-11-32)",
    "$": 444500,
    "address": "44 Washington St, Unit 905 & P164",
    "parcel_id": "287-11-32",
    "owner1": "ABRAHAM REAL ESTATE LLC",
    "owner2": "",
    "current_taxes": 4551.68,
    "new_taxes_no_override": 4748.31,
    "override_total_1": 4883.04,
    "override_increase_1": 134.73
  },
  {
    "#": "44 Washington St, Unit 906 (287-11-33)",
    "$": 406100,
    "address": "44 Washington St, Unit 906",
    "parcel_id": "287-11-33",
    "owner1": "SULLIVAN, TIMOTHY ET AL",
    "owner2": "C/O AP NEW DELHI BUREAU",
    "current_taxes": 4158.46,
    "new_taxes_no_override": 4338.11,
    "override_total_1": 4461.2,
    "override_increase_1": 123.09
  },
  {
    "#": "44 Washington St, Unit 907&P284 (287-11-34)",
    "$": 469400,
    "address": "44 Washington St, Unit 907&P284",
    "parcel_id": "287-11-34",
    "owner1": "KIM, DOO YEON",
    "owner2": "LEE, DONG EUN",
    "current_taxes": 4806.66,
    "new_taxes_no_override": 5014.31,
    "override_total_1": 5156.58,
    "override_increase_1": 142.28
  },
  {
    "#": "44 Washington St, Unit 908 (287-11-35)",
    "$": 358400,
    "address": "44 Washington St, Unit 908",
    "parcel_id": "287-11-35",
    "owner1": "CHANG, BAOLIN",
    "owner2": "WANG, YOUPING",
    "current_taxes": 3670.02,
    "new_taxes_no_override": 3828.56,
    "override_total_1": 3937.2,
    "override_increase_1": 108.63
  },
  {
    "#": "44 Washington St, Unit 909 (287-11-36)",
    "$": 419700,
    "address": "44 Washington St, Unit 909",
    "parcel_id": "287-11-36",
    "owner1": "BAUTISTA TR, VIRGINIA L",
    "owner2": "",
    "current_taxes": 4297.73,
    "new_taxes_no_override": 4483.39,
    "override_total_1": 4610.6,
    "override_increase_1": 127.21
  },
  {
    "#": "44 Washington St, Unit 910 & P450 (287-11-37)",
    "$": 444500,
    "address": "44 Washington St, Unit 910 & P450",
    "parcel_id": "287-11-37",
    "owner1": "TANZER TR, KEVIN",
    "owner2": "",
    "current_taxes": 4551.68,
    "new_taxes_no_override": 4748.31,
    "override_total_1": 4883.04,
    "override_increase_1": 134.73
  },
  {
    "#": "44 Washington St, Unit 911 & P606 (287-11-38)",
    "$": 444500,
    "address": "44 Washington St, Unit 911 & P606",
    "parcel_id": "287-11-38",
    "owner1": "SHTIFTER, ZVI",
    "owner2": "",
    "current_taxes": 4551.68,
    "new_taxes_no_override": 4748.31,
    "override_total_1": 4883.04,
    "override_increase_1": 134.73
  },
  {
    "#": "44 Washington St, Unit 912 (287-11-39)",
    "$": 406200,
    "address": "44 Washington St, Unit 912",
    "parcel_id": "287-11-39",
    "owner1": "RUDITSKY PROPERTY MANAGEMENT LLC",
    "owner2": "",
    "current_taxes": 4159.49,
    "new_taxes_no_override": 4339.18,
    "override_total_1": 4462.3,
    "override_increase_1": 123.12
  },
  {
    "#": "44 Washington St, Unit 913 (287-11-40)",
    "$": 401600,
    "address": "44 Washington St, Unit 913",
    "parcel_id": "287-11-40",
    "owner1": "DESMOND, RALPH",
    "owner2": "",
    "current_taxes": 4112.38,
    "new_taxes_no_override": 4290.03,
    "override_total_1": 4411.76,
    "override_increase_1": 121.73
  },
  {
    "#": "44 Washington St, Unit 914 (287-11-41)",
    "$": 358400,
    "address": "44 Washington St, Unit 914",
    "parcel_id": "287-11-41",
    "owner1": "LIU, BOTAO",
    "owner2": "YUAN, YIFAN",
    "current_taxes": 3670.02,
    "new_taxes_no_override": 3828.56,
    "override_total_1": 3937.2,
    "override_increase_1": 108.63
  },
  {
    "#": "44 Washington St, Unit 915 (287-11-42)",
    "$": 392100,
    "address": "44 Washington St, Unit 915",
    "parcel_id": "287-11-42",
    "owner1": "SILBERSTEIN, DANA J",
    "owner2": "",
    "current_taxes": 4015.1,
    "new_taxes_no_override": 4188.55,
    "override_total_1": 4307.4,
    "override_increase_1": 118.85
  },
  {
    "#": "44 Washington St, Unit 916 & P662 (287-11-43)",
    "$": 444500,
    "address": "44 Washington St, Unit 916 & P662",
    "parcel_id": "287-11-43",
    "owner1": "KRAM HOLDING LLC",
    "owner2": "",
    "current_taxes": 4551.68,
    "new_taxes_no_override": 4748.31,
    "override_total_1": 4883.04,
    "override_increase_1": 134.73
  },
  {
    "#": "44 Washington St, Unit 917 & P420 (287-11-44)",
    "$": 509200,
    "address": "44 Washington St, Unit 917 & P420",
    "parcel_id": "287-11-44",
    "owner1": "LERNER, LORENA",
    "owner2": "ROSEMBERG, ELIAS",
    "current_taxes": 5214.21,
    "new_taxes_no_override": 5439.46,
    "override_total_1": 5593.8,
    "override_increase_1": 154.34
  },
  {
    "#": "44 Washington St, Unit 918 & P145 (287-11-45)",
    "$": 560900,
    "address": "44 Washington St, Unit 918 & P145",
    "parcel_id": "287-11-45",
    "owner1": "BLANCHARD, NANCY",
    "owner2": "",
    "current_taxes": 5743.62,
    "new_taxes_no_override": 5991.74,
    "override_total_1": 6161.76,
    "override_increase_1": 170.01
  },
  {
    "#": "44 Washington St, Unit Nr-103A (287-18-26)",
    "$": 2305900,
    "address": "44 Washington St, Unit Nr-103A",
    "parcel_id": "287-18-26",
    "owner1": "BEPS REALTY LLC",
    "owner2": "",
    "current_taxes": 39569.24,
    "new_taxes_no_override": 41278.63,
    "override_total_1": 42449.88,
    "override_increase_1": 1171.25
  },
  {
    "#": "44 Washington St, Unit Nr-104A (287-18-27)",
    "$": 560300,
    "address": "44 Washington St, Unit Nr-104A",
    "parcel_id": "287-18-27",
    "owner1": "ZHOU TRS, YING",
    "owner2": "XU, GUANG LI",
    "current_taxes": 9614.75,
    "new_taxes_no_override": 10030.11,
    "override_total_1": 10314.7,
    "override_increase_1": 284.6
  },
  {
    "#": "44 Washington St, Unit Nr-105A (287-18-28)",
    "$": 736100,
    "address": "44 Washington St, Unit Nr-105A",
    "parcel_id": "287-18-28",
    "owner1": "BEPS REALTY LLC",
    "owner2": "",
    "current_taxes": 12631.48,
    "new_taxes_no_override": 13177.16,
    "override_total_1": 13551.05,
    "override_increase_1": 373.89
  },
  {
    "#": "44 Washington St, Unit Nr-106A (287-18-29)",
    "$": 1088500,
    "address": "44 Washington St, Unit Nr-106A",
    "parcel_id": "287-18-29",
    "owner1": "GOLDEN REALTY LLC",
    "owner2": "",
    "current_taxes": 18678.66,
    "new_taxes_no_override": 19485.58,
    "override_total_1": 20038.47,
    "override_increase_1": 552.89
  },
  {
    "#": "44 Washington St, Unit Nr-2 (287-10-01)",
    "$": 465600,
    "address": "44 Washington St, Unit Nr-2",
    "parcel_id": "287-10-01",
    "owner1": "SANDERSON, ROBERT G",
    "owner2": "",
    "current_taxes": 7989.7,
    "new_taxes_no_override": 8334.86,
    "override_total_1": 8571.35,
    "override_increase_1": 236.5
  },
  {
    "#": "44 Washington St, Unit P-144 (287-17-89)",
    "$": 60000,
    "address": "44 Washington St, Unit P-144",
    "parcel_id": "287-17-89",
    "owner1": "LAM, CARRIE",
    "owner2": "",
    "current_taxes": 614.4,
    "new_taxes_no_override": 640.94,
    "override_total_1": 659.13,
    "override_increase_1": 18.19
  },
  {
    "#": "44 Washington St, Unit P-170 (287-18-10)",
    "$": 60000,
    "address": "44 Washington St, Unit P-170",
    "parcel_id": "287-18-10",
    "owner1": "YEO, PENG CHYE & TAN POH MOI",
    "owner2": "C/O SMITH",
    "current_taxes": 614.4,
    "new_taxes_no_override": 640.94,
    "override_total_1": 659.13,
    "override_increase_1": 18.19
  },
  {
    "#": "44 Washington St, Unit P-221 (287-18-05)",
    "$": 60000,
    "address": "44 Washington St, Unit P-221",
    "parcel_id": "287-18-05",
    "owner1": "FAN, VICTOR & ANGELA",
    "owner2": "",
    "current_taxes": 614.4,
    "new_taxes_no_override": 640.94,
    "override_total_1": 659.13,
    "override_increase_1": 18.19
  },
  {
    "#": "44 Washington St, Unit P212 (287-18-61)",
    "$": 60000,
    "address": "44 Washington St, Unit P212",
    "parcel_id": "287-18-61",
    "owner1": "HOU, GUAN R",
    "owner2": "ZHENG, CHEN J",
    "current_taxes": 614.4,
    "new_taxes_no_override": 640.94,
    "override_total_1": 659.13,
    "override_increase_1": 18.19
  },
  {
    "#": "44 Washington St, Unit P247 (287-18-56)",
    "$": 60000,
    "address": "44 Washington St, Unit P247",
    "parcel_id": "287-18-56",
    "owner1": "PACSON TR, MARIO P",
    "owner2": "",
    "current_taxes": 614.4,
    "new_taxes_no_override": 640.94,
    "override_total_1": 659.13,
    "override_increase_1": 18.19
  },
  {
    "#": "44 Washington St, Unit P253 (287-18-79)",
    "$": 61900,
    "address": "44 Washington St, Unit P253",
    "parcel_id": "287-18-79",
    "owner1": "HATTORI, MIKIYO",
    "owner2": "",
    "current_taxes": 633.86,
    "new_taxes_no_override": 661.24,
    "override_total_1": 680.01,
    "override_increase_1": 18.76
  },
  {
    "#": "44 Washington St, Unit P262 (287-18-65)",
    "$": 60000,
    "address": "44 Washington St, Unit P262",
    "parcel_id": "287-18-65",
    "owner1": "CRANDALL JR, JOEL",
    "owner2": "",
    "current_taxes": 614.4,
    "new_taxes_no_override": 640.94,
    "override_total_1": 659.13,
    "override_increase_1": 18.19
  },
  {
    "#": "44 Washington St, Unit P325 (287-18-64)",
    "$": 60000,
    "address": "44 Washington St, Unit P325",
    "parcel_id": "287-18-64",
    "owner1": "REVZIN TR, MARC W",
    "owner2": "",
    "current_taxes": 614.4,
    "new_taxes_no_override": 640.94,
    "override_total_1": 659.13,
    "override_increase_1": 18.19
  },
  {
    "#": "44 Washington St, Unit P370 (287-18-78)",
    "$": 61900,
    "address": "44 Washington St, Unit P370",
    "parcel_id": "287-18-78",
    "owner1": "CHANG, BAOLIN",
    "owner2": "",
    "current_taxes": 633.86,
    "new_taxes_no_override": 661.24,
    "override_total_1": 680.01,
    "override_increase_1": 18.76
  },
  {
    "#": "44 Washington St, Unit P379A&B (287-18-58)",
    "$": 90000,
    "address": "44 Washington St, Unit P379A&B",
    "parcel_id": "287-18-58",
    "owner1": "SINGER, BARBARA",
    "owner2": "",
    "current_taxes": 921.6,
    "new_taxes_no_override": 961.41,
    "override_total_1": 988.69,
    "override_increase_1": 27.28
  },
  {
    "#": "44 Washington St, Unit P388 (287-18-70)",
    "$": 60000,
    "address": "44 Washington St, Unit P388",
    "parcel_id": "287-18-70",
    "owner1": "REISS, ROBIN",
    "owner2": "",
    "current_taxes": 614.4,
    "new_taxes_no_override": 640.94,
    "override_total_1": 659.13,
    "override_increase_1": 18.19
  },
  {
    "#": "44 Washington St, Unit P452 (287-18-73)",
    "$": 63500,
    "address": "44 Washington St, Unit P452",
    "parcel_id": "287-18-73",
    "owner1": "SELIM, ALFREDO J C & MARIA A",
    "owner2": "",
    "current_taxes": 650.24,
    "new_taxes_no_override": 678.33,
    "override_total_1": 697.58,
    "override_increase_1": 19.25
  },
  {
    "#": "44 Washington St, Unit P474 (287-18-86)",
    "$": 58500,
    "address": "44 Washington St, Unit P474",
    "parcel_id": "287-18-86",
    "owner1": "KARAGIANNIS, PANAGIOTIS",
    "owner2": "",
    "current_taxes": 599.04,
    "new_taxes_no_override": 624.92,
    "override_total_1": 642.65,
    "override_increase_1": 17.73
  },
  {
    "#": "44 Washington St, Unit P593 (287-18-63)",
    "$": 60000,
    "address": "44 Washington St, Unit P593",
    "parcel_id": "287-18-63",
    "owner1": "CHEN, CHUNG-YANG",
    "owner2": "",
    "current_taxes": 614.4,
    "new_taxes_no_override": 640.94,
    "override_total_1": 659.13,
    "override_increase_1": 18.19
  },
  {
    "#": "44 Washington St, Unit P598 (287-18-77)",
    "$": 61900,
    "address": "44 Washington St, Unit P598",
    "parcel_id": "287-18-77",
    "owner1": "CHANG, BAOLIN",
    "owner2": "WANG, YOUPING",
    "current_taxes": 633.86,
    "new_taxes_no_override": 661.24,
    "override_total_1": 680.01,
    "override_increase_1": 18.76
  },
  {
    "#": "44 Washington St, Unit P647 (287-18-62)",
    "$": 60000,
    "address": "44 Washington St, Unit P647",
    "parcel_id": "287-18-62",
    "owner1": "DUBOVSKIY, YAKOV",
    "owner2": "NEMIROVSKAYA, LYUDMILA",
    "current_taxes": 614.4,
    "new_taxes_no_override": 640.94,
    "override_total_1": 659.13,
    "override_increase_1": 18.19
  },
  {
    "#": "44 Washington St, Unit P649 (287-18-59)",
    "$": 60000,
    "address": "44 Washington St, Unit P649",
    "parcel_id": "287-18-59",
    "owner1": "GOLDSTEIN, DAVID E",
    "owner2": "",
    "current_taxes": 614.4,
    "new_taxes_no_override": 640.94,
    "override_total_1": 659.13,
    "override_increase_1": 18.19
  },
  {
    "#": "44 Washington St, Unit P663 (287-18-67)",
    "$": 60000,
    "address": "44 Washington St, Unit P663",
    "parcel_id": "287-18-67",
    "owner1": "WARAT, LAURA M",
    "owner2": "",
    "current_taxes": 614.4,
    "new_taxes_no_override": 640.94,
    "override_total_1": 659.13,
    "override_increase_1": 18.19
  },
  {
    "#": "44 Washington St, Unit P683 (287-18-68)",
    "$": 60000,
    "address": "44 Washington St, Unit P683",
    "parcel_id": "287-18-68",
    "owner1": "RAMOS, EVELYN",
    "owner2": "",
    "current_taxes": 614.4,
    "new_taxes_no_override": 640.94,
    "override_total_1": 659.13,
    "override_increase_1": 18.19
  },
  {
    "#": "55 Washington St, Unit Nr-101E (287-18-22)",
    "$": 421400,
    "address": "55 Washington St, Unit Nr-101E",
    "parcel_id": "287-18-22",
    "owner1": "STATION 34 REAL ESTATE LLC",
    "owner2": "",
    "current_taxes": 7231.22,
    "new_taxes_no_override": 7543.61,
    "override_total_1": 7757.65,
    "override_increase_1": 214.04
  },
  {
    "#": "55 Washington St, Unit Nr-102E (287-18-23)",
    "$": 273500,
    "address": "55 Washington St, Unit Nr-102E",
    "parcel_id": "287-18-23",
    "owner1": "KICO, TOLI & EVDHOKSI",
    "owner2": "",
    "current_taxes": 4693.26,
    "new_taxes_no_override": 4896.01,
    "override_total_1": 5034.93,
    "override_increase_1": 138.92
  },
  {
    "#": "55 Washington St, Unit Nr-103E (287-18-81)",
    "$": 628200,
    "address": "55 Washington St, Unit Nr-103E",
    "parcel_id": "287-18-81",
    "owner1": "THE TRUSTEES OF THE BROOK HOUSE CONDO TRUST",
    "owner2": "",
    "current_taxes": 10779.91,
    "new_taxes_no_override": 11245.6,
    "override_total_1": 11564.69,
    "override_increase_1": 319.09
  },
  {
    "#": "55 Washington St, Unit Nr-104E (287-18-25)",
    "$": 356200,
    "address": "55 Washington St, Unit Nr-104E",
    "parcel_id": "287-18-25",
    "owner1": "WIN INTERNATIONAL LLC",
    "owner2": "",
    "current_taxes": 6112.39,
    "new_taxes_no_override": 6376.45,
    "override_total_1": 6557.37,
    "override_increase_1": 180.93
  },
  {
    "#": "55 Washington St, Unit Nr-105E (287-18-82)",
    "$": 595700,
    "address": "55 Washington St, Unit Nr-105E",
    "parcel_id": "287-18-82",
    "owner1": "THE TRUSTEES OF THE BROOK HOUSE CONDOMINIUM TRUST",
    "owner2": "",
    "current_taxes": 10222.21,
    "new_taxes_no_override": 10663.81,
    "override_total_1": 10966.39,
    "override_increase_1": 302.58
  },
  {
    "#": "55 Washington St, Unit Nr-201E (287-18-83)",
    "$": 2084800,
    "address": "55 Washington St, Unit Nr-201E",
    "parcel_id": "287-18-83",
    "owner1": "AVK REALTY LLC",
    "owner2": "",
    "current_taxes": 35775.17,
    "new_taxes_no_override": 37320.66,
    "override_total_1": 38379.6,
    "override_increase_1": 1058.95
  },
  {
    "#": "55 Washington St, Unit Nr-202E (287-18-84)",
    "$": 877500,
    "address": "55 Washington St, Unit Nr-202E",
    "parcel_id": "287-18-84",
    "owner1": "ATLANTIC BROOKHOUSE REALTY LLC",
    "owner2": "",
    "current_taxes": 15057.9,
    "new_taxes_no_override": 15708.4,
    "override_total_1": 16154.12,
    "override_increase_1": 445.71
  },
  {
    "#": "140 Washington St (293-01-00)",
    "$": 4352500,
    "address": "140 Washington St",
    "parcel_id": "293-01-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O FIRE STATION #1",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "160 Washington St (185-02-00)",
    "$": 4521100,
    "address": "160 Washington St",
    "parcel_id": "185-02-00",
    "owner1": "WASHINGTON 160 LLC",
    "owner2": "",
    "current_taxes": 77582.08,
    "new_taxes_no_override": 80933.63,
    "override_total_1": 83230.06,
    "override_increase_1": 2296.43
  },
  {
    "#": "176 Washington St (185-01-00)",
    "$": 1020400,
    "address": "176 Washington St",
    "parcel_id": "185-01-00",
    "owner1": "WASHINGTON 160 LLC",
    "owner2": "",
    "current_taxes": 17510.06,
    "new_taxes_no_override": 18266.49,
    "override_total_1": 18784.79,
    "override_increase_1": 518.3
  },
  {
    "#": "190 Washington St (183-18-00)",
    "$": 2589800,
    "address": "190 Washington St",
    "parcel_id": "183-18-00",
    "owner1": "190-200 WASHINGTON STREET LLC",
    "owner2": "",
    "current_taxes": 44440.97,
    "new_taxes_no_override": 46360.82,
    "override_total_1": 47676.27,
    "override_increase_1": 1315.45
  },
  {
    "#": "202 Washington St (183-17-00)",
    "$": 2280100,
    "address": "202 Washington St",
    "parcel_id": "183-17-00",
    "owner1": "WASHINGTON 202 LLC",
    "owner2": "C/O SHANNON LISS-RIORDAN",
    "current_taxes": 39126.52,
    "new_taxes_no_override": 40816.79,
    "override_total_1": 41974.93,
    "override_increase_1": 1158.14
  },
  {
    "#": "207 Washington St (140-08-00)",
    "$": 6247700,
    "address": "207 Washington St",
    "parcel_id": "140-08-00",
    "owner1": "WARREN PROPERTIES GROUP LLC",
    "owner2": "C/O MICHAEL SHASHOUA",
    "current_taxes": 80837.62,
    "new_taxes_no_override": 84329.81,
    "override_total_1": 86722.6,
    "override_increase_1": 2392.79
  },
  {
    "#": "214 Washington St (183-16-00)",
    "$": 1528800,
    "address": "214 Washington St",
    "parcel_id": "183-16-00",
    "owner1": "ASIMAKOPOULOS TRS, JOHN HELEN DIMITRIOS & HELEN A",
    "owner2": "",
    "current_taxes": 26234.21,
    "new_taxes_no_override": 27367.53,
    "override_total_1": 28144.06,
    "override_increase_1": 776.53
  },
  {
    "#": "217 Washington St (140-08-01)",
    "$": 6117200,
    "address": "217 Washington St",
    "parcel_id": "140-08-01",
    "owner1": "WARREN PROPERTIES GROUP LLC",
    "owner2": "C/O MICHAEL SHASHOUA",
    "current_taxes": 77522.49,
    "new_taxes_no_override": 80871.46,
    "override_total_1": 83166.13,
    "override_increase_1": 2294.67
  },
  {
    "#": "220 Washington St, Unit 1 (183-15-01)",
    "$": 680100,
    "address": "220 Washington St, Unit 1",
    "parcel_id": "183-15-01",
    "owner1": "YEE TR, GEORGE S",
    "owner2": "",
    "current_taxes": 11670.52,
    "new_taxes_no_override": 12174.69,
    "override_total_1": 12520.13,
    "override_increase_1": 345.45
  },
  {
    "#": "220 Washington St, Unit 2 (183-15-02)",
    "$": 681000,
    "address": "220 Washington St, Unit 2",
    "parcel_id": "183-15-02",
    "owner1": "WONG, TR, ERIC CHUN NING",
    "owner2": "",
    "current_taxes": 11685.96,
    "new_taxes_no_override": 12190.79,
    "override_total_1": 12536.7,
    "override_increase_1": 345.9
  },
  {
    "#": "220 Washington St, Unit 3 (183-15-03)",
    "$": 622500,
    "address": "220 Washington St, Unit 3",
    "parcel_id": "183-15-03",
    "owner1": "DUFFY, PATRICK",
    "owner2": "OGORMAN, SALLY",
    "current_taxes": 2739.47,
    "new_taxes_no_override": 2857.82,
    "override_total_1": 2938.9,
    "override_increase_1": 81.09
  },
  {
    "#": "220 Washington St, Unit 4 & 4 Pk Sps (183-15-04)",
    "$": 738500,
    "address": "220 Washington St, Unit 4 & 4 Pk Sps",
    "parcel_id": "183-15-04",
    "owner1": "CHIN, BEN",
    "owner2": "",
    "current_taxes": 7562.24,
    "new_taxes_no_override": 7888.93,
    "override_total_1": 8112.77,
    "override_increase_1": 223.84
  },
  {
    "#": "220 Washington St, Unit 5 (183-15-05)",
    "$": 621300,
    "address": "220 Washington St, Unit 5",
    "parcel_id": "183-15-05",
    "owner1": "HUA, XIANGHONG",
    "owner2": "",
    "current_taxes": 6362.11,
    "new_taxes_no_override": 6636.95,
    "override_total_1": 6825.27,
    "override_increase_1": 188.32
  },
  {
    "#": "220 Washington St, Unit 6 (183-15-06)",
    "$": 648700,
    "address": "220 Washington St, Unit 6",
    "parcel_id": "183-15-06",
    "owner1": "ROSENBERG, SARAH H",
    "owner2": "",
    "current_taxes": 3007.75,
    "new_taxes_no_override": 3137.68,
    "override_total_1": 3226.71,
    "override_increase_1": 89.03
  },
  {
    "#": "220 Washington St, Unit 7 (183-15-07)",
    "$": 599700,
    "address": "220 Washington St, Unit 7",
    "parcel_id": "183-15-07",
    "owner1": "SALEM, HANA ABU KHADRA",
    "owner2": "",
    "current_taxes": 6140.93,
    "new_taxes_no_override": 6406.22,
    "override_total_1": 6587.99,
    "override_increase_1": 181.77
  },
  {
    "#": "220 Washington St, Unit 8 (183-15-08)",
    "$": 580400,
    "address": "220 Washington St, Unit 8",
    "parcel_id": "183-15-08",
    "owner1": "CHIN TRS, YENNY W Y & RODERICK",
    "owner2": "",
    "current_taxes": 2308.36,
    "new_taxes_no_override": 2408.08,
    "override_total_1": 2476.41,
    "override_increase_1": 68.33
  },
  {
    "#": "231 Washington St, Unit 231-2 (140-08-03)",
    "$": 652700,
    "address": "231 Washington St, Unit 231-2",
    "parcel_id": "140-08-03",
    "owner1": "BARSTOW, JOHN A & LISA A",
    "owner2": "",
    "current_taxes": 3048.71,
    "new_taxes_no_override": 3180.41,
    "override_total_1": 3270.66,
    "override_increase_1": 90.24
  },
  {
    "#": "231 Washington St, Unit 231-3 (140-08-04)",
    "$": 683500,
    "address": "231 Washington St, Unit 231-3",
    "parcel_id": "140-08-04",
    "owner1": "ABUKHADRA, HANA",
    "owner2": "SALEM, KARMA",
    "current_taxes": 6999.04,
    "new_taxes_no_override": 7301.4,
    "override_total_1": 7508.57,
    "override_increase_1": 207.17
  },
  {
    "#": "231 Washington St, Unit 231-4 (140-08-05)",
    "$": 679700,
    "address": "231 Washington St, Unit 231-4",
    "parcel_id": "140-08-05",
    "owner1": "SURI, SAHIL",
    "owner2": "",
    "current_taxes": 6960.13,
    "new_taxes_no_override": 7260.81,
    "override_total_1": 7466.83,
    "override_increase_1": 206.02
  },
  {
    "#": "233 Washington St, Unit 233-1 (140-08-06)",
    "$": 685000,
    "address": "233 Washington St, Unit 233-1",
    "parcel_id": "140-08-06",
    "owner1": "CZHAKOV, NILLI",
    "owner2": "",
    "current_taxes": 11754.6,
    "new_taxes_no_override": 12262.4,
    "override_total_1": 12610.33,
    "override_increase_1": 347.94
  },
  {
    "#": "235 Washington St, Unit 235-2 (140-08-07)",
    "$": 669700,
    "address": "235 Washington St, Unit 235-2",
    "parcel_id": "140-08-07",
    "owner1": "WU, MIN",
    "owner2": "",
    "current_taxes": 6857.73,
    "new_taxes_no_override": 7153.98,
    "override_total_1": 7356.97,
    "override_increase_1": 202.99
  },
  {
    "#": "235 Washington St, Unit 235-3 (140-08-08)",
    "$": 701800,
    "address": "235 Washington St, Unit 235-3",
    "parcel_id": "140-08-08",
    "owner1": "SHAW TRS, GREGORY R & MAUREEN",
    "owner2": "",
    "current_taxes": 7186.43,
    "new_taxes_no_override": 7496.88,
    "override_total_1": 7709.6,
    "override_increase_1": 212.72
  },
  {
    "#": "235 Washington St, Unit 235-4 (140-08-09)",
    "$": 596200,
    "address": "235 Washington St, Unit 235-4",
    "parcel_id": "140-08-09",
    "owner1": "WANG, LINA",
    "owner2": "",
    "current_taxes": 6105.09,
    "new_taxes_no_override": 6368.83,
    "override_total_1": 6549.54,
    "override_increase_1": 180.71
  },
  {
    "#": "236 Washington St (183-12-00)",
    "$": 7954700,
    "address": "236 Washington St",
    "parcel_id": "183-12-00",
    "owner1": "LOTMAN ET AL TRS, HANK",
    "owner2": "C/O TUCK RICHARD",
    "current_taxes": 101271.41,
    "new_taxes_no_override": 105646.33,
    "override_total_1": 108643.97,
    "override_increase_1": 2997.63
  },
  {
    "#": "237 Washington St, Unit 237-1 (140-08-10)",
    "$": 729600,
    "address": "237 Washington St, Unit 237-1",
    "parcel_id": "140-08-10",
    "owner1": "237 WASHINGTON LLC",
    "owner2": "ALBERT HYMAN",
    "current_taxes": 12519.94,
    "new_taxes_no_override": 13060.8,
    "override_total_1": 13431.39,
    "override_increase_1": 370.59
  },
  {
    "#": "239 Washington St, Unit 239-2 (140-08-11)",
    "$": 526000,
    "address": "239 Washington St, Unit 239-2",
    "parcel_id": "140-08-11",
    "owner1": "PERSIO, ELLEN",
    "owner2": "",
    "current_taxes": 1751.31,
    "new_taxes_no_override": 1826.97,
    "override_total_1": 1878.81,
    "override_increase_1": 51.84
  },
  {
    "#": "239 Washington St, Unit 239-3 (140-08-12)",
    "$": 535000,
    "address": "239 Washington St, Unit 239-3",
    "parcel_id": "140-08-12",
    "owner1": "DOLMA, PASSANG",
    "owner2": "",
    "current_taxes": 5478.4,
    "new_taxes_no_override": 5715.07,
    "override_total_1": 5877.23,
    "override_increase_1": 162.16
  },
  {
    "#": "239 Washington St, Unit 239-4 (140-08-13)",
    "$": 534400,
    "address": "239 Washington St, Unit 239-4",
    "parcel_id": "140-08-13",
    "owner1": "SHI, GUO-PING",
    "owner2": "DU, JUAN",
    "current_taxes": 5472.26,
    "new_taxes_no_override": 5708.66,
    "override_total_1": 5870.64,
    "override_increase_1": 161.98
  },
  {
    "#": "241 Washington St, Unit 241-1 (140-08-14)",
    "$": 635400,
    "address": "241 Washington St, Unit 241-1",
    "parcel_id": "140-08-14",
    "owner1": "241 WASHINGTON STREET LLC",
    "owner2": "",
    "current_taxes": 10903.46,
    "new_taxes_no_override": 11374.49,
    "override_total_1": 11697.23,
    "override_increase_1": 322.74
  },
  {
    "#": "256 Washington St (176-01-00)",
    "$": 6061500,
    "address": "256 Washington St",
    "parcel_id": "176-01-00",
    "owner1": "KCEKOB LLC",
    "owner2": "",
    "current_taxes": 72556.16,
    "new_taxes_no_override": 75690.59,
    "override_total_1": 77838.25,
    "override_increase_1": 2147.66
  },
  {
    "#": "264 Washington St (176-34-00)",
    "$": 1878300,
    "address": "264 Washington St",
    "parcel_id": "176-34-00",
    "owner1": "RUIZ & RODRIGUEZ REALTY LLC",
    "owner2": "",
    "current_taxes": 32231.63,
    "new_taxes_no_override": 33624.04,
    "override_total_1": 34578.09,
    "override_increase_1": 954.06
  },
  {
    "#": "274 Washington St (176-33-00)",
    "$": 2811100,
    "address": "274 Washington St",
    "parcel_id": "176-33-00",
    "owner1": "274-278 WASHINGTON LLC",
    "owner2": "C/O THRIVE REALTY PARTNERS",
    "current_taxes": 35382.35,
    "new_taxes_no_override": 36910.87,
    "override_total_1": 37958.19,
    "override_increase_1": 1047.32
  },
  {
    "#": "279 Washington St (174-03-06)",
    "$": 8521700,
    "address": "279 Washington St",
    "parcel_id": "174-03-06",
    "owner1": "RODMAN TR, DOUGLAS S",
    "owner2": "",
    "current_taxes": 146232.37,
    "new_taxes_no_override": 152549.61,
    "override_total_1": 156878.09,
    "override_increase_1": 4328.48
  },
  {
    "#": "280 Washington St (176-32-00)",
    "$": 3869900,
    "address": "280 Washington St",
    "parcel_id": "176-32-00",
    "owner1": "LEE TRS, KEVIN",
    "owner2": "SUN, LI JUAN",
    "current_taxes": 49804.05,
    "new_taxes_no_override": 51955.58,
    "override_total_1": 53429.78,
    "override_increase_1": 1474.2
  },
  {
    "#": "288 Washington St (176-30-00)",
    "$": 2013600,
    "address": "288 Washington St",
    "parcel_id": "176-30-00",
    "owner1": "300 WASHINGTON ST LLC",
    "owner2": "",
    "current_taxes": 34553.38,
    "new_taxes_no_override": 36046.09,
    "override_total_1": 37068.87,
    "override_increase_1": 1022.78
  },
  {
    "#": "295 Washington St (174-07-00)",
    "$": 1667800,
    "address": "295 Washington St",
    "parcel_id": "174-07-00",
    "owner1": "HSU TRS, PING H & HSIU M",
    "owner2": "",
    "current_taxes": 28619.45,
    "new_taxes_no_override": 29855.81,
    "override_total_1": 30702.95,
    "override_increase_1": 847.14
  },
  {
    "#": "300 Washington St (176-29-00)",
    "$": 3192900,
    "address": "300 Washington St",
    "parcel_id": "176-29-00",
    "owner1": "300 WASHINGTON STREET LLC",
    "owner2": "",
    "current_taxes": 49266.27,
    "new_taxes_no_override": 51394.57,
    "override_total_1": 52852.85,
    "override_increase_1": 1458.28
  },
  {
    "#": "303 Washington St (174-07-01)",
    "$": 1716600,
    "address": "303 Washington St",
    "parcel_id": "174-07-01",
    "owner1": "ASLANIDIS TRS, FOTINI",
    "owner2": "GERASIMIDIS TRS, EVYENIA & ILIAS",
    "current_taxes": 29456.86,
    "new_taxes_no_override": 30729.4,
    "override_total_1": 31601.32,
    "override_increase_1": 871.92
  },
  {
    "#": "306 Washington St (176-27-28)",
    "$": 2619100,
    "address": "306 Washington St",
    "parcel_id": "176-27-28",
    "owner1": "MALLIOS, ANASTASIOS & CHRISTINE",
    "owner2": "",
    "current_taxes": 36996.03,
    "new_taxes_no_override": 38594.26,
    "override_total_1": 39689.34,
    "override_increase_1": 1095.08
  },
  {
    "#": "311 Washington St (174-08-00)",
    "$": 3414500,
    "address": "311 Washington St",
    "parcel_id": "174-08-00",
    "owner1": "HARTIGAN, JOSEPH A",
    "owner2": "",
    "current_taxes": 58592.82,
    "new_taxes_no_override": 61124.03,
    "override_total_1": 62858.38,
    "override_increase_1": 1734.35
  },
  {
    "#": "316 Washington St (176-26-00)",
    "$": 11541100,
    "address": "316 Washington St",
    "parcel_id": "176-26-00",
    "owner1": "SANIEOFF, TRS, KHOSRO & SYROOS",
    "owner2": "",
    "current_taxes": 198045.28,
    "new_taxes_no_override": 206600.84,
    "override_total_1": 212462.98,
    "override_increase_1": 5862.14
  },
  {
    "#": "322 Washington St (176-25-00)",
    "$": 11588900,
    "address": "322 Washington St",
    "parcel_id": "176-25-00",
    "owner1": "322 WASHINGTON STREET HOLDINGS LLC",
    "owner2": "C/O TREMONT ASSET MGMT LLC",
    "current_taxes": 198865.52,
    "new_taxes_no_override": 207456.51,
    "override_total_1": 213342.93,
    "override_increase_1": 5886.42
  },
  {
    "#": "328 Washington St (176-24-00)",
    "$": 2317600,
    "address": "328 Washington St",
    "parcel_id": "176-24-00",
    "owner1": "KOZLEK, THOMAS D",
    "owner2": "HERNANDEZ, LUNINGING",
    "current_taxes": 20097.29,
    "new_taxes_no_override": 20965.49,
    "override_total_1": 21560.37,
    "override_increase_1": 594.88
  },
  {
    "#": "330 Washington St (176-23-00)",
    "$": 2224800,
    "address": "330 Washington St",
    "parcel_id": "176-23-00",
    "owner1": "THOMAS JR, DAVID L ET AL",
    "owner2": "C/O CHARLESGATE PROPERTY MGMT",
    "current_taxes": 22781.95,
    "new_taxes_no_override": 23766.13,
    "override_total_1": 24440.48,
    "override_increase_1": 674.35
  },
  {
    "#": "332 Washington St, Unit 1 (176-22-01)",
    "$": 546100,
    "address": "332 Washington St, Unit 1",
    "parcel_id": "176-22-01",
    "owner1": "HO TR, WIDDY S",
    "owner2": "",
    "current_taxes": 5592.06,
    "new_taxes_no_override": 5833.64,
    "override_total_1": 5999.16,
    "override_increase_1": 165.52
  },
  {
    "#": "332 Washington St, Unit 2 (176-22-02)",
    "$": 626800,
    "address": "332 Washington St, Unit 2",
    "parcel_id": "176-22-02",
    "owner1": "HO TR, WIDDY S",
    "owner2": "",
    "current_taxes": 2783.5,
    "new_taxes_no_override": 2903.75,
    "override_total_1": 2986.14,
    "override_increase_1": 82.39
  },
  {
    "#": "332 Washington St, Unit 3 (176-22-03)",
    "$": 1311600,
    "address": "332 Washington St, Unit 3",
    "parcel_id": "176-22-03",
    "owner1": "STOCK, PATRICK E",
    "owner2": "DEL MARMOL, JOSEFINA I",
    "current_taxes": 9795.85,
    "new_taxes_no_override": 10219.03,
    "override_total_1": 10508.99,
    "override_increase_1": 289.96
  },
  {
    "#": "333 Washington St (172-01-00)",
    "$": 40000000,
    "address": "333 Washington St",
    "parcel_id": "172-01-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O TOWN HALL",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "334 Washington St (176-21-01)",
    "$": 1395200,
    "address": "334 Washington St",
    "parcel_id": "176-21-01",
    "owner1": "BROOKLINE MUNICIPAL CREDIT UN",
    "owner2": "",
    "current_taxes": 23941.63,
    "new_taxes_no_override": 24975.91,
    "override_total_1": 25684.58,
    "override_increase_1": 708.67
  },
  {
    "#": "336 Washington St, Unit 1 (176-21-04)",
    "$": 940400,
    "address": "336 Washington St, Unit 1",
    "parcel_id": "176-21-04",
    "owner1": "FORDE, LESLIE M",
    "owner2": "",
    "current_taxes": 9629.7,
    "new_taxes_no_override": 10045.7,
    "override_total_1": 10330.74,
    "override_increase_1": 285.04
  },
  {
    "#": "336 Washington St, Unit 1A (176-21-08)",
    "$": 399800,
    "address": "336 Washington St, Unit 1A",
    "parcel_id": "176-21-08",
    "owner1": "SOMERS, M SHELEAGH",
    "owner2": "ALSOP, JONATHON",
    "current_taxes": 4093.95,
    "new_taxes_no_override": 4270.81,
    "override_total_1": 4391.99,
    "override_increase_1": 121.18
  },
  {
    "#": "336 Washington St, Unit 2 (176-21-05)",
    "$": 1039400,
    "address": "336 Washington St, Unit 2",
    "parcel_id": "176-21-05",
    "owner1": "MOUSSA, MARWAN",
    "owner2": "ELDAMATY, ALAN",
    "current_taxes": 7008.52,
    "new_taxes_no_override": 7311.29,
    "override_total_1": 7518.74,
    "override_increase_1": 207.45
  },
  {
    "#": "336 Washington St, Unit 3 (176-21-07)",
    "$": 1016300,
    "address": "336 Washington St, Unit 3",
    "parcel_id": "176-21-07",
    "owner1": "HANNA, PAUL",
    "owner2": "LINOS, NATALIA",
    "current_taxes": 10406.91,
    "new_taxes_no_override": 10856.49,
    "override_total_1": 11164.53,
    "override_increase_1": 308.04
  },
  {
    "#": "350 Washington St (177-01-00)",
    "$": 21835200,
    "address": "350 Washington St",
    "parcel_id": "177-01-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O PUBLIC SAFETY BUILDING",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "360 Washington St (177-47-00)",
    "$": 6650000,
    "address": "360 Washington St",
    "parcel_id": "177-47-00",
    "owner1": "NORFOLK COUNTY COMMISSIONERS",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "361 Washington St (172-02-00)",
    "$": 32967300,
    "address": "361 Washington St",
    "parcel_id": "172-02-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O LIBRARY/MAIN BRANCH",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "366 Washington St (177-46-00)",
    "$": 2122700,
    "address": "366 Washington St",
    "parcel_id": "177-46-00",
    "owner1": "THE CHRISTIAN COMMUNITY",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "370 Washington St (177-42-00)",
    "$": 2654900,
    "address": "370 Washington St",
    "parcel_id": "177-42-00",
    "owner1": "370 WASH LLC",
    "owner2": "",
    "current_taxes": 45558.08,
    "new_taxes_no_override": 47526.19,
    "override_total_1": 48874.71,
    "override_increase_1": 1348.52
  },
  {
    "#": "376 Washington St (177-41-00)",
    "$": 1927600,
    "address": "376 Washington St",
    "parcel_id": "177-41-00",
    "owner1": "ODEA, GEORGE T & MARIE P",
    "owner2": "",
    "current_taxes": 29879.19,
    "new_taxes_no_override": 31169.97,
    "override_total_1": 32054.4,
    "override_increase_1": 884.42
  },
  {
    "#": "378 Washington St (177-40-02)",
    "$": 1076600,
    "address": "378 Washington St",
    "parcel_id": "177-40-02",
    "owner1": "WANG, NAN",
    "owner2": "HUGHES, ALTON R",
    "current_taxes": 7389.45,
    "new_taxes_no_override": 7708.67,
    "override_total_1": 7927.4,
    "override_increase_1": 218.73
  },
  {
    "#": "380 Washington St (177-40-00)",
    "$": 2359900,
    "address": "380 Washington St",
    "parcel_id": "177-40-00",
    "owner1": "GANGAPUTRA, SACHIN",
    "owner2": "BHATIA, NEHA",
    "current_taxes": 20530.44,
    "new_taxes_no_override": 21417.36,
    "override_total_1": 22025.06,
    "override_increase_1": 607.7
  },
  {
    "#": "382 Washington St (177-40-01)",
    "$": 1235600,
    "address": "382 Washington St",
    "parcel_id": "177-40-01",
    "owner1": "MANSUETO, LISA",
    "owner2": "",
    "current_taxes": 9017.61,
    "new_taxes_no_override": 9407.17,
    "override_total_1": 9674.09,
    "override_increase_1": 266.92
  },
  {
    "#": "384 Washington St (177-39-00)",
    "$": 1538200,
    "address": "384 Washington St",
    "parcel_id": "177-39-00",
    "owner1": "BROOKLINE AL VFW BUILDINGS INC",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "385 Washington St (171-53-00)",
    "$": 4959000,
    "address": "385 Washington St",
    "parcel_id": "171-53-00",
    "owner1": "WARREN PROPERTIES GROUP LLC",
    "owner2": "C/O MICHAEL M SHASHOUA",
    "current_taxes": 85096.44,
    "new_taxes_no_override": 88772.61,
    "override_total_1": 91291.46,
    "override_increase_1": 2518.85
  },
  {
    "#": "390 Washington St (177-38-00)",
    "$": 2349400,
    "address": "390 Washington St",
    "parcel_id": "177-38-00",
    "owner1": "SIMBOLI, TR, ANTHONY C",
    "owner2": "",
    "current_taxes": 31699.54,
    "new_taxes_no_override": 33068.96,
    "override_total_1": 34007.27,
    "override_increase_1": 938.31
  },
  {
    "#": "399 Washington St, Unit 1 (171-53-31)",
    "$": 817400,
    "address": "399 Washington St, Unit 1",
    "parcel_id": "171-53-31",
    "owner1": "ALEXANDROV, BORISLAV",
    "owner2": "SATHYANARAYANA, AARTI",
    "current_taxes": 4735.24,
    "new_taxes_no_override": 4939.8,
    "override_total_1": 5079.97,
    "override_increase_1": 140.16
  },
  {
    "#": "399 Washington St, Unit 2 (171-53-02)",
    "$": 1011000,
    "address": "399 Washington St, Unit 2",
    "parcel_id": "171-53-02",
    "owner1": "ADMANIT, YISHAI & REUMA",
    "owner2": "",
    "current_taxes": 6717.71,
    "new_taxes_no_override": 7007.92,
    "override_total_1": 7206.76,
    "override_increase_1": 198.84
  },
  {
    "#": "399 Washington St, Unit 3 (171-53-03)",
    "$": 801800,
    "address": "399 Washington St, Unit 3",
    "parcel_id": "171-53-03",
    "owner1": "MA, XINU & SIYONG",
    "owner2": "",
    "current_taxes": 8210.43,
    "new_taxes_no_override": 8565.12,
    "override_total_1": 8808.15,
    "override_increase_1": 243.03
  },
  {
    "#": "399 Washington St, Unit 4 (171-53-04)",
    "$": 965900,
    "address": "399 Washington St, Unit 4",
    "parcel_id": "171-53-04",
    "owner1": "LUKATSKY, MICHAEL & EDWARD",
    "owner2": "",
    "current_taxes": 9890.82,
    "new_taxes_no_override": 10318.1,
    "override_total_1": 10610.87,
    "override_increase_1": 292.77
  },
  {
    "#": "399 Washington St, Unit 5 (171-53-05)",
    "$": 780400,
    "address": "399 Washington St, Unit 5",
    "parcel_id": "171-53-05",
    "owner1": "DENNISTON TR, DEAN K JR",
    "owner2": "",
    "current_taxes": 4356.36,
    "new_taxes_no_override": 4544.55,
    "override_total_1": 4673.5,
    "override_increase_1": 128.95
  },
  {
    "#": "399 Washington St, Unit 6 (171-53-06)",
    "$": 978400,
    "address": "399 Washington St, Unit 6",
    "parcel_id": "171-53-06",
    "owner1": "THUMMA, ERIC",
    "owner2": "LANE, COURTNEY D",
    "current_taxes": 6383.88,
    "new_taxes_no_override": 6659.66,
    "override_total_1": 6848.63,
    "override_increase_1": 188.96
  },
  {
    "#": "400 Washington St (200-15-01)",
    "$": 6900000,
    "address": "400 Washington St",
    "parcel_id": "200-15-01",
    "owner1": "QUINCY, TRS, RICHARD P & CHRISTOPHER T",
    "owner2": "C/O QUINCY & CO",
    "current_taxes": 118404.0,
    "new_taxes_no_override": 123519.05,
    "override_total_1": 127023.81,
    "override_increase_1": 3504.76
  },
  {
    "#": "401 Washington St, Unit 1 (171-53-07)",
    "$": 547900,
    "address": "401 Washington St, Unit 1",
    "parcel_id": "171-53-07",
    "owner1": "NAGYMANYOKI, ZOLTAN",
    "owner2": "ZHOU, YILAN",
    "current_taxes": 5610.5,
    "new_taxes_no_override": 5852.87,
    "override_total_1": 6018.94,
    "override_increase_1": 166.07
  },
  {
    "#": "401 Washington St, Unit 2 (171-53-08)",
    "$": 616000,
    "address": "401 Washington St, Unit 2",
    "parcel_id": "171-53-08",
    "owner1": "GOTHERS, THOMAS & ROSALBA",
    "owner2": "",
    "current_taxes": 2672.91,
    "new_taxes_no_override": 2788.38,
    "override_total_1": 2867.5,
    "override_increase_1": 79.12
  },
  {
    "#": "401 Washington St, Unit 3 (171-53-09)",
    "$": 563200,
    "address": "401 Washington St, Unit 3",
    "parcel_id": "171-53-09",
    "owner1": "COYLE, TR, JULIANA M",
    "owner2": "",
    "current_taxes": 2132.23,
    "new_taxes_no_override": 2224.34,
    "override_total_1": 2287.46,
    "override_increase_1": 63.11
  },
  {
    "#": "401 Washington St, Unit 4 (171-53-10)",
    "$": 614000,
    "address": "401 Washington St, Unit 4",
    "parcel_id": "171-53-10",
    "owner1": "CUI, KUIYUAN",
    "owner2": "LI, XIN",
    "current_taxes": 6287.36,
    "new_taxes_no_override": 6558.97,
    "override_total_1": 6745.08,
    "override_increase_1": 186.11
  },
  {
    "#": "401 Washington St, Unit 5 (171-53-11)",
    "$": 558500,
    "address": "401 Washington St, Unit 5",
    "parcel_id": "171-53-11",
    "owner1": "BRYKMAN, LAURIE Y",
    "owner2": "",
    "current_taxes": 5719.04,
    "new_taxes_no_override": 5966.1,
    "override_total_1": 6135.39,
    "override_increase_1": 169.28
  },
  {
    "#": "401 Washington St, Unit 6 (171-53-12)",
    "$": 696700,
    "address": "401 Washington St, Unit 6",
    "parcel_id": "171-53-12",
    "owner1": "ZHU, JIANQIAO",
    "owner2": "FAN, JINGJING",
    "current_taxes": 7134.21,
    "new_taxes_no_override": 7442.41,
    "override_total_1": 7653.58,
    "override_increase_1": 211.17
  },
  {
    "#": "403 Washington St, Unit 1 (171-53-13)",
    "$": 1055500,
    "address": "403 Washington St, Unit 1",
    "parcel_id": "171-53-13",
    "owner1": "CLARK, BRUCE H & JUDITH",
    "owner2": "",
    "current_taxes": 7173.39,
    "new_taxes_no_override": 7483.28,
    "override_total_1": 7695.61,
    "override_increase_1": 212.33
  },
  {
    "#": "403 Washington St, Unit 2 (171-53-14)",
    "$": 1011200,
    "address": "403 Washington St, Unit 2",
    "parcel_id": "171-53-14",
    "owner1": "PALMER, LOUISA & HENRY",
    "owner2": "",
    "current_taxes": 10354.69,
    "new_taxes_no_override": 10802.01,
    "override_total_1": 11108.51,
    "override_increase_1": 306.5
  },
  {
    "#": "403 Washington St, Unit 3 (171-53-15)",
    "$": 1016200,
    "address": "403 Washington St, Unit 3",
    "parcel_id": "171-53-15",
    "owner1": "BERNHARDT TR, LAURA J",
    "owner2": "",
    "current_taxes": 10405.89,
    "new_taxes_no_override": 10855.42,
    "override_total_1": 11163.44,
    "override_increase_1": 308.01
  },
  {
    "#": "403 Washington St, Unit 4 (171-53-16)",
    "$": 1021400,
    "address": "403 Washington St, Unit 4",
    "parcel_id": "171-53-16",
    "owner1": "GARCIA-MARCOS, MIKEL",
    "owner2": "LANGARIKA, AMAGOIA",
    "current_taxes": 6824.2,
    "new_taxes_no_override": 7119.01,
    "override_total_1": 7321.0,
    "override_increase_1": 202.0
  },
  {
    "#": "403 Washington St, Unit 5 (171-53-17)",
    "$": 1055500,
    "address": "403 Washington St, Unit 5",
    "parcel_id": "171-53-17",
    "owner1": "ERIKSEN TR, CURT",
    "owner2": "",
    "current_taxes": 7173.39,
    "new_taxes_no_override": 7483.28,
    "override_total_1": 7695.61,
    "override_increase_1": 212.33
  },
  {
    "#": "403 Washington St, Unit 6 (171-53-18)",
    "$": 1020500,
    "address": "403 Washington St, Unit 6",
    "parcel_id": "171-53-18",
    "owner1": "DATEL, MARIA",
    "owner2": "",
    "current_taxes": 6814.99,
    "new_taxes_no_override": 7109.4,
    "override_total_1": 7311.12,
    "override_increase_1": 201.72
  },
  {
    "#": "405 Washington St, Unit 1 (171-53-19)",
    "$": 797500,
    "address": "405 Washington St, Unit 1",
    "parcel_id": "171-53-19",
    "owner1": "ZHANG, RUI & YIXIN",
    "owner2": "XING, WEI",
    "current_taxes": 4531.47,
    "new_taxes_no_override": 4727.23,
    "override_total_1": 4861.36,
    "override_increase_1": 134.13
  },
  {
    "#": "405 Washington St, Unit 2 (171-53-20)",
    "$": 627200,
    "address": "405 Washington St, Unit 2",
    "parcel_id": "171-53-20",
    "owner1": "VACHON, JEAN M",
    "owner2": "",
    "current_taxes": 2787.59,
    "new_taxes_no_override": 2908.01,
    "override_total_1": 2990.53,
    "override_increase_1": 82.51
  },
  {
    "#": "405 Washington St, Unit 3 (171-53-21)",
    "$": 778100,
    "address": "405 Washington St, Unit 3",
    "parcel_id": "171-53-21",
    "owner1": "WARRINER TR, TAUBY",
    "owner2": "C/O DAWN WALNUT",
    "current_taxes": 7967.74,
    "new_taxes_no_override": 8311.95,
    "override_total_1": 8547.79,
    "override_increase_1": 235.85
  },
  {
    "#": "405 Washington St, Unit 4 (171-53-22)",
    "$": 639100,
    "address": "405 Washington St, Unit 4",
    "parcel_id": "171-53-22",
    "owner1": "CHARPAK, MICHAEL & DAVIDA",
    "owner2": "",
    "current_taxes": 6544.38,
    "new_taxes_no_override": 6827.1,
    "override_total_1": 7020.81,
    "override_increase_1": 193.71
  },
  {
    "#": "405 Washington St, Unit 5 (171-53-23)",
    "$": 706100,
    "address": "405 Washington St, Unit 5",
    "parcel_id": "171-53-23",
    "owner1": "ZHANG, YIXIN & RUI",
    "owner2": "XING, WEI",
    "current_taxes": 3595.53,
    "new_taxes_no_override": 3750.86,
    "override_total_1": 3857.28,
    "override_increase_1": 106.43
  },
  {
    "#": "405 Washington St, Unit 6 (171-53-24)",
    "$": 747800,
    "address": "405 Washington St, Unit 6",
    "parcel_id": "171-53-24",
    "owner1": "JACOBS, CHARLES",
    "owner2": "",
    "current_taxes": 7657.47,
    "new_taxes_no_override": 7988.27,
    "override_total_1": 8214.93,
    "override_increase_1": 226.66
  },
  {
    "#": "407 Washington St, Unit 1 (171-53-25)",
    "$": 1048800,
    "address": "407 Washington St, Unit 1",
    "parcel_id": "171-53-25",
    "owner1": "GHAFARI, RAMESH",
    "owner2": "",
    "current_taxes": 10739.71,
    "new_taxes_no_override": 11203.67,
    "override_total_1": 11521.56,
    "override_increase_1": 317.9
  },
  {
    "#": "407 Washington St, Unit 2 (171-53-26)",
    "$": 604700,
    "address": "407 Washington St, Unit 2",
    "parcel_id": "171-53-26",
    "owner1": "407 WASHINGTON LLC",
    "owner2": "",
    "current_taxes": 6192.13,
    "new_taxes_no_override": 6459.63,
    "override_total_1": 6642.92,
    "override_increase_1": 183.29
  },
  {
    "#": "407 Washington St, Unit 3 (171-53-27)",
    "$": 1060500,
    "address": "407 Washington St, Unit 3",
    "parcel_id": "171-53-27",
    "owner1": "SIMOVICI, DAN A & DOINA",
    "owner2": "",
    "current_taxes": 7224.59,
    "new_taxes_no_override": 7536.69,
    "override_total_1": 7750.54,
    "override_increase_1": 213.85
  },
  {
    "#": "407 Washington St, Unit 4 (171-53-28)",
    "$": 698200,
    "address": "407 Washington St, Unit 4",
    "parcel_id": "171-53-28",
    "owner1": "COHEN, JASON B & WENDY",
    "owner2": "",
    "current_taxes": 7149.57,
    "new_taxes_no_override": 7458.43,
    "override_total_1": 7670.06,
    "override_increase_1": 211.63
  },
  {
    "#": "407 Washington St, Unit 5 & P11 (171-53-29)",
    "$": 1060500,
    "address": "407 Washington St, Unit 5 & P11",
    "parcel_id": "171-53-29",
    "owner1": "RIZOVA, POLLY S",
    "owner2": "RADOYNOVSKI, M",
    "current_taxes": 10859.52,
    "new_taxes_no_override": 11328.65,
    "override_total_1": 11650.09,
    "override_increase_1": 321.44
  },
  {
    "#": "407 Washington St, Unit 6 (171-53-30)",
    "$": 620000,
    "address": "407 Washington St, Unit 6",
    "parcel_id": "171-53-30",
    "owner1": "LEGGAT TR, ELIZABETH",
    "owner2": "",
    "current_taxes": 2713.87,
    "new_taxes_no_override": 2831.11,
    "override_total_1": 2911.44,
    "override_increase_1": 80.33
  },
  {
    "#": "411 Washington St, Unit 1 (171-54-61)",
    "$": 747700,
    "address": "411 Washington St, Unit 1",
    "parcel_id": "171-54-61",
    "owner1": "RUDRA, BALU",
    "owner2": "",
    "current_taxes": 4021.51,
    "new_taxes_no_override": 4195.24,
    "override_total_1": 4314.28,
    "override_increase_1": 119.04
  },
  {
    "#": "411 Washington St, Unit 1B (171-54-60)",
    "$": 754900,
    "address": "411 Washington St, Unit 1B",
    "parcel_id": "171-54-60",
    "owner1": "LUISO TR, PETER J",
    "owner2": "",
    "current_taxes": 7730.18,
    "new_taxes_no_override": 8064.12,
    "override_total_1": 8292.94,
    "override_increase_1": 228.81
  },
  {
    "#": "411 Washington St, Unit 2 (171-54-01)",
    "$": 1132500,
    "address": "411 Washington St, Unit 2",
    "parcel_id": "171-54-01",
    "owner1": "NETHERSOLE, JONATHAN LAWRENCE",
    "owner2": "",
    "current_taxes": 11596.8,
    "new_taxes_no_override": 12097.78,
    "override_total_1": 12441.05,
    "override_increase_1": 343.27
  },
  {
    "#": "411 Washington St, Unit 3 (171-54-02)",
    "$": 830700,
    "address": "411 Washington St, Unit 3",
    "parcel_id": "171-54-02",
    "owner1": "KIEFFER , GORDON D",
    "owner2": "",
    "current_taxes": 8506.37,
    "new_taxes_no_override": 8873.85,
    "override_total_1": 9125.63,
    "override_increase_1": 251.79
  },
  {
    "#": "411 Washington St, Unit 4 (171-54-03)",
    "$": 1132500,
    "address": "411 Washington St, Unit 4",
    "parcel_id": "171-54-03",
    "owner1": "BARLEV, RAFAEL",
    "owner2": "KATZ, MIREYA",
    "current_taxes": 11596.8,
    "new_taxes_no_override": 12097.78,
    "override_total_1": 12441.05,
    "override_increase_1": 343.27
  },
  {
    "#": "411 Washington St, Unit 5 (171-54-04)",
    "$": 859400,
    "address": "411 Washington St, Unit 5",
    "parcel_id": "171-54-04",
    "owner1": "411 WASHINGTON STREET LLC",
    "owner2": "",
    "current_taxes": 8800.26,
    "new_taxes_no_override": 9180.43,
    "override_total_1": 9440.92,
    "override_increase_1": 260.49
  },
  {
    "#": "411 Washington St, Unit 6 & P1 (171-54-05)",
    "$": 1219500,
    "address": "411 Washington St, Unit 6 & P1",
    "parcel_id": "171-54-05",
    "owner1": "ZIMMERMAN, AMANDA",
    "owner2": "WACHTER, JEFFREY",
    "current_taxes": 8852.75,
    "new_taxes_no_override": 9235.19,
    "override_total_1": 9497.23,
    "override_increase_1": 262.04
  },
  {
    "#": "413 Washington St, Unit 1 (171-54-06)",
    "$": 683400,
    "address": "413 Washington St, Unit 1",
    "parcel_id": "171-54-06",
    "owner1": "KRIAUCIUNAS, KRISTINA M",
    "owner2": "",
    "current_taxes": 3363.08,
    "new_taxes_no_override": 3508.37,
    "override_total_1": 3607.91,
    "override_increase_1": 99.55
  },
  {
    "#": "413 Washington St, Unit 2 (171-54-07)",
    "$": 712200,
    "address": "413 Washington St, Unit 2",
    "parcel_id": "171-54-07",
    "owner1": "MAHER TR, PATRICIA",
    "owner2": "",
    "current_taxes": 3657.99,
    "new_taxes_no_override": 3816.02,
    "override_total_1": 3924.29,
    "override_increase_1": 108.28
  },
  {
    "#": "413 Washington St, Unit 3 (171-54-08)",
    "$": 762500,
    "address": "413 Washington St, Unit 3",
    "parcel_id": "171-54-08",
    "owner1": "DIKTER, DAVID M",
    "owner2": "",
    "current_taxes": 4173.07,
    "new_taxes_no_override": 4353.35,
    "override_total_1": 4476.87,
    "override_increase_1": 123.52
  },
  {
    "#": "413 Washington St, Unit 4 (171-54-09)",
    "$": 686600,
    "address": "413 Washington St, Unit 4",
    "parcel_id": "171-54-09",
    "owner1": "GELMAN FAMILY TRUST",
    "owner2": "GELMAN TRS, EFIM & ALLA",
    "current_taxes": 3395.85,
    "new_taxes_no_override": 3542.55,
    "override_total_1": 3643.07,
    "override_increase_1": 100.52
  },
  {
    "#": "413 Washington St, Unit 5 (171-54-10)",
    "$": 776100,
    "address": "413 Washington St, Unit 5",
    "parcel_id": "171-54-10",
    "owner1": "SIPAHI, RIFAT",
    "owner2": "DE SAINT ETIENNE, ALIX",
    "current_taxes": 4312.33,
    "new_taxes_no_override": 4498.62,
    "override_total_1": 4626.27,
    "override_increase_1": 127.64
  },
  {
    "#": "413 Washington St, Unit 6 (171-54-11)",
    "$": 764100,
    "address": "413 Washington St, Unit 6",
    "parcel_id": "171-54-11",
    "owner1": "LOPEZ TR, JO CHRIS G",
    "owner2": "",
    "current_taxes": 7824.38,
    "new_taxes_no_override": 8162.39,
    "override_total_1": 8393.99,
    "override_increase_1": 231.6
  },
  {
    "#": "415 Washington St, Unit 1 (171-54-12)",
    "$": 740900,
    "address": "415 Washington St, Unit 1",
    "parcel_id": "171-54-12",
    "owner1": "SASSAMAN, ERIK",
    "owner2": "FENG, MARGIE",
    "current_taxes": 7586.82,
    "new_taxes_no_override": 7914.57,
    "override_total_1": 8139.14,
    "override_increase_1": 224.57
  },
  {
    "#": "415 Washington St, Unit 2 (171-54-13)",
    "$": 1102200,
    "address": "415 Washington St, Unit 2",
    "parcel_id": "171-54-13",
    "owner1": "MYERS TR, JILL A",
    "owner2": "",
    "current_taxes": 7651.59,
    "new_taxes_no_override": 7982.14,
    "override_total_1": 8208.63,
    "override_increase_1": 226.49
  },
  {
    "#": "415 Washington St, Unit 3 (171-54-14)",
    "$": 837700,
    "address": "415 Washington St, Unit 3",
    "parcel_id": "171-54-14",
    "owner1": "VO, HIEP",
    "owner2": "WONG, MAGGIE",
    "current_taxes": 4943.11,
    "new_taxes_no_override": 5156.65,
    "override_total_1": 5302.97,
    "override_increase_1": 146.32
  },
  {
    "#": "415 Washington St, Unit 4 (171-54-15)",
    "$": 1102200,
    "address": "415 Washington St, Unit 4",
    "parcel_id": "171-54-15",
    "owner1": "STANDER, PEGGY A",
    "owner2": "",
    "current_taxes": 11286.53,
    "new_taxes_no_override": 11774.11,
    "override_total_1": 12108.19,
    "override_increase_1": 334.08
  },
  {
    "#": "415 Washington St, Unit 5 (171-54-16)",
    "$": 817900,
    "address": "415 Washington St, Unit 5",
    "parcel_id": "171-54-16",
    "owner1": "HOU, WENLIANG",
    "owner2": "HONG, JIAN",
    "current_taxes": 4740.36,
    "new_taxes_no_override": 4945.14,
    "override_total_1": 5085.46,
    "override_increase_1": 140.31
  },
  {
    "#": "415 Washington St, Unit 6 (171-54-17)",
    "$": 1102200,
    "address": "415 Washington St, Unit 6",
    "parcel_id": "171-54-17",
    "owner1": "BRADLEY, MARY P",
    "owner2": "",
    "current_taxes": 7651.59,
    "new_taxes_no_override": 7982.14,
    "override_total_1": 8208.63,
    "override_increase_1": 226.49
  },
  {
    "#": "416 Washington St (200-14-00)",
    "$": 2201000,
    "address": "416 Washington St",
    "parcel_id": "200-14-00",
    "owner1": "BROOKLINE CHURCH OF CHRIST",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "417 Washington St, Unit 1 (171-54-18)",
    "$": 933100,
    "address": "417 Washington St, Unit 1",
    "parcel_id": "171-54-18",
    "owner1": "COHEN, ZACHARY A & DIANE K",
    "owner2": "",
    "current_taxes": 5920.01,
    "new_taxes_no_override": 6175.75,
    "override_total_1": 6350.99,
    "override_increase_1": 175.23
  },
  {
    "#": "417 Washington St, Unit 2 (171-54-19)",
    "$": 702900,
    "address": "417 Washington St, Unit 2",
    "parcel_id": "171-54-19",
    "owner1": "THOMPSON, GLORIA G",
    "owner2": "",
    "current_taxes": 3562.76,
    "new_taxes_no_override": 3716.67,
    "override_total_1": 3822.13,
    "override_increase_1": 105.46
  },
  {
    "#": "417 Washington St, Unit 3 (171-54-20)",
    "$": 1025100,
    "address": "417 Washington St, Unit 3",
    "parcel_id": "171-54-20",
    "owner1": "NAJARIAN, ANOUSH",
    "owner2": "SHEPHERD, STEVEN",
    "current_taxes": 6862.09,
    "new_taxes_no_override": 7158.53,
    "override_total_1": 7361.65,
    "override_increase_1": 203.12
  },
  {
    "#": "417 Washington St, Unit 4 (171-54-21)",
    "$": 728500,
    "address": "417 Washington St, Unit 4",
    "parcel_id": "171-54-21",
    "owner1": "RICCO, LUCA",
    "owner2": "",
    "current_taxes": 3824.91,
    "new_taxes_no_override": 3990.15,
    "override_total_1": 4103.36,
    "override_increase_1": 113.22
  },
  {
    "#": "417 Washington St, Unit 5 (171-54-22)",
    "$": 1064700,
    "address": "417 Washington St, Unit 5",
    "parcel_id": "171-54-22",
    "owner1": "WHITTAKER, RUSSELL & MARJORIE",
    "owner2": "",
    "current_taxes": 7267.59,
    "new_taxes_no_override": 7581.55,
    "override_total_1": 7796.67,
    "override_increase_1": 215.12
  },
  {
    "#": "417 Washington St, Unit 6 (171-54-23)",
    "$": 817800,
    "address": "417 Washington St, Unit 6",
    "parcel_id": "171-54-23",
    "owner1": "DE MENDONCA, VICTOR CAYRES",
    "owner2": "CHI, HEEYEON",
    "current_taxes": 4739.34,
    "new_taxes_no_override": 4944.08,
    "override_total_1": 5084.36,
    "override_increase_1": 140.28
  },
  {
    "#": "419 Washington St, Unit 1 (171-54-24)",
    "$": 1017000,
    "address": "419 Washington St, Unit 1",
    "parcel_id": "171-54-24",
    "owner1": "GLADYSHEVA, HELEN",
    "owner2": "",
    "current_taxes": 6779.15,
    "new_taxes_no_override": 7072.01,
    "override_total_1": 7272.67,
    "override_increase_1": 200.66
  },
  {
    "#": "419 Washington St, Unit 2 (171-54-25)",
    "$": 723100,
    "address": "419 Washington St, Unit 2",
    "parcel_id": "171-54-25",
    "owner1": "MILLER, MICHELLE",
    "owner2": "",
    "current_taxes": 3769.61,
    "new_taxes_no_override": 3932.46,
    "override_total_1": 4044.04,
    "override_increase_1": 111.58
  },
  {
    "#": "419 Washington St, Unit 3 (171-54-26)",
    "$": 1029400,
    "address": "419 Washington St, Unit 3",
    "parcel_id": "171-54-26",
    "owner1": "ROOKE, HEATHER",
    "owner2": "SCHLAEGER, THORSTEN",
    "current_taxes": 6906.12,
    "new_taxes_no_override": 7204.46,
    "override_total_1": 7408.89,
    "override_increase_1": 204.42
  },
  {
    "#": "419 Washington St, Unit 4 (171-54-27)",
    "$": 815800,
    "address": "419 Washington St, Unit 4",
    "parcel_id": "171-54-27",
    "owner1": "FEINGOLD, GABRIEL & SHEENA",
    "owner2": "",
    "current_taxes": 4718.86,
    "new_taxes_no_override": 4922.71,
    "override_total_1": 5062.39,
    "override_increase_1": 139.68
  },
  {
    "#": "419 Washington St, Unit 5 (171-54-28)",
    "$": 992200,
    "address": "419 Washington St, Unit 5",
    "parcel_id": "171-54-28",
    "owner1": "ZEEVI, YEHOSHUA Y & NAOMO",
    "owner2": "C/O PETER A COTE",
    "current_taxes": 10160.13,
    "new_taxes_no_override": 10599.05,
    "override_total_1": 10899.79,
    "override_increase_1": 300.74
  },
  {
    "#": "419 Washington St, Unit 6 & P7 (171-54-29)",
    "$": 848300,
    "address": "419 Washington St, Unit 6 & P7",
    "parcel_id": "171-54-29",
    "owner1": "SHAUGHNESSY, ALLISON",
    "owner2": "",
    "current_taxes": 5051.66,
    "new_taxes_no_override": 5269.89,
    "override_total_1": 5419.42,
    "override_increase_1": 149.53
  },
  {
    "#": "423 Washington St, Unit 1 & P14 (171-54-30)",
    "$": 853700,
    "address": "423 Washington St, Unit 1 & P14",
    "parcel_id": "171-54-30",
    "owner1": "CASTRO, MARIA G",
    "owner2": "LOWENSTEIN, PEDRO R",
    "current_taxes": 8741.89,
    "new_taxes_no_override": 9119.54,
    "override_total_1": 9378.3,
    "override_increase_1": 258.76
  },
  {
    "#": "423 Washington St, Unit 2 (171-54-31)",
    "$": 981700,
    "address": "423 Washington St, Unit 2",
    "parcel_id": "171-54-31",
    "owner1": "KRUTTER, SHIRLEY & MARLENE",
    "owner2": "",
    "current_taxes": 6417.67,
    "new_taxes_no_override": 6694.91,
    "override_total_1": 6884.88,
    "override_increase_1": 189.96
  },
  {
    "#": "423 Washington St, Unit 3 (171-54-32)",
    "$": 962500,
    "address": "423 Washington St, Unit 3",
    "parcel_id": "171-54-32",
    "owner1": "FREY, ERNEST A",
    "owner2": "RUBACKIN, NANCY P",
    "current_taxes": 6221.07,
    "new_taxes_no_override": 6489.82,
    "override_total_1": 6673.96,
    "override_increase_1": 184.14
  },
  {
    "#": "423 Washington St, Unit 4 (171-54-33)",
    "$": 1094100,
    "address": "423 Washington St, Unit 4",
    "parcel_id": "171-54-33",
    "owner1": "KATZ, GERALD E & IRENA C",
    "owner2": "",
    "current_taxes": 7568.65,
    "new_taxes_no_override": 7895.62,
    "override_total_1": 8119.65,
    "override_increase_1": 224.03
  },
  {
    "#": "423 Washington St, Unit 5 (171-54-34)",
    "$": 933500,
    "address": "423 Washington St, Unit 5",
    "parcel_id": "171-54-34",
    "owner1": "PURCELL, KEVIN",
    "owner2": "POON, COURTNEY",
    "current_taxes": 5924.11,
    "new_taxes_no_override": 6180.03,
    "override_total_1": 6355.39,
    "override_increase_1": 175.35
  },
  {
    "#": "423 Washington St, Unit 6 (171-54-35)",
    "$": 1148000,
    "address": "423 Washington St, Unit 6",
    "parcel_id": "171-54-35",
    "owner1": "SLAVICI, VLAD ALEXANDRU",
    "owner2": "BOBOILA, MARCELA SIMON",
    "current_taxes": 8120.59,
    "new_taxes_no_override": 8471.4,
    "override_total_1": 8711.77,
    "override_increase_1": 240.37
  },
  {
    "#": "425 Washington St, Unit 1 (171-54-36)",
    "$": 979100,
    "address": "425 Washington St, Unit 1",
    "parcel_id": "171-54-36",
    "owner1": "ROSS, ANDREW JACOB",
    "owner2": "ALFORD, REBECCA FAYE",
    "current_taxes": 6391.05,
    "new_taxes_no_override": 6667.14,
    "override_total_1": 6856.32,
    "override_increase_1": 189.18
  },
  {
    "#": "425 Washington St, Unit 2 (171-54-37)",
    "$": 805800,
    "address": "425 Washington St, Unit 2",
    "parcel_id": "171-54-37",
    "owner1": "HOROWITZ TRS, MARTIN",
    "owner2": "CRYAN TR, MARTHA A",
    "current_taxes": 8251.39,
    "new_taxes_no_override": 8607.85,
    "override_total_1": 8852.09,
    "override_increase_1": 244.24
  },
  {
    "#": "425 Washington St, Unit 3 & P16 (171-54-38)",
    "$": 984800,
    "address": "425 Washington St, Unit 3 & P16",
    "parcel_id": "171-54-38",
    "owner1": "NACHIMSON, JOYCE E",
    "owner2": "",
    "current_taxes": 10084.35,
    "new_taxes_no_override": 10519.99,
    "override_total_1": 10818.49,
    "override_increase_1": 298.5
  },
  {
    "#": "425 Washington St, Unit 4 (171-54-39)",
    "$": 792600,
    "address": "425 Washington St, Unit 4",
    "parcel_id": "171-54-39",
    "owner1": "HUANG, JOYCE M & JEAN J & FAYE",
    "owner2": "",
    "current_taxes": 4481.29,
    "new_taxes_no_override": 4674.88,
    "override_total_1": 4807.53,
    "override_increase_1": 132.65
  },
  {
    "#": "425 Washington St, Unit 5 (171-54-40)",
    "$": 962100,
    "address": "425 Washington St, Unit 5",
    "parcel_id": "171-54-40",
    "owner1": "SHUBERT TRS, JAN & MARINA",
    "owner2": "",
    "current_taxes": 6216.97,
    "new_taxes_no_override": 6485.54,
    "override_total_1": 6669.57,
    "override_increase_1": 184.02
  },
  {
    "#": "425 Washington St, Unit 6 & P13 (171-54-41)",
    "$": 894800,
    "address": "425 Washington St, Unit 6 & P13",
    "parcel_id": "171-54-41",
    "owner1": "SAPIENZA TR, FRANK C",
    "owner2": "",
    "current_taxes": 5527.82,
    "new_taxes_no_override": 5766.62,
    "override_total_1": 5930.25,
    "override_increase_1": 163.62
  },
  {
    "#": "427 Washington St, Unit 1 (171-54-42)",
    "$": 830200,
    "address": "427 Washington St, Unit 1",
    "parcel_id": "171-54-42",
    "owner1": "TANNENBAUM, ANDREW",
    "owner2": "",
    "current_taxes": 4866.31,
    "new_taxes_no_override": 5076.53,
    "override_total_1": 5220.58,
    "override_increase_1": 144.04
  },
  {
    "#": "427 Washington St, Unit 2 (171-54-43)",
    "$": 812000,
    "address": "427 Washington St, Unit 2",
    "parcel_id": "171-54-43",
    "owner1": "SUKHARENKO, ARKADIY & TATYANA",
    "owner2": "",
    "current_taxes": 4679.95,
    "new_taxes_no_override": 4882.12,
    "override_total_1": 5020.65,
    "override_increase_1": 138.53
  },
  {
    "#": "427 Washington St, Unit 3 (171-54-44)",
    "$": 939700,
    "address": "427 Washington St, Unit 3",
    "parcel_id": "171-54-44",
    "owner1": "MILLER TR, NANCY",
    "owner2": "",
    "current_taxes": 5987.59,
    "new_taxes_no_override": 6246.25,
    "override_total_1": 6423.49,
    "override_increase_1": 177.23
  },
  {
    "#": "427 Washington St, Unit 4 (171-54-45)",
    "$": 822200,
    "address": "427 Washington St, Unit 4",
    "parcel_id": "171-54-45",
    "owner1": "LEE TRS, DAVID & MARY I",
    "owner2": "",
    "current_taxes": 8419.33,
    "new_taxes_no_override": 8783.05,
    "override_total_1": 9032.26,
    "override_increase_1": 249.21
  },
  {
    "#": "427 Washington St, Unit 5 & P9 (171-54-46)",
    "$": 963000,
    "address": "427 Washington St, Unit 5 & P9",
    "parcel_id": "171-54-46",
    "owner1": "PRICE, HAROLD",
    "owner2": "LI, LI",
    "current_taxes": 6226.19,
    "new_taxes_no_override": 6495.16,
    "override_total_1": 6679.46,
    "override_increase_1": 184.3
  },
  {
    "#": "427 Washington St, Unit 6 (171-54-47)",
    "$": 889700,
    "address": "427 Washington St, Unit 6",
    "parcel_id": "171-54-47",
    "owner1": "BAKHTIAR, SIMINTAJ",
    "owner2": "",
    "current_taxes": 5475.59,
    "new_taxes_no_override": 5712.14,
    "override_total_1": 5874.21,
    "override_increase_1": 162.08
  },
  {
    "#": "429 Washington St, Unit 1 (171-54-48)",
    "$": 696000,
    "address": "429 Washington St, Unit 1",
    "parcel_id": "171-54-48",
    "owner1": "RAPOSO TR, LUISA MEDEIROS",
    "owner2": "",
    "current_taxes": 3492.11,
    "new_taxes_no_override": 3642.97,
    "override_total_1": 3746.34,
    "override_increase_1": 103.37
  },
  {
    "#": "429 Washington St, Unit 2 (171-54-49)",
    "$": 634200,
    "address": "429 Washington St, Unit 2",
    "parcel_id": "171-54-49",
    "owner1": "WONG, PATRICK JIAN & SUNNY JIAN YANG",
    "owner2": "",
    "current_taxes": 6494.21,
    "new_taxes_no_override": 6774.76,
    "override_total_1": 6966.99,
    "override_increase_1": 192.23
  },
  {
    "#": "429 Washington St, Unit 3 (171-54-50)",
    "$": 786500,
    "address": "429 Washington St, Unit 3",
    "parcel_id": "171-54-50",
    "owner1": "KOGAN TRS, ROZALIA",
    "owner2": "RABIN, TATYANA V",
    "current_taxes": 4418.83,
    "new_taxes_no_override": 4609.72,
    "override_total_1": 4740.52,
    "override_increase_1": 130.8
  },
  {
    "#": "429 Washington St, Unit 4 (171-54-51)",
    "$": 637700,
    "address": "429 Washington St, Unit 4",
    "parcel_id": "171-54-51",
    "owner1": "DAI, YUELIANG",
    "owner2": "",
    "current_taxes": 6530.05,
    "new_taxes_no_override": 6812.15,
    "override_total_1": 7005.44,
    "override_increase_1": 193.29
  },
  {
    "#": "429 Washington St, Unit 5 (171-54-52)",
    "$": 794700,
    "address": "429 Washington St, Unit 5",
    "parcel_id": "171-54-52",
    "owner1": "EGELE, MANUEL",
    "owner2": "",
    "current_taxes": 8137.73,
    "new_taxes_no_override": 8489.28,
    "override_total_1": 8730.16,
    "override_increase_1": 240.88
  },
  {
    "#": "429 Washington St, Unit 6 (171-54-53)",
    "$": 793600,
    "address": "429 Washington St, Unit 6",
    "parcel_id": "171-54-53",
    "owner1": "LEE, WON ICK",
    "owner2": "SONG, CHLOE BYUNGOK",
    "current_taxes": 8126.46,
    "new_taxes_no_override": 8477.52,
    "override_total_1": 8718.07,
    "override_increase_1": 240.54
  },
  {
    "#": "431 Washington St, Unit 1 (171-54-54)",
    "$": 926500,
    "address": "431 Washington St, Unit 1",
    "parcel_id": "171-54-54",
    "owner1": "WEBER, H CHRISTIAN",
    "owner2": "KIM, HAESOOK",
    "current_taxes": 9487.36,
    "new_taxes_no_override": 9897.21,
    "override_total_1": 10178.04,
    "override_increase_1": 280.83
  },
  {
    "#": "431 Washington St, Unit 2 (171-54-55)",
    "$": 784000,
    "address": "431 Washington St, Unit 2",
    "parcel_id": "171-54-55",
    "owner1": "HIGGINS, MARY ANN",
    "owner2": "",
    "current_taxes": 4393.23,
    "new_taxes_no_override": 4583.02,
    "override_total_1": 4713.06,
    "override_increase_1": 130.04
  },
  {
    "#": "431 Washington St, Unit 3 (171-54-56)",
    "$": 927800,
    "address": "431 Washington St, Unit 3",
    "parcel_id": "171-54-56",
    "owner1": "ELLIS TR, SUSAN P",
    "owner2": "",
    "current_taxes": 5865.74,
    "new_taxes_no_override": 6119.14,
    "override_total_1": 6292.77,
    "override_increase_1": 173.63
  },
  {
    "#": "431 Washington St, Unit 4 (171-54-57)",
    "$": 830400,
    "address": "431 Washington St, Unit 4",
    "parcel_id": "171-54-57",
    "owner1": "SALEM, HIBA ZIAD",
    "owner2": "ABU KHADRA, HANA KANAAN",
    "current_taxes": 8503.3,
    "new_taxes_no_override": 8870.64,
    "override_total_1": 9122.34,
    "override_increase_1": 251.7
  },
  {
    "#": "431 Washington St, Unit 5 (171-54-58)",
    "$": 967100,
    "address": "431 Washington St, Unit 5",
    "parcel_id": "171-54-58",
    "owner1": "CARPELAN, ELIZABETH L",
    "owner2": "PICARD, ROBERT G",
    "current_taxes": 6268.17,
    "new_taxes_no_override": 6538.95,
    "override_total_1": 6724.49,
    "override_increase_1": 185.54
  },
  {
    "#": "431 Washington St, Unit 6 (171-54-59)",
    "$": 777200,
    "address": "431 Washington St, Unit 6",
    "parcel_id": "171-54-59",
    "owner1": "FITZGERALD, STEVEN MAURICE & HILDA C",
    "owner2": "",
    "current_taxes": 4323.59,
    "new_taxes_no_override": 4510.37,
    "override_total_1": 4638.35,
    "override_increase_1": 127.98
  },
  {
    "#": "432 Washington St (200-12-01)",
    "$": 3402600,
    "address": "432 Washington St",
    "parcel_id": "200-12-01",
    "owner1": "LAZOWSKI TRS, DAVID & DANA",
    "owner2": "",
    "current_taxes": 31207.69,
    "new_taxes_no_override": 32555.86,
    "override_total_1": 33479.61,
    "override_increase_1": 923.75
  },
  {
    "#": "439 Washington St, Unit 1 & P6 (171-55-02)",
    "$": 1010000,
    "address": "439 Washington St, Unit 1 & P6",
    "parcel_id": "171-55-02",
    "owner1": "STEINFINK, IRVING",
    "owner2": "HARRINGTON, LAURA",
    "current_taxes": 6707.47,
    "new_taxes_no_override": 6997.23,
    "override_total_1": 7195.77,
    "override_increase_1": 198.54
  },
  {
    "#": "439 Washington St, Unit 2 & P18 (171-55-03)",
    "$": 987800,
    "address": "439 Washington St, Unit 2 & P18",
    "parcel_id": "171-55-03",
    "owner1": "SEGEV, ERAN",
    "owner2": "FAVERMAN, LIDIA",
    "current_taxes": 6480.14,
    "new_taxes_no_override": 6760.08,
    "override_total_1": 6951.89,
    "override_increase_1": 191.81
  },
  {
    "#": "439 Washington St, Unit 3 (171-55-04)",
    "$": 958600,
    "address": "439 Washington St, Unit 3",
    "parcel_id": "171-55-04",
    "owner1": "KILLOUGH TRS, JOSEPH ALLEN & ANN JOSLIN",
    "owner2": "",
    "current_taxes": 6181.13,
    "new_taxes_no_override": 6448.15,
    "override_total_1": 6631.12,
    "override_increase_1": 182.96
  },
  {
    "#": "439 Washington St, Unit 4 & P19 (171-55-05)",
    "$": 1047000,
    "address": "439 Washington St, Unit 4 & P19",
    "parcel_id": "171-55-05",
    "owner1": "KATARI, KAUSHIK & ELEANOR",
    "owner2": "",
    "current_taxes": 7086.35,
    "new_taxes_no_override": 7392.48,
    "override_total_1": 7602.24,
    "override_increase_1": 209.76
  },
  {
    "#": "439 Washington St, Unit 5 (171-55-06)",
    "$": 1007100,
    "address": "439 Washington St, Unit 5",
    "parcel_id": "171-55-06",
    "owner1": "FARBSTEIN TRS, AVRAHAM & LILI",
    "owner2": "",
    "current_taxes": 10312.7,
    "new_taxes_no_override": 10758.21,
    "override_total_1": 11063.46,
    "override_increase_1": 305.26
  },
  {
    "#": "439 Washington St, Unit 6 & P12 (171-55-07)",
    "$": 1073200,
    "address": "439 Washington St, Unit 6 & P12",
    "parcel_id": "171-55-07",
    "owner1": "ELTON, JESSICA E S",
    "owner2": "",
    "current_taxes": 7354.63,
    "new_taxes_no_override": 7672.35,
    "override_total_1": 7890.05,
    "override_increase_1": 217.7
  },
  {
    "#": "441 Washington St, Unit 1 (171-55-08)",
    "$": 966300,
    "address": "441 Washington St, Unit 1",
    "parcel_id": "171-55-08",
    "owner1": "RUBENSTEIN TR, BETH C",
    "owner2": "",
    "current_taxes": 6259.98,
    "new_taxes_no_override": 6530.41,
    "override_total_1": 6715.71,
    "override_increase_1": 185.3
  },
  {
    "#": "441 Washington St, Unit 2 (171-55-09)",
    "$": 882500,
    "address": "441 Washington St, Unit 2",
    "parcel_id": "171-55-09",
    "owner1": "KLEILER, DAVID A JR",
    "owner2": "",
    "current_taxes": 9036.8,
    "new_taxes_no_override": 9427.19,
    "override_total_1": 9694.68,
    "override_increase_1": 267.49
  },
  {
    "#": "441 Washington St, Unit 3 (171-55-10)",
    "$": 1047400,
    "address": "441 Washington St, Unit 3",
    "parcel_id": "171-55-10",
    "owner1": "HAIMOWITZ, BRUCE R",
    "owner2": "BALL, ELLEN B",
    "current_taxes": 7090.44,
    "new_taxes_no_override": 7396.75,
    "override_total_1": 7606.62,
    "override_increase_1": 209.88
  },
  {
    "#": "441 Washington St, Unit 4 & P3 (171-55-11)",
    "$": 963500,
    "address": "441 Washington St, Unit 4 & P3",
    "parcel_id": "171-55-11",
    "owner1": "XIA, QING",
    "owner2": "",
    "current_taxes": 6231.31,
    "new_taxes_no_override": 6500.5,
    "override_total_1": 6684.95,
    "override_increase_1": 184.45
  },
  {
    "#": "441 Washington St, Unit 5 (171-55-12)",
    "$": 1056200,
    "address": "441 Washington St, Unit 5",
    "parcel_id": "171-55-12",
    "owner1": "WEEDON TRS, JANET A",
    "owner2": "",
    "current_taxes": 10815.49,
    "new_taxes_no_override": 11282.72,
    "override_total_1": 11602.86,
    "override_increase_1": 320.14
  },
  {
    "#": "441 Washington St, Unit 6 & P8 (171-55-13)",
    "$": 1030900,
    "address": "441 Washington St, Unit 6 & P8",
    "parcel_id": "171-55-13",
    "owner1": "ORLOVSKY, DMITRY",
    "owner2": "VILENCHIK, YANA",
    "current_taxes": 6921.48,
    "new_taxes_no_override": 7220.49,
    "override_total_1": 7425.36,
    "override_increase_1": 204.88
  },
  {
    "#": "447 Washington St, Unit 1 & P1 P2 (171-55-14)",
    "$": 1147700,
    "address": "447 Washington St, Unit 1 & P1 P2",
    "parcel_id": "171-55-14",
    "owner1": "KUKLEWICZ, ANDREW",
    "owner2": "VROOMAN, LYNDA",
    "current_taxes": 8117.51,
    "new_taxes_no_override": 8468.19,
    "override_total_1": 8708.46,
    "override_increase_1": 240.28
  },
  {
    "#": "447 Washington St, Unit 2 & P5 P8 (171-55-15)",
    "$": 1429800,
    "address": "447 Washington St, Unit 2 & P5 P8",
    "parcel_id": "171-55-15",
    "owner1": "SILVA, FERNANDO",
    "owner2": "AGRIN-SILVA, RACHEL",
    "current_taxes": 11006.22,
    "new_taxes_no_override": 11481.69,
    "override_total_1": 11807.47,
    "override_increase_1": 325.78
  },
  {
    "#": "447 Washington St, Unit 3 & P6 P7 (171-55-16)",
    "$": 1447000,
    "address": "447 Washington St, Unit 3 & P6 P7",
    "parcel_id": "171-55-16",
    "owner1": "CORSON TR, LAURA B",
    "owner2": "",
    "current_taxes": 11182.35,
    "new_taxes_no_override": 11665.43,
    "override_total_1": 11996.43,
    "override_increase_1": 331.0
  },
  {
    "#": "447 Washington St, Unit 4 & P3 P4 (171-55-17)",
    "$": 2366600,
    "address": "447 Washington St, Unit 4 & P3 P4",
    "parcel_id": "171-55-17",
    "owner1": "NOBEL, KENNETH W & PHYLLIS R",
    "owner2": "",
    "current_taxes": 20599.05,
    "new_taxes_no_override": 21488.93,
    "override_total_1": 22098.66,
    "override_increase_1": 609.73
  },
  {
    "#": "453 Washington St, Unit 1 (171-56-01)",
    "$": 618500,
    "address": "453 Washington St, Unit 1",
    "parcel_id": "171-56-01",
    "owner1": "YU TRS, LEI",
    "owner2": "SHEN, LIJUN",
    "current_taxes": 6333.44,
    "new_taxes_no_override": 6607.04,
    "override_total_1": 6794.51,
    "override_increase_1": 187.47
  },
  {
    "#": "453 Washington St, Unit 2 (171-56-02)",
    "$": 662900,
    "address": "453 Washington St, Unit 2",
    "parcel_id": "171-56-02",
    "owner1": "MORKOS, MICHAEL & SARAH",
    "owner2": "",
    "current_taxes": 6788.1,
    "new_taxes_no_override": 7081.35,
    "override_total_1": 7282.27,
    "override_increase_1": 200.93
  },
  {
    "#": "453 Washington St, Unit 3 (171-56-03)",
    "$": 626400,
    "address": "453 Washington St, Unit 3",
    "parcel_id": "171-56-03",
    "owner1": "BURSTYN, GILDA",
    "owner2": "",
    "current_taxes": 2779.4,
    "new_taxes_no_override": 2899.47,
    "override_total_1": 2981.74,
    "override_increase_1": 82.27
  },
  {
    "#": "453 Washington St, Unit 4 (171-56-04)",
    "$": 754700,
    "address": "453 Washington St, Unit 4",
    "parcel_id": "171-56-04",
    "owner1": "TSVETKOVA, IRENA",
    "owner2": "",
    "current_taxes": 4093.19,
    "new_taxes_no_override": 4270.02,
    "override_total_1": 4391.17,
    "override_increase_1": 121.16
  },
  {
    "#": "453 Washington St, Unit 5 (171-56-05)",
    "$": 639000,
    "address": "453 Washington St, Unit 5",
    "parcel_id": "171-56-05",
    "owner1": "BENWAIT, JASPREET KAUR",
    "owner2": "SINGH, AVINAINDER",
    "current_taxes": 2908.43,
    "new_taxes_no_override": 3034.07,
    "override_total_1": 3120.16,
    "override_increase_1": 86.09
  },
  {
    "#": "453 Washington St, Unit 6 (171-56-06)",
    "$": 669800,
    "address": "453 Washington St, Unit 6",
    "parcel_id": "171-56-06",
    "owner1": "KAZANTSEV, ALEKSEY",
    "owner2": "",
    "current_taxes": 3223.82,
    "new_taxes_no_override": 3363.09,
    "override_total_1": 3458.51,
    "override_increase_1": 95.43
  },
  {
    "#": "453 Washington St, Unit B (171-56-31)",
    "$": 413400,
    "address": "453 Washington St, Unit B",
    "parcel_id": "171-56-31",
    "owner1": "BRODY LLC",
    "owner2": "",
    "current_taxes": 4233.22,
    "new_taxes_no_override": 4416.1,
    "override_total_1": 4541.4,
    "override_increase_1": 125.3
  },
  {
    "#": "454 Washington St (207-05-06)",
    "$": 3163400,
    "address": "454 Washington St",
    "parcel_id": "207-05-06",
    "owner1": "SANDERS, LEO S",
    "owner2": "NISSENBAUM, CHERYL B",
    "current_taxes": 28758.28,
    "new_taxes_no_override": 30000.64,
    "override_total_1": 30851.88,
    "override_increase_1": 851.25
  },
  {
    "#": "455 Washington St, Unit 1 (171-56-08)",
    "$": 571100,
    "address": "455 Washington St, Unit 1",
    "parcel_id": "171-56-08",
    "owner1": "PENTA TR, ANITA",
    "owner2": "",
    "current_taxes": 5848.06,
    "new_taxes_no_override": 6100.7,
    "override_total_1": 6273.8,
    "override_increase_1": 173.1
  },
  {
    "#": "455 Washington St, Unit 2 (171-56-09)",
    "$": 675900,
    "address": "455 Washington St, Unit 2",
    "parcel_id": "171-56-09",
    "owner1": "THERRIEN, AMELIE",
    "owner2": "",
    "current_taxes": 3286.28,
    "new_taxes_no_override": 3428.25,
    "override_total_1": 3525.52,
    "override_increase_1": 97.27
  },
  {
    "#": "455 Washington St, Unit 3 (171-56-10)",
    "$": 602600,
    "address": "455 Washington St, Unit 3",
    "parcel_id": "171-56-10",
    "owner1": "ZHAO, YANSONG",
    "owner2": "WANG, HUIFANG",
    "current_taxes": 2535.69,
    "new_taxes_no_override": 2645.23,
    "override_total_1": 2720.29,
    "override_increase_1": 75.06
  },
  {
    "#": "455 Washington St, Unit 4 (171-56-11)",
    "$": 644300,
    "address": "455 Washington St, Unit 4",
    "parcel_id": "171-56-11",
    "owner1": "SHIH, JENNY LIN",
    "owner2": "WU, SIMON",
    "current_taxes": 2962.7,
    "new_taxes_no_override": 3090.69,
    "override_total_1": 3178.38,
    "override_increase_1": 87.7
  },
  {
    "#": "455 Washington St, Unit 5 (171-56-12)",
    "$": 577000,
    "address": "455 Washington St, Unit 5",
    "parcel_id": "171-56-12",
    "owner1": "ORSATTI, REBECKAH",
    "owner2": "",
    "current_taxes": 2273.55,
    "new_taxes_no_override": 2371.77,
    "override_total_1": 2439.06,
    "override_increase_1": 67.3
  },
  {
    "#": "455 Washington St, Unit 6 (171-56-13)",
    "$": 693400,
    "address": "455 Washington St, Unit 6",
    "parcel_id": "171-56-13",
    "owner1": "PLAISIMOND TR, MICHELE",
    "owner2": "",
    "current_taxes": 3465.48,
    "new_taxes_no_override": 3615.19,
    "override_total_1": 3717.77,
    "override_increase_1": 102.58
  },
  {
    "#": "455 Washington St, Unit B (171-56-07)",
    "$": 385200,
    "address": "455 Washington St, Unit B",
    "parcel_id": "171-56-07",
    "owner1": "LEY, ROBERT J",
    "owner2": "AUSTIN, MAYLEE",
    "current_taxes": 3944.45,
    "new_taxes_no_override": 4114.85,
    "override_total_1": 4231.61,
    "override_increase_1": 116.76
  },
  {
    "#": "457 Washington St, Unit 1 (171-56-15)",
    "$": 568500,
    "address": "457 Washington St, Unit 1",
    "parcel_id": "171-56-15",
    "owner1": "PLAMENVSKAYA, OLGA",
    "owner2": "RETAKH, ALEXANDER",
    "current_taxes": 5821.44,
    "new_taxes_no_override": 6072.93,
    "override_total_1": 6245.24,
    "override_increase_1": 172.31
  },
  {
    "#": "457 Washington St, Unit 2 (171-56-16)",
    "$": 448400,
    "address": "457 Washington St, Unit 2",
    "parcel_id": "171-56-16",
    "owner1": "PATEL, SANJAY",
    "owner2": "",
    "current_taxes": 4591.62,
    "new_taxes_no_override": 4789.98,
    "override_total_1": 4925.89,
    "override_increase_1": 135.91
  },
  {
    "#": "457 Washington St, Unit 3 (171-56-17)",
    "$": 571800,
    "address": "457 Washington St, Unit 3",
    "parcel_id": "171-56-17",
    "owner1": "BESHANSKY, JASON",
    "owner2": "",
    "current_taxes": 5855.23,
    "new_taxes_no_override": 6108.18,
    "override_total_1": 6281.49,
    "override_increase_1": 173.31
  },
  {
    "#": "457 Washington St, Unit 4 (171-56-18)",
    "$": 473200,
    "address": "457 Washington St, Unit 4",
    "parcel_id": "171-56-18",
    "owner1": "SWEEZEY, JANET",
    "owner2": "",
    "current_taxes": 1210.63,
    "new_taxes_no_override": 1262.93,
    "override_total_1": 1298.76,
    "override_increase_1": 35.83
  },
  {
    "#": "457 Washington St, Unit 5 (171-56-19)",
    "$": 553000,
    "address": "457 Washington St, Unit 5",
    "parcel_id": "171-56-19",
    "owner1": "GRUJIC, DANICA",
    "owner2": "",
    "current_taxes": 5662.72,
    "new_taxes_no_override": 5907.35,
    "override_total_1": 6074.97,
    "override_increase_1": 167.62
  },
  {
    "#": "457 Washington St, Unit 6 (171-56-20)",
    "$": 448400,
    "address": "457 Washington St, Unit 6",
    "parcel_id": "171-56-20",
    "owner1": "VISCUSO, ANTHONY & SUSAN",
    "owner2": "",
    "current_taxes": 4591.62,
    "new_taxes_no_override": 4789.98,
    "override_total_1": 4925.89,
    "override_increase_1": 135.91
  },
  {
    "#": "457 Washington St, Unit B (171-56-14)",
    "$": 331900,
    "address": "457 Washington St, Unit B",
    "parcel_id": "171-56-14",
    "owner1": "GHARAVY TR, GOLLAM HASSAN",
    "owner2": "",
    "current_taxes": 3398.66,
    "new_taxes_no_override": 3545.48,
    "override_total_1": 3646.08,
    "override_increase_1": 100.6
  },
  {
    "#": "459 Washington St, Unit 1 (171-56-21)",
    "$": 577100,
    "address": "459 Washington St, Unit 1",
    "parcel_id": "171-56-21",
    "owner1": "SCARLATELLI, PAMELA A",
    "owner2": "",
    "current_taxes": 2274.57,
    "new_taxes_no_override": 2372.83,
    "override_total_1": 2440.16,
    "override_increase_1": 67.33
  },
  {
    "#": "459 Washington St, Unit 2 (171-56-22)",
    "$": 628600,
    "address": "459 Washington St, Unit 2",
    "parcel_id": "171-56-22",
    "owner1": "SCHELL, LAWRENCE M",
    "owner2": "",
    "current_taxes": 6436.86,
    "new_taxes_no_override": 6714.93,
    "override_total_1": 6905.46,
    "override_increase_1": 190.53
  },
  {
    "#": "459 Washington St, Unit 3 (171-56-23)",
    "$": 647600,
    "address": "459 Washington St, Unit 3",
    "parcel_id": "171-56-23",
    "owner1": "WANG, JINGJUN",
    "owner2": "",
    "current_taxes": 2996.49,
    "new_taxes_no_override": 3125.94,
    "override_total_1": 3214.63,
    "override_increase_1": 88.7
  },
  {
    "#": "461 Washington St, Unit 1 (171-56-25)",
    "$": 659700,
    "address": "461 Washington St, Unit 1",
    "parcel_id": "171-56-25",
    "owner1": "HAO, BING MEI",
    "owner2": "",
    "current_taxes": 6755.33,
    "new_taxes_no_override": 7047.16,
    "override_total_1": 7247.12,
    "override_increase_1": 199.96
  },
  {
    "#": "461 Washington St, Unit 2 (171-56-26)",
    "$": 587200,
    "address": "461 Washington St, Unit 2",
    "parcel_id": "171-56-26",
    "owner1": "WISNIAK, BARBARA",
    "owner2": "MARCINIAK, PIOTR R",
    "current_taxes": 2377.99,
    "new_taxes_no_override": 2480.72,
    "override_total_1": 2551.11,
    "override_increase_1": 70.39
  },
  {
    "#": "461 Washington St, Unit 3 (171-56-27)",
    "$": 747000,
    "address": "461 Washington St, Unit 3",
    "parcel_id": "171-56-27",
    "owner1": "WANG, QI",
    "owner2": "",
    "current_taxes": 4014.35,
    "new_taxes_no_override": 4187.77,
    "override_total_1": 4306.59,
    "override_increase_1": 118.82
  },
  {
    "#": "461 Washington St, Unit 4 (171-56-28)",
    "$": 605900,
    "address": "461 Washington St, Unit 4",
    "parcel_id": "171-56-28",
    "owner1": "GINZBURG, EUGENE",
    "owner2": "",
    "current_taxes": 2569.48,
    "new_taxes_no_override": 2680.48,
    "override_total_1": 2756.54,
    "override_increase_1": 76.06
  },
  {
    "#": "461 Washington St, Unit 5 (171-56-29)",
    "$": 662500,
    "address": "461 Washington St, Unit 5",
    "parcel_id": "171-56-29",
    "owner1": "STRAUSS, ADAM",
    "owner2": "HAHN, CYNTHIA KENDALL",
    "current_taxes": 3149.07,
    "new_taxes_no_override": 3285.11,
    "override_total_1": 3378.32,
    "override_increase_1": 93.21
  },
  {
    "#": "461 Washington St, Unit 6 (171-56-30)",
    "$": 605900,
    "address": "461 Washington St, Unit 6",
    "parcel_id": "171-56-30",
    "owner1": "HAN, TAE HEUI",
    "owner2": "",
    "current_taxes": 2569.48,
    "new_taxes_no_override": 2680.48,
    "override_total_1": 2756.54,
    "override_increase_1": 76.06
  },
  {
    "#": "461 Washington St, Unit B (171-56-24)",
    "$": 452700,
    "address": "461 Washington St, Unit B",
    "parcel_id": "171-56-24",
    "owner1": "JACOFF, MARK",
    "owner2": "",
    "current_taxes": 4635.65,
    "new_taxes_no_override": 4835.91,
    "override_total_1": 4973.13,
    "override_increase_1": 137.22
  },
  {
    "#": "465 Washington St, Unit 1 & P9 (171-57-07)",
    "$": 914000,
    "address": "465 Washington St, Unit 1 & P9",
    "parcel_id": "171-57-07",
    "owner1": "RAKALIN, ANDREY",
    "owner2": "",
    "current_taxes": 5724.43,
    "new_taxes_no_override": 5971.73,
    "override_total_1": 6141.17,
    "override_increase_1": 169.44
  },
  {
    "#": "465 Washington St, Unit 2 &  P5 P6 (171-57-01)",
    "$": 932300,
    "address": "465 Washington St, Unit 2 &  P5 P6",
    "parcel_id": "171-57-01",
    "owner1": "NELSON, JENNIFER A",
    "owner2": "",
    "current_taxes": 5911.82,
    "new_taxes_no_override": 6167.21,
    "override_total_1": 6342.2,
    "override_increase_1": 174.99
  },
  {
    "#": "465 Washington St, Unit 3 & P4 (171-57-02)",
    "$": 916300,
    "address": "465 Washington St, Unit 3 & P4",
    "parcel_id": "171-57-02",
    "owner1": "VITTORI, KAMBER D",
    "owner2": "",
    "current_taxes": 5747.98,
    "new_taxes_no_override": 5996.29,
    "override_total_1": 6166.43,
    "override_increase_1": 170.14
  },
  {
    "#": "465 Washington St, Unit 4 & P3 (171-57-03)",
    "$": 935200,
    "address": "465 Washington St, Unit 4 & P3",
    "parcel_id": "171-57-03",
    "owner1": "WONG, AMY W",
    "owner2": "MEDOLO, JOSEPH E",
    "current_taxes": 9576.45,
    "new_taxes_no_override": 9990.15,
    "override_total_1": 10273.62,
    "override_increase_1": 283.46
  },
  {
    "#": "465 Washington St, Unit 5 & P8 (171-57-04)",
    "$": 935100,
    "address": "465 Washington St, Unit 5 & P8",
    "parcel_id": "171-57-04",
    "owner1": "OCONNOR, LUKE JEN & ISABEL RUANE",
    "owner2": "",
    "current_taxes": 9575.42,
    "new_taxes_no_override": 9989.08,
    "override_total_1": 10272.51,
    "override_increase_1": 283.43
  },
  {
    "#": "465 Washington St, Unit 6 &  P7 (171-57-05)",
    "$": 940700,
    "address": "465 Washington St, Unit 6 &  P7",
    "parcel_id": "171-57-05",
    "owner1": "FU, YAYING",
    "owner2": "HU, GUOAN",
    "current_taxes": 5997.83,
    "new_taxes_no_override": 6256.94,
    "override_total_1": 6434.47,
    "override_increase_1": 177.54
  },
  {
    "#": "465 Washington St, Unit 7 & P1-2 (171-57-06)",
    "$": 1149900,
    "address": "465 Washington St, Unit 7 & P1-2",
    "parcel_id": "171-57-06",
    "owner1": "SUTTON, MARK & HELENA",
    "owner2": "",
    "current_taxes": 11774.98,
    "new_taxes_no_override": 12283.66,
    "override_total_1": 12632.2,
    "override_increase_1": 348.54
  },
  {
    "#": "471 Washington St, Unit 1 (171-58-15)",
    "$": 827500,
    "address": "471 Washington St, Unit 1",
    "parcel_id": "171-58-15",
    "owner1": "GORMAN, SHEILA M",
    "owner2": "",
    "current_taxes": 4838.67,
    "new_taxes_no_override": 5047.7,
    "override_total_1": 5190.93,
    "override_increase_1": 143.22
  },
  {
    "#": "471 Washington St, Unit 2 (171-58-01)",
    "$": 803800,
    "address": "471 Washington St, Unit 2",
    "parcel_id": "171-58-01",
    "owner1": "SCHEER, EDWARD H JR  & ANTONIA R",
    "owner2": "",
    "current_taxes": 4595.98,
    "new_taxes_no_override": 4794.53,
    "override_total_1": 4930.57,
    "override_increase_1": 136.04
  },
  {
    "#": "471 Washington St, Unit 3 (171-58-02)",
    "$": 881700,
    "address": "471 Washington St, Unit 3",
    "parcel_id": "171-58-02",
    "owner1": "ZHOU, YIKAI",
    "owner2": "",
    "current_taxes": 9028.61,
    "new_taxes_no_override": 9418.65,
    "override_total_1": 9685.89,
    "override_increase_1": 267.25
  },
  {
    "#": "471 Washington St, Unit 4 (171-58-03)",
    "$": 926000,
    "address": "471 Washington St, Unit 4",
    "parcel_id": "171-58-03",
    "owner1": "MENE XAVIER, CLAUDIA REGINA",
    "owner2": "",
    "current_taxes": 9482.24,
    "new_taxes_no_override": 9891.87,
    "override_total_1": 10172.55,
    "override_increase_1": 280.67
  },
  {
    "#": "471 Washington St, Unit 5 (171-58-04)",
    "$": 857100,
    "address": "471 Washington St, Unit 5",
    "parcel_id": "171-58-04",
    "owner1": "BAISSAC, MATHIEU",
    "owner2": "",
    "current_taxes": 8776.7,
    "new_taxes_no_override": 9155.85,
    "override_total_1": 9415.64,
    "override_increase_1": 259.79
  },
  {
    "#": "471 Washington St, Unit 6 (171-58-05)",
    "$": 914000,
    "address": "471 Washington St, Unit 6",
    "parcel_id": "171-58-05",
    "owner1": "RAMAKRISHNAN, SUBRAMANIAM & SRUTHI & SWATHI",
    "owner2": "",
    "current_taxes": 5724.43,
    "new_taxes_no_override": 5971.73,
    "override_total_1": 6141.17,
    "override_increase_1": 169.44
  },
  {
    "#": "471 Washington St, Unit 7 (171-58-06)",
    "$": 851700,
    "address": "471 Washington St, Unit 7",
    "parcel_id": "171-58-06",
    "owner1": "YAN, ZHIYONG",
    "owner2": "C/O WANTING NIU",
    "current_taxes": 8721.41,
    "new_taxes_no_override": 9098.17,
    "override_total_1": 9356.33,
    "override_increase_1": 258.15
  },
  {
    "#": "471 Washington St, Unit 8 (171-58-07)",
    "$": 916300,
    "address": "471 Washington St, Unit 8",
    "parcel_id": "171-58-07",
    "owner1": "KALISH, ISAAC",
    "owner2": "AKBARI, YASIN",
    "current_taxes": 5747.98,
    "new_taxes_no_override": 5996.29,
    "override_total_1": 6166.43,
    "override_increase_1": 170.14
  },
  {
    "#": "471 Washington St, Unit B (171-58-14)",
    "$": 835200,
    "address": "471 Washington St, Unit B",
    "parcel_id": "171-58-14",
    "owner1": "HILLENBRAND TR, LISA M",
    "owner2": "",
    "current_taxes": 4917.51,
    "new_taxes_no_override": 5129.95,
    "override_total_1": 5275.5,
    "override_increase_1": 145.56
  },
  {
    "#": "472 Washington St (208-04-00)",
    "$": 1667600,
    "address": "472 Washington St",
    "parcel_id": "208-04-00",
    "owner1": "RADZINSKY, ALEKSANDR & DINA",
    "owner2": "",
    "current_taxes": 13441.29,
    "new_taxes_no_override": 14021.95,
    "override_total_1": 14419.82,
    "override_increase_1": 397.86
  },
  {
    "#": "480 Washington St (208-03-00)",
    "$": 1779000,
    "address": "480 Washington St",
    "parcel_id": "208-03-00",
    "owner1": "LESCHINSKY, DEBORAH & DAVID",
    "owner2": "",
    "current_taxes": 14582.03,
    "new_taxes_no_override": 15211.97,
    "override_total_1": 15643.6,
    "override_increase_1": 431.63
  },
  {
    "#": "483 Washington St, Unit 1 (214-50-01)",
    "$": 1206300,
    "address": "483 Washington St, Unit 1",
    "parcel_id": "214-50-01",
    "owner1": "BUTTERS, MERYL",
    "owner2": "",
    "current_taxes": 8717.58,
    "new_taxes_no_override": 9094.18,
    "override_total_1": 9352.22,
    "override_increase_1": 258.04
  },
  {
    "#": "483 Washington St, Unit 2 (214-50-02)",
    "$": 1023300,
    "address": "483 Washington St, Unit 2",
    "parcel_id": "214-50-02",
    "owner1": "ISRAEL, NAFTALI",
    "owner2": "GIBELEY, RACHEL LYNN",
    "current_taxes": 10478.59,
    "new_taxes_no_override": 10931.27,
    "override_total_1": 11241.43,
    "override_increase_1": 310.17
  },
  {
    "#": "483 Washington St, Unit 3 (214-50-03)",
    "$": 963600,
    "address": "483 Washington St, Unit 3",
    "parcel_id": "214-50-03",
    "owner1": "FIORELLI, JESS T & PAMELA M",
    "owner2": "",
    "current_taxes": 6232.33,
    "new_taxes_no_override": 6501.57,
    "override_total_1": 6686.04,
    "override_increase_1": 184.48
  },
  {
    "#": "484 Washington St (208-02-00)",
    "$": 1934300,
    "address": "484 Washington St",
    "parcel_id": "208-02-00",
    "owner1": "ROSENBERG, MITCHELL L",
    "owner2": "SCHECTMAN, AMY N",
    "current_taxes": 16172.3,
    "new_taxes_no_override": 16870.94,
    "override_total_1": 17349.64,
    "override_increase_1": 478.7
  },
  {
    "#": "485 Washington St, Unit 2 (214-51-03)",
    "$": 933100,
    "address": "485 Washington St, Unit 2",
    "parcel_id": "214-51-03",
    "owner1": "MA, HONGYU",
    "owner2": "",
    "current_taxes": 9554.94,
    "new_taxes_no_override": 9967.71,
    "override_total_1": 10250.54,
    "override_increase_1": 282.83
  },
  {
    "#": "485 Washington St, Unit 3&Pksp C (214-51-01)",
    "$": 914800,
    "address": "485 Washington St, Unit 3&Pksp C",
    "parcel_id": "214-51-01",
    "owner1": "N A J R REALTY LLC",
    "owner2": "",
    "current_taxes": 9367.55,
    "new_taxes_no_override": 9772.23,
    "override_total_1": 10049.51,
    "override_increase_1": 277.28
  },
  {
    "#": "485 Washington St, Unit 4 & P-B (214-51-02)",
    "$": 917700,
    "address": "485 Washington St, Unit 4 & P-B",
    "parcel_id": "214-51-02",
    "owner1": "CHUANG, JACINTA S MA & THEODORE D",
    "owner2": "",
    "current_taxes": 9397.25,
    "new_taxes_no_override": 9803.21,
    "override_total_1": 10081.37,
    "override_increase_1": 278.16
  },
  {
    "#": "487 Washington St, Unit 1 & P4-P5 (214-52-03)",
    "$": 1182700,
    "address": "487 Washington St, Unit 1 & P4-P5",
    "parcel_id": "214-52-03",
    "owner1": "SHUBINA TRS, ANNA M & GALINA E",
    "owner2": "",
    "current_taxes": 12110.85,
    "new_taxes_no_override": 12634.04,
    "override_total_1": 12992.52,
    "override_increase_1": 358.48
  },
  {
    "#": "487 Washington St, Unit 2 & P2 (214-52-01)",
    "$": 891000,
    "address": "487 Washington St, Unit 2 & P2",
    "parcel_id": "214-52-01",
    "owner1": "PECI, ERION",
    "owner2": "JHA, RAJANI",
    "current_taxes": 9123.84,
    "new_taxes_no_override": 9517.99,
    "override_total_1": 9788.06,
    "override_increase_1": 270.07
  },
  {
    "#": "487 Washington St, Unit 3 & P1 (214-52-02)",
    "$": 999100,
    "address": "487 Washington St, Unit 3 & P1",
    "parcel_id": "214-52-02",
    "owner1": "NANDA, PRANAV",
    "owner2": "",
    "current_taxes": 10230.78,
    "new_taxes_no_override": 10672.75,
    "override_total_1": 10975.58,
    "override_increase_1": 302.83
  },
  {
    "#": "489 Washington St (214-53-00)",
    "$": 2166400,
    "address": "489 Washington St",
    "parcel_id": "214-53-00",
    "owner1": "FIELD CORPORATION",
    "owner2": "",
    "current_taxes": 22183.94,
    "new_taxes_no_override": 23142.29,
    "override_total_1": 23798.93,
    "override_increase_1": 656.64
  },
  {
    "#": "490 Washington St (208-01-00)",
    "$": 1793700,
    "address": "490 Washington St",
    "parcel_id": "208-01-00",
    "owner1": "LISS, KENNETH M",
    "owner2": "FEBLOWITZ, JILL",
    "current_taxes": 14732.55,
    "new_taxes_no_override": 15369.0,
    "override_total_1": 15805.08,
    "override_increase_1": 436.08
  },
  {
    "#": "496 Washington St (208-39-00)",
    "$": 1398900,
    "address": "496 Washington St",
    "parcel_id": "208-39-00",
    "owner1": "VINFEN CORPORATION",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "497 Washington St (214-54-00)",
    "$": 2790000,
    "address": "497 Washington St",
    "parcel_id": "214-54-00",
    "owner1": "SANIEOFF, ASHKAN",
    "owner2": "",
    "current_taxes": 28569.6,
    "new_taxes_no_override": 29803.81,
    "override_total_1": 30649.47,
    "override_increase_1": 845.66
  },
  {
    "#": "500 Washington St, Unit 1 (208-38-02)",
    "$": 964400,
    "address": "500 Washington St, Unit 1",
    "parcel_id": "208-38-02",
    "owner1": "BELOZERSKY TR, MARINA",
    "owner2": "",
    "current_taxes": 9875.46,
    "new_taxes_no_override": 10302.08,
    "override_total_1": 10594.39,
    "override_increase_1": 292.31
  },
  {
    "#": "500 Washington St, Unit 2 (208-38-01)",
    "$": 1146200,
    "address": "500 Washington St, Unit 2",
    "parcel_id": "208-38-01",
    "owner1": "REICHGOTT TR, STANLEY D & AVIVA",
    "owner2": "",
    "current_taxes": 8102.15,
    "new_taxes_no_override": 8452.16,
    "override_total_1": 8691.99,
    "override_increase_1": 239.82
  },
  {
    "#": "503 Washington St (214-55-00)",
    "$": 2235600,
    "address": "503 Washington St",
    "parcel_id": "214-55-00",
    "owner1": "MAIELLA, GERALD & KATHLEEN",
    "owner2": "",
    "current_taxes": 19257.61,
    "new_taxes_no_override": 20089.54,
    "override_total_1": 20659.56,
    "override_increase_1": 570.03
  },
  {
    "#": "504 Washington St (208-37-00)",
    "$": 2202700,
    "address": "504 Washington St",
    "parcel_id": "208-37-00",
    "owner1": "CIRO, M AIDA & FREDDY",
    "owner2": "",
    "current_taxes": 22555.65,
    "new_taxes_no_override": 23530.05,
    "override_total_1": 24197.7,
    "override_increase_1": 667.65
  },
  {
    "#": "508 Washington St (208-36-01)",
    "$": 1960700,
    "address": "508 Washington St",
    "parcel_id": "208-36-01",
    "owner1": "LEFMAN, TANIA & CHERYL M",
    "owner2": "",
    "current_taxes": 16442.63,
    "new_taxes_no_override": 17152.95,
    "override_total_1": 17639.65,
    "override_increase_1": 486.7
  },
  {
    "#": "512 Washington St (208-36-00)",
    "$": 1931100,
    "address": "512 Washington St",
    "parcel_id": "208-36-00",
    "owner1": "CHEUNG, BILL C H & ANNA S W",
    "owner2": "",
    "current_taxes": 19774.46,
    "new_taxes_no_override": 20628.72,
    "override_total_1": 21214.04,
    "override_increase_1": 585.32
  },
  {
    "#": "516 Washington St (208-35-00)",
    "$": 2597000,
    "address": "516 Washington St",
    "parcel_id": "208-35-00",
    "owner1": "SHING TRS, CHU KWOK",
    "owner2": "SOON, CHU GIN",
    "current_taxes": 26593.28,
    "new_taxes_no_override": 27742.11,
    "override_total_1": 28529.27,
    "override_increase_1": 787.16
  },
  {
    "#": "519 Washington St (212-15-00)",
    "$": 9345800,
    "address": "519 Washington St",
    "parcel_id": "212-15-00",
    "owner1": "JJC GRIGGS LLC",
    "owner2": "",
    "current_taxes": 95700.99,
    "new_taxes_no_override": 99835.27,
    "override_total_1": 102668.02,
    "override_increase_1": 2832.75
  },
  {
    "#": "520 Washington St (208-34-00)",
    "$": 1665300,
    "address": "520 Washington St",
    "parcel_id": "208-34-00",
    "owner1": "WETTSTEIN, GAL",
    "owner2": "NOBARI, NEZAM",
    "current_taxes": 13417.74,
    "new_taxes_no_override": 13997.39,
    "override_total_1": 14394.55,
    "override_increase_1": 397.17
  },
  {
    "#": "523 Washington St, Unit 1 (212-14-01)",
    "$": 2493800,
    "address": "523 Washington St, Unit 1",
    "parcel_id": "212-14-01",
    "owner1": "SCHWARTZ TRS, MARK J & SARAH B",
    "owner2": "",
    "current_taxes": 25536.51,
    "new_taxes_no_override": 26639.69,
    "override_total_1": 27395.57,
    "override_increase_1": 755.88
  },
  {
    "#": "523 Washington St, Unit 2 (212-14-02)",
    "$": 2626500,
    "address": "523 Washington St, Unit 2",
    "parcel_id": "212-14-02",
    "owner1": "RAJLIC, ALEKSANDAR & IVANA LIRIC",
    "owner2": "",
    "current_taxes": 23260.43,
    "new_taxes_no_override": 24265.28,
    "override_total_1": 24953.79,
    "override_increase_1": 688.51
  },
  {
    "#": "531 Washington St, Unit 1 (212-13-01)",
    "$": 2068700,
    "address": "531 Washington St, Unit 1",
    "parcel_id": "212-13-01",
    "owner1": "SHUNBO HATHOU, SHERINE",
    "owner2": "HATHOUT, JEAN P",
    "current_taxes": 17548.55,
    "new_taxes_no_override": 18306.65,
    "override_total_1": 18826.08,
    "override_increase_1": 519.44
  },
  {
    "#": "531 Washington St, Unit 2 (212-13-02)",
    "$": 2509600,
    "address": "531 Washington St, Unit 2",
    "parcel_id": "212-13-02",
    "owner1": "MCANDREWS, TERENCE",
    "owner2": "STEINBERG, EMMA",
    "current_taxes": 22063.37,
    "new_taxes_no_override": 23016.51,
    "override_total_1": 23669.58,
    "override_increase_1": 653.08
  },
  {
    "#": "537 Washington St, Unit 1 (212-12-01)",
    "$": 1101700,
    "address": "537 Washington St, Unit 1",
    "parcel_id": "212-12-01",
    "owner1": "FIGELMAN LIFE ESTATE, FRANCINE",
    "owner2": "",
    "current_taxes": 7646.47,
    "new_taxes_no_override": 7976.8,
    "override_total_1": 8203.13,
    "override_increase_1": 226.34
  },
  {
    "#": "537 Washington St, Unit 2 (212-12-02)",
    "$": 1586300,
    "address": "537 Washington St, Unit 2",
    "parcel_id": "212-12-02",
    "owner1": "TOTO, JONATHAN A & CHERYL",
    "owner2": "",
    "current_taxes": 12608.78,
    "new_taxes_no_override": 13153.48,
    "override_total_1": 13526.7,
    "override_increase_1": 373.22
  },
  {
    "#": "541 Washington St (212-11-00)",
    "$": 1835900,
    "address": "541 Washington St",
    "parcel_id": "212-11-00",
    "owner1": "POLLARD, CATHERINE MARY & WALTER S",
    "owner2": "C/O JMF WASHINGTON ST PARTNERS, LLC",
    "current_taxes": 18799.62,
    "new_taxes_no_override": 19611.76,
    "override_total_1": 20168.23,
    "override_increase_1": 556.47
  },
  {
    "#": "549 Washington St (212-09-00)",
    "$": 1828300,
    "address": "549 Washington St",
    "parcel_id": "212-09-00",
    "owner1": "SONENSHEIN, ABRAHAM L & GAIL E",
    "owner2": "",
    "current_taxes": 15086.86,
    "new_taxes_no_override": 15738.61,
    "override_total_1": 16185.18,
    "override_increase_1": 446.57
  },
  {
    "#": "563 Washington St, Unit 15 & Gar 1 (212-05-14)",
    "$": 785300,
    "address": "563 Washington St, Unit 15 & Gar 1",
    "parcel_id": "212-05-14",
    "owner1": "KLEYMAN, ILYA",
    "owner2": "STEIN, ELLA V",
    "current_taxes": 4406.54,
    "new_taxes_no_override": 4596.9,
    "override_total_1": 4727.34,
    "override_increase_1": 130.43
  },
  {
    "#": "563 Washington St, Unit 16 & Gar 8 (212-05-15)",
    "$": 803400,
    "address": "563 Washington St, Unit 16 & Gar 8",
    "parcel_id": "212-05-15",
    "owner1": "LADYZHENSKY, AVIVO L",
    "owner2": "",
    "current_taxes": 4591.88,
    "new_taxes_no_override": 4790.25,
    "override_total_1": 4926.17,
    "override_increase_1": 135.92
  },
  {
    "#": "563 Washington St, Unit 25 & P4 (212-05-24)",
    "$": 766200,
    "address": "563 Washington St, Unit 25 & P4",
    "parcel_id": "212-05-24",
    "owner1": "MITLIN, MATTHEW & LENA & ANATOLY",
    "owner2": "",
    "current_taxes": 4210.95,
    "new_taxes_no_override": 4392.86,
    "override_total_1": 4517.51,
    "override_increase_1": 124.64
  },
  {
    "#": "563 Washington St, Unit 26 & P-15 (212-05-25)",
    "$": 772200,
    "address": "563 Washington St, Unit 26 & P-15",
    "parcel_id": "212-05-25",
    "owner1": "WU, YUE",
    "owner2": "",
    "current_taxes": 4272.39,
    "new_taxes_no_override": 4456.96,
    "override_total_1": 4583.42,
    "override_increase_1": 126.46
  },
  {
    "#": "563 Washington St, Unit 35 & P-16 (212-05-34)",
    "$": 334500,
    "address": "563 Washington St, Unit 35 & P-16",
    "parcel_id": "212-05-34",
    "owner1": "PERRELLY, KAITLIN",
    "owner2": "",
    "current_taxes": 3425.28,
    "new_taxes_no_override": 3573.25,
    "override_total_1": 3674.64,
    "override_increase_1": 101.39
  },
  {
    "#": "563 Washington St, Unit 5 & P9 (212-05-04)",
    "$": 784800,
    "address": "563 Washington St, Unit 5 & P9",
    "parcel_id": "212-05-04",
    "owner1": "SOUTHMAYD, JOHN W & ELINNE GACU",
    "owner2": "",
    "current_taxes": 4401.42,
    "new_taxes_no_override": 4591.56,
    "override_total_1": 4721.84,
    "override_increase_1": 130.28
  },
  {
    "#": "563 Washington St, Unit 6 & Gar 3 (212-05-05)",
    "$": 772100,
    "address": "563 Washington St, Unit 6 & Gar 3",
    "parcel_id": "212-05-05",
    "owner1": "SEEGEL, LESLIE",
    "owner2": "C/O ALTMAN DAVID PERS REP",
    "current_taxes": 7906.3,
    "new_taxes_no_override": 8247.85,
    "override_total_1": 8481.88,
    "override_increase_1": 234.03
  },
  {
    "#": "569 Washington St, Unit 17 & G-18 (212-05-16)",
    "$": 809500,
    "address": "569 Washington St, Unit 17 & G-18",
    "parcel_id": "212-05-16",
    "owner1": "PALMER, JASON O",
    "owner2": "",
    "current_taxes": 8289.28,
    "new_taxes_no_override": 8647.38,
    "override_total_1": 8892.74,
    "override_increase_1": 245.36
  },
  {
    "#": "569 Washington St, Unit 18 & Gar 6 (212-05-17)",
    "$": 807800,
    "address": "569 Washington St, Unit 18 & Gar 6",
    "parcel_id": "212-05-17",
    "owner1": "YANG, JUN",
    "owner2": "ZHAO, JING",
    "current_taxes": 8271.87,
    "new_taxes_no_override": 8629.21,
    "override_total_1": 8874.06,
    "override_increase_1": 244.85
  },
  {
    "#": "569 Washington St, Unit 27 & P6 (212-05-26)",
    "$": 754200,
    "address": "569 Washington St, Unit 27 & P6",
    "parcel_id": "212-05-26",
    "owner1": "YE, BIN",
    "owner2": "LI, MIN",
    "current_taxes": 7723.01,
    "new_taxes_no_override": 8056.64,
    "override_total_1": 8285.25,
    "override_increase_1": 228.6
  },
  {
    "#": "569 Washington St, Unit 28 & G2-P3 (212-05-27)",
    "$": 820600,
    "address": "569 Washington St, Unit 28 & G2-P3",
    "parcel_id": "212-05-27",
    "owner1": "ISIKOFF TR, JEREMY",
    "owner2": "",
    "current_taxes": 4768.01,
    "new_taxes_no_override": 4973.99,
    "override_total_1": 5115.12,
    "override_increase_1": 141.13
  },
  {
    "#": "569 Washington St, Unit 7 G17 P2 (212-05-06)",
    "$": 818000,
    "address": "569 Washington St, Unit 7 G17 P2",
    "parcel_id": "212-05-06",
    "owner1": "LUNA, ARTHUR M & CRISTINA S",
    "owner2": "",
    "current_taxes": 8376.32,
    "new_taxes_no_override": 8738.18,
    "override_total_1": 8986.12,
    "override_increase_1": 247.94
  },
  {
    "#": "569 Washington St, Unit 8 & Gar 19 (212-05-07)",
    "$": 822300,
    "address": "569 Washington St, Unit 8 & Gar 19",
    "parcel_id": "212-05-07",
    "owner1": "CAZALA, LUIS FERNANDO AMARAL",
    "owner2": "FILARDO, MARIA NATALIA ROMERO",
    "current_taxes": 4785.42,
    "new_taxes_no_override": 4992.15,
    "override_total_1": 5133.8,
    "override_increase_1": 141.65
  },
  {
    "#": "573 Washington St, Unit 10 & Gar 9 (212-05-09)",
    "$": 804800,
    "address": "573 Washington St, Unit 10 & Gar 9",
    "parcel_id": "212-05-09",
    "owner1": "GRIMBERG, FANI",
    "owner2": "",
    "current_taxes": 4606.22,
    "new_taxes_no_override": 4805.21,
    "override_total_1": 4941.55,
    "override_increase_1": 136.34
  },
  {
    "#": "573 Washington St, Unit 19 & G-7 (212-05-18)",
    "$": 773300,
    "address": "573 Washington St, Unit 19 & G-7",
    "parcel_id": "212-05-18",
    "owner1": "KATS, ROMAN & YANA L",
    "owner2": "",
    "current_taxes": 7918.59,
    "new_taxes_no_override": 8260.67,
    "override_total_1": 8495.06,
    "override_increase_1": 234.39
  },
  {
    "#": "573 Washington St, Unit 20 G4-P21 (212-05-19)",
    "$": 826100,
    "address": "573 Washington St, Unit 20 G4-P21",
    "parcel_id": "212-05-19",
    "owner1": "SELDEN, JORDAN P",
    "owner2": "",
    "current_taxes": 4824.33,
    "new_taxes_no_override": 5032.74,
    "override_total_1": 5175.54,
    "override_increase_1": 142.8
  },
  {
    "#": "573 Washington St, Unit 29 & P19 (212-05-28)",
    "$": 730900,
    "address": "573 Washington St, Unit 29 & P19",
    "parcel_id": "212-05-28",
    "owner1": "ZHAO, HUI",
    "owner2": "",
    "current_taxes": 7484.42,
    "new_taxes_no_override": 7807.75,
    "override_total_1": 8029.29,
    "override_increase_1": 221.54
  },
  {
    "#": "573 Washington St, Unit 30 & Gar 5 (212-05-29)",
    "$": 806100,
    "address": "573 Washington St, Unit 30 & Gar 5",
    "parcel_id": "212-05-29",
    "owner1": "DENG, YANHUI",
    "owner2": "",
    "current_taxes": 4619.53,
    "new_taxes_no_override": 4819.09,
    "override_total_1": 4955.83,
    "override_increase_1": 136.74
  },
  {
    "#": "573 Washington St, Unit 9 & Gar 10 (212-05-08)",
    "$": 762300,
    "address": "573 Washington St, Unit 9 & Gar 10",
    "parcel_id": "212-05-08",
    "owner1": "RALPHINA LLC",
    "owner2": "",
    "current_taxes": 7805.95,
    "new_taxes_no_override": 8143.17,
    "override_total_1": 8374.22,
    "override_increase_1": 231.06
  },
  {
    "#": "575 Washington St (212-04-00)",
    "$": 2410200,
    "address": "575 Washington St",
    "parcel_id": "212-04-00",
    "owner1": "YOUNIS LIFE ESTATE, LINDA A & THOMAS J",
    "owner2": "",
    "current_taxes": 21045.51,
    "new_taxes_no_override": 21954.68,
    "override_total_1": 22577.62,
    "override_increase_1": 622.95
  },
  {
    "#": "576 Washington St, Unit 1 (211-15-07)",
    "$": 748500,
    "address": "576 Washington St, Unit 1",
    "parcel_id": "211-15-07",
    "owner1": "RUPP, JACQUELYN",
    "owner2": "OZIEBLOWSKI, JOZEF",
    "current_taxes": 4029.71,
    "new_taxes_no_override": 4203.79,
    "override_total_1": 4323.07,
    "override_increase_1": 119.28
  },
  {
    "#": "576 Washington St, Unit 2 (211-15-01)",
    "$": 909300,
    "address": "576 Washington St, Unit 2",
    "parcel_id": "211-15-01",
    "owner1": "MALTSEVA TRS, INNA",
    "owner2": "TARGAN, EUGENE",
    "current_taxes": 9311.23,
    "new_taxes_no_override": 9713.48,
    "override_total_1": 9989.09,
    "override_increase_1": 275.61
  },
  {
    "#": "576 Washington St, Unit 3 (211-15-02)",
    "$": 866300,
    "address": "576 Washington St, Unit 3",
    "parcel_id": "211-15-02",
    "owner1": "576 WASHINGTON ST #3 LLC",
    "owner2": "",
    "current_taxes": 8870.91,
    "new_taxes_no_override": 9254.13,
    "override_total_1": 9516.71,
    "override_increase_1": 262.58
  },
  {
    "#": "576 Washington St, Unit 4 (211-15-03)",
    "$": 900200,
    "address": "576 Washington St, Unit 4",
    "parcel_id": "211-15-03",
    "owner1": "MULDOWNEY, LESLIE B",
    "owner2": "",
    "current_taxes": 5583.11,
    "new_taxes_no_override": 5824.3,
    "override_total_1": 5989.56,
    "override_increase_1": 165.26
  },
  {
    "#": "576 Washington St, Unit 5 (211-15-04)",
    "$": 833500,
    "address": "576 Washington St, Unit 5",
    "parcel_id": "211-15-04",
    "owner1": "CHEN, XUN",
    "owner2": "TONG, KINH",
    "current_taxes": 4900.11,
    "new_taxes_no_override": 5111.79,
    "override_total_1": 5256.84,
    "override_increase_1": 145.04
  },
  {
    "#": "576 Washington St, Unit 6 (211-15-05)",
    "$": 1004100,
    "address": "576 Washington St, Unit 6",
    "parcel_id": "211-15-05",
    "owner1": "ANDAYA, ROBERTO",
    "owner2": "CHOO, SEO HYUN",
    "current_taxes": 6647.05,
    "new_taxes_no_override": 6934.2,
    "override_total_1": 7130.96,
    "override_increase_1": 196.75
  },
  {
    "#": "576 Washington St, Unit 7 (211-15-06)",
    "$": 456700,
    "address": "576 Washington St, Unit 7",
    "parcel_id": "211-15-06",
    "owner1": "YOUNIS, ROSALIND & MICHAEL  VINCENT",
    "owner2": "",
    "current_taxes": 4676.61,
    "new_taxes_no_override": 4878.64,
    "override_total_1": 5017.07,
    "override_increase_1": 138.43
  },
  {
    "#": "580 Washington St, Unit 1 & G1 (211-17-01)",
    "$": 990400,
    "address": "580 Washington St, Unit 1 & G1",
    "parcel_id": "211-17-01",
    "owner1": "JOHNSON, ETHAN M",
    "owner2": "GRANSER, ALEXA N",
    "current_taxes": 6506.76,
    "new_taxes_no_override": 6787.85,
    "override_total_1": 6980.45,
    "override_increase_1": 192.6
  },
  {
    "#": "580 Washington St, Unit 2&G2 G3 (211-17-02)",
    "$": 1484300,
    "address": "580 Washington St, Unit 2&G2 G3",
    "parcel_id": "211-17-02",
    "owner1": "LIM, SANGHEE",
    "owner2": "LEE, DONGWON",
    "current_taxes": 15199.23,
    "new_taxes_no_override": 15855.84,
    "override_total_1": 16305.73,
    "override_increase_1": 449.9
  },
  {
    "#": "584 Washington St (211-18-00)",
    "$": 2435400,
    "address": "584 Washington St",
    "parcel_id": "211-18-00",
    "owner1": "STERGIOS, JAMES",
    "owner2": "MACHIDA, RITSUKO",
    "current_taxes": 21303.56,
    "new_taxes_no_override": 22223.87,
    "override_total_1": 22854.46,
    "override_increase_1": 630.59
  },
  {
    "#": "585 Washington St (212-03-00)",
    "$": 1605500,
    "address": "585 Washington St",
    "parcel_id": "212-03-00",
    "owner1": "MOONEY TRS, RITA G",
    "owner2": "TZIMORANGAS, JOHN G",
    "current_taxes": 16440.32,
    "new_taxes_no_override": 17150.54,
    "override_total_1": 17637.18,
    "override_increase_1": 486.63
  },
  {
    "#": "586 Washington St, Unit 1 (211-19-22)",
    "$": 381000,
    "address": "586 Washington St, Unit 1",
    "parcel_id": "211-19-22",
    "owner1": "GLENSIDE PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 3901.44,
    "new_taxes_no_override": 4069.98,
    "override_total_1": 4185.46,
    "override_increase_1": 115.48
  },
  {
    "#": "586 Washington St, Unit 2 (211-19-01)",
    "$": 391600,
    "address": "586 Washington St, Unit 2",
    "parcel_id": "211-19-01",
    "owner1": "GLENSIDE PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 4009.98,
    "new_taxes_no_override": 4183.21,
    "override_total_1": 4301.91,
    "override_increase_1": 118.7
  },
  {
    "#": "586 Washington St, Unit 3 (211-19-06)",
    "$": 381000,
    "address": "586 Washington St, Unit 3",
    "parcel_id": "211-19-06",
    "owner1": "GLENSIDE PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 3901.44,
    "new_taxes_no_override": 4069.98,
    "override_total_1": 4185.46,
    "override_increase_1": 115.48
  },
  {
    "#": "586 Washington St, Unit 4 (211-19-07)",
    "$": 406900,
    "address": "586 Washington St, Unit 4",
    "parcel_id": "211-19-07",
    "owner1": "XU, CHANXING W",
    "owner2": "HUANG, ESTHER",
    "current_taxes": 4166.66,
    "new_taxes_no_override": 4346.66,
    "override_total_1": 4469.99,
    "override_increase_1": 123.33
  },
  {
    "#": "586 Washington St, Unit 5 (211-19-14)",
    "$": 385800,
    "address": "586 Washington St, Unit 5",
    "parcel_id": "211-19-14",
    "owner1": "CHOW TRS, HOWARD H & LISA W",
    "owner2": "",
    "current_taxes": 3950.59,
    "new_taxes_no_override": 4121.26,
    "override_total_1": 4238.19,
    "override_increase_1": 116.94
  },
  {
    "#": "586 Washington St, Unit 6 (211-19-15)",
    "$": 403500,
    "address": "586 Washington St, Unit 6",
    "parcel_id": "211-19-15",
    "owner1": "GLENSIDE PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 4131.84,
    "new_taxes_no_override": 4310.34,
    "override_total_1": 4432.64,
    "override_increase_1": 122.3
  },
  {
    "#": "588 Washington St, Unit 1 (211-19-08)",
    "$": 405600,
    "address": "588 Washington St, Unit 1",
    "parcel_id": "211-19-08",
    "owner1": "GLENSIDE PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 4153.34,
    "new_taxes_no_override": 4332.76,
    "override_total_1": 4455.7,
    "override_increase_1": 122.94
  },
  {
    "#": "588 Washington St, Unit 2 (211-19-09)",
    "$": 398600,
    "address": "588 Washington St, Unit 2",
    "parcel_id": "211-19-09",
    "owner1": "GLENSIDE PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 4081.66,
    "new_taxes_no_override": 4257.99,
    "override_total_1": 4378.8,
    "override_increase_1": 120.82
  },
  {
    "#": "588 Washington St, Unit 3 (211-19-16)",
    "$": 412700,
    "address": "588 Washington St, Unit 3",
    "parcel_id": "211-19-16",
    "owner1": "GLENSIDE PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 4226.05,
    "new_taxes_no_override": 4408.62,
    "override_total_1": 4533.71,
    "override_increase_1": 125.09
  },
  {
    "#": "588 Washington St, Unit 4 (211-19-17)",
    "$": 398600,
    "address": "588 Washington St, Unit 4",
    "parcel_id": "211-19-17",
    "owner1": "GLENSIDE PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 4081.66,
    "new_taxes_no_override": 4257.99,
    "override_total_1": 4378.8,
    "override_increase_1": 120.82
  },
  {
    "#": "588 Washington St, Unit A (211-19-02)",
    "$": 363800,
    "address": "588 Washington St, Unit A",
    "parcel_id": "211-19-02",
    "owner1": "GLENSIDE PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 3725.31,
    "new_taxes_no_override": 3886.24,
    "override_total_1": 3996.51,
    "override_increase_1": 110.27
  },
  {
    "#": "589 Washington St (212-02-00)",
    "$": 1999700,
    "address": "589 Washington St",
    "parcel_id": "212-02-00",
    "owner1": "RAO, P M V & UMA M P",
    "owner2": "",
    "current_taxes": 20476.93,
    "new_taxes_no_override": 21361.53,
    "override_total_1": 21967.65,
    "override_increase_1": 606.12
  },
  {
    "#": "590 Washington St, Unit 1 (211-19-10)",
    "$": 403300,
    "address": "590 Washington St, Unit 1",
    "parcel_id": "211-19-10",
    "owner1": "GLENSIDE PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 4129.79,
    "new_taxes_no_override": 4308.2,
    "override_total_1": 4430.44,
    "override_increase_1": 122.24
  },
  {
    "#": "590 Washington St, Unit 2 (211-19-11)",
    "$": 405600,
    "address": "590 Washington St, Unit 2",
    "parcel_id": "211-19-11",
    "owner1": "GLENSIDE PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 4153.34,
    "new_taxes_no_override": 4332.76,
    "override_total_1": 4455.7,
    "override_increase_1": 122.94
  },
  {
    "#": "590 Washington St, Unit 3 (211-19-18)",
    "$": 398600,
    "address": "590 Washington St, Unit 3",
    "parcel_id": "211-19-18",
    "owner1": "GLENSIDE PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 4081.66,
    "new_taxes_no_override": 4257.99,
    "override_total_1": 4378.8,
    "override_increase_1": 120.82
  },
  {
    "#": "590 Washington St, Unit 4 (211-19-19)",
    "$": 405600,
    "address": "590 Washington St, Unit 4",
    "parcel_id": "211-19-19",
    "owner1": "GLENSIDE PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 4153.34,
    "new_taxes_no_override": 4332.76,
    "override_total_1": 4455.7,
    "override_increase_1": 122.94
  },
  {
    "#": "590 Washington St, Unit A (211-19-03)",
    "$": 273200,
    "address": "590 Washington St, Unit A",
    "parcel_id": "211-19-03",
    "owner1": "GLENSIDE PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 2797.57,
    "new_taxes_no_override": 2918.43,
    "override_total_1": 3001.23,
    "override_increase_1": 82.81
  },
  {
    "#": "592 Washington St, Unit 1 (211-19-04)",
    "$": 417100,
    "address": "592 Washington St, Unit 1",
    "parcel_id": "211-19-04",
    "owner1": "GLENSIDE PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 4271.1,
    "new_taxes_no_override": 4455.61,
    "override_total_1": 4582.04,
    "override_increase_1": 126.42
  },
  {
    "#": "592 Washington St, Unit 2 (211-19-05)",
    "$": 381000,
    "address": "592 Washington St, Unit 2",
    "parcel_id": "211-19-05",
    "owner1": "GLENSIDE PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 3901.44,
    "new_taxes_no_override": 4069.98,
    "override_total_1": 4185.46,
    "override_increase_1": 115.48
  },
  {
    "#": "592 Washington St, Unit 3 (211-19-12)",
    "$": 391600,
    "address": "592 Washington St, Unit 3",
    "parcel_id": "211-19-12",
    "owner1": "GLENSIDE PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 4009.98,
    "new_taxes_no_override": 4183.21,
    "override_total_1": 4301.91,
    "override_increase_1": 118.7
  },
  {
    "#": "592 Washington St, Unit 4 (211-19-13)",
    "$": 381000,
    "address": "592 Washington St, Unit 4",
    "parcel_id": "211-19-13",
    "owner1": "GLENSIDE PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 3901.44,
    "new_taxes_no_override": 4069.98,
    "override_total_1": 4185.46,
    "override_increase_1": 115.48
  },
  {
    "#": "592 Washington St, Unit 5 (211-19-20)",
    "$": 403500,
    "address": "592 Washington St, Unit 5",
    "parcel_id": "211-19-20",
    "owner1": "RENTALS ONE LLC",
    "owner2": "",
    "current_taxes": 4131.84,
    "new_taxes_no_override": 4310.34,
    "override_total_1": 4432.64,
    "override_increase_1": 122.3
  },
  {
    "#": "592 Washington St, Unit 6 (211-19-21)",
    "$": 381000,
    "address": "592 Washington St, Unit 6",
    "parcel_id": "211-19-21",
    "owner1": "GLENSIDE PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 3901.44,
    "new_taxes_no_override": 4069.98,
    "override_total_1": 4185.46,
    "override_increase_1": 115.48
  },
  {
    "#": "594 Washington St, Unit 594 (211-21-01)",
    "$": 876300,
    "address": "594 Washington St, Unit 594",
    "parcel_id": "211-21-01",
    "owner1": "RAFATI, MASOUD",
    "owner2": "SAFAEE, POURAN",
    "current_taxes": 5338.38,
    "new_taxes_no_override": 5569.0,
    "override_total_1": 5727.01,
    "override_increase_1": 158.02
  },
  {
    "#": "594 Washington St, Unit 596 (211-21-02)",
    "$": 945700,
    "address": "594 Washington St, Unit 596",
    "parcel_id": "211-21-02",
    "owner1": "RAFATI, BEHNAM",
    "owner2": "",
    "current_taxes": 9683.97,
    "new_taxes_no_override": 10102.32,
    "override_total_1": 10388.96,
    "override_increase_1": 286.65
  },
  {
    "#": "598 Washington St, Unit 598 (211-22-01)",
    "$": 1195500,
    "address": "598 Washington St, Unit 598",
    "parcel_id": "211-22-01",
    "owner1": "LIOR TRS, DAVID & SANDRA OKIN",
    "owner2": "",
    "current_taxes": 8606.99,
    "new_taxes_no_override": 8978.81,
    "override_total_1": 9233.58,
    "override_increase_1": 254.77
  },
  {
    "#": "599 Washington St (212-01-00)",
    "$": 2143700,
    "address": "599 Washington St",
    "parcel_id": "212-01-00",
    "owner1": "LE CANNET LLC",
    "owner2": "",
    "current_taxes": 21951.49,
    "new_taxes_no_override": 22899.79,
    "override_total_1": 23549.56,
    "override_increase_1": 649.76
  },
  {
    "#": "600 Washington St, Unit 600 (211-22-02)",
    "$": 1239300,
    "address": "600 Washington St, Unit 600",
    "parcel_id": "211-22-02",
    "owner1": "HANSEN, DEBORAH J",
    "owner2": "",
    "current_taxes": 9055.5,
    "new_taxes_no_override": 9446.7,
    "override_total_1": 9714.74,
    "override_increase_1": 268.04
  },
  {
    "#": "602 Washington St (211-23-00)",
    "$": 455100,
    "address": "602 Washington St",
    "parcel_id": "211-23-00",
    "owner1": "HALL TRS, JACKSON",
    "owner2": "TRASK, ANNA M",
    "current_taxes": 4660.22,
    "new_taxes_no_override": 4861.54,
    "override_total_1": 4999.48,
    "override_increase_1": 137.94
  },
  {
    "#": "606 Washington St, Unit 1 (211-24-03)",
    "$": 871300,
    "address": "606 Washington St, Unit 1",
    "parcel_id": "211-24-03",
    "owner1": "HARK, PHILIP",
    "owner2": "ROLBEIN, FAYE",
    "current_taxes": 5287.18,
    "new_taxes_no_override": 5515.59,
    "override_total_1": 5672.09,
    "override_increase_1": 156.5
  },
  {
    "#": "608 Washington St, Unit 2 (211-24-02)",
    "$": 1115900,
    "address": "608 Washington St, Unit 2",
    "parcel_id": "211-24-02",
    "owner1": "WALLACE, JAMES D & ELIZABETH K",
    "owner2": "",
    "current_taxes": 7791.88,
    "new_taxes_no_override": 8128.49,
    "override_total_1": 8359.13,
    "override_increase_1": 230.64
  },
  {
    "#": "609 Washington St, Unit 1 (214-83-01)",
    "$": 983000,
    "address": "609 Washington St, Unit 1",
    "parcel_id": "214-83-01",
    "owner1": "BENYISRAEL TRS, YITZHAK",
    "owner2": "GALAMBOS, A",
    "current_taxes": 10065.92,
    "new_taxes_no_override": 10500.77,
    "override_total_1": 10798.72,
    "override_increase_1": 297.95
  },
  {
    "#": "609 Washington St, Unit 2 (214-83-02)",
    "$": 1036500,
    "address": "609 Washington St, Unit 2",
    "parcel_id": "214-83-02",
    "owner1": "GALL, TR, DANIEL",
    "owner2": "",
    "current_taxes": 10613.76,
    "new_taxes_no_override": 11072.27,
    "override_total_1": 11386.44,
    "override_increase_1": 314.17
  },
  {
    "#": "610 Washington St (211-24-01)",
    "$": 1755800,
    "address": "610 Washington St",
    "parcel_id": "211-24-01",
    "owner1": "HALL TRS, JACKSON",
    "owner2": "TRASK, ANNA M",
    "current_taxes": 14344.46,
    "new_taxes_no_override": 14964.14,
    "override_total_1": 15388.74,
    "override_increase_1": 424.6
  },
  {
    "#": "611 Washington St (214-84-00)",
    "$": 1604700,
    "address": "611 Washington St",
    "parcel_id": "214-84-00",
    "owner1": "GALL, TRS, DANIEL",
    "owner2": "",
    "current_taxes": 12797.19,
    "new_taxes_no_override": 13350.03,
    "override_total_1": 13728.83,
    "override_increase_1": 378.8
  },
  {
    "#": "615 Washington St, Unit 615 (214-01-05)",
    "$": 836100,
    "address": "615 Washington St, Unit 615",
    "parcel_id": "214-01-05",
    "owner1": "ROBERTS TR, SUSANE",
    "owner2": "MCGOUGH, SHANA",
    "current_taxes": 4926.73,
    "new_taxes_no_override": 5139.56,
    "override_total_1": 5285.4,
    "override_increase_1": 145.83
  },
  {
    "#": "616 Washington St, Unit 1 (211-25-03)",
    "$": 1536400,
    "address": "616 Washington St, Unit 1",
    "parcel_id": "211-25-03",
    "owner1": "LIANG, JOHN T",
    "owner2": "HYDE, PHOEBE B",
    "current_taxes": 12097.8,
    "new_taxes_no_override": 12620.42,
    "override_total_1": 12978.52,
    "override_increase_1": 358.09
  },
  {
    "#": "617 Washington St, Unit 617 (214-01-01)",
    "$": 1228400,
    "address": "617 Washington St, Unit 617",
    "parcel_id": "214-01-01",
    "owner1": "FORREST, SUZANNE",
    "owner2": "WONG, DANIEL J",
    "current_taxes": 8943.88,
    "new_taxes_no_override": 9330.26,
    "override_total_1": 9594.99,
    "override_increase_1": 264.74
  },
  {
    "#": "618 Washington St, Unit 2 (211-25-01)",
    "$": 1405000,
    "address": "618 Washington St, Unit 2",
    "parcel_id": "211-25-01",
    "owner1": "WULFSON, JEFFREY R",
    "owner2": "LANGA, MELISSA F",
    "current_taxes": 10752.27,
    "new_taxes_no_override": 11216.77,
    "override_total_1": 11535.04,
    "override_increase_1": 318.27
  },
  {
    "#": "619 Washington St, Unit 619 & P-11 (214-01-02)",
    "$": 810400,
    "address": "619 Washington St, Unit 619 & P-11",
    "parcel_id": "214-01-02",
    "owner1": "JACOBS, LAURIE A",
    "owner2": "",
    "current_taxes": 8298.5,
    "new_taxes_no_override": 8657.0,
    "override_total_1": 8902.63,
    "override_increase_1": 245.64
  },
  {
    "#": "620 Washington St, Unit 3 (211-25-02)",
    "$": 1424100,
    "address": "620 Washington St, Unit 3",
    "parcel_id": "211-25-02",
    "owner1": "GERRIE, JUNE",
    "owner2": "MICHAELSON, IRA",
    "current_taxes": 14582.78,
    "new_taxes_no_override": 15212.76,
    "override_total_1": 15644.41,
    "override_increase_1": 431.65
  },
  {
    "#": "626 Washington St, Unit 1  (216-01-01)",
    "$": 1015400,
    "address": "626 Washington St, Unit 1 ",
    "parcel_id": "216-01-01",
    "owner1": "LY, KUONG",
    "owner2": "RANGER, BRYAN",
    "current_taxes": 6762.76,
    "new_taxes_no_override": 7054.91,
    "override_total_1": 7255.09,
    "override_increase_1": 200.18
  },
  {
    "#": "626 Washington St, Unit 2 & G4 (216-01-02)",
    "$": 821300,
    "address": "626 Washington St, Unit 2 & G4",
    "parcel_id": "216-01-02",
    "owner1": "HO, SUNG TAT RICHARD & CARMEN",
    "owner2": "HUI, CHUI LIN SUSANNA",
    "current_taxes": 4775.18,
    "new_taxes_no_override": 4981.47,
    "override_total_1": 5122.81,
    "override_increase_1": 141.35
  },
  {
    "#": "626 Washington St, Unit 3 & G1 (216-01-03)",
    "$": 1159400,
    "address": "626 Washington St, Unit 3 & G1",
    "parcel_id": "216-01-03",
    "owner1": "SMITH, BENJAMIN A",
    "owner2": "",
    "current_taxes": 11872.26,
    "new_taxes_no_override": 12385.14,
    "override_total_1": 12736.56,
    "override_increase_1": 351.42
  },
  {
    "#": "626 Washington St, Unit 4 & G3-17 (216-01-04)",
    "$": 1158500,
    "address": "626 Washington St, Unit 4 & G3-17",
    "parcel_id": "216-01-04",
    "owner1": "STALCUP TR, NAZNEEN P",
    "owner2": "STALCUP, THOMAS F",
    "current_taxes": 8228.11,
    "new_taxes_no_override": 8583.56,
    "override_total_1": 8827.12,
    "override_increase_1": 243.55
  },
  {
    "#": "626 Washington St, Unit G-18 (216-01-18)",
    "$": 90800,
    "address": "626 Washington St, Unit G-18",
    "parcel_id": "216-01-18",
    "owner1": "FRANK-KANENETSKII, MAXIM D",
    "owner2": "",
    "current_taxes": 929.79,
    "new_taxes_no_override": 969.96,
    "override_total_1": 997.48,
    "override_increase_1": 27.52
  },
  {
    "#": "626 Washington St, Unit G-19 (216-01-16)",
    "$": 90800,
    "address": "626 Washington St, Unit G-19",
    "parcel_id": "216-01-16",
    "owner1": "WASHINGTON TERRACE CONDOMINIUM TRUST",
    "owner2": "C/O JENNESS KEVIN M & REBECCA A",
    "current_taxes": 929.79,
    "new_taxes_no_override": 969.96,
    "override_total_1": 997.48,
    "override_increase_1": 27.52
  },
  {
    "#": "626 Washington St, Unit G-2 (216-01-15)",
    "$": 90800,
    "address": "626 Washington St, Unit G-2",
    "parcel_id": "216-01-15",
    "owner1": "WASHINGTON TERRACE CONDOMINIUM TRUST",
    "owner2": "C/O CASSIS BEATRICE",
    "current_taxes": 929.79,
    "new_taxes_no_override": 969.96,
    "override_total_1": 997.48,
    "override_increase_1": 27.52
  },
  {
    "#": "626 Washington St, Unit G-20 (216-01-17)",
    "$": 90800,
    "address": "626 Washington St, Unit G-20",
    "parcel_id": "216-01-17",
    "owner1": "WASHINGTON TERRACE CONDOMINIUM TRUST",
    "owner2": "C/O GONIK ARKADY & IRENA",
    "current_taxes": 929.79,
    "new_taxes_no_override": 969.96,
    "override_total_1": 997.48,
    "override_increase_1": 27.52
  },
  {
    "#": "626 Washington St, Unit G-5 (216-01-13)",
    "$": 90800,
    "address": "626 Washington St, Unit G-5",
    "parcel_id": "216-01-13",
    "owner1": "TAYLOR, KATHLEEN",
    "owner2": "",
    "current_taxes": 929.79,
    "new_taxes_no_override": 969.96,
    "override_total_1": 997.48,
    "override_increase_1": 27.52
  },
  {
    "#": "626 Washington St, Unit G-9 (216-01-14)",
    "$": 90800,
    "address": "626 Washington St, Unit G-9",
    "parcel_id": "216-01-14",
    "owner1": "AGAMOV, ANDREY & ALLA",
    "owner2": "",
    "current_taxes": 929.79,
    "new_taxes_no_override": 969.96,
    "override_total_1": 997.48,
    "override_increase_1": 27.52
  },
  {
    "#": "626 Washington St, Unit G13 (216-01-19)",
    "$": 90800,
    "address": "626 Washington St, Unit G13",
    "parcel_id": "216-01-19",
    "owner1": "MURRAY, TARA A",
    "owner2": "MARTIN, JOHN-CHRISTOPHER G",
    "current_taxes": 929.79,
    "new_taxes_no_override": 969.96,
    "override_total_1": 997.48,
    "override_increase_1": 27.52
  },
  {
    "#": "628 Washington St, Unit 1 & G10 (216-01-05)",
    "$": 829900,
    "address": "628 Washington St, Unit 1 & G10",
    "parcel_id": "216-01-05",
    "owner1": "PLOTKIN, ALEXANDER",
    "owner2": "KOCHEROVSKAYA, MARINA",
    "current_taxes": 4863.24,
    "new_taxes_no_override": 5073.33,
    "override_total_1": 5217.28,
    "override_increase_1": 143.95
  },
  {
    "#": "628 Washington St, Unit 2 & G8 (216-01-06)",
    "$": 848500,
    "address": "628 Washington St, Unit 2 & G8",
    "parcel_id": "216-01-06",
    "owner1": "COHEN, ALON N",
    "owner2": "",
    "current_taxes": 8688.64,
    "new_taxes_no_override": 9063.99,
    "override_total_1": 9321.17,
    "override_increase_1": 257.18
  },
  {
    "#": "628 Washington St, Unit 3 & G11 (216-01-07)",
    "$": 1054200,
    "address": "628 Washington St, Unit 3 & G11",
    "parcel_id": "216-01-07",
    "owner1": "POON, ANTONIO CHI KEUNG & AUDREY HO YEE",
    "owner2": "",
    "current_taxes": 10795.01,
    "new_taxes_no_override": 11261.35,
    "override_total_1": 11580.89,
    "override_increase_1": 319.53
  },
  {
    "#": "628 Washington St, Unit 4 & G7 (216-01-08)",
    "$": 1096200,
    "address": "628 Washington St, Unit 4 & G7",
    "parcel_id": "216-01-08",
    "owner1": "TAHOORI, ET AL, MEHDI BARADARAN",
    "owner2": "",
    "current_taxes": 11225.09,
    "new_taxes_no_override": 11710.01,
    "override_total_1": 12042.28,
    "override_increase_1": 332.26
  },
  {
    "#": "630 Washington St, Unit 1 & G14 (216-01-09)",
    "$": 848500,
    "address": "630 Washington St, Unit 1 & G14",
    "parcel_id": "216-01-09",
    "owner1": "SHISHKIN, EDUARD ALEKSANDROVICH",
    "owner2": "VITKINA, OLGA ASANOVNA",
    "current_taxes": 8688.64,
    "new_taxes_no_override": 9063.99,
    "override_total_1": 9321.17,
    "override_increase_1": 257.18
  },
  {
    "#": "630 Washington St, Unit 2 & G15 (216-01-10)",
    "$": 923200,
    "address": "630 Washington St, Unit 2 & G15",
    "parcel_id": "216-01-10",
    "owner1": "LI, XIAOTONG",
    "owner2": "",
    "current_taxes": 5818.63,
    "new_taxes_no_override": 6069.99,
    "override_total_1": 6242.23,
    "override_increase_1": 172.23
  },
  {
    "#": "630 Washington St, Unit 3 & G16 (216-01-11)",
    "$": 1096200,
    "address": "630 Washington St, Unit 3 & G16",
    "parcel_id": "216-01-11",
    "owner1": "EL-CHEMALY, SOUHEIL",
    "owner2": "LIM, RAMONA",
    "current_taxes": 7590.15,
    "new_taxes_no_override": 7918.04,
    "override_total_1": 8142.71,
    "override_increase_1": 224.67
  },
  {
    "#": "630 Washington St, Unit 4 & G12 (216-01-12)",
    "$": 1099900,
    "address": "630 Washington St, Unit 4 & G12",
    "parcel_id": "216-01-12",
    "owner1": "CHEN, YI DA",
    "owner2": "",
    "current_taxes": 7628.04,
    "new_taxes_no_override": 7957.57,
    "override_total_1": 8183.36,
    "override_increase_1": 225.79
  },
  {
    "#": "636 Washington St (216-02-00)",
    "$": 2849300,
    "address": "636 Washington St",
    "parcel_id": "216-02-00",
    "owner1": "SHARAF TR, ALAN B",
    "owner2": "",
    "current_taxes": 29176.83,
    "new_taxes_no_override": 30437.27,
    "override_total_1": 31300.9,
    "override_increase_1": 863.63
  },
  {
    "#": "637 Washington St (215-02-03)",
    "$": 11800000,
    "address": "637 Washington St",
    "parcel_id": "215-02-03",
    "owner1": "COHEN, ET AL TRS, GERALD D",
    "owner2": "C/O CGI MANAGEMENT INC",
    "current_taxes": 202488.0,
    "new_taxes_no_override": 211235.48,
    "override_total_1": 217229.13,
    "override_increase_1": 5993.64
  },
  {
    "#": "638 Washington St, Unit 1 (216-02-03)",
    "$": 695100,
    "address": "638 Washington St, Unit 1",
    "parcel_id": "216-02-03",
    "owner1": "ROUSKIN-FAUST, TYLER",
    "owner2": "ROUSKIN, SILVI",
    "current_taxes": 7117.82,
    "new_taxes_no_override": 7425.31,
    "override_total_1": 7636.0,
    "override_increase_1": 210.69
  },
  {
    "#": "638 Washington St, Unit 2 (216-02-04)",
    "$": 814500,
    "address": "638 Washington St, Unit 2",
    "parcel_id": "216-02-04",
    "owner1": "ANQUETIL, PATRICK A",
    "owner2": "MANCHANDA, NITASHA",
    "current_taxes": 8340.48,
    "new_taxes_no_override": 8700.79,
    "override_total_1": 8947.67,
    "override_increase_1": 246.88
  },
  {
    "#": "638 Washington St, Unit 3 (216-02-05)",
    "$": 857600,
    "address": "638 Washington St, Unit 3",
    "parcel_id": "216-02-05",
    "owner1": "IBANEZ, ANTONIO",
    "owner2": "MENDELSOHN, DARA",
    "current_taxes": 8781.82,
    "new_taxes_no_override": 9161.19,
    "override_total_1": 9421.14,
    "override_increase_1": 259.94
  },
  {
    "#": "640 Washington St, Unit 1 (216-02-08)",
    "$": 784500,
    "address": "640 Washington St, Unit 1",
    "parcel_id": "216-02-08",
    "owner1": "RAGAN, SANDRA LEE",
    "owner2": "",
    "current_taxes": 4398.35,
    "new_taxes_no_override": 4588.36,
    "override_total_1": 4718.55,
    "override_increase_1": 130.19
  },
  {
    "#": "640 Washington St, Unit 2 (216-02-09)",
    "$": 921600,
    "address": "640 Washington St, Unit 2",
    "parcel_id": "216-02-09",
    "owner1": "PERSITS, LEV & NILI",
    "owner2": "",
    "current_taxes": 5802.25,
    "new_taxes_no_override": 6052.91,
    "override_total_1": 6224.65,
    "override_increase_1": 171.75
  },
  {
    "#": "640 Washington St, Unit 3 (216-02-10)",
    "$": 853300,
    "address": "640 Washington St, Unit 3",
    "parcel_id": "216-02-10",
    "owner1": "VIANELLO, ALESSANDRO",
    "owner2": "GALLIN, MELISSA K",
    "current_taxes": 5102.86,
    "new_taxes_no_override": 5323.3,
    "override_total_1": 5474.35,
    "override_increase_1": 151.04
  },
  {
    "#": "648 Washington St, Unit 1 & P12 (216-03-14)",
    "$": 808400,
    "address": "648 Washington St, Unit 1 & P12",
    "parcel_id": "216-03-14",
    "owner1": "REEVES, CARLA A",
    "owner2": "BORRERO, LUIS",
    "current_taxes": 4643.08,
    "new_taxes_no_override": 4843.66,
    "override_total_1": 4981.1,
    "override_increase_1": 137.44
  },
  {
    "#": "648 Washington St, Unit 2 (216-03-01)",
    "$": 782600,
    "address": "648 Washington St, Unit 2",
    "parcel_id": "216-03-01",
    "owner1": "GHAFARI, RAMESH",
    "owner2": "",
    "current_taxes": 8013.82,
    "new_taxes_no_override": 8360.02,
    "override_total_1": 8597.23,
    "override_increase_1": 237.21
  },
  {
    "#": "648 Washington St, Unit 3 (216-03-02)",
    "$": 776900,
    "address": "648 Washington St, Unit 3",
    "parcel_id": "216-03-02",
    "owner1": "ANANTHAKRISHNAN, SONIA",
    "owner2": "",
    "current_taxes": 7955.46,
    "new_taxes_no_override": 8299.14,
    "override_total_1": 8534.62,
    "override_increase_1": 235.48
  },
  {
    "#": "648 Washington St, Unit 4 (216-03-03)",
    "$": 773800,
    "address": "648 Washington St, Unit 4",
    "parcel_id": "216-03-03",
    "owner1": "BOESZOERMENYI, ANDRAS & BARBARA ANETA",
    "owner2": "",
    "current_taxes": 4288.78,
    "new_taxes_no_override": 4474.06,
    "override_total_1": 4601.0,
    "override_increase_1": 126.95
  },
  {
    "#": "648 Washington St, Unit 5 (216-03-04)",
    "$": 776900,
    "address": "648 Washington St, Unit 5",
    "parcel_id": "216-03-04",
    "owner1": "TUCKER TRS, SCOTT R & JILL N",
    "owner2": "",
    "current_taxes": 7955.46,
    "new_taxes_no_override": 8299.14,
    "override_total_1": 8534.62,
    "override_increase_1": 235.48
  },
  {
    "#": "648 Washington St, Unit 6 (216-03-05)",
    "$": 792700,
    "address": "648 Washington St, Unit 6",
    "parcel_id": "216-03-05",
    "owner1": "LIANG, HONGYAN",
    "owner2": "",
    "current_taxes": 8117.25,
    "new_taxes_no_override": 8467.92,
    "override_total_1": 8708.19,
    "override_increase_1": 240.27
  },
  {
    "#": "648 Washington St, Unit 7 (216-03-06)",
    "$": 776900,
    "address": "648 Washington St, Unit 7",
    "parcel_id": "216-03-06",
    "owner1": "HOFF, GARY L",
    "owner2": "",
    "current_taxes": 7955.46,
    "new_taxes_no_override": 8299.14,
    "override_total_1": 8534.62,
    "override_increase_1": 235.48
  },
  {
    "#": "652 Washington St, Unit 1 & P-32 (216-03-07)",
    "$": 801700,
    "address": "652 Washington St, Unit 1 & P-32",
    "parcel_id": "216-03-07",
    "owner1": "NG, KIT YUNG KAREN",
    "owner2": "",
    "current_taxes": 4574.47,
    "new_taxes_no_override": 4772.09,
    "override_total_1": 4907.49,
    "override_increase_1": 135.4
  },
  {
    "#": "652 Washington St, Unit 2 (216-03-08)",
    "$": 773800,
    "address": "652 Washington St, Unit 2",
    "parcel_id": "216-03-08",
    "owner1": "LEVKOVICH, BORIS & IRINA",
    "owner2": "",
    "current_taxes": 4288.78,
    "new_taxes_no_override": 4474.06,
    "override_total_1": 4601.0,
    "override_increase_1": 126.95
  },
  {
    "#": "652 Washington St, Unit 3 (216-03-09)",
    "$": 808400,
    "address": "652 Washington St, Unit 3",
    "parcel_id": "216-03-09",
    "owner1": "ZONG, GENG",
    "owner2": "ZHU, JINGWEN",
    "current_taxes": 8278.02,
    "new_taxes_no_override": 8635.63,
    "override_total_1": 8880.66,
    "override_increase_1": 245.03
  },
  {
    "#": "652 Washington St, Unit 4 & P3 (216-03-10)",
    "$": 792700,
    "address": "652 Washington St, Unit 4 & P3",
    "parcel_id": "216-03-10",
    "owner1": "AFACAN, ONUR",
    "owner2": "KURUGOL, SILA",
    "current_taxes": 4482.31,
    "new_taxes_no_override": 4675.95,
    "override_total_1": 4808.62,
    "override_increase_1": 132.68
  },
  {
    "#": "652 Washington St, Unit 5 (216-03-11)",
    "$": 795800,
    "address": "652 Washington St, Unit 5",
    "parcel_id": "216-03-11",
    "owner1": "WANG, BETTY CHUNGMEI",
    "owner2": "REINHARD, BJOERN",
    "current_taxes": 8148.99,
    "new_taxes_no_override": 8501.03,
    "override_total_1": 8742.24,
    "override_increase_1": 241.21
  },
  {
    "#": "652 Washington St, Unit 6 (216-03-12)",
    "$": 788500,
    "address": "652 Washington St, Unit 6",
    "parcel_id": "216-03-12",
    "owner1": "YAN, FEIFEI",
    "owner2": "",
    "current_taxes": 4439.31,
    "new_taxes_no_override": 4631.09,
    "override_total_1": 4762.49,
    "override_increase_1": 131.4
  },
  {
    "#": "652 Washington St, Unit 7 (216-03-13)",
    "$": 795800,
    "address": "652 Washington St, Unit 7",
    "parcel_id": "216-03-13",
    "owner1": "CHENG, LONG",
    "owner2": "SU, YI",
    "current_taxes": 4514.06,
    "new_taxes_no_override": 4709.07,
    "override_total_1": 4842.68,
    "override_increase_1": 133.62
  },
  {
    "#": "655 Washington St, Unit 1 (215-04-02)",
    "$": 1504200,
    "address": "655 Washington St, Unit 1",
    "parcel_id": "215-04-02",
    "owner1": "CHOW TR, JOHN",
    "owner2": "",
    "current_taxes": 15403.01,
    "new_taxes_no_override": 16068.42,
    "override_total_1": 16524.35,
    "override_increase_1": 455.93
  },
  {
    "#": "657 Washington St, Unit 2 (215-04-01)",
    "$": 1364600,
    "address": "657 Washington St, Unit 2",
    "parcel_id": "215-04-01",
    "owner1": "CHOW TR, JOHN",
    "owner2": "",
    "current_taxes": 13973.5,
    "new_taxes_no_override": 14577.16,
    "override_total_1": 14990.77,
    "override_increase_1": 413.62
  },
  {
    "#": "658 Washington St (216-05-00)",
    "$": 2498500,
    "address": "658 Washington St",
    "parcel_id": "216-05-00",
    "owner1": "FU TR, XIANG",
    "owner2": "",
    "current_taxes": 21949.71,
    "new_taxes_no_override": 22897.94,
    "override_total_1": 23547.65,
    "override_increase_1": 649.71
  },
  {
    "#": "659 Washington St (215-05-01)",
    "$": 1782700,
    "address": "659 Washington St",
    "parcel_id": "215-05-01",
    "owner1": "CHUNG, JOU-KU",
    "owner2": "SCHENA, ANGELA",
    "current_taxes": 14619.91,
    "new_taxes_no_override": 15251.49,
    "override_total_1": 15684.24,
    "override_increase_1": 432.75
  },
  {
    "#": "661 Washington St (215-05-02)",
    "$": 1440100,
    "address": "661 Washington St",
    "parcel_id": "215-05-02",
    "owner1": "SOKOLOW, RENA A",
    "owner2": "ANDERSON, JOHN T",
    "current_taxes": 11111.69,
    "new_taxes_no_override": 11591.72,
    "override_total_1": 11920.62,
    "override_increase_1": 328.91
  },
  {
    "#": "662 Washington St, Unit 1 (216-06-01)",
    "$": 175400,
    "address": "662 Washington St, Unit 1",
    "parcel_id": "216-06-01",
    "owner1": "MALKIN, ROSE",
    "owner2": "",
    "current_taxes": 1796.1,
    "new_taxes_no_override": 1873.69,
    "override_total_1": 1926.86,
    "override_increase_1": 53.16
  },
  {
    "#": "662 Washington St, Unit 10 (216-06-10)",
    "$": 163100,
    "address": "662 Washington St, Unit 10",
    "parcel_id": "216-06-10",
    "owner1": "PORTER, TR, SUSAN M",
    "owner2": "",
    "current_taxes": 1670.14,
    "new_taxes_no_override": 1742.29,
    "override_total_1": 1791.73,
    "override_increase_1": 49.44
  },
  {
    "#": "662 Washington St, Unit 2 (216-06-02)",
    "$": 147500,
    "address": "662 Washington St, Unit 2",
    "parcel_id": "216-06-02",
    "owner1": "BAYLES, TRS, RICHARD-MARGARET-KEITH",
    "owner2": "",
    "current_taxes": 151.04,
    "new_taxes_no_override": 157.56,
    "override_total_1": 162.04,
    "override_increase_1": 4.47
  },
  {
    "#": "662 Washington St, Unit 3 (216-06-03)",
    "$": 158800,
    "address": "662 Washington St, Unit 3",
    "parcel_id": "216-06-03",
    "owner1": "SCHMIDT ET AL TRS, MARY H",
    "owner2": "C/O RYAN LLC",
    "current_taxes": 1626.11,
    "new_taxes_no_override": 1696.36,
    "override_total_1": 1744.49,
    "override_increase_1": 48.13
  },
  {
    "#": "662 Washington St, Unit 4 (216-06-04)",
    "$": 160700,
    "address": "662 Washington St, Unit 4",
    "parcel_id": "216-06-04",
    "owner1": "STANTON TR, VINCENT P",
    "owner2": "",
    "current_taxes": 1645.57,
    "new_taxes_no_override": 1716.66,
    "override_total_1": 1765.37,
    "override_increase_1": 48.71
  },
  {
    "#": "662 Washington St, Unit 5 (216-06-05)",
    "$": 181200,
    "address": "662 Washington St, Unit 5",
    "parcel_id": "216-06-05",
    "owner1": "HAUSSLEIN, TRS, ROBERT W & EVELYN",
    "owner2": "",
    "current_taxes": 1855.49,
    "new_taxes_no_override": 1935.65,
    "override_total_1": 1990.57,
    "override_increase_1": 54.92
  },
  {
    "#": "662 Washington St, Unit 6 (216-06-06)",
    "$": 189400,
    "address": "662 Washington St, Unit 6",
    "parcel_id": "216-06-06",
    "owner1": "TEPPER, ANDREA & MARK",
    "owner2": "HOUSMAN TR, MARK",
    "current_taxes": 1939.46,
    "new_taxes_no_override": 2023.24,
    "override_total_1": 2080.65,
    "override_increase_1": 57.41
  },
  {
    "#": "662 Washington St, Unit 7 (216-06-07)",
    "$": 194400,
    "address": "662 Washington St, Unit 7",
    "parcel_id": "216-06-07",
    "owner1": "ARONSON ET AL TRS, FREDERIC G",
    "owner2": "C/O FREDO REALTY",
    "current_taxes": 199.07,
    "new_taxes_no_override": 207.67,
    "override_total_1": 213.56,
    "override_increase_1": 5.89
  },
  {
    "#": "662 Washington St, Unit 8 (216-06-08)",
    "$": 173900,
    "address": "662 Washington St, Unit 8",
    "parcel_id": "216-06-08",
    "owner1": "CALVIN TR, JANE N",
    "owner2": "",
    "current_taxes": 1780.74,
    "new_taxes_no_override": 1857.67,
    "override_total_1": 1910.38,
    "override_increase_1": 52.71
  },
  {
    "#": "662 Washington St, Unit 9 (216-06-09)",
    "$": 174600,
    "address": "662 Washington St, Unit 9",
    "parcel_id": "216-06-09",
    "owner1": "FISHER TRS, KAREN L & TODD M",
    "owner2": "",
    "current_taxes": 1787.9,
    "new_taxes_no_override": 1865.14,
    "override_total_1": 1918.06,
    "override_increase_1": 52.92
  },
  {
    "#": "665 Washington St (215-06-00)",
    "$": 2922300,
    "address": "665 Washington St",
    "parcel_id": "215-06-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O FIRE STATION #7",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "666 Washington St, Unit 1 (216-07-10)",
    "$": 197300,
    "address": "666 Washington St, Unit 1",
    "parcel_id": "216-07-10",
    "owner1": "HAMILTON TRS, JAMES A G & JOAN M W",
    "owner2": "",
    "current_taxes": 2020.35,
    "new_taxes_no_override": 2107.63,
    "override_total_1": 2167.43,
    "override_increase_1": 59.8
  },
  {
    "#": "666 Washington St, Unit 10 (216-07-09)",
    "$": 153500,
    "address": "666 Washington St, Unit 10",
    "parcel_id": "216-07-09",
    "owner1": "BRADY, GAIL",
    "owner2": "C/O BRADY JENNIFER",
    "current_taxes": 1571.84,
    "new_taxes_no_override": 1639.74,
    "override_total_1": 1686.27,
    "override_increase_1": 46.53
  },
  {
    "#": "666 Washington St, Unit 2 (216-07-01)",
    "$": 198800,
    "address": "666 Washington St, Unit 2",
    "parcel_id": "216-07-01",
    "owner1": "SKATRUD, MICHAEL & ALISA",
    "owner2": "",
    "current_taxes": 2035.71,
    "new_taxes_no_override": 2123.65,
    "override_total_1": 2183.91,
    "override_increase_1": 60.26
  },
  {
    "#": "666 Washington St, Unit 3 (216-07-02)",
    "$": 125300,
    "address": "666 Washington St, Unit 3",
    "parcel_id": "216-07-02",
    "owner1": "HOBSON TRS, IAN B H & CHRISTOPHER R W",
    "owner2": "HAGGERTY TR, JULIE HOBSON",
    "current_taxes": 1283.07,
    "new_taxes_no_override": 1338.5,
    "override_total_1": 1376.48,
    "override_increase_1": 37.98
  },
  {
    "#": "666 Washington St, Unit 4 (216-07-03)",
    "$": 204900,
    "address": "666 Washington St, Unit 4",
    "parcel_id": "216-07-03",
    "owner1": "TUTTLE TR, MARTHA G",
    "owner2": "C/O DEBORAH JENNINGS",
    "current_taxes": 2098.18,
    "new_taxes_no_override": 2188.82,
    "override_total_1": 2250.93,
    "override_increase_1": 62.11
  },
  {
    "#": "666 Washington St, Unit 5 (216-07-04)",
    "$": 179800,
    "address": "666 Washington St, Unit 5",
    "parcel_id": "216-07-04",
    "owner1": "LONG TRS, KATHLEEN A & MARY R",
    "owner2": "",
    "current_taxes": 1841.15,
    "new_taxes_no_override": 1920.69,
    "override_total_1": 1975.19,
    "override_increase_1": 54.5
  },
  {
    "#": "666 Washington St, Unit 6 (216-07-05)",
    "$": 166900,
    "address": "666 Washington St, Unit 6",
    "parcel_id": "216-07-05",
    "owner1": "SLATTERY TR, CATHERINE P",
    "owner2": "",
    "current_taxes": 170.91,
    "new_taxes_no_override": 178.29,
    "override_total_1": 183.35,
    "override_increase_1": 5.06
  },
  {
    "#": "666 Washington St, Unit 7 (216-07-06)",
    "$": 162300,
    "address": "666 Washington St, Unit 7",
    "parcel_id": "216-07-06",
    "owner1": "DONALD, TRS, CHARLES R & ELIZABETH G & CHARLES M",
    "owner2": "",
    "current_taxes": 166.2,
    "new_taxes_no_override": 173.38,
    "override_total_1": 178.3,
    "override_increase_1": 4.92
  },
  {
    "#": "666 Washington St, Unit 8 (216-07-07)",
    "$": 121200,
    "address": "666 Washington St, Unit 8",
    "parcel_id": "216-07-07",
    "owner1": "ROSS TRS, NANCY J & BURTON M",
    "owner2": "",
    "current_taxes": 1241.09,
    "new_taxes_no_override": 1294.71,
    "override_total_1": 1331.44,
    "override_increase_1": 36.74
  },
  {
    "#": "666 Washington St, Unit 9 (216-07-08)",
    "$": 158500,
    "address": "666 Washington St, Unit 9",
    "parcel_id": "216-07-08",
    "owner1": "ROSMAN TRS, JAY & CATHY REIMAN",
    "owner2": "",
    "current_taxes": 1623.04,
    "new_taxes_no_override": 1693.16,
    "override_total_1": 1741.2,
    "override_increase_1": 48.04
  },
  {
    "#": "667 Washington St (215-07-00)",
    "$": 4402600,
    "address": "667 Washington St",
    "parcel_id": "215-07-00",
    "owner1": "BODEK, TR, ITAMAR",
    "owner2": "",
    "current_taxes": 49927.92,
    "new_taxes_no_override": 52084.81,
    "override_total_1": 53562.67,
    "override_increase_1": 1477.87
  },
  {
    "#": "672 Washington St (216-08-01)",
    "$": 5966400,
    "address": "672 Washington St",
    "parcel_id": "216-08-01",
    "owner1": "THE EDD KAMP FAMILY LP",
    "owner2": "",
    "current_taxes": 61095.94,
    "new_taxes_no_override": 63735.28,
    "override_total_1": 65543.72,
    "override_increase_1": 1808.44
  },
  {
    "#": "673 Washington St (215-08-00)",
    "$": 3787100,
    "address": "673 Washington St",
    "parcel_id": "215-08-00",
    "owner1": "TWISTER MANAGEMENT INTERNATIONAL LLC",
    "owner2": "",
    "current_taxes": 38779.9,
    "new_taxes_no_override": 40455.19,
    "override_total_1": 41603.08,
    "override_increase_1": 1147.89
  },
  {
    "#": "676 Washington St (216-09-00)",
    "$": 2389800,
    "address": "676 Washington St",
    "parcel_id": "216-09-00",
    "owner1": "ZORN, MARK & TAMA",
    "owner2": "",
    "current_taxes": 24471.55,
    "new_taxes_no_override": 25528.72,
    "override_total_1": 26253.08,
    "override_increase_1": 724.36
  },
  {
    "#": "677 Washington St (215-09-00)",
    "$": 4838700,
    "address": "677 Washington St",
    "parcel_id": "215-09-00",
    "owner1": "CHAN TRS, DAVID C W & CATHERINE T",
    "owner2": "C/O R BROWN PARTNERS",
    "current_taxes": 49548.29,
    "new_taxes_no_override": 51688.78,
    "override_total_1": 53155.41,
    "override_increase_1": 1466.63
  },
  {
    "#": "682 Washington St (216-10-00)",
    "$": 2242200,
    "address": "682 Washington St",
    "parcel_id": "216-10-00",
    "owner1": "MCPHERSON TRS, GUY W",
    "owner2": "HEDRICK, SHANNON M",
    "current_taxes": 19325.19,
    "new_taxes_no_override": 20160.04,
    "override_total_1": 20732.06,
    "override_increase_1": 572.03
  },
  {
    "#": "683 Washington St (215-10-00)",
    "$": 4838700,
    "address": "683 Washington St",
    "parcel_id": "215-10-00",
    "owner1": "CHAN TRS, DAVID C W & CATHERINE T",
    "owner2": "C/O R BROWN PARTNERS",
    "current_taxes": 49548.29,
    "new_taxes_no_override": 51688.78,
    "override_total_1": 53155.41,
    "override_increase_1": 1466.63
  },
  {
    "#": "684 Washington St (216-11-00)",
    "$": 2181000,
    "address": "684 Washington St",
    "parcel_id": "216-11-00",
    "owner1": "BEATTIE, KIRK J",
    "owner2": "HAGGE, ELIZABETH E",
    "current_taxes": 18698.51,
    "new_taxes_no_override": 19506.29,
    "override_total_1": 20059.76,
    "override_increase_1": 553.48
  },
  {
    "#": "686 Washington St (216-12-00)",
    "$": 1884200,
    "address": "686 Washington St",
    "parcel_id": "216-12-00",
    "owner1": "WASHINGTON 686 LLC",
    "owner2": "",
    "current_taxes": 19294.21,
    "new_taxes_no_override": 20127.72,
    "override_total_1": 20698.83,
    "override_increase_1": 571.11
  },
  {
    "#": "688 Washington St (216-13-00)",
    "$": 1564300,
    "address": "688 Washington St",
    "parcel_id": "216-13-00",
    "owner1": "SIMONS TRS, GEORGE B",
    "owner2": "WORON TRS, SUSAN B",
    "current_taxes": 12383.5,
    "new_taxes_no_override": 12918.47,
    "override_total_1": 13285.02,
    "override_increase_1": 366.55
  },
  {
    "#": "689 Washington St, Unit 1 (215-11-02)",
    "$": 713600,
    "address": "689 Washington St, Unit 1",
    "parcel_id": "215-11-02",
    "owner1": "BIELAUS, JOHN",
    "owner2": "KITO, MIHO",
    "current_taxes": 3672.33,
    "new_taxes_no_override": 3830.97,
    "override_total_1": 3939.68,
    "override_increase_1": 108.7
  },
  {
    "#": "689 Washington St, Unit 2 (215-11-03)",
    "$": 738600,
    "address": "689 Washington St, Unit 2",
    "parcel_id": "215-11-03",
    "owner1": "ELLIOTT, ZACHARY",
    "owner2": "",
    "current_taxes": 7563.26,
    "new_taxes_no_override": 7889.99,
    "override_total_1": 8113.87,
    "override_increase_1": 223.87
  },
  {
    "#": "689 Washington St, Unit 3 (215-11-04)",
    "$": 738600,
    "address": "689 Washington St, Unit 3",
    "parcel_id": "215-11-04",
    "owner1": "ZHU TR, JUNMEI",
    "owner2": "",
    "current_taxes": 7563.26,
    "new_taxes_no_override": 7889.99,
    "override_total_1": 8113.87,
    "override_increase_1": 223.87
  },
  {
    "#": "689 Washington St, Unit 4 (215-11-05)",
    "$": 730900,
    "address": "689 Washington St, Unit 4",
    "parcel_id": "215-11-05",
    "owner1": "SHULKIN, BORIS & TATIANA",
    "owner2": "",
    "current_taxes": 7484.42,
    "new_taxes_no_override": 7807.75,
    "override_total_1": 8029.29,
    "override_increase_1": 221.54
  },
  {
    "#": "689 Washington St, Unit B (215-11-01)",
    "$": 609800,
    "address": "689 Washington St, Unit B",
    "parcel_id": "215-11-01",
    "owner1": "OSENTON, RICHARD J",
    "owner2": "",
    "current_taxes": 2609.42,
    "new_taxes_no_override": 2722.15,
    "override_total_1": 2799.39,
    "override_increase_1": 77.24
  },
  {
    "#": "690 Washington St (216-14-00)",
    "$": 1897300,
    "address": "690 Washington St",
    "parcel_id": "216-14-00",
    "owner1": "LEE RETAIL INVESTMENTS LLC",
    "owner2": "C/O GEOFFREY DAVID LEE",
    "current_taxes": 21397.78,
    "new_taxes_no_override": 22322.16,
    "override_total_1": 22955.54,
    "override_increase_1": 633.37
  },
  {
    "#": "692 Washington St (216-15-00)",
    "$": 2850000,
    "address": "692 Washington St",
    "parcel_id": "216-15-00",
    "owner1": "GARNICK, ET AL, HAROLD C",
    "owner2": "C/O CGI MANAGEMENT INC",
    "current_taxes": 48906.0,
    "new_taxes_no_override": 51018.74,
    "override_total_1": 52466.36,
    "override_increase_1": 1447.62
  },
  {
    "#": "704 Washington St (216-16-00)",
    "$": 2709700,
    "address": "704 Washington St",
    "parcel_id": "216-16-00",
    "owner1": "PHOENIX VENTURES REALTY LLC",
    "owner2": "",
    "current_taxes": 46498.45,
    "new_taxes_no_override": 48507.18,
    "override_total_1": 49883.54,
    "override_increase_1": 1376.35
  },
  {
    "#": "724 Washington St (101-27-00)",
    "$": 5565600,
    "address": "724 Washington St",
    "parcel_id": "101-27-00",
    "owner1": "NORA LLC",
    "owner2": "",
    "current_taxes": 56991.74,
    "new_taxes_no_override": 59453.78,
    "override_total_1": 61140.74,
    "override_increase_1": 1686.96
  },
  {
    "#": "725 Washington St (092-18-00)",
    "$": 117918100,
    "address": "725 Washington St",
    "parcel_id": "092-18-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O DRISCOLL SCHOOL & PLAYGROUND",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "732 Washington St (101-26-00)",
    "$": 405800,
    "address": "732 Washington St",
    "parcel_id": "101-26-00",
    "owner1": "MARZYNSKI TR, GRAZYNA",
    "owner2": "",
    "current_taxes": 4155.39,
    "new_taxes_no_override": 4334.9,
    "override_total_1": 4457.9,
    "override_increase_1": 123.0
  },
  {
    "#": "736 Washington St (101-25-00)",
    "$": 3540600,
    "address": "736 Washington St",
    "parcel_id": "101-25-00",
    "owner1": "MARZYNSKI TR, GRAZYNA",
    "owner2": "",
    "current_taxes": 36255.74,
    "new_taxes_no_override": 37821.99,
    "override_total_1": 38895.16,
    "override_increase_1": 1073.17
  },
  {
    "#": "740 Washington St (100-01-00)",
    "$": 3330600,
    "address": "740 Washington St",
    "parcel_id": "100-01-00",
    "owner1": "PRONOVOST, NANCY",
    "owner2": "",
    "current_taxes": 30470.41,
    "new_taxes_no_override": 31786.73,
    "override_total_1": 32688.66,
    "override_increase_1": 901.92
  },
  {
    "#": "747 Washington St (092-12-00)",
    "$": 2191700,
    "address": "747 Washington St",
    "parcel_id": "092-12-00",
    "owner1": "WONG, LISA D",
    "owner2": "",
    "current_taxes": 18808.07,
    "new_taxes_no_override": 19620.58,
    "override_total_1": 20177.3,
    "override_increase_1": 556.72
  },
  {
    "#": "750 Washington St (100-20-00)",
    "$": 2247900,
    "address": "750 Washington St",
    "parcel_id": "100-20-00",
    "owner1": "GAGE TRS, BRENDAN M & JANINE BURMAN",
    "owner2": "",
    "current_taxes": 19383.56,
    "new_taxes_no_override": 20220.93,
    "override_total_1": 20794.68,
    "override_increase_1": 573.75
  },
  {
    "#": "751 Washington St, Unit 1 (092-13-01)",
    "$": 1852800,
    "address": "751 Washington St, Unit 1",
    "parcel_id": "092-13-01",
    "owner1": "GILLACH, MARY C",
    "owner2": "",
    "current_taxes": 15337.74,
    "new_taxes_no_override": 16000.33,
    "override_total_1": 16454.33,
    "override_increase_1": 454.0
  },
  {
    "#": "751 Washington St, Unit 2 & P2 (092-13-02)",
    "$": 803500,
    "address": "751 Washington St, Unit 2 & P2",
    "parcel_id": "092-13-02",
    "owner1": "GILLACH, MARY",
    "owner2": "",
    "current_taxes": 8227.84,
    "new_taxes_no_override": 8583.28,
    "override_total_1": 8826.83,
    "override_increase_1": 243.54
  },
  {
    "#": "756 Washington St (100-19-01)",
    "$": 2546500,
    "address": "756 Washington St",
    "parcel_id": "100-19-01",
    "owner1": "KORETSKY, DONNA M",
    "owner2": "",
    "current_taxes": 26076.16,
    "new_taxes_no_override": 27202.65,
    "override_total_1": 27974.5,
    "override_increase_1": 771.85
  },
  {
    "#": "757 Washington St (092-14-00)",
    "$": 2066200,
    "address": "757 Washington St",
    "parcel_id": "092-14-00",
    "owner1": "RDC-WASHINGTON 757 LLC",
    "owner2": "",
    "current_taxes": 21157.89,
    "new_taxes_no_override": 22071.91,
    "override_total_1": 22698.18,
    "override_increase_1": 626.27
  },
  {
    "#": "761 Washington St (092-15-00)",
    "$": 2766800,
    "address": "761 Washington St",
    "parcel_id": "092-15-00",
    "owner1": "SHIN, ROBERT",
    "owner2": "SANGMI, LEE",
    "current_taxes": 28332.03,
    "new_taxes_no_override": 29555.97,
    "override_total_1": 30394.6,
    "override_increase_1": 838.63
  },
  {
    "#": "762 Washington St (100-19-00)",
    "$": 2186300,
    "address": "762 Washington St",
    "parcel_id": "100-19-00",
    "owner1": "KAIM TRS, ROBERT & SUSAN",
    "owner2": "",
    "current_taxes": 18752.78,
    "new_taxes_no_override": 19562.9,
    "override_total_1": 20117.98,
    "override_increase_1": 555.08
  },
  {
    "#": "765 Washington St (092-16-00)",
    "$": 2908000,
    "address": "765 Washington St",
    "parcel_id": "092-16-00",
    "owner1": "DITZION, SAMUEL M",
    "owner2": "KRITZ, JENNIFER L",
    "current_taxes": 26142.99,
    "new_taxes_no_override": 27272.37,
    "override_total_1": 28046.2,
    "override_increase_1": 773.83
  },
  {
    "#": "769 Washington St, Unit 1 (092-17-12)",
    "$": 160500,
    "address": "769 Washington St, Unit 1",
    "parcel_id": "092-17-12",
    "owner1": "CUSHING, TRS, THERESA & PASCAL & THIERRY",
    "owner2": "",
    "current_taxes": 1643.52,
    "new_taxes_no_override": 1714.52,
    "override_total_1": 1763.17,
    "override_increase_1": 48.65
  },
  {
    "#": "769 Washington St, Unit 10 (092-17-09)",
    "$": 153300,
    "address": "769 Washington St, Unit 10",
    "parcel_id": "092-17-09",
    "owner1": "ELDRIDGE, TR, DARRYL W",
    "owner2": "C/O MARJORIE J PETRUCCELLI",
    "current_taxes": 1569.79,
    "new_taxes_no_override": 1637.6,
    "override_total_1": 1684.07,
    "override_increase_1": 46.47
  },
  {
    "#": "769 Washington St, Unit 11 (092-17-10)",
    "$": 157800,
    "address": "769 Washington St, Unit 11",
    "parcel_id": "092-17-10",
    "owner1": "COHEN, TRS, MARCIA-FRED-LINDA",
    "owner2": "C/O SANDRA MAZUR",
    "current_taxes": 161.59,
    "new_taxes_no_override": 168.57,
    "override_total_1": 173.35,
    "override_increase_1": 4.78
  },
  {
    "#": "769 Washington St, Unit 12 (092-17-11)",
    "$": 160500,
    "address": "769 Washington St, Unit 12",
    "parcel_id": "092-17-11",
    "owner1": "NUSSENBAUM TR, ADAM",
    "owner2": "",
    "current_taxes": 1643.52,
    "new_taxes_no_override": 1714.52,
    "override_total_1": 1763.17,
    "override_increase_1": 48.65
  },
  {
    "#": "769 Washington St, Unit 2 (092-17-01)",
    "$": 199800,
    "address": "769 Washington St, Unit 2",
    "parcel_id": "092-17-01",
    "owner1": "GRILICHES TRS, DIANE ASSEO & EVE & MARC E",
    "owner2": "",
    "current_taxes": 204.6,
    "new_taxes_no_override": 213.44,
    "override_total_1": 219.49,
    "override_increase_1": 6.06
  },
  {
    "#": "769 Washington St, Unit 3 (092-17-02)",
    "$": 240200,
    "address": "769 Washington St, Unit 3",
    "parcel_id": "092-17-02",
    "owner1": "NUSSENBAUM TR, ADAM J",
    "owner2": "",
    "current_taxes": 2459.65,
    "new_taxes_no_override": 2565.91,
    "override_total_1": 2638.71,
    "override_increase_1": 72.81
  },
  {
    "#": "769 Washington St, Unit 4 (092-17-03)",
    "$": 200100,
    "address": "769 Washington St, Unit 4",
    "parcel_id": "092-17-03",
    "owner1": "SUGARMAN TRS, DEBRA & JAY",
    "owner2": "",
    "current_taxes": 2049.02,
    "new_taxes_no_override": 2137.54,
    "override_total_1": 2198.19,
    "override_increase_1": 60.65
  },
  {
    "#": "769 Washington St, Unit 5 (092-17-04)",
    "$": 177700,
    "address": "769 Washington St, Unit 5",
    "parcel_id": "092-17-04",
    "owner1": "GLASKY, TRS, JOEL H & BETH",
    "owner2": "",
    "current_taxes": 181.96,
    "new_taxes_no_override": 189.82,
    "override_total_1": 195.21,
    "override_increase_1": 5.39
  },
  {
    "#": "769 Washington St, Unit 6 (092-17-05)",
    "$": 156600,
    "address": "769 Washington St, Unit 6",
    "parcel_id": "092-17-05",
    "owner1": "WEAVER, STEPHEN L",
    "owner2": "",
    "current_taxes": 1603.58,
    "new_taxes_no_override": 1672.85,
    "override_total_1": 1720.32,
    "override_increase_1": 47.47
  },
  {
    "#": "769 Washington St, Unit 7 (092-17-06)",
    "$": 189500,
    "address": "769 Washington St, Unit 7",
    "parcel_id": "092-17-06",
    "owner1": "NUSSENBAUM ET AL TRS, ADAM",
    "owner2": "C/O SPECIALIZED HOUSING INC",
    "current_taxes": 1940.48,
    "new_taxes_no_override": 2024.31,
    "override_total_1": 2081.75,
    "override_increase_1": 57.44
  },
  {
    "#": "769 Washington St, Unit 8 (092-17-07)",
    "$": 182800,
    "address": "769 Washington St, Unit 8",
    "parcel_id": "092-17-07",
    "owner1": "RITTER TRS, ROBERT A",
    "owner2": "JOHNSON, DONALD W & HELEN R",
    "current_taxes": 187.19,
    "new_taxes_no_override": 195.28,
    "override_total_1": 200.82,
    "override_increase_1": 5.54
  },
  {
    "#": "769 Washington St, Unit 9 (092-17-08)",
    "$": 167600,
    "address": "769 Washington St, Unit 9",
    "parcel_id": "092-17-08",
    "owner1": "NUSSENBAUM ET AL TRS, ADAM",
    "owner2": "C/O SPECIALIZED HOUSING INC",
    "current_taxes": 1716.22,
    "new_taxes_no_override": 1790.36,
    "override_total_1": 1841.16,
    "override_increase_1": 50.8
  },
  {
    "#": "779 Washington St (094-01-00)",
    "$": 2271700,
    "address": "779 Washington St",
    "parcel_id": "094-01-00",
    "owner1": "EPSTEIN, DANIEL",
    "owner2": "",
    "current_taxes": 19627.27,
    "new_taxes_no_override": 20475.17,
    "override_total_1": 21056.14,
    "override_increase_1": 580.97
  },
  {
    "#": "782 Washington St, Unit 782 (096-11-01)",
    "$": 2090500,
    "address": "782 Washington St, Unit 782",
    "parcel_id": "096-11-01",
    "owner1": "DESHMUKH, SUJAL & SAMIDHA",
    "owner2": "",
    "current_taxes": 17771.79,
    "new_taxes_no_override": 18539.53,
    "override_total_1": 19065.58,
    "override_increase_1": 526.04
  },
  {
    "#": "782 Washington St, Unit 784 (096-11-02)",
    "$": 1954600,
    "address": "782 Washington St, Unit 784",
    "parcel_id": "096-11-02",
    "owner1": "LIRAS, SPIROS & JENNIFER L",
    "owner2": "",
    "current_taxes": 20015.1,
    "new_taxes_no_override": 20879.75,
    "override_total_1": 21472.2,
    "override_increase_1": 592.45
  },
  {
    "#": "783 Washington St (094-02-00)",
    "$": 2092900,
    "address": "783 Washington St",
    "parcel_id": "094-02-00",
    "owner1": "MOY, EDWIN G",
    "owner2": "",
    "current_taxes": 21431.3,
    "new_taxes_no_override": 22357.13,
    "override_total_1": 22991.5,
    "override_increase_1": 634.37
  },
  {
    "#": "785 Washington St (094-03-00)",
    "$": 2141000,
    "address": "785 Washington St",
    "parcel_id": "094-03-00",
    "owner1": "FIRST COMMERCIAL REALTY LLC",
    "owner2": "C/O ALPHA MGMT CORP, ANWAR FAISAL",
    "current_taxes": 21923.84,
    "new_taxes_no_override": 22870.95,
    "override_total_1": 23519.9,
    "override_increase_1": 648.95
  },
  {
    "#": "786 Washington St (096-10-00)",
    "$": 2433300,
    "address": "786 Washington St",
    "parcel_id": "096-10-00",
    "owner1": "OLEARY, JOHN",
    "owner2": "BRITTON, SARAH",
    "current_taxes": 24916.99,
    "new_taxes_no_override": 25993.4,
    "override_total_1": 26730.95,
    "override_increase_1": 737.54
  },
  {
    "#": "789 Washington St (094-04-00)",
    "$": 2149500,
    "address": "789 Washington St",
    "parcel_id": "094-04-00",
    "owner1": "ORIAIN TRS, FEARGHAL",
    "owner2": "NI RIAIN, TINA",
    "current_taxes": 18375.95,
    "new_taxes_no_override": 19169.79,
    "override_total_1": 19713.72,
    "override_increase_1": 543.93
  },
  {
    "#": "793 Washington St (094-04-01)",
    "$": 1995900,
    "address": "793 Washington St",
    "parcel_id": "094-04-01",
    "owner1": "WASHINGTON PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 20438.02,
    "new_taxes_no_override": 21320.94,
    "override_total_1": 21925.91,
    "override_increase_1": 604.97
  },
  {
    "#": "797 Washington St (094-04-02)",
    "$": 3526900,
    "address": "797 Washington St",
    "parcel_id": "094-04-02",
    "owner1": "WASHINGTON PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 36115.46,
    "new_taxes_no_override": 37675.65,
    "override_total_1": 38744.67,
    "override_increase_1": 1069.02
  },
  {
    "#": "800 Washington St (095-04-02)",
    "$": 2863600,
    "address": "800 Washington St",
    "parcel_id": "095-04-02",
    "owner1": "DELUCIA, MICHAEL",
    "owner2": "WALSH, HEATHER",
    "current_taxes": 29323.26,
    "new_taxes_no_override": 30590.02,
    "override_total_1": 31457.99,
    "override_increase_1": 867.97
  },
  {
    "#": "803 Washington St (094-05-00)",
    "$": 2705300,
    "address": "803 Washington St",
    "parcel_id": "094-05-00",
    "owner1": "CHIN, ET AL, WAYNE L",
    "owner2": "",
    "current_taxes": 27702.27,
    "new_taxes_no_override": 28899.01,
    "override_total_1": 29719.0,
    "override_increase_1": 819.99
  },
  {
    "#": "804 Washington St, Unit 804 (095-04-04)",
    "$": 1966300,
    "address": "804 Washington St, Unit 804",
    "parcel_id": "095-04-04",
    "owner1": "DAVENPORT TRS, DAVID S",
    "owner2": "CORLEY, NOLLY E",
    "current_taxes": 16499.98,
    "new_taxes_no_override": 17212.78,
    "override_total_1": 17701.18,
    "override_increase_1": 488.4
  },
  {
    "#": "804 Washington St, Unit 808 (095-04-05)",
    "$": 2038200,
    "address": "804 Washington St, Unit 808",
    "parcel_id": "095-04-05",
    "owner1": "GOLDMAN, ANIKA",
    "owner2": "KRAKOWSKI, MARTY",
    "current_taxes": 20871.17,
    "new_taxes_no_override": 21772.8,
    "override_total_1": 22390.59,
    "override_increase_1": 617.79
  },
  {
    "#": "805 Washington St (094-06-00)",
    "$": 2833400,
    "address": "805 Washington St",
    "parcel_id": "094-06-00",
    "owner1": "BIRD'S HILL PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 29014.02,
    "new_taxes_no_override": 30267.43,
    "override_total_1": 31126.24,
    "override_increase_1": 858.81
  },
  {
    "#": "807 Washington St (094-07-00)",
    "$": 2809100,
    "address": "807 Washington St",
    "parcel_id": "094-07-00",
    "owner1": "807-809 WASHINGTON STREET LLC",
    "owner2": "",
    "current_taxes": 28765.18,
    "new_taxes_no_override": 30007.84,
    "override_total_1": 30859.29,
    "override_increase_1": 851.45
  },
  {
    "#": "809 Washington St (094-08-00)",
    "$": 2833400,
    "address": "809 Washington St",
    "parcel_id": "094-08-00",
    "owner1": "807-809 WASHINGTON STREET LLC",
    "owner2": "",
    "current_taxes": 29014.02,
    "new_taxes_no_override": 30267.43,
    "override_total_1": 31126.24,
    "override_increase_1": 858.81
  },
  {
    "#": "811 Washington St (094-09-00)",
    "$": 2813700,
    "address": "811 Washington St",
    "parcel_id": "094-09-00",
    "owner1": "WASHINGTON STREET 811 LLC",
    "owner2": "",
    "current_taxes": 28812.29,
    "new_taxes_no_override": 30056.98,
    "override_total_1": 30909.82,
    "override_increase_1": 852.84
  },
  {
    "#": "815 Washington St, Unit 1 (094-10-01)",
    "$": 1112900,
    "address": "815 Washington St, Unit 1",
    "parcel_id": "094-10-01",
    "owner1": "KRAMER, BRADLEY",
    "owner2": "KAUFMAN, BETH",
    "current_taxes": 7761.16,
    "new_taxes_no_override": 8096.44,
    "override_total_1": 8326.17,
    "override_increase_1": 229.73
  },
  {
    "#": "815 Washington St, Unit 2 (094-10-02)",
    "$": 839800,
    "address": "815 Washington St, Unit 2",
    "parcel_id": "094-10-02",
    "owner1": "KOSHELEVA, ANNA A",
    "owner2": "",
    "current_taxes": 4964.62,
    "new_taxes_no_override": 5179.09,
    "override_total_1": 5326.04,
    "override_increase_1": 146.95
  },
  {
    "#": "815 Washington St, Unit 3 (094-10-03)",
    "$": 828200,
    "address": "815 Washington St, Unit 3",
    "parcel_id": "094-10-03",
    "owner1": "LEE TRS, JOSEPH S & HONG",
    "owner2": "",
    "current_taxes": 8480.77,
    "new_taxes_no_override": 8847.14,
    "override_total_1": 9098.17,
    "override_increase_1": 251.03
  },
  {
    "#": "816 Washington St, Unit 1 (095-03-02)",
    "$": 911900,
    "address": "816 Washington St, Unit 1",
    "parcel_id": "095-03-02",
    "owner1": "RABIN, REBECCA J",
    "owner2": "",
    "current_taxes": 5702.92,
    "new_taxes_no_override": 5949.29,
    "override_total_1": 6118.09,
    "override_increase_1": 168.81
  },
  {
    "#": "816 Washington St, Unit 2 (095-03-01)",
    "$": 943300,
    "address": "816 Washington St, Unit 2",
    "parcel_id": "095-03-01",
    "owner1": "GUARCH, ALICIA GARCIA",
    "owner2": "",
    "current_taxes": 6024.46,
    "new_taxes_no_override": 6284.72,
    "override_total_1": 6463.04,
    "override_increase_1": 178.32
  },
  {
    "#": "817 Washington St (094-11-00)",
    "$": 1904000,
    "address": "817 Washington St",
    "parcel_id": "094-11-00",
    "owner1": "WATSON, STEVE & GRACE",
    "owner2": "",
    "current_taxes": 15862.03,
    "new_taxes_no_override": 16547.27,
    "override_total_1": 17016.79,
    "override_increase_1": 469.52
  },
  {
    "#": "820 Washington St (095-02-01)",
    "$": 1720100,
    "address": "820 Washington St",
    "parcel_id": "095-02-01",
    "owner1": "HAWKINS, VIRIDIANA E & DARRIN",
    "owner2": "",
    "current_taxes": 13978.89,
    "new_taxes_no_override": 14582.78,
    "override_total_1": 14996.55,
    "override_increase_1": 413.78
  },
  {
    "#": "824 Washington St (095-01-00)",
    "$": 1917600,
    "address": "824 Washington St",
    "parcel_id": "095-01-00",
    "owner1": "SPECIALITY MANAGEMENT SVCS LLP",
    "owner2": "",
    "current_taxes": 19636.22,
    "new_taxes_no_override": 20484.5,
    "override_total_1": 21065.74,
    "override_increase_1": 581.23
  },
  {
    "#": "11 Waverly St, Unit 1 & G5-P6 (176-15-06)",
    "$": 1636700,
    "address": "11 Waverly St, Unit 1 & G5-P6",
    "parcel_id": "176-15-06",
    "owner1": "CHILD TRS, RALPH A",
    "owner2": "BLANCHARD, ELIZA S",
    "current_taxes": 13124.87,
    "new_taxes_no_override": 13691.86,
    "override_total_1": 14080.36,
    "override_increase_1": 388.5
  },
  {
    "#": "11 Waverly St, Unit 2 & G2 (176-15-01)",
    "$": 1546500,
    "address": "11 Waverly St, Unit 2 & G2",
    "parcel_id": "176-15-01",
    "owner1": "GANGAPUTRA, SACHIN S",
    "owner2": "BHATIA, NEHA S",
    "current_taxes": 15836.16,
    "new_taxes_no_override": 16520.28,
    "override_total_1": 16989.03,
    "override_increase_1": 468.75
  },
  {
    "#": "11 Waverly St, Unit 3 & P4 (176-15-02)",
    "$": 1115700,
    "address": "11 Waverly St, Unit 3 & P4",
    "parcel_id": "176-15-02",
    "owner1": "ATEMA, ILYSE",
    "owner2": "",
    "current_taxes": 7789.83,
    "new_taxes_no_override": 8126.35,
    "override_total_1": 8356.93,
    "override_increase_1": 230.58
  },
  {
    "#": "11 Waverly St, Unit 4 & G1 (176-15-03)",
    "$": 1254600,
    "address": "11 Waverly St, Unit 4 & G1",
    "parcel_id": "176-15-03",
    "owner1": "BURKE, MARY",
    "owner2": "FAGHERAZZI, SERGIO",
    "current_taxes": 9212.17,
    "new_taxes_no_override": 9610.14,
    "override_total_1": 9882.82,
    "override_increase_1": 272.68
  },
  {
    "#": "11 Waverly St, Unit 5 & G7-P8 (176-15-04)",
    "$": 1446400,
    "address": "11 Waverly St, Unit 5 & G7-P8",
    "parcel_id": "176-15-04",
    "owner1": "HINKLE, BENJAMIN V",
    "owner2": "WALKER, ANN",
    "current_taxes": 11176.2,
    "new_taxes_no_override": 11659.01,
    "override_total_1": 11989.83,
    "override_increase_1": 330.82
  },
  {
    "#": "11 Waverly St, Unit 6 & P3 (176-15-05)",
    "$": 1160100,
    "address": "11 Waverly St, Unit 6 & P3",
    "parcel_id": "176-15-05",
    "owner1": "MONTERO, WILHELM",
    "owner2": "LAM, MAN-YIN MIMI",
    "current_taxes": 11879.42,
    "new_taxes_no_override": 12392.61,
    "override_total_1": 12744.24,
    "override_increase_1": 351.63
  },
  {
    "#": "19 Waverly St (176-16-00)",
    "$": 2131600,
    "address": "19 Waverly St",
    "parcel_id": "176-16-00",
    "owner1": "COLLINS TRS, JOAN D & CATHERINE D",
    "owner2": "",
    "current_taxes": 18192.65,
    "new_taxes_no_override": 18978.57,
    "override_total_1": 19517.07,
    "override_increase_1": 538.5
  },
  {
    "#": "25 Waverly St (177-15-00)",
    "$": 2533900,
    "address": "25 Waverly St",
    "parcel_id": "177-15-00",
    "owner1": "NIXON, NICHOLAS & BEVERLY",
    "owner2": "",
    "current_taxes": 22312.2,
    "new_taxes_no_override": 23276.09,
    "override_total_1": 23936.53,
    "override_increase_1": 660.44
  },
  {
    "#": "27 Waverly St (177-16-00)",
    "$": 2329000,
    "address": "27 Waverly St",
    "parcel_id": "177-16-00",
    "owner1": "BING TR, CLAUDINE",
    "owner2": "",
    "current_taxes": 20214.03,
    "new_taxes_no_override": 21087.28,
    "override_total_1": 21685.61,
    "override_increase_1": 598.34
  },
  {
    "#": "33 Waverly St, Unit 33 (177-17-01)",
    "$": 1277000,
    "address": "33 Waverly St, Unit 33",
    "parcel_id": "177-17-01",
    "owner1": "RICH TR, GAYLE L",
    "owner2": "",
    "current_taxes": 9441.55,
    "new_taxes_no_override": 9849.42,
    "override_total_1": 10128.89,
    "override_increase_1": 279.47
  },
  {
    "#": "35 Waverly St, Unit 35 & P3 P4 (177-17-02)",
    "$": 1872800,
    "address": "35 Waverly St, Unit 35 & P3 P4",
    "parcel_id": "177-17-02",
    "owner1": "BARKOUDAH, ELIZABETH",
    "owner2": "",
    "current_taxes": 15542.54,
    "new_taxes_no_override": 16213.98,
    "override_total_1": 16674.04,
    "override_increase_1": 460.06
  },
  {
    "#": "36 Waverly St (179-14-00)",
    "$": 3012200,
    "address": "36 Waverly St",
    "parcel_id": "179-14-00",
    "owner1": "SCHWARTZ, JAMES O",
    "owner2": "HOCHSCHILD, ANN",
    "current_taxes": 27209.99,
    "new_taxes_no_override": 28385.46,
    "override_total_1": 29190.88,
    "override_increase_1": 805.42
  },
  {
    "#": "37 Waverly St, Unit 2 (177-18-02)",
    "$": 1459300,
    "address": "37 Waverly St, Unit 2",
    "parcel_id": "177-18-02",
    "owner1": "DISCENZA, DANIEL L",
    "owner2": "BRODY, DIANE E",
    "current_taxes": 11308.3,
    "new_taxes_no_override": 11796.82,
    "override_total_1": 12131.54,
    "override_increase_1": 334.73
  },
  {
    "#": "39 Waverly St, Unit 1 (177-18-01)",
    "$": 3074800,
    "address": "39 Waverly St, Unit 1",
    "parcel_id": "177-18-01",
    "owner1": "NIGROVIC, PETER & LISE",
    "owner2": "",
    "current_taxes": 27851.02,
    "new_taxes_no_override": 29054.18,
    "override_total_1": 29878.57,
    "override_increase_1": 824.39
  },
  {
    "#": "41 Waverly St (177-19-00)",
    "$": 3139500,
    "address": "41 Waverly St",
    "parcel_id": "177-19-00",
    "owner1": "FRIDLAND TRS, ELLEN R",
    "owner2": "PORTER, ANDREW L",
    "current_taxes": 32148.48,
    "new_taxes_no_override": 33537.29,
    "override_total_1": 34488.89,
    "override_increase_1": 951.6
  },
  {
    "#": "43 Waverly St (177-20-00)",
    "$": 2020100,
    "address": "43 Waverly St",
    "parcel_id": "177-20-00",
    "owner1": "OBERHOLZER, TONI B & DANIEL W",
    "owner2": "",
    "current_taxes": 17050.89,
    "new_taxes_no_override": 17787.49,
    "override_total_1": 18292.19,
    "override_increase_1": 504.71
  },
  {
    "#": "44 Waverly St, Unit 44 (179-13-01)",
    "$": 1485600,
    "address": "44 Waverly St, Unit 44",
    "parcel_id": "179-13-01",
    "owner1": "MASSEY, DAVID REID",
    "owner2": "BROWN, BARBARA BARNES",
    "current_taxes": 11577.61,
    "new_taxes_no_override": 12077.76,
    "override_total_1": 12420.46,
    "override_increase_1": 342.7
  },
  {
    "#": "44 Waverly St, Unit 46A (179-13-02)",
    "$": 830700,
    "address": "44 Waverly St, Unit 46A",
    "parcel_id": "179-13-02",
    "owner1": "EDWARDS, NANCY MASSEY & RODNEY JR",
    "owner2": "",
    "current_taxes": 8506.37,
    "new_taxes_no_override": 8873.85,
    "override_total_1": 9125.63,
    "override_increase_1": 251.79
  },
  {
    "#": "44 Waverly St, Unit 46B (179-13-03)",
    "$": 1017100,
    "address": "44 Waverly St, Unit 46B",
    "parcel_id": "179-13-03",
    "owner1": "EDWARDS, NANCY MASSEY & RODNEY JR",
    "owner2": "",
    "current_taxes": 10415.1,
    "new_taxes_no_override": 10865.03,
    "override_total_1": 11173.32,
    "override_increase_1": 308.29
  },
  {
    "#": "47 Waverly St (177-21-00)",
    "$": 2821600,
    "address": "47 Waverly St",
    "parcel_id": "177-21-00",
    "owner1": "691-693 HEATH STREET LLC",
    "owner2": "",
    "current_taxes": 28893.18,
    "new_taxes_no_override": 30141.37,
    "override_total_1": 30996.6,
    "override_increase_1": 855.24
  },
  {
    "#": "48 Waverly St (179-12-01)",
    "$": 2072200,
    "address": "48 Waverly St",
    "parcel_id": "179-12-01",
    "owner1": "PERKELL, JOSEPH S",
    "owner2": "GINSBERG-PLACE, RUTH",
    "current_taxes": 17584.39,
    "new_taxes_no_override": 18344.04,
    "override_total_1": 18864.53,
    "override_increase_1": 520.5
  },
  {
    "#": "50 Waverly St (179-12-00)",
    "$": 2174100,
    "address": "50 Waverly St",
    "parcel_id": "179-12-00",
    "owner1": "LEE TR, M DAVID JR",
    "owner2": "",
    "current_taxes": 22262.78,
    "new_taxes_no_override": 23224.53,
    "override_total_1": 23883.51,
    "override_increase_1": 658.98
  },
  {
    "#": "53 Waverly St (177-22-00)",
    "$": 2420100,
    "address": "53 Waverly St",
    "parcel_id": "177-22-00",
    "owner1": "TEICH, DOUGLAS",
    "owner2": "SIEWERT, BETTINA",
    "current_taxes": 21146.89,
    "new_taxes_no_override": 22060.44,
    "override_total_1": 22686.38,
    "override_increase_1": 625.95
  },
  {
    "#": "57 Waverly St (177-22-01)",
    "$": 2432100,
    "address": "57 Waverly St",
    "parcel_id": "177-22-01",
    "owner1": "BRISSETTE TRS, STEPHEN F & RONI",
    "owner2": "",
    "current_taxes": 21269.77,
    "new_taxes_no_override": 22188.62,
    "override_total_1": 22818.21,
    "override_increase_1": 629.59
  },
  {
    "#": "58 Waverly St, Unit 1 (179-11-03)",
    "$": 1696900,
    "address": "58 Waverly St, Unit 1",
    "parcel_id": "179-11-03",
    "owner1": "BISHINS, ANDREW A",
    "owner2": "MELHADO, SARAH A",
    "current_taxes": 13741.32,
    "new_taxes_no_override": 14334.95,
    "override_total_1": 14741.69,
    "override_increase_1": 406.74
  },
  {
    "#": "60 Waverly St, Unit 2 (179-11-04)",
    "$": 2072700,
    "address": "60 Waverly St, Unit 2",
    "parcel_id": "179-11-04",
    "owner1": "FLECKER TR, DALE",
    "owner2": "",
    "current_taxes": 17589.51,
    "new_taxes_no_override": 18349.38,
    "override_total_1": 18870.03,
    "override_increase_1": 520.65
  },
  {
    "#": "20 Webster Pl (141-29-00)",
    "$": 9455500,
    "address": "20 Webster Pl",
    "parcel_id": "141-29-00",
    "owner1": "BEAL ET AL TRS, BRUCE A",
    "owner2": "",
    "current_taxes": 162256.38,
    "new_taxes_no_override": 169265.86,
    "override_total_1": 174068.64,
    "override_increase_1": 4802.79
  },
  {
    "#": "30 Webster Pl (141-28-00)",
    "$": 2831800,
    "address": "30 Webster Pl",
    "parcel_id": "141-28-00",
    "owner1": "BARRON TR, ROSALYN",
    "owner2": "",
    "current_taxes": 25362.7,
    "new_taxes_no_override": 26458.37,
    "override_total_1": 27209.1,
    "override_increase_1": 750.74
  },
  {
    "#": "40 Webster Pl (141-27-00)",
    "$": 2709800,
    "address": "40 Webster Pl",
    "parcel_id": "141-27-00",
    "owner1": "40 KENT STREET LLC",
    "owner2": "C/O DND HOMES LLC",
    "current_taxes": 46500.17,
    "new_taxes_no_override": 48508.98,
    "override_total_1": 49885.38,
    "override_increase_1": 1376.41
  },
  {
    "#": "13 Webster St (163-03-00)",
    "$": 1365300,
    "address": "13 Webster St",
    "parcel_id": "163-03-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O WEBSTER ST PARKING LOT",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "19 Webster St (163-04-00)",
    "$": 3372700,
    "address": "19 Webster St",
    "parcel_id": "163-04-00",
    "owner1": "COMMONWEALTH OF MASSACHUSETTS",
    "owner2": "C/O MASS BAY TRANSIT AUTHORITY",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "20 Webster St, Unit 201 & P18 (164-04-01)",
    "$": 574000,
    "address": "20 Webster St, Unit 201 & P18",
    "parcel_id": "164-04-01",
    "owner1": "HERTZ, LAWRENCE R & JOANN",
    "owner2": "",
    "current_taxes": 5877.76,
    "new_taxes_no_override": 6131.68,
    "override_total_1": 6305.66,
    "override_increase_1": 173.98
  },
  {
    "#": "20 Webster St, Unit 202 & P1-2 (164-04-02)",
    "$": 989100,
    "address": "20 Webster St, Unit 202 & P1-2",
    "parcel_id": "164-04-02",
    "owner1": "VENKATAKRISHNAN, ANNAPURNA & GITA",
    "owner2": "",
    "current_taxes": 6493.45,
    "new_taxes_no_override": 6773.97,
    "override_total_1": 6966.17,
    "override_increase_1": 192.21
  },
  {
    "#": "20 Webster St, Unit 203 & P27 (164-04-03)",
    "$": 899600,
    "address": "20 Webster St, Unit 203 & P27",
    "parcel_id": "164-04-03",
    "owner1": "YI, SO CHONG",
    "owner2": "",
    "current_taxes": 5576.97,
    "new_taxes_no_override": 5817.9,
    "override_total_1": 5982.97,
    "override_increase_1": 165.08
  },
  {
    "#": "20 Webster St, Unit 204 & P50 (164-04-04)",
    "$": 821800,
    "address": "20 Webster St, Unit 204 & P50",
    "parcel_id": "164-04-04",
    "owner1": "KERN, MARJORIE & EMILY",
    "owner2": "",
    "current_taxes": 8415.23,
    "new_taxes_no_override": 8778.77,
    "override_total_1": 9027.86,
    "override_increase_1": 249.09
  },
  {
    "#": "20 Webster St, Unit 205 & P47 (164-04-05)",
    "$": 754500,
    "address": "20 Webster St, Unit 205 & P47",
    "parcel_id": "164-04-05",
    "owner1": "HUNG, SHAO-WEI",
    "owner2": "LIU, LIN-TIEN",
    "current_taxes": 4091.15,
    "new_taxes_no_override": 4267.89,
    "override_total_1": 4388.99,
    "override_increase_1": 121.1
  },
  {
    "#": "20 Webster St, Unit 206 & P66 (164-04-06)",
    "$": 573900,
    "address": "20 Webster St, Unit 206 & P66",
    "parcel_id": "164-04-06",
    "owner1": "LIN, ANNE YI-JIUN",
    "owner2": "",
    "current_taxes": 5876.74,
    "new_taxes_no_override": 6130.62,
    "override_total_1": 6304.57,
    "override_increase_1": 173.95
  },
  {
    "#": "20 Webster St, Unit 207 P44&69 (164-04-07)",
    "$": 1054200,
    "address": "20 Webster St, Unit 207 P44&69",
    "parcel_id": "164-04-07",
    "owner1": "DENG, DONG",
    "owner2": "YANG, XIAOHUI",
    "current_taxes": 10795.01,
    "new_taxes_no_override": 11261.35,
    "override_total_1": 11580.89,
    "override_increase_1": 319.53
  },
  {
    "#": "20 Webster St, Unit 208 P38-39 (164-04-08)",
    "$": 1085600,
    "address": "20 Webster St, Unit 208 P38-39",
    "parcel_id": "164-04-08",
    "owner1": "WONG, ELIZABETH & VICTORIA MARY",
    "owner2": "",
    "current_taxes": 11116.54,
    "new_taxes_no_override": 11596.77,
    "override_total_1": 11925.82,
    "override_increase_1": 329.05
  },
  {
    "#": "20 Webster St, Unit 209 & P87 (164-04-09)",
    "$": 867500,
    "address": "20 Webster St, Unit 209 & P87",
    "parcel_id": "164-04-09",
    "owner1": "WILDE, JOSIAH B",
    "owner2": "",
    "current_taxes": 5248.27,
    "new_taxes_no_override": 5475.0,
    "override_total_1": 5630.34,
    "override_increase_1": 155.35
  },
  {
    "#": "20 Webster St, Unit 210 & P9 (164-04-10)",
    "$": 711500,
    "address": "20 Webster St, Unit 210 & P9",
    "parcel_id": "164-04-10",
    "owner1": "YOON, TAE",
    "owner2": "",
    "current_taxes": 7285.76,
    "new_taxes_no_override": 7600.5,
    "override_total_1": 7816.16,
    "override_increase_1": 215.66
  },
  {
    "#": "20 Webster St, Unit 211 P15-80 (164-04-11)",
    "$": 963000,
    "address": "20 Webster St, Unit 211 P15-80",
    "parcel_id": "164-04-11",
    "owner1": "SINGH, KARAN",
    "owner2": "",
    "current_taxes": 9861.12,
    "new_taxes_no_override": 10287.12,
    "override_total_1": 10579.01,
    "override_increase_1": 291.89
  },
  {
    "#": "20 Webster St, Unit 212 P65&71 (164-04-12)",
    "$": 989100,
    "address": "20 Webster St, Unit 212 P65&71",
    "parcel_id": "164-04-12",
    "owner1": "REAMER, ARDEN",
    "owner2": "TABACK, KEVIN",
    "current_taxes": 10128.38,
    "new_taxes_no_override": 10565.93,
    "override_total_1": 10865.73,
    "override_increase_1": 299.8
  },
  {
    "#": "20 Webster St, Unit 213 P72-73 (164-04-13)",
    "$": 1328400,
    "address": "20 Webster St, Unit 213 P72-73",
    "parcel_id": "164-04-13",
    "owner1": "REAMER, SUE B",
    "owner2": "",
    "current_taxes": 9967.88,
    "new_taxes_no_override": 10398.49,
    "override_total_1": 10693.54,
    "override_increase_1": 295.05
  },
  {
    "#": "20 Webster St, Unit 301 & P59 (164-04-14)",
    "$": 573900,
    "address": "20 Webster St, Unit 301 & P59",
    "parcel_id": "164-04-14",
    "owner1": "CHANG, LIN-TI",
    "owner2": "",
    "current_taxes": 5876.74,
    "new_taxes_no_override": 6130.62,
    "override_total_1": 6304.57,
    "override_increase_1": 173.95
  },
  {
    "#": "20 Webster St, Unit 302 & P56 (164-04-15)",
    "$": 899700,
    "address": "20 Webster St, Unit 302 & P56",
    "parcel_id": "164-04-15",
    "owner1": "LIU, HARRY HANGSHENG",
    "owner2": "ZHAO, SOPHIA HUIFANG",
    "current_taxes": 5577.99,
    "new_taxes_no_override": 5818.96,
    "override_total_1": 5984.07,
    "override_increase_1": 165.11
  },
  {
    "#": "20 Webster St, Unit 303 P19&51 (164-04-16)",
    "$": 944600,
    "address": "20 Webster St, Unit 303 P19&51",
    "parcel_id": "164-04-16",
    "owner1": "NIKOVSKI, DANIEL N & EVA P",
    "owner2": "",
    "current_taxes": 6037.77,
    "new_taxes_no_override": 6298.6,
    "override_total_1": 6477.32,
    "override_increase_1": 178.72
  },
  {
    "#": "20 Webster St, Unit 304 & P64 (164-04-17)",
    "$": 799900,
    "address": "20 Webster St, Unit 304 & P64",
    "parcel_id": "164-04-17",
    "owner1": "FAN, SHUYI",
    "owner2": "C/O BLUE OCEAN PROP MANAGEMENT",
    "current_taxes": 8190.98,
    "new_taxes_no_override": 8544.83,
    "override_total_1": 8787.28,
    "override_increase_1": 242.45
  },
  {
    "#": "20 Webster St, Unit 305 & P43 (164-04-18)",
    "$": 758900,
    "address": "20 Webster St, Unit 305 & P43",
    "parcel_id": "164-04-18",
    "owner1": "CHANG, LIN TI",
    "owner2": "",
    "current_taxes": 7771.14,
    "new_taxes_no_override": 8106.85,
    "override_total_1": 8336.88,
    "override_increase_1": 230.03
  },
  {
    "#": "20 Webster St, Unit 306 & P30 (164-04-19)",
    "$": 1019800,
    "address": "20 Webster St, Unit 306 & P30",
    "parcel_id": "164-04-19",
    "owner1": "CHANG-SUNG TRS, MEI-JAN",
    "owner2": "",
    "current_taxes": 10442.75,
    "new_taxes_no_override": 10893.88,
    "override_total_1": 11202.98,
    "override_increase_1": 309.11
  },
  {
    "#": "20 Webster St, Unit 307 & P31 (164-04-20)",
    "$": 972000,
    "address": "20 Webster St, Unit 307 & P31",
    "parcel_id": "164-04-20",
    "owner1": "ALI-HASSAN TRS, MARIE-JEANNE & AMINE",
    "owner2": "",
    "current_taxes": 9953.28,
    "new_taxes_no_override": 10383.26,
    "override_total_1": 10677.88,
    "override_increase_1": 294.62
  },
  {
    "#": "20 Webster St, Unit 308 & P75 (164-04-21)",
    "$": 1019800,
    "address": "20 Webster St, Unit 308 & P75",
    "parcel_id": "164-04-21",
    "owner1": "APTEKMAN TR, ANGELA A",
    "owner2": "",
    "current_taxes": 10442.75,
    "new_taxes_no_override": 10893.88,
    "override_total_1": 11202.98,
    "override_increase_1": 309.11
  },
  {
    "#": "20 Webster St, Unit 309&P68 76 (164-04-76)",
    "$": 1402300,
    "address": "20 Webster St, Unit 309&P68 76",
    "parcel_id": "164-04-76",
    "owner1": "GLASSOFF, ERIC & INGRID",
    "owner2": "",
    "current_taxes": 10724.62,
    "new_taxes_no_override": 11187.92,
    "override_total_1": 11505.37,
    "override_increase_1": 317.45
  },
  {
    "#": "20 Webster St, Unit 311 & P16 (164-04-24)",
    "$": 878900,
    "address": "20 Webster St, Unit 311 & P16",
    "parcel_id": "164-04-24",
    "owner1": "PAN, ZHIYONG",
    "owner2": "",
    "current_taxes": 8999.94,
    "new_taxes_no_override": 9388.74,
    "override_total_1": 9655.14,
    "override_increase_1": 266.4
  },
  {
    "#": "20 Webster St, Unit 312 P84-85 (164-04-25)",
    "$": 965500,
    "address": "20 Webster St, Unit 312 P84-85",
    "parcel_id": "164-04-25",
    "owner1": "WONG, HING LI DENNIS",
    "owner2": "HUI, CONNIE WAI MAN",
    "current_taxes": 9886.72,
    "new_taxes_no_override": 10313.83,
    "override_total_1": 10606.47,
    "override_increase_1": 292.65
  },
  {
    "#": "20 Webster St, Unit 313 & P58 (164-04-26)",
    "$": 993000,
    "address": "20 Webster St, Unit 313 & P58",
    "parcel_id": "164-04-26",
    "owner1": "NADJMI, TRS, BRUCE J & MANIJEH M",
    "owner2": "",
    "current_taxes": 6533.39,
    "new_taxes_no_override": 6815.63,
    "override_total_1": 7009.02,
    "override_increase_1": 193.39
  },
  {
    "#": "20 Webster St, Unit 314 & P7 (164-04-27)",
    "$": 1020900,
    "address": "20 Webster St, Unit 314 & P7",
    "parcel_id": "164-04-27",
    "owner1": "BLACK TRS, BARRY H & JILL D",
    "owner2": "",
    "current_taxes": 6819.08,
    "new_taxes_no_override": 7113.66,
    "override_total_1": 7315.51,
    "override_increase_1": 201.84
  },
  {
    "#": "20 Webster St, Unit 401 & P62 (164-04-28)",
    "$": 573900,
    "address": "20 Webster St, Unit 401 & P62",
    "parcel_id": "164-04-28",
    "owner1": "GRAHAM, WAN CHEN K",
    "owner2": "",
    "current_taxes": 5876.74,
    "new_taxes_no_override": 6130.62,
    "override_total_1": 6304.57,
    "override_increase_1": 173.95
  },
  {
    "#": "20 Webster St, Unit 402 & P52 (164-04-29)",
    "$": 862400,
    "address": "20 Webster St, Unit 402 & P52",
    "parcel_id": "164-04-29",
    "owner1": "HO, KALON KWUN LEUNG",
    "owner2": "",
    "current_taxes": 5196.04,
    "new_taxes_no_override": 5420.51,
    "override_total_1": 5574.31,
    "override_increase_1": 153.8
  },
  {
    "#": "20 Webster St, Unit 403 & P40 (164-04-30)",
    "$": 878900,
    "address": "20 Webster St, Unit 403 & P40",
    "parcel_id": "164-04-30",
    "owner1": "GAVRONSKY, STAS",
    "owner2": "DZEVENSKAYA, TATIANA",
    "current_taxes": 8999.94,
    "new_taxes_no_override": 9388.74,
    "override_total_1": 9655.14,
    "override_increase_1": 266.4
  },
  {
    "#": "20 Webster St, Unit 404 & P23 (164-04-31)",
    "$": 799800,
    "address": "20 Webster St, Unit 404 & P23",
    "parcel_id": "164-04-31",
    "owner1": "FAZIO, SARA B",
    "owner2": "",
    "current_taxes": 8189.95,
    "new_taxes_no_override": 8543.76,
    "override_total_1": 8786.18,
    "override_increase_1": 242.42
  },
  {
    "#": "20 Webster St, Unit 405 & P57 (164-04-32)",
    "$": 744000,
    "address": "20 Webster St, Unit 405 & P57",
    "parcel_id": "164-04-32",
    "owner1": "SHARMA TR, NEELU",
    "owner2": "",
    "current_taxes": 7618.56,
    "new_taxes_no_override": 7947.68,
    "override_total_1": 8173.19,
    "override_increase_1": 225.51
  },
  {
    "#": "20 Webster St, Unit 406 & P60 (164-04-33)",
    "$": 1044400,
    "address": "20 Webster St, Unit 406 & P60",
    "parcel_id": "164-04-33",
    "owner1": "MAZUR, MARK J. & SANDRA C.",
    "owner2": "",
    "current_taxes": 7059.72,
    "new_taxes_no_override": 7364.7,
    "override_total_1": 7573.67,
    "override_increase_1": 208.97
  },
  {
    "#": "20 Webster St, Unit 407 P55-63 (164-04-34)",
    "$": 1064700,
    "address": "20 Webster St, Unit 407 P55-63",
    "parcel_id": "164-04-34",
    "owner1": "GORSKY TR, BRUCE",
    "owner2": "C/O 20 WEBSTER TRUST",
    "current_taxes": 10902.53,
    "new_taxes_no_override": 11373.52,
    "override_total_1": 11696.23,
    "override_increase_1": 322.71
  },
  {
    "#": "20 Webster St, Unit 408 & P42 (164-04-35)",
    "$": 1033000,
    "address": "20 Webster St, Unit 408 & P42",
    "parcel_id": "164-04-35",
    "owner1": "GROSZMANN TRS, AIDA Z",
    "owner2": "",
    "current_taxes": 10577.92,
    "new_taxes_no_override": 11034.89,
    "override_total_1": 11347.99,
    "override_increase_1": 313.11
  },
  {
    "#": "20 Webster St, Unit 409 & P4 (164-04-36)",
    "$": 867800,
    "address": "20 Webster St, Unit 409 & P4",
    "parcel_id": "164-04-36",
    "owner1": "CARBO, ALEXANDER R",
    "owner2": "",
    "current_taxes": 8886.27,
    "new_taxes_no_override": 9270.16,
    "override_total_1": 9533.19,
    "override_increase_1": 263.03
  },
  {
    "#": "20 Webster St, Unit 410 & P81 (164-04-37)",
    "$": 668600,
    "address": "20 Webster St, Unit 410 & P81",
    "parcel_id": "164-04-37",
    "owner1": "LUKATSKY HOLDINGS LLC",
    "owner2": "",
    "current_taxes": 6846.46,
    "new_taxes_no_override": 7142.23,
    "override_total_1": 7344.88,
    "override_increase_1": 202.66
  },
  {
    "#": "20 Webster St, Unit 411 & P5 (164-04-38)",
    "$": 926000,
    "address": "20 Webster St, Unit 411 & P5",
    "parcel_id": "164-04-38",
    "owner1": "DUAN, CHUNJIE",
    "owner2": "PU, RUI",
    "current_taxes": 5847.31,
    "new_taxes_no_override": 6099.91,
    "override_total_1": 6272.99,
    "override_increase_1": 173.08
  },
  {
    "#": "20 Webster St, Unit 412 & P79 (164-04-39)",
    "$": 859800,
    "address": "20 Webster St, Unit 412 & P79",
    "parcel_id": "164-04-39",
    "owner1": "LEE, BONGWOOK",
    "owner2": "",
    "current_taxes": 5169.42,
    "new_taxes_no_override": 5392.74,
    "override_total_1": 5545.75,
    "override_increase_1": 153.01
  },
  {
    "#": "20 Webster St, Unit 413 & P61 (164-04-40)",
    "$": 1043400,
    "address": "20 Webster St, Unit 413 & P61",
    "parcel_id": "164-04-40",
    "owner1": "DENNIS, STANLEY",
    "owner2": "LAVIE, RENA",
    "current_taxes": 7049.48,
    "new_taxes_no_override": 7354.02,
    "override_total_1": 7562.68,
    "override_increase_1": 208.66
  },
  {
    "#": "20 Webster St, Unit 414 P48-49 (164-04-41)",
    "$": 1074000,
    "address": "20 Webster St, Unit 414 P48-49",
    "parcel_id": "164-04-41",
    "owner1": "FREEDMAN, REVITAL",
    "owner2": "",
    "current_taxes": 7362.83,
    "new_taxes_no_override": 7680.9,
    "override_total_1": 7898.84,
    "override_increase_1": 217.94
  },
  {
    "#": "20 Webster St, Unit 501 & P20 (164-04-42)",
    "$": 574000,
    "address": "20 Webster St, Unit 501 & P20",
    "parcel_id": "164-04-42",
    "owner1": "KASO-COLLETTE, EVA",
    "owner2": "KASO, ALMA",
    "current_taxes": 5877.76,
    "new_taxes_no_override": 6131.68,
    "override_total_1": 6305.66,
    "override_increase_1": 173.98
  },
  {
    "#": "20 Webster St, Unit 502 & P83 (164-04-43)",
    "$": 878800,
    "address": "20 Webster St, Unit 502 & P83",
    "parcel_id": "164-04-43",
    "owner1": "BORER, JOSEPH G & KIMBERLY G",
    "owner2": "",
    "current_taxes": 8998.91,
    "new_taxes_no_override": 9387.66,
    "override_total_1": 9654.03,
    "override_increase_1": 266.37
  },
  {
    "#": "20 Webster St, Unit 503 & P11 (164-04-44)",
    "$": 878800,
    "address": "20 Webster St, Unit 503 & P11",
    "parcel_id": "164-04-44",
    "owner1": "VONGVADHANAROJ, SORAPON",
    "owner2": "",
    "current_taxes": 8998.91,
    "new_taxes_no_override": 9387.66,
    "override_total_1": 9654.03,
    "override_increase_1": 266.37
  },
  {
    "#": "20 Webster St, Unit 504 P32-33 (164-04-45)",
    "$": 1426000,
    "address": "20 Webster St, Unit 504 P32-33",
    "parcel_id": "164-04-45",
    "owner1": "HERZBERG TR, VICTOR",
    "owner2": "",
    "current_taxes": 10967.31,
    "new_taxes_no_override": 11441.1,
    "override_total_1": 11765.73,
    "override_increase_1": 324.63
  },
  {
    "#": "20 Webster St, Unit 505 & P37 (164-04-46)",
    "$": 970400,
    "address": "20 Webster St, Unit 505 & P37",
    "parcel_id": "164-04-46",
    "owner1": "WANTMAN, NICOLE CHELSEA",
    "owner2": "",
    "current_taxes": 6301.96,
    "new_taxes_no_override": 6574.2,
    "override_total_1": 6760.74,
    "override_increase_1": 186.54
  },
  {
    "#": "20 Webster St, Unit 506 & P24 (164-04-47)",
    "$": 975600,
    "address": "20 Webster St, Unit 506 & P24",
    "parcel_id": "164-04-47",
    "owner1": "BORER, JOSEPH GERARD",
    "owner2": "WOO-BORER, KIMBERLY G",
    "current_taxes": 9990.14,
    "new_taxes_no_override": 10421.71,
    "override_total_1": 10717.42,
    "override_increase_1": 295.71
  },
  {
    "#": "20 Webster St, Unit 507 & P22 (164-04-48)",
    "$": 950800,
    "address": "20 Webster St, Unit 507 & P22",
    "parcel_id": "164-04-48",
    "owner1": "LAM ET AL, OPHELIA YUET",
    "owner2": "C/O SETO CAROL",
    "current_taxes": 9736.19,
    "new_taxes_no_override": 10156.79,
    "override_total_1": 10444.98,
    "override_increase_1": 288.19
  },
  {
    "#": "20 Webster St, Unit 508 & P6 (164-04-49)",
    "$": 1077800,
    "address": "20 Webster St, Unit 508 & P6",
    "parcel_id": "164-04-49",
    "owner1": "MAZZASCHI ET AL TRS, MICHAEL",
    "owner2": "BATES, MARTHA J",
    "current_taxes": 7401.74,
    "new_taxes_no_override": 7721.5,
    "override_total_1": 7940.59,
    "override_increase_1": 219.09
  },
  {
    "#": "20 Webster St, Unit 509 & P41 (164-04-50)",
    "$": 868400,
    "address": "20 Webster St, Unit 509 & P41",
    "parcel_id": "164-04-50",
    "owner1": "VIVAVA CO LLC",
    "owner2": "",
    "current_taxes": 8892.42,
    "new_taxes_no_override": 9276.57,
    "override_total_1": 9539.79,
    "override_increase_1": 263.22
  },
  {
    "#": "20 Webster St, Unit 510 & P67 (164-04-51)",
    "$": 945600,
    "address": "20 Webster St, Unit 510 & P67",
    "parcel_id": "164-04-51",
    "owner1": "SANDROCK, ERICA L",
    "owner2": "",
    "current_taxes": 9682.94,
    "new_taxes_no_override": 10101.24,
    "override_total_1": 10387.86,
    "override_increase_1": 286.62
  },
  {
    "#": "20 Webster St, Unit 511 & P28 (164-04-52)",
    "$": 925800,
    "address": "20 Webster St, Unit 511 & P28",
    "parcel_id": "164-04-52",
    "owner1": "BALKH, KARINA G",
    "owner2": "",
    "current_taxes": 9480.19,
    "new_taxes_no_override": 9889.73,
    "override_total_1": 10170.35,
    "override_increase_1": 280.61
  },
  {
    "#": "20 Webster St, Unit 601 & P46 (164-04-53)",
    "$": 573900,
    "address": "20 Webster St, Unit 601 & P46",
    "parcel_id": "164-04-53",
    "owner1": "ALANKAR, GOPAL & DEVYANI & ARCHANA",
    "owner2": "",
    "current_taxes": 5876.74,
    "new_taxes_no_override": 6130.62,
    "override_total_1": 6304.57,
    "override_increase_1": 173.95
  },
  {
    "#": "20 Webster St, Unit 602 & P45 (164-04-54)",
    "$": 878900,
    "address": "20 Webster St, Unit 602 & P45",
    "parcel_id": "164-04-54",
    "owner1": "EPELBAUM, DANIEL",
    "owner2": "",
    "current_taxes": 8999.94,
    "new_taxes_no_override": 9388.74,
    "override_total_1": 9655.14,
    "override_increase_1": 266.4
  },
  {
    "#": "20 Webster St, Unit 603 & P17 (164-04-55)",
    "$": 878800,
    "address": "20 Webster St, Unit 603 & P17",
    "parcel_id": "164-04-55",
    "owner1": "LIMPIVIWATKUL, PARON",
    "owner2": "C/O NIPPON INT`L REALTY",
    "current_taxes": 8998.91,
    "new_taxes_no_override": 9387.66,
    "override_total_1": 9654.03,
    "override_increase_1": 266.37
  },
  {
    "#": "20 Webster St, Unit 604 & P29 (164-04-56)",
    "$": 1198700,
    "address": "20 Webster St, Unit 604 & P29",
    "parcel_id": "164-04-56",
    "owner1": "JORDAN TR, FAYE",
    "owner2": "",
    "current_taxes": 8639.75,
    "new_taxes_no_override": 9012.99,
    "override_total_1": 9268.72,
    "override_increase_1": 255.74
  },
  {
    "#": "20 Webster St, Unit 605 & P8 (164-04-57)",
    "$": 936300,
    "address": "20 Webster St, Unit 605 & P8",
    "parcel_id": "164-04-57",
    "owner1": "YANG, SHAW",
    "owner2": "DENG, DONG",
    "current_taxes": 9587.71,
    "new_taxes_no_override": 10001.9,
    "override_total_1": 10285.7,
    "override_increase_1": 283.8
  },
  {
    "#": "20 Webster St, Unit 606 & P3 (164-04-58)",
    "$": 980800,
    "address": "20 Webster St, Unit 606 & P3",
    "parcel_id": "164-04-58",
    "owner1": "WEBSTER STREET REALTY LLC",
    "owner2": "",
    "current_taxes": 10043.39,
    "new_taxes_no_override": 10477.26,
    "override_total_1": 10774.55,
    "override_increase_1": 297.28
  },
  {
    "#": "20 Webster St, Unit 607 & P21 (164-04-59)",
    "$": 951900,
    "address": "20 Webster St, Unit 607 & P21",
    "parcel_id": "164-04-59",
    "owner1": "JABBAWY  LIFE ESTATE, CAROLE G",
    "owner2": "",
    "current_taxes": 9747.46,
    "new_taxes_no_override": 10168.55,
    "override_total_1": 10457.08,
    "override_increase_1": 288.52
  },
  {
    "#": "20 Webster St, Unit 608 & G-25 (164-04-60)",
    "$": 920600,
    "address": "20 Webster St, Unit 608 & G-25",
    "parcel_id": "164-04-60",
    "owner1": "GARGIULO, ANTONIO R",
    "owner2": "DES, ELISABETTA",
    "current_taxes": 9426.94,
    "new_taxes_no_override": 9834.18,
    "override_total_1": 10113.22,
    "override_increase_1": 279.04
  },
  {
    "#": "20 Webster St, Unit 609 & P54-86 (164-04-61)",
    "$": 1004300,
    "address": "20 Webster St, Unit 609 & P54-86",
    "parcel_id": "164-04-61",
    "owner1": "DESAI, MANISHI A",
    "owner2": "",
    "current_taxes": 6649.1,
    "new_taxes_no_override": 6936.34,
    "override_total_1": 7133.15,
    "override_increase_1": 196.81
  },
  {
    "#": "20 Webster St, Unit 610 & P14 (164-04-62)",
    "$": 936300,
    "address": "20 Webster St, Unit 610 & P14",
    "parcel_id": "164-04-62",
    "owner1": "LEONARD TRS, SUSAN A & RICHARD M",
    "owner2": "",
    "current_taxes": 9587.71,
    "new_taxes_no_override": 10001.9,
    "override_total_1": 10285.7,
    "override_increase_1": 283.8
  },
  {
    "#": "20 Webster St, Unit 701 & P77 (164-04-63)",
    "$": 573900,
    "address": "20 Webster St, Unit 701 & P77",
    "parcel_id": "164-04-63",
    "owner1": "HELMAN, JUDITH G",
    "owner2": "",
    "current_taxes": 2241.8,
    "new_taxes_no_override": 2338.65,
    "override_total_1": 2405.0,
    "override_increase_1": 66.36
  },
  {
    "#": "20 Webster St, Unit 702 & P78 (164-04-64)",
    "$": 908600,
    "address": "20 Webster St, Unit 702 & P78",
    "parcel_id": "164-04-64",
    "owner1": "SOMA RALE LLC",
    "owner2": "",
    "current_taxes": 9304.06,
    "new_taxes_no_override": 9706.0,
    "override_total_1": 9981.4,
    "override_increase_1": 275.4
  },
  {
    "#": "20 Webster St, Unit 703  G-10 (164-04-65)",
    "$": 898600,
    "address": "20 Webster St, Unit 703  G-10",
    "parcel_id": "164-04-65",
    "owner1": "LEVIN, BRUCE D",
    "owner2": "KOOKANGWARN, VANTHANA",
    "current_taxes": 5566.73,
    "new_taxes_no_override": 5807.21,
    "override_total_1": 5971.99,
    "override_increase_1": 164.78
  },
  {
    "#": "20 Webster St, Unit 704 P34-35 (164-04-66)",
    "$": 1400500,
    "address": "20 Webster St, Unit 704 P34-35",
    "parcel_id": "164-04-66",
    "owner1": "PETRUZZIELLO LIFE ESTATE, GLORIA",
    "owner2": "",
    "current_taxes": 10706.19,
    "new_taxes_no_override": 11168.7,
    "override_total_1": 11485.6,
    "override_increase_1": 316.9
  },
  {
    "#": "20 Webster St, Unit 705 & P36 (164-04-67)",
    "$": 947800,
    "address": "20 Webster St, Unit 705 & P36",
    "parcel_id": "164-04-67",
    "owner1": "FEDOTOVA, MARINA",
    "owner2": "",
    "current_taxes": 6070.54,
    "new_taxes_no_override": 6332.79,
    "override_total_1": 6512.48,
    "override_increase_1": 179.69
  },
  {
    "#": "20 Webster St, Unit 706 &  P70 (164-04-68)",
    "$": 936300,
    "address": "20 Webster St, Unit 706 &  P70",
    "parcel_id": "164-04-68",
    "owner1": "KARR, MICHAEL",
    "owner2": "BONDAT, MARIE-PAULE",
    "current_taxes": 5952.78,
    "new_taxes_no_override": 6209.94,
    "override_total_1": 6386.14,
    "override_increase_1": 176.2
  },
  {
    "#": "20 Webster St, Unit 707 & P74 (164-04-69)",
    "$": 1043100,
    "address": "20 Webster St, Unit 707 & P74",
    "parcel_id": "164-04-69",
    "owner1": "REDDY, SARATHCHANDRA & KIRANMAYI",
    "owner2": "",
    "current_taxes": 7046.41,
    "new_taxes_no_override": 7350.81,
    "override_total_1": 7559.39,
    "override_increase_1": 208.57
  },
  {
    "#": "20 Webster St, Unit 708 & P26 (164-04-70)",
    "$": 899700,
    "address": "20 Webster St, Unit 708 & P26",
    "parcel_id": "164-04-70",
    "owner1": "KUEN HENRY NS TRUSTEE",
    "owner2": "C/O NG BETH",
    "current_taxes": 9212.93,
    "new_taxes_no_override": 9610.93,
    "override_total_1": 9883.63,
    "override_increase_1": 272.7
  },
  {
    "#": "20 Webster St, Unit 709 P12-13 (164-04-71)",
    "$": 1058300,
    "address": "20 Webster St, Unit 709 P12-13",
    "parcel_id": "164-04-71",
    "owner1": "CHAPIN TRS, CYNTHIA E & DAVID C",
    "owner2": "KUCHENBECKER, CYNTHIA",
    "current_taxes": 10836.99,
    "new_taxes_no_override": 11305.15,
    "override_total_1": 11625.92,
    "override_increase_1": 320.77
  },
  {
    "#": "20 Webster St, Unit C-1A (164-04-73)",
    "$": 1208100,
    "address": "20 Webster St, Unit C-1A",
    "parcel_id": "164-04-73",
    "owner1": "MAIDEN TR, GENYA",
    "owner2": "",
    "current_taxes": 20731.0,
    "new_taxes_no_override": 21626.58,
    "override_total_1": 22240.22,
    "override_increase_1": 613.64
  },
  {
    "#": "20 Webster St, Unit C-1B (164-04-74)",
    "$": 840200,
    "address": "20 Webster St, Unit C-1B",
    "parcel_id": "164-04-74",
    "owner1": "SASSON TR, JOSEPH ALAN",
    "owner2": "",
    "current_taxes": 14417.83,
    "new_taxes_no_override": 15040.68,
    "override_total_1": 15467.45,
    "override_increase_1": 426.77
  },
  {
    "#": "20 Webster St, Unit C2 &P16-20 (164-04-72)",
    "$": 813000,
    "address": "20 Webster St, Unit C2 &P16-20",
    "parcel_id": "164-04-72",
    "owner1": "CONDOS ETC LLC",
    "owner2": "",
    "current_taxes": 13951.08,
    "new_taxes_no_override": 14553.77,
    "override_total_1": 14966.72,
    "override_increase_1": 412.95
  },
  {
    "#": "20 Webster St, Unit P53 (164-04-75)",
    "$": 82500,
    "address": "20 Webster St, Unit P53",
    "parcel_id": "164-04-75",
    "owner1": "ALI HASSAN, AMINE & MARIE JEAN",
    "owner2": "",
    "current_taxes": 844.8,
    "new_taxes_no_override": 881.3,
    "override_total_1": 906.3,
    "override_increase_1": 25.01
  },
  {
    "#": "25 Webster St (163-05-00)",
    "$": 2672000,
    "address": "25 Webster St",
    "parcel_id": "163-05-00",
    "owner1": "S-BNK BROOKLINE LLC",
    "owner2": "C/O CHESTNUT HILL REALTY",
    "current_taxes": 45851.52,
    "new_taxes_no_override": 47832.31,
    "override_total_1": 49189.51,
    "override_increase_1": 1357.2
  },
  {
    "#": "30 Webster St (164-03-00)",
    "$": 42216700,
    "address": "30 Webster St",
    "parcel_id": "164-03-00",
    "owner1": "LAMTIOUI TR, ADIL",
    "owner2": "C/O FAISAL, ANWAR",
    "current_taxes": 724438.57,
    "new_taxes_no_override": 755734.32,
    "override_total_1": 777177.7,
    "override_increase_1": 21443.38
  },
  {
    "#": "40 Webster St (164-02-00)",
    "$": 89862400,
    "address": "40 Webster St",
    "parcel_id": "164-02-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O HERSHA HOSPITALITY LP, DESFOR-TREAS",
    "current_taxes": 1542038.78,
    "new_taxes_no_override": 1608654.86,
    "override_total_1": 1654299.2,
    "override_increase_1": 45644.35
  },
  {
    "#": "11 Welch Rd (328-01-00)",
    "$": 2986200,
    "address": "11 Welch Rd",
    "parcel_id": "328-01-00",
    "owner1": "HOCHBERG, EPHRAIM P & CLAUDIA",
    "owner2": "",
    "current_taxes": 26943.75,
    "new_taxes_no_override": 28107.72,
    "override_total_1": 28905.26,
    "override_increase_1": 797.54
  },
  {
    "#": "25 Welch Rd (328-02-00)",
    "$": 5251000,
    "address": "25 Welch Rd",
    "parcel_id": "328-02-00",
    "owner1": "GLASS, ASTRID",
    "owner2": "",
    "current_taxes": 50135.31,
    "new_taxes_no_override": 52301.16,
    "override_total_1": 53785.16,
    "override_increase_1": 1484.01
  },
  {
    "#": "38 Welch Rd (328-06-00)",
    "$": 3799100,
    "address": "38 Welch Rd",
    "parcel_id": "328-06-00",
    "owner1": "SIDEEKA, IRSHAD",
    "owner2": "KHAN, KHADIJA",
    "current_taxes": 38902.78,
    "new_taxes_no_override": 40583.38,
    "override_total_1": 41734.9,
    "override_increase_1": 1151.52
  },
  {
    "#": "39 Welch Rd (328-03-00)",
    "$": 5692100,
    "address": "39 Welch Rd",
    "parcel_id": "328-03-00",
    "owner1": "FAN, JOHN C C & STEPHANIE W",
    "owner2": "",
    "current_taxes": 54652.17,
    "new_taxes_no_override": 57013.14,
    "override_total_1": 58630.85,
    "override_increase_1": 1617.7
  },
  {
    "#": "46 Welch Rd (328-05-00)",
    "$": 3394400,
    "address": "46 Welch Rd",
    "parcel_id": "328-05-00",
    "owner1": "CHANDLER, LOGAN M & NANETTE M",
    "owner2": "",
    "current_taxes": 31123.72,
    "new_taxes_no_override": 32468.26,
    "override_total_1": 33389.53,
    "override_increase_1": 921.26
  },
  {
    "#": "58 Welch Rd (328-04-00)",
    "$": 5528100,
    "address": "58 Welch Rd",
    "parcel_id": "328-04-00",
    "owner1": "MANUS TR, DEBORAH J",
    "owner2": "",
    "current_taxes": 56607.74,
    "new_taxes_no_override": 59053.19,
    "override_total_1": 60728.78,
    "override_increase_1": 1675.59
  },
  {
    "#": "4 Welland Rd (208-17-18)",
    "$": 3397200,
    "address": "4 Welland Rd",
    "parcel_id": "208-17-18",
    "owner1": "THIBAULT, JEFFREY WAYNE & KATE MCARDLE",
    "owner2": "",
    "current_taxes": 34787.33,
    "new_taxes_no_override": 36290.14,
    "override_total_1": 37319.85,
    "override_increase_1": 1029.7
  },
  {
    "#": "14 Welland Rd (208-16-00)",
    "$": 2781300,
    "address": "14 Welland Rd",
    "parcel_id": "208-16-00",
    "owner1": "HOFFER TRS, AXEL & ANITA P",
    "owner2": "",
    "current_taxes": 24845.58,
    "new_taxes_no_override": 25918.91,
    "override_total_1": 26654.34,
    "override_increase_1": 735.43
  },
  {
    "#": "26 Welland Rd (206-09-00)",
    "$": 3050400,
    "address": "26 Welland Rd",
    "parcel_id": "206-09-00",
    "owner1": "HAHN, EMILY",
    "owner2": "SAVOS, JACOB",
    "current_taxes": 27601.16,
    "new_taxes_no_override": 28793.53,
    "override_total_1": 29610.52,
    "override_increase_1": 816.99
  },
  {
    "#": "32 Welland Rd (206-08-00)",
    "$": 2578000,
    "address": "32 Welland Rd",
    "parcel_id": "206-08-00",
    "owner1": "LAHAV TRS, ALEXANDRA D & ABSHALOM J",
    "owner2": "",
    "current_taxes": 26398.72,
    "new_taxes_no_override": 27539.14,
    "override_total_1": 28320.55,
    "override_increase_1": 781.4
  },
  {
    "#": "33 Welland Rd (205-15-00)",
    "$": 2592900,
    "address": "33 Welland Rd",
    "parcel_id": "205-15-00",
    "owner1": "DIMICCO, MICHAEL A & JOAN M",
    "owner2": "",
    "current_taxes": 22916.36,
    "new_taxes_no_override": 23906.35,
    "override_total_1": 24584.67,
    "override_increase_1": 678.32
  },
  {
    "#": "41 Welland Rd (205-16-00)",
    "$": 2385900,
    "address": "41 Welland Rd",
    "parcel_id": "205-16-00",
    "owner1": "LYETTEFI TR, DEAN OMAR",
    "owner2": "",
    "current_taxes": 20796.68,
    "new_taxes_no_override": 21695.1,
    "override_total_1": 22310.68,
    "override_increase_1": 615.58
  },
  {
    "#": "42 Welland Rd (202-19-00)",
    "$": 2231600,
    "address": "42 Welland Rd",
    "parcel_id": "202-19-00",
    "owner1": "DORFMAN, DAVID M",
    "owner2": "LAPLANTE, EVE",
    "current_taxes": 19216.65,
    "new_taxes_no_override": 20046.81,
    "override_total_1": 20615.62,
    "override_increase_1": 568.81
  },
  {
    "#": "48 Welland Rd (202-18-00)",
    "$": 3148000,
    "address": "48 Welland Rd",
    "parcel_id": "202-18-00",
    "owner1": "KACZMAREK, CHRISTOPHER",
    "owner2": "BRENNINKMEYER, MARY LIZ",
    "current_taxes": 28600.59,
    "new_taxes_no_override": 29836.14,
    "override_total_1": 30682.71,
    "override_increase_1": 846.58
  },
  {
    "#": "49 Welland Rd (205-17-00)",
    "$": 2617300,
    "address": "49 Welland Rd",
    "parcel_id": "205-17-00",
    "owner1": "NOLAN TRS, PETER R",
    "owner2": "BARONOFF, SUSAN J",
    "current_taxes": 23166.22,
    "new_taxes_no_override": 24167.0,
    "override_total_1": 24852.72,
    "override_increase_1": 685.72
  },
  {
    "#": "54 Welland Rd (202-17-00)",
    "$": 2804800,
    "address": "54 Welland Rd",
    "parcel_id": "202-17-00",
    "owner1": "WILLIG-ONWUACHI, JACOB",
    "owner2": "ONWUACHI-WILLIG, ANGELA",
    "current_taxes": 25086.22,
    "new_taxes_no_override": 26169.94,
    "override_total_1": 26912.5,
    "override_increase_1": 742.55
  },
  {
    "#": "55 Welland Rd (205-18-00)",
    "$": 2565400,
    "address": "55 Welland Rd",
    "parcel_id": "205-18-00",
    "owner1": "BRENNAN, KYLE D & MELANIE",
    "owner2": "",
    "current_taxes": 22634.76,
    "new_taxes_no_override": 23612.58,
    "override_total_1": 24282.57,
    "override_increase_1": 669.99
  },
  {
    "#": "58 Welland Rd (202-16-00)",
    "$": 3171300,
    "address": "58 Welland Rd",
    "parcel_id": "202-16-00",
    "owner1": "KALAYDJIEV, SVETLIN GEORGIEV",
    "owner2": "RASHKOVA, BISERKA RASHKOVA",
    "current_taxes": 32474.11,
    "new_taxes_no_override": 33876.99,
    "override_total_1": 34838.23,
    "override_increase_1": 961.23
  },
  {
    "#": "61 Welland Rd (205-19-00)",
    "$": 2715500,
    "address": "61 Welland Rd",
    "parcel_id": "205-19-00",
    "owner1": "OLSON, ELENA B",
    "owner2": "GERSZTEN, ROBERT E",
    "current_taxes": 24171.79,
    "new_taxes_no_override": 25216.01,
    "override_total_1": 25931.5,
    "override_increase_1": 715.48
  },
  {
    "#": "64 Welland Rd (202-15-00)",
    "$": 2319300,
    "address": "64 Welland Rd",
    "parcel_id": "202-15-00",
    "owner1": "COSSIO, PATRICIA",
    "owner2": "OVSICH, ALEXANDER",
    "current_taxes": 20114.7,
    "new_taxes_no_override": 20983.66,
    "override_total_1": 21579.05,
    "override_increase_1": 595.4
  },
  {
    "#": "65 Welland Rd (205-20-00)",
    "$": 2196400,
    "address": "65 Welland Rd",
    "parcel_id": "205-20-00",
    "owner1": "LEIPMAN, SUSAN N",
    "owner2": "ROBERGE, JOHN H",
    "current_taxes": 18856.2,
    "new_taxes_no_override": 19670.79,
    "override_total_1": 20228.93,
    "override_increase_1": 558.14
  },
  {
    "#": "70 Welland Rd (202-14-00)",
    "$": 2457500,
    "address": "70 Welland Rd",
    "parcel_id": "202-14-00",
    "owner1": "HAFNER, JOSEPH A",
    "owner2": "ASHBY, RACHEL K",
    "current_taxes": 21529.87,
    "new_taxes_no_override": 22459.96,
    "override_total_1": 23097.24,
    "override_increase_1": 637.28
  },
  {
    "#": "73 Welland Rd (205-21-00)",
    "$": 2656500,
    "address": "73 Welland Rd",
    "parcel_id": "205-21-00",
    "owner1": "HOROWITZ, NEIL",
    "owner2": "SROUJI, SERENE",
    "current_taxes": 23567.63,
    "new_taxes_no_override": 24585.75,
    "override_total_1": 25283.35,
    "override_increase_1": 697.6
  },
  {
    "#": "77 Welland Rd (205-22-00)",
    "$": 2290800,
    "address": "77 Welland Rd",
    "parcel_id": "205-22-00",
    "owner1": "NEUSNER, ELI & PAULETTE",
    "owner2": "",
    "current_taxes": 19822.86,
    "new_taxes_no_override": 20679.21,
    "override_total_1": 21265.96,
    "override_increase_1": 586.76
  },
  {
    "#": "83 Welland Rd (205-23-00)",
    "$": 2336300,
    "address": "83 Welland Rd",
    "parcel_id": "205-23-00",
    "owner1": "BARKAY, AVIHOU",
    "owner2": "KAPLAN, MAYA",
    "current_taxes": 20288.78,
    "new_taxes_no_override": 21165.26,
    "override_total_1": 21765.8,
    "override_increase_1": 600.55
  },
  {
    "#": "89 Welland Rd (205-24-00)",
    "$": 2632600,
    "address": "89 Welland Rd",
    "parcel_id": "205-24-00",
    "owner1": "RAJARAMAN, RAJMOHAN",
    "owner2": "MAHALINGAM, BHUVANA",
    "current_taxes": 23322.89,
    "new_taxes_no_override": 24330.44,
    "override_total_1": 25020.8,
    "override_increase_1": 690.36
  },
  {
    "#": "95 Welland Rd (205-25-00)",
    "$": 3459800,
    "address": "95 Welland Rd",
    "parcel_id": "205-25-00",
    "owner1": "WHALEN, STEPHEN",
    "owner2": "",
    "current_taxes": 35428.35,
    "new_taxes_no_override": 36958.85,
    "override_total_1": 38007.53,
    "override_increase_1": 1048.68
  },
  {
    "#": "99 Welland Rd (205-26-00)",
    "$": 2634000,
    "address": "99 Welland Rd",
    "parcel_id": "205-26-00",
    "owner1": "OHARA TR, EDEL",
    "owner2": "",
    "current_taxes": 23337.23,
    "new_taxes_no_override": 24345.4,
    "override_total_1": 25036.18,
    "override_increase_1": 690.78
  },
  {
    "#": "103 Welland Rd (205-27-00)",
    "$": 2351000,
    "address": "103 Welland Rd",
    "parcel_id": "205-27-00",
    "owner1": "WONG, JEFFREY & SOUYAN",
    "owner2": "",
    "current_taxes": 20439.31,
    "new_taxes_no_override": 21322.29,
    "override_total_1": 21927.29,
    "override_increase_1": 605.0
  },
  {
    "#": "109 Welland Rd (205-28-00)",
    "$": 2403400,
    "address": "109 Welland Rd",
    "parcel_id": "205-28-00",
    "owner1": "MANNA, ROBIN A",
    "owner2": "",
    "current_taxes": 20975.88,
    "new_taxes_no_override": 21882.04,
    "override_total_1": 22502.92,
    "override_increase_1": 620.89
  },
  {
    "#": "1 Wellington Ter (307-05-00)",
    "$": 2145200,
    "address": "1 Wellington Ter",
    "parcel_id": "307-05-00",
    "owner1": "GHELANI, SUNIL J",
    "owner2": "KWATRA, NEHA S",
    "current_taxes": 18331.91,
    "new_taxes_no_override": 19123.85,
    "override_total_1": 19666.47,
    "override_increase_1": 542.62
  },
  {
    "#": "2 Wellington Ter, Unit 1 (307-12-08)",
    "$": 654400,
    "address": "2 Wellington Ter, Unit 1",
    "parcel_id": "307-12-08",
    "owner1": "DE BASTOS, DEBRA A",
    "owner2": "",
    "current_taxes": 6701.06,
    "new_taxes_no_override": 6990.55,
    "override_total_1": 7188.9,
    "override_increase_1": 198.35
  },
  {
    "#": "2 Wellington Ter, Unit 2 (307-12-01)",
    "$": 870800,
    "address": "2 Wellington Ter, Unit 2",
    "parcel_id": "307-12-01",
    "owner1": "MCCONNELL, DANIEL RAY",
    "owner2": "ALBANESE, FRANCESCA B",
    "current_taxes": 5282.06,
    "new_taxes_no_override": 5510.24,
    "override_total_1": 5666.59,
    "override_increase_1": 156.35
  },
  {
    "#": "2 Wellington Ter, Unit 3 & P3 P8 (307-12-02)",
    "$": 779500,
    "address": "2 Wellington Ter, Unit 3 & P3 P8",
    "parcel_id": "307-12-02",
    "owner1": "CONNER, ALLSA A",
    "owner2": "",
    "current_taxes": 4347.15,
    "new_taxes_no_override": 4534.95,
    "override_total_1": 4663.62,
    "override_increase_1": 128.68
  },
  {
    "#": "2 Wellington Ter, Unit 4 (307-12-03)",
    "$": 806600,
    "address": "2 Wellington Ter, Unit 4",
    "parcel_id": "307-12-03",
    "owner1": "FERRIGNO, GABRIELE",
    "owner2": "",
    "current_taxes": 4624.65,
    "new_taxes_no_override": 4824.43,
    "override_total_1": 4961.32,
    "override_increase_1": 136.89
  },
  {
    "#": "2 Wellington Ter, Unit 5 & P4-P5 (307-12-04)",
    "$": 1071400,
    "address": "2 Wellington Ter, Unit 5 & P4-P5",
    "parcel_id": "307-12-04",
    "owner1": "ROGULJA, DRAGANA",
    "owner2": "CRICKMORE, MICHAEL",
    "current_taxes": 7336.2,
    "new_taxes_no_override": 7653.12,
    "override_total_1": 7870.28,
    "override_increase_1": 217.15
  },
  {
    "#": "2 Wellington Ter, Unit 6 & P6 (307-12-05)",
    "$": 656300,
    "address": "2 Wellington Ter, Unit 6 & P6",
    "parcel_id": "307-12-05",
    "owner1": "SCHIFF, JONATHAN",
    "owner2": "LAI, YING JU",
    "current_taxes": 6720.51,
    "new_taxes_no_override": 7010.84,
    "override_total_1": 7209.76,
    "override_increase_1": 198.93
  },
  {
    "#": "2 Wellington Ter, Unit 7 (307-12-06)",
    "$": 841000,
    "address": "2 Wellington Ter, Unit 7",
    "parcel_id": "307-12-06",
    "owner1": "FOX TR, LAURIE",
    "owner2": "",
    "current_taxes": 4976.91,
    "new_taxes_no_override": 5191.91,
    "override_total_1": 5339.23,
    "override_increase_1": 147.32
  },
  {
    "#": "2 Wellington Ter, Unit Gar 8 (307-12-07)",
    "$": 181500,
    "address": "2 Wellington Ter, Unit Gar 8",
    "parcel_id": "307-12-07",
    "owner1": "MORRISSETTE, DEVASENA & DENNIS J",
    "owner2": "",
    "current_taxes": 1858.56,
    "new_taxes_no_override": 1938.85,
    "override_total_1": 1993.86,
    "override_increase_1": 55.01
  },
  {
    "#": "3 Wellington Ter, Unit 1 (307-06-01)",
    "$": 1106700,
    "address": "3 Wellington Ter, Unit 1",
    "parcel_id": "307-06-01",
    "owner1": "TULIPANI, MICHAEL J",
    "owner2": "MEUS, JENNIFER",
    "current_taxes": 7697.67,
    "new_taxes_no_override": 8030.21,
    "override_total_1": 8258.06,
    "override_increase_1": 227.85
  },
  {
    "#": "3 Wellington Ter, Unit 2 (307-06-02)",
    "$": 1707800,
    "address": "3 Wellington Ter, Unit 2",
    "parcel_id": "307-06-02",
    "owner1": "DAVIS, MARTHA F",
    "owner2": "",
    "current_taxes": 13852.94,
    "new_taxes_no_override": 14451.39,
    "override_total_1": 14861.43,
    "override_increase_1": 410.05
  },
  {
    "#": "4 Wellington Ter (307-11-00)",
    "$": 3119100,
    "address": "4 Wellington Ter",
    "parcel_id": "307-11-00",
    "owner1": "JOHNSON, DOUGLAS H",
    "owner2": "LAU, VICKY",
    "current_taxes": 28304.65,
    "new_taxes_no_override": 29527.41,
    "override_total_1": 30365.23,
    "override_increase_1": 837.82
  },
  {
    "#": "5 Wellington Ter (307-07-00)",
    "$": 3258200,
    "address": "5 Wellington Ter",
    "parcel_id": "307-07-00",
    "owner1": "HARTMANN, NATASHA ARCHER & JAN",
    "owner2": "",
    "current_taxes": 29729.03,
    "new_taxes_no_override": 31013.32,
    "override_total_1": 31893.3,
    "override_increase_1": 879.98
  },
  {
    "#": "6 Wellington Ter (307-09-10)",
    "$": 3136200,
    "address": "6 Wellington Ter",
    "parcel_id": "307-09-10",
    "owner1": "HAMLIN, DAVID & LINDA",
    "owner2": "",
    "current_taxes": 28479.75,
    "new_taxes_no_override": 29710.08,
    "override_total_1": 30553.08,
    "override_increase_1": 843.0
  },
  {
    "#": "7 Wellington Ter (307-08-00)",
    "$": 1927300,
    "address": "7 Wellington Ter",
    "parcel_id": "307-08-00",
    "owner1": "SHAPIRO, RACHEL",
    "owner2": "",
    "current_taxes": 16100.62,
    "new_taxes_no_override": 16796.17,
    "override_total_1": 17272.75,
    "override_increase_1": 476.58
  },
  {
    "#": "6 Wellman St, Unit 1 (083-01-02)",
    "$": 1643300,
    "address": "6 Wellman St, Unit 1",
    "parcel_id": "083-01-02",
    "owner1": "WOOLLEY, SHANNON TOMMIE",
    "owner2": "",
    "current_taxes": 13192.46,
    "new_taxes_no_override": 13762.37,
    "override_total_1": 14152.87,
    "override_increase_1": 390.5
  },
  {
    "#": "9 Wellman St (080-05-00)",
    "$": 2282300,
    "address": "9 Wellman St",
    "parcel_id": "080-05-00",
    "owner1": "LEE TR, KEVIN W",
    "owner2": "",
    "current_taxes": 23370.75,
    "new_taxes_no_override": 24380.37,
    "override_total_1": 25072.14,
    "override_increase_1": 691.77
  },
  {
    "#": "10 Wellman St (083-21-00)",
    "$": 2393500,
    "address": "10 Wellman St",
    "parcel_id": "083-21-00",
    "owner1": "SIU KUN LEONG REVOCABLE TRUST",
    "owner2": "",
    "current_taxes": 20874.51,
    "new_taxes_no_override": 21776.29,
    "override_total_1": 22394.17,
    "override_increase_1": 617.89
  },
  {
    "#": "11 Wellman St, Unit 1 (080-06-03)",
    "$": 957800,
    "address": "11 Wellman St, Unit 1",
    "parcel_id": "080-06-03",
    "owner1": "CANNING, RICHARD G C",
    "owner2": "COLWELL, A STACIE C",
    "current_taxes": 9807.87,
    "new_taxes_no_override": 10231.57,
    "override_total_1": 10521.88,
    "override_increase_1": 290.31
  },
  {
    "#": "11 Wellman St, Unit 2 (080-06-01)",
    "$": 1016700,
    "address": "11 Wellman St, Unit 2",
    "parcel_id": "080-06-01",
    "owner1": "MOLODTSOVA, ANNA",
    "owner2": "",
    "current_taxes": 10411.01,
    "new_taxes_no_override": 10860.77,
    "override_total_1": 11168.93,
    "override_increase_1": 308.17
  },
  {
    "#": "11 Wellman St, Unit 3 (080-06-02)",
    "$": 1002400,
    "address": "11 Wellman St, Unit 3",
    "parcel_id": "080-06-02",
    "owner1": "FREEDMAN, MARION H",
    "owner2": "C/O GURSPAN MARION",
    "current_taxes": 6629.64,
    "new_taxes_no_override": 6916.04,
    "override_total_1": 7112.28,
    "override_increase_1": 196.24
  },
  {
    "#": "12 Wellman St, Unit 1 (083-20-01)",
    "$": 1092700,
    "address": "12 Wellman St, Unit 1",
    "parcel_id": "083-20-01",
    "owner1": "HAMMAMI, MOHAMMAD",
    "owner2": "NABULSI-HAMMAMI, JUDE",
    "current_taxes": 11189.25,
    "new_taxes_no_override": 11672.63,
    "override_total_1": 12003.83,
    "override_increase_1": 331.2
  },
  {
    "#": "12 Wellman St, Unit 2 (083-20-02)",
    "$": 1004800,
    "address": "12 Wellman St, Unit 2",
    "parcel_id": "083-20-02",
    "owner1": "NOUBIR, GUEVARA",
    "owner2": "HURIOGLU, TAMARA",
    "current_taxes": 10289.15,
    "new_taxes_no_override": 10733.64,
    "override_total_1": 11038.2,
    "override_increase_1": 304.56
  },
  {
    "#": "12 Wellman St, Unit 3 (083-20-03)",
    "$": 985600,
    "address": "12 Wellman St, Unit 3",
    "parcel_id": "083-20-03",
    "owner1": "MANNING TR, KATHLEEN V",
    "owner2": "",
    "current_taxes": 6457.61,
    "new_taxes_no_override": 6736.58,
    "override_total_1": 6927.72,
    "override_increase_1": 191.15
  },
  {
    "#": "14 Wellman St (083-19-00)",
    "$": 2278700,
    "address": "14 Wellman St",
    "parcel_id": "083-19-00",
    "owner1": "14 WELLMAN STREET LLC",
    "owner2": "",
    "current_taxes": 23333.89,
    "new_taxes_no_override": 24341.91,
    "override_total_1": 25032.6,
    "override_increase_1": 690.68
  },
  {
    "#": "15 Wellman St, Unit 1 (080-07-01)",
    "$": 734700,
    "address": "15 Wellman St, Unit 1",
    "parcel_id": "080-07-01",
    "owner1": "CHAN LIFE ESTATE, JOHN K",
    "owner2": "",
    "current_taxes": 7523.33,
    "new_taxes_no_override": 7848.34,
    "override_total_1": 8071.03,
    "override_increase_1": 222.69
  },
  {
    "#": "15 Wellman St, Unit 2 (080-07-02)",
    "$": 893000,
    "address": "15 Wellman St, Unit 2",
    "parcel_id": "080-07-02",
    "owner1": "ZHANG, MIN",
    "owner2": "",
    "current_taxes": 9144.32,
    "new_taxes_no_override": 9539.35,
    "override_total_1": 9810.03,
    "override_increase_1": 270.67
  },
  {
    "#": "15 Wellman St, Unit 3 (080-07-03)",
    "$": 916100,
    "address": "15 Wellman St, Unit 3",
    "parcel_id": "080-07-03",
    "owner1": "LIU, LI",
    "owner2": "XU, YU XIN",
    "current_taxes": 9380.86,
    "new_taxes_no_override": 9786.11,
    "override_total_1": 10063.79,
    "override_increase_1": 277.67
  },
  {
    "#": "15 Wellman St, Unit 4 (080-07-04)",
    "$": 924000,
    "address": "15 Wellman St, Unit 4",
    "parcel_id": "080-07-04",
    "owner1": "PEZZULO, GARY & ABIGAIL KANE",
    "owner2": "",
    "current_taxes": 5826.83,
    "new_taxes_no_override": 6078.55,
    "override_total_1": 6251.02,
    "override_increase_1": 172.47
  },
  {
    "#": "243 West Roxbury Pky (376-15-00)",
    "$": 311000,
    "address": "243 West Roxbury Pky",
    "parcel_id": "376-15-00",
    "owner1": "SINGER, THEA",
    "owner2": "",
    "current_taxes": 3184.64,
    "new_taxes_no_override": 3322.22,
    "override_total_1": 3416.48,
    "override_increase_1": 94.27
  },
  {
    "#": "800 West Roxbury Pky (376-16-00)",
    "$": 1422600,
    "address": "800 West Roxbury Pky",
    "parcel_id": "376-16-00",
    "owner1": "BACK EAST PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 14567.42,
    "new_taxes_no_override": 15196.73,
    "override_total_1": 15627.93,
    "override_increase_1": 431.2
  },
  {
    "#": "806 West Roxbury Pky (376-17-00)",
    "$": 1285800,
    "address": "806 West Roxbury Pky",
    "parcel_id": "376-17-00",
    "owner1": "ALEXANDER, PETA-MAREE ANN",
    "owner2": "SIMPSON, JAMIE SCOTT",
    "current_taxes": 9531.66,
    "new_taxes_no_override": 9943.43,
    "override_total_1": 10225.56,
    "override_increase_1": 282.14
  },
  {
    "#": "810 West Roxbury Pky (376-18-00)",
    "$": 1612500,
    "address": "810 West Roxbury Pky",
    "parcel_id": "376-18-00",
    "owner1": "MCLEAN, JAMES ANDREW",
    "owner2": "DUNCAN, CHRISTINE N",
    "current_taxes": 12877.07,
    "new_taxes_no_override": 13433.36,
    "override_total_1": 13814.52,
    "override_increase_1": 381.16
  },
  {
    "#": "811 West Roxbury Pky (365-27-00)",
    "$": 1240100,
    "address": "811 West Roxbury Pky",
    "parcel_id": "365-27-00",
    "owner1": "PODOREFSKY, DONNA",
    "owner2": "",
    "current_taxes": 9063.69,
    "new_taxes_no_override": 9455.24,
    "override_total_1": 9723.53,
    "override_increase_1": 268.29
  },
  {
    "#": "819 West Roxbury Pky (365-26-00)",
    "$": 1488700,
    "address": "819 West Roxbury Pky",
    "parcel_id": "365-26-00",
    "owner1": "BERGMARK, BRIAN & REGAN",
    "owner2": "",
    "current_taxes": 11609.35,
    "new_taxes_no_override": 12110.87,
    "override_total_1": 12454.51,
    "override_increase_1": 343.64
  },
  {
    "#": "822 West Roxbury Pky (376-19-00)",
    "$": 1284600,
    "address": "822 West Roxbury Pky",
    "parcel_id": "376-19-00",
    "owner1": "CHIPALKATTY, CARLA K & RAHUL D",
    "owner2": "",
    "current_taxes": 9519.37,
    "new_taxes_no_override": 9930.61,
    "override_total_1": 10212.38,
    "override_increase_1": 281.77
  },
  {
    "#": "828 West Roxbury Pky (376-20-00)",
    "$": 1065400,
    "address": "828 West Roxbury Pky",
    "parcel_id": "376-20-00",
    "owner1": "KAZACHKOV, VLADIMIR & DIANA",
    "owner2": "",
    "current_taxes": 7274.76,
    "new_taxes_no_override": 7589.03,
    "override_total_1": 7804.36,
    "override_increase_1": 215.33
  },
  {
    "#": "829 West Roxbury Pky (365-25-00)",
    "$": 1625100,
    "address": "829 West Roxbury Pky",
    "parcel_id": "365-25-00",
    "owner1": "VILLAR, DANNY",
    "owner2": "",
    "current_taxes": 16641.02,
    "new_taxes_no_override": 17359.91,
    "override_total_1": 17852.49,
    "override_increase_1": 492.57
  },
  {
    "#": "836 West Roxbury Pky (376-21-00)",
    "$": 1032700,
    "address": "836 West Roxbury Pky",
    "parcel_id": "376-21-00",
    "owner1": "SANDLER TRS, HAROLD S & SHIRLEY",
    "owner2": "",
    "current_taxes": 6939.91,
    "new_taxes_no_override": 7239.71,
    "override_total_1": 7445.14,
    "override_increase_1": 205.42
  },
  {
    "#": "842 West Roxbury Pky (376-22-00)",
    "$": 1220200,
    "address": "842 West Roxbury Pky",
    "parcel_id": "376-22-00",
    "owner1": "CARROLL, LAUREN R",
    "owner2": "OCONNOR, ROBERT",
    "current_taxes": 8859.91,
    "new_taxes_no_override": 9242.66,
    "override_total_1": 9504.91,
    "override_increase_1": 262.25
  },
  {
    "#": "850 West Roxbury Pky (376-23-00)",
    "$": 1332100,
    "address": "850 West Roxbury Pky",
    "parcel_id": "376-23-00",
    "owner1": "JAKOBSON, BORIS & ELINA",
    "owner2": "",
    "current_taxes": 10005.77,
    "new_taxes_no_override": 10438.02,
    "override_total_1": 10734.19,
    "override_increase_1": 296.17
  },
  {
    "#": "851 West Roxbury Pky (365-08-00)",
    "$": 1524400,
    "address": "851 West Roxbury Pky",
    "parcel_id": "365-08-00",
    "owner1": "BRODY, PHYLLIS R",
    "owner2": "C/O ELLEN BRODY",
    "current_taxes": 11974.92,
    "new_taxes_no_override": 12492.24,
    "override_total_1": 12846.69,
    "override_increase_1": 354.46
  },
  {
    "#": "858 West Roxbury Pky (376-24-00)",
    "$": 1032400,
    "address": "858 West Roxbury Pky",
    "parcel_id": "376-24-00",
    "owner1": "WAN, TRS, LEONARD C C & FELISA Y S",
    "owner2": "",
    "current_taxes": 6936.84,
    "new_taxes_no_override": 7236.51,
    "override_total_1": 7441.84,
    "override_increase_1": 205.33
  },
  {
    "#": "861 West Roxbury Pky (365-07-00)",
    "$": 1688900,
    "address": "861 West Roxbury Pky",
    "parcel_id": "365-07-00",
    "owner1": "JABOUR, MARY T",
    "owner2": "C/O JABOUR , GEORGE R",
    "current_taxes": 13659.4,
    "new_taxes_no_override": 14249.49,
    "override_total_1": 14653.8,
    "override_increase_1": 404.32
  },
  {
    "#": "866 West Roxbury Pky (376-25-00)",
    "$": 1081900,
    "address": "866 West Roxbury Pky",
    "parcel_id": "376-25-00",
    "owner1": "GRANDIN TRS, PRESTON B & SUSAN M",
    "owner2": "",
    "current_taxes": 7443.72,
    "new_taxes_no_override": 7765.29,
    "override_total_1": 7985.62,
    "override_increase_1": 220.33
  },
  {
    "#": "869 West Roxbury Pky (365-06-00)",
    "$": 1559600,
    "address": "869 West Roxbury Pky",
    "parcel_id": "365-06-00",
    "owner1": "KRUSE, ANDREW C",
    "owner2": "CUI, JIN",
    "current_taxes": 12335.37,
    "new_taxes_no_override": 12868.26,
    "override_total_1": 13233.38,
    "override_increase_1": 365.13
  },
  {
    "#": "872 West Roxbury Pky (376-26-00)",
    "$": 1535700,
    "address": "872 West Roxbury Pky",
    "parcel_id": "376-26-00",
    "owner1": "JACOFF, TRS, MARK H & PAULA M",
    "owner2": "",
    "current_taxes": 12090.63,
    "new_taxes_no_override": 12612.95,
    "override_total_1": 12970.83,
    "override_increase_1": 357.88
  },
  {
    "#": "875 West Roxbury Pky (365-05-00)",
    "$": 1528900,
    "address": "875 West Roxbury Pky",
    "parcel_id": "365-05-00",
    "owner1": "DINAPOLI TR, LISA A",
    "owner2": "DINAPOLI, BIANCA M",
    "current_taxes": 12021.0,
    "new_taxes_no_override": 12540.31,
    "override_total_1": 12896.13,
    "override_increase_1": 355.82
  },
  {
    "#": "881 West Roxbury Pky (365-04-00)",
    "$": 1775500,
    "address": "881 West Roxbury Pky",
    "parcel_id": "365-04-00",
    "owner1": "SWEI, ABDULLAH",
    "owner2": "BARRON, KATHLEEN",
    "current_taxes": 14546.19,
    "new_taxes_no_override": 15174.59,
    "override_total_1": 15605.15,
    "override_increase_1": 430.57
  },
  {
    "#": "882 West Roxbury Pky (376-01-00)",
    "$": 1351800,
    "address": "882 West Roxbury Pky",
    "parcel_id": "376-01-00",
    "owner1": "SABET, HAMID",
    "owner2": "BONYANALAM, ZAHRA",
    "current_taxes": 10207.5,
    "new_taxes_no_override": 10648.46,
    "override_total_1": 10950.61,
    "override_increase_1": 302.14
  },
  {
    "#": "887 West Roxbury Pky (365-03-00)",
    "$": 2349200,
    "address": "887 West Roxbury Pky",
    "parcel_id": "365-03-00",
    "owner1": "EZICKSON, ELAN Z & MELANIE",
    "owner2": "",
    "current_taxes": 20420.87,
    "new_taxes_no_override": 21303.05,
    "override_total_1": 21907.51,
    "override_increase_1": 604.46
  },
  {
    "#": "893 West Roxbury Pky (365-02-00)",
    "$": 1771600,
    "address": "893 West Roxbury Pky",
    "parcel_id": "365-02-00",
    "owner1": "SHINBERG TRS, AARON M I & ROSITA",
    "owner2": "",
    "current_taxes": 14506.25,
    "new_taxes_no_override": 15132.92,
    "override_total_1": 15562.31,
    "override_increase_1": 429.39
  },
  {
    "#": "900 West Roxbury Pky (375E-01-02)",
    "$": 9196900,
    "address": "900 West Roxbury Pky",
    "parcel_id": "375E-01-02",
    "owner1": "PUTTERHAM ASSOCIATES LLC",
    "owner2": "",
    "current_taxes": 94176.26,
    "new_taxes_no_override": 98244.67,
    "override_total_1": 101032.29,
    "override_increase_1": 2787.62
  },
  {
    "#": "901 West Roxbury Pky (365-01-00)",
    "$": 1693100,
    "address": "901 West Roxbury Pky",
    "parcel_id": "365-01-00",
    "owner1": "EAGLESFIELD TRS, GEORGE DAVID",
    "owner2": "BUTLER, ANNE",
    "current_taxes": 13702.41,
    "new_taxes_no_override": 14294.35,
    "override_total_1": 14699.95,
    "override_increase_1": 405.59
  },
  {
    "#": "909 West Roxbury Pky (364-22-00)",
    "$": 1899100,
    "address": "909 West Roxbury Pky",
    "parcel_id": "364-22-00",
    "owner1": "ABANE, FARIDA",
    "owner2": "OULD KACI, MAHMOUD",
    "current_taxes": 15811.85,
    "new_taxes_no_override": 16494.92,
    "override_total_1": 16962.95,
    "override_increase_1": 468.03
  },
  {
    "#": "917 West Roxbury Pky (364-21-00)",
    "$": 1690200,
    "address": "917 West Roxbury Pky",
    "parcel_id": "364-21-00",
    "owner1": "DIPPEL, CHRISTOPHER",
    "owner2": "SANTOS, CHRISTINE",
    "current_taxes": 13672.71,
    "new_taxes_no_override": 14263.37,
    "override_total_1": 14668.08,
    "override_increase_1": 404.71
  },
  {
    "#": "925 West Roxbury Pky (364-20-00)",
    "$": 1542700,
    "address": "925 West Roxbury Pky",
    "parcel_id": "364-20-00",
    "owner1": "LAIRD TRS, MARTIN H & LINDA K",
    "owner2": "",
    "current_taxes": 12162.31,
    "new_taxes_no_override": 12687.72,
    "override_total_1": 13047.73,
    "override_increase_1": 360.0
  },
  {
    "#": "930 West Roxbury Pky (375B-09-00)",
    "$": 1425500,
    "address": "930 West Roxbury Pky",
    "parcel_id": "375B-09-00",
    "owner1": "LENNON TRS, JAMES F",
    "owner2": "",
    "current_taxes": 10962.19,
    "new_taxes_no_override": 11435.76,
    "override_total_1": 11760.24,
    "override_increase_1": 324.48
  },
  {
    "#": "933 West Roxbury Pky (364-19-00)",
    "$": 1440700,
    "address": "933 West Roxbury Pky",
    "parcel_id": "364-19-00",
    "owner1": "LAHAM, KENNETH M & PATRICIA",
    "owner2": "",
    "current_taxes": 11117.83,
    "new_taxes_no_override": 11598.12,
    "override_total_1": 11927.21,
    "override_increase_1": 329.09
  },
  {
    "#": "940 West Roxbury Pky (375B-08-00)",
    "$": 1542000,
    "address": "940 West Roxbury Pky",
    "parcel_id": "375B-08-00",
    "owner1": "HSU, YI-HSIANG",
    "owner2": "LIEN, JU-PING",
    "current_taxes": 12155.15,
    "new_taxes_no_override": 12680.25,
    "override_total_1": 13040.04,
    "override_increase_1": 359.79
  },
  {
    "#": "941 West Roxbury Pky (364-14-00)",
    "$": 1976600,
    "address": "941 West Roxbury Pky",
    "parcel_id": "364-14-00",
    "owner1": "LAHAM TR, GLADYS S",
    "owner2": "",
    "current_taxes": 20240.38,
    "new_taxes_no_override": 21114.76,
    "override_total_1": 21713.88,
    "override_increase_1": 599.12
  },
  {
    "#": "954 West Roxbury Pky (375A-07-00)",
    "$": 1397000,
    "address": "954 West Roxbury Pky",
    "parcel_id": "375A-07-00",
    "owner1": "PATZ, SAMUEL & MARTHA J",
    "owner2": "",
    "current_taxes": 10670.35,
    "new_taxes_no_override": 11131.31,
    "override_total_1": 11447.15,
    "override_increase_1": 315.84
  },
  {
    "#": "959 West Roxbury Pky (364-13-00)",
    "$": 4793000,
    "address": "959 West Roxbury Pky",
    "parcel_id": "364-13-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O LIBRARY/PUTTERHAM BRANCH",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "962 West Roxbury Pky (375A-06-00)",
    "$": 1712400,
    "address": "962 West Roxbury Pky",
    "parcel_id": "375A-06-00",
    "owner1": "HUNG, ALEXIS & JANET",
    "owner2": "",
    "current_taxes": 17534.98,
    "new_taxes_no_override": 18292.49,
    "override_total_1": 18811.53,
    "override_increase_1": 519.04
  },
  {
    "#": "1025 West Roxbury Pky (371-07-00)",
    "$": 1319100,
    "address": "1025 West Roxbury Pky",
    "parcel_id": "371-07-00",
    "owner1": "CHERNOV, ILIA & AFEK",
    "owner2": "",
    "current_taxes": 13507.58,
    "new_taxes_no_override": 14091.11,
    "override_total_1": 14490.93,
    "override_increase_1": 399.82
  },
  {
    "#": "1033 West Roxbury Pky (371-08-00)",
    "$": 1169500,
    "address": "1033 West Roxbury Pky",
    "parcel_id": "371-08-00",
    "owner1": "OSTROV TR, JULIA I",
    "owner2": "",
    "current_taxes": 8340.75,
    "new_taxes_no_override": 8701.07,
    "override_total_1": 8947.96,
    "override_increase_1": 246.89
  },
  {
    "#": "1039 West Roxbury Pky (371-09-00)",
    "$": 983500,
    "address": "1039 West Roxbury Pky",
    "parcel_id": "371-09-00",
    "owner1": "WAX, CHARLENE I",
    "owner2": "",
    "current_taxes": 10071.04,
    "new_taxes_no_override": 10506.11,
    "override_total_1": 10804.21,
    "override_increase_1": 298.1
  },
  {
    "#": "1040 West Roxbury Pky (373-06-00)",
    "$": 1869000,
    "address": "1040 West Roxbury Pky",
    "parcel_id": "373-06-00",
    "owner1": "BASILE, J ROBERT",
    "owner2": "",
    "current_taxes": 15503.63,
    "new_taxes_no_override": 16173.39,
    "override_total_1": 16632.29,
    "override_increase_1": 458.91
  },
  {
    "#": "1046 West Roxbury Pky (373-05-00)",
    "$": 2079000,
    "address": "1046 West Roxbury Pky",
    "parcel_id": "373-05-00",
    "owner1": "SWITALSKI, ROSALIND",
    "owner2": "WONG, GARI D",
    "current_taxes": 17654.03,
    "new_taxes_no_override": 18416.68,
    "override_total_1": 18939.24,
    "override_increase_1": 522.56
  },
  {
    "#": "1054 West Roxbury Pky (373-04-00)",
    "$": 1924400,
    "address": "1054 West Roxbury Pky",
    "parcel_id": "373-04-00",
    "owner1": "TURCHIN, ALEXANDER",
    "owner2": "BONDAR, OKSANA",
    "current_taxes": 16070.92,
    "new_taxes_no_override": 16765.18,
    "override_total_1": 17240.88,
    "override_increase_1": 475.7
  },
  {
    "#": "1060 West Roxbury Pky (373-03-00)",
    "$": 1068100,
    "address": "1060 West Roxbury Pky",
    "parcel_id": "373-03-00",
    "owner1": "WOLF TR, TODD DAVID",
    "owner2": "",
    "current_taxes": 10937.34,
    "new_taxes_no_override": 11409.83,
    "override_total_1": 11733.58,
    "override_increase_1": 323.75
  },
  {
    "#": "1069 West Roxbury Pky (371-29-00)",
    "$": 1790900,
    "address": "1069 West Roxbury Pky",
    "parcel_id": "371-29-00",
    "owner1": "HANKS, JOHN E",
    "owner2": "SAYRE, KELLY S",
    "current_taxes": 14703.88,
    "new_taxes_no_override": 15339.09,
    "override_total_1": 15774.32,
    "override_increase_1": 435.23
  },
  {
    "#": "1075 West Roxbury Pky (371-14-15)",
    "$": 2382200,
    "address": "1075 West Roxbury Pky",
    "parcel_id": "371-14-15",
    "owner1": "GOLDMAN, EDITH",
    "owner2": "HOFFMAN, MORTON",
    "current_taxes": 20758.79,
    "new_taxes_no_override": 21655.57,
    "override_total_1": 22270.03,
    "override_increase_1": 614.46
  },
  {
    "#": "1087 West Roxbury Pky (371-16-00)",
    "$": 1991800,
    "address": "1087 West Roxbury Pky",
    "parcel_id": "371-16-00",
    "owner1": "MURPHY, MICHAEL S",
    "owner2": "FARNAN, LORI A",
    "current_taxes": 16761.1,
    "new_taxes_no_override": 17485.18,
    "override_total_1": 17981.31,
    "override_increase_1": 496.13
  },
  {
    "#": "1097 West Roxbury Pky (371-17-18)",
    "$": 1735200,
    "address": "1097 West Roxbury Pky",
    "parcel_id": "371-17-18",
    "owner1": "ZHANG, LIANG",
    "owner2": "CUI, XIAOHUI",
    "current_taxes": 14133.51,
    "new_taxes_no_override": 14744.08,
    "override_total_1": 15162.43,
    "override_increase_1": 418.35
  },
  {
    "#": "1100 West Roxbury Pky (399-46-00)",
    "$": 1728400,
    "address": "1100 West Roxbury Pky",
    "parcel_id": "399-46-00",
    "owner1": "FRETTS TR, RUTH C",
    "owner2": "",
    "current_taxes": 14063.88,
    "new_taxes_no_override": 14671.44,
    "override_total_1": 15087.73,
    "override_increase_1": 416.29
  },
  {
    "#": "1110 West Roxbury Pky (399-45-00)",
    "$": 1867500,
    "address": "1110 West Roxbury Pky",
    "parcel_id": "399-45-00",
    "owner1": "ZOUMMAR, ALBERTA F & PAUL A",
    "owner2": "",
    "current_taxes": 15488.27,
    "new_taxes_no_override": 16157.36,
    "override_total_1": 16615.82,
    "override_increase_1": 458.45
  },
  {
    "#": "1114 West Roxbury Pky (399-44-00)",
    "$": 2339800,
    "address": "1114 West Roxbury Pky",
    "parcel_id": "399-44-00",
    "owner1": "CHANG, JOHN C",
    "owner2": "JIA, YA",
    "current_taxes": 23959.55,
    "new_taxes_no_override": 24994.6,
    "override_total_1": 25703.81,
    "override_increase_1": 709.2
  },
  {
    "#": "1124 West Roxbury Pky (399-42-43)",
    "$": 2500100,
    "address": "1124 West Roxbury Pky",
    "parcel_id": "399-42-43",
    "owner1": "GREEK ORTHODOX ARCHDIOCESE OF, N & S AMERICA",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "1125 West Roxbury Pky (372-02-00)",
    "$": 2423400,
    "address": "1125 West Roxbury Pky",
    "parcel_id": "372-02-00",
    "owner1": "KHOKHAR, NAUSHEEN",
    "owner2": "",
    "current_taxes": 21180.68,
    "new_taxes_no_override": 22095.69,
    "override_total_1": 22722.63,
    "override_increase_1": 626.95
  },
  {
    "#": "1140 West Roxbury Pky (399-41-00)",
    "$": 3794100,
    "address": "1140 West Roxbury Pky",
    "parcel_id": "399-41-00",
    "owner1": "ZHANG, JIANPING",
    "owner2": "",
    "current_taxes": 35216.65,
    "new_taxes_no_override": 36738.01,
    "override_total_1": 37780.42,
    "override_increase_1": 1042.41
  },
  {
    "#": "1152 West Roxbury Pky (399-40-00)",
    "$": 2895000,
    "address": "1152 West Roxbury Pky",
    "parcel_id": "399-40-00",
    "owner1": "CHABAD LUBAVITCH OF CHESTNUT HILL INC",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "1281 West Roxbury Pky (441-04-00)",
    "$": 86096500,
    "address": "1281 West Roxbury Pky",
    "parcel_id": "441-04-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O PUTTERHAM MEADOW GOLF COURSE",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "15 Westbourne Ter, Unit 1 (091-09-01)",
    "$": 714900,
    "address": "15 Westbourne Ter, Unit 1",
    "parcel_id": "091-09-01",
    "owner1": "ZHANG, YUXIAN",
    "owner2": "",
    "current_taxes": 3685.64,
    "new_taxes_no_override": 3844.86,
    "override_total_1": 3953.95,
    "override_increase_1": 109.09
  },
  {
    "#": "15 Westbourne Ter, Unit 2 (091-09-02)",
    "$": 797300,
    "address": "15 Westbourne Ter, Unit 2",
    "parcel_id": "091-09-02",
    "owner1": "YE, DAWEI",
    "owner2": "",
    "current_taxes": 4529.42,
    "new_taxes_no_override": 4725.09,
    "override_total_1": 4859.16,
    "override_increase_1": 134.07
  },
  {
    "#": "15 Westbourne Ter, Unit 3 (091-09-03)",
    "$": 804400,
    "address": "15 Westbourne Ter, Unit 3",
    "parcel_id": "091-09-03",
    "owner1": "BABIC, ANA",
    "owner2": "WEIDENMAIER, CHRISTOPHER",
    "current_taxes": 4602.12,
    "new_taxes_no_override": 4800.93,
    "override_total_1": 4937.15,
    "override_increase_1": 136.22
  },
  {
    "#": "15 Westbourne Ter, Unit A (091-09-31)",
    "$": 474400,
    "address": "15 Westbourne Ter, Unit A",
    "parcel_id": "091-09-31",
    "owner1": "COLLINS, SAMUEL",
    "owner2": "YEUNG, TRACY",
    "current_taxes": 1222.92,
    "new_taxes_no_override": 1275.75,
    "override_total_1": 1311.95,
    "override_increase_1": 36.2
  },
  {
    "#": "17 Westbourne Ter, Unit 1 (091-09-04)",
    "$": 684400,
    "address": "17 Westbourne Ter, Unit 1",
    "parcel_id": "091-09-04",
    "owner1": "HE, SHUNING",
    "owner2": "",
    "current_taxes": 7008.26,
    "new_taxes_no_override": 7311.02,
    "override_total_1": 7518.46,
    "override_increase_1": 207.44
  },
  {
    "#": "17 Westbourne Ter, Unit 2 (091-09-05)",
    "$": 757300,
    "address": "17 Westbourne Ter, Unit 2",
    "parcel_id": "091-09-05",
    "owner1": "LIN, WEINONG",
    "owner2": "CHEN, AIMEI",
    "current_taxes": 7754.75,
    "new_taxes_no_override": 8089.76,
    "override_total_1": 8319.3,
    "override_increase_1": 229.54
  },
  {
    "#": "17 Westbourne Ter, Unit 3 (091-09-06)",
    "$": 740000,
    "address": "17 Westbourne Ter, Unit 3",
    "parcel_id": "091-09-06",
    "owner1": "LAI, WEN HSING",
    "owner2": "WONG, LEE HAN",
    "current_taxes": 3942.67,
    "new_taxes_no_override": 4112.99,
    "override_total_1": 4229.7,
    "override_increase_1": 116.7
  },
  {
    "#": "19 Westbourne Ter, Unit 1 (091-09-08)",
    "$": 629200,
    "address": "19 Westbourne Ter, Unit 1",
    "parcel_id": "091-09-08",
    "owner1": "KUO, SONIA",
    "owner2": "",
    "current_taxes": 6443.01,
    "new_taxes_no_override": 6721.35,
    "override_total_1": 6912.06,
    "override_increase_1": 190.71
  },
  {
    "#": "19 Westbourne Ter, Unit 19A (091-09-07)",
    "$": 449500,
    "address": "19 Westbourne Ter, Unit 19A",
    "parcel_id": "091-09-07",
    "owner1": "WANG, WEIFENG",
    "owner2": "DAI, HUJI",
    "current_taxes": 4602.88,
    "new_taxes_no_override": 4801.72,
    "override_total_1": 4937.97,
    "override_increase_1": 136.25
  },
  {
    "#": "19 Westbourne Ter, Unit 2 (091-09-09)",
    "$": 475700,
    "address": "19 Westbourne Ter, Unit 2",
    "parcel_id": "091-09-09",
    "owner1": "NOCK, MICHAEL R",
    "owner2": "",
    "current_taxes": 1236.23,
    "new_taxes_no_override": 1289.64,
    "override_total_1": 1326.23,
    "override_increase_1": 36.59
  },
  {
    "#": "19 Westbourne Ter, Unit 3 (091-09-10)",
    "$": 827300,
    "address": "19 Westbourne Ter, Unit 3",
    "parcel_id": "091-09-10",
    "owner1": "SHNAYDMAN, DANIL & MARINA",
    "owner2": "",
    "current_taxes": 8471.55,
    "new_taxes_no_override": 8837.52,
    "override_total_1": 9088.28,
    "override_increase_1": 250.76
  },
  {
    "#": "19 Westbourne Ter, Unit 4 (091-09-11)",
    "$": 451400,
    "address": "19 Westbourne Ter, Unit 4",
    "parcel_id": "091-09-11",
    "owner1": "KEILSON, JOSHUA",
    "owner2": "",
    "current_taxes": 987.4,
    "new_taxes_no_override": 1030.06,
    "override_total_1": 1059.28,
    "override_increase_1": 29.23
  },
  {
    "#": "19 Westbourne Ter, Unit 5 (091-09-12)",
    "$": 809100,
    "address": "19 Westbourne Ter, Unit 5",
    "parcel_id": "091-09-12",
    "owner1": "A & R ASSOCIATES LLC",
    "owner2": "",
    "current_taxes": 8285.18,
    "new_taxes_no_override": 8643.1,
    "override_total_1": 8888.34,
    "override_increase_1": 245.24
  },
  {
    "#": "19 Westbourne Ter, Unit 6 (091-09-13)",
    "$": 464900,
    "address": "19 Westbourne Ter, Unit 6",
    "parcel_id": "091-09-13",
    "owner1": "SENDER, ANNA R",
    "owner2": "",
    "current_taxes": 1125.64,
    "new_taxes_no_override": 1174.27,
    "override_total_1": 1207.59,
    "override_increase_1": 33.32
  },
  {
    "#": "21 Westbourne Ter, Unit 1 (091-09-15)",
    "$": 529500,
    "address": "21 Westbourne Ter, Unit 1",
    "parcel_id": "091-09-15",
    "owner1": "EDELMAN, TR, DAVID",
    "owner2": "",
    "current_taxes": 5422.08,
    "new_taxes_no_override": 5656.31,
    "override_total_1": 5816.81,
    "override_increase_1": 160.49
  },
  {
    "#": "21 Westbourne Ter, Unit 2 (091-09-16)",
    "$": 490900,
    "address": "21 Westbourne Ter, Unit 2",
    "parcel_id": "091-09-16",
    "owner1": "PENG, BO",
    "owner2": "QIAN, GENG",
    "current_taxes": 5026.82,
    "new_taxes_no_override": 5243.98,
    "override_total_1": 5392.77,
    "override_increase_1": 148.79
  },
  {
    "#": "21 Westbourne Ter, Unit 21A (091-09-14)",
    "$": 471200,
    "address": "21 Westbourne Ter, Unit 21A",
    "parcel_id": "091-09-14",
    "owner1": "DO, THUYHONG T",
    "owner2": "",
    "current_taxes": 4825.09,
    "new_taxes_no_override": 5033.53,
    "override_total_1": 5176.36,
    "override_increase_1": 142.82
  },
  {
    "#": "21 Westbourne Ter, Unit 3 (091-09-17)",
    "$": 630000,
    "address": "21 Westbourne Ter, Unit 3",
    "parcel_id": "091-09-17",
    "owner1": "WONG, JENNIFER",
    "owner2": "",
    "current_taxes": 6451.2,
    "new_taxes_no_override": 6729.89,
    "override_total_1": 6920.85,
    "override_increase_1": 190.96
  },
  {
    "#": "21 Westbourne Ter, Unit 4 (091-09-18)",
    "$": 503900,
    "address": "21 Westbourne Ter, Unit 4",
    "parcel_id": "091-09-18",
    "owner1": "WU, YIYONG",
    "owner2": "",
    "current_taxes": 5159.94,
    "new_taxes_no_override": 5382.85,
    "override_total_1": 5535.58,
    "override_increase_1": 152.73
  },
  {
    "#": "21 Westbourne Ter, Unit 5 (091-09-19)",
    "$": 678100,
    "address": "21 Westbourne Ter, Unit 5",
    "parcel_id": "091-09-19",
    "owner1": "HE, SHIJIE",
    "owner2": "WANG, XUE",
    "current_taxes": 3308.81,
    "new_taxes_no_override": 3451.75,
    "override_total_1": 3549.69,
    "override_increase_1": 97.94
  },
  {
    "#": "21 Westbourne Ter, Unit 6 (091-09-20)",
    "$": 499400,
    "address": "21 Westbourne Ter, Unit 6",
    "parcel_id": "091-09-20",
    "owner1": "SPERANZA, MARIA C",
    "owner2": "IACOVITTI, FRANCESCO",
    "current_taxes": 5113.86,
    "new_taxes_no_override": 5334.78,
    "override_total_1": 5486.15,
    "override_increase_1": 151.37
  },
  {
    "#": "23 Westbourne Ter, Unit 1 (091-09-21)",
    "$": 669900,
    "address": "23 Westbourne Ter, Unit 1",
    "parcel_id": "091-09-21",
    "owner1": "A & R ASSOCIATES LLC",
    "owner2": "",
    "current_taxes": 6859.78,
    "new_taxes_no_override": 7156.12,
    "override_total_1": 7359.17,
    "override_increase_1": 203.05
  },
  {
    "#": "23 Westbourne Ter, Unit 2 (091-09-22)",
    "$": 829600,
    "address": "23 Westbourne Ter, Unit 2",
    "parcel_id": "091-09-22",
    "owner1": "A & R ASSOCIATES LLC",
    "owner2": "",
    "current_taxes": 8495.1,
    "new_taxes_no_override": 8862.09,
    "override_total_1": 9113.54,
    "override_increase_1": 251.45
  },
  {
    "#": "23 Westbourne Ter, Unit 3 (091-09-23)",
    "$": 449100,
    "address": "23 Westbourne Ter, Unit 3",
    "parcel_id": "091-09-23",
    "owner1": "COPPOLA, RACHEL M",
    "owner2": "",
    "current_taxes": 963.85,
    "new_taxes_no_override": 1005.49,
    "override_total_1": 1034.02,
    "override_increase_1": 28.53
  },
  {
    "#": "23 Westbourne Ter, Unit 3A (091-09-24)",
    "$": 500900,
    "address": "23 Westbourne Ter, Unit 3A",
    "parcel_id": "091-09-24",
    "owner1": "PATELL, RUSHAD",
    "owner2": "",
    "current_taxes": 5129.22,
    "new_taxes_no_override": 5350.8,
    "override_total_1": 5502.63,
    "override_increase_1": 151.82
  },
  {
    "#": "25 Westbourne Ter, Unit 1 (091-09-26)",
    "$": 789200,
    "address": "25 Westbourne Ter, Unit 1",
    "parcel_id": "091-09-26",
    "owner1": "ARBOR PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 8081.41,
    "new_taxes_no_override": 8430.53,
    "override_total_1": 8669.74,
    "override_increase_1": 239.21
  },
  {
    "#": "25 Westbourne Ter, Unit 2 (091-09-27)",
    "$": 508700,
    "address": "25 Westbourne Ter, Unit 2",
    "parcel_id": "091-09-27",
    "owner1": "BIRBRAYER, LYUDMILA",
    "owner2": "",
    "current_taxes": 1574.15,
    "new_taxes_no_override": 1642.15,
    "override_total_1": 1688.75,
    "override_increase_1": 46.59
  },
  {
    "#": "25 Westbourne Ter, Unit 2A (091-09-29)",
    "$": 413500,
    "address": "25 Westbourne Ter, Unit 2A",
    "parcel_id": "091-09-29",
    "owner1": "ORKIN, ILYA",
    "owner2": "",
    "current_taxes": 4234.24,
    "new_taxes_no_override": 4417.16,
    "override_total_1": 4542.49,
    "override_increase_1": 125.33
  },
  {
    "#": "25 Westbourne Ter, Unit 3 (091-09-28)",
    "$": 521900,
    "address": "25 Westbourne Ter, Unit 3",
    "parcel_id": "091-09-28",
    "owner1": "ARGILAGOS, CARLOS",
    "owner2": "BRUETT, LINDA",
    "current_taxes": 5344.26,
    "new_taxes_no_override": 5575.13,
    "override_total_1": 5733.32,
    "override_increase_1": 158.19
  },
  {
    "#": "25 Westbourne Ter, Unit 3A (091-09-30)",
    "$": 444100,
    "address": "25 Westbourne Ter, Unit 3A",
    "parcel_id": "091-09-30",
    "owner1": "SHANBAUM, R MELODY & HERBERT",
    "owner2": "",
    "current_taxes": 4547.58,
    "new_taxes_no_override": 4744.04,
    "override_total_1": 4878.64,
    "override_increase_1": 134.61
  },
  {
    "#": "25 Westbourne Ter, Unit A (091-09-25)",
    "$": 467900,
    "address": "25 Westbourne Ter, Unit A",
    "parcel_id": "091-09-25",
    "owner1": "WONG TRS, KA LAI",
    "owner2": "YUEN, ANGELA S C",
    "current_taxes": 4791.3,
    "new_taxes_no_override": 4998.28,
    "override_total_1": 5140.11,
    "override_increase_1": 141.82
  },
  {
    "#": "31 Westbourne Ter, Unit 1 (091-13-18)",
    "$": 594200,
    "address": "31 Westbourne Ter, Unit 1",
    "parcel_id": "091-13-18",
    "owner1": "RENAUD, KRISTEN",
    "owner2": "",
    "current_taxes": 2449.67,
    "new_taxes_no_override": 2555.5,
    "override_total_1": 2628.01,
    "override_increase_1": 72.51
  },
  {
    "#": "31 Westbourne Ter, Unit 2 (091-13-01)",
    "$": 550700,
    "address": "31 Westbourne Ter, Unit 2",
    "parcel_id": "091-13-01",
    "owner1": "CHEN, JIANHUI",
    "owner2": "LI, YANQING",
    "current_taxes": 5639.17,
    "new_taxes_no_override": 5882.78,
    "override_total_1": 6049.7,
    "override_increase_1": 166.92
  },
  {
    "#": "31 Westbourne Ter, Unit 3 (091-13-02)",
    "$": 624100,
    "address": "31 Westbourne Ter, Unit 3",
    "parcel_id": "091-13-02",
    "owner1": "YU, YAN",
    "owner2": "",
    "current_taxes": 2755.85,
    "new_taxes_no_override": 2874.9,
    "override_total_1": 2956.48,
    "override_increase_1": 81.57
  },
  {
    "#": "31 Westbourne Ter, Unit 4 (091-13-03)",
    "$": 549900,
    "address": "31 Westbourne Ter, Unit 4",
    "parcel_id": "091-13-03",
    "owner1": "ELIAS, OLGA M",
    "owner2": "",
    "current_taxes": 1996.04,
    "new_taxes_no_override": 2082.27,
    "override_total_1": 2141.35,
    "override_increase_1": 59.08
  },
  {
    "#": "31 Westbourne Ter, Unit 5 (091-13-04)",
    "$": 608700,
    "address": "31 Westbourne Ter, Unit 5",
    "parcel_id": "091-13-04",
    "owner1": "SHEPETOVSKIY, YAN F & TATYANA",
    "owner2": "",
    "current_taxes": 2598.15,
    "new_taxes_no_override": 2710.39,
    "override_total_1": 2787.3,
    "override_increase_1": 76.91
  },
  {
    "#": "31 Westbourne Ter, Unit 6 (091-13-05)",
    "$": 549900,
    "address": "31 Westbourne Ter, Unit 6",
    "parcel_id": "091-13-05",
    "owner1": "GILBO, JOSEPH",
    "owner2": "",
    "current_taxes": 1996.04,
    "new_taxes_no_override": 2082.27,
    "override_total_1": 2141.35,
    "override_increase_1": 59.08
  },
  {
    "#": "33 Westbourne Ter, Unit 1 (091-13-06)",
    "$": 559200,
    "address": "33 Westbourne Ter, Unit 1",
    "parcel_id": "091-13-06",
    "owner1": "KARATEPE, KUTAY",
    "owner2": "",
    "current_taxes": 2091.27,
    "new_taxes_no_override": 2181.61,
    "override_total_1": 2243.51,
    "override_increase_1": 61.9
  },
  {
    "#": "33 Westbourne Ter, Unit 2 (091-13-07)",
    "$": 583500,
    "address": "33 Westbourne Ter, Unit 2",
    "parcel_id": "091-13-07",
    "owner1": "WU TRS, KERRY",
    "owner2": "LEE TR, CHEN YI JANE",
    "current_taxes": 5975.04,
    "new_taxes_no_override": 6233.16,
    "override_total_1": 6410.02,
    "override_increase_1": 176.86
  },
  {
    "#": "33 Westbourne Ter, Unit 3 (091-13-08)",
    "$": 630900,
    "address": "33 Westbourne Ter, Unit 3",
    "parcel_id": "091-13-08",
    "owner1": "TURESKY, LISA D",
    "owner2": "",
    "current_taxes": 6460.42,
    "new_taxes_no_override": 6739.51,
    "override_total_1": 6930.74,
    "override_increase_1": 191.23
  },
  {
    "#": "33 Westbourne Ter, Unit 4 (091-13-09)",
    "$": 578600,
    "address": "33 Westbourne Ter, Unit 4",
    "parcel_id": "091-13-09",
    "owner1": "SHERIDAN, CONNOR",
    "owner2": "HUANG, YUE",
    "current_taxes": 2289.93,
    "new_taxes_no_override": 2388.85,
    "override_total_1": 2456.64,
    "override_increase_1": 67.78
  },
  {
    "#": "33 Westbourne Ter, Unit 5 (091-13-10)",
    "$": 617300,
    "address": "33 Westbourne Ter, Unit 5",
    "parcel_id": "091-13-10",
    "owner1": "AMBURG, JOHN E & MADELON",
    "owner2": "",
    "current_taxes": 2686.22,
    "new_taxes_no_override": 2802.26,
    "override_total_1": 2881.78,
    "override_increase_1": 79.51
  },
  {
    "#": "33 Westbourne Ter, Unit 6 (091-13-11)",
    "$": 580400,
    "address": "33 Westbourne Ter, Unit 6",
    "parcel_id": "091-13-11",
    "owner1": "ROJANSKI, RACHEL",
    "owner2": "",
    "current_taxes": 5943.3,
    "new_taxes_no_override": 6200.05,
    "override_total_1": 6375.97,
    "override_increase_1": 175.92
  },
  {
    "#": "35 Westbourne Ter, Unit 1 (091-13-12)",
    "$": 575700,
    "address": "35 Westbourne Ter, Unit 1",
    "parcel_id": "091-13-12",
    "owner1": "VINCENT, JEFFREY & YI-CHIA",
    "owner2": "",
    "current_taxes": 2260.23,
    "new_taxes_no_override": 2357.87,
    "override_total_1": 2424.77,
    "override_increase_1": 66.9
  },
  {
    "#": "35 Westbourne Ter, Unit 2 (091-13-13)",
    "$": 572000,
    "address": "35 Westbourne Ter, Unit 2",
    "parcel_id": "091-13-13",
    "owner1": "YUNG, CARRIE",
    "owner2": "MUI, MAGGIE",
    "current_taxes": 5857.28,
    "new_taxes_no_override": 6110.31,
    "override_total_1": 6283.69,
    "override_increase_1": 173.38
  },
  {
    "#": "35 Westbourne Ter, Unit 3 (091-13-14)",
    "$": 631400,
    "address": "35 Westbourne Ter, Unit 3",
    "parcel_id": "091-13-14",
    "owner1": "LAWRENCE TR, SUSANNAH",
    "owner2": "",
    "current_taxes": 6465.54,
    "new_taxes_no_override": 6744.85,
    "override_total_1": 6936.23,
    "override_increase_1": 191.38
  },
  {
    "#": "35 Westbourne Ter, Unit 4 (091-13-15)",
    "$": 590200,
    "address": "35 Westbourne Ter, Unit 4",
    "parcel_id": "091-13-15",
    "owner1": "KRILL, ANDREW D",
    "owner2": "",
    "current_taxes": 6043.65,
    "new_taxes_no_override": 6304.74,
    "override_total_1": 6483.63,
    "override_increase_1": 178.89
  },
  {
    "#": "35 Westbourne Ter, Unit 5 (091-13-16)",
    "$": 712800,
    "address": "35 Westbourne Ter, Unit 5",
    "parcel_id": "091-13-16",
    "owner1": "MCGEE TRS, VANN ROGER",
    "owner2": "HAYES-BAUTISTA, ROBERTA",
    "current_taxes": 7299.07,
    "new_taxes_no_override": 7614.39,
    "override_total_1": 7830.44,
    "override_increase_1": 216.05
  },
  {
    "#": "35 Westbourne Ter, Unit 6 (091-13-17)",
    "$": 555600,
    "address": "35 Westbourne Ter, Unit 6",
    "parcel_id": "091-13-17",
    "owner1": "BURDENKO, ALEXANDER & MARINA",
    "owner2": "",
    "current_taxes": 5689.34,
    "new_taxes_no_override": 5935.12,
    "override_total_1": 6103.52,
    "override_increase_1": 168.4
  },
  {
    "#": "41 Westbourne Ter (091-16-00)",
    "$": 2547800,
    "address": "41 Westbourne Ter",
    "parcel_id": "091-16-00",
    "owner1": "KREWINGHAUS, DAVID B",
    "owner2": "KELLY, ERIN L",
    "current_taxes": 22454.54,
    "new_taxes_no_override": 23424.58,
    "override_total_1": 24089.23,
    "override_increase_1": 664.65
  },
  {
    "#": "45 Westbourne Ter (091-17-00)",
    "$": 2997200,
    "address": "45 Westbourne Ter",
    "parcel_id": "091-17-00",
    "owner1": "LAWRENCE TRS, GREGORY K",
    "owner2": "RYAN, KATIE A",
    "current_taxes": 27056.39,
    "new_taxes_no_override": 28225.23,
    "override_total_1": 29026.1,
    "override_increase_1": 800.87
  },
  {
    "#": "49 Westbourne Ter (091-18-00)",
    "$": 2457100,
    "address": "49 Westbourne Ter",
    "parcel_id": "091-18-00",
    "owner1": "YACKLE, JEANETTE & LARRY W",
    "owner2": "",
    "current_taxes": 21525.77,
    "new_taxes_no_override": 22455.68,
    "override_total_1": 23092.85,
    "override_increase_1": 637.16
  },
  {
    "#": "53 Westbourne Ter (091-19-00)",
    "$": 2651900,
    "address": "53 Westbourne Ter",
    "parcel_id": "091-19-00",
    "owner1": "ENG, JANICE",
    "owner2": "ASH, BRIAN",
    "current_taxes": 23520.52,
    "new_taxes_no_override": 24536.61,
    "override_total_1": 25232.81,
    "override_increase_1": 696.21
  },
  {
    "#": "57 Westbourne Ter (091-20-00)",
    "$": 2789800,
    "address": "57 Westbourne Ter",
    "parcel_id": "091-20-00",
    "owner1": "SCHULTZ, DANIEL",
    "owner2": "HASTIE, EMILY",
    "current_taxes": 24932.62,
    "new_taxes_no_override": 26009.71,
    "override_total_1": 26747.71,
    "override_increase_1": 738.01
  },
  {
    "#": "61 Westbourne Ter (091-21-00)",
    "$": 2790100,
    "address": "61 Westbourne Ter",
    "parcel_id": "091-21-00",
    "owner1": "WARD, MARJORIE",
    "owner2": "",
    "current_taxes": 24935.69,
    "new_taxes_no_override": 26012.91,
    "override_total_1": 26751.01,
    "override_increase_1": 738.1
  },
  {
    "#": "65 Westbourne Ter (091-22-00)",
    "$": 3061900,
    "address": "65 Westbourne Ter",
    "parcel_id": "091-22-00",
    "owner1": "PARKER, GLEN R & NANCY K",
    "owner2": "",
    "current_taxes": 27718.92,
    "new_taxes_no_override": 28916.38,
    "override_total_1": 29736.86,
    "override_increase_1": 820.48
  },
  {
    "#": "69 Westbourne Ter, Unit 69 (091-23-06)",
    "$": 3157900,
    "address": "69 Westbourne Ter, Unit 69",
    "parcel_id": "091-23-06",
    "owner1": "ORKIN, STUART H & ROSLYN W",
    "owner2": "",
    "current_taxes": 28701.96,
    "new_taxes_no_override": 29941.88,
    "override_total_1": 30791.46,
    "override_increase_1": 849.58
  },
  {
    "#": "69 Westbourne Ter, Unit 71 (091-23-07)",
    "$": 3241600,
    "address": "69 Westbourne Ter, Unit 71",
    "parcel_id": "091-23-07",
    "owner1": "GLAZER, DANIEL I & JANE O",
    "owner2": "",
    "current_taxes": 29559.05,
    "new_taxes_no_override": 30836.0,
    "override_total_1": 31710.95,
    "override_increase_1": 874.95
  },
  {
    "#": "69 Westbourne Ter, Unit 73 (091-23-08)",
    "$": 3160900,
    "address": "69 Westbourne Ter, Unit 73",
    "parcel_id": "091-23-08",
    "owner1": "OZIK, GIDEON",
    "owner2": "CHERIZLI, TALI",
    "current_taxes": 32367.62,
    "new_taxes_no_override": 33765.9,
    "override_total_1": 34723.98,
    "override_increase_1": 958.08
  },
  {
    "#": "69 Westbourne Ter, Unit 75 (091-23-09)",
    "$": 3272200,
    "address": "69 Westbourne Ter, Unit 75",
    "parcel_id": "091-23-09",
    "owner1": "HIRSCHMAN TRS, JASON & CAGLA B",
    "owner2": "",
    "current_taxes": 33507.33,
    "new_taxes_no_override": 34954.85,
    "override_total_1": 35946.66,
    "override_increase_1": 991.82
  },
  {
    "#": "77 Westbourne Ter (091-24-00)",
    "$": 3586200,
    "address": "77 Westbourne Ter",
    "parcel_id": "091-24-00",
    "owner1": "CHANDLER, DANIEL",
    "owner2": "LEE, WON MON",
    "current_taxes": 33087.75,
    "new_taxes_no_override": 34517.14,
    "override_total_1": 35496.54,
    "override_increase_1": 979.4
  },
  {
    "#": "81 Westbourne Ter, Unit 1 (091-25-01)",
    "$": 1281900,
    "address": "81 Westbourne Ter, Unit 1",
    "parcel_id": "091-25-01",
    "owner1": "HERTZ, PATRICIA",
    "owner2": "",
    "current_taxes": 9491.72,
    "new_taxes_no_override": 9901.76,
    "override_total_1": 10182.72,
    "override_increase_1": 280.95
  },
  {
    "#": "81 Westbourne Ter, Unit 2 (091-25-02)",
    "$": 1971100,
    "address": "81 Westbourne Ter, Unit 2",
    "parcel_id": "091-25-02",
    "owner1": "URMAN TRS, SERGEY & CHRISTINE ORLOVA",
    "owner2": "",
    "current_taxes": 20184.06,
    "new_taxes_no_override": 21056.01,
    "override_total_1": 21653.46,
    "override_increase_1": 597.45
  },
  {
    "#": "84 Westbourne Ter, Unit 84 (093-14-01)",
    "$": 2525300,
    "address": "84 Westbourne Ter, Unit 84",
    "parcel_id": "093-14-01",
    "owner1": "TACK, JASON & EMILIE",
    "owner2": "",
    "current_taxes": 25859.07,
    "new_taxes_no_override": 26976.18,
    "override_total_1": 27741.61,
    "override_increase_1": 765.43
  },
  {
    "#": "84 Westbourne Ter, Unit 86 (093-14-02)",
    "$": 2689700,
    "address": "84 Westbourne Ter, Unit 86",
    "parcel_id": "093-14-02",
    "owner1": "GOPALAKRISHNAN, ANIRUDDHA",
    "owner2": "VARMA, NISHA VERONICA",
    "current_taxes": 23907.59,
    "new_taxes_no_override": 24940.4,
    "override_total_1": 25648.06,
    "override_increase_1": 707.66
  },
  {
    "#": "85 Westbourne Ter (091-26-00)",
    "$": 2235700,
    "address": "85 Westbourne Ter",
    "parcel_id": "091-26-00",
    "owner1": "EDELMAN, SIDNEY & ELLEN M",
    "owner2": "",
    "current_taxes": 19258.63,
    "new_taxes_no_override": 20090.6,
    "override_total_1": 20660.66,
    "override_increase_1": 570.06
  },
  {
    "#": "89 Westbourne Ter (091-27-00)",
    "$": 2583600,
    "address": "89 Westbourne Ter",
    "parcel_id": "091-27-00",
    "owner1": "WONG TRS, FOO YUEN",
    "owner2": "WAGNER, JEAN W",
    "current_taxes": 22821.13,
    "new_taxes_no_override": 23807.0,
    "override_total_1": 24482.51,
    "override_increase_1": 675.51
  },
  {
    "#": "90 Westbourne Ter, Unit 1 (093-13-01)",
    "$": 1208300,
    "address": "90 Westbourne Ter, Unit 1",
    "parcel_id": "093-13-01",
    "owner1": "ROSENFELD, LEONID & JULIA LEV",
    "owner2": "",
    "current_taxes": 8738.06,
    "new_taxes_no_override": 9115.54,
    "override_total_1": 9374.19,
    "override_increase_1": 258.65
  },
  {
    "#": "90 Westbourne Ter, Unit 2 (093-13-02)",
    "$": 1313900,
    "address": "90 Westbourne Ter, Unit 2",
    "parcel_id": "093-13-02",
    "owner1": "EAGAN, MARGERY M",
    "owner2": "",
    "current_taxes": 9819.4,
    "new_taxes_no_override": 10243.6,
    "override_total_1": 10534.25,
    "override_increase_1": 290.65
  },
  {
    "#": "94 Westbourne Ter (093-12-00)",
    "$": 2194800,
    "address": "94 Westbourne Ter",
    "parcel_id": "093-12-00",
    "owner1": "WEINBERGER, DAVID D",
    "owner2": "GELLER, ANN S",
    "current_taxes": 18839.82,
    "new_taxes_no_override": 19653.7,
    "override_total_1": 20211.36,
    "override_increase_1": 557.66
  },
  {
    "#": "95 Westbourne Ter (091-28-00)",
    "$": 2440100,
    "address": "95 Westbourne Ter",
    "parcel_id": "091-28-00",
    "owner1": "WESTBOURNE TERRACE LLC",
    "owner2": "",
    "current_taxes": 24986.62,
    "new_taxes_no_override": 26066.04,
    "override_total_1": 26805.65,
    "override_increase_1": 739.6
  },
  {
    "#": "98 Westbourne Ter (093-11-00)",
    "$": 2206400,
    "address": "98 Westbourne Ter",
    "parcel_id": "093-11-00",
    "owner1": "GOULSTON TR, ELEANOR L",
    "owner2": "C/O GOULSTON, RICHARD B",
    "current_taxes": 22593.54,
    "new_taxes_no_override": 23569.58,
    "override_total_1": 24238.35,
    "override_increase_1": 668.77
  },
  {
    "#": "99 Westbourne Ter, Unit 101 (091-29-02)",
    "$": 831600,
    "address": "99 Westbourne Ter, Unit 101",
    "parcel_id": "091-29-02",
    "owner1": "TYAGI, SHIVRAJ S & BIMLA",
    "owner2": "",
    "current_taxes": 4880.65,
    "new_taxes_no_override": 5091.49,
    "override_total_1": 5235.96,
    "override_increase_1": 144.47
  },
  {
    "#": "99 Westbourne Ter, Unit 201 (091-29-01)",
    "$": 873100,
    "address": "99 Westbourne Ter, Unit 201",
    "parcel_id": "091-29-01",
    "owner1": "ZHANG, PING",
    "owner2": "",
    "current_taxes": 5305.61,
    "new_taxes_no_override": 5534.81,
    "override_total_1": 5691.86,
    "override_increase_1": 157.05
  },
  {
    "#": "103 Westbourne Ter (091-30-00)",
    "$": 2143500,
    "address": "103 Westbourne Ter",
    "parcel_id": "091-30-00",
    "owner1": "ANDLER TR, DAVID B",
    "owner2": "",
    "current_taxes": 21949.44,
    "new_taxes_no_override": 22897.66,
    "override_total_1": 23547.36,
    "override_increase_1": 649.7
  },
  {
    "#": "104 Westbourne Ter, Unit 1 (093-10-01)",
    "$": 948800,
    "address": "104 Westbourne Ter, Unit 1",
    "parcel_id": "093-10-01",
    "owner1": "KAIM DONIGER TRS, JEREMY & TAMAR",
    "owner2": "",
    "current_taxes": 6080.78,
    "new_taxes_no_override": 6343.47,
    "override_total_1": 6523.46,
    "override_increase_1": 179.99
  },
  {
    "#": "104 Westbourne Ter, Unit Pk Sps A-B (093-10-02)",
    "$": 1041200,
    "address": "104 Westbourne Ter, Unit Pk Sps A-B",
    "parcel_id": "093-10-02",
    "owner1": "HAZEN, ERIC S",
    "owner2": "STOUTLAND, SARA E",
    "current_taxes": 7026.95,
    "new_taxes_no_override": 7330.51,
    "override_total_1": 7538.51,
    "override_increase_1": 208.0
  },
  {
    "#": "106 Westbourne Ter, Unit 1 (093-09-01)",
    "$": 1227100,
    "address": "106 Westbourne Ter, Unit 1",
    "parcel_id": "093-09-01",
    "owner1": "RATIALA LTD",
    "owner2": "",
    "current_taxes": 12565.5,
    "new_taxes_no_override": 13108.33,
    "override_total_1": 13480.27,
    "override_increase_1": 371.94
  },
  {
    "#": "106 Westbourne Ter, Unit 2 (093-09-02)",
    "$": 1269300,
    "address": "106 Westbourne Ter, Unit 2",
    "parcel_id": "093-09-02",
    "owner1": "RATIALA LTD",
    "owner2": "",
    "current_taxes": 9362.7,
    "new_taxes_no_override": 9767.17,
    "override_total_1": 10044.3,
    "override_increase_1": 277.14
  },
  {
    "#": "107 Westbourne Ter, Unit 1 (091-31-01)",
    "$": 1454100,
    "address": "107 Westbourne Ter, Unit 1",
    "parcel_id": "091-31-01",
    "owner1": "HUBERFELD, NICOLE L",
    "owner2": "TREACY, DAVID J",
    "current_taxes": 11255.05,
    "new_taxes_no_override": 11741.27,
    "override_total_1": 12074.42,
    "override_increase_1": 333.15
  },
  {
    "#": "107 Westbourne Ter, Unit 2 (091-31-02)",
    "$": 1955800,
    "address": "107 Westbourne Ter, Unit 2",
    "parcel_id": "091-31-02",
    "owner1": "GUO, JOSHUA",
    "owner2": "LEE, STEFI",
    "current_taxes": 16392.46,
    "new_taxes_no_override": 17100.61,
    "override_total_1": 17585.83,
    "override_increase_1": 485.22
  },
  {
    "#": "108 Westbourne Ter, Unit 1 & P3 & 4 (093-08-01)",
    "$": 1739500,
    "address": "108 Westbourne Ter, Unit 1 & P3 & 4",
    "parcel_id": "093-08-01",
    "owner1": "HU-BIANCO, QING LINA & ANDREA",
    "owner2": "",
    "current_taxes": 17812.48,
    "new_taxes_no_override": 18581.98,
    "override_total_1": 19109.23,
    "override_increase_1": 527.25
  },
  {
    "#": "108 Westbourne Ter, Unit 2 & P1 & P2 (093-08-02)",
    "$": 2113100,
    "address": "108 Westbourne Ter, Unit 2 & P1 & P2",
    "parcel_id": "093-08-02",
    "owner1": "VITEK, OLGA",
    "owner2": "",
    "current_taxes": 18003.21,
    "new_taxes_no_override": 18780.95,
    "override_total_1": 19313.84,
    "override_increase_1": 532.9
  },
  {
    "#": "111 Westbourne Ter (091-32-00)",
    "$": 2342900,
    "address": "111 Westbourne Ter",
    "parcel_id": "091-32-00",
    "owner1": "PUSHAK, TRS, VLADIMIR & LYUDMILA",
    "owner2": "",
    "current_taxes": 23991.3,
    "new_taxes_no_override": 25027.72,
    "override_total_1": 25737.87,
    "override_increase_1": 710.14
  },
  {
    "#": "112 Westbourne Ter, Unit 112 (093-07-02)",
    "$": 1758600,
    "address": "112 Westbourne Ter, Unit 112",
    "parcel_id": "093-07-02",
    "owner1": "COHEN, JONATHAN I & MARGEAUX S",
    "owner2": "",
    "current_taxes": 14373.13,
    "new_taxes_no_override": 14994.05,
    "override_total_1": 15419.49,
    "override_increase_1": 425.44
  },
  {
    "#": "112 Westbourne Ter, Unit 114 (093-07-01)",
    "$": 1242500,
    "address": "112 Westbourne Ter, Unit 114",
    "parcel_id": "093-07-01",
    "owner1": "LEE, RICHARD H",
    "owner2": "",
    "current_taxes": 12723.2,
    "new_taxes_no_override": 13272.84,
    "override_total_1": 13649.45,
    "override_increase_1": 376.61
  },
  {
    "#": "115 Westbourne Ter, Unit 1 (091-33-01)",
    "$": 1183400,
    "address": "115 Westbourne Ter, Unit 1",
    "parcel_id": "091-33-01",
    "owner1": "BARNARD, ANNE",
    "owner2": "",
    "current_taxes": 8483.08,
    "new_taxes_no_override": 8849.55,
    "override_total_1": 9100.65,
    "override_increase_1": 251.1
  },
  {
    "#": "115 Westbourne Ter, Unit 2 (091-33-02)",
    "$": 1188400,
    "address": "115 Westbourne Ter, Unit 2",
    "parcel_id": "091-33-02",
    "owner1": "SCHACHTER TRS, HYME",
    "owner2": "GRAY, CINDY",
    "current_taxes": 8534.28,
    "new_taxes_no_override": 8902.96,
    "override_total_1": 9155.58,
    "override_increase_1": 252.61
  },
  {
    "#": "116 Westbourne Ter (093-06-00)",
    "$": 2041700,
    "address": "116 Westbourne Ter",
    "parcel_id": "093-06-00",
    "owner1": "TAM, MELINDA",
    "owner2": "AU, CONSTANCE & THOMAS L",
    "current_taxes": 17272.07,
    "new_taxes_no_override": 18018.22,
    "override_total_1": 18529.48,
    "override_increase_1": 511.25
  },
  {
    "#": "119 Westbourne Ter (091-34-00)",
    "$": 3279900,
    "address": "119 Westbourne Ter",
    "parcel_id": "091-34-00",
    "owner1": "ADLER TR, AARON M",
    "owner2": "",
    "current_taxes": 33586.18,
    "new_taxes_no_override": 35037.1,
    "override_total_1": 36031.25,
    "override_increase_1": 994.15
  },
  {
    "#": "120 Westbourne Ter, Unit A (093-05-00)",
    "$": 1559600,
    "address": "120 Westbourne Ter, Unit A",
    "parcel_id": "093-05-00",
    "owner1": "LEVINE, MIRIAM",
    "owner2": "",
    "current_taxes": 12335.37,
    "new_taxes_no_override": 12868.26,
    "override_total_1": 13233.38,
    "override_increase_1": 365.13
  },
  {
    "#": "122 Westbourne Ter, Unit A (093-04-00)",
    "$": 2007600,
    "address": "122 Westbourne Ter, Unit A",
    "parcel_id": "093-04-00",
    "owner1": "PASEK, CRAIG J",
    "owner2": "ALLEN, SUSAN F",
    "current_taxes": 16922.89,
    "new_taxes_no_override": 17653.96,
    "override_total_1": 18154.88,
    "override_increase_1": 500.92
  },
  {
    "#": "125 Westbourne Ter (091-36-00)",
    "$": 2060700,
    "address": "125 Westbourne Ter",
    "parcel_id": "091-36-00",
    "owner1": "ADLER TR, AARON M",
    "owner2": "",
    "current_taxes": 21101.57,
    "new_taxes_no_override": 22013.16,
    "override_total_1": 22637.76,
    "override_increase_1": 624.61
  },
  {
    "#": "126 Westbourne Ter (093-03-00)",
    "$": 2028800,
    "address": "126 Westbourne Ter",
    "parcel_id": "093-03-00",
    "owner1": "GARMEL, JEFFREY",
    "owner2": "KNOTT, LAURA",
    "current_taxes": 17139.98,
    "new_taxes_no_override": 17880.43,
    "override_total_1": 18387.77,
    "override_increase_1": 507.34
  },
  {
    "#": "127 Westbourne Ter, Unit 1 (091-37-01)",
    "$": 588200,
    "address": "127 Westbourne Ter, Unit 1",
    "parcel_id": "091-37-01",
    "owner1": "TOORISH, MELODY",
    "owner2": "",
    "current_taxes": 2388.23,
    "new_taxes_no_override": 2491.4,
    "override_total_1": 2562.09,
    "override_increase_1": 70.69
  },
  {
    "#": "127 Westbourne Ter, Unit 2 (091-37-02)",
    "$": 1910000,
    "address": "127 Westbourne Ter, Unit 2",
    "parcel_id": "091-37-02",
    "owner1": "SHAINHOUSE, AVRAHAM Y",
    "owner2": "KAGEDAN, LILA",
    "current_taxes": 15923.47,
    "new_taxes_no_override": 16611.36,
    "override_total_1": 17082.7,
    "override_increase_1": 471.33
  },
  {
    "#": "128 Westbourne Ter (093-02-00)",
    "$": 1950600,
    "address": "128 Westbourne Ter",
    "parcel_id": "093-02-00",
    "owner1": "WONG TRS, WING & MICHAEL",
    "owner2": "",
    "current_taxes": 16339.21,
    "new_taxes_no_override": 17045.06,
    "override_total_1": 17528.7,
    "override_increase_1": 483.64
  },
  {
    "#": "131 Westbourne Ter (091-38-00)",
    "$": 1952800,
    "address": "131 Westbourne Ter",
    "parcel_id": "091-38-00",
    "owner1": "WANG, DONGYU",
    "owner2": "CHEN, SHENGYING",
    "current_taxes": 16361.74,
    "new_taxes_no_override": 17068.57,
    "override_total_1": 17552.87,
    "override_increase_1": 484.31
  },
  {
    "#": "132 Westbourne Ter (093-01-00)",
    "$": 1306700,
    "address": "132 Westbourne Ter",
    "parcel_id": "093-01-00",
    "owner1": "WC- AMBOJANG LLC",
    "owner2": "",
    "current_taxes": 13380.61,
    "new_taxes_no_override": 13958.65,
    "override_total_1": 14354.72,
    "override_increase_1": 396.07
  },
  {
    "#": "133 Westbourne Ter, Unit 1 (091-38-02)",
    "$": 259000,
    "address": "133 Westbourne Ter, Unit 1",
    "parcel_id": "091-38-02",
    "owner1": "STARK, FRANCESCA",
    "owner2": "",
    "current_taxes": 2652.16,
    "new_taxes_no_override": 2766.73,
    "override_total_1": 2845.24,
    "override_increase_1": 78.5
  },
  {
    "#": "133 Westbourne Ter, Unit 2 (091-38-03)",
    "$": 178900,
    "address": "133 Westbourne Ter, Unit 2",
    "parcel_id": "091-38-03",
    "owner1": "GOODNOW, EMILY",
    "owner2": "",
    "current_taxes": 1831.94,
    "new_taxes_no_override": 1911.08,
    "override_total_1": 1965.31,
    "override_increase_1": 54.23
  },
  {
    "#": "133 Westbourne Ter, Unit 3 (091-38-04)",
    "$": 199900,
    "address": "133 Westbourne Ter, Unit 3",
    "parcel_id": "091-38-04",
    "owner1": "DONOVAN, ELIZABETH A",
    "owner2": "QUIGLEY, BRENDAN E",
    "current_taxes": 2046.98,
    "new_taxes_no_override": 2135.41,
    "override_total_1": 2196.0,
    "override_increase_1": 60.59
  },
  {
    "#": "17 Weybridge Ln (208-04-01)",
    "$": 2373000,
    "address": "17 Weybridge Ln",
    "parcel_id": "208-04-01",
    "owner1": "CHAMBERLIN, PAUL",
    "owner2": "ARISTONDO, MARIA",
    "current_taxes": 20664.59,
    "new_taxes_no_override": 21557.3,
    "override_total_1": 22168.97,
    "override_increase_1": 611.67
  },
  {
    "#": "25 Weybridge Ln (208-03-01)",
    "$": 2696500,
    "address": "25 Weybridge Ln",
    "parcel_id": "208-03-01",
    "owner1": "WOLITZKY, ALEXANDER GREENBERG & SANDRA ULLMAN",
    "owner2": "",
    "current_taxes": 23977.23,
    "new_taxes_no_override": 25013.05,
    "override_total_1": 25722.77,
    "override_increase_1": 709.73
  },
  {
    "#": "33 Weybridge Ln (208-02-01)",
    "$": 2387600,
    "address": "33 Weybridge Ln",
    "parcel_id": "208-02-01",
    "owner1": "TALBOT, CYNTHIA H",
    "owner2": "FRANGOS, JASON E",
    "current_taxes": 20814.09,
    "new_taxes_no_override": 21713.26,
    "override_total_1": 22329.36,
    "override_increase_1": 616.1
  },
  {
    "#": "37 Weybridge Ln (208-01-01)",
    "$": 2464500,
    "address": "37 Weybridge Ln",
    "parcel_id": "208-01-01",
    "owner1": "HIRSOWITZ, GEOFFREY & DEBORAH B",
    "owner2": "",
    "current_taxes": 21601.55,
    "new_taxes_no_override": 22534.74,
    "override_total_1": 23174.14,
    "override_increase_1": 639.41
  },
  {
    "#": "7 Weybridge Rd (208-05-00)",
    "$": 1864000,
    "address": "7 Weybridge Rd",
    "parcel_id": "208-05-00",
    "owner1": "GREEN, ELIOT J & ELISSA E",
    "owner2": "",
    "current_taxes": 15452.43,
    "new_taxes_no_override": 16119.97,
    "override_total_1": 16577.37,
    "override_increase_1": 457.39
  },
  {
    "#": "15 Weybridge Rd (208-06-00)",
    "$": 2717900,
    "address": "15 Weybridge Rd",
    "parcel_id": "208-06-00",
    "owner1": "UNDERHILL, LISA",
    "owner2": "MONROE, MICHAEL",
    "current_taxes": 24196.36,
    "new_taxes_no_override": 25241.64,
    "override_total_1": 25957.86,
    "override_increase_1": 716.21
  },
  {
    "#": "25 Weybridge Rd (208-07-00)",
    "$": 2603400,
    "address": "25 Weybridge Rd",
    "parcel_id": "208-07-00",
    "owner1": "MARCUS, LEONARD J",
    "owner2": "",
    "current_taxes": 23023.88,
    "new_taxes_no_override": 24018.51,
    "override_total_1": 24700.02,
    "override_increase_1": 681.51
  },
  {
    "#": "26 Weybridge Rd (207-03-04)",
    "$": 4701200,
    "address": "26 Weybridge Rd",
    "parcel_id": "207-03-04",
    "owner1": "ANG, DERRICK",
    "owner2": "HO, JUNLIN",
    "current_taxes": 48140.29,
    "new_taxes_no_override": 50219.95,
    "override_total_1": 51644.9,
    "override_increase_1": 1424.95
  },
  {
    "#": "31 Weybridge Rd (208-09-00)",
    "$": 2377200,
    "address": "31 Weybridge Rd",
    "parcel_id": "208-09-00",
    "owner1": "MCARDLE TRS, CHRISTINE GRIZEL & COLIN ROBERT",
    "owner2": "",
    "current_taxes": 20707.59,
    "new_taxes_no_override": 21602.16,
    "override_total_1": 22215.1,
    "override_increase_1": 612.94
  },
  {
    "#": "35 Weybridge Rd (208-10-00)",
    "$": 2153500,
    "address": "35 Weybridge Rd",
    "parcel_id": "208-10-00",
    "owner1": "DENKER, STEPHEN P & ELAYNE W",
    "owner2": "",
    "current_taxes": 18416.91,
    "new_taxes_no_override": 19212.52,
    "override_total_1": 19757.66,
    "override_increase_1": 545.14
  },
  {
    "#": "8 White Ave (274-08-00)",
    "$": 2148300,
    "address": "8 White Ave",
    "parcel_id": "274-08-00",
    "owner1": "NIAKOSARI TR, ALI",
    "owner2": "",
    "current_taxes": 21998.59,
    "new_taxes_no_override": 22948.93,
    "override_total_1": 23600.09,
    "override_increase_1": 651.16
  },
  {
    "#": "12 White Ave, Unit 1 (274-07-01)",
    "$": 783800,
    "address": "12 White Ave, Unit 1",
    "parcel_id": "274-07-01",
    "owner1": "DEVECSERI, ZSUZSANNA",
    "owner2": "WATZKER, ANDRAS IMRE",
    "current_taxes": 8026.11,
    "new_taxes_no_override": 8372.84,
    "override_total_1": 8610.41,
    "override_increase_1": 237.57
  },
  {
    "#": "12 White Ave, Unit 2 & P4 (274-07-02)",
    "$": 974700,
    "address": "12 White Ave, Unit 2 & P4",
    "parcel_id": "274-07-02",
    "owner1": "POTTER, JULIA E",
    "owner2": "BERTOLI, VINCENZO",
    "current_taxes": 9980.93,
    "new_taxes_no_override": 10412.11,
    "override_total_1": 10707.54,
    "override_increase_1": 295.44
  },
  {
    "#": "12 White Ave, Unit 3 (274-07-03)",
    "$": 895800,
    "address": "12 White Ave, Unit 3",
    "parcel_id": "274-07-03",
    "owner1": "LENNON, XIANLU & DAVID",
    "owner2": "",
    "current_taxes": 9172.99,
    "new_taxes_no_override": 9569.26,
    "override_total_1": 9840.78,
    "override_increase_1": 271.52
  },
  {
    "#": "2 White Pl (184-17-01)",
    "$": 422600,
    "address": "2 White Pl",
    "parcel_id": "184-17-01",
    "owner1": "2 WHITE PLACE LLC",
    "owner2": "",
    "current_taxes": 7251.82,
    "new_taxes_no_override": 7565.1,
    "override_total_1": 7779.75,
    "override_increase_1": 214.65
  },
  {
    "#": "9 White Pl (183-19-00)",
    "$": 2102700,
    "address": "9 White Pl",
    "parcel_id": "183-19-00",
    "owner1": "MATSKEVICH, LEV & ASHLEY N",
    "owner2": "",
    "current_taxes": 21531.65,
    "new_taxes_no_override": 22461.82,
    "override_total_1": 23099.15,
    "override_increase_1": 637.34
  },
  {
    "#": "10 White Pl (184-17-00)",
    "$": 1821200,
    "address": "10 White Pl",
    "parcel_id": "184-17-00",
    "owner1": "FURNISS, CONSTANCE SLOANE",
    "owner2": "STEKETEE, DANIEL JAMES",
    "current_taxes": 15014.15,
    "new_taxes_no_override": 15662.76,
    "override_total_1": 16107.18,
    "override_increase_1": 444.42
  },
  {
    "#": "11 White Pl (183-20-00)",
    "$": 1565900,
    "address": "11 White Pl",
    "parcel_id": "183-20-00",
    "owner1": "SNYDER TRS, CHERYL ANNE",
    "owner2": "WILLEMSEN CORTES, BALAM QUITZE ANDRES",
    "current_taxes": 12399.88,
    "new_taxes_no_override": 12935.55,
    "override_total_1": 13302.59,
    "override_increase_1": 367.04
  },
  {
    "#": "12 White Pl, Unit 12A (184-16-04)",
    "$": 653500,
    "address": "12 White Pl, Unit 12A",
    "parcel_id": "184-16-04",
    "owner1": "DALY, KEVIN",
    "owner2": "",
    "current_taxes": 6691.84,
    "new_taxes_no_override": 6980.93,
    "override_total_1": 7179.01,
    "override_increase_1": 198.08
  },
  {
    "#": "12 White Pl, Unit 12B (184-16-01)",
    "$": 657400,
    "address": "12 White Pl, Unit 12B",
    "parcel_id": "184-16-01",
    "owner1": "ARLIA, FRANCES",
    "owner2": "",
    "current_taxes": 3096.84,
    "new_taxes_no_override": 3230.62,
    "override_total_1": 3322.29,
    "override_increase_1": 91.67
  },
  {
    "#": "12 White Pl, Unit 12C & Pk Sp B (184-16-02)",
    "$": 667600,
    "address": "12 White Pl, Unit 12C & Pk Sp B",
    "parcel_id": "184-16-02",
    "owner1": "PRICE, ALLEN C",
    "owner2": "OTERO, ANA ROSA",
    "current_taxes": 3201.29,
    "new_taxes_no_override": 3339.59,
    "override_total_1": 3434.34,
    "override_increase_1": 94.76
  },
  {
    "#": "13 White Pl (183-21-22)",
    "$": 2357500,
    "address": "13 White Pl",
    "parcel_id": "183-21-22",
    "owner1": "LEVINE, SAMUEL P & SANDRA W",
    "owner2": "",
    "current_taxes": 20505.87,
    "new_taxes_no_override": 21391.72,
    "override_total_1": 21998.7,
    "override_increase_1": 606.97
  },
  {
    "#": "14 White Pl, Unit 14 & Pk Sp A (184-16-03)",
    "$": 826500,
    "address": "14 White Pl, Unit 14 & Pk Sp A",
    "parcel_id": "184-16-03",
    "owner1": "KAPLAN, SETH L & ELIZABETH Z S",
    "owner2": "",
    "current_taxes": 4828.43,
    "new_taxes_no_override": 5037.02,
    "override_total_1": 5179.94,
    "override_increase_1": 142.92
  },
  {
    "#": "16 White Pl (184-15-00)",
    "$": 1869600,
    "address": "16 White Pl",
    "parcel_id": "184-15-00",
    "owner1": "ROH, JASON",
    "owner2": "HUNTER, REBECCA",
    "current_taxes": 15509.77,
    "new_taxes_no_override": 16179.79,
    "override_total_1": 16638.88,
    "override_increase_1": 459.09
  },
  {
    "#": "17 White Pl (183-23-00)",
    "$": 1593900,
    "address": "17 White Pl",
    "parcel_id": "183-23-00",
    "owner1": "RILEY, EMMA M",
    "owner2": "",
    "current_taxes": 16321.54,
    "new_taxes_no_override": 17026.63,
    "override_total_1": 17509.75,
    "override_increase_1": 483.12
  },
  {
    "#": "20 White Pl (184-14-00)",
    "$": 1551300,
    "address": "20 White Pl",
    "parcel_id": "184-14-00",
    "owner1": "KLEMAN, NICOLE C",
    "owner2": "BOWERS, JASON D",
    "current_taxes": 12250.38,
    "new_taxes_no_override": 12779.6,
    "override_total_1": 13142.21,
    "override_increase_1": 362.61
  },
  {
    "#": "21 White Pl (183-24-00)",
    "$": 1555300,
    "address": "21 White Pl",
    "parcel_id": "183-24-00",
    "owner1": "TRECKER, STANLEY M & MARY ANNE",
    "owner2": "",
    "current_taxes": 12291.34,
    "new_taxes_no_override": 12822.33,
    "override_total_1": 13186.15,
    "override_increase_1": 363.82
  },
  {
    "#": "22 White Pl, Unit 1 (184-13-01)",
    "$": 1086100,
    "address": "22 White Pl, Unit 1",
    "parcel_id": "184-13-01",
    "owner1": "ARTIGAS REALTY LLC",
    "owner2": "JESSE METCALF C/O NADEAU & ASSOC CPAS LLC",
    "current_taxes": 11121.66,
    "new_taxes_no_override": 11602.12,
    "override_total_1": 11931.32,
    "override_increase_1": 329.2
  },
  {
    "#": "23 White Pl (183-25-00)",
    "$": 1522800,
    "address": "23 White Pl",
    "parcel_id": "183-25-00",
    "owner1": "WHITNEY, LAWRENCE A",
    "owner2": "RAWIZZA, HOLLY E",
    "current_taxes": 11958.54,
    "new_taxes_no_override": 12475.15,
    "override_total_1": 12829.12,
    "override_increase_1": 353.97
  },
  {
    "#": "24 White Pl, Unit 2 (184-13-02)",
    "$": 1116600,
    "address": "24 White Pl, Unit 2",
    "parcel_id": "184-13-02",
    "owner1": "AYALAS REALTY LLC",
    "owner2": "JESSE METCALF C/O NADEAU & ASSOC CPAS LLC",
    "current_taxes": 11433.98,
    "new_taxes_no_override": 11927.93,
    "override_total_1": 12266.37,
    "override_increase_1": 338.45
  },
  {
    "#": "25 White Pl (183-26-00)",
    "$": 1585600,
    "address": "25 White Pl",
    "parcel_id": "183-26-00",
    "owner1": "RAWIZZA TR, ALAN R",
    "owner2": "",
    "current_taxes": 12601.61,
    "new_taxes_no_override": 13146.0,
    "override_total_1": 13519.01,
    "override_increase_1": 373.01
  },
  {
    "#": "26 White Pl, Unit B, Unit 1 (184-12-01)",
    "$": 924800,
    "address": "26 White Pl, Unit B, Unit 1",
    "parcel_id": "184-12-01",
    "owner1": "MAZER, MICHAEL E & HANNAH G & ANNE LEE",
    "owner2": "",
    "current_taxes": 5835.02,
    "new_taxes_no_override": 6087.09,
    "override_total_1": 6259.81,
    "override_increase_1": 172.72
  },
  {
    "#": "26 White Pl, Unit B, Unit 2 (184-12-02)",
    "$": 914100,
    "address": "26 White Pl, Unit B, Unit 2",
    "parcel_id": "184-12-02",
    "owner1": "WANG, XIN & YUEYUE",
    "owner2": "",
    "current_taxes": 5725.45,
    "new_taxes_no_override": 5972.79,
    "override_total_1": 6142.26,
    "override_increase_1": 169.47
  },
  {
    "#": "26 White Pl, Unit B, Unit 3 (184-12-03)",
    "$": 910300,
    "address": "26 White Pl, Unit B, Unit 3",
    "parcel_id": "184-12-03",
    "owner1": "LINDSAY, JAMES & EMMA MULLEN",
    "owner2": "",
    "current_taxes": 5686.54,
    "new_taxes_no_override": 5932.2,
    "override_total_1": 6100.52,
    "override_increase_1": 168.32
  },
  {
    "#": "27 White Pl (183-27-00)",
    "$": 1421000,
    "address": "27 White Pl",
    "parcel_id": "183-27-00",
    "owner1": "MORRIS, MELODY K",
    "owner2": "GREINER, JONATHAN M",
    "current_taxes": 10916.11,
    "new_taxes_no_override": 11387.69,
    "override_total_1": 11710.8,
    "override_increase_1": 323.12
  },
  {
    "#": "28 White Pl (184-11-00)",
    "$": 1465000,
    "address": "28 White Pl",
    "parcel_id": "184-11-00",
    "owner1": "AUDITORE, JAMES A",
    "owner2": "",
    "current_taxes": 11366.67,
    "new_taxes_no_override": 11857.71,
    "override_total_1": 12194.16,
    "override_increase_1": 336.45
  },
  {
    "#": "31 White Pl (183-28-00)",
    "$": 1249400,
    "address": "31 White Pl",
    "parcel_id": "183-28-00",
    "owner1": "BERRY, CHARLES",
    "owner2": "",
    "current_taxes": 12793.86,
    "new_taxes_no_override": 13346.55,
    "override_total_1": 13725.25,
    "override_increase_1": 378.7
  },
  {
    "#": "33 White Pl (183-29-00)",
    "$": 1676700,
    "address": "33 White Pl",
    "parcel_id": "183-29-00",
    "owner1": "ZEDEK TRS, DANIEL A",
    "owner2": "JOHNSON, MARILYNN S",
    "current_taxes": 13534.47,
    "new_taxes_no_override": 14119.16,
    "override_total_1": 14519.78,
    "override_increase_1": 400.62
  },
  {
    "#": "34 White Pl (184-08-10)",
    "$": 2379500,
    "address": "34 White Pl",
    "parcel_id": "184-08-10",
    "owner1": "KCEKOB LLC",
    "owner2": "",
    "current_taxes": 24366.08,
    "new_taxes_no_override": 25418.69,
    "override_total_1": 26139.93,
    "override_increase_1": 721.24
  },
  {
    "#": "35 White Pl, Unit 1 (183-30-01)",
    "$": 785600,
    "address": "35 White Pl, Unit 1",
    "parcel_id": "183-30-01",
    "owner1": "TIAN, LIPENG",
    "owner2": "ZHANG, SHI",
    "current_taxes": 4409.61,
    "new_taxes_no_override": 4600.11,
    "override_total_1": 4730.63,
    "override_increase_1": 130.52
  },
  {
    "#": "35 White Pl, Unit 2 (183-30-02)",
    "$": 790600,
    "address": "35 White Pl, Unit 2",
    "parcel_id": "183-30-02",
    "owner1": "ASFOUR, AMMAR",
    "owner2": "",
    "current_taxes": 4460.81,
    "new_taxes_no_override": 4653.52,
    "override_total_1": 4785.56,
    "override_increase_1": 132.04
  },
  {
    "#": "35 White Pl, Unit 3 (183-30-03)",
    "$": 871800,
    "address": "35 White Pl, Unit 3",
    "parcel_id": "183-30-03",
    "owner1": "FU, YUXIN",
    "owner2": "",
    "current_taxes": 8927.23,
    "new_taxes_no_override": 9312.89,
    "override_total_1": 9577.13,
    "override_increase_1": 264.25
  },
  {
    "#": "37 White Pl, Unit 1 (183-31-01)",
    "$": 675300,
    "address": "37 White Pl, Unit 1",
    "parcel_id": "183-31-01",
    "owner1": "TAYLOR TR, EMMA T",
    "owner2": "",
    "current_taxes": 3280.14,
    "new_taxes_no_override": 3421.84,
    "override_total_1": 3518.93,
    "override_increase_1": 97.09
  },
  {
    "#": "37 White Pl, Unit 2 (183-31-02)",
    "$": 706500,
    "address": "37 White Pl, Unit 2",
    "parcel_id": "183-31-02",
    "owner1": "KIM, EVA J",
    "owner2": "",
    "current_taxes": 3599.63,
    "new_taxes_no_override": 3755.13,
    "override_total_1": 3861.68,
    "override_increase_1": 106.55
  },
  {
    "#": "37 White Pl, Unit 3 (183-31-03)",
    "$": 727700,
    "address": "37 White Pl, Unit 3",
    "parcel_id": "183-31-03",
    "owner1": "BICHIMER TRS, DEBORAH J & MICHAEL R",
    "owner2": "",
    "current_taxes": 7451.65,
    "new_taxes_no_override": 7773.56,
    "override_total_1": 7994.13,
    "override_increase_1": 220.57
  },
  {
    "#": "38 White Pl (184-07-00)",
    "$": 1764300,
    "address": "38 White Pl",
    "parcel_id": "184-07-00",
    "owner1": "MONIS, STEVEN & MARY ELLEN",
    "owner2": "",
    "current_taxes": 14431.5,
    "new_taxes_no_override": 15054.94,
    "override_total_1": 15482.11,
    "override_increase_1": 427.17
  },
  {
    "#": "40 White Pl, Unit 1 (184-18-01)",
    "$": 693900,
    "address": "40 White Pl, Unit 1",
    "parcel_id": "184-18-01",
    "owner1": "CORRDIN, WILL & VERONIQUE",
    "owner2": "",
    "current_taxes": 3470.6,
    "new_taxes_no_override": 3620.53,
    "override_total_1": 3723.26,
    "override_increase_1": 102.73
  },
  {
    "#": "40 White Pl, Unit 2 (184-18-02)",
    "$": 704900,
    "address": "40 White Pl, Unit 2",
    "parcel_id": "184-18-02",
    "owner1": "YUAN, CHEN",
    "owner2": "",
    "current_taxes": 3583.24,
    "new_taxes_no_override": 3738.04,
    "override_total_1": 3844.1,
    "override_increase_1": 106.06
  },
  {
    "#": "40 White Pl, Unit 3 (184-18-03)",
    "$": 758200,
    "address": "40 White Pl, Unit 3",
    "parcel_id": "184-18-03",
    "owner1": "BERNTSEN, MATTHEW C",
    "owner2": "PERLMAN, ELISABETH R",
    "current_taxes": 7763.97,
    "new_taxes_no_override": 8099.37,
    "override_total_1": 8329.19,
    "override_increase_1": 229.81
  },
  {
    "#": "41 White Pl (183-32-00)",
    "$": 2046100,
    "address": "41 White Pl",
    "parcel_id": "183-32-00",
    "owner1": "SHI, MENGLIN",
    "owner2": "",
    "current_taxes": 20952.06,
    "new_taxes_no_override": 21857.19,
    "override_total_1": 22477.37,
    "override_increase_1": 620.18
  },
  {
    "#": "44 White Pl (184-05-00)",
    "$": 1445700,
    "address": "44 White Pl",
    "parcel_id": "184-05-00",
    "owner1": "COSTELLO, DEIDRE LYON",
    "owner2": "MARTIN, HOWARD WILBUR III",
    "current_taxes": 11169.03,
    "new_taxes_no_override": 11651.53,
    "override_total_1": 11982.14,
    "override_increase_1": 330.6
  },
  {
    "#": "45 White Pl (183-33-00)",
    "$": 1427600,
    "address": "45 White Pl",
    "parcel_id": "183-33-00",
    "owner1": "DENTREMONT, TRS, FRANKLIN J & RITA M",
    "owner2": "",
    "current_taxes": 10983.69,
    "new_taxes_no_override": 11458.19,
    "override_total_1": 11783.3,
    "override_increase_1": 325.12
  },
  {
    "#": "46 White Pl (184-04-01)",
    "$": 2137900,
    "address": "46 White Pl",
    "parcel_id": "184-04-01",
    "owner1": "PRETZEL FACTORY LLC",
    "owner2": "",
    "current_taxes": 21892.1,
    "new_taxes_no_override": 22837.84,
    "override_total_1": 23485.84,
    "override_increase_1": 648.01
  },
  {
    "#": "47 White Pl (183-34-00)",
    "$": 1565000,
    "address": "47 White Pl",
    "parcel_id": "183-34-00",
    "owner1": "BRACKEN, DAMIEN S & PAMELA S",
    "owner2": "",
    "current_taxes": 12390.67,
    "new_taxes_no_override": 12925.95,
    "override_total_1": 13292.71,
    "override_increase_1": 366.76
  },
  {
    "#": "48 White Pl, Unit 48-1 (184-04-02)",
    "$": 903800,
    "address": "48 White Pl, Unit 48-1",
    "parcel_id": "184-04-02",
    "owner1": "GRIMES, YURI & NYDJIE",
    "owner2": "",
    "current_taxes": 5619.98,
    "new_taxes_no_override": 5862.76,
    "override_total_1": 6029.11,
    "override_increase_1": 166.35
  },
  {
    "#": "48 White Pl, Unit 48-2 (184-04-03)",
    "$": 890200,
    "address": "48 White Pl, Unit 48-2",
    "parcel_id": "184-04-03",
    "owner1": "SHERIDAN, DANA & THALIA LUISE",
    "owner2": "",
    "current_taxes": 5480.71,
    "new_taxes_no_override": 5717.48,
    "override_total_1": 5879.71,
    "override_increase_1": 162.23
  },
  {
    "#": "49 White Pl (183-35-00)",
    "$": 1527300,
    "address": "49 White Pl",
    "parcel_id": "183-35-00",
    "owner1": "PERRY, REBECCA",
    "owner2": "",
    "current_taxes": 12004.62,
    "new_taxes_no_override": 12523.22,
    "override_total_1": 12878.56,
    "override_increase_1": 355.34
  },
  {
    "#": "50 White Pl, Unit 50-1 (184-04-04)",
    "$": 855200,
    "address": "50 White Pl, Unit 50-1",
    "parcel_id": "184-04-04",
    "owner1": "COHEN, SAMANTHA",
    "owner2": "CHRISTIE, FRASER GAVIN",
    "current_taxes": 5122.31,
    "new_taxes_no_override": 5343.59,
    "override_total_1": 5495.21,
    "override_increase_1": 151.62
  },
  {
    "#": "50 White Pl, Unit 50-2 (184-04-05)",
    "$": 833700,
    "address": "50 White Pl, Unit 50-2",
    "parcel_id": "184-04-05",
    "owner1": "WITKIN, ANDREW & LEAH S",
    "owner2": "",
    "current_taxes": 4902.15,
    "new_taxes_no_override": 5113.92,
    "override_total_1": 5259.03,
    "override_increase_1": 145.1
  },
  {
    "#": "51 White Pl (183-36-00)",
    "$": 1698600,
    "address": "51 White Pl",
    "parcel_id": "183-36-00",
    "owner1": "BRILL TRS, MICHAEL E",
    "owner2": "IRVINGS, LISA R",
    "current_taxes": 13758.73,
    "new_taxes_no_override": 14353.11,
    "override_total_1": 14760.37,
    "override_increase_1": 407.26
  },
  {
    "#": "52 White Pl, Unit 52 (184-04-06)",
    "$": 691100,
    "address": "52 White Pl, Unit 52",
    "parcel_id": "184-04-06",
    "owner1": "BORN TR, ANNETTE L",
    "owner2": "",
    "current_taxes": 3441.93,
    "new_taxes_no_override": 3590.62,
    "override_total_1": 3692.5,
    "override_increase_1": 101.88
  },
  {
    "#": "53 White Pl (183-37-00)",
    "$": 1905300,
    "address": "53 White Pl",
    "parcel_id": "183-37-00",
    "owner1": "HEENEY, LEO P",
    "owner2": "",
    "current_taxes": 19510.27,
    "new_taxes_no_override": 20353.11,
    "override_total_1": 20930.62,
    "override_increase_1": 577.5
  },
  {
    "#": "54 White Pl, Unit 54 (184-04-07)",
    "$": 861300,
    "address": "54 White Pl, Unit 54",
    "parcel_id": "184-04-07",
    "owner1": "PONCE, FERNANDO",
    "owner2": "",
    "current_taxes": 8819.71,
    "new_taxes_no_override": 9200.72,
    "override_total_1": 9461.78,
    "override_increase_1": 261.06
  },
  {
    "#": "55 White Pl (183-38-00)",
    "$": 2056700,
    "address": "55 White Pl",
    "parcel_id": "183-38-00",
    "owner1": "BAID, AKASH",
    "owner2": "CHAUDHURY, ANWESHA",
    "current_taxes": 17425.67,
    "new_taxes_no_override": 18178.46,
    "override_total_1": 18694.26,
    "override_increase_1": 515.8
  },
  {
    "#": "61 White Pl (183-39-00)",
    "$": 1647500,
    "address": "61 White Pl",
    "parcel_id": "183-39-00",
    "owner1": "DOWNEY, BRENDAN G",
    "owner2": "STACEY, IRWIN",
    "current_taxes": 13235.47,
    "new_taxes_no_override": 13807.24,
    "override_total_1": 14199.01,
    "override_increase_1": 391.77
  },
  {
    "#": "62 White Pl (184-02-00)",
    "$": 1218900,
    "address": "62 White Pl",
    "parcel_id": "184-02-00",
    "owner1": "SALTZMAN, DANIEL",
    "owner2": "AMIGONE, JENNIFER",
    "current_taxes": 8846.6,
    "new_taxes_no_override": 9228.77,
    "override_total_1": 9490.63,
    "override_increase_1": 261.86
  },
  {
    "#": "64 White Pl, Unit 1 (184-01-01)",
    "$": 539500,
    "address": "64 White Pl, Unit 1",
    "parcel_id": "184-01-01",
    "owner1": "VILENCHIK, YANA",
    "owner2": "ORLOVSKY, DMITRY",
    "current_taxes": 5524.48,
    "new_taxes_no_override": 5763.14,
    "override_total_1": 5926.66,
    "override_increase_1": 163.52
  },
  {
    "#": "64 White Pl, Unit 2 (184-01-02)",
    "$": 519500,
    "address": "64 White Pl, Unit 2",
    "parcel_id": "184-01-02",
    "owner1": "GEDSTAD, ABBY",
    "owner2": "",
    "current_taxes": 5319.68,
    "new_taxes_no_override": 5549.49,
    "override_total_1": 5706.95,
    "override_increase_1": 157.46
  },
  {
    "#": "64 White Pl, Unit 3 (184-01-03)",
    "$": 526100,
    "address": "64 White Pl, Unit 3",
    "parcel_id": "184-01-03",
    "owner1": "MULLER-SZERAWS, JAN",
    "owner2": "JUEZ-PERRONE, MELBA",
    "current_taxes": 5387.26,
    "new_taxes_no_override": 5619.99,
    "override_total_1": 5779.45,
    "override_increase_1": 159.46
  },
  {
    "#": "65 White Pl (183-40-00)",
    "$": 108900,
    "address": "65 White Pl",
    "parcel_id": "183-40-00",
    "owner1": "DOWNEY, BRENDAN G",
    "owner2": "STACEY, IRWIN",
    "current_taxes": 1115.14,
    "new_taxes_no_override": 1163.31,
    "override_total_1": 1196.32,
    "override_increase_1": 33.01
  },
  {
    "#": "70 White Pl, Unit 70 (182-18-01)",
    "$": 2377300,
    "address": "70 White Pl, Unit 70",
    "parcel_id": "182-18-01",
    "owner1": "DEPETRO, WYNDSOR & MARILYN",
    "owner2": "",
    "current_taxes": 20708.62,
    "new_taxes_no_override": 21603.23,
    "override_total_1": 22216.21,
    "override_increase_1": 612.98
  },
  {
    "#": "72 White Pl, Unit 72 (182-18-02)",
    "$": 2308200,
    "address": "72 White Pl, Unit 72",
    "parcel_id": "182-18-02",
    "owner1": "JERNIGAN, KEVIN",
    "owner2": "HASTINGS, ALLISON",
    "current_taxes": 20001.03,
    "new_taxes_no_override": 20865.07,
    "override_total_1": 21457.1,
    "override_increase_1": 592.03
  },
  {
    "#": "9 Whitney St, Unit 9 (344-02-01)",
    "$": 933000,
    "address": "9 Whitney St, Unit 9",
    "parcel_id": "344-02-01",
    "owner1": "SHI, XIAOMENG",
    "owner2": "MA, LI",
    "current_taxes": 5918.99,
    "new_taxes_no_override": 6174.69,
    "override_total_1": 6349.89,
    "override_increase_1": 175.2
  },
  {
    "#": "10 Whitney St (343-09-00)",
    "$": 1406300,
    "address": "10 Whitney St",
    "parcel_id": "343-09-00",
    "owner1": "FORTUNATO, ARLENE",
    "owner2": "",
    "current_taxes": 10765.58,
    "new_taxes_no_override": 11230.65,
    "override_total_1": 11549.31,
    "override_increase_1": 318.66
  },
  {
    "#": "11 Whitney St, Unit 11 (344-02-02)",
    "$": 773400,
    "address": "11 Whitney St, Unit 11",
    "parcel_id": "344-02-02",
    "owner1": "FORTRESS HOLDINGS LLC",
    "owner2": "",
    "current_taxes": 7919.62,
    "new_taxes_no_override": 8261.75,
    "override_total_1": 8496.17,
    "override_increase_1": 234.42
  },
  {
    "#": "14 Whitney St (343-08-00)",
    "$": 1344800,
    "address": "14 Whitney St",
    "parcel_id": "343-08-00",
    "owner1": "CONNELLY, SUSAN",
    "owner2": "",
    "current_taxes": 10135.82,
    "new_taxes_no_override": 10573.69,
    "override_total_1": 10873.71,
    "override_increase_1": 300.02
  },
  {
    "#": "15 Whitney St (344-03-00)",
    "$": 1754900,
    "address": "15 Whitney St",
    "parcel_id": "344-03-00",
    "owner1": "PORKHOVNIK TRS, JANNA & PAUL",
    "owner2": "",
    "current_taxes": 14335.24,
    "new_taxes_no_override": 14954.52,
    "override_total_1": 15378.85,
    "override_increase_1": 424.32
  },
  {
    "#": "17 Whitney St (344-04-00)",
    "$": 1224800,
    "address": "17 Whitney St",
    "parcel_id": "344-04-00",
    "owner1": "CHARNEY, DAVID C & STEVEN H",
    "owner2": "NATHANSON, DORIA A",
    "current_taxes": 12541.95,
    "new_taxes_no_override": 13083.76,
    "override_total_1": 13455.0,
    "override_increase_1": 371.24
  },
  {
    "#": "20 Whitney St (343-07-00)",
    "$": 1152800,
    "address": "20 Whitney St",
    "parcel_id": "343-07-00",
    "owner1": "PARKS COHEN, SUSAN M",
    "owner2": "COHEN, ANDREW",
    "current_taxes": 8169.74,
    "new_taxes_no_override": 8522.67,
    "override_total_1": 8764.5,
    "override_increase_1": 241.82
  },
  {
    "#": "21 Whitney St (344-05-00)",
    "$": 1447100,
    "address": "21 Whitney St",
    "parcel_id": "344-05-00",
    "owner1": "FREESE, JOHN B",
    "owner2": "WOLF, WENDY A",
    "current_taxes": 11183.37,
    "new_taxes_no_override": 11666.49,
    "override_total_1": 11997.52,
    "override_increase_1": 331.03
  },
  {
    "#": "24 Whitney St (343-06-00)",
    "$": 1107800,
    "address": "24 Whitney St",
    "parcel_id": "343-06-00",
    "owner1": "HATZIELEFTHERIADIS, HARRY & DEBORAH",
    "owner2": "",
    "current_taxes": 7708.94,
    "new_taxes_no_override": 8041.97,
    "override_total_1": 8270.15,
    "override_increase_1": 228.18
  },
  {
    "#": "25 Whitney St (344-06-00)",
    "$": 1433100,
    "address": "25 Whitney St",
    "parcel_id": "344-06-00",
    "owner1": "AMES, BROOKS A & MARIELA G",
    "owner2": "",
    "current_taxes": 11040.01,
    "new_taxes_no_override": 11516.94,
    "override_total_1": 11843.72,
    "override_increase_1": 326.78
  },
  {
    "#": "27 Whitney St, Unit 6 (344-08-07)",
    "$": 1590700,
    "address": "27 Whitney St, Unit 6",
    "parcel_id": "344-08-07",
    "owner1": "BHATTACHARYYA, NEIL",
    "owner2": "VIRMANI, ANJINI",
    "current_taxes": 12653.83,
    "new_taxes_no_override": 13200.48,
    "override_total_1": 13575.03,
    "override_increase_1": 374.55
  },
  {
    "#": "29 Whitney St, Unit 5 (344-08-06)",
    "$": 1372800,
    "address": "29 Whitney St, Unit 5",
    "parcel_id": "344-08-06",
    "owner1": "PHILLIPS III, TRS, ASA E",
    "owner2": "GARDNER, SUSAN P",
    "current_taxes": 10422.54,
    "new_taxes_no_override": 10872.79,
    "override_total_1": 11181.3,
    "override_increase_1": 308.51
  },
  {
    "#": "9 Willard Rd (241-03-00)",
    "$": 1630000,
    "address": "9 Willard Rd",
    "parcel_id": "241-03-00",
    "owner1": "LEE TR, SEE",
    "owner2": "",
    "current_taxes": 16691.2,
    "new_taxes_no_override": 17412.26,
    "override_total_1": 17906.32,
    "override_increase_1": 494.06
  },
  {
    "#": "18 Willard Rd (242-04-00)",
    "$": 3614400,
    "address": "18 Willard Rd",
    "parcel_id": "242-04-00",
    "owner1": "SON, JUN HO & MARY BETH",
    "owner2": "",
    "current_taxes": 33376.52,
    "new_taxes_no_override": 34818.39,
    "override_total_1": 35806.33,
    "override_increase_1": 987.94
  },
  {
    "#": "19 Willard Rd (241-04-00)",
    "$": 3073000,
    "address": "19 Willard Rd",
    "parcel_id": "241-04-00",
    "owner1": "ADATT0 TRS, KIKU R",
    "owner2": "SANDEL, MICHAEL J",
    "current_taxes": 27832.59,
    "new_taxes_no_override": 29034.96,
    "override_total_1": 29858.8,
    "override_increase_1": 823.84
  },
  {
    "#": "25 Willard Rd (241-05-00)",
    "$": 3283900,
    "address": "25 Willard Rd",
    "parcel_id": "241-05-00",
    "owner1": "NEWMAN, MARSHALL F & HARRIET",
    "owner2": "",
    "current_taxes": 29992.2,
    "new_taxes_no_override": 31287.86,
    "override_total_1": 32175.63,
    "override_increase_1": 887.77
  },
  {
    "#": "50 Willard Rd (259-06-00)",
    "$": 4186100,
    "address": "50 Willard Rd",
    "parcel_id": "259-06-00",
    "owner1": "SHERMAN TR, ALEC W",
    "owner2": "",
    "current_taxes": 39230.73,
    "new_taxes_no_override": 40925.5,
    "override_total_1": 42086.73,
    "override_increase_1": 1161.23
  },
  {
    "#": "53 Willard Rd (263-08-00)",
    "$": 4316100,
    "address": "53 Willard Rd",
    "parcel_id": "263-08-00",
    "owner1": "JUDGE TR, GREGORY B",
    "owner2": "",
    "current_taxes": 40561.93,
    "new_taxes_no_override": 42314.21,
    "override_total_1": 43514.84,
    "override_increase_1": 1200.63
  },
  {
    "#": "60 Willard Rd (259-05-00)",
    "$": 3214100,
    "address": "60 Willard Rd",
    "parcel_id": "259-05-00",
    "owner1": "PALMISANO, SAMUEL L & TESSA",
    "owner2": "",
    "current_taxes": 32912.38,
    "new_taxes_no_override": 34334.19,
    "override_total_1": 35308.4,
    "override_increase_1": 974.21
  },
  {
    "#": "63 Willard Rd (263-01-01)",
    "$": 4335500,
    "address": "63 Willard Rd",
    "parcel_id": "263-01-01",
    "owner1": "MALONEY, KENNETH A",
    "owner2": "CAMPBELL, SARA J",
    "current_taxes": 40760.59,
    "new_taxes_no_override": 42521.45,
    "override_total_1": 43727.96,
    "override_increase_1": 1206.51
  },
  {
    "#": "74 Willard Rd (260-01-00)",
    "$": 3664000,
    "address": "74 Willard Rd",
    "parcel_id": "260-01-00",
    "owner1": "CHEN TRS, DANNY & LIANG YEU",
    "owner2": "",
    "current_taxes": 33884.43,
    "new_taxes_no_override": 35348.24,
    "override_total_1": 36351.22,
    "override_increase_1": 1002.98
  },
  {
    "#": "75 Willard Rd (262-08-00)",
    "$": 3149100,
    "address": "75 Willard Rd",
    "parcel_id": "262-08-00",
    "owner1": "GAVALYA-SANDOVAL, VALENTINA",
    "owner2": "",
    "current_taxes": 28611.85,
    "new_taxes_no_override": 29847.88,
    "override_total_1": 30694.79,
    "override_increase_1": 846.91
  },
  {
    "#": "85 Willard Rd (262-01-00)",
    "$": 4272000,
    "address": "85 Willard Rd",
    "parcel_id": "262-01-00",
    "owner1": "FOKINA, TATIANA",
    "owner2": "BERNSTEIN, DAVID",
    "current_taxes": 43745.28,
    "new_taxes_no_override": 45635.08,
    "override_total_1": 46929.94,
    "override_increase_1": 1294.86
  },
  {
    "#": "86 Willard Rd (260-06-00)",
    "$": 3694800,
    "address": "86 Willard Rd",
    "parcel_id": "260-06-00",
    "owner1": "KALISH, JEFFREY",
    "owner2": "SHERMAN, BONNIE J",
    "current_taxes": 34199.82,
    "new_taxes_no_override": 35677.25,
    "override_total_1": 36689.57,
    "override_increase_1": 1012.31
  },
  {
    "#": "97 Willard Rd (264B-04-00)",
    "$": 3358100,
    "address": "97 Willard Rd",
    "parcel_id": "264B-04-00",
    "owner1": "SPIRO, RICHARD & ALISON",
    "owner2": "",
    "current_taxes": 30752.01,
    "new_taxes_no_override": 32080.5,
    "override_total_1": 32990.76,
    "override_increase_1": 910.26
  },
  {
    "#": "100 Willard Rd (261-01-00)",
    "$": 3080200,
    "address": "100 Willard Rd",
    "parcel_id": "261-01-00",
    "owner1": "GALLICO TR, ELLEN L",
    "owner2": "",
    "current_taxes": 27906.31,
    "new_taxes_no_override": 29111.86,
    "override_total_1": 29937.89,
    "override_increase_1": 826.03
  },
  {
    "#": "105 Willard Rd (264B-05-00)",
    "$": 3209700,
    "address": "105 Willard Rd",
    "parcel_id": "264B-05-00",
    "owner1": "STOLZBERG TRS, ROBERT A",
    "owner2": "BERMAN, PAULA G",
    "current_taxes": 29232.39,
    "new_taxes_no_override": 30495.23,
    "override_total_1": 31360.51,
    "override_increase_1": 865.28
  },
  {
    "#": "107 Willard Rd (264B-05-01)",
    "$": 8000,
    "address": "107 Willard Rd",
    "parcel_id": "264B-05-01",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O VACANT PARCEL/REAR 105 WILLARD",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "108 Willard Rd (261-14-00)",
    "$": 2949500,
    "address": "108 Willard Rd",
    "parcel_id": "261-14-00",
    "owner1": "GADD, MICHELE",
    "owner2": "TANABE, KENNETH",
    "current_taxes": 26567.95,
    "new_taxes_no_override": 27715.69,
    "override_total_1": 28502.1,
    "override_increase_1": 786.41
  },
  {
    "#": "111 Willard Rd (264B-06-00)",
    "$": 2948700,
    "address": "111 Willard Rd",
    "parcel_id": "264B-06-00",
    "owner1": "MURRAY, FIONA",
    "owner2": "KURIYEL, RALF",
    "current_taxes": 26559.75,
    "new_taxes_no_override": 27707.13,
    "override_total_1": 28493.3,
    "override_increase_1": 786.17
  },
  {
    "#": "114 Willard Rd (261-13-00)",
    "$": 2896800,
    "address": "114 Willard Rd",
    "parcel_id": "261-13-00",
    "owner1": "LAPIDES, JAMES A & MICHELLE M",
    "owner2": "",
    "current_taxes": 26028.3,
    "new_taxes_no_override": 27152.72,
    "override_total_1": 27923.16,
    "override_increase_1": 770.44
  },
  {
    "#": "119 Willard Rd (264B-07-00)",
    "$": 3901400,
    "address": "119 Willard Rd",
    "parcel_id": "264B-07-00",
    "owner1": "HRABOWYCH, OREST & LILLIAN",
    "owner2": "",
    "current_taxes": 36315.4,
    "new_taxes_no_override": 37884.23,
    "override_total_1": 38959.16,
    "override_increase_1": 1074.94
  },
  {
    "#": "120 Willard Rd (261-12-00)",
    "$": 2257200,
    "address": "120 Willard Rd",
    "parcel_id": "261-12-00",
    "owner1": "FORMAN, AVERY R & EDWARD M",
    "owner2": "",
    "current_taxes": 19478.79,
    "new_taxes_no_override": 20320.27,
    "override_total_1": 20896.85,
    "override_increase_1": 576.57
  },
  {
    "#": "125 Willard Rd (264B-08-00)",
    "$": 2975300,
    "address": "125 Willard Rd",
    "parcel_id": "264B-08-00",
    "owner1": "IZUMO, SEIGO & HIROKO",
    "owner2": "",
    "current_taxes": 26832.14,
    "new_taxes_no_override": 27991.29,
    "override_total_1": 28785.52,
    "override_increase_1": 794.23
  },
  {
    "#": "130 Willard Rd (261-11-00)",
    "$": 3132200,
    "address": "130 Willard Rd",
    "parcel_id": "261-11-00",
    "owner1": "RUBENSTEIN TRS, MICHAEL C",
    "owner2": "SKAVISH, ELIZABETH",
    "current_taxes": 28438.79,
    "new_taxes_no_override": 29667.35,
    "override_total_1": 30509.13,
    "override_increase_1": 841.79
  },
  {
    "#": "135 Willard Rd (264B-09-00)",
    "$": 3157800,
    "address": "135 Willard Rd",
    "parcel_id": "264B-09-00",
    "owner1": "GHATGE, CHETAN",
    "owner2": "NANDAKUMAR, NAMRATA",
    "current_taxes": 28700.94,
    "new_taxes_no_override": 29940.82,
    "override_total_1": 30790.37,
    "override_increase_1": 849.55
  },
  {
    "#": "136 Willard Rd (261-10-00)",
    "$": 3191700,
    "address": "136 Willard Rd",
    "parcel_id": "261-10-00",
    "owner1": "GUSEH, STEPHANIE & JAMES SAWALLA",
    "owner2": "",
    "current_taxes": 29048.07,
    "new_taxes_no_override": 30302.95,
    "override_total_1": 31162.77,
    "override_increase_1": 859.82
  },
  {
    "#": "148 Willard Rd (261-09-00)",
    "$": 2743800,
    "address": "148 Willard Rd",
    "parcel_id": "261-09-00",
    "owner1": "HOLTZ, BENJAMIN",
    "owner2": "",
    "current_taxes": 24461.58,
    "new_taxes_no_override": 25518.32,
    "override_total_1": 26242.38,
    "override_increase_1": 724.06
  },
  {
    "#": "149 Willard Rd (264C-03-00)",
    "$": 3180500,
    "address": "149 Willard Rd",
    "parcel_id": "264C-03-00",
    "owner1": "TAYLOR, CAROLINE",
    "owner2": "C/O GELFAND RENNERT & FELDMAN",
    "current_taxes": 32568.32,
    "new_taxes_no_override": 33975.27,
    "override_total_1": 34939.29,
    "override_increase_1": 964.02
  },
  {
    "#": "155 Willard Rd (264C-04-00)",
    "$": 3092000,
    "address": "155 Willard Rd",
    "parcel_id": "264C-04-00",
    "owner1": "DUBIN, MARLA",
    "owner2": "",
    "current_taxes": 28027.15,
    "new_taxes_no_override": 29237.92,
    "override_total_1": 30067.53,
    "override_increase_1": 829.6
  },
  {
    "#": "158 Willard Rd (261-08-01)",
    "$": 2730200,
    "address": "158 Willard Rd",
    "parcel_id": "261-08-01",
    "owner1": "JOHNSON, GENAE",
    "owner2": "COLLINS JR, JAMES H",
    "current_taxes": 24322.31,
    "new_taxes_no_override": 25373.03,
    "override_total_1": 26092.97,
    "override_increase_1": 719.94
  },
  {
    "#": "161 Willard Rd (264C-05-00)",
    "$": 2510600,
    "address": "161 Willard Rd",
    "parcel_id": "264C-05-00",
    "owner1": "MEGO, ALEX & LARA",
    "owner2": "",
    "current_taxes": 22073.61,
    "new_taxes_no_override": 23027.19,
    "override_total_1": 23680.57,
    "override_increase_1": 653.38
  },
  {
    "#": "164 Willard Rd (261-08-00)",
    "$": 3266100,
    "address": "164 Willard Rd",
    "parcel_id": "261-08-00",
    "owner1": "BURG TRS, SARAH S",
    "owner2": "DANFORD, ANDREW J",
    "current_taxes": 29809.93,
    "new_taxes_no_override": 31097.72,
    "override_total_1": 31980.09,
    "override_increase_1": 882.37
  },
  {
    "#": "167 Willard Rd (264C-06-00)",
    "$": 3024200,
    "address": "167 Willard Rd",
    "parcel_id": "264C-06-00",
    "owner1": "KERNER, HILARY",
    "owner2": "KOLICK, ADAM",
    "current_taxes": 27332.87,
    "new_taxes_no_override": 28513.65,
    "override_total_1": 29322.7,
    "override_increase_1": 809.05
  },
  {
    "#": "11 Williams St, Unit 10 &P10-16 (078-09-10)",
    "$": 1223900,
    "address": "11 Williams St, Unit 10 &P10-16",
    "parcel_id": "078-09-10",
    "owner1": "FRIMERMAN, REVITAL & GUY",
    "owner2": "",
    "current_taxes": 8897.8,
    "new_taxes_no_override": 9282.18,
    "override_total_1": 9545.56,
    "override_increase_1": 263.37
  },
  {
    "#": "12 Williams St (081-10-00)",
    "$": 1729800,
    "address": "12 Williams St",
    "parcel_id": "081-10-00",
    "owner1": "STARIKOV TR, FRED",
    "owner2": "",
    "current_taxes": 17713.15,
    "new_taxes_no_override": 18478.36,
    "override_total_1": 19002.67,
    "override_increase_1": 524.31
  },
  {
    "#": "15 Williams St, Unit 9 & Sp 9 (078-09-09)",
    "$": 1074400,
    "address": "15 Williams St, Unit 9 & Sp 9",
    "parcel_id": "078-09-09",
    "owner1": "WACKS, KENNETH P",
    "owner2": "",
    "current_taxes": 7366.92,
    "new_taxes_no_override": 7685.17,
    "override_total_1": 7903.23,
    "override_increase_1": 218.06
  },
  {
    "#": "16 Williams St (081-09-00)",
    "$": 2136000,
    "address": "16 Williams St",
    "parcel_id": "081-09-00",
    "owner1": "HUMANITY HOUSE INC",
    "owner2": "C/O BARRY PRICE REHAB",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "17 Williams St, Unit 8 & P8 (078-09-08)",
    "$": 1106100,
    "address": "17 Williams St, Unit 8 & P8",
    "parcel_id": "078-09-08",
    "owner1": "JENG, LAWRENCE",
    "owner2": "KAO, CHING-WUN",
    "current_taxes": 11326.46,
    "new_taxes_no_override": 11815.76,
    "override_total_1": 12151.03,
    "override_increase_1": 335.26
  },
  {
    "#": "19 Williams St, Unit 7 & Sp 7 (078-09-07)",
    "$": 1167300,
    "address": "19 Williams St, Unit 7 & Sp 7",
    "parcel_id": "078-09-07",
    "owner1": "MEUNIER, JACOB B & BO Z",
    "owner2": "",
    "current_taxes": 11953.15,
    "new_taxes_no_override": 12469.53,
    "override_total_1": 12823.34,
    "override_increase_1": 353.81
  },
  {
    "#": "21 Williams St, Unit 6 Pk #6 14 (078-09-06)",
    "$": 1150100,
    "address": "21 Williams St, Unit 6 Pk #6 14",
    "parcel_id": "078-09-06",
    "owner1": "YEUNG TRS, JAMES C",
    "owner2": "MOH, LILY P",
    "current_taxes": 8142.09,
    "new_taxes_no_override": 8493.83,
    "override_total_1": 8734.83,
    "override_increase_1": 241.01
  },
  {
    "#": "23 Williams St, Unit 5 Pk 5 11 (078-09-05)",
    "$": 1092100,
    "address": "23 Williams St, Unit 5 Pk 5 11",
    "parcel_id": "078-09-05",
    "owner1": "GOHIL, SHILA",
    "owner2": "",
    "current_taxes": 11183.1,
    "new_taxes_no_override": 11666.21,
    "override_total_1": 11997.23,
    "override_increase_1": 331.02
  },
  {
    "#": "24 Williams St (081-08-00)",
    "$": 2418900,
    "address": "24 Williams St",
    "parcel_id": "081-08-00",
    "owner1": "GOLDBERG TR, CAREY",
    "owner2": "",
    "current_taxes": 21134.6,
    "new_taxes_no_override": 22047.61,
    "override_total_1": 22673.2,
    "override_increase_1": 625.58
  },
  {
    "#": "25 Williams St, Unit 4 (078-09-04)",
    "$": 1104700,
    "address": "25 Williams St, Unit 4",
    "parcel_id": "078-09-04",
    "owner1": "SADEH, AMIR & ADI HANA DOVER",
    "owner2": "",
    "current_taxes": 7677.19,
    "new_taxes_no_override": 8008.84,
    "override_total_1": 8236.09,
    "override_increase_1": 227.24
  },
  {
    "#": "40 Williams St (080-01-00)",
    "$": 15402500,
    "address": "40 Williams St",
    "parcel_id": "080-01-00",
    "owner1": "BASILE, ROBERT W",
    "owner2": "C/O FORTY WILLIAMS ASSOC LLC",
    "current_taxes": 159851.65,
    "new_taxes_no_override": 166757.24,
    "override_total_1": 171488.85,
    "override_increase_1": 4731.61
  },
  {
    "#": "46 Williams St (080-16-00)",
    "$": 3344000,
    "address": "46 Williams St",
    "parcel_id": "080-16-00",
    "owner1": "GRAFF TR, JOYCE WILCOX",
    "owner2": "",
    "current_taxes": 30607.63,
    "new_taxes_no_override": 31929.88,
    "override_total_1": 32835.87,
    "override_increase_1": 905.99
  },
  {
    "#": "48 Williams St, Unit 1 (080-15-03)",
    "$": 906700,
    "address": "48 Williams St, Unit 1",
    "parcel_id": "080-15-03",
    "owner1": "MEYERS, TERRY F",
    "owner2": "",
    "current_taxes": 5649.67,
    "new_taxes_no_override": 5893.74,
    "override_total_1": 6060.97,
    "override_increase_1": 167.23
  },
  {
    "#": "48 Williams St, Unit 2 (080-15-01)",
    "$": 976400,
    "address": "48 Williams St, Unit 2",
    "parcel_id": "080-15-01",
    "owner1": "BARRON, ORIT AVNI",
    "owner2": "",
    "current_taxes": 6363.4,
    "new_taxes_no_override": 6638.3,
    "override_total_1": 6826.66,
    "override_increase_1": 188.36
  },
  {
    "#": "48 Williams St, Unit 3 (080-15-02)",
    "$": 956300,
    "address": "48 Williams St, Unit 3",
    "parcel_id": "080-15-02",
    "owner1": "YEE, DEREK",
    "owner2": "WANG, VIVIAN L",
    "current_taxes": 9792.51,
    "new_taxes_no_override": 10215.55,
    "override_total_1": 10505.4,
    "override_increase_1": 289.86
  },
  {
    "#": "50 Williams St, Unit 1 (080-14-02)",
    "$": 795600,
    "address": "50 Williams St, Unit 1",
    "parcel_id": "080-14-02",
    "owner1": "SHEPRO, TR, JUDITH E S",
    "owner2": "",
    "current_taxes": 8146.94,
    "new_taxes_no_override": 8498.89,
    "override_total_1": 8740.04,
    "override_increase_1": 241.15
  },
  {
    "#": "50 Williams St, Unit 2 (080-14-03)",
    "$": 850800,
    "address": "50 Williams St, Unit 2",
    "parcel_id": "080-14-03",
    "owner1": "SILVER, TR, RACHEL ANN",
    "owner2": "",
    "current_taxes": 5077.26,
    "new_taxes_no_override": 5296.6,
    "override_total_1": 5446.88,
    "override_increase_1": 150.29
  },
  {
    "#": "50 Williams St, Unit 3 (080-14-04)",
    "$": 839600,
    "address": "50 Williams St, Unit 3",
    "parcel_id": "080-14-04",
    "owner1": "SHEPRO TRS, ALAN G & JUDITH E S",
    "owner2": "",
    "current_taxes": 4962.57,
    "new_taxes_no_override": 5176.95,
    "override_total_1": 5323.85,
    "override_increase_1": 146.89
  },
  {
    "#": "50 Williams St, Unit B (080-14-01)",
    "$": 452600,
    "address": "50 Williams St, Unit B",
    "parcel_id": "080-14-01",
    "owner1": "YOUNG, TR, LAUREL M",
    "owner2": "",
    "current_taxes": 4634.62,
    "new_taxes_no_override": 4834.84,
    "override_total_1": 4972.02,
    "override_increase_1": 137.18
  },
  {
    "#": "11 Williston Rd (101-14-01)",
    "$": 4153900,
    "address": "11 Williston Rd",
    "parcel_id": "101-14-01",
    "owner1": "TORAH ACADEMY INC",
    "owner2": "CONGREGATION BETH PINCHOS, OF GRAND RABBI HOROWITZ INC",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "17 Williston Rd (101-15-00)",
    "$": 3054500,
    "address": "17 Williston Rd",
    "parcel_id": "101-15-00",
    "owner1": "CONGREGATION BETH PINCHOS OF GRAND RABBI HOROWITZ INC",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "18 Williston Rd (102-37-00)",
    "$": 2571900,
    "address": "18 Williston Rd",
    "parcel_id": "102-37-00",
    "owner1": "SEPHARDIC CONGREGATION OF N E",
    "owner2": "C/O DAVID SHEENAH",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "29 Williston Rd (100-11-00)",
    "$": 2748000,
    "address": "29 Williston Rd",
    "parcel_id": "100-11-00",
    "owner1": "RABE JR, FRANK T",
    "owner2": "LEFKO, JANET L",
    "current_taxes": 24504.59,
    "new_taxes_no_override": 25563.19,
    "override_total_1": 26288.52,
    "override_increase_1": 725.34
  },
  {
    "#": "30 Williston Rd (099-01-00)",
    "$": 2888700,
    "address": "30 Williston Rd",
    "parcel_id": "099-01-00",
    "owner1": "DOCTOROFF, ADAM S & CHRISTINA R",
    "owner2": "",
    "current_taxes": 25945.35,
    "new_taxes_no_override": 27066.19,
    "override_total_1": 27834.17,
    "override_increase_1": 767.98
  },
  {
    "#": "39 Williston Rd (100-12-00)",
    "$": 2836600,
    "address": "39 Williston Rd",
    "parcel_id": "100-12-00",
    "owner1": "CONGREGATION BETH PINCHOS OF, GRAND RABBI HOROWITZ INC",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "55 Williston Rd (097-07-00)",
    "$": 4005100,
    "address": "55 Williston Rd",
    "parcel_id": "097-07-00",
    "owner1": "MCCANDLESS, HOLLOWAY",
    "owner2": "BELT, ANDREW R",
    "current_taxes": 37377.29,
    "new_taxes_no_override": 38991.99,
    "override_total_1": 40098.36,
    "override_increase_1": 1106.37
  },
  {
    "#": "64 Williston Rd (098-05-00)",
    "$": 3548400,
    "address": "64 Williston Rd",
    "parcel_id": "098-05-00",
    "owner1": "RUBIN, RON & RACHEL",
    "owner2": "",
    "current_taxes": 32700.68,
    "new_taxes_no_override": 34113.35,
    "override_total_1": 35081.29,
    "override_increase_1": 967.94
  },
  {
    "#": "65 Williston Rd (097-08-00)",
    "$": 3305600,
    "address": "65 Williston Rd",
    "parcel_id": "097-08-00",
    "owner1": "SHAKED TRS, VARDA & ISRAEL",
    "owner2": "",
    "current_taxes": 30214.41,
    "new_taxes_no_override": 31519.67,
    "override_total_1": 32414.02,
    "override_increase_1": 894.35
  },
  {
    "#": "70 Williston Rd (098-04-00)",
    "$": 3106400,
    "address": "70 Williston Rd",
    "parcel_id": "098-04-00",
    "owner1": "LEV TRS, MARK TOBY & CAROL RADACK",
    "owner2": "",
    "current_taxes": 28174.6,
    "new_taxes_no_override": 29391.74,
    "override_total_1": 30225.71,
    "override_increase_1": 833.97
  },
  {
    "#": "71 Williston Rd (097-09-00)",
    "$": 3029000,
    "address": "71 Williston Rd",
    "parcel_id": "097-09-00",
    "owner1": "GINER TR, A SILVANA",
    "owner2": "",
    "current_taxes": 27382.03,
    "new_taxes_no_override": 28564.93,
    "override_total_1": 29375.44,
    "override_increase_1": 810.51
  },
  {
    "#": "76 Williston Rd (098-03-00)",
    "$": 2719400,
    "address": "76 Williston Rd",
    "parcel_id": "098-03-00",
    "owner1": "LUNGU, CODRIN ION & ANDREEA ONDINA",
    "owner2": "",
    "current_taxes": 24211.72,
    "new_taxes_no_override": 25257.67,
    "override_total_1": 25974.33,
    "override_increase_1": 716.67
  },
  {
    "#": "79 Williston Rd (097-10-00)",
    "$": 3107500,
    "address": "79 Williston Rd",
    "parcel_id": "097-10-00",
    "owner1": "RUSSO, MASSIMO & FARLA",
    "owner2": "",
    "current_taxes": 28185.87,
    "new_taxes_no_override": 29403.5,
    "override_total_1": 30237.8,
    "override_increase_1": 834.3
  },
  {
    "#": "82 Williston Rd (098-02-00)",
    "$": 2526400,
    "address": "82 Williston Rd",
    "parcel_id": "098-02-00",
    "owner1": "PINTO, PATRICIA E",
    "owner2": "SALIC, ADRIAN",
    "current_taxes": 22235.4,
    "new_taxes_no_override": 23195.97,
    "override_total_1": 23854.14,
    "override_increase_1": 658.17
  },
  {
    "#": "85 Williston Rd (097-11-00)",
    "$": 3522700,
    "address": "85 Williston Rd",
    "parcel_id": "097-11-00",
    "owner1": "SSK BIRDS LLC",
    "owner2": "",
    "current_taxes": 36072.45,
    "new_taxes_no_override": 37630.78,
    "override_total_1": 38698.52,
    "override_increase_1": 1067.74
  },
  {
    "#": "88 Williston Rd (098-01-00)",
    "$": 3411200,
    "address": "88 Williston Rd",
    "parcel_id": "098-01-00",
    "owner1": "SAXENA, SHEEL J & ADITI RAO",
    "owner2": "",
    "current_taxes": 31295.75,
    "new_taxes_no_override": 32647.73,
    "override_total_1": 33574.08,
    "override_increase_1": 926.35
  },
  {
    "#": "5 Willow Cres (264A-01-00)",
    "$": 2494000,
    "address": "5 Willow Cres",
    "parcel_id": "264A-01-00",
    "owner1": "CHA TR, ASSUNTA H",
    "owner2": "C/O CHA TR, ASSUNTA H",
    "current_taxes": 21903.63,
    "new_taxes_no_override": 22849.87,
    "override_total_1": 23498.21,
    "override_increase_1": 648.35
  },
  {
    "#": "11 Willow Cres (264A-02-00)",
    "$": 3336900,
    "address": "11 Willow Cres",
    "parcel_id": "264A-02-00",
    "owner1": "BEESTON, DAVID & KATHARINE",
    "owner2": "",
    "current_taxes": 30534.92,
    "new_taxes_no_override": 31854.03,
    "override_total_1": 32757.86,
    "override_increase_1": 903.83
  },
  {
    "#": "20 Willow Cres (264B-22-00)",
    "$": 3073900,
    "address": "20 Willow Cres",
    "parcel_id": "264B-22-00",
    "owner1": "RIVO TR, SHARON P",
    "owner2": "",
    "current_taxes": 27841.8,
    "new_taxes_no_override": 29044.57,
    "override_total_1": 29868.68,
    "override_increase_1": 824.12
  },
  {
    "#": "21 Willow Cres (264A-03-00)",
    "$": 2321600,
    "address": "21 Willow Cres",
    "parcel_id": "264A-03-00",
    "owner1": "MICHAELS, SUSAN P",
    "owner2": "",
    "current_taxes": 20138.25,
    "new_taxes_no_override": 21008.22,
    "override_total_1": 21604.31,
    "override_increase_1": 596.09
  },
  {
    "#": "26 Willow Cres (264B-21-00)",
    "$": 3327600,
    "address": "26 Willow Cres",
    "parcel_id": "264B-21-00",
    "owner1": "GOLDSTEIN, ROBERT S & MARA RIEMER",
    "owner2": "",
    "current_taxes": 30439.69,
    "new_taxes_no_override": 31754.68,
    "override_total_1": 32655.7,
    "override_increase_1": 901.01
  },
  {
    "#": "27 Willow Cres (264A-04-05)",
    "$": 3622300,
    "address": "27 Willow Cres",
    "parcel_id": "264A-04-05",
    "owner1": "EISENBERG TRS, LEWIS C",
    "owner2": "FARRELL, NANCY FRANCES",
    "current_taxes": 33457.42,
    "new_taxes_no_override": 34902.78,
    "override_total_1": 35893.12,
    "override_increase_1": 990.34
  },
  {
    "#": "34 Willow Cres (264B-20-00)",
    "$": 2668100,
    "address": "34 Willow Cres",
    "parcel_id": "264B-20-00",
    "owner1": "LISS, AVI & HEIDI B",
    "owner2": "",
    "current_taxes": 23686.41,
    "new_taxes_no_override": 24709.66,
    "override_total_1": 25410.78,
    "override_increase_1": 701.12
  },
  {
    "#": "38 Willow Cres (264B-19-00)",
    "$": 1986000,
    "address": "38 Willow Cres",
    "parcel_id": "264B-19-00",
    "owner1": "SMITH TRS, GEORGE E & INDIA S",
    "owner2": "",
    "current_taxes": 20336.64,
    "new_taxes_no_override": 21215.18,
    "override_total_1": 21817.15,
    "override_increase_1": 601.96
  },
  {
    "#": "44 Willow Cres (264B-18-00)",
    "$": 2792800,
    "address": "44 Willow Cres",
    "parcel_id": "264B-18-00",
    "owner1": "GEBHARDT, PAULETTE T",
    "owner2": "",
    "current_taxes": 24963.34,
    "new_taxes_no_override": 26041.76,
    "override_total_1": 26780.67,
    "override_increase_1": 738.91
  },
  {
    "#": "45 Willow Cres (264A-06-00)",
    "$": 2931900,
    "address": "45 Willow Cres",
    "parcel_id": "264A-06-00",
    "owner1": "WARNER TRS, CHERYL K & DONALD A",
    "owner2": "",
    "current_taxes": 26387.72,
    "new_taxes_no_override": 27527.67,
    "override_total_1": 28308.75,
    "override_increase_1": 781.08
  },
  {
    "#": "50 Willow Cres (264B-17-00)",
    "$": 3461000,
    "address": "50 Willow Cres",
    "parcel_id": "264B-17-00",
    "owner1": "ELENTUKH, ALEXANDER",
    "owner2": "FIGO, IRINA",
    "current_taxes": 31805.71,
    "new_taxes_no_override": 33179.72,
    "override_total_1": 34121.17,
    "override_increase_1": 941.45
  },
  {
    "#": "54 Willow Cres (264B-16-00)",
    "$": 3081800,
    "address": "54 Willow Cres",
    "parcel_id": "264B-16-00",
    "owner1": "BERKSON, DOUGLAS & SARA COOPER",
    "owner2": "",
    "current_taxes": 27922.7,
    "new_taxes_no_override": 29128.96,
    "override_total_1": 29955.47,
    "override_increase_1": 826.51
  },
  {
    "#": "57 Willow Cres (264A-07-00)",
    "$": 2273600,
    "address": "57 Willow Cres",
    "parcel_id": "264A-07-00",
    "owner1": "FINE TR, JONATHAN S",
    "owner2": "",
    "current_taxes": 19646.73,
    "new_taxes_no_override": 20495.47,
    "override_total_1": 21077.01,
    "override_increase_1": 581.54
  },
  {
    "#": "60 Willow Cres (264B-23-00)",
    "$": 3186400,
    "address": "60 Willow Cres",
    "parcel_id": "264B-23-00",
    "owner1": "SHORE JR, MARTIN H",
    "owner2": "LISANN, SHARI",
    "current_taxes": 28993.8,
    "new_taxes_no_override": 30246.33,
    "override_total_1": 31104.55,
    "override_increase_1": 858.22
  },
  {
    "#": "1 Winchester St (083-14-15)",
    "$": 10784000,
    "address": "1 Winchester St",
    "parcel_id": "083-14-15",
    "owner1": "BOSTON INVESTMENT PROPERTY #1/5 WINCHESTER",
    "owner2": "",
    "current_taxes": 110428.16,
    "new_taxes_no_override": 115198.66,
    "override_total_1": 118467.33,
    "override_increase_1": 3268.67
  },
  {
    "#": "14 Winchester St (084-40-00)",
    "$": 1789600,
    "address": "14 Winchester St",
    "parcel_id": "084-40-00",
    "owner1": "SHANNON, ANDREW M",
    "owner2": "",
    "current_taxes": 14690.57,
    "new_taxes_no_override": 15325.2,
    "override_total_1": 15760.04,
    "override_increase_1": 434.84
  },
  {
    "#": "16 Winchester St (084-39-01)",
    "$": 2943400,
    "address": "16 Winchester St",
    "parcel_id": "084-39-01",
    "owner1": "YEE TRS, RICHARD N & WAI HING",
    "owner2": "",
    "current_taxes": 26505.48,
    "new_taxes_no_override": 27650.52,
    "override_total_1": 28435.08,
    "override_increase_1": 784.56
  },
  {
    "#": "19 Winchester St, Unit 102 & G25 (083-16-98)",
    "$": 552700,
    "address": "19 Winchester St, Unit 102 & G25",
    "parcel_id": "083-16-98",
    "owner1": "NOCA REALTY LLC",
    "owner2": "",
    "current_taxes": 5659.65,
    "new_taxes_no_override": 5904.15,
    "override_total_1": 6071.67,
    "override_increase_1": 167.53
  },
  {
    "#": "19 Winchester St, Unit 103 & G39 (083-16-01)",
    "$": 624300,
    "address": "19 Winchester St, Unit 103 & G39",
    "parcel_id": "083-16-01",
    "owner1": "LIPETSKER, BORIS & GALINA & ALEKSANDR",
    "owner2": "",
    "current_taxes": 2757.9,
    "new_taxes_no_override": 2877.04,
    "override_total_1": 2958.68,
    "override_increase_1": 81.63
  },
  {
    "#": "19 Winchester St, Unit 104 & G15 (083-16-02)",
    "$": 652400,
    "address": "19 Winchester St, Unit 104 & G15",
    "parcel_id": "083-16-02",
    "owner1": "CHIU, GORDON",
    "owner2": "CHEUNG, MEGAN",
    "current_taxes": 6680.58,
    "new_taxes_no_override": 6969.18,
    "override_total_1": 7166.93,
    "override_increase_1": 197.75
  },
  {
    "#": "19 Winchester St, Unit 105 & G50 (083-16-03)",
    "$": 624300,
    "address": "19 Winchester St, Unit 105 & G50",
    "parcel_id": "083-16-03",
    "owner1": "EDELMAN, DAVID & CAROL",
    "owner2": "",
    "current_taxes": 6392.83,
    "new_taxes_no_override": 6669.0,
    "override_total_1": 6858.23,
    "override_increase_1": 189.23
  },
  {
    "#": "19 Winchester St, Unit 107 & G2 (083-16-04)",
    "$": 550800,
    "address": "19 Winchester St, Unit 107 & G2",
    "parcel_id": "083-16-04",
    "owner1": "SAXE, GABRIEL WESCOTT",
    "owner2": "",
    "current_taxes": 2005.26,
    "new_taxes_no_override": 2091.89,
    "override_total_1": 2151.24,
    "override_increase_1": 59.36
  },
  {
    "#": "19 Winchester St, Unit 108 & G45 (083-16-05)",
    "$": 620100,
    "address": "19 Winchester St, Unit 108 & G45",
    "parcel_id": "083-16-05",
    "owner1": "BLEICHMAN, MARGARET",
    "owner2": "CRAIG, CHARLOTTE",
    "current_taxes": 6349.82,
    "new_taxes_no_override": 6624.13,
    "override_total_1": 6812.09,
    "override_increase_1": 187.95
  },
  {
    "#": "19 Winchester St, Unit 110 (083-16-06)",
    "$": 411700,
    "address": "19 Winchester St, Unit 110",
    "parcel_id": "083-16-06",
    "owner1": "MURPHY EDBERG, CAROL E",
    "owner2": "",
    "current_taxes": 4215.81,
    "new_taxes_no_override": 4397.93,
    "override_total_1": 4522.72,
    "override_increase_1": 124.79
  },
  {
    "#": "19 Winchester St, Unit 201 & P80 (083-16-07)",
    "$": 583300,
    "address": "19 Winchester St, Unit 201 & P80",
    "parcel_id": "083-16-07",
    "owner1": "DUNN, ERIN",
    "owner2": "",
    "current_taxes": 5972.99,
    "new_taxes_no_override": 6231.02,
    "override_total_1": 6407.82,
    "override_increase_1": 176.8
  },
  {
    "#": "19 Winchester St, Unit 202 & G22 (083-16-08)",
    "$": 565400,
    "address": "19 Winchester St, Unit 202 & G22",
    "parcel_id": "083-16-08",
    "owner1": "HOWARDS, SUSAN K BINEN",
    "owner2": "",
    "current_taxes": 2154.76,
    "new_taxes_no_override": 2247.85,
    "override_total_1": 2311.63,
    "override_increase_1": 63.78
  },
  {
    "#": "19 Winchester St, Unit 203 (083-16-09)",
    "$": 495600,
    "address": "19 Winchester St, Unit 203",
    "parcel_id": "083-16-09",
    "owner1": "NG TR, THERESA",
    "owner2": "",
    "current_taxes": 5074.94,
    "new_taxes_no_override": 5294.18,
    "override_total_1": 5444.4,
    "override_increase_1": 150.22
  },
  {
    "#": "19 Winchester St, Unit 204 & P101 (083-16-10)",
    "$": 505800,
    "address": "19 Winchester St, Unit 204 & P101",
    "parcel_id": "083-16-10",
    "owner1": "MCAULIFFE TRS, LISA A",
    "owner2": "VARA TR, HOLLI P",
    "current_taxes": 1544.46,
    "new_taxes_no_override": 1611.18,
    "override_total_1": 1656.9,
    "override_increase_1": 45.72
  },
  {
    "#": "19 Winchester St, Unit 205 & P71 (083-16-11)",
    "$": 540300,
    "address": "19 Winchester St, Unit 205 & P71",
    "parcel_id": "083-16-11",
    "owner1": "FIENMAN, BARBARA M",
    "owner2": "",
    "current_taxes": 1897.74,
    "new_taxes_no_override": 1979.72,
    "override_total_1": 2035.9,
    "override_increase_1": 56.17
  },
  {
    "#": "19 Winchester St, Unit 206 & P13 (083-16-12)",
    "$": 569500,
    "address": "19 Winchester St, Unit 206 & P13",
    "parcel_id": "083-16-12",
    "owner1": "WONG, LENA M",
    "owner2": "",
    "current_taxes": 2196.75,
    "new_taxes_no_override": 2291.65,
    "override_total_1": 2356.67,
    "override_increase_1": 65.02
  },
  {
    "#": "19 Winchester St, Unit 207 & P74 (083-16-13)",
    "$": 553500,
    "address": "19 Winchester St, Unit 207 & P74",
    "parcel_id": "083-16-13",
    "owner1": "RABINOVICH TRS, DANIEL & DAPHNA",
    "owner2": "",
    "current_taxes": 5667.84,
    "new_taxes_no_override": 5912.69,
    "override_total_1": 6080.46,
    "override_increase_1": 167.77
  },
  {
    "#": "19 Winchester St, Unit 208 & P46 (083-16-14)",
    "$": 513600,
    "address": "19 Winchester St, Unit 208 & P46",
    "parcel_id": "083-16-14",
    "owner1": "NOVACK, BRANDON S",
    "owner2": "",
    "current_taxes": 1624.33,
    "new_taxes_no_override": 1694.5,
    "override_total_1": 1742.58,
    "override_increase_1": 48.08
  },
  {
    "#": "19 Winchester St, Unit 209 (083-16-15)",
    "$": 470100,
    "address": "19 Winchester St, Unit 209",
    "parcel_id": "083-16-15",
    "owner1": "ZAKON, LYNNE C",
    "owner2": "",
    "current_taxes": 1178.89,
    "new_taxes_no_override": 1229.82,
    "override_total_1": 1264.71,
    "override_increase_1": 34.9
  },
  {
    "#": "19 Winchester St, Unit 210 & G33 (083-16-16)",
    "$": 516900,
    "address": "19 Winchester St, Unit 210 & G33",
    "parcel_id": "083-16-16",
    "owner1": "ASHKENAZI , HANNAH GONCALVES & YITSHAK",
    "owner2": "GONCALVES, MANUELA",
    "current_taxes": 5293.06,
    "new_taxes_no_override": 5521.72,
    "override_total_1": 5678.39,
    "override_increase_1": 156.67
  },
  {
    "#": "19 Winchester St, Unit 211 & G26 (083-16-17)",
    "$": 595400,
    "address": "19 Winchester St, Unit 211 & G26",
    "parcel_id": "083-16-17",
    "owner1": "STERETT, MARJORIE C",
    "owner2": "",
    "current_taxes": 2461.96,
    "new_taxes_no_override": 2568.32,
    "override_total_1": 2641.19,
    "override_increase_1": 72.87
  },
  {
    "#": "19 Winchester St, Unit 212 & G43 (083-16-18)",
    "$": 565400,
    "address": "19 Winchester St, Unit 212 & G43",
    "parcel_id": "083-16-18",
    "owner1": "KIM, SANDRA M",
    "owner2": "",
    "current_taxes": 2154.76,
    "new_taxes_no_override": 2247.85,
    "override_total_1": 2311.63,
    "override_increase_1": 63.78
  },
  {
    "#": "19 Winchester St, Unit 301 & P70 (083-16-19)",
    "$": 541000,
    "address": "19 Winchester St, Unit 301 & P70",
    "parcel_id": "083-16-19",
    "owner1": "GAYNES, LISA R",
    "owner2": "",
    "current_taxes": 5539.84,
    "new_taxes_no_override": 5779.16,
    "override_total_1": 5943.14,
    "override_increase_1": 163.98
  },
  {
    "#": "19 Winchester St, Unit 302 & G51 (083-16-20)",
    "$": 584800,
    "address": "19 Winchester St, Unit 302 & G51",
    "parcel_id": "083-16-20",
    "owner1": "SHAPIRO, NATHAN",
    "owner2": "",
    "current_taxes": 5988.35,
    "new_taxes_no_override": 6247.05,
    "override_total_1": 6424.3,
    "override_increase_1": 177.26
  },
  {
    "#": "19 Winchester St, Unit 303 & P66 (083-16-21)",
    "$": 552000,
    "address": "19 Winchester St, Unit 303 & P66",
    "parcel_id": "083-16-21",
    "owner1": "LIMA, JULIAN H",
    "owner2": "",
    "current_taxes": 2017.55,
    "new_taxes_no_override": 2104.71,
    "override_total_1": 2164.43,
    "override_increase_1": 59.72
  },
  {
    "#": "19 Winchester St, Unit 304 & P76 (083-16-22)",
    "$": 552000,
    "address": "19 Winchester St, Unit 304 & P76",
    "parcel_id": "083-16-22",
    "owner1": "SPUNGIN, CYNTHIA",
    "owner2": "",
    "current_taxes": 5652.48,
    "new_taxes_no_override": 5896.67,
    "override_total_1": 6063.98,
    "override_increase_1": 167.31
  },
  {
    "#": "19 Winchester St, Unit 305 & G21 (083-16-23)",
    "$": 594700,
    "address": "19 Winchester St, Unit 305 & G21",
    "parcel_id": "083-16-23",
    "owner1": "SADSAD, NANCY",
    "owner2": "",
    "current_taxes": 6089.73,
    "new_taxes_no_override": 6352.81,
    "override_total_1": 6533.06,
    "override_increase_1": 180.26
  },
  {
    "#": "19 Winchester St, Unit 306 & G6 (083-16-24)",
    "$": 557900,
    "address": "19 Winchester St, Unit 306 & G6",
    "parcel_id": "083-16-24",
    "owner1": "BERNSTEIN, IRIS S & STEVEN E",
    "owner2": "",
    "current_taxes": 2077.96,
    "new_taxes_no_override": 2167.73,
    "override_total_1": 2229.24,
    "override_increase_1": 61.51
  },
  {
    "#": "19 Winchester St, Unit 307 & P65 (083-16-25)",
    "$": 560100,
    "address": "19 Winchester St, Unit 307 & P65",
    "parcel_id": "083-16-25",
    "owner1": "NATH TRS, PRAN & SHASHI",
    "owner2": "",
    "current_taxes": 5735.42,
    "new_taxes_no_override": 5983.19,
    "override_total_1": 6152.96,
    "override_increase_1": 169.77
  },
  {
    "#": "19 Winchester St, Unit 308 (083-16-26)",
    "$": 424300,
    "address": "19 Winchester St, Unit 308",
    "parcel_id": "083-16-26",
    "owner1": "CALABRESE, ANDREA",
    "owner2": "",
    "current_taxes": 709.9,
    "new_taxes_no_override": 740.57,
    "override_total_1": 761.58,
    "override_increase_1": 21.01
  },
  {
    "#": "19 Winchester St, Unit 309 & G24 (083-16-27)",
    "$": 608200,
    "address": "19 Winchester St, Unit 309 & G24",
    "parcel_id": "083-16-27",
    "owner1": "RAHMA, OSAMA",
    "owner2": "YAZIGI, SHASA",
    "current_taxes": 6227.97,
    "new_taxes_no_override": 6497.02,
    "override_total_1": 6681.37,
    "override_increase_1": 184.35
  },
  {
    "#": "19 Winchester St, Unit 310 & G6A (083-16-28)",
    "$": 576300,
    "address": "19 Winchester St, Unit 310 & G6A",
    "parcel_id": "083-16-28",
    "owner1": "CHEN, MAN",
    "owner2": "",
    "current_taxes": 5901.31,
    "new_taxes_no_override": 6156.25,
    "override_total_1": 6330.93,
    "override_increase_1": 174.68
  },
  {
    "#": "19 Winchester St, Unit 311 & P61 (083-16-29)",
    "$": 589500,
    "address": "19 Winchester St, Unit 311 & P61",
    "parcel_id": "083-16-29",
    "owner1": "LAHAV , PNINA TR & ALEXANDRA",
    "owner2": "",
    "current_taxes": 6036.48,
    "new_taxes_no_override": 6297.26,
    "override_total_1": 6475.94,
    "override_increase_1": 178.68
  },
  {
    "#": "19 Winchester St, Unit 312 & P57 (083-16-30)",
    "$": 559500,
    "address": "19 Winchester St, Unit 312 & P57",
    "parcel_id": "083-16-30",
    "owner1": "XIA, YU",
    "owner2": "",
    "current_taxes": 5729.28,
    "new_taxes_no_override": 5976.78,
    "override_total_1": 6146.37,
    "override_increase_1": 169.59
  },
  {
    "#": "19 Winchester St, Unit 401 & P63 (083-16-31)",
    "$": 589500,
    "address": "19 Winchester St, Unit 401 & P63",
    "parcel_id": "083-16-31",
    "owner1": "EDELMAN, DAVID & CAROL",
    "owner2": "",
    "current_taxes": 6036.48,
    "new_taxes_no_override": 6297.26,
    "override_total_1": 6475.94,
    "override_increase_1": 178.68
  },
  {
    "#": "19 Winchester St, Unit 402 & G54 (083-16-32)",
    "$": 613900,
    "address": "19 Winchester St, Unit 402 & G54",
    "parcel_id": "083-16-32",
    "owner1": "LEE, BERTHA",
    "owner2": "",
    "current_taxes": 2651.4,
    "new_taxes_no_override": 2765.94,
    "override_total_1": 2844.42,
    "override_increase_1": 78.48
  },
  {
    "#": "19 Winchester St, Unit 403 & G47 (083-16-33)",
    "$": 623800,
    "address": "19 Winchester St, Unit 403 & G47",
    "parcel_id": "083-16-33",
    "owner1": "CAI, ZHENYING",
    "owner2": "LI, JIAMING",
    "current_taxes": 2752.78,
    "new_taxes_no_override": 2871.7,
    "override_total_1": 2953.18,
    "override_increase_1": 81.48
  },
  {
    "#": "19 Winchester St, Unit 404 & G49 (083-16-34)",
    "$": 623800,
    "address": "19 Winchester St, Unit 404 & G49",
    "parcel_id": "083-16-34",
    "owner1": "BAUMGARTEN, AMY D",
    "owner2": "",
    "current_taxes": 2752.78,
    "new_taxes_no_override": 2871.7,
    "override_total_1": 2953.18,
    "override_increase_1": 81.48
  },
  {
    "#": "19 Winchester St, Unit 405 & G28 (083-16-35)",
    "$": 606300,
    "address": "19 Winchester St, Unit 405 & G28",
    "parcel_id": "083-16-35",
    "owner1": "PURDY, ARIANE LEIGH",
    "owner2": "",
    "current_taxes": 6208.51,
    "new_taxes_no_override": 6476.72,
    "override_total_1": 6660.49,
    "override_increase_1": 183.77
  },
  {
    "#": "19 Winchester St, Unit 406 & P79 (083-16-36)",
    "$": 522900,
    "address": "19 Winchester St, Unit 406 & P79",
    "parcel_id": "083-16-36",
    "owner1": "BOGDANOV, BRANKA",
    "owner2": "",
    "current_taxes": 5354.5,
    "new_taxes_no_override": 5585.81,
    "override_total_1": 5744.31,
    "override_increase_1": 158.49
  },
  {
    "#": "19 Winchester St, Unit 407 & P72 (083-16-37)",
    "$": 588800,
    "address": "19 Winchester St, Unit 407 & P72",
    "parcel_id": "083-16-37",
    "owner1": "AUERBACH  ET AL TRS, JUDITH",
    "owner2": "C/O SEAWARD MGMT, ATTN F SCHULTZ",
    "current_taxes": 6029.31,
    "new_taxes_no_override": 6289.78,
    "override_total_1": 6468.24,
    "override_increase_1": 178.47
  },
  {
    "#": "19 Winchester St, Unit 408 & G1 (083-16-38)",
    "$": 522300,
    "address": "19 Winchester St, Unit 408 & G1",
    "parcel_id": "083-16-38",
    "owner1": "GOLDSTEIN, DAVID",
    "owner2": "",
    "current_taxes": 5348.35,
    "new_taxes_no_override": 5579.4,
    "override_total_1": 5737.71,
    "override_increase_1": 158.31
  },
  {
    "#": "19 Winchester St, Unit 409 & G32 (083-16-39)",
    "$": 594700,
    "address": "19 Winchester St, Unit 409 & G32",
    "parcel_id": "083-16-39",
    "owner1": "HU, CUIE",
    "owner2": "MAO, MELODY",
    "current_taxes": 6089.73,
    "new_taxes_no_override": 6352.81,
    "override_total_1": 6533.06,
    "override_increase_1": 180.26
  },
  {
    "#": "19 Winchester St, Unit 410 & P64 (083-16-40)",
    "$": 553000,
    "address": "19 Winchester St, Unit 410 & P64",
    "parcel_id": "083-16-40",
    "owner1": "GRIMES TR, CAROLYN Y",
    "owner2": "",
    "current_taxes": 5662.72,
    "new_taxes_no_override": 5907.35,
    "override_total_1": 6074.97,
    "override_increase_1": 167.62
  },
  {
    "#": "19 Winchester St, Unit 411 & G3 (083-16-41)",
    "$": 608900,
    "address": "19 Winchester St, Unit 411 & G3",
    "parcel_id": "083-16-41",
    "owner1": "NOBLE, MICHAEL SCOTT",
    "owner2": "PECHORIN, VALERIA  V",
    "current_taxes": 6235.14,
    "new_taxes_no_override": 6504.5,
    "override_total_1": 6689.06,
    "override_increase_1": 184.56
  },
  {
    "#": "19 Winchester St, Unit 412 & G11 (083-16-42)",
    "$": 584800,
    "address": "19 Winchester St, Unit 412 & G11",
    "parcel_id": "083-16-42",
    "owner1": "SOLOMON, MARK B",
    "owner2": "",
    "current_taxes": 2353.42,
    "new_taxes_no_override": 2455.09,
    "override_total_1": 2524.75,
    "override_increase_1": 69.66
  },
  {
    "#": "19 Winchester St, Unit 501 & G29 (083-16-43)",
    "$": 595400,
    "address": "19 Winchester St, Unit 501 & G29",
    "parcel_id": "083-16-43",
    "owner1": "HOYT, EDWARD W",
    "owner2": "CONNOLLY, MAUREEN A",
    "current_taxes": 6096.9,
    "new_taxes_no_override": 6360.29,
    "override_total_1": 6540.75,
    "override_increase_1": 180.47
  },
  {
    "#": "19 Winchester St, Unit 502 & G27 (083-16-44)",
    "$": 590200,
    "address": "19 Winchester St, Unit 502 & G27",
    "parcel_id": "083-16-44",
    "owner1": "TALLARICO, AIMEE & MADELINE",
    "owner2": "",
    "current_taxes": 2408.71,
    "new_taxes_no_override": 2512.77,
    "override_total_1": 2584.06,
    "override_increase_1": 71.3
  },
  {
    "#": "19 Winchester St, Unit 503 & G41 (083-16-45)",
    "$": 594700,
    "address": "19 Winchester St, Unit 503 & G41",
    "parcel_id": "083-16-45",
    "owner1": "WATERS TR, BARRY G",
    "owner2": "",
    "current_taxes": 2454.79,
    "new_taxes_no_override": 2560.84,
    "override_total_1": 2633.5,
    "override_increase_1": 72.66
  },
  {
    "#": "19 Winchester St, Unit 504 & P59 (083-16-46)",
    "$": 571400,
    "address": "19 Winchester St, Unit 504 & P59",
    "parcel_id": "083-16-46",
    "owner1": "ZARE, SABA",
    "owner2": "",
    "current_taxes": 5851.14,
    "new_taxes_no_override": 6103.91,
    "override_total_1": 6277.1,
    "override_increase_1": 173.19
  },
  {
    "#": "19 Winchester St, Unit 505 & G30 (083-16-47)",
    "$": 606300,
    "address": "19 Winchester St, Unit 505 & G30",
    "parcel_id": "083-16-47",
    "owner1": "SHER, JUDITH E",
    "owner2": "",
    "current_taxes": 2573.58,
    "new_taxes_no_override": 2684.76,
    "override_total_1": 2760.94,
    "override_increase_1": 76.18
  },
  {
    "#": "19 Winchester St, Unit 506 & G14 (083-16-48)",
    "$": 557900,
    "address": "19 Winchester St, Unit 506 & G14",
    "parcel_id": "083-16-48",
    "owner1": "DAVIDSON, LEONARD M & LAURIE",
    "owner2": "",
    "current_taxes": 5712.9,
    "new_taxes_no_override": 5959.7,
    "override_total_1": 6128.8,
    "override_increase_1": 169.1
  },
  {
    "#": "19 Winchester St, Unit 507 & G52 (083-16-49)",
    "$": 608200,
    "address": "19 Winchester St, Unit 507 & G52",
    "parcel_id": "083-16-49",
    "owner1": "BAINES, SALLY",
    "owner2": "",
    "current_taxes": 2593.03,
    "new_taxes_no_override": 2705.05,
    "override_total_1": 2781.8,
    "override_increase_1": 76.75
  },
  {
    "#": "19 Winchester St, Unit 508 & P75 (083-16-50)",
    "$": 484500,
    "address": "19 Winchester St, Unit 508 & P75",
    "parcel_id": "083-16-50",
    "owner1": "LAKOV, GERMAN & ALLA",
    "owner2": "",
    "current_taxes": 4961.28,
    "new_taxes_no_override": 5175.61,
    "override_total_1": 5322.46,
    "override_increase_1": 146.85
  },
  {
    "#": "19 Winchester St, Unit 509 & P94 (083-16-51)",
    "$": 559700,
    "address": "19 Winchester St, Unit 509 & P94",
    "parcel_id": "083-16-51",
    "owner1": "HAAS, MARY W",
    "owner2": "",
    "current_taxes": 2096.39,
    "new_taxes_no_override": 2186.95,
    "override_total_1": 2249.01,
    "override_increase_1": 62.05
  },
  {
    "#": "19 Winchester St, Unit 510 & P92 (083-16-52)",
    "$": 570400,
    "address": "19 Winchester St, Unit 510 & P92",
    "parcel_id": "083-16-52",
    "owner1": "JAFARNEJAD, AYDIN",
    "owner2": "",
    "current_taxes": 5840.9,
    "new_taxes_no_override": 6093.23,
    "override_total_1": 6266.12,
    "override_increase_1": 172.89
  },
  {
    "#": "19 Winchester St, Unit 511 & G19 (083-16-53)",
    "$": 595400,
    "address": "19 Winchester St, Unit 511 & G19",
    "parcel_id": "083-16-53",
    "owner1": "GOON, SUZANNE",
    "owner2": "",
    "current_taxes": 2461.96,
    "new_taxes_no_override": 2568.32,
    "override_total_1": 2641.19,
    "override_increase_1": 72.87
  },
  {
    "#": "19 Winchester St, Unit 512 & G42 (083-16-54)",
    "$": 519600,
    "address": "19 Winchester St, Unit 512 & G42",
    "parcel_id": "083-16-54",
    "owner1": "AOL REALTY LLC",
    "owner2": "",
    "current_taxes": 5320.7,
    "new_taxes_no_override": 5550.55,
    "override_total_1": 5708.05,
    "override_increase_1": 157.49
  },
  {
    "#": "19 Winchester St, Unit 601 & G12 (083-16-55)",
    "$": 624500,
    "address": "19 Winchester St, Unit 601 & G12",
    "parcel_id": "083-16-55",
    "owner1": "GROSSMAN TRS, STEPHEN H & SUSAN C",
    "owner2": "",
    "current_taxes": 6394.88,
    "new_taxes_no_override": 6671.14,
    "override_total_1": 6860.43,
    "override_increase_1": 189.29
  },
  {
    "#": "19 Winchester St, Unit 602 & P62 (083-16-56)",
    "$": 578900,
    "address": "19 Winchester St, Unit 602 & P62",
    "parcel_id": "083-16-56",
    "owner1": "MUKHERJEE, KIRITI",
    "owner2": "CHAKROVORTY, SRABANA",
    "current_taxes": 5927.94,
    "new_taxes_no_override": 6184.03,
    "override_total_1": 6359.49,
    "override_increase_1": 175.47
  },
  {
    "#": "19 Winchester St, Unit 603 & P98 (083-16-57)",
    "$": 559700,
    "address": "19 Winchester St, Unit 603 & P98",
    "parcel_id": "083-16-57",
    "owner1": "NASKHLETASHVILI, SHALVA",
    "owner2": "",
    "current_taxes": 2096.39,
    "new_taxes_no_override": 2186.95,
    "override_total_1": 2249.01,
    "override_increase_1": 62.05
  },
  {
    "#": "19 Winchester St, Unit 604 & P103 (083-16-58)",
    "$": 620600,
    "address": "19 Winchester St, Unit 604 & P103",
    "parcel_id": "083-16-58",
    "owner1": "CHENG, LIYANG S",
    "owner2": "",
    "current_taxes": 6354.94,
    "new_taxes_no_override": 6629.47,
    "override_total_1": 6817.58,
    "override_increase_1": 188.11
  },
  {
    "#": "19 Winchester St, Unit 605 & G10 (083-16-59)",
    "$": 594700,
    "address": "19 Winchester St, Unit 605 & G10",
    "parcel_id": "083-16-59",
    "owner1": "NOVINSKY, ELLEN",
    "owner2": "",
    "current_taxes": 2454.79,
    "new_taxes_no_override": 2560.84,
    "override_total_1": 2633.5,
    "override_increase_1": 72.66
  },
  {
    "#": "19 Winchester St, Unit 606 & G23 (083-16-60)",
    "$": 609700,
    "address": "19 Winchester St, Unit 606 & G23",
    "parcel_id": "083-16-60",
    "owner1": "JACOBS TRS, DEBORAH MANN & JOSHUA M",
    "owner2": "",
    "current_taxes": 6243.33,
    "new_taxes_no_override": 6513.04,
    "override_total_1": 6697.84,
    "override_increase_1": 184.8
  },
  {
    "#": "19 Winchester St, Unit 607 &P58 (083-16-61)",
    "$": 588800,
    "address": "19 Winchester St, Unit 607 &P58",
    "parcel_id": "083-16-61",
    "owner1": "BALASHOV, KONSTANTIN",
    "owner2": "",
    "current_taxes": 2394.38,
    "new_taxes_no_override": 2497.82,
    "override_total_1": 2568.69,
    "override_increase_1": 70.87
  },
  {
    "#": "19 Winchester St, Unit 608 & P102 (083-16-62)",
    "$": 514400,
    "address": "19 Winchester St, Unit 608 & P102",
    "parcel_id": "083-16-62",
    "owner1": "LIU, LISHA",
    "owner2": "",
    "current_taxes": 5267.46,
    "new_taxes_no_override": 5495.01,
    "override_total_1": 5650.93,
    "override_increase_1": 155.92
  },
  {
    "#": "19 Winchester St, Unit 609 & G31 (083-16-63)",
    "$": 617100,
    "address": "19 Winchester St, Unit 609 & G31",
    "parcel_id": "083-16-63",
    "owner1": "FIELDMAN, JANICE M",
    "owner2": "",
    "current_taxes": 2684.17,
    "new_taxes_no_override": 2800.13,
    "override_total_1": 2879.58,
    "override_increase_1": 79.45
  },
  {
    "#": "19 Winchester St, Unit 610 & G48 (083-16-64)",
    "$": 576300,
    "address": "19 Winchester St, Unit 610 & G48",
    "parcel_id": "083-16-64",
    "owner1": "KING TRS, CHAO-MIN & LO-SU",
    "owner2": "",
    "current_taxes": 5901.31,
    "new_taxes_no_override": 6156.25,
    "override_total_1": 6330.93,
    "override_increase_1": 174.68
  },
  {
    "#": "19 Winchester St, Unit 611 & P105 (083-16-65)",
    "$": 560400,
    "address": "19 Winchester St, Unit 611 & P105",
    "parcel_id": "083-16-65",
    "owner1": "GERSHON-STERN ET AL, FORTUNEE",
    "owner2": "SCHNEIDER , ROSE G",
    "current_taxes": 5738.5,
    "new_taxes_no_override": 5986.4,
    "override_total_1": 6156.26,
    "override_increase_1": 169.86
  },
  {
    "#": "19 Winchester St, Unit 612 & G38 (083-16-66)",
    "$": 584800,
    "address": "19 Winchester St, Unit 612 & G38",
    "parcel_id": "083-16-66",
    "owner1": "BOGDANOV, BRANKA",
    "owner2": "",
    "current_taxes": 5988.35,
    "new_taxes_no_override": 6247.05,
    "override_total_1": 6424.3,
    "override_increase_1": 177.26
  },
  {
    "#": "19 Winchester St, Unit 701 & G37 (083-16-67)",
    "$": 644500,
    "address": "19 Winchester St, Unit 701 & G37",
    "parcel_id": "083-16-67",
    "owner1": "GAO, YUAN ZHAO",
    "owner2": "",
    "current_taxes": 6599.68,
    "new_taxes_no_override": 6884.79,
    "override_total_1": 7080.14,
    "override_increase_1": 195.35
  },
  {
    "#": "19 Winchester St, Unit 702 & G18 (083-16-68)",
    "$": 602200,
    "address": "19 Winchester St, Unit 702 & G18",
    "parcel_id": "083-16-68",
    "owner1": "CHIU, PATRICIA",
    "owner2": "LIAW, WILLIAM",
    "current_taxes": 6166.53,
    "new_taxes_no_override": 6432.92,
    "override_total_1": 6615.45,
    "override_increase_1": 182.53
  },
  {
    "#": "19 Winchester St, Unit 703 & P90 (083-16-69)",
    "$": 618500,
    "address": "19 Winchester St, Unit 703 & P90",
    "parcel_id": "083-16-69",
    "owner1": "PEECHER, SUSAN E",
    "owner2": "",
    "current_taxes": 2698.51,
    "new_taxes_no_override": 2815.09,
    "override_total_1": 2894.96,
    "override_increase_1": 79.88
  },
  {
    "#": "19 Winchester St, Unit 704 & P77 (083-16-70)",
    "$": 620600,
    "address": "19 Winchester St, Unit 704 & P77",
    "parcel_id": "083-16-70",
    "owner1": "CHERNENKO, TATIANA",
    "owner2": "BREKHMAN, ARKADIY",
    "current_taxes": 2720.01,
    "new_taxes_no_override": 2837.51,
    "override_total_1": 2918.03,
    "override_increase_1": 80.51
  },
  {
    "#": "19 Winchester St, Unit 705 & P106 (083-16-71)",
    "$": 588800,
    "address": "19 Winchester St, Unit 705 & P106",
    "parcel_id": "083-16-71",
    "owner1": "FERESTIEN, ANDREW",
    "owner2": "",
    "current_taxes": 2394.38,
    "new_taxes_no_override": 2497.82,
    "override_total_1": 2568.69,
    "override_increase_1": 70.87
  },
  {
    "#": "19 Winchester St, Unit 706 & P68 (083-16-72)",
    "$": 545100,
    "address": "19 Winchester St, Unit 706 & P68",
    "parcel_id": "083-16-72",
    "owner1": "WU, CAROLINE & ALAN L",
    "owner2": "",
    "current_taxes": 5581.82,
    "new_taxes_no_override": 5822.95,
    "override_total_1": 5988.18,
    "override_increase_1": 165.22
  },
  {
    "#": "19 Winchester St, Unit 707 & G53 (083-16-73)",
    "$": 594700,
    "address": "19 Winchester St, Unit 707 & G53",
    "parcel_id": "083-16-73",
    "owner1": "LEVIN, TR, ERIC",
    "owner2": "C/O K SHULMAN -DAY PITNEY LLC",
    "current_taxes": 6089.73,
    "new_taxes_no_override": 6352.81,
    "override_total_1": 6533.06,
    "override_increase_1": 180.26
  },
  {
    "#": "19 Winchester St, Unit 708 & P93 (083-16-74)",
    "$": 537000,
    "address": "19 Winchester St, Unit 708 & P93",
    "parcel_id": "083-16-74",
    "owner1": "MARK, GEORGE E&JUDITH GOLDSTEIN",
    "owner2": "",
    "current_taxes": 5498.88,
    "new_taxes_no_override": 5736.43,
    "override_total_1": 5899.2,
    "override_increase_1": 162.77
  },
  {
    "#": "19 Winchester St, Unit 709 & P91 (083-16-75)",
    "$": 600700,
    "address": "19 Winchester St, Unit 709 & P91",
    "parcel_id": "083-16-75",
    "owner1": "BROWNBAUM REAL ESTATE, INVESTMENT LLC",
    "owner2": "",
    "current_taxes": 6151.17,
    "new_taxes_no_override": 6416.9,
    "override_total_1": 6598.98,
    "override_increase_1": 182.07
  },
  {
    "#": "19 Winchester St, Unit 710 & P100 (083-16-76)",
    "$": 541300,
    "address": "19 Winchester St, Unit 710 & P100",
    "parcel_id": "083-16-76",
    "owner1": "MAKEDON, FILLIA",
    "owner2": "",
    "current_taxes": 5542.91,
    "new_taxes_no_override": 5782.36,
    "override_total_1": 5946.43,
    "override_increase_1": 164.07
  },
  {
    "#": "19 Winchester St, Unit 711 & G20 (083-16-77)",
    "$": 624500,
    "address": "19 Winchester St, Unit 711 & G20",
    "parcel_id": "083-16-77",
    "owner1": "GREENSTEIN, DANIEL",
    "owner2": "",
    "current_taxes": 6394.88,
    "new_taxes_no_override": 6671.14,
    "override_total_1": 6860.43,
    "override_increase_1": 189.29
  },
  {
    "#": "19 Winchester St, Unit 712 & P97 (083-16-78)",
    "$": 609900,
    "address": "19 Winchester St, Unit 712 & P97",
    "parcel_id": "083-16-78",
    "owner1": "EDELMAN, DAVID & CAROL",
    "owner2": "",
    "current_taxes": 6245.38,
    "new_taxes_no_override": 6515.18,
    "override_total_1": 6700.04,
    "override_increase_1": 184.86
  },
  {
    "#": "19 Winchester St, Unit 801 & P107 (083-16-79)",
    "$": 621400,
    "address": "19 Winchester St, Unit 801 & P107",
    "parcel_id": "083-16-79",
    "owner1": "HUANG, YENLING",
    "owner2": "LIAO, YU-TUAN",
    "current_taxes": 6363.14,
    "new_taxes_no_override": 6638.03,
    "override_total_1": 6826.38,
    "override_increase_1": 188.35
  },
  {
    "#": "19 Winchester St, Unit 802 & P89 (083-16-80)",
    "$": 609900,
    "address": "19 Winchester St, Unit 802 & P89",
    "parcel_id": "083-16-80",
    "owner1": "ALLYN, CYNTHIA R",
    "owner2": "",
    "current_taxes": 2610.44,
    "new_taxes_no_override": 2723.21,
    "override_total_1": 2800.48,
    "override_increase_1": 77.27
  },
  {
    "#": "19 Winchester St, Unit 803 & P60 (083-16-81)",
    "$": 584900,
    "address": "19 Winchester St, Unit 803 & P60",
    "parcel_id": "083-16-81",
    "owner1": "GOU, QING",
    "owner2": "",
    "current_taxes": 2354.44,
    "new_taxes_no_override": 2456.15,
    "override_total_1": 2525.84,
    "override_increase_1": 69.69
  },
  {
    "#": "19 Winchester St, Unit 804 & G40 (083-16-82)",
    "$": 643700,
    "address": "19 Winchester St, Unit 804 & G40",
    "parcel_id": "083-16-82",
    "owner1": "DO ESPIRITO SANTO, YOLANDA",
    "owner2": "",
    "current_taxes": 2956.55,
    "new_taxes_no_override": 3084.27,
    "override_total_1": 3171.79,
    "override_increase_1": 87.51
  },
  {
    "#": "19 Winchester St, Unit 805 & G17 (083-16-83)",
    "$": 658400,
    "address": "19 Winchester St, Unit 805 & G17",
    "parcel_id": "083-16-83",
    "owner1": "MARK, GEORGE E & JUDITH GOLDSTEIN",
    "owner2": "",
    "current_taxes": 6742.02,
    "new_taxes_no_override": 7033.28,
    "override_total_1": 7232.84,
    "override_increase_1": 199.56
  },
  {
    "#": "19 Winchester St, Unit 806 & G44 (083-16-84)",
    "$": 635400,
    "address": "19 Winchester St, Unit 806 & G44",
    "parcel_id": "083-16-84",
    "owner1": "CHIU, PATRICIA",
    "owner2": "LIAW, WILLIAM",
    "current_taxes": 6506.5,
    "new_taxes_no_override": 6787.58,
    "override_total_1": 6980.17,
    "override_increase_1": 192.59
  },
  {
    "#": "19 Winchester St, Unit 807 & P73 (083-16-85)",
    "$": 620600,
    "address": "19 Winchester St, Unit 807 & P73",
    "parcel_id": "083-16-85",
    "owner1": "DE SAINT LEGER, BERANGERE",
    "owner2": "",
    "current_taxes": 2720.01,
    "new_taxes_no_override": 2837.51,
    "override_total_1": 2918.03,
    "override_increase_1": 80.51
  },
  {
    "#": "19 Winchester St, Unit 808 & P104 (083-16-86)",
    "$": 537000,
    "address": "19 Winchester St, Unit 808 & P104",
    "parcel_id": "083-16-86",
    "owner1": "POCHAMPALLY, KISHORE K",
    "owner2": "DASGUPTA, SEEMA",
    "current_taxes": 5498.88,
    "new_taxes_no_override": 5736.43,
    "override_total_1": 5899.2,
    "override_increase_1": 162.77
  },
  {
    "#": "19 Winchester St, Unit 809 & P95 (083-16-87)",
    "$": 584900,
    "address": "19 Winchester St, Unit 809 & P95",
    "parcel_id": "083-16-87",
    "owner1": "SIMONELLI, RICHARD A & CYNTHIA A",
    "owner2": "",
    "current_taxes": 5989.38,
    "new_taxes_no_override": 6248.12,
    "override_total_1": 6425.41,
    "override_increase_1": 177.29
  },
  {
    "#": "19 Winchester St, Unit 810 & P69 (083-16-88)",
    "$": 617500,
    "address": "19 Winchester St, Unit 810 & P69",
    "parcel_id": "083-16-88",
    "owner1": "HYDE TRS, BRIAN R & SAMANTHA E",
    "owner2": "",
    "current_taxes": 2688.27,
    "new_taxes_no_override": 2804.4,
    "override_total_1": 2883.98,
    "override_increase_1": 79.57
  },
  {
    "#": "19 Winchester St, Unit 811 & P67 (083-16-89)",
    "$": 585700,
    "address": "19 Winchester St, Unit 811 & P67",
    "parcel_id": "083-16-89",
    "owner1": "FRANCINI, MARZIA",
    "owner2": "",
    "current_taxes": 5997.57,
    "new_taxes_no_override": 6256.67,
    "override_total_1": 6434.19,
    "override_increase_1": 177.53
  },
  {
    "#": "19 Winchester St, Unit 812 & P96 (083-16-90)",
    "$": 609900,
    "address": "19 Winchester St, Unit 812 & P96",
    "parcel_id": "083-16-90",
    "owner1": "SOLOMON, MARK B",
    "owner2": "",
    "current_taxes": 6245.38,
    "new_taxes_no_override": 6515.18,
    "override_total_1": 6700.04,
    "override_increase_1": 184.86
  },
  {
    "#": "19 Winchester St, Unit 901 & G5 (083-16-91)",
    "$": 898800,
    "address": "19 Winchester St, Unit 901 & G5",
    "parcel_id": "083-16-91",
    "owner1": "ROSENTHAL, ELISSA",
    "owner2": "",
    "current_taxes": 5568.78,
    "new_taxes_no_override": 5809.35,
    "override_total_1": 5974.19,
    "override_increase_1": 164.84
  },
  {
    "#": "19 Winchester St, Unit 902 & G16 (083-16-92)",
    "$": 956100,
    "address": "19 Winchester St, Unit 902 & G16",
    "parcel_id": "083-16-92",
    "owner1": "LEE, JEAN-PIERRE & ROSA",
    "owner2": "",
    "current_taxes": 9790.46,
    "new_taxes_no_override": 10213.41,
    "override_total_1": 10503.21,
    "override_increase_1": 289.8
  },
  {
    "#": "19 Winchester St, Unit 903 G34&55 (083-16-93)",
    "$": 987400,
    "address": "19 Winchester St, Unit 903 G34&55",
    "parcel_id": "083-16-93",
    "owner1": "ZHANG, GUOQI",
    "owner2": "CHEN, YUYING",
    "current_taxes": 10110.98,
    "new_taxes_no_override": 10547.77,
    "override_total_1": 10847.06,
    "override_increase_1": 299.29
  },
  {
    "#": "19 Winchester St, Unit 904 & G35 (083-16-94)",
    "$": 575600,
    "address": "19 Winchester St, Unit 904 & G35",
    "parcel_id": "083-16-94",
    "owner1": "SULLIVAN, MARK & GRACE",
    "owner2": "",
    "current_taxes": 2259.21,
    "new_taxes_no_override": 2356.81,
    "override_total_1": 2423.68,
    "override_increase_1": 66.87
  },
  {
    "#": "19 Winchester St, Unit 905 & P99 (083-16-95)",
    "$": 468100,
    "address": "19 Winchester St, Unit 905 & P99",
    "parcel_id": "083-16-95",
    "owner1": "KORTE-NAHABEDIAN, ADRIANNA",
    "owner2": "",
    "current_taxes": 4793.34,
    "new_taxes_no_override": 5000.41,
    "override_total_1": 5142.3,
    "override_increase_1": 141.88
  },
  {
    "#": "19 Winchester St, Unit 906 & G36 (083-16-96)",
    "$": 937100,
    "address": "19 Winchester St, Unit 906 & G36",
    "parcel_id": "083-16-96",
    "owner1": "LEVITT, JEFFREY C & MARILYN G",
    "owner2": "",
    "current_taxes": 5960.97,
    "new_taxes_no_override": 6218.48,
    "override_total_1": 6394.93,
    "override_increase_1": 176.44
  },
  {
    "#": "19 Winchester St, Unit 907 & P78 (083-16-97)",
    "$": 905600,
    "address": "19 Winchester St, Unit 907 & P78",
    "parcel_id": "083-16-97",
    "owner1": "TAN TR, FIONA",
    "owner2": "",
    "current_taxes": 9273.34,
    "new_taxes_no_override": 9673.95,
    "override_total_1": 9948.44,
    "override_increase_1": 274.49
  },
  {
    "#": "19 Winchester St, Unit P81-88 & P108-114 (083-16-99)",
    "$": 787800,
    "address": "19 Winchester St, Unit P81-88 & P108-114",
    "parcel_id": "083-16-99",
    "owner1": "HRT#1 PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 8067.07,
    "new_taxes_no_override": 8415.57,
    "override_total_1": 8654.35,
    "override_increase_1": 238.79
  },
  {
    "#": "20 Winchester St, Unit 1 (084-39-09)",
    "$": 809300,
    "address": "20 Winchester St, Unit 1",
    "parcel_id": "084-39-09",
    "owner1": "BOERMEESTER, BONNIE",
    "owner2": "",
    "current_taxes": 4652.3,
    "new_taxes_no_override": 4853.28,
    "override_total_1": 4990.99,
    "override_increase_1": 137.71
  },
  {
    "#": "20 Winchester St, Unit 2 (084-39-08)",
    "$": 809300,
    "address": "20 Winchester St, Unit 2",
    "parcel_id": "084-39-08",
    "owner1": "CHOW, ET AL, NGOOT P",
    "owner2": "",
    "current_taxes": 4652.3,
    "new_taxes_no_override": 4853.28,
    "override_total_1": 4990.99,
    "override_increase_1": 137.71
  },
  {
    "#": "20 Winchester St, Unit 3 (084-39-02)",
    "$": 894300,
    "address": "20 Winchester St, Unit 3",
    "parcel_id": "084-39-02",
    "owner1": "SUN, YU",
    "owner2": "RANGWALA, AKEEL",
    "current_taxes": 5522.7,
    "new_taxes_no_override": 5761.28,
    "override_total_1": 5924.75,
    "override_increase_1": 163.47
  },
  {
    "#": "20 Winchester St, Unit 4 (084-39-03)",
    "$": 877600,
    "address": "20 Winchester St, Unit 4",
    "parcel_id": "084-39-03",
    "owner1": "BARAN, LUCAS & ALESSANDRA",
    "owner2": "",
    "current_taxes": 8986.62,
    "new_taxes_no_override": 9374.84,
    "override_total_1": 9640.85,
    "override_increase_1": 266.0
  },
  {
    "#": "20 Winchester St, Unit 5 (084-39-04)",
    "$": 900700,
    "address": "20 Winchester St, Unit 5",
    "parcel_id": "084-39-04",
    "owner1": "HAWKINS, DOUGLAS Q & ELIF",
    "owner2": "",
    "current_taxes": 9223.17,
    "new_taxes_no_override": 9621.61,
    "override_total_1": 9894.62,
    "override_increase_1": 273.01
  },
  {
    "#": "20 Winchester St, Unit 6 (084-39-05)",
    "$": 877500,
    "address": "20 Winchester St, Unit 6",
    "parcel_id": "084-39-05",
    "owner1": "ABEZGAUZ, VLADIMIR",
    "owner2": "TSYVINA, YELENA",
    "current_taxes": 5350.67,
    "new_taxes_no_override": 5581.82,
    "override_total_1": 5740.2,
    "override_increase_1": 158.38
  },
  {
    "#": "20 Winchester St, Unit 7 (084-39-06)",
    "$": 874200,
    "address": "20 Winchester St, Unit 7",
    "parcel_id": "084-39-06",
    "owner1": "LING, XI",
    "owner2": "QIN, CHANGMING",
    "current_taxes": 5316.87,
    "new_taxes_no_override": 5546.56,
    "override_total_1": 5703.94,
    "override_increase_1": 157.38
  },
  {
    "#": "20 Winchester St, Unit 8 (084-39-07)",
    "$": 874200,
    "address": "20 Winchester St, Unit 8",
    "parcel_id": "084-39-07",
    "owner1": "AKKAS TR, ARZUM",
    "owner2": "",
    "current_taxes": 8951.81,
    "new_taxes_no_override": 9338.53,
    "override_total_1": 9603.5,
    "override_increase_1": 264.97
  },
  {
    "#": "24 Winchester St, Unit 1 (084-38-03)",
    "$": 1136000,
    "address": "24 Winchester St, Unit 1",
    "parcel_id": "084-38-03",
    "owner1": "HOWARD TRS, PETER JOHN & NOREEN MARY",
    "owner2": "",
    "current_taxes": 7997.71,
    "new_taxes_no_override": 8343.21,
    "override_total_1": 8579.94,
    "override_increase_1": 236.73
  },
  {
    "#": "24 Winchester St, Unit 2 (084-38-01)",
    "$": 1076800,
    "address": "24 Winchester St, Unit 2",
    "parcel_id": "084-38-01",
    "owner1": "PARSONS, PETER W",
    "owner2": "BOZDOGAN, SIBEL",
    "current_taxes": 7391.5,
    "new_taxes_no_override": 7710.81,
    "override_total_1": 7929.6,
    "override_increase_1": 218.79
  },
  {
    "#": "24 Winchester St, Unit 3 (084-38-02)",
    "$": 1077700,
    "address": "24 Winchester St, Unit 3",
    "parcel_id": "084-38-02",
    "owner1": "TOMLIN, PENELOPE M",
    "owner2": "",
    "current_taxes": 7400.71,
    "new_taxes_no_override": 7720.42,
    "override_total_1": 7939.48,
    "override_increase_1": 219.06
  },
  {
    "#": "26 Winchester St (084-41-00)",
    "$": 2130600,
    "address": "26 Winchester St",
    "parcel_id": "084-41-00",
    "owner1": "PENDERY, STEVEN",
    "owner2": "JORGENSEN, ELISABETH A",
    "current_taxes": 18182.41,
    "new_taxes_no_override": 18967.89,
    "override_total_1": 19506.09,
    "override_increase_1": 538.2
  },
  {
    "#": "30 Winchester St (084-37-00)",
    "$": 3921600,
    "address": "30 Winchester St",
    "parcel_id": "084-37-00",
    "owner1": "GREEN-BARTON TR, ALISON",
    "owner2": "",
    "current_taxes": 40157.18,
    "new_taxes_no_override": 41891.97,
    "override_total_1": 43080.62,
    "override_increase_1": 1188.65
  },
  {
    "#": "32 Winchester St, Unit 1 (084-36-01)",
    "$": 540000,
    "address": "32 Winchester St, Unit 1",
    "parcel_id": "084-36-01",
    "owner1": "MICONDO REALTY LLC",
    "owner2": "",
    "current_taxes": 5529.6,
    "new_taxes_no_override": 5768.48,
    "override_total_1": 5932.15,
    "override_increase_1": 163.68
  },
  {
    "#": "32 Winchester St, Unit 2 (084-36-02)",
    "$": 359400,
    "address": "32 Winchester St, Unit 2",
    "parcel_id": "084-36-02",
    "owner1": "GOLDSTEIN, DAVID E",
    "owner2": "",
    "current_taxes": 3680.26,
    "new_taxes_no_override": 3839.25,
    "override_total_1": 3948.18,
    "override_increase_1": 108.94
  },
  {
    "#": "32 Winchester St, Unit 3 (084-36-03)",
    "$": 367800,
    "address": "32 Winchester St, Unit 3",
    "parcel_id": "084-36-03",
    "owner1": "MARTINEZ TR, AMY",
    "owner2": "",
    "current_taxes": 3766.27,
    "new_taxes_no_override": 3928.97,
    "override_total_1": 4040.45,
    "override_increase_1": 111.48
  },
  {
    "#": "32 Winchester St, Unit 4 (084-36-04)",
    "$": 572500,
    "address": "32 Winchester St, Unit 4",
    "parcel_id": "084-36-04",
    "owner1": "BRENNAN, ROSEMARY & TERENCE",
    "owner2": "",
    "current_taxes": 5862.4,
    "new_taxes_no_override": 6115.66,
    "override_total_1": 6289.18,
    "override_increase_1": 173.53
  },
  {
    "#": "32 Winchester St, Unit 5 (084-36-05)",
    "$": 384900,
    "address": "32 Winchester St, Unit 5",
    "parcel_id": "084-36-05",
    "owner1": "GORSHTEYN, IRINA",
    "owner2": "",
    "current_taxes": 394.14,
    "new_taxes_no_override": 411.17,
    "override_total_1": 422.83,
    "override_increase_1": 11.67
  },
  {
    "#": "32 Winchester St, Unit 6 (084-36-06)",
    "$": 399200,
    "address": "32 Winchester St, Unit 6",
    "parcel_id": "084-36-06",
    "owner1": "ZHANG, XIAO WEI",
    "owner2": "",
    "current_taxes": 4087.81,
    "new_taxes_no_override": 4264.4,
    "override_total_1": 4385.4,
    "override_increase_1": 121.0
  },
  {
    "#": "32 Winchester St, Unit 7 (084-36-07)",
    "$": 596400,
    "address": "32 Winchester St, Unit 7",
    "parcel_id": "084-36-07",
    "owner1": "RUBIN, LISA E",
    "owner2": "",
    "current_taxes": 6107.14,
    "new_taxes_no_override": 6370.97,
    "override_total_1": 6551.74,
    "override_increase_1": 180.77
  },
  {
    "#": "32 Winchester St, Unit 8 (084-36-08)",
    "$": 415600,
    "address": "32 Winchester St, Unit 8",
    "parcel_id": "084-36-08",
    "owner1": "PARABOSCHI, ANDREA",
    "owner2": "HENDRICK, NATALIE M",
    "current_taxes": 4255.74,
    "new_taxes_no_override": 4439.59,
    "override_total_1": 4565.56,
    "override_increase_1": 125.97
  },
  {
    "#": "32 Winchester St, Unit 9 (084-36-09)",
    "$": 384900,
    "address": "32 Winchester St, Unit 9",
    "parcel_id": "084-36-09",
    "owner1": "TOW, RANDOLPH B & SUSAN P C",
    "owner2": "",
    "current_taxes": 3941.38,
    "new_taxes_no_override": 4111.65,
    "override_total_1": 4228.31,
    "override_increase_1": 116.66
  },
  {
    "#": "32 Winchester St, Unit B (084-36-10)",
    "$": 433200,
    "address": "32 Winchester St, Unit B",
    "parcel_id": "084-36-10",
    "owner1": "DAVIS, KAREN",
    "owner2": "",
    "current_taxes": 4435.97,
    "new_taxes_no_override": 4627.6,
    "override_total_1": 4758.91,
    "override_increase_1": 131.3
  },
  {
    "#": "34 Winchester St, Unit 1 (084-35-01)",
    "$": 496700,
    "address": "34 Winchester St, Unit 1",
    "parcel_id": "084-35-01",
    "owner1": "GARFINKEL TR, CRAIG D",
    "owner2": "",
    "current_taxes": 5086.21,
    "new_taxes_no_override": 5305.93,
    "override_total_1": 5456.49,
    "override_increase_1": 150.55
  },
  {
    "#": "34 Winchester St, Unit 2 (084-35-02)",
    "$": 372900,
    "address": "34 Winchester St, Unit 2",
    "parcel_id": "084-35-02",
    "owner1": "MAKAROV, IGOR",
    "owner2": "ANDRADE, DAVID B",
    "current_taxes": 381.85,
    "new_taxes_no_override": 398.35,
    "override_total_1": 409.65,
    "override_increase_1": 11.3
  },
  {
    "#": "34 Winchester St, Unit 3 (084-35-03)",
    "$": 366800,
    "address": "34 Winchester St, Unit 3",
    "parcel_id": "084-35-03",
    "owner1": "JOYCE, SHARON A",
    "owner2": "",
    "current_taxes": 375.6,
    "new_taxes_no_override": 391.83,
    "override_total_1": 402.94,
    "override_increase_1": 11.12
  },
  {
    "#": "34 Winchester St, Unit 4 (084-35-04)",
    "$": 594400,
    "address": "34 Winchester St, Unit 4",
    "parcel_id": "084-35-04",
    "owner1": "SHAFFER, STEVEN",
    "owner2": "WELLS, HEIDI K",
    "current_taxes": 6086.66,
    "new_taxes_no_override": 6349.6,
    "override_total_1": 6529.77,
    "override_increase_1": 180.17
  },
  {
    "#": "34 Winchester St, Unit 5 (084-35-05)",
    "$": 396400,
    "address": "34 Winchester St, Unit 5",
    "parcel_id": "084-35-05",
    "owner1": "HURWITZ TR, BEVERLY A",
    "owner2": "",
    "current_taxes": 4059.14,
    "new_taxes_no_override": 4234.49,
    "override_total_1": 4354.65,
    "override_increase_1": 120.15
  },
  {
    "#": "34 Winchester St, Unit 6 (084-35-06)",
    "$": 375000,
    "address": "34 Winchester St, Unit 6",
    "parcel_id": "084-35-06",
    "owner1": "SUN, SISI",
    "owner2": "",
    "current_taxes": 384.0,
    "new_taxes_no_override": 400.59,
    "override_total_1": 411.96,
    "override_increase_1": 11.37
  },
  {
    "#": "34 Winchester St, Unit 7 (084-35-07)",
    "$": 580300,
    "address": "34 Winchester St, Unit 7",
    "parcel_id": "084-35-07",
    "owner1": "DIAZ, LARA K & LINO L",
    "owner2": "",
    "current_taxes": 5942.27,
    "new_taxes_no_override": 6198.98,
    "override_total_1": 6374.87,
    "override_increase_1": 175.89
  },
  {
    "#": "34 Winchester St, Unit 8 (084-35-08)",
    "$": 404600,
    "address": "34 Winchester St, Unit 8",
    "parcel_id": "084-35-08",
    "owner1": "ZHOU, MINGREN",
    "owner2": "YANG, MEI",
    "current_taxes": 4143.1,
    "new_taxes_no_override": 4322.08,
    "override_total_1": 4444.72,
    "override_increase_1": 122.64
  },
  {
    "#": "34 Winchester St, Unit 9 (084-35-09)",
    "$": 380400,
    "address": "34 Winchester St, Unit 9",
    "parcel_id": "084-35-09",
    "owner1": "WONG, LEE HAN",
    "owner2": "LAI, WEN-HSING",
    "current_taxes": 3895.3,
    "new_taxes_no_override": 4063.58,
    "override_total_1": 4178.88,
    "override_increase_1": 115.3
  },
  {
    "#": "34 Winchester St, Unit B (084-35-10)",
    "$": 602800,
    "address": "34 Winchester St, Unit B",
    "parcel_id": "084-35-10",
    "owner1": "LEVANGIE, KRISTIN & DEREK",
    "owner2": "",
    "current_taxes": 6172.67,
    "new_taxes_no_override": 6439.33,
    "override_total_1": 6622.04,
    "override_increase_1": 182.71
  },
  {
    "#": "35 Winchester St, Unit 35 (080-08-01)",
    "$": 2673000,
    "address": "35 Winchester St, Unit 35",
    "parcel_id": "080-08-01",
    "owner1": "GOLDBERG, MICHAEL A & REBECCA H",
    "owner2": "",
    "current_taxes": 23736.59,
    "new_taxes_no_override": 24762.01,
    "override_total_1": 25464.61,
    "override_increase_1": 702.6
  },
  {
    "#": "36 Winchester St, Unit 1 (084-34-01)",
    "$": 496700,
    "address": "36 Winchester St, Unit 1",
    "parcel_id": "084-34-01",
    "owner1": "RAWAL, RUSHI D",
    "owner2": "",
    "current_taxes": 5086.21,
    "new_taxes_no_override": 5305.93,
    "override_total_1": 5456.49,
    "override_increase_1": 150.55
  },
  {
    "#": "36 Winchester St, Unit 2 (084-34-02)",
    "$": 396500,
    "address": "36 Winchester St, Unit 2",
    "parcel_id": "084-34-02",
    "owner1": "LI, AMY",
    "owner2": "",
    "current_taxes": 4060.16,
    "new_taxes_no_override": 4235.56,
    "override_total_1": 4355.74,
    "override_increase_1": 120.18
  },
  {
    "#": "36 Winchester St, Unit 3 (084-34-03)",
    "$": 366800,
    "address": "36 Winchester St, Unit 3",
    "parcel_id": "084-34-03",
    "owner1": "OZERNOV, MARINA",
    "owner2": "",
    "current_taxes": 375.6,
    "new_taxes_no_override": 391.83,
    "override_total_1": 402.94,
    "override_increase_1": 11.12
  },
  {
    "#": "36 Winchester St, Unit 4 (084-34-04)",
    "$": 576100,
    "address": "36 Winchester St, Unit 4",
    "parcel_id": "084-34-04",
    "owner1": "SAMOYLOV, VLADIMIR",
    "owner2": "SIGAREVA, MARINA",
    "current_taxes": 5899.26,
    "new_taxes_no_override": 6154.11,
    "override_total_1": 6328.73,
    "override_increase_1": 174.62
  },
  {
    "#": "36 Winchester St, Unit 5 (084-34-05)",
    "$": 396400,
    "address": "36 Winchester St, Unit 5",
    "parcel_id": "084-34-05",
    "owner1": "MODY, AMBRISH",
    "owner2": "",
    "current_taxes": 4059.14,
    "new_taxes_no_override": 4234.49,
    "override_total_1": 4354.65,
    "override_increase_1": 120.15
  },
  {
    "#": "36 Winchester St, Unit 6 (084-34-06)",
    "$": 380400,
    "address": "36 Winchester St, Unit 6",
    "parcel_id": "084-34-06",
    "owner1": "YARBROUGH, CHASE G & AMANDA",
    "owner2": "",
    "current_taxes": 3895.3,
    "new_taxes_no_override": 4063.58,
    "override_total_1": 4178.88,
    "override_increase_1": 115.3
  },
  {
    "#": "36 Winchester St, Unit 7 (084-34-07)",
    "$": 582600,
    "address": "36 Winchester St, Unit 7",
    "parcel_id": "084-34-07",
    "owner1": "ROZOVSKY, ANATOLY & MARINA",
    "owner2": "",
    "current_taxes": 5965.82,
    "new_taxes_no_override": 6223.54,
    "override_total_1": 6400.13,
    "override_increase_1": 176.59
  },
  {
    "#": "36 Winchester St, Unit 8 (084-34-08)",
    "$": 396400,
    "address": "36 Winchester St, Unit 8",
    "parcel_id": "084-34-08",
    "owner1": "JAMES TRS, MICHAEL AARON",
    "owner2": "LEIS, JULIE ANN",
    "current_taxes": 4059.14,
    "new_taxes_no_override": 4234.49,
    "override_total_1": 4354.65,
    "override_increase_1": 120.15
  },
  {
    "#": "36 Winchester St, Unit 9 (084-34-09)",
    "$": 386700,
    "address": "36 Winchester St, Unit 9",
    "parcel_id": "084-34-09",
    "owner1": "MOON, SUNG H & YOON C",
    "owner2": "",
    "current_taxes": 3959.81,
    "new_taxes_no_override": 4130.87,
    "override_total_1": 4248.08,
    "override_increase_1": 117.21
  },
  {
    "#": "36 Winchester St, Unit B (084-34-10)",
    "$": 410800,
    "address": "36 Winchester St, Unit B",
    "parcel_id": "084-34-10",
    "owner1": "CHOI, MICHAEL Y & KATHERINE",
    "owner2": "",
    "current_taxes": 4206.59,
    "new_taxes_no_override": 4388.31,
    "override_total_1": 4512.83,
    "override_increase_1": 124.52
  },
  {
    "#": "37 Winchester St, Unit 37 (080-08-02)",
    "$": 2647800,
    "address": "37 Winchester St, Unit 37",
    "parcel_id": "080-08-02",
    "owner1": "ROGERS, GREGORY S",
    "owner2": "LARM, JENNY F",
    "current_taxes": 23478.54,
    "new_taxes_no_override": 24492.81,
    "override_total_1": 25187.78,
    "override_increase_1": 694.96
  },
  {
    "#": "38 Winchester St, Unit 1 (084-33-01)",
    "$": 494200,
    "address": "38 Winchester St, Unit 1",
    "parcel_id": "084-33-01",
    "owner1": "XU, JIAYI & XIQING",
    "owner2": "",
    "current_taxes": 5060.61,
    "new_taxes_no_override": 5279.23,
    "override_total_1": 5429.02,
    "override_increase_1": 149.79
  },
  {
    "#": "38 Winchester St, Unit 2 (084-33-02)",
    "$": 411800,
    "address": "38 Winchester St, Unit 2",
    "parcel_id": "084-33-02",
    "owner1": "RENTALS ONE LLC",
    "owner2": "",
    "current_taxes": 4216.83,
    "new_taxes_no_override": 4399.0,
    "override_total_1": 4523.82,
    "override_increase_1": 124.82
  },
  {
    "#": "38 Winchester St, Unit 3 (084-33-03)",
    "$": 359600,
    "address": "38 Winchester St, Unit 3",
    "parcel_id": "084-33-03",
    "owner1": "CONDOS ETC LLC",
    "owner2": "",
    "current_taxes": 3682.3,
    "new_taxes_no_override": 3841.38,
    "override_total_1": 3950.37,
    "override_increase_1": 109.0
  },
  {
    "#": "38 Winchester St, Unit 4 (084-33-04)",
    "$": 548400,
    "address": "38 Winchester St, Unit 4",
    "parcel_id": "084-33-04",
    "owner1": "GUPTA TR, PAVI",
    "owner2": "",
    "current_taxes": 5615.62,
    "new_taxes_no_override": 5858.21,
    "override_total_1": 6024.44,
    "override_increase_1": 166.22
  },
  {
    "#": "38 Winchester St, Unit 5 (084-33-05)",
    "$": 382700,
    "address": "38 Winchester St, Unit 5",
    "parcel_id": "084-33-05",
    "owner1": "MAGK LLC",
    "owner2": "",
    "current_taxes": 3918.85,
    "new_taxes_no_override": 4088.14,
    "override_total_1": 4204.14,
    "override_increase_1": 116.0
  },
  {
    "#": "38 Winchester St, Unit 6 (084-33-06)",
    "$": 354200,
    "address": "38 Winchester St, Unit 6",
    "parcel_id": "084-33-06",
    "owner1": "38 WINCHESTER LLC",
    "owner2": "",
    "current_taxes": 3627.01,
    "new_taxes_no_override": 3783.7,
    "override_total_1": 3891.06,
    "override_increase_1": 107.36
  },
  {
    "#": "38 Winchester St, Unit 7 (084-33-07)",
    "$": 570000,
    "address": "38 Winchester St, Unit 7",
    "parcel_id": "084-33-07",
    "owner1": "WBYGB PROPERTIES LLC",
    "owner2": "",
    "current_taxes": 5836.8,
    "new_taxes_no_override": 6088.95,
    "override_total_1": 6261.72,
    "override_increase_1": 172.77
  },
  {
    "#": "38 Winchester St, Unit 8 (084-33-08)",
    "$": 394300,
    "address": "38 Winchester St, Unit 8",
    "parcel_id": "084-33-08",
    "owner1": "RENTALS ONE LLC",
    "owner2": "",
    "current_taxes": 4037.63,
    "new_taxes_no_override": 4212.06,
    "override_total_1": 4331.57,
    "override_increase_1": 119.51
  },
  {
    "#": "38 Winchester St, Unit 9 (084-33-09)",
    "$": 383300,
    "address": "38 Winchester St, Unit 9",
    "parcel_id": "084-33-09",
    "owner1": "RENTALS ONE LLC",
    "owner2": "",
    "current_taxes": 3924.99,
    "new_taxes_no_override": 4094.55,
    "override_total_1": 4210.73,
    "override_increase_1": 116.18
  },
  {
    "#": "38 Winchester St, Unit B (084-33-10)",
    "$": 402900,
    "address": "38 Winchester St, Unit B",
    "parcel_id": "084-33-10",
    "owner1": "GOLDMAN, JOSEPH E",
    "owner2": "",
    "current_taxes": 4125.7,
    "new_taxes_no_override": 4303.93,
    "override_total_1": 4426.05,
    "override_increase_1": 122.12
  },
  {
    "#": "40 Winchester St, Unit 1 (084-32-01)",
    "$": 514500,
    "address": "40 Winchester St, Unit 1",
    "parcel_id": "084-32-01",
    "owner1": "HUMMEL, JANET",
    "owner2": "",
    "current_taxes": 1633.55,
    "new_taxes_no_override": 1704.12,
    "override_total_1": 1752.47,
    "override_increase_1": 48.35
  },
  {
    "#": "40 Winchester St, Unit 2 (084-32-02)",
    "$": 384900,
    "address": "40 Winchester St, Unit 2",
    "parcel_id": "084-32-02",
    "owner1": "RENTALS ONE LLC",
    "owner2": "",
    "current_taxes": 3941.38,
    "new_taxes_no_override": 4111.65,
    "override_total_1": 4228.31,
    "override_increase_1": 116.66
  },
  {
    "#": "40 Winchester St, Unit 3 (084-32-03)",
    "$": 332500,
    "address": "40 Winchester St, Unit 3",
    "parcel_id": "084-32-03",
    "owner1": "SAVOLAINEN, ERIC C",
    "owner2": "",
    "current_taxes": 340.48,
    "new_taxes_no_override": 355.19,
    "override_total_1": 365.27,
    "override_increase_1": 10.08
  },
  {
    "#": "40 Winchester St, Unit 4 (084-32-04)",
    "$": 601400,
    "address": "40 Winchester St, Unit 4",
    "parcel_id": "084-32-04",
    "owner1": "RAWAL, RUSHI D",
    "owner2": "",
    "current_taxes": 6158.34,
    "new_taxes_no_override": 6424.38,
    "override_total_1": 6606.67,
    "override_increase_1": 182.29
  },
  {
    "#": "40 Winchester St, Unit 5 (084-32-05)",
    "$": 410200,
    "address": "40 Winchester St, Unit 5",
    "parcel_id": "084-32-05",
    "owner1": "JALILI, NADER",
    "owner2": "",
    "current_taxes": 4200.45,
    "new_taxes_no_override": 4381.91,
    "override_total_1": 4506.24,
    "override_increase_1": 124.33
  },
  {
    "#": "40 Winchester St, Unit 6 (084-32-06)",
    "$": 358000,
    "address": "40 Winchester St, Unit 6",
    "parcel_id": "084-32-06",
    "owner1": "RENTALS ONE LLC",
    "owner2": "",
    "current_taxes": 3665.92,
    "new_taxes_no_override": 3824.29,
    "override_total_1": 3932.8,
    "override_increase_1": 108.51
  },
  {
    "#": "40 Winchester St, Unit 7 (084-32-07)",
    "$": 596300,
    "address": "40 Winchester St, Unit 7",
    "parcel_id": "084-32-07",
    "owner1": "IMRGMR REALTY ASSOCIATES LLC",
    "owner2": "",
    "current_taxes": 6106.11,
    "new_taxes_no_override": 6369.89,
    "override_total_1": 6550.63,
    "override_increase_1": 180.74
  },
  {
    "#": "40 Winchester St, Unit 8 (084-32-08)",
    "$": 384900,
    "address": "40 Winchester St, Unit 8",
    "parcel_id": "084-32-08",
    "owner1": "ZOU, LIN FENG",
    "owner2": "HUANG, HUI MING",
    "current_taxes": 394.14,
    "new_taxes_no_override": 411.17,
    "override_total_1": 422.83,
    "override_increase_1": 11.67
  },
  {
    "#": "40 Winchester St, Unit 9 (084-32-09)",
    "$": 379500,
    "address": "40 Winchester St, Unit 9",
    "parcel_id": "084-32-09",
    "owner1": "SHKOLNIK TR, DANIEL L",
    "owner2": "",
    "current_taxes": 3886.08,
    "new_taxes_no_override": 4053.96,
    "override_total_1": 4168.99,
    "override_increase_1": 115.03
  },
  {
    "#": "40 Winchester St, Unit B (084-32-10)",
    "$": 408700,
    "address": "40 Winchester St, Unit B",
    "parcel_id": "084-32-10",
    "owner1": "40 B WINCHESTER STREET BROOKLINE LLC",
    "owner2": "",
    "current_taxes": 7013.29,
    "new_taxes_no_override": 7316.26,
    "override_total_1": 7523.86,
    "override_increase_1": 207.59
  },
  {
    "#": "43 Winchester St (080-09-00)",
    "$": 2479500,
    "address": "43 Winchester St",
    "parcel_id": "080-09-00",
    "owner1": "BURROWS, WILLIAM C & HELENE C",
    "owner2": "",
    "current_taxes": 21755.15,
    "new_taxes_no_override": 22694.97,
    "override_total_1": 23338.92,
    "override_increase_1": 643.95
  },
  {
    "#": "47 Winchester St, Unit 1 (080-10-01)",
    "$": 1043600,
    "address": "47 Winchester St, Unit 1",
    "parcel_id": "080-10-01",
    "owner1": "AHARONI, DAN & OSNAT",
    "owner2": "",
    "current_taxes": 7051.53,
    "new_taxes_no_override": 7356.16,
    "override_total_1": 7564.88,
    "override_increase_1": 208.73
  },
  {
    "#": "47 Winchester St, Unit 2 (080-10-02)",
    "$": 896400,
    "address": "47 Winchester St, Unit 2",
    "parcel_id": "080-10-02",
    "owner1": "ABRAMOVICI, ARIE & MICHAL",
    "owner2": "",
    "current_taxes": 5544.2,
    "new_taxes_no_override": 5783.71,
    "override_total_1": 5947.82,
    "override_increase_1": 164.11
  },
  {
    "#": "47 Winchester St, Unit 3 (080-10-03)",
    "$": 901300,
    "address": "47 Winchester St, Unit 3",
    "parcel_id": "080-10-03",
    "owner1": "SOKOL-MARGOLIS, SAM",
    "owner2": "",
    "current_taxes": 5594.38,
    "new_taxes_no_override": 5836.06,
    "override_total_1": 6001.65,
    "override_increase_1": 165.59
  },
  {
    "#": "49 Winchester St, Unit 1 (080-11-03)",
    "$": 1006200,
    "address": "49 Winchester St, Unit 1",
    "parcel_id": "080-11-03",
    "owner1": "GROSSMAN TRS, SEVERIN",
    "owner2": "SPOLSINO, NANCY E",
    "current_taxes": 10303.49,
    "new_taxes_no_override": 10748.6,
    "override_total_1": 11053.58,
    "override_increase_1": 304.98
  },
  {
    "#": "49 Winchester St, Unit 2 (080-11-01)",
    "$": 1083800,
    "address": "49 Winchester St, Unit 2",
    "parcel_id": "080-11-01",
    "owner1": "MARK, GEORGE E & JUDITH GOLDSTEIN",
    "owner2": "",
    "current_taxes": 7463.18,
    "new_taxes_no_override": 7785.59,
    "override_total_1": 8006.5,
    "override_increase_1": 220.91
  },
  {
    "#": "49 Winchester St, Unit 3 (080-11-02)",
    "$": 1083900,
    "address": "49 Winchester St, Unit 3",
    "parcel_id": "080-11-02",
    "owner1": "SPOLSINO TRS, NANCY E",
    "owner2": "GROSSMAN, SEVERIN",
    "current_taxes": 7464.2,
    "new_taxes_no_override": 7786.65,
    "override_total_1": 8007.59,
    "override_increase_1": 220.94
  },
  {
    "#": "50 Winchester St, Unit 101 (084-30-34)",
    "$": 1415300,
    "address": "50 Winchester St, Unit 101",
    "parcel_id": "084-30-34",
    "owner1": "WEIDMULLER, HENRY",
    "owner2": "BACH-WEIDMULLER, ALEXANDRA",
    "current_taxes": 10857.74,
    "new_taxes_no_override": 11326.79,
    "override_total_1": 11648.18,
    "override_increase_1": 321.39
  },
  {
    "#": "50 Winchester St, Unit 102 & P17 (084-30-01)",
    "$": 1041500,
    "address": "50 Winchester St, Unit 102 & P17",
    "parcel_id": "084-30-01",
    "owner1": "SHABY, VELDA",
    "owner2": "",
    "current_taxes": 7030.03,
    "new_taxes_no_override": 7333.73,
    "override_total_1": 7541.82,
    "override_increase_1": 208.09
  },
  {
    "#": "50 Winchester St, Unit 103 & P22 (084-30-02)",
    "$": 1202700,
    "address": "50 Winchester St, Unit 103 & P22",
    "parcel_id": "084-30-02",
    "owner1": "LESCOHIER TRS, DAVID & ILANA",
    "owner2": "",
    "current_taxes": 8680.71,
    "new_taxes_no_override": 9055.72,
    "override_total_1": 9312.67,
    "override_increase_1": 256.95
  },
  {
    "#": "50 Winchester St, Unit 201 & P29 (084-30-03)",
    "$": 863300,
    "address": "50 Winchester St, Unit 201 & P29",
    "parcel_id": "084-30-03",
    "owner1": "THOMAS, JEANNE O & WALTER CLYDE III",
    "owner2": "",
    "current_taxes": 8840.19,
    "new_taxes_no_override": 9222.09,
    "override_total_1": 9483.76,
    "override_increase_1": 261.67
  },
  {
    "#": "50 Winchester St, Unit 202 (084-30-04)",
    "$": 611700,
    "address": "50 Winchester St, Unit 202",
    "parcel_id": "084-30-04",
    "owner1": "DECATALDI, CYNTHIA A",
    "owner2": "C/O SIMONELLI RICHARD",
    "current_taxes": 6263.81,
    "new_taxes_no_override": 6534.41,
    "override_total_1": 6719.82,
    "override_increase_1": 185.41
  },
  {
    "#": "50 Winchester St, Unit 203 (084-30-05)",
    "$": 1318800,
    "address": "50 Winchester St, Unit 203",
    "parcel_id": "084-30-05",
    "owner1": "SAHR, JANET",
    "owner2": "",
    "current_taxes": 13504.51,
    "new_taxes_no_override": 14087.9,
    "override_total_1": 14487.64,
    "override_increase_1": 399.73
  },
  {
    "#": "50 Winchester St, Unit 204 & P18 (084-30-06)",
    "$": 1013500,
    "address": "50 Winchester St, Unit 204 & P18",
    "parcel_id": "084-30-06",
    "owner1": "CARON, STEVEN & KATHRYN",
    "owner2": "",
    "current_taxes": 6743.31,
    "new_taxes_no_override": 7034.62,
    "override_total_1": 7234.22,
    "override_increase_1": 199.6
  },
  {
    "#": "50 Winchester St, Unit 205 & G19 (084-30-07)",
    "$": 1017100,
    "address": "50 Winchester St, Unit 205 & G19",
    "parcel_id": "084-30-07",
    "owner1": "BLISS TR, STEPHEN B",
    "owner2": "",
    "current_taxes": 6780.17,
    "new_taxes_no_override": 7073.07,
    "override_total_1": 7273.77,
    "override_increase_1": 200.69
  },
  {
    "#": "50 Winchester St, Unit 206 & P16 (084-30-08)",
    "$": 1124900,
    "address": "50 Winchester St, Unit 206 & P16",
    "parcel_id": "084-30-08",
    "owner1": "KUMARAGURU, BHARATHAN",
    "owner2": "",
    "current_taxes": 11518.98,
    "new_taxes_no_override": 12016.6,
    "override_total_1": 12357.56,
    "override_increase_1": 340.96
  },
  {
    "#": "50 Winchester St, Unit 207 & P9 (084-30-09)",
    "$": 1019600,
    "address": "50 Winchester St, Unit 207 & P9",
    "parcel_id": "084-30-09",
    "owner1": "ORR, ERAN & SHIRA",
    "owner2": "",
    "current_taxes": 10440.7,
    "new_taxes_no_override": 10891.74,
    "override_total_1": 11200.78,
    "override_increase_1": 309.04
  },
  {
    "#": "50 Winchester St, Unit 208 & P12 (084-30-10)",
    "$": 1246300,
    "address": "50 Winchester St, Unit 208 & P12",
    "parcel_id": "084-30-10",
    "owner1": "CASEY, KEVIN P & KRISTIN A",
    "owner2": "",
    "current_taxes": 9127.18,
    "new_taxes_no_override": 9521.47,
    "override_total_1": 9791.64,
    "override_increase_1": 270.16
  },
  {
    "#": "50 Winchester St, Unit 209 & P11 (084-30-11)",
    "$": 1161300,
    "address": "50 Winchester St, Unit 209 & P11",
    "parcel_id": "084-30-11",
    "owner1": "WU, SARAH",
    "owner2": "THOMAS, AARON",
    "current_taxes": 8256.78,
    "new_taxes_no_override": 8613.47,
    "override_total_1": 8857.87,
    "override_increase_1": 244.4
  },
  {
    "#": "50 Winchester St, Unit 210 & P27 (084-30-12)",
    "$": 721500,
    "address": "50 Winchester St, Unit 210 & P27",
    "parcel_id": "084-30-12",
    "owner1": "GHAFARI, RAMESH",
    "owner2": "",
    "current_taxes": 3753.23,
    "new_taxes_no_override": 3915.37,
    "override_total_1": 4026.47,
    "override_increase_1": 111.1
  },
  {
    "#": "50 Winchester St, Unit 301 (084-30-13)",
    "$": 941500,
    "address": "50 Winchester St, Unit 301",
    "parcel_id": "084-30-13",
    "owner1": "LIU, YU-HSUAN",
    "owner2": "",
    "current_taxes": 6006.03,
    "new_taxes_no_override": 6265.49,
    "override_total_1": 6443.27,
    "override_increase_1": 177.78
  },
  {
    "#": "50 Winchester St, Unit 302 & P6 (084-30-14)",
    "$": 1294200,
    "address": "50 Winchester St, Unit 302 & P6",
    "parcel_id": "084-30-14",
    "owner1": "50-302 WINCHESTER LLC",
    "owner2": "",
    "current_taxes": 13252.61,
    "new_taxes_no_override": 13825.12,
    "override_total_1": 14217.4,
    "override_increase_1": 392.28
  },
  {
    "#": "50 Winchester St, Unit 303 (084-30-15)",
    "$": 745100,
    "address": "50 Winchester St, Unit 303",
    "parcel_id": "084-30-15",
    "owner1": "BITRAN TRS, LAURINDA C & STELLA",
    "owner2": "",
    "current_taxes": 7629.82,
    "new_taxes_no_override": 7959.43,
    "override_total_1": 8185.27,
    "override_increase_1": 225.84
  },
  {
    "#": "50 Winchester St, Unit 304 (084-30-16)",
    "$": 1123200,
    "address": "50 Winchester St, Unit 304",
    "parcel_id": "084-30-16",
    "owner1": "CHIU, FLORA T K",
    "owner2": "CHIU  ET AL TRS, ROBERTA TZE CHING",
    "current_taxes": 11501.57,
    "new_taxes_no_override": 11998.44,
    "override_total_1": 12338.88,
    "override_increase_1": 340.45
  },
  {
    "#": "50 Winchester St, Unit 305 & G7 (084-30-17)",
    "$": 1144300,
    "address": "50 Winchester St, Unit 305 & G7",
    "parcel_id": "084-30-17",
    "owner1": "GERZON, IGOR & POLINA",
    "owner2": "",
    "current_taxes": 8082.7,
    "new_taxes_no_override": 8431.87,
    "override_total_1": 8671.12,
    "override_increase_1": 239.25
  },
  {
    "#": "50 Winchester St, Unit 306 & P39 (084-30-18)",
    "$": 952700,
    "address": "50 Winchester St, Unit 306 & P39",
    "parcel_id": "084-30-18",
    "owner1": "LI, XIAOYU",
    "owner2": "ZENG, ZEXIAN",
    "current_taxes": 9755.65,
    "new_taxes_no_override": 10177.09,
    "override_total_1": 10465.86,
    "override_increase_1": 288.77
  },
  {
    "#": "50 Winchester St, Unit 307 & P38 (084-30-19)",
    "$": 704300,
    "address": "50 Winchester St, Unit 307 & P38",
    "parcel_id": "084-30-19",
    "owner1": "WIENER TRS, MONA & MARTIN D",
    "owner2": "",
    "current_taxes": 7212.03,
    "new_taxes_no_override": 7523.59,
    "override_total_1": 7737.07,
    "override_increase_1": 213.48
  },
  {
    "#": "50 Winchester St, Unit 308 & P37 (084-30-20)",
    "$": 978700,
    "address": "50 Winchester St, Unit 308 & P37",
    "parcel_id": "084-30-20",
    "owner1": "XU, MINGHONG",
    "owner2": "",
    "current_taxes": 10021.89,
    "new_taxes_no_override": 10454.84,
    "override_total_1": 10751.48,
    "override_increase_1": 296.65
  },
  {
    "#": "50 Winchester St, Unit 401 & P8 (084-30-21)",
    "$": 1316000,
    "address": "50 Winchester St, Unit 401 & P8",
    "parcel_id": "084-30-21",
    "owner1": "DAYTON, PETER L",
    "owner2": "",
    "current_taxes": 9840.91,
    "new_taxes_no_override": 10266.04,
    "override_total_1": 10557.33,
    "override_increase_1": 291.29
  },
  {
    "#": "50 Winchester St, Unit 402 & P36 (084-30-22)",
    "$": 771100,
    "address": "50 Winchester St, Unit 402 & P36",
    "parcel_id": "084-30-22",
    "owner1": "FRIED TR, SUSAN B",
    "owner2": "",
    "current_taxes": 4261.13,
    "new_taxes_no_override": 4445.21,
    "override_total_1": 4571.34,
    "override_increase_1": 126.13
  },
  {
    "#": "50 Winchester St, Unit 403 & P14 (084-30-23)",
    "$": 1122000,
    "address": "50 Winchester St, Unit 403 & P14",
    "parcel_id": "084-30-23",
    "owner1": "TRAYNOR TR, ROBERTA J",
    "owner2": "",
    "current_taxes": 7854.35,
    "new_taxes_no_override": 8193.66,
    "override_total_1": 8426.15,
    "override_increase_1": 232.49
  },
  {
    "#": "50 Winchester St, Unit 404 (084-30-24)",
    "$": 961200,
    "address": "50 Winchester St, Unit 404",
    "parcel_id": "084-30-24",
    "owner1": "GLUZMAN TRS, VADIM",
    "owner2": "",
    "current_taxes": 9842.69,
    "new_taxes_no_override": 10267.89,
    "override_total_1": 10559.24,
    "override_increase_1": 291.34
  },
  {
    "#": "50 Winchester St, Unit 405 & G15 (084-30-25)",
    "$": 1153300,
    "address": "50 Winchester St, Unit 405 & G15",
    "parcel_id": "084-30-25",
    "owner1": "AISH TR, LEO S",
    "owner2": "",
    "current_taxes": 11809.79,
    "new_taxes_no_override": 12319.97,
    "override_total_1": 12669.54,
    "override_increase_1": 349.57
  },
  {
    "#": "50 Winchester St, Unit 406 & P20 (084-30-26)",
    "$": 1143100,
    "address": "50 Winchester St, Unit 406 & P20",
    "parcel_id": "084-30-26",
    "owner1": "GREENBERG TR, JILL M",
    "owner2": "",
    "current_taxes": 8070.41,
    "new_taxes_no_override": 8419.05,
    "override_total_1": 8657.94,
    "override_increase_1": 238.88
  },
  {
    "#": "50 Winchester St, Unit 407 & P4 (084-30-27)",
    "$": 1199300,
    "address": "50 Winchester St, Unit 407 & P4",
    "parcel_id": "084-30-27",
    "owner1": "YAVNER, ELLEN F",
    "owner2": "",
    "current_taxes": 8645.9,
    "new_taxes_no_override": 9019.4,
    "override_total_1": 9275.32,
    "override_increase_1": 255.92
  },
  {
    "#": "50 Winchester St, Unit 408 (084-30-28)",
    "$": 1108800,
    "address": "50 Winchester St, Unit 408",
    "parcel_id": "084-30-28",
    "owner1": "SELLING, AVIVA",
    "owner2": "",
    "current_taxes": 11354.11,
    "new_taxes_no_override": 11844.61,
    "override_total_1": 12180.69,
    "override_increase_1": 336.08
  },
  {
    "#": "50 Winchester St, Unit 409 & P23 (084-30-29)",
    "$": 876200,
    "address": "50 Winchester St, Unit 409 & P23",
    "parcel_id": "084-30-29",
    "owner1": "XIAO, QIAN",
    "owner2": "",
    "current_taxes": 5337.35,
    "new_taxes_no_override": 5567.92,
    "override_total_1": 5725.91,
    "override_increase_1": 157.99
  },
  {
    "#": "50 Winchester St, Unit 410 & P10 (084-30-30)",
    "$": 1185200,
    "address": "50 Winchester St, Unit 410 & P10",
    "parcel_id": "084-30-30",
    "owner1": "VIDONE, LINDA S",
    "owner2": "",
    "current_taxes": 8501.51,
    "new_taxes_no_override": 8868.78,
    "override_total_1": 9120.42,
    "override_increase_1": 251.64
  },
  {
    "#": "50 Winchester St, Unit 411 (084-30-31)",
    "$": 1048900,
    "address": "50 Winchester St, Unit 411",
    "parcel_id": "084-30-31",
    "owner1": "SEAY, JOHN A",
    "owner2": "",
    "current_taxes": 7105.8,
    "new_taxes_no_override": 7412.77,
    "override_total_1": 7623.1,
    "override_increase_1": 210.33
  },
  {
    "#": "50 Winchester St, Unit 412 & P13 (084-30-32)",
    "$": 1157200,
    "address": "50 Winchester St, Unit 412 & P13",
    "parcel_id": "084-30-32",
    "owner1": "WHITMORE TRS, ELLEN B",
    "owner2": "HINES TRS, SARAH WHITMORE",
    "current_taxes": 8214.79,
    "new_taxes_no_override": 8569.67,
    "override_total_1": 8812.83,
    "override_increase_1": 243.16
  },
  {
    "#": "50 Winchester St, Unit 413 & P5 (084-30-33)",
    "$": 1162600,
    "address": "50 Winchester St, Unit 413 & P5",
    "parcel_id": "084-30-33",
    "owner1": "FREINK, DANIEL & MARIANNA",
    "owner2": "",
    "current_taxes": 8270.09,
    "new_taxes_no_override": 8627.36,
    "override_total_1": 8872.15,
    "override_increase_1": 244.79
  },
  {
    "#": "51 Winchester St, Unit 1 (080-12-03)",
    "$": 979700,
    "address": "51 Winchester St, Unit 1",
    "parcel_id": "080-12-03",
    "owner1": "ROY, MODHUMITA",
    "owner2": "",
    "current_taxes": 6397.19,
    "new_taxes_no_override": 6673.55,
    "override_total_1": 6862.91,
    "override_increase_1": 189.36
  },
  {
    "#": "51 Winchester St, Unit 2 (080-12-01)",
    "$": 1041400,
    "address": "51 Winchester St, Unit 2",
    "parcel_id": "080-12-01",
    "owner1": "MILLER, MARK",
    "owner2": "TACHIBANA, MIYUKI",
    "current_taxes": 7029.0,
    "new_taxes_no_override": 7332.65,
    "override_total_1": 7540.71,
    "override_increase_1": 208.06
  },
  {
    "#": "51 Winchester St, Unit 3 (080-12-02)",
    "$": 1069500,
    "address": "51 Winchester St, Unit 3",
    "parcel_id": "080-12-02",
    "owner1": "HUNTER, JOHN",
    "owner2": "CHIGIRINSKAYA, YELANA",
    "current_taxes": 7316.75,
    "new_taxes_no_override": 7632.83,
    "override_total_1": 7849.41,
    "override_increase_1": 216.58
  },
  {
    "#": "53 Winchester St (080-13-00)",
    "$": 2549800,
    "address": "53 Winchester St",
    "parcel_id": "080-13-00",
    "owner1": "LEE, PETER HANG POR &ANNIE S-M &STEVEN T-Y & JOHN C-Y",
    "owner2": "",
    "current_taxes": 22475.02,
    "new_taxes_no_override": 23445.94,
    "override_total_1": 24111.2,
    "override_increase_1": 665.26
  },
  {
    "#": "64 Winchester St, Unit 100 & P4 P5 (084-29-17)",
    "$": 1302500,
    "address": "64 Winchester St, Unit 100 & P4 P5",
    "parcel_id": "084-29-17",
    "owner1": "TAKAGI, YUKIKO",
    "owner2": "",
    "current_taxes": 9702.67,
    "new_taxes_no_override": 10121.83,
    "override_total_1": 10409.02,
    "override_increase_1": 287.2
  },
  {
    "#": "66 Winchester St, Unit 101 P2-G5 (084-29-01)",
    "$": 1321200,
    "address": "66 Winchester St, Unit 101 P2-G5",
    "parcel_id": "084-29-01",
    "owner1": "PORTNOW TR, LEAH",
    "owner2": "",
    "current_taxes": 13529.09,
    "new_taxes_no_override": 14113.55,
    "override_total_1": 14514.01,
    "override_increase_1": 400.46
  },
  {
    "#": "66 Winchester St, Unit 102& G3-G7-P7 (084-29-02)",
    "$": 1128100,
    "address": "66 Winchester St, Unit 102& G3-G7-P7",
    "parcel_id": "084-29-02",
    "owner1": "MARANTZ, JOSHUA & JING",
    "owner2": "",
    "current_taxes": 11551.74,
    "new_taxes_no_override": 12050.78,
    "override_total_1": 12392.71,
    "override_increase_1": 341.93
  },
  {
    "#": "66 Winchester St, Unit 201 & P1 (084-29-03)",
    "$": 966200,
    "address": "66 Winchester St, Unit 201 & P1",
    "parcel_id": "084-29-03",
    "owner1": "ROTMAN TRS, ARY & ZOYA",
    "owner2": "",
    "current_taxes": 9893.89,
    "new_taxes_no_override": 10321.31,
    "override_total_1": 10614.17,
    "override_increase_1": 292.86
  },
  {
    "#": "66 Winchester St, Unit 202 & G-9 (084-29-04)",
    "$": 1014200,
    "address": "66 Winchester St, Unit 202 & G-9",
    "parcel_id": "084-29-04",
    "owner1": "YU TR, JENNY",
    "owner2": "",
    "current_taxes": 6750.47,
    "new_taxes_no_override": 7042.09,
    "override_total_1": 7241.9,
    "override_increase_1": 199.81
  },
  {
    "#": "66 Winchester St, Unit 203 & G-6 (084-29-05)",
    "$": 1012200,
    "address": "66 Winchester St, Unit 203 & G-6",
    "parcel_id": "084-29-05",
    "owner1": "TSYVIN, ELLEN",
    "owner2": "ABEZGAUZ, VLADIMIR",
    "current_taxes": 10364.93,
    "new_taxes_no_override": 10812.69,
    "override_total_1": 11119.5,
    "override_increase_1": 306.8
  },
  {
    "#": "66 Winchester St, Unit 301 & G10 (084-29-06)",
    "$": 1002900,
    "address": "66 Winchester St, Unit 301 & G10",
    "parcel_id": "084-29-06",
    "owner1": "YEH, KUEI JU",
    "owner2": "",
    "current_taxes": 10269.7,
    "new_taxes_no_override": 10713.35,
    "override_total_1": 11017.33,
    "override_increase_1": 303.98
  },
  {
    "#": "66 Winchester St, Unit 302 & G1 (084-29-07)",
    "$": 1043300,
    "address": "66 Winchester St, Unit 302 & G1",
    "parcel_id": "084-29-07",
    "owner1": "LEE, SHIH YUAN",
    "owner2": "",
    "current_taxes": 7048.46,
    "new_taxes_no_override": 7352.95,
    "override_total_1": 7561.59,
    "override_increase_1": 208.63
  },
  {
    "#": "66 Winchester St, Unit 303 & P8 (084-29-08)",
    "$": 992700,
    "address": "66 Winchester St, Unit 303 & P8",
    "parcel_id": "084-29-08",
    "owner1": "MARGOLSKEE, PENNY ELLEN",
    "owner2": "",
    "current_taxes": 6530.31,
    "new_taxes_no_override": 6812.42,
    "override_total_1": 7005.72,
    "override_increase_1": 193.3
  },
  {
    "#": "66 Winchester St, Unit 401& G13 (084-29-09)",
    "$": 1111900,
    "address": "66 Winchester St, Unit 401& G13",
    "parcel_id": "084-29-09",
    "owner1": "GREENWOOD TRS, CATHERINE C & TED RONALD IVAN",
    "owner2": "",
    "current_taxes": 7750.92,
    "new_taxes_no_override": 8085.76,
    "override_total_1": 8315.19,
    "override_increase_1": 229.43
  },
  {
    "#": "66 Winchester St, Unit 402 & G4 (084-29-10)",
    "$": 1033800,
    "address": "66 Winchester St, Unit 402 & G4",
    "parcel_id": "084-29-10",
    "owner1": "NAKAMURA, EIJIRO & NOBUKO",
    "owner2": "C/O RELO REDAC 2211",
    "current_taxes": 10586.11,
    "new_taxes_no_override": 11043.43,
    "override_total_1": 11356.78,
    "override_increase_1": 313.35
  },
  {
    "#": "66 Winchester St, Unit 403 & P6 (084-29-11)",
    "$": 1011800,
    "address": "66 Winchester St, Unit 403 & P6",
    "parcel_id": "084-29-11",
    "owner1": "ASHKENAZI ETAL, HANNAH GONCALVES",
    "owner2": "GONCALVES, MANUELA",
    "current_taxes": 6725.9,
    "new_taxes_no_override": 7016.46,
    "override_total_1": 7215.55,
    "override_increase_1": 199.09
  },
  {
    "#": "66 Winchester St, Unit 501 & G2 (084-29-12)",
    "$": 1088500,
    "address": "66 Winchester St, Unit 501 & G2",
    "parcel_id": "084-29-12",
    "owner1": "YAN, AIMIN",
    "owner2": "LU, HUIMIN",
    "current_taxes": 7511.31,
    "new_taxes_no_override": 7835.8,
    "override_total_1": 8058.13,
    "override_increase_1": 222.33
  },
  {
    "#": "66 Winchester St, Unit 502 & P3 (084-29-13)",
    "$": 1038300,
    "address": "66 Winchester St, Unit 502 & P3",
    "parcel_id": "084-29-13",
    "owner1": "RAJABIUN REALTY LLC",
    "owner2": "",
    "current_taxes": 10632.19,
    "new_taxes_no_override": 11091.5,
    "override_total_1": 11406.21,
    "override_increase_1": 314.71
  },
  {
    "#": "66 Winchester St, Unit 503 & G8 (084-29-14)",
    "$": 1108300,
    "address": "66 Winchester St, Unit 503 & G8",
    "parcel_id": "084-29-14",
    "owner1": "VALENTE, ANNE MARIE",
    "owner2": "",
    "current_taxes": 7714.06,
    "new_taxes_no_override": 8047.31,
    "override_total_1": 8275.64,
    "override_increase_1": 228.34
  },
  {
    "#": "66 Winchester St, Unit Pha & G11 (084-29-15)",
    "$": 1185600,
    "address": "66 Winchester St, Unit Pha & G11",
    "parcel_id": "084-29-15",
    "owner1": "WINCHESTER STREET PROPERTIES LLC",
    "owner2": "C/O JEFFREY ABARBANEL ESQ",
    "current_taxes": 12140.54,
    "new_taxes_no_override": 12665.01,
    "override_total_1": 13024.37,
    "override_increase_1": 359.36
  },
  {
    "#": "66 Winchester St, Unit Phb & G12 (084-29-16)",
    "$": 1160200,
    "address": "66 Winchester St, Unit Phb & G12",
    "parcel_id": "084-29-16",
    "owner1": "MAGDOVITZ, LAWRENCE M II & NOUTH C",
    "owner2": "",
    "current_taxes": 11880.45,
    "new_taxes_no_override": 12393.69,
    "override_total_1": 12745.35,
    "override_increase_1": 351.66
  },
  {
    "#": "67 Winchester St, Unit 1 (079-04-01)",
    "$": 210500,
    "address": "67 Winchester St, Unit 1",
    "parcel_id": "079-04-01",
    "owner1": "SAGAKIS, TR, NINA L",
    "owner2": "",
    "current_taxes": 2155.52,
    "new_taxes_no_override": 2248.64,
    "override_total_1": 2312.44,
    "override_increase_1": 63.8
  },
  {
    "#": "67 Winchester St, Unit 2 (079-04-02)",
    "$": 176800,
    "address": "67 Winchester St, Unit 2",
    "parcel_id": "079-04-02",
    "owner1": "WEILER TRS, TIMOTHY W & MARY BETH & ANDREW S",
    "owner2": "",
    "current_taxes": 1810.43,
    "new_taxes_no_override": 1888.64,
    "override_total_1": 1942.23,
    "override_increase_1": 53.59
  },
  {
    "#": "67 Winchester St, Unit 3 (079-04-03)",
    "$": 185000,
    "address": "67 Winchester St, Unit 3",
    "parcel_id": "079-04-03",
    "owner1": "DAVIDOVSKY, TRS, ELAINE& ADRIANA T",
    "owner2": "",
    "current_taxes": 1894.4,
    "new_taxes_no_override": 1976.24,
    "override_total_1": 2032.31,
    "override_increase_1": 56.07
  },
  {
    "#": "67 Winchester St, Unit 4 (079-04-04)",
    "$": 195500,
    "address": "67 Winchester St, Unit 4",
    "parcel_id": "079-04-04",
    "owner1": "WASSERMAN TR, MARCIA",
    "owner2": "GWIRTZMAN, M",
    "current_taxes": 2001.92,
    "new_taxes_no_override": 2088.4,
    "override_total_1": 2147.66,
    "override_increase_1": 59.26
  },
  {
    "#": "67 Winchester St, Unit 5 (079-04-05)",
    "$": 199400,
    "address": "67 Winchester St, Unit 5",
    "parcel_id": "079-04-05",
    "owner1": "BRANDSTATER TR, CHARLES E",
    "owner2": "",
    "current_taxes": 2041.86,
    "new_taxes_no_override": 2130.07,
    "override_total_1": 2190.51,
    "override_increase_1": 60.44
  },
  {
    "#": "67 Winchester St, Unit 6 (079-04-06)",
    "$": 185800,
    "address": "67 Winchester St, Unit 6",
    "parcel_id": "079-04-06",
    "owner1": "MINKEL TRS, JEAN",
    "owner2": "CORKERY, MATTHEW B",
    "current_taxes": 1902.59,
    "new_taxes_no_override": 1984.78,
    "override_total_1": 2041.1,
    "override_increase_1": 56.32
  },
  {
    "#": "70 Winchester St (084-28-00)",
    "$": 2473000,
    "address": "70 Winchester St",
    "parcel_id": "084-28-00",
    "owner1": "BLOOM, SARA LEE",
    "owner2": "CUSHNER ET AL TRS, STUART C",
    "current_taxes": 21688.59,
    "new_taxes_no_override": 22625.54,
    "override_total_1": 23267.52,
    "override_increase_1": 641.98
  },
  {
    "#": "71 Winchester St, Unit A (079-05-01)",
    "$": 1909300,
    "address": "71 Winchester St, Unit A",
    "parcel_id": "079-05-01",
    "owner1": "ECHEVERRIA, MARCO A",
    "owner2": "DECORDOVA, MARIA",
    "current_taxes": 15916.3,
    "new_taxes_no_override": 16603.88,
    "override_total_1": 17075.01,
    "override_increase_1": 471.12
  },
  {
    "#": "71 Winchester St, Unit B (079-05-02)",
    "$": 762300,
    "address": "71 Winchester St, Unit B",
    "parcel_id": "079-05-02",
    "owner1": "759 REAL ESTATE LLC",
    "owner2": "",
    "current_taxes": 7805.95,
    "new_taxes_no_override": 8143.17,
    "override_total_1": 8374.22,
    "override_increase_1": 231.06
  },
  {
    "#": "71 Winchester St, Unit C (079-05-03)",
    "$": 947300,
    "address": "71 Winchester St, Unit C",
    "parcel_id": "079-05-03",
    "owner1": "759 REAL ESTATE LLC",
    "owner2": "",
    "current_taxes": 9700.35,
    "new_taxes_no_override": 10119.41,
    "override_total_1": 10406.54,
    "override_increase_1": 287.13
  },
  {
    "#": "71 Winchester St, Unit D (079-05-04)",
    "$": 3267700,
    "address": "71 Winchester St, Unit D",
    "parcel_id": "079-05-04",
    "owner1": "FONG ET AL TRS, JUSTIN Y",
    "owner2": "FONG, ALISON",
    "current_taxes": 29826.31,
    "new_taxes_no_override": 31114.81,
    "override_total_1": 31997.67,
    "override_increase_1": 882.86
  },
  {
    "#": "74 Winchester St (084-27-00)",
    "$": 2276400,
    "address": "74 Winchester St",
    "parcel_id": "084-27-00",
    "owner1": "BOZOVIC TR, MLADJAN G",
    "owner2": "ZIVKOVIC-BOZOVIC TR, LJILJANA Z",
    "current_taxes": 19675.4,
    "new_taxes_no_override": 20525.38,
    "override_total_1": 21107.77,
    "override_increase_1": 582.39
  },
  {
    "#": "75 Winchester St, Unit 101 G13-18 (079-06-01)",
    "$": 1572100,
    "address": "75 Winchester St, Unit 101 G13-18",
    "parcel_id": "079-06-01",
    "owner1": "COHEN TR, TERRIE F",
    "owner2": "",
    "current_taxes": 16098.3,
    "new_taxes_no_override": 16793.75,
    "override_total_1": 17270.26,
    "override_increase_1": 476.51
  },
  {
    "#": "75 Winchester St, Unit 102 & G14 (079-06-02)",
    "$": 480900,
    "address": "75 Winchester St, Unit 102 & G14",
    "parcel_id": "079-06-02",
    "owner1": "CHAMBERS, SARAH S",
    "owner2": "",
    "current_taxes": 1289.48,
    "new_taxes_no_override": 1345.19,
    "override_total_1": 1383.35,
    "override_increase_1": 38.17
  },
  {
    "#": "75 Winchester St, Unit 201 G15-19 (079-06-03)",
    "$": 1572100,
    "address": "75 Winchester St, Unit 201 G15-19",
    "parcel_id": "079-06-03",
    "owner1": "WEYL, BARBARA",
    "owner2": "",
    "current_taxes": 12463.37,
    "new_taxes_no_override": 13001.79,
    "override_total_1": 13370.7,
    "override_increase_1": 368.92
  },
  {
    "#": "75 Winchester St, Unit 202 G6-12 (079-06-04)",
    "$": 1406800,
    "address": "75 Winchester St, Unit 202 G6-12",
    "parcel_id": "079-06-04",
    "owner1": "GRINSTAFF, MARK W",
    "owner2": "MEYERS, FABIENNE",
    "current_taxes": 14405.63,
    "new_taxes_no_override": 15027.95,
    "override_total_1": 15454.36,
    "override_increase_1": 426.41
  },
  {
    "#": "75 Winchester St, Unit 203 G5-8 (079-06-05)",
    "$": 1521700,
    "address": "75 Winchester St, Unit 203 G5-8",
    "parcel_id": "079-06-05",
    "owner1": "WISEMAN, ELENA",
    "owner2": "",
    "current_taxes": 11947.27,
    "new_taxes_no_override": 12463.39,
    "override_total_1": 12817.03,
    "override_increase_1": 353.64
  },
  {
    "#": "75 Winchester St, Unit 301 & G3-9 (079-06-06)",
    "$": 1572100,
    "address": "75 Winchester St, Unit 301 & G3-9",
    "parcel_id": "079-06-06",
    "owner1": "GAO, YUAN ZHAO & ANNE ELIZABETH",
    "owner2": "",
    "current_taxes": 12463.37,
    "new_taxes_no_override": 13001.79,
    "override_total_1": 13370.7,
    "override_increase_1": 368.92
  },
  {
    "#": "75 Winchester St, Unit 302 G4-11 (079-06-07)",
    "$": 1406800,
    "address": "75 Winchester St, Unit 302 G4-11",
    "parcel_id": "079-06-07",
    "owner1": "HERBLUM TRS, KYLA",
    "owner2": "BORG, ROCHELLE",
    "current_taxes": 10770.7,
    "new_taxes_no_override": 11235.99,
    "override_total_1": 11554.81,
    "override_increase_1": 318.81
  },
  {
    "#": "75 Winchester St, Unit 303 G17-21 (079-06-08)",
    "$": 1527300,
    "address": "75 Winchester St, Unit 303 G17-21",
    "parcel_id": "079-06-08",
    "owner1": "PHILLIPS, ELLEN N & PHILIP J",
    "owner2": "",
    "current_taxes": 15639.55,
    "new_taxes_no_override": 16315.18,
    "override_total_1": 16778.11,
    "override_increase_1": 462.93
  },
  {
    "#": "75 Winchester St, Unit 401&G16&22 (079-06-09)",
    "$": 1572100,
    "address": "75 Winchester St, Unit 401&G16&22",
    "parcel_id": "079-06-09",
    "owner1": "ROSENBERG, ABBY S",
    "owner2": "",
    "current_taxes": 12463.37,
    "new_taxes_no_override": 13001.79,
    "override_total_1": 13370.7,
    "override_increase_1": 368.92
  },
  {
    "#": "75 Winchester St, Unit 402 G10-20 (079-06-10)",
    "$": 1406800,
    "address": "75 Winchester St, Unit 402 G10-20",
    "parcel_id": "079-06-10",
    "owner1": "HIGGINS, MICHAEL",
    "owner2": "ELLIOTT, JULIA",
    "current_taxes": 14405.63,
    "new_taxes_no_override": 15027.95,
    "override_total_1": 15454.36,
    "override_increase_1": 426.41
  },
  {
    "#": "75 Winchester St, Unit 403 G2-17 (079-06-11)",
    "$": 1521700,
    "address": "75 Winchester St, Unit 403 G2-17",
    "parcel_id": "079-06-11",
    "owner1": "SUCOFF TR, ANDREW C",
    "owner2": "C/O GOODWIN PROCTER LLP",
    "current_taxes": 15582.21,
    "new_taxes_no_override": 16255.36,
    "override_total_1": 16716.59,
    "override_increase_1": 461.23
  },
  {
    "#": "76 Winchester St (084-26-00)",
    "$": 1982000,
    "address": "76 Winchester St",
    "parcel_id": "084-26-00",
    "owner1": "SANDER TRS, DANIEL & SARANNA & MARCEL & SARAH E",
    "owner2": "",
    "current_taxes": 16660.75,
    "new_taxes_no_override": 17380.49,
    "override_total_1": 17873.65,
    "override_increase_1": 493.16
  },
  {
    "#": "80 Winchester St (084-25-00)",
    "$": 1885800,
    "address": "80 Winchester St",
    "parcel_id": "084-25-00",
    "owner1": "ATHERTON LLC",
    "owner2": "",
    "current_taxes": 15675.66,
    "new_taxes_no_override": 16352.85,
    "override_total_1": 16816.85,
    "override_increase_1": 464.0
  },
  {
    "#": "81 Winchester St (079-07-08)",
    "$": 11364100,
    "address": "81 Winchester St",
    "parcel_id": "079-07-08",
    "owner1": "COHEN ET AL TRS, HARRY A",
    "owner2": "",
    "current_taxes": 118719.88,
    "new_taxes_no_override": 123848.58,
    "override_total_1": 127362.69,
    "override_increase_1": 3514.11
  },
  {
    "#": "90 Winchester St (084-24-00)",
    "$": 2425800,
    "address": "90 Winchester St",
    "parcel_id": "084-24-00",
    "owner1": "GARGIULO, ANTONIO & ELISABETTA D",
    "owner2": "",
    "current_taxes": 24840.19,
    "new_taxes_no_override": 25913.29,
    "override_total_1": 26648.56,
    "override_increase_1": 735.27
  },
  {
    "#": "93 Winchester St (079-09-00)",
    "$": 16531400,
    "address": "93 Winchester St",
    "parcel_id": "079-09-00",
    "owner1": "TOWN OF BROOKLINE",
    "owner2": "C/O SENIOR CENTER",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "94 Winchester St (084-23-00)",
    "$": 2189700,
    "address": "94 Winchester St",
    "parcel_id": "084-23-00",
    "owner1": "ZOLL TRS, STANLEY & ROBIN G",
    "owner2": "",
    "current_taxes": 22422.53,
    "new_taxes_no_override": 23391.18,
    "override_total_1": 24054.89,
    "override_increase_1": 663.71
  },
  {
    "#": "99 Winchester St, Unit 1 & G7 G8 (079-10-01)",
    "$": 2482100,
    "address": "99 Winchester St, Unit 1 & G7 G8",
    "parcel_id": "079-10-01",
    "owner1": "SIMANSKY, HAROLD M & LINDA MANN",
    "owner2": "",
    "current_taxes": 21781.77,
    "new_taxes_no_override": 22722.74,
    "override_total_1": 23367.48,
    "override_increase_1": 644.74
  },
  {
    "#": "99 Winchester St, Unit 2&G1 G2 (079-10-02)",
    "$": 2122300,
    "address": "99 Winchester St, Unit 2&G1 G2",
    "parcel_id": "079-10-02",
    "owner1": "TATE TRS, STEPHEN JEFFERSON",
    "owner2": "DONG , QING",
    "current_taxes": 18097.42,
    "new_taxes_no_override": 18879.23,
    "override_total_1": 19414.91,
    "override_increase_1": 535.68
  },
  {
    "#": "99 Winchester St, Unit 3 (079-10-03)",
    "$": 2356500,
    "address": "99 Winchester St, Unit 3",
    "parcel_id": "079-10-03",
    "owner1": "RAIDE TRS, ALIDA HARB",
    "owner2": "ZOGHBI, ELIAS",
    "current_taxes": 24130.56,
    "new_taxes_no_override": 25173.0,
    "override_total_1": 25887.26,
    "override_increase_1": 714.26
  },
  {
    "#": "99 Winchester St, Unit 4 (079-10-04)",
    "$": 2586500,
    "address": "99 Winchester St, Unit 4",
    "parcel_id": "079-10-04",
    "owner1": "POHLMANN, SHARON & DAVID",
    "owner2": "",
    "current_taxes": 22850.83,
    "new_taxes_no_override": 23837.99,
    "override_total_1": 24514.37,
    "override_increase_1": 676.38
  },
  {
    "#": "99 Winchester St, Unit 5 (079-10-05)",
    "$": 2826900,
    "address": "99 Winchester St, Unit 5",
    "parcel_id": "079-10-05",
    "owner1": "FARBER, MARK A",
    "owner2": "KATZ, SHERRYI  L",
    "current_taxes": 25312.52,
    "new_taxes_no_override": 26406.02,
    "override_total_1": 27155.27,
    "override_increase_1": 749.25
  },
  {
    "#": "100 Winchester St, Unit 1 (084-22-01)",
    "$": 1137700,
    "address": "100 Winchester St, Unit 1",
    "parcel_id": "084-22-01",
    "owner1": "MORAN, ROBERT E & MARELLEN",
    "owner2": "",
    "current_taxes": 8015.11,
    "new_taxes_no_override": 8361.36,
    "override_total_1": 8598.61,
    "override_increase_1": 237.25
  },
  {
    "#": "100 Winchester St, Unit 2 (084-22-02)",
    "$": 1760300,
    "address": "100 Winchester St, Unit 2",
    "parcel_id": "084-22-02",
    "owner1": "WAHL, KATHERINE M",
    "owner2": "JONES, THEODORE W",
    "current_taxes": 14390.54,
    "new_taxes_no_override": 15012.21,
    "override_total_1": 15438.17,
    "override_increase_1": 425.96
  },
  {
    "#": "103 Winchester St, Unit 1 (079-11-03)",
    "$": 1373400,
    "address": "103 Winchester St, Unit 1",
    "parcel_id": "079-11-03",
    "owner1": "SIRAJ, YASMIN",
    "owner2": "BOOTHROYD, PETER EDWARD",
    "current_taxes": 14063.62,
    "new_taxes_no_override": 14671.17,
    "override_total_1": 15087.45,
    "override_increase_1": 416.28
  },
  {
    "#": "103 Winchester St, Unit 2 (079-11-01)",
    "$": 1270200,
    "address": "103 Winchester St, Unit 2",
    "parcel_id": "079-11-01",
    "owner1": "BELLOU, ABDELOUAHAB & MOUFIDA",
    "owner2": "",
    "current_taxes": 9371.91,
    "new_taxes_no_override": 9776.78,
    "override_total_1": 10054.19,
    "override_increase_1": 277.41
  },
  {
    "#": "103 Winchester St, Unit 3 (079-11-02)",
    "$": 1337900,
    "address": "103 Winchester St, Unit 3",
    "parcel_id": "079-11-02",
    "owner1": "GINER, JOSE",
    "owner2": "",
    "current_taxes": 13700.1,
    "new_taxes_no_override": 14291.94,
    "override_total_1": 14697.47,
    "override_increase_1": 405.52
  },
  {
    "#": "104 Winchester St, Unit 1 (084-21-03)",
    "$": 1071000,
    "address": "104 Winchester St, Unit 1",
    "parcel_id": "084-21-03",
    "owner1": "COTE, KELLY A & JOSEPH E JR",
    "owner2": "",
    "current_taxes": 7332.11,
    "new_taxes_no_override": 7648.86,
    "override_total_1": 7865.89,
    "override_increase_1": 217.03
  },
  {
    "#": "105 Winchester St, Unit 1 (079-12-03)",
    "$": 932200,
    "address": "105 Winchester St, Unit 1",
    "parcel_id": "079-12-03",
    "owner1": "SCHIFF TR, JILL B",
    "owner2": "",
    "current_taxes": 5910.79,
    "new_taxes_no_override": 6166.14,
    "override_total_1": 6341.1,
    "override_increase_1": 174.96
  },
  {
    "#": "105 Winchester St, Unit 2 & P12 (079-12-01)",
    "$": 1248600,
    "address": "105 Winchester St, Unit 2 & P12",
    "parcel_id": "079-12-01",
    "owner1": "WIGMORE, HEATHER",
    "owner2": "MILLER, ERIC J",
    "current_taxes": 9150.73,
    "new_taxes_no_override": 9546.04,
    "override_total_1": 9816.9,
    "override_increase_1": 270.86
  },
  {
    "#": "105 Winchester St, Unit 3 (079-12-02)",
    "$": 1577400,
    "address": "105 Winchester St, Unit 3",
    "parcel_id": "079-12-02",
    "owner1": "IACUS, STEFANO",
    "owner2": "CARPI, TIZIANA",
    "current_taxes": 16152.58,
    "new_taxes_no_override": 16850.37,
    "override_total_1": 17328.49,
    "override_increase_1": 478.12
  },
  {
    "#": "106 Winchester St, Unit 2 (084-21-01)",
    "$": 791200,
    "address": "106 Winchester St, Unit 2",
    "parcel_id": "084-21-01",
    "owner1": "GWOZDZ, ANDREW & GRACE",
    "owner2": "",
    "current_taxes": 4466.95,
    "new_taxes_no_override": 4659.92,
    "override_total_1": 4792.14,
    "override_increase_1": 132.22
  },
  {
    "#": "106 Winchester St, Unit 3 (084-21-02)",
    "$": 880900,
    "address": "106 Winchester St, Unit 3",
    "parcel_id": "084-21-02",
    "owner1": "QIAN, BO",
    "owner2": "CHEN, JIFENG",
    "current_taxes": 5385.48,
    "new_taxes_no_override": 5618.13,
    "override_total_1": 5777.54,
    "override_increase_1": 159.41
  },
  {
    "#": "109 Winchester St, Unit 1 (079-13-09)",
    "$": 521200,
    "address": "109 Winchester St, Unit 1",
    "parcel_id": "079-13-09",
    "owner1": "MANDON, POOJA & ISHA",
    "owner2": "",
    "current_taxes": 5337.09,
    "new_taxes_no_override": 5567.65,
    "override_total_1": 5725.63,
    "override_increase_1": 157.98
  },
  {
    "#": "109 Winchester St, Unit 2 (079-13-01)",
    "$": 519600,
    "address": "109 Winchester St, Unit 2",
    "parcel_id": "079-13-01",
    "owner1": "WANG, I-LING",
    "owner2": "",
    "current_taxes": 5320.7,
    "new_taxes_no_override": 5550.55,
    "override_total_1": 5708.05,
    "override_increase_1": 157.49
  },
  {
    "#": "109 Winchester St, Unit 3 (079-13-02)",
    "$": 444600,
    "address": "109 Winchester St, Unit 3",
    "parcel_id": "079-13-02",
    "owner1": "LOUX TR, GEORGE E III",
    "owner2": "",
    "current_taxes": 4552.7,
    "new_taxes_no_override": 4749.38,
    "override_total_1": 4884.14,
    "override_increase_1": 134.76
  },
  {
    "#": "109 Winchester St, Unit 4 (079-13-03)",
    "$": 595000,
    "address": "109 Winchester St, Unit 4",
    "parcel_id": "079-13-03",
    "owner1": "DIAMOND, MIRIAM R",
    "owner2": "",
    "current_taxes": 2457.87,
    "new_taxes_no_override": 2564.05,
    "override_total_1": 2636.8,
    "override_increase_1": 72.75
  },
  {
    "#": "109 Winchester St, Unit 5 (079-13-04)",
    "$": 557500,
    "address": "109 Winchester St, Unit 5",
    "parcel_id": "079-13-04",
    "owner1": "GUGLIELMO, JEANNE",
    "owner2": "",
    "current_taxes": 2073.87,
    "new_taxes_no_override": 2163.46,
    "override_total_1": 2224.85,
    "override_increase_1": 61.39
  },
  {
    "#": "109 Winchester St, Unit 6 (079-13-05)",
    "$": 456500,
    "address": "109 Winchester St, Unit 6",
    "parcel_id": "079-13-05",
    "owner1": "CUI, LEI",
    "owner2": "CHEN, XIAO TIAN",
    "current_taxes": 4674.56,
    "new_taxes_no_override": 4876.5,
    "override_total_1": 5014.87,
    "override_increase_1": 138.37
  },
  {
    "#": "109 Winchester St, Unit 7 (079-13-06)",
    "$": 615100,
    "address": "109 Winchester St, Unit 7",
    "parcel_id": "079-13-06",
    "owner1": "DEVORE, ALLISON",
    "owner2": "",
    "current_taxes": 6298.62,
    "new_taxes_no_override": 6570.72,
    "override_total_1": 6757.16,
    "override_increase_1": 186.44
  },
  {
    "#": "109 Winchester St, Unit 8 (079-13-07)",
    "$": 572800,
    "address": "109 Winchester St, Unit 8",
    "parcel_id": "079-13-07",
    "owner1": "MAURANO, ANDREA",
    "owner2": "DE VITO, ROBERTA",
    "current_taxes": 5865.47,
    "new_taxes_no_override": 6118.86,
    "override_total_1": 6292.48,
    "override_increase_1": 173.62
  },
  {
    "#": "109 Winchester St, Unit 9 (079-13-08)",
    "$": 456500,
    "address": "109 Winchester St, Unit 9",
    "parcel_id": "079-13-08",
    "owner1": "BECHARD, BETH",
    "owner2": "",
    "current_taxes": 1039.63,
    "new_taxes_no_override": 1084.54,
    "override_total_1": 1115.32,
    "override_increase_1": 30.77
  },
  {
    "#": "110 Winchester St (084-20-00)",
    "$": 2209400,
    "address": "110 Winchester St",
    "parcel_id": "084-20-00",
    "owner1": "BROOKLINE PROSPERITY REALTY LLC",
    "owner2": "C/O DANNIN MANAGEMENT CORP",
    "current_taxes": 22624.26,
    "new_taxes_no_override": 23601.63,
    "override_total_1": 24271.31,
    "override_increase_1": 669.68
  },
  {
    "#": "118 Winchester St (085-30-00)",
    "$": 2579700,
    "address": "118 Winchester St",
    "parcel_id": "085-30-00",
    "owner1": "BRASS, ERIC A",
    "owner2": "",
    "current_taxes": 22781.19,
    "new_taxes_no_override": 23765.34,
    "override_total_1": 24439.66,
    "override_increase_1": 674.32
  },
  {
    "#": "122 Winchester St, Unit 1 & G1 P1 (085-29-01)",
    "$": 1944200,
    "address": "122 Winchester St, Unit 1 & G1 P1",
    "parcel_id": "085-29-01",
    "owner1": "KLEEMAN, ANDREW & SUZANNE",
    "owner2": "",
    "current_taxes": 19908.61,
    "new_taxes_no_override": 20768.66,
    "override_total_1": 21357.96,
    "override_increase_1": 589.29
  },
  {
    "#": "122 Winchester St, Unit 2 & G2  P2 (085-29-02)",
    "$": 1990400,
    "address": "122 Winchester St, Unit 2 & G2  P2",
    "parcel_id": "085-29-02",
    "owner1": "FANG, ZI",
    "owner2": "QIN, YILING",
    "current_taxes": 16746.76,
    "new_taxes_no_override": 17470.22,
    "override_total_1": 17965.92,
    "override_increase_1": 495.7
  },
  {
    "#": "125 Winchester St (077-24-00)",
    "$": 2529500,
    "address": "125 Winchester St",
    "parcel_id": "077-24-00",
    "owner1": "GLASS LIFE ESTATE, CATHERINE E",
    "owner2": "",
    "current_taxes": 22267.15,
    "new_taxes_no_override": 23229.09,
    "override_total_1": 23888.2,
    "override_increase_1": 659.11
  },
  {
    "#": "126 Winchester St (085-28-00)",
    "$": 2350700,
    "address": "126 Winchester St",
    "parcel_id": "085-28-00",
    "owner1": "RAHKLIN, ALEXANDER & MARINA",
    "owner2": "",
    "current_taxes": 24071.17,
    "new_taxes_no_override": 25111.04,
    "override_total_1": 25823.55,
    "override_increase_1": 712.51
  },
  {
    "#": "130 Winchester St (085-27-00)",
    "$": 2282700,
    "address": "130 Winchester St",
    "parcel_id": "085-27-00",
    "owner1": "ERICKSON TR, SUSAN E",
    "owner2": "",
    "current_taxes": 19739.91,
    "new_taxes_no_override": 20592.67,
    "override_total_1": 21176.98,
    "override_increase_1": 584.3
  },
  {
    "#": "131 Winchester St, Unit 131 (077-01-03)",
    "$": 2208700,
    "address": "131 Winchester St, Unit 131",
    "parcel_id": "077-01-03",
    "owner1": "SAMPSON, MATHEW & NICOLE",
    "owner2": "",
    "current_taxes": 22617.09,
    "new_taxes_no_override": 23594.15,
    "override_total_1": 24263.61,
    "override_increase_1": 669.47
  },
  {
    "#": "133 Winchester St, Unit 133 (077-01-02)",
    "$": 1821100,
    "address": "133 Winchester St, Unit 133",
    "parcel_id": "077-01-02",
    "owner1": "ZHANG, KAN",
    "owner2": "FENG, FANG",
    "current_taxes": 18648.06,
    "new_taxes_no_override": 19453.66,
    "override_total_1": 20005.64,
    "override_increase_1": 551.98
  },
  {
    "#": "134 Winchester St (085-26-00)",
    "$": 2417100,
    "address": "134 Winchester St",
    "parcel_id": "085-26-00",
    "owner1": "WEINKLE, BERTHA R",
    "owner2": "",
    "current_taxes": 21116.17,
    "new_taxes_no_override": 22028.39,
    "override_total_1": 22653.43,
    "override_increase_1": 625.04
  },
  {
    "#": "138 Winchester St, Unit 1 (085-25-01)",
    "$": 2316200,
    "address": "138 Winchester St, Unit 1",
    "parcel_id": "085-25-01",
    "owner1": "GRIFFIN, RACHEL",
    "owner2": "",
    "current_taxes": 20082.95,
    "new_taxes_no_override": 20950.53,
    "override_total_1": 21544.99,
    "override_increase_1": 594.46
  },
  {
    "#": "138 Winchester St, Unit 2 (085-25-02)",
    "$": 2257700,
    "address": "138 Winchester St, Unit 2",
    "parcel_id": "085-25-02",
    "owner1": "IHLBERG, LEO H M & VIRPI E",
    "owner2": "",
    "current_taxes": 19483.91,
    "new_taxes_no_override": 20325.61,
    "override_total_1": 20902.34,
    "override_increase_1": 576.72
  },
  {
    "#": "143 Winchester St (076-24-00)",
    "$": 2650500,
    "address": "143 Winchester St",
    "parcel_id": "076-24-00",
    "owner1": "WHITE, GEORGE ABBOTT",
    "owner2": "",
    "current_taxes": 23506.19,
    "new_taxes_no_override": 24521.66,
    "override_total_1": 25217.44,
    "override_increase_1": 695.78
  },
  {
    "#": "144 Winchester St (085-24-00)",
    "$": 2778000,
    "address": "144 Winchester St",
    "parcel_id": "085-24-00",
    "owner1": "SOO HOO, CHUCK & KWAI LAN",
    "owner2": "",
    "current_taxes": 24811.79,
    "new_taxes_no_override": 25883.66,
    "override_total_1": 26618.09,
    "override_increase_1": 734.43
  },
  {
    "#": "147 Winchester St, Unit 1 (076-01-01)",
    "$": 1085800,
    "address": "147 Winchester St, Unit 1",
    "parcel_id": "076-01-01",
    "owner1": "DOKOV, BISSER I",
    "owner2": "PRIMOVA, BORIANA A",
    "current_taxes": 7483.66,
    "new_taxes_no_override": 7806.95,
    "override_total_1": 8028.47,
    "override_increase_1": 221.52
  },
  {
    "#": "147 Winchester St, Unit 2 (076-01-02)",
    "$": 1597400,
    "address": "147 Winchester St, Unit 2",
    "parcel_id": "076-01-02",
    "owner1": "HELLMAN, DAVID E & ARIELLA S",
    "owner2": "",
    "current_taxes": 12722.44,
    "new_taxes_no_override": 13272.05,
    "override_total_1": 13648.63,
    "override_increase_1": 376.58
  },
  {
    "#": "148 Winchester St (085-23-00)",
    "$": 2355500,
    "address": "148 Winchester St",
    "parcel_id": "085-23-00",
    "owner1": "WONG TRS, LAP BOON & WAI LING",
    "owner2": "",
    "current_taxes": 20485.39,
    "new_taxes_no_override": 21370.36,
    "override_total_1": 21976.73,
    "override_increase_1": 606.37
  },
  {
    "#": "152 Winchester St (085-22-00)",
    "$": 3143300,
    "address": "152 Winchester St",
    "parcel_id": "085-22-00",
    "owner1": "HARVARD REALTY ADVISORS LLC",
    "owner2": "",
    "current_taxes": 32187.39,
    "new_taxes_no_override": 33577.89,
    "override_total_1": 34530.63,
    "override_increase_1": 952.75
  },
  {
    "#": "156 Winchester St (085-21-00)",
    "$": 2456400,
    "address": "156 Winchester St",
    "parcel_id": "085-21-00",
    "owner1": "MEILL, AUGUSTA",
    "owner2": "",
    "current_taxes": 21518.6,
    "new_taxes_no_override": 22448.2,
    "override_total_1": 23085.15,
    "override_increase_1": 636.95
  },
  {
    "#": "164 Winchester St (085-20-00)",
    "$": 2614700,
    "address": "164 Winchester St",
    "parcel_id": "085-20-00",
    "owner1": "REILLY, SARAH ELIZABETH & JOSEPH MICHAEL",
    "owner2": "",
    "current_taxes": 23139.59,
    "new_taxes_no_override": 24139.22,
    "override_total_1": 24824.15,
    "override_increase_1": 684.93
  },
  {
    "#": "165 Winchester St, Unit 1 (075-15-01)",
    "$": 2367800,
    "address": "165 Winchester St, Unit 1",
    "parcel_id": "075-15-01",
    "owner1": "MADDAH TRS, SEYYEDEH MAHNAZ",
    "owner2": "KHAKIFIROOZ, ALI",
    "current_taxes": 20611.34,
    "new_taxes_no_override": 21501.75,
    "override_total_1": 22111.85,
    "override_increase_1": 610.1
  },
  {
    "#": "165 Winchester St, Unit 2 (075-15-02)",
    "$": 2580100,
    "address": "165 Winchester St, Unit 2",
    "parcel_id": "075-15-02",
    "owner1": "LEVY, DAN & GABRIELENA ALCALA",
    "owner2": "",
    "current_taxes": 22785.29,
    "new_taxes_no_override": 23769.61,
    "override_total_1": 24444.06,
    "override_increase_1": 674.44
  },
  {
    "#": "167 Winchester St (075-16-00)",
    "$": 2170000,
    "address": "167 Winchester St",
    "parcel_id": "075-16-00",
    "owner1": "GESZPENC TR, LEON",
    "owner2": "",
    "current_taxes": 22220.8,
    "new_taxes_no_override": 23180.74,
    "override_total_1": 23838.47,
    "override_increase_1": 657.74
  },
  {
    "#": "168 Winchester St, Unit 1 & P1 (085-19-01)",
    "$": 1193100,
    "address": "168 Winchester St, Unit 1 & P1",
    "parcel_id": "085-19-01",
    "owner1": "SEIDLE, RUSSELL",
    "owner2": "HADDAD, DENA",
    "current_taxes": 8582.41,
    "new_taxes_no_override": 8953.17,
    "override_total_1": 9207.21,
    "override_increase_1": 254.04
  },
  {
    "#": "170 Winchester St, Unit 2 (085-19-02)",
    "$": 1367600,
    "address": "170 Winchester St, Unit 2",
    "parcel_id": "085-19-02",
    "owner1": "STANGENBERG, LARS & ANNA SCHINZEL",
    "owner2": "",
    "current_taxes": 14004.22,
    "new_taxes_no_override": 14609.2,
    "override_total_1": 15023.73,
    "override_increase_1": 414.52
  },
  {
    "#": "173 Winchester St, Unit 1 & P3-P4 (075-17-01)",
    "$": 1315900,
    "address": "173 Winchester St, Unit 1 & P3-P4",
    "parcel_id": "075-17-01",
    "owner1": "SANIEOFF, SYROOS",
    "owner2": "",
    "current_taxes": 13474.82,
    "new_taxes_no_override": 14056.93,
    "override_total_1": 14455.79,
    "override_increase_1": 398.85
  },
  {
    "#": "173 Winchester St, Unit 2 (075-17-02)",
    "$": 1276400,
    "address": "173 Winchester St, Unit 2",
    "parcel_id": "075-17-02",
    "owner1": "SENDOR, DAVID ELIYAHU",
    "owner2": "ISRAEL, REBECCA",
    "current_taxes": 9435.4,
    "new_taxes_no_override": 9843.01,
    "override_total_1": 10122.3,
    "override_increase_1": 279.29
  },
  {
    "#": "174 Winchester St (085-18-00)",
    "$": 2906800,
    "address": "174 Winchester St",
    "parcel_id": "085-18-00",
    "owner1": "BROADRUP TRS, GARRETT C",
    "owner2": "HUANG, JENNIFER",
    "current_taxes": 26130.7,
    "new_taxes_no_override": 27259.55,
    "override_total_1": 28033.01,
    "override_increase_1": 773.47
  },
  {
    "#": "177 Winchester St (075-18-00)",
    "$": 2672600,
    "address": "177 Winchester St",
    "parcel_id": "075-18-00",
    "owner1": "LANG, KEVIN E",
    "owner2": "KAHN, SHULAMIT B",
    "current_taxes": 23732.49,
    "new_taxes_no_override": 24757.73,
    "override_total_1": 25460.22,
    "override_increase_1": 702.48
  },
  {
    "#": "180 Winchester St (085-17-00)",
    "$": 2702400,
    "address": "180 Winchester St",
    "parcel_id": "085-17-00",
    "owner1": "CUBELL TRS, NORMAN & CLARICE M",
    "owner2": "",
    "current_taxes": 24037.64,
    "new_taxes_no_override": 25076.07,
    "override_total_1": 25787.58,
    "override_increase_1": 711.51
  },
  {
    "#": "183 Winchester St (075-19-00)",
    "$": 2299200,
    "address": "183 Winchester St",
    "parcel_id": "075-19-00",
    "owner1": "JOZWICKI LIFE ESTATE, BARR A & JOYCE C",
    "owner2": "",
    "current_taxes": 19908.87,
    "new_taxes_no_override": 20768.93,
    "override_total_1": 21358.24,
    "override_increase_1": 589.3
  },
  {
    "#": "184 Winchester St (085-16-00)",
    "$": 2688300,
    "address": "184 Winchester St",
    "parcel_id": "085-16-00",
    "owner1": "RAHME, LAURENCE",
    "owner2": "",
    "current_taxes": 23893.26,
    "new_taxes_no_override": 24925.45,
    "override_total_1": 25632.69,
    "override_increase_1": 707.24
  },
  {
    "#": "187 Winchester St (075-20-00)",
    "$": 2778100,
    "address": "187 Winchester St",
    "parcel_id": "075-20-00",
    "owner1": "HUMMEL, GREGORY",
    "owner2": "",
    "current_taxes": 24812.81,
    "new_taxes_no_override": 25884.72,
    "override_total_1": 26619.18,
    "override_increase_1": 734.46
  },
  {
    "#": "188 Winchester St, Unit 1 (085-15-01)",
    "$": 1633600,
    "address": "188 Winchester St, Unit 1",
    "parcel_id": "085-15-01",
    "owner1": "LOUI, PSYCHE",
    "owner2": "WEST, RICHARD H",
    "current_taxes": 16728.06,
    "new_taxes_no_override": 17450.71,
    "override_total_1": 17945.86,
    "override_increase_1": 495.15
  },
  {
    "#": "188 Winchester St, Unit 2 (085-15-02)",
    "$": 1665300,
    "address": "188 Winchester St, Unit 2",
    "parcel_id": "085-15-02",
    "owner1": "LOUI, PSYCHE",
    "owner2": "WEST, RICHARD H",
    "current_taxes": 13417.74,
    "new_taxes_no_override": 13997.39,
    "override_total_1": 14394.55,
    "override_increase_1": 397.17
  },
  {
    "#": "192 Winchester St, Unit 1 (085-14-01)",
    "$": 1712700,
    "address": "192 Winchester St, Unit 1",
    "parcel_id": "085-14-01",
    "owner1": "ZHELEZNYAK TRS, IGOR",
    "owner2": "KANEVSKY, ANNA",
    "current_taxes": 17538.05,
    "new_taxes_no_override": 18295.69,
    "override_total_1": 18814.82,
    "override_increase_1": 519.13
  },
  {
    "#": "192 Winchester St, Unit 2 (085-14-02)",
    "$": 1541700,
    "address": "192 Winchester St, Unit 2",
    "parcel_id": "085-14-02",
    "owner1": "CROWLEY, SARAH & MARTHA J",
    "owner2": "",
    "current_taxes": 12152.07,
    "new_taxes_no_override": 12677.04,
    "override_total_1": 13036.74,
    "override_increase_1": 359.7
  },
  {
    "#": "193 Winchester St (075-21-00)",
    "$": 3253100,
    "address": "193 Winchester St",
    "parcel_id": "075-21-00",
    "owner1": "YEE, TRS, JOSEPH K & DAVID Y",
    "owner2": "",
    "current_taxes": 29676.81,
    "new_taxes_no_override": 30958.85,
    "override_total_1": 31837.28,
    "override_increase_1": 878.43
  },
  {
    "#": "196 Winchester St (085-13-01)",
    "$": 2237400,
    "address": "196 Winchester St",
    "parcel_id": "085-13-01",
    "owner1": "LEM, LAPSHUN CHOW",
    "owner2": "",
    "current_taxes": 19276.04,
    "new_taxes_no_override": 20108.76,
    "override_total_1": 20679.34,
    "override_increase_1": 570.57
  },
  {
    "#": "197 Winchester St (075-22-00)",
    "$": 3000100,
    "address": "197 Winchester St",
    "parcel_id": "075-22-00",
    "owner1": "197-199 WINCHESTER STREET HOLDINGS LLC",
    "owner2": "",
    "current_taxes": 30721.02,
    "new_taxes_no_override": 32048.17,
    "override_total_1": 32957.51,
    "override_increase_1": 909.34
  },
  {
    "#": "200 Winchester St, Unit 1 G4 P5-6 (085-13-02)",
    "$": 1801100,
    "address": "200 Winchester St, Unit 1 G4 P5-6",
    "parcel_id": "085-13-02",
    "owner1": "FRENKEL, RAN AVRAHAM & EFRAT",
    "owner2": "",
    "current_taxes": 14808.33,
    "new_taxes_no_override": 15448.05,
    "override_total_1": 15886.38,
    "override_increase_1": 438.33
  },
  {
    "#": "200 Winchester St, Unit 2 & P1-2-3 (085-13-03)",
    "$": 1893600,
    "address": "200 Winchester St, Unit 2 & P1-2-3",
    "parcel_id": "085-13-03",
    "owner1": "COOKE, MICHAEL T & DONNA",
    "owner2": "",
    "current_taxes": 15755.53,
    "new_taxes_no_override": 16436.17,
    "override_total_1": 16902.53,
    "override_increase_1": 466.36
  },
  {
    "#": "201 Winchester St, Unit 201 (075-23-01)",
    "$": 1602600,
    "address": "201 Winchester St, Unit 201",
    "parcel_id": "075-23-01",
    "owner1": "SVENSTRUP, NIELS & JIA",
    "owner2": "",
    "current_taxes": 12775.69,
    "new_taxes_no_override": 13327.6,
    "override_total_1": 13705.76,
    "override_increase_1": 378.16
  },
  {
    "#": "203 Winchester St, Unit 203 (075-23-02)",
    "$": 1590200,
    "address": "203 Winchester St, Unit 203",
    "parcel_id": "075-23-02",
    "owner1": "KANDALAFT, FAREED",
    "owner2": "SABA, HALA",
    "current_taxes": 16283.65,
    "new_taxes_no_override": 16987.1,
    "override_total_1": 17469.1,
    "override_increase_1": 482.0
  },
  {
    "#": "206 Winchester St (085-12-00)",
    "$": 2642000,
    "address": "206 Winchester St",
    "parcel_id": "085-12-00",
    "owner1": "CLEVENGER, JAZAHN",
    "owner2": "CHI, AN",
    "current_taxes": 23419.15,
    "new_taxes_no_override": 24430.86,
    "override_total_1": 25124.06,
    "override_increase_1": 693.21
  },
  {
    "#": "207 Winchester St, Unit A (075-24-02)",
    "$": 1296700,
    "address": "207 Winchester St, Unit A",
    "parcel_id": "075-24-02",
    "owner1": "ADLER, LIBBY S",
    "owner2": "",
    "current_taxes": 9643.27,
    "new_taxes_no_override": 10059.86,
    "override_total_1": 10345.3,
    "override_increase_1": 285.44
  },
  {
    "#": "207 Winchester St, Unit B (075-24-01)",
    "$": 1616000,
    "address": "207 Winchester St, Unit B",
    "parcel_id": "075-24-01",
    "owner1": "RUGGERI , LUKE M",
    "owner2": "WOOD, LIANNA F & ANITA J",
    "current_taxes": 12912.91,
    "new_taxes_no_override": 13470.75,
    "override_total_1": 13852.97,
    "override_increase_1": 382.22
  },
  {
    "#": "212 Winchester St, Unit 1 (085-11-01)",
    "$": 2045200,
    "address": "212 Winchester St, Unit 1",
    "parcel_id": "085-11-01",
    "owner1": "GATES, STEPHANIE T",
    "owner2": "SIMCOE, TIMOTHY S",
    "current_taxes": 20942.85,
    "new_taxes_no_override": 21847.58,
    "override_total_1": 22467.49,
    "override_increase_1": 619.91
  },
  {
    "#": "212 Winchester St, Unit 2 (085-11-02)",
    "$": 2279500,
    "address": "212 Winchester St, Unit 2",
    "parcel_id": "085-11-02",
    "owner1": "AUPERIN, THIERRY",
    "owner2": "",
    "current_taxes": 19707.15,
    "new_taxes_no_override": 20558.5,
    "override_total_1": 21141.83,
    "override_increase_1": 583.33
  },
  {
    "#": "213 Winchester St, Unit 1 (075-25-01)",
    "$": 1628300,
    "address": "213 Winchester St, Unit 1",
    "parcel_id": "075-25-01",
    "owner1": "JAGODNIK LIFE ESTATE, BARRY N & JUNE S",
    "owner2": "",
    "current_taxes": 13038.86,
    "new_taxes_no_override": 13602.14,
    "override_total_1": 13988.09,
    "override_increase_1": 385.95
  },
  {
    "#": "213 Winchester St, Unit 2 (075-25-02)",
    "$": 1598000,
    "address": "213 Winchester St, Unit 2",
    "parcel_id": "075-25-02",
    "owner1": "GRIFFIN, ROBERT V JR & NICOLA",
    "owner2": "",
    "current_taxes": 12728.59,
    "new_taxes_no_override": 13278.47,
    "override_total_1": 13655.23,
    "override_increase_1": 376.77
  },
  {
    "#": "216 Winchester St, Unit 1 (085-10-01)",
    "$": 1594900,
    "address": "216 Winchester St, Unit 1",
    "parcel_id": "085-10-01",
    "owner1": "SCHACHTER, JOHN",
    "owner2": "WERGLAND, KARYN G",
    "current_taxes": 12696.84,
    "new_taxes_no_override": 13245.34,
    "override_total_1": 13621.17,
    "override_increase_1": 375.83
  },
  {
    "#": "216 Winchester St, Unit 2 (085-10-02)",
    "$": 1442300,
    "address": "216 Winchester St, Unit 2",
    "parcel_id": "085-10-02",
    "owner1": "ANCOWITZ, BRET",
    "owner2": "RUBIN, SHIRAH",
    "current_taxes": 11134.22,
    "new_taxes_no_override": 11615.22,
    "override_total_1": 11944.79,
    "override_increase_1": 329.57
  },
  {
    "#": "217 Winchester St, Unit 1 (075-26-01)",
    "$": 1581500,
    "address": "217 Winchester St, Unit 1",
    "parcel_id": "075-26-01",
    "owner1": "NEWMAN TR, LESLIE C",
    "owner2": "",
    "current_taxes": 16194.56,
    "new_taxes_no_override": 16894.16,
    "override_total_1": 17373.52,
    "override_increase_1": 479.36
  },
  {
    "#": "217 Winchester St, Unit 2 (075-26-02)",
    "$": 1541200,
    "address": "217 Winchester St, Unit 2",
    "parcel_id": "075-26-02",
    "owner1": "GROUSTRA, PETER A & ELLEN S",
    "owner2": "",
    "current_taxes": 12146.95,
    "new_taxes_no_override": 12671.7,
    "override_total_1": 13031.25,
    "override_increase_1": 359.55
  },
  {
    "#": "221 Winchester St (075-27-00)",
    "$": 2292200,
    "address": "221 Winchester St",
    "parcel_id": "075-27-00",
    "owner1": "BENET, MARIA E",
    "owner2": "",
    "current_taxes": 19837.19,
    "new_taxes_no_override": 20694.16,
    "override_total_1": 21281.34,
    "override_increase_1": 587.18
  },
  {
    "#": "222 Winchester St (085-09-00)",
    "$": 2940200,
    "address": "222 Winchester St",
    "parcel_id": "085-09-00",
    "owner1": "LI, YIN",
    "owner2": "LEE, HONGMEI",
    "current_taxes": 30107.65,
    "new_taxes_no_override": 31408.3,
    "override_total_1": 32299.49,
    "override_increase_1": 891.19
  },
  {
    "#": "226 Winchester St (085-08-00)",
    "$": 2091100,
    "address": "226 Winchester St",
    "parcel_id": "085-08-00",
    "owner1": "ROSS, CONSTANCE V & MARC A",
    "owner2": "",
    "current_taxes": 21412.86,
    "new_taxes_no_override": 22337.9,
    "override_total_1": 22971.72,
    "override_increase_1": 633.82
  },
  {
    "#": "227 Winchester St (075-28-00)",
    "$": 2193900,
    "address": "227 Winchester St",
    "parcel_id": "075-28-00",
    "owner1": "JOSHI 02446 LLC",
    "owner2": "",
    "current_taxes": 22465.54,
    "new_taxes_no_override": 23436.05,
    "override_total_1": 24101.03,
    "override_increase_1": 664.98
  },
  {
    "#": "228 Winchester St, Unit 1 (085-07-02)",
    "$": 1039500,
    "address": "228 Winchester St, Unit 1",
    "parcel_id": "085-07-02",
    "owner1": "BHANDARI, APOORVA",
    "owner2": "MEHTA, STUTI RUSHIKANT",
    "current_taxes": 7009.55,
    "new_taxes_no_override": 7312.36,
    "override_total_1": 7519.85,
    "override_increase_1": 207.48
  },
  {
    "#": "228 Winchester St, Unit 2 (085-07-01)",
    "$": 1144300,
    "address": "228 Winchester St, Unit 2",
    "parcel_id": "085-07-01",
    "owner1": "LEMIEUX, ANNETTE",
    "owner2": "",
    "current_taxes": 8082.7,
    "new_taxes_no_override": 8431.87,
    "override_total_1": 8671.12,
    "override_increase_1": 239.25
  },
  {
    "#": "231 Winchester St (075-29-00)",
    "$": 2114800,
    "address": "231 Winchester St",
    "parcel_id": "075-29-00",
    "owner1": "HUI, WEI-HUNG",
    "owner2": "LI, ALICE",
    "current_taxes": 21655.55,
    "new_taxes_no_override": 22591.07,
    "override_total_1": 23232.07,
    "override_increase_1": 641.0
  },
  {
    "#": "232 Winchester St, Unit 1 & Pk C-D (085-06-02)",
    "$": 1197300,
    "address": "232 Winchester St, Unit 1 & Pk C-D",
    "parcel_id": "085-06-02",
    "owner1": "MA, YUAN",
    "owner2": "YU, CHENYANG",
    "current_taxes": 8625.42,
    "new_taxes_no_override": 8998.04,
    "override_total_1": 9253.35,
    "override_increase_1": 255.31
  },
  {
    "#": "232 Winchester St, Unit 2 & Pk A-B (085-06-01)",
    "$": 1212500,
    "address": "232 Winchester St, Unit 2 & Pk A-B",
    "parcel_id": "085-06-01",
    "owner1": "DONNELLY, LYNN E",
    "owner2": "",
    "current_taxes": 8781.07,
    "new_taxes_no_override": 9160.41,
    "override_total_1": 9420.33,
    "override_increase_1": 259.92
  },
  {
    "#": "236 Winchester St (085-05-00)",
    "$": 2609000,
    "address": "236 Winchester St",
    "parcel_id": "085-05-00",
    "owner1": "MAH, HELEN",
    "owner2": "",
    "current_taxes": 26716.16,
    "new_taxes_no_override": 27870.3,
    "override_total_1": 28661.1,
    "override_increase_1": 790.8
  },
  {
    "#": "237 Winchester St, Unit 1 (075-30-01)",
    "$": 1144500,
    "address": "237 Winchester St, Unit 1",
    "parcel_id": "075-30-01",
    "owner1": "SIBDARI, SOHEIL",
    "owner2": "",
    "current_taxes": 11719.68,
    "new_taxes_no_override": 12225.97,
    "override_total_1": 12572.87,
    "override_increase_1": 346.9
  },
  {
    "#": "237 Winchester St, Unit 2 (075-30-02)",
    "$": 1681200,
    "address": "237 Winchester St, Unit 2",
    "parcel_id": "075-30-02",
    "owner1": "LECKER, STEWART H",
    "owner2": "FINN, SHARI",
    "current_taxes": 13580.55,
    "new_taxes_no_override": 14167.23,
    "override_total_1": 14569.21,
    "override_increase_1": 401.98
  },
  {
    "#": "240 Winchester St (085-04-00)",
    "$": 2243900,
    "address": "240 Winchester St",
    "parcel_id": "085-04-00",
    "owner1": "WONG, HOWARD",
    "owner2": "KIM, FAYE",
    "current_taxes": 19342.6,
    "new_taxes_no_override": 20178.2,
    "override_total_1": 20750.74,
    "override_increase_1": 572.54
  },
  {
    "#": "241 Winchester St (075-31-00)",
    "$": 2792300,
    "address": "241 Winchester St",
    "parcel_id": "075-31-00",
    "owner1": "LIM, JAMES KING",
    "owner2": "YONG, HUA",
    "current_taxes": 24958.22,
    "new_taxes_no_override": 26036.42,
    "override_total_1": 26775.18,
    "override_increase_1": 738.76
  },
  {
    "#": "244 Winchester St (085-03-00)",
    "$": 2204900,
    "address": "244 Winchester St",
    "parcel_id": "085-03-00",
    "owner1": "RAHMANI, NEJAT",
    "owner2": "",
    "current_taxes": 22578.18,
    "new_taxes_no_override": 23553.56,
    "override_total_1": 24221.87,
    "override_increase_1": 668.31
  },
  {
    "#": "247 Winchester St (075-32-00)",
    "$": 2440700,
    "address": "247 Winchester St",
    "parcel_id": "075-32-00",
    "owner1": "SPIROUNIS TR, VASSILIOS K",
    "owner2": "",
    "current_taxes": 24992.77,
    "new_taxes_no_override": 26072.46,
    "override_total_1": 26812.24,
    "override_increase_1": 739.79
  },
  {
    "#": "248 Winchester St, Unit 1 (085-02-05)",
    "$": 1352000,
    "address": "248 Winchester St, Unit 1",
    "parcel_id": "085-02-05",
    "owner1": "KENT, DALYA",
    "owner2": "",
    "current_taxes": 10209.55,
    "new_taxes_no_override": 10650.6,
    "override_total_1": 10952.81,
    "override_increase_1": 302.2
  },
  {
    "#": "248 Winchester St, Unit 2 (085-02-06)",
    "$": 1788000,
    "address": "248 Winchester St, Unit 2",
    "parcel_id": "085-02-06",
    "owner1": "WICHMANN, LISA M & RICHARD M",
    "owner2": "",
    "current_taxes": 14674.19,
    "new_taxes_no_override": 15308.12,
    "override_total_1": 15742.47,
    "override_increase_1": 434.36
  },
  {
    "#": "250 Winchester St, Unit 1 & G1-P1 (085-02-03)",
    "$": 2031600,
    "address": "250 Winchester St, Unit 1 & G1-P1",
    "parcel_id": "085-02-03",
    "owner1": "SMITH TRS, ANNETTE & GARY",
    "owner2": "",
    "current_taxes": 17168.65,
    "new_taxes_no_override": 17910.34,
    "override_total_1": 18418.53,
    "override_increase_1": 508.19
  },
  {
    "#": "250 Winchester St, Unit 2 & Gar 2 (085-02-04)",
    "$": 2023200,
    "address": "250 Winchester St, Unit 2 & Gar 2",
    "parcel_id": "085-02-04",
    "owner1": "GAITO, ROBERT C",
    "owner2": "CHAN, CHRISTINA A",
    "current_taxes": 17082.63,
    "new_taxes_no_override": 17820.6,
    "override_total_1": 18326.25,
    "override_increase_1": 505.65
  },
  {
    "#": "251 Winchester St (075-33-00)",
    "$": 2769900,
    "address": "251 Winchester St",
    "parcel_id": "075-33-00",
    "owner1": "LAM TRS, KIN CHUNG & CHRISTINE",
    "owner2": "",
    "current_taxes": 28363.78,
    "new_taxes_no_override": 29589.1,
    "override_total_1": 30428.66,
    "override_increase_1": 839.57
  },
  {
    "#": "255 Winchester St (075-34-00)",
    "$": 2721400,
    "address": "255 Winchester St",
    "parcel_id": "075-34-00",
    "owner1": "KHAZANOV, IGOR",
    "owner2": "SCHMIDT, SIMON",
    "current_taxes": 24232.2,
    "new_taxes_no_override": 25279.03,
    "override_total_1": 25996.3,
    "override_increase_1": 717.27
  },
  {
    "#": "260 Winchester St (085-01-01)",
    "$": 2908500,
    "address": "260 Winchester St",
    "parcel_id": "085-01-01",
    "owner1": "CHIANG, ALBERT K & KAREN Y",
    "owner2": "",
    "current_taxes": 26148.11,
    "new_taxes_no_override": 27277.71,
    "override_total_1": 28051.69,
    "override_increase_1": 773.98
  },
  {
    "#": "261 Winchester St (075-35-00)",
    "$": 1965800,
    "address": "261 Winchester St",
    "parcel_id": "075-35-00",
    "owner1": "JOHNSON, BRIAN D",
    "owner2": "WHITESEL, ELIZABETH A",
    "current_taxes": 16494.86,
    "new_taxes_no_override": 17207.44,
    "override_total_1": 17695.69,
    "override_increase_1": 488.25
  },
  {
    "#": "262 Winchester St (085-01-00)",
    "$": 3061500,
    "address": "262 Winchester St",
    "parcel_id": "085-01-00",
    "owner1": "STEVENS TRS, JACK H & ARLENE S",
    "owner2": "CAREY, JAMES E & RACHEL MORRIS",
    "current_taxes": 27714.83,
    "new_taxes_no_override": 28912.11,
    "override_total_1": 29732.47,
    "override_increase_1": 820.36
  },
  {
    "#": "7 Windsor Rd (099-06-00)",
    "$": 2620400,
    "address": "7 Windsor Rd",
    "parcel_id": "099-06-00",
    "owner1": "WEGLEIN, JONATHAN S",
    "owner2": "MAZAR, NORAH A",
    "current_taxes": 26832.9,
    "new_taxes_no_override": 27992.08,
    "override_total_1": 28786.34,
    "override_increase_1": 794.25
  },
  {
    "#": "15 Windsor Rd (099-07-00)",
    "$": 2605300,
    "address": "15 Windsor Rd",
    "parcel_id": "099-07-00",
    "owner1": "FELDGOISE, JEFFREY A",
    "owner2": "REMEN, DANNA M",
    "current_taxes": 23043.34,
    "new_taxes_no_override": 24038.81,
    "override_total_1": 24720.9,
    "override_increase_1": 682.08
  },
  {
    "#": "16 Windsor Rd (103-07-00)",
    "$": 2816400,
    "address": "16 Windsor Rd",
    "parcel_id": "103-07-00",
    "owner1": "POLANSKY, DEBORAH L",
    "owner2": "",
    "current_taxes": 25205.0,
    "new_taxes_no_override": 26293.86,
    "override_total_1": 27039.92,
    "override_increase_1": 746.07
  },
  {
    "#": "19 Windsor Rd (099-08-00)",
    "$": 1945000,
    "address": "19 Windsor Rd",
    "parcel_id": "099-08-00",
    "owner1": "GREENFIELD, ALLAN H",
    "owner2": "",
    "current_taxes": 16281.87,
    "new_taxes_no_override": 16985.25,
    "override_total_1": 17467.19,
    "override_increase_1": 481.94
  },
  {
    "#": "22 Windsor Rd (103-06-00)",
    "$": 2077500,
    "address": "22 Windsor Rd",
    "parcel_id": "103-06-00",
    "owner1": "COHEN, EVELYN E & GEORGE M & CHARLENE R",
    "owner2": "",
    "current_taxes": 17638.67,
    "new_taxes_no_override": 18400.66,
    "override_total_1": 18922.77,
    "override_increase_1": 522.1
  },
  {
    "#": "25 Windsor Rd (099-09-00)",
    "$": 2905800,
    "address": "25 Windsor Rd",
    "parcel_id": "099-09-00",
    "owner1": "WILLEY, DANIEL P & EMILY E",
    "owner2": "",
    "current_taxes": 26120.46,
    "new_taxes_no_override": 27248.86,
    "override_total_1": 28022.03,
    "override_increase_1": 773.17
  },
  {
    "#": "45 Windsor Rd (104-02-00)",
    "$": 2290200,
    "address": "45 Windsor Rd",
    "parcel_id": "104-02-00",
    "owner1": "GALLION , TAD S",
    "owner2": "SCHAEFER, KRISTEN G",
    "current_taxes": 19816.71,
    "new_taxes_no_override": 20672.79,
    "override_total_1": 21259.37,
    "override_increase_1": 586.57
  },
  {
    "#": "53 Windsor Rd (104-03-00)",
    "$": 2910400,
    "address": "53 Windsor Rd",
    "parcel_id": "104-03-00",
    "owner1": "CARCHIA, LEO & JOHN V",
    "owner2": "",
    "current_taxes": 26167.56,
    "new_taxes_no_override": 27298.0,
    "override_total_1": 28072.56,
    "override_increase_1": 774.56
  },
  {
    "#": "56 Windsor Rd (105-13-00)",
    "$": 2814600,
    "address": "56 Windsor Rd",
    "parcel_id": "105-13-00",
    "owner1": "FOLEY TR, MARIE A",
    "owner2": "",
    "current_taxes": 25186.57,
    "new_taxes_no_override": 26274.63,
    "override_total_1": 27020.15,
    "override_increase_1": 745.52
  },
  {
    "#": "59 Windsor Rd (104-04-00)",
    "$": 3557900,
    "address": "59 Windsor Rd",
    "parcel_id": "104-04-00",
    "owner1": "CREMIEUX, PIERRE YVES & JARVINEN D",
    "owner2": "",
    "current_taxes": 32797.96,
    "new_taxes_no_override": 34214.83,
    "override_total_1": 35185.65,
    "override_increase_1": 970.82
  },
  {
    "#": "60 Windsor Rd (105-12-00)",
    "$": 3313500,
    "address": "60 Windsor Rd",
    "parcel_id": "105-12-00",
    "owner1": "SULLIVAN TRS, MICHAEL E & LESLIE C",
    "owner2": "",
    "current_taxes": 30295.31,
    "new_taxes_no_override": 31604.07,
    "override_total_1": 32500.81,
    "override_increase_1": 896.74
  },
  {
    "#": "63 Windsor Rd (104-07-00)",
    "$": 17100,
    "address": "63 Windsor Rd",
    "parcel_id": "104-07-00",
    "owner1": "KILSYTH COURT 71-75 LLC",
    "owner2": "C/O CHESTNUT HILL REALTY",
    "current_taxes": 175.1,
    "new_taxes_no_override": 182.66,
    "override_total_1": 187.85,
    "override_increase_1": 5.18
  },
  {
    "#": "65 Windsor Rd (104-05-00)",
    "$": 3517200,
    "address": "65 Windsor Rd",
    "parcel_id": "104-05-00",
    "owner1": "NOCK, MATTHEW K & KEESHA M",
    "owner2": "",
    "current_taxes": 32381.19,
    "new_taxes_no_override": 33780.06,
    "override_total_1": 34738.54,
    "override_increase_1": 958.48
  },
  {
    "#": "68 Windsor Rd (105-11-00)",
    "$": 5234000,
    "address": "68 Windsor Rd",
    "parcel_id": "105-11-00",
    "owner1": "KHAN, JAMSHED AHMED & FAIZA I",
    "owner2": "",
    "current_taxes": 49961.23,
    "new_taxes_no_override": 52119.56,
    "override_total_1": 53598.41,
    "override_increase_1": 1478.85
  },
  {
    "#": "73 Windsor Rd (104-06-00)",
    "$": 3633500,
    "address": "73 Windsor Rd",
    "parcel_id": "104-06-00",
    "owner1": "GOLDBERG, JONATHAN",
    "owner2": "",
    "current_taxes": 37207.04,
    "new_taxes_no_override": 38814.38,
    "override_total_1": 39915.71,
    "override_increase_1": 1101.33
  },
  {
    "#": "78 Windsor Rd, Unit 1 & P1 (105-10-03)",
    "$": 743400,
    "address": "78 Windsor Rd, Unit 1 & P1",
    "parcel_id": "105-10-03",
    "owner1": "WING, JOSHUA",
    "owner2": "PISCOPO, LAUREN",
    "current_taxes": 3977.48,
    "new_taxes_no_override": 4149.31,
    "override_total_1": 4267.04,
    "override_increase_1": 117.73
  },
  {
    "#": "78 Windsor Rd, Unit 2 & P2 (105-10-04)",
    "$": 1219000,
    "address": "78 Windsor Rd, Unit 2 & P2",
    "parcel_id": "105-10-04",
    "owner1": "CLARK LIFE ESTATE, DAVID W",
    "owner2": "CHUN LIFE ESTATE, MILA",
    "current_taxes": 8847.63,
    "new_taxes_no_override": 9229.85,
    "override_total_1": 9491.74,
    "override_increase_1": 261.89
  },
  {
    "#": "16 Winslow Rd (056-07-00)",
    "$": 2173600,
    "address": "16 Winslow Rd",
    "parcel_id": "056-07-00",
    "owner1": "SHAHROOZ, KAMYAR & FARHAD",
    "owner2": "",
    "current_taxes": 22257.66,
    "new_taxes_no_override": 23219.19,
    "override_total_1": 23878.02,
    "override_increase_1": 658.83
  },
  {
    "#": "18 Winslow Rd (056-06-00)",
    "$": 3370000,
    "address": "18 Winslow Rd",
    "parcel_id": "056-06-00",
    "owner1": "WINSLOW APARTMENTS LLC",
    "owner2": "C/O MERGO REALTY GROUP LLC",
    "current_taxes": 34508.8,
    "new_taxes_no_override": 35999.58,
    "override_total_1": 37021.04,
    "override_increase_1": 1021.46
  },
  {
    "#": "22 Winslow Rd (056-05-00)",
    "$": 1657700,
    "address": "22 Winslow Rd",
    "parcel_id": "056-05-00",
    "owner1": "22 WINSLOW ROAD LLC",
    "owner2": "",
    "current_taxes": 16974.85,
    "new_taxes_no_override": 17708.16,
    "override_total_1": 18210.62,
    "override_increase_1": 502.46
  },
  {
    "#": "23 Winslow Rd, Unit 1 (055-22-01)",
    "$": 1835000,
    "address": "23 Winslow Rd, Unit 1",
    "parcel_id": "055-22-01",
    "owner1": "THK DEVELOPMENT LLC",
    "owner2": "",
    "current_taxes": 18790.4,
    "new_taxes_no_override": 19602.15,
    "override_total_1": 20158.34,
    "override_increase_1": 556.2
  },
  {
    "#": "23 Winslow Rd, Unit 2 (055-22-02)",
    "$": 1719400,
    "address": "23 Winslow Rd, Unit 2",
    "parcel_id": "055-22-02",
    "owner1": "LAUREATE BW.2150 LLC",
    "owner2": "",
    "current_taxes": 17606.66,
    "new_taxes_no_override": 18367.27,
    "override_total_1": 18888.42,
    "override_increase_1": 521.16
  },
  {
    "#": "24 Winslow Rd (056-04-00)",
    "$": 1858700,
    "address": "24 Winslow Rd",
    "parcel_id": "056-04-00",
    "owner1": "LAMEI, SHWAN",
    "owner2": "SCHWARTZ, ELIZABETH LYDIA",
    "current_taxes": 19033.09,
    "new_taxes_no_override": 19855.32,
    "override_total_1": 20418.7,
    "override_increase_1": 563.38
  },
  {
    "#": "27 Winslow Rd (055-23-00)",
    "$": 2389400,
    "address": "27 Winslow Rd",
    "parcel_id": "055-23-00",
    "owner1": "STIEVATER TR, DONNA M",
    "owner2": "",
    "current_taxes": 20832.52,
    "new_taxes_no_override": 21732.48,
    "override_total_1": 22349.13,
    "override_increase_1": 616.64
  },
  {
    "#": "28 Winslow Rd (056-03-00)",
    "$": 2177800,
    "address": "28 Winslow Rd",
    "parcel_id": "056-03-00",
    "owner1": "CASSIDY TRS, JAMES A JR",
    "owner2": "",
    "current_taxes": 18665.74,
    "new_taxes_no_override": 19472.1,
    "override_total_1": 20024.61,
    "override_increase_1": 552.51
  },
  {
    "#": "31 Winslow Rd, Unit 1 (055-24-19)",
    "$": 533000,
    "address": "31 Winslow Rd, Unit 1",
    "parcel_id": "055-24-19",
    "owner1": "JIANG, RAYMOND RUEY & JORDAN JONQLIANG",
    "owner2": "",
    "current_taxes": 5457.92,
    "new_taxes_no_override": 5693.7,
    "override_total_1": 5855.26,
    "override_increase_1": 161.55
  },
  {
    "#": "31 Winslow Rd, Unit 2 (055-24-01)",
    "$": 627200,
    "address": "31 Winslow Rd, Unit 2",
    "parcel_id": "055-24-01",
    "owner1": "LI, ZHONG",
    "owner2": "",
    "current_taxes": 6422.53,
    "new_taxes_no_override": 6699.98,
    "override_total_1": 6890.09,
    "override_increase_1": 190.11
  },
  {
    "#": "31 Winslow Rd, Unit 3 (055-24-02)",
    "$": 544300,
    "address": "31 Winslow Rd, Unit 3",
    "parcel_id": "055-24-02",
    "owner1": "CAPONE TRS, JEFFREY & COURTNEY",
    "owner2": "",
    "current_taxes": 5573.63,
    "new_taxes_no_override": 5814.41,
    "override_total_1": 5979.39,
    "override_increase_1": 164.98
  },
  {
    "#": "31 Winslow Rd, Unit 4 (055-24-03)",
    "$": 609800,
    "address": "31 Winslow Rd, Unit 4",
    "parcel_id": "055-24-03",
    "owner1": "JING, YIHUA",
    "owner2": "",
    "current_taxes": 2609.42,
    "new_taxes_no_override": 2722.15,
    "override_total_1": 2799.39,
    "override_increase_1": 77.24
  },
  {
    "#": "31 Winslow Rd, Unit 5 (055-24-04)",
    "$": 550500,
    "address": "31 Winslow Rd, Unit 5",
    "parcel_id": "055-24-04",
    "owner1": "ZHANG, TIANJIAO",
    "owner2": "",
    "current_taxes": 5637.12,
    "new_taxes_no_override": 5880.64,
    "override_total_1": 6047.5,
    "override_increase_1": 166.86
  },
  {
    "#": "31 Winslow Rd, Unit 6 (055-24-05)",
    "$": 615600,
    "address": "31 Winslow Rd, Unit 6",
    "parcel_id": "055-24-05",
    "owner1": "LIN, ZIQI",
    "owner2": "YAN, RUIBO",
    "current_taxes": 2668.81,
    "new_taxes_no_override": 2784.1,
    "override_total_1": 2863.1,
    "override_increase_1": 79.0
  },
  {
    "#": "33 Winslow Rd, Unit 1 (055-24-07)",
    "$": 630900,
    "address": "33 Winslow Rd, Unit 1",
    "parcel_id": "055-24-07",
    "owner1": "WU, LIH CHUEN",
    "owner2": "",
    "current_taxes": 6460.42,
    "new_taxes_no_override": 6739.51,
    "override_total_1": 6930.74,
    "override_increase_1": 191.23
  },
  {
    "#": "33 Winslow Rd, Unit 2 (055-24-08)",
    "$": 639600,
    "address": "33 Winslow Rd, Unit 2",
    "parcel_id": "055-24-08",
    "owner1": "BASSA, ANGELA S",
    "owner2": "",
    "current_taxes": 6549.5,
    "new_taxes_no_override": 6832.44,
    "override_total_1": 7026.3,
    "override_increase_1": 193.87
  },
  {
    "#": "33 Winslow Rd, Unit 3 (055-24-09)",
    "$": 665400,
    "address": "33 Winslow Rd, Unit 3",
    "parcel_id": "055-24-09",
    "owner1": "WANG, RENZHI",
    "owner2": "",
    "current_taxes": 3178.76,
    "new_taxes_no_override": 3316.08,
    "override_total_1": 3410.17,
    "override_increase_1": 94.09
  },
  {
    "#": "33 Winslow Rd, Unit 4 (055-24-10)",
    "$": 663700,
    "address": "33 Winslow Rd, Unit 4",
    "parcel_id": "055-24-10",
    "owner1": "WEISNER, CATHERINE",
    "owner2": "",
    "current_taxes": 3161.35,
    "new_taxes_no_override": 3297.92,
    "override_total_1": 3391.5,
    "override_increase_1": 93.58
  },
  {
    "#": "33 Winslow Rd, Unit 5 (055-24-11)",
    "$": 657100,
    "address": "33 Winslow Rd, Unit 5",
    "parcel_id": "055-24-11",
    "owner1": "ST AMAND, CARRIEANNE",
    "owner2": "",
    "current_taxes": 6728.7,
    "new_taxes_no_override": 7019.38,
    "override_total_1": 7218.55,
    "override_increase_1": 199.17
  },
  {
    "#": "33 Winslow Rd, Unit 6 (055-24-12)",
    "$": 733200,
    "address": "33 Winslow Rd, Unit 6",
    "parcel_id": "055-24-12",
    "owner1": "KOGAN, BARRY A & CHERYL GELDER K",
    "owner2": "",
    "current_taxes": 7507.97,
    "new_taxes_no_override": 7832.31,
    "override_total_1": 8054.55,
    "override_increase_1": 222.24
  },
  {
    "#": "33 Winslow Rd, Unit B (055-24-06)",
    "$": 549500,
    "address": "33 Winslow Rd, Unit B",
    "parcel_id": "055-24-06",
    "owner1": "ZHENG, WEI",
    "owner2": "",
    "current_taxes": 5626.88,
    "new_taxes_no_override": 5869.96,
    "override_total_1": 6036.52,
    "override_increase_1": 166.56
  },
  {
    "#": "35 Winslow Rd, Unit 1 (055-24-13)",
    "$": 659700,
    "address": "35 Winslow Rd, Unit 1",
    "parcel_id": "055-24-13",
    "owner1": "MARCUS, JAMES",
    "owner2": "",
    "current_taxes": 6755.33,
    "new_taxes_no_override": 7047.16,
    "override_total_1": 7247.12,
    "override_increase_1": 199.96
  },
  {
    "#": "35 Winslow Rd, Unit 2 (055-24-14)",
    "$": 564600,
    "address": "35 Winslow Rd, Unit 2",
    "parcel_id": "055-24-14",
    "owner1": "HERNANDEZ DE PARDO TR, DIANA",
    "owner2": "",
    "current_taxes": 5781.5,
    "new_taxes_no_override": 6031.26,
    "override_total_1": 6202.39,
    "override_increase_1": 171.13
  },
  {
    "#": "35 Winslow Rd, Unit 3 (055-24-15)",
    "$": 629800,
    "address": "35 Winslow Rd, Unit 3",
    "parcel_id": "055-24-15",
    "owner1": "ROLLER, NATHAN W",
    "owner2": "",
    "current_taxes": 6449.15,
    "new_taxes_no_override": 6727.75,
    "override_total_1": 6918.65,
    "override_increase_1": 190.89
  },
  {
    "#": "35 Winslow Rd, Unit 4 (055-24-16)",
    "$": 582000,
    "address": "35 Winslow Rd, Unit 4",
    "parcel_id": "055-24-16",
    "owner1": "BRIEF TRS, DAVID CHAIM & HAZEL SUSAN KASSEL",
    "owner2": "C/O MACKIN GROUP INC",
    "current_taxes": 5959.68,
    "new_taxes_no_override": 6217.14,
    "override_total_1": 6393.54,
    "override_increase_1": 176.41
  },
  {
    "#": "35 Winslow Rd, Unit 5 (055-24-17)",
    "$": 624300,
    "address": "35 Winslow Rd, Unit 5",
    "parcel_id": "055-24-17",
    "owner1": "BRUCE, JEFFREY S",
    "owner2": "",
    "current_taxes": 6392.83,
    "new_taxes_no_override": 6669.0,
    "override_total_1": 6858.23,
    "override_increase_1": 189.23
  },
  {
    "#": "35 Winslow Rd, Unit 6 (055-24-18)",
    "$": 564600,
    "address": "35 Winslow Rd, Unit 6",
    "parcel_id": "055-24-18",
    "owner1": "HOGAN, DOUGLAS L",
    "owner2": "AGUERO, NIDIA R",
    "current_taxes": 2146.57,
    "new_taxes_no_override": 2239.3,
    "override_total_1": 2302.84,
    "override_increase_1": 63.54
  },
  {
    "#": "41 Winslow Rd, Unit 1 (055-25-08)",
    "$": 557400,
    "address": "41 Winslow Rd, Unit 1",
    "parcel_id": "055-25-08",
    "owner1": "FRANK, ROSEMARY E",
    "owner2": "",
    "current_taxes": 5707.78,
    "new_taxes_no_override": 5954.36,
    "override_total_1": 6123.31,
    "override_increase_1": 168.95
  },
  {
    "#": "41 Winslow Rd, Unit 2 (055-25-01)",
    "$": 580000,
    "address": "41 Winslow Rd, Unit 2",
    "parcel_id": "055-25-01",
    "owner1": "BROWN, ELEANOR",
    "owner2": "",
    "current_taxes": 5939.2,
    "new_taxes_no_override": 6195.77,
    "override_total_1": 6371.57,
    "override_increase_1": 175.8
  },
  {
    "#": "41 Winslow Rd, Unit 3 (055-25-02)",
    "$": 583700,
    "address": "41 Winslow Rd, Unit 3",
    "parcel_id": "055-25-02",
    "owner1": "BROWN, ELEANOR",
    "owner2": "",
    "current_taxes": 5977.09,
    "new_taxes_no_override": 6235.3,
    "override_total_1": 6412.22,
    "override_increase_1": 176.92
  },
  {
    "#": "41 Winslow Rd, Unit 4 (055-25-03)",
    "$": 588300,
    "address": "41 Winslow Rd, Unit 4",
    "parcel_id": "055-25-03",
    "owner1": "HEALEY, DENNIS",
    "owner2": "",
    "current_taxes": 2389.26,
    "new_taxes_no_override": 2492.48,
    "override_total_1": 2563.2,
    "override_increase_1": 70.72
  },
  {
    "#": "41 Winslow Rd, Unit 5 (055-25-04)",
    "$": 558400,
    "address": "41 Winslow Rd, Unit 5",
    "parcel_id": "055-25-04",
    "owner1": "ZIMETBAUM TR, PETER J",
    "owner2": "",
    "current_taxes": 5718.02,
    "new_taxes_no_override": 5965.04,
    "override_total_1": 6134.29,
    "override_increase_1": 169.25
  },
  {
    "#": "41 Winslow Rd, Unit 6 (055-25-05)",
    "$": 574400,
    "address": "41 Winslow Rd, Unit 6",
    "parcel_id": "055-25-05",
    "owner1": "WONG, JOCELYNE W",
    "owner2": "",
    "current_taxes": 5881.86,
    "new_taxes_no_override": 6135.96,
    "override_total_1": 6310.06,
    "override_increase_1": 174.1
  },
  {
    "#": "41 Winslow Rd, Unit 7 (055-25-06)",
    "$": 899900,
    "address": "41 Winslow Rd, Unit 7",
    "parcel_id": "055-25-06",
    "owner1": "PYES TRS, SHARON E & MERRIL S",
    "owner2": "",
    "current_taxes": 9214.98,
    "new_taxes_no_override": 9613.07,
    "override_total_1": 9885.83,
    "override_increase_1": 272.76
  },
  {
    "#": "41 Winslow Rd (055-25-07)",
    "$": 1508200,
    "address": "41 Winslow Rd",
    "parcel_id": "055-25-07",
    "owner1": "WINSLOW 41 TRUST",
    "owner2": "C/O THE HAMILTON CO",
    "current_taxes": 15443.97,
    "new_taxes_no_override": 16111.15,
    "override_total_1": 16568.29,
    "override_increase_1": 457.14
  },
  {
    "#": "44 Winslow Rd (056-02-00)",
    "$": 2830600,
    "address": "44 Winslow Rd",
    "parcel_id": "056-02-00",
    "owner1": "WINSLOW HOUSE LLC",
    "owner2": "",
    "current_taxes": 28985.34,
    "new_taxes_no_override": 30237.51,
    "override_total_1": 31095.47,
    "override_increase_1": 857.97
  },
  {
    "#": "45 Winslow Rd (055-26-00)",
    "$": 1821600,
    "address": "45 Winslow Rd",
    "parcel_id": "055-26-00",
    "owner1": "45 WINSLOW LLC",
    "owner2": "C/O THRIVE REALTY PARTNERS",
    "current_taxes": 18653.18,
    "new_taxes_no_override": 19459.0,
    "override_total_1": 20011.13,
    "override_increase_1": 552.13
  },
  {
    "#": "51 Winslow Rd (055-27-01)",
    "$": 3720700,
    "address": "51 Winslow Rd",
    "parcel_id": "055-27-01",
    "owner1": "THE MEHTA GROUP LLC",
    "owner2": "",
    "current_taxes": 38099.97,
    "new_taxes_no_override": 39745.89,
    "override_total_1": 40873.65,
    "override_increase_1": 1127.76
  },
  {
    "#": "53 Winslow Rd (055-27-02)",
    "$": 3721400,
    "address": "53 Winslow Rd",
    "parcel_id": "055-27-02",
    "owner1": "MENTA, SUCHINTA",
    "owner2": "",
    "current_taxes": 38107.14,
    "new_taxes_no_override": 39753.37,
    "override_total_1": 40881.34,
    "override_increase_1": 1127.97
  },
  {
    "#": "7 Winthrop Rd (210-11-04)",
    "$": 4185800,
    "address": "7 Winthrop Rd",
    "parcel_id": "210-11-04",
    "owner1": "JAFFE, JEFFREY MARTIN & ESTHER P",
    "owner2": "",
    "current_taxes": 39227.66,
    "new_taxes_no_override": 40922.29,
    "override_total_1": 42083.43,
    "override_increase_1": 1161.14
  },
  {
    "#": "9 Winthrop Rd (210-11-03)",
    "$": 4185000,
    "address": "9 Winthrop Rd",
    "parcel_id": "210-11-03",
    "owner1": "FISCHER, KRISZTINA",
    "owner2": "",
    "current_taxes": 39219.47,
    "new_taxes_no_override": 40913.75,
    "override_total_1": 42074.65,
    "override_increase_1": 1160.9
  },
  {
    "#": "10 Winthrop Rd (209-10-00)",
    "$": 2088400,
    "address": "10 Winthrop Rd",
    "parcel_id": "209-10-00",
    "owner1": "SEIDMAN, ILENE B",
    "owner2": "",
    "current_taxes": 17750.28,
    "new_taxes_no_override": 18517.09,
    "override_total_1": 19042.5,
    "override_increase_1": 525.41
  },
  {
    "#": "15 Winthrop Rd (210-11-01)",
    "$": 2889800,
    "address": "15 Winthrop Rd",
    "parcel_id": "210-11-01",
    "owner1": "BASU, TONUCA",
    "owner2": "NAGARWALLA, NEVILLE",
    "current_taxes": 29591.55,
    "new_taxes_no_override": 30869.9,
    "override_total_1": 31745.81,
    "override_increase_1": 875.91
  },
  {
    "#": "16 Winthrop Rd (209-09-00)",
    "$": 2279200,
    "address": "16 Winthrop Rd",
    "parcel_id": "209-09-00",
    "owner1": "LIPSEY, GERALD & CAROL",
    "owner2": "",
    "current_taxes": 19704.07,
    "new_taxes_no_override": 20555.29,
    "override_total_1": 21138.53,
    "override_increase_1": 583.24
  },
  {
    "#": "20 Winthrop Rd (209-08-00)",
    "$": 2304800,
    "address": "20 Winthrop Rd",
    "parcel_id": "209-08-00",
    "owner1": "GOLDMAN, LAURIE L",
    "owner2": "HENLEY, KAREN M",
    "current_taxes": 19966.22,
    "new_taxes_no_override": 20828.76,
    "override_total_1": 21419.76,
    "override_increase_1": 591.0
  },
  {
    "#": "21 Winthrop Rd (210-11-00)",
    "$": 2704100,
    "address": "21 Winthrop Rd",
    "parcel_id": "210-11-00",
    "owner1": "MEYERS, KAREN INA",
    "owner2": "ZAGORSKY, JAY L",
    "current_taxes": 24055.05,
    "new_taxes_no_override": 25094.23,
    "override_total_1": 25806.26,
    "override_increase_1": 712.03
  },
  {
    "#": "25 Winthrop Rd (210-10-02)",
    "$": 3929000,
    "address": "25 Winthrop Rd",
    "parcel_id": "210-10-02",
    "owner1": "KLEIN TR, JEFFREY F",
    "owner2": "",
    "current_taxes": 36598.03,
    "new_taxes_no_override": 38179.06,
    "override_total_1": 39262.37,
    "override_increase_1": 1083.3
  },
  {
    "#": "29 Winthrop Rd, Unit 1 (210-10-03)",
    "$": 1761100,
    "address": "29 Winthrop Rd, Unit 1",
    "parcel_id": "210-10-03",
    "owner1": "LEVENSON TR, LESLIE C",
    "owner2": "",
    "current_taxes": 14398.73,
    "new_taxes_no_override": 15020.76,
    "override_total_1": 15446.96,
    "override_increase_1": 426.2
  },
  {
    "#": "30 Winthrop Rd, Unit 30 (209-07-03)",
    "$": 2751000,
    "address": "30 Winthrop Rd, Unit 30",
    "parcel_id": "209-07-03",
    "owner1": "KELLEY TR, JANET",
    "owner2": "",
    "current_taxes": 24535.31,
    "new_taxes_no_override": 25595.24,
    "override_total_1": 26321.48,
    "override_increase_1": 726.25
  },
  {
    "#": "30 Winthrop Rd, Unit 32 (209-07-04)",
    "$": 2721300,
    "address": "30 Winthrop Rd, Unit 32",
    "parcel_id": "209-07-04",
    "owner1": "CASADESUS MASANELL, RAMON",
    "owner2": "GONZALEZ PALOMARES, ANA LETICIA",
    "current_taxes": 27866.11,
    "new_taxes_no_override": 29069.93,
    "override_total_1": 29894.76,
    "override_increase_1": 824.84
  },
  {
    "#": "30 Winthrop Rd, Unit 34 (209-07-05)",
    "$": 2890500,
    "address": "30 Winthrop Rd, Unit 34",
    "parcel_id": "209-07-05",
    "owner1": "LEBED, JAY A",
    "owner2": "KAHN, KARIN R",
    "current_taxes": 25963.79,
    "new_taxes_no_override": 27085.43,
    "override_total_1": 27853.95,
    "override_increase_1": 768.53
  },
  {
    "#": "30 Winthrop Rd, Unit 36 (209-07-06)",
    "$": 2838200,
    "address": "30 Winthrop Rd, Unit 36",
    "parcel_id": "209-07-06",
    "owner1": "SHEN, JIE",
    "owner2": "",
    "current_taxes": 25428.23,
    "new_taxes_no_override": 26526.73,
    "override_total_1": 27279.41,
    "override_increase_1": 752.68
  },
  {
    "#": "31 Winthrop Rd, Unit 2 (210-10-04)",
    "$": 1781800,
    "address": "31 Winthrop Rd, Unit 2",
    "parcel_id": "210-10-04",
    "owner1": "PONCE, EVA",
    "owner2": "SIERRA, JOSE",
    "current_taxes": 14610.7,
    "new_taxes_no_override": 15241.88,
    "override_total_1": 15674.36,
    "override_increase_1": 432.48
  },
  {
    "#": "33 Winthrop Rd, Unit 1 & G1 G2 (210-10-05)",
    "$": 3149800,
    "address": "33 Winthrop Rd, Unit 1 & G1 G2",
    "parcel_id": "210-10-05",
    "owner1": "TTUS LLC",
    "owner2": "",
    "current_taxes": 32253.95,
    "new_taxes_no_override": 33647.32,
    "override_total_1": 34602.04,
    "override_increase_1": 954.72
  },
  {
    "#": "33 Winthrop Rd, Unit 2 (210-10-06)",
    "$": 3054800,
    "address": "33 Winthrop Rd, Unit 2",
    "parcel_id": "210-10-06",
    "owner1": "SEGEV, IDO",
    "owner2": "LEE, ROZINA",
    "current_taxes": 31281.15,
    "new_taxes_no_override": 32632.5,
    "override_total_1": 33558.42,
    "override_increase_1": 925.92
  },
  {
    "#": "35 Winthrop Rd (210-09-00)",
    "$": 2383000,
    "address": "35 Winthrop Rd",
    "parcel_id": "210-09-00",
    "owner1": "WICHS, DANIEL",
    "owner2": "LIBBY, ELIZABETH",
    "current_taxes": 24401.92,
    "new_taxes_no_override": 25456.08,
    "override_total_1": 26178.38,
    "override_increase_1": 722.3
  },
  {
    "#": "39 Winthrop Rd, Unit 39 (210-08-01)",
    "$": 1659100,
    "address": "39 Winthrop Rd, Unit 39",
    "parcel_id": "210-08-01",
    "owner1": "MOREA, DIANE",
    "owner2": "",
    "current_taxes": 13354.25,
    "new_taxes_no_override": 13931.15,
    "override_total_1": 14326.44,
    "override_increase_1": 395.29
  },
  {
    "#": "39 Winthrop Rd, Unit 41 (210-08-02)",
    "$": 1573400,
    "address": "39 Winthrop Rd, Unit 41",
    "parcel_id": "210-08-02",
    "owner1": "SZALAT, RAPHAEL ELIE",
    "owner2": "KANTER, LAURA",
    "current_taxes": 12476.68,
    "new_taxes_no_override": 13015.67,
    "override_total_1": 13384.98,
    "override_increase_1": 369.31
  },
  {
    "#": "47 Winthrop Rd, Unit 1 (210-07-02)",
    "$": 1625700,
    "address": "47 Winthrop Rd, Unit 1",
    "parcel_id": "210-07-02",
    "owner1": "FINK TRS, SAUL WILLIAM & TRACY L",
    "owner2": "",
    "current_taxes": 16647.17,
    "new_taxes_no_override": 17366.33,
    "override_total_1": 17859.08,
    "override_increase_1": 492.76
  },
  {
    "#": "47 Winthrop Rd, Unit 2 & P2 (210-07-01)",
    "$": 1644300,
    "address": "47 Winthrop Rd, Unit 2 & P2",
    "parcel_id": "210-07-01",
    "owner1": "KEEFE, AUDRA R & RYAN M",
    "owner2": "",
    "current_taxes": 13202.7,
    "new_taxes_no_override": 13773.06,
    "override_total_1": 14163.86,
    "override_increase_1": 390.8
  },
  {
    "#": "51 Winthrop Rd, Unit 1 (210-06-01)",
    "$": 1683800,
    "address": "51 Winthrop Rd, Unit 1",
    "parcel_id": "210-06-01",
    "owner1": "CASTELLI, MARCO & ELVIRA S PEREZ DE",
    "owner2": "",
    "current_taxes": 13607.18,
    "new_taxes_no_override": 14195.01,
    "override_total_1": 14597.78,
    "override_increase_1": 402.77
  },
  {
    "#": "51 Winthrop Rd, Unit 2 (210-06-02)",
    "$": 1601900,
    "address": "51 Winthrop Rd, Unit 2",
    "parcel_id": "210-06-02",
    "owner1": "LEJFER, BENJAMIN T & SARAH L",
    "owner2": "",
    "current_taxes": 12768.52,
    "new_taxes_no_override": 13320.12,
    "override_total_1": 13698.07,
    "override_increase_1": 377.95
  },
  {
    "#": "57 Winthrop Rd, Unit 1 (210-05-01)",
    "$": 1662400,
    "address": "57 Winthrop Rd, Unit 1",
    "parcel_id": "210-05-01",
    "owner1": "WENG, ZHIGANG",
    "owner2": "LAZAROVA, TSVETELINA",
    "current_taxes": 13388.04,
    "new_taxes_no_override": 13966.4,
    "override_total_1": 14362.69,
    "override_increase_1": 396.29
  },
  {
    "#": "57 Winthrop Rd, Unit 2 (210-05-02)",
    "$": 1853300,
    "address": "57 Winthrop Rd, Unit 2",
    "parcel_id": "210-05-02",
    "owner1": "JOHNSON, JEFFREY P & SANDY H",
    "owner2": "",
    "current_taxes": 15342.86,
    "new_taxes_no_override": 16005.67,
    "override_total_1": 16459.82,
    "override_increase_1": 454.15
  },
  {
    "#": "63 Winthrop Rd, Unit 1 (210-04-01)",
    "$": 1261200,
    "address": "63 Winthrop Rd, Unit 1",
    "parcel_id": "210-04-01",
    "owner1": "PRIZER, LESLIE A",
    "owner2": "",
    "current_taxes": 9279.75,
    "new_taxes_no_override": 9680.64,
    "override_total_1": 9955.32,
    "override_increase_1": 274.68
  },
  {
    "#": "63 Winthrop Rd, Unit 2 (210-04-02)",
    "$": 1453300,
    "address": "63 Winthrop Rd, Unit 2",
    "parcel_id": "210-04-02",
    "owner1": "KLAFTER, DAVID",
    "owner2": "ABBOT, SUZETTE",
    "current_taxes": 11246.86,
    "new_taxes_no_override": 11732.72,
    "override_total_1": 12065.63,
    "override_increase_1": 332.91
  },
  {
    "#": "67 Winthrop Rd, Unit 67 (210-03-01)",
    "$": 1787400,
    "address": "67 Winthrop Rd, Unit 67",
    "parcel_id": "210-03-01",
    "owner1": "KAISER TRS, MICHAEL DAVID",
    "owner2": "WEAVER, KARIN L",
    "current_taxes": 14668.04,
    "new_taxes_no_override": 15301.7,
    "override_total_1": 15735.87,
    "override_increase_1": 434.17
  },
  {
    "#": "69 Winthrop Rd, Unit 69 (210-03-02)",
    "$": 1419200,
    "address": "69 Winthrop Rd, Unit 69",
    "parcel_id": "210-03-02",
    "owner1": "HARRIS, THOMAS C",
    "owner2": "MEYER, FREMONTA L",
    "current_taxes": 10897.67,
    "new_taxes_no_override": 11368.45,
    "override_total_1": 11691.02,
    "override_increase_1": 322.57
  },
  {
    "#": "73 Winthrop Rd, Unit 1 (210-02-01)",
    "$": 1686600,
    "address": "73 Winthrop Rd, Unit 1",
    "parcel_id": "210-02-01",
    "owner1": "DEMEHRI, FAROKH RUSTOM & ANGELA CANOY",
    "owner2": "",
    "current_taxes": 13635.85,
    "new_taxes_no_override": 14224.92,
    "override_total_1": 14628.54,
    "override_increase_1": 403.62
  },
  {
    "#": "73 Winthrop Rd, Unit 2 (210-02-02)",
    "$": 1452400,
    "address": "73 Winthrop Rd, Unit 2",
    "parcel_id": "210-02-02",
    "owner1": "FOWLKES, E OLIVER",
    "owner2": "HARVEY, MARY R",
    "current_taxes": 11237.64,
    "new_taxes_no_override": 11723.11,
    "override_total_1": 12055.74,
    "override_increase_1": 332.63
  },
  {
    "#": "78 Winthrop Rd, Unit 1 (218-05-01)",
    "$": 2580400,
    "address": "78 Winthrop Rd, Unit 1",
    "parcel_id": "218-05-01",
    "owner1": "RATHE, APRIL L",
    "owner2": "KROLNIK, MICHAEL F",
    "current_taxes": 22788.36,
    "new_taxes_no_override": 23772.82,
    "override_total_1": 24447.35,
    "override_increase_1": 674.54
  },
  {
    "#": "78 Winthrop Rd, Unit 2 (218-05-02)",
    "$": 2826400,
    "address": "78 Winthrop Rd, Unit 2",
    "parcel_id": "218-05-02",
    "owner1": "XIAO, FAZHEN",
    "owner2": "",
    "current_taxes": 28942.34,
    "new_taxes_no_override": 30192.65,
    "override_total_1": 31049.34,
    "override_increase_1": 856.69
  },
  {
    "#": "79 Winthrop Rd (210-01-00)",
    "$": 2118900,
    "address": "79 Winthrop Rd",
    "parcel_id": "210-01-00",
    "owner1": "BRYANT, PETER G",
    "owner2": "",
    "current_taxes": 21697.54,
    "new_taxes_no_override": 22634.87,
    "override_total_1": 23277.12,
    "override_increase_1": 642.25
  },
  {
    "#": "84 Winthrop Rd, Unit 1 (218-04-01)",
    "$": 1820200,
    "address": "84 Winthrop Rd, Unit 1",
    "parcel_id": "218-04-01",
    "owner1": "84 WINTHROP ROAD LLC",
    "owner2": "",
    "current_taxes": 18638.85,
    "new_taxes_no_override": 19444.05,
    "override_total_1": 19995.76,
    "override_increase_1": 551.71
  },
  {
    "#": "84 Winthrop Rd, Unit 2 (218-04-02)",
    "$": 1923700,
    "address": "84 Winthrop Rd, Unit 2",
    "parcel_id": "218-04-02",
    "owner1": "84 WINTHROP ROAD LLC",
    "owner2": "",
    "current_taxes": 19698.69,
    "new_taxes_no_override": 20549.67,
    "override_total_1": 21132.75,
    "override_increase_1": 583.08
  },
  {
    "#": "89 Winthrop Rd, Unit 1 P1 P2 (217-48-01)",
    "$": 1573400,
    "address": "89 Winthrop Rd, Unit 1 P1 P2",
    "parcel_id": "217-48-01",
    "owner1": "GREENFIELD, ARNOLD J",
    "owner2": "SLATTERY, SUZANNE",
    "current_taxes": 12476.68,
    "new_taxes_no_override": 13015.67,
    "override_total_1": 13384.98,
    "override_increase_1": 369.31
  },
  {
    "#": "89 Winthrop Rd, Unit 2 P3 P4 (217-48-02)",
    "$": 1773400,
    "address": "89 Winthrop Rd, Unit 2 P3 P4",
    "parcel_id": "217-48-02",
    "owner1": "SICILIANO, DONNA A",
    "owner2": "",
    "current_taxes": 14524.68,
    "new_taxes_no_override": 15152.15,
    "override_total_1": 15582.08,
    "override_increase_1": 429.93
  },
  {
    "#": "89 Winthrop Rd, Unit 3 (217-48-03)",
    "$": 1289700,
    "address": "89 Winthrop Rd, Unit 3",
    "parcel_id": "217-48-03",
    "owner1": "LYNCH, THOMAS S & ERIN A",
    "owner2": "",
    "current_taxes": 9571.59,
    "new_taxes_no_override": 9985.08,
    "override_total_1": 10268.4,
    "override_increase_1": 283.32
  },
  {
    "#": "91 Winthrop Rd (217-47-00)",
    "$": 2300200,
    "address": "91 Winthrop Rd",
    "parcel_id": "217-47-00",
    "owner1": "LEUNG, JOHN S",
    "owner2": "",
    "current_taxes": 19919.11,
    "new_taxes_no_override": 20779.62,
    "override_total_1": 21369.22,
    "override_increase_1": 589.61
  },
  {
    "#": "92 Winthrop Rd, Unit 1 (218-03-03)",
    "$": 766900,
    "address": "92 Winthrop Rd, Unit 1",
    "parcel_id": "218-03-03",
    "owner1": "HECHT, HOWARD M",
    "owner2": "",
    "current_taxes": 7853.06,
    "new_taxes_no_override": 8192.31,
    "override_total_1": 8424.76,
    "override_increase_1": 232.45
  },
  {
    "#": "92 Winthrop Rd, Unit 2 (218-03-01)",
    "$": 804200,
    "address": "92 Winthrop Rd, Unit 2",
    "parcel_id": "218-03-01",
    "owner1": "MULLER, JA YOUNG KIM & RETO",
    "owner2": "",
    "current_taxes": 4600.07,
    "new_taxes_no_override": 4798.79,
    "override_total_1": 4934.96,
    "override_increase_1": 136.16
  },
  {
    "#": "92 Winthrop Rd, Unit 3 (218-03-02)",
    "$": 817400,
    "address": "92 Winthrop Rd, Unit 3",
    "parcel_id": "218-03-02",
    "owner1": "IOFFE, YEVGENY",
    "owner2": "",
    "current_taxes": 4735.24,
    "new_taxes_no_override": 4939.8,
    "override_total_1": 5079.97,
    "override_increase_1": 140.16
  },
  {
    "#": "96 Winthrop Rd (218-02-00)",
    "$": 2940500,
    "address": "96 Winthrop Rd",
    "parcel_id": "218-02-00",
    "owner1": "96 WINTHROP ROAD LLC",
    "owner2": "",
    "current_taxes": 30110.72,
    "new_taxes_no_override": 31411.5,
    "override_total_1": 32302.78,
    "override_increase_1": 891.28
  },
  {
    "#": "97 Winthrop Rd, Unit 97 (217-46-02)",
    "$": 2119600,
    "address": "97 Winthrop Rd, Unit 97",
    "parcel_id": "217-46-02",
    "owner1": "VANDERLINDEN, SANDRINE",
    "owner2": "GOLDMUNTZ, GARY R",
    "current_taxes": 18069.77,
    "new_taxes_no_override": 18850.38,
    "override_total_1": 19385.25,
    "override_increase_1": 534.87
  },
  {
    "#": "97 Winthrop Rd, Unit 97A (217-46-01)",
    "$": 1170300,
    "address": "97 Winthrop Rd, Unit 97A",
    "parcel_id": "217-46-01",
    "owner1": "TRUE, DEBORAH A",
    "owner2": "",
    "current_taxes": 8348.94,
    "new_taxes_no_override": 8709.61,
    "override_total_1": 8956.74,
    "override_increase_1": 247.13
  },
  {
    "#": "101 Winthrop Rd, Unit 1 (217-45-03)",
    "$": 1113000,
    "address": "101 Winthrop Rd, Unit 1",
    "parcel_id": "217-45-03",
    "owner1": "PITTEL, ELENA & ARKADY",
    "owner2": "",
    "current_taxes": 7762.19,
    "new_taxes_no_override": 8097.52,
    "override_total_1": 8327.28,
    "override_increase_1": 229.76
  },
  {
    "#": "101 Winthrop Rd, Unit 2 (217-45-01)",
    "$": 1167300,
    "address": "101 Winthrop Rd, Unit 2",
    "parcel_id": "217-45-01",
    "owner1": "YURCHENKO, OLGA",
    "owner2": "",
    "current_taxes": 8318.22,
    "new_taxes_no_override": 8677.57,
    "override_total_1": 8923.79,
    "override_increase_1": 246.22
  },
  {
    "#": "101 Winthrop Rd, Unit 3 & G2 (217-45-02)",
    "$": 1343600,
    "address": "101 Winthrop Rd, Unit 3 & G2",
    "parcel_id": "217-45-02",
    "owner1": "MALENFANT, CHRISTOPHER J",
    "owner2": "",
    "current_taxes": 10123.53,
    "new_taxes_no_override": 10560.87,
    "override_total_1": 10860.52,
    "override_increase_1": 299.66
  },
  {
    "#": "105 Winthrop Rd, Unit 1 & P-C (217-44-02)",
    "$": 1580600,
    "address": "105 Winthrop Rd, Unit 1 & P-C",
    "parcel_id": "217-44-02",
    "owner1": "EPIFANTSEVA, YULIYA",
    "owner2": "",
    "current_taxes": 16185.34,
    "new_taxes_no_override": 16884.55,
    "override_total_1": 17363.63,
    "override_increase_1": 479.09
  },
  {
    "#": "105 Winthrop Rd, Unit 2 & G-A (217-44-03)",
    "$": 1738100,
    "address": "105 Winthrop Rd, Unit 2 & G-A",
    "parcel_id": "217-44-03",
    "owner1": "CONSOLI, LORENZO",
    "owner2": "",
    "current_taxes": 17798.14,
    "new_taxes_no_override": 18567.02,
    "override_total_1": 19093.84,
    "override_increase_1": 526.82
  },
  {
    "#": "105 Winthrop Rd, Unit 3 & G-B (217-44-04)",
    "$": 1926200,
    "address": "105 Winthrop Rd, Unit 3 & G-B",
    "parcel_id": "217-44-04",
    "owner1": "KNOBLOCH, THORSTEN & TAMARA",
    "owner2": "",
    "current_taxes": 16089.35,
    "new_taxes_no_override": 16784.41,
    "override_total_1": 17260.65,
    "override_increase_1": 476.24
  },
  {
    "#": "107 Winthrop Rd (217-44-00)",
    "$": 2936800,
    "address": "107 Winthrop Rd",
    "parcel_id": "217-44-00",
    "owner1": "CHAN TRS, PETER K Y & EVA F K A",
    "owner2": "",
    "current_taxes": 26437.9,
    "new_taxes_no_override": 27580.02,
    "override_total_1": 28362.58,
    "override_increase_1": 782.56
  },
  {
    "#": "108 Winthrop Rd (219-01-03)",
    "$": 11019600,
    "address": "108 Winthrop Rd",
    "parcel_id": "219-01-03",
    "owner1": "TMI-RR WINTHROP ROAD BROOKLINE LLC",
    "owner2": "C/O TAYMIL PARTNERS, LLC",
    "current_taxes": 112840.7,
    "new_taxes_no_override": 117715.42,
    "override_total_1": 121055.5,
    "override_increase_1": 3340.08
  },
  {
    "#": "111 Winthrop Rd, Unit 1 (217-43-01)",
    "$": 803700,
    "address": "111 Winthrop Rd, Unit 1",
    "parcel_id": "217-43-01",
    "owner1": "DEMEO, MELISSA",
    "owner2": "COHEN, GODERT",
    "current_taxes": 8229.89,
    "new_taxes_no_override": 8585.42,
    "override_total_1": 8829.03,
    "override_increase_1": 243.6
  },
  {
    "#": "111 Winthrop Rd, Unit 2 (217-43-02)",
    "$": 1187200,
    "address": "111 Winthrop Rd, Unit 2",
    "parcel_id": "217-43-02",
    "owner1": "SUBAK, DANIEL",
    "owner2": "",
    "current_taxes": 8521.99,
    "new_taxes_no_override": 8890.14,
    "override_total_1": 9142.39,
    "override_increase_1": 252.25
  },
  {
    "#": "111 Winthrop Rd, Unit 3 (217-43-03)",
    "$": 1451800,
    "address": "111 Winthrop Rd, Unit 3",
    "parcel_id": "217-43-03",
    "owner1": "KO, NARAE",
    "owner2": "",
    "current_taxes": 11231.5,
    "new_taxes_no_override": 11716.7,
    "override_total_1": 12049.15,
    "override_increase_1": 332.45
  },
  {
    "#": "111 Winthrop Rd, Unit 4 (217-43-04)",
    "$": 1484800,
    "address": "111 Winthrop Rd, Unit 4",
    "parcel_id": "217-43-04",
    "owner1": "TRON, ADRIANA",
    "owner2": "",
    "current_taxes": 11569.42,
    "new_taxes_no_override": 12069.22,
    "override_total_1": 12411.67,
    "override_increase_1": 342.45
  },
  {
    "#": "111 Winthrop Rd, Unit 5 (217-43-05)",
    "$": 1688100,
    "address": "111 Winthrop Rd, Unit 5",
    "parcel_id": "217-43-05",
    "owner1": "BOTTOMLEY, MATTHEW",
    "owner2": "LO SURDO, PAOLA",
    "current_taxes": 13651.21,
    "new_taxes_no_override": 14240.94,
    "override_total_1": 14645.02,
    "override_increase_1": 404.08
  },
  {
    "#": "119 Winthrop Rd, Unit 11C (217-42-06)",
    "$": 557900,
    "address": "119 Winthrop Rd, Unit 11C",
    "parcel_id": "217-42-06",
    "owner1": "ULYANSKAYA, ALLA",
    "owner2": "",
    "current_taxes": 2077.96,
    "new_taxes_no_override": 2167.73,
    "override_total_1": 2229.24,
    "override_increase_1": 61.51
  },
  {
    "#": "119 Winthrop Rd, Unit 12C (217-42-07)",
    "$": 524100,
    "address": "119 Winthrop Rd, Unit 12C",
    "parcel_id": "217-42-07",
    "owner1": "WILSON, SARAH A",
    "owner2": "",
    "current_taxes": 5366.78,
    "new_taxes_no_override": 5598.62,
    "override_total_1": 5757.48,
    "override_increase_1": 158.86
  },
  {
    "#": "119 Winthrop Rd, Unit 1C (217-42-20)",
    "$": 753500,
    "address": "119 Winthrop Rd, Unit 1C",
    "parcel_id": "217-42-20",
    "owner1": "ELFANT, VENIAMIN",
    "owner2": "",
    "current_taxes": 4080.91,
    "new_taxes_no_override": 4257.21,
    "override_total_1": 4378.0,
    "override_increase_1": 120.79
  },
  {
    "#": "119 Winthrop Rd, Unit 2C (217-42-01)",
    "$": 573000,
    "address": "119 Winthrop Rd, Unit 2C",
    "parcel_id": "217-42-01",
    "owner1": "RAJAPAKSE, SUDHEERA & JALINI",
    "owner2": "",
    "current_taxes": 5867.52,
    "new_taxes_no_override": 6121.0,
    "override_total_1": 6294.68,
    "override_increase_1": 173.68
  },
  {
    "#": "119 Winthrop Rd, Unit 2D (217-42-08)",
    "$": 549000,
    "address": "119 Winthrop Rd, Unit 2D",
    "parcel_id": "217-42-08",
    "owner1": "WELLS TR, FREDERIC L",
    "owner2": "",
    "current_taxes": 1986.83,
    "new_taxes_no_override": 2072.66,
    "override_total_1": 2131.47,
    "override_increase_1": 58.81
  },
  {
    "#": "119 Winthrop Rd, Unit 3C & P6 (217-42-02)",
    "$": 953600,
    "address": "119 Winthrop Rd, Unit 3C & P6",
    "parcel_id": "217-42-02",
    "owner1": "PINSKY, VENYAMIN",
    "owner2": "MELENEVSKAYA, SOFIA",
    "current_taxes": 9764.86,
    "new_taxes_no_override": 10186.7,
    "override_total_1": 10475.74,
    "override_increase_1": 289.04
  },
  {
    "#": "119 Winthrop Rd, Unit 4C & P1 (217-42-03)",
    "$": 1149700,
    "address": "119 Winthrop Rd, Unit 4C & P1",
    "parcel_id": "217-42-03",
    "owner1": "VILK TRS, DMITRIY",
    "owner2": "",
    "current_taxes": 11772.93,
    "new_taxes_no_override": 12281.52,
    "override_total_1": 12630.0,
    "override_increase_1": 348.48
  },
  {
    "#": "119 Winthrop Rd, Unit 5C (217-42-04)",
    "$": 931100,
    "address": "119 Winthrop Rd, Unit 5C",
    "parcel_id": "217-42-04",
    "owner1": "KALAYDJIEV, SVETLIN G",
    "owner2": "RASHKOVA, BISERKA R",
    "current_taxes": 5899.53,
    "new_taxes_no_override": 6154.39,
    "override_total_1": 6329.02,
    "override_increase_1": 174.63
  },
  {
    "#": "119 Winthrop Rd, Unit 6C & P4 (217-42-05)",
    "$": 1142600,
    "address": "119 Winthrop Rd, Unit 6C & P4",
    "parcel_id": "217-42-05",
    "owner1": "SHEFF TRS, ALEXANDER",
    "owner2": "CORREA, ELIZABETH",
    "current_taxes": 8065.29,
    "new_taxes_no_override": 8413.71,
    "override_total_1": 8652.44,
    "override_increase_1": 238.73
  },
  {
    "#": "123 Winthrop Rd, Unit 1B (217-42-09)",
    "$": 814100,
    "address": "123 Winthrop Rd, Unit 1B",
    "parcel_id": "217-42-09",
    "owner1": "MARTEL TRS, CYDNEY R & DAVID A",
    "owner2": "",
    "current_taxes": 8336.38,
    "new_taxes_no_override": 8696.51,
    "override_total_1": 8943.27,
    "override_increase_1": 246.76
  },
  {
    "#": "123 Winthrop Rd, Unit 2B (217-42-10)",
    "$": 714400,
    "address": "123 Winthrop Rd, Unit 2B",
    "parcel_id": "217-42-10",
    "owner1": "ALEKSEYEV, ZELMAN",
    "owner2": "ALEKSEYEVA, BRONISLAVA",
    "current_taxes": 3680.52,
    "new_taxes_no_override": 3839.52,
    "override_total_1": 3948.46,
    "override_increase_1": 108.94
  },
  {
    "#": "123 Winthrop Rd, Unit 3B & P8 (217-42-11)",
    "$": 873400,
    "address": "123 Winthrop Rd, Unit 3B & P8",
    "parcel_id": "217-42-11",
    "owner1": "JADHAV, ASHUTOSH P",
    "owner2": "JHA, RUCHIRA M",
    "current_taxes": 8943.62,
    "new_taxes_no_override": 9329.98,
    "override_total_1": 9594.72,
    "override_increase_1": 264.73
  },
  {
    "#": "124 Winthrop Rd, Unit 1 Pk-F (219-38-07)",
    "$": 1000900,
    "address": "124 Winthrop Rd, Unit 1 Pk-F",
    "parcel_id": "219-38-07",
    "owner1": "MCLAUGHLIN, FRANCES K",
    "owner2": "",
    "current_taxes": 6614.28,
    "new_taxes_no_override": 6900.02,
    "override_total_1": 7095.8,
    "override_increase_1": 195.78
  },
  {
    "#": "124 Winthrop Rd, Unit 2 Pk G-H (219-38-01)",
    "$": 1178400,
    "address": "124 Winthrop Rd, Unit 2 Pk G-H",
    "parcel_id": "219-38-01",
    "owner1": "KARON, JONATHAN A & KIMBERLY D",
    "owner2": "",
    "current_taxes": 8431.88,
    "new_taxes_no_override": 8796.14,
    "override_total_1": 9045.72,
    "override_increase_1": 249.58
  },
  {
    "#": "124 Winthrop Rd, Unit 3 Pk-B-I (219-38-02)",
    "$": 1459400,
    "address": "124 Winthrop Rd, Unit 3 Pk-B-I",
    "parcel_id": "219-38-02",
    "owner1": "PHILBIN, THOMAS RUSSELL & KRISTINE WHITFIELD",
    "owner2": "",
    "current_taxes": 14944.26,
    "new_taxes_no_override": 15589.85,
    "override_total_1": 16032.2,
    "override_increase_1": 442.35
  },
  {
    "#": "124 Winthrop Rd, Unit 4 & Pk-A (219-38-03)",
    "$": 817400,
    "address": "124 Winthrop Rd, Unit 4 & Pk-A",
    "parcel_id": "219-38-03",
    "owner1": "XU, NING",
    "owner2": "",
    "current_taxes": 8370.18,
    "new_taxes_no_override": 8731.77,
    "override_total_1": 8979.53,
    "override_increase_1": 247.76
  },
  {
    "#": "124 Winthrop Rd, Unit 5 & Pk- E (219-38-04)",
    "$": 790600,
    "address": "124 Winthrop Rd, Unit 5 & Pk- E",
    "parcel_id": "219-38-04",
    "owner1": "ARONSON TR, PATRICIA K",
    "owner2": "",
    "current_taxes": 4460.81,
    "new_taxes_no_override": 4653.52,
    "override_total_1": 4785.56,
    "override_increase_1": 132.04
  },
  {
    "#": "124 Winthrop Rd, Unit 6 & Pk-D (219-38-05)",
    "$": 626800,
    "address": "124 Winthrop Rd, Unit 6 & Pk-D",
    "parcel_id": "219-38-05",
    "owner1": "DAKOULAS, SAMANTHA RENE",
    "owner2": "TORRALBA, MICHAEL EDLIN",
    "current_taxes": 2783.5,
    "new_taxes_no_override": 2903.75,
    "override_total_1": 2986.14,
    "override_increase_1": 82.39
  },
  {
    "#": "124 Winthrop Rd, Unit 7 & Pk-C (219-38-06)",
    "$": 797300,
    "address": "124 Winthrop Rd, Unit 7 & Pk-C",
    "parcel_id": "219-38-06",
    "owner1": "YU, CHUN L",
    "owner2": "",
    "current_taxes": 8164.35,
    "new_taxes_no_override": 8517.05,
    "override_total_1": 8758.71,
    "override_increase_1": 241.66
  },
  {
    "#": "127 Winthrop Rd, Unit 1 & P5 (217-42-12)",
    "$": 600400,
    "address": "127 Winthrop Rd, Unit 1 & P5",
    "parcel_id": "217-42-12",
    "owner1": "SCHULER, KATHARINE",
    "owner2": "",
    "current_taxes": 2513.16,
    "new_taxes_no_override": 2621.73,
    "override_total_1": 2696.12,
    "override_increase_1": 74.39
  },
  {
    "#": "127 Winthrop Rd, Unit 12A (217-42-19)",
    "$": 717300,
    "address": "127 Winthrop Rd, Unit 12A",
    "parcel_id": "217-42-19",
    "owner1": "OH TR, JULIE ANN",
    "owner2": "",
    "current_taxes": 7345.15,
    "new_taxes_no_override": 7662.46,
    "override_total_1": 7879.88,
    "override_increase_1": 217.42
  },
  {
    "#": "127 Winthrop Rd, Unit 1A (217-42-13)",
    "$": 710000,
    "address": "127 Winthrop Rd, Unit 1A",
    "parcel_id": "217-42-13",
    "owner1": "WYMAN, PAIGE C",
    "owner2": "",
    "current_taxes": 3635.47,
    "new_taxes_no_override": 3792.52,
    "override_total_1": 3900.13,
    "override_increase_1": 107.61
  },
  {
    "#": "127 Winthrop Rd, Unit 2A & P7 (217-42-14)",
    "$": 1141600,
    "address": "127 Winthrop Rd, Unit 2A & P7",
    "parcel_id": "217-42-14",
    "owner1": "AXELROD, IRA & NANCY S & JOSEPH W",
    "owner2": "",
    "current_taxes": 8055.05,
    "new_taxes_no_override": 8403.03,
    "override_total_1": 8641.46,
    "override_increase_1": 238.43
  },
  {
    "#": "127 Winthrop Rd, Unit 3A & P2 (217-42-15)",
    "$": 1183900,
    "address": "127 Winthrop Rd, Unit 3A & P2",
    "parcel_id": "217-42-15",
    "owner1": "FISHER, DAVID & NANCY",
    "owner2": "",
    "current_taxes": 8488.2,
    "new_taxes_no_override": 8854.89,
    "override_total_1": 9106.14,
    "override_increase_1": 251.25
  },
  {
    "#": "127 Winthrop Rd, Unit 4A & P10 (217-42-16)",
    "$": 1302300,
    "address": "127 Winthrop Rd, Unit 4A & P10",
    "parcel_id": "217-42-16",
    "owner1": "RODEHAVER, MARK W",
    "owner2": "VAN KENNEN, KAREN",
    "current_taxes": 9700.62,
    "new_taxes_no_override": 10119.69,
    "override_total_1": 10406.83,
    "override_increase_1": 287.14
  },
  {
    "#": "127 Winthrop Rd, Unit 5A & P9 (217-42-17)",
    "$": 1172300,
    "address": "127 Winthrop Rd, Unit 5A & P9",
    "parcel_id": "217-42-17",
    "owner1": "ZHOU, JESSICA L",
    "owner2": "",
    "current_taxes": 8369.42,
    "new_taxes_no_override": 8730.98,
    "override_total_1": 8978.71,
    "override_increase_1": 247.73
  },
  {
    "#": "127 Winthrop Rd, Unit 6A & P3 (217-42-18)",
    "$": 1192000,
    "address": "127 Winthrop Rd, Unit 6A & P3",
    "parcel_id": "217-42-18",
    "owner1": "RUPRECHT, RUTH M",
    "owner2": "",
    "current_taxes": 12206.08,
    "new_taxes_no_override": 12733.38,
    "override_total_1": 13094.68,
    "override_increase_1": 361.3
  },
  {
    "#": "135 Winthrop Rd (217-41-00)",
    "$": 3112300,
    "address": "135 Winthrop Rd",
    "parcel_id": "217-41-00",
    "owner1": "WATSON, ALICE",
    "owner2": "BELL, ALASTAIR",
    "current_taxes": 28235.02,
    "new_taxes_no_override": 29454.77,
    "override_total_1": 30290.53,
    "override_increase_1": 835.76
  },
  {
    "#": "139 Winthrop Rd (217-40-00)",
    "$": 2874600,
    "address": "139 Winthrop Rd",
    "parcel_id": "217-40-00",
    "owner1": "MCDEVITT TR, PATRICK",
    "owner2": "C/O PHOENIX REALTY",
    "current_taxes": 29435.9,
    "new_taxes_no_override": 30707.53,
    "override_total_1": 31578.83,
    "override_increase_1": 871.3
  },
  {
    "#": "145 Winthrop Rd, Unit 1 (217-37-24)",
    "$": 439100,
    "address": "145 Winthrop Rd, Unit 1",
    "parcel_id": "217-37-24",
    "owner1": "ABBATE, MARK",
    "owner2": "",
    "current_taxes": 861.45,
    "new_taxes_no_override": 898.66,
    "override_total_1": 924.16,
    "override_increase_1": 25.5
  },
  {
    "#": "145 Winthrop Rd, Unit 2 (217-37-01)",
    "$": 421400,
    "address": "145 Winthrop Rd, Unit 2",
    "parcel_id": "217-37-01",
    "owner1": "LOPEZ, SAUL & ANNA LUCIA TOVAR D",
    "owner2": "",
    "current_taxes": 680.2,
    "new_taxes_no_override": 709.58,
    "override_total_1": 729.72,
    "override_increase_1": 20.13
  },
  {
    "#": "145 Winthrop Rd, Unit 3 & P-A-11 (217-37-02)",
    "$": 656900,
    "address": "145 Winthrop Rd, Unit 3 & P-A-11",
    "parcel_id": "217-37-02",
    "owner1": "KNUBOVETS, TATYANA",
    "owner2": "",
    "current_taxes": 6726.66,
    "new_taxes_no_override": 7017.25,
    "override_total_1": 7216.36,
    "override_increase_1": 199.11
  },
  {
    "#": "145 Winthrop Rd, Unit 4 (217-37-03)",
    "$": 378700,
    "address": "145 Winthrop Rd, Unit 4",
    "parcel_id": "217-37-03",
    "owner1": "ZELIKMAN LIFE ESTATE, LUBA",
    "owner2": "",
    "current_taxes": 387.79,
    "new_taxes_no_override": 404.54,
    "override_total_1": 416.02,
    "override_increase_1": 11.48
  },
  {
    "#": "145 Winthrop Rd, Unit 5 (217-37-04)",
    "$": 699600,
    "address": "145 Winthrop Rd, Unit 5",
    "parcel_id": "217-37-04",
    "owner1": "HYMAN, MIRIAM S",
    "owner2": "WEINER, DANIEL M",
    "current_taxes": 3528.97,
    "new_taxes_no_override": 3681.42,
    "override_total_1": 3785.88,
    "override_increase_1": 104.46
  },
  {
    "#": "145 Winthrop Rd, Unit 6 (217-37-05)",
    "$": 387700,
    "address": "145 Winthrop Rd, Unit 6",
    "parcel_id": "217-37-05",
    "owner1": "KAO, SUSANA S K",
    "owner2": "",
    "current_taxes": 3970.05,
    "new_taxes_no_override": 4141.56,
    "override_total_1": 4259.07,
    "override_increase_1": 117.51
  },
  {
    "#": "145 Winthrop Rd, Unit 7 & P-A-2 (217-37-06)",
    "$": 778000,
    "address": "145 Winthrop Rd, Unit 7 & P-A-2",
    "parcel_id": "217-37-06",
    "owner1": "PIEKARSKI, CAROLINE H & DANIEL J",
    "owner2": "",
    "current_taxes": 4331.79,
    "new_taxes_no_override": 4518.92,
    "override_total_1": 4647.14,
    "override_increase_1": 128.22
  },
  {
    "#": "145 Winthrop Rd, Unit 8 Pk A-10 (217-37-07)",
    "$": 442900,
    "address": "145 Winthrop Rd, Unit 8 Pk A-10",
    "parcel_id": "217-37-07",
    "owner1": "RAMANAN, RADHIKA",
    "owner2": "",
    "current_taxes": 4535.3,
    "new_taxes_no_override": 4731.22,
    "override_total_1": 4865.47,
    "override_increase_1": 134.24
  },
  {
    "#": "146 Winthrop Rd, Unit A (220-78-02)",
    "$": 1343400,
    "address": "146 Winthrop Rd, Unit A",
    "parcel_id": "220-78-02",
    "owner1": "REIS, JONATHAN & AVA HADDAD",
    "owner2": "",
    "current_taxes": 10121.48,
    "new_taxes_no_override": 10558.73,
    "override_total_1": 10858.32,
    "override_increase_1": 299.6
  },
  {
    "#": "146 Winthrop Rd, Unit B (220-78-01)",
    "$": 1505400,
    "address": "146 Winthrop Rd, Unit B",
    "parcel_id": "220-78-01",
    "owner1": "DHITAL, SAURAV",
    "owner2": "ATALAY, ALEV J",
    "current_taxes": 11780.36,
    "new_taxes_no_override": 12289.27,
    "override_total_1": 12637.97,
    "override_increase_1": 348.7
  },
  {
    "#": "147 Winthrop Rd, Unit 1 Pa-6 (217-37-08)",
    "$": 421000,
    "address": "147 Winthrop Rd, Unit 1 Pa-6",
    "parcel_id": "217-37-08",
    "owner1": "KALMAN, RON A",
    "owner2": "",
    "current_taxes": 676.11,
    "new_taxes_no_override": 705.32,
    "override_total_1": 725.33,
    "override_increase_1": 20.01
  },
  {
    "#": "147 Winthrop Rd, Unit 2 (217-37-09)",
    "$": 333200,
    "address": "147 Winthrop Rd, Unit 2",
    "parcel_id": "217-37-09",
    "owner1": "ZAVAL, PETER & JESSICA",
    "owner2": "",
    "current_taxes": 3411.97,
    "new_taxes_no_override": 3559.37,
    "override_total_1": 3660.36,
    "override_increase_1": 100.99
  },
  {
    "#": "147 Winthrop Rd, Unit 3 & P2 (217-37-10)",
    "$": 676000,
    "address": "147 Winthrop Rd, Unit 3 & P2",
    "parcel_id": "217-37-10",
    "owner1": "147 WINTHROP ROAD REALTY LLC",
    "owner2": "C/O CATHERINE WU",
    "current_taxes": 6922.24,
    "new_taxes_no_override": 7221.28,
    "override_total_1": 7426.18,
    "override_increase_1": 204.9
  },
  {
    "#": "147 Winthrop Rd, Unit 4 & P-A-8 (217-37-11)",
    "$": 442900,
    "address": "147 Winthrop Rd, Unit 4 & P-A-8",
    "parcel_id": "217-37-11",
    "owner1": "SHIRAHAMA, SEIYA-JUN-KRISTIN WILDMAN",
    "owner2": "",
    "current_taxes": 4535.3,
    "new_taxes_no_override": 4731.22,
    "override_total_1": 4865.47,
    "override_increase_1": 134.24
  },
  {
    "#": "147 Winthrop Rd, Unit 5 & P-A-5 (217-37-12)",
    "$": 728000,
    "address": "147 Winthrop Rd, Unit 5 & P-A-5",
    "parcel_id": "217-37-12",
    "owner1": "ZILBERBERG, ALINA",
    "owner2": "",
    "current_taxes": 3819.79,
    "new_taxes_no_override": 3984.8,
    "override_total_1": 4097.87,
    "override_increase_1": 113.07
  },
  {
    "#": "147 Winthrop Rd, Unit 6 (217-37-13)",
    "$": 387700,
    "address": "147 Winthrop Rd, Unit 6",
    "parcel_id": "217-37-13",
    "owner1": "NALLADARU, YEZAD",
    "owner2": "",
    "current_taxes": 3970.05,
    "new_taxes_no_override": 4141.56,
    "override_total_1": 4259.07,
    "override_increase_1": 117.51
  },
  {
    "#": "147 Winthrop Rd, Unit 7 & P-A-9 (217-37-14)",
    "$": 807800,
    "address": "147 Winthrop Rd, Unit 7 & P-A-9",
    "parcel_id": "217-37-14",
    "owner1": "DEMONT TR, MARK",
    "owner2": "",
    "current_taxes": 8271.87,
    "new_taxes_no_override": 8629.21,
    "override_total_1": 8874.06,
    "override_increase_1": 244.85
  },
  {
    "#": "147 Winthrop Rd, Unit 8 & P-A-12 (217-37-15)",
    "$": 442900,
    "address": "147 Winthrop Rd, Unit 8 & P-A-12",
    "parcel_id": "217-37-15",
    "owner1": "TREPANIER, TR, RALPH D & LEILA MARIE",
    "owner2": "",
    "current_taxes": 4535.3,
    "new_taxes_no_override": 4731.22,
    "override_total_1": 4865.47,
    "override_increase_1": 134.24
  },
  {
    "#": "149 Winthrop Rd, Unit 1 (217-37-16)",
    "$": 425800,
    "address": "149 Winthrop Rd, Unit 1",
    "parcel_id": "217-37-16",
    "owner1": "FERREIRA-CESAR, MARIA",
    "owner2": "",
    "current_taxes": 4360.19,
    "new_taxes_no_override": 4548.55,
    "override_total_1": 4677.61,
    "override_increase_1": 129.06
  },
  {
    "#": "149 Winthrop Rd, Unit 2 (217-37-17)",
    "$": 487100,
    "address": "149 Winthrop Rd, Unit 2",
    "parcel_id": "217-37-17",
    "owner1": "CABRERA, CRISTINA MARIA SANTOS",
    "owner2": "",
    "current_taxes": 1352.97,
    "new_taxes_no_override": 1411.42,
    "override_total_1": 1451.47,
    "override_increase_1": 40.05
  },
  {
    "#": "149 Winthrop Rd, Unit 3 & P1 (217-37-18)",
    "$": 685100,
    "address": "149 Winthrop Rd, Unit 3 & P1",
    "parcel_id": "217-37-18",
    "owner1": "CHENG, IRENE",
    "owner2": "SNYDER, BRETT",
    "current_taxes": 7015.42,
    "new_taxes_no_override": 7318.49,
    "override_total_1": 7526.14,
    "override_increase_1": 207.66
  },
  {
    "#": "149 Winthrop Rd, Unit 4 & P-A-1 (217-37-19)",
    "$": 442900,
    "address": "149 Winthrop Rd, Unit 4 & P-A-1",
    "parcel_id": "217-37-19",
    "owner1": "BADALAMENTI, GIUSEPPE & MICHELE",
    "owner2": "",
    "current_taxes": 4535.3,
    "new_taxes_no_override": 4731.22,
    "override_total_1": 4865.47,
    "override_increase_1": 134.24
  },
  {
    "#": "149 Winthrop Rd, Unit 5 & P3 (217-37-20)",
    "$": 728100,
    "address": "149 Winthrop Rd, Unit 5 & P3",
    "parcel_id": "217-37-20",
    "owner1": "VAILLANCOURT, ROGER J & ALEXANDRA",
    "owner2": "",
    "current_taxes": 3820.81,
    "new_taxes_no_override": 3985.87,
    "override_total_1": 4098.96,
    "override_increase_1": 113.1
  },
  {
    "#": "149 Winthrop Rd, Unit 6 & P-A-7 (217-37-21)",
    "$": 442900,
    "address": "149 Winthrop Rd, Unit 6 & P-A-7",
    "parcel_id": "217-37-21",
    "owner1": "LAU, STEPHEN",
    "owner2": "",
    "current_taxes": 900.36,
    "new_taxes_no_override": 939.26,
    "override_total_1": 965.91,
    "override_increase_1": 26.65
  },
  {
    "#": "149 Winthrop Rd, Unit 7 & P-A-4 (217-37-22)",
    "$": 786100,
    "address": "149 Winthrop Rd, Unit 7 & P-A-4",
    "parcel_id": "217-37-22",
    "owner1": "GIANTURCO, MARYWYNNE",
    "owner2": "",
    "current_taxes": 4414.73,
    "new_taxes_no_override": 4605.45,
    "override_total_1": 4736.12,
    "override_increase_1": 130.68
  },
  {
    "#": "149 Winthrop Rd, Unit 8 & P-A-3 (217-37-23)",
    "$": 455700,
    "address": "149 Winthrop Rd, Unit 8 & P-A-3",
    "parcel_id": "217-37-23",
    "owner1": "MERMELL, JESSE",
    "owner2": "",
    "current_taxes": 1031.43,
    "new_taxes_no_override": 1075.99,
    "override_total_1": 1106.52,
    "override_increase_1": 30.53
  },
  {
    "#": "152 Winthrop Rd, Unit 1 (220-77-01)",
    "$": 1320100,
    "address": "152 Winthrop Rd, Unit 1",
    "parcel_id": "220-77-01",
    "owner1": "CHANDIA, RODRIGO",
    "owner2": "SANZONETTI, EILEEN",
    "current_taxes": 9882.89,
    "new_taxes_no_override": 10309.83,
    "override_total_1": 10602.36,
    "override_increase_1": 292.53
  },
  {
    "#": "152 Winthrop Rd, Unit 2 & 2 Pk Sps (220-77-02)",
    "$": 1963400,
    "address": "152 Winthrop Rd, Unit 2 & 2 Pk Sps",
    "parcel_id": "220-77-02",
    "owner1": "SOOBEN, KEVIN",
    "owner2": "KEATING, KAREN D",
    "current_taxes": 16470.28,
    "new_taxes_no_override": 17181.8,
    "override_total_1": 17669.32,
    "override_increase_1": 487.52
  },
  {
    "#": "157 Winthrop Rd, Unit 1 (217-36-01)",
    "$": 2681800,
    "address": "157 Winthrop Rd, Unit 1",
    "parcel_id": "217-36-01",
    "owner1": "ORR, ERAN & SHIRA",
    "owner2": "",
    "current_taxes": 23826.7,
    "new_taxes_no_override": 24856.01,
    "override_total_1": 25561.28,
    "override_increase_1": 705.27
  },
  {
    "#": "157 Winthrop Rd, Unit 2 (217-36-02)",
    "$": 2226400,
    "address": "157 Winthrop Rd, Unit 2",
    "parcel_id": "217-36-02",
    "owner1": "FAYNZILBERG, SIMON J",
    "owner2": "SHANKOVICH, S",
    "current_taxes": 19163.4,
    "new_taxes_no_override": 19991.26,
    "override_total_1": 20558.5,
    "override_increase_1": 567.24
  },
  {
    "#": "158 Winthrop Rd, Unit 1 & G5 & 6 (220-76-01)",
    "$": 2245800,
    "address": "158 Winthrop Rd, Unit 1 & G5 & 6",
    "parcel_id": "220-76-01",
    "owner1": "BENHAYON, BONITA C",
    "owner2": "TETRAULT, PETER E",
    "current_taxes": 19362.06,
    "new_taxes_no_override": 20198.5,
    "override_total_1": 20771.62,
    "override_increase_1": 573.12
  },
  {
    "#": "158 Winthrop Rd, Unit 2 & G2C & 3 (220-76-02)",
    "$": 2329800,
    "address": "158 Winthrop Rd, Unit 2 & G2C & 3",
    "parcel_id": "220-76-02",
    "owner1": "KUSHLEFSKY TR, BENNA RUTH",
    "owner2": "",
    "current_taxes": 20222.22,
    "new_taxes_no_override": 21095.82,
    "override_total_1": 21694.4,
    "override_increase_1": 598.58
  },
  {
    "#": "158 Winthrop Rd, Unit 3 & G1C & 4 (220-76-03)",
    "$": 2243500,
    "address": "158 Winthrop Rd, Unit 3 & G1C & 4",
    "parcel_id": "220-76-03",
    "owner1": "SHIN, JEE YOUNG",
    "owner2": "KIM, SUN YOUNG",
    "current_taxes": 19338.51,
    "new_taxes_no_override": 20173.93,
    "override_total_1": 20746.35,
    "override_increase_1": 572.42
  },
  {
    "#": "158 Winthrop Rd, Unit 4 & G7 & 9 (220-76-04)",
    "$": 2243500,
    "address": "158 Winthrop Rd, Unit 4 & G7 & 9",
    "parcel_id": "220-76-04",
    "owner1": "SILVERMAN TR, STEWART J",
    "owner2": "",
    "current_taxes": 19338.51,
    "new_taxes_no_override": 20173.93,
    "override_total_1": 20746.35,
    "override_increase_1": 572.42
  },
  {
    "#": "158 Winthrop Rd, Unit 5 & G8 & 10 (220-76-05)",
    "$": 2580800,
    "address": "158 Winthrop Rd, Unit 5 & G8 & 10",
    "parcel_id": "220-76-05",
    "owner1": "SAXENA, SAPNA",
    "owner2": "GHOSH, ARIJIT",
    "current_taxes": 22792.46,
    "new_taxes_no_override": 23777.09,
    "override_total_1": 24451.75,
    "override_increase_1": 674.66
  },
  {
    "#": "164 Winthrop Rd (220-75-00)",
    "$": 2650900,
    "address": "164 Winthrop Rd",
    "parcel_id": "220-75-00",
    "owner1": "LEE, TR, MUN JUNG",
    "owner2": "",
    "current_taxes": 27145.22,
    "new_taxes_no_override": 28317.89,
    "override_total_1": 29121.39,
    "override_increase_1": 803.5
  },
  {
    "#": "165 Winthrop Rd (217-35-00)",
    "$": 3553400,
    "address": "165 Winthrop Rd",
    "parcel_id": "217-35-00",
    "owner1": "COOPER, TRS, MARC L & SUSAN L",
    "owner2": "",
    "current_taxes": 36386.82,
    "new_taxes_no_override": 37958.73,
    "override_total_1": 39035.78,
    "override_increase_1": 1077.05
  },
  {
    "#": "168 Winthrop Rd (220-73-74)",
    "$": 7617100,
    "address": "168 Winthrop Rd",
    "parcel_id": "220-73-74",
    "owner1": "WINTHROP 168 LLC",
    "owner2": "",
    "current_taxes": 77999.1,
    "new_taxes_no_override": 81368.66,
    "override_total_1": 83677.43,
    "override_increase_1": 2308.77
  },
  {
    "#": "175 Winthrop Rd, Unit 1 (217-34-01)",
    "$": 910900,
    "address": "175 Winthrop Rd, Unit 1",
    "parcel_id": "217-34-01",
    "owner1": "RAHMANDAD, HAZHIR",
    "owner2": "SARKHILI, SARA",
    "current_taxes": 9327.62,
    "new_taxes_no_override": 9730.57,
    "override_total_1": 10006.67,
    "override_increase_1": 276.1
  },
  {
    "#": "175 Winthrop Rd, Unit 2 (217-34-02)",
    "$": 1196600,
    "address": "175 Winthrop Rd, Unit 2",
    "parcel_id": "217-34-02",
    "owner1": "VERAKSA, ALEXEY",
    "owner2": "GUSEVA, ALEVTINA",
    "current_taxes": 8618.25,
    "new_taxes_no_override": 8990.56,
    "override_total_1": 9245.66,
    "override_increase_1": 255.1
  },
  {
    "#": "175 Winthrop Rd, Unit 3 (217-34-03)",
    "$": 1600300,
    "address": "175 Winthrop Rd, Unit 3",
    "parcel_id": "217-34-03",
    "owner1": "ROBISON, KATHRYN",
    "owner2": "D ARCANGELO, MATTHEW",
    "current_taxes": 16387.07,
    "new_taxes_no_override": 17094.99,
    "override_total_1": 17580.05,
    "override_increase_1": 485.06
  },
  {
    "#": "177 Winthrop Rd, Unit 1 (217-33-01)",
    "$": 801400,
    "address": "177 Winthrop Rd, Unit 1",
    "parcel_id": "217-33-01",
    "owner1": "MADDOX, MARGARET F",
    "owner2": "",
    "current_taxes": 4571.4,
    "new_taxes_no_override": 4768.88,
    "override_total_1": 4904.2,
    "override_increase_1": 135.31
  },
  {
    "#": "177 Winthrop Rd, Unit 2 (217-33-02)",
    "$": 1246400,
    "address": "177 Winthrop Rd, Unit 2",
    "parcel_id": "217-33-02",
    "owner1": "ANASTAS, ADAM J",
    "owner2": "NAHIGIAN, ANDREA D",
    "current_taxes": 9128.2,
    "new_taxes_no_override": 9522.54,
    "override_total_1": 9792.73,
    "override_increase_1": 270.19
  },
  {
    "#": "177 Winthrop Rd, Unit 3 (217-33-03)",
    "$": 1323500,
    "address": "177 Winthrop Rd, Unit 3",
    "parcel_id": "217-33-03",
    "owner1": "FU, YUN",
    "owner2": "GUO, WENTING",
    "current_taxes": 9917.71,
    "new_taxes_no_override": 10346.16,
    "override_total_1": 10639.72,
    "override_increase_1": 293.56
  },
  {
    "#": "177 Winthrop Rd, Unit 4 (217-33-04)",
    "$": 1401400,
    "address": "177 Winthrop Rd, Unit 4",
    "parcel_id": "217-33-04",
    "owner1": "SMITH, MICHAEL HANSCOM",
    "owner2": "LU, YING-TSUNG",
    "current_taxes": 10715.4,
    "new_taxes_no_override": 11178.31,
    "override_total_1": 11495.48,
    "override_increase_1": 317.18
  },
  {
    "#": "181 Winthrop Rd (217-32-00)",
    "$": 4192900,
    "address": "181 Winthrop Rd",
    "parcel_id": "217-32-00",
    "owner1": "SANIEOFF TR, SYROOS",
    "owner2": "",
    "current_taxes": 42935.3,
    "new_taxes_no_override": 44790.1,
    "override_total_1": 46060.99,
    "override_increase_1": 1270.88
  },
  {
    "#": "185 Winthrop Rd (217-31-00)",
    "$": 2883900,
    "address": "185 Winthrop Rd",
    "parcel_id": "217-31-00",
    "owner1": "ENG TR, DUNCAN",
    "owner2": "",
    "current_taxes": 29531.14,
    "new_taxes_no_override": 30806.89,
    "override_total_1": 31681.01,
    "override_increase_1": 874.12
  },
  {
    "#": "187 Winthrop Rd (217-30-00)",
    "$": 3359900,
    "address": "187 Winthrop Rd",
    "parcel_id": "217-30-00",
    "owner1": "187 WINTHROP ROAD LLC",
    "owner2": "",
    "current_taxes": 34405.38,
    "new_taxes_no_override": 35891.69,
    "override_total_1": 36910.09,
    "override_increase_1": 1018.4
  },
  {
    "#": "191 Winthrop Rd (217-29-00)",
    "$": 4382100,
    "address": "191 Winthrop Rd",
    "parcel_id": "217-29-00",
    "owner1": "191 WINTHROP ST LLC",
    "owner2": "",
    "current_taxes": 44872.7,
    "new_taxes_no_override": 46811.2,
    "override_total_1": 48139.43,
    "override_increase_1": 1328.23
  },
  {
    "#": "195 Winthrop Rd, Unit 1 (217-28-03)",
    "$": 1259400,
    "address": "195 Winthrop Rd, Unit 1",
    "parcel_id": "217-28-03",
    "owner1": "VASIOS, GEORGE & CLAIRE",
    "owner2": "",
    "current_taxes": 9261.32,
    "new_taxes_no_override": 9661.41,
    "override_total_1": 9935.54,
    "override_increase_1": 274.14
  },
  {
    "#": "195 Winthrop Rd, Unit 2 (217-28-01)",
    "$": 978400,
    "address": "195 Winthrop Rd, Unit 2",
    "parcel_id": "217-28-01",
    "owner1": "GROSS TR, ESTHER C",
    "owner2": "",
    "current_taxes": 6383.88,
    "new_taxes_no_override": 6659.66,
    "override_total_1": 6848.63,
    "override_increase_1": 188.96
  },
  {
    "#": "195 Winthrop Rd, Unit 3 (217-28-02)",
    "$": 983800,
    "address": "195 Winthrop Rd, Unit 3",
    "parcel_id": "217-28-02",
    "owner1": "PINSKY, EUGENE & LUDMILA",
    "owner2": "",
    "current_taxes": 10074.11,
    "new_taxes_no_override": 10509.31,
    "override_total_1": 10807.51,
    "override_increase_1": 298.19
  },
  {
    "#": "199 Winthrop Rd (217-27-00)",
    "$": 4459800,
    "address": "199 Winthrop Rd",
    "parcel_id": "217-27-00",
    "owner1": "THE JOHN P DOYLE FAMILY, LIMITED PARTNERSHIP",
    "owner2": "",
    "current_taxes": 45668.35,
    "new_taxes_no_override": 47641.22,
    "override_total_1": 48993.01,
    "override_increase_1": 1351.78
  },
  {
    "#": "203 Winthrop Rd (217-26-00)",
    "$": 3599600,
    "address": "203 Winthrop Rd",
    "parcel_id": "217-26-00",
    "owner1": "DDG WINTHROP LLC",
    "owner2": "",
    "current_taxes": 36859.9,
    "new_taxes_no_override": 38452.25,
    "override_total_1": 39543.3,
    "override_increase_1": 1091.05
  },
  {
    "#": "208 Winthrop Rd (224-33-00)",
    "$": 10230400,
    "address": "208 Winthrop Rd",
    "parcel_id": "224-33-00",
    "owner1": "NORA LLC",
    "owner2": "",
    "current_taxes": 104759.3,
    "new_taxes_no_override": 109284.9,
    "override_total_1": 112385.78,
    "override_increase_1": 3100.88
  },
  {
    "#": "210 Winthrop Rd (224-32-00)",
    "$": 8309600,
    "address": "210 Winthrop Rd",
    "parcel_id": "224-32-00",
    "owner1": "210 WINTHROP ROAD LLC",
    "owner2": "",
    "current_taxes": 85090.3,
    "new_taxes_no_override": 88766.2,
    "override_total_1": 91284.87,
    "override_increase_1": 2518.67
  },
  {
    "#": "8 Wolcott Rd (399-19-00)",
    "$": 1447300,
    "address": "8 Wolcott Rd",
    "parcel_id": "399-19-00",
    "owner1": "SONG, QIAN",
    "owner2": "LI, ZHONGDA",
    "current_taxes": 11185.42,
    "new_taxes_no_override": 11668.63,
    "override_total_1": 11999.72,
    "override_increase_1": 331.09
  },
  {
    "#": "9 Wolcott Rd (402-27-00)",
    "$": 1305200,
    "address": "9 Wolcott Rd",
    "parcel_id": "402-27-00",
    "owner1": "RAFATI, BEHNAM",
    "owner2": "MEHRABI, MITRA",
    "current_taxes": 9730.31,
    "new_taxes_no_override": 10150.66,
    "override_total_1": 10438.68,
    "override_increase_1": 288.02
  },
  {
    "#": "14 Wolcott Rd (399-18-00)",
    "$": 1745400,
    "address": "14 Wolcott Rd",
    "parcel_id": "399-18-00",
    "owner1": "JACKSON, DAVID",
    "owner2": "WANG, HEJIA",
    "current_taxes": 17872.9,
    "new_taxes_no_override": 18645.01,
    "override_total_1": 19174.05,
    "override_increase_1": 529.04
  },
  {
    "#": "18 Wolcott Rd (399-17-00)",
    "$": 1346900,
    "address": "18 Wolcott Rd",
    "parcel_id": "399-17-00",
    "owner1": "MCNAMARA, DANIEL & ASHLEY",
    "owner2": "",
    "current_taxes": 13792.26,
    "new_taxes_no_override": 14388.09,
    "override_total_1": 14796.34,
    "override_increase_1": 408.25
  },
  {
    "#": "19 Wolcott Rd (402-26-00)",
    "$": 1103700,
    "address": "19 Wolcott Rd",
    "parcel_id": "402-26-00",
    "owner1": "AGARWAL, SHIKHAR",
    "owner2": "GUPTA, SRISHTI",
    "current_taxes": 7666.95,
    "new_taxes_no_override": 7998.16,
    "override_total_1": 8225.1,
    "override_increase_1": 226.94
  },
  {
    "#": "24 Wolcott Rd (399-16-00)",
    "$": 1302600,
    "address": "24 Wolcott Rd",
    "parcel_id": "399-16-00",
    "owner1": "SIRIWARDANA, NIRODHINI",
    "owner2": "AMUNUGAMA, RAVINDRA",
    "current_taxes": 9703.69,
    "new_taxes_no_override": 10122.89,
    "override_total_1": 10410.12,
    "override_increase_1": 287.23
  },
  {
    "#": "27 Wolcott Rd (402-25-00)",
    "$": 3645500,
    "address": "27 Wolcott Rd",
    "parcel_id": "402-25-00",
    "owner1": "SOUSA, LISA B",
    "owner2": "",
    "current_taxes": 33694.99,
    "new_taxes_no_override": 35150.61,
    "override_total_1": 36147.99,
    "override_increase_1": 997.37
  },
  {
    "#": "28 Wolcott Rd (399-15-00)",
    "$": 1590900,
    "address": "28 Wolcott Rd",
    "parcel_id": "399-15-00",
    "owner1": "HEH, RUI",
    "owner2": "LI, YUAN",
    "current_taxes": 16290.82,
    "new_taxes_no_override": 16994.58,
    "override_total_1": 17476.79,
    "override_increase_1": 482.21
  },
  {
    "#": "31 Wolcott Rd (402-24-00)",
    "$": 1470900,
    "address": "31 Wolcott Rd",
    "parcel_id": "402-24-00",
    "owner1": "WEBER TRS, MARCIA & ALFRED",
    "owner2": "",
    "current_taxes": 11427.08,
    "new_taxes_no_override": 11920.73,
    "override_total_1": 12258.97,
    "override_increase_1": 338.24
  },
  {
    "#": "34 Wolcott Rd (399-14-00)",
    "$": 1525100,
    "address": "34 Wolcott Rd",
    "parcel_id": "399-14-00",
    "owner1": "YE, MIN",
    "owner2": "CHAI, YUNRONG",
    "current_taxes": 11982.09,
    "new_taxes_no_override": 12499.72,
    "override_total_1": 12854.39,
    "override_increase_1": 354.67
  },
  {
    "#": "37 Wolcott Rd (402-23-00)",
    "$": 2080600,
    "address": "37 Wolcott Rd",
    "parcel_id": "402-23-00",
    "owner1": "COHEN TR, NEIL S",
    "owner2": "",
    "current_taxes": 21305.34,
    "new_taxes_no_override": 22225.73,
    "override_total_1": 22856.37,
    "override_increase_1": 630.64
  },
  {
    "#": "43 Wolcott Rd (402-22-00)",
    "$": 1291200,
    "address": "43 Wolcott Rd",
    "parcel_id": "402-22-00",
    "owner1": "CORCORAN TRS, MADELEINE M & JACQUELINE M",
    "owner2": "",
    "current_taxes": 9586.95,
    "new_taxes_no_override": 10001.11,
    "override_total_1": 10284.88,
    "override_increase_1": 283.77
  },
  {
    "#": "47 Wolcott Rd (402-21-00)",
    "$": 1456600,
    "address": "47 Wolcott Rd",
    "parcel_id": "402-21-00",
    "owner1": "BROMFIELD TRS, RICHARD N & DEBRA L",
    "owner2": "",
    "current_taxes": 11280.65,
    "new_taxes_no_override": 11767.97,
    "override_total_1": 12101.88,
    "override_increase_1": 333.91
  },
  {
    "#": "51 Wolcott Rd (402-20-00)",
    "$": 1487800,
    "address": "51 Wolcott Rd",
    "parcel_id": "402-20-00",
    "owner1": "KYL LLP",
    "owner2": "",
    "current_taxes": 15235.07,
    "new_taxes_no_override": 15893.23,
    "override_total_1": 16344.18,
    "override_increase_1": 450.96
  },
  {
    "#": "55 Wolcott Rd (402-19-00)",
    "$": 1622000,
    "address": "55 Wolcott Rd",
    "parcel_id": "402-19-00",
    "owner1": "FOX, CHRISTOPHER",
    "owner2": "FALK, LAURA M L",
    "current_taxes": 12974.35,
    "new_taxes_no_override": 13534.84,
    "override_total_1": 13918.88,
    "override_increase_1": 384.04
  },
  {
    "#": "58 Wolcott Rd (401-14-00)",
    "$": 1337800,
    "address": "58 Wolcott Rd",
    "parcel_id": "401-14-00",
    "owner1": "WU, XINQI",
    "owner2": "XU, LIHUI",
    "current_taxes": 10064.14,
    "new_taxes_no_override": 10498.91,
    "override_total_1": 10796.81,
    "override_increase_1": 297.9
  },
  {
    "#": "61 Wolcott Rd (402-18-00)",
    "$": 1575500,
    "address": "61 Wolcott Rd",
    "parcel_id": "402-18-00",
    "owner1": "SOARES, MATTHEW V",
    "owner2": "KNOWLTON, KATHERINE A",
    "current_taxes": 12498.19,
    "new_taxes_no_override": 13038.11,
    "override_total_1": 13408.06,
    "override_increase_1": 369.95
  },
  {
    "#": "64 Wolcott Rd (401-13-00)",
    "$": 1250600,
    "address": "64 Wolcott Rd",
    "parcel_id": "401-13-00",
    "owner1": "SHANE, CHRISTINE L",
    "owner2": "",
    "current_taxes": 9171.21,
    "new_taxes_no_override": 9567.41,
    "override_total_1": 9838.87,
    "override_increase_1": 271.47
  },
  {
    "#": "65 Wolcott Rd (402-17-00)",
    "$": 1470800,
    "address": "65 Wolcott Rd",
    "parcel_id": "402-17-00",
    "owner1": "PODER TRS, DANIEL & AIVAN",
    "owner2": "",
    "current_taxes": 11426.06,
    "new_taxes_no_override": 11919.67,
    "override_total_1": 12257.88,
    "override_increase_1": 338.21
  },
  {
    "#": "68 Wolcott Rd (401-12-00)",
    "$": 1407500,
    "address": "68 Wolcott Rd",
    "parcel_id": "401-12-00",
    "owner1": "BREWER TRS, WILLIAM CONANT III",
    "owner2": "ANDERSON, LORRIE R",
    "current_taxes": 10777.87,
    "new_taxes_no_override": 11243.47,
    "override_total_1": 11562.5,
    "override_increase_1": 319.02
  },
  {
    "#": "69 Wolcott Rd (402-16-00)",
    "$": 1379600,
    "address": "69 Wolcott Rd",
    "parcel_id": "402-16-00",
    "owner1": "JOSEPH, ANDREI I",
    "owner2": "ROGERS, PAMELA A",
    "current_taxes": 10492.17,
    "new_taxes_no_override": 10945.43,
    "override_total_1": 11256.0,
    "override_increase_1": 310.57
  },
  {
    "#": "75 Wolcott Rd (402-15-00)",
    "$": 1518400,
    "address": "75 Wolcott Rd",
    "parcel_id": "402-15-00",
    "owner1": "ROTENBERG, GEORGINA & ALEXANDER",
    "owner2": "",
    "current_taxes": 11913.48,
    "new_taxes_no_override": 12428.14,
    "override_total_1": 12780.78,
    "override_increase_1": 352.64
  },
  {
    "#": "78 Wolcott Rd (401-11-00)",
    "$": 1564500,
    "address": "78 Wolcott Rd",
    "parcel_id": "401-11-00",
    "owner1": "SCHMIDT TRS, RICHARD F JR & JANICE M",
    "owner2": "",
    "current_taxes": 12385.55,
    "new_taxes_no_override": 12920.61,
    "override_total_1": 13287.22,
    "override_increase_1": 366.61
  },
  {
    "#": "79 Wolcott Rd (402-14-00)",
    "$": 1600100,
    "address": "79 Wolcott Rd",
    "parcel_id": "402-14-00",
    "owner1": "RICHARDS, PAUL G",
    "owner2": "MAY, LISA M",
    "current_taxes": 12750.09,
    "new_taxes_no_override": 13300.89,
    "override_total_1": 13678.3,
    "override_increase_1": 377.4
  },
  {
    "#": "84 Wolcott Rd (401-10-00)",
    "$": 1818600,
    "address": "84 Wolcott Rd",
    "parcel_id": "401-10-00",
    "owner1": "DRUMMOND, BRUCE & LISA",
    "owner2": "",
    "current_taxes": 14987.53,
    "new_taxes_no_override": 15634.99,
    "override_total_1": 16078.62,
    "override_increase_1": 443.63
  },
  {
    "#": "85 Wolcott Rd (402-13-00)",
    "$": 1973200,
    "address": "85 Wolcott Rd",
    "parcel_id": "402-13-00",
    "owner1": "KHANDEKAR, SRAVANA",
    "owner2": "",
    "current_taxes": 16570.63,
    "new_taxes_no_override": 17286.48,
    "override_total_1": 17776.97,
    "override_increase_1": 490.49
  },
  {
    "#": "89 Wolcott Rd (402-12-00)",
    "$": 1184800,
    "address": "89 Wolcott Rd",
    "parcel_id": "402-12-00",
    "owner1": "ALLEN, JEFFREY & ANGELA",
    "owner2": "",
    "current_taxes": 8497.42,
    "new_taxes_no_override": 8864.51,
    "override_total_1": 9116.03,
    "override_increase_1": 251.52
  },
  {
    "#": "93 Wolcott Rd (402-11-00)",
    "$": 1465200,
    "address": "93 Wolcott Rd",
    "parcel_id": "402-11-00",
    "owner1": "ZHANG, TING TING",
    "owner2": "MASUCH, BENJAMIN ALISTER ROSS",
    "current_taxes": 11368.71,
    "new_taxes_no_override": 11859.84,
    "override_total_1": 12196.35,
    "override_increase_1": 336.51
  },
  {
    "#": "96 Wolcott Rd (401-09-00)",
    "$": 1814800,
    "address": "96 Wolcott Rd",
    "parcel_id": "401-09-00",
    "owner1": "HSU, HUANG-CHE",
    "owner2": "KUO, TZU-HSING",
    "current_taxes": 18583.55,
    "new_taxes_no_override": 19386.36,
    "override_total_1": 19936.43,
    "override_increase_1": 550.07
  },
  {
    "#": "100 Wolcott Rd (401-07-00)",
    "$": 1720300,
    "address": "100 Wolcott Rd",
    "parcel_id": "401-07-00",
    "owner1": "VAN DER ZIEL, ET AL TRS, CORNELIA H J",
    "owner2": "",
    "current_taxes": 13980.94,
    "new_taxes_no_override": 14584.92,
    "override_total_1": 14998.75,
    "override_increase_1": 413.84
  },
  {
    "#": "101 Wolcott Rd (402-10-00)",
    "$": 2097700,
    "address": "101 Wolcott Rd",
    "parcel_id": "402-10-00",
    "owner1": "BLUMENTHAL TR, AMY",
    "owner2": "",
    "current_taxes": 17845.51,
    "new_taxes_no_override": 18616.44,
    "override_total_1": 19144.66,
    "override_increase_1": 528.23
  },
  {
    "#": "111 Wolcott Rd (402-09-00)",
    "$": 1297100,
    "address": "111 Wolcott Rd",
    "parcel_id": "402-09-00",
    "owner1": "PUIGSERVER, PERE",
    "owner2": "VAZQUEZ, FRANCISCA",
    "current_taxes": 9647.37,
    "new_taxes_no_override": 10064.14,
    "override_total_1": 10349.7,
    "override_increase_1": 285.56
  },
  {
    "#": "112 Wolcott Rd (401-06-00)",
    "$": 1887000,
    "address": "112 Wolcott Rd",
    "parcel_id": "401-06-00",
    "owner1": "BERGER, MICHAEL & EILEEN C",
    "owner2": "",
    "current_taxes": 15687.95,
    "new_taxes_no_override": 16365.67,
    "override_total_1": 16830.03,
    "override_increase_1": 464.36
  },
  {
    "#": "115 Wolcott Rd (402-08-00)",
    "$": 1915100,
    "address": "115 Wolcott Rd",
    "parcel_id": "402-08-00",
    "owner1": "RUANE, JUSTIN A & ZAINUB RAKLA",
    "owner2": "",
    "current_taxes": 15975.69,
    "new_taxes_no_override": 16665.84,
    "override_total_1": 17138.72,
    "override_increase_1": 472.88
  },
  {
    "#": "117 Wolcott Rd (402-07-00)",
    "$": 2163500,
    "address": "117 Wolcott Rd",
    "parcel_id": "402-07-00",
    "owner1": "KESNER, MATTHEW & LILLY",
    "owner2": "",
    "current_taxes": 18519.31,
    "new_taxes_no_override": 19319.34,
    "override_total_1": 19867.52,
    "override_increase_1": 548.17
  },
  {
    "#": "118 Wolcott Rd (401-05-00)",
    "$": 1616100,
    "address": "118 Wolcott Rd",
    "parcel_id": "401-05-00",
    "owner1": "GROSSMAN, JOSHUA A",
    "owner2": "LIPTZ, RACHEL LAURA",
    "current_taxes": 12913.93,
    "new_taxes_no_override": 13471.81,
    "override_total_1": 13854.06,
    "override_increase_1": 382.25
  },
  {
    "#": "123 Wolcott Rd (402-06-00)",
    "$": 1288300,
    "address": "123 Wolcott Rd",
    "parcel_id": "402-06-00",
    "owner1": "BENDER TR, WELCOME",
    "owner2": "",
    "current_taxes": 13192.19,
    "new_taxes_no_override": 13762.09,
    "override_total_1": 14152.58,
    "override_increase_1": 390.49
  },
  {
    "#": "124 Wolcott Rd (401-04-00)",
    "$": 1850800,
    "address": "124 Wolcott Rd",
    "parcel_id": "401-04-00",
    "owner1": "SHIH TRS, GARRET W & LUDY C",
    "owner2": "",
    "current_taxes": 15317.26,
    "new_taxes_no_override": 15978.97,
    "override_total_1": 16432.36,
    "override_increase_1": 453.39
  },
  {
    "#": "127 Wolcott Rd (402-05-00)",
    "$": 1333700,
    "address": "127 Wolcott Rd",
    "parcel_id": "402-05-00",
    "owner1": "BENDER, ET AL, WELCOME",
    "owner2": "",
    "current_taxes": 10022.15,
    "new_taxes_no_override": 10455.11,
    "override_total_1": 10751.76,
    "override_increase_1": 296.66
  },
  {
    "#": "133 Wolcott Rd (402-04-00)",
    "$": 1800000,
    "address": "133 Wolcott Rd",
    "parcel_id": "402-04-00",
    "owner1": "SACHAROW, AARON & STEPHANIE J",
    "owner2": "",
    "current_taxes": 14797.07,
    "new_taxes_no_override": 15436.3,
    "override_total_1": 15874.3,
    "override_increase_1": 437.99
  },
  {
    "#": "136 Wolcott Rd (401-03-00)",
    "$": 1565200,
    "address": "136 Wolcott Rd",
    "parcel_id": "401-03-00",
    "owner1": "HUANG, KEVIN TED",
    "owner2": "LI, JOSEPHINE H",
    "current_taxes": 12392.71,
    "new_taxes_no_override": 12928.08,
    "override_total_1": 13294.9,
    "override_increase_1": 366.82
  },
  {
    "#": "151 Wolcott Rd (400-09-00)",
    "$": 1520700,
    "address": "151 Wolcott Rd",
    "parcel_id": "400-09-00",
    "owner1": "DU, WEIYU",
    "owner2": "MENG, QI",
    "current_taxes": 11937.03,
    "new_taxes_no_override": 12452.71,
    "override_total_1": 12806.05,
    "override_increase_1": 353.34
  },
  {
    "#": "157 Wolcott Rd (400-10-00)",
    "$": 1815400,
    "address": "157 Wolcott Rd",
    "parcel_id": "400-10-00",
    "owner1": "ANSIN, JOSEPH",
    "owner2": "",
    "current_taxes": 14954.76,
    "new_taxes_no_override": 15600.81,
    "override_total_1": 16043.47,
    "override_increase_1": 442.66
  },
  {
    "#": "158 Wolcott Rd (401-02-00)",
    "$": 3023300,
    "address": "158 Wolcott Rd",
    "parcel_id": "401-02-00",
    "owner1": "RUBENSTEIN, MITCHELL H",
    "owner2": "GORDON, SUSAN R",
    "current_taxes": 27323.66,
    "new_taxes_no_override": 28504.04,
    "override_total_1": 29312.82,
    "override_increase_1": 808.78
  },
  {
    "#": "161 Wolcott Rd (400-11-00)",
    "$": 1841500,
    "address": "161 Wolcott Rd",
    "parcel_id": "400-11-00",
    "owner1": "RINTELL, DAVID J & JEANNE M",
    "owner2": "",
    "current_taxes": 15222.03,
    "new_taxes_no_override": 15879.62,
    "override_total_1": 16330.19,
    "override_increase_1": 450.57
  },
  {
    "#": "171 Wolcott Rd (400-12-00)",
    "$": 1926700,
    "address": "171 Wolcott Rd",
    "parcel_id": "400-12-00",
    "owner1": "DELSHAD, HAJAR R",
    "owner2": "ISMAIL, KHALID H",
    "current_taxes": 16094.47,
    "new_taxes_no_override": 16789.75,
    "override_total_1": 17266.15,
    "override_increase_1": 476.4
  },
  {
    "#": "172 Wolcott Rd (401-01-00)",
    "$": 2071400,
    "address": "172 Wolcott Rd",
    "parcel_id": "401-01-00",
    "owner1": "SPIROUNIS TR, VASSILIOS K",
    "owner2": "",
    "current_taxes": 17576.2,
    "new_taxes_no_override": 18335.49,
    "override_total_1": 18855.75,
    "override_increase_1": 520.26
  },
  {
    "#": "187 Wolcott Rd (399-01-00)",
    "$": 1466000,
    "address": "187 Wolcott Rd",
    "parcel_id": "399-01-00",
    "owner1": "SIEGAL, MARTIN A & DORIS P",
    "owner2": "",
    "current_taxes": 11376.91,
    "new_taxes_no_override": 11868.39,
    "override_total_1": 12205.15,
    "override_increase_1": 336.76
  },
  {
    "#": "190 Wolcott Rd (401-24-00)",
    "$": 2167600,
    "address": "190 Wolcott Rd",
    "parcel_id": "401-24-00",
    "owner1": "SIMEONE, JOSEPH F & ANN M",
    "owner2": "",
    "current_taxes": 18561.29,
    "new_taxes_no_override": 19363.14,
    "override_total_1": 19912.55,
    "override_increase_1": 549.41
  },
  {
    "#": "193 Wolcott Rd (399-02-00)",
    "$": 1321300,
    "address": "193 Wolcott Rd",
    "parcel_id": "399-02-00",
    "owner1": "JHAVERI-SCHNEIDER, SONAL",
    "owner2": "",
    "current_taxes": 9895.18,
    "new_taxes_no_override": 10322.65,
    "override_total_1": 10615.55,
    "override_increase_1": 292.9
  },
  {
    "#": "198 Wolcott Rd (401-22-23)",
    "$": 1896400,
    "address": "198 Wolcott Rd",
    "parcel_id": "401-22-23",
    "owner1": "CRAMER, TR, ROY",
    "owner2": "C/O LIGHTING & LAMPS",
    "current_taxes": 19419.14,
    "new_taxes_no_override": 20258.05,
    "override_total_1": 20832.85,
    "override_increase_1": 574.81
  },
  {
    "#": "199 Wolcott Rd (399-03-00)",
    "$": 1136700,
    "address": "199 Wolcott Rd",
    "parcel_id": "399-03-00",
    "owner1": "HEINRICH, SVEN",
    "owner2": "RICHARDSON, CELESTE",
    "current_taxes": 8004.87,
    "new_taxes_no_override": 8350.68,
    "override_total_1": 8587.62,
    "override_increase_1": 236.94
  },
  {
    "#": "205 Wolcott Rd (399-04-00)",
    "$": 1463600,
    "address": "205 Wolcott Rd",
    "parcel_id": "399-04-00",
    "owner1": "WEILL, KENNETH S",
    "owner2": "CATALDO, JOANNA R",
    "current_taxes": 11352.33,
    "new_taxes_no_override": 11842.75,
    "override_total_1": 12178.78,
    "override_increase_1": 336.03
  },
  {
    "#": "207 Wolcott Rd (399-05-00)",
    "$": 1668200,
    "address": "207 Wolcott Rd",
    "parcel_id": "399-05-00",
    "owner1": "SCHRAGE TRS, MICHAEL M & ELIZABETH M",
    "owner2": "",
    "current_taxes": 17082.37,
    "new_taxes_no_override": 17820.33,
    "override_total_1": 18325.97,
    "override_increase_1": 505.64
  },
  {
    "#": "210 Wolcott Rd (401-21-00)",
    "$": 2146600,
    "address": "210 Wolcott Rd",
    "parcel_id": "401-21-00",
    "owner1": "GOLDSTEIN, CRAIG J",
    "owner2": "DANIELS, CHRISTINE L",
    "current_taxes": 18346.25,
    "new_taxes_no_override": 19138.81,
    "override_total_1": 19681.86,
    "override_increase_1": 543.05
  },
  {
    "#": "211 Wolcott Rd (399-06-00)",
    "$": 1244400,
    "address": "211 Wolcott Rd",
    "parcel_id": "399-06-00",
    "owner1": "HORNUNG, CHRISTOPHER",
    "owner2": "",
    "current_taxes": 9107.72,
    "new_taxes_no_override": 9501.17,
    "override_total_1": 9770.76,
    "override_increase_1": 269.59
  },
  {
    "#": "214 Wolcott Rd (401-20-00)",
    "$": 1736000,
    "address": "214 Wolcott Rd",
    "parcel_id": "401-20-00",
    "owner1": "KIM, PETER",
    "owner2": "",
    "current_taxes": 14141.71,
    "new_taxes_no_override": 14752.63,
    "override_total_1": 15171.23,
    "override_increase_1": 418.59
  },
  {
    "#": "217 Wolcott Rd (399-07-00)",
    "$": 2867800,
    "address": "217 Wolcott Rd",
    "parcel_id": "399-07-00",
    "owner1": "LEVY, MICHAEL",
    "owner2": "BURNS, KATHLEEN HELEN",
    "current_taxes": 25731.34,
    "new_taxes_no_override": 26842.93,
    "override_total_1": 27604.58,
    "override_increase_1": 761.65
  },
  {
    "#": "220 Wolcott Rd (401-19-00)",
    "$": 2689000,
    "address": "220 Wolcott Rd",
    "parcel_id": "401-19-00",
    "owner1": "TOLOUE, MASOUD & NEDA",
    "owner2": "",
    "current_taxes": 23900.43,
    "new_taxes_no_override": 24932.93,
    "override_total_1": 25640.38,
    "override_increase_1": 707.45
  },
  {
    "#": "221 Wolcott Rd (399-08-00)",
    "$": 1302500,
    "address": "221 Wolcott Rd",
    "parcel_id": "399-08-00",
    "owner1": "KUPERWASER, MARK C & JUDITH A",
    "owner2": "",
    "current_taxes": 9702.67,
    "new_taxes_no_override": 10121.83,
    "override_total_1": 10409.02,
    "override_increase_1": 287.2
  },
  {
    "#": "227 Wolcott Rd (399-09-00)",
    "$": 1394000,
    "address": "227 Wolcott Rd",
    "parcel_id": "399-09-00",
    "owner1": "GLEASON, EDWARD D",
    "owner2": "CHANG, MONICA",
    "current_taxes": 10639.63,
    "new_taxes_no_override": 11099.26,
    "override_total_1": 11414.2,
    "override_increase_1": 314.93
  },
  {
    "#": "228 Wolcott Rd (401-18-00)",
    "$": 1870700,
    "address": "228 Wolcott Rd",
    "parcel_id": "401-18-00",
    "owner1": "DREWES TR, BRIAN F",
    "owner2": "",
    "current_taxes": 19155.97,
    "new_taxes_no_override": 19983.51,
    "override_total_1": 20550.52,
    "override_increase_1": 567.02
  },
  {
    "#": "231 Wolcott Rd (399-10-00)",
    "$": 2085700,
    "address": "231 Wolcott Rd",
    "parcel_id": "399-10-00",
    "owner1": "MUFTU, SINAN",
    "owner2": "BRUM, LYNNE",
    "current_taxes": 17722.63,
    "new_taxes_no_override": 18488.25,
    "override_total_1": 19012.84,
    "override_increase_1": 524.59
  },
  {
    "#": "234 Wolcott Rd (401-17-00)",
    "$": 1787000,
    "address": "234 Wolcott Rd",
    "parcel_id": "401-17-00",
    "owner1": "ANASTOPOULOS JR, GEORGE V",
    "owner2": "",
    "current_taxes": 14663.95,
    "new_taxes_no_override": 15297.43,
    "override_total_1": 15731.49,
    "override_increase_1": 434.05
  },
  {
    "#": "239 Wolcott Rd (399-11-12)",
    "$": 2826900,
    "address": "239 Wolcott Rd",
    "parcel_id": "399-11-12",
    "owner1": "KARP, JEFFREY",
    "owner2": "SIMONETTI, JESSICA",
    "current_taxes": 25312.52,
    "new_taxes_no_override": 26406.02,
    "override_total_1": 27155.27,
    "override_increase_1": 749.25
  },
  {
    "#": "240 Wolcott Rd (401-16-00)",
    "$": 1835300,
    "address": "240 Wolcott Rd",
    "parcel_id": "401-16-00",
    "owner1": "MCMULLEN, ANNE C & BRIAN",
    "owner2": "",
    "current_taxes": 18793.47,
    "new_taxes_no_override": 19605.35,
    "override_total_1": 20161.63,
    "override_increase_1": 556.29
  },
  {
    "#": "245 Wolcott Rd (399-13-00)",
    "$": 1278600,
    "address": "245 Wolcott Rd",
    "parcel_id": "399-13-00",
    "owner1": "FISHMAN TRS, ELLEN O",
    "owner2": "",
    "current_taxes": 9457.93,
    "new_taxes_no_override": 9866.51,
    "override_total_1": 10146.47,
    "override_increase_1": 279.95
  },
  {
    "#": "246 Wolcott Rd (401-15-00)",
    "$": 1789300,
    "address": "246 Wolcott Rd",
    "parcel_id": "401-15-00",
    "owner1": "FINN TRS, STEFFANIE & DAVID",
    "owner2": "",
    "current_taxes": 14687.5,
    "new_taxes_no_override": 15322.0,
    "override_total_1": 15756.75,
    "override_increase_1": 434.75
  },
  {
    "#": "8 Wolcott Rd Ext (398A-11-00)",
    "$": 2441900,
    "address": "8 Wolcott Rd Ext",
    "parcel_id": "398A-11-00",
    "owner1": "ECK TRS, MICHAEL J",
    "owner2": "JEON, HYESUNG",
    "current_taxes": 21370.12,
    "new_taxes_no_override": 22293.31,
    "override_total_1": 22925.86,
    "override_increase_1": 632.56
  },
  {
    "#": "11 Wolcott Rd Ext (400-06-00)",
    "$": 1710700,
    "address": "11 Wolcott Rd Ext",
    "parcel_id": "400-06-00",
    "owner1": "BENDETT TR, MICHAEL J",
    "owner2": "",
    "current_taxes": 17517.57,
    "new_taxes_no_override": 18274.33,
    "override_total_1": 18792.85,
    "override_increase_1": 518.52
  },
  {
    "#": "18 Wolcott Rd Ext (398A-12-00)",
    "$": 2404100,
    "address": "18 Wolcott Rd Ext",
    "parcel_id": "398A-12-00",
    "owner1": "DEMB, CLAUDIO",
    "owner2": "UFANO, SONIA",
    "current_taxes": 20983.05,
    "new_taxes_no_override": 21889.52,
    "override_total_1": 22510.62,
    "override_increase_1": 621.1
  },
  {
    "#": "21 Wolcott Rd Ext (400-07-00)",
    "$": 1888900,
    "address": "21 Wolcott Rd Ext",
    "parcel_id": "400-07-00",
    "owner1": "BARNUM TRS, RICHARD & BONNIE L",
    "owner2": "",
    "current_taxes": 15707.4,
    "new_taxes_no_override": 16385.96,
    "override_total_1": 16850.9,
    "override_increase_1": 464.94
  },
  {
    "#": "26 Wolcott Rd Ext (398A-13-00)",
    "$": 2038300,
    "address": "26 Wolcott Rd Ext",
    "parcel_id": "398A-13-00",
    "owner1": "KHADEM TRS, MOZHAN & JALEH J",
    "owner2": "",
    "current_taxes": 17237.26,
    "new_taxes_no_override": 17981.91,
    "override_total_1": 18492.13,
    "override_increase_1": 510.22
  },
  {
    "#": "33 Wolcott Rd Ext (400-08-00)",
    "$": 2098800,
    "address": "33 Wolcott Rd Ext",
    "parcel_id": "400-08-00",
    "owner1": "CHISHOLM, AARON JR & FENELLA M",
    "owner2": "",
    "current_taxes": 17856.78,
    "new_taxes_no_override": 18628.19,
    "override_total_1": 19156.75,
    "override_increase_1": 528.56
  },
  {
    "#": "34 Wolcott Rd Ext (402-01-02)",
    "$": 1500900,
    "address": "34 Wolcott Rd Ext",
    "parcel_id": "402-01-02",
    "owner1": "SCHUETTE TR, DEIRDRE A",
    "owner2": "",
    "current_taxes": 11734.28,
    "new_taxes_no_override": 12241.2,
    "override_total_1": 12588.54,
    "override_increase_1": 347.33
  },
  {
    "#": "42 Wolcott Rd Ext (402-03-00)",
    "$": 1851600,
    "address": "42 Wolcott Rd Ext",
    "parcel_id": "402-03-00",
    "owner1": "LEONG, ELMER F & GINA L",
    "owner2": "",
    "current_taxes": 15325.45,
    "new_taxes_no_override": 15987.51,
    "override_total_1": 16441.14,
    "override_increase_1": 453.63
  },
  {
    "#": "11 Woodcliff Rd (375D-02-00)",
    "$": 2135700,
    "address": "11 Woodcliff Rd",
    "parcel_id": "375D-02-00",
    "owner1": "SHRIVASTAVA TRS, SANJAY & ANJNA",
    "owner2": "",
    "current_taxes": 18234.63,
    "new_taxes_no_override": 19022.37,
    "override_total_1": 19562.11,
    "override_increase_1": 539.75
  },
  {
    "#": "21 Woodcliff Rd (375D-03-00)",
    "$": 1506900,
    "address": "21 Woodcliff Rd",
    "parcel_id": "375D-03-00",
    "owner1": "SMITH TR, ELEANORE E",
    "owner2": "",
    "current_taxes": 11795.72,
    "new_taxes_no_override": 12305.3,
    "override_total_1": 12654.45,
    "override_increase_1": 349.15
  },
  {
    "#": "27 Woodcliff Rd (375D-04-00)",
    "$": 1548700,
    "address": "27 Woodcliff Rd",
    "parcel_id": "375D-04-00",
    "owner1": "MAB COMMUNITY SERVICES INC",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "43 Woodcliff Rd (376A-01-01)",
    "$": 1548900,
    "address": "43 Woodcliff Rd",
    "parcel_id": "376A-01-01",
    "owner1": "NISSENBAUM, MAUREEN B & ANDREA C",
    "owner2": "",
    "current_taxes": 12225.8,
    "new_taxes_no_override": 12753.95,
    "override_total_1": 13115.84,
    "override_increase_1": 361.88
  },
  {
    "#": "46 Woodcliff Rd (376-02-00)",
    "$": 1330000,
    "address": "46 Woodcliff Rd",
    "parcel_id": "376-02-00",
    "owner1": "CHABAD LUBAVITCH OF CHESTNUT HILL INC",
    "owner2": "",
    "current_taxes": 13619.2,
    "new_taxes_no_override": 14207.55,
    "override_total_1": 14610.68,
    "override_increase_1": 403.13
  },
  {
    "#": "51 Woodcliff Rd (376A-02-00)",
    "$": 1391700,
    "address": "51 Woodcliff Rd",
    "parcel_id": "376A-02-00",
    "owner1": "GREENE TR, STEVEN M",
    "owner2": "",
    "current_taxes": 10616.07,
    "new_taxes_no_override": 11074.68,
    "override_total_1": 11388.92,
    "override_increase_1": 314.24
  },
  {
    "#": "54 Woodcliff Rd (376-03-00)",
    "$": 1399200,
    "address": "54 Woodcliff Rd",
    "parcel_id": "376-03-00",
    "owner1": "BANKER, RELY & YIGAL",
    "owner2": "",
    "current_taxes": 10692.87,
    "new_taxes_no_override": 11154.8,
    "override_total_1": 11471.31,
    "override_increase_1": 316.51
  },
  {
    "#": "59 Woodcliff Rd (376A-03-00)",
    "$": 1663600,
    "address": "59 Woodcliff Rd",
    "parcel_id": "376A-03-00",
    "owner1": "WALSH, GREGORY F",
    "owner2": "BAINES-WALSH, LAURA K",
    "current_taxes": 13400.33,
    "new_taxes_no_override": 13979.22,
    "override_total_1": 14375.87,
    "override_increase_1": 396.65
  },
  {
    "#": "60 Woodcliff Rd (376-04-00)",
    "$": 1813100,
    "address": "60 Woodcliff Rd",
    "parcel_id": "376-04-00",
    "owner1": "LEVITT, MATTHEW D",
    "owner2": "DUDLEY, KATHERINE A",
    "current_taxes": 14931.21,
    "new_taxes_no_override": 15576.24,
    "override_total_1": 16018.2,
    "override_increase_1": 441.96
  },
  {
    "#": "65 Woodcliff Rd (376A-04-00)",
    "$": 1395600,
    "address": "65 Woodcliff Rd",
    "parcel_id": "376A-04-00",
    "owner1": "KATSMAN, IGOR",
    "owner2": "DYMKOVA, GALINA",
    "current_taxes": 10656.01,
    "new_taxes_no_override": 11116.35,
    "override_total_1": 11431.77,
    "override_increase_1": 315.42
  },
  {
    "#": "66 Woodcliff Rd (376-05-00)",
    "$": 1423300,
    "address": "66 Woodcliff Rd",
    "parcel_id": "376-05-00",
    "owner1": "CHU, SYLVIA",
    "owner2": "CO, JOHN PATRICK TAN",
    "current_taxes": 10939.66,
    "new_taxes_no_override": 11412.25,
    "override_total_1": 11736.07,
    "override_increase_1": 323.81
  },
  {
    "#": "73 Woodcliff Rd (376A-05-00)",
    "$": 1255700,
    "address": "73 Woodcliff Rd",
    "parcel_id": "376A-05-00",
    "owner1": "STERN, TRS, ALEXANDER & MARINA",
    "owner2": "",
    "current_taxes": 9223.43,
    "new_taxes_no_override": 9621.88,
    "override_total_1": 9894.9,
    "override_increase_1": 273.01
  },
  {
    "#": "74 Woodcliff Rd (376-06-00)",
    "$": 1191000,
    "address": "74 Woodcliff Rd",
    "parcel_id": "376-06-00",
    "owner1": "GARELICK, TR, JUDITH S",
    "owner2": "",
    "current_taxes": 8560.91,
    "new_taxes_no_override": 8930.74,
    "override_total_1": 9184.14,
    "override_increase_1": 253.4
  },
  {
    "#": "79 Woodcliff Rd (376A-06-00)",
    "$": 1816500,
    "address": "79 Woodcliff Rd",
    "parcel_id": "376A-06-00",
    "owner1": "SLAVIN, BRIAN & KRISTI",
    "owner2": "",
    "current_taxes": 18600.96,
    "new_taxes_no_override": 19404.52,
    "override_total_1": 19955.11,
    "override_increase_1": 550.59
  },
  {
    "#": "80 Woodcliff Rd (376-07-00)",
    "$": 1368900,
    "address": "80 Woodcliff Rd",
    "parcel_id": "376-07-00",
    "owner1": "DAI, DAVID GUOWEI",
    "owner2": "ZHU, YUNLING",
    "current_taxes": 14017.54,
    "new_taxes_no_override": 14623.1,
    "override_total_1": 15038.02,
    "override_increase_1": 414.92
  },
  {
    "#": "82 Woodcliff Rd (376-08-01)",
    "$": 17300,
    "address": "82 Woodcliff Rd",
    "parcel_id": "376-08-01",
    "owner1": "HIBBARD TR, JONATHAN D",
    "owner2": "ZUO, HAOBO",
    "current_taxes": 177.15,
    "new_taxes_no_override": 184.8,
    "override_total_1": 190.05,
    "override_increase_1": 5.24
  },
  {
    "#": "85 Woodcliff Rd (376A-07-00)",
    "$": 1534700,
    "address": "85 Woodcliff Rd",
    "parcel_id": "376A-07-00",
    "owner1": "SHORE, FELIX & LINA",
    "owner2": "",
    "current_taxes": 12080.39,
    "new_taxes_no_override": 12602.26,
    "override_total_1": 12959.84,
    "override_increase_1": 357.58
  },
  {
    "#": "86 Woodcliff Rd (376-08-00)",
    "$": 1827800,
    "address": "86 Woodcliff Rd",
    "parcel_id": "376-08-00",
    "owner1": "HIBBARD TR, JONATHAN D",
    "owner2": "ZUO, HAOBO",
    "current_taxes": 15081.74,
    "new_taxes_no_override": 15733.27,
    "override_total_1": 16179.69,
    "override_increase_1": 446.42
  },
  {
    "#": "92 Woodcliff Rd (376-09-00)",
    "$": 1161100,
    "address": "92 Woodcliff Rd",
    "parcel_id": "376-09-00",
    "owner1": "ZHENG, WEIHONG",
    "owner2": "WANG, TAO",
    "current_taxes": 11889.66,
    "new_taxes_no_override": 12403.29,
    "override_total_1": 12755.23,
    "override_increase_1": 351.93
  },
  {
    "#": "93 Woodcliff Rd (376A-08-00)",
    "$": 1491100,
    "address": "93 Woodcliff Rd",
    "parcel_id": "376A-08-00",
    "owner1": "YAHALOM, BARAK",
    "owner2": "OUZIEL-YAHALOM, LIMOR",
    "current_taxes": 15268.86,
    "new_taxes_no_override": 15928.47,
    "override_total_1": 16380.43,
    "override_increase_1": 451.96
  },
  {
    "#": "100 Woodcliff Rd (376-10-00)",
    "$": 1209700,
    "address": "100 Woodcliff Rd",
    "parcel_id": "376-10-00",
    "owner1": "100 WOODCLIFF LLC",
    "owner2": "",
    "current_taxes": 12387.33,
    "new_taxes_no_override": 12922.46,
    "override_total_1": 13289.13,
    "override_increase_1": 366.66
  },
  {
    "#": "105 Woodcliff Rd (376A-09-00)",
    "$": 1351300,
    "address": "105 Woodcliff Rd",
    "parcel_id": "376A-09-00",
    "owner1": "KATZ TR, JULIE P",
    "owner2": "",
    "current_taxes": 10202.38,
    "new_taxes_no_override": 10643.12,
    "override_total_1": 10945.11,
    "override_increase_1": 301.99
  },
  {
    "#": "106 Woodcliff Rd (376-11-00)",
    "$": 1354800,
    "address": "106 Woodcliff Rd",
    "parcel_id": "376-11-00",
    "owner1": "GOODWIN TRS, SCOTT R & LI NA",
    "owner2": "",
    "current_taxes": 10238.22,
    "new_taxes_no_override": 10680.51,
    "override_total_1": 10983.56,
    "override_increase_1": 303.05
  },
  {
    "#": "110 Woodcliff Rd (376-12-00)",
    "$": 1382200,
    "address": "110 Woodcliff Rd",
    "parcel_id": "376-12-00",
    "owner1": "HASSON, MICHAEL & LEVANA K",
    "owner2": "",
    "current_taxes": 10518.79,
    "new_taxes_no_override": 10973.2,
    "override_total_1": 11284.56,
    "override_increase_1": 311.36
  },
  {
    "#": "111 Woodcliff Rd (376A-10-00)",
    "$": 1328600,
    "address": "111 Woodcliff Rd",
    "parcel_id": "376A-10-00",
    "owner1": "ARKIN, EYTAN & YAFA",
    "owner2": "",
    "current_taxes": 9969.93,
    "new_taxes_no_override": 10400.63,
    "override_total_1": 10695.74,
    "override_increase_1": 295.11
  },
  {
    "#": "117 Woodcliff Rd (376A-11-00)",
    "$": 1484600,
    "address": "117 Woodcliff Rd",
    "parcel_id": "376A-11-00",
    "owner1": "KARUMANCHI, SUBBIAN ANANTH & SREEDEV",
    "owner2": "",
    "current_taxes": 11567.37,
    "new_taxes_no_override": 12067.08,
    "override_total_1": 12409.47,
    "override_increase_1": 342.39
  },
  {
    "#": "118 Woodcliff Rd (376-13-00)",
    "$": 1142500,
    "address": "118 Woodcliff Rd",
    "parcel_id": "376-13-00",
    "owner1": "FARIBORZ, PARVIZ & JEANETTE",
    "owner2": "",
    "current_taxes": 8064.27,
    "new_taxes_no_override": 8412.65,
    "override_total_1": 8651.35,
    "override_increase_1": 238.7
  },
  {
    "#": "122 Woodcliff Rd (376-14-00)",
    "$": 559000,
    "address": "122 Woodcliff Rd",
    "parcel_id": "376-14-00",
    "owner1": "CORMAN, ET AL TRS, MICHAEL",
    "owner2": "",
    "current_taxes": 2089.23,
    "new_taxes_no_override": 2179.48,
    "override_total_1": 2241.33,
    "override_increase_1": 61.84
  },
  {
    "#": "123 Woodcliff Rd (376A-12-13)",
    "$": 1714200,
    "address": "123 Woodcliff Rd",
    "parcel_id": "376A-12-13",
    "owner1": "DIMITRIADES, TATIANA",
    "owner2": "BASS, JONATHAN",
    "current_taxes": 13918.47,
    "new_taxes_no_override": 14519.75,
    "override_total_1": 14931.73,
    "override_increase_1": 411.99
  },
  {
    "#": "27 Woodland Rd (432-33-00)",
    "$": 13795200,
    "address": "27 Woodland Rd",
    "parcel_id": "432-33-00",
    "owner1": "KRAFT, JONATHAN A & PATRICIA L",
    "owner2": "C/O THE KRAFT GROUP",
    "current_taxes": 137627.91,
    "new_taxes_no_override": 143573.44,
    "override_total_1": 147647.22,
    "override_increase_1": 4073.79
  },
  {
    "#": "31 Woodland Rd (432-32-00)",
    "$": 3459800,
    "address": "31 Woodland Rd",
    "parcel_id": "432-32-00",
    "owner1": "KRAFT, JONATHAN A & PATRICIA L",
    "owner2": "C/O THE KRAFT GROUP",
    "current_taxes": 35428.35,
    "new_taxes_no_override": 36958.85,
    "override_total_1": 38007.53,
    "override_increase_1": 1048.68
  },
  {
    "#": "33 Woodland Rd (432-31-04)",
    "$": 7093500,
    "address": "33 Woodland Rd",
    "parcel_id": "432-31-04",
    "owner1": "TEPERMAN, ALEXANDER & DEBRA",
    "owner2": "",
    "current_taxes": 69002.51,
    "new_taxes_no_override": 71983.42,
    "override_total_1": 74025.89,
    "override_increase_1": 2042.47
  },
  {
    "#": "45 Woodland Rd (432-31-03)",
    "$": 8037200,
    "address": "45 Woodland Rd",
    "parcel_id": "432-31-03",
    "owner1": "WOLK, JEFFREY C & MARLA L",
    "owner2": "",
    "current_taxes": 78665.99,
    "new_taxes_no_override": 82064.36,
    "override_total_1": 84392.87,
    "override_increase_1": 2328.51
  },
  {
    "#": "49 Woodland Rd (432-31-02)",
    "$": 6839000,
    "address": "49 Woodland Rd",
    "parcel_id": "432-31-02",
    "owner1": "GOLDEN, MATTHEW T",
    "owner2": "GOLDIN, LISA H",
    "current_taxes": 70031.36,
    "new_taxes_no_override": 73056.71,
    "override_total_1": 75129.64,
    "override_increase_1": 2072.93
  },
  {
    "#": "53 Woodland Rd (432-31-01)",
    "$": 7009800,
    "address": "53 Woodland Rd",
    "parcel_id": "432-31-01",
    "owner1": "DENISE JEFFERSON",
    "owner2": "",
    "current_taxes": 68145.42,
    "new_taxes_no_override": 71089.3,
    "override_total_1": 73106.41,
    "override_increase_1": 2017.1
  },
  {
    "#": "69 Woodland Rd (432-01-00)",
    "$": 7483500,
    "address": "69 Woodland Rd",
    "parcel_id": "432-01-00",
    "owner1": "BARDON TR, OLIVER",
    "owner2": "",
    "current_taxes": 76631.04,
    "new_taxes_no_override": 79941.5,
    "override_total_1": 82209.78,
    "override_increase_1": 2268.28
  },
  {
    "#": "89 Woodland Rd (431-10-00)",
    "$": 1879700,
    "address": "89 Woodland Rd",
    "parcel_id": "431-10-00",
    "owner1": "BASILE, JOHN ROBERT",
    "owner2": "",
    "current_taxes": 19248.13,
    "new_taxes_no_override": 20079.65,
    "override_total_1": 20649.39,
    "override_increase_1": 569.74
  },
  {
    "#": "105 Woodland Rd (431-11-00)",
    "$": 6966700,
    "address": "105 Woodland Rd",
    "parcel_id": "431-11-00",
    "owner1": "EGAN, TIMOTHY & COURTNEY",
    "owner2": "",
    "current_taxes": 71339.01,
    "new_taxes_no_override": 74420.86,
    "override_total_1": 76532.49,
    "override_increase_1": 2111.63
  },
  {
    "#": "112 Woodland Rd (440-39-02)",
    "$": 23269300,
    "address": "112 Woodland Rd",
    "parcel_id": "440-39-02",
    "owner1": "KITTLER TR, JAMES",
    "owner2": "",
    "current_taxes": 238277.63,
    "new_taxes_no_override": 248571.22,
    "override_total_1": 255624.24,
    "override_increase_1": 7053.02
  },
  {
    "#": "116 Woodland Rd (440-39-03)",
    "$": 14799200,
    "address": "116 Woodland Rd",
    "parcel_id": "440-39-03",
    "owner1": "TRUSTEES OF BOSTON COLLEGE",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "117 Woodland Rd (431-12-00)",
    "$": 4299900,
    "address": "117 Woodland Rd",
    "parcel_id": "431-12-00",
    "owner1": "IMPERATO, CHRISTINE A & JASON C",
    "owner2": "",
    "current_taxes": 40396.04,
    "new_taxes_no_override": 42141.15,
    "override_total_1": 43336.87,
    "override_increase_1": 1195.72
  },
  {
    "#": "118 Woodland Rd (440-40-00)",
    "$": 11084900,
    "address": "118 Woodland Rd",
    "parcel_id": "440-40-00",
    "owner1": "ANDELMAN TR, DAVID R",
    "owner2": "",
    "current_taxes": 113509.38,
    "new_taxes_no_override": 118412.99,
    "override_total_1": 121772.86,
    "override_increase_1": 3359.88
  },
  {
    "#": "126 Woodland Rd (440-41-00)",
    "$": 9173600,
    "address": "126 Woodland Rd",
    "parcel_id": "440-41-00",
    "owner1": "AREA 9 W126 INC",
    "owner2": "C/O BUTTERS BRAZILIAN LLP",
    "current_taxes": 93937.66,
    "new_taxes_no_override": 97995.77,
    "override_total_1": 100776.32,
    "override_increase_1": 2780.55
  },
  {
    "#": "127 Woodland Rd (431-01-00)",
    "$": 3306600,
    "address": "127 Woodland Rd",
    "parcel_id": "431-01-00",
    "owner1": "LATTARI, TAYLOR & JOSEPH",
    "owner2": "",
    "current_taxes": 30224.65,
    "new_taxes_no_override": 31530.35,
    "override_total_1": 32425.0,
    "override_increase_1": 894.65
  },
  {
    "#": "134 Woodland Rd (440-42-00)",
    "$": 8650600,
    "address": "134 Woodland Rd",
    "parcel_id": "440-42-00",
    "owner1": "SPIVAK, VICTOR & RAYA",
    "owner2": "",
    "current_taxes": 84947.21,
    "new_taxes_no_override": 88616.93,
    "override_total_1": 91131.37,
    "override_increase_1": 2514.44
  },
  {
    "#": "136 Woodland Rd (440-43-02)",
    "$": 9341200,
    "address": "136 Woodland Rd",
    "parcel_id": "440-43-02",
    "owner1": "MAGNIFICAT GENUS HOLDING LLC",
    "owner2": "",
    "current_taxes": 95653.89,
    "new_taxes_no_override": 99786.14,
    "override_total_1": 102617.49,
    "override_increase_1": 2831.36
  },
  {
    "#": "138 Woodland Rd (440-43-01)",
    "$": 8896000,
    "address": "138 Woodland Rd",
    "parcel_id": "440-43-01",
    "owner1": "MILLER TR, RICHARD T",
    "owner2": "",
    "current_taxes": 91095.04,
    "new_taxes_no_override": 95030.35,
    "override_total_1": 97726.76,
    "override_increase_1": 2696.41
  },
  {
    "#": "145 Woodland Rd (430-01-00)",
    "$": 2980400,
    "address": "145 Woodland Rd",
    "parcel_id": "430-01-00",
    "owner1": "HARDING 4TH, LOUIS B",
    "owner2": "",
    "current_taxes": 26884.36,
    "new_taxes_no_override": 28045.76,
    "override_total_1": 28841.54,
    "override_increase_1": 795.78
  },
  {
    "#": "150 Woodland Rd (441-53-04)",
    "$": 9717400,
    "address": "150 Woodland Rd",
    "parcel_id": "441-53-04",
    "owner1": "MAGNIFICAT PAX HOLDING LLC",
    "owner2": "",
    "current_taxes": 99506.18,
    "new_taxes_no_override": 103804.85,
    "override_total_1": 106750.23,
    "override_increase_1": 2945.38
  },
  {
    "#": "152 Woodland Rd (441-53-03)",
    "$": 6897600,
    "address": "152 Woodland Rd",
    "parcel_id": "441-53-03",
    "owner1": "MAGERER TR, MICHAEL",
    "owner2": "",
    "current_taxes": 70631.42,
    "new_taxes_no_override": 73682.7,
    "override_total_1": 75773.39,
    "override_increase_1": 2090.69
  },
  {
    "#": "154 Woodland Rd (441-53-02)",
    "$": 5949300,
    "address": "154 Woodland Rd",
    "parcel_id": "441-53-02",
    "owner1": "KRAZDAN WOODLAND LLC",
    "owner2": "",
    "current_taxes": 60920.83,
    "new_taxes_no_override": 63552.61,
    "override_total_1": 65355.87,
    "override_increase_1": 1803.26
  },
  {
    "#": "161 Woodland Rd (430-02-00)",
    "$": 4221600,
    "address": "161 Woodland Rd",
    "parcel_id": "430-02-00",
    "owner1": "FLORENCE, FAYE A",
    "owner2": "",
    "current_taxes": 39594.25,
    "new_taxes_no_override": 41304.72,
    "override_total_1": 42476.71,
    "override_increase_1": 1171.99
  },
  {
    "#": "168 Woodland Rd (441-53-01)",
    "$": 29102000,
    "address": "168 Woodland Rd",
    "parcel_id": "441-53-01",
    "owner1": "KARGER TR, PAUL",
    "owner2": "C/O TWIN FOCUS",
    "current_taxes": 298004.48,
    "new_taxes_no_override": 310878.27,
    "override_total_1": 319699.21,
    "override_increase_1": 8820.93
  },
  {
    "#": "173 Woodland Rd (430-02-01)",
    "$": 4548500,
    "address": "173 Woodland Rd",
    "parcel_id": "430-02-01",
    "owner1": "NEST, MATTHEW J & LINDSEY",
    "owner2": "",
    "current_taxes": 46576.64,
    "new_taxes_no_override": 48588.75,
    "override_total_1": 49967.42,
    "override_increase_1": 1378.67
  },
  {
    "#": "181 Woodland Rd (430-03-00)",
    "$": 2362200,
    "address": "181 Woodland Rd",
    "parcel_id": "430-03-00",
    "owner1": "KATZ, GERALD M & BARBARA K",
    "owner2": "",
    "current_taxes": 20553.99,
    "new_taxes_no_override": 21441.92,
    "override_total_1": 22050.32,
    "override_increase_1": 608.4
  },
  {
    "#": "187 Woodland Rd (430-03-01)",
    "$": 1843600,
    "address": "187 Woodland Rd",
    "parcel_id": "430-03-01",
    "owner1": "STAMP, ANDREA T",
    "owner2": "",
    "current_taxes": 15243.53,
    "new_taxes_no_override": 15902.05,
    "override_total_1": 16353.26,
    "override_increase_1": 451.21
  },
  {
    "#": "222 Woodland Rd (420-04-01)",
    "$": 1892900,
    "address": "222 Woodland Rd",
    "parcel_id": "420-04-01",
    "owner1": "ROBERTSON, WILLIAM M",
    "owner2": "SHEVCHENKO, TAMARA N",
    "current_taxes": 15748.36,
    "new_taxes_no_override": 16428.69,
    "override_total_1": 16894.84,
    "override_increase_1": 466.15
  },
  {
    "#": "225 Woodland Rd (422-04-00)",
    "$": 2983400,
    "address": "225 Woodland Rd",
    "parcel_id": "422-04-00",
    "owner1": "GARASIC, JOSEPH M",
    "owner2": "MARCHANT, KATHRYN E",
    "current_taxes": 26915.08,
    "new_taxes_no_override": 28077.81,
    "override_total_1": 28874.5,
    "override_increase_1": 796.69
  },
  {
    "#": "232 Woodland Rd (420-05-00)",
    "$": 5491800,
    "address": "232 Woodland Rd",
    "parcel_id": "420-05-00",
    "owner1": "BERLIN TR, ROBERT M",
    "owner2": "",
    "current_taxes": 56236.03,
    "new_taxes_no_override": 58665.43,
    "override_total_1": 60330.01,
    "override_increase_1": 1664.59
  },
  {
    "#": "235 Woodland Rd (422-05-00)",
    "$": 2883300,
    "address": "235 Woodland Rd",
    "parcel_id": "422-05-00",
    "owner1": "MORRIS, BRIAN",
    "owner2": "LORD, EMILY",
    "current_taxes": 29524.99,
    "new_taxes_no_override": 30800.47,
    "override_total_1": 31674.41,
    "override_increase_1": 873.94
  },
  {
    "#": "242 Woodland Rd (420-06-00)",
    "$": 3936100,
    "address": "242 Woodland Rd",
    "parcel_id": "420-06-00",
    "owner1": "VAFAI, AVERY & SCOTT",
    "owner2": "",
    "current_taxes": 36670.73,
    "new_taxes_no_override": 38254.91,
    "override_total_1": 39340.36,
    "override_increase_1": 1085.45
  },
  {
    "#": "245 Woodland Rd (422-06-00)",
    "$": 3321100,
    "address": "245 Woodland Rd",
    "parcel_id": "422-06-00",
    "owner1": "BEAVER COUNTRY DAY SCHOOL INC",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "252 Woodland Rd (420-07-00)",
    "$": 3766300,
    "address": "252 Woodland Rd",
    "parcel_id": "420-07-00",
    "owner1": "SHAPIRO, TRS, ROBERT & VALYA",
    "owner2": "",
    "current_taxes": 34931.98,
    "new_taxes_no_override": 36441.04,
    "override_total_1": 37475.03,
    "override_increase_1": 1033.99
  },
  {
    "#": "255 Woodland Rd (422-07-00)",
    "$": 3560400,
    "address": "255 Woodland Rd",
    "parcel_id": "422-07-00",
    "owner1": "COFFIN, PETER B & ANN R",
    "owner2": "",
    "current_taxes": 36458.5,
    "new_taxes_no_override": 38033.51,
    "override_total_1": 39112.68,
    "override_increase_1": 1079.17
  },
  {
    "#": "262 Woodland Rd (420-08-00)",
    "$": 4758300,
    "address": "262 Woodland Rd",
    "parcel_id": "420-08-00",
    "owner1": "BIALOW, COREY & NIKKI LANK",
    "owner2": "",
    "current_taxes": 45090.06,
    "new_taxes_no_override": 47037.95,
    "override_total_1": 48372.62,
    "override_increase_1": 1334.67
  },
  {
    "#": "265 Woodland Rd (422-08-00)",
    "$": 4952900,
    "address": "265 Woodland Rd",
    "parcel_id": "422-08-00",
    "owner1": "WEINSTEIN, BARTON & GABRIELLA",
    "owner2": "",
    "current_taxes": 47082.76,
    "new_taxes_no_override": 49116.74,
    "override_total_1": 50510.38,
    "override_increase_1": 1393.65
  },
  {
    "#": "272 Woodland Rd (420-09-00)",
    "$": 3877800,
    "address": "272 Woodland Rd",
    "parcel_id": "420-09-00",
    "owner1": "UTZSCHNEIDER TRS, ROBERT L & CATHARINE VK",
    "owner2": "",
    "current_taxes": 36073.74,
    "new_taxes_no_override": 37632.13,
    "override_total_1": 38699.91,
    "override_increase_1": 1067.78
  },
  {
    "#": "284 Woodland Rd (420-10-00)",
    "$": 3132800,
    "address": "284 Woodland Rd",
    "parcel_id": "420-10-00",
    "owner1": "SHENDE TRS, SUZANNE L & ALMA ELAINE",
    "owner2": "",
    "current_taxes": 28444.94,
    "new_taxes_no_override": 29673.76,
    "override_total_1": 30515.73,
    "override_increase_1": 841.97
  },
  {
    "#": "300 Woodland Rd (420-11-00)",
    "$": 5306900,
    "address": "300 Woodland Rd",
    "parcel_id": "420-11-00",
    "owner1": "STOESSER, BRADFORD D & ZOE J",
    "owner2": "",
    "current_taxes": 50707.72,
    "new_taxes_no_override": 52898.29,
    "override_total_1": 54399.24,
    "override_increase_1": 1500.95
  },
  {
    "#": "310 Woodland Rd (420-12-00)",
    "$": 2541700,
    "address": "310 Woodland Rd",
    "parcel_id": "420-12-00",
    "owner1": "GESSNER, JAMES & ANN",
    "owner2": "",
    "current_taxes": 22392.07,
    "new_taxes_no_override": 23359.41,
    "override_total_1": 24022.21,
    "override_increase_1": 662.81
  },
  {
    "#": "320 Woodland Rd (420-13-00)",
    "$": 2171700,
    "address": "320 Woodland Rd",
    "parcel_id": "420-13-00",
    "owner1": "320 WOODLAND ROAD LLC",
    "owner2": "",
    "current_taxes": 22238.21,
    "new_taxes_no_override": 23198.9,
    "override_total_1": 23857.15,
    "override_increase_1": 658.25
  },
  {
    "#": "333 Woodland Rd (429-40-00)",
    "$": 3338600,
    "address": "333 Woodland Rd",
    "parcel_id": "429-40-00",
    "owner1": "BEAVER COUNTRY DAY SCHOOL INC",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "342 Woodland Rd (421-12-00)",
    "$": 3695400,
    "address": "342 Woodland Rd",
    "parcel_id": "421-12-00",
    "owner1": "SAROSIEK, KRZYSZTOF A & SHAYNA R",
    "owner2": "",
    "current_taxes": 34205.96,
    "new_taxes_no_override": 35683.66,
    "override_total_1": 36696.15,
    "override_increase_1": 1012.5
  },
  {
    "#": "347 Woodland Rd (429-41-00)",
    "$": 6253900,
    "address": "347 Woodland Rd",
    "parcel_id": "429-41-00",
    "owner1": "FURUFU, HIROMASA",
    "owner2": "",
    "current_taxes": 60405.0,
    "new_taxes_no_override": 63014.5,
    "override_total_1": 64802.48,
    "override_increase_1": 1787.99
  },
  {
    "#": "354 Woodland Rd (421-13-00)",
    "$": 2321300,
    "address": "354 Woodland Rd",
    "parcel_id": "421-13-00",
    "owner1": "DRETCHEN TRS, JOSHUA R & SARAH I M",
    "owner2": "",
    "current_taxes": 20135.18,
    "new_taxes_no_override": 21005.02,
    "override_total_1": 21601.02,
    "override_increase_1": 596.0
  },
  {
    "#": "360 Woodland Rd (421-13-01)",
    "$": 1523300,
    "address": "360 Woodland Rd",
    "parcel_id": "421-13-01",
    "owner1": "PRESS TR, DIANE",
    "owner2": "",
    "current_taxes": 11963.66,
    "new_taxes_no_override": 12480.49,
    "override_total_1": 12834.61,
    "override_increase_1": 354.12
  },
  {
    "#": "361 Woodland Rd (429-42-00)",
    "$": 3063300,
    "address": "361 Woodland Rd",
    "parcel_id": "429-42-00",
    "owner1": "HOLYHOOD CEMETERY ASSOC",
    "owner2": "",
    "current_taxes": 0.0,
    "new_taxes_no_override": 0.0,
    "override_total_1": 0.0,
    "override_increase_1": 0.0
  },
  {
    "#": "370 Woodland Rd (421-13-02)",
    "$": 1647500,
    "address": "370 Woodland Rd",
    "parcel_id": "421-13-02",
    "owner1": "COHEN TR, NEIL S",
    "owner2": "",
    "current_taxes": 16870.4,
    "new_taxes_no_override": 17599.2,
    "override_total_1": 18098.57,
    "override_increase_1": 499.36
  },
  {
    "#": "378 Woodland Rd (421-14-00)",
    "$": 1387000,
    "address": "378 Woodland Rd",
    "parcel_id": "421-14-00",
    "owner1": "ROLBIN TR, FLORENCE E",
    "owner2": "",
    "current_taxes": 10567.95,
    "new_taxes_no_override": 11024.49,
    "override_total_1": 11337.3,
    "override_increase_1": 312.81
  },
  {
    "#": "382 Woodland Rd (421-14-02)",
    "$": 1334400,
    "address": "382 Woodland Rd",
    "parcel_id": "421-14-02",
    "owner1": "HOFFMAN, DAVID E & LINDSEY M",
    "owner2": "",
    "current_taxes": 10029.32,
    "new_taxes_no_override": 10462.59,
    "override_total_1": 10759.45,
    "override_increase_1": 296.87
  },
  {
    "#": " Woodland Rd (441-53-05)",
    "$": 868800,
    "address": " Woodland Rd",
    "parcel_id": "441-53-05",
    "owner1": "WOODLAND XP LLC ET AL",
    "owner2": "",
    "current_taxes": 8896.51,
    "new_taxes_no_override": 9280.84,
    "override_total_1": 9544.18,
    "override_increase_1": 263.34
  },
  {
    "#": "3 Worthington Rd (015-05-00)",
    "$": 5139400,
    "address": "3 Worthington Rd",
    "parcel_id": "015-05-00",
    "owner1": "DELONG, TR, SUSAN E",
    "owner2": "",
    "current_taxes": 48992.52,
    "new_taxes_no_override": 51109.0,
    "override_total_1": 52559.18,
    "override_increase_1": 1450.18
  },
  {
    "#": "4 Worthington Rd (014-03-00)",
    "$": 5288500,
    "address": "4 Worthington Rd",
    "parcel_id": "014-03-00",
    "owner1": "SITKOFF, ROBERT H & TAMARA S",
    "owner2": "",
    "current_taxes": 50519.31,
    "new_taxes_no_override": 52701.74,
    "override_total_1": 54197.12,
    "override_increase_1": 1495.37
  },
  {
    "#": "11 Worthington Rd (015-06-00)",
    "$": 4001100,
    "address": "11 Worthington Rd",
    "parcel_id": "015-06-00",
    "owner1": "NOGI, EUGENE & ALISON G",
    "owner2": "",
    "current_taxes": 37336.33,
    "new_taxes_no_override": 38949.26,
    "override_total_1": 40054.41,
    "override_increase_1": 1105.16
  },
  {
    "#": "12 Worthington Rd (014-02-00)",
    "$": 5297800,
    "address": "12 Worthington Rd",
    "parcel_id": "014-02-00",
    "owner1": "PARAFESTAS TR, ANASTASIOS",
    "owner2": "",
    "current_taxes": 54249.47,
    "new_taxes_no_override": 56593.05,
    "override_total_1": 58198.83,
    "override_increase_1": 1605.78
  },
  {
    "#": "22 Worthington Rd (014-01-00)",
    "$": 7793500,
    "address": "22 Worthington Rd",
    "parcel_id": "014-01-00",
    "owner1": "FORRESTER, MICHAEL A & COURTNEY M",
    "owner2": "",
    "current_taxes": 76170.51,
    "new_taxes_no_override": 79461.08,
    "override_total_1": 81715.72,
    "override_increase_1": 2254.65
  },
  {
    "#": "39 Worthington Rd (016-04-04)",
    "$": 6536100,
    "address": "39 Worthington Rd",
    "parcel_id": "016-04-04",
    "owner1": "GORDON, PAUL J & AMANDA KATE NAM",
    "owner2": "",
    "current_taxes": 66929.66,
    "new_taxes_no_override": 69821.02,
    "override_total_1": 71802.14,
    "override_increase_1": 1981.12
  },
  {
    "#": "49 Worthington Rd (016-05-00)",
    "$": 5941500,
    "address": "49 Worthington Rd",
    "parcel_id": "016-05-00",
    "owner1": "VAN HOOK TR, TIMOTHY J",
    "owner2": "WOOLF TR, VICKI W",
    "current_taxes": 57206.03,
    "new_taxes_no_override": 59677.33,
    "override_total_1": 61370.63,
    "override_increase_1": 1693.3
  },
  {
    "#": "50 Worthington Rd (012-06-00)",
    "$": 12908000,
    "address": "50 Worthington Rd",
    "parcel_id": "012-06-00",
    "owner1": "BOSTON UNIVERSITY TRS",
    "owner2": "C/O GENERAL ACCOUNTING 4TH FL",
    "current_taxes": 132177.92,
    "new_taxes_no_override": 137888.01,
    "override_total_1": 141800.47,
    "override_increase_1": 3912.47
  },
  {
    "#": "53 Worthington Rd (016-01-02)",
    "$": 3769700,
    "address": "53 Worthington Rd",
    "parcel_id": "016-01-02",
    "owner1": "DAGOSTINO, JEFFREY & LISA",
    "owner2": "",
    "current_taxes": 38601.73,
    "new_taxes_no_override": 40269.32,
    "override_total_1": 41411.94,
    "override_increase_1": 1142.61
  },
  {
    "#": "17 Yarmouth Rd (440-31-00)",
    "$": 9168600,
    "address": "17 Yarmouth Rd",
    "parcel_id": "440-31-00",
    "owner1": "AM FAMILY ASSOCIATES LLC",
    "owner2": "",
    "current_taxes": 93886.46,
    "new_taxes_no_override": 97942.36,
    "override_total_1": 100721.39,
    "override_increase_1": 2779.04
  },
  {
    "#": "24 Yarmouth Rd (440-14-00)",
    "$": 7244600,
    "address": "24 Yarmouth Rd",
    "parcel_id": "440-14-00",
    "owner1": "KAITZ TR, MITZI",
    "owner2": "",
    "current_taxes": 74184.7,
    "new_taxes_no_override": 77389.48,
    "override_total_1": 79585.35,
    "override_increase_1": 2195.87
  },
  {
    "#": "33 Yarmouth Rd (440-28-29)",
    "$": 9269700,
    "address": "33 Yarmouth Rd",
    "parcel_id": "440-28-29",
    "owner1": "KOPELMAN, TR, LEONARD",
    "owner2": "",
    "current_taxes": 91286.79,
    "new_taxes_no_override": 95230.38,
    "override_total_1": 97932.47,
    "override_increase_1": 2702.09
  },
  {
    "#": "40 Yarmouth Rd (440-15-00)",
    "$": 4549900,
    "address": "40 Yarmouth Rd",
    "parcel_id": "440-15-00",
    "owner1": "PAGOUNIS TRS, STRATTON & DEBRA",
    "owner2": "",
    "current_taxes": 46590.98,
    "new_taxes_no_override": 48603.71,
    "override_total_1": 49982.8,
    "override_increase_1": 1379.09
  },
  {
    "#": "50 Yarmouth Rd (440-16-00)",
    "$": 7964100,
    "address": "50 Yarmouth Rd",
    "parcel_id": "440-16-00",
    "owner1": "KAZA, ELISABETH & ADITYA",
    "owner2": "",
    "current_taxes": 77917.45,
    "new_taxes_no_override": 81283.48,
    "override_total_1": 83589.84,
    "override_increase_1": 2306.36
  },
  {
    "#": "74 Yarmouth Rd (440-17-00)",
    "$": 4975800,
    "address": "74 Yarmouth Rd",
    "parcel_id": "440-17-00",
    "owner1": "PAGOUNIS, PASHALIS",
    "owner2": "",
    "current_taxes": 47317.26,
    "new_taxes_no_override": 49361.37,
    "override_total_1": 50761.96,
    "override_increase_1": 1400.59
  },
  {
    "#": "83 Yarmouth Rd (440-27-00)",
    "$": 10447400,
    "address": "83 Yarmouth Rd",
    "parcel_id": "440-27-00",
    "owner1": "WONG TR, YEE KENG",
    "owner2": "",
    "current_taxes": 106981.38,
    "new_taxes_no_override": 111602.98,
    "override_total_1": 114769.62,
    "override_increase_1": 3166.65
  },
  {
    "#": "85 Yarmouth Rd (440-26-30)",
    "$": 15813000,
    "address": "85 Yarmouth Rd",
    "parcel_id": "440-26-30",
    "owner1": "FRANKLIN TR, LARRY J",
    "owner2": "",
    "current_taxes": 161925.12,
    "new_taxes_no_override": 168920.29,
    "override_total_1": 173713.27,
    "override_increase_1": 4792.98
  },
  {
    "#": "90 Yarmouth Rd (440-18-00)",
    "$": 8079400,
    "address": "90 Yarmouth Rd",
    "parcel_id": "440-18-00",
    "owner1": "KUCHROO, VIJAY K & KIRAN R",
    "owner2": "",
    "current_taxes": 79098.12,
    "new_taxes_no_override": 82515.16,
    "override_total_1": 84856.46,
    "override_increase_1": 2341.3
  },
  {
    "#": "99 Yarmouth Rd (440-25-00)",
    "$": 6556100,
    "address": "99 Yarmouth Rd",
    "parcel_id": "440-25-00",
    "owner1": "99YARMOUTH ASSOCIATES LLC",
    "owner2": "",
    "current_taxes": 67134.46,
    "new_taxes_no_override": 70034.67,
    "override_total_1": 72021.85,
    "override_increase_1": 1987.18
  },
  {
    "#": "110 Yarmouth Rd (440-19-00)",
    "$": 7902500,
    "address": "110 Yarmouth Rd",
    "parcel_id": "440-19-00",
    "owner1": "NABEL TR, ELIZABETH G",
    "owner2": "",
    "current_taxes": 80921.6,
    "new_taxes_no_override": 84417.41,
    "override_total_1": 86812.69,
    "override_increase_1": 2395.28
  },
  {
    "#": "111 Yarmouth Rd (440-24-00)",
    "$": 7870500,
    "address": "111 Yarmouth Rd",
    "parcel_id": "440-24-00",
    "owner1": "KANE, NADA DESPOTOVICH",
    "owner2": "",
    "current_taxes": 76958.99,
    "new_taxes_no_override": 80283.62,
    "override_total_1": 82561.6,
    "override_increase_1": 2277.99
  },
  {
    "#": "125 Yarmouth Rd (440-23-00)",
    "$": 8882000,
    "address": "125 Yarmouth Rd",
    "parcel_id": "440-23-00",
    "owner1": "SAF NANTUCKET LLC",
    "owner2": "",
    "current_taxes": 90951.68,
    "new_taxes_no_override": 94880.79,
    "override_total_1": 97572.96,
    "override_increase_1": 2692.17
  },
  {
    "#": "132 Yarmouth Rd (440-20-00)",
    "$": 6009700,
    "address": "132 Yarmouth Rd",
    "parcel_id": "440-20-00",
    "owner1": "EXCLUSIVE PROPERTY RENTALS INC",
    "owner2": "",
    "current_taxes": 61539.33,
    "new_taxes_no_override": 64197.83,
    "override_total_1": 66019.39,
    "override_increase_1": 1821.56
  },
  {
    "#": "145 Yarmouth Rd (440-22-00)",
    "$": 4037800,
    "address": "145 Yarmouth Rd",
    "parcel_id": "440-22-00",
    "owner1": "SARGENT, ANN",
    "owner2": "",
    "current_taxes": 37712.14,
    "new_taxes_no_override": 39341.3,
    "override_total_1": 40457.58,
    "override_increase_1": 1116.28
  },
  {
    "#": "150 Yarmouth Rd (440-21-00)",
    "$": 7163900,
    "address": "150 Yarmouth Rd",
    "parcel_id": "440-21-00",
    "owner1": "MANZI TR, GLENDA B",
    "owner2": "",
    "current_taxes": 69723.4,
    "new_taxes_no_override": 72735.45,
    "override_total_1": 74799.26,
    "override_increase_1": 2063.81
  },
  {
    "#": "6 York Ter (088-48-00)",
    "$": 1931500,
    "address": "6 York Ter",
    "parcel_id": "088-48-00",
    "owner1": "SOUMERAI, LEAH K",
    "owner2": "SULLIVAN, COLLEEN M",
    "current_taxes": 16143.63,
    "new_taxes_no_override": 16841.03,
    "override_total_1": 17318.89,
    "override_increase_1": 477.85
  },
  {
    "#": "9 York Ter, Unit 2 (087-01-02)",
    "$": 1194200,
    "address": "9 York Ter, Unit 2",
    "parcel_id": "087-01-02",
    "owner1": "YEH, TAMMIE CHIMUI",
    "owner2": "HAYES-POLLARD, STEPHEN",
    "current_taxes": 8593.67,
    "new_taxes_no_override": 8964.92,
    "override_total_1": 9219.29,
    "override_increase_1": 254.37
  },
  {
    "#": "12 York Ter, Unit 1 (088-47-01)",
    "$": 1364600,
    "address": "12 York Ter, Unit 1",
    "parcel_id": "088-47-01",
    "owner1": "MAUTNER, REBECCA PLAUT",
    "owner2": "MAZLEN, EMILIANO",
    "current_taxes": 10338.57,
    "new_taxes_no_override": 10785.2,
    "override_total_1": 11091.22,
    "override_increase_1": 306.02
  },
  {
    "#": "12 York Ter, Unit 2 (088-47-02)",
    "$": 1375200,
    "address": "12 York Ter, Unit 2",
    "parcel_id": "088-47-02",
    "owner1": "NSANGOU TRS, MARY HELEN N & USMANOU",
    "owner2": "",
    "current_taxes": 10447.11,
    "new_taxes_no_override": 10898.43,
    "override_total_1": 11207.66,
    "override_increase_1": 309.23
  },
  {
    "#": "15 York Ter (087-02-00)",
    "$": 2640400,
    "address": "15 York Ter",
    "parcel_id": "087-02-00",
    "owner1": "LUPATKIN, RICHARD W & DONNA F",
    "owner2": "",
    "current_taxes": 23402.76,
    "new_taxes_no_override": 24413.76,
    "override_total_1": 25106.48,
    "override_increase_1": 692.72
  },
  {
    "#": "16 York Ter (088-46-00)",
    "$": 3327000,
    "address": "16 York Ter",
    "parcel_id": "088-46-00",
    "owner1": "LOGOTHETIS, DIOMEDES E & EFROSINI",
    "owner2": "",
    "current_taxes": 30433.55,
    "new_taxes_no_override": 31748.28,
    "override_total_1": 32649.11,
    "override_increase_1": 900.83
  },
  {
    "#": "22 York Ter (088-45-00)",
    "$": 2319700,
    "address": "22 York Ter",
    "parcel_id": "088-45-00",
    "owner1": "PAYNE, ELLEN L",
    "owner2": "",
    "current_taxes": 20118.79,
    "new_taxes_no_override": 20987.92,
    "override_total_1": 21583.44,
    "override_increase_1": 595.52
  },
  {
    "#": "23 York Ter, Unit 1 (087-03-01)",
    "$": 2638500,
    "address": "23 York Ter, Unit 1",
    "parcel_id": "087-03-01",
    "owner1": "FOLEY, ANDREW M & IRIS H",
    "owner2": "",
    "current_taxes": 23383.31,
    "new_taxes_no_override": 24393.47,
    "override_total_1": 25085.61,
    "override_increase_1": 692.15
  },
  {
    "#": "23 York Ter, Unit 2 (087-03-02)",
    "$": 2464400,
    "address": "23 York Ter, Unit 2",
    "parcel_id": "087-03-02",
    "owner1": "SHIN TRS, ALICE MYONGHAE",
    "owner2": "NORRIS, MARK CHARLES",
    "current_taxes": 21600.52,
    "new_taxes_no_override": 22533.66,
    "override_total_1": 23173.04,
    "override_increase_1": 639.38
  },
  {
    "#": "24 York Ter (088-44-00)",
    "$": 2388500,
    "address": "24 York Ter",
    "parcel_id": "088-44-00",
    "owner1": "FACHINI, FABIO",
    "owner2": "RAYALA, HEIDI J",
    "current_taxes": 20823.31,
    "new_taxes_no_override": 21722.88,
    "override_total_1": 22339.25,
    "override_increase_1": 616.37
  },
  {
    "#": "28 York Ter (088-43-00)",
    "$": 2001000,
    "address": "28 York Ter",
    "parcel_id": "088-43-00",
    "owner1": "PERLMANN TRS, ARI JOEL & RIVKA Y",
    "owner2": "",
    "current_taxes": 16855.31,
    "new_taxes_no_override": 17583.46,
    "override_total_1": 18082.38,
    "override_increase_1": 498.92
  },
  {
    "#": "30 York Ter (088-42-00)",
    "$": 1867500,
    "address": "30 York Ter",
    "parcel_id": "088-42-00",
    "owner1": "BREINES LIFE ESTATE, WINIFRED",
    "owner2": "",
    "current_taxes": 15488.27,
    "new_taxes_no_override": 16157.36,
    "override_total_1": 16615.82,
    "override_increase_1": 458.45
  },
  {
    "#": "31 York Ter (087-04-00)",
    "$": 3680300,
    "address": "31 York Ter",
    "parcel_id": "087-04-00",
    "owner1": "POURATI, JACOB",
    "owner2": "",
    "current_taxes": 37686.27,
    "new_taxes_no_override": 39314.32,
    "override_total_1": 40429.83,
    "override_increase_1": 1115.51
  },
  {
    "#": "34 York Ter (088-41-00)",
    "$": 1924100,
    "address": "34 York Ter",
    "parcel_id": "088-41-00",
    "owner1": "GERSHENSON, ADAM",
    "owner2": "",
    "current_taxes": 19702.78,
    "new_taxes_no_override": 20553.94,
    "override_total_1": 21137.14,
    "override_increase_1": 583.2
  },
  {
    "#": "38 York Ter (088-40-00)",
    "$": 3341700,
    "address": "38 York Ter",
    "parcel_id": "088-40-00",
    "owner1": "SPITZER, ARIELLA KAHN-LANG & DAVID",
    "owner2": "",
    "current_taxes": 34219.01,
    "new_taxes_no_override": 35697.27,
    "override_total_1": 36710.15,
    "override_increase_1": 1012.88
  },
  {
    "#": "39 York Ter (087-05-00)",
    "$": 2106400,
    "address": "39 York Ter",
    "parcel_id": "087-05-00",
    "owner1": "VYSHEDSKIY, ANDREY",
    "owner2": "VYSHEDSKAYA, OLGA",
    "current_taxes": 17934.6,
    "new_taxes_no_override": 18709.37,
    "override_total_1": 19240.24,
    "override_increase_1": 530.86
  },
  {
    "#": "44 York Ter (088-39-00)",
    "$": 2846800,
    "address": "44 York Ter",
    "parcel_id": "088-39-00",
    "owner1": "SHAHROOZ TRS, DEENA A & KAMYAR",
    "owner2": "",
    "current_taxes": 29151.23,
    "new_taxes_no_override": 30410.56,
    "override_total_1": 31273.44,
    "override_increase_1": 862.88
  },
  {
    "#": "45 York Ter (087-06-00)",
    "$": 2819800,
    "address": "45 York Ter",
    "parcel_id": "087-06-00",
    "owner1": "PERGANTIS, JOHN PETER & MARY LYNN",
    "owner2": "",
    "current_taxes": 25239.82,
    "new_taxes_no_override": 26330.18,
    "override_total_1": 27077.28,
    "override_increase_1": 747.1
  },
  {
    "#": "48 York Ter, Unit 48 (088-38-01)",
    "$": 2241100,
    "address": "48 York Ter, Unit 48",
    "parcel_id": "088-38-01",
    "owner1": "THARP, STEPHEN G & LAUREN J",
    "owner2": "",
    "current_taxes": 19313.93,
    "new_taxes_no_override": 20148.29,
    "override_total_1": 20719.98,
    "override_increase_1": 571.69
  },
  {
    "#": "50 York Ter, Unit 50 (088-38-02)",
    "$": 1928300,
    "address": "50 York Ter, Unit 50",
    "parcel_id": "088-38-02",
    "owner1": "SCHNOOR, ROBERTA K",
    "owner2": "",
    "current_taxes": 16110.86,
    "new_taxes_no_override": 16806.85,
    "override_total_1": 17283.73,
    "override_increase_1": 476.88
  },
  {
    "#": "51 York Ter (087-07-00)",
    "$": 2320900,
    "address": "51 York Ter",
    "parcel_id": "087-07-00",
    "owner1": "RICHARDSON, MARK M & YESIM C",
    "owner2": "",
    "current_taxes": 20131.08,
    "new_taxes_no_override": 21000.74,
    "override_total_1": 21596.62,
    "override_increase_1": 595.88
  },
  {
    "#": "57 York Ter (087-08-00)",
    "$": 3849100,
    "address": "57 York Ter",
    "parcel_id": "087-08-00",
    "owner1": "WACNIK, PAUL W",
    "owner2": "SCHREIBER, KRISTIN L",
    "current_taxes": 35779.85,
    "new_taxes_no_override": 37325.54,
    "override_total_1": 38384.62,
    "override_increase_1": 1059.08
  },
  {
    "#": "58 York Ter (088-37-00)",
    "$": 1997600,
    "address": "58 York Ter",
    "parcel_id": "088-37-00",
    "owner1": "ATHENS, DEMITRIOS",
    "owner2": "DREIHAUS, ELIZABETH A",
    "current_taxes": 20455.42,
    "new_taxes_no_override": 21339.09,
    "override_total_1": 21944.57,
    "override_increase_1": 605.48
  },
  {
    "#": "66 York Ter (088-36-00)",
    "$": 1950600,
    "address": "66 York Ter",
    "parcel_id": "088-36-00",
    "owner1": "LEE TRS, HONG WOO & ALICE W",
    "owner2": "",
    "current_taxes": 16339.21,
    "new_taxes_no_override": 17045.06,
    "override_total_1": 17528.7,
    "override_increase_1": 483.64
  },
  {
    "#": "72 York Ter (088-35-00)",
    "$": 3322700,
    "address": "72 York Ter",
    "parcel_id": "088-35-00",
    "owner1": "SCHWARTZ TRS, ERIC L & HELEN E",
    "owner2": "",
    "current_taxes": 30389.51,
    "new_taxes_no_override": 31702.34,
    "override_total_1": 32601.87,
    "override_increase_1": 899.53
  },
  {
    "#": "80 York Ter (088-33-34)",
    "$": 2178200,
    "address": "80 York Ter",
    "parcel_id": "088-33-34",
    "owner1": "EOVINE, ROBERT & LINDA",
    "owner2": "",
    "current_taxes": 18669.83,
    "new_taxes_no_override": 19476.37,
    "override_total_1": 20028.99,
    "override_increase_1": 552.63
  },
  {
    "#": "88 York Ter (088-32-00)",
    "$": 1721300,
    "address": "88 York Ter",
    "parcel_id": "088-32-00",
    "owner1": "CORRIN TRS, JAY P & NANCY J",
    "owner2": "",
    "current_taxes": 13991.18,
    "new_taxes_no_override": 14595.6,
    "override_total_1": 15009.74,
    "override_increase_1": 414.14
  },
  {
    "#": "96 York Ter (088-31-00)",
    "$": 2718500,
    "address": "96 York Ter",
    "parcel_id": "088-31-00",
    "owner1": "LINDSTROM, MICHAEL A",
    "owner2": "VAUTRIN, M M",
    "current_taxes": 24202.51,
    "new_taxes_no_override": 25248.06,
    "override_total_1": 25964.45,
    "override_increase_1": 716.39
  },
  {
    "#": "104 York Ter (088-30-00)",
    "$": 2142300,
    "address": "104 York Ter",
    "parcel_id": "088-30-00",
    "owner1": "RIMON, KEREN",
    "owner2": "",
    "current_taxes": 18302.22,
    "new_taxes_no_override": 19092.88,
    "override_total_1": 19634.62,
    "override_increase_1": 541.75
  },
  {
    "#": "107 York Ter (087-10-00)",
    "$": 2398400,
    "address": "107 York Ter",
    "parcel_id": "087-10-00",
    "owner1": "NAVEH, RON & GILI",
    "owner2": "",
    "current_taxes": 20924.68,
    "new_taxes_no_override": 21828.63,
    "override_total_1": 22448.0,
    "override_increase_1": 619.37
  },
  {
    "#": "110 York Ter (088-29-00)",
    "$": 2075500,
    "address": "110 York Ter",
    "parcel_id": "088-29-00",
    "owner1": "LYNCH TR, MARCIA A",
    "owner2": "",
    "current_taxes": 17618.19,
    "new_taxes_no_override": 18379.3,
    "override_total_1": 18900.79,
    "override_increase_1": 521.5
  },
  {
    "#": "111 York Ter (087-11-00)",
    "$": 2335500,
    "address": "111 York Ter",
    "parcel_id": "087-11-00",
    "owner1": "RISMAN, MAX",
    "owner2": "KHRAPUNOVA, YULIA",
    "current_taxes": 20280.59,
    "new_taxes_no_override": 21156.71,
    "override_total_1": 21757.02,
    "override_increase_1": 600.31
  },
  {
    "#": "118 York Ter (088-28-00)",
    "$": 2556400,
    "address": "118 York Ter",
    "parcel_id": "088-28-00",
    "owner1": "KANN, BENJAMIN H",
    "owner2": "BENITEZ, VIVIANA",
    "current_taxes": 22542.6,
    "new_taxes_no_override": 23516.44,
    "override_total_1": 24183.7,
    "override_increase_1": 667.26
  },
  {
    "#": "119 York Ter (087-12-00)",
    "$": 2418900,
    "address": "119 York Ter",
    "parcel_id": "087-12-00",
    "owner1": "MEGASON, SEAN G & BERNADINE TSUNG",
    "owner2": "TSUNG, MICHAEL",
    "current_taxes": 24769.54,
    "new_taxes_no_override": 25839.58,
    "override_total_1": 26572.76,
    "override_increase_1": 733.18
  },
  {
    "#": "125 York Ter, Unit 1 (087-13-01)",
    "$": 909900,
    "address": "125 York Ter, Unit 1",
    "parcel_id": "087-13-01",
    "owner1": "RAO, VIKRAM",
    "owner2": "NARAYANAN, RANJANI",
    "current_taxes": 9317.38,
    "new_taxes_no_override": 9719.89,
    "override_total_1": 9995.69,
    "override_increase_1": 275.79
  },
  {
    "#": "125 York Ter, Unit 2 (087-13-02)",
    "$": 1065500,
    "address": "125 York Ter, Unit 2",
    "parcel_id": "087-13-02",
    "owner1": "RAO, VIKRAM",
    "owner2": "NARAYANAN, RANJANI",
    "current_taxes": 10910.72,
    "new_taxes_no_override": 11382.06,
    "override_total_1": 11705.02,
    "override_increase_1": 322.96
  }
]
